// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27 fill=%27none%27%3e%3cpath d=%27M7 7l3-3 3 3m0 6l-3 3-3-3%27 stroke=%27%239fa6b2%27 stroke-width=%271.5%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3csvg viewBox=%270 0 16 16%27 fill=%27white%27 xmlns=%27http://www.w3.org/2000/svg%27%3e%3cpath d=%27M5.707 7.293a1 1 0 0 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 0 0-1.414-1.414L7 8.586 5.707 7.293z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml,%3csvg viewBox=%270 0 16 16%27 fill=%27white%27 xmlns=%27http://www.w3.org/2000/svg%27%3e%3ccircle cx=%278%27 cy=%278%27 r=%273%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*! tailwindcss v4.0.15 | MIT License | https://tailwindcss.com */
/*! normalize.css v8.0.1 | MIT License | github.com/necolas/normalize.css */
@layer theme, base, components, utilities;
@layer theme {
  :root, :host {
    --font-sans: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji",
      "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
    --font-mono: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono",
      "Courier New", monospace;
    --color-orange-100: oklch(0.954 0.038 75.164);
    --color-orange-300: oklch(0.837 0.128 66.29);
    --color-orange-400: oklch(0.75 0.183 55.934);
    --color-green-400: oklch(0.792 0.209 151.711);
    --color-green-500: oklch(0.723 0.219 149.579);
    --color-green-600: oklch(0.627 0.194 149.214);
    --color-green-700: oklch(0.527 0.154 150.069);
    --color-green-900: oklch(0.393 0.095 152.535);
    --color-indigo-500: oklch(0.585 0.233 277.117);
    --color-indigo-600: oklch(0.511 0.262 276.966);
    --color-indigo-700: oklch(0.457 0.24 277.023);
    --color-gray-50: oklch(0.985 0.002 247.839);
    --color-gray-100: oklch(0.967 0.003 264.542);
    --color-gray-200: oklch(0.928 0.006 264.531);
    --color-gray-300: oklch(0.872 0.01 258.338);
    --color-gray-400: oklch(0.707 0.022 261.325);
    --color-gray-500: oklch(0.551 0.027 264.364);
    --color-gray-600: oklch(0.446 0.03 256.802);
    --color-gray-700: oklch(0.373 0.034 259.733);
    --color-gray-800: oklch(0.278 0.033 256.848);
    --color-gray-900: oklch(0.21 0.034 264.665);
    --color-black: #000;
    --color-white: #fff;
    --spacing: 0.25rem;
    --container-md: 28rem;
    --container-2xl: 42rem;
    --container-4xl: 56rem;
    --container-7xl: 80rem;
    --text-xs: 0.75rem;
    --text-xs--line-height: calc(1 / 0.75);
    --text-sm: 0.875rem;
    --text-sm--line-height: calc(1.25 / 0.875);
    --text-base: 1rem;
    --text-base--line-height: calc(1.5 / 1);
    --text-lg: 1.125rem;
    --text-lg--line-height: calc(1.75 / 1.125);
    --text-2xl: 1.5rem;
    --text-2xl--line-height: calc(2 / 1.5);
    --text-3xl: 1.875rem;
    --text-3xl--line-height: calc(2.25 / 1.875);
    --text-4xl: 2.25rem;
    --text-4xl--line-height: calc(2.5 / 2.25);
    --font-weight-medium: 500;
    --font-weight-semibold: 600;
    --font-weight-bold: 700;
    --font-weight-extrabold: 800;
    --tracking-tight: -0.025em;
    --radius-md: 0.375rem;
    --radius-lg: 0.5rem;
    --radius-xl: 0.75rem;
    --radius-2xl: 1rem;
    --radius-3xl: 1.5rem;
    --ease-in: cubic-bezier(0.4, 0, 1, 1);
    --ease-out: cubic-bezier(0, 0, 0.2, 1);
    --ease-in-out: cubic-bezier(0.4, 0, 0.2, 1);
    --default-transition-duration: 150ms;
    --default-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    --default-font-family: var(--font-sans);
    --default-mono-font-family: var(--font-mono);
  }
}
@layer base {
  *, ::after, ::before, ::backdrop, ::file-selector-button {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    border: 0 solid;
  }
  html, :host {
    line-height: 1.5;
    -webkit-text-size-adjust: 100%;
    tab-size: 4;
    font-family: var(--default-font-family, ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji");
    font-feature-settings: var(--default-font-feature-settings, normal);
    font-variation-settings: var(--default-font-variation-settings, normal);
    -webkit-tap-highlight-color: transparent;
  }
  hr {
    height: 0;
    color: inherit;
    border-top-width: 1px;
  }
  abbr:where([title]) {
    -webkit-text-decoration: underline dotted;
    text-decoration: underline dotted;
  }
  h1, h2, h3, h4, h5, h6 {
    font-size: inherit;
    font-weight: inherit;
  }
  a {
    color: inherit;
    -webkit-text-decoration: inherit;
    text-decoration: inherit;
  }
  b, strong {
    font-weight: bolder;
  }
  code, kbd, samp, pre {
    font-family: var(--default-mono-font-family, ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace);
    font-feature-settings: var(--default-mono-font-feature-settings, normal);
    font-variation-settings: var(--default-mono-font-variation-settings, normal);
    font-size: 1em;
  }
  small {
    font-size: 80%;
  }
  sub, sup {
    font-size: 75%;
    line-height: 0;
    position: relative;
    vertical-align: baseline;
  }
  sub {
    bottom: -0.25em;
  }
  sup {
    top: -0.5em;
  }
  table {
    text-indent: 0;
    border-color: inherit;
    border-collapse: collapse;
  }
  :-moz-focusring {
    outline: auto;
  }
  progress {
    vertical-align: baseline;
  }
  summary {
    display: list-item;
  }
  ol, ul, menu {
    list-style: none;
  }
  img, svg, video, canvas, audio, iframe, embed, object {
    display: block;
    vertical-align: middle;
  }
  img, video {
    max-width: 100%;
    height: auto;
  }
  button, input, select, optgroup, textarea, ::file-selector-button {
    font: inherit;
    font-feature-settings: inherit;
    font-variation-settings: inherit;
    letter-spacing: inherit;
    color: inherit;
    border-radius: 0;
    background-color: transparent;
    opacity: 1;
  }
  :where(select:is([multiple], [size])) optgroup {
    font-weight: bolder;
  }
  :where(select:is([multiple], [size])) optgroup option {
    padding-inline-start: 20px;
  }
  ::file-selector-button {
    margin-inline-end: 4px;
  }
  ::placeholder {
    opacity: 1;
  }
  @supports (not (-webkit-appearance: -apple-pay-button))  or (contain-intrinsic-size: 1px) {
    ::placeholder {
      color: color-mix(in oklab, currentColor 50%, transparent);
    }
  }
  textarea {
    resize: vertical;
  }
  ::-webkit-search-decoration {
    -webkit-appearance: none;
  }
  ::-webkit-date-and-time-value {
    min-height: 1lh;
    text-align: inherit;
  }
  ::-webkit-datetime-edit {
    display: inline-flex;
  }
  ::-webkit-datetime-edit-fields-wrapper {
    padding: 0;
  }
  ::-webkit-datetime-edit, ::-webkit-datetime-edit-year-field, ::-webkit-datetime-edit-month-field, ::-webkit-datetime-edit-day-field, ::-webkit-datetime-edit-hour-field, ::-webkit-datetime-edit-minute-field, ::-webkit-datetime-edit-second-field, ::-webkit-datetime-edit-millisecond-field, ::-webkit-datetime-edit-meridiem-field {
    padding-block: 0;
  }
  :-moz-ui-invalid {
    box-shadow: none;
  }
  button, input:where([type="button"], [type="reset"], [type="submit"]), ::file-selector-button {
    appearance: button;
  }
  ::-webkit-inner-spin-button, ::-webkit-outer-spin-button {
    height: auto;
  }
  [hidden]:where(:not([hidden="until-found"])) {
    display: none !important;
  }
}
@layer utilities {
  .pointer-events-none {
    pointer-events: none;
  }
  .sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border-width: 0;
  }
  .absolute {
    position: absolute;
  }
  .relative {
    position: relative;
  }
  .static {
    position: static;
  }
  .inset-0 {
    inset: calc(var(--spacing) * 0);
  }
  .top-0 {
    top: calc(var(--spacing) * 0);
  }
  .top-\\[60px\\] {
    top: 60px;
  }
  .right-0 {
    right: calc(var(--spacing) * 0);
  }
  .left-0 {
    left: calc(var(--spacing) * 0);
  }
  .left-\\[-254px\\] {
    left: -254px;
  }
  .z-10 {
    z-index: 10;
  }
  .col-span-1 {
    grid-column: span 1 / span 1;
  }
  .col-span-2 {
    grid-column: span 2 / span 2;
  }
  .col-span-3 {
    grid-column: span 3 / span 3;
  }
  .col-start-1 {
    grid-column-start: 1;
  }
  .row-start-1 {
    grid-row-start: 1;
  }
  .container {
    width: 100%;
    @media (width >= 40rem) {
      max-width: 40rem;
    }
    @media (width >= 48rem) {
      max-width: 48rem;
    }
    @media (width >= 64rem) {
      max-width: 64rem;
    }
    @media (width >= 80rem) {
      max-width: 80rem;
    }
    @media (width >= 96rem) {
      max-width: 96rem;
    }
  }
  .-m-2 {
    margin: calc(var(--spacing) * -2);
  }
  .m-0 {
    margin: calc(var(--spacing) * 0);
  }
  .mx-20 {
    margin-inline: calc(var(--spacing) * 20);
  }
  .mx-auto {
    margin-inline: auto;
  }
  .my-8 {
    margin-block: calc(var(--spacing) * 8);
  }
  .my-20 {
    margin-block: calc(var(--spacing) * 20);
  }
  .mt-1 {
    margin-top: calc(var(--spacing) * 1);
  }
  .mt-2 {
    margin-top: calc(var(--spacing) * 2);
  }
  .mt-3 {
    margin-top: calc(var(--spacing) * 3);
  }
  .mt-4 {
    margin-top: calc(var(--spacing) * 4);
  }
  .mt-6 {
    margin-top: calc(var(--spacing) * 6);
  }
  .mt-10 {
    margin-top: calc(var(--spacing) * 10);
  }
  .mt-12 {
    margin-top: calc(var(--spacing) * 12);
  }
  .mt-16 {
    margin-top: calc(var(--spacing) * 16);
  }
  .mt-32 {
    margin-top: calc(var(--spacing) * 32);
  }
  .mr-2 {
    margin-right: calc(var(--spacing) * 2);
  }
  .mr-4 {
    margin-right: calc(var(--spacing) * 4);
  }
  .mr-8 {
    margin-right: calc(var(--spacing) * 8);
  }
  .mb-4 {
    margin-bottom: calc(var(--spacing) * 4);
  }
  .mb-10 {
    margin-bottom: calc(var(--spacing) * 10);
  }
  .mb-20 {
    margin-bottom: calc(var(--spacing) * 20);
  }
  .mb-40 {
    margin-bottom: calc(var(--spacing) * 40);
  }
  .ml-2 {
    margin-left: calc(var(--spacing) * 2);
  }
  .ml-4 {
    margin-left: calc(var(--spacing) * 4);
  }
  .block {
    display: block;
  }
  .contents {
    display: contents;
  }
  .flex {
    display: flex;
  }
  .grid {
    display: grid;
  }
  .hidden {
    display: none;
  }
  .inline {
    display: inline;
  }
  .inline-block {
    display: inline-block;
  }
  .inline-flex {
    display: inline-flex;
  }
  .aspect-square {
    aspect-ratio: 1 / 1;
  }
  .size-5 {
    width: calc(var(--spacing) * 5);
    height: calc(var(--spacing) * 5);
  }
  .size-24 {
    width: calc(var(--spacing) * 24);
    height: calc(var(--spacing) * 24);
  }
  .size-full {
    width: 100%;
    height: 100%;
  }
  .h-1\\/3 {
    height: calc(1/3 * 100%);
  }
  .h-4 {
    height: calc(var(--spacing) * 4);
  }
  .h-5 {
    height: calc(var(--spacing) * 5);
  }
  .h-8 {
    height: calc(var(--spacing) * 8);
  }
  .h-10 {
    height: calc(var(--spacing) * 10);
  }
  .h-12 {
    height: calc(var(--spacing) * 12);
  }
  .h-16 {
    height: calc(var(--spacing) * 16);
  }
  .h-full {
    height: 100%;
  }
  .h-screen {
    height: 100vh;
  }
  .min-h-full {
    min-height: 100%;
  }
  .w-1\\/2 {
    width: calc(1/2 * 100%);
  }
  .w-3\\/4 {
    width: calc(3/4 * 100%);
  }
  .w-4 {
    width: calc(var(--spacing) * 4);
  }
  .w-5 {
    width: calc(var(--spacing) * 5);
  }
  .w-10 {
    width: calc(var(--spacing) * 10);
  }
  .w-16 {
    width: calc(var(--spacing) * 16);
  }
  .w-52 {
    width: calc(var(--spacing) * 52);
  }
  .w-56 {
    width: calc(var(--spacing) * 56);
  }
  .w-92 {
    width: calc(var(--spacing) * 92);
  }
  .w-fit {
    width: fit-content;
  }
  .w-full {
    width: 100%;
  }
  .max-w-2xl {
    max-width: var(--container-2xl);
  }
  .max-w-4xl {
    max-width: var(--container-4xl);
  }
  .max-w-16 {
    max-width: calc(var(--spacing) * 16);
  }
  .flex-1 {
    flex: 1 1;
  }
  .shrink-0 {
    flex-shrink: 0;
  }
  .grow {
    flex-grow: 1;
  }
  .origin-top-right {
    transform-origin: top right;
  }
  .-translate-x-full {
    --tw-translate-x: -100%;
    translate: var(--tw-translate-x) var(--tw-translate-y);
  }
  .translate-x-0 {
    --tw-translate-x: calc(var(--spacing) * 0);
    translate: var(--tw-translate-x) var(--tw-translate-y);
  }
  .translate-x-full {
    --tw-translate-x: 100%;
    translate: var(--tw-translate-x) var(--tw-translate-y);
  }
  .scale-95 {
    --tw-scale-x: 95%;
    --tw-scale-y: 95%;
    --tw-scale-z: 95%;
    scale: var(--tw-scale-x) var(--tw-scale-y);
  }
  .scale-100 {
    --tw-scale-x: 100%;
    --tw-scale-y: 100%;
    --tw-scale-z: 100%;
    scale: var(--tw-scale-x) var(--tw-scale-y);
  }
  .transform {
    transform: var(--tw-rotate-x) var(--tw-rotate-y) var(--tw-rotate-z) var(--tw-skew-x) var(--tw-skew-y);
  }
  .cursor-crosshair {
    cursor: crosshair;
  }
  .cursor-not-allowed {
    cursor: not-allowed;
  }
  .cursor-pointer {
    cursor: pointer;
  }
  .resize {
    resize: both;
  }
  .appearance-none {
    appearance: none;
  }
  .grid-cols-1 {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }
  .grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .grid-cols-8 {
    grid-template-columns: repeat(8, minmax(0, 1fr));
  }
  .flex-col {
    flex-direction: column;
  }
  .items-center {
    align-items: center;
  }
  .justify-between {
    justify-content: space-between;
  }
  .justify-center {
    justify-content: center;
  }
  .justify-end {
    justify-content: flex-end;
  }
  .gap-0 {
    gap: calc(var(--spacing) * 0);
  }
  .gap-3 {
    gap: calc(var(--spacing) * 3);
  }
  .gap-4 {
    gap: calc(var(--spacing) * 4);
  }
  .gap-8 {
    gap: calc(var(--spacing) * 8);
  }
  .space-y-0 {
    :where(& > :not(:last-child)) {
      --tw-space-y-reverse: 0;
      margin-block-start: calc(calc(var(--spacing) * 0) * var(--tw-space-y-reverse));
      margin-block-end: calc(calc(var(--spacing) * 0) * calc(1 - var(--tw-space-y-reverse)));
    }
  }
  .space-y-2 {
    :where(& > :not(:last-child)) {
      --tw-space-y-reverse: 0;
      margin-block-start: calc(calc(var(--spacing) * 2) * var(--tw-space-y-reverse));
      margin-block-end: calc(calc(var(--spacing) * 2) * calc(1 - var(--tw-space-y-reverse)));
    }
  }
  .space-y-4 {
    :where(& > :not(:last-child)) {
      --tw-space-y-reverse: 0;
      margin-block-start: calc(calc(var(--spacing) * 4) * var(--tw-space-y-reverse));
      margin-block-end: calc(calc(var(--spacing) * 4) * calc(1 - var(--tw-space-y-reverse)));
    }
  }
  .space-y-6 {
    :where(& > :not(:last-child)) {
      --tw-space-y-reverse: 0;
      margin-block-start: calc(calc(var(--spacing) * 6) * var(--tw-space-y-reverse));
      margin-block-end: calc(calc(var(--spacing) * 6) * calc(1 - var(--tw-space-y-reverse)));
    }
  }
  .space-y-8 {
    :where(& > :not(:last-child)) {
      --tw-space-y-reverse: 0;
      margin-block-start: calc(calc(var(--spacing) * 8) * var(--tw-space-y-reverse));
      margin-block-end: calc(calc(var(--spacing) * 8) * calc(1 - var(--tw-space-y-reverse)));
    }
  }
  .gap-x-1\\.5 {
    column-gap: calc(var(--spacing) * 1.5);
  }
  .gap-x-8 {
    column-gap: calc(var(--spacing) * 8);
  }
  .space-x-2 {
    :where(& > :not(:last-child)) {
      --tw-space-x-reverse: 0;
      margin-inline-start: calc(calc(var(--spacing) * 2) * var(--tw-space-x-reverse));
      margin-inline-end: calc(calc(var(--spacing) * 2) * calc(1 - var(--tw-space-x-reverse)));
    }
  }
  .space-x-4 {
    :where(& > :not(:last-child)) {
      --tw-space-x-reverse: 0;
      margin-inline-start: calc(calc(var(--spacing) * 4) * var(--tw-space-x-reverse));
      margin-inline-end: calc(calc(var(--spacing) * 4) * calc(1 - var(--tw-space-x-reverse)));
    }
  }
  .divide-y {
    :where(& > :not(:last-child)) {
      --tw-divide-y-reverse: 0;
      border-bottom-style: var(--tw-border-style);
      border-top-style: var(--tw-border-style);
      border-top-width: calc(1px * var(--tw-divide-y-reverse));
      border-bottom-width: calc(1px * calc(1 - var(--tw-divide-y-reverse)));
    }
  }
  .divide-gray-200 {
    :where(& > :not(:last-child)) {
      border-color: var(--color-gray-200);
    }
  }
  .self-center {
    align-self: center;
  }
  .justify-self-end {
    justify-self: flex-end;
  }
  .rounded {
    border-radius: 0.25rem;
  }
  .rounded-2xl {
    border-radius: var(--radius-2xl);
  }
  .rounded-3xl {
    border-radius: var(--radius-3xl);
  }
  .rounded-full {
    border-radius: calc(infinity * 1px);
  }
  .rounded-lg {
    border-radius: var(--radius-lg);
  }
  .rounded-md {
    border-radius: var(--radius-md);
  }
  .rounded-xl {
    border-radius: var(--radius-xl);
  }
  .border {
    border-style: var(--tw-border-style);
    border-width: 1px;
  }
  .border-0 {
    border-style: var(--tw-border-style);
    border-width: 0px;
  }
  .border-12 {
    border-style: var(--tw-border-style);
    border-width: 12px;
  }
  .border-t {
    border-top-style: var(--tw-border-style);
    border-top-width: 1px;
  }
  .border-b {
    border-bottom-style: var(--tw-border-style);
    border-bottom-width: 1px;
  }
  .border-l {
    border-left-style: var(--tw-border-style);
    border-left-width: 1px;
  }
  .border-none {
    --tw-border-style: none;
    border-style: none;
  }
  .border-gray-200 {
    border-color: var(--color-gray-200);
  }
  .border-gray-300 {
    border-color: var(--color-gray-300);
  }
  .border-transparent {
    border-color: transparent;
  }
  .bg-gray-50 {
    background-color: var(--color-gray-50);
  }
  .bg-gray-100 {
    background-color: var(--color-gray-100);
  }
  .bg-gray-200 {
    background-color: var(--color-gray-200);
  }
  .bg-gray-400 {
    background-color: var(--color-gray-400);
  }
  .bg-green-400 {
    background-color: var(--color-green-400);
  }
  .bg-green-600 {
    background-color: var(--color-green-600);
  }
  .bg-green-700 {
    background-color: var(--color-green-700);
  }
  .bg-green-900 {
    background-color: var(--color-green-900);
  }
  .bg-indigo-600 {
    background-color: var(--color-indigo-600);
  }
  .bg-orange-300 {
    background-color: var(--color-orange-300);
  }
  .bg-orange-400 {
    background-color: var(--color-orange-400);
  }
  .bg-white {
    background-color: var(--color-white);
  }
  .fill-\\[\\#24292F\\] {
    fill: #24292F;
  }
  .object-cover {
    object-fit: cover;
  }
  .p-0 {
    padding: calc(var(--spacing) * 0);
  }
  .p-1 {
    padding: calc(var(--spacing) * 1);
  }
  .p-1\\.5 {
    padding: calc(var(--spacing) * 1.5);
  }
  .p-2 {
    padding: calc(var(--spacing) * 2);
  }
  .p-4 {
    padding: calc(var(--spacing) * 4);
  }
  .p-10 {
    padding: calc(var(--spacing) * 10);
  }
  .px-0 {
    padding-inline: calc(var(--spacing) * 0);
  }
  .px-1\\.5 {
    padding-inline: calc(var(--spacing) * 1.5);
  }
  .px-2 {
    padding-inline: calc(var(--spacing) * 2);
  }
  .px-2\\.5 {
    padding-inline: calc(var(--spacing) * 2.5);
  }
  .px-3 {
    padding-inline: calc(var(--spacing) * 3);
  }
  .px-4 {
    padding-inline: calc(var(--spacing) * 4);
  }
  .px-6 {
    padding-inline: calc(var(--spacing) * 6);
  }
  .px-8 {
    padding-inline: calc(var(--spacing) * 8);
  }
  .py-1 {
    padding-block: calc(var(--spacing) * 1);
  }
  .py-1\\.5 {
    padding-block: calc(var(--spacing) * 1.5);
  }
  .py-2 {
    padding-block: calc(var(--spacing) * 2);
  }
  .py-3 {
    padding-block: calc(var(--spacing) * 3);
  }
  .py-4 {
    padding-block: calc(var(--spacing) * 4);
  }
  .py-6 {
    padding-block: calc(var(--spacing) * 6);
  }
  .py-12 {
    padding-block: calc(var(--spacing) * 12);
  }
  .pt-2 {
    padding-top: calc(var(--spacing) * 2);
  }
  .pt-4 {
    padding-top: calc(var(--spacing) * 4);
  }
  .pt-8 {
    padding-top: calc(var(--spacing) * 8);
  }
  .pt-16 {
    padding-top: calc(var(--spacing) * 16);
  }
  .pr-2 {
    padding-right: calc(var(--spacing) * 2);
  }
  .pr-8 {
    padding-right: calc(var(--spacing) * 8);
  }
  .pr-9 {
    padding-right: calc(var(--spacing) * 9);
  }
  .pb-4 {
    padding-bottom: calc(var(--spacing) * 4);
  }
  .pb-8 {
    padding-bottom: calc(var(--spacing) * 8);
  }
  .pb-24 {
    padding-bottom: calc(var(--spacing) * 24);
  }
  .pl-3 {
    padding-left: calc(var(--spacing) * 3);
  }
  .pl-4 {
    padding-left: calc(var(--spacing) * 4);
  }
  .text-center {
    text-align: center;
  }
  .text-left {
    text-align: left;
  }
  .text-2xl {
    font-size: var(--text-2xl);
    line-height: var(--tw-leading, var(--text-2xl--line-height));
  }
  .text-3xl {
    font-size: var(--text-3xl);
    line-height: var(--tw-leading, var(--text-3xl--line-height));
  }
  .text-base {
    font-size: var(--text-base);
    line-height: var(--tw-leading, var(--text-base--line-height));
  }
  .text-lg {
    font-size: var(--text-lg);
    line-height: var(--tw-leading, var(--text-lg--line-height));
  }
  .text-sm {
    font-size: var(--text-sm);
    line-height: var(--tw-leading, var(--text-sm--line-height));
  }
  .text-xs {
    font-size: var(--text-xs);
    line-height: var(--tw-leading, var(--text-xs--line-height));
  }
  .leading-5 {
    --tw-leading: calc(var(--spacing) * 5);
    line-height: calc(var(--spacing) * 5);
  }
  .leading-6 {
    --tw-leading: calc(var(--spacing) * 6);
    line-height: calc(var(--spacing) * 6);
  }
  .leading-9 {
    --tw-leading: calc(var(--spacing) * 9);
    line-height: calc(var(--spacing) * 9);
  }
  .font-bold {
    --tw-font-weight: var(--font-weight-bold);
    font-weight: var(--font-weight-bold);
  }
  .font-extrabold {
    --tw-font-weight: var(--font-weight-extrabold);
    font-weight: var(--font-weight-extrabold);
  }
  .font-medium {
    --tw-font-weight: var(--font-weight-medium);
    font-weight: var(--font-weight-medium);
  }
  .font-semibold {
    --tw-font-weight: var(--font-weight-semibold);
    font-weight: var(--font-weight-semibold);
  }
  .tracking-tight {
    --tw-tracking: var(--tracking-tight);
    letter-spacing: var(--tracking-tight);
  }
  .text-wrap {
    text-wrap: wrap;
  }
  .text-black {
    color: var(--color-black);
  }
  .text-gray-100 {
    color: var(--color-gray-100);
  }
  .text-gray-300 {
    color: var(--color-gray-300);
  }
  .text-gray-400 {
    color: var(--color-gray-400);
  }
  .text-gray-500 {
    color: var(--color-gray-500);
  }
  .text-gray-600 {
    color: var(--color-gray-600);
  }
  .text-gray-700 {
    color: var(--color-gray-700);
  }
  .text-gray-900 {
    color: var(--color-gray-900);
  }
  .text-green-500 {
    color: var(--color-green-500);
  }
  .text-green-600 {
    color: var(--color-green-600);
  }
  .text-green-700 {
    color: var(--color-green-700);
  }
  .text-indigo-600 {
    color: var(--color-indigo-600);
  }
  .text-white {
    color: var(--color-white);
  }
  .underline {
    text-decoration-line: underline;
  }
  .opacity-0 {
    opacity: 0%;
  }
  .opacity-50 {
    opacity: 50%;
  }
  .opacity-100 {
    opacity: 100%;
  }
  .shadow {
    --tw-shadow: 0 1px 3px 0 var(--tw-shadow-color, rgb(0 0 0 / 0.1)), 0 1px 2px -1px var(--tw-shadow-color, rgb(0 0 0 / 0.1));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-2xl {
    --tw-shadow: 0 25px 50px -12px var(--tw-shadow-color, rgb(0 0 0 / 0.25));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-lg {
    --tw-shadow: 0 10px 15px -3px var(--tw-shadow-color, rgb(0 0 0 / 0.1)), 0 4px 6px -4px var(--tw-shadow-color, rgb(0 0 0 / 0.1));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-md {
    --tw-shadow: 0 4px 6px -1px var(--tw-shadow-color, rgb(0 0 0 / 0.1)), 0 2px 4px -2px var(--tw-shadow-color, rgb(0 0 0 / 0.1));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-sm {
    --tw-shadow: 0 1px 3px 0 var(--tw-shadow-color, rgb(0 0 0 / 0.1)), 0 1px 2px -1px var(--tw-shadow-color, rgb(0 0 0 / 0.1));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .ring-1 {
    --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentColor);
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .ring-black {
    --tw-ring-color: var(--color-black);
  }
  .ring-gray-200 {
    --tw-ring-color: var(--color-gray-200);
  }
  .ring-gray-300 {
    --tw-ring-color: var(--color-gray-300);
  }
  .outline {
    outline-style: var(--tw-outline-style);
    outline-width: 1px;
  }
  .outline-1 {
    outline-style: var(--tw-outline-style);
    outline-width: 1px;
  }
  .-outline-offset-1 {
    outline-offset: calc(1px * -1);
  }
  .outline-gray-300 {
    outline-color: var(--color-gray-300);
  }
  .filter {
    filter: var(--tw-blur,) var(--tw-brightness,) var(--tw-contrast,) var(--tw-grayscale,) var(--tw-hue-rotate,) var(--tw-invert,) var(--tw-saturate,) var(--tw-sepia,) var(--tw-drop-shadow,);
  }
  .transition {
    transition-property: color, background-color, border-color, outline-color, text-decoration-color, fill, stroke, --tw-gradient-from, --tw-gradient-via, --tw-gradient-to, opacity, box-shadow, transform, translate, scale, rotate, filter, backdrop-filter;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
    transition-duration: var(--tw-duration, var(--default-transition-duration));
  }
  .transition-opacity {
    transition-property: opacity;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
    transition-duration: var(--tw-duration, var(--default-transition-duration));
  }
  .duration-75 {
    --tw-duration: 75ms;
    transition-duration: 75ms;
  }
  .duration-100 {
    --tw-duration: 100ms;
    transition-duration: 100ms;
  }
  .duration-300 {
    --tw-duration: 300ms;
    transition-duration: 300ms;
  }
  .duration-700 {
    --tw-duration: 700ms;
    transition-duration: 700ms;
  }
  .duration-1000 {
    --tw-duration: 1000ms;
    transition-duration: 1000ms;
  }
  .ease-in {
    --tw-ease: var(--ease-in);
    transition-timing-function: var(--ease-in);
  }
  .ease-in-out {
    --tw-ease: var(--ease-in-out);
    transition-timing-function: var(--ease-in-out);
  }
  .ease-out {
    --tw-ease: var(--ease-out);
    transition-timing-function: var(--ease-out);
  }
  .ring-inset {
    --tw-ring-inset: inset;
  }
  .placeholder\\:text-gray-400 {
    &::placeholder {
      color: var(--color-gray-400);
    }
  }
  .hover\\:bg-gray-50 {
    &:hover {
      @media (hover: hover) {
        background-color: var(--color-gray-50);
      }
    }
  }
  .hover\\:bg-gray-500 {
    &:hover {
      @media (hover: hover) {
        background-color: var(--color-gray-500);
      }
    }
  }
  .hover\\:bg-green-500 {
    &:hover {
      @media (hover: hover) {
        background-color: var(--color-green-500);
      }
    }
  }
  .hover\\:bg-indigo-700 {
    &:hover {
      @media (hover: hover) {
        background-color: var(--color-indigo-700);
      }
    }
  }
  .hover\\:bg-orange-100 {
    &:hover {
      @media (hover: hover) {
        background-color: var(--color-orange-100);
      }
    }
  }
  .hover\\:text-gray-500 {
    &:hover {
      @media (hover: hover) {
        color: var(--color-gray-500);
      }
    }
  }
  .hover\\:text-gray-800 {
    &:hover {
      @media (hover: hover) {
        color: var(--color-gray-800);
      }
    }
  }
  .hover\\:text-green-500 {
    &:hover {
      @media (hover: hover) {
        color: var(--color-green-500);
      }
    }
  }
  .hover\\:text-indigo-500 {
    &:hover {
      @media (hover: hover) {
        color: var(--color-indigo-500);
      }
    }
  }
  .focus\\:ring-2 {
    &:focus {
      --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentColor);
      box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
    }
  }
  .focus\\:ring-green-600 {
    &:focus {
      --tw-ring-color: var(--color-green-600);
    }
  }
  .focus\\:ring-indigo-500 {
    &:focus {
      --tw-ring-color: var(--color-indigo-500);
    }
  }
  .focus\\:ring-indigo-600 {
    &:focus {
      --tw-ring-color: var(--color-indigo-600);
    }
  }
  .focus\\:ring-offset-2 {
    &:focus {
      --tw-ring-offset-width: 2px;
      --tw-ring-offset-shadow: var(--tw-ring-inset,) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
    }
  }
  .focus\\:ring-offset-gray-50 {
    &:focus {
      --tw-ring-offset-color: var(--color-gray-50);
    }
  }
  .focus\\:outline {
    &:focus {
      outline-style: var(--tw-outline-style);
      outline-width: 1px;
    }
  }
  .focus\\:outline-2 {
    &:focus {
      outline-style: var(--tw-outline-style);
      outline-width: 2px;
    }
  }
  .focus\\:-outline-offset-2 {
    &:focus {
      outline-offset: calc(2px * -1);
    }
  }
  .focus\\:outline-indigo-600 {
    &:focus {
      outline-color: var(--color-indigo-600);
    }
  }
  .focus\\:outline-none {
    &:focus {
      --tw-outline-style: none;
      outline-style: none;
    }
  }
  .focus\\:ring-inset {
    &:focus {
      --tw-ring-inset: inset;
    }
  }
  .focus-visible\\:ring-transparent {
    &:focus-visible {
      --tw-ring-color: transparent;
    }
  }
  .focus-visible\\:outline {
    &:focus-visible {
      outline-style: var(--tw-outline-style);
      outline-width: 1px;
    }
  }
  .focus-visible\\:outline-2 {
    &:focus-visible {
      outline-style: var(--tw-outline-style);
      outline-width: 2px;
    }
  }
  .focus-visible\\:outline-offset-2 {
    &:focus-visible {
      outline-offset: 2px;
    }
  }
  .focus-visible\\:outline-indigo-600 {
    &:focus-visible {
      outline-color: var(--color-indigo-600);
    }
  }
  .sm\\:mx-auto {
    @media (width >= 40rem) {
      margin-inline: auto;
    }
  }
  .sm\\:mt-0 {
    @media (width >= 40rem) {
      margin-top: calc(var(--spacing) * 0);
    }
  }
  .sm\\:mt-10 {
    @media (width >= 40rem) {
      margin-top: calc(var(--spacing) * 10);
    }
  }
  .sm\\:ml-6 {
    @media (width >= 40rem) {
      margin-left: calc(var(--spacing) * 6);
    }
  }
  .sm\\:flex {
    @media (width >= 40rem) {
      display: flex;
    }
  }
  .sm\\:grid {
    @media (width >= 40rem) {
      display: grid;
    }
  }
  .sm\\:size-4 {
    @media (width >= 40rem) {
      width: calc(var(--spacing) * 4);
      height: calc(var(--spacing) * 4);
    }
  }
  .sm\\:size-48 {
    @media (width >= 40rem) {
      width: calc(var(--spacing) * 48);
      height: calc(var(--spacing) * 48);
    }
  }
  .sm\\:w-full {
    @media (width >= 40rem) {
      width: 100%;
    }
  }
  .sm\\:max-w-\\[480px\\] {
    @media (width >= 40rem) {
      max-width: 480px;
    }
  }
  .sm\\:max-w-md {
    @media (width >= 40rem) {
      max-width: var(--container-md);
    }
  }
  .sm\\:grid-cols-2 {
    @media (width >= 40rem) {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }
  }
  .sm\\:gap-x-6 {
    @media (width >= 40rem) {
      column-gap: calc(var(--spacing) * 6);
    }
  }
  .sm\\:rounded-xl {
    @media (width >= 40rem) {
      border-radius: var(--radius-xl);
    }
  }
  .sm\\:p-6 {
    @media (width >= 40rem) {
      padding: calc(var(--spacing) * 6);
    }
  }
  .sm\\:px-6 {
    @media (width >= 40rem) {
      padding-inline: calc(var(--spacing) * 6);
    }
  }
  .sm\\:px-12 {
    @media (width >= 40rem) {
      padding-inline: calc(var(--spacing) * 12);
    }
  }
  .sm\\:py-10 {
    @media (width >= 40rem) {
      padding-block: calc(var(--spacing) * 10);
    }
  }
  .sm\\:pr-0 {
    @media (width >= 40rem) {
      padding-right: calc(var(--spacing) * 0);
    }
  }
  .sm\\:pr-9 {
    @media (width >= 40rem) {
      padding-right: calc(var(--spacing) * 9);
    }
  }
  .sm\\:text-4xl {
    @media (width >= 40rem) {
      font-size: var(--text-4xl);
      line-height: var(--tw-leading, var(--text-4xl--line-height));
    }
  }
  .sm\\:text-sm {
    @media (width >= 40rem) {
      font-size: var(--text-sm);
      line-height: var(--tw-leading, var(--text-sm--line-height));
    }
  }
  .sm\\:text-sm\\/6 {
    @media (width >= 40rem) {
      font-size: var(--text-sm);
      line-height: calc(var(--spacing) * 6);
    }
  }
  .sm\\:leading-6 {
    @media (width >= 40rem) {
      --tw-leading: calc(var(--spacing) * 6);
      line-height: calc(var(--spacing) * 6);
    }
  }
  .md\\:grid-cols-2 {
    @media (width >= 48rem) {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }
  }
  .md\\:p-4 {
    @media (width >= 48rem) {
      padding: calc(var(--spacing) * 4);
    }
  }
  .md\\:px-0 {
    @media (width >= 48rem) {
      padding-inline: calc(var(--spacing) * 0);
    }
  }
  .md\\:px-4 {
    @media (width >= 48rem) {
      padding-inline: calc(var(--spacing) * 4);
    }
  }
  .md\\:pt-8 {
    @media (width >= 48rem) {
      padding-top: calc(var(--spacing) * 8);
    }
  }
  .md\\:text-left {
    @media (width >= 48rem) {
      text-align: left;
    }
  }
  .lg\\:col-span-5 {
    @media (width >= 64rem) {
      grid-column: span 5 / span 5;
    }
  }
  .lg\\:col-span-7 {
    @media (width >= 64rem) {
      grid-column: span 7 / span 7;
    }
  }
  .lg\\:mt-0 {
    @media (width >= 64rem) {
      margin-top: calc(var(--spacing) * 0);
    }
  }
  .lg\\:grid {
    @media (width >= 64rem) {
      display: grid;
    }
  }
  .lg\\:w-1\\/2 {
    @media (width >= 64rem) {
      width: calc(1/2 * 100%);
    }
  }
  .lg\\:max-w-7xl {
    @media (width >= 64rem) {
      max-width: var(--container-7xl);
    }
  }
  .lg\\:grid-cols-12 {
    @media (width >= 64rem) {
      grid-template-columns: repeat(12, minmax(0, 1fr));
    }
  }
  .lg\\:items-start {
    @media (width >= 64rem) {
      align-items: flex-start;
    }
  }
  .lg\\:gap-x-12 {
    @media (width >= 64rem) {
      column-gap: calc(var(--spacing) * 12);
    }
  }
  .lg\\:p-8 {
    @media (width >= 64rem) {
      padding: calc(var(--spacing) * 8);
    }
  }
  .lg\\:px-8 {
    @media (width >= 64rem) {
      padding-inline: calc(var(--spacing) * 8);
    }
  }
  .xl\\:gap-x-16 {
    @media (width >= 80rem) {
      column-gap: calc(var(--spacing) * 16);
    }
  }
}
@layer base {
  *, ::after, ::before, ::backdrop, ::file-selector-button {
    border-color: var(--color-gray-200, currentColor);
  }
}
html {
  line-height: 1.15;
  -webkit-text-size-adjust: 100%;
}
body {
  margin: 0;
}
main {
  display: block;
}
h1 {
  font-size: 2em;
  margin: 0.67em 0;
}
hr {
  box-sizing: content-box;
  height: 0;
  overflow: visible;
}
pre {
  font-family: monospace, monospace;
  font-size: 1em;
}
a {
  background-color: transparent;
}
abbr[title] {
  border-bottom: none;
  text-decoration: none;
  -webkit-text-decoration: none dotted;
  text-decoration: none dotted;
}
b, strong {
  font-weight: bolder;
}
code, kbd, samp {
  font-family: monospace, monospace;
  font-size: 1em;
}
small {
  font-size: 80%;
}
sub, sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}
sub {
  bottom: -0.25em;
}
sup {
  top: -0.5em;
}
img {
  border-style: none;
}
button, input, optgroup, select, textarea {
  font-family: inherit;
  font-size: 100%;
  line-height: 1.15;
  margin: 0;
}
button, input {
  overflow: visible;
}
button, select {
  text-transform: none;
}
button, [type="button"], [type="reset"], [type="submit"] {
  -webkit-appearance: button;
}
button::-moz-focus-inner, [type="button"]::-moz-focus-inner, [type="reset"]::-moz-focus-inner, [type="submit"]::-moz-focus-inner {
  border-style: none;
  padding: 0;
}
button:-moz-focusring, [type="button"]:-moz-focusring, [type="reset"]:-moz-focusring, [type="submit"]:-moz-focusring {
  outline: 1px dotted ButtonText;
}
fieldset {
  padding: 0.35em 0.75em 0.625em;
}
legend {
  box-sizing: border-box;
  color: inherit;
  display: table;
  max-width: 100%;
  padding: 0;
  white-space: normal;
}
progress {
  vertical-align: baseline;
}
textarea {
  overflow: auto;
}
[type="checkbox"], [type="radio"] {
  box-sizing: border-box;
  padding: 0;
}
[type="number"]::-webkit-inner-spin-button, [type="number"]::-webkit-outer-spin-button {
  height: auto;
}
[type="search"] {
  -webkit-appearance: textfield;
  outline-offset: -2px;
}
[type="search"]::-webkit-search-decoration {
  -webkit-appearance: none;
}
::-webkit-file-upload-button {
  -webkit-appearance: button;
  font: inherit;
}
details {
  display: block;
}
summary {
  display: list-item;
}
template {
  display: none;
}
[hidden] {
  display: none;
}
blockquote, dl, dd, h1, h2, h3, h4, h5, h6, hr, figure, p, pre {
  margin: 0;
}
button {
  background-color: transparent;
  background-image: none;
}
button:focus {
  outline: 1px dotted;
  outline: 5px auto -webkit-focus-ring-color;
}
fieldset {
  margin: 0;
  padding: 0;
}
ol, ul {
  list-style: none;
  margin: 0;
  padding: 0;
}
html {
  font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  line-height: 1.5;
}
*, ::before, ::after {
  box-sizing: border-box;
  border-width: 0;
  border-style: solid;
  border-color: #d2d6dc;
}
hr {
  border-top-width: 1px;
}
img {
  border-style: solid;
}
textarea {
  resize: vertical;
}
input::placeholder, textarea::placeholder {
  color: #a0aec0;
}
button, [role="button"] {
  cursor: pointer;
}
table {
  border-collapse: collapse;
}
h1, h2, h3, h4, h5, h6 {
  font-size: inherit;
  font-weight: inherit;
}
button, input, optgroup, select, textarea {
  padding: 0;
  line-height: inherit;
  color: inherit;
}
pre, code, kbd, samp {
  font-family: Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
}
img, svg, video, canvas, audio, iframe, embed, object {
  display: block;
  vertical-align: middle;
}
img, video {
  max-width: 100%;
  height: auto;
}
.container {
  width: 100%;
}
@media (min-width: 640px) {
  .container {
    max-width: 640px;
  }
}
@media (min-width: 768px) {
  .container {
    max-width: 768px;
  }
}
@media (min-width: 1024px) {
  .container {
    max-width: 1024px;
  }
}
@media (min-width: 1280px) {
  .container {
    max-width: 1280px;
  }
}
.form-input {
  appearance: none;
  background-color: #ffffff;
  border-color: #d2d6dc;
  border-width: 1px;
  border-radius: 0.375rem;
  padding-top: 0.5rem;
  padding-right: 0.75rem;
  padding-bottom: 0.5rem;
  padding-left: 0.75rem;
  font-size: 1rem;
  line-height: 1.5;
}
.form-input::placeholder {
  color: #9fa6b2;
  opacity: 1;
}
.form-input:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(164, 202, 254, 0.45);
  border-color: #a4cafe;
}
.form-textarea {
  appearance: none;
  background-color: #ffffff;
  border-color: #d2d6dc;
  border-width: 1px;
  border-radius: 0.375rem;
  padding-top: 0.5rem;
  padding-right: 0.75rem;
  padding-bottom: 0.5rem;
  padding-left: 0.75rem;
  font-size: 1rem;
  line-height: 1.5;
}
.form-textarea::placeholder {
  color: #9fa6b2;
  opacity: 1;
}
.form-textarea:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(164, 202, 254, 0.45);
  border-color: #a4cafe;
}
.form-multiselect {
  appearance: none;
  background-color: #ffffff;
  border-color: #d2d6dc;
  border-width: 1px;
  border-radius: 0.375rem;
  padding-top: 0.5rem;
  padding-right: 0.75rem;
  padding-bottom: 0.5rem;
  padding-left: 0.75rem;
  font-size: 1rem;
  line-height: 1.5;
}
.form-multiselect:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(164, 202, 254, 0.45);
  border-color: #a4cafe;
}
.form-select {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  appearance: none;
  -webkit-print-color-adjust: exact;
  print-color-adjust: exact;
  background-repeat: no-repeat;
  background-color: #ffffff;
  border-color: #d2d6dc;
  border-width: 1px;
  border-radius: 0.375rem;
  padding-top: 0.5rem;
  padding-right: 2.5rem;
  padding-bottom: 0.5rem;
  padding-left: 0.75rem;
  font-size: 1rem;
  line-height: 1.5;
  background-position: right 0.5rem center;
  background-size: 1.5em 1.5em;
}
.form-select::-ms-expand {
  color: #9fa6b2;
  border: none;
}
@media not print {
  .form-select::-ms-expand {
    display: none;
  }
}
@media print and (-ms-high-contrast: active), print and (-ms-high-contrast: none) {
  .form-select {
    padding-right: 0.75rem;
  }
}
.form-select:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(164, 202, 254, 0.45);
  border-color: #a4cafe;
}
.form-checkbox:checked {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  border-color: transparent;
  background-color: currentColor;
  background-size: 100% 100%;
  background-position: center;
  background-repeat: no-repeat;
}
@media not print {
  .form-checkbox::-ms-check {
    border-width: 1px;
    color: transparent;
    background: inherit;
    border-color: inherit;
    border-radius: inherit;
  }
}
.form-checkbox {
  appearance: none;
  -webkit-print-color-adjust: exact;
  print-color-adjust: exact;
  display: inline-block;
  vertical-align: middle;
  background-origin: border-box;
  -webkit-user-select: none;
  user-select: none;
  flex-shrink: 0;
  height: 1rem;
  width: 1rem;
  color: #3f83f8;
  background-color: #ffffff;
  border-color: #d2d6dc;
  border-width: 1px;
  border-radius: 0.25rem;
}
.form-checkbox:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(164, 202, 254, 0.45);
  border-color: #a4cafe;
}
.form-checkbox:checked:focus {
  border-color: transparent;
}
.form-radio:checked {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  border-color: transparent;
  background-color: currentColor;
  background-size: 100% 100%;
  background-position: center;
  background-repeat: no-repeat;
}
@media not print {
  .form-radio::-ms-check {
    border-width: 1px;
    color: transparent;
    background: inherit;
    border-color: inherit;
    border-radius: inherit;
  }
}
.form-radio {
  appearance: none;
  -webkit-print-color-adjust: exact;
  print-color-adjust: exact;
  display: inline-block;
  vertical-align: middle;
  background-origin: border-box;
  -webkit-user-select: none;
  user-select: none;
  flex-shrink: 0;
  border-radius: 100%;
  height: 1rem;
  width: 1rem;
  color: #3f83f8;
  background-color: #ffffff;
  border-color: #d2d6dc;
  border-width: 1px;
}
.form-radio:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(164, 202, 254, 0.45);
  border-color: #a4cafe;
}
.form-radio:checked:focus {
  border-color: transparent;
}
.prose {
  color: #374151;
  max-width: 65ch;
}
.prose [class~="lead"] {
  color: #4b5563;
  font-size: 1.25em;
  line-height: 1.6;
  margin-top: 1.2em;
  margin-bottom: 1.2em;
}
.prose a {
  color: #5850ec;
  text-decoration: none;
  font-weight: 600;
}
.prose strong {
  color: #161e2e;
  font-weight: 600;
}
.prose ol {
  counter-reset: list-counter;
  margin-top: 1.25em;
  margin-bottom: 1.25em;
}
.prose ol>li {
  position: relative;
  counter-increment: list-counter;
  padding-left: 1.75em;
}
.prose ol>li::before {
  content: counter(list-counter) ".";
  position: absolute;
  font-weight: 400;
  color: #6b7280;
}
.prose ul>li {
  position: relative;
  padding-left: 1.75em;
}
.prose ul>li::before {
  content: "";
  position: absolute;
  background-color: #d2d6dc;
  border-radius: 50%;
  width: 0.375em;
  height: 0.375em;
  top: calc(0.875em - 0.1875em);
  left: 0.25em;
}
.prose hr {
  border-color: #e5e7eb;
  border-top-width: 1px;
  margin-top: 3em;
  margin-bottom: 3em;
}
.prose blockquote {
  font-weight: 500;
  font-style: italic;
  color: #161e2e;
  border-left-width: 0.25rem;
  border-left-color: #e5e7eb;
  quotes: "\\201C" "\\201D" "\\2018" "\\2019";
  margin-top: 1.6em;
  margin-bottom: 1.6em;
  padding-left: 1em;
}
.prose blockquote p:first-of-type::before {
  content: open-quote;
}
.prose blockquote p:last-of-type::after {
  content: close-quote;
}
.prose h1 {
  color: #1a202c;
  font-weight: 800;
  font-size: 2.25em;
  margin-top: 0;
  margin-bottom: 0.8888889em;
  line-height: 1.1111111;
}
.prose h2 {
  color: #1a202c;
  font-weight: 700;
  font-size: 1.5em;
  margin-top: 2em;
  margin-bottom: 1em;
  line-height: 1.3333333;
}
.prose h3 {
  color: #1a202c;
  font-weight: 600;
  font-size: 1.25em;
  margin-top: 1.6em;
  margin-bottom: 0.6em;
  line-height: 1.6;
}
.prose h4 {
  color: #1a202c;
  font-weight: 600;
  margin-top: 1.5em;
  margin-bottom: 0.5em;
  line-height: 1.5;
}
.prose figure figcaption {
  color: #6b7280;
  font-size: 0.875em;
  line-height: 1.4285714;
  margin-top: 0.8571429em;
}
.prose code {
  color: #161e2e;
  font-weight: 600;
  font-size: 0.875em;
}
.prose code::before {
  content: "\`";
}
.prose code::after {
  content: "\`";
}
.prose pre {
  color: #e5e7eb;
  background-color: #252f3f;
  overflow-x: auto;
  font-size: 0.875em;
  line-height: 1.7142857;
  margin-top: 1.7142857em;
  margin-bottom: 1.7142857em;
  border-radius: 0.375rem;
  padding-top: 0.8571429em;
  padding-right: 1.1428571em;
  padding-bottom: 0.8571429em;
  padding-left: 1.1428571em;
}
.prose pre code {
  background-color: transparent;
  border-width: 0;
  border-radius: 0;
  padding: 0;
  font-weight: 400;
  color: inherit;
  font-size: inherit;
  font-family: inherit;
  line-height: inherit;
}
.prose pre code::before {
  content: "";
}
.prose pre code::after {
  content: "";
}
.prose table {
  width: 100%;
  table-layout: auto;
  text-align: left;
  margin-top: 2em;
  margin-bottom: 2em;
  font-size: 0.875em;
  line-height: 1.7142857;
}
.prose thead {
  color: #161e2e;
  font-weight: 600;
  border-bottom-width: 1px;
  border-bottom-color: #d2d6dc;
}
.prose thead th {
  vertical-align: bottom;
  padding-right: 0.5714286em;
  padding-bottom: 0.5714286em;
  padding-left: 0.5714286em;
}
.prose tbody tr {
  border-bottom-width: 1px;
  border-bottom-color: #e5e7eb;
}
.prose tbody tr:last-child {
  border-bottom-width: 0;
}
.prose tbody td {
  vertical-align: top;
  padding-top: 0.5714286em;
  padding-right: 0.5714286em;
  padding-bottom: 0.5714286em;
  padding-left: 0.5714286em;
}
.prose {
  font-size: 1rem;
  line-height: 1.75;
}
.prose p {
  margin-top: 1.25em;
  margin-bottom: 1.25em;
}
.prose img {
  margin-top: 2em;
  margin-bottom: 2em;
}
.prose video {
  margin-top: 2em;
  margin-bottom: 2em;
}
.prose figure {
  margin-top: 2em;
  margin-bottom: 2em;
}
.prose figure>* {
  margin-top: 0;
  margin-bottom: 0;
}
.prose h2 code {
  font-size: 0.875em;
}
.prose h3 code {
  font-size: 0.9em;
}
.prose ul {
  margin-top: 1.25em;
  margin-bottom: 1.25em;
}
.prose li {
  margin-top: 0.5em;
  margin-bottom: 0.5em;
}
.prose ol>li:before {
  left: 0;
}
.prose>ul>li p {
  margin-top: 0.75em;
  margin-bottom: 0.75em;
}
.prose>ul>li>*:first-child {
  margin-top: 1.25em;
}
.prose>ul>li>*:last-child {
  margin-bottom: 1.25em;
}
.prose>ol>li>*:first-child {
  margin-top: 1.25em;
}
.prose>ol>li>*:last-child {
  margin-bottom: 1.25em;
}
.prose ul ul, .prose ul ol, .prose ol ul, .prose ol ol {
  margin-top: 0.75em;
  margin-bottom: 0.75em;
}
.prose hr+* {
  margin-top: 0;
}
.prose h2+* {
  margin-top: 0;
}
.prose h3+* {
  margin-top: 0;
}
.prose h4+* {
  margin-top: 0;
}
.prose thead th:first-child {
  padding-left: 0;
}
.prose thead th:last-child {
  padding-right: 0;
}
.prose tbody td:first-child {
  padding-left: 0;
}
.prose tbody td:last-child {
  padding-right: 0;
}
.prose> :first-child {
  margin-top: 0;
}
.prose> :last-child {
  margin-bottom: 0;
}
.prose h1, .prose h2, .prose h3, .prose h4 {
  color: #161e2e;
}
.prose-sm {
  font-size: 0.875rem;
  line-height: 1.7142857;
}
.prose-sm p {
  margin-top: 1.1428571em;
  margin-bottom: 1.1428571em;
}
.prose-sm [class~="lead"] {
  font-size: 1.2857143em;
  line-height: 1.5555556;
  margin-top: 0.8888889em;
  margin-bottom: 0.8888889em;
}
.prose-sm blockquote {
  margin-top: 1.3333333em;
  margin-bottom: 1.3333333em;
  padding-left: 1.1111111em;
}
.prose-sm h1 {
  font-size: 2.1428571em;
  margin-top: 0;
  margin-bottom: 0.8em;
  line-height: 1.2;
}
.prose-sm h2 {
  font-size: 1.4285714em;
  margin-top: 1.6em;
  margin-bottom: 0.8em;
  line-height: 1.4;
}
.prose-sm h3 {
  font-size: 1.2857143em;
  margin-top: 1.5555556em;
  margin-bottom: 0.4444444em;
  line-height: 1.5555556;
}
.prose-sm h4 {
  margin-top: 1.4285714em;
  margin-bottom: 0.5714286em;
  line-height: 1.4285714;
}
.prose-sm img {
  margin-top: 1.7142857em;
  margin-bottom: 1.7142857em;
}
.prose-sm video {
  margin-top: 1.7142857em;
  margin-bottom: 1.7142857em;
}
.prose-sm figure {
  margin-top: 1.7142857em;
  margin-bottom: 1.7142857em;
}
.prose-sm figure>* {
  margin-top: 0;
  margin-bottom: 0;
}
.prose-sm figure figcaption {
  font-size: 0.8571429em;
  line-height: 1.3333333;
  margin-top: 0.6666667em;
}
.prose-sm code {
  font-size: 0.8571429em;
}
.prose-sm h2 code {
  font-size: 0.9em;
}
.prose-sm h3 code {
  font-size: 0.8888889em;
}
.prose-sm pre {
  font-size: 0.8571429em;
  line-height: 1.6666667;
  margin-top: 1.6666667em;
  margin-bottom: 1.6666667em;
  border-radius: 0.25rem;
  padding-top: 0.6666667em;
  padding-right: 1em;
  padding-bottom: 0.6666667em;
  padding-left: 1em;
}
.prose-sm ol {
  margin-top: 1.1428571em;
  margin-bottom: 1.1428571em;
}
.prose-sm ul {
  margin-top: 1.1428571em;
  margin-bottom: 1.1428571em;
}
.prose-sm li {
  margin-top: 0.2857143em;
  margin-bottom: 0.2857143em;
}
.prose-sm ol>li {
  padding-left: 1.5714286em;
}
.prose-sm ol>li:before {
  left: 0;
}
.prose-sm ul>li {
  padding-left: 1.5714286em;
}
.prose-sm ul>li::before {
  height: 0.3571429em;
  width: 0.3571429em;
  top: calc(0.8571429em - 0.1785714em);
  left: 0.2142857em;
}
.prose-sm>ul>li p {
  margin-top: 0.5714286em;
  margin-bottom: 0.5714286em;
}
.prose-sm>ul>li>*:first-child {
  margin-top: 1.1428571em;
}
.prose-sm>ul>li>*:last-child {
  margin-bottom: 1.1428571em;
}
.prose-sm>ol>li>*:first-child {
  margin-top: 1.1428571em;
}
.prose-sm>ol>li>*:last-child {
  margin-bottom: 1.1428571em;
}
.prose-sm ul ul, .prose-sm ul ol, .prose-sm ol ul, .prose-sm ol ol {
  margin-top: 0.5714286em;
  margin-bottom: 0.5714286em;
}
.prose-sm hr {
  margin-top: 2.8571429em;
  margin-bottom: 2.8571429em;
}
.prose-sm hr+* {
  margin-top: 0;
}
.prose-sm h2+* {
  margin-top: 0;
}
.prose-sm h3+* {
  margin-top: 0;
}
.prose-sm h4+* {
  margin-top: 0;
}
.prose-sm table {
  font-size: 0.8571429em;
  line-height: 1.5;
}
.prose-sm thead th {
  padding-right: 1em;
  padding-bottom: 0.6666667em;
  padding-left: 1em;
}
.prose-sm thead th:first-child {
  padding-left: 0;
}
.prose-sm thead th:last-child {
  padding-right: 0;
}
.prose-sm tbody td {
  padding-top: 0.6666667em;
  padding-right: 1em;
  padding-bottom: 0.6666667em;
  padding-left: 1em;
}
.prose-sm tbody td:first-child {
  padding-left: 0;
}
.prose-sm tbody td:last-child {
  padding-right: 0;
}
.prose-sm> :first-child {
  margin-top: 0;
}
.prose-sm> :last-child {
  margin-bottom: 0;
}
.prose-lg {
  font-size: 1.125rem;
  line-height: 1.7777778;
}
.prose-lg p {
  margin-top: 1.3333333em;
  margin-bottom: 1.3333333em;
}
.prose-lg [class~="lead"] {
  font-size: 1.2222222em;
  line-height: 1.4545455;
  margin-top: 1.0909091em;
  margin-bottom: 1.0909091em;
}
.prose-lg blockquote {
  margin-top: 1.6666667em;
  margin-bottom: 1.6666667em;
  padding-left: 1em;
}
.prose-lg h1 {
  font-size: 2.6666667em;
  margin-top: 0;
  margin-bottom: 0.8333333em;
  line-height: 1;
}
.prose-lg h2 {
  font-size: 1.6666667em;
  margin-top: 1.8666667em;
  margin-bottom: 1.0666667em;
  line-height: 1.3333333;
}
.prose-lg h3 {
  font-size: 1.3333333em;
  margin-top: 1.6666667em;
  margin-bottom: 0.6666667em;
  line-height: 1.5;
}
.prose-lg h4 {
  margin-top: 1.7777778em;
  margin-bottom: 0.4444444em;
  line-height: 1.5555556;
}
.prose-lg img {
  margin-top: 1.7777778em;
  margin-bottom: 1.7777778em;
}
.prose-lg video {
  margin-top: 1.7777778em;
  margin-bottom: 1.7777778em;
}
.prose-lg figure {
  margin-top: 1.7777778em;
  margin-bottom: 1.7777778em;
}
.prose-lg figure>* {
  margin-top: 0;
  margin-bottom: 0;
}
.prose-lg figure figcaption {
  font-size: 0.8888889em;
  line-height: 1.5;
  margin-top: 1em;
}
.prose-lg code {
  font-size: 0.8888889em;
}
.prose-lg h2 code {
  font-size: 0.8666667em;
}
.prose-lg h3 code {
  font-size: 0.875em;
}
.prose-lg pre {
  font-size: 0.8888889em;
  line-height: 1.75;
  margin-top: 2em;
  margin-bottom: 2em;
  border-radius: 0.375rem;
  padding-top: 1em;
  padding-right: 1.5em;
  padding-bottom: 1em;
  padding-left: 1.5em;
}
.prose-lg ol {
  margin-top: 1.3333333em;
  margin-bottom: 1.3333333em;
}
.prose-lg ul {
  margin-top: 1.3333333em;
  margin-bottom: 1.3333333em;
}
.prose-lg li {
  margin-top: 0.6666667em;
  margin-bottom: 0.6666667em;
}
.prose-lg ol>li {
  padding-left: 1.6666667em;
}
.prose-lg ol>li:before {
  left: 0;
}
.prose-lg ul>li {
  padding-left: 1.6666667em;
}
.prose-lg ul>li::before {
  width: 0.3333333em;
  height: 0.3333333em;
  top: calc(0.8888889em - 0.1666667em);
  left: 0.2222222em;
}
.prose-lg>ul>li p {
  margin-top: 0.8888889em;
  margin-bottom: 0.8888889em;
}
.prose-lg>ul>li>*:first-child {
  margin-top: 1.3333333em;
}
.prose-lg>ul>li>*:last-child {
  margin-bottom: 1.3333333em;
}
.prose-lg>ol>li>*:first-child {
  margin-top: 1.3333333em;
}
.prose-lg>ol>li>*:last-child {
  margin-bottom: 1.3333333em;
}
.prose-lg ul ul, .prose-lg ul ol, .prose-lg ol ul, .prose-lg ol ol {
  margin-top: 0.8888889em;
  margin-bottom: 0.8888889em;
}
.prose-lg hr {
  margin-top: 3.1111111em;
  margin-bottom: 3.1111111em;
}
.prose-lg hr+* {
  margin-top: 0;
}
.prose-lg h2+* {
  margin-top: 0;
}
.prose-lg h3+* {
  margin-top: 0;
}
.prose-lg h4+* {
  margin-top: 0;
}
.prose-lg table {
  font-size: 0.8888889em;
  line-height: 1.5;
}
.prose-lg thead th {
  padding-right: 0.75em;
  padding-bottom: 0.75em;
  padding-left: 0.75em;
}
.prose-lg thead th:first-child {
  padding-left: 0;
}
.prose-lg thead th:last-child {
  padding-right: 0;
}
.prose-lg tbody td {
  padding-top: 0.75em;
  padding-right: 0.75em;
  padding-bottom: 0.75em;
  padding-left: 0.75em;
}
.prose-lg tbody td:first-child {
  padding-left: 0;
}
.prose-lg tbody td:last-child {
  padding-right: 0;
}
.prose-lg> :first-child {
  margin-top: 0;
}
.prose-lg> :last-child {
  margin-bottom: 0;
}
.prose-xl {
  font-size: 1.25rem;
  line-height: 1.8;
}
.prose-xl p {
  margin-top: 1.2em;
  margin-bottom: 1.2em;
}
.prose-xl [class~="lead"] {
  font-size: 1.2em;
  line-height: 1.5;
  margin-top: 1em;
  margin-bottom: 1em;
}
.prose-xl blockquote {
  margin-top: 1.6em;
  margin-bottom: 1.6em;
  padding-left: 1.0666667em;
}
.prose-xl h1 {
  font-size: 2.8em;
  margin-top: 0;
  margin-bottom: 0.8571429em;
  line-height: 1;
}
.prose-xl h2 {
  font-size: 1.8em;
  margin-top: 1.5555556em;
  margin-bottom: 0.8888889em;
  line-height: 1.1111111;
}
.prose-xl h3 {
  font-size: 1.5em;
  margin-top: 1.6em;
  margin-bottom: 0.6666667em;
  line-height: 1.3333333;
}
.prose-xl h4 {
  margin-top: 1.8em;
  margin-bottom: 0.6em;
  line-height: 1.6;
}
.prose-xl img {
  margin-top: 2em;
  margin-bottom: 2em;
}
.prose-xl video {
  margin-top: 2em;
  margin-bottom: 2em;
}
.prose-xl figure {
  margin-top: 2em;
  margin-bottom: 2em;
}
.prose-xl figure>* {
  margin-top: 0;
  margin-bottom: 0;
}
.prose-xl figure figcaption {
  font-size: 0.9em;
  line-height: 1.5555556;
  margin-top: 1em;
}
.prose-xl code {
  font-size: 0.9em;
}
.prose-xl h2 code {
  font-size: 0.8611111em;
}
.prose-xl h3 code {
  font-size: 0.9em;
}
.prose-xl pre {
  font-size: 0.9em;
  line-height: 1.7777778;
  margin-top: 2em;
  margin-bottom: 2em;
  border-radius: 0.5rem;
  padding-top: 1.1111111em;
  padding-right: 1.3333333em;
  padding-bottom: 1.1111111em;
  padding-left: 1.3333333em;
}
.prose-xl ol {
  margin-top: 1.2em;
  margin-bottom: 1.2em;
}
.prose-xl ul {
  margin-top: 1.2em;
  margin-bottom: 1.2em;
}
.prose-xl li {
  margin-top: 0.6em;
  margin-bottom: 0.6em;
}
.prose-xl ol>li {
  padding-left: 1.8em;
}
.prose-xl ol>li:before {
  left: 0;
}
.prose-xl ul>li {
  padding-left: 1.8em;
}
.prose-xl ul>li::before {
  width: 0.35em;
  height: 0.35em;
  top: calc(0.9em - 0.175em);
  left: 0.25em;
}
.prose-xl>ul>li p {
  margin-top: 0.8em;
  margin-bottom: 0.8em;
}
.prose-xl>ul>li>*:first-child {
  margin-top: 1.2em;
}
.prose-xl>ul>li>*:last-child {
  margin-bottom: 1.2em;
}
.prose-xl>ol>li>*:first-child {
  margin-top: 1.2em;
}
.prose-xl>ol>li>*:last-child {
  margin-bottom: 1.2em;
}
.prose-xl ul ul, .prose-xl ul ol, .prose-xl ol ul, .prose-xl ol ol {
  margin-top: 0.8em;
  margin-bottom: 0.8em;
}
.prose-xl hr {
  margin-top: 2.8em;
  margin-bottom: 2.8em;
}
.prose-xl hr+* {
  margin-top: 0;
}
.prose-xl h2+* {
  margin-top: 0;
}
.prose-xl h3+* {
  margin-top: 0;
}
.prose-xl h4+* {
  margin-top: 0;
}
.prose-xl table {
  font-size: 0.9em;
  line-height: 1.5555556;
}
.prose-xl thead th {
  padding-right: 0.6666667em;
  padding-bottom: 0.8888889em;
  padding-left: 0.6666667em;
}
.prose-xl thead th:first-child {
  padding-left: 0;
}
.prose-xl thead th:last-child {
  padding-right: 0;
}
.prose-xl tbody td {
  padding-top: 0.8888889em;
  padding-right: 0.6666667em;
  padding-bottom: 0.8888889em;
  padding-left: 0.6666667em;
}
.prose-xl tbody td:first-child {
  padding-left: 0;
}
.prose-xl tbody td:last-child {
  padding-right: 0;
}
.prose-xl> :first-child {
  margin-top: 0;
}
.prose-xl> :last-child {
  margin-bottom: 0;
}
.prose-2xl {
  font-size: 1.5rem;
  line-height: 1.6666667;
}
.prose-2xl p {
  margin-top: 1.3333333em;
  margin-bottom: 1.3333333em;
}
.prose-2xl [class~="lead"] {
  font-size: 1.25em;
  line-height: 1.4666667;
  margin-top: 1.0666667em;
  margin-bottom: 1.0666667em;
}
.prose-2xl blockquote {
  margin-top: 1.7777778em;
  margin-bottom: 1.7777778em;
  padding-left: 1.1111111em;
}
.prose-2xl h1 {
  font-size: 2.6666667em;
  margin-top: 0;
  margin-bottom: 0.875em;
  line-height: 1;
}
.prose-2xl h2 {
  font-size: 2em;
  margin-top: 1.5em;
  margin-bottom: 0.8333333em;
  line-height: 1.0833333;
}
.prose-2xl h3 {
  font-size: 1.5em;
  margin-top: 1.5555556em;
  margin-bottom: 0.6666667em;
  line-height: 1.2222222;
}
.prose-2xl h4 {
  margin-top: 1.6666667em;
  margin-bottom: 0.6666667em;
  line-height: 1.5;
}
.prose-2xl img {
  margin-top: 2em;
  margin-bottom: 2em;
}
.prose-2xl video {
  margin-top: 2em;
  margin-bottom: 2em;
}
.prose-2xl figure {
  margin-top: 2em;
  margin-bottom: 2em;
}
.prose-2xl figure>* {
  margin-top: 0;
  margin-bottom: 0;
}
.prose-2xl figure figcaption {
  font-size: 0.8333333em;
  line-height: 1.6;
  margin-top: 1em;
}
.prose-2xl code {
  font-size: 0.8333333em;
}
.prose-2xl h2 code {
  font-size: 0.875em;
}
.prose-2xl h3 code {
  font-size: 0.8888889em;
}
.prose-2xl pre {
  font-size: 0.8333333em;
  line-height: 1.8;
  margin-top: 2em;
  margin-bottom: 2em;
  border-radius: 0.5rem;
  padding-top: 1.2em;
  padding-right: 1.6em;
  padding-bottom: 1.2em;
  padding-left: 1.6em;
}
.prose-2xl ol {
  margin-top: 1.3333333em;
  margin-bottom: 1.3333333em;
}
.prose-2xl ul {
  margin-top: 1.3333333em;
  margin-bottom: 1.3333333em;
}
.prose-2xl li {
  margin-top: 0.5em;
  margin-bottom: 0.5em;
}
.prose-2xl ol>li {
  padding-left: 1.6666667em;
}
.prose-2xl ol>li:before {
  left: 0;
}
.prose-2xl ul>li {
  padding-left: 1.6666667em;
}
.prose-2xl ul>li::before {
  width: 0.3333333em;
  height: 0.3333333em;
  top: calc(0.8333333em - 0.1666667em);
  left: 0.25em;
}
.prose-2xl>ul>li p {
  margin-top: 0.8333333em;
  margin-bottom: 0.8333333em;
}
.prose-2xl>ul>li>*:first-child {
  margin-top: 1.3333333em;
}
.prose-2xl>ul>li>*:last-child {
  margin-bottom: 1.3333333em;
}
.prose-2xl>ol>li>*:first-child {
  margin-top: 1.3333333em;
}
.prose-2xl>ol>li>*:last-child {
  margin-bottom: 1.3333333em;
}
.prose-2xl ul ul, .prose-2xl ul ol, .prose-2xl ol ul, .prose-2xl ol ol {
  margin-top: 0.6666667em;
  margin-bottom: 0.6666667em;
}
.prose-2xl hr {
  margin-top: 3em;
  margin-bottom: 3em;
}
.prose-2xl hr+* {
  margin-top: 0;
}
.prose-2xl h2+* {
  margin-top: 0;
}
.prose-2xl h3+* {
  margin-top: 0;
}
.prose-2xl h4+* {
  margin-top: 0;
}
.prose-2xl table {
  font-size: 0.8333333em;
  line-height: 1.4;
}
.prose-2xl thead th {
  padding-right: 0.6em;
  padding-bottom: 0.8em;
  padding-left: 0.6em;
}
.prose-2xl thead th:first-child {
  padding-left: 0;
}
.prose-2xl thead th:last-child {
  padding-right: 0;
}
.prose-2xl tbody td {
  padding-top: 0.8em;
  padding-right: 0.6em;
  padding-bottom: 0.8em;
  padding-left: 0.6em;
}
.prose-2xl tbody td:first-child {
  padding-left: 0;
}
.prose-2xl tbody td:last-child {
  padding-right: 0;
}
.prose-2xl> :first-child {
  margin-top: 0;
}
.prose-2xl> :last-child {
  margin-bottom: 0;
}
.space-y-0> :not(template)~ :not(template) {
  --space-y-reverse: 0;
  margin-top: calc(0px * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(0px * var(--space-y-reverse));
}
.space-x-0> :not(template)~ :not(template) {
  --space-x-reverse: 0;
  margin-right: calc(0px * var(--space-x-reverse));
  margin-left: calc(0px * calc(1 - var(--space-x-reverse)));
}
.space-y-1> :not(template)~ :not(template) {
  --space-y-reverse: 0;
  margin-top: calc(0.25rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(0.25rem * var(--space-y-reverse));
}
.space-x-1> :not(template)~ :not(template) {
  --space-x-reverse: 0;
  margin-right: calc(0.25rem * var(--space-x-reverse));
  margin-left: calc(0.25rem * calc(1 - var(--space-x-reverse)));
}
.space-y-2> :not(template)~ :not(template) {
  --space-y-reverse: 0;
  margin-top: calc(0.5rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(0.5rem * var(--space-y-reverse));
}
.space-x-2> :not(template)~ :not(template) {
  --space-x-reverse: 0;
  margin-right: calc(0.5rem * var(--space-x-reverse));
  margin-left: calc(0.5rem * calc(1 - var(--space-x-reverse)));
}
.space-y-3> :not(template)~ :not(template) {
  --space-y-reverse: 0;
  margin-top: calc(0.75rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(0.75rem * var(--space-y-reverse));
}
.space-x-3> :not(template)~ :not(template) {
  --space-x-reverse: 0;
  margin-right: calc(0.75rem * var(--space-x-reverse));
  margin-left: calc(0.75rem * calc(1 - var(--space-x-reverse)));
}
.space-y-4> :not(template)~ :not(template) {
  --space-y-reverse: 0;
  margin-top: calc(1rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(1rem * var(--space-y-reverse));
}
.space-x-4> :not(template)~ :not(template) {
  --space-x-reverse: 0;
  margin-right: calc(1rem * var(--space-x-reverse));
  margin-left: calc(1rem * calc(1 - var(--space-x-reverse)));
}
.space-y-5> :not(template)~ :not(template) {
  --space-y-reverse: 0;
  margin-top: calc(1.25rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(1.25rem * var(--space-y-reverse));
}
.space-x-5> :not(template)~ :not(template) {
  --space-x-reverse: 0;
  margin-right: calc(1.25rem * var(--space-x-reverse));
  margin-left: calc(1.25rem * calc(1 - var(--space-x-reverse)));
}
.space-y-6> :not(template)~ :not(template) {
  --space-y-reverse: 0;
  margin-top: calc(1.5rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(1.5rem * var(--space-y-reverse));
}
.space-x-6> :not(template)~ :not(template) {
  --space-x-reverse: 0;
  margin-right: calc(1.5rem * var(--space-x-reverse));
  margin-left: calc(1.5rem * calc(1 - var(--space-x-reverse)));
}
.space-y-7> :not(template)~ :not(template) {
  --space-y-reverse: 0;
  margin-top: calc(1.75rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(1.75rem * var(--space-y-reverse));
}
.space-x-7> :not(template)~ :not(template) {
  --space-x-reverse: 0;
  margin-right: calc(1.75rem * var(--space-x-reverse));
  margin-left: calc(1.75rem * calc(1 - var(--space-x-reverse)));
}
.space-y-8> :not(template)~ :not(template) {
  --space-y-reverse: 0;
  margin-top: calc(2rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(2rem * var(--space-y-reverse));
}
.space-x-8> :not(template)~ :not(template) {
  --space-x-reverse: 0;
  margin-right: calc(2rem * var(--space-x-reverse));
  margin-left: calc(2rem * calc(1 - var(--space-x-reverse)));
}
.space-y-9> :not(template)~ :not(template) {
  --space-y-reverse: 0;
  margin-top: calc(2.25rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(2.25rem * var(--space-y-reverse));
}
.space-x-9> :not(template)~ :not(template) {
  --space-x-reverse: 0;
  margin-right: calc(2.25rem * var(--space-x-reverse));
  margin-left: calc(2.25rem * calc(1 - var(--space-x-reverse)));
}
.space-y-10> :not(template)~ :not(template) {
  --space-y-reverse: 0;
  margin-top: calc(2.5rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(2.5rem * var(--space-y-reverse));
}
.space-x-10> :not(template)~ :not(template) {
  --space-x-reverse: 0;
  margin-right: calc(2.5rem * var(--space-x-reverse));
  margin-left: calc(2.5rem * calc(1 - var(--space-x-reverse)));
}
.space-y-11> :not(template)~ :not(template) {
  --space-y-reverse: 0;
  margin-top: calc(2.75rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(2.75rem * var(--space-y-reverse));
}
.space-x-11> :not(template)~ :not(template) {
  --space-x-reverse: 0;
  margin-right: calc(2.75rem * var(--space-x-reverse));
  margin-left: calc(2.75rem * calc(1 - var(--space-x-reverse)));
}
.space-y-12> :not(template)~ :not(template) {
  --space-y-reverse: 0;
  margin-top: calc(3rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(3rem * var(--space-y-reverse));
}
.space-x-12> :not(template)~ :not(template) {
  --space-x-reverse: 0;
  margin-right: calc(3rem * var(--space-x-reverse));
  margin-left: calc(3rem * calc(1 - var(--space-x-reverse)));
}
.space-y-13> :not(template)~ :not(template) {
  --space-y-reverse: 0;
  margin-top: calc(3.25rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(3.25rem * var(--space-y-reverse));
}
.space-x-13> :not(template)~ :not(template) {
  --space-x-reverse: 0;
  margin-right: calc(3.25rem * var(--space-x-reverse));
  margin-left: calc(3.25rem * calc(1 - var(--space-x-reverse)));
}
.space-y-14> :not(template)~ :not(template) {
  --space-y-reverse: 0;
  margin-top: calc(3.5rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(3.5rem * var(--space-y-reverse));
}
.space-x-14> :not(template)~ :not(template) {
  --space-x-reverse: 0;
  margin-right: calc(3.5rem * var(--space-x-reverse));
  margin-left: calc(3.5rem * calc(1 - var(--space-x-reverse)));
}
.space-y-15> :not(template)~ :not(template) {
  --space-y-reverse: 0;
  margin-top: calc(3.75rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(3.75rem * var(--space-y-reverse));
}
.space-x-15> :not(template)~ :not(template) {
  --space-x-reverse: 0;
  margin-right: calc(3.75rem * var(--space-x-reverse));
  margin-left: calc(3.75rem * calc(1 - var(--space-x-reverse)));
}
.space-y-16> :not(template)~ :not(template) {
  --space-y-reverse: 0;
  margin-top: calc(4rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(4rem * var(--space-y-reverse));
}
.space-x-16> :not(template)~ :not(template) {
  --space-x-reverse: 0;
  margin-right: calc(4rem * var(--space-x-reverse));
  margin-left: calc(4rem * calc(1 - var(--space-x-reverse)));
}
.space-y-20> :not(template)~ :not(template) {
  --space-y-reverse: 0;
  margin-top: calc(5rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(5rem * var(--space-y-reverse));
}
.space-x-20> :not(template)~ :not(template) {
  --space-x-reverse: 0;
  margin-right: calc(5rem * var(--space-x-reverse));
  margin-left: calc(5rem * calc(1 - var(--space-x-reverse)));
}
.space-y-24> :not(template)~ :not(template) {
  --space-y-reverse: 0;
  margin-top: calc(6rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(6rem * var(--space-y-reverse));
}
.space-x-24> :not(template)~ :not(template) {
  --space-x-reverse: 0;
  margin-right: calc(6rem * var(--space-x-reverse));
  margin-left: calc(6rem * calc(1 - var(--space-x-reverse)));
}
.space-y-28> :not(template)~ :not(template) {
  --space-y-reverse: 0;
  margin-top: calc(7rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(7rem * var(--space-y-reverse));
}
.space-x-28> :not(template)~ :not(template) {
  --space-x-reverse: 0;
  margin-right: calc(7rem * var(--space-x-reverse));
  margin-left: calc(7rem * calc(1 - var(--space-x-reverse)));
}
.space-y-32> :not(template)~ :not(template) {
  --space-y-reverse: 0;
  margin-top: calc(8rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(8rem * var(--space-y-reverse));
}
.space-x-32> :not(template)~ :not(template) {
  --space-x-reverse: 0;
  margin-right: calc(8rem * var(--space-x-reverse));
  margin-left: calc(8rem * calc(1 - var(--space-x-reverse)));
}
.space-y-36> :not(template)~ :not(template) {
  --space-y-reverse: 0;
  margin-top: calc(9rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(9rem * var(--space-y-reverse));
}
.space-x-36> :not(template)~ :not(template) {
  --space-x-reverse: 0;
  margin-right: calc(9rem * var(--space-x-reverse));
  margin-left: calc(9rem * calc(1 - var(--space-x-reverse)));
}
.space-y-40> :not(template)~ :not(template) {
  --space-y-reverse: 0;
  margin-top: calc(10rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(10rem * var(--space-y-reverse));
}
.space-x-40> :not(template)~ :not(template) {
  --space-x-reverse: 0;
  margin-right: calc(10rem * var(--space-x-reverse));
  margin-left: calc(10rem * calc(1 - var(--space-x-reverse)));
}
.space-y-44> :not(template)~ :not(template) {
  --space-y-reverse: 0;
  margin-top: calc(11rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(11rem * var(--space-y-reverse));
}
.space-x-44> :not(template)~ :not(template) {
  --space-x-reverse: 0;
  margin-right: calc(11rem * var(--space-x-reverse));
  margin-left: calc(11rem * calc(1 - var(--space-x-reverse)));
}
.space-y-48> :not(template)~ :not(template) {
  --space-y-reverse: 0;
  margin-top: calc(12rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(12rem * var(--space-y-reverse));
}
.space-x-48> :not(template)~ :not(template) {
  --space-x-reverse: 0;
  margin-right: calc(12rem * var(--space-x-reverse));
  margin-left: calc(12rem * calc(1 - var(--space-x-reverse)));
}
.space-y-52> :not(template)~ :not(template) {
  --space-y-reverse: 0;
  margin-top: calc(13rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(13rem * var(--space-y-reverse));
}
.space-x-52> :not(template)~ :not(template) {
  --space-x-reverse: 0;
  margin-right: calc(13rem * var(--space-x-reverse));
  margin-left: calc(13rem * calc(1 - var(--space-x-reverse)));
}
.space-y-56> :not(template)~ :not(template) {
  --space-y-reverse: 0;
  margin-top: calc(14rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(14rem * var(--space-y-reverse));
}
.space-x-56> :not(template)~ :not(template) {
  --space-x-reverse: 0;
  margin-right: calc(14rem * var(--space-x-reverse));
  margin-left: calc(14rem * calc(1 - var(--space-x-reverse)));
}
.space-y-60> :not(template)~ :not(template) {
  --space-y-reverse: 0;
  margin-top: calc(15rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(15rem * var(--space-y-reverse));
}
.space-x-60> :not(template)~ :not(template) {
  --space-x-reverse: 0;
  margin-right: calc(15rem * var(--space-x-reverse));
  margin-left: calc(15rem * calc(1 - var(--space-x-reverse)));
}
.space-y-64> :not(template)~ :not(template) {
  --space-y-reverse: 0;
  margin-top: calc(16rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(16rem * var(--space-y-reverse));
}
.space-x-64> :not(template)~ :not(template) {
  --space-x-reverse: 0;
  margin-right: calc(16rem * var(--space-x-reverse));
  margin-left: calc(16rem * calc(1 - var(--space-x-reverse)));
}
.space-y-72> :not(template)~ :not(template) {
  --space-y-reverse: 0;
  margin-top: calc(18rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(18rem * var(--space-y-reverse));
}
.space-x-72> :not(template)~ :not(template) {
  --space-x-reverse: 0;
  margin-right: calc(18rem * var(--space-x-reverse));
  margin-left: calc(18rem * calc(1 - var(--space-x-reverse)));
}
.space-y-80> :not(template)~ :not(template) {
  --space-y-reverse: 0;
  margin-top: calc(20rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(20rem * var(--space-y-reverse));
}
.space-x-80> :not(template)~ :not(template) {
  --space-x-reverse: 0;
  margin-right: calc(20rem * var(--space-x-reverse));
  margin-left: calc(20rem * calc(1 - var(--space-x-reverse)));
}
.space-y-96> :not(template)~ :not(template) {
  --space-y-reverse: 0;
  margin-top: calc(24rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(24rem * var(--space-y-reverse));
}
.space-x-96> :not(template)~ :not(template) {
  --space-x-reverse: 0;
  margin-right: calc(24rem * var(--space-x-reverse));
  margin-left: calc(24rem * calc(1 - var(--space-x-reverse)));
}
.space-y-px> :not(template)~ :not(template) {
  --space-y-reverse: 0;
  margin-top: calc(1px * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(1px * var(--space-y-reverse));
}
.space-x-px> :not(template)~ :not(template) {
  --space-x-reverse: 0;
  margin-right: calc(1px * var(--space-x-reverse));
  margin-left: calc(1px * calc(1 - var(--space-x-reverse)));
}
.space-y-0\\.5> :not(template)~ :not(template) {
  --space-y-reverse: 0;
  margin-top: calc(0.125rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(0.125rem * var(--space-y-reverse));
}
.space-x-0\\.5> :not(template)~ :not(template) {
  --space-x-reverse: 0;
  margin-right: calc(0.125rem * var(--space-x-reverse));
  margin-left: calc(0.125rem * calc(1 - var(--space-x-reverse)));
}
.space-y-1\\.5> :not(template)~ :not(template) {
  --space-y-reverse: 0;
  margin-top: calc(0.375rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(0.375rem * var(--space-y-reverse));
}
.space-x-1\\.5> :not(template)~ :not(template) {
  --space-x-reverse: 0;
  margin-right: calc(0.375rem * var(--space-x-reverse));
  margin-left: calc(0.375rem * calc(1 - var(--space-x-reverse)));
}
.space-y-2\\.5> :not(template)~ :not(template) {
  --space-y-reverse: 0;
  margin-top: calc(0.625rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(0.625rem * var(--space-y-reverse));
}
.space-x-2\\.5> :not(template)~ :not(template) {
  --space-x-reverse: 0;
  margin-right: calc(0.625rem * var(--space-x-reverse));
  margin-left: calc(0.625rem * calc(1 - var(--space-x-reverse)));
}
.space-y-3\\.5> :not(template)~ :not(template) {
  --space-y-reverse: 0;
  margin-top: calc(0.875rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(0.875rem * var(--space-y-reverse));
}
.space-x-3\\.5> :not(template)~ :not(template) {
  --space-x-reverse: 0;
  margin-right: calc(0.875rem * var(--space-x-reverse));
  margin-left: calc(0.875rem * calc(1 - var(--space-x-reverse)));
}
.space-y-1\\/2> :not(template)~ :not(template) {
  --space-y-reverse: 0;
  margin-top: calc(50% * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(50% * var(--space-y-reverse));
}
.space-x-1\\/2> :not(template)~ :not(template) {
  --space-x-reverse: 0;
  margin-right: calc(50% * var(--space-x-reverse));
  margin-left: calc(50% * calc(1 - var(--space-x-reverse)));
}
.space-y-1\\/3> :not(template)~ :not(template) {
  --space-y-reverse: 0;
  margin-top: calc(33.333333% * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(33.333333% * var(--space-y-reverse));
}
.space-x-1\\/3> :not(template)~ :not(template) {
  --space-x-reverse: 0;
  margin-right: calc(33.333333% * var(--space-x-reverse));
  margin-left: calc(33.333333% * calc(1 - var(--space-x-reverse)));
}
.space-y-2\\/3> :not(template)~ :not(template) {
  --space-y-reverse: 0;
  margin-top: calc(66.666667% * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(66.666667% * var(--space-y-reverse));
}
.space-x-2\\/3> :not(template)~ :not(template) {
  --space-x-reverse: 0;
  margin-right: calc(66.666667% * var(--space-x-reverse));
  margin-left: calc(66.666667% * calc(1 - var(--space-x-reverse)));
}
.space-y-1\\/4> :not(template)~ :not(template) {
  --space-y-reverse: 0;
  margin-top: calc(25% * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(25% * var(--space-y-reverse));
}
.space-x-1\\/4> :not(template)~ :not(template) {
  --space-x-reverse: 0;
  margin-right: calc(25% * var(--space-x-reverse));
  margin-left: calc(25% * calc(1 - var(--space-x-reverse)));
}
.space-y-2\\/4> :not(template)~ :not(template) {
  --space-y-reverse: 0;
  margin-top: calc(50% * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(50% * var(--space-y-reverse));
}
.space-x-2\\/4> :not(template)~ :not(template) {
  --space-x-reverse: 0;
  margin-right: calc(50% * var(--space-x-reverse));
  margin-left: calc(50% * calc(1 - var(--space-x-reverse)));
}
.space-y-3\\/4> :not(template)~ :not(template) {
  --space-y-reverse: 0;
  margin-top: calc(75% * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(75% * var(--space-y-reverse));
}
.space-x-3\\/4> :not(template)~ :not(template) {
  --space-x-reverse: 0;
  margin-right: calc(75% * var(--space-x-reverse));
  margin-left: calc(75% * calc(1 - var(--space-x-reverse)));
}
.space-y-1\\/5> :not(template)~ :not(template) {
  --space-y-reverse: 0;
  margin-top: calc(20% * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(20% * var(--space-y-reverse));
}
.space-x-1\\/5> :not(template)~ :not(template) {
  --space-x-reverse: 0;
  margin-right: calc(20% * var(--space-x-reverse));
  margin-left: calc(20% * calc(1 - var(--space-x-reverse)));
}
.space-y-2\\/5> :not(template)~ :not(template) {
  --space-y-reverse: 0;
  margin-top: calc(40% * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(40% * var(--space-y-reverse));
}
.space-x-2\\/5> :not(template)~ :not(template) {
  --space-x-reverse: 0;
  margin-right: calc(40% * var(--space-x-reverse));
  margin-left: calc(40% * calc(1 - var(--space-x-reverse)));
}
.space-y-3\\/5> :not(template)~ :not(template) {
  --space-y-reverse: 0;
  margin-top: calc(60% * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(60% * var(--space-y-reverse));
}
.space-x-3\\/5> :not(template)~ :not(template) {
  --space-x-reverse: 0;
  margin-right: calc(60% * var(--space-x-reverse));
  margin-left: calc(60% * calc(1 - var(--space-x-reverse)));
}
.space-y-4\\/5> :not(template)~ :not(template) {
  --space-y-reverse: 0;
  margin-top: calc(80% * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(80% * var(--space-y-reverse));
}
.space-x-4\\/5> :not(template)~ :not(template) {
  --space-x-reverse: 0;
  margin-right: calc(80% * var(--space-x-reverse));
  margin-left: calc(80% * calc(1 - var(--space-x-reverse)));
}
.space-y-1\\/6> :not(template)~ :not(template) {
  --space-y-reverse: 0;
  margin-top: calc(16.666667% * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(16.666667% * var(--space-y-reverse));
}
.space-x-1\\/6> :not(template)~ :not(template) {
  --space-x-reverse: 0;
  margin-right: calc(16.666667% * var(--space-x-reverse));
  margin-left: calc(16.666667% * calc(1 - var(--space-x-reverse)));
}
.space-y-2\\/6> :not(template)~ :not(template) {
  --space-y-reverse: 0;
  margin-top: calc(33.333333% * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(33.333333% * var(--space-y-reverse));
}
.space-x-2\\/6> :not(template)~ :not(template) {
  --space-x-reverse: 0;
  margin-right: calc(33.333333% * var(--space-x-reverse));
  margin-left: calc(33.333333% * calc(1 - var(--space-x-reverse)));
}
.space-y-3\\/6> :not(template)~ :not(template) {
  --space-y-reverse: 0;
  margin-top: calc(50% * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(50% * var(--space-y-reverse));
}
.space-x-3\\/6> :not(template)~ :not(template) {
  --space-x-reverse: 0;
  margin-right: calc(50% * var(--space-x-reverse));
  margin-left: calc(50% * calc(1 - var(--space-x-reverse)));
}
.space-y-4\\/6> :not(template)~ :not(template) {
  --space-y-reverse: 0;
  margin-top: calc(66.666667% * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(66.666667% * var(--space-y-reverse));
}
.space-x-4\\/6> :not(template)~ :not(template) {
  --space-x-reverse: 0;
  margin-right: calc(66.666667% * var(--space-x-reverse));
  margin-left: calc(66.666667% * calc(1 - var(--space-x-reverse)));
}
.space-y-5\\/6> :not(template)~ :not(template) {
  --space-y-reverse: 0;
  margin-top: calc(83.333333% * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(83.333333% * var(--space-y-reverse));
}
.space-x-5\\/6> :not(template)~ :not(template) {
  --space-x-reverse: 0;
  margin-right: calc(83.333333% * var(--space-x-reverse));
  margin-left: calc(83.333333% * calc(1 - var(--space-x-reverse)));
}
.space-y-1\\/12> :not(template)~ :not(template) {
  --space-y-reverse: 0;
  margin-top: calc(8.333333% * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(8.333333% * var(--space-y-reverse));
}
.space-x-1\\/12> :not(template)~ :not(template) {
  --space-x-reverse: 0;
  margin-right: calc(8.333333% * var(--space-x-reverse));
  margin-left: calc(8.333333% * calc(1 - var(--space-x-reverse)));
}
.space-y-2\\/12> :not(template)~ :not(template) {
  --space-y-reverse: 0;
  margin-top: calc(16.666667% * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(16.666667% * var(--space-y-reverse));
}
.space-x-2\\/12> :not(template)~ :not(template) {
  --space-x-reverse: 0;
  margin-right: calc(16.666667% * var(--space-x-reverse));
  margin-left: calc(16.666667% * calc(1 - var(--space-x-reverse)));
}
.space-y-3\\/12> :not(template)~ :not(template) {
  --space-y-reverse: 0;
  margin-top: calc(25% * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(25% * var(--space-y-reverse));
}
.space-x-3\\/12> :not(template)~ :not(template) {
  --space-x-reverse: 0;
  margin-right: calc(25% * var(--space-x-reverse));
  margin-left: calc(25% * calc(1 - var(--space-x-reverse)));
}
.space-y-4\\/12> :not(template)~ :not(template) {
  --space-y-reverse: 0;
  margin-top: calc(33.333333% * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(33.333333% * var(--space-y-reverse));
}
.space-x-4\\/12> :not(template)~ :not(template) {
  --space-x-reverse: 0;
  margin-right: calc(33.333333% * var(--space-x-reverse));
  margin-left: calc(33.333333% * calc(1 - var(--space-x-reverse)));
}
.space-y-5\\/12> :not(template)~ :not(template) {
  --space-y-reverse: 0;
  margin-top: calc(41.666667% * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(41.666667% * var(--space-y-reverse));
}
.space-x-5\\/12> :not(template)~ :not(template) {
  --space-x-reverse: 0;
  margin-right: calc(41.666667% * var(--space-x-reverse));
  margin-left: calc(41.666667% * calc(1 - var(--space-x-reverse)));
}
.space-y-6\\/12> :not(template)~ :not(template) {
  --space-y-reverse: 0;
  margin-top: calc(50% * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(50% * var(--space-y-reverse));
}
.space-x-6\\/12> :not(template)~ :not(template) {
  --space-x-reverse: 0;
  margin-right: calc(50% * var(--space-x-reverse));
  margin-left: calc(50% * calc(1 - var(--space-x-reverse)));
}
.space-y-7\\/12> :not(template)~ :not(template) {
  --space-y-reverse: 0;
  margin-top: calc(58.333333% * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(58.333333% * var(--space-y-reverse));
}
.space-x-7\\/12> :not(template)~ :not(template) {
  --space-x-reverse: 0;
  margin-right: calc(58.333333% * var(--space-x-reverse));
  margin-left: calc(58.333333% * calc(1 - var(--space-x-reverse)));
}
.space-y-8\\/12> :not(template)~ :not(template) {
  --space-y-reverse: 0;
  margin-top: calc(66.666667% * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(66.666667% * var(--space-y-reverse));
}
.space-x-8\\/12> :not(template)~ :not(template) {
  --space-x-reverse: 0;
  margin-right: calc(66.666667% * var(--space-x-reverse));
  margin-left: calc(66.666667% * calc(1 - var(--space-x-reverse)));
}
.space-y-9\\/12> :not(template)~ :not(template) {
  --space-y-reverse: 0;
  margin-top: calc(75% * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(75% * var(--space-y-reverse));
}
.space-x-9\\/12> :not(template)~ :not(template) {
  --space-x-reverse: 0;
  margin-right: calc(75% * var(--space-x-reverse));
  margin-left: calc(75% * calc(1 - var(--space-x-reverse)));
}
.space-y-10\\/12> :not(template)~ :not(template) {
  --space-y-reverse: 0;
  margin-top: calc(83.333333% * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(83.333333% * var(--space-y-reverse));
}
.space-x-10\\/12> :not(template)~ :not(template) {
  --space-x-reverse: 0;
  margin-right: calc(83.333333% * var(--space-x-reverse));
  margin-left: calc(83.333333% * calc(1 - var(--space-x-reverse)));
}
.space-y-11\\/12> :not(template)~ :not(template) {
  --space-y-reverse: 0;
  margin-top: calc(91.666667% * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(91.666667% * var(--space-y-reverse));
}
.space-x-11\\/12> :not(template)~ :not(template) {
  --space-x-reverse: 0;
  margin-right: calc(91.666667% * var(--space-x-reverse));
  margin-left: calc(91.666667% * calc(1 - var(--space-x-reverse)));
}
.space-y-full> :not(template)~ :not(template) {
  --space-y-reverse: 0;
  margin-top: calc(100% * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(100% * var(--space-y-reverse));
}
.space-x-full> :not(template)~ :not(template) {
  --space-x-reverse: 0;
  margin-right: calc(100% * var(--space-x-reverse));
  margin-left: calc(100% * calc(1 - var(--space-x-reverse)));
}
.-space-y-1> :not(template)~ :not(template) {
  --space-y-reverse: 0;
  margin-top: calc(-0.25rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(-0.25rem * var(--space-y-reverse));
}
.-space-x-1> :not(template)~ :not(template) {
  --space-x-reverse: 0;
  margin-right: calc(-0.25rem * var(--space-x-reverse));
  margin-left: calc(-0.25rem * calc(1 - var(--space-x-reverse)));
}
.-space-y-2> :not(template)~ :not(template) {
  --space-y-reverse: 0;
  margin-top: calc(-0.5rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(-0.5rem * var(--space-y-reverse));
}
.-space-x-2> :not(template)~ :not(template) {
  --space-x-reverse: 0;
  margin-right: calc(-0.5rem * var(--space-x-reverse));
  margin-left: calc(-0.5rem * calc(1 - var(--space-x-reverse)));
}
.-space-y-3> :not(template)~ :not(template) {
  --space-y-reverse: 0;
  margin-top: calc(-0.75rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(-0.75rem * var(--space-y-reverse));
}
.-space-x-3> :not(template)~ :not(template) {
  --space-x-reverse: 0;
  margin-right: calc(-0.75rem * var(--space-x-reverse));
  margin-left: calc(-0.75rem * calc(1 - var(--space-x-reverse)));
}
.-space-y-4> :not(template)~ :not(template) {
  --space-y-reverse: 0;
  margin-top: calc(-1rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(-1rem * var(--space-y-reverse));
}
.-space-x-4> :not(template)~ :not(template) {
  --space-x-reverse: 0;
  margin-right: calc(-1rem * var(--space-x-reverse));
  margin-left: calc(-1rem * calc(1 - var(--space-x-reverse)));
}
.-space-y-5> :not(template)~ :not(template) {
  --space-y-reverse: 0;
  margin-top: calc(-1.25rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(-1.25rem * var(--space-y-reverse));
}
.-space-x-5> :not(template)~ :not(template) {
  --space-x-reverse: 0;
  margin-right: calc(-1.25rem * var(--space-x-reverse));
  margin-left: calc(-1.25rem * calc(1 - var(--space-x-reverse)));
}
.-space-y-6> :not(template)~ :not(template) {
  --space-y-reverse: 0;
  margin-top: calc(-1.5rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(-1.5rem * var(--space-y-reverse));
}
.-space-x-6> :not(template)~ :not(template) {
  --space-x-reverse: 0;
  margin-right: calc(-1.5rem * var(--space-x-reverse));
  margin-left: calc(-1.5rem * calc(1 - var(--space-x-reverse)));
}
.-space-y-7> :not(template)~ :not(template) {
  --space-y-reverse: 0;
  margin-top: calc(-1.75rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(-1.75rem * var(--space-y-reverse));
}
.-space-x-7> :not(template)~ :not(template) {
  --space-x-reverse: 0;
  margin-right: calc(-1.75rem * var(--space-x-reverse));
  margin-left: calc(-1.75rem * calc(1 - var(--space-x-reverse)));
}
.-space-y-8> :not(template)~ :not(template) {
  --space-y-reverse: 0;
  margin-top: calc(-2rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(-2rem * var(--space-y-reverse));
}
.-space-x-8> :not(template)~ :not(template) {
  --space-x-reverse: 0;
  margin-right: calc(-2rem * var(--space-x-reverse));
  margin-left: calc(-2rem * calc(1 - var(--space-x-reverse)));
}
.-space-y-9> :not(template)~ :not(template) {
  --space-y-reverse: 0;
  margin-top: calc(-2.25rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(-2.25rem * var(--space-y-reverse));
}
.-space-x-9> :not(template)~ :not(template) {
  --space-x-reverse: 0;
  margin-right: calc(-2.25rem * var(--space-x-reverse));
  margin-left: calc(-2.25rem * calc(1 - var(--space-x-reverse)));
}
.-space-y-10> :not(template)~ :not(template) {
  --space-y-reverse: 0;
  margin-top: calc(-2.5rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(-2.5rem * var(--space-y-reverse));
}
.-space-x-10> :not(template)~ :not(template) {
  --space-x-reverse: 0;
  margin-right: calc(-2.5rem * var(--space-x-reverse));
  margin-left: calc(-2.5rem * calc(1 - var(--space-x-reverse)));
}
.-space-y-11> :not(template)~ :not(template) {
  --space-y-reverse: 0;
  margin-top: calc(-2.75rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(-2.75rem * var(--space-y-reverse));
}
.-space-x-11> :not(template)~ :not(template) {
  --space-x-reverse: 0;
  margin-right: calc(-2.75rem * var(--space-x-reverse));
  margin-left: calc(-2.75rem * calc(1 - var(--space-x-reverse)));
}
.-space-y-12> :not(template)~ :not(template) {
  --space-y-reverse: 0;
  margin-top: calc(-3rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(-3rem * var(--space-y-reverse));
}
.-space-x-12> :not(template)~ :not(template) {
  --space-x-reverse: 0;
  margin-right: calc(-3rem * var(--space-x-reverse));
  margin-left: calc(-3rem * calc(1 - var(--space-x-reverse)));
}
.-space-y-13> :not(template)~ :not(template) {
  --space-y-reverse: 0;
  margin-top: calc(-3.25rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(-3.25rem * var(--space-y-reverse));
}
.-space-x-13> :not(template)~ :not(template) {
  --space-x-reverse: 0;
  margin-right: calc(-3.25rem * var(--space-x-reverse));
  margin-left: calc(-3.25rem * calc(1 - var(--space-x-reverse)));
}
.-space-y-14> :not(template)~ :not(template) {
  --space-y-reverse: 0;
  margin-top: calc(-3.5rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(-3.5rem * var(--space-y-reverse));
}
.-space-x-14> :not(template)~ :not(template) {
  --space-x-reverse: 0;
  margin-right: calc(-3.5rem * var(--space-x-reverse));
  margin-left: calc(-3.5rem * calc(1 - var(--space-x-reverse)));
}
.-space-y-15> :not(template)~ :not(template) {
  --space-y-reverse: 0;
  margin-top: calc(-3.75rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(-3.75rem * var(--space-y-reverse));
}
.-space-x-15> :not(template)~ :not(template) {
  --space-x-reverse: 0;
  margin-right: calc(-3.75rem * var(--space-x-reverse));
  margin-left: calc(-3.75rem * calc(1 - var(--space-x-reverse)));
}
.-space-y-16> :not(template)~ :not(template) {
  --space-y-reverse: 0;
  margin-top: calc(-4rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(-4rem * var(--space-y-reverse));
}
.-space-x-16> :not(template)~ :not(template) {
  --space-x-reverse: 0;
  margin-right: calc(-4rem * var(--space-x-reverse));
  margin-left: calc(-4rem * calc(1 - var(--space-x-reverse)));
}
.-space-y-20> :not(template)~ :not(template) {
  --space-y-reverse: 0;
  margin-top: calc(-5rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(-5rem * var(--space-y-reverse));
}
.-space-x-20> :not(template)~ :not(template) {
  --space-x-reverse: 0;
  margin-right: calc(-5rem * var(--space-x-reverse));
  margin-left: calc(-5rem * calc(1 - var(--space-x-reverse)));
}
.-space-y-24> :not(template)~ :not(template) {
  --space-y-reverse: 0;
  margin-top: calc(-6rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(-6rem * var(--space-y-reverse));
}
.-space-x-24> :not(template)~ :not(template) {
  --space-x-reverse: 0;
  margin-right: calc(-6rem * var(--space-x-reverse));
  margin-left: calc(-6rem * calc(1 - var(--space-x-reverse)));
}
.-space-y-28> :not(template)~ :not(template) {
  --space-y-reverse: 0;
  margin-top: calc(-7rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(-7rem * var(--space-y-reverse));
}
.-space-x-28> :not(template)~ :not(template) {
  --space-x-reverse: 0;
  margin-right: calc(-7rem * var(--space-x-reverse));
  margin-left: calc(-7rem * calc(1 - var(--space-x-reverse)));
}
.-space-y-32> :not(template)~ :not(template) {
  --space-y-reverse: 0;
  margin-top: calc(-8rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(-8rem * var(--space-y-reverse));
}
.-space-x-32> :not(template)~ :not(template) {
  --space-x-reverse: 0;
  margin-right: calc(-8rem * var(--space-x-reverse));
  margin-left: calc(-8rem * calc(1 - var(--space-x-reverse)));
}
.-space-y-36> :not(template)~ :not(template) {
  --space-y-reverse: 0;
  margin-top: calc(-9rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(-9rem * var(--space-y-reverse));
}
.-space-x-36> :not(template)~ :not(template) {
  --space-x-reverse: 0;
  margin-right: calc(-9rem * var(--space-x-reverse));
  margin-left: calc(-9rem * calc(1 - var(--space-x-reverse)));
}
.-space-y-40> :not(template)~ :not(template) {
  --space-y-reverse: 0;
  margin-top: calc(-10rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(-10rem * var(--space-y-reverse));
}
.-space-x-40> :not(template)~ :not(template) {
  --space-x-reverse: 0;
  margin-right: calc(-10rem * var(--space-x-reverse));
  margin-left: calc(-10rem * calc(1 - var(--space-x-reverse)));
}
.-space-y-44> :not(template)~ :not(template) {
  --space-y-reverse: 0;
  margin-top: calc(-11rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(-11rem * var(--space-y-reverse));
}
.-space-x-44> :not(template)~ :not(template) {
  --space-x-reverse: 0;
  margin-right: calc(-11rem * var(--space-x-reverse));
  margin-left: calc(-11rem * calc(1 - var(--space-x-reverse)));
}
.-space-y-48> :not(template)~ :not(template) {
  --space-y-reverse: 0;
  margin-top: calc(-12rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(-12rem * var(--space-y-reverse));
}
.-space-x-48> :not(template)~ :not(template) {
  --space-x-reverse: 0;
  margin-right: calc(-12rem * var(--space-x-reverse));
  margin-left: calc(-12rem * calc(1 - var(--space-x-reverse)));
}
.-space-y-52> :not(template)~ :not(template) {
  --space-y-reverse: 0;
  margin-top: calc(-13rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(-13rem * var(--space-y-reverse));
}
.-space-x-52> :not(template)~ :not(template) {
  --space-x-reverse: 0;
  margin-right: calc(-13rem * var(--space-x-reverse));
  margin-left: calc(-13rem * calc(1 - var(--space-x-reverse)));
}
.-space-y-56> :not(template)~ :not(template) {
  --space-y-reverse: 0;
  margin-top: calc(-14rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(-14rem * var(--space-y-reverse));
}
.-space-x-56> :not(template)~ :not(template) {
  --space-x-reverse: 0;
  margin-right: calc(-14rem * var(--space-x-reverse));
  margin-left: calc(-14rem * calc(1 - var(--space-x-reverse)));
}
.-space-y-60> :not(template)~ :not(template) {
  --space-y-reverse: 0;
  margin-top: calc(-15rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(-15rem * var(--space-y-reverse));
}
.-space-x-60> :not(template)~ :not(template) {
  --space-x-reverse: 0;
  margin-right: calc(-15rem * var(--space-x-reverse));
  margin-left: calc(-15rem * calc(1 - var(--space-x-reverse)));
}
.-space-y-64> :not(template)~ :not(template) {
  --space-y-reverse: 0;
  margin-top: calc(-16rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(-16rem * var(--space-y-reverse));
}
.-space-x-64> :not(template)~ :not(template) {
  --space-x-reverse: 0;
  margin-right: calc(-16rem * var(--space-x-reverse));
  margin-left: calc(-16rem * calc(1 - var(--space-x-reverse)));
}
.-space-y-72> :not(template)~ :not(template) {
  --space-y-reverse: 0;
  margin-top: calc(-18rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(-18rem * var(--space-y-reverse));
}
.-space-x-72> :not(template)~ :not(template) {
  --space-x-reverse: 0;
  margin-right: calc(-18rem * var(--space-x-reverse));
  margin-left: calc(-18rem * calc(1 - var(--space-x-reverse)));
}
.-space-y-80> :not(template)~ :not(template) {
  --space-y-reverse: 0;
  margin-top: calc(-20rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(-20rem * var(--space-y-reverse));
}
.-space-x-80> :not(template)~ :not(template) {
  --space-x-reverse: 0;
  margin-right: calc(-20rem * var(--space-x-reverse));
  margin-left: calc(-20rem * calc(1 - var(--space-x-reverse)));
}
.-space-y-96> :not(template)~ :not(template) {
  --space-y-reverse: 0;
  margin-top: calc(-24rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(-24rem * var(--space-y-reverse));
}
.-space-x-96> :not(template)~ :not(template) {
  --space-x-reverse: 0;
  margin-right: calc(-24rem * var(--space-x-reverse));
  margin-left: calc(-24rem * calc(1 - var(--space-x-reverse)));
}
.-space-y-px> :not(template)~ :not(template) {
  --space-y-reverse: 0;
  margin-top: calc(-1px * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(-1px * var(--space-y-reverse));
}
.-space-x-px> :not(template)~ :not(template) {
  --space-x-reverse: 0;
  margin-right: calc(-1px * var(--space-x-reverse));
  margin-left: calc(-1px * calc(1 - var(--space-x-reverse)));
}
.-space-y-0\\.5> :not(template)~ :not(template) {
  --space-y-reverse: 0;
  margin-top: calc(-0.125rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(-0.125rem * var(--space-y-reverse));
}
.-space-x-0\\.5> :not(template)~ :not(template) {
  --space-x-reverse: 0;
  margin-right: calc(-0.125rem * var(--space-x-reverse));
  margin-left: calc(-0.125rem * calc(1 - var(--space-x-reverse)));
}
.-space-y-1\\.5> :not(template)~ :not(template) {
  --space-y-reverse: 0;
  margin-top: calc(-0.375rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(-0.375rem * var(--space-y-reverse));
}
.-space-x-1\\.5> :not(template)~ :not(template) {
  --space-x-reverse: 0;
  margin-right: calc(-0.375rem * var(--space-x-reverse));
  margin-left: calc(-0.375rem * calc(1 - var(--space-x-reverse)));
}
.-space-y-2\\.5> :not(template)~ :not(template) {
  --space-y-reverse: 0;
  margin-top: calc(-0.625rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(-0.625rem * var(--space-y-reverse));
}
.-space-x-2\\.5> :not(template)~ :not(template) {
  --space-x-reverse: 0;
  margin-right: calc(-0.625rem * var(--space-x-reverse));
  margin-left: calc(-0.625rem * calc(1 - var(--space-x-reverse)));
}
.-space-y-3\\.5> :not(template)~ :not(template) {
  --space-y-reverse: 0;
  margin-top: calc(-0.875rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(-0.875rem * var(--space-y-reverse));
}
.-space-x-3\\.5> :not(template)~ :not(template) {
  --space-x-reverse: 0;
  margin-right: calc(-0.875rem * var(--space-x-reverse));
  margin-left: calc(-0.875rem * calc(1 - var(--space-x-reverse)));
}
.-space-y-1\\/2> :not(template)~ :not(template) {
  --space-y-reverse: 0;
  margin-top: calc(-50% * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(-50% * var(--space-y-reverse));
}
.-space-x-1\\/2> :not(template)~ :not(template) {
  --space-x-reverse: 0;
  margin-right: calc(-50% * var(--space-x-reverse));
  margin-left: calc(-50% * calc(1 - var(--space-x-reverse)));
}
.-space-y-1\\/3> :not(template)~ :not(template) {
  --space-y-reverse: 0;
  margin-top: calc(-33.33333% * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(-33.33333% * var(--space-y-reverse));
}
.-space-x-1\\/3> :not(template)~ :not(template) {
  --space-x-reverse: 0;
  margin-right: calc(-33.33333% * var(--space-x-reverse));
  margin-left: calc(-33.33333% * calc(1 - var(--space-x-reverse)));
}
.-space-y-2\\/3> :not(template)~ :not(template) {
  --space-y-reverse: 0;
  margin-top: calc(-66.66667% * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(-66.66667% * var(--space-y-reverse));
}
.-space-x-2\\/3> :not(template)~ :not(template) {
  --space-x-reverse: 0;
  margin-right: calc(-66.66667% * var(--space-x-reverse));
  margin-left: calc(-66.66667% * calc(1 - var(--space-x-reverse)));
}
.-space-y-1\\/4> :not(template)~ :not(template) {
  --space-y-reverse: 0;
  margin-top: calc(-25% * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(-25% * var(--space-y-reverse));
}
.-space-x-1\\/4> :not(template)~ :not(template) {
  --space-x-reverse: 0;
  margin-right: calc(-25% * var(--space-x-reverse));
  margin-left: calc(-25% * calc(1 - var(--space-x-reverse)));
}
.-space-y-2\\/4> :not(template)~ :not(template) {
  --space-y-reverse: 0;
  margin-top: calc(-50% * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(-50% * var(--space-y-reverse));
}
.-space-x-2\\/4> :not(template)~ :not(template) {
  --space-x-reverse: 0;
  margin-right: calc(-50% * var(--space-x-reverse));
  margin-left: calc(-50% * calc(1 - var(--space-x-reverse)));
}
.-space-y-3\\/4> :not(template)~ :not(template) {
  --space-y-reverse: 0;
  margin-top: calc(-75% * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(-75% * var(--space-y-reverse));
}
.-space-x-3\\/4> :not(template)~ :not(template) {
  --space-x-reverse: 0;
  margin-right: calc(-75% * var(--space-x-reverse));
  margin-left: calc(-75% * calc(1 - var(--space-x-reverse)));
}
.-space-y-1\\/5> :not(template)~ :not(template) {
  --space-y-reverse: 0;
  margin-top: calc(-20% * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(-20% * var(--space-y-reverse));
}
.-space-x-1\\/5> :not(template)~ :not(template) {
  --space-x-reverse: 0;
  margin-right: calc(-20% * var(--space-x-reverse));
  margin-left: calc(-20% * calc(1 - var(--space-x-reverse)));
}
.-space-y-2\\/5> :not(template)~ :not(template) {
  --space-y-reverse: 0;
  margin-top: calc(-40% * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(-40% * var(--space-y-reverse));
}
.-space-x-2\\/5> :not(template)~ :not(template) {
  --space-x-reverse: 0;
  margin-right: calc(-40% * var(--space-x-reverse));
  margin-left: calc(-40% * calc(1 - var(--space-x-reverse)));
}
.-space-y-3\\/5> :not(template)~ :not(template) {
  --space-y-reverse: 0;
  margin-top: calc(-60% * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(-60% * var(--space-y-reverse));
}
.-space-x-3\\/5> :not(template)~ :not(template) {
  --space-x-reverse: 0;
  margin-right: calc(-60% * var(--space-x-reverse));
  margin-left: calc(-60% * calc(1 - var(--space-x-reverse)));
}
.-space-y-4\\/5> :not(template)~ :not(template) {
  --space-y-reverse: 0;
  margin-top: calc(-80% * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(-80% * var(--space-y-reverse));
}
.-space-x-4\\/5> :not(template)~ :not(template) {
  --space-x-reverse: 0;
  margin-right: calc(-80% * var(--space-x-reverse));
  margin-left: calc(-80% * calc(1 - var(--space-x-reverse)));
}
.-space-y-1\\/6> :not(template)~ :not(template) {
  --space-y-reverse: 0;
  margin-top: calc(-16.66667% * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(-16.66667% * var(--space-y-reverse));
}
.-space-x-1\\/6> :not(template)~ :not(template) {
  --space-x-reverse: 0;
  margin-right: calc(-16.66667% * var(--space-x-reverse));
  margin-left: calc(-16.66667% * calc(1 - var(--space-x-reverse)));
}
.-space-y-2\\/6> :not(template)~ :not(template) {
  --space-y-reverse: 0;
  margin-top: calc(-33.33333% * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(-33.33333% * var(--space-y-reverse));
}
.-space-x-2\\/6> :not(template)~ :not(template) {
  --space-x-reverse: 0;
  margin-right: calc(-33.33333% * var(--space-x-reverse));
  margin-left: calc(-33.33333% * calc(1 - var(--space-x-reverse)));
}
.-space-y-3\\/6> :not(template)~ :not(template) {
  --space-y-reverse: 0;
  margin-top: calc(-50% * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(-50% * var(--space-y-reverse));
}
.-space-x-3\\/6> :not(template)~ :not(template) {
  --space-x-reverse: 0;
  margin-right: calc(-50% * var(--space-x-reverse));
  margin-left: calc(-50% * calc(1 - var(--space-x-reverse)));
}
.-space-y-4\\/6> :not(template)~ :not(template) {
  --space-y-reverse: 0;
  margin-top: calc(-66.66667% * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(-66.66667% * var(--space-y-reverse));
}
.-space-x-4\\/6> :not(template)~ :not(template) {
  --space-x-reverse: 0;
  margin-right: calc(-66.66667% * var(--space-x-reverse));
  margin-left: calc(-66.66667% * calc(1 - var(--space-x-reverse)));
}
.-space-y-5\\/6> :not(template)~ :not(template) {
  --space-y-reverse: 0;
  margin-top: calc(-83.33333% * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(-83.33333% * var(--space-y-reverse));
}
.-space-x-5\\/6> :not(template)~ :not(template) {
  --space-x-reverse: 0;
  margin-right: calc(-83.33333% * var(--space-x-reverse));
  margin-left: calc(-83.33333% * calc(1 - var(--space-x-reverse)));
}
.-space-y-1\\/12> :not(template)~ :not(template) {
  --space-y-reverse: 0;
  margin-top: calc(-8.33333% * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(-8.33333% * var(--space-y-reverse));
}
.-space-x-1\\/12> :not(template)~ :not(template) {
  --space-x-reverse: 0;
  margin-right: calc(-8.33333% * var(--space-x-reverse));
  margin-left: calc(-8.33333% * calc(1 - var(--space-x-reverse)));
}
.-space-y-2\\/12> :not(template)~ :not(template) {
  --space-y-reverse: 0;
  margin-top: calc(-16.66667% * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(-16.66667% * var(--space-y-reverse));
}
.-space-x-2\\/12> :not(template)~ :not(template) {
  --space-x-reverse: 0;
  margin-right: calc(-16.66667% * var(--space-x-reverse));
  margin-left: calc(-16.66667% * calc(1 - var(--space-x-reverse)));
}
.-space-y-3\\/12> :not(template)~ :not(template) {
  --space-y-reverse: 0;
  margin-top: calc(-25% * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(-25% * var(--space-y-reverse));
}
.-space-x-3\\/12> :not(template)~ :not(template) {
  --space-x-reverse: 0;
  margin-right: calc(-25% * var(--space-x-reverse));
  margin-left: calc(-25% * calc(1 - var(--space-x-reverse)));
}
.-space-y-4\\/12> :not(template)~ :not(template) {
  --space-y-reverse: 0;
  margin-top: calc(-33.33333% * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(-33.33333% * var(--space-y-reverse));
}
.-space-x-4\\/12> :not(template)~ :not(template) {
  --space-x-reverse: 0;
  margin-right: calc(-33.33333% * var(--space-x-reverse));
  margin-left: calc(-33.33333% * calc(1 - var(--space-x-reverse)));
}
.-space-y-5\\/12> :not(template)~ :not(template) {
  --space-y-reverse: 0;
  margin-top: calc(-41.66667% * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(-41.66667% * var(--space-y-reverse));
}
.-space-x-5\\/12> :not(template)~ :not(template) {
  --space-x-reverse: 0;
  margin-right: calc(-41.66667% * var(--space-x-reverse));
  margin-left: calc(-41.66667% * calc(1 - var(--space-x-reverse)));
}
.-space-y-6\\/12> :not(template)~ :not(template) {
  --space-y-reverse: 0;
  margin-top: calc(-50% * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(-50% * var(--space-y-reverse));
}
.-space-x-6\\/12> :not(template)~ :not(template) {
  --space-x-reverse: 0;
  margin-right: calc(-50% * var(--space-x-reverse));
  margin-left: calc(-50% * calc(1 - var(--space-x-reverse)));
}
.-space-y-7\\/12> :not(template)~ :not(template) {
  --space-y-reverse: 0;
  margin-top: calc(-58.33333% * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(-58.33333% * var(--space-y-reverse));
}
.-space-x-7\\/12> :not(template)~ :not(template) {
  --space-x-reverse: 0;
  margin-right: calc(-58.33333% * var(--space-x-reverse));
  margin-left: calc(-58.33333% * calc(1 - var(--space-x-reverse)));
}
.-space-y-8\\/12> :not(template)~ :not(template) {
  --space-y-reverse: 0;
  margin-top: calc(-66.66667% * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(-66.66667% * var(--space-y-reverse));
}
.-space-x-8\\/12> :not(template)~ :not(template) {
  --space-x-reverse: 0;
  margin-right: calc(-66.66667% * var(--space-x-reverse));
  margin-left: calc(-66.66667% * calc(1 - var(--space-x-reverse)));
}
.-space-y-9\\/12> :not(template)~ :not(template) {
  --space-y-reverse: 0;
  margin-top: calc(-75% * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(-75% * var(--space-y-reverse));
}
.-space-x-9\\/12> :not(template)~ :not(template) {
  --space-x-reverse: 0;
  margin-right: calc(-75% * var(--space-x-reverse));
  margin-left: calc(-75% * calc(1 - var(--space-x-reverse)));
}
.-space-y-10\\/12> :not(template)~ :not(template) {
  --space-y-reverse: 0;
  margin-top: calc(-83.33333% * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(-83.33333% * var(--space-y-reverse));
}
.-space-x-10\\/12> :not(template)~ :not(template) {
  --space-x-reverse: 0;
  margin-right: calc(-83.33333% * var(--space-x-reverse));
  margin-left: calc(-83.33333% * calc(1 - var(--space-x-reverse)));
}
.-space-y-11\\/12> :not(template)~ :not(template) {
  --space-y-reverse: 0;
  margin-top: calc(-91.66667% * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(-91.66667% * var(--space-y-reverse));
}
.-space-x-11\\/12> :not(template)~ :not(template) {
  --space-x-reverse: 0;
  margin-right: calc(-91.66667% * var(--space-x-reverse));
  margin-left: calc(-91.66667% * calc(1 - var(--space-x-reverse)));
}
.-space-y-full> :not(template)~ :not(template) {
  --space-y-reverse: 0;
  margin-top: calc(-100% * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(-100% * var(--space-y-reverse));
}
.-space-x-full> :not(template)~ :not(template) {
  --space-x-reverse: 0;
  margin-right: calc(-100% * var(--space-x-reverse));
  margin-left: calc(-100% * calc(1 - var(--space-x-reverse)));
}
.space-y-reverse> :not(template)~ :not(template) {
  --space-y-reverse: 1;
}
.space-x-reverse> :not(template)~ :not(template) {
  --space-x-reverse: 1;
}
.divide-y-0> :not(template)~ :not(template) {
  --divide-y-reverse: 0;
  border-top-width: calc(0px * calc(1 - var(--divide-y-reverse)));
  border-bottom-width: calc(0px * var(--divide-y-reverse));
}
.divide-x-0> :not(template)~ :not(template) {
  --divide-x-reverse: 0;
  border-right-width: calc(0px * var(--divide-x-reverse));
  border-left-width: calc(0px * calc(1 - var(--divide-x-reverse)));
}
.divide-y-2> :not(template)~ :not(template) {
  --divide-y-reverse: 0;
  border-top-width: calc(2px * calc(1 - var(--divide-y-reverse)));
  border-bottom-width: calc(2px * var(--divide-y-reverse));
}
.divide-x-2> :not(template)~ :not(template) {
  --divide-x-reverse: 0;
  border-right-width: calc(2px * var(--divide-x-reverse));
  border-left-width: calc(2px * calc(1 - var(--divide-x-reverse)));
}
.divide-y-4> :not(template)~ :not(template) {
  --divide-y-reverse: 0;
  border-top-width: calc(4px * calc(1 - var(--divide-y-reverse)));
  border-bottom-width: calc(4px * var(--divide-y-reverse));
}
.divide-x-4> :not(template)~ :not(template) {
  --divide-x-reverse: 0;
  border-right-width: calc(4px * var(--divide-x-reverse));
  border-left-width: calc(4px * calc(1 - var(--divide-x-reverse)));
}
.divide-y-8> :not(template)~ :not(template) {
  --divide-y-reverse: 0;
  border-top-width: calc(8px * calc(1 - var(--divide-y-reverse)));
  border-bottom-width: calc(8px * var(--divide-y-reverse));
}
.divide-x-8> :not(template)~ :not(template) {
  --divide-x-reverse: 0;
  border-right-width: calc(8px * var(--divide-x-reverse));
  border-left-width: calc(8px * calc(1 - var(--divide-x-reverse)));
}
.divide-y> :not(template)~ :not(template) {
  --divide-y-reverse: 0;
  border-top-width: calc(1px * calc(1 - var(--divide-y-reverse)));
  border-bottom-width: calc(1px * var(--divide-y-reverse));
}
.divide-x> :not(template)~ :not(template) {
  --divide-x-reverse: 0;
  border-right-width: calc(1px * var(--divide-x-reverse));
  border-left-width: calc(1px * calc(1 - var(--divide-x-reverse)));
}
.divide-y-reverse> :not(template)~ :not(template) {
  --divide-y-reverse: 1;
}
.divide-x-reverse> :not(template)~ :not(template) {
  --divide-x-reverse: 1;
}
.divide-current> :not(template)~ :not(template) {
  border-color: currentColor;
}
.divide-transparent> :not(template)~ :not(template) {
  border-color: transparent;
}
.divide-white> :not(template)~ :not(template) {
  --divide-opacity: 1;
  border-color: #ffffff;
  border-color: rgba(255, 255, 255, var(--divide-opacity));
}
.divide-black> :not(template)~ :not(template) {
  --divide-opacity: 1;
  border-color: #000000;
  border-color: rgba(0, 0, 0, var(--divide-opacity));
}
.divide-gray-50> :not(template)~ :not(template) {
  --divide-opacity: 1;
  border-color: #f9fafb;
  border-color: rgba(249, 250, 251, var(--divide-opacity));
}
.divide-gray-100> :not(template)~ :not(template) {
  --divide-opacity: 1;
  border-color: #f4f5f7;
  border-color: rgba(244, 245, 247, var(--divide-opacity));
}
.divide-gray-200> :not(template)~ :not(template) {
  --divide-opacity: 1;
  border-color: #e5e7eb;
  border-color: rgba(229, 231, 235, var(--divide-opacity));
}
.divide-gray-300> :not(template)~ :not(template) {
  --divide-opacity: 1;
  border-color: #d2d6dc;
  border-color: rgba(210, 214, 220, var(--divide-opacity));
}
.divide-gray-400> :not(template)~ :not(template) {
  --divide-opacity: 1;
  border-color: #9fa6b2;
  border-color: rgba(159, 166, 178, var(--divide-opacity));
}
.divide-gray-500> :not(template)~ :not(template) {
  --divide-opacity: 1;
  border-color: #6b7280;
  border-color: rgba(107, 114, 128, var(--divide-opacity));
}
.divide-gray-600> :not(template)~ :not(template) {
  --divide-opacity: 1;
  border-color: #4b5563;
  border-color: rgba(75, 85, 99, var(--divide-opacity));
}
.divide-gray-700> :not(template)~ :not(template) {
  --divide-opacity: 1;
  border-color: #374151;
  border-color: rgba(55, 65, 81, var(--divide-opacity));
}
.divide-gray-800> :not(template)~ :not(template) {
  --divide-opacity: 1;
  border-color: #252f3f;
  border-color: rgba(37, 47, 63, var(--divide-opacity));
}
.divide-gray-900> :not(template)~ :not(template) {
  --divide-opacity: 1;
  border-color: #161e2e;
  border-color: rgba(22, 30, 46, var(--divide-opacity));
}
.divide-red-50> :not(template)~ :not(template) {
  --divide-opacity: 1;
  border-color: #fdf2f2;
  border-color: rgba(253, 242, 242, var(--divide-opacity));
}
.divide-red-100> :not(template)~ :not(template) {
  --divide-opacity: 1;
  border-color: #fde8e8;
  border-color: rgba(253, 232, 232, var(--divide-opacity));
}
.divide-red-200> :not(template)~ :not(template) {
  --divide-opacity: 1;
  border-color: #fbd5d5;
  border-color: rgba(251, 213, 213, var(--divide-opacity));
}
.divide-red-300> :not(template)~ :not(template) {
  --divide-opacity: 1;
  border-color: #f8b4b4;
  border-color: rgba(248, 180, 180, var(--divide-opacity));
}
.divide-red-400> :not(template)~ :not(template) {
  --divide-opacity: 1;
  border-color: #f98080;
  border-color: rgba(249, 128, 128, var(--divide-opacity));
}
.divide-red-500> :not(template)~ :not(template) {
  --divide-opacity: 1;
  border-color: #f05252;
  border-color: rgba(240, 82, 82, var(--divide-opacity));
}
.divide-red-600> :not(template)~ :not(template) {
  --divide-opacity: 1;
  border-color: #e02424;
  border-color: rgba(224, 36, 36, var(--divide-opacity));
}
.divide-red-700> :not(template)~ :not(template) {
  --divide-opacity: 1;
  border-color: #c81e1e;
  border-color: rgba(200, 30, 30, var(--divide-opacity));
}
.divide-red-800> :not(template)~ :not(template) {
  --divide-opacity: 1;
  border-color: #9b1c1c;
  border-color: rgba(155, 28, 28, var(--divide-opacity));
}
.divide-red-900> :not(template)~ :not(template) {
  --divide-opacity: 1;
  border-color: #771d1d;
  border-color: rgba(119, 29, 29, var(--divide-opacity));
}
.divide-orange-50> :not(template)~ :not(template) {
  --divide-opacity: 1;
  border-color: #fff8f1;
  border-color: rgba(255, 248, 241, var(--divide-opacity));
}
.divide-orange-100> :not(template)~ :not(template) {
  --divide-opacity: 1;
  border-color: #feecdc;
  border-color: rgba(254, 236, 220, var(--divide-opacity));
}
.divide-orange-200> :not(template)~ :not(template) {
  --divide-opacity: 1;
  border-color: #fcd9bd;
  border-color: rgba(252, 217, 189, var(--divide-opacity));
}
.divide-orange-300> :not(template)~ :not(template) {
  --divide-opacity: 1;
  border-color: #fdba8c;
  border-color: rgba(253, 186, 140, var(--divide-opacity));
}
.divide-orange-400> :not(template)~ :not(template) {
  --divide-opacity: 1;
  border-color: #ff8a4c;
  border-color: rgba(255, 138, 76, var(--divide-opacity));
}
.divide-orange-500> :not(template)~ :not(template) {
  --divide-opacity: 1;
  border-color: #ff5a1f;
  border-color: rgba(255, 90, 31, var(--divide-opacity));
}
.divide-orange-600> :not(template)~ :not(template) {
  --divide-opacity: 1;
  border-color: #d03801;
  border-color: rgba(208, 56, 1, var(--divide-opacity));
}
.divide-orange-700> :not(template)~ :not(template) {
  --divide-opacity: 1;
  border-color: #b43403;
  border-color: rgba(180, 52, 3, var(--divide-opacity));
}
.divide-orange-800> :not(template)~ :not(template) {
  --divide-opacity: 1;
  border-color: #8a2c0d;
  border-color: rgba(138, 44, 13, var(--divide-opacity));
}
.divide-orange-900> :not(template)~ :not(template) {
  --divide-opacity: 1;
  border-color: #73230d;
  border-color: rgba(115, 35, 13, var(--divide-opacity));
}
.divide-yellow-50> :not(template)~ :not(template) {
  --divide-opacity: 1;
  border-color: #fdfdea;
  border-color: rgba(253, 253, 234, var(--divide-opacity));
}
.divide-yellow-100> :not(template)~ :not(template) {
  --divide-opacity: 1;
  border-color: #fdf6b2;
  border-color: rgba(253, 246, 178, var(--divide-opacity));
}
.divide-yellow-200> :not(template)~ :not(template) {
  --divide-opacity: 1;
  border-color: #fce96a;
  border-color: rgba(252, 233, 106, var(--divide-opacity));
}
.divide-yellow-300> :not(template)~ :not(template) {
  --divide-opacity: 1;
  border-color: #faca15;
  border-color: rgba(250, 202, 21, var(--divide-opacity));
}
.divide-yellow-400> :not(template)~ :not(template) {
  --divide-opacity: 1;
  border-color: #e3a008;
  border-color: rgba(227, 160, 8, var(--divide-opacity));
}
.divide-yellow-500> :not(template)~ :not(template) {
  --divide-opacity: 1;
  border-color: #c27803;
  border-color: rgba(194, 120, 3, var(--divide-opacity));
}
.divide-yellow-600> :not(template)~ :not(template) {
  --divide-opacity: 1;
  border-color: #9f580a;
  border-color: rgba(159, 88, 10, var(--divide-opacity));
}
.divide-yellow-700> :not(template)~ :not(template) {
  --divide-opacity: 1;
  border-color: #8e4b10;
  border-color: rgba(142, 75, 16, var(--divide-opacity));
}
.divide-yellow-800> :not(template)~ :not(template) {
  --divide-opacity: 1;
  border-color: #723b13;
  border-color: rgba(114, 59, 19, var(--divide-opacity));
}
.divide-yellow-900> :not(template)~ :not(template) {
  --divide-opacity: 1;
  border-color: #633112;
  border-color: rgba(99, 49, 18, var(--divide-opacity));
}
.divide-green-50> :not(template)~ :not(template) {
  --divide-opacity: 1;
  border-color: #f3faf7;
  border-color: rgba(243, 250, 247, var(--divide-opacity));
}
.divide-green-100> :not(template)~ :not(template) {
  --divide-opacity: 1;
  border-color: #def7ec;
  border-color: rgba(222, 247, 236, var(--divide-opacity));
}
.divide-green-200> :not(template)~ :not(template) {
  --divide-opacity: 1;
  border-color: #bcf0da;
  border-color: rgba(188, 240, 218, var(--divide-opacity));
}
.divide-green-300> :not(template)~ :not(template) {
  --divide-opacity: 1;
  border-color: #84e1bc;
  border-color: rgba(132, 225, 188, var(--divide-opacity));
}
.divide-green-400> :not(template)~ :not(template) {
  --divide-opacity: 1;
  border-color: #31c48d;
  border-color: rgba(49, 196, 141, var(--divide-opacity));
}
.divide-green-500> :not(template)~ :not(template) {
  --divide-opacity: 1;
  border-color: #0e9f6e;
  border-color: rgba(14, 159, 110, var(--divide-opacity));
}
.divide-green-600> :not(template)~ :not(template) {
  --divide-opacity: 1;
  border-color: #057a55;
  border-color: rgba(5, 122, 85, var(--divide-opacity));
}
.divide-green-700> :not(template)~ :not(template) {
  --divide-opacity: 1;
  border-color: #046c4e;
  border-color: rgba(4, 108, 78, var(--divide-opacity));
}
.divide-green-800> :not(template)~ :not(template) {
  --divide-opacity: 1;
  border-color: #03543f;
  border-color: rgba(3, 84, 63, var(--divide-opacity));
}
.divide-green-900> :not(template)~ :not(template) {
  --divide-opacity: 1;
  border-color: #014737;
  border-color: rgba(1, 71, 55, var(--divide-opacity));
}
.divide-teal-50> :not(template)~ :not(template) {
  --divide-opacity: 1;
  border-color: #edfafa;
  border-color: rgba(237, 250, 250, var(--divide-opacity));
}
.divide-teal-100> :not(template)~ :not(template) {
  --divide-opacity: 1;
  border-color: #d5f5f6;
  border-color: rgba(213, 245, 246, var(--divide-opacity));
}
.divide-teal-200> :not(template)~ :not(template) {
  --divide-opacity: 1;
  border-color: #afecef;
  border-color: rgba(175, 236, 239, var(--divide-opacity));
}
.divide-teal-300> :not(template)~ :not(template) {
  --divide-opacity: 1;
  border-color: #7edce2;
  border-color: rgba(126, 220, 226, var(--divide-opacity));
}
.divide-teal-400> :not(template)~ :not(template) {
  --divide-opacity: 1;
  border-color: #16bdca;
  border-color: rgba(22, 189, 202, var(--divide-opacity));
}
.divide-teal-500> :not(template)~ :not(template) {
  --divide-opacity: 1;
  border-color: #0694a2;
  border-color: rgba(6, 148, 162, var(--divide-opacity));
}
.divide-teal-600> :not(template)~ :not(template) {
  --divide-opacity: 1;
  border-color: #047481;
  border-color: rgba(4, 116, 129, var(--divide-opacity));
}
.divide-teal-700> :not(template)~ :not(template) {
  --divide-opacity: 1;
  border-color: #036672;
  border-color: rgba(3, 102, 114, var(--divide-opacity));
}
.divide-teal-800> :not(template)~ :not(template) {
  --divide-opacity: 1;
  border-color: #05505c;
  border-color: rgba(5, 80, 92, var(--divide-opacity));
}
.divide-teal-900> :not(template)~ :not(template) {
  --divide-opacity: 1;
  border-color: #014451;
  border-color: rgba(1, 68, 81, var(--divide-opacity));
}
.divide-blue-50> :not(template)~ :not(template) {
  --divide-opacity: 1;
  border-color: #ebf5ff;
  border-color: rgba(235, 245, 255, var(--divide-opacity));
}
.divide-blue-100> :not(template)~ :not(template) {
  --divide-opacity: 1;
  border-color: #e1effe;
  border-color: rgba(225, 239, 254, var(--divide-opacity));
}
.divide-blue-200> :not(template)~ :not(template) {
  --divide-opacity: 1;
  border-color: #c3ddfd;
  border-color: rgba(195, 221, 253, var(--divide-opacity));
}
.divide-blue-300> :not(template)~ :not(template) {
  --divide-opacity: 1;
  border-color: #a4cafe;
  border-color: rgba(164, 202, 254, var(--divide-opacity));
}
.divide-blue-400> :not(template)~ :not(template) {
  --divide-opacity: 1;
  border-color: #76a9fa;
  border-color: rgba(118, 169, 250, var(--divide-opacity));
}
.divide-blue-500> :not(template)~ :not(template) {
  --divide-opacity: 1;
  border-color: #3f83f8;
  border-color: rgba(63, 131, 248, var(--divide-opacity));
}
.divide-blue-600> :not(template)~ :not(template) {
  --divide-opacity: 1;
  border-color: #1c64f2;
  border-color: rgba(28, 100, 242, var(--divide-opacity));
}
.divide-blue-700> :not(template)~ :not(template) {
  --divide-opacity: 1;
  border-color: #1a56db;
  border-color: rgba(26, 86, 219, var(--divide-opacity));
}
.divide-blue-800> :not(template)~ :not(template) {
  --divide-opacity: 1;
  border-color: #1e429f;
  border-color: rgba(30, 66, 159, var(--divide-opacity));
}
.divide-blue-900> :not(template)~ :not(template) {
  --divide-opacity: 1;
  border-color: #233876;
  border-color: rgba(35, 56, 118, var(--divide-opacity));
}
.divide-indigo-50> :not(template)~ :not(template) {
  --divide-opacity: 1;
  border-color: #f0f5ff;
  border-color: rgba(240, 245, 255, var(--divide-opacity));
}
.divide-indigo-100> :not(template)~ :not(template) {
  --divide-opacity: 1;
  border-color: #e5edff;
  border-color: rgba(229, 237, 255, var(--divide-opacity));
}
.divide-indigo-200> :not(template)~ :not(template) {
  --divide-opacity: 1;
  border-color: #cddbfe;
  border-color: rgba(205, 219, 254, var(--divide-opacity));
}
.divide-indigo-300> :not(template)~ :not(template) {
  --divide-opacity: 1;
  border-color: #b4c6fc;
  border-color: rgba(180, 198, 252, var(--divide-opacity));
}
.divide-indigo-400> :not(template)~ :not(template) {
  --divide-opacity: 1;
  border-color: #8da2fb;
  border-color: rgba(141, 162, 251, var(--divide-opacity));
}
.divide-indigo-500> :not(template)~ :not(template) {
  --divide-opacity: 1;
  border-color: #6875f5;
  border-color: rgba(104, 117, 245, var(--divide-opacity));
}
.divide-indigo-600> :not(template)~ :not(template) {
  --divide-opacity: 1;
  border-color: #5850ec;
  border-color: rgba(88, 80, 236, var(--divide-opacity));
}
.divide-indigo-700> :not(template)~ :not(template) {
  --divide-opacity: 1;
  border-color: #5145cd;
  border-color: rgba(81, 69, 205, var(--divide-opacity));
}
.divide-indigo-800> :not(template)~ :not(template) {
  --divide-opacity: 1;
  border-color: #42389d;
  border-color: rgba(66, 56, 157, var(--divide-opacity));
}
.divide-indigo-900> :not(template)~ :not(template) {
  --divide-opacity: 1;
  border-color: #362f78;
  border-color: rgba(54, 47, 120, var(--divide-opacity));
}
.divide-purple-50> :not(template)~ :not(template) {
  --divide-opacity: 1;
  border-color: #f6f5ff;
  border-color: rgba(246, 245, 255, var(--divide-opacity));
}
.divide-purple-100> :not(template)~ :not(template) {
  --divide-opacity: 1;
  border-color: #edebfe;
  border-color: rgba(237, 235, 254, var(--divide-opacity));
}
.divide-purple-200> :not(template)~ :not(template) {
  --divide-opacity: 1;
  border-color: #dcd7fe;
  border-color: rgba(220, 215, 254, var(--divide-opacity));
}
.divide-purple-300> :not(template)~ :not(template) {
  --divide-opacity: 1;
  border-color: #cabffd;
  border-color: rgba(202, 191, 253, var(--divide-opacity));
}
.divide-purple-400> :not(template)~ :not(template) {
  --divide-opacity: 1;
  border-color: #ac94fa;
  border-color: rgba(172, 148, 250, var(--divide-opacity));
}
.divide-purple-500> :not(template)~ :not(template) {
  --divide-opacity: 1;
  border-color: #9061f9;
  border-color: rgba(144, 97, 249, var(--divide-opacity));
}
.divide-purple-600> :not(template)~ :not(template) {
  --divide-opacity: 1;
  border-color: #7e3af2;
  border-color: rgba(126, 58, 242, var(--divide-opacity));
}
.divide-purple-700> :not(template)~ :not(template) {
  --divide-opacity: 1;
  border-color: #6c2bd9;
  border-color: rgba(108, 43, 217, var(--divide-opacity));
}
.divide-purple-800> :not(template)~ :not(template) {
  --divide-opacity: 1;
  border-color: #5521b5;
  border-color: rgba(85, 33, 181, var(--divide-opacity));
}
.divide-purple-900> :not(template)~ :not(template) {
  --divide-opacity: 1;
  border-color: #4a1d96;
  border-color: rgba(74, 29, 150, var(--divide-opacity));
}
.divide-pink-50> :not(template)~ :not(template) {
  --divide-opacity: 1;
  border-color: #fdf2f8;
  border-color: rgba(253, 242, 248, var(--divide-opacity));
}
.divide-pink-100> :not(template)~ :not(template) {
  --divide-opacity: 1;
  border-color: #fce8f3;
  border-color: rgba(252, 232, 243, var(--divide-opacity));
}
.divide-pink-200> :not(template)~ :not(template) {
  --divide-opacity: 1;
  border-color: #fad1e8;
  border-color: rgba(250, 209, 232, var(--divide-opacity));
}
.divide-pink-300> :not(template)~ :not(template) {
  --divide-opacity: 1;
  border-color: #f8b4d9;
  border-color: rgba(248, 180, 217, var(--divide-opacity));
}
.divide-pink-400> :not(template)~ :not(template) {
  --divide-opacity: 1;
  border-color: #f17eb8;
  border-color: rgba(241, 126, 184, var(--divide-opacity));
}
.divide-pink-500> :not(template)~ :not(template) {
  --divide-opacity: 1;
  border-color: #e74694;
  border-color: rgba(231, 70, 148, var(--divide-opacity));
}
.divide-pink-600> :not(template)~ :not(template) {
  --divide-opacity: 1;
  border-color: #d61f69;
  border-color: rgba(214, 31, 105, var(--divide-opacity));
}
.divide-pink-700> :not(template)~ :not(template) {
  --divide-opacity: 1;
  border-color: #bf125d;
  border-color: rgba(191, 18, 93, var(--divide-opacity));
}
.divide-pink-800> :not(template)~ :not(template) {
  --divide-opacity: 1;
  border-color: #99154b;
  border-color: rgba(153, 21, 75, var(--divide-opacity));
}
.divide-pink-900> :not(template)~ :not(template) {
  --divide-opacity: 1;
  border-color: #751a3d;
  border-color: rgba(117, 26, 61, var(--divide-opacity));
}
.divide-cool-gray-50> :not(template)~ :not(template) {
  --divide-opacity: 1;
  border-color: #f8fafc;
  border-color: rgba(248, 250, 252, var(--divide-opacity));
}
.divide-cool-gray-100> :not(template)~ :not(template) {
  --divide-opacity: 1;
  border-color: #f1f5f9;
  border-color: rgba(241, 245, 249, var(--divide-opacity));
}
.divide-cool-gray-200> :not(template)~ :not(template) {
  --divide-opacity: 1;
  border-color: #e2e8f0;
  border-color: rgba(226, 232, 240, var(--divide-opacity));
}
.divide-cool-gray-300> :not(template)~ :not(template) {
  --divide-opacity: 1;
  border-color: #cfd8e3;
  border-color: rgba(207, 216, 227, var(--divide-opacity));
}
.divide-cool-gray-400> :not(template)~ :not(template) {
  --divide-opacity: 1;
  border-color: #97a6ba;
  border-color: rgba(151, 166, 186, var(--divide-opacity));
}
.divide-cool-gray-500> :not(template)~ :not(template) {
  --divide-opacity: 1;
  border-color: #64748b;
  border-color: rgba(100, 116, 139, var(--divide-opacity));
}
.divide-cool-gray-600> :not(template)~ :not(template) {
  --divide-opacity: 1;
  border-color: #475569;
  border-color: rgba(71, 85, 105, var(--divide-opacity));
}
.divide-cool-gray-700> :not(template)~ :not(template) {
  --divide-opacity: 1;
  border-color: #364152;
  border-color: rgba(54, 65, 82, var(--divide-opacity));
}
.divide-cool-gray-800> :not(template)~ :not(template) {
  --divide-opacity: 1;
  border-color: #27303f;
  border-color: rgba(39, 48, 63, var(--divide-opacity));
}
.divide-cool-gray-900> :not(template)~ :not(template) {
  --divide-opacity: 1;
  border-color: #1a202e;
  border-color: rgba(26, 32, 46, var(--divide-opacity));
}
.divide-solid> :not(template)~ :not(template) {
  border-style: solid;
}
.divide-dashed> :not(template)~ :not(template) {
  border-style: dashed;
}
.divide-dotted> :not(template)~ :not(template) {
  border-style: dotted;
}
.divide-double> :not(template)~ :not(template) {
  border-style: double;
}
.divide-none> :not(template)~ :not(template) {
  border-style: none;
}
.divide-opacity-0> :not(template)~ :not(template) {
  --divide-opacity: 0;
}
.divide-opacity-25> :not(template)~ :not(template) {
  --divide-opacity: 0.25;
}
.divide-opacity-50> :not(template)~ :not(template) {
  --divide-opacity: 0.5;
}
.divide-opacity-75> :not(template)~ :not(template) {
  --divide-opacity: 0.75;
}
.divide-opacity-100> :not(template)~ :not(template) {
  --divide-opacity: 1;
}
.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
.not-sr-only {
  position: static;
  width: auto;
  height: auto;
  padding: 0;
  margin: 0;
  overflow: visible;
  clip: auto;
  white-space: normal;
}
.focus\\:sr-only:focus {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
.focus\\:not-sr-only:focus {
  position: static;
  width: auto;
  height: auto;
  padding: 0;
  margin: 0;
  overflow: visible;
  clip: auto;
  white-space: normal;
}
.appearance-none {
  appearance: none;
}
.bg-fixed {
  background-attachment: fixed;
}
.bg-local {
  background-attachment: local;
}
.bg-scroll {
  background-attachment: scroll;
}
.bg-clip-border {
  background-clip: border-box;
}
.bg-clip-padding {
  background-clip: padding-box;
}
.bg-clip-content {
  background-clip: content-box;
}
.bg-clip-text {
  -webkit-background-clip: text;
  background-clip: text;
}
.bg-current {
  background-color: currentColor;
}
.bg-transparent {
  background-color: transparent;
}
.bg-white {
  --bg-opacity: 1;
  background-color: #ffffff;
  background-color: rgba(255, 255, 255, var(--bg-opacity));
}
.bg-black {
  --bg-opacity: 1;
  background-color: #000000;
  background-color: rgba(0, 0, 0, var(--bg-opacity));
}
.bg-gray-50 {
  --bg-opacity: 1;
  background-color: #f9fafb;
  background-color: rgba(249, 250, 251, var(--bg-opacity));
}
.bg-gray-100 {
  --bg-opacity: 1;
  background-color: #f4f5f7;
  background-color: rgba(244, 245, 247, var(--bg-opacity));
}
.bg-gray-200 {
  --bg-opacity: 1;
  background-color: #e5e7eb;
  background-color: rgba(229, 231, 235, var(--bg-opacity));
}
.bg-gray-300 {
  --bg-opacity: 1;
  background-color: #d2d6dc;
  background-color: rgba(210, 214, 220, var(--bg-opacity));
}
.bg-gray-400 {
  --bg-opacity: 1;
  background-color: #9fa6b2;
  background-color: rgba(159, 166, 178, var(--bg-opacity));
}
.bg-gray-500 {
  --bg-opacity: 1;
  background-color: #6b7280;
  background-color: rgba(107, 114, 128, var(--bg-opacity));
}
.bg-gray-600 {
  --bg-opacity: 1;
  background-color: #4b5563;
  background-color: rgba(75, 85, 99, var(--bg-opacity));
}
.bg-gray-700 {
  --bg-opacity: 1;
  background-color: #374151;
  background-color: rgba(55, 65, 81, var(--bg-opacity));
}
.bg-gray-800 {
  --bg-opacity: 1;
  background-color: #252f3f;
  background-color: rgba(37, 47, 63, var(--bg-opacity));
}
.bg-gray-900 {
  --bg-opacity: 1;
  background-color: #161e2e;
  background-color: rgba(22, 30, 46, var(--bg-opacity));
}
.bg-red-50 {
  --bg-opacity: 1;
  background-color: #fdf2f2;
  background-color: rgba(253, 242, 242, var(--bg-opacity));
}
.bg-red-100 {
  --bg-opacity: 1;
  background-color: #fde8e8;
  background-color: rgba(253, 232, 232, var(--bg-opacity));
}
.bg-red-200 {
  --bg-opacity: 1;
  background-color: #fbd5d5;
  background-color: rgba(251, 213, 213, var(--bg-opacity));
}
.bg-red-300 {
  --bg-opacity: 1;
  background-color: #f8b4b4;
  background-color: rgba(248, 180, 180, var(--bg-opacity));
}
.bg-red-400 {
  --bg-opacity: 1;
  background-color: #f98080;
  background-color: rgba(249, 128, 128, var(--bg-opacity));
}
.bg-red-500 {
  --bg-opacity: 1;
  background-color: #f05252;
  background-color: rgba(240, 82, 82, var(--bg-opacity));
}
.bg-red-600 {
  --bg-opacity: 1;
  background-color: #e02424;
  background-color: rgba(224, 36, 36, var(--bg-opacity));
}
.bg-red-700 {
  --bg-opacity: 1;
  background-color: #c81e1e;
  background-color: rgba(200, 30, 30, var(--bg-opacity));
}
.bg-red-800 {
  --bg-opacity: 1;
  background-color: #9b1c1c;
  background-color: rgba(155, 28, 28, var(--bg-opacity));
}
.bg-red-900 {
  --bg-opacity: 1;
  background-color: #771d1d;
  background-color: rgba(119, 29, 29, var(--bg-opacity));
}
.bg-orange-50 {
  --bg-opacity: 1;
  background-color: #fff8f1;
  background-color: rgba(255, 248, 241, var(--bg-opacity));
}
.bg-orange-100 {
  --bg-opacity: 1;
  background-color: #feecdc;
  background-color: rgba(254, 236, 220, var(--bg-opacity));
}
.bg-orange-200 {
  --bg-opacity: 1;
  background-color: #fcd9bd;
  background-color: rgba(252, 217, 189, var(--bg-opacity));
}
.bg-orange-300 {
  --bg-opacity: 1;
  background-color: #fdba8c;
  background-color: rgba(253, 186, 140, var(--bg-opacity));
}
.bg-orange-400 {
  --bg-opacity: 1;
  background-color: #ff8a4c;
  background-color: rgba(255, 138, 76, var(--bg-opacity));
}
.bg-orange-500 {
  --bg-opacity: 1;
  background-color: #ff5a1f;
  background-color: rgba(255, 90, 31, var(--bg-opacity));
}
.bg-orange-600 {
  --bg-opacity: 1;
  background-color: #d03801;
  background-color: rgba(208, 56, 1, var(--bg-opacity));
}
.bg-orange-700 {
  --bg-opacity: 1;
  background-color: #b43403;
  background-color: rgba(180, 52, 3, var(--bg-opacity));
}
.bg-orange-800 {
  --bg-opacity: 1;
  background-color: #8a2c0d;
  background-color: rgba(138, 44, 13, var(--bg-opacity));
}
.bg-orange-900 {
  --bg-opacity: 1;
  background-color: #73230d;
  background-color: rgba(115, 35, 13, var(--bg-opacity));
}
.bg-yellow-50 {
  --bg-opacity: 1;
  background-color: #fdfdea;
  background-color: rgba(253, 253, 234, var(--bg-opacity));
}
.bg-yellow-100 {
  --bg-opacity: 1;
  background-color: #fdf6b2;
  background-color: rgba(253, 246, 178, var(--bg-opacity));
}
.bg-yellow-200 {
  --bg-opacity: 1;
  background-color: #fce96a;
  background-color: rgba(252, 233, 106, var(--bg-opacity));
}
.bg-yellow-300 {
  --bg-opacity: 1;
  background-color: #faca15;
  background-color: rgba(250, 202, 21, var(--bg-opacity));
}
.bg-yellow-400 {
  --bg-opacity: 1;
  background-color: #e3a008;
  background-color: rgba(227, 160, 8, var(--bg-opacity));
}
.bg-yellow-500 {
  --bg-opacity: 1;
  background-color: #c27803;
  background-color: rgba(194, 120, 3, var(--bg-opacity));
}
.bg-yellow-600 {
  --bg-opacity: 1;
  background-color: #9f580a;
  background-color: rgba(159, 88, 10, var(--bg-opacity));
}
.bg-yellow-700 {
  --bg-opacity: 1;
  background-color: #8e4b10;
  background-color: rgba(142, 75, 16, var(--bg-opacity));
}
.bg-yellow-800 {
  --bg-opacity: 1;
  background-color: #723b13;
  background-color: rgba(114, 59, 19, var(--bg-opacity));
}
.bg-yellow-900 {
  --bg-opacity: 1;
  background-color: #633112;
  background-color: rgba(99, 49, 18, var(--bg-opacity));
}
.bg-green-50 {
  --bg-opacity: 1;
  background-color: #f3faf7;
  background-color: rgba(243, 250, 247, var(--bg-opacity));
}
.bg-green-100 {
  --bg-opacity: 1;
  background-color: #def7ec;
  background-color: rgba(222, 247, 236, var(--bg-opacity));
}
.bg-green-200 {
  --bg-opacity: 1;
  background-color: #bcf0da;
  background-color: rgba(188, 240, 218, var(--bg-opacity));
}
.bg-green-300 {
  --bg-opacity: 1;
  background-color: #84e1bc;
  background-color: rgba(132, 225, 188, var(--bg-opacity));
}
.bg-green-400 {
  --bg-opacity: 1;
  background-color: #31c48d;
  background-color: rgba(49, 196, 141, var(--bg-opacity));
}
.bg-green-500 {
  --bg-opacity: 1;
  background-color: #0e9f6e;
  background-color: rgba(14, 159, 110, var(--bg-opacity));
}
.bg-green-600 {
  --bg-opacity: 1;
  background-color: #057a55;
  background-color: rgba(5, 122, 85, var(--bg-opacity));
}
.bg-green-700 {
  --bg-opacity: 1;
  background-color: #046c4e;
  background-color: rgba(4, 108, 78, var(--bg-opacity));
}
.bg-green-800 {
  --bg-opacity: 1;
  background-color: #03543f;
  background-color: rgba(3, 84, 63, var(--bg-opacity));
}
.bg-green-900 {
  --bg-opacity: 1;
  background-color: #014737;
  background-color: rgba(1, 71, 55, var(--bg-opacity));
}
.bg-teal-50 {
  --bg-opacity: 1;
  background-color: #edfafa;
  background-color: rgba(237, 250, 250, var(--bg-opacity));
}
.bg-teal-100 {
  --bg-opacity: 1;
  background-color: #d5f5f6;
  background-color: rgba(213, 245, 246, var(--bg-opacity));
}
.bg-teal-200 {
  --bg-opacity: 1;
  background-color: #afecef;
  background-color: rgba(175, 236, 239, var(--bg-opacity));
}
.bg-teal-300 {
  --bg-opacity: 1;
  background-color: #7edce2;
  background-color: rgba(126, 220, 226, var(--bg-opacity));
}
.bg-teal-400 {
  --bg-opacity: 1;
  background-color: #16bdca;
  background-color: rgba(22, 189, 202, var(--bg-opacity));
}
.bg-teal-500 {
  --bg-opacity: 1;
  background-color: #0694a2;
  background-color: rgba(6, 148, 162, var(--bg-opacity));
}
.bg-teal-600 {
  --bg-opacity: 1;
  background-color: #047481;
  background-color: rgba(4, 116, 129, var(--bg-opacity));
}
.bg-teal-700 {
  --bg-opacity: 1;
  background-color: #036672;
  background-color: rgba(3, 102, 114, var(--bg-opacity));
}
.bg-teal-800 {
  --bg-opacity: 1;
  background-color: #05505c;
  background-color: rgba(5, 80, 92, var(--bg-opacity));
}
.bg-teal-900 {
  --bg-opacity: 1;
  background-color: #014451;
  background-color: rgba(1, 68, 81, var(--bg-opacity));
}
.bg-blue-50 {
  --bg-opacity: 1;
  background-color: #ebf5ff;
  background-color: rgba(235, 245, 255, var(--bg-opacity));
}
.bg-blue-100 {
  --bg-opacity: 1;
  background-color: #e1effe;
  background-color: rgba(225, 239, 254, var(--bg-opacity));
}
.bg-blue-200 {
  --bg-opacity: 1;
  background-color: #c3ddfd;
  background-color: rgba(195, 221, 253, var(--bg-opacity));
}
.bg-blue-300 {
  --bg-opacity: 1;
  background-color: #a4cafe;
  background-color: rgba(164, 202, 254, var(--bg-opacity));
}
.bg-blue-400 {
  --bg-opacity: 1;
  background-color: #76a9fa;
  background-color: rgba(118, 169, 250, var(--bg-opacity));
}
.bg-blue-500 {
  --bg-opacity: 1;
  background-color: #3f83f8;
  background-color: rgba(63, 131, 248, var(--bg-opacity));
}
.bg-blue-600 {
  --bg-opacity: 1;
  background-color: #1c64f2;
  background-color: rgba(28, 100, 242, var(--bg-opacity));
}
.bg-blue-700 {
  --bg-opacity: 1;
  background-color: #1a56db;
  background-color: rgba(26, 86, 219, var(--bg-opacity));
}
.bg-blue-800 {
  --bg-opacity: 1;
  background-color: #1e429f;
  background-color: rgba(30, 66, 159, var(--bg-opacity));
}
.bg-blue-900 {
  --bg-opacity: 1;
  background-color: #233876;
  background-color: rgba(35, 56, 118, var(--bg-opacity));
}
.bg-indigo-50 {
  --bg-opacity: 1;
  background-color: #f0f5ff;
  background-color: rgba(240, 245, 255, var(--bg-opacity));
}
.bg-indigo-100 {
  --bg-opacity: 1;
  background-color: #e5edff;
  background-color: rgba(229, 237, 255, var(--bg-opacity));
}
.bg-indigo-200 {
  --bg-opacity: 1;
  background-color: #cddbfe;
  background-color: rgba(205, 219, 254, var(--bg-opacity));
}
.bg-indigo-300 {
  --bg-opacity: 1;
  background-color: #b4c6fc;
  background-color: rgba(180, 198, 252, var(--bg-opacity));
}
.bg-indigo-400 {
  --bg-opacity: 1;
  background-color: #8da2fb;
  background-color: rgba(141, 162, 251, var(--bg-opacity));
}
.bg-indigo-500 {
  --bg-opacity: 1;
  background-color: #6875f5;
  background-color: rgba(104, 117, 245, var(--bg-opacity));
}
.bg-indigo-600 {
  --bg-opacity: 1;
  background-color: #5850ec;
  background-color: rgba(88, 80, 236, var(--bg-opacity));
}
.bg-indigo-700 {
  --bg-opacity: 1;
  background-color: #5145cd;
  background-color: rgba(81, 69, 205, var(--bg-opacity));
}
.bg-indigo-800 {
  --bg-opacity: 1;
  background-color: #42389d;
  background-color: rgba(66, 56, 157, var(--bg-opacity));
}
.bg-indigo-900 {
  --bg-opacity: 1;
  background-color: #362f78;
  background-color: rgba(54, 47, 120, var(--bg-opacity));
}
.bg-purple-50 {
  --bg-opacity: 1;
  background-color: #f6f5ff;
  background-color: rgba(246, 245, 255, var(--bg-opacity));
}
.bg-purple-100 {
  --bg-opacity: 1;
  background-color: #edebfe;
  background-color: rgba(237, 235, 254, var(--bg-opacity));
}
.bg-purple-200 {
  --bg-opacity: 1;
  background-color: #dcd7fe;
  background-color: rgba(220, 215, 254, var(--bg-opacity));
}
.bg-purple-300 {
  --bg-opacity: 1;
  background-color: #cabffd;
  background-color: rgba(202, 191, 253, var(--bg-opacity));
}
.bg-purple-400 {
  --bg-opacity: 1;
  background-color: #ac94fa;
  background-color: rgba(172, 148, 250, var(--bg-opacity));
}
.bg-purple-500 {
  --bg-opacity: 1;
  background-color: #9061f9;
  background-color: rgba(144, 97, 249, var(--bg-opacity));
}
.bg-purple-600 {
  --bg-opacity: 1;
  background-color: #7e3af2;
  background-color: rgba(126, 58, 242, var(--bg-opacity));
}
.bg-purple-700 {
  --bg-opacity: 1;
  background-color: #6c2bd9;
  background-color: rgba(108, 43, 217, var(--bg-opacity));
}
.bg-purple-800 {
  --bg-opacity: 1;
  background-color: #5521b5;
  background-color: rgba(85, 33, 181, var(--bg-opacity));
}
.bg-purple-900 {
  --bg-opacity: 1;
  background-color: #4a1d96;
  background-color: rgba(74, 29, 150, var(--bg-opacity));
}
.bg-pink-50 {
  --bg-opacity: 1;
  background-color: #fdf2f8;
  background-color: rgba(253, 242, 248, var(--bg-opacity));
}
.bg-pink-100 {
  --bg-opacity: 1;
  background-color: #fce8f3;
  background-color: rgba(252, 232, 243, var(--bg-opacity));
}
.bg-pink-200 {
  --bg-opacity: 1;
  background-color: #fad1e8;
  background-color: rgba(250, 209, 232, var(--bg-opacity));
}
.bg-pink-300 {
  --bg-opacity: 1;
  background-color: #f8b4d9;
  background-color: rgba(248, 180, 217, var(--bg-opacity));
}
.bg-pink-400 {
  --bg-opacity: 1;
  background-color: #f17eb8;
  background-color: rgba(241, 126, 184, var(--bg-opacity));
}
.bg-pink-500 {
  --bg-opacity: 1;
  background-color: #e74694;
  background-color: rgba(231, 70, 148, var(--bg-opacity));
}
.bg-pink-600 {
  --bg-opacity: 1;
  background-color: #d61f69;
  background-color: rgba(214, 31, 105, var(--bg-opacity));
}
.bg-pink-700 {
  --bg-opacity: 1;
  background-color: #bf125d;
  background-color: rgba(191, 18, 93, var(--bg-opacity));
}
.bg-pink-800 {
  --bg-opacity: 1;
  background-color: #99154b;
  background-color: rgba(153, 21, 75, var(--bg-opacity));
}
.bg-pink-900 {
  --bg-opacity: 1;
  background-color: #751a3d;
  background-color: rgba(117, 26, 61, var(--bg-opacity));
}
.bg-cool-gray-50 {
  --bg-opacity: 1;
  background-color: #f8fafc;
  background-color: rgba(248, 250, 252, var(--bg-opacity));
}
.bg-cool-gray-100 {
  --bg-opacity: 1;
  background-color: #f1f5f9;
  background-color: rgba(241, 245, 249, var(--bg-opacity));
}
.bg-cool-gray-200 {
  --bg-opacity: 1;
  background-color: #e2e8f0;
  background-color: rgba(226, 232, 240, var(--bg-opacity));
}
.bg-cool-gray-300 {
  --bg-opacity: 1;
  background-color: #cfd8e3;
  background-color: rgba(207, 216, 227, var(--bg-opacity));
}
.bg-cool-gray-400 {
  --bg-opacity: 1;
  background-color: #97a6ba;
  background-color: rgba(151, 166, 186, var(--bg-opacity));
}
.bg-cool-gray-500 {
  --bg-opacity: 1;
  background-color: #64748b;
  background-color: rgba(100, 116, 139, var(--bg-opacity));
}
.bg-cool-gray-600 {
  --bg-opacity: 1;
  background-color: #475569;
  background-color: rgba(71, 85, 105, var(--bg-opacity));
}
.bg-cool-gray-700 {
  --bg-opacity: 1;
  background-color: #364152;
  background-color: rgba(54, 65, 82, var(--bg-opacity));
}
.bg-cool-gray-800 {
  --bg-opacity: 1;
  background-color: #27303f;
  background-color: rgba(39, 48, 63, var(--bg-opacity));
}
.bg-cool-gray-900 {
  --bg-opacity: 1;
  background-color: #1a202e;
  background-color: rgba(26, 32, 46, var(--bg-opacity));
}
.group:hover .group-hover\\:bg-current {
  background-color: currentColor;
}
.group:hover .group-hover\\:bg-transparent {
  background-color: transparent;
}
.group:hover .group-hover\\:bg-white {
  --bg-opacity: 1;
  background-color: #ffffff;
  background-color: rgba(255, 255, 255, var(--bg-opacity));
}
.group:hover .group-hover\\:bg-black {
  --bg-opacity: 1;
  background-color: #000000;
  background-color: rgba(0, 0, 0, var(--bg-opacity));
}
.group:hover .group-hover\\:bg-gray-50 {
  --bg-opacity: 1;
  background-color: #f9fafb;
  background-color: rgba(249, 250, 251, var(--bg-opacity));
}
.group:hover .group-hover\\:bg-gray-100 {
  --bg-opacity: 1;
  background-color: #f4f5f7;
  background-color: rgba(244, 245, 247, var(--bg-opacity));
}
.group:hover .group-hover\\:bg-gray-200 {
  --bg-opacity: 1;
  background-color: #e5e7eb;
  background-color: rgba(229, 231, 235, var(--bg-opacity));
}
.group:hover .group-hover\\:bg-gray-300 {
  --bg-opacity: 1;
  background-color: #d2d6dc;
  background-color: rgba(210, 214, 220, var(--bg-opacity));
}
.group:hover .group-hover\\:bg-gray-400 {
  --bg-opacity: 1;
  background-color: #9fa6b2;
  background-color: rgba(159, 166, 178, var(--bg-opacity));
}
.group:hover .group-hover\\:bg-gray-500 {
  --bg-opacity: 1;
  background-color: #6b7280;
  background-color: rgba(107, 114, 128, var(--bg-opacity));
}
.group:hover .group-hover\\:bg-gray-600 {
  --bg-opacity: 1;
  background-color: #4b5563;
  background-color: rgba(75, 85, 99, var(--bg-opacity));
}
.group:hover .group-hover\\:bg-gray-700 {
  --bg-opacity: 1;
  background-color: #374151;
  background-color: rgba(55, 65, 81, var(--bg-opacity));
}
.group:hover .group-hover\\:bg-gray-800 {
  --bg-opacity: 1;
  background-color: #252f3f;
  background-color: rgba(37, 47, 63, var(--bg-opacity));
}
.group:hover .group-hover\\:bg-gray-900 {
  --bg-opacity: 1;
  background-color: #161e2e;
  background-color: rgba(22, 30, 46, var(--bg-opacity));
}
.group:hover .group-hover\\:bg-red-50 {
  --bg-opacity: 1;
  background-color: #fdf2f2;
  background-color: rgba(253, 242, 242, var(--bg-opacity));
}
.group:hover .group-hover\\:bg-red-100 {
  --bg-opacity: 1;
  background-color: #fde8e8;
  background-color: rgba(253, 232, 232, var(--bg-opacity));
}
.group:hover .group-hover\\:bg-red-200 {
  --bg-opacity: 1;
  background-color: #fbd5d5;
  background-color: rgba(251, 213, 213, var(--bg-opacity));
}
.group:hover .group-hover\\:bg-red-300 {
  --bg-opacity: 1;
  background-color: #f8b4b4;
  background-color: rgba(248, 180, 180, var(--bg-opacity));
}
.group:hover .group-hover\\:bg-red-400 {
  --bg-opacity: 1;
  background-color: #f98080;
  background-color: rgba(249, 128, 128, var(--bg-opacity));
}
.group:hover .group-hover\\:bg-red-500 {
  --bg-opacity: 1;
  background-color: #f05252;
  background-color: rgba(240, 82, 82, var(--bg-opacity));
}
.group:hover .group-hover\\:bg-red-600 {
  --bg-opacity: 1;
  background-color: #e02424;
  background-color: rgba(224, 36, 36, var(--bg-opacity));
}
.group:hover .group-hover\\:bg-red-700 {
  --bg-opacity: 1;
  background-color: #c81e1e;
  background-color: rgba(200, 30, 30, var(--bg-opacity));
}
.group:hover .group-hover\\:bg-red-800 {
  --bg-opacity: 1;
  background-color: #9b1c1c;
  background-color: rgba(155, 28, 28, var(--bg-opacity));
}
.group:hover .group-hover\\:bg-red-900 {
  --bg-opacity: 1;
  background-color: #771d1d;
  background-color: rgba(119, 29, 29, var(--bg-opacity));
}
.group:hover .group-hover\\:bg-orange-50 {
  --bg-opacity: 1;
  background-color: #fff8f1;
  background-color: rgba(255, 248, 241, var(--bg-opacity));
}
.group:hover .group-hover\\:bg-orange-100 {
  --bg-opacity: 1;
  background-color: #feecdc;
  background-color: rgba(254, 236, 220, var(--bg-opacity));
}
.group:hover .group-hover\\:bg-orange-200 {
  --bg-opacity: 1;
  background-color: #fcd9bd;
  background-color: rgba(252, 217, 189, var(--bg-opacity));
}
.group:hover .group-hover\\:bg-orange-300 {
  --bg-opacity: 1;
  background-color: #fdba8c;
  background-color: rgba(253, 186, 140, var(--bg-opacity));
}
.group:hover .group-hover\\:bg-orange-400 {
  --bg-opacity: 1;
  background-color: #ff8a4c;
  background-color: rgba(255, 138, 76, var(--bg-opacity));
}
.group:hover .group-hover\\:bg-orange-500 {
  --bg-opacity: 1;
  background-color: #ff5a1f;
  background-color: rgba(255, 90, 31, var(--bg-opacity));
}
.group:hover .group-hover\\:bg-orange-600 {
  --bg-opacity: 1;
  background-color: #d03801;
  background-color: rgba(208, 56, 1, var(--bg-opacity));
}
.group:hover .group-hover\\:bg-orange-700 {
  --bg-opacity: 1;
  background-color: #b43403;
  background-color: rgba(180, 52, 3, var(--bg-opacity));
}
.group:hover .group-hover\\:bg-orange-800 {
  --bg-opacity: 1;
  background-color: #8a2c0d;
  background-color: rgba(138, 44, 13, var(--bg-opacity));
}
.group:hover .group-hover\\:bg-orange-900 {
  --bg-opacity: 1;
  background-color: #73230d;
  background-color: rgba(115, 35, 13, var(--bg-opacity));
}
.group:hover .group-hover\\:bg-yellow-50 {
  --bg-opacity: 1;
  background-color: #fdfdea;
  background-color: rgba(253, 253, 234, var(--bg-opacity));
}
.group:hover .group-hover\\:bg-yellow-100 {
  --bg-opacity: 1;
  background-color: #fdf6b2;
  background-color: rgba(253, 246, 178, var(--bg-opacity));
}
.group:hover .group-hover\\:bg-yellow-200 {
  --bg-opacity: 1;
  background-color: #fce96a;
  background-color: rgba(252, 233, 106, var(--bg-opacity));
}
.group:hover .group-hover\\:bg-yellow-300 {
  --bg-opacity: 1;
  background-color: #faca15;
  background-color: rgba(250, 202, 21, var(--bg-opacity));
}
.group:hover .group-hover\\:bg-yellow-400 {
  --bg-opacity: 1;
  background-color: #e3a008;
  background-color: rgba(227, 160, 8, var(--bg-opacity));
}
.group:hover .group-hover\\:bg-yellow-500 {
  --bg-opacity: 1;
  background-color: #c27803;
  background-color: rgba(194, 120, 3, var(--bg-opacity));
}
.group:hover .group-hover\\:bg-yellow-600 {
  --bg-opacity: 1;
  background-color: #9f580a;
  background-color: rgba(159, 88, 10, var(--bg-opacity));
}
.group:hover .group-hover\\:bg-yellow-700 {
  --bg-opacity: 1;
  background-color: #8e4b10;
  background-color: rgba(142, 75, 16, var(--bg-opacity));
}
.group:hover .group-hover\\:bg-yellow-800 {
  --bg-opacity: 1;
  background-color: #723b13;
  background-color: rgba(114, 59, 19, var(--bg-opacity));
}
.group:hover .group-hover\\:bg-yellow-900 {
  --bg-opacity: 1;
  background-color: #633112;
  background-color: rgba(99, 49, 18, var(--bg-opacity));
}
.group:hover .group-hover\\:bg-green-50 {
  --bg-opacity: 1;
  background-color: #f3faf7;
  background-color: rgba(243, 250, 247, var(--bg-opacity));
}
.group:hover .group-hover\\:bg-green-100 {
  --bg-opacity: 1;
  background-color: #def7ec;
  background-color: rgba(222, 247, 236, var(--bg-opacity));
}
.group:hover .group-hover\\:bg-green-200 {
  --bg-opacity: 1;
  background-color: #bcf0da;
  background-color: rgba(188, 240, 218, var(--bg-opacity));
}
.group:hover .group-hover\\:bg-green-300 {
  --bg-opacity: 1;
  background-color: #84e1bc;
  background-color: rgba(132, 225, 188, var(--bg-opacity));
}
.group:hover .group-hover\\:bg-green-400 {
  --bg-opacity: 1;
  background-color: #31c48d;
  background-color: rgba(49, 196, 141, var(--bg-opacity));
}
.group:hover .group-hover\\:bg-green-500 {
  --bg-opacity: 1;
  background-color: #0e9f6e;
  background-color: rgba(14, 159, 110, var(--bg-opacity));
}
.group:hover .group-hover\\:bg-green-600 {
  --bg-opacity: 1;
  background-color: #057a55;
  background-color: rgba(5, 122, 85, var(--bg-opacity));
}
.group:hover .group-hover\\:bg-green-700 {
  --bg-opacity: 1;
  background-color: #046c4e;
  background-color: rgba(4, 108, 78, var(--bg-opacity));
}
.group:hover .group-hover\\:bg-green-800 {
  --bg-opacity: 1;
  background-color: #03543f;
  background-color: rgba(3, 84, 63, var(--bg-opacity));
}
.group:hover .group-hover\\:bg-green-900 {
  --bg-opacity: 1;
  background-color: #014737;
  background-color: rgba(1, 71, 55, var(--bg-opacity));
}
.group:hover .group-hover\\:bg-teal-50 {
  --bg-opacity: 1;
  background-color: #edfafa;
  background-color: rgba(237, 250, 250, var(--bg-opacity));
}
.group:hover .group-hover\\:bg-teal-100 {
  --bg-opacity: 1;
  background-color: #d5f5f6;
  background-color: rgba(213, 245, 246, var(--bg-opacity));
}
.group:hover .group-hover\\:bg-teal-200 {
  --bg-opacity: 1;
  background-color: #afecef;
  background-color: rgba(175, 236, 239, var(--bg-opacity));
}
.group:hover .group-hover\\:bg-teal-300 {
  --bg-opacity: 1;
  background-color: #7edce2;
  background-color: rgba(126, 220, 226, var(--bg-opacity));
}
.group:hover .group-hover\\:bg-teal-400 {
  --bg-opacity: 1;
  background-color: #16bdca;
  background-color: rgba(22, 189, 202, var(--bg-opacity));
}
.group:hover .group-hover\\:bg-teal-500 {
  --bg-opacity: 1;
  background-color: #0694a2;
  background-color: rgba(6, 148, 162, var(--bg-opacity));
}
.group:hover .group-hover\\:bg-teal-600 {
  --bg-opacity: 1;
  background-color: #047481;
  background-color: rgba(4, 116, 129, var(--bg-opacity));
}
.group:hover .group-hover\\:bg-teal-700 {
  --bg-opacity: 1;
  background-color: #036672;
  background-color: rgba(3, 102, 114, var(--bg-opacity));
}
.group:hover .group-hover\\:bg-teal-800 {
  --bg-opacity: 1;
  background-color: #05505c;
  background-color: rgba(5, 80, 92, var(--bg-opacity));
}
.group:hover .group-hover\\:bg-teal-900 {
  --bg-opacity: 1;
  background-color: #014451;
  background-color: rgba(1, 68, 81, var(--bg-opacity));
}
.group:hover .group-hover\\:bg-blue-50 {
  --bg-opacity: 1;
  background-color: #ebf5ff;
  background-color: rgba(235, 245, 255, var(--bg-opacity));
}
.group:hover .group-hover\\:bg-blue-100 {
  --bg-opacity: 1;
  background-color: #e1effe;
  background-color: rgba(225, 239, 254, var(--bg-opacity));
}
.group:hover .group-hover\\:bg-blue-200 {
  --bg-opacity: 1;
  background-color: #c3ddfd;
  background-color: rgba(195, 221, 253, var(--bg-opacity));
}
.group:hover .group-hover\\:bg-blue-300 {
  --bg-opacity: 1;
  background-color: #a4cafe;
  background-color: rgba(164, 202, 254, var(--bg-opacity));
}
.group:hover .group-hover\\:bg-blue-400 {
  --bg-opacity: 1;
  background-color: #76a9fa;
  background-color: rgba(118, 169, 250, var(--bg-opacity));
}
.group:hover .group-hover\\:bg-blue-500 {
  --bg-opacity: 1;
  background-color: #3f83f8;
  background-color: rgba(63, 131, 248, var(--bg-opacity));
}
.group:hover .group-hover\\:bg-blue-600 {
  --bg-opacity: 1;
  background-color: #1c64f2;
  background-color: rgba(28, 100, 242, var(--bg-opacity));
}
.group:hover .group-hover\\:bg-blue-700 {
  --bg-opacity: 1;
  background-color: #1a56db;
  background-color: rgba(26, 86, 219, var(--bg-opacity));
}
.group:hover .group-hover\\:bg-blue-800 {
  --bg-opacity: 1;
  background-color: #1e429f;
  background-color: rgba(30, 66, 159, var(--bg-opacity));
}
.group:hover .group-hover\\:bg-blue-900 {
  --bg-opacity: 1;
  background-color: #233876;
  background-color: rgba(35, 56, 118, var(--bg-opacity));
}
.group:hover .group-hover\\:bg-indigo-50 {
  --bg-opacity: 1;
  background-color: #f0f5ff;
  background-color: rgba(240, 245, 255, var(--bg-opacity));
}
.group:hover .group-hover\\:bg-indigo-100 {
  --bg-opacity: 1;
  background-color: #e5edff;
  background-color: rgba(229, 237, 255, var(--bg-opacity));
}
.group:hover .group-hover\\:bg-indigo-200 {
  --bg-opacity: 1;
  background-color: #cddbfe;
  background-color: rgba(205, 219, 254, var(--bg-opacity));
}
.group:hover .group-hover\\:bg-indigo-300 {
  --bg-opacity: 1;
  background-color: #b4c6fc;
  background-color: rgba(180, 198, 252, var(--bg-opacity));
}
.group:hover .group-hover\\:bg-indigo-400 {
  --bg-opacity: 1;
  background-color: #8da2fb;
  background-color: rgba(141, 162, 251, var(--bg-opacity));
}
.group:hover .group-hover\\:bg-indigo-500 {
  --bg-opacity: 1;
  background-color: #6875f5;
  background-color: rgba(104, 117, 245, var(--bg-opacity));
}
.group:hover .group-hover\\:bg-indigo-600 {
  --bg-opacity: 1;
  background-color: #5850ec;
  background-color: rgba(88, 80, 236, var(--bg-opacity));
}
.group:hover .group-hover\\:bg-indigo-700 {
  --bg-opacity: 1;
  background-color: #5145cd;
  background-color: rgba(81, 69, 205, var(--bg-opacity));
}
.group:hover .group-hover\\:bg-indigo-800 {
  --bg-opacity: 1;
  background-color: #42389d;
  background-color: rgba(66, 56, 157, var(--bg-opacity));
}
.group:hover .group-hover\\:bg-indigo-900 {
  --bg-opacity: 1;
  background-color: #362f78;
  background-color: rgba(54, 47, 120, var(--bg-opacity));
}
.group:hover .group-hover\\:bg-purple-50 {
  --bg-opacity: 1;
  background-color: #f6f5ff;
  background-color: rgba(246, 245, 255, var(--bg-opacity));
}
.group:hover .group-hover\\:bg-purple-100 {
  --bg-opacity: 1;
  background-color: #edebfe;
  background-color: rgba(237, 235, 254, var(--bg-opacity));
}
.group:hover .group-hover\\:bg-purple-200 {
  --bg-opacity: 1;
  background-color: #dcd7fe;
  background-color: rgba(220, 215, 254, var(--bg-opacity));
}
.group:hover .group-hover\\:bg-purple-300 {
  --bg-opacity: 1;
  background-color: #cabffd;
  background-color: rgba(202, 191, 253, var(--bg-opacity));
}
.group:hover .group-hover\\:bg-purple-400 {
  --bg-opacity: 1;
  background-color: #ac94fa;
  background-color: rgba(172, 148, 250, var(--bg-opacity));
}
.group:hover .group-hover\\:bg-purple-500 {
  --bg-opacity: 1;
  background-color: #9061f9;
  background-color: rgba(144, 97, 249, var(--bg-opacity));
}
.group:hover .group-hover\\:bg-purple-600 {
  --bg-opacity: 1;
  background-color: #7e3af2;
  background-color: rgba(126, 58, 242, var(--bg-opacity));
}
.group:hover .group-hover\\:bg-purple-700 {
  --bg-opacity: 1;
  background-color: #6c2bd9;
  background-color: rgba(108, 43, 217, var(--bg-opacity));
}
.group:hover .group-hover\\:bg-purple-800 {
  --bg-opacity: 1;
  background-color: #5521b5;
  background-color: rgba(85, 33, 181, var(--bg-opacity));
}
.group:hover .group-hover\\:bg-purple-900 {
  --bg-opacity: 1;
  background-color: #4a1d96;
  background-color: rgba(74, 29, 150, var(--bg-opacity));
}
.group:hover .group-hover\\:bg-pink-50 {
  --bg-opacity: 1;
  background-color: #fdf2f8;
  background-color: rgba(253, 242, 248, var(--bg-opacity));
}
.group:hover .group-hover\\:bg-pink-100 {
  --bg-opacity: 1;
  background-color: #fce8f3;
  background-color: rgba(252, 232, 243, var(--bg-opacity));
}
.group:hover .group-hover\\:bg-pink-200 {
  --bg-opacity: 1;
  background-color: #fad1e8;
  background-color: rgba(250, 209, 232, var(--bg-opacity));
}
.group:hover .group-hover\\:bg-pink-300 {
  --bg-opacity: 1;
  background-color: #f8b4d9;
  background-color: rgba(248, 180, 217, var(--bg-opacity));
}
.group:hover .group-hover\\:bg-pink-400 {
  --bg-opacity: 1;
  background-color: #f17eb8;
  background-color: rgba(241, 126, 184, var(--bg-opacity));
}
.group:hover .group-hover\\:bg-pink-500 {
  --bg-opacity: 1;
  background-color: #e74694;
  background-color: rgba(231, 70, 148, var(--bg-opacity));
}
.group:hover .group-hover\\:bg-pink-600 {
  --bg-opacity: 1;
  background-color: #d61f69;
  background-color: rgba(214, 31, 105, var(--bg-opacity));
}
.group:hover .group-hover\\:bg-pink-700 {
  --bg-opacity: 1;
  background-color: #bf125d;
  background-color: rgba(191, 18, 93, var(--bg-opacity));
}
.group:hover .group-hover\\:bg-pink-800 {
  --bg-opacity: 1;
  background-color: #99154b;
  background-color: rgba(153, 21, 75, var(--bg-opacity));
}
.group:hover .group-hover\\:bg-pink-900 {
  --bg-opacity: 1;
  background-color: #751a3d;
  background-color: rgba(117, 26, 61, var(--bg-opacity));
}
.group:hover .group-hover\\:bg-cool-gray-50 {
  --bg-opacity: 1;
  background-color: #f8fafc;
  background-color: rgba(248, 250, 252, var(--bg-opacity));
}
.group:hover .group-hover\\:bg-cool-gray-100 {
  --bg-opacity: 1;
  background-color: #f1f5f9;
  background-color: rgba(241, 245, 249, var(--bg-opacity));
}
.group:hover .group-hover\\:bg-cool-gray-200 {
  --bg-opacity: 1;
  background-color: #e2e8f0;
  background-color: rgba(226, 232, 240, var(--bg-opacity));
}
.group:hover .group-hover\\:bg-cool-gray-300 {
  --bg-opacity: 1;
  background-color: #cfd8e3;
  background-color: rgba(207, 216, 227, var(--bg-opacity));
}
.group:hover .group-hover\\:bg-cool-gray-400 {
  --bg-opacity: 1;
  background-color: #97a6ba;
  background-color: rgba(151, 166, 186, var(--bg-opacity));
}
.group:hover .group-hover\\:bg-cool-gray-500 {
  --bg-opacity: 1;
  background-color: #64748b;
  background-color: rgba(100, 116, 139, var(--bg-opacity));
}
.group:hover .group-hover\\:bg-cool-gray-600 {
  --bg-opacity: 1;
  background-color: #475569;
  background-color: rgba(71, 85, 105, var(--bg-opacity));
}
.group:hover .group-hover\\:bg-cool-gray-700 {
  --bg-opacity: 1;
  background-color: #364152;
  background-color: rgba(54, 65, 82, var(--bg-opacity));
}
.group:hover .group-hover\\:bg-cool-gray-800 {
  --bg-opacity: 1;
  background-color: #27303f;
  background-color: rgba(39, 48, 63, var(--bg-opacity));
}
.group:hover .group-hover\\:bg-cool-gray-900 {
  --bg-opacity: 1;
  background-color: #1a202e;
  background-color: rgba(26, 32, 46, var(--bg-opacity));
}
.group:focus .group-focus\\:bg-current {
  background-color: currentColor;
}
.group:focus .group-focus\\:bg-transparent {
  background-color: transparent;
}
.group:focus .group-focus\\:bg-white {
  --bg-opacity: 1;
  background-color: #ffffff;
  background-color: rgba(255, 255, 255, var(--bg-opacity));
}
.group:focus .group-focus\\:bg-black {
  --bg-opacity: 1;
  background-color: #000000;
  background-color: rgba(0, 0, 0, var(--bg-opacity));
}
.group:focus .group-focus\\:bg-gray-50 {
  --bg-opacity: 1;
  background-color: #f9fafb;
  background-color: rgba(249, 250, 251, var(--bg-opacity));
}
.group:focus .group-focus\\:bg-gray-100 {
  --bg-opacity: 1;
  background-color: #f4f5f7;
  background-color: rgba(244, 245, 247, var(--bg-opacity));
}
.group:focus .group-focus\\:bg-gray-200 {
  --bg-opacity: 1;
  background-color: #e5e7eb;
  background-color: rgba(229, 231, 235, var(--bg-opacity));
}
.group:focus .group-focus\\:bg-gray-300 {
  --bg-opacity: 1;
  background-color: #d2d6dc;
  background-color: rgba(210, 214, 220, var(--bg-opacity));
}
.group:focus .group-focus\\:bg-gray-400 {
  --bg-opacity: 1;
  background-color: #9fa6b2;
  background-color: rgba(159, 166, 178, var(--bg-opacity));
}
.group:focus .group-focus\\:bg-gray-500 {
  --bg-opacity: 1;
  background-color: #6b7280;
  background-color: rgba(107, 114, 128, var(--bg-opacity));
}
.group:focus .group-focus\\:bg-gray-600 {
  --bg-opacity: 1;
  background-color: #4b5563;
  background-color: rgba(75, 85, 99, var(--bg-opacity));
}
.group:focus .group-focus\\:bg-gray-700 {
  --bg-opacity: 1;
  background-color: #374151;
  background-color: rgba(55, 65, 81, var(--bg-opacity));
}
.group:focus .group-focus\\:bg-gray-800 {
  --bg-opacity: 1;
  background-color: #252f3f;
  background-color: rgba(37, 47, 63, var(--bg-opacity));
}
.group:focus .group-focus\\:bg-gray-900 {
  --bg-opacity: 1;
  background-color: #161e2e;
  background-color: rgba(22, 30, 46, var(--bg-opacity));
}
.group:focus .group-focus\\:bg-red-50 {
  --bg-opacity: 1;
  background-color: #fdf2f2;
  background-color: rgba(253, 242, 242, var(--bg-opacity));
}
.group:focus .group-focus\\:bg-red-100 {
  --bg-opacity: 1;
  background-color: #fde8e8;
  background-color: rgba(253, 232, 232, var(--bg-opacity));
}
.group:focus .group-focus\\:bg-red-200 {
  --bg-opacity: 1;
  background-color: #fbd5d5;
  background-color: rgba(251, 213, 213, var(--bg-opacity));
}
.group:focus .group-focus\\:bg-red-300 {
  --bg-opacity: 1;
  background-color: #f8b4b4;
  background-color: rgba(248, 180, 180, var(--bg-opacity));
}
.group:focus .group-focus\\:bg-red-400 {
  --bg-opacity: 1;
  background-color: #f98080;
  background-color: rgba(249, 128, 128, var(--bg-opacity));
}
.group:focus .group-focus\\:bg-red-500 {
  --bg-opacity: 1;
  background-color: #f05252;
  background-color: rgba(240, 82, 82, var(--bg-opacity));
}
.group:focus .group-focus\\:bg-red-600 {
  --bg-opacity: 1;
  background-color: #e02424;
  background-color: rgba(224, 36, 36, var(--bg-opacity));
}
.group:focus .group-focus\\:bg-red-700 {
  --bg-opacity: 1;
  background-color: #c81e1e;
  background-color: rgba(200, 30, 30, var(--bg-opacity));
}
.group:focus .group-focus\\:bg-red-800 {
  --bg-opacity: 1;
  background-color: #9b1c1c;
  background-color: rgba(155, 28, 28, var(--bg-opacity));
}
.group:focus .group-focus\\:bg-red-900 {
  --bg-opacity: 1;
  background-color: #771d1d;
  background-color: rgba(119, 29, 29, var(--bg-opacity));
}
.group:focus .group-focus\\:bg-orange-50 {
  --bg-opacity: 1;
  background-color: #fff8f1;
  background-color: rgba(255, 248, 241, var(--bg-opacity));
}
.group:focus .group-focus\\:bg-orange-100 {
  --bg-opacity: 1;
  background-color: #feecdc;
  background-color: rgba(254, 236, 220, var(--bg-opacity));
}
.group:focus .group-focus\\:bg-orange-200 {
  --bg-opacity: 1;
  background-color: #fcd9bd;
  background-color: rgba(252, 217, 189, var(--bg-opacity));
}
.group:focus .group-focus\\:bg-orange-300 {
  --bg-opacity: 1;
  background-color: #fdba8c;
  background-color: rgba(253, 186, 140, var(--bg-opacity));
}
.group:focus .group-focus\\:bg-orange-400 {
  --bg-opacity: 1;
  background-color: #ff8a4c;
  background-color: rgba(255, 138, 76, var(--bg-opacity));
}
.group:focus .group-focus\\:bg-orange-500 {
  --bg-opacity: 1;
  background-color: #ff5a1f;
  background-color: rgba(255, 90, 31, var(--bg-opacity));
}
.group:focus .group-focus\\:bg-orange-600 {
  --bg-opacity: 1;
  background-color: #d03801;
  background-color: rgba(208, 56, 1, var(--bg-opacity));
}
.group:focus .group-focus\\:bg-orange-700 {
  --bg-opacity: 1;
  background-color: #b43403;
  background-color: rgba(180, 52, 3, var(--bg-opacity));
}
.group:focus .group-focus\\:bg-orange-800 {
  --bg-opacity: 1;
  background-color: #8a2c0d;
  background-color: rgba(138, 44, 13, var(--bg-opacity));
}
.group:focus .group-focus\\:bg-orange-900 {
  --bg-opacity: 1;
  background-color: #73230d;
  background-color: rgba(115, 35, 13, var(--bg-opacity));
}
.group:focus .group-focus\\:bg-yellow-50 {
  --bg-opacity: 1;
  background-color: #fdfdea;
  background-color: rgba(253, 253, 234, var(--bg-opacity));
}
.group:focus .group-focus\\:bg-yellow-100 {
  --bg-opacity: 1;
  background-color: #fdf6b2;
  background-color: rgba(253, 246, 178, var(--bg-opacity));
}
.group:focus .group-focus\\:bg-yellow-200 {
  --bg-opacity: 1;
  background-color: #fce96a;
  background-color: rgba(252, 233, 106, var(--bg-opacity));
}
.group:focus .group-focus\\:bg-yellow-300 {
  --bg-opacity: 1;
  background-color: #faca15;
  background-color: rgba(250, 202, 21, var(--bg-opacity));
}
.group:focus .group-focus\\:bg-yellow-400 {
  --bg-opacity: 1;
  background-color: #e3a008;
  background-color: rgba(227, 160, 8, var(--bg-opacity));
}
.group:focus .group-focus\\:bg-yellow-500 {
  --bg-opacity: 1;
  background-color: #c27803;
  background-color: rgba(194, 120, 3, var(--bg-opacity));
}
.group:focus .group-focus\\:bg-yellow-600 {
  --bg-opacity: 1;
  background-color: #9f580a;
  background-color: rgba(159, 88, 10, var(--bg-opacity));
}
.group:focus .group-focus\\:bg-yellow-700 {
  --bg-opacity: 1;
  background-color: #8e4b10;
  background-color: rgba(142, 75, 16, var(--bg-opacity));
}
.group:focus .group-focus\\:bg-yellow-800 {
  --bg-opacity: 1;
  background-color: #723b13;
  background-color: rgba(114, 59, 19, var(--bg-opacity));
}
.group:focus .group-focus\\:bg-yellow-900 {
  --bg-opacity: 1;
  background-color: #633112;
  background-color: rgba(99, 49, 18, var(--bg-opacity));
}
.group:focus .group-focus\\:bg-green-50 {
  --bg-opacity: 1;
  background-color: #f3faf7;
  background-color: rgba(243, 250, 247, var(--bg-opacity));
}
.group:focus .group-focus\\:bg-green-100 {
  --bg-opacity: 1;
  background-color: #def7ec;
  background-color: rgba(222, 247, 236, var(--bg-opacity));
}
.group:focus .group-focus\\:bg-green-200 {
  --bg-opacity: 1;
  background-color: #bcf0da;
  background-color: rgba(188, 240, 218, var(--bg-opacity));
}
.group:focus .group-focus\\:bg-green-300 {
  --bg-opacity: 1;
  background-color: #84e1bc;
  background-color: rgba(132, 225, 188, var(--bg-opacity));
}
.group:focus .group-focus\\:bg-green-400 {
  --bg-opacity: 1;
  background-color: #31c48d;
  background-color: rgba(49, 196, 141, var(--bg-opacity));
}
.group:focus .group-focus\\:bg-green-500 {
  --bg-opacity: 1;
  background-color: #0e9f6e;
  background-color: rgba(14, 159, 110, var(--bg-opacity));
}
.group:focus .group-focus\\:bg-green-600 {
  --bg-opacity: 1;
  background-color: #057a55;
  background-color: rgba(5, 122, 85, var(--bg-opacity));
}
.group:focus .group-focus\\:bg-green-700 {
  --bg-opacity: 1;
  background-color: #046c4e;
  background-color: rgba(4, 108, 78, var(--bg-opacity));
}
.group:focus .group-focus\\:bg-green-800 {
  --bg-opacity: 1;
  background-color: #03543f;
  background-color: rgba(3, 84, 63, var(--bg-opacity));
}
.group:focus .group-focus\\:bg-green-900 {
  --bg-opacity: 1;
  background-color: #014737;
  background-color: rgba(1, 71, 55, var(--bg-opacity));
}
.group:focus .group-focus\\:bg-teal-50 {
  --bg-opacity: 1;
  background-color: #edfafa;
  background-color: rgba(237, 250, 250, var(--bg-opacity));
}
.group:focus .group-focus\\:bg-teal-100 {
  --bg-opacity: 1;
  background-color: #d5f5f6;
  background-color: rgba(213, 245, 246, var(--bg-opacity));
}
.group:focus .group-focus\\:bg-teal-200 {
  --bg-opacity: 1;
  background-color: #afecef;
  background-color: rgba(175, 236, 239, var(--bg-opacity));
}
.group:focus .group-focus\\:bg-teal-300 {
  --bg-opacity: 1;
  background-color: #7edce2;
  background-color: rgba(126, 220, 226, var(--bg-opacity));
}
.group:focus .group-focus\\:bg-teal-400 {
  --bg-opacity: 1;
  background-color: #16bdca;
  background-color: rgba(22, 189, 202, var(--bg-opacity));
}
.group:focus .group-focus\\:bg-teal-500 {
  --bg-opacity: 1;
  background-color: #0694a2;
  background-color: rgba(6, 148, 162, var(--bg-opacity));
}
.group:focus .group-focus\\:bg-teal-600 {
  --bg-opacity: 1;
  background-color: #047481;
  background-color: rgba(4, 116, 129, var(--bg-opacity));
}
.group:focus .group-focus\\:bg-teal-700 {
  --bg-opacity: 1;
  background-color: #036672;
  background-color: rgba(3, 102, 114, var(--bg-opacity));
}
.group:focus .group-focus\\:bg-teal-800 {
  --bg-opacity: 1;
  background-color: #05505c;
  background-color: rgba(5, 80, 92, var(--bg-opacity));
}
.group:focus .group-focus\\:bg-teal-900 {
  --bg-opacity: 1;
  background-color: #014451;
  background-color: rgba(1, 68, 81, var(--bg-opacity));
}
.group:focus .group-focus\\:bg-blue-50 {
  --bg-opacity: 1;
  background-color: #ebf5ff;
  background-color: rgba(235, 245, 255, var(--bg-opacity));
}
.group:focus .group-focus\\:bg-blue-100 {
  --bg-opacity: 1;
  background-color: #e1effe;
  background-color: rgba(225, 239, 254, var(--bg-opacity));
}
.group:focus .group-focus\\:bg-blue-200 {
  --bg-opacity: 1;
  background-color: #c3ddfd;
  background-color: rgba(195, 221, 253, var(--bg-opacity));
}
.group:focus .group-focus\\:bg-blue-300 {
  --bg-opacity: 1;
  background-color: #a4cafe;
  background-color: rgba(164, 202, 254, var(--bg-opacity));
}
.group:focus .group-focus\\:bg-blue-400 {
  --bg-opacity: 1;
  background-color: #76a9fa;
  background-color: rgba(118, 169, 250, var(--bg-opacity));
}
.group:focus .group-focus\\:bg-blue-500 {
  --bg-opacity: 1;
  background-color: #3f83f8;
  background-color: rgba(63, 131, 248, var(--bg-opacity));
}
.group:focus .group-focus\\:bg-blue-600 {
  --bg-opacity: 1;
  background-color: #1c64f2;
  background-color: rgba(28, 100, 242, var(--bg-opacity));
}
.group:focus .group-focus\\:bg-blue-700 {
  --bg-opacity: 1;
  background-color: #1a56db;
  background-color: rgba(26, 86, 219, var(--bg-opacity));
}
.group:focus .group-focus\\:bg-blue-800 {
  --bg-opacity: 1;
  background-color: #1e429f;
  background-color: rgba(30, 66, 159, var(--bg-opacity));
}
.group:focus .group-focus\\:bg-blue-900 {
  --bg-opacity: 1;
  background-color: #233876;
  background-color: rgba(35, 56, 118, var(--bg-opacity));
}
.group:focus .group-focus\\:bg-indigo-50 {
  --bg-opacity: 1;
  background-color: #f0f5ff;
  background-color: rgba(240, 245, 255, var(--bg-opacity));
}
.group:focus .group-focus\\:bg-indigo-100 {
  --bg-opacity: 1;
  background-color: #e5edff;
  background-color: rgba(229, 237, 255, var(--bg-opacity));
}
.group:focus .group-focus\\:bg-indigo-200 {
  --bg-opacity: 1;
  background-color: #cddbfe;
  background-color: rgba(205, 219, 254, var(--bg-opacity));
}
.group:focus .group-focus\\:bg-indigo-300 {
  --bg-opacity: 1;
  background-color: #b4c6fc;
  background-color: rgba(180, 198, 252, var(--bg-opacity));
}
.group:focus .group-focus\\:bg-indigo-400 {
  --bg-opacity: 1;
  background-color: #8da2fb;
  background-color: rgba(141, 162, 251, var(--bg-opacity));
}
.group:focus .group-focus\\:bg-indigo-500 {
  --bg-opacity: 1;
  background-color: #6875f5;
  background-color: rgba(104, 117, 245, var(--bg-opacity));
}
.group:focus .group-focus\\:bg-indigo-600 {
  --bg-opacity: 1;
  background-color: #5850ec;
  background-color: rgba(88, 80, 236, var(--bg-opacity));
}
.group:focus .group-focus\\:bg-indigo-700 {
  --bg-opacity: 1;
  background-color: #5145cd;
  background-color: rgba(81, 69, 205, var(--bg-opacity));
}
.group:focus .group-focus\\:bg-indigo-800 {
  --bg-opacity: 1;
  background-color: #42389d;
  background-color: rgba(66, 56, 157, var(--bg-opacity));
}
.group:focus .group-focus\\:bg-indigo-900 {
  --bg-opacity: 1;
  background-color: #362f78;
  background-color: rgba(54, 47, 120, var(--bg-opacity));
}
.group:focus .group-focus\\:bg-purple-50 {
  --bg-opacity: 1;
  background-color: #f6f5ff;
  background-color: rgba(246, 245, 255, var(--bg-opacity));
}
.group:focus .group-focus\\:bg-purple-100 {
  --bg-opacity: 1;
  background-color: #edebfe;
  background-color: rgba(237, 235, 254, var(--bg-opacity));
}
.group:focus .group-focus\\:bg-purple-200 {
  --bg-opacity: 1;
  background-color: #dcd7fe;
  background-color: rgba(220, 215, 254, var(--bg-opacity));
}
.group:focus .group-focus\\:bg-purple-300 {
  --bg-opacity: 1;
  background-color: #cabffd;
  background-color: rgba(202, 191, 253, var(--bg-opacity));
}
.group:focus .group-focus\\:bg-purple-400 {
  --bg-opacity: 1;
  background-color: #ac94fa;
  background-color: rgba(172, 148, 250, var(--bg-opacity));
}
.group:focus .group-focus\\:bg-purple-500 {
  --bg-opacity: 1;
  background-color: #9061f9;
  background-color: rgba(144, 97, 249, var(--bg-opacity));
}
.group:focus .group-focus\\:bg-purple-600 {
  --bg-opacity: 1;
  background-color: #7e3af2;
  background-color: rgba(126, 58, 242, var(--bg-opacity));
}
.group:focus .group-focus\\:bg-purple-700 {
  --bg-opacity: 1;
  background-color: #6c2bd9;
  background-color: rgba(108, 43, 217, var(--bg-opacity));
}
.group:focus .group-focus\\:bg-purple-800 {
  --bg-opacity: 1;
  background-color: #5521b5;
  background-color: rgba(85, 33, 181, var(--bg-opacity));
}
.group:focus .group-focus\\:bg-purple-900 {
  --bg-opacity: 1;
  background-color: #4a1d96;
  background-color: rgba(74, 29, 150, var(--bg-opacity));
}
.group:focus .group-focus\\:bg-pink-50 {
  --bg-opacity: 1;
  background-color: #fdf2f8;
  background-color: rgba(253, 242, 248, var(--bg-opacity));
}
.group:focus .group-focus\\:bg-pink-100 {
  --bg-opacity: 1;
  background-color: #fce8f3;
  background-color: rgba(252, 232, 243, var(--bg-opacity));
}
.group:focus .group-focus\\:bg-pink-200 {
  --bg-opacity: 1;
  background-color: #fad1e8;
  background-color: rgba(250, 209, 232, var(--bg-opacity));
}
.group:focus .group-focus\\:bg-pink-300 {
  --bg-opacity: 1;
  background-color: #f8b4d9;
  background-color: rgba(248, 180, 217, var(--bg-opacity));
}
.group:focus .group-focus\\:bg-pink-400 {
  --bg-opacity: 1;
  background-color: #f17eb8;
  background-color: rgba(241, 126, 184, var(--bg-opacity));
}
.group:focus .group-focus\\:bg-pink-500 {
  --bg-opacity: 1;
  background-color: #e74694;
  background-color: rgba(231, 70, 148, var(--bg-opacity));
}
.group:focus .group-focus\\:bg-pink-600 {
  --bg-opacity: 1;
  background-color: #d61f69;
  background-color: rgba(214, 31, 105, var(--bg-opacity));
}
.group:focus .group-focus\\:bg-pink-700 {
  --bg-opacity: 1;
  background-color: #bf125d;
  background-color: rgba(191, 18, 93, var(--bg-opacity));
}
.group:focus .group-focus\\:bg-pink-800 {
  --bg-opacity: 1;
  background-color: #99154b;
  background-color: rgba(153, 21, 75, var(--bg-opacity));
}
.group:focus .group-focus\\:bg-pink-900 {
  --bg-opacity: 1;
  background-color: #751a3d;
  background-color: rgba(117, 26, 61, var(--bg-opacity));
}
.group:focus .group-focus\\:bg-cool-gray-50 {
  --bg-opacity: 1;
  background-color: #f8fafc;
  background-color: rgba(248, 250, 252, var(--bg-opacity));
}
.group:focus .group-focus\\:bg-cool-gray-100 {
  --bg-opacity: 1;
  background-color: #f1f5f9;
  background-color: rgba(241, 245, 249, var(--bg-opacity));
}
.group:focus .group-focus\\:bg-cool-gray-200 {
  --bg-opacity: 1;
  background-color: #e2e8f0;
  background-color: rgba(226, 232, 240, var(--bg-opacity));
}
.group:focus .group-focus\\:bg-cool-gray-300 {
  --bg-opacity: 1;
  background-color: #cfd8e3;
  background-color: rgba(207, 216, 227, var(--bg-opacity));
}
.group:focus .group-focus\\:bg-cool-gray-400 {
  --bg-opacity: 1;
  background-color: #97a6ba;
  background-color: rgba(151, 166, 186, var(--bg-opacity));
}
.group:focus .group-focus\\:bg-cool-gray-500 {
  --bg-opacity: 1;
  background-color: #64748b;
  background-color: rgba(100, 116, 139, var(--bg-opacity));
}
.group:focus .group-focus\\:bg-cool-gray-600 {
  --bg-opacity: 1;
  background-color: #475569;
  background-color: rgba(71, 85, 105, var(--bg-opacity));
}
.group:focus .group-focus\\:bg-cool-gray-700 {
  --bg-opacity: 1;
  background-color: #364152;
  background-color: rgba(54, 65, 82, var(--bg-opacity));
}
.group:focus .group-focus\\:bg-cool-gray-800 {
  --bg-opacity: 1;
  background-color: #27303f;
  background-color: rgba(39, 48, 63, var(--bg-opacity));
}
.group:focus .group-focus\\:bg-cool-gray-900 {
  --bg-opacity: 1;
  background-color: #1a202e;
  background-color: rgba(26, 32, 46, var(--bg-opacity));
}
.hover\\:bg-current:hover {
  background-color: currentColor;
}
.hover\\:bg-transparent:hover {
  background-color: transparent;
}
.hover\\:bg-white:hover {
  --bg-opacity: 1;
  background-color: #ffffff;
  background-color: rgba(255, 255, 255, var(--bg-opacity));
}
.hover\\:bg-black:hover {
  --bg-opacity: 1;
  background-color: #000000;
  background-color: rgba(0, 0, 0, var(--bg-opacity));
}
.hover\\:bg-gray-50:hover {
  --bg-opacity: 1;
  background-color: #f9fafb;
  background-color: rgba(249, 250, 251, var(--bg-opacity));
}
.hover\\:bg-gray-100:hover {
  --bg-opacity: 1;
  background-color: #f4f5f7;
  background-color: rgba(244, 245, 247, var(--bg-opacity));
}
.hover\\:bg-gray-200:hover {
  --bg-opacity: 1;
  background-color: #e5e7eb;
  background-color: rgba(229, 231, 235, var(--bg-opacity));
}
.hover\\:bg-gray-300:hover {
  --bg-opacity: 1;
  background-color: #d2d6dc;
  background-color: rgba(210, 214, 220, var(--bg-opacity));
}
.hover\\:bg-gray-400:hover {
  --bg-opacity: 1;
  background-color: #9fa6b2;
  background-color: rgba(159, 166, 178, var(--bg-opacity));
}
.hover\\:bg-gray-500:hover {
  --bg-opacity: 1;
  background-color: #6b7280;
  background-color: rgba(107, 114, 128, var(--bg-opacity));
}
.hover\\:bg-gray-600:hover {
  --bg-opacity: 1;
  background-color: #4b5563;
  background-color: rgba(75, 85, 99, var(--bg-opacity));
}
.hover\\:bg-gray-700:hover {
  --bg-opacity: 1;
  background-color: #374151;
  background-color: rgba(55, 65, 81, var(--bg-opacity));
}
.hover\\:bg-gray-800:hover {
  --bg-opacity: 1;
  background-color: #252f3f;
  background-color: rgba(37, 47, 63, var(--bg-opacity));
}
.hover\\:bg-gray-900:hover {
  --bg-opacity: 1;
  background-color: #161e2e;
  background-color: rgba(22, 30, 46, var(--bg-opacity));
}
.hover\\:bg-red-50:hover {
  --bg-opacity: 1;
  background-color: #fdf2f2;
  background-color: rgba(253, 242, 242, var(--bg-opacity));
}
.hover\\:bg-red-100:hover {
  --bg-opacity: 1;
  background-color: #fde8e8;
  background-color: rgba(253, 232, 232, var(--bg-opacity));
}
.hover\\:bg-red-200:hover {
  --bg-opacity: 1;
  background-color: #fbd5d5;
  background-color: rgba(251, 213, 213, var(--bg-opacity));
}
.hover\\:bg-red-300:hover {
  --bg-opacity: 1;
  background-color: #f8b4b4;
  background-color: rgba(248, 180, 180, var(--bg-opacity));
}
.hover\\:bg-red-400:hover {
  --bg-opacity: 1;
  background-color: #f98080;
  background-color: rgba(249, 128, 128, var(--bg-opacity));
}
.hover\\:bg-red-500:hover {
  --bg-opacity: 1;
  background-color: #f05252;
  background-color: rgba(240, 82, 82, var(--bg-opacity));
}
.hover\\:bg-red-600:hover {
  --bg-opacity: 1;
  background-color: #e02424;
  background-color: rgba(224, 36, 36, var(--bg-opacity));
}
.hover\\:bg-red-700:hover {
  --bg-opacity: 1;
  background-color: #c81e1e;
  background-color: rgba(200, 30, 30, var(--bg-opacity));
}
.hover\\:bg-red-800:hover {
  --bg-opacity: 1;
  background-color: #9b1c1c;
  background-color: rgba(155, 28, 28, var(--bg-opacity));
}
.hover\\:bg-red-900:hover {
  --bg-opacity: 1;
  background-color: #771d1d;
  background-color: rgba(119, 29, 29, var(--bg-opacity));
}
.hover\\:bg-orange-50:hover {
  --bg-opacity: 1;
  background-color: #fff8f1;
  background-color: rgba(255, 248, 241, var(--bg-opacity));
}
.hover\\:bg-orange-100:hover {
  --bg-opacity: 1;
  background-color: #feecdc;
  background-color: rgba(254, 236, 220, var(--bg-opacity));
}
.hover\\:bg-orange-200:hover {
  --bg-opacity: 1;
  background-color: #fcd9bd;
  background-color: rgba(252, 217, 189, var(--bg-opacity));
}
.hover\\:bg-orange-300:hover {
  --bg-opacity: 1;
  background-color: #fdba8c;
  background-color: rgba(253, 186, 140, var(--bg-opacity));
}
.hover\\:bg-orange-400:hover {
  --bg-opacity: 1;
  background-color: #ff8a4c;
  background-color: rgba(255, 138, 76, var(--bg-opacity));
}
.hover\\:bg-orange-500:hover {
  --bg-opacity: 1;
  background-color: #ff5a1f;
  background-color: rgba(255, 90, 31, var(--bg-opacity));
}
.hover\\:bg-orange-600:hover {
  --bg-opacity: 1;
  background-color: #d03801;
  background-color: rgba(208, 56, 1, var(--bg-opacity));
}
.hover\\:bg-orange-700:hover {
  --bg-opacity: 1;
  background-color: #b43403;
  background-color: rgba(180, 52, 3, var(--bg-opacity));
}
.hover\\:bg-orange-800:hover {
  --bg-opacity: 1;
  background-color: #8a2c0d;
  background-color: rgba(138, 44, 13, var(--bg-opacity));
}
.hover\\:bg-orange-900:hover {
  --bg-opacity: 1;
  background-color: #73230d;
  background-color: rgba(115, 35, 13, var(--bg-opacity));
}
.hover\\:bg-yellow-50:hover {
  --bg-opacity: 1;
  background-color: #fdfdea;
  background-color: rgba(253, 253, 234, var(--bg-opacity));
}
.hover\\:bg-yellow-100:hover {
  --bg-opacity: 1;
  background-color: #fdf6b2;
  background-color: rgba(253, 246, 178, var(--bg-opacity));
}
.hover\\:bg-yellow-200:hover {
  --bg-opacity: 1;
  background-color: #fce96a;
  background-color: rgba(252, 233, 106, var(--bg-opacity));
}
.hover\\:bg-yellow-300:hover {
  --bg-opacity: 1;
  background-color: #faca15;
  background-color: rgba(250, 202, 21, var(--bg-opacity));
}
.hover\\:bg-yellow-400:hover {
  --bg-opacity: 1;
  background-color: #e3a008;
  background-color: rgba(227, 160, 8, var(--bg-opacity));
}
.hover\\:bg-yellow-500:hover {
  --bg-opacity: 1;
  background-color: #c27803;
  background-color: rgba(194, 120, 3, var(--bg-opacity));
}
.hover\\:bg-yellow-600:hover {
  --bg-opacity: 1;
  background-color: #9f580a;
  background-color: rgba(159, 88, 10, var(--bg-opacity));
}
.hover\\:bg-yellow-700:hover {
  --bg-opacity: 1;
  background-color: #8e4b10;
  background-color: rgba(142, 75, 16, var(--bg-opacity));
}
.hover\\:bg-yellow-800:hover {
  --bg-opacity: 1;
  background-color: #723b13;
  background-color: rgba(114, 59, 19, var(--bg-opacity));
}
.hover\\:bg-yellow-900:hover {
  --bg-opacity: 1;
  background-color: #633112;
  background-color: rgba(99, 49, 18, var(--bg-opacity));
}
.hover\\:bg-green-50:hover {
  --bg-opacity: 1;
  background-color: #f3faf7;
  background-color: rgba(243, 250, 247, var(--bg-opacity));
}
.hover\\:bg-green-100:hover {
  --bg-opacity: 1;
  background-color: #def7ec;
  background-color: rgba(222, 247, 236, var(--bg-opacity));
}
.hover\\:bg-green-200:hover {
  --bg-opacity: 1;
  background-color: #bcf0da;
  background-color: rgba(188, 240, 218, var(--bg-opacity));
}
.hover\\:bg-green-300:hover {
  --bg-opacity: 1;
  background-color: #84e1bc;
  background-color: rgba(132, 225, 188, var(--bg-opacity));
}
.hover\\:bg-green-400:hover {
  --bg-opacity: 1;
  background-color: #31c48d;
  background-color: rgba(49, 196, 141, var(--bg-opacity));
}
.hover\\:bg-green-500:hover {
  --bg-opacity: 1;
  background-color: #0e9f6e;
  background-color: rgba(14, 159, 110, var(--bg-opacity));
}
.hover\\:bg-green-600:hover {
  --bg-opacity: 1;
  background-color: #057a55;
  background-color: rgba(5, 122, 85, var(--bg-opacity));
}
.hover\\:bg-green-700:hover {
  --bg-opacity: 1;
  background-color: #046c4e;
  background-color: rgba(4, 108, 78, var(--bg-opacity));
}
.hover\\:bg-green-800:hover {
  --bg-opacity: 1;
  background-color: #03543f;
  background-color: rgba(3, 84, 63, var(--bg-opacity));
}
.hover\\:bg-green-900:hover {
  --bg-opacity: 1;
  background-color: #014737;
  background-color: rgba(1, 71, 55, var(--bg-opacity));
}
.hover\\:bg-teal-50:hover {
  --bg-opacity: 1;
  background-color: #edfafa;
  background-color: rgba(237, 250, 250, var(--bg-opacity));
}
.hover\\:bg-teal-100:hover {
  --bg-opacity: 1;
  background-color: #d5f5f6;
  background-color: rgba(213, 245, 246, var(--bg-opacity));
}
.hover\\:bg-teal-200:hover {
  --bg-opacity: 1;
  background-color: #afecef;
  background-color: rgba(175, 236, 239, var(--bg-opacity));
}
.hover\\:bg-teal-300:hover {
  --bg-opacity: 1;
  background-color: #7edce2;
  background-color: rgba(126, 220, 226, var(--bg-opacity));
}
.hover\\:bg-teal-400:hover {
  --bg-opacity: 1;
  background-color: #16bdca;
  background-color: rgba(22, 189, 202, var(--bg-opacity));
}
.hover\\:bg-teal-500:hover {
  --bg-opacity: 1;
  background-color: #0694a2;
  background-color: rgba(6, 148, 162, var(--bg-opacity));
}
.hover\\:bg-teal-600:hover {
  --bg-opacity: 1;
  background-color: #047481;
  background-color: rgba(4, 116, 129, var(--bg-opacity));
}
.hover\\:bg-teal-700:hover {
  --bg-opacity: 1;
  background-color: #036672;
  background-color: rgba(3, 102, 114, var(--bg-opacity));
}
.hover\\:bg-teal-800:hover {
  --bg-opacity: 1;
  background-color: #05505c;
  background-color: rgba(5, 80, 92, var(--bg-opacity));
}
.hover\\:bg-teal-900:hover {
  --bg-opacity: 1;
  background-color: #014451;
  background-color: rgba(1, 68, 81, var(--bg-opacity));
}
.hover\\:bg-blue-50:hover {
  --bg-opacity: 1;
  background-color: #ebf5ff;
  background-color: rgba(235, 245, 255, var(--bg-opacity));
}
.hover\\:bg-blue-100:hover {
  --bg-opacity: 1;
  background-color: #e1effe;
  background-color: rgba(225, 239, 254, var(--bg-opacity));
}
.hover\\:bg-blue-200:hover {
  --bg-opacity: 1;
  background-color: #c3ddfd;
  background-color: rgba(195, 221, 253, var(--bg-opacity));
}
.hover\\:bg-blue-300:hover {
  --bg-opacity: 1;
  background-color: #a4cafe;
  background-color: rgba(164, 202, 254, var(--bg-opacity));
}
.hover\\:bg-blue-400:hover {
  --bg-opacity: 1;
  background-color: #76a9fa;
  background-color: rgba(118, 169, 250, var(--bg-opacity));
}
.hover\\:bg-blue-500:hover {
  --bg-opacity: 1;
  background-color: #3f83f8;
  background-color: rgba(63, 131, 248, var(--bg-opacity));
}
.hover\\:bg-blue-600:hover {
  --bg-opacity: 1;
  background-color: #1c64f2;
  background-color: rgba(28, 100, 242, var(--bg-opacity));
}
.hover\\:bg-blue-700:hover {
  --bg-opacity: 1;
  background-color: #1a56db;
  background-color: rgba(26, 86, 219, var(--bg-opacity));
}
.hover\\:bg-blue-800:hover {
  --bg-opacity: 1;
  background-color: #1e429f;
  background-color: rgba(30, 66, 159, var(--bg-opacity));
}
.hover\\:bg-blue-900:hover {
  --bg-opacity: 1;
  background-color: #233876;
  background-color: rgba(35, 56, 118, var(--bg-opacity));
}
.hover\\:bg-indigo-50:hover {
  --bg-opacity: 1;
  background-color: #f0f5ff;
  background-color: rgba(240, 245, 255, var(--bg-opacity));
}
.hover\\:bg-indigo-100:hover {
  --bg-opacity: 1;
  background-color: #e5edff;
  background-color: rgba(229, 237, 255, var(--bg-opacity));
}
.hover\\:bg-indigo-200:hover {
  --bg-opacity: 1;
  background-color: #cddbfe;
  background-color: rgba(205, 219, 254, var(--bg-opacity));
}
.hover\\:bg-indigo-300:hover {
  --bg-opacity: 1;
  background-color: #b4c6fc;
  background-color: rgba(180, 198, 252, var(--bg-opacity));
}
.hover\\:bg-indigo-400:hover {
  --bg-opacity: 1;
  background-color: #8da2fb;
  background-color: rgba(141, 162, 251, var(--bg-opacity));
}
.hover\\:bg-indigo-500:hover {
  --bg-opacity: 1;
  background-color: #6875f5;
  background-color: rgba(104, 117, 245, var(--bg-opacity));
}
.hover\\:bg-indigo-600:hover {
  --bg-opacity: 1;
  background-color: #5850ec;
  background-color: rgba(88, 80, 236, var(--bg-opacity));
}
.hover\\:bg-indigo-700:hover {
  --bg-opacity: 1;
  background-color: #5145cd;
  background-color: rgba(81, 69, 205, var(--bg-opacity));
}
.hover\\:bg-indigo-800:hover {
  --bg-opacity: 1;
  background-color: #42389d;
  background-color: rgba(66, 56, 157, var(--bg-opacity));
}
.hover\\:bg-indigo-900:hover {
  --bg-opacity: 1;
  background-color: #362f78;
  background-color: rgba(54, 47, 120, var(--bg-opacity));
}
.hover\\:bg-purple-50:hover {
  --bg-opacity: 1;
  background-color: #f6f5ff;
  background-color: rgba(246, 245, 255, var(--bg-opacity));
}
.hover\\:bg-purple-100:hover {
  --bg-opacity: 1;
  background-color: #edebfe;
  background-color: rgba(237, 235, 254, var(--bg-opacity));
}
.hover\\:bg-purple-200:hover {
  --bg-opacity: 1;
  background-color: #dcd7fe;
  background-color: rgba(220, 215, 254, var(--bg-opacity));
}
.hover\\:bg-purple-300:hover {
  --bg-opacity: 1;
  background-color: #cabffd;
  background-color: rgba(202, 191, 253, var(--bg-opacity));
}
.hover\\:bg-purple-400:hover {
  --bg-opacity: 1;
  background-color: #ac94fa;
  background-color: rgba(172, 148, 250, var(--bg-opacity));
}
.hover\\:bg-purple-500:hover {
  --bg-opacity: 1;
  background-color: #9061f9;
  background-color: rgba(144, 97, 249, var(--bg-opacity));
}
.hover\\:bg-purple-600:hover {
  --bg-opacity: 1;
  background-color: #7e3af2;
  background-color: rgba(126, 58, 242, var(--bg-opacity));
}
.hover\\:bg-purple-700:hover {
  --bg-opacity: 1;
  background-color: #6c2bd9;
  background-color: rgba(108, 43, 217, var(--bg-opacity));
}
.hover\\:bg-purple-800:hover {
  --bg-opacity: 1;
  background-color: #5521b5;
  background-color: rgba(85, 33, 181, var(--bg-opacity));
}
.hover\\:bg-purple-900:hover {
  --bg-opacity: 1;
  background-color: #4a1d96;
  background-color: rgba(74, 29, 150, var(--bg-opacity));
}
.hover\\:bg-pink-50:hover {
  --bg-opacity: 1;
  background-color: #fdf2f8;
  background-color: rgba(253, 242, 248, var(--bg-opacity));
}
.hover\\:bg-pink-100:hover {
  --bg-opacity: 1;
  background-color: #fce8f3;
  background-color: rgba(252, 232, 243, var(--bg-opacity));
}
.hover\\:bg-pink-200:hover {
  --bg-opacity: 1;
  background-color: #fad1e8;
  background-color: rgba(250, 209, 232, var(--bg-opacity));
}
.hover\\:bg-pink-300:hover {
  --bg-opacity: 1;
  background-color: #f8b4d9;
  background-color: rgba(248, 180, 217, var(--bg-opacity));
}
.hover\\:bg-pink-400:hover {
  --bg-opacity: 1;
  background-color: #f17eb8;
  background-color: rgba(241, 126, 184, var(--bg-opacity));
}
.hover\\:bg-pink-500:hover {
  --bg-opacity: 1;
  background-color: #e74694;
  background-color: rgba(231, 70, 148, var(--bg-opacity));
}
.hover\\:bg-pink-600:hover {
  --bg-opacity: 1;
  background-color: #d61f69;
  background-color: rgba(214, 31, 105, var(--bg-opacity));
}
.hover\\:bg-pink-700:hover {
  --bg-opacity: 1;
  background-color: #bf125d;
  background-color: rgba(191, 18, 93, var(--bg-opacity));
}
.hover\\:bg-pink-800:hover {
  --bg-opacity: 1;
  background-color: #99154b;
  background-color: rgba(153, 21, 75, var(--bg-opacity));
}
.hover\\:bg-pink-900:hover {
  --bg-opacity: 1;
  background-color: #751a3d;
  background-color: rgba(117, 26, 61, var(--bg-opacity));
}
.hover\\:bg-cool-gray-50:hover {
  --bg-opacity: 1;
  background-color: #f8fafc;
  background-color: rgba(248, 250, 252, var(--bg-opacity));
}
.hover\\:bg-cool-gray-100:hover {
  --bg-opacity: 1;
  background-color: #f1f5f9;
  background-color: rgba(241, 245, 249, var(--bg-opacity));
}
.hover\\:bg-cool-gray-200:hover {
  --bg-opacity: 1;
  background-color: #e2e8f0;
  background-color: rgba(226, 232, 240, var(--bg-opacity));
}
.hover\\:bg-cool-gray-300:hover {
  --bg-opacity: 1;
  background-color: #cfd8e3;
  background-color: rgba(207, 216, 227, var(--bg-opacity));
}
.hover\\:bg-cool-gray-400:hover {
  --bg-opacity: 1;
  background-color: #97a6ba;
  background-color: rgba(151, 166, 186, var(--bg-opacity));
}
.hover\\:bg-cool-gray-500:hover {
  --bg-opacity: 1;
  background-color: #64748b;
  background-color: rgba(100, 116, 139, var(--bg-opacity));
}
.hover\\:bg-cool-gray-600:hover {
  --bg-opacity: 1;
  background-color: #475569;
  background-color: rgba(71, 85, 105, var(--bg-opacity));
}
.hover\\:bg-cool-gray-700:hover {
  --bg-opacity: 1;
  background-color: #364152;
  background-color: rgba(54, 65, 82, var(--bg-opacity));
}
.hover\\:bg-cool-gray-800:hover {
  --bg-opacity: 1;
  background-color: #27303f;
  background-color: rgba(39, 48, 63, var(--bg-opacity));
}
.hover\\:bg-cool-gray-900:hover {
  --bg-opacity: 1;
  background-color: #1a202e;
  background-color: rgba(26, 32, 46, var(--bg-opacity));
}
.focus\\:bg-current:focus {
  background-color: currentColor;
}
.focus\\:bg-transparent:focus {
  background-color: transparent;
}
.focus\\:bg-white:focus {
  --bg-opacity: 1;
  background-color: #ffffff;
  background-color: rgba(255, 255, 255, var(--bg-opacity));
}
.focus\\:bg-black:focus {
  --bg-opacity: 1;
  background-color: #000000;
  background-color: rgba(0, 0, 0, var(--bg-opacity));
}
.focus\\:bg-gray-50:focus {
  --bg-opacity: 1;
  background-color: #f9fafb;
  background-color: rgba(249, 250, 251, var(--bg-opacity));
}
.focus\\:bg-gray-100:focus {
  --bg-opacity: 1;
  background-color: #f4f5f7;
  background-color: rgba(244, 245, 247, var(--bg-opacity));
}
.focus\\:bg-gray-200:focus {
  --bg-opacity: 1;
  background-color: #e5e7eb;
  background-color: rgba(229, 231, 235, var(--bg-opacity));
}
.focus\\:bg-gray-300:focus {
  --bg-opacity: 1;
  background-color: #d2d6dc;
  background-color: rgba(210, 214, 220, var(--bg-opacity));
}
.focus\\:bg-gray-400:focus {
  --bg-opacity: 1;
  background-color: #9fa6b2;
  background-color: rgba(159, 166, 178, var(--bg-opacity));
}
.focus\\:bg-gray-500:focus {
  --bg-opacity: 1;
  background-color: #6b7280;
  background-color: rgba(107, 114, 128, var(--bg-opacity));
}
.focus\\:bg-gray-600:focus {
  --bg-opacity: 1;
  background-color: #4b5563;
  background-color: rgba(75, 85, 99, var(--bg-opacity));
}
.focus\\:bg-gray-700:focus {
  --bg-opacity: 1;
  background-color: #374151;
  background-color: rgba(55, 65, 81, var(--bg-opacity));
}
.focus\\:bg-gray-800:focus {
  --bg-opacity: 1;
  background-color: #252f3f;
  background-color: rgba(37, 47, 63, var(--bg-opacity));
}
.focus\\:bg-gray-900:focus {
  --bg-opacity: 1;
  background-color: #161e2e;
  background-color: rgba(22, 30, 46, var(--bg-opacity));
}
.focus\\:bg-red-50:focus {
  --bg-opacity: 1;
  background-color: #fdf2f2;
  background-color: rgba(253, 242, 242, var(--bg-opacity));
}
.focus\\:bg-red-100:focus {
  --bg-opacity: 1;
  background-color: #fde8e8;
  background-color: rgba(253, 232, 232, var(--bg-opacity));
}
.focus\\:bg-red-200:focus {
  --bg-opacity: 1;
  background-color: #fbd5d5;
  background-color: rgba(251, 213, 213, var(--bg-opacity));
}
.focus\\:bg-red-300:focus {
  --bg-opacity: 1;
  background-color: #f8b4b4;
  background-color: rgba(248, 180, 180, var(--bg-opacity));
}
.focus\\:bg-red-400:focus {
  --bg-opacity: 1;
  background-color: #f98080;
  background-color: rgba(249, 128, 128, var(--bg-opacity));
}
.focus\\:bg-red-500:focus {
  --bg-opacity: 1;
  background-color: #f05252;
  background-color: rgba(240, 82, 82, var(--bg-opacity));
}
.focus\\:bg-red-600:focus {
  --bg-opacity: 1;
  background-color: #e02424;
  background-color: rgba(224, 36, 36, var(--bg-opacity));
}
.focus\\:bg-red-700:focus {
  --bg-opacity: 1;
  background-color: #c81e1e;
  background-color: rgba(200, 30, 30, var(--bg-opacity));
}
.focus\\:bg-red-800:focus {
  --bg-opacity: 1;
  background-color: #9b1c1c;
  background-color: rgba(155, 28, 28, var(--bg-opacity));
}
.focus\\:bg-red-900:focus {
  --bg-opacity: 1;
  background-color: #771d1d;
  background-color: rgba(119, 29, 29, var(--bg-opacity));
}
.focus\\:bg-orange-50:focus {
  --bg-opacity: 1;
  background-color: #fff8f1;
  background-color: rgba(255, 248, 241, var(--bg-opacity));
}
.focus\\:bg-orange-100:focus {
  --bg-opacity: 1;
  background-color: #feecdc;
  background-color: rgba(254, 236, 220, var(--bg-opacity));
}
.focus\\:bg-orange-200:focus {
  --bg-opacity: 1;
  background-color: #fcd9bd;
  background-color: rgba(252, 217, 189, var(--bg-opacity));
}
.focus\\:bg-orange-300:focus {
  --bg-opacity: 1;
  background-color: #fdba8c;
  background-color: rgba(253, 186, 140, var(--bg-opacity));
}
.focus\\:bg-orange-400:focus {
  --bg-opacity: 1;
  background-color: #ff8a4c;
  background-color: rgba(255, 138, 76, var(--bg-opacity));
}
.focus\\:bg-orange-500:focus {
  --bg-opacity: 1;
  background-color: #ff5a1f;
  background-color: rgba(255, 90, 31, var(--bg-opacity));
}
.focus\\:bg-orange-600:focus {
  --bg-opacity: 1;
  background-color: #d03801;
  background-color: rgba(208, 56, 1, var(--bg-opacity));
}
.focus\\:bg-orange-700:focus {
  --bg-opacity: 1;
  background-color: #b43403;
  background-color: rgba(180, 52, 3, var(--bg-opacity));
}
.focus\\:bg-orange-800:focus {
  --bg-opacity: 1;
  background-color: #8a2c0d;
  background-color: rgba(138, 44, 13, var(--bg-opacity));
}
.focus\\:bg-orange-900:focus {
  --bg-opacity: 1;
  background-color: #73230d;
  background-color: rgba(115, 35, 13, var(--bg-opacity));
}
.focus\\:bg-yellow-50:focus {
  --bg-opacity: 1;
  background-color: #fdfdea;
  background-color: rgba(253, 253, 234, var(--bg-opacity));
}
.focus\\:bg-yellow-100:focus {
  --bg-opacity: 1;
  background-color: #fdf6b2;
  background-color: rgba(253, 246, 178, var(--bg-opacity));
}
.focus\\:bg-yellow-200:focus {
  --bg-opacity: 1;
  background-color: #fce96a;
  background-color: rgba(252, 233, 106, var(--bg-opacity));
}
.focus\\:bg-yellow-300:focus {
  --bg-opacity: 1;
  background-color: #faca15;
  background-color: rgba(250, 202, 21, var(--bg-opacity));
}
.focus\\:bg-yellow-400:focus {
  --bg-opacity: 1;
  background-color: #e3a008;
  background-color: rgba(227, 160, 8, var(--bg-opacity));
}
.focus\\:bg-yellow-500:focus {
  --bg-opacity: 1;
  background-color: #c27803;
  background-color: rgba(194, 120, 3, var(--bg-opacity));
}
.focus\\:bg-yellow-600:focus {
  --bg-opacity: 1;
  background-color: #9f580a;
  background-color: rgba(159, 88, 10, var(--bg-opacity));
}
.focus\\:bg-yellow-700:focus {
  --bg-opacity: 1;
  background-color: #8e4b10;
  background-color: rgba(142, 75, 16, var(--bg-opacity));
}
.focus\\:bg-yellow-800:focus {
  --bg-opacity: 1;
  background-color: #723b13;
  background-color: rgba(114, 59, 19, var(--bg-opacity));
}
.focus\\:bg-yellow-900:focus {
  --bg-opacity: 1;
  background-color: #633112;
  background-color: rgba(99, 49, 18, var(--bg-opacity));
}
.focus\\:bg-green-50:focus {
  --bg-opacity: 1;
  background-color: #f3faf7;
  background-color: rgba(243, 250, 247, var(--bg-opacity));
}
.focus\\:bg-green-100:focus {
  --bg-opacity: 1;
  background-color: #def7ec;
  background-color: rgba(222, 247, 236, var(--bg-opacity));
}
.focus\\:bg-green-200:focus {
  --bg-opacity: 1;
  background-color: #bcf0da;
  background-color: rgba(188, 240, 218, var(--bg-opacity));
}
.focus\\:bg-green-300:focus {
  --bg-opacity: 1;
  background-color: #84e1bc;
  background-color: rgba(132, 225, 188, var(--bg-opacity));
}
.focus\\:bg-green-400:focus {
  --bg-opacity: 1;
  background-color: #31c48d;
  background-color: rgba(49, 196, 141, var(--bg-opacity));
}
.focus\\:bg-green-500:focus {
  --bg-opacity: 1;
  background-color: #0e9f6e;
  background-color: rgba(14, 159, 110, var(--bg-opacity));
}
.focus\\:bg-green-600:focus {
  --bg-opacity: 1;
  background-color: #057a55;
  background-color: rgba(5, 122, 85, var(--bg-opacity));
}
.focus\\:bg-green-700:focus {
  --bg-opacity: 1;
  background-color: #046c4e;
  background-color: rgba(4, 108, 78, var(--bg-opacity));
}
.focus\\:bg-green-800:focus {
  --bg-opacity: 1;
  background-color: #03543f;
  background-color: rgba(3, 84, 63, var(--bg-opacity));
}
.focus\\:bg-green-900:focus {
  --bg-opacity: 1;
  background-color: #014737;
  background-color: rgba(1, 71, 55, var(--bg-opacity));
}
.focus\\:bg-teal-50:focus {
  --bg-opacity: 1;
  background-color: #edfafa;
  background-color: rgba(237, 250, 250, var(--bg-opacity));
}
.focus\\:bg-teal-100:focus {
  --bg-opacity: 1;
  background-color: #d5f5f6;
  background-color: rgba(213, 245, 246, var(--bg-opacity));
}
.focus\\:bg-teal-200:focus {
  --bg-opacity: 1;
  background-color: #afecef;
  background-color: rgba(175, 236, 239, var(--bg-opacity));
}
.focus\\:bg-teal-300:focus {
  --bg-opacity: 1;
  background-color: #7edce2;
  background-color: rgba(126, 220, 226, var(--bg-opacity));
}
.focus\\:bg-teal-400:focus {
  --bg-opacity: 1;
  background-color: #16bdca;
  background-color: rgba(22, 189, 202, var(--bg-opacity));
}
.focus\\:bg-teal-500:focus {
  --bg-opacity: 1;
  background-color: #0694a2;
  background-color: rgba(6, 148, 162, var(--bg-opacity));
}
.focus\\:bg-teal-600:focus {
  --bg-opacity: 1;
  background-color: #047481;
  background-color: rgba(4, 116, 129, var(--bg-opacity));
}
.focus\\:bg-teal-700:focus {
  --bg-opacity: 1;
  background-color: #036672;
  background-color: rgba(3, 102, 114, var(--bg-opacity));
}
.focus\\:bg-teal-800:focus {
  --bg-opacity: 1;
  background-color: #05505c;
  background-color: rgba(5, 80, 92, var(--bg-opacity));
}
.focus\\:bg-teal-900:focus {
  --bg-opacity: 1;
  background-color: #014451;
  background-color: rgba(1, 68, 81, var(--bg-opacity));
}
.focus\\:bg-blue-50:focus {
  --bg-opacity: 1;
  background-color: #ebf5ff;
  background-color: rgba(235, 245, 255, var(--bg-opacity));
}
.focus\\:bg-blue-100:focus {
  --bg-opacity: 1;
  background-color: #e1effe;
  background-color: rgba(225, 239, 254, var(--bg-opacity));
}
.focus\\:bg-blue-200:focus {
  --bg-opacity: 1;
  background-color: #c3ddfd;
  background-color: rgba(195, 221, 253, var(--bg-opacity));
}
.focus\\:bg-blue-300:focus {
  --bg-opacity: 1;
  background-color: #a4cafe;
  background-color: rgba(164, 202, 254, var(--bg-opacity));
}
.focus\\:bg-blue-400:focus {
  --bg-opacity: 1;
  background-color: #76a9fa;
  background-color: rgba(118, 169, 250, var(--bg-opacity));
}
.focus\\:bg-blue-500:focus {
  --bg-opacity: 1;
  background-color: #3f83f8;
  background-color: rgba(63, 131, 248, var(--bg-opacity));
}
.focus\\:bg-blue-600:focus {
  --bg-opacity: 1;
  background-color: #1c64f2;
  background-color: rgba(28, 100, 242, var(--bg-opacity));
}
.focus\\:bg-blue-700:focus {
  --bg-opacity: 1;
  background-color: #1a56db;
  background-color: rgba(26, 86, 219, var(--bg-opacity));
}
.focus\\:bg-blue-800:focus {
  --bg-opacity: 1;
  background-color: #1e429f;
  background-color: rgba(30, 66, 159, var(--bg-opacity));
}
.focus\\:bg-blue-900:focus {
  --bg-opacity: 1;
  background-color: #233876;
  background-color: rgba(35, 56, 118, var(--bg-opacity));
}
.focus\\:bg-indigo-50:focus {
  --bg-opacity: 1;
  background-color: #f0f5ff;
  background-color: rgba(240, 245, 255, var(--bg-opacity));
}
.focus\\:bg-indigo-100:focus {
  --bg-opacity: 1;
  background-color: #e5edff;
  background-color: rgba(229, 237, 255, var(--bg-opacity));
}
.focus\\:bg-indigo-200:focus {
  --bg-opacity: 1;
  background-color: #cddbfe;
  background-color: rgba(205, 219, 254, var(--bg-opacity));
}
.focus\\:bg-indigo-300:focus {
  --bg-opacity: 1;
  background-color: #b4c6fc;
  background-color: rgba(180, 198, 252, var(--bg-opacity));
}
.focus\\:bg-indigo-400:focus {
  --bg-opacity: 1;
  background-color: #8da2fb;
  background-color: rgba(141, 162, 251, var(--bg-opacity));
}
.focus\\:bg-indigo-500:focus {
  --bg-opacity: 1;
  background-color: #6875f5;
  background-color: rgba(104, 117, 245, var(--bg-opacity));
}
.focus\\:bg-indigo-600:focus {
  --bg-opacity: 1;
  background-color: #5850ec;
  background-color: rgba(88, 80, 236, var(--bg-opacity));
}
.focus\\:bg-indigo-700:focus {
  --bg-opacity: 1;
  background-color: #5145cd;
  background-color: rgba(81, 69, 205, var(--bg-opacity));
}
.focus\\:bg-indigo-800:focus {
  --bg-opacity: 1;
  background-color: #42389d;
  background-color: rgba(66, 56, 157, var(--bg-opacity));
}
.focus\\:bg-indigo-900:focus {
  --bg-opacity: 1;
  background-color: #362f78;
  background-color: rgba(54, 47, 120, var(--bg-opacity));
}
.focus\\:bg-purple-50:focus {
  --bg-opacity: 1;
  background-color: #f6f5ff;
  background-color: rgba(246, 245, 255, var(--bg-opacity));
}
.focus\\:bg-purple-100:focus {
  --bg-opacity: 1;
  background-color: #edebfe;
  background-color: rgba(237, 235, 254, var(--bg-opacity));
}
.focus\\:bg-purple-200:focus {
  --bg-opacity: 1;
  background-color: #dcd7fe;
  background-color: rgba(220, 215, 254, var(--bg-opacity));
}
.focus\\:bg-purple-300:focus {
  --bg-opacity: 1;
  background-color: #cabffd;
  background-color: rgba(202, 191, 253, var(--bg-opacity));
}
.focus\\:bg-purple-400:focus {
  --bg-opacity: 1;
  background-color: #ac94fa;
  background-color: rgba(172, 148, 250, var(--bg-opacity));
}
.focus\\:bg-purple-500:focus {
  --bg-opacity: 1;
  background-color: #9061f9;
  background-color: rgba(144, 97, 249, var(--bg-opacity));
}
.focus\\:bg-purple-600:focus {
  --bg-opacity: 1;
  background-color: #7e3af2;
  background-color: rgba(126, 58, 242, var(--bg-opacity));
}
.focus\\:bg-purple-700:focus {
  --bg-opacity: 1;
  background-color: #6c2bd9;
  background-color: rgba(108, 43, 217, var(--bg-opacity));
}
.focus\\:bg-purple-800:focus {
  --bg-opacity: 1;
  background-color: #5521b5;
  background-color: rgba(85, 33, 181, var(--bg-opacity));
}
.focus\\:bg-purple-900:focus {
  --bg-opacity: 1;
  background-color: #4a1d96;
  background-color: rgba(74, 29, 150, var(--bg-opacity));
}
.focus\\:bg-pink-50:focus {
  --bg-opacity: 1;
  background-color: #fdf2f8;
  background-color: rgba(253, 242, 248, var(--bg-opacity));
}
.focus\\:bg-pink-100:focus {
  --bg-opacity: 1;
  background-color: #fce8f3;
  background-color: rgba(252, 232, 243, var(--bg-opacity));
}
.focus\\:bg-pink-200:focus {
  --bg-opacity: 1;
  background-color: #fad1e8;
  background-color: rgba(250, 209, 232, var(--bg-opacity));
}
.focus\\:bg-pink-300:focus {
  --bg-opacity: 1;
  background-color: #f8b4d9;
  background-color: rgba(248, 180, 217, var(--bg-opacity));
}
.focus\\:bg-pink-400:focus {
  --bg-opacity: 1;
  background-color: #f17eb8;
  background-color: rgba(241, 126, 184, var(--bg-opacity));
}
.focus\\:bg-pink-500:focus {
  --bg-opacity: 1;
  background-color: #e74694;
  background-color: rgba(231, 70, 148, var(--bg-opacity));
}
.focus\\:bg-pink-600:focus {
  --bg-opacity: 1;
  background-color: #d61f69;
  background-color: rgba(214, 31, 105, var(--bg-opacity));
}
.focus\\:bg-pink-700:focus {
  --bg-opacity: 1;
  background-color: #bf125d;
  background-color: rgba(191, 18, 93, var(--bg-opacity));
}
.focus\\:bg-pink-800:focus {
  --bg-opacity: 1;
  background-color: #99154b;
  background-color: rgba(153, 21, 75, var(--bg-opacity));
}
.focus\\:bg-pink-900:focus {
  --bg-opacity: 1;
  background-color: #751a3d;
  background-color: rgba(117, 26, 61, var(--bg-opacity));
}
.focus\\:bg-cool-gray-50:focus {
  --bg-opacity: 1;
  background-color: #f8fafc;
  background-color: rgba(248, 250, 252, var(--bg-opacity));
}
.focus\\:bg-cool-gray-100:focus {
  --bg-opacity: 1;
  background-color: #f1f5f9;
  background-color: rgba(241, 245, 249, var(--bg-opacity));
}
.focus\\:bg-cool-gray-200:focus {
  --bg-opacity: 1;
  background-color: #e2e8f0;
  background-color: rgba(226, 232, 240, var(--bg-opacity));
}
.focus\\:bg-cool-gray-300:focus {
  --bg-opacity: 1;
  background-color: #cfd8e3;
  background-color: rgba(207, 216, 227, var(--bg-opacity));
}
.focus\\:bg-cool-gray-400:focus {
  --bg-opacity: 1;
  background-color: #97a6ba;
  background-color: rgba(151, 166, 186, var(--bg-opacity));
}
.focus\\:bg-cool-gray-500:focus {
  --bg-opacity: 1;
  background-color: #64748b;
  background-color: rgba(100, 116, 139, var(--bg-opacity));
}
.focus\\:bg-cool-gray-600:focus {
  --bg-opacity: 1;
  background-color: #475569;
  background-color: rgba(71, 85, 105, var(--bg-opacity));
}
.focus\\:bg-cool-gray-700:focus {
  --bg-opacity: 1;
  background-color: #364152;
  background-color: rgba(54, 65, 82, var(--bg-opacity));
}
.focus\\:bg-cool-gray-800:focus {
  --bg-opacity: 1;
  background-color: #27303f;
  background-color: rgba(39, 48, 63, var(--bg-opacity));
}
.focus\\:bg-cool-gray-900:focus {
  --bg-opacity: 1;
  background-color: #1a202e;
  background-color: rgba(26, 32, 46, var(--bg-opacity));
}
.active\\:bg-current:active {
  background-color: currentColor;
}
.active\\:bg-transparent:active {
  background-color: transparent;
}
.active\\:bg-white:active {
  --bg-opacity: 1;
  background-color: #ffffff;
  background-color: rgba(255, 255, 255, var(--bg-opacity));
}
.active\\:bg-black:active {
  --bg-opacity: 1;
  background-color: #000000;
  background-color: rgba(0, 0, 0, var(--bg-opacity));
}
.active\\:bg-gray-50:active {
  --bg-opacity: 1;
  background-color: #f9fafb;
  background-color: rgba(249, 250, 251, var(--bg-opacity));
}
.active\\:bg-gray-100:active {
  --bg-opacity: 1;
  background-color: #f4f5f7;
  background-color: rgba(244, 245, 247, var(--bg-opacity));
}
.active\\:bg-gray-200:active {
  --bg-opacity: 1;
  background-color: #e5e7eb;
  background-color: rgba(229, 231, 235, var(--bg-opacity));
}
.active\\:bg-gray-300:active {
  --bg-opacity: 1;
  background-color: #d2d6dc;
  background-color: rgba(210, 214, 220, var(--bg-opacity));
}
.active\\:bg-gray-400:active {
  --bg-opacity: 1;
  background-color: #9fa6b2;
  background-color: rgba(159, 166, 178, var(--bg-opacity));
}
.active\\:bg-gray-500:active {
  --bg-opacity: 1;
  background-color: #6b7280;
  background-color: rgba(107, 114, 128, var(--bg-opacity));
}
.active\\:bg-gray-600:active {
  --bg-opacity: 1;
  background-color: #4b5563;
  background-color: rgba(75, 85, 99, var(--bg-opacity));
}
.active\\:bg-gray-700:active {
  --bg-opacity: 1;
  background-color: #374151;
  background-color: rgba(55, 65, 81, var(--bg-opacity));
}
.active\\:bg-gray-800:active {
  --bg-opacity: 1;
  background-color: #252f3f;
  background-color: rgba(37, 47, 63, var(--bg-opacity));
}
.active\\:bg-gray-900:active {
  --bg-opacity: 1;
  background-color: #161e2e;
  background-color: rgba(22, 30, 46, var(--bg-opacity));
}
.active\\:bg-red-50:active {
  --bg-opacity: 1;
  background-color: #fdf2f2;
  background-color: rgba(253, 242, 242, var(--bg-opacity));
}
.active\\:bg-red-100:active {
  --bg-opacity: 1;
  background-color: #fde8e8;
  background-color: rgba(253, 232, 232, var(--bg-opacity));
}
.active\\:bg-red-200:active {
  --bg-opacity: 1;
  background-color: #fbd5d5;
  background-color: rgba(251, 213, 213, var(--bg-opacity));
}
.active\\:bg-red-300:active {
  --bg-opacity: 1;
  background-color: #f8b4b4;
  background-color: rgba(248, 180, 180, var(--bg-opacity));
}
.active\\:bg-red-400:active {
  --bg-opacity: 1;
  background-color: #f98080;
  background-color: rgba(249, 128, 128, var(--bg-opacity));
}
.active\\:bg-red-500:active {
  --bg-opacity: 1;
  background-color: #f05252;
  background-color: rgba(240, 82, 82, var(--bg-opacity));
}
.active\\:bg-red-600:active {
  --bg-opacity: 1;
  background-color: #e02424;
  background-color: rgba(224, 36, 36, var(--bg-opacity));
}
.active\\:bg-red-700:active {
  --bg-opacity: 1;
  background-color: #c81e1e;
  background-color: rgba(200, 30, 30, var(--bg-opacity));
}
.active\\:bg-red-800:active {
  --bg-opacity: 1;
  background-color: #9b1c1c;
  background-color: rgba(155, 28, 28, var(--bg-opacity));
}
.active\\:bg-red-900:active {
  --bg-opacity: 1;
  background-color: #771d1d;
  background-color: rgba(119, 29, 29, var(--bg-opacity));
}
.active\\:bg-orange-50:active {
  --bg-opacity: 1;
  background-color: #fff8f1;
  background-color: rgba(255, 248, 241, var(--bg-opacity));
}
.active\\:bg-orange-100:active {
  --bg-opacity: 1;
  background-color: #feecdc;
  background-color: rgba(254, 236, 220, var(--bg-opacity));
}
.active\\:bg-orange-200:active {
  --bg-opacity: 1;
  background-color: #fcd9bd;
  background-color: rgba(252, 217, 189, var(--bg-opacity));
}
.active\\:bg-orange-300:active {
  --bg-opacity: 1;
  background-color: #fdba8c;
  background-color: rgba(253, 186, 140, var(--bg-opacity));
}
.active\\:bg-orange-400:active {
  --bg-opacity: 1;
  background-color: #ff8a4c;
  background-color: rgba(255, 138, 76, var(--bg-opacity));
}
.active\\:bg-orange-500:active {
  --bg-opacity: 1;
  background-color: #ff5a1f;
  background-color: rgba(255, 90, 31, var(--bg-opacity));
}
.active\\:bg-orange-600:active {
  --bg-opacity: 1;
  background-color: #d03801;
  background-color: rgba(208, 56, 1, var(--bg-opacity));
}
.active\\:bg-orange-700:active {
  --bg-opacity: 1;
  background-color: #b43403;
  background-color: rgba(180, 52, 3, var(--bg-opacity));
}
.active\\:bg-orange-800:active {
  --bg-opacity: 1;
  background-color: #8a2c0d;
  background-color: rgba(138, 44, 13, var(--bg-opacity));
}
.active\\:bg-orange-900:active {
  --bg-opacity: 1;
  background-color: #73230d;
  background-color: rgba(115, 35, 13, var(--bg-opacity));
}
.active\\:bg-yellow-50:active {
  --bg-opacity: 1;
  background-color: #fdfdea;
  background-color: rgba(253, 253, 234, var(--bg-opacity));
}
.active\\:bg-yellow-100:active {
  --bg-opacity: 1;
  background-color: #fdf6b2;
  background-color: rgba(253, 246, 178, var(--bg-opacity));
}
.active\\:bg-yellow-200:active {
  --bg-opacity: 1;
  background-color: #fce96a;
  background-color: rgba(252, 233, 106, var(--bg-opacity));
}
.active\\:bg-yellow-300:active {
  --bg-opacity: 1;
  background-color: #faca15;
  background-color: rgba(250, 202, 21, var(--bg-opacity));
}
.active\\:bg-yellow-400:active {
  --bg-opacity: 1;
  background-color: #e3a008;
  background-color: rgba(227, 160, 8, var(--bg-opacity));
}
.active\\:bg-yellow-500:active {
  --bg-opacity: 1;
  background-color: #c27803;
  background-color: rgba(194, 120, 3, var(--bg-opacity));
}
.active\\:bg-yellow-600:active {
  --bg-opacity: 1;
  background-color: #9f580a;
  background-color: rgba(159, 88, 10, var(--bg-opacity));
}
.active\\:bg-yellow-700:active {
  --bg-opacity: 1;
  background-color: #8e4b10;
  background-color: rgba(142, 75, 16, var(--bg-opacity));
}
.active\\:bg-yellow-800:active {
  --bg-opacity: 1;
  background-color: #723b13;
  background-color: rgba(114, 59, 19, var(--bg-opacity));
}
.active\\:bg-yellow-900:active {
  --bg-opacity: 1;
  background-color: #633112;
  background-color: rgba(99, 49, 18, var(--bg-opacity));
}
.active\\:bg-green-50:active {
  --bg-opacity: 1;
  background-color: #f3faf7;
  background-color: rgba(243, 250, 247, var(--bg-opacity));
}
.active\\:bg-green-100:active {
  --bg-opacity: 1;
  background-color: #def7ec;
  background-color: rgba(222, 247, 236, var(--bg-opacity));
}
.active\\:bg-green-200:active {
  --bg-opacity: 1;
  background-color: #bcf0da;
  background-color: rgba(188, 240, 218, var(--bg-opacity));
}
.active\\:bg-green-300:active {
  --bg-opacity: 1;
  background-color: #84e1bc;
  background-color: rgba(132, 225, 188, var(--bg-opacity));
}
.active\\:bg-green-400:active {
  --bg-opacity: 1;
  background-color: #31c48d;
  background-color: rgba(49, 196, 141, var(--bg-opacity));
}
.active\\:bg-green-500:active {
  --bg-opacity: 1;
  background-color: #0e9f6e;
  background-color: rgba(14, 159, 110, var(--bg-opacity));
}
.active\\:bg-green-600:active {
  --bg-opacity: 1;
  background-color: #057a55;
  background-color: rgba(5, 122, 85, var(--bg-opacity));
}
.active\\:bg-green-700:active {
  --bg-opacity: 1;
  background-color: #046c4e;
  background-color: rgba(4, 108, 78, var(--bg-opacity));
}
.active\\:bg-green-800:active {
  --bg-opacity: 1;
  background-color: #03543f;
  background-color: rgba(3, 84, 63, var(--bg-opacity));
}
.active\\:bg-green-900:active {
  --bg-opacity: 1;
  background-color: #014737;
  background-color: rgba(1, 71, 55, var(--bg-opacity));
}
.active\\:bg-teal-50:active {
  --bg-opacity: 1;
  background-color: #edfafa;
  background-color: rgba(237, 250, 250, var(--bg-opacity));
}
.active\\:bg-teal-100:active {
  --bg-opacity: 1;
  background-color: #d5f5f6;
  background-color: rgba(213, 245, 246, var(--bg-opacity));
}
.active\\:bg-teal-200:active {
  --bg-opacity: 1;
  background-color: #afecef;
  background-color: rgba(175, 236, 239, var(--bg-opacity));
}
.active\\:bg-teal-300:active {
  --bg-opacity: 1;
  background-color: #7edce2;
  background-color: rgba(126, 220, 226, var(--bg-opacity));
}
.active\\:bg-teal-400:active {
  --bg-opacity: 1;
  background-color: #16bdca;
  background-color: rgba(22, 189, 202, var(--bg-opacity));
}
.active\\:bg-teal-500:active {
  --bg-opacity: 1;
  background-color: #0694a2;
  background-color: rgba(6, 148, 162, var(--bg-opacity));
}
.active\\:bg-teal-600:active {
  --bg-opacity: 1;
  background-color: #047481;
  background-color: rgba(4, 116, 129, var(--bg-opacity));
}
.active\\:bg-teal-700:active {
  --bg-opacity: 1;
  background-color: #036672;
  background-color: rgba(3, 102, 114, var(--bg-opacity));
}
.active\\:bg-teal-800:active {
  --bg-opacity: 1;
  background-color: #05505c;
  background-color: rgba(5, 80, 92, var(--bg-opacity));
}
.active\\:bg-teal-900:active {
  --bg-opacity: 1;
  background-color: #014451;
  background-color: rgba(1, 68, 81, var(--bg-opacity));
}
.active\\:bg-blue-50:active {
  --bg-opacity: 1;
  background-color: #ebf5ff;
  background-color: rgba(235, 245, 255, var(--bg-opacity));
}
.active\\:bg-blue-100:active {
  --bg-opacity: 1;
  background-color: #e1effe;
  background-color: rgba(225, 239, 254, var(--bg-opacity));
}
.active\\:bg-blue-200:active {
  --bg-opacity: 1;
  background-color: #c3ddfd;
  background-color: rgba(195, 221, 253, var(--bg-opacity));
}
.active\\:bg-blue-300:active {
  --bg-opacity: 1;
  background-color: #a4cafe;
  background-color: rgba(164, 202, 254, var(--bg-opacity));
}
.active\\:bg-blue-400:active {
  --bg-opacity: 1;
  background-color: #76a9fa;
  background-color: rgba(118, 169, 250, var(--bg-opacity));
}
.active\\:bg-blue-500:active {
  --bg-opacity: 1;
  background-color: #3f83f8;
  background-color: rgba(63, 131, 248, var(--bg-opacity));
}
.active\\:bg-blue-600:active {
  --bg-opacity: 1;
  background-color: #1c64f2;
  background-color: rgba(28, 100, 242, var(--bg-opacity));
}
.active\\:bg-blue-700:active {
  --bg-opacity: 1;
  background-color: #1a56db;
  background-color: rgba(26, 86, 219, var(--bg-opacity));
}
.active\\:bg-blue-800:active {
  --bg-opacity: 1;
  background-color: #1e429f;
  background-color: rgba(30, 66, 159, var(--bg-opacity));
}
.active\\:bg-blue-900:active {
  --bg-opacity: 1;
  background-color: #233876;
  background-color: rgba(35, 56, 118, var(--bg-opacity));
}
.active\\:bg-indigo-50:active {
  --bg-opacity: 1;
  background-color: #f0f5ff;
  background-color: rgba(240, 245, 255, var(--bg-opacity));
}
.active\\:bg-indigo-100:active {
  --bg-opacity: 1;
  background-color: #e5edff;
  background-color: rgba(229, 237, 255, var(--bg-opacity));
}
.active\\:bg-indigo-200:active {
  --bg-opacity: 1;
  background-color: #cddbfe;
  background-color: rgba(205, 219, 254, var(--bg-opacity));
}
.active\\:bg-indigo-300:active {
  --bg-opacity: 1;
  background-color: #b4c6fc;
  background-color: rgba(180, 198, 252, var(--bg-opacity));
}
.active\\:bg-indigo-400:active {
  --bg-opacity: 1;
  background-color: #8da2fb;
  background-color: rgba(141, 162, 251, var(--bg-opacity));
}
.active\\:bg-indigo-500:active {
  --bg-opacity: 1;
  background-color: #6875f5;
  background-color: rgba(104, 117, 245, var(--bg-opacity));
}
.active\\:bg-indigo-600:active {
  --bg-opacity: 1;
  background-color: #5850ec;
  background-color: rgba(88, 80, 236, var(--bg-opacity));
}
.active\\:bg-indigo-700:active {
  --bg-opacity: 1;
  background-color: #5145cd;
  background-color: rgba(81, 69, 205, var(--bg-opacity));
}
.active\\:bg-indigo-800:active {
  --bg-opacity: 1;
  background-color: #42389d;
  background-color: rgba(66, 56, 157, var(--bg-opacity));
}
.active\\:bg-indigo-900:active {
  --bg-opacity: 1;
  background-color: #362f78;
  background-color: rgba(54, 47, 120, var(--bg-opacity));
}
.active\\:bg-purple-50:active {
  --bg-opacity: 1;
  background-color: #f6f5ff;
  background-color: rgba(246, 245, 255, var(--bg-opacity));
}
.active\\:bg-purple-100:active {
  --bg-opacity: 1;
  background-color: #edebfe;
  background-color: rgba(237, 235, 254, var(--bg-opacity));
}
.active\\:bg-purple-200:active {
  --bg-opacity: 1;
  background-color: #dcd7fe;
  background-color: rgba(220, 215, 254, var(--bg-opacity));
}
.active\\:bg-purple-300:active {
  --bg-opacity: 1;
  background-color: #cabffd;
  background-color: rgba(202, 191, 253, var(--bg-opacity));
}
.active\\:bg-purple-400:active {
  --bg-opacity: 1;
  background-color: #ac94fa;
  background-color: rgba(172, 148, 250, var(--bg-opacity));
}
.active\\:bg-purple-500:active {
  --bg-opacity: 1;
  background-color: #9061f9;
  background-color: rgba(144, 97, 249, var(--bg-opacity));
}
.active\\:bg-purple-600:active {
  --bg-opacity: 1;
  background-color: #7e3af2;
  background-color: rgba(126, 58, 242, var(--bg-opacity));
}
.active\\:bg-purple-700:active {
  --bg-opacity: 1;
  background-color: #6c2bd9;
  background-color: rgba(108, 43, 217, var(--bg-opacity));
}
.active\\:bg-purple-800:active {
  --bg-opacity: 1;
  background-color: #5521b5;
  background-color: rgba(85, 33, 181, var(--bg-opacity));
}
.active\\:bg-purple-900:active {
  --bg-opacity: 1;
  background-color: #4a1d96;
  background-color: rgba(74, 29, 150, var(--bg-opacity));
}
.active\\:bg-pink-50:active {
  --bg-opacity: 1;
  background-color: #fdf2f8;
  background-color: rgba(253, 242, 248, var(--bg-opacity));
}
.active\\:bg-pink-100:active {
  --bg-opacity: 1;
  background-color: #fce8f3;
  background-color: rgba(252, 232, 243, var(--bg-opacity));
}
.active\\:bg-pink-200:active {
  --bg-opacity: 1;
  background-color: #fad1e8;
  background-color: rgba(250, 209, 232, var(--bg-opacity));
}
.active\\:bg-pink-300:active {
  --bg-opacity: 1;
  background-color: #f8b4d9;
  background-color: rgba(248, 180, 217, var(--bg-opacity));
}
.active\\:bg-pink-400:active {
  --bg-opacity: 1;
  background-color: #f17eb8;
  background-color: rgba(241, 126, 184, var(--bg-opacity));
}
.active\\:bg-pink-500:active {
  --bg-opacity: 1;
  background-color: #e74694;
  background-color: rgba(231, 70, 148, var(--bg-opacity));
}
.active\\:bg-pink-600:active {
  --bg-opacity: 1;
  background-color: #d61f69;
  background-color: rgba(214, 31, 105, var(--bg-opacity));
}
.active\\:bg-pink-700:active {
  --bg-opacity: 1;
  background-color: #bf125d;
  background-color: rgba(191, 18, 93, var(--bg-opacity));
}
.active\\:bg-pink-800:active {
  --bg-opacity: 1;
  background-color: #99154b;
  background-color: rgba(153, 21, 75, var(--bg-opacity));
}
.active\\:bg-pink-900:active {
  --bg-opacity: 1;
  background-color: #751a3d;
  background-color: rgba(117, 26, 61, var(--bg-opacity));
}
.active\\:bg-cool-gray-50:active {
  --bg-opacity: 1;
  background-color: #f8fafc;
  background-color: rgba(248, 250, 252, var(--bg-opacity));
}
.active\\:bg-cool-gray-100:active {
  --bg-opacity: 1;
  background-color: #f1f5f9;
  background-color: rgba(241, 245, 249, var(--bg-opacity));
}
.active\\:bg-cool-gray-200:active {
  --bg-opacity: 1;
  background-color: #e2e8f0;
  background-color: rgba(226, 232, 240, var(--bg-opacity));
}
.active\\:bg-cool-gray-300:active {
  --bg-opacity: 1;
  background-color: #cfd8e3;
  background-color: rgba(207, 216, 227, var(--bg-opacity));
}
.active\\:bg-cool-gray-400:active {
  --bg-opacity: 1;
  background-color: #97a6ba;
  background-color: rgba(151, 166, 186, var(--bg-opacity));
}
.active\\:bg-cool-gray-500:active {
  --bg-opacity: 1;
  background-color: #64748b;
  background-color: rgba(100, 116, 139, var(--bg-opacity));
}
.active\\:bg-cool-gray-600:active {
  --bg-opacity: 1;
  background-color: #475569;
  background-color: rgba(71, 85, 105, var(--bg-opacity));
}
.active\\:bg-cool-gray-700:active {
  --bg-opacity: 1;
  background-color: #364152;
  background-color: rgba(54, 65, 82, var(--bg-opacity));
}
.active\\:bg-cool-gray-800:active {
  --bg-opacity: 1;
  background-color: #27303f;
  background-color: rgba(39, 48, 63, var(--bg-opacity));
}
.active\\:bg-cool-gray-900:active {
  --bg-opacity: 1;
  background-color: #1a202e;
  background-color: rgba(26, 32, 46, var(--bg-opacity));
}
.bg-none {
  background-image: none;
}
.bg-gradient-to-t {
  background-image: linear-gradient(to top, var(--gradient-color-stops));
}
.bg-gradient-to-tr {
  background-image: linear-gradient(to top right, var(--gradient-color-stops));
}
.bg-gradient-to-r {
  background-image: linear-gradient(to right, var(--gradient-color-stops));
}
.bg-gradient-to-br {
  background-image: linear-gradient(to bottom right, var(--gradient-color-stops));
}
.bg-gradient-to-b {
  background-image: linear-gradient(to bottom, var(--gradient-color-stops));
}
.bg-gradient-to-bl {
  background-image: linear-gradient(to bottom left, var(--gradient-color-stops));
}
.bg-gradient-to-l {
  background-image: linear-gradient(to left, var(--gradient-color-stops));
}
.bg-gradient-to-tl {
  background-image: linear-gradient(to top left, var(--gradient-color-stops));
}
.from-current {
  --gradient-from-color: currentColor;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
}
.from-transparent {
  --gradient-from-color: transparent;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
}
.from-white {
  --gradient-from-color: #ffffff;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
}
.from-black {
  --gradient-from-color: #000000;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
}
.from-gray-50 {
  --gradient-from-color: #f9fafb;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(249, 250, 251, 0));
}
.from-gray-100 {
  --gradient-from-color: #f4f5f7;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(244, 245, 247, 0));
}
.from-gray-200 {
  --gradient-from-color: #e5e7eb;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(229, 231, 235, 0));
}
.from-gray-300 {
  --gradient-from-color: #d2d6dc;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(210, 214, 220, 0));
}
.from-gray-400 {
  --gradient-from-color: #9fa6b2;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(159, 166, 178, 0));
}
.from-gray-500 {
  --gradient-from-color: #6b7280;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(107, 114, 128, 0));
}
.from-gray-600 {
  --gradient-from-color: #4b5563;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(75, 85, 99, 0));
}
.from-gray-700 {
  --gradient-from-color: #374151;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(55, 65, 81, 0));
}
.from-gray-800 {
  --gradient-from-color: #252f3f;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(37, 47, 63, 0));
}
.from-gray-900 {
  --gradient-from-color: #161e2e;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(22, 30, 46, 0));
}
.from-red-50 {
  --gradient-from-color: #fdf2f2;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 242, 242, 0));
}
.from-red-100 {
  --gradient-from-color: #fde8e8;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 232, 232, 0));
}
.from-red-200 {
  --gradient-from-color: #fbd5d5;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(251, 213, 213, 0));
}
.from-red-300 {
  --gradient-from-color: #f8b4b4;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(248, 180, 180, 0));
}
.from-red-400 {
  --gradient-from-color: #f98080;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(249, 128, 128, 0));
}
.from-red-500 {
  --gradient-from-color: #f05252;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(240, 82, 82, 0));
}
.from-red-600 {
  --gradient-from-color: #e02424;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(224, 36, 36, 0));
}
.from-red-700 {
  --gradient-from-color: #c81e1e;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(200, 30, 30, 0));
}
.from-red-800 {
  --gradient-from-color: #9b1c1c;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(155, 28, 28, 0));
}
.from-red-900 {
  --gradient-from-color: #771d1d;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(119, 29, 29, 0));
}
.from-orange-50 {
  --gradient-from-color: #fff8f1;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 248, 241, 0));
}
.from-orange-100 {
  --gradient-from-color: #feecdc;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 236, 220, 0));
}
.from-orange-200 {
  --gradient-from-color: #fcd9bd;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(252, 217, 189, 0));
}
.from-orange-300 {
  --gradient-from-color: #fdba8c;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 186, 140, 0));
}
.from-orange-400 {
  --gradient-from-color: #ff8a4c;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 138, 76, 0));
}
.from-orange-500 {
  --gradient-from-color: #ff5a1f;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 90, 31, 0));
}
.from-orange-600 {
  --gradient-from-color: #d03801;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(208, 56, 1, 0));
}
.from-orange-700 {
  --gradient-from-color: #b43403;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(180, 52, 3, 0));
}
.from-orange-800 {
  --gradient-from-color: #8a2c0d;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(138, 44, 13, 0));
}
.from-orange-900 {
  --gradient-from-color: #73230d;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(115, 35, 13, 0));
}
.from-yellow-50 {
  --gradient-from-color: #fdfdea;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 253, 234, 0));
}
.from-yellow-100 {
  --gradient-from-color: #fdf6b2;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 246, 178, 0));
}
.from-yellow-200 {
  --gradient-from-color: #fce96a;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(252, 233, 106, 0));
}
.from-yellow-300 {
  --gradient-from-color: #faca15;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(250, 202, 21, 0));
}
.from-yellow-400 {
  --gradient-from-color: #e3a008;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(227, 160, 8, 0));
}
.from-yellow-500 {
  --gradient-from-color: #c27803;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(194, 120, 3, 0));
}
.from-yellow-600 {
  --gradient-from-color: #9f580a;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(159, 88, 10, 0));
}
.from-yellow-700 {
  --gradient-from-color: #8e4b10;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(142, 75, 16, 0));
}
.from-yellow-800 {
  --gradient-from-color: #723b13;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(114, 59, 19, 0));
}
.from-yellow-900 {
  --gradient-from-color: #633112;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(99, 49, 18, 0));
}
.from-green-50 {
  --gradient-from-color: #f3faf7;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(243, 250, 247, 0));
}
.from-green-100 {
  --gradient-from-color: #def7ec;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(222, 247, 236, 0));
}
.from-green-200 {
  --gradient-from-color: #bcf0da;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(188, 240, 218, 0));
}
.from-green-300 {
  --gradient-from-color: #84e1bc;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(132, 225, 188, 0));
}
.from-green-400 {
  --gradient-from-color: #31c48d;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(49, 196, 141, 0));
}
.from-green-500 {
  --gradient-from-color: #0e9f6e;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(14, 159, 110, 0));
}
.from-green-600 {
  --gradient-from-color: #057a55;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(5, 122, 85, 0));
}
.from-green-700 {
  --gradient-from-color: #046c4e;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(4, 108, 78, 0));
}
.from-green-800 {
  --gradient-from-color: #03543f;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(3, 84, 63, 0));
}
.from-green-900 {
  --gradient-from-color: #014737;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(1, 71, 55, 0));
}
.from-teal-50 {
  --gradient-from-color: #edfafa;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(237, 250, 250, 0));
}
.from-teal-100 {
  --gradient-from-color: #d5f5f6;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(213, 245, 246, 0));
}
.from-teal-200 {
  --gradient-from-color: #afecef;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(175, 236, 239, 0));
}
.from-teal-300 {
  --gradient-from-color: #7edce2;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(126, 220, 226, 0));
}
.from-teal-400 {
  --gradient-from-color: #16bdca;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(22, 189, 202, 0));
}
.from-teal-500 {
  --gradient-from-color: #0694a2;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(6, 148, 162, 0));
}
.from-teal-600 {
  --gradient-from-color: #047481;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(4, 116, 129, 0));
}
.from-teal-700 {
  --gradient-from-color: #036672;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(3, 102, 114, 0));
}
.from-teal-800 {
  --gradient-from-color: #05505c;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(5, 80, 92, 0));
}
.from-teal-900 {
  --gradient-from-color: #014451;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(1, 68, 81, 0));
}
.from-blue-50 {
  --gradient-from-color: #ebf5ff;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(235, 245, 255, 0));
}
.from-blue-100 {
  --gradient-from-color: #e1effe;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(225, 239, 254, 0));
}
.from-blue-200 {
  --gradient-from-color: #c3ddfd;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(195, 221, 253, 0));
}
.from-blue-300 {
  --gradient-from-color: #a4cafe;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(164, 202, 254, 0));
}
.from-blue-400 {
  --gradient-from-color: #76a9fa;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(118, 169, 250, 0));
}
.from-blue-500 {
  --gradient-from-color: #3f83f8;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(63, 131, 248, 0));
}
.from-blue-600 {
  --gradient-from-color: #1c64f2;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(28, 100, 242, 0));
}
.from-blue-700 {
  --gradient-from-color: #1a56db;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(26, 86, 219, 0));
}
.from-blue-800 {
  --gradient-from-color: #1e429f;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(30, 66, 159, 0));
}
.from-blue-900 {
  --gradient-from-color: #233876;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(35, 56, 118, 0));
}
.from-indigo-50 {
  --gradient-from-color: #f0f5ff;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(240, 245, 255, 0));
}
.from-indigo-100 {
  --gradient-from-color: #e5edff;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(229, 237, 255, 0));
}
.from-indigo-200 {
  --gradient-from-color: #cddbfe;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(205, 219, 254, 0));
}
.from-indigo-300 {
  --gradient-from-color: #b4c6fc;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(180, 198, 252, 0));
}
.from-indigo-400 {
  --gradient-from-color: #8da2fb;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(141, 162, 251, 0));
}
.from-indigo-500 {
  --gradient-from-color: #6875f5;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(104, 117, 245, 0));
}
.from-indigo-600 {
  --gradient-from-color: #5850ec;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(88, 80, 236, 0));
}
.from-indigo-700 {
  --gradient-from-color: #5145cd;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(81, 69, 205, 0));
}
.from-indigo-800 {
  --gradient-from-color: #42389d;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(66, 56, 157, 0));
}
.from-indigo-900 {
  --gradient-from-color: #362f78;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(54, 47, 120, 0));
}
.from-purple-50 {
  --gradient-from-color: #f6f5ff;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(246, 245, 255, 0));
}
.from-purple-100 {
  --gradient-from-color: #edebfe;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(237, 235, 254, 0));
}
.from-purple-200 {
  --gradient-from-color: #dcd7fe;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(220, 215, 254, 0));
}
.from-purple-300 {
  --gradient-from-color: #cabffd;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(202, 191, 253, 0));
}
.from-purple-400 {
  --gradient-from-color: #ac94fa;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(172, 148, 250, 0));
}
.from-purple-500 {
  --gradient-from-color: #9061f9;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(144, 97, 249, 0));
}
.from-purple-600 {
  --gradient-from-color: #7e3af2;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(126, 58, 242, 0));
}
.from-purple-700 {
  --gradient-from-color: #6c2bd9;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(108, 43, 217, 0));
}
.from-purple-800 {
  --gradient-from-color: #5521b5;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(85, 33, 181, 0));
}
.from-purple-900 {
  --gradient-from-color: #4a1d96;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(74, 29, 150, 0));
}
.from-pink-50 {
  --gradient-from-color: #fdf2f8;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 242, 248, 0));
}
.from-pink-100 {
  --gradient-from-color: #fce8f3;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(252, 232, 243, 0));
}
.from-pink-200 {
  --gradient-from-color: #fad1e8;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(250, 209, 232, 0));
}
.from-pink-300 {
  --gradient-from-color: #f8b4d9;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(248, 180, 217, 0));
}
.from-pink-400 {
  --gradient-from-color: #f17eb8;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(241, 126, 184, 0));
}
.from-pink-500 {
  --gradient-from-color: #e74694;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(231, 70, 148, 0));
}
.from-pink-600 {
  --gradient-from-color: #d61f69;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(214, 31, 105, 0));
}
.from-pink-700 {
  --gradient-from-color: #bf125d;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(191, 18, 93, 0));
}
.from-pink-800 {
  --gradient-from-color: #99154b;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(153, 21, 75, 0));
}
.from-pink-900 {
  --gradient-from-color: #751a3d;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(117, 26, 61, 0));
}
.from-cool-gray-50 {
  --gradient-from-color: #f8fafc;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(248, 250, 252, 0));
}
.from-cool-gray-100 {
  --gradient-from-color: #f1f5f9;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(241, 245, 249, 0));
}
.from-cool-gray-200 {
  --gradient-from-color: #e2e8f0;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(226, 232, 240, 0));
}
.from-cool-gray-300 {
  --gradient-from-color: #cfd8e3;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(207, 216, 227, 0));
}
.from-cool-gray-400 {
  --gradient-from-color: #97a6ba;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(151, 166, 186, 0));
}
.from-cool-gray-500 {
  --gradient-from-color: #64748b;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(100, 116, 139, 0));
}
.from-cool-gray-600 {
  --gradient-from-color: #475569;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(71, 85, 105, 0));
}
.from-cool-gray-700 {
  --gradient-from-color: #364152;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(54, 65, 82, 0));
}
.from-cool-gray-800 {
  --gradient-from-color: #27303f;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(39, 48, 63, 0));
}
.from-cool-gray-900 {
  --gradient-from-color: #1a202e;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(26, 32, 46, 0));
}
.via-current {
  --gradient-via-color: currentColor;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
}
.via-transparent {
  --gradient-via-color: transparent;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
}
.via-white {
  --gradient-via-color: #ffffff;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
}
.via-black {
  --gradient-via-color: #000000;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
}
.via-gray-50 {
  --gradient-via-color: #f9fafb;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(249, 250, 251, 0));
}
.via-gray-100 {
  --gradient-via-color: #f4f5f7;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(244, 245, 247, 0));
}
.via-gray-200 {
  --gradient-via-color: #e5e7eb;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(229, 231, 235, 0));
}
.via-gray-300 {
  --gradient-via-color: #d2d6dc;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(210, 214, 220, 0));
}
.via-gray-400 {
  --gradient-via-color: #9fa6b2;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(159, 166, 178, 0));
}
.via-gray-500 {
  --gradient-via-color: #6b7280;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(107, 114, 128, 0));
}
.via-gray-600 {
  --gradient-via-color: #4b5563;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(75, 85, 99, 0));
}
.via-gray-700 {
  --gradient-via-color: #374151;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(55, 65, 81, 0));
}
.via-gray-800 {
  --gradient-via-color: #252f3f;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(37, 47, 63, 0));
}
.via-gray-900 {
  --gradient-via-color: #161e2e;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(22, 30, 46, 0));
}
.via-red-50 {
  --gradient-via-color: #fdf2f2;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 242, 242, 0));
}
.via-red-100 {
  --gradient-via-color: #fde8e8;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 232, 232, 0));
}
.via-red-200 {
  --gradient-via-color: #fbd5d5;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(251, 213, 213, 0));
}
.via-red-300 {
  --gradient-via-color: #f8b4b4;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(248, 180, 180, 0));
}
.via-red-400 {
  --gradient-via-color: #f98080;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(249, 128, 128, 0));
}
.via-red-500 {
  --gradient-via-color: #f05252;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(240, 82, 82, 0));
}
.via-red-600 {
  --gradient-via-color: #e02424;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(224, 36, 36, 0));
}
.via-red-700 {
  --gradient-via-color: #c81e1e;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(200, 30, 30, 0));
}
.via-red-800 {
  --gradient-via-color: #9b1c1c;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(155, 28, 28, 0));
}
.via-red-900 {
  --gradient-via-color: #771d1d;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(119, 29, 29, 0));
}
.via-orange-50 {
  --gradient-via-color: #fff8f1;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 248, 241, 0));
}
.via-orange-100 {
  --gradient-via-color: #feecdc;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 236, 220, 0));
}
.via-orange-200 {
  --gradient-via-color: #fcd9bd;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(252, 217, 189, 0));
}
.via-orange-300 {
  --gradient-via-color: #fdba8c;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 186, 140, 0));
}
.via-orange-400 {
  --gradient-via-color: #ff8a4c;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 138, 76, 0));
}
.via-orange-500 {
  --gradient-via-color: #ff5a1f;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 90, 31, 0));
}
.via-orange-600 {
  --gradient-via-color: #d03801;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(208, 56, 1, 0));
}
.via-orange-700 {
  --gradient-via-color: #b43403;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(180, 52, 3, 0));
}
.via-orange-800 {
  --gradient-via-color: #8a2c0d;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(138, 44, 13, 0));
}
.via-orange-900 {
  --gradient-via-color: #73230d;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(115, 35, 13, 0));
}
.via-yellow-50 {
  --gradient-via-color: #fdfdea;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 253, 234, 0));
}
.via-yellow-100 {
  --gradient-via-color: #fdf6b2;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 246, 178, 0));
}
.via-yellow-200 {
  --gradient-via-color: #fce96a;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(252, 233, 106, 0));
}
.via-yellow-300 {
  --gradient-via-color: #faca15;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(250, 202, 21, 0));
}
.via-yellow-400 {
  --gradient-via-color: #e3a008;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(227, 160, 8, 0));
}
.via-yellow-500 {
  --gradient-via-color: #c27803;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(194, 120, 3, 0));
}
.via-yellow-600 {
  --gradient-via-color: #9f580a;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(159, 88, 10, 0));
}
.via-yellow-700 {
  --gradient-via-color: #8e4b10;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(142, 75, 16, 0));
}
.via-yellow-800 {
  --gradient-via-color: #723b13;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(114, 59, 19, 0));
}
.via-yellow-900 {
  --gradient-via-color: #633112;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(99, 49, 18, 0));
}
.via-green-50 {
  --gradient-via-color: #f3faf7;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(243, 250, 247, 0));
}
.via-green-100 {
  --gradient-via-color: #def7ec;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(222, 247, 236, 0));
}
.via-green-200 {
  --gradient-via-color: #bcf0da;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(188, 240, 218, 0));
}
.via-green-300 {
  --gradient-via-color: #84e1bc;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(132, 225, 188, 0));
}
.via-green-400 {
  --gradient-via-color: #31c48d;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(49, 196, 141, 0));
}
.via-green-500 {
  --gradient-via-color: #0e9f6e;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(14, 159, 110, 0));
}
.via-green-600 {
  --gradient-via-color: #057a55;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(5, 122, 85, 0));
}
.via-green-700 {
  --gradient-via-color: #046c4e;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(4, 108, 78, 0));
}
.via-green-800 {
  --gradient-via-color: #03543f;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(3, 84, 63, 0));
}
.via-green-900 {
  --gradient-via-color: #014737;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(1, 71, 55, 0));
}
.via-teal-50 {
  --gradient-via-color: #edfafa;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(237, 250, 250, 0));
}
.via-teal-100 {
  --gradient-via-color: #d5f5f6;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(213, 245, 246, 0));
}
.via-teal-200 {
  --gradient-via-color: #afecef;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(175, 236, 239, 0));
}
.via-teal-300 {
  --gradient-via-color: #7edce2;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(126, 220, 226, 0));
}
.via-teal-400 {
  --gradient-via-color: #16bdca;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(22, 189, 202, 0));
}
.via-teal-500 {
  --gradient-via-color: #0694a2;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(6, 148, 162, 0));
}
.via-teal-600 {
  --gradient-via-color: #047481;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(4, 116, 129, 0));
}
.via-teal-700 {
  --gradient-via-color: #036672;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(3, 102, 114, 0));
}
.via-teal-800 {
  --gradient-via-color: #05505c;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(5, 80, 92, 0));
}
.via-teal-900 {
  --gradient-via-color: #014451;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(1, 68, 81, 0));
}
.via-blue-50 {
  --gradient-via-color: #ebf5ff;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(235, 245, 255, 0));
}
.via-blue-100 {
  --gradient-via-color: #e1effe;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(225, 239, 254, 0));
}
.via-blue-200 {
  --gradient-via-color: #c3ddfd;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(195, 221, 253, 0));
}
.via-blue-300 {
  --gradient-via-color: #a4cafe;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(164, 202, 254, 0));
}
.via-blue-400 {
  --gradient-via-color: #76a9fa;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(118, 169, 250, 0));
}
.via-blue-500 {
  --gradient-via-color: #3f83f8;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(63, 131, 248, 0));
}
.via-blue-600 {
  --gradient-via-color: #1c64f2;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(28, 100, 242, 0));
}
.via-blue-700 {
  --gradient-via-color: #1a56db;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(26, 86, 219, 0));
}
.via-blue-800 {
  --gradient-via-color: #1e429f;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(30, 66, 159, 0));
}
.via-blue-900 {
  --gradient-via-color: #233876;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(35, 56, 118, 0));
}
.via-indigo-50 {
  --gradient-via-color: #f0f5ff;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(240, 245, 255, 0));
}
.via-indigo-100 {
  --gradient-via-color: #e5edff;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(229, 237, 255, 0));
}
.via-indigo-200 {
  --gradient-via-color: #cddbfe;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(205, 219, 254, 0));
}
.via-indigo-300 {
  --gradient-via-color: #b4c6fc;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(180, 198, 252, 0));
}
.via-indigo-400 {
  --gradient-via-color: #8da2fb;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(141, 162, 251, 0));
}
.via-indigo-500 {
  --gradient-via-color: #6875f5;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(104, 117, 245, 0));
}
.via-indigo-600 {
  --gradient-via-color: #5850ec;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(88, 80, 236, 0));
}
.via-indigo-700 {
  --gradient-via-color: #5145cd;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(81, 69, 205, 0));
}
.via-indigo-800 {
  --gradient-via-color: #42389d;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(66, 56, 157, 0));
}
.via-indigo-900 {
  --gradient-via-color: #362f78;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(54, 47, 120, 0));
}
.via-purple-50 {
  --gradient-via-color: #f6f5ff;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(246, 245, 255, 0));
}
.via-purple-100 {
  --gradient-via-color: #edebfe;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(237, 235, 254, 0));
}
.via-purple-200 {
  --gradient-via-color: #dcd7fe;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(220, 215, 254, 0));
}
.via-purple-300 {
  --gradient-via-color: #cabffd;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(202, 191, 253, 0));
}
.via-purple-400 {
  --gradient-via-color: #ac94fa;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(172, 148, 250, 0));
}
.via-purple-500 {
  --gradient-via-color: #9061f9;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(144, 97, 249, 0));
}
.via-purple-600 {
  --gradient-via-color: #7e3af2;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(126, 58, 242, 0));
}
.via-purple-700 {
  --gradient-via-color: #6c2bd9;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(108, 43, 217, 0));
}
.via-purple-800 {
  --gradient-via-color: #5521b5;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(85, 33, 181, 0));
}
.via-purple-900 {
  --gradient-via-color: #4a1d96;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(74, 29, 150, 0));
}
.via-pink-50 {
  --gradient-via-color: #fdf2f8;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 242, 248, 0));
}
.via-pink-100 {
  --gradient-via-color: #fce8f3;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(252, 232, 243, 0));
}
.via-pink-200 {
  --gradient-via-color: #fad1e8;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(250, 209, 232, 0));
}
.via-pink-300 {
  --gradient-via-color: #f8b4d9;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(248, 180, 217, 0));
}
.via-pink-400 {
  --gradient-via-color: #f17eb8;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(241, 126, 184, 0));
}
.via-pink-500 {
  --gradient-via-color: #e74694;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(231, 70, 148, 0));
}
.via-pink-600 {
  --gradient-via-color: #d61f69;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(214, 31, 105, 0));
}
.via-pink-700 {
  --gradient-via-color: #bf125d;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(191, 18, 93, 0));
}
.via-pink-800 {
  --gradient-via-color: #99154b;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(153, 21, 75, 0));
}
.via-pink-900 {
  --gradient-via-color: #751a3d;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(117, 26, 61, 0));
}
.via-cool-gray-50 {
  --gradient-via-color: #f8fafc;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(248, 250, 252, 0));
}
.via-cool-gray-100 {
  --gradient-via-color: #f1f5f9;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(241, 245, 249, 0));
}
.via-cool-gray-200 {
  --gradient-via-color: #e2e8f0;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(226, 232, 240, 0));
}
.via-cool-gray-300 {
  --gradient-via-color: #cfd8e3;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(207, 216, 227, 0));
}
.via-cool-gray-400 {
  --gradient-via-color: #97a6ba;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(151, 166, 186, 0));
}
.via-cool-gray-500 {
  --gradient-via-color: #64748b;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(100, 116, 139, 0));
}
.via-cool-gray-600 {
  --gradient-via-color: #475569;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(71, 85, 105, 0));
}
.via-cool-gray-700 {
  --gradient-via-color: #364152;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(54, 65, 82, 0));
}
.via-cool-gray-800 {
  --gradient-via-color: #27303f;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(39, 48, 63, 0));
}
.via-cool-gray-900 {
  --gradient-via-color: #1a202e;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(26, 32, 46, 0));
}
.to-current {
  --gradient-to-color: currentColor;
}
.to-transparent {
  --gradient-to-color: transparent;
}
.to-white {
  --gradient-to-color: #ffffff;
}
.to-black {
  --gradient-to-color: #000000;
}
.to-gray-50 {
  --gradient-to-color: #f9fafb;
}
.to-gray-100 {
  --gradient-to-color: #f4f5f7;
}
.to-gray-200 {
  --gradient-to-color: #e5e7eb;
}
.to-gray-300 {
  --gradient-to-color: #d2d6dc;
}
.to-gray-400 {
  --gradient-to-color: #9fa6b2;
}
.to-gray-500 {
  --gradient-to-color: #6b7280;
}
.to-gray-600 {
  --gradient-to-color: #4b5563;
}
.to-gray-700 {
  --gradient-to-color: #374151;
}
.to-gray-800 {
  --gradient-to-color: #252f3f;
}
.to-gray-900 {
  --gradient-to-color: #161e2e;
}
.to-red-50 {
  --gradient-to-color: #fdf2f2;
}
.to-red-100 {
  --gradient-to-color: #fde8e8;
}
.to-red-200 {
  --gradient-to-color: #fbd5d5;
}
.to-red-300 {
  --gradient-to-color: #f8b4b4;
}
.to-red-400 {
  --gradient-to-color: #f98080;
}
.to-red-500 {
  --gradient-to-color: #f05252;
}
.to-red-600 {
  --gradient-to-color: #e02424;
}
.to-red-700 {
  --gradient-to-color: #c81e1e;
}
.to-red-800 {
  --gradient-to-color: #9b1c1c;
}
.to-red-900 {
  --gradient-to-color: #771d1d;
}
.to-orange-50 {
  --gradient-to-color: #fff8f1;
}
.to-orange-100 {
  --gradient-to-color: #feecdc;
}
.to-orange-200 {
  --gradient-to-color: #fcd9bd;
}
.to-orange-300 {
  --gradient-to-color: #fdba8c;
}
.to-orange-400 {
  --gradient-to-color: #ff8a4c;
}
.to-orange-500 {
  --gradient-to-color: #ff5a1f;
}
.to-orange-600 {
  --gradient-to-color: #d03801;
}
.to-orange-700 {
  --gradient-to-color: #b43403;
}
.to-orange-800 {
  --gradient-to-color: #8a2c0d;
}
.to-orange-900 {
  --gradient-to-color: #73230d;
}
.to-yellow-50 {
  --gradient-to-color: #fdfdea;
}
.to-yellow-100 {
  --gradient-to-color: #fdf6b2;
}
.to-yellow-200 {
  --gradient-to-color: #fce96a;
}
.to-yellow-300 {
  --gradient-to-color: #faca15;
}
.to-yellow-400 {
  --gradient-to-color: #e3a008;
}
.to-yellow-500 {
  --gradient-to-color: #c27803;
}
.to-yellow-600 {
  --gradient-to-color: #9f580a;
}
.to-yellow-700 {
  --gradient-to-color: #8e4b10;
}
.to-yellow-800 {
  --gradient-to-color: #723b13;
}
.to-yellow-900 {
  --gradient-to-color: #633112;
}
.to-green-50 {
  --gradient-to-color: #f3faf7;
}
.to-green-100 {
  --gradient-to-color: #def7ec;
}
.to-green-200 {
  --gradient-to-color: #bcf0da;
}
.to-green-300 {
  --gradient-to-color: #84e1bc;
}
.to-green-400 {
  --gradient-to-color: #31c48d;
}
.to-green-500 {
  --gradient-to-color: #0e9f6e;
}
.to-green-600 {
  --gradient-to-color: #057a55;
}
.to-green-700 {
  --gradient-to-color: #046c4e;
}
.to-green-800 {
  --gradient-to-color: #03543f;
}
.to-green-900 {
  --gradient-to-color: #014737;
}
.to-teal-50 {
  --gradient-to-color: #edfafa;
}
.to-teal-100 {
  --gradient-to-color: #d5f5f6;
}
.to-teal-200 {
  --gradient-to-color: #afecef;
}
.to-teal-300 {
  --gradient-to-color: #7edce2;
}
.to-teal-400 {
  --gradient-to-color: #16bdca;
}
.to-teal-500 {
  --gradient-to-color: #0694a2;
}
.to-teal-600 {
  --gradient-to-color: #047481;
}
.to-teal-700 {
  --gradient-to-color: #036672;
}
.to-teal-800 {
  --gradient-to-color: #05505c;
}
.to-teal-900 {
  --gradient-to-color: #014451;
}
.to-blue-50 {
  --gradient-to-color: #ebf5ff;
}
.to-blue-100 {
  --gradient-to-color: #e1effe;
}
.to-blue-200 {
  --gradient-to-color: #c3ddfd;
}
.to-blue-300 {
  --gradient-to-color: #a4cafe;
}
.to-blue-400 {
  --gradient-to-color: #76a9fa;
}
.to-blue-500 {
  --gradient-to-color: #3f83f8;
}
.to-blue-600 {
  --gradient-to-color: #1c64f2;
}
.to-blue-700 {
  --gradient-to-color: #1a56db;
}
.to-blue-800 {
  --gradient-to-color: #1e429f;
}
.to-blue-900 {
  --gradient-to-color: #233876;
}
.to-indigo-50 {
  --gradient-to-color: #f0f5ff;
}
.to-indigo-100 {
  --gradient-to-color: #e5edff;
}
.to-indigo-200 {
  --gradient-to-color: #cddbfe;
}
.to-indigo-300 {
  --gradient-to-color: #b4c6fc;
}
.to-indigo-400 {
  --gradient-to-color: #8da2fb;
}
.to-indigo-500 {
  --gradient-to-color: #6875f5;
}
.to-indigo-600 {
  --gradient-to-color: #5850ec;
}
.to-indigo-700 {
  --gradient-to-color: #5145cd;
}
.to-indigo-800 {
  --gradient-to-color: #42389d;
}
.to-indigo-900 {
  --gradient-to-color: #362f78;
}
.to-purple-50 {
  --gradient-to-color: #f6f5ff;
}
.to-purple-100 {
  --gradient-to-color: #edebfe;
}
.to-purple-200 {
  --gradient-to-color: #dcd7fe;
}
.to-purple-300 {
  --gradient-to-color: #cabffd;
}
.to-purple-400 {
  --gradient-to-color: #ac94fa;
}
.to-purple-500 {
  --gradient-to-color: #9061f9;
}
.to-purple-600 {
  --gradient-to-color: #7e3af2;
}
.to-purple-700 {
  --gradient-to-color: #6c2bd9;
}
.to-purple-800 {
  --gradient-to-color: #5521b5;
}
.to-purple-900 {
  --gradient-to-color: #4a1d96;
}
.to-pink-50 {
  --gradient-to-color: #fdf2f8;
}
.to-pink-100 {
  --gradient-to-color: #fce8f3;
}
.to-pink-200 {
  --gradient-to-color: #fad1e8;
}
.to-pink-300 {
  --gradient-to-color: #f8b4d9;
}
.to-pink-400 {
  --gradient-to-color: #f17eb8;
}
.to-pink-500 {
  --gradient-to-color: #e74694;
}
.to-pink-600 {
  --gradient-to-color: #d61f69;
}
.to-pink-700 {
  --gradient-to-color: #bf125d;
}
.to-pink-800 {
  --gradient-to-color: #99154b;
}
.to-pink-900 {
  --gradient-to-color: #751a3d;
}
.to-cool-gray-50 {
  --gradient-to-color: #f8fafc;
}
.to-cool-gray-100 {
  --gradient-to-color: #f1f5f9;
}
.to-cool-gray-200 {
  --gradient-to-color: #e2e8f0;
}
.to-cool-gray-300 {
  --gradient-to-color: #cfd8e3;
}
.to-cool-gray-400 {
  --gradient-to-color: #97a6ba;
}
.to-cool-gray-500 {
  --gradient-to-color: #64748b;
}
.to-cool-gray-600 {
  --gradient-to-color: #475569;
}
.to-cool-gray-700 {
  --gradient-to-color: #364152;
}
.to-cool-gray-800 {
  --gradient-to-color: #27303f;
}
.to-cool-gray-900 {
  --gradient-to-color: #1a202e;
}
.hover\\:from-current:hover {
  --gradient-from-color: currentColor;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
}
.hover\\:from-transparent:hover {
  --gradient-from-color: transparent;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
}
.hover\\:from-white:hover {
  --gradient-from-color: #ffffff;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
}
.hover\\:from-black:hover {
  --gradient-from-color: #000000;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
}
.hover\\:from-gray-50:hover {
  --gradient-from-color: #f9fafb;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(249, 250, 251, 0));
}
.hover\\:from-gray-100:hover {
  --gradient-from-color: #f4f5f7;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(244, 245, 247, 0));
}
.hover\\:from-gray-200:hover {
  --gradient-from-color: #e5e7eb;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(229, 231, 235, 0));
}
.hover\\:from-gray-300:hover {
  --gradient-from-color: #d2d6dc;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(210, 214, 220, 0));
}
.hover\\:from-gray-400:hover {
  --gradient-from-color: #9fa6b2;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(159, 166, 178, 0));
}
.hover\\:from-gray-500:hover {
  --gradient-from-color: #6b7280;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(107, 114, 128, 0));
}
.hover\\:from-gray-600:hover {
  --gradient-from-color: #4b5563;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(75, 85, 99, 0));
}
.hover\\:from-gray-700:hover {
  --gradient-from-color: #374151;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(55, 65, 81, 0));
}
.hover\\:from-gray-800:hover {
  --gradient-from-color: #252f3f;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(37, 47, 63, 0));
}
.hover\\:from-gray-900:hover {
  --gradient-from-color: #161e2e;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(22, 30, 46, 0));
}
.hover\\:from-red-50:hover {
  --gradient-from-color: #fdf2f2;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 242, 242, 0));
}
.hover\\:from-red-100:hover {
  --gradient-from-color: #fde8e8;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 232, 232, 0));
}
.hover\\:from-red-200:hover {
  --gradient-from-color: #fbd5d5;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(251, 213, 213, 0));
}
.hover\\:from-red-300:hover {
  --gradient-from-color: #f8b4b4;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(248, 180, 180, 0));
}
.hover\\:from-red-400:hover {
  --gradient-from-color: #f98080;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(249, 128, 128, 0));
}
.hover\\:from-red-500:hover {
  --gradient-from-color: #f05252;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(240, 82, 82, 0));
}
.hover\\:from-red-600:hover {
  --gradient-from-color: #e02424;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(224, 36, 36, 0));
}
.hover\\:from-red-700:hover {
  --gradient-from-color: #c81e1e;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(200, 30, 30, 0));
}
.hover\\:from-red-800:hover {
  --gradient-from-color: #9b1c1c;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(155, 28, 28, 0));
}
.hover\\:from-red-900:hover {
  --gradient-from-color: #771d1d;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(119, 29, 29, 0));
}
.hover\\:from-orange-50:hover {
  --gradient-from-color: #fff8f1;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 248, 241, 0));
}
.hover\\:from-orange-100:hover {
  --gradient-from-color: #feecdc;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 236, 220, 0));
}
.hover\\:from-orange-200:hover {
  --gradient-from-color: #fcd9bd;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(252, 217, 189, 0));
}
.hover\\:from-orange-300:hover {
  --gradient-from-color: #fdba8c;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 186, 140, 0));
}
.hover\\:from-orange-400:hover {
  --gradient-from-color: #ff8a4c;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 138, 76, 0));
}
.hover\\:from-orange-500:hover {
  --gradient-from-color: #ff5a1f;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 90, 31, 0));
}
.hover\\:from-orange-600:hover {
  --gradient-from-color: #d03801;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(208, 56, 1, 0));
}
.hover\\:from-orange-700:hover {
  --gradient-from-color: #b43403;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(180, 52, 3, 0));
}
.hover\\:from-orange-800:hover {
  --gradient-from-color: #8a2c0d;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(138, 44, 13, 0));
}
.hover\\:from-orange-900:hover {
  --gradient-from-color: #73230d;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(115, 35, 13, 0));
}
.hover\\:from-yellow-50:hover {
  --gradient-from-color: #fdfdea;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 253, 234, 0));
}
.hover\\:from-yellow-100:hover {
  --gradient-from-color: #fdf6b2;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 246, 178, 0));
}
.hover\\:from-yellow-200:hover {
  --gradient-from-color: #fce96a;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(252, 233, 106, 0));
}
.hover\\:from-yellow-300:hover {
  --gradient-from-color: #faca15;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(250, 202, 21, 0));
}
.hover\\:from-yellow-400:hover {
  --gradient-from-color: #e3a008;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(227, 160, 8, 0));
}
.hover\\:from-yellow-500:hover {
  --gradient-from-color: #c27803;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(194, 120, 3, 0));
}
.hover\\:from-yellow-600:hover {
  --gradient-from-color: #9f580a;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(159, 88, 10, 0));
}
.hover\\:from-yellow-700:hover {
  --gradient-from-color: #8e4b10;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(142, 75, 16, 0));
}
.hover\\:from-yellow-800:hover {
  --gradient-from-color: #723b13;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(114, 59, 19, 0));
}
.hover\\:from-yellow-900:hover {
  --gradient-from-color: #633112;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(99, 49, 18, 0));
}
.hover\\:from-green-50:hover {
  --gradient-from-color: #f3faf7;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(243, 250, 247, 0));
}
.hover\\:from-green-100:hover {
  --gradient-from-color: #def7ec;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(222, 247, 236, 0));
}
.hover\\:from-green-200:hover {
  --gradient-from-color: #bcf0da;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(188, 240, 218, 0));
}
.hover\\:from-green-300:hover {
  --gradient-from-color: #84e1bc;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(132, 225, 188, 0));
}
.hover\\:from-green-400:hover {
  --gradient-from-color: #31c48d;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(49, 196, 141, 0));
}
.hover\\:from-green-500:hover {
  --gradient-from-color: #0e9f6e;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(14, 159, 110, 0));
}
.hover\\:from-green-600:hover {
  --gradient-from-color: #057a55;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(5, 122, 85, 0));
}
.hover\\:from-green-700:hover {
  --gradient-from-color: #046c4e;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(4, 108, 78, 0));
}
.hover\\:from-green-800:hover {
  --gradient-from-color: #03543f;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(3, 84, 63, 0));
}
.hover\\:from-green-900:hover {
  --gradient-from-color: #014737;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(1, 71, 55, 0));
}
.hover\\:from-teal-50:hover {
  --gradient-from-color: #edfafa;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(237, 250, 250, 0));
}
.hover\\:from-teal-100:hover {
  --gradient-from-color: #d5f5f6;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(213, 245, 246, 0));
}
.hover\\:from-teal-200:hover {
  --gradient-from-color: #afecef;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(175, 236, 239, 0));
}
.hover\\:from-teal-300:hover {
  --gradient-from-color: #7edce2;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(126, 220, 226, 0));
}
.hover\\:from-teal-400:hover {
  --gradient-from-color: #16bdca;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(22, 189, 202, 0));
}
.hover\\:from-teal-500:hover {
  --gradient-from-color: #0694a2;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(6, 148, 162, 0));
}
.hover\\:from-teal-600:hover {
  --gradient-from-color: #047481;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(4, 116, 129, 0));
}
.hover\\:from-teal-700:hover {
  --gradient-from-color: #036672;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(3, 102, 114, 0));
}
.hover\\:from-teal-800:hover {
  --gradient-from-color: #05505c;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(5, 80, 92, 0));
}
.hover\\:from-teal-900:hover {
  --gradient-from-color: #014451;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(1, 68, 81, 0));
}
.hover\\:from-blue-50:hover {
  --gradient-from-color: #ebf5ff;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(235, 245, 255, 0));
}
.hover\\:from-blue-100:hover {
  --gradient-from-color: #e1effe;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(225, 239, 254, 0));
}
.hover\\:from-blue-200:hover {
  --gradient-from-color: #c3ddfd;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(195, 221, 253, 0));
}
.hover\\:from-blue-300:hover {
  --gradient-from-color: #a4cafe;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(164, 202, 254, 0));
}
.hover\\:from-blue-400:hover {
  --gradient-from-color: #76a9fa;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(118, 169, 250, 0));
}
.hover\\:from-blue-500:hover {
  --gradient-from-color: #3f83f8;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(63, 131, 248, 0));
}
.hover\\:from-blue-600:hover {
  --gradient-from-color: #1c64f2;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(28, 100, 242, 0));
}
.hover\\:from-blue-700:hover {
  --gradient-from-color: #1a56db;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(26, 86, 219, 0));
}
.hover\\:from-blue-800:hover {
  --gradient-from-color: #1e429f;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(30, 66, 159, 0));
}
.hover\\:from-blue-900:hover {
  --gradient-from-color: #233876;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(35, 56, 118, 0));
}
.hover\\:from-indigo-50:hover {
  --gradient-from-color: #f0f5ff;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(240, 245, 255, 0));
}
.hover\\:from-indigo-100:hover {
  --gradient-from-color: #e5edff;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(229, 237, 255, 0));
}
.hover\\:from-indigo-200:hover {
  --gradient-from-color: #cddbfe;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(205, 219, 254, 0));
}
.hover\\:from-indigo-300:hover {
  --gradient-from-color: #b4c6fc;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(180, 198, 252, 0));
}
.hover\\:from-indigo-400:hover {
  --gradient-from-color: #8da2fb;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(141, 162, 251, 0));
}
.hover\\:from-indigo-500:hover {
  --gradient-from-color: #6875f5;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(104, 117, 245, 0));
}
.hover\\:from-indigo-600:hover {
  --gradient-from-color: #5850ec;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(88, 80, 236, 0));
}
.hover\\:from-indigo-700:hover {
  --gradient-from-color: #5145cd;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(81, 69, 205, 0));
}
.hover\\:from-indigo-800:hover {
  --gradient-from-color: #42389d;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(66, 56, 157, 0));
}
.hover\\:from-indigo-900:hover {
  --gradient-from-color: #362f78;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(54, 47, 120, 0));
}
.hover\\:from-purple-50:hover {
  --gradient-from-color: #f6f5ff;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(246, 245, 255, 0));
}
.hover\\:from-purple-100:hover {
  --gradient-from-color: #edebfe;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(237, 235, 254, 0));
}
.hover\\:from-purple-200:hover {
  --gradient-from-color: #dcd7fe;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(220, 215, 254, 0));
}
.hover\\:from-purple-300:hover {
  --gradient-from-color: #cabffd;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(202, 191, 253, 0));
}
.hover\\:from-purple-400:hover {
  --gradient-from-color: #ac94fa;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(172, 148, 250, 0));
}
.hover\\:from-purple-500:hover {
  --gradient-from-color: #9061f9;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(144, 97, 249, 0));
}
.hover\\:from-purple-600:hover {
  --gradient-from-color: #7e3af2;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(126, 58, 242, 0));
}
.hover\\:from-purple-700:hover {
  --gradient-from-color: #6c2bd9;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(108, 43, 217, 0));
}
.hover\\:from-purple-800:hover {
  --gradient-from-color: #5521b5;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(85, 33, 181, 0));
}
.hover\\:from-purple-900:hover {
  --gradient-from-color: #4a1d96;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(74, 29, 150, 0));
}
.hover\\:from-pink-50:hover {
  --gradient-from-color: #fdf2f8;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 242, 248, 0));
}
.hover\\:from-pink-100:hover {
  --gradient-from-color: #fce8f3;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(252, 232, 243, 0));
}
.hover\\:from-pink-200:hover {
  --gradient-from-color: #fad1e8;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(250, 209, 232, 0));
}
.hover\\:from-pink-300:hover {
  --gradient-from-color: #f8b4d9;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(248, 180, 217, 0));
}
.hover\\:from-pink-400:hover {
  --gradient-from-color: #f17eb8;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(241, 126, 184, 0));
}
.hover\\:from-pink-500:hover {
  --gradient-from-color: #e74694;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(231, 70, 148, 0));
}
.hover\\:from-pink-600:hover {
  --gradient-from-color: #d61f69;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(214, 31, 105, 0));
}
.hover\\:from-pink-700:hover {
  --gradient-from-color: #bf125d;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(191, 18, 93, 0));
}
.hover\\:from-pink-800:hover {
  --gradient-from-color: #99154b;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(153, 21, 75, 0));
}
.hover\\:from-pink-900:hover {
  --gradient-from-color: #751a3d;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(117, 26, 61, 0));
}
.hover\\:from-cool-gray-50:hover {
  --gradient-from-color: #f8fafc;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(248, 250, 252, 0));
}
.hover\\:from-cool-gray-100:hover {
  --gradient-from-color: #f1f5f9;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(241, 245, 249, 0));
}
.hover\\:from-cool-gray-200:hover {
  --gradient-from-color: #e2e8f0;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(226, 232, 240, 0));
}
.hover\\:from-cool-gray-300:hover {
  --gradient-from-color: #cfd8e3;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(207, 216, 227, 0));
}
.hover\\:from-cool-gray-400:hover {
  --gradient-from-color: #97a6ba;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(151, 166, 186, 0));
}
.hover\\:from-cool-gray-500:hover {
  --gradient-from-color: #64748b;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(100, 116, 139, 0));
}
.hover\\:from-cool-gray-600:hover {
  --gradient-from-color: #475569;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(71, 85, 105, 0));
}
.hover\\:from-cool-gray-700:hover {
  --gradient-from-color: #364152;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(54, 65, 82, 0));
}
.hover\\:from-cool-gray-800:hover {
  --gradient-from-color: #27303f;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(39, 48, 63, 0));
}
.hover\\:from-cool-gray-900:hover {
  --gradient-from-color: #1a202e;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(26, 32, 46, 0));
}
.hover\\:via-current:hover {
  --gradient-via-color: currentColor;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
}
.hover\\:via-transparent:hover {
  --gradient-via-color: transparent;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
}
.hover\\:via-white:hover {
  --gradient-via-color: #ffffff;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
}
.hover\\:via-black:hover {
  --gradient-via-color: #000000;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
}
.hover\\:via-gray-50:hover {
  --gradient-via-color: #f9fafb;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(249, 250, 251, 0));
}
.hover\\:via-gray-100:hover {
  --gradient-via-color: #f4f5f7;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(244, 245, 247, 0));
}
.hover\\:via-gray-200:hover {
  --gradient-via-color: #e5e7eb;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(229, 231, 235, 0));
}
.hover\\:via-gray-300:hover {
  --gradient-via-color: #d2d6dc;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(210, 214, 220, 0));
}
.hover\\:via-gray-400:hover {
  --gradient-via-color: #9fa6b2;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(159, 166, 178, 0));
}
.hover\\:via-gray-500:hover {
  --gradient-via-color: #6b7280;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(107, 114, 128, 0));
}
.hover\\:via-gray-600:hover {
  --gradient-via-color: #4b5563;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(75, 85, 99, 0));
}
.hover\\:via-gray-700:hover {
  --gradient-via-color: #374151;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(55, 65, 81, 0));
}
.hover\\:via-gray-800:hover {
  --gradient-via-color: #252f3f;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(37, 47, 63, 0));
}
.hover\\:via-gray-900:hover {
  --gradient-via-color: #161e2e;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(22, 30, 46, 0));
}
.hover\\:via-red-50:hover {
  --gradient-via-color: #fdf2f2;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 242, 242, 0));
}
.hover\\:via-red-100:hover {
  --gradient-via-color: #fde8e8;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 232, 232, 0));
}
.hover\\:via-red-200:hover {
  --gradient-via-color: #fbd5d5;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(251, 213, 213, 0));
}
.hover\\:via-red-300:hover {
  --gradient-via-color: #f8b4b4;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(248, 180, 180, 0));
}
.hover\\:via-red-400:hover {
  --gradient-via-color: #f98080;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(249, 128, 128, 0));
}
.hover\\:via-red-500:hover {
  --gradient-via-color: #f05252;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(240, 82, 82, 0));
}
.hover\\:via-red-600:hover {
  --gradient-via-color: #e02424;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(224, 36, 36, 0));
}
.hover\\:via-red-700:hover {
  --gradient-via-color: #c81e1e;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(200, 30, 30, 0));
}
.hover\\:via-red-800:hover {
  --gradient-via-color: #9b1c1c;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(155, 28, 28, 0));
}
.hover\\:via-red-900:hover {
  --gradient-via-color: #771d1d;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(119, 29, 29, 0));
}
.hover\\:via-orange-50:hover {
  --gradient-via-color: #fff8f1;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 248, 241, 0));
}
.hover\\:via-orange-100:hover {
  --gradient-via-color: #feecdc;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 236, 220, 0));
}
.hover\\:via-orange-200:hover {
  --gradient-via-color: #fcd9bd;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(252, 217, 189, 0));
}
.hover\\:via-orange-300:hover {
  --gradient-via-color: #fdba8c;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 186, 140, 0));
}
.hover\\:via-orange-400:hover {
  --gradient-via-color: #ff8a4c;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 138, 76, 0));
}
.hover\\:via-orange-500:hover {
  --gradient-via-color: #ff5a1f;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 90, 31, 0));
}
.hover\\:via-orange-600:hover {
  --gradient-via-color: #d03801;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(208, 56, 1, 0));
}
.hover\\:via-orange-700:hover {
  --gradient-via-color: #b43403;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(180, 52, 3, 0));
}
.hover\\:via-orange-800:hover {
  --gradient-via-color: #8a2c0d;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(138, 44, 13, 0));
}
.hover\\:via-orange-900:hover {
  --gradient-via-color: #73230d;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(115, 35, 13, 0));
}
.hover\\:via-yellow-50:hover {
  --gradient-via-color: #fdfdea;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 253, 234, 0));
}
.hover\\:via-yellow-100:hover {
  --gradient-via-color: #fdf6b2;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 246, 178, 0));
}
.hover\\:via-yellow-200:hover {
  --gradient-via-color: #fce96a;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(252, 233, 106, 0));
}
.hover\\:via-yellow-300:hover {
  --gradient-via-color: #faca15;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(250, 202, 21, 0));
}
.hover\\:via-yellow-400:hover {
  --gradient-via-color: #e3a008;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(227, 160, 8, 0));
}
.hover\\:via-yellow-500:hover {
  --gradient-via-color: #c27803;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(194, 120, 3, 0));
}
.hover\\:via-yellow-600:hover {
  --gradient-via-color: #9f580a;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(159, 88, 10, 0));
}
.hover\\:via-yellow-700:hover {
  --gradient-via-color: #8e4b10;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(142, 75, 16, 0));
}
.hover\\:via-yellow-800:hover {
  --gradient-via-color: #723b13;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(114, 59, 19, 0));
}
.hover\\:via-yellow-900:hover {
  --gradient-via-color: #633112;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(99, 49, 18, 0));
}
.hover\\:via-green-50:hover {
  --gradient-via-color: #f3faf7;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(243, 250, 247, 0));
}
.hover\\:via-green-100:hover {
  --gradient-via-color: #def7ec;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(222, 247, 236, 0));
}
.hover\\:via-green-200:hover {
  --gradient-via-color: #bcf0da;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(188, 240, 218, 0));
}
.hover\\:via-green-300:hover {
  --gradient-via-color: #84e1bc;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(132, 225, 188, 0));
}
.hover\\:via-green-400:hover {
  --gradient-via-color: #31c48d;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(49, 196, 141, 0));
}
.hover\\:via-green-500:hover {
  --gradient-via-color: #0e9f6e;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(14, 159, 110, 0));
}
.hover\\:via-green-600:hover {
  --gradient-via-color: #057a55;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(5, 122, 85, 0));
}
.hover\\:via-green-700:hover {
  --gradient-via-color: #046c4e;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(4, 108, 78, 0));
}
.hover\\:via-green-800:hover {
  --gradient-via-color: #03543f;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(3, 84, 63, 0));
}
.hover\\:via-green-900:hover {
  --gradient-via-color: #014737;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(1, 71, 55, 0));
}
.hover\\:via-teal-50:hover {
  --gradient-via-color: #edfafa;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(237, 250, 250, 0));
}
.hover\\:via-teal-100:hover {
  --gradient-via-color: #d5f5f6;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(213, 245, 246, 0));
}
.hover\\:via-teal-200:hover {
  --gradient-via-color: #afecef;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(175, 236, 239, 0));
}
.hover\\:via-teal-300:hover {
  --gradient-via-color: #7edce2;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(126, 220, 226, 0));
}
.hover\\:via-teal-400:hover {
  --gradient-via-color: #16bdca;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(22, 189, 202, 0));
}
.hover\\:via-teal-500:hover {
  --gradient-via-color: #0694a2;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(6, 148, 162, 0));
}
.hover\\:via-teal-600:hover {
  --gradient-via-color: #047481;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(4, 116, 129, 0));
}
.hover\\:via-teal-700:hover {
  --gradient-via-color: #036672;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(3, 102, 114, 0));
}
.hover\\:via-teal-800:hover {
  --gradient-via-color: #05505c;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(5, 80, 92, 0));
}
.hover\\:via-teal-900:hover {
  --gradient-via-color: #014451;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(1, 68, 81, 0));
}
.hover\\:via-blue-50:hover {
  --gradient-via-color: #ebf5ff;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(235, 245, 255, 0));
}
.hover\\:via-blue-100:hover {
  --gradient-via-color: #e1effe;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(225, 239, 254, 0));
}
.hover\\:via-blue-200:hover {
  --gradient-via-color: #c3ddfd;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(195, 221, 253, 0));
}
.hover\\:via-blue-300:hover {
  --gradient-via-color: #a4cafe;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(164, 202, 254, 0));
}
.hover\\:via-blue-400:hover {
  --gradient-via-color: #76a9fa;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(118, 169, 250, 0));
}
.hover\\:via-blue-500:hover {
  --gradient-via-color: #3f83f8;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(63, 131, 248, 0));
}
.hover\\:via-blue-600:hover {
  --gradient-via-color: #1c64f2;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(28, 100, 242, 0));
}
.hover\\:via-blue-700:hover {
  --gradient-via-color: #1a56db;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(26, 86, 219, 0));
}
.hover\\:via-blue-800:hover {
  --gradient-via-color: #1e429f;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(30, 66, 159, 0));
}
.hover\\:via-blue-900:hover {
  --gradient-via-color: #233876;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(35, 56, 118, 0));
}
.hover\\:via-indigo-50:hover {
  --gradient-via-color: #f0f5ff;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(240, 245, 255, 0));
}
.hover\\:via-indigo-100:hover {
  --gradient-via-color: #e5edff;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(229, 237, 255, 0));
}
.hover\\:via-indigo-200:hover {
  --gradient-via-color: #cddbfe;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(205, 219, 254, 0));
}
.hover\\:via-indigo-300:hover {
  --gradient-via-color: #b4c6fc;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(180, 198, 252, 0));
}
.hover\\:via-indigo-400:hover {
  --gradient-via-color: #8da2fb;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(141, 162, 251, 0));
}
.hover\\:via-indigo-500:hover {
  --gradient-via-color: #6875f5;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(104, 117, 245, 0));
}
.hover\\:via-indigo-600:hover {
  --gradient-via-color: #5850ec;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(88, 80, 236, 0));
}
.hover\\:via-indigo-700:hover {
  --gradient-via-color: #5145cd;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(81, 69, 205, 0));
}
.hover\\:via-indigo-800:hover {
  --gradient-via-color: #42389d;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(66, 56, 157, 0));
}
.hover\\:via-indigo-900:hover {
  --gradient-via-color: #362f78;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(54, 47, 120, 0));
}
.hover\\:via-purple-50:hover {
  --gradient-via-color: #f6f5ff;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(246, 245, 255, 0));
}
.hover\\:via-purple-100:hover {
  --gradient-via-color: #edebfe;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(237, 235, 254, 0));
}
.hover\\:via-purple-200:hover {
  --gradient-via-color: #dcd7fe;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(220, 215, 254, 0));
}
.hover\\:via-purple-300:hover {
  --gradient-via-color: #cabffd;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(202, 191, 253, 0));
}
.hover\\:via-purple-400:hover {
  --gradient-via-color: #ac94fa;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(172, 148, 250, 0));
}
.hover\\:via-purple-500:hover {
  --gradient-via-color: #9061f9;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(144, 97, 249, 0));
}
.hover\\:via-purple-600:hover {
  --gradient-via-color: #7e3af2;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(126, 58, 242, 0));
}
.hover\\:via-purple-700:hover {
  --gradient-via-color: #6c2bd9;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(108, 43, 217, 0));
}
.hover\\:via-purple-800:hover {
  --gradient-via-color: #5521b5;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(85, 33, 181, 0));
}
.hover\\:via-purple-900:hover {
  --gradient-via-color: #4a1d96;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(74, 29, 150, 0));
}
.hover\\:via-pink-50:hover {
  --gradient-via-color: #fdf2f8;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 242, 248, 0));
}
.hover\\:via-pink-100:hover {
  --gradient-via-color: #fce8f3;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(252, 232, 243, 0));
}
.hover\\:via-pink-200:hover {
  --gradient-via-color: #fad1e8;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(250, 209, 232, 0));
}
.hover\\:via-pink-300:hover {
  --gradient-via-color: #f8b4d9;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(248, 180, 217, 0));
}
.hover\\:via-pink-400:hover {
  --gradient-via-color: #f17eb8;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(241, 126, 184, 0));
}
.hover\\:via-pink-500:hover {
  --gradient-via-color: #e74694;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(231, 70, 148, 0));
}
.hover\\:via-pink-600:hover {
  --gradient-via-color: #d61f69;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(214, 31, 105, 0));
}
.hover\\:via-pink-700:hover {
  --gradient-via-color: #bf125d;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(191, 18, 93, 0));
}
.hover\\:via-pink-800:hover {
  --gradient-via-color: #99154b;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(153, 21, 75, 0));
}
.hover\\:via-pink-900:hover {
  --gradient-via-color: #751a3d;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(117, 26, 61, 0));
}
.hover\\:via-cool-gray-50:hover {
  --gradient-via-color: #f8fafc;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(248, 250, 252, 0));
}
.hover\\:via-cool-gray-100:hover {
  --gradient-via-color: #f1f5f9;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(241, 245, 249, 0));
}
.hover\\:via-cool-gray-200:hover {
  --gradient-via-color: #e2e8f0;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(226, 232, 240, 0));
}
.hover\\:via-cool-gray-300:hover {
  --gradient-via-color: #cfd8e3;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(207, 216, 227, 0));
}
.hover\\:via-cool-gray-400:hover {
  --gradient-via-color: #97a6ba;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(151, 166, 186, 0));
}
.hover\\:via-cool-gray-500:hover {
  --gradient-via-color: #64748b;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(100, 116, 139, 0));
}
.hover\\:via-cool-gray-600:hover {
  --gradient-via-color: #475569;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(71, 85, 105, 0));
}
.hover\\:via-cool-gray-700:hover {
  --gradient-via-color: #364152;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(54, 65, 82, 0));
}
.hover\\:via-cool-gray-800:hover {
  --gradient-via-color: #27303f;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(39, 48, 63, 0));
}
.hover\\:via-cool-gray-900:hover {
  --gradient-via-color: #1a202e;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(26, 32, 46, 0));
}
.hover\\:to-current:hover {
  --gradient-to-color: currentColor;
}
.hover\\:to-transparent:hover {
  --gradient-to-color: transparent;
}
.hover\\:to-white:hover {
  --gradient-to-color: #ffffff;
}
.hover\\:to-black:hover {
  --gradient-to-color: #000000;
}
.hover\\:to-gray-50:hover {
  --gradient-to-color: #f9fafb;
}
.hover\\:to-gray-100:hover {
  --gradient-to-color: #f4f5f7;
}
.hover\\:to-gray-200:hover {
  --gradient-to-color: #e5e7eb;
}
.hover\\:to-gray-300:hover {
  --gradient-to-color: #d2d6dc;
}
.hover\\:to-gray-400:hover {
  --gradient-to-color: #9fa6b2;
}
.hover\\:to-gray-500:hover {
  --gradient-to-color: #6b7280;
}
.hover\\:to-gray-600:hover {
  --gradient-to-color: #4b5563;
}
.hover\\:to-gray-700:hover {
  --gradient-to-color: #374151;
}
.hover\\:to-gray-800:hover {
  --gradient-to-color: #252f3f;
}
.hover\\:to-gray-900:hover {
  --gradient-to-color: #161e2e;
}
.hover\\:to-red-50:hover {
  --gradient-to-color: #fdf2f2;
}
.hover\\:to-red-100:hover {
  --gradient-to-color: #fde8e8;
}
.hover\\:to-red-200:hover {
  --gradient-to-color: #fbd5d5;
}
.hover\\:to-red-300:hover {
  --gradient-to-color: #f8b4b4;
}
.hover\\:to-red-400:hover {
  --gradient-to-color: #f98080;
}
.hover\\:to-red-500:hover {
  --gradient-to-color: #f05252;
}
.hover\\:to-red-600:hover {
  --gradient-to-color: #e02424;
}
.hover\\:to-red-700:hover {
  --gradient-to-color: #c81e1e;
}
.hover\\:to-red-800:hover {
  --gradient-to-color: #9b1c1c;
}
.hover\\:to-red-900:hover {
  --gradient-to-color: #771d1d;
}
.hover\\:to-orange-50:hover {
  --gradient-to-color: #fff8f1;
}
.hover\\:to-orange-100:hover {
  --gradient-to-color: #feecdc;
}
.hover\\:to-orange-200:hover {
  --gradient-to-color: #fcd9bd;
}
.hover\\:to-orange-300:hover {
  --gradient-to-color: #fdba8c;
}
.hover\\:to-orange-400:hover {
  --gradient-to-color: #ff8a4c;
}
.hover\\:to-orange-500:hover {
  --gradient-to-color: #ff5a1f;
}
.hover\\:to-orange-600:hover {
  --gradient-to-color: #d03801;
}
.hover\\:to-orange-700:hover {
  --gradient-to-color: #b43403;
}
.hover\\:to-orange-800:hover {
  --gradient-to-color: #8a2c0d;
}
.hover\\:to-orange-900:hover {
  --gradient-to-color: #73230d;
}
.hover\\:to-yellow-50:hover {
  --gradient-to-color: #fdfdea;
}
.hover\\:to-yellow-100:hover {
  --gradient-to-color: #fdf6b2;
}
.hover\\:to-yellow-200:hover {
  --gradient-to-color: #fce96a;
}
.hover\\:to-yellow-300:hover {
  --gradient-to-color: #faca15;
}
.hover\\:to-yellow-400:hover {
  --gradient-to-color: #e3a008;
}
.hover\\:to-yellow-500:hover {
  --gradient-to-color: #c27803;
}
.hover\\:to-yellow-600:hover {
  --gradient-to-color: #9f580a;
}
.hover\\:to-yellow-700:hover {
  --gradient-to-color: #8e4b10;
}
.hover\\:to-yellow-800:hover {
  --gradient-to-color: #723b13;
}
.hover\\:to-yellow-900:hover {
  --gradient-to-color: #633112;
}
.hover\\:to-green-50:hover {
  --gradient-to-color: #f3faf7;
}
.hover\\:to-green-100:hover {
  --gradient-to-color: #def7ec;
}
.hover\\:to-green-200:hover {
  --gradient-to-color: #bcf0da;
}
.hover\\:to-green-300:hover {
  --gradient-to-color: #84e1bc;
}
.hover\\:to-green-400:hover {
  --gradient-to-color: #31c48d;
}
.hover\\:to-green-500:hover {
  --gradient-to-color: #0e9f6e;
}
.hover\\:to-green-600:hover {
  --gradient-to-color: #057a55;
}
.hover\\:to-green-700:hover {
  --gradient-to-color: #046c4e;
}
.hover\\:to-green-800:hover {
  --gradient-to-color: #03543f;
}
.hover\\:to-green-900:hover {
  --gradient-to-color: #014737;
}
.hover\\:to-teal-50:hover {
  --gradient-to-color: #edfafa;
}
.hover\\:to-teal-100:hover {
  --gradient-to-color: #d5f5f6;
}
.hover\\:to-teal-200:hover {
  --gradient-to-color: #afecef;
}
.hover\\:to-teal-300:hover {
  --gradient-to-color: #7edce2;
}
.hover\\:to-teal-400:hover {
  --gradient-to-color: #16bdca;
}
.hover\\:to-teal-500:hover {
  --gradient-to-color: #0694a2;
}
.hover\\:to-teal-600:hover {
  --gradient-to-color: #047481;
}
.hover\\:to-teal-700:hover {
  --gradient-to-color: #036672;
}
.hover\\:to-teal-800:hover {
  --gradient-to-color: #05505c;
}
.hover\\:to-teal-900:hover {
  --gradient-to-color: #014451;
}
.hover\\:to-blue-50:hover {
  --gradient-to-color: #ebf5ff;
}
.hover\\:to-blue-100:hover {
  --gradient-to-color: #e1effe;
}
.hover\\:to-blue-200:hover {
  --gradient-to-color: #c3ddfd;
}
.hover\\:to-blue-300:hover {
  --gradient-to-color: #a4cafe;
}
.hover\\:to-blue-400:hover {
  --gradient-to-color: #76a9fa;
}
.hover\\:to-blue-500:hover {
  --gradient-to-color: #3f83f8;
}
.hover\\:to-blue-600:hover {
  --gradient-to-color: #1c64f2;
}
.hover\\:to-blue-700:hover {
  --gradient-to-color: #1a56db;
}
.hover\\:to-blue-800:hover {
  --gradient-to-color: #1e429f;
}
.hover\\:to-blue-900:hover {
  --gradient-to-color: #233876;
}
.hover\\:to-indigo-50:hover {
  --gradient-to-color: #f0f5ff;
}
.hover\\:to-indigo-100:hover {
  --gradient-to-color: #e5edff;
}
.hover\\:to-indigo-200:hover {
  --gradient-to-color: #cddbfe;
}
.hover\\:to-indigo-300:hover {
  --gradient-to-color: #b4c6fc;
}
.hover\\:to-indigo-400:hover {
  --gradient-to-color: #8da2fb;
}
.hover\\:to-indigo-500:hover {
  --gradient-to-color: #6875f5;
}
.hover\\:to-indigo-600:hover {
  --gradient-to-color: #5850ec;
}
.hover\\:to-indigo-700:hover {
  --gradient-to-color: #5145cd;
}
.hover\\:to-indigo-800:hover {
  --gradient-to-color: #42389d;
}
.hover\\:to-indigo-900:hover {
  --gradient-to-color: #362f78;
}
.hover\\:to-purple-50:hover {
  --gradient-to-color: #f6f5ff;
}
.hover\\:to-purple-100:hover {
  --gradient-to-color: #edebfe;
}
.hover\\:to-purple-200:hover {
  --gradient-to-color: #dcd7fe;
}
.hover\\:to-purple-300:hover {
  --gradient-to-color: #cabffd;
}
.hover\\:to-purple-400:hover {
  --gradient-to-color: #ac94fa;
}
.hover\\:to-purple-500:hover {
  --gradient-to-color: #9061f9;
}
.hover\\:to-purple-600:hover {
  --gradient-to-color: #7e3af2;
}
.hover\\:to-purple-700:hover {
  --gradient-to-color: #6c2bd9;
}
.hover\\:to-purple-800:hover {
  --gradient-to-color: #5521b5;
}
.hover\\:to-purple-900:hover {
  --gradient-to-color: #4a1d96;
}
.hover\\:to-pink-50:hover {
  --gradient-to-color: #fdf2f8;
}
.hover\\:to-pink-100:hover {
  --gradient-to-color: #fce8f3;
}
.hover\\:to-pink-200:hover {
  --gradient-to-color: #fad1e8;
}
.hover\\:to-pink-300:hover {
  --gradient-to-color: #f8b4d9;
}
.hover\\:to-pink-400:hover {
  --gradient-to-color: #f17eb8;
}
.hover\\:to-pink-500:hover {
  --gradient-to-color: #e74694;
}
.hover\\:to-pink-600:hover {
  --gradient-to-color: #d61f69;
}
.hover\\:to-pink-700:hover {
  --gradient-to-color: #bf125d;
}
.hover\\:to-pink-800:hover {
  --gradient-to-color: #99154b;
}
.hover\\:to-pink-900:hover {
  --gradient-to-color: #751a3d;
}
.hover\\:to-cool-gray-50:hover {
  --gradient-to-color: #f8fafc;
}
.hover\\:to-cool-gray-100:hover {
  --gradient-to-color: #f1f5f9;
}
.hover\\:to-cool-gray-200:hover {
  --gradient-to-color: #e2e8f0;
}
.hover\\:to-cool-gray-300:hover {
  --gradient-to-color: #cfd8e3;
}
.hover\\:to-cool-gray-400:hover {
  --gradient-to-color: #97a6ba;
}
.hover\\:to-cool-gray-500:hover {
  --gradient-to-color: #64748b;
}
.hover\\:to-cool-gray-600:hover {
  --gradient-to-color: #475569;
}
.hover\\:to-cool-gray-700:hover {
  --gradient-to-color: #364152;
}
.hover\\:to-cool-gray-800:hover {
  --gradient-to-color: #27303f;
}
.hover\\:to-cool-gray-900:hover {
  --gradient-to-color: #1a202e;
}
.focus\\:from-current:focus {
  --gradient-from-color: currentColor;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
}
.focus\\:from-transparent:focus {
  --gradient-from-color: transparent;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
}
.focus\\:from-white:focus {
  --gradient-from-color: #ffffff;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
}
.focus\\:from-black:focus {
  --gradient-from-color: #000000;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
}
.focus\\:from-gray-50:focus {
  --gradient-from-color: #f9fafb;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(249, 250, 251, 0));
}
.focus\\:from-gray-100:focus {
  --gradient-from-color: #f4f5f7;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(244, 245, 247, 0));
}
.focus\\:from-gray-200:focus {
  --gradient-from-color: #e5e7eb;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(229, 231, 235, 0));
}
.focus\\:from-gray-300:focus {
  --gradient-from-color: #d2d6dc;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(210, 214, 220, 0));
}
.focus\\:from-gray-400:focus {
  --gradient-from-color: #9fa6b2;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(159, 166, 178, 0));
}
.focus\\:from-gray-500:focus {
  --gradient-from-color: #6b7280;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(107, 114, 128, 0));
}
.focus\\:from-gray-600:focus {
  --gradient-from-color: #4b5563;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(75, 85, 99, 0));
}
.focus\\:from-gray-700:focus {
  --gradient-from-color: #374151;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(55, 65, 81, 0));
}
.focus\\:from-gray-800:focus {
  --gradient-from-color: #252f3f;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(37, 47, 63, 0));
}
.focus\\:from-gray-900:focus {
  --gradient-from-color: #161e2e;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(22, 30, 46, 0));
}
.focus\\:from-red-50:focus {
  --gradient-from-color: #fdf2f2;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 242, 242, 0));
}
.focus\\:from-red-100:focus {
  --gradient-from-color: #fde8e8;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 232, 232, 0));
}
.focus\\:from-red-200:focus {
  --gradient-from-color: #fbd5d5;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(251, 213, 213, 0));
}
.focus\\:from-red-300:focus {
  --gradient-from-color: #f8b4b4;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(248, 180, 180, 0));
}
.focus\\:from-red-400:focus {
  --gradient-from-color: #f98080;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(249, 128, 128, 0));
}
.focus\\:from-red-500:focus {
  --gradient-from-color: #f05252;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(240, 82, 82, 0));
}
.focus\\:from-red-600:focus {
  --gradient-from-color: #e02424;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(224, 36, 36, 0));
}
.focus\\:from-red-700:focus {
  --gradient-from-color: #c81e1e;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(200, 30, 30, 0));
}
.focus\\:from-red-800:focus {
  --gradient-from-color: #9b1c1c;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(155, 28, 28, 0));
}
.focus\\:from-red-900:focus {
  --gradient-from-color: #771d1d;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(119, 29, 29, 0));
}
.focus\\:from-orange-50:focus {
  --gradient-from-color: #fff8f1;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 248, 241, 0));
}
.focus\\:from-orange-100:focus {
  --gradient-from-color: #feecdc;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 236, 220, 0));
}
.focus\\:from-orange-200:focus {
  --gradient-from-color: #fcd9bd;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(252, 217, 189, 0));
}
.focus\\:from-orange-300:focus {
  --gradient-from-color: #fdba8c;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 186, 140, 0));
}
.focus\\:from-orange-400:focus {
  --gradient-from-color: #ff8a4c;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 138, 76, 0));
}
.focus\\:from-orange-500:focus {
  --gradient-from-color: #ff5a1f;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 90, 31, 0));
}
.focus\\:from-orange-600:focus {
  --gradient-from-color: #d03801;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(208, 56, 1, 0));
}
.focus\\:from-orange-700:focus {
  --gradient-from-color: #b43403;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(180, 52, 3, 0));
}
.focus\\:from-orange-800:focus {
  --gradient-from-color: #8a2c0d;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(138, 44, 13, 0));
}
.focus\\:from-orange-900:focus {
  --gradient-from-color: #73230d;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(115, 35, 13, 0));
}
.focus\\:from-yellow-50:focus {
  --gradient-from-color: #fdfdea;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 253, 234, 0));
}
.focus\\:from-yellow-100:focus {
  --gradient-from-color: #fdf6b2;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 246, 178, 0));
}
.focus\\:from-yellow-200:focus {
  --gradient-from-color: #fce96a;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(252, 233, 106, 0));
}
.focus\\:from-yellow-300:focus {
  --gradient-from-color: #faca15;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(250, 202, 21, 0));
}
.focus\\:from-yellow-400:focus {
  --gradient-from-color: #e3a008;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(227, 160, 8, 0));
}
.focus\\:from-yellow-500:focus {
  --gradient-from-color: #c27803;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(194, 120, 3, 0));
}
.focus\\:from-yellow-600:focus {
  --gradient-from-color: #9f580a;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(159, 88, 10, 0));
}
.focus\\:from-yellow-700:focus {
  --gradient-from-color: #8e4b10;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(142, 75, 16, 0));
}
.focus\\:from-yellow-800:focus {
  --gradient-from-color: #723b13;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(114, 59, 19, 0));
}
.focus\\:from-yellow-900:focus {
  --gradient-from-color: #633112;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(99, 49, 18, 0));
}
.focus\\:from-green-50:focus {
  --gradient-from-color: #f3faf7;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(243, 250, 247, 0));
}
.focus\\:from-green-100:focus {
  --gradient-from-color: #def7ec;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(222, 247, 236, 0));
}
.focus\\:from-green-200:focus {
  --gradient-from-color: #bcf0da;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(188, 240, 218, 0));
}
.focus\\:from-green-300:focus {
  --gradient-from-color: #84e1bc;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(132, 225, 188, 0));
}
.focus\\:from-green-400:focus {
  --gradient-from-color: #31c48d;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(49, 196, 141, 0));
}
.focus\\:from-green-500:focus {
  --gradient-from-color: #0e9f6e;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(14, 159, 110, 0));
}
.focus\\:from-green-600:focus {
  --gradient-from-color: #057a55;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(5, 122, 85, 0));
}
.focus\\:from-green-700:focus {
  --gradient-from-color: #046c4e;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(4, 108, 78, 0));
}
.focus\\:from-green-800:focus {
  --gradient-from-color: #03543f;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(3, 84, 63, 0));
}
.focus\\:from-green-900:focus {
  --gradient-from-color: #014737;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(1, 71, 55, 0));
}
.focus\\:from-teal-50:focus {
  --gradient-from-color: #edfafa;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(237, 250, 250, 0));
}
.focus\\:from-teal-100:focus {
  --gradient-from-color: #d5f5f6;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(213, 245, 246, 0));
}
.focus\\:from-teal-200:focus {
  --gradient-from-color: #afecef;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(175, 236, 239, 0));
}
.focus\\:from-teal-300:focus {
  --gradient-from-color: #7edce2;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(126, 220, 226, 0));
}
.focus\\:from-teal-400:focus {
  --gradient-from-color: #16bdca;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(22, 189, 202, 0));
}
.focus\\:from-teal-500:focus {
  --gradient-from-color: #0694a2;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(6, 148, 162, 0));
}
.focus\\:from-teal-600:focus {
  --gradient-from-color: #047481;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(4, 116, 129, 0));
}
.focus\\:from-teal-700:focus {
  --gradient-from-color: #036672;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(3, 102, 114, 0));
}
.focus\\:from-teal-800:focus {
  --gradient-from-color: #05505c;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(5, 80, 92, 0));
}
.focus\\:from-teal-900:focus {
  --gradient-from-color: #014451;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(1, 68, 81, 0));
}
.focus\\:from-blue-50:focus {
  --gradient-from-color: #ebf5ff;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(235, 245, 255, 0));
}
.focus\\:from-blue-100:focus {
  --gradient-from-color: #e1effe;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(225, 239, 254, 0));
}
.focus\\:from-blue-200:focus {
  --gradient-from-color: #c3ddfd;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(195, 221, 253, 0));
}
.focus\\:from-blue-300:focus {
  --gradient-from-color: #a4cafe;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(164, 202, 254, 0));
}
.focus\\:from-blue-400:focus {
  --gradient-from-color: #76a9fa;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(118, 169, 250, 0));
}
.focus\\:from-blue-500:focus {
  --gradient-from-color: #3f83f8;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(63, 131, 248, 0));
}
.focus\\:from-blue-600:focus {
  --gradient-from-color: #1c64f2;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(28, 100, 242, 0));
}
.focus\\:from-blue-700:focus {
  --gradient-from-color: #1a56db;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(26, 86, 219, 0));
}
.focus\\:from-blue-800:focus {
  --gradient-from-color: #1e429f;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(30, 66, 159, 0));
}
.focus\\:from-blue-900:focus {
  --gradient-from-color: #233876;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(35, 56, 118, 0));
}
.focus\\:from-indigo-50:focus {
  --gradient-from-color: #f0f5ff;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(240, 245, 255, 0));
}
.focus\\:from-indigo-100:focus {
  --gradient-from-color: #e5edff;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(229, 237, 255, 0));
}
.focus\\:from-indigo-200:focus {
  --gradient-from-color: #cddbfe;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(205, 219, 254, 0));
}
.focus\\:from-indigo-300:focus {
  --gradient-from-color: #b4c6fc;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(180, 198, 252, 0));
}
.focus\\:from-indigo-400:focus {
  --gradient-from-color: #8da2fb;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(141, 162, 251, 0));
}
.focus\\:from-indigo-500:focus {
  --gradient-from-color: #6875f5;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(104, 117, 245, 0));
}
.focus\\:from-indigo-600:focus {
  --gradient-from-color: #5850ec;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(88, 80, 236, 0));
}
.focus\\:from-indigo-700:focus {
  --gradient-from-color: #5145cd;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(81, 69, 205, 0));
}
.focus\\:from-indigo-800:focus {
  --gradient-from-color: #42389d;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(66, 56, 157, 0));
}
.focus\\:from-indigo-900:focus {
  --gradient-from-color: #362f78;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(54, 47, 120, 0));
}
.focus\\:from-purple-50:focus {
  --gradient-from-color: #f6f5ff;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(246, 245, 255, 0));
}
.focus\\:from-purple-100:focus {
  --gradient-from-color: #edebfe;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(237, 235, 254, 0));
}
.focus\\:from-purple-200:focus {
  --gradient-from-color: #dcd7fe;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(220, 215, 254, 0));
}
.focus\\:from-purple-300:focus {
  --gradient-from-color: #cabffd;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(202, 191, 253, 0));
}
.focus\\:from-purple-400:focus {
  --gradient-from-color: #ac94fa;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(172, 148, 250, 0));
}
.focus\\:from-purple-500:focus {
  --gradient-from-color: #9061f9;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(144, 97, 249, 0));
}
.focus\\:from-purple-600:focus {
  --gradient-from-color: #7e3af2;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(126, 58, 242, 0));
}
.focus\\:from-purple-700:focus {
  --gradient-from-color: #6c2bd9;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(108, 43, 217, 0));
}
.focus\\:from-purple-800:focus {
  --gradient-from-color: #5521b5;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(85, 33, 181, 0));
}
.focus\\:from-purple-900:focus {
  --gradient-from-color: #4a1d96;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(74, 29, 150, 0));
}
.focus\\:from-pink-50:focus {
  --gradient-from-color: #fdf2f8;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 242, 248, 0));
}
.focus\\:from-pink-100:focus {
  --gradient-from-color: #fce8f3;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(252, 232, 243, 0));
}
.focus\\:from-pink-200:focus {
  --gradient-from-color: #fad1e8;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(250, 209, 232, 0));
}
.focus\\:from-pink-300:focus {
  --gradient-from-color: #f8b4d9;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(248, 180, 217, 0));
}
.focus\\:from-pink-400:focus {
  --gradient-from-color: #f17eb8;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(241, 126, 184, 0));
}
.focus\\:from-pink-500:focus {
  --gradient-from-color: #e74694;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(231, 70, 148, 0));
}
.focus\\:from-pink-600:focus {
  --gradient-from-color: #d61f69;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(214, 31, 105, 0));
}
.focus\\:from-pink-700:focus {
  --gradient-from-color: #bf125d;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(191, 18, 93, 0));
}
.focus\\:from-pink-800:focus {
  --gradient-from-color: #99154b;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(153, 21, 75, 0));
}
.focus\\:from-pink-900:focus {
  --gradient-from-color: #751a3d;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(117, 26, 61, 0));
}
.focus\\:from-cool-gray-50:focus {
  --gradient-from-color: #f8fafc;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(248, 250, 252, 0));
}
.focus\\:from-cool-gray-100:focus {
  --gradient-from-color: #f1f5f9;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(241, 245, 249, 0));
}
.focus\\:from-cool-gray-200:focus {
  --gradient-from-color: #e2e8f0;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(226, 232, 240, 0));
}
.focus\\:from-cool-gray-300:focus {
  --gradient-from-color: #cfd8e3;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(207, 216, 227, 0));
}
.focus\\:from-cool-gray-400:focus {
  --gradient-from-color: #97a6ba;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(151, 166, 186, 0));
}
.focus\\:from-cool-gray-500:focus {
  --gradient-from-color: #64748b;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(100, 116, 139, 0));
}
.focus\\:from-cool-gray-600:focus {
  --gradient-from-color: #475569;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(71, 85, 105, 0));
}
.focus\\:from-cool-gray-700:focus {
  --gradient-from-color: #364152;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(54, 65, 82, 0));
}
.focus\\:from-cool-gray-800:focus {
  --gradient-from-color: #27303f;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(39, 48, 63, 0));
}
.focus\\:from-cool-gray-900:focus {
  --gradient-from-color: #1a202e;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(26, 32, 46, 0));
}
.focus\\:via-current:focus {
  --gradient-via-color: currentColor;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
}
.focus\\:via-transparent:focus {
  --gradient-via-color: transparent;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
}
.focus\\:via-white:focus {
  --gradient-via-color: #ffffff;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
}
.focus\\:via-black:focus {
  --gradient-via-color: #000000;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
}
.focus\\:via-gray-50:focus {
  --gradient-via-color: #f9fafb;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(249, 250, 251, 0));
}
.focus\\:via-gray-100:focus {
  --gradient-via-color: #f4f5f7;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(244, 245, 247, 0));
}
.focus\\:via-gray-200:focus {
  --gradient-via-color: #e5e7eb;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(229, 231, 235, 0));
}
.focus\\:via-gray-300:focus {
  --gradient-via-color: #d2d6dc;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(210, 214, 220, 0));
}
.focus\\:via-gray-400:focus {
  --gradient-via-color: #9fa6b2;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(159, 166, 178, 0));
}
.focus\\:via-gray-500:focus {
  --gradient-via-color: #6b7280;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(107, 114, 128, 0));
}
.focus\\:via-gray-600:focus {
  --gradient-via-color: #4b5563;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(75, 85, 99, 0));
}
.focus\\:via-gray-700:focus {
  --gradient-via-color: #374151;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(55, 65, 81, 0));
}
.focus\\:via-gray-800:focus {
  --gradient-via-color: #252f3f;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(37, 47, 63, 0));
}
.focus\\:via-gray-900:focus {
  --gradient-via-color: #161e2e;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(22, 30, 46, 0));
}
.focus\\:via-red-50:focus {
  --gradient-via-color: #fdf2f2;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 242, 242, 0));
}
.focus\\:via-red-100:focus {
  --gradient-via-color: #fde8e8;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 232, 232, 0));
}
.focus\\:via-red-200:focus {
  --gradient-via-color: #fbd5d5;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(251, 213, 213, 0));
}
.focus\\:via-red-300:focus {
  --gradient-via-color: #f8b4b4;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(248, 180, 180, 0));
}
.focus\\:via-red-400:focus {
  --gradient-via-color: #f98080;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(249, 128, 128, 0));
}
.focus\\:via-red-500:focus {
  --gradient-via-color: #f05252;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(240, 82, 82, 0));
}
.focus\\:via-red-600:focus {
  --gradient-via-color: #e02424;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(224, 36, 36, 0));
}
.focus\\:via-red-700:focus {
  --gradient-via-color: #c81e1e;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(200, 30, 30, 0));
}
.focus\\:via-red-800:focus {
  --gradient-via-color: #9b1c1c;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(155, 28, 28, 0));
}
.focus\\:via-red-900:focus {
  --gradient-via-color: #771d1d;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(119, 29, 29, 0));
}
.focus\\:via-orange-50:focus {
  --gradient-via-color: #fff8f1;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 248, 241, 0));
}
.focus\\:via-orange-100:focus {
  --gradient-via-color: #feecdc;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 236, 220, 0));
}
.focus\\:via-orange-200:focus {
  --gradient-via-color: #fcd9bd;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(252, 217, 189, 0));
}
.focus\\:via-orange-300:focus {
  --gradient-via-color: #fdba8c;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 186, 140, 0));
}
.focus\\:via-orange-400:focus {
  --gradient-via-color: #ff8a4c;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 138, 76, 0));
}
.focus\\:via-orange-500:focus {
  --gradient-via-color: #ff5a1f;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 90, 31, 0));
}
.focus\\:via-orange-600:focus {
  --gradient-via-color: #d03801;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(208, 56, 1, 0));
}
.focus\\:via-orange-700:focus {
  --gradient-via-color: #b43403;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(180, 52, 3, 0));
}
.focus\\:via-orange-800:focus {
  --gradient-via-color: #8a2c0d;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(138, 44, 13, 0));
}
.focus\\:via-orange-900:focus {
  --gradient-via-color: #73230d;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(115, 35, 13, 0));
}
.focus\\:via-yellow-50:focus {
  --gradient-via-color: #fdfdea;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 253, 234, 0));
}
.focus\\:via-yellow-100:focus {
  --gradient-via-color: #fdf6b2;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 246, 178, 0));
}
.focus\\:via-yellow-200:focus {
  --gradient-via-color: #fce96a;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(252, 233, 106, 0));
}
.focus\\:via-yellow-300:focus {
  --gradient-via-color: #faca15;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(250, 202, 21, 0));
}
.focus\\:via-yellow-400:focus {
  --gradient-via-color: #e3a008;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(227, 160, 8, 0));
}
.focus\\:via-yellow-500:focus {
  --gradient-via-color: #c27803;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(194, 120, 3, 0));
}
.focus\\:via-yellow-600:focus {
  --gradient-via-color: #9f580a;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(159, 88, 10, 0));
}
.focus\\:via-yellow-700:focus {
  --gradient-via-color: #8e4b10;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(142, 75, 16, 0));
}
.focus\\:via-yellow-800:focus {
  --gradient-via-color: #723b13;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(114, 59, 19, 0));
}
.focus\\:via-yellow-900:focus {
  --gradient-via-color: #633112;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(99, 49, 18, 0));
}
.focus\\:via-green-50:focus {
  --gradient-via-color: #f3faf7;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(243, 250, 247, 0));
}
.focus\\:via-green-100:focus {
  --gradient-via-color: #def7ec;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(222, 247, 236, 0));
}
.focus\\:via-green-200:focus {
  --gradient-via-color: #bcf0da;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(188, 240, 218, 0));
}
.focus\\:via-green-300:focus {
  --gradient-via-color: #84e1bc;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(132, 225, 188, 0));
}
.focus\\:via-green-400:focus {
  --gradient-via-color: #31c48d;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(49, 196, 141, 0));
}
.focus\\:via-green-500:focus {
  --gradient-via-color: #0e9f6e;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(14, 159, 110, 0));
}
.focus\\:via-green-600:focus {
  --gradient-via-color: #057a55;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(5, 122, 85, 0));
}
.focus\\:via-green-700:focus {
  --gradient-via-color: #046c4e;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(4, 108, 78, 0));
}
.focus\\:via-green-800:focus {
  --gradient-via-color: #03543f;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(3, 84, 63, 0));
}
.focus\\:via-green-900:focus {
  --gradient-via-color: #014737;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(1, 71, 55, 0));
}
.focus\\:via-teal-50:focus {
  --gradient-via-color: #edfafa;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(237, 250, 250, 0));
}
.focus\\:via-teal-100:focus {
  --gradient-via-color: #d5f5f6;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(213, 245, 246, 0));
}
.focus\\:via-teal-200:focus {
  --gradient-via-color: #afecef;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(175, 236, 239, 0));
}
.focus\\:via-teal-300:focus {
  --gradient-via-color: #7edce2;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(126, 220, 226, 0));
}
.focus\\:via-teal-400:focus {
  --gradient-via-color: #16bdca;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(22, 189, 202, 0));
}
.focus\\:via-teal-500:focus {
  --gradient-via-color: #0694a2;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(6, 148, 162, 0));
}
.focus\\:via-teal-600:focus {
  --gradient-via-color: #047481;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(4, 116, 129, 0));
}
.focus\\:via-teal-700:focus {
  --gradient-via-color: #036672;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(3, 102, 114, 0));
}
.focus\\:via-teal-800:focus {
  --gradient-via-color: #05505c;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(5, 80, 92, 0));
}
.focus\\:via-teal-900:focus {
  --gradient-via-color: #014451;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(1, 68, 81, 0));
}
.focus\\:via-blue-50:focus {
  --gradient-via-color: #ebf5ff;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(235, 245, 255, 0));
}
.focus\\:via-blue-100:focus {
  --gradient-via-color: #e1effe;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(225, 239, 254, 0));
}
.focus\\:via-blue-200:focus {
  --gradient-via-color: #c3ddfd;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(195, 221, 253, 0));
}
.focus\\:via-blue-300:focus {
  --gradient-via-color: #a4cafe;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(164, 202, 254, 0));
}
.focus\\:via-blue-400:focus {
  --gradient-via-color: #76a9fa;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(118, 169, 250, 0));
}
.focus\\:via-blue-500:focus {
  --gradient-via-color: #3f83f8;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(63, 131, 248, 0));
}
.focus\\:via-blue-600:focus {
  --gradient-via-color: #1c64f2;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(28, 100, 242, 0));
}
.focus\\:via-blue-700:focus {
  --gradient-via-color: #1a56db;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(26, 86, 219, 0));
}
.focus\\:via-blue-800:focus {
  --gradient-via-color: #1e429f;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(30, 66, 159, 0));
}
.focus\\:via-blue-900:focus {
  --gradient-via-color: #233876;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(35, 56, 118, 0));
}
.focus\\:via-indigo-50:focus {
  --gradient-via-color: #f0f5ff;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(240, 245, 255, 0));
}
.focus\\:via-indigo-100:focus {
  --gradient-via-color: #e5edff;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(229, 237, 255, 0));
}
.focus\\:via-indigo-200:focus {
  --gradient-via-color: #cddbfe;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(205, 219, 254, 0));
}
.focus\\:via-indigo-300:focus {
  --gradient-via-color: #b4c6fc;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(180, 198, 252, 0));
}
.focus\\:via-indigo-400:focus {
  --gradient-via-color: #8da2fb;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(141, 162, 251, 0));
}
.focus\\:via-indigo-500:focus {
  --gradient-via-color: #6875f5;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(104, 117, 245, 0));
}
.focus\\:via-indigo-600:focus {
  --gradient-via-color: #5850ec;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(88, 80, 236, 0));
}
.focus\\:via-indigo-700:focus {
  --gradient-via-color: #5145cd;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(81, 69, 205, 0));
}
.focus\\:via-indigo-800:focus {
  --gradient-via-color: #42389d;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(66, 56, 157, 0));
}
.focus\\:via-indigo-900:focus {
  --gradient-via-color: #362f78;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(54, 47, 120, 0));
}
.focus\\:via-purple-50:focus {
  --gradient-via-color: #f6f5ff;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(246, 245, 255, 0));
}
.focus\\:via-purple-100:focus {
  --gradient-via-color: #edebfe;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(237, 235, 254, 0));
}
.focus\\:via-purple-200:focus {
  --gradient-via-color: #dcd7fe;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(220, 215, 254, 0));
}
.focus\\:via-purple-300:focus {
  --gradient-via-color: #cabffd;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(202, 191, 253, 0));
}
.focus\\:via-purple-400:focus {
  --gradient-via-color: #ac94fa;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(172, 148, 250, 0));
}
.focus\\:via-purple-500:focus {
  --gradient-via-color: #9061f9;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(144, 97, 249, 0));
}
.focus\\:via-purple-600:focus {
  --gradient-via-color: #7e3af2;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(126, 58, 242, 0));
}
.focus\\:via-purple-700:focus {
  --gradient-via-color: #6c2bd9;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(108, 43, 217, 0));
}
.focus\\:via-purple-800:focus {
  --gradient-via-color: #5521b5;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(85, 33, 181, 0));
}
.focus\\:via-purple-900:focus {
  --gradient-via-color: #4a1d96;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(74, 29, 150, 0));
}
.focus\\:via-pink-50:focus {
  --gradient-via-color: #fdf2f8;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 242, 248, 0));
}
.focus\\:via-pink-100:focus {
  --gradient-via-color: #fce8f3;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(252, 232, 243, 0));
}
.focus\\:via-pink-200:focus {
  --gradient-via-color: #fad1e8;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(250, 209, 232, 0));
}
.focus\\:via-pink-300:focus {
  --gradient-via-color: #f8b4d9;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(248, 180, 217, 0));
}
.focus\\:via-pink-400:focus {
  --gradient-via-color: #f17eb8;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(241, 126, 184, 0));
}
.focus\\:via-pink-500:focus {
  --gradient-via-color: #e74694;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(231, 70, 148, 0));
}
.focus\\:via-pink-600:focus {
  --gradient-via-color: #d61f69;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(214, 31, 105, 0));
}
.focus\\:via-pink-700:focus {
  --gradient-via-color: #bf125d;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(191, 18, 93, 0));
}
.focus\\:via-pink-800:focus {
  --gradient-via-color: #99154b;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(153, 21, 75, 0));
}
.focus\\:via-pink-900:focus {
  --gradient-via-color: #751a3d;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(117, 26, 61, 0));
}
.focus\\:via-cool-gray-50:focus {
  --gradient-via-color: #f8fafc;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(248, 250, 252, 0));
}
.focus\\:via-cool-gray-100:focus {
  --gradient-via-color: #f1f5f9;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(241, 245, 249, 0));
}
.focus\\:via-cool-gray-200:focus {
  --gradient-via-color: #e2e8f0;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(226, 232, 240, 0));
}
.focus\\:via-cool-gray-300:focus {
  --gradient-via-color: #cfd8e3;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(207, 216, 227, 0));
}
.focus\\:via-cool-gray-400:focus {
  --gradient-via-color: #97a6ba;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(151, 166, 186, 0));
}
.focus\\:via-cool-gray-500:focus {
  --gradient-via-color: #64748b;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(100, 116, 139, 0));
}
.focus\\:via-cool-gray-600:focus {
  --gradient-via-color: #475569;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(71, 85, 105, 0));
}
.focus\\:via-cool-gray-700:focus {
  --gradient-via-color: #364152;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(54, 65, 82, 0));
}
.focus\\:via-cool-gray-800:focus {
  --gradient-via-color: #27303f;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(39, 48, 63, 0));
}
.focus\\:via-cool-gray-900:focus {
  --gradient-via-color: #1a202e;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(26, 32, 46, 0));
}
.focus\\:to-current:focus {
  --gradient-to-color: currentColor;
}
.focus\\:to-transparent:focus {
  --gradient-to-color: transparent;
}
.focus\\:to-white:focus {
  --gradient-to-color: #ffffff;
}
.focus\\:to-black:focus {
  --gradient-to-color: #000000;
}
.focus\\:to-gray-50:focus {
  --gradient-to-color: #f9fafb;
}
.focus\\:to-gray-100:focus {
  --gradient-to-color: #f4f5f7;
}
.focus\\:to-gray-200:focus {
  --gradient-to-color: #e5e7eb;
}
.focus\\:to-gray-300:focus {
  --gradient-to-color: #d2d6dc;
}
.focus\\:to-gray-400:focus {
  --gradient-to-color: #9fa6b2;
}
.focus\\:to-gray-500:focus {
  --gradient-to-color: #6b7280;
}
.focus\\:to-gray-600:focus {
  --gradient-to-color: #4b5563;
}
.focus\\:to-gray-700:focus {
  --gradient-to-color: #374151;
}
.focus\\:to-gray-800:focus {
  --gradient-to-color: #252f3f;
}
.focus\\:to-gray-900:focus {
  --gradient-to-color: #161e2e;
}
.focus\\:to-red-50:focus {
  --gradient-to-color: #fdf2f2;
}
.focus\\:to-red-100:focus {
  --gradient-to-color: #fde8e8;
}
.focus\\:to-red-200:focus {
  --gradient-to-color: #fbd5d5;
}
.focus\\:to-red-300:focus {
  --gradient-to-color: #f8b4b4;
}
.focus\\:to-red-400:focus {
  --gradient-to-color: #f98080;
}
.focus\\:to-red-500:focus {
  --gradient-to-color: #f05252;
}
.focus\\:to-red-600:focus {
  --gradient-to-color: #e02424;
}
.focus\\:to-red-700:focus {
  --gradient-to-color: #c81e1e;
}
.focus\\:to-red-800:focus {
  --gradient-to-color: #9b1c1c;
}
.focus\\:to-red-900:focus {
  --gradient-to-color: #771d1d;
}
.focus\\:to-orange-50:focus {
  --gradient-to-color: #fff8f1;
}
.focus\\:to-orange-100:focus {
  --gradient-to-color: #feecdc;
}
.focus\\:to-orange-200:focus {
  --gradient-to-color: #fcd9bd;
}
.focus\\:to-orange-300:focus {
  --gradient-to-color: #fdba8c;
}
.focus\\:to-orange-400:focus {
  --gradient-to-color: #ff8a4c;
}
.focus\\:to-orange-500:focus {
  --gradient-to-color: #ff5a1f;
}
.focus\\:to-orange-600:focus {
  --gradient-to-color: #d03801;
}
.focus\\:to-orange-700:focus {
  --gradient-to-color: #b43403;
}
.focus\\:to-orange-800:focus {
  --gradient-to-color: #8a2c0d;
}
.focus\\:to-orange-900:focus {
  --gradient-to-color: #73230d;
}
.focus\\:to-yellow-50:focus {
  --gradient-to-color: #fdfdea;
}
.focus\\:to-yellow-100:focus {
  --gradient-to-color: #fdf6b2;
}
.focus\\:to-yellow-200:focus {
  --gradient-to-color: #fce96a;
}
.focus\\:to-yellow-300:focus {
  --gradient-to-color: #faca15;
}
.focus\\:to-yellow-400:focus {
  --gradient-to-color: #e3a008;
}
.focus\\:to-yellow-500:focus {
  --gradient-to-color: #c27803;
}
.focus\\:to-yellow-600:focus {
  --gradient-to-color: #9f580a;
}
.focus\\:to-yellow-700:focus {
  --gradient-to-color: #8e4b10;
}
.focus\\:to-yellow-800:focus {
  --gradient-to-color: #723b13;
}
.focus\\:to-yellow-900:focus {
  --gradient-to-color: #633112;
}
.focus\\:to-green-50:focus {
  --gradient-to-color: #f3faf7;
}
.focus\\:to-green-100:focus {
  --gradient-to-color: #def7ec;
}
.focus\\:to-green-200:focus {
  --gradient-to-color: #bcf0da;
}
.focus\\:to-green-300:focus {
  --gradient-to-color: #84e1bc;
}
.focus\\:to-green-400:focus {
  --gradient-to-color: #31c48d;
}
.focus\\:to-green-500:focus {
  --gradient-to-color: #0e9f6e;
}
.focus\\:to-green-600:focus {
  --gradient-to-color: #057a55;
}
.focus\\:to-green-700:focus {
  --gradient-to-color: #046c4e;
}
.focus\\:to-green-800:focus {
  --gradient-to-color: #03543f;
}
.focus\\:to-green-900:focus {
  --gradient-to-color: #014737;
}
.focus\\:to-teal-50:focus {
  --gradient-to-color: #edfafa;
}
.focus\\:to-teal-100:focus {
  --gradient-to-color: #d5f5f6;
}
.focus\\:to-teal-200:focus {
  --gradient-to-color: #afecef;
}
.focus\\:to-teal-300:focus {
  --gradient-to-color: #7edce2;
}
.focus\\:to-teal-400:focus {
  --gradient-to-color: #16bdca;
}
.focus\\:to-teal-500:focus {
  --gradient-to-color: #0694a2;
}
.focus\\:to-teal-600:focus {
  --gradient-to-color: #047481;
}
.focus\\:to-teal-700:focus {
  --gradient-to-color: #036672;
}
.focus\\:to-teal-800:focus {
  --gradient-to-color: #05505c;
}
.focus\\:to-teal-900:focus {
  --gradient-to-color: #014451;
}
.focus\\:to-blue-50:focus {
  --gradient-to-color: #ebf5ff;
}
.focus\\:to-blue-100:focus {
  --gradient-to-color: #e1effe;
}
.focus\\:to-blue-200:focus {
  --gradient-to-color: #c3ddfd;
}
.focus\\:to-blue-300:focus {
  --gradient-to-color: #a4cafe;
}
.focus\\:to-blue-400:focus {
  --gradient-to-color: #76a9fa;
}
.focus\\:to-blue-500:focus {
  --gradient-to-color: #3f83f8;
}
.focus\\:to-blue-600:focus {
  --gradient-to-color: #1c64f2;
}
.focus\\:to-blue-700:focus {
  --gradient-to-color: #1a56db;
}
.focus\\:to-blue-800:focus {
  --gradient-to-color: #1e429f;
}
.focus\\:to-blue-900:focus {
  --gradient-to-color: #233876;
}
.focus\\:to-indigo-50:focus {
  --gradient-to-color: #f0f5ff;
}
.focus\\:to-indigo-100:focus {
  --gradient-to-color: #e5edff;
}
.focus\\:to-indigo-200:focus {
  --gradient-to-color: #cddbfe;
}
.focus\\:to-indigo-300:focus {
  --gradient-to-color: #b4c6fc;
}
.focus\\:to-indigo-400:focus {
  --gradient-to-color: #8da2fb;
}
.focus\\:to-indigo-500:focus {
  --gradient-to-color: #6875f5;
}
.focus\\:to-indigo-600:focus {
  --gradient-to-color: #5850ec;
}
.focus\\:to-indigo-700:focus {
  --gradient-to-color: #5145cd;
}
.focus\\:to-indigo-800:focus {
  --gradient-to-color: #42389d;
}
.focus\\:to-indigo-900:focus {
  --gradient-to-color: #362f78;
}
.focus\\:to-purple-50:focus {
  --gradient-to-color: #f6f5ff;
}
.focus\\:to-purple-100:focus {
  --gradient-to-color: #edebfe;
}
.focus\\:to-purple-200:focus {
  --gradient-to-color: #dcd7fe;
}
.focus\\:to-purple-300:focus {
  --gradient-to-color: #cabffd;
}
.focus\\:to-purple-400:focus {
  --gradient-to-color: #ac94fa;
}
.focus\\:to-purple-500:focus {
  --gradient-to-color: #9061f9;
}
.focus\\:to-purple-600:focus {
  --gradient-to-color: #7e3af2;
}
.focus\\:to-purple-700:focus {
  --gradient-to-color: #6c2bd9;
}
.focus\\:to-purple-800:focus {
  --gradient-to-color: #5521b5;
}
.focus\\:to-purple-900:focus {
  --gradient-to-color: #4a1d96;
}
.focus\\:to-pink-50:focus {
  --gradient-to-color: #fdf2f8;
}
.focus\\:to-pink-100:focus {
  --gradient-to-color: #fce8f3;
}
.focus\\:to-pink-200:focus {
  --gradient-to-color: #fad1e8;
}
.focus\\:to-pink-300:focus {
  --gradient-to-color: #f8b4d9;
}
.focus\\:to-pink-400:focus {
  --gradient-to-color: #f17eb8;
}
.focus\\:to-pink-500:focus {
  --gradient-to-color: #e74694;
}
.focus\\:to-pink-600:focus {
  --gradient-to-color: #d61f69;
}
.focus\\:to-pink-700:focus {
  --gradient-to-color: #bf125d;
}
.focus\\:to-pink-800:focus {
  --gradient-to-color: #99154b;
}
.focus\\:to-pink-900:focus {
  --gradient-to-color: #751a3d;
}
.focus\\:to-cool-gray-50:focus {
  --gradient-to-color: #f8fafc;
}
.focus\\:to-cool-gray-100:focus {
  --gradient-to-color: #f1f5f9;
}
.focus\\:to-cool-gray-200:focus {
  --gradient-to-color: #e2e8f0;
}
.focus\\:to-cool-gray-300:focus {
  --gradient-to-color: #cfd8e3;
}
.focus\\:to-cool-gray-400:focus {
  --gradient-to-color: #97a6ba;
}
.focus\\:to-cool-gray-500:focus {
  --gradient-to-color: #64748b;
}
.focus\\:to-cool-gray-600:focus {
  --gradient-to-color: #475569;
}
.focus\\:to-cool-gray-700:focus {
  --gradient-to-color: #364152;
}
.focus\\:to-cool-gray-800:focus {
  --gradient-to-color: #27303f;
}
.focus\\:to-cool-gray-900:focus {
  --gradient-to-color: #1a202e;
}
.bg-opacity-0 {
  --bg-opacity: 0;
}
.bg-opacity-25 {
  --bg-opacity: 0.25;
}
.bg-opacity-50 {
  --bg-opacity: 0.5;
}
.bg-opacity-75 {
  --bg-opacity: 0.75;
}
.bg-opacity-100 {
  --bg-opacity: 1;
}
.hover\\:bg-opacity-0:hover {
  --bg-opacity: 0;
}
.hover\\:bg-opacity-25:hover {
  --bg-opacity: 0.25;
}
.hover\\:bg-opacity-50:hover {
  --bg-opacity: 0.5;
}
.hover\\:bg-opacity-75:hover {
  --bg-opacity: 0.75;
}
.hover\\:bg-opacity-100:hover {
  --bg-opacity: 1;
}
.focus\\:bg-opacity-0:focus {
  --bg-opacity: 0;
}
.focus\\:bg-opacity-25:focus {
  --bg-opacity: 0.25;
}
.focus\\:bg-opacity-50:focus {
  --bg-opacity: 0.5;
}
.focus\\:bg-opacity-75:focus {
  --bg-opacity: 0.75;
}
.focus\\:bg-opacity-100:focus {
  --bg-opacity: 1;
}
.bg-bottom {
  background-position: bottom;
}
.bg-center {
  background-position: center;
}
.bg-left {
  background-position: left;
}
.bg-left-bottom {
  background-position: left bottom;
}
.bg-left-top {
  background-position: left top;
}
.bg-right {
  background-position: right;
}
.bg-right-bottom {
  background-position: right bottom;
}
.bg-right-top {
  background-position: right top;
}
.bg-top {
  background-position: top;
}
.bg-repeat {
  background-repeat: repeat;
}
.bg-no-repeat {
  background-repeat: no-repeat;
}
.bg-repeat-x {
  background-repeat: repeat-x;
}
.bg-repeat-y {
  background-repeat: repeat-y;
}
.bg-repeat-round {
  background-repeat: round;
}
.bg-repeat-space {
  background-repeat: space;
}
.bg-auto {
  background-size: auto;
}
.bg-cover {
  background-size: cover;
}
.bg-contain {
  background-size: contain;
}
.border-collapse {
  border-collapse: collapse;
}
.border-separate {
  border-collapse: separate;
}
.border-current {
  border-color: currentColor;
}
.border-transparent {
  border-color: transparent;
}
.border-white {
  --border-opacity: 1;
  border-color: #ffffff;
  border-color: rgba(255, 255, 255, var(--border-opacity));
}
.border-black {
  --border-opacity: 1;
  border-color: #000000;
  border-color: rgba(0, 0, 0, var(--border-opacity));
}
.border-gray-50 {
  --border-opacity: 1;
  border-color: #f9fafb;
  border-color: rgba(249, 250, 251, var(--border-opacity));
}
.border-gray-100 {
  --border-opacity: 1;
  border-color: #f4f5f7;
  border-color: rgba(244, 245, 247, var(--border-opacity));
}
.border-gray-200 {
  --border-opacity: 1;
  border-color: #e5e7eb;
  border-color: rgba(229, 231, 235, var(--border-opacity));
}
.border-gray-300 {
  --border-opacity: 1;
  border-color: #d2d6dc;
  border-color: rgba(210, 214, 220, var(--border-opacity));
}
.border-gray-400 {
  --border-opacity: 1;
  border-color: #9fa6b2;
  border-color: rgba(159, 166, 178, var(--border-opacity));
}
.border-gray-500 {
  --border-opacity: 1;
  border-color: #6b7280;
  border-color: rgba(107, 114, 128, var(--border-opacity));
}
.border-gray-600 {
  --border-opacity: 1;
  border-color: #4b5563;
  border-color: rgba(75, 85, 99, var(--border-opacity));
}
.border-gray-700 {
  --border-opacity: 1;
  border-color: #374151;
  border-color: rgba(55, 65, 81, var(--border-opacity));
}
.border-gray-800 {
  --border-opacity: 1;
  border-color: #252f3f;
  border-color: rgba(37, 47, 63, var(--border-opacity));
}
.border-gray-900 {
  --border-opacity: 1;
  border-color: #161e2e;
  border-color: rgba(22, 30, 46, var(--border-opacity));
}
.border-red-50 {
  --border-opacity: 1;
  border-color: #fdf2f2;
  border-color: rgba(253, 242, 242, var(--border-opacity));
}
.border-red-100 {
  --border-opacity: 1;
  border-color: #fde8e8;
  border-color: rgba(253, 232, 232, var(--border-opacity));
}
.border-red-200 {
  --border-opacity: 1;
  border-color: #fbd5d5;
  border-color: rgba(251, 213, 213, var(--border-opacity));
}
.border-red-300 {
  --border-opacity: 1;
  border-color: #f8b4b4;
  border-color: rgba(248, 180, 180, var(--border-opacity));
}
.border-red-400 {
  --border-opacity: 1;
  border-color: #f98080;
  border-color: rgba(249, 128, 128, var(--border-opacity));
}
.border-red-500 {
  --border-opacity: 1;
  border-color: #f05252;
  border-color: rgba(240, 82, 82, var(--border-opacity));
}
.border-red-600 {
  --border-opacity: 1;
  border-color: #e02424;
  border-color: rgba(224, 36, 36, var(--border-opacity));
}
.border-red-700 {
  --border-opacity: 1;
  border-color: #c81e1e;
  border-color: rgba(200, 30, 30, var(--border-opacity));
}
.border-red-800 {
  --border-opacity: 1;
  border-color: #9b1c1c;
  border-color: rgba(155, 28, 28, var(--border-opacity));
}
.border-red-900 {
  --border-opacity: 1;
  border-color: #771d1d;
  border-color: rgba(119, 29, 29, var(--border-opacity));
}
.border-orange-50 {
  --border-opacity: 1;
  border-color: #fff8f1;
  border-color: rgba(255, 248, 241, var(--border-opacity));
}
.border-orange-100 {
  --border-opacity: 1;
  border-color: #feecdc;
  border-color: rgba(254, 236, 220, var(--border-opacity));
}
.border-orange-200 {
  --border-opacity: 1;
  border-color: #fcd9bd;
  border-color: rgba(252, 217, 189, var(--border-opacity));
}
.border-orange-300 {
  --border-opacity: 1;
  border-color: #fdba8c;
  border-color: rgba(253, 186, 140, var(--border-opacity));
}
.border-orange-400 {
  --border-opacity: 1;
  border-color: #ff8a4c;
  border-color: rgba(255, 138, 76, var(--border-opacity));
}
.border-orange-500 {
  --border-opacity: 1;
  border-color: #ff5a1f;
  border-color: rgba(255, 90, 31, var(--border-opacity));
}
.border-orange-600 {
  --border-opacity: 1;
  border-color: #d03801;
  border-color: rgba(208, 56, 1, var(--border-opacity));
}
.border-orange-700 {
  --border-opacity: 1;
  border-color: #b43403;
  border-color: rgba(180, 52, 3, var(--border-opacity));
}
.border-orange-800 {
  --border-opacity: 1;
  border-color: #8a2c0d;
  border-color: rgba(138, 44, 13, var(--border-opacity));
}
.border-orange-900 {
  --border-opacity: 1;
  border-color: #73230d;
  border-color: rgba(115, 35, 13, var(--border-opacity));
}
.border-yellow-50 {
  --border-opacity: 1;
  border-color: #fdfdea;
  border-color: rgba(253, 253, 234, var(--border-opacity));
}
.border-yellow-100 {
  --border-opacity: 1;
  border-color: #fdf6b2;
  border-color: rgba(253, 246, 178, var(--border-opacity));
}
.border-yellow-200 {
  --border-opacity: 1;
  border-color: #fce96a;
  border-color: rgba(252, 233, 106, var(--border-opacity));
}
.border-yellow-300 {
  --border-opacity: 1;
  border-color: #faca15;
  border-color: rgba(250, 202, 21, var(--border-opacity));
}
.border-yellow-400 {
  --border-opacity: 1;
  border-color: #e3a008;
  border-color: rgba(227, 160, 8, var(--border-opacity));
}
.border-yellow-500 {
  --border-opacity: 1;
  border-color: #c27803;
  border-color: rgba(194, 120, 3, var(--border-opacity));
}
.border-yellow-600 {
  --border-opacity: 1;
  border-color: #9f580a;
  border-color: rgba(159, 88, 10, var(--border-opacity));
}
.border-yellow-700 {
  --border-opacity: 1;
  border-color: #8e4b10;
  border-color: rgba(142, 75, 16, var(--border-opacity));
}
.border-yellow-800 {
  --border-opacity: 1;
  border-color: #723b13;
  border-color: rgba(114, 59, 19, var(--border-opacity));
}
.border-yellow-900 {
  --border-opacity: 1;
  border-color: #633112;
  border-color: rgba(99, 49, 18, var(--border-opacity));
}
.border-green-50 {
  --border-opacity: 1;
  border-color: #f3faf7;
  border-color: rgba(243, 250, 247, var(--border-opacity));
}
.border-green-100 {
  --border-opacity: 1;
  border-color: #def7ec;
  border-color: rgba(222, 247, 236, var(--border-opacity));
}
.border-green-200 {
  --border-opacity: 1;
  border-color: #bcf0da;
  border-color: rgba(188, 240, 218, var(--border-opacity));
}
.border-green-300 {
  --border-opacity: 1;
  border-color: #84e1bc;
  border-color: rgba(132, 225, 188, var(--border-opacity));
}
.border-green-400 {
  --border-opacity: 1;
  border-color: #31c48d;
  border-color: rgba(49, 196, 141, var(--border-opacity));
}
.border-green-500 {
  --border-opacity: 1;
  border-color: #0e9f6e;
  border-color: rgba(14, 159, 110, var(--border-opacity));
}
.border-green-600 {
  --border-opacity: 1;
  border-color: #057a55;
  border-color: rgba(5, 122, 85, var(--border-opacity));
}
.border-green-700 {
  --border-opacity: 1;
  border-color: #046c4e;
  border-color: rgba(4, 108, 78, var(--border-opacity));
}
.border-green-800 {
  --border-opacity: 1;
  border-color: #03543f;
  border-color: rgba(3, 84, 63, var(--border-opacity));
}
.border-green-900 {
  --border-opacity: 1;
  border-color: #014737;
  border-color: rgba(1, 71, 55, var(--border-opacity));
}
.border-teal-50 {
  --border-opacity: 1;
  border-color: #edfafa;
  border-color: rgba(237, 250, 250, var(--border-opacity));
}
.border-teal-100 {
  --border-opacity: 1;
  border-color: #d5f5f6;
  border-color: rgba(213, 245, 246, var(--border-opacity));
}
.border-teal-200 {
  --border-opacity: 1;
  border-color: #afecef;
  border-color: rgba(175, 236, 239, var(--border-opacity));
}
.border-teal-300 {
  --border-opacity: 1;
  border-color: #7edce2;
  border-color: rgba(126, 220, 226, var(--border-opacity));
}
.border-teal-400 {
  --border-opacity: 1;
  border-color: #16bdca;
  border-color: rgba(22, 189, 202, var(--border-opacity));
}
.border-teal-500 {
  --border-opacity: 1;
  border-color: #0694a2;
  border-color: rgba(6, 148, 162, var(--border-opacity));
}
.border-teal-600 {
  --border-opacity: 1;
  border-color: #047481;
  border-color: rgba(4, 116, 129, var(--border-opacity));
}
.border-teal-700 {
  --border-opacity: 1;
  border-color: #036672;
  border-color: rgba(3, 102, 114, var(--border-opacity));
}
.border-teal-800 {
  --border-opacity: 1;
  border-color: #05505c;
  border-color: rgba(5, 80, 92, var(--border-opacity));
}
.border-teal-900 {
  --border-opacity: 1;
  border-color: #014451;
  border-color: rgba(1, 68, 81, var(--border-opacity));
}
.border-blue-50 {
  --border-opacity: 1;
  border-color: #ebf5ff;
  border-color: rgba(235, 245, 255, var(--border-opacity));
}
.border-blue-100 {
  --border-opacity: 1;
  border-color: #e1effe;
  border-color: rgba(225, 239, 254, var(--border-opacity));
}
.border-blue-200 {
  --border-opacity: 1;
  border-color: #c3ddfd;
  border-color: rgba(195, 221, 253, var(--border-opacity));
}
.border-blue-300 {
  --border-opacity: 1;
  border-color: #a4cafe;
  border-color: rgba(164, 202, 254, var(--border-opacity));
}
.border-blue-400 {
  --border-opacity: 1;
  border-color: #76a9fa;
  border-color: rgba(118, 169, 250, var(--border-opacity));
}
.border-blue-500 {
  --border-opacity: 1;
  border-color: #3f83f8;
  border-color: rgba(63, 131, 248, var(--border-opacity));
}
.border-blue-600 {
  --border-opacity: 1;
  border-color: #1c64f2;
  border-color: rgba(28, 100, 242, var(--border-opacity));
}
.border-blue-700 {
  --border-opacity: 1;
  border-color: #1a56db;
  border-color: rgba(26, 86, 219, var(--border-opacity));
}
.border-blue-800 {
  --border-opacity: 1;
  border-color: #1e429f;
  border-color: rgba(30, 66, 159, var(--border-opacity));
}
.border-blue-900 {
  --border-opacity: 1;
  border-color: #233876;
  border-color: rgba(35, 56, 118, var(--border-opacity));
}
.border-indigo-50 {
  --border-opacity: 1;
  border-color: #f0f5ff;
  border-color: rgba(240, 245, 255, var(--border-opacity));
}
.border-indigo-100 {
  --border-opacity: 1;
  border-color: #e5edff;
  border-color: rgba(229, 237, 255, var(--border-opacity));
}
.border-indigo-200 {
  --border-opacity: 1;
  border-color: #cddbfe;
  border-color: rgba(205, 219, 254, var(--border-opacity));
}
.border-indigo-300 {
  --border-opacity: 1;
  border-color: #b4c6fc;
  border-color: rgba(180, 198, 252, var(--border-opacity));
}
.border-indigo-400 {
  --border-opacity: 1;
  border-color: #8da2fb;
  border-color: rgba(141, 162, 251, var(--border-opacity));
}
.border-indigo-500 {
  --border-opacity: 1;
  border-color: #6875f5;
  border-color: rgba(104, 117, 245, var(--border-opacity));
}
.border-indigo-600 {
  --border-opacity: 1;
  border-color: #5850ec;
  border-color: rgba(88, 80, 236, var(--border-opacity));
}
.border-indigo-700 {
  --border-opacity: 1;
  border-color: #5145cd;
  border-color: rgba(81, 69, 205, var(--border-opacity));
}
.border-indigo-800 {
  --border-opacity: 1;
  border-color: #42389d;
  border-color: rgba(66, 56, 157, var(--border-opacity));
}
.border-indigo-900 {
  --border-opacity: 1;
  border-color: #362f78;
  border-color: rgba(54, 47, 120, var(--border-opacity));
}
.border-purple-50 {
  --border-opacity: 1;
  border-color: #f6f5ff;
  border-color: rgba(246, 245, 255, var(--border-opacity));
}
.border-purple-100 {
  --border-opacity: 1;
  border-color: #edebfe;
  border-color: rgba(237, 235, 254, var(--border-opacity));
}
.border-purple-200 {
  --border-opacity: 1;
  border-color: #dcd7fe;
  border-color: rgba(220, 215, 254, var(--border-opacity));
}
.border-purple-300 {
  --border-opacity: 1;
  border-color: #cabffd;
  border-color: rgba(202, 191, 253, var(--border-opacity));
}
.border-purple-400 {
  --border-opacity: 1;
  border-color: #ac94fa;
  border-color: rgba(172, 148, 250, var(--border-opacity));
}
.border-purple-500 {
  --border-opacity: 1;
  border-color: #9061f9;
  border-color: rgba(144, 97, 249, var(--border-opacity));
}
.border-purple-600 {
  --border-opacity: 1;
  border-color: #7e3af2;
  border-color: rgba(126, 58, 242, var(--border-opacity));
}
.border-purple-700 {
  --border-opacity: 1;
  border-color: #6c2bd9;
  border-color: rgba(108, 43, 217, var(--border-opacity));
}
.border-purple-800 {
  --border-opacity: 1;
  border-color: #5521b5;
  border-color: rgba(85, 33, 181, var(--border-opacity));
}
.border-purple-900 {
  --border-opacity: 1;
  border-color: #4a1d96;
  border-color: rgba(74, 29, 150, var(--border-opacity));
}
.border-pink-50 {
  --border-opacity: 1;
  border-color: #fdf2f8;
  border-color: rgba(253, 242, 248, var(--border-opacity));
}
.border-pink-100 {
  --border-opacity: 1;
  border-color: #fce8f3;
  border-color: rgba(252, 232, 243, var(--border-opacity));
}
.border-pink-200 {
  --border-opacity: 1;
  border-color: #fad1e8;
  border-color: rgba(250, 209, 232, var(--border-opacity));
}
.border-pink-300 {
  --border-opacity: 1;
  border-color: #f8b4d9;
  border-color: rgba(248, 180, 217, var(--border-opacity));
}
.border-pink-400 {
  --border-opacity: 1;
  border-color: #f17eb8;
  border-color: rgba(241, 126, 184, var(--border-opacity));
}
.border-pink-500 {
  --border-opacity: 1;
  border-color: #e74694;
  border-color: rgba(231, 70, 148, var(--border-opacity));
}
.border-pink-600 {
  --border-opacity: 1;
  border-color: #d61f69;
  border-color: rgba(214, 31, 105, var(--border-opacity));
}
.border-pink-700 {
  --border-opacity: 1;
  border-color: #bf125d;
  border-color: rgba(191, 18, 93, var(--border-opacity));
}
.border-pink-800 {
  --border-opacity: 1;
  border-color: #99154b;
  border-color: rgba(153, 21, 75, var(--border-opacity));
}
.border-pink-900 {
  --border-opacity: 1;
  border-color: #751a3d;
  border-color: rgba(117, 26, 61, var(--border-opacity));
}
.border-cool-gray-50 {
  --border-opacity: 1;
  border-color: #f8fafc;
  border-color: rgba(248, 250, 252, var(--border-opacity));
}
.border-cool-gray-100 {
  --border-opacity: 1;
  border-color: #f1f5f9;
  border-color: rgba(241, 245, 249, var(--border-opacity));
}
.border-cool-gray-200 {
  --border-opacity: 1;
  border-color: #e2e8f0;
  border-color: rgba(226, 232, 240, var(--border-opacity));
}
.border-cool-gray-300 {
  --border-opacity: 1;
  border-color: #cfd8e3;
  border-color: rgba(207, 216, 227, var(--border-opacity));
}
.border-cool-gray-400 {
  --border-opacity: 1;
  border-color: #97a6ba;
  border-color: rgba(151, 166, 186, var(--border-opacity));
}
.border-cool-gray-500 {
  --border-opacity: 1;
  border-color: #64748b;
  border-color: rgba(100, 116, 139, var(--border-opacity));
}
.border-cool-gray-600 {
  --border-opacity: 1;
  border-color: #475569;
  border-color: rgba(71, 85, 105, var(--border-opacity));
}
.border-cool-gray-700 {
  --border-opacity: 1;
  border-color: #364152;
  border-color: rgba(54, 65, 82, var(--border-opacity));
}
.border-cool-gray-800 {
  --border-opacity: 1;
  border-color: #27303f;
  border-color: rgba(39, 48, 63, var(--border-opacity));
}
.border-cool-gray-900 {
  --border-opacity: 1;
  border-color: #1a202e;
  border-color: rgba(26, 32, 46, var(--border-opacity));
}
.group:hover .group-hover\\:border-current {
  border-color: currentColor;
}
.group:hover .group-hover\\:border-transparent {
  border-color: transparent;
}
.group:hover .group-hover\\:border-white {
  --border-opacity: 1;
  border-color: #ffffff;
  border-color: rgba(255, 255, 255, var(--border-opacity));
}
.group:hover .group-hover\\:border-black {
  --border-opacity: 1;
  border-color: #000000;
  border-color: rgba(0, 0, 0, var(--border-opacity));
}
.group:hover .group-hover\\:border-gray-50 {
  --border-opacity: 1;
  border-color: #f9fafb;
  border-color: rgba(249, 250, 251, var(--border-opacity));
}
.group:hover .group-hover\\:border-gray-100 {
  --border-opacity: 1;
  border-color: #f4f5f7;
  border-color: rgba(244, 245, 247, var(--border-opacity));
}
.group:hover .group-hover\\:border-gray-200 {
  --border-opacity: 1;
  border-color: #e5e7eb;
  border-color: rgba(229, 231, 235, var(--border-opacity));
}
.group:hover .group-hover\\:border-gray-300 {
  --border-opacity: 1;
  border-color: #d2d6dc;
  border-color: rgba(210, 214, 220, var(--border-opacity));
}
.group:hover .group-hover\\:border-gray-400 {
  --border-opacity: 1;
  border-color: #9fa6b2;
  border-color: rgba(159, 166, 178, var(--border-opacity));
}
.group:hover .group-hover\\:border-gray-500 {
  --border-opacity: 1;
  border-color: #6b7280;
  border-color: rgba(107, 114, 128, var(--border-opacity));
}
.group:hover .group-hover\\:border-gray-600 {
  --border-opacity: 1;
  border-color: #4b5563;
  border-color: rgba(75, 85, 99, var(--border-opacity));
}
.group:hover .group-hover\\:border-gray-700 {
  --border-opacity: 1;
  border-color: #374151;
  border-color: rgba(55, 65, 81, var(--border-opacity));
}
.group:hover .group-hover\\:border-gray-800 {
  --border-opacity: 1;
  border-color: #252f3f;
  border-color: rgba(37, 47, 63, var(--border-opacity));
}
.group:hover .group-hover\\:border-gray-900 {
  --border-opacity: 1;
  border-color: #161e2e;
  border-color: rgba(22, 30, 46, var(--border-opacity));
}
.group:hover .group-hover\\:border-red-50 {
  --border-opacity: 1;
  border-color: #fdf2f2;
  border-color: rgba(253, 242, 242, var(--border-opacity));
}
.group:hover .group-hover\\:border-red-100 {
  --border-opacity: 1;
  border-color: #fde8e8;
  border-color: rgba(253, 232, 232, var(--border-opacity));
}
.group:hover .group-hover\\:border-red-200 {
  --border-opacity: 1;
  border-color: #fbd5d5;
  border-color: rgba(251, 213, 213, var(--border-opacity));
}
.group:hover .group-hover\\:border-red-300 {
  --border-opacity: 1;
  border-color: #f8b4b4;
  border-color: rgba(248, 180, 180, var(--border-opacity));
}
.group:hover .group-hover\\:border-red-400 {
  --border-opacity: 1;
  border-color: #f98080;
  border-color: rgba(249, 128, 128, var(--border-opacity));
}
.group:hover .group-hover\\:border-red-500 {
  --border-opacity: 1;
  border-color: #f05252;
  border-color: rgba(240, 82, 82, var(--border-opacity));
}
.group:hover .group-hover\\:border-red-600 {
  --border-opacity: 1;
  border-color: #e02424;
  border-color: rgba(224, 36, 36, var(--border-opacity));
}
.group:hover .group-hover\\:border-red-700 {
  --border-opacity: 1;
  border-color: #c81e1e;
  border-color: rgba(200, 30, 30, var(--border-opacity));
}
.group:hover .group-hover\\:border-red-800 {
  --border-opacity: 1;
  border-color: #9b1c1c;
  border-color: rgba(155, 28, 28, var(--border-opacity));
}
.group:hover .group-hover\\:border-red-900 {
  --border-opacity: 1;
  border-color: #771d1d;
  border-color: rgba(119, 29, 29, var(--border-opacity));
}
.group:hover .group-hover\\:border-orange-50 {
  --border-opacity: 1;
  border-color: #fff8f1;
  border-color: rgba(255, 248, 241, var(--border-opacity));
}
.group:hover .group-hover\\:border-orange-100 {
  --border-opacity: 1;
  border-color: #feecdc;
  border-color: rgba(254, 236, 220, var(--border-opacity));
}
.group:hover .group-hover\\:border-orange-200 {
  --border-opacity: 1;
  border-color: #fcd9bd;
  border-color: rgba(252, 217, 189, var(--border-opacity));
}
.group:hover .group-hover\\:border-orange-300 {
  --border-opacity: 1;
  border-color: #fdba8c;
  border-color: rgba(253, 186, 140, var(--border-opacity));
}
.group:hover .group-hover\\:border-orange-400 {
  --border-opacity: 1;
  border-color: #ff8a4c;
  border-color: rgba(255, 138, 76, var(--border-opacity));
}
.group:hover .group-hover\\:border-orange-500 {
  --border-opacity: 1;
  border-color: #ff5a1f;
  border-color: rgba(255, 90, 31, var(--border-opacity));
}
.group:hover .group-hover\\:border-orange-600 {
  --border-opacity: 1;
  border-color: #d03801;
  border-color: rgba(208, 56, 1, var(--border-opacity));
}
.group:hover .group-hover\\:border-orange-700 {
  --border-opacity: 1;
  border-color: #b43403;
  border-color: rgba(180, 52, 3, var(--border-opacity));
}
.group:hover .group-hover\\:border-orange-800 {
  --border-opacity: 1;
  border-color: #8a2c0d;
  border-color: rgba(138, 44, 13, var(--border-opacity));
}
.group:hover .group-hover\\:border-orange-900 {
  --border-opacity: 1;
  border-color: #73230d;
  border-color: rgba(115, 35, 13, var(--border-opacity));
}
.group:hover .group-hover\\:border-yellow-50 {
  --border-opacity: 1;
  border-color: #fdfdea;
  border-color: rgba(253, 253, 234, var(--border-opacity));
}
.group:hover .group-hover\\:border-yellow-100 {
  --border-opacity: 1;
  border-color: #fdf6b2;
  border-color: rgba(253, 246, 178, var(--border-opacity));
}
.group:hover .group-hover\\:border-yellow-200 {
  --border-opacity: 1;
  border-color: #fce96a;
  border-color: rgba(252, 233, 106, var(--border-opacity));
}
.group:hover .group-hover\\:border-yellow-300 {
  --border-opacity: 1;
  border-color: #faca15;
  border-color: rgba(250, 202, 21, var(--border-opacity));
}
.group:hover .group-hover\\:border-yellow-400 {
  --border-opacity: 1;
  border-color: #e3a008;
  border-color: rgba(227, 160, 8, var(--border-opacity));
}
.group:hover .group-hover\\:border-yellow-500 {
  --border-opacity: 1;
  border-color: #c27803;
  border-color: rgba(194, 120, 3, var(--border-opacity));
}
.group:hover .group-hover\\:border-yellow-600 {
  --border-opacity: 1;
  border-color: #9f580a;
  border-color: rgba(159, 88, 10, var(--border-opacity));
}
.group:hover .group-hover\\:border-yellow-700 {
  --border-opacity: 1;
  border-color: #8e4b10;
  border-color: rgba(142, 75, 16, var(--border-opacity));
}
.group:hover .group-hover\\:border-yellow-800 {
  --border-opacity: 1;
  border-color: #723b13;
  border-color: rgba(114, 59, 19, var(--border-opacity));
}
.group:hover .group-hover\\:border-yellow-900 {
  --border-opacity: 1;
  border-color: #633112;
  border-color: rgba(99, 49, 18, var(--border-opacity));
}
.group:hover .group-hover\\:border-green-50 {
  --border-opacity: 1;
  border-color: #f3faf7;
  border-color: rgba(243, 250, 247, var(--border-opacity));
}
.group:hover .group-hover\\:border-green-100 {
  --border-opacity: 1;
  border-color: #def7ec;
  border-color: rgba(222, 247, 236, var(--border-opacity));
}
.group:hover .group-hover\\:border-green-200 {
  --border-opacity: 1;
  border-color: #bcf0da;
  border-color: rgba(188, 240, 218, var(--border-opacity));
}
.group:hover .group-hover\\:border-green-300 {
  --border-opacity: 1;
  border-color: #84e1bc;
  border-color: rgba(132, 225, 188, var(--border-opacity));
}
.group:hover .group-hover\\:border-green-400 {
  --border-opacity: 1;
  border-color: #31c48d;
  border-color: rgba(49, 196, 141, var(--border-opacity));
}
.group:hover .group-hover\\:border-green-500 {
  --border-opacity: 1;
  border-color: #0e9f6e;
  border-color: rgba(14, 159, 110, var(--border-opacity));
}
.group:hover .group-hover\\:border-green-600 {
  --border-opacity: 1;
  border-color: #057a55;
  border-color: rgba(5, 122, 85, var(--border-opacity));
}
.group:hover .group-hover\\:border-green-700 {
  --border-opacity: 1;
  border-color: #046c4e;
  border-color: rgba(4, 108, 78, var(--border-opacity));
}
.group:hover .group-hover\\:border-green-800 {
  --border-opacity: 1;
  border-color: #03543f;
  border-color: rgba(3, 84, 63, var(--border-opacity));
}
.group:hover .group-hover\\:border-green-900 {
  --border-opacity: 1;
  border-color: #014737;
  border-color: rgba(1, 71, 55, var(--border-opacity));
}
.group:hover .group-hover\\:border-teal-50 {
  --border-opacity: 1;
  border-color: #edfafa;
  border-color: rgba(237, 250, 250, var(--border-opacity));
}
.group:hover .group-hover\\:border-teal-100 {
  --border-opacity: 1;
  border-color: #d5f5f6;
  border-color: rgba(213, 245, 246, var(--border-opacity));
}
.group:hover .group-hover\\:border-teal-200 {
  --border-opacity: 1;
  border-color: #afecef;
  border-color: rgba(175, 236, 239, var(--border-opacity));
}
.group:hover .group-hover\\:border-teal-300 {
  --border-opacity: 1;
  border-color: #7edce2;
  border-color: rgba(126, 220, 226, var(--border-opacity));
}
.group:hover .group-hover\\:border-teal-400 {
  --border-opacity: 1;
  border-color: #16bdca;
  border-color: rgba(22, 189, 202, var(--border-opacity));
}
.group:hover .group-hover\\:border-teal-500 {
  --border-opacity: 1;
  border-color: #0694a2;
  border-color: rgba(6, 148, 162, var(--border-opacity));
}
.group:hover .group-hover\\:border-teal-600 {
  --border-opacity: 1;
  border-color: #047481;
  border-color: rgba(4, 116, 129, var(--border-opacity));
}
.group:hover .group-hover\\:border-teal-700 {
  --border-opacity: 1;
  border-color: #036672;
  border-color: rgba(3, 102, 114, var(--border-opacity));
}
.group:hover .group-hover\\:border-teal-800 {
  --border-opacity: 1;
  border-color: #05505c;
  border-color: rgba(5, 80, 92, var(--border-opacity));
}
.group:hover .group-hover\\:border-teal-900 {
  --border-opacity: 1;
  border-color: #014451;
  border-color: rgba(1, 68, 81, var(--border-opacity));
}
.group:hover .group-hover\\:border-blue-50 {
  --border-opacity: 1;
  border-color: #ebf5ff;
  border-color: rgba(235, 245, 255, var(--border-opacity));
}
.group:hover .group-hover\\:border-blue-100 {
  --border-opacity: 1;
  border-color: #e1effe;
  border-color: rgba(225, 239, 254, var(--border-opacity));
}
.group:hover .group-hover\\:border-blue-200 {
  --border-opacity: 1;
  border-color: #c3ddfd;
  border-color: rgba(195, 221, 253, var(--border-opacity));
}
.group:hover .group-hover\\:border-blue-300 {
  --border-opacity: 1;
  border-color: #a4cafe;
  border-color: rgba(164, 202, 254, var(--border-opacity));
}
.group:hover .group-hover\\:border-blue-400 {
  --border-opacity: 1;
  border-color: #76a9fa;
  border-color: rgba(118, 169, 250, var(--border-opacity));
}
.group:hover .group-hover\\:border-blue-500 {
  --border-opacity: 1;
  border-color: #3f83f8;
  border-color: rgba(63, 131, 248, var(--border-opacity));
}
.group:hover .group-hover\\:border-blue-600 {
  --border-opacity: 1;
  border-color: #1c64f2;
  border-color: rgba(28, 100, 242, var(--border-opacity));
}
.group:hover .group-hover\\:border-blue-700 {
  --border-opacity: 1;
  border-color: #1a56db;
  border-color: rgba(26, 86, 219, var(--border-opacity));
}
.group:hover .group-hover\\:border-blue-800 {
  --border-opacity: 1;
  border-color: #1e429f;
  border-color: rgba(30, 66, 159, var(--border-opacity));
}
.group:hover .group-hover\\:border-blue-900 {
  --border-opacity: 1;
  border-color: #233876;
  border-color: rgba(35, 56, 118, var(--border-opacity));
}
.group:hover .group-hover\\:border-indigo-50 {
  --border-opacity: 1;
  border-color: #f0f5ff;
  border-color: rgba(240, 245, 255, var(--border-opacity));
}
.group:hover .group-hover\\:border-indigo-100 {
  --border-opacity: 1;
  border-color: #e5edff;
  border-color: rgba(229, 237, 255, var(--border-opacity));
}
.group:hover .group-hover\\:border-indigo-200 {
  --border-opacity: 1;
  border-color: #cddbfe;
  border-color: rgba(205, 219, 254, var(--border-opacity));
}
.group:hover .group-hover\\:border-indigo-300 {
  --border-opacity: 1;
  border-color: #b4c6fc;
  border-color: rgba(180, 198, 252, var(--border-opacity));
}
.group:hover .group-hover\\:border-indigo-400 {
  --border-opacity: 1;
  border-color: #8da2fb;
  border-color: rgba(141, 162, 251, var(--border-opacity));
}
.group:hover .group-hover\\:border-indigo-500 {
  --border-opacity: 1;
  border-color: #6875f5;
  border-color: rgba(104, 117, 245, var(--border-opacity));
}
.group:hover .group-hover\\:border-indigo-600 {
  --border-opacity: 1;
  border-color: #5850ec;
  border-color: rgba(88, 80, 236, var(--border-opacity));
}
.group:hover .group-hover\\:border-indigo-700 {
  --border-opacity: 1;
  border-color: #5145cd;
  border-color: rgba(81, 69, 205, var(--border-opacity));
}
.group:hover .group-hover\\:border-indigo-800 {
  --border-opacity: 1;
  border-color: #42389d;
  border-color: rgba(66, 56, 157, var(--border-opacity));
}
.group:hover .group-hover\\:border-indigo-900 {
  --border-opacity: 1;
  border-color: #362f78;
  border-color: rgba(54, 47, 120, var(--border-opacity));
}
.group:hover .group-hover\\:border-purple-50 {
  --border-opacity: 1;
  border-color: #f6f5ff;
  border-color: rgba(246, 245, 255, var(--border-opacity));
}
.group:hover .group-hover\\:border-purple-100 {
  --border-opacity: 1;
  border-color: #edebfe;
  border-color: rgba(237, 235, 254, var(--border-opacity));
}
.group:hover .group-hover\\:border-purple-200 {
  --border-opacity: 1;
  border-color: #dcd7fe;
  border-color: rgba(220, 215, 254, var(--border-opacity));
}
.group:hover .group-hover\\:border-purple-300 {
  --border-opacity: 1;
  border-color: #cabffd;
  border-color: rgba(202, 191, 253, var(--border-opacity));
}
.group:hover .group-hover\\:border-purple-400 {
  --border-opacity: 1;
  border-color: #ac94fa;
  border-color: rgba(172, 148, 250, var(--border-opacity));
}
.group:hover .group-hover\\:border-purple-500 {
  --border-opacity: 1;
  border-color: #9061f9;
  border-color: rgba(144, 97, 249, var(--border-opacity));
}
.group:hover .group-hover\\:border-purple-600 {
  --border-opacity: 1;
  border-color: #7e3af2;
  border-color: rgba(126, 58, 242, var(--border-opacity));
}
.group:hover .group-hover\\:border-purple-700 {
  --border-opacity: 1;
  border-color: #6c2bd9;
  border-color: rgba(108, 43, 217, var(--border-opacity));
}
.group:hover .group-hover\\:border-purple-800 {
  --border-opacity: 1;
  border-color: #5521b5;
  border-color: rgba(85, 33, 181, var(--border-opacity));
}
.group:hover .group-hover\\:border-purple-900 {
  --border-opacity: 1;
  border-color: #4a1d96;
  border-color: rgba(74, 29, 150, var(--border-opacity));
}
.group:hover .group-hover\\:border-pink-50 {
  --border-opacity: 1;
  border-color: #fdf2f8;
  border-color: rgba(253, 242, 248, var(--border-opacity));
}
.group:hover .group-hover\\:border-pink-100 {
  --border-opacity: 1;
  border-color: #fce8f3;
  border-color: rgba(252, 232, 243, var(--border-opacity));
}
.group:hover .group-hover\\:border-pink-200 {
  --border-opacity: 1;
  border-color: #fad1e8;
  border-color: rgba(250, 209, 232, var(--border-opacity));
}
.group:hover .group-hover\\:border-pink-300 {
  --border-opacity: 1;
  border-color: #f8b4d9;
  border-color: rgba(248, 180, 217, var(--border-opacity));
}
.group:hover .group-hover\\:border-pink-400 {
  --border-opacity: 1;
  border-color: #f17eb8;
  border-color: rgba(241, 126, 184, var(--border-opacity));
}
.group:hover .group-hover\\:border-pink-500 {
  --border-opacity: 1;
  border-color: #e74694;
  border-color: rgba(231, 70, 148, var(--border-opacity));
}
.group:hover .group-hover\\:border-pink-600 {
  --border-opacity: 1;
  border-color: #d61f69;
  border-color: rgba(214, 31, 105, var(--border-opacity));
}
.group:hover .group-hover\\:border-pink-700 {
  --border-opacity: 1;
  border-color: #bf125d;
  border-color: rgba(191, 18, 93, var(--border-opacity));
}
.group:hover .group-hover\\:border-pink-800 {
  --border-opacity: 1;
  border-color: #99154b;
  border-color: rgba(153, 21, 75, var(--border-opacity));
}
.group:hover .group-hover\\:border-pink-900 {
  --border-opacity: 1;
  border-color: #751a3d;
  border-color: rgba(117, 26, 61, var(--border-opacity));
}
.group:hover .group-hover\\:border-cool-gray-50 {
  --border-opacity: 1;
  border-color: #f8fafc;
  border-color: rgba(248, 250, 252, var(--border-opacity));
}
.group:hover .group-hover\\:border-cool-gray-100 {
  --border-opacity: 1;
  border-color: #f1f5f9;
  border-color: rgba(241, 245, 249, var(--border-opacity));
}
.group:hover .group-hover\\:border-cool-gray-200 {
  --border-opacity: 1;
  border-color: #e2e8f0;
  border-color: rgba(226, 232, 240, var(--border-opacity));
}
.group:hover .group-hover\\:border-cool-gray-300 {
  --border-opacity: 1;
  border-color: #cfd8e3;
  border-color: rgba(207, 216, 227, var(--border-opacity));
}
.group:hover .group-hover\\:border-cool-gray-400 {
  --border-opacity: 1;
  border-color: #97a6ba;
  border-color: rgba(151, 166, 186, var(--border-opacity));
}
.group:hover .group-hover\\:border-cool-gray-500 {
  --border-opacity: 1;
  border-color: #64748b;
  border-color: rgba(100, 116, 139, var(--border-opacity));
}
.group:hover .group-hover\\:border-cool-gray-600 {
  --border-opacity: 1;
  border-color: #475569;
  border-color: rgba(71, 85, 105, var(--border-opacity));
}
.group:hover .group-hover\\:border-cool-gray-700 {
  --border-opacity: 1;
  border-color: #364152;
  border-color: rgba(54, 65, 82, var(--border-opacity));
}
.group:hover .group-hover\\:border-cool-gray-800 {
  --border-opacity: 1;
  border-color: #27303f;
  border-color: rgba(39, 48, 63, var(--border-opacity));
}
.group:hover .group-hover\\:border-cool-gray-900 {
  --border-opacity: 1;
  border-color: #1a202e;
  border-color: rgba(26, 32, 46, var(--border-opacity));
}
.group:focus .group-focus\\:border-current {
  border-color: currentColor;
}
.group:focus .group-focus\\:border-transparent {
  border-color: transparent;
}
.group:focus .group-focus\\:border-white {
  --border-opacity: 1;
  border-color: #ffffff;
  border-color: rgba(255, 255, 255, var(--border-opacity));
}
.group:focus .group-focus\\:border-black {
  --border-opacity: 1;
  border-color: #000000;
  border-color: rgba(0, 0, 0, var(--border-opacity));
}
.group:focus .group-focus\\:border-gray-50 {
  --border-opacity: 1;
  border-color: #f9fafb;
  border-color: rgba(249, 250, 251, var(--border-opacity));
}
.group:focus .group-focus\\:border-gray-100 {
  --border-opacity: 1;
  border-color: #f4f5f7;
  border-color: rgba(244, 245, 247, var(--border-opacity));
}
.group:focus .group-focus\\:border-gray-200 {
  --border-opacity: 1;
  border-color: #e5e7eb;
  border-color: rgba(229, 231, 235, var(--border-opacity));
}
.group:focus .group-focus\\:border-gray-300 {
  --border-opacity: 1;
  border-color: #d2d6dc;
  border-color: rgba(210, 214, 220, var(--border-opacity));
}
.group:focus .group-focus\\:border-gray-400 {
  --border-opacity: 1;
  border-color: #9fa6b2;
  border-color: rgba(159, 166, 178, var(--border-opacity));
}
.group:focus .group-focus\\:border-gray-500 {
  --border-opacity: 1;
  border-color: #6b7280;
  border-color: rgba(107, 114, 128, var(--border-opacity));
}
.group:focus .group-focus\\:border-gray-600 {
  --border-opacity: 1;
  border-color: #4b5563;
  border-color: rgba(75, 85, 99, var(--border-opacity));
}
.group:focus .group-focus\\:border-gray-700 {
  --border-opacity: 1;
  border-color: #374151;
  border-color: rgba(55, 65, 81, var(--border-opacity));
}
.group:focus .group-focus\\:border-gray-800 {
  --border-opacity: 1;
  border-color: #252f3f;
  border-color: rgba(37, 47, 63, var(--border-opacity));
}
.group:focus .group-focus\\:border-gray-900 {
  --border-opacity: 1;
  border-color: #161e2e;
  border-color: rgba(22, 30, 46, var(--border-opacity));
}
.group:focus .group-focus\\:border-red-50 {
  --border-opacity: 1;
  border-color: #fdf2f2;
  border-color: rgba(253, 242, 242, var(--border-opacity));
}
.group:focus .group-focus\\:border-red-100 {
  --border-opacity: 1;
  border-color: #fde8e8;
  border-color: rgba(253, 232, 232, var(--border-opacity));
}
.group:focus .group-focus\\:border-red-200 {
  --border-opacity: 1;
  border-color: #fbd5d5;
  border-color: rgba(251, 213, 213, var(--border-opacity));
}
.group:focus .group-focus\\:border-red-300 {
  --border-opacity: 1;
  border-color: #f8b4b4;
  border-color: rgba(248, 180, 180, var(--border-opacity));
}
.group:focus .group-focus\\:border-red-400 {
  --border-opacity: 1;
  border-color: #f98080;
  border-color: rgba(249, 128, 128, var(--border-opacity));
}
.group:focus .group-focus\\:border-red-500 {
  --border-opacity: 1;
  border-color: #f05252;
  border-color: rgba(240, 82, 82, var(--border-opacity));
}
.group:focus .group-focus\\:border-red-600 {
  --border-opacity: 1;
  border-color: #e02424;
  border-color: rgba(224, 36, 36, var(--border-opacity));
}
.group:focus .group-focus\\:border-red-700 {
  --border-opacity: 1;
  border-color: #c81e1e;
  border-color: rgba(200, 30, 30, var(--border-opacity));
}
.group:focus .group-focus\\:border-red-800 {
  --border-opacity: 1;
  border-color: #9b1c1c;
  border-color: rgba(155, 28, 28, var(--border-opacity));
}
.group:focus .group-focus\\:border-red-900 {
  --border-opacity: 1;
  border-color: #771d1d;
  border-color: rgba(119, 29, 29, var(--border-opacity));
}
.group:focus .group-focus\\:border-orange-50 {
  --border-opacity: 1;
  border-color: #fff8f1;
  border-color: rgba(255, 248, 241, var(--border-opacity));
}
.group:focus .group-focus\\:border-orange-100 {
  --border-opacity: 1;
  border-color: #feecdc;
  border-color: rgba(254, 236, 220, var(--border-opacity));
}
.group:focus .group-focus\\:border-orange-200 {
  --border-opacity: 1;
  border-color: #fcd9bd;
  border-color: rgba(252, 217, 189, var(--border-opacity));
}
.group:focus .group-focus\\:border-orange-300 {
  --border-opacity: 1;
  border-color: #fdba8c;
  border-color: rgba(253, 186, 140, var(--border-opacity));
}
.group:focus .group-focus\\:border-orange-400 {
  --border-opacity: 1;
  border-color: #ff8a4c;
  border-color: rgba(255, 138, 76, var(--border-opacity));
}
.group:focus .group-focus\\:border-orange-500 {
  --border-opacity: 1;
  border-color: #ff5a1f;
  border-color: rgba(255, 90, 31, var(--border-opacity));
}
.group:focus .group-focus\\:border-orange-600 {
  --border-opacity: 1;
  border-color: #d03801;
  border-color: rgba(208, 56, 1, var(--border-opacity));
}
.group:focus .group-focus\\:border-orange-700 {
  --border-opacity: 1;
  border-color: #b43403;
  border-color: rgba(180, 52, 3, var(--border-opacity));
}
.group:focus .group-focus\\:border-orange-800 {
  --border-opacity: 1;
  border-color: #8a2c0d;
  border-color: rgba(138, 44, 13, var(--border-opacity));
}
.group:focus .group-focus\\:border-orange-900 {
  --border-opacity: 1;
  border-color: #73230d;
  border-color: rgba(115, 35, 13, var(--border-opacity));
}
.group:focus .group-focus\\:border-yellow-50 {
  --border-opacity: 1;
  border-color: #fdfdea;
  border-color: rgba(253, 253, 234, var(--border-opacity));
}
.group:focus .group-focus\\:border-yellow-100 {
  --border-opacity: 1;
  border-color: #fdf6b2;
  border-color: rgba(253, 246, 178, var(--border-opacity));
}
.group:focus .group-focus\\:border-yellow-200 {
  --border-opacity: 1;
  border-color: #fce96a;
  border-color: rgba(252, 233, 106, var(--border-opacity));
}
.group:focus .group-focus\\:border-yellow-300 {
  --border-opacity: 1;
  border-color: #faca15;
  border-color: rgba(250, 202, 21, var(--border-opacity));
}
.group:focus .group-focus\\:border-yellow-400 {
  --border-opacity: 1;
  border-color: #e3a008;
  border-color: rgba(227, 160, 8, var(--border-opacity));
}
.group:focus .group-focus\\:border-yellow-500 {
  --border-opacity: 1;
  border-color: #c27803;
  border-color: rgba(194, 120, 3, var(--border-opacity));
}
.group:focus .group-focus\\:border-yellow-600 {
  --border-opacity: 1;
  border-color: #9f580a;
  border-color: rgba(159, 88, 10, var(--border-opacity));
}
.group:focus .group-focus\\:border-yellow-700 {
  --border-opacity: 1;
  border-color: #8e4b10;
  border-color: rgba(142, 75, 16, var(--border-opacity));
}
.group:focus .group-focus\\:border-yellow-800 {
  --border-opacity: 1;
  border-color: #723b13;
  border-color: rgba(114, 59, 19, var(--border-opacity));
}
.group:focus .group-focus\\:border-yellow-900 {
  --border-opacity: 1;
  border-color: #633112;
  border-color: rgba(99, 49, 18, var(--border-opacity));
}
.group:focus .group-focus\\:border-green-50 {
  --border-opacity: 1;
  border-color: #f3faf7;
  border-color: rgba(243, 250, 247, var(--border-opacity));
}
.group:focus .group-focus\\:border-green-100 {
  --border-opacity: 1;
  border-color: #def7ec;
  border-color: rgba(222, 247, 236, var(--border-opacity));
}
.group:focus .group-focus\\:border-green-200 {
  --border-opacity: 1;
  border-color: #bcf0da;
  border-color: rgba(188, 240, 218, var(--border-opacity));
}
.group:focus .group-focus\\:border-green-300 {
  --border-opacity: 1;
  border-color: #84e1bc;
  border-color: rgba(132, 225, 188, var(--border-opacity));
}
.group:focus .group-focus\\:border-green-400 {
  --border-opacity: 1;
  border-color: #31c48d;
  border-color: rgba(49, 196, 141, var(--border-opacity));
}
.group:focus .group-focus\\:border-green-500 {
  --border-opacity: 1;
  border-color: #0e9f6e;
  border-color: rgba(14, 159, 110, var(--border-opacity));
}
.group:focus .group-focus\\:border-green-600 {
  --border-opacity: 1;
  border-color: #057a55;
  border-color: rgba(5, 122, 85, var(--border-opacity));
}
.group:focus .group-focus\\:border-green-700 {
  --border-opacity: 1;
  border-color: #046c4e;
  border-color: rgba(4, 108, 78, var(--border-opacity));
}
.group:focus .group-focus\\:border-green-800 {
  --border-opacity: 1;
  border-color: #03543f;
  border-color: rgba(3, 84, 63, var(--border-opacity));
}
.group:focus .group-focus\\:border-green-900 {
  --border-opacity: 1;
  border-color: #014737;
  border-color: rgba(1, 71, 55, var(--border-opacity));
}
.group:focus .group-focus\\:border-teal-50 {
  --border-opacity: 1;
  border-color: #edfafa;
  border-color: rgba(237, 250, 250, var(--border-opacity));
}
.group:focus .group-focus\\:border-teal-100 {
  --border-opacity: 1;
  border-color: #d5f5f6;
  border-color: rgba(213, 245, 246, var(--border-opacity));
}
.group:focus .group-focus\\:border-teal-200 {
  --border-opacity: 1;
  border-color: #afecef;
  border-color: rgba(175, 236, 239, var(--border-opacity));
}
.group:focus .group-focus\\:border-teal-300 {
  --border-opacity: 1;
  border-color: #7edce2;
  border-color: rgba(126, 220, 226, var(--border-opacity));
}
.group:focus .group-focus\\:border-teal-400 {
  --border-opacity: 1;
  border-color: #16bdca;
  border-color: rgba(22, 189, 202, var(--border-opacity));
}
.group:focus .group-focus\\:border-teal-500 {
  --border-opacity: 1;
  border-color: #0694a2;
  border-color: rgba(6, 148, 162, var(--border-opacity));
}
.group:focus .group-focus\\:border-teal-600 {
  --border-opacity: 1;
  border-color: #047481;
  border-color: rgba(4, 116, 129, var(--border-opacity));
}
.group:focus .group-focus\\:border-teal-700 {
  --border-opacity: 1;
  border-color: #036672;
  border-color: rgba(3, 102, 114, var(--border-opacity));
}
.group:focus .group-focus\\:border-teal-800 {
  --border-opacity: 1;
  border-color: #05505c;
  border-color: rgba(5, 80, 92, var(--border-opacity));
}
.group:focus .group-focus\\:border-teal-900 {
  --border-opacity: 1;
  border-color: #014451;
  border-color: rgba(1, 68, 81, var(--border-opacity));
}
.group:focus .group-focus\\:border-blue-50 {
  --border-opacity: 1;
  border-color: #ebf5ff;
  border-color: rgba(235, 245, 255, var(--border-opacity));
}
.group:focus .group-focus\\:border-blue-100 {
  --border-opacity: 1;
  border-color: #e1effe;
  border-color: rgba(225, 239, 254, var(--border-opacity));
}
.group:focus .group-focus\\:border-blue-200 {
  --border-opacity: 1;
  border-color: #c3ddfd;
  border-color: rgba(195, 221, 253, var(--border-opacity));
}
.group:focus .group-focus\\:border-blue-300 {
  --border-opacity: 1;
  border-color: #a4cafe;
  border-color: rgba(164, 202, 254, var(--border-opacity));
}
.group:focus .group-focus\\:border-blue-400 {
  --border-opacity: 1;
  border-color: #76a9fa;
  border-color: rgba(118, 169, 250, var(--border-opacity));
}
.group:focus .group-focus\\:border-blue-500 {
  --border-opacity: 1;
  border-color: #3f83f8;
  border-color: rgba(63, 131, 248, var(--border-opacity));
}
.group:focus .group-focus\\:border-blue-600 {
  --border-opacity: 1;
  border-color: #1c64f2;
  border-color: rgba(28, 100, 242, var(--border-opacity));
}
.group:focus .group-focus\\:border-blue-700 {
  --border-opacity: 1;
  border-color: #1a56db;
  border-color: rgba(26, 86, 219, var(--border-opacity));
}
.group:focus .group-focus\\:border-blue-800 {
  --border-opacity: 1;
  border-color: #1e429f;
  border-color: rgba(30, 66, 159, var(--border-opacity));
}
.group:focus .group-focus\\:border-blue-900 {
  --border-opacity: 1;
  border-color: #233876;
  border-color: rgba(35, 56, 118, var(--border-opacity));
}
.group:focus .group-focus\\:border-indigo-50 {
  --border-opacity: 1;
  border-color: #f0f5ff;
  border-color: rgba(240, 245, 255, var(--border-opacity));
}
.group:focus .group-focus\\:border-indigo-100 {
  --border-opacity: 1;
  border-color: #e5edff;
  border-color: rgba(229, 237, 255, var(--border-opacity));
}
.group:focus .group-focus\\:border-indigo-200 {
  --border-opacity: 1;
  border-color: #cddbfe;
  border-color: rgba(205, 219, 254, var(--border-opacity));
}
.group:focus .group-focus\\:border-indigo-300 {
  --border-opacity: 1;
  border-color: #b4c6fc;
  border-color: rgba(180, 198, 252, var(--border-opacity));
}
.group:focus .group-focus\\:border-indigo-400 {
  --border-opacity: 1;
  border-color: #8da2fb;
  border-color: rgba(141, 162, 251, var(--border-opacity));
}
.group:focus .group-focus\\:border-indigo-500 {
  --border-opacity: 1;
  border-color: #6875f5;
  border-color: rgba(104, 117, 245, var(--border-opacity));
}
.group:focus .group-focus\\:border-indigo-600 {
  --border-opacity: 1;
  border-color: #5850ec;
  border-color: rgba(88, 80, 236, var(--border-opacity));
}
.group:focus .group-focus\\:border-indigo-700 {
  --border-opacity: 1;
  border-color: #5145cd;
  border-color: rgba(81, 69, 205, var(--border-opacity));
}
.group:focus .group-focus\\:border-indigo-800 {
  --border-opacity: 1;
  border-color: #42389d;
  border-color: rgba(66, 56, 157, var(--border-opacity));
}
.group:focus .group-focus\\:border-indigo-900 {
  --border-opacity: 1;
  border-color: #362f78;
  border-color: rgba(54, 47, 120, var(--border-opacity));
}
.group:focus .group-focus\\:border-purple-50 {
  --border-opacity: 1;
  border-color: #f6f5ff;
  border-color: rgba(246, 245, 255, var(--border-opacity));
}
.group:focus .group-focus\\:border-purple-100 {
  --border-opacity: 1;
  border-color: #edebfe;
  border-color: rgba(237, 235, 254, var(--border-opacity));
}
.group:focus .group-focus\\:border-purple-200 {
  --border-opacity: 1;
  border-color: #dcd7fe;
  border-color: rgba(220, 215, 254, var(--border-opacity));
}
.group:focus .group-focus\\:border-purple-300 {
  --border-opacity: 1;
  border-color: #cabffd;
  border-color: rgba(202, 191, 253, var(--border-opacity));
}
.group:focus .group-focus\\:border-purple-400 {
  --border-opacity: 1;
  border-color: #ac94fa;
  border-color: rgba(172, 148, 250, var(--border-opacity));
}
.group:focus .group-focus\\:border-purple-500 {
  --border-opacity: 1;
  border-color: #9061f9;
  border-color: rgba(144, 97, 249, var(--border-opacity));
}
.group:focus .group-focus\\:border-purple-600 {
  --border-opacity: 1;
  border-color: #7e3af2;
  border-color: rgba(126, 58, 242, var(--border-opacity));
}
.group:focus .group-focus\\:border-purple-700 {
  --border-opacity: 1;
  border-color: #6c2bd9;
  border-color: rgba(108, 43, 217, var(--border-opacity));
}
.group:focus .group-focus\\:border-purple-800 {
  --border-opacity: 1;
  border-color: #5521b5;
  border-color: rgba(85, 33, 181, var(--border-opacity));
}
.group:focus .group-focus\\:border-purple-900 {
  --border-opacity: 1;
  border-color: #4a1d96;
  border-color: rgba(74, 29, 150, var(--border-opacity));
}
.group:focus .group-focus\\:border-pink-50 {
  --border-opacity: 1;
  border-color: #fdf2f8;
  border-color: rgba(253, 242, 248, var(--border-opacity));
}
.group:focus .group-focus\\:border-pink-100 {
  --border-opacity: 1;
  border-color: #fce8f3;
  border-color: rgba(252, 232, 243, var(--border-opacity));
}
.group:focus .group-focus\\:border-pink-200 {
  --border-opacity: 1;
  border-color: #fad1e8;
  border-color: rgba(250, 209, 232, var(--border-opacity));
}
.group:focus .group-focus\\:border-pink-300 {
  --border-opacity: 1;
  border-color: #f8b4d9;
  border-color: rgba(248, 180, 217, var(--border-opacity));
}
.group:focus .group-focus\\:border-pink-400 {
  --border-opacity: 1;
  border-color: #f17eb8;
  border-color: rgba(241, 126, 184, var(--border-opacity));
}
.group:focus .group-focus\\:border-pink-500 {
  --border-opacity: 1;
  border-color: #e74694;
  border-color: rgba(231, 70, 148, var(--border-opacity));
}
.group:focus .group-focus\\:border-pink-600 {
  --border-opacity: 1;
  border-color: #d61f69;
  border-color: rgba(214, 31, 105, var(--border-opacity));
}
.group:focus .group-focus\\:border-pink-700 {
  --border-opacity: 1;
  border-color: #bf125d;
  border-color: rgba(191, 18, 93, var(--border-opacity));
}
.group:focus .group-focus\\:border-pink-800 {
  --border-opacity: 1;
  border-color: #99154b;
  border-color: rgba(153, 21, 75, var(--border-opacity));
}
.group:focus .group-focus\\:border-pink-900 {
  --border-opacity: 1;
  border-color: #751a3d;
  border-color: rgba(117, 26, 61, var(--border-opacity));
}
.group:focus .group-focus\\:border-cool-gray-50 {
  --border-opacity: 1;
  border-color: #f8fafc;
  border-color: rgba(248, 250, 252, var(--border-opacity));
}
.group:focus .group-focus\\:border-cool-gray-100 {
  --border-opacity: 1;
  border-color: #f1f5f9;
  border-color: rgba(241, 245, 249, var(--border-opacity));
}
.group:focus .group-focus\\:border-cool-gray-200 {
  --border-opacity: 1;
  border-color: #e2e8f0;
  border-color: rgba(226, 232, 240, var(--border-opacity));
}
.group:focus .group-focus\\:border-cool-gray-300 {
  --border-opacity: 1;
  border-color: #cfd8e3;
  border-color: rgba(207, 216, 227, var(--border-opacity));
}
.group:focus .group-focus\\:border-cool-gray-400 {
  --border-opacity: 1;
  border-color: #97a6ba;
  border-color: rgba(151, 166, 186, var(--border-opacity));
}
.group:focus .group-focus\\:border-cool-gray-500 {
  --border-opacity: 1;
  border-color: #64748b;
  border-color: rgba(100, 116, 139, var(--border-opacity));
}
.group:focus .group-focus\\:border-cool-gray-600 {
  --border-opacity: 1;
  border-color: #475569;
  border-color: rgba(71, 85, 105, var(--border-opacity));
}
.group:focus .group-focus\\:border-cool-gray-700 {
  --border-opacity: 1;
  border-color: #364152;
  border-color: rgba(54, 65, 82, var(--border-opacity));
}
.group:focus .group-focus\\:border-cool-gray-800 {
  --border-opacity: 1;
  border-color: #27303f;
  border-color: rgba(39, 48, 63, var(--border-opacity));
}
.group:focus .group-focus\\:border-cool-gray-900 {
  --border-opacity: 1;
  border-color: #1a202e;
  border-color: rgba(26, 32, 46, var(--border-opacity));
}
.hover\\:border-current:hover {
  border-color: currentColor;
}
.hover\\:border-transparent:hover {
  border-color: transparent;
}
.hover\\:border-white:hover {
  --border-opacity: 1;
  border-color: #ffffff;
  border-color: rgba(255, 255, 255, var(--border-opacity));
}
.hover\\:border-black:hover {
  --border-opacity: 1;
  border-color: #000000;
  border-color: rgba(0, 0, 0, var(--border-opacity));
}
.hover\\:border-gray-50:hover {
  --border-opacity: 1;
  border-color: #f9fafb;
  border-color: rgba(249, 250, 251, var(--border-opacity));
}
.hover\\:border-gray-100:hover {
  --border-opacity: 1;
  border-color: #f4f5f7;
  border-color: rgba(244, 245, 247, var(--border-opacity));
}
.hover\\:border-gray-200:hover {
  --border-opacity: 1;
  border-color: #e5e7eb;
  border-color: rgba(229, 231, 235, var(--border-opacity));
}
.hover\\:border-gray-300:hover {
  --border-opacity: 1;
  border-color: #d2d6dc;
  border-color: rgba(210, 214, 220, var(--border-opacity));
}
.hover\\:border-gray-400:hover {
  --border-opacity: 1;
  border-color: #9fa6b2;
  border-color: rgba(159, 166, 178, var(--border-opacity));
}
.hover\\:border-gray-500:hover {
  --border-opacity: 1;
  border-color: #6b7280;
  border-color: rgba(107, 114, 128, var(--border-opacity));
}
.hover\\:border-gray-600:hover {
  --border-opacity: 1;
  border-color: #4b5563;
  border-color: rgba(75, 85, 99, var(--border-opacity));
}
.hover\\:border-gray-700:hover {
  --border-opacity: 1;
  border-color: #374151;
  border-color: rgba(55, 65, 81, var(--border-opacity));
}
.hover\\:border-gray-800:hover {
  --border-opacity: 1;
  border-color: #252f3f;
  border-color: rgba(37, 47, 63, var(--border-opacity));
}
.hover\\:border-gray-900:hover {
  --border-opacity: 1;
  border-color: #161e2e;
  border-color: rgba(22, 30, 46, var(--border-opacity));
}
.hover\\:border-red-50:hover {
  --border-opacity: 1;
  border-color: #fdf2f2;
  border-color: rgba(253, 242, 242, var(--border-opacity));
}
.hover\\:border-red-100:hover {
  --border-opacity: 1;
  border-color: #fde8e8;
  border-color: rgba(253, 232, 232, var(--border-opacity));
}
.hover\\:border-red-200:hover {
  --border-opacity: 1;
  border-color: #fbd5d5;
  border-color: rgba(251, 213, 213, var(--border-opacity));
}
.hover\\:border-red-300:hover {
  --border-opacity: 1;
  border-color: #f8b4b4;
  border-color: rgba(248, 180, 180, var(--border-opacity));
}
.hover\\:border-red-400:hover {
  --border-opacity: 1;
  border-color: #f98080;
  border-color: rgba(249, 128, 128, var(--border-opacity));
}
.hover\\:border-red-500:hover {
  --border-opacity: 1;
  border-color: #f05252;
  border-color: rgba(240, 82, 82, var(--border-opacity));
}
.hover\\:border-red-600:hover {
  --border-opacity: 1;
  border-color: #e02424;
  border-color: rgba(224, 36, 36, var(--border-opacity));
}
.hover\\:border-red-700:hover {
  --border-opacity: 1;
  border-color: #c81e1e;
  border-color: rgba(200, 30, 30, var(--border-opacity));
}
.hover\\:border-red-800:hover {
  --border-opacity: 1;
  border-color: #9b1c1c;
  border-color: rgba(155, 28, 28, var(--border-opacity));
}
.hover\\:border-red-900:hover {
  --border-opacity: 1;
  border-color: #771d1d;
  border-color: rgba(119, 29, 29, var(--border-opacity));
}
.hover\\:border-orange-50:hover {
  --border-opacity: 1;
  border-color: #fff8f1;
  border-color: rgba(255, 248, 241, var(--border-opacity));
}
.hover\\:border-orange-100:hover {
  --border-opacity: 1;
  border-color: #feecdc;
  border-color: rgba(254, 236, 220, var(--border-opacity));
}
.hover\\:border-orange-200:hover {
  --border-opacity: 1;
  border-color: #fcd9bd;
  border-color: rgba(252, 217, 189, var(--border-opacity));
}
.hover\\:border-orange-300:hover {
  --border-opacity: 1;
  border-color: #fdba8c;
  border-color: rgba(253, 186, 140, var(--border-opacity));
}
.hover\\:border-orange-400:hover {
  --border-opacity: 1;
  border-color: #ff8a4c;
  border-color: rgba(255, 138, 76, var(--border-opacity));
}
.hover\\:border-orange-500:hover {
  --border-opacity: 1;
  border-color: #ff5a1f;
  border-color: rgba(255, 90, 31, var(--border-opacity));
}
.hover\\:border-orange-600:hover {
  --border-opacity: 1;
  border-color: #d03801;
  border-color: rgba(208, 56, 1, var(--border-opacity));
}
.hover\\:border-orange-700:hover {
  --border-opacity: 1;
  border-color: #b43403;
  border-color: rgba(180, 52, 3, var(--border-opacity));
}
.hover\\:border-orange-800:hover {
  --border-opacity: 1;
  border-color: #8a2c0d;
  border-color: rgba(138, 44, 13, var(--border-opacity));
}
.hover\\:border-orange-900:hover {
  --border-opacity: 1;
  border-color: #73230d;
  border-color: rgba(115, 35, 13, var(--border-opacity));
}
.hover\\:border-yellow-50:hover {
  --border-opacity: 1;
  border-color: #fdfdea;
  border-color: rgba(253, 253, 234, var(--border-opacity));
}
.hover\\:border-yellow-100:hover {
  --border-opacity: 1;
  border-color: #fdf6b2;
  border-color: rgba(253, 246, 178, var(--border-opacity));
}
.hover\\:border-yellow-200:hover {
  --border-opacity: 1;
  border-color: #fce96a;
  border-color: rgba(252, 233, 106, var(--border-opacity));
}
.hover\\:border-yellow-300:hover {
  --border-opacity: 1;
  border-color: #faca15;
  border-color: rgba(250, 202, 21, var(--border-opacity));
}
.hover\\:border-yellow-400:hover {
  --border-opacity: 1;
  border-color: #e3a008;
  border-color: rgba(227, 160, 8, var(--border-opacity));
}
.hover\\:border-yellow-500:hover {
  --border-opacity: 1;
  border-color: #c27803;
  border-color: rgba(194, 120, 3, var(--border-opacity));
}
.hover\\:border-yellow-600:hover {
  --border-opacity: 1;
  border-color: #9f580a;
  border-color: rgba(159, 88, 10, var(--border-opacity));
}
.hover\\:border-yellow-700:hover {
  --border-opacity: 1;
  border-color: #8e4b10;
  border-color: rgba(142, 75, 16, var(--border-opacity));
}
.hover\\:border-yellow-800:hover {
  --border-opacity: 1;
  border-color: #723b13;
  border-color: rgba(114, 59, 19, var(--border-opacity));
}
.hover\\:border-yellow-900:hover {
  --border-opacity: 1;
  border-color: #633112;
  border-color: rgba(99, 49, 18, var(--border-opacity));
}
.hover\\:border-green-50:hover {
  --border-opacity: 1;
  border-color: #f3faf7;
  border-color: rgba(243, 250, 247, var(--border-opacity));
}
.hover\\:border-green-100:hover {
  --border-opacity: 1;
  border-color: #def7ec;
  border-color: rgba(222, 247, 236, var(--border-opacity));
}
.hover\\:border-green-200:hover {
  --border-opacity: 1;
  border-color: #bcf0da;
  border-color: rgba(188, 240, 218, var(--border-opacity));
}
.hover\\:border-green-300:hover {
  --border-opacity: 1;
  border-color: #84e1bc;
  border-color: rgba(132, 225, 188, var(--border-opacity));
}
.hover\\:border-green-400:hover {
  --border-opacity: 1;
  border-color: #31c48d;
  border-color: rgba(49, 196, 141, var(--border-opacity));
}
.hover\\:border-green-500:hover {
  --border-opacity: 1;
  border-color: #0e9f6e;
  border-color: rgba(14, 159, 110, var(--border-opacity));
}
.hover\\:border-green-600:hover {
  --border-opacity: 1;
  border-color: #057a55;
  border-color: rgba(5, 122, 85, var(--border-opacity));
}
.hover\\:border-green-700:hover {
  --border-opacity: 1;
  border-color: #046c4e;
  border-color: rgba(4, 108, 78, var(--border-opacity));
}
.hover\\:border-green-800:hover {
  --border-opacity: 1;
  border-color: #03543f;
  border-color: rgba(3, 84, 63, var(--border-opacity));
}
.hover\\:border-green-900:hover {
  --border-opacity: 1;
  border-color: #014737;
  border-color: rgba(1, 71, 55, var(--border-opacity));
}
.hover\\:border-teal-50:hover {
  --border-opacity: 1;
  border-color: #edfafa;
  border-color: rgba(237, 250, 250, var(--border-opacity));
}
.hover\\:border-teal-100:hover {
  --border-opacity: 1;
  border-color: #d5f5f6;
  border-color: rgba(213, 245, 246, var(--border-opacity));
}
.hover\\:border-teal-200:hover {
  --border-opacity: 1;
  border-color: #afecef;
  border-color: rgba(175, 236, 239, var(--border-opacity));
}
.hover\\:border-teal-300:hover {
  --border-opacity: 1;
  border-color: #7edce2;
  border-color: rgba(126, 220, 226, var(--border-opacity));
}
.hover\\:border-teal-400:hover {
  --border-opacity: 1;
  border-color: #16bdca;
  border-color: rgba(22, 189, 202, var(--border-opacity));
}
.hover\\:border-teal-500:hover {
  --border-opacity: 1;
  border-color: #0694a2;
  border-color: rgba(6, 148, 162, var(--border-opacity));
}
.hover\\:border-teal-600:hover {
  --border-opacity: 1;
  border-color: #047481;
  border-color: rgba(4, 116, 129, var(--border-opacity));
}
.hover\\:border-teal-700:hover {
  --border-opacity: 1;
  border-color: #036672;
  border-color: rgba(3, 102, 114, var(--border-opacity));
}
.hover\\:border-teal-800:hover {
  --border-opacity: 1;
  border-color: #05505c;
  border-color: rgba(5, 80, 92, var(--border-opacity));
}
.hover\\:border-teal-900:hover {
  --border-opacity: 1;
  border-color: #014451;
  border-color: rgba(1, 68, 81, var(--border-opacity));
}
.hover\\:border-blue-50:hover {
  --border-opacity: 1;
  border-color: #ebf5ff;
  border-color: rgba(235, 245, 255, var(--border-opacity));
}
.hover\\:border-blue-100:hover {
  --border-opacity: 1;
  border-color: #e1effe;
  border-color: rgba(225, 239, 254, var(--border-opacity));
}
.hover\\:border-blue-200:hover {
  --border-opacity: 1;
  border-color: #c3ddfd;
  border-color: rgba(195, 221, 253, var(--border-opacity));
}
.hover\\:border-blue-300:hover {
  --border-opacity: 1;
  border-color: #a4cafe;
  border-color: rgba(164, 202, 254, var(--border-opacity));
}
.hover\\:border-blue-400:hover {
  --border-opacity: 1;
  border-color: #76a9fa;
  border-color: rgba(118, 169, 250, var(--border-opacity));
}
.hover\\:border-blue-500:hover {
  --border-opacity: 1;
  border-color: #3f83f8;
  border-color: rgba(63, 131, 248, var(--border-opacity));
}
.hover\\:border-blue-600:hover {
  --border-opacity: 1;
  border-color: #1c64f2;
  border-color: rgba(28, 100, 242, var(--border-opacity));
}
.hover\\:border-blue-700:hover {
  --border-opacity: 1;
  border-color: #1a56db;
  border-color: rgba(26, 86, 219, var(--border-opacity));
}
.hover\\:border-blue-800:hover {
  --border-opacity: 1;
  border-color: #1e429f;
  border-color: rgba(30, 66, 159, var(--border-opacity));
}
.hover\\:border-blue-900:hover {
  --border-opacity: 1;
  border-color: #233876;
  border-color: rgba(35, 56, 118, var(--border-opacity));
}
.hover\\:border-indigo-50:hover {
  --border-opacity: 1;
  border-color: #f0f5ff;
  border-color: rgba(240, 245, 255, var(--border-opacity));
}
.hover\\:border-indigo-100:hover {
  --border-opacity: 1;
  border-color: #e5edff;
  border-color: rgba(229, 237, 255, var(--border-opacity));
}
.hover\\:border-indigo-200:hover {
  --border-opacity: 1;
  border-color: #cddbfe;
  border-color: rgba(205, 219, 254, var(--border-opacity));
}
.hover\\:border-indigo-300:hover {
  --border-opacity: 1;
  border-color: #b4c6fc;
  border-color: rgba(180, 198, 252, var(--border-opacity));
}
.hover\\:border-indigo-400:hover {
  --border-opacity: 1;
  border-color: #8da2fb;
  border-color: rgba(141, 162, 251, var(--border-opacity));
}
.hover\\:border-indigo-500:hover {
  --border-opacity: 1;
  border-color: #6875f5;
  border-color: rgba(104, 117, 245, var(--border-opacity));
}
.hover\\:border-indigo-600:hover {
  --border-opacity: 1;
  border-color: #5850ec;
  border-color: rgba(88, 80, 236, var(--border-opacity));
}
.hover\\:border-indigo-700:hover {
  --border-opacity: 1;
  border-color: #5145cd;
  border-color: rgba(81, 69, 205, var(--border-opacity));
}
.hover\\:border-indigo-800:hover {
  --border-opacity: 1;
  border-color: #42389d;
  border-color: rgba(66, 56, 157, var(--border-opacity));
}
.hover\\:border-indigo-900:hover {
  --border-opacity: 1;
  border-color: #362f78;
  border-color: rgba(54, 47, 120, var(--border-opacity));
}
.hover\\:border-purple-50:hover {
  --border-opacity: 1;
  border-color: #f6f5ff;
  border-color: rgba(246, 245, 255, var(--border-opacity));
}
.hover\\:border-purple-100:hover {
  --border-opacity: 1;
  border-color: #edebfe;
  border-color: rgba(237, 235, 254, var(--border-opacity));
}
.hover\\:border-purple-200:hover {
  --border-opacity: 1;
  border-color: #dcd7fe;
  border-color: rgba(220, 215, 254, var(--border-opacity));
}
.hover\\:border-purple-300:hover {
  --border-opacity: 1;
  border-color: #cabffd;
  border-color: rgba(202, 191, 253, var(--border-opacity));
}
.hover\\:border-purple-400:hover {
  --border-opacity: 1;
  border-color: #ac94fa;
  border-color: rgba(172, 148, 250, var(--border-opacity));
}
.hover\\:border-purple-500:hover {
  --border-opacity: 1;
  border-color: #9061f9;
  border-color: rgba(144, 97, 249, var(--border-opacity));
}
.hover\\:border-purple-600:hover {
  --border-opacity: 1;
  border-color: #7e3af2;
  border-color: rgba(126, 58, 242, var(--border-opacity));
}
.hover\\:border-purple-700:hover {
  --border-opacity: 1;
  border-color: #6c2bd9;
  border-color: rgba(108, 43, 217, var(--border-opacity));
}
.hover\\:border-purple-800:hover {
  --border-opacity: 1;
  border-color: #5521b5;
  border-color: rgba(85, 33, 181, var(--border-opacity));
}
.hover\\:border-purple-900:hover {
  --border-opacity: 1;
  border-color: #4a1d96;
  border-color: rgba(74, 29, 150, var(--border-opacity));
}
.hover\\:border-pink-50:hover {
  --border-opacity: 1;
  border-color: #fdf2f8;
  border-color: rgba(253, 242, 248, var(--border-opacity));
}
.hover\\:border-pink-100:hover {
  --border-opacity: 1;
  border-color: #fce8f3;
  border-color: rgba(252, 232, 243, var(--border-opacity));
}
.hover\\:border-pink-200:hover {
  --border-opacity: 1;
  border-color: #fad1e8;
  border-color: rgba(250, 209, 232, var(--border-opacity));
}
.hover\\:border-pink-300:hover {
  --border-opacity: 1;
  border-color: #f8b4d9;
  border-color: rgba(248, 180, 217, var(--border-opacity));
}
.hover\\:border-pink-400:hover {
  --border-opacity: 1;
  border-color: #f17eb8;
  border-color: rgba(241, 126, 184, var(--border-opacity));
}
.hover\\:border-pink-500:hover {
  --border-opacity: 1;
  border-color: #e74694;
  border-color: rgba(231, 70, 148, var(--border-opacity));
}
.hover\\:border-pink-600:hover {
  --border-opacity: 1;
  border-color: #d61f69;
  border-color: rgba(214, 31, 105, var(--border-opacity));
}
.hover\\:border-pink-700:hover {
  --border-opacity: 1;
  border-color: #bf125d;
  border-color: rgba(191, 18, 93, var(--border-opacity));
}
.hover\\:border-pink-800:hover {
  --border-opacity: 1;
  border-color: #99154b;
  border-color: rgba(153, 21, 75, var(--border-opacity));
}
.hover\\:border-pink-900:hover {
  --border-opacity: 1;
  border-color: #751a3d;
  border-color: rgba(117, 26, 61, var(--border-opacity));
}
.hover\\:border-cool-gray-50:hover {
  --border-opacity: 1;
  border-color: #f8fafc;
  border-color: rgba(248, 250, 252, var(--border-opacity));
}
.hover\\:border-cool-gray-100:hover {
  --border-opacity: 1;
  border-color: #f1f5f9;
  border-color: rgba(241, 245, 249, var(--border-opacity));
}
.hover\\:border-cool-gray-200:hover {
  --border-opacity: 1;
  border-color: #e2e8f0;
  border-color: rgba(226, 232, 240, var(--border-opacity));
}
.hover\\:border-cool-gray-300:hover {
  --border-opacity: 1;
  border-color: #cfd8e3;
  border-color: rgba(207, 216, 227, var(--border-opacity));
}
.hover\\:border-cool-gray-400:hover {
  --border-opacity: 1;
  border-color: #97a6ba;
  border-color: rgba(151, 166, 186, var(--border-opacity));
}
.hover\\:border-cool-gray-500:hover {
  --border-opacity: 1;
  border-color: #64748b;
  border-color: rgba(100, 116, 139, var(--border-opacity));
}
.hover\\:border-cool-gray-600:hover {
  --border-opacity: 1;
  border-color: #475569;
  border-color: rgba(71, 85, 105, var(--border-opacity));
}
.hover\\:border-cool-gray-700:hover {
  --border-opacity: 1;
  border-color: #364152;
  border-color: rgba(54, 65, 82, var(--border-opacity));
}
.hover\\:border-cool-gray-800:hover {
  --border-opacity: 1;
  border-color: #27303f;
  border-color: rgba(39, 48, 63, var(--border-opacity));
}
.hover\\:border-cool-gray-900:hover {
  --border-opacity: 1;
  border-color: #1a202e;
  border-color: rgba(26, 32, 46, var(--border-opacity));
}
.focus-within\\:border-current:focus-within {
  border-color: currentColor;
}
.focus-within\\:border-transparent:focus-within {
  border-color: transparent;
}
.focus-within\\:border-white:focus-within {
  --border-opacity: 1;
  border-color: #ffffff;
  border-color: rgba(255, 255, 255, var(--border-opacity));
}
.focus-within\\:border-black:focus-within {
  --border-opacity: 1;
  border-color: #000000;
  border-color: rgba(0, 0, 0, var(--border-opacity));
}
.focus-within\\:border-gray-50:focus-within {
  --border-opacity: 1;
  border-color: #f9fafb;
  border-color: rgba(249, 250, 251, var(--border-opacity));
}
.focus-within\\:border-gray-100:focus-within {
  --border-opacity: 1;
  border-color: #f4f5f7;
  border-color: rgba(244, 245, 247, var(--border-opacity));
}
.focus-within\\:border-gray-200:focus-within {
  --border-opacity: 1;
  border-color: #e5e7eb;
  border-color: rgba(229, 231, 235, var(--border-opacity));
}
.focus-within\\:border-gray-300:focus-within {
  --border-opacity: 1;
  border-color: #d2d6dc;
  border-color: rgba(210, 214, 220, var(--border-opacity));
}
.focus-within\\:border-gray-400:focus-within {
  --border-opacity: 1;
  border-color: #9fa6b2;
  border-color: rgba(159, 166, 178, var(--border-opacity));
}
.focus-within\\:border-gray-500:focus-within {
  --border-opacity: 1;
  border-color: #6b7280;
  border-color: rgba(107, 114, 128, var(--border-opacity));
}
.focus-within\\:border-gray-600:focus-within {
  --border-opacity: 1;
  border-color: #4b5563;
  border-color: rgba(75, 85, 99, var(--border-opacity));
}
.focus-within\\:border-gray-700:focus-within {
  --border-opacity: 1;
  border-color: #374151;
  border-color: rgba(55, 65, 81, var(--border-opacity));
}
.focus-within\\:border-gray-800:focus-within {
  --border-opacity: 1;
  border-color: #252f3f;
  border-color: rgba(37, 47, 63, var(--border-opacity));
}
.focus-within\\:border-gray-900:focus-within {
  --border-opacity: 1;
  border-color: #161e2e;
  border-color: rgba(22, 30, 46, var(--border-opacity));
}
.focus-within\\:border-red-50:focus-within {
  --border-opacity: 1;
  border-color: #fdf2f2;
  border-color: rgba(253, 242, 242, var(--border-opacity));
}
.focus-within\\:border-red-100:focus-within {
  --border-opacity: 1;
  border-color: #fde8e8;
  border-color: rgba(253, 232, 232, var(--border-opacity));
}
.focus-within\\:border-red-200:focus-within {
  --border-opacity: 1;
  border-color: #fbd5d5;
  border-color: rgba(251, 213, 213, var(--border-opacity));
}
.focus-within\\:border-red-300:focus-within {
  --border-opacity: 1;
  border-color: #f8b4b4;
  border-color: rgba(248, 180, 180, var(--border-opacity));
}
.focus-within\\:border-red-400:focus-within {
  --border-opacity: 1;
  border-color: #f98080;
  border-color: rgba(249, 128, 128, var(--border-opacity));
}
.focus-within\\:border-red-500:focus-within {
  --border-opacity: 1;
  border-color: #f05252;
  border-color: rgba(240, 82, 82, var(--border-opacity));
}
.focus-within\\:border-red-600:focus-within {
  --border-opacity: 1;
  border-color: #e02424;
  border-color: rgba(224, 36, 36, var(--border-opacity));
}
.focus-within\\:border-red-700:focus-within {
  --border-opacity: 1;
  border-color: #c81e1e;
  border-color: rgba(200, 30, 30, var(--border-opacity));
}
.focus-within\\:border-red-800:focus-within {
  --border-opacity: 1;
  border-color: #9b1c1c;
  border-color: rgba(155, 28, 28, var(--border-opacity));
}
.focus-within\\:border-red-900:focus-within {
  --border-opacity: 1;
  border-color: #771d1d;
  border-color: rgba(119, 29, 29, var(--border-opacity));
}
.focus-within\\:border-orange-50:focus-within {
  --border-opacity: 1;
  border-color: #fff8f1;
  border-color: rgba(255, 248, 241, var(--border-opacity));
}
.focus-within\\:border-orange-100:focus-within {
  --border-opacity: 1;
  border-color: #feecdc;
  border-color: rgba(254, 236, 220, var(--border-opacity));
}
.focus-within\\:border-orange-200:focus-within {
  --border-opacity: 1;
  border-color: #fcd9bd;
  border-color: rgba(252, 217, 189, var(--border-opacity));
}
.focus-within\\:border-orange-300:focus-within {
  --border-opacity: 1;
  border-color: #fdba8c;
  border-color: rgba(253, 186, 140, var(--border-opacity));
}
.focus-within\\:border-orange-400:focus-within {
  --border-opacity: 1;
  border-color: #ff8a4c;
  border-color: rgba(255, 138, 76, var(--border-opacity));
}
.focus-within\\:border-orange-500:focus-within {
  --border-opacity: 1;
  border-color: #ff5a1f;
  border-color: rgba(255, 90, 31, var(--border-opacity));
}
.focus-within\\:border-orange-600:focus-within {
  --border-opacity: 1;
  border-color: #d03801;
  border-color: rgba(208, 56, 1, var(--border-opacity));
}
.focus-within\\:border-orange-700:focus-within {
  --border-opacity: 1;
  border-color: #b43403;
  border-color: rgba(180, 52, 3, var(--border-opacity));
}
.focus-within\\:border-orange-800:focus-within {
  --border-opacity: 1;
  border-color: #8a2c0d;
  border-color: rgba(138, 44, 13, var(--border-opacity));
}
.focus-within\\:border-orange-900:focus-within {
  --border-opacity: 1;
  border-color: #73230d;
  border-color: rgba(115, 35, 13, var(--border-opacity));
}
.focus-within\\:border-yellow-50:focus-within {
  --border-opacity: 1;
  border-color: #fdfdea;
  border-color: rgba(253, 253, 234, var(--border-opacity));
}
.focus-within\\:border-yellow-100:focus-within {
  --border-opacity: 1;
  border-color: #fdf6b2;
  border-color: rgba(253, 246, 178, var(--border-opacity));
}
.focus-within\\:border-yellow-200:focus-within {
  --border-opacity: 1;
  border-color: #fce96a;
  border-color: rgba(252, 233, 106, var(--border-opacity));
}
.focus-within\\:border-yellow-300:focus-within {
  --border-opacity: 1;
  border-color: #faca15;
  border-color: rgba(250, 202, 21, var(--border-opacity));
}
.focus-within\\:border-yellow-400:focus-within {
  --border-opacity: 1;
  border-color: #e3a008;
  border-color: rgba(227, 160, 8, var(--border-opacity));
}
.focus-within\\:border-yellow-500:focus-within {
  --border-opacity: 1;
  border-color: #c27803;
  border-color: rgba(194, 120, 3, var(--border-opacity));
}
.focus-within\\:border-yellow-600:focus-within {
  --border-opacity: 1;
  border-color: #9f580a;
  border-color: rgba(159, 88, 10, var(--border-opacity));
}
.focus-within\\:border-yellow-700:focus-within {
  --border-opacity: 1;
  border-color: #8e4b10;
  border-color: rgba(142, 75, 16, var(--border-opacity));
}
.focus-within\\:border-yellow-800:focus-within {
  --border-opacity: 1;
  border-color: #723b13;
  border-color: rgba(114, 59, 19, var(--border-opacity));
}
.focus-within\\:border-yellow-900:focus-within {
  --border-opacity: 1;
  border-color: #633112;
  border-color: rgba(99, 49, 18, var(--border-opacity));
}
.focus-within\\:border-green-50:focus-within {
  --border-opacity: 1;
  border-color: #f3faf7;
  border-color: rgba(243, 250, 247, var(--border-opacity));
}
.focus-within\\:border-green-100:focus-within {
  --border-opacity: 1;
  border-color: #def7ec;
  border-color: rgba(222, 247, 236, var(--border-opacity));
}
.focus-within\\:border-green-200:focus-within {
  --border-opacity: 1;
  border-color: #bcf0da;
  border-color: rgba(188, 240, 218, var(--border-opacity));
}
.focus-within\\:border-green-300:focus-within {
  --border-opacity: 1;
  border-color: #84e1bc;
  border-color: rgba(132, 225, 188, var(--border-opacity));
}
.focus-within\\:border-green-400:focus-within {
  --border-opacity: 1;
  border-color: #31c48d;
  border-color: rgba(49, 196, 141, var(--border-opacity));
}
.focus-within\\:border-green-500:focus-within {
  --border-opacity: 1;
  border-color: #0e9f6e;
  border-color: rgba(14, 159, 110, var(--border-opacity));
}
.focus-within\\:border-green-600:focus-within {
  --border-opacity: 1;
  border-color: #057a55;
  border-color: rgba(5, 122, 85, var(--border-opacity));
}
.focus-within\\:border-green-700:focus-within {
  --border-opacity: 1;
  border-color: #046c4e;
  border-color: rgba(4, 108, 78, var(--border-opacity));
}
.focus-within\\:border-green-800:focus-within {
  --border-opacity: 1;
  border-color: #03543f;
  border-color: rgba(3, 84, 63, var(--border-opacity));
}
.focus-within\\:border-green-900:focus-within {
  --border-opacity: 1;
  border-color: #014737;
  border-color: rgba(1, 71, 55, var(--border-opacity));
}
.focus-within\\:border-teal-50:focus-within {
  --border-opacity: 1;
  border-color: #edfafa;
  border-color: rgba(237, 250, 250, var(--border-opacity));
}
.focus-within\\:border-teal-100:focus-within {
  --border-opacity: 1;
  border-color: #d5f5f6;
  border-color: rgba(213, 245, 246, var(--border-opacity));
}
.focus-within\\:border-teal-200:focus-within {
  --border-opacity: 1;
  border-color: #afecef;
  border-color: rgba(175, 236, 239, var(--border-opacity));
}
.focus-within\\:border-teal-300:focus-within {
  --border-opacity: 1;
  border-color: #7edce2;
  border-color: rgba(126, 220, 226, var(--border-opacity));
}
.focus-within\\:border-teal-400:focus-within {
  --border-opacity: 1;
  border-color: #16bdca;
  border-color: rgba(22, 189, 202, var(--border-opacity));
}
.focus-within\\:border-teal-500:focus-within {
  --border-opacity: 1;
  border-color: #0694a2;
  border-color: rgba(6, 148, 162, var(--border-opacity));
}
.focus-within\\:border-teal-600:focus-within {
  --border-opacity: 1;
  border-color: #047481;
  border-color: rgba(4, 116, 129, var(--border-opacity));
}
.focus-within\\:border-teal-700:focus-within {
  --border-opacity: 1;
  border-color: #036672;
  border-color: rgba(3, 102, 114, var(--border-opacity));
}
.focus-within\\:border-teal-800:focus-within {
  --border-opacity: 1;
  border-color: #05505c;
  border-color: rgba(5, 80, 92, var(--border-opacity));
}
.focus-within\\:border-teal-900:focus-within {
  --border-opacity: 1;
  border-color: #014451;
  border-color: rgba(1, 68, 81, var(--border-opacity));
}
.focus-within\\:border-blue-50:focus-within {
  --border-opacity: 1;
  border-color: #ebf5ff;
  border-color: rgba(235, 245, 255, var(--border-opacity));
}
.focus-within\\:border-blue-100:focus-within {
  --border-opacity: 1;
  border-color: #e1effe;
  border-color: rgba(225, 239, 254, var(--border-opacity));
}
.focus-within\\:border-blue-200:focus-within {
  --border-opacity: 1;
  border-color: #c3ddfd;
  border-color: rgba(195, 221, 253, var(--border-opacity));
}
.focus-within\\:border-blue-300:focus-within {
  --border-opacity: 1;
  border-color: #a4cafe;
  border-color: rgba(164, 202, 254, var(--border-opacity));
}
.focus-within\\:border-blue-400:focus-within {
  --border-opacity: 1;
  border-color: #76a9fa;
  border-color: rgba(118, 169, 250, var(--border-opacity));
}
.focus-within\\:border-blue-500:focus-within {
  --border-opacity: 1;
  border-color: #3f83f8;
  border-color: rgba(63, 131, 248, var(--border-opacity));
}
.focus-within\\:border-blue-600:focus-within {
  --border-opacity: 1;
  border-color: #1c64f2;
  border-color: rgba(28, 100, 242, var(--border-opacity));
}
.focus-within\\:border-blue-700:focus-within {
  --border-opacity: 1;
  border-color: #1a56db;
  border-color: rgba(26, 86, 219, var(--border-opacity));
}
.focus-within\\:border-blue-800:focus-within {
  --border-opacity: 1;
  border-color: #1e429f;
  border-color: rgba(30, 66, 159, var(--border-opacity));
}
.focus-within\\:border-blue-900:focus-within {
  --border-opacity: 1;
  border-color: #233876;
  border-color: rgba(35, 56, 118, var(--border-opacity));
}
.focus-within\\:border-indigo-50:focus-within {
  --border-opacity: 1;
  border-color: #f0f5ff;
  border-color: rgba(240, 245, 255, var(--border-opacity));
}
.focus-within\\:border-indigo-100:focus-within {
  --border-opacity: 1;
  border-color: #e5edff;
  border-color: rgba(229, 237, 255, var(--border-opacity));
}
.focus-within\\:border-indigo-200:focus-within {
  --border-opacity: 1;
  border-color: #cddbfe;
  border-color: rgba(205, 219, 254, var(--border-opacity));
}
.focus-within\\:border-indigo-300:focus-within {
  --border-opacity: 1;
  border-color: #b4c6fc;
  border-color: rgba(180, 198, 252, var(--border-opacity));
}
.focus-within\\:border-indigo-400:focus-within {
  --border-opacity: 1;
  border-color: #8da2fb;
  border-color: rgba(141, 162, 251, var(--border-opacity));
}
.focus-within\\:border-indigo-500:focus-within {
  --border-opacity: 1;
  border-color: #6875f5;
  border-color: rgba(104, 117, 245, var(--border-opacity));
}
.focus-within\\:border-indigo-600:focus-within {
  --border-opacity: 1;
  border-color: #5850ec;
  border-color: rgba(88, 80, 236, var(--border-opacity));
}
.focus-within\\:border-indigo-700:focus-within {
  --border-opacity: 1;
  border-color: #5145cd;
  border-color: rgba(81, 69, 205, var(--border-opacity));
}
.focus-within\\:border-indigo-800:focus-within {
  --border-opacity: 1;
  border-color: #42389d;
  border-color: rgba(66, 56, 157, var(--border-opacity));
}
.focus-within\\:border-indigo-900:focus-within {
  --border-opacity: 1;
  border-color: #362f78;
  border-color: rgba(54, 47, 120, var(--border-opacity));
}
.focus-within\\:border-purple-50:focus-within {
  --border-opacity: 1;
  border-color: #f6f5ff;
  border-color: rgba(246, 245, 255, var(--border-opacity));
}
.focus-within\\:border-purple-100:focus-within {
  --border-opacity: 1;
  border-color: #edebfe;
  border-color: rgba(237, 235, 254, var(--border-opacity));
}
.focus-within\\:border-purple-200:focus-within {
  --border-opacity: 1;
  border-color: #dcd7fe;
  border-color: rgba(220, 215, 254, var(--border-opacity));
}
.focus-within\\:border-purple-300:focus-within {
  --border-opacity: 1;
  border-color: #cabffd;
  border-color: rgba(202, 191, 253, var(--border-opacity));
}
.focus-within\\:border-purple-400:focus-within {
  --border-opacity: 1;
  border-color: #ac94fa;
  border-color: rgba(172, 148, 250, var(--border-opacity));
}
.focus-within\\:border-purple-500:focus-within {
  --border-opacity: 1;
  border-color: #9061f9;
  border-color: rgba(144, 97, 249, var(--border-opacity));
}
.focus-within\\:border-purple-600:focus-within {
  --border-opacity: 1;
  border-color: #7e3af2;
  border-color: rgba(126, 58, 242, var(--border-opacity));
}
.focus-within\\:border-purple-700:focus-within {
  --border-opacity: 1;
  border-color: #6c2bd9;
  border-color: rgba(108, 43, 217, var(--border-opacity));
}
.focus-within\\:border-purple-800:focus-within {
  --border-opacity: 1;
  border-color: #5521b5;
  border-color: rgba(85, 33, 181, var(--border-opacity));
}
.focus-within\\:border-purple-900:focus-within {
  --border-opacity: 1;
  border-color: #4a1d96;
  border-color: rgba(74, 29, 150, var(--border-opacity));
}
.focus-within\\:border-pink-50:focus-within {
  --border-opacity: 1;
  border-color: #fdf2f8;
  border-color: rgba(253, 242, 248, var(--border-opacity));
}
.focus-within\\:border-pink-100:focus-within {
  --border-opacity: 1;
  border-color: #fce8f3;
  border-color: rgba(252, 232, 243, var(--border-opacity));
}
.focus-within\\:border-pink-200:focus-within {
  --border-opacity: 1;
  border-color: #fad1e8;
  border-color: rgba(250, 209, 232, var(--border-opacity));
}
.focus-within\\:border-pink-300:focus-within {
  --border-opacity: 1;
  border-color: #f8b4d9;
  border-color: rgba(248, 180, 217, var(--border-opacity));
}
.focus-within\\:border-pink-400:focus-within {
  --border-opacity: 1;
  border-color: #f17eb8;
  border-color: rgba(241, 126, 184, var(--border-opacity));
}
.focus-within\\:border-pink-500:focus-within {
  --border-opacity: 1;
  border-color: #e74694;
  border-color: rgba(231, 70, 148, var(--border-opacity));
}
.focus-within\\:border-pink-600:focus-within {
  --border-opacity: 1;
  border-color: #d61f69;
  border-color: rgba(214, 31, 105, var(--border-opacity));
}
.focus-within\\:border-pink-700:focus-within {
  --border-opacity: 1;
  border-color: #bf125d;
  border-color: rgba(191, 18, 93, var(--border-opacity));
}
.focus-within\\:border-pink-800:focus-within {
  --border-opacity: 1;
  border-color: #99154b;
  border-color: rgba(153, 21, 75, var(--border-opacity));
}
.focus-within\\:border-pink-900:focus-within {
  --border-opacity: 1;
  border-color: #751a3d;
  border-color: rgba(117, 26, 61, var(--border-opacity));
}
.focus-within\\:border-cool-gray-50:focus-within {
  --border-opacity: 1;
  border-color: #f8fafc;
  border-color: rgba(248, 250, 252, var(--border-opacity));
}
.focus-within\\:border-cool-gray-100:focus-within {
  --border-opacity: 1;
  border-color: #f1f5f9;
  border-color: rgba(241, 245, 249, var(--border-opacity));
}
.focus-within\\:border-cool-gray-200:focus-within {
  --border-opacity: 1;
  border-color: #e2e8f0;
  border-color: rgba(226, 232, 240, var(--border-opacity));
}
.focus-within\\:border-cool-gray-300:focus-within {
  --border-opacity: 1;
  border-color: #cfd8e3;
  border-color: rgba(207, 216, 227, var(--border-opacity));
}
.focus-within\\:border-cool-gray-400:focus-within {
  --border-opacity: 1;
  border-color: #97a6ba;
  border-color: rgba(151, 166, 186, var(--border-opacity));
}
.focus-within\\:border-cool-gray-500:focus-within {
  --border-opacity: 1;
  border-color: #64748b;
  border-color: rgba(100, 116, 139, var(--border-opacity));
}
.focus-within\\:border-cool-gray-600:focus-within {
  --border-opacity: 1;
  border-color: #475569;
  border-color: rgba(71, 85, 105, var(--border-opacity));
}
.focus-within\\:border-cool-gray-700:focus-within {
  --border-opacity: 1;
  border-color: #364152;
  border-color: rgba(54, 65, 82, var(--border-opacity));
}
.focus-within\\:border-cool-gray-800:focus-within {
  --border-opacity: 1;
  border-color: #27303f;
  border-color: rgba(39, 48, 63, var(--border-opacity));
}
.focus-within\\:border-cool-gray-900:focus-within {
  --border-opacity: 1;
  border-color: #1a202e;
  border-color: rgba(26, 32, 46, var(--border-opacity));
}
.focus\\:border-current:focus {
  border-color: currentColor;
}
.focus\\:border-transparent:focus {
  border-color: transparent;
}
.focus\\:border-white:focus {
  --border-opacity: 1;
  border-color: #ffffff;
  border-color: rgba(255, 255, 255, var(--border-opacity));
}
.focus\\:border-black:focus {
  --border-opacity: 1;
  border-color: #000000;
  border-color: rgba(0, 0, 0, var(--border-opacity));
}
.focus\\:border-gray-50:focus {
  --border-opacity: 1;
  border-color: #f9fafb;
  border-color: rgba(249, 250, 251, var(--border-opacity));
}
.focus\\:border-gray-100:focus {
  --border-opacity: 1;
  border-color: #f4f5f7;
  border-color: rgba(244, 245, 247, var(--border-opacity));
}
.focus\\:border-gray-200:focus {
  --border-opacity: 1;
  border-color: #e5e7eb;
  border-color: rgba(229, 231, 235, var(--border-opacity));
}
.focus\\:border-gray-300:focus {
  --border-opacity: 1;
  border-color: #d2d6dc;
  border-color: rgba(210, 214, 220, var(--border-opacity));
}
.focus\\:border-gray-400:focus {
  --border-opacity: 1;
  border-color: #9fa6b2;
  border-color: rgba(159, 166, 178, var(--border-opacity));
}
.focus\\:border-gray-500:focus {
  --border-opacity: 1;
  border-color: #6b7280;
  border-color: rgba(107, 114, 128, var(--border-opacity));
}
.focus\\:border-gray-600:focus {
  --border-opacity: 1;
  border-color: #4b5563;
  border-color: rgba(75, 85, 99, var(--border-opacity));
}
.focus\\:border-gray-700:focus {
  --border-opacity: 1;
  border-color: #374151;
  border-color: rgba(55, 65, 81, var(--border-opacity));
}
.focus\\:border-gray-800:focus {
  --border-opacity: 1;
  border-color: #252f3f;
  border-color: rgba(37, 47, 63, var(--border-opacity));
}
.focus\\:border-gray-900:focus {
  --border-opacity: 1;
  border-color: #161e2e;
  border-color: rgba(22, 30, 46, var(--border-opacity));
}
.focus\\:border-red-50:focus {
  --border-opacity: 1;
  border-color: #fdf2f2;
  border-color: rgba(253, 242, 242, var(--border-opacity));
}
.focus\\:border-red-100:focus {
  --border-opacity: 1;
  border-color: #fde8e8;
  border-color: rgba(253, 232, 232, var(--border-opacity));
}
.focus\\:border-red-200:focus {
  --border-opacity: 1;
  border-color: #fbd5d5;
  border-color: rgba(251, 213, 213, var(--border-opacity));
}
.focus\\:border-red-300:focus {
  --border-opacity: 1;
  border-color: #f8b4b4;
  border-color: rgba(248, 180, 180, var(--border-opacity));
}
.focus\\:border-red-400:focus {
  --border-opacity: 1;
  border-color: #f98080;
  border-color: rgba(249, 128, 128, var(--border-opacity));
}
.focus\\:border-red-500:focus {
  --border-opacity: 1;
  border-color: #f05252;
  border-color: rgba(240, 82, 82, var(--border-opacity));
}
.focus\\:border-red-600:focus {
  --border-opacity: 1;
  border-color: #e02424;
  border-color: rgba(224, 36, 36, var(--border-opacity));
}
.focus\\:border-red-700:focus {
  --border-opacity: 1;
  border-color: #c81e1e;
  border-color: rgba(200, 30, 30, var(--border-opacity));
}
.focus\\:border-red-800:focus {
  --border-opacity: 1;
  border-color: #9b1c1c;
  border-color: rgba(155, 28, 28, var(--border-opacity));
}
.focus\\:border-red-900:focus {
  --border-opacity: 1;
  border-color: #771d1d;
  border-color: rgba(119, 29, 29, var(--border-opacity));
}
.focus\\:border-orange-50:focus {
  --border-opacity: 1;
  border-color: #fff8f1;
  border-color: rgba(255, 248, 241, var(--border-opacity));
}
.focus\\:border-orange-100:focus {
  --border-opacity: 1;
  border-color: #feecdc;
  border-color: rgba(254, 236, 220, var(--border-opacity));
}
.focus\\:border-orange-200:focus {
  --border-opacity: 1;
  border-color: #fcd9bd;
  border-color: rgba(252, 217, 189, var(--border-opacity));
}
.focus\\:border-orange-300:focus {
  --border-opacity: 1;
  border-color: #fdba8c;
  border-color: rgba(253, 186, 140, var(--border-opacity));
}
.focus\\:border-orange-400:focus {
  --border-opacity: 1;
  border-color: #ff8a4c;
  border-color: rgba(255, 138, 76, var(--border-opacity));
}
.focus\\:border-orange-500:focus {
  --border-opacity: 1;
  border-color: #ff5a1f;
  border-color: rgba(255, 90, 31, var(--border-opacity));
}
.focus\\:border-orange-600:focus {
  --border-opacity: 1;
  border-color: #d03801;
  border-color: rgba(208, 56, 1, var(--border-opacity));
}
.focus\\:border-orange-700:focus {
  --border-opacity: 1;
  border-color: #b43403;
  border-color: rgba(180, 52, 3, var(--border-opacity));
}
.focus\\:border-orange-800:focus {
  --border-opacity: 1;
  border-color: #8a2c0d;
  border-color: rgba(138, 44, 13, var(--border-opacity));
}
.focus\\:border-orange-900:focus {
  --border-opacity: 1;
  border-color: #73230d;
  border-color: rgba(115, 35, 13, var(--border-opacity));
}
.focus\\:border-yellow-50:focus {
  --border-opacity: 1;
  border-color: #fdfdea;
  border-color: rgba(253, 253, 234, var(--border-opacity));
}
.focus\\:border-yellow-100:focus {
  --border-opacity: 1;
  border-color: #fdf6b2;
  border-color: rgba(253, 246, 178, var(--border-opacity));
}
.focus\\:border-yellow-200:focus {
  --border-opacity: 1;
  border-color: #fce96a;
  border-color: rgba(252, 233, 106, var(--border-opacity));
}
.focus\\:border-yellow-300:focus {
  --border-opacity: 1;
  border-color: #faca15;
  border-color: rgba(250, 202, 21, var(--border-opacity));
}
.focus\\:border-yellow-400:focus {
  --border-opacity: 1;
  border-color: #e3a008;
  border-color: rgba(227, 160, 8, var(--border-opacity));
}
.focus\\:border-yellow-500:focus {
  --border-opacity: 1;
  border-color: #c27803;
  border-color: rgba(194, 120, 3, var(--border-opacity));
}
.focus\\:border-yellow-600:focus {
  --border-opacity: 1;
  border-color: #9f580a;
  border-color: rgba(159, 88, 10, var(--border-opacity));
}
.focus\\:border-yellow-700:focus {
  --border-opacity: 1;
  border-color: #8e4b10;
  border-color: rgba(142, 75, 16, var(--border-opacity));
}
.focus\\:border-yellow-800:focus {
  --border-opacity: 1;
  border-color: #723b13;
  border-color: rgba(114, 59, 19, var(--border-opacity));
}
.focus\\:border-yellow-900:focus {
  --border-opacity: 1;
  border-color: #633112;
  border-color: rgba(99, 49, 18, var(--border-opacity));
}
.focus\\:border-green-50:focus {
  --border-opacity: 1;
  border-color: #f3faf7;
  border-color: rgba(243, 250, 247, var(--border-opacity));
}
.focus\\:border-green-100:focus {
  --border-opacity: 1;
  border-color: #def7ec;
  border-color: rgba(222, 247, 236, var(--border-opacity));
}
.focus\\:border-green-200:focus {
  --border-opacity: 1;
  border-color: #bcf0da;
  border-color: rgba(188, 240, 218, var(--border-opacity));
}
.focus\\:border-green-300:focus {
  --border-opacity: 1;
  border-color: #84e1bc;
  border-color: rgba(132, 225, 188, var(--border-opacity));
}
.focus\\:border-green-400:focus {
  --border-opacity: 1;
  border-color: #31c48d;
  border-color: rgba(49, 196, 141, var(--border-opacity));
}
.focus\\:border-green-500:focus {
  --border-opacity: 1;
  border-color: #0e9f6e;
  border-color: rgba(14, 159, 110, var(--border-opacity));
}
.focus\\:border-green-600:focus {
  --border-opacity: 1;
  border-color: #057a55;
  border-color: rgba(5, 122, 85, var(--border-opacity));
}
.focus\\:border-green-700:focus {
  --border-opacity: 1;
  border-color: #046c4e;
  border-color: rgba(4, 108, 78, var(--border-opacity));
}
.focus\\:border-green-800:focus {
  --border-opacity: 1;
  border-color: #03543f;
  border-color: rgba(3, 84, 63, var(--border-opacity));
}
.focus\\:border-green-900:focus {
  --border-opacity: 1;
  border-color: #014737;
  border-color: rgba(1, 71, 55, var(--border-opacity));
}
.focus\\:border-teal-50:focus {
  --border-opacity: 1;
  border-color: #edfafa;
  border-color: rgba(237, 250, 250, var(--border-opacity));
}
.focus\\:border-teal-100:focus {
  --border-opacity: 1;
  border-color: #d5f5f6;
  border-color: rgba(213, 245, 246, var(--border-opacity));
}
.focus\\:border-teal-200:focus {
  --border-opacity: 1;
  border-color: #afecef;
  border-color: rgba(175, 236, 239, var(--border-opacity));
}
.focus\\:border-teal-300:focus {
  --border-opacity: 1;
  border-color: #7edce2;
  border-color: rgba(126, 220, 226, var(--border-opacity));
}
.focus\\:border-teal-400:focus {
  --border-opacity: 1;
  border-color: #16bdca;
  border-color: rgba(22, 189, 202, var(--border-opacity));
}
.focus\\:border-teal-500:focus {
  --border-opacity: 1;
  border-color: #0694a2;
  border-color: rgba(6, 148, 162, var(--border-opacity));
}
.focus\\:border-teal-600:focus {
  --border-opacity: 1;
  border-color: #047481;
  border-color: rgba(4, 116, 129, var(--border-opacity));
}
.focus\\:border-teal-700:focus {
  --border-opacity: 1;
  border-color: #036672;
  border-color: rgba(3, 102, 114, var(--border-opacity));
}
.focus\\:border-teal-800:focus {
  --border-opacity: 1;
  border-color: #05505c;
  border-color: rgba(5, 80, 92, var(--border-opacity));
}
.focus\\:border-teal-900:focus {
  --border-opacity: 1;
  border-color: #014451;
  border-color: rgba(1, 68, 81, var(--border-opacity));
}
.focus\\:border-blue-50:focus {
  --border-opacity: 1;
  border-color: #ebf5ff;
  border-color: rgba(235, 245, 255, var(--border-opacity));
}
.focus\\:border-blue-100:focus {
  --border-opacity: 1;
  border-color: #e1effe;
  border-color: rgba(225, 239, 254, var(--border-opacity));
}
.focus\\:border-blue-200:focus {
  --border-opacity: 1;
  border-color: #c3ddfd;
  border-color: rgba(195, 221, 253, var(--border-opacity));
}
.focus\\:border-blue-300:focus {
  --border-opacity: 1;
  border-color: #a4cafe;
  border-color: rgba(164, 202, 254, var(--border-opacity));
}
.focus\\:border-blue-400:focus {
  --border-opacity: 1;
  border-color: #76a9fa;
  border-color: rgba(118, 169, 250, var(--border-opacity));
}
.focus\\:border-blue-500:focus {
  --border-opacity: 1;
  border-color: #3f83f8;
  border-color: rgba(63, 131, 248, var(--border-opacity));
}
.focus\\:border-blue-600:focus {
  --border-opacity: 1;
  border-color: #1c64f2;
  border-color: rgba(28, 100, 242, var(--border-opacity));
}
.focus\\:border-blue-700:focus {
  --border-opacity: 1;
  border-color: #1a56db;
  border-color: rgba(26, 86, 219, var(--border-opacity));
}
.focus\\:border-blue-800:focus {
  --border-opacity: 1;
  border-color: #1e429f;
  border-color: rgba(30, 66, 159, var(--border-opacity));
}
.focus\\:border-blue-900:focus {
  --border-opacity: 1;
  border-color: #233876;
  border-color: rgba(35, 56, 118, var(--border-opacity));
}
.focus\\:border-indigo-50:focus {
  --border-opacity: 1;
  border-color: #f0f5ff;
  border-color: rgba(240, 245, 255, var(--border-opacity));
}
.focus\\:border-indigo-100:focus {
  --border-opacity: 1;
  border-color: #e5edff;
  border-color: rgba(229, 237, 255, var(--border-opacity));
}
.focus\\:border-indigo-200:focus {
  --border-opacity: 1;
  border-color: #cddbfe;
  border-color: rgba(205, 219, 254, var(--border-opacity));
}
.focus\\:border-indigo-300:focus {
  --border-opacity: 1;
  border-color: #b4c6fc;
  border-color: rgba(180, 198, 252, var(--border-opacity));
}
.focus\\:border-indigo-400:focus {
  --border-opacity: 1;
  border-color: #8da2fb;
  border-color: rgba(141, 162, 251, var(--border-opacity));
}
.focus\\:border-indigo-500:focus {
  --border-opacity: 1;
  border-color: #6875f5;
  border-color: rgba(104, 117, 245, var(--border-opacity));
}
.focus\\:border-indigo-600:focus {
  --border-opacity: 1;
  border-color: #5850ec;
  border-color: rgba(88, 80, 236, var(--border-opacity));
}
.focus\\:border-indigo-700:focus {
  --border-opacity: 1;
  border-color: #5145cd;
  border-color: rgba(81, 69, 205, var(--border-opacity));
}
.focus\\:border-indigo-800:focus {
  --border-opacity: 1;
  border-color: #42389d;
  border-color: rgba(66, 56, 157, var(--border-opacity));
}
.focus\\:border-indigo-900:focus {
  --border-opacity: 1;
  border-color: #362f78;
  border-color: rgba(54, 47, 120, var(--border-opacity));
}
.focus\\:border-purple-50:focus {
  --border-opacity: 1;
  border-color: #f6f5ff;
  border-color: rgba(246, 245, 255, var(--border-opacity));
}
.focus\\:border-purple-100:focus {
  --border-opacity: 1;
  border-color: #edebfe;
  border-color: rgba(237, 235, 254, var(--border-opacity));
}
.focus\\:border-purple-200:focus {
  --border-opacity: 1;
  border-color: #dcd7fe;
  border-color: rgba(220, 215, 254, var(--border-opacity));
}
.focus\\:border-purple-300:focus {
  --border-opacity: 1;
  border-color: #cabffd;
  border-color: rgba(202, 191, 253, var(--border-opacity));
}
.focus\\:border-purple-400:focus {
  --border-opacity: 1;
  border-color: #ac94fa;
  border-color: rgba(172, 148, 250, var(--border-opacity));
}
.focus\\:border-purple-500:focus {
  --border-opacity: 1;
  border-color: #9061f9;
  border-color: rgba(144, 97, 249, var(--border-opacity));
}
.focus\\:border-purple-600:focus {
  --border-opacity: 1;
  border-color: #7e3af2;
  border-color: rgba(126, 58, 242, var(--border-opacity));
}
.focus\\:border-purple-700:focus {
  --border-opacity: 1;
  border-color: #6c2bd9;
  border-color: rgba(108, 43, 217, var(--border-opacity));
}
.focus\\:border-purple-800:focus {
  --border-opacity: 1;
  border-color: #5521b5;
  border-color: rgba(85, 33, 181, var(--border-opacity));
}
.focus\\:border-purple-900:focus {
  --border-opacity: 1;
  border-color: #4a1d96;
  border-color: rgba(74, 29, 150, var(--border-opacity));
}
.focus\\:border-pink-50:focus {
  --border-opacity: 1;
  border-color: #fdf2f8;
  border-color: rgba(253, 242, 248, var(--border-opacity));
}
.focus\\:border-pink-100:focus {
  --border-opacity: 1;
  border-color: #fce8f3;
  border-color: rgba(252, 232, 243, var(--border-opacity));
}
.focus\\:border-pink-200:focus {
  --border-opacity: 1;
  border-color: #fad1e8;
  border-color: rgba(250, 209, 232, var(--border-opacity));
}
.focus\\:border-pink-300:focus {
  --border-opacity: 1;
  border-color: #f8b4d9;
  border-color: rgba(248, 180, 217, var(--border-opacity));
}
.focus\\:border-pink-400:focus {
  --border-opacity: 1;
  border-color: #f17eb8;
  border-color: rgba(241, 126, 184, var(--border-opacity));
}
.focus\\:border-pink-500:focus {
  --border-opacity: 1;
  border-color: #e74694;
  border-color: rgba(231, 70, 148, var(--border-opacity));
}
.focus\\:border-pink-600:focus {
  --border-opacity: 1;
  border-color: #d61f69;
  border-color: rgba(214, 31, 105, var(--border-opacity));
}
.focus\\:border-pink-700:focus {
  --border-opacity: 1;
  border-color: #bf125d;
  border-color: rgba(191, 18, 93, var(--border-opacity));
}
.focus\\:border-pink-800:focus {
  --border-opacity: 1;
  border-color: #99154b;
  border-color: rgba(153, 21, 75, var(--border-opacity));
}
.focus\\:border-pink-900:focus {
  --border-opacity: 1;
  border-color: #751a3d;
  border-color: rgba(117, 26, 61, var(--border-opacity));
}
.focus\\:border-cool-gray-50:focus {
  --border-opacity: 1;
  border-color: #f8fafc;
  border-color: rgba(248, 250, 252, var(--border-opacity));
}
.focus\\:border-cool-gray-100:focus {
  --border-opacity: 1;
  border-color: #f1f5f9;
  border-color: rgba(241, 245, 249, var(--border-opacity));
}
.focus\\:border-cool-gray-200:focus {
  --border-opacity: 1;
  border-color: #e2e8f0;
  border-color: rgba(226, 232, 240, var(--border-opacity));
}
.focus\\:border-cool-gray-300:focus {
  --border-opacity: 1;
  border-color: #cfd8e3;
  border-color: rgba(207, 216, 227, var(--border-opacity));
}
.focus\\:border-cool-gray-400:focus {
  --border-opacity: 1;
  border-color: #97a6ba;
  border-color: rgba(151, 166, 186, var(--border-opacity));
}
.focus\\:border-cool-gray-500:focus {
  --border-opacity: 1;
  border-color: #64748b;
  border-color: rgba(100, 116, 139, var(--border-opacity));
}
.focus\\:border-cool-gray-600:focus {
  --border-opacity: 1;
  border-color: #475569;
  border-color: rgba(71, 85, 105, var(--border-opacity));
}
.focus\\:border-cool-gray-700:focus {
  --border-opacity: 1;
  border-color: #364152;
  border-color: rgba(54, 65, 82, var(--border-opacity));
}
.focus\\:border-cool-gray-800:focus {
  --border-opacity: 1;
  border-color: #27303f;
  border-color: rgba(39, 48, 63, var(--border-opacity));
}
.focus\\:border-cool-gray-900:focus {
  --border-opacity: 1;
  border-color: #1a202e;
  border-color: rgba(26, 32, 46, var(--border-opacity));
}
.border-opacity-0 {
  --border-opacity: 0;
}
.border-opacity-25 {
  --border-opacity: 0.25;
}
.border-opacity-50 {
  --border-opacity: 0.5;
}
.border-opacity-75 {
  --border-opacity: 0.75;
}
.border-opacity-100 {
  --border-opacity: 1;
}
.hover\\:border-opacity-0:hover {
  --border-opacity: 0;
}
.hover\\:border-opacity-25:hover {
  --border-opacity: 0.25;
}
.hover\\:border-opacity-50:hover {
  --border-opacity: 0.5;
}
.hover\\:border-opacity-75:hover {
  --border-opacity: 0.75;
}
.hover\\:border-opacity-100:hover {
  --border-opacity: 1;
}
.focus\\:border-opacity-0:focus {
  --border-opacity: 0;
}
.focus\\:border-opacity-25:focus {
  --border-opacity: 0.25;
}
.focus\\:border-opacity-50:focus {
  --border-opacity: 0.5;
}
.focus\\:border-opacity-75:focus {
  --border-opacity: 0.75;
}
.focus\\:border-opacity-100:focus {
  --border-opacity: 1;
}
.rounded-none {
  border-radius: 0;
}
.rounded-sm {
  border-radius: 0.125rem;
}
.rounded {
  border-radius: 0.25rem;
}
.rounded-md {
  border-radius: 0.375rem;
}
.rounded-lg {
  border-radius: 0.5rem;
}
.rounded-xl {
  border-radius: 0.75rem;
}
.rounded-2xl {
  border-radius: 1rem;
}
.rounded-3xl {
  border-radius: 1.5rem;
}
.rounded-full {
  border-radius: 9999px;
}
.rounded-t-none {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
.rounded-r-none {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.rounded-b-none {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.rounded-l-none {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.rounded-t-sm {
  border-top-left-radius: 0.125rem;
  border-top-right-radius: 0.125rem;
}
.rounded-r-sm {
  border-top-right-radius: 0.125rem;
  border-bottom-right-radius: 0.125rem;
}
.rounded-b-sm {
  border-bottom-right-radius: 0.125rem;
  border-bottom-left-radius: 0.125rem;
}
.rounded-l-sm {
  border-top-left-radius: 0.125rem;
  border-bottom-left-radius: 0.125rem;
}
.rounded-t {
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
}
.rounded-r {
  border-top-right-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem;
}
.rounded-b {
  border-bottom-right-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
}
.rounded-l {
  border-top-left-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
}
.rounded-t-md {
  border-top-left-radius: 0.375rem;
  border-top-right-radius: 0.375rem;
}
.rounded-r-md {
  border-top-right-radius: 0.375rem;
  border-bottom-right-radius: 0.375rem;
}
.rounded-b-md {
  border-bottom-right-radius: 0.375rem;
  border-bottom-left-radius: 0.375rem;
}
.rounded-l-md {
  border-top-left-radius: 0.375rem;
  border-bottom-left-radius: 0.375rem;
}
.rounded-t-lg {
  border-top-left-radius: 0.5rem;
  border-top-right-radius: 0.5rem;
}
.rounded-r-lg {
  border-top-right-radius: 0.5rem;
  border-bottom-right-radius: 0.5rem;
}
.rounded-b-lg {
  border-bottom-right-radius: 0.5rem;
  border-bottom-left-radius: 0.5rem;
}
.rounded-l-lg {
  border-top-left-radius: 0.5rem;
  border-bottom-left-radius: 0.5rem;
}
.rounded-t-xl {
  border-top-left-radius: 0.75rem;
  border-top-right-radius: 0.75rem;
}
.rounded-r-xl {
  border-top-right-radius: 0.75rem;
  border-bottom-right-radius: 0.75rem;
}
.rounded-b-xl {
  border-bottom-right-radius: 0.75rem;
  border-bottom-left-radius: 0.75rem;
}
.rounded-l-xl {
  border-top-left-radius: 0.75rem;
  border-bottom-left-radius: 0.75rem;
}
.rounded-t-2xl {
  border-top-left-radius: 1rem;
  border-top-right-radius: 1rem;
}
.rounded-r-2xl {
  border-top-right-radius: 1rem;
  border-bottom-right-radius: 1rem;
}
.rounded-b-2xl {
  border-bottom-right-radius: 1rem;
  border-bottom-left-radius: 1rem;
}
.rounded-l-2xl {
  border-top-left-radius: 1rem;
  border-bottom-left-radius: 1rem;
}
.rounded-t-3xl {
  border-top-left-radius: 1.5rem;
  border-top-right-radius: 1.5rem;
}
.rounded-r-3xl {
  border-top-right-radius: 1.5rem;
  border-bottom-right-radius: 1.5rem;
}
.rounded-b-3xl {
  border-bottom-right-radius: 1.5rem;
  border-bottom-left-radius: 1.5rem;
}
.rounded-l-3xl {
  border-top-left-radius: 1.5rem;
  border-bottom-left-radius: 1.5rem;
}
.rounded-t-full {
  border-top-left-radius: 9999px;
  border-top-right-radius: 9999px;
}
.rounded-r-full {
  border-top-right-radius: 9999px;
  border-bottom-right-radius: 9999px;
}
.rounded-b-full {
  border-bottom-right-radius: 9999px;
  border-bottom-left-radius: 9999px;
}
.rounded-l-full {
  border-top-left-radius: 9999px;
  border-bottom-left-radius: 9999px;
}
.rounded-tl-none {
  border-top-left-radius: 0;
}
.rounded-tr-none {
  border-top-right-radius: 0;
}
.rounded-br-none {
  border-bottom-right-radius: 0;
}
.rounded-bl-none {
  border-bottom-left-radius: 0;
}
.rounded-tl-sm {
  border-top-left-radius: 0.125rem;
}
.rounded-tr-sm {
  border-top-right-radius: 0.125rem;
}
.rounded-br-sm {
  border-bottom-right-radius: 0.125rem;
}
.rounded-bl-sm {
  border-bottom-left-radius: 0.125rem;
}
.rounded-tl {
  border-top-left-radius: 0.25rem;
}
.rounded-tr {
  border-top-right-radius: 0.25rem;
}
.rounded-br {
  border-bottom-right-radius: 0.25rem;
}
.rounded-bl {
  border-bottom-left-radius: 0.25rem;
}
.rounded-tl-md {
  border-top-left-radius: 0.375rem;
}
.rounded-tr-md {
  border-top-right-radius: 0.375rem;
}
.rounded-br-md {
  border-bottom-right-radius: 0.375rem;
}
.rounded-bl-md {
  border-bottom-left-radius: 0.375rem;
}
.rounded-tl-lg {
  border-top-left-radius: 0.5rem;
}
.rounded-tr-lg {
  border-top-right-radius: 0.5rem;
}
.rounded-br-lg {
  border-bottom-right-radius: 0.5rem;
}
.rounded-bl-lg {
  border-bottom-left-radius: 0.5rem;
}
.rounded-tl-xl {
  border-top-left-radius: 0.75rem;
}
.rounded-tr-xl {
  border-top-right-radius: 0.75rem;
}
.rounded-br-xl {
  border-bottom-right-radius: 0.75rem;
}
.rounded-bl-xl {
  border-bottom-left-radius: 0.75rem;
}
.rounded-tl-2xl {
  border-top-left-radius: 1rem;
}
.rounded-tr-2xl {
  border-top-right-radius: 1rem;
}
.rounded-br-2xl {
  border-bottom-right-radius: 1rem;
}
.rounded-bl-2xl {
  border-bottom-left-radius: 1rem;
}
.rounded-tl-3xl {
  border-top-left-radius: 1.5rem;
}
.rounded-tr-3xl {
  border-top-right-radius: 1.5rem;
}
.rounded-br-3xl {
  border-bottom-right-radius: 1.5rem;
}
.rounded-bl-3xl {
  border-bottom-left-radius: 1.5rem;
}
.rounded-tl-full {
  border-top-left-radius: 9999px;
}
.rounded-tr-full {
  border-top-right-radius: 9999px;
}
.rounded-br-full {
  border-bottom-right-radius: 9999px;
}
.rounded-bl-full {
  border-bottom-left-radius: 9999px;
}
.border-solid {
  border-style: solid;
}
.border-dashed {
  border-style: dashed;
}
.border-dotted {
  border-style: dotted;
}
.border-double {
  border-style: double;
}
.border-none {
  border-style: none;
}
.border-0 {
  border-width: 0;
}
.border-2 {
  border-width: 2px;
}
.border-4 {
  border-width: 4px;
}
.border-8 {
  border-width: 8px;
}
.border {
  border-width: 1px;
}
.border-t-0 {
  border-top-width: 0;
}
.border-r-0 {
  border-right-width: 0;
}
.border-b-0 {
  border-bottom-width: 0;
}
.border-l-0 {
  border-left-width: 0;
}
.border-t-2 {
  border-top-width: 2px;
}
.border-r-2 {
  border-right-width: 2px;
}
.border-b-2 {
  border-bottom-width: 2px;
}
.border-l-2 {
  border-left-width: 2px;
}
.border-t-4 {
  border-top-width: 4px;
}
.border-r-4 {
  border-right-width: 4px;
}
.border-b-4 {
  border-bottom-width: 4px;
}
.border-l-4 {
  border-left-width: 4px;
}
.border-t-8 {
  border-top-width: 8px;
}
.border-r-8 {
  border-right-width: 8px;
}
.border-b-8 {
  border-bottom-width: 8px;
}
.border-l-8 {
  border-left-width: 8px;
}
.border-t {
  border-top-width: 1px;
}
.border-r {
  border-right-width: 1px;
}
.border-b {
  border-bottom-width: 1px;
}
.border-l {
  border-left-width: 1px;
}
.box-border {
  box-sizing: border-box;
}
.box-content {
  box-sizing: content-box;
}
.cursor-auto {
  cursor: auto;
}
.cursor-default {
  cursor: default;
}
.cursor-pointer {
  cursor: pointer;
}
.cursor-wait {
  cursor: wait;
}
.cursor-text {
  cursor: text;
}
.cursor-move {
  cursor: move;
}
.cursor-not-allowed {
  cursor: not-allowed;
}
.block {
  display: block;
}
.inline-block {
  display: inline-block;
}
.inline {
  display: inline;
}
.flex {
  display: flex;
}
.inline-flex {
  display: inline-flex;
}
.table {
  display: table;
}
.table-caption {
  display: table-caption;
}
.table-cell {
  display: table-cell;
}
.table-column {
  display: table-column;
}
.table-column-group {
  display: table-column-group;
}
.table-footer-group {
  display: table-footer-group;
}
.table-header-group {
  display: table-header-group;
}
.table-row-group {
  display: table-row-group;
}
.table-row {
  display: table-row;
}
.flow-root {
  display: flow-root;
}
.grid {
  display: grid;
}
.inline-grid {
  display: inline-grid;
}
.contents {
  display: contents;
}
.hidden {
  display: none;
}
.flex-row {
  flex-direction: row;
}
.flex-row-reverse {
  flex-direction: row-reverse;
}
.flex-col {
  flex-direction: column;
}
.flex-col-reverse {
  flex-direction: column-reverse;
}
.flex-wrap {
  flex-wrap: wrap;
}
.flex-wrap-reverse {
  flex-wrap: wrap-reverse;
}
.flex-no-wrap {
  flex-wrap: nowrap;
}
.place-items-auto {
  place-items: auto;
}
.place-items-start {
  place-items: start;
}
.place-items-end {
  place-items: end;
}
.place-items-center {
  place-items: center;
}
.place-items-stretch {
  place-items: stretch;
}
.place-content-center {
  place-content: center;
}
.place-content-start {
  place-content: start;
}
.place-content-end {
  place-content: end;
}
.place-content-between {
  place-content: space-between;
}
.place-content-around {
  place-content: space-around;
}
.place-content-evenly {
  place-content: space-evenly;
}
.place-content-stretch {
  place-content: stretch;
}
.place-self-auto {
  place-self: auto;
}
.place-self-start {
  place-self: start;
}
.place-self-end {
  place-self: end;
}
.place-self-center {
  place-self: center;
}
.place-self-stretch {
  place-self: stretch;
}
.items-start {
  align-items: flex-start;
}
.items-end {
  align-items: flex-end;
}
.items-center {
  align-items: center;
}
.items-baseline {
  align-items: baseline;
}
.items-stretch {
  align-items: stretch;
}
.content-center {
  align-content: center;
}
.content-start {
  align-content: flex-start;
}
.content-end {
  align-content: flex-end;
}
.content-between {
  align-content: space-between;
}
.content-around {
  align-content: space-around;
}
.content-evenly {
  align-content: space-evenly;
}
.self-auto {
  align-self: auto;
}
.self-start {
  align-self: flex-start;
}
.self-end {
  align-self: flex-end;
}
.self-center {
  align-self: center;
}
.self-stretch {
  align-self: stretch;
}
.justify-items-auto {
  justify-items: auto;
}
.justify-items-start {
  justify-items: start;
}
.justify-items-end {
  justify-items: end;
}
.justify-items-center {
  justify-items: center;
}
.justify-items-stretch {
  justify-items: stretch;
}
.justify-start {
  justify-content: flex-start;
}
.justify-end {
  justify-content: flex-end;
}
.justify-center {
  justify-content: center;
}
.justify-between {
  justify-content: space-between;
}
.justify-around {
  justify-content: space-around;
}
.justify-evenly {
  justify-content: space-evenly;
}
.justify-self-auto {
  justify-self: auto;
}
.justify-self-start {
  justify-self: start;
}
.justify-self-end {
  justify-self: end;
}
.justify-self-center {
  justify-self: center;
}
.justify-self-stretch {
  justify-self: stretch;
}
.flex-1 {
  flex: 1 1;
}
.flex-auto {
  flex: 1 1 auto;
}
.flex-initial {
  flex: 0 1 auto;
}
.flex-none {
  flex: none;
}
.flex-grow-0 {
  flex-grow: 0;
}
.flex-grow {
  flex-grow: 1;
}
.flex-shrink-0 {
  flex-shrink: 0;
}
.flex-shrink {
  flex-shrink: 1;
}
.order-1 {
  order: 1;
}
.order-2 {
  order: 2;
}
.order-3 {
  order: 3;
}
.order-4 {
  order: 4;
}
.order-5 {
  order: 5;
}
.order-6 {
  order: 6;
}
.order-7 {
  order: 7;
}
.order-8 {
  order: 8;
}
.order-9 {
  order: 9;
}
.order-10 {
  order: 10;
}
.order-11 {
  order: 11;
}
.order-12 {
  order: 12;
}
.order-first {
  order: -9999;
}
.order-last {
  order: 9999;
}
.order-none {
  order: 0;
}
.float-right {
  float: right;
}
.float-left {
  float: left;
}
.float-none {
  float: none;
}
.clearfix:after {
  content: "";
  display: table;
  clear: both;
}
.clear-left {
  clear: left;
}
.clear-right {
  clear: right;
}
.clear-both {
  clear: both;
}
.clear-none {
  clear: none;
}
.font-sans {
  font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
}
.font-serif {
  font-family: Georgia, Cambria, "Times New Roman", Times, serif;
}
.font-mono {
  font-family: Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
}
.font-hairline {
  font-weight: 100;
}
.font-thin {
  font-weight: 200;
}
.font-light {
  font-weight: 300;
}
.font-normal {
  font-weight: 400;
}
.font-medium {
  font-weight: 500;
}
.font-semibold {
  font-weight: 600;
}
.font-bold {
  font-weight: 700;
}
.font-extrabold {
  font-weight: 800;
}
.font-black {
  font-weight: 900;
}
.hover\\:font-hairline:hover {
  font-weight: 100;
}
.hover\\:font-thin:hover {
  font-weight: 200;
}
.hover\\:font-light:hover {
  font-weight: 300;
}
.hover\\:font-normal:hover {
  font-weight: 400;
}
.hover\\:font-medium:hover {
  font-weight: 500;
}
.hover\\:font-semibold:hover {
  font-weight: 600;
}
.hover\\:font-bold:hover {
  font-weight: 700;
}
.hover\\:font-extrabold:hover {
  font-weight: 800;
}
.hover\\:font-black:hover {
  font-weight: 900;
}
.focus\\:font-hairline:focus {
  font-weight: 100;
}
.focus\\:font-thin:focus {
  font-weight: 200;
}
.focus\\:font-light:focus {
  font-weight: 300;
}
.focus\\:font-normal:focus {
  font-weight: 400;
}
.focus\\:font-medium:focus {
  font-weight: 500;
}
.focus\\:font-semibold:focus {
  font-weight: 600;
}
.focus\\:font-bold:focus {
  font-weight: 700;
}
.focus\\:font-extrabold:focus {
  font-weight: 800;
}
.focus\\:font-black:focus {
  font-weight: 900;
}
.h-0 {
  height: 0;
}
.h-1 {
  height: 0.25rem;
}
.h-2 {
  height: 0.5rem;
}
.h-3 {
  height: 0.75rem;
}
.h-4 {
  height: 1rem;
}
.h-5 {
  height: 1.25rem;
}
.h-6 {
  height: 1.5rem;
}
.h-7 {
  height: 1.75rem;
}
.h-8 {
  height: 3rem;
}
.h-9 {
  height: 2.25rem;
}
.h-10 {
  height: 2.5rem;
}
.h-11 {
  height: 2.75rem;
}
.h-12 {
  height: 3rem;
}
.h-13 {
  height: 3.25rem;
}
.h-14 {
  height: 3.5rem;
}
.h-15 {
  height: 3.75rem;
}
.h-16 {
  height: 4rem;
}
.h-20 {
  height: 5rem;
}
.h-24 {
  height: 6rem;
}
.h-28 {
  height: 7rem;
}
.h-32 {
  height: 8rem;
}
.h-36 {
  height: 9rem;
}
.h-40 {
  height: 10rem;
}
.h-44 {
  height: 11rem;
}
.h-48 {
  height: 12rem;
}
.h-52 {
  height: 13rem;
}
.h-56 {
  height: 14rem;
}
.h-60 {
  height: 15rem;
}
.h-64 {
  height: 16rem;
}
.h-72 {
  height: 18rem;
}
.h-80 {
  height: 20rem;
}
.h-96 {
  height: 24rem;
}
.h-auto {
  height: auto;
}
.h-px {
  height: 1px;
}
.h-0\\.5 {
  height: 0.125rem;
}
.h-1\\.5 {
  height: 0.375rem;
}
.h-2\\.5 {
  height: 0.625rem;
}
.h-3\\.5 {
  height: 0.875rem;
}
.h-1\\/2 {
  height: 50%;
}
.h-1\\/3 {
  height: 33.333333%;
}
.h-2\\/3 {
  height: 66.666667%;
}
.h-1\\/4 {
  height: 25%;
}
.h-2\\/4 {
  height: 50%;
}
.h-3\\/4 {
  height: 75%;
}
.h-1\\/5 {
  height: 20%;
}
.h-2\\/5 {
  height: 40%;
}
.h-3\\/5 {
  height: 60%;
}
.h-4\\/5 {
  height: 80%;
}
.h-1\\/6 {
  height: 16.666667%;
}
.h-2\\/6 {
  height: 33.333333%;
}
.h-3\\/6 {
  height: 50%;
}
.h-4\\/6 {
  height: 66.666667%;
}
.h-5\\/6 {
  height: 83.333333%;
}
.h-1\\/12 {
  height: 8.333333%;
}
.h-2\\/12 {
  height: 16.666667%;
}
.h-3\\/12 {
  height: 25%;
}
.h-4\\/12 {
  height: 33.333333%;
}
.h-5\\/12 {
  height: 41.666667%;
}
.h-6\\/12 {
  height: 50%;
}
.h-7\\/12 {
  height: 58.333333%;
}
.h-8\\/12 {
  height: 66.666667%;
}
.h-9\\/12 {
  height: 75%;
}
.h-10\\/12 {
  height: 83.333333%;
}
.h-11\\/12 {
  height: 91.666667%;
}
.h-full {
  height: 100%;
}
.h-screen {
  height: 100vh;
}
.text-xs {
  font-size: 0.75rem;
}
.text-sm {
  font-size: 0.875rem;
}
.text-base {
  font-size: 1rem;
}
.text-lg {
  font-size: 1.125rem;
}
.text-xl {
  font-size: 1.25rem;
}
.text-2xl {
  font-size: 1.5rem;
}
.text-3xl {
  font-size: 1.875rem;
}
.text-4xl {
  font-size: 2.25rem;
}
.text-5xl {
  font-size: 3rem;
}
.text-6xl {
  font-size: 4rem;
}
.leading-3 {
  line-height: .75rem;
}
.leading-4 {
  line-height: 1rem;
}
.leading-5 {
  line-height: 1.25rem;
}
.leading-6 {
  line-height: 1.5rem;
}
.leading-7 {
  line-height: 1.75rem;
}
.leading-8 {
  line-height: 2rem;
}
.leading-9 {
  line-height: 2.25rem;
}
.leading-10 {
  line-height: 2.5rem;
}
.leading-none {
  line-height: 1;
}
.leading-tight {
  line-height: 1.25;
}
.leading-snug {
  line-height: 1.375;
}
.leading-normal {
  line-height: 1.5;
}
.leading-relaxed {
  line-height: 1.625;
}
.leading-loose {
  line-height: 2;
}
.list-inside {
  list-style-position: inside;
}
.list-outside {
  list-style-position: outside;
}
.list-none {
  list-style-type: none;
}
.list-disc {
  list-style-type: disc;
}
.list-decimal {
  list-style-type: decimal;
}
.m-0 {
  margin: 0;
}
.m-1 {
  margin: 0.25rem;
}
.m-2 {
  margin: 0.5rem;
}
.m-3 {
  margin: 0.75rem;
}
.m-4 {
  margin: 1rem;
}
.m-5 {
  margin: 1.25rem;
}
.m-6 {
  margin: 1.5rem;
}
.m-7 {
  margin: 1.75rem;
}
.m-8 {
  margin: 2rem;
}
.m-9 {
  margin: 2.25rem;
}
.m-10 {
  margin: 2.5rem;
}
.m-11 {
  margin: 2.75rem;
}
.m-12 {
  margin: 3rem;
}
.m-13 {
  margin: 3.25rem;
}
.m-14 {
  margin: 3.5rem;
}
.m-15 {
  margin: 3.75rem;
}
.m-16 {
  margin: 4rem;
}
.m-20 {
  margin: 5rem;
}
.m-24 {
  margin: 6rem;
}
.m-28 {
  margin: 7rem;
}
.m-32 {
  margin: 8rem;
}
.m-36 {
  margin: 9rem;
}
.m-40 {
  margin: 10rem;
}
.m-44 {
  margin: 11rem;
}
.m-48 {
  margin: 12rem;
}
.m-52 {
  margin: 13rem;
}
.m-56 {
  margin: 14rem;
}
.m-60 {
  margin: 15rem;
}
.m-64 {
  margin: 16rem;
}
.m-72 {
  margin: 18rem;
}
.m-80 {
  margin: 20rem;
}
.m-96 {
  margin: 24rem;
}
.m-auto {
  margin: auto;
}
.m-px {
  margin: 1px;
}
.m-0\\.5 {
  margin: 0.125rem;
}
.m-1\\.5 {
  margin: 0.375rem;
}
.m-2\\.5 {
  margin: 0.625rem;
}
.m-3\\.5 {
  margin: 0.875rem;
}
.m-1\\/2 {
  margin: 50%;
}
.m-1\\/3 {
  margin: 33.333333%;
}
.m-2\\/3 {
  margin: 66.666667%;
}
.m-1\\/4 {
  margin: 25%;
}
.m-2\\/4 {
  margin: 50%;
}
.m-3\\/4 {
  margin: 75%;
}
.m-1\\/5 {
  margin: 20%;
}
.m-2\\/5 {
  margin: 40%;
}
.m-3\\/5 {
  margin: 60%;
}
.m-4\\/5 {
  margin: 80%;
}
.m-1\\/6 {
  margin: 16.666667%;
}
.m-2\\/6 {
  margin: 33.333333%;
}
.m-3\\/6 {
  margin: 50%;
}
.m-4\\/6 {
  margin: 66.666667%;
}
.m-5\\/6 {
  margin: 83.333333%;
}
.m-1\\/12 {
  margin: 8.333333%;
}
.m-2\\/12 {
  margin: 16.666667%;
}
.m-3\\/12 {
  margin: 25%;
}
.m-4\\/12 {
  margin: 33.333333%;
}
.m-5\\/12 {
  margin: 41.666667%;
}
.m-6\\/12 {
  margin: 50%;
}
.m-7\\/12 {
  margin: 58.333333%;
}
.m-8\\/12 {
  margin: 66.666667%;
}
.m-9\\/12 {
  margin: 75%;
}
.m-10\\/12 {
  margin: 83.333333%;
}
.m-11\\/12 {
  margin: 91.666667%;
}
.m-full {
  margin: 100%;
}
.-m-1 {
  margin: -0.25rem;
}
.-m-2 {
  margin: -0.5rem;
}
.-m-3 {
  margin: -0.75rem;
}
.-m-4 {
  margin: -1rem;
}
.-m-5 {
  margin: -1.25rem;
}
.-m-6 {
  margin: -1.5rem;
}
.-m-7 {
  margin: -1.75rem;
}
.-m-8 {
  margin: -2rem;
}
.-m-9 {
  margin: -2.25rem;
}
.-m-10 {
  margin: -2.5rem;
}
.-m-11 {
  margin: -2.75rem;
}
.-m-12 {
  margin: -3rem;
}
.-m-13 {
  margin: -3.25rem;
}
.-m-14 {
  margin: -3.5rem;
}
.-m-15 {
  margin: -3.75rem;
}
.-m-16 {
  margin: -4rem;
}
.-m-20 {
  margin: -5rem;
}
.-m-24 {
  margin: -6rem;
}
.-m-28 {
  margin: -7rem;
}
.-m-32 {
  margin: -8rem;
}
.-m-36 {
  margin: -9rem;
}
.-m-40 {
  margin: -10rem;
}
.-m-44 {
  margin: -11rem;
}
.-m-48 {
  margin: -12rem;
}
.-m-52 {
  margin: -13rem;
}
.-m-56 {
  margin: -14rem;
}
.-m-60 {
  margin: -15rem;
}
.-m-64 {
  margin: -16rem;
}
.-m-72 {
  margin: -18rem;
}
.-m-80 {
  margin: -20rem;
}
.-m-96 {
  margin: -24rem;
}
.-m-px {
  margin: -1px;
}
.-m-0\\.5 {
  margin: -0.125rem;
}
.-m-1\\.5 {
  margin: -0.375rem;
}
.-m-2\\.5 {
  margin: -0.625rem;
}
.-m-3\\.5 {
  margin: -0.875rem;
}
.-m-1\\/2 {
  margin: -50%;
}
.-m-1\\/3 {
  margin: -33.33333%;
}
.-m-2\\/3 {
  margin: -66.66667%;
}
.-m-1\\/4 {
  margin: -25%;
}
.-m-2\\/4 {
  margin: -50%;
}
.-m-3\\/4 {
  margin: -75%;
}
.-m-1\\/5 {
  margin: -20%;
}
.-m-2\\/5 {
  margin: -40%;
}
.-m-3\\/5 {
  margin: -60%;
}
.-m-4\\/5 {
  margin: -80%;
}
.-m-1\\/6 {
  margin: -16.66667%;
}
.-m-2\\/6 {
  margin: -33.33333%;
}
.-m-3\\/6 {
  margin: -50%;
}
.-m-4\\/6 {
  margin: -66.66667%;
}
.-m-5\\/6 {
  margin: -83.33333%;
}
.-m-1\\/12 {
  margin: -8.33333%;
}
.-m-2\\/12 {
  margin: -16.66667%;
}
.-m-3\\/12 {
  margin: -25%;
}
.-m-4\\/12 {
  margin: -33.33333%;
}
.-m-5\\/12 {
  margin: -41.66667%;
}
.-m-6\\/12 {
  margin: -50%;
}
.-m-7\\/12 {
  margin: -58.33333%;
}
.-m-8\\/12 {
  margin: -66.66667%;
}
.-m-9\\/12 {
  margin: -75%;
}
.-m-10\\/12 {
  margin: -83.33333%;
}
.-m-11\\/12 {
  margin: -91.66667%;
}
.-m-full {
  margin: -100%;
}
.my-0 {
  margin-top: 0;
  margin-bottom: 0;
}
.mx-0 {
  margin-left: 0;
  margin-right: 0;
}
.my-1 {
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
}
.mx-1 {
  margin-left: 0.25rem;
  margin-right: 0.25rem;
}
.my-2 {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
.mx-2 {
  margin-left: 0.5rem;
  margin-right: 0.5rem;
}
.my-3 {
  margin-top: 0.75rem;
  margin-bottom: 0.75rem;
}
.mx-3 {
  margin-left: 0.75rem;
  margin-right: 0.75rem;
}
.my-4 {
  margin-top: 1rem;
  margin-bottom: 1rem;
}
.mx-4 {
  margin-left: 1rem;
  margin-right: 1rem;
}
.my-5 {
  margin-top: 1.25rem;
  margin-bottom: 1.25rem;
}
.mx-5 {
  margin-left: 1.25rem;
  margin-right: 1.25rem;
}
.my-6 {
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;
}
.mx-6 {
  margin-left: 1.5rem;
  margin-right: 1.5rem;
}
.my-7 {
  margin-top: 1.75rem;
  margin-bottom: 1.75rem;
}
.mx-7 {
  margin-left: 1.75rem;
  margin-right: 1.75rem;
}
.my-8 {
  margin-top: 2rem;
  margin-bottom: 2rem;
}
.mx-8 {
  margin-left: 2rem;
  margin-right: 2rem;
}
.my-9 {
  margin-top: 2.25rem;
  margin-bottom: 2.25rem;
}
.mx-9 {
  margin-left: 2.25rem;
  margin-right: 2.25rem;
}
.my-10 {
  margin-top: 2.5rem;
  margin-bottom: 2.5rem;
}
.mx-10 {
  margin-left: 2.5rem;
  margin-right: 2.5rem;
}
.my-11 {
  margin-top: 2.75rem;
  margin-bottom: 2.75rem;
}
.mx-11 {
  margin-left: 2.75rem;
  margin-right: 2.75rem;
}
.my-12 {
  margin-top: 3rem;
  margin-bottom: 3rem;
}
.mx-12 {
  margin-left: 3rem;
  margin-right: 3rem;
}
.my-13 {
  margin-top: 3.25rem;
  margin-bottom: 3.25rem;
}
.mx-13 {
  margin-left: 3.25rem;
  margin-right: 3.25rem;
}
.my-14 {
  margin-top: 3.5rem;
  margin-bottom: 3.5rem;
}
.mx-14 {
  margin-left: 3.5rem;
  margin-right: 3.5rem;
}
.my-15 {
  margin-top: 3.75rem;
  margin-bottom: 3.75rem;
}
.mx-15 {
  margin-left: 3.75rem;
  margin-right: 3.75rem;
}
.my-16 {
  margin-top: 4rem;
  margin-bottom: 4rem;
}
.mx-16 {
  margin-left: 4rem;
  margin-right: 4rem;
}
.my-20 {
  margin-top: 5rem;
  margin-bottom: 5rem;
}
.mx-20 {
  margin-left: 5rem;
  margin-right: 5rem;
}
.my-24 {
  margin-top: 6rem;
  margin-bottom: 6rem;
}
.mx-24 {
  margin-left: 6rem;
  margin-right: 6rem;
}
.my-28 {
  margin-top: 7rem;
  margin-bottom: 7rem;
}
.mx-28 {
  margin-left: 7rem;
  margin-right: 7rem;
}
.my-32 {
  margin-top: 8rem;
  margin-bottom: 8rem;
}
.mx-32 {
  margin-left: 8rem;
  margin-right: 8rem;
}
.my-36 {
  margin-top: 9rem;
  margin-bottom: 9rem;
}
.mx-36 {
  margin-left: 9rem;
  margin-right: 9rem;
}
.my-40 {
  margin-top: 10rem;
  margin-bottom: 10rem;
}
.mx-40 {
  margin-left: 10rem;
  margin-right: 10rem;
}
.my-44 {
  margin-top: 11rem;
  margin-bottom: 11rem;
}
.mx-44 {
  margin-left: 11rem;
  margin-right: 11rem;
}
.my-48 {
  margin-top: 12rem;
  margin-bottom: 12rem;
}
.mx-48 {
  margin-left: 12rem;
  margin-right: 12rem;
}
.my-52 {
  margin-top: 13rem;
  margin-bottom: 13rem;
}
.mx-52 {
  margin-left: 13rem;
  margin-right: 13rem;
}
.my-56 {
  margin-top: 14rem;
  margin-bottom: 14rem;
}
.mx-56 {
  margin-left: 14rem;
  margin-right: 14rem;
}
.my-60 {
  margin-top: 15rem;
  margin-bottom: 15rem;
}
.mx-60 {
  margin-left: 15rem;
  margin-right: 15rem;
}
.my-64 {
  margin-top: 16rem;
  margin-bottom: 16rem;
}
.mx-64 {
  margin-left: 16rem;
  margin-right: 16rem;
}
.my-72 {
  margin-top: 18rem;
  margin-bottom: 18rem;
}
.mx-72 {
  margin-left: 18rem;
  margin-right: 18rem;
}
.my-80 {
  margin-top: 20rem;
  margin-bottom: 20rem;
}
.mx-80 {
  margin-left: 20rem;
  margin-right: 20rem;
}
.my-96 {
  margin-top: 24rem;
  margin-bottom: 24rem;
}
.mx-96 {
  margin-left: 24rem;
  margin-right: 24rem;
}
.my-auto {
  margin-top: auto;
  margin-bottom: auto;
}
.mx-auto {
  margin-left: auto;
  margin-right: auto;
}
.my-px {
  margin-top: 1px;
  margin-bottom: 1px;
}
.mx-px {
  margin-left: 1px;
  margin-right: 1px;
}
.my-0\\.5 {
  margin-top: 0.125rem;
  margin-bottom: 0.125rem;
}
.mx-0\\.5 {
  margin-left: 0.125rem;
  margin-right: 0.125rem;
}
.my-1\\.5 {
  margin-top: 0.375rem;
  margin-bottom: 0.375rem;
}
.mx-1\\.5 {
  margin-left: 0.375rem;
  margin-right: 0.375rem;
}
.my-2\\.5 {
  margin-top: 0.625rem;
  margin-bottom: 0.625rem;
}
.mx-2\\.5 {
  margin-left: 0.625rem;
  margin-right: 0.625rem;
}
.my-3\\.5 {
  margin-top: 0.875rem;
  margin-bottom: 0.875rem;
}
.mx-3\\.5 {
  margin-left: 0.875rem;
  margin-right: 0.875rem;
}
.my-1\\/2 {
  margin-top: 50%;
  margin-bottom: 50%;
}
.mx-1\\/2 {
  margin-left: 50%;
  margin-right: 50%;
}
.my-1\\/3 {
  margin-top: 33.333333%;
  margin-bottom: 33.333333%;
}
.mx-1\\/3 {
  margin-left: 33.333333%;
  margin-right: 33.333333%;
}
.my-2\\/3 {
  margin-top: 66.666667%;
  margin-bottom: 66.666667%;
}
.mx-2\\/3 {
  margin-left: 66.666667%;
  margin-right: 66.666667%;
}
.my-1\\/4 {
  margin-top: 25%;
  margin-bottom: 25%;
}
.mx-1\\/4 {
  margin-left: 25%;
  margin-right: 25%;
}
.my-2\\/4 {
  margin-top: 50%;
  margin-bottom: 50%;
}
.mx-2\\/4 {
  margin-left: 50%;
  margin-right: 50%;
}
.my-3\\/4 {
  margin-top: 75%;
  margin-bottom: 75%;
}
.mx-3\\/4 {
  margin-left: 75%;
  margin-right: 75%;
}
.my-1\\/5 {
  margin-top: 20%;
  margin-bottom: 20%;
}
.mx-1\\/5 {
  margin-left: 20%;
  margin-right: 20%;
}
.my-2\\/5 {
  margin-top: 40%;
  margin-bottom: 40%;
}
.mx-2\\/5 {
  margin-left: 40%;
  margin-right: 40%;
}
.my-3\\/5 {
  margin-top: 60%;
  margin-bottom: 60%;
}
.mx-3\\/5 {
  margin-left: 60%;
  margin-right: 60%;
}
.my-4\\/5 {
  margin-top: 80%;
  margin-bottom: 80%;
}
.mx-4\\/5 {
  margin-left: 80%;
  margin-right: 80%;
}
.my-1\\/6 {
  margin-top: 16.666667%;
  margin-bottom: 16.666667%;
}
.mx-1\\/6 {
  margin-left: 16.666667%;
  margin-right: 16.666667%;
}
.my-2\\/6 {
  margin-top: 33.333333%;
  margin-bottom: 33.333333%;
}
.mx-2\\/6 {
  margin-left: 33.333333%;
  margin-right: 33.333333%;
}
.my-3\\/6 {
  margin-top: 50%;
  margin-bottom: 50%;
}
.mx-3\\/6 {
  margin-left: 50%;
  margin-right: 50%;
}
.my-4\\/6 {
  margin-top: 66.666667%;
  margin-bottom: 66.666667%;
}
.mx-4\\/6 {
  margin-left: 66.666667%;
  margin-right: 66.666667%;
}
.my-5\\/6 {
  margin-top: 83.333333%;
  margin-bottom: 83.333333%;
}
.mx-5\\/6 {
  margin-left: 83.333333%;
  margin-right: 83.333333%;
}
.my-1\\/12 {
  margin-top: 8.333333%;
  margin-bottom: 8.333333%;
}
.mx-1\\/12 {
  margin-left: 8.333333%;
  margin-right: 8.333333%;
}
.my-2\\/12 {
  margin-top: 16.666667%;
  margin-bottom: 16.666667%;
}
.mx-2\\/12 {
  margin-left: 16.666667%;
  margin-right: 16.666667%;
}
.my-3\\/12 {
  margin-top: 25%;
  margin-bottom: 25%;
}
.mx-3\\/12 {
  margin-left: 25%;
  margin-right: 25%;
}
.my-4\\/12 {
  margin-top: 33.333333%;
  margin-bottom: 33.333333%;
}
.mx-4\\/12 {
  margin-left: 33.333333%;
  margin-right: 33.333333%;
}
.my-5\\/12 {
  margin-top: 41.666667%;
  margin-bottom: 41.666667%;
}
.mx-5\\/12 {
  margin-left: 41.666667%;
  margin-right: 41.666667%;
}
.my-6\\/12 {
  margin-top: 50%;
  margin-bottom: 50%;
}
.mx-6\\/12 {
  margin-left: 50%;
  margin-right: 50%;
}
.my-7\\/12 {
  margin-top: 58.333333%;
  margin-bottom: 58.333333%;
}
.mx-7\\/12 {
  margin-left: 58.333333%;
  margin-right: 58.333333%;
}
.my-8\\/12 {
  margin-top: 66.666667%;
  margin-bottom: 66.666667%;
}
.mx-8\\/12 {
  margin-left: 66.666667%;
  margin-right: 66.666667%;
}
.my-9\\/12 {
  margin-top: 75%;
  margin-bottom: 75%;
}
.mx-9\\/12 {
  margin-left: 75%;
  margin-right: 75%;
}
.my-10\\/12 {
  margin-top: 83.333333%;
  margin-bottom: 83.333333%;
}
.mx-10\\/12 {
  margin-left: 83.333333%;
  margin-right: 83.333333%;
}
.my-11\\/12 {
  margin-top: 91.666667%;
  margin-bottom: 91.666667%;
}
.mx-11\\/12 {
  margin-left: 91.666667%;
  margin-right: 91.666667%;
}
.my-full {
  margin-top: 100%;
  margin-bottom: 100%;
}
.mx-full {
  margin-left: 100%;
  margin-right: 100%;
}
.-my-1 {
  margin-top: -0.25rem;
  margin-bottom: -0.25rem;
}
.-mx-1 {
  margin-left: -0.25rem;
  margin-right: -0.25rem;
}
.-my-2 {
  margin-top: -0.5rem;
  margin-bottom: -0.5rem;
}
.-mx-2 {
  margin-left: -0.5rem;
  margin-right: -0.5rem;
}
.-my-3 {
  margin-top: -0.75rem;
  margin-bottom: -0.75rem;
}
.-mx-3 {
  margin-left: -0.75rem;
  margin-right: -0.75rem;
}
.-my-4 {
  margin-top: -1rem;
  margin-bottom: -1rem;
}
.-mx-4 {
  margin-left: -1rem;
  margin-right: -1rem;
}
.-my-5 {
  margin-top: -1.25rem;
  margin-bottom: -1.25rem;
}
.-mx-5 {
  margin-left: -1.25rem;
  margin-right: -1.25rem;
}
.-my-6 {
  margin-top: -1.5rem;
  margin-bottom: -1.5rem;
}
.-mx-6 {
  margin-left: -1.5rem;
  margin-right: -1.5rem;
}
.-my-7 {
  margin-top: -1.75rem;
  margin-bottom: -1.75rem;
}
.-mx-7 {
  margin-left: -1.75rem;
  margin-right: -1.75rem;
}
.-my-8 {
  margin-top: -2rem;
  margin-bottom: -2rem;
}
.-mx-8 {
  margin-left: -2rem;
  margin-right: -2rem;
}
.-my-9 {
  margin-top: -2.25rem;
  margin-bottom: -2.25rem;
}
.-mx-9 {
  margin-left: -2.25rem;
  margin-right: -2.25rem;
}
.-my-10 {
  margin-top: -2.5rem;
  margin-bottom: -2.5rem;
}
.-mx-10 {
  margin-left: -2.5rem;
  margin-right: -2.5rem;
}
.-my-11 {
  margin-top: -2.75rem;
  margin-bottom: -2.75rem;
}
.-mx-11 {
  margin-left: -2.75rem;
  margin-right: -2.75rem;
}
.-my-12 {
  margin-top: -3rem;
  margin-bottom: -3rem;
}
.-mx-12 {
  margin-left: -3rem;
  margin-right: -3rem;
}
.-my-13 {
  margin-top: -3.25rem;
  margin-bottom: -3.25rem;
}
.-mx-13 {
  margin-left: -3.25rem;
  margin-right: -3.25rem;
}
.-my-14 {
  margin-top: -3.5rem;
  margin-bottom: -3.5rem;
}
.-mx-14 {
  margin-left: -3.5rem;
  margin-right: -3.5rem;
}
.-my-15 {
  margin-top: -3.75rem;
  margin-bottom: -3.75rem;
}
.-mx-15 {
  margin-left: -3.75rem;
  margin-right: -3.75rem;
}
.-my-16 {
  margin-top: -4rem;
  margin-bottom: -4rem;
}
.-mx-16 {
  margin-left: -4rem;
  margin-right: -4rem;
}
.-my-20 {
  margin-top: -5rem;
  margin-bottom: -5rem;
}
.-mx-20 {
  margin-left: -5rem;
  margin-right: -5rem;
}
.-my-24 {
  margin-top: -6rem;
  margin-bottom: -6rem;
}
.-mx-24 {
  margin-left: -6rem;
  margin-right: -6rem;
}
.-my-28 {
  margin-top: -7rem;
  margin-bottom: -7rem;
}
.-mx-28 {
  margin-left: -7rem;
  margin-right: -7rem;
}
.-my-32 {
  margin-top: -8rem;
  margin-bottom: -8rem;
}
.-mx-32 {
  margin-left: -8rem;
  margin-right: -8rem;
}
.-my-36 {
  margin-top: -9rem;
  margin-bottom: -9rem;
}
.-mx-36 {
  margin-left: -9rem;
  margin-right: -9rem;
}
.-my-40 {
  margin-top: -10rem;
  margin-bottom: -10rem;
}
.-mx-40 {
  margin-left: -10rem;
  margin-right: -10rem;
}
.-my-44 {
  margin-top: -11rem;
  margin-bottom: -11rem;
}
.-mx-44 {
  margin-left: -11rem;
  margin-right: -11rem;
}
.-my-48 {
  margin-top: -12rem;
  margin-bottom: -12rem;
}
.-mx-48 {
  margin-left: -12rem;
  margin-right: -12rem;
}
.-my-52 {
  margin-top: -13rem;
  margin-bottom: -13rem;
}
.-mx-52 {
  margin-left: -13rem;
  margin-right: -13rem;
}
.-my-56 {
  margin-top: -14rem;
  margin-bottom: -14rem;
}
.-mx-56 {
  margin-left: -14rem;
  margin-right: -14rem;
}
.-my-60 {
  margin-top: -15rem;
  margin-bottom: -15rem;
}
.-mx-60 {
  margin-left: -15rem;
  margin-right: -15rem;
}
.-my-64 {
  margin-top: -16rem;
  margin-bottom: -16rem;
}
.-mx-64 {
  margin-left: -16rem;
  margin-right: -16rem;
}
.-my-72 {
  margin-top: -18rem;
  margin-bottom: -18rem;
}
.-mx-72 {
  margin-left: -18rem;
  margin-right: -18rem;
}
.-my-80 {
  margin-top: -20rem;
  margin-bottom: -20rem;
}
.-mx-80 {
  margin-left: -20rem;
  margin-right: -20rem;
}
.-my-96 {
  margin-top: -24rem;
  margin-bottom: -24rem;
}
.-mx-96 {
  margin-left: -24rem;
  margin-right: -24rem;
}
.-my-px {
  margin-top: -1px;
  margin-bottom: -1px;
}
.-mx-px {
  margin-left: -1px;
  margin-right: -1px;
}
.-my-0\\.5 {
  margin-top: -0.125rem;
  margin-bottom: -0.125rem;
}
.-mx-0\\.5 {
  margin-left: -0.125rem;
  margin-right: -0.125rem;
}
.-my-1\\.5 {
  margin-top: -0.375rem;
  margin-bottom: -0.375rem;
}
.-mx-1\\.5 {
  margin-left: -0.375rem;
  margin-right: -0.375rem;
}
.-my-2\\.5 {
  margin-top: -0.625rem;
  margin-bottom: -0.625rem;
}
.-mx-2\\.5 {
  margin-left: -0.625rem;
  margin-right: -0.625rem;
}
.-my-3\\.5 {
  margin-top: -0.875rem;
  margin-bottom: -0.875rem;
}
.-mx-3\\.5 {
  margin-left: -0.875rem;
  margin-right: -0.875rem;
}
.-my-1\\/2 {
  margin-top: -50%;
  margin-bottom: -50%;
}
.-mx-1\\/2 {
  margin-left: -50%;
  margin-right: -50%;
}
.-my-1\\/3 {
  margin-top: -33.33333%;
  margin-bottom: -33.33333%;
}
.-mx-1\\/3 {
  margin-left: -33.33333%;
  margin-right: -33.33333%;
}
.-my-2\\/3 {
  margin-top: -66.66667%;
  margin-bottom: -66.66667%;
}
.-mx-2\\/3 {
  margin-left: -66.66667%;
  margin-right: -66.66667%;
}
.-my-1\\/4 {
  margin-top: -25%;
  margin-bottom: -25%;
}
.-mx-1\\/4 {
  margin-left: -25%;
  margin-right: -25%;
}
.-my-2\\/4 {
  margin-top: -50%;
  margin-bottom: -50%;
}
.-mx-2\\/4 {
  margin-left: -50%;
  margin-right: -50%;
}
.-my-3\\/4 {
  margin-top: -75%;
  margin-bottom: -75%;
}
.-mx-3\\/4 {
  margin-left: -75%;
  margin-right: -75%;
}
.-my-1\\/5 {
  margin-top: -20%;
  margin-bottom: -20%;
}
.-mx-1\\/5 {
  margin-left: -20%;
  margin-right: -20%;
}
.-my-2\\/5 {
  margin-top: -40%;
  margin-bottom: -40%;
}
.-mx-2\\/5 {
  margin-left: -40%;
  margin-right: -40%;
}
.-my-3\\/5 {
  margin-top: -60%;
  margin-bottom: -60%;
}
.-mx-3\\/5 {
  margin-left: -60%;
  margin-right: -60%;
}
.-my-4\\/5 {
  margin-top: -80%;
  margin-bottom: -80%;
}
.-mx-4\\/5 {
  margin-left: -80%;
  margin-right: -80%;
}
.-my-1\\/6 {
  margin-top: -16.66667%;
  margin-bottom: -16.66667%;
}
.-mx-1\\/6 {
  margin-left: -16.66667%;
  margin-right: -16.66667%;
}
.-my-2\\/6 {
  margin-top: -33.33333%;
  margin-bottom: -33.33333%;
}
.-mx-2\\/6 {
  margin-left: -33.33333%;
  margin-right: -33.33333%;
}
.-my-3\\/6 {
  margin-top: -50%;
  margin-bottom: -50%;
}
.-mx-3\\/6 {
  margin-left: -50%;
  margin-right: -50%;
}
.-my-4\\/6 {
  margin-top: -66.66667%;
  margin-bottom: -66.66667%;
}
.-mx-4\\/6 {
  margin-left: -66.66667%;
  margin-right: -66.66667%;
}
.-my-5\\/6 {
  margin-top: -83.33333%;
  margin-bottom: -83.33333%;
}
.-mx-5\\/6 {
  margin-left: -83.33333%;
  margin-right: -83.33333%;
}
.-my-1\\/12 {
  margin-top: -8.33333%;
  margin-bottom: -8.33333%;
}
.-mx-1\\/12 {
  margin-left: -8.33333%;
  margin-right: -8.33333%;
}
.-my-2\\/12 {
  margin-top: -16.66667%;
  margin-bottom: -16.66667%;
}
.-mx-2\\/12 {
  margin-left: -16.66667%;
  margin-right: -16.66667%;
}
.-my-3\\/12 {
  margin-top: -25%;
  margin-bottom: -25%;
}
.-mx-3\\/12 {
  margin-left: -25%;
  margin-right: -25%;
}
.-my-4\\/12 {
  margin-top: -33.33333%;
  margin-bottom: -33.33333%;
}
.-mx-4\\/12 {
  margin-left: -33.33333%;
  margin-right: -33.33333%;
}
.-my-5\\/12 {
  margin-top: -41.66667%;
  margin-bottom: -41.66667%;
}
.-mx-5\\/12 {
  margin-left: -41.66667%;
  margin-right: -41.66667%;
}
.-my-6\\/12 {
  margin-top: -50%;
  margin-bottom: -50%;
}
.-mx-6\\/12 {
  margin-left: -50%;
  margin-right: -50%;
}
.-my-7\\/12 {
  margin-top: -58.33333%;
  margin-bottom: -58.33333%;
}
.-mx-7\\/12 {
  margin-left: -58.33333%;
  margin-right: -58.33333%;
}
.-my-8\\/12 {
  margin-top: -66.66667%;
  margin-bottom: -66.66667%;
}
.-mx-8\\/12 {
  margin-left: -66.66667%;
  margin-right: -66.66667%;
}
.-my-9\\/12 {
  margin-top: -75%;
  margin-bottom: -75%;
}
.-mx-9\\/12 {
  margin-left: -75%;
  margin-right: -75%;
}
.-my-10\\/12 {
  margin-top: -83.33333%;
  margin-bottom: -83.33333%;
}
.-mx-10\\/12 {
  margin-left: -83.33333%;
  margin-right: -83.33333%;
}
.-my-11\\/12 {
  margin-top: -91.66667%;
  margin-bottom: -91.66667%;
}
.-mx-11\\/12 {
  margin-left: -91.66667%;
  margin-right: -91.66667%;
}
.-my-full {
  margin-top: -100%;
  margin-bottom: -100%;
}
.-mx-full {
  margin-left: -100%;
  margin-right: -100%;
}
.mt-0 {
  margin-top: 0;
}
.mr-0 {
  margin-right: 0;
}
.mb-0 {
  margin-bottom: 0;
}
.ml-0 {
  margin-left: 0;
}
.mt-1 {
  margin-top: 0.25rem;
}
.mr-1 {
  margin-right: 0.25rem;
}
.mb-1 {
  margin-bottom: 0.25rem;
}
.ml-1 {
  margin-left: 0.25rem;
}
.mt-2 {
  margin-top: 0.5rem;
}
.mr-2 {
  margin-right: 0.5rem;
}
.mb-2 {
  margin-bottom: 0.5rem;
}
.ml-2 {
  margin-left: 0.5rem;
}
.mt-3 {
  margin-top: 0.75rem;
}
.mr-3 {
  margin-right: 0.75rem;
}
.mb-3 {
  margin-bottom: 0.75rem;
}
.ml-3 {
  margin-left: 0.75rem;
}
.mt-4 {
  margin-top: 1rem;
}
.mr-4 {
  margin-right: 1rem;
}
.mb-4 {
  margin-bottom: 1rem;
}
.ml-4 {
  margin-left: 1rem;
}
.mt-5 {
  margin-top: 1.25rem;
}
.mr-5 {
  margin-right: 1.25rem;
}
.mb-5 {
  margin-bottom: 1.25rem;
}
.ml-5 {
  margin-left: 1.25rem;
}
.mt-6 {
  margin-top: 1.5rem;
}
.mr-6 {
  margin-right: 1.5rem;
}
.mb-6 {
  margin-bottom: 1.5rem;
}
.ml-6 {
  margin-left: 1.5rem;
}
.mt-7 {
  margin-top: 1.75rem;
}
.mr-7 {
  margin-right: 1.75rem;
}
.mb-7 {
  margin-bottom: 1.75rem;
}
.ml-7 {
  margin-left: 1.75rem;
}
.mt-8 {
  margin-top: 2rem;
}
.mr-8 {
  margin-right: 2rem;
}
.mb-8 {
  margin-bottom: 2rem;
}
.ml-8 {
  margin-left: 2rem;
}
.mt-9 {
  margin-top: 2.25rem;
}
.mr-9 {
  margin-right: 2.25rem;
}
.mb-9 {
  margin-bottom: 2.25rem;
}
.ml-9 {
  margin-left: 2.25rem;
}
.mt-10 {
  margin-top: 2.5rem;
}
.mr-10 {
  margin-right: 2.5rem;
}
.mb-10 {
  margin-bottom: 2.5rem;
}
.ml-10 {
  margin-left: 2.5rem;
}
.mt-11 {
  margin-top: 2.75rem;
}
.mr-11 {
  margin-right: 2.75rem;
}
.mb-11 {
  margin-bottom: 2.75rem;
}
.ml-11 {
  margin-left: 2.75rem;
}
.mt-12 {
  margin-top: 3rem;
}
.mr-12 {
  margin-right: 3rem;
}
.mb-12 {
  margin-bottom: 3rem;
}
.ml-12 {
  margin-left: 3rem;
}
.mt-13 {
  margin-top: 3.25rem;
}
.mr-13 {
  margin-right: 3.25rem;
}
.mb-13 {
  margin-bottom: 3.25rem;
}
.ml-13 {
  margin-left: 3.25rem;
}
.mt-14 {
  margin-top: 3.5rem;
}
.mr-14 {
  margin-right: 3.5rem;
}
.mb-14 {
  margin-bottom: 3.5rem;
}
.ml-14 {
  margin-left: 3.5rem;
}
.mt-15 {
  margin-top: 3.75rem;
}
.mr-15 {
  margin-right: 3.75rem;
}
.mb-15 {
  margin-bottom: 3.75rem;
}
.ml-15 {
  margin-left: 3.75rem;
}
.mt-16 {
  margin-top: 4rem;
}
.mr-16 {
  margin-right: 4rem;
}
.mb-16 {
  margin-bottom: 4rem;
}
.ml-16 {
  margin-left: 4rem;
}
.mt-20 {
  margin-top: 5rem;
}
.mr-20 {
  margin-right: 5rem;
}
.mb-20 {
  margin-bottom: 5rem;
}
.ml-20 {
  margin-left: 5rem;
}
.mt-24 {
  margin-top: 6rem;
}
.mr-24 {
  margin-right: 6rem;
}
.mb-24 {
  margin-bottom: 6rem;
}
.ml-24 {
  margin-left: 6rem;
}
.mt-28 {
  margin-top: 7rem;
}
.mr-28 {
  margin-right: 7rem;
}
.mb-28 {
  margin-bottom: 7rem;
}
.ml-28 {
  margin-left: 7rem;
}
.mt-32 {
  margin-top: 5rem;
}
.mr-32 {
  margin-right: 8rem;
}
.mb-32 {
  margin-bottom: 8rem;
}
.ml-32 {
  margin-left: 8rem;
}
.mt-36 {
  margin-top: 9rem;
}
.mr-36 {
  margin-right: 9rem;
}
.mb-36 {
  margin-bottom: 9rem;
}
.ml-36 {
  margin-left: 9rem;
}
.mt-40 {
  margin-top: 10rem;
}
.mr-40 {
  margin-right: 10rem;
}
.mb-40 {
  margin-bottom: 10rem;
}
.ml-40 {
  margin-left: 10rem;
}
.mt-44 {
  margin-top: 11rem;
}
.mr-44 {
  margin-right: 11rem;
}
.mb-44 {
  margin-bottom: 11rem;
}
.ml-44 {
  margin-left: 11rem;
}
.mt-48 {
  margin-top: 12rem;
}
.mr-48 {
  margin-right: 12rem;
}
.mb-48 {
  margin-bottom: 12rem;
}
.ml-48 {
  margin-left: 12rem;
}
.mt-52 {
  margin-top: 13rem;
}
.mr-52 {
  margin-right: 13rem;
}
.mb-52 {
  margin-bottom: 13rem;
}
.ml-52 {
  margin-left: 13rem;
}
.mt-56 {
  margin-top: 14rem;
}
.mr-56 {
  margin-right: 14rem;
}
.mb-56 {
  margin-bottom: 14rem;
}
.ml-56 {
  margin-left: 14rem;
}
.mt-60 {
  margin-top: 15rem;
}
.mr-60 {
  margin-right: 15rem;
}
.mb-60 {
  margin-bottom: 15rem;
}
.ml-60 {
  margin-left: 15rem;
}
.mt-64 {
  margin-top: 16rem;
}
.mr-64 {
  margin-right: 16rem;
}
.mb-64 {
  margin-bottom: 16rem;
}
.ml-64 {
  margin-left: 16rem;
}
.mt-72 {
  margin-top: 18rem;
}
.mr-72 {
  margin-right: 18rem;
}
.mb-72 {
  margin-bottom: 18rem;
}
.ml-72 {
  margin-left: 18rem;
}
.mt-80 {
  margin-top: 20rem;
}
.mr-80 {
  margin-right: 20rem;
}
.mb-80 {
  margin-bottom: 20rem;
}
.ml-80 {
  margin-left: 20rem;
}
.mt-96 {
  margin-top: 24rem;
}
.mr-96 {
  margin-right: 24rem;
}
.mb-96 {
  margin-bottom: 24rem;
}
.ml-96 {
  margin-left: 24rem;
}
.mt-auto {
  margin-top: auto;
}
.mr-auto {
  margin-right: auto;
}
.mb-auto {
  margin-bottom: auto;
}
.ml-auto {
  margin-left: auto;
}
.mt-px {
  margin-top: 1px;
}
.mr-px {
  margin-right: 1px;
}
.mb-px {
  margin-bottom: 1px;
}
.ml-px {
  margin-left: 1px;
}
.mt-0\\.5 {
  margin-top: 0.125rem;
}
.mr-0\\.5 {
  margin-right: 0.125rem;
}
.mb-0\\.5 {
  margin-bottom: 0.125rem;
}
.ml-0\\.5 {
  margin-left: 0.125rem;
}
.mt-1\\.5 {
  margin-top: 0.375rem;
}
.mr-1\\.5 {
  margin-right: 0.375rem;
}
.mb-1\\.5 {
  margin-bottom: 0.375rem;
}
.ml-1\\.5 {
  margin-left: 0.375rem;
}
.mt-2\\.5 {
  margin-top: 0.625rem;
}
.mr-2\\.5 {
  margin-right: 0.625rem;
}
.mb-2\\.5 {
  margin-bottom: 0.625rem;
}
.ml-2\\.5 {
  margin-left: 0.625rem;
}
.mt-3\\.5 {
  margin-top: 0.875rem;
}
.mr-3\\.5 {
  margin-right: 0.875rem;
}
.mb-3\\.5 {
  margin-bottom: 0.875rem;
}
.ml-3\\.5 {
  margin-left: 0.875rem;
}
.mt-1\\/2 {
  margin-top: 50%;
}
.mr-1\\/2 {
  margin-right: 50%;
}
.mb-1\\/2 {
  margin-bottom: 50%;
}
.ml-1\\/2 {
  margin-left: 50%;
}
.mt-1\\/3 {
  margin-top: 33.333333%;
}
.mr-1\\/3 {
  margin-right: 33.333333%;
}
.mb-1\\/3 {
  margin-bottom: 33.333333%;
}
.ml-1\\/3 {
  margin-left: 33.333333%;
}
.mt-2\\/3 {
  margin-top: 66.666667%;
}
.mr-2\\/3 {
  margin-right: 66.666667%;
}
.mb-2\\/3 {
  margin-bottom: 66.666667%;
}
.ml-2\\/3 {
  margin-left: 66.666667%;
}
.mt-1\\/4 {
  margin-top: 25%;
}
.mr-1\\/4 {
  margin-right: 25%;
}
.mb-1\\/4 {
  margin-bottom: 25%;
}
.ml-1\\/4 {
  margin-left: 25%;
}
.mt-2\\/4 {
  margin-top: 50%;
}
.mr-2\\/4 {
  margin-right: 50%;
}
.mb-2\\/4 {
  margin-bottom: 50%;
}
.ml-2\\/4 {
  margin-left: 50%;
}
.mt-3\\/4 {
  margin-top: 75%;
}
.mr-3\\/4 {
  margin-right: 75%;
}
.mb-3\\/4 {
  margin-bottom: 75%;
}
.ml-3\\/4 {
  margin-left: 75%;
}
.mt-1\\/5 {
  margin-top: 20%;
}
.mr-1\\/5 {
  margin-right: 20%;
}
.mb-1\\/5 {
  margin-bottom: 20%;
}
.ml-1\\/5 {
  margin-left: 20%;
}
.mt-2\\/5 {
  margin-top: 40%;
}
.mr-2\\/5 {
  margin-right: 40%;
}
.mb-2\\/5 {
  margin-bottom: 40%;
}
.ml-2\\/5 {
  margin-left: 40%;
}
.mt-3\\/5 {
  margin-top: 60%;
}
.mr-3\\/5 {
  margin-right: 60%;
}
.mb-3\\/5 {
  margin-bottom: 60%;
}
.ml-3\\/5 {
  margin-left: 60%;
}
.mt-4\\/5 {
  margin-top: 80%;
}
.mr-4\\/5 {
  margin-right: 80%;
}
.mb-4\\/5 {
  margin-bottom: 80%;
}
.ml-4\\/5 {
  margin-left: 80%;
}
.mt-1\\/6 {
  margin-top: 16.666667%;
}
.mr-1\\/6 {
  margin-right: 16.666667%;
}
.mb-1\\/6 {
  margin-bottom: 16.666667%;
}
.ml-1\\/6 {
  margin-left: 16.666667%;
}
.mt-2\\/6 {
  margin-top: 33.333333%;
}
.mr-2\\/6 {
  margin-right: 33.333333%;
}
.mb-2\\/6 {
  margin-bottom: 33.333333%;
}
.ml-2\\/6 {
  margin-left: 33.333333%;
}
.mt-3\\/6 {
  margin-top: 50%;
}
.mr-3\\/6 {
  margin-right: 50%;
}
.mb-3\\/6 {
  margin-bottom: 50%;
}
.ml-3\\/6 {
  margin-left: 50%;
}
.mt-4\\/6 {
  margin-top: 66.666667%;
}
.mr-4\\/6 {
  margin-right: 66.666667%;
}
.mb-4\\/6 {
  margin-bottom: 66.666667%;
}
.ml-4\\/6 {
  margin-left: 66.666667%;
}
.mt-5\\/6 {
  margin-top: 83.333333%;
}
.mr-5\\/6 {
  margin-right: 83.333333%;
}
.mb-5\\/6 {
  margin-bottom: 83.333333%;
}
.ml-5\\/6 {
  margin-left: 83.333333%;
}
.mt-1\\/12 {
  margin-top: 8.333333%;
}
.mr-1\\/12 {
  margin-right: 8.333333%;
}
.mb-1\\/12 {
  margin-bottom: 8.333333%;
}
.ml-1\\/12 {
  margin-left: 8.333333%;
}
.mt-2\\/12 {
  margin-top: 16.666667%;
}
.mr-2\\/12 {
  margin-right: 16.666667%;
}
.mb-2\\/12 {
  margin-bottom: 16.666667%;
}
.ml-2\\/12 {
  margin-left: 16.666667%;
}
.mt-3\\/12 {
  margin-top: 25%;
}
.mr-3\\/12 {
  margin-right: 25%;
}
.mb-3\\/12 {
  margin-bottom: 25%;
}
.ml-3\\/12 {
  margin-left: 25%;
}
.mt-4\\/12 {
  margin-top: 33.333333%;
}
.mr-4\\/12 {
  margin-right: 33.333333%;
}
.mb-4\\/12 {
  margin-bottom: 33.333333%;
}
.ml-4\\/12 {
  margin-left: 33.333333%;
}
.mt-5\\/12 {
  margin-top: 41.666667%;
}
.mr-5\\/12 {
  margin-right: 41.666667%;
}
.mb-5\\/12 {
  margin-bottom: 41.666667%;
}
.ml-5\\/12 {
  margin-left: 41.666667%;
}
.mt-6\\/12 {
  margin-top: 50%;
}
.mr-6\\/12 {
  margin-right: 50%;
}
.mb-6\\/12 {
  margin-bottom: 50%;
}
.ml-6\\/12 {
  margin-left: 50%;
}
.mt-7\\/12 {
  margin-top: 58.333333%;
}
.mr-7\\/12 {
  margin-right: 58.333333%;
}
.mb-7\\/12 {
  margin-bottom: 58.333333%;
}
.ml-7\\/12 {
  margin-left: 58.333333%;
}
.mt-8\\/12 {
  margin-top: 66.666667%;
}
.mr-8\\/12 {
  margin-right: 66.666667%;
}
.mb-8\\/12 {
  margin-bottom: 66.666667%;
}
.ml-8\\/12 {
  margin-left: 66.666667%;
}
.mt-9\\/12 {
  margin-top: 75%;
}
.mr-9\\/12 {
  margin-right: 75%;
}
.mb-9\\/12 {
  margin-bottom: 75%;
}
.ml-9\\/12 {
  margin-left: 75%;
}
.mt-10\\/12 {
  margin-top: 83.333333%;
}
.mr-10\\/12 {
  margin-right: 83.333333%;
}
.mb-10\\/12 {
  margin-bottom: 83.333333%;
}
.ml-10\\/12 {
  margin-left: 83.333333%;
}
.mt-11\\/12 {
  margin-top: 91.666667%;
}
.mr-11\\/12 {
  margin-right: 91.666667%;
}
.mb-11\\/12 {
  margin-bottom: 91.666667%;
}
.ml-11\\/12 {
  margin-left: 91.666667%;
}
.mt-full {
  margin-top: 100%;
}
.mr-full {
  margin-right: 100%;
}
.mb-full {
  margin-bottom: 100%;
}
.ml-full {
  margin-left: 100%;
}
.-mt-1 {
  margin-top: -0.25rem;
}
.-mr-1 {
  margin-right: -0.25rem;
}
.-mb-1 {
  margin-bottom: -0.25rem;
}
.-ml-1 {
  margin-left: -0.25rem;
}
.-mt-2 {
  margin-top: -0.5rem;
}
.-mr-2 {
  margin-right: -0.5rem;
}
.-mb-2 {
  margin-bottom: -0.5rem;
}
.-ml-2 {
  margin-left: -0.5rem;
}
.-mt-3 {
  margin-top: -0.75rem;
}
.-mr-3 {
  margin-right: -0.75rem;
}
.-mb-3 {
  margin-bottom: -0.75rem;
}
.-ml-3 {
  margin-left: -0.75rem;
}
.-mt-4 {
  margin-top: -1rem;
}
.-mr-4 {
  margin-right: -1rem;
}
.-mb-4 {
  margin-bottom: -1rem;
}
.-ml-4 {
  margin-left: -1rem;
}
.-mt-5 {
  margin-top: -1.25rem;
}
.-mr-5 {
  margin-right: -1.25rem;
}
.-mb-5 {
  margin-bottom: -1.25rem;
}
.-ml-5 {
  margin-left: -1.25rem;
}
.-mt-6 {
  margin-top: -1.5rem;
}
.-mr-6 {
  margin-right: -1.5rem;
}
.-mb-6 {
  margin-bottom: -1.5rem;
}
.-ml-6 {
  margin-left: -1.5rem;
}
.-mt-7 {
  margin-top: -1.75rem;
}
.-mr-7 {
  margin-right: -1.75rem;
}
.-mb-7 {
  margin-bottom: -1.75rem;
}
.-ml-7 {
  margin-left: -1.75rem;
}
.-mt-8 {
  margin-top: -2rem;
}
.-mr-8 {
  margin-right: -2rem;
}
.-mb-8 {
  margin-bottom: -2rem;
}
.-ml-8 {
  margin-left: -2rem;
}
.-mt-9 {
  margin-top: -2.25rem;
}
.-mr-9 {
  margin-right: -2.25rem;
}
.-mb-9 {
  margin-bottom: -2.25rem;
}
.-ml-9 {
  margin-left: -2.25rem;
}
.-mt-10 {
  margin-top: -2.5rem;
}
.-mr-10 {
  margin-right: -2.5rem;
}
.-mb-10 {
  margin-bottom: -2.5rem;
}
.-ml-10 {
  margin-left: -2.5rem;
}
.-mt-11 {
  margin-top: -2.75rem;
}
.-mr-11 {
  margin-right: -2.75rem;
}
.-mb-11 {
  margin-bottom: -2.75rem;
}
.-ml-11 {
  margin-left: -2.75rem;
}
.-mt-12 {
  margin-top: -3rem;
}
.-mr-12 {
  margin-right: -3rem;
}
.-mb-12 {
  margin-bottom: -3rem;
}
.-ml-12 {
  margin-left: -3rem;
}
.-mt-13 {
  margin-top: -3.25rem;
}
.-mr-13 {
  margin-right: -3.25rem;
}
.-mb-13 {
  margin-bottom: -3.25rem;
}
.-ml-13 {
  margin-left: -3.25rem;
}
.-mt-14 {
  margin-top: -3.5rem;
}
.-mr-14 {
  margin-right: -3.5rem;
}
.-mb-14 {
  margin-bottom: -3.5rem;
}
.-ml-14 {
  margin-left: -3.5rem;
}
.-mt-15 {
  margin-top: -3.75rem;
}
.-mr-15 {
  margin-right: -3.75rem;
}
.-mb-15 {
  margin-bottom: -3.75rem;
}
.-ml-15 {
  margin-left: -3.75rem;
}
.-mt-16 {
  margin-top: -4rem;
}
.-mr-16 {
  margin-right: -4rem;
}
.-mb-16 {
  margin-bottom: -4rem;
}
.-ml-16 {
  margin-left: -4rem;
}
.-mt-20 {
  margin-top: -5rem;
}
.-mr-20 {
  margin-right: -5rem;
}
.-mb-20 {
  margin-bottom: -5rem;
}
.-ml-20 {
  margin-left: -5rem;
}
.-mt-24 {
  margin-top: -6rem;
}
.-mr-24 {
  margin-right: -6rem;
}
.-mb-24 {
  margin-bottom: -6rem;
}
.-ml-24 {
  margin-left: -6rem;
}
.-mt-28 {
  margin-top: -7rem;
}
.-mr-28 {
  margin-right: -7rem;
}
.-mb-28 {
  margin-bottom: -7rem;
}
.-ml-28 {
  margin-left: -7rem;
}
.-mt-32 {
  margin-top: -8rem;
}
.-mr-32 {
  margin-right: -8rem;
}
.-mb-32 {
  margin-bottom: -8rem;
}
.-ml-32 {
  margin-left: -8rem;
}
.-mt-36 {
  margin-top: -9rem;
}
.-mr-36 {
  margin-right: -9rem;
}
.-mb-36 {
  margin-bottom: -9rem;
}
.-ml-36 {
  margin-left: -9rem;
}
.-mt-40 {
  margin-top: -10rem;
}
.-mr-40 {
  margin-right: -10rem;
}
.-mb-40 {
  margin-bottom: -10rem;
}
.-ml-40 {
  margin-left: -10rem;
}
.-mt-44 {
  margin-top: -11rem;
}
.-mr-44 {
  margin-right: -11rem;
}
.-mb-44 {
  margin-bottom: -11rem;
}
.-ml-44 {
  margin-left: -11rem;
}
.-mt-48 {
  margin-top: -12rem;
}
.-mr-48 {
  margin-right: -12rem;
}
.-mb-48 {
  margin-bottom: -12rem;
}
.-ml-48 {
  margin-left: -12rem;
}
.-mt-52 {
  margin-top: -13rem;
}
.-mr-52 {
  margin-right: -13rem;
}
.-mb-52 {
  margin-bottom: -13rem;
}
.-ml-52 {
  margin-left: -13rem;
}
.-mt-56 {
  margin-top: -14rem;
}
.-mr-56 {
  margin-right: -14rem;
}
.-mb-56 {
  margin-bottom: -14rem;
}
.-ml-56 {
  margin-left: -14rem;
}
.-mt-60 {
  margin-top: -15rem;
}
.-mr-60 {
  margin-right: -15rem;
}
.-mb-60 {
  margin-bottom: -15rem;
}
.-ml-60 {
  margin-left: -15rem;
}
.-mt-64 {
  margin-top: -16rem;
}
.-mr-64 {
  margin-right: -16rem;
}
.-mb-64 {
  margin-bottom: -16rem;
}
.-ml-64 {
  margin-left: -16rem;
}
.-mt-72 {
  margin-top: -18rem;
}
.-mr-72 {
  margin-right: -18rem;
}
.-mb-72 {
  margin-bottom: -18rem;
}
.-ml-72 {
  margin-left: -18rem;
}
.-mt-80 {
  margin-top: -20rem;
}
.-mr-80 {
  margin-right: -20rem;
}
.-mb-80 {
  margin-bottom: -20rem;
}
.-ml-80 {
  margin-left: -20rem;
}
.-mt-96 {
  margin-top: -24rem;
}
.-mr-96 {
  margin-right: -24rem;
}
.-mb-96 {
  margin-bottom: -24rem;
}
.-ml-96 {
  margin-left: -24rem;
}
.-mt-px {
  margin-top: -1px;
}
.-mr-px {
  margin-right: -1px;
}
.-mb-px {
  margin-bottom: -1px;
}
.-ml-px {
  margin-left: -1px;
}
.-mt-0\\.5 {
  margin-top: -0.125rem;
}
.-mr-0\\.5 {
  margin-right: -0.125rem;
}
.-mb-0\\.5 {
  margin-bottom: -0.125rem;
}
.-ml-0\\.5 {
  margin-left: -0.125rem;
}
.-mt-1\\.5 {
  margin-top: -0.375rem;
}
.-mr-1\\.5 {
  margin-right: -0.375rem;
}
.-mb-1\\.5 {
  margin-bottom: -0.375rem;
}
.-ml-1\\.5 {
  margin-left: -0.375rem;
}
.-mt-2\\.5 {
  margin-top: -0.625rem;
}
.-mr-2\\.5 {
  margin-right: -0.625rem;
}
.-mb-2\\.5 {
  margin-bottom: -0.625rem;
}
.-ml-2\\.5 {
  margin-left: -0.625rem;
}
.-mt-3\\.5 {
  margin-top: -0.875rem;
}
.-mr-3\\.5 {
  margin-right: -0.875rem;
}
.-mb-3\\.5 {
  margin-bottom: -0.875rem;
}
.-ml-3\\.5 {
  margin-left: -0.875rem;
}
.-mt-1\\/2 {
  margin-top: -50%;
}
.-mr-1\\/2 {
  margin-right: -50%;
}
.-mb-1\\/2 {
  margin-bottom: -50%;
}
.-ml-1\\/2 {
  margin-left: -50%;
}
.-mt-1\\/3 {
  margin-top: -33.33333%;
}
.-mr-1\\/3 {
  margin-right: -33.33333%;
}
.-mb-1\\/3 {
  margin-bottom: -33.33333%;
}
.-ml-1\\/3 {
  margin-left: -33.33333%;
}
.-mt-2\\/3 {
  margin-top: -66.66667%;
}
.-mr-2\\/3 {
  margin-right: -66.66667%;
}
.-mb-2\\/3 {
  margin-bottom: -66.66667%;
}
.-ml-2\\/3 {
  margin-left: -66.66667%;
}
.-mt-1\\/4 {
  margin-top: -25%;
}
.-mr-1\\/4 {
  margin-right: -25%;
}
.-mb-1\\/4 {
  margin-bottom: -25%;
}
.-ml-1\\/4 {
  margin-left: -25%;
}
.-mt-2\\/4 {
  margin-top: -50%;
}
.-mr-2\\/4 {
  margin-right: -50%;
}
.-mb-2\\/4 {
  margin-bottom: -50%;
}
.-ml-2\\/4 {
  margin-left: -50%;
}
.-mt-3\\/4 {
  margin-top: -75%;
}
.-mr-3\\/4 {
  margin-right: -75%;
}
.-mb-3\\/4 {
  margin-bottom: -75%;
}
.-ml-3\\/4 {
  margin-left: -75%;
}
.-mt-1\\/5 {
  margin-top: -20%;
}
.-mr-1\\/5 {
  margin-right: -20%;
}
.-mb-1\\/5 {
  margin-bottom: -20%;
}
.-ml-1\\/5 {
  margin-left: -20%;
}
.-mt-2\\/5 {
  margin-top: -40%;
}
.-mr-2\\/5 {
  margin-right: -40%;
}
.-mb-2\\/5 {
  margin-bottom: -40%;
}
.-ml-2\\/5 {
  margin-left: -40%;
}
.-mt-3\\/5 {
  margin-top: -60%;
}
.-mr-3\\/5 {
  margin-right: -60%;
}
.-mb-3\\/5 {
  margin-bottom: -60%;
}
.-ml-3\\/5 {
  margin-left: -60%;
}
.-mt-4\\/5 {
  margin-top: -80%;
}
.-mr-4\\/5 {
  margin-right: -80%;
}
.-mb-4\\/5 {
  margin-bottom: -80%;
}
.-ml-4\\/5 {
  margin-left: -80%;
}
.-mt-1\\/6 {
  margin-top: -16.66667%;
}
.-mr-1\\/6 {
  margin-right: -16.66667%;
}
.-mb-1\\/6 {
  margin-bottom: -16.66667%;
}
.-ml-1\\/6 {
  margin-left: -16.66667%;
}
.-mt-2\\/6 {
  margin-top: -33.33333%;
}
.-mr-2\\/6 {
  margin-right: -33.33333%;
}
.-mb-2\\/6 {
  margin-bottom: -33.33333%;
}
.-ml-2\\/6 {
  margin-left: -33.33333%;
}
.-mt-3\\/6 {
  margin-top: -50%;
}
.-mr-3\\/6 {
  margin-right: -50%;
}
.-mb-3\\/6 {
  margin-bottom: -50%;
}
.-ml-3\\/6 {
  margin-left: -50%;
}
.-mt-4\\/6 {
  margin-top: -66.66667%;
}
.-mr-4\\/6 {
  margin-right: -66.66667%;
}
.-mb-4\\/6 {
  margin-bottom: -66.66667%;
}
.-ml-4\\/6 {
  margin-left: -66.66667%;
}
.-mt-5\\/6 {
  margin-top: -83.33333%;
}
.-mr-5\\/6 {
  margin-right: -83.33333%;
}
.-mb-5\\/6 {
  margin-bottom: -83.33333%;
}
.-ml-5\\/6 {
  margin-left: -83.33333%;
}
.-mt-1\\/12 {
  margin-top: -8.33333%;
}
.-mr-1\\/12 {
  margin-right: -8.33333%;
}
.-mb-1\\/12 {
  margin-bottom: -8.33333%;
}
.-ml-1\\/12 {
  margin-left: -8.33333%;
}
.-mt-2\\/12 {
  margin-top: -16.66667%;
}
.-mr-2\\/12 {
  margin-right: -16.66667%;
}
.-mb-2\\/12 {
  margin-bottom: -16.66667%;
}
.-ml-2\\/12 {
  margin-left: -16.66667%;
}
.-mt-3\\/12 {
  margin-top: -25%;
}
.-mr-3\\/12 {
  margin-right: -25%;
}
.-mb-3\\/12 {
  margin-bottom: -25%;
}
.-ml-3\\/12 {
  margin-left: -25%;
}
.-mt-4\\/12 {
  margin-top: -33.33333%;
}
.-mr-4\\/12 {
  margin-right: -33.33333%;
}
.-mb-4\\/12 {
  margin-bottom: -33.33333%;
}
.-ml-4\\/12 {
  margin-left: -33.33333%;
}
.-mt-5\\/12 {
  margin-top: -41.66667%;
}
.-mr-5\\/12 {
  margin-right: -41.66667%;
}
.-mb-5\\/12 {
  margin-bottom: -41.66667%;
}
.-ml-5\\/12 {
  margin-left: -41.66667%;
}
.-mt-6\\/12 {
  margin-top: -50%;
}
.-mr-6\\/12 {
  margin-right: -50%;
}
.-mb-6\\/12 {
  margin-bottom: -50%;
}
.-ml-6\\/12 {
  margin-left: -50%;
}
.-mt-7\\/12 {
  margin-top: -58.33333%;
}
.-mr-7\\/12 {
  margin-right: -58.33333%;
}
.-mb-7\\/12 {
  margin-bottom: -58.33333%;
}
.-ml-7\\/12 {
  margin-left: -58.33333%;
}
.-mt-8\\/12 {
  margin-top: -66.66667%;
}
.-mr-8\\/12 {
  margin-right: -66.66667%;
}
.-mb-8\\/12 {
  margin-bottom: -66.66667%;
}
.-ml-8\\/12 {
  margin-left: -66.66667%;
}
.-mt-9\\/12 {
  margin-top: -75%;
}
.-mr-9\\/12 {
  margin-right: -75%;
}
.-mb-9\\/12 {
  margin-bottom: -75%;
}
.-ml-9\\/12 {
  margin-left: -75%;
}
.-mt-10\\/12 {
  margin-top: -83.33333%;
}
.-mr-10\\/12 {
  margin-right: -83.33333%;
}
.-mb-10\\/12 {
  margin-bottom: -83.33333%;
}
.-ml-10\\/12 {
  margin-left: -83.33333%;
}
.-mt-11\\/12 {
  margin-top: -91.66667%;
}
.-mr-11\\/12 {
  margin-right: -91.66667%;
}
.-mb-11\\/12 {
  margin-bottom: -91.66667%;
}
.-ml-11\\/12 {
  margin-left: -91.66667%;
}
.-mt-full {
  margin-top: -100%;
}
.-mr-full {
  margin-right: -100%;
}
.-mb-full {
  margin-bottom: -100%;
}
.-ml-full {
  margin-left: -100%;
}
.max-h-0 {
  max-height: 0;
}
.max-h-1 {
  max-height: 0.25rem;
}
.max-h-2 {
  max-height: 0.5rem;
}
.max-h-3 {
  max-height: 0.75rem;
}
.max-h-4 {
  max-height: 1rem;
}
.max-h-5 {
  max-height: 1.25rem;
}
.max-h-6 {
  max-height: 1.5rem;
}
.max-h-7 {
  max-height: 1.75rem;
}
.max-h-8 {
  max-height: 4rem;
}
.max-h-9 {
  max-height: 2.25rem;
}
.max-h-10 {
  max-height: 2.5rem;
}
.max-h-11 {
  max-height: 2.75rem;
}
.max-h-12 {
  max-height: 3rem;
}
.max-h-13 {
  max-height: 3.25rem;
}
.max-h-14 {
  max-height: 3.5rem;
}
.max-h-15 {
  max-height: 3.75rem;
}
.max-h-16 {
  max-height: 4rem;
}
.max-h-20 {
  max-height: 5rem;
}
.max-h-24 {
  max-height: 6rem;
}
.max-h-28 {
  max-height: 7rem;
}
.max-h-32 {
  max-height: 8rem;
}
.max-h-36 {
  max-height: 9rem;
}
.max-h-40 {
  max-height: 10rem;
}
.max-h-44 {
  max-height: 11rem;
}
.max-h-48 {
  max-height: 12rem;
}
.max-h-52 {
  max-height: 13rem;
}
.max-h-56 {
  max-height: 14rem;
}
.max-h-60 {
  max-height: 15rem;
}
.max-h-64 {
  max-height: 16rem;
}
.max-h-72 {
  max-height: 18rem;
}
.max-h-80 {
  max-height: 20rem;
}
.max-h-96 {
  max-height: 24rem;
}
.max-h-screen {
  max-height: 100vh;
}
.max-h-px {
  max-height: 1px;
}
.max-h-0\\.5 {
  max-height: 0.125rem;
}
.max-h-1\\.5 {
  max-height: 0.375rem;
}
.max-h-2\\.5 {
  max-height: 0.625rem;
}
.max-h-3\\.5 {
  max-height: 0.875rem;
}
.max-h-1\\/2 {
  max-height: 50%;
}
.max-h-1\\/3 {
  max-height: 33.333333%;
}
.max-h-2\\/3 {
  max-height: 66.666667%;
}
.max-h-1\\/4 {
  max-height: 25%;
}
.max-h-2\\/4 {
  max-height: 50%;
}
.max-h-3\\/4 {
  max-height: 75%;
}
.max-h-1\\/5 {
  max-height: 20%;
}
.max-h-2\\/5 {
  max-height: 40%;
}
.max-h-3\\/5 {
  max-height: 60%;
}
.max-h-4\\/5 {
  max-height: 80%;
}
.max-h-1\\/6 {
  max-height: 16.666667%;
}
.max-h-2\\/6 {
  max-height: 33.333333%;
}
.max-h-3\\/6 {
  max-height: 50%;
}
.max-h-4\\/6 {
  max-height: 66.666667%;
}
.max-h-5\\/6 {
  max-height: 83.333333%;
}
.max-h-1\\/12 {
  max-height: 8.333333%;
}
.max-h-2\\/12 {
  max-height: 16.666667%;
}
.max-h-3\\/12 {
  max-height: 25%;
}
.max-h-4\\/12 {
  max-height: 33.333333%;
}
.max-h-5\\/12 {
  max-height: 41.666667%;
}
.max-h-6\\/12 {
  max-height: 50%;
}
.max-h-7\\/12 {
  max-height: 58.333333%;
}
.max-h-8\\/12 {
  max-height: 66.666667%;
}
.max-h-9\\/12 {
  max-height: 75%;
}
.max-h-10\\/12 {
  max-height: 83.333333%;
}
.max-h-11\\/12 {
  max-height: 91.666667%;
}
.max-h-full {
  max-height: 100%;
}
.max-w-0 {
  max-width: 0rem;
}
.max-w-none {
  max-width: none;
}
.max-w-xs {
  max-width: 20rem;
}
.max-w-sm {
  max-width: 24rem;
}
.max-w-md {
  max-width: 28rem;
}
.max-w-lg {
  max-width: 32rem;
}
.max-w-xl {
  max-width: 36rem;
}
.max-w-2xl {
  max-width: 42rem;
}
.max-w-3xl {
  max-width: 48rem;
}
.max-w-4xl {
  max-width: 56rem;
}
.max-w-5xl {
  max-width: 64rem;
}
.max-w-6xl {
  max-width: 72rem;
}
.max-w-7xl {
  max-width: 80rem;
}
.max-w-full {
  max-width: 100%;
}
.max-w-min-content {
  max-width: min-content;
}
.max-w-max-content {
  max-width: max-content;
}
.max-w-prose {
  max-width: 65ch;
}
.max-w-screen-sm {
  max-width: 640px;
}
.max-w-screen-md {
  max-width: 768px;
}
.max-w-screen-lg {
  max-width: 1024px;
}
.max-w-screen-xl {
  max-width: 1280px;
}
.min-h-0 {
  min-height: 0;
}
.min-h-full {
  min-height: 100%;
}
.min-h-screen {
  min-height: 100vh;
}
.min-w-0 {
  min-width: 0;
}
.min-w-full {
  min-width: 100%;
}
.min-w-min-content {
  min-width: min-content;
}
.min-w-max-content {
  min-width: max-content;
}
.object-contain {
  object-fit: contain;
}
.object-cover {
  object-fit: cover;
}
.object-fill {
  object-fit: fill;
}
.object-none {
  object-fit: none;
}
.object-scale-down {
  object-fit: scale-down;
}
.object-bottom {
  object-position: bottom;
}
.object-center {
  object-position: center;
}
.object-left {
  object-position: left;
}
.object-left-bottom {
  object-position: left bottom;
}
.object-left-top {
  object-position: left top;
}
.object-right {
  object-position: right;
}
.object-right-bottom {
  object-position: right bottom;
}
.object-right-top {
  object-position: right top;
}
.object-top {
  object-position: top;
}
.opacity-0 {
  opacity: 0;
}
.opacity-25 {
  opacity: 0.25;
}
.opacity-50 {
  opacity: 0.5;
}
.opacity-75 {
  opacity: 0.75;
}
.opacity-100 {
  opacity: 1;
}
.focus-within\\:opacity-0:focus-within {
  opacity: 0;
}
.focus-within\\:opacity-25:focus-within {
  opacity: 0.25;
}
.focus-within\\:opacity-50:focus-within {
  opacity: 0.5;
}
.focus-within\\:opacity-75:focus-within {
  opacity: 0.75;
}
.focus-within\\:opacity-100:focus-within {
  opacity: 1;
}
.group:hover .group-hover\\:opacity-0 {
  opacity: 0;
}
.group:hover .group-hover\\:opacity-25 {
  opacity: 0.25;
}
.group:hover .group-hover\\:opacity-50 {
  opacity: 0.5;
}
.group:hover .group-hover\\:opacity-75 {
  opacity: 0.75;
}
.group:hover .group-hover\\:opacity-100 {
  opacity: 1;
}
.group:focus .group-focus\\:opacity-0 {
  opacity: 0;
}
.group:focus .group-focus\\:opacity-25 {
  opacity: 0.25;
}
.group:focus .group-focus\\:opacity-50 {
  opacity: 0.5;
}
.group:focus .group-focus\\:opacity-75 {
  opacity: 0.75;
}
.group:focus .group-focus\\:opacity-100 {
  opacity: 1;
}
.hover\\:opacity-0:hover {
  opacity: 0;
}
.hover\\:opacity-25:hover {
  opacity: 0.25;
}
.hover\\:opacity-50:hover {
  opacity: 0.5;
}
.hover\\:opacity-75:hover {
  opacity: 0.75;
}
.hover\\:opacity-100:hover {
  opacity: 1;
}
.focus\\:opacity-0:focus {
  opacity: 0;
}
.focus\\:opacity-25:focus {
  opacity: 0.25;
}
.focus\\:opacity-50:focus {
  opacity: 0.5;
}
.focus\\:opacity-75:focus {
  opacity: 0.75;
}
.focus\\:opacity-100:focus {
  opacity: 1;
}
.outline-none {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.outline-white {
  outline: 2px dotted white;
  outline-offset: 2px;
}
.outline-black {
  outline: 2px dotted black;
  outline-offset: 2px;
}
.focus\\:outline-none:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.focus\\:outline-white:focus {
  outline: 2px dotted white;
  outline-offset: 2px;
}
.focus\\:outline-black:focus {
  outline: 2px dotted black;
  outline-offset: 2px;
}
.overflow-auto {
  overflow: auto;
}
.overflow-hidden {
  overflow: hidden;
}
.overflow-visible {
  overflow: visible;
}
.overflow-scroll {
  overflow: scroll;
}
.overflow-x-auto {
  overflow-x: auto;
}
.overflow-y-auto {
  overflow-y: auto;
}
.overflow-x-hidden {
  overflow-x: hidden;
}
.overflow-y-hidden {
  overflow-y: hidden;
}
.overflow-x-visible {
  overflow-x: visible;
}
.overflow-y-visible {
  overflow-y: visible;
}
.overflow-x-scroll {
  overflow-x: scroll;
}
.overflow-y-scroll {
  overflow-y: scroll;
}
.scrolling-touch {
  -webkit-overflow-scrolling: touch;
}
.scrolling-auto {
  -webkit-overflow-scrolling: auto;
}
.overscroll-auto {
  overscroll-behavior: auto;
}
.overscroll-contain {
  overscroll-behavior: contain;
}
.overscroll-none {
  overscroll-behavior: none;
}
.overscroll-y-auto {
  overscroll-behavior-y: auto;
}
.overscroll-y-contain {
  overscroll-behavior-y: contain;
}
.overscroll-y-none {
  overscroll-behavior-y: none;
}
.overscroll-x-auto {
  overscroll-behavior-x: auto;
}
.overscroll-x-contain {
  overscroll-behavior-x: contain;
}
.overscroll-x-none {
  overscroll-behavior-x: none;
}
.p-0 {
  padding: 0;
}
.p-1 {
  padding: 0.25rem;
}
.p-2 {
  padding: 0.5rem;
}
.p-3 {
  padding: 0.75rem;
}
.p-4 {
  padding: 1rem;
}
.p-5 {
  padding: 1.25rem;
}
.p-6 {
  padding: 1.5rem;
}
.p-7 {
  padding: 1.75rem;
}
.p-8 {
  padding: 2rem;
}
.p-9 {
  padding: 2.25rem;
}
.p-10 {
  padding: 2.5rem;
}
.p-11 {
  padding: 2.75rem;
}
.p-12 {
  padding: 3rem;
}
.p-13 {
  padding: 3.25rem;
}
.p-14 {
  padding: 3.5rem;
}
.p-15 {
  padding: 3.75rem;
}
.p-16 {
  padding: 4rem;
}
.p-20 {
  padding: 5rem;
}
.p-24 {
  padding: 6rem;
}
.p-28 {
  padding: 7rem;
}
.p-32 {
  padding: 8rem;
}
.p-36 {
  padding: 9rem;
}
.p-40 {
  padding: 10rem;
}
.p-44 {
  padding: 11rem;
}
.p-48 {
  padding: 12rem;
}
.p-52 {
  padding: 13rem;
}
.p-56 {
  padding: 14rem;
}
.p-60 {
  padding: 15rem;
}
.p-64 {
  padding: 16rem;
}
.p-72 {
  padding: 18rem;
}
.p-80 {
  padding: 20rem;
}
.p-96 {
  padding: 24rem;
}
.p-px {
  padding: 1px;
}
.p-0\\.5 {
  padding: 0.125rem;
}
.p-1\\.5 {
  padding: 0.375rem;
}
.p-2\\.5 {
  padding: 0.625rem;
}
.p-3\\.5 {
  padding: 0.875rem;
}
.p-1\\/2 {
  padding: 50%;
}
.p-1\\/3 {
  padding: 33.333333%;
}
.p-2\\/3 {
  padding: 66.666667%;
}
.p-1\\/4 {
  padding: 25%;
}
.p-2\\/4 {
  padding: 50%;
}
.p-3\\/4 {
  padding: 75%;
}
.p-1\\/5 {
  padding: 20%;
}
.p-2\\/5 {
  padding: 40%;
}
.p-3\\/5 {
  padding: 60%;
}
.p-4\\/5 {
  padding: 80%;
}
.p-1\\/6 {
  padding: 16.666667%;
}
.p-2\\/6 {
  padding: 33.333333%;
}
.p-3\\/6 {
  padding: 50%;
}
.p-4\\/6 {
  padding: 66.666667%;
}
.p-5\\/6 {
  padding: 83.333333%;
}
.p-1\\/12 {
  padding: 8.333333%;
}
.p-2\\/12 {
  padding: 16.666667%;
}
.p-3\\/12 {
  padding: 25%;
}
.p-4\\/12 {
  padding: 33.333333%;
}
.p-5\\/12 {
  padding: 41.666667%;
}
.p-6\\/12 {
  padding: 50%;
}
.p-7\\/12 {
  padding: 58.333333%;
}
.p-8\\/12 {
  padding: 66.666667%;
}
.p-9\\/12 {
  padding: 75%;
}
.p-10\\/12 {
  padding: 83.333333%;
}
.p-11\\/12 {
  padding: 91.666667%;
}
.p-full {
  padding: 100%;
}
.py-0 {
  padding-top: 0;
  padding-bottom: 0;
}
.px-0 {
  padding-left: 0;
  padding-right: 0;
}
.py-1 {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.px-1 {
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}
.py-2 {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.px-2 {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.py-3 {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.px-3 {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.py-4 {
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}
.py-5 {
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
}
.px-5 {
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
.py-6 {
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}
.px-6 {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.py-7 {
  padding-top: 1.75rem;
  padding-bottom: 1.75rem;
}
.px-7 {
  padding-left: 1.75rem;
  padding-right: 1.75rem;
}
.py-8 {
  padding-top: 2rem;
  padding-bottom: 2rem;
}
.px-8 {
  padding-left: 2rem;
  padding-right: 2rem;
}
.py-9 {
  padding-top: 2.25rem;
  padding-bottom: 2.25rem;
}
.px-9 {
  padding-left: 2.25rem;
  padding-right: 2.25rem;
}
.py-10 {
  padding-top: 2.5rem;
  padding-bottom: 2.5rem;
}
.px-10 {
  padding-left: 2.5rem;
  padding-right: 2.5rem;
}
.py-11 {
  padding-top: 2.75rem;
  padding-bottom: 2.75rem;
}
.px-11 {
  padding-left: 2.75rem;
  padding-right: 2.75rem;
}
.py-12 {
  padding-top: 3rem;
  padding-bottom: 3rem;
}
.px-12 {
  padding-left: 3rem;
  padding-right: 3rem;
}
.py-13 {
  padding-top: 3.25rem;
  padding-bottom: 3.25rem;
}
.px-13 {
  padding-left: 3.25rem;
  padding-right: 3.25rem;
}
.py-14 {
  padding-top: 3.5rem;
  padding-bottom: 3.5rem;
}
.px-14 {
  padding-left: 3.5rem;
  padding-right: 3.5rem;
}
.py-15 {
  padding-top: 3.75rem;
  padding-bottom: 3.75rem;
}
.px-15 {
  padding-left: 3.75rem;
  padding-right: 3.75rem;
}
.py-16 {
  padding-top: 4rem;
  padding-bottom: 4rem;
}
.px-16 {
  padding-left: 4rem;
  padding-right: 4rem;
}
.py-20 {
  padding-top: 5rem;
  padding-bottom: 5rem;
}
.px-20 {
  padding-left: 5rem;
  padding-right: 5rem;
}
.py-24 {
  padding-top: 6rem;
  padding-bottom: 6rem;
}
.px-24 {
  padding-left: 6rem;
  padding-right: 6rem;
}
.py-28 {
  padding-top: 7rem;
  padding-bottom: 7rem;
}
.px-28 {
  padding-left: 7rem;
  padding-right: 7rem;
}
.py-32 {
  padding-top: 8rem;
  padding-bottom: 8rem;
}
.px-32 {
  padding-left: 8rem;
  padding-right: 8rem;
}
.py-36 {
  padding-top: 9rem;
  padding-bottom: 9rem;
}
.px-36 {
  padding-left: 9rem;
  padding-right: 9rem;
}
.py-40 {
  padding-top: 10rem;
  padding-bottom: 10rem;
}
.px-40 {
  padding-left: 10rem;
  padding-right: 10rem;
}
.py-44 {
  padding-top: 11rem;
  padding-bottom: 11rem;
}
.px-44 {
  padding-left: 11rem;
  padding-right: 11rem;
}
.py-48 {
  padding-top: 12rem;
  padding-bottom: 12rem;
}
.px-48 {
  padding-left: 12rem;
  padding-right: 12rem;
}
.py-52 {
  padding-top: 13rem;
  padding-bottom: 13rem;
}
.px-52 {
  padding-left: 13rem;
  padding-right: 13rem;
}
.py-56 {
  padding-top: 14rem;
  padding-bottom: 14rem;
}
.px-56 {
  padding-left: 14rem;
  padding-right: 14rem;
}
.py-60 {
  padding-top: 15rem;
  padding-bottom: 15rem;
}
.px-60 {
  padding-left: 15rem;
  padding-right: 15rem;
}
.py-64 {
  padding-top: 16rem;
  padding-bottom: 16rem;
}
.px-64 {
  padding-left: 16rem;
  padding-right: 16rem;
}
.py-72 {
  padding-top: 18rem;
  padding-bottom: 18rem;
}
.px-72 {
  padding-left: 18rem;
  padding-right: 18rem;
}
.py-80 {
  padding-top: 20rem;
  padding-bottom: 20rem;
}
.px-80 {
  padding-left: 20rem;
  padding-right: 20rem;
}
.py-96 {
  padding-top: 24rem;
  padding-bottom: 24rem;
}
.px-96 {
  padding-left: 24rem;
  padding-right: 24rem;
}
.py-px {
  padding-top: 1px;
  padding-bottom: 1px;
}
.px-px {
  padding-left: 1px;
  padding-right: 1px;
}
.py-0\\.5 {
  padding-top: 0.125rem;
  padding-bottom: 0.125rem;
}
.px-0\\.5 {
  padding-left: 0.125rem;
  padding-right: 0.125rem;
}
.py-1\\.5 {
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}
.px-1\\.5 {
  padding-left: 0.375rem;
  padding-right: 0.375rem;
}
.py-2\\.5 {
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
}
.px-2\\.5 {
  padding-left: 0.625rem;
  padding-right: 0.625rem;
}
.py-3\\.5 {
  padding-top: 0.875rem;
  padding-bottom: 0.875rem;
}
.px-3\\.5 {
  padding-left: 0.875rem;
  padding-right: 0.875rem;
}
.py-1\\/2 {
  padding-top: 50%;
  padding-bottom: 50%;
}
.px-1\\/2 {
  padding-left: 50%;
  padding-right: 50%;
}
.py-1\\/3 {
  padding-top: 33.333333%;
  padding-bottom: 33.333333%;
}
.px-1\\/3 {
  padding-left: 33.333333%;
  padding-right: 33.333333%;
}
.py-2\\/3 {
  padding-top: 66.666667%;
  padding-bottom: 66.666667%;
}
.px-2\\/3 {
  padding-left: 66.666667%;
  padding-right: 66.666667%;
}
.py-1\\/4 {
  padding-top: 25%;
  padding-bottom: 25%;
}
.px-1\\/4 {
  padding-left: 25%;
  padding-right: 25%;
}
.py-2\\/4 {
  padding-top: 50%;
  padding-bottom: 50%;
}
.px-2\\/4 {
  padding-left: 50%;
  padding-right: 50%;
}
.py-3\\/4 {
  padding-top: 75%;
  padding-bottom: 75%;
}
.px-3\\/4 {
  padding-left: 75%;
  padding-right: 75%;
}
.py-1\\/5 {
  padding-top: 20%;
  padding-bottom: 20%;
}
.px-1\\/5 {
  padding-left: 20%;
  padding-right: 20%;
}
.py-2\\/5 {
  padding-top: 40%;
  padding-bottom: 40%;
}
.px-2\\/5 {
  padding-left: 40%;
  padding-right: 40%;
}
.py-3\\/5 {
  padding-top: 60%;
  padding-bottom: 60%;
}
.px-3\\/5 {
  padding-left: 60%;
  padding-right: 60%;
}
.py-4\\/5 {
  padding-top: 80%;
  padding-bottom: 80%;
}
.px-4\\/5 {
  padding-left: 80%;
  padding-right: 80%;
}
.py-1\\/6 {
  padding-top: 16.666667%;
  padding-bottom: 16.666667%;
}
.px-1\\/6 {
  padding-left: 16.666667%;
  padding-right: 16.666667%;
}
.py-2\\/6 {
  padding-top: 33.333333%;
  padding-bottom: 33.333333%;
}
.px-2\\/6 {
  padding-left: 33.333333%;
  padding-right: 33.333333%;
}
.py-3\\/6 {
  padding-top: 50%;
  padding-bottom: 50%;
}
.px-3\\/6 {
  padding-left: 50%;
  padding-right: 50%;
}
.py-4\\/6 {
  padding-top: 66.666667%;
  padding-bottom: 66.666667%;
}
.px-4\\/6 {
  padding-left: 66.666667%;
  padding-right: 66.666667%;
}
.py-5\\/6 {
  padding-top: 83.333333%;
  padding-bottom: 83.333333%;
}
.px-5\\/6 {
  padding-left: 83.333333%;
  padding-right: 83.333333%;
}
.py-1\\/12 {
  padding-top: 8.333333%;
  padding-bottom: 8.333333%;
}
.px-1\\/12 {
  padding-left: 8.333333%;
  padding-right: 8.333333%;
}
.py-2\\/12 {
  padding-top: 16.666667%;
  padding-bottom: 16.666667%;
}
.px-2\\/12 {
  padding-left: 16.666667%;
  padding-right: 16.666667%;
}
.py-3\\/12 {
  padding-top: 25%;
  padding-bottom: 25%;
}
.px-3\\/12 {
  padding-left: 25%;
  padding-right: 25%;
}
.py-4\\/12 {
  padding-top: 33.333333%;
  padding-bottom: 33.333333%;
}
.px-4\\/12 {
  padding-left: 33.333333%;
  padding-right: 33.333333%;
}
.py-5\\/12 {
  padding-top: 41.666667%;
  padding-bottom: 41.666667%;
}
.px-5\\/12 {
  padding-left: 41.666667%;
  padding-right: 41.666667%;
}
.py-6\\/12 {
  padding-top: 50%;
  padding-bottom: 50%;
}
.px-6\\/12 {
  padding-left: 50%;
  padding-right: 50%;
}
.py-7\\/12 {
  padding-top: 58.333333%;
  padding-bottom: 58.333333%;
}
.px-7\\/12 {
  padding-left: 58.333333%;
  padding-right: 58.333333%;
}
.py-8\\/12 {
  padding-top: 66.666667%;
  padding-bottom: 66.666667%;
}
.px-8\\/12 {
  padding-left: 66.666667%;
  padding-right: 66.666667%;
}
.py-9\\/12 {
  padding-top: 75%;
  padding-bottom: 75%;
}
.px-9\\/12 {
  padding-left: 75%;
  padding-right: 75%;
}
.py-10\\/12 {
  padding-top: 83.333333%;
  padding-bottom: 83.333333%;
}
.px-10\\/12 {
  padding-left: 83.333333%;
  padding-right: 83.333333%;
}
.py-11\\/12 {
  padding-top: 91.666667%;
  padding-bottom: 91.666667%;
}
.px-11\\/12 {
  padding-left: 91.666667%;
  padding-right: 91.666667%;
}
.py-full {
  padding-top: 100%;
  padding-bottom: 100%;
}
.px-full {
  padding-left: 100%;
  padding-right: 100%;
}
.pt-0 {
  padding-top: 0;
}
.pr-0 {
  padding-right: 0;
}
.pb-0 {
  padding-bottom: 0;
}
.pl-0 {
  padding-left: 0;
}
.pt-1 {
  padding-top: 0.25rem;
}
.pr-1 {
  padding-right: 0.25rem;
}
.pb-1 {
  padding-bottom: 0.25rem;
}
.pl-1 {
  padding-left: 0.25rem;
}
.pt-2 {
  padding-top: 0.5rem;
}
.pr-2 {
  padding-right: 0.5rem;
}
.pb-2 {
  padding-bottom: 0.5rem;
}
.pl-2 {
  padding-left: 0.5rem;
}
.pt-3 {
  padding-top: 0.75rem;
}
.pr-3 {
  padding-right: 0.75rem;
}
.pb-3 {
  padding-bottom: 0.75rem;
}
.pl-3 {
  padding-left: 0.75rem;
}
.pt-4 {
  padding-top: 1rem;
}
.pr-4 {
  padding-right: 1rem;
}
.pb-4 {
  padding-bottom: 1rem;
}
.pl-4 {
  padding-left: 1rem;
}
.pt-5 {
  padding-top: 1.25rem;
}
.pr-5 {
  padding-right: 1.25rem;
}
.pb-5 {
  padding-bottom: 1.25rem;
}
.pl-5 {
  padding-left: 1.25rem;
}
.pt-6 {
  padding-top: 1.5rem;
}
.pr-6 {
  padding-right: 1.5rem;
}
.pb-6 {
  padding-bottom: 1.5rem;
}
.pl-6 {
  padding-left: 1.5rem;
}
.pt-7 {
  padding-top: 1.75rem;
}
.pr-7 {
  padding-right: 1.75rem;
}
.pb-7 {
  padding-bottom: 1.75rem;
}
.pl-7 {
  padding-left: 1.75rem;
}
.pt-8 {
  padding-top: 2rem;
}
.pr-8 {
  padding-right: 2rem;
}
.pb-8 {
  padding-bottom: 2rem;
}
.pl-8 {
  padding-left: 2rem;
}
.pt-9 {
  padding-top: 2.25rem;
}
.pr-9 {
  padding-right: 2.25rem;
}
.pb-9 {
  padding-bottom: 2.25rem;
}
.pl-9 {
  padding-left: 2.25rem;
}
.pt-10 {
  padding-top: 2.5rem;
}
.pr-10 {
  padding-right: 2.5rem;
}
.pb-10 {
  padding-bottom: 2.5rem;
}
.pl-10 {
  padding-left: 2.5rem;
}
.pt-11 {
  padding-top: 2.75rem;
}
.pr-11 {
  padding-right: 2.75rem;
}
.pb-11 {
  padding-bottom: 2.75rem;
}
.pl-11 {
  padding-left: 2.75rem;
}
.pt-12 {
  padding-top: 3rem;
}
.pr-12 {
  padding-right: 3rem;
}
.pb-12 {
  padding-bottom: 3rem;
}
.pl-12 {
  padding-left: 3rem;
}
.pt-13 {
  padding-top: 3.25rem;
}
.pr-13 {
  padding-right: 3.25rem;
}
.pb-13 {
  padding-bottom: 3.25rem;
}
.pl-13 {
  padding-left: 3.25rem;
}
.pt-14 {
  padding-top: 3.5rem;
}
.pr-14 {
  padding-right: 3.5rem;
}
.pb-14 {
  padding-bottom: 3.5rem;
}
.pl-14 {
  padding-left: 3.5rem;
}
.pt-15 {
  padding-top: 3.75rem;
}
.pr-15 {
  padding-right: 3.75rem;
}
.pb-15 {
  padding-bottom: 3.75rem;
}
.pl-15 {
  padding-left: 3.75rem;
}
.pt-16 {
  padding-top: 4rem;
}
.pr-16 {
  padding-right: 4rem;
}
.pb-16 {
  padding-bottom: 4rem;
}
.pl-16 {
  padding-left: 4rem;
}
.pt-20 {
  padding-top: 5rem;
}
.pr-20 {
  padding-right: 5rem;
}
.pb-20 {
  padding-bottom: 5rem;
}
.pl-20 {
  padding-left: 5rem;
}
.pt-24 {
  padding-top: 6rem;
}
.pr-24 {
  padding-right: 6rem;
}
.pb-24 {
  padding-bottom: 6rem;
}
.pl-24 {
  padding-left: 6rem;
}
.pt-28 {
  padding-top: 7rem;
}
.pr-28 {
  padding-right: 7rem;
}
.pb-28 {
  padding-bottom: 7rem;
}
.pl-28 {
  padding-left: 7rem;
}
.pt-32 {
  padding-top: 8rem;
}
.pr-32 {
  padding-right: 8rem;
}
.pb-32 {
  padding-bottom: 8rem;
}
.pl-32 {
  padding-left: 8rem;
}
.pt-36 {
  padding-top: 9rem;
}
.pr-36 {
  padding-right: 9rem;
}
.pb-36 {
  padding-bottom: 9rem;
}
.pl-36 {
  padding-left: 9rem;
}
.pt-40 {
  padding-top: 10rem;
}
.pr-40 {
  padding-right: 10rem;
}
.pb-40 {
  padding-bottom: 10rem;
}
.pl-40 {
  padding-left: 10rem;
}
.pt-44 {
  padding-top: 11rem;
}
.pr-44 {
  padding-right: 11rem;
}
.pb-44 {
  padding-bottom: 11rem;
}
.pl-44 {
  padding-left: 11rem;
}
.pt-48 {
  padding-top: 12rem;
}
.pr-48 {
  padding-right: 12rem;
}
.pb-48 {
  padding-bottom: 12rem;
}
.pl-48 {
  padding-left: 12rem;
}
.pt-52 {
  padding-top: 13rem;
}
.pr-52 {
  padding-right: 13rem;
}
.pb-52 {
  padding-bottom: 13rem;
}
.pl-52 {
  padding-left: 13rem;
}
.pt-56 {
  padding-top: 14rem;
}
.pr-56 {
  padding-right: 14rem;
}
.pb-56 {
  padding-bottom: 14rem;
}
.pl-56 {
  padding-left: 14rem;
}
.pt-60 {
  padding-top: 15rem;
}
.pr-60 {
  padding-right: 15rem;
}
.pb-60 {
  padding-bottom: 15rem;
}
.pl-60 {
  padding-left: 15rem;
}
.pt-64 {
  padding-top: 16rem;
}
.pr-64 {
  padding-right: 16rem;
}
.pb-64 {
  padding-bottom: 16rem;
}
.pl-64 {
  padding-left: 16rem;
}
.pt-72 {
  padding-top: 18rem;
}
.pr-72 {
  padding-right: 18rem;
}
.pb-72 {
  padding-bottom: 18rem;
}
.pl-72 {
  padding-left: 18rem;
}
.pt-80 {
  padding-top: 20rem;
}
.pr-80 {
  padding-right: 20rem;
}
.pb-80 {
  padding-bottom: 20rem;
}
.pl-80 {
  padding-left: 20rem;
}
.pt-96 {
  padding-top: 24rem;
}
.pr-96 {
  padding-right: 24rem;
}
.pb-96 {
  padding-bottom: 24rem;
}
.pl-96 {
  padding-left: 24rem;
}
.pt-px {
  padding-top: 1px;
}
.pr-px {
  padding-right: 1px;
}
.pb-px {
  padding-bottom: 1px;
}
.pl-px {
  padding-left: 1px;
}
.pt-0\\.5 {
  padding-top: 0.125rem;
}
.pr-0\\.5 {
  padding-right: 0.125rem;
}
.pb-0\\.5 {
  padding-bottom: 0.125rem;
}
.pl-0\\.5 {
  padding-left: 0.125rem;
}
.pt-1\\.5 {
  padding-top: 0.375rem;
}
.pr-1\\.5 {
  padding-right: 0.375rem;
}
.pb-1\\.5 {
  padding-bottom: 0.375rem;
}
.pl-1\\.5 {
  padding-left: 0.375rem;
}
.pt-2\\.5 {
  padding-top: 0.625rem;
}
.pr-2\\.5 {
  padding-right: 0.625rem;
}
.pb-2\\.5 {
  padding-bottom: 0.625rem;
}
.pl-2\\.5 {
  padding-left: 0.625rem;
}
.pt-3\\.5 {
  padding-top: 0.875rem;
}
.pr-3\\.5 {
  padding-right: 0.875rem;
}
.pb-3\\.5 {
  padding-bottom: 0.875rem;
}
.pl-3\\.5 {
  padding-left: 0.875rem;
}
.pt-1\\/2 {
  padding-top: 50%;
}
.pr-1\\/2 {
  padding-right: 50%;
}
.pb-1\\/2 {
  padding-bottom: 50%;
}
.pl-1\\/2 {
  padding-left: 50%;
}
.pt-1\\/3 {
  padding-top: 33.333333%;
}
.pr-1\\/3 {
  padding-right: 33.333333%;
}
.pb-1\\/3 {
  padding-bottom: 33.333333%;
}
.pl-1\\/3 {
  padding-left: 33.333333%;
}
.pt-2\\/3 {
  padding-top: 66.666667%;
}
.pr-2\\/3 {
  padding-right: 66.666667%;
}
.pb-2\\/3 {
  padding-bottom: 66.666667%;
}
.pl-2\\/3 {
  padding-left: 66.666667%;
}
.pt-1\\/4 {
  padding-top: 25%;
}
.pr-1\\/4 {
  padding-right: 25%;
}
.pb-1\\/4 {
  padding-bottom: 25%;
}
.pl-1\\/4 {
  padding-left: 25%;
}
.pt-2\\/4 {
  padding-top: 50%;
}
.pr-2\\/4 {
  padding-right: 50%;
}
.pb-2\\/4 {
  padding-bottom: 50%;
}
.pl-2\\/4 {
  padding-left: 50%;
}
.pt-3\\/4 {
  padding-top: 75%;
}
.pr-3\\/4 {
  padding-right: 75%;
}
.pb-3\\/4 {
  padding-bottom: 75%;
}
.pl-3\\/4 {
  padding-left: 75%;
}
.pt-1\\/5 {
  padding-top: 20%;
}
.pr-1\\/5 {
  padding-right: 20%;
}
.pb-1\\/5 {
  padding-bottom: 20%;
}
.pl-1\\/5 {
  padding-left: 20%;
}
.pt-2\\/5 {
  padding-top: 40%;
}
.pr-2\\/5 {
  padding-right: 40%;
}
.pb-2\\/5 {
  padding-bottom: 40%;
}
.pl-2\\/5 {
  padding-left: 40%;
}
.pt-3\\/5 {
  padding-top: 60%;
}
.pr-3\\/5 {
  padding-right: 60%;
}
.pb-3\\/5 {
  padding-bottom: 60%;
}
.pl-3\\/5 {
  padding-left: 60%;
}
.pt-4\\/5 {
  padding-top: 80%;
}
.pr-4\\/5 {
  padding-right: 80%;
}
.pb-4\\/5 {
  padding-bottom: 80%;
}
.pl-4\\/5 {
  padding-left: 80%;
}
.pt-1\\/6 {
  padding-top: 16.666667%;
}
.pr-1\\/6 {
  padding-right: 16.666667%;
}
.pb-1\\/6 {
  padding-bottom: 16.666667%;
}
.pl-1\\/6 {
  padding-left: 16.666667%;
}
.pt-2\\/6 {
  padding-top: 33.333333%;
}
.pr-2\\/6 {
  padding-right: 33.333333%;
}
.pb-2\\/6 {
  padding-bottom: 33.333333%;
}
.pl-2\\/6 {
  padding-left: 33.333333%;
}
.pt-3\\/6 {
  padding-top: 50%;
}
.pr-3\\/6 {
  padding-right: 50%;
}
.pb-3\\/6 {
  padding-bottom: 50%;
}
.pl-3\\/6 {
  padding-left: 50%;
}
.pt-4\\/6 {
  padding-top: 66.666667%;
}
.pr-4\\/6 {
  padding-right: 66.666667%;
}
.pb-4\\/6 {
  padding-bottom: 66.666667%;
}
.pl-4\\/6 {
  padding-left: 66.666667%;
}
.pt-5\\/6 {
  padding-top: 83.333333%;
}
.pr-5\\/6 {
  padding-right: 83.333333%;
}
.pb-5\\/6 {
  padding-bottom: 83.333333%;
}
.pl-5\\/6 {
  padding-left: 83.333333%;
}
.pt-1\\/12 {
  padding-top: 8.333333%;
}
.pr-1\\/12 {
  padding-right: 8.333333%;
}
.pb-1\\/12 {
  padding-bottom: 8.333333%;
}
.pl-1\\/12 {
  padding-left: 8.333333%;
}
.pt-2\\/12 {
  padding-top: 16.666667%;
}
.pr-2\\/12 {
  padding-right: 16.666667%;
}
.pb-2\\/12 {
  padding-bottom: 16.666667%;
}
.pl-2\\/12 {
  padding-left: 16.666667%;
}
.pt-3\\/12 {
  padding-top: 25%;
}
.pr-3\\/12 {
  padding-right: 25%;
}
.pb-3\\/12 {
  padding-bottom: 25%;
}
.pl-3\\/12 {
  padding-left: 25%;
}
.pt-4\\/12 {
  padding-top: 33.333333%;
}
.pr-4\\/12 {
  padding-right: 33.333333%;
}
.pb-4\\/12 {
  padding-bottom: 33.333333%;
}
.pl-4\\/12 {
  padding-left: 33.333333%;
}
.pt-5\\/12 {
  padding-top: 41.666667%;
}
.pr-5\\/12 {
  padding-right: 41.666667%;
}
.pb-5\\/12 {
  padding-bottom: 41.666667%;
}
.pl-5\\/12 {
  padding-left: 41.666667%;
}
.pt-6\\/12 {
  padding-top: 50%;
}
.pr-6\\/12 {
  padding-right: 50%;
}
.pb-6\\/12 {
  padding-bottom: 50%;
}
.pl-6\\/12 {
  padding-left: 50%;
}
.pt-7\\/12 {
  padding-top: 58.333333%;
}
.pr-7\\/12 {
  padding-right: 58.333333%;
}
.pb-7\\/12 {
  padding-bottom: 58.333333%;
}
.pl-7\\/12 {
  padding-left: 58.333333%;
}
.pt-8\\/12 {
  padding-top: 66.666667%;
}
.pr-8\\/12 {
  padding-right: 66.666667%;
}
.pb-8\\/12 {
  padding-bottom: 66.666667%;
}
.pl-8\\/12 {
  padding-left: 66.666667%;
}
.pt-9\\/12 {
  padding-top: 75%;
}
.pr-9\\/12 {
  padding-right: 75%;
}
.pb-9\\/12 {
  padding-bottom: 75%;
}
.pl-9\\/12 {
  padding-left: 75%;
}
.pt-10\\/12 {
  padding-top: 83.333333%;
}
.pr-10\\/12 {
  padding-right: 83.333333%;
}
.pb-10\\/12 {
  padding-bottom: 83.333333%;
}
.pl-10\\/12 {
  padding-left: 83.333333%;
}
.pt-11\\/12 {
  padding-top: 91.666667%;
}
.pr-11\\/12 {
  padding-right: 91.666667%;
}
.pb-11\\/12 {
  padding-bottom: 91.666667%;
}
.pl-11\\/12 {
  padding-left: 91.666667%;
}
.pt-full {
  padding-top: 100%;
}
.pr-full {
  padding-right: 100%;
}
.pb-full {
  padding-bottom: 100%;
}
.pl-full {
  padding-left: 100%;
}
.placeholder-current::placeholder {
  color: currentColor;
}
.placeholder-transparent::placeholder {
  color: transparent;
}
.placeholder-white::placeholder {
  --placeholder-opacity: 1;
  color: #ffffff;
  color: rgba(255, 255, 255, var(--placeholder-opacity));
}
.placeholder-black::placeholder {
  --placeholder-opacity: 1;
  color: #000000;
  color: rgba(0, 0, 0, var(--placeholder-opacity));
}
.placeholder-gray-50::placeholder {
  --placeholder-opacity: 1;
  color: #f9fafb;
  color: rgba(249, 250, 251, var(--placeholder-opacity));
}
.placeholder-gray-100::placeholder {
  --placeholder-opacity: 1;
  color: #f4f5f7;
  color: rgba(244, 245, 247, var(--placeholder-opacity));
}
.placeholder-gray-200::placeholder {
  --placeholder-opacity: 1;
  color: #e5e7eb;
  color: rgba(229, 231, 235, var(--placeholder-opacity));
}
.placeholder-gray-300::placeholder {
  --placeholder-opacity: 1;
  color: #d2d6dc;
  color: rgba(210, 214, 220, var(--placeholder-opacity));
}
.placeholder-gray-400::placeholder {
  --placeholder-opacity: 1;
  color: #9fa6b2;
  color: rgba(159, 166, 178, var(--placeholder-opacity));
}
.placeholder-gray-500::placeholder {
  --placeholder-opacity: 1;
  color: #6b7280;
  color: rgba(107, 114, 128, var(--placeholder-opacity));
}
.placeholder-gray-600::placeholder {
  --placeholder-opacity: 1;
  color: #4b5563;
  color: rgba(75, 85, 99, var(--placeholder-opacity));
}
.placeholder-gray-700::placeholder {
  --placeholder-opacity: 1;
  color: #374151;
  color: rgba(55, 65, 81, var(--placeholder-opacity));
}
.placeholder-gray-800::placeholder {
  --placeholder-opacity: 1;
  color: #252f3f;
  color: rgba(37, 47, 63, var(--placeholder-opacity));
}
.placeholder-gray-900::placeholder {
  --placeholder-opacity: 1;
  color: #161e2e;
  color: rgba(22, 30, 46, var(--placeholder-opacity));
}
.placeholder-red-50::placeholder {
  --placeholder-opacity: 1;
  color: #fdf2f2;
  color: rgba(253, 242, 242, var(--placeholder-opacity));
}
.placeholder-red-100::placeholder {
  --placeholder-opacity: 1;
  color: #fde8e8;
  color: rgba(253, 232, 232, var(--placeholder-opacity));
}
.placeholder-red-200::placeholder {
  --placeholder-opacity: 1;
  color: #fbd5d5;
  color: rgba(251, 213, 213, var(--placeholder-opacity));
}
.placeholder-red-300::placeholder {
  --placeholder-opacity: 1;
  color: #f8b4b4;
  color: rgba(248, 180, 180, var(--placeholder-opacity));
}
.placeholder-red-400::placeholder {
  --placeholder-opacity: 1;
  color: #f98080;
  color: rgba(249, 128, 128, var(--placeholder-opacity));
}
.placeholder-red-500::placeholder {
  --placeholder-opacity: 1;
  color: #f05252;
  color: rgba(240, 82, 82, var(--placeholder-opacity));
}
.placeholder-red-600::placeholder {
  --placeholder-opacity: 1;
  color: #e02424;
  color: rgba(224, 36, 36, var(--placeholder-opacity));
}
.placeholder-red-700::placeholder {
  --placeholder-opacity: 1;
  color: #c81e1e;
  color: rgba(200, 30, 30, var(--placeholder-opacity));
}
.placeholder-red-800::placeholder {
  --placeholder-opacity: 1;
  color: #9b1c1c;
  color: rgba(155, 28, 28, var(--placeholder-opacity));
}
.placeholder-red-900::placeholder {
  --placeholder-opacity: 1;
  color: #771d1d;
  color: rgba(119, 29, 29, var(--placeholder-opacity));
}
.placeholder-orange-50::placeholder {
  --placeholder-opacity: 1;
  color: #fff8f1;
  color: rgba(255, 248, 241, var(--placeholder-opacity));
}
.placeholder-orange-100::placeholder {
  --placeholder-opacity: 1;
  color: #feecdc;
  color: rgba(254, 236, 220, var(--placeholder-opacity));
}
.placeholder-orange-200::placeholder {
  --placeholder-opacity: 1;
  color: #fcd9bd;
  color: rgba(252, 217, 189, var(--placeholder-opacity));
}
.placeholder-orange-300::placeholder {
  --placeholder-opacity: 1;
  color: #fdba8c;
  color: rgba(253, 186, 140, var(--placeholder-opacity));
}
.placeholder-orange-400::placeholder {
  --placeholder-opacity: 1;
  color: #ff8a4c;
  color: rgba(255, 138, 76, var(--placeholder-opacity));
}
.placeholder-orange-500::placeholder {
  --placeholder-opacity: 1;
  color: #ff5a1f;
  color: rgba(255, 90, 31, var(--placeholder-opacity));
}
.placeholder-orange-600::placeholder {
  --placeholder-opacity: 1;
  color: #d03801;
  color: rgba(208, 56, 1, var(--placeholder-opacity));
}
.placeholder-orange-700::placeholder {
  --placeholder-opacity: 1;
  color: #b43403;
  color: rgba(180, 52, 3, var(--placeholder-opacity));
}
.placeholder-orange-800::placeholder {
  --placeholder-opacity: 1;
  color: #8a2c0d;
  color: rgba(138, 44, 13, var(--placeholder-opacity));
}
.placeholder-orange-900::placeholder {
  --placeholder-opacity: 1;
  color: #73230d;
  color: rgba(115, 35, 13, var(--placeholder-opacity));
}
.placeholder-yellow-50::placeholder {
  --placeholder-opacity: 1;
  color: #fdfdea;
  color: rgba(253, 253, 234, var(--placeholder-opacity));
}
.placeholder-yellow-100::placeholder {
  --placeholder-opacity: 1;
  color: #fdf6b2;
  color: rgba(253, 246, 178, var(--placeholder-opacity));
}
.placeholder-yellow-200::placeholder {
  --placeholder-opacity: 1;
  color: #fce96a;
  color: rgba(252, 233, 106, var(--placeholder-opacity));
}
.placeholder-yellow-300::placeholder {
  --placeholder-opacity: 1;
  color: #faca15;
  color: rgba(250, 202, 21, var(--placeholder-opacity));
}
.placeholder-yellow-400::placeholder {
  --placeholder-opacity: 1;
  color: #e3a008;
  color: rgba(227, 160, 8, var(--placeholder-opacity));
}
.placeholder-yellow-500::placeholder {
  --placeholder-opacity: 1;
  color: #c27803;
  color: rgba(194, 120, 3, var(--placeholder-opacity));
}
.placeholder-yellow-600::placeholder {
  --placeholder-opacity: 1;
  color: #9f580a;
  color: rgba(159, 88, 10, var(--placeholder-opacity));
}
.placeholder-yellow-700::placeholder {
  --placeholder-opacity: 1;
  color: #8e4b10;
  color: rgba(142, 75, 16, var(--placeholder-opacity));
}
.placeholder-yellow-800::placeholder {
  --placeholder-opacity: 1;
  color: #723b13;
  color: rgba(114, 59, 19, var(--placeholder-opacity));
}
.placeholder-yellow-900::placeholder {
  --placeholder-opacity: 1;
  color: #633112;
  color: rgba(99, 49, 18, var(--placeholder-opacity));
}
.placeholder-green-50::placeholder {
  --placeholder-opacity: 1;
  color: #f3faf7;
  color: rgba(243, 250, 247, var(--placeholder-opacity));
}
.placeholder-green-100::placeholder {
  --placeholder-opacity: 1;
  color: #def7ec;
  color: rgba(222, 247, 236, var(--placeholder-opacity));
}
.placeholder-green-200::placeholder {
  --placeholder-opacity: 1;
  color: #bcf0da;
  color: rgba(188, 240, 218, var(--placeholder-opacity));
}
.placeholder-green-300::placeholder {
  --placeholder-opacity: 1;
  color: #84e1bc;
  color: rgba(132, 225, 188, var(--placeholder-opacity));
}
.placeholder-green-400::placeholder {
  --placeholder-opacity: 1;
  color: #31c48d;
  color: rgba(49, 196, 141, var(--placeholder-opacity));
}
.placeholder-green-500::placeholder {
  --placeholder-opacity: 1;
  color: #0e9f6e;
  color: rgba(14, 159, 110, var(--placeholder-opacity));
}
.placeholder-green-600::placeholder {
  --placeholder-opacity: 1;
  color: #057a55;
  color: rgba(5, 122, 85, var(--placeholder-opacity));
}
.placeholder-green-700::placeholder {
  --placeholder-opacity: 1;
  color: #046c4e;
  color: rgba(4, 108, 78, var(--placeholder-opacity));
}
.placeholder-green-800::placeholder {
  --placeholder-opacity: 1;
  color: #03543f;
  color: rgba(3, 84, 63, var(--placeholder-opacity));
}
.placeholder-green-900::placeholder {
  --placeholder-opacity: 1;
  color: #014737;
  color: rgba(1, 71, 55, var(--placeholder-opacity));
}
.placeholder-teal-50::placeholder {
  --placeholder-opacity: 1;
  color: #edfafa;
  color: rgba(237, 250, 250, var(--placeholder-opacity));
}
.placeholder-teal-100::placeholder {
  --placeholder-opacity: 1;
  color: #d5f5f6;
  color: rgba(213, 245, 246, var(--placeholder-opacity));
}
.placeholder-teal-200::placeholder {
  --placeholder-opacity: 1;
  color: #afecef;
  color: rgba(175, 236, 239, var(--placeholder-opacity));
}
.placeholder-teal-300::placeholder {
  --placeholder-opacity: 1;
  color: #7edce2;
  color: rgba(126, 220, 226, var(--placeholder-opacity));
}
.placeholder-teal-400::placeholder {
  --placeholder-opacity: 1;
  color: #16bdca;
  color: rgba(22, 189, 202, var(--placeholder-opacity));
}
.placeholder-teal-500::placeholder {
  --placeholder-opacity: 1;
  color: #0694a2;
  color: rgba(6, 148, 162, var(--placeholder-opacity));
}
.placeholder-teal-600::placeholder {
  --placeholder-opacity: 1;
  color: #047481;
  color: rgba(4, 116, 129, var(--placeholder-opacity));
}
.placeholder-teal-700::placeholder {
  --placeholder-opacity: 1;
  color: #036672;
  color: rgba(3, 102, 114, var(--placeholder-opacity));
}
.placeholder-teal-800::placeholder {
  --placeholder-opacity: 1;
  color: #05505c;
  color: rgba(5, 80, 92, var(--placeholder-opacity));
}
.placeholder-teal-900::placeholder {
  --placeholder-opacity: 1;
  color: #014451;
  color: rgba(1, 68, 81, var(--placeholder-opacity));
}
.placeholder-blue-50::placeholder {
  --placeholder-opacity: 1;
  color: #ebf5ff;
  color: rgba(235, 245, 255, var(--placeholder-opacity));
}
.placeholder-blue-100::placeholder {
  --placeholder-opacity: 1;
  color: #e1effe;
  color: rgba(225, 239, 254, var(--placeholder-opacity));
}
.placeholder-blue-200::placeholder {
  --placeholder-opacity: 1;
  color: #c3ddfd;
  color: rgba(195, 221, 253, var(--placeholder-opacity));
}
.placeholder-blue-300::placeholder {
  --placeholder-opacity: 1;
  color: #a4cafe;
  color: rgba(164, 202, 254, var(--placeholder-opacity));
}
.placeholder-blue-400::placeholder {
  --placeholder-opacity: 1;
  color: #76a9fa;
  color: rgba(118, 169, 250, var(--placeholder-opacity));
}
.placeholder-blue-500::placeholder {
  --placeholder-opacity: 1;
  color: #3f83f8;
  color: rgba(63, 131, 248, var(--placeholder-opacity));
}
.placeholder-blue-600::placeholder {
  --placeholder-opacity: 1;
  color: #1c64f2;
  color: rgba(28, 100, 242, var(--placeholder-opacity));
}
.placeholder-blue-700::placeholder {
  --placeholder-opacity: 1;
  color: #1a56db;
  color: rgba(26, 86, 219, var(--placeholder-opacity));
}
.placeholder-blue-800::placeholder {
  --placeholder-opacity: 1;
  color: #1e429f;
  color: rgba(30, 66, 159, var(--placeholder-opacity));
}
.placeholder-blue-900::placeholder {
  --placeholder-opacity: 1;
  color: #233876;
  color: rgba(35, 56, 118, var(--placeholder-opacity));
}
.placeholder-indigo-50::placeholder {
  --placeholder-opacity: 1;
  color: #f0f5ff;
  color: rgba(240, 245, 255, var(--placeholder-opacity));
}
.placeholder-indigo-100::placeholder {
  --placeholder-opacity: 1;
  color: #e5edff;
  color: rgba(229, 237, 255, var(--placeholder-opacity));
}
.placeholder-indigo-200::placeholder {
  --placeholder-opacity: 1;
  color: #cddbfe;
  color: rgba(205, 219, 254, var(--placeholder-opacity));
}
.placeholder-indigo-300::placeholder {
  --placeholder-opacity: 1;
  color: #b4c6fc;
  color: rgba(180, 198, 252, var(--placeholder-opacity));
}
.placeholder-indigo-400::placeholder {
  --placeholder-opacity: 1;
  color: #8da2fb;
  color: rgba(141, 162, 251, var(--placeholder-opacity));
}
.placeholder-indigo-500::placeholder {
  --placeholder-opacity: 1;
  color: #6875f5;
  color: rgba(104, 117, 245, var(--placeholder-opacity));
}
.placeholder-indigo-600::placeholder {
  --placeholder-opacity: 1;
  color: #5850ec;
  color: rgba(88, 80, 236, var(--placeholder-opacity));
}
.placeholder-indigo-700::placeholder {
  --placeholder-opacity: 1;
  color: #5145cd;
  color: rgba(81, 69, 205, var(--placeholder-opacity));
}
.placeholder-indigo-800::placeholder {
  --placeholder-opacity: 1;
  color: #42389d;
  color: rgba(66, 56, 157, var(--placeholder-opacity));
}
.placeholder-indigo-900::placeholder {
  --placeholder-opacity: 1;
  color: #362f78;
  color: rgba(54, 47, 120, var(--placeholder-opacity));
}
.placeholder-purple-50::placeholder {
  --placeholder-opacity: 1;
  color: #f6f5ff;
  color: rgba(246, 245, 255, var(--placeholder-opacity));
}
.placeholder-purple-100::placeholder {
  --placeholder-opacity: 1;
  color: #edebfe;
  color: rgba(237, 235, 254, var(--placeholder-opacity));
}
.placeholder-purple-200::placeholder {
  --placeholder-opacity: 1;
  color: #dcd7fe;
  color: rgba(220, 215, 254, var(--placeholder-opacity));
}
.placeholder-purple-300::placeholder {
  --placeholder-opacity: 1;
  color: #cabffd;
  color: rgba(202, 191, 253, var(--placeholder-opacity));
}
.placeholder-purple-400::placeholder {
  --placeholder-opacity: 1;
  color: #ac94fa;
  color: rgba(172, 148, 250, var(--placeholder-opacity));
}
.placeholder-purple-500::placeholder {
  --placeholder-opacity: 1;
  color: #9061f9;
  color: rgba(144, 97, 249, var(--placeholder-opacity));
}
.placeholder-purple-600::placeholder {
  --placeholder-opacity: 1;
  color: #7e3af2;
  color: rgba(126, 58, 242, var(--placeholder-opacity));
}
.placeholder-purple-700::placeholder {
  --placeholder-opacity: 1;
  color: #6c2bd9;
  color: rgba(108, 43, 217, var(--placeholder-opacity));
}
.placeholder-purple-800::placeholder {
  --placeholder-opacity: 1;
  color: #5521b5;
  color: rgba(85, 33, 181, var(--placeholder-opacity));
}
.placeholder-purple-900::placeholder {
  --placeholder-opacity: 1;
  color: #4a1d96;
  color: rgba(74, 29, 150, var(--placeholder-opacity));
}
.placeholder-pink-50::placeholder {
  --placeholder-opacity: 1;
  color: #fdf2f8;
  color: rgba(253, 242, 248, var(--placeholder-opacity));
}
.placeholder-pink-100::placeholder {
  --placeholder-opacity: 1;
  color: #fce8f3;
  color: rgba(252, 232, 243, var(--placeholder-opacity));
}
.placeholder-pink-200::placeholder {
  --placeholder-opacity: 1;
  color: #fad1e8;
  color: rgba(250, 209, 232, var(--placeholder-opacity));
}
.placeholder-pink-300::placeholder {
  --placeholder-opacity: 1;
  color: #f8b4d9;
  color: rgba(248, 180, 217, var(--placeholder-opacity));
}
.placeholder-pink-400::placeholder {
  --placeholder-opacity: 1;
  color: #f17eb8;
  color: rgba(241, 126, 184, var(--placeholder-opacity));
}
.placeholder-pink-500::placeholder {
  --placeholder-opacity: 1;
  color: #e74694;
  color: rgba(231, 70, 148, var(--placeholder-opacity));
}
.placeholder-pink-600::placeholder {
  --placeholder-opacity: 1;
  color: #d61f69;
  color: rgba(214, 31, 105, var(--placeholder-opacity));
}
.placeholder-pink-700::placeholder {
  --placeholder-opacity: 1;
  color: #bf125d;
  color: rgba(191, 18, 93, var(--placeholder-opacity));
}
.placeholder-pink-800::placeholder {
  --placeholder-opacity: 1;
  color: #99154b;
  color: rgba(153, 21, 75, var(--placeholder-opacity));
}
.placeholder-pink-900::placeholder {
  --placeholder-opacity: 1;
  color: #751a3d;
  color: rgba(117, 26, 61, var(--placeholder-opacity));
}
.placeholder-cool-gray-50::placeholder {
  --placeholder-opacity: 1;
  color: #f8fafc;
  color: rgba(248, 250, 252, var(--placeholder-opacity));
}
.placeholder-cool-gray-100::placeholder {
  --placeholder-opacity: 1;
  color: #f1f5f9;
  color: rgba(241, 245, 249, var(--placeholder-opacity));
}
.placeholder-cool-gray-200::placeholder {
  --placeholder-opacity: 1;
  color: #e2e8f0;
  color: rgba(226, 232, 240, var(--placeholder-opacity));
}
.placeholder-cool-gray-300::placeholder {
  --placeholder-opacity: 1;
  color: #cfd8e3;
  color: rgba(207, 216, 227, var(--placeholder-opacity));
}
.placeholder-cool-gray-400::placeholder {
  --placeholder-opacity: 1;
  color: #97a6ba;
  color: rgba(151, 166, 186, var(--placeholder-opacity));
}
.placeholder-cool-gray-500::placeholder {
  --placeholder-opacity: 1;
  color: #64748b;
  color: rgba(100, 116, 139, var(--placeholder-opacity));
}
.placeholder-cool-gray-600::placeholder {
  --placeholder-opacity: 1;
  color: #475569;
  color: rgba(71, 85, 105, var(--placeholder-opacity));
}
.placeholder-cool-gray-700::placeholder {
  --placeholder-opacity: 1;
  color: #364152;
  color: rgba(54, 65, 82, var(--placeholder-opacity));
}
.placeholder-cool-gray-800::placeholder {
  --placeholder-opacity: 1;
  color: #27303f;
  color: rgba(39, 48, 63, var(--placeholder-opacity));
}
.placeholder-cool-gray-900::placeholder {
  --placeholder-opacity: 1;
  color: #1a202e;
  color: rgba(26, 32, 46, var(--placeholder-opacity));
}
.focus\\:placeholder-current:focus::placeholder {
  color: currentColor;
}
.focus\\:placeholder-transparent:focus::placeholder {
  color: transparent;
}
.focus\\:placeholder-white:focus::placeholder {
  --placeholder-opacity: 1;
  color: #ffffff;
  color: rgba(255, 255, 255, var(--placeholder-opacity));
}
.focus\\:placeholder-black:focus::placeholder {
  --placeholder-opacity: 1;
  color: #000000;
  color: rgba(0, 0, 0, var(--placeholder-opacity));
}
.focus\\:placeholder-gray-50:focus::placeholder {
  --placeholder-opacity: 1;
  color: #f9fafb;
  color: rgba(249, 250, 251, var(--placeholder-opacity));
}
.focus\\:placeholder-gray-100:focus::placeholder {
  --placeholder-opacity: 1;
  color: #f4f5f7;
  color: rgba(244, 245, 247, var(--placeholder-opacity));
}
.focus\\:placeholder-gray-200:focus::placeholder {
  --placeholder-opacity: 1;
  color: #e5e7eb;
  color: rgba(229, 231, 235, var(--placeholder-opacity));
}
.focus\\:placeholder-gray-300:focus::placeholder {
  --placeholder-opacity: 1;
  color: #d2d6dc;
  color: rgba(210, 214, 220, var(--placeholder-opacity));
}
.focus\\:placeholder-gray-400:focus::placeholder {
  --placeholder-opacity: 1;
  color: #9fa6b2;
  color: rgba(159, 166, 178, var(--placeholder-opacity));
}
.focus\\:placeholder-gray-500:focus::placeholder {
  --placeholder-opacity: 1;
  color: #6b7280;
  color: rgba(107, 114, 128, var(--placeholder-opacity));
}
.focus\\:placeholder-gray-600:focus::placeholder {
  --placeholder-opacity: 1;
  color: #4b5563;
  color: rgba(75, 85, 99, var(--placeholder-opacity));
}
.focus\\:placeholder-gray-700:focus::placeholder {
  --placeholder-opacity: 1;
  color: #374151;
  color: rgba(55, 65, 81, var(--placeholder-opacity));
}
.focus\\:placeholder-gray-800:focus::placeholder {
  --placeholder-opacity: 1;
  color: #252f3f;
  color: rgba(37, 47, 63, var(--placeholder-opacity));
}
.focus\\:placeholder-gray-900:focus::placeholder {
  --placeholder-opacity: 1;
  color: #161e2e;
  color: rgba(22, 30, 46, var(--placeholder-opacity));
}
.focus\\:placeholder-red-50:focus::placeholder {
  --placeholder-opacity: 1;
  color: #fdf2f2;
  color: rgba(253, 242, 242, var(--placeholder-opacity));
}
.focus\\:placeholder-red-100:focus::placeholder {
  --placeholder-opacity: 1;
  color: #fde8e8;
  color: rgba(253, 232, 232, var(--placeholder-opacity));
}
.focus\\:placeholder-red-200:focus::placeholder {
  --placeholder-opacity: 1;
  color: #fbd5d5;
  color: rgba(251, 213, 213, var(--placeholder-opacity));
}
.focus\\:placeholder-red-300:focus::placeholder {
  --placeholder-opacity: 1;
  color: #f8b4b4;
  color: rgba(248, 180, 180, var(--placeholder-opacity));
}
.focus\\:placeholder-red-400:focus::placeholder {
  --placeholder-opacity: 1;
  color: #f98080;
  color: rgba(249, 128, 128, var(--placeholder-opacity));
}
.focus\\:placeholder-red-500:focus::placeholder {
  --placeholder-opacity: 1;
  color: #f05252;
  color: rgba(240, 82, 82, var(--placeholder-opacity));
}
.focus\\:placeholder-red-600:focus::placeholder {
  --placeholder-opacity: 1;
  color: #e02424;
  color: rgba(224, 36, 36, var(--placeholder-opacity));
}
.focus\\:placeholder-red-700:focus::placeholder {
  --placeholder-opacity: 1;
  color: #c81e1e;
  color: rgba(200, 30, 30, var(--placeholder-opacity));
}
.focus\\:placeholder-red-800:focus::placeholder {
  --placeholder-opacity: 1;
  color: #9b1c1c;
  color: rgba(155, 28, 28, var(--placeholder-opacity));
}
.focus\\:placeholder-red-900:focus::placeholder {
  --placeholder-opacity: 1;
  color: #771d1d;
  color: rgba(119, 29, 29, var(--placeholder-opacity));
}
.focus\\:placeholder-orange-50:focus::placeholder {
  --placeholder-opacity: 1;
  color: #fff8f1;
  color: rgba(255, 248, 241, var(--placeholder-opacity));
}
.focus\\:placeholder-orange-100:focus::placeholder {
  --placeholder-opacity: 1;
  color: #feecdc;
  color: rgba(254, 236, 220, var(--placeholder-opacity));
}
.focus\\:placeholder-orange-200:focus::placeholder {
  --placeholder-opacity: 1;
  color: #fcd9bd;
  color: rgba(252, 217, 189, var(--placeholder-opacity));
}
.focus\\:placeholder-orange-300:focus::placeholder {
  --placeholder-opacity: 1;
  color: #fdba8c;
  color: rgba(253, 186, 140, var(--placeholder-opacity));
}
.focus\\:placeholder-orange-400:focus::placeholder {
  --placeholder-opacity: 1;
  color: #ff8a4c;
  color: rgba(255, 138, 76, var(--placeholder-opacity));
}
.focus\\:placeholder-orange-500:focus::placeholder {
  --placeholder-opacity: 1;
  color: #ff5a1f;
  color: rgba(255, 90, 31, var(--placeholder-opacity));
}
.focus\\:placeholder-orange-600:focus::placeholder {
  --placeholder-opacity: 1;
  color: #d03801;
  color: rgba(208, 56, 1, var(--placeholder-opacity));
}
.focus\\:placeholder-orange-700:focus::placeholder {
  --placeholder-opacity: 1;
  color: #b43403;
  color: rgba(180, 52, 3, var(--placeholder-opacity));
}
.focus\\:placeholder-orange-800:focus::placeholder {
  --placeholder-opacity: 1;
  color: #8a2c0d;
  color: rgba(138, 44, 13, var(--placeholder-opacity));
}
.focus\\:placeholder-orange-900:focus::placeholder {
  --placeholder-opacity: 1;
  color: #73230d;
  color: rgba(115, 35, 13, var(--placeholder-opacity));
}
.focus\\:placeholder-yellow-50:focus::placeholder {
  --placeholder-opacity: 1;
  color: #fdfdea;
  color: rgba(253, 253, 234, var(--placeholder-opacity));
}
.focus\\:placeholder-yellow-100:focus::placeholder {
  --placeholder-opacity: 1;
  color: #fdf6b2;
  color: rgba(253, 246, 178, var(--placeholder-opacity));
}
.focus\\:placeholder-yellow-200:focus::placeholder {
  --placeholder-opacity: 1;
  color: #fce96a;
  color: rgba(252, 233, 106, var(--placeholder-opacity));
}
.focus\\:placeholder-yellow-300:focus::placeholder {
  --placeholder-opacity: 1;
  color: #faca15;
  color: rgba(250, 202, 21, var(--placeholder-opacity));
}
.focus\\:placeholder-yellow-400:focus::placeholder {
  --placeholder-opacity: 1;
  color: #e3a008;
  color: rgba(227, 160, 8, var(--placeholder-opacity));
}
.focus\\:placeholder-yellow-500:focus::placeholder {
  --placeholder-opacity: 1;
  color: #c27803;
  color: rgba(194, 120, 3, var(--placeholder-opacity));
}
.focus\\:placeholder-yellow-600:focus::placeholder {
  --placeholder-opacity: 1;
  color: #9f580a;
  color: rgba(159, 88, 10, var(--placeholder-opacity));
}
.focus\\:placeholder-yellow-700:focus::placeholder {
  --placeholder-opacity: 1;
  color: #8e4b10;
  color: rgba(142, 75, 16, var(--placeholder-opacity));
}
.focus\\:placeholder-yellow-800:focus::placeholder {
  --placeholder-opacity: 1;
  color: #723b13;
  color: rgba(114, 59, 19, var(--placeholder-opacity));
}
.focus\\:placeholder-yellow-900:focus::placeholder {
  --placeholder-opacity: 1;
  color: #633112;
  color: rgba(99, 49, 18, var(--placeholder-opacity));
}
.focus\\:placeholder-green-50:focus::placeholder {
  --placeholder-opacity: 1;
  color: #f3faf7;
  color: rgba(243, 250, 247, var(--placeholder-opacity));
}
.focus\\:placeholder-green-100:focus::placeholder {
  --placeholder-opacity: 1;
  color: #def7ec;
  color: rgba(222, 247, 236, var(--placeholder-opacity));
}
.focus\\:placeholder-green-200:focus::placeholder {
  --placeholder-opacity: 1;
  color: #bcf0da;
  color: rgba(188, 240, 218, var(--placeholder-opacity));
}
.focus\\:placeholder-green-300:focus::placeholder {
  --placeholder-opacity: 1;
  color: #84e1bc;
  color: rgba(132, 225, 188, var(--placeholder-opacity));
}
.focus\\:placeholder-green-400:focus::placeholder {
  --placeholder-opacity: 1;
  color: #31c48d;
  color: rgba(49, 196, 141, var(--placeholder-opacity));
}
.focus\\:placeholder-green-500:focus::placeholder {
  --placeholder-opacity: 1;
  color: #0e9f6e;
  color: rgba(14, 159, 110, var(--placeholder-opacity));
}
.focus\\:placeholder-green-600:focus::placeholder {
  --placeholder-opacity: 1;
  color: #057a55;
  color: rgba(5, 122, 85, var(--placeholder-opacity));
}
.focus\\:placeholder-green-700:focus::placeholder {
  --placeholder-opacity: 1;
  color: #046c4e;
  color: rgba(4, 108, 78, var(--placeholder-opacity));
}
.focus\\:placeholder-green-800:focus::placeholder {
  --placeholder-opacity: 1;
  color: #03543f;
  color: rgba(3, 84, 63, var(--placeholder-opacity));
}
.focus\\:placeholder-green-900:focus::placeholder {
  --placeholder-opacity: 1;
  color: #014737;
  color: rgba(1, 71, 55, var(--placeholder-opacity));
}
.focus\\:placeholder-teal-50:focus::placeholder {
  --placeholder-opacity: 1;
  color: #edfafa;
  color: rgba(237, 250, 250, var(--placeholder-opacity));
}
.focus\\:placeholder-teal-100:focus::placeholder {
  --placeholder-opacity: 1;
  color: #d5f5f6;
  color: rgba(213, 245, 246, var(--placeholder-opacity));
}
.focus\\:placeholder-teal-200:focus::placeholder {
  --placeholder-opacity: 1;
  color: #afecef;
  color: rgba(175, 236, 239, var(--placeholder-opacity));
}
.focus\\:placeholder-teal-300:focus::placeholder {
  --placeholder-opacity: 1;
  color: #7edce2;
  color: rgba(126, 220, 226, var(--placeholder-opacity));
}
.focus\\:placeholder-teal-400:focus::placeholder {
  --placeholder-opacity: 1;
  color: #16bdca;
  color: rgba(22, 189, 202, var(--placeholder-opacity));
}
.focus\\:placeholder-teal-500:focus::placeholder {
  --placeholder-opacity: 1;
  color: #0694a2;
  color: rgba(6, 148, 162, var(--placeholder-opacity));
}
.focus\\:placeholder-teal-600:focus::placeholder {
  --placeholder-opacity: 1;
  color: #047481;
  color: rgba(4, 116, 129, var(--placeholder-opacity));
}
.focus\\:placeholder-teal-700:focus::placeholder {
  --placeholder-opacity: 1;
  color: #036672;
  color: rgba(3, 102, 114, var(--placeholder-opacity));
}
.focus\\:placeholder-teal-800:focus::placeholder {
  --placeholder-opacity: 1;
  color: #05505c;
  color: rgba(5, 80, 92, var(--placeholder-opacity));
}
.focus\\:placeholder-teal-900:focus::placeholder {
  --placeholder-opacity: 1;
  color: #014451;
  color: rgba(1, 68, 81, var(--placeholder-opacity));
}
.focus\\:placeholder-blue-50:focus::placeholder {
  --placeholder-opacity: 1;
  color: #ebf5ff;
  color: rgba(235, 245, 255, var(--placeholder-opacity));
}
.focus\\:placeholder-blue-100:focus::placeholder {
  --placeholder-opacity: 1;
  color: #e1effe;
  color: rgba(225, 239, 254, var(--placeholder-opacity));
}
.focus\\:placeholder-blue-200:focus::placeholder {
  --placeholder-opacity: 1;
  color: #c3ddfd;
  color: rgba(195, 221, 253, var(--placeholder-opacity));
}
.focus\\:placeholder-blue-300:focus::placeholder {
  --placeholder-opacity: 1;
  color: #a4cafe;
  color: rgba(164, 202, 254, var(--placeholder-opacity));
}
.focus\\:placeholder-blue-400:focus::placeholder {
  --placeholder-opacity: 1;
  color: #76a9fa;
  color: rgba(118, 169, 250, var(--placeholder-opacity));
}
.focus\\:placeholder-blue-500:focus::placeholder {
  --placeholder-opacity: 1;
  color: #3f83f8;
  color: rgba(63, 131, 248, var(--placeholder-opacity));
}
.focus\\:placeholder-blue-600:focus::placeholder {
  --placeholder-opacity: 1;
  color: #1c64f2;
  color: rgba(28, 100, 242, var(--placeholder-opacity));
}
.focus\\:placeholder-blue-700:focus::placeholder {
  --placeholder-opacity: 1;
  color: #1a56db;
  color: rgba(26, 86, 219, var(--placeholder-opacity));
}
.focus\\:placeholder-blue-800:focus::placeholder {
  --placeholder-opacity: 1;
  color: #1e429f;
  color: rgba(30, 66, 159, var(--placeholder-opacity));
}
.focus\\:placeholder-blue-900:focus::placeholder {
  --placeholder-opacity: 1;
  color: #233876;
  color: rgba(35, 56, 118, var(--placeholder-opacity));
}
.focus\\:placeholder-indigo-50:focus::placeholder {
  --placeholder-opacity: 1;
  color: #f0f5ff;
  color: rgba(240, 245, 255, var(--placeholder-opacity));
}
.focus\\:placeholder-indigo-100:focus::placeholder {
  --placeholder-opacity: 1;
  color: #e5edff;
  color: rgba(229, 237, 255, var(--placeholder-opacity));
}
.focus\\:placeholder-indigo-200:focus::placeholder {
  --placeholder-opacity: 1;
  color: #cddbfe;
  color: rgba(205, 219, 254, var(--placeholder-opacity));
}
.focus\\:placeholder-indigo-300:focus::placeholder {
  --placeholder-opacity: 1;
  color: #b4c6fc;
  color: rgba(180, 198, 252, var(--placeholder-opacity));
}
.focus\\:placeholder-indigo-400:focus::placeholder {
  --placeholder-opacity: 1;
  color: #8da2fb;
  color: rgba(141, 162, 251, var(--placeholder-opacity));
}
.focus\\:placeholder-indigo-500:focus::placeholder {
  --placeholder-opacity: 1;
  color: #6875f5;
  color: rgba(104, 117, 245, var(--placeholder-opacity));
}
.focus\\:placeholder-indigo-600:focus::placeholder {
  --placeholder-opacity: 1;
  color: #5850ec;
  color: rgba(88, 80, 236, var(--placeholder-opacity));
}
.focus\\:placeholder-indigo-700:focus::placeholder {
  --placeholder-opacity: 1;
  color: #5145cd;
  color: rgba(81, 69, 205, var(--placeholder-opacity));
}
.focus\\:placeholder-indigo-800:focus::placeholder {
  --placeholder-opacity: 1;
  color: #42389d;
  color: rgba(66, 56, 157, var(--placeholder-opacity));
}
.focus\\:placeholder-indigo-900:focus::placeholder {
  --placeholder-opacity: 1;
  color: #362f78;
  color: rgba(54, 47, 120, var(--placeholder-opacity));
}
.focus\\:placeholder-purple-50:focus::placeholder {
  --placeholder-opacity: 1;
  color: #f6f5ff;
  color: rgba(246, 245, 255, var(--placeholder-opacity));
}
.focus\\:placeholder-purple-100:focus::placeholder {
  --placeholder-opacity: 1;
  color: #edebfe;
  color: rgba(237, 235, 254, var(--placeholder-opacity));
}
.focus\\:placeholder-purple-200:focus::placeholder {
  --placeholder-opacity: 1;
  color: #dcd7fe;
  color: rgba(220, 215, 254, var(--placeholder-opacity));
}
.focus\\:placeholder-purple-300:focus::placeholder {
  --placeholder-opacity: 1;
  color: #cabffd;
  color: rgba(202, 191, 253, var(--placeholder-opacity));
}
.focus\\:placeholder-purple-400:focus::placeholder {
  --placeholder-opacity: 1;
  color: #ac94fa;
  color: rgba(172, 148, 250, var(--placeholder-opacity));
}
.focus\\:placeholder-purple-500:focus::placeholder {
  --placeholder-opacity: 1;
  color: #9061f9;
  color: rgba(144, 97, 249, var(--placeholder-opacity));
}
.focus\\:placeholder-purple-600:focus::placeholder {
  --placeholder-opacity: 1;
  color: #7e3af2;
  color: rgba(126, 58, 242, var(--placeholder-opacity));
}
.focus\\:placeholder-purple-700:focus::placeholder {
  --placeholder-opacity: 1;
  color: #6c2bd9;
  color: rgba(108, 43, 217, var(--placeholder-opacity));
}
.focus\\:placeholder-purple-800:focus::placeholder {
  --placeholder-opacity: 1;
  color: #5521b5;
  color: rgba(85, 33, 181, var(--placeholder-opacity));
}
.focus\\:placeholder-purple-900:focus::placeholder {
  --placeholder-opacity: 1;
  color: #4a1d96;
  color: rgba(74, 29, 150, var(--placeholder-opacity));
}
.focus\\:placeholder-pink-50:focus::placeholder {
  --placeholder-opacity: 1;
  color: #fdf2f8;
  color: rgba(253, 242, 248, var(--placeholder-opacity));
}
.focus\\:placeholder-pink-100:focus::placeholder {
  --placeholder-opacity: 1;
  color: #fce8f3;
  color: rgba(252, 232, 243, var(--placeholder-opacity));
}
.focus\\:placeholder-pink-200:focus::placeholder {
  --placeholder-opacity: 1;
  color: #fad1e8;
  color: rgba(250, 209, 232, var(--placeholder-opacity));
}
.focus\\:placeholder-pink-300:focus::placeholder {
  --placeholder-opacity: 1;
  color: #f8b4d9;
  color: rgba(248, 180, 217, var(--placeholder-opacity));
}
.focus\\:placeholder-pink-400:focus::placeholder {
  --placeholder-opacity: 1;
  color: #f17eb8;
  color: rgba(241, 126, 184, var(--placeholder-opacity));
}
.focus\\:placeholder-pink-500:focus::placeholder {
  --placeholder-opacity: 1;
  color: #e74694;
  color: rgba(231, 70, 148, var(--placeholder-opacity));
}
.focus\\:placeholder-pink-600:focus::placeholder {
  --placeholder-opacity: 1;
  color: #d61f69;
  color: rgba(214, 31, 105, var(--placeholder-opacity));
}
.focus\\:placeholder-pink-700:focus::placeholder {
  --placeholder-opacity: 1;
  color: #bf125d;
  color: rgba(191, 18, 93, var(--placeholder-opacity));
}
.focus\\:placeholder-pink-800:focus::placeholder {
  --placeholder-opacity: 1;
  color: #99154b;
  color: rgba(153, 21, 75, var(--placeholder-opacity));
}
.focus\\:placeholder-pink-900:focus::placeholder {
  --placeholder-opacity: 1;
  color: #751a3d;
  color: rgba(117, 26, 61, var(--placeholder-opacity));
}
.focus\\:placeholder-cool-gray-50:focus::placeholder {
  --placeholder-opacity: 1;
  color: #f8fafc;
  color: rgba(248, 250, 252, var(--placeholder-opacity));
}
.focus\\:placeholder-cool-gray-100:focus::placeholder {
  --placeholder-opacity: 1;
  color: #f1f5f9;
  color: rgba(241, 245, 249, var(--placeholder-opacity));
}
.focus\\:placeholder-cool-gray-200:focus::placeholder {
  --placeholder-opacity: 1;
  color: #e2e8f0;
  color: rgba(226, 232, 240, var(--placeholder-opacity));
}
.focus\\:placeholder-cool-gray-300:focus::placeholder {
  --placeholder-opacity: 1;
  color: #cfd8e3;
  color: rgba(207, 216, 227, var(--placeholder-opacity));
}
.focus\\:placeholder-cool-gray-400:focus::placeholder {
  --placeholder-opacity: 1;
  color: #97a6ba;
  color: rgba(151, 166, 186, var(--placeholder-opacity));
}
.focus\\:placeholder-cool-gray-500:focus::placeholder {
  --placeholder-opacity: 1;
  color: #64748b;
  color: rgba(100, 116, 139, var(--placeholder-opacity));
}
.focus\\:placeholder-cool-gray-600:focus::placeholder {
  --placeholder-opacity: 1;
  color: #475569;
  color: rgba(71, 85, 105, var(--placeholder-opacity));
}
.focus\\:placeholder-cool-gray-700:focus::placeholder {
  --placeholder-opacity: 1;
  color: #364152;
  color: rgba(54, 65, 82, var(--placeholder-opacity));
}
.focus\\:placeholder-cool-gray-800:focus::placeholder {
  --placeholder-opacity: 1;
  color: #27303f;
  color: rgba(39, 48, 63, var(--placeholder-opacity));
}
.focus\\:placeholder-cool-gray-900:focus::placeholder {
  --placeholder-opacity: 1;
  color: #1a202e;
  color: rgba(26, 32, 46, var(--placeholder-opacity));
}
.placeholder-opacity-0::placeholder {
  --placeholder-opacity: 0;
}
.placeholder-opacity-25::placeholder {
  --placeholder-opacity: 0.25;
}
.placeholder-opacity-50::placeholder {
  --placeholder-opacity: 0.5;
}
.placeholder-opacity-75::placeholder {
  --placeholder-opacity: 0.75;
}
.placeholder-opacity-100::placeholder {
  --placeholder-opacity: 1;
}
.focus\\:placeholder-opacity-0:focus::placeholder {
  --placeholder-opacity: 0;
}
.focus\\:placeholder-opacity-25:focus::placeholder {
  --placeholder-opacity: 0.25;
}
.focus\\:placeholder-opacity-50:focus::placeholder {
  --placeholder-opacity: 0.5;
}
.focus\\:placeholder-opacity-75:focus::placeholder {
  --placeholder-opacity: 0.75;
}
.focus\\:placeholder-opacity-100:focus::placeholder {
  --placeholder-opacity: 1;
}
.pointer-events-none {
  pointer-events: none;
}
.pointer-events-auto {
  pointer-events: auto;
}
.static {
  position: static;
}
.fixed {
  position: fixed;
}
.absolute {
  position: absolute;
}
.relative {
  position: relative;
}
.sticky {
  position: sticky;
}
.inset-0 {
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}
.inset-1 {
  top: 0.25rem;
  right: 0.25rem;
  bottom: 0.25rem;
  left: 0.25rem;
}
.inset-2 {
  top: 0.5rem;
  right: 0.5rem;
  bottom: 0.5rem;
  left: 0.5rem;
}
.inset-3 {
  top: 0.75rem;
  right: 0.75rem;
  bottom: 0.75rem;
  left: 0.75rem;
}
.inset-4 {
  top: 1rem;
  right: 1rem;
  bottom: 1rem;
  left: 1rem;
}
.inset-5 {
  top: 1.25rem;
  right: 1.25rem;
  bottom: 1.25rem;
  left: 1.25rem;
}
.inset-6 {
  top: 1.5rem;
  right: 1.5rem;
  bottom: 1.5rem;
  left: 1.5rem;
}
.inset-7 {
  top: 1.75rem;
  right: 1.75rem;
  bottom: 1.75rem;
  left: 1.75rem;
}
.inset-8 {
  top: 2rem;
  right: 2rem;
  bottom: 2rem;
  left: 2rem;
}
.inset-9 {
  top: 2.25rem;
  right: 2.25rem;
  bottom: 2.25rem;
  left: 2.25rem;
}
.inset-10 {
  top: 2.5rem;
  right: 2.5rem;
  bottom: 2.5rem;
  left: 2.5rem;
}
.inset-11 {
  top: 2.75rem;
  right: 2.75rem;
  bottom: 2.75rem;
  left: 2.75rem;
}
.inset-12 {
  top: 3rem;
  right: 3rem;
  bottom: 3rem;
  left: 3rem;
}
.inset-13 {
  top: 3.25rem;
  right: 3.25rem;
  bottom: 3.25rem;
  left: 3.25rem;
}
.inset-14 {
  top: 3.5rem;
  right: 3.5rem;
  bottom: 3.5rem;
  left: 3.5rem;
}
.inset-15 {
  top: 3.75rem;
  right: 3.75rem;
  bottom: 3.75rem;
  left: 3.75rem;
}
.inset-16 {
  top: 4rem;
  right: 4rem;
  bottom: 4rem;
  left: 4rem;
}
.inset-20 {
  top: 5rem;
  right: 5rem;
  bottom: 5rem;
  left: 5rem;
}
.inset-24 {
  top: 6rem;
  right: 6rem;
  bottom: 6rem;
  left: 6rem;
}
.inset-28 {
  top: 7rem;
  right: 7rem;
  bottom: 7rem;
  left: 7rem;
}
.inset-32 {
  top: 8rem;
  right: 8rem;
  bottom: 8rem;
  left: 8rem;
}
.inset-36 {
  top: 9rem;
  right: 9rem;
  bottom: 9rem;
  left: 9rem;
}
.inset-40 {
  top: 10rem;
  right: 10rem;
  bottom: 10rem;
  left: 10rem;
}
.inset-44 {
  top: 11rem;
  right: 11rem;
  bottom: 11rem;
  left: 11rem;
}
.inset-48 {
  top: 12rem;
  right: 12rem;
  bottom: 12rem;
  left: 12rem;
}
.inset-52 {
  top: 13rem;
  right: 13rem;
  bottom: 13rem;
  left: 13rem;
}
.inset-56 {
  top: 14rem;
  right: 14rem;
  bottom: 14rem;
  left: 14rem;
}
.inset-60 {
  top: 15rem;
  right: 15rem;
  bottom: 15rem;
  left: 15rem;
}
.inset-64 {
  top: 16rem;
  right: 16rem;
  bottom: 16rem;
  left: 16rem;
}
.inset-72 {
  top: 18rem;
  right: 18rem;
  bottom: 18rem;
  left: 18rem;
}
.inset-80 {
  top: 20rem;
  right: 20rem;
  bottom: 20rem;
  left: 20rem;
}
.inset-96 {
  top: 24rem;
  right: 24rem;
  bottom: 24rem;
  left: 24rem;
}
.inset-auto {
  top: auto;
  right: auto;
  bottom: auto;
  left: auto;
}
.inset-px {
  top: 1px;
  right: 1px;
  bottom: 1px;
  left: 1px;
}
.inset-0\\.5 {
  top: 0.125rem;
  right: 0.125rem;
  bottom: 0.125rem;
  left: 0.125rem;
}
.inset-1\\.5 {
  top: 0.375rem;
  right: 0.375rem;
  bottom: 0.375rem;
  left: 0.375rem;
}
.inset-2\\.5 {
  top: 0.625rem;
  right: 0.625rem;
  bottom: 0.625rem;
  left: 0.625rem;
}
.inset-3\\.5 {
  top: 0.875rem;
  right: 0.875rem;
  bottom: 0.875rem;
  left: 0.875rem;
}
.inset-1\\/2 {
  top: 50%;
  right: 50%;
  bottom: 50%;
  left: 50%;
}
.inset-1\\/3 {
  top: 33.333333%;
  right: 33.333333%;
  bottom: 33.333333%;
  left: 33.333333%;
}
.inset-2\\/3 {
  top: 66.666667%;
  right: 66.666667%;
  bottom: 66.666667%;
  left: 66.666667%;
}
.inset-1\\/4 {
  top: 25%;
  right: 25%;
  bottom: 25%;
  left: 25%;
}
.inset-2\\/4 {
  top: 50%;
  right: 50%;
  bottom: 50%;
  left: 50%;
}
.inset-3\\/4 {
  top: 75%;
  right: 75%;
  bottom: 75%;
  left: 75%;
}
.inset-1\\/5 {
  top: 20%;
  right: 20%;
  bottom: 20%;
  left: 20%;
}
.inset-2\\/5 {
  top: 40%;
  right: 40%;
  bottom: 40%;
  left: 40%;
}
.inset-3\\/5 {
  top: 60%;
  right: 60%;
  bottom: 60%;
  left: 60%;
}
.inset-4\\/5 {
  top: 80%;
  right: 80%;
  bottom: 80%;
  left: 80%;
}
.inset-1\\/6 {
  top: 16.666667%;
  right: 16.666667%;
  bottom: 16.666667%;
  left: 16.666667%;
}
.inset-2\\/6 {
  top: 33.333333%;
  right: 33.333333%;
  bottom: 33.333333%;
  left: 33.333333%;
}
.inset-3\\/6 {
  top: 50%;
  right: 50%;
  bottom: 50%;
  left: 50%;
}
.inset-4\\/6 {
  top: 66.666667%;
  right: 66.666667%;
  bottom: 66.666667%;
  left: 66.666667%;
}
.inset-5\\/6 {
  top: 83.333333%;
  right: 83.333333%;
  bottom: 83.333333%;
  left: 83.333333%;
}
.inset-1\\/12 {
  top: 8.333333%;
  right: 8.333333%;
  bottom: 8.333333%;
  left: 8.333333%;
}
.inset-2\\/12 {
  top: 16.666667%;
  right: 16.666667%;
  bottom: 16.666667%;
  left: 16.666667%;
}
.inset-3\\/12 {
  top: 25%;
  right: 25%;
  bottom: 25%;
  left: 25%;
}
.inset-4\\/12 {
  top: 33.333333%;
  right: 33.333333%;
  bottom: 33.333333%;
  left: 33.333333%;
}
.inset-5\\/12 {
  top: 41.666667%;
  right: 41.666667%;
  bottom: 41.666667%;
  left: 41.666667%;
}
.inset-6\\/12 {
  top: 50%;
  right: 50%;
  bottom: 50%;
  left: 50%;
}
.inset-7\\/12 {
  top: 58.333333%;
  right: 58.333333%;
  bottom: 58.333333%;
  left: 58.333333%;
}
.inset-8\\/12 {
  top: 66.666667%;
  right: 66.666667%;
  bottom: 66.666667%;
  left: 66.666667%;
}
.inset-9\\/12 {
  top: 75%;
  right: 75%;
  bottom: 75%;
  left: 75%;
}
.inset-10\\/12 {
  top: 83.333333%;
  right: 83.333333%;
  bottom: 83.333333%;
  left: 83.333333%;
}
.inset-11\\/12 {
  top: 91.666667%;
  right: 91.666667%;
  bottom: 91.666667%;
  left: 91.666667%;
}
.inset-full {
  top: 100%;
  right: 100%;
  bottom: 100%;
  left: 100%;
}
.inset-y-0 {
  top: 0;
  bottom: 0;
}
.inset-x-0 {
  right: 0;
  left: 0;
}
.inset-y-1 {
  top: 0.25rem;
  bottom: 0.25rem;
}
.inset-x-1 {
  right: 0.25rem;
  left: 0.25rem;
}
.inset-y-2 {
  top: 0.5rem;
  bottom: 0.5rem;
}
.inset-x-2 {
  right: 0.5rem;
  left: 0.5rem;
}
.inset-y-3 {
  top: 0.75rem;
  bottom: 0.75rem;
}
.inset-x-3 {
  right: 0.75rem;
  left: 0.75rem;
}
.inset-y-4 {
  top: 1rem;
  bottom: 1rem;
}
.inset-x-4 {
  right: 1rem;
  left: 1rem;
}
.inset-y-5 {
  top: 1.25rem;
  bottom: 1.25rem;
}
.inset-x-5 {
  right: 1.25rem;
  left: 1.25rem;
}
.inset-y-6 {
  top: 1.5rem;
  bottom: 1.5rem;
}
.inset-x-6 {
  right: 1.5rem;
  left: 1.5rem;
}
.inset-y-7 {
  top: 1.75rem;
  bottom: 1.75rem;
}
.inset-x-7 {
  right: 1.75rem;
  left: 1.75rem;
}
.inset-y-8 {
  top: 2rem;
  bottom: 2rem;
}
.inset-x-8 {
  right: 2rem;
  left: 2rem;
}
.inset-y-9 {
  top: 2.25rem;
  bottom: 2.25rem;
}
.inset-x-9 {
  right: 2.25rem;
  left: 2.25rem;
}
.inset-y-10 {
  top: 2.5rem;
  bottom: 2.5rem;
}
.inset-x-10 {
  right: 2.5rem;
  left: 2.5rem;
}
.inset-y-11 {
  top: 2.75rem;
  bottom: 2.75rem;
}
.inset-x-11 {
  right: 2.75rem;
  left: 2.75rem;
}
.inset-y-12 {
  top: 3rem;
  bottom: 3rem;
}
.inset-x-12 {
  right: 3rem;
  left: 3rem;
}
.inset-y-13 {
  top: 3.25rem;
  bottom: 3.25rem;
}
.inset-x-13 {
  right: 3.25rem;
  left: 3.25rem;
}
.inset-y-14 {
  top: 3.5rem;
  bottom: 3.5rem;
}
.inset-x-14 {
  right: 3.5rem;
  left: 3.5rem;
}
.inset-y-15 {
  top: 3.75rem;
  bottom: 3.75rem;
}
.inset-x-15 {
  right: 3.75rem;
  left: 3.75rem;
}
.inset-y-16 {
  top: 4rem;
  bottom: 4rem;
}
.inset-x-16 {
  right: 4rem;
  left: 4rem;
}
.inset-y-20 {
  top: 5rem;
  bottom: 5rem;
}
.inset-x-20 {
  right: 5rem;
  left: 5rem;
}
.inset-y-24 {
  top: 6rem;
  bottom: 6rem;
}
.inset-x-24 {
  right: 6rem;
  left: 6rem;
}
.inset-y-28 {
  top: 7rem;
  bottom: 7rem;
}
.inset-x-28 {
  right: 7rem;
  left: 7rem;
}
.inset-y-32 {
  top: 8rem;
  bottom: 8rem;
}
.inset-x-32 {
  right: 8rem;
  left: 8rem;
}
.inset-y-36 {
  top: 9rem;
  bottom: 9rem;
}
.inset-x-36 {
  right: 9rem;
  left: 9rem;
}
.inset-y-40 {
  top: 10rem;
  bottom: 10rem;
}
.inset-x-40 {
  right: 10rem;
  left: 10rem;
}
.inset-y-44 {
  top: 11rem;
  bottom: 11rem;
}
.inset-x-44 {
  right: 11rem;
  left: 11rem;
}
.inset-y-48 {
  top: 12rem;
  bottom: 12rem;
}
.inset-x-48 {
  right: 12rem;
  left: 12rem;
}
.inset-y-52 {
  top: 13rem;
  bottom: 13rem;
}
.inset-x-52 {
  right: 13rem;
  left: 13rem;
}
.inset-y-56 {
  top: 14rem;
  bottom: 14rem;
}
.inset-x-56 {
  right: 14rem;
  left: 14rem;
}
.inset-y-60 {
  top: 15rem;
  bottom: 15rem;
}
.inset-x-60 {
  right: 15rem;
  left: 15rem;
}
.inset-y-64 {
  top: 16rem;
  bottom: 16rem;
}
.inset-x-64 {
  right: 16rem;
  left: 16rem;
}
.inset-y-72 {
  top: 18rem;
  bottom: 18rem;
}
.inset-x-72 {
  right: 18rem;
  left: 18rem;
}
.inset-y-80 {
  top: 20rem;
  bottom: 20rem;
}
.inset-x-80 {
  right: 20rem;
  left: 20rem;
}
.inset-y-96 {
  top: 24rem;
  bottom: 24rem;
}
.inset-x-96 {
  right: 24rem;
  left: 24rem;
}
.inset-y-auto {
  top: auto;
  bottom: auto;
}
.inset-x-auto {
  right: auto;
  left: auto;
}
.inset-y-px {
  top: 1px;
  bottom: 1px;
}
.inset-x-px {
  right: 1px;
  left: 1px;
}
.inset-y-0\\.5 {
  top: 0.125rem;
  bottom: 0.125rem;
}
.inset-x-0\\.5 {
  right: 0.125rem;
  left: 0.125rem;
}
.inset-y-1\\.5 {
  top: 0.375rem;
  bottom: 0.375rem;
}
.inset-x-1\\.5 {
  right: 0.375rem;
  left: 0.375rem;
}
.inset-y-2\\.5 {
  top: 0.625rem;
  bottom: 0.625rem;
}
.inset-x-2\\.5 {
  right: 0.625rem;
  left: 0.625rem;
}
.inset-y-3\\.5 {
  top: 0.875rem;
  bottom: 0.875rem;
}
.inset-x-3\\.5 {
  right: 0.875rem;
  left: 0.875rem;
}
.inset-y-1\\/2 {
  top: 50%;
  bottom: 50%;
}
.inset-x-1\\/2 {
  right: 50%;
  left: 50%;
}
.inset-y-1\\/3 {
  top: 33.333333%;
  bottom: 33.333333%;
}
.inset-x-1\\/3 {
  right: 33.333333%;
  left: 33.333333%;
}
.inset-y-2\\/3 {
  top: 66.666667%;
  bottom: 66.666667%;
}
.inset-x-2\\/3 {
  right: 66.666667%;
  left: 66.666667%;
}
.inset-y-1\\/4 {
  top: 25%;
  bottom: 25%;
}
.inset-x-1\\/4 {
  right: 25%;
  left: 25%;
}
.inset-y-2\\/4 {
  top: 50%;
  bottom: 50%;
}
.inset-x-2\\/4 {
  right: 50%;
  left: 50%;
}
.inset-y-3\\/4 {
  top: 75%;
  bottom: 75%;
}
.inset-x-3\\/4 {
  right: 75%;
  left: 75%;
}
.inset-y-1\\/5 {
  top: 20%;
  bottom: 20%;
}
.inset-x-1\\/5 {
  right: 20%;
  left: 20%;
}
.inset-y-2\\/5 {
  top: 40%;
  bottom: 40%;
}
.inset-x-2\\/5 {
  right: 40%;
  left: 40%;
}
.inset-y-3\\/5 {
  top: 60%;
  bottom: 60%;
}
.inset-x-3\\/5 {
  right: 60%;
  left: 60%;
}
.inset-y-4\\/5 {
  top: 80%;
  bottom: 80%;
}
.inset-x-4\\/5 {
  right: 80%;
  left: 80%;
}
.inset-y-1\\/6 {
  top: 16.666667%;
  bottom: 16.666667%;
}
.inset-x-1\\/6 {
  right: 16.666667%;
  left: 16.666667%;
}
.inset-y-2\\/6 {
  top: 33.333333%;
  bottom: 33.333333%;
}
.inset-x-2\\/6 {
  right: 33.333333%;
  left: 33.333333%;
}
.inset-y-3\\/6 {
  top: 50%;
  bottom: 50%;
}
.inset-x-3\\/6 {
  right: 50%;
  left: 50%;
}
.inset-y-4\\/6 {
  top: 66.666667%;
  bottom: 66.666667%;
}
.inset-x-4\\/6 {
  right: 66.666667%;
  left: 66.666667%;
}
.inset-y-5\\/6 {
  top: 83.333333%;
  bottom: 83.333333%;
}
.inset-x-5\\/6 {
  right: 83.333333%;
  left: 83.333333%;
}
.inset-y-1\\/12 {
  top: 8.333333%;
  bottom: 8.333333%;
}
.inset-x-1\\/12 {
  right: 8.333333%;
  left: 8.333333%;
}
.inset-y-2\\/12 {
  top: 16.666667%;
  bottom: 16.666667%;
}
.inset-x-2\\/12 {
  right: 16.666667%;
  left: 16.666667%;
}
.inset-y-3\\/12 {
  top: 25%;
  bottom: 25%;
}
.inset-x-3\\/12 {
  right: 25%;
  left: 25%;
}
.inset-y-4\\/12 {
  top: 33.333333%;
  bottom: 33.333333%;
}
.inset-x-4\\/12 {
  right: 33.333333%;
  left: 33.333333%;
}
.inset-y-5\\/12 {
  top: 41.666667%;
  bottom: 41.666667%;
}
.inset-x-5\\/12 {
  right: 41.666667%;
  left: 41.666667%;
}
.inset-y-6\\/12 {
  top: 50%;
  bottom: 50%;
}
.inset-x-6\\/12 {
  right: 50%;
  left: 50%;
}
.inset-y-7\\/12 {
  top: 58.333333%;
  bottom: 58.333333%;
}
.inset-x-7\\/12 {
  right: 58.333333%;
  left: 58.333333%;
}
.inset-y-8\\/12 {
  top: 66.666667%;
  bottom: 66.666667%;
}
.inset-x-8\\/12 {
  right: 66.666667%;
  left: 66.666667%;
}
.inset-y-9\\/12 {
  top: 75%;
  bottom: 75%;
}
.inset-x-9\\/12 {
  right: 75%;
  left: 75%;
}
.inset-y-10\\/12 {
  top: 83.333333%;
  bottom: 83.333333%;
}
.inset-x-10\\/12 {
  right: 83.333333%;
  left: 83.333333%;
}
.inset-y-11\\/12 {
  top: 91.666667%;
  bottom: 91.666667%;
}
.inset-x-11\\/12 {
  right: 91.666667%;
  left: 91.666667%;
}
.inset-y-full {
  top: 100%;
  bottom: 100%;
}
.inset-x-full {
  right: 100%;
  left: 100%;
}
.top-0 {
  top: 0;
}
.right-0 {
  right: 0;
}
.bottom-0 {
  bottom: 0;
}
.left-0 {
  left: 0;
}
.top-1 {
  top: 0.25rem;
}
.right-1 {
  right: 0.25rem;
}
.bottom-1 {
  bottom: 0.25rem;
}
.left-1 {
  left: 0.25rem;
}
.top-2 {
  top: 0.5rem;
}
.right-2 {
  right: 0.5rem;
}
.bottom-2 {
  bottom: 0.5rem;
}
.left-2 {
  left: 0.5rem;
}
.top-3 {
  top: 0.75rem;
}
.right-3 {
  right: 0.75rem;
}
.bottom-3 {
  bottom: 0.75rem;
}
.left-3 {
  left: 0.75rem;
}
.top-4 {
  top: 1rem;
}
.right-4 {
  right: 1rem;
}
.bottom-4 {
  bottom: 1rem;
}
.left-4 {
  left: 1rem;
}
.top-5 {
  top: 1.25rem;
}
.right-5 {
  right: 1.25rem;
}
.bottom-5 {
  bottom: 1.25rem;
}
.left-5 {
  left: 1.25rem;
}
.top-6 {
  top: 1.5rem;
}
.right-6 {
  right: 1.5rem;
}
.bottom-6 {
  bottom: 1.5rem;
}
.left-6 {
  left: 1.5rem;
}
.top-7 {
  top: 1.75rem;
}
.right-7 {
  right: 1.75rem;
}
.bottom-7 {
  bottom: 1.75rem;
}
.left-7 {
  left: 1.75rem;
}
.top-8 {
  top: 2rem;
}
.right-8 {
  right: 2rem;
}
.bottom-8 {
  bottom: 2rem;
}
.left-8 {
  left: 2rem;
}
.top-9 {
  top: 2.25rem;
}
.right-9 {
  right: 2.25rem;
}
.bottom-9 {
  bottom: 2.25rem;
}
.left-9 {
  left: 2.25rem;
}
.top-10 {
  top: 2.5rem;
}
.right-10 {
  right: 2.5rem;
}
.bottom-10 {
  bottom: 2.5rem;
}
.left-10 {
  left: 2.5rem;
}
.top-11 {
  top: 2.75rem;
}
.right-11 {
  right: 2.75rem;
}
.bottom-11 {
  bottom: 2.75rem;
}
.left-11 {
  left: 2.75rem;
}
.top-12 {
  top: 3rem;
}
.right-12 {
  right: 3rem;
}
.bottom-12 {
  bottom: 3rem;
}
.left-12 {
  left: 3rem;
}
.top-13 {
  top: 3.25rem;
}
.right-13 {
  right: 3.25rem;
}
.bottom-13 {
  bottom: 3.25rem;
}
.left-13 {
  left: 3.25rem;
}
.top-14 {
  top: 3.5rem;
}
.right-14 {
  right: 3.5rem;
}
.bottom-14 {
  bottom: 3.5rem;
}
.left-14 {
  left: 3.5rem;
}
.top-15 {
  top: 3.75rem;
}
.right-15 {
  right: 3.75rem;
}
.bottom-15 {
  bottom: 3.75rem;
}
.left-15 {
  left: 3.75rem;
}
.top-16 {
  top: 4rem;
}
.right-16 {
  right: 4rem;
}
.bottom-16 {
  bottom: 4rem;
}
.left-16 {
  left: 4rem;
}
.top-20 {
  top: 5rem;
}
.right-20 {
  right: 5rem;
}
.bottom-20 {
  bottom: 5rem;
}
.left-20 {
  left: 5rem;
}
.top-24 {
  top: 6rem;
}
.right-24 {
  right: 6rem;
}
.bottom-24 {
  bottom: 6rem;
}
.left-24 {
  left: 6rem;
}
.top-28 {
  top: 7rem;
}
.right-28 {
  right: 7rem;
}
.bottom-28 {
  bottom: 7rem;
}
.left-28 {
  left: 7rem;
}
.top-32 {
  top: 8rem;
}
.right-32 {
  right: 8rem;
}
.bottom-32 {
  bottom: 8rem;
}
.left-32 {
  left: 8rem;
}
.top-36 {
  top: 9rem;
}
.right-36 {
  right: 9rem;
}
.bottom-36 {
  bottom: 9rem;
}
.left-36 {
  left: 9rem;
}
.top-40 {
  top: 10rem;
}
.right-40 {
  right: 10rem;
}
.bottom-40 {
  bottom: 10rem;
}
.left-40 {
  left: 10rem;
}
.top-44 {
  top: 11rem;
}
.right-44 {
  right: 11rem;
}
.bottom-44 {
  bottom: 11rem;
}
.left-44 {
  left: 11rem;
}
.top-48 {
  top: 12rem;
}
.right-48 {
  right: 12rem;
}
.bottom-48 {
  bottom: 12rem;
}
.left-48 {
  left: 12rem;
}
.top-52 {
  top: 13rem;
}
.right-52 {
  right: 13rem;
}
.bottom-52 {
  bottom: 13rem;
}
.left-52 {
  left: 13rem;
}
.top-56 {
  top: 14rem;
}
.right-56 {
  right: 14rem;
}
.bottom-56 {
  bottom: 14rem;
}
.left-56 {
  left: 14rem;
}
.top-60 {
  top: 15rem;
}
.right-60 {
  right: 15rem;
}
.bottom-60 {
  bottom: 15rem;
}
.left-60 {
  left: 15rem;
}
.top-64 {
  top: 16rem;
}
.right-64 {
  right: 16rem;
}
.bottom-64 {
  bottom: 16rem;
}
.left-64 {
  left: 16rem;
}
.top-72 {
  top: 18rem;
}
.right-72 {
  right: 18rem;
}
.bottom-72 {
  bottom: 18rem;
}
.left-72 {
  left: 18rem;
}
.top-80 {
  top: 20rem;
}
.right-80 {
  right: 20rem;
}
.bottom-80 {
  bottom: 20rem;
}
.left-80 {
  left: 20rem;
}
.top-96 {
  top: 24rem;
}
.right-96 {
  right: 24rem;
}
.bottom-96 {
  bottom: 24rem;
}
.left-96 {
  left: 24rem;
}
.top-auto {
  top: auto;
}
.right-auto {
  right: auto;
}
.bottom-auto {
  bottom: auto;
}
.left-auto {
  left: auto;
}
.top-px {
  top: 1px;
}
.right-px {
  right: 1px;
}
.bottom-px {
  bottom: 1px;
}
.left-px {
  left: 1px;
}
.top-0\\.5 {
  top: 0.125rem;
}
.right-0\\.5 {
  right: 0.125rem;
}
.bottom-0\\.5 {
  bottom: 0.125rem;
}
.left-0\\.5 {
  left: 0.125rem;
}
.top-1\\.5 {
  top: 0.375rem;
}
.right-1\\.5 {
  right: 0.375rem;
}
.bottom-1\\.5 {
  bottom: 0.375rem;
}
.left-1\\.5 {
  left: 0.375rem;
}
.top-2\\.5 {
  top: 0.625rem;
}
.right-2\\.5 {
  right: 0.625rem;
}
.bottom-2\\.5 {
  bottom: 0.625rem;
}
.left-2\\.5 {
  left: 0.625rem;
}
.top-3\\.5 {
  top: 0.875rem;
}
.right-3\\.5 {
  right: 0.875rem;
}
.bottom-3\\.5 {
  bottom: 0.875rem;
}
.left-3\\.5 {
  left: 0.875rem;
}
.top-1\\/2 {
  top: 50%;
}
.right-1\\/2 {
  right: 50%;
}
.bottom-1\\/2 {
  bottom: 50%;
}
.left-1\\/2 {
  left: 50%;
}
.top-1\\/3 {
  top: 33.333333%;
}
.right-1\\/3 {
  right: 33.333333%;
}
.bottom-1\\/3 {
  bottom: 33.333333%;
}
.left-1\\/3 {
  left: 33.333333%;
}
.top-2\\/3 {
  top: 66.666667%;
}
.right-2\\/3 {
  right: 66.666667%;
}
.bottom-2\\/3 {
  bottom: 66.666667%;
}
.left-2\\/3 {
  left: 66.666667%;
}
.top-1\\/4 {
  top: 25%;
}
.right-1\\/4 {
  right: 25%;
}
.bottom-1\\/4 {
  bottom: 25%;
}
.left-1\\/4 {
  left: 25%;
}
.top-2\\/4 {
  top: 50%;
}
.right-2\\/4 {
  right: 50%;
}
.bottom-2\\/4 {
  bottom: 50%;
}
.left-2\\/4 {
  left: 50%;
}
.top-3\\/4 {
  top: 75%;
}
.right-3\\/4 {
  right: 75%;
}
.bottom-3\\/4 {
  bottom: 75%;
}
.left-3\\/4 {
  left: 75%;
}
.top-1\\/5 {
  top: 20%;
}
.right-1\\/5 {
  right: 20%;
}
.bottom-1\\/5 {
  bottom: 20%;
}
.left-1\\/5 {
  left: 20%;
}
.top-2\\/5 {
  top: 40%;
}
.right-2\\/5 {
  right: 40%;
}
.bottom-2\\/5 {
  bottom: 40%;
}
.left-2\\/5 {
  left: 40%;
}
.top-3\\/5 {
  top: 60%;
}
.right-3\\/5 {
  right: 60%;
}
.bottom-3\\/5 {
  bottom: 60%;
}
.left-3\\/5 {
  left: 60%;
}
.top-4\\/5 {
  top: 80%;
}
.right-4\\/5 {
  right: 80%;
}
.bottom-4\\/5 {
  bottom: 80%;
}
.left-4\\/5 {
  left: 80%;
}
.top-1\\/6 {
  top: 16.666667%;
}
.right-1\\/6 {
  right: 16.666667%;
}
.bottom-1\\/6 {
  bottom: 16.666667%;
}
.left-1\\/6 {
  left: 16.666667%;
}
.top-2\\/6 {
  top: 33.333333%;
}
.right-2\\/6 {
  right: 33.333333%;
}
.bottom-2\\/6 {
  bottom: 33.333333%;
}
.left-2\\/6 {
  left: 33.333333%;
}
.top-3\\/6 {
  top: 50%;
}
.right-3\\/6 {
  right: 50%;
}
.bottom-3\\/6 {
  bottom: 50%;
}
.left-3\\/6 {
  left: 50%;
}
.top-4\\/6 {
  top: 66.666667%;
}
.right-4\\/6 {
  right: 66.666667%;
}
.bottom-4\\/6 {
  bottom: 66.666667%;
}
.left-4\\/6 {
  left: 66.666667%;
}
.top-5\\/6 {
  top: 83.333333%;
}
.right-5\\/6 {
  right: 83.333333%;
}
.bottom-5\\/6 {
  bottom: 83.333333%;
}
.left-5\\/6 {
  left: 83.333333%;
}
.top-1\\/12 {
  top: 8.333333%;
}
.right-1\\/12 {
  right: 8.333333%;
}
.bottom-1\\/12 {
  bottom: 8.333333%;
}
.left-1\\/12 {
  left: 8.333333%;
}
.top-2\\/12 {
  top: 16.666667%;
}
.right-2\\/12 {
  right: 16.666667%;
}
.bottom-2\\/12 {
  bottom: 16.666667%;
}
.left-2\\/12 {
  left: 16.666667%;
}
.top-3\\/12 {
  top: 25%;
}
.right-3\\/12 {
  right: 25%;
}
.bottom-3\\/12 {
  bottom: 25%;
}
.left-3\\/12 {
  left: 25%;
}
.top-4\\/12 {
  top: 33.333333%;
}
.right-4\\/12 {
  right: 33.333333%;
}
.bottom-4\\/12 {
  bottom: 33.333333%;
}
.left-4\\/12 {
  left: 33.333333%;
}
.top-5\\/12 {
  top: 41.666667%;
}
.right-5\\/12 {
  right: 41.666667%;
}
.bottom-5\\/12 {
  bottom: 41.666667%;
}
.left-5\\/12 {
  left: 41.666667%;
}
.top-6\\/12 {
  top: 50%;
}
.right-6\\/12 {
  right: 50%;
}
.bottom-6\\/12 {
  bottom: 50%;
}
.left-6\\/12 {
  left: 50%;
}
.top-7\\/12 {
  top: 58.333333%;
}
.right-7\\/12 {
  right: 58.333333%;
}
.bottom-7\\/12 {
  bottom: 58.333333%;
}
.left-7\\/12 {
  left: 58.333333%;
}
.top-8\\/12 {
  top: 66.666667%;
}
.right-8\\/12 {
  right: 66.666667%;
}
.bottom-8\\/12 {
  bottom: 66.666667%;
}
.left-8\\/12 {
  left: 66.666667%;
}
.top-9\\/12 {
  top: 75%;
}
.right-9\\/12 {
  right: 75%;
}
.bottom-9\\/12 {
  bottom: 75%;
}
.left-9\\/12 {
  left: 75%;
}
.top-10\\/12 {
  top: 83.333333%;
}
.right-10\\/12 {
  right: 83.333333%;
}
.bottom-10\\/12 {
  bottom: 83.333333%;
}
.left-10\\/12 {
  left: 83.333333%;
}
.top-11\\/12 {
  top: 91.666667%;
}
.right-11\\/12 {
  right: 91.666667%;
}
.bottom-11\\/12 {
  bottom: 91.666667%;
}
.left-11\\/12 {
  left: 91.666667%;
}
.top-full {
  top: 100%;
}
.right-full {
  right: 100%;
}
.bottom-full {
  bottom: 100%;
}
.left-full {
  left: 100%;
}
.resize-none {
  resize: none;
}
.resize-y {
  resize: vertical;
}
.resize-x {
  resize: horizontal;
}
.resize {
  resize: both;
}
.shadow-xs {
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.05);
}
.shadow-sm {
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
}
.shadow {
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
}
.shadow-md {
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
}
.shadow-lg {
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
}
.shadow-xl {
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
}
.shadow-2xl {
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
}
.shadow-inner {
  box-shadow: inset 0 2px 4px 0 rgba(0, 0, 0, 0.06);
}
.shadow-outline {
  box-shadow: 0 0 0 3px rgba(118, 169, 250, 0.45);
}
.shadow-none {
  box-shadow: none;
}
.shadow-solid {
  box-shadow: 0 0 0 2px currentColor;
}
.shadow-outline-gray {
  box-shadow: 0 0 0 3px rgba(159, 166, 178, 0.45);
}
.shadow-outline-blue {
  box-shadow: 0 0 0 3px rgba(164, 202, 254, 0.45);
}
.shadow-outline-teal {
  box-shadow: 0 0 0 3px rgba(126, 220, 226, 0.45);
}
.shadow-outline-green {
  box-shadow: 0 0 0 3px rgba(132, 225, 188, 0.45);
}
.shadow-outline-yellow {
  box-shadow: 0 0 0 3px rgba(250, 202, 21, 0.45);
}
.shadow-outline-orange {
  box-shadow: 0 0 0 3px rgba(253, 186, 140, 0.45);
}
.shadow-outline-red {
  box-shadow: 0 0 0 3px rgba(248, 180, 180, 0.45);
}
.shadow-outline-pink {
  box-shadow: 0 0 0 3px rgba(248, 180, 217, 0.45);
}
.shadow-outline-purple {
  box-shadow: 0 0 0 3px rgba(202, 191, 253, 0.45);
}
.shadow-outline-indigo {
  box-shadow: 0 0 0 3px rgba(180, 198, 252, 0.45);
}
.group:focus .group-focus\\:shadow-xs {
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.05);
}
.group:focus .group-focus\\:shadow-sm {
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
}
.group:focus .group-focus\\:shadow {
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
}
.group:focus .group-focus\\:shadow-md {
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
}
.group:focus .group-focus\\:shadow-lg {
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
}
.group:focus .group-focus\\:shadow-xl {
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
}
.group:focus .group-focus\\:shadow-2xl {
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
}
.group:focus .group-focus\\:shadow-inner {
  box-shadow: inset 0 2px 4px 0 rgba(0, 0, 0, 0.06);
}
.group:focus .group-focus\\:shadow-outline {
  box-shadow: 0 0 0 3px rgba(118, 169, 250, 0.45);
}
.group:focus .group-focus\\:shadow-none {
  box-shadow: none;
}
.group:focus .group-focus\\:shadow-solid {
  box-shadow: 0 0 0 2px currentColor;
}
.group:focus .group-focus\\:shadow-outline-gray {
  box-shadow: 0 0 0 3px rgba(159, 166, 178, 0.45);
}
.group:focus .group-focus\\:shadow-outline-blue {
  box-shadow: 0 0 0 3px rgba(164, 202, 254, 0.45);
}
.group:focus .group-focus\\:shadow-outline-teal {
  box-shadow: 0 0 0 3px rgba(126, 220, 226, 0.45);
}
.group:focus .group-focus\\:shadow-outline-green {
  box-shadow: 0 0 0 3px rgba(132, 225, 188, 0.45);
}
.group:focus .group-focus\\:shadow-outline-yellow {
  box-shadow: 0 0 0 3px rgba(250, 202, 21, 0.45);
}
.group:focus .group-focus\\:shadow-outline-orange {
  box-shadow: 0 0 0 3px rgba(253, 186, 140, 0.45);
}
.group:focus .group-focus\\:shadow-outline-red {
  box-shadow: 0 0 0 3px rgba(248, 180, 180, 0.45);
}
.group:focus .group-focus\\:shadow-outline-pink {
  box-shadow: 0 0 0 3px rgba(248, 180, 217, 0.45);
}
.group:focus .group-focus\\:shadow-outline-purple {
  box-shadow: 0 0 0 3px rgba(202, 191, 253, 0.45);
}
.group:focus .group-focus\\:shadow-outline-indigo {
  box-shadow: 0 0 0 3px rgba(180, 198, 252, 0.45);
}
.hover\\:shadow-xs:hover {
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.05);
}
.hover\\:shadow-sm:hover {
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
}
.hover\\:shadow:hover {
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
}
.hover\\:shadow-md:hover {
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
}
.hover\\:shadow-lg:hover {
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
}
.hover\\:shadow-xl:hover {
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
}
.hover\\:shadow-2xl:hover {
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
}
.hover\\:shadow-inner:hover {
  box-shadow: inset 0 2px 4px 0 rgba(0, 0, 0, 0.06);
}
.hover\\:shadow-outline:hover {
  box-shadow: 0 0 0 3px rgba(118, 169, 250, 0.45);
}
.hover\\:shadow-none:hover {
  box-shadow: none;
}
.hover\\:shadow-solid:hover {
  box-shadow: 0 0 0 2px currentColor;
}
.hover\\:shadow-outline-gray:hover {
  box-shadow: 0 0 0 3px rgba(159, 166, 178, 0.45);
}
.hover\\:shadow-outline-blue:hover {
  box-shadow: 0 0 0 3px rgba(164, 202, 254, 0.45);
}
.hover\\:shadow-outline-teal:hover {
  box-shadow: 0 0 0 3px rgba(126, 220, 226, 0.45);
}
.hover\\:shadow-outline-green:hover {
  box-shadow: 0 0 0 3px rgba(132, 225, 188, 0.45);
}
.hover\\:shadow-outline-yellow:hover {
  box-shadow: 0 0 0 3px rgba(250, 202, 21, 0.45);
}
.hover\\:shadow-outline-orange:hover {
  box-shadow: 0 0 0 3px rgba(253, 186, 140, 0.45);
}
.hover\\:shadow-outline-red:hover {
  box-shadow: 0 0 0 3px rgba(248, 180, 180, 0.45);
}
.hover\\:shadow-outline-pink:hover {
  box-shadow: 0 0 0 3px rgba(248, 180, 217, 0.45);
}
.hover\\:shadow-outline-purple:hover {
  box-shadow: 0 0 0 3px rgba(202, 191, 253, 0.45);
}
.hover\\:shadow-outline-indigo:hover {
  box-shadow: 0 0 0 3px rgba(180, 198, 252, 0.45);
}
.focus-within\\:shadow-xs:focus-within {
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.05);
}
.focus-within\\:shadow-sm:focus-within {
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
}
.focus-within\\:shadow:focus-within {
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
}
.focus-within\\:shadow-md:focus-within {
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
}
.focus-within\\:shadow-lg:focus-within {
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
}
.focus-within\\:shadow-xl:focus-within {
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
}
.focus-within\\:shadow-2xl:focus-within {
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
}
.focus-within\\:shadow-inner:focus-within {
  box-shadow: inset 0 2px 4px 0 rgba(0, 0, 0, 0.06);
}
.focus-within\\:shadow-outline:focus-within {
  box-shadow: 0 0 0 3px rgba(118, 169, 250, 0.45);
}
.focus-within\\:shadow-none:focus-within {
  box-shadow: none;
}
.focus-within\\:shadow-solid:focus-within {
  box-shadow: 0 0 0 2px currentColor;
}
.focus-within\\:shadow-outline-gray:focus-within {
  box-shadow: 0 0 0 3px rgba(159, 166, 178, 0.45);
}
.focus-within\\:shadow-outline-blue:focus-within {
  box-shadow: 0 0 0 3px rgba(164, 202, 254, 0.45);
}
.focus-within\\:shadow-outline-teal:focus-within {
  box-shadow: 0 0 0 3px rgba(126, 220, 226, 0.45);
}
.focus-within\\:shadow-outline-green:focus-within {
  box-shadow: 0 0 0 3px rgba(132, 225, 188, 0.45);
}
.focus-within\\:shadow-outline-yellow:focus-within {
  box-shadow: 0 0 0 3px rgba(250, 202, 21, 0.45);
}
.focus-within\\:shadow-outline-orange:focus-within {
  box-shadow: 0 0 0 3px rgba(253, 186, 140, 0.45);
}
.focus-within\\:shadow-outline-red:focus-within {
  box-shadow: 0 0 0 3px rgba(248, 180, 180, 0.45);
}
.focus-within\\:shadow-outline-pink:focus-within {
  box-shadow: 0 0 0 3px rgba(248, 180, 217, 0.45);
}
.focus-within\\:shadow-outline-purple:focus-within {
  box-shadow: 0 0 0 3px rgba(202, 191, 253, 0.45);
}
.focus-within\\:shadow-outline-indigo:focus-within {
  box-shadow: 0 0 0 3px rgba(180, 198, 252, 0.45);
}
.focus\\:shadow-xs:focus {
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.05);
}
.focus\\:shadow-sm:focus {
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
}
.focus\\:shadow:focus {
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
}
.focus\\:shadow-md:focus {
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
}
.focus\\:shadow-lg:focus {
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
}
.focus\\:shadow-xl:focus {
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
}
.focus\\:shadow-2xl:focus {
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
}
.focus\\:shadow-inner:focus {
  box-shadow: inset 0 2px 4px 0 rgba(0, 0, 0, 0.06);
}
.focus\\:shadow-outline:focus {
  box-shadow: 0 0 0 3px rgba(118, 169, 250, 0.45);
}
.focus\\:shadow-none:focus {
  box-shadow: none;
}
.focus\\:shadow-solid:focus {
  box-shadow: 0 0 0 2px currentColor;
}
.focus\\:shadow-outline-gray:focus {
  box-shadow: 0 0 0 3px rgba(159, 166, 178, 0.45);
}
.focus\\:shadow-outline-blue:focus {
  box-shadow: 0 0 0 3px rgba(164, 202, 254, 0.45);
}
.focus\\:shadow-outline-teal:focus {
  box-shadow: 0 0 0 3px rgba(126, 220, 226, 0.45);
}
.focus\\:shadow-outline-green:focus {
  box-shadow: 0 0 0 3px rgba(132, 225, 188, 0.45);
}
.focus\\:shadow-outline-yellow:focus {
  box-shadow: 0 0 0 3px rgba(250, 202, 21, 0.45);
}
.focus\\:shadow-outline-orange:focus {
  box-shadow: 0 0 0 3px rgba(253, 186, 140, 0.45);
}
.focus\\:shadow-outline-red:focus {
  box-shadow: 0 0 0 3px rgba(248, 180, 180, 0.45);
}
.focus\\:shadow-outline-pink:focus {
  box-shadow: 0 0 0 3px rgba(248, 180, 217, 0.45);
}
.focus\\:shadow-outline-purple:focus {
  box-shadow: 0 0 0 3px rgba(202, 191, 253, 0.45);
}
.focus\\:shadow-outline-indigo:focus {
  box-shadow: 0 0 0 3px rgba(180, 198, 252, 0.45);
}
.fill-current {
  fill: currentColor;
}
.stroke-current {
  stroke: currentColor;
}
.stroke-0 {
  stroke-width: 0;
}
.stroke-1 {
  stroke-width: 1;
}
.stroke-2 {
  stroke-width: 2;
}
.table-auto {
  table-layout: auto;
}
.table-fixed {
  table-layout: fixed;
}
.text-left {
  text-align: left;
}
.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}
.text-justify {
  text-align: justify;
}
.text-current {
  color: currentColor;
}
.text-transparent {
  color: transparent;
}
.text-white {
  --text-opacity: 1;
  color: #ffffff;
  color: rgba(255, 255, 255, var(--text-opacity));
}
.text-black {
  --text-opacity: 1;
  color: #000000;
  color: rgba(0, 0, 0, var(--text-opacity));
}
.text-gray-50 {
  --text-opacity: 1;
  color: #f9fafb;
  color: rgba(249, 250, 251, var(--text-opacity));
}
.text-gray-100 {
  --text-opacity: 1;
  color: #f4f5f7;
  color: rgba(244, 245, 247, var(--text-opacity));
}
.text-gray-200 {
  --text-opacity: 1;
  color: #e5e7eb;
  color: rgba(229, 231, 235, var(--text-opacity));
}
.text-gray-300 {
  --text-opacity: 1;
  color: #d2d6dc;
  color: rgba(210, 214, 220, var(--text-opacity));
}
.text-gray-400 {
  --text-opacity: 1;
  color: #9fa6b2;
  color: rgba(159, 166, 178, var(--text-opacity));
}
.text-gray-500 {
  --text-opacity: 1;
  color: #6b7280;
  color: rgba(107, 114, 128, var(--text-opacity));
}
.text-gray-600 {
  --text-opacity: 1;
  color: #4b5563;
  color: rgba(75, 85, 99, var(--text-opacity));
}
.text-gray-700 {
  --text-opacity: 1;
  color: #374151;
  color: rgba(55, 65, 81, var(--text-opacity));
}
.text-gray-800 {
  --text-opacity: 1;
  color: #252f3f;
  color: rgba(37, 47, 63, var(--text-opacity));
}
.text-gray-900 {
  --text-opacity: 1;
  color: #161e2e;
  color: rgba(22, 30, 46, var(--text-opacity));
}
.text-red-50 {
  --text-opacity: 1;
  color: #fdf2f2;
  color: rgba(253, 242, 242, var(--text-opacity));
}
.text-red-100 {
  --text-opacity: 1;
  color: #fde8e8;
  color: rgba(253, 232, 232, var(--text-opacity));
}
.text-red-200 {
  --text-opacity: 1;
  color: #fbd5d5;
  color: rgba(251, 213, 213, var(--text-opacity));
}
.text-red-300 {
  --text-opacity: 1;
  color: #f8b4b4;
  color: rgba(248, 180, 180, var(--text-opacity));
}
.text-red-400 {
  --text-opacity: 1;
  color: #f98080;
  color: rgba(249, 128, 128, var(--text-opacity));
}
.text-red-500 {
  --text-opacity: 1;
  color: #f05252;
  color: rgba(240, 82, 82, var(--text-opacity));
}
.text-red-600 {
  --text-opacity: 1;
  color: #e02424;
  color: rgba(224, 36, 36, var(--text-opacity));
}
.text-red-700 {
  --text-opacity: 1;
  color: #c81e1e;
  color: rgba(200, 30, 30, var(--text-opacity));
}
.text-red-800 {
  --text-opacity: 1;
  color: #9b1c1c;
  color: rgba(155, 28, 28, var(--text-opacity));
}
.text-red-900 {
  --text-opacity: 1;
  color: #771d1d;
  color: rgba(119, 29, 29, var(--text-opacity));
}
.text-orange-50 {
  --text-opacity: 1;
  color: #fff8f1;
  color: rgba(255, 248, 241, var(--text-opacity));
}
.text-orange-100 {
  --text-opacity: 1;
  color: #feecdc;
  color: rgba(254, 236, 220, var(--text-opacity));
}
.text-orange-200 {
  --text-opacity: 1;
  color: #fcd9bd;
  color: rgba(252, 217, 189, var(--text-opacity));
}
.text-orange-300 {
  --text-opacity: 1;
  color: #fdba8c;
  color: rgba(253, 186, 140, var(--text-opacity));
}
.text-orange-400 {
  --text-opacity: 1;
  color: #ff8a4c;
  color: rgba(255, 138, 76, var(--text-opacity));
}
.text-orange-500 {
  --text-opacity: 1;
  color: #ff5a1f;
  color: rgba(255, 90, 31, var(--text-opacity));
}
.text-orange-600 {
  --text-opacity: 1;
  color: #d03801;
  color: rgba(208, 56, 1, var(--text-opacity));
}
.text-orange-700 {
  --text-opacity: 1;
  color: #b43403;
  color: rgba(180, 52, 3, var(--text-opacity));
}
.text-orange-800 {
  --text-opacity: 1;
  color: #8a2c0d;
  color: rgba(138, 44, 13, var(--text-opacity));
}
.text-orange-900 {
  --text-opacity: 1;
  color: #73230d;
  color: rgba(115, 35, 13, var(--text-opacity));
}
.text-yellow-50 {
  --text-opacity: 1;
  color: #fdfdea;
  color: rgba(253, 253, 234, var(--text-opacity));
}
.text-yellow-100 {
  --text-opacity: 1;
  color: #fdf6b2;
  color: rgba(253, 246, 178, var(--text-opacity));
}
.text-yellow-200 {
  --text-opacity: 1;
  color: #fce96a;
  color: rgba(252, 233, 106, var(--text-opacity));
}
.text-yellow-300 {
  --text-opacity: 1;
  color: #faca15;
  color: rgba(250, 202, 21, var(--text-opacity));
}
.text-yellow-400 {
  --text-opacity: 1;
  color: #e3a008;
  color: rgba(227, 160, 8, var(--text-opacity));
}
.text-yellow-500 {
  --text-opacity: 1;
  color: #c27803;
  color: rgba(194, 120, 3, var(--text-opacity));
}
.text-yellow-600 {
  --text-opacity: 1;
  color: #9f580a;
  color: rgba(159, 88, 10, var(--text-opacity));
}
.text-yellow-700 {
  --text-opacity: 1;
  color: #8e4b10;
  color: rgba(142, 75, 16, var(--text-opacity));
}
.text-yellow-800 {
  --text-opacity: 1;
  color: #723b13;
  color: rgba(114, 59, 19, var(--text-opacity));
}
.text-yellow-900 {
  --text-opacity: 1;
  color: #633112;
  color: rgba(99, 49, 18, var(--text-opacity));
}
.text-green-50 {
  --text-opacity: 1;
  color: #f3faf7;
  color: rgba(243, 250, 247, var(--text-opacity));
}
.text-green-100 {
  --text-opacity: 1;
  color: #def7ec;
  color: rgba(222, 247, 236, var(--text-opacity));
}
.text-green-200 {
  --text-opacity: 1;
  color: #bcf0da;
  color: rgba(188, 240, 218, var(--text-opacity));
}
.text-green-300 {
  --text-opacity: 1;
  color: #84e1bc;
  color: rgba(132, 225, 188, var(--text-opacity));
}
.text-green-400 {
  --text-opacity: 1;
  color: #31c48d;
  color: rgba(49, 196, 141, var(--text-opacity));
}
.text-green-500 {
  --text-opacity: 1;
  color: #0e9f6e;
  color: rgba(14, 159, 110, var(--text-opacity));
}
.text-green-600 {
  --text-opacity: 1;
  color: #057a55;
  color: rgba(5, 122, 85, var(--text-opacity));
}
.text-green-700 {
  --text-opacity: 1;
  color: #046c4e;
  color: rgba(4, 108, 78, var(--text-opacity));
}
.text-green-800 {
  --text-opacity: 1;
  color: #03543f;
  color: rgba(3, 84, 63, var(--text-opacity));
}
.text-green-900 {
  --text-opacity: 1;
  color: #014737;
  color: rgba(1, 71, 55, var(--text-opacity));
}
.text-teal-50 {
  --text-opacity: 1;
  color: #edfafa;
  color: rgba(237, 250, 250, var(--text-opacity));
}
.text-teal-100 {
  --text-opacity: 1;
  color: #d5f5f6;
  color: rgba(213, 245, 246, var(--text-opacity));
}
.text-teal-200 {
  --text-opacity: 1;
  color: #afecef;
  color: rgba(175, 236, 239, var(--text-opacity));
}
.text-teal-300 {
  --text-opacity: 1;
  color: #7edce2;
  color: rgba(126, 220, 226, var(--text-opacity));
}
.text-teal-400 {
  --text-opacity: 1;
  color: #16bdca;
  color: rgba(22, 189, 202, var(--text-opacity));
}
.text-teal-500 {
  --text-opacity: 1;
  color: #0694a2;
  color: rgba(6, 148, 162, var(--text-opacity));
}
.text-teal-600 {
  --text-opacity: 1;
  color: #047481;
  color: rgba(4, 116, 129, var(--text-opacity));
}
.text-teal-700 {
  --text-opacity: 1;
  color: #036672;
  color: rgba(3, 102, 114, var(--text-opacity));
}
.text-teal-800 {
  --text-opacity: 1;
  color: #05505c;
  color: rgba(5, 80, 92, var(--text-opacity));
}
.text-teal-900 {
  --text-opacity: 1;
  color: #014451;
  color: rgba(1, 68, 81, var(--text-opacity));
}
.text-blue-50 {
  --text-opacity: 1;
  color: #ebf5ff;
  color: rgba(235, 245, 255, var(--text-opacity));
}
.text-blue-100 {
  --text-opacity: 1;
  color: #e1effe;
  color: rgba(225, 239, 254, var(--text-opacity));
}
.text-blue-200 {
  --text-opacity: 1;
  color: #c3ddfd;
  color: rgba(195, 221, 253, var(--text-opacity));
}
.text-blue-300 {
  --text-opacity: 1;
  color: #a4cafe;
  color: rgba(164, 202, 254, var(--text-opacity));
}
.text-blue-400 {
  --text-opacity: 1;
  color: #76a9fa;
  color: rgba(118, 169, 250, var(--text-opacity));
}
.text-blue-500 {
  --text-opacity: 1;
  color: #3f83f8;
  color: rgba(63, 131, 248, var(--text-opacity));
}
.text-blue-600 {
  --text-opacity: 1;
  color: #1c64f2;
  color: rgba(28, 100, 242, var(--text-opacity));
}
.text-blue-700 {
  --text-opacity: 1;
  color: #1a56db;
  color: rgba(26, 86, 219, var(--text-opacity));
}
.text-blue-800 {
  --text-opacity: 1;
  color: #1e429f;
  color: rgba(30, 66, 159, var(--text-opacity));
}
.text-blue-900 {
  --text-opacity: 1;
  color: #233876;
  color: rgba(35, 56, 118, var(--text-opacity));
}
.text-indigo-50 {
  --text-opacity: 1;
  color: #f0f5ff;
  color: rgba(240, 245, 255, var(--text-opacity));
}
.text-indigo-100 {
  --text-opacity: 1;
  color: #e5edff;
  color: rgba(229, 237, 255, var(--text-opacity));
}
.text-indigo-200 {
  --text-opacity: 1;
  color: #cddbfe;
  color: rgba(205, 219, 254, var(--text-opacity));
}
.text-indigo-300 {
  --text-opacity: 1;
  color: #b4c6fc;
  color: rgba(180, 198, 252, var(--text-opacity));
}
.text-indigo-400 {
  --text-opacity: 1;
  color: #8da2fb;
  color: rgba(141, 162, 251, var(--text-opacity));
}
.text-indigo-500 {
  --text-opacity: 1;
  color: #6875f5;
  color: rgba(104, 117, 245, var(--text-opacity));
}
.text-indigo-600 {
  --text-opacity: 1;
  color: #5850ec;
  color: rgba(88, 80, 236, var(--text-opacity));
}
.text-indigo-700 {
  --text-opacity: 1;
  color: #5145cd;
  color: rgba(81, 69, 205, var(--text-opacity));
}
.text-indigo-800 {
  --text-opacity: 1;
  color: #42389d;
  color: rgba(66, 56, 157, var(--text-opacity));
}
.text-indigo-900 {
  --text-opacity: 1;
  color: #362f78;
  color: rgba(54, 47, 120, var(--text-opacity));
}
.text-purple-50 {
  --text-opacity: 1;
  color: #f6f5ff;
  color: rgba(246, 245, 255, var(--text-opacity));
}
.text-purple-100 {
  --text-opacity: 1;
  color: #edebfe;
  color: rgba(237, 235, 254, var(--text-opacity));
}
.text-purple-200 {
  --text-opacity: 1;
  color: #dcd7fe;
  color: rgba(220, 215, 254, var(--text-opacity));
}
.text-purple-300 {
  --text-opacity: 1;
  color: #cabffd;
  color: rgba(202, 191, 253, var(--text-opacity));
}
.text-purple-400 {
  --text-opacity: 1;
  color: #ac94fa;
  color: rgba(172, 148, 250, var(--text-opacity));
}
.text-purple-500 {
  --text-opacity: 1;
  color: #9061f9;
  color: rgba(144, 97, 249, var(--text-opacity));
}
.text-purple-600 {
  --text-opacity: 1;
  color: #7e3af2;
  color: rgba(126, 58, 242, var(--text-opacity));
}
.text-purple-700 {
  --text-opacity: 1;
  color: #6c2bd9;
  color: rgba(108, 43, 217, var(--text-opacity));
}
.text-purple-800 {
  --text-opacity: 1;
  color: #5521b5;
  color: rgba(85, 33, 181, var(--text-opacity));
}
.text-purple-900 {
  --text-opacity: 1;
  color: #4a1d96;
  color: rgba(74, 29, 150, var(--text-opacity));
}
.text-pink-50 {
  --text-opacity: 1;
  color: #fdf2f8;
  color: rgba(253, 242, 248, var(--text-opacity));
}
.text-pink-100 {
  --text-opacity: 1;
  color: #fce8f3;
  color: rgba(252, 232, 243, var(--text-opacity));
}
.text-pink-200 {
  --text-opacity: 1;
  color: #fad1e8;
  color: rgba(250, 209, 232, var(--text-opacity));
}
.text-pink-300 {
  --text-opacity: 1;
  color: #f8b4d9;
  color: rgba(248, 180, 217, var(--text-opacity));
}
.text-pink-400 {
  --text-opacity: 1;
  color: #f17eb8;
  color: rgba(241, 126, 184, var(--text-opacity));
}
.text-pink-500 {
  --text-opacity: 1;
  color: #e74694;
  color: rgba(231, 70, 148, var(--text-opacity));
}
.text-pink-600 {
  --text-opacity: 1;
  color: #d61f69;
  color: rgba(214, 31, 105, var(--text-opacity));
}
.text-pink-700 {
  --text-opacity: 1;
  color: #bf125d;
  color: rgba(191, 18, 93, var(--text-opacity));
}
.text-pink-800 {
  --text-opacity: 1;
  color: #99154b;
  color: rgba(153, 21, 75, var(--text-opacity));
}
.text-pink-900 {
  --text-opacity: 1;
  color: #751a3d;
  color: rgba(117, 26, 61, var(--text-opacity));
}
.text-cool-gray-50 {
  --text-opacity: 1;
  color: #f8fafc;
  color: rgba(248, 250, 252, var(--text-opacity));
}
.text-cool-gray-100 {
  --text-opacity: 1;
  color: #f1f5f9;
  color: rgba(241, 245, 249, var(--text-opacity));
}
.text-cool-gray-200 {
  --text-opacity: 1;
  color: #e2e8f0;
  color: rgba(226, 232, 240, var(--text-opacity));
}
.text-cool-gray-300 {
  --text-opacity: 1;
  color: #cfd8e3;
  color: rgba(207, 216, 227, var(--text-opacity));
}
.text-cool-gray-400 {
  --text-opacity: 1;
  color: #97a6ba;
  color: rgba(151, 166, 186, var(--text-opacity));
}
.text-cool-gray-500 {
  --text-opacity: 1;
  color: #64748b;
  color: rgba(100, 116, 139, var(--text-opacity));
}
.text-cool-gray-600 {
  --text-opacity: 1;
  color: #475569;
  color: rgba(71, 85, 105, var(--text-opacity));
}
.text-cool-gray-700 {
  --text-opacity: 1;
  color: #364152;
  color: rgba(54, 65, 82, var(--text-opacity));
}
.text-cool-gray-800 {
  --text-opacity: 1;
  color: #27303f;
  color: rgba(39, 48, 63, var(--text-opacity));
}
.text-cool-gray-900 {
  --text-opacity: 1;
  color: #1a202e;
  color: rgba(26, 32, 46, var(--text-opacity));
}
.group:hover .group-hover\\:text-current {
  color: currentColor;
}
.group:hover .group-hover\\:text-transparent {
  color: transparent;
}
.group:hover .group-hover\\:text-white {
  --text-opacity: 1;
  color: #ffffff;
  color: rgba(255, 255, 255, var(--text-opacity));
}
.group:hover .group-hover\\:text-black {
  --text-opacity: 1;
  color: #000000;
  color: rgba(0, 0, 0, var(--text-opacity));
}
.group:hover .group-hover\\:text-gray-50 {
  --text-opacity: 1;
  color: #f9fafb;
  color: rgba(249, 250, 251, var(--text-opacity));
}
.group:hover .group-hover\\:text-gray-100 {
  --text-opacity: 1;
  color: #f4f5f7;
  color: rgba(244, 245, 247, var(--text-opacity));
}
.group:hover .group-hover\\:text-gray-200 {
  --text-opacity: 1;
  color: #e5e7eb;
  color: rgba(229, 231, 235, var(--text-opacity));
}
.group:hover .group-hover\\:text-gray-300 {
  --text-opacity: 1;
  color: #d2d6dc;
  color: rgba(210, 214, 220, var(--text-opacity));
}
.group:hover .group-hover\\:text-gray-400 {
  --text-opacity: 1;
  color: #9fa6b2;
  color: rgba(159, 166, 178, var(--text-opacity));
}
.group:hover .group-hover\\:text-gray-500 {
  --text-opacity: 1;
  color: #6b7280;
  color: rgba(107, 114, 128, var(--text-opacity));
}
.group:hover .group-hover\\:text-gray-600 {
  --text-opacity: 1;
  color: #4b5563;
  color: rgba(75, 85, 99, var(--text-opacity));
}
.group:hover .group-hover\\:text-gray-700 {
  --text-opacity: 1;
  color: #374151;
  color: rgba(55, 65, 81, var(--text-opacity));
}
.group:hover .group-hover\\:text-gray-800 {
  --text-opacity: 1;
  color: #252f3f;
  color: rgba(37, 47, 63, var(--text-opacity));
}
.group:hover .group-hover\\:text-gray-900 {
  --text-opacity: 1;
  color: #161e2e;
  color: rgba(22, 30, 46, var(--text-opacity));
}
.group:hover .group-hover\\:text-red-50 {
  --text-opacity: 1;
  color: #fdf2f2;
  color: rgba(253, 242, 242, var(--text-opacity));
}
.group:hover .group-hover\\:text-red-100 {
  --text-opacity: 1;
  color: #fde8e8;
  color: rgba(253, 232, 232, var(--text-opacity));
}
.group:hover .group-hover\\:text-red-200 {
  --text-opacity: 1;
  color: #fbd5d5;
  color: rgba(251, 213, 213, var(--text-opacity));
}
.group:hover .group-hover\\:text-red-300 {
  --text-opacity: 1;
  color: #f8b4b4;
  color: rgba(248, 180, 180, var(--text-opacity));
}
.group:hover .group-hover\\:text-red-400 {
  --text-opacity: 1;
  color: #f98080;
  color: rgba(249, 128, 128, var(--text-opacity));
}
.group:hover .group-hover\\:text-red-500 {
  --text-opacity: 1;
  color: #f05252;
  color: rgba(240, 82, 82, var(--text-opacity));
}
.group:hover .group-hover\\:text-red-600 {
  --text-opacity: 1;
  color: #e02424;
  color: rgba(224, 36, 36, var(--text-opacity));
}
.group:hover .group-hover\\:text-red-700 {
  --text-opacity: 1;
  color: #c81e1e;
  color: rgba(200, 30, 30, var(--text-opacity));
}
.group:hover .group-hover\\:text-red-800 {
  --text-opacity: 1;
  color: #9b1c1c;
  color: rgba(155, 28, 28, var(--text-opacity));
}
.group:hover .group-hover\\:text-red-900 {
  --text-opacity: 1;
  color: #771d1d;
  color: rgba(119, 29, 29, var(--text-opacity));
}
.group:hover .group-hover\\:text-orange-50 {
  --text-opacity: 1;
  color: #fff8f1;
  color: rgba(255, 248, 241, var(--text-opacity));
}
.group:hover .group-hover\\:text-orange-100 {
  --text-opacity: 1;
  color: #feecdc;
  color: rgba(254, 236, 220, var(--text-opacity));
}
.group:hover .group-hover\\:text-orange-200 {
  --text-opacity: 1;
  color: #fcd9bd;
  color: rgba(252, 217, 189, var(--text-opacity));
}
.group:hover .group-hover\\:text-orange-300 {
  --text-opacity: 1;
  color: #fdba8c;
  color: rgba(253, 186, 140, var(--text-opacity));
}
.group:hover .group-hover\\:text-orange-400 {
  --text-opacity: 1;
  color: #ff8a4c;
  color: rgba(255, 138, 76, var(--text-opacity));
}
.group:hover .group-hover\\:text-orange-500 {
  --text-opacity: 1;
  color: #ff5a1f;
  color: rgba(255, 90, 31, var(--text-opacity));
}
.group:hover .group-hover\\:text-orange-600 {
  --text-opacity: 1;
  color: #d03801;
  color: rgba(208, 56, 1, var(--text-opacity));
}
.group:hover .group-hover\\:text-orange-700 {
  --text-opacity: 1;
  color: #b43403;
  color: rgba(180, 52, 3, var(--text-opacity));
}
.group:hover .group-hover\\:text-orange-800 {
  --text-opacity: 1;
  color: #8a2c0d;
  color: rgba(138, 44, 13, var(--text-opacity));
}
.group:hover .group-hover\\:text-orange-900 {
  --text-opacity: 1;
  color: #73230d;
  color: rgba(115, 35, 13, var(--text-opacity));
}
.group:hover .group-hover\\:text-yellow-50 {
  --text-opacity: 1;
  color: #fdfdea;
  color: rgba(253, 253, 234, var(--text-opacity));
}
.group:hover .group-hover\\:text-yellow-100 {
  --text-opacity: 1;
  color: #fdf6b2;
  color: rgba(253, 246, 178, var(--text-opacity));
}
.group:hover .group-hover\\:text-yellow-200 {
  --text-opacity: 1;
  color: #fce96a;
  color: rgba(252, 233, 106, var(--text-opacity));
}
.group:hover .group-hover\\:text-yellow-300 {
  --text-opacity: 1;
  color: #faca15;
  color: rgba(250, 202, 21, var(--text-opacity));
}
.group:hover .group-hover\\:text-yellow-400 {
  --text-opacity: 1;
  color: #e3a008;
  color: rgba(227, 160, 8, var(--text-opacity));
}
.group:hover .group-hover\\:text-yellow-500 {
  --text-opacity: 1;
  color: #c27803;
  color: rgba(194, 120, 3, var(--text-opacity));
}
.group:hover .group-hover\\:text-yellow-600 {
  --text-opacity: 1;
  color: #9f580a;
  color: rgba(159, 88, 10, var(--text-opacity));
}
.group:hover .group-hover\\:text-yellow-700 {
  --text-opacity: 1;
  color: #8e4b10;
  color: rgba(142, 75, 16, var(--text-opacity));
}
.group:hover .group-hover\\:text-yellow-800 {
  --text-opacity: 1;
  color: #723b13;
  color: rgba(114, 59, 19, var(--text-opacity));
}
.group:hover .group-hover\\:text-yellow-900 {
  --text-opacity: 1;
  color: #633112;
  color: rgba(99, 49, 18, var(--text-opacity));
}
.group:hover .group-hover\\:text-green-50 {
  --text-opacity: 1;
  color: #f3faf7;
  color: rgba(243, 250, 247, var(--text-opacity));
}
.group:hover .group-hover\\:text-green-100 {
  --text-opacity: 1;
  color: #def7ec;
  color: rgba(222, 247, 236, var(--text-opacity));
}
.group:hover .group-hover\\:text-green-200 {
  --text-opacity: 1;
  color: #bcf0da;
  color: rgba(188, 240, 218, var(--text-opacity));
}
.group:hover .group-hover\\:text-green-300 {
  --text-opacity: 1;
  color: #84e1bc;
  color: rgba(132, 225, 188, var(--text-opacity));
}
.group:hover .group-hover\\:text-green-400 {
  --text-opacity: 1;
  color: #31c48d;
  color: rgba(49, 196, 141, var(--text-opacity));
}
.group:hover .group-hover\\:text-green-500 {
  --text-opacity: 1;
  color: #0e9f6e;
  color: rgba(14, 159, 110, var(--text-opacity));
}
.group:hover .group-hover\\:text-green-600 {
  --text-opacity: 1;
  color: #057a55;
  color: rgba(5, 122, 85, var(--text-opacity));
}
.group:hover .group-hover\\:text-green-700 {
  --text-opacity: 1;
  color: #046c4e;
  color: rgba(4, 108, 78, var(--text-opacity));
}
.group:hover .group-hover\\:text-green-800 {
  --text-opacity: 1;
  color: #03543f;
  color: rgba(3, 84, 63, var(--text-opacity));
}
.group:hover .group-hover\\:text-green-900 {
  --text-opacity: 1;
  color: #014737;
  color: rgba(1, 71, 55, var(--text-opacity));
}
.group:hover .group-hover\\:text-teal-50 {
  --text-opacity: 1;
  color: #edfafa;
  color: rgba(237, 250, 250, var(--text-opacity));
}
.group:hover .group-hover\\:text-teal-100 {
  --text-opacity: 1;
  color: #d5f5f6;
  color: rgba(213, 245, 246, var(--text-opacity));
}
.group:hover .group-hover\\:text-teal-200 {
  --text-opacity: 1;
  color: #afecef;
  color: rgba(175, 236, 239, var(--text-opacity));
}
.group:hover .group-hover\\:text-teal-300 {
  --text-opacity: 1;
  color: #7edce2;
  color: rgba(126, 220, 226, var(--text-opacity));
}
.group:hover .group-hover\\:text-teal-400 {
  --text-opacity: 1;
  color: #16bdca;
  color: rgba(22, 189, 202, var(--text-opacity));
}
.group:hover .group-hover\\:text-teal-500 {
  --text-opacity: 1;
  color: #0694a2;
  color: rgba(6, 148, 162, var(--text-opacity));
}
.group:hover .group-hover\\:text-teal-600 {
  --text-opacity: 1;
  color: #047481;
  color: rgba(4, 116, 129, var(--text-opacity));
}
.group:hover .group-hover\\:text-teal-700 {
  --text-opacity: 1;
  color: #036672;
  color: rgba(3, 102, 114, var(--text-opacity));
}
.group:hover .group-hover\\:text-teal-800 {
  --text-opacity: 1;
  color: #05505c;
  color: rgba(5, 80, 92, var(--text-opacity));
}
.group:hover .group-hover\\:text-teal-900 {
  --text-opacity: 1;
  color: #014451;
  color: rgba(1, 68, 81, var(--text-opacity));
}
.group:hover .group-hover\\:text-blue-50 {
  --text-opacity: 1;
  color: #ebf5ff;
  color: rgba(235, 245, 255, var(--text-opacity));
}
.group:hover .group-hover\\:text-blue-100 {
  --text-opacity: 1;
  color: #e1effe;
  color: rgba(225, 239, 254, var(--text-opacity));
}
.group:hover .group-hover\\:text-blue-200 {
  --text-opacity: 1;
  color: #c3ddfd;
  color: rgba(195, 221, 253, var(--text-opacity));
}
.group:hover .group-hover\\:text-blue-300 {
  --text-opacity: 1;
  color: #a4cafe;
  color: rgba(164, 202, 254, var(--text-opacity));
}
.group:hover .group-hover\\:text-blue-400 {
  --text-opacity: 1;
  color: #76a9fa;
  color: rgba(118, 169, 250, var(--text-opacity));
}
.group:hover .group-hover\\:text-blue-500 {
  --text-opacity: 1;
  color: #3f83f8;
  color: rgba(63, 131, 248, var(--text-opacity));
}
.group:hover .group-hover\\:text-blue-600 {
  --text-opacity: 1;
  color: #1c64f2;
  color: rgba(28, 100, 242, var(--text-opacity));
}
.group:hover .group-hover\\:text-blue-700 {
  --text-opacity: 1;
  color: #1a56db;
  color: rgba(26, 86, 219, var(--text-opacity));
}
.group:hover .group-hover\\:text-blue-800 {
  --text-opacity: 1;
  color: #1e429f;
  color: rgba(30, 66, 159, var(--text-opacity));
}
.group:hover .group-hover\\:text-blue-900 {
  --text-opacity: 1;
  color: #233876;
  color: rgba(35, 56, 118, var(--text-opacity));
}
.group:hover .group-hover\\:text-indigo-50 {
  --text-opacity: 1;
  color: #f0f5ff;
  color: rgba(240, 245, 255, var(--text-opacity));
}
.group:hover .group-hover\\:text-indigo-100 {
  --text-opacity: 1;
  color: #e5edff;
  color: rgba(229, 237, 255, var(--text-opacity));
}
.group:hover .group-hover\\:text-indigo-200 {
  --text-opacity: 1;
  color: #cddbfe;
  color: rgba(205, 219, 254, var(--text-opacity));
}
.group:hover .group-hover\\:text-indigo-300 {
  --text-opacity: 1;
  color: #b4c6fc;
  color: rgba(180, 198, 252, var(--text-opacity));
}
.group:hover .group-hover\\:text-indigo-400 {
  --text-opacity: 1;
  color: #8da2fb;
  color: rgba(141, 162, 251, var(--text-opacity));
}
.group:hover .group-hover\\:text-indigo-500 {
  --text-opacity: 1;
  color: #6875f5;
  color: rgba(104, 117, 245, var(--text-opacity));
}
.group:hover .group-hover\\:text-indigo-600 {
  --text-opacity: 1;
  color: #5850ec;
  color: rgba(88, 80, 236, var(--text-opacity));
}
.group:hover .group-hover\\:text-indigo-700 {
  --text-opacity: 1;
  color: #5145cd;
  color: rgba(81, 69, 205, var(--text-opacity));
}
.group:hover .group-hover\\:text-indigo-800 {
  --text-opacity: 1;
  color: #42389d;
  color: rgba(66, 56, 157, var(--text-opacity));
}
.group:hover .group-hover\\:text-indigo-900 {
  --text-opacity: 1;
  color: #362f78;
  color: rgba(54, 47, 120, var(--text-opacity));
}
.group:hover .group-hover\\:text-purple-50 {
  --text-opacity: 1;
  color: #f6f5ff;
  color: rgba(246, 245, 255, var(--text-opacity));
}
.group:hover .group-hover\\:text-purple-100 {
  --text-opacity: 1;
  color: #edebfe;
  color: rgba(237, 235, 254, var(--text-opacity));
}
.group:hover .group-hover\\:text-purple-200 {
  --text-opacity: 1;
  color: #dcd7fe;
  color: rgba(220, 215, 254, var(--text-opacity));
}
.group:hover .group-hover\\:text-purple-300 {
  --text-opacity: 1;
  color: #cabffd;
  color: rgba(202, 191, 253, var(--text-opacity));
}
.group:hover .group-hover\\:text-purple-400 {
  --text-opacity: 1;
  color: #ac94fa;
  color: rgba(172, 148, 250, var(--text-opacity));
}
.group:hover .group-hover\\:text-purple-500 {
  --text-opacity: 1;
  color: #9061f9;
  color: rgba(144, 97, 249, var(--text-opacity));
}
.group:hover .group-hover\\:text-purple-600 {
  --text-opacity: 1;
  color: #7e3af2;
  color: rgba(126, 58, 242, var(--text-opacity));
}
.group:hover .group-hover\\:text-purple-700 {
  --text-opacity: 1;
  color: #6c2bd9;
  color: rgba(108, 43, 217, var(--text-opacity));
}
.group:hover .group-hover\\:text-purple-800 {
  --text-opacity: 1;
  color: #5521b5;
  color: rgba(85, 33, 181, var(--text-opacity));
}
.group:hover .group-hover\\:text-purple-900 {
  --text-opacity: 1;
  color: #4a1d96;
  color: rgba(74, 29, 150, var(--text-opacity));
}
.group:hover .group-hover\\:text-pink-50 {
  --text-opacity: 1;
  color: #fdf2f8;
  color: rgba(253, 242, 248, var(--text-opacity));
}
.group:hover .group-hover\\:text-pink-100 {
  --text-opacity: 1;
  color: #fce8f3;
  color: rgba(252, 232, 243, var(--text-opacity));
}
.group:hover .group-hover\\:text-pink-200 {
  --text-opacity: 1;
  color: #fad1e8;
  color: rgba(250, 209, 232, var(--text-opacity));
}
.group:hover .group-hover\\:text-pink-300 {
  --text-opacity: 1;
  color: #f8b4d9;
  color: rgba(248, 180, 217, var(--text-opacity));
}
.group:hover .group-hover\\:text-pink-400 {
  --text-opacity: 1;
  color: #f17eb8;
  color: rgba(241, 126, 184, var(--text-opacity));
}
.group:hover .group-hover\\:text-pink-500 {
  --text-opacity: 1;
  color: #e74694;
  color: rgba(231, 70, 148, var(--text-opacity));
}
.group:hover .group-hover\\:text-pink-600 {
  --text-opacity: 1;
  color: #d61f69;
  color: rgba(214, 31, 105, var(--text-opacity));
}
.group:hover .group-hover\\:text-pink-700 {
  --text-opacity: 1;
  color: #bf125d;
  color: rgba(191, 18, 93, var(--text-opacity));
}
.group:hover .group-hover\\:text-pink-800 {
  --text-opacity: 1;
  color: #99154b;
  color: rgba(153, 21, 75, var(--text-opacity));
}
.group:hover .group-hover\\:text-pink-900 {
  --text-opacity: 1;
  color: #751a3d;
  color: rgba(117, 26, 61, var(--text-opacity));
}
.group:hover .group-hover\\:text-cool-gray-50 {
  --text-opacity: 1;
  color: #f8fafc;
  color: rgba(248, 250, 252, var(--text-opacity));
}
.group:hover .group-hover\\:text-cool-gray-100 {
  --text-opacity: 1;
  color: #f1f5f9;
  color: rgba(241, 245, 249, var(--text-opacity));
}
.group:hover .group-hover\\:text-cool-gray-200 {
  --text-opacity: 1;
  color: #e2e8f0;
  color: rgba(226, 232, 240, var(--text-opacity));
}
.group:hover .group-hover\\:text-cool-gray-300 {
  --text-opacity: 1;
  color: #cfd8e3;
  color: rgba(207, 216, 227, var(--text-opacity));
}
.group:hover .group-hover\\:text-cool-gray-400 {
  --text-opacity: 1;
  color: #97a6ba;
  color: rgba(151, 166, 186, var(--text-opacity));
}
.group:hover .group-hover\\:text-cool-gray-500 {
  --text-opacity: 1;
  color: #64748b;
  color: rgba(100, 116, 139, var(--text-opacity));
}
.group:hover .group-hover\\:text-cool-gray-600 {
  --text-opacity: 1;
  color: #475569;
  color: rgba(71, 85, 105, var(--text-opacity));
}
.group:hover .group-hover\\:text-cool-gray-700 {
  --text-opacity: 1;
  color: #364152;
  color: rgba(54, 65, 82, var(--text-opacity));
}
.group:hover .group-hover\\:text-cool-gray-800 {
  --text-opacity: 1;
  color: #27303f;
  color: rgba(39, 48, 63, var(--text-opacity));
}
.group:hover .group-hover\\:text-cool-gray-900 {
  --text-opacity: 1;
  color: #1a202e;
  color: rgba(26, 32, 46, var(--text-opacity));
}
.group:focus .group-focus\\:text-current {
  color: currentColor;
}
.group:focus .group-focus\\:text-transparent {
  color: transparent;
}
.group:focus .group-focus\\:text-white {
  --text-opacity: 1;
  color: #ffffff;
  color: rgba(255, 255, 255, var(--text-opacity));
}
.group:focus .group-focus\\:text-black {
  --text-opacity: 1;
  color: #000000;
  color: rgba(0, 0, 0, var(--text-opacity));
}
.group:focus .group-focus\\:text-gray-50 {
  --text-opacity: 1;
  color: #f9fafb;
  color: rgba(249, 250, 251, var(--text-opacity));
}
.group:focus .group-focus\\:text-gray-100 {
  --text-opacity: 1;
  color: #f4f5f7;
  color: rgba(244, 245, 247, var(--text-opacity));
}
.group:focus .group-focus\\:text-gray-200 {
  --text-opacity: 1;
  color: #e5e7eb;
  color: rgba(229, 231, 235, var(--text-opacity));
}
.group:focus .group-focus\\:text-gray-300 {
  --text-opacity: 1;
  color: #d2d6dc;
  color: rgba(210, 214, 220, var(--text-opacity));
}
.group:focus .group-focus\\:text-gray-400 {
  --text-opacity: 1;
  color: #9fa6b2;
  color: rgba(159, 166, 178, var(--text-opacity));
}
.group:focus .group-focus\\:text-gray-500 {
  --text-opacity: 1;
  color: #6b7280;
  color: rgba(107, 114, 128, var(--text-opacity));
}
.group:focus .group-focus\\:text-gray-600 {
  --text-opacity: 1;
  color: #4b5563;
  color: rgba(75, 85, 99, var(--text-opacity));
}
.group:focus .group-focus\\:text-gray-700 {
  --text-opacity: 1;
  color: #374151;
  color: rgba(55, 65, 81, var(--text-opacity));
}
.group:focus .group-focus\\:text-gray-800 {
  --text-opacity: 1;
  color: #252f3f;
  color: rgba(37, 47, 63, var(--text-opacity));
}
.group:focus .group-focus\\:text-gray-900 {
  --text-opacity: 1;
  color: #161e2e;
  color: rgba(22, 30, 46, var(--text-opacity));
}
.group:focus .group-focus\\:text-red-50 {
  --text-opacity: 1;
  color: #fdf2f2;
  color: rgba(253, 242, 242, var(--text-opacity));
}
.group:focus .group-focus\\:text-red-100 {
  --text-opacity: 1;
  color: #fde8e8;
  color: rgba(253, 232, 232, var(--text-opacity));
}
.group:focus .group-focus\\:text-red-200 {
  --text-opacity: 1;
  color: #fbd5d5;
  color: rgba(251, 213, 213, var(--text-opacity));
}
.group:focus .group-focus\\:text-red-300 {
  --text-opacity: 1;
  color: #f8b4b4;
  color: rgba(248, 180, 180, var(--text-opacity));
}
.group:focus .group-focus\\:text-red-400 {
  --text-opacity: 1;
  color: #f98080;
  color: rgba(249, 128, 128, var(--text-opacity));
}
.group:focus .group-focus\\:text-red-500 {
  --text-opacity: 1;
  color: #f05252;
  color: rgba(240, 82, 82, var(--text-opacity));
}
.group:focus .group-focus\\:text-red-600 {
  --text-opacity: 1;
  color: #e02424;
  color: rgba(224, 36, 36, var(--text-opacity));
}
.group:focus .group-focus\\:text-red-700 {
  --text-opacity: 1;
  color: #c81e1e;
  color: rgba(200, 30, 30, var(--text-opacity));
}
.group:focus .group-focus\\:text-red-800 {
  --text-opacity: 1;
  color: #9b1c1c;
  color: rgba(155, 28, 28, var(--text-opacity));
}
.group:focus .group-focus\\:text-red-900 {
  --text-opacity: 1;
  color: #771d1d;
  color: rgba(119, 29, 29, var(--text-opacity));
}
.group:focus .group-focus\\:text-orange-50 {
  --text-opacity: 1;
  color: #fff8f1;
  color: rgba(255, 248, 241, var(--text-opacity));
}
.group:focus .group-focus\\:text-orange-100 {
  --text-opacity: 1;
  color: #feecdc;
  color: rgba(254, 236, 220, var(--text-opacity));
}
.group:focus .group-focus\\:text-orange-200 {
  --text-opacity: 1;
  color: #fcd9bd;
  color: rgba(252, 217, 189, var(--text-opacity));
}
.group:focus .group-focus\\:text-orange-300 {
  --text-opacity: 1;
  color: #fdba8c;
  color: rgba(253, 186, 140, var(--text-opacity));
}
.group:focus .group-focus\\:text-orange-400 {
  --text-opacity: 1;
  color: #ff8a4c;
  color: rgba(255, 138, 76, var(--text-opacity));
}
.group:focus .group-focus\\:text-orange-500 {
  --text-opacity: 1;
  color: #ff5a1f;
  color: rgba(255, 90, 31, var(--text-opacity));
}
.group:focus .group-focus\\:text-orange-600 {
  --text-opacity: 1;
  color: #d03801;
  color: rgba(208, 56, 1, var(--text-opacity));
}
.group:focus .group-focus\\:text-orange-700 {
  --text-opacity: 1;
  color: #b43403;
  color: rgba(180, 52, 3, var(--text-opacity));
}
.group:focus .group-focus\\:text-orange-800 {
  --text-opacity: 1;
  color: #8a2c0d;
  color: rgba(138, 44, 13, var(--text-opacity));
}
.group:focus .group-focus\\:text-orange-900 {
  --text-opacity: 1;
  color: #73230d;
  color: rgba(115, 35, 13, var(--text-opacity));
}
.group:focus .group-focus\\:text-yellow-50 {
  --text-opacity: 1;
  color: #fdfdea;
  color: rgba(253, 253, 234, var(--text-opacity));
}
.group:focus .group-focus\\:text-yellow-100 {
  --text-opacity: 1;
  color: #fdf6b2;
  color: rgba(253, 246, 178, var(--text-opacity));
}
.group:focus .group-focus\\:text-yellow-200 {
  --text-opacity: 1;
  color: #fce96a;
  color: rgba(252, 233, 106, var(--text-opacity));
}
.group:focus .group-focus\\:text-yellow-300 {
  --text-opacity: 1;
  color: #faca15;
  color: rgba(250, 202, 21, var(--text-opacity));
}
.group:focus .group-focus\\:text-yellow-400 {
  --text-opacity: 1;
  color: #e3a008;
  color: rgba(227, 160, 8, var(--text-opacity));
}
.group:focus .group-focus\\:text-yellow-500 {
  --text-opacity: 1;
  color: #c27803;
  color: rgba(194, 120, 3, var(--text-opacity));
}
.group:focus .group-focus\\:text-yellow-600 {
  --text-opacity: 1;
  color: #9f580a;
  color: rgba(159, 88, 10, var(--text-opacity));
}
.group:focus .group-focus\\:text-yellow-700 {
  --text-opacity: 1;
  color: #8e4b10;
  color: rgba(142, 75, 16, var(--text-opacity));
}
.group:focus .group-focus\\:text-yellow-800 {
  --text-opacity: 1;
  color: #723b13;
  color: rgba(114, 59, 19, var(--text-opacity));
}
.group:focus .group-focus\\:text-yellow-900 {
  --text-opacity: 1;
  color: #633112;
  color: rgba(99, 49, 18, var(--text-opacity));
}
.group:focus .group-focus\\:text-green-50 {
  --text-opacity: 1;
  color: #f3faf7;
  color: rgba(243, 250, 247, var(--text-opacity));
}
.group:focus .group-focus\\:text-green-100 {
  --text-opacity: 1;
  color: #def7ec;
  color: rgba(222, 247, 236, var(--text-opacity));
}
.group:focus .group-focus\\:text-green-200 {
  --text-opacity: 1;
  color: #bcf0da;
  color: rgba(188, 240, 218, var(--text-opacity));
}
.group:focus .group-focus\\:text-green-300 {
  --text-opacity: 1;
  color: #84e1bc;
  color: rgba(132, 225, 188, var(--text-opacity));
}
.group:focus .group-focus\\:text-green-400 {
  --text-opacity: 1;
  color: #31c48d;
  color: rgba(49, 196, 141, var(--text-opacity));
}
.group:focus .group-focus\\:text-green-500 {
  --text-opacity: 1;
  color: #0e9f6e;
  color: rgba(14, 159, 110, var(--text-opacity));
}
.group:focus .group-focus\\:text-green-600 {
  --text-opacity: 1;
  color: #057a55;
  color: rgba(5, 122, 85, var(--text-opacity));
}
.group:focus .group-focus\\:text-green-700 {
  --text-opacity: 1;
  color: #046c4e;
  color: rgba(4, 108, 78, var(--text-opacity));
}
.group:focus .group-focus\\:text-green-800 {
  --text-opacity: 1;
  color: #03543f;
  color: rgba(3, 84, 63, var(--text-opacity));
}
.group:focus .group-focus\\:text-green-900 {
  --text-opacity: 1;
  color: #014737;
  color: rgba(1, 71, 55, var(--text-opacity));
}
.group:focus .group-focus\\:text-teal-50 {
  --text-opacity: 1;
  color: #edfafa;
  color: rgba(237, 250, 250, var(--text-opacity));
}
.group:focus .group-focus\\:text-teal-100 {
  --text-opacity: 1;
  color: #d5f5f6;
  color: rgba(213, 245, 246, var(--text-opacity));
}
.group:focus .group-focus\\:text-teal-200 {
  --text-opacity: 1;
  color: #afecef;
  color: rgba(175, 236, 239, var(--text-opacity));
}
.group:focus .group-focus\\:text-teal-300 {
  --text-opacity: 1;
  color: #7edce2;
  color: rgba(126, 220, 226, var(--text-opacity));
}
.group:focus .group-focus\\:text-teal-400 {
  --text-opacity: 1;
  color: #16bdca;
  color: rgba(22, 189, 202, var(--text-opacity));
}
.group:focus .group-focus\\:text-teal-500 {
  --text-opacity: 1;
  color: #0694a2;
  color: rgba(6, 148, 162, var(--text-opacity));
}
.group:focus .group-focus\\:text-teal-600 {
  --text-opacity: 1;
  color: #047481;
  color: rgba(4, 116, 129, var(--text-opacity));
}
.group:focus .group-focus\\:text-teal-700 {
  --text-opacity: 1;
  color: #036672;
  color: rgba(3, 102, 114, var(--text-opacity));
}
.group:focus .group-focus\\:text-teal-800 {
  --text-opacity: 1;
  color: #05505c;
  color: rgba(5, 80, 92, var(--text-opacity));
}
.group:focus .group-focus\\:text-teal-900 {
  --text-opacity: 1;
  color: #014451;
  color: rgba(1, 68, 81, var(--text-opacity));
}
.group:focus .group-focus\\:text-blue-50 {
  --text-opacity: 1;
  color: #ebf5ff;
  color: rgba(235, 245, 255, var(--text-opacity));
}
.group:focus .group-focus\\:text-blue-100 {
  --text-opacity: 1;
  color: #e1effe;
  color: rgba(225, 239, 254, var(--text-opacity));
}
.group:focus .group-focus\\:text-blue-200 {
  --text-opacity: 1;
  color: #c3ddfd;
  color: rgba(195, 221, 253, var(--text-opacity));
}
.group:focus .group-focus\\:text-blue-300 {
  --text-opacity: 1;
  color: #a4cafe;
  color: rgba(164, 202, 254, var(--text-opacity));
}
.group:focus .group-focus\\:text-blue-400 {
  --text-opacity: 1;
  color: #76a9fa;
  color: rgba(118, 169, 250, var(--text-opacity));
}
.group:focus .group-focus\\:text-blue-500 {
  --text-opacity: 1;
  color: #3f83f8;
  color: rgba(63, 131, 248, var(--text-opacity));
}
.group:focus .group-focus\\:text-blue-600 {
  --text-opacity: 1;
  color: #1c64f2;
  color: rgba(28, 100, 242, var(--text-opacity));
}
.group:focus .group-focus\\:text-blue-700 {
  --text-opacity: 1;
  color: #1a56db;
  color: rgba(26, 86, 219, var(--text-opacity));
}
.group:focus .group-focus\\:text-blue-800 {
  --text-opacity: 1;
  color: #1e429f;
  color: rgba(30, 66, 159, var(--text-opacity));
}
.group:focus .group-focus\\:text-blue-900 {
  --text-opacity: 1;
  color: #233876;
  color: rgba(35, 56, 118, var(--text-opacity));
}
.group:focus .group-focus\\:text-indigo-50 {
  --text-opacity: 1;
  color: #f0f5ff;
  color: rgba(240, 245, 255, var(--text-opacity));
}
.group:focus .group-focus\\:text-indigo-100 {
  --text-opacity: 1;
  color: #e5edff;
  color: rgba(229, 237, 255, var(--text-opacity));
}
.group:focus .group-focus\\:text-indigo-200 {
  --text-opacity: 1;
  color: #cddbfe;
  color: rgba(205, 219, 254, var(--text-opacity));
}
.group:focus .group-focus\\:text-indigo-300 {
  --text-opacity: 1;
  color: #b4c6fc;
  color: rgba(180, 198, 252, var(--text-opacity));
}
.group:focus .group-focus\\:text-indigo-400 {
  --text-opacity: 1;
  color: #8da2fb;
  color: rgba(141, 162, 251, var(--text-opacity));
}
.group:focus .group-focus\\:text-indigo-500 {
  --text-opacity: 1;
  color: #6875f5;
  color: rgba(104, 117, 245, var(--text-opacity));
}
.group:focus .group-focus\\:text-indigo-600 {
  --text-opacity: 1;
  color: #5850ec;
  color: rgba(88, 80, 236, var(--text-opacity));
}
.group:focus .group-focus\\:text-indigo-700 {
  --text-opacity: 1;
  color: #5145cd;
  color: rgba(81, 69, 205, var(--text-opacity));
}
.group:focus .group-focus\\:text-indigo-800 {
  --text-opacity: 1;
  color: #42389d;
  color: rgba(66, 56, 157, var(--text-opacity));
}
.group:focus .group-focus\\:text-indigo-900 {
  --text-opacity: 1;
  color: #362f78;
  color: rgba(54, 47, 120, var(--text-opacity));
}
.group:focus .group-focus\\:text-purple-50 {
  --text-opacity: 1;
  color: #f6f5ff;
  color: rgba(246, 245, 255, var(--text-opacity));
}
.group:focus .group-focus\\:text-purple-100 {
  --text-opacity: 1;
  color: #edebfe;
  color: rgba(237, 235, 254, var(--text-opacity));
}
.group:focus .group-focus\\:text-purple-200 {
  --text-opacity: 1;
  color: #dcd7fe;
  color: rgba(220, 215, 254, var(--text-opacity));
}
.group:focus .group-focus\\:text-purple-300 {
  --text-opacity: 1;
  color: #cabffd;
  color: rgba(202, 191, 253, var(--text-opacity));
}
.group:focus .group-focus\\:text-purple-400 {
  --text-opacity: 1;
  color: #ac94fa;
  color: rgba(172, 148, 250, var(--text-opacity));
}
.group:focus .group-focus\\:text-purple-500 {
  --text-opacity: 1;
  color: #9061f9;
  color: rgba(144, 97, 249, var(--text-opacity));
}
.group:focus .group-focus\\:text-purple-600 {
  --text-opacity: 1;
  color: #7e3af2;
  color: rgba(126, 58, 242, var(--text-opacity));
}
.group:focus .group-focus\\:text-purple-700 {
  --text-opacity: 1;
  color: #6c2bd9;
  color: rgba(108, 43, 217, var(--text-opacity));
}
.group:focus .group-focus\\:text-purple-800 {
  --text-opacity: 1;
  color: #5521b5;
  color: rgba(85, 33, 181, var(--text-opacity));
}
.group:focus .group-focus\\:text-purple-900 {
  --text-opacity: 1;
  color: #4a1d96;
  color: rgba(74, 29, 150, var(--text-opacity));
}
.group:focus .group-focus\\:text-pink-50 {
  --text-opacity: 1;
  color: #fdf2f8;
  color: rgba(253, 242, 248, var(--text-opacity));
}
.group:focus .group-focus\\:text-pink-100 {
  --text-opacity: 1;
  color: #fce8f3;
  color: rgba(252, 232, 243, var(--text-opacity));
}
.group:focus .group-focus\\:text-pink-200 {
  --text-opacity: 1;
  color: #fad1e8;
  color: rgba(250, 209, 232, var(--text-opacity));
}
.group:focus .group-focus\\:text-pink-300 {
  --text-opacity: 1;
  color: #f8b4d9;
  color: rgba(248, 180, 217, var(--text-opacity));
}
.group:focus .group-focus\\:text-pink-400 {
  --text-opacity: 1;
  color: #f17eb8;
  color: rgba(241, 126, 184, var(--text-opacity));
}
.group:focus .group-focus\\:text-pink-500 {
  --text-opacity: 1;
  color: #e74694;
  color: rgba(231, 70, 148, var(--text-opacity));
}
.group:focus .group-focus\\:text-pink-600 {
  --text-opacity: 1;
  color: #d61f69;
  color: rgba(214, 31, 105, var(--text-opacity));
}
.group:focus .group-focus\\:text-pink-700 {
  --text-opacity: 1;
  color: #bf125d;
  color: rgba(191, 18, 93, var(--text-opacity));
}
.group:focus .group-focus\\:text-pink-800 {
  --text-opacity: 1;
  color: #99154b;
  color: rgba(153, 21, 75, var(--text-opacity));
}
.group:focus .group-focus\\:text-pink-900 {
  --text-opacity: 1;
  color: #751a3d;
  color: rgba(117, 26, 61, var(--text-opacity));
}
.group:focus .group-focus\\:text-cool-gray-50 {
  --text-opacity: 1;
  color: #f8fafc;
  color: rgba(248, 250, 252, var(--text-opacity));
}
.group:focus .group-focus\\:text-cool-gray-100 {
  --text-opacity: 1;
  color: #f1f5f9;
  color: rgba(241, 245, 249, var(--text-opacity));
}
.group:focus .group-focus\\:text-cool-gray-200 {
  --text-opacity: 1;
  color: #e2e8f0;
  color: rgba(226, 232, 240, var(--text-opacity));
}
.group:focus .group-focus\\:text-cool-gray-300 {
  --text-opacity: 1;
  color: #cfd8e3;
  color: rgba(207, 216, 227, var(--text-opacity));
}
.group:focus .group-focus\\:text-cool-gray-400 {
  --text-opacity: 1;
  color: #97a6ba;
  color: rgba(151, 166, 186, var(--text-opacity));
}
.group:focus .group-focus\\:text-cool-gray-500 {
  --text-opacity: 1;
  color: #64748b;
  color: rgba(100, 116, 139, var(--text-opacity));
}
.group:focus .group-focus\\:text-cool-gray-600 {
  --text-opacity: 1;
  color: #475569;
  color: rgba(71, 85, 105, var(--text-opacity));
}
.group:focus .group-focus\\:text-cool-gray-700 {
  --text-opacity: 1;
  color: #364152;
  color: rgba(54, 65, 82, var(--text-opacity));
}
.group:focus .group-focus\\:text-cool-gray-800 {
  --text-opacity: 1;
  color: #27303f;
  color: rgba(39, 48, 63, var(--text-opacity));
}
.group:focus .group-focus\\:text-cool-gray-900 {
  --text-opacity: 1;
  color: #1a202e;
  color: rgba(26, 32, 46, var(--text-opacity));
}
.hover\\:text-current:hover {
  color: currentColor;
}
.hover\\:text-transparent:hover {
  color: transparent;
}
.hover\\:text-white:hover {
  --text-opacity: 1;
  color: #ffffff;
  color: rgba(255, 255, 255, var(--text-opacity));
}
.hover\\:text-black:hover {
  --text-opacity: 1;
  color: #000000;
  color: rgba(0, 0, 0, var(--text-opacity));
}
.hover\\:text-gray-50:hover {
  --text-opacity: 1;
  color: #f9fafb;
  color: rgba(249, 250, 251, var(--text-opacity));
}
.hover\\:text-gray-100:hover {
  --text-opacity: 1;
  color: #f4f5f7;
  color: rgba(244, 245, 247, var(--text-opacity));
}
.hover\\:text-gray-200:hover {
  --text-opacity: 1;
  color: #e5e7eb;
  color: rgba(229, 231, 235, var(--text-opacity));
}
.hover\\:text-gray-300:hover {
  --text-opacity: 1;
  color: #d2d6dc;
  color: rgba(210, 214, 220, var(--text-opacity));
}
.hover\\:text-gray-400:hover {
  --text-opacity: 1;
  color: #9fa6b2;
  color: rgba(159, 166, 178, var(--text-opacity));
}
.hover\\:text-gray-500:hover {
  --text-opacity: 1;
  color: #6b7280;
  color: rgba(107, 114, 128, var(--text-opacity));
}
.hover\\:text-gray-600:hover {
  --text-opacity: 1;
  color: #4b5563;
  color: rgba(75, 85, 99, var(--text-opacity));
}
.hover\\:text-gray-700:hover {
  --text-opacity: 1;
  color: #374151;
  color: rgba(55, 65, 81, var(--text-opacity));
}
.hover\\:text-gray-800:hover {
  --text-opacity: 1;
  color: #252f3f;
  color: rgba(37, 47, 63, var(--text-opacity));
}
.hover\\:text-gray-900:hover {
  --text-opacity: 1;
  color: #161e2e;
  color: rgba(22, 30, 46, var(--text-opacity));
}
.hover\\:text-red-50:hover {
  --text-opacity: 1;
  color: #fdf2f2;
  color: rgba(253, 242, 242, var(--text-opacity));
}
.hover\\:text-red-100:hover {
  --text-opacity: 1;
  color: #fde8e8;
  color: rgba(253, 232, 232, var(--text-opacity));
}
.hover\\:text-red-200:hover {
  --text-opacity: 1;
  color: #fbd5d5;
  color: rgba(251, 213, 213, var(--text-opacity));
}
.hover\\:text-red-300:hover {
  --text-opacity: 1;
  color: #f8b4b4;
  color: rgba(248, 180, 180, var(--text-opacity));
}
.hover\\:text-red-400:hover {
  --text-opacity: 1;
  color: #f98080;
  color: rgba(249, 128, 128, var(--text-opacity));
}
.hover\\:text-red-500:hover {
  --text-opacity: 1;
  color: #f05252;
  color: rgba(240, 82, 82, var(--text-opacity));
}
.hover\\:text-red-600:hover {
  --text-opacity: 1;
  color: #e02424;
  color: rgba(224, 36, 36, var(--text-opacity));
}
.hover\\:text-red-700:hover {
  --text-opacity: 1;
  color: #c81e1e;
  color: rgba(200, 30, 30, var(--text-opacity));
}
.hover\\:text-red-800:hover {
  --text-opacity: 1;
  color: #9b1c1c;
  color: rgba(155, 28, 28, var(--text-opacity));
}
.hover\\:text-red-900:hover {
  --text-opacity: 1;
  color: #771d1d;
  color: rgba(119, 29, 29, var(--text-opacity));
}
.hover\\:text-orange-50:hover {
  --text-opacity: 1;
  color: #fff8f1;
  color: rgba(255, 248, 241, var(--text-opacity));
}
.hover\\:text-orange-100:hover {
  --text-opacity: 1;
  color: #feecdc;
  color: rgba(254, 236, 220, var(--text-opacity));
}
.hover\\:text-orange-200:hover {
  --text-opacity: 1;
  color: #fcd9bd;
  color: rgba(252, 217, 189, var(--text-opacity));
}
.hover\\:text-orange-300:hover {
  --text-opacity: 1;
  color: #fdba8c;
  color: rgba(253, 186, 140, var(--text-opacity));
}
.hover\\:text-orange-400:hover {
  --text-opacity: 1;
  color: #ff8a4c;
  color: rgba(255, 138, 76, var(--text-opacity));
}
.hover\\:text-orange-500:hover {
  --text-opacity: 1;
  color: #ff5a1f;
  color: rgba(255, 90, 31, var(--text-opacity));
}
.hover\\:text-orange-600:hover {
  --text-opacity: 1;
  color: #d03801;
  color: rgba(208, 56, 1, var(--text-opacity));
}
.hover\\:text-orange-700:hover {
  --text-opacity: 1;
  color: #b43403;
  color: rgba(180, 52, 3, var(--text-opacity));
}
.hover\\:text-orange-800:hover {
  --text-opacity: 1;
  color: #8a2c0d;
  color: rgba(138, 44, 13, var(--text-opacity));
}
.hover\\:text-orange-900:hover {
  --text-opacity: 1;
  color: #73230d;
  color: rgba(115, 35, 13, var(--text-opacity));
}
.hover\\:text-yellow-50:hover {
  --text-opacity: 1;
  color: #fdfdea;
  color: rgba(253, 253, 234, var(--text-opacity));
}
.hover\\:text-yellow-100:hover {
  --text-opacity: 1;
  color: #fdf6b2;
  color: rgba(253, 246, 178, var(--text-opacity));
}
.hover\\:text-yellow-200:hover {
  --text-opacity: 1;
  color: #fce96a;
  color: rgba(252, 233, 106, var(--text-opacity));
}
.hover\\:text-yellow-300:hover {
  --text-opacity: 1;
  color: #faca15;
  color: rgba(250, 202, 21, var(--text-opacity));
}
.hover\\:text-yellow-400:hover {
  --text-opacity: 1;
  color: #e3a008;
  color: rgba(227, 160, 8, var(--text-opacity));
}
.hover\\:text-yellow-500:hover {
  --text-opacity: 1;
  color: #c27803;
  color: rgba(194, 120, 3, var(--text-opacity));
}
.hover\\:text-yellow-600:hover {
  --text-opacity: 1;
  color: #9f580a;
  color: rgba(159, 88, 10, var(--text-opacity));
}
.hover\\:text-yellow-700:hover {
  --text-opacity: 1;
  color: #8e4b10;
  color: rgba(142, 75, 16, var(--text-opacity));
}
.hover\\:text-yellow-800:hover {
  --text-opacity: 1;
  color: #723b13;
  color: rgba(114, 59, 19, var(--text-opacity));
}
.hover\\:text-yellow-900:hover {
  --text-opacity: 1;
  color: #633112;
  color: rgba(99, 49, 18, var(--text-opacity));
}
.hover\\:text-green-50:hover {
  --text-opacity: 1;
  color: #f3faf7;
  color: rgba(243, 250, 247, var(--text-opacity));
}
.hover\\:text-green-100:hover {
  --text-opacity: 1;
  color: #def7ec;
  color: rgba(222, 247, 236, var(--text-opacity));
}
.hover\\:text-green-200:hover {
  --text-opacity: 1;
  color: #bcf0da;
  color: rgba(188, 240, 218, var(--text-opacity));
}
.hover\\:text-green-300:hover {
  --text-opacity: 1;
  color: #84e1bc;
  color: rgba(132, 225, 188, var(--text-opacity));
}
.hover\\:text-green-400:hover {
  --text-opacity: 1;
  color: #31c48d;
  color: rgba(49, 196, 141, var(--text-opacity));
}
.hover\\:text-green-500:hover {
  --text-opacity: 1;
  color: #0e9f6e;
  color: rgba(14, 159, 110, var(--text-opacity));
}
.hover\\:text-green-600:hover {
  --text-opacity: 1;
  color: #057a55;
  color: rgba(5, 122, 85, var(--text-opacity));
}
.hover\\:text-green-700:hover {
  --text-opacity: 1;
  color: #046c4e;
  color: rgba(4, 108, 78, var(--text-opacity));
}
.hover\\:text-green-800:hover {
  --text-opacity: 1;
  color: #03543f;
  color: rgba(3, 84, 63, var(--text-opacity));
}
.hover\\:text-green-900:hover {
  --text-opacity: 1;
  color: #014737;
  color: rgba(1, 71, 55, var(--text-opacity));
}
.hover\\:text-teal-50:hover {
  --text-opacity: 1;
  color: #edfafa;
  color: rgba(237, 250, 250, var(--text-opacity));
}
.hover\\:text-teal-100:hover {
  --text-opacity: 1;
  color: #d5f5f6;
  color: rgba(213, 245, 246, var(--text-opacity));
}
.hover\\:text-teal-200:hover {
  --text-opacity: 1;
  color: #afecef;
  color: rgba(175, 236, 239, var(--text-opacity));
}
.hover\\:text-teal-300:hover {
  --text-opacity: 1;
  color: #7edce2;
  color: rgba(126, 220, 226, var(--text-opacity));
}
.hover\\:text-teal-400:hover {
  --text-opacity: 1;
  color: #16bdca;
  color: rgba(22, 189, 202, var(--text-opacity));
}
.hover\\:text-teal-500:hover {
  --text-opacity: 1;
  color: #0694a2;
  color: rgba(6, 148, 162, var(--text-opacity));
}
.hover\\:text-teal-600:hover {
  --text-opacity: 1;
  color: #047481;
  color: rgba(4, 116, 129, var(--text-opacity));
}
.hover\\:text-teal-700:hover {
  --text-opacity: 1;
  color: #036672;
  color: rgba(3, 102, 114, var(--text-opacity));
}
.hover\\:text-teal-800:hover {
  --text-opacity: 1;
  color: #05505c;
  color: rgba(5, 80, 92, var(--text-opacity));
}
.hover\\:text-teal-900:hover {
  --text-opacity: 1;
  color: #014451;
  color: rgba(1, 68, 81, var(--text-opacity));
}
.hover\\:text-blue-50:hover {
  --text-opacity: 1;
  color: #ebf5ff;
  color: rgba(235, 245, 255, var(--text-opacity));
}
.hover\\:text-blue-100:hover {
  --text-opacity: 1;
  color: #e1effe;
  color: rgba(225, 239, 254, var(--text-opacity));
}
.hover\\:text-blue-200:hover {
  --text-opacity: 1;
  color: #c3ddfd;
  color: rgba(195, 221, 253, var(--text-opacity));
}
.hover\\:text-blue-300:hover {
  --text-opacity: 1;
  color: #a4cafe;
  color: rgba(164, 202, 254, var(--text-opacity));
}
.hover\\:text-blue-400:hover {
  --text-opacity: 1;
  color: #76a9fa;
  color: rgba(118, 169, 250, var(--text-opacity));
}
.hover\\:text-blue-500:hover {
  --text-opacity: 1;
  color: #3f83f8;
  color: rgba(63, 131, 248, var(--text-opacity));
}
.hover\\:text-blue-600:hover {
  --text-opacity: 1;
  color: #1c64f2;
  color: rgba(28, 100, 242, var(--text-opacity));
}
.hover\\:text-blue-700:hover {
  --text-opacity: 1;
  color: #1a56db;
  color: rgba(26, 86, 219, var(--text-opacity));
}
.hover\\:text-blue-800:hover {
  --text-opacity: 1;
  color: #1e429f;
  color: rgba(30, 66, 159, var(--text-opacity));
}
.hover\\:text-blue-900:hover {
  --text-opacity: 1;
  color: #233876;
  color: rgba(35, 56, 118, var(--text-opacity));
}
.hover\\:text-indigo-50:hover {
  --text-opacity: 1;
  color: #f0f5ff;
  color: rgba(240, 245, 255, var(--text-opacity));
}
.hover\\:text-indigo-100:hover {
  --text-opacity: 1;
  color: #e5edff;
  color: rgba(229, 237, 255, var(--text-opacity));
}
.hover\\:text-indigo-200:hover {
  --text-opacity: 1;
  color: #cddbfe;
  color: rgba(205, 219, 254, var(--text-opacity));
}
.hover\\:text-indigo-300:hover {
  --text-opacity: 1;
  color: #b4c6fc;
  color: rgba(180, 198, 252, var(--text-opacity));
}
.hover\\:text-indigo-400:hover {
  --text-opacity: 1;
  color: #8da2fb;
  color: rgba(141, 162, 251, var(--text-opacity));
}
.hover\\:text-indigo-500:hover {
  --text-opacity: 1;
  color: #6875f5;
  color: rgba(104, 117, 245, var(--text-opacity));
}
.hover\\:text-indigo-600:hover {
  --text-opacity: 1;
  color: #5850ec;
  color: rgba(88, 80, 236, var(--text-opacity));
}
.hover\\:text-indigo-700:hover {
  --text-opacity: 1;
  color: #5145cd;
  color: rgba(81, 69, 205, var(--text-opacity));
}
.hover\\:text-indigo-800:hover {
  --text-opacity: 1;
  color: #42389d;
  color: rgba(66, 56, 157, var(--text-opacity));
}
.hover\\:text-indigo-900:hover {
  --text-opacity: 1;
  color: #362f78;
  color: rgba(54, 47, 120, var(--text-opacity));
}
.hover\\:text-purple-50:hover {
  --text-opacity: 1;
  color: #f6f5ff;
  color: rgba(246, 245, 255, var(--text-opacity));
}
.hover\\:text-purple-100:hover {
  --text-opacity: 1;
  color: #edebfe;
  color: rgba(237, 235, 254, var(--text-opacity));
}
.hover\\:text-purple-200:hover {
  --text-opacity: 1;
  color: #dcd7fe;
  color: rgba(220, 215, 254, var(--text-opacity));
}
.hover\\:text-purple-300:hover {
  --text-opacity: 1;
  color: #cabffd;
  color: rgba(202, 191, 253, var(--text-opacity));
}
.hover\\:text-purple-400:hover {
  --text-opacity: 1;
  color: #ac94fa;
  color: rgba(172, 148, 250, var(--text-opacity));
}
.hover\\:text-purple-500:hover {
  --text-opacity: 1;
  color: #9061f9;
  color: rgba(144, 97, 249, var(--text-opacity));
}
.hover\\:text-purple-600:hover {
  --text-opacity: 1;
  color: #7e3af2;
  color: rgba(126, 58, 242, var(--text-opacity));
}
.hover\\:text-purple-700:hover {
  --text-opacity: 1;
  color: #6c2bd9;
  color: rgba(108, 43, 217, var(--text-opacity));
}
.hover\\:text-purple-800:hover {
  --text-opacity: 1;
  color: #5521b5;
  color: rgba(85, 33, 181, var(--text-opacity));
}
.hover\\:text-purple-900:hover {
  --text-opacity: 1;
  color: #4a1d96;
  color: rgba(74, 29, 150, var(--text-opacity));
}
.hover\\:text-pink-50:hover {
  --text-opacity: 1;
  color: #fdf2f8;
  color: rgba(253, 242, 248, var(--text-opacity));
}
.hover\\:text-pink-100:hover {
  --text-opacity: 1;
  color: #fce8f3;
  color: rgba(252, 232, 243, var(--text-opacity));
}
.hover\\:text-pink-200:hover {
  --text-opacity: 1;
  color: #fad1e8;
  color: rgba(250, 209, 232, var(--text-opacity));
}
.hover\\:text-pink-300:hover {
  --text-opacity: 1;
  color: #f8b4d9;
  color: rgba(248, 180, 217, var(--text-opacity));
}
.hover\\:text-pink-400:hover {
  --text-opacity: 1;
  color: #f17eb8;
  color: rgba(241, 126, 184, var(--text-opacity));
}
.hover\\:text-pink-500:hover {
  --text-opacity: 1;
  color: #e74694;
  color: rgba(231, 70, 148, var(--text-opacity));
}
.hover\\:text-pink-600:hover {
  --text-opacity: 1;
  color: #d61f69;
  color: rgba(214, 31, 105, var(--text-opacity));
}
.hover\\:text-pink-700:hover {
  --text-opacity: 1;
  color: #bf125d;
  color: rgba(191, 18, 93, var(--text-opacity));
}
.hover\\:text-pink-800:hover {
  --text-opacity: 1;
  color: #99154b;
  color: rgba(153, 21, 75, var(--text-opacity));
}
.hover\\:text-pink-900:hover {
  --text-opacity: 1;
  color: #751a3d;
  color: rgba(117, 26, 61, var(--text-opacity));
}
.hover\\:text-cool-gray-50:hover {
  --text-opacity: 1;
  color: #f8fafc;
  color: rgba(248, 250, 252, var(--text-opacity));
}
.hover\\:text-cool-gray-100:hover {
  --text-opacity: 1;
  color: #f1f5f9;
  color: rgba(241, 245, 249, var(--text-opacity));
}
.hover\\:text-cool-gray-200:hover {
  --text-opacity: 1;
  color: #e2e8f0;
  color: rgba(226, 232, 240, var(--text-opacity));
}
.hover\\:text-cool-gray-300:hover {
  --text-opacity: 1;
  color: #cfd8e3;
  color: rgba(207, 216, 227, var(--text-opacity));
}
.hover\\:text-cool-gray-400:hover {
  --text-opacity: 1;
  color: #97a6ba;
  color: rgba(151, 166, 186, var(--text-opacity));
}
.hover\\:text-cool-gray-500:hover {
  --text-opacity: 1;
  color: #64748b;
  color: rgba(100, 116, 139, var(--text-opacity));
}
.hover\\:text-cool-gray-600:hover {
  --text-opacity: 1;
  color: #475569;
  color: rgba(71, 85, 105, var(--text-opacity));
}
.hover\\:text-cool-gray-700:hover {
  --text-opacity: 1;
  color: #364152;
  color: rgba(54, 65, 82, var(--text-opacity));
}
.hover\\:text-cool-gray-800:hover {
  --text-opacity: 1;
  color: #27303f;
  color: rgba(39, 48, 63, var(--text-opacity));
}
.hover\\:text-cool-gray-900:hover {
  --text-opacity: 1;
  color: #1a202e;
  color: rgba(26, 32, 46, var(--text-opacity));
}
.focus-within\\:text-current:focus-within {
  color: currentColor;
}
.focus-within\\:text-transparent:focus-within {
  color: transparent;
}
.focus-within\\:text-white:focus-within {
  --text-opacity: 1;
  color: #ffffff;
  color: rgba(255, 255, 255, var(--text-opacity));
}
.focus-within\\:text-black:focus-within {
  --text-opacity: 1;
  color: #000000;
  color: rgba(0, 0, 0, var(--text-opacity));
}
.focus-within\\:text-gray-50:focus-within {
  --text-opacity: 1;
  color: #f9fafb;
  color: rgba(249, 250, 251, var(--text-opacity));
}
.focus-within\\:text-gray-100:focus-within {
  --text-opacity: 1;
  color: #f4f5f7;
  color: rgba(244, 245, 247, var(--text-opacity));
}
.focus-within\\:text-gray-200:focus-within {
  --text-opacity: 1;
  color: #e5e7eb;
  color: rgba(229, 231, 235, var(--text-opacity));
}
.focus-within\\:text-gray-300:focus-within {
  --text-opacity: 1;
  color: #d2d6dc;
  color: rgba(210, 214, 220, var(--text-opacity));
}
.focus-within\\:text-gray-400:focus-within {
  --text-opacity: 1;
  color: #9fa6b2;
  color: rgba(159, 166, 178, var(--text-opacity));
}
.focus-within\\:text-gray-500:focus-within {
  --text-opacity: 1;
  color: #6b7280;
  color: rgba(107, 114, 128, var(--text-opacity));
}
.focus-within\\:text-gray-600:focus-within {
  --text-opacity: 1;
  color: #4b5563;
  color: rgba(75, 85, 99, var(--text-opacity));
}
.focus-within\\:text-gray-700:focus-within {
  --text-opacity: 1;
  color: #374151;
  color: rgba(55, 65, 81, var(--text-opacity));
}
.focus-within\\:text-gray-800:focus-within {
  --text-opacity: 1;
  color: #252f3f;
  color: rgba(37, 47, 63, var(--text-opacity));
}
.focus-within\\:text-gray-900:focus-within {
  --text-opacity: 1;
  color: #161e2e;
  color: rgba(22, 30, 46, var(--text-opacity));
}
.focus-within\\:text-red-50:focus-within {
  --text-opacity: 1;
  color: #fdf2f2;
  color: rgba(253, 242, 242, var(--text-opacity));
}
.focus-within\\:text-red-100:focus-within {
  --text-opacity: 1;
  color: #fde8e8;
  color: rgba(253, 232, 232, var(--text-opacity));
}
.focus-within\\:text-red-200:focus-within {
  --text-opacity: 1;
  color: #fbd5d5;
  color: rgba(251, 213, 213, var(--text-opacity));
}
.focus-within\\:text-red-300:focus-within {
  --text-opacity: 1;
  color: #f8b4b4;
  color: rgba(248, 180, 180, var(--text-opacity));
}
.focus-within\\:text-red-400:focus-within {
  --text-opacity: 1;
  color: #f98080;
  color: rgba(249, 128, 128, var(--text-opacity));
}
.focus-within\\:text-red-500:focus-within {
  --text-opacity: 1;
  color: #f05252;
  color: rgba(240, 82, 82, var(--text-opacity));
}
.focus-within\\:text-red-600:focus-within {
  --text-opacity: 1;
  color: #e02424;
  color: rgba(224, 36, 36, var(--text-opacity));
}
.focus-within\\:text-red-700:focus-within {
  --text-opacity: 1;
  color: #c81e1e;
  color: rgba(200, 30, 30, var(--text-opacity));
}
.focus-within\\:text-red-800:focus-within {
  --text-opacity: 1;
  color: #9b1c1c;
  color: rgba(155, 28, 28, var(--text-opacity));
}
.focus-within\\:text-red-900:focus-within {
  --text-opacity: 1;
  color: #771d1d;
  color: rgba(119, 29, 29, var(--text-opacity));
}
.focus-within\\:text-orange-50:focus-within {
  --text-opacity: 1;
  color: #fff8f1;
  color: rgba(255, 248, 241, var(--text-opacity));
}
.focus-within\\:text-orange-100:focus-within {
  --text-opacity: 1;
  color: #feecdc;
  color: rgba(254, 236, 220, var(--text-opacity));
}
.focus-within\\:text-orange-200:focus-within {
  --text-opacity: 1;
  color: #fcd9bd;
  color: rgba(252, 217, 189, var(--text-opacity));
}
.focus-within\\:text-orange-300:focus-within {
  --text-opacity: 1;
  color: #fdba8c;
  color: rgba(253, 186, 140, var(--text-opacity));
}
.focus-within\\:text-orange-400:focus-within {
  --text-opacity: 1;
  color: #ff8a4c;
  color: rgba(255, 138, 76, var(--text-opacity));
}
.focus-within\\:text-orange-500:focus-within {
  --text-opacity: 1;
  color: #ff5a1f;
  color: rgba(255, 90, 31, var(--text-opacity));
}
.focus-within\\:text-orange-600:focus-within {
  --text-opacity: 1;
  color: #d03801;
  color: rgba(208, 56, 1, var(--text-opacity));
}
.focus-within\\:text-orange-700:focus-within {
  --text-opacity: 1;
  color: #b43403;
  color: rgba(180, 52, 3, var(--text-opacity));
}
.focus-within\\:text-orange-800:focus-within {
  --text-opacity: 1;
  color: #8a2c0d;
  color: rgba(138, 44, 13, var(--text-opacity));
}
.focus-within\\:text-orange-900:focus-within {
  --text-opacity: 1;
  color: #73230d;
  color: rgba(115, 35, 13, var(--text-opacity));
}
.focus-within\\:text-yellow-50:focus-within {
  --text-opacity: 1;
  color: #fdfdea;
  color: rgba(253, 253, 234, var(--text-opacity));
}
.focus-within\\:text-yellow-100:focus-within {
  --text-opacity: 1;
  color: #fdf6b2;
  color: rgba(253, 246, 178, var(--text-opacity));
}
.focus-within\\:text-yellow-200:focus-within {
  --text-opacity: 1;
  color: #fce96a;
  color: rgba(252, 233, 106, var(--text-opacity));
}
.focus-within\\:text-yellow-300:focus-within {
  --text-opacity: 1;
  color: #faca15;
  color: rgba(250, 202, 21, var(--text-opacity));
}
.focus-within\\:text-yellow-400:focus-within {
  --text-opacity: 1;
  color: #e3a008;
  color: rgba(227, 160, 8, var(--text-opacity));
}
.focus-within\\:text-yellow-500:focus-within {
  --text-opacity: 1;
  color: #c27803;
  color: rgba(194, 120, 3, var(--text-opacity));
}
.focus-within\\:text-yellow-600:focus-within {
  --text-opacity: 1;
  color: #9f580a;
  color: rgba(159, 88, 10, var(--text-opacity));
}
.focus-within\\:text-yellow-700:focus-within {
  --text-opacity: 1;
  color: #8e4b10;
  color: rgba(142, 75, 16, var(--text-opacity));
}
.focus-within\\:text-yellow-800:focus-within {
  --text-opacity: 1;
  color: #723b13;
  color: rgba(114, 59, 19, var(--text-opacity));
}
.focus-within\\:text-yellow-900:focus-within {
  --text-opacity: 1;
  color: #633112;
  color: rgba(99, 49, 18, var(--text-opacity));
}
.focus-within\\:text-green-50:focus-within {
  --text-opacity: 1;
  color: #f3faf7;
  color: rgba(243, 250, 247, var(--text-opacity));
}
.focus-within\\:text-green-100:focus-within {
  --text-opacity: 1;
  color: #def7ec;
  color: rgba(222, 247, 236, var(--text-opacity));
}
.focus-within\\:text-green-200:focus-within {
  --text-opacity: 1;
  color: #bcf0da;
  color: rgba(188, 240, 218, var(--text-opacity));
}
.focus-within\\:text-green-300:focus-within {
  --text-opacity: 1;
  color: #84e1bc;
  color: rgba(132, 225, 188, var(--text-opacity));
}
.focus-within\\:text-green-400:focus-within {
  --text-opacity: 1;
  color: #31c48d;
  color: rgba(49, 196, 141, var(--text-opacity));
}
.focus-within\\:text-green-500:focus-within {
  --text-opacity: 1;
  color: #0e9f6e;
  color: rgba(14, 159, 110, var(--text-opacity));
}
.focus-within\\:text-green-600:focus-within {
  --text-opacity: 1;
  color: #057a55;
  color: rgba(5, 122, 85, var(--text-opacity));
}
.focus-within\\:text-green-700:focus-within {
  --text-opacity: 1;
  color: #046c4e;
  color: rgba(4, 108, 78, var(--text-opacity));
}
.focus-within\\:text-green-800:focus-within {
  --text-opacity: 1;
  color: #03543f;
  color: rgba(3, 84, 63, var(--text-opacity));
}
.focus-within\\:text-green-900:focus-within {
  --text-opacity: 1;
  color: #014737;
  color: rgba(1, 71, 55, var(--text-opacity));
}
.focus-within\\:text-teal-50:focus-within {
  --text-opacity: 1;
  color: #edfafa;
  color: rgba(237, 250, 250, var(--text-opacity));
}
.focus-within\\:text-teal-100:focus-within {
  --text-opacity: 1;
  color: #d5f5f6;
  color: rgba(213, 245, 246, var(--text-opacity));
}
.focus-within\\:text-teal-200:focus-within {
  --text-opacity: 1;
  color: #afecef;
  color: rgba(175, 236, 239, var(--text-opacity));
}
.focus-within\\:text-teal-300:focus-within {
  --text-opacity: 1;
  color: #7edce2;
  color: rgba(126, 220, 226, var(--text-opacity));
}
.focus-within\\:text-teal-400:focus-within {
  --text-opacity: 1;
  color: #16bdca;
  color: rgba(22, 189, 202, var(--text-opacity));
}
.focus-within\\:text-teal-500:focus-within {
  --text-opacity: 1;
  color: #0694a2;
  color: rgba(6, 148, 162, var(--text-opacity));
}
.focus-within\\:text-teal-600:focus-within {
  --text-opacity: 1;
  color: #047481;
  color: rgba(4, 116, 129, var(--text-opacity));
}
.focus-within\\:text-teal-700:focus-within {
  --text-opacity: 1;
  color: #036672;
  color: rgba(3, 102, 114, var(--text-opacity));
}
.focus-within\\:text-teal-800:focus-within {
  --text-opacity: 1;
  color: #05505c;
  color: rgba(5, 80, 92, var(--text-opacity));
}
.focus-within\\:text-teal-900:focus-within {
  --text-opacity: 1;
  color: #014451;
  color: rgba(1, 68, 81, var(--text-opacity));
}
.focus-within\\:text-blue-50:focus-within {
  --text-opacity: 1;
  color: #ebf5ff;
  color: rgba(235, 245, 255, var(--text-opacity));
}
.focus-within\\:text-blue-100:focus-within {
  --text-opacity: 1;
  color: #e1effe;
  color: rgba(225, 239, 254, var(--text-opacity));
}
.focus-within\\:text-blue-200:focus-within {
  --text-opacity: 1;
  color: #c3ddfd;
  color: rgba(195, 221, 253, var(--text-opacity));
}
.focus-within\\:text-blue-300:focus-within {
  --text-opacity: 1;
  color: #a4cafe;
  color: rgba(164, 202, 254, var(--text-opacity));
}
.focus-within\\:text-blue-400:focus-within {
  --text-opacity: 1;
  color: #76a9fa;
  color: rgba(118, 169, 250, var(--text-opacity));
}
.focus-within\\:text-blue-500:focus-within {
  --text-opacity: 1;
  color: #3f83f8;
  color: rgba(63, 131, 248, var(--text-opacity));
}
.focus-within\\:text-blue-600:focus-within {
  --text-opacity: 1;
  color: #1c64f2;
  color: rgba(28, 100, 242, var(--text-opacity));
}
.focus-within\\:text-blue-700:focus-within {
  --text-opacity: 1;
  color: #1a56db;
  color: rgba(26, 86, 219, var(--text-opacity));
}
.focus-within\\:text-blue-800:focus-within {
  --text-opacity: 1;
  color: #1e429f;
  color: rgba(30, 66, 159, var(--text-opacity));
}
.focus-within\\:text-blue-900:focus-within {
  --text-opacity: 1;
  color: #233876;
  color: rgba(35, 56, 118, var(--text-opacity));
}
.focus-within\\:text-indigo-50:focus-within {
  --text-opacity: 1;
  color: #f0f5ff;
  color: rgba(240, 245, 255, var(--text-opacity));
}
.focus-within\\:text-indigo-100:focus-within {
  --text-opacity: 1;
  color: #e5edff;
  color: rgba(229, 237, 255, var(--text-opacity));
}
.focus-within\\:text-indigo-200:focus-within {
  --text-opacity: 1;
  color: #cddbfe;
  color: rgba(205, 219, 254, var(--text-opacity));
}
.focus-within\\:text-indigo-300:focus-within {
  --text-opacity: 1;
  color: #b4c6fc;
  color: rgba(180, 198, 252, var(--text-opacity));
}
.focus-within\\:text-indigo-400:focus-within {
  --text-opacity: 1;
  color: #8da2fb;
  color: rgba(141, 162, 251, var(--text-opacity));
}
.focus-within\\:text-indigo-500:focus-within {
  --text-opacity: 1;
  color: #6875f5;
  color: rgba(104, 117, 245, var(--text-opacity));
}
.focus-within\\:text-indigo-600:focus-within {
  --text-opacity: 1;
  color: #5850ec;
  color: rgba(88, 80, 236, var(--text-opacity));
}
.focus-within\\:text-indigo-700:focus-within {
  --text-opacity: 1;
  color: #5145cd;
  color: rgba(81, 69, 205, var(--text-opacity));
}
.focus-within\\:text-indigo-800:focus-within {
  --text-opacity: 1;
  color: #42389d;
  color: rgba(66, 56, 157, var(--text-opacity));
}
.focus-within\\:text-indigo-900:focus-within {
  --text-opacity: 1;
  color: #362f78;
  color: rgba(54, 47, 120, var(--text-opacity));
}
.focus-within\\:text-purple-50:focus-within {
  --text-opacity: 1;
  color: #f6f5ff;
  color: rgba(246, 245, 255, var(--text-opacity));
}
.focus-within\\:text-purple-100:focus-within {
  --text-opacity: 1;
  color: #edebfe;
  color: rgba(237, 235, 254, var(--text-opacity));
}
.focus-within\\:text-purple-200:focus-within {
  --text-opacity: 1;
  color: #dcd7fe;
  color: rgba(220, 215, 254, var(--text-opacity));
}
.focus-within\\:text-purple-300:focus-within {
  --text-opacity: 1;
  color: #cabffd;
  color: rgba(202, 191, 253, var(--text-opacity));
}
.focus-within\\:text-purple-400:focus-within {
  --text-opacity: 1;
  color: #ac94fa;
  color: rgba(172, 148, 250, var(--text-opacity));
}
.focus-within\\:text-purple-500:focus-within {
  --text-opacity: 1;
  color: #9061f9;
  color: rgba(144, 97, 249, var(--text-opacity));
}
.focus-within\\:text-purple-600:focus-within {
  --text-opacity: 1;
  color: #7e3af2;
  color: rgba(126, 58, 242, var(--text-opacity));
}
.focus-within\\:text-purple-700:focus-within {
  --text-opacity: 1;
  color: #6c2bd9;
  color: rgba(108, 43, 217, var(--text-opacity));
}
.focus-within\\:text-purple-800:focus-within {
  --text-opacity: 1;
  color: #5521b5;
  color: rgba(85, 33, 181, var(--text-opacity));
}
.focus-within\\:text-purple-900:focus-within {
  --text-opacity: 1;
  color: #4a1d96;
  color: rgba(74, 29, 150, var(--text-opacity));
}
.focus-within\\:text-pink-50:focus-within {
  --text-opacity: 1;
  color: #fdf2f8;
  color: rgba(253, 242, 248, var(--text-opacity));
}
.focus-within\\:text-pink-100:focus-within {
  --text-opacity: 1;
  color: #fce8f3;
  color: rgba(252, 232, 243, var(--text-opacity));
}
.focus-within\\:text-pink-200:focus-within {
  --text-opacity: 1;
  color: #fad1e8;
  color: rgba(250, 209, 232, var(--text-opacity));
}
.focus-within\\:text-pink-300:focus-within {
  --text-opacity: 1;
  color: #f8b4d9;
  color: rgba(248, 180, 217, var(--text-opacity));
}
.focus-within\\:text-pink-400:focus-within {
  --text-opacity: 1;
  color: #f17eb8;
  color: rgba(241, 126, 184, var(--text-opacity));
}
.focus-within\\:text-pink-500:focus-within {
  --text-opacity: 1;
  color: #e74694;
  color: rgba(231, 70, 148, var(--text-opacity));
}
.focus-within\\:text-pink-600:focus-within {
  --text-opacity: 1;
  color: #d61f69;
  color: rgba(214, 31, 105, var(--text-opacity));
}
.focus-within\\:text-pink-700:focus-within {
  --text-opacity: 1;
  color: #bf125d;
  color: rgba(191, 18, 93, var(--text-opacity));
}
.focus-within\\:text-pink-800:focus-within {
  --text-opacity: 1;
  color: #99154b;
  color: rgba(153, 21, 75, var(--text-opacity));
}
.focus-within\\:text-pink-900:focus-within {
  --text-opacity: 1;
  color: #751a3d;
  color: rgba(117, 26, 61, var(--text-opacity));
}
.focus-within\\:text-cool-gray-50:focus-within {
  --text-opacity: 1;
  color: #f8fafc;
  color: rgba(248, 250, 252, var(--text-opacity));
}
.focus-within\\:text-cool-gray-100:focus-within {
  --text-opacity: 1;
  color: #f1f5f9;
  color: rgba(241, 245, 249, var(--text-opacity));
}
.focus-within\\:text-cool-gray-200:focus-within {
  --text-opacity: 1;
  color: #e2e8f0;
  color: rgba(226, 232, 240, var(--text-opacity));
}
.focus-within\\:text-cool-gray-300:focus-within {
  --text-opacity: 1;
  color: #cfd8e3;
  color: rgba(207, 216, 227, var(--text-opacity));
}
.focus-within\\:text-cool-gray-400:focus-within {
  --text-opacity: 1;
  color: #97a6ba;
  color: rgba(151, 166, 186, var(--text-opacity));
}
.focus-within\\:text-cool-gray-500:focus-within {
  --text-opacity: 1;
  color: #64748b;
  color: rgba(100, 116, 139, var(--text-opacity));
}
.focus-within\\:text-cool-gray-600:focus-within {
  --text-opacity: 1;
  color: #475569;
  color: rgba(71, 85, 105, var(--text-opacity));
}
.focus-within\\:text-cool-gray-700:focus-within {
  --text-opacity: 1;
  color: #364152;
  color: rgba(54, 65, 82, var(--text-opacity));
}
.focus-within\\:text-cool-gray-800:focus-within {
  --text-opacity: 1;
  color: #27303f;
  color: rgba(39, 48, 63, var(--text-opacity));
}
.focus-within\\:text-cool-gray-900:focus-within {
  --text-opacity: 1;
  color: #1a202e;
  color: rgba(26, 32, 46, var(--text-opacity));
}
.focus\\:text-current:focus {
  color: currentColor;
}
.focus\\:text-transparent:focus {
  color: transparent;
}
.focus\\:text-white:focus {
  --text-opacity: 1;
  color: #ffffff;
  color: rgba(255, 255, 255, var(--text-opacity));
}
.focus\\:text-black:focus {
  --text-opacity: 1;
  color: #000000;
  color: rgba(0, 0, 0, var(--text-opacity));
}
.focus\\:text-gray-50:focus {
  --text-opacity: 1;
  color: #f9fafb;
  color: rgba(249, 250, 251, var(--text-opacity));
}
.focus\\:text-gray-100:focus {
  --text-opacity: 1;
  color: #f4f5f7;
  color: rgba(244, 245, 247, var(--text-opacity));
}
.focus\\:text-gray-200:focus {
  --text-opacity: 1;
  color: #e5e7eb;
  color: rgba(229, 231, 235, var(--text-opacity));
}
.focus\\:text-gray-300:focus {
  --text-opacity: 1;
  color: #d2d6dc;
  color: rgba(210, 214, 220, var(--text-opacity));
}
.focus\\:text-gray-400:focus {
  --text-opacity: 1;
  color: #9fa6b2;
  color: rgba(159, 166, 178, var(--text-opacity));
}
.focus\\:text-gray-500:focus {
  --text-opacity: 1;
  color: #6b7280;
  color: rgba(107, 114, 128, var(--text-opacity));
}
.focus\\:text-gray-600:focus {
  --text-opacity: 1;
  color: #4b5563;
  color: rgba(75, 85, 99, var(--text-opacity));
}
.focus\\:text-gray-700:focus {
  --text-opacity: 1;
  color: #374151;
  color: rgba(55, 65, 81, var(--text-opacity));
}
.focus\\:text-gray-800:focus {
  --text-opacity: 1;
  color: #252f3f;
  color: rgba(37, 47, 63, var(--text-opacity));
}
.focus\\:text-gray-900:focus {
  --text-opacity: 1;
  color: #161e2e;
  color: rgba(22, 30, 46, var(--text-opacity));
}
.focus\\:text-red-50:focus {
  --text-opacity: 1;
  color: #fdf2f2;
  color: rgba(253, 242, 242, var(--text-opacity));
}
.focus\\:text-red-100:focus {
  --text-opacity: 1;
  color: #fde8e8;
  color: rgba(253, 232, 232, var(--text-opacity));
}
.focus\\:text-red-200:focus {
  --text-opacity: 1;
  color: #fbd5d5;
  color: rgba(251, 213, 213, var(--text-opacity));
}
.focus\\:text-red-300:focus {
  --text-opacity: 1;
  color: #f8b4b4;
  color: rgba(248, 180, 180, var(--text-opacity));
}
.focus\\:text-red-400:focus {
  --text-opacity: 1;
  color: #f98080;
  color: rgba(249, 128, 128, var(--text-opacity));
}
.focus\\:text-red-500:focus {
  --text-opacity: 1;
  color: #f05252;
  color: rgba(240, 82, 82, var(--text-opacity));
}
.focus\\:text-red-600:focus {
  --text-opacity: 1;
  color: #e02424;
  color: rgba(224, 36, 36, var(--text-opacity));
}
.focus\\:text-red-700:focus {
  --text-opacity: 1;
  color: #c81e1e;
  color: rgba(200, 30, 30, var(--text-opacity));
}
.focus\\:text-red-800:focus {
  --text-opacity: 1;
  color: #9b1c1c;
  color: rgba(155, 28, 28, var(--text-opacity));
}
.focus\\:text-red-900:focus {
  --text-opacity: 1;
  color: #771d1d;
  color: rgba(119, 29, 29, var(--text-opacity));
}
.focus\\:text-orange-50:focus {
  --text-opacity: 1;
  color: #fff8f1;
  color: rgba(255, 248, 241, var(--text-opacity));
}
.focus\\:text-orange-100:focus {
  --text-opacity: 1;
  color: #feecdc;
  color: rgba(254, 236, 220, var(--text-opacity));
}
.focus\\:text-orange-200:focus {
  --text-opacity: 1;
  color: #fcd9bd;
  color: rgba(252, 217, 189, var(--text-opacity));
}
.focus\\:text-orange-300:focus {
  --text-opacity: 1;
  color: #fdba8c;
  color: rgba(253, 186, 140, var(--text-opacity));
}
.focus\\:text-orange-400:focus {
  --text-opacity: 1;
  color: #ff8a4c;
  color: rgba(255, 138, 76, var(--text-opacity));
}
.focus\\:text-orange-500:focus {
  --text-opacity: 1;
  color: #ff5a1f;
  color: rgba(255, 90, 31, var(--text-opacity));
}
.focus\\:text-orange-600:focus {
  --text-opacity: 1;
  color: #d03801;
  color: rgba(208, 56, 1, var(--text-opacity));
}
.focus\\:text-orange-700:focus {
  --text-opacity: 1;
  color: #b43403;
  color: rgba(180, 52, 3, var(--text-opacity));
}
.focus\\:text-orange-800:focus {
  --text-opacity: 1;
  color: #8a2c0d;
  color: rgba(138, 44, 13, var(--text-opacity));
}
.focus\\:text-orange-900:focus {
  --text-opacity: 1;
  color: #73230d;
  color: rgba(115, 35, 13, var(--text-opacity));
}
.focus\\:text-yellow-50:focus {
  --text-opacity: 1;
  color: #fdfdea;
  color: rgba(253, 253, 234, var(--text-opacity));
}
.focus\\:text-yellow-100:focus {
  --text-opacity: 1;
  color: #fdf6b2;
  color: rgba(253, 246, 178, var(--text-opacity));
}
.focus\\:text-yellow-200:focus {
  --text-opacity: 1;
  color: #fce96a;
  color: rgba(252, 233, 106, var(--text-opacity));
}
.focus\\:text-yellow-300:focus {
  --text-opacity: 1;
  color: #faca15;
  color: rgba(250, 202, 21, var(--text-opacity));
}
.focus\\:text-yellow-400:focus {
  --text-opacity: 1;
  color: #e3a008;
  color: rgba(227, 160, 8, var(--text-opacity));
}
.focus\\:text-yellow-500:focus {
  --text-opacity: 1;
  color: #c27803;
  color: rgba(194, 120, 3, var(--text-opacity));
}
.focus\\:text-yellow-600:focus {
  --text-opacity: 1;
  color: #9f580a;
  color: rgba(159, 88, 10, var(--text-opacity));
}
.focus\\:text-yellow-700:focus {
  --text-opacity: 1;
  color: #8e4b10;
  color: rgba(142, 75, 16, var(--text-opacity));
}
.focus\\:text-yellow-800:focus {
  --text-opacity: 1;
  color: #723b13;
  color: rgba(114, 59, 19, var(--text-opacity));
}
.focus\\:text-yellow-900:focus {
  --text-opacity: 1;
  color: #633112;
  color: rgba(99, 49, 18, var(--text-opacity));
}
.focus\\:text-green-50:focus {
  --text-opacity: 1;
  color: #f3faf7;
  color: rgba(243, 250, 247, var(--text-opacity));
}
.focus\\:text-green-100:focus {
  --text-opacity: 1;
  color: #def7ec;
  color: rgba(222, 247, 236, var(--text-opacity));
}
.focus\\:text-green-200:focus {
  --text-opacity: 1;
  color: #bcf0da;
  color: rgba(188, 240, 218, var(--text-opacity));
}
.focus\\:text-green-300:focus {
  --text-opacity: 1;
  color: #84e1bc;
  color: rgba(132, 225, 188, var(--text-opacity));
}
.focus\\:text-green-400:focus {
  --text-opacity: 1;
  color: #31c48d;
  color: rgba(49, 196, 141, var(--text-opacity));
}
.focus\\:text-green-500:focus {
  --text-opacity: 1;
  color: #0e9f6e;
  color: rgba(14, 159, 110, var(--text-opacity));
}
.focus\\:text-green-600:focus {
  --text-opacity: 1;
  color: #057a55;
  color: rgba(5, 122, 85, var(--text-opacity));
}
.focus\\:text-green-700:focus {
  --text-opacity: 1;
  color: #046c4e;
  color: rgba(4, 108, 78, var(--text-opacity));
}
.focus\\:text-green-800:focus {
  --text-opacity: 1;
  color: #03543f;
  color: rgba(3, 84, 63, var(--text-opacity));
}
.focus\\:text-green-900:focus {
  --text-opacity: 1;
  color: #014737;
  color: rgba(1, 71, 55, var(--text-opacity));
}
.focus\\:text-teal-50:focus {
  --text-opacity: 1;
  color: #edfafa;
  color: rgba(237, 250, 250, var(--text-opacity));
}
.focus\\:text-teal-100:focus {
  --text-opacity: 1;
  color: #d5f5f6;
  color: rgba(213, 245, 246, var(--text-opacity));
}
.focus\\:text-teal-200:focus {
  --text-opacity: 1;
  color: #afecef;
  color: rgba(175, 236, 239, var(--text-opacity));
}
.focus\\:text-teal-300:focus {
  --text-opacity: 1;
  color: #7edce2;
  color: rgba(126, 220, 226, var(--text-opacity));
}
.focus\\:text-teal-400:focus {
  --text-opacity: 1;
  color: #16bdca;
  color: rgba(22, 189, 202, var(--text-opacity));
}
.focus\\:text-teal-500:focus {
  --text-opacity: 1;
  color: #0694a2;
  color: rgba(6, 148, 162, var(--text-opacity));
}
.focus\\:text-teal-600:focus {
  --text-opacity: 1;
  color: #047481;
  color: rgba(4, 116, 129, var(--text-opacity));
}
.focus\\:text-teal-700:focus {
  --text-opacity: 1;
  color: #036672;
  color: rgba(3, 102, 114, var(--text-opacity));
}
.focus\\:text-teal-800:focus {
  --text-opacity: 1;
  color: #05505c;
  color: rgba(5, 80, 92, var(--text-opacity));
}
.focus\\:text-teal-900:focus {
  --text-opacity: 1;
  color: #014451;
  color: rgba(1, 68, 81, var(--text-opacity));
}
.focus\\:text-blue-50:focus {
  --text-opacity: 1;
  color: #ebf5ff;
  color: rgba(235, 245, 255, var(--text-opacity));
}
.focus\\:text-blue-100:focus {
  --text-opacity: 1;
  color: #e1effe;
  color: rgba(225, 239, 254, var(--text-opacity));
}
.focus\\:text-blue-200:focus {
  --text-opacity: 1;
  color: #c3ddfd;
  color: rgba(195, 221, 253, var(--text-opacity));
}
.focus\\:text-blue-300:focus {
  --text-opacity: 1;
  color: #a4cafe;
  color: rgba(164, 202, 254, var(--text-opacity));
}
.focus\\:text-blue-400:focus {
  --text-opacity: 1;
  color: #76a9fa;
  color: rgba(118, 169, 250, var(--text-opacity));
}
.focus\\:text-blue-500:focus {
  --text-opacity: 1;
  color: #3f83f8;
  color: rgba(63, 131, 248, var(--text-opacity));
}
.focus\\:text-blue-600:focus {
  --text-opacity: 1;
  color: #1c64f2;
  color: rgba(28, 100, 242, var(--text-opacity));
}
.focus\\:text-blue-700:focus {
  --text-opacity: 1;
  color: #1a56db;
  color: rgba(26, 86, 219, var(--text-opacity));
}
.focus\\:text-blue-800:focus {
  --text-opacity: 1;
  color: #1e429f;
  color: rgba(30, 66, 159, var(--text-opacity));
}
.focus\\:text-blue-900:focus {
  --text-opacity: 1;
  color: #233876;
  color: rgba(35, 56, 118, var(--text-opacity));
}
.focus\\:text-indigo-50:focus {
  --text-opacity: 1;
  color: #f0f5ff;
  color: rgba(240, 245, 255, var(--text-opacity));
}
.focus\\:text-indigo-100:focus {
  --text-opacity: 1;
  color: #e5edff;
  color: rgba(229, 237, 255, var(--text-opacity));
}
.focus\\:text-indigo-200:focus {
  --text-opacity: 1;
  color: #cddbfe;
  color: rgba(205, 219, 254, var(--text-opacity));
}
.focus\\:text-indigo-300:focus {
  --text-opacity: 1;
  color: #b4c6fc;
  color: rgba(180, 198, 252, var(--text-opacity));
}
.focus\\:text-indigo-400:focus {
  --text-opacity: 1;
  color: #8da2fb;
  color: rgba(141, 162, 251, var(--text-opacity));
}
.focus\\:text-indigo-500:focus {
  --text-opacity: 1;
  color: #6875f5;
  color: rgba(104, 117, 245, var(--text-opacity));
}
.focus\\:text-indigo-600:focus {
  --text-opacity: 1;
  color: #5850ec;
  color: rgba(88, 80, 236, var(--text-opacity));
}
.focus\\:text-indigo-700:focus {
  --text-opacity: 1;
  color: #5145cd;
  color: rgba(81, 69, 205, var(--text-opacity));
}
.focus\\:text-indigo-800:focus {
  --text-opacity: 1;
  color: #42389d;
  color: rgba(66, 56, 157, var(--text-opacity));
}
.focus\\:text-indigo-900:focus {
  --text-opacity: 1;
  color: #362f78;
  color: rgba(54, 47, 120, var(--text-opacity));
}
.focus\\:text-purple-50:focus {
  --text-opacity: 1;
  color: #f6f5ff;
  color: rgba(246, 245, 255, var(--text-opacity));
}
.focus\\:text-purple-100:focus {
  --text-opacity: 1;
  color: #edebfe;
  color: rgba(237, 235, 254, var(--text-opacity));
}
.focus\\:text-purple-200:focus {
  --text-opacity: 1;
  color: #dcd7fe;
  color: rgba(220, 215, 254, var(--text-opacity));
}
.focus\\:text-purple-300:focus {
  --text-opacity: 1;
  color: #cabffd;
  color: rgba(202, 191, 253, var(--text-opacity));
}
.focus\\:text-purple-400:focus {
  --text-opacity: 1;
  color: #ac94fa;
  color: rgba(172, 148, 250, var(--text-opacity));
}
.focus\\:text-purple-500:focus {
  --text-opacity: 1;
  color: #9061f9;
  color: rgba(144, 97, 249, var(--text-opacity));
}
.focus\\:text-purple-600:focus {
  --text-opacity: 1;
  color: #7e3af2;
  color: rgba(126, 58, 242, var(--text-opacity));
}
.focus\\:text-purple-700:focus {
  --text-opacity: 1;
  color: #6c2bd9;
  color: rgba(108, 43, 217, var(--text-opacity));
}
.focus\\:text-purple-800:focus {
  --text-opacity: 1;
  color: #5521b5;
  color: rgba(85, 33, 181, var(--text-opacity));
}
.focus\\:text-purple-900:focus {
  --text-opacity: 1;
  color: #4a1d96;
  color: rgba(74, 29, 150, var(--text-opacity));
}
.focus\\:text-pink-50:focus {
  --text-opacity: 1;
  color: #fdf2f8;
  color: rgba(253, 242, 248, var(--text-opacity));
}
.focus\\:text-pink-100:focus {
  --text-opacity: 1;
  color: #fce8f3;
  color: rgba(252, 232, 243, var(--text-opacity));
}
.focus\\:text-pink-200:focus {
  --text-opacity: 1;
  color: #fad1e8;
  color: rgba(250, 209, 232, var(--text-opacity));
}
.focus\\:text-pink-300:focus {
  --text-opacity: 1;
  color: #f8b4d9;
  color: rgba(248, 180, 217, var(--text-opacity));
}
.focus\\:text-pink-400:focus {
  --text-opacity: 1;
  color: #f17eb8;
  color: rgba(241, 126, 184, var(--text-opacity));
}
.focus\\:text-pink-500:focus {
  --text-opacity: 1;
  color: #e74694;
  color: rgba(231, 70, 148, var(--text-opacity));
}
.focus\\:text-pink-600:focus {
  --text-opacity: 1;
  color: #d61f69;
  color: rgba(214, 31, 105, var(--text-opacity));
}
.focus\\:text-pink-700:focus {
  --text-opacity: 1;
  color: #bf125d;
  color: rgba(191, 18, 93, var(--text-opacity));
}
.focus\\:text-pink-800:focus {
  --text-opacity: 1;
  color: #99154b;
  color: rgba(153, 21, 75, var(--text-opacity));
}
.focus\\:text-pink-900:focus {
  --text-opacity: 1;
  color: #751a3d;
  color: rgba(117, 26, 61, var(--text-opacity));
}
.focus\\:text-cool-gray-50:focus {
  --text-opacity: 1;
  color: #f8fafc;
  color: rgba(248, 250, 252, var(--text-opacity));
}
.focus\\:text-cool-gray-100:focus {
  --text-opacity: 1;
  color: #f1f5f9;
  color: rgba(241, 245, 249, var(--text-opacity));
}
.focus\\:text-cool-gray-200:focus {
  --text-opacity: 1;
  color: #e2e8f0;
  color: rgba(226, 232, 240, var(--text-opacity));
}
.focus\\:text-cool-gray-300:focus {
  --text-opacity: 1;
  color: #cfd8e3;
  color: rgba(207, 216, 227, var(--text-opacity));
}
.focus\\:text-cool-gray-400:focus {
  --text-opacity: 1;
  color: #97a6ba;
  color: rgba(151, 166, 186, var(--text-opacity));
}
.focus\\:text-cool-gray-500:focus {
  --text-opacity: 1;
  color: #64748b;
  color: rgba(100, 116, 139, var(--text-opacity));
}
.focus\\:text-cool-gray-600:focus {
  --text-opacity: 1;
  color: #475569;
  color: rgba(71, 85, 105, var(--text-opacity));
}
.focus\\:text-cool-gray-700:focus {
  --text-opacity: 1;
  color: #364152;
  color: rgba(54, 65, 82, var(--text-opacity));
}
.focus\\:text-cool-gray-800:focus {
  --text-opacity: 1;
  color: #27303f;
  color: rgba(39, 48, 63, var(--text-opacity));
}
.focus\\:text-cool-gray-900:focus {
  --text-opacity: 1;
  color: #1a202e;
  color: rgba(26, 32, 46, var(--text-opacity));
}
.active\\:text-current:active {
  color: currentColor;
}
.active\\:text-transparent:active {
  color: transparent;
}
.active\\:text-white:active {
  --text-opacity: 1;
  color: #ffffff;
  color: rgba(255, 255, 255, var(--text-opacity));
}
.active\\:text-black:active {
  --text-opacity: 1;
  color: #000000;
  color: rgba(0, 0, 0, var(--text-opacity));
}
.active\\:text-gray-50:active {
  --text-opacity: 1;
  color: #f9fafb;
  color: rgba(249, 250, 251, var(--text-opacity));
}
.active\\:text-gray-100:active {
  --text-opacity: 1;
  color: #f4f5f7;
  color: rgba(244, 245, 247, var(--text-opacity));
}
.active\\:text-gray-200:active {
  --text-opacity: 1;
  color: #e5e7eb;
  color: rgba(229, 231, 235, var(--text-opacity));
}
.active\\:text-gray-300:active {
  --text-opacity: 1;
  color: #d2d6dc;
  color: rgba(210, 214, 220, var(--text-opacity));
}
.active\\:text-gray-400:active {
  --text-opacity: 1;
  color: #9fa6b2;
  color: rgba(159, 166, 178, var(--text-opacity));
}
.active\\:text-gray-500:active {
  --text-opacity: 1;
  color: #6b7280;
  color: rgba(107, 114, 128, var(--text-opacity));
}
.active\\:text-gray-600:active {
  --text-opacity: 1;
  color: #4b5563;
  color: rgba(75, 85, 99, var(--text-opacity));
}
.active\\:text-gray-700:active {
  --text-opacity: 1;
  color: #374151;
  color: rgba(55, 65, 81, var(--text-opacity));
}
.active\\:text-gray-800:active {
  --text-opacity: 1;
  color: #252f3f;
  color: rgba(37, 47, 63, var(--text-opacity));
}
.active\\:text-gray-900:active {
  --text-opacity: 1;
  color: #161e2e;
  color: rgba(22, 30, 46, var(--text-opacity));
}
.active\\:text-red-50:active {
  --text-opacity: 1;
  color: #fdf2f2;
  color: rgba(253, 242, 242, var(--text-opacity));
}
.active\\:text-red-100:active {
  --text-opacity: 1;
  color: #fde8e8;
  color: rgba(253, 232, 232, var(--text-opacity));
}
.active\\:text-red-200:active {
  --text-opacity: 1;
  color: #fbd5d5;
  color: rgba(251, 213, 213, var(--text-opacity));
}
.active\\:text-red-300:active {
  --text-opacity: 1;
  color: #f8b4b4;
  color: rgba(248, 180, 180, var(--text-opacity));
}
.active\\:text-red-400:active {
  --text-opacity: 1;
  color: #f98080;
  color: rgba(249, 128, 128, var(--text-opacity));
}
.active\\:text-red-500:active {
  --text-opacity: 1;
  color: #f05252;
  color: rgba(240, 82, 82, var(--text-opacity));
}
.active\\:text-red-600:active {
  --text-opacity: 1;
  color: #e02424;
  color: rgba(224, 36, 36, var(--text-opacity));
}
.active\\:text-red-700:active {
  --text-opacity: 1;
  color: #c81e1e;
  color: rgba(200, 30, 30, var(--text-opacity));
}
.active\\:text-red-800:active {
  --text-opacity: 1;
  color: #9b1c1c;
  color: rgba(155, 28, 28, var(--text-opacity));
}
.active\\:text-red-900:active {
  --text-opacity: 1;
  color: #771d1d;
  color: rgba(119, 29, 29, var(--text-opacity));
}
.active\\:text-orange-50:active {
  --text-opacity: 1;
  color: #fff8f1;
  color: rgba(255, 248, 241, var(--text-opacity));
}
.active\\:text-orange-100:active {
  --text-opacity: 1;
  color: #feecdc;
  color: rgba(254, 236, 220, var(--text-opacity));
}
.active\\:text-orange-200:active {
  --text-opacity: 1;
  color: #fcd9bd;
  color: rgba(252, 217, 189, var(--text-opacity));
}
.active\\:text-orange-300:active {
  --text-opacity: 1;
  color: #fdba8c;
  color: rgba(253, 186, 140, var(--text-opacity));
}
.active\\:text-orange-400:active {
  --text-opacity: 1;
  color: #ff8a4c;
  color: rgba(255, 138, 76, var(--text-opacity));
}
.active\\:text-orange-500:active {
  --text-opacity: 1;
  color: #ff5a1f;
  color: rgba(255, 90, 31, var(--text-opacity));
}
.active\\:text-orange-600:active {
  --text-opacity: 1;
  color: #d03801;
  color: rgba(208, 56, 1, var(--text-opacity));
}
.active\\:text-orange-700:active {
  --text-opacity: 1;
  color: #b43403;
  color: rgba(180, 52, 3, var(--text-opacity));
}
.active\\:text-orange-800:active {
  --text-opacity: 1;
  color: #8a2c0d;
  color: rgba(138, 44, 13, var(--text-opacity));
}
.active\\:text-orange-900:active {
  --text-opacity: 1;
  color: #73230d;
  color: rgba(115, 35, 13, var(--text-opacity));
}
.active\\:text-yellow-50:active {
  --text-opacity: 1;
  color: #fdfdea;
  color: rgba(253, 253, 234, var(--text-opacity));
}
.active\\:text-yellow-100:active {
  --text-opacity: 1;
  color: #fdf6b2;
  color: rgba(253, 246, 178, var(--text-opacity));
}
.active\\:text-yellow-200:active {
  --text-opacity: 1;
  color: #fce96a;
  color: rgba(252, 233, 106, var(--text-opacity));
}
.active\\:text-yellow-300:active {
  --text-opacity: 1;
  color: #faca15;
  color: rgba(250, 202, 21, var(--text-opacity));
}
.active\\:text-yellow-400:active {
  --text-opacity: 1;
  color: #e3a008;
  color: rgba(227, 160, 8, var(--text-opacity));
}
.active\\:text-yellow-500:active {
  --text-opacity: 1;
  color: #c27803;
  color: rgba(194, 120, 3, var(--text-opacity));
}
.active\\:text-yellow-600:active {
  --text-opacity: 1;
  color: #9f580a;
  color: rgba(159, 88, 10, var(--text-opacity));
}
.active\\:text-yellow-700:active {
  --text-opacity: 1;
  color: #8e4b10;
  color: rgba(142, 75, 16, var(--text-opacity));
}
.active\\:text-yellow-800:active {
  --text-opacity: 1;
  color: #723b13;
  color: rgba(114, 59, 19, var(--text-opacity));
}
.active\\:text-yellow-900:active {
  --text-opacity: 1;
  color: #633112;
  color: rgba(99, 49, 18, var(--text-opacity));
}
.active\\:text-green-50:active {
  --text-opacity: 1;
  color: #f3faf7;
  color: rgba(243, 250, 247, var(--text-opacity));
}
.active\\:text-green-100:active {
  --text-opacity: 1;
  color: #def7ec;
  color: rgba(222, 247, 236, var(--text-opacity));
}
.active\\:text-green-200:active {
  --text-opacity: 1;
  color: #bcf0da;
  color: rgba(188, 240, 218, var(--text-opacity));
}
.active\\:text-green-300:active {
  --text-opacity: 1;
  color: #84e1bc;
  color: rgba(132, 225, 188, var(--text-opacity));
}
.active\\:text-green-400:active {
  --text-opacity: 1;
  color: #31c48d;
  color: rgba(49, 196, 141, var(--text-opacity));
}
.active\\:text-green-500:active {
  --text-opacity: 1;
  color: #0e9f6e;
  color: rgba(14, 159, 110, var(--text-opacity));
}
.active\\:text-green-600:active {
  --text-opacity: 1;
  color: #057a55;
  color: rgba(5, 122, 85, var(--text-opacity));
}
.active\\:text-green-700:active {
  --text-opacity: 1;
  color: #046c4e;
  color: rgba(4, 108, 78, var(--text-opacity));
}
.active\\:text-green-800:active {
  --text-opacity: 1;
  color: #03543f;
  color: rgba(3, 84, 63, var(--text-opacity));
}
.active\\:text-green-900:active {
  --text-opacity: 1;
  color: #014737;
  color: rgba(1, 71, 55, var(--text-opacity));
}
.active\\:text-teal-50:active {
  --text-opacity: 1;
  color: #edfafa;
  color: rgba(237, 250, 250, var(--text-opacity));
}
.active\\:text-teal-100:active {
  --text-opacity: 1;
  color: #d5f5f6;
  color: rgba(213, 245, 246, var(--text-opacity));
}
.active\\:text-teal-200:active {
  --text-opacity: 1;
  color: #afecef;
  color: rgba(175, 236, 239, var(--text-opacity));
}
.active\\:text-teal-300:active {
  --text-opacity: 1;
  color: #7edce2;
  color: rgba(126, 220, 226, var(--text-opacity));
}
.active\\:text-teal-400:active {
  --text-opacity: 1;
  color: #16bdca;
  color: rgba(22, 189, 202, var(--text-opacity));
}
.active\\:text-teal-500:active {
  --text-opacity: 1;
  color: #0694a2;
  color: rgba(6, 148, 162, var(--text-opacity));
}
.active\\:text-teal-600:active {
  --text-opacity: 1;
  color: #047481;
  color: rgba(4, 116, 129, var(--text-opacity));
}
.active\\:text-teal-700:active {
  --text-opacity: 1;
  color: #036672;
  color: rgba(3, 102, 114, var(--text-opacity));
}
.active\\:text-teal-800:active {
  --text-opacity: 1;
  color: #05505c;
  color: rgba(5, 80, 92, var(--text-opacity));
}
.active\\:text-teal-900:active {
  --text-opacity: 1;
  color: #014451;
  color: rgba(1, 68, 81, var(--text-opacity));
}
.active\\:text-blue-50:active {
  --text-opacity: 1;
  color: #ebf5ff;
  color: rgba(235, 245, 255, var(--text-opacity));
}
.active\\:text-blue-100:active {
  --text-opacity: 1;
  color: #e1effe;
  color: rgba(225, 239, 254, var(--text-opacity));
}
.active\\:text-blue-200:active {
  --text-opacity: 1;
  color: #c3ddfd;
  color: rgba(195, 221, 253, var(--text-opacity));
}
.active\\:text-blue-300:active {
  --text-opacity: 1;
  color: #a4cafe;
  color: rgba(164, 202, 254, var(--text-opacity));
}
.active\\:text-blue-400:active {
  --text-opacity: 1;
  color: #76a9fa;
  color: rgba(118, 169, 250, var(--text-opacity));
}
.active\\:text-blue-500:active {
  --text-opacity: 1;
  color: #3f83f8;
  color: rgba(63, 131, 248, var(--text-opacity));
}
.active\\:text-blue-600:active {
  --text-opacity: 1;
  color: #1c64f2;
  color: rgba(28, 100, 242, var(--text-opacity));
}
.active\\:text-blue-700:active {
  --text-opacity: 1;
  color: #1a56db;
  color: rgba(26, 86, 219, var(--text-opacity));
}
.active\\:text-blue-800:active {
  --text-opacity: 1;
  color: #1e429f;
  color: rgba(30, 66, 159, var(--text-opacity));
}
.active\\:text-blue-900:active {
  --text-opacity: 1;
  color: #233876;
  color: rgba(35, 56, 118, var(--text-opacity));
}
.active\\:text-indigo-50:active {
  --text-opacity: 1;
  color: #f0f5ff;
  color: rgba(240, 245, 255, var(--text-opacity));
}
.active\\:text-indigo-100:active {
  --text-opacity: 1;
  color: #e5edff;
  color: rgba(229, 237, 255, var(--text-opacity));
}
.active\\:text-indigo-200:active {
  --text-opacity: 1;
  color: #cddbfe;
  color: rgba(205, 219, 254, var(--text-opacity));
}
.active\\:text-indigo-300:active {
  --text-opacity: 1;
  color: #b4c6fc;
  color: rgba(180, 198, 252, var(--text-opacity));
}
.active\\:text-indigo-400:active {
  --text-opacity: 1;
  color: #8da2fb;
  color: rgba(141, 162, 251, var(--text-opacity));
}
.active\\:text-indigo-500:active {
  --text-opacity: 1;
  color: #6875f5;
  color: rgba(104, 117, 245, var(--text-opacity));
}
.active\\:text-indigo-600:active {
  --text-opacity: 1;
  color: #5850ec;
  color: rgba(88, 80, 236, var(--text-opacity));
}
.active\\:text-indigo-700:active {
  --text-opacity: 1;
  color: #5145cd;
  color: rgba(81, 69, 205, var(--text-opacity));
}
.active\\:text-indigo-800:active {
  --text-opacity: 1;
  color: #42389d;
  color: rgba(66, 56, 157, var(--text-opacity));
}
.active\\:text-indigo-900:active {
  --text-opacity: 1;
  color: #362f78;
  color: rgba(54, 47, 120, var(--text-opacity));
}
.active\\:text-purple-50:active {
  --text-opacity: 1;
  color: #f6f5ff;
  color: rgba(246, 245, 255, var(--text-opacity));
}
.active\\:text-purple-100:active {
  --text-opacity: 1;
  color: #edebfe;
  color: rgba(237, 235, 254, var(--text-opacity));
}
.active\\:text-purple-200:active {
  --text-opacity: 1;
  color: #dcd7fe;
  color: rgba(220, 215, 254, var(--text-opacity));
}
.active\\:text-purple-300:active {
  --text-opacity: 1;
  color: #cabffd;
  color: rgba(202, 191, 253, var(--text-opacity));
}
.active\\:text-purple-400:active {
  --text-opacity: 1;
  color: #ac94fa;
  color: rgba(172, 148, 250, var(--text-opacity));
}
.active\\:text-purple-500:active {
  --text-opacity: 1;
  color: #9061f9;
  color: rgba(144, 97, 249, var(--text-opacity));
}
.active\\:text-purple-600:active {
  --text-opacity: 1;
  color: #7e3af2;
  color: rgba(126, 58, 242, var(--text-opacity));
}
.active\\:text-purple-700:active {
  --text-opacity: 1;
  color: #6c2bd9;
  color: rgba(108, 43, 217, var(--text-opacity));
}
.active\\:text-purple-800:active {
  --text-opacity: 1;
  color: #5521b5;
  color: rgba(85, 33, 181, var(--text-opacity));
}
.active\\:text-purple-900:active {
  --text-opacity: 1;
  color: #4a1d96;
  color: rgba(74, 29, 150, var(--text-opacity));
}
.active\\:text-pink-50:active {
  --text-opacity: 1;
  color: #fdf2f8;
  color: rgba(253, 242, 248, var(--text-opacity));
}
.active\\:text-pink-100:active {
  --text-opacity: 1;
  color: #fce8f3;
  color: rgba(252, 232, 243, var(--text-opacity));
}
.active\\:text-pink-200:active {
  --text-opacity: 1;
  color: #fad1e8;
  color: rgba(250, 209, 232, var(--text-opacity));
}
.active\\:text-pink-300:active {
  --text-opacity: 1;
  color: #f8b4d9;
  color: rgba(248, 180, 217, var(--text-opacity));
}
.active\\:text-pink-400:active {
  --text-opacity: 1;
  color: #f17eb8;
  color: rgba(241, 126, 184, var(--text-opacity));
}
.active\\:text-pink-500:active {
  --text-opacity: 1;
  color: #e74694;
  color: rgba(231, 70, 148, var(--text-opacity));
}
.active\\:text-pink-600:active {
  --text-opacity: 1;
  color: #d61f69;
  color: rgba(214, 31, 105, var(--text-opacity));
}
.active\\:text-pink-700:active {
  --text-opacity: 1;
  color: #bf125d;
  color: rgba(191, 18, 93, var(--text-opacity));
}
.active\\:text-pink-800:active {
  --text-opacity: 1;
  color: #99154b;
  color: rgba(153, 21, 75, var(--text-opacity));
}
.active\\:text-pink-900:active {
  --text-opacity: 1;
  color: #751a3d;
  color: rgba(117, 26, 61, var(--text-opacity));
}
.active\\:text-cool-gray-50:active {
  --text-opacity: 1;
  color: #f8fafc;
  color: rgba(248, 250, 252, var(--text-opacity));
}
.active\\:text-cool-gray-100:active {
  --text-opacity: 1;
  color: #f1f5f9;
  color: rgba(241, 245, 249, var(--text-opacity));
}
.active\\:text-cool-gray-200:active {
  --text-opacity: 1;
  color: #e2e8f0;
  color: rgba(226, 232, 240, var(--text-opacity));
}
.active\\:text-cool-gray-300:active {
  --text-opacity: 1;
  color: #cfd8e3;
  color: rgba(207, 216, 227, var(--text-opacity));
}
.active\\:text-cool-gray-400:active {
  --text-opacity: 1;
  color: #97a6ba;
  color: rgba(151, 166, 186, var(--text-opacity));
}
.active\\:text-cool-gray-500:active {
  --text-opacity: 1;
  color: #64748b;
  color: rgba(100, 116, 139, var(--text-opacity));
}
.active\\:text-cool-gray-600:active {
  --text-opacity: 1;
  color: #475569;
  color: rgba(71, 85, 105, var(--text-opacity));
}
.active\\:text-cool-gray-700:active {
  --text-opacity: 1;
  color: #364152;
  color: rgba(54, 65, 82, var(--text-opacity));
}
.active\\:text-cool-gray-800:active {
  --text-opacity: 1;
  color: #27303f;
  color: rgba(39, 48, 63, var(--text-opacity));
}
.active\\:text-cool-gray-900:active {
  --text-opacity: 1;
  color: #1a202e;
  color: rgba(26, 32, 46, var(--text-opacity));
}
.text-opacity-0 {
  --text-opacity: 0;
}
.text-opacity-25 {
  --text-opacity: 0.25;
}
.text-opacity-50 {
  --text-opacity: 0.5;
}
.text-opacity-75 {
  --text-opacity: 0.75;
}
.text-opacity-100 {
  --text-opacity: 1;
}
.hover\\:text-opacity-0:hover {
  --text-opacity: 0;
}
.hover\\:text-opacity-25:hover {
  --text-opacity: 0.25;
}
.hover\\:text-opacity-50:hover {
  --text-opacity: 0.5;
}
.hover\\:text-opacity-75:hover {
  --text-opacity: 0.75;
}
.hover\\:text-opacity-100:hover {
  --text-opacity: 1;
}
.focus\\:text-opacity-0:focus {
  --text-opacity: 0;
}
.focus\\:text-opacity-25:focus {
  --text-opacity: 0.25;
}
.focus\\:text-opacity-50:focus {
  --text-opacity: 0.5;
}
.focus\\:text-opacity-75:focus {
  --text-opacity: 0.75;
}
.focus\\:text-opacity-100:focus {
  --text-opacity: 1;
}
.italic {
  font-style: italic;
}
.not-italic {
  font-style: normal;
}
.uppercase {
  text-transform: uppercase;
}
.lowercase {
  text-transform: lowercase;
}
.capitalize {
  text-transform: capitalize;
}
.normal-case {
  text-transform: none;
}
.underline {
  text-decoration: none;
}
.line-through {
  text-decoration: line-through;
}
.no-underline {
  text-decoration: none;
}
.group:hover .group-hover\\:underline {
  text-decoration: none;
}
.group:hover .group-hover\\:line-through {
  text-decoration: line-through;
}
.group:hover .group-hover\\:no-underline {
  text-decoration: none;
}
.group:focus .group-focus\\:underline {
  text-decoration: none;
}
.group:focus .group-focus\\:line-through {
  text-decoration: line-through;
}
.group:focus .group-focus\\:no-underline {
  text-decoration: none;
}
.hover\\:underline:hover {
  text-decoration: none;
}
.hover\\:line-through:hover {
  text-decoration: line-through;
}
.hover\\:no-underline:hover {
  text-decoration: none;
}
.focus\\:underline:focus {
  text-decoration: none;
}
.focus\\:line-through:focus {
  text-decoration: line-through;
}
.focus\\:no-underline:focus {
  text-decoration: none;
}
.antialiased {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.subpixel-antialiased {
  -webkit-font-smoothing: auto;
  -moz-osx-font-smoothing: auto;
}
.ordinal, .slashed-zero, .lining-nums, .oldstyle-nums, .proportional-nums, .tabular-nums, .diagonal-fractions, .stacked-fractions {
  --font-variant-numeric-ordinal: var(--tailwind-empty,
      /*!*/
      /*!*/
    );
  --font-variant-numeric-slashed-zero: var(--tailwind-empty,
      /*!*/
      /*!*/
    );
  --font-variant-numeric-figure: var(--tailwind-empty,
      /*!*/
      /*!*/
    );
  --font-variant-numeric-spacing: var(--tailwind-empty,
      /*!*/
      /*!*/
    );
  --font-variant-numeric-fraction: var(--tailwind-empty,
      /*!*/
      /*!*/
    );
  font-variant-numeric: var(--font-variant-numeric-ordinal) var(--font-variant-numeric-slashed-zero) var(--font-variant-numeric-figure) var(--font-variant-numeric-spacing) var(--font-variant-numeric-fraction);
}
.normal-nums {
  font-variant-numeric: normal;
}
.ordinal {
  --font-variant-numeric-ordinal: ordinal;
}
.slashed-zero {
  --font-variant-numeric-slashed-zero: slashed-zero;
}
.lining-nums {
  --font-variant-numeric-figure: lining-nums;
}
.oldstyle-nums {
  --font-variant-numeric-figure: oldstyle-nums;
}
.proportional-nums {
  --font-variant-numeric-spacing: proportional-nums;
}
.tabular-nums {
  --font-variant-numeric-spacing: tabular-nums;
}
.diagonal-fractions {
  --font-variant-numeric-fraction: diagonal-fractions;
}
.stacked-fractions {
  --font-variant-numeric-fraction: stacked-fractions;
}
.tracking-tighter {
  letter-spacing: -0.05em;
}
.tracking-tight {
  letter-spacing: -0.025em;
}
.tracking-normal {
  letter-spacing: 0;
}
.tracking-wide {
  letter-spacing: 0.025em;
}
.tracking-wider {
  letter-spacing: 0.05em;
}
.tracking-widest {
  letter-spacing: 0.1em;
}
.select-none {
  -webkit-user-select: none;
  user-select: none;
}
.select-text {
  -webkit-user-select: text;
  user-select: text;
}
.select-all {
  -webkit-user-select: all;
  user-select: all;
}
.select-auto {
  -webkit-user-select: auto;
  user-select: auto;
}
.align-baseline {
  vertical-align: baseline;
}
.align-top {
  vertical-align: top;
}
.align-middle {
  vertical-align: middle;
}
.align-bottom {
  vertical-align: bottom;
}
.align-text-top {
  vertical-align: text-top;
}
.align-text-bottom {
  vertical-align: text-bottom;
}
.visible {
  visibility: visible;
}
.invisible {
  visibility: hidden;
}
.whitespace-normal {
  white-space: normal;
}
.whitespace-no-wrap {
  white-space: nowrap;
}
.whitespace-pre {
  white-space: pre;
}
.whitespace-pre-line {
  white-space: pre-line;
}
.whitespace-pre-wrap {
  white-space: pre-wrap;
}
.break-normal {
  word-wrap: normal;
  overflow-wrap: normal;
  word-break: normal;
}
.break-words {
  word-wrap: break-word;
  overflow-wrap: break-word;
}
.break-all {
  word-break: break-all;
}
.truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.w-0 {
  width: 0;
}
.w-1 {
  width: 0.25rem;
}
.w-2 {
  width: 0.5rem;
}
.w-3 {
  width: 0.75rem;
}
.w-4 {
  width: 1rem;
}
.w-5 {
  width: 1.25rem;
}
.w-6 {
  width: 1.5rem;
}
.w-7 {
  width: 1.75rem;
}
.w-8 {
  width: 2rem;
}
.w-9 {
  width: 2.25rem;
}
.w-10 {
  width: 2.5rem;
}
.w-11 {
  width: 2.75rem;
}
.w-12 {
  width: 3rem;
}
.w-13 {
  width: 3.25rem;
}
.w-14 {
  width: 3.5rem;
}
.w-15 {
  width: 3.75rem;
}
.w-16 {
  width: 4rem;
}
.w-20 {
  width: 5rem;
}
.w-24 {
  width: 6rem;
}
.w-28 {
  width: 7rem;
}
.w-32 {
  width: 8rem;
}
.w-36 {
  width: 9rem;
}
.w-40 {
  width: 10rem;
}
.w-44 {
  width: 11rem;
}
.w-48 {
  width: 12rem;
}
.w-52 {
  width: 13rem;
}
.w-56 {
  width: 14rem;
}
.w-60 {
  width: 15rem;
}
.w-64 {
  width: 16rem;
}
.w-72 {
  width: 18rem;
}
.w-80 {
  width: 20rem;
}
.w-96 {
  width: 24rem;
}
.w-auto {
  width: auto;
}
.w-px {
  width: 1px;
}
.w-0\\.5 {
  width: 0.125rem;
}
.w-1\\.5 {
  width: 0.375rem;
}
.w-2\\.5 {
  width: 0.625rem;
}
.w-3\\.5 {
  width: 0.875rem;
}
.w-1\\/2 {
  width: 50%;
}
.w-1\\/3 {
  width: 33.333333%;
}
.w-2\\/3 {
  width: 66.666667%;
}
.w-1\\/4 {
  width: 25%;
}
.w-2\\/4 {
  width: 50%;
}
.w-3\\/4 {
  width: 75%;
}
.w-1\\/5 {
  width: 20%;
}
.w-2\\/5 {
  width: 40%;
}
.w-3\\/5 {
  width: 60%;
}
.w-4\\/5 {
  width: 80%;
}
.w-1\\/6 {
  width: 16.666667%;
}
.w-2\\/6 {
  width: 33.333333%;
}
.w-3\\/6 {
  width: 50%;
}
.w-4\\/6 {
  width: 66.666667%;
}
.w-5\\/6 {
  width: 83.333333%;
}
.w-1\\/12 {
  width: 8.333333%;
}
.w-2\\/12 {
  width: 16.666667%;
}
.w-3\\/12 {
  width: 25%;
}
.w-4\\/12 {
  width: 33.333333%;
}
.w-5\\/12 {
  width: 41.666667%;
}
.w-6\\/12 {
  width: 50%;
}
.w-7\\/12 {
  width: 58.333333%;
}
.w-8\\/12 {
  width: 66.666667%;
}
.w-9\\/12 {
  width: 75%;
}
.w-10\\/12 {
  width: 83.333333%;
}
.w-11\\/12 {
  width: 91.666667%;
}
.w-full {
  width: 100%;
}
.w-screen {
  width: 100vw;
}
.w-min-content {
  width: min-content;
}
.w-max-content {
  width: max-content;
}
.z-0 {
  z-index: 0;
}
.z-10 {
  z-index: 10;
}
.z-20 {
  z-index: 20;
}
.z-30 {
  z-index: 30;
}
.z-40 {
  z-index: 40;
}
.z-50 {
  z-index: 50;
}
.z-auto {
  z-index: auto;
}
.focus-within\\:z-0:focus-within {
  z-index: 0;
}
.focus-within\\:z-10:focus-within {
  z-index: 10;
}
.focus-within\\:z-20:focus-within {
  z-index: 20;
}
.focus-within\\:z-30:focus-within {
  z-index: 30;
}
.focus-within\\:z-40:focus-within {
  z-index: 40;
}
.focus-within\\:z-50:focus-within {
  z-index: 50;
}
.focus-within\\:z-auto:focus-within {
  z-index: auto;
}
.focus\\:z-0:focus {
  z-index: 0;
}
.focus\\:z-10:focus {
  z-index: 10;
}
.focus\\:z-20:focus {
  z-index: 20;
}
.focus\\:z-30:focus {
  z-index: 30;
}
.focus\\:z-40:focus {
  z-index: 40;
}
.focus\\:z-50:focus {
  z-index: 50;
}
.focus\\:z-auto:focus {
  z-index: auto;
}
.gap-0 {
  grid-gap: 0;
  gap: 0;
}
.gap-1 {
  grid-gap: 0.25rem;
  gap: 0.25rem;
}
.gap-2 {
  grid-gap: 0.5rem;
  gap: 0.5rem;
}
.gap-3 {
  grid-gap: 0.75rem;
  gap: 0.75rem;
}
.gap-4 {
  grid-gap: 1rem;
  gap: 1rem;
}
.gap-5 {
  grid-gap: 1.25rem;
  gap: 1.25rem;
}
.gap-6 {
  grid-gap: 1.5rem;
  gap: 1.5rem;
}
.gap-7 {
  grid-gap: 1.75rem;
  gap: 1.75rem;
}
.gap-8 {
  grid-gap: 2rem;
  gap: 2rem;
}
.gap-9 {
  grid-gap: 2.25rem;
  gap: 2.25rem;
}
.gap-10 {
  grid-gap: 2.5rem;
  gap: 2.5rem;
}
.gap-11 {
  grid-gap: 2.75rem;
  gap: 2.75rem;
}
.gap-12 {
  grid-gap: 3rem;
  gap: 3rem;
}
.gap-13 {
  grid-gap: 3.25rem;
  gap: 3.25rem;
}
.gap-14 {
  grid-gap: 3.5rem;
  gap: 3.5rem;
}
.gap-15 {
  grid-gap: 3.75rem;
  gap: 3.75rem;
}
.gap-16 {
  grid-gap: 4rem;
  gap: 4rem;
}
.gap-20 {
  grid-gap: 5rem;
  gap: 5rem;
}
.gap-24 {
  grid-gap: 6rem;
  gap: 6rem;
}
.gap-28 {
  grid-gap: 7rem;
  gap: 7rem;
}
.gap-32 {
  grid-gap: 8rem;
  gap: 8rem;
}
.gap-36 {
  grid-gap: 9rem;
  gap: 9rem;
}
.gap-40 {
  grid-gap: 10rem;
  gap: 10rem;
}
.gap-44 {
  grid-gap: 11rem;
  gap: 11rem;
}
.gap-48 {
  grid-gap: 12rem;
  gap: 12rem;
}
.gap-52 {
  grid-gap: 13rem;
  gap: 13rem;
}
.gap-56 {
  grid-gap: 14rem;
  gap: 14rem;
}
.gap-60 {
  grid-gap: 15rem;
  gap: 15rem;
}
.gap-64 {
  grid-gap: 16rem;
  gap: 16rem;
}
.gap-72 {
  grid-gap: 18rem;
  gap: 18rem;
}
.gap-80 {
  grid-gap: 20rem;
  gap: 20rem;
}
.gap-96 {
  grid-gap: 24rem;
  gap: 24rem;
}
.gap-px {
  grid-gap: 1px;
  gap: 1px;
}
.gap-0\\.5 {
  grid-gap: 0.125rem;
  gap: 0.125rem;
}
.gap-1\\.5 {
  grid-gap: 0.375rem;
  gap: 0.375rem;
}
.gap-2\\.5 {
  grid-gap: 0.625rem;
  gap: 0.625rem;
}
.gap-3\\.5 {
  grid-gap: 0.875rem;
  gap: 0.875rem;
}
.gap-1\\/2 {
  grid-gap: 50%;
  gap: 50%;
}
.gap-1\\/3 {
  grid-gap: 33.333333%;
  gap: 33.333333%;
}
.gap-2\\/3 {
  grid-gap: 66.666667%;
  gap: 66.666667%;
}
.gap-1\\/4 {
  grid-gap: 25%;
  gap: 25%;
}
.gap-2\\/4 {
  grid-gap: 50%;
  gap: 50%;
}
.gap-3\\/4 {
  grid-gap: 75%;
  gap: 75%;
}
.gap-1\\/5 {
  grid-gap: 20%;
  gap: 20%;
}
.gap-2\\/5 {
  grid-gap: 40%;
  gap: 40%;
}
.gap-3\\/5 {
  grid-gap: 60%;
  gap: 60%;
}
.gap-4\\/5 {
  grid-gap: 80%;
  gap: 80%;
}
.gap-1\\/6 {
  grid-gap: 16.666667%;
  gap: 16.666667%;
}
.gap-2\\/6 {
  grid-gap: 33.333333%;
  gap: 33.333333%;
}
.gap-3\\/6 {
  grid-gap: 50%;
  gap: 50%;
}
.gap-4\\/6 {
  grid-gap: 66.666667%;
  gap: 66.666667%;
}
.gap-5\\/6 {
  grid-gap: 83.333333%;
  gap: 83.333333%;
}
.gap-1\\/12 {
  grid-gap: 8.333333%;
  gap: 8.333333%;
}
.gap-2\\/12 {
  grid-gap: 16.666667%;
  gap: 16.666667%;
}
.gap-3\\/12 {
  grid-gap: 25%;
  gap: 25%;
}
.gap-4\\/12 {
  grid-gap: 33.333333%;
  gap: 33.333333%;
}
.gap-5\\/12 {
  grid-gap: 41.666667%;
  gap: 41.666667%;
}
.gap-6\\/12 {
  grid-gap: 50%;
  gap: 50%;
}
.gap-7\\/12 {
  grid-gap: 58.333333%;
  gap: 58.333333%;
}
.gap-8\\/12 {
  grid-gap: 66.666667%;
  gap: 66.666667%;
}
.gap-9\\/12 {
  grid-gap: 75%;
  gap: 75%;
}
.gap-10\\/12 {
  grid-gap: 83.333333%;
  gap: 83.333333%;
}
.gap-11\\/12 {
  grid-gap: 91.666667%;
  gap: 91.666667%;
}
.gap-full {
  grid-gap: 100%;
  gap: 100%;
}
.col-gap-0 {
  grid-column-gap: 0;
  column-gap: 0;
}
.col-gap-1 {
  grid-column-gap: 0.25rem;
  column-gap: 0.25rem;
}
.col-gap-2 {
  grid-column-gap: 0.5rem;
  column-gap: 0.5rem;
}
.col-gap-3 {
  grid-column-gap: 0.75rem;
  column-gap: 0.75rem;
}
.col-gap-4 {
  grid-column-gap: 1rem;
  column-gap: 1rem;
}
.col-gap-5 {
  grid-column-gap: 1.25rem;
  column-gap: 1.25rem;
}
.col-gap-6 {
  grid-column-gap: 1.5rem;
  column-gap: 1.5rem;
}
.col-gap-7 {
  grid-column-gap: 1.75rem;
  column-gap: 1.75rem;
}
.col-gap-8 {
  grid-column-gap: 2rem;
  column-gap: 2rem;
}
.col-gap-9 {
  grid-column-gap: 2.25rem;
  column-gap: 2.25rem;
}
.col-gap-10 {
  grid-column-gap: 2.5rem;
  column-gap: 2.5rem;
}
.col-gap-11 {
  grid-column-gap: 2.75rem;
  column-gap: 2.75rem;
}
.col-gap-12 {
  grid-column-gap: 3rem;
  column-gap: 3rem;
}
.col-gap-13 {
  grid-column-gap: 3.25rem;
  column-gap: 3.25rem;
}
.col-gap-14 {
  grid-column-gap: 3.5rem;
  column-gap: 3.5rem;
}
.col-gap-15 {
  grid-column-gap: 3.75rem;
  column-gap: 3.75rem;
}
.col-gap-16 {
  grid-column-gap: 4rem;
  column-gap: 4rem;
}
.col-gap-20 {
  grid-column-gap: 5rem;
  column-gap: 5rem;
}
.col-gap-24 {
  grid-column-gap: 6rem;
  column-gap: 6rem;
}
.col-gap-28 {
  grid-column-gap: 7rem;
  column-gap: 7rem;
}
.col-gap-32 {
  grid-column-gap: 8rem;
  column-gap: 8rem;
}
.col-gap-36 {
  grid-column-gap: 9rem;
  column-gap: 9rem;
}
.col-gap-40 {
  grid-column-gap: 10rem;
  column-gap: 10rem;
}
.col-gap-44 {
  grid-column-gap: 11rem;
  column-gap: 11rem;
}
.col-gap-48 {
  grid-column-gap: 12rem;
  column-gap: 12rem;
}
.col-gap-52 {
  grid-column-gap: 13rem;
  column-gap: 13rem;
}
.col-gap-56 {
  grid-column-gap: 14rem;
  column-gap: 14rem;
}
.col-gap-60 {
  grid-column-gap: 15rem;
  column-gap: 15rem;
}
.col-gap-64 {
  grid-column-gap: 16rem;
  column-gap: 16rem;
}
.col-gap-72 {
  grid-column-gap: 18rem;
  column-gap: 18rem;
}
.col-gap-80 {
  grid-column-gap: 20rem;
  column-gap: 20rem;
}
.col-gap-96 {
  grid-column-gap: 24rem;
  column-gap: 24rem;
}
.col-gap-px {
  grid-column-gap: 1px;
  column-gap: 1px;
}
.col-gap-0\\.5 {
  grid-column-gap: 0.125rem;
  column-gap: 0.125rem;
}
.col-gap-1\\.5 {
  grid-column-gap: 0.375rem;
  column-gap: 0.375rem;
}
.col-gap-2\\.5 {
  grid-column-gap: 0.625rem;
  column-gap: 0.625rem;
}
.col-gap-3\\.5 {
  grid-column-gap: 0.875rem;
  column-gap: 0.875rem;
}
.col-gap-1\\/2 {
  grid-column-gap: 50%;
  column-gap: 50%;
}
.col-gap-1\\/3 {
  grid-column-gap: 33.333333%;
  column-gap: 33.333333%;
}
.col-gap-2\\/3 {
  grid-column-gap: 66.666667%;
  column-gap: 66.666667%;
}
.col-gap-1\\/4 {
  grid-column-gap: 25%;
  column-gap: 25%;
}
.col-gap-2\\/4 {
  grid-column-gap: 50%;
  column-gap: 50%;
}
.col-gap-3\\/4 {
  grid-column-gap: 75%;
  column-gap: 75%;
}
.col-gap-1\\/5 {
  grid-column-gap: 20%;
  column-gap: 20%;
}
.col-gap-2\\/5 {
  grid-column-gap: 40%;
  column-gap: 40%;
}
.col-gap-3\\/5 {
  grid-column-gap: 60%;
  column-gap: 60%;
}
.col-gap-4\\/5 {
  grid-column-gap: 80%;
  column-gap: 80%;
}
.col-gap-1\\/6 {
  grid-column-gap: 16.666667%;
  column-gap: 16.666667%;
}
.col-gap-2\\/6 {
  grid-column-gap: 33.333333%;
  column-gap: 33.333333%;
}
.col-gap-3\\/6 {
  grid-column-gap: 50%;
  column-gap: 50%;
}
.col-gap-4\\/6 {
  grid-column-gap: 66.666667%;
  column-gap: 66.666667%;
}
.col-gap-5\\/6 {
  grid-column-gap: 83.333333%;
  column-gap: 83.333333%;
}
.col-gap-1\\/12 {
  grid-column-gap: 8.333333%;
  column-gap: 8.333333%;
}
.col-gap-2\\/12 {
  grid-column-gap: 16.666667%;
  column-gap: 16.666667%;
}
.col-gap-3\\/12 {
  grid-column-gap: 25%;
  column-gap: 25%;
}
.col-gap-4\\/12 {
  grid-column-gap: 33.333333%;
  column-gap: 33.333333%;
}
.col-gap-5\\/12 {
  grid-column-gap: 41.666667%;
  column-gap: 41.666667%;
}
.col-gap-6\\/12 {
  grid-column-gap: 50%;
  column-gap: 50%;
}
.col-gap-7\\/12 {
  grid-column-gap: 58.333333%;
  column-gap: 58.333333%;
}
.col-gap-8\\/12 {
  grid-column-gap: 66.666667%;
  column-gap: 66.666667%;
}
.col-gap-9\\/12 {
  grid-column-gap: 75%;
  column-gap: 75%;
}
.col-gap-10\\/12 {
  grid-column-gap: 83.333333%;
  column-gap: 83.333333%;
}
.col-gap-11\\/12 {
  grid-column-gap: 91.666667%;
  column-gap: 91.666667%;
}
.col-gap-full {
  grid-column-gap: 100%;
  column-gap: 100%;
}
.gap-x-0 {
  grid-column-gap: 0;
  column-gap: 0;
}
.gap-x-1 {
  grid-column-gap: 0.25rem;
  column-gap: 0.25rem;
}
.gap-x-2 {
  grid-column-gap: 0.5rem;
  column-gap: 0.5rem;
}
.gap-x-3 {
  grid-column-gap: 0.75rem;
  column-gap: 0.75rem;
}
.gap-x-4 {
  grid-column-gap: 1rem;
  column-gap: 1rem;
}
.gap-x-5 {
  grid-column-gap: 1.25rem;
  column-gap: 1.25rem;
}
.gap-x-6 {
  grid-column-gap: 1.5rem;
  column-gap: 1.5rem;
}
.gap-x-7 {
  grid-column-gap: 1.75rem;
  column-gap: 1.75rem;
}
.gap-x-8 {
  grid-column-gap: 2rem;
  column-gap: 2rem;
}
.gap-x-9 {
  grid-column-gap: 2.25rem;
  column-gap: 2.25rem;
}
.gap-x-10 {
  grid-column-gap: 2.5rem;
  column-gap: 2.5rem;
}
.gap-x-11 {
  grid-column-gap: 2.75rem;
  column-gap: 2.75rem;
}
.gap-x-12 {
  grid-column-gap: 3rem;
  column-gap: 3rem;
}
.gap-x-13 {
  grid-column-gap: 3.25rem;
  column-gap: 3.25rem;
}
.gap-x-14 {
  grid-column-gap: 3.5rem;
  column-gap: 3.5rem;
}
.gap-x-15 {
  grid-column-gap: 3.75rem;
  column-gap: 3.75rem;
}
.gap-x-16 {
  grid-column-gap: 4rem;
  column-gap: 4rem;
}
.gap-x-20 {
  grid-column-gap: 5rem;
  column-gap: 5rem;
}
.gap-x-24 {
  grid-column-gap: 6rem;
  column-gap: 6rem;
}
.gap-x-28 {
  grid-column-gap: 7rem;
  column-gap: 7rem;
}
.gap-x-32 {
  grid-column-gap: 8rem;
  column-gap: 8rem;
}
.gap-x-36 {
  grid-column-gap: 9rem;
  column-gap: 9rem;
}
.gap-x-40 {
  grid-column-gap: 10rem;
  column-gap: 10rem;
}
.gap-x-44 {
  grid-column-gap: 11rem;
  column-gap: 11rem;
}
.gap-x-48 {
  grid-column-gap: 12rem;
  column-gap: 12rem;
}
.gap-x-52 {
  grid-column-gap: 13rem;
  column-gap: 13rem;
}
.gap-x-56 {
  grid-column-gap: 14rem;
  column-gap: 14rem;
}
.gap-x-60 {
  grid-column-gap: 15rem;
  column-gap: 15rem;
}
.gap-x-64 {
  grid-column-gap: 16rem;
  column-gap: 16rem;
}
.gap-x-72 {
  grid-column-gap: 18rem;
  column-gap: 18rem;
}
.gap-x-80 {
  grid-column-gap: 20rem;
  column-gap: 20rem;
}
.gap-x-96 {
  grid-column-gap: 24rem;
  column-gap: 24rem;
}
.gap-x-px {
  grid-column-gap: 1px;
  column-gap: 1px;
}
.gap-x-0\\.5 {
  grid-column-gap: 0.125rem;
  column-gap: 0.125rem;
}
.gap-x-1\\.5 {
  grid-column-gap: 0.375rem;
  column-gap: 0.375rem;
}
.gap-x-2\\.5 {
  grid-column-gap: 0.625rem;
  column-gap: 0.625rem;
}
.gap-x-3\\.5 {
  grid-column-gap: 0.875rem;
  column-gap: 0.875rem;
}
.gap-x-1\\/2 {
  grid-column-gap: 50%;
  column-gap: 50%;
}
.gap-x-1\\/3 {
  grid-column-gap: 33.333333%;
  column-gap: 33.333333%;
}
.gap-x-2\\/3 {
  grid-column-gap: 66.666667%;
  column-gap: 66.666667%;
}
.gap-x-1\\/4 {
  grid-column-gap: 25%;
  column-gap: 25%;
}
.gap-x-2\\/4 {
  grid-column-gap: 50%;
  column-gap: 50%;
}
.gap-x-3\\/4 {
  grid-column-gap: 75%;
  column-gap: 75%;
}
.gap-x-1\\/5 {
  grid-column-gap: 20%;
  column-gap: 20%;
}
.gap-x-2\\/5 {
  grid-column-gap: 40%;
  column-gap: 40%;
}
.gap-x-3\\/5 {
  grid-column-gap: 60%;
  column-gap: 60%;
}
.gap-x-4\\/5 {
  grid-column-gap: 80%;
  column-gap: 80%;
}
.gap-x-1\\/6 {
  grid-column-gap: 16.666667%;
  column-gap: 16.666667%;
}
.gap-x-2\\/6 {
  grid-column-gap: 33.333333%;
  column-gap: 33.333333%;
}
.gap-x-3\\/6 {
  grid-column-gap: 50%;
  column-gap: 50%;
}
.gap-x-4\\/6 {
  grid-column-gap: 66.666667%;
  column-gap: 66.666667%;
}
.gap-x-5\\/6 {
  grid-column-gap: 83.333333%;
  column-gap: 83.333333%;
}
.gap-x-1\\/12 {
  grid-column-gap: 8.333333%;
  column-gap: 8.333333%;
}
.gap-x-2\\/12 {
  grid-column-gap: 16.666667%;
  column-gap: 16.666667%;
}
.gap-x-3\\/12 {
  grid-column-gap: 25%;
  column-gap: 25%;
}
.gap-x-4\\/12 {
  grid-column-gap: 33.333333%;
  column-gap: 33.333333%;
}
.gap-x-5\\/12 {
  grid-column-gap: 41.666667%;
  column-gap: 41.666667%;
}
.gap-x-6\\/12 {
  grid-column-gap: 50%;
  column-gap: 50%;
}
.gap-x-7\\/12 {
  grid-column-gap: 58.333333%;
  column-gap: 58.333333%;
}
.gap-x-8\\/12 {
  grid-column-gap: 66.666667%;
  column-gap: 66.666667%;
}
.gap-x-9\\/12 {
  grid-column-gap: 75%;
  column-gap: 75%;
}
.gap-x-10\\/12 {
  grid-column-gap: 83.333333%;
  column-gap: 83.333333%;
}
.gap-x-11\\/12 {
  grid-column-gap: 91.666667%;
  column-gap: 91.666667%;
}
.gap-x-full {
  grid-column-gap: 100%;
  column-gap: 100%;
}
.row-gap-0 {
  grid-row-gap: 0;
  row-gap: 0;
}
.row-gap-1 {
  grid-row-gap: 0.25rem;
  row-gap: 0.25rem;
}
.row-gap-2 {
  grid-row-gap: 0.5rem;
  row-gap: 0.5rem;
}
.row-gap-3 {
  grid-row-gap: 0.75rem;
  row-gap: 0.75rem;
}
.row-gap-4 {
  grid-row-gap: 1rem;
  row-gap: 1rem;
}
.row-gap-5 {
  grid-row-gap: 1.25rem;
  row-gap: 1.25rem;
}
.row-gap-6 {
  grid-row-gap: 1.5rem;
  row-gap: 1.5rem;
}
.row-gap-7 {
  grid-row-gap: 1.75rem;
  row-gap: 1.75rem;
}
.row-gap-8 {
  grid-row-gap: 2rem;
  row-gap: 2rem;
}
.row-gap-9 {
  grid-row-gap: 2.25rem;
  row-gap: 2.25rem;
}
.row-gap-10 {
  grid-row-gap: 2.5rem;
  row-gap: 2.5rem;
}
.row-gap-11 {
  grid-row-gap: 2.75rem;
  row-gap: 2.75rem;
}
.row-gap-12 {
  grid-row-gap: 3rem;
  row-gap: 3rem;
}
.row-gap-13 {
  grid-row-gap: 3.25rem;
  row-gap: 3.25rem;
}
.row-gap-14 {
  grid-row-gap: 3.5rem;
  row-gap: 3.5rem;
}
.row-gap-15 {
  grid-row-gap: 3.75rem;
  row-gap: 3.75rem;
}
.row-gap-16 {
  grid-row-gap: 4rem;
  row-gap: 4rem;
}
.row-gap-20 {
  grid-row-gap: 5rem;
  row-gap: 5rem;
}
.row-gap-24 {
  grid-row-gap: 6rem;
  row-gap: 6rem;
}
.row-gap-28 {
  grid-row-gap: 7rem;
  row-gap: 7rem;
}
.row-gap-32 {
  grid-row-gap: 8rem;
  row-gap: 8rem;
}
.row-gap-36 {
  grid-row-gap: 9rem;
  row-gap: 9rem;
}
.row-gap-40 {
  grid-row-gap: 10rem;
  row-gap: 10rem;
}
.row-gap-44 {
  grid-row-gap: 11rem;
  row-gap: 11rem;
}
.row-gap-48 {
  grid-row-gap: 12rem;
  row-gap: 12rem;
}
.row-gap-52 {
  grid-row-gap: 13rem;
  row-gap: 13rem;
}
.row-gap-56 {
  grid-row-gap: 14rem;
  row-gap: 14rem;
}
.row-gap-60 {
  grid-row-gap: 15rem;
  row-gap: 15rem;
}
.row-gap-64 {
  grid-row-gap: 16rem;
  row-gap: 16rem;
}
.row-gap-72 {
  grid-row-gap: 18rem;
  row-gap: 18rem;
}
.row-gap-80 {
  grid-row-gap: 20rem;
  row-gap: 20rem;
}
.row-gap-96 {
  grid-row-gap: 24rem;
  row-gap: 24rem;
}
.row-gap-px {
  grid-row-gap: 1px;
  row-gap: 1px;
}
.row-gap-0\\.5 {
  grid-row-gap: 0.125rem;
  row-gap: 0.125rem;
}
.row-gap-1\\.5 {
  grid-row-gap: 0.375rem;
  row-gap: 0.375rem;
}
.row-gap-2\\.5 {
  grid-row-gap: 0.625rem;
  row-gap: 0.625rem;
}
.row-gap-3\\.5 {
  grid-row-gap: 0.875rem;
  row-gap: 0.875rem;
}
.row-gap-1\\/2 {
  grid-row-gap: 50%;
  row-gap: 50%;
}
.row-gap-1\\/3 {
  grid-row-gap: 33.333333%;
  row-gap: 33.333333%;
}
.row-gap-2\\/3 {
  grid-row-gap: 66.666667%;
  row-gap: 66.666667%;
}
.row-gap-1\\/4 {
  grid-row-gap: 25%;
  row-gap: 25%;
}
.row-gap-2\\/4 {
  grid-row-gap: 50%;
  row-gap: 50%;
}
.row-gap-3\\/4 {
  grid-row-gap: 75%;
  row-gap: 75%;
}
.row-gap-1\\/5 {
  grid-row-gap: 20%;
  row-gap: 20%;
}
.row-gap-2\\/5 {
  grid-row-gap: 40%;
  row-gap: 40%;
}
.row-gap-3\\/5 {
  grid-row-gap: 60%;
  row-gap: 60%;
}
.row-gap-4\\/5 {
  grid-row-gap: 80%;
  row-gap: 80%;
}
.row-gap-1\\/6 {
  grid-row-gap: 16.666667%;
  row-gap: 16.666667%;
}
.row-gap-2\\/6 {
  grid-row-gap: 33.333333%;
  row-gap: 33.333333%;
}
.row-gap-3\\/6 {
  grid-row-gap: 50%;
  row-gap: 50%;
}
.row-gap-4\\/6 {
  grid-row-gap: 66.666667%;
  row-gap: 66.666667%;
}
.row-gap-5\\/6 {
  grid-row-gap: 83.333333%;
  row-gap: 83.333333%;
}
.row-gap-1\\/12 {
  grid-row-gap: 8.333333%;
  row-gap: 8.333333%;
}
.row-gap-2\\/12 {
  grid-row-gap: 16.666667%;
  row-gap: 16.666667%;
}
.row-gap-3\\/12 {
  grid-row-gap: 25%;
  row-gap: 25%;
}
.row-gap-4\\/12 {
  grid-row-gap: 33.333333%;
  row-gap: 33.333333%;
}
.row-gap-5\\/12 {
  grid-row-gap: 41.666667%;
  row-gap: 41.666667%;
}
.row-gap-6\\/12 {
  grid-row-gap: 50%;
  row-gap: 50%;
}
.row-gap-7\\/12 {
  grid-row-gap: 58.333333%;
  row-gap: 58.333333%;
}
.row-gap-8\\/12 {
  grid-row-gap: 66.666667%;
  row-gap: 66.666667%;
}
.row-gap-9\\/12 {
  grid-row-gap: 75%;
  row-gap: 75%;
}
.row-gap-10\\/12 {
  grid-row-gap: 83.333333%;
  row-gap: 83.333333%;
}
.row-gap-11\\/12 {
  grid-row-gap: 91.666667%;
  row-gap: 91.666667%;
}
.row-gap-full {
  grid-row-gap: 100%;
  row-gap: 100%;
}
.gap-y-0 {
  grid-row-gap: 0;
  row-gap: 0;
}
.gap-y-1 {
  grid-row-gap: 0.25rem;
  row-gap: 0.25rem;
}
.gap-y-2 {
  grid-row-gap: 0.5rem;
  row-gap: 0.5rem;
}
.gap-y-3 {
  grid-row-gap: 0.75rem;
  row-gap: 0.75rem;
}
.gap-y-4 {
  grid-row-gap: 1rem;
  row-gap: 1rem;
}
.gap-y-5 {
  grid-row-gap: 1.25rem;
  row-gap: 1.25rem;
}
.gap-y-6 {
  grid-row-gap: 1.5rem;
  row-gap: 1.5rem;
}
.gap-y-7 {
  grid-row-gap: 1.75rem;
  row-gap: 1.75rem;
}
.gap-y-8 {
  grid-row-gap: 2rem;
  row-gap: 2rem;
}
.gap-y-9 {
  grid-row-gap: 2.25rem;
  row-gap: 2.25rem;
}
.gap-y-10 {
  grid-row-gap: 2.5rem;
  row-gap: 2.5rem;
}
.gap-y-11 {
  grid-row-gap: 2.75rem;
  row-gap: 2.75rem;
}
.gap-y-12 {
  grid-row-gap: 3rem;
  row-gap: 3rem;
}
.gap-y-13 {
  grid-row-gap: 3.25rem;
  row-gap: 3.25rem;
}
.gap-y-14 {
  grid-row-gap: 3.5rem;
  row-gap: 3.5rem;
}
.gap-y-15 {
  grid-row-gap: 3.75rem;
  row-gap: 3.75rem;
}
.gap-y-16 {
  grid-row-gap: 4rem;
  row-gap: 4rem;
}
.gap-y-20 {
  grid-row-gap: 5rem;
  row-gap: 5rem;
}
.gap-y-24 {
  grid-row-gap: 6rem;
  row-gap: 6rem;
}
.gap-y-28 {
  grid-row-gap: 7rem;
  row-gap: 7rem;
}
.gap-y-32 {
  grid-row-gap: 8rem;
  row-gap: 8rem;
}
.gap-y-36 {
  grid-row-gap: 9rem;
  row-gap: 9rem;
}
.gap-y-40 {
  grid-row-gap: 10rem;
  row-gap: 10rem;
}
.gap-y-44 {
  grid-row-gap: 11rem;
  row-gap: 11rem;
}
.gap-y-48 {
  grid-row-gap: 12rem;
  row-gap: 12rem;
}
.gap-y-52 {
  grid-row-gap: 13rem;
  row-gap: 13rem;
}
.gap-y-56 {
  grid-row-gap: 14rem;
  row-gap: 14rem;
}
.gap-y-60 {
  grid-row-gap: 15rem;
  row-gap: 15rem;
}
.gap-y-64 {
  grid-row-gap: 16rem;
  row-gap: 16rem;
}
.gap-y-72 {
  grid-row-gap: 18rem;
  row-gap: 18rem;
}
.gap-y-80 {
  grid-row-gap: 20rem;
  row-gap: 20rem;
}
.gap-y-96 {
  grid-row-gap: 24rem;
  row-gap: 24rem;
}
.gap-y-px {
  grid-row-gap: 1px;
  row-gap: 1px;
}
.gap-y-0\\.5 {
  grid-row-gap: 0.125rem;
  row-gap: 0.125rem;
}
.gap-y-1\\.5 {
  grid-row-gap: 0.375rem;
  row-gap: 0.375rem;
}
.gap-y-2\\.5 {
  grid-row-gap: 0.625rem;
  row-gap: 0.625rem;
}
.gap-y-3\\.5 {
  grid-row-gap: 0.875rem;
  row-gap: 0.875rem;
}
.gap-y-1\\/2 {
  grid-row-gap: 50%;
  row-gap: 50%;
}
.gap-y-1\\/3 {
  grid-row-gap: 33.333333%;
  row-gap: 33.333333%;
}
.gap-y-2\\/3 {
  grid-row-gap: 66.666667%;
  row-gap: 66.666667%;
}
.gap-y-1\\/4 {
  grid-row-gap: 25%;
  row-gap: 25%;
}
.gap-y-2\\/4 {
  grid-row-gap: 50%;
  row-gap: 50%;
}
.gap-y-3\\/4 {
  grid-row-gap: 75%;
  row-gap: 75%;
}
.gap-y-1\\/5 {
  grid-row-gap: 20%;
  row-gap: 20%;
}
.gap-y-2\\/5 {
  grid-row-gap: 40%;
  row-gap: 40%;
}
.gap-y-3\\/5 {
  grid-row-gap: 60%;
  row-gap: 60%;
}
.gap-y-4\\/5 {
  grid-row-gap: 80%;
  row-gap: 80%;
}
.gap-y-1\\/6 {
  grid-row-gap: 16.666667%;
  row-gap: 16.666667%;
}
.gap-y-2\\/6 {
  grid-row-gap: 33.333333%;
  row-gap: 33.333333%;
}
.gap-y-3\\/6 {
  grid-row-gap: 50%;
  row-gap: 50%;
}
.gap-y-4\\/6 {
  grid-row-gap: 66.666667%;
  row-gap: 66.666667%;
}
.gap-y-5\\/6 {
  grid-row-gap: 83.333333%;
  row-gap: 83.333333%;
}
.gap-y-1\\/12 {
  grid-row-gap: 8.333333%;
  row-gap: 8.333333%;
}
.gap-y-2\\/12 {
  grid-row-gap: 16.666667%;
  row-gap: 16.666667%;
}
.gap-y-3\\/12 {
  grid-row-gap: 25%;
  row-gap: 25%;
}
.gap-y-4\\/12 {
  grid-row-gap: 33.333333%;
  row-gap: 33.333333%;
}
.gap-y-5\\/12 {
  grid-row-gap: 41.666667%;
  row-gap: 41.666667%;
}
.gap-y-6\\/12 {
  grid-row-gap: 50%;
  row-gap: 50%;
}
.gap-y-7\\/12 {
  grid-row-gap: 58.333333%;
  row-gap: 58.333333%;
}
.gap-y-8\\/12 {
  grid-row-gap: 66.666667%;
  row-gap: 66.666667%;
}
.gap-y-9\\/12 {
  grid-row-gap: 75%;
  row-gap: 75%;
}
.gap-y-10\\/12 {
  grid-row-gap: 83.333333%;
  row-gap: 83.333333%;
}
.gap-y-11\\/12 {
  grid-row-gap: 91.666667%;
  row-gap: 91.666667%;
}
.gap-y-full {
  grid-row-gap: 100%;
  row-gap: 100%;
}
.grid-flow-row {
  grid-auto-flow: row;
}
.grid-flow-col {
  grid-auto-flow: column;
}
.grid-flow-row-dense {
  grid-auto-flow: row dense;
}
.grid-flow-col-dense {
  grid-auto-flow: column dense;
}
.grid-cols-1 {
  grid-template-columns: repeat(1, minmax(0, 1fr));
}
.grid-cols-2 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.grid-cols-3 {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}
.grid-cols-4 {
  grid-template-columns: repeat(4, minmax(0, 1fr));
}
.grid-cols-5 {
  grid-template-columns: repeat(5, minmax(0, 1fr));
}
.grid-cols-6 {
  grid-template-columns: repeat(6, minmax(0, 1fr));
}
.grid-cols-7 {
  grid-template-columns: repeat(7, minmax(0, 1fr));
}
.grid-cols-8 {
  grid-template-columns: repeat(8, minmax(0, 1fr));
}
.grid-cols-9 {
  grid-template-columns: repeat(9, minmax(0, 1fr));
}
.grid-cols-10 {
  grid-template-columns: repeat(10, minmax(0, 1fr));
}
.grid-cols-11 {
  grid-template-columns: repeat(11, minmax(0, 1fr));
}
.grid-cols-12 {
  grid-template-columns: repeat(12, minmax(0, 1fr));
}
.grid-cols-none {
  grid-template-columns: none;
}
.auto-cols-auto {
  grid-auto-columns: auto;
}
.auto-cols-min {
  grid-auto-columns: min-content;
}
.auto-cols-max {
  grid-auto-columns: max-content;
}
.auto-cols-fr {
  grid-auto-columns: minmax(0, 1fr);
}
.col-auto {
  grid-column: auto;
}
.col-span-1 {
  grid-column: span 1 / span 1;
}
.col-span-2 {
  grid-column: span 2 / span 2;
}
.col-span-3 {
  grid-column: span 3 / span 3;
}
.col-span-4 {
  grid-column: span 4 / span 4;
}
.col-span-5 {
  grid-column: span 5 / span 5;
}
.col-span-6 {
  grid-column: span 6 / span 6;
}
.col-span-7 {
  grid-column: span 7 / span 7;
}
.col-span-8 {
  grid-column: span 8 / span 8;
}
.col-span-9 {
  grid-column: span 9 / span 9;
}
.col-span-10 {
  grid-column: span 10 / span 10;
}
.col-span-11 {
  grid-column: span 11 / span 11;
}
.col-span-12 {
  grid-column: span 12 / span 12;
}
.col-span-full {
  grid-column: 1 / -1;
}
.col-start-1 {
  grid-column-start: 1;
}
.col-start-2 {
  grid-column-start: 2;
}
.col-start-3 {
  grid-column-start: 3;
}
.col-start-4 {
  grid-column-start: 4;
}
.col-start-5 {
  grid-column-start: 5;
}
.col-start-6 {
  grid-column-start: 6;
}
.col-start-7 {
  grid-column-start: 7;
}
.col-start-8 {
  grid-column-start: 8;
}
.col-start-9 {
  grid-column-start: 9;
}
.col-start-10 {
  grid-column-start: 10;
}
.col-start-11 {
  grid-column-start: 11;
}
.col-start-12 {
  grid-column-start: 12;
}
.col-start-13 {
  grid-column-start: 13;
}
.col-start-auto {
  grid-column-start: auto;
}
.col-end-1 {
  grid-column-end: 1;
}
.col-end-2 {
  grid-column-end: 2;
}
.col-end-3 {
  grid-column-end: 3;
}
.col-end-4 {
  grid-column-end: 4;
}
.col-end-5 {
  grid-column-end: 5;
}
.col-end-6 {
  grid-column-end: 6;
}
.col-end-7 {
  grid-column-end: 7;
}
.col-end-8 {
  grid-column-end: 8;
}
.col-end-9 {
  grid-column-end: 9;
}
.col-end-10 {
  grid-column-end: 10;
}
.col-end-11 {
  grid-column-end: 11;
}
.col-end-12 {
  grid-column-end: 12;
}
.col-end-13 {
  grid-column-end: 13;
}
.col-end-auto {
  grid-column-end: auto;
}
.grid-rows-1 {
  grid-template-rows: repeat(1, minmax(0, 1fr));
}
.grid-rows-2 {
  grid-template-rows: repeat(2, minmax(0, 1fr));
}
.grid-rows-3 {
  grid-template-rows: repeat(3, minmax(0, 1fr));
}
.grid-rows-4 {
  grid-template-rows: repeat(4, minmax(0, 1fr));
}
.grid-rows-5 {
  grid-template-rows: repeat(5, minmax(0, 1fr));
}
.grid-rows-6 {
  grid-template-rows: repeat(6, minmax(0, 1fr));
}
.grid-rows-none {
  grid-template-rows: none;
}
.auto-rows-auto {
  grid-auto-rows: auto;
}
.auto-rows-min {
  grid-auto-rows: min-content;
}
.auto-rows-max {
  grid-auto-rows: max-content;
}
.auto-rows-fr {
  grid-auto-rows: minmax(0, 1fr);
}
.row-auto {
  grid-row: auto;
}
.row-span-1 {
  grid-row: span 1 / span 1;
}
.row-span-2 {
  grid-row: span 2 / span 2;
}
.row-span-3 {
  grid-row: span 3 / span 3;
}
.row-span-4 {
  grid-row: span 4 / span 4;
}
.row-span-5 {
  grid-row: span 5 / span 5;
}
.row-span-6 {
  grid-row: span 6 / span 6;
}
.row-span-full {
  grid-row: 1 / -1;
}
.row-start-1 {
  grid-row-start: 1;
}
.row-start-2 {
  grid-row-start: 2;
}
.row-start-3 {
  grid-row-start: 3;
}
.row-start-4 {
  grid-row-start: 4;
}
.row-start-5 {
  grid-row-start: 5;
}
.row-start-6 {
  grid-row-start: 6;
}
.row-start-7 {
  grid-row-start: 7;
}
.row-start-auto {
  grid-row-start: auto;
}
.row-end-1 {
  grid-row-end: 1;
}
.row-end-2 {
  grid-row-end: 2;
}
.row-end-3 {
  grid-row-end: 3;
}
.row-end-4 {
  grid-row-end: 4;
}
.row-end-5 {
  grid-row-end: 5;
}
.row-end-6 {
  grid-row-end: 6;
}
.row-end-7 {
  grid-row-end: 7;
}
.row-end-auto {
  grid-row-end: auto;
}
.transform {
  --transform-translate-x: 0;
  --transform-translate-y: 0;
  --transform-rotate: 0;
  --transform-skew-x: 0;
  --transform-skew-y: 0;
  --transform-scale-x: 1;
  --transform-scale-y: 1;
  transform: translateX(var(--transform-translate-x)) translateY(var(--transform-translate-y)) rotate(var(--transform-rotate)) skewX(var(--transform-skew-x)) skewY(var(--transform-skew-y)) scaleX(var(--transform-scale-x)) scaleY(var(--transform-scale-y));
}
.transform-none {
  transform: none;
}
.origin-center {
  transform-origin: center;
}
.origin-top {
  transform-origin: top;
}
.origin-top-right {
  transform-origin: top right;
}
.origin-right {
  transform-origin: right;
}
.origin-bottom-right {
  transform-origin: bottom right;
}
.origin-bottom {
  transform-origin: bottom;
}
.origin-bottom-left {
  transform-origin: bottom left;
}
.origin-left {
  transform-origin: left;
}
.origin-top-left {
  transform-origin: top left;
}
.scale-0 {
  --transform-scale-x: 0;
  --transform-scale-y: 0;
}
.scale-50 {
  --transform-scale-x: .5;
  --transform-scale-y: .5;
}
.scale-75 {
  --transform-scale-x: .75;
  --transform-scale-y: .75;
}
.scale-90 {
  --transform-scale-x: .9;
  --transform-scale-y: .9;
}
.scale-95 {
  --transform-scale-x: .95;
  --transform-scale-y: .95;
}
.scale-100 {
  --transform-scale-x: 1;
  --transform-scale-y: 1;
}
.scale-105 {
  --transform-scale-x: 1.05;
  --transform-scale-y: 1.05;
}
.scale-110 {
  --transform-scale-x: 1.1;
  --transform-scale-y: 1.1;
}
.scale-125 {
  --transform-scale-x: 1.25;
  --transform-scale-y: 1.25;
}
.scale-150 {
  --transform-scale-x: 1.5;
  --transform-scale-y: 1.5;
}
.scale-x-0 {
  --transform-scale-x: 0;
}
.scale-x-50 {
  --transform-scale-x: .5;
}
.scale-x-75 {
  --transform-scale-x: .75;
}
.scale-x-90 {
  --transform-scale-x: .9;
}
.scale-x-95 {
  --transform-scale-x: .95;
}
.scale-x-100 {
  --transform-scale-x: 1;
}
.scale-x-105 {
  --transform-scale-x: 1.05;
}
.scale-x-110 {
  --transform-scale-x: 1.1;
}
.scale-x-125 {
  --transform-scale-x: 1.25;
}
.scale-x-150 {
  --transform-scale-x: 1.5;
}
.scale-y-0 {
  --transform-scale-y: 0;
}
.scale-y-50 {
  --transform-scale-y: .5;
}
.scale-y-75 {
  --transform-scale-y: .75;
}
.scale-y-90 {
  --transform-scale-y: .9;
}
.scale-y-95 {
  --transform-scale-y: .95;
}
.scale-y-100 {
  --transform-scale-y: 1;
}
.scale-y-105 {
  --transform-scale-y: 1.05;
}
.scale-y-110 {
  --transform-scale-y: 1.1;
}
.scale-y-125 {
  --transform-scale-y: 1.25;
}
.scale-y-150 {
  --transform-scale-y: 1.5;
}
.hover\\:scale-0:hover {
  --transform-scale-x: 0;
  --transform-scale-y: 0;
}
.hover\\:scale-50:hover {
  --transform-scale-x: .5;
  --transform-scale-y: .5;
}
.hover\\:scale-75:hover {
  --transform-scale-x: .75;
  --transform-scale-y: .75;
}
.hover\\:scale-90:hover {
  --transform-scale-x: .9;
  --transform-scale-y: .9;
}
.hover\\:scale-95:hover {
  --transform-scale-x: .95;
  --transform-scale-y: .95;
}
.hover\\:scale-100:hover {
  --transform-scale-x: 1;
  --transform-scale-y: 1;
}
.hover\\:scale-105:hover {
  --transform-scale-x: 1.05;
  --transform-scale-y: 1.05;
}
.hover\\:scale-110:hover {
  --transform-scale-x: 1.1;
  --transform-scale-y: 1.1;
}
.hover\\:scale-125:hover {
  --transform-scale-x: 1.25;
  --transform-scale-y: 1.25;
}
.hover\\:scale-150:hover {
  --transform-scale-x: 1.5;
  --transform-scale-y: 1.5;
}
.hover\\:scale-x-0:hover {
  --transform-scale-x: 0;
}
.hover\\:scale-x-50:hover {
  --transform-scale-x: .5;
}
.hover\\:scale-x-75:hover {
  --transform-scale-x: .75;
}
.hover\\:scale-x-90:hover {
  --transform-scale-x: .9;
}
.hover\\:scale-x-95:hover {
  --transform-scale-x: .95;
}
.hover\\:scale-x-100:hover {
  --transform-scale-x: 1;
}
.hover\\:scale-x-105:hover {
  --transform-scale-x: 1.05;
}
.hover\\:scale-x-110:hover {
  --transform-scale-x: 1.1;
}
.hover\\:scale-x-125:hover {
  --transform-scale-x: 1.25;
}
.hover\\:scale-x-150:hover {
  --transform-scale-x: 1.5;
}
.hover\\:scale-y-0:hover {
  --transform-scale-y: 0;
}
.hover\\:scale-y-50:hover {
  --transform-scale-y: .5;
}
.hover\\:scale-y-75:hover {
  --transform-scale-y: .75;
}
.hover\\:scale-y-90:hover {
  --transform-scale-y: .9;
}
.hover\\:scale-y-95:hover {
  --transform-scale-y: .95;
}
.hover\\:scale-y-100:hover {
  --transform-scale-y: 1;
}
.hover\\:scale-y-105:hover {
  --transform-scale-y: 1.05;
}
.hover\\:scale-y-110:hover {
  --transform-scale-y: 1.1;
}
.hover\\:scale-y-125:hover {
  --transform-scale-y: 1.25;
}
.hover\\:scale-y-150:hover {
  --transform-scale-y: 1.5;
}
.focus\\:scale-0:focus {
  --transform-scale-x: 0;
  --transform-scale-y: 0;
}
.focus\\:scale-50:focus {
  --transform-scale-x: .5;
  --transform-scale-y: .5;
}
.focus\\:scale-75:focus {
  --transform-scale-x: .75;
  --transform-scale-y: .75;
}
.focus\\:scale-90:focus {
  --transform-scale-x: .9;
  --transform-scale-y: .9;
}
.focus\\:scale-95:focus {
  --transform-scale-x: .95;
  --transform-scale-y: .95;
}
.focus\\:scale-100:focus {
  --transform-scale-x: 1;
  --transform-scale-y: 1;
}
.focus\\:scale-105:focus {
  --transform-scale-x: 1.05;
  --transform-scale-y: 1.05;
}
.focus\\:scale-110:focus {
  --transform-scale-x: 1.1;
  --transform-scale-y: 1.1;
}
.focus\\:scale-125:focus {
  --transform-scale-x: 1.25;
  --transform-scale-y: 1.25;
}
.focus\\:scale-150:focus {
  --transform-scale-x: 1.5;
  --transform-scale-y: 1.5;
}
.focus\\:scale-x-0:focus {
  --transform-scale-x: 0;
}
.focus\\:scale-x-50:focus {
  --transform-scale-x: .5;
}
.focus\\:scale-x-75:focus {
  --transform-scale-x: .75;
}
.focus\\:scale-x-90:focus {
  --transform-scale-x: .9;
}
.focus\\:scale-x-95:focus {
  --transform-scale-x: .95;
}
.focus\\:scale-x-100:focus {
  --transform-scale-x: 1;
}
.focus\\:scale-x-105:focus {
  --transform-scale-x: 1.05;
}
.focus\\:scale-x-110:focus {
  --transform-scale-x: 1.1;
}
.focus\\:scale-x-125:focus {
  --transform-scale-x: 1.25;
}
.focus\\:scale-x-150:focus {
  --transform-scale-x: 1.5;
}
.focus\\:scale-y-0:focus {
  --transform-scale-y: 0;
}
.focus\\:scale-y-50:focus {
  --transform-scale-y: .5;
}
.focus\\:scale-y-75:focus {
  --transform-scale-y: .75;
}
.focus\\:scale-y-90:focus {
  --transform-scale-y: .9;
}
.focus\\:scale-y-95:focus {
  --transform-scale-y: .95;
}
.focus\\:scale-y-100:focus {
  --transform-scale-y: 1;
}
.focus\\:scale-y-105:focus {
  --transform-scale-y: 1.05;
}
.focus\\:scale-y-110:focus {
  --transform-scale-y: 1.1;
}
.focus\\:scale-y-125:focus {
  --transform-scale-y: 1.25;
}
.focus\\:scale-y-150:focus {
  --transform-scale-y: 1.5;
}
.rotate-0 {
  --transform-rotate: 0;
}
.rotate-1 {
  --transform-rotate: 1deg;
}
.rotate-2 {
  --transform-rotate: 2deg;
}
.rotate-3 {
  --transform-rotate: 3deg;
}
.rotate-6 {
  --transform-rotate: 6deg;
}
.rotate-12 {
  --transform-rotate: 12deg;
}
.rotate-45 {
  --transform-rotate: 45deg;
}
.rotate-90 {
  --transform-rotate: 90deg;
}
.rotate-180 {
  --transform-rotate: 180deg;
}
.-rotate-180 {
  --transform-rotate: -180deg;
}
.-rotate-90 {
  --transform-rotate: -90deg;
}
.-rotate-45 {
  --transform-rotate: -45deg;
}
.-rotate-12 {
  --transform-rotate: -12deg;
}
.-rotate-6 {
  --transform-rotate: -6deg;
}
.-rotate-3 {
  --transform-rotate: -3deg;
}
.-rotate-2 {
  --transform-rotate: -2deg;
}
.-rotate-1 {
  --transform-rotate: -1deg;
}
.hover\\:rotate-0:hover {
  --transform-rotate: 0;
}
.hover\\:rotate-1:hover {
  --transform-rotate: 1deg;
}
.hover\\:rotate-2:hover {
  --transform-rotate: 2deg;
}
.hover\\:rotate-3:hover {
  --transform-rotate: 3deg;
}
.hover\\:rotate-6:hover {
  --transform-rotate: 6deg;
}
.hover\\:rotate-12:hover {
  --transform-rotate: 12deg;
}
.hover\\:rotate-45:hover {
  --transform-rotate: 45deg;
}
.hover\\:rotate-90:hover {
  --transform-rotate: 90deg;
}
.hover\\:rotate-180:hover {
  --transform-rotate: 180deg;
}
.hover\\:-rotate-180:hover {
  --transform-rotate: -180deg;
}
.hover\\:-rotate-90:hover {
  --transform-rotate: -90deg;
}
.hover\\:-rotate-45:hover {
  --transform-rotate: -45deg;
}
.hover\\:-rotate-12:hover {
  --transform-rotate: -12deg;
}
.hover\\:-rotate-6:hover {
  --transform-rotate: -6deg;
}
.hover\\:-rotate-3:hover {
  --transform-rotate: -3deg;
}
.hover\\:-rotate-2:hover {
  --transform-rotate: -2deg;
}
.hover\\:-rotate-1:hover {
  --transform-rotate: -1deg;
}
.focus\\:rotate-0:focus {
  --transform-rotate: 0;
}
.focus\\:rotate-1:focus {
  --transform-rotate: 1deg;
}
.focus\\:rotate-2:focus {
  --transform-rotate: 2deg;
}
.focus\\:rotate-3:focus {
  --transform-rotate: 3deg;
}
.focus\\:rotate-6:focus {
  --transform-rotate: 6deg;
}
.focus\\:rotate-12:focus {
  --transform-rotate: 12deg;
}
.focus\\:rotate-45:focus {
  --transform-rotate: 45deg;
}
.focus\\:rotate-90:focus {
  --transform-rotate: 90deg;
}
.focus\\:rotate-180:focus {
  --transform-rotate: 180deg;
}
.focus\\:-rotate-180:focus {
  --transform-rotate: -180deg;
}
.focus\\:-rotate-90:focus {
  --transform-rotate: -90deg;
}
.focus\\:-rotate-45:focus {
  --transform-rotate: -45deg;
}
.focus\\:-rotate-12:focus {
  --transform-rotate: -12deg;
}
.focus\\:-rotate-6:focus {
  --transform-rotate: -6deg;
}
.focus\\:-rotate-3:focus {
  --transform-rotate: -3deg;
}
.focus\\:-rotate-2:focus {
  --transform-rotate: -2deg;
}
.focus\\:-rotate-1:focus {
  --transform-rotate: -1deg;
}
.translate-x-0 {
  --transform-translate-x: 0;
}
.translate-x-1 {
  --transform-translate-x: 0.25rem;
}
.translate-x-2 {
  --transform-translate-x: 0.5rem;
}
.translate-x-3 {
  --transform-translate-x: 0.75rem;
}
.translate-x-4 {
  --transform-translate-x: 1rem;
}
.translate-x-5 {
  --transform-translate-x: 1.25rem;
}
.translate-x-6 {
  --transform-translate-x: 1.5rem;
}
.translate-x-7 {
  --transform-translate-x: 1.75rem;
}
.translate-x-8 {
  --transform-translate-x: 2rem;
}
.translate-x-9 {
  --transform-translate-x: 2.25rem;
}
.translate-x-10 {
  --transform-translate-x: 2.5rem;
}
.translate-x-11 {
  --transform-translate-x: 2.75rem;
}
.translate-x-12 {
  --transform-translate-x: 3rem;
}
.translate-x-13 {
  --transform-translate-x: 3.25rem;
}
.translate-x-14 {
  --transform-translate-x: 3.5rem;
}
.translate-x-15 {
  --transform-translate-x: 3.75rem;
}
.translate-x-16 {
  --transform-translate-x: 4rem;
}
.translate-x-20 {
  --transform-translate-x: 5rem;
}
.translate-x-24 {
  --transform-translate-x: 6rem;
}
.translate-x-28 {
  --transform-translate-x: 7rem;
}
.translate-x-32 {
  --transform-translate-x: 8rem;
}
.translate-x-36 {
  --transform-translate-x: 9rem;
}
.translate-x-40 {
  --transform-translate-x: 10rem;
}
.translate-x-44 {
  --transform-translate-x: 11rem;
}
.translate-x-48 {
  --transform-translate-x: 12rem;
}
.translate-x-52 {
  --transform-translate-x: 13rem;
}
.translate-x-56 {
  --transform-translate-x: 14rem;
}
.translate-x-60 {
  --transform-translate-x: 15rem;
}
.translate-x-64 {
  --transform-translate-x: 16rem;
}
.translate-x-72 {
  --transform-translate-x: 18rem;
}
.translate-x-80 {
  --transform-translate-x: 20rem;
}
.translate-x-96 {
  --transform-translate-x: 24rem;
}
.translate-x-px {
  --transform-translate-x: 1px;
}
.translate-x-0\\.5 {
  --transform-translate-x: 0.125rem;
}
.translate-x-1\\.5 {
  --transform-translate-x: 0.375rem;
}
.translate-x-2\\.5 {
  --transform-translate-x: 0.625rem;
}
.translate-x-3\\.5 {
  --transform-translate-x: 0.875rem;
}
.translate-x-1\\/2 {
  --transform-translate-x: 50%;
}
.translate-x-1\\/3 {
  --transform-translate-x: 33.333333%;
}
.translate-x-2\\/3 {
  --transform-translate-x: 66.666667%;
}
.translate-x-1\\/4 {
  --transform-translate-x: 25%;
}
.translate-x-2\\/4 {
  --transform-translate-x: 50%;
}
.translate-x-3\\/4 {
  --transform-translate-x: 75%;
}
.translate-x-1\\/5 {
  --transform-translate-x: 20%;
}
.translate-x-2\\/5 {
  --transform-translate-x: 40%;
}
.translate-x-3\\/5 {
  --transform-translate-x: 60%;
}
.translate-x-4\\/5 {
  --transform-translate-x: 80%;
}
.translate-x-1\\/6 {
  --transform-translate-x: 16.666667%;
}
.translate-x-2\\/6 {
  --transform-translate-x: 33.333333%;
}
.translate-x-3\\/6 {
  --transform-translate-x: 50%;
}
.translate-x-4\\/6 {
  --transform-translate-x: 66.666667%;
}
.translate-x-5\\/6 {
  --transform-translate-x: 83.333333%;
}
.translate-x-1\\/12 {
  --transform-translate-x: 8.333333%;
}
.translate-x-2\\/12 {
  --transform-translate-x: 16.666667%;
}
.translate-x-3\\/12 {
  --transform-translate-x: 25%;
}
.translate-x-4\\/12 {
  --transform-translate-x: 33.333333%;
}
.translate-x-5\\/12 {
  --transform-translate-x: 41.666667%;
}
.translate-x-6\\/12 {
  --transform-translate-x: 50%;
}
.translate-x-7\\/12 {
  --transform-translate-x: 58.333333%;
}
.translate-x-8\\/12 {
  --transform-translate-x: 66.666667%;
}
.translate-x-9\\/12 {
  --transform-translate-x: 75%;
}
.translate-x-10\\/12 {
  --transform-translate-x: 83.333333%;
}
.translate-x-11\\/12 {
  --transform-translate-x: 91.666667%;
}
.translate-x-full {
  --transform-translate-x: 100%;
}
.-translate-x-1 {
  --transform-translate-x: -0.25rem;
}
.-translate-x-2 {
  --transform-translate-x: -0.5rem;
}
.-translate-x-3 {
  --transform-translate-x: -0.75rem;
}
.-translate-x-4 {
  --transform-translate-x: -1rem;
}
.-translate-x-5 {
  --transform-translate-x: -1.25rem;
}
.-translate-x-6 {
  --transform-translate-x: -1.5rem;
}
.-translate-x-7 {
  --transform-translate-x: -1.75rem;
}
.-translate-x-8 {
  --transform-translate-x: -2rem;
}
.-translate-x-9 {
  --transform-translate-x: -2.25rem;
}
.-translate-x-10 {
  --transform-translate-x: -2.5rem;
}
.-translate-x-11 {
  --transform-translate-x: -2.75rem;
}
.-translate-x-12 {
  --transform-translate-x: -3rem;
}
.-translate-x-13 {
  --transform-translate-x: -3.25rem;
}
.-translate-x-14 {
  --transform-translate-x: -3.5rem;
}
.-translate-x-15 {
  --transform-translate-x: -3.75rem;
}
.-translate-x-16 {
  --transform-translate-x: -4rem;
}
.-translate-x-20 {
  --transform-translate-x: -5rem;
}
.-translate-x-24 {
  --transform-translate-x: -6rem;
}
.-translate-x-28 {
  --transform-translate-x: -7rem;
}
.-translate-x-32 {
  --transform-translate-x: -8rem;
}
.-translate-x-36 {
  --transform-translate-x: -9rem;
}
.-translate-x-40 {
  --transform-translate-x: -10rem;
}
.-translate-x-44 {
  --transform-translate-x: -11rem;
}
.-translate-x-48 {
  --transform-translate-x: -12rem;
}
.-translate-x-52 {
  --transform-translate-x: -13rem;
}
.-translate-x-56 {
  --transform-translate-x: -14rem;
}
.-translate-x-60 {
  --transform-translate-x: -15rem;
}
.-translate-x-64 {
  --transform-translate-x: -16rem;
}
.-translate-x-72 {
  --transform-translate-x: -18rem;
}
.-translate-x-80 {
  --transform-translate-x: -20rem;
}
.-translate-x-96 {
  --transform-translate-x: -24rem;
}
.-translate-x-px {
  --transform-translate-x: -1px;
}
.-translate-x-0\\.5 {
  --transform-translate-x: -0.125rem;
}
.-translate-x-1\\.5 {
  --transform-translate-x: -0.375rem;
}
.-translate-x-2\\.5 {
  --transform-translate-x: -0.625rem;
}
.-translate-x-3\\.5 {
  --transform-translate-x: -0.875rem;
}
.-translate-x-1\\/2 {
  --transform-translate-x: -50%;
}
.-translate-x-1\\/3 {
  --transform-translate-x: -33.33333%;
}
.-translate-x-2\\/3 {
  --transform-translate-x: -66.66667%;
}
.-translate-x-1\\/4 {
  --transform-translate-x: -25%;
}
.-translate-x-2\\/4 {
  --transform-translate-x: -50%;
}
.-translate-x-3\\/4 {
  --transform-translate-x: -75%;
}
.-translate-x-1\\/5 {
  --transform-translate-x: -20%;
}
.-translate-x-2\\/5 {
  --transform-translate-x: -40%;
}
.-translate-x-3\\/5 {
  --transform-translate-x: -60%;
}
.-translate-x-4\\/5 {
  --transform-translate-x: -80%;
}
.-translate-x-1\\/6 {
  --transform-translate-x: -16.66667%;
}
.-translate-x-2\\/6 {
  --transform-translate-x: -33.33333%;
}
.-translate-x-3\\/6 {
  --transform-translate-x: -50%;
}
.-translate-x-4\\/6 {
  --transform-translate-x: -66.66667%;
}
.-translate-x-5\\/6 {
  --transform-translate-x: -83.33333%;
}
.-translate-x-1\\/12 {
  --transform-translate-x: -8.33333%;
}
.-translate-x-2\\/12 {
  --transform-translate-x: -16.66667%;
}
.-translate-x-3\\/12 {
  --transform-translate-x: -25%;
}
.-translate-x-4\\/12 {
  --transform-translate-x: -33.33333%;
}
.-translate-x-5\\/12 {
  --transform-translate-x: -41.66667%;
}
.-translate-x-6\\/12 {
  --transform-translate-x: -50%;
}
.-translate-x-7\\/12 {
  --transform-translate-x: -58.33333%;
}
.-translate-x-8\\/12 {
  --transform-translate-x: -66.66667%;
}
.-translate-x-9\\/12 {
  --transform-translate-x: -75%;
}
.-translate-x-10\\/12 {
  --transform-translate-x: -83.33333%;
}
.-translate-x-11\\/12 {
  --transform-translate-x: -91.66667%;
}
.-translate-x-full {
  --transform-translate-x: -100%;
}
.translate-y-0 {
  --transform-translate-y: 0;
}
.translate-y-1 {
  --transform-translate-y: 0.25rem;
}
.translate-y-2 {
  --transform-translate-y: 0.5rem;
}
.translate-y-3 {
  --transform-translate-y: 0.75rem;
}
.translate-y-4 {
  --transform-translate-y: 1rem;
}
.translate-y-5 {
  --transform-translate-y: 1.25rem;
}
.translate-y-6 {
  --transform-translate-y: 1.5rem;
}
.translate-y-7 {
  --transform-translate-y: 1.75rem;
}
.translate-y-8 {
  --transform-translate-y: 2rem;
}
.translate-y-9 {
  --transform-translate-y: 2.25rem;
}
.translate-y-10 {
  --transform-translate-y: 2.5rem;
}
.translate-y-11 {
  --transform-translate-y: 2.75rem;
}
.translate-y-12 {
  --transform-translate-y: 3rem;
}
.translate-y-13 {
  --transform-translate-y: 3.25rem;
}
.translate-y-14 {
  --transform-translate-y: 3.5rem;
}
.translate-y-15 {
  --transform-translate-y: 3.75rem;
}
.translate-y-16 {
  --transform-translate-y: 4rem;
}
.translate-y-20 {
  --transform-translate-y: 5rem;
}
.translate-y-24 {
  --transform-translate-y: 6rem;
}
.translate-y-28 {
  --transform-translate-y: 7rem;
}
.translate-y-32 {
  --transform-translate-y: 8rem;
}
.translate-y-36 {
  --transform-translate-y: 9rem;
}
.translate-y-40 {
  --transform-translate-y: 10rem;
}
.translate-y-44 {
  --transform-translate-y: 11rem;
}
.translate-y-48 {
  --transform-translate-y: 12rem;
}
.translate-y-52 {
  --transform-translate-y: 13rem;
}
.translate-y-56 {
  --transform-translate-y: 14rem;
}
.translate-y-60 {
  --transform-translate-y: 15rem;
}
.translate-y-64 {
  --transform-translate-y: 16rem;
}
.translate-y-72 {
  --transform-translate-y: 18rem;
}
.translate-y-80 {
  --transform-translate-y: 20rem;
}
.translate-y-96 {
  --transform-translate-y: 24rem;
}
.translate-y-px {
  --transform-translate-y: 1px;
}
.translate-y-0\\.5 {
  --transform-translate-y: 0.125rem;
}
.translate-y-1\\.5 {
  --transform-translate-y: 0.375rem;
}
.translate-y-2\\.5 {
  --transform-translate-y: 0.625rem;
}
.translate-y-3\\.5 {
  --transform-translate-y: 0.875rem;
}
.translate-y-1\\/2 {
  --transform-translate-y: 50%;
}
.translate-y-1\\/3 {
  --transform-translate-y: 33.333333%;
}
.translate-y-2\\/3 {
  --transform-translate-y: 66.666667%;
}
.translate-y-1\\/4 {
  --transform-translate-y: 25%;
}
.translate-y-2\\/4 {
  --transform-translate-y: 50%;
}
.translate-y-3\\/4 {
  --transform-translate-y: 75%;
}
.translate-y-1\\/5 {
  --transform-translate-y: 20%;
}
.translate-y-2\\/5 {
  --transform-translate-y: 40%;
}
.translate-y-3\\/5 {
  --transform-translate-y: 60%;
}
.translate-y-4\\/5 {
  --transform-translate-y: 80%;
}
.translate-y-1\\/6 {
  --transform-translate-y: 16.666667%;
}
.translate-y-2\\/6 {
  --transform-translate-y: 33.333333%;
}
.translate-y-3\\/6 {
  --transform-translate-y: 50%;
}
.translate-y-4\\/6 {
  --transform-translate-y: 66.666667%;
}
.translate-y-5\\/6 {
  --transform-translate-y: 83.333333%;
}
.translate-y-1\\/12 {
  --transform-translate-y: 8.333333%;
}
.translate-y-2\\/12 {
  --transform-translate-y: 16.666667%;
}
.translate-y-3\\/12 {
  --transform-translate-y: 25%;
}
.translate-y-4\\/12 {
  --transform-translate-y: 33.333333%;
}
.translate-y-5\\/12 {
  --transform-translate-y: 41.666667%;
}
.translate-y-6\\/12 {
  --transform-translate-y: 50%;
}
.translate-y-7\\/12 {
  --transform-translate-y: 58.333333%;
}
.translate-y-8\\/12 {
  --transform-translate-y: 66.666667%;
}
.translate-y-9\\/12 {
  --transform-translate-y: 75%;
}
.translate-y-10\\/12 {
  --transform-translate-y: 83.333333%;
}
.translate-y-11\\/12 {
  --transform-translate-y: 91.666667%;
}
.translate-y-full {
  --transform-translate-y: 100%;
}
.-translate-y-1 {
  --transform-translate-y: -0.25rem;
}
.-translate-y-2 {
  --transform-translate-y: -0.5rem;
}
.-translate-y-3 {
  --transform-translate-y: -0.75rem;
}
.-translate-y-4 {
  --transform-translate-y: -1rem;
}
.-translate-y-5 {
  --transform-translate-y: -1.25rem;
}
.-translate-y-6 {
  --transform-translate-y: -1.5rem;
}
.-translate-y-7 {
  --transform-translate-y: -1.75rem;
}
.-translate-y-8 {
  --transform-translate-y: -2rem;
}
.-translate-y-9 {
  --transform-translate-y: -2.25rem;
}
.-translate-y-10 {
  --transform-translate-y: -2.5rem;
}
.-translate-y-11 {
  --transform-translate-y: -2.75rem;
}
.-translate-y-12 {
  --transform-translate-y: -3rem;
}
.-translate-y-13 {
  --transform-translate-y: -3.25rem;
}
.-translate-y-14 {
  --transform-translate-y: -3.5rem;
}
.-translate-y-15 {
  --transform-translate-y: -3.75rem;
}
.-translate-y-16 {
  --transform-translate-y: -4rem;
}
.-translate-y-20 {
  --transform-translate-y: -5rem;
}
.-translate-y-24 {
  --transform-translate-y: -6rem;
}
.-translate-y-28 {
  --transform-translate-y: -7rem;
}
.-translate-y-32 {
  --transform-translate-y: -8rem;
}
.-translate-y-36 {
  --transform-translate-y: -9rem;
}
.-translate-y-40 {
  --transform-translate-y: -10rem;
}
.-translate-y-44 {
  --transform-translate-y: -11rem;
}
.-translate-y-48 {
  --transform-translate-y: -12rem;
}
.-translate-y-52 {
  --transform-translate-y: -13rem;
}
.-translate-y-56 {
  --transform-translate-y: -14rem;
}
.-translate-y-60 {
  --transform-translate-y: -15rem;
}
.-translate-y-64 {
  --transform-translate-y: -16rem;
}
.-translate-y-72 {
  --transform-translate-y: -18rem;
}
.-translate-y-80 {
  --transform-translate-y: -20rem;
}
.-translate-y-96 {
  --transform-translate-y: -24rem;
}
.-translate-y-px {
  --transform-translate-y: -1px;
}
.-translate-y-0\\.5 {
  --transform-translate-y: -0.125rem;
}
.-translate-y-1\\.5 {
  --transform-translate-y: -0.375rem;
}
.-translate-y-2\\.5 {
  --transform-translate-y: -0.625rem;
}
.-translate-y-3\\.5 {
  --transform-translate-y: -0.875rem;
}
.-translate-y-1\\/2 {
  --transform-translate-y: -50%;
}
.-translate-y-1\\/3 {
  --transform-translate-y: -33.33333%;
}
.-translate-y-2\\/3 {
  --transform-translate-y: -66.66667%;
}
.-translate-y-1\\/4 {
  --transform-translate-y: -25%;
}
.-translate-y-2\\/4 {
  --transform-translate-y: -50%;
}
.-translate-y-3\\/4 {
  --transform-translate-y: -75%;
}
.-translate-y-1\\/5 {
  --transform-translate-y: -20%;
}
.-translate-y-2\\/5 {
  --transform-translate-y: -40%;
}
.-translate-y-3\\/5 {
  --transform-translate-y: -60%;
}
.-translate-y-4\\/5 {
  --transform-translate-y: -80%;
}
.-translate-y-1\\/6 {
  --transform-translate-y: -16.66667%;
}
.-translate-y-2\\/6 {
  --transform-translate-y: -33.33333%;
}
.-translate-y-3\\/6 {
  --transform-translate-y: -50%;
}
.-translate-y-4\\/6 {
  --transform-translate-y: -66.66667%;
}
.-translate-y-5\\/6 {
  --transform-translate-y: -83.33333%;
}
.-translate-y-1\\/12 {
  --transform-translate-y: -8.33333%;
}
.-translate-y-2\\/12 {
  --transform-translate-y: -16.66667%;
}
.-translate-y-3\\/12 {
  --transform-translate-y: -25%;
}
.-translate-y-4\\/12 {
  --transform-translate-y: -33.33333%;
}
.-translate-y-5\\/12 {
  --transform-translate-y: -41.66667%;
}
.-translate-y-6\\/12 {
  --transform-translate-y: -50%;
}
.-translate-y-7\\/12 {
  --transform-translate-y: -58.33333%;
}
.-translate-y-8\\/12 {
  --transform-translate-y: -66.66667%;
}
.-translate-y-9\\/12 {
  --transform-translate-y: -75%;
}
.-translate-y-10\\/12 {
  --transform-translate-y: -83.33333%;
}
.-translate-y-11\\/12 {
  --transform-translate-y: -91.66667%;
}
.-translate-y-full {
  --transform-translate-y: -100%;
}
.hover\\:translate-x-0:hover {
  --transform-translate-x: 0;
}
.hover\\:translate-x-1:hover {
  --transform-translate-x: 0.25rem;
}
.hover\\:translate-x-2:hover {
  --transform-translate-x: 0.5rem;
}
.hover\\:translate-x-3:hover {
  --transform-translate-x: 0.75rem;
}
.hover\\:translate-x-4:hover {
  --transform-translate-x: 1rem;
}
.hover\\:translate-x-5:hover {
  --transform-translate-x: 1.25rem;
}
.hover\\:translate-x-6:hover {
  --transform-translate-x: 1.5rem;
}
.hover\\:translate-x-7:hover {
  --transform-translate-x: 1.75rem;
}
.hover\\:translate-x-8:hover {
  --transform-translate-x: 2rem;
}
.hover\\:translate-x-9:hover {
  --transform-translate-x: 2.25rem;
}
.hover\\:translate-x-10:hover {
  --transform-translate-x: 2.5rem;
}
.hover\\:translate-x-11:hover {
  --transform-translate-x: 2.75rem;
}
.hover\\:translate-x-12:hover {
  --transform-translate-x: 3rem;
}
.hover\\:translate-x-13:hover {
  --transform-translate-x: 3.25rem;
}
.hover\\:translate-x-14:hover {
  --transform-translate-x: 3.5rem;
}
.hover\\:translate-x-15:hover {
  --transform-translate-x: 3.75rem;
}
.hover\\:translate-x-16:hover {
  --transform-translate-x: 4rem;
}
.hover\\:translate-x-20:hover {
  --transform-translate-x: 5rem;
}
.hover\\:translate-x-24:hover {
  --transform-translate-x: 6rem;
}
.hover\\:translate-x-28:hover {
  --transform-translate-x: 7rem;
}
.hover\\:translate-x-32:hover {
  --transform-translate-x: 8rem;
}
.hover\\:translate-x-36:hover {
  --transform-translate-x: 9rem;
}
.hover\\:translate-x-40:hover {
  --transform-translate-x: 10rem;
}
.hover\\:translate-x-44:hover {
  --transform-translate-x: 11rem;
}
.hover\\:translate-x-48:hover {
  --transform-translate-x: 12rem;
}
.hover\\:translate-x-52:hover {
  --transform-translate-x: 13rem;
}
.hover\\:translate-x-56:hover {
  --transform-translate-x: 14rem;
}
.hover\\:translate-x-60:hover {
  --transform-translate-x: 15rem;
}
.hover\\:translate-x-64:hover {
  --transform-translate-x: 16rem;
}
.hover\\:translate-x-72:hover {
  --transform-translate-x: 18rem;
}
.hover\\:translate-x-80:hover {
  --transform-translate-x: 20rem;
}
.hover\\:translate-x-96:hover {
  --transform-translate-x: 24rem;
}
.hover\\:translate-x-px:hover {
  --transform-translate-x: 1px;
}
.hover\\:translate-x-0\\.5:hover {
  --transform-translate-x: 0.125rem;
}
.hover\\:translate-x-1\\.5:hover {
  --transform-translate-x: 0.375rem;
}
.hover\\:translate-x-2\\.5:hover {
  --transform-translate-x: 0.625rem;
}
.hover\\:translate-x-3\\.5:hover {
  --transform-translate-x: 0.875rem;
}
.hover\\:translate-x-1\\/2:hover {
  --transform-translate-x: 50%;
}
.hover\\:translate-x-1\\/3:hover {
  --transform-translate-x: 33.333333%;
}
.hover\\:translate-x-2\\/3:hover {
  --transform-translate-x: 66.666667%;
}
.hover\\:translate-x-1\\/4:hover {
  --transform-translate-x: 25%;
}
.hover\\:translate-x-2\\/4:hover {
  --transform-translate-x: 50%;
}
.hover\\:translate-x-3\\/4:hover {
  --transform-translate-x: 75%;
}
.hover\\:translate-x-1\\/5:hover {
  --transform-translate-x: 20%;
}
.hover\\:translate-x-2\\/5:hover {
  --transform-translate-x: 40%;
}
.hover\\:translate-x-3\\/5:hover {
  --transform-translate-x: 60%;
}
.hover\\:translate-x-4\\/5:hover {
  --transform-translate-x: 80%;
}
.hover\\:translate-x-1\\/6:hover {
  --transform-translate-x: 16.666667%;
}
.hover\\:translate-x-2\\/6:hover {
  --transform-translate-x: 33.333333%;
}
.hover\\:translate-x-3\\/6:hover {
  --transform-translate-x: 50%;
}
.hover\\:translate-x-4\\/6:hover {
  --transform-translate-x: 66.666667%;
}
.hover\\:translate-x-5\\/6:hover {
  --transform-translate-x: 83.333333%;
}
.hover\\:translate-x-1\\/12:hover {
  --transform-translate-x: 8.333333%;
}
.hover\\:translate-x-2\\/12:hover {
  --transform-translate-x: 16.666667%;
}
.hover\\:translate-x-3\\/12:hover {
  --transform-translate-x: 25%;
}
.hover\\:translate-x-4\\/12:hover {
  --transform-translate-x: 33.333333%;
}
.hover\\:translate-x-5\\/12:hover {
  --transform-translate-x: 41.666667%;
}
.hover\\:translate-x-6\\/12:hover {
  --transform-translate-x: 50%;
}
.hover\\:translate-x-7\\/12:hover {
  --transform-translate-x: 58.333333%;
}
.hover\\:translate-x-8\\/12:hover {
  --transform-translate-x: 66.666667%;
}
.hover\\:translate-x-9\\/12:hover {
  --transform-translate-x: 75%;
}
.hover\\:translate-x-10\\/12:hover {
  --transform-translate-x: 83.333333%;
}
.hover\\:translate-x-11\\/12:hover {
  --transform-translate-x: 91.666667%;
}
.hover\\:translate-x-full:hover {
  --transform-translate-x: 100%;
}
.hover\\:-translate-x-1:hover {
  --transform-translate-x: -0.25rem;
}
.hover\\:-translate-x-2:hover {
  --transform-translate-x: -0.5rem;
}
.hover\\:-translate-x-3:hover {
  --transform-translate-x: -0.75rem;
}
.hover\\:-translate-x-4:hover {
  --transform-translate-x: -1rem;
}
.hover\\:-translate-x-5:hover {
  --transform-translate-x: -1.25rem;
}
.hover\\:-translate-x-6:hover {
  --transform-translate-x: -1.5rem;
}
.hover\\:-translate-x-7:hover {
  --transform-translate-x: -1.75rem;
}
.hover\\:-translate-x-8:hover {
  --transform-translate-x: -2rem;
}
.hover\\:-translate-x-9:hover {
  --transform-translate-x: -2.25rem;
}
.hover\\:-translate-x-10:hover {
  --transform-translate-x: -2.5rem;
}
.hover\\:-translate-x-11:hover {
  --transform-translate-x: -2.75rem;
}
.hover\\:-translate-x-12:hover {
  --transform-translate-x: -3rem;
}
.hover\\:-translate-x-13:hover {
  --transform-translate-x: -3.25rem;
}
.hover\\:-translate-x-14:hover {
  --transform-translate-x: -3.5rem;
}
.hover\\:-translate-x-15:hover {
  --transform-translate-x: -3.75rem;
}
.hover\\:-translate-x-16:hover {
  --transform-translate-x: -4rem;
}
.hover\\:-translate-x-20:hover {
  --transform-translate-x: -5rem;
}
.hover\\:-translate-x-24:hover {
  --transform-translate-x: -6rem;
}
.hover\\:-translate-x-28:hover {
  --transform-translate-x: -7rem;
}
.hover\\:-translate-x-32:hover {
  --transform-translate-x: -8rem;
}
.hover\\:-translate-x-36:hover {
  --transform-translate-x: -9rem;
}
.hover\\:-translate-x-40:hover {
  --transform-translate-x: -10rem;
}
.hover\\:-translate-x-44:hover {
  --transform-translate-x: -11rem;
}
.hover\\:-translate-x-48:hover {
  --transform-translate-x: -12rem;
}
.hover\\:-translate-x-52:hover {
  --transform-translate-x: -13rem;
}
.hover\\:-translate-x-56:hover {
  --transform-translate-x: -14rem;
}
.hover\\:-translate-x-60:hover {
  --transform-translate-x: -15rem;
}
.hover\\:-translate-x-64:hover {
  --transform-translate-x: -16rem;
}
.hover\\:-translate-x-72:hover {
  --transform-translate-x: -18rem;
}
.hover\\:-translate-x-80:hover {
  --transform-translate-x: -20rem;
}
.hover\\:-translate-x-96:hover {
  --transform-translate-x: -24rem;
}
.hover\\:-translate-x-px:hover {
  --transform-translate-x: -1px;
}
.hover\\:-translate-x-0\\.5:hover {
  --transform-translate-x: -0.125rem;
}
.hover\\:-translate-x-1\\.5:hover {
  --transform-translate-x: -0.375rem;
}
.hover\\:-translate-x-2\\.5:hover {
  --transform-translate-x: -0.625rem;
}
.hover\\:-translate-x-3\\.5:hover {
  --transform-translate-x: -0.875rem;
}
.hover\\:-translate-x-1\\/2:hover {
  --transform-translate-x: -50%;
}
.hover\\:-translate-x-1\\/3:hover {
  --transform-translate-x: -33.33333%;
}
.hover\\:-translate-x-2\\/3:hover {
  --transform-translate-x: -66.66667%;
}
.hover\\:-translate-x-1\\/4:hover {
  --transform-translate-x: -25%;
}
.hover\\:-translate-x-2\\/4:hover {
  --transform-translate-x: -50%;
}
.hover\\:-translate-x-3\\/4:hover {
  --transform-translate-x: -75%;
}
.hover\\:-translate-x-1\\/5:hover {
  --transform-translate-x: -20%;
}
.hover\\:-translate-x-2\\/5:hover {
  --transform-translate-x: -40%;
}
.hover\\:-translate-x-3\\/5:hover {
  --transform-translate-x: -60%;
}
.hover\\:-translate-x-4\\/5:hover {
  --transform-translate-x: -80%;
}
.hover\\:-translate-x-1\\/6:hover {
  --transform-translate-x: -16.66667%;
}
.hover\\:-translate-x-2\\/6:hover {
  --transform-translate-x: -33.33333%;
}
.hover\\:-translate-x-3\\/6:hover {
  --transform-translate-x: -50%;
}
.hover\\:-translate-x-4\\/6:hover {
  --transform-translate-x: -66.66667%;
}
.hover\\:-translate-x-5\\/6:hover {
  --transform-translate-x: -83.33333%;
}
.hover\\:-translate-x-1\\/12:hover {
  --transform-translate-x: -8.33333%;
}
.hover\\:-translate-x-2\\/12:hover {
  --transform-translate-x: -16.66667%;
}
.hover\\:-translate-x-3\\/12:hover {
  --transform-translate-x: -25%;
}
.hover\\:-translate-x-4\\/12:hover {
  --transform-translate-x: -33.33333%;
}
.hover\\:-translate-x-5\\/12:hover {
  --transform-translate-x: -41.66667%;
}
.hover\\:-translate-x-6\\/12:hover {
  --transform-translate-x: -50%;
}
.hover\\:-translate-x-7\\/12:hover {
  --transform-translate-x: -58.33333%;
}
.hover\\:-translate-x-8\\/12:hover {
  --transform-translate-x: -66.66667%;
}
.hover\\:-translate-x-9\\/12:hover {
  --transform-translate-x: -75%;
}
.hover\\:-translate-x-10\\/12:hover {
  --transform-translate-x: -83.33333%;
}
.hover\\:-translate-x-11\\/12:hover {
  --transform-translate-x: -91.66667%;
}
.hover\\:-translate-x-full:hover {
  --transform-translate-x: -100%;
}
.hover\\:translate-y-0:hover {
  --transform-translate-y: 0;
}
.hover\\:translate-y-1:hover {
  --transform-translate-y: 0.25rem;
}
.hover\\:translate-y-2:hover {
  --transform-translate-y: 0.5rem;
}
.hover\\:translate-y-3:hover {
  --transform-translate-y: 0.75rem;
}
.hover\\:translate-y-4:hover {
  --transform-translate-y: 1rem;
}
.hover\\:translate-y-5:hover {
  --transform-translate-y: 1.25rem;
}
.hover\\:translate-y-6:hover {
  --transform-translate-y: 1.5rem;
}
.hover\\:translate-y-7:hover {
  --transform-translate-y: 1.75rem;
}
.hover\\:translate-y-8:hover {
  --transform-translate-y: 2rem;
}
.hover\\:translate-y-9:hover {
  --transform-translate-y: 2.25rem;
}
.hover\\:translate-y-10:hover {
  --transform-translate-y: 2.5rem;
}
.hover\\:translate-y-11:hover {
  --transform-translate-y: 2.75rem;
}
.hover\\:translate-y-12:hover {
  --transform-translate-y: 3rem;
}
.hover\\:translate-y-13:hover {
  --transform-translate-y: 3.25rem;
}
.hover\\:translate-y-14:hover {
  --transform-translate-y: 3.5rem;
}
.hover\\:translate-y-15:hover {
  --transform-translate-y: 3.75rem;
}
.hover\\:translate-y-16:hover {
  --transform-translate-y: 4rem;
}
.hover\\:translate-y-20:hover {
  --transform-translate-y: 5rem;
}
.hover\\:translate-y-24:hover {
  --transform-translate-y: 6rem;
}
.hover\\:translate-y-28:hover {
  --transform-translate-y: 7rem;
}
.hover\\:translate-y-32:hover {
  --transform-translate-y: 8rem;
}
.hover\\:translate-y-36:hover {
  --transform-translate-y: 9rem;
}
.hover\\:translate-y-40:hover {
  --transform-translate-y: 10rem;
}
.hover\\:translate-y-44:hover {
  --transform-translate-y: 11rem;
}
.hover\\:translate-y-48:hover {
  --transform-translate-y: 12rem;
}
.hover\\:translate-y-52:hover {
  --transform-translate-y: 13rem;
}
.hover\\:translate-y-56:hover {
  --transform-translate-y: 14rem;
}
.hover\\:translate-y-60:hover {
  --transform-translate-y: 15rem;
}
.hover\\:translate-y-64:hover {
  --transform-translate-y: 16rem;
}
.hover\\:translate-y-72:hover {
  --transform-translate-y: 18rem;
}
.hover\\:translate-y-80:hover {
  --transform-translate-y: 20rem;
}
.hover\\:translate-y-96:hover {
  --transform-translate-y: 24rem;
}
.hover\\:translate-y-px:hover {
  --transform-translate-y: 1px;
}
.hover\\:translate-y-0\\.5:hover {
  --transform-translate-y: 0.125rem;
}
.hover\\:translate-y-1\\.5:hover {
  --transform-translate-y: 0.375rem;
}
.hover\\:translate-y-2\\.5:hover {
  --transform-translate-y: 0.625rem;
}
.hover\\:translate-y-3\\.5:hover {
  --transform-translate-y: 0.875rem;
}
.hover\\:translate-y-1\\/2:hover {
  --transform-translate-y: 50%;
}
.hover\\:translate-y-1\\/3:hover {
  --transform-translate-y: 33.333333%;
}
.hover\\:translate-y-2\\/3:hover {
  --transform-translate-y: 66.666667%;
}
.hover\\:translate-y-1\\/4:hover {
  --transform-translate-y: 25%;
}
.hover\\:translate-y-2\\/4:hover {
  --transform-translate-y: 50%;
}
.hover\\:translate-y-3\\/4:hover {
  --transform-translate-y: 75%;
}
.hover\\:translate-y-1\\/5:hover {
  --transform-translate-y: 20%;
}
.hover\\:translate-y-2\\/5:hover {
  --transform-translate-y: 40%;
}
.hover\\:translate-y-3\\/5:hover {
  --transform-translate-y: 60%;
}
.hover\\:translate-y-4\\/5:hover {
  --transform-translate-y: 80%;
}
.hover\\:translate-y-1\\/6:hover {
  --transform-translate-y: 16.666667%;
}
.hover\\:translate-y-2\\/6:hover {
  --transform-translate-y: 33.333333%;
}
.hover\\:translate-y-3\\/6:hover {
  --transform-translate-y: 50%;
}
.hover\\:translate-y-4\\/6:hover {
  --transform-translate-y: 66.666667%;
}
.hover\\:translate-y-5\\/6:hover {
  --transform-translate-y: 83.333333%;
}
.hover\\:translate-y-1\\/12:hover {
  --transform-translate-y: 8.333333%;
}
.hover\\:translate-y-2\\/12:hover {
  --transform-translate-y: 16.666667%;
}
.hover\\:translate-y-3\\/12:hover {
  --transform-translate-y: 25%;
}
.hover\\:translate-y-4\\/12:hover {
  --transform-translate-y: 33.333333%;
}
.hover\\:translate-y-5\\/12:hover {
  --transform-translate-y: 41.666667%;
}
.hover\\:translate-y-6\\/12:hover {
  --transform-translate-y: 50%;
}
.hover\\:translate-y-7\\/12:hover {
  --transform-translate-y: 58.333333%;
}
.hover\\:translate-y-8\\/12:hover {
  --transform-translate-y: 66.666667%;
}
.hover\\:translate-y-9\\/12:hover {
  --transform-translate-y: 75%;
}
.hover\\:translate-y-10\\/12:hover {
  --transform-translate-y: 83.333333%;
}
.hover\\:translate-y-11\\/12:hover {
  --transform-translate-y: 91.666667%;
}
.hover\\:translate-y-full:hover {
  --transform-translate-y: 100%;
}
.hover\\:-translate-y-1:hover {
  --transform-translate-y: -0.25rem;
}
.hover\\:-translate-y-2:hover {
  --transform-translate-y: -0.5rem;
}
.hover\\:-translate-y-3:hover {
  --transform-translate-y: -0.75rem;
}
.hover\\:-translate-y-4:hover {
  --transform-translate-y: -1rem;
}
.hover\\:-translate-y-5:hover {
  --transform-translate-y: -1.25rem;
}
.hover\\:-translate-y-6:hover {
  --transform-translate-y: -1.5rem;
}
.hover\\:-translate-y-7:hover {
  --transform-translate-y: -1.75rem;
}
.hover\\:-translate-y-8:hover {
  --transform-translate-y: -2rem;
}
.hover\\:-translate-y-9:hover {
  --transform-translate-y: -2.25rem;
}
.hover\\:-translate-y-10:hover {
  --transform-translate-y: -2.5rem;
}
.hover\\:-translate-y-11:hover {
  --transform-translate-y: -2.75rem;
}
.hover\\:-translate-y-12:hover {
  --transform-translate-y: -3rem;
}
.hover\\:-translate-y-13:hover {
  --transform-translate-y: -3.25rem;
}
.hover\\:-translate-y-14:hover {
  --transform-translate-y: -3.5rem;
}
.hover\\:-translate-y-15:hover {
  --transform-translate-y: -3.75rem;
}
.hover\\:-translate-y-16:hover {
  --transform-translate-y: -4rem;
}
.hover\\:-translate-y-20:hover {
  --transform-translate-y: -5rem;
}
.hover\\:-translate-y-24:hover {
  --transform-translate-y: -6rem;
}
.hover\\:-translate-y-28:hover {
  --transform-translate-y: -7rem;
}
.hover\\:-translate-y-32:hover {
  --transform-translate-y: -8rem;
}
.hover\\:-translate-y-36:hover {
  --transform-translate-y: -9rem;
}
.hover\\:-translate-y-40:hover {
  --transform-translate-y: -10rem;
}
.hover\\:-translate-y-44:hover {
  --transform-translate-y: -11rem;
}
.hover\\:-translate-y-48:hover {
  --transform-translate-y: -12rem;
}
.hover\\:-translate-y-52:hover {
  --transform-translate-y: -13rem;
}
.hover\\:-translate-y-56:hover {
  --transform-translate-y: -14rem;
}
.hover\\:-translate-y-60:hover {
  --transform-translate-y: -15rem;
}
.hover\\:-translate-y-64:hover {
  --transform-translate-y: -16rem;
}
.hover\\:-translate-y-72:hover {
  --transform-translate-y: -18rem;
}
.hover\\:-translate-y-80:hover {
  --transform-translate-y: -20rem;
}
.hover\\:-translate-y-96:hover {
  --transform-translate-y: -24rem;
}
.hover\\:-translate-y-px:hover {
  --transform-translate-y: -1px;
}
.hover\\:-translate-y-0\\.5:hover {
  --transform-translate-y: -0.125rem;
}
.hover\\:-translate-y-1\\.5:hover {
  --transform-translate-y: -0.375rem;
}
.hover\\:-translate-y-2\\.5:hover {
  --transform-translate-y: -0.625rem;
}
.hover\\:-translate-y-3\\.5:hover {
  --transform-translate-y: -0.875rem;
}
.hover\\:-translate-y-1\\/2:hover {
  --transform-translate-y: -50%;
}
.hover\\:-translate-y-1\\/3:hover {
  --transform-translate-y: -33.33333%;
}
.hover\\:-translate-y-2\\/3:hover {
  --transform-translate-y: -66.66667%;
}
.hover\\:-translate-y-1\\/4:hover {
  --transform-translate-y: -25%;
}
.hover\\:-translate-y-2\\/4:hover {
  --transform-translate-y: -50%;
}
.hover\\:-translate-y-3\\/4:hover {
  --transform-translate-y: -75%;
}
.hover\\:-translate-y-1\\/5:hover {
  --transform-translate-y: -20%;
}
.hover\\:-translate-y-2\\/5:hover {
  --transform-translate-y: -40%;
}
.hover\\:-translate-y-3\\/5:hover {
  --transform-translate-y: -60%;
}
.hover\\:-translate-y-4\\/5:hover {
  --transform-translate-y: -80%;
}
.hover\\:-translate-y-1\\/6:hover {
  --transform-translate-y: -16.66667%;
}
.hover\\:-translate-y-2\\/6:hover {
  --transform-translate-y: -33.33333%;
}
.hover\\:-translate-y-3\\/6:hover {
  --transform-translate-y: -50%;
}
.hover\\:-translate-y-4\\/6:hover {
  --transform-translate-y: -66.66667%;
}
.hover\\:-translate-y-5\\/6:hover {
  --transform-translate-y: -83.33333%;
}
.hover\\:-translate-y-1\\/12:hover {
  --transform-translate-y: -8.33333%;
}
.hover\\:-translate-y-2\\/12:hover {
  --transform-translate-y: -16.66667%;
}
.hover\\:-translate-y-3\\/12:hover {
  --transform-translate-y: -25%;
}
.hover\\:-translate-y-4\\/12:hover {
  --transform-translate-y: -33.33333%;
}
.hover\\:-translate-y-5\\/12:hover {
  --transform-translate-y: -41.66667%;
}
.hover\\:-translate-y-6\\/12:hover {
  --transform-translate-y: -50%;
}
.hover\\:-translate-y-7\\/12:hover {
  --transform-translate-y: -58.33333%;
}
.hover\\:-translate-y-8\\/12:hover {
  --transform-translate-y: -66.66667%;
}
.hover\\:-translate-y-9\\/12:hover {
  --transform-translate-y: -75%;
}
.hover\\:-translate-y-10\\/12:hover {
  --transform-translate-y: -83.33333%;
}
.hover\\:-translate-y-11\\/12:hover {
  --transform-translate-y: -91.66667%;
}
.hover\\:-translate-y-full:hover {
  --transform-translate-y: -100%;
}
.focus\\:translate-x-0:focus {
  --transform-translate-x: 0;
}
.focus\\:translate-x-1:focus {
  --transform-translate-x: 0.25rem;
}
.focus\\:translate-x-2:focus {
  --transform-translate-x: 0.5rem;
}
.focus\\:translate-x-3:focus {
  --transform-translate-x: 0.75rem;
}
.focus\\:translate-x-4:focus {
  --transform-translate-x: 1rem;
}
.focus\\:translate-x-5:focus {
  --transform-translate-x: 1.25rem;
}
.focus\\:translate-x-6:focus {
  --transform-translate-x: 1.5rem;
}
.focus\\:translate-x-7:focus {
  --transform-translate-x: 1.75rem;
}
.focus\\:translate-x-8:focus {
  --transform-translate-x: 2rem;
}
.focus\\:translate-x-9:focus {
  --transform-translate-x: 2.25rem;
}
.focus\\:translate-x-10:focus {
  --transform-translate-x: 2.5rem;
}
.focus\\:translate-x-11:focus {
  --transform-translate-x: 2.75rem;
}
.focus\\:translate-x-12:focus {
  --transform-translate-x: 3rem;
}
.focus\\:translate-x-13:focus {
  --transform-translate-x: 3.25rem;
}
.focus\\:translate-x-14:focus {
  --transform-translate-x: 3.5rem;
}
.focus\\:translate-x-15:focus {
  --transform-translate-x: 3.75rem;
}
.focus\\:translate-x-16:focus {
  --transform-translate-x: 4rem;
}
.focus\\:translate-x-20:focus {
  --transform-translate-x: 5rem;
}
.focus\\:translate-x-24:focus {
  --transform-translate-x: 6rem;
}
.focus\\:translate-x-28:focus {
  --transform-translate-x: 7rem;
}
.focus\\:translate-x-32:focus {
  --transform-translate-x: 8rem;
}
.focus\\:translate-x-36:focus {
  --transform-translate-x: 9rem;
}
.focus\\:translate-x-40:focus {
  --transform-translate-x: 10rem;
}
.focus\\:translate-x-44:focus {
  --transform-translate-x: 11rem;
}
.focus\\:translate-x-48:focus {
  --transform-translate-x: 12rem;
}
.focus\\:translate-x-52:focus {
  --transform-translate-x: 13rem;
}
.focus\\:translate-x-56:focus {
  --transform-translate-x: 14rem;
}
.focus\\:translate-x-60:focus {
  --transform-translate-x: 15rem;
}
.focus\\:translate-x-64:focus {
  --transform-translate-x: 16rem;
}
.focus\\:translate-x-72:focus {
  --transform-translate-x: 18rem;
}
.focus\\:translate-x-80:focus {
  --transform-translate-x: 20rem;
}
.focus\\:translate-x-96:focus {
  --transform-translate-x: 24rem;
}
.focus\\:translate-x-px:focus {
  --transform-translate-x: 1px;
}
.focus\\:translate-x-0\\.5:focus {
  --transform-translate-x: 0.125rem;
}
.focus\\:translate-x-1\\.5:focus {
  --transform-translate-x: 0.375rem;
}
.focus\\:translate-x-2\\.5:focus {
  --transform-translate-x: 0.625rem;
}
.focus\\:translate-x-3\\.5:focus {
  --transform-translate-x: 0.875rem;
}
.focus\\:translate-x-1\\/2:focus {
  --transform-translate-x: 50%;
}
.focus\\:translate-x-1\\/3:focus {
  --transform-translate-x: 33.333333%;
}
.focus\\:translate-x-2\\/3:focus {
  --transform-translate-x: 66.666667%;
}
.focus\\:translate-x-1\\/4:focus {
  --transform-translate-x: 25%;
}
.focus\\:translate-x-2\\/4:focus {
  --transform-translate-x: 50%;
}
.focus\\:translate-x-3\\/4:focus {
  --transform-translate-x: 75%;
}
.focus\\:translate-x-1\\/5:focus {
  --transform-translate-x: 20%;
}
.focus\\:translate-x-2\\/5:focus {
  --transform-translate-x: 40%;
}
.focus\\:translate-x-3\\/5:focus {
  --transform-translate-x: 60%;
}
.focus\\:translate-x-4\\/5:focus {
  --transform-translate-x: 80%;
}
.focus\\:translate-x-1\\/6:focus {
  --transform-translate-x: 16.666667%;
}
.focus\\:translate-x-2\\/6:focus {
  --transform-translate-x: 33.333333%;
}
.focus\\:translate-x-3\\/6:focus {
  --transform-translate-x: 50%;
}
.focus\\:translate-x-4\\/6:focus {
  --transform-translate-x: 66.666667%;
}
.focus\\:translate-x-5\\/6:focus {
  --transform-translate-x: 83.333333%;
}
.focus\\:translate-x-1\\/12:focus {
  --transform-translate-x: 8.333333%;
}
.focus\\:translate-x-2\\/12:focus {
  --transform-translate-x: 16.666667%;
}
.focus\\:translate-x-3\\/12:focus {
  --transform-translate-x: 25%;
}
.focus\\:translate-x-4\\/12:focus {
  --transform-translate-x: 33.333333%;
}
.focus\\:translate-x-5\\/12:focus {
  --transform-translate-x: 41.666667%;
}
.focus\\:translate-x-6\\/12:focus {
  --transform-translate-x: 50%;
}
.focus\\:translate-x-7\\/12:focus {
  --transform-translate-x: 58.333333%;
}
.focus\\:translate-x-8\\/12:focus {
  --transform-translate-x: 66.666667%;
}
.focus\\:translate-x-9\\/12:focus {
  --transform-translate-x: 75%;
}
.focus\\:translate-x-10\\/12:focus {
  --transform-translate-x: 83.333333%;
}
.focus\\:translate-x-11\\/12:focus {
  --transform-translate-x: 91.666667%;
}
.focus\\:translate-x-full:focus {
  --transform-translate-x: 100%;
}
.focus\\:-translate-x-1:focus {
  --transform-translate-x: -0.25rem;
}
.focus\\:-translate-x-2:focus {
  --transform-translate-x: -0.5rem;
}
.focus\\:-translate-x-3:focus {
  --transform-translate-x: -0.75rem;
}
.focus\\:-translate-x-4:focus {
  --transform-translate-x: -1rem;
}
.focus\\:-translate-x-5:focus {
  --transform-translate-x: -1.25rem;
}
.focus\\:-translate-x-6:focus {
  --transform-translate-x: -1.5rem;
}
.focus\\:-translate-x-7:focus {
  --transform-translate-x: -1.75rem;
}
.focus\\:-translate-x-8:focus {
  --transform-translate-x: -2rem;
}
.focus\\:-translate-x-9:focus {
  --transform-translate-x: -2.25rem;
}
.focus\\:-translate-x-10:focus {
  --transform-translate-x: -2.5rem;
}
.focus\\:-translate-x-11:focus {
  --transform-translate-x: -2.75rem;
}
.focus\\:-translate-x-12:focus {
  --transform-translate-x: -3rem;
}
.focus\\:-translate-x-13:focus {
  --transform-translate-x: -3.25rem;
}
.focus\\:-translate-x-14:focus {
  --transform-translate-x: -3.5rem;
}
.focus\\:-translate-x-15:focus {
  --transform-translate-x: -3.75rem;
}
.focus\\:-translate-x-16:focus {
  --transform-translate-x: -4rem;
}
.focus\\:-translate-x-20:focus {
  --transform-translate-x: -5rem;
}
.focus\\:-translate-x-24:focus {
  --transform-translate-x: -6rem;
}
.focus\\:-translate-x-28:focus {
  --transform-translate-x: -7rem;
}
.focus\\:-translate-x-32:focus {
  --transform-translate-x: -8rem;
}
.focus\\:-translate-x-36:focus {
  --transform-translate-x: -9rem;
}
.focus\\:-translate-x-40:focus {
  --transform-translate-x: -10rem;
}
.focus\\:-translate-x-44:focus {
  --transform-translate-x: -11rem;
}
.focus\\:-translate-x-48:focus {
  --transform-translate-x: -12rem;
}
.focus\\:-translate-x-52:focus {
  --transform-translate-x: -13rem;
}
.focus\\:-translate-x-56:focus {
  --transform-translate-x: -14rem;
}
.focus\\:-translate-x-60:focus {
  --transform-translate-x: -15rem;
}
.focus\\:-translate-x-64:focus {
  --transform-translate-x: -16rem;
}
.focus\\:-translate-x-72:focus {
  --transform-translate-x: -18rem;
}
.focus\\:-translate-x-80:focus {
  --transform-translate-x: -20rem;
}
.focus\\:-translate-x-96:focus {
  --transform-translate-x: -24rem;
}
.focus\\:-translate-x-px:focus {
  --transform-translate-x: -1px;
}
.focus\\:-translate-x-0\\.5:focus {
  --transform-translate-x: -0.125rem;
}
.focus\\:-translate-x-1\\.5:focus {
  --transform-translate-x: -0.375rem;
}
.focus\\:-translate-x-2\\.5:focus {
  --transform-translate-x: -0.625rem;
}
.focus\\:-translate-x-3\\.5:focus {
  --transform-translate-x: -0.875rem;
}
.focus\\:-translate-x-1\\/2:focus {
  --transform-translate-x: -50%;
}
.focus\\:-translate-x-1\\/3:focus {
  --transform-translate-x: -33.33333%;
}
.focus\\:-translate-x-2\\/3:focus {
  --transform-translate-x: -66.66667%;
}
.focus\\:-translate-x-1\\/4:focus {
  --transform-translate-x: -25%;
}
.focus\\:-translate-x-2\\/4:focus {
  --transform-translate-x: -50%;
}
.focus\\:-translate-x-3\\/4:focus {
  --transform-translate-x: -75%;
}
.focus\\:-translate-x-1\\/5:focus {
  --transform-translate-x: -20%;
}
.focus\\:-translate-x-2\\/5:focus {
  --transform-translate-x: -40%;
}
.focus\\:-translate-x-3\\/5:focus {
  --transform-translate-x: -60%;
}
.focus\\:-translate-x-4\\/5:focus {
  --transform-translate-x: -80%;
}
.focus\\:-translate-x-1\\/6:focus {
  --transform-translate-x: -16.66667%;
}
.focus\\:-translate-x-2\\/6:focus {
  --transform-translate-x: -33.33333%;
}
.focus\\:-translate-x-3\\/6:focus {
  --transform-translate-x: -50%;
}
.focus\\:-translate-x-4\\/6:focus {
  --transform-translate-x: -66.66667%;
}
.focus\\:-translate-x-5\\/6:focus {
  --transform-translate-x: -83.33333%;
}
.focus\\:-translate-x-1\\/12:focus {
  --transform-translate-x: -8.33333%;
}
.focus\\:-translate-x-2\\/12:focus {
  --transform-translate-x: -16.66667%;
}
.focus\\:-translate-x-3\\/12:focus {
  --transform-translate-x: -25%;
}
.focus\\:-translate-x-4\\/12:focus {
  --transform-translate-x: -33.33333%;
}
.focus\\:-translate-x-5\\/12:focus {
  --transform-translate-x: -41.66667%;
}
.focus\\:-translate-x-6\\/12:focus {
  --transform-translate-x: -50%;
}
.focus\\:-translate-x-7\\/12:focus {
  --transform-translate-x: -58.33333%;
}
.focus\\:-translate-x-8\\/12:focus {
  --transform-translate-x: -66.66667%;
}
.focus\\:-translate-x-9\\/12:focus {
  --transform-translate-x: -75%;
}
.focus\\:-translate-x-10\\/12:focus {
  --transform-translate-x: -83.33333%;
}
.focus\\:-translate-x-11\\/12:focus {
  --transform-translate-x: -91.66667%;
}
.focus\\:-translate-x-full:focus {
  --transform-translate-x: -100%;
}
.focus\\:translate-y-0:focus {
  --transform-translate-y: 0;
}
.focus\\:translate-y-1:focus {
  --transform-translate-y: 0.25rem;
}
.focus\\:translate-y-2:focus {
  --transform-translate-y: 0.5rem;
}
.focus\\:translate-y-3:focus {
  --transform-translate-y: 0.75rem;
}
.focus\\:translate-y-4:focus {
  --transform-translate-y: 1rem;
}
.focus\\:translate-y-5:focus {
  --transform-translate-y: 1.25rem;
}
.focus\\:translate-y-6:focus {
  --transform-translate-y: 1.5rem;
}
.focus\\:translate-y-7:focus {
  --transform-translate-y: 1.75rem;
}
.focus\\:translate-y-8:focus {
  --transform-translate-y: 2rem;
}
.focus\\:translate-y-9:focus {
  --transform-translate-y: 2.25rem;
}
.focus\\:translate-y-10:focus {
  --transform-translate-y: 2.5rem;
}
.focus\\:translate-y-11:focus {
  --transform-translate-y: 2.75rem;
}
.focus\\:translate-y-12:focus {
  --transform-translate-y: 3rem;
}
.focus\\:translate-y-13:focus {
  --transform-translate-y: 3.25rem;
}
.focus\\:translate-y-14:focus {
  --transform-translate-y: 3.5rem;
}
.focus\\:translate-y-15:focus {
  --transform-translate-y: 3.75rem;
}
.focus\\:translate-y-16:focus {
  --transform-translate-y: 4rem;
}
.focus\\:translate-y-20:focus {
  --transform-translate-y: 5rem;
}
.focus\\:translate-y-24:focus {
  --transform-translate-y: 6rem;
}
.focus\\:translate-y-28:focus {
  --transform-translate-y: 7rem;
}
.focus\\:translate-y-32:focus {
  --transform-translate-y: 8rem;
}
.focus\\:translate-y-36:focus {
  --transform-translate-y: 9rem;
}
.focus\\:translate-y-40:focus {
  --transform-translate-y: 10rem;
}
.focus\\:translate-y-44:focus {
  --transform-translate-y: 11rem;
}
.focus\\:translate-y-48:focus {
  --transform-translate-y: 12rem;
}
.focus\\:translate-y-52:focus {
  --transform-translate-y: 13rem;
}
.focus\\:translate-y-56:focus {
  --transform-translate-y: 14rem;
}
.focus\\:translate-y-60:focus {
  --transform-translate-y: 15rem;
}
.focus\\:translate-y-64:focus {
  --transform-translate-y: 16rem;
}
.focus\\:translate-y-72:focus {
  --transform-translate-y: 18rem;
}
.focus\\:translate-y-80:focus {
  --transform-translate-y: 20rem;
}
.focus\\:translate-y-96:focus {
  --transform-translate-y: 24rem;
}
.focus\\:translate-y-px:focus {
  --transform-translate-y: 1px;
}
.focus\\:translate-y-0\\.5:focus {
  --transform-translate-y: 0.125rem;
}
.focus\\:translate-y-1\\.5:focus {
  --transform-translate-y: 0.375rem;
}
.focus\\:translate-y-2\\.5:focus {
  --transform-translate-y: 0.625rem;
}
.focus\\:translate-y-3\\.5:focus {
  --transform-translate-y: 0.875rem;
}
.focus\\:translate-y-1\\/2:focus {
  --transform-translate-y: 50%;
}
.focus\\:translate-y-1\\/3:focus {
  --transform-translate-y: 33.333333%;
}
.focus\\:translate-y-2\\/3:focus {
  --transform-translate-y: 66.666667%;
}
.focus\\:translate-y-1\\/4:focus {
  --transform-translate-y: 25%;
}
.focus\\:translate-y-2\\/4:focus {
  --transform-translate-y: 50%;
}
.focus\\:translate-y-3\\/4:focus {
  --transform-translate-y: 75%;
}
.focus\\:translate-y-1\\/5:focus {
  --transform-translate-y: 20%;
}
.focus\\:translate-y-2\\/5:focus {
  --transform-translate-y: 40%;
}
.focus\\:translate-y-3\\/5:focus {
  --transform-translate-y: 60%;
}
.focus\\:translate-y-4\\/5:focus {
  --transform-translate-y: 80%;
}
.focus\\:translate-y-1\\/6:focus {
  --transform-translate-y: 16.666667%;
}
.focus\\:translate-y-2\\/6:focus {
  --transform-translate-y: 33.333333%;
}
.focus\\:translate-y-3\\/6:focus {
  --transform-translate-y: 50%;
}
.focus\\:translate-y-4\\/6:focus {
  --transform-translate-y: 66.666667%;
}
.focus\\:translate-y-5\\/6:focus {
  --transform-translate-y: 83.333333%;
}
.focus\\:translate-y-1\\/12:focus {
  --transform-translate-y: 8.333333%;
}
.focus\\:translate-y-2\\/12:focus {
  --transform-translate-y: 16.666667%;
}
.focus\\:translate-y-3\\/12:focus {
  --transform-translate-y: 25%;
}
.focus\\:translate-y-4\\/12:focus {
  --transform-translate-y: 33.333333%;
}
.focus\\:translate-y-5\\/12:focus {
  --transform-translate-y: 41.666667%;
}
.focus\\:translate-y-6\\/12:focus {
  --transform-translate-y: 50%;
}
.focus\\:translate-y-7\\/12:focus {
  --transform-translate-y: 58.333333%;
}
.focus\\:translate-y-8\\/12:focus {
  --transform-translate-y: 66.666667%;
}
.focus\\:translate-y-9\\/12:focus {
  --transform-translate-y: 75%;
}
.focus\\:translate-y-10\\/12:focus {
  --transform-translate-y: 83.333333%;
}
.focus\\:translate-y-11\\/12:focus {
  --transform-translate-y: 91.666667%;
}
.focus\\:translate-y-full:focus {
  --transform-translate-y: 100%;
}
.focus\\:-translate-y-1:focus {
  --transform-translate-y: -0.25rem;
}
.focus\\:-translate-y-2:focus {
  --transform-translate-y: -0.5rem;
}
.focus\\:-translate-y-3:focus {
  --transform-translate-y: -0.75rem;
}
.focus\\:-translate-y-4:focus {
  --transform-translate-y: -1rem;
}
.focus\\:-translate-y-5:focus {
  --transform-translate-y: -1.25rem;
}
.focus\\:-translate-y-6:focus {
  --transform-translate-y: -1.5rem;
}
.focus\\:-translate-y-7:focus {
  --transform-translate-y: -1.75rem;
}
.focus\\:-translate-y-8:focus {
  --transform-translate-y: -2rem;
}
.focus\\:-translate-y-9:focus {
  --transform-translate-y: -2.25rem;
}
.focus\\:-translate-y-10:focus {
  --transform-translate-y: -2.5rem;
}
.focus\\:-translate-y-11:focus {
  --transform-translate-y: -2.75rem;
}
.focus\\:-translate-y-12:focus {
  --transform-translate-y: -3rem;
}
.focus\\:-translate-y-13:focus {
  --transform-translate-y: -3.25rem;
}
.focus\\:-translate-y-14:focus {
  --transform-translate-y: -3.5rem;
}
.focus\\:-translate-y-15:focus {
  --transform-translate-y: -3.75rem;
}
.focus\\:-translate-y-16:focus {
  --transform-translate-y: -4rem;
}
.focus\\:-translate-y-20:focus {
  --transform-translate-y: -5rem;
}
.focus\\:-translate-y-24:focus {
  --transform-translate-y: -6rem;
}
.focus\\:-translate-y-28:focus {
  --transform-translate-y: -7rem;
}
.focus\\:-translate-y-32:focus {
  --transform-translate-y: -8rem;
}
.focus\\:-translate-y-36:focus {
  --transform-translate-y: -9rem;
}
.focus\\:-translate-y-40:focus {
  --transform-translate-y: -10rem;
}
.focus\\:-translate-y-44:focus {
  --transform-translate-y: -11rem;
}
.focus\\:-translate-y-48:focus {
  --transform-translate-y: -12rem;
}
.focus\\:-translate-y-52:focus {
  --transform-translate-y: -13rem;
}
.focus\\:-translate-y-56:focus {
  --transform-translate-y: -14rem;
}
.focus\\:-translate-y-60:focus {
  --transform-translate-y: -15rem;
}
.focus\\:-translate-y-64:focus {
  --transform-translate-y: -16rem;
}
.focus\\:-translate-y-72:focus {
  --transform-translate-y: -18rem;
}
.focus\\:-translate-y-80:focus {
  --transform-translate-y: -20rem;
}
.focus\\:-translate-y-96:focus {
  --transform-translate-y: -24rem;
}
.focus\\:-translate-y-px:focus {
  --transform-translate-y: -1px;
}
.focus\\:-translate-y-0\\.5:focus {
  --transform-translate-y: -0.125rem;
}
.focus\\:-translate-y-1\\.5:focus {
  --transform-translate-y: -0.375rem;
}
.focus\\:-translate-y-2\\.5:focus {
  --transform-translate-y: -0.625rem;
}
.focus\\:-translate-y-3\\.5:focus {
  --transform-translate-y: -0.875rem;
}
.focus\\:-translate-y-1\\/2:focus {
  --transform-translate-y: -50%;
}
.focus\\:-translate-y-1\\/3:focus {
  --transform-translate-y: -33.33333%;
}
.focus\\:-translate-y-2\\/3:focus {
  --transform-translate-y: -66.66667%;
}
.focus\\:-translate-y-1\\/4:focus {
  --transform-translate-y: -25%;
}
.focus\\:-translate-y-2\\/4:focus {
  --transform-translate-y: -50%;
}
.focus\\:-translate-y-3\\/4:focus {
  --transform-translate-y: -75%;
}
.focus\\:-translate-y-1\\/5:focus {
  --transform-translate-y: -20%;
}
.focus\\:-translate-y-2\\/5:focus {
  --transform-translate-y: -40%;
}
.focus\\:-translate-y-3\\/5:focus {
  --transform-translate-y: -60%;
}
.focus\\:-translate-y-4\\/5:focus {
  --transform-translate-y: -80%;
}
.focus\\:-translate-y-1\\/6:focus {
  --transform-translate-y: -16.66667%;
}
.focus\\:-translate-y-2\\/6:focus {
  --transform-translate-y: -33.33333%;
}
.focus\\:-translate-y-3\\/6:focus {
  --transform-translate-y: -50%;
}
.focus\\:-translate-y-4\\/6:focus {
  --transform-translate-y: -66.66667%;
}
.focus\\:-translate-y-5\\/6:focus {
  --transform-translate-y: -83.33333%;
}
.focus\\:-translate-y-1\\/12:focus {
  --transform-translate-y: -8.33333%;
}
.focus\\:-translate-y-2\\/12:focus {
  --transform-translate-y: -16.66667%;
}
.focus\\:-translate-y-3\\/12:focus {
  --transform-translate-y: -25%;
}
.focus\\:-translate-y-4\\/12:focus {
  --transform-translate-y: -33.33333%;
}
.focus\\:-translate-y-5\\/12:focus {
  --transform-translate-y: -41.66667%;
}
.focus\\:-translate-y-6\\/12:focus {
  --transform-translate-y: -50%;
}
.focus\\:-translate-y-7\\/12:focus {
  --transform-translate-y: -58.33333%;
}
.focus\\:-translate-y-8\\/12:focus {
  --transform-translate-y: -66.66667%;
}
.focus\\:-translate-y-9\\/12:focus {
  --transform-translate-y: -75%;
}
.focus\\:-translate-y-10\\/12:focus {
  --transform-translate-y: -83.33333%;
}
.focus\\:-translate-y-11\\/12:focus {
  --transform-translate-y: -91.66667%;
}
.focus\\:-translate-y-full:focus {
  --transform-translate-y: -100%;
}
.skew-x-0 {
  --transform-skew-x: 0;
}
.skew-x-1 {
  --transform-skew-x: 1deg;
}
.skew-x-2 {
  --transform-skew-x: 2deg;
}
.skew-x-3 {
  --transform-skew-x: 3deg;
}
.skew-x-6 {
  --transform-skew-x: 6deg;
}
.skew-x-12 {
  --transform-skew-x: 12deg;
}
.-skew-x-12 {
  --transform-skew-x: -12deg;
}
.-skew-x-6 {
  --transform-skew-x: -6deg;
}
.-skew-x-3 {
  --transform-skew-x: -3deg;
}
.-skew-x-2 {
  --transform-skew-x: -2deg;
}
.-skew-x-1 {
  --transform-skew-x: -1deg;
}
.skew-y-0 {
  --transform-skew-y: 0;
}
.skew-y-1 {
  --transform-skew-y: 1deg;
}
.skew-y-2 {
  --transform-skew-y: 2deg;
}
.skew-y-3 {
  --transform-skew-y: 3deg;
}
.skew-y-6 {
  --transform-skew-y: 6deg;
}
.skew-y-12 {
  --transform-skew-y: 12deg;
}
.-skew-y-12 {
  --transform-skew-y: -12deg;
}
.-skew-y-6 {
  --transform-skew-y: -6deg;
}
.-skew-y-3 {
  --transform-skew-y: -3deg;
}
.-skew-y-2 {
  --transform-skew-y: -2deg;
}
.-skew-y-1 {
  --transform-skew-y: -1deg;
}
.hover\\:skew-x-0:hover {
  --transform-skew-x: 0;
}
.hover\\:skew-x-1:hover {
  --transform-skew-x: 1deg;
}
.hover\\:skew-x-2:hover {
  --transform-skew-x: 2deg;
}
.hover\\:skew-x-3:hover {
  --transform-skew-x: 3deg;
}
.hover\\:skew-x-6:hover {
  --transform-skew-x: 6deg;
}
.hover\\:skew-x-12:hover {
  --transform-skew-x: 12deg;
}
.hover\\:-skew-x-12:hover {
  --transform-skew-x: -12deg;
}
.hover\\:-skew-x-6:hover {
  --transform-skew-x: -6deg;
}
.hover\\:-skew-x-3:hover {
  --transform-skew-x: -3deg;
}
.hover\\:-skew-x-2:hover {
  --transform-skew-x: -2deg;
}
.hover\\:-skew-x-1:hover {
  --transform-skew-x: -1deg;
}
.hover\\:skew-y-0:hover {
  --transform-skew-y: 0;
}
.hover\\:skew-y-1:hover {
  --transform-skew-y: 1deg;
}
.hover\\:skew-y-2:hover {
  --transform-skew-y: 2deg;
}
.hover\\:skew-y-3:hover {
  --transform-skew-y: 3deg;
}
.hover\\:skew-y-6:hover {
  --transform-skew-y: 6deg;
}
.hover\\:skew-y-12:hover {
  --transform-skew-y: 12deg;
}
.hover\\:-skew-y-12:hover {
  --transform-skew-y: -12deg;
}
.hover\\:-skew-y-6:hover {
  --transform-skew-y: -6deg;
}
.hover\\:-skew-y-3:hover {
  --transform-skew-y: -3deg;
}
.hover\\:-skew-y-2:hover {
  --transform-skew-y: -2deg;
}
.hover\\:-skew-y-1:hover {
  --transform-skew-y: -1deg;
}
.focus\\:skew-x-0:focus {
  --transform-skew-x: 0;
}
.focus\\:skew-x-1:focus {
  --transform-skew-x: 1deg;
}
.focus\\:skew-x-2:focus {
  --transform-skew-x: 2deg;
}
.focus\\:skew-x-3:focus {
  --transform-skew-x: 3deg;
}
.focus\\:skew-x-6:focus {
  --transform-skew-x: 6deg;
}
.focus\\:skew-x-12:focus {
  --transform-skew-x: 12deg;
}
.focus\\:-skew-x-12:focus {
  --transform-skew-x: -12deg;
}
.focus\\:-skew-x-6:focus {
  --transform-skew-x: -6deg;
}
.focus\\:-skew-x-3:focus {
  --transform-skew-x: -3deg;
}
.focus\\:-skew-x-2:focus {
  --transform-skew-x: -2deg;
}
.focus\\:-skew-x-1:focus {
  --transform-skew-x: -1deg;
}
.focus\\:skew-y-0:focus {
  --transform-skew-y: 0;
}
.focus\\:skew-y-1:focus {
  --transform-skew-y: 1deg;
}
.focus\\:skew-y-2:focus {
  --transform-skew-y: 2deg;
}
.focus\\:skew-y-3:focus {
  --transform-skew-y: 3deg;
}
.focus\\:skew-y-6:focus {
  --transform-skew-y: 6deg;
}
.focus\\:skew-y-12:focus {
  --transform-skew-y: 12deg;
}
.focus\\:-skew-y-12:focus {
  --transform-skew-y: -12deg;
}
.focus\\:-skew-y-6:focus {
  --transform-skew-y: -6deg;
}
.focus\\:-skew-y-3:focus {
  --transform-skew-y: -3deg;
}
.focus\\:-skew-y-2:focus {
  --transform-skew-y: -2deg;
}
.focus\\:-skew-y-1:focus {
  --transform-skew-y: -1deg;
}
.transition-none {
  transition-property: none;
}
.transition-all {
  transition-property: all;
}
.transition {
  transition-property: background-color, border-color, color, fill, stroke, opacity, box-shadow, transform;
}
.transition-colors {
  transition-property: background-color, border-color, color, fill, stroke;
}
.transition-opacity {
  transition-property: opacity;
}
.transition-shadow {
  transition-property: box-shadow;
}
.transition-transform {
  transition-property: transform;
}
.ease-linear {
  transition-timing-function: linear;
}
.ease-in {
  transition-timing-function: cubic-bezier(0.4, 0, 1, 1);
}
.ease-out {
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
}
.ease-in-out {
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
.duration-75 {
  transition-duration: 75ms;
}
.duration-100 {
  transition-duration: 100ms;
}
.duration-150 {
  transition-duration: 150ms;
}
.duration-200 {
  transition-duration: 200ms;
}
.duration-300 {
  transition-duration: 300ms;
}
.duration-500 {
  transition-duration: 500ms;
}
.duration-700 {
  transition-duration: 700ms;
}
.duration-1000 {
  transition-duration: 1000ms;
}
.delay-75 {
  transition-delay: 75ms;
}
.delay-100 {
  transition-delay: 100ms;
}
.delay-150 {
  transition-delay: 150ms;
}
.delay-200 {
  transition-delay: 200ms;
}
.delay-300 {
  transition-delay: 300ms;
}
.delay-500 {
  transition-delay: 500ms;
}
.delay-700 {
  transition-delay: 700ms;
}
.delay-1000 {
  transition-delay: 1000ms;
}
@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
@keyframes ping {
  75%, 100% {
    transform: scale(2);
    opacity: 0;
  }
}
@keyframes pulse {
  50% {
    opacity: .5;
  }
}
@keyframes bounce {
  0%, 100% {
    transform: translateY(-25%);
    animation-timing-function: cubic-bezier(0.8, 0, 1, 1);
  }
  50% {
    transform: none;
    animation-timing-function: cubic-bezier(0, 0, 0.2, 1);
  }
}
.animate-none {
  animation: none;
}
.animate-spin {
  animation: spin 1s linear infinite;
}
.animate-ping {
  animation: ping 1s cubic-bezier(0, 0, 0.2, 1) infinite;
}
.animate-pulse {
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}
.animate-bounce {
  animation: bounce 1s infinite;
}
@media (min-width: 640px) {
  .sm\\:container {
    width: 100%;
  }
  @media (min-width: 640px) {
    .sm\\:container {
      max-width: 640px;
    }
  }
  @media (min-width: 768px) {
    .sm\\:container {
      max-width: 768px;
    }
  }
  @media (min-width: 1024px) {
    .sm\\:container {
      max-width: 1024px;
    }
  }
  @media (min-width: 1280px) {
    .sm\\:container {
      max-width: 1280px;
    }
  }
  .sm\\:prose {
    color: #374151;
    max-width: 65ch;
  }
  .sm\\:prose [class~="lead"] {
    color: #4b5563;
    font-size: 1.25em;
    line-height: 1.6;
    margin-top: 1.2em;
    margin-bottom: 1.2em;
  }
  .sm\\:prose a {
    color: #5850ec;
    text-decoration: none;
    font-weight: 600;
  }
  .sm\\:prose strong {
    color: #161e2e;
    font-weight: 600;
  }
  .sm\\:prose ol {
    counter-reset: list-counter;
    margin-top: 1.25em;
    margin-bottom: 1.25em;
  }
  .sm\\:prose ol>li {
    position: relative;
    counter-increment: list-counter;
    padding-left: 1.75em;
  }
  .sm\\:prose ol>li::before {
    content: counter(list-counter) ".";
    position: absolute;
    font-weight: 400;
    color: #6b7280;
  }
  .sm\\:prose ul>li {
    position: relative;
    padding-left: 1.75em;
  }
  .sm\\:prose ul>li::before {
    content: "";
    position: absolute;
    background-color: #d2d6dc;
    border-radius: 50%;
    width: 0.375em;
    height: 0.375em;
    top: calc(0.875em - 0.1875em);
    left: 0.25em;
  }
  .sm\\:prose hr {
    border-color: #e5e7eb;
    border-top-width: 1px;
    margin-top: 3em;
    margin-bottom: 3em;
  }
  .sm\\:prose blockquote {
    font-weight: 500;
    font-style: italic;
    color: #161e2e;
    border-left-width: 0.25rem;
    border-left-color: #e5e7eb;
    quotes: "\\201C" "\\201D" "\\2018" "\\2019";
    margin-top: 1.6em;
    margin-bottom: 1.6em;
    padding-left: 1em;
  }
  .sm\\:prose blockquote p:first-of-type::before {
    content: open-quote;
  }
  .sm\\:prose blockquote p:last-of-type::after {
    content: close-quote;
  }
  .sm\\:prose h1 {
    color: #1a202c;
    font-weight: 800;
    font-size: 2.25em;
    margin-top: 0;
    margin-bottom: 0.8888889em;
    line-height: 1.1111111;
  }
  .sm\\:prose h2 {
    color: #1a202c;
    font-weight: 700;
    font-size: 1.5em;
    margin-top: 2em;
    margin-bottom: 1em;
    line-height: 1.3333333;
  }
  .sm\\:prose h3 {
    color: #1a202c;
    font-weight: 600;
    font-size: 1.25em;
    margin-top: 1.6em;
    margin-bottom: 0.6em;
    line-height: 1.6;
  }
  .sm\\:prose h4 {
    color: #1a202c;
    font-weight: 600;
    margin-top: 1.5em;
    margin-bottom: 0.5em;
    line-height: 1.5;
  }
  .sm\\:prose figure figcaption {
    color: #6b7280;
    font-size: 0.875em;
    line-height: 1.4285714;
    margin-top: 0.8571429em;
  }
  .sm\\:prose code {
    color: #161e2e;
    font-weight: 600;
    font-size: 0.875em;
  }
  .sm\\:prose code::before {
    content: "\`";
  }
  .sm\\:prose code::after {
    content: "\`";
  }
  .sm\\:prose pre {
    color: #e5e7eb;
    background-color: #252f3f;
    overflow-x: auto;
    font-size: 0.875em;
    line-height: 1.7142857;
    margin-top: 1.7142857em;
    margin-bottom: 1.7142857em;
    border-radius: 0.375rem;
    padding-top: 0.8571429em;
    padding-right: 1.1428571em;
    padding-bottom: 0.8571429em;
    padding-left: 1.1428571em;
  }
  .sm\\:prose pre code {
    background-color: transparent;
    border-width: 0;
    border-radius: 0;
    padding: 0;
    font-weight: 400;
    color: inherit;
    font-size: inherit;
    font-family: inherit;
    line-height: inherit;
  }
  .sm\\:prose pre code::before {
    content: "";
  }
  .sm\\:prose pre code::after {
    content: "";
  }
  .sm\\:prose table {
    width: 100%;
    table-layout: auto;
    text-align: left;
    margin-top: 2em;
    margin-bottom: 2em;
    font-size: 0.875em;
    line-height: 1.7142857;
  }
  .sm\\:prose thead {
    color: #161e2e;
    font-weight: 600;
    border-bottom-width: 1px;
    border-bottom-color: #d2d6dc;
  }
  .sm\\:prose thead th {
    vertical-align: bottom;
    padding-right: 0.5714286em;
    padding-bottom: 0.5714286em;
    padding-left: 0.5714286em;
  }
  .sm\\:prose tbody tr {
    border-bottom-width: 1px;
    border-bottom-color: #e5e7eb;
  }
  .sm\\:prose tbody tr:last-child {
    border-bottom-width: 0;
  }
  .sm\\:prose tbody td {
    vertical-align: top;
    padding-top: 0.5714286em;
    padding-right: 0.5714286em;
    padding-bottom: 0.5714286em;
    padding-left: 0.5714286em;
  }
  .sm\\:prose {
    font-size: 1rem;
    line-height: 1.75;
  }
  .sm\\:prose p {
    margin-top: 1.25em;
    margin-bottom: 1.25em;
  }
  .sm\\:prose img {
    margin-top: 2em;
    margin-bottom: 2em;
  }
  .sm\\:prose video {
    margin-top: 2em;
    margin-bottom: 2em;
  }
  .sm\\:prose figure {
    margin-top: 2em;
    margin-bottom: 2em;
  }
  .sm\\:prose figure>* {
    margin-top: 0;
    margin-bottom: 0;
  }
  .sm\\:prose h2 code {
    font-size: 0.875em;
  }
  .sm\\:prose h3 code {
    font-size: 0.9em;
  }
  .sm\\:prose ul {
    margin-top: 1.25em;
    margin-bottom: 1.25em;
  }
  .sm\\:prose li {
    margin-top: 0.5em;
    margin-bottom: 0.5em;
  }
  .sm\\:prose ol>li:before {
    left: 0;
  }
  .sm\\:prose>ul>li p {
    margin-top: 0.75em;
    margin-bottom: 0.75em;
  }
  .sm\\:prose>ul>li>*:first-child {
    margin-top: 1.25em;
  }
  .sm\\:prose>ul>li>*:last-child {
    margin-bottom: 1.25em;
  }
  .sm\\:prose>ol>li>*:first-child {
    margin-top: 1.25em;
  }
  .sm\\:prose>ol>li>*:last-child {
    margin-bottom: 1.25em;
  }
  .sm\\:prose ul ul, .sm\\:prose ul ol, .sm\\:prose ol ul, .sm\\:prose ol ol {
    margin-top: 0.75em;
    margin-bottom: 0.75em;
  }
  .sm\\:prose hr+* {
    margin-top: 0;
  }
  .sm\\:prose h2+* {
    margin-top: 0;
  }
  .sm\\:prose h3+* {
    margin-top: 0;
  }
  .sm\\:prose h4+* {
    margin-top: 0;
  }
  .sm\\:prose thead th:first-child {
    padding-left: 0;
  }
  .sm\\:prose thead th:last-child {
    padding-right: 0;
  }
  .sm\\:prose tbody td:first-child {
    padding-left: 0;
  }
  .sm\\:prose tbody td:last-child {
    padding-right: 0;
  }
  .sm\\:prose> :first-child {
    margin-top: 0;
  }
  .sm\\:prose> :last-child {
    margin-bottom: 0;
  }
  .sm\\:prose h1, .sm\\:prose h2, .sm\\:prose h3, .sm\\:prose h4 {
    color: #161e2e;
  }
  .sm\\:prose-sm {
    font-size: 0.875rem;
    line-height: 1.7142857;
  }
  .sm\\:prose-sm p {
    margin-top: 1.1428571em;
    margin-bottom: 1.1428571em;
  }
  .sm\\:prose-sm [class~="lead"] {
    font-size: 1.2857143em;
    line-height: 1.5555556;
    margin-top: 0.8888889em;
    margin-bottom: 0.8888889em;
  }
  .sm\\:prose-sm blockquote {
    margin-top: 1.3333333em;
    margin-bottom: 1.3333333em;
    padding-left: 1.1111111em;
  }
  .sm\\:prose-sm h1 {
    font-size: 2.1428571em;
    margin-top: 0;
    margin-bottom: 0.8em;
    line-height: 1.2;
  }
  .sm\\:prose-sm h2 {
    font-size: 1.4285714em;
    margin-top: 1.6em;
    margin-bottom: 0.8em;
    line-height: 1.4;
  }
  .sm\\:prose-sm h3 {
    font-size: 1.2857143em;
    margin-top: 1.5555556em;
    margin-bottom: 0.4444444em;
    line-height: 1.5555556;
  }
  .sm\\:prose-sm h4 {
    margin-top: 1.4285714em;
    margin-bottom: 0.5714286em;
    line-height: 1.4285714;
  }
  .sm\\:prose-sm img {
    margin-top: 1.7142857em;
    margin-bottom: 1.7142857em;
  }
  .sm\\:prose-sm video {
    margin-top: 1.7142857em;
    margin-bottom: 1.7142857em;
  }
  .sm\\:prose-sm figure {
    margin-top: 1.7142857em;
    margin-bottom: 1.7142857em;
  }
  .sm\\:prose-sm figure>* {
    margin-top: 0;
    margin-bottom: 0;
  }
  .sm\\:prose-sm figure figcaption {
    font-size: 0.8571429em;
    line-height: 1.3333333;
    margin-top: 0.6666667em;
  }
  .sm\\:prose-sm code {
    font-size: 0.8571429em;
  }
  .sm\\:prose-sm h2 code {
    font-size: 0.9em;
  }
  .sm\\:prose-sm h3 code {
    font-size: 0.8888889em;
  }
  .sm\\:prose-sm pre {
    font-size: 0.8571429em;
    line-height: 1.6666667;
    margin-top: 1.6666667em;
    margin-bottom: 1.6666667em;
    border-radius: 0.25rem;
    padding-top: 0.6666667em;
    padding-right: 1em;
    padding-bottom: 0.6666667em;
    padding-left: 1em;
  }
  .sm\\:prose-sm ol {
    margin-top: 1.1428571em;
    margin-bottom: 1.1428571em;
  }
  .sm\\:prose-sm ul {
    margin-top: 1.1428571em;
    margin-bottom: 1.1428571em;
  }
  .sm\\:prose-sm li {
    margin-top: 0.2857143em;
    margin-bottom: 0.2857143em;
  }
  .sm\\:prose-sm ol>li {
    padding-left: 1.5714286em;
  }
  .sm\\:prose-sm ol>li:before {
    left: 0;
  }
  .sm\\:prose-sm ul>li {
    padding-left: 1.5714286em;
  }
  .sm\\:prose-sm ul>li::before {
    height: 0.3571429em;
    width: 0.3571429em;
    top: calc(0.8571429em - 0.1785714em);
    left: 0.2142857em;
  }
  .sm\\:prose-sm>ul>li p {
    margin-top: 0.5714286em;
    margin-bottom: 0.5714286em;
  }
  .sm\\:prose-sm>ul>li>*:first-child {
    margin-top: 1.1428571em;
  }
  .sm\\:prose-sm>ul>li>*:last-child {
    margin-bottom: 1.1428571em;
  }
  .sm\\:prose-sm>ol>li>*:first-child {
    margin-top: 1.1428571em;
  }
  .sm\\:prose-sm>ol>li>*:last-child {
    margin-bottom: 1.1428571em;
  }
  .sm\\:prose-sm ul ul, .sm\\:prose-sm ul ol, .sm\\:prose-sm ol ul, .sm\\:prose-sm ol ol {
    margin-top: 0.5714286em;
    margin-bottom: 0.5714286em;
  }
  .sm\\:prose-sm hr {
    margin-top: 2.8571429em;
    margin-bottom: 2.8571429em;
  }
  .sm\\:prose-sm hr+* {
    margin-top: 0;
  }
  .sm\\:prose-sm h2+* {
    margin-top: 0;
  }
  .sm\\:prose-sm h3+* {
    margin-top: 0;
  }
  .sm\\:prose-sm h4+* {
    margin-top: 0;
  }
  .sm\\:prose-sm table {
    font-size: 0.8571429em;
    line-height: 1.5;
  }
  .sm\\:prose-sm thead th {
    padding-right: 1em;
    padding-bottom: 0.6666667em;
    padding-left: 1em;
  }
  .sm\\:prose-sm thead th:first-child {
    padding-left: 0;
  }
  .sm\\:prose-sm thead th:last-child {
    padding-right: 0;
  }
  .sm\\:prose-sm tbody td {
    padding-top: 0.6666667em;
    padding-right: 1em;
    padding-bottom: 0.6666667em;
    padding-left: 1em;
  }
  .sm\\:prose-sm tbody td:first-child {
    padding-left: 0;
  }
  .sm\\:prose-sm tbody td:last-child {
    padding-right: 0;
  }
  .sm\\:prose-sm> :first-child {
    margin-top: 0;
  }
  .sm\\:prose-sm> :last-child {
    margin-bottom: 0;
  }
  .sm\\:prose-lg {
    font-size: 1.125rem;
    line-height: 1.7777778;
  }
  .sm\\:prose-lg p {
    margin-top: 1.3333333em;
    margin-bottom: 1.3333333em;
  }
  .sm\\:prose-lg [class~="lead"] {
    font-size: 1.2222222em;
    line-height: 1.4545455;
    margin-top: 1.0909091em;
    margin-bottom: 1.0909091em;
  }
  .sm\\:prose-lg blockquote {
    margin-top: 1.6666667em;
    margin-bottom: 1.6666667em;
    padding-left: 1em;
  }
  .sm\\:prose-lg h1 {
    font-size: 2.6666667em;
    margin-top: 0;
    margin-bottom: 0.8333333em;
    line-height: 1;
  }
  .sm\\:prose-lg h2 {
    font-size: 1.6666667em;
    margin-top: 1.8666667em;
    margin-bottom: 1.0666667em;
    line-height: 1.3333333;
  }
  .sm\\:prose-lg h3 {
    font-size: 1.3333333em;
    margin-top: 1.6666667em;
    margin-bottom: 0.6666667em;
    line-height: 1.5;
  }
  .sm\\:prose-lg h4 {
    margin-top: 1.7777778em;
    margin-bottom: 0.4444444em;
    line-height: 1.5555556;
  }
  .sm\\:prose-lg img {
    margin-top: 1.7777778em;
    margin-bottom: 1.7777778em;
  }
  .sm\\:prose-lg video {
    margin-top: 1.7777778em;
    margin-bottom: 1.7777778em;
  }
  .sm\\:prose-lg figure {
    margin-top: 1.7777778em;
    margin-bottom: 1.7777778em;
  }
  .sm\\:prose-lg figure>* {
    margin-top: 0;
    margin-bottom: 0;
  }
  .sm\\:prose-lg figure figcaption {
    font-size: 0.8888889em;
    line-height: 1.5;
    margin-top: 1em;
  }
  .sm\\:prose-lg code {
    font-size: 0.8888889em;
  }
  .sm\\:prose-lg h2 code {
    font-size: 0.8666667em;
  }
  .sm\\:prose-lg h3 code {
    font-size: 0.875em;
  }
  .sm\\:prose-lg pre {
    font-size: 0.8888889em;
    line-height: 1.75;
    margin-top: 2em;
    margin-bottom: 2em;
    border-radius: 0.375rem;
    padding-top: 1em;
    padding-right: 1.5em;
    padding-bottom: 1em;
    padding-left: 1.5em;
  }
  .sm\\:prose-lg ol {
    margin-top: 1.3333333em;
    margin-bottom: 1.3333333em;
  }
  .sm\\:prose-lg ul {
    margin-top: 1.3333333em;
    margin-bottom: 1.3333333em;
  }
  .sm\\:prose-lg li {
    margin-top: 0.6666667em;
    margin-bottom: 0.6666667em;
  }
  .sm\\:prose-lg ol>li {
    padding-left: 1.6666667em;
  }
  .sm\\:prose-lg ol>li:before {
    left: 0;
  }
  .sm\\:prose-lg ul>li {
    padding-left: 1.6666667em;
  }
  .sm\\:prose-lg ul>li::before {
    width: 0.3333333em;
    height: 0.3333333em;
    top: calc(0.8888889em - 0.1666667em);
    left: 0.2222222em;
  }
  .sm\\:prose-lg>ul>li p {
    margin-top: 0.8888889em;
    margin-bottom: 0.8888889em;
  }
  .sm\\:prose-lg>ul>li>*:first-child {
    margin-top: 1.3333333em;
  }
  .sm\\:prose-lg>ul>li>*:last-child {
    margin-bottom: 1.3333333em;
  }
  .sm\\:prose-lg>ol>li>*:first-child {
    margin-top: 1.3333333em;
  }
  .sm\\:prose-lg>ol>li>*:last-child {
    margin-bottom: 1.3333333em;
  }
  .sm\\:prose-lg ul ul, .sm\\:prose-lg ul ol, .sm\\:prose-lg ol ul, .sm\\:prose-lg ol ol {
    margin-top: 0.8888889em;
    margin-bottom: 0.8888889em;
  }
  .sm\\:prose-lg hr {
    margin-top: 3.1111111em;
    margin-bottom: 3.1111111em;
  }
  .sm\\:prose-lg hr+* {
    margin-top: 0;
  }
  .sm\\:prose-lg h2+* {
    margin-top: 0;
  }
  .sm\\:prose-lg h3+* {
    margin-top: 0;
  }
  .sm\\:prose-lg h4+* {
    margin-top: 0;
  }
  .sm\\:prose-lg table {
    font-size: 0.8888889em;
    line-height: 1.5;
  }
  .sm\\:prose-lg thead th {
    padding-right: 0.75em;
    padding-bottom: 0.75em;
    padding-left: 0.75em;
  }
  .sm\\:prose-lg thead th:first-child {
    padding-left: 0;
  }
  .sm\\:prose-lg thead th:last-child {
    padding-right: 0;
  }
  .sm\\:prose-lg tbody td {
    padding-top: 0.75em;
    padding-right: 0.75em;
    padding-bottom: 0.75em;
    padding-left: 0.75em;
  }
  .sm\\:prose-lg tbody td:first-child {
    padding-left: 0;
  }
  .sm\\:prose-lg tbody td:last-child {
    padding-right: 0;
  }
  .sm\\:prose-lg> :first-child {
    margin-top: 0;
  }
  .sm\\:prose-lg> :last-child {
    margin-bottom: 0;
  }
  .sm\\:prose-xl {
    font-size: 1.25rem;
    line-height: 1.8;
  }
  .sm\\:prose-xl p {
    margin-top: 1.2em;
    margin-bottom: 1.2em;
  }
  .sm\\:prose-xl [class~="lead"] {
    font-size: 1.2em;
    line-height: 1.5;
    margin-top: 1em;
    margin-bottom: 1em;
  }
  .sm\\:prose-xl blockquote {
    margin-top: 1.6em;
    margin-bottom: 1.6em;
    padding-left: 1.0666667em;
  }
  .sm\\:prose-xl h1 {
    font-size: 2.8em;
    margin-top: 0;
    margin-bottom: 0.8571429em;
    line-height: 1;
  }
  .sm\\:prose-xl h2 {
    font-size: 1.8em;
    margin-top: 1.5555556em;
    margin-bottom: 0.8888889em;
    line-height: 1.1111111;
  }
  .sm\\:prose-xl h3 {
    font-size: 1.5em;
    margin-top: 1.6em;
    margin-bottom: 0.6666667em;
    line-height: 1.3333333;
  }
  .sm\\:prose-xl h4 {
    margin-top: 1.8em;
    margin-bottom: 0.6em;
    line-height: 1.6;
  }
  .sm\\:prose-xl img {
    margin-top: 2em;
    margin-bottom: 2em;
  }
  .sm\\:prose-xl video {
    margin-top: 2em;
    margin-bottom: 2em;
  }
  .sm\\:prose-xl figure {
    margin-top: 2em;
    margin-bottom: 2em;
  }
  .sm\\:prose-xl figure>* {
    margin-top: 0;
    margin-bottom: 0;
  }
  .sm\\:prose-xl figure figcaption {
    font-size: 0.9em;
    line-height: 1.5555556;
    margin-top: 1em;
  }
  .sm\\:prose-xl code {
    font-size: 0.9em;
  }
  .sm\\:prose-xl h2 code {
    font-size: 0.8611111em;
  }
  .sm\\:prose-xl h3 code {
    font-size: 0.9em;
  }
  .sm\\:prose-xl pre {
    font-size: 0.9em;
    line-height: 1.7777778;
    margin-top: 2em;
    margin-bottom: 2em;
    border-radius: 0.5rem;
    padding-top: 1.1111111em;
    padding-right: 1.3333333em;
    padding-bottom: 1.1111111em;
    padding-left: 1.3333333em;
  }
  .sm\\:prose-xl ol {
    margin-top: 1.2em;
    margin-bottom: 1.2em;
  }
  .sm\\:prose-xl ul {
    margin-top: 1.2em;
    margin-bottom: 1.2em;
  }
  .sm\\:prose-xl li {
    margin-top: 0.6em;
    margin-bottom: 0.6em;
  }
  .sm\\:prose-xl ol>li {
    padding-left: 1.8em;
  }
  .sm\\:prose-xl ol>li:before {
    left: 0;
  }
  .sm\\:prose-xl ul>li {
    padding-left: 1.8em;
  }
  .sm\\:prose-xl ul>li::before {
    width: 0.35em;
    height: 0.35em;
    top: calc(0.9em - 0.175em);
    left: 0.25em;
  }
  .sm\\:prose-xl>ul>li p {
    margin-top: 0.8em;
    margin-bottom: 0.8em;
  }
  .sm\\:prose-xl>ul>li>*:first-child {
    margin-top: 1.2em;
  }
  .sm\\:prose-xl>ul>li>*:last-child {
    margin-bottom: 1.2em;
  }
  .sm\\:prose-xl>ol>li>*:first-child {
    margin-top: 1.2em;
  }
  .sm\\:prose-xl>ol>li>*:last-child {
    margin-bottom: 1.2em;
  }
  .sm\\:prose-xl ul ul, .sm\\:prose-xl ul ol, .sm\\:prose-xl ol ul, .sm\\:prose-xl ol ol {
    margin-top: 0.8em;
    margin-bottom: 0.8em;
  }
  .sm\\:prose-xl hr {
    margin-top: 2.8em;
    margin-bottom: 2.8em;
  }
  .sm\\:prose-xl hr+* {
    margin-top: 0;
  }
  .sm\\:prose-xl h2+* {
    margin-top: 0;
  }
  .sm\\:prose-xl h3+* {
    margin-top: 0;
  }
  .sm\\:prose-xl h4+* {
    margin-top: 0;
  }
  .sm\\:prose-xl table {
    font-size: 0.9em;
    line-height: 1.5555556;
  }
  .sm\\:prose-xl thead th {
    padding-right: 0.6666667em;
    padding-bottom: 0.8888889em;
    padding-left: 0.6666667em;
  }
  .sm\\:prose-xl thead th:first-child {
    padding-left: 0;
  }
  .sm\\:prose-xl thead th:last-child {
    padding-right: 0;
  }
  .sm\\:prose-xl tbody td {
    padding-top: 0.8888889em;
    padding-right: 0.6666667em;
    padding-bottom: 0.8888889em;
    padding-left: 0.6666667em;
  }
  .sm\\:prose-xl tbody td:first-child {
    padding-left: 0;
  }
  .sm\\:prose-xl tbody td:last-child {
    padding-right: 0;
  }
  .sm\\:prose-xl> :first-child {
    margin-top: 0;
  }
  .sm\\:prose-xl> :last-child {
    margin-bottom: 0;
  }
  .sm\\:prose-2xl {
    font-size: 1.5rem;
    line-height: 1.6666667;
  }
  .sm\\:prose-2xl p {
    margin-top: 1.3333333em;
    margin-bottom: 1.3333333em;
  }
  .sm\\:prose-2xl [class~="lead"] {
    font-size: 1.25em;
    line-height: 1.4666667;
    margin-top: 1.0666667em;
    margin-bottom: 1.0666667em;
  }
  .sm\\:prose-2xl blockquote {
    margin-top: 1.7777778em;
    margin-bottom: 1.7777778em;
    padding-left: 1.1111111em;
  }
  .sm\\:prose-2xl h1 {
    font-size: 2.6666667em;
    margin-top: 0;
    margin-bottom: 0.875em;
    line-height: 1;
  }
  .sm\\:prose-2xl h2 {
    font-size: 2em;
    margin-top: 1.5em;
    margin-bottom: 0.8333333em;
    line-height: 1.0833333;
  }
  .sm\\:prose-2xl h3 {
    font-size: 1.5em;
    margin-top: 1.5555556em;
    margin-bottom: 0.6666667em;
    line-height: 1.2222222;
  }
  .sm\\:prose-2xl h4 {
    margin-top: 1.6666667em;
    margin-bottom: 0.6666667em;
    line-height: 1.5;
  }
  .sm\\:prose-2xl img {
    margin-top: 2em;
    margin-bottom: 2em;
  }
  .sm\\:prose-2xl video {
    margin-top: 2em;
    margin-bottom: 2em;
  }
  .sm\\:prose-2xl figure {
    margin-top: 2em;
    margin-bottom: 2em;
  }
  .sm\\:prose-2xl figure>* {
    margin-top: 0;
    margin-bottom: 0;
  }
  .sm\\:prose-2xl figure figcaption {
    font-size: 0.8333333em;
    line-height: 1.6;
    margin-top: 1em;
  }
  .sm\\:prose-2xl code {
    font-size: 0.8333333em;
  }
  .sm\\:prose-2xl h2 code {
    font-size: 0.875em;
  }
  .sm\\:prose-2xl h3 code {
    font-size: 0.8888889em;
  }
  .sm\\:prose-2xl pre {
    font-size: 0.8333333em;
    line-height: 1.8;
    margin-top: 2em;
    margin-bottom: 2em;
    border-radius: 0.5rem;
    padding-top: 1.2em;
    padding-right: 1.6em;
    padding-bottom: 1.2em;
    padding-left: 1.6em;
  }
  .sm\\:prose-2xl ol {
    margin-top: 1.3333333em;
    margin-bottom: 1.3333333em;
  }
  .sm\\:prose-2xl ul {
    margin-top: 1.3333333em;
    margin-bottom: 1.3333333em;
  }
  .sm\\:prose-2xl li {
    margin-top: 0.5em;
    margin-bottom: 0.5em;
  }
  .sm\\:prose-2xl ol>li {
    padding-left: 1.6666667em;
  }
  .sm\\:prose-2xl ol>li:before {
    left: 0;
  }
  .sm\\:prose-2xl ul>li {
    padding-left: 1.6666667em;
  }
  .sm\\:prose-2xl ul>li::before {
    width: 0.3333333em;
    height: 0.3333333em;
    top: calc(0.8333333em - 0.1666667em);
    left: 0.25em;
  }
  .sm\\:prose-2xl>ul>li p {
    margin-top: 0.8333333em;
    margin-bottom: 0.8333333em;
  }
  .sm\\:prose-2xl>ul>li>*:first-child {
    margin-top: 1.3333333em;
  }
  .sm\\:prose-2xl>ul>li>*:last-child {
    margin-bottom: 1.3333333em;
  }
  .sm\\:prose-2xl>ol>li>*:first-child {
    margin-top: 1.3333333em;
  }
  .sm\\:prose-2xl>ol>li>*:last-child {
    margin-bottom: 1.3333333em;
  }
  .sm\\:prose-2xl ul ul, .sm\\:prose-2xl ul ol, .sm\\:prose-2xl ol ul, .sm\\:prose-2xl ol ol {
    margin-top: 0.6666667em;
    margin-bottom: 0.6666667em;
  }
  .sm\\:prose-2xl hr {
    margin-top: 3em;
    margin-bottom: 3em;
  }
  .sm\\:prose-2xl hr+* {
    margin-top: 0;
  }
  .sm\\:prose-2xl h2+* {
    margin-top: 0;
  }
  .sm\\:prose-2xl h3+* {
    margin-top: 0;
  }
  .sm\\:prose-2xl h4+* {
    margin-top: 0;
  }
  .sm\\:prose-2xl table {
    font-size: 0.8333333em;
    line-height: 1.4;
  }
  .sm\\:prose-2xl thead th {
    padding-right: 0.6em;
    padding-bottom: 0.8em;
    padding-left: 0.6em;
  }
  .sm\\:prose-2xl thead th:first-child {
    padding-left: 0;
  }
  .sm\\:prose-2xl thead th:last-child {
    padding-right: 0;
  }
  .sm\\:prose-2xl tbody td {
    padding-top: 0.8em;
    padding-right: 0.6em;
    padding-bottom: 0.8em;
    padding-left: 0.6em;
  }
  .sm\\:prose-2xl tbody td:first-child {
    padding-left: 0;
  }
  .sm\\:prose-2xl tbody td:last-child {
    padding-right: 0;
  }
  .sm\\:prose-2xl> :first-child {
    margin-top: 0;
  }
  .sm\\:prose-2xl> :last-child {
    margin-bottom: 0;
  }
  .sm\\:space-y-0> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(0px * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(0px * var(--space-y-reverse));
  }
  .sm\\:space-x-0> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(0px * var(--space-x-reverse));
    margin-left: calc(0px * calc(1 - var(--space-x-reverse)));
  }
  .sm\\:space-y-1> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(0.25rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(0.25rem * var(--space-y-reverse));
  }
  .sm\\:space-x-1> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(0.25rem * var(--space-x-reverse));
    margin-left: calc(0.25rem * calc(1 - var(--space-x-reverse)));
  }
  .sm\\:space-y-2> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(0.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(0.5rem * var(--space-y-reverse));
  }
  .sm\\:space-x-2> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(0.5rem * var(--space-x-reverse));
    margin-left: calc(0.5rem * calc(1 - var(--space-x-reverse)));
  }
  .sm\\:space-y-3> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(0.75rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(0.75rem * var(--space-y-reverse));
  }
  .sm\\:space-x-3> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(0.75rem * var(--space-x-reverse));
    margin-left: calc(0.75rem * calc(1 - var(--space-x-reverse)));
  }
  .sm\\:space-y-4> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(1rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(1rem * var(--space-y-reverse));
  }
  .sm\\:space-x-4> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(1rem * var(--space-x-reverse));
    margin-left: calc(1rem * calc(1 - var(--space-x-reverse)));
  }
  .sm\\:space-y-5> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(1.25rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(1.25rem * var(--space-y-reverse));
  }
  .sm\\:space-x-5> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(1.25rem * var(--space-x-reverse));
    margin-left: calc(1.25rem * calc(1 - var(--space-x-reverse)));
  }
  .sm\\:space-y-6> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(1.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(1.5rem * var(--space-y-reverse));
  }
  .sm\\:space-x-6> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(1.5rem * var(--space-x-reverse));
    margin-left: calc(1.5rem * calc(1 - var(--space-x-reverse)));
  }
  .sm\\:space-y-7> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(1.75rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(1.75rem * var(--space-y-reverse));
  }
  .sm\\:space-x-7> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(1.75rem * var(--space-x-reverse));
    margin-left: calc(1.75rem * calc(1 - var(--space-x-reverse)));
  }
  .sm\\:space-y-8> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(2rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(2rem * var(--space-y-reverse));
  }
  .sm\\:space-x-8> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(2rem * var(--space-x-reverse));
    margin-left: calc(2rem * calc(1 - var(--space-x-reverse)));
  }
  .sm\\:space-y-9> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(2.25rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(2.25rem * var(--space-y-reverse));
  }
  .sm\\:space-x-9> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(2.25rem * var(--space-x-reverse));
    margin-left: calc(2.25rem * calc(1 - var(--space-x-reverse)));
  }
  .sm\\:space-y-10> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(2.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(2.5rem * var(--space-y-reverse));
  }
  .sm\\:space-x-10> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(2.5rem * var(--space-x-reverse));
    margin-left: calc(2.5rem * calc(1 - var(--space-x-reverse)));
  }
  .sm\\:space-y-11> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(2.75rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(2.75rem * var(--space-y-reverse));
  }
  .sm\\:space-x-11> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(2.75rem * var(--space-x-reverse));
    margin-left: calc(2.75rem * calc(1 - var(--space-x-reverse)));
  }
  .sm\\:space-y-12> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(3rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(3rem * var(--space-y-reverse));
  }
  .sm\\:space-x-12> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(3rem * var(--space-x-reverse));
    margin-left: calc(3rem * calc(1 - var(--space-x-reverse)));
  }
  .sm\\:space-y-13> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(3.25rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(3.25rem * var(--space-y-reverse));
  }
  .sm\\:space-x-13> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(3.25rem * var(--space-x-reverse));
    margin-left: calc(3.25rem * calc(1 - var(--space-x-reverse)));
  }
  .sm\\:space-y-14> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(3.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(3.5rem * var(--space-y-reverse));
  }
  .sm\\:space-x-14> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(3.5rem * var(--space-x-reverse));
    margin-left: calc(3.5rem * calc(1 - var(--space-x-reverse)));
  }
  .sm\\:space-y-15> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(3.75rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(3.75rem * var(--space-y-reverse));
  }
  .sm\\:space-x-15> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(3.75rem * var(--space-x-reverse));
    margin-left: calc(3.75rem * calc(1 - var(--space-x-reverse)));
  }
  .sm\\:space-y-16> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(4rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(4rem * var(--space-y-reverse));
  }
  .sm\\:space-x-16> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(4rem * var(--space-x-reverse));
    margin-left: calc(4rem * calc(1 - var(--space-x-reverse)));
  }
  .sm\\:space-y-20> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(5rem * var(--space-y-reverse));
  }
  .sm\\:space-x-20> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(5rem * var(--space-x-reverse));
    margin-left: calc(5rem * calc(1 - var(--space-x-reverse)));
  }
  .sm\\:space-y-24> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(6rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(6rem * var(--space-y-reverse));
  }
  .sm\\:space-x-24> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(6rem * var(--space-x-reverse));
    margin-left: calc(6rem * calc(1 - var(--space-x-reverse)));
  }
  .sm\\:space-y-28> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(7rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(7rem * var(--space-y-reverse));
  }
  .sm\\:space-x-28> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(7rem * var(--space-x-reverse));
    margin-left: calc(7rem * calc(1 - var(--space-x-reverse)));
  }
  .sm\\:space-y-32> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(8rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(8rem * var(--space-y-reverse));
  }
  .sm\\:space-x-32> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(8rem * var(--space-x-reverse));
    margin-left: calc(8rem * calc(1 - var(--space-x-reverse)));
  }
  .sm\\:space-y-36> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(9rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(9rem * var(--space-y-reverse));
  }
  .sm\\:space-x-36> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(9rem * var(--space-x-reverse));
    margin-left: calc(9rem * calc(1 - var(--space-x-reverse)));
  }
  .sm\\:space-y-40> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(10rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(10rem * var(--space-y-reverse));
  }
  .sm\\:space-x-40> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(10rem * var(--space-x-reverse));
    margin-left: calc(10rem * calc(1 - var(--space-x-reverse)));
  }
  .sm\\:space-y-44> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(11rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(11rem * var(--space-y-reverse));
  }
  .sm\\:space-x-44> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(11rem * var(--space-x-reverse));
    margin-left: calc(11rem * calc(1 - var(--space-x-reverse)));
  }
  .sm\\:space-y-48> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(12rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(12rem * var(--space-y-reverse));
  }
  .sm\\:space-x-48> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(12rem * var(--space-x-reverse));
    margin-left: calc(12rem * calc(1 - var(--space-x-reverse)));
  }
  .sm\\:space-y-52> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(13rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(13rem * var(--space-y-reverse));
  }
  .sm\\:space-x-52> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(13rem * var(--space-x-reverse));
    margin-left: calc(13rem * calc(1 - var(--space-x-reverse)));
  }
  .sm\\:space-y-56> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(14rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(14rem * var(--space-y-reverse));
  }
  .sm\\:space-x-56> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(14rem * var(--space-x-reverse));
    margin-left: calc(14rem * calc(1 - var(--space-x-reverse)));
  }
  .sm\\:space-y-60> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(15rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(15rem * var(--space-y-reverse));
  }
  .sm\\:space-x-60> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(15rem * var(--space-x-reverse));
    margin-left: calc(15rem * calc(1 - var(--space-x-reverse)));
  }
  .sm\\:space-y-64> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(16rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(16rem * var(--space-y-reverse));
  }
  .sm\\:space-x-64> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(16rem * var(--space-x-reverse));
    margin-left: calc(16rem * calc(1 - var(--space-x-reverse)));
  }
  .sm\\:space-y-72> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(18rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(18rem * var(--space-y-reverse));
  }
  .sm\\:space-x-72> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(18rem * var(--space-x-reverse));
    margin-left: calc(18rem * calc(1 - var(--space-x-reverse)));
  }
  .sm\\:space-y-80> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(20rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(20rem * var(--space-y-reverse));
  }
  .sm\\:space-x-80> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(20rem * var(--space-x-reverse));
    margin-left: calc(20rem * calc(1 - var(--space-x-reverse)));
  }
  .sm\\:space-y-96> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(24rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(24rem * var(--space-y-reverse));
  }
  .sm\\:space-x-96> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(24rem * var(--space-x-reverse));
    margin-left: calc(24rem * calc(1 - var(--space-x-reverse)));
  }
  .sm\\:space-y-px> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(1px * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(1px * var(--space-y-reverse));
  }
  .sm\\:space-x-px> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(1px * var(--space-x-reverse));
    margin-left: calc(1px * calc(1 - var(--space-x-reverse)));
  }
  .sm\\:space-y-0\\.5> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(0.125rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(0.125rem * var(--space-y-reverse));
  }
  .sm\\:space-x-0\\.5> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(0.125rem * var(--space-x-reverse));
    margin-left: calc(0.125rem * calc(1 - var(--space-x-reverse)));
  }
  .sm\\:space-y-1\\.5> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(0.375rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(0.375rem * var(--space-y-reverse));
  }
  .sm\\:space-x-1\\.5> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(0.375rem * var(--space-x-reverse));
    margin-left: calc(0.375rem * calc(1 - var(--space-x-reverse)));
  }
  .sm\\:space-y-2\\.5> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(0.625rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(0.625rem * var(--space-y-reverse));
  }
  .sm\\:space-x-2\\.5> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(0.625rem * var(--space-x-reverse));
    margin-left: calc(0.625rem * calc(1 - var(--space-x-reverse)));
  }
  .sm\\:space-y-3\\.5> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(0.875rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(0.875rem * var(--space-y-reverse));
  }
  .sm\\:space-x-3\\.5> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(0.875rem * var(--space-x-reverse));
    margin-left: calc(0.875rem * calc(1 - var(--space-x-reverse)));
  }
  .sm\\:space-y-1\\/2> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(50% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(50% * var(--space-y-reverse));
  }
  .sm\\:space-x-1\\/2> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(50% * var(--space-x-reverse));
    margin-left: calc(50% * calc(1 - var(--space-x-reverse)));
  }
  .sm\\:space-y-1\\/3> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(33.333333% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(33.333333% * var(--space-y-reverse));
  }
  .sm\\:space-x-1\\/3> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(33.333333% * var(--space-x-reverse));
    margin-left: calc(33.333333% * calc(1 - var(--space-x-reverse)));
  }
  .sm\\:space-y-2\\/3> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(66.666667% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(66.666667% * var(--space-y-reverse));
  }
  .sm\\:space-x-2\\/3> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(66.666667% * var(--space-x-reverse));
    margin-left: calc(66.666667% * calc(1 - var(--space-x-reverse)));
  }
  .sm\\:space-y-1\\/4> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(25% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(25% * var(--space-y-reverse));
  }
  .sm\\:space-x-1\\/4> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(25% * var(--space-x-reverse));
    margin-left: calc(25% * calc(1 - var(--space-x-reverse)));
  }
  .sm\\:space-y-2\\/4> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(50% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(50% * var(--space-y-reverse));
  }
  .sm\\:space-x-2\\/4> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(50% * var(--space-x-reverse));
    margin-left: calc(50% * calc(1 - var(--space-x-reverse)));
  }
  .sm\\:space-y-3\\/4> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(75% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(75% * var(--space-y-reverse));
  }
  .sm\\:space-x-3\\/4> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(75% * var(--space-x-reverse));
    margin-left: calc(75% * calc(1 - var(--space-x-reverse)));
  }
  .sm\\:space-y-1\\/5> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(20% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(20% * var(--space-y-reverse));
  }
  .sm\\:space-x-1\\/5> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(20% * var(--space-x-reverse));
    margin-left: calc(20% * calc(1 - var(--space-x-reverse)));
  }
  .sm\\:space-y-2\\/5> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(40% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(40% * var(--space-y-reverse));
  }
  .sm\\:space-x-2\\/5> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(40% * var(--space-x-reverse));
    margin-left: calc(40% * calc(1 - var(--space-x-reverse)));
  }
  .sm\\:space-y-3\\/5> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(60% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(60% * var(--space-y-reverse));
  }
  .sm\\:space-x-3\\/5> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(60% * var(--space-x-reverse));
    margin-left: calc(60% * calc(1 - var(--space-x-reverse)));
  }
  .sm\\:space-y-4\\/5> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(80% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(80% * var(--space-y-reverse));
  }
  .sm\\:space-x-4\\/5> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(80% * var(--space-x-reverse));
    margin-left: calc(80% * calc(1 - var(--space-x-reverse)));
  }
  .sm\\:space-y-1\\/6> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(16.666667% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(16.666667% * var(--space-y-reverse));
  }
  .sm\\:space-x-1\\/6> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(16.666667% * var(--space-x-reverse));
    margin-left: calc(16.666667% * calc(1 - var(--space-x-reverse)));
  }
  .sm\\:space-y-2\\/6> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(33.333333% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(33.333333% * var(--space-y-reverse));
  }
  .sm\\:space-x-2\\/6> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(33.333333% * var(--space-x-reverse));
    margin-left: calc(33.333333% * calc(1 - var(--space-x-reverse)));
  }
  .sm\\:space-y-3\\/6> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(50% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(50% * var(--space-y-reverse));
  }
  .sm\\:space-x-3\\/6> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(50% * var(--space-x-reverse));
    margin-left: calc(50% * calc(1 - var(--space-x-reverse)));
  }
  .sm\\:space-y-4\\/6> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(66.666667% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(66.666667% * var(--space-y-reverse));
  }
  .sm\\:space-x-4\\/6> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(66.666667% * var(--space-x-reverse));
    margin-left: calc(66.666667% * calc(1 - var(--space-x-reverse)));
  }
  .sm\\:space-y-5\\/6> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(83.333333% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(83.333333% * var(--space-y-reverse));
  }
  .sm\\:space-x-5\\/6> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(83.333333% * var(--space-x-reverse));
    margin-left: calc(83.333333% * calc(1 - var(--space-x-reverse)));
  }
  .sm\\:space-y-1\\/12> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(8.333333% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(8.333333% * var(--space-y-reverse));
  }
  .sm\\:space-x-1\\/12> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(8.333333% * var(--space-x-reverse));
    margin-left: calc(8.333333% * calc(1 - var(--space-x-reverse)));
  }
  .sm\\:space-y-2\\/12> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(16.666667% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(16.666667% * var(--space-y-reverse));
  }
  .sm\\:space-x-2\\/12> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(16.666667% * var(--space-x-reverse));
    margin-left: calc(16.666667% * calc(1 - var(--space-x-reverse)));
  }
  .sm\\:space-y-3\\/12> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(25% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(25% * var(--space-y-reverse));
  }
  .sm\\:space-x-3\\/12> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(25% * var(--space-x-reverse));
    margin-left: calc(25% * calc(1 - var(--space-x-reverse)));
  }
  .sm\\:space-y-4\\/12> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(33.333333% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(33.333333% * var(--space-y-reverse));
  }
  .sm\\:space-x-4\\/12> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(33.333333% * var(--space-x-reverse));
    margin-left: calc(33.333333% * calc(1 - var(--space-x-reverse)));
  }
  .sm\\:space-y-5\\/12> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(41.666667% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(41.666667% * var(--space-y-reverse));
  }
  .sm\\:space-x-5\\/12> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(41.666667% * var(--space-x-reverse));
    margin-left: calc(41.666667% * calc(1 - var(--space-x-reverse)));
  }
  .sm\\:space-y-6\\/12> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(50% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(50% * var(--space-y-reverse));
  }
  .sm\\:space-x-6\\/12> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(50% * var(--space-x-reverse));
    margin-left: calc(50% * calc(1 - var(--space-x-reverse)));
  }
  .sm\\:space-y-7\\/12> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(58.333333% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(58.333333% * var(--space-y-reverse));
  }
  .sm\\:space-x-7\\/12> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(58.333333% * var(--space-x-reverse));
    margin-left: calc(58.333333% * calc(1 - var(--space-x-reverse)));
  }
  .sm\\:space-y-8\\/12> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(66.666667% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(66.666667% * var(--space-y-reverse));
  }
  .sm\\:space-x-8\\/12> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(66.666667% * var(--space-x-reverse));
    margin-left: calc(66.666667% * calc(1 - var(--space-x-reverse)));
  }
  .sm\\:space-y-9\\/12> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(75% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(75% * var(--space-y-reverse));
  }
  .sm\\:space-x-9\\/12> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(75% * var(--space-x-reverse));
    margin-left: calc(75% * calc(1 - var(--space-x-reverse)));
  }
  .sm\\:space-y-10\\/12> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(83.333333% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(83.333333% * var(--space-y-reverse));
  }
  .sm\\:space-x-10\\/12> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(83.333333% * var(--space-x-reverse));
    margin-left: calc(83.333333% * calc(1 - var(--space-x-reverse)));
  }
  .sm\\:space-y-11\\/12> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(91.666667% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(91.666667% * var(--space-y-reverse));
  }
  .sm\\:space-x-11\\/12> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(91.666667% * var(--space-x-reverse));
    margin-left: calc(91.666667% * calc(1 - var(--space-x-reverse)));
  }
  .sm\\:space-y-full> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(100% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(100% * var(--space-y-reverse));
  }
  .sm\\:space-x-full> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(100% * var(--space-x-reverse));
    margin-left: calc(100% * calc(1 - var(--space-x-reverse)));
  }
  .sm\\:-space-y-1> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-0.25rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-0.25rem * var(--space-y-reverse));
  }
  .sm\\:-space-x-1> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-0.25rem * var(--space-x-reverse));
    margin-left: calc(-0.25rem * calc(1 - var(--space-x-reverse)));
  }
  .sm\\:-space-y-2> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-0.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-0.5rem * var(--space-y-reverse));
  }
  .sm\\:-space-x-2> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-0.5rem * var(--space-x-reverse));
    margin-left: calc(-0.5rem * calc(1 - var(--space-x-reverse)));
  }
  .sm\\:-space-y-3> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-0.75rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-0.75rem * var(--space-y-reverse));
  }
  .sm\\:-space-x-3> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-0.75rem * var(--space-x-reverse));
    margin-left: calc(-0.75rem * calc(1 - var(--space-x-reverse)));
  }
  .sm\\:-space-y-4> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-1rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-1rem * var(--space-y-reverse));
  }
  .sm\\:-space-x-4> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-1rem * var(--space-x-reverse));
    margin-left: calc(-1rem * calc(1 - var(--space-x-reverse)));
  }
  .sm\\:-space-y-5> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-1.25rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-1.25rem * var(--space-y-reverse));
  }
  .sm\\:-space-x-5> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-1.25rem * var(--space-x-reverse));
    margin-left: calc(-1.25rem * calc(1 - var(--space-x-reverse)));
  }
  .sm\\:-space-y-6> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-1.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-1.5rem * var(--space-y-reverse));
  }
  .sm\\:-space-x-6> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-1.5rem * var(--space-x-reverse));
    margin-left: calc(-1.5rem * calc(1 - var(--space-x-reverse)));
  }
  .sm\\:-space-y-7> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-1.75rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-1.75rem * var(--space-y-reverse));
  }
  .sm\\:-space-x-7> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-1.75rem * var(--space-x-reverse));
    margin-left: calc(-1.75rem * calc(1 - var(--space-x-reverse)));
  }
  .sm\\:-space-y-8> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-2rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-2rem * var(--space-y-reverse));
  }
  .sm\\:-space-x-8> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-2rem * var(--space-x-reverse));
    margin-left: calc(-2rem * calc(1 - var(--space-x-reverse)));
  }
  .sm\\:-space-y-9> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-2.25rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-2.25rem * var(--space-y-reverse));
  }
  .sm\\:-space-x-9> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-2.25rem * var(--space-x-reverse));
    margin-left: calc(-2.25rem * calc(1 - var(--space-x-reverse)));
  }
  .sm\\:-space-y-10> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-2.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-2.5rem * var(--space-y-reverse));
  }
  .sm\\:-space-x-10> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-2.5rem * var(--space-x-reverse));
    margin-left: calc(-2.5rem * calc(1 - var(--space-x-reverse)));
  }
  .sm\\:-space-y-11> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-2.75rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-2.75rem * var(--space-y-reverse));
  }
  .sm\\:-space-x-11> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-2.75rem * var(--space-x-reverse));
    margin-left: calc(-2.75rem * calc(1 - var(--space-x-reverse)));
  }
  .sm\\:-space-y-12> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-3rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-3rem * var(--space-y-reverse));
  }
  .sm\\:-space-x-12> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-3rem * var(--space-x-reverse));
    margin-left: calc(-3rem * calc(1 - var(--space-x-reverse)));
  }
  .sm\\:-space-y-13> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-3.25rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-3.25rem * var(--space-y-reverse));
  }
  .sm\\:-space-x-13> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-3.25rem * var(--space-x-reverse));
    margin-left: calc(-3.25rem * calc(1 - var(--space-x-reverse)));
  }
  .sm\\:-space-y-14> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-3.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-3.5rem * var(--space-y-reverse));
  }
  .sm\\:-space-x-14> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-3.5rem * var(--space-x-reverse));
    margin-left: calc(-3.5rem * calc(1 - var(--space-x-reverse)));
  }
  .sm\\:-space-y-15> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-3.75rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-3.75rem * var(--space-y-reverse));
  }
  .sm\\:-space-x-15> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-3.75rem * var(--space-x-reverse));
    margin-left: calc(-3.75rem * calc(1 - var(--space-x-reverse)));
  }
  .sm\\:-space-y-16> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-4rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-4rem * var(--space-y-reverse));
  }
  .sm\\:-space-x-16> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-4rem * var(--space-x-reverse));
    margin-left: calc(-4rem * calc(1 - var(--space-x-reverse)));
  }
  .sm\\:-space-y-20> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-5rem * var(--space-y-reverse));
  }
  .sm\\:-space-x-20> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-5rem * var(--space-x-reverse));
    margin-left: calc(-5rem * calc(1 - var(--space-x-reverse)));
  }
  .sm\\:-space-y-24> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-6rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-6rem * var(--space-y-reverse));
  }
  .sm\\:-space-x-24> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-6rem * var(--space-x-reverse));
    margin-left: calc(-6rem * calc(1 - var(--space-x-reverse)));
  }
  .sm\\:-space-y-28> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-7rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-7rem * var(--space-y-reverse));
  }
  .sm\\:-space-x-28> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-7rem * var(--space-x-reverse));
    margin-left: calc(-7rem * calc(1 - var(--space-x-reverse)));
  }
  .sm\\:-space-y-32> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-8rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-8rem * var(--space-y-reverse));
  }
  .sm\\:-space-x-32> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-8rem * var(--space-x-reverse));
    margin-left: calc(-8rem * calc(1 - var(--space-x-reverse)));
  }
  .sm\\:-space-y-36> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-9rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-9rem * var(--space-y-reverse));
  }
  .sm\\:-space-x-36> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-9rem * var(--space-x-reverse));
    margin-left: calc(-9rem * calc(1 - var(--space-x-reverse)));
  }
  .sm\\:-space-y-40> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-10rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-10rem * var(--space-y-reverse));
  }
  .sm\\:-space-x-40> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-10rem * var(--space-x-reverse));
    margin-left: calc(-10rem * calc(1 - var(--space-x-reverse)));
  }
  .sm\\:-space-y-44> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-11rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-11rem * var(--space-y-reverse));
  }
  .sm\\:-space-x-44> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-11rem * var(--space-x-reverse));
    margin-left: calc(-11rem * calc(1 - var(--space-x-reverse)));
  }
  .sm\\:-space-y-48> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-12rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-12rem * var(--space-y-reverse));
  }
  .sm\\:-space-x-48> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-12rem * var(--space-x-reverse));
    margin-left: calc(-12rem * calc(1 - var(--space-x-reverse)));
  }
  .sm\\:-space-y-52> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-13rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-13rem * var(--space-y-reverse));
  }
  .sm\\:-space-x-52> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-13rem * var(--space-x-reverse));
    margin-left: calc(-13rem * calc(1 - var(--space-x-reverse)));
  }
  .sm\\:-space-y-56> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-14rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-14rem * var(--space-y-reverse));
  }
  .sm\\:-space-x-56> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-14rem * var(--space-x-reverse));
    margin-left: calc(-14rem * calc(1 - var(--space-x-reverse)));
  }
  .sm\\:-space-y-60> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-15rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-15rem * var(--space-y-reverse));
  }
  .sm\\:-space-x-60> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-15rem * var(--space-x-reverse));
    margin-left: calc(-15rem * calc(1 - var(--space-x-reverse)));
  }
  .sm\\:-space-y-64> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-16rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-16rem * var(--space-y-reverse));
  }
  .sm\\:-space-x-64> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-16rem * var(--space-x-reverse));
    margin-left: calc(-16rem * calc(1 - var(--space-x-reverse)));
  }
  .sm\\:-space-y-72> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-18rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-18rem * var(--space-y-reverse));
  }
  .sm\\:-space-x-72> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-18rem * var(--space-x-reverse));
    margin-left: calc(-18rem * calc(1 - var(--space-x-reverse)));
  }
  .sm\\:-space-y-80> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-20rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-20rem * var(--space-y-reverse));
  }
  .sm\\:-space-x-80> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-20rem * var(--space-x-reverse));
    margin-left: calc(-20rem * calc(1 - var(--space-x-reverse)));
  }
  .sm\\:-space-y-96> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-24rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-24rem * var(--space-y-reverse));
  }
  .sm\\:-space-x-96> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-24rem * var(--space-x-reverse));
    margin-left: calc(-24rem * calc(1 - var(--space-x-reverse)));
  }
  .sm\\:-space-y-px> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-1px * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-1px * var(--space-y-reverse));
  }
  .sm\\:-space-x-px> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-1px * var(--space-x-reverse));
    margin-left: calc(-1px * calc(1 - var(--space-x-reverse)));
  }
  .sm\\:-space-y-0\\.5> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-0.125rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-0.125rem * var(--space-y-reverse));
  }
  .sm\\:-space-x-0\\.5> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-0.125rem * var(--space-x-reverse));
    margin-left: calc(-0.125rem * calc(1 - var(--space-x-reverse)));
  }
  .sm\\:-space-y-1\\.5> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-0.375rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-0.375rem * var(--space-y-reverse));
  }
  .sm\\:-space-x-1\\.5> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-0.375rem * var(--space-x-reverse));
    margin-left: calc(-0.375rem * calc(1 - var(--space-x-reverse)));
  }
  .sm\\:-space-y-2\\.5> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-0.625rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-0.625rem * var(--space-y-reverse));
  }
  .sm\\:-space-x-2\\.5> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-0.625rem * var(--space-x-reverse));
    margin-left: calc(-0.625rem * calc(1 - var(--space-x-reverse)));
  }
  .sm\\:-space-y-3\\.5> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-0.875rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-0.875rem * var(--space-y-reverse));
  }
  .sm\\:-space-x-3\\.5> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-0.875rem * var(--space-x-reverse));
    margin-left: calc(-0.875rem * calc(1 - var(--space-x-reverse)));
  }
  .sm\\:-space-y-1\\/2> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-50% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-50% * var(--space-y-reverse));
  }
  .sm\\:-space-x-1\\/2> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-50% * var(--space-x-reverse));
    margin-left: calc(-50% * calc(1 - var(--space-x-reverse)));
  }
  .sm\\:-space-y-1\\/3> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-33.33333% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-33.33333% * var(--space-y-reverse));
  }
  .sm\\:-space-x-1\\/3> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-33.33333% * var(--space-x-reverse));
    margin-left: calc(-33.33333% * calc(1 - var(--space-x-reverse)));
  }
  .sm\\:-space-y-2\\/3> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-66.66667% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-66.66667% * var(--space-y-reverse));
  }
  .sm\\:-space-x-2\\/3> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-66.66667% * var(--space-x-reverse));
    margin-left: calc(-66.66667% * calc(1 - var(--space-x-reverse)));
  }
  .sm\\:-space-y-1\\/4> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-25% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-25% * var(--space-y-reverse));
  }
  .sm\\:-space-x-1\\/4> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-25% * var(--space-x-reverse));
    margin-left: calc(-25% * calc(1 - var(--space-x-reverse)));
  }
  .sm\\:-space-y-2\\/4> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-50% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-50% * var(--space-y-reverse));
  }
  .sm\\:-space-x-2\\/4> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-50% * var(--space-x-reverse));
    margin-left: calc(-50% * calc(1 - var(--space-x-reverse)));
  }
  .sm\\:-space-y-3\\/4> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-75% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-75% * var(--space-y-reverse));
  }
  .sm\\:-space-x-3\\/4> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-75% * var(--space-x-reverse));
    margin-left: calc(-75% * calc(1 - var(--space-x-reverse)));
  }
  .sm\\:-space-y-1\\/5> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-20% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-20% * var(--space-y-reverse));
  }
  .sm\\:-space-x-1\\/5> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-20% * var(--space-x-reverse));
    margin-left: calc(-20% * calc(1 - var(--space-x-reverse)));
  }
  .sm\\:-space-y-2\\/5> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-40% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-40% * var(--space-y-reverse));
  }
  .sm\\:-space-x-2\\/5> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-40% * var(--space-x-reverse));
    margin-left: calc(-40% * calc(1 - var(--space-x-reverse)));
  }
  .sm\\:-space-y-3\\/5> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-60% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-60% * var(--space-y-reverse));
  }
  .sm\\:-space-x-3\\/5> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-60% * var(--space-x-reverse));
    margin-left: calc(-60% * calc(1 - var(--space-x-reverse)));
  }
  .sm\\:-space-y-4\\/5> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-80% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-80% * var(--space-y-reverse));
  }
  .sm\\:-space-x-4\\/5> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-80% * var(--space-x-reverse));
    margin-left: calc(-80% * calc(1 - var(--space-x-reverse)));
  }
  .sm\\:-space-y-1\\/6> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-16.66667% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-16.66667% * var(--space-y-reverse));
  }
  .sm\\:-space-x-1\\/6> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-16.66667% * var(--space-x-reverse));
    margin-left: calc(-16.66667% * calc(1 - var(--space-x-reverse)));
  }
  .sm\\:-space-y-2\\/6> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-33.33333% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-33.33333% * var(--space-y-reverse));
  }
  .sm\\:-space-x-2\\/6> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-33.33333% * var(--space-x-reverse));
    margin-left: calc(-33.33333% * calc(1 - var(--space-x-reverse)));
  }
  .sm\\:-space-y-3\\/6> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-50% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-50% * var(--space-y-reverse));
  }
  .sm\\:-space-x-3\\/6> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-50% * var(--space-x-reverse));
    margin-left: calc(-50% * calc(1 - var(--space-x-reverse)));
  }
  .sm\\:-space-y-4\\/6> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-66.66667% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-66.66667% * var(--space-y-reverse));
  }
  .sm\\:-space-x-4\\/6> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-66.66667% * var(--space-x-reverse));
    margin-left: calc(-66.66667% * calc(1 - var(--space-x-reverse)));
  }
  .sm\\:-space-y-5\\/6> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-83.33333% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-83.33333% * var(--space-y-reverse));
  }
  .sm\\:-space-x-5\\/6> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-83.33333% * var(--space-x-reverse));
    margin-left: calc(-83.33333% * calc(1 - var(--space-x-reverse)));
  }
  .sm\\:-space-y-1\\/12> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-8.33333% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-8.33333% * var(--space-y-reverse));
  }
  .sm\\:-space-x-1\\/12> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-8.33333% * var(--space-x-reverse));
    margin-left: calc(-8.33333% * calc(1 - var(--space-x-reverse)));
  }
  .sm\\:-space-y-2\\/12> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-16.66667% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-16.66667% * var(--space-y-reverse));
  }
  .sm\\:-space-x-2\\/12> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-16.66667% * var(--space-x-reverse));
    margin-left: calc(-16.66667% * calc(1 - var(--space-x-reverse)));
  }
  .sm\\:-space-y-3\\/12> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-25% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-25% * var(--space-y-reverse));
  }
  .sm\\:-space-x-3\\/12> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-25% * var(--space-x-reverse));
    margin-left: calc(-25% * calc(1 - var(--space-x-reverse)));
  }
  .sm\\:-space-y-4\\/12> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-33.33333% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-33.33333% * var(--space-y-reverse));
  }
  .sm\\:-space-x-4\\/12> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-33.33333% * var(--space-x-reverse));
    margin-left: calc(-33.33333% * calc(1 - var(--space-x-reverse)));
  }
  .sm\\:-space-y-5\\/12> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-41.66667% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-41.66667% * var(--space-y-reverse));
  }
  .sm\\:-space-x-5\\/12> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-41.66667% * var(--space-x-reverse));
    margin-left: calc(-41.66667% * calc(1 - var(--space-x-reverse)));
  }
  .sm\\:-space-y-6\\/12> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-50% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-50% * var(--space-y-reverse));
  }
  .sm\\:-space-x-6\\/12> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-50% * var(--space-x-reverse));
    margin-left: calc(-50% * calc(1 - var(--space-x-reverse)));
  }
  .sm\\:-space-y-7\\/12> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-58.33333% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-58.33333% * var(--space-y-reverse));
  }
  .sm\\:-space-x-7\\/12> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-58.33333% * var(--space-x-reverse));
    margin-left: calc(-58.33333% * calc(1 - var(--space-x-reverse)));
  }
  .sm\\:-space-y-8\\/12> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-66.66667% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-66.66667% * var(--space-y-reverse));
  }
  .sm\\:-space-x-8\\/12> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-66.66667% * var(--space-x-reverse));
    margin-left: calc(-66.66667% * calc(1 - var(--space-x-reverse)));
  }
  .sm\\:-space-y-9\\/12> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-75% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-75% * var(--space-y-reverse));
  }
  .sm\\:-space-x-9\\/12> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-75% * var(--space-x-reverse));
    margin-left: calc(-75% * calc(1 - var(--space-x-reverse)));
  }
  .sm\\:-space-y-10\\/12> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-83.33333% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-83.33333% * var(--space-y-reverse));
  }
  .sm\\:-space-x-10\\/12> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-83.33333% * var(--space-x-reverse));
    margin-left: calc(-83.33333% * calc(1 - var(--space-x-reverse)));
  }
  .sm\\:-space-y-11\\/12> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-91.66667% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-91.66667% * var(--space-y-reverse));
  }
  .sm\\:-space-x-11\\/12> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-91.66667% * var(--space-x-reverse));
    margin-left: calc(-91.66667% * calc(1 - var(--space-x-reverse)));
  }
  .sm\\:-space-y-full> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-100% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-100% * var(--space-y-reverse));
  }
  .sm\\:-space-x-full> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-100% * var(--space-x-reverse));
    margin-left: calc(-100% * calc(1 - var(--space-x-reverse)));
  }
  .sm\\:space-y-reverse> :not(template)~ :not(template) {
    --space-y-reverse: 1;
  }
  .sm\\:space-x-reverse> :not(template)~ :not(template) {
    --space-x-reverse: 1;
  }
  .sm\\:divide-y-0> :not(template)~ :not(template) {
    --divide-y-reverse: 0;
    border-top-width: calc(0px * calc(1 - var(--divide-y-reverse)));
    border-bottom-width: calc(0px * var(--divide-y-reverse));
  }
  .sm\\:divide-x-0> :not(template)~ :not(template) {
    --divide-x-reverse: 0;
    border-right-width: calc(0px * var(--divide-x-reverse));
    border-left-width: calc(0px * calc(1 - var(--divide-x-reverse)));
  }
  .sm\\:divide-y-2> :not(template)~ :not(template) {
    --divide-y-reverse: 0;
    border-top-width: calc(2px * calc(1 - var(--divide-y-reverse)));
    border-bottom-width: calc(2px * var(--divide-y-reverse));
  }
  .sm\\:divide-x-2> :not(template)~ :not(template) {
    --divide-x-reverse: 0;
    border-right-width: calc(2px * var(--divide-x-reverse));
    border-left-width: calc(2px * calc(1 - var(--divide-x-reverse)));
  }
  .sm\\:divide-y-4> :not(template)~ :not(template) {
    --divide-y-reverse: 0;
    border-top-width: calc(4px * calc(1 - var(--divide-y-reverse)));
    border-bottom-width: calc(4px * var(--divide-y-reverse));
  }
  .sm\\:divide-x-4> :not(template)~ :not(template) {
    --divide-x-reverse: 0;
    border-right-width: calc(4px * var(--divide-x-reverse));
    border-left-width: calc(4px * calc(1 - var(--divide-x-reverse)));
  }
  .sm\\:divide-y-8> :not(template)~ :not(template) {
    --divide-y-reverse: 0;
    border-top-width: calc(8px * calc(1 - var(--divide-y-reverse)));
    border-bottom-width: calc(8px * var(--divide-y-reverse));
  }
  .sm\\:divide-x-8> :not(template)~ :not(template) {
    --divide-x-reverse: 0;
    border-right-width: calc(8px * var(--divide-x-reverse));
    border-left-width: calc(8px * calc(1 - var(--divide-x-reverse)));
  }
  .sm\\:divide-y> :not(template)~ :not(template) {
    --divide-y-reverse: 0;
    border-top-width: calc(1px * calc(1 - var(--divide-y-reverse)));
    border-bottom-width: calc(1px * var(--divide-y-reverse));
  }
  .sm\\:divide-x> :not(template)~ :not(template) {
    --divide-x-reverse: 0;
    border-right-width: calc(1px * var(--divide-x-reverse));
    border-left-width: calc(1px * calc(1 - var(--divide-x-reverse)));
  }
  .sm\\:divide-y-reverse> :not(template)~ :not(template) {
    --divide-y-reverse: 1;
  }
  .sm\\:divide-x-reverse> :not(template)~ :not(template) {
    --divide-x-reverse: 1;
  }
  .sm\\:divide-current> :not(template)~ :not(template) {
    border-color: currentColor;
  }
  .sm\\:divide-transparent> :not(template)~ :not(template) {
    border-color: transparent;
  }
  .sm\\:divide-white> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #ffffff;
    border-color: rgba(255, 255, 255, var(--divide-opacity));
  }
  .sm\\:divide-black> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #000000;
    border-color: rgba(0, 0, 0, var(--divide-opacity));
  }
  .sm\\:divide-gray-50> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #f9fafb;
    border-color: rgba(249, 250, 251, var(--divide-opacity));
  }
  .sm\\:divide-gray-100> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #f4f5f7;
    border-color: rgba(244, 245, 247, var(--divide-opacity));
  }
  .sm\\:divide-gray-200> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #e5e7eb;
    border-color: rgba(229, 231, 235, var(--divide-opacity));
  }
  .sm\\:divide-gray-300> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #d2d6dc;
    border-color: rgba(210, 214, 220, var(--divide-opacity));
  }
  .sm\\:divide-gray-400> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #9fa6b2;
    border-color: rgba(159, 166, 178, var(--divide-opacity));
  }
  .sm\\:divide-gray-500> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #6b7280;
    border-color: rgba(107, 114, 128, var(--divide-opacity));
  }
  .sm\\:divide-gray-600> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #4b5563;
    border-color: rgba(75, 85, 99, var(--divide-opacity));
  }
  .sm\\:divide-gray-700> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #374151;
    border-color: rgba(55, 65, 81, var(--divide-opacity));
  }
  .sm\\:divide-gray-800> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #252f3f;
    border-color: rgba(37, 47, 63, var(--divide-opacity));
  }
  .sm\\:divide-gray-900> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #161e2e;
    border-color: rgba(22, 30, 46, var(--divide-opacity));
  }
  .sm\\:divide-red-50> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #fdf2f2;
    border-color: rgba(253, 242, 242, var(--divide-opacity));
  }
  .sm\\:divide-red-100> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #fde8e8;
    border-color: rgba(253, 232, 232, var(--divide-opacity));
  }
  .sm\\:divide-red-200> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #fbd5d5;
    border-color: rgba(251, 213, 213, var(--divide-opacity));
  }
  .sm\\:divide-red-300> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #f8b4b4;
    border-color: rgba(248, 180, 180, var(--divide-opacity));
  }
  .sm\\:divide-red-400> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #f98080;
    border-color: rgba(249, 128, 128, var(--divide-opacity));
  }
  .sm\\:divide-red-500> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #f05252;
    border-color: rgba(240, 82, 82, var(--divide-opacity));
  }
  .sm\\:divide-red-600> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #e02424;
    border-color: rgba(224, 36, 36, var(--divide-opacity));
  }
  .sm\\:divide-red-700> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #c81e1e;
    border-color: rgba(200, 30, 30, var(--divide-opacity));
  }
  .sm\\:divide-red-800> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #9b1c1c;
    border-color: rgba(155, 28, 28, var(--divide-opacity));
  }
  .sm\\:divide-red-900> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #771d1d;
    border-color: rgba(119, 29, 29, var(--divide-opacity));
  }
  .sm\\:divide-orange-50> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #fff8f1;
    border-color: rgba(255, 248, 241, var(--divide-opacity));
  }
  .sm\\:divide-orange-100> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #feecdc;
    border-color: rgba(254, 236, 220, var(--divide-opacity));
  }
  .sm\\:divide-orange-200> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #fcd9bd;
    border-color: rgba(252, 217, 189, var(--divide-opacity));
  }
  .sm\\:divide-orange-300> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #fdba8c;
    border-color: rgba(253, 186, 140, var(--divide-opacity));
  }
  .sm\\:divide-orange-400> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #ff8a4c;
    border-color: rgba(255, 138, 76, var(--divide-opacity));
  }
  .sm\\:divide-orange-500> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #ff5a1f;
    border-color: rgba(255, 90, 31, var(--divide-opacity));
  }
  .sm\\:divide-orange-600> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #d03801;
    border-color: rgba(208, 56, 1, var(--divide-opacity));
  }
  .sm\\:divide-orange-700> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #b43403;
    border-color: rgba(180, 52, 3, var(--divide-opacity));
  }
  .sm\\:divide-orange-800> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #8a2c0d;
    border-color: rgba(138, 44, 13, var(--divide-opacity));
  }
  .sm\\:divide-orange-900> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #73230d;
    border-color: rgba(115, 35, 13, var(--divide-opacity));
  }
  .sm\\:divide-yellow-50> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #fdfdea;
    border-color: rgba(253, 253, 234, var(--divide-opacity));
  }
  .sm\\:divide-yellow-100> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #fdf6b2;
    border-color: rgba(253, 246, 178, var(--divide-opacity));
  }
  .sm\\:divide-yellow-200> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #fce96a;
    border-color: rgba(252, 233, 106, var(--divide-opacity));
  }
  .sm\\:divide-yellow-300> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #faca15;
    border-color: rgba(250, 202, 21, var(--divide-opacity));
  }
  .sm\\:divide-yellow-400> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #e3a008;
    border-color: rgba(227, 160, 8, var(--divide-opacity));
  }
  .sm\\:divide-yellow-500> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #c27803;
    border-color: rgba(194, 120, 3, var(--divide-opacity));
  }
  .sm\\:divide-yellow-600> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #9f580a;
    border-color: rgba(159, 88, 10, var(--divide-opacity));
  }
  .sm\\:divide-yellow-700> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #8e4b10;
    border-color: rgba(142, 75, 16, var(--divide-opacity));
  }
  .sm\\:divide-yellow-800> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #723b13;
    border-color: rgba(114, 59, 19, var(--divide-opacity));
  }
  .sm\\:divide-yellow-900> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #633112;
    border-color: rgba(99, 49, 18, var(--divide-opacity));
  }
  .sm\\:divide-green-50> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #f3faf7;
    border-color: rgba(243, 250, 247, var(--divide-opacity));
  }
  .sm\\:divide-green-100> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #def7ec;
    border-color: rgba(222, 247, 236, var(--divide-opacity));
  }
  .sm\\:divide-green-200> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #bcf0da;
    border-color: rgba(188, 240, 218, var(--divide-opacity));
  }
  .sm\\:divide-green-300> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #84e1bc;
    border-color: rgba(132, 225, 188, var(--divide-opacity));
  }
  .sm\\:divide-green-400> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #31c48d;
    border-color: rgba(49, 196, 141, var(--divide-opacity));
  }
  .sm\\:divide-green-500> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #0e9f6e;
    border-color: rgba(14, 159, 110, var(--divide-opacity));
  }
  .sm\\:divide-green-600> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #057a55;
    border-color: rgba(5, 122, 85, var(--divide-opacity));
  }
  .sm\\:divide-green-700> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #046c4e;
    border-color: rgba(4, 108, 78, var(--divide-opacity));
  }
  .sm\\:divide-green-800> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #03543f;
    border-color: rgba(3, 84, 63, var(--divide-opacity));
  }
  .sm\\:divide-green-900> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #014737;
    border-color: rgba(1, 71, 55, var(--divide-opacity));
  }
  .sm\\:divide-teal-50> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #edfafa;
    border-color: rgba(237, 250, 250, var(--divide-opacity));
  }
  .sm\\:divide-teal-100> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #d5f5f6;
    border-color: rgba(213, 245, 246, var(--divide-opacity));
  }
  .sm\\:divide-teal-200> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #afecef;
    border-color: rgba(175, 236, 239, var(--divide-opacity));
  }
  .sm\\:divide-teal-300> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #7edce2;
    border-color: rgba(126, 220, 226, var(--divide-opacity));
  }
  .sm\\:divide-teal-400> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #16bdca;
    border-color: rgba(22, 189, 202, var(--divide-opacity));
  }
  .sm\\:divide-teal-500> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #0694a2;
    border-color: rgba(6, 148, 162, var(--divide-opacity));
  }
  .sm\\:divide-teal-600> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #047481;
    border-color: rgba(4, 116, 129, var(--divide-opacity));
  }
  .sm\\:divide-teal-700> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #036672;
    border-color: rgba(3, 102, 114, var(--divide-opacity));
  }
  .sm\\:divide-teal-800> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #05505c;
    border-color: rgba(5, 80, 92, var(--divide-opacity));
  }
  .sm\\:divide-teal-900> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #014451;
    border-color: rgba(1, 68, 81, var(--divide-opacity));
  }
  .sm\\:divide-blue-50> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #ebf5ff;
    border-color: rgba(235, 245, 255, var(--divide-opacity));
  }
  .sm\\:divide-blue-100> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #e1effe;
    border-color: rgba(225, 239, 254, var(--divide-opacity));
  }
  .sm\\:divide-blue-200> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #c3ddfd;
    border-color: rgba(195, 221, 253, var(--divide-opacity));
  }
  .sm\\:divide-blue-300> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #a4cafe;
    border-color: rgba(164, 202, 254, var(--divide-opacity));
  }
  .sm\\:divide-blue-400> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #76a9fa;
    border-color: rgba(118, 169, 250, var(--divide-opacity));
  }
  .sm\\:divide-blue-500> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #3f83f8;
    border-color: rgba(63, 131, 248, var(--divide-opacity));
  }
  .sm\\:divide-blue-600> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #1c64f2;
    border-color: rgba(28, 100, 242, var(--divide-opacity));
  }
  .sm\\:divide-blue-700> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #1a56db;
    border-color: rgba(26, 86, 219, var(--divide-opacity));
  }
  .sm\\:divide-blue-800> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #1e429f;
    border-color: rgba(30, 66, 159, var(--divide-opacity));
  }
  .sm\\:divide-blue-900> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #233876;
    border-color: rgba(35, 56, 118, var(--divide-opacity));
  }
  .sm\\:divide-indigo-50> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #f0f5ff;
    border-color: rgba(240, 245, 255, var(--divide-opacity));
  }
  .sm\\:divide-indigo-100> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #e5edff;
    border-color: rgba(229, 237, 255, var(--divide-opacity));
  }
  .sm\\:divide-indigo-200> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #cddbfe;
    border-color: rgba(205, 219, 254, var(--divide-opacity));
  }
  .sm\\:divide-indigo-300> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #b4c6fc;
    border-color: rgba(180, 198, 252, var(--divide-opacity));
  }
  .sm\\:divide-indigo-400> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #8da2fb;
    border-color: rgba(141, 162, 251, var(--divide-opacity));
  }
  .sm\\:divide-indigo-500> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #6875f5;
    border-color: rgba(104, 117, 245, var(--divide-opacity));
  }
  .sm\\:divide-indigo-600> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #5850ec;
    border-color: rgba(88, 80, 236, var(--divide-opacity));
  }
  .sm\\:divide-indigo-700> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #5145cd;
    border-color: rgba(81, 69, 205, var(--divide-opacity));
  }
  .sm\\:divide-indigo-800> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #42389d;
    border-color: rgba(66, 56, 157, var(--divide-opacity));
  }
  .sm\\:divide-indigo-900> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #362f78;
    border-color: rgba(54, 47, 120, var(--divide-opacity));
  }
  .sm\\:divide-purple-50> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #f6f5ff;
    border-color: rgba(246, 245, 255, var(--divide-opacity));
  }
  .sm\\:divide-purple-100> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #edebfe;
    border-color: rgba(237, 235, 254, var(--divide-opacity));
  }
  .sm\\:divide-purple-200> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #dcd7fe;
    border-color: rgba(220, 215, 254, var(--divide-opacity));
  }
  .sm\\:divide-purple-300> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #cabffd;
    border-color: rgba(202, 191, 253, var(--divide-opacity));
  }
  .sm\\:divide-purple-400> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #ac94fa;
    border-color: rgba(172, 148, 250, var(--divide-opacity));
  }
  .sm\\:divide-purple-500> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #9061f9;
    border-color: rgba(144, 97, 249, var(--divide-opacity));
  }
  .sm\\:divide-purple-600> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #7e3af2;
    border-color: rgba(126, 58, 242, var(--divide-opacity));
  }
  .sm\\:divide-purple-700> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #6c2bd9;
    border-color: rgba(108, 43, 217, var(--divide-opacity));
  }
  .sm\\:divide-purple-800> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #5521b5;
    border-color: rgba(85, 33, 181, var(--divide-opacity));
  }
  .sm\\:divide-purple-900> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #4a1d96;
    border-color: rgba(74, 29, 150, var(--divide-opacity));
  }
  .sm\\:divide-pink-50> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #fdf2f8;
    border-color: rgba(253, 242, 248, var(--divide-opacity));
  }
  .sm\\:divide-pink-100> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #fce8f3;
    border-color: rgba(252, 232, 243, var(--divide-opacity));
  }
  .sm\\:divide-pink-200> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #fad1e8;
    border-color: rgba(250, 209, 232, var(--divide-opacity));
  }
  .sm\\:divide-pink-300> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #f8b4d9;
    border-color: rgba(248, 180, 217, var(--divide-opacity));
  }
  .sm\\:divide-pink-400> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #f17eb8;
    border-color: rgba(241, 126, 184, var(--divide-opacity));
  }
  .sm\\:divide-pink-500> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #e74694;
    border-color: rgba(231, 70, 148, var(--divide-opacity));
  }
  .sm\\:divide-pink-600> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #d61f69;
    border-color: rgba(214, 31, 105, var(--divide-opacity));
  }
  .sm\\:divide-pink-700> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #bf125d;
    border-color: rgba(191, 18, 93, var(--divide-opacity));
  }
  .sm\\:divide-pink-800> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #99154b;
    border-color: rgba(153, 21, 75, var(--divide-opacity));
  }
  .sm\\:divide-pink-900> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #751a3d;
    border-color: rgba(117, 26, 61, var(--divide-opacity));
  }
  .sm\\:divide-cool-gray-50> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #f8fafc;
    border-color: rgba(248, 250, 252, var(--divide-opacity));
  }
  .sm\\:divide-cool-gray-100> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #f1f5f9;
    border-color: rgba(241, 245, 249, var(--divide-opacity));
  }
  .sm\\:divide-cool-gray-200> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #e2e8f0;
    border-color: rgba(226, 232, 240, var(--divide-opacity));
  }
  .sm\\:divide-cool-gray-300> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #cfd8e3;
    border-color: rgba(207, 216, 227, var(--divide-opacity));
  }
  .sm\\:divide-cool-gray-400> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #97a6ba;
    border-color: rgba(151, 166, 186, var(--divide-opacity));
  }
  .sm\\:divide-cool-gray-500> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #64748b;
    border-color: rgba(100, 116, 139, var(--divide-opacity));
  }
  .sm\\:divide-cool-gray-600> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #475569;
    border-color: rgba(71, 85, 105, var(--divide-opacity));
  }
  .sm\\:divide-cool-gray-700> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #364152;
    border-color: rgba(54, 65, 82, var(--divide-opacity));
  }
  .sm\\:divide-cool-gray-800> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #27303f;
    border-color: rgba(39, 48, 63, var(--divide-opacity));
  }
  .sm\\:divide-cool-gray-900> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #1a202e;
    border-color: rgba(26, 32, 46, var(--divide-opacity));
  }
  .sm\\:divide-solid> :not(template)~ :not(template) {
    border-style: solid;
  }
  .sm\\:divide-dashed> :not(template)~ :not(template) {
    border-style: dashed;
  }
  .sm\\:divide-dotted> :not(template)~ :not(template) {
    border-style: dotted;
  }
  .sm\\:divide-double> :not(template)~ :not(template) {
    border-style: double;
  }
  .sm\\:divide-none> :not(template)~ :not(template) {
    border-style: none;
  }
  .sm\\:divide-opacity-0> :not(template)~ :not(template) {
    --divide-opacity: 0;
  }
  .sm\\:divide-opacity-25> :not(template)~ :not(template) {
    --divide-opacity: 0.25;
  }
  .sm\\:divide-opacity-50> :not(template)~ :not(template) {
    --divide-opacity: 0.5;
  }
  .sm\\:divide-opacity-75> :not(template)~ :not(template) {
    --divide-opacity: 0.75;
  }
  .sm\\:divide-opacity-100> :not(template)~ :not(template) {
    --divide-opacity: 1;
  }
  .sm\\:sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border-width: 0;
  }
  .sm\\:not-sr-only {
    position: static;
    width: auto;
    height: auto;
    padding: 0;
    margin: 0;
    overflow: visible;
    clip: auto;
    white-space: normal;
  }
  .sm\\:focus\\:sr-only:focus {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border-width: 0;
  }
  .sm\\:focus\\:not-sr-only:focus {
    position: static;
    width: auto;
    height: auto;
    padding: 0;
    margin: 0;
    overflow: visible;
    clip: auto;
    white-space: normal;
  }
  .sm\\:appearance-none {
    appearance: none;
  }
  .sm\\:bg-fixed {
    background-attachment: fixed;
  }
  .sm\\:bg-local {
    background-attachment: local;
  }
  .sm\\:bg-scroll {
    background-attachment: scroll;
  }
  .sm\\:bg-clip-border {
    background-clip: border-box;
  }
  .sm\\:bg-clip-padding {
    background-clip: padding-box;
  }
  .sm\\:bg-clip-content {
    background-clip: content-box;
  }
  .sm\\:bg-clip-text {
    -webkit-background-clip: text;
    background-clip: text;
  }
  .sm\\:bg-current {
    background-color: currentColor;
  }
  .sm\\:bg-transparent {
    background-color: transparent;
  }
  .sm\\:bg-white {
    --bg-opacity: 1;
    background-color: #ffffff;
    background-color: rgba(255, 255, 255, var(--bg-opacity));
  }
  .sm\\:bg-black {
    --bg-opacity: 1;
    background-color: #000000;
    background-color: rgba(0, 0, 0, var(--bg-opacity));
  }
  .sm\\:bg-gray-50 {
    --bg-opacity: 1;
    background-color: #f9fafb;
    background-color: rgba(249, 250, 251, var(--bg-opacity));
  }
  .sm\\:bg-gray-100 {
    --bg-opacity: 1;
    background-color: #f4f5f7;
    background-color: rgba(244, 245, 247, var(--bg-opacity));
  }
  .sm\\:bg-gray-200 {
    --bg-opacity: 1;
    background-color: #e5e7eb;
    background-color: rgba(229, 231, 235, var(--bg-opacity));
  }
  .sm\\:bg-gray-300 {
    --bg-opacity: 1;
    background-color: #d2d6dc;
    background-color: rgba(210, 214, 220, var(--bg-opacity));
  }
  .sm\\:bg-gray-400 {
    --bg-opacity: 1;
    background-color: #9fa6b2;
    background-color: rgba(159, 166, 178, var(--bg-opacity));
  }
  .sm\\:bg-gray-500 {
    --bg-opacity: 1;
    background-color: #6b7280;
    background-color: rgba(107, 114, 128, var(--bg-opacity));
  }
  .sm\\:bg-gray-600 {
    --bg-opacity: 1;
    background-color: #4b5563;
    background-color: rgba(75, 85, 99, var(--bg-opacity));
  }
  .sm\\:bg-gray-700 {
    --bg-opacity: 1;
    background-color: #374151;
    background-color: rgba(55, 65, 81, var(--bg-opacity));
  }
  .sm\\:bg-gray-800 {
    --bg-opacity: 1;
    background-color: #252f3f;
    background-color: rgba(37, 47, 63, var(--bg-opacity));
  }
  .sm\\:bg-gray-900 {
    --bg-opacity: 1;
    background-color: #161e2e;
    background-color: rgba(22, 30, 46, var(--bg-opacity));
  }
  .sm\\:bg-red-50 {
    --bg-opacity: 1;
    background-color: #fdf2f2;
    background-color: rgba(253, 242, 242, var(--bg-opacity));
  }
  .sm\\:bg-red-100 {
    --bg-opacity: 1;
    background-color: #fde8e8;
    background-color: rgba(253, 232, 232, var(--bg-opacity));
  }
  .sm\\:bg-red-200 {
    --bg-opacity: 1;
    background-color: #fbd5d5;
    background-color: rgba(251, 213, 213, var(--bg-opacity));
  }
  .sm\\:bg-red-300 {
    --bg-opacity: 1;
    background-color: #f8b4b4;
    background-color: rgba(248, 180, 180, var(--bg-opacity));
  }
  .sm\\:bg-red-400 {
    --bg-opacity: 1;
    background-color: #f98080;
    background-color: rgba(249, 128, 128, var(--bg-opacity));
  }
  .sm\\:bg-red-500 {
    --bg-opacity: 1;
    background-color: #f05252;
    background-color: rgba(240, 82, 82, var(--bg-opacity));
  }
  .sm\\:bg-red-600 {
    --bg-opacity: 1;
    background-color: #e02424;
    background-color: rgba(224, 36, 36, var(--bg-opacity));
  }
  .sm\\:bg-red-700 {
    --bg-opacity: 1;
    background-color: #c81e1e;
    background-color: rgba(200, 30, 30, var(--bg-opacity));
  }
  .sm\\:bg-red-800 {
    --bg-opacity: 1;
    background-color: #9b1c1c;
    background-color: rgba(155, 28, 28, var(--bg-opacity));
  }
  .sm\\:bg-red-900 {
    --bg-opacity: 1;
    background-color: #771d1d;
    background-color: rgba(119, 29, 29, var(--bg-opacity));
  }
  .sm\\:bg-orange-50 {
    --bg-opacity: 1;
    background-color: #fff8f1;
    background-color: rgba(255, 248, 241, var(--bg-opacity));
  }
  .sm\\:bg-orange-100 {
    --bg-opacity: 1;
    background-color: #feecdc;
    background-color: rgba(254, 236, 220, var(--bg-opacity));
  }
  .sm\\:bg-orange-200 {
    --bg-opacity: 1;
    background-color: #fcd9bd;
    background-color: rgba(252, 217, 189, var(--bg-opacity));
  }
  .sm\\:bg-orange-300 {
    --bg-opacity: 1;
    background-color: #fdba8c;
    background-color: rgba(253, 186, 140, var(--bg-opacity));
  }
  .sm\\:bg-orange-400 {
    --bg-opacity: 1;
    background-color: #ff8a4c;
    background-color: rgba(255, 138, 76, var(--bg-opacity));
  }
  .sm\\:bg-orange-500 {
    --bg-opacity: 1;
    background-color: #ff5a1f;
    background-color: rgba(255, 90, 31, var(--bg-opacity));
  }
  .sm\\:bg-orange-600 {
    --bg-opacity: 1;
    background-color: #d03801;
    background-color: rgba(208, 56, 1, var(--bg-opacity));
  }
  .sm\\:bg-orange-700 {
    --bg-opacity: 1;
    background-color: #b43403;
    background-color: rgba(180, 52, 3, var(--bg-opacity));
  }
  .sm\\:bg-orange-800 {
    --bg-opacity: 1;
    background-color: #8a2c0d;
    background-color: rgba(138, 44, 13, var(--bg-opacity));
  }
  .sm\\:bg-orange-900 {
    --bg-opacity: 1;
    background-color: #73230d;
    background-color: rgba(115, 35, 13, var(--bg-opacity));
  }
  .sm\\:bg-yellow-50 {
    --bg-opacity: 1;
    background-color: #fdfdea;
    background-color: rgba(253, 253, 234, var(--bg-opacity));
  }
  .sm\\:bg-yellow-100 {
    --bg-opacity: 1;
    background-color: #fdf6b2;
    background-color: rgba(253, 246, 178, var(--bg-opacity));
  }
  .sm\\:bg-yellow-200 {
    --bg-opacity: 1;
    background-color: #fce96a;
    background-color: rgba(252, 233, 106, var(--bg-opacity));
  }
  .sm\\:bg-yellow-300 {
    --bg-opacity: 1;
    background-color: #faca15;
    background-color: rgba(250, 202, 21, var(--bg-opacity));
  }
  .sm\\:bg-yellow-400 {
    --bg-opacity: 1;
    background-color: #e3a008;
    background-color: rgba(227, 160, 8, var(--bg-opacity));
  }
  .sm\\:bg-yellow-500 {
    --bg-opacity: 1;
    background-color: #c27803;
    background-color: rgba(194, 120, 3, var(--bg-opacity));
  }
  .sm\\:bg-yellow-600 {
    --bg-opacity: 1;
    background-color: #9f580a;
    background-color: rgba(159, 88, 10, var(--bg-opacity));
  }
  .sm\\:bg-yellow-700 {
    --bg-opacity: 1;
    background-color: #8e4b10;
    background-color: rgba(142, 75, 16, var(--bg-opacity));
  }
  .sm\\:bg-yellow-800 {
    --bg-opacity: 1;
    background-color: #723b13;
    background-color: rgba(114, 59, 19, var(--bg-opacity));
  }
  .sm\\:bg-yellow-900 {
    --bg-opacity: 1;
    background-color: #633112;
    background-color: rgba(99, 49, 18, var(--bg-opacity));
  }
  .sm\\:bg-green-50 {
    --bg-opacity: 1;
    background-color: #f3faf7;
    background-color: rgba(243, 250, 247, var(--bg-opacity));
  }
  .sm\\:bg-green-100 {
    --bg-opacity: 1;
    background-color: #def7ec;
    background-color: rgba(222, 247, 236, var(--bg-opacity));
  }
  .sm\\:bg-green-200 {
    --bg-opacity: 1;
    background-color: #bcf0da;
    background-color: rgba(188, 240, 218, var(--bg-opacity));
  }
  .sm\\:bg-green-300 {
    --bg-opacity: 1;
    background-color: #84e1bc;
    background-color: rgba(132, 225, 188, var(--bg-opacity));
  }
  .sm\\:bg-green-400 {
    --bg-opacity: 1;
    background-color: #31c48d;
    background-color: rgba(49, 196, 141, var(--bg-opacity));
  }
  .sm\\:bg-green-500 {
    --bg-opacity: 1;
    background-color: #0e9f6e;
    background-color: rgba(14, 159, 110, var(--bg-opacity));
  }
  .sm\\:bg-green-600 {
    --bg-opacity: 1;
    background-color: #057a55;
    background-color: rgba(5, 122, 85, var(--bg-opacity));
  }
  .sm\\:bg-green-700 {
    --bg-opacity: 1;
    background-color: #046c4e;
    background-color: rgba(4, 108, 78, var(--bg-opacity));
  }
  .sm\\:bg-green-800 {
    --bg-opacity: 1;
    background-color: #03543f;
    background-color: rgba(3, 84, 63, var(--bg-opacity));
  }
  .sm\\:bg-green-900 {
    --bg-opacity: 1;
    background-color: #014737;
    background-color: rgba(1, 71, 55, var(--bg-opacity));
  }
  .sm\\:bg-teal-50 {
    --bg-opacity: 1;
    background-color: #edfafa;
    background-color: rgba(237, 250, 250, var(--bg-opacity));
  }
  .sm\\:bg-teal-100 {
    --bg-opacity: 1;
    background-color: #d5f5f6;
    background-color: rgba(213, 245, 246, var(--bg-opacity));
  }
  .sm\\:bg-teal-200 {
    --bg-opacity: 1;
    background-color: #afecef;
    background-color: rgba(175, 236, 239, var(--bg-opacity));
  }
  .sm\\:bg-teal-300 {
    --bg-opacity: 1;
    background-color: #7edce2;
    background-color: rgba(126, 220, 226, var(--bg-opacity));
  }
  .sm\\:bg-teal-400 {
    --bg-opacity: 1;
    background-color: #16bdca;
    background-color: rgba(22, 189, 202, var(--bg-opacity));
  }
  .sm\\:bg-teal-500 {
    --bg-opacity: 1;
    background-color: #0694a2;
    background-color: rgba(6, 148, 162, var(--bg-opacity));
  }
  .sm\\:bg-teal-600 {
    --bg-opacity: 1;
    background-color: #047481;
    background-color: rgba(4, 116, 129, var(--bg-opacity));
  }
  .sm\\:bg-teal-700 {
    --bg-opacity: 1;
    background-color: #036672;
    background-color: rgba(3, 102, 114, var(--bg-opacity));
  }
  .sm\\:bg-teal-800 {
    --bg-opacity: 1;
    background-color: #05505c;
    background-color: rgba(5, 80, 92, var(--bg-opacity));
  }
  .sm\\:bg-teal-900 {
    --bg-opacity: 1;
    background-color: #014451;
    background-color: rgba(1, 68, 81, var(--bg-opacity));
  }
  .sm\\:bg-blue-50 {
    --bg-opacity: 1;
    background-color: #ebf5ff;
    background-color: rgba(235, 245, 255, var(--bg-opacity));
  }
  .sm\\:bg-blue-100 {
    --bg-opacity: 1;
    background-color: #e1effe;
    background-color: rgba(225, 239, 254, var(--bg-opacity));
  }
  .sm\\:bg-blue-200 {
    --bg-opacity: 1;
    background-color: #c3ddfd;
    background-color: rgba(195, 221, 253, var(--bg-opacity));
  }
  .sm\\:bg-blue-300 {
    --bg-opacity: 1;
    background-color: #a4cafe;
    background-color: rgba(164, 202, 254, var(--bg-opacity));
  }
  .sm\\:bg-blue-400 {
    --bg-opacity: 1;
    background-color: #76a9fa;
    background-color: rgba(118, 169, 250, var(--bg-opacity));
  }
  .sm\\:bg-blue-500 {
    --bg-opacity: 1;
    background-color: #3f83f8;
    background-color: rgba(63, 131, 248, var(--bg-opacity));
  }
  .sm\\:bg-blue-600 {
    --bg-opacity: 1;
    background-color: #1c64f2;
    background-color: rgba(28, 100, 242, var(--bg-opacity));
  }
  .sm\\:bg-blue-700 {
    --bg-opacity: 1;
    background-color: #1a56db;
    background-color: rgba(26, 86, 219, var(--bg-opacity));
  }
  .sm\\:bg-blue-800 {
    --bg-opacity: 1;
    background-color: #1e429f;
    background-color: rgba(30, 66, 159, var(--bg-opacity));
  }
  .sm\\:bg-blue-900 {
    --bg-opacity: 1;
    background-color: #233876;
    background-color: rgba(35, 56, 118, var(--bg-opacity));
  }
  .sm\\:bg-indigo-50 {
    --bg-opacity: 1;
    background-color: #f0f5ff;
    background-color: rgba(240, 245, 255, var(--bg-opacity));
  }
  .sm\\:bg-indigo-100 {
    --bg-opacity: 1;
    background-color: #e5edff;
    background-color: rgba(229, 237, 255, var(--bg-opacity));
  }
  .sm\\:bg-indigo-200 {
    --bg-opacity: 1;
    background-color: #cddbfe;
    background-color: rgba(205, 219, 254, var(--bg-opacity));
  }
  .sm\\:bg-indigo-300 {
    --bg-opacity: 1;
    background-color: #b4c6fc;
    background-color: rgba(180, 198, 252, var(--bg-opacity));
  }
  .sm\\:bg-indigo-400 {
    --bg-opacity: 1;
    background-color: #8da2fb;
    background-color: rgba(141, 162, 251, var(--bg-opacity));
  }
  .sm\\:bg-indigo-500 {
    --bg-opacity: 1;
    background-color: #6875f5;
    background-color: rgba(104, 117, 245, var(--bg-opacity));
  }
  .sm\\:bg-indigo-600 {
    --bg-opacity: 1;
    background-color: #5850ec;
    background-color: rgba(88, 80, 236, var(--bg-opacity));
  }
  .sm\\:bg-indigo-700 {
    --bg-opacity: 1;
    background-color: #5145cd;
    background-color: rgba(81, 69, 205, var(--bg-opacity));
  }
  .sm\\:bg-indigo-800 {
    --bg-opacity: 1;
    background-color: #42389d;
    background-color: rgba(66, 56, 157, var(--bg-opacity));
  }
  .sm\\:bg-indigo-900 {
    --bg-opacity: 1;
    background-color: #362f78;
    background-color: rgba(54, 47, 120, var(--bg-opacity));
  }
  .sm\\:bg-purple-50 {
    --bg-opacity: 1;
    background-color: #f6f5ff;
    background-color: rgba(246, 245, 255, var(--bg-opacity));
  }
  .sm\\:bg-purple-100 {
    --bg-opacity: 1;
    background-color: #edebfe;
    background-color: rgba(237, 235, 254, var(--bg-opacity));
  }
  .sm\\:bg-purple-200 {
    --bg-opacity: 1;
    background-color: #dcd7fe;
    background-color: rgba(220, 215, 254, var(--bg-opacity));
  }
  .sm\\:bg-purple-300 {
    --bg-opacity: 1;
    background-color: #cabffd;
    background-color: rgba(202, 191, 253, var(--bg-opacity));
  }
  .sm\\:bg-purple-400 {
    --bg-opacity: 1;
    background-color: #ac94fa;
    background-color: rgba(172, 148, 250, var(--bg-opacity));
  }
  .sm\\:bg-purple-500 {
    --bg-opacity: 1;
    background-color: #9061f9;
    background-color: rgba(144, 97, 249, var(--bg-opacity));
  }
  .sm\\:bg-purple-600 {
    --bg-opacity: 1;
    background-color: #7e3af2;
    background-color: rgba(126, 58, 242, var(--bg-opacity));
  }
  .sm\\:bg-purple-700 {
    --bg-opacity: 1;
    background-color: #6c2bd9;
    background-color: rgba(108, 43, 217, var(--bg-opacity));
  }
  .sm\\:bg-purple-800 {
    --bg-opacity: 1;
    background-color: #5521b5;
    background-color: rgba(85, 33, 181, var(--bg-opacity));
  }
  .sm\\:bg-purple-900 {
    --bg-opacity: 1;
    background-color: #4a1d96;
    background-color: rgba(74, 29, 150, var(--bg-opacity));
  }
  .sm\\:bg-pink-50 {
    --bg-opacity: 1;
    background-color: #fdf2f8;
    background-color: rgba(253, 242, 248, var(--bg-opacity));
  }
  .sm\\:bg-pink-100 {
    --bg-opacity: 1;
    background-color: #fce8f3;
    background-color: rgba(252, 232, 243, var(--bg-opacity));
  }
  .sm\\:bg-pink-200 {
    --bg-opacity: 1;
    background-color: #fad1e8;
    background-color: rgba(250, 209, 232, var(--bg-opacity));
  }
  .sm\\:bg-pink-300 {
    --bg-opacity: 1;
    background-color: #f8b4d9;
    background-color: rgba(248, 180, 217, var(--bg-opacity));
  }
  .sm\\:bg-pink-400 {
    --bg-opacity: 1;
    background-color: #f17eb8;
    background-color: rgba(241, 126, 184, var(--bg-opacity));
  }
  .sm\\:bg-pink-500 {
    --bg-opacity: 1;
    background-color: #e74694;
    background-color: rgba(231, 70, 148, var(--bg-opacity));
  }
  .sm\\:bg-pink-600 {
    --bg-opacity: 1;
    background-color: #d61f69;
    background-color: rgba(214, 31, 105, var(--bg-opacity));
  }
  .sm\\:bg-pink-700 {
    --bg-opacity: 1;
    background-color: #bf125d;
    background-color: rgba(191, 18, 93, var(--bg-opacity));
  }
  .sm\\:bg-pink-800 {
    --bg-opacity: 1;
    background-color: #99154b;
    background-color: rgba(153, 21, 75, var(--bg-opacity));
  }
  .sm\\:bg-pink-900 {
    --bg-opacity: 1;
    background-color: #751a3d;
    background-color: rgba(117, 26, 61, var(--bg-opacity));
  }
  .sm\\:bg-cool-gray-50 {
    --bg-opacity: 1;
    background-color: #f8fafc;
    background-color: rgba(248, 250, 252, var(--bg-opacity));
  }
  .sm\\:bg-cool-gray-100 {
    --bg-opacity: 1;
    background-color: #f1f5f9;
    background-color: rgba(241, 245, 249, var(--bg-opacity));
  }
  .sm\\:bg-cool-gray-200 {
    --bg-opacity: 1;
    background-color: #e2e8f0;
    background-color: rgba(226, 232, 240, var(--bg-opacity));
  }
  .sm\\:bg-cool-gray-300 {
    --bg-opacity: 1;
    background-color: #cfd8e3;
    background-color: rgba(207, 216, 227, var(--bg-opacity));
  }
  .sm\\:bg-cool-gray-400 {
    --bg-opacity: 1;
    background-color: #97a6ba;
    background-color: rgba(151, 166, 186, var(--bg-opacity));
  }
  .sm\\:bg-cool-gray-500 {
    --bg-opacity: 1;
    background-color: #64748b;
    background-color: rgba(100, 116, 139, var(--bg-opacity));
  }
  .sm\\:bg-cool-gray-600 {
    --bg-opacity: 1;
    background-color: #475569;
    background-color: rgba(71, 85, 105, var(--bg-opacity));
  }
  .sm\\:bg-cool-gray-700 {
    --bg-opacity: 1;
    background-color: #364152;
    background-color: rgba(54, 65, 82, var(--bg-opacity));
  }
  .sm\\:bg-cool-gray-800 {
    --bg-opacity: 1;
    background-color: #27303f;
    background-color: rgba(39, 48, 63, var(--bg-opacity));
  }
  .sm\\:bg-cool-gray-900 {
    --bg-opacity: 1;
    background-color: #1a202e;
    background-color: rgba(26, 32, 46, var(--bg-opacity));
  }
  .group:hover .sm\\:group-hover\\:bg-current {
    background-color: currentColor;
  }
  .group:hover .sm\\:group-hover\\:bg-transparent {
    background-color: transparent;
  }
  .group:hover .sm\\:group-hover\\:bg-white {
    --bg-opacity: 1;
    background-color: #ffffff;
    background-color: rgba(255, 255, 255, var(--bg-opacity));
  }
  .group:hover .sm\\:group-hover\\:bg-black {
    --bg-opacity: 1;
    background-color: #000000;
    background-color: rgba(0, 0, 0, var(--bg-opacity));
  }
  .group:hover .sm\\:group-hover\\:bg-gray-50 {
    --bg-opacity: 1;
    background-color: #f9fafb;
    background-color: rgba(249, 250, 251, var(--bg-opacity));
  }
  .group:hover .sm\\:group-hover\\:bg-gray-100 {
    --bg-opacity: 1;
    background-color: #f4f5f7;
    background-color: rgba(244, 245, 247, var(--bg-opacity));
  }
  .group:hover .sm\\:group-hover\\:bg-gray-200 {
    --bg-opacity: 1;
    background-color: #e5e7eb;
    background-color: rgba(229, 231, 235, var(--bg-opacity));
  }
  .group:hover .sm\\:group-hover\\:bg-gray-300 {
    --bg-opacity: 1;
    background-color: #d2d6dc;
    background-color: rgba(210, 214, 220, var(--bg-opacity));
  }
  .group:hover .sm\\:group-hover\\:bg-gray-400 {
    --bg-opacity: 1;
    background-color: #9fa6b2;
    background-color: rgba(159, 166, 178, var(--bg-opacity));
  }
  .group:hover .sm\\:group-hover\\:bg-gray-500 {
    --bg-opacity: 1;
    background-color: #6b7280;
    background-color: rgba(107, 114, 128, var(--bg-opacity));
  }
  .group:hover .sm\\:group-hover\\:bg-gray-600 {
    --bg-opacity: 1;
    background-color: #4b5563;
    background-color: rgba(75, 85, 99, var(--bg-opacity));
  }
  .group:hover .sm\\:group-hover\\:bg-gray-700 {
    --bg-opacity: 1;
    background-color: #374151;
    background-color: rgba(55, 65, 81, var(--bg-opacity));
  }
  .group:hover .sm\\:group-hover\\:bg-gray-800 {
    --bg-opacity: 1;
    background-color: #252f3f;
    background-color: rgba(37, 47, 63, var(--bg-opacity));
  }
  .group:hover .sm\\:group-hover\\:bg-gray-900 {
    --bg-opacity: 1;
    background-color: #161e2e;
    background-color: rgba(22, 30, 46, var(--bg-opacity));
  }
  .group:hover .sm\\:group-hover\\:bg-red-50 {
    --bg-opacity: 1;
    background-color: #fdf2f2;
    background-color: rgba(253, 242, 242, var(--bg-opacity));
  }
  .group:hover .sm\\:group-hover\\:bg-red-100 {
    --bg-opacity: 1;
    background-color: #fde8e8;
    background-color: rgba(253, 232, 232, var(--bg-opacity));
  }
  .group:hover .sm\\:group-hover\\:bg-red-200 {
    --bg-opacity: 1;
    background-color: #fbd5d5;
    background-color: rgba(251, 213, 213, var(--bg-opacity));
  }
  .group:hover .sm\\:group-hover\\:bg-red-300 {
    --bg-opacity: 1;
    background-color: #f8b4b4;
    background-color: rgba(248, 180, 180, var(--bg-opacity));
  }
  .group:hover .sm\\:group-hover\\:bg-red-400 {
    --bg-opacity: 1;
    background-color: #f98080;
    background-color: rgba(249, 128, 128, var(--bg-opacity));
  }
  .group:hover .sm\\:group-hover\\:bg-red-500 {
    --bg-opacity: 1;
    background-color: #f05252;
    background-color: rgba(240, 82, 82, var(--bg-opacity));
  }
  .group:hover .sm\\:group-hover\\:bg-red-600 {
    --bg-opacity: 1;
    background-color: #e02424;
    background-color: rgba(224, 36, 36, var(--bg-opacity));
  }
  .group:hover .sm\\:group-hover\\:bg-red-700 {
    --bg-opacity: 1;
    background-color: #c81e1e;
    background-color: rgba(200, 30, 30, var(--bg-opacity));
  }
  .group:hover .sm\\:group-hover\\:bg-red-800 {
    --bg-opacity: 1;
    background-color: #9b1c1c;
    background-color: rgba(155, 28, 28, var(--bg-opacity));
  }
  .group:hover .sm\\:group-hover\\:bg-red-900 {
    --bg-opacity: 1;
    background-color: #771d1d;
    background-color: rgba(119, 29, 29, var(--bg-opacity));
  }
  .group:hover .sm\\:group-hover\\:bg-orange-50 {
    --bg-opacity: 1;
    background-color: #fff8f1;
    background-color: rgba(255, 248, 241, var(--bg-opacity));
  }
  .group:hover .sm\\:group-hover\\:bg-orange-100 {
    --bg-opacity: 1;
    background-color: #feecdc;
    background-color: rgba(254, 236, 220, var(--bg-opacity));
  }
  .group:hover .sm\\:group-hover\\:bg-orange-200 {
    --bg-opacity: 1;
    background-color: #fcd9bd;
    background-color: rgba(252, 217, 189, var(--bg-opacity));
  }
  .group:hover .sm\\:group-hover\\:bg-orange-300 {
    --bg-opacity: 1;
    background-color: #fdba8c;
    background-color: rgba(253, 186, 140, var(--bg-opacity));
  }
  .group:hover .sm\\:group-hover\\:bg-orange-400 {
    --bg-opacity: 1;
    background-color: #ff8a4c;
    background-color: rgba(255, 138, 76, var(--bg-opacity));
  }
  .group:hover .sm\\:group-hover\\:bg-orange-500 {
    --bg-opacity: 1;
    background-color: #ff5a1f;
    background-color: rgba(255, 90, 31, var(--bg-opacity));
  }
  .group:hover .sm\\:group-hover\\:bg-orange-600 {
    --bg-opacity: 1;
    background-color: #d03801;
    background-color: rgba(208, 56, 1, var(--bg-opacity));
  }
  .group:hover .sm\\:group-hover\\:bg-orange-700 {
    --bg-opacity: 1;
    background-color: #b43403;
    background-color: rgba(180, 52, 3, var(--bg-opacity));
  }
  .group:hover .sm\\:group-hover\\:bg-orange-800 {
    --bg-opacity: 1;
    background-color: #8a2c0d;
    background-color: rgba(138, 44, 13, var(--bg-opacity));
  }
  .group:hover .sm\\:group-hover\\:bg-orange-900 {
    --bg-opacity: 1;
    background-color: #73230d;
    background-color: rgba(115, 35, 13, var(--bg-opacity));
  }
  .group:hover .sm\\:group-hover\\:bg-yellow-50 {
    --bg-opacity: 1;
    background-color: #fdfdea;
    background-color: rgba(253, 253, 234, var(--bg-opacity));
  }
  .group:hover .sm\\:group-hover\\:bg-yellow-100 {
    --bg-opacity: 1;
    background-color: #fdf6b2;
    background-color: rgba(253, 246, 178, var(--bg-opacity));
  }
  .group:hover .sm\\:group-hover\\:bg-yellow-200 {
    --bg-opacity: 1;
    background-color: #fce96a;
    background-color: rgba(252, 233, 106, var(--bg-opacity));
  }
  .group:hover .sm\\:group-hover\\:bg-yellow-300 {
    --bg-opacity: 1;
    background-color: #faca15;
    background-color: rgba(250, 202, 21, var(--bg-opacity));
  }
  .group:hover .sm\\:group-hover\\:bg-yellow-400 {
    --bg-opacity: 1;
    background-color: #e3a008;
    background-color: rgba(227, 160, 8, var(--bg-opacity));
  }
  .group:hover .sm\\:group-hover\\:bg-yellow-500 {
    --bg-opacity: 1;
    background-color: #c27803;
    background-color: rgba(194, 120, 3, var(--bg-opacity));
  }
  .group:hover .sm\\:group-hover\\:bg-yellow-600 {
    --bg-opacity: 1;
    background-color: #9f580a;
    background-color: rgba(159, 88, 10, var(--bg-opacity));
  }
  .group:hover .sm\\:group-hover\\:bg-yellow-700 {
    --bg-opacity: 1;
    background-color: #8e4b10;
    background-color: rgba(142, 75, 16, var(--bg-opacity));
  }
  .group:hover .sm\\:group-hover\\:bg-yellow-800 {
    --bg-opacity: 1;
    background-color: #723b13;
    background-color: rgba(114, 59, 19, var(--bg-opacity));
  }
  .group:hover .sm\\:group-hover\\:bg-yellow-900 {
    --bg-opacity: 1;
    background-color: #633112;
    background-color: rgba(99, 49, 18, var(--bg-opacity));
  }
  .group:hover .sm\\:group-hover\\:bg-green-50 {
    --bg-opacity: 1;
    background-color: #f3faf7;
    background-color: rgba(243, 250, 247, var(--bg-opacity));
  }
  .group:hover .sm\\:group-hover\\:bg-green-100 {
    --bg-opacity: 1;
    background-color: #def7ec;
    background-color: rgba(222, 247, 236, var(--bg-opacity));
  }
  .group:hover .sm\\:group-hover\\:bg-green-200 {
    --bg-opacity: 1;
    background-color: #bcf0da;
    background-color: rgba(188, 240, 218, var(--bg-opacity));
  }
  .group:hover .sm\\:group-hover\\:bg-green-300 {
    --bg-opacity: 1;
    background-color: #84e1bc;
    background-color: rgba(132, 225, 188, var(--bg-opacity));
  }
  .group:hover .sm\\:group-hover\\:bg-green-400 {
    --bg-opacity: 1;
    background-color: #31c48d;
    background-color: rgba(49, 196, 141, var(--bg-opacity));
  }
  .group:hover .sm\\:group-hover\\:bg-green-500 {
    --bg-opacity: 1;
    background-color: #0e9f6e;
    background-color: rgba(14, 159, 110, var(--bg-opacity));
  }
  .group:hover .sm\\:group-hover\\:bg-green-600 {
    --bg-opacity: 1;
    background-color: #057a55;
    background-color: rgba(5, 122, 85, var(--bg-opacity));
  }
  .group:hover .sm\\:group-hover\\:bg-green-700 {
    --bg-opacity: 1;
    background-color: #046c4e;
    background-color: rgba(4, 108, 78, var(--bg-opacity));
  }
  .group:hover .sm\\:group-hover\\:bg-green-800 {
    --bg-opacity: 1;
    background-color: #03543f;
    background-color: rgba(3, 84, 63, var(--bg-opacity));
  }
  .group:hover .sm\\:group-hover\\:bg-green-900 {
    --bg-opacity: 1;
    background-color: #014737;
    background-color: rgba(1, 71, 55, var(--bg-opacity));
  }
  .group:hover .sm\\:group-hover\\:bg-teal-50 {
    --bg-opacity: 1;
    background-color: #edfafa;
    background-color: rgba(237, 250, 250, var(--bg-opacity));
  }
  .group:hover .sm\\:group-hover\\:bg-teal-100 {
    --bg-opacity: 1;
    background-color: #d5f5f6;
    background-color: rgba(213, 245, 246, var(--bg-opacity));
  }
  .group:hover .sm\\:group-hover\\:bg-teal-200 {
    --bg-opacity: 1;
    background-color: #afecef;
    background-color: rgba(175, 236, 239, var(--bg-opacity));
  }
  .group:hover .sm\\:group-hover\\:bg-teal-300 {
    --bg-opacity: 1;
    background-color: #7edce2;
    background-color: rgba(126, 220, 226, var(--bg-opacity));
  }
  .group:hover .sm\\:group-hover\\:bg-teal-400 {
    --bg-opacity: 1;
    background-color: #16bdca;
    background-color: rgba(22, 189, 202, var(--bg-opacity));
  }
  .group:hover .sm\\:group-hover\\:bg-teal-500 {
    --bg-opacity: 1;
    background-color: #0694a2;
    background-color: rgba(6, 148, 162, var(--bg-opacity));
  }
  .group:hover .sm\\:group-hover\\:bg-teal-600 {
    --bg-opacity: 1;
    background-color: #047481;
    background-color: rgba(4, 116, 129, var(--bg-opacity));
  }
  .group:hover .sm\\:group-hover\\:bg-teal-700 {
    --bg-opacity: 1;
    background-color: #036672;
    background-color: rgba(3, 102, 114, var(--bg-opacity));
  }
  .group:hover .sm\\:group-hover\\:bg-teal-800 {
    --bg-opacity: 1;
    background-color: #05505c;
    background-color: rgba(5, 80, 92, var(--bg-opacity));
  }
  .group:hover .sm\\:group-hover\\:bg-teal-900 {
    --bg-opacity: 1;
    background-color: #014451;
    background-color: rgba(1, 68, 81, var(--bg-opacity));
  }
  .group:hover .sm\\:group-hover\\:bg-blue-50 {
    --bg-opacity: 1;
    background-color: #ebf5ff;
    background-color: rgba(235, 245, 255, var(--bg-opacity));
  }
  .group:hover .sm\\:group-hover\\:bg-blue-100 {
    --bg-opacity: 1;
    background-color: #e1effe;
    background-color: rgba(225, 239, 254, var(--bg-opacity));
  }
  .group:hover .sm\\:group-hover\\:bg-blue-200 {
    --bg-opacity: 1;
    background-color: #c3ddfd;
    background-color: rgba(195, 221, 253, var(--bg-opacity));
  }
  .group:hover .sm\\:group-hover\\:bg-blue-300 {
    --bg-opacity: 1;
    background-color: #a4cafe;
    background-color: rgba(164, 202, 254, var(--bg-opacity));
  }
  .group:hover .sm\\:group-hover\\:bg-blue-400 {
    --bg-opacity: 1;
    background-color: #76a9fa;
    background-color: rgba(118, 169, 250, var(--bg-opacity));
  }
  .group:hover .sm\\:group-hover\\:bg-blue-500 {
    --bg-opacity: 1;
    background-color: #3f83f8;
    background-color: rgba(63, 131, 248, var(--bg-opacity));
  }
  .group:hover .sm\\:group-hover\\:bg-blue-600 {
    --bg-opacity: 1;
    background-color: #1c64f2;
    background-color: rgba(28, 100, 242, var(--bg-opacity));
  }
  .group:hover .sm\\:group-hover\\:bg-blue-700 {
    --bg-opacity: 1;
    background-color: #1a56db;
    background-color: rgba(26, 86, 219, var(--bg-opacity));
  }
  .group:hover .sm\\:group-hover\\:bg-blue-800 {
    --bg-opacity: 1;
    background-color: #1e429f;
    background-color: rgba(30, 66, 159, var(--bg-opacity));
  }
  .group:hover .sm\\:group-hover\\:bg-blue-900 {
    --bg-opacity: 1;
    background-color: #233876;
    background-color: rgba(35, 56, 118, var(--bg-opacity));
  }
  .group:hover .sm\\:group-hover\\:bg-indigo-50 {
    --bg-opacity: 1;
    background-color: #f0f5ff;
    background-color: rgba(240, 245, 255, var(--bg-opacity));
  }
  .group:hover .sm\\:group-hover\\:bg-indigo-100 {
    --bg-opacity: 1;
    background-color: #e5edff;
    background-color: rgba(229, 237, 255, var(--bg-opacity));
  }
  .group:hover .sm\\:group-hover\\:bg-indigo-200 {
    --bg-opacity: 1;
    background-color: #cddbfe;
    background-color: rgba(205, 219, 254, var(--bg-opacity));
  }
  .group:hover .sm\\:group-hover\\:bg-indigo-300 {
    --bg-opacity: 1;
    background-color: #b4c6fc;
    background-color: rgba(180, 198, 252, var(--bg-opacity));
  }
  .group:hover .sm\\:group-hover\\:bg-indigo-400 {
    --bg-opacity: 1;
    background-color: #8da2fb;
    background-color: rgba(141, 162, 251, var(--bg-opacity));
  }
  .group:hover .sm\\:group-hover\\:bg-indigo-500 {
    --bg-opacity: 1;
    background-color: #6875f5;
    background-color: rgba(104, 117, 245, var(--bg-opacity));
  }
  .group:hover .sm\\:group-hover\\:bg-indigo-600 {
    --bg-opacity: 1;
    background-color: #5850ec;
    background-color: rgba(88, 80, 236, var(--bg-opacity));
  }
  .group:hover .sm\\:group-hover\\:bg-indigo-700 {
    --bg-opacity: 1;
    background-color: #5145cd;
    background-color: rgba(81, 69, 205, var(--bg-opacity));
  }
  .group:hover .sm\\:group-hover\\:bg-indigo-800 {
    --bg-opacity: 1;
    background-color: #42389d;
    background-color: rgba(66, 56, 157, var(--bg-opacity));
  }
  .group:hover .sm\\:group-hover\\:bg-indigo-900 {
    --bg-opacity: 1;
    background-color: #362f78;
    background-color: rgba(54, 47, 120, var(--bg-opacity));
  }
  .group:hover .sm\\:group-hover\\:bg-purple-50 {
    --bg-opacity: 1;
    background-color: #f6f5ff;
    background-color: rgba(246, 245, 255, var(--bg-opacity));
  }
  .group:hover .sm\\:group-hover\\:bg-purple-100 {
    --bg-opacity: 1;
    background-color: #edebfe;
    background-color: rgba(237, 235, 254, var(--bg-opacity));
  }
  .group:hover .sm\\:group-hover\\:bg-purple-200 {
    --bg-opacity: 1;
    background-color: #dcd7fe;
    background-color: rgba(220, 215, 254, var(--bg-opacity));
  }
  .group:hover .sm\\:group-hover\\:bg-purple-300 {
    --bg-opacity: 1;
    background-color: #cabffd;
    background-color: rgba(202, 191, 253, var(--bg-opacity));
  }
  .group:hover .sm\\:group-hover\\:bg-purple-400 {
    --bg-opacity: 1;
    background-color: #ac94fa;
    background-color: rgba(172, 148, 250, var(--bg-opacity));
  }
  .group:hover .sm\\:group-hover\\:bg-purple-500 {
    --bg-opacity: 1;
    background-color: #9061f9;
    background-color: rgba(144, 97, 249, var(--bg-opacity));
  }
  .group:hover .sm\\:group-hover\\:bg-purple-600 {
    --bg-opacity: 1;
    background-color: #7e3af2;
    background-color: rgba(126, 58, 242, var(--bg-opacity));
  }
  .group:hover .sm\\:group-hover\\:bg-purple-700 {
    --bg-opacity: 1;
    background-color: #6c2bd9;
    background-color: rgba(108, 43, 217, var(--bg-opacity));
  }
  .group:hover .sm\\:group-hover\\:bg-purple-800 {
    --bg-opacity: 1;
    background-color: #5521b5;
    background-color: rgba(85, 33, 181, var(--bg-opacity));
  }
  .group:hover .sm\\:group-hover\\:bg-purple-900 {
    --bg-opacity: 1;
    background-color: #4a1d96;
    background-color: rgba(74, 29, 150, var(--bg-opacity));
  }
  .group:hover .sm\\:group-hover\\:bg-pink-50 {
    --bg-opacity: 1;
    background-color: #fdf2f8;
    background-color: rgba(253, 242, 248, var(--bg-opacity));
  }
  .group:hover .sm\\:group-hover\\:bg-pink-100 {
    --bg-opacity: 1;
    background-color: #fce8f3;
    background-color: rgba(252, 232, 243, var(--bg-opacity));
  }
  .group:hover .sm\\:group-hover\\:bg-pink-200 {
    --bg-opacity: 1;
    background-color: #fad1e8;
    background-color: rgba(250, 209, 232, var(--bg-opacity));
  }
  .group:hover .sm\\:group-hover\\:bg-pink-300 {
    --bg-opacity: 1;
    background-color: #f8b4d9;
    background-color: rgba(248, 180, 217, var(--bg-opacity));
  }
  .group:hover .sm\\:group-hover\\:bg-pink-400 {
    --bg-opacity: 1;
    background-color: #f17eb8;
    background-color: rgba(241, 126, 184, var(--bg-opacity));
  }
  .group:hover .sm\\:group-hover\\:bg-pink-500 {
    --bg-opacity: 1;
    background-color: #e74694;
    background-color: rgba(231, 70, 148, var(--bg-opacity));
  }
  .group:hover .sm\\:group-hover\\:bg-pink-600 {
    --bg-opacity: 1;
    background-color: #d61f69;
    background-color: rgba(214, 31, 105, var(--bg-opacity));
  }
  .group:hover .sm\\:group-hover\\:bg-pink-700 {
    --bg-opacity: 1;
    background-color: #bf125d;
    background-color: rgba(191, 18, 93, var(--bg-opacity));
  }
  .group:hover .sm\\:group-hover\\:bg-pink-800 {
    --bg-opacity: 1;
    background-color: #99154b;
    background-color: rgba(153, 21, 75, var(--bg-opacity));
  }
  .group:hover .sm\\:group-hover\\:bg-pink-900 {
    --bg-opacity: 1;
    background-color: #751a3d;
    background-color: rgba(117, 26, 61, var(--bg-opacity));
  }
  .group:hover .sm\\:group-hover\\:bg-cool-gray-50 {
    --bg-opacity: 1;
    background-color: #f8fafc;
    background-color: rgba(248, 250, 252, var(--bg-opacity));
  }
  .group:hover .sm\\:group-hover\\:bg-cool-gray-100 {
    --bg-opacity: 1;
    background-color: #f1f5f9;
    background-color: rgba(241, 245, 249, var(--bg-opacity));
  }
  .group:hover .sm\\:group-hover\\:bg-cool-gray-200 {
    --bg-opacity: 1;
    background-color: #e2e8f0;
    background-color: rgba(226, 232, 240, var(--bg-opacity));
  }
  .group:hover .sm\\:group-hover\\:bg-cool-gray-300 {
    --bg-opacity: 1;
    background-color: #cfd8e3;
    background-color: rgba(207, 216, 227, var(--bg-opacity));
  }
  .group:hover .sm\\:group-hover\\:bg-cool-gray-400 {
    --bg-opacity: 1;
    background-color: #97a6ba;
    background-color: rgba(151, 166, 186, var(--bg-opacity));
  }
  .group:hover .sm\\:group-hover\\:bg-cool-gray-500 {
    --bg-opacity: 1;
    background-color: #64748b;
    background-color: rgba(100, 116, 139, var(--bg-opacity));
  }
  .group:hover .sm\\:group-hover\\:bg-cool-gray-600 {
    --bg-opacity: 1;
    background-color: #475569;
    background-color: rgba(71, 85, 105, var(--bg-opacity));
  }
  .group:hover .sm\\:group-hover\\:bg-cool-gray-700 {
    --bg-opacity: 1;
    background-color: #364152;
    background-color: rgba(54, 65, 82, var(--bg-opacity));
  }
  .group:hover .sm\\:group-hover\\:bg-cool-gray-800 {
    --bg-opacity: 1;
    background-color: #27303f;
    background-color: rgba(39, 48, 63, var(--bg-opacity));
  }
  .group:hover .sm\\:group-hover\\:bg-cool-gray-900 {
    --bg-opacity: 1;
    background-color: #1a202e;
    background-color: rgba(26, 32, 46, var(--bg-opacity));
  }
  .group:focus .sm\\:group-focus\\:bg-current {
    background-color: currentColor;
  }
  .group:focus .sm\\:group-focus\\:bg-transparent {
    background-color: transparent;
  }
  .group:focus .sm\\:group-focus\\:bg-white {
    --bg-opacity: 1;
    background-color: #ffffff;
    background-color: rgba(255, 255, 255, var(--bg-opacity));
  }
  .group:focus .sm\\:group-focus\\:bg-black {
    --bg-opacity: 1;
    background-color: #000000;
    background-color: rgba(0, 0, 0, var(--bg-opacity));
  }
  .group:focus .sm\\:group-focus\\:bg-gray-50 {
    --bg-opacity: 1;
    background-color: #f9fafb;
    background-color: rgba(249, 250, 251, var(--bg-opacity));
  }
  .group:focus .sm\\:group-focus\\:bg-gray-100 {
    --bg-opacity: 1;
    background-color: #f4f5f7;
    background-color: rgba(244, 245, 247, var(--bg-opacity));
  }
  .group:focus .sm\\:group-focus\\:bg-gray-200 {
    --bg-opacity: 1;
    background-color: #e5e7eb;
    background-color: rgba(229, 231, 235, var(--bg-opacity));
  }
  .group:focus .sm\\:group-focus\\:bg-gray-300 {
    --bg-opacity: 1;
    background-color: #d2d6dc;
    background-color: rgba(210, 214, 220, var(--bg-opacity));
  }
  .group:focus .sm\\:group-focus\\:bg-gray-400 {
    --bg-opacity: 1;
    background-color: #9fa6b2;
    background-color: rgba(159, 166, 178, var(--bg-opacity));
  }
  .group:focus .sm\\:group-focus\\:bg-gray-500 {
    --bg-opacity: 1;
    background-color: #6b7280;
    background-color: rgba(107, 114, 128, var(--bg-opacity));
  }
  .group:focus .sm\\:group-focus\\:bg-gray-600 {
    --bg-opacity: 1;
    background-color: #4b5563;
    background-color: rgba(75, 85, 99, var(--bg-opacity));
  }
  .group:focus .sm\\:group-focus\\:bg-gray-700 {
    --bg-opacity: 1;
    background-color: #374151;
    background-color: rgba(55, 65, 81, var(--bg-opacity));
  }
  .group:focus .sm\\:group-focus\\:bg-gray-800 {
    --bg-opacity: 1;
    background-color: #252f3f;
    background-color: rgba(37, 47, 63, var(--bg-opacity));
  }
  .group:focus .sm\\:group-focus\\:bg-gray-900 {
    --bg-opacity: 1;
    background-color: #161e2e;
    background-color: rgba(22, 30, 46, var(--bg-opacity));
  }
  .group:focus .sm\\:group-focus\\:bg-red-50 {
    --bg-opacity: 1;
    background-color: #fdf2f2;
    background-color: rgba(253, 242, 242, var(--bg-opacity));
  }
  .group:focus .sm\\:group-focus\\:bg-red-100 {
    --bg-opacity: 1;
    background-color: #fde8e8;
    background-color: rgba(253, 232, 232, var(--bg-opacity));
  }
  .group:focus .sm\\:group-focus\\:bg-red-200 {
    --bg-opacity: 1;
    background-color: #fbd5d5;
    background-color: rgba(251, 213, 213, var(--bg-opacity));
  }
  .group:focus .sm\\:group-focus\\:bg-red-300 {
    --bg-opacity: 1;
    background-color: #f8b4b4;
    background-color: rgba(248, 180, 180, var(--bg-opacity));
  }
  .group:focus .sm\\:group-focus\\:bg-red-400 {
    --bg-opacity: 1;
    background-color: #f98080;
    background-color: rgba(249, 128, 128, var(--bg-opacity));
  }
  .group:focus .sm\\:group-focus\\:bg-red-500 {
    --bg-opacity: 1;
    background-color: #f05252;
    background-color: rgba(240, 82, 82, var(--bg-opacity));
  }
  .group:focus .sm\\:group-focus\\:bg-red-600 {
    --bg-opacity: 1;
    background-color: #e02424;
    background-color: rgba(224, 36, 36, var(--bg-opacity));
  }
  .group:focus .sm\\:group-focus\\:bg-red-700 {
    --bg-opacity: 1;
    background-color: #c81e1e;
    background-color: rgba(200, 30, 30, var(--bg-opacity));
  }
  .group:focus .sm\\:group-focus\\:bg-red-800 {
    --bg-opacity: 1;
    background-color: #9b1c1c;
    background-color: rgba(155, 28, 28, var(--bg-opacity));
  }
  .group:focus .sm\\:group-focus\\:bg-red-900 {
    --bg-opacity: 1;
    background-color: #771d1d;
    background-color: rgba(119, 29, 29, var(--bg-opacity));
  }
  .group:focus .sm\\:group-focus\\:bg-orange-50 {
    --bg-opacity: 1;
    background-color: #fff8f1;
    background-color: rgba(255, 248, 241, var(--bg-opacity));
  }
  .group:focus .sm\\:group-focus\\:bg-orange-100 {
    --bg-opacity: 1;
    background-color: #feecdc;
    background-color: rgba(254, 236, 220, var(--bg-opacity));
  }
  .group:focus .sm\\:group-focus\\:bg-orange-200 {
    --bg-opacity: 1;
    background-color: #fcd9bd;
    background-color: rgba(252, 217, 189, var(--bg-opacity));
  }
  .group:focus .sm\\:group-focus\\:bg-orange-300 {
    --bg-opacity: 1;
    background-color: #fdba8c;
    background-color: rgba(253, 186, 140, var(--bg-opacity));
  }
  .group:focus .sm\\:group-focus\\:bg-orange-400 {
    --bg-opacity: 1;
    background-color: #ff8a4c;
    background-color: rgba(255, 138, 76, var(--bg-opacity));
  }
  .group:focus .sm\\:group-focus\\:bg-orange-500 {
    --bg-opacity: 1;
    background-color: #ff5a1f;
    background-color: rgba(255, 90, 31, var(--bg-opacity));
  }
  .group:focus .sm\\:group-focus\\:bg-orange-600 {
    --bg-opacity: 1;
    background-color: #d03801;
    background-color: rgba(208, 56, 1, var(--bg-opacity));
  }
  .group:focus .sm\\:group-focus\\:bg-orange-700 {
    --bg-opacity: 1;
    background-color: #b43403;
    background-color: rgba(180, 52, 3, var(--bg-opacity));
  }
  .group:focus .sm\\:group-focus\\:bg-orange-800 {
    --bg-opacity: 1;
    background-color: #8a2c0d;
    background-color: rgba(138, 44, 13, var(--bg-opacity));
  }
  .group:focus .sm\\:group-focus\\:bg-orange-900 {
    --bg-opacity: 1;
    background-color: #73230d;
    background-color: rgba(115, 35, 13, var(--bg-opacity));
  }
  .group:focus .sm\\:group-focus\\:bg-yellow-50 {
    --bg-opacity: 1;
    background-color: #fdfdea;
    background-color: rgba(253, 253, 234, var(--bg-opacity));
  }
  .group:focus .sm\\:group-focus\\:bg-yellow-100 {
    --bg-opacity: 1;
    background-color: #fdf6b2;
    background-color: rgba(253, 246, 178, var(--bg-opacity));
  }
  .group:focus .sm\\:group-focus\\:bg-yellow-200 {
    --bg-opacity: 1;
    background-color: #fce96a;
    background-color: rgba(252, 233, 106, var(--bg-opacity));
  }
  .group:focus .sm\\:group-focus\\:bg-yellow-300 {
    --bg-opacity: 1;
    background-color: #faca15;
    background-color: rgba(250, 202, 21, var(--bg-opacity));
  }
  .group:focus .sm\\:group-focus\\:bg-yellow-400 {
    --bg-opacity: 1;
    background-color: #e3a008;
    background-color: rgba(227, 160, 8, var(--bg-opacity));
  }
  .group:focus .sm\\:group-focus\\:bg-yellow-500 {
    --bg-opacity: 1;
    background-color: #c27803;
    background-color: rgba(194, 120, 3, var(--bg-opacity));
  }
  .group:focus .sm\\:group-focus\\:bg-yellow-600 {
    --bg-opacity: 1;
    background-color: #9f580a;
    background-color: rgba(159, 88, 10, var(--bg-opacity));
  }
  .group:focus .sm\\:group-focus\\:bg-yellow-700 {
    --bg-opacity: 1;
    background-color: #8e4b10;
    background-color: rgba(142, 75, 16, var(--bg-opacity));
  }
  .group:focus .sm\\:group-focus\\:bg-yellow-800 {
    --bg-opacity: 1;
    background-color: #723b13;
    background-color: rgba(114, 59, 19, var(--bg-opacity));
  }
  .group:focus .sm\\:group-focus\\:bg-yellow-900 {
    --bg-opacity: 1;
    background-color: #633112;
    background-color: rgba(99, 49, 18, var(--bg-opacity));
  }
  .group:focus .sm\\:group-focus\\:bg-green-50 {
    --bg-opacity: 1;
    background-color: #f3faf7;
    background-color: rgba(243, 250, 247, var(--bg-opacity));
  }
  .group:focus .sm\\:group-focus\\:bg-green-100 {
    --bg-opacity: 1;
    background-color: #def7ec;
    background-color: rgba(222, 247, 236, var(--bg-opacity));
  }
  .group:focus .sm\\:group-focus\\:bg-green-200 {
    --bg-opacity: 1;
    background-color: #bcf0da;
    background-color: rgba(188, 240, 218, var(--bg-opacity));
  }
  .group:focus .sm\\:group-focus\\:bg-green-300 {
    --bg-opacity: 1;
    background-color: #84e1bc;
    background-color: rgba(132, 225, 188, var(--bg-opacity));
  }
  .group:focus .sm\\:group-focus\\:bg-green-400 {
    --bg-opacity: 1;
    background-color: #31c48d;
    background-color: rgba(49, 196, 141, var(--bg-opacity));
  }
  .group:focus .sm\\:group-focus\\:bg-green-500 {
    --bg-opacity: 1;
    background-color: #0e9f6e;
    background-color: rgba(14, 159, 110, var(--bg-opacity));
  }
  .group:focus .sm\\:group-focus\\:bg-green-600 {
    --bg-opacity: 1;
    background-color: #057a55;
    background-color: rgba(5, 122, 85, var(--bg-opacity));
  }
  .group:focus .sm\\:group-focus\\:bg-green-700 {
    --bg-opacity: 1;
    background-color: #046c4e;
    background-color: rgba(4, 108, 78, var(--bg-opacity));
  }
  .group:focus .sm\\:group-focus\\:bg-green-800 {
    --bg-opacity: 1;
    background-color: #03543f;
    background-color: rgba(3, 84, 63, var(--bg-opacity));
  }
  .group:focus .sm\\:group-focus\\:bg-green-900 {
    --bg-opacity: 1;
    background-color: #014737;
    background-color: rgba(1, 71, 55, var(--bg-opacity));
  }
  .group:focus .sm\\:group-focus\\:bg-teal-50 {
    --bg-opacity: 1;
    background-color: #edfafa;
    background-color: rgba(237, 250, 250, var(--bg-opacity));
  }
  .group:focus .sm\\:group-focus\\:bg-teal-100 {
    --bg-opacity: 1;
    background-color: #d5f5f6;
    background-color: rgba(213, 245, 246, var(--bg-opacity));
  }
  .group:focus .sm\\:group-focus\\:bg-teal-200 {
    --bg-opacity: 1;
    background-color: #afecef;
    background-color: rgba(175, 236, 239, var(--bg-opacity));
  }
  .group:focus .sm\\:group-focus\\:bg-teal-300 {
    --bg-opacity: 1;
    background-color: #7edce2;
    background-color: rgba(126, 220, 226, var(--bg-opacity));
  }
  .group:focus .sm\\:group-focus\\:bg-teal-400 {
    --bg-opacity: 1;
    background-color: #16bdca;
    background-color: rgba(22, 189, 202, var(--bg-opacity));
  }
  .group:focus .sm\\:group-focus\\:bg-teal-500 {
    --bg-opacity: 1;
    background-color: #0694a2;
    background-color: rgba(6, 148, 162, var(--bg-opacity));
  }
  .group:focus .sm\\:group-focus\\:bg-teal-600 {
    --bg-opacity: 1;
    background-color: #047481;
    background-color: rgba(4, 116, 129, var(--bg-opacity));
  }
  .group:focus .sm\\:group-focus\\:bg-teal-700 {
    --bg-opacity: 1;
    background-color: #036672;
    background-color: rgba(3, 102, 114, var(--bg-opacity));
  }
  .group:focus .sm\\:group-focus\\:bg-teal-800 {
    --bg-opacity: 1;
    background-color: #05505c;
    background-color: rgba(5, 80, 92, var(--bg-opacity));
  }
  .group:focus .sm\\:group-focus\\:bg-teal-900 {
    --bg-opacity: 1;
    background-color: #014451;
    background-color: rgba(1, 68, 81, var(--bg-opacity));
  }
  .group:focus .sm\\:group-focus\\:bg-blue-50 {
    --bg-opacity: 1;
    background-color: #ebf5ff;
    background-color: rgba(235, 245, 255, var(--bg-opacity));
  }
  .group:focus .sm\\:group-focus\\:bg-blue-100 {
    --bg-opacity: 1;
    background-color: #e1effe;
    background-color: rgba(225, 239, 254, var(--bg-opacity));
  }
  .group:focus .sm\\:group-focus\\:bg-blue-200 {
    --bg-opacity: 1;
    background-color: #c3ddfd;
    background-color: rgba(195, 221, 253, var(--bg-opacity));
  }
  .group:focus .sm\\:group-focus\\:bg-blue-300 {
    --bg-opacity: 1;
    background-color: #a4cafe;
    background-color: rgba(164, 202, 254, var(--bg-opacity));
  }
  .group:focus .sm\\:group-focus\\:bg-blue-400 {
    --bg-opacity: 1;
    background-color: #76a9fa;
    background-color: rgba(118, 169, 250, var(--bg-opacity));
  }
  .group:focus .sm\\:group-focus\\:bg-blue-500 {
    --bg-opacity: 1;
    background-color: #3f83f8;
    background-color: rgba(63, 131, 248, var(--bg-opacity));
  }
  .group:focus .sm\\:group-focus\\:bg-blue-600 {
    --bg-opacity: 1;
    background-color: #1c64f2;
    background-color: rgba(28, 100, 242, var(--bg-opacity));
  }
  .group:focus .sm\\:group-focus\\:bg-blue-700 {
    --bg-opacity: 1;
    background-color: #1a56db;
    background-color: rgba(26, 86, 219, var(--bg-opacity));
  }
  .group:focus .sm\\:group-focus\\:bg-blue-800 {
    --bg-opacity: 1;
    background-color: #1e429f;
    background-color: rgba(30, 66, 159, var(--bg-opacity));
  }
  .group:focus .sm\\:group-focus\\:bg-blue-900 {
    --bg-opacity: 1;
    background-color: #233876;
    background-color: rgba(35, 56, 118, var(--bg-opacity));
  }
  .group:focus .sm\\:group-focus\\:bg-indigo-50 {
    --bg-opacity: 1;
    background-color: #f0f5ff;
    background-color: rgba(240, 245, 255, var(--bg-opacity));
  }
  .group:focus .sm\\:group-focus\\:bg-indigo-100 {
    --bg-opacity: 1;
    background-color: #e5edff;
    background-color: rgba(229, 237, 255, var(--bg-opacity));
  }
  .group:focus .sm\\:group-focus\\:bg-indigo-200 {
    --bg-opacity: 1;
    background-color: #cddbfe;
    background-color: rgba(205, 219, 254, var(--bg-opacity));
  }
  .group:focus .sm\\:group-focus\\:bg-indigo-300 {
    --bg-opacity: 1;
    background-color: #b4c6fc;
    background-color: rgba(180, 198, 252, var(--bg-opacity));
  }
  .group:focus .sm\\:group-focus\\:bg-indigo-400 {
    --bg-opacity: 1;
    background-color: #8da2fb;
    background-color: rgba(141, 162, 251, var(--bg-opacity));
  }
  .group:focus .sm\\:group-focus\\:bg-indigo-500 {
    --bg-opacity: 1;
    background-color: #6875f5;
    background-color: rgba(104, 117, 245, var(--bg-opacity));
  }
  .group:focus .sm\\:group-focus\\:bg-indigo-600 {
    --bg-opacity: 1;
    background-color: #5850ec;
    background-color: rgba(88, 80, 236, var(--bg-opacity));
  }
  .group:focus .sm\\:group-focus\\:bg-indigo-700 {
    --bg-opacity: 1;
    background-color: #5145cd;
    background-color: rgba(81, 69, 205, var(--bg-opacity));
  }
  .group:focus .sm\\:group-focus\\:bg-indigo-800 {
    --bg-opacity: 1;
    background-color: #42389d;
    background-color: rgba(66, 56, 157, var(--bg-opacity));
  }
  .group:focus .sm\\:group-focus\\:bg-indigo-900 {
    --bg-opacity: 1;
    background-color: #362f78;
    background-color: rgba(54, 47, 120, var(--bg-opacity));
  }
  .group:focus .sm\\:group-focus\\:bg-purple-50 {
    --bg-opacity: 1;
    background-color: #f6f5ff;
    background-color: rgba(246, 245, 255, var(--bg-opacity));
  }
  .group:focus .sm\\:group-focus\\:bg-purple-100 {
    --bg-opacity: 1;
    background-color: #edebfe;
    background-color: rgba(237, 235, 254, var(--bg-opacity));
  }
  .group:focus .sm\\:group-focus\\:bg-purple-200 {
    --bg-opacity: 1;
    background-color: #dcd7fe;
    background-color: rgba(220, 215, 254, var(--bg-opacity));
  }
  .group:focus .sm\\:group-focus\\:bg-purple-300 {
    --bg-opacity: 1;
    background-color: #cabffd;
    background-color: rgba(202, 191, 253, var(--bg-opacity));
  }
  .group:focus .sm\\:group-focus\\:bg-purple-400 {
    --bg-opacity: 1;
    background-color: #ac94fa;
    background-color: rgba(172, 148, 250, var(--bg-opacity));
  }
  .group:focus .sm\\:group-focus\\:bg-purple-500 {
    --bg-opacity: 1;
    background-color: #9061f9;
    background-color: rgba(144, 97, 249, var(--bg-opacity));
  }
  .group:focus .sm\\:group-focus\\:bg-purple-600 {
    --bg-opacity: 1;
    background-color: #7e3af2;
    background-color: rgba(126, 58, 242, var(--bg-opacity));
  }
  .group:focus .sm\\:group-focus\\:bg-purple-700 {
    --bg-opacity: 1;
    background-color: #6c2bd9;
    background-color: rgba(108, 43, 217, var(--bg-opacity));
  }
  .group:focus .sm\\:group-focus\\:bg-purple-800 {
    --bg-opacity: 1;
    background-color: #5521b5;
    background-color: rgba(85, 33, 181, var(--bg-opacity));
  }
  .group:focus .sm\\:group-focus\\:bg-purple-900 {
    --bg-opacity: 1;
    background-color: #4a1d96;
    background-color: rgba(74, 29, 150, var(--bg-opacity));
  }
  .group:focus .sm\\:group-focus\\:bg-pink-50 {
    --bg-opacity: 1;
    background-color: #fdf2f8;
    background-color: rgba(253, 242, 248, var(--bg-opacity));
  }
  .group:focus .sm\\:group-focus\\:bg-pink-100 {
    --bg-opacity: 1;
    background-color: #fce8f3;
    background-color: rgba(252, 232, 243, var(--bg-opacity));
  }
  .group:focus .sm\\:group-focus\\:bg-pink-200 {
    --bg-opacity: 1;
    background-color: #fad1e8;
    background-color: rgba(250, 209, 232, var(--bg-opacity));
  }
  .group:focus .sm\\:group-focus\\:bg-pink-300 {
    --bg-opacity: 1;
    background-color: #f8b4d9;
    background-color: rgba(248, 180, 217, var(--bg-opacity));
  }
  .group:focus .sm\\:group-focus\\:bg-pink-400 {
    --bg-opacity: 1;
    background-color: #f17eb8;
    background-color: rgba(241, 126, 184, var(--bg-opacity));
  }
  .group:focus .sm\\:group-focus\\:bg-pink-500 {
    --bg-opacity: 1;
    background-color: #e74694;
    background-color: rgba(231, 70, 148, var(--bg-opacity));
  }
  .group:focus .sm\\:group-focus\\:bg-pink-600 {
    --bg-opacity: 1;
    background-color: #d61f69;
    background-color: rgba(214, 31, 105, var(--bg-opacity));
  }
  .group:focus .sm\\:group-focus\\:bg-pink-700 {
    --bg-opacity: 1;
    background-color: #bf125d;
    background-color: rgba(191, 18, 93, var(--bg-opacity));
  }
  .group:focus .sm\\:group-focus\\:bg-pink-800 {
    --bg-opacity: 1;
    background-color: #99154b;
    background-color: rgba(153, 21, 75, var(--bg-opacity));
  }
  .group:focus .sm\\:group-focus\\:bg-pink-900 {
    --bg-opacity: 1;
    background-color: #751a3d;
    background-color: rgba(117, 26, 61, var(--bg-opacity));
  }
  .group:focus .sm\\:group-focus\\:bg-cool-gray-50 {
    --bg-opacity: 1;
    background-color: #f8fafc;
    background-color: rgba(248, 250, 252, var(--bg-opacity));
  }
  .group:focus .sm\\:group-focus\\:bg-cool-gray-100 {
    --bg-opacity: 1;
    background-color: #f1f5f9;
    background-color: rgba(241, 245, 249, var(--bg-opacity));
  }
  .group:focus .sm\\:group-focus\\:bg-cool-gray-200 {
    --bg-opacity: 1;
    background-color: #e2e8f0;
    background-color: rgba(226, 232, 240, var(--bg-opacity));
  }
  .group:focus .sm\\:group-focus\\:bg-cool-gray-300 {
    --bg-opacity: 1;
    background-color: #cfd8e3;
    background-color: rgba(207, 216, 227, var(--bg-opacity));
  }
  .group:focus .sm\\:group-focus\\:bg-cool-gray-400 {
    --bg-opacity: 1;
    background-color: #97a6ba;
    background-color: rgba(151, 166, 186, var(--bg-opacity));
  }
  .group:focus .sm\\:group-focus\\:bg-cool-gray-500 {
    --bg-opacity: 1;
    background-color: #64748b;
    background-color: rgba(100, 116, 139, var(--bg-opacity));
  }
  .group:focus .sm\\:group-focus\\:bg-cool-gray-600 {
    --bg-opacity: 1;
    background-color: #475569;
    background-color: rgba(71, 85, 105, var(--bg-opacity));
  }
  .group:focus .sm\\:group-focus\\:bg-cool-gray-700 {
    --bg-opacity: 1;
    background-color: #364152;
    background-color: rgba(54, 65, 82, var(--bg-opacity));
  }
  .group:focus .sm\\:group-focus\\:bg-cool-gray-800 {
    --bg-opacity: 1;
    background-color: #27303f;
    background-color: rgba(39, 48, 63, var(--bg-opacity));
  }
  .group:focus .sm\\:group-focus\\:bg-cool-gray-900 {
    --bg-opacity: 1;
    background-color: #1a202e;
    background-color: rgba(26, 32, 46, var(--bg-opacity));
  }
  .sm\\:hover\\:bg-current:hover {
    background-color: currentColor;
  }
  .sm\\:hover\\:bg-transparent:hover {
    background-color: transparent;
  }
  .sm\\:hover\\:bg-white:hover {
    --bg-opacity: 1;
    background-color: #ffffff;
    background-color: rgba(255, 255, 255, var(--bg-opacity));
  }
  .sm\\:hover\\:bg-black:hover {
    --bg-opacity: 1;
    background-color: #000000;
    background-color: rgba(0, 0, 0, var(--bg-opacity));
  }
  .sm\\:hover\\:bg-gray-50:hover {
    --bg-opacity: 1;
    background-color: #f9fafb;
    background-color: rgba(249, 250, 251, var(--bg-opacity));
  }
  .sm\\:hover\\:bg-gray-100:hover {
    --bg-opacity: 1;
    background-color: #f4f5f7;
    background-color: rgba(244, 245, 247, var(--bg-opacity));
  }
  .sm\\:hover\\:bg-gray-200:hover {
    --bg-opacity: 1;
    background-color: #e5e7eb;
    background-color: rgba(229, 231, 235, var(--bg-opacity));
  }
  .sm\\:hover\\:bg-gray-300:hover {
    --bg-opacity: 1;
    background-color: #d2d6dc;
    background-color: rgba(210, 214, 220, var(--bg-opacity));
  }
  .sm\\:hover\\:bg-gray-400:hover {
    --bg-opacity: 1;
    background-color: #9fa6b2;
    background-color: rgba(159, 166, 178, var(--bg-opacity));
  }
  .sm\\:hover\\:bg-gray-500:hover {
    --bg-opacity: 1;
    background-color: #6b7280;
    background-color: rgba(107, 114, 128, var(--bg-opacity));
  }
  .sm\\:hover\\:bg-gray-600:hover {
    --bg-opacity: 1;
    background-color: #4b5563;
    background-color: rgba(75, 85, 99, var(--bg-opacity));
  }
  .sm\\:hover\\:bg-gray-700:hover {
    --bg-opacity: 1;
    background-color: #374151;
    background-color: rgba(55, 65, 81, var(--bg-opacity));
  }
  .sm\\:hover\\:bg-gray-800:hover {
    --bg-opacity: 1;
    background-color: #252f3f;
    background-color: rgba(37, 47, 63, var(--bg-opacity));
  }
  .sm\\:hover\\:bg-gray-900:hover {
    --bg-opacity: 1;
    background-color: #161e2e;
    background-color: rgba(22, 30, 46, var(--bg-opacity));
  }
  .sm\\:hover\\:bg-red-50:hover {
    --bg-opacity: 1;
    background-color: #fdf2f2;
    background-color: rgba(253, 242, 242, var(--bg-opacity));
  }
  .sm\\:hover\\:bg-red-100:hover {
    --bg-opacity: 1;
    background-color: #fde8e8;
    background-color: rgba(253, 232, 232, var(--bg-opacity));
  }
  .sm\\:hover\\:bg-red-200:hover {
    --bg-opacity: 1;
    background-color: #fbd5d5;
    background-color: rgba(251, 213, 213, var(--bg-opacity));
  }
  .sm\\:hover\\:bg-red-300:hover {
    --bg-opacity: 1;
    background-color: #f8b4b4;
    background-color: rgba(248, 180, 180, var(--bg-opacity));
  }
  .sm\\:hover\\:bg-red-400:hover {
    --bg-opacity: 1;
    background-color: #f98080;
    background-color: rgba(249, 128, 128, var(--bg-opacity));
  }
  .sm\\:hover\\:bg-red-500:hover {
    --bg-opacity: 1;
    background-color: #f05252;
    background-color: rgba(240, 82, 82, var(--bg-opacity));
  }
  .sm\\:hover\\:bg-red-600:hover {
    --bg-opacity: 1;
    background-color: #e02424;
    background-color: rgba(224, 36, 36, var(--bg-opacity));
  }
  .sm\\:hover\\:bg-red-700:hover {
    --bg-opacity: 1;
    background-color: #c81e1e;
    background-color: rgba(200, 30, 30, var(--bg-opacity));
  }
  .sm\\:hover\\:bg-red-800:hover {
    --bg-opacity: 1;
    background-color: #9b1c1c;
    background-color: rgba(155, 28, 28, var(--bg-opacity));
  }
  .sm\\:hover\\:bg-red-900:hover {
    --bg-opacity: 1;
    background-color: #771d1d;
    background-color: rgba(119, 29, 29, var(--bg-opacity));
  }
  .sm\\:hover\\:bg-orange-50:hover {
    --bg-opacity: 1;
    background-color: #fff8f1;
    background-color: rgba(255, 248, 241, var(--bg-opacity));
  }
  .sm\\:hover\\:bg-orange-100:hover {
    --bg-opacity: 1;
    background-color: #feecdc;
    background-color: rgba(254, 236, 220, var(--bg-opacity));
  }
  .sm\\:hover\\:bg-orange-200:hover {
    --bg-opacity: 1;
    background-color: #fcd9bd;
    background-color: rgba(252, 217, 189, var(--bg-opacity));
  }
  .sm\\:hover\\:bg-orange-300:hover {
    --bg-opacity: 1;
    background-color: #fdba8c;
    background-color: rgba(253, 186, 140, var(--bg-opacity));
  }
  .sm\\:hover\\:bg-orange-400:hover {
    --bg-opacity: 1;
    background-color: #ff8a4c;
    background-color: rgba(255, 138, 76, var(--bg-opacity));
  }
  .sm\\:hover\\:bg-orange-500:hover {
    --bg-opacity: 1;
    background-color: #ff5a1f;
    background-color: rgba(255, 90, 31, var(--bg-opacity));
  }
  .sm\\:hover\\:bg-orange-600:hover {
    --bg-opacity: 1;
    background-color: #d03801;
    background-color: rgba(208, 56, 1, var(--bg-opacity));
  }
  .sm\\:hover\\:bg-orange-700:hover {
    --bg-opacity: 1;
    background-color: #b43403;
    background-color: rgba(180, 52, 3, var(--bg-opacity));
  }
  .sm\\:hover\\:bg-orange-800:hover {
    --bg-opacity: 1;
    background-color: #8a2c0d;
    background-color: rgba(138, 44, 13, var(--bg-opacity));
  }
  .sm\\:hover\\:bg-orange-900:hover {
    --bg-opacity: 1;
    background-color: #73230d;
    background-color: rgba(115, 35, 13, var(--bg-opacity));
  }
  .sm\\:hover\\:bg-yellow-50:hover {
    --bg-opacity: 1;
    background-color: #fdfdea;
    background-color: rgba(253, 253, 234, var(--bg-opacity));
  }
  .sm\\:hover\\:bg-yellow-100:hover {
    --bg-opacity: 1;
    background-color: #fdf6b2;
    background-color: rgba(253, 246, 178, var(--bg-opacity));
  }
  .sm\\:hover\\:bg-yellow-200:hover {
    --bg-opacity: 1;
    background-color: #fce96a;
    background-color: rgba(252, 233, 106, var(--bg-opacity));
  }
  .sm\\:hover\\:bg-yellow-300:hover {
    --bg-opacity: 1;
    background-color: #faca15;
    background-color: rgba(250, 202, 21, var(--bg-opacity));
  }
  .sm\\:hover\\:bg-yellow-400:hover {
    --bg-opacity: 1;
    background-color: #e3a008;
    background-color: rgba(227, 160, 8, var(--bg-opacity));
  }
  .sm\\:hover\\:bg-yellow-500:hover {
    --bg-opacity: 1;
    background-color: #c27803;
    background-color: rgba(194, 120, 3, var(--bg-opacity));
  }
  .sm\\:hover\\:bg-yellow-600:hover {
    --bg-opacity: 1;
    background-color: #9f580a;
    background-color: rgba(159, 88, 10, var(--bg-opacity));
  }
  .sm\\:hover\\:bg-yellow-700:hover {
    --bg-opacity: 1;
    background-color: #8e4b10;
    background-color: rgba(142, 75, 16, var(--bg-opacity));
  }
  .sm\\:hover\\:bg-yellow-800:hover {
    --bg-opacity: 1;
    background-color: #723b13;
    background-color: rgba(114, 59, 19, var(--bg-opacity));
  }
  .sm\\:hover\\:bg-yellow-900:hover {
    --bg-opacity: 1;
    background-color: #633112;
    background-color: rgba(99, 49, 18, var(--bg-opacity));
  }
  .sm\\:hover\\:bg-green-50:hover {
    --bg-opacity: 1;
    background-color: #f3faf7;
    background-color: rgba(243, 250, 247, var(--bg-opacity));
  }
  .sm\\:hover\\:bg-green-100:hover {
    --bg-opacity: 1;
    background-color: #def7ec;
    background-color: rgba(222, 247, 236, var(--bg-opacity));
  }
  .sm\\:hover\\:bg-green-200:hover {
    --bg-opacity: 1;
    background-color: #bcf0da;
    background-color: rgba(188, 240, 218, var(--bg-opacity));
  }
  .sm\\:hover\\:bg-green-300:hover {
    --bg-opacity: 1;
    background-color: #84e1bc;
    background-color: rgba(132, 225, 188, var(--bg-opacity));
  }
  .sm\\:hover\\:bg-green-400:hover {
    --bg-opacity: 1;
    background-color: #31c48d;
    background-color: rgba(49, 196, 141, var(--bg-opacity));
  }
  .sm\\:hover\\:bg-green-500:hover {
    --bg-opacity: 1;
    background-color: #0e9f6e;
    background-color: rgba(14, 159, 110, var(--bg-opacity));
  }
  .sm\\:hover\\:bg-green-600:hover {
    --bg-opacity: 1;
    background-color: #057a55;
    background-color: rgba(5, 122, 85, var(--bg-opacity));
  }
  .sm\\:hover\\:bg-green-700:hover {
    --bg-opacity: 1;
    background-color: #046c4e;
    background-color: rgba(4, 108, 78, var(--bg-opacity));
  }
  .sm\\:hover\\:bg-green-800:hover {
    --bg-opacity: 1;
    background-color: #03543f;
    background-color: rgba(3, 84, 63, var(--bg-opacity));
  }
  .sm\\:hover\\:bg-green-900:hover {
    --bg-opacity: 1;
    background-color: #014737;
    background-color: rgba(1, 71, 55, var(--bg-opacity));
  }
  .sm\\:hover\\:bg-teal-50:hover {
    --bg-opacity: 1;
    background-color: #edfafa;
    background-color: rgba(237, 250, 250, var(--bg-opacity));
  }
  .sm\\:hover\\:bg-teal-100:hover {
    --bg-opacity: 1;
    background-color: #d5f5f6;
    background-color: rgba(213, 245, 246, var(--bg-opacity));
  }
  .sm\\:hover\\:bg-teal-200:hover {
    --bg-opacity: 1;
    background-color: #afecef;
    background-color: rgba(175, 236, 239, var(--bg-opacity));
  }
  .sm\\:hover\\:bg-teal-300:hover {
    --bg-opacity: 1;
    background-color: #7edce2;
    background-color: rgba(126, 220, 226, var(--bg-opacity));
  }
  .sm\\:hover\\:bg-teal-400:hover {
    --bg-opacity: 1;
    background-color: #16bdca;
    background-color: rgba(22, 189, 202, var(--bg-opacity));
  }
  .sm\\:hover\\:bg-teal-500:hover {
    --bg-opacity: 1;
    background-color: #0694a2;
    background-color: rgba(6, 148, 162, var(--bg-opacity));
  }
  .sm\\:hover\\:bg-teal-600:hover {
    --bg-opacity: 1;
    background-color: #047481;
    background-color: rgba(4, 116, 129, var(--bg-opacity));
  }
  .sm\\:hover\\:bg-teal-700:hover {
    --bg-opacity: 1;
    background-color: #036672;
    background-color: rgba(3, 102, 114, var(--bg-opacity));
  }
  .sm\\:hover\\:bg-teal-800:hover {
    --bg-opacity: 1;
    background-color: #05505c;
    background-color: rgba(5, 80, 92, var(--bg-opacity));
  }
  .sm\\:hover\\:bg-teal-900:hover {
    --bg-opacity: 1;
    background-color: #014451;
    background-color: rgba(1, 68, 81, var(--bg-opacity));
  }
  .sm\\:hover\\:bg-blue-50:hover {
    --bg-opacity: 1;
    background-color: #ebf5ff;
    background-color: rgba(235, 245, 255, var(--bg-opacity));
  }
  .sm\\:hover\\:bg-blue-100:hover {
    --bg-opacity: 1;
    background-color: #e1effe;
    background-color: rgba(225, 239, 254, var(--bg-opacity));
  }
  .sm\\:hover\\:bg-blue-200:hover {
    --bg-opacity: 1;
    background-color: #c3ddfd;
    background-color: rgba(195, 221, 253, var(--bg-opacity));
  }
  .sm\\:hover\\:bg-blue-300:hover {
    --bg-opacity: 1;
    background-color: #a4cafe;
    background-color: rgba(164, 202, 254, var(--bg-opacity));
  }
  .sm\\:hover\\:bg-blue-400:hover {
    --bg-opacity: 1;
    background-color: #76a9fa;
    background-color: rgba(118, 169, 250, var(--bg-opacity));
  }
  .sm\\:hover\\:bg-blue-500:hover {
    --bg-opacity: 1;
    background-color: #3f83f8;
    background-color: rgba(63, 131, 248, var(--bg-opacity));
  }
  .sm\\:hover\\:bg-blue-600:hover {
    --bg-opacity: 1;
    background-color: #1c64f2;
    background-color: rgba(28, 100, 242, var(--bg-opacity));
  }
  .sm\\:hover\\:bg-blue-700:hover {
    --bg-opacity: 1;
    background-color: #1a56db;
    background-color: rgba(26, 86, 219, var(--bg-opacity));
  }
  .sm\\:hover\\:bg-blue-800:hover {
    --bg-opacity: 1;
    background-color: #1e429f;
    background-color: rgba(30, 66, 159, var(--bg-opacity));
  }
  .sm\\:hover\\:bg-blue-900:hover {
    --bg-opacity: 1;
    background-color: #233876;
    background-color: rgba(35, 56, 118, var(--bg-opacity));
  }
  .sm\\:hover\\:bg-indigo-50:hover {
    --bg-opacity: 1;
    background-color: #f0f5ff;
    background-color: rgba(240, 245, 255, var(--bg-opacity));
  }
  .sm\\:hover\\:bg-indigo-100:hover {
    --bg-opacity: 1;
    background-color: #e5edff;
    background-color: rgba(229, 237, 255, var(--bg-opacity));
  }
  .sm\\:hover\\:bg-indigo-200:hover {
    --bg-opacity: 1;
    background-color: #cddbfe;
    background-color: rgba(205, 219, 254, var(--bg-opacity));
  }
  .sm\\:hover\\:bg-indigo-300:hover {
    --bg-opacity: 1;
    background-color: #b4c6fc;
    background-color: rgba(180, 198, 252, var(--bg-opacity));
  }
  .sm\\:hover\\:bg-indigo-400:hover {
    --bg-opacity: 1;
    background-color: #8da2fb;
    background-color: rgba(141, 162, 251, var(--bg-opacity));
  }
  .sm\\:hover\\:bg-indigo-500:hover {
    --bg-opacity: 1;
    background-color: #6875f5;
    background-color: rgba(104, 117, 245, var(--bg-opacity));
  }
  .sm\\:hover\\:bg-indigo-600:hover {
    --bg-opacity: 1;
    background-color: #5850ec;
    background-color: rgba(88, 80, 236, var(--bg-opacity));
  }
  .sm\\:hover\\:bg-indigo-700:hover {
    --bg-opacity: 1;
    background-color: #5145cd;
    background-color: rgba(81, 69, 205, var(--bg-opacity));
  }
  .sm\\:hover\\:bg-indigo-800:hover {
    --bg-opacity: 1;
    background-color: #42389d;
    background-color: rgba(66, 56, 157, var(--bg-opacity));
  }
  .sm\\:hover\\:bg-indigo-900:hover {
    --bg-opacity: 1;
    background-color: #362f78;
    background-color: rgba(54, 47, 120, var(--bg-opacity));
  }
  .sm\\:hover\\:bg-purple-50:hover {
    --bg-opacity: 1;
    background-color: #f6f5ff;
    background-color: rgba(246, 245, 255, var(--bg-opacity));
  }
  .sm\\:hover\\:bg-purple-100:hover {
    --bg-opacity: 1;
    background-color: #edebfe;
    background-color: rgba(237, 235, 254, var(--bg-opacity));
  }
  .sm\\:hover\\:bg-purple-200:hover {
    --bg-opacity: 1;
    background-color: #dcd7fe;
    background-color: rgba(220, 215, 254, var(--bg-opacity));
  }
  .sm\\:hover\\:bg-purple-300:hover {
    --bg-opacity: 1;
    background-color: #cabffd;
    background-color: rgba(202, 191, 253, var(--bg-opacity));
  }
  .sm\\:hover\\:bg-purple-400:hover {
    --bg-opacity: 1;
    background-color: #ac94fa;
    background-color: rgba(172, 148, 250, var(--bg-opacity));
  }
  .sm\\:hover\\:bg-purple-500:hover {
    --bg-opacity: 1;
    background-color: #9061f9;
    background-color: rgba(144, 97, 249, var(--bg-opacity));
  }
  .sm\\:hover\\:bg-purple-600:hover {
    --bg-opacity: 1;
    background-color: #7e3af2;
    background-color: rgba(126, 58, 242, var(--bg-opacity));
  }
  .sm\\:hover\\:bg-purple-700:hover {
    --bg-opacity: 1;
    background-color: #6c2bd9;
    background-color: rgba(108, 43, 217, var(--bg-opacity));
  }
  .sm\\:hover\\:bg-purple-800:hover {
    --bg-opacity: 1;
    background-color: #5521b5;
    background-color: rgba(85, 33, 181, var(--bg-opacity));
  }
  .sm\\:hover\\:bg-purple-900:hover {
    --bg-opacity: 1;
    background-color: #4a1d96;
    background-color: rgba(74, 29, 150, var(--bg-opacity));
  }
  .sm\\:hover\\:bg-pink-50:hover {
    --bg-opacity: 1;
    background-color: #fdf2f8;
    background-color: rgba(253, 242, 248, var(--bg-opacity));
  }
  .sm\\:hover\\:bg-pink-100:hover {
    --bg-opacity: 1;
    background-color: #fce8f3;
    background-color: rgba(252, 232, 243, var(--bg-opacity));
  }
  .sm\\:hover\\:bg-pink-200:hover {
    --bg-opacity: 1;
    background-color: #fad1e8;
    background-color: rgba(250, 209, 232, var(--bg-opacity));
  }
  .sm\\:hover\\:bg-pink-300:hover {
    --bg-opacity: 1;
    background-color: #f8b4d9;
    background-color: rgba(248, 180, 217, var(--bg-opacity));
  }
  .sm\\:hover\\:bg-pink-400:hover {
    --bg-opacity: 1;
    background-color: #f17eb8;
    background-color: rgba(241, 126, 184, var(--bg-opacity));
  }
  .sm\\:hover\\:bg-pink-500:hover {
    --bg-opacity: 1;
    background-color: #e74694;
    background-color: rgba(231, 70, 148, var(--bg-opacity));
  }
  .sm\\:hover\\:bg-pink-600:hover {
    --bg-opacity: 1;
    background-color: #d61f69;
    background-color: rgba(214, 31, 105, var(--bg-opacity));
  }
  .sm\\:hover\\:bg-pink-700:hover {
    --bg-opacity: 1;
    background-color: #bf125d;
    background-color: rgba(191, 18, 93, var(--bg-opacity));
  }
  .sm\\:hover\\:bg-pink-800:hover {
    --bg-opacity: 1;
    background-color: #99154b;
    background-color: rgba(153, 21, 75, var(--bg-opacity));
  }
  .sm\\:hover\\:bg-pink-900:hover {
    --bg-opacity: 1;
    background-color: #751a3d;
    background-color: rgba(117, 26, 61, var(--bg-opacity));
  }
  .sm\\:hover\\:bg-cool-gray-50:hover {
    --bg-opacity: 1;
    background-color: #f8fafc;
    background-color: rgba(248, 250, 252, var(--bg-opacity));
  }
  .sm\\:hover\\:bg-cool-gray-100:hover {
    --bg-opacity: 1;
    background-color: #f1f5f9;
    background-color: rgba(241, 245, 249, var(--bg-opacity));
  }
  .sm\\:hover\\:bg-cool-gray-200:hover {
    --bg-opacity: 1;
    background-color: #e2e8f0;
    background-color: rgba(226, 232, 240, var(--bg-opacity));
  }
  .sm\\:hover\\:bg-cool-gray-300:hover {
    --bg-opacity: 1;
    background-color: #cfd8e3;
    background-color: rgba(207, 216, 227, var(--bg-opacity));
  }
  .sm\\:hover\\:bg-cool-gray-400:hover {
    --bg-opacity: 1;
    background-color: #97a6ba;
    background-color: rgba(151, 166, 186, var(--bg-opacity));
  }
  .sm\\:hover\\:bg-cool-gray-500:hover {
    --bg-opacity: 1;
    background-color: #64748b;
    background-color: rgba(100, 116, 139, var(--bg-opacity));
  }
  .sm\\:hover\\:bg-cool-gray-600:hover {
    --bg-opacity: 1;
    background-color: #475569;
    background-color: rgba(71, 85, 105, var(--bg-opacity));
  }
  .sm\\:hover\\:bg-cool-gray-700:hover {
    --bg-opacity: 1;
    background-color: #364152;
    background-color: rgba(54, 65, 82, var(--bg-opacity));
  }
  .sm\\:hover\\:bg-cool-gray-800:hover {
    --bg-opacity: 1;
    background-color: #27303f;
    background-color: rgba(39, 48, 63, var(--bg-opacity));
  }
  .sm\\:hover\\:bg-cool-gray-900:hover {
    --bg-opacity: 1;
    background-color: #1a202e;
    background-color: rgba(26, 32, 46, var(--bg-opacity));
  }
  .sm\\:focus\\:bg-current:focus {
    background-color: currentColor;
  }
  .sm\\:focus\\:bg-transparent:focus {
    background-color: transparent;
  }
  .sm\\:focus\\:bg-white:focus {
    --bg-opacity: 1;
    background-color: #ffffff;
    background-color: rgba(255, 255, 255, var(--bg-opacity));
  }
  .sm\\:focus\\:bg-black:focus {
    --bg-opacity: 1;
    background-color: #000000;
    background-color: rgba(0, 0, 0, var(--bg-opacity));
  }
  .sm\\:focus\\:bg-gray-50:focus {
    --bg-opacity: 1;
    background-color: #f9fafb;
    background-color: rgba(249, 250, 251, var(--bg-opacity));
  }
  .sm\\:focus\\:bg-gray-100:focus {
    --bg-opacity: 1;
    background-color: #f4f5f7;
    background-color: rgba(244, 245, 247, var(--bg-opacity));
  }
  .sm\\:focus\\:bg-gray-200:focus {
    --bg-opacity: 1;
    background-color: #e5e7eb;
    background-color: rgba(229, 231, 235, var(--bg-opacity));
  }
  .sm\\:focus\\:bg-gray-300:focus {
    --bg-opacity: 1;
    background-color: #d2d6dc;
    background-color: rgba(210, 214, 220, var(--bg-opacity));
  }
  .sm\\:focus\\:bg-gray-400:focus {
    --bg-opacity: 1;
    background-color: #9fa6b2;
    background-color: rgba(159, 166, 178, var(--bg-opacity));
  }
  .sm\\:focus\\:bg-gray-500:focus {
    --bg-opacity: 1;
    background-color: #6b7280;
    background-color: rgba(107, 114, 128, var(--bg-opacity));
  }
  .sm\\:focus\\:bg-gray-600:focus {
    --bg-opacity: 1;
    background-color: #4b5563;
    background-color: rgba(75, 85, 99, var(--bg-opacity));
  }
  .sm\\:focus\\:bg-gray-700:focus {
    --bg-opacity: 1;
    background-color: #374151;
    background-color: rgba(55, 65, 81, var(--bg-opacity));
  }
  .sm\\:focus\\:bg-gray-800:focus {
    --bg-opacity: 1;
    background-color: #252f3f;
    background-color: rgba(37, 47, 63, var(--bg-opacity));
  }
  .sm\\:focus\\:bg-gray-900:focus {
    --bg-opacity: 1;
    background-color: #161e2e;
    background-color: rgba(22, 30, 46, var(--bg-opacity));
  }
  .sm\\:focus\\:bg-red-50:focus {
    --bg-opacity: 1;
    background-color: #fdf2f2;
    background-color: rgba(253, 242, 242, var(--bg-opacity));
  }
  .sm\\:focus\\:bg-red-100:focus {
    --bg-opacity: 1;
    background-color: #fde8e8;
    background-color: rgba(253, 232, 232, var(--bg-opacity));
  }
  .sm\\:focus\\:bg-red-200:focus {
    --bg-opacity: 1;
    background-color: #fbd5d5;
    background-color: rgba(251, 213, 213, var(--bg-opacity));
  }
  .sm\\:focus\\:bg-red-300:focus {
    --bg-opacity: 1;
    background-color: #f8b4b4;
    background-color: rgba(248, 180, 180, var(--bg-opacity));
  }
  .sm\\:focus\\:bg-red-400:focus {
    --bg-opacity: 1;
    background-color: #f98080;
    background-color: rgba(249, 128, 128, var(--bg-opacity));
  }
  .sm\\:focus\\:bg-red-500:focus {
    --bg-opacity: 1;
    background-color: #f05252;
    background-color: rgba(240, 82, 82, var(--bg-opacity));
  }
  .sm\\:focus\\:bg-red-600:focus {
    --bg-opacity: 1;
    background-color: #e02424;
    background-color: rgba(224, 36, 36, var(--bg-opacity));
  }
  .sm\\:focus\\:bg-red-700:focus {
    --bg-opacity: 1;
    background-color: #c81e1e;
    background-color: rgba(200, 30, 30, var(--bg-opacity));
  }
  .sm\\:focus\\:bg-red-800:focus {
    --bg-opacity: 1;
    background-color: #9b1c1c;
    background-color: rgba(155, 28, 28, var(--bg-opacity));
  }
  .sm\\:focus\\:bg-red-900:focus {
    --bg-opacity: 1;
    background-color: #771d1d;
    background-color: rgba(119, 29, 29, var(--bg-opacity));
  }
  .sm\\:focus\\:bg-orange-50:focus {
    --bg-opacity: 1;
    background-color: #fff8f1;
    background-color: rgba(255, 248, 241, var(--bg-opacity));
  }
  .sm\\:focus\\:bg-orange-100:focus {
    --bg-opacity: 1;
    background-color: #feecdc;
    background-color: rgba(254, 236, 220, var(--bg-opacity));
  }
  .sm\\:focus\\:bg-orange-200:focus {
    --bg-opacity: 1;
    background-color: #fcd9bd;
    background-color: rgba(252, 217, 189, var(--bg-opacity));
  }
  .sm\\:focus\\:bg-orange-300:focus {
    --bg-opacity: 1;
    background-color: #fdba8c;
    background-color: rgba(253, 186, 140, var(--bg-opacity));
  }
  .sm\\:focus\\:bg-orange-400:focus {
    --bg-opacity: 1;
    background-color: #ff8a4c;
    background-color: rgba(255, 138, 76, var(--bg-opacity));
  }
  .sm\\:focus\\:bg-orange-500:focus {
    --bg-opacity: 1;
    background-color: #ff5a1f;
    background-color: rgba(255, 90, 31, var(--bg-opacity));
  }
  .sm\\:focus\\:bg-orange-600:focus {
    --bg-opacity: 1;
    background-color: #d03801;
    background-color: rgba(208, 56, 1, var(--bg-opacity));
  }
  .sm\\:focus\\:bg-orange-700:focus {
    --bg-opacity: 1;
    background-color: #b43403;
    background-color: rgba(180, 52, 3, var(--bg-opacity));
  }
  .sm\\:focus\\:bg-orange-800:focus {
    --bg-opacity: 1;
    background-color: #8a2c0d;
    background-color: rgba(138, 44, 13, var(--bg-opacity));
  }
  .sm\\:focus\\:bg-orange-900:focus {
    --bg-opacity: 1;
    background-color: #73230d;
    background-color: rgba(115, 35, 13, var(--bg-opacity));
  }
  .sm\\:focus\\:bg-yellow-50:focus {
    --bg-opacity: 1;
    background-color: #fdfdea;
    background-color: rgba(253, 253, 234, var(--bg-opacity));
  }
  .sm\\:focus\\:bg-yellow-100:focus {
    --bg-opacity: 1;
    background-color: #fdf6b2;
    background-color: rgba(253, 246, 178, var(--bg-opacity));
  }
  .sm\\:focus\\:bg-yellow-200:focus {
    --bg-opacity: 1;
    background-color: #fce96a;
    background-color: rgba(252, 233, 106, var(--bg-opacity));
  }
  .sm\\:focus\\:bg-yellow-300:focus {
    --bg-opacity: 1;
    background-color: #faca15;
    background-color: rgba(250, 202, 21, var(--bg-opacity));
  }
  .sm\\:focus\\:bg-yellow-400:focus {
    --bg-opacity: 1;
    background-color: #e3a008;
    background-color: rgba(227, 160, 8, var(--bg-opacity));
  }
  .sm\\:focus\\:bg-yellow-500:focus {
    --bg-opacity: 1;
    background-color: #c27803;
    background-color: rgba(194, 120, 3, var(--bg-opacity));
  }
  .sm\\:focus\\:bg-yellow-600:focus {
    --bg-opacity: 1;
    background-color: #9f580a;
    background-color: rgba(159, 88, 10, var(--bg-opacity));
  }
  .sm\\:focus\\:bg-yellow-700:focus {
    --bg-opacity: 1;
    background-color: #8e4b10;
    background-color: rgba(142, 75, 16, var(--bg-opacity));
  }
  .sm\\:focus\\:bg-yellow-800:focus {
    --bg-opacity: 1;
    background-color: #723b13;
    background-color: rgba(114, 59, 19, var(--bg-opacity));
  }
  .sm\\:focus\\:bg-yellow-900:focus {
    --bg-opacity: 1;
    background-color: #633112;
    background-color: rgba(99, 49, 18, var(--bg-opacity));
  }
  .sm\\:focus\\:bg-green-50:focus {
    --bg-opacity: 1;
    background-color: #f3faf7;
    background-color: rgba(243, 250, 247, var(--bg-opacity));
  }
  .sm\\:focus\\:bg-green-100:focus {
    --bg-opacity: 1;
    background-color: #def7ec;
    background-color: rgba(222, 247, 236, var(--bg-opacity));
  }
  .sm\\:focus\\:bg-green-200:focus {
    --bg-opacity: 1;
    background-color: #bcf0da;
    background-color: rgba(188, 240, 218, var(--bg-opacity));
  }
  .sm\\:focus\\:bg-green-300:focus {
    --bg-opacity: 1;
    background-color: #84e1bc;
    background-color: rgba(132, 225, 188, var(--bg-opacity));
  }
  .sm\\:focus\\:bg-green-400:focus {
    --bg-opacity: 1;
    background-color: #31c48d;
    background-color: rgba(49, 196, 141, var(--bg-opacity));
  }
  .sm\\:focus\\:bg-green-500:focus {
    --bg-opacity: 1;
    background-color: #0e9f6e;
    background-color: rgba(14, 159, 110, var(--bg-opacity));
  }
  .sm\\:focus\\:bg-green-600:focus {
    --bg-opacity: 1;
    background-color: #057a55;
    background-color: rgba(5, 122, 85, var(--bg-opacity));
  }
  .sm\\:focus\\:bg-green-700:focus {
    --bg-opacity: 1;
    background-color: #046c4e;
    background-color: rgba(4, 108, 78, var(--bg-opacity));
  }
  .sm\\:focus\\:bg-green-800:focus {
    --bg-opacity: 1;
    background-color: #03543f;
    background-color: rgba(3, 84, 63, var(--bg-opacity));
  }
  .sm\\:focus\\:bg-green-900:focus {
    --bg-opacity: 1;
    background-color: #014737;
    background-color: rgba(1, 71, 55, var(--bg-opacity));
  }
  .sm\\:focus\\:bg-teal-50:focus {
    --bg-opacity: 1;
    background-color: #edfafa;
    background-color: rgba(237, 250, 250, var(--bg-opacity));
  }
  .sm\\:focus\\:bg-teal-100:focus {
    --bg-opacity: 1;
    background-color: #d5f5f6;
    background-color: rgba(213, 245, 246, var(--bg-opacity));
  }
  .sm\\:focus\\:bg-teal-200:focus {
    --bg-opacity: 1;
    background-color: #afecef;
    background-color: rgba(175, 236, 239, var(--bg-opacity));
  }
  .sm\\:focus\\:bg-teal-300:focus {
    --bg-opacity: 1;
    background-color: #7edce2;
    background-color: rgba(126, 220, 226, var(--bg-opacity));
  }
  .sm\\:focus\\:bg-teal-400:focus {
    --bg-opacity: 1;
    background-color: #16bdca;
    background-color: rgba(22, 189, 202, var(--bg-opacity));
  }
  .sm\\:focus\\:bg-teal-500:focus {
    --bg-opacity: 1;
    background-color: #0694a2;
    background-color: rgba(6, 148, 162, var(--bg-opacity));
  }
  .sm\\:focus\\:bg-teal-600:focus {
    --bg-opacity: 1;
    background-color: #047481;
    background-color: rgba(4, 116, 129, var(--bg-opacity));
  }
  .sm\\:focus\\:bg-teal-700:focus {
    --bg-opacity: 1;
    background-color: #036672;
    background-color: rgba(3, 102, 114, var(--bg-opacity));
  }
  .sm\\:focus\\:bg-teal-800:focus {
    --bg-opacity: 1;
    background-color: #05505c;
    background-color: rgba(5, 80, 92, var(--bg-opacity));
  }
  .sm\\:focus\\:bg-teal-900:focus {
    --bg-opacity: 1;
    background-color: #014451;
    background-color: rgba(1, 68, 81, var(--bg-opacity));
  }
  .sm\\:focus\\:bg-blue-50:focus {
    --bg-opacity: 1;
    background-color: #ebf5ff;
    background-color: rgba(235, 245, 255, var(--bg-opacity));
  }
  .sm\\:focus\\:bg-blue-100:focus {
    --bg-opacity: 1;
    background-color: #e1effe;
    background-color: rgba(225, 239, 254, var(--bg-opacity));
  }
  .sm\\:focus\\:bg-blue-200:focus {
    --bg-opacity: 1;
    background-color: #c3ddfd;
    background-color: rgba(195, 221, 253, var(--bg-opacity));
  }
  .sm\\:focus\\:bg-blue-300:focus {
    --bg-opacity: 1;
    background-color: #a4cafe;
    background-color: rgba(164, 202, 254, var(--bg-opacity));
  }
  .sm\\:focus\\:bg-blue-400:focus {
    --bg-opacity: 1;
    background-color: #76a9fa;
    background-color: rgba(118, 169, 250, var(--bg-opacity));
  }
  .sm\\:focus\\:bg-blue-500:focus {
    --bg-opacity: 1;
    background-color: #3f83f8;
    background-color: rgba(63, 131, 248, var(--bg-opacity));
  }
  .sm\\:focus\\:bg-blue-600:focus {
    --bg-opacity: 1;
    background-color: #1c64f2;
    background-color: rgba(28, 100, 242, var(--bg-opacity));
  }
  .sm\\:focus\\:bg-blue-700:focus {
    --bg-opacity: 1;
    background-color: #1a56db;
    background-color: rgba(26, 86, 219, var(--bg-opacity));
  }
  .sm\\:focus\\:bg-blue-800:focus {
    --bg-opacity: 1;
    background-color: #1e429f;
    background-color: rgba(30, 66, 159, var(--bg-opacity));
  }
  .sm\\:focus\\:bg-blue-900:focus {
    --bg-opacity: 1;
    background-color: #233876;
    background-color: rgba(35, 56, 118, var(--bg-opacity));
  }
  .sm\\:focus\\:bg-indigo-50:focus {
    --bg-opacity: 1;
    background-color: #f0f5ff;
    background-color: rgba(240, 245, 255, var(--bg-opacity));
  }
  .sm\\:focus\\:bg-indigo-100:focus {
    --bg-opacity: 1;
    background-color: #e5edff;
    background-color: rgba(229, 237, 255, var(--bg-opacity));
  }
  .sm\\:focus\\:bg-indigo-200:focus {
    --bg-opacity: 1;
    background-color: #cddbfe;
    background-color: rgba(205, 219, 254, var(--bg-opacity));
  }
  .sm\\:focus\\:bg-indigo-300:focus {
    --bg-opacity: 1;
    background-color: #b4c6fc;
    background-color: rgba(180, 198, 252, var(--bg-opacity));
  }
  .sm\\:focus\\:bg-indigo-400:focus {
    --bg-opacity: 1;
    background-color: #8da2fb;
    background-color: rgba(141, 162, 251, var(--bg-opacity));
  }
  .sm\\:focus\\:bg-indigo-500:focus {
    --bg-opacity: 1;
    background-color: #6875f5;
    background-color: rgba(104, 117, 245, var(--bg-opacity));
  }
  .sm\\:focus\\:bg-indigo-600:focus {
    --bg-opacity: 1;
    background-color: #5850ec;
    background-color: rgba(88, 80, 236, var(--bg-opacity));
  }
  .sm\\:focus\\:bg-indigo-700:focus {
    --bg-opacity: 1;
    background-color: #5145cd;
    background-color: rgba(81, 69, 205, var(--bg-opacity));
  }
  .sm\\:focus\\:bg-indigo-800:focus {
    --bg-opacity: 1;
    background-color: #42389d;
    background-color: rgba(66, 56, 157, var(--bg-opacity));
  }
  .sm\\:focus\\:bg-indigo-900:focus {
    --bg-opacity: 1;
    background-color: #362f78;
    background-color: rgba(54, 47, 120, var(--bg-opacity));
  }
  .sm\\:focus\\:bg-purple-50:focus {
    --bg-opacity: 1;
    background-color: #f6f5ff;
    background-color: rgba(246, 245, 255, var(--bg-opacity));
  }
  .sm\\:focus\\:bg-purple-100:focus {
    --bg-opacity: 1;
    background-color: #edebfe;
    background-color: rgba(237, 235, 254, var(--bg-opacity));
  }
  .sm\\:focus\\:bg-purple-200:focus {
    --bg-opacity: 1;
    background-color: #dcd7fe;
    background-color: rgba(220, 215, 254, var(--bg-opacity));
  }
  .sm\\:focus\\:bg-purple-300:focus {
    --bg-opacity: 1;
    background-color: #cabffd;
    background-color: rgba(202, 191, 253, var(--bg-opacity));
  }
  .sm\\:focus\\:bg-purple-400:focus {
    --bg-opacity: 1;
    background-color: #ac94fa;
    background-color: rgba(172, 148, 250, var(--bg-opacity));
  }
  .sm\\:focus\\:bg-purple-500:focus {
    --bg-opacity: 1;
    background-color: #9061f9;
    background-color: rgba(144, 97, 249, var(--bg-opacity));
  }
  .sm\\:focus\\:bg-purple-600:focus {
    --bg-opacity: 1;
    background-color: #7e3af2;
    background-color: rgba(126, 58, 242, var(--bg-opacity));
  }
  .sm\\:focus\\:bg-purple-700:focus {
    --bg-opacity: 1;
    background-color: #6c2bd9;
    background-color: rgba(108, 43, 217, var(--bg-opacity));
  }
  .sm\\:focus\\:bg-purple-800:focus {
    --bg-opacity: 1;
    background-color: #5521b5;
    background-color: rgba(85, 33, 181, var(--bg-opacity));
  }
  .sm\\:focus\\:bg-purple-900:focus {
    --bg-opacity: 1;
    background-color: #4a1d96;
    background-color: rgba(74, 29, 150, var(--bg-opacity));
  }
  .sm\\:focus\\:bg-pink-50:focus {
    --bg-opacity: 1;
    background-color: #fdf2f8;
    background-color: rgba(253, 242, 248, var(--bg-opacity));
  }
  .sm\\:focus\\:bg-pink-100:focus {
    --bg-opacity: 1;
    background-color: #fce8f3;
    background-color: rgba(252, 232, 243, var(--bg-opacity));
  }
  .sm\\:focus\\:bg-pink-200:focus {
    --bg-opacity: 1;
    background-color: #fad1e8;
    background-color: rgba(250, 209, 232, var(--bg-opacity));
  }
  .sm\\:focus\\:bg-pink-300:focus {
    --bg-opacity: 1;
    background-color: #f8b4d9;
    background-color: rgba(248, 180, 217, var(--bg-opacity));
  }
  .sm\\:focus\\:bg-pink-400:focus {
    --bg-opacity: 1;
    background-color: #f17eb8;
    background-color: rgba(241, 126, 184, var(--bg-opacity));
  }
  .sm\\:focus\\:bg-pink-500:focus {
    --bg-opacity: 1;
    background-color: #e74694;
    background-color: rgba(231, 70, 148, var(--bg-opacity));
  }
  .sm\\:focus\\:bg-pink-600:focus {
    --bg-opacity: 1;
    background-color: #d61f69;
    background-color: rgba(214, 31, 105, var(--bg-opacity));
  }
  .sm\\:focus\\:bg-pink-700:focus {
    --bg-opacity: 1;
    background-color: #bf125d;
    background-color: rgba(191, 18, 93, var(--bg-opacity));
  }
  .sm\\:focus\\:bg-pink-800:focus {
    --bg-opacity: 1;
    background-color: #99154b;
    background-color: rgba(153, 21, 75, var(--bg-opacity));
  }
  .sm\\:focus\\:bg-pink-900:focus {
    --bg-opacity: 1;
    background-color: #751a3d;
    background-color: rgba(117, 26, 61, var(--bg-opacity));
  }
  .sm\\:focus\\:bg-cool-gray-50:focus {
    --bg-opacity: 1;
    background-color: #f8fafc;
    background-color: rgba(248, 250, 252, var(--bg-opacity));
  }
  .sm\\:focus\\:bg-cool-gray-100:focus {
    --bg-opacity: 1;
    background-color: #f1f5f9;
    background-color: rgba(241, 245, 249, var(--bg-opacity));
  }
  .sm\\:focus\\:bg-cool-gray-200:focus {
    --bg-opacity: 1;
    background-color: #e2e8f0;
    background-color: rgba(226, 232, 240, var(--bg-opacity));
  }
  .sm\\:focus\\:bg-cool-gray-300:focus {
    --bg-opacity: 1;
    background-color: #cfd8e3;
    background-color: rgba(207, 216, 227, var(--bg-opacity));
  }
  .sm\\:focus\\:bg-cool-gray-400:focus {
    --bg-opacity: 1;
    background-color: #97a6ba;
    background-color: rgba(151, 166, 186, var(--bg-opacity));
  }
  .sm\\:focus\\:bg-cool-gray-500:focus {
    --bg-opacity: 1;
    background-color: #64748b;
    background-color: rgba(100, 116, 139, var(--bg-opacity));
  }
  .sm\\:focus\\:bg-cool-gray-600:focus {
    --bg-opacity: 1;
    background-color: #475569;
    background-color: rgba(71, 85, 105, var(--bg-opacity));
  }
  .sm\\:focus\\:bg-cool-gray-700:focus {
    --bg-opacity: 1;
    background-color: #364152;
    background-color: rgba(54, 65, 82, var(--bg-opacity));
  }
  .sm\\:focus\\:bg-cool-gray-800:focus {
    --bg-opacity: 1;
    background-color: #27303f;
    background-color: rgba(39, 48, 63, var(--bg-opacity));
  }
  .sm\\:focus\\:bg-cool-gray-900:focus {
    --bg-opacity: 1;
    background-color: #1a202e;
    background-color: rgba(26, 32, 46, var(--bg-opacity));
  }
  .sm\\:active\\:bg-current:active {
    background-color: currentColor;
  }
  .sm\\:active\\:bg-transparent:active {
    background-color: transparent;
  }
  .sm\\:active\\:bg-white:active {
    --bg-opacity: 1;
    background-color: #ffffff;
    background-color: rgba(255, 255, 255, var(--bg-opacity));
  }
  .sm\\:active\\:bg-black:active {
    --bg-opacity: 1;
    background-color: #000000;
    background-color: rgba(0, 0, 0, var(--bg-opacity));
  }
  .sm\\:active\\:bg-gray-50:active {
    --bg-opacity: 1;
    background-color: #f9fafb;
    background-color: rgba(249, 250, 251, var(--bg-opacity));
  }
  .sm\\:active\\:bg-gray-100:active {
    --bg-opacity: 1;
    background-color: #f4f5f7;
    background-color: rgba(244, 245, 247, var(--bg-opacity));
  }
  .sm\\:active\\:bg-gray-200:active {
    --bg-opacity: 1;
    background-color: #e5e7eb;
    background-color: rgba(229, 231, 235, var(--bg-opacity));
  }
  .sm\\:active\\:bg-gray-300:active {
    --bg-opacity: 1;
    background-color: #d2d6dc;
    background-color: rgba(210, 214, 220, var(--bg-opacity));
  }
  .sm\\:active\\:bg-gray-400:active {
    --bg-opacity: 1;
    background-color: #9fa6b2;
    background-color: rgba(159, 166, 178, var(--bg-opacity));
  }
  .sm\\:active\\:bg-gray-500:active {
    --bg-opacity: 1;
    background-color: #6b7280;
    background-color: rgba(107, 114, 128, var(--bg-opacity));
  }
  .sm\\:active\\:bg-gray-600:active {
    --bg-opacity: 1;
    background-color: #4b5563;
    background-color: rgba(75, 85, 99, var(--bg-opacity));
  }
  .sm\\:active\\:bg-gray-700:active {
    --bg-opacity: 1;
    background-color: #374151;
    background-color: rgba(55, 65, 81, var(--bg-opacity));
  }
  .sm\\:active\\:bg-gray-800:active {
    --bg-opacity: 1;
    background-color: #252f3f;
    background-color: rgba(37, 47, 63, var(--bg-opacity));
  }
  .sm\\:active\\:bg-gray-900:active {
    --bg-opacity: 1;
    background-color: #161e2e;
    background-color: rgba(22, 30, 46, var(--bg-opacity));
  }
  .sm\\:active\\:bg-red-50:active {
    --bg-opacity: 1;
    background-color: #fdf2f2;
    background-color: rgba(253, 242, 242, var(--bg-opacity));
  }
  .sm\\:active\\:bg-red-100:active {
    --bg-opacity: 1;
    background-color: #fde8e8;
    background-color: rgba(253, 232, 232, var(--bg-opacity));
  }
  .sm\\:active\\:bg-red-200:active {
    --bg-opacity: 1;
    background-color: #fbd5d5;
    background-color: rgba(251, 213, 213, var(--bg-opacity));
  }
  .sm\\:active\\:bg-red-300:active {
    --bg-opacity: 1;
    background-color: #f8b4b4;
    background-color: rgba(248, 180, 180, var(--bg-opacity));
  }
  .sm\\:active\\:bg-red-400:active {
    --bg-opacity: 1;
    background-color: #f98080;
    background-color: rgba(249, 128, 128, var(--bg-opacity));
  }
  .sm\\:active\\:bg-red-500:active {
    --bg-opacity: 1;
    background-color: #f05252;
    background-color: rgba(240, 82, 82, var(--bg-opacity));
  }
  .sm\\:active\\:bg-red-600:active {
    --bg-opacity: 1;
    background-color: #e02424;
    background-color: rgba(224, 36, 36, var(--bg-opacity));
  }
  .sm\\:active\\:bg-red-700:active {
    --bg-opacity: 1;
    background-color: #c81e1e;
    background-color: rgba(200, 30, 30, var(--bg-opacity));
  }
  .sm\\:active\\:bg-red-800:active {
    --bg-opacity: 1;
    background-color: #9b1c1c;
    background-color: rgba(155, 28, 28, var(--bg-opacity));
  }
  .sm\\:active\\:bg-red-900:active {
    --bg-opacity: 1;
    background-color: #771d1d;
    background-color: rgba(119, 29, 29, var(--bg-opacity));
  }
  .sm\\:active\\:bg-orange-50:active {
    --bg-opacity: 1;
    background-color: #fff8f1;
    background-color: rgba(255, 248, 241, var(--bg-opacity));
  }
  .sm\\:active\\:bg-orange-100:active {
    --bg-opacity: 1;
    background-color: #feecdc;
    background-color: rgba(254, 236, 220, var(--bg-opacity));
  }
  .sm\\:active\\:bg-orange-200:active {
    --bg-opacity: 1;
    background-color: #fcd9bd;
    background-color: rgba(252, 217, 189, var(--bg-opacity));
  }
  .sm\\:active\\:bg-orange-300:active {
    --bg-opacity: 1;
    background-color: #fdba8c;
    background-color: rgba(253, 186, 140, var(--bg-opacity));
  }
  .sm\\:active\\:bg-orange-400:active {
    --bg-opacity: 1;
    background-color: #ff8a4c;
    background-color: rgba(255, 138, 76, var(--bg-opacity));
  }
  .sm\\:active\\:bg-orange-500:active {
    --bg-opacity: 1;
    background-color: #ff5a1f;
    background-color: rgba(255, 90, 31, var(--bg-opacity));
  }
  .sm\\:active\\:bg-orange-600:active {
    --bg-opacity: 1;
    background-color: #d03801;
    background-color: rgba(208, 56, 1, var(--bg-opacity));
  }
  .sm\\:active\\:bg-orange-700:active {
    --bg-opacity: 1;
    background-color: #b43403;
    background-color: rgba(180, 52, 3, var(--bg-opacity));
  }
  .sm\\:active\\:bg-orange-800:active {
    --bg-opacity: 1;
    background-color: #8a2c0d;
    background-color: rgba(138, 44, 13, var(--bg-opacity));
  }
  .sm\\:active\\:bg-orange-900:active {
    --bg-opacity: 1;
    background-color: #73230d;
    background-color: rgba(115, 35, 13, var(--bg-opacity));
  }
  .sm\\:active\\:bg-yellow-50:active {
    --bg-opacity: 1;
    background-color: #fdfdea;
    background-color: rgba(253, 253, 234, var(--bg-opacity));
  }
  .sm\\:active\\:bg-yellow-100:active {
    --bg-opacity: 1;
    background-color: #fdf6b2;
    background-color: rgba(253, 246, 178, var(--bg-opacity));
  }
  .sm\\:active\\:bg-yellow-200:active {
    --bg-opacity: 1;
    background-color: #fce96a;
    background-color: rgba(252, 233, 106, var(--bg-opacity));
  }
  .sm\\:active\\:bg-yellow-300:active {
    --bg-opacity: 1;
    background-color: #faca15;
    background-color: rgba(250, 202, 21, var(--bg-opacity));
  }
  .sm\\:active\\:bg-yellow-400:active {
    --bg-opacity: 1;
    background-color: #e3a008;
    background-color: rgba(227, 160, 8, var(--bg-opacity));
  }
  .sm\\:active\\:bg-yellow-500:active {
    --bg-opacity: 1;
    background-color: #c27803;
    background-color: rgba(194, 120, 3, var(--bg-opacity));
  }
  .sm\\:active\\:bg-yellow-600:active {
    --bg-opacity: 1;
    background-color: #9f580a;
    background-color: rgba(159, 88, 10, var(--bg-opacity));
  }
  .sm\\:active\\:bg-yellow-700:active {
    --bg-opacity: 1;
    background-color: #8e4b10;
    background-color: rgba(142, 75, 16, var(--bg-opacity));
  }
  .sm\\:active\\:bg-yellow-800:active {
    --bg-opacity: 1;
    background-color: #723b13;
    background-color: rgba(114, 59, 19, var(--bg-opacity));
  }
  .sm\\:active\\:bg-yellow-900:active {
    --bg-opacity: 1;
    background-color: #633112;
    background-color: rgba(99, 49, 18, var(--bg-opacity));
  }
  .sm\\:active\\:bg-green-50:active {
    --bg-opacity: 1;
    background-color: #f3faf7;
    background-color: rgba(243, 250, 247, var(--bg-opacity));
  }
  .sm\\:active\\:bg-green-100:active {
    --bg-opacity: 1;
    background-color: #def7ec;
    background-color: rgba(222, 247, 236, var(--bg-opacity));
  }
  .sm\\:active\\:bg-green-200:active {
    --bg-opacity: 1;
    background-color: #bcf0da;
    background-color: rgba(188, 240, 218, var(--bg-opacity));
  }
  .sm\\:active\\:bg-green-300:active {
    --bg-opacity: 1;
    background-color: #84e1bc;
    background-color: rgba(132, 225, 188, var(--bg-opacity));
  }
  .sm\\:active\\:bg-green-400:active {
    --bg-opacity: 1;
    background-color: #31c48d;
    background-color: rgba(49, 196, 141, var(--bg-opacity));
  }
  .sm\\:active\\:bg-green-500:active {
    --bg-opacity: 1;
    background-color: #0e9f6e;
    background-color: rgba(14, 159, 110, var(--bg-opacity));
  }
  .sm\\:active\\:bg-green-600:active {
    --bg-opacity: 1;
    background-color: #057a55;
    background-color: rgba(5, 122, 85, var(--bg-opacity));
  }
  .sm\\:active\\:bg-green-700:active {
    --bg-opacity: 1;
    background-color: #046c4e;
    background-color: rgba(4, 108, 78, var(--bg-opacity));
  }
  .sm\\:active\\:bg-green-800:active {
    --bg-opacity: 1;
    background-color: #03543f;
    background-color: rgba(3, 84, 63, var(--bg-opacity));
  }
  .sm\\:active\\:bg-green-900:active {
    --bg-opacity: 1;
    background-color: #014737;
    background-color: rgba(1, 71, 55, var(--bg-opacity));
  }
  .sm\\:active\\:bg-teal-50:active {
    --bg-opacity: 1;
    background-color: #edfafa;
    background-color: rgba(237, 250, 250, var(--bg-opacity));
  }
  .sm\\:active\\:bg-teal-100:active {
    --bg-opacity: 1;
    background-color: #d5f5f6;
    background-color: rgba(213, 245, 246, var(--bg-opacity));
  }
  .sm\\:active\\:bg-teal-200:active {
    --bg-opacity: 1;
    background-color: #afecef;
    background-color: rgba(175, 236, 239, var(--bg-opacity));
  }
  .sm\\:active\\:bg-teal-300:active {
    --bg-opacity: 1;
    background-color: #7edce2;
    background-color: rgba(126, 220, 226, var(--bg-opacity));
  }
  .sm\\:active\\:bg-teal-400:active {
    --bg-opacity: 1;
    background-color: #16bdca;
    background-color: rgba(22, 189, 202, var(--bg-opacity));
  }
  .sm\\:active\\:bg-teal-500:active {
    --bg-opacity: 1;
    background-color: #0694a2;
    background-color: rgba(6, 148, 162, var(--bg-opacity));
  }
  .sm\\:active\\:bg-teal-600:active {
    --bg-opacity: 1;
    background-color: #047481;
    background-color: rgba(4, 116, 129, var(--bg-opacity));
  }
  .sm\\:active\\:bg-teal-700:active {
    --bg-opacity: 1;
    background-color: #036672;
    background-color: rgba(3, 102, 114, var(--bg-opacity));
  }
  .sm\\:active\\:bg-teal-800:active {
    --bg-opacity: 1;
    background-color: #05505c;
    background-color: rgba(5, 80, 92, var(--bg-opacity));
  }
  .sm\\:active\\:bg-teal-900:active {
    --bg-opacity: 1;
    background-color: #014451;
    background-color: rgba(1, 68, 81, var(--bg-opacity));
  }
  .sm\\:active\\:bg-blue-50:active {
    --bg-opacity: 1;
    background-color: #ebf5ff;
    background-color: rgba(235, 245, 255, var(--bg-opacity));
  }
  .sm\\:active\\:bg-blue-100:active {
    --bg-opacity: 1;
    background-color: #e1effe;
    background-color: rgba(225, 239, 254, var(--bg-opacity));
  }
  .sm\\:active\\:bg-blue-200:active {
    --bg-opacity: 1;
    background-color: #c3ddfd;
    background-color: rgba(195, 221, 253, var(--bg-opacity));
  }
  .sm\\:active\\:bg-blue-300:active {
    --bg-opacity: 1;
    background-color: #a4cafe;
    background-color: rgba(164, 202, 254, var(--bg-opacity));
  }
  .sm\\:active\\:bg-blue-400:active {
    --bg-opacity: 1;
    background-color: #76a9fa;
    background-color: rgba(118, 169, 250, var(--bg-opacity));
  }
  .sm\\:active\\:bg-blue-500:active {
    --bg-opacity: 1;
    background-color: #3f83f8;
    background-color: rgba(63, 131, 248, var(--bg-opacity));
  }
  .sm\\:active\\:bg-blue-600:active {
    --bg-opacity: 1;
    background-color: #1c64f2;
    background-color: rgba(28, 100, 242, var(--bg-opacity));
  }
  .sm\\:active\\:bg-blue-700:active {
    --bg-opacity: 1;
    background-color: #1a56db;
    background-color: rgba(26, 86, 219, var(--bg-opacity));
  }
  .sm\\:active\\:bg-blue-800:active {
    --bg-opacity: 1;
    background-color: #1e429f;
    background-color: rgba(30, 66, 159, var(--bg-opacity));
  }
  .sm\\:active\\:bg-blue-900:active {
    --bg-opacity: 1;
    background-color: #233876;
    background-color: rgba(35, 56, 118, var(--bg-opacity));
  }
  .sm\\:active\\:bg-indigo-50:active {
    --bg-opacity: 1;
    background-color: #f0f5ff;
    background-color: rgba(240, 245, 255, var(--bg-opacity));
  }
  .sm\\:active\\:bg-indigo-100:active {
    --bg-opacity: 1;
    background-color: #e5edff;
    background-color: rgba(229, 237, 255, var(--bg-opacity));
  }
  .sm\\:active\\:bg-indigo-200:active {
    --bg-opacity: 1;
    background-color: #cddbfe;
    background-color: rgba(205, 219, 254, var(--bg-opacity));
  }
  .sm\\:active\\:bg-indigo-300:active {
    --bg-opacity: 1;
    background-color: #b4c6fc;
    background-color: rgba(180, 198, 252, var(--bg-opacity));
  }
  .sm\\:active\\:bg-indigo-400:active {
    --bg-opacity: 1;
    background-color: #8da2fb;
    background-color: rgba(141, 162, 251, var(--bg-opacity));
  }
  .sm\\:active\\:bg-indigo-500:active {
    --bg-opacity: 1;
    background-color: #6875f5;
    background-color: rgba(104, 117, 245, var(--bg-opacity));
  }
  .sm\\:active\\:bg-indigo-600:active {
    --bg-opacity: 1;
    background-color: #5850ec;
    background-color: rgba(88, 80, 236, var(--bg-opacity));
  }
  .sm\\:active\\:bg-indigo-700:active {
    --bg-opacity: 1;
    background-color: #5145cd;
    background-color: rgba(81, 69, 205, var(--bg-opacity));
  }
  .sm\\:active\\:bg-indigo-800:active {
    --bg-opacity: 1;
    background-color: #42389d;
    background-color: rgba(66, 56, 157, var(--bg-opacity));
  }
  .sm\\:active\\:bg-indigo-900:active {
    --bg-opacity: 1;
    background-color: #362f78;
    background-color: rgba(54, 47, 120, var(--bg-opacity));
  }
  .sm\\:active\\:bg-purple-50:active {
    --bg-opacity: 1;
    background-color: #f6f5ff;
    background-color: rgba(246, 245, 255, var(--bg-opacity));
  }
  .sm\\:active\\:bg-purple-100:active {
    --bg-opacity: 1;
    background-color: #edebfe;
    background-color: rgba(237, 235, 254, var(--bg-opacity));
  }
  .sm\\:active\\:bg-purple-200:active {
    --bg-opacity: 1;
    background-color: #dcd7fe;
    background-color: rgba(220, 215, 254, var(--bg-opacity));
  }
  .sm\\:active\\:bg-purple-300:active {
    --bg-opacity: 1;
    background-color: #cabffd;
    background-color: rgba(202, 191, 253, var(--bg-opacity));
  }
  .sm\\:active\\:bg-purple-400:active {
    --bg-opacity: 1;
    background-color: #ac94fa;
    background-color: rgba(172, 148, 250, var(--bg-opacity));
  }
  .sm\\:active\\:bg-purple-500:active {
    --bg-opacity: 1;
    background-color: #9061f9;
    background-color: rgba(144, 97, 249, var(--bg-opacity));
  }
  .sm\\:active\\:bg-purple-600:active {
    --bg-opacity: 1;
    background-color: #7e3af2;
    background-color: rgba(126, 58, 242, var(--bg-opacity));
  }
  .sm\\:active\\:bg-purple-700:active {
    --bg-opacity: 1;
    background-color: #6c2bd9;
    background-color: rgba(108, 43, 217, var(--bg-opacity));
  }
  .sm\\:active\\:bg-purple-800:active {
    --bg-opacity: 1;
    background-color: #5521b5;
    background-color: rgba(85, 33, 181, var(--bg-opacity));
  }
  .sm\\:active\\:bg-purple-900:active {
    --bg-opacity: 1;
    background-color: #4a1d96;
    background-color: rgba(74, 29, 150, var(--bg-opacity));
  }
  .sm\\:active\\:bg-pink-50:active {
    --bg-opacity: 1;
    background-color: #fdf2f8;
    background-color: rgba(253, 242, 248, var(--bg-opacity));
  }
  .sm\\:active\\:bg-pink-100:active {
    --bg-opacity: 1;
    background-color: #fce8f3;
    background-color: rgba(252, 232, 243, var(--bg-opacity));
  }
  .sm\\:active\\:bg-pink-200:active {
    --bg-opacity: 1;
    background-color: #fad1e8;
    background-color: rgba(250, 209, 232, var(--bg-opacity));
  }
  .sm\\:active\\:bg-pink-300:active {
    --bg-opacity: 1;
    background-color: #f8b4d9;
    background-color: rgba(248, 180, 217, var(--bg-opacity));
  }
  .sm\\:active\\:bg-pink-400:active {
    --bg-opacity: 1;
    background-color: #f17eb8;
    background-color: rgba(241, 126, 184, var(--bg-opacity));
  }
  .sm\\:active\\:bg-pink-500:active {
    --bg-opacity: 1;
    background-color: #e74694;
    background-color: rgba(231, 70, 148, var(--bg-opacity));
  }
  .sm\\:active\\:bg-pink-600:active {
    --bg-opacity: 1;
    background-color: #d61f69;
    background-color: rgba(214, 31, 105, var(--bg-opacity));
  }
  .sm\\:active\\:bg-pink-700:active {
    --bg-opacity: 1;
    background-color: #bf125d;
    background-color: rgba(191, 18, 93, var(--bg-opacity));
  }
  .sm\\:active\\:bg-pink-800:active {
    --bg-opacity: 1;
    background-color: #99154b;
    background-color: rgba(153, 21, 75, var(--bg-opacity));
  }
  .sm\\:active\\:bg-pink-900:active {
    --bg-opacity: 1;
    background-color: #751a3d;
    background-color: rgba(117, 26, 61, var(--bg-opacity));
  }
  .sm\\:active\\:bg-cool-gray-50:active {
    --bg-opacity: 1;
    background-color: #f8fafc;
    background-color: rgba(248, 250, 252, var(--bg-opacity));
  }
  .sm\\:active\\:bg-cool-gray-100:active {
    --bg-opacity: 1;
    background-color: #f1f5f9;
    background-color: rgba(241, 245, 249, var(--bg-opacity));
  }
  .sm\\:active\\:bg-cool-gray-200:active {
    --bg-opacity: 1;
    background-color: #e2e8f0;
    background-color: rgba(226, 232, 240, var(--bg-opacity));
  }
  .sm\\:active\\:bg-cool-gray-300:active {
    --bg-opacity: 1;
    background-color: #cfd8e3;
    background-color: rgba(207, 216, 227, var(--bg-opacity));
  }
  .sm\\:active\\:bg-cool-gray-400:active {
    --bg-opacity: 1;
    background-color: #97a6ba;
    background-color: rgba(151, 166, 186, var(--bg-opacity));
  }
  .sm\\:active\\:bg-cool-gray-500:active {
    --bg-opacity: 1;
    background-color: #64748b;
    background-color: rgba(100, 116, 139, var(--bg-opacity));
  }
  .sm\\:active\\:bg-cool-gray-600:active {
    --bg-opacity: 1;
    background-color: #475569;
    background-color: rgba(71, 85, 105, var(--bg-opacity));
  }
  .sm\\:active\\:bg-cool-gray-700:active {
    --bg-opacity: 1;
    background-color: #364152;
    background-color: rgba(54, 65, 82, var(--bg-opacity));
  }
  .sm\\:active\\:bg-cool-gray-800:active {
    --bg-opacity: 1;
    background-color: #27303f;
    background-color: rgba(39, 48, 63, var(--bg-opacity));
  }
  .sm\\:active\\:bg-cool-gray-900:active {
    --bg-opacity: 1;
    background-color: #1a202e;
    background-color: rgba(26, 32, 46, var(--bg-opacity));
  }
  .sm\\:bg-none {
    background-image: none;
  }
  .sm\\:bg-gradient-to-t {
    background-image: linear-gradient(to top, var(--gradient-color-stops));
  }
  .sm\\:bg-gradient-to-tr {
    background-image: linear-gradient(to top right, var(--gradient-color-stops));
  }
  .sm\\:bg-gradient-to-r {
    background-image: linear-gradient(to right, var(--gradient-color-stops));
  }
  .sm\\:bg-gradient-to-br {
    background-image: linear-gradient(to bottom right, var(--gradient-color-stops));
  }
  .sm\\:bg-gradient-to-b {
    background-image: linear-gradient(to bottom, var(--gradient-color-stops));
  }
  .sm\\:bg-gradient-to-bl {
    background-image: linear-gradient(to bottom left, var(--gradient-color-stops));
  }
  .sm\\:bg-gradient-to-l {
    background-image: linear-gradient(to left, var(--gradient-color-stops));
  }
  .sm\\:bg-gradient-to-tl {
    background-image: linear-gradient(to top left, var(--gradient-color-stops));
  }
  .sm\\:from-current {
    --gradient-from-color: currentColor;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }
  .sm\\:from-transparent {
    --gradient-from-color: transparent;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  }
  .sm\\:from-white {
    --gradient-from-color: #ffffff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }
  .sm\\:from-black {
    --gradient-from-color: #000000;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  }
  .sm\\:from-gray-50 {
    --gradient-from-color: #f9fafb;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(249, 250, 251, 0));
  }
  .sm\\:from-gray-100 {
    --gradient-from-color: #f4f5f7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(244, 245, 247, 0));
  }
  .sm\\:from-gray-200 {
    --gradient-from-color: #e5e7eb;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(229, 231, 235, 0));
  }
  .sm\\:from-gray-300 {
    --gradient-from-color: #d2d6dc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(210, 214, 220, 0));
  }
  .sm\\:from-gray-400 {
    --gradient-from-color: #9fa6b2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(159, 166, 178, 0));
  }
  .sm\\:from-gray-500 {
    --gradient-from-color: #6b7280;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(107, 114, 128, 0));
  }
  .sm\\:from-gray-600 {
    --gradient-from-color: #4b5563;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(75, 85, 99, 0));
  }
  .sm\\:from-gray-700 {
    --gradient-from-color: #374151;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(55, 65, 81, 0));
  }
  .sm\\:from-gray-800 {
    --gradient-from-color: #252f3f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(37, 47, 63, 0));
  }
  .sm\\:from-gray-900 {
    --gradient-from-color: #161e2e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(22, 30, 46, 0));
  }
  .sm\\:from-red-50 {
    --gradient-from-color: #fdf2f2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 242, 242, 0));
  }
  .sm\\:from-red-100 {
    --gradient-from-color: #fde8e8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 232, 232, 0));
  }
  .sm\\:from-red-200 {
    --gradient-from-color: #fbd5d5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(251, 213, 213, 0));
  }
  .sm\\:from-red-300 {
    --gradient-from-color: #f8b4b4;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(248, 180, 180, 0));
  }
  .sm\\:from-red-400 {
    --gradient-from-color: #f98080;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(249, 128, 128, 0));
  }
  .sm\\:from-red-500 {
    --gradient-from-color: #f05252;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(240, 82, 82, 0));
  }
  .sm\\:from-red-600 {
    --gradient-from-color: #e02424;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(224, 36, 36, 0));
  }
  .sm\\:from-red-700 {
    --gradient-from-color: #c81e1e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(200, 30, 30, 0));
  }
  .sm\\:from-red-800 {
    --gradient-from-color: #9b1c1c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(155, 28, 28, 0));
  }
  .sm\\:from-red-900 {
    --gradient-from-color: #771d1d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(119, 29, 29, 0));
  }
  .sm\\:from-orange-50 {
    --gradient-from-color: #fff8f1;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 248, 241, 0));
  }
  .sm\\:from-orange-100 {
    --gradient-from-color: #feecdc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 236, 220, 0));
  }
  .sm\\:from-orange-200 {
    --gradient-from-color: #fcd9bd;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(252, 217, 189, 0));
  }
  .sm\\:from-orange-300 {
    --gradient-from-color: #fdba8c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 186, 140, 0));
  }
  .sm\\:from-orange-400 {
    --gradient-from-color: #ff8a4c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 138, 76, 0));
  }
  .sm\\:from-orange-500 {
    --gradient-from-color: #ff5a1f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 90, 31, 0));
  }
  .sm\\:from-orange-600 {
    --gradient-from-color: #d03801;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(208, 56, 1, 0));
  }
  .sm\\:from-orange-700 {
    --gradient-from-color: #b43403;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(180, 52, 3, 0));
  }
  .sm\\:from-orange-800 {
    --gradient-from-color: #8a2c0d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(138, 44, 13, 0));
  }
  .sm\\:from-orange-900 {
    --gradient-from-color: #73230d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(115, 35, 13, 0));
  }
  .sm\\:from-yellow-50 {
    --gradient-from-color: #fdfdea;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 253, 234, 0));
  }
  .sm\\:from-yellow-100 {
    --gradient-from-color: #fdf6b2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 246, 178, 0));
  }
  .sm\\:from-yellow-200 {
    --gradient-from-color: #fce96a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(252, 233, 106, 0));
  }
  .sm\\:from-yellow-300 {
    --gradient-from-color: #faca15;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(250, 202, 21, 0));
  }
  .sm\\:from-yellow-400 {
    --gradient-from-color: #e3a008;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(227, 160, 8, 0));
  }
  .sm\\:from-yellow-500 {
    --gradient-from-color: #c27803;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(194, 120, 3, 0));
  }
  .sm\\:from-yellow-600 {
    --gradient-from-color: #9f580a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(159, 88, 10, 0));
  }
  .sm\\:from-yellow-700 {
    --gradient-from-color: #8e4b10;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(142, 75, 16, 0));
  }
  .sm\\:from-yellow-800 {
    --gradient-from-color: #723b13;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(114, 59, 19, 0));
  }
  .sm\\:from-yellow-900 {
    --gradient-from-color: #633112;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(99, 49, 18, 0));
  }
  .sm\\:from-green-50 {
    --gradient-from-color: #f3faf7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(243, 250, 247, 0));
  }
  .sm\\:from-green-100 {
    --gradient-from-color: #def7ec;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(222, 247, 236, 0));
  }
  .sm\\:from-green-200 {
    --gradient-from-color: #bcf0da;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(188, 240, 218, 0));
  }
  .sm\\:from-green-300 {
    --gradient-from-color: #84e1bc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(132, 225, 188, 0));
  }
  .sm\\:from-green-400 {
    --gradient-from-color: #31c48d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(49, 196, 141, 0));
  }
  .sm\\:from-green-500 {
    --gradient-from-color: #0e9f6e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(14, 159, 110, 0));
  }
  .sm\\:from-green-600 {
    --gradient-from-color: #057a55;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(5, 122, 85, 0));
  }
  .sm\\:from-green-700 {
    --gradient-from-color: #046c4e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(4, 108, 78, 0));
  }
  .sm\\:from-green-800 {
    --gradient-from-color: #03543f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(3, 84, 63, 0));
  }
  .sm\\:from-green-900 {
    --gradient-from-color: #014737;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(1, 71, 55, 0));
  }
  .sm\\:from-teal-50 {
    --gradient-from-color: #edfafa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(237, 250, 250, 0));
  }
  .sm\\:from-teal-100 {
    --gradient-from-color: #d5f5f6;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(213, 245, 246, 0));
  }
  .sm\\:from-teal-200 {
    --gradient-from-color: #afecef;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(175, 236, 239, 0));
  }
  .sm\\:from-teal-300 {
    --gradient-from-color: #7edce2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(126, 220, 226, 0));
  }
  .sm\\:from-teal-400 {
    --gradient-from-color: #16bdca;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(22, 189, 202, 0));
  }
  .sm\\:from-teal-500 {
    --gradient-from-color: #0694a2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(6, 148, 162, 0));
  }
  .sm\\:from-teal-600 {
    --gradient-from-color: #047481;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(4, 116, 129, 0));
  }
  .sm\\:from-teal-700 {
    --gradient-from-color: #036672;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(3, 102, 114, 0));
  }
  .sm\\:from-teal-800 {
    --gradient-from-color: #05505c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(5, 80, 92, 0));
  }
  .sm\\:from-teal-900 {
    --gradient-from-color: #014451;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(1, 68, 81, 0));
  }
  .sm\\:from-blue-50 {
    --gradient-from-color: #ebf5ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(235, 245, 255, 0));
  }
  .sm\\:from-blue-100 {
    --gradient-from-color: #e1effe;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(225, 239, 254, 0));
  }
  .sm\\:from-blue-200 {
    --gradient-from-color: #c3ddfd;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(195, 221, 253, 0));
  }
  .sm\\:from-blue-300 {
    --gradient-from-color: #a4cafe;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(164, 202, 254, 0));
  }
  .sm\\:from-blue-400 {
    --gradient-from-color: #76a9fa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(118, 169, 250, 0));
  }
  .sm\\:from-blue-500 {
    --gradient-from-color: #3f83f8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(63, 131, 248, 0));
  }
  .sm\\:from-blue-600 {
    --gradient-from-color: #1c64f2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(28, 100, 242, 0));
  }
  .sm\\:from-blue-700 {
    --gradient-from-color: #1a56db;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(26, 86, 219, 0));
  }
  .sm\\:from-blue-800 {
    --gradient-from-color: #1e429f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(30, 66, 159, 0));
  }
  .sm\\:from-blue-900 {
    --gradient-from-color: #233876;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(35, 56, 118, 0));
  }
  .sm\\:from-indigo-50 {
    --gradient-from-color: #f0f5ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(240, 245, 255, 0));
  }
  .sm\\:from-indigo-100 {
    --gradient-from-color: #e5edff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(229, 237, 255, 0));
  }
  .sm\\:from-indigo-200 {
    --gradient-from-color: #cddbfe;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(205, 219, 254, 0));
  }
  .sm\\:from-indigo-300 {
    --gradient-from-color: #b4c6fc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(180, 198, 252, 0));
  }
  .sm\\:from-indigo-400 {
    --gradient-from-color: #8da2fb;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(141, 162, 251, 0));
  }
  .sm\\:from-indigo-500 {
    --gradient-from-color: #6875f5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(104, 117, 245, 0));
  }
  .sm\\:from-indigo-600 {
    --gradient-from-color: #5850ec;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(88, 80, 236, 0));
  }
  .sm\\:from-indigo-700 {
    --gradient-from-color: #5145cd;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(81, 69, 205, 0));
  }
  .sm\\:from-indigo-800 {
    --gradient-from-color: #42389d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(66, 56, 157, 0));
  }
  .sm\\:from-indigo-900 {
    --gradient-from-color: #362f78;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(54, 47, 120, 0));
  }
  .sm\\:from-purple-50 {
    --gradient-from-color: #f6f5ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(246, 245, 255, 0));
  }
  .sm\\:from-purple-100 {
    --gradient-from-color: #edebfe;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(237, 235, 254, 0));
  }
  .sm\\:from-purple-200 {
    --gradient-from-color: #dcd7fe;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(220, 215, 254, 0));
  }
  .sm\\:from-purple-300 {
    --gradient-from-color: #cabffd;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(202, 191, 253, 0));
  }
  .sm\\:from-purple-400 {
    --gradient-from-color: #ac94fa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(172, 148, 250, 0));
  }
  .sm\\:from-purple-500 {
    --gradient-from-color: #9061f9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(144, 97, 249, 0));
  }
  .sm\\:from-purple-600 {
    --gradient-from-color: #7e3af2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(126, 58, 242, 0));
  }
  .sm\\:from-purple-700 {
    --gradient-from-color: #6c2bd9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(108, 43, 217, 0));
  }
  .sm\\:from-purple-800 {
    --gradient-from-color: #5521b5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(85, 33, 181, 0));
  }
  .sm\\:from-purple-900 {
    --gradient-from-color: #4a1d96;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(74, 29, 150, 0));
  }
  .sm\\:from-pink-50 {
    --gradient-from-color: #fdf2f8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 242, 248, 0));
  }
  .sm\\:from-pink-100 {
    --gradient-from-color: #fce8f3;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(252, 232, 243, 0));
  }
  .sm\\:from-pink-200 {
    --gradient-from-color: #fad1e8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(250, 209, 232, 0));
  }
  .sm\\:from-pink-300 {
    --gradient-from-color: #f8b4d9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(248, 180, 217, 0));
  }
  .sm\\:from-pink-400 {
    --gradient-from-color: #f17eb8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(241, 126, 184, 0));
  }
  .sm\\:from-pink-500 {
    --gradient-from-color: #e74694;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(231, 70, 148, 0));
  }
  .sm\\:from-pink-600 {
    --gradient-from-color: #d61f69;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(214, 31, 105, 0));
  }
  .sm\\:from-pink-700 {
    --gradient-from-color: #bf125d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(191, 18, 93, 0));
  }
  .sm\\:from-pink-800 {
    --gradient-from-color: #99154b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(153, 21, 75, 0));
  }
  .sm\\:from-pink-900 {
    --gradient-from-color: #751a3d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(117, 26, 61, 0));
  }
  .sm\\:from-cool-gray-50 {
    --gradient-from-color: #f8fafc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(248, 250, 252, 0));
  }
  .sm\\:from-cool-gray-100 {
    --gradient-from-color: #f1f5f9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(241, 245, 249, 0));
  }
  .sm\\:from-cool-gray-200 {
    --gradient-from-color: #e2e8f0;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(226, 232, 240, 0));
  }
  .sm\\:from-cool-gray-300 {
    --gradient-from-color: #cfd8e3;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(207, 216, 227, 0));
  }
  .sm\\:from-cool-gray-400 {
    --gradient-from-color: #97a6ba;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(151, 166, 186, 0));
  }
  .sm\\:from-cool-gray-500 {
    --gradient-from-color: #64748b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(100, 116, 139, 0));
  }
  .sm\\:from-cool-gray-600 {
    --gradient-from-color: #475569;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(71, 85, 105, 0));
  }
  .sm\\:from-cool-gray-700 {
    --gradient-from-color: #364152;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(54, 65, 82, 0));
  }
  .sm\\:from-cool-gray-800 {
    --gradient-from-color: #27303f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(39, 48, 63, 0));
  }
  .sm\\:from-cool-gray-900 {
    --gradient-from-color: #1a202e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(26, 32, 46, 0));
  }
  .sm\\:via-current {
    --gradient-via-color: currentColor;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }
  .sm\\:via-transparent {
    --gradient-via-color: transparent;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  }
  .sm\\:via-white {
    --gradient-via-color: #ffffff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }
  .sm\\:via-black {
    --gradient-via-color: #000000;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  }
  .sm\\:via-gray-50 {
    --gradient-via-color: #f9fafb;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(249, 250, 251, 0));
  }
  .sm\\:via-gray-100 {
    --gradient-via-color: #f4f5f7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(244, 245, 247, 0));
  }
  .sm\\:via-gray-200 {
    --gradient-via-color: #e5e7eb;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(229, 231, 235, 0));
  }
  .sm\\:via-gray-300 {
    --gradient-via-color: #d2d6dc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(210, 214, 220, 0));
  }
  .sm\\:via-gray-400 {
    --gradient-via-color: #9fa6b2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(159, 166, 178, 0));
  }
  .sm\\:via-gray-500 {
    --gradient-via-color: #6b7280;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(107, 114, 128, 0));
  }
  .sm\\:via-gray-600 {
    --gradient-via-color: #4b5563;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(75, 85, 99, 0));
  }
  .sm\\:via-gray-700 {
    --gradient-via-color: #374151;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(55, 65, 81, 0));
  }
  .sm\\:via-gray-800 {
    --gradient-via-color: #252f3f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(37, 47, 63, 0));
  }
  .sm\\:via-gray-900 {
    --gradient-via-color: #161e2e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(22, 30, 46, 0));
  }
  .sm\\:via-red-50 {
    --gradient-via-color: #fdf2f2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 242, 242, 0));
  }
  .sm\\:via-red-100 {
    --gradient-via-color: #fde8e8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 232, 232, 0));
  }
  .sm\\:via-red-200 {
    --gradient-via-color: #fbd5d5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(251, 213, 213, 0));
  }
  .sm\\:via-red-300 {
    --gradient-via-color: #f8b4b4;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(248, 180, 180, 0));
  }
  .sm\\:via-red-400 {
    --gradient-via-color: #f98080;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(249, 128, 128, 0));
  }
  .sm\\:via-red-500 {
    --gradient-via-color: #f05252;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(240, 82, 82, 0));
  }
  .sm\\:via-red-600 {
    --gradient-via-color: #e02424;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(224, 36, 36, 0));
  }
  .sm\\:via-red-700 {
    --gradient-via-color: #c81e1e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(200, 30, 30, 0));
  }
  .sm\\:via-red-800 {
    --gradient-via-color: #9b1c1c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(155, 28, 28, 0));
  }
  .sm\\:via-red-900 {
    --gradient-via-color: #771d1d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(119, 29, 29, 0));
  }
  .sm\\:via-orange-50 {
    --gradient-via-color: #fff8f1;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 248, 241, 0));
  }
  .sm\\:via-orange-100 {
    --gradient-via-color: #feecdc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 236, 220, 0));
  }
  .sm\\:via-orange-200 {
    --gradient-via-color: #fcd9bd;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(252, 217, 189, 0));
  }
  .sm\\:via-orange-300 {
    --gradient-via-color: #fdba8c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 186, 140, 0));
  }
  .sm\\:via-orange-400 {
    --gradient-via-color: #ff8a4c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 138, 76, 0));
  }
  .sm\\:via-orange-500 {
    --gradient-via-color: #ff5a1f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 90, 31, 0));
  }
  .sm\\:via-orange-600 {
    --gradient-via-color: #d03801;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(208, 56, 1, 0));
  }
  .sm\\:via-orange-700 {
    --gradient-via-color: #b43403;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(180, 52, 3, 0));
  }
  .sm\\:via-orange-800 {
    --gradient-via-color: #8a2c0d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(138, 44, 13, 0));
  }
  .sm\\:via-orange-900 {
    --gradient-via-color: #73230d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(115, 35, 13, 0));
  }
  .sm\\:via-yellow-50 {
    --gradient-via-color: #fdfdea;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 253, 234, 0));
  }
  .sm\\:via-yellow-100 {
    --gradient-via-color: #fdf6b2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 246, 178, 0));
  }
  .sm\\:via-yellow-200 {
    --gradient-via-color: #fce96a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(252, 233, 106, 0));
  }
  .sm\\:via-yellow-300 {
    --gradient-via-color: #faca15;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(250, 202, 21, 0));
  }
  .sm\\:via-yellow-400 {
    --gradient-via-color: #e3a008;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(227, 160, 8, 0));
  }
  .sm\\:via-yellow-500 {
    --gradient-via-color: #c27803;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(194, 120, 3, 0));
  }
  .sm\\:via-yellow-600 {
    --gradient-via-color: #9f580a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(159, 88, 10, 0));
  }
  .sm\\:via-yellow-700 {
    --gradient-via-color: #8e4b10;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(142, 75, 16, 0));
  }
  .sm\\:via-yellow-800 {
    --gradient-via-color: #723b13;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(114, 59, 19, 0));
  }
  .sm\\:via-yellow-900 {
    --gradient-via-color: #633112;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(99, 49, 18, 0));
  }
  .sm\\:via-green-50 {
    --gradient-via-color: #f3faf7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(243, 250, 247, 0));
  }
  .sm\\:via-green-100 {
    --gradient-via-color: #def7ec;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(222, 247, 236, 0));
  }
  .sm\\:via-green-200 {
    --gradient-via-color: #bcf0da;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(188, 240, 218, 0));
  }
  .sm\\:via-green-300 {
    --gradient-via-color: #84e1bc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(132, 225, 188, 0));
  }
  .sm\\:via-green-400 {
    --gradient-via-color: #31c48d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(49, 196, 141, 0));
  }
  .sm\\:via-green-500 {
    --gradient-via-color: #0e9f6e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(14, 159, 110, 0));
  }
  .sm\\:via-green-600 {
    --gradient-via-color: #057a55;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(5, 122, 85, 0));
  }
  .sm\\:via-green-700 {
    --gradient-via-color: #046c4e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(4, 108, 78, 0));
  }
  .sm\\:via-green-800 {
    --gradient-via-color: #03543f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(3, 84, 63, 0));
  }
  .sm\\:via-green-900 {
    --gradient-via-color: #014737;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(1, 71, 55, 0));
  }
  .sm\\:via-teal-50 {
    --gradient-via-color: #edfafa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(237, 250, 250, 0));
  }
  .sm\\:via-teal-100 {
    --gradient-via-color: #d5f5f6;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(213, 245, 246, 0));
  }
  .sm\\:via-teal-200 {
    --gradient-via-color: #afecef;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(175, 236, 239, 0));
  }
  .sm\\:via-teal-300 {
    --gradient-via-color: #7edce2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(126, 220, 226, 0));
  }
  .sm\\:via-teal-400 {
    --gradient-via-color: #16bdca;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(22, 189, 202, 0));
  }
  .sm\\:via-teal-500 {
    --gradient-via-color: #0694a2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(6, 148, 162, 0));
  }
  .sm\\:via-teal-600 {
    --gradient-via-color: #047481;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(4, 116, 129, 0));
  }
  .sm\\:via-teal-700 {
    --gradient-via-color: #036672;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(3, 102, 114, 0));
  }
  .sm\\:via-teal-800 {
    --gradient-via-color: #05505c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(5, 80, 92, 0));
  }
  .sm\\:via-teal-900 {
    --gradient-via-color: #014451;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(1, 68, 81, 0));
  }
  .sm\\:via-blue-50 {
    --gradient-via-color: #ebf5ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(235, 245, 255, 0));
  }
  .sm\\:via-blue-100 {
    --gradient-via-color: #e1effe;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(225, 239, 254, 0));
  }
  .sm\\:via-blue-200 {
    --gradient-via-color: #c3ddfd;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(195, 221, 253, 0));
  }
  .sm\\:via-blue-300 {
    --gradient-via-color: #a4cafe;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(164, 202, 254, 0));
  }
  .sm\\:via-blue-400 {
    --gradient-via-color: #76a9fa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(118, 169, 250, 0));
  }
  .sm\\:via-blue-500 {
    --gradient-via-color: #3f83f8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(63, 131, 248, 0));
  }
  .sm\\:via-blue-600 {
    --gradient-via-color: #1c64f2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(28, 100, 242, 0));
  }
  .sm\\:via-blue-700 {
    --gradient-via-color: #1a56db;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(26, 86, 219, 0));
  }
  .sm\\:via-blue-800 {
    --gradient-via-color: #1e429f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(30, 66, 159, 0));
  }
  .sm\\:via-blue-900 {
    --gradient-via-color: #233876;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(35, 56, 118, 0));
  }
  .sm\\:via-indigo-50 {
    --gradient-via-color: #f0f5ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(240, 245, 255, 0));
  }
  .sm\\:via-indigo-100 {
    --gradient-via-color: #e5edff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(229, 237, 255, 0));
  }
  .sm\\:via-indigo-200 {
    --gradient-via-color: #cddbfe;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(205, 219, 254, 0));
  }
  .sm\\:via-indigo-300 {
    --gradient-via-color: #b4c6fc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(180, 198, 252, 0));
  }
  .sm\\:via-indigo-400 {
    --gradient-via-color: #8da2fb;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(141, 162, 251, 0));
  }
  .sm\\:via-indigo-500 {
    --gradient-via-color: #6875f5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(104, 117, 245, 0));
  }
  .sm\\:via-indigo-600 {
    --gradient-via-color: #5850ec;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(88, 80, 236, 0));
  }
  .sm\\:via-indigo-700 {
    --gradient-via-color: #5145cd;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(81, 69, 205, 0));
  }
  .sm\\:via-indigo-800 {
    --gradient-via-color: #42389d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(66, 56, 157, 0));
  }
  .sm\\:via-indigo-900 {
    --gradient-via-color: #362f78;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(54, 47, 120, 0));
  }
  .sm\\:via-purple-50 {
    --gradient-via-color: #f6f5ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(246, 245, 255, 0));
  }
  .sm\\:via-purple-100 {
    --gradient-via-color: #edebfe;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(237, 235, 254, 0));
  }
  .sm\\:via-purple-200 {
    --gradient-via-color: #dcd7fe;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(220, 215, 254, 0));
  }
  .sm\\:via-purple-300 {
    --gradient-via-color: #cabffd;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(202, 191, 253, 0));
  }
  .sm\\:via-purple-400 {
    --gradient-via-color: #ac94fa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(172, 148, 250, 0));
  }
  .sm\\:via-purple-500 {
    --gradient-via-color: #9061f9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(144, 97, 249, 0));
  }
  .sm\\:via-purple-600 {
    --gradient-via-color: #7e3af2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(126, 58, 242, 0));
  }
  .sm\\:via-purple-700 {
    --gradient-via-color: #6c2bd9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(108, 43, 217, 0));
  }
  .sm\\:via-purple-800 {
    --gradient-via-color: #5521b5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(85, 33, 181, 0));
  }
  .sm\\:via-purple-900 {
    --gradient-via-color: #4a1d96;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(74, 29, 150, 0));
  }
  .sm\\:via-pink-50 {
    --gradient-via-color: #fdf2f8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 242, 248, 0));
  }
  .sm\\:via-pink-100 {
    --gradient-via-color: #fce8f3;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(252, 232, 243, 0));
  }
  .sm\\:via-pink-200 {
    --gradient-via-color: #fad1e8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(250, 209, 232, 0));
  }
  .sm\\:via-pink-300 {
    --gradient-via-color: #f8b4d9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(248, 180, 217, 0));
  }
  .sm\\:via-pink-400 {
    --gradient-via-color: #f17eb8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(241, 126, 184, 0));
  }
  .sm\\:via-pink-500 {
    --gradient-via-color: #e74694;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(231, 70, 148, 0));
  }
  .sm\\:via-pink-600 {
    --gradient-via-color: #d61f69;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(214, 31, 105, 0));
  }
  .sm\\:via-pink-700 {
    --gradient-via-color: #bf125d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(191, 18, 93, 0));
  }
  .sm\\:via-pink-800 {
    --gradient-via-color: #99154b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(153, 21, 75, 0));
  }
  .sm\\:via-pink-900 {
    --gradient-via-color: #751a3d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(117, 26, 61, 0));
  }
  .sm\\:via-cool-gray-50 {
    --gradient-via-color: #f8fafc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(248, 250, 252, 0));
  }
  .sm\\:via-cool-gray-100 {
    --gradient-via-color: #f1f5f9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(241, 245, 249, 0));
  }
  .sm\\:via-cool-gray-200 {
    --gradient-via-color: #e2e8f0;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(226, 232, 240, 0));
  }
  .sm\\:via-cool-gray-300 {
    --gradient-via-color: #cfd8e3;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(207, 216, 227, 0));
  }
  .sm\\:via-cool-gray-400 {
    --gradient-via-color: #97a6ba;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(151, 166, 186, 0));
  }
  .sm\\:via-cool-gray-500 {
    --gradient-via-color: #64748b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(100, 116, 139, 0));
  }
  .sm\\:via-cool-gray-600 {
    --gradient-via-color: #475569;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(71, 85, 105, 0));
  }
  .sm\\:via-cool-gray-700 {
    --gradient-via-color: #364152;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(54, 65, 82, 0));
  }
  .sm\\:via-cool-gray-800 {
    --gradient-via-color: #27303f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(39, 48, 63, 0));
  }
  .sm\\:via-cool-gray-900 {
    --gradient-via-color: #1a202e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(26, 32, 46, 0));
  }
  .sm\\:to-current {
    --gradient-to-color: currentColor;
  }
  .sm\\:to-transparent {
    --gradient-to-color: transparent;
  }
  .sm\\:to-white {
    --gradient-to-color: #ffffff;
  }
  .sm\\:to-black {
    --gradient-to-color: #000000;
  }
  .sm\\:to-gray-50 {
    --gradient-to-color: #f9fafb;
  }
  .sm\\:to-gray-100 {
    --gradient-to-color: #f4f5f7;
  }
  .sm\\:to-gray-200 {
    --gradient-to-color: #e5e7eb;
  }
  .sm\\:to-gray-300 {
    --gradient-to-color: #d2d6dc;
  }
  .sm\\:to-gray-400 {
    --gradient-to-color: #9fa6b2;
  }
  .sm\\:to-gray-500 {
    --gradient-to-color: #6b7280;
  }
  .sm\\:to-gray-600 {
    --gradient-to-color: #4b5563;
  }
  .sm\\:to-gray-700 {
    --gradient-to-color: #374151;
  }
  .sm\\:to-gray-800 {
    --gradient-to-color: #252f3f;
  }
  .sm\\:to-gray-900 {
    --gradient-to-color: #161e2e;
  }
  .sm\\:to-red-50 {
    --gradient-to-color: #fdf2f2;
  }
  .sm\\:to-red-100 {
    --gradient-to-color: #fde8e8;
  }
  .sm\\:to-red-200 {
    --gradient-to-color: #fbd5d5;
  }
  .sm\\:to-red-300 {
    --gradient-to-color: #f8b4b4;
  }
  .sm\\:to-red-400 {
    --gradient-to-color: #f98080;
  }
  .sm\\:to-red-500 {
    --gradient-to-color: #f05252;
  }
  .sm\\:to-red-600 {
    --gradient-to-color: #e02424;
  }
  .sm\\:to-red-700 {
    --gradient-to-color: #c81e1e;
  }
  .sm\\:to-red-800 {
    --gradient-to-color: #9b1c1c;
  }
  .sm\\:to-red-900 {
    --gradient-to-color: #771d1d;
  }
  .sm\\:to-orange-50 {
    --gradient-to-color: #fff8f1;
  }
  .sm\\:to-orange-100 {
    --gradient-to-color: #feecdc;
  }
  .sm\\:to-orange-200 {
    --gradient-to-color: #fcd9bd;
  }
  .sm\\:to-orange-300 {
    --gradient-to-color: #fdba8c;
  }
  .sm\\:to-orange-400 {
    --gradient-to-color: #ff8a4c;
  }
  .sm\\:to-orange-500 {
    --gradient-to-color: #ff5a1f;
  }
  .sm\\:to-orange-600 {
    --gradient-to-color: #d03801;
  }
  .sm\\:to-orange-700 {
    --gradient-to-color: #b43403;
  }
  .sm\\:to-orange-800 {
    --gradient-to-color: #8a2c0d;
  }
  .sm\\:to-orange-900 {
    --gradient-to-color: #73230d;
  }
  .sm\\:to-yellow-50 {
    --gradient-to-color: #fdfdea;
  }
  .sm\\:to-yellow-100 {
    --gradient-to-color: #fdf6b2;
  }
  .sm\\:to-yellow-200 {
    --gradient-to-color: #fce96a;
  }
  .sm\\:to-yellow-300 {
    --gradient-to-color: #faca15;
  }
  .sm\\:to-yellow-400 {
    --gradient-to-color: #e3a008;
  }
  .sm\\:to-yellow-500 {
    --gradient-to-color: #c27803;
  }
  .sm\\:to-yellow-600 {
    --gradient-to-color: #9f580a;
  }
  .sm\\:to-yellow-700 {
    --gradient-to-color: #8e4b10;
  }
  .sm\\:to-yellow-800 {
    --gradient-to-color: #723b13;
  }
  .sm\\:to-yellow-900 {
    --gradient-to-color: #633112;
  }
  .sm\\:to-green-50 {
    --gradient-to-color: #f3faf7;
  }
  .sm\\:to-green-100 {
    --gradient-to-color: #def7ec;
  }
  .sm\\:to-green-200 {
    --gradient-to-color: #bcf0da;
  }
  .sm\\:to-green-300 {
    --gradient-to-color: #84e1bc;
  }
  .sm\\:to-green-400 {
    --gradient-to-color: #31c48d;
  }
  .sm\\:to-green-500 {
    --gradient-to-color: #0e9f6e;
  }
  .sm\\:to-green-600 {
    --gradient-to-color: #057a55;
  }
  .sm\\:to-green-700 {
    --gradient-to-color: #046c4e;
  }
  .sm\\:to-green-800 {
    --gradient-to-color: #03543f;
  }
  .sm\\:to-green-900 {
    --gradient-to-color: #014737;
  }
  .sm\\:to-teal-50 {
    --gradient-to-color: #edfafa;
  }
  .sm\\:to-teal-100 {
    --gradient-to-color: #d5f5f6;
  }
  .sm\\:to-teal-200 {
    --gradient-to-color: #afecef;
  }
  .sm\\:to-teal-300 {
    --gradient-to-color: #7edce2;
  }
  .sm\\:to-teal-400 {
    --gradient-to-color: #16bdca;
  }
  .sm\\:to-teal-500 {
    --gradient-to-color: #0694a2;
  }
  .sm\\:to-teal-600 {
    --gradient-to-color: #047481;
  }
  .sm\\:to-teal-700 {
    --gradient-to-color: #036672;
  }
  .sm\\:to-teal-800 {
    --gradient-to-color: #05505c;
  }
  .sm\\:to-teal-900 {
    --gradient-to-color: #014451;
  }
  .sm\\:to-blue-50 {
    --gradient-to-color: #ebf5ff;
  }
  .sm\\:to-blue-100 {
    --gradient-to-color: #e1effe;
  }
  .sm\\:to-blue-200 {
    --gradient-to-color: #c3ddfd;
  }
  .sm\\:to-blue-300 {
    --gradient-to-color: #a4cafe;
  }
  .sm\\:to-blue-400 {
    --gradient-to-color: #76a9fa;
  }
  .sm\\:to-blue-500 {
    --gradient-to-color: #3f83f8;
  }
  .sm\\:to-blue-600 {
    --gradient-to-color: #1c64f2;
  }
  .sm\\:to-blue-700 {
    --gradient-to-color: #1a56db;
  }
  .sm\\:to-blue-800 {
    --gradient-to-color: #1e429f;
  }
  .sm\\:to-blue-900 {
    --gradient-to-color: #233876;
  }
  .sm\\:to-indigo-50 {
    --gradient-to-color: #f0f5ff;
  }
  .sm\\:to-indigo-100 {
    --gradient-to-color: #e5edff;
  }
  .sm\\:to-indigo-200 {
    --gradient-to-color: #cddbfe;
  }
  .sm\\:to-indigo-300 {
    --gradient-to-color: #b4c6fc;
  }
  .sm\\:to-indigo-400 {
    --gradient-to-color: #8da2fb;
  }
  .sm\\:to-indigo-500 {
    --gradient-to-color: #6875f5;
  }
  .sm\\:to-indigo-600 {
    --gradient-to-color: #5850ec;
  }
  .sm\\:to-indigo-700 {
    --gradient-to-color: #5145cd;
  }
  .sm\\:to-indigo-800 {
    --gradient-to-color: #42389d;
  }
  .sm\\:to-indigo-900 {
    --gradient-to-color: #362f78;
  }
  .sm\\:to-purple-50 {
    --gradient-to-color: #f6f5ff;
  }
  .sm\\:to-purple-100 {
    --gradient-to-color: #edebfe;
  }
  .sm\\:to-purple-200 {
    --gradient-to-color: #dcd7fe;
  }
  .sm\\:to-purple-300 {
    --gradient-to-color: #cabffd;
  }
  .sm\\:to-purple-400 {
    --gradient-to-color: #ac94fa;
  }
  .sm\\:to-purple-500 {
    --gradient-to-color: #9061f9;
  }
  .sm\\:to-purple-600 {
    --gradient-to-color: #7e3af2;
  }
  .sm\\:to-purple-700 {
    --gradient-to-color: #6c2bd9;
  }
  .sm\\:to-purple-800 {
    --gradient-to-color: #5521b5;
  }
  .sm\\:to-purple-900 {
    --gradient-to-color: #4a1d96;
  }
  .sm\\:to-pink-50 {
    --gradient-to-color: #fdf2f8;
  }
  .sm\\:to-pink-100 {
    --gradient-to-color: #fce8f3;
  }
  .sm\\:to-pink-200 {
    --gradient-to-color: #fad1e8;
  }
  .sm\\:to-pink-300 {
    --gradient-to-color: #f8b4d9;
  }
  .sm\\:to-pink-400 {
    --gradient-to-color: #f17eb8;
  }
  .sm\\:to-pink-500 {
    --gradient-to-color: #e74694;
  }
  .sm\\:to-pink-600 {
    --gradient-to-color: #d61f69;
  }
  .sm\\:to-pink-700 {
    --gradient-to-color: #bf125d;
  }
  .sm\\:to-pink-800 {
    --gradient-to-color: #99154b;
  }
  .sm\\:to-pink-900 {
    --gradient-to-color: #751a3d;
  }
  .sm\\:to-cool-gray-50 {
    --gradient-to-color: #f8fafc;
  }
  .sm\\:to-cool-gray-100 {
    --gradient-to-color: #f1f5f9;
  }
  .sm\\:to-cool-gray-200 {
    --gradient-to-color: #e2e8f0;
  }
  .sm\\:to-cool-gray-300 {
    --gradient-to-color: #cfd8e3;
  }
  .sm\\:to-cool-gray-400 {
    --gradient-to-color: #97a6ba;
  }
  .sm\\:to-cool-gray-500 {
    --gradient-to-color: #64748b;
  }
  .sm\\:to-cool-gray-600 {
    --gradient-to-color: #475569;
  }
  .sm\\:to-cool-gray-700 {
    --gradient-to-color: #364152;
  }
  .sm\\:to-cool-gray-800 {
    --gradient-to-color: #27303f;
  }
  .sm\\:to-cool-gray-900 {
    --gradient-to-color: #1a202e;
  }
  .sm\\:hover\\:from-current:hover {
    --gradient-from-color: currentColor;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }
  .sm\\:hover\\:from-transparent:hover {
    --gradient-from-color: transparent;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  }
  .sm\\:hover\\:from-white:hover {
    --gradient-from-color: #ffffff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }
  .sm\\:hover\\:from-black:hover {
    --gradient-from-color: #000000;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  }
  .sm\\:hover\\:from-gray-50:hover {
    --gradient-from-color: #f9fafb;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(249, 250, 251, 0));
  }
  .sm\\:hover\\:from-gray-100:hover {
    --gradient-from-color: #f4f5f7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(244, 245, 247, 0));
  }
  .sm\\:hover\\:from-gray-200:hover {
    --gradient-from-color: #e5e7eb;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(229, 231, 235, 0));
  }
  .sm\\:hover\\:from-gray-300:hover {
    --gradient-from-color: #d2d6dc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(210, 214, 220, 0));
  }
  .sm\\:hover\\:from-gray-400:hover {
    --gradient-from-color: #9fa6b2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(159, 166, 178, 0));
  }
  .sm\\:hover\\:from-gray-500:hover {
    --gradient-from-color: #6b7280;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(107, 114, 128, 0));
  }
  .sm\\:hover\\:from-gray-600:hover {
    --gradient-from-color: #4b5563;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(75, 85, 99, 0));
  }
  .sm\\:hover\\:from-gray-700:hover {
    --gradient-from-color: #374151;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(55, 65, 81, 0));
  }
  .sm\\:hover\\:from-gray-800:hover {
    --gradient-from-color: #252f3f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(37, 47, 63, 0));
  }
  .sm\\:hover\\:from-gray-900:hover {
    --gradient-from-color: #161e2e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(22, 30, 46, 0));
  }
  .sm\\:hover\\:from-red-50:hover {
    --gradient-from-color: #fdf2f2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 242, 242, 0));
  }
  .sm\\:hover\\:from-red-100:hover {
    --gradient-from-color: #fde8e8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 232, 232, 0));
  }
  .sm\\:hover\\:from-red-200:hover {
    --gradient-from-color: #fbd5d5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(251, 213, 213, 0));
  }
  .sm\\:hover\\:from-red-300:hover {
    --gradient-from-color: #f8b4b4;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(248, 180, 180, 0));
  }
  .sm\\:hover\\:from-red-400:hover {
    --gradient-from-color: #f98080;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(249, 128, 128, 0));
  }
  .sm\\:hover\\:from-red-500:hover {
    --gradient-from-color: #f05252;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(240, 82, 82, 0));
  }
  .sm\\:hover\\:from-red-600:hover {
    --gradient-from-color: #e02424;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(224, 36, 36, 0));
  }
  .sm\\:hover\\:from-red-700:hover {
    --gradient-from-color: #c81e1e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(200, 30, 30, 0));
  }
  .sm\\:hover\\:from-red-800:hover {
    --gradient-from-color: #9b1c1c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(155, 28, 28, 0));
  }
  .sm\\:hover\\:from-red-900:hover {
    --gradient-from-color: #771d1d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(119, 29, 29, 0));
  }
  .sm\\:hover\\:from-orange-50:hover {
    --gradient-from-color: #fff8f1;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 248, 241, 0));
  }
  .sm\\:hover\\:from-orange-100:hover {
    --gradient-from-color: #feecdc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 236, 220, 0));
  }
  .sm\\:hover\\:from-orange-200:hover {
    --gradient-from-color: #fcd9bd;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(252, 217, 189, 0));
  }
  .sm\\:hover\\:from-orange-300:hover {
    --gradient-from-color: #fdba8c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 186, 140, 0));
  }
  .sm\\:hover\\:from-orange-400:hover {
    --gradient-from-color: #ff8a4c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 138, 76, 0));
  }
  .sm\\:hover\\:from-orange-500:hover {
    --gradient-from-color: #ff5a1f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 90, 31, 0));
  }
  .sm\\:hover\\:from-orange-600:hover {
    --gradient-from-color: #d03801;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(208, 56, 1, 0));
  }
  .sm\\:hover\\:from-orange-700:hover {
    --gradient-from-color: #b43403;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(180, 52, 3, 0));
  }
  .sm\\:hover\\:from-orange-800:hover {
    --gradient-from-color: #8a2c0d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(138, 44, 13, 0));
  }
  .sm\\:hover\\:from-orange-900:hover {
    --gradient-from-color: #73230d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(115, 35, 13, 0));
  }
  .sm\\:hover\\:from-yellow-50:hover {
    --gradient-from-color: #fdfdea;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 253, 234, 0));
  }
  .sm\\:hover\\:from-yellow-100:hover {
    --gradient-from-color: #fdf6b2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 246, 178, 0));
  }
  .sm\\:hover\\:from-yellow-200:hover {
    --gradient-from-color: #fce96a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(252, 233, 106, 0));
  }
  .sm\\:hover\\:from-yellow-300:hover {
    --gradient-from-color: #faca15;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(250, 202, 21, 0));
  }
  .sm\\:hover\\:from-yellow-400:hover {
    --gradient-from-color: #e3a008;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(227, 160, 8, 0));
  }
  .sm\\:hover\\:from-yellow-500:hover {
    --gradient-from-color: #c27803;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(194, 120, 3, 0));
  }
  .sm\\:hover\\:from-yellow-600:hover {
    --gradient-from-color: #9f580a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(159, 88, 10, 0));
  }
  .sm\\:hover\\:from-yellow-700:hover {
    --gradient-from-color: #8e4b10;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(142, 75, 16, 0));
  }
  .sm\\:hover\\:from-yellow-800:hover {
    --gradient-from-color: #723b13;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(114, 59, 19, 0));
  }
  .sm\\:hover\\:from-yellow-900:hover {
    --gradient-from-color: #633112;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(99, 49, 18, 0));
  }
  .sm\\:hover\\:from-green-50:hover {
    --gradient-from-color: #f3faf7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(243, 250, 247, 0));
  }
  .sm\\:hover\\:from-green-100:hover {
    --gradient-from-color: #def7ec;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(222, 247, 236, 0));
  }
  .sm\\:hover\\:from-green-200:hover {
    --gradient-from-color: #bcf0da;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(188, 240, 218, 0));
  }
  .sm\\:hover\\:from-green-300:hover {
    --gradient-from-color: #84e1bc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(132, 225, 188, 0));
  }
  .sm\\:hover\\:from-green-400:hover {
    --gradient-from-color: #31c48d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(49, 196, 141, 0));
  }
  .sm\\:hover\\:from-green-500:hover {
    --gradient-from-color: #0e9f6e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(14, 159, 110, 0));
  }
  .sm\\:hover\\:from-green-600:hover {
    --gradient-from-color: #057a55;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(5, 122, 85, 0));
  }
  .sm\\:hover\\:from-green-700:hover {
    --gradient-from-color: #046c4e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(4, 108, 78, 0));
  }
  .sm\\:hover\\:from-green-800:hover {
    --gradient-from-color: #03543f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(3, 84, 63, 0));
  }
  .sm\\:hover\\:from-green-900:hover {
    --gradient-from-color: #014737;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(1, 71, 55, 0));
  }
  .sm\\:hover\\:from-teal-50:hover {
    --gradient-from-color: #edfafa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(237, 250, 250, 0));
  }
  .sm\\:hover\\:from-teal-100:hover {
    --gradient-from-color: #d5f5f6;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(213, 245, 246, 0));
  }
  .sm\\:hover\\:from-teal-200:hover {
    --gradient-from-color: #afecef;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(175, 236, 239, 0));
  }
  .sm\\:hover\\:from-teal-300:hover {
    --gradient-from-color: #7edce2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(126, 220, 226, 0));
  }
  .sm\\:hover\\:from-teal-400:hover {
    --gradient-from-color: #16bdca;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(22, 189, 202, 0));
  }
  .sm\\:hover\\:from-teal-500:hover {
    --gradient-from-color: #0694a2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(6, 148, 162, 0));
  }
  .sm\\:hover\\:from-teal-600:hover {
    --gradient-from-color: #047481;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(4, 116, 129, 0));
  }
  .sm\\:hover\\:from-teal-700:hover {
    --gradient-from-color: #036672;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(3, 102, 114, 0));
  }
  .sm\\:hover\\:from-teal-800:hover {
    --gradient-from-color: #05505c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(5, 80, 92, 0));
  }
  .sm\\:hover\\:from-teal-900:hover {
    --gradient-from-color: #014451;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(1, 68, 81, 0));
  }
  .sm\\:hover\\:from-blue-50:hover {
    --gradient-from-color: #ebf5ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(235, 245, 255, 0));
  }
  .sm\\:hover\\:from-blue-100:hover {
    --gradient-from-color: #e1effe;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(225, 239, 254, 0));
  }
  .sm\\:hover\\:from-blue-200:hover {
    --gradient-from-color: #c3ddfd;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(195, 221, 253, 0));
  }
  .sm\\:hover\\:from-blue-300:hover {
    --gradient-from-color: #a4cafe;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(164, 202, 254, 0));
  }
  .sm\\:hover\\:from-blue-400:hover {
    --gradient-from-color: #76a9fa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(118, 169, 250, 0));
  }
  .sm\\:hover\\:from-blue-500:hover {
    --gradient-from-color: #3f83f8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(63, 131, 248, 0));
  }
  .sm\\:hover\\:from-blue-600:hover {
    --gradient-from-color: #1c64f2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(28, 100, 242, 0));
  }
  .sm\\:hover\\:from-blue-700:hover {
    --gradient-from-color: #1a56db;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(26, 86, 219, 0));
  }
  .sm\\:hover\\:from-blue-800:hover {
    --gradient-from-color: #1e429f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(30, 66, 159, 0));
  }
  .sm\\:hover\\:from-blue-900:hover {
    --gradient-from-color: #233876;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(35, 56, 118, 0));
  }
  .sm\\:hover\\:from-indigo-50:hover {
    --gradient-from-color: #f0f5ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(240, 245, 255, 0));
  }
  .sm\\:hover\\:from-indigo-100:hover {
    --gradient-from-color: #e5edff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(229, 237, 255, 0));
  }
  .sm\\:hover\\:from-indigo-200:hover {
    --gradient-from-color: #cddbfe;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(205, 219, 254, 0));
  }
  .sm\\:hover\\:from-indigo-300:hover {
    --gradient-from-color: #b4c6fc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(180, 198, 252, 0));
  }
  .sm\\:hover\\:from-indigo-400:hover {
    --gradient-from-color: #8da2fb;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(141, 162, 251, 0));
  }
  .sm\\:hover\\:from-indigo-500:hover {
    --gradient-from-color: #6875f5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(104, 117, 245, 0));
  }
  .sm\\:hover\\:from-indigo-600:hover {
    --gradient-from-color: #5850ec;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(88, 80, 236, 0));
  }
  .sm\\:hover\\:from-indigo-700:hover {
    --gradient-from-color: #5145cd;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(81, 69, 205, 0));
  }
  .sm\\:hover\\:from-indigo-800:hover {
    --gradient-from-color: #42389d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(66, 56, 157, 0));
  }
  .sm\\:hover\\:from-indigo-900:hover {
    --gradient-from-color: #362f78;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(54, 47, 120, 0));
  }
  .sm\\:hover\\:from-purple-50:hover {
    --gradient-from-color: #f6f5ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(246, 245, 255, 0));
  }
  .sm\\:hover\\:from-purple-100:hover {
    --gradient-from-color: #edebfe;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(237, 235, 254, 0));
  }
  .sm\\:hover\\:from-purple-200:hover {
    --gradient-from-color: #dcd7fe;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(220, 215, 254, 0));
  }
  .sm\\:hover\\:from-purple-300:hover {
    --gradient-from-color: #cabffd;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(202, 191, 253, 0));
  }
  .sm\\:hover\\:from-purple-400:hover {
    --gradient-from-color: #ac94fa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(172, 148, 250, 0));
  }
  .sm\\:hover\\:from-purple-500:hover {
    --gradient-from-color: #9061f9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(144, 97, 249, 0));
  }
  .sm\\:hover\\:from-purple-600:hover {
    --gradient-from-color: #7e3af2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(126, 58, 242, 0));
  }
  .sm\\:hover\\:from-purple-700:hover {
    --gradient-from-color: #6c2bd9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(108, 43, 217, 0));
  }
  .sm\\:hover\\:from-purple-800:hover {
    --gradient-from-color: #5521b5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(85, 33, 181, 0));
  }
  .sm\\:hover\\:from-purple-900:hover {
    --gradient-from-color: #4a1d96;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(74, 29, 150, 0));
  }
  .sm\\:hover\\:from-pink-50:hover {
    --gradient-from-color: #fdf2f8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 242, 248, 0));
  }
  .sm\\:hover\\:from-pink-100:hover {
    --gradient-from-color: #fce8f3;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(252, 232, 243, 0));
  }
  .sm\\:hover\\:from-pink-200:hover {
    --gradient-from-color: #fad1e8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(250, 209, 232, 0));
  }
  .sm\\:hover\\:from-pink-300:hover {
    --gradient-from-color: #f8b4d9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(248, 180, 217, 0));
  }
  .sm\\:hover\\:from-pink-400:hover {
    --gradient-from-color: #f17eb8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(241, 126, 184, 0));
  }
  .sm\\:hover\\:from-pink-500:hover {
    --gradient-from-color: #e74694;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(231, 70, 148, 0));
  }
  .sm\\:hover\\:from-pink-600:hover {
    --gradient-from-color: #d61f69;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(214, 31, 105, 0));
  }
  .sm\\:hover\\:from-pink-700:hover {
    --gradient-from-color: #bf125d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(191, 18, 93, 0));
  }
  .sm\\:hover\\:from-pink-800:hover {
    --gradient-from-color: #99154b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(153, 21, 75, 0));
  }
  .sm\\:hover\\:from-pink-900:hover {
    --gradient-from-color: #751a3d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(117, 26, 61, 0));
  }
  .sm\\:hover\\:from-cool-gray-50:hover {
    --gradient-from-color: #f8fafc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(248, 250, 252, 0));
  }
  .sm\\:hover\\:from-cool-gray-100:hover {
    --gradient-from-color: #f1f5f9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(241, 245, 249, 0));
  }
  .sm\\:hover\\:from-cool-gray-200:hover {
    --gradient-from-color: #e2e8f0;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(226, 232, 240, 0));
  }
  .sm\\:hover\\:from-cool-gray-300:hover {
    --gradient-from-color: #cfd8e3;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(207, 216, 227, 0));
  }
  .sm\\:hover\\:from-cool-gray-400:hover {
    --gradient-from-color: #97a6ba;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(151, 166, 186, 0));
  }
  .sm\\:hover\\:from-cool-gray-500:hover {
    --gradient-from-color: #64748b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(100, 116, 139, 0));
  }
  .sm\\:hover\\:from-cool-gray-600:hover {
    --gradient-from-color: #475569;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(71, 85, 105, 0));
  }
  .sm\\:hover\\:from-cool-gray-700:hover {
    --gradient-from-color: #364152;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(54, 65, 82, 0));
  }
  .sm\\:hover\\:from-cool-gray-800:hover {
    --gradient-from-color: #27303f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(39, 48, 63, 0));
  }
  .sm\\:hover\\:from-cool-gray-900:hover {
    --gradient-from-color: #1a202e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(26, 32, 46, 0));
  }
  .sm\\:hover\\:via-current:hover {
    --gradient-via-color: currentColor;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }
  .sm\\:hover\\:via-transparent:hover {
    --gradient-via-color: transparent;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  }
  .sm\\:hover\\:via-white:hover {
    --gradient-via-color: #ffffff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }
  .sm\\:hover\\:via-black:hover {
    --gradient-via-color: #000000;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  }
  .sm\\:hover\\:via-gray-50:hover {
    --gradient-via-color: #f9fafb;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(249, 250, 251, 0));
  }
  .sm\\:hover\\:via-gray-100:hover {
    --gradient-via-color: #f4f5f7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(244, 245, 247, 0));
  }
  .sm\\:hover\\:via-gray-200:hover {
    --gradient-via-color: #e5e7eb;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(229, 231, 235, 0));
  }
  .sm\\:hover\\:via-gray-300:hover {
    --gradient-via-color: #d2d6dc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(210, 214, 220, 0));
  }
  .sm\\:hover\\:via-gray-400:hover {
    --gradient-via-color: #9fa6b2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(159, 166, 178, 0));
  }
  .sm\\:hover\\:via-gray-500:hover {
    --gradient-via-color: #6b7280;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(107, 114, 128, 0));
  }
  .sm\\:hover\\:via-gray-600:hover {
    --gradient-via-color: #4b5563;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(75, 85, 99, 0));
  }
  .sm\\:hover\\:via-gray-700:hover {
    --gradient-via-color: #374151;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(55, 65, 81, 0));
  }
  .sm\\:hover\\:via-gray-800:hover {
    --gradient-via-color: #252f3f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(37, 47, 63, 0));
  }
  .sm\\:hover\\:via-gray-900:hover {
    --gradient-via-color: #161e2e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(22, 30, 46, 0));
  }
  .sm\\:hover\\:via-red-50:hover {
    --gradient-via-color: #fdf2f2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 242, 242, 0));
  }
  .sm\\:hover\\:via-red-100:hover {
    --gradient-via-color: #fde8e8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 232, 232, 0));
  }
  .sm\\:hover\\:via-red-200:hover {
    --gradient-via-color: #fbd5d5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(251, 213, 213, 0));
  }
  .sm\\:hover\\:via-red-300:hover {
    --gradient-via-color: #f8b4b4;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(248, 180, 180, 0));
  }
  .sm\\:hover\\:via-red-400:hover {
    --gradient-via-color: #f98080;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(249, 128, 128, 0));
  }
  .sm\\:hover\\:via-red-500:hover {
    --gradient-via-color: #f05252;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(240, 82, 82, 0));
  }
  .sm\\:hover\\:via-red-600:hover {
    --gradient-via-color: #e02424;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(224, 36, 36, 0));
  }
  .sm\\:hover\\:via-red-700:hover {
    --gradient-via-color: #c81e1e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(200, 30, 30, 0));
  }
  .sm\\:hover\\:via-red-800:hover {
    --gradient-via-color: #9b1c1c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(155, 28, 28, 0));
  }
  .sm\\:hover\\:via-red-900:hover {
    --gradient-via-color: #771d1d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(119, 29, 29, 0));
  }
  .sm\\:hover\\:via-orange-50:hover {
    --gradient-via-color: #fff8f1;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 248, 241, 0));
  }
  .sm\\:hover\\:via-orange-100:hover {
    --gradient-via-color: #feecdc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 236, 220, 0));
  }
  .sm\\:hover\\:via-orange-200:hover {
    --gradient-via-color: #fcd9bd;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(252, 217, 189, 0));
  }
  .sm\\:hover\\:via-orange-300:hover {
    --gradient-via-color: #fdba8c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 186, 140, 0));
  }
  .sm\\:hover\\:via-orange-400:hover {
    --gradient-via-color: #ff8a4c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 138, 76, 0));
  }
  .sm\\:hover\\:via-orange-500:hover {
    --gradient-via-color: #ff5a1f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 90, 31, 0));
  }
  .sm\\:hover\\:via-orange-600:hover {
    --gradient-via-color: #d03801;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(208, 56, 1, 0));
  }
  .sm\\:hover\\:via-orange-700:hover {
    --gradient-via-color: #b43403;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(180, 52, 3, 0));
  }
  .sm\\:hover\\:via-orange-800:hover {
    --gradient-via-color: #8a2c0d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(138, 44, 13, 0));
  }
  .sm\\:hover\\:via-orange-900:hover {
    --gradient-via-color: #73230d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(115, 35, 13, 0));
  }
  .sm\\:hover\\:via-yellow-50:hover {
    --gradient-via-color: #fdfdea;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 253, 234, 0));
  }
  .sm\\:hover\\:via-yellow-100:hover {
    --gradient-via-color: #fdf6b2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 246, 178, 0));
  }
  .sm\\:hover\\:via-yellow-200:hover {
    --gradient-via-color: #fce96a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(252, 233, 106, 0));
  }
  .sm\\:hover\\:via-yellow-300:hover {
    --gradient-via-color: #faca15;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(250, 202, 21, 0));
  }
  .sm\\:hover\\:via-yellow-400:hover {
    --gradient-via-color: #e3a008;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(227, 160, 8, 0));
  }
  .sm\\:hover\\:via-yellow-500:hover {
    --gradient-via-color: #c27803;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(194, 120, 3, 0));
  }
  .sm\\:hover\\:via-yellow-600:hover {
    --gradient-via-color: #9f580a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(159, 88, 10, 0));
  }
  .sm\\:hover\\:via-yellow-700:hover {
    --gradient-via-color: #8e4b10;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(142, 75, 16, 0));
  }
  .sm\\:hover\\:via-yellow-800:hover {
    --gradient-via-color: #723b13;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(114, 59, 19, 0));
  }
  .sm\\:hover\\:via-yellow-900:hover {
    --gradient-via-color: #633112;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(99, 49, 18, 0));
  }
  .sm\\:hover\\:via-green-50:hover {
    --gradient-via-color: #f3faf7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(243, 250, 247, 0));
  }
  .sm\\:hover\\:via-green-100:hover {
    --gradient-via-color: #def7ec;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(222, 247, 236, 0));
  }
  .sm\\:hover\\:via-green-200:hover {
    --gradient-via-color: #bcf0da;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(188, 240, 218, 0));
  }
  .sm\\:hover\\:via-green-300:hover {
    --gradient-via-color: #84e1bc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(132, 225, 188, 0));
  }
  .sm\\:hover\\:via-green-400:hover {
    --gradient-via-color: #31c48d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(49, 196, 141, 0));
  }
  .sm\\:hover\\:via-green-500:hover {
    --gradient-via-color: #0e9f6e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(14, 159, 110, 0));
  }
  .sm\\:hover\\:via-green-600:hover {
    --gradient-via-color: #057a55;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(5, 122, 85, 0));
  }
  .sm\\:hover\\:via-green-700:hover {
    --gradient-via-color: #046c4e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(4, 108, 78, 0));
  }
  .sm\\:hover\\:via-green-800:hover {
    --gradient-via-color: #03543f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(3, 84, 63, 0));
  }
  .sm\\:hover\\:via-green-900:hover {
    --gradient-via-color: #014737;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(1, 71, 55, 0));
  }
  .sm\\:hover\\:via-teal-50:hover {
    --gradient-via-color: #edfafa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(237, 250, 250, 0));
  }
  .sm\\:hover\\:via-teal-100:hover {
    --gradient-via-color: #d5f5f6;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(213, 245, 246, 0));
  }
  .sm\\:hover\\:via-teal-200:hover {
    --gradient-via-color: #afecef;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(175, 236, 239, 0));
  }
  .sm\\:hover\\:via-teal-300:hover {
    --gradient-via-color: #7edce2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(126, 220, 226, 0));
  }
  .sm\\:hover\\:via-teal-400:hover {
    --gradient-via-color: #16bdca;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(22, 189, 202, 0));
  }
  .sm\\:hover\\:via-teal-500:hover {
    --gradient-via-color: #0694a2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(6, 148, 162, 0));
  }
  .sm\\:hover\\:via-teal-600:hover {
    --gradient-via-color: #047481;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(4, 116, 129, 0));
  }
  .sm\\:hover\\:via-teal-700:hover {
    --gradient-via-color: #036672;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(3, 102, 114, 0));
  }
  .sm\\:hover\\:via-teal-800:hover {
    --gradient-via-color: #05505c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(5, 80, 92, 0));
  }
  .sm\\:hover\\:via-teal-900:hover {
    --gradient-via-color: #014451;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(1, 68, 81, 0));
  }
  .sm\\:hover\\:via-blue-50:hover {
    --gradient-via-color: #ebf5ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(235, 245, 255, 0));
  }
  .sm\\:hover\\:via-blue-100:hover {
    --gradient-via-color: #e1effe;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(225, 239, 254, 0));
  }
  .sm\\:hover\\:via-blue-200:hover {
    --gradient-via-color: #c3ddfd;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(195, 221, 253, 0));
  }
  .sm\\:hover\\:via-blue-300:hover {
    --gradient-via-color: #a4cafe;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(164, 202, 254, 0));
  }
  .sm\\:hover\\:via-blue-400:hover {
    --gradient-via-color: #76a9fa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(118, 169, 250, 0));
  }
  .sm\\:hover\\:via-blue-500:hover {
    --gradient-via-color: #3f83f8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(63, 131, 248, 0));
  }
  .sm\\:hover\\:via-blue-600:hover {
    --gradient-via-color: #1c64f2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(28, 100, 242, 0));
  }
  .sm\\:hover\\:via-blue-700:hover {
    --gradient-via-color: #1a56db;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(26, 86, 219, 0));
  }
  .sm\\:hover\\:via-blue-800:hover {
    --gradient-via-color: #1e429f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(30, 66, 159, 0));
  }
  .sm\\:hover\\:via-blue-900:hover {
    --gradient-via-color: #233876;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(35, 56, 118, 0));
  }
  .sm\\:hover\\:via-indigo-50:hover {
    --gradient-via-color: #f0f5ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(240, 245, 255, 0));
  }
  .sm\\:hover\\:via-indigo-100:hover {
    --gradient-via-color: #e5edff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(229, 237, 255, 0));
  }
  .sm\\:hover\\:via-indigo-200:hover {
    --gradient-via-color: #cddbfe;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(205, 219, 254, 0));
  }
  .sm\\:hover\\:via-indigo-300:hover {
    --gradient-via-color: #b4c6fc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(180, 198, 252, 0));
  }
  .sm\\:hover\\:via-indigo-400:hover {
    --gradient-via-color: #8da2fb;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(141, 162, 251, 0));
  }
  .sm\\:hover\\:via-indigo-500:hover {
    --gradient-via-color: #6875f5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(104, 117, 245, 0));
  }
  .sm\\:hover\\:via-indigo-600:hover {
    --gradient-via-color: #5850ec;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(88, 80, 236, 0));
  }
  .sm\\:hover\\:via-indigo-700:hover {
    --gradient-via-color: #5145cd;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(81, 69, 205, 0));
  }
  .sm\\:hover\\:via-indigo-800:hover {
    --gradient-via-color: #42389d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(66, 56, 157, 0));
  }
  .sm\\:hover\\:via-indigo-900:hover {
    --gradient-via-color: #362f78;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(54, 47, 120, 0));
  }
  .sm\\:hover\\:via-purple-50:hover {
    --gradient-via-color: #f6f5ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(246, 245, 255, 0));
  }
  .sm\\:hover\\:via-purple-100:hover {
    --gradient-via-color: #edebfe;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(237, 235, 254, 0));
  }
  .sm\\:hover\\:via-purple-200:hover {
    --gradient-via-color: #dcd7fe;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(220, 215, 254, 0));
  }
  .sm\\:hover\\:via-purple-300:hover {
    --gradient-via-color: #cabffd;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(202, 191, 253, 0));
  }
  .sm\\:hover\\:via-purple-400:hover {
    --gradient-via-color: #ac94fa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(172, 148, 250, 0));
  }
  .sm\\:hover\\:via-purple-500:hover {
    --gradient-via-color: #9061f9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(144, 97, 249, 0));
  }
  .sm\\:hover\\:via-purple-600:hover {
    --gradient-via-color: #7e3af2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(126, 58, 242, 0));
  }
  .sm\\:hover\\:via-purple-700:hover {
    --gradient-via-color: #6c2bd9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(108, 43, 217, 0));
  }
  .sm\\:hover\\:via-purple-800:hover {
    --gradient-via-color: #5521b5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(85, 33, 181, 0));
  }
  .sm\\:hover\\:via-purple-900:hover {
    --gradient-via-color: #4a1d96;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(74, 29, 150, 0));
  }
  .sm\\:hover\\:via-pink-50:hover {
    --gradient-via-color: #fdf2f8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 242, 248, 0));
  }
  .sm\\:hover\\:via-pink-100:hover {
    --gradient-via-color: #fce8f3;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(252, 232, 243, 0));
  }
  .sm\\:hover\\:via-pink-200:hover {
    --gradient-via-color: #fad1e8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(250, 209, 232, 0));
  }
  .sm\\:hover\\:via-pink-300:hover {
    --gradient-via-color: #f8b4d9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(248, 180, 217, 0));
  }
  .sm\\:hover\\:via-pink-400:hover {
    --gradient-via-color: #f17eb8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(241, 126, 184, 0));
  }
  .sm\\:hover\\:via-pink-500:hover {
    --gradient-via-color: #e74694;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(231, 70, 148, 0));
  }
  .sm\\:hover\\:via-pink-600:hover {
    --gradient-via-color: #d61f69;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(214, 31, 105, 0));
  }
  .sm\\:hover\\:via-pink-700:hover {
    --gradient-via-color: #bf125d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(191, 18, 93, 0));
  }
  .sm\\:hover\\:via-pink-800:hover {
    --gradient-via-color: #99154b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(153, 21, 75, 0));
  }
  .sm\\:hover\\:via-pink-900:hover {
    --gradient-via-color: #751a3d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(117, 26, 61, 0));
  }
  .sm\\:hover\\:via-cool-gray-50:hover {
    --gradient-via-color: #f8fafc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(248, 250, 252, 0));
  }
  .sm\\:hover\\:via-cool-gray-100:hover {
    --gradient-via-color: #f1f5f9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(241, 245, 249, 0));
  }
  .sm\\:hover\\:via-cool-gray-200:hover {
    --gradient-via-color: #e2e8f0;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(226, 232, 240, 0));
  }
  .sm\\:hover\\:via-cool-gray-300:hover {
    --gradient-via-color: #cfd8e3;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(207, 216, 227, 0));
  }
  .sm\\:hover\\:via-cool-gray-400:hover {
    --gradient-via-color: #97a6ba;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(151, 166, 186, 0));
  }
  .sm\\:hover\\:via-cool-gray-500:hover {
    --gradient-via-color: #64748b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(100, 116, 139, 0));
  }
  .sm\\:hover\\:via-cool-gray-600:hover {
    --gradient-via-color: #475569;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(71, 85, 105, 0));
  }
  .sm\\:hover\\:via-cool-gray-700:hover {
    --gradient-via-color: #364152;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(54, 65, 82, 0));
  }
  .sm\\:hover\\:via-cool-gray-800:hover {
    --gradient-via-color: #27303f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(39, 48, 63, 0));
  }
  .sm\\:hover\\:via-cool-gray-900:hover {
    --gradient-via-color: #1a202e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(26, 32, 46, 0));
  }
  .sm\\:hover\\:to-current:hover {
    --gradient-to-color: currentColor;
  }
  .sm\\:hover\\:to-transparent:hover {
    --gradient-to-color: transparent;
  }
  .sm\\:hover\\:to-white:hover {
    --gradient-to-color: #ffffff;
  }
  .sm\\:hover\\:to-black:hover {
    --gradient-to-color: #000000;
  }
  .sm\\:hover\\:to-gray-50:hover {
    --gradient-to-color: #f9fafb;
  }
  .sm\\:hover\\:to-gray-100:hover {
    --gradient-to-color: #f4f5f7;
  }
  .sm\\:hover\\:to-gray-200:hover {
    --gradient-to-color: #e5e7eb;
  }
  .sm\\:hover\\:to-gray-300:hover {
    --gradient-to-color: #d2d6dc;
  }
  .sm\\:hover\\:to-gray-400:hover {
    --gradient-to-color: #9fa6b2;
  }
  .sm\\:hover\\:to-gray-500:hover {
    --gradient-to-color: #6b7280;
  }
  .sm\\:hover\\:to-gray-600:hover {
    --gradient-to-color: #4b5563;
  }
  .sm\\:hover\\:to-gray-700:hover {
    --gradient-to-color: #374151;
  }
  .sm\\:hover\\:to-gray-800:hover {
    --gradient-to-color: #252f3f;
  }
  .sm\\:hover\\:to-gray-900:hover {
    --gradient-to-color: #161e2e;
  }
  .sm\\:hover\\:to-red-50:hover {
    --gradient-to-color: #fdf2f2;
  }
  .sm\\:hover\\:to-red-100:hover {
    --gradient-to-color: #fde8e8;
  }
  .sm\\:hover\\:to-red-200:hover {
    --gradient-to-color: #fbd5d5;
  }
  .sm\\:hover\\:to-red-300:hover {
    --gradient-to-color: #f8b4b4;
  }
  .sm\\:hover\\:to-red-400:hover {
    --gradient-to-color: #f98080;
  }
  .sm\\:hover\\:to-red-500:hover {
    --gradient-to-color: #f05252;
  }
  .sm\\:hover\\:to-red-600:hover {
    --gradient-to-color: #e02424;
  }
  .sm\\:hover\\:to-red-700:hover {
    --gradient-to-color: #c81e1e;
  }
  .sm\\:hover\\:to-red-800:hover {
    --gradient-to-color: #9b1c1c;
  }
  .sm\\:hover\\:to-red-900:hover {
    --gradient-to-color: #771d1d;
  }
  .sm\\:hover\\:to-orange-50:hover {
    --gradient-to-color: #fff8f1;
  }
  .sm\\:hover\\:to-orange-100:hover {
    --gradient-to-color: #feecdc;
  }
  .sm\\:hover\\:to-orange-200:hover {
    --gradient-to-color: #fcd9bd;
  }
  .sm\\:hover\\:to-orange-300:hover {
    --gradient-to-color: #fdba8c;
  }
  .sm\\:hover\\:to-orange-400:hover {
    --gradient-to-color: #ff8a4c;
  }
  .sm\\:hover\\:to-orange-500:hover {
    --gradient-to-color: #ff5a1f;
  }
  .sm\\:hover\\:to-orange-600:hover {
    --gradient-to-color: #d03801;
  }
  .sm\\:hover\\:to-orange-700:hover {
    --gradient-to-color: #b43403;
  }
  .sm\\:hover\\:to-orange-800:hover {
    --gradient-to-color: #8a2c0d;
  }
  .sm\\:hover\\:to-orange-900:hover {
    --gradient-to-color: #73230d;
  }
  .sm\\:hover\\:to-yellow-50:hover {
    --gradient-to-color: #fdfdea;
  }
  .sm\\:hover\\:to-yellow-100:hover {
    --gradient-to-color: #fdf6b2;
  }
  .sm\\:hover\\:to-yellow-200:hover {
    --gradient-to-color: #fce96a;
  }
  .sm\\:hover\\:to-yellow-300:hover {
    --gradient-to-color: #faca15;
  }
  .sm\\:hover\\:to-yellow-400:hover {
    --gradient-to-color: #e3a008;
  }
  .sm\\:hover\\:to-yellow-500:hover {
    --gradient-to-color: #c27803;
  }
  .sm\\:hover\\:to-yellow-600:hover {
    --gradient-to-color: #9f580a;
  }
  .sm\\:hover\\:to-yellow-700:hover {
    --gradient-to-color: #8e4b10;
  }
  .sm\\:hover\\:to-yellow-800:hover {
    --gradient-to-color: #723b13;
  }
  .sm\\:hover\\:to-yellow-900:hover {
    --gradient-to-color: #633112;
  }
  .sm\\:hover\\:to-green-50:hover {
    --gradient-to-color: #f3faf7;
  }
  .sm\\:hover\\:to-green-100:hover {
    --gradient-to-color: #def7ec;
  }
  .sm\\:hover\\:to-green-200:hover {
    --gradient-to-color: #bcf0da;
  }
  .sm\\:hover\\:to-green-300:hover {
    --gradient-to-color: #84e1bc;
  }
  .sm\\:hover\\:to-green-400:hover {
    --gradient-to-color: #31c48d;
  }
  .sm\\:hover\\:to-green-500:hover {
    --gradient-to-color: #0e9f6e;
  }
  .sm\\:hover\\:to-green-600:hover {
    --gradient-to-color: #057a55;
  }
  .sm\\:hover\\:to-green-700:hover {
    --gradient-to-color: #046c4e;
  }
  .sm\\:hover\\:to-green-800:hover {
    --gradient-to-color: #03543f;
  }
  .sm\\:hover\\:to-green-900:hover {
    --gradient-to-color: #014737;
  }
  .sm\\:hover\\:to-teal-50:hover {
    --gradient-to-color: #edfafa;
  }
  .sm\\:hover\\:to-teal-100:hover {
    --gradient-to-color: #d5f5f6;
  }
  .sm\\:hover\\:to-teal-200:hover {
    --gradient-to-color: #afecef;
  }
  .sm\\:hover\\:to-teal-300:hover {
    --gradient-to-color: #7edce2;
  }
  .sm\\:hover\\:to-teal-400:hover {
    --gradient-to-color: #16bdca;
  }
  .sm\\:hover\\:to-teal-500:hover {
    --gradient-to-color: #0694a2;
  }
  .sm\\:hover\\:to-teal-600:hover {
    --gradient-to-color: #047481;
  }
  .sm\\:hover\\:to-teal-700:hover {
    --gradient-to-color: #036672;
  }
  .sm\\:hover\\:to-teal-800:hover {
    --gradient-to-color: #05505c;
  }
  .sm\\:hover\\:to-teal-900:hover {
    --gradient-to-color: #014451;
  }
  .sm\\:hover\\:to-blue-50:hover {
    --gradient-to-color: #ebf5ff;
  }
  .sm\\:hover\\:to-blue-100:hover {
    --gradient-to-color: #e1effe;
  }
  .sm\\:hover\\:to-blue-200:hover {
    --gradient-to-color: #c3ddfd;
  }
  .sm\\:hover\\:to-blue-300:hover {
    --gradient-to-color: #a4cafe;
  }
  .sm\\:hover\\:to-blue-400:hover {
    --gradient-to-color: #76a9fa;
  }
  .sm\\:hover\\:to-blue-500:hover {
    --gradient-to-color: #3f83f8;
  }
  .sm\\:hover\\:to-blue-600:hover {
    --gradient-to-color: #1c64f2;
  }
  .sm\\:hover\\:to-blue-700:hover {
    --gradient-to-color: #1a56db;
  }
  .sm\\:hover\\:to-blue-800:hover {
    --gradient-to-color: #1e429f;
  }
  .sm\\:hover\\:to-blue-900:hover {
    --gradient-to-color: #233876;
  }
  .sm\\:hover\\:to-indigo-50:hover {
    --gradient-to-color: #f0f5ff;
  }
  .sm\\:hover\\:to-indigo-100:hover {
    --gradient-to-color: #e5edff;
  }
  .sm\\:hover\\:to-indigo-200:hover {
    --gradient-to-color: #cddbfe;
  }
  .sm\\:hover\\:to-indigo-300:hover {
    --gradient-to-color: #b4c6fc;
  }
  .sm\\:hover\\:to-indigo-400:hover {
    --gradient-to-color: #8da2fb;
  }
  .sm\\:hover\\:to-indigo-500:hover {
    --gradient-to-color: #6875f5;
  }
  .sm\\:hover\\:to-indigo-600:hover {
    --gradient-to-color: #5850ec;
  }
  .sm\\:hover\\:to-indigo-700:hover {
    --gradient-to-color: #5145cd;
  }
  .sm\\:hover\\:to-indigo-800:hover {
    --gradient-to-color: #42389d;
  }
  .sm\\:hover\\:to-indigo-900:hover {
    --gradient-to-color: #362f78;
  }
  .sm\\:hover\\:to-purple-50:hover {
    --gradient-to-color: #f6f5ff;
  }
  .sm\\:hover\\:to-purple-100:hover {
    --gradient-to-color: #edebfe;
  }
  .sm\\:hover\\:to-purple-200:hover {
    --gradient-to-color: #dcd7fe;
  }
  .sm\\:hover\\:to-purple-300:hover {
    --gradient-to-color: #cabffd;
  }
  .sm\\:hover\\:to-purple-400:hover {
    --gradient-to-color: #ac94fa;
  }
  .sm\\:hover\\:to-purple-500:hover {
    --gradient-to-color: #9061f9;
  }
  .sm\\:hover\\:to-purple-600:hover {
    --gradient-to-color: #7e3af2;
  }
  .sm\\:hover\\:to-purple-700:hover {
    --gradient-to-color: #6c2bd9;
  }
  .sm\\:hover\\:to-purple-800:hover {
    --gradient-to-color: #5521b5;
  }
  .sm\\:hover\\:to-purple-900:hover {
    --gradient-to-color: #4a1d96;
  }
  .sm\\:hover\\:to-pink-50:hover {
    --gradient-to-color: #fdf2f8;
  }
  .sm\\:hover\\:to-pink-100:hover {
    --gradient-to-color: #fce8f3;
  }
  .sm\\:hover\\:to-pink-200:hover {
    --gradient-to-color: #fad1e8;
  }
  .sm\\:hover\\:to-pink-300:hover {
    --gradient-to-color: #f8b4d9;
  }
  .sm\\:hover\\:to-pink-400:hover {
    --gradient-to-color: #f17eb8;
  }
  .sm\\:hover\\:to-pink-500:hover {
    --gradient-to-color: #e74694;
  }
  .sm\\:hover\\:to-pink-600:hover {
    --gradient-to-color: #d61f69;
  }
  .sm\\:hover\\:to-pink-700:hover {
    --gradient-to-color: #bf125d;
  }
  .sm\\:hover\\:to-pink-800:hover {
    --gradient-to-color: #99154b;
  }
  .sm\\:hover\\:to-pink-900:hover {
    --gradient-to-color: #751a3d;
  }
  .sm\\:hover\\:to-cool-gray-50:hover {
    --gradient-to-color: #f8fafc;
  }
  .sm\\:hover\\:to-cool-gray-100:hover {
    --gradient-to-color: #f1f5f9;
  }
  .sm\\:hover\\:to-cool-gray-200:hover {
    --gradient-to-color: #e2e8f0;
  }
  .sm\\:hover\\:to-cool-gray-300:hover {
    --gradient-to-color: #cfd8e3;
  }
  .sm\\:hover\\:to-cool-gray-400:hover {
    --gradient-to-color: #97a6ba;
  }
  .sm\\:hover\\:to-cool-gray-500:hover {
    --gradient-to-color: #64748b;
  }
  .sm\\:hover\\:to-cool-gray-600:hover {
    --gradient-to-color: #475569;
  }
  .sm\\:hover\\:to-cool-gray-700:hover {
    --gradient-to-color: #364152;
  }
  .sm\\:hover\\:to-cool-gray-800:hover {
    --gradient-to-color: #27303f;
  }
  .sm\\:hover\\:to-cool-gray-900:hover {
    --gradient-to-color: #1a202e;
  }
  .sm\\:focus\\:from-current:focus {
    --gradient-from-color: currentColor;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }
  .sm\\:focus\\:from-transparent:focus {
    --gradient-from-color: transparent;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  }
  .sm\\:focus\\:from-white:focus {
    --gradient-from-color: #ffffff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }
  .sm\\:focus\\:from-black:focus {
    --gradient-from-color: #000000;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  }
  .sm\\:focus\\:from-gray-50:focus {
    --gradient-from-color: #f9fafb;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(249, 250, 251, 0));
  }
  .sm\\:focus\\:from-gray-100:focus {
    --gradient-from-color: #f4f5f7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(244, 245, 247, 0));
  }
  .sm\\:focus\\:from-gray-200:focus {
    --gradient-from-color: #e5e7eb;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(229, 231, 235, 0));
  }
  .sm\\:focus\\:from-gray-300:focus {
    --gradient-from-color: #d2d6dc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(210, 214, 220, 0));
  }
  .sm\\:focus\\:from-gray-400:focus {
    --gradient-from-color: #9fa6b2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(159, 166, 178, 0));
  }
  .sm\\:focus\\:from-gray-500:focus {
    --gradient-from-color: #6b7280;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(107, 114, 128, 0));
  }
  .sm\\:focus\\:from-gray-600:focus {
    --gradient-from-color: #4b5563;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(75, 85, 99, 0));
  }
  .sm\\:focus\\:from-gray-700:focus {
    --gradient-from-color: #374151;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(55, 65, 81, 0));
  }
  .sm\\:focus\\:from-gray-800:focus {
    --gradient-from-color: #252f3f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(37, 47, 63, 0));
  }
  .sm\\:focus\\:from-gray-900:focus {
    --gradient-from-color: #161e2e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(22, 30, 46, 0));
  }
  .sm\\:focus\\:from-red-50:focus {
    --gradient-from-color: #fdf2f2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 242, 242, 0));
  }
  .sm\\:focus\\:from-red-100:focus {
    --gradient-from-color: #fde8e8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 232, 232, 0));
  }
  .sm\\:focus\\:from-red-200:focus {
    --gradient-from-color: #fbd5d5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(251, 213, 213, 0));
  }
  .sm\\:focus\\:from-red-300:focus {
    --gradient-from-color: #f8b4b4;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(248, 180, 180, 0));
  }
  .sm\\:focus\\:from-red-400:focus {
    --gradient-from-color: #f98080;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(249, 128, 128, 0));
  }
  .sm\\:focus\\:from-red-500:focus {
    --gradient-from-color: #f05252;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(240, 82, 82, 0));
  }
  .sm\\:focus\\:from-red-600:focus {
    --gradient-from-color: #e02424;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(224, 36, 36, 0));
  }
  .sm\\:focus\\:from-red-700:focus {
    --gradient-from-color: #c81e1e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(200, 30, 30, 0));
  }
  .sm\\:focus\\:from-red-800:focus {
    --gradient-from-color: #9b1c1c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(155, 28, 28, 0));
  }
  .sm\\:focus\\:from-red-900:focus {
    --gradient-from-color: #771d1d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(119, 29, 29, 0));
  }
  .sm\\:focus\\:from-orange-50:focus {
    --gradient-from-color: #fff8f1;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 248, 241, 0));
  }
  .sm\\:focus\\:from-orange-100:focus {
    --gradient-from-color: #feecdc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 236, 220, 0));
  }
  .sm\\:focus\\:from-orange-200:focus {
    --gradient-from-color: #fcd9bd;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(252, 217, 189, 0));
  }
  .sm\\:focus\\:from-orange-300:focus {
    --gradient-from-color: #fdba8c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 186, 140, 0));
  }
  .sm\\:focus\\:from-orange-400:focus {
    --gradient-from-color: #ff8a4c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 138, 76, 0));
  }
  .sm\\:focus\\:from-orange-500:focus {
    --gradient-from-color: #ff5a1f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 90, 31, 0));
  }
  .sm\\:focus\\:from-orange-600:focus {
    --gradient-from-color: #d03801;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(208, 56, 1, 0));
  }
  .sm\\:focus\\:from-orange-700:focus {
    --gradient-from-color: #b43403;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(180, 52, 3, 0));
  }
  .sm\\:focus\\:from-orange-800:focus {
    --gradient-from-color: #8a2c0d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(138, 44, 13, 0));
  }
  .sm\\:focus\\:from-orange-900:focus {
    --gradient-from-color: #73230d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(115, 35, 13, 0));
  }
  .sm\\:focus\\:from-yellow-50:focus {
    --gradient-from-color: #fdfdea;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 253, 234, 0));
  }
  .sm\\:focus\\:from-yellow-100:focus {
    --gradient-from-color: #fdf6b2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 246, 178, 0));
  }
  .sm\\:focus\\:from-yellow-200:focus {
    --gradient-from-color: #fce96a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(252, 233, 106, 0));
  }
  .sm\\:focus\\:from-yellow-300:focus {
    --gradient-from-color: #faca15;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(250, 202, 21, 0));
  }
  .sm\\:focus\\:from-yellow-400:focus {
    --gradient-from-color: #e3a008;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(227, 160, 8, 0));
  }
  .sm\\:focus\\:from-yellow-500:focus {
    --gradient-from-color: #c27803;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(194, 120, 3, 0));
  }
  .sm\\:focus\\:from-yellow-600:focus {
    --gradient-from-color: #9f580a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(159, 88, 10, 0));
  }
  .sm\\:focus\\:from-yellow-700:focus {
    --gradient-from-color: #8e4b10;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(142, 75, 16, 0));
  }
  .sm\\:focus\\:from-yellow-800:focus {
    --gradient-from-color: #723b13;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(114, 59, 19, 0));
  }
  .sm\\:focus\\:from-yellow-900:focus {
    --gradient-from-color: #633112;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(99, 49, 18, 0));
  }
  .sm\\:focus\\:from-green-50:focus {
    --gradient-from-color: #f3faf7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(243, 250, 247, 0));
  }
  .sm\\:focus\\:from-green-100:focus {
    --gradient-from-color: #def7ec;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(222, 247, 236, 0));
  }
  .sm\\:focus\\:from-green-200:focus {
    --gradient-from-color: #bcf0da;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(188, 240, 218, 0));
  }
  .sm\\:focus\\:from-green-300:focus {
    --gradient-from-color: #84e1bc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(132, 225, 188, 0));
  }
  .sm\\:focus\\:from-green-400:focus {
    --gradient-from-color: #31c48d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(49, 196, 141, 0));
  }
  .sm\\:focus\\:from-green-500:focus {
    --gradient-from-color: #0e9f6e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(14, 159, 110, 0));
  }
  .sm\\:focus\\:from-green-600:focus {
    --gradient-from-color: #057a55;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(5, 122, 85, 0));
  }
  .sm\\:focus\\:from-green-700:focus {
    --gradient-from-color: #046c4e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(4, 108, 78, 0));
  }
  .sm\\:focus\\:from-green-800:focus {
    --gradient-from-color: #03543f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(3, 84, 63, 0));
  }
  .sm\\:focus\\:from-green-900:focus {
    --gradient-from-color: #014737;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(1, 71, 55, 0));
  }
  .sm\\:focus\\:from-teal-50:focus {
    --gradient-from-color: #edfafa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(237, 250, 250, 0));
  }
  .sm\\:focus\\:from-teal-100:focus {
    --gradient-from-color: #d5f5f6;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(213, 245, 246, 0));
  }
  .sm\\:focus\\:from-teal-200:focus {
    --gradient-from-color: #afecef;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(175, 236, 239, 0));
  }
  .sm\\:focus\\:from-teal-300:focus {
    --gradient-from-color: #7edce2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(126, 220, 226, 0));
  }
  .sm\\:focus\\:from-teal-400:focus {
    --gradient-from-color: #16bdca;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(22, 189, 202, 0));
  }
  .sm\\:focus\\:from-teal-500:focus {
    --gradient-from-color: #0694a2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(6, 148, 162, 0));
  }
  .sm\\:focus\\:from-teal-600:focus {
    --gradient-from-color: #047481;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(4, 116, 129, 0));
  }
  .sm\\:focus\\:from-teal-700:focus {
    --gradient-from-color: #036672;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(3, 102, 114, 0));
  }
  .sm\\:focus\\:from-teal-800:focus {
    --gradient-from-color: #05505c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(5, 80, 92, 0));
  }
  .sm\\:focus\\:from-teal-900:focus {
    --gradient-from-color: #014451;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(1, 68, 81, 0));
  }
  .sm\\:focus\\:from-blue-50:focus {
    --gradient-from-color: #ebf5ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(235, 245, 255, 0));
  }
  .sm\\:focus\\:from-blue-100:focus {
    --gradient-from-color: #e1effe;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(225, 239, 254, 0));
  }
  .sm\\:focus\\:from-blue-200:focus {
    --gradient-from-color: #c3ddfd;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(195, 221, 253, 0));
  }
  .sm\\:focus\\:from-blue-300:focus {
    --gradient-from-color: #a4cafe;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(164, 202, 254, 0));
  }
  .sm\\:focus\\:from-blue-400:focus {
    --gradient-from-color: #76a9fa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(118, 169, 250, 0));
  }
  .sm\\:focus\\:from-blue-500:focus {
    --gradient-from-color: #3f83f8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(63, 131, 248, 0));
  }
  .sm\\:focus\\:from-blue-600:focus {
    --gradient-from-color: #1c64f2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(28, 100, 242, 0));
  }
  .sm\\:focus\\:from-blue-700:focus {
    --gradient-from-color: #1a56db;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(26, 86, 219, 0));
  }
  .sm\\:focus\\:from-blue-800:focus {
    --gradient-from-color: #1e429f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(30, 66, 159, 0));
  }
  .sm\\:focus\\:from-blue-900:focus {
    --gradient-from-color: #233876;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(35, 56, 118, 0));
  }
  .sm\\:focus\\:from-indigo-50:focus {
    --gradient-from-color: #f0f5ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(240, 245, 255, 0));
  }
  .sm\\:focus\\:from-indigo-100:focus {
    --gradient-from-color: #e5edff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(229, 237, 255, 0));
  }
  .sm\\:focus\\:from-indigo-200:focus {
    --gradient-from-color: #cddbfe;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(205, 219, 254, 0));
  }
  .sm\\:focus\\:from-indigo-300:focus {
    --gradient-from-color: #b4c6fc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(180, 198, 252, 0));
  }
  .sm\\:focus\\:from-indigo-400:focus {
    --gradient-from-color: #8da2fb;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(141, 162, 251, 0));
  }
  .sm\\:focus\\:from-indigo-500:focus {
    --gradient-from-color: #6875f5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(104, 117, 245, 0));
  }
  .sm\\:focus\\:from-indigo-600:focus {
    --gradient-from-color: #5850ec;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(88, 80, 236, 0));
  }
  .sm\\:focus\\:from-indigo-700:focus {
    --gradient-from-color: #5145cd;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(81, 69, 205, 0));
  }
  .sm\\:focus\\:from-indigo-800:focus {
    --gradient-from-color: #42389d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(66, 56, 157, 0));
  }
  .sm\\:focus\\:from-indigo-900:focus {
    --gradient-from-color: #362f78;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(54, 47, 120, 0));
  }
  .sm\\:focus\\:from-purple-50:focus {
    --gradient-from-color: #f6f5ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(246, 245, 255, 0));
  }
  .sm\\:focus\\:from-purple-100:focus {
    --gradient-from-color: #edebfe;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(237, 235, 254, 0));
  }
  .sm\\:focus\\:from-purple-200:focus {
    --gradient-from-color: #dcd7fe;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(220, 215, 254, 0));
  }
  .sm\\:focus\\:from-purple-300:focus {
    --gradient-from-color: #cabffd;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(202, 191, 253, 0));
  }
  .sm\\:focus\\:from-purple-400:focus {
    --gradient-from-color: #ac94fa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(172, 148, 250, 0));
  }
  .sm\\:focus\\:from-purple-500:focus {
    --gradient-from-color: #9061f9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(144, 97, 249, 0));
  }
  .sm\\:focus\\:from-purple-600:focus {
    --gradient-from-color: #7e3af2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(126, 58, 242, 0));
  }
  .sm\\:focus\\:from-purple-700:focus {
    --gradient-from-color: #6c2bd9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(108, 43, 217, 0));
  }
  .sm\\:focus\\:from-purple-800:focus {
    --gradient-from-color: #5521b5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(85, 33, 181, 0));
  }
  .sm\\:focus\\:from-purple-900:focus {
    --gradient-from-color: #4a1d96;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(74, 29, 150, 0));
  }
  .sm\\:focus\\:from-pink-50:focus {
    --gradient-from-color: #fdf2f8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 242, 248, 0));
  }
  .sm\\:focus\\:from-pink-100:focus {
    --gradient-from-color: #fce8f3;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(252, 232, 243, 0));
  }
  .sm\\:focus\\:from-pink-200:focus {
    --gradient-from-color: #fad1e8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(250, 209, 232, 0));
  }
  .sm\\:focus\\:from-pink-300:focus {
    --gradient-from-color: #f8b4d9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(248, 180, 217, 0));
  }
  .sm\\:focus\\:from-pink-400:focus {
    --gradient-from-color: #f17eb8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(241, 126, 184, 0));
  }
  .sm\\:focus\\:from-pink-500:focus {
    --gradient-from-color: #e74694;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(231, 70, 148, 0));
  }
  .sm\\:focus\\:from-pink-600:focus {
    --gradient-from-color: #d61f69;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(214, 31, 105, 0));
  }
  .sm\\:focus\\:from-pink-700:focus {
    --gradient-from-color: #bf125d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(191, 18, 93, 0));
  }
  .sm\\:focus\\:from-pink-800:focus {
    --gradient-from-color: #99154b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(153, 21, 75, 0));
  }
  .sm\\:focus\\:from-pink-900:focus {
    --gradient-from-color: #751a3d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(117, 26, 61, 0));
  }
  .sm\\:focus\\:from-cool-gray-50:focus {
    --gradient-from-color: #f8fafc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(248, 250, 252, 0));
  }
  .sm\\:focus\\:from-cool-gray-100:focus {
    --gradient-from-color: #f1f5f9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(241, 245, 249, 0));
  }
  .sm\\:focus\\:from-cool-gray-200:focus {
    --gradient-from-color: #e2e8f0;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(226, 232, 240, 0));
  }
  .sm\\:focus\\:from-cool-gray-300:focus {
    --gradient-from-color: #cfd8e3;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(207, 216, 227, 0));
  }
  .sm\\:focus\\:from-cool-gray-400:focus {
    --gradient-from-color: #97a6ba;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(151, 166, 186, 0));
  }
  .sm\\:focus\\:from-cool-gray-500:focus {
    --gradient-from-color: #64748b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(100, 116, 139, 0));
  }
  .sm\\:focus\\:from-cool-gray-600:focus {
    --gradient-from-color: #475569;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(71, 85, 105, 0));
  }
  .sm\\:focus\\:from-cool-gray-700:focus {
    --gradient-from-color: #364152;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(54, 65, 82, 0));
  }
  .sm\\:focus\\:from-cool-gray-800:focus {
    --gradient-from-color: #27303f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(39, 48, 63, 0));
  }
  .sm\\:focus\\:from-cool-gray-900:focus {
    --gradient-from-color: #1a202e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(26, 32, 46, 0));
  }
  .sm\\:focus\\:via-current:focus {
    --gradient-via-color: currentColor;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }
  .sm\\:focus\\:via-transparent:focus {
    --gradient-via-color: transparent;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  }
  .sm\\:focus\\:via-white:focus {
    --gradient-via-color: #ffffff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }
  .sm\\:focus\\:via-black:focus {
    --gradient-via-color: #000000;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  }
  .sm\\:focus\\:via-gray-50:focus {
    --gradient-via-color: #f9fafb;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(249, 250, 251, 0));
  }
  .sm\\:focus\\:via-gray-100:focus {
    --gradient-via-color: #f4f5f7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(244, 245, 247, 0));
  }
  .sm\\:focus\\:via-gray-200:focus {
    --gradient-via-color: #e5e7eb;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(229, 231, 235, 0));
  }
  .sm\\:focus\\:via-gray-300:focus {
    --gradient-via-color: #d2d6dc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(210, 214, 220, 0));
  }
  .sm\\:focus\\:via-gray-400:focus {
    --gradient-via-color: #9fa6b2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(159, 166, 178, 0));
  }
  .sm\\:focus\\:via-gray-500:focus {
    --gradient-via-color: #6b7280;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(107, 114, 128, 0));
  }
  .sm\\:focus\\:via-gray-600:focus {
    --gradient-via-color: #4b5563;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(75, 85, 99, 0));
  }
  .sm\\:focus\\:via-gray-700:focus {
    --gradient-via-color: #374151;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(55, 65, 81, 0));
  }
  .sm\\:focus\\:via-gray-800:focus {
    --gradient-via-color: #252f3f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(37, 47, 63, 0));
  }
  .sm\\:focus\\:via-gray-900:focus {
    --gradient-via-color: #161e2e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(22, 30, 46, 0));
  }
  .sm\\:focus\\:via-red-50:focus {
    --gradient-via-color: #fdf2f2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 242, 242, 0));
  }
  .sm\\:focus\\:via-red-100:focus {
    --gradient-via-color: #fde8e8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 232, 232, 0));
  }
  .sm\\:focus\\:via-red-200:focus {
    --gradient-via-color: #fbd5d5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(251, 213, 213, 0));
  }
  .sm\\:focus\\:via-red-300:focus {
    --gradient-via-color: #f8b4b4;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(248, 180, 180, 0));
  }
  .sm\\:focus\\:via-red-400:focus {
    --gradient-via-color: #f98080;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(249, 128, 128, 0));
  }
  .sm\\:focus\\:via-red-500:focus {
    --gradient-via-color: #f05252;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(240, 82, 82, 0));
  }
  .sm\\:focus\\:via-red-600:focus {
    --gradient-via-color: #e02424;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(224, 36, 36, 0));
  }
  .sm\\:focus\\:via-red-700:focus {
    --gradient-via-color: #c81e1e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(200, 30, 30, 0));
  }
  .sm\\:focus\\:via-red-800:focus {
    --gradient-via-color: #9b1c1c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(155, 28, 28, 0));
  }
  .sm\\:focus\\:via-red-900:focus {
    --gradient-via-color: #771d1d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(119, 29, 29, 0));
  }
  .sm\\:focus\\:via-orange-50:focus {
    --gradient-via-color: #fff8f1;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 248, 241, 0));
  }
  .sm\\:focus\\:via-orange-100:focus {
    --gradient-via-color: #feecdc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 236, 220, 0));
  }
  .sm\\:focus\\:via-orange-200:focus {
    --gradient-via-color: #fcd9bd;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(252, 217, 189, 0));
  }
  .sm\\:focus\\:via-orange-300:focus {
    --gradient-via-color: #fdba8c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 186, 140, 0));
  }
  .sm\\:focus\\:via-orange-400:focus {
    --gradient-via-color: #ff8a4c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 138, 76, 0));
  }
  .sm\\:focus\\:via-orange-500:focus {
    --gradient-via-color: #ff5a1f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 90, 31, 0));
  }
  .sm\\:focus\\:via-orange-600:focus {
    --gradient-via-color: #d03801;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(208, 56, 1, 0));
  }
  .sm\\:focus\\:via-orange-700:focus {
    --gradient-via-color: #b43403;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(180, 52, 3, 0));
  }
  .sm\\:focus\\:via-orange-800:focus {
    --gradient-via-color: #8a2c0d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(138, 44, 13, 0));
  }
  .sm\\:focus\\:via-orange-900:focus {
    --gradient-via-color: #73230d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(115, 35, 13, 0));
  }
  .sm\\:focus\\:via-yellow-50:focus {
    --gradient-via-color: #fdfdea;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 253, 234, 0));
  }
  .sm\\:focus\\:via-yellow-100:focus {
    --gradient-via-color: #fdf6b2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 246, 178, 0));
  }
  .sm\\:focus\\:via-yellow-200:focus {
    --gradient-via-color: #fce96a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(252, 233, 106, 0));
  }
  .sm\\:focus\\:via-yellow-300:focus {
    --gradient-via-color: #faca15;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(250, 202, 21, 0));
  }
  .sm\\:focus\\:via-yellow-400:focus {
    --gradient-via-color: #e3a008;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(227, 160, 8, 0));
  }
  .sm\\:focus\\:via-yellow-500:focus {
    --gradient-via-color: #c27803;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(194, 120, 3, 0));
  }
  .sm\\:focus\\:via-yellow-600:focus {
    --gradient-via-color: #9f580a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(159, 88, 10, 0));
  }
  .sm\\:focus\\:via-yellow-700:focus {
    --gradient-via-color: #8e4b10;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(142, 75, 16, 0));
  }
  .sm\\:focus\\:via-yellow-800:focus {
    --gradient-via-color: #723b13;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(114, 59, 19, 0));
  }
  .sm\\:focus\\:via-yellow-900:focus {
    --gradient-via-color: #633112;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(99, 49, 18, 0));
  }
  .sm\\:focus\\:via-green-50:focus {
    --gradient-via-color: #f3faf7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(243, 250, 247, 0));
  }
  .sm\\:focus\\:via-green-100:focus {
    --gradient-via-color: #def7ec;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(222, 247, 236, 0));
  }
  .sm\\:focus\\:via-green-200:focus {
    --gradient-via-color: #bcf0da;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(188, 240, 218, 0));
  }
  .sm\\:focus\\:via-green-300:focus {
    --gradient-via-color: #84e1bc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(132, 225, 188, 0));
  }
  .sm\\:focus\\:via-green-400:focus {
    --gradient-via-color: #31c48d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(49, 196, 141, 0));
  }
  .sm\\:focus\\:via-green-500:focus {
    --gradient-via-color: #0e9f6e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(14, 159, 110, 0));
  }
  .sm\\:focus\\:via-green-600:focus {
    --gradient-via-color: #057a55;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(5, 122, 85, 0));
  }
  .sm\\:focus\\:via-green-700:focus {
    --gradient-via-color: #046c4e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(4, 108, 78, 0));
  }
  .sm\\:focus\\:via-green-800:focus {
    --gradient-via-color: #03543f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(3, 84, 63, 0));
  }
  .sm\\:focus\\:via-green-900:focus {
    --gradient-via-color: #014737;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(1, 71, 55, 0));
  }
  .sm\\:focus\\:via-teal-50:focus {
    --gradient-via-color: #edfafa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(237, 250, 250, 0));
  }
  .sm\\:focus\\:via-teal-100:focus {
    --gradient-via-color: #d5f5f6;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(213, 245, 246, 0));
  }
  .sm\\:focus\\:via-teal-200:focus {
    --gradient-via-color: #afecef;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(175, 236, 239, 0));
  }
  .sm\\:focus\\:via-teal-300:focus {
    --gradient-via-color: #7edce2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(126, 220, 226, 0));
  }
  .sm\\:focus\\:via-teal-400:focus {
    --gradient-via-color: #16bdca;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(22, 189, 202, 0));
  }
  .sm\\:focus\\:via-teal-500:focus {
    --gradient-via-color: #0694a2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(6, 148, 162, 0));
  }
  .sm\\:focus\\:via-teal-600:focus {
    --gradient-via-color: #047481;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(4, 116, 129, 0));
  }
  .sm\\:focus\\:via-teal-700:focus {
    --gradient-via-color: #036672;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(3, 102, 114, 0));
  }
  .sm\\:focus\\:via-teal-800:focus {
    --gradient-via-color: #05505c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(5, 80, 92, 0));
  }
  .sm\\:focus\\:via-teal-900:focus {
    --gradient-via-color: #014451;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(1, 68, 81, 0));
  }
  .sm\\:focus\\:via-blue-50:focus {
    --gradient-via-color: #ebf5ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(235, 245, 255, 0));
  }
  .sm\\:focus\\:via-blue-100:focus {
    --gradient-via-color: #e1effe;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(225, 239, 254, 0));
  }
  .sm\\:focus\\:via-blue-200:focus {
    --gradient-via-color: #c3ddfd;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(195, 221, 253, 0));
  }
  .sm\\:focus\\:via-blue-300:focus {
    --gradient-via-color: #a4cafe;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(164, 202, 254, 0));
  }
  .sm\\:focus\\:via-blue-400:focus {
    --gradient-via-color: #76a9fa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(118, 169, 250, 0));
  }
  .sm\\:focus\\:via-blue-500:focus {
    --gradient-via-color: #3f83f8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(63, 131, 248, 0));
  }
  .sm\\:focus\\:via-blue-600:focus {
    --gradient-via-color: #1c64f2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(28, 100, 242, 0));
  }
  .sm\\:focus\\:via-blue-700:focus {
    --gradient-via-color: #1a56db;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(26, 86, 219, 0));
  }
  .sm\\:focus\\:via-blue-800:focus {
    --gradient-via-color: #1e429f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(30, 66, 159, 0));
  }
  .sm\\:focus\\:via-blue-900:focus {
    --gradient-via-color: #233876;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(35, 56, 118, 0));
  }
  .sm\\:focus\\:via-indigo-50:focus {
    --gradient-via-color: #f0f5ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(240, 245, 255, 0));
  }
  .sm\\:focus\\:via-indigo-100:focus {
    --gradient-via-color: #e5edff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(229, 237, 255, 0));
  }
  .sm\\:focus\\:via-indigo-200:focus {
    --gradient-via-color: #cddbfe;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(205, 219, 254, 0));
  }
  .sm\\:focus\\:via-indigo-300:focus {
    --gradient-via-color: #b4c6fc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(180, 198, 252, 0));
  }
  .sm\\:focus\\:via-indigo-400:focus {
    --gradient-via-color: #8da2fb;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(141, 162, 251, 0));
  }
  .sm\\:focus\\:via-indigo-500:focus {
    --gradient-via-color: #6875f5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(104, 117, 245, 0));
  }
  .sm\\:focus\\:via-indigo-600:focus {
    --gradient-via-color: #5850ec;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(88, 80, 236, 0));
  }
  .sm\\:focus\\:via-indigo-700:focus {
    --gradient-via-color: #5145cd;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(81, 69, 205, 0));
  }
  .sm\\:focus\\:via-indigo-800:focus {
    --gradient-via-color: #42389d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(66, 56, 157, 0));
  }
  .sm\\:focus\\:via-indigo-900:focus {
    --gradient-via-color: #362f78;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(54, 47, 120, 0));
  }
  .sm\\:focus\\:via-purple-50:focus {
    --gradient-via-color: #f6f5ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(246, 245, 255, 0));
  }
  .sm\\:focus\\:via-purple-100:focus {
    --gradient-via-color: #edebfe;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(237, 235, 254, 0));
  }
  .sm\\:focus\\:via-purple-200:focus {
    --gradient-via-color: #dcd7fe;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(220, 215, 254, 0));
  }
  .sm\\:focus\\:via-purple-300:focus {
    --gradient-via-color: #cabffd;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(202, 191, 253, 0));
  }
  .sm\\:focus\\:via-purple-400:focus {
    --gradient-via-color: #ac94fa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(172, 148, 250, 0));
  }
  .sm\\:focus\\:via-purple-500:focus {
    --gradient-via-color: #9061f9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(144, 97, 249, 0));
  }
  .sm\\:focus\\:via-purple-600:focus {
    --gradient-via-color: #7e3af2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(126, 58, 242, 0));
  }
  .sm\\:focus\\:via-purple-700:focus {
    --gradient-via-color: #6c2bd9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(108, 43, 217, 0));
  }
  .sm\\:focus\\:via-purple-800:focus {
    --gradient-via-color: #5521b5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(85, 33, 181, 0));
  }
  .sm\\:focus\\:via-purple-900:focus {
    --gradient-via-color: #4a1d96;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(74, 29, 150, 0));
  }
  .sm\\:focus\\:via-pink-50:focus {
    --gradient-via-color: #fdf2f8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 242, 248, 0));
  }
  .sm\\:focus\\:via-pink-100:focus {
    --gradient-via-color: #fce8f3;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(252, 232, 243, 0));
  }
  .sm\\:focus\\:via-pink-200:focus {
    --gradient-via-color: #fad1e8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(250, 209, 232, 0));
  }
  .sm\\:focus\\:via-pink-300:focus {
    --gradient-via-color: #f8b4d9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(248, 180, 217, 0));
  }
  .sm\\:focus\\:via-pink-400:focus {
    --gradient-via-color: #f17eb8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(241, 126, 184, 0));
  }
  .sm\\:focus\\:via-pink-500:focus {
    --gradient-via-color: #e74694;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(231, 70, 148, 0));
  }
  .sm\\:focus\\:via-pink-600:focus {
    --gradient-via-color: #d61f69;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(214, 31, 105, 0));
  }
  .sm\\:focus\\:via-pink-700:focus {
    --gradient-via-color: #bf125d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(191, 18, 93, 0));
  }
  .sm\\:focus\\:via-pink-800:focus {
    --gradient-via-color: #99154b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(153, 21, 75, 0));
  }
  .sm\\:focus\\:via-pink-900:focus {
    --gradient-via-color: #751a3d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(117, 26, 61, 0));
  }
  .sm\\:focus\\:via-cool-gray-50:focus {
    --gradient-via-color: #f8fafc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(248, 250, 252, 0));
  }
  .sm\\:focus\\:via-cool-gray-100:focus {
    --gradient-via-color: #f1f5f9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(241, 245, 249, 0));
  }
  .sm\\:focus\\:via-cool-gray-200:focus {
    --gradient-via-color: #e2e8f0;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(226, 232, 240, 0));
  }
  .sm\\:focus\\:via-cool-gray-300:focus {
    --gradient-via-color: #cfd8e3;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(207, 216, 227, 0));
  }
  .sm\\:focus\\:via-cool-gray-400:focus {
    --gradient-via-color: #97a6ba;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(151, 166, 186, 0));
  }
  .sm\\:focus\\:via-cool-gray-500:focus {
    --gradient-via-color: #64748b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(100, 116, 139, 0));
  }
  .sm\\:focus\\:via-cool-gray-600:focus {
    --gradient-via-color: #475569;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(71, 85, 105, 0));
  }
  .sm\\:focus\\:via-cool-gray-700:focus {
    --gradient-via-color: #364152;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(54, 65, 82, 0));
  }
  .sm\\:focus\\:via-cool-gray-800:focus {
    --gradient-via-color: #27303f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(39, 48, 63, 0));
  }
  .sm\\:focus\\:via-cool-gray-900:focus {
    --gradient-via-color: #1a202e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(26, 32, 46, 0));
  }
  .sm\\:focus\\:to-current:focus {
    --gradient-to-color: currentColor;
  }
  .sm\\:focus\\:to-transparent:focus {
    --gradient-to-color: transparent;
  }
  .sm\\:focus\\:to-white:focus {
    --gradient-to-color: #ffffff;
  }
  .sm\\:focus\\:to-black:focus {
    --gradient-to-color: #000000;
  }
  .sm\\:focus\\:to-gray-50:focus {
    --gradient-to-color: #f9fafb;
  }
  .sm\\:focus\\:to-gray-100:focus {
    --gradient-to-color: #f4f5f7;
  }
  .sm\\:focus\\:to-gray-200:focus {
    --gradient-to-color: #e5e7eb;
  }
  .sm\\:focus\\:to-gray-300:focus {
    --gradient-to-color: #d2d6dc;
  }
  .sm\\:focus\\:to-gray-400:focus {
    --gradient-to-color: #9fa6b2;
  }
  .sm\\:focus\\:to-gray-500:focus {
    --gradient-to-color: #6b7280;
  }
  .sm\\:focus\\:to-gray-600:focus {
    --gradient-to-color: #4b5563;
  }
  .sm\\:focus\\:to-gray-700:focus {
    --gradient-to-color: #374151;
  }
  .sm\\:focus\\:to-gray-800:focus {
    --gradient-to-color: #252f3f;
  }
  .sm\\:focus\\:to-gray-900:focus {
    --gradient-to-color: #161e2e;
  }
  .sm\\:focus\\:to-red-50:focus {
    --gradient-to-color: #fdf2f2;
  }
  .sm\\:focus\\:to-red-100:focus {
    --gradient-to-color: #fde8e8;
  }
  .sm\\:focus\\:to-red-200:focus {
    --gradient-to-color: #fbd5d5;
  }
  .sm\\:focus\\:to-red-300:focus {
    --gradient-to-color: #f8b4b4;
  }
  .sm\\:focus\\:to-red-400:focus {
    --gradient-to-color: #f98080;
  }
  .sm\\:focus\\:to-red-500:focus {
    --gradient-to-color: #f05252;
  }
  .sm\\:focus\\:to-red-600:focus {
    --gradient-to-color: #e02424;
  }
  .sm\\:focus\\:to-red-700:focus {
    --gradient-to-color: #c81e1e;
  }
  .sm\\:focus\\:to-red-800:focus {
    --gradient-to-color: #9b1c1c;
  }
  .sm\\:focus\\:to-red-900:focus {
    --gradient-to-color: #771d1d;
  }
  .sm\\:focus\\:to-orange-50:focus {
    --gradient-to-color: #fff8f1;
  }
  .sm\\:focus\\:to-orange-100:focus {
    --gradient-to-color: #feecdc;
  }
  .sm\\:focus\\:to-orange-200:focus {
    --gradient-to-color: #fcd9bd;
  }
  .sm\\:focus\\:to-orange-300:focus {
    --gradient-to-color: #fdba8c;
  }
  .sm\\:focus\\:to-orange-400:focus {
    --gradient-to-color: #ff8a4c;
  }
  .sm\\:focus\\:to-orange-500:focus {
    --gradient-to-color: #ff5a1f;
  }
  .sm\\:focus\\:to-orange-600:focus {
    --gradient-to-color: #d03801;
  }
  .sm\\:focus\\:to-orange-700:focus {
    --gradient-to-color: #b43403;
  }
  .sm\\:focus\\:to-orange-800:focus {
    --gradient-to-color: #8a2c0d;
  }
  .sm\\:focus\\:to-orange-900:focus {
    --gradient-to-color: #73230d;
  }
  .sm\\:focus\\:to-yellow-50:focus {
    --gradient-to-color: #fdfdea;
  }
  .sm\\:focus\\:to-yellow-100:focus {
    --gradient-to-color: #fdf6b2;
  }
  .sm\\:focus\\:to-yellow-200:focus {
    --gradient-to-color: #fce96a;
  }
  .sm\\:focus\\:to-yellow-300:focus {
    --gradient-to-color: #faca15;
  }
  .sm\\:focus\\:to-yellow-400:focus {
    --gradient-to-color: #e3a008;
  }
  .sm\\:focus\\:to-yellow-500:focus {
    --gradient-to-color: #c27803;
  }
  .sm\\:focus\\:to-yellow-600:focus {
    --gradient-to-color: #9f580a;
  }
  .sm\\:focus\\:to-yellow-700:focus {
    --gradient-to-color: #8e4b10;
  }
  .sm\\:focus\\:to-yellow-800:focus {
    --gradient-to-color: #723b13;
  }
  .sm\\:focus\\:to-yellow-900:focus {
    --gradient-to-color: #633112;
  }
  .sm\\:focus\\:to-green-50:focus {
    --gradient-to-color: #f3faf7;
  }
  .sm\\:focus\\:to-green-100:focus {
    --gradient-to-color: #def7ec;
  }
  .sm\\:focus\\:to-green-200:focus {
    --gradient-to-color: #bcf0da;
  }
  .sm\\:focus\\:to-green-300:focus {
    --gradient-to-color: #84e1bc;
  }
  .sm\\:focus\\:to-green-400:focus {
    --gradient-to-color: #31c48d;
  }
  .sm\\:focus\\:to-green-500:focus {
    --gradient-to-color: #0e9f6e;
  }
  .sm\\:focus\\:to-green-600:focus {
    --gradient-to-color: #057a55;
  }
  .sm\\:focus\\:to-green-700:focus {
    --gradient-to-color: #046c4e;
  }
  .sm\\:focus\\:to-green-800:focus {
    --gradient-to-color: #03543f;
  }
  .sm\\:focus\\:to-green-900:focus {
    --gradient-to-color: #014737;
  }
  .sm\\:focus\\:to-teal-50:focus {
    --gradient-to-color: #edfafa;
  }
  .sm\\:focus\\:to-teal-100:focus {
    --gradient-to-color: #d5f5f6;
  }
  .sm\\:focus\\:to-teal-200:focus {
    --gradient-to-color: #afecef;
  }
  .sm\\:focus\\:to-teal-300:focus {
    --gradient-to-color: #7edce2;
  }
  .sm\\:focus\\:to-teal-400:focus {
    --gradient-to-color: #16bdca;
  }
  .sm\\:focus\\:to-teal-500:focus {
    --gradient-to-color: #0694a2;
  }
  .sm\\:focus\\:to-teal-600:focus {
    --gradient-to-color: #047481;
  }
  .sm\\:focus\\:to-teal-700:focus {
    --gradient-to-color: #036672;
  }
  .sm\\:focus\\:to-teal-800:focus {
    --gradient-to-color: #05505c;
  }
  .sm\\:focus\\:to-teal-900:focus {
    --gradient-to-color: #014451;
  }
  .sm\\:focus\\:to-blue-50:focus {
    --gradient-to-color: #ebf5ff;
  }
  .sm\\:focus\\:to-blue-100:focus {
    --gradient-to-color: #e1effe;
  }
  .sm\\:focus\\:to-blue-200:focus {
    --gradient-to-color: #c3ddfd;
  }
  .sm\\:focus\\:to-blue-300:focus {
    --gradient-to-color: #a4cafe;
  }
  .sm\\:focus\\:to-blue-400:focus {
    --gradient-to-color: #76a9fa;
  }
  .sm\\:focus\\:to-blue-500:focus {
    --gradient-to-color: #3f83f8;
  }
  .sm\\:focus\\:to-blue-600:focus {
    --gradient-to-color: #1c64f2;
  }
  .sm\\:focus\\:to-blue-700:focus {
    --gradient-to-color: #1a56db;
  }
  .sm\\:focus\\:to-blue-800:focus {
    --gradient-to-color: #1e429f;
  }
  .sm\\:focus\\:to-blue-900:focus {
    --gradient-to-color: #233876;
  }
  .sm\\:focus\\:to-indigo-50:focus {
    --gradient-to-color: #f0f5ff;
  }
  .sm\\:focus\\:to-indigo-100:focus {
    --gradient-to-color: #e5edff;
  }
  .sm\\:focus\\:to-indigo-200:focus {
    --gradient-to-color: #cddbfe;
  }
  .sm\\:focus\\:to-indigo-300:focus {
    --gradient-to-color: #b4c6fc;
  }
  .sm\\:focus\\:to-indigo-400:focus {
    --gradient-to-color: #8da2fb;
  }
  .sm\\:focus\\:to-indigo-500:focus {
    --gradient-to-color: #6875f5;
  }
  .sm\\:focus\\:to-indigo-600:focus {
    --gradient-to-color: #5850ec;
  }
  .sm\\:focus\\:to-indigo-700:focus {
    --gradient-to-color: #5145cd;
  }
  .sm\\:focus\\:to-indigo-800:focus {
    --gradient-to-color: #42389d;
  }
  .sm\\:focus\\:to-indigo-900:focus {
    --gradient-to-color: #362f78;
  }
  .sm\\:focus\\:to-purple-50:focus {
    --gradient-to-color: #f6f5ff;
  }
  .sm\\:focus\\:to-purple-100:focus {
    --gradient-to-color: #edebfe;
  }
  .sm\\:focus\\:to-purple-200:focus {
    --gradient-to-color: #dcd7fe;
  }
  .sm\\:focus\\:to-purple-300:focus {
    --gradient-to-color: #cabffd;
  }
  .sm\\:focus\\:to-purple-400:focus {
    --gradient-to-color: #ac94fa;
  }
  .sm\\:focus\\:to-purple-500:focus {
    --gradient-to-color: #9061f9;
  }
  .sm\\:focus\\:to-purple-600:focus {
    --gradient-to-color: #7e3af2;
  }
  .sm\\:focus\\:to-purple-700:focus {
    --gradient-to-color: #6c2bd9;
  }
  .sm\\:focus\\:to-purple-800:focus {
    --gradient-to-color: #5521b5;
  }
  .sm\\:focus\\:to-purple-900:focus {
    --gradient-to-color: #4a1d96;
  }
  .sm\\:focus\\:to-pink-50:focus {
    --gradient-to-color: #fdf2f8;
  }
  .sm\\:focus\\:to-pink-100:focus {
    --gradient-to-color: #fce8f3;
  }
  .sm\\:focus\\:to-pink-200:focus {
    --gradient-to-color: #fad1e8;
  }
  .sm\\:focus\\:to-pink-300:focus {
    --gradient-to-color: #f8b4d9;
  }
  .sm\\:focus\\:to-pink-400:focus {
    --gradient-to-color: #f17eb8;
  }
  .sm\\:focus\\:to-pink-500:focus {
    --gradient-to-color: #e74694;
  }
  .sm\\:focus\\:to-pink-600:focus {
    --gradient-to-color: #d61f69;
  }
  .sm\\:focus\\:to-pink-700:focus {
    --gradient-to-color: #bf125d;
  }
  .sm\\:focus\\:to-pink-800:focus {
    --gradient-to-color: #99154b;
  }
  .sm\\:focus\\:to-pink-900:focus {
    --gradient-to-color: #751a3d;
  }
  .sm\\:focus\\:to-cool-gray-50:focus {
    --gradient-to-color: #f8fafc;
  }
  .sm\\:focus\\:to-cool-gray-100:focus {
    --gradient-to-color: #f1f5f9;
  }
  .sm\\:focus\\:to-cool-gray-200:focus {
    --gradient-to-color: #e2e8f0;
  }
  .sm\\:focus\\:to-cool-gray-300:focus {
    --gradient-to-color: #cfd8e3;
  }
  .sm\\:focus\\:to-cool-gray-400:focus {
    --gradient-to-color: #97a6ba;
  }
  .sm\\:focus\\:to-cool-gray-500:focus {
    --gradient-to-color: #64748b;
  }
  .sm\\:focus\\:to-cool-gray-600:focus {
    --gradient-to-color: #475569;
  }
  .sm\\:focus\\:to-cool-gray-700:focus {
    --gradient-to-color: #364152;
  }
  .sm\\:focus\\:to-cool-gray-800:focus {
    --gradient-to-color: #27303f;
  }
  .sm\\:focus\\:to-cool-gray-900:focus {
    --gradient-to-color: #1a202e;
  }
  .sm\\:bg-opacity-0 {
    --bg-opacity: 0;
  }
  .sm\\:bg-opacity-25 {
    --bg-opacity: 0.25;
  }
  .sm\\:bg-opacity-50 {
    --bg-opacity: 0.5;
  }
  .sm\\:bg-opacity-75 {
    --bg-opacity: 0.75;
  }
  .sm\\:bg-opacity-100 {
    --bg-opacity: 1;
  }
  .sm\\:hover\\:bg-opacity-0:hover {
    --bg-opacity: 0;
  }
  .sm\\:hover\\:bg-opacity-25:hover {
    --bg-opacity: 0.25;
  }
  .sm\\:hover\\:bg-opacity-50:hover {
    --bg-opacity: 0.5;
  }
  .sm\\:hover\\:bg-opacity-75:hover {
    --bg-opacity: 0.75;
  }
  .sm\\:hover\\:bg-opacity-100:hover {
    --bg-opacity: 1;
  }
  .sm\\:focus\\:bg-opacity-0:focus {
    --bg-opacity: 0;
  }
  .sm\\:focus\\:bg-opacity-25:focus {
    --bg-opacity: 0.25;
  }
  .sm\\:focus\\:bg-opacity-50:focus {
    --bg-opacity: 0.5;
  }
  .sm\\:focus\\:bg-opacity-75:focus {
    --bg-opacity: 0.75;
  }
  .sm\\:focus\\:bg-opacity-100:focus {
    --bg-opacity: 1;
  }
  .sm\\:bg-bottom {
    background-position: bottom;
  }
  .sm\\:bg-center {
    background-position: center;
  }
  .sm\\:bg-left {
    background-position: left;
  }
  .sm\\:bg-left-bottom {
    background-position: left bottom;
  }
  .sm\\:bg-left-top {
    background-position: left top;
  }
  .sm\\:bg-right {
    background-position: right;
  }
  .sm\\:bg-right-bottom {
    background-position: right bottom;
  }
  .sm\\:bg-right-top {
    background-position: right top;
  }
  .sm\\:bg-top {
    background-position: top;
  }
  .sm\\:bg-repeat {
    background-repeat: repeat;
  }
  .sm\\:bg-no-repeat {
    background-repeat: no-repeat;
  }
  .sm\\:bg-repeat-x {
    background-repeat: repeat-x;
  }
  .sm\\:bg-repeat-y {
    background-repeat: repeat-y;
  }
  .sm\\:bg-repeat-round {
    background-repeat: round;
  }
  .sm\\:bg-repeat-space {
    background-repeat: space;
  }
  .sm\\:bg-auto {
    background-size: auto;
  }
  .sm\\:bg-cover {
    background-size: cover;
  }
  .sm\\:bg-contain {
    background-size: contain;
  }
  .sm\\:border-collapse {
    border-collapse: collapse;
  }
  .sm\\:border-separate {
    border-collapse: separate;
  }
  .sm\\:border-current {
    border-color: currentColor;
  }
  .sm\\:border-transparent {
    border-color: transparent;
  }
  .sm\\:border-white {
    --border-opacity: 1;
    border-color: #ffffff;
    border-color: rgba(255, 255, 255, var(--border-opacity));
  }
  .sm\\:border-black {
    --border-opacity: 1;
    border-color: #000000;
    border-color: rgba(0, 0, 0, var(--border-opacity));
  }
  .sm\\:border-gray-50 {
    --border-opacity: 1;
    border-color: #f9fafb;
    border-color: rgba(249, 250, 251, var(--border-opacity));
  }
  .sm\\:border-gray-100 {
    --border-opacity: 1;
    border-color: #f4f5f7;
    border-color: rgba(244, 245, 247, var(--border-opacity));
  }
  .sm\\:border-gray-200 {
    --border-opacity: 1;
    border-color: #e5e7eb;
    border-color: rgba(229, 231, 235, var(--border-opacity));
  }
  .sm\\:border-gray-300 {
    --border-opacity: 1;
    border-color: #d2d6dc;
    border-color: rgba(210, 214, 220, var(--border-opacity));
  }
  .sm\\:border-gray-400 {
    --border-opacity: 1;
    border-color: #9fa6b2;
    border-color: rgba(159, 166, 178, var(--border-opacity));
  }
  .sm\\:border-gray-500 {
    --border-opacity: 1;
    border-color: #6b7280;
    border-color: rgba(107, 114, 128, var(--border-opacity));
  }
  .sm\\:border-gray-600 {
    --border-opacity: 1;
    border-color: #4b5563;
    border-color: rgba(75, 85, 99, var(--border-opacity));
  }
  .sm\\:border-gray-700 {
    --border-opacity: 1;
    border-color: #374151;
    border-color: rgba(55, 65, 81, var(--border-opacity));
  }
  .sm\\:border-gray-800 {
    --border-opacity: 1;
    border-color: #252f3f;
    border-color: rgba(37, 47, 63, var(--border-opacity));
  }
  .sm\\:border-gray-900 {
    --border-opacity: 1;
    border-color: #161e2e;
    border-color: rgba(22, 30, 46, var(--border-opacity));
  }
  .sm\\:border-red-50 {
    --border-opacity: 1;
    border-color: #fdf2f2;
    border-color: rgba(253, 242, 242, var(--border-opacity));
  }
  .sm\\:border-red-100 {
    --border-opacity: 1;
    border-color: #fde8e8;
    border-color: rgba(253, 232, 232, var(--border-opacity));
  }
  .sm\\:border-red-200 {
    --border-opacity: 1;
    border-color: #fbd5d5;
    border-color: rgba(251, 213, 213, var(--border-opacity));
  }
  .sm\\:border-red-300 {
    --border-opacity: 1;
    border-color: #f8b4b4;
    border-color: rgba(248, 180, 180, var(--border-opacity));
  }
  .sm\\:border-red-400 {
    --border-opacity: 1;
    border-color: #f98080;
    border-color: rgba(249, 128, 128, var(--border-opacity));
  }
  .sm\\:border-red-500 {
    --border-opacity: 1;
    border-color: #f05252;
    border-color: rgba(240, 82, 82, var(--border-opacity));
  }
  .sm\\:border-red-600 {
    --border-opacity: 1;
    border-color: #e02424;
    border-color: rgba(224, 36, 36, var(--border-opacity));
  }
  .sm\\:border-red-700 {
    --border-opacity: 1;
    border-color: #c81e1e;
    border-color: rgba(200, 30, 30, var(--border-opacity));
  }
  .sm\\:border-red-800 {
    --border-opacity: 1;
    border-color: #9b1c1c;
    border-color: rgba(155, 28, 28, var(--border-opacity));
  }
  .sm\\:border-red-900 {
    --border-opacity: 1;
    border-color: #771d1d;
    border-color: rgba(119, 29, 29, var(--border-opacity));
  }
  .sm\\:border-orange-50 {
    --border-opacity: 1;
    border-color: #fff8f1;
    border-color: rgba(255, 248, 241, var(--border-opacity));
  }
  .sm\\:border-orange-100 {
    --border-opacity: 1;
    border-color: #feecdc;
    border-color: rgba(254, 236, 220, var(--border-opacity));
  }
  .sm\\:border-orange-200 {
    --border-opacity: 1;
    border-color: #fcd9bd;
    border-color: rgba(252, 217, 189, var(--border-opacity));
  }
  .sm\\:border-orange-300 {
    --border-opacity: 1;
    border-color: #fdba8c;
    border-color: rgba(253, 186, 140, var(--border-opacity));
  }
  .sm\\:border-orange-400 {
    --border-opacity: 1;
    border-color: #ff8a4c;
    border-color: rgba(255, 138, 76, var(--border-opacity));
  }
  .sm\\:border-orange-500 {
    --border-opacity: 1;
    border-color: #ff5a1f;
    border-color: rgba(255, 90, 31, var(--border-opacity));
  }
  .sm\\:border-orange-600 {
    --border-opacity: 1;
    border-color: #d03801;
    border-color: rgba(208, 56, 1, var(--border-opacity));
  }
  .sm\\:border-orange-700 {
    --border-opacity: 1;
    border-color: #b43403;
    border-color: rgba(180, 52, 3, var(--border-opacity));
  }
  .sm\\:border-orange-800 {
    --border-opacity: 1;
    border-color: #8a2c0d;
    border-color: rgba(138, 44, 13, var(--border-opacity));
  }
  .sm\\:border-orange-900 {
    --border-opacity: 1;
    border-color: #73230d;
    border-color: rgba(115, 35, 13, var(--border-opacity));
  }
  .sm\\:border-yellow-50 {
    --border-opacity: 1;
    border-color: #fdfdea;
    border-color: rgba(253, 253, 234, var(--border-opacity));
  }
  .sm\\:border-yellow-100 {
    --border-opacity: 1;
    border-color: #fdf6b2;
    border-color: rgba(253, 246, 178, var(--border-opacity));
  }
  .sm\\:border-yellow-200 {
    --border-opacity: 1;
    border-color: #fce96a;
    border-color: rgba(252, 233, 106, var(--border-opacity));
  }
  .sm\\:border-yellow-300 {
    --border-opacity: 1;
    border-color: #faca15;
    border-color: rgba(250, 202, 21, var(--border-opacity));
  }
  .sm\\:border-yellow-400 {
    --border-opacity: 1;
    border-color: #e3a008;
    border-color: rgba(227, 160, 8, var(--border-opacity));
  }
  .sm\\:border-yellow-500 {
    --border-opacity: 1;
    border-color: #c27803;
    border-color: rgba(194, 120, 3, var(--border-opacity));
  }
  .sm\\:border-yellow-600 {
    --border-opacity: 1;
    border-color: #9f580a;
    border-color: rgba(159, 88, 10, var(--border-opacity));
  }
  .sm\\:border-yellow-700 {
    --border-opacity: 1;
    border-color: #8e4b10;
    border-color: rgba(142, 75, 16, var(--border-opacity));
  }
  .sm\\:border-yellow-800 {
    --border-opacity: 1;
    border-color: #723b13;
    border-color: rgba(114, 59, 19, var(--border-opacity));
  }
  .sm\\:border-yellow-900 {
    --border-opacity: 1;
    border-color: #633112;
    border-color: rgba(99, 49, 18, var(--border-opacity));
  }
  .sm\\:border-green-50 {
    --border-opacity: 1;
    border-color: #f3faf7;
    border-color: rgba(243, 250, 247, var(--border-opacity));
  }
  .sm\\:border-green-100 {
    --border-opacity: 1;
    border-color: #def7ec;
    border-color: rgba(222, 247, 236, var(--border-opacity));
  }
  .sm\\:border-green-200 {
    --border-opacity: 1;
    border-color: #bcf0da;
    border-color: rgba(188, 240, 218, var(--border-opacity));
  }
  .sm\\:border-green-300 {
    --border-opacity: 1;
    border-color: #84e1bc;
    border-color: rgba(132, 225, 188, var(--border-opacity));
  }
  .sm\\:border-green-400 {
    --border-opacity: 1;
    border-color: #31c48d;
    border-color: rgba(49, 196, 141, var(--border-opacity));
  }
  .sm\\:border-green-500 {
    --border-opacity: 1;
    border-color: #0e9f6e;
    border-color: rgba(14, 159, 110, var(--border-opacity));
  }
  .sm\\:border-green-600 {
    --border-opacity: 1;
    border-color: #057a55;
    border-color: rgba(5, 122, 85, var(--border-opacity));
  }
  .sm\\:border-green-700 {
    --border-opacity: 1;
    border-color: #046c4e;
    border-color: rgba(4, 108, 78, var(--border-opacity));
  }
  .sm\\:border-green-800 {
    --border-opacity: 1;
    border-color: #03543f;
    border-color: rgba(3, 84, 63, var(--border-opacity));
  }
  .sm\\:border-green-900 {
    --border-opacity: 1;
    border-color: #014737;
    border-color: rgba(1, 71, 55, var(--border-opacity));
  }
  .sm\\:border-teal-50 {
    --border-opacity: 1;
    border-color: #edfafa;
    border-color: rgba(237, 250, 250, var(--border-opacity));
  }
  .sm\\:border-teal-100 {
    --border-opacity: 1;
    border-color: #d5f5f6;
    border-color: rgba(213, 245, 246, var(--border-opacity));
  }
  .sm\\:border-teal-200 {
    --border-opacity: 1;
    border-color: #afecef;
    border-color: rgba(175, 236, 239, var(--border-opacity));
  }
  .sm\\:border-teal-300 {
    --border-opacity: 1;
    border-color: #7edce2;
    border-color: rgba(126, 220, 226, var(--border-opacity));
  }
  .sm\\:border-teal-400 {
    --border-opacity: 1;
    border-color: #16bdca;
    border-color: rgba(22, 189, 202, var(--border-opacity));
  }
  .sm\\:border-teal-500 {
    --border-opacity: 1;
    border-color: #0694a2;
    border-color: rgba(6, 148, 162, var(--border-opacity));
  }
  .sm\\:border-teal-600 {
    --border-opacity: 1;
    border-color: #047481;
    border-color: rgba(4, 116, 129, var(--border-opacity));
  }
  .sm\\:border-teal-700 {
    --border-opacity: 1;
    border-color: #036672;
    border-color: rgba(3, 102, 114, var(--border-opacity));
  }
  .sm\\:border-teal-800 {
    --border-opacity: 1;
    border-color: #05505c;
    border-color: rgba(5, 80, 92, var(--border-opacity));
  }
  .sm\\:border-teal-900 {
    --border-opacity: 1;
    border-color: #014451;
    border-color: rgba(1, 68, 81, var(--border-opacity));
  }
  .sm\\:border-blue-50 {
    --border-opacity: 1;
    border-color: #ebf5ff;
    border-color: rgba(235, 245, 255, var(--border-opacity));
  }
  .sm\\:border-blue-100 {
    --border-opacity: 1;
    border-color: #e1effe;
    border-color: rgba(225, 239, 254, var(--border-opacity));
  }
  .sm\\:border-blue-200 {
    --border-opacity: 1;
    border-color: #c3ddfd;
    border-color: rgba(195, 221, 253, var(--border-opacity));
  }
  .sm\\:border-blue-300 {
    --border-opacity: 1;
    border-color: #a4cafe;
    border-color: rgba(164, 202, 254, var(--border-opacity));
  }
  .sm\\:border-blue-400 {
    --border-opacity: 1;
    border-color: #76a9fa;
    border-color: rgba(118, 169, 250, var(--border-opacity));
  }
  .sm\\:border-blue-500 {
    --border-opacity: 1;
    border-color: #3f83f8;
    border-color: rgba(63, 131, 248, var(--border-opacity));
  }
  .sm\\:border-blue-600 {
    --border-opacity: 1;
    border-color: #1c64f2;
    border-color: rgba(28, 100, 242, var(--border-opacity));
  }
  .sm\\:border-blue-700 {
    --border-opacity: 1;
    border-color: #1a56db;
    border-color: rgba(26, 86, 219, var(--border-opacity));
  }
  .sm\\:border-blue-800 {
    --border-opacity: 1;
    border-color: #1e429f;
    border-color: rgba(30, 66, 159, var(--border-opacity));
  }
  .sm\\:border-blue-900 {
    --border-opacity: 1;
    border-color: #233876;
    border-color: rgba(35, 56, 118, var(--border-opacity));
  }
  .sm\\:border-indigo-50 {
    --border-opacity: 1;
    border-color: #f0f5ff;
    border-color: rgba(240, 245, 255, var(--border-opacity));
  }
  .sm\\:border-indigo-100 {
    --border-opacity: 1;
    border-color: #e5edff;
    border-color: rgba(229, 237, 255, var(--border-opacity));
  }
  .sm\\:border-indigo-200 {
    --border-opacity: 1;
    border-color: #cddbfe;
    border-color: rgba(205, 219, 254, var(--border-opacity));
  }
  .sm\\:border-indigo-300 {
    --border-opacity: 1;
    border-color: #b4c6fc;
    border-color: rgba(180, 198, 252, var(--border-opacity));
  }
  .sm\\:border-indigo-400 {
    --border-opacity: 1;
    border-color: #8da2fb;
    border-color: rgba(141, 162, 251, var(--border-opacity));
  }
  .sm\\:border-indigo-500 {
    --border-opacity: 1;
    border-color: #6875f5;
    border-color: rgba(104, 117, 245, var(--border-opacity));
  }
  .sm\\:border-indigo-600 {
    --border-opacity: 1;
    border-color: #5850ec;
    border-color: rgba(88, 80, 236, var(--border-opacity));
  }
  .sm\\:border-indigo-700 {
    --border-opacity: 1;
    border-color: #5145cd;
    border-color: rgba(81, 69, 205, var(--border-opacity));
  }
  .sm\\:border-indigo-800 {
    --border-opacity: 1;
    border-color: #42389d;
    border-color: rgba(66, 56, 157, var(--border-opacity));
  }
  .sm\\:border-indigo-900 {
    --border-opacity: 1;
    border-color: #362f78;
    border-color: rgba(54, 47, 120, var(--border-opacity));
  }
  .sm\\:border-purple-50 {
    --border-opacity: 1;
    border-color: #f6f5ff;
    border-color: rgba(246, 245, 255, var(--border-opacity));
  }
  .sm\\:border-purple-100 {
    --border-opacity: 1;
    border-color: #edebfe;
    border-color: rgba(237, 235, 254, var(--border-opacity));
  }
  .sm\\:border-purple-200 {
    --border-opacity: 1;
    border-color: #dcd7fe;
    border-color: rgba(220, 215, 254, var(--border-opacity));
  }
  .sm\\:border-purple-300 {
    --border-opacity: 1;
    border-color: #cabffd;
    border-color: rgba(202, 191, 253, var(--border-opacity));
  }
  .sm\\:border-purple-400 {
    --border-opacity: 1;
    border-color: #ac94fa;
    border-color: rgba(172, 148, 250, var(--border-opacity));
  }
  .sm\\:border-purple-500 {
    --border-opacity: 1;
    border-color: #9061f9;
    border-color: rgba(144, 97, 249, var(--border-opacity));
  }
  .sm\\:border-purple-600 {
    --border-opacity: 1;
    border-color: #7e3af2;
    border-color: rgba(126, 58, 242, var(--border-opacity));
  }
  .sm\\:border-purple-700 {
    --border-opacity: 1;
    border-color: #6c2bd9;
    border-color: rgba(108, 43, 217, var(--border-opacity));
  }
  .sm\\:border-purple-800 {
    --border-opacity: 1;
    border-color: #5521b5;
    border-color: rgba(85, 33, 181, var(--border-opacity));
  }
  .sm\\:border-purple-900 {
    --border-opacity: 1;
    border-color: #4a1d96;
    border-color: rgba(74, 29, 150, var(--border-opacity));
  }
  .sm\\:border-pink-50 {
    --border-opacity: 1;
    border-color: #fdf2f8;
    border-color: rgba(253, 242, 248, var(--border-opacity));
  }
  .sm\\:border-pink-100 {
    --border-opacity: 1;
    border-color: #fce8f3;
    border-color: rgba(252, 232, 243, var(--border-opacity));
  }
  .sm\\:border-pink-200 {
    --border-opacity: 1;
    border-color: #fad1e8;
    border-color: rgba(250, 209, 232, var(--border-opacity));
  }
  .sm\\:border-pink-300 {
    --border-opacity: 1;
    border-color: #f8b4d9;
    border-color: rgba(248, 180, 217, var(--border-opacity));
  }
  .sm\\:border-pink-400 {
    --border-opacity: 1;
    border-color: #f17eb8;
    border-color: rgba(241, 126, 184, var(--border-opacity));
  }
  .sm\\:border-pink-500 {
    --border-opacity: 1;
    border-color: #e74694;
    border-color: rgba(231, 70, 148, var(--border-opacity));
  }
  .sm\\:border-pink-600 {
    --border-opacity: 1;
    border-color: #d61f69;
    border-color: rgba(214, 31, 105, var(--border-opacity));
  }
  .sm\\:border-pink-700 {
    --border-opacity: 1;
    border-color: #bf125d;
    border-color: rgba(191, 18, 93, var(--border-opacity));
  }
  .sm\\:border-pink-800 {
    --border-opacity: 1;
    border-color: #99154b;
    border-color: rgba(153, 21, 75, var(--border-opacity));
  }
  .sm\\:border-pink-900 {
    --border-opacity: 1;
    border-color: #751a3d;
    border-color: rgba(117, 26, 61, var(--border-opacity));
  }
  .sm\\:border-cool-gray-50 {
    --border-opacity: 1;
    border-color: #f8fafc;
    border-color: rgba(248, 250, 252, var(--border-opacity));
  }
  .sm\\:border-cool-gray-100 {
    --border-opacity: 1;
    border-color: #f1f5f9;
    border-color: rgba(241, 245, 249, var(--border-opacity));
  }
  .sm\\:border-cool-gray-200 {
    --border-opacity: 1;
    border-color: #e2e8f0;
    border-color: rgba(226, 232, 240, var(--border-opacity));
  }
  .sm\\:border-cool-gray-300 {
    --border-opacity: 1;
    border-color: #cfd8e3;
    border-color: rgba(207, 216, 227, var(--border-opacity));
  }
  .sm\\:border-cool-gray-400 {
    --border-opacity: 1;
    border-color: #97a6ba;
    border-color: rgba(151, 166, 186, var(--border-opacity));
  }
  .sm\\:border-cool-gray-500 {
    --border-opacity: 1;
    border-color: #64748b;
    border-color: rgba(100, 116, 139, var(--border-opacity));
  }
  .sm\\:border-cool-gray-600 {
    --border-opacity: 1;
    border-color: #475569;
    border-color: rgba(71, 85, 105, var(--border-opacity));
  }
  .sm\\:border-cool-gray-700 {
    --border-opacity: 1;
    border-color: #364152;
    border-color: rgba(54, 65, 82, var(--border-opacity));
  }
  .sm\\:border-cool-gray-800 {
    --border-opacity: 1;
    border-color: #27303f;
    border-color: rgba(39, 48, 63, var(--border-opacity));
  }
  .sm\\:border-cool-gray-900 {
    --border-opacity: 1;
    border-color: #1a202e;
    border-color: rgba(26, 32, 46, var(--border-opacity));
  }
  .group:hover .sm\\:group-hover\\:border-current {
    border-color: currentColor;
  }
  .group:hover .sm\\:group-hover\\:border-transparent {
    border-color: transparent;
  }
  .group:hover .sm\\:group-hover\\:border-white {
    --border-opacity: 1;
    border-color: #ffffff;
    border-color: rgba(255, 255, 255, var(--border-opacity));
  }
  .group:hover .sm\\:group-hover\\:border-black {
    --border-opacity: 1;
    border-color: #000000;
    border-color: rgba(0, 0, 0, var(--border-opacity));
  }
  .group:hover .sm\\:group-hover\\:border-gray-50 {
    --border-opacity: 1;
    border-color: #f9fafb;
    border-color: rgba(249, 250, 251, var(--border-opacity));
  }
  .group:hover .sm\\:group-hover\\:border-gray-100 {
    --border-opacity: 1;
    border-color: #f4f5f7;
    border-color: rgba(244, 245, 247, var(--border-opacity));
  }
  .group:hover .sm\\:group-hover\\:border-gray-200 {
    --border-opacity: 1;
    border-color: #e5e7eb;
    border-color: rgba(229, 231, 235, var(--border-opacity));
  }
  .group:hover .sm\\:group-hover\\:border-gray-300 {
    --border-opacity: 1;
    border-color: #d2d6dc;
    border-color: rgba(210, 214, 220, var(--border-opacity));
  }
  .group:hover .sm\\:group-hover\\:border-gray-400 {
    --border-opacity: 1;
    border-color: #9fa6b2;
    border-color: rgba(159, 166, 178, var(--border-opacity));
  }
  .group:hover .sm\\:group-hover\\:border-gray-500 {
    --border-opacity: 1;
    border-color: #6b7280;
    border-color: rgba(107, 114, 128, var(--border-opacity));
  }
  .group:hover .sm\\:group-hover\\:border-gray-600 {
    --border-opacity: 1;
    border-color: #4b5563;
    border-color: rgba(75, 85, 99, var(--border-opacity));
  }
  .group:hover .sm\\:group-hover\\:border-gray-700 {
    --border-opacity: 1;
    border-color: #374151;
    border-color: rgba(55, 65, 81, var(--border-opacity));
  }
  .group:hover .sm\\:group-hover\\:border-gray-800 {
    --border-opacity: 1;
    border-color: #252f3f;
    border-color: rgba(37, 47, 63, var(--border-opacity));
  }
  .group:hover .sm\\:group-hover\\:border-gray-900 {
    --border-opacity: 1;
    border-color: #161e2e;
    border-color: rgba(22, 30, 46, var(--border-opacity));
  }
  .group:hover .sm\\:group-hover\\:border-red-50 {
    --border-opacity: 1;
    border-color: #fdf2f2;
    border-color: rgba(253, 242, 242, var(--border-opacity));
  }
  .group:hover .sm\\:group-hover\\:border-red-100 {
    --border-opacity: 1;
    border-color: #fde8e8;
    border-color: rgba(253, 232, 232, var(--border-opacity));
  }
  .group:hover .sm\\:group-hover\\:border-red-200 {
    --border-opacity: 1;
    border-color: #fbd5d5;
    border-color: rgba(251, 213, 213, var(--border-opacity));
  }
  .group:hover .sm\\:group-hover\\:border-red-300 {
    --border-opacity: 1;
    border-color: #f8b4b4;
    border-color: rgba(248, 180, 180, var(--border-opacity));
  }
  .group:hover .sm\\:group-hover\\:border-red-400 {
    --border-opacity: 1;
    border-color: #f98080;
    border-color: rgba(249, 128, 128, var(--border-opacity));
  }
  .group:hover .sm\\:group-hover\\:border-red-500 {
    --border-opacity: 1;
    border-color: #f05252;
    border-color: rgba(240, 82, 82, var(--border-opacity));
  }
  .group:hover .sm\\:group-hover\\:border-red-600 {
    --border-opacity: 1;
    border-color: #e02424;
    border-color: rgba(224, 36, 36, var(--border-opacity));
  }
  .group:hover .sm\\:group-hover\\:border-red-700 {
    --border-opacity: 1;
    border-color: #c81e1e;
    border-color: rgba(200, 30, 30, var(--border-opacity));
  }
  .group:hover .sm\\:group-hover\\:border-red-800 {
    --border-opacity: 1;
    border-color: #9b1c1c;
    border-color: rgba(155, 28, 28, var(--border-opacity));
  }
  .group:hover .sm\\:group-hover\\:border-red-900 {
    --border-opacity: 1;
    border-color: #771d1d;
    border-color: rgba(119, 29, 29, var(--border-opacity));
  }
  .group:hover .sm\\:group-hover\\:border-orange-50 {
    --border-opacity: 1;
    border-color: #fff8f1;
    border-color: rgba(255, 248, 241, var(--border-opacity));
  }
  .group:hover .sm\\:group-hover\\:border-orange-100 {
    --border-opacity: 1;
    border-color: #feecdc;
    border-color: rgba(254, 236, 220, var(--border-opacity));
  }
  .group:hover .sm\\:group-hover\\:border-orange-200 {
    --border-opacity: 1;
    border-color: #fcd9bd;
    border-color: rgba(252, 217, 189, var(--border-opacity));
  }
  .group:hover .sm\\:group-hover\\:border-orange-300 {
    --border-opacity: 1;
    border-color: #fdba8c;
    border-color: rgba(253, 186, 140, var(--border-opacity));
  }
  .group:hover .sm\\:group-hover\\:border-orange-400 {
    --border-opacity: 1;
    border-color: #ff8a4c;
    border-color: rgba(255, 138, 76, var(--border-opacity));
  }
  .group:hover .sm\\:group-hover\\:border-orange-500 {
    --border-opacity: 1;
    border-color: #ff5a1f;
    border-color: rgba(255, 90, 31, var(--border-opacity));
  }
  .group:hover .sm\\:group-hover\\:border-orange-600 {
    --border-opacity: 1;
    border-color: #d03801;
    border-color: rgba(208, 56, 1, var(--border-opacity));
  }
  .group:hover .sm\\:group-hover\\:border-orange-700 {
    --border-opacity: 1;
    border-color: #b43403;
    border-color: rgba(180, 52, 3, var(--border-opacity));
  }
  .group:hover .sm\\:group-hover\\:border-orange-800 {
    --border-opacity: 1;
    border-color: #8a2c0d;
    border-color: rgba(138, 44, 13, var(--border-opacity));
  }
  .group:hover .sm\\:group-hover\\:border-orange-900 {
    --border-opacity: 1;
    border-color: #73230d;
    border-color: rgba(115, 35, 13, var(--border-opacity));
  }
  .group:hover .sm\\:group-hover\\:border-yellow-50 {
    --border-opacity: 1;
    border-color: #fdfdea;
    border-color: rgba(253, 253, 234, var(--border-opacity));
  }
  .group:hover .sm\\:group-hover\\:border-yellow-100 {
    --border-opacity: 1;
    border-color: #fdf6b2;
    border-color: rgba(253, 246, 178, var(--border-opacity));
  }
  .group:hover .sm\\:group-hover\\:border-yellow-200 {
    --border-opacity: 1;
    border-color: #fce96a;
    border-color: rgba(252, 233, 106, var(--border-opacity));
  }
  .group:hover .sm\\:group-hover\\:border-yellow-300 {
    --border-opacity: 1;
    border-color: #faca15;
    border-color: rgba(250, 202, 21, var(--border-opacity));
  }
  .group:hover .sm\\:group-hover\\:border-yellow-400 {
    --border-opacity: 1;
    border-color: #e3a008;
    border-color: rgba(227, 160, 8, var(--border-opacity));
  }
  .group:hover .sm\\:group-hover\\:border-yellow-500 {
    --border-opacity: 1;
    border-color: #c27803;
    border-color: rgba(194, 120, 3, var(--border-opacity));
  }
  .group:hover .sm\\:group-hover\\:border-yellow-600 {
    --border-opacity: 1;
    border-color: #9f580a;
    border-color: rgba(159, 88, 10, var(--border-opacity));
  }
  .group:hover .sm\\:group-hover\\:border-yellow-700 {
    --border-opacity: 1;
    border-color: #8e4b10;
    border-color: rgba(142, 75, 16, var(--border-opacity));
  }
  .group:hover .sm\\:group-hover\\:border-yellow-800 {
    --border-opacity: 1;
    border-color: #723b13;
    border-color: rgba(114, 59, 19, var(--border-opacity));
  }
  .group:hover .sm\\:group-hover\\:border-yellow-900 {
    --border-opacity: 1;
    border-color: #633112;
    border-color: rgba(99, 49, 18, var(--border-opacity));
  }
  .group:hover .sm\\:group-hover\\:border-green-50 {
    --border-opacity: 1;
    border-color: #f3faf7;
    border-color: rgba(243, 250, 247, var(--border-opacity));
  }
  .group:hover .sm\\:group-hover\\:border-green-100 {
    --border-opacity: 1;
    border-color: #def7ec;
    border-color: rgba(222, 247, 236, var(--border-opacity));
  }
  .group:hover .sm\\:group-hover\\:border-green-200 {
    --border-opacity: 1;
    border-color: #bcf0da;
    border-color: rgba(188, 240, 218, var(--border-opacity));
  }
  .group:hover .sm\\:group-hover\\:border-green-300 {
    --border-opacity: 1;
    border-color: #84e1bc;
    border-color: rgba(132, 225, 188, var(--border-opacity));
  }
  .group:hover .sm\\:group-hover\\:border-green-400 {
    --border-opacity: 1;
    border-color: #31c48d;
    border-color: rgba(49, 196, 141, var(--border-opacity));
  }
  .group:hover .sm\\:group-hover\\:border-green-500 {
    --border-opacity: 1;
    border-color: #0e9f6e;
    border-color: rgba(14, 159, 110, var(--border-opacity));
  }
  .group:hover .sm\\:group-hover\\:border-green-600 {
    --border-opacity: 1;
    border-color: #057a55;
    border-color: rgba(5, 122, 85, var(--border-opacity));
  }
  .group:hover .sm\\:group-hover\\:border-green-700 {
    --border-opacity: 1;
    border-color: #046c4e;
    border-color: rgba(4, 108, 78, var(--border-opacity));
  }
  .group:hover .sm\\:group-hover\\:border-green-800 {
    --border-opacity: 1;
    border-color: #03543f;
    border-color: rgba(3, 84, 63, var(--border-opacity));
  }
  .group:hover .sm\\:group-hover\\:border-green-900 {
    --border-opacity: 1;
    border-color: #014737;
    border-color: rgba(1, 71, 55, var(--border-opacity));
  }
  .group:hover .sm\\:group-hover\\:border-teal-50 {
    --border-opacity: 1;
    border-color: #edfafa;
    border-color: rgba(237, 250, 250, var(--border-opacity));
  }
  .group:hover .sm\\:group-hover\\:border-teal-100 {
    --border-opacity: 1;
    border-color: #d5f5f6;
    border-color: rgba(213, 245, 246, var(--border-opacity));
  }
  .group:hover .sm\\:group-hover\\:border-teal-200 {
    --border-opacity: 1;
    border-color: #afecef;
    border-color: rgba(175, 236, 239, var(--border-opacity));
  }
  .group:hover .sm\\:group-hover\\:border-teal-300 {
    --border-opacity: 1;
    border-color: #7edce2;
    border-color: rgba(126, 220, 226, var(--border-opacity));
  }
  .group:hover .sm\\:group-hover\\:border-teal-400 {
    --border-opacity: 1;
    border-color: #16bdca;
    border-color: rgba(22, 189, 202, var(--border-opacity));
  }
  .group:hover .sm\\:group-hover\\:border-teal-500 {
    --border-opacity: 1;
    border-color: #0694a2;
    border-color: rgba(6, 148, 162, var(--border-opacity));
  }
  .group:hover .sm\\:group-hover\\:border-teal-600 {
    --border-opacity: 1;
    border-color: #047481;
    border-color: rgba(4, 116, 129, var(--border-opacity));
  }
  .group:hover .sm\\:group-hover\\:border-teal-700 {
    --border-opacity: 1;
    border-color: #036672;
    border-color: rgba(3, 102, 114, var(--border-opacity));
  }
  .group:hover .sm\\:group-hover\\:border-teal-800 {
    --border-opacity: 1;
    border-color: #05505c;
    border-color: rgba(5, 80, 92, var(--border-opacity));
  }
  .group:hover .sm\\:group-hover\\:border-teal-900 {
    --border-opacity: 1;
    border-color: #014451;
    border-color: rgba(1, 68, 81, var(--border-opacity));
  }
  .group:hover .sm\\:group-hover\\:border-blue-50 {
    --border-opacity: 1;
    border-color: #ebf5ff;
    border-color: rgba(235, 245, 255, var(--border-opacity));
  }
  .group:hover .sm\\:group-hover\\:border-blue-100 {
    --border-opacity: 1;
    border-color: #e1effe;
    border-color: rgba(225, 239, 254, var(--border-opacity));
  }
  .group:hover .sm\\:group-hover\\:border-blue-200 {
    --border-opacity: 1;
    border-color: #c3ddfd;
    border-color: rgba(195, 221, 253, var(--border-opacity));
  }
  .group:hover .sm\\:group-hover\\:border-blue-300 {
    --border-opacity: 1;
    border-color: #a4cafe;
    border-color: rgba(164, 202, 254, var(--border-opacity));
  }
  .group:hover .sm\\:group-hover\\:border-blue-400 {
    --border-opacity: 1;
    border-color: #76a9fa;
    border-color: rgba(118, 169, 250, var(--border-opacity));
  }
  .group:hover .sm\\:group-hover\\:border-blue-500 {
    --border-opacity: 1;
    border-color: #3f83f8;
    border-color: rgba(63, 131, 248, var(--border-opacity));
  }
  .group:hover .sm\\:group-hover\\:border-blue-600 {
    --border-opacity: 1;
    border-color: #1c64f2;
    border-color: rgba(28, 100, 242, var(--border-opacity));
  }
  .group:hover .sm\\:group-hover\\:border-blue-700 {
    --border-opacity: 1;
    border-color: #1a56db;
    border-color: rgba(26, 86, 219, var(--border-opacity));
  }
  .group:hover .sm\\:group-hover\\:border-blue-800 {
    --border-opacity: 1;
    border-color: #1e429f;
    border-color: rgba(30, 66, 159, var(--border-opacity));
  }
  .group:hover .sm\\:group-hover\\:border-blue-900 {
    --border-opacity: 1;
    border-color: #233876;
    border-color: rgba(35, 56, 118, var(--border-opacity));
  }
  .group:hover .sm\\:group-hover\\:border-indigo-50 {
    --border-opacity: 1;
    border-color: #f0f5ff;
    border-color: rgba(240, 245, 255, var(--border-opacity));
  }
  .group:hover .sm\\:group-hover\\:border-indigo-100 {
    --border-opacity: 1;
    border-color: #e5edff;
    border-color: rgba(229, 237, 255, var(--border-opacity));
  }
  .group:hover .sm\\:group-hover\\:border-indigo-200 {
    --border-opacity: 1;
    border-color: #cddbfe;
    border-color: rgba(205, 219, 254, var(--border-opacity));
  }
  .group:hover .sm\\:group-hover\\:border-indigo-300 {
    --border-opacity: 1;
    border-color: #b4c6fc;
    border-color: rgba(180, 198, 252, var(--border-opacity));
  }
  .group:hover .sm\\:group-hover\\:border-indigo-400 {
    --border-opacity: 1;
    border-color: #8da2fb;
    border-color: rgba(141, 162, 251, var(--border-opacity));
  }
  .group:hover .sm\\:group-hover\\:border-indigo-500 {
    --border-opacity: 1;
    border-color: #6875f5;
    border-color: rgba(104, 117, 245, var(--border-opacity));
  }
  .group:hover .sm\\:group-hover\\:border-indigo-600 {
    --border-opacity: 1;
    border-color: #5850ec;
    border-color: rgba(88, 80, 236, var(--border-opacity));
  }
  .group:hover .sm\\:group-hover\\:border-indigo-700 {
    --border-opacity: 1;
    border-color: #5145cd;
    border-color: rgba(81, 69, 205, var(--border-opacity));
  }
  .group:hover .sm\\:group-hover\\:border-indigo-800 {
    --border-opacity: 1;
    border-color: #42389d;
    border-color: rgba(66, 56, 157, var(--border-opacity));
  }
  .group:hover .sm\\:group-hover\\:border-indigo-900 {
    --border-opacity: 1;
    border-color: #362f78;
    border-color: rgba(54, 47, 120, var(--border-opacity));
  }
  .group:hover .sm\\:group-hover\\:border-purple-50 {
    --border-opacity: 1;
    border-color: #f6f5ff;
    border-color: rgba(246, 245, 255, var(--border-opacity));
  }
  .group:hover .sm\\:group-hover\\:border-purple-100 {
    --border-opacity: 1;
    border-color: #edebfe;
    border-color: rgba(237, 235, 254, var(--border-opacity));
  }
  .group:hover .sm\\:group-hover\\:border-purple-200 {
    --border-opacity: 1;
    border-color: #dcd7fe;
    border-color: rgba(220, 215, 254, var(--border-opacity));
  }
  .group:hover .sm\\:group-hover\\:border-purple-300 {
    --border-opacity: 1;
    border-color: #cabffd;
    border-color: rgba(202, 191, 253, var(--border-opacity));
  }
  .group:hover .sm\\:group-hover\\:border-purple-400 {
    --border-opacity: 1;
    border-color: #ac94fa;
    border-color: rgba(172, 148, 250, var(--border-opacity));
  }
  .group:hover .sm\\:group-hover\\:border-purple-500 {
    --border-opacity: 1;
    border-color: #9061f9;
    border-color: rgba(144, 97, 249, var(--border-opacity));
  }
  .group:hover .sm\\:group-hover\\:border-purple-600 {
    --border-opacity: 1;
    border-color: #7e3af2;
    border-color: rgba(126, 58, 242, var(--border-opacity));
  }
  .group:hover .sm\\:group-hover\\:border-purple-700 {
    --border-opacity: 1;
    border-color: #6c2bd9;
    border-color: rgba(108, 43, 217, var(--border-opacity));
  }
  .group:hover .sm\\:group-hover\\:border-purple-800 {
    --border-opacity: 1;
    border-color: #5521b5;
    border-color: rgba(85, 33, 181, var(--border-opacity));
  }
  .group:hover .sm\\:group-hover\\:border-purple-900 {
    --border-opacity: 1;
    border-color: #4a1d96;
    border-color: rgba(74, 29, 150, var(--border-opacity));
  }
  .group:hover .sm\\:group-hover\\:border-pink-50 {
    --border-opacity: 1;
    border-color: #fdf2f8;
    border-color: rgba(253, 242, 248, var(--border-opacity));
  }
  .group:hover .sm\\:group-hover\\:border-pink-100 {
    --border-opacity: 1;
    border-color: #fce8f3;
    border-color: rgba(252, 232, 243, var(--border-opacity));
  }
  .group:hover .sm\\:group-hover\\:border-pink-200 {
    --border-opacity: 1;
    border-color: #fad1e8;
    border-color: rgba(250, 209, 232, var(--border-opacity));
  }
  .group:hover .sm\\:group-hover\\:border-pink-300 {
    --border-opacity: 1;
    border-color: #f8b4d9;
    border-color: rgba(248, 180, 217, var(--border-opacity));
  }
  .group:hover .sm\\:group-hover\\:border-pink-400 {
    --border-opacity: 1;
    border-color: #f17eb8;
    border-color: rgba(241, 126, 184, var(--border-opacity));
  }
  .group:hover .sm\\:group-hover\\:border-pink-500 {
    --border-opacity: 1;
    border-color: #e74694;
    border-color: rgba(231, 70, 148, var(--border-opacity));
  }
  .group:hover .sm\\:group-hover\\:border-pink-600 {
    --border-opacity: 1;
    border-color: #d61f69;
    border-color: rgba(214, 31, 105, var(--border-opacity));
  }
  .group:hover .sm\\:group-hover\\:border-pink-700 {
    --border-opacity: 1;
    border-color: #bf125d;
    border-color: rgba(191, 18, 93, var(--border-opacity));
  }
  .group:hover .sm\\:group-hover\\:border-pink-800 {
    --border-opacity: 1;
    border-color: #99154b;
    border-color: rgba(153, 21, 75, var(--border-opacity));
  }
  .group:hover .sm\\:group-hover\\:border-pink-900 {
    --border-opacity: 1;
    border-color: #751a3d;
    border-color: rgba(117, 26, 61, var(--border-opacity));
  }
  .group:hover .sm\\:group-hover\\:border-cool-gray-50 {
    --border-opacity: 1;
    border-color: #f8fafc;
    border-color: rgba(248, 250, 252, var(--border-opacity));
  }
  .group:hover .sm\\:group-hover\\:border-cool-gray-100 {
    --border-opacity: 1;
    border-color: #f1f5f9;
    border-color: rgba(241, 245, 249, var(--border-opacity));
  }
  .group:hover .sm\\:group-hover\\:border-cool-gray-200 {
    --border-opacity: 1;
    border-color: #e2e8f0;
    border-color: rgba(226, 232, 240, var(--border-opacity));
  }
  .group:hover .sm\\:group-hover\\:border-cool-gray-300 {
    --border-opacity: 1;
    border-color: #cfd8e3;
    border-color: rgba(207, 216, 227, var(--border-opacity));
  }
  .group:hover .sm\\:group-hover\\:border-cool-gray-400 {
    --border-opacity: 1;
    border-color: #97a6ba;
    border-color: rgba(151, 166, 186, var(--border-opacity));
  }
  .group:hover .sm\\:group-hover\\:border-cool-gray-500 {
    --border-opacity: 1;
    border-color: #64748b;
    border-color: rgba(100, 116, 139, var(--border-opacity));
  }
  .group:hover .sm\\:group-hover\\:border-cool-gray-600 {
    --border-opacity: 1;
    border-color: #475569;
    border-color: rgba(71, 85, 105, var(--border-opacity));
  }
  .group:hover .sm\\:group-hover\\:border-cool-gray-700 {
    --border-opacity: 1;
    border-color: #364152;
    border-color: rgba(54, 65, 82, var(--border-opacity));
  }
  .group:hover .sm\\:group-hover\\:border-cool-gray-800 {
    --border-opacity: 1;
    border-color: #27303f;
    border-color: rgba(39, 48, 63, var(--border-opacity));
  }
  .group:hover .sm\\:group-hover\\:border-cool-gray-900 {
    --border-opacity: 1;
    border-color: #1a202e;
    border-color: rgba(26, 32, 46, var(--border-opacity));
  }
  .group:focus .sm\\:group-focus\\:border-current {
    border-color: currentColor;
  }
  .group:focus .sm\\:group-focus\\:border-transparent {
    border-color: transparent;
  }
  .group:focus .sm\\:group-focus\\:border-white {
    --border-opacity: 1;
    border-color: #ffffff;
    border-color: rgba(255, 255, 255, var(--border-opacity));
  }
  .group:focus .sm\\:group-focus\\:border-black {
    --border-opacity: 1;
    border-color: #000000;
    border-color: rgba(0, 0, 0, var(--border-opacity));
  }
  .group:focus .sm\\:group-focus\\:border-gray-50 {
    --border-opacity: 1;
    border-color: #f9fafb;
    border-color: rgba(249, 250, 251, var(--border-opacity));
  }
  .group:focus .sm\\:group-focus\\:border-gray-100 {
    --border-opacity: 1;
    border-color: #f4f5f7;
    border-color: rgba(244, 245, 247, var(--border-opacity));
  }
  .group:focus .sm\\:group-focus\\:border-gray-200 {
    --border-opacity: 1;
    border-color: #e5e7eb;
    border-color: rgba(229, 231, 235, var(--border-opacity));
  }
  .group:focus .sm\\:group-focus\\:border-gray-300 {
    --border-opacity: 1;
    border-color: #d2d6dc;
    border-color: rgba(210, 214, 220, var(--border-opacity));
  }
  .group:focus .sm\\:group-focus\\:border-gray-400 {
    --border-opacity: 1;
    border-color: #9fa6b2;
    border-color: rgba(159, 166, 178, var(--border-opacity));
  }
  .group:focus .sm\\:group-focus\\:border-gray-500 {
    --border-opacity: 1;
    border-color: #6b7280;
    border-color: rgba(107, 114, 128, var(--border-opacity));
  }
  .group:focus .sm\\:group-focus\\:border-gray-600 {
    --border-opacity: 1;
    border-color: #4b5563;
    border-color: rgba(75, 85, 99, var(--border-opacity));
  }
  .group:focus .sm\\:group-focus\\:border-gray-700 {
    --border-opacity: 1;
    border-color: #374151;
    border-color: rgba(55, 65, 81, var(--border-opacity));
  }
  .group:focus .sm\\:group-focus\\:border-gray-800 {
    --border-opacity: 1;
    border-color: #252f3f;
    border-color: rgba(37, 47, 63, var(--border-opacity));
  }
  .group:focus .sm\\:group-focus\\:border-gray-900 {
    --border-opacity: 1;
    border-color: #161e2e;
    border-color: rgba(22, 30, 46, var(--border-opacity));
  }
  .group:focus .sm\\:group-focus\\:border-red-50 {
    --border-opacity: 1;
    border-color: #fdf2f2;
    border-color: rgba(253, 242, 242, var(--border-opacity));
  }
  .group:focus .sm\\:group-focus\\:border-red-100 {
    --border-opacity: 1;
    border-color: #fde8e8;
    border-color: rgba(253, 232, 232, var(--border-opacity));
  }
  .group:focus .sm\\:group-focus\\:border-red-200 {
    --border-opacity: 1;
    border-color: #fbd5d5;
    border-color: rgba(251, 213, 213, var(--border-opacity));
  }
  .group:focus .sm\\:group-focus\\:border-red-300 {
    --border-opacity: 1;
    border-color: #f8b4b4;
    border-color: rgba(248, 180, 180, var(--border-opacity));
  }
  .group:focus .sm\\:group-focus\\:border-red-400 {
    --border-opacity: 1;
    border-color: #f98080;
    border-color: rgba(249, 128, 128, var(--border-opacity));
  }
  .group:focus .sm\\:group-focus\\:border-red-500 {
    --border-opacity: 1;
    border-color: #f05252;
    border-color: rgba(240, 82, 82, var(--border-opacity));
  }
  .group:focus .sm\\:group-focus\\:border-red-600 {
    --border-opacity: 1;
    border-color: #e02424;
    border-color: rgba(224, 36, 36, var(--border-opacity));
  }
  .group:focus .sm\\:group-focus\\:border-red-700 {
    --border-opacity: 1;
    border-color: #c81e1e;
    border-color: rgba(200, 30, 30, var(--border-opacity));
  }
  .group:focus .sm\\:group-focus\\:border-red-800 {
    --border-opacity: 1;
    border-color: #9b1c1c;
    border-color: rgba(155, 28, 28, var(--border-opacity));
  }
  .group:focus .sm\\:group-focus\\:border-red-900 {
    --border-opacity: 1;
    border-color: #771d1d;
    border-color: rgba(119, 29, 29, var(--border-opacity));
  }
  .group:focus .sm\\:group-focus\\:border-orange-50 {
    --border-opacity: 1;
    border-color: #fff8f1;
    border-color: rgba(255, 248, 241, var(--border-opacity));
  }
  .group:focus .sm\\:group-focus\\:border-orange-100 {
    --border-opacity: 1;
    border-color: #feecdc;
    border-color: rgba(254, 236, 220, var(--border-opacity));
  }
  .group:focus .sm\\:group-focus\\:border-orange-200 {
    --border-opacity: 1;
    border-color: #fcd9bd;
    border-color: rgba(252, 217, 189, var(--border-opacity));
  }
  .group:focus .sm\\:group-focus\\:border-orange-300 {
    --border-opacity: 1;
    border-color: #fdba8c;
    border-color: rgba(253, 186, 140, var(--border-opacity));
  }
  .group:focus .sm\\:group-focus\\:border-orange-400 {
    --border-opacity: 1;
    border-color: #ff8a4c;
    border-color: rgba(255, 138, 76, var(--border-opacity));
  }
  .group:focus .sm\\:group-focus\\:border-orange-500 {
    --border-opacity: 1;
    border-color: #ff5a1f;
    border-color: rgba(255, 90, 31, var(--border-opacity));
  }
  .group:focus .sm\\:group-focus\\:border-orange-600 {
    --border-opacity: 1;
    border-color: #d03801;
    border-color: rgba(208, 56, 1, var(--border-opacity));
  }
  .group:focus .sm\\:group-focus\\:border-orange-700 {
    --border-opacity: 1;
    border-color: #b43403;
    border-color: rgba(180, 52, 3, var(--border-opacity));
  }
  .group:focus .sm\\:group-focus\\:border-orange-800 {
    --border-opacity: 1;
    border-color: #8a2c0d;
    border-color: rgba(138, 44, 13, var(--border-opacity));
  }
  .group:focus .sm\\:group-focus\\:border-orange-900 {
    --border-opacity: 1;
    border-color: #73230d;
    border-color: rgba(115, 35, 13, var(--border-opacity));
  }
  .group:focus .sm\\:group-focus\\:border-yellow-50 {
    --border-opacity: 1;
    border-color: #fdfdea;
    border-color: rgba(253, 253, 234, var(--border-opacity));
  }
  .group:focus .sm\\:group-focus\\:border-yellow-100 {
    --border-opacity: 1;
    border-color: #fdf6b2;
    border-color: rgba(253, 246, 178, var(--border-opacity));
  }
  .group:focus .sm\\:group-focus\\:border-yellow-200 {
    --border-opacity: 1;
    border-color: #fce96a;
    border-color: rgba(252, 233, 106, var(--border-opacity));
  }
  .group:focus .sm\\:group-focus\\:border-yellow-300 {
    --border-opacity: 1;
    border-color: #faca15;
    border-color: rgba(250, 202, 21, var(--border-opacity));
  }
  .group:focus .sm\\:group-focus\\:border-yellow-400 {
    --border-opacity: 1;
    border-color: #e3a008;
    border-color: rgba(227, 160, 8, var(--border-opacity));
  }
  .group:focus .sm\\:group-focus\\:border-yellow-500 {
    --border-opacity: 1;
    border-color: #c27803;
    border-color: rgba(194, 120, 3, var(--border-opacity));
  }
  .group:focus .sm\\:group-focus\\:border-yellow-600 {
    --border-opacity: 1;
    border-color: #9f580a;
    border-color: rgba(159, 88, 10, var(--border-opacity));
  }
  .group:focus .sm\\:group-focus\\:border-yellow-700 {
    --border-opacity: 1;
    border-color: #8e4b10;
    border-color: rgba(142, 75, 16, var(--border-opacity));
  }
  .group:focus .sm\\:group-focus\\:border-yellow-800 {
    --border-opacity: 1;
    border-color: #723b13;
    border-color: rgba(114, 59, 19, var(--border-opacity));
  }
  .group:focus .sm\\:group-focus\\:border-yellow-900 {
    --border-opacity: 1;
    border-color: #633112;
    border-color: rgba(99, 49, 18, var(--border-opacity));
  }
  .group:focus .sm\\:group-focus\\:border-green-50 {
    --border-opacity: 1;
    border-color: #f3faf7;
    border-color: rgba(243, 250, 247, var(--border-opacity));
  }
  .group:focus .sm\\:group-focus\\:border-green-100 {
    --border-opacity: 1;
    border-color: #def7ec;
    border-color: rgba(222, 247, 236, var(--border-opacity));
  }
  .group:focus .sm\\:group-focus\\:border-green-200 {
    --border-opacity: 1;
    border-color: #bcf0da;
    border-color: rgba(188, 240, 218, var(--border-opacity));
  }
  .group:focus .sm\\:group-focus\\:border-green-300 {
    --border-opacity: 1;
    border-color: #84e1bc;
    border-color: rgba(132, 225, 188, var(--border-opacity));
  }
  .group:focus .sm\\:group-focus\\:border-green-400 {
    --border-opacity: 1;
    border-color: #31c48d;
    border-color: rgba(49, 196, 141, var(--border-opacity));
  }
  .group:focus .sm\\:group-focus\\:border-green-500 {
    --border-opacity: 1;
    border-color: #0e9f6e;
    border-color: rgba(14, 159, 110, var(--border-opacity));
  }
  .group:focus .sm\\:group-focus\\:border-green-600 {
    --border-opacity: 1;
    border-color: #057a55;
    border-color: rgba(5, 122, 85, var(--border-opacity));
  }
  .group:focus .sm\\:group-focus\\:border-green-700 {
    --border-opacity: 1;
    border-color: #046c4e;
    border-color: rgba(4, 108, 78, var(--border-opacity));
  }
  .group:focus .sm\\:group-focus\\:border-green-800 {
    --border-opacity: 1;
    border-color: #03543f;
    border-color: rgba(3, 84, 63, var(--border-opacity));
  }
  .group:focus .sm\\:group-focus\\:border-green-900 {
    --border-opacity: 1;
    border-color: #014737;
    border-color: rgba(1, 71, 55, var(--border-opacity));
  }
  .group:focus .sm\\:group-focus\\:border-teal-50 {
    --border-opacity: 1;
    border-color: #edfafa;
    border-color: rgba(237, 250, 250, var(--border-opacity));
  }
  .group:focus .sm\\:group-focus\\:border-teal-100 {
    --border-opacity: 1;
    border-color: #d5f5f6;
    border-color: rgba(213, 245, 246, var(--border-opacity));
  }
  .group:focus .sm\\:group-focus\\:border-teal-200 {
    --border-opacity: 1;
    border-color: #afecef;
    border-color: rgba(175, 236, 239, var(--border-opacity));
  }
  .group:focus .sm\\:group-focus\\:border-teal-300 {
    --border-opacity: 1;
    border-color: #7edce2;
    border-color: rgba(126, 220, 226, var(--border-opacity));
  }
  .group:focus .sm\\:group-focus\\:border-teal-400 {
    --border-opacity: 1;
    border-color: #16bdca;
    border-color: rgba(22, 189, 202, var(--border-opacity));
  }
  .group:focus .sm\\:group-focus\\:border-teal-500 {
    --border-opacity: 1;
    border-color: #0694a2;
    border-color: rgba(6, 148, 162, var(--border-opacity));
  }
  .group:focus .sm\\:group-focus\\:border-teal-600 {
    --border-opacity: 1;
    border-color: #047481;
    border-color: rgba(4, 116, 129, var(--border-opacity));
  }
  .group:focus .sm\\:group-focus\\:border-teal-700 {
    --border-opacity: 1;
    border-color: #036672;
    border-color: rgba(3, 102, 114, var(--border-opacity));
  }
  .group:focus .sm\\:group-focus\\:border-teal-800 {
    --border-opacity: 1;
    border-color: #05505c;
    border-color: rgba(5, 80, 92, var(--border-opacity));
  }
  .group:focus .sm\\:group-focus\\:border-teal-900 {
    --border-opacity: 1;
    border-color: #014451;
    border-color: rgba(1, 68, 81, var(--border-opacity));
  }
  .group:focus .sm\\:group-focus\\:border-blue-50 {
    --border-opacity: 1;
    border-color: #ebf5ff;
    border-color: rgba(235, 245, 255, var(--border-opacity));
  }
  .group:focus .sm\\:group-focus\\:border-blue-100 {
    --border-opacity: 1;
    border-color: #e1effe;
    border-color: rgba(225, 239, 254, var(--border-opacity));
  }
  .group:focus .sm\\:group-focus\\:border-blue-200 {
    --border-opacity: 1;
    border-color: #c3ddfd;
    border-color: rgba(195, 221, 253, var(--border-opacity));
  }
  .group:focus .sm\\:group-focus\\:border-blue-300 {
    --border-opacity: 1;
    border-color: #a4cafe;
    border-color: rgba(164, 202, 254, var(--border-opacity));
  }
  .group:focus .sm\\:group-focus\\:border-blue-400 {
    --border-opacity: 1;
    border-color: #76a9fa;
    border-color: rgba(118, 169, 250, var(--border-opacity));
  }
  .group:focus .sm\\:group-focus\\:border-blue-500 {
    --border-opacity: 1;
    border-color: #3f83f8;
    border-color: rgba(63, 131, 248, var(--border-opacity));
  }
  .group:focus .sm\\:group-focus\\:border-blue-600 {
    --border-opacity: 1;
    border-color: #1c64f2;
    border-color: rgba(28, 100, 242, var(--border-opacity));
  }
  .group:focus .sm\\:group-focus\\:border-blue-700 {
    --border-opacity: 1;
    border-color: #1a56db;
    border-color: rgba(26, 86, 219, var(--border-opacity));
  }
  .group:focus .sm\\:group-focus\\:border-blue-800 {
    --border-opacity: 1;
    border-color: #1e429f;
    border-color: rgba(30, 66, 159, var(--border-opacity));
  }
  .group:focus .sm\\:group-focus\\:border-blue-900 {
    --border-opacity: 1;
    border-color: #233876;
    border-color: rgba(35, 56, 118, var(--border-opacity));
  }
  .group:focus .sm\\:group-focus\\:border-indigo-50 {
    --border-opacity: 1;
    border-color: #f0f5ff;
    border-color: rgba(240, 245, 255, var(--border-opacity));
  }
  .group:focus .sm\\:group-focus\\:border-indigo-100 {
    --border-opacity: 1;
    border-color: #e5edff;
    border-color: rgba(229, 237, 255, var(--border-opacity));
  }
  .group:focus .sm\\:group-focus\\:border-indigo-200 {
    --border-opacity: 1;
    border-color: #cddbfe;
    border-color: rgba(205, 219, 254, var(--border-opacity));
  }
  .group:focus .sm\\:group-focus\\:border-indigo-300 {
    --border-opacity: 1;
    border-color: #b4c6fc;
    border-color: rgba(180, 198, 252, var(--border-opacity));
  }
  .group:focus .sm\\:group-focus\\:border-indigo-400 {
    --border-opacity: 1;
    border-color: #8da2fb;
    border-color: rgba(141, 162, 251, var(--border-opacity));
  }
  .group:focus .sm\\:group-focus\\:border-indigo-500 {
    --border-opacity: 1;
    border-color: #6875f5;
    border-color: rgba(104, 117, 245, var(--border-opacity));
  }
  .group:focus .sm\\:group-focus\\:border-indigo-600 {
    --border-opacity: 1;
    border-color: #5850ec;
    border-color: rgba(88, 80, 236, var(--border-opacity));
  }
  .group:focus .sm\\:group-focus\\:border-indigo-700 {
    --border-opacity: 1;
    border-color: #5145cd;
    border-color: rgba(81, 69, 205, var(--border-opacity));
  }
  .group:focus .sm\\:group-focus\\:border-indigo-800 {
    --border-opacity: 1;
    border-color: #42389d;
    border-color: rgba(66, 56, 157, var(--border-opacity));
  }
  .group:focus .sm\\:group-focus\\:border-indigo-900 {
    --border-opacity: 1;
    border-color: #362f78;
    border-color: rgba(54, 47, 120, var(--border-opacity));
  }
  .group:focus .sm\\:group-focus\\:border-purple-50 {
    --border-opacity: 1;
    border-color: #f6f5ff;
    border-color: rgba(246, 245, 255, var(--border-opacity));
  }
  .group:focus .sm\\:group-focus\\:border-purple-100 {
    --border-opacity: 1;
    border-color: #edebfe;
    border-color: rgba(237, 235, 254, var(--border-opacity));
  }
  .group:focus .sm\\:group-focus\\:border-purple-200 {
    --border-opacity: 1;
    border-color: #dcd7fe;
    border-color: rgba(220, 215, 254, var(--border-opacity));
  }
  .group:focus .sm\\:group-focus\\:border-purple-300 {
    --border-opacity: 1;
    border-color: #cabffd;
    border-color: rgba(202, 191, 253, var(--border-opacity));
  }
  .group:focus .sm\\:group-focus\\:border-purple-400 {
    --border-opacity: 1;
    border-color: #ac94fa;
    border-color: rgba(172, 148, 250, var(--border-opacity));
  }
  .group:focus .sm\\:group-focus\\:border-purple-500 {
    --border-opacity: 1;
    border-color: #9061f9;
    border-color: rgba(144, 97, 249, var(--border-opacity));
  }
  .group:focus .sm\\:group-focus\\:border-purple-600 {
    --border-opacity: 1;
    border-color: #7e3af2;
    border-color: rgba(126, 58, 242, var(--border-opacity));
  }
  .group:focus .sm\\:group-focus\\:border-purple-700 {
    --border-opacity: 1;
    border-color: #6c2bd9;
    border-color: rgba(108, 43, 217, var(--border-opacity));
  }
  .group:focus .sm\\:group-focus\\:border-purple-800 {
    --border-opacity: 1;
    border-color: #5521b5;
    border-color: rgba(85, 33, 181, var(--border-opacity));
  }
  .group:focus .sm\\:group-focus\\:border-purple-900 {
    --border-opacity: 1;
    border-color: #4a1d96;
    border-color: rgba(74, 29, 150, var(--border-opacity));
  }
  .group:focus .sm\\:group-focus\\:border-pink-50 {
    --border-opacity: 1;
    border-color: #fdf2f8;
    border-color: rgba(253, 242, 248, var(--border-opacity));
  }
  .group:focus .sm\\:group-focus\\:border-pink-100 {
    --border-opacity: 1;
    border-color: #fce8f3;
    border-color: rgba(252, 232, 243, var(--border-opacity));
  }
  .group:focus .sm\\:group-focus\\:border-pink-200 {
    --border-opacity: 1;
    border-color: #fad1e8;
    border-color: rgba(250, 209, 232, var(--border-opacity));
  }
  .group:focus .sm\\:group-focus\\:border-pink-300 {
    --border-opacity: 1;
    border-color: #f8b4d9;
    border-color: rgba(248, 180, 217, var(--border-opacity));
  }
  .group:focus .sm\\:group-focus\\:border-pink-400 {
    --border-opacity: 1;
    border-color: #f17eb8;
    border-color: rgba(241, 126, 184, var(--border-opacity));
  }
  .group:focus .sm\\:group-focus\\:border-pink-500 {
    --border-opacity: 1;
    border-color: #e74694;
    border-color: rgba(231, 70, 148, var(--border-opacity));
  }
  .group:focus .sm\\:group-focus\\:border-pink-600 {
    --border-opacity: 1;
    border-color: #d61f69;
    border-color: rgba(214, 31, 105, var(--border-opacity));
  }
  .group:focus .sm\\:group-focus\\:border-pink-700 {
    --border-opacity: 1;
    border-color: #bf125d;
    border-color: rgba(191, 18, 93, var(--border-opacity));
  }
  .group:focus .sm\\:group-focus\\:border-pink-800 {
    --border-opacity: 1;
    border-color: #99154b;
    border-color: rgba(153, 21, 75, var(--border-opacity));
  }
  .group:focus .sm\\:group-focus\\:border-pink-900 {
    --border-opacity: 1;
    border-color: #751a3d;
    border-color: rgba(117, 26, 61, var(--border-opacity));
  }
  .group:focus .sm\\:group-focus\\:border-cool-gray-50 {
    --border-opacity: 1;
    border-color: #f8fafc;
    border-color: rgba(248, 250, 252, var(--border-opacity));
  }
  .group:focus .sm\\:group-focus\\:border-cool-gray-100 {
    --border-opacity: 1;
    border-color: #f1f5f9;
    border-color: rgba(241, 245, 249, var(--border-opacity));
  }
  .group:focus .sm\\:group-focus\\:border-cool-gray-200 {
    --border-opacity: 1;
    border-color: #e2e8f0;
    border-color: rgba(226, 232, 240, var(--border-opacity));
  }
  .group:focus .sm\\:group-focus\\:border-cool-gray-300 {
    --border-opacity: 1;
    border-color: #cfd8e3;
    border-color: rgba(207, 216, 227, var(--border-opacity));
  }
  .group:focus .sm\\:group-focus\\:border-cool-gray-400 {
    --border-opacity: 1;
    border-color: #97a6ba;
    border-color: rgba(151, 166, 186, var(--border-opacity));
  }
  .group:focus .sm\\:group-focus\\:border-cool-gray-500 {
    --border-opacity: 1;
    border-color: #64748b;
    border-color: rgba(100, 116, 139, var(--border-opacity));
  }
  .group:focus .sm\\:group-focus\\:border-cool-gray-600 {
    --border-opacity: 1;
    border-color: #475569;
    border-color: rgba(71, 85, 105, var(--border-opacity));
  }
  .group:focus .sm\\:group-focus\\:border-cool-gray-700 {
    --border-opacity: 1;
    border-color: #364152;
    border-color: rgba(54, 65, 82, var(--border-opacity));
  }
  .group:focus .sm\\:group-focus\\:border-cool-gray-800 {
    --border-opacity: 1;
    border-color: #27303f;
    border-color: rgba(39, 48, 63, var(--border-opacity));
  }
  .group:focus .sm\\:group-focus\\:border-cool-gray-900 {
    --border-opacity: 1;
    border-color: #1a202e;
    border-color: rgba(26, 32, 46, var(--border-opacity));
  }
  .sm\\:hover\\:border-current:hover {
    border-color: currentColor;
  }
  .sm\\:hover\\:border-transparent:hover {
    border-color: transparent;
  }
  .sm\\:hover\\:border-white:hover {
    --border-opacity: 1;
    border-color: #ffffff;
    border-color: rgba(255, 255, 255, var(--border-opacity));
  }
  .sm\\:hover\\:border-black:hover {
    --border-opacity: 1;
    border-color: #000000;
    border-color: rgba(0, 0, 0, var(--border-opacity));
  }
  .sm\\:hover\\:border-gray-50:hover {
    --border-opacity: 1;
    border-color: #f9fafb;
    border-color: rgba(249, 250, 251, var(--border-opacity));
  }
  .sm\\:hover\\:border-gray-100:hover {
    --border-opacity: 1;
    border-color: #f4f5f7;
    border-color: rgba(244, 245, 247, var(--border-opacity));
  }
  .sm\\:hover\\:border-gray-200:hover {
    --border-opacity: 1;
    border-color: #e5e7eb;
    border-color: rgba(229, 231, 235, var(--border-opacity));
  }
  .sm\\:hover\\:border-gray-300:hover {
    --border-opacity: 1;
    border-color: #d2d6dc;
    border-color: rgba(210, 214, 220, var(--border-opacity));
  }
  .sm\\:hover\\:border-gray-400:hover {
    --border-opacity: 1;
    border-color: #9fa6b2;
    border-color: rgba(159, 166, 178, var(--border-opacity));
  }
  .sm\\:hover\\:border-gray-500:hover {
    --border-opacity: 1;
    border-color: #6b7280;
    border-color: rgba(107, 114, 128, var(--border-opacity));
  }
  .sm\\:hover\\:border-gray-600:hover {
    --border-opacity: 1;
    border-color: #4b5563;
    border-color: rgba(75, 85, 99, var(--border-opacity));
  }
  .sm\\:hover\\:border-gray-700:hover {
    --border-opacity: 1;
    border-color: #374151;
    border-color: rgba(55, 65, 81, var(--border-opacity));
  }
  .sm\\:hover\\:border-gray-800:hover {
    --border-opacity: 1;
    border-color: #252f3f;
    border-color: rgba(37, 47, 63, var(--border-opacity));
  }
  .sm\\:hover\\:border-gray-900:hover {
    --border-opacity: 1;
    border-color: #161e2e;
    border-color: rgba(22, 30, 46, var(--border-opacity));
  }
  .sm\\:hover\\:border-red-50:hover {
    --border-opacity: 1;
    border-color: #fdf2f2;
    border-color: rgba(253, 242, 242, var(--border-opacity));
  }
  .sm\\:hover\\:border-red-100:hover {
    --border-opacity: 1;
    border-color: #fde8e8;
    border-color: rgba(253, 232, 232, var(--border-opacity));
  }
  .sm\\:hover\\:border-red-200:hover {
    --border-opacity: 1;
    border-color: #fbd5d5;
    border-color: rgba(251, 213, 213, var(--border-opacity));
  }
  .sm\\:hover\\:border-red-300:hover {
    --border-opacity: 1;
    border-color: #f8b4b4;
    border-color: rgba(248, 180, 180, var(--border-opacity));
  }
  .sm\\:hover\\:border-red-400:hover {
    --border-opacity: 1;
    border-color: #f98080;
    border-color: rgba(249, 128, 128, var(--border-opacity));
  }
  .sm\\:hover\\:border-red-500:hover {
    --border-opacity: 1;
    border-color: #f05252;
    border-color: rgba(240, 82, 82, var(--border-opacity));
  }
  .sm\\:hover\\:border-red-600:hover {
    --border-opacity: 1;
    border-color: #e02424;
    border-color: rgba(224, 36, 36, var(--border-opacity));
  }
  .sm\\:hover\\:border-red-700:hover {
    --border-opacity: 1;
    border-color: #c81e1e;
    border-color: rgba(200, 30, 30, var(--border-opacity));
  }
  .sm\\:hover\\:border-red-800:hover {
    --border-opacity: 1;
    border-color: #9b1c1c;
    border-color: rgba(155, 28, 28, var(--border-opacity));
  }
  .sm\\:hover\\:border-red-900:hover {
    --border-opacity: 1;
    border-color: #771d1d;
    border-color: rgba(119, 29, 29, var(--border-opacity));
  }
  .sm\\:hover\\:border-orange-50:hover {
    --border-opacity: 1;
    border-color: #fff8f1;
    border-color: rgba(255, 248, 241, var(--border-opacity));
  }
  .sm\\:hover\\:border-orange-100:hover {
    --border-opacity: 1;
    border-color: #feecdc;
    border-color: rgba(254, 236, 220, var(--border-opacity));
  }
  .sm\\:hover\\:border-orange-200:hover {
    --border-opacity: 1;
    border-color: #fcd9bd;
    border-color: rgba(252, 217, 189, var(--border-opacity));
  }
  .sm\\:hover\\:border-orange-300:hover {
    --border-opacity: 1;
    border-color: #fdba8c;
    border-color: rgba(253, 186, 140, var(--border-opacity));
  }
  .sm\\:hover\\:border-orange-400:hover {
    --border-opacity: 1;
    border-color: #ff8a4c;
    border-color: rgba(255, 138, 76, var(--border-opacity));
  }
  .sm\\:hover\\:border-orange-500:hover {
    --border-opacity: 1;
    border-color: #ff5a1f;
    border-color: rgba(255, 90, 31, var(--border-opacity));
  }
  .sm\\:hover\\:border-orange-600:hover {
    --border-opacity: 1;
    border-color: #d03801;
    border-color: rgba(208, 56, 1, var(--border-opacity));
  }
  .sm\\:hover\\:border-orange-700:hover {
    --border-opacity: 1;
    border-color: #b43403;
    border-color: rgba(180, 52, 3, var(--border-opacity));
  }
  .sm\\:hover\\:border-orange-800:hover {
    --border-opacity: 1;
    border-color: #8a2c0d;
    border-color: rgba(138, 44, 13, var(--border-opacity));
  }
  .sm\\:hover\\:border-orange-900:hover {
    --border-opacity: 1;
    border-color: #73230d;
    border-color: rgba(115, 35, 13, var(--border-opacity));
  }
  .sm\\:hover\\:border-yellow-50:hover {
    --border-opacity: 1;
    border-color: #fdfdea;
    border-color: rgba(253, 253, 234, var(--border-opacity));
  }
  .sm\\:hover\\:border-yellow-100:hover {
    --border-opacity: 1;
    border-color: #fdf6b2;
    border-color: rgba(253, 246, 178, var(--border-opacity));
  }
  .sm\\:hover\\:border-yellow-200:hover {
    --border-opacity: 1;
    border-color: #fce96a;
    border-color: rgba(252, 233, 106, var(--border-opacity));
  }
  .sm\\:hover\\:border-yellow-300:hover {
    --border-opacity: 1;
    border-color: #faca15;
    border-color: rgba(250, 202, 21, var(--border-opacity));
  }
  .sm\\:hover\\:border-yellow-400:hover {
    --border-opacity: 1;
    border-color: #e3a008;
    border-color: rgba(227, 160, 8, var(--border-opacity));
  }
  .sm\\:hover\\:border-yellow-500:hover {
    --border-opacity: 1;
    border-color: #c27803;
    border-color: rgba(194, 120, 3, var(--border-opacity));
  }
  .sm\\:hover\\:border-yellow-600:hover {
    --border-opacity: 1;
    border-color: #9f580a;
    border-color: rgba(159, 88, 10, var(--border-opacity));
  }
  .sm\\:hover\\:border-yellow-700:hover {
    --border-opacity: 1;
    border-color: #8e4b10;
    border-color: rgba(142, 75, 16, var(--border-opacity));
  }
  .sm\\:hover\\:border-yellow-800:hover {
    --border-opacity: 1;
    border-color: #723b13;
    border-color: rgba(114, 59, 19, var(--border-opacity));
  }
  .sm\\:hover\\:border-yellow-900:hover {
    --border-opacity: 1;
    border-color: #633112;
    border-color: rgba(99, 49, 18, var(--border-opacity));
  }
  .sm\\:hover\\:border-green-50:hover {
    --border-opacity: 1;
    border-color: #f3faf7;
    border-color: rgba(243, 250, 247, var(--border-opacity));
  }
  .sm\\:hover\\:border-green-100:hover {
    --border-opacity: 1;
    border-color: #def7ec;
    border-color: rgba(222, 247, 236, var(--border-opacity));
  }
  .sm\\:hover\\:border-green-200:hover {
    --border-opacity: 1;
    border-color: #bcf0da;
    border-color: rgba(188, 240, 218, var(--border-opacity));
  }
  .sm\\:hover\\:border-green-300:hover {
    --border-opacity: 1;
    border-color: #84e1bc;
    border-color: rgba(132, 225, 188, var(--border-opacity));
  }
  .sm\\:hover\\:border-green-400:hover {
    --border-opacity: 1;
    border-color: #31c48d;
    border-color: rgba(49, 196, 141, var(--border-opacity));
  }
  .sm\\:hover\\:border-green-500:hover {
    --border-opacity: 1;
    border-color: #0e9f6e;
    border-color: rgba(14, 159, 110, var(--border-opacity));
  }
  .sm\\:hover\\:border-green-600:hover {
    --border-opacity: 1;
    border-color: #057a55;
    border-color: rgba(5, 122, 85, var(--border-opacity));
  }
  .sm\\:hover\\:border-green-700:hover {
    --border-opacity: 1;
    border-color: #046c4e;
    border-color: rgba(4, 108, 78, var(--border-opacity));
  }
  .sm\\:hover\\:border-green-800:hover {
    --border-opacity: 1;
    border-color: #03543f;
    border-color: rgba(3, 84, 63, var(--border-opacity));
  }
  .sm\\:hover\\:border-green-900:hover {
    --border-opacity: 1;
    border-color: #014737;
    border-color: rgba(1, 71, 55, var(--border-opacity));
  }
  .sm\\:hover\\:border-teal-50:hover {
    --border-opacity: 1;
    border-color: #edfafa;
    border-color: rgba(237, 250, 250, var(--border-opacity));
  }
  .sm\\:hover\\:border-teal-100:hover {
    --border-opacity: 1;
    border-color: #d5f5f6;
    border-color: rgba(213, 245, 246, var(--border-opacity));
  }
  .sm\\:hover\\:border-teal-200:hover {
    --border-opacity: 1;
    border-color: #afecef;
    border-color: rgba(175, 236, 239, var(--border-opacity));
  }
  .sm\\:hover\\:border-teal-300:hover {
    --border-opacity: 1;
    border-color: #7edce2;
    border-color: rgba(126, 220, 226, var(--border-opacity));
  }
  .sm\\:hover\\:border-teal-400:hover {
    --border-opacity: 1;
    border-color: #16bdca;
    border-color: rgba(22, 189, 202, var(--border-opacity));
  }
  .sm\\:hover\\:border-teal-500:hover {
    --border-opacity: 1;
    border-color: #0694a2;
    border-color: rgba(6, 148, 162, var(--border-opacity));
  }
  .sm\\:hover\\:border-teal-600:hover {
    --border-opacity: 1;
    border-color: #047481;
    border-color: rgba(4, 116, 129, var(--border-opacity));
  }
  .sm\\:hover\\:border-teal-700:hover {
    --border-opacity: 1;
    border-color: #036672;
    border-color: rgba(3, 102, 114, var(--border-opacity));
  }
  .sm\\:hover\\:border-teal-800:hover {
    --border-opacity: 1;
    border-color: #05505c;
    border-color: rgba(5, 80, 92, var(--border-opacity));
  }
  .sm\\:hover\\:border-teal-900:hover {
    --border-opacity: 1;
    border-color: #014451;
    border-color: rgba(1, 68, 81, var(--border-opacity));
  }
  .sm\\:hover\\:border-blue-50:hover {
    --border-opacity: 1;
    border-color: #ebf5ff;
    border-color: rgba(235, 245, 255, var(--border-opacity));
  }
  .sm\\:hover\\:border-blue-100:hover {
    --border-opacity: 1;
    border-color: #e1effe;
    border-color: rgba(225, 239, 254, var(--border-opacity));
  }
  .sm\\:hover\\:border-blue-200:hover {
    --border-opacity: 1;
    border-color: #c3ddfd;
    border-color: rgba(195, 221, 253, var(--border-opacity));
  }
  .sm\\:hover\\:border-blue-300:hover {
    --border-opacity: 1;
    border-color: #a4cafe;
    border-color: rgba(164, 202, 254, var(--border-opacity));
  }
  .sm\\:hover\\:border-blue-400:hover {
    --border-opacity: 1;
    border-color: #76a9fa;
    border-color: rgba(118, 169, 250, var(--border-opacity));
  }
  .sm\\:hover\\:border-blue-500:hover {
    --border-opacity: 1;
    border-color: #3f83f8;
    border-color: rgba(63, 131, 248, var(--border-opacity));
  }
  .sm\\:hover\\:border-blue-600:hover {
    --border-opacity: 1;
    border-color: #1c64f2;
    border-color: rgba(28, 100, 242, var(--border-opacity));
  }
  .sm\\:hover\\:border-blue-700:hover {
    --border-opacity: 1;
    border-color: #1a56db;
    border-color: rgba(26, 86, 219, var(--border-opacity));
  }
  .sm\\:hover\\:border-blue-800:hover {
    --border-opacity: 1;
    border-color: #1e429f;
    border-color: rgba(30, 66, 159, var(--border-opacity));
  }
  .sm\\:hover\\:border-blue-900:hover {
    --border-opacity: 1;
    border-color: #233876;
    border-color: rgba(35, 56, 118, var(--border-opacity));
  }
  .sm\\:hover\\:border-indigo-50:hover {
    --border-opacity: 1;
    border-color: #f0f5ff;
    border-color: rgba(240, 245, 255, var(--border-opacity));
  }
  .sm\\:hover\\:border-indigo-100:hover {
    --border-opacity: 1;
    border-color: #e5edff;
    border-color: rgba(229, 237, 255, var(--border-opacity));
  }
  .sm\\:hover\\:border-indigo-200:hover {
    --border-opacity: 1;
    border-color: #cddbfe;
    border-color: rgba(205, 219, 254, var(--border-opacity));
  }
  .sm\\:hover\\:border-indigo-300:hover {
    --border-opacity: 1;
    border-color: #b4c6fc;
    border-color: rgba(180, 198, 252, var(--border-opacity));
  }
  .sm\\:hover\\:border-indigo-400:hover {
    --border-opacity: 1;
    border-color: #8da2fb;
    border-color: rgba(141, 162, 251, var(--border-opacity));
  }
  .sm\\:hover\\:border-indigo-500:hover {
    --border-opacity: 1;
    border-color: #6875f5;
    border-color: rgba(104, 117, 245, var(--border-opacity));
  }
  .sm\\:hover\\:border-indigo-600:hover {
    --border-opacity: 1;
    border-color: #5850ec;
    border-color: rgba(88, 80, 236, var(--border-opacity));
  }
  .sm\\:hover\\:border-indigo-700:hover {
    --border-opacity: 1;
    border-color: #5145cd;
    border-color: rgba(81, 69, 205, var(--border-opacity));
  }
  .sm\\:hover\\:border-indigo-800:hover {
    --border-opacity: 1;
    border-color: #42389d;
    border-color: rgba(66, 56, 157, var(--border-opacity));
  }
  .sm\\:hover\\:border-indigo-900:hover {
    --border-opacity: 1;
    border-color: #362f78;
    border-color: rgba(54, 47, 120, var(--border-opacity));
  }
  .sm\\:hover\\:border-purple-50:hover {
    --border-opacity: 1;
    border-color: #f6f5ff;
    border-color: rgba(246, 245, 255, var(--border-opacity));
  }
  .sm\\:hover\\:border-purple-100:hover {
    --border-opacity: 1;
    border-color: #edebfe;
    border-color: rgba(237, 235, 254, var(--border-opacity));
  }
  .sm\\:hover\\:border-purple-200:hover {
    --border-opacity: 1;
    border-color: #dcd7fe;
    border-color: rgba(220, 215, 254, var(--border-opacity));
  }
  .sm\\:hover\\:border-purple-300:hover {
    --border-opacity: 1;
    border-color: #cabffd;
    border-color: rgba(202, 191, 253, var(--border-opacity));
  }
  .sm\\:hover\\:border-purple-400:hover {
    --border-opacity: 1;
    border-color: #ac94fa;
    border-color: rgba(172, 148, 250, var(--border-opacity));
  }
  .sm\\:hover\\:border-purple-500:hover {
    --border-opacity: 1;
    border-color: #9061f9;
    border-color: rgba(144, 97, 249, var(--border-opacity));
  }
  .sm\\:hover\\:border-purple-600:hover {
    --border-opacity: 1;
    border-color: #7e3af2;
    border-color: rgba(126, 58, 242, var(--border-opacity));
  }
  .sm\\:hover\\:border-purple-700:hover {
    --border-opacity: 1;
    border-color: #6c2bd9;
    border-color: rgba(108, 43, 217, var(--border-opacity));
  }
  .sm\\:hover\\:border-purple-800:hover {
    --border-opacity: 1;
    border-color: #5521b5;
    border-color: rgba(85, 33, 181, var(--border-opacity));
  }
  .sm\\:hover\\:border-purple-900:hover {
    --border-opacity: 1;
    border-color: #4a1d96;
    border-color: rgba(74, 29, 150, var(--border-opacity));
  }
  .sm\\:hover\\:border-pink-50:hover {
    --border-opacity: 1;
    border-color: #fdf2f8;
    border-color: rgba(253, 242, 248, var(--border-opacity));
  }
  .sm\\:hover\\:border-pink-100:hover {
    --border-opacity: 1;
    border-color: #fce8f3;
    border-color: rgba(252, 232, 243, var(--border-opacity));
  }
  .sm\\:hover\\:border-pink-200:hover {
    --border-opacity: 1;
    border-color: #fad1e8;
    border-color: rgba(250, 209, 232, var(--border-opacity));
  }
  .sm\\:hover\\:border-pink-300:hover {
    --border-opacity: 1;
    border-color: #f8b4d9;
    border-color: rgba(248, 180, 217, var(--border-opacity));
  }
  .sm\\:hover\\:border-pink-400:hover {
    --border-opacity: 1;
    border-color: #f17eb8;
    border-color: rgba(241, 126, 184, var(--border-opacity));
  }
  .sm\\:hover\\:border-pink-500:hover {
    --border-opacity: 1;
    border-color: #e74694;
    border-color: rgba(231, 70, 148, var(--border-opacity));
  }
  .sm\\:hover\\:border-pink-600:hover {
    --border-opacity: 1;
    border-color: #d61f69;
    border-color: rgba(214, 31, 105, var(--border-opacity));
  }
  .sm\\:hover\\:border-pink-700:hover {
    --border-opacity: 1;
    border-color: #bf125d;
    border-color: rgba(191, 18, 93, var(--border-opacity));
  }
  .sm\\:hover\\:border-pink-800:hover {
    --border-opacity: 1;
    border-color: #99154b;
    border-color: rgba(153, 21, 75, var(--border-opacity));
  }
  .sm\\:hover\\:border-pink-900:hover {
    --border-opacity: 1;
    border-color: #751a3d;
    border-color: rgba(117, 26, 61, var(--border-opacity));
  }
  .sm\\:hover\\:border-cool-gray-50:hover {
    --border-opacity: 1;
    border-color: #f8fafc;
    border-color: rgba(248, 250, 252, var(--border-opacity));
  }
  .sm\\:hover\\:border-cool-gray-100:hover {
    --border-opacity: 1;
    border-color: #f1f5f9;
    border-color: rgba(241, 245, 249, var(--border-opacity));
  }
  .sm\\:hover\\:border-cool-gray-200:hover {
    --border-opacity: 1;
    border-color: #e2e8f0;
    border-color: rgba(226, 232, 240, var(--border-opacity));
  }
  .sm\\:hover\\:border-cool-gray-300:hover {
    --border-opacity: 1;
    border-color: #cfd8e3;
    border-color: rgba(207, 216, 227, var(--border-opacity));
  }
  .sm\\:hover\\:border-cool-gray-400:hover {
    --border-opacity: 1;
    border-color: #97a6ba;
    border-color: rgba(151, 166, 186, var(--border-opacity));
  }
  .sm\\:hover\\:border-cool-gray-500:hover {
    --border-opacity: 1;
    border-color: #64748b;
    border-color: rgba(100, 116, 139, var(--border-opacity));
  }
  .sm\\:hover\\:border-cool-gray-600:hover {
    --border-opacity: 1;
    border-color: #475569;
    border-color: rgba(71, 85, 105, var(--border-opacity));
  }
  .sm\\:hover\\:border-cool-gray-700:hover {
    --border-opacity: 1;
    border-color: #364152;
    border-color: rgba(54, 65, 82, var(--border-opacity));
  }
  .sm\\:hover\\:border-cool-gray-800:hover {
    --border-opacity: 1;
    border-color: #27303f;
    border-color: rgba(39, 48, 63, var(--border-opacity));
  }
  .sm\\:hover\\:border-cool-gray-900:hover {
    --border-opacity: 1;
    border-color: #1a202e;
    border-color: rgba(26, 32, 46, var(--border-opacity));
  }
  .sm\\:focus-within\\:border-current:focus-within {
    border-color: currentColor;
  }
  .sm\\:focus-within\\:border-transparent:focus-within {
    border-color: transparent;
  }
  .sm\\:focus-within\\:border-white:focus-within {
    --border-opacity: 1;
    border-color: #ffffff;
    border-color: rgba(255, 255, 255, var(--border-opacity));
  }
  .sm\\:focus-within\\:border-black:focus-within {
    --border-opacity: 1;
    border-color: #000000;
    border-color: rgba(0, 0, 0, var(--border-opacity));
  }
  .sm\\:focus-within\\:border-gray-50:focus-within {
    --border-opacity: 1;
    border-color: #f9fafb;
    border-color: rgba(249, 250, 251, var(--border-opacity));
  }
  .sm\\:focus-within\\:border-gray-100:focus-within {
    --border-opacity: 1;
    border-color: #f4f5f7;
    border-color: rgba(244, 245, 247, var(--border-opacity));
  }
  .sm\\:focus-within\\:border-gray-200:focus-within {
    --border-opacity: 1;
    border-color: #e5e7eb;
    border-color: rgba(229, 231, 235, var(--border-opacity));
  }
  .sm\\:focus-within\\:border-gray-300:focus-within {
    --border-opacity: 1;
    border-color: #d2d6dc;
    border-color: rgba(210, 214, 220, var(--border-opacity));
  }
  .sm\\:focus-within\\:border-gray-400:focus-within {
    --border-opacity: 1;
    border-color: #9fa6b2;
    border-color: rgba(159, 166, 178, var(--border-opacity));
  }
  .sm\\:focus-within\\:border-gray-500:focus-within {
    --border-opacity: 1;
    border-color: #6b7280;
    border-color: rgba(107, 114, 128, var(--border-opacity));
  }
  .sm\\:focus-within\\:border-gray-600:focus-within {
    --border-opacity: 1;
    border-color: #4b5563;
    border-color: rgba(75, 85, 99, var(--border-opacity));
  }
  .sm\\:focus-within\\:border-gray-700:focus-within {
    --border-opacity: 1;
    border-color: #374151;
    border-color: rgba(55, 65, 81, var(--border-opacity));
  }
  .sm\\:focus-within\\:border-gray-800:focus-within {
    --border-opacity: 1;
    border-color: #252f3f;
    border-color: rgba(37, 47, 63, var(--border-opacity));
  }
  .sm\\:focus-within\\:border-gray-900:focus-within {
    --border-opacity: 1;
    border-color: #161e2e;
    border-color: rgba(22, 30, 46, var(--border-opacity));
  }
  .sm\\:focus-within\\:border-red-50:focus-within {
    --border-opacity: 1;
    border-color: #fdf2f2;
    border-color: rgba(253, 242, 242, var(--border-opacity));
  }
  .sm\\:focus-within\\:border-red-100:focus-within {
    --border-opacity: 1;
    border-color: #fde8e8;
    border-color: rgba(253, 232, 232, var(--border-opacity));
  }
  .sm\\:focus-within\\:border-red-200:focus-within {
    --border-opacity: 1;
    border-color: #fbd5d5;
    border-color: rgba(251, 213, 213, var(--border-opacity));
  }
  .sm\\:focus-within\\:border-red-300:focus-within {
    --border-opacity: 1;
    border-color: #f8b4b4;
    border-color: rgba(248, 180, 180, var(--border-opacity));
  }
  .sm\\:focus-within\\:border-red-400:focus-within {
    --border-opacity: 1;
    border-color: #f98080;
    border-color: rgba(249, 128, 128, var(--border-opacity));
  }
  .sm\\:focus-within\\:border-red-500:focus-within {
    --border-opacity: 1;
    border-color: #f05252;
    border-color: rgba(240, 82, 82, var(--border-opacity));
  }
  .sm\\:focus-within\\:border-red-600:focus-within {
    --border-opacity: 1;
    border-color: #e02424;
    border-color: rgba(224, 36, 36, var(--border-opacity));
  }
  .sm\\:focus-within\\:border-red-700:focus-within {
    --border-opacity: 1;
    border-color: #c81e1e;
    border-color: rgba(200, 30, 30, var(--border-opacity));
  }
  .sm\\:focus-within\\:border-red-800:focus-within {
    --border-opacity: 1;
    border-color: #9b1c1c;
    border-color: rgba(155, 28, 28, var(--border-opacity));
  }
  .sm\\:focus-within\\:border-red-900:focus-within {
    --border-opacity: 1;
    border-color: #771d1d;
    border-color: rgba(119, 29, 29, var(--border-opacity));
  }
  .sm\\:focus-within\\:border-orange-50:focus-within {
    --border-opacity: 1;
    border-color: #fff8f1;
    border-color: rgba(255, 248, 241, var(--border-opacity));
  }
  .sm\\:focus-within\\:border-orange-100:focus-within {
    --border-opacity: 1;
    border-color: #feecdc;
    border-color: rgba(254, 236, 220, var(--border-opacity));
  }
  .sm\\:focus-within\\:border-orange-200:focus-within {
    --border-opacity: 1;
    border-color: #fcd9bd;
    border-color: rgba(252, 217, 189, var(--border-opacity));
  }
  .sm\\:focus-within\\:border-orange-300:focus-within {
    --border-opacity: 1;
    border-color: #fdba8c;
    border-color: rgba(253, 186, 140, var(--border-opacity));
  }
  .sm\\:focus-within\\:border-orange-400:focus-within {
    --border-opacity: 1;
    border-color: #ff8a4c;
    border-color: rgba(255, 138, 76, var(--border-opacity));
  }
  .sm\\:focus-within\\:border-orange-500:focus-within {
    --border-opacity: 1;
    border-color: #ff5a1f;
    border-color: rgba(255, 90, 31, var(--border-opacity));
  }
  .sm\\:focus-within\\:border-orange-600:focus-within {
    --border-opacity: 1;
    border-color: #d03801;
    border-color: rgba(208, 56, 1, var(--border-opacity));
  }
  .sm\\:focus-within\\:border-orange-700:focus-within {
    --border-opacity: 1;
    border-color: #b43403;
    border-color: rgba(180, 52, 3, var(--border-opacity));
  }
  .sm\\:focus-within\\:border-orange-800:focus-within {
    --border-opacity: 1;
    border-color: #8a2c0d;
    border-color: rgba(138, 44, 13, var(--border-opacity));
  }
  .sm\\:focus-within\\:border-orange-900:focus-within {
    --border-opacity: 1;
    border-color: #73230d;
    border-color: rgba(115, 35, 13, var(--border-opacity));
  }
  .sm\\:focus-within\\:border-yellow-50:focus-within {
    --border-opacity: 1;
    border-color: #fdfdea;
    border-color: rgba(253, 253, 234, var(--border-opacity));
  }
  .sm\\:focus-within\\:border-yellow-100:focus-within {
    --border-opacity: 1;
    border-color: #fdf6b2;
    border-color: rgba(253, 246, 178, var(--border-opacity));
  }
  .sm\\:focus-within\\:border-yellow-200:focus-within {
    --border-opacity: 1;
    border-color: #fce96a;
    border-color: rgba(252, 233, 106, var(--border-opacity));
  }
  .sm\\:focus-within\\:border-yellow-300:focus-within {
    --border-opacity: 1;
    border-color: #faca15;
    border-color: rgba(250, 202, 21, var(--border-opacity));
  }
  .sm\\:focus-within\\:border-yellow-400:focus-within {
    --border-opacity: 1;
    border-color: #e3a008;
    border-color: rgba(227, 160, 8, var(--border-opacity));
  }
  .sm\\:focus-within\\:border-yellow-500:focus-within {
    --border-opacity: 1;
    border-color: #c27803;
    border-color: rgba(194, 120, 3, var(--border-opacity));
  }
  .sm\\:focus-within\\:border-yellow-600:focus-within {
    --border-opacity: 1;
    border-color: #9f580a;
    border-color: rgba(159, 88, 10, var(--border-opacity));
  }
  .sm\\:focus-within\\:border-yellow-700:focus-within {
    --border-opacity: 1;
    border-color: #8e4b10;
    border-color: rgba(142, 75, 16, var(--border-opacity));
  }
  .sm\\:focus-within\\:border-yellow-800:focus-within {
    --border-opacity: 1;
    border-color: #723b13;
    border-color: rgba(114, 59, 19, var(--border-opacity));
  }
  .sm\\:focus-within\\:border-yellow-900:focus-within {
    --border-opacity: 1;
    border-color: #633112;
    border-color: rgba(99, 49, 18, var(--border-opacity));
  }
  .sm\\:focus-within\\:border-green-50:focus-within {
    --border-opacity: 1;
    border-color: #f3faf7;
    border-color: rgba(243, 250, 247, var(--border-opacity));
  }
  .sm\\:focus-within\\:border-green-100:focus-within {
    --border-opacity: 1;
    border-color: #def7ec;
    border-color: rgba(222, 247, 236, var(--border-opacity));
  }
  .sm\\:focus-within\\:border-green-200:focus-within {
    --border-opacity: 1;
    border-color: #bcf0da;
    border-color: rgba(188, 240, 218, var(--border-opacity));
  }
  .sm\\:focus-within\\:border-green-300:focus-within {
    --border-opacity: 1;
    border-color: #84e1bc;
    border-color: rgba(132, 225, 188, var(--border-opacity));
  }
  .sm\\:focus-within\\:border-green-400:focus-within {
    --border-opacity: 1;
    border-color: #31c48d;
    border-color: rgba(49, 196, 141, var(--border-opacity));
  }
  .sm\\:focus-within\\:border-green-500:focus-within {
    --border-opacity: 1;
    border-color: #0e9f6e;
    border-color: rgba(14, 159, 110, var(--border-opacity));
  }
  .sm\\:focus-within\\:border-green-600:focus-within {
    --border-opacity: 1;
    border-color: #057a55;
    border-color: rgba(5, 122, 85, var(--border-opacity));
  }
  .sm\\:focus-within\\:border-green-700:focus-within {
    --border-opacity: 1;
    border-color: #046c4e;
    border-color: rgba(4, 108, 78, var(--border-opacity));
  }
  .sm\\:focus-within\\:border-green-800:focus-within {
    --border-opacity: 1;
    border-color: #03543f;
    border-color: rgba(3, 84, 63, var(--border-opacity));
  }
  .sm\\:focus-within\\:border-green-900:focus-within {
    --border-opacity: 1;
    border-color: #014737;
    border-color: rgba(1, 71, 55, var(--border-opacity));
  }
  .sm\\:focus-within\\:border-teal-50:focus-within {
    --border-opacity: 1;
    border-color: #edfafa;
    border-color: rgba(237, 250, 250, var(--border-opacity));
  }
  .sm\\:focus-within\\:border-teal-100:focus-within {
    --border-opacity: 1;
    border-color: #d5f5f6;
    border-color: rgba(213, 245, 246, var(--border-opacity));
  }
  .sm\\:focus-within\\:border-teal-200:focus-within {
    --border-opacity: 1;
    border-color: #afecef;
    border-color: rgba(175, 236, 239, var(--border-opacity));
  }
  .sm\\:focus-within\\:border-teal-300:focus-within {
    --border-opacity: 1;
    border-color: #7edce2;
    border-color: rgba(126, 220, 226, var(--border-opacity));
  }
  .sm\\:focus-within\\:border-teal-400:focus-within {
    --border-opacity: 1;
    border-color: #16bdca;
    border-color: rgba(22, 189, 202, var(--border-opacity));
  }
  .sm\\:focus-within\\:border-teal-500:focus-within {
    --border-opacity: 1;
    border-color: #0694a2;
    border-color: rgba(6, 148, 162, var(--border-opacity));
  }
  .sm\\:focus-within\\:border-teal-600:focus-within {
    --border-opacity: 1;
    border-color: #047481;
    border-color: rgba(4, 116, 129, var(--border-opacity));
  }
  .sm\\:focus-within\\:border-teal-700:focus-within {
    --border-opacity: 1;
    border-color: #036672;
    border-color: rgba(3, 102, 114, var(--border-opacity));
  }
  .sm\\:focus-within\\:border-teal-800:focus-within {
    --border-opacity: 1;
    border-color: #05505c;
    border-color: rgba(5, 80, 92, var(--border-opacity));
  }
  .sm\\:focus-within\\:border-teal-900:focus-within {
    --border-opacity: 1;
    border-color: #014451;
    border-color: rgba(1, 68, 81, var(--border-opacity));
  }
  .sm\\:focus-within\\:border-blue-50:focus-within {
    --border-opacity: 1;
    border-color: #ebf5ff;
    border-color: rgba(235, 245, 255, var(--border-opacity));
  }
  .sm\\:focus-within\\:border-blue-100:focus-within {
    --border-opacity: 1;
    border-color: #e1effe;
    border-color: rgba(225, 239, 254, var(--border-opacity));
  }
  .sm\\:focus-within\\:border-blue-200:focus-within {
    --border-opacity: 1;
    border-color: #c3ddfd;
    border-color: rgba(195, 221, 253, var(--border-opacity));
  }
  .sm\\:focus-within\\:border-blue-300:focus-within {
    --border-opacity: 1;
    border-color: #a4cafe;
    border-color: rgba(164, 202, 254, var(--border-opacity));
  }
  .sm\\:focus-within\\:border-blue-400:focus-within {
    --border-opacity: 1;
    border-color: #76a9fa;
    border-color: rgba(118, 169, 250, var(--border-opacity));
  }
  .sm\\:focus-within\\:border-blue-500:focus-within {
    --border-opacity: 1;
    border-color: #3f83f8;
    border-color: rgba(63, 131, 248, var(--border-opacity));
  }
  .sm\\:focus-within\\:border-blue-600:focus-within {
    --border-opacity: 1;
    border-color: #1c64f2;
    border-color: rgba(28, 100, 242, var(--border-opacity));
  }
  .sm\\:focus-within\\:border-blue-700:focus-within {
    --border-opacity: 1;
    border-color: #1a56db;
    border-color: rgba(26, 86, 219, var(--border-opacity));
  }
  .sm\\:focus-within\\:border-blue-800:focus-within {
    --border-opacity: 1;
    border-color: #1e429f;
    border-color: rgba(30, 66, 159, var(--border-opacity));
  }
  .sm\\:focus-within\\:border-blue-900:focus-within {
    --border-opacity: 1;
    border-color: #233876;
    border-color: rgba(35, 56, 118, var(--border-opacity));
  }
  .sm\\:focus-within\\:border-indigo-50:focus-within {
    --border-opacity: 1;
    border-color: #f0f5ff;
    border-color: rgba(240, 245, 255, var(--border-opacity));
  }
  .sm\\:focus-within\\:border-indigo-100:focus-within {
    --border-opacity: 1;
    border-color: #e5edff;
    border-color: rgba(229, 237, 255, var(--border-opacity));
  }
  .sm\\:focus-within\\:border-indigo-200:focus-within {
    --border-opacity: 1;
    border-color: #cddbfe;
    border-color: rgba(205, 219, 254, var(--border-opacity));
  }
  .sm\\:focus-within\\:border-indigo-300:focus-within {
    --border-opacity: 1;
    border-color: #b4c6fc;
    border-color: rgba(180, 198, 252, var(--border-opacity));
  }
  .sm\\:focus-within\\:border-indigo-400:focus-within {
    --border-opacity: 1;
    border-color: #8da2fb;
    border-color: rgba(141, 162, 251, var(--border-opacity));
  }
  .sm\\:focus-within\\:border-indigo-500:focus-within {
    --border-opacity: 1;
    border-color: #6875f5;
    border-color: rgba(104, 117, 245, var(--border-opacity));
  }
  .sm\\:focus-within\\:border-indigo-600:focus-within {
    --border-opacity: 1;
    border-color: #5850ec;
    border-color: rgba(88, 80, 236, var(--border-opacity));
  }
  .sm\\:focus-within\\:border-indigo-700:focus-within {
    --border-opacity: 1;
    border-color: #5145cd;
    border-color: rgba(81, 69, 205, var(--border-opacity));
  }
  .sm\\:focus-within\\:border-indigo-800:focus-within {
    --border-opacity: 1;
    border-color: #42389d;
    border-color: rgba(66, 56, 157, var(--border-opacity));
  }
  .sm\\:focus-within\\:border-indigo-900:focus-within {
    --border-opacity: 1;
    border-color: #362f78;
    border-color: rgba(54, 47, 120, var(--border-opacity));
  }
  .sm\\:focus-within\\:border-purple-50:focus-within {
    --border-opacity: 1;
    border-color: #f6f5ff;
    border-color: rgba(246, 245, 255, var(--border-opacity));
  }
  .sm\\:focus-within\\:border-purple-100:focus-within {
    --border-opacity: 1;
    border-color: #edebfe;
    border-color: rgba(237, 235, 254, var(--border-opacity));
  }
  .sm\\:focus-within\\:border-purple-200:focus-within {
    --border-opacity: 1;
    border-color: #dcd7fe;
    border-color: rgba(220, 215, 254, var(--border-opacity));
  }
  .sm\\:focus-within\\:border-purple-300:focus-within {
    --border-opacity: 1;
    border-color: #cabffd;
    border-color: rgba(202, 191, 253, var(--border-opacity));
  }
  .sm\\:focus-within\\:border-purple-400:focus-within {
    --border-opacity: 1;
    border-color: #ac94fa;
    border-color: rgba(172, 148, 250, var(--border-opacity));
  }
  .sm\\:focus-within\\:border-purple-500:focus-within {
    --border-opacity: 1;
    border-color: #9061f9;
    border-color: rgba(144, 97, 249, var(--border-opacity));
  }
  .sm\\:focus-within\\:border-purple-600:focus-within {
    --border-opacity: 1;
    border-color: #7e3af2;
    border-color: rgba(126, 58, 242, var(--border-opacity));
  }
  .sm\\:focus-within\\:border-purple-700:focus-within {
    --border-opacity: 1;
    border-color: #6c2bd9;
    border-color: rgba(108, 43, 217, var(--border-opacity));
  }
  .sm\\:focus-within\\:border-purple-800:focus-within {
    --border-opacity: 1;
    border-color: #5521b5;
    border-color: rgba(85, 33, 181, var(--border-opacity));
  }
  .sm\\:focus-within\\:border-purple-900:focus-within {
    --border-opacity: 1;
    border-color: #4a1d96;
    border-color: rgba(74, 29, 150, var(--border-opacity));
  }
  .sm\\:focus-within\\:border-pink-50:focus-within {
    --border-opacity: 1;
    border-color: #fdf2f8;
    border-color: rgba(253, 242, 248, var(--border-opacity));
  }
  .sm\\:focus-within\\:border-pink-100:focus-within {
    --border-opacity: 1;
    border-color: #fce8f3;
    border-color: rgba(252, 232, 243, var(--border-opacity));
  }
  .sm\\:focus-within\\:border-pink-200:focus-within {
    --border-opacity: 1;
    border-color: #fad1e8;
    border-color: rgba(250, 209, 232, var(--border-opacity));
  }
  .sm\\:focus-within\\:border-pink-300:focus-within {
    --border-opacity: 1;
    border-color: #f8b4d9;
    border-color: rgba(248, 180, 217, var(--border-opacity));
  }
  .sm\\:focus-within\\:border-pink-400:focus-within {
    --border-opacity: 1;
    border-color: #f17eb8;
    border-color: rgba(241, 126, 184, var(--border-opacity));
  }
  .sm\\:focus-within\\:border-pink-500:focus-within {
    --border-opacity: 1;
    border-color: #e74694;
    border-color: rgba(231, 70, 148, var(--border-opacity));
  }
  .sm\\:focus-within\\:border-pink-600:focus-within {
    --border-opacity: 1;
    border-color: #d61f69;
    border-color: rgba(214, 31, 105, var(--border-opacity));
  }
  .sm\\:focus-within\\:border-pink-700:focus-within {
    --border-opacity: 1;
    border-color: #bf125d;
    border-color: rgba(191, 18, 93, var(--border-opacity));
  }
  .sm\\:focus-within\\:border-pink-800:focus-within {
    --border-opacity: 1;
    border-color: #99154b;
    border-color: rgba(153, 21, 75, var(--border-opacity));
  }
  .sm\\:focus-within\\:border-pink-900:focus-within {
    --border-opacity: 1;
    border-color: #751a3d;
    border-color: rgba(117, 26, 61, var(--border-opacity));
  }
  .sm\\:focus-within\\:border-cool-gray-50:focus-within {
    --border-opacity: 1;
    border-color: #f8fafc;
    border-color: rgba(248, 250, 252, var(--border-opacity));
  }
  .sm\\:focus-within\\:border-cool-gray-100:focus-within {
    --border-opacity: 1;
    border-color: #f1f5f9;
    border-color: rgba(241, 245, 249, var(--border-opacity));
  }
  .sm\\:focus-within\\:border-cool-gray-200:focus-within {
    --border-opacity: 1;
    border-color: #e2e8f0;
    border-color: rgba(226, 232, 240, var(--border-opacity));
  }
  .sm\\:focus-within\\:border-cool-gray-300:focus-within {
    --border-opacity: 1;
    border-color: #cfd8e3;
    border-color: rgba(207, 216, 227, var(--border-opacity));
  }
  .sm\\:focus-within\\:border-cool-gray-400:focus-within {
    --border-opacity: 1;
    border-color: #97a6ba;
    border-color: rgba(151, 166, 186, var(--border-opacity));
  }
  .sm\\:focus-within\\:border-cool-gray-500:focus-within {
    --border-opacity: 1;
    border-color: #64748b;
    border-color: rgba(100, 116, 139, var(--border-opacity));
  }
  .sm\\:focus-within\\:border-cool-gray-600:focus-within {
    --border-opacity: 1;
    border-color: #475569;
    border-color: rgba(71, 85, 105, var(--border-opacity));
  }
  .sm\\:focus-within\\:border-cool-gray-700:focus-within {
    --border-opacity: 1;
    border-color: #364152;
    border-color: rgba(54, 65, 82, var(--border-opacity));
  }
  .sm\\:focus-within\\:border-cool-gray-800:focus-within {
    --border-opacity: 1;
    border-color: #27303f;
    border-color: rgba(39, 48, 63, var(--border-opacity));
  }
  .sm\\:focus-within\\:border-cool-gray-900:focus-within {
    --border-opacity: 1;
    border-color: #1a202e;
    border-color: rgba(26, 32, 46, var(--border-opacity));
  }
  .sm\\:focus\\:border-current:focus {
    border-color: currentColor;
  }
  .sm\\:focus\\:border-transparent:focus {
    border-color: transparent;
  }
  .sm\\:focus\\:border-white:focus {
    --border-opacity: 1;
    border-color: #ffffff;
    border-color: rgba(255, 255, 255, var(--border-opacity));
  }
  .sm\\:focus\\:border-black:focus {
    --border-opacity: 1;
    border-color: #000000;
    border-color: rgba(0, 0, 0, var(--border-opacity));
  }
  .sm\\:focus\\:border-gray-50:focus {
    --border-opacity: 1;
    border-color: #f9fafb;
    border-color: rgba(249, 250, 251, var(--border-opacity));
  }
  .sm\\:focus\\:border-gray-100:focus {
    --border-opacity: 1;
    border-color: #f4f5f7;
    border-color: rgba(244, 245, 247, var(--border-opacity));
  }
  .sm\\:focus\\:border-gray-200:focus {
    --border-opacity: 1;
    border-color: #e5e7eb;
    border-color: rgba(229, 231, 235, var(--border-opacity));
  }
  .sm\\:focus\\:border-gray-300:focus {
    --border-opacity: 1;
    border-color: #d2d6dc;
    border-color: rgba(210, 214, 220, var(--border-opacity));
  }
  .sm\\:focus\\:border-gray-400:focus {
    --border-opacity: 1;
    border-color: #9fa6b2;
    border-color: rgba(159, 166, 178, var(--border-opacity));
  }
  .sm\\:focus\\:border-gray-500:focus {
    --border-opacity: 1;
    border-color: #6b7280;
    border-color: rgba(107, 114, 128, var(--border-opacity));
  }
  .sm\\:focus\\:border-gray-600:focus {
    --border-opacity: 1;
    border-color: #4b5563;
    border-color: rgba(75, 85, 99, var(--border-opacity));
  }
  .sm\\:focus\\:border-gray-700:focus {
    --border-opacity: 1;
    border-color: #374151;
    border-color: rgba(55, 65, 81, var(--border-opacity));
  }
  .sm\\:focus\\:border-gray-800:focus {
    --border-opacity: 1;
    border-color: #252f3f;
    border-color: rgba(37, 47, 63, var(--border-opacity));
  }
  .sm\\:focus\\:border-gray-900:focus {
    --border-opacity: 1;
    border-color: #161e2e;
    border-color: rgba(22, 30, 46, var(--border-opacity));
  }
  .sm\\:focus\\:border-red-50:focus {
    --border-opacity: 1;
    border-color: #fdf2f2;
    border-color: rgba(253, 242, 242, var(--border-opacity));
  }
  .sm\\:focus\\:border-red-100:focus {
    --border-opacity: 1;
    border-color: #fde8e8;
    border-color: rgba(253, 232, 232, var(--border-opacity));
  }
  .sm\\:focus\\:border-red-200:focus {
    --border-opacity: 1;
    border-color: #fbd5d5;
    border-color: rgba(251, 213, 213, var(--border-opacity));
  }
  .sm\\:focus\\:border-red-300:focus {
    --border-opacity: 1;
    border-color: #f8b4b4;
    border-color: rgba(248, 180, 180, var(--border-opacity));
  }
  .sm\\:focus\\:border-red-400:focus {
    --border-opacity: 1;
    border-color: #f98080;
    border-color: rgba(249, 128, 128, var(--border-opacity));
  }
  .sm\\:focus\\:border-red-500:focus {
    --border-opacity: 1;
    border-color: #f05252;
    border-color: rgba(240, 82, 82, var(--border-opacity));
  }
  .sm\\:focus\\:border-red-600:focus {
    --border-opacity: 1;
    border-color: #e02424;
    border-color: rgba(224, 36, 36, var(--border-opacity));
  }
  .sm\\:focus\\:border-red-700:focus {
    --border-opacity: 1;
    border-color: #c81e1e;
    border-color: rgba(200, 30, 30, var(--border-opacity));
  }
  .sm\\:focus\\:border-red-800:focus {
    --border-opacity: 1;
    border-color: #9b1c1c;
    border-color: rgba(155, 28, 28, var(--border-opacity));
  }
  .sm\\:focus\\:border-red-900:focus {
    --border-opacity: 1;
    border-color: #771d1d;
    border-color: rgba(119, 29, 29, var(--border-opacity));
  }
  .sm\\:focus\\:border-orange-50:focus {
    --border-opacity: 1;
    border-color: #fff8f1;
    border-color: rgba(255, 248, 241, var(--border-opacity));
  }
  .sm\\:focus\\:border-orange-100:focus {
    --border-opacity: 1;
    border-color: #feecdc;
    border-color: rgba(254, 236, 220, var(--border-opacity));
  }
  .sm\\:focus\\:border-orange-200:focus {
    --border-opacity: 1;
    border-color: #fcd9bd;
    border-color: rgba(252, 217, 189, var(--border-opacity));
  }
  .sm\\:focus\\:border-orange-300:focus {
    --border-opacity: 1;
    border-color: #fdba8c;
    border-color: rgba(253, 186, 140, var(--border-opacity));
  }
  .sm\\:focus\\:border-orange-400:focus {
    --border-opacity: 1;
    border-color: #ff8a4c;
    border-color: rgba(255, 138, 76, var(--border-opacity));
  }
  .sm\\:focus\\:border-orange-500:focus {
    --border-opacity: 1;
    border-color: #ff5a1f;
    border-color: rgba(255, 90, 31, var(--border-opacity));
  }
  .sm\\:focus\\:border-orange-600:focus {
    --border-opacity: 1;
    border-color: #d03801;
    border-color: rgba(208, 56, 1, var(--border-opacity));
  }
  .sm\\:focus\\:border-orange-700:focus {
    --border-opacity: 1;
    border-color: #b43403;
    border-color: rgba(180, 52, 3, var(--border-opacity));
  }
  .sm\\:focus\\:border-orange-800:focus {
    --border-opacity: 1;
    border-color: #8a2c0d;
    border-color: rgba(138, 44, 13, var(--border-opacity));
  }
  .sm\\:focus\\:border-orange-900:focus {
    --border-opacity: 1;
    border-color: #73230d;
    border-color: rgba(115, 35, 13, var(--border-opacity));
  }
  .sm\\:focus\\:border-yellow-50:focus {
    --border-opacity: 1;
    border-color: #fdfdea;
    border-color: rgba(253, 253, 234, var(--border-opacity));
  }
  .sm\\:focus\\:border-yellow-100:focus {
    --border-opacity: 1;
    border-color: #fdf6b2;
    border-color: rgba(253, 246, 178, var(--border-opacity));
  }
  .sm\\:focus\\:border-yellow-200:focus {
    --border-opacity: 1;
    border-color: #fce96a;
    border-color: rgba(252, 233, 106, var(--border-opacity));
  }
  .sm\\:focus\\:border-yellow-300:focus {
    --border-opacity: 1;
    border-color: #faca15;
    border-color: rgba(250, 202, 21, var(--border-opacity));
  }
  .sm\\:focus\\:border-yellow-400:focus {
    --border-opacity: 1;
    border-color: #e3a008;
    border-color: rgba(227, 160, 8, var(--border-opacity));
  }
  .sm\\:focus\\:border-yellow-500:focus {
    --border-opacity: 1;
    border-color: #c27803;
    border-color: rgba(194, 120, 3, var(--border-opacity));
  }
  .sm\\:focus\\:border-yellow-600:focus {
    --border-opacity: 1;
    border-color: #9f580a;
    border-color: rgba(159, 88, 10, var(--border-opacity));
  }
  .sm\\:focus\\:border-yellow-700:focus {
    --border-opacity: 1;
    border-color: #8e4b10;
    border-color: rgba(142, 75, 16, var(--border-opacity));
  }
  .sm\\:focus\\:border-yellow-800:focus {
    --border-opacity: 1;
    border-color: #723b13;
    border-color: rgba(114, 59, 19, var(--border-opacity));
  }
  .sm\\:focus\\:border-yellow-900:focus {
    --border-opacity: 1;
    border-color: #633112;
    border-color: rgba(99, 49, 18, var(--border-opacity));
  }
  .sm\\:focus\\:border-green-50:focus {
    --border-opacity: 1;
    border-color: #f3faf7;
    border-color: rgba(243, 250, 247, var(--border-opacity));
  }
  .sm\\:focus\\:border-green-100:focus {
    --border-opacity: 1;
    border-color: #def7ec;
    border-color: rgba(222, 247, 236, var(--border-opacity));
  }
  .sm\\:focus\\:border-green-200:focus {
    --border-opacity: 1;
    border-color: #bcf0da;
    border-color: rgba(188, 240, 218, var(--border-opacity));
  }
  .sm\\:focus\\:border-green-300:focus {
    --border-opacity: 1;
    border-color: #84e1bc;
    border-color: rgba(132, 225, 188, var(--border-opacity));
  }
  .sm\\:focus\\:border-green-400:focus {
    --border-opacity: 1;
    border-color: #31c48d;
    border-color: rgba(49, 196, 141, var(--border-opacity));
  }
  .sm\\:focus\\:border-green-500:focus {
    --border-opacity: 1;
    border-color: #0e9f6e;
    border-color: rgba(14, 159, 110, var(--border-opacity));
  }
  .sm\\:focus\\:border-green-600:focus {
    --border-opacity: 1;
    border-color: #057a55;
    border-color: rgba(5, 122, 85, var(--border-opacity));
  }
  .sm\\:focus\\:border-green-700:focus {
    --border-opacity: 1;
    border-color: #046c4e;
    border-color: rgba(4, 108, 78, var(--border-opacity));
  }
  .sm\\:focus\\:border-green-800:focus {
    --border-opacity: 1;
    border-color: #03543f;
    border-color: rgba(3, 84, 63, var(--border-opacity));
  }
  .sm\\:focus\\:border-green-900:focus {
    --border-opacity: 1;
    border-color: #014737;
    border-color: rgba(1, 71, 55, var(--border-opacity));
  }
  .sm\\:focus\\:border-teal-50:focus {
    --border-opacity: 1;
    border-color: #edfafa;
    border-color: rgba(237, 250, 250, var(--border-opacity));
  }
  .sm\\:focus\\:border-teal-100:focus {
    --border-opacity: 1;
    border-color: #d5f5f6;
    border-color: rgba(213, 245, 246, var(--border-opacity));
  }
  .sm\\:focus\\:border-teal-200:focus {
    --border-opacity: 1;
    border-color: #afecef;
    border-color: rgba(175, 236, 239, var(--border-opacity));
  }
  .sm\\:focus\\:border-teal-300:focus {
    --border-opacity: 1;
    border-color: #7edce2;
    border-color: rgba(126, 220, 226, var(--border-opacity));
  }
  .sm\\:focus\\:border-teal-400:focus {
    --border-opacity: 1;
    border-color: #16bdca;
    border-color: rgba(22, 189, 202, var(--border-opacity));
  }
  .sm\\:focus\\:border-teal-500:focus {
    --border-opacity: 1;
    border-color: #0694a2;
    border-color: rgba(6, 148, 162, var(--border-opacity));
  }
  .sm\\:focus\\:border-teal-600:focus {
    --border-opacity: 1;
    border-color: #047481;
    border-color: rgba(4, 116, 129, var(--border-opacity));
  }
  .sm\\:focus\\:border-teal-700:focus {
    --border-opacity: 1;
    border-color: #036672;
    border-color: rgba(3, 102, 114, var(--border-opacity));
  }
  .sm\\:focus\\:border-teal-800:focus {
    --border-opacity: 1;
    border-color: #05505c;
    border-color: rgba(5, 80, 92, var(--border-opacity));
  }
  .sm\\:focus\\:border-teal-900:focus {
    --border-opacity: 1;
    border-color: #014451;
    border-color: rgba(1, 68, 81, var(--border-opacity));
  }
  .sm\\:focus\\:border-blue-50:focus {
    --border-opacity: 1;
    border-color: #ebf5ff;
    border-color: rgba(235, 245, 255, var(--border-opacity));
  }
  .sm\\:focus\\:border-blue-100:focus {
    --border-opacity: 1;
    border-color: #e1effe;
    border-color: rgba(225, 239, 254, var(--border-opacity));
  }
  .sm\\:focus\\:border-blue-200:focus {
    --border-opacity: 1;
    border-color: #c3ddfd;
    border-color: rgba(195, 221, 253, var(--border-opacity));
  }
  .sm\\:focus\\:border-blue-300:focus {
    --border-opacity: 1;
    border-color: #a4cafe;
    border-color: rgba(164, 202, 254, var(--border-opacity));
  }
  .sm\\:focus\\:border-blue-400:focus {
    --border-opacity: 1;
    border-color: #76a9fa;
    border-color: rgba(118, 169, 250, var(--border-opacity));
  }
  .sm\\:focus\\:border-blue-500:focus {
    --border-opacity: 1;
    border-color: #3f83f8;
    border-color: rgba(63, 131, 248, var(--border-opacity));
  }
  .sm\\:focus\\:border-blue-600:focus {
    --border-opacity: 1;
    border-color: #1c64f2;
    border-color: rgba(28, 100, 242, var(--border-opacity));
  }
  .sm\\:focus\\:border-blue-700:focus {
    --border-opacity: 1;
    border-color: #1a56db;
    border-color: rgba(26, 86, 219, var(--border-opacity));
  }
  .sm\\:focus\\:border-blue-800:focus {
    --border-opacity: 1;
    border-color: #1e429f;
    border-color: rgba(30, 66, 159, var(--border-opacity));
  }
  .sm\\:focus\\:border-blue-900:focus {
    --border-opacity: 1;
    border-color: #233876;
    border-color: rgba(35, 56, 118, var(--border-opacity));
  }
  .sm\\:focus\\:border-indigo-50:focus {
    --border-opacity: 1;
    border-color: #f0f5ff;
    border-color: rgba(240, 245, 255, var(--border-opacity));
  }
  .sm\\:focus\\:border-indigo-100:focus {
    --border-opacity: 1;
    border-color: #e5edff;
    border-color: rgba(229, 237, 255, var(--border-opacity));
  }
  .sm\\:focus\\:border-indigo-200:focus {
    --border-opacity: 1;
    border-color: #cddbfe;
    border-color: rgba(205, 219, 254, var(--border-opacity));
  }
  .sm\\:focus\\:border-indigo-300:focus {
    --border-opacity: 1;
    border-color: #b4c6fc;
    border-color: rgba(180, 198, 252, var(--border-opacity));
  }
  .sm\\:focus\\:border-indigo-400:focus {
    --border-opacity: 1;
    border-color: #8da2fb;
    border-color: rgba(141, 162, 251, var(--border-opacity));
  }
  .sm\\:focus\\:border-indigo-500:focus {
    --border-opacity: 1;
    border-color: #6875f5;
    border-color: rgba(104, 117, 245, var(--border-opacity));
  }
  .sm\\:focus\\:border-indigo-600:focus {
    --border-opacity: 1;
    border-color: #5850ec;
    border-color: rgba(88, 80, 236, var(--border-opacity));
  }
  .sm\\:focus\\:border-indigo-700:focus {
    --border-opacity: 1;
    border-color: #5145cd;
    border-color: rgba(81, 69, 205, var(--border-opacity));
  }
  .sm\\:focus\\:border-indigo-800:focus {
    --border-opacity: 1;
    border-color: #42389d;
    border-color: rgba(66, 56, 157, var(--border-opacity));
  }
  .sm\\:focus\\:border-indigo-900:focus {
    --border-opacity: 1;
    border-color: #362f78;
    border-color: rgba(54, 47, 120, var(--border-opacity));
  }
  .sm\\:focus\\:border-purple-50:focus {
    --border-opacity: 1;
    border-color: #f6f5ff;
    border-color: rgba(246, 245, 255, var(--border-opacity));
  }
  .sm\\:focus\\:border-purple-100:focus {
    --border-opacity: 1;
    border-color: #edebfe;
    border-color: rgba(237, 235, 254, var(--border-opacity));
  }
  .sm\\:focus\\:border-purple-200:focus {
    --border-opacity: 1;
    border-color: #dcd7fe;
    border-color: rgba(220, 215, 254, var(--border-opacity));
  }
  .sm\\:focus\\:border-purple-300:focus {
    --border-opacity: 1;
    border-color: #cabffd;
    border-color: rgba(202, 191, 253, var(--border-opacity));
  }
  .sm\\:focus\\:border-purple-400:focus {
    --border-opacity: 1;
    border-color: #ac94fa;
    border-color: rgba(172, 148, 250, var(--border-opacity));
  }
  .sm\\:focus\\:border-purple-500:focus {
    --border-opacity: 1;
    border-color: #9061f9;
    border-color: rgba(144, 97, 249, var(--border-opacity));
  }
  .sm\\:focus\\:border-purple-600:focus {
    --border-opacity: 1;
    border-color: #7e3af2;
    border-color: rgba(126, 58, 242, var(--border-opacity));
  }
  .sm\\:focus\\:border-purple-700:focus {
    --border-opacity: 1;
    border-color: #6c2bd9;
    border-color: rgba(108, 43, 217, var(--border-opacity));
  }
  .sm\\:focus\\:border-purple-800:focus {
    --border-opacity: 1;
    border-color: #5521b5;
    border-color: rgba(85, 33, 181, var(--border-opacity));
  }
  .sm\\:focus\\:border-purple-900:focus {
    --border-opacity: 1;
    border-color: #4a1d96;
    border-color: rgba(74, 29, 150, var(--border-opacity));
  }
  .sm\\:focus\\:border-pink-50:focus {
    --border-opacity: 1;
    border-color: #fdf2f8;
    border-color: rgba(253, 242, 248, var(--border-opacity));
  }
  .sm\\:focus\\:border-pink-100:focus {
    --border-opacity: 1;
    border-color: #fce8f3;
    border-color: rgba(252, 232, 243, var(--border-opacity));
  }
  .sm\\:focus\\:border-pink-200:focus {
    --border-opacity: 1;
    border-color: #fad1e8;
    border-color: rgba(250, 209, 232, var(--border-opacity));
  }
  .sm\\:focus\\:border-pink-300:focus {
    --border-opacity: 1;
    border-color: #f8b4d9;
    border-color: rgba(248, 180, 217, var(--border-opacity));
  }
  .sm\\:focus\\:border-pink-400:focus {
    --border-opacity: 1;
    border-color: #f17eb8;
    border-color: rgba(241, 126, 184, var(--border-opacity));
  }
  .sm\\:focus\\:border-pink-500:focus {
    --border-opacity: 1;
    border-color: #e74694;
    border-color: rgba(231, 70, 148, var(--border-opacity));
  }
  .sm\\:focus\\:border-pink-600:focus {
    --border-opacity: 1;
    border-color: #d61f69;
    border-color: rgba(214, 31, 105, var(--border-opacity));
  }
  .sm\\:focus\\:border-pink-700:focus {
    --border-opacity: 1;
    border-color: #bf125d;
    border-color: rgba(191, 18, 93, var(--border-opacity));
  }
  .sm\\:focus\\:border-pink-800:focus {
    --border-opacity: 1;
    border-color: #99154b;
    border-color: rgba(153, 21, 75, var(--border-opacity));
  }
  .sm\\:focus\\:border-pink-900:focus {
    --border-opacity: 1;
    border-color: #751a3d;
    border-color: rgba(117, 26, 61, var(--border-opacity));
  }
  .sm\\:focus\\:border-cool-gray-50:focus {
    --border-opacity: 1;
    border-color: #f8fafc;
    border-color: rgba(248, 250, 252, var(--border-opacity));
  }
  .sm\\:focus\\:border-cool-gray-100:focus {
    --border-opacity: 1;
    border-color: #f1f5f9;
    border-color: rgba(241, 245, 249, var(--border-opacity));
  }
  .sm\\:focus\\:border-cool-gray-200:focus {
    --border-opacity: 1;
    border-color: #e2e8f0;
    border-color: rgba(226, 232, 240, var(--border-opacity));
  }
  .sm\\:focus\\:border-cool-gray-300:focus {
    --border-opacity: 1;
    border-color: #cfd8e3;
    border-color: rgba(207, 216, 227, var(--border-opacity));
  }
  .sm\\:focus\\:border-cool-gray-400:focus {
    --border-opacity: 1;
    border-color: #97a6ba;
    border-color: rgba(151, 166, 186, var(--border-opacity));
  }
  .sm\\:focus\\:border-cool-gray-500:focus {
    --border-opacity: 1;
    border-color: #64748b;
    border-color: rgba(100, 116, 139, var(--border-opacity));
  }
  .sm\\:focus\\:border-cool-gray-600:focus {
    --border-opacity: 1;
    border-color: #475569;
    border-color: rgba(71, 85, 105, var(--border-opacity));
  }
  .sm\\:focus\\:border-cool-gray-700:focus {
    --border-opacity: 1;
    border-color: #364152;
    border-color: rgba(54, 65, 82, var(--border-opacity));
  }
  .sm\\:focus\\:border-cool-gray-800:focus {
    --border-opacity: 1;
    border-color: #27303f;
    border-color: rgba(39, 48, 63, var(--border-opacity));
  }
  .sm\\:focus\\:border-cool-gray-900:focus {
    --border-opacity: 1;
    border-color: #1a202e;
    border-color: rgba(26, 32, 46, var(--border-opacity));
  }
  .sm\\:border-opacity-0 {
    --border-opacity: 0;
  }
  .sm\\:border-opacity-25 {
    --border-opacity: 0.25;
  }
  .sm\\:border-opacity-50 {
    --border-opacity: 0.5;
  }
  .sm\\:border-opacity-75 {
    --border-opacity: 0.75;
  }
  .sm\\:border-opacity-100 {
    --border-opacity: 1;
  }
  .sm\\:hover\\:border-opacity-0:hover {
    --border-opacity: 0;
  }
  .sm\\:hover\\:border-opacity-25:hover {
    --border-opacity: 0.25;
  }
  .sm\\:hover\\:border-opacity-50:hover {
    --border-opacity: 0.5;
  }
  .sm\\:hover\\:border-opacity-75:hover {
    --border-opacity: 0.75;
  }
  .sm\\:hover\\:border-opacity-100:hover {
    --border-opacity: 1;
  }
  .sm\\:focus\\:border-opacity-0:focus {
    --border-opacity: 0;
  }
  .sm\\:focus\\:border-opacity-25:focus {
    --border-opacity: 0.25;
  }
  .sm\\:focus\\:border-opacity-50:focus {
    --border-opacity: 0.5;
  }
  .sm\\:focus\\:border-opacity-75:focus {
    --border-opacity: 0.75;
  }
  .sm\\:focus\\:border-opacity-100:focus {
    --border-opacity: 1;
  }
  .sm\\:rounded-none {
    border-radius: 0;
  }
  .sm\\:rounded-sm {
    border-radius: 0.125rem;
  }
  .sm\\:rounded {
    border-radius: 0.25rem;
  }
  .sm\\:rounded-md {
    border-radius: 0.375rem;
  }
  .sm\\:rounded-lg {
    border-radius: 0.5rem;
  }
  .sm\\:rounded-xl {
    border-radius: 0.75rem;
  }
  .sm\\:rounded-2xl {
    border-radius: 1rem;
  }
  .sm\\:rounded-3xl {
    border-radius: 1.5rem;
  }
  .sm\\:rounded-full {
    border-radius: 9999px;
  }
  .sm\\:rounded-t-none {
    border-top-left-radius: 0;
    border-top-right-radius: 0;
  }
  .sm\\:rounded-r-none {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
  .sm\\:rounded-b-none {
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0;
  }
  .sm\\:rounded-l-none {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
  .sm\\:rounded-t-sm {
    border-top-left-radius: 0.125rem;
    border-top-right-radius: 0.125rem;
  }
  .sm\\:rounded-r-sm {
    border-top-right-radius: 0.125rem;
    border-bottom-right-radius: 0.125rem;
  }
  .sm\\:rounded-b-sm {
    border-bottom-right-radius: 0.125rem;
    border-bottom-left-radius: 0.125rem;
  }
  .sm\\:rounded-l-sm {
    border-top-left-radius: 0.125rem;
    border-bottom-left-radius: 0.125rem;
  }
  .sm\\:rounded-t {
    border-top-left-radius: 0.25rem;
    border-top-right-radius: 0.25rem;
  }
  .sm\\:rounded-r {
    border-top-right-radius: 0.25rem;
    border-bottom-right-radius: 0.25rem;
  }
  .sm\\:rounded-b {
    border-bottom-right-radius: 0.25rem;
    border-bottom-left-radius: 0.25rem;
  }
  .sm\\:rounded-l {
    border-top-left-radius: 0.25rem;
    border-bottom-left-radius: 0.25rem;
  }
  .sm\\:rounded-t-md {
    border-top-left-radius: 0.375rem;
    border-top-right-radius: 0.375rem;
  }
  .sm\\:rounded-r-md {
    border-top-right-radius: 0.375rem;
    border-bottom-right-radius: 0.375rem;
  }
  .sm\\:rounded-b-md {
    border-bottom-right-radius: 0.375rem;
    border-bottom-left-radius: 0.375rem;
  }
  .sm\\:rounded-l-md {
    border-top-left-radius: 0.375rem;
    border-bottom-left-radius: 0.375rem;
  }
  .sm\\:rounded-t-lg {
    border-top-left-radius: 0.5rem;
    border-top-right-radius: 0.5rem;
  }
  .sm\\:rounded-r-lg {
    border-top-right-radius: 0.5rem;
    border-bottom-right-radius: 0.5rem;
  }
  .sm\\:rounded-b-lg {
    border-bottom-right-radius: 0.5rem;
    border-bottom-left-radius: 0.5rem;
  }
  .sm\\:rounded-l-lg {
    border-top-left-radius: 0.5rem;
    border-bottom-left-radius: 0.5rem;
  }
  .sm\\:rounded-t-xl {
    border-top-left-radius: 0.75rem;
    border-top-right-radius: 0.75rem;
  }
  .sm\\:rounded-r-xl {
    border-top-right-radius: 0.75rem;
    border-bottom-right-radius: 0.75rem;
  }
  .sm\\:rounded-b-xl {
    border-bottom-right-radius: 0.75rem;
    border-bottom-left-radius: 0.75rem;
  }
  .sm\\:rounded-l-xl {
    border-top-left-radius: 0.75rem;
    border-bottom-left-radius: 0.75rem;
  }
  .sm\\:rounded-t-2xl {
    border-top-left-radius: 1rem;
    border-top-right-radius: 1rem;
  }
  .sm\\:rounded-r-2xl {
    border-top-right-radius: 1rem;
    border-bottom-right-radius: 1rem;
  }
  .sm\\:rounded-b-2xl {
    border-bottom-right-radius: 1rem;
    border-bottom-left-radius: 1rem;
  }
  .sm\\:rounded-l-2xl {
    border-top-left-radius: 1rem;
    border-bottom-left-radius: 1rem;
  }
  .sm\\:rounded-t-3xl {
    border-top-left-radius: 1.5rem;
    border-top-right-radius: 1.5rem;
  }
  .sm\\:rounded-r-3xl {
    border-top-right-radius: 1.5rem;
    border-bottom-right-radius: 1.5rem;
  }
  .sm\\:rounded-b-3xl {
    border-bottom-right-radius: 1.5rem;
    border-bottom-left-radius: 1.5rem;
  }
  .sm\\:rounded-l-3xl {
    border-top-left-radius: 1.5rem;
    border-bottom-left-radius: 1.5rem;
  }
  .sm\\:rounded-t-full {
    border-top-left-radius: 9999px;
    border-top-right-radius: 9999px;
  }
  .sm\\:rounded-r-full {
    border-top-right-radius: 9999px;
    border-bottom-right-radius: 9999px;
  }
  .sm\\:rounded-b-full {
    border-bottom-right-radius: 9999px;
    border-bottom-left-radius: 9999px;
  }
  .sm\\:rounded-l-full {
    border-top-left-radius: 9999px;
    border-bottom-left-radius: 9999px;
  }
  .sm\\:rounded-tl-none {
    border-top-left-radius: 0;
  }
  .sm\\:rounded-tr-none {
    border-top-right-radius: 0;
  }
  .sm\\:rounded-br-none {
    border-bottom-right-radius: 0;
  }
  .sm\\:rounded-bl-none {
    border-bottom-left-radius: 0;
  }
  .sm\\:rounded-tl-sm {
    border-top-left-radius: 0.125rem;
  }
  .sm\\:rounded-tr-sm {
    border-top-right-radius: 0.125rem;
  }
  .sm\\:rounded-br-sm {
    border-bottom-right-radius: 0.125rem;
  }
  .sm\\:rounded-bl-sm {
    border-bottom-left-radius: 0.125rem;
  }
  .sm\\:rounded-tl {
    border-top-left-radius: 0.25rem;
  }
  .sm\\:rounded-tr {
    border-top-right-radius: 0.25rem;
  }
  .sm\\:rounded-br {
    border-bottom-right-radius: 0.25rem;
  }
  .sm\\:rounded-bl {
    border-bottom-left-radius: 0.25rem;
  }
  .sm\\:rounded-tl-md {
    border-top-left-radius: 0.375rem;
  }
  .sm\\:rounded-tr-md {
    border-top-right-radius: 0.375rem;
  }
  .sm\\:rounded-br-md {
    border-bottom-right-radius: 0.375rem;
  }
  .sm\\:rounded-bl-md {
    border-bottom-left-radius: 0.375rem;
  }
  .sm\\:rounded-tl-lg {
    border-top-left-radius: 0.5rem;
  }
  .sm\\:rounded-tr-lg {
    border-top-right-radius: 0.5rem;
  }
  .sm\\:rounded-br-lg {
    border-bottom-right-radius: 0.5rem;
  }
  .sm\\:rounded-bl-lg {
    border-bottom-left-radius: 0.5rem;
  }
  .sm\\:rounded-tl-xl {
    border-top-left-radius: 0.75rem;
  }
  .sm\\:rounded-tr-xl {
    border-top-right-radius: 0.75rem;
  }
  .sm\\:rounded-br-xl {
    border-bottom-right-radius: 0.75rem;
  }
  .sm\\:rounded-bl-xl {
    border-bottom-left-radius: 0.75rem;
  }
  .sm\\:rounded-tl-2xl {
    border-top-left-radius: 1rem;
  }
  .sm\\:rounded-tr-2xl {
    border-top-right-radius: 1rem;
  }
  .sm\\:rounded-br-2xl {
    border-bottom-right-radius: 1rem;
  }
  .sm\\:rounded-bl-2xl {
    border-bottom-left-radius: 1rem;
  }
  .sm\\:rounded-tl-3xl {
    border-top-left-radius: 1.5rem;
  }
  .sm\\:rounded-tr-3xl {
    border-top-right-radius: 1.5rem;
  }
  .sm\\:rounded-br-3xl {
    border-bottom-right-radius: 1.5rem;
  }
  .sm\\:rounded-bl-3xl {
    border-bottom-left-radius: 1.5rem;
  }
  .sm\\:rounded-tl-full {
    border-top-left-radius: 9999px;
  }
  .sm\\:rounded-tr-full {
    border-top-right-radius: 9999px;
  }
  .sm\\:rounded-br-full {
    border-bottom-right-radius: 9999px;
  }
  .sm\\:rounded-bl-full {
    border-bottom-left-radius: 9999px;
  }
  .sm\\:border-solid {
    border-style: solid;
  }
  .sm\\:border-dashed {
    border-style: dashed;
  }
  .sm\\:border-dotted {
    border-style: dotted;
  }
  .sm\\:border-double {
    border-style: double;
  }
  .sm\\:border-none {
    border-style: none;
  }
  .sm\\:border-0 {
    border-width: 0;
  }
  .sm\\:border-2 {
    border-width: 2px;
  }
  .sm\\:border-4 {
    border-width: 4px;
  }
  .sm\\:border-8 {
    border-width: 8px;
  }
  .sm\\:border {
    border-width: 1px;
  }
  .sm\\:border-t-0 {
    border-top-width: 0;
  }
  .sm\\:border-r-0 {
    border-right-width: 0;
  }
  .sm\\:border-b-0 {
    border-bottom-width: 0;
  }
  .sm\\:border-l-0 {
    border-left-width: 0;
  }
  .sm\\:border-t-2 {
    border-top-width: 2px;
  }
  .sm\\:border-r-2 {
    border-right-width: 2px;
  }
  .sm\\:border-b-2 {
    border-bottom-width: 2px;
  }
  .sm\\:border-l-2 {
    border-left-width: 2px;
  }
  .sm\\:border-t-4 {
    border-top-width: 4px;
  }
  .sm\\:border-r-4 {
    border-right-width: 4px;
  }
  .sm\\:border-b-4 {
    border-bottom-width: 4px;
  }
  .sm\\:border-l-4 {
    border-left-width: 4px;
  }
  .sm\\:border-t-8 {
    border-top-width: 8px;
  }
  .sm\\:border-r-8 {
    border-right-width: 8px;
  }
  .sm\\:border-b-8 {
    border-bottom-width: 8px;
  }
  .sm\\:border-l-8 {
    border-left-width: 8px;
  }
  .sm\\:border-t {
    border-top-width: 1px;
  }
  .sm\\:border-r {
    border-right-width: 1px;
  }
  .sm\\:border-b {
    border-bottom-width: 1px;
  }
  .sm\\:border-l {
    border-left-width: 1px;
  }
  .sm\\:box-border {
    box-sizing: border-box;
  }
  .sm\\:box-content {
    box-sizing: content-box;
  }
  .sm\\:cursor-auto {
    cursor: auto;
  }
  .sm\\:cursor-default {
    cursor: default;
  }
  .sm\\:cursor-pointer {
    cursor: pointer;
  }
  .sm\\:cursor-wait {
    cursor: wait;
  }
  .sm\\:cursor-text {
    cursor: text;
  }
  .sm\\:cursor-move {
    cursor: move;
  }
  .sm\\:cursor-not-allowed {
    cursor: not-allowed;
  }
  .sm\\:block {
    display: block;
  }
  .sm\\:inline-block {
    display: inline-block;
  }
  .sm\\:inline {
    display: inline;
  }
  .sm\\:flex {
    display: flex;
  }
  .sm\\:inline-flex {
    display: inline-flex;
  }
  .sm\\:table {
    display: table;
  }
  .sm\\:table-caption {
    display: table-caption;
  }
  .sm\\:table-cell {
    display: table-cell;
  }
  .sm\\:table-column {
    display: table-column;
  }
  .sm\\:table-column-group {
    display: table-column-group;
  }
  .sm\\:table-footer-group {
    display: table-footer-group;
  }
  .sm\\:table-header-group {
    display: table-header-group;
  }
  .sm\\:table-row-group {
    display: table-row-group;
  }
  .sm\\:table-row {
    display: table-row;
  }
  .sm\\:flow-root {
    display: flow-root;
  }
  .sm\\:grid {
    display: grid;
  }
  .sm\\:inline-grid {
    display: inline-grid;
  }
  .sm\\:contents {
    display: contents;
  }
  .sm\\:hidden {
    display: none;
  }
  .sm\\:flex-row {
    flex-direction: row;
  }
  .sm\\:flex-row-reverse {
    flex-direction: row-reverse;
  }
  .sm\\:flex-col {
    flex-direction: column;
  }
  .sm\\:flex-col-reverse {
    flex-direction: column-reverse;
  }
  .sm\\:flex-wrap {
    flex-wrap: wrap;
  }
  .sm\\:flex-wrap-reverse {
    flex-wrap: wrap-reverse;
  }
  .sm\\:flex-no-wrap {
    flex-wrap: nowrap;
  }
  .sm\\:place-items-auto {
    place-items: auto;
  }
  .sm\\:place-items-start {
    place-items: start;
  }
  .sm\\:place-items-end {
    place-items: end;
  }
  .sm\\:place-items-center {
    place-items: center;
  }
  .sm\\:place-items-stretch {
    place-items: stretch;
  }
  .sm\\:place-content-center {
    place-content: center;
  }
  .sm\\:place-content-start {
    place-content: start;
  }
  .sm\\:place-content-end {
    place-content: end;
  }
  .sm\\:place-content-between {
    place-content: space-between;
  }
  .sm\\:place-content-around {
    place-content: space-around;
  }
  .sm\\:place-content-evenly {
    place-content: space-evenly;
  }
  .sm\\:place-content-stretch {
    place-content: stretch;
  }
  .sm\\:place-self-auto {
    place-self: auto;
  }
  .sm\\:place-self-start {
    place-self: start;
  }
  .sm\\:place-self-end {
    place-self: end;
  }
  .sm\\:place-self-center {
    place-self: center;
  }
  .sm\\:place-self-stretch {
    place-self: stretch;
  }
  .sm\\:items-start {
    align-items: flex-start;
  }
  .sm\\:items-end {
    align-items: flex-end;
  }
  .sm\\:items-center {
    align-items: center;
  }
  .sm\\:items-baseline {
    align-items: baseline;
  }
  .sm\\:items-stretch {
    align-items: stretch;
  }
  .sm\\:content-center {
    align-content: center;
  }
  .sm\\:content-start {
    align-content: flex-start;
  }
  .sm\\:content-end {
    align-content: flex-end;
  }
  .sm\\:content-between {
    align-content: space-between;
  }
  .sm\\:content-around {
    align-content: space-around;
  }
  .sm\\:content-evenly {
    align-content: space-evenly;
  }
  .sm\\:self-auto {
    align-self: auto;
  }
  .sm\\:self-start {
    align-self: flex-start;
  }
  .sm\\:self-end {
    align-self: flex-end;
  }
  .sm\\:self-center {
    align-self: center;
  }
  .sm\\:self-stretch {
    align-self: stretch;
  }
  .sm\\:justify-items-auto {
    justify-items: auto;
  }
  .sm\\:justify-items-start {
    justify-items: start;
  }
  .sm\\:justify-items-end {
    justify-items: end;
  }
  .sm\\:justify-items-center {
    justify-items: center;
  }
  .sm\\:justify-items-stretch {
    justify-items: stretch;
  }
  .sm\\:justify-start {
    justify-content: flex-start;
  }
  .sm\\:justify-end {
    justify-content: flex-end;
  }
  .sm\\:justify-center {
    justify-content: center;
  }
  .sm\\:justify-between {
    justify-content: space-between;
  }
  .sm\\:justify-around {
    justify-content: space-around;
  }
  .sm\\:justify-evenly {
    justify-content: space-evenly;
  }
  .sm\\:justify-self-auto {
    justify-self: auto;
  }
  .sm\\:justify-self-start {
    justify-self: start;
  }
  .sm\\:justify-self-end {
    justify-self: end;
  }
  .sm\\:justify-self-center {
    justify-self: center;
  }
  .sm\\:justify-self-stretch {
    justify-self: stretch;
  }
  .sm\\:flex-1 {
    flex: 1 1;
  }
  .sm\\:flex-auto {
    flex: 1 1 auto;
  }
  .sm\\:flex-initial {
    flex: 0 1 auto;
  }
  .sm\\:flex-none {
    flex: none;
  }
  .sm\\:flex-grow-0 {
    flex-grow: 0;
  }
  .sm\\:flex-grow {
    flex-grow: 1;
  }
  .sm\\:flex-shrink-0 {
    flex-shrink: 0;
  }
  .sm\\:flex-shrink {
    flex-shrink: 1;
  }
  .sm\\:order-1 {
    order: 1;
  }
  .sm\\:order-2 {
    order: 2;
  }
  .sm\\:order-3 {
    order: 3;
  }
  .sm\\:order-4 {
    order: 4;
  }
  .sm\\:order-5 {
    order: 5;
  }
  .sm\\:order-6 {
    order: 6;
  }
  .sm\\:order-7 {
    order: 7;
  }
  .sm\\:order-8 {
    order: 8;
  }
  .sm\\:order-9 {
    order: 9;
  }
  .sm\\:order-10 {
    order: 10;
  }
  .sm\\:order-11 {
    order: 11;
  }
  .sm\\:order-12 {
    order: 12;
  }
  .sm\\:order-first {
    order: -9999;
  }
  .sm\\:order-last {
    order: 9999;
  }
  .sm\\:order-none {
    order: 0;
  }
  .sm\\:float-right {
    float: right;
  }
  .sm\\:float-left {
    float: left;
  }
  .sm\\:float-none {
    float: none;
  }
  .sm\\:clearfix:after {
    content: "";
    display: table;
    clear: both;
  }
  .sm\\:clear-left {
    clear: left;
  }
  .sm\\:clear-right {
    clear: right;
  }
  .sm\\:clear-both {
    clear: both;
  }
  .sm\\:clear-none {
    clear: none;
  }
  .sm\\:font-sans {
    font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  }
  .sm\\:font-serif {
    font-family: Georgia, Cambria, "Times New Roman", Times, serif;
  }
  .sm\\:font-mono {
    font-family: Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  }
  .sm\\:font-hairline {
    font-weight: 100;
  }
  .sm\\:font-thin {
    font-weight: 200;
  }
  .sm\\:font-light {
    font-weight: 300;
  }
  .sm\\:font-normal {
    font-weight: 400;
  }
  .sm\\:font-medium {
    font-weight: 500;
  }
  .sm\\:font-semibold {
    font-weight: 600;
  }
  .sm\\:font-bold {
    font-weight: 700;
  }
  .sm\\:font-extrabold {
    font-weight: 800;
  }
  .sm\\:font-black {
    font-weight: 900;
  }
  .sm\\:hover\\:font-hairline:hover {
    font-weight: 100;
  }
  .sm\\:hover\\:font-thin:hover {
    font-weight: 200;
  }
  .sm\\:hover\\:font-light:hover {
    font-weight: 300;
  }
  .sm\\:hover\\:font-normal:hover {
    font-weight: 400;
  }
  .sm\\:hover\\:font-medium:hover {
    font-weight: 500;
  }
  .sm\\:hover\\:font-semibold:hover {
    font-weight: 600;
  }
  .sm\\:hover\\:font-bold:hover {
    font-weight: 700;
  }
  .sm\\:hover\\:font-extrabold:hover {
    font-weight: 800;
  }
  .sm\\:hover\\:font-black:hover {
    font-weight: 900;
  }
  .sm\\:focus\\:font-hairline:focus {
    font-weight: 100;
  }
  .sm\\:focus\\:font-thin:focus {
    font-weight: 200;
  }
  .sm\\:focus\\:font-light:focus {
    font-weight: 300;
  }
  .sm\\:focus\\:font-normal:focus {
    font-weight: 400;
  }
  .sm\\:focus\\:font-medium:focus {
    font-weight: 500;
  }
  .sm\\:focus\\:font-semibold:focus {
    font-weight: 600;
  }
  .sm\\:focus\\:font-bold:focus {
    font-weight: 700;
  }
  .sm\\:focus\\:font-extrabold:focus {
    font-weight: 800;
  }
  .sm\\:focus\\:font-black:focus {
    font-weight: 900;
  }
  .sm\\:h-0 {
    height: 0;
  }
  .sm\\:h-1 {
    height: 0.25rem;
  }
  .sm\\:h-2 {
    height: 0.5rem;
  }
  .sm\\:h-3 {
    height: 0.75rem;
  }
  .sm\\:h-4 {
    height: 1rem;
  }
  .sm\\:h-5 {
    height: 1.25rem;
  }
  .sm\\:h-6 {
    height: 1.5rem;
  }
  .sm\\:h-7 {
    height: 1.75rem;
  }
  .sm\\:h-8 {
    height: 2rem;
  }
  .sm\\:h-9 {
    height: 2.25rem;
  }
  .sm\\:h-10 {
    height: 2.5rem;
  }
  .sm\\:h-11 {
    height: 2.75rem;
  }
  .sm\\:h-12 {
    height: 3rem;
  }
  .sm\\:h-13 {
    height: 3.25rem;
  }
  .sm\\:h-14 {
    height: 3.5rem;
  }
  .sm\\:h-15 {
    height: 3.75rem;
  }
  .sm\\:h-16 {
    height: 4rem;
  }
  .sm\\:h-20 {
    height: 5rem;
  }
  .sm\\:h-24 {
    height: 6rem;
  }
  .sm\\:h-28 {
    height: 7rem;
  }
  .sm\\:h-32 {
    height: 8rem;
  }
  .sm\\:h-36 {
    height: 9rem;
  }
  .sm\\:h-40 {
    height: 10rem;
  }
  .sm\\:h-44 {
    height: 11rem;
  }
  .sm\\:h-48 {
    height: 12rem;
  }
  .sm\\:h-52 {
    height: 13rem;
  }
  .sm\\:h-56 {
    height: 14rem;
  }
  .sm\\:h-60 {
    height: 15rem;
  }
  .sm\\:h-64 {
    height: 16rem;
  }
  .sm\\:h-72 {
    height: 18rem;
  }
  .sm\\:h-80 {
    height: 20rem;
  }
  .sm\\:h-96 {
    height: 24rem;
  }
  .sm\\:h-auto {
    height: auto;
  }
  .sm\\:h-px {
    height: 1px;
  }
  .sm\\:h-0\\.5 {
    height: 0.125rem;
  }
  .sm\\:h-1\\.5 {
    height: 0.375rem;
  }
  .sm\\:h-2\\.5 {
    height: 0.625rem;
  }
  .sm\\:h-3\\.5 {
    height: 0.875rem;
  }
  .sm\\:h-1\\/2 {
    height: 50%;
  }
  .sm\\:h-1\\/3 {
    height: 33.333333%;
  }
  .sm\\:h-2\\/3 {
    height: 66.666667%;
  }
  .sm\\:h-1\\/4 {
    height: 25%;
  }
  .sm\\:h-2\\/4 {
    height: 50%;
  }
  .sm\\:h-3\\/4 {
    height: 75%;
  }
  .sm\\:h-1\\/5 {
    height: 20%;
  }
  .sm\\:h-2\\/5 {
    height: 40%;
  }
  .sm\\:h-3\\/5 {
    height: 60%;
  }
  .sm\\:h-4\\/5 {
    height: 80%;
  }
  .sm\\:h-1\\/6 {
    height: 16.666667%;
  }
  .sm\\:h-2\\/6 {
    height: 33.333333%;
  }
  .sm\\:h-3\\/6 {
    height: 50%;
  }
  .sm\\:h-4\\/6 {
    height: 66.666667%;
  }
  .sm\\:h-5\\/6 {
    height: 83.333333%;
  }
  .sm\\:h-1\\/12 {
    height: 8.333333%;
  }
  .sm\\:h-2\\/12 {
    height: 16.666667%;
  }
  .sm\\:h-3\\/12 {
    height: 25%;
  }
  .sm\\:h-4\\/12 {
    height: 33.333333%;
  }
  .sm\\:h-5\\/12 {
    height: 41.666667%;
  }
  .sm\\:h-6\\/12 {
    height: 50%;
  }
  .sm\\:h-7\\/12 {
    height: 58.333333%;
  }
  .sm\\:h-8\\/12 {
    height: 66.666667%;
  }
  .sm\\:h-9\\/12 {
    height: 75%;
  }
  .sm\\:h-10\\/12 {
    height: 83.333333%;
  }
  .sm\\:h-11\\/12 {
    height: 91.666667%;
  }
  .sm\\:h-full {
    height: 100%;
  }
  .sm\\:h-screen {
    height: 100vh;
  }
  .sm\\:text-xs {
    font-size: 0.75rem;
  }
  .sm\\:text-sm {
    font-size: 0.875rem;
  }
  .sm\\:text-base {
    font-size: 1rem;
  }
  .sm\\:text-lg {
    font-size: 1.125rem;
  }
  .sm\\:text-xl {
    font-size: 1.25rem;
  }
  .sm\\:text-2xl {
    font-size: 1.5rem;
  }
  .sm\\:text-3xl {
    font-size: 1.875rem;
  }
  .sm\\:text-4xl {
    font-size: 2.25rem;
  }
  .sm\\:text-5xl {
    font-size: 3rem;
  }
  .sm\\:text-6xl {
    font-size: 4rem;
  }
  .sm\\:leading-3 {
    line-height: .75rem;
  }
  .sm\\:leading-4 {
    line-height: 1rem;
  }
  .sm\\:leading-5 {
    line-height: 1.25rem;
  }
  .sm\\:leading-6 {
    line-height: 1.5rem;
  }
  .sm\\:leading-7 {
    line-height: 1.75rem;
  }
  .sm\\:leading-8 {
    line-height: 2rem;
  }
  .sm\\:leading-9 {
    line-height: 2.25rem;
  }
  .sm\\:leading-10 {
    line-height: 2.5rem;
  }
  .sm\\:leading-none {
    line-height: 1;
  }
  .sm\\:leading-tight {
    line-height: 1.25;
  }
  .sm\\:leading-snug {
    line-height: 1.375;
  }
  .sm\\:leading-normal {
    line-height: 1.5;
  }
  .sm\\:leading-relaxed {
    line-height: 1.625;
  }
  .sm\\:leading-loose {
    line-height: 2;
  }
  .sm\\:list-inside {
    list-style-position: inside;
  }
  .sm\\:list-outside {
    list-style-position: outside;
  }
  .sm\\:list-none {
    list-style-type: none;
  }
  .sm\\:list-disc {
    list-style-type: disc;
  }
  .sm\\:list-decimal {
    list-style-type: decimal;
  }
  .sm\\:m-0 {
    margin: 0;
  }
  .sm\\:m-1 {
    margin: 0.25rem;
  }
  .sm\\:m-2 {
    margin: 0.5rem;
  }
  .sm\\:m-3 {
    margin: 0.75rem;
  }
  .sm\\:m-4 {
    margin: 1rem;
  }
  .sm\\:m-5 {
    margin: 1.25rem;
  }
  .sm\\:m-6 {
    margin: 1.5rem;
  }
  .sm\\:m-7 {
    margin: 1.75rem;
  }
  .sm\\:m-8 {
    margin: 2rem;
  }
  .sm\\:m-9 {
    margin: 2.25rem;
  }
  .sm\\:m-10 {
    margin: 2.5rem;
  }
  .sm\\:m-11 {
    margin: 2.75rem;
  }
  .sm\\:m-12 {
    margin: 3rem;
  }
  .sm\\:m-13 {
    margin: 3.25rem;
  }
  .sm\\:m-14 {
    margin: 3.5rem;
  }
  .sm\\:m-15 {
    margin: 3.75rem;
  }
  .sm\\:m-16 {
    margin: 4rem;
  }
  .sm\\:m-20 {
    margin: 5rem;
  }
  .sm\\:m-24 {
    margin: 6rem;
  }
  .sm\\:m-28 {
    margin: 7rem;
  }
  .sm\\:m-32 {
    margin: 8rem;
  }
  .sm\\:m-36 {
    margin: 9rem;
  }
  .sm\\:m-40 {
    margin: 10rem;
  }
  .sm\\:m-44 {
    margin: 11rem;
  }
  .sm\\:m-48 {
    margin: 12rem;
  }
  .sm\\:m-52 {
    margin: 13rem;
  }
  .sm\\:m-56 {
    margin: 14rem;
  }
  .sm\\:m-60 {
    margin: 15rem;
  }
  .sm\\:m-64 {
    margin: 16rem;
  }
  .sm\\:m-72 {
    margin: 18rem;
  }
  .sm\\:m-80 {
    margin: 20rem;
  }
  .sm\\:m-96 {
    margin: 24rem;
  }
  .sm\\:m-auto {
    margin: auto;
  }
  .sm\\:m-px {
    margin: 1px;
  }
  .sm\\:m-0\\.5 {
    margin: 0.125rem;
  }
  .sm\\:m-1\\.5 {
    margin: 0.375rem;
  }
  .sm\\:m-2\\.5 {
    margin: 0.625rem;
  }
  .sm\\:m-3\\.5 {
    margin: 0.875rem;
  }
  .sm\\:m-1\\/2 {
    margin: 50%;
  }
  .sm\\:m-1\\/3 {
    margin: 33.333333%;
  }
  .sm\\:m-2\\/3 {
    margin: 66.666667%;
  }
  .sm\\:m-1\\/4 {
    margin: 25%;
  }
  .sm\\:m-2\\/4 {
    margin: 50%;
  }
  .sm\\:m-3\\/4 {
    margin: 75%;
  }
  .sm\\:m-1\\/5 {
    margin: 20%;
  }
  .sm\\:m-2\\/5 {
    margin: 40%;
  }
  .sm\\:m-3\\/5 {
    margin: 60%;
  }
  .sm\\:m-4\\/5 {
    margin: 80%;
  }
  .sm\\:m-1\\/6 {
    margin: 16.666667%;
  }
  .sm\\:m-2\\/6 {
    margin: 33.333333%;
  }
  .sm\\:m-3\\/6 {
    margin: 50%;
  }
  .sm\\:m-4\\/6 {
    margin: 66.666667%;
  }
  .sm\\:m-5\\/6 {
    margin: 83.333333%;
  }
  .sm\\:m-1\\/12 {
    margin: 8.333333%;
  }
  .sm\\:m-2\\/12 {
    margin: 16.666667%;
  }
  .sm\\:m-3\\/12 {
    margin: 25%;
  }
  .sm\\:m-4\\/12 {
    margin: 33.333333%;
  }
  .sm\\:m-5\\/12 {
    margin: 41.666667%;
  }
  .sm\\:m-6\\/12 {
    margin: 50%;
  }
  .sm\\:m-7\\/12 {
    margin: 58.333333%;
  }
  .sm\\:m-8\\/12 {
    margin: 66.666667%;
  }
  .sm\\:m-9\\/12 {
    margin: 75%;
  }
  .sm\\:m-10\\/12 {
    margin: 83.333333%;
  }
  .sm\\:m-11\\/12 {
    margin: 91.666667%;
  }
  .sm\\:m-full {
    margin: 100%;
  }
  .sm\\:-m-1 {
    margin: -0.25rem;
  }
  .sm\\:-m-2 {
    margin: -0.5rem;
  }
  .sm\\:-m-3 {
    margin: -0.75rem;
  }
  .sm\\:-m-4 {
    margin: -1rem;
  }
  .sm\\:-m-5 {
    margin: -1.25rem;
  }
  .sm\\:-m-6 {
    margin: -1.5rem;
  }
  .sm\\:-m-7 {
    margin: -1.75rem;
  }
  .sm\\:-m-8 {
    margin: -2rem;
  }
  .sm\\:-m-9 {
    margin: -2.25rem;
  }
  .sm\\:-m-10 {
    margin: -2.5rem;
  }
  .sm\\:-m-11 {
    margin: -2.75rem;
  }
  .sm\\:-m-12 {
    margin: -3rem;
  }
  .sm\\:-m-13 {
    margin: -3.25rem;
  }
  .sm\\:-m-14 {
    margin: -3.5rem;
  }
  .sm\\:-m-15 {
    margin: -3.75rem;
  }
  .sm\\:-m-16 {
    margin: -4rem;
  }
  .sm\\:-m-20 {
    margin: -5rem;
  }
  .sm\\:-m-24 {
    margin: -6rem;
  }
  .sm\\:-m-28 {
    margin: -7rem;
  }
  .sm\\:-m-32 {
    margin: -8rem;
  }
  .sm\\:-m-36 {
    margin: -9rem;
  }
  .sm\\:-m-40 {
    margin: -10rem;
  }
  .sm\\:-m-44 {
    margin: -11rem;
  }
  .sm\\:-m-48 {
    margin: -12rem;
  }
  .sm\\:-m-52 {
    margin: -13rem;
  }
  .sm\\:-m-56 {
    margin: -14rem;
  }
  .sm\\:-m-60 {
    margin: -15rem;
  }
  .sm\\:-m-64 {
    margin: -16rem;
  }
  .sm\\:-m-72 {
    margin: -18rem;
  }
  .sm\\:-m-80 {
    margin: -20rem;
  }
  .sm\\:-m-96 {
    margin: -24rem;
  }
  .sm\\:-m-px {
    margin: -1px;
  }
  .sm\\:-m-0\\.5 {
    margin: -0.125rem;
  }
  .sm\\:-m-1\\.5 {
    margin: -0.375rem;
  }
  .sm\\:-m-2\\.5 {
    margin: -0.625rem;
  }
  .sm\\:-m-3\\.5 {
    margin: -0.875rem;
  }
  .sm\\:-m-1\\/2 {
    margin: -50%;
  }
  .sm\\:-m-1\\/3 {
    margin: -33.33333%;
  }
  .sm\\:-m-2\\/3 {
    margin: -66.66667%;
  }
  .sm\\:-m-1\\/4 {
    margin: -25%;
  }
  .sm\\:-m-2\\/4 {
    margin: -50%;
  }
  .sm\\:-m-3\\/4 {
    margin: -75%;
  }
  .sm\\:-m-1\\/5 {
    margin: -20%;
  }
  .sm\\:-m-2\\/5 {
    margin: -40%;
  }
  .sm\\:-m-3\\/5 {
    margin: -60%;
  }
  .sm\\:-m-4\\/5 {
    margin: -80%;
  }
  .sm\\:-m-1\\/6 {
    margin: -16.66667%;
  }
  .sm\\:-m-2\\/6 {
    margin: -33.33333%;
  }
  .sm\\:-m-3\\/6 {
    margin: -50%;
  }
  .sm\\:-m-4\\/6 {
    margin: -66.66667%;
  }
  .sm\\:-m-5\\/6 {
    margin: -83.33333%;
  }
  .sm\\:-m-1\\/12 {
    margin: -8.33333%;
  }
  .sm\\:-m-2\\/12 {
    margin: -16.66667%;
  }
  .sm\\:-m-3\\/12 {
    margin: -25%;
  }
  .sm\\:-m-4\\/12 {
    margin: -33.33333%;
  }
  .sm\\:-m-5\\/12 {
    margin: -41.66667%;
  }
  .sm\\:-m-6\\/12 {
    margin: -50%;
  }
  .sm\\:-m-7\\/12 {
    margin: -58.33333%;
  }
  .sm\\:-m-8\\/12 {
    margin: -66.66667%;
  }
  .sm\\:-m-9\\/12 {
    margin: -75%;
  }
  .sm\\:-m-10\\/12 {
    margin: -83.33333%;
  }
  .sm\\:-m-11\\/12 {
    margin: -91.66667%;
  }
  .sm\\:-m-full {
    margin: -100%;
  }
  .sm\\:my-0 {
    margin-top: 0;
    margin-bottom: 0;
  }
  .sm\\:mx-0 {
    margin-left: 0;
    margin-right: 0;
  }
  .sm\\:my-1 {
    margin-top: 0.25rem;
    margin-bottom: 0.25rem;
  }
  .sm\\:mx-1 {
    margin-left: 0.25rem;
    margin-right: 0.25rem;
  }
  .sm\\:my-2 {
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
  }
  .sm\\:mx-2 {
    margin-left: 0.5rem;
    margin-right: 0.5rem;
  }
  .sm\\:my-3 {
    margin-top: 0.75rem;
    margin-bottom: 0.75rem;
  }
  .sm\\:mx-3 {
    margin-left: 0.75rem;
    margin-right: 0.75rem;
  }
  .sm\\:my-4 {
    margin-top: 1rem;
    margin-bottom: 1rem;
  }
  .sm\\:mx-4 {
    margin-left: 1rem;
    margin-right: 1rem;
  }
  .sm\\:my-5 {
    margin-top: 1.25rem;
    margin-bottom: 1.25rem;
  }
  .sm\\:mx-5 {
    margin-left: 1.25rem;
    margin-right: 1.25rem;
  }
  .sm\\:my-6 {
    margin-top: 1.5rem;
    margin-bottom: 1.5rem;
  }
  .sm\\:mx-6 {
    margin-left: 1.5rem;
    margin-right: 1.5rem;
  }
  .sm\\:my-7 {
    margin-top: 1.75rem;
    margin-bottom: 1.75rem;
  }
  .sm\\:mx-7 {
    margin-left: 1.75rem;
    margin-right: 1.75rem;
  }
  .sm\\:my-8 {
    margin-top: 2rem;
    margin-bottom: 2rem;
  }
  .sm\\:mx-8 {
    margin-left: 2rem;
    margin-right: 2rem;
  }
  .sm\\:my-9 {
    margin-top: 2.25rem;
    margin-bottom: 2.25rem;
  }
  .sm\\:mx-9 {
    margin-left: 2.25rem;
    margin-right: 2.25rem;
  }
  .sm\\:my-10 {
    margin-top: 2.5rem;
    margin-bottom: 2.5rem;
  }
  .sm\\:mx-10 {
    margin-left: 2.5rem;
    margin-right: 2.5rem;
  }
  .sm\\:my-11 {
    margin-top: 2.75rem;
    margin-bottom: 2.75rem;
  }
  .sm\\:mx-11 {
    margin-left: 2.75rem;
    margin-right: 2.75rem;
  }
  .sm\\:my-12 {
    margin-top: 3rem;
    margin-bottom: 3rem;
  }
  .sm\\:mx-12 {
    margin-left: 3rem;
    margin-right: 3rem;
  }
  .sm\\:my-13 {
    margin-top: 3.25rem;
    margin-bottom: 3.25rem;
  }
  .sm\\:mx-13 {
    margin-left: 3.25rem;
    margin-right: 3.25rem;
  }
  .sm\\:my-14 {
    margin-top: 3.5rem;
    margin-bottom: 3.5rem;
  }
  .sm\\:mx-14 {
    margin-left: 3.5rem;
    margin-right: 3.5rem;
  }
  .sm\\:my-15 {
    margin-top: 3.75rem;
    margin-bottom: 3.75rem;
  }
  .sm\\:mx-15 {
    margin-left: 3.75rem;
    margin-right: 3.75rem;
  }
  .sm\\:my-16 {
    margin-top: 4rem;
    margin-bottom: 4rem;
  }
  .sm\\:mx-16 {
    margin-left: 4rem;
    margin-right: 4rem;
  }
  .sm\\:my-20 {
    margin-top: 5rem;
    margin-bottom: 5rem;
  }
  .sm\\:mx-20 {
    margin-left: 5rem;
    margin-right: 5rem;
  }
  .sm\\:my-24 {
    margin-top: 6rem;
    margin-bottom: 6rem;
  }
  .sm\\:mx-24 {
    margin-left: 6rem;
    margin-right: 6rem;
  }
  .sm\\:my-28 {
    margin-top: 7rem;
    margin-bottom: 7rem;
  }
  .sm\\:mx-28 {
    margin-left: 7rem;
    margin-right: 7rem;
  }
  .sm\\:my-32 {
    margin-top: 8rem;
    margin-bottom: 8rem;
  }
  .sm\\:mx-32 {
    margin-left: 8rem;
    margin-right: 8rem;
  }
  .sm\\:my-36 {
    margin-top: 9rem;
    margin-bottom: 9rem;
  }
  .sm\\:mx-36 {
    margin-left: 9rem;
    margin-right: 9rem;
  }
  .sm\\:my-40 {
    margin-top: 10rem;
    margin-bottom: 10rem;
  }
  .sm\\:mx-40 {
    margin-left: 10rem;
    margin-right: 10rem;
  }
  .sm\\:my-44 {
    margin-top: 11rem;
    margin-bottom: 11rem;
  }
  .sm\\:mx-44 {
    margin-left: 11rem;
    margin-right: 11rem;
  }
  .sm\\:my-48 {
    margin-top: 12rem;
    margin-bottom: 12rem;
  }
  .sm\\:mx-48 {
    margin-left: 12rem;
    margin-right: 12rem;
  }
  .sm\\:my-52 {
    margin-top: 13rem;
    margin-bottom: 13rem;
  }
  .sm\\:mx-52 {
    margin-left: 13rem;
    margin-right: 13rem;
  }
  .sm\\:my-56 {
    margin-top: 14rem;
    margin-bottom: 14rem;
  }
  .sm\\:mx-56 {
    margin-left: 14rem;
    margin-right: 14rem;
  }
  .sm\\:my-60 {
    margin-top: 15rem;
    margin-bottom: 15rem;
  }
  .sm\\:mx-60 {
    margin-left: 15rem;
    margin-right: 15rem;
  }
  .sm\\:my-64 {
    margin-top: 16rem;
    margin-bottom: 16rem;
  }
  .sm\\:mx-64 {
    margin-left: 16rem;
    margin-right: 16rem;
  }
  .sm\\:my-72 {
    margin-top: 18rem;
    margin-bottom: 18rem;
  }
  .sm\\:mx-72 {
    margin-left: 18rem;
    margin-right: 18rem;
  }
  .sm\\:my-80 {
    margin-top: 20rem;
    margin-bottom: 20rem;
  }
  .sm\\:mx-80 {
    margin-left: 20rem;
    margin-right: 20rem;
  }
  .sm\\:my-96 {
    margin-top: 24rem;
    margin-bottom: 24rem;
  }
  .sm\\:mx-96 {
    margin-left: 24rem;
    margin-right: 24rem;
  }
  .sm\\:my-auto {
    margin-top: auto;
    margin-bottom: auto;
  }
  .sm\\:mx-auto {
    margin-left: auto;
    margin-right: auto;
  }
  .sm\\:my-px {
    margin-top: 1px;
    margin-bottom: 1px;
  }
  .sm\\:mx-px {
    margin-left: 1px;
    margin-right: 1px;
  }
  .sm\\:my-0\\.5 {
    margin-top: 0.125rem;
    margin-bottom: 0.125rem;
  }
  .sm\\:mx-0\\.5 {
    margin-left: 0.125rem;
    margin-right: 0.125rem;
  }
  .sm\\:my-1\\.5 {
    margin-top: 0.375rem;
    margin-bottom: 0.375rem;
  }
  .sm\\:mx-1\\.5 {
    margin-left: 0.375rem;
    margin-right: 0.375rem;
  }
  .sm\\:my-2\\.5 {
    margin-top: 0.625rem;
    margin-bottom: 0.625rem;
  }
  .sm\\:mx-2\\.5 {
    margin-left: 0.625rem;
    margin-right: 0.625rem;
  }
  .sm\\:my-3\\.5 {
    margin-top: 0.875rem;
    margin-bottom: 0.875rem;
  }
  .sm\\:mx-3\\.5 {
    margin-left: 0.875rem;
    margin-right: 0.875rem;
  }
  .sm\\:my-1\\/2 {
    margin-top: 50%;
    margin-bottom: 50%;
  }
  .sm\\:mx-1\\/2 {
    margin-left: 50%;
    margin-right: 50%;
  }
  .sm\\:my-1\\/3 {
    margin-top: 33.333333%;
    margin-bottom: 33.333333%;
  }
  .sm\\:mx-1\\/3 {
    margin-left: 33.333333%;
    margin-right: 33.333333%;
  }
  .sm\\:my-2\\/3 {
    margin-top: 66.666667%;
    margin-bottom: 66.666667%;
  }
  .sm\\:mx-2\\/3 {
    margin-left: 66.666667%;
    margin-right: 66.666667%;
  }
  .sm\\:my-1\\/4 {
    margin-top: 25%;
    margin-bottom: 25%;
  }
  .sm\\:mx-1\\/4 {
    margin-left: 25%;
    margin-right: 25%;
  }
  .sm\\:my-2\\/4 {
    margin-top: 50%;
    margin-bottom: 50%;
  }
  .sm\\:mx-2\\/4 {
    margin-left: 50%;
    margin-right: 50%;
  }
  .sm\\:my-3\\/4 {
    margin-top: 75%;
    margin-bottom: 75%;
  }
  .sm\\:mx-3\\/4 {
    margin-left: 75%;
    margin-right: 75%;
  }
  .sm\\:my-1\\/5 {
    margin-top: 20%;
    margin-bottom: 20%;
  }
  .sm\\:mx-1\\/5 {
    margin-left: 20%;
    margin-right: 20%;
  }
  .sm\\:my-2\\/5 {
    margin-top: 40%;
    margin-bottom: 40%;
  }
  .sm\\:mx-2\\/5 {
    margin-left: 40%;
    margin-right: 40%;
  }
  .sm\\:my-3\\/5 {
    margin-top: 60%;
    margin-bottom: 60%;
  }
  .sm\\:mx-3\\/5 {
    margin-left: 60%;
    margin-right: 60%;
  }
  .sm\\:my-4\\/5 {
    margin-top: 80%;
    margin-bottom: 80%;
  }
  .sm\\:mx-4\\/5 {
    margin-left: 80%;
    margin-right: 80%;
  }
  .sm\\:my-1\\/6 {
    margin-top: 16.666667%;
    margin-bottom: 16.666667%;
  }
  .sm\\:mx-1\\/6 {
    margin-left: 16.666667%;
    margin-right: 16.666667%;
  }
  .sm\\:my-2\\/6 {
    margin-top: 33.333333%;
    margin-bottom: 33.333333%;
  }
  .sm\\:mx-2\\/6 {
    margin-left: 33.333333%;
    margin-right: 33.333333%;
  }
  .sm\\:my-3\\/6 {
    margin-top: 50%;
    margin-bottom: 50%;
  }
  .sm\\:mx-3\\/6 {
    margin-left: 50%;
    margin-right: 50%;
  }
  .sm\\:my-4\\/6 {
    margin-top: 66.666667%;
    margin-bottom: 66.666667%;
  }
  .sm\\:mx-4\\/6 {
    margin-left: 66.666667%;
    margin-right: 66.666667%;
  }
  .sm\\:my-5\\/6 {
    margin-top: 83.333333%;
    margin-bottom: 83.333333%;
  }
  .sm\\:mx-5\\/6 {
    margin-left: 83.333333%;
    margin-right: 83.333333%;
  }
  .sm\\:my-1\\/12 {
    margin-top: 8.333333%;
    margin-bottom: 8.333333%;
  }
  .sm\\:mx-1\\/12 {
    margin-left: 8.333333%;
    margin-right: 8.333333%;
  }
  .sm\\:my-2\\/12 {
    margin-top: 16.666667%;
    margin-bottom: 16.666667%;
  }
  .sm\\:mx-2\\/12 {
    margin-left: 16.666667%;
    margin-right: 16.666667%;
  }
  .sm\\:my-3\\/12 {
    margin-top: 25%;
    margin-bottom: 25%;
  }
  .sm\\:mx-3\\/12 {
    margin-left: 25%;
    margin-right: 25%;
  }
  .sm\\:my-4\\/12 {
    margin-top: 33.333333%;
    margin-bottom: 33.333333%;
  }
  .sm\\:mx-4\\/12 {
    margin-left: 33.333333%;
    margin-right: 33.333333%;
  }
  .sm\\:my-5\\/12 {
    margin-top: 41.666667%;
    margin-bottom: 41.666667%;
  }
  .sm\\:mx-5\\/12 {
    margin-left: 41.666667%;
    margin-right: 41.666667%;
  }
  .sm\\:my-6\\/12 {
    margin-top: 50%;
    margin-bottom: 50%;
  }
  .sm\\:mx-6\\/12 {
    margin-left: 50%;
    margin-right: 50%;
  }
  .sm\\:my-7\\/12 {
    margin-top: 58.333333%;
    margin-bottom: 58.333333%;
  }
  .sm\\:mx-7\\/12 {
    margin-left: 58.333333%;
    margin-right: 58.333333%;
  }
  .sm\\:my-8\\/12 {
    margin-top: 66.666667%;
    margin-bottom: 66.666667%;
  }
  .sm\\:mx-8\\/12 {
    margin-left: 66.666667%;
    margin-right: 66.666667%;
  }
  .sm\\:my-9\\/12 {
    margin-top: 75%;
    margin-bottom: 75%;
  }
  .sm\\:mx-9\\/12 {
    margin-left: 75%;
    margin-right: 75%;
  }
  .sm\\:my-10\\/12 {
    margin-top: 83.333333%;
    margin-bottom: 83.333333%;
  }
  .sm\\:mx-10\\/12 {
    margin-left: 83.333333%;
    margin-right: 83.333333%;
  }
  .sm\\:my-11\\/12 {
    margin-top: 91.666667%;
    margin-bottom: 91.666667%;
  }
  .sm\\:mx-11\\/12 {
    margin-left: 91.666667%;
    margin-right: 91.666667%;
  }
  .sm\\:my-full {
    margin-top: 100%;
    margin-bottom: 100%;
  }
  .sm\\:mx-full {
    margin-left: 100%;
    margin-right: 100%;
  }
  .sm\\:-my-1 {
    margin-top: -0.25rem;
    margin-bottom: -0.25rem;
  }
  .sm\\:-mx-1 {
    margin-left: -0.25rem;
    margin-right: -0.25rem;
  }
  .sm\\:-my-2 {
    margin-top: -0.5rem;
    margin-bottom: -0.5rem;
  }
  .sm\\:-mx-2 {
    margin-left: -0.5rem;
    margin-right: -0.5rem;
  }
  .sm\\:-my-3 {
    margin-top: -0.75rem;
    margin-bottom: -0.75rem;
  }
  .sm\\:-mx-3 {
    margin-left: -0.75rem;
    margin-right: -0.75rem;
  }
  .sm\\:-my-4 {
    margin-top: -1rem;
    margin-bottom: -1rem;
  }
  .sm\\:-mx-4 {
    margin-left: -1rem;
    margin-right: -1rem;
  }
  .sm\\:-my-5 {
    margin-top: -1.25rem;
    margin-bottom: -1.25rem;
  }
  .sm\\:-mx-5 {
    margin-left: -1.25rem;
    margin-right: -1.25rem;
  }
  .sm\\:-my-6 {
    margin-top: -1.5rem;
    margin-bottom: -1.5rem;
  }
  .sm\\:-mx-6 {
    margin-left: -1.5rem;
    margin-right: -1.5rem;
  }
  .sm\\:-my-7 {
    margin-top: -1.75rem;
    margin-bottom: -1.75rem;
  }
  .sm\\:-mx-7 {
    margin-left: -1.75rem;
    margin-right: -1.75rem;
  }
  .sm\\:-my-8 {
    margin-top: -2rem;
    margin-bottom: -2rem;
  }
  .sm\\:-mx-8 {
    margin-left: -2rem;
    margin-right: -2rem;
  }
  .sm\\:-my-9 {
    margin-top: -2.25rem;
    margin-bottom: -2.25rem;
  }
  .sm\\:-mx-9 {
    margin-left: -2.25rem;
    margin-right: -2.25rem;
  }
  .sm\\:-my-10 {
    margin-top: -2.5rem;
    margin-bottom: -2.5rem;
  }
  .sm\\:-mx-10 {
    margin-left: -2.5rem;
    margin-right: -2.5rem;
  }
  .sm\\:-my-11 {
    margin-top: -2.75rem;
    margin-bottom: -2.75rem;
  }
  .sm\\:-mx-11 {
    margin-left: -2.75rem;
    margin-right: -2.75rem;
  }
  .sm\\:-my-12 {
    margin-top: -3rem;
    margin-bottom: -3rem;
  }
  .sm\\:-mx-12 {
    margin-left: -3rem;
    margin-right: -3rem;
  }
  .sm\\:-my-13 {
    margin-top: -3.25rem;
    margin-bottom: -3.25rem;
  }
  .sm\\:-mx-13 {
    margin-left: -3.25rem;
    margin-right: -3.25rem;
  }
  .sm\\:-my-14 {
    margin-top: -3.5rem;
    margin-bottom: -3.5rem;
  }
  .sm\\:-mx-14 {
    margin-left: -3.5rem;
    margin-right: -3.5rem;
  }
  .sm\\:-my-15 {
    margin-top: -3.75rem;
    margin-bottom: -3.75rem;
  }
  .sm\\:-mx-15 {
    margin-left: -3.75rem;
    margin-right: -3.75rem;
  }
  .sm\\:-my-16 {
    margin-top: -4rem;
    margin-bottom: -4rem;
  }
  .sm\\:-mx-16 {
    margin-left: -4rem;
    margin-right: -4rem;
  }
  .sm\\:-my-20 {
    margin-top: -5rem;
    margin-bottom: -5rem;
  }
  .sm\\:-mx-20 {
    margin-left: -5rem;
    margin-right: -5rem;
  }
  .sm\\:-my-24 {
    margin-top: -6rem;
    margin-bottom: -6rem;
  }
  .sm\\:-mx-24 {
    margin-left: -6rem;
    margin-right: -6rem;
  }
  .sm\\:-my-28 {
    margin-top: -7rem;
    margin-bottom: -7rem;
  }
  .sm\\:-mx-28 {
    margin-left: -7rem;
    margin-right: -7rem;
  }
  .sm\\:-my-32 {
    margin-top: -8rem;
    margin-bottom: -8rem;
  }
  .sm\\:-mx-32 {
    margin-left: -8rem;
    margin-right: -8rem;
  }
  .sm\\:-my-36 {
    margin-top: -9rem;
    margin-bottom: -9rem;
  }
  .sm\\:-mx-36 {
    margin-left: -9rem;
    margin-right: -9rem;
  }
  .sm\\:-my-40 {
    margin-top: -10rem;
    margin-bottom: -10rem;
  }
  .sm\\:-mx-40 {
    margin-left: -10rem;
    margin-right: -10rem;
  }
  .sm\\:-my-44 {
    margin-top: -11rem;
    margin-bottom: -11rem;
  }
  .sm\\:-mx-44 {
    margin-left: -11rem;
    margin-right: -11rem;
  }
  .sm\\:-my-48 {
    margin-top: -12rem;
    margin-bottom: -12rem;
  }
  .sm\\:-mx-48 {
    margin-left: -12rem;
    margin-right: -12rem;
  }
  .sm\\:-my-52 {
    margin-top: -13rem;
    margin-bottom: -13rem;
  }
  .sm\\:-mx-52 {
    margin-left: -13rem;
    margin-right: -13rem;
  }
  .sm\\:-my-56 {
    margin-top: -14rem;
    margin-bottom: -14rem;
  }
  .sm\\:-mx-56 {
    margin-left: -14rem;
    margin-right: -14rem;
  }
  .sm\\:-my-60 {
    margin-top: -15rem;
    margin-bottom: -15rem;
  }
  .sm\\:-mx-60 {
    margin-left: -15rem;
    margin-right: -15rem;
  }
  .sm\\:-my-64 {
    margin-top: -16rem;
    margin-bottom: -16rem;
  }
  .sm\\:-mx-64 {
    margin-left: -16rem;
    margin-right: -16rem;
  }
  .sm\\:-my-72 {
    margin-top: -18rem;
    margin-bottom: -18rem;
  }
  .sm\\:-mx-72 {
    margin-left: -18rem;
    margin-right: -18rem;
  }
  .sm\\:-my-80 {
    margin-top: -20rem;
    margin-bottom: -20rem;
  }
  .sm\\:-mx-80 {
    margin-left: -20rem;
    margin-right: -20rem;
  }
  .sm\\:-my-96 {
    margin-top: -24rem;
    margin-bottom: -24rem;
  }
  .sm\\:-mx-96 {
    margin-left: -24rem;
    margin-right: -24rem;
  }
  .sm\\:-my-px {
    margin-top: -1px;
    margin-bottom: -1px;
  }
  .sm\\:-mx-px {
    margin-left: -1px;
    margin-right: -1px;
  }
  .sm\\:-my-0\\.5 {
    margin-top: -0.125rem;
    margin-bottom: -0.125rem;
  }
  .sm\\:-mx-0\\.5 {
    margin-left: -0.125rem;
    margin-right: -0.125rem;
  }
  .sm\\:-my-1\\.5 {
    margin-top: -0.375rem;
    margin-bottom: -0.375rem;
  }
  .sm\\:-mx-1\\.5 {
    margin-left: -0.375rem;
    margin-right: -0.375rem;
  }
  .sm\\:-my-2\\.5 {
    margin-top: -0.625rem;
    margin-bottom: -0.625rem;
  }
  .sm\\:-mx-2\\.5 {
    margin-left: -0.625rem;
    margin-right: -0.625rem;
  }
  .sm\\:-my-3\\.5 {
    margin-top: -0.875rem;
    margin-bottom: -0.875rem;
  }
  .sm\\:-mx-3\\.5 {
    margin-left: -0.875rem;
    margin-right: -0.875rem;
  }
  .sm\\:-my-1\\/2 {
    margin-top: -50%;
    margin-bottom: -50%;
  }
  .sm\\:-mx-1\\/2 {
    margin-left: -50%;
    margin-right: -50%;
  }
  .sm\\:-my-1\\/3 {
    margin-top: -33.33333%;
    margin-bottom: -33.33333%;
  }
  .sm\\:-mx-1\\/3 {
    margin-left: -33.33333%;
    margin-right: -33.33333%;
  }
  .sm\\:-my-2\\/3 {
    margin-top: -66.66667%;
    margin-bottom: -66.66667%;
  }
  .sm\\:-mx-2\\/3 {
    margin-left: -66.66667%;
    margin-right: -66.66667%;
  }
  .sm\\:-my-1\\/4 {
    margin-top: -25%;
    margin-bottom: -25%;
  }
  .sm\\:-mx-1\\/4 {
    margin-left: -25%;
    margin-right: -25%;
  }
  .sm\\:-my-2\\/4 {
    margin-top: -50%;
    margin-bottom: -50%;
  }
  .sm\\:-mx-2\\/4 {
    margin-left: -50%;
    margin-right: -50%;
  }
  .sm\\:-my-3\\/4 {
    margin-top: -75%;
    margin-bottom: -75%;
  }
  .sm\\:-mx-3\\/4 {
    margin-left: -75%;
    margin-right: -75%;
  }
  .sm\\:-my-1\\/5 {
    margin-top: -20%;
    margin-bottom: -20%;
  }
  .sm\\:-mx-1\\/5 {
    margin-left: -20%;
    margin-right: -20%;
  }
  .sm\\:-my-2\\/5 {
    margin-top: -40%;
    margin-bottom: -40%;
  }
  .sm\\:-mx-2\\/5 {
    margin-left: -40%;
    margin-right: -40%;
  }
  .sm\\:-my-3\\/5 {
    margin-top: -60%;
    margin-bottom: -60%;
  }
  .sm\\:-mx-3\\/5 {
    margin-left: -60%;
    margin-right: -60%;
  }
  .sm\\:-my-4\\/5 {
    margin-top: -80%;
    margin-bottom: -80%;
  }
  .sm\\:-mx-4\\/5 {
    margin-left: -80%;
    margin-right: -80%;
  }
  .sm\\:-my-1\\/6 {
    margin-top: -16.66667%;
    margin-bottom: -16.66667%;
  }
  .sm\\:-mx-1\\/6 {
    margin-left: -16.66667%;
    margin-right: -16.66667%;
  }
  .sm\\:-my-2\\/6 {
    margin-top: -33.33333%;
    margin-bottom: -33.33333%;
  }
  .sm\\:-mx-2\\/6 {
    margin-left: -33.33333%;
    margin-right: -33.33333%;
  }
  .sm\\:-my-3\\/6 {
    margin-top: -50%;
    margin-bottom: -50%;
  }
  .sm\\:-mx-3\\/6 {
    margin-left: -50%;
    margin-right: -50%;
  }
  .sm\\:-my-4\\/6 {
    margin-top: -66.66667%;
    margin-bottom: -66.66667%;
  }
  .sm\\:-mx-4\\/6 {
    margin-left: -66.66667%;
    margin-right: -66.66667%;
  }
  .sm\\:-my-5\\/6 {
    margin-top: -83.33333%;
    margin-bottom: -83.33333%;
  }
  .sm\\:-mx-5\\/6 {
    margin-left: -83.33333%;
    margin-right: -83.33333%;
  }
  .sm\\:-my-1\\/12 {
    margin-top: -8.33333%;
    margin-bottom: -8.33333%;
  }
  .sm\\:-mx-1\\/12 {
    margin-left: -8.33333%;
    margin-right: -8.33333%;
  }
  .sm\\:-my-2\\/12 {
    margin-top: -16.66667%;
    margin-bottom: -16.66667%;
  }
  .sm\\:-mx-2\\/12 {
    margin-left: -16.66667%;
    margin-right: -16.66667%;
  }
  .sm\\:-my-3\\/12 {
    margin-top: -25%;
    margin-bottom: -25%;
  }
  .sm\\:-mx-3\\/12 {
    margin-left: -25%;
    margin-right: -25%;
  }
  .sm\\:-my-4\\/12 {
    margin-top: -33.33333%;
    margin-bottom: -33.33333%;
  }
  .sm\\:-mx-4\\/12 {
    margin-left: -33.33333%;
    margin-right: -33.33333%;
  }
  .sm\\:-my-5\\/12 {
    margin-top: -41.66667%;
    margin-bottom: -41.66667%;
  }
  .sm\\:-mx-5\\/12 {
    margin-left: -41.66667%;
    margin-right: -41.66667%;
  }
  .sm\\:-my-6\\/12 {
    margin-top: -50%;
    margin-bottom: -50%;
  }
  .sm\\:-mx-6\\/12 {
    margin-left: -50%;
    margin-right: -50%;
  }
  .sm\\:-my-7\\/12 {
    margin-top: -58.33333%;
    margin-bottom: -58.33333%;
  }
  .sm\\:-mx-7\\/12 {
    margin-left: -58.33333%;
    margin-right: -58.33333%;
  }
  .sm\\:-my-8\\/12 {
    margin-top: -66.66667%;
    margin-bottom: -66.66667%;
  }
  .sm\\:-mx-8\\/12 {
    margin-left: -66.66667%;
    margin-right: -66.66667%;
  }
  .sm\\:-my-9\\/12 {
    margin-top: -75%;
    margin-bottom: -75%;
  }
  .sm\\:-mx-9\\/12 {
    margin-left: -75%;
    margin-right: -75%;
  }
  .sm\\:-my-10\\/12 {
    margin-top: -83.33333%;
    margin-bottom: -83.33333%;
  }
  .sm\\:-mx-10\\/12 {
    margin-left: -83.33333%;
    margin-right: -83.33333%;
  }
  .sm\\:-my-11\\/12 {
    margin-top: -91.66667%;
    margin-bottom: -91.66667%;
  }
  .sm\\:-mx-11\\/12 {
    margin-left: -91.66667%;
    margin-right: -91.66667%;
  }
  .sm\\:-my-full {
    margin-top: -100%;
    margin-bottom: -100%;
  }
  .sm\\:-mx-full {
    margin-left: -100%;
    margin-right: -100%;
  }
  .sm\\:mt-0 {
    margin-top: 0;
  }
  .sm\\:mr-0 {
    margin-right: 0;
  }
  .sm\\:mb-0 {
    margin-bottom: 0;
  }
  .sm\\:ml-0 {
    margin-left: 0;
  }
  .sm\\:mt-1 {
    margin-top: 0.25rem;
  }
  .sm\\:mr-1 {
    margin-right: 0.25rem;
  }
  .sm\\:mb-1 {
    margin-bottom: 0.25rem;
  }
  .sm\\:ml-1 {
    margin-left: 0.25rem;
  }
  .sm\\:mt-2 {
    margin-top: 0.5rem;
  }
  .sm\\:mr-2 {
    margin-right: 0.5rem;
  }
  .sm\\:mb-2 {
    margin-bottom: 0.5rem;
  }
  .sm\\:ml-2 {
    margin-left: 0.5rem;
  }
  .sm\\:mt-3 {
    margin-top: 0.75rem;
  }
  .sm\\:mr-3 {
    margin-right: 0.75rem;
  }
  .sm\\:mb-3 {
    margin-bottom: 0.75rem;
  }
  .sm\\:ml-3 {
    margin-left: 0.75rem;
  }
  .sm\\:mt-4 {
    margin-top: 1rem;
  }
  .sm\\:mr-4 {
    margin-right: 1rem;
  }
  .sm\\:mb-4 {
    margin-bottom: 1rem;
  }
  .sm\\:ml-4 {
    margin-left: 1rem;
  }
  .sm\\:mt-5 {
    margin-top: 1.25rem;
  }
  .sm\\:mr-5 {
    margin-right: 1.25rem;
  }
  .sm\\:mb-5 {
    margin-bottom: 1.25rem;
  }
  .sm\\:ml-5 {
    margin-left: 1.25rem;
  }
  .sm\\:mt-6 {
    margin-top: 1.5rem;
  }
  .sm\\:mr-6 {
    margin-right: 1.5rem;
  }
  .sm\\:mb-6 {
    margin-bottom: 1.5rem;
  }
  .sm\\:ml-6 {
    margin-left: 1.5rem;
  }
  .sm\\:mt-7 {
    margin-top: 1.75rem;
  }
  .sm\\:mr-7 {
    margin-right: 1.75rem;
  }
  .sm\\:mb-7 {
    margin-bottom: 1.75rem;
  }
  .sm\\:ml-7 {
    margin-left: 1.75rem;
  }
  .sm\\:mt-8 {
    margin-top: 2rem;
  }
  .sm\\:mr-8 {
    margin-right: 2rem;
  }
  .sm\\:mb-8 {
    margin-bottom: 2rem;
  }
  .sm\\:ml-8 {
    margin-left: 2rem;
  }
  .sm\\:mt-9 {
    margin-top: 2.25rem;
  }
  .sm\\:mr-9 {
    margin-right: 2.25rem;
  }
  .sm\\:mb-9 {
    margin-bottom: 2.25rem;
  }
  .sm\\:ml-9 {
    margin-left: 2.25rem;
  }
  .sm\\:mt-10 {
    margin-top: 2.5rem;
  }
  .sm\\:mr-10 {
    margin-right: 2.5rem;
  }
  .sm\\:mb-10 {
    margin-bottom: 2.5rem;
  }
  .sm\\:ml-10 {
    margin-left: 2.5rem;
  }
  .sm\\:mt-11 {
    margin-top: 2.75rem;
  }
  .sm\\:mr-11 {
    margin-right: 2.75rem;
  }
  .sm\\:mb-11 {
    margin-bottom: 2.75rem;
  }
  .sm\\:ml-11 {
    margin-left: 2.75rem;
  }
  .sm\\:mt-12 {
    margin-top: 3rem;
  }
  .sm\\:mr-12 {
    margin-right: 3rem;
  }
  .sm\\:mb-12 {
    margin-bottom: 3rem;
  }
  .sm\\:ml-12 {
    margin-left: 3rem;
  }
  .sm\\:mt-13 {
    margin-top: 3.25rem;
  }
  .sm\\:mr-13 {
    margin-right: 3.25rem;
  }
  .sm\\:mb-13 {
    margin-bottom: 3.25rem;
  }
  .sm\\:ml-13 {
    margin-left: 3.25rem;
  }
  .sm\\:mt-14 {
    margin-top: 3.5rem;
  }
  .sm\\:mr-14 {
    margin-right: 3.5rem;
  }
  .sm\\:mb-14 {
    margin-bottom: 3.5rem;
  }
  .sm\\:ml-14 {
    margin-left: 3.5rem;
  }
  .sm\\:mt-15 {
    margin-top: 3.75rem;
  }
  .sm\\:mr-15 {
    margin-right: 3.75rem;
  }
  .sm\\:mb-15 {
    margin-bottom: 3.75rem;
  }
  .sm\\:ml-15 {
    margin-left: 3.75rem;
  }
  .sm\\:mt-16 {
    margin-top: 4rem;
  }
  .sm\\:mr-16 {
    margin-right: 4rem;
  }
  .sm\\:mb-16 {
    margin-bottom: 4rem;
  }
  .sm\\:ml-16 {
    margin-left: 4rem;
  }
  .sm\\:mt-20 {
    margin-top: 5rem;
  }
  .sm\\:mr-20 {
    margin-right: 5rem;
  }
  .sm\\:mb-20 {
    margin-bottom: 5rem;
  }
  .sm\\:ml-20 {
    margin-left: 5rem;
  }
  .sm\\:mt-24 {
    margin-top: 6rem;
  }
  .sm\\:mr-24 {
    margin-right: 6rem;
  }
  .sm\\:mb-24 {
    margin-bottom: 6rem;
  }
  .sm\\:ml-24 {
    margin-left: 6rem;
  }
  .sm\\:mt-28 {
    margin-top: 7rem;
  }
  .sm\\:mr-28 {
    margin-right: 7rem;
  }
  .sm\\:mb-28 {
    margin-bottom: 7rem;
  }
  .sm\\:ml-28 {
    margin-left: 7rem;
  }
  .sm\\:mt-32 {
    margin-top: 8rem;
  }
  .sm\\:mr-32 {
    margin-right: 8rem;
  }
  .sm\\:mb-32 {
    margin-bottom: 8rem;
  }
  .sm\\:ml-32 {
    margin-left: 8rem;
  }
  .sm\\:mt-36 {
    margin-top: 9rem;
  }
  .sm\\:mr-36 {
    margin-right: 9rem;
  }
  .sm\\:mb-36 {
    margin-bottom: 9rem;
  }
  .sm\\:ml-36 {
    margin-left: 9rem;
  }
  .sm\\:mt-40 {
    margin-top: 10rem;
  }
  .sm\\:mr-40 {
    margin-right: 10rem;
  }
  .sm\\:mb-40 {
    margin-bottom: 10rem;
  }
  .sm\\:ml-40 {
    margin-left: 10rem;
  }
  .sm\\:mt-44 {
    margin-top: 11rem;
  }
  .sm\\:mr-44 {
    margin-right: 11rem;
  }
  .sm\\:mb-44 {
    margin-bottom: 11rem;
  }
  .sm\\:ml-44 {
    margin-left: 11rem;
  }
  .sm\\:mt-48 {
    margin-top: 12rem;
  }
  .sm\\:mr-48 {
    margin-right: 12rem;
  }
  .sm\\:mb-48 {
    margin-bottom: 12rem;
  }
  .sm\\:ml-48 {
    margin-left: 12rem;
  }
  .sm\\:mt-52 {
    margin-top: 13rem;
  }
  .sm\\:mr-52 {
    margin-right: 13rem;
  }
  .sm\\:mb-52 {
    margin-bottom: 13rem;
  }
  .sm\\:ml-52 {
    margin-left: 13rem;
  }
  .sm\\:mt-56 {
    margin-top: 14rem;
  }
  .sm\\:mr-56 {
    margin-right: 14rem;
  }
  .sm\\:mb-56 {
    margin-bottom: 14rem;
  }
  .sm\\:ml-56 {
    margin-left: 14rem;
  }
  .sm\\:mt-60 {
    margin-top: 15rem;
  }
  .sm\\:mr-60 {
    margin-right: 15rem;
  }
  .sm\\:mb-60 {
    margin-bottom: 15rem;
  }
  .sm\\:ml-60 {
    margin-left: 15rem;
  }
  .sm\\:mt-64 {
    margin-top: 16rem;
  }
  .sm\\:mr-64 {
    margin-right: 16rem;
  }
  .sm\\:mb-64 {
    margin-bottom: 16rem;
  }
  .sm\\:ml-64 {
    margin-left: 16rem;
  }
  .sm\\:mt-72 {
    margin-top: 18rem;
  }
  .sm\\:mr-72 {
    margin-right: 18rem;
  }
  .sm\\:mb-72 {
    margin-bottom: 18rem;
  }
  .sm\\:ml-72 {
    margin-left: 18rem;
  }
  .sm\\:mt-80 {
    margin-top: 20rem;
  }
  .sm\\:mr-80 {
    margin-right: 20rem;
  }
  .sm\\:mb-80 {
    margin-bottom: 20rem;
  }
  .sm\\:ml-80 {
    margin-left: 20rem;
  }
  .sm\\:mt-96 {
    margin-top: 24rem;
  }
  .sm\\:mr-96 {
    margin-right: 24rem;
  }
  .sm\\:mb-96 {
    margin-bottom: 24rem;
  }
  .sm\\:ml-96 {
    margin-left: 24rem;
  }
  .sm\\:mt-auto {
    margin-top: auto;
  }
  .sm\\:mr-auto {
    margin-right: auto;
  }
  .sm\\:mb-auto {
    margin-bottom: auto;
  }
  .sm\\:ml-auto {
    margin-left: auto;
  }
  .sm\\:mt-px {
    margin-top: 1px;
  }
  .sm\\:mr-px {
    margin-right: 1px;
  }
  .sm\\:mb-px {
    margin-bottom: 1px;
  }
  .sm\\:ml-px {
    margin-left: 1px;
  }
  .sm\\:mt-0\\.5 {
    margin-top: 0.125rem;
  }
  .sm\\:mr-0\\.5 {
    margin-right: 0.125rem;
  }
  .sm\\:mb-0\\.5 {
    margin-bottom: 0.125rem;
  }
  .sm\\:ml-0\\.5 {
    margin-left: 0.125rem;
  }
  .sm\\:mt-1\\.5 {
    margin-top: 0.375rem;
  }
  .sm\\:mr-1\\.5 {
    margin-right: 0.375rem;
  }
  .sm\\:mb-1\\.5 {
    margin-bottom: 0.375rem;
  }
  .sm\\:ml-1\\.5 {
    margin-left: 0.375rem;
  }
  .sm\\:mt-2\\.5 {
    margin-top: 0.625rem;
  }
  .sm\\:mr-2\\.5 {
    margin-right: 0.625rem;
  }
  .sm\\:mb-2\\.5 {
    margin-bottom: 0.625rem;
  }
  .sm\\:ml-2\\.5 {
    margin-left: 0.625rem;
  }
  .sm\\:mt-3\\.5 {
    margin-top: 0.875rem;
  }
  .sm\\:mr-3\\.5 {
    margin-right: 0.875rem;
  }
  .sm\\:mb-3\\.5 {
    margin-bottom: 0.875rem;
  }
  .sm\\:ml-3\\.5 {
    margin-left: 0.875rem;
  }
  .sm\\:mt-1\\/2 {
    margin-top: 50%;
  }
  .sm\\:mr-1\\/2 {
    margin-right: 50%;
  }
  .sm\\:mb-1\\/2 {
    margin-bottom: 50%;
  }
  .sm\\:ml-1\\/2 {
    margin-left: 50%;
  }
  .sm\\:mt-1\\/3 {
    margin-top: 33.333333%;
  }
  .sm\\:mr-1\\/3 {
    margin-right: 33.333333%;
  }
  .sm\\:mb-1\\/3 {
    margin-bottom: 33.333333%;
  }
  .sm\\:ml-1\\/3 {
    margin-left: 33.333333%;
  }
  .sm\\:mt-2\\/3 {
    margin-top: 66.666667%;
  }
  .sm\\:mr-2\\/3 {
    margin-right: 66.666667%;
  }
  .sm\\:mb-2\\/3 {
    margin-bottom: 66.666667%;
  }
  .sm\\:ml-2\\/3 {
    margin-left: 66.666667%;
  }
  .sm\\:mt-1\\/4 {
    margin-top: 25%;
  }
  .sm\\:mr-1\\/4 {
    margin-right: 25%;
  }
  .sm\\:mb-1\\/4 {
    margin-bottom: 25%;
  }
  .sm\\:ml-1\\/4 {
    margin-left: 25%;
  }
  .sm\\:mt-2\\/4 {
    margin-top: 50%;
  }
  .sm\\:mr-2\\/4 {
    margin-right: 50%;
  }
  .sm\\:mb-2\\/4 {
    margin-bottom: 50%;
  }
  .sm\\:ml-2\\/4 {
    margin-left: 50%;
  }
  .sm\\:mt-3\\/4 {
    margin-top: 75%;
  }
  .sm\\:mr-3\\/4 {
    margin-right: 75%;
  }
  .sm\\:mb-3\\/4 {
    margin-bottom: 75%;
  }
  .sm\\:ml-3\\/4 {
    margin-left: 75%;
  }
  .sm\\:mt-1\\/5 {
    margin-top: 20%;
  }
  .sm\\:mr-1\\/5 {
    margin-right: 20%;
  }
  .sm\\:mb-1\\/5 {
    margin-bottom: 20%;
  }
  .sm\\:ml-1\\/5 {
    margin-left: 20%;
  }
  .sm\\:mt-2\\/5 {
    margin-top: 40%;
  }
  .sm\\:mr-2\\/5 {
    margin-right: 40%;
  }
  .sm\\:mb-2\\/5 {
    margin-bottom: 40%;
  }
  .sm\\:ml-2\\/5 {
    margin-left: 40%;
  }
  .sm\\:mt-3\\/5 {
    margin-top: 60%;
  }
  .sm\\:mr-3\\/5 {
    margin-right: 60%;
  }
  .sm\\:mb-3\\/5 {
    margin-bottom: 60%;
  }
  .sm\\:ml-3\\/5 {
    margin-left: 60%;
  }
  .sm\\:mt-4\\/5 {
    margin-top: 80%;
  }
  .sm\\:mr-4\\/5 {
    margin-right: 80%;
  }
  .sm\\:mb-4\\/5 {
    margin-bottom: 80%;
  }
  .sm\\:ml-4\\/5 {
    margin-left: 80%;
  }
  .sm\\:mt-1\\/6 {
    margin-top: 16.666667%;
  }
  .sm\\:mr-1\\/6 {
    margin-right: 16.666667%;
  }
  .sm\\:mb-1\\/6 {
    margin-bottom: 16.666667%;
  }
  .sm\\:ml-1\\/6 {
    margin-left: 16.666667%;
  }
  .sm\\:mt-2\\/6 {
    margin-top: 33.333333%;
  }
  .sm\\:mr-2\\/6 {
    margin-right: 33.333333%;
  }
  .sm\\:mb-2\\/6 {
    margin-bottom: 33.333333%;
  }
  .sm\\:ml-2\\/6 {
    margin-left: 33.333333%;
  }
  .sm\\:mt-3\\/6 {
    margin-top: 50%;
  }
  .sm\\:mr-3\\/6 {
    margin-right: 50%;
  }
  .sm\\:mb-3\\/6 {
    margin-bottom: 50%;
  }
  .sm\\:ml-3\\/6 {
    margin-left: 50%;
  }
  .sm\\:mt-4\\/6 {
    margin-top: 66.666667%;
  }
  .sm\\:mr-4\\/6 {
    margin-right: 66.666667%;
  }
  .sm\\:mb-4\\/6 {
    margin-bottom: 66.666667%;
  }
  .sm\\:ml-4\\/6 {
    margin-left: 66.666667%;
  }
  .sm\\:mt-5\\/6 {
    margin-top: 83.333333%;
  }
  .sm\\:mr-5\\/6 {
    margin-right: 83.333333%;
  }
  .sm\\:mb-5\\/6 {
    margin-bottom: 83.333333%;
  }
  .sm\\:ml-5\\/6 {
    margin-left: 83.333333%;
  }
  .sm\\:mt-1\\/12 {
    margin-top: 8.333333%;
  }
  .sm\\:mr-1\\/12 {
    margin-right: 8.333333%;
  }
  .sm\\:mb-1\\/12 {
    margin-bottom: 8.333333%;
  }
  .sm\\:ml-1\\/12 {
    margin-left: 8.333333%;
  }
  .sm\\:mt-2\\/12 {
    margin-top: 16.666667%;
  }
  .sm\\:mr-2\\/12 {
    margin-right: 16.666667%;
  }
  .sm\\:mb-2\\/12 {
    margin-bottom: 16.666667%;
  }
  .sm\\:ml-2\\/12 {
    margin-left: 16.666667%;
  }
  .sm\\:mt-3\\/12 {
    margin-top: 25%;
  }
  .sm\\:mr-3\\/12 {
    margin-right: 25%;
  }
  .sm\\:mb-3\\/12 {
    margin-bottom: 25%;
  }
  .sm\\:ml-3\\/12 {
    margin-left: 25%;
  }
  .sm\\:mt-4\\/12 {
    margin-top: 33.333333%;
  }
  .sm\\:mr-4\\/12 {
    margin-right: 33.333333%;
  }
  .sm\\:mb-4\\/12 {
    margin-bottom: 33.333333%;
  }
  .sm\\:ml-4\\/12 {
    margin-left: 33.333333%;
  }
  .sm\\:mt-5\\/12 {
    margin-top: 41.666667%;
  }
  .sm\\:mr-5\\/12 {
    margin-right: 41.666667%;
  }
  .sm\\:mb-5\\/12 {
    margin-bottom: 41.666667%;
  }
  .sm\\:ml-5\\/12 {
    margin-left: 41.666667%;
  }
  .sm\\:mt-6\\/12 {
    margin-top: 50%;
  }
  .sm\\:mr-6\\/12 {
    margin-right: 50%;
  }
  .sm\\:mb-6\\/12 {
    margin-bottom: 50%;
  }
  .sm\\:ml-6\\/12 {
    margin-left: 50%;
  }
  .sm\\:mt-7\\/12 {
    margin-top: 58.333333%;
  }
  .sm\\:mr-7\\/12 {
    margin-right: 58.333333%;
  }
  .sm\\:mb-7\\/12 {
    margin-bottom: 58.333333%;
  }
  .sm\\:ml-7\\/12 {
    margin-left: 58.333333%;
  }
  .sm\\:mt-8\\/12 {
    margin-top: 66.666667%;
  }
  .sm\\:mr-8\\/12 {
    margin-right: 66.666667%;
  }
  .sm\\:mb-8\\/12 {
    margin-bottom: 66.666667%;
  }
  .sm\\:ml-8\\/12 {
    margin-left: 66.666667%;
  }
  .sm\\:mt-9\\/12 {
    margin-top: 75%;
  }
  .sm\\:mr-9\\/12 {
    margin-right: 75%;
  }
  .sm\\:mb-9\\/12 {
    margin-bottom: 75%;
  }
  .sm\\:ml-9\\/12 {
    margin-left: 75%;
  }
  .sm\\:mt-10\\/12 {
    margin-top: 83.333333%;
  }
  .sm\\:mr-10\\/12 {
    margin-right: 83.333333%;
  }
  .sm\\:mb-10\\/12 {
    margin-bottom: 83.333333%;
  }
  .sm\\:ml-10\\/12 {
    margin-left: 83.333333%;
  }
  .sm\\:mt-11\\/12 {
    margin-top: 91.666667%;
  }
  .sm\\:mr-11\\/12 {
    margin-right: 91.666667%;
  }
  .sm\\:mb-11\\/12 {
    margin-bottom: 91.666667%;
  }
  .sm\\:ml-11\\/12 {
    margin-left: 91.666667%;
  }
  .sm\\:mt-full {
    margin-top: 100%;
  }
  .sm\\:mr-full {
    margin-right: 100%;
  }
  .sm\\:mb-full {
    margin-bottom: 100%;
  }
  .sm\\:ml-full {
    margin-left: 100%;
  }
  .sm\\:-mt-1 {
    margin-top: -0.25rem;
  }
  .sm\\:-mr-1 {
    margin-right: -0.25rem;
  }
  .sm\\:-mb-1 {
    margin-bottom: -0.25rem;
  }
  .sm\\:-ml-1 {
    margin-left: -0.25rem;
  }
  .sm\\:-mt-2 {
    margin-top: -0.5rem;
  }
  .sm\\:-mr-2 {
    margin-right: -0.5rem;
  }
  .sm\\:-mb-2 {
    margin-bottom: -0.5rem;
  }
  .sm\\:-ml-2 {
    margin-left: -0.5rem;
  }
  .sm\\:-mt-3 {
    margin-top: -0.75rem;
  }
  .sm\\:-mr-3 {
    margin-right: -0.75rem;
  }
  .sm\\:-mb-3 {
    margin-bottom: -0.75rem;
  }
  .sm\\:-ml-3 {
    margin-left: -0.75rem;
  }
  .sm\\:-mt-4 {
    margin-top: -1rem;
  }
  .sm\\:-mr-4 {
    margin-right: -1rem;
  }
  .sm\\:-mb-4 {
    margin-bottom: -1rem;
  }
  .sm\\:-ml-4 {
    margin-left: -1rem;
  }
  .sm\\:-mt-5 {
    margin-top: -1.25rem;
  }
  .sm\\:-mr-5 {
    margin-right: -1.25rem;
  }
  .sm\\:-mb-5 {
    margin-bottom: -1.25rem;
  }
  .sm\\:-ml-5 {
    margin-left: -1.25rem;
  }
  .sm\\:-mt-6 {
    margin-top: -1.5rem;
  }
  .sm\\:-mr-6 {
    margin-right: -1.5rem;
  }
  .sm\\:-mb-6 {
    margin-bottom: -1.5rem;
  }
  .sm\\:-ml-6 {
    margin-left: -1.5rem;
  }
  .sm\\:-mt-7 {
    margin-top: -1.75rem;
  }
  .sm\\:-mr-7 {
    margin-right: -1.75rem;
  }
  .sm\\:-mb-7 {
    margin-bottom: -1.75rem;
  }
  .sm\\:-ml-7 {
    margin-left: -1.75rem;
  }
  .sm\\:-mt-8 {
    margin-top: -2rem;
  }
  .sm\\:-mr-8 {
    margin-right: -2rem;
  }
  .sm\\:-mb-8 {
    margin-bottom: -2rem;
  }
  .sm\\:-ml-8 {
    margin-left: -2rem;
  }
  .sm\\:-mt-9 {
    margin-top: -2.25rem;
  }
  .sm\\:-mr-9 {
    margin-right: -2.25rem;
  }
  .sm\\:-mb-9 {
    margin-bottom: -2.25rem;
  }
  .sm\\:-ml-9 {
    margin-left: -2.25rem;
  }
  .sm\\:-mt-10 {
    margin-top: -2.5rem;
  }
  .sm\\:-mr-10 {
    margin-right: -2.5rem;
  }
  .sm\\:-mb-10 {
    margin-bottom: -2.5rem;
  }
  .sm\\:-ml-10 {
    margin-left: -2.5rem;
  }
  .sm\\:-mt-11 {
    margin-top: -2.75rem;
  }
  .sm\\:-mr-11 {
    margin-right: -2.75rem;
  }
  .sm\\:-mb-11 {
    margin-bottom: -2.75rem;
  }
  .sm\\:-ml-11 {
    margin-left: -2.75rem;
  }
  .sm\\:-mt-12 {
    margin-top: -3rem;
  }
  .sm\\:-mr-12 {
    margin-right: -3rem;
  }
  .sm\\:-mb-12 {
    margin-bottom: -3rem;
  }
  .sm\\:-ml-12 {
    margin-left: -3rem;
  }
  .sm\\:-mt-13 {
    margin-top: -3.25rem;
  }
  .sm\\:-mr-13 {
    margin-right: -3.25rem;
  }
  .sm\\:-mb-13 {
    margin-bottom: -3.25rem;
  }
  .sm\\:-ml-13 {
    margin-left: -3.25rem;
  }
  .sm\\:-mt-14 {
    margin-top: -3.5rem;
  }
  .sm\\:-mr-14 {
    margin-right: -3.5rem;
  }
  .sm\\:-mb-14 {
    margin-bottom: -3.5rem;
  }
  .sm\\:-ml-14 {
    margin-left: -3.5rem;
  }
  .sm\\:-mt-15 {
    margin-top: -3.75rem;
  }
  .sm\\:-mr-15 {
    margin-right: -3.75rem;
  }
  .sm\\:-mb-15 {
    margin-bottom: -3.75rem;
  }
  .sm\\:-ml-15 {
    margin-left: -3.75rem;
  }
  .sm\\:-mt-16 {
    margin-top: -4rem;
  }
  .sm\\:-mr-16 {
    margin-right: -4rem;
  }
  .sm\\:-mb-16 {
    margin-bottom: -4rem;
  }
  .sm\\:-ml-16 {
    margin-left: -4rem;
  }
  .sm\\:-mt-20 {
    margin-top: -5rem;
  }
  .sm\\:-mr-20 {
    margin-right: -5rem;
  }
  .sm\\:-mb-20 {
    margin-bottom: -5rem;
  }
  .sm\\:-ml-20 {
    margin-left: -5rem;
  }
  .sm\\:-mt-24 {
    margin-top: -6rem;
  }
  .sm\\:-mr-24 {
    margin-right: -6rem;
  }
  .sm\\:-mb-24 {
    margin-bottom: -6rem;
  }
  .sm\\:-ml-24 {
    margin-left: -6rem;
  }
  .sm\\:-mt-28 {
    margin-top: -7rem;
  }
  .sm\\:-mr-28 {
    margin-right: -7rem;
  }
  .sm\\:-mb-28 {
    margin-bottom: -7rem;
  }
  .sm\\:-ml-28 {
    margin-left: -7rem;
  }
  .sm\\:-mt-32 {
    margin-top: -8rem;
  }
  .sm\\:-mr-32 {
    margin-right: -8rem;
  }
  .sm\\:-mb-32 {
    margin-bottom: -8rem;
  }
  .sm\\:-ml-32 {
    margin-left: -8rem;
  }
  .sm\\:-mt-36 {
    margin-top: -9rem;
  }
  .sm\\:-mr-36 {
    margin-right: -9rem;
  }
  .sm\\:-mb-36 {
    margin-bottom: -9rem;
  }
  .sm\\:-ml-36 {
    margin-left: -9rem;
  }
  .sm\\:-mt-40 {
    margin-top: -10rem;
  }
  .sm\\:-mr-40 {
    margin-right: -10rem;
  }
  .sm\\:-mb-40 {
    margin-bottom: -10rem;
  }
  .sm\\:-ml-40 {
    margin-left: -10rem;
  }
  .sm\\:-mt-44 {
    margin-top: -11rem;
  }
  .sm\\:-mr-44 {
    margin-right: -11rem;
  }
  .sm\\:-mb-44 {
    margin-bottom: -11rem;
  }
  .sm\\:-ml-44 {
    margin-left: -11rem;
  }
  .sm\\:-mt-48 {
    margin-top: -12rem;
  }
  .sm\\:-mr-48 {
    margin-right: -12rem;
  }
  .sm\\:-mb-48 {
    margin-bottom: -12rem;
  }
  .sm\\:-ml-48 {
    margin-left: -12rem;
  }
  .sm\\:-mt-52 {
    margin-top: -13rem;
  }
  .sm\\:-mr-52 {
    margin-right: -13rem;
  }
  .sm\\:-mb-52 {
    margin-bottom: -13rem;
  }
  .sm\\:-ml-52 {
    margin-left: -13rem;
  }
  .sm\\:-mt-56 {
    margin-top: -14rem;
  }
  .sm\\:-mr-56 {
    margin-right: -14rem;
  }
  .sm\\:-mb-56 {
    margin-bottom: -14rem;
  }
  .sm\\:-ml-56 {
    margin-left: -14rem;
  }
  .sm\\:-mt-60 {
    margin-top: -15rem;
  }
  .sm\\:-mr-60 {
    margin-right: -15rem;
  }
  .sm\\:-mb-60 {
    margin-bottom: -15rem;
  }
  .sm\\:-ml-60 {
    margin-left: -15rem;
  }
  .sm\\:-mt-64 {
    margin-top: -16rem;
  }
  .sm\\:-mr-64 {
    margin-right: -16rem;
  }
  .sm\\:-mb-64 {
    margin-bottom: -16rem;
  }
  .sm\\:-ml-64 {
    margin-left: -16rem;
  }
  .sm\\:-mt-72 {
    margin-top: -18rem;
  }
  .sm\\:-mr-72 {
    margin-right: -18rem;
  }
  .sm\\:-mb-72 {
    margin-bottom: -18rem;
  }
  .sm\\:-ml-72 {
    margin-left: -18rem;
  }
  .sm\\:-mt-80 {
    margin-top: -20rem;
  }
  .sm\\:-mr-80 {
    margin-right: -20rem;
  }
  .sm\\:-mb-80 {
    margin-bottom: -20rem;
  }
  .sm\\:-ml-80 {
    margin-left: -20rem;
  }
  .sm\\:-mt-96 {
    margin-top: -24rem;
  }
  .sm\\:-mr-96 {
    margin-right: -24rem;
  }
  .sm\\:-mb-96 {
    margin-bottom: -24rem;
  }
  .sm\\:-ml-96 {
    margin-left: -24rem;
  }
  .sm\\:-mt-px {
    margin-top: -1px;
  }
  .sm\\:-mr-px {
    margin-right: -1px;
  }
  .sm\\:-mb-px {
    margin-bottom: -1px;
  }
  .sm\\:-ml-px {
    margin-left: -1px;
  }
  .sm\\:-mt-0\\.5 {
    margin-top: -0.125rem;
  }
  .sm\\:-mr-0\\.5 {
    margin-right: -0.125rem;
  }
  .sm\\:-mb-0\\.5 {
    margin-bottom: -0.125rem;
  }
  .sm\\:-ml-0\\.5 {
    margin-left: -0.125rem;
  }
  .sm\\:-mt-1\\.5 {
    margin-top: -0.375rem;
  }
  .sm\\:-mr-1\\.5 {
    margin-right: -0.375rem;
  }
  .sm\\:-mb-1\\.5 {
    margin-bottom: -0.375rem;
  }
  .sm\\:-ml-1\\.5 {
    margin-left: -0.375rem;
  }
  .sm\\:-mt-2\\.5 {
    margin-top: -0.625rem;
  }
  .sm\\:-mr-2\\.5 {
    margin-right: -0.625rem;
  }
  .sm\\:-mb-2\\.5 {
    margin-bottom: -0.625rem;
  }
  .sm\\:-ml-2\\.5 {
    margin-left: -0.625rem;
  }
  .sm\\:-mt-3\\.5 {
    margin-top: -0.875rem;
  }
  .sm\\:-mr-3\\.5 {
    margin-right: -0.875rem;
  }
  .sm\\:-mb-3\\.5 {
    margin-bottom: -0.875rem;
  }
  .sm\\:-ml-3\\.5 {
    margin-left: -0.875rem;
  }
  .sm\\:-mt-1\\/2 {
    margin-top: -50%;
  }
  .sm\\:-mr-1\\/2 {
    margin-right: -50%;
  }
  .sm\\:-mb-1\\/2 {
    margin-bottom: -50%;
  }
  .sm\\:-ml-1\\/2 {
    margin-left: -50%;
  }
  .sm\\:-mt-1\\/3 {
    margin-top: -33.33333%;
  }
  .sm\\:-mr-1\\/3 {
    margin-right: -33.33333%;
  }
  .sm\\:-mb-1\\/3 {
    margin-bottom: -33.33333%;
  }
  .sm\\:-ml-1\\/3 {
    margin-left: -33.33333%;
  }
  .sm\\:-mt-2\\/3 {
    margin-top: -66.66667%;
  }
  .sm\\:-mr-2\\/3 {
    margin-right: -66.66667%;
  }
  .sm\\:-mb-2\\/3 {
    margin-bottom: -66.66667%;
  }
  .sm\\:-ml-2\\/3 {
    margin-left: -66.66667%;
  }
  .sm\\:-mt-1\\/4 {
    margin-top: -25%;
  }
  .sm\\:-mr-1\\/4 {
    margin-right: -25%;
  }
  .sm\\:-mb-1\\/4 {
    margin-bottom: -25%;
  }
  .sm\\:-ml-1\\/4 {
    margin-left: -25%;
  }
  .sm\\:-mt-2\\/4 {
    margin-top: -50%;
  }
  .sm\\:-mr-2\\/4 {
    margin-right: -50%;
  }
  .sm\\:-mb-2\\/4 {
    margin-bottom: -50%;
  }
  .sm\\:-ml-2\\/4 {
    margin-left: -50%;
  }
  .sm\\:-mt-3\\/4 {
    margin-top: -75%;
  }
  .sm\\:-mr-3\\/4 {
    margin-right: -75%;
  }
  .sm\\:-mb-3\\/4 {
    margin-bottom: -75%;
  }
  .sm\\:-ml-3\\/4 {
    margin-left: -75%;
  }
  .sm\\:-mt-1\\/5 {
    margin-top: -20%;
  }
  .sm\\:-mr-1\\/5 {
    margin-right: -20%;
  }
  .sm\\:-mb-1\\/5 {
    margin-bottom: -20%;
  }
  .sm\\:-ml-1\\/5 {
    margin-left: -20%;
  }
  .sm\\:-mt-2\\/5 {
    margin-top: -40%;
  }
  .sm\\:-mr-2\\/5 {
    margin-right: -40%;
  }
  .sm\\:-mb-2\\/5 {
    margin-bottom: -40%;
  }
  .sm\\:-ml-2\\/5 {
    margin-left: -40%;
  }
  .sm\\:-mt-3\\/5 {
    margin-top: -60%;
  }
  .sm\\:-mr-3\\/5 {
    margin-right: -60%;
  }
  .sm\\:-mb-3\\/5 {
    margin-bottom: -60%;
  }
  .sm\\:-ml-3\\/5 {
    margin-left: -60%;
  }
  .sm\\:-mt-4\\/5 {
    margin-top: -80%;
  }
  .sm\\:-mr-4\\/5 {
    margin-right: -80%;
  }
  .sm\\:-mb-4\\/5 {
    margin-bottom: -80%;
  }
  .sm\\:-ml-4\\/5 {
    margin-left: -80%;
  }
  .sm\\:-mt-1\\/6 {
    margin-top: -16.66667%;
  }
  .sm\\:-mr-1\\/6 {
    margin-right: -16.66667%;
  }
  .sm\\:-mb-1\\/6 {
    margin-bottom: -16.66667%;
  }
  .sm\\:-ml-1\\/6 {
    margin-left: -16.66667%;
  }
  .sm\\:-mt-2\\/6 {
    margin-top: -33.33333%;
  }
  .sm\\:-mr-2\\/6 {
    margin-right: -33.33333%;
  }
  .sm\\:-mb-2\\/6 {
    margin-bottom: -33.33333%;
  }
  .sm\\:-ml-2\\/6 {
    margin-left: -33.33333%;
  }
  .sm\\:-mt-3\\/6 {
    margin-top: -50%;
  }
  .sm\\:-mr-3\\/6 {
    margin-right: -50%;
  }
  .sm\\:-mb-3\\/6 {
    margin-bottom: -50%;
  }
  .sm\\:-ml-3\\/6 {
    margin-left: -50%;
  }
  .sm\\:-mt-4\\/6 {
    margin-top: -66.66667%;
  }
  .sm\\:-mr-4\\/6 {
    margin-right: -66.66667%;
  }
  .sm\\:-mb-4\\/6 {
    margin-bottom: -66.66667%;
  }
  .sm\\:-ml-4\\/6 {
    margin-left: -66.66667%;
  }
  .sm\\:-mt-5\\/6 {
    margin-top: -83.33333%;
  }
  .sm\\:-mr-5\\/6 {
    margin-right: -83.33333%;
  }
  .sm\\:-mb-5\\/6 {
    margin-bottom: -83.33333%;
  }
  .sm\\:-ml-5\\/6 {
    margin-left: -83.33333%;
  }
  .sm\\:-mt-1\\/12 {
    margin-top: -8.33333%;
  }
  .sm\\:-mr-1\\/12 {
    margin-right: -8.33333%;
  }
  .sm\\:-mb-1\\/12 {
    margin-bottom: -8.33333%;
  }
  .sm\\:-ml-1\\/12 {
    margin-left: -8.33333%;
  }
  .sm\\:-mt-2\\/12 {
    margin-top: -16.66667%;
  }
  .sm\\:-mr-2\\/12 {
    margin-right: -16.66667%;
  }
  .sm\\:-mb-2\\/12 {
    margin-bottom: -16.66667%;
  }
  .sm\\:-ml-2\\/12 {
    margin-left: -16.66667%;
  }
  .sm\\:-mt-3\\/12 {
    margin-top: -25%;
  }
  .sm\\:-mr-3\\/12 {
    margin-right: -25%;
  }
  .sm\\:-mb-3\\/12 {
    margin-bottom: -25%;
  }
  .sm\\:-ml-3\\/12 {
    margin-left: -25%;
  }
  .sm\\:-mt-4\\/12 {
    margin-top: -33.33333%;
  }
  .sm\\:-mr-4\\/12 {
    margin-right: -33.33333%;
  }
  .sm\\:-mb-4\\/12 {
    margin-bottom: -33.33333%;
  }
  .sm\\:-ml-4\\/12 {
    margin-left: -33.33333%;
  }
  .sm\\:-mt-5\\/12 {
    margin-top: -41.66667%;
  }
  .sm\\:-mr-5\\/12 {
    margin-right: -41.66667%;
  }
  .sm\\:-mb-5\\/12 {
    margin-bottom: -41.66667%;
  }
  .sm\\:-ml-5\\/12 {
    margin-left: -41.66667%;
  }
  .sm\\:-mt-6\\/12 {
    margin-top: -50%;
  }
  .sm\\:-mr-6\\/12 {
    margin-right: -50%;
  }
  .sm\\:-mb-6\\/12 {
    margin-bottom: -50%;
  }
  .sm\\:-ml-6\\/12 {
    margin-left: -50%;
  }
  .sm\\:-mt-7\\/12 {
    margin-top: -58.33333%;
  }
  .sm\\:-mr-7\\/12 {
    margin-right: -58.33333%;
  }
  .sm\\:-mb-7\\/12 {
    margin-bottom: -58.33333%;
  }
  .sm\\:-ml-7\\/12 {
    margin-left: -58.33333%;
  }
  .sm\\:-mt-8\\/12 {
    margin-top: -66.66667%;
  }
  .sm\\:-mr-8\\/12 {
    margin-right: -66.66667%;
  }
  .sm\\:-mb-8\\/12 {
    margin-bottom: -66.66667%;
  }
  .sm\\:-ml-8\\/12 {
    margin-left: -66.66667%;
  }
  .sm\\:-mt-9\\/12 {
    margin-top: -75%;
  }
  .sm\\:-mr-9\\/12 {
    margin-right: -75%;
  }
  .sm\\:-mb-9\\/12 {
    margin-bottom: -75%;
  }
  .sm\\:-ml-9\\/12 {
    margin-left: -75%;
  }
  .sm\\:-mt-10\\/12 {
    margin-top: -83.33333%;
  }
  .sm\\:-mr-10\\/12 {
    margin-right: -83.33333%;
  }
  .sm\\:-mb-10\\/12 {
    margin-bottom: -83.33333%;
  }
  .sm\\:-ml-10\\/12 {
    margin-left: -83.33333%;
  }
  .sm\\:-mt-11\\/12 {
    margin-top: -91.66667%;
  }
  .sm\\:-mr-11\\/12 {
    margin-right: -91.66667%;
  }
  .sm\\:-mb-11\\/12 {
    margin-bottom: -91.66667%;
  }
  .sm\\:-ml-11\\/12 {
    margin-left: -91.66667%;
  }
  .sm\\:-mt-full {
    margin-top: -100%;
  }
  .sm\\:-mr-full {
    margin-right: -100%;
  }
  .sm\\:-mb-full {
    margin-bottom: -100%;
  }
  .sm\\:-ml-full {
    margin-left: -100%;
  }
  .sm\\:max-h-0 {
    max-height: 0;
  }
  .sm\\:max-h-1 {
    max-height: 0.25rem;
  }
  .sm\\:max-h-2 {
    max-height: 0.5rem;
  }
  .sm\\:max-h-3 {
    max-height: 0.75rem;
  }
  .sm\\:max-h-4 {
    max-height: 1rem;
  }
  .sm\\:max-h-5 {
    max-height: 1.25rem;
  }
  .sm\\:max-h-6 {
    max-height: 1.5rem;
  }
  .sm\\:max-h-7 {
    max-height: 1.75rem;
  }
  .sm\\:max-h-8 {
    max-height: 2rem;
  }
  .sm\\:max-h-9 {
    max-height: 2.25rem;
  }
  .sm\\:max-h-10 {
    max-height: 2.5rem;
  }
  .sm\\:max-h-11 {
    max-height: 2.75rem;
  }
  .sm\\:max-h-12 {
    max-height: 3rem;
  }
  .sm\\:max-h-13 {
    max-height: 3.25rem;
  }
  .sm\\:max-h-14 {
    max-height: 3.5rem;
  }
  .sm\\:max-h-15 {
    max-height: 3.75rem;
  }
  .sm\\:max-h-16 {
    max-height: 4rem;
  }
  .sm\\:max-h-20 {
    max-height: 5rem;
  }
  .sm\\:max-h-24 {
    max-height: 6rem;
  }
  .sm\\:max-h-28 {
    max-height: 7rem;
  }
  .sm\\:max-h-32 {
    max-height: 8rem;
  }
  .sm\\:max-h-36 {
    max-height: 9rem;
  }
  .sm\\:max-h-40 {
    max-height: 10rem;
  }
  .sm\\:max-h-44 {
    max-height: 11rem;
  }
  .sm\\:max-h-48 {
    max-height: 12rem;
  }
  .sm\\:max-h-52 {
    max-height: 13rem;
  }
  .sm\\:max-h-56 {
    max-height: 14rem;
  }
  .sm\\:max-h-60 {
    max-height: 15rem;
  }
  .sm\\:max-h-64 {
    max-height: 16rem;
  }
  .sm\\:max-h-72 {
    max-height: 18rem;
  }
  .sm\\:max-h-80 {
    max-height: 20rem;
  }
  .sm\\:max-h-96 {
    max-height: 24rem;
  }
  .sm\\:max-h-screen {
    max-height: 100vh;
  }
  .sm\\:max-h-px {
    max-height: 1px;
  }
  .sm\\:max-h-0\\.5 {
    max-height: 0.125rem;
  }
  .sm\\:max-h-1\\.5 {
    max-height: 0.375rem;
  }
  .sm\\:max-h-2\\.5 {
    max-height: 0.625rem;
  }
  .sm\\:max-h-3\\.5 {
    max-height: 0.875rem;
  }
  .sm\\:max-h-1\\/2 {
    max-height: 50%;
  }
  .sm\\:max-h-1\\/3 {
    max-height: 33.333333%;
  }
  .sm\\:max-h-2\\/3 {
    max-height: 66.666667%;
  }
  .sm\\:max-h-1\\/4 {
    max-height: 25%;
  }
  .sm\\:max-h-2\\/4 {
    max-height: 50%;
  }
  .sm\\:max-h-3\\/4 {
    max-height: 75%;
  }
  .sm\\:max-h-1\\/5 {
    max-height: 20%;
  }
  .sm\\:max-h-2\\/5 {
    max-height: 40%;
  }
  .sm\\:max-h-3\\/5 {
    max-height: 60%;
  }
  .sm\\:max-h-4\\/5 {
    max-height: 80%;
  }
  .sm\\:max-h-1\\/6 {
    max-height: 16.666667%;
  }
  .sm\\:max-h-2\\/6 {
    max-height: 33.333333%;
  }
  .sm\\:max-h-3\\/6 {
    max-height: 50%;
  }
  .sm\\:max-h-4\\/6 {
    max-height: 66.666667%;
  }
  .sm\\:max-h-5\\/6 {
    max-height: 83.333333%;
  }
  .sm\\:max-h-1\\/12 {
    max-height: 8.333333%;
  }
  .sm\\:max-h-2\\/12 {
    max-height: 16.666667%;
  }
  .sm\\:max-h-3\\/12 {
    max-height: 25%;
  }
  .sm\\:max-h-4\\/12 {
    max-height: 33.333333%;
  }
  .sm\\:max-h-5\\/12 {
    max-height: 41.666667%;
  }
  .sm\\:max-h-6\\/12 {
    max-height: 50%;
  }
  .sm\\:max-h-7\\/12 {
    max-height: 58.333333%;
  }
  .sm\\:max-h-8\\/12 {
    max-height: 66.666667%;
  }
  .sm\\:max-h-9\\/12 {
    max-height: 75%;
  }
  .sm\\:max-h-10\\/12 {
    max-height: 83.333333%;
  }
  .sm\\:max-h-11\\/12 {
    max-height: 91.666667%;
  }
  .sm\\:max-h-full {
    max-height: 100%;
  }
  .sm\\:max-w-0 {
    max-width: 0rem;
  }
  .sm\\:max-w-none {
    max-width: none;
  }
  .sm\\:max-w-xs {
    max-width: 20rem;
  }
  .sm\\:max-w-sm {
    max-width: 24rem;
  }
  .sm\\:max-w-md {
    max-width: 28rem;
  }
  .sm\\:max-w-lg {
    max-width: 32rem;
  }
  .sm\\:max-w-xl {
    max-width: 36rem;
  }
  .sm\\:max-w-2xl {
    max-width: 42rem;
  }
  .sm\\:max-w-3xl {
    max-width: 48rem;
  }
  .sm\\:max-w-4xl {
    max-width: 56rem;
  }
  .sm\\:max-w-5xl {
    max-width: 64rem;
  }
  .sm\\:max-w-6xl {
    max-width: 72rem;
  }
  .sm\\:max-w-7xl {
    max-width: 80rem;
  }
  .sm\\:max-w-full {
    max-width: 100%;
  }
  .sm\\:max-w-min-content {
    max-width: min-content;
  }
  .sm\\:max-w-max-content {
    max-width: max-content;
  }
  .sm\\:max-w-prose {
    max-width: 65ch;
  }
  .sm\\:max-w-screen-sm {
    max-width: 640px;
  }
  .sm\\:max-w-screen-md {
    max-width: 768px;
  }
  .sm\\:max-w-screen-lg {
    max-width: 1024px;
  }
  .sm\\:max-w-screen-xl {
    max-width: 1280px;
  }
  .sm\\:min-h-0 {
    min-height: 0;
  }
  .sm\\:min-h-full {
    min-height: 100%;
  }
  .sm\\:min-h-screen {
    min-height: 100vh;
  }
  .sm\\:min-w-0 {
    min-width: 0;
  }
  .sm\\:min-w-full {
    min-width: 100%;
  }
  .sm\\:min-w-min-content {
    min-width: min-content;
  }
  .sm\\:min-w-max-content {
    min-width: max-content;
  }
  .sm\\:object-contain {
    object-fit: contain;
  }
  .sm\\:object-cover {
    object-fit: cover;
  }
  .sm\\:object-fill {
    object-fit: fill;
  }
  .sm\\:object-none {
    object-fit: none;
  }
  .sm\\:object-scale-down {
    object-fit: scale-down;
  }
  .sm\\:object-bottom {
    object-position: bottom;
  }
  .sm\\:object-center {
    object-position: center;
  }
  .sm\\:object-left {
    object-position: left;
  }
  .sm\\:object-left-bottom {
    object-position: left bottom;
  }
  .sm\\:object-left-top {
    object-position: left top;
  }
  .sm\\:object-right {
    object-position: right;
  }
  .sm\\:object-right-bottom {
    object-position: right bottom;
  }
  .sm\\:object-right-top {
    object-position: right top;
  }
  .sm\\:object-top {
    object-position: top;
  }
  .sm\\:opacity-0 {
    opacity: 0;
  }
  .sm\\:opacity-25 {
    opacity: 0.25;
  }
  .sm\\:opacity-50 {
    opacity: 0.5;
  }
  .sm\\:opacity-75 {
    opacity: 0.75;
  }
  .sm\\:opacity-100 {
    opacity: 1;
  }
  .sm\\:focus-within\\:opacity-0:focus-within {
    opacity: 0;
  }
  .sm\\:focus-within\\:opacity-25:focus-within {
    opacity: 0.25;
  }
  .sm\\:focus-within\\:opacity-50:focus-within {
    opacity: 0.5;
  }
  .sm\\:focus-within\\:opacity-75:focus-within {
    opacity: 0.75;
  }
  .sm\\:focus-within\\:opacity-100:focus-within {
    opacity: 1;
  }
  .group:hover .sm\\:group-hover\\:opacity-0 {
    opacity: 0;
  }
  .group:hover .sm\\:group-hover\\:opacity-25 {
    opacity: 0.25;
  }
  .group:hover .sm\\:group-hover\\:opacity-50 {
    opacity: 0.5;
  }
  .group:hover .sm\\:group-hover\\:opacity-75 {
    opacity: 0.75;
  }
  .group:hover .sm\\:group-hover\\:opacity-100 {
    opacity: 1;
  }
  .group:focus .sm\\:group-focus\\:opacity-0 {
    opacity: 0;
  }
  .group:focus .sm\\:group-focus\\:opacity-25 {
    opacity: 0.25;
  }
  .group:focus .sm\\:group-focus\\:opacity-50 {
    opacity: 0.5;
  }
  .group:focus .sm\\:group-focus\\:opacity-75 {
    opacity: 0.75;
  }
  .group:focus .sm\\:group-focus\\:opacity-100 {
    opacity: 1;
  }
  .sm\\:hover\\:opacity-0:hover {
    opacity: 0;
  }
  .sm\\:hover\\:opacity-25:hover {
    opacity: 0.25;
  }
  .sm\\:hover\\:opacity-50:hover {
    opacity: 0.5;
  }
  .sm\\:hover\\:opacity-75:hover {
    opacity: 0.75;
  }
  .sm\\:hover\\:opacity-100:hover {
    opacity: 1;
  }
  .sm\\:focus\\:opacity-0:focus {
    opacity: 0;
  }
  .sm\\:focus\\:opacity-25:focus {
    opacity: 0.25;
  }
  .sm\\:focus\\:opacity-50:focus {
    opacity: 0.5;
  }
  .sm\\:focus\\:opacity-75:focus {
    opacity: 0.75;
  }
  .sm\\:focus\\:opacity-100:focus {
    opacity: 1;
  }
  .sm\\:outline-none {
    outline: 2px solid transparent;
    outline-offset: 2px;
  }
  .sm\\:outline-white {
    outline: 2px dotted white;
    outline-offset: 2px;
  }
  .sm\\:outline-black {
    outline: 2px dotted black;
    outline-offset: 2px;
  }
  .sm\\:focus\\:outline-none:focus {
    outline: 2px solid transparent;
    outline-offset: 2px;
  }
  .sm\\:focus\\:outline-white:focus {
    outline: 2px dotted white;
    outline-offset: 2px;
  }
  .sm\\:focus\\:outline-black:focus {
    outline: 2px dotted black;
    outline-offset: 2px;
  }
  .sm\\:overflow-auto {
    overflow: auto;
  }
  .sm\\:overflow-hidden {
    overflow: hidden;
  }
  .sm\\:overflow-visible {
    overflow: visible;
  }
  .sm\\:overflow-scroll {
    overflow: scroll;
  }
  .sm\\:overflow-x-auto {
    overflow-x: auto;
  }
  .sm\\:overflow-y-auto {
    overflow-y: auto;
  }
  .sm\\:overflow-x-hidden {
    overflow-x: hidden;
  }
  .sm\\:overflow-y-hidden {
    overflow-y: hidden;
  }
  .sm\\:overflow-x-visible {
    overflow-x: visible;
  }
  .sm\\:overflow-y-visible {
    overflow-y: visible;
  }
  .sm\\:overflow-x-scroll {
    overflow-x: scroll;
  }
  .sm\\:overflow-y-scroll {
    overflow-y: scroll;
  }
  .sm\\:scrolling-touch {
    -webkit-overflow-scrolling: touch;
  }
  .sm\\:scrolling-auto {
    -webkit-overflow-scrolling: auto;
  }
  .sm\\:overscroll-auto {
    overscroll-behavior: auto;
  }
  .sm\\:overscroll-contain {
    overscroll-behavior: contain;
  }
  .sm\\:overscroll-none {
    overscroll-behavior: none;
  }
  .sm\\:overscroll-y-auto {
    overscroll-behavior-y: auto;
  }
  .sm\\:overscroll-y-contain {
    overscroll-behavior-y: contain;
  }
  .sm\\:overscroll-y-none {
    overscroll-behavior-y: none;
  }
  .sm\\:overscroll-x-auto {
    overscroll-behavior-x: auto;
  }
  .sm\\:overscroll-x-contain {
    overscroll-behavior-x: contain;
  }
  .sm\\:overscroll-x-none {
    overscroll-behavior-x: none;
  }
  .sm\\:p-0 {
    padding: 0;
  }
  .sm\\:p-1 {
    padding: 0.25rem;
  }
  .sm\\:p-2 {
    padding: 0.5rem;
  }
  .sm\\:p-3 {
    padding: 0.75rem;
  }
  .sm\\:p-4 {
    padding: 1rem;
  }
  .sm\\:p-5 {
    padding: 1.25rem;
  }
  .sm\\:p-6 {
    padding: 1.5rem;
  }
  .sm\\:p-7 {
    padding: 1.75rem;
  }
  .sm\\:p-8 {
    padding: 2rem;
  }
  .sm\\:p-9 {
    padding: 2.25rem;
  }
  .sm\\:p-10 {
    padding: 2.5rem;
  }
  .sm\\:p-11 {
    padding: 2.75rem;
  }
  .sm\\:p-12 {
    padding: 3rem;
  }
  .sm\\:p-13 {
    padding: 3.25rem;
  }
  .sm\\:p-14 {
    padding: 3.5rem;
  }
  .sm\\:p-15 {
    padding: 3.75rem;
  }
  .sm\\:p-16 {
    padding: 4rem;
  }
  .sm\\:p-20 {
    padding: 5rem;
  }
  .sm\\:p-24 {
    padding: 6rem;
  }
  .sm\\:p-28 {
    padding: 7rem;
  }
  .sm\\:p-32 {
    padding: 8rem;
  }
  .sm\\:p-36 {
    padding: 9rem;
  }
  .sm\\:p-40 {
    padding: 10rem;
  }
  .sm\\:p-44 {
    padding: 11rem;
  }
  .sm\\:p-48 {
    padding: 12rem;
  }
  .sm\\:p-52 {
    padding: 13rem;
  }
  .sm\\:p-56 {
    padding: 14rem;
  }
  .sm\\:p-60 {
    padding: 15rem;
  }
  .sm\\:p-64 {
    padding: 16rem;
  }
  .sm\\:p-72 {
    padding: 18rem;
  }
  .sm\\:p-80 {
    padding: 20rem;
  }
  .sm\\:p-96 {
    padding: 24rem;
  }
  .sm\\:p-px {
    padding: 1px;
  }
  .sm\\:p-0\\.5 {
    padding: 0.125rem;
  }
  .sm\\:p-1\\.5 {
    padding: 0.375rem;
  }
  .sm\\:p-2\\.5 {
    padding: 0.625rem;
  }
  .sm\\:p-3\\.5 {
    padding: 0.875rem;
  }
  .sm\\:p-1\\/2 {
    padding: 50%;
  }
  .sm\\:p-1\\/3 {
    padding: 33.333333%;
  }
  .sm\\:p-2\\/3 {
    padding: 66.666667%;
  }
  .sm\\:p-1\\/4 {
    padding: 25%;
  }
  .sm\\:p-2\\/4 {
    padding: 50%;
  }
  .sm\\:p-3\\/4 {
    padding: 75%;
  }
  .sm\\:p-1\\/5 {
    padding: 20%;
  }
  .sm\\:p-2\\/5 {
    padding: 40%;
  }
  .sm\\:p-3\\/5 {
    padding: 60%;
  }
  .sm\\:p-4\\/5 {
    padding: 80%;
  }
  .sm\\:p-1\\/6 {
    padding: 16.666667%;
  }
  .sm\\:p-2\\/6 {
    padding: 33.333333%;
  }
  .sm\\:p-3\\/6 {
    padding: 50%;
  }
  .sm\\:p-4\\/6 {
    padding: 66.666667%;
  }
  .sm\\:p-5\\/6 {
    padding: 83.333333%;
  }
  .sm\\:p-1\\/12 {
    padding: 8.333333%;
  }
  .sm\\:p-2\\/12 {
    padding: 16.666667%;
  }
  .sm\\:p-3\\/12 {
    padding: 25%;
  }
  .sm\\:p-4\\/12 {
    padding: 33.333333%;
  }
  .sm\\:p-5\\/12 {
    padding: 41.666667%;
  }
  .sm\\:p-6\\/12 {
    padding: 50%;
  }
  .sm\\:p-7\\/12 {
    padding: 58.333333%;
  }
  .sm\\:p-8\\/12 {
    padding: 66.666667%;
  }
  .sm\\:p-9\\/12 {
    padding: 75%;
  }
  .sm\\:p-10\\/12 {
    padding: 83.333333%;
  }
  .sm\\:p-11\\/12 {
    padding: 91.666667%;
  }
  .sm\\:p-full {
    padding: 100%;
  }
  .sm\\:py-0 {
    padding-top: 0;
    padding-bottom: 0;
  }
  .sm\\:px-0 {
    padding-left: 0;
    padding-right: 0;
  }
  .sm\\:py-1 {
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
  }
  .sm\\:px-1 {
    padding-left: 0.25rem;
    padding-right: 0.25rem;
  }
  .sm\\:py-2 {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }
  .sm\\:px-2 {
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }
  .sm\\:py-3 {
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
  }
  .sm\\:px-3 {
    padding-left: 0.75rem;
    padding-right: 0.75rem;
  }
  .sm\\:py-4 {
    padding-top: 1rem;
    padding-bottom: 1rem;
  }
  .sm\\:px-4 {
    padding-left: 1rem;
    padding-right: 1rem;
  }
  .sm\\:py-5 {
    padding-top: 1.25rem;
    padding-bottom: 1.25rem;
  }
  .sm\\:px-5 {
    padding-left: 1.25rem;
    padding-right: 1.25rem;
  }
  .sm\\:py-6 {
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
  }
  .sm\\:px-6 {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }
  .sm\\:py-7 {
    padding-top: 1.75rem;
    padding-bottom: 1.75rem;
  }
  .sm\\:px-7 {
    padding-left: 1.75rem;
    padding-right: 1.75rem;
  }
  .sm\\:py-8 {
    padding-top: 2rem;
    padding-bottom: 2rem;
  }
  .sm\\:px-8 {
    padding-left: 2rem;
    padding-right: 2rem;
  }
  .sm\\:py-9 {
    padding-top: 2.25rem;
    padding-bottom: 2.25rem;
  }
  .sm\\:px-9 {
    padding-left: 2.25rem;
    padding-right: 2.25rem;
  }
  .sm\\:py-10 {
    padding-top: 2.5rem;
    padding-bottom: 2.5rem;
  }
  .sm\\:px-10 {
    padding-left: 2.5rem;
    padding-right: 2.5rem;
  }
  .sm\\:py-11 {
    padding-top: 2.75rem;
    padding-bottom: 2.75rem;
  }
  .sm\\:px-11 {
    padding-left: 2.75rem;
    padding-right: 2.75rem;
  }
  .sm\\:py-12 {
    padding-top: 3rem;
    padding-bottom: 3rem;
  }
  .sm\\:px-12 {
    padding-left: 3rem;
    padding-right: 3rem;
  }
  .sm\\:py-13 {
    padding-top: 3.25rem;
    padding-bottom: 3.25rem;
  }
  .sm\\:px-13 {
    padding-left: 3.25rem;
    padding-right: 3.25rem;
  }
  .sm\\:py-14 {
    padding-top: 3.5rem;
    padding-bottom: 3.5rem;
  }
  .sm\\:px-14 {
    padding-left: 3.5rem;
    padding-right: 3.5rem;
  }
  .sm\\:py-15 {
    padding-top: 3.75rem;
    padding-bottom: 3.75rem;
  }
  .sm\\:px-15 {
    padding-left: 3.75rem;
    padding-right: 3.75rem;
  }
  .sm\\:py-16 {
    padding-top: 4rem;
    padding-bottom: 4rem;
  }
  .sm\\:px-16 {
    padding-left: 4rem;
    padding-right: 4rem;
  }
  .sm\\:py-20 {
    padding-top: 5rem;
    padding-bottom: 5rem;
  }
  .sm\\:px-20 {
    padding-left: 5rem;
    padding-right: 5rem;
  }
  .sm\\:py-24 {
    padding-top: 6rem;
    padding-bottom: 6rem;
  }
  .sm\\:px-24 {
    padding-left: 6rem;
    padding-right: 6rem;
  }
  .sm\\:py-28 {
    padding-top: 7rem;
    padding-bottom: 7rem;
  }
  .sm\\:px-28 {
    padding-left: 7rem;
    padding-right: 7rem;
  }
  .sm\\:py-32 {
    padding-top: 8rem;
    padding-bottom: 8rem;
  }
  .sm\\:px-32 {
    padding-left: 8rem;
    padding-right: 8rem;
  }
  .sm\\:py-36 {
    padding-top: 9rem;
    padding-bottom: 9rem;
  }
  .sm\\:px-36 {
    padding-left: 9rem;
    padding-right: 9rem;
  }
  .sm\\:py-40 {
    padding-top: 10rem;
    padding-bottom: 10rem;
  }
  .sm\\:px-40 {
    padding-left: 10rem;
    padding-right: 10rem;
  }
  .sm\\:py-44 {
    padding-top: 11rem;
    padding-bottom: 11rem;
  }
  .sm\\:px-44 {
    padding-left: 11rem;
    padding-right: 11rem;
  }
  .sm\\:py-48 {
    padding-top: 12rem;
    padding-bottom: 12rem;
  }
  .sm\\:px-48 {
    padding-left: 12rem;
    padding-right: 12rem;
  }
  .sm\\:py-52 {
    padding-top: 13rem;
    padding-bottom: 13rem;
  }
  .sm\\:px-52 {
    padding-left: 13rem;
    padding-right: 13rem;
  }
  .sm\\:py-56 {
    padding-top: 14rem;
    padding-bottom: 14rem;
  }
  .sm\\:px-56 {
    padding-left: 14rem;
    padding-right: 14rem;
  }
  .sm\\:py-60 {
    padding-top: 15rem;
    padding-bottom: 15rem;
  }
  .sm\\:px-60 {
    padding-left: 15rem;
    padding-right: 15rem;
  }
  .sm\\:py-64 {
    padding-top: 16rem;
    padding-bottom: 16rem;
  }
  .sm\\:px-64 {
    padding-left: 16rem;
    padding-right: 16rem;
  }
  .sm\\:py-72 {
    padding-top: 18rem;
    padding-bottom: 18rem;
  }
  .sm\\:px-72 {
    padding-left: 18rem;
    padding-right: 18rem;
  }
  .sm\\:py-80 {
    padding-top: 20rem;
    padding-bottom: 20rem;
  }
  .sm\\:px-80 {
    padding-left: 20rem;
    padding-right: 20rem;
  }
  .sm\\:py-96 {
    padding-top: 24rem;
    padding-bottom: 24rem;
  }
  .sm\\:px-96 {
    padding-left: 24rem;
    padding-right: 24rem;
  }
  .sm\\:py-px {
    padding-top: 1px;
    padding-bottom: 1px;
  }
  .sm\\:px-px {
    padding-left: 1px;
    padding-right: 1px;
  }
  .sm\\:py-0\\.5 {
    padding-top: 0.125rem;
    padding-bottom: 0.125rem;
  }
  .sm\\:px-0\\.5 {
    padding-left: 0.125rem;
    padding-right: 0.125rem;
  }
  .sm\\:py-1\\.5 {
    padding-top: 0.375rem;
    padding-bottom: 0.375rem;
  }
  .sm\\:px-1\\.5 {
    padding-left: 0.375rem;
    padding-right: 0.375rem;
  }
  .sm\\:py-2\\.5 {
    padding-top: 0.625rem;
    padding-bottom: 0.625rem;
  }
  .sm\\:px-2\\.5 {
    padding-left: 0.625rem;
    padding-right: 0.625rem;
  }
  .sm\\:py-3\\.5 {
    padding-top: 0.875rem;
    padding-bottom: 0.875rem;
  }
  .sm\\:px-3\\.5 {
    padding-left: 0.875rem;
    padding-right: 0.875rem;
  }
  .sm\\:py-1\\/2 {
    padding-top: 50%;
    padding-bottom: 50%;
  }
  .sm\\:px-1\\/2 {
    padding-left: 50%;
    padding-right: 50%;
  }
  .sm\\:py-1\\/3 {
    padding-top: 33.333333%;
    padding-bottom: 33.333333%;
  }
  .sm\\:px-1\\/3 {
    padding-left: 33.333333%;
    padding-right: 33.333333%;
  }
  .sm\\:py-2\\/3 {
    padding-top: 66.666667%;
    padding-bottom: 66.666667%;
  }
  .sm\\:px-2\\/3 {
    padding-left: 66.666667%;
    padding-right: 66.666667%;
  }
  .sm\\:py-1\\/4 {
    padding-top: 25%;
    padding-bottom: 25%;
  }
  .sm\\:px-1\\/4 {
    padding-left: 25%;
    padding-right: 25%;
  }
  .sm\\:py-2\\/4 {
    padding-top: 50%;
    padding-bottom: 50%;
  }
  .sm\\:px-2\\/4 {
    padding-left: 50%;
    padding-right: 50%;
  }
  .sm\\:py-3\\/4 {
    padding-top: 75%;
    padding-bottom: 75%;
  }
  .sm\\:px-3\\/4 {
    padding-left: 75%;
    padding-right: 75%;
  }
  .sm\\:py-1\\/5 {
    padding-top: 20%;
    padding-bottom: 20%;
  }
  .sm\\:px-1\\/5 {
    padding-left: 20%;
    padding-right: 20%;
  }
  .sm\\:py-2\\/5 {
    padding-top: 40%;
    padding-bottom: 40%;
  }
  .sm\\:px-2\\/5 {
    padding-left: 40%;
    padding-right: 40%;
  }
  .sm\\:py-3\\/5 {
    padding-top: 60%;
    padding-bottom: 60%;
  }
  .sm\\:px-3\\/5 {
    padding-left: 60%;
    padding-right: 60%;
  }
  .sm\\:py-4\\/5 {
    padding-top: 80%;
    padding-bottom: 80%;
  }
  .sm\\:px-4\\/5 {
    padding-left: 80%;
    padding-right: 80%;
  }
  .sm\\:py-1\\/6 {
    padding-top: 16.666667%;
    padding-bottom: 16.666667%;
  }
  .sm\\:px-1\\/6 {
    padding-left: 16.666667%;
    padding-right: 16.666667%;
  }
  .sm\\:py-2\\/6 {
    padding-top: 33.333333%;
    padding-bottom: 33.333333%;
  }
  .sm\\:px-2\\/6 {
    padding-left: 33.333333%;
    padding-right: 33.333333%;
  }
  .sm\\:py-3\\/6 {
    padding-top: 50%;
    padding-bottom: 50%;
  }
  .sm\\:px-3\\/6 {
    padding-left: 50%;
    padding-right: 50%;
  }
  .sm\\:py-4\\/6 {
    padding-top: 66.666667%;
    padding-bottom: 66.666667%;
  }
  .sm\\:px-4\\/6 {
    padding-left: 66.666667%;
    padding-right: 66.666667%;
  }
  .sm\\:py-5\\/6 {
    padding-top: 83.333333%;
    padding-bottom: 83.333333%;
  }
  .sm\\:px-5\\/6 {
    padding-left: 83.333333%;
    padding-right: 83.333333%;
  }
  .sm\\:py-1\\/12 {
    padding-top: 8.333333%;
    padding-bottom: 8.333333%;
  }
  .sm\\:px-1\\/12 {
    padding-left: 8.333333%;
    padding-right: 8.333333%;
  }
  .sm\\:py-2\\/12 {
    padding-top: 16.666667%;
    padding-bottom: 16.666667%;
  }
  .sm\\:px-2\\/12 {
    padding-left: 16.666667%;
    padding-right: 16.666667%;
  }
  .sm\\:py-3\\/12 {
    padding-top: 25%;
    padding-bottom: 25%;
  }
  .sm\\:px-3\\/12 {
    padding-left: 25%;
    padding-right: 25%;
  }
  .sm\\:py-4\\/12 {
    padding-top: 33.333333%;
    padding-bottom: 33.333333%;
  }
  .sm\\:px-4\\/12 {
    padding-left: 33.333333%;
    padding-right: 33.333333%;
  }
  .sm\\:py-5\\/12 {
    padding-top: 41.666667%;
    padding-bottom: 41.666667%;
  }
  .sm\\:px-5\\/12 {
    padding-left: 41.666667%;
    padding-right: 41.666667%;
  }
  .sm\\:py-6\\/12 {
    padding-top: 50%;
    padding-bottom: 50%;
  }
  .sm\\:px-6\\/12 {
    padding-left: 50%;
    padding-right: 50%;
  }
  .sm\\:py-7\\/12 {
    padding-top: 58.333333%;
    padding-bottom: 58.333333%;
  }
  .sm\\:px-7\\/12 {
    padding-left: 58.333333%;
    padding-right: 58.333333%;
  }
  .sm\\:py-8\\/12 {
    padding-top: 66.666667%;
    padding-bottom: 66.666667%;
  }
  .sm\\:px-8\\/12 {
    padding-left: 66.666667%;
    padding-right: 66.666667%;
  }
  .sm\\:py-9\\/12 {
    padding-top: 75%;
    padding-bottom: 75%;
  }
  .sm\\:px-9\\/12 {
    padding-left: 75%;
    padding-right: 75%;
  }
  .sm\\:py-10\\/12 {
    padding-top: 83.333333%;
    padding-bottom: 83.333333%;
  }
  .sm\\:px-10\\/12 {
    padding-left: 83.333333%;
    padding-right: 83.333333%;
  }
  .sm\\:py-11\\/12 {
    padding-top: 91.666667%;
    padding-bottom: 91.666667%;
  }
  .sm\\:px-11\\/12 {
    padding-left: 91.666667%;
    padding-right: 91.666667%;
  }
  .sm\\:py-full {
    padding-top: 100%;
    padding-bottom: 100%;
  }
  .sm\\:px-full {
    padding-left: 100%;
    padding-right: 100%;
  }
  .sm\\:pt-0 {
    padding-top: 0;
  }
  .sm\\:pr-0 {
    padding-right: 0;
  }
  .sm\\:pb-0 {
    padding-bottom: 0;
  }
  .sm\\:pl-0 {
    padding-left: 0;
  }
  .sm\\:pt-1 {
    padding-top: 0.25rem;
  }
  .sm\\:pr-1 {
    padding-right: 0.25rem;
  }
  .sm\\:pb-1 {
    padding-bottom: 0.25rem;
  }
  .sm\\:pl-1 {
    padding-left: 0.25rem;
  }
  .sm\\:pt-2 {
    padding-top: 0.5rem;
  }
  .sm\\:pr-2 {
    padding-right: 0.5rem;
  }
  .sm\\:pb-2 {
    padding-bottom: 0.5rem;
  }
  .sm\\:pl-2 {
    padding-left: 0.5rem;
  }
  .sm\\:pt-3 {
    padding-top: 0.75rem;
  }
  .sm\\:pr-3 {
    padding-right: 0.75rem;
  }
  .sm\\:pb-3 {
    padding-bottom: 0.75rem;
  }
  .sm\\:pl-3 {
    padding-left: 0.75rem;
  }
  .sm\\:pt-4 {
    padding-top: 1rem;
  }
  .sm\\:pr-4 {
    padding-right: 1rem;
  }
  .sm\\:pb-4 {
    padding-bottom: 1rem;
  }
  .sm\\:pl-4 {
    padding-left: 1rem;
  }
  .sm\\:pt-5 {
    padding-top: 1.25rem;
  }
  .sm\\:pr-5 {
    padding-right: 1.25rem;
  }
  .sm\\:pb-5 {
    padding-bottom: 1.25rem;
  }
  .sm\\:pl-5 {
    padding-left: 1.25rem;
  }
  .sm\\:pt-6 {
    padding-top: 1.5rem;
  }
  .sm\\:pr-6 {
    padding-right: 1.5rem;
  }
  .sm\\:pb-6 {
    padding-bottom: 1.5rem;
  }
  .sm\\:pl-6 {
    padding-left: 1.5rem;
  }
  .sm\\:pt-7 {
    padding-top: 1.75rem;
  }
  .sm\\:pr-7 {
    padding-right: 1.75rem;
  }
  .sm\\:pb-7 {
    padding-bottom: 1.75rem;
  }
  .sm\\:pl-7 {
    padding-left: 1.75rem;
  }
  .sm\\:pt-8 {
    padding-top: 2rem;
  }
  .sm\\:pr-8 {
    padding-right: 2rem;
  }
  .sm\\:pb-8 {
    padding-bottom: 2rem;
  }
  .sm\\:pl-8 {
    padding-left: 2rem;
  }
  .sm\\:pt-9 {
    padding-top: 2.25rem;
  }
  .sm\\:pr-9 {
    padding-right: 2.25rem;
  }
  .sm\\:pb-9 {
    padding-bottom: 2.25rem;
  }
  .sm\\:pl-9 {
    padding-left: 2.25rem;
  }
  .sm\\:pt-10 {
    padding-top: 2.5rem;
  }
  .sm\\:pr-10 {
    padding-right: 2.5rem;
  }
  .sm\\:pb-10 {
    padding-bottom: 2.5rem;
  }
  .sm\\:pl-10 {
    padding-left: 2.5rem;
  }
  .sm\\:pt-11 {
    padding-top: 2.75rem;
  }
  .sm\\:pr-11 {
    padding-right: 2.75rem;
  }
  .sm\\:pb-11 {
    padding-bottom: 2.75rem;
  }
  .sm\\:pl-11 {
    padding-left: 2.75rem;
  }
  .sm\\:pt-12 {
    padding-top: 3rem;
  }
  .sm\\:pr-12 {
    padding-right: 3rem;
  }
  .sm\\:pb-12 {
    padding-bottom: 3rem;
  }
  .sm\\:pl-12 {
    padding-left: 3rem;
  }
  .sm\\:pt-13 {
    padding-top: 3.25rem;
  }
  .sm\\:pr-13 {
    padding-right: 3.25rem;
  }
  .sm\\:pb-13 {
    padding-bottom: 3.25rem;
  }
  .sm\\:pl-13 {
    padding-left: 3.25rem;
  }
  .sm\\:pt-14 {
    padding-top: 3.5rem;
  }
  .sm\\:pr-14 {
    padding-right: 3.5rem;
  }
  .sm\\:pb-14 {
    padding-bottom: 3.5rem;
  }
  .sm\\:pl-14 {
    padding-left: 3.5rem;
  }
  .sm\\:pt-15 {
    padding-top: 3.75rem;
  }
  .sm\\:pr-15 {
    padding-right: 3.75rem;
  }
  .sm\\:pb-15 {
    padding-bottom: 3.75rem;
  }
  .sm\\:pl-15 {
    padding-left: 3.75rem;
  }
  .sm\\:pt-16 {
    padding-top: 4rem;
  }
  .sm\\:pr-16 {
    padding-right: 4rem;
  }
  .sm\\:pb-16 {
    padding-bottom: 4rem;
  }
  .sm\\:pl-16 {
    padding-left: 4rem;
  }
  .sm\\:pt-20 {
    padding-top: 5rem;
  }
  .sm\\:pr-20 {
    padding-right: 5rem;
  }
  .sm\\:pb-20 {
    padding-bottom: 5rem;
  }
  .sm\\:pl-20 {
    padding-left: 5rem;
  }
  .sm\\:pt-24 {
    padding-top: 6rem;
  }
  .sm\\:pr-24 {
    padding-right: 6rem;
  }
  .sm\\:pb-24 {
    padding-bottom: 6rem;
  }
  .sm\\:pl-24 {
    padding-left: 6rem;
  }
  .sm\\:pt-28 {
    padding-top: 7rem;
  }
  .sm\\:pr-28 {
    padding-right: 7rem;
  }
  .sm\\:pb-28 {
    padding-bottom: 7rem;
  }
  .sm\\:pl-28 {
    padding-left: 7rem;
  }
  .sm\\:pt-32 {
    padding-top: 8rem;
  }
  .sm\\:pr-32 {
    padding-right: 8rem;
  }
  .sm\\:pb-32 {
    padding-bottom: 8rem;
  }
  .sm\\:pl-32 {
    padding-left: 8rem;
  }
  .sm\\:pt-36 {
    padding-top: 9rem;
  }
  .sm\\:pr-36 {
    padding-right: 9rem;
  }
  .sm\\:pb-36 {
    padding-bottom: 9rem;
  }
  .sm\\:pl-36 {
    padding-left: 9rem;
  }
  .sm\\:pt-40 {
    padding-top: 10rem;
  }
  .sm\\:pr-40 {
    padding-right: 10rem;
  }
  .sm\\:pb-40 {
    padding-bottom: 10rem;
  }
  .sm\\:pl-40 {
    padding-left: 10rem;
  }
  .sm\\:pt-44 {
    padding-top: 11rem;
  }
  .sm\\:pr-44 {
    padding-right: 11rem;
  }
  .sm\\:pb-44 {
    padding-bottom: 11rem;
  }
  .sm\\:pl-44 {
    padding-left: 11rem;
  }
  .sm\\:pt-48 {
    padding-top: 12rem;
  }
  .sm\\:pr-48 {
    padding-right: 12rem;
  }
  .sm\\:pb-48 {
    padding-bottom: 12rem;
  }
  .sm\\:pl-48 {
    padding-left: 12rem;
  }
  .sm\\:pt-52 {
    padding-top: 13rem;
  }
  .sm\\:pr-52 {
    padding-right: 13rem;
  }
  .sm\\:pb-52 {
    padding-bottom: 13rem;
  }
  .sm\\:pl-52 {
    padding-left: 13rem;
  }
  .sm\\:pt-56 {
    padding-top: 14rem;
  }
  .sm\\:pr-56 {
    padding-right: 14rem;
  }
  .sm\\:pb-56 {
    padding-bottom: 14rem;
  }
  .sm\\:pl-56 {
    padding-left: 14rem;
  }
  .sm\\:pt-60 {
    padding-top: 15rem;
  }
  .sm\\:pr-60 {
    padding-right: 15rem;
  }
  .sm\\:pb-60 {
    padding-bottom: 15rem;
  }
  .sm\\:pl-60 {
    padding-left: 15rem;
  }
  .sm\\:pt-64 {
    padding-top: 16rem;
  }
  .sm\\:pr-64 {
    padding-right: 16rem;
  }
  .sm\\:pb-64 {
    padding-bottom: 16rem;
  }
  .sm\\:pl-64 {
    padding-left: 16rem;
  }
  .sm\\:pt-72 {
    padding-top: 18rem;
  }
  .sm\\:pr-72 {
    padding-right: 18rem;
  }
  .sm\\:pb-72 {
    padding-bottom: 18rem;
  }
  .sm\\:pl-72 {
    padding-left: 18rem;
  }
  .sm\\:pt-80 {
    padding-top: 20rem;
  }
  .sm\\:pr-80 {
    padding-right: 20rem;
  }
  .sm\\:pb-80 {
    padding-bottom: 20rem;
  }
  .sm\\:pl-80 {
    padding-left: 20rem;
  }
  .sm\\:pt-96 {
    padding-top: 24rem;
  }
  .sm\\:pr-96 {
    padding-right: 24rem;
  }
  .sm\\:pb-96 {
    padding-bottom: 24rem;
  }
  .sm\\:pl-96 {
    padding-left: 24rem;
  }
  .sm\\:pt-px {
    padding-top: 1px;
  }
  .sm\\:pr-px {
    padding-right: 1px;
  }
  .sm\\:pb-px {
    padding-bottom: 1px;
  }
  .sm\\:pl-px {
    padding-left: 1px;
  }
  .sm\\:pt-0\\.5 {
    padding-top: 0.125rem;
  }
  .sm\\:pr-0\\.5 {
    padding-right: 0.125rem;
  }
  .sm\\:pb-0\\.5 {
    padding-bottom: 0.125rem;
  }
  .sm\\:pl-0\\.5 {
    padding-left: 0.125rem;
  }
  .sm\\:pt-1\\.5 {
    padding-top: 0.375rem;
  }
  .sm\\:pr-1\\.5 {
    padding-right: 0.375rem;
  }
  .sm\\:pb-1\\.5 {
    padding-bottom: 0.375rem;
  }
  .sm\\:pl-1\\.5 {
    padding-left: 0.375rem;
  }
  .sm\\:pt-2\\.5 {
    padding-top: 0.625rem;
  }
  .sm\\:pr-2\\.5 {
    padding-right: 0.625rem;
  }
  .sm\\:pb-2\\.5 {
    padding-bottom: 0.625rem;
  }
  .sm\\:pl-2\\.5 {
    padding-left: 0.625rem;
  }
  .sm\\:pt-3\\.5 {
    padding-top: 0.875rem;
  }
  .sm\\:pr-3\\.5 {
    padding-right: 0.875rem;
  }
  .sm\\:pb-3\\.5 {
    padding-bottom: 0.875rem;
  }
  .sm\\:pl-3\\.5 {
    padding-left: 0.875rem;
  }
  .sm\\:pt-1\\/2 {
    padding-top: 50%;
  }
  .sm\\:pr-1\\/2 {
    padding-right: 50%;
  }
  .sm\\:pb-1\\/2 {
    padding-bottom: 50%;
  }
  .sm\\:pl-1\\/2 {
    padding-left: 50%;
  }
  .sm\\:pt-1\\/3 {
    padding-top: 33.333333%;
  }
  .sm\\:pr-1\\/3 {
    padding-right: 33.333333%;
  }
  .sm\\:pb-1\\/3 {
    padding-bottom: 33.333333%;
  }
  .sm\\:pl-1\\/3 {
    padding-left: 33.333333%;
  }
  .sm\\:pt-2\\/3 {
    padding-top: 66.666667%;
  }
  .sm\\:pr-2\\/3 {
    padding-right: 66.666667%;
  }
  .sm\\:pb-2\\/3 {
    padding-bottom: 66.666667%;
  }
  .sm\\:pl-2\\/3 {
    padding-left: 66.666667%;
  }
  .sm\\:pt-1\\/4 {
    padding-top: 25%;
  }
  .sm\\:pr-1\\/4 {
    padding-right: 25%;
  }
  .sm\\:pb-1\\/4 {
    padding-bottom: 25%;
  }
  .sm\\:pl-1\\/4 {
    padding-left: 25%;
  }
  .sm\\:pt-2\\/4 {
    padding-top: 50%;
  }
  .sm\\:pr-2\\/4 {
    padding-right: 50%;
  }
  .sm\\:pb-2\\/4 {
    padding-bottom: 50%;
  }
  .sm\\:pl-2\\/4 {
    padding-left: 50%;
  }
  .sm\\:pt-3\\/4 {
    padding-top: 75%;
  }
  .sm\\:pr-3\\/4 {
    padding-right: 75%;
  }
  .sm\\:pb-3\\/4 {
    padding-bottom: 75%;
  }
  .sm\\:pl-3\\/4 {
    padding-left: 75%;
  }
  .sm\\:pt-1\\/5 {
    padding-top: 20%;
  }
  .sm\\:pr-1\\/5 {
    padding-right: 20%;
  }
  .sm\\:pb-1\\/5 {
    padding-bottom: 20%;
  }
  .sm\\:pl-1\\/5 {
    padding-left: 20%;
  }
  .sm\\:pt-2\\/5 {
    padding-top: 40%;
  }
  .sm\\:pr-2\\/5 {
    padding-right: 40%;
  }
  .sm\\:pb-2\\/5 {
    padding-bottom: 40%;
  }
  .sm\\:pl-2\\/5 {
    padding-left: 40%;
  }
  .sm\\:pt-3\\/5 {
    padding-top: 60%;
  }
  .sm\\:pr-3\\/5 {
    padding-right: 60%;
  }
  .sm\\:pb-3\\/5 {
    padding-bottom: 60%;
  }
  .sm\\:pl-3\\/5 {
    padding-left: 60%;
  }
  .sm\\:pt-4\\/5 {
    padding-top: 80%;
  }
  .sm\\:pr-4\\/5 {
    padding-right: 80%;
  }
  .sm\\:pb-4\\/5 {
    padding-bottom: 80%;
  }
  .sm\\:pl-4\\/5 {
    padding-left: 80%;
  }
  .sm\\:pt-1\\/6 {
    padding-top: 16.666667%;
  }
  .sm\\:pr-1\\/6 {
    padding-right: 16.666667%;
  }
  .sm\\:pb-1\\/6 {
    padding-bottom: 16.666667%;
  }
  .sm\\:pl-1\\/6 {
    padding-left: 16.666667%;
  }
  .sm\\:pt-2\\/6 {
    padding-top: 33.333333%;
  }
  .sm\\:pr-2\\/6 {
    padding-right: 33.333333%;
  }
  .sm\\:pb-2\\/6 {
    padding-bottom: 33.333333%;
  }
  .sm\\:pl-2\\/6 {
    padding-left: 33.333333%;
  }
  .sm\\:pt-3\\/6 {
    padding-top: 50%;
  }
  .sm\\:pr-3\\/6 {
    padding-right: 50%;
  }
  .sm\\:pb-3\\/6 {
    padding-bottom: 50%;
  }
  .sm\\:pl-3\\/6 {
    padding-left: 50%;
  }
  .sm\\:pt-4\\/6 {
    padding-top: 66.666667%;
  }
  .sm\\:pr-4\\/6 {
    padding-right: 66.666667%;
  }
  .sm\\:pb-4\\/6 {
    padding-bottom: 66.666667%;
  }
  .sm\\:pl-4\\/6 {
    padding-left: 66.666667%;
  }
  .sm\\:pt-5\\/6 {
    padding-top: 83.333333%;
  }
  .sm\\:pr-5\\/6 {
    padding-right: 83.333333%;
  }
  .sm\\:pb-5\\/6 {
    padding-bottom: 83.333333%;
  }
  .sm\\:pl-5\\/6 {
    padding-left: 83.333333%;
  }
  .sm\\:pt-1\\/12 {
    padding-top: 8.333333%;
  }
  .sm\\:pr-1\\/12 {
    padding-right: 8.333333%;
  }
  .sm\\:pb-1\\/12 {
    padding-bottom: 8.333333%;
  }
  .sm\\:pl-1\\/12 {
    padding-left: 8.333333%;
  }
  .sm\\:pt-2\\/12 {
    padding-top: 16.666667%;
  }
  .sm\\:pr-2\\/12 {
    padding-right: 16.666667%;
  }
  .sm\\:pb-2\\/12 {
    padding-bottom: 16.666667%;
  }
  .sm\\:pl-2\\/12 {
    padding-left: 16.666667%;
  }
  .sm\\:pt-3\\/12 {
    padding-top: 25%;
  }
  .sm\\:pr-3\\/12 {
    padding-right: 25%;
  }
  .sm\\:pb-3\\/12 {
    padding-bottom: 25%;
  }
  .sm\\:pl-3\\/12 {
    padding-left: 25%;
  }
  .sm\\:pt-4\\/12 {
    padding-top: 33.333333%;
  }
  .sm\\:pr-4\\/12 {
    padding-right: 33.333333%;
  }
  .sm\\:pb-4\\/12 {
    padding-bottom: 33.333333%;
  }
  .sm\\:pl-4\\/12 {
    padding-left: 33.333333%;
  }
  .sm\\:pt-5\\/12 {
    padding-top: 41.666667%;
  }
  .sm\\:pr-5\\/12 {
    padding-right: 41.666667%;
  }
  .sm\\:pb-5\\/12 {
    padding-bottom: 41.666667%;
  }
  .sm\\:pl-5\\/12 {
    padding-left: 41.666667%;
  }
  .sm\\:pt-6\\/12 {
    padding-top: 50%;
  }
  .sm\\:pr-6\\/12 {
    padding-right: 50%;
  }
  .sm\\:pb-6\\/12 {
    padding-bottom: 50%;
  }
  .sm\\:pl-6\\/12 {
    padding-left: 50%;
  }
  .sm\\:pt-7\\/12 {
    padding-top: 58.333333%;
  }
  .sm\\:pr-7\\/12 {
    padding-right: 58.333333%;
  }
  .sm\\:pb-7\\/12 {
    padding-bottom: 58.333333%;
  }
  .sm\\:pl-7\\/12 {
    padding-left: 58.333333%;
  }
  .sm\\:pt-8\\/12 {
    padding-top: 66.666667%;
  }
  .sm\\:pr-8\\/12 {
    padding-right: 66.666667%;
  }
  .sm\\:pb-8\\/12 {
    padding-bottom: 66.666667%;
  }
  .sm\\:pl-8\\/12 {
    padding-left: 66.666667%;
  }
  .sm\\:pt-9\\/12 {
    padding-top: 75%;
  }
  .sm\\:pr-9\\/12 {
    padding-right: 75%;
  }
  .sm\\:pb-9\\/12 {
    padding-bottom: 75%;
  }
  .sm\\:pl-9\\/12 {
    padding-left: 75%;
  }
  .sm\\:pt-10\\/12 {
    padding-top: 83.333333%;
  }
  .sm\\:pr-10\\/12 {
    padding-right: 83.333333%;
  }
  .sm\\:pb-10\\/12 {
    padding-bottom: 83.333333%;
  }
  .sm\\:pl-10\\/12 {
    padding-left: 83.333333%;
  }
  .sm\\:pt-11\\/12 {
    padding-top: 91.666667%;
  }
  .sm\\:pr-11\\/12 {
    padding-right: 91.666667%;
  }
  .sm\\:pb-11\\/12 {
    padding-bottom: 91.666667%;
  }
  .sm\\:pl-11\\/12 {
    padding-left: 91.666667%;
  }
  .sm\\:pt-full {
    padding-top: 100%;
  }
  .sm\\:pr-full {
    padding-right: 100%;
  }
  .sm\\:pb-full {
    padding-bottom: 100%;
  }
  .sm\\:pl-full {
    padding-left: 100%;
  }
  .sm\\:placeholder-current::placeholder {
    color: currentColor;
  }
  .sm\\:placeholder-transparent::placeholder {
    color: transparent;
  }
  .sm\\:placeholder-white::placeholder {
    --placeholder-opacity: 1;
    color: #ffffff;
    color: rgba(255, 255, 255, var(--placeholder-opacity));
  }
  .sm\\:placeholder-black::placeholder {
    --placeholder-opacity: 1;
    color: #000000;
    color: rgba(0, 0, 0, var(--placeholder-opacity));
  }
  .sm\\:placeholder-gray-50::placeholder {
    --placeholder-opacity: 1;
    color: #f9fafb;
    color: rgba(249, 250, 251, var(--placeholder-opacity));
  }
  .sm\\:placeholder-gray-100::placeholder {
    --placeholder-opacity: 1;
    color: #f4f5f7;
    color: rgba(244, 245, 247, var(--placeholder-opacity));
  }
  .sm\\:placeholder-gray-200::placeholder {
    --placeholder-opacity: 1;
    color: #e5e7eb;
    color: rgba(229, 231, 235, var(--placeholder-opacity));
  }
  .sm\\:placeholder-gray-300::placeholder {
    --placeholder-opacity: 1;
    color: #d2d6dc;
    color: rgba(210, 214, 220, var(--placeholder-opacity));
  }
  .sm\\:placeholder-gray-400::placeholder {
    --placeholder-opacity: 1;
    color: #9fa6b2;
    color: rgba(159, 166, 178, var(--placeholder-opacity));
  }
  .sm\\:placeholder-gray-500::placeholder {
    --placeholder-opacity: 1;
    color: #6b7280;
    color: rgba(107, 114, 128, var(--placeholder-opacity));
  }
  .sm\\:placeholder-gray-600::placeholder {
    --placeholder-opacity: 1;
    color: #4b5563;
    color: rgba(75, 85, 99, var(--placeholder-opacity));
  }
  .sm\\:placeholder-gray-700::placeholder {
    --placeholder-opacity: 1;
    color: #374151;
    color: rgba(55, 65, 81, var(--placeholder-opacity));
  }
  .sm\\:placeholder-gray-800::placeholder {
    --placeholder-opacity: 1;
    color: #252f3f;
    color: rgba(37, 47, 63, var(--placeholder-opacity));
  }
  .sm\\:placeholder-gray-900::placeholder {
    --placeholder-opacity: 1;
    color: #161e2e;
    color: rgba(22, 30, 46, var(--placeholder-opacity));
  }
  .sm\\:placeholder-red-50::placeholder {
    --placeholder-opacity: 1;
    color: #fdf2f2;
    color: rgba(253, 242, 242, var(--placeholder-opacity));
  }
  .sm\\:placeholder-red-100::placeholder {
    --placeholder-opacity: 1;
    color: #fde8e8;
    color: rgba(253, 232, 232, var(--placeholder-opacity));
  }
  .sm\\:placeholder-red-200::placeholder {
    --placeholder-opacity: 1;
    color: #fbd5d5;
    color: rgba(251, 213, 213, var(--placeholder-opacity));
  }
  .sm\\:placeholder-red-300::placeholder {
    --placeholder-opacity: 1;
    color: #f8b4b4;
    color: rgba(248, 180, 180, var(--placeholder-opacity));
  }
  .sm\\:placeholder-red-400::placeholder {
    --placeholder-opacity: 1;
    color: #f98080;
    color: rgba(249, 128, 128, var(--placeholder-opacity));
  }
  .sm\\:placeholder-red-500::placeholder {
    --placeholder-opacity: 1;
    color: #f05252;
    color: rgba(240, 82, 82, var(--placeholder-opacity));
  }
  .sm\\:placeholder-red-600::placeholder {
    --placeholder-opacity: 1;
    color: #e02424;
    color: rgba(224, 36, 36, var(--placeholder-opacity));
  }
  .sm\\:placeholder-red-700::placeholder {
    --placeholder-opacity: 1;
    color: #c81e1e;
    color: rgba(200, 30, 30, var(--placeholder-opacity));
  }
  .sm\\:placeholder-red-800::placeholder {
    --placeholder-opacity: 1;
    color: #9b1c1c;
    color: rgba(155, 28, 28, var(--placeholder-opacity));
  }
  .sm\\:placeholder-red-900::placeholder {
    --placeholder-opacity: 1;
    color: #771d1d;
    color: rgba(119, 29, 29, var(--placeholder-opacity));
  }
  .sm\\:placeholder-orange-50::placeholder {
    --placeholder-opacity: 1;
    color: #fff8f1;
    color: rgba(255, 248, 241, var(--placeholder-opacity));
  }
  .sm\\:placeholder-orange-100::placeholder {
    --placeholder-opacity: 1;
    color: #feecdc;
    color: rgba(254, 236, 220, var(--placeholder-opacity));
  }
  .sm\\:placeholder-orange-200::placeholder {
    --placeholder-opacity: 1;
    color: #fcd9bd;
    color: rgba(252, 217, 189, var(--placeholder-opacity));
  }
  .sm\\:placeholder-orange-300::placeholder {
    --placeholder-opacity: 1;
    color: #fdba8c;
    color: rgba(253, 186, 140, var(--placeholder-opacity));
  }
  .sm\\:placeholder-orange-400::placeholder {
    --placeholder-opacity: 1;
    color: #ff8a4c;
    color: rgba(255, 138, 76, var(--placeholder-opacity));
  }
  .sm\\:placeholder-orange-500::placeholder {
    --placeholder-opacity: 1;
    color: #ff5a1f;
    color: rgba(255, 90, 31, var(--placeholder-opacity));
  }
  .sm\\:placeholder-orange-600::placeholder {
    --placeholder-opacity: 1;
    color: #d03801;
    color: rgba(208, 56, 1, var(--placeholder-opacity));
  }
  .sm\\:placeholder-orange-700::placeholder {
    --placeholder-opacity: 1;
    color: #b43403;
    color: rgba(180, 52, 3, var(--placeholder-opacity));
  }
  .sm\\:placeholder-orange-800::placeholder {
    --placeholder-opacity: 1;
    color: #8a2c0d;
    color: rgba(138, 44, 13, var(--placeholder-opacity));
  }
  .sm\\:placeholder-orange-900::placeholder {
    --placeholder-opacity: 1;
    color: #73230d;
    color: rgba(115, 35, 13, var(--placeholder-opacity));
  }
  .sm\\:placeholder-yellow-50::placeholder {
    --placeholder-opacity: 1;
    color: #fdfdea;
    color: rgba(253, 253, 234, var(--placeholder-opacity));
  }
  .sm\\:placeholder-yellow-100::placeholder {
    --placeholder-opacity: 1;
    color: #fdf6b2;
    color: rgba(253, 246, 178, var(--placeholder-opacity));
  }
  .sm\\:placeholder-yellow-200::placeholder {
    --placeholder-opacity: 1;
    color: #fce96a;
    color: rgba(252, 233, 106, var(--placeholder-opacity));
  }
  .sm\\:placeholder-yellow-300::placeholder {
    --placeholder-opacity: 1;
    color: #faca15;
    color: rgba(250, 202, 21, var(--placeholder-opacity));
  }
  .sm\\:placeholder-yellow-400::placeholder {
    --placeholder-opacity: 1;
    color: #e3a008;
    color: rgba(227, 160, 8, var(--placeholder-opacity));
  }
  .sm\\:placeholder-yellow-500::placeholder {
    --placeholder-opacity: 1;
    color: #c27803;
    color: rgba(194, 120, 3, var(--placeholder-opacity));
  }
  .sm\\:placeholder-yellow-600::placeholder {
    --placeholder-opacity: 1;
    color: #9f580a;
    color: rgba(159, 88, 10, var(--placeholder-opacity));
  }
  .sm\\:placeholder-yellow-700::placeholder {
    --placeholder-opacity: 1;
    color: #8e4b10;
    color: rgba(142, 75, 16, var(--placeholder-opacity));
  }
  .sm\\:placeholder-yellow-800::placeholder {
    --placeholder-opacity: 1;
    color: #723b13;
    color: rgba(114, 59, 19, var(--placeholder-opacity));
  }
  .sm\\:placeholder-yellow-900::placeholder {
    --placeholder-opacity: 1;
    color: #633112;
    color: rgba(99, 49, 18, var(--placeholder-opacity));
  }
  .sm\\:placeholder-green-50::placeholder {
    --placeholder-opacity: 1;
    color: #f3faf7;
    color: rgba(243, 250, 247, var(--placeholder-opacity));
  }
  .sm\\:placeholder-green-100::placeholder {
    --placeholder-opacity: 1;
    color: #def7ec;
    color: rgba(222, 247, 236, var(--placeholder-opacity));
  }
  .sm\\:placeholder-green-200::placeholder {
    --placeholder-opacity: 1;
    color: #bcf0da;
    color: rgba(188, 240, 218, var(--placeholder-opacity));
  }
  .sm\\:placeholder-green-300::placeholder {
    --placeholder-opacity: 1;
    color: #84e1bc;
    color: rgba(132, 225, 188, var(--placeholder-opacity));
  }
  .sm\\:placeholder-green-400::placeholder {
    --placeholder-opacity: 1;
    color: #31c48d;
    color: rgba(49, 196, 141, var(--placeholder-opacity));
  }
  .sm\\:placeholder-green-500::placeholder {
    --placeholder-opacity: 1;
    color: #0e9f6e;
    color: rgba(14, 159, 110, var(--placeholder-opacity));
  }
  .sm\\:placeholder-green-600::placeholder {
    --placeholder-opacity: 1;
    color: #057a55;
    color: rgba(5, 122, 85, var(--placeholder-opacity));
  }
  .sm\\:placeholder-green-700::placeholder {
    --placeholder-opacity: 1;
    color: #046c4e;
    color: rgba(4, 108, 78, var(--placeholder-opacity));
  }
  .sm\\:placeholder-green-800::placeholder {
    --placeholder-opacity: 1;
    color: #03543f;
    color: rgba(3, 84, 63, var(--placeholder-opacity));
  }
  .sm\\:placeholder-green-900::placeholder {
    --placeholder-opacity: 1;
    color: #014737;
    color: rgba(1, 71, 55, var(--placeholder-opacity));
  }
  .sm\\:placeholder-teal-50::placeholder {
    --placeholder-opacity: 1;
    color: #edfafa;
    color: rgba(237, 250, 250, var(--placeholder-opacity));
  }
  .sm\\:placeholder-teal-100::placeholder {
    --placeholder-opacity: 1;
    color: #d5f5f6;
    color: rgba(213, 245, 246, var(--placeholder-opacity));
  }
  .sm\\:placeholder-teal-200::placeholder {
    --placeholder-opacity: 1;
    color: #afecef;
    color: rgba(175, 236, 239, var(--placeholder-opacity));
  }
  .sm\\:placeholder-teal-300::placeholder {
    --placeholder-opacity: 1;
    color: #7edce2;
    color: rgba(126, 220, 226, var(--placeholder-opacity));
  }
  .sm\\:placeholder-teal-400::placeholder {
    --placeholder-opacity: 1;
    color: #16bdca;
    color: rgba(22, 189, 202, var(--placeholder-opacity));
  }
  .sm\\:placeholder-teal-500::placeholder {
    --placeholder-opacity: 1;
    color: #0694a2;
    color: rgba(6, 148, 162, var(--placeholder-opacity));
  }
  .sm\\:placeholder-teal-600::placeholder {
    --placeholder-opacity: 1;
    color: #047481;
    color: rgba(4, 116, 129, var(--placeholder-opacity));
  }
  .sm\\:placeholder-teal-700::placeholder {
    --placeholder-opacity: 1;
    color: #036672;
    color: rgba(3, 102, 114, var(--placeholder-opacity));
  }
  .sm\\:placeholder-teal-800::placeholder {
    --placeholder-opacity: 1;
    color: #05505c;
    color: rgba(5, 80, 92, var(--placeholder-opacity));
  }
  .sm\\:placeholder-teal-900::placeholder {
    --placeholder-opacity: 1;
    color: #014451;
    color: rgba(1, 68, 81, var(--placeholder-opacity));
  }
  .sm\\:placeholder-blue-50::placeholder {
    --placeholder-opacity: 1;
    color: #ebf5ff;
    color: rgba(235, 245, 255, var(--placeholder-opacity));
  }
  .sm\\:placeholder-blue-100::placeholder {
    --placeholder-opacity: 1;
    color: #e1effe;
    color: rgba(225, 239, 254, var(--placeholder-opacity));
  }
  .sm\\:placeholder-blue-200::placeholder {
    --placeholder-opacity: 1;
    color: #c3ddfd;
    color: rgba(195, 221, 253, var(--placeholder-opacity));
  }
  .sm\\:placeholder-blue-300::placeholder {
    --placeholder-opacity: 1;
    color: #a4cafe;
    color: rgba(164, 202, 254, var(--placeholder-opacity));
  }
  .sm\\:placeholder-blue-400::placeholder {
    --placeholder-opacity: 1;
    color: #76a9fa;
    color: rgba(118, 169, 250, var(--placeholder-opacity));
  }
  .sm\\:placeholder-blue-500::placeholder {
    --placeholder-opacity: 1;
    color: #3f83f8;
    color: rgba(63, 131, 248, var(--placeholder-opacity));
  }
  .sm\\:placeholder-blue-600::placeholder {
    --placeholder-opacity: 1;
    color: #1c64f2;
    color: rgba(28, 100, 242, var(--placeholder-opacity));
  }
  .sm\\:placeholder-blue-700::placeholder {
    --placeholder-opacity: 1;
    color: #1a56db;
    color: rgba(26, 86, 219, var(--placeholder-opacity));
  }
  .sm\\:placeholder-blue-800::placeholder {
    --placeholder-opacity: 1;
    color: #1e429f;
    color: rgba(30, 66, 159, var(--placeholder-opacity));
  }
  .sm\\:placeholder-blue-900::placeholder {
    --placeholder-opacity: 1;
    color: #233876;
    color: rgba(35, 56, 118, var(--placeholder-opacity));
  }
  .sm\\:placeholder-indigo-50::placeholder {
    --placeholder-opacity: 1;
    color: #f0f5ff;
    color: rgba(240, 245, 255, var(--placeholder-opacity));
  }
  .sm\\:placeholder-indigo-100::placeholder {
    --placeholder-opacity: 1;
    color: #e5edff;
    color: rgba(229, 237, 255, var(--placeholder-opacity));
  }
  .sm\\:placeholder-indigo-200::placeholder {
    --placeholder-opacity: 1;
    color: #cddbfe;
    color: rgba(205, 219, 254, var(--placeholder-opacity));
  }
  .sm\\:placeholder-indigo-300::placeholder {
    --placeholder-opacity: 1;
    color: #b4c6fc;
    color: rgba(180, 198, 252, var(--placeholder-opacity));
  }
  .sm\\:placeholder-indigo-400::placeholder {
    --placeholder-opacity: 1;
    color: #8da2fb;
    color: rgba(141, 162, 251, var(--placeholder-opacity));
  }
  .sm\\:placeholder-indigo-500::placeholder {
    --placeholder-opacity: 1;
    color: #6875f5;
    color: rgba(104, 117, 245, var(--placeholder-opacity));
  }
  .sm\\:placeholder-indigo-600::placeholder {
    --placeholder-opacity: 1;
    color: #5850ec;
    color: rgba(88, 80, 236, var(--placeholder-opacity));
  }
  .sm\\:placeholder-indigo-700::placeholder {
    --placeholder-opacity: 1;
    color: #5145cd;
    color: rgba(81, 69, 205, var(--placeholder-opacity));
  }
  .sm\\:placeholder-indigo-800::placeholder {
    --placeholder-opacity: 1;
    color: #42389d;
    color: rgba(66, 56, 157, var(--placeholder-opacity));
  }
  .sm\\:placeholder-indigo-900::placeholder {
    --placeholder-opacity: 1;
    color: #362f78;
    color: rgba(54, 47, 120, var(--placeholder-opacity));
  }
  .sm\\:placeholder-purple-50::placeholder {
    --placeholder-opacity: 1;
    color: #f6f5ff;
    color: rgba(246, 245, 255, var(--placeholder-opacity));
  }
  .sm\\:placeholder-purple-100::placeholder {
    --placeholder-opacity: 1;
    color: #edebfe;
    color: rgba(237, 235, 254, var(--placeholder-opacity));
  }
  .sm\\:placeholder-purple-200::placeholder {
    --placeholder-opacity: 1;
    color: #dcd7fe;
    color: rgba(220, 215, 254, var(--placeholder-opacity));
  }
  .sm\\:placeholder-purple-300::placeholder {
    --placeholder-opacity: 1;
    color: #cabffd;
    color: rgba(202, 191, 253, var(--placeholder-opacity));
  }
  .sm\\:placeholder-purple-400::placeholder {
    --placeholder-opacity: 1;
    color: #ac94fa;
    color: rgba(172, 148, 250, var(--placeholder-opacity));
  }
  .sm\\:placeholder-purple-500::placeholder {
    --placeholder-opacity: 1;
    color: #9061f9;
    color: rgba(144, 97, 249, var(--placeholder-opacity));
  }
  .sm\\:placeholder-purple-600::placeholder {
    --placeholder-opacity: 1;
    color: #7e3af2;
    color: rgba(126, 58, 242, var(--placeholder-opacity));
  }
  .sm\\:placeholder-purple-700::placeholder {
    --placeholder-opacity: 1;
    color: #6c2bd9;
    color: rgba(108, 43, 217, var(--placeholder-opacity));
  }
  .sm\\:placeholder-purple-800::placeholder {
    --placeholder-opacity: 1;
    color: #5521b5;
    color: rgba(85, 33, 181, var(--placeholder-opacity));
  }
  .sm\\:placeholder-purple-900::placeholder {
    --placeholder-opacity: 1;
    color: #4a1d96;
    color: rgba(74, 29, 150, var(--placeholder-opacity));
  }
  .sm\\:placeholder-pink-50::placeholder {
    --placeholder-opacity: 1;
    color: #fdf2f8;
    color: rgba(253, 242, 248, var(--placeholder-opacity));
  }
  .sm\\:placeholder-pink-100::placeholder {
    --placeholder-opacity: 1;
    color: #fce8f3;
    color: rgba(252, 232, 243, var(--placeholder-opacity));
  }
  .sm\\:placeholder-pink-200::placeholder {
    --placeholder-opacity: 1;
    color: #fad1e8;
    color: rgba(250, 209, 232, var(--placeholder-opacity));
  }
  .sm\\:placeholder-pink-300::placeholder {
    --placeholder-opacity: 1;
    color: #f8b4d9;
    color: rgba(248, 180, 217, var(--placeholder-opacity));
  }
  .sm\\:placeholder-pink-400::placeholder {
    --placeholder-opacity: 1;
    color: #f17eb8;
    color: rgba(241, 126, 184, var(--placeholder-opacity));
  }
  .sm\\:placeholder-pink-500::placeholder {
    --placeholder-opacity: 1;
    color: #e74694;
    color: rgba(231, 70, 148, var(--placeholder-opacity));
  }
  .sm\\:placeholder-pink-600::placeholder {
    --placeholder-opacity: 1;
    color: #d61f69;
    color: rgba(214, 31, 105, var(--placeholder-opacity));
  }
  .sm\\:placeholder-pink-700::placeholder {
    --placeholder-opacity: 1;
    color: #bf125d;
    color: rgba(191, 18, 93, var(--placeholder-opacity));
  }
  .sm\\:placeholder-pink-800::placeholder {
    --placeholder-opacity: 1;
    color: #99154b;
    color: rgba(153, 21, 75, var(--placeholder-opacity));
  }
  .sm\\:placeholder-pink-900::placeholder {
    --placeholder-opacity: 1;
    color: #751a3d;
    color: rgba(117, 26, 61, var(--placeholder-opacity));
  }
  .sm\\:placeholder-cool-gray-50::placeholder {
    --placeholder-opacity: 1;
    color: #f8fafc;
    color: rgba(248, 250, 252, var(--placeholder-opacity));
  }
  .sm\\:placeholder-cool-gray-100::placeholder {
    --placeholder-opacity: 1;
    color: #f1f5f9;
    color: rgba(241, 245, 249, var(--placeholder-opacity));
  }
  .sm\\:placeholder-cool-gray-200::placeholder {
    --placeholder-opacity: 1;
    color: #e2e8f0;
    color: rgba(226, 232, 240, var(--placeholder-opacity));
  }
  .sm\\:placeholder-cool-gray-300::placeholder {
    --placeholder-opacity: 1;
    color: #cfd8e3;
    color: rgba(207, 216, 227, var(--placeholder-opacity));
  }
  .sm\\:placeholder-cool-gray-400::placeholder {
    --placeholder-opacity: 1;
    color: #97a6ba;
    color: rgba(151, 166, 186, var(--placeholder-opacity));
  }
  .sm\\:placeholder-cool-gray-500::placeholder {
    --placeholder-opacity: 1;
    color: #64748b;
    color: rgba(100, 116, 139, var(--placeholder-opacity));
  }
  .sm\\:placeholder-cool-gray-600::placeholder {
    --placeholder-opacity: 1;
    color: #475569;
    color: rgba(71, 85, 105, var(--placeholder-opacity));
  }
  .sm\\:placeholder-cool-gray-700::placeholder {
    --placeholder-opacity: 1;
    color: #364152;
    color: rgba(54, 65, 82, var(--placeholder-opacity));
  }
  .sm\\:placeholder-cool-gray-800::placeholder {
    --placeholder-opacity: 1;
    color: #27303f;
    color: rgba(39, 48, 63, var(--placeholder-opacity));
  }
  .sm\\:placeholder-cool-gray-900::placeholder {
    --placeholder-opacity: 1;
    color: #1a202e;
    color: rgba(26, 32, 46, var(--placeholder-opacity));
  }
  .sm\\:focus\\:placeholder-current:focus::placeholder {
    color: currentColor;
  }
  .sm\\:focus\\:placeholder-transparent:focus::placeholder {
    color: transparent;
  }
  .sm\\:focus\\:placeholder-white:focus::placeholder {
    --placeholder-opacity: 1;
    color: #ffffff;
    color: rgba(255, 255, 255, var(--placeholder-opacity));
  }
  .sm\\:focus\\:placeholder-black:focus::placeholder {
    --placeholder-opacity: 1;
    color: #000000;
    color: rgba(0, 0, 0, var(--placeholder-opacity));
  }
  .sm\\:focus\\:placeholder-gray-50:focus::placeholder {
    --placeholder-opacity: 1;
    color: #f9fafb;
    color: rgba(249, 250, 251, var(--placeholder-opacity));
  }
  .sm\\:focus\\:placeholder-gray-100:focus::placeholder {
    --placeholder-opacity: 1;
    color: #f4f5f7;
    color: rgba(244, 245, 247, var(--placeholder-opacity));
  }
  .sm\\:focus\\:placeholder-gray-200:focus::placeholder {
    --placeholder-opacity: 1;
    color: #e5e7eb;
    color: rgba(229, 231, 235, var(--placeholder-opacity));
  }
  .sm\\:focus\\:placeholder-gray-300:focus::placeholder {
    --placeholder-opacity: 1;
    color: #d2d6dc;
    color: rgba(210, 214, 220, var(--placeholder-opacity));
  }
  .sm\\:focus\\:placeholder-gray-400:focus::placeholder {
    --placeholder-opacity: 1;
    color: #9fa6b2;
    color: rgba(159, 166, 178, var(--placeholder-opacity));
  }
  .sm\\:focus\\:placeholder-gray-500:focus::placeholder {
    --placeholder-opacity: 1;
    color: #6b7280;
    color: rgba(107, 114, 128, var(--placeholder-opacity));
  }
  .sm\\:focus\\:placeholder-gray-600:focus::placeholder {
    --placeholder-opacity: 1;
    color: #4b5563;
    color: rgba(75, 85, 99, var(--placeholder-opacity));
  }
  .sm\\:focus\\:placeholder-gray-700:focus::placeholder {
    --placeholder-opacity: 1;
    color: #374151;
    color: rgba(55, 65, 81, var(--placeholder-opacity));
  }
  .sm\\:focus\\:placeholder-gray-800:focus::placeholder {
    --placeholder-opacity: 1;
    color: #252f3f;
    color: rgba(37, 47, 63, var(--placeholder-opacity));
  }
  .sm\\:focus\\:placeholder-gray-900:focus::placeholder {
    --placeholder-opacity: 1;
    color: #161e2e;
    color: rgba(22, 30, 46, var(--placeholder-opacity));
  }
  .sm\\:focus\\:placeholder-red-50:focus::placeholder {
    --placeholder-opacity: 1;
    color: #fdf2f2;
    color: rgba(253, 242, 242, var(--placeholder-opacity));
  }
  .sm\\:focus\\:placeholder-red-100:focus::placeholder {
    --placeholder-opacity: 1;
    color: #fde8e8;
    color: rgba(253, 232, 232, var(--placeholder-opacity));
  }
  .sm\\:focus\\:placeholder-red-200:focus::placeholder {
    --placeholder-opacity: 1;
    color: #fbd5d5;
    color: rgba(251, 213, 213, var(--placeholder-opacity));
  }
  .sm\\:focus\\:placeholder-red-300:focus::placeholder {
    --placeholder-opacity: 1;
    color: #f8b4b4;
    color: rgba(248, 180, 180, var(--placeholder-opacity));
  }
  .sm\\:focus\\:placeholder-red-400:focus::placeholder {
    --placeholder-opacity: 1;
    color: #f98080;
    color: rgba(249, 128, 128, var(--placeholder-opacity));
  }
  .sm\\:focus\\:placeholder-red-500:focus::placeholder {
    --placeholder-opacity: 1;
    color: #f05252;
    color: rgba(240, 82, 82, var(--placeholder-opacity));
  }
  .sm\\:focus\\:placeholder-red-600:focus::placeholder {
    --placeholder-opacity: 1;
    color: #e02424;
    color: rgba(224, 36, 36, var(--placeholder-opacity));
  }
  .sm\\:focus\\:placeholder-red-700:focus::placeholder {
    --placeholder-opacity: 1;
    color: #c81e1e;
    color: rgba(200, 30, 30, var(--placeholder-opacity));
  }
  .sm\\:focus\\:placeholder-red-800:focus::placeholder {
    --placeholder-opacity: 1;
    color: #9b1c1c;
    color: rgba(155, 28, 28, var(--placeholder-opacity));
  }
  .sm\\:focus\\:placeholder-red-900:focus::placeholder {
    --placeholder-opacity: 1;
    color: #771d1d;
    color: rgba(119, 29, 29, var(--placeholder-opacity));
  }
  .sm\\:focus\\:placeholder-orange-50:focus::placeholder {
    --placeholder-opacity: 1;
    color: #fff8f1;
    color: rgba(255, 248, 241, var(--placeholder-opacity));
  }
  .sm\\:focus\\:placeholder-orange-100:focus::placeholder {
    --placeholder-opacity: 1;
    color: #feecdc;
    color: rgba(254, 236, 220, var(--placeholder-opacity));
  }
  .sm\\:focus\\:placeholder-orange-200:focus::placeholder {
    --placeholder-opacity: 1;
    color: #fcd9bd;
    color: rgba(252, 217, 189, var(--placeholder-opacity));
  }
  .sm\\:focus\\:placeholder-orange-300:focus::placeholder {
    --placeholder-opacity: 1;
    color: #fdba8c;
    color: rgba(253, 186, 140, var(--placeholder-opacity));
  }
  .sm\\:focus\\:placeholder-orange-400:focus::placeholder {
    --placeholder-opacity: 1;
    color: #ff8a4c;
    color: rgba(255, 138, 76, var(--placeholder-opacity));
  }
  .sm\\:focus\\:placeholder-orange-500:focus::placeholder {
    --placeholder-opacity: 1;
    color: #ff5a1f;
    color: rgba(255, 90, 31, var(--placeholder-opacity));
  }
  .sm\\:focus\\:placeholder-orange-600:focus::placeholder {
    --placeholder-opacity: 1;
    color: #d03801;
    color: rgba(208, 56, 1, var(--placeholder-opacity));
  }
  .sm\\:focus\\:placeholder-orange-700:focus::placeholder {
    --placeholder-opacity: 1;
    color: #b43403;
    color: rgba(180, 52, 3, var(--placeholder-opacity));
  }
  .sm\\:focus\\:placeholder-orange-800:focus::placeholder {
    --placeholder-opacity: 1;
    color: #8a2c0d;
    color: rgba(138, 44, 13, var(--placeholder-opacity));
  }
  .sm\\:focus\\:placeholder-orange-900:focus::placeholder {
    --placeholder-opacity: 1;
    color: #73230d;
    color: rgba(115, 35, 13, var(--placeholder-opacity));
  }
  .sm\\:focus\\:placeholder-yellow-50:focus::placeholder {
    --placeholder-opacity: 1;
    color: #fdfdea;
    color: rgba(253, 253, 234, var(--placeholder-opacity));
  }
  .sm\\:focus\\:placeholder-yellow-100:focus::placeholder {
    --placeholder-opacity: 1;
    color: #fdf6b2;
    color: rgba(253, 246, 178, var(--placeholder-opacity));
  }
  .sm\\:focus\\:placeholder-yellow-200:focus::placeholder {
    --placeholder-opacity: 1;
    color: #fce96a;
    color: rgba(252, 233, 106, var(--placeholder-opacity));
  }
  .sm\\:focus\\:placeholder-yellow-300:focus::placeholder {
    --placeholder-opacity: 1;
    color: #faca15;
    color: rgba(250, 202, 21, var(--placeholder-opacity));
  }
  .sm\\:focus\\:placeholder-yellow-400:focus::placeholder {
    --placeholder-opacity: 1;
    color: #e3a008;
    color: rgba(227, 160, 8, var(--placeholder-opacity));
  }
  .sm\\:focus\\:placeholder-yellow-500:focus::placeholder {
    --placeholder-opacity: 1;
    color: #c27803;
    color: rgba(194, 120, 3, var(--placeholder-opacity));
  }
  .sm\\:focus\\:placeholder-yellow-600:focus::placeholder {
    --placeholder-opacity: 1;
    color: #9f580a;
    color: rgba(159, 88, 10, var(--placeholder-opacity));
  }
  .sm\\:focus\\:placeholder-yellow-700:focus::placeholder {
    --placeholder-opacity: 1;
    color: #8e4b10;
    color: rgba(142, 75, 16, var(--placeholder-opacity));
  }
  .sm\\:focus\\:placeholder-yellow-800:focus::placeholder {
    --placeholder-opacity: 1;
    color: #723b13;
    color: rgba(114, 59, 19, var(--placeholder-opacity));
  }
  .sm\\:focus\\:placeholder-yellow-900:focus::placeholder {
    --placeholder-opacity: 1;
    color: #633112;
    color: rgba(99, 49, 18, var(--placeholder-opacity));
  }
  .sm\\:focus\\:placeholder-green-50:focus::placeholder {
    --placeholder-opacity: 1;
    color: #f3faf7;
    color: rgba(243, 250, 247, var(--placeholder-opacity));
  }
  .sm\\:focus\\:placeholder-green-100:focus::placeholder {
    --placeholder-opacity: 1;
    color: #def7ec;
    color: rgba(222, 247, 236, var(--placeholder-opacity));
  }
  .sm\\:focus\\:placeholder-green-200:focus::placeholder {
    --placeholder-opacity: 1;
    color: #bcf0da;
    color: rgba(188, 240, 218, var(--placeholder-opacity));
  }
  .sm\\:focus\\:placeholder-green-300:focus::placeholder {
    --placeholder-opacity: 1;
    color: #84e1bc;
    color: rgba(132, 225, 188, var(--placeholder-opacity));
  }
  .sm\\:focus\\:placeholder-green-400:focus::placeholder {
    --placeholder-opacity: 1;
    color: #31c48d;
    color: rgba(49, 196, 141, var(--placeholder-opacity));
  }
  .sm\\:focus\\:placeholder-green-500:focus::placeholder {
    --placeholder-opacity: 1;
    color: #0e9f6e;
    color: rgba(14, 159, 110, var(--placeholder-opacity));
  }
  .sm\\:focus\\:placeholder-green-600:focus::placeholder {
    --placeholder-opacity: 1;
    color: #057a55;
    color: rgba(5, 122, 85, var(--placeholder-opacity));
  }
  .sm\\:focus\\:placeholder-green-700:focus::placeholder {
    --placeholder-opacity: 1;
    color: #046c4e;
    color: rgba(4, 108, 78, var(--placeholder-opacity));
  }
  .sm\\:focus\\:placeholder-green-800:focus::placeholder {
    --placeholder-opacity: 1;
    color: #03543f;
    color: rgba(3, 84, 63, var(--placeholder-opacity));
  }
  .sm\\:focus\\:placeholder-green-900:focus::placeholder {
    --placeholder-opacity: 1;
    color: #014737;
    color: rgba(1, 71, 55, var(--placeholder-opacity));
  }
  .sm\\:focus\\:placeholder-teal-50:focus::placeholder {
    --placeholder-opacity: 1;
    color: #edfafa;
    color: rgba(237, 250, 250, var(--placeholder-opacity));
  }
  .sm\\:focus\\:placeholder-teal-100:focus::placeholder {
    --placeholder-opacity: 1;
    color: #d5f5f6;
    color: rgba(213, 245, 246, var(--placeholder-opacity));
  }
  .sm\\:focus\\:placeholder-teal-200:focus::placeholder {
    --placeholder-opacity: 1;
    color: #afecef;
    color: rgba(175, 236, 239, var(--placeholder-opacity));
  }
  .sm\\:focus\\:placeholder-teal-300:focus::placeholder {
    --placeholder-opacity: 1;
    color: #7edce2;
    color: rgba(126, 220, 226, var(--placeholder-opacity));
  }
  .sm\\:focus\\:placeholder-teal-400:focus::placeholder {
    --placeholder-opacity: 1;
    color: #16bdca;
    color: rgba(22, 189, 202, var(--placeholder-opacity));
  }
  .sm\\:focus\\:placeholder-teal-500:focus::placeholder {
    --placeholder-opacity: 1;
    color: #0694a2;
    color: rgba(6, 148, 162, var(--placeholder-opacity));
  }
  .sm\\:focus\\:placeholder-teal-600:focus::placeholder {
    --placeholder-opacity: 1;
    color: #047481;
    color: rgba(4, 116, 129, var(--placeholder-opacity));
  }
  .sm\\:focus\\:placeholder-teal-700:focus::placeholder {
    --placeholder-opacity: 1;
    color: #036672;
    color: rgba(3, 102, 114, var(--placeholder-opacity));
  }
  .sm\\:focus\\:placeholder-teal-800:focus::placeholder {
    --placeholder-opacity: 1;
    color: #05505c;
    color: rgba(5, 80, 92, var(--placeholder-opacity));
  }
  .sm\\:focus\\:placeholder-teal-900:focus::placeholder {
    --placeholder-opacity: 1;
    color: #014451;
    color: rgba(1, 68, 81, var(--placeholder-opacity));
  }
  .sm\\:focus\\:placeholder-blue-50:focus::placeholder {
    --placeholder-opacity: 1;
    color: #ebf5ff;
    color: rgba(235, 245, 255, var(--placeholder-opacity));
  }
  .sm\\:focus\\:placeholder-blue-100:focus::placeholder {
    --placeholder-opacity: 1;
    color: #e1effe;
    color: rgba(225, 239, 254, var(--placeholder-opacity));
  }
  .sm\\:focus\\:placeholder-blue-200:focus::placeholder {
    --placeholder-opacity: 1;
    color: #c3ddfd;
    color: rgba(195, 221, 253, var(--placeholder-opacity));
  }
  .sm\\:focus\\:placeholder-blue-300:focus::placeholder {
    --placeholder-opacity: 1;
    color: #a4cafe;
    color: rgba(164, 202, 254, var(--placeholder-opacity));
  }
  .sm\\:focus\\:placeholder-blue-400:focus::placeholder {
    --placeholder-opacity: 1;
    color: #76a9fa;
    color: rgba(118, 169, 250, var(--placeholder-opacity));
  }
  .sm\\:focus\\:placeholder-blue-500:focus::placeholder {
    --placeholder-opacity: 1;
    color: #3f83f8;
    color: rgba(63, 131, 248, var(--placeholder-opacity));
  }
  .sm\\:focus\\:placeholder-blue-600:focus::placeholder {
    --placeholder-opacity: 1;
    color: #1c64f2;
    color: rgba(28, 100, 242, var(--placeholder-opacity));
  }
  .sm\\:focus\\:placeholder-blue-700:focus::placeholder {
    --placeholder-opacity: 1;
    color: #1a56db;
    color: rgba(26, 86, 219, var(--placeholder-opacity));
  }
  .sm\\:focus\\:placeholder-blue-800:focus::placeholder {
    --placeholder-opacity: 1;
    color: #1e429f;
    color: rgba(30, 66, 159, var(--placeholder-opacity));
  }
  .sm\\:focus\\:placeholder-blue-900:focus::placeholder {
    --placeholder-opacity: 1;
    color: #233876;
    color: rgba(35, 56, 118, var(--placeholder-opacity));
  }
  .sm\\:focus\\:placeholder-indigo-50:focus::placeholder {
    --placeholder-opacity: 1;
    color: #f0f5ff;
    color: rgba(240, 245, 255, var(--placeholder-opacity));
  }
  .sm\\:focus\\:placeholder-indigo-100:focus::placeholder {
    --placeholder-opacity: 1;
    color: #e5edff;
    color: rgba(229, 237, 255, var(--placeholder-opacity));
  }
  .sm\\:focus\\:placeholder-indigo-200:focus::placeholder {
    --placeholder-opacity: 1;
    color: #cddbfe;
    color: rgba(205, 219, 254, var(--placeholder-opacity));
  }
  .sm\\:focus\\:placeholder-indigo-300:focus::placeholder {
    --placeholder-opacity: 1;
    color: #b4c6fc;
    color: rgba(180, 198, 252, var(--placeholder-opacity));
  }
  .sm\\:focus\\:placeholder-indigo-400:focus::placeholder {
    --placeholder-opacity: 1;
    color: #8da2fb;
    color: rgba(141, 162, 251, var(--placeholder-opacity));
  }
  .sm\\:focus\\:placeholder-indigo-500:focus::placeholder {
    --placeholder-opacity: 1;
    color: #6875f5;
    color: rgba(104, 117, 245, var(--placeholder-opacity));
  }
  .sm\\:focus\\:placeholder-indigo-600:focus::placeholder {
    --placeholder-opacity: 1;
    color: #5850ec;
    color: rgba(88, 80, 236, var(--placeholder-opacity));
  }
  .sm\\:focus\\:placeholder-indigo-700:focus::placeholder {
    --placeholder-opacity: 1;
    color: #5145cd;
    color: rgba(81, 69, 205, var(--placeholder-opacity));
  }
  .sm\\:focus\\:placeholder-indigo-800:focus::placeholder {
    --placeholder-opacity: 1;
    color: #42389d;
    color: rgba(66, 56, 157, var(--placeholder-opacity));
  }
  .sm\\:focus\\:placeholder-indigo-900:focus::placeholder {
    --placeholder-opacity: 1;
    color: #362f78;
    color: rgba(54, 47, 120, var(--placeholder-opacity));
  }
  .sm\\:focus\\:placeholder-purple-50:focus::placeholder {
    --placeholder-opacity: 1;
    color: #f6f5ff;
    color: rgba(246, 245, 255, var(--placeholder-opacity));
  }
  .sm\\:focus\\:placeholder-purple-100:focus::placeholder {
    --placeholder-opacity: 1;
    color: #edebfe;
    color: rgba(237, 235, 254, var(--placeholder-opacity));
  }
  .sm\\:focus\\:placeholder-purple-200:focus::placeholder {
    --placeholder-opacity: 1;
    color: #dcd7fe;
    color: rgba(220, 215, 254, var(--placeholder-opacity));
  }
  .sm\\:focus\\:placeholder-purple-300:focus::placeholder {
    --placeholder-opacity: 1;
    color: #cabffd;
    color: rgba(202, 191, 253, var(--placeholder-opacity));
  }
  .sm\\:focus\\:placeholder-purple-400:focus::placeholder {
    --placeholder-opacity: 1;
    color: #ac94fa;
    color: rgba(172, 148, 250, var(--placeholder-opacity));
  }
  .sm\\:focus\\:placeholder-purple-500:focus::placeholder {
    --placeholder-opacity: 1;
    color: #9061f9;
    color: rgba(144, 97, 249, var(--placeholder-opacity));
  }
  .sm\\:focus\\:placeholder-purple-600:focus::placeholder {
    --placeholder-opacity: 1;
    color: #7e3af2;
    color: rgba(126, 58, 242, var(--placeholder-opacity));
  }
  .sm\\:focus\\:placeholder-purple-700:focus::placeholder {
    --placeholder-opacity: 1;
    color: #6c2bd9;
    color: rgba(108, 43, 217, var(--placeholder-opacity));
  }
  .sm\\:focus\\:placeholder-purple-800:focus::placeholder {
    --placeholder-opacity: 1;
    color: #5521b5;
    color: rgba(85, 33, 181, var(--placeholder-opacity));
  }
  .sm\\:focus\\:placeholder-purple-900:focus::placeholder {
    --placeholder-opacity: 1;
    color: #4a1d96;
    color: rgba(74, 29, 150, var(--placeholder-opacity));
  }
  .sm\\:focus\\:placeholder-pink-50:focus::placeholder {
    --placeholder-opacity: 1;
    color: #fdf2f8;
    color: rgba(253, 242, 248, var(--placeholder-opacity));
  }
  .sm\\:focus\\:placeholder-pink-100:focus::placeholder {
    --placeholder-opacity: 1;
    color: #fce8f3;
    color: rgba(252, 232, 243, var(--placeholder-opacity));
  }
  .sm\\:focus\\:placeholder-pink-200:focus::placeholder {
    --placeholder-opacity: 1;
    color: #fad1e8;
    color: rgba(250, 209, 232, var(--placeholder-opacity));
  }
  .sm\\:focus\\:placeholder-pink-300:focus::placeholder {
    --placeholder-opacity: 1;
    color: #f8b4d9;
    color: rgba(248, 180, 217, var(--placeholder-opacity));
  }
  .sm\\:focus\\:placeholder-pink-400:focus::placeholder {
    --placeholder-opacity: 1;
    color: #f17eb8;
    color: rgba(241, 126, 184, var(--placeholder-opacity));
  }
  .sm\\:focus\\:placeholder-pink-500:focus::placeholder {
    --placeholder-opacity: 1;
    color: #e74694;
    color: rgba(231, 70, 148, var(--placeholder-opacity));
  }
  .sm\\:focus\\:placeholder-pink-600:focus::placeholder {
    --placeholder-opacity: 1;
    color: #d61f69;
    color: rgba(214, 31, 105, var(--placeholder-opacity));
  }
  .sm\\:focus\\:placeholder-pink-700:focus::placeholder {
    --placeholder-opacity: 1;
    color: #bf125d;
    color: rgba(191, 18, 93, var(--placeholder-opacity));
  }
  .sm\\:focus\\:placeholder-pink-800:focus::placeholder {
    --placeholder-opacity: 1;
    color: #99154b;
    color: rgba(153, 21, 75, var(--placeholder-opacity));
  }
  .sm\\:focus\\:placeholder-pink-900:focus::placeholder {
    --placeholder-opacity: 1;
    color: #751a3d;
    color: rgba(117, 26, 61, var(--placeholder-opacity));
  }
  .sm\\:focus\\:placeholder-cool-gray-50:focus::placeholder {
    --placeholder-opacity: 1;
    color: #f8fafc;
    color: rgba(248, 250, 252, var(--placeholder-opacity));
  }
  .sm\\:focus\\:placeholder-cool-gray-100:focus::placeholder {
    --placeholder-opacity: 1;
    color: #f1f5f9;
    color: rgba(241, 245, 249, var(--placeholder-opacity));
  }
  .sm\\:focus\\:placeholder-cool-gray-200:focus::placeholder {
    --placeholder-opacity: 1;
    color: #e2e8f0;
    color: rgba(226, 232, 240, var(--placeholder-opacity));
  }
  .sm\\:focus\\:placeholder-cool-gray-300:focus::placeholder {
    --placeholder-opacity: 1;
    color: #cfd8e3;
    color: rgba(207, 216, 227, var(--placeholder-opacity));
  }
  .sm\\:focus\\:placeholder-cool-gray-400:focus::placeholder {
    --placeholder-opacity: 1;
    color: #97a6ba;
    color: rgba(151, 166, 186, var(--placeholder-opacity));
  }
  .sm\\:focus\\:placeholder-cool-gray-500:focus::placeholder {
    --placeholder-opacity: 1;
    color: #64748b;
    color: rgba(100, 116, 139, var(--placeholder-opacity));
  }
  .sm\\:focus\\:placeholder-cool-gray-600:focus::placeholder {
    --placeholder-opacity: 1;
    color: #475569;
    color: rgba(71, 85, 105, var(--placeholder-opacity));
  }
  .sm\\:focus\\:placeholder-cool-gray-700:focus::placeholder {
    --placeholder-opacity: 1;
    color: #364152;
    color: rgba(54, 65, 82, var(--placeholder-opacity));
  }
  .sm\\:focus\\:placeholder-cool-gray-800:focus::placeholder {
    --placeholder-opacity: 1;
    color: #27303f;
    color: rgba(39, 48, 63, var(--placeholder-opacity));
  }
  .sm\\:focus\\:placeholder-cool-gray-900:focus::placeholder {
    --placeholder-opacity: 1;
    color: #1a202e;
    color: rgba(26, 32, 46, var(--placeholder-opacity));
  }
  .sm\\:placeholder-opacity-0::placeholder {
    --placeholder-opacity: 0;
  }
  .sm\\:placeholder-opacity-25::placeholder {
    --placeholder-opacity: 0.25;
  }
  .sm\\:placeholder-opacity-50::placeholder {
    --placeholder-opacity: 0.5;
  }
  .sm\\:placeholder-opacity-75::placeholder {
    --placeholder-opacity: 0.75;
  }
  .sm\\:placeholder-opacity-100::placeholder {
    --placeholder-opacity: 1;
  }
  .sm\\:focus\\:placeholder-opacity-0:focus::placeholder {
    --placeholder-opacity: 0;
  }
  .sm\\:focus\\:placeholder-opacity-25:focus::placeholder {
    --placeholder-opacity: 0.25;
  }
  .sm\\:focus\\:placeholder-opacity-50:focus::placeholder {
    --placeholder-opacity: 0.5;
  }
  .sm\\:focus\\:placeholder-opacity-75:focus::placeholder {
    --placeholder-opacity: 0.75;
  }
  .sm\\:focus\\:placeholder-opacity-100:focus::placeholder {
    --placeholder-opacity: 1;
  }
  .sm\\:pointer-events-none {
    pointer-events: none;
  }
  .sm\\:pointer-events-auto {
    pointer-events: auto;
  }
  .sm\\:static {
    position: static;
  }
  .sm\\:fixed {
    position: fixed;
  }
  .sm\\:absolute {
    position: absolute;
  }
  .sm\\:relative {
    position: relative;
  }
  .sm\\:sticky {
    position: sticky;
  }
  .sm\\:inset-0 {
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
  }
  .sm\\:inset-1 {
    top: 0.25rem;
    right: 0.25rem;
    bottom: 0.25rem;
    left: 0.25rem;
  }
  .sm\\:inset-2 {
    top: 0.5rem;
    right: 0.5rem;
    bottom: 0.5rem;
    left: 0.5rem;
  }
  .sm\\:inset-3 {
    top: 0.75rem;
    right: 0.75rem;
    bottom: 0.75rem;
    left: 0.75rem;
  }
  .sm\\:inset-4 {
    top: 1rem;
    right: 1rem;
    bottom: 1rem;
    left: 1rem;
  }
  .sm\\:inset-5 {
    top: 1.25rem;
    right: 1.25rem;
    bottom: 1.25rem;
    left: 1.25rem;
  }
  .sm\\:inset-6 {
    top: 1.5rem;
    right: 1.5rem;
    bottom: 1.5rem;
    left: 1.5rem;
  }
  .sm\\:inset-7 {
    top: 1.75rem;
    right: 1.75rem;
    bottom: 1.75rem;
    left: 1.75rem;
  }
  .sm\\:inset-8 {
    top: 2rem;
    right: 2rem;
    bottom: 2rem;
    left: 2rem;
  }
  .sm\\:inset-9 {
    top: 2.25rem;
    right: 2.25rem;
    bottom: 2.25rem;
    left: 2.25rem;
  }
  .sm\\:inset-10 {
    top: 2.5rem;
    right: 2.5rem;
    bottom: 2.5rem;
    left: 2.5rem;
  }
  .sm\\:inset-11 {
    top: 2.75rem;
    right: 2.75rem;
    bottom: 2.75rem;
    left: 2.75rem;
  }
  .sm\\:inset-12 {
    top: 3rem;
    right: 3rem;
    bottom: 3rem;
    left: 3rem;
  }
  .sm\\:inset-13 {
    top: 3.25rem;
    right: 3.25rem;
    bottom: 3.25rem;
    left: 3.25rem;
  }
  .sm\\:inset-14 {
    top: 3.5rem;
    right: 3.5rem;
    bottom: 3.5rem;
    left: 3.5rem;
  }
  .sm\\:inset-15 {
    top: 3.75rem;
    right: 3.75rem;
    bottom: 3.75rem;
    left: 3.75rem;
  }
  .sm\\:inset-16 {
    top: 4rem;
    right: 4rem;
    bottom: 4rem;
    left: 4rem;
  }
  .sm\\:inset-20 {
    top: 5rem;
    right: 5rem;
    bottom: 5rem;
    left: 5rem;
  }
  .sm\\:inset-24 {
    top: 6rem;
    right: 6rem;
    bottom: 6rem;
    left: 6rem;
  }
  .sm\\:inset-28 {
    top: 7rem;
    right: 7rem;
    bottom: 7rem;
    left: 7rem;
  }
  .sm\\:inset-32 {
    top: 8rem;
    right: 8rem;
    bottom: 8rem;
    left: 8rem;
  }
  .sm\\:inset-36 {
    top: 9rem;
    right: 9rem;
    bottom: 9rem;
    left: 9rem;
  }
  .sm\\:inset-40 {
    top: 10rem;
    right: 10rem;
    bottom: 10rem;
    left: 10rem;
  }
  .sm\\:inset-44 {
    top: 11rem;
    right: 11rem;
    bottom: 11rem;
    left: 11rem;
  }
  .sm\\:inset-48 {
    top: 12rem;
    right: 12rem;
    bottom: 12rem;
    left: 12rem;
  }
  .sm\\:inset-52 {
    top: 13rem;
    right: 13rem;
    bottom: 13rem;
    left: 13rem;
  }
  .sm\\:inset-56 {
    top: 14rem;
    right: 14rem;
    bottom: 14rem;
    left: 14rem;
  }
  .sm\\:inset-60 {
    top: 15rem;
    right: 15rem;
    bottom: 15rem;
    left: 15rem;
  }
  .sm\\:inset-64 {
    top: 16rem;
    right: 16rem;
    bottom: 16rem;
    left: 16rem;
  }
  .sm\\:inset-72 {
    top: 18rem;
    right: 18rem;
    bottom: 18rem;
    left: 18rem;
  }
  .sm\\:inset-80 {
    top: 20rem;
    right: 20rem;
    bottom: 20rem;
    left: 20rem;
  }
  .sm\\:inset-96 {
    top: 24rem;
    right: 24rem;
    bottom: 24rem;
    left: 24rem;
  }
  .sm\\:inset-auto {
    top: auto;
    right: auto;
    bottom: auto;
    left: auto;
  }
  .sm\\:inset-px {
    top: 1px;
    right: 1px;
    bottom: 1px;
    left: 1px;
  }
  .sm\\:inset-0\\.5 {
    top: 0.125rem;
    right: 0.125rem;
    bottom: 0.125rem;
    left: 0.125rem;
  }
  .sm\\:inset-1\\.5 {
    top: 0.375rem;
    right: 0.375rem;
    bottom: 0.375rem;
    left: 0.375rem;
  }
  .sm\\:inset-2\\.5 {
    top: 0.625rem;
    right: 0.625rem;
    bottom: 0.625rem;
    left: 0.625rem;
  }
  .sm\\:inset-3\\.5 {
    top: 0.875rem;
    right: 0.875rem;
    bottom: 0.875rem;
    left: 0.875rem;
  }
  .sm\\:inset-1\\/2 {
    top: 50%;
    right: 50%;
    bottom: 50%;
    left: 50%;
  }
  .sm\\:inset-1\\/3 {
    top: 33.333333%;
    right: 33.333333%;
    bottom: 33.333333%;
    left: 33.333333%;
  }
  .sm\\:inset-2\\/3 {
    top: 66.666667%;
    right: 66.666667%;
    bottom: 66.666667%;
    left: 66.666667%;
  }
  .sm\\:inset-1\\/4 {
    top: 25%;
    right: 25%;
    bottom: 25%;
    left: 25%;
  }
  .sm\\:inset-2\\/4 {
    top: 50%;
    right: 50%;
    bottom: 50%;
    left: 50%;
  }
  .sm\\:inset-3\\/4 {
    top: 75%;
    right: 75%;
    bottom: 75%;
    left: 75%;
  }
  .sm\\:inset-1\\/5 {
    top: 20%;
    right: 20%;
    bottom: 20%;
    left: 20%;
  }
  .sm\\:inset-2\\/5 {
    top: 40%;
    right: 40%;
    bottom: 40%;
    left: 40%;
  }
  .sm\\:inset-3\\/5 {
    top: 60%;
    right: 60%;
    bottom: 60%;
    left: 60%;
  }
  .sm\\:inset-4\\/5 {
    top: 80%;
    right: 80%;
    bottom: 80%;
    left: 80%;
  }
  .sm\\:inset-1\\/6 {
    top: 16.666667%;
    right: 16.666667%;
    bottom: 16.666667%;
    left: 16.666667%;
  }
  .sm\\:inset-2\\/6 {
    top: 33.333333%;
    right: 33.333333%;
    bottom: 33.333333%;
    left: 33.333333%;
  }
  .sm\\:inset-3\\/6 {
    top: 50%;
    right: 50%;
    bottom: 50%;
    left: 50%;
  }
  .sm\\:inset-4\\/6 {
    top: 66.666667%;
    right: 66.666667%;
    bottom: 66.666667%;
    left: 66.666667%;
  }
  .sm\\:inset-5\\/6 {
    top: 83.333333%;
    right: 83.333333%;
    bottom: 83.333333%;
    left: 83.333333%;
  }
  .sm\\:inset-1\\/12 {
    top: 8.333333%;
    right: 8.333333%;
    bottom: 8.333333%;
    left: 8.333333%;
  }
  .sm\\:inset-2\\/12 {
    top: 16.666667%;
    right: 16.666667%;
    bottom: 16.666667%;
    left: 16.666667%;
  }
  .sm\\:inset-3\\/12 {
    top: 25%;
    right: 25%;
    bottom: 25%;
    left: 25%;
  }
  .sm\\:inset-4\\/12 {
    top: 33.333333%;
    right: 33.333333%;
    bottom: 33.333333%;
    left: 33.333333%;
  }
  .sm\\:inset-5\\/12 {
    top: 41.666667%;
    right: 41.666667%;
    bottom: 41.666667%;
    left: 41.666667%;
  }
  .sm\\:inset-6\\/12 {
    top: 50%;
    right: 50%;
    bottom: 50%;
    left: 50%;
  }
  .sm\\:inset-7\\/12 {
    top: 58.333333%;
    right: 58.333333%;
    bottom: 58.333333%;
    left: 58.333333%;
  }
  .sm\\:inset-8\\/12 {
    top: 66.666667%;
    right: 66.666667%;
    bottom: 66.666667%;
    left: 66.666667%;
  }
  .sm\\:inset-9\\/12 {
    top: 75%;
    right: 75%;
    bottom: 75%;
    left: 75%;
  }
  .sm\\:inset-10\\/12 {
    top: 83.333333%;
    right: 83.333333%;
    bottom: 83.333333%;
    left: 83.333333%;
  }
  .sm\\:inset-11\\/12 {
    top: 91.666667%;
    right: 91.666667%;
    bottom: 91.666667%;
    left: 91.666667%;
  }
  .sm\\:inset-full {
    top: 100%;
    right: 100%;
    bottom: 100%;
    left: 100%;
  }
  .sm\\:inset-y-0 {
    top: 0;
    bottom: 0;
  }
  .sm\\:inset-x-0 {
    right: 0;
    left: 0;
  }
  .sm\\:inset-y-1 {
    top: 0.25rem;
    bottom: 0.25rem;
  }
  .sm\\:inset-x-1 {
    right: 0.25rem;
    left: 0.25rem;
  }
  .sm\\:inset-y-2 {
    top: 0.5rem;
    bottom: 0.5rem;
  }
  .sm\\:inset-x-2 {
    right: 0.5rem;
    left: 0.5rem;
  }
  .sm\\:inset-y-3 {
    top: 0.75rem;
    bottom: 0.75rem;
  }
  .sm\\:inset-x-3 {
    right: 0.75rem;
    left: 0.75rem;
  }
  .sm\\:inset-y-4 {
    top: 1rem;
    bottom: 1rem;
  }
  .sm\\:inset-x-4 {
    right: 1rem;
    left: 1rem;
  }
  .sm\\:inset-y-5 {
    top: 1.25rem;
    bottom: 1.25rem;
  }
  .sm\\:inset-x-5 {
    right: 1.25rem;
    left: 1.25rem;
  }
  .sm\\:inset-y-6 {
    top: 1.5rem;
    bottom: 1.5rem;
  }
  .sm\\:inset-x-6 {
    right: 1.5rem;
    left: 1.5rem;
  }
  .sm\\:inset-y-7 {
    top: 1.75rem;
    bottom: 1.75rem;
  }
  .sm\\:inset-x-7 {
    right: 1.75rem;
    left: 1.75rem;
  }
  .sm\\:inset-y-8 {
    top: 2rem;
    bottom: 2rem;
  }
  .sm\\:inset-x-8 {
    right: 2rem;
    left: 2rem;
  }
  .sm\\:inset-y-9 {
    top: 2.25rem;
    bottom: 2.25rem;
  }
  .sm\\:inset-x-9 {
    right: 2.25rem;
    left: 2.25rem;
  }
  .sm\\:inset-y-10 {
    top: 2.5rem;
    bottom: 2.5rem;
  }
  .sm\\:inset-x-10 {
    right: 2.5rem;
    left: 2.5rem;
  }
  .sm\\:inset-y-11 {
    top: 2.75rem;
    bottom: 2.75rem;
  }
  .sm\\:inset-x-11 {
    right: 2.75rem;
    left: 2.75rem;
  }
  .sm\\:inset-y-12 {
    top: 3rem;
    bottom: 3rem;
  }
  .sm\\:inset-x-12 {
    right: 3rem;
    left: 3rem;
  }
  .sm\\:inset-y-13 {
    top: 3.25rem;
    bottom: 3.25rem;
  }
  .sm\\:inset-x-13 {
    right: 3.25rem;
    left: 3.25rem;
  }
  .sm\\:inset-y-14 {
    top: 3.5rem;
    bottom: 3.5rem;
  }
  .sm\\:inset-x-14 {
    right: 3.5rem;
    left: 3.5rem;
  }
  .sm\\:inset-y-15 {
    top: 3.75rem;
    bottom: 3.75rem;
  }
  .sm\\:inset-x-15 {
    right: 3.75rem;
    left: 3.75rem;
  }
  .sm\\:inset-y-16 {
    top: 4rem;
    bottom: 4rem;
  }
  .sm\\:inset-x-16 {
    right: 4rem;
    left: 4rem;
  }
  .sm\\:inset-y-20 {
    top: 5rem;
    bottom: 5rem;
  }
  .sm\\:inset-x-20 {
    right: 5rem;
    left: 5rem;
  }
  .sm\\:inset-y-24 {
    top: 6rem;
    bottom: 6rem;
  }
  .sm\\:inset-x-24 {
    right: 6rem;
    left: 6rem;
  }
  .sm\\:inset-y-28 {
    top: 7rem;
    bottom: 7rem;
  }
  .sm\\:inset-x-28 {
    right: 7rem;
    left: 7rem;
  }
  .sm\\:inset-y-32 {
    top: 8rem;
    bottom: 8rem;
  }
  .sm\\:inset-x-32 {
    right: 8rem;
    left: 8rem;
  }
  .sm\\:inset-y-36 {
    top: 9rem;
    bottom: 9rem;
  }
  .sm\\:inset-x-36 {
    right: 9rem;
    left: 9rem;
  }
  .sm\\:inset-y-40 {
    top: 10rem;
    bottom: 10rem;
  }
  .sm\\:inset-x-40 {
    right: 10rem;
    left: 10rem;
  }
  .sm\\:inset-y-44 {
    top: 11rem;
    bottom: 11rem;
  }
  .sm\\:inset-x-44 {
    right: 11rem;
    left: 11rem;
  }
  .sm\\:inset-y-48 {
    top: 12rem;
    bottom: 12rem;
  }
  .sm\\:inset-x-48 {
    right: 12rem;
    left: 12rem;
  }
  .sm\\:inset-y-52 {
    top: 13rem;
    bottom: 13rem;
  }
  .sm\\:inset-x-52 {
    right: 13rem;
    left: 13rem;
  }
  .sm\\:inset-y-56 {
    top: 14rem;
    bottom: 14rem;
  }
  .sm\\:inset-x-56 {
    right: 14rem;
    left: 14rem;
  }
  .sm\\:inset-y-60 {
    top: 15rem;
    bottom: 15rem;
  }
  .sm\\:inset-x-60 {
    right: 15rem;
    left: 15rem;
  }
  .sm\\:inset-y-64 {
    top: 16rem;
    bottom: 16rem;
  }
  .sm\\:inset-x-64 {
    right: 16rem;
    left: 16rem;
  }
  .sm\\:inset-y-72 {
    top: 18rem;
    bottom: 18rem;
  }
  .sm\\:inset-x-72 {
    right: 18rem;
    left: 18rem;
  }
  .sm\\:inset-y-80 {
    top: 20rem;
    bottom: 20rem;
  }
  .sm\\:inset-x-80 {
    right: 20rem;
    left: 20rem;
  }
  .sm\\:inset-y-96 {
    top: 24rem;
    bottom: 24rem;
  }
  .sm\\:inset-x-96 {
    right: 24rem;
    left: 24rem;
  }
  .sm\\:inset-y-auto {
    top: auto;
    bottom: auto;
  }
  .sm\\:inset-x-auto {
    right: auto;
    left: auto;
  }
  .sm\\:inset-y-px {
    top: 1px;
    bottom: 1px;
  }
  .sm\\:inset-x-px {
    right: 1px;
    left: 1px;
  }
  .sm\\:inset-y-0\\.5 {
    top: 0.125rem;
    bottom: 0.125rem;
  }
  .sm\\:inset-x-0\\.5 {
    right: 0.125rem;
    left: 0.125rem;
  }
  .sm\\:inset-y-1\\.5 {
    top: 0.375rem;
    bottom: 0.375rem;
  }
  .sm\\:inset-x-1\\.5 {
    right: 0.375rem;
    left: 0.375rem;
  }
  .sm\\:inset-y-2\\.5 {
    top: 0.625rem;
    bottom: 0.625rem;
  }
  .sm\\:inset-x-2\\.5 {
    right: 0.625rem;
    left: 0.625rem;
  }
  .sm\\:inset-y-3\\.5 {
    top: 0.875rem;
    bottom: 0.875rem;
  }
  .sm\\:inset-x-3\\.5 {
    right: 0.875rem;
    left: 0.875rem;
  }
  .sm\\:inset-y-1\\/2 {
    top: 50%;
    bottom: 50%;
  }
  .sm\\:inset-x-1\\/2 {
    right: 50%;
    left: 50%;
  }
  .sm\\:inset-y-1\\/3 {
    top: 33.333333%;
    bottom: 33.333333%;
  }
  .sm\\:inset-x-1\\/3 {
    right: 33.333333%;
    left: 33.333333%;
  }
  .sm\\:inset-y-2\\/3 {
    top: 66.666667%;
    bottom: 66.666667%;
  }
  .sm\\:inset-x-2\\/3 {
    right: 66.666667%;
    left: 66.666667%;
  }
  .sm\\:inset-y-1\\/4 {
    top: 25%;
    bottom: 25%;
  }
  .sm\\:inset-x-1\\/4 {
    right: 25%;
    left: 25%;
  }
  .sm\\:inset-y-2\\/4 {
    top: 50%;
    bottom: 50%;
  }
  .sm\\:inset-x-2\\/4 {
    right: 50%;
    left: 50%;
  }
  .sm\\:inset-y-3\\/4 {
    top: 75%;
    bottom: 75%;
  }
  .sm\\:inset-x-3\\/4 {
    right: 75%;
    left: 75%;
  }
  .sm\\:inset-y-1\\/5 {
    top: 20%;
    bottom: 20%;
  }
  .sm\\:inset-x-1\\/5 {
    right: 20%;
    left: 20%;
  }
  .sm\\:inset-y-2\\/5 {
    top: 40%;
    bottom: 40%;
  }
  .sm\\:inset-x-2\\/5 {
    right: 40%;
    left: 40%;
  }
  .sm\\:inset-y-3\\/5 {
    top: 60%;
    bottom: 60%;
  }
  .sm\\:inset-x-3\\/5 {
    right: 60%;
    left: 60%;
  }
  .sm\\:inset-y-4\\/5 {
    top: 80%;
    bottom: 80%;
  }
  .sm\\:inset-x-4\\/5 {
    right: 80%;
    left: 80%;
  }
  .sm\\:inset-y-1\\/6 {
    top: 16.666667%;
    bottom: 16.666667%;
  }
  .sm\\:inset-x-1\\/6 {
    right: 16.666667%;
    left: 16.666667%;
  }
  .sm\\:inset-y-2\\/6 {
    top: 33.333333%;
    bottom: 33.333333%;
  }
  .sm\\:inset-x-2\\/6 {
    right: 33.333333%;
    left: 33.333333%;
  }
  .sm\\:inset-y-3\\/6 {
    top: 50%;
    bottom: 50%;
  }
  .sm\\:inset-x-3\\/6 {
    right: 50%;
    left: 50%;
  }
  .sm\\:inset-y-4\\/6 {
    top: 66.666667%;
    bottom: 66.666667%;
  }
  .sm\\:inset-x-4\\/6 {
    right: 66.666667%;
    left: 66.666667%;
  }
  .sm\\:inset-y-5\\/6 {
    top: 83.333333%;
    bottom: 83.333333%;
  }
  .sm\\:inset-x-5\\/6 {
    right: 83.333333%;
    left: 83.333333%;
  }
  .sm\\:inset-y-1\\/12 {
    top: 8.333333%;
    bottom: 8.333333%;
  }
  .sm\\:inset-x-1\\/12 {
    right: 8.333333%;
    left: 8.333333%;
  }
  .sm\\:inset-y-2\\/12 {
    top: 16.666667%;
    bottom: 16.666667%;
  }
  .sm\\:inset-x-2\\/12 {
    right: 16.666667%;
    left: 16.666667%;
  }
  .sm\\:inset-y-3\\/12 {
    top: 25%;
    bottom: 25%;
  }
  .sm\\:inset-x-3\\/12 {
    right: 25%;
    left: 25%;
  }
  .sm\\:inset-y-4\\/12 {
    top: 33.333333%;
    bottom: 33.333333%;
  }
  .sm\\:inset-x-4\\/12 {
    right: 33.333333%;
    left: 33.333333%;
  }
  .sm\\:inset-y-5\\/12 {
    top: 41.666667%;
    bottom: 41.666667%;
  }
  .sm\\:inset-x-5\\/12 {
    right: 41.666667%;
    left: 41.666667%;
  }
  .sm\\:inset-y-6\\/12 {
    top: 50%;
    bottom: 50%;
  }
  .sm\\:inset-x-6\\/12 {
    right: 50%;
    left: 50%;
  }
  .sm\\:inset-y-7\\/12 {
    top: 58.333333%;
    bottom: 58.333333%;
  }
  .sm\\:inset-x-7\\/12 {
    right: 58.333333%;
    left: 58.333333%;
  }
  .sm\\:inset-y-8\\/12 {
    top: 66.666667%;
    bottom: 66.666667%;
  }
  .sm\\:inset-x-8\\/12 {
    right: 66.666667%;
    left: 66.666667%;
  }
  .sm\\:inset-y-9\\/12 {
    top: 75%;
    bottom: 75%;
  }
  .sm\\:inset-x-9\\/12 {
    right: 75%;
    left: 75%;
  }
  .sm\\:inset-y-10\\/12 {
    top: 83.333333%;
    bottom: 83.333333%;
  }
  .sm\\:inset-x-10\\/12 {
    right: 83.333333%;
    left: 83.333333%;
  }
  .sm\\:inset-y-11\\/12 {
    top: 91.666667%;
    bottom: 91.666667%;
  }
  .sm\\:inset-x-11\\/12 {
    right: 91.666667%;
    left: 91.666667%;
  }
  .sm\\:inset-y-full {
    top: 100%;
    bottom: 100%;
  }
  .sm\\:inset-x-full {
    right: 100%;
    left: 100%;
  }
  .sm\\:top-0 {
    top: 0;
  }
  .sm\\:right-0 {
    right: 0;
  }
  .sm\\:bottom-0 {
    bottom: 0;
  }
  .sm\\:left-0 {
    left: 0;
  }
  .sm\\:top-1 {
    top: 0.25rem;
  }
  .sm\\:right-1 {
    right: 0.25rem;
  }
  .sm\\:bottom-1 {
    bottom: 0.25rem;
  }
  .sm\\:left-1 {
    left: 0.25rem;
  }
  .sm\\:top-2 {
    top: 0.5rem;
  }
  .sm\\:right-2 {
    right: 0.5rem;
  }
  .sm\\:bottom-2 {
    bottom: 0.5rem;
  }
  .sm\\:left-2 {
    left: 0.5rem;
  }
  .sm\\:top-3 {
    top: 0.75rem;
  }
  .sm\\:right-3 {
    right: 0.75rem;
  }
  .sm\\:bottom-3 {
    bottom: 0.75rem;
  }
  .sm\\:left-3 {
    left: 0.75rem;
  }
  .sm\\:top-4 {
    top: 1rem;
  }
  .sm\\:right-4 {
    right: 1rem;
  }
  .sm\\:bottom-4 {
    bottom: 1rem;
  }
  .sm\\:left-4 {
    left: 1rem;
  }
  .sm\\:top-5 {
    top: 1.25rem;
  }
  .sm\\:right-5 {
    right: 1.25rem;
  }
  .sm\\:bottom-5 {
    bottom: 1.25rem;
  }
  .sm\\:left-5 {
    left: 1.25rem;
  }
  .sm\\:top-6 {
    top: 1.5rem;
  }
  .sm\\:right-6 {
    right: 1.5rem;
  }
  .sm\\:bottom-6 {
    bottom: 1.5rem;
  }
  .sm\\:left-6 {
    left: 1.5rem;
  }
  .sm\\:top-7 {
    top: 1.75rem;
  }
  .sm\\:right-7 {
    right: 1.75rem;
  }
  .sm\\:bottom-7 {
    bottom: 1.75rem;
  }
  .sm\\:left-7 {
    left: 1.75rem;
  }
  .sm\\:top-8 {
    top: 2rem;
  }
  .sm\\:right-8 {
    right: 2rem;
  }
  .sm\\:bottom-8 {
    bottom: 2rem;
  }
  .sm\\:left-8 {
    left: 2rem;
  }
  .sm\\:top-9 {
    top: 2.25rem;
  }
  .sm\\:right-9 {
    right: 2.25rem;
  }
  .sm\\:bottom-9 {
    bottom: 2.25rem;
  }
  .sm\\:left-9 {
    left: 2.25rem;
  }
  .sm\\:top-10 {
    top: 2.5rem;
  }
  .sm\\:right-10 {
    right: 2.5rem;
  }
  .sm\\:bottom-10 {
    bottom: 2.5rem;
  }
  .sm\\:left-10 {
    left: 2.5rem;
  }
  .sm\\:top-11 {
    top: 2.75rem;
  }
  .sm\\:right-11 {
    right: 2.75rem;
  }
  .sm\\:bottom-11 {
    bottom: 2.75rem;
  }
  .sm\\:left-11 {
    left: 2.75rem;
  }
  .sm\\:top-12 {
    top: 3rem;
  }
  .sm\\:right-12 {
    right: 3rem;
  }
  .sm\\:bottom-12 {
    bottom: 3rem;
  }
  .sm\\:left-12 {
    left: 3rem;
  }
  .sm\\:top-13 {
    top: 3.25rem;
  }
  .sm\\:right-13 {
    right: 3.25rem;
  }
  .sm\\:bottom-13 {
    bottom: 3.25rem;
  }
  .sm\\:left-13 {
    left: 3.25rem;
  }
  .sm\\:top-14 {
    top: 3.5rem;
  }
  .sm\\:right-14 {
    right: 3.5rem;
  }
  .sm\\:bottom-14 {
    bottom: 3.5rem;
  }
  .sm\\:left-14 {
    left: 3.5rem;
  }
  .sm\\:top-15 {
    top: 3.75rem;
  }
  .sm\\:right-15 {
    right: 3.75rem;
  }
  .sm\\:bottom-15 {
    bottom: 3.75rem;
  }
  .sm\\:left-15 {
    left: 3.75rem;
  }
  .sm\\:top-16 {
    top: 4rem;
  }
  .sm\\:right-16 {
    right: 4rem;
  }
  .sm\\:bottom-16 {
    bottom: 4rem;
  }
  .sm\\:left-16 {
    left: 4rem;
  }
  .sm\\:top-20 {
    top: 5rem;
  }
  .sm\\:right-20 {
    right: 5rem;
  }
  .sm\\:bottom-20 {
    bottom: 5rem;
  }
  .sm\\:left-20 {
    left: 5rem;
  }
  .sm\\:top-24 {
    top: 6rem;
  }
  .sm\\:right-24 {
    right: 6rem;
  }
  .sm\\:bottom-24 {
    bottom: 6rem;
  }
  .sm\\:left-24 {
    left: 6rem;
  }
  .sm\\:top-28 {
    top: 7rem;
  }
  .sm\\:right-28 {
    right: 7rem;
  }
  .sm\\:bottom-28 {
    bottom: 7rem;
  }
  .sm\\:left-28 {
    left: 7rem;
  }
  .sm\\:top-32 {
    top: 8rem;
  }
  .sm\\:right-32 {
    right: 8rem;
  }
  .sm\\:bottom-32 {
    bottom: 8rem;
  }
  .sm\\:left-32 {
    left: 8rem;
  }
  .sm\\:top-36 {
    top: 9rem;
  }
  .sm\\:right-36 {
    right: 9rem;
  }
  .sm\\:bottom-36 {
    bottom: 9rem;
  }
  .sm\\:left-36 {
    left: 9rem;
  }
  .sm\\:top-40 {
    top: 10rem;
  }
  .sm\\:right-40 {
    right: 10rem;
  }
  .sm\\:bottom-40 {
    bottom: 10rem;
  }
  .sm\\:left-40 {
    left: 10rem;
  }
  .sm\\:top-44 {
    top: 11rem;
  }
  .sm\\:right-44 {
    right: 11rem;
  }
  .sm\\:bottom-44 {
    bottom: 11rem;
  }
  .sm\\:left-44 {
    left: 11rem;
  }
  .sm\\:top-48 {
    top: 12rem;
  }
  .sm\\:right-48 {
    right: 12rem;
  }
  .sm\\:bottom-48 {
    bottom: 12rem;
  }
  .sm\\:left-48 {
    left: 12rem;
  }
  .sm\\:top-52 {
    top: 13rem;
  }
  .sm\\:right-52 {
    right: 13rem;
  }
  .sm\\:bottom-52 {
    bottom: 13rem;
  }
  .sm\\:left-52 {
    left: 13rem;
  }
  .sm\\:top-56 {
    top: 14rem;
  }
  .sm\\:right-56 {
    right: 14rem;
  }
  .sm\\:bottom-56 {
    bottom: 14rem;
  }
  .sm\\:left-56 {
    left: 14rem;
  }
  .sm\\:top-60 {
    top: 15rem;
  }
  .sm\\:right-60 {
    right: 15rem;
  }
  .sm\\:bottom-60 {
    bottom: 15rem;
  }
  .sm\\:left-60 {
    left: 15rem;
  }
  .sm\\:top-64 {
    top: 16rem;
  }
  .sm\\:right-64 {
    right: 16rem;
  }
  .sm\\:bottom-64 {
    bottom: 16rem;
  }
  .sm\\:left-64 {
    left: 16rem;
  }
  .sm\\:top-72 {
    top: 18rem;
  }
  .sm\\:right-72 {
    right: 18rem;
  }
  .sm\\:bottom-72 {
    bottom: 18rem;
  }
  .sm\\:left-72 {
    left: 18rem;
  }
  .sm\\:top-80 {
    top: 20rem;
  }
  .sm\\:right-80 {
    right: 20rem;
  }
  .sm\\:bottom-80 {
    bottom: 20rem;
  }
  .sm\\:left-80 {
    left: 20rem;
  }
  .sm\\:top-96 {
    top: 24rem;
  }
  .sm\\:right-96 {
    right: 24rem;
  }
  .sm\\:bottom-96 {
    bottom: 24rem;
  }
  .sm\\:left-96 {
    left: 24rem;
  }
  .sm\\:top-auto {
    top: auto;
  }
  .sm\\:right-auto {
    right: auto;
  }
  .sm\\:bottom-auto {
    bottom: auto;
  }
  .sm\\:left-auto {
    left: auto;
  }
  .sm\\:top-px {
    top: 1px;
  }
  .sm\\:right-px {
    right: 1px;
  }
  .sm\\:bottom-px {
    bottom: 1px;
  }
  .sm\\:left-px {
    left: 1px;
  }
  .sm\\:top-0\\.5 {
    top: 0.125rem;
  }
  .sm\\:right-0\\.5 {
    right: 0.125rem;
  }
  .sm\\:bottom-0\\.5 {
    bottom: 0.125rem;
  }
  .sm\\:left-0\\.5 {
    left: 0.125rem;
  }
  .sm\\:top-1\\.5 {
    top: 0.375rem;
  }
  .sm\\:right-1\\.5 {
    right: 0.375rem;
  }
  .sm\\:bottom-1\\.5 {
    bottom: 0.375rem;
  }
  .sm\\:left-1\\.5 {
    left: 0.375rem;
  }
  .sm\\:top-2\\.5 {
    top: 0.625rem;
  }
  .sm\\:right-2\\.5 {
    right: 0.625rem;
  }
  .sm\\:bottom-2\\.5 {
    bottom: 0.625rem;
  }
  .sm\\:left-2\\.5 {
    left: 0.625rem;
  }
  .sm\\:top-3\\.5 {
    top: 0.875rem;
  }
  .sm\\:right-3\\.5 {
    right: 0.875rem;
  }
  .sm\\:bottom-3\\.5 {
    bottom: 0.875rem;
  }
  .sm\\:left-3\\.5 {
    left: 0.875rem;
  }
  .sm\\:top-1\\/2 {
    top: 50%;
  }
  .sm\\:right-1\\/2 {
    right: 50%;
  }
  .sm\\:bottom-1\\/2 {
    bottom: 50%;
  }
  .sm\\:left-1\\/2 {
    left: 50%;
  }
  .sm\\:top-1\\/3 {
    top: 33.333333%;
  }
  .sm\\:right-1\\/3 {
    right: 33.333333%;
  }
  .sm\\:bottom-1\\/3 {
    bottom: 33.333333%;
  }
  .sm\\:left-1\\/3 {
    left: 33.333333%;
  }
  .sm\\:top-2\\/3 {
    top: 66.666667%;
  }
  .sm\\:right-2\\/3 {
    right: 66.666667%;
  }
  .sm\\:bottom-2\\/3 {
    bottom: 66.666667%;
  }
  .sm\\:left-2\\/3 {
    left: 66.666667%;
  }
  .sm\\:top-1\\/4 {
    top: 25%;
  }
  .sm\\:right-1\\/4 {
    right: 25%;
  }
  .sm\\:bottom-1\\/4 {
    bottom: 25%;
  }
  .sm\\:left-1\\/4 {
    left: 25%;
  }
  .sm\\:top-2\\/4 {
    top: 50%;
  }
  .sm\\:right-2\\/4 {
    right: 50%;
  }
  .sm\\:bottom-2\\/4 {
    bottom: 50%;
  }
  .sm\\:left-2\\/4 {
    left: 50%;
  }
  .sm\\:top-3\\/4 {
    top: 75%;
  }
  .sm\\:right-3\\/4 {
    right: 75%;
  }
  .sm\\:bottom-3\\/4 {
    bottom: 75%;
  }
  .sm\\:left-3\\/4 {
    left: 75%;
  }
  .sm\\:top-1\\/5 {
    top: 20%;
  }
  .sm\\:right-1\\/5 {
    right: 20%;
  }
  .sm\\:bottom-1\\/5 {
    bottom: 20%;
  }
  .sm\\:left-1\\/5 {
    left: 20%;
  }
  .sm\\:top-2\\/5 {
    top: 40%;
  }
  .sm\\:right-2\\/5 {
    right: 40%;
  }
  .sm\\:bottom-2\\/5 {
    bottom: 40%;
  }
  .sm\\:left-2\\/5 {
    left: 40%;
  }
  .sm\\:top-3\\/5 {
    top: 60%;
  }
  .sm\\:right-3\\/5 {
    right: 60%;
  }
  .sm\\:bottom-3\\/5 {
    bottom: 60%;
  }
  .sm\\:left-3\\/5 {
    left: 60%;
  }
  .sm\\:top-4\\/5 {
    top: 80%;
  }
  .sm\\:right-4\\/5 {
    right: 80%;
  }
  .sm\\:bottom-4\\/5 {
    bottom: 80%;
  }
  .sm\\:left-4\\/5 {
    left: 80%;
  }
  .sm\\:top-1\\/6 {
    top: 16.666667%;
  }
  .sm\\:right-1\\/6 {
    right: 16.666667%;
  }
  .sm\\:bottom-1\\/6 {
    bottom: 16.666667%;
  }
  .sm\\:left-1\\/6 {
    left: 16.666667%;
  }
  .sm\\:top-2\\/6 {
    top: 33.333333%;
  }
  .sm\\:right-2\\/6 {
    right: 33.333333%;
  }
  .sm\\:bottom-2\\/6 {
    bottom: 33.333333%;
  }
  .sm\\:left-2\\/6 {
    left: 33.333333%;
  }
  .sm\\:top-3\\/6 {
    top: 50%;
  }
  .sm\\:right-3\\/6 {
    right: 50%;
  }
  .sm\\:bottom-3\\/6 {
    bottom: 50%;
  }
  .sm\\:left-3\\/6 {
    left: 50%;
  }
  .sm\\:top-4\\/6 {
    top: 66.666667%;
  }
  .sm\\:right-4\\/6 {
    right: 66.666667%;
  }
  .sm\\:bottom-4\\/6 {
    bottom: 66.666667%;
  }
  .sm\\:left-4\\/6 {
    left: 66.666667%;
  }
  .sm\\:top-5\\/6 {
    top: 83.333333%;
  }
  .sm\\:right-5\\/6 {
    right: 83.333333%;
  }
  .sm\\:bottom-5\\/6 {
    bottom: 83.333333%;
  }
  .sm\\:left-5\\/6 {
    left: 83.333333%;
  }
  .sm\\:top-1\\/12 {
    top: 8.333333%;
  }
  .sm\\:right-1\\/12 {
    right: 8.333333%;
  }
  .sm\\:bottom-1\\/12 {
    bottom: 8.333333%;
  }
  .sm\\:left-1\\/12 {
    left: 8.333333%;
  }
  .sm\\:top-2\\/12 {
    top: 16.666667%;
  }
  .sm\\:right-2\\/12 {
    right: 16.666667%;
  }
  .sm\\:bottom-2\\/12 {
    bottom: 16.666667%;
  }
  .sm\\:left-2\\/12 {
    left: 16.666667%;
  }
  .sm\\:top-3\\/12 {
    top: 25%;
  }
  .sm\\:right-3\\/12 {
    right: 25%;
  }
  .sm\\:bottom-3\\/12 {
    bottom: 25%;
  }
  .sm\\:left-3\\/12 {
    left: 25%;
  }
  .sm\\:top-4\\/12 {
    top: 33.333333%;
  }
  .sm\\:right-4\\/12 {
    right: 33.333333%;
  }
  .sm\\:bottom-4\\/12 {
    bottom: 33.333333%;
  }
  .sm\\:left-4\\/12 {
    left: 33.333333%;
  }
  .sm\\:top-5\\/12 {
    top: 41.666667%;
  }
  .sm\\:right-5\\/12 {
    right: 41.666667%;
  }
  .sm\\:bottom-5\\/12 {
    bottom: 41.666667%;
  }
  .sm\\:left-5\\/12 {
    left: 41.666667%;
  }
  .sm\\:top-6\\/12 {
    top: 50%;
  }
  .sm\\:right-6\\/12 {
    right: 50%;
  }
  .sm\\:bottom-6\\/12 {
    bottom: 50%;
  }
  .sm\\:left-6\\/12 {
    left: 50%;
  }
  .sm\\:top-7\\/12 {
    top: 58.333333%;
  }
  .sm\\:right-7\\/12 {
    right: 58.333333%;
  }
  .sm\\:bottom-7\\/12 {
    bottom: 58.333333%;
  }
  .sm\\:left-7\\/12 {
    left: 58.333333%;
  }
  .sm\\:top-8\\/12 {
    top: 66.666667%;
  }
  .sm\\:right-8\\/12 {
    right: 66.666667%;
  }
  .sm\\:bottom-8\\/12 {
    bottom: 66.666667%;
  }
  .sm\\:left-8\\/12 {
    left: 66.666667%;
  }
  .sm\\:top-9\\/12 {
    top: 75%;
  }
  .sm\\:right-9\\/12 {
    right: 75%;
  }
  .sm\\:bottom-9\\/12 {
    bottom: 75%;
  }
  .sm\\:left-9\\/12 {
    left: 75%;
  }
  .sm\\:top-10\\/12 {
    top: 83.333333%;
  }
  .sm\\:right-10\\/12 {
    right: 83.333333%;
  }
  .sm\\:bottom-10\\/12 {
    bottom: 83.333333%;
  }
  .sm\\:left-10\\/12 {
    left: 83.333333%;
  }
  .sm\\:top-11\\/12 {
    top: 91.666667%;
  }
  .sm\\:right-11\\/12 {
    right: 91.666667%;
  }
  .sm\\:bottom-11\\/12 {
    bottom: 91.666667%;
  }
  .sm\\:left-11\\/12 {
    left: 91.666667%;
  }
  .sm\\:top-full {
    top: 100%;
  }
  .sm\\:right-full {
    right: 100%;
  }
  .sm\\:bottom-full {
    bottom: 100%;
  }
  .sm\\:left-full {
    left: 100%;
  }
  .sm\\:resize-none {
    resize: none;
  }
  .sm\\:resize-y {
    resize: vertical;
  }
  .sm\\:resize-x {
    resize: horizontal;
  }
  .sm\\:resize {
    resize: both;
  }
  .sm\\:shadow-xs {
    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.05);
  }
  .sm\\:shadow-sm {
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  }
  .sm\\:shadow {
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
  }
  .sm\\:shadow-md {
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  }
  .sm\\:shadow-lg {
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
  }
  .sm\\:shadow-xl {
    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  }
  .sm\\:shadow-2xl {
    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  }
  .sm\\:shadow-inner {
    box-shadow: inset 0 2px 4px 0 rgba(0, 0, 0, 0.06);
  }
  .sm\\:shadow-outline {
    box-shadow: 0 0 0 3px rgba(118, 169, 250, 0.45);
  }
  .sm\\:shadow-none {
    box-shadow: none;
  }
  .sm\\:shadow-solid {
    box-shadow: 0 0 0 2px currentColor;
  }
  .sm\\:shadow-outline-gray {
    box-shadow: 0 0 0 3px rgba(159, 166, 178, 0.45);
  }
  .sm\\:shadow-outline-blue {
    box-shadow: 0 0 0 3px rgba(164, 202, 254, 0.45);
  }
  .sm\\:shadow-outline-teal {
    box-shadow: 0 0 0 3px rgba(126, 220, 226, 0.45);
  }
  .sm\\:shadow-outline-green {
    box-shadow: 0 0 0 3px rgba(132, 225, 188, 0.45);
  }
  .sm\\:shadow-outline-yellow {
    box-shadow: 0 0 0 3px rgba(250, 202, 21, 0.45);
  }
  .sm\\:shadow-outline-orange {
    box-shadow: 0 0 0 3px rgba(253, 186, 140, 0.45);
  }
  .sm\\:shadow-outline-red {
    box-shadow: 0 0 0 3px rgba(248, 180, 180, 0.45);
  }
  .sm\\:shadow-outline-pink {
    box-shadow: 0 0 0 3px rgba(248, 180, 217, 0.45);
  }
  .sm\\:shadow-outline-purple {
    box-shadow: 0 0 0 3px rgba(202, 191, 253, 0.45);
  }
  .sm\\:shadow-outline-indigo {
    box-shadow: 0 0 0 3px rgba(180, 198, 252, 0.45);
  }
  .group:focus .sm\\:group-focus\\:shadow-xs {
    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.05);
  }
  .group:focus .sm\\:group-focus\\:shadow-sm {
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  }
  .group:focus .sm\\:group-focus\\:shadow {
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
  }
  .group:focus .sm\\:group-focus\\:shadow-md {
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  }
  .group:focus .sm\\:group-focus\\:shadow-lg {
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
  }
  .group:focus .sm\\:group-focus\\:shadow-xl {
    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  }
  .group:focus .sm\\:group-focus\\:shadow-2xl {
    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  }
  .group:focus .sm\\:group-focus\\:shadow-inner {
    box-shadow: inset 0 2px 4px 0 rgba(0, 0, 0, 0.06);
  }
  .group:focus .sm\\:group-focus\\:shadow-outline {
    box-shadow: 0 0 0 3px rgba(118, 169, 250, 0.45);
  }
  .group:focus .sm\\:group-focus\\:shadow-none {
    box-shadow: none;
  }
  .group:focus .sm\\:group-focus\\:shadow-solid {
    box-shadow: 0 0 0 2px currentColor;
  }
  .group:focus .sm\\:group-focus\\:shadow-outline-gray {
    box-shadow: 0 0 0 3px rgba(159, 166, 178, 0.45);
  }
  .group:focus .sm\\:group-focus\\:shadow-outline-blue {
    box-shadow: 0 0 0 3px rgba(164, 202, 254, 0.45);
  }
  .group:focus .sm\\:group-focus\\:shadow-outline-teal {
    box-shadow: 0 0 0 3px rgba(126, 220, 226, 0.45);
  }
  .group:focus .sm\\:group-focus\\:shadow-outline-green {
    box-shadow: 0 0 0 3px rgba(132, 225, 188, 0.45);
  }
  .group:focus .sm\\:group-focus\\:shadow-outline-yellow {
    box-shadow: 0 0 0 3px rgba(250, 202, 21, 0.45);
  }
  .group:focus .sm\\:group-focus\\:shadow-outline-orange {
    box-shadow: 0 0 0 3px rgba(253, 186, 140, 0.45);
  }
  .group:focus .sm\\:group-focus\\:shadow-outline-red {
    box-shadow: 0 0 0 3px rgba(248, 180, 180, 0.45);
  }
  .group:focus .sm\\:group-focus\\:shadow-outline-pink {
    box-shadow: 0 0 0 3px rgba(248, 180, 217, 0.45);
  }
  .group:focus .sm\\:group-focus\\:shadow-outline-purple {
    box-shadow: 0 0 0 3px rgba(202, 191, 253, 0.45);
  }
  .group:focus .sm\\:group-focus\\:shadow-outline-indigo {
    box-shadow: 0 0 0 3px rgba(180, 198, 252, 0.45);
  }
  .sm\\:hover\\:shadow-xs:hover {
    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.05);
  }
  .sm\\:hover\\:shadow-sm:hover {
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  }
  .sm\\:hover\\:shadow:hover {
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
  }
  .sm\\:hover\\:shadow-md:hover {
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  }
  .sm\\:hover\\:shadow-lg:hover {
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
  }
  .sm\\:hover\\:shadow-xl:hover {
    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  }
  .sm\\:hover\\:shadow-2xl:hover {
    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  }
  .sm\\:hover\\:shadow-inner:hover {
    box-shadow: inset 0 2px 4px 0 rgba(0, 0, 0, 0.06);
  }
  .sm\\:hover\\:shadow-outline:hover {
    box-shadow: 0 0 0 3px rgba(118, 169, 250, 0.45);
  }
  .sm\\:hover\\:shadow-none:hover {
    box-shadow: none;
  }
  .sm\\:hover\\:shadow-solid:hover {
    box-shadow: 0 0 0 2px currentColor;
  }
  .sm\\:hover\\:shadow-outline-gray:hover {
    box-shadow: 0 0 0 3px rgba(159, 166, 178, 0.45);
  }
  .sm\\:hover\\:shadow-outline-blue:hover {
    box-shadow: 0 0 0 3px rgba(164, 202, 254, 0.45);
  }
  .sm\\:hover\\:shadow-outline-teal:hover {
    box-shadow: 0 0 0 3px rgba(126, 220, 226, 0.45);
  }
  .sm\\:hover\\:shadow-outline-green:hover {
    box-shadow: 0 0 0 3px rgba(132, 225, 188, 0.45);
  }
  .sm\\:hover\\:shadow-outline-yellow:hover {
    box-shadow: 0 0 0 3px rgba(250, 202, 21, 0.45);
  }
  .sm\\:hover\\:shadow-outline-orange:hover {
    box-shadow: 0 0 0 3px rgba(253, 186, 140, 0.45);
  }
  .sm\\:hover\\:shadow-outline-red:hover {
    box-shadow: 0 0 0 3px rgba(248, 180, 180, 0.45);
  }
  .sm\\:hover\\:shadow-outline-pink:hover {
    box-shadow: 0 0 0 3px rgba(248, 180, 217, 0.45);
  }
  .sm\\:hover\\:shadow-outline-purple:hover {
    box-shadow: 0 0 0 3px rgba(202, 191, 253, 0.45);
  }
  .sm\\:hover\\:shadow-outline-indigo:hover {
    box-shadow: 0 0 0 3px rgba(180, 198, 252, 0.45);
  }
  .sm\\:focus-within\\:shadow-xs:focus-within {
    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.05);
  }
  .sm\\:focus-within\\:shadow-sm:focus-within {
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  }
  .sm\\:focus-within\\:shadow:focus-within {
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
  }
  .sm\\:focus-within\\:shadow-md:focus-within {
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  }
  .sm\\:focus-within\\:shadow-lg:focus-within {
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
  }
  .sm\\:focus-within\\:shadow-xl:focus-within {
    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  }
  .sm\\:focus-within\\:shadow-2xl:focus-within {
    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  }
  .sm\\:focus-within\\:shadow-inner:focus-within {
    box-shadow: inset 0 2px 4px 0 rgba(0, 0, 0, 0.06);
  }
  .sm\\:focus-within\\:shadow-outline:focus-within {
    box-shadow: 0 0 0 3px rgba(118, 169, 250, 0.45);
  }
  .sm\\:focus-within\\:shadow-none:focus-within {
    box-shadow: none;
  }
  .sm\\:focus-within\\:shadow-solid:focus-within {
    box-shadow: 0 0 0 2px currentColor;
  }
  .sm\\:focus-within\\:shadow-outline-gray:focus-within {
    box-shadow: 0 0 0 3px rgba(159, 166, 178, 0.45);
  }
  .sm\\:focus-within\\:shadow-outline-blue:focus-within {
    box-shadow: 0 0 0 3px rgba(164, 202, 254, 0.45);
  }
  .sm\\:focus-within\\:shadow-outline-teal:focus-within {
    box-shadow: 0 0 0 3px rgba(126, 220, 226, 0.45);
  }
  .sm\\:focus-within\\:shadow-outline-green:focus-within {
    box-shadow: 0 0 0 3px rgba(132, 225, 188, 0.45);
  }
  .sm\\:focus-within\\:shadow-outline-yellow:focus-within {
    box-shadow: 0 0 0 3px rgba(250, 202, 21, 0.45);
  }
  .sm\\:focus-within\\:shadow-outline-orange:focus-within {
    box-shadow: 0 0 0 3px rgba(253, 186, 140, 0.45);
  }
  .sm\\:focus-within\\:shadow-outline-red:focus-within {
    box-shadow: 0 0 0 3px rgba(248, 180, 180, 0.45);
  }
  .sm\\:focus-within\\:shadow-outline-pink:focus-within {
    box-shadow: 0 0 0 3px rgba(248, 180, 217, 0.45);
  }
  .sm\\:focus-within\\:shadow-outline-purple:focus-within {
    box-shadow: 0 0 0 3px rgba(202, 191, 253, 0.45);
  }
  .sm\\:focus-within\\:shadow-outline-indigo:focus-within {
    box-shadow: 0 0 0 3px rgba(180, 198, 252, 0.45);
  }
  .sm\\:focus\\:shadow-xs:focus {
    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.05);
  }
  .sm\\:focus\\:shadow-sm:focus {
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  }
  .sm\\:focus\\:shadow:focus {
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
  }
  .sm\\:focus\\:shadow-md:focus {
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  }
  .sm\\:focus\\:shadow-lg:focus {
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
  }
  .sm\\:focus\\:shadow-xl:focus {
    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  }
  .sm\\:focus\\:shadow-2xl:focus {
    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  }
  .sm\\:focus\\:shadow-inner:focus {
    box-shadow: inset 0 2px 4px 0 rgba(0, 0, 0, 0.06);
  }
  .sm\\:focus\\:shadow-outline:focus {
    box-shadow: 0 0 0 3px rgba(118, 169, 250, 0.45);
  }
  .sm\\:focus\\:shadow-none:focus {
    box-shadow: none;
  }
  .sm\\:focus\\:shadow-solid:focus {
    box-shadow: 0 0 0 2px currentColor;
  }
  .sm\\:focus\\:shadow-outline-gray:focus {
    box-shadow: 0 0 0 3px rgba(159, 166, 178, 0.45);
  }
  .sm\\:focus\\:shadow-outline-blue:focus {
    box-shadow: 0 0 0 3px rgba(164, 202, 254, 0.45);
  }
  .sm\\:focus\\:shadow-outline-teal:focus {
    box-shadow: 0 0 0 3px rgba(126, 220, 226, 0.45);
  }
  .sm\\:focus\\:shadow-outline-green:focus {
    box-shadow: 0 0 0 3px rgba(132, 225, 188, 0.45);
  }
  .sm\\:focus\\:shadow-outline-yellow:focus {
    box-shadow: 0 0 0 3px rgba(250, 202, 21, 0.45);
  }
  .sm\\:focus\\:shadow-outline-orange:focus {
    box-shadow: 0 0 0 3px rgba(253, 186, 140, 0.45);
  }
  .sm\\:focus\\:shadow-outline-red:focus {
    box-shadow: 0 0 0 3px rgba(248, 180, 180, 0.45);
  }
  .sm\\:focus\\:shadow-outline-pink:focus {
    box-shadow: 0 0 0 3px rgba(248, 180, 217, 0.45);
  }
  .sm\\:focus\\:shadow-outline-purple:focus {
    box-shadow: 0 0 0 3px rgba(202, 191, 253, 0.45);
  }
  .sm\\:focus\\:shadow-outline-indigo:focus {
    box-shadow: 0 0 0 3px rgba(180, 198, 252, 0.45);
  }
  .sm\\:fill-current {
    fill: currentColor;
  }
  .sm\\:stroke-current {
    stroke: currentColor;
  }
  .sm\\:stroke-0 {
    stroke-width: 0;
  }
  .sm\\:stroke-1 {
    stroke-width: 1;
  }
  .sm\\:stroke-2 {
    stroke-width: 2;
  }
  .sm\\:table-auto {
    table-layout: auto;
  }
  .sm\\:table-fixed {
    table-layout: fixed;
  }
  .sm\\:text-left {
    text-align: left;
  }
  .sm\\:text-center {
    text-align: center;
  }
  .sm\\:text-right {
    text-align: right;
  }
  .sm\\:text-justify {
    text-align: justify;
  }
  .sm\\:text-current {
    color: currentColor;
  }
  .sm\\:text-transparent {
    color: transparent;
  }
  .sm\\:text-white {
    --text-opacity: 1;
    color: #ffffff;
    color: rgba(255, 255, 255, var(--text-opacity));
  }
  .sm\\:text-black {
    --text-opacity: 1;
    color: #000000;
    color: rgba(0, 0, 0, var(--text-opacity));
  }
  .sm\\:text-gray-50 {
    --text-opacity: 1;
    color: #f9fafb;
    color: rgba(249, 250, 251, var(--text-opacity));
  }
  .sm\\:text-gray-100 {
    --text-opacity: 1;
    color: #f4f5f7;
    color: rgba(244, 245, 247, var(--text-opacity));
  }
  .sm\\:text-gray-200 {
    --text-opacity: 1;
    color: #e5e7eb;
    color: rgba(229, 231, 235, var(--text-opacity));
  }
  .sm\\:text-gray-300 {
    --text-opacity: 1;
    color: #d2d6dc;
    color: rgba(210, 214, 220, var(--text-opacity));
  }
  .sm\\:text-gray-400 {
    --text-opacity: 1;
    color: #9fa6b2;
    color: rgba(159, 166, 178, var(--text-opacity));
  }
  .sm\\:text-gray-500 {
    --text-opacity: 1;
    color: #6b7280;
    color: rgba(107, 114, 128, var(--text-opacity));
  }
  .sm\\:text-gray-600 {
    --text-opacity: 1;
    color: #4b5563;
    color: rgba(75, 85, 99, var(--text-opacity));
  }
  .sm\\:text-gray-700 {
    --text-opacity: 1;
    color: #374151;
    color: rgba(55, 65, 81, var(--text-opacity));
  }
  .sm\\:text-gray-800 {
    --text-opacity: 1;
    color: #252f3f;
    color: rgba(37, 47, 63, var(--text-opacity));
  }
  .sm\\:text-gray-900 {
    --text-opacity: 1;
    color: #161e2e;
    color: rgba(22, 30, 46, var(--text-opacity));
  }
  .sm\\:text-red-50 {
    --text-opacity: 1;
    color: #fdf2f2;
    color: rgba(253, 242, 242, var(--text-opacity));
  }
  .sm\\:text-red-100 {
    --text-opacity: 1;
    color: #fde8e8;
    color: rgba(253, 232, 232, var(--text-opacity));
  }
  .sm\\:text-red-200 {
    --text-opacity: 1;
    color: #fbd5d5;
    color: rgba(251, 213, 213, var(--text-opacity));
  }
  .sm\\:text-red-300 {
    --text-opacity: 1;
    color: #f8b4b4;
    color: rgba(248, 180, 180, var(--text-opacity));
  }
  .sm\\:text-red-400 {
    --text-opacity: 1;
    color: #f98080;
    color: rgba(249, 128, 128, var(--text-opacity));
  }
  .sm\\:text-red-500 {
    --text-opacity: 1;
    color: #f05252;
    color: rgba(240, 82, 82, var(--text-opacity));
  }
  .sm\\:text-red-600 {
    --text-opacity: 1;
    color: #e02424;
    color: rgba(224, 36, 36, var(--text-opacity));
  }
  .sm\\:text-red-700 {
    --text-opacity: 1;
    color: #c81e1e;
    color: rgba(200, 30, 30, var(--text-opacity));
  }
  .sm\\:text-red-800 {
    --text-opacity: 1;
    color: #9b1c1c;
    color: rgba(155, 28, 28, var(--text-opacity));
  }
  .sm\\:text-red-900 {
    --text-opacity: 1;
    color: #771d1d;
    color: rgba(119, 29, 29, var(--text-opacity));
  }
  .sm\\:text-orange-50 {
    --text-opacity: 1;
    color: #fff8f1;
    color: rgba(255, 248, 241, var(--text-opacity));
  }
  .sm\\:text-orange-100 {
    --text-opacity: 1;
    color: #feecdc;
    color: rgba(254, 236, 220, var(--text-opacity));
  }
  .sm\\:text-orange-200 {
    --text-opacity: 1;
    color: #fcd9bd;
    color: rgba(252, 217, 189, var(--text-opacity));
  }
  .sm\\:text-orange-300 {
    --text-opacity: 1;
    color: #fdba8c;
    color: rgba(253, 186, 140, var(--text-opacity));
  }
  .sm\\:text-orange-400 {
    --text-opacity: 1;
    color: #ff8a4c;
    color: rgba(255, 138, 76, var(--text-opacity));
  }
  .sm\\:text-orange-500 {
    --text-opacity: 1;
    color: #ff5a1f;
    color: rgba(255, 90, 31, var(--text-opacity));
  }
  .sm\\:text-orange-600 {
    --text-opacity: 1;
    color: #d03801;
    color: rgba(208, 56, 1, var(--text-opacity));
  }
  .sm\\:text-orange-700 {
    --text-opacity: 1;
    color: #b43403;
    color: rgba(180, 52, 3, var(--text-opacity));
  }
  .sm\\:text-orange-800 {
    --text-opacity: 1;
    color: #8a2c0d;
    color: rgba(138, 44, 13, var(--text-opacity));
  }
  .sm\\:text-orange-900 {
    --text-opacity: 1;
    color: #73230d;
    color: rgba(115, 35, 13, var(--text-opacity));
  }
  .sm\\:text-yellow-50 {
    --text-opacity: 1;
    color: #fdfdea;
    color: rgba(253, 253, 234, var(--text-opacity));
  }
  .sm\\:text-yellow-100 {
    --text-opacity: 1;
    color: #fdf6b2;
    color: rgba(253, 246, 178, var(--text-opacity));
  }
  .sm\\:text-yellow-200 {
    --text-opacity: 1;
    color: #fce96a;
    color: rgba(252, 233, 106, var(--text-opacity));
  }
  .sm\\:text-yellow-300 {
    --text-opacity: 1;
    color: #faca15;
    color: rgba(250, 202, 21, var(--text-opacity));
  }
  .sm\\:text-yellow-400 {
    --text-opacity: 1;
    color: #e3a008;
    color: rgba(227, 160, 8, var(--text-opacity));
  }
  .sm\\:text-yellow-500 {
    --text-opacity: 1;
    color: #c27803;
    color: rgba(194, 120, 3, var(--text-opacity));
  }
  .sm\\:text-yellow-600 {
    --text-opacity: 1;
    color: #9f580a;
    color: rgba(159, 88, 10, var(--text-opacity));
  }
  .sm\\:text-yellow-700 {
    --text-opacity: 1;
    color: #8e4b10;
    color: rgba(142, 75, 16, var(--text-opacity));
  }
  .sm\\:text-yellow-800 {
    --text-opacity: 1;
    color: #723b13;
    color: rgba(114, 59, 19, var(--text-opacity));
  }
  .sm\\:text-yellow-900 {
    --text-opacity: 1;
    color: #633112;
    color: rgba(99, 49, 18, var(--text-opacity));
  }
  .sm\\:text-green-50 {
    --text-opacity: 1;
    color: #f3faf7;
    color: rgba(243, 250, 247, var(--text-opacity));
  }
  .sm\\:text-green-100 {
    --text-opacity: 1;
    color: #def7ec;
    color: rgba(222, 247, 236, var(--text-opacity));
  }
  .sm\\:text-green-200 {
    --text-opacity: 1;
    color: #bcf0da;
    color: rgba(188, 240, 218, var(--text-opacity));
  }
  .sm\\:text-green-300 {
    --text-opacity: 1;
    color: #84e1bc;
    color: rgba(132, 225, 188, var(--text-opacity));
  }
  .sm\\:text-green-400 {
    --text-opacity: 1;
    color: #31c48d;
    color: rgba(49, 196, 141, var(--text-opacity));
  }
  .sm\\:text-green-500 {
    --text-opacity: 1;
    color: #0e9f6e;
    color: rgba(14, 159, 110, var(--text-opacity));
  }
  .sm\\:text-green-600 {
    --text-opacity: 1;
    color: #057a55;
    color: rgba(5, 122, 85, var(--text-opacity));
  }
  .sm\\:text-green-700 {
    --text-opacity: 1;
    color: #046c4e;
    color: rgba(4, 108, 78, var(--text-opacity));
  }
  .sm\\:text-green-800 {
    --text-opacity: 1;
    color: #03543f;
    color: rgba(3, 84, 63, var(--text-opacity));
  }
  .sm\\:text-green-900 {
    --text-opacity: 1;
    color: #014737;
    color: rgba(1, 71, 55, var(--text-opacity));
  }
  .sm\\:text-teal-50 {
    --text-opacity: 1;
    color: #edfafa;
    color: rgba(237, 250, 250, var(--text-opacity));
  }
  .sm\\:text-teal-100 {
    --text-opacity: 1;
    color: #d5f5f6;
    color: rgba(213, 245, 246, var(--text-opacity));
  }
  .sm\\:text-teal-200 {
    --text-opacity: 1;
    color: #afecef;
    color: rgba(175, 236, 239, var(--text-opacity));
  }
  .sm\\:text-teal-300 {
    --text-opacity: 1;
    color: #7edce2;
    color: rgba(126, 220, 226, var(--text-opacity));
  }
  .sm\\:text-teal-400 {
    --text-opacity: 1;
    color: #16bdca;
    color: rgba(22, 189, 202, var(--text-opacity));
  }
  .sm\\:text-teal-500 {
    --text-opacity: 1;
    color: #0694a2;
    color: rgba(6, 148, 162, var(--text-opacity));
  }
  .sm\\:text-teal-600 {
    --text-opacity: 1;
    color: #047481;
    color: rgba(4, 116, 129, var(--text-opacity));
  }
  .sm\\:text-teal-700 {
    --text-opacity: 1;
    color: #036672;
    color: rgba(3, 102, 114, var(--text-opacity));
  }
  .sm\\:text-teal-800 {
    --text-opacity: 1;
    color: #05505c;
    color: rgba(5, 80, 92, var(--text-opacity));
  }
  .sm\\:text-teal-900 {
    --text-opacity: 1;
    color: #014451;
    color: rgba(1, 68, 81, var(--text-opacity));
  }
  .sm\\:text-blue-50 {
    --text-opacity: 1;
    color: #ebf5ff;
    color: rgba(235, 245, 255, var(--text-opacity));
  }
  .sm\\:text-blue-100 {
    --text-opacity: 1;
    color: #e1effe;
    color: rgba(225, 239, 254, var(--text-opacity));
  }
  .sm\\:text-blue-200 {
    --text-opacity: 1;
    color: #c3ddfd;
    color: rgba(195, 221, 253, var(--text-opacity));
  }
  .sm\\:text-blue-300 {
    --text-opacity: 1;
    color: #a4cafe;
    color: rgba(164, 202, 254, var(--text-opacity));
  }
  .sm\\:text-blue-400 {
    --text-opacity: 1;
    color: #76a9fa;
    color: rgba(118, 169, 250, var(--text-opacity));
  }
  .sm\\:text-blue-500 {
    --text-opacity: 1;
    color: #3f83f8;
    color: rgba(63, 131, 248, var(--text-opacity));
  }
  .sm\\:text-blue-600 {
    --text-opacity: 1;
    color: #1c64f2;
    color: rgba(28, 100, 242, var(--text-opacity));
  }
  .sm\\:text-blue-700 {
    --text-opacity: 1;
    color: #1a56db;
    color: rgba(26, 86, 219, var(--text-opacity));
  }
  .sm\\:text-blue-800 {
    --text-opacity: 1;
    color: #1e429f;
    color: rgba(30, 66, 159, var(--text-opacity));
  }
  .sm\\:text-blue-900 {
    --text-opacity: 1;
    color: #233876;
    color: rgba(35, 56, 118, var(--text-opacity));
  }
  .sm\\:text-indigo-50 {
    --text-opacity: 1;
    color: #f0f5ff;
    color: rgba(240, 245, 255, var(--text-opacity));
  }
  .sm\\:text-indigo-100 {
    --text-opacity: 1;
    color: #e5edff;
    color: rgba(229, 237, 255, var(--text-opacity));
  }
  .sm\\:text-indigo-200 {
    --text-opacity: 1;
    color: #cddbfe;
    color: rgba(205, 219, 254, var(--text-opacity));
  }
  .sm\\:text-indigo-300 {
    --text-opacity: 1;
    color: #b4c6fc;
    color: rgba(180, 198, 252, var(--text-opacity));
  }
  .sm\\:text-indigo-400 {
    --text-opacity: 1;
    color: #8da2fb;
    color: rgba(141, 162, 251, var(--text-opacity));
  }
  .sm\\:text-indigo-500 {
    --text-opacity: 1;
    color: #6875f5;
    color: rgba(104, 117, 245, var(--text-opacity));
  }
  .sm\\:text-indigo-600 {
    --text-opacity: 1;
    color: #5850ec;
    color: rgba(88, 80, 236, var(--text-opacity));
  }
  .sm\\:text-indigo-700 {
    --text-opacity: 1;
    color: #5145cd;
    color: rgba(81, 69, 205, var(--text-opacity));
  }
  .sm\\:text-indigo-800 {
    --text-opacity: 1;
    color: #42389d;
    color: rgba(66, 56, 157, var(--text-opacity));
  }
  .sm\\:text-indigo-900 {
    --text-opacity: 1;
    color: #362f78;
    color: rgba(54, 47, 120, var(--text-opacity));
  }
  .sm\\:text-purple-50 {
    --text-opacity: 1;
    color: #f6f5ff;
    color: rgba(246, 245, 255, var(--text-opacity));
  }
  .sm\\:text-purple-100 {
    --text-opacity: 1;
    color: #edebfe;
    color: rgba(237, 235, 254, var(--text-opacity));
  }
  .sm\\:text-purple-200 {
    --text-opacity: 1;
    color: #dcd7fe;
    color: rgba(220, 215, 254, var(--text-opacity));
  }
  .sm\\:text-purple-300 {
    --text-opacity: 1;
    color: #cabffd;
    color: rgba(202, 191, 253, var(--text-opacity));
  }
  .sm\\:text-purple-400 {
    --text-opacity: 1;
    color: #ac94fa;
    color: rgba(172, 148, 250, var(--text-opacity));
  }
  .sm\\:text-purple-500 {
    --text-opacity: 1;
    color: #9061f9;
    color: rgba(144, 97, 249, var(--text-opacity));
  }
  .sm\\:text-purple-600 {
    --text-opacity: 1;
    color: #7e3af2;
    color: rgba(126, 58, 242, var(--text-opacity));
  }
  .sm\\:text-purple-700 {
    --text-opacity: 1;
    color: #6c2bd9;
    color: rgba(108, 43, 217, var(--text-opacity));
  }
  .sm\\:text-purple-800 {
    --text-opacity: 1;
    color: #5521b5;
    color: rgba(85, 33, 181, var(--text-opacity));
  }
  .sm\\:text-purple-900 {
    --text-opacity: 1;
    color: #4a1d96;
    color: rgba(74, 29, 150, var(--text-opacity));
  }
  .sm\\:text-pink-50 {
    --text-opacity: 1;
    color: #fdf2f8;
    color: rgba(253, 242, 248, var(--text-opacity));
  }
  .sm\\:text-pink-100 {
    --text-opacity: 1;
    color: #fce8f3;
    color: rgba(252, 232, 243, var(--text-opacity));
  }
  .sm\\:text-pink-200 {
    --text-opacity: 1;
    color: #fad1e8;
    color: rgba(250, 209, 232, var(--text-opacity));
  }
  .sm\\:text-pink-300 {
    --text-opacity: 1;
    color: #f8b4d9;
    color: rgba(248, 180, 217, var(--text-opacity));
  }
  .sm\\:text-pink-400 {
    --text-opacity: 1;
    color: #f17eb8;
    color: rgba(241, 126, 184, var(--text-opacity));
  }
  .sm\\:text-pink-500 {
    --text-opacity: 1;
    color: #e74694;
    color: rgba(231, 70, 148, var(--text-opacity));
  }
  .sm\\:text-pink-600 {
    --text-opacity: 1;
    color: #d61f69;
    color: rgba(214, 31, 105, var(--text-opacity));
  }
  .sm\\:text-pink-700 {
    --text-opacity: 1;
    color: #bf125d;
    color: rgba(191, 18, 93, var(--text-opacity));
  }
  .sm\\:text-pink-800 {
    --text-opacity: 1;
    color: #99154b;
    color: rgba(153, 21, 75, var(--text-opacity));
  }
  .sm\\:text-pink-900 {
    --text-opacity: 1;
    color: #751a3d;
    color: rgba(117, 26, 61, var(--text-opacity));
  }
  .sm\\:text-cool-gray-50 {
    --text-opacity: 1;
    color: #f8fafc;
    color: rgba(248, 250, 252, var(--text-opacity));
  }
  .sm\\:text-cool-gray-100 {
    --text-opacity: 1;
    color: #f1f5f9;
    color: rgba(241, 245, 249, var(--text-opacity));
  }
  .sm\\:text-cool-gray-200 {
    --text-opacity: 1;
    color: #e2e8f0;
    color: rgba(226, 232, 240, var(--text-opacity));
  }
  .sm\\:text-cool-gray-300 {
    --text-opacity: 1;
    color: #cfd8e3;
    color: rgba(207, 216, 227, var(--text-opacity));
  }
  .sm\\:text-cool-gray-400 {
    --text-opacity: 1;
    color: #97a6ba;
    color: rgba(151, 166, 186, var(--text-opacity));
  }
  .sm\\:text-cool-gray-500 {
    --text-opacity: 1;
    color: #64748b;
    color: rgba(100, 116, 139, var(--text-opacity));
  }
  .sm\\:text-cool-gray-600 {
    --text-opacity: 1;
    color: #475569;
    color: rgba(71, 85, 105, var(--text-opacity));
  }
  .sm\\:text-cool-gray-700 {
    --text-opacity: 1;
    color: #364152;
    color: rgba(54, 65, 82, var(--text-opacity));
  }
  .sm\\:text-cool-gray-800 {
    --text-opacity: 1;
    color: #27303f;
    color: rgba(39, 48, 63, var(--text-opacity));
  }
  .sm\\:text-cool-gray-900 {
    --text-opacity: 1;
    color: #1a202e;
    color: rgba(26, 32, 46, var(--text-opacity));
  }
  .group:hover .sm\\:group-hover\\:text-current {
    color: currentColor;
  }
  .group:hover .sm\\:group-hover\\:text-transparent {
    color: transparent;
  }
  .group:hover .sm\\:group-hover\\:text-white {
    --text-opacity: 1;
    color: #ffffff;
    color: rgba(255, 255, 255, var(--text-opacity));
  }
  .group:hover .sm\\:group-hover\\:text-black {
    --text-opacity: 1;
    color: #000000;
    color: rgba(0, 0, 0, var(--text-opacity));
  }
  .group:hover .sm\\:group-hover\\:text-gray-50 {
    --text-opacity: 1;
    color: #f9fafb;
    color: rgba(249, 250, 251, var(--text-opacity));
  }
  .group:hover .sm\\:group-hover\\:text-gray-100 {
    --text-opacity: 1;
    color: #f4f5f7;
    color: rgba(244, 245, 247, var(--text-opacity));
  }
  .group:hover .sm\\:group-hover\\:text-gray-200 {
    --text-opacity: 1;
    color: #e5e7eb;
    color: rgba(229, 231, 235, var(--text-opacity));
  }
  .group:hover .sm\\:group-hover\\:text-gray-300 {
    --text-opacity: 1;
    color: #d2d6dc;
    color: rgba(210, 214, 220, var(--text-opacity));
  }
  .group:hover .sm\\:group-hover\\:text-gray-400 {
    --text-opacity: 1;
    color: #9fa6b2;
    color: rgba(159, 166, 178, var(--text-opacity));
  }
  .group:hover .sm\\:group-hover\\:text-gray-500 {
    --text-opacity: 1;
    color: #6b7280;
    color: rgba(107, 114, 128, var(--text-opacity));
  }
  .group:hover .sm\\:group-hover\\:text-gray-600 {
    --text-opacity: 1;
    color: #4b5563;
    color: rgba(75, 85, 99, var(--text-opacity));
  }
  .group:hover .sm\\:group-hover\\:text-gray-700 {
    --text-opacity: 1;
    color: #374151;
    color: rgba(55, 65, 81, var(--text-opacity));
  }
  .group:hover .sm\\:group-hover\\:text-gray-800 {
    --text-opacity: 1;
    color: #252f3f;
    color: rgba(37, 47, 63, var(--text-opacity));
  }
  .group:hover .sm\\:group-hover\\:text-gray-900 {
    --text-opacity: 1;
    color: #161e2e;
    color: rgba(22, 30, 46, var(--text-opacity));
  }
  .group:hover .sm\\:group-hover\\:text-red-50 {
    --text-opacity: 1;
    color: #fdf2f2;
    color: rgba(253, 242, 242, var(--text-opacity));
  }
  .group:hover .sm\\:group-hover\\:text-red-100 {
    --text-opacity: 1;
    color: #fde8e8;
    color: rgba(253, 232, 232, var(--text-opacity));
  }
  .group:hover .sm\\:group-hover\\:text-red-200 {
    --text-opacity: 1;
    color: #fbd5d5;
    color: rgba(251, 213, 213, var(--text-opacity));
  }
  .group:hover .sm\\:group-hover\\:text-red-300 {
    --text-opacity: 1;
    color: #f8b4b4;
    color: rgba(248, 180, 180, var(--text-opacity));
  }
  .group:hover .sm\\:group-hover\\:text-red-400 {
    --text-opacity: 1;
    color: #f98080;
    color: rgba(249, 128, 128, var(--text-opacity));
  }
  .group:hover .sm\\:group-hover\\:text-red-500 {
    --text-opacity: 1;
    color: #f05252;
    color: rgba(240, 82, 82, var(--text-opacity));
  }
  .group:hover .sm\\:group-hover\\:text-red-600 {
    --text-opacity: 1;
    color: #e02424;
    color: rgba(224, 36, 36, var(--text-opacity));
  }
  .group:hover .sm\\:group-hover\\:text-red-700 {
    --text-opacity: 1;
    color: #c81e1e;
    color: rgba(200, 30, 30, var(--text-opacity));
  }
  .group:hover .sm\\:group-hover\\:text-red-800 {
    --text-opacity: 1;
    color: #9b1c1c;
    color: rgba(155, 28, 28, var(--text-opacity));
  }
  .group:hover .sm\\:group-hover\\:text-red-900 {
    --text-opacity: 1;
    color: #771d1d;
    color: rgba(119, 29, 29, var(--text-opacity));
  }
  .group:hover .sm\\:group-hover\\:text-orange-50 {
    --text-opacity: 1;
    color: #fff8f1;
    color: rgba(255, 248, 241, var(--text-opacity));
  }
  .group:hover .sm\\:group-hover\\:text-orange-100 {
    --text-opacity: 1;
    color: #feecdc;
    color: rgba(254, 236, 220, var(--text-opacity));
  }
  .group:hover .sm\\:group-hover\\:text-orange-200 {
    --text-opacity: 1;
    color: #fcd9bd;
    color: rgba(252, 217, 189, var(--text-opacity));
  }
  .group:hover .sm\\:group-hover\\:text-orange-300 {
    --text-opacity: 1;
    color: #fdba8c;
    color: rgba(253, 186, 140, var(--text-opacity));
  }
  .group:hover .sm\\:group-hover\\:text-orange-400 {
    --text-opacity: 1;
    color: #ff8a4c;
    color: rgba(255, 138, 76, var(--text-opacity));
  }
  .group:hover .sm\\:group-hover\\:text-orange-500 {
    --text-opacity: 1;
    color: #ff5a1f;
    color: rgba(255, 90, 31, var(--text-opacity));
  }
  .group:hover .sm\\:group-hover\\:text-orange-600 {
    --text-opacity: 1;
    color: #d03801;
    color: rgba(208, 56, 1, var(--text-opacity));
  }
  .group:hover .sm\\:group-hover\\:text-orange-700 {
    --text-opacity: 1;
    color: #b43403;
    color: rgba(180, 52, 3, var(--text-opacity));
  }
  .group:hover .sm\\:group-hover\\:text-orange-800 {
    --text-opacity: 1;
    color: #8a2c0d;
    color: rgba(138, 44, 13, var(--text-opacity));
  }
  .group:hover .sm\\:group-hover\\:text-orange-900 {
    --text-opacity: 1;
    color: #73230d;
    color: rgba(115, 35, 13, var(--text-opacity));
  }
  .group:hover .sm\\:group-hover\\:text-yellow-50 {
    --text-opacity: 1;
    color: #fdfdea;
    color: rgba(253, 253, 234, var(--text-opacity));
  }
  .group:hover .sm\\:group-hover\\:text-yellow-100 {
    --text-opacity: 1;
    color: #fdf6b2;
    color: rgba(253, 246, 178, var(--text-opacity));
  }
  .group:hover .sm\\:group-hover\\:text-yellow-200 {
    --text-opacity: 1;
    color: #fce96a;
    color: rgba(252, 233, 106, var(--text-opacity));
  }
  .group:hover .sm\\:group-hover\\:text-yellow-300 {
    --text-opacity: 1;
    color: #faca15;
    color: rgba(250, 202, 21, var(--text-opacity));
  }
  .group:hover .sm\\:group-hover\\:text-yellow-400 {
    --text-opacity: 1;
    color: #e3a008;
    color: rgba(227, 160, 8, var(--text-opacity));
  }
  .group:hover .sm\\:group-hover\\:text-yellow-500 {
    --text-opacity: 1;
    color: #c27803;
    color: rgba(194, 120, 3, var(--text-opacity));
  }
  .group:hover .sm\\:group-hover\\:text-yellow-600 {
    --text-opacity: 1;
    color: #9f580a;
    color: rgba(159, 88, 10, var(--text-opacity));
  }
  .group:hover .sm\\:group-hover\\:text-yellow-700 {
    --text-opacity: 1;
    color: #8e4b10;
    color: rgba(142, 75, 16, var(--text-opacity));
  }
  .group:hover .sm\\:group-hover\\:text-yellow-800 {
    --text-opacity: 1;
    color: #723b13;
    color: rgba(114, 59, 19, var(--text-opacity));
  }
  .group:hover .sm\\:group-hover\\:text-yellow-900 {
    --text-opacity: 1;
    color: #633112;
    color: rgba(99, 49, 18, var(--text-opacity));
  }
  .group:hover .sm\\:group-hover\\:text-green-50 {
    --text-opacity: 1;
    color: #f3faf7;
    color: rgba(243, 250, 247, var(--text-opacity));
  }
  .group:hover .sm\\:group-hover\\:text-green-100 {
    --text-opacity: 1;
    color: #def7ec;
    color: rgba(222, 247, 236, var(--text-opacity));
  }
  .group:hover .sm\\:group-hover\\:text-green-200 {
    --text-opacity: 1;
    color: #bcf0da;
    color: rgba(188, 240, 218, var(--text-opacity));
  }
  .group:hover .sm\\:group-hover\\:text-green-300 {
    --text-opacity: 1;
    color: #84e1bc;
    color: rgba(132, 225, 188, var(--text-opacity));
  }
  .group:hover .sm\\:group-hover\\:text-green-400 {
    --text-opacity: 1;
    color: #31c48d;
    color: rgba(49, 196, 141, var(--text-opacity));
  }
  .group:hover .sm\\:group-hover\\:text-green-500 {
    --text-opacity: 1;
    color: #0e9f6e;
    color: rgba(14, 159, 110, var(--text-opacity));
  }
  .group:hover .sm\\:group-hover\\:text-green-600 {
    --text-opacity: 1;
    color: #057a55;
    color: rgba(5, 122, 85, var(--text-opacity));
  }
  .group:hover .sm\\:group-hover\\:text-green-700 {
    --text-opacity: 1;
    color: #046c4e;
    color: rgba(4, 108, 78, var(--text-opacity));
  }
  .group:hover .sm\\:group-hover\\:text-green-800 {
    --text-opacity: 1;
    color: #03543f;
    color: rgba(3, 84, 63, var(--text-opacity));
  }
  .group:hover .sm\\:group-hover\\:text-green-900 {
    --text-opacity: 1;
    color: #014737;
    color: rgba(1, 71, 55, var(--text-opacity));
  }
  .group:hover .sm\\:group-hover\\:text-teal-50 {
    --text-opacity: 1;
    color: #edfafa;
    color: rgba(237, 250, 250, var(--text-opacity));
  }
  .group:hover .sm\\:group-hover\\:text-teal-100 {
    --text-opacity: 1;
    color: #d5f5f6;
    color: rgba(213, 245, 246, var(--text-opacity));
  }
  .group:hover .sm\\:group-hover\\:text-teal-200 {
    --text-opacity: 1;
    color: #afecef;
    color: rgba(175, 236, 239, var(--text-opacity));
  }
  .group:hover .sm\\:group-hover\\:text-teal-300 {
    --text-opacity: 1;
    color: #7edce2;
    color: rgba(126, 220, 226, var(--text-opacity));
  }
  .group:hover .sm\\:group-hover\\:text-teal-400 {
    --text-opacity: 1;
    color: #16bdca;
    color: rgba(22, 189, 202, var(--text-opacity));
  }
  .group:hover .sm\\:group-hover\\:text-teal-500 {
    --text-opacity: 1;
    color: #0694a2;
    color: rgba(6, 148, 162, var(--text-opacity));
  }
  .group:hover .sm\\:group-hover\\:text-teal-600 {
    --text-opacity: 1;
    color: #047481;
    color: rgba(4, 116, 129, var(--text-opacity));
  }
  .group:hover .sm\\:group-hover\\:text-teal-700 {
    --text-opacity: 1;
    color: #036672;
    color: rgba(3, 102, 114, var(--text-opacity));
  }
  .group:hover .sm\\:group-hover\\:text-teal-800 {
    --text-opacity: 1;
    color: #05505c;
    color: rgba(5, 80, 92, var(--text-opacity));
  }
  .group:hover .sm\\:group-hover\\:text-teal-900 {
    --text-opacity: 1;
    color: #014451;
    color: rgba(1, 68, 81, var(--text-opacity));
  }
  .group:hover .sm\\:group-hover\\:text-blue-50 {
    --text-opacity: 1;
    color: #ebf5ff;
    color: rgba(235, 245, 255, var(--text-opacity));
  }
  .group:hover .sm\\:group-hover\\:text-blue-100 {
    --text-opacity: 1;
    color: #e1effe;
    color: rgba(225, 239, 254, var(--text-opacity));
  }
  .group:hover .sm\\:group-hover\\:text-blue-200 {
    --text-opacity: 1;
    color: #c3ddfd;
    color: rgba(195, 221, 253, var(--text-opacity));
  }
  .group:hover .sm\\:group-hover\\:text-blue-300 {
    --text-opacity: 1;
    color: #a4cafe;
    color: rgba(164, 202, 254, var(--text-opacity));
  }
  .group:hover .sm\\:group-hover\\:text-blue-400 {
    --text-opacity: 1;
    color: #76a9fa;
    color: rgba(118, 169, 250, var(--text-opacity));
  }
  .group:hover .sm\\:group-hover\\:text-blue-500 {
    --text-opacity: 1;
    color: #3f83f8;
    color: rgba(63, 131, 248, var(--text-opacity));
  }
  .group:hover .sm\\:group-hover\\:text-blue-600 {
    --text-opacity: 1;
    color: #1c64f2;
    color: rgba(28, 100, 242, var(--text-opacity));
  }
  .group:hover .sm\\:group-hover\\:text-blue-700 {
    --text-opacity: 1;
    color: #1a56db;
    color: rgba(26, 86, 219, var(--text-opacity));
  }
  .group:hover .sm\\:group-hover\\:text-blue-800 {
    --text-opacity: 1;
    color: #1e429f;
    color: rgba(30, 66, 159, var(--text-opacity));
  }
  .group:hover .sm\\:group-hover\\:text-blue-900 {
    --text-opacity: 1;
    color: #233876;
    color: rgba(35, 56, 118, var(--text-opacity));
  }
  .group:hover .sm\\:group-hover\\:text-indigo-50 {
    --text-opacity: 1;
    color: #f0f5ff;
    color: rgba(240, 245, 255, var(--text-opacity));
  }
  .group:hover .sm\\:group-hover\\:text-indigo-100 {
    --text-opacity: 1;
    color: #e5edff;
    color: rgba(229, 237, 255, var(--text-opacity));
  }
  .group:hover .sm\\:group-hover\\:text-indigo-200 {
    --text-opacity: 1;
    color: #cddbfe;
    color: rgba(205, 219, 254, var(--text-opacity));
  }
  .group:hover .sm\\:group-hover\\:text-indigo-300 {
    --text-opacity: 1;
    color: #b4c6fc;
    color: rgba(180, 198, 252, var(--text-opacity));
  }
  .group:hover .sm\\:group-hover\\:text-indigo-400 {
    --text-opacity: 1;
    color: #8da2fb;
    color: rgba(141, 162, 251, var(--text-opacity));
  }
  .group:hover .sm\\:group-hover\\:text-indigo-500 {
    --text-opacity: 1;
    color: #6875f5;
    color: rgba(104, 117, 245, var(--text-opacity));
  }
  .group:hover .sm\\:group-hover\\:text-indigo-600 {
    --text-opacity: 1;
    color: #5850ec;
    color: rgba(88, 80, 236, var(--text-opacity));
  }
  .group:hover .sm\\:group-hover\\:text-indigo-700 {
    --text-opacity: 1;
    color: #5145cd;
    color: rgba(81, 69, 205, var(--text-opacity));
  }
  .group:hover .sm\\:group-hover\\:text-indigo-800 {
    --text-opacity: 1;
    color: #42389d;
    color: rgba(66, 56, 157, var(--text-opacity));
  }
  .group:hover .sm\\:group-hover\\:text-indigo-900 {
    --text-opacity: 1;
    color: #362f78;
    color: rgba(54, 47, 120, var(--text-opacity));
  }
  .group:hover .sm\\:group-hover\\:text-purple-50 {
    --text-opacity: 1;
    color: #f6f5ff;
    color: rgba(246, 245, 255, var(--text-opacity));
  }
  .group:hover .sm\\:group-hover\\:text-purple-100 {
    --text-opacity: 1;
    color: #edebfe;
    color: rgba(237, 235, 254, var(--text-opacity));
  }
  .group:hover .sm\\:group-hover\\:text-purple-200 {
    --text-opacity: 1;
    color: #dcd7fe;
    color: rgba(220, 215, 254, var(--text-opacity));
  }
  .group:hover .sm\\:group-hover\\:text-purple-300 {
    --text-opacity: 1;
    color: #cabffd;
    color: rgba(202, 191, 253, var(--text-opacity));
  }
  .group:hover .sm\\:group-hover\\:text-purple-400 {
    --text-opacity: 1;
    color: #ac94fa;
    color: rgba(172, 148, 250, var(--text-opacity));
  }
  .group:hover .sm\\:group-hover\\:text-purple-500 {
    --text-opacity: 1;
    color: #9061f9;
    color: rgba(144, 97, 249, var(--text-opacity));
  }
  .group:hover .sm\\:group-hover\\:text-purple-600 {
    --text-opacity: 1;
    color: #7e3af2;
    color: rgba(126, 58, 242, var(--text-opacity));
  }
  .group:hover .sm\\:group-hover\\:text-purple-700 {
    --text-opacity: 1;
    color: #6c2bd9;
    color: rgba(108, 43, 217, var(--text-opacity));
  }
  .group:hover .sm\\:group-hover\\:text-purple-800 {
    --text-opacity: 1;
    color: #5521b5;
    color: rgba(85, 33, 181, var(--text-opacity));
  }
  .group:hover .sm\\:group-hover\\:text-purple-900 {
    --text-opacity: 1;
    color: #4a1d96;
    color: rgba(74, 29, 150, var(--text-opacity));
  }
  .group:hover .sm\\:group-hover\\:text-pink-50 {
    --text-opacity: 1;
    color: #fdf2f8;
    color: rgba(253, 242, 248, var(--text-opacity));
  }
  .group:hover .sm\\:group-hover\\:text-pink-100 {
    --text-opacity: 1;
    color: #fce8f3;
    color: rgba(252, 232, 243, var(--text-opacity));
  }
  .group:hover .sm\\:group-hover\\:text-pink-200 {
    --text-opacity: 1;
    color: #fad1e8;
    color: rgba(250, 209, 232, var(--text-opacity));
  }
  .group:hover .sm\\:group-hover\\:text-pink-300 {
    --text-opacity: 1;
    color: #f8b4d9;
    color: rgba(248, 180, 217, var(--text-opacity));
  }
  .group:hover .sm\\:group-hover\\:text-pink-400 {
    --text-opacity: 1;
    color: #f17eb8;
    color: rgba(241, 126, 184, var(--text-opacity));
  }
  .group:hover .sm\\:group-hover\\:text-pink-500 {
    --text-opacity: 1;
    color: #e74694;
    color: rgba(231, 70, 148, var(--text-opacity));
  }
  .group:hover .sm\\:group-hover\\:text-pink-600 {
    --text-opacity: 1;
    color: #d61f69;
    color: rgba(214, 31, 105, var(--text-opacity));
  }
  .group:hover .sm\\:group-hover\\:text-pink-700 {
    --text-opacity: 1;
    color: #bf125d;
    color: rgba(191, 18, 93, var(--text-opacity));
  }
  .group:hover .sm\\:group-hover\\:text-pink-800 {
    --text-opacity: 1;
    color: #99154b;
    color: rgba(153, 21, 75, var(--text-opacity));
  }
  .group:hover .sm\\:group-hover\\:text-pink-900 {
    --text-opacity: 1;
    color: #751a3d;
    color: rgba(117, 26, 61, var(--text-opacity));
  }
  .group:hover .sm\\:group-hover\\:text-cool-gray-50 {
    --text-opacity: 1;
    color: #f8fafc;
    color: rgba(248, 250, 252, var(--text-opacity));
  }
  .group:hover .sm\\:group-hover\\:text-cool-gray-100 {
    --text-opacity: 1;
    color: #f1f5f9;
    color: rgba(241, 245, 249, var(--text-opacity));
  }
  .group:hover .sm\\:group-hover\\:text-cool-gray-200 {
    --text-opacity: 1;
    color: #e2e8f0;
    color: rgba(226, 232, 240, var(--text-opacity));
  }
  .group:hover .sm\\:group-hover\\:text-cool-gray-300 {
    --text-opacity: 1;
    color: #cfd8e3;
    color: rgba(207, 216, 227, var(--text-opacity));
  }
  .group:hover .sm\\:group-hover\\:text-cool-gray-400 {
    --text-opacity: 1;
    color: #97a6ba;
    color: rgba(151, 166, 186, var(--text-opacity));
  }
  .group:hover .sm\\:group-hover\\:text-cool-gray-500 {
    --text-opacity: 1;
    color: #64748b;
    color: rgba(100, 116, 139, var(--text-opacity));
  }
  .group:hover .sm\\:group-hover\\:text-cool-gray-600 {
    --text-opacity: 1;
    color: #475569;
    color: rgba(71, 85, 105, var(--text-opacity));
  }
  .group:hover .sm\\:group-hover\\:text-cool-gray-700 {
    --text-opacity: 1;
    color: #364152;
    color: rgba(54, 65, 82, var(--text-opacity));
  }
  .group:hover .sm\\:group-hover\\:text-cool-gray-800 {
    --text-opacity: 1;
    color: #27303f;
    color: rgba(39, 48, 63, var(--text-opacity));
  }
  .group:hover .sm\\:group-hover\\:text-cool-gray-900 {
    --text-opacity: 1;
    color: #1a202e;
    color: rgba(26, 32, 46, var(--text-opacity));
  }
  .group:focus .sm\\:group-focus\\:text-current {
    color: currentColor;
  }
  .group:focus .sm\\:group-focus\\:text-transparent {
    color: transparent;
  }
  .group:focus .sm\\:group-focus\\:text-white {
    --text-opacity: 1;
    color: #ffffff;
    color: rgba(255, 255, 255, var(--text-opacity));
  }
  .group:focus .sm\\:group-focus\\:text-black {
    --text-opacity: 1;
    color: #000000;
    color: rgba(0, 0, 0, var(--text-opacity));
  }
  .group:focus .sm\\:group-focus\\:text-gray-50 {
    --text-opacity: 1;
    color: #f9fafb;
    color: rgba(249, 250, 251, var(--text-opacity));
  }
  .group:focus .sm\\:group-focus\\:text-gray-100 {
    --text-opacity: 1;
    color: #f4f5f7;
    color: rgba(244, 245, 247, var(--text-opacity));
  }
  .group:focus .sm\\:group-focus\\:text-gray-200 {
    --text-opacity: 1;
    color: #e5e7eb;
    color: rgba(229, 231, 235, var(--text-opacity));
  }
  .group:focus .sm\\:group-focus\\:text-gray-300 {
    --text-opacity: 1;
    color: #d2d6dc;
    color: rgba(210, 214, 220, var(--text-opacity));
  }
  .group:focus .sm\\:group-focus\\:text-gray-400 {
    --text-opacity: 1;
    color: #9fa6b2;
    color: rgba(159, 166, 178, var(--text-opacity));
  }
  .group:focus .sm\\:group-focus\\:text-gray-500 {
    --text-opacity: 1;
    color: #6b7280;
    color: rgba(107, 114, 128, var(--text-opacity));
  }
  .group:focus .sm\\:group-focus\\:text-gray-600 {
    --text-opacity: 1;
    color: #4b5563;
    color: rgba(75, 85, 99, var(--text-opacity));
  }
  .group:focus .sm\\:group-focus\\:text-gray-700 {
    --text-opacity: 1;
    color: #374151;
    color: rgba(55, 65, 81, var(--text-opacity));
  }
  .group:focus .sm\\:group-focus\\:text-gray-800 {
    --text-opacity: 1;
    color: #252f3f;
    color: rgba(37, 47, 63, var(--text-opacity));
  }
  .group:focus .sm\\:group-focus\\:text-gray-900 {
    --text-opacity: 1;
    color: #161e2e;
    color: rgba(22, 30, 46, var(--text-opacity));
  }
  .group:focus .sm\\:group-focus\\:text-red-50 {
    --text-opacity: 1;
    color: #fdf2f2;
    color: rgba(253, 242, 242, var(--text-opacity));
  }
  .group:focus .sm\\:group-focus\\:text-red-100 {
    --text-opacity: 1;
    color: #fde8e8;
    color: rgba(253, 232, 232, var(--text-opacity));
  }
  .group:focus .sm\\:group-focus\\:text-red-200 {
    --text-opacity: 1;
    color: #fbd5d5;
    color: rgba(251, 213, 213, var(--text-opacity));
  }
  .group:focus .sm\\:group-focus\\:text-red-300 {
    --text-opacity: 1;
    color: #f8b4b4;
    color: rgba(248, 180, 180, var(--text-opacity));
  }
  .group:focus .sm\\:group-focus\\:text-red-400 {
    --text-opacity: 1;
    color: #f98080;
    color: rgba(249, 128, 128, var(--text-opacity));
  }
  .group:focus .sm\\:group-focus\\:text-red-500 {
    --text-opacity: 1;
    color: #f05252;
    color: rgba(240, 82, 82, var(--text-opacity));
  }
  .group:focus .sm\\:group-focus\\:text-red-600 {
    --text-opacity: 1;
    color: #e02424;
    color: rgba(224, 36, 36, var(--text-opacity));
  }
  .group:focus .sm\\:group-focus\\:text-red-700 {
    --text-opacity: 1;
    color: #c81e1e;
    color: rgba(200, 30, 30, var(--text-opacity));
  }
  .group:focus .sm\\:group-focus\\:text-red-800 {
    --text-opacity: 1;
    color: #9b1c1c;
    color: rgba(155, 28, 28, var(--text-opacity));
  }
  .group:focus .sm\\:group-focus\\:text-red-900 {
    --text-opacity: 1;
    color: #771d1d;
    color: rgba(119, 29, 29, var(--text-opacity));
  }
  .group:focus .sm\\:group-focus\\:text-orange-50 {
    --text-opacity: 1;
    color: #fff8f1;
    color: rgba(255, 248, 241, var(--text-opacity));
  }
  .group:focus .sm\\:group-focus\\:text-orange-100 {
    --text-opacity: 1;
    color: #feecdc;
    color: rgba(254, 236, 220, var(--text-opacity));
  }
  .group:focus .sm\\:group-focus\\:text-orange-200 {
    --text-opacity: 1;
    color: #fcd9bd;
    color: rgba(252, 217, 189, var(--text-opacity));
  }
  .group:focus .sm\\:group-focus\\:text-orange-300 {
    --text-opacity: 1;
    color: #fdba8c;
    color: rgba(253, 186, 140, var(--text-opacity));
  }
  .group:focus .sm\\:group-focus\\:text-orange-400 {
    --text-opacity: 1;
    color: #ff8a4c;
    color: rgba(255, 138, 76, var(--text-opacity));
  }
  .group:focus .sm\\:group-focus\\:text-orange-500 {
    --text-opacity: 1;
    color: #ff5a1f;
    color: rgba(255, 90, 31, var(--text-opacity));
  }
  .group:focus .sm\\:group-focus\\:text-orange-600 {
    --text-opacity: 1;
    color: #d03801;
    color: rgba(208, 56, 1, var(--text-opacity));
  }
  .group:focus .sm\\:group-focus\\:text-orange-700 {
    --text-opacity: 1;
    color: #b43403;
    color: rgba(180, 52, 3, var(--text-opacity));
  }
  .group:focus .sm\\:group-focus\\:text-orange-800 {
    --text-opacity: 1;
    color: #8a2c0d;
    color: rgba(138, 44, 13, var(--text-opacity));
  }
  .group:focus .sm\\:group-focus\\:text-orange-900 {
    --text-opacity: 1;
    color: #73230d;
    color: rgba(115, 35, 13, var(--text-opacity));
  }
  .group:focus .sm\\:group-focus\\:text-yellow-50 {
    --text-opacity: 1;
    color: #fdfdea;
    color: rgba(253, 253, 234, var(--text-opacity));
  }
  .group:focus .sm\\:group-focus\\:text-yellow-100 {
    --text-opacity: 1;
    color: #fdf6b2;
    color: rgba(253, 246, 178, var(--text-opacity));
  }
  .group:focus .sm\\:group-focus\\:text-yellow-200 {
    --text-opacity: 1;
    color: #fce96a;
    color: rgba(252, 233, 106, var(--text-opacity));
  }
  .group:focus .sm\\:group-focus\\:text-yellow-300 {
    --text-opacity: 1;
    color: #faca15;
    color: rgba(250, 202, 21, var(--text-opacity));
  }
  .group:focus .sm\\:group-focus\\:text-yellow-400 {
    --text-opacity: 1;
    color: #e3a008;
    color: rgba(227, 160, 8, var(--text-opacity));
  }
  .group:focus .sm\\:group-focus\\:text-yellow-500 {
    --text-opacity: 1;
    color: #c27803;
    color: rgba(194, 120, 3, var(--text-opacity));
  }
  .group:focus .sm\\:group-focus\\:text-yellow-600 {
    --text-opacity: 1;
    color: #9f580a;
    color: rgba(159, 88, 10, var(--text-opacity));
  }
  .group:focus .sm\\:group-focus\\:text-yellow-700 {
    --text-opacity: 1;
    color: #8e4b10;
    color: rgba(142, 75, 16, var(--text-opacity));
  }
  .group:focus .sm\\:group-focus\\:text-yellow-800 {
    --text-opacity: 1;
    color: #723b13;
    color: rgba(114, 59, 19, var(--text-opacity));
  }
  .group:focus .sm\\:group-focus\\:text-yellow-900 {
    --text-opacity: 1;
    color: #633112;
    color: rgba(99, 49, 18, var(--text-opacity));
  }
  .group:focus .sm\\:group-focus\\:text-green-50 {
    --text-opacity: 1;
    color: #f3faf7;
    color: rgba(243, 250, 247, var(--text-opacity));
  }
  .group:focus .sm\\:group-focus\\:text-green-100 {
    --text-opacity: 1;
    color: #def7ec;
    color: rgba(222, 247, 236, var(--text-opacity));
  }
  .group:focus .sm\\:group-focus\\:text-green-200 {
    --text-opacity: 1;
    color: #bcf0da;
    color: rgba(188, 240, 218, var(--text-opacity));
  }
  .group:focus .sm\\:group-focus\\:text-green-300 {
    --text-opacity: 1;
    color: #84e1bc;
    color: rgba(132, 225, 188, var(--text-opacity));
  }
  .group:focus .sm\\:group-focus\\:text-green-400 {
    --text-opacity: 1;
    color: #31c48d;
    color: rgba(49, 196, 141, var(--text-opacity));
  }
  .group:focus .sm\\:group-focus\\:text-green-500 {
    --text-opacity: 1;
    color: #0e9f6e;
    color: rgba(14, 159, 110, var(--text-opacity));
  }
  .group:focus .sm\\:group-focus\\:text-green-600 {
    --text-opacity: 1;
    color: #057a55;
    color: rgba(5, 122, 85, var(--text-opacity));
  }
  .group:focus .sm\\:group-focus\\:text-green-700 {
    --text-opacity: 1;
    color: #046c4e;
    color: rgba(4, 108, 78, var(--text-opacity));
  }
  .group:focus .sm\\:group-focus\\:text-green-800 {
    --text-opacity: 1;
    color: #03543f;
    color: rgba(3, 84, 63, var(--text-opacity));
  }
  .group:focus .sm\\:group-focus\\:text-green-900 {
    --text-opacity: 1;
    color: #014737;
    color: rgba(1, 71, 55, var(--text-opacity));
  }
  .group:focus .sm\\:group-focus\\:text-teal-50 {
    --text-opacity: 1;
    color: #edfafa;
    color: rgba(237, 250, 250, var(--text-opacity));
  }
  .group:focus .sm\\:group-focus\\:text-teal-100 {
    --text-opacity: 1;
    color: #d5f5f6;
    color: rgba(213, 245, 246, var(--text-opacity));
  }
  .group:focus .sm\\:group-focus\\:text-teal-200 {
    --text-opacity: 1;
    color: #afecef;
    color: rgba(175, 236, 239, var(--text-opacity));
  }
  .group:focus .sm\\:group-focus\\:text-teal-300 {
    --text-opacity: 1;
    color: #7edce2;
    color: rgba(126, 220, 226, var(--text-opacity));
  }
  .group:focus .sm\\:group-focus\\:text-teal-400 {
    --text-opacity: 1;
    color: #16bdca;
    color: rgba(22, 189, 202, var(--text-opacity));
  }
  .group:focus .sm\\:group-focus\\:text-teal-500 {
    --text-opacity: 1;
    color: #0694a2;
    color: rgba(6, 148, 162, var(--text-opacity));
  }
  .group:focus .sm\\:group-focus\\:text-teal-600 {
    --text-opacity: 1;
    color: #047481;
    color: rgba(4, 116, 129, var(--text-opacity));
  }
  .group:focus .sm\\:group-focus\\:text-teal-700 {
    --text-opacity: 1;
    color: #036672;
    color: rgba(3, 102, 114, var(--text-opacity));
  }
  .group:focus .sm\\:group-focus\\:text-teal-800 {
    --text-opacity: 1;
    color: #05505c;
    color: rgba(5, 80, 92, var(--text-opacity));
  }
  .group:focus .sm\\:group-focus\\:text-teal-900 {
    --text-opacity: 1;
    color: #014451;
    color: rgba(1, 68, 81, var(--text-opacity));
  }
  .group:focus .sm\\:group-focus\\:text-blue-50 {
    --text-opacity: 1;
    color: #ebf5ff;
    color: rgba(235, 245, 255, var(--text-opacity));
  }
  .group:focus .sm\\:group-focus\\:text-blue-100 {
    --text-opacity: 1;
    color: #e1effe;
    color: rgba(225, 239, 254, var(--text-opacity));
  }
  .group:focus .sm\\:group-focus\\:text-blue-200 {
    --text-opacity: 1;
    color: #c3ddfd;
    color: rgba(195, 221, 253, var(--text-opacity));
  }
  .group:focus .sm\\:group-focus\\:text-blue-300 {
    --text-opacity: 1;
    color: #a4cafe;
    color: rgba(164, 202, 254, var(--text-opacity));
  }
  .group:focus .sm\\:group-focus\\:text-blue-400 {
    --text-opacity: 1;
    color: #76a9fa;
    color: rgba(118, 169, 250, var(--text-opacity));
  }
  .group:focus .sm\\:group-focus\\:text-blue-500 {
    --text-opacity: 1;
    color: #3f83f8;
    color: rgba(63, 131, 248, var(--text-opacity));
  }
  .group:focus .sm\\:group-focus\\:text-blue-600 {
    --text-opacity: 1;
    color: #1c64f2;
    color: rgba(28, 100, 242, var(--text-opacity));
  }
  .group:focus .sm\\:group-focus\\:text-blue-700 {
    --text-opacity: 1;
    color: #1a56db;
    color: rgba(26, 86, 219, var(--text-opacity));
  }
  .group:focus .sm\\:group-focus\\:text-blue-800 {
    --text-opacity: 1;
    color: #1e429f;
    color: rgba(30, 66, 159, var(--text-opacity));
  }
  .group:focus .sm\\:group-focus\\:text-blue-900 {
    --text-opacity: 1;
    color: #233876;
    color: rgba(35, 56, 118, var(--text-opacity));
  }
  .group:focus .sm\\:group-focus\\:text-indigo-50 {
    --text-opacity: 1;
    color: #f0f5ff;
    color: rgba(240, 245, 255, var(--text-opacity));
  }
  .group:focus .sm\\:group-focus\\:text-indigo-100 {
    --text-opacity: 1;
    color: #e5edff;
    color: rgba(229, 237, 255, var(--text-opacity));
  }
  .group:focus .sm\\:group-focus\\:text-indigo-200 {
    --text-opacity: 1;
    color: #cddbfe;
    color: rgba(205, 219, 254, var(--text-opacity));
  }
  .group:focus .sm\\:group-focus\\:text-indigo-300 {
    --text-opacity: 1;
    color: #b4c6fc;
    color: rgba(180, 198, 252, var(--text-opacity));
  }
  .group:focus .sm\\:group-focus\\:text-indigo-400 {
    --text-opacity: 1;
    color: #8da2fb;
    color: rgba(141, 162, 251, var(--text-opacity));
  }
  .group:focus .sm\\:group-focus\\:text-indigo-500 {
    --text-opacity: 1;
    color: #6875f5;
    color: rgba(104, 117, 245, var(--text-opacity));
  }
  .group:focus .sm\\:group-focus\\:text-indigo-600 {
    --text-opacity: 1;
    color: #5850ec;
    color: rgba(88, 80, 236, var(--text-opacity));
  }
  .group:focus .sm\\:group-focus\\:text-indigo-700 {
    --text-opacity: 1;
    color: #5145cd;
    color: rgba(81, 69, 205, var(--text-opacity));
  }
  .group:focus .sm\\:group-focus\\:text-indigo-800 {
    --text-opacity: 1;
    color: #42389d;
    color: rgba(66, 56, 157, var(--text-opacity));
  }
  .group:focus .sm\\:group-focus\\:text-indigo-900 {
    --text-opacity: 1;
    color: #362f78;
    color: rgba(54, 47, 120, var(--text-opacity));
  }
  .group:focus .sm\\:group-focus\\:text-purple-50 {
    --text-opacity: 1;
    color: #f6f5ff;
    color: rgba(246, 245, 255, var(--text-opacity));
  }
  .group:focus .sm\\:group-focus\\:text-purple-100 {
    --text-opacity: 1;
    color: #edebfe;
    color: rgba(237, 235, 254, var(--text-opacity));
  }
  .group:focus .sm\\:group-focus\\:text-purple-200 {
    --text-opacity: 1;
    color: #dcd7fe;
    color: rgba(220, 215, 254, var(--text-opacity));
  }
  .group:focus .sm\\:group-focus\\:text-purple-300 {
    --text-opacity: 1;
    color: #cabffd;
    color: rgba(202, 191, 253, var(--text-opacity));
  }
  .group:focus .sm\\:group-focus\\:text-purple-400 {
    --text-opacity: 1;
    color: #ac94fa;
    color: rgba(172, 148, 250, var(--text-opacity));
  }
  .group:focus .sm\\:group-focus\\:text-purple-500 {
    --text-opacity: 1;
    color: #9061f9;
    color: rgba(144, 97, 249, var(--text-opacity));
  }
  .group:focus .sm\\:group-focus\\:text-purple-600 {
    --text-opacity: 1;
    color: #7e3af2;
    color: rgba(126, 58, 242, var(--text-opacity));
  }
  .group:focus .sm\\:group-focus\\:text-purple-700 {
    --text-opacity: 1;
    color: #6c2bd9;
    color: rgba(108, 43, 217, var(--text-opacity));
  }
  .group:focus .sm\\:group-focus\\:text-purple-800 {
    --text-opacity: 1;
    color: #5521b5;
    color: rgba(85, 33, 181, var(--text-opacity));
  }
  .group:focus .sm\\:group-focus\\:text-purple-900 {
    --text-opacity: 1;
    color: #4a1d96;
    color: rgba(74, 29, 150, var(--text-opacity));
  }
  .group:focus .sm\\:group-focus\\:text-pink-50 {
    --text-opacity: 1;
    color: #fdf2f8;
    color: rgba(253, 242, 248, var(--text-opacity));
  }
  .group:focus .sm\\:group-focus\\:text-pink-100 {
    --text-opacity: 1;
    color: #fce8f3;
    color: rgba(252, 232, 243, var(--text-opacity));
  }
  .group:focus .sm\\:group-focus\\:text-pink-200 {
    --text-opacity: 1;
    color: #fad1e8;
    color: rgba(250, 209, 232, var(--text-opacity));
  }
  .group:focus .sm\\:group-focus\\:text-pink-300 {
    --text-opacity: 1;
    color: #f8b4d9;
    color: rgba(248, 180, 217, var(--text-opacity));
  }
  .group:focus .sm\\:group-focus\\:text-pink-400 {
    --text-opacity: 1;
    color: #f17eb8;
    color: rgba(241, 126, 184, var(--text-opacity));
  }
  .group:focus .sm\\:group-focus\\:text-pink-500 {
    --text-opacity: 1;
    color: #e74694;
    color: rgba(231, 70, 148, var(--text-opacity));
  }
  .group:focus .sm\\:group-focus\\:text-pink-600 {
    --text-opacity: 1;
    color: #d61f69;
    color: rgba(214, 31, 105, var(--text-opacity));
  }
  .group:focus .sm\\:group-focus\\:text-pink-700 {
    --text-opacity: 1;
    color: #bf125d;
    color: rgba(191, 18, 93, var(--text-opacity));
  }
  .group:focus .sm\\:group-focus\\:text-pink-800 {
    --text-opacity: 1;
    color: #99154b;
    color: rgba(153, 21, 75, var(--text-opacity));
  }
  .group:focus .sm\\:group-focus\\:text-pink-900 {
    --text-opacity: 1;
    color: #751a3d;
    color: rgba(117, 26, 61, var(--text-opacity));
  }
  .group:focus .sm\\:group-focus\\:text-cool-gray-50 {
    --text-opacity: 1;
    color: #f8fafc;
    color: rgba(248, 250, 252, var(--text-opacity));
  }
  .group:focus .sm\\:group-focus\\:text-cool-gray-100 {
    --text-opacity: 1;
    color: #f1f5f9;
    color: rgba(241, 245, 249, var(--text-opacity));
  }
  .group:focus .sm\\:group-focus\\:text-cool-gray-200 {
    --text-opacity: 1;
    color: #e2e8f0;
    color: rgba(226, 232, 240, var(--text-opacity));
  }
  .group:focus .sm\\:group-focus\\:text-cool-gray-300 {
    --text-opacity: 1;
    color: #cfd8e3;
    color: rgba(207, 216, 227, var(--text-opacity));
  }
  .group:focus .sm\\:group-focus\\:text-cool-gray-400 {
    --text-opacity: 1;
    color: #97a6ba;
    color: rgba(151, 166, 186, var(--text-opacity));
  }
  .group:focus .sm\\:group-focus\\:text-cool-gray-500 {
    --text-opacity: 1;
    color: #64748b;
    color: rgba(100, 116, 139, var(--text-opacity));
  }
  .group:focus .sm\\:group-focus\\:text-cool-gray-600 {
    --text-opacity: 1;
    color: #475569;
    color: rgba(71, 85, 105, var(--text-opacity));
  }
  .group:focus .sm\\:group-focus\\:text-cool-gray-700 {
    --text-opacity: 1;
    color: #364152;
    color: rgba(54, 65, 82, var(--text-opacity));
  }
  .group:focus .sm\\:group-focus\\:text-cool-gray-800 {
    --text-opacity: 1;
    color: #27303f;
    color: rgba(39, 48, 63, var(--text-opacity));
  }
  .group:focus .sm\\:group-focus\\:text-cool-gray-900 {
    --text-opacity: 1;
    color: #1a202e;
    color: rgba(26, 32, 46, var(--text-opacity));
  }
  .sm\\:hover\\:text-current:hover {
    color: currentColor;
  }
  .sm\\:hover\\:text-transparent:hover {
    color: transparent;
  }
  .sm\\:hover\\:text-white:hover {
    --text-opacity: 1;
    color: #ffffff;
    color: rgba(255, 255, 255, var(--text-opacity));
  }
  .sm\\:hover\\:text-black:hover {
    --text-opacity: 1;
    color: #000000;
    color: rgba(0, 0, 0, var(--text-opacity));
  }
  .sm\\:hover\\:text-gray-50:hover {
    --text-opacity: 1;
    color: #f9fafb;
    color: rgba(249, 250, 251, var(--text-opacity));
  }
  .sm\\:hover\\:text-gray-100:hover {
    --text-opacity: 1;
    color: #f4f5f7;
    color: rgba(244, 245, 247, var(--text-opacity));
  }
  .sm\\:hover\\:text-gray-200:hover {
    --text-opacity: 1;
    color: #e5e7eb;
    color: rgba(229, 231, 235, var(--text-opacity));
  }
  .sm\\:hover\\:text-gray-300:hover {
    --text-opacity: 1;
    color: #d2d6dc;
    color: rgba(210, 214, 220, var(--text-opacity));
  }
  .sm\\:hover\\:text-gray-400:hover {
    --text-opacity: 1;
    color: #9fa6b2;
    color: rgba(159, 166, 178, var(--text-opacity));
  }
  .sm\\:hover\\:text-gray-500:hover {
    --text-opacity: 1;
    color: #6b7280;
    color: rgba(107, 114, 128, var(--text-opacity));
  }
  .sm\\:hover\\:text-gray-600:hover {
    --text-opacity: 1;
    color: #4b5563;
    color: rgba(75, 85, 99, var(--text-opacity));
  }
  .sm\\:hover\\:text-gray-700:hover {
    --text-opacity: 1;
    color: #374151;
    color: rgba(55, 65, 81, var(--text-opacity));
  }
  .sm\\:hover\\:text-gray-800:hover {
    --text-opacity: 1;
    color: #252f3f;
    color: rgba(37, 47, 63, var(--text-opacity));
  }
  .sm\\:hover\\:text-gray-900:hover {
    --text-opacity: 1;
    color: #161e2e;
    color: rgba(22, 30, 46, var(--text-opacity));
  }
  .sm\\:hover\\:text-red-50:hover {
    --text-opacity: 1;
    color: #fdf2f2;
    color: rgba(253, 242, 242, var(--text-opacity));
  }
  .sm\\:hover\\:text-red-100:hover {
    --text-opacity: 1;
    color: #fde8e8;
    color: rgba(253, 232, 232, var(--text-opacity));
  }
  .sm\\:hover\\:text-red-200:hover {
    --text-opacity: 1;
    color: #fbd5d5;
    color: rgba(251, 213, 213, var(--text-opacity));
  }
  .sm\\:hover\\:text-red-300:hover {
    --text-opacity: 1;
    color: #f8b4b4;
    color: rgba(248, 180, 180, var(--text-opacity));
  }
  .sm\\:hover\\:text-red-400:hover {
    --text-opacity: 1;
    color: #f98080;
    color: rgba(249, 128, 128, var(--text-opacity));
  }
  .sm\\:hover\\:text-red-500:hover {
    --text-opacity: 1;
    color: #f05252;
    color: rgba(240, 82, 82, var(--text-opacity));
  }
  .sm\\:hover\\:text-red-600:hover {
    --text-opacity: 1;
    color: #e02424;
    color: rgba(224, 36, 36, var(--text-opacity));
  }
  .sm\\:hover\\:text-red-700:hover {
    --text-opacity: 1;
    color: #c81e1e;
    color: rgba(200, 30, 30, var(--text-opacity));
  }
  .sm\\:hover\\:text-red-800:hover {
    --text-opacity: 1;
    color: #9b1c1c;
    color: rgba(155, 28, 28, var(--text-opacity));
  }
  .sm\\:hover\\:text-red-900:hover {
    --text-opacity: 1;
    color: #771d1d;
    color: rgba(119, 29, 29, var(--text-opacity));
  }
  .sm\\:hover\\:text-orange-50:hover {
    --text-opacity: 1;
    color: #fff8f1;
    color: rgba(255, 248, 241, var(--text-opacity));
  }
  .sm\\:hover\\:text-orange-100:hover {
    --text-opacity: 1;
    color: #feecdc;
    color: rgba(254, 236, 220, var(--text-opacity));
  }
  .sm\\:hover\\:text-orange-200:hover {
    --text-opacity: 1;
    color: #fcd9bd;
    color: rgba(252, 217, 189, var(--text-opacity));
  }
  .sm\\:hover\\:text-orange-300:hover {
    --text-opacity: 1;
    color: #fdba8c;
    color: rgba(253, 186, 140, var(--text-opacity));
  }
  .sm\\:hover\\:text-orange-400:hover {
    --text-opacity: 1;
    color: #ff8a4c;
    color: rgba(255, 138, 76, var(--text-opacity));
  }
  .sm\\:hover\\:text-orange-500:hover {
    --text-opacity: 1;
    color: #ff5a1f;
    color: rgba(255, 90, 31, var(--text-opacity));
  }
  .sm\\:hover\\:text-orange-600:hover {
    --text-opacity: 1;
    color: #d03801;
    color: rgba(208, 56, 1, var(--text-opacity));
  }
  .sm\\:hover\\:text-orange-700:hover {
    --text-opacity: 1;
    color: #b43403;
    color: rgba(180, 52, 3, var(--text-opacity));
  }
  .sm\\:hover\\:text-orange-800:hover {
    --text-opacity: 1;
    color: #8a2c0d;
    color: rgba(138, 44, 13, var(--text-opacity));
  }
  .sm\\:hover\\:text-orange-900:hover {
    --text-opacity: 1;
    color: #73230d;
    color: rgba(115, 35, 13, var(--text-opacity));
  }
  .sm\\:hover\\:text-yellow-50:hover {
    --text-opacity: 1;
    color: #fdfdea;
    color: rgba(253, 253, 234, var(--text-opacity));
  }
  .sm\\:hover\\:text-yellow-100:hover {
    --text-opacity: 1;
    color: #fdf6b2;
    color: rgba(253, 246, 178, var(--text-opacity));
  }
  .sm\\:hover\\:text-yellow-200:hover {
    --text-opacity: 1;
    color: #fce96a;
    color: rgba(252, 233, 106, var(--text-opacity));
  }
  .sm\\:hover\\:text-yellow-300:hover {
    --text-opacity: 1;
    color: #faca15;
    color: rgba(250, 202, 21, var(--text-opacity));
  }
  .sm\\:hover\\:text-yellow-400:hover {
    --text-opacity: 1;
    color: #e3a008;
    color: rgba(227, 160, 8, var(--text-opacity));
  }
  .sm\\:hover\\:text-yellow-500:hover {
    --text-opacity: 1;
    color: #c27803;
    color: rgba(194, 120, 3, var(--text-opacity));
  }
  .sm\\:hover\\:text-yellow-600:hover {
    --text-opacity: 1;
    color: #9f580a;
    color: rgba(159, 88, 10, var(--text-opacity));
  }
  .sm\\:hover\\:text-yellow-700:hover {
    --text-opacity: 1;
    color: #8e4b10;
    color: rgba(142, 75, 16, var(--text-opacity));
  }
  .sm\\:hover\\:text-yellow-800:hover {
    --text-opacity: 1;
    color: #723b13;
    color: rgba(114, 59, 19, var(--text-opacity));
  }
  .sm\\:hover\\:text-yellow-900:hover {
    --text-opacity: 1;
    color: #633112;
    color: rgba(99, 49, 18, var(--text-opacity));
  }
  .sm\\:hover\\:text-green-50:hover {
    --text-opacity: 1;
    color: #f3faf7;
    color: rgba(243, 250, 247, var(--text-opacity));
  }
  .sm\\:hover\\:text-green-100:hover {
    --text-opacity: 1;
    color: #def7ec;
    color: rgba(222, 247, 236, var(--text-opacity));
  }
  .sm\\:hover\\:text-green-200:hover {
    --text-opacity: 1;
    color: #bcf0da;
    color: rgba(188, 240, 218, var(--text-opacity));
  }
  .sm\\:hover\\:text-green-300:hover {
    --text-opacity: 1;
    color: #84e1bc;
    color: rgba(132, 225, 188, var(--text-opacity));
  }
  .sm\\:hover\\:text-green-400:hover {
    --text-opacity: 1;
    color: #31c48d;
    color: rgba(49, 196, 141, var(--text-opacity));
  }
  .sm\\:hover\\:text-green-500:hover {
    --text-opacity: 1;
    color: #0e9f6e;
    color: rgba(14, 159, 110, var(--text-opacity));
  }
  .sm\\:hover\\:text-green-600:hover {
    --text-opacity: 1;
    color: #057a55;
    color: rgba(5, 122, 85, var(--text-opacity));
  }
  .sm\\:hover\\:text-green-700:hover {
    --text-opacity: 1;
    color: #046c4e;
    color: rgba(4, 108, 78, var(--text-opacity));
  }
  .sm\\:hover\\:text-green-800:hover {
    --text-opacity: 1;
    color: #03543f;
    color: rgba(3, 84, 63, var(--text-opacity));
  }
  .sm\\:hover\\:text-green-900:hover {
    --text-opacity: 1;
    color: #014737;
    color: rgba(1, 71, 55, var(--text-opacity));
  }
  .sm\\:hover\\:text-teal-50:hover {
    --text-opacity: 1;
    color: #edfafa;
    color: rgba(237, 250, 250, var(--text-opacity));
  }
  .sm\\:hover\\:text-teal-100:hover {
    --text-opacity: 1;
    color: #d5f5f6;
    color: rgba(213, 245, 246, var(--text-opacity));
  }
  .sm\\:hover\\:text-teal-200:hover {
    --text-opacity: 1;
    color: #afecef;
    color: rgba(175, 236, 239, var(--text-opacity));
  }
  .sm\\:hover\\:text-teal-300:hover {
    --text-opacity: 1;
    color: #7edce2;
    color: rgba(126, 220, 226, var(--text-opacity));
  }
  .sm\\:hover\\:text-teal-400:hover {
    --text-opacity: 1;
    color: #16bdca;
    color: rgba(22, 189, 202, var(--text-opacity));
  }
  .sm\\:hover\\:text-teal-500:hover {
    --text-opacity: 1;
    color: #0694a2;
    color: rgba(6, 148, 162, var(--text-opacity));
  }
  .sm\\:hover\\:text-teal-600:hover {
    --text-opacity: 1;
    color: #047481;
    color: rgba(4, 116, 129, var(--text-opacity));
  }
  .sm\\:hover\\:text-teal-700:hover {
    --text-opacity: 1;
    color: #036672;
    color: rgba(3, 102, 114, var(--text-opacity));
  }
  .sm\\:hover\\:text-teal-800:hover {
    --text-opacity: 1;
    color: #05505c;
    color: rgba(5, 80, 92, var(--text-opacity));
  }
  .sm\\:hover\\:text-teal-900:hover {
    --text-opacity: 1;
    color: #014451;
    color: rgba(1, 68, 81, var(--text-opacity));
  }
  .sm\\:hover\\:text-blue-50:hover {
    --text-opacity: 1;
    color: #ebf5ff;
    color: rgba(235, 245, 255, var(--text-opacity));
  }
  .sm\\:hover\\:text-blue-100:hover {
    --text-opacity: 1;
    color: #e1effe;
    color: rgba(225, 239, 254, var(--text-opacity));
  }
  .sm\\:hover\\:text-blue-200:hover {
    --text-opacity: 1;
    color: #c3ddfd;
    color: rgba(195, 221, 253, var(--text-opacity));
  }
  .sm\\:hover\\:text-blue-300:hover {
    --text-opacity: 1;
    color: #a4cafe;
    color: rgba(164, 202, 254, var(--text-opacity));
  }
  .sm\\:hover\\:text-blue-400:hover {
    --text-opacity: 1;
    color: #76a9fa;
    color: rgba(118, 169, 250, var(--text-opacity));
  }
  .sm\\:hover\\:text-blue-500:hover {
    --text-opacity: 1;
    color: #3f83f8;
    color: rgba(63, 131, 248, var(--text-opacity));
  }
  .sm\\:hover\\:text-blue-600:hover {
    --text-opacity: 1;
    color: #1c64f2;
    color: rgba(28, 100, 242, var(--text-opacity));
  }
  .sm\\:hover\\:text-blue-700:hover {
    --text-opacity: 1;
    color: #1a56db;
    color: rgba(26, 86, 219, var(--text-opacity));
  }
  .sm\\:hover\\:text-blue-800:hover {
    --text-opacity: 1;
    color: #1e429f;
    color: rgba(30, 66, 159, var(--text-opacity));
  }
  .sm\\:hover\\:text-blue-900:hover {
    --text-opacity: 1;
    color: #233876;
    color: rgba(35, 56, 118, var(--text-opacity));
  }
  .sm\\:hover\\:text-indigo-50:hover {
    --text-opacity: 1;
    color: #f0f5ff;
    color: rgba(240, 245, 255, var(--text-opacity));
  }
  .sm\\:hover\\:text-indigo-100:hover {
    --text-opacity: 1;
    color: #e5edff;
    color: rgba(229, 237, 255, var(--text-opacity));
  }
  .sm\\:hover\\:text-indigo-200:hover {
    --text-opacity: 1;
    color: #cddbfe;
    color: rgba(205, 219, 254, var(--text-opacity));
  }
  .sm\\:hover\\:text-indigo-300:hover {
    --text-opacity: 1;
    color: #b4c6fc;
    color: rgba(180, 198, 252, var(--text-opacity));
  }
  .sm\\:hover\\:text-indigo-400:hover {
    --text-opacity: 1;
    color: #8da2fb;
    color: rgba(141, 162, 251, var(--text-opacity));
  }
  .sm\\:hover\\:text-indigo-500:hover {
    --text-opacity: 1;
    color: #6875f5;
    color: rgba(104, 117, 245, var(--text-opacity));
  }
  .sm\\:hover\\:text-indigo-600:hover {
    --text-opacity: 1;
    color: #5850ec;
    color: rgba(88, 80, 236, var(--text-opacity));
  }
  .sm\\:hover\\:text-indigo-700:hover {
    --text-opacity: 1;
    color: #5145cd;
    color: rgba(81, 69, 205, var(--text-opacity));
  }
  .sm\\:hover\\:text-indigo-800:hover {
    --text-opacity: 1;
    color: #42389d;
    color: rgba(66, 56, 157, var(--text-opacity));
  }
  .sm\\:hover\\:text-indigo-900:hover {
    --text-opacity: 1;
    color: #362f78;
    color: rgba(54, 47, 120, var(--text-opacity));
  }
  .sm\\:hover\\:text-purple-50:hover {
    --text-opacity: 1;
    color: #f6f5ff;
    color: rgba(246, 245, 255, var(--text-opacity));
  }
  .sm\\:hover\\:text-purple-100:hover {
    --text-opacity: 1;
    color: #edebfe;
    color: rgba(237, 235, 254, var(--text-opacity));
  }
  .sm\\:hover\\:text-purple-200:hover {
    --text-opacity: 1;
    color: #dcd7fe;
    color: rgba(220, 215, 254, var(--text-opacity));
  }
  .sm\\:hover\\:text-purple-300:hover {
    --text-opacity: 1;
    color: #cabffd;
    color: rgba(202, 191, 253, var(--text-opacity));
  }
  .sm\\:hover\\:text-purple-400:hover {
    --text-opacity: 1;
    color: #ac94fa;
    color: rgba(172, 148, 250, var(--text-opacity));
  }
  .sm\\:hover\\:text-purple-500:hover {
    --text-opacity: 1;
    color: #9061f9;
    color: rgba(144, 97, 249, var(--text-opacity));
  }
  .sm\\:hover\\:text-purple-600:hover {
    --text-opacity: 1;
    color: #7e3af2;
    color: rgba(126, 58, 242, var(--text-opacity));
  }
  .sm\\:hover\\:text-purple-700:hover {
    --text-opacity: 1;
    color: #6c2bd9;
    color: rgba(108, 43, 217, var(--text-opacity));
  }
  .sm\\:hover\\:text-purple-800:hover {
    --text-opacity: 1;
    color: #5521b5;
    color: rgba(85, 33, 181, var(--text-opacity));
  }
  .sm\\:hover\\:text-purple-900:hover {
    --text-opacity: 1;
    color: #4a1d96;
    color: rgba(74, 29, 150, var(--text-opacity));
  }
  .sm\\:hover\\:text-pink-50:hover {
    --text-opacity: 1;
    color: #fdf2f8;
    color: rgba(253, 242, 248, var(--text-opacity));
  }
  .sm\\:hover\\:text-pink-100:hover {
    --text-opacity: 1;
    color: #fce8f3;
    color: rgba(252, 232, 243, var(--text-opacity));
  }
  .sm\\:hover\\:text-pink-200:hover {
    --text-opacity: 1;
    color: #fad1e8;
    color: rgba(250, 209, 232, var(--text-opacity));
  }
  .sm\\:hover\\:text-pink-300:hover {
    --text-opacity: 1;
    color: #f8b4d9;
    color: rgba(248, 180, 217, var(--text-opacity));
  }
  .sm\\:hover\\:text-pink-400:hover {
    --text-opacity: 1;
    color: #f17eb8;
    color: rgba(241, 126, 184, var(--text-opacity));
  }
  .sm\\:hover\\:text-pink-500:hover {
    --text-opacity: 1;
    color: #e74694;
    color: rgba(231, 70, 148, var(--text-opacity));
  }
  .sm\\:hover\\:text-pink-600:hover {
    --text-opacity: 1;
    color: #d61f69;
    color: rgba(214, 31, 105, var(--text-opacity));
  }
  .sm\\:hover\\:text-pink-700:hover {
    --text-opacity: 1;
    color: #bf125d;
    color: rgba(191, 18, 93, var(--text-opacity));
  }
  .sm\\:hover\\:text-pink-800:hover {
    --text-opacity: 1;
    color: #99154b;
    color: rgba(153, 21, 75, var(--text-opacity));
  }
  .sm\\:hover\\:text-pink-900:hover {
    --text-opacity: 1;
    color: #751a3d;
    color: rgba(117, 26, 61, var(--text-opacity));
  }
  .sm\\:hover\\:text-cool-gray-50:hover {
    --text-opacity: 1;
    color: #f8fafc;
    color: rgba(248, 250, 252, var(--text-opacity));
  }
  .sm\\:hover\\:text-cool-gray-100:hover {
    --text-opacity: 1;
    color: #f1f5f9;
    color: rgba(241, 245, 249, var(--text-opacity));
  }
  .sm\\:hover\\:text-cool-gray-200:hover {
    --text-opacity: 1;
    color: #e2e8f0;
    color: rgba(226, 232, 240, var(--text-opacity));
  }
  .sm\\:hover\\:text-cool-gray-300:hover {
    --text-opacity: 1;
    color: #cfd8e3;
    color: rgba(207, 216, 227, var(--text-opacity));
  }
  .sm\\:hover\\:text-cool-gray-400:hover {
    --text-opacity: 1;
    color: #97a6ba;
    color: rgba(151, 166, 186, var(--text-opacity));
  }
  .sm\\:hover\\:text-cool-gray-500:hover {
    --text-opacity: 1;
    color: #64748b;
    color: rgba(100, 116, 139, var(--text-opacity));
  }
  .sm\\:hover\\:text-cool-gray-600:hover {
    --text-opacity: 1;
    color: #475569;
    color: rgba(71, 85, 105, var(--text-opacity));
  }
  .sm\\:hover\\:text-cool-gray-700:hover {
    --text-opacity: 1;
    color: #364152;
    color: rgba(54, 65, 82, var(--text-opacity));
  }
  .sm\\:hover\\:text-cool-gray-800:hover {
    --text-opacity: 1;
    color: #27303f;
    color: rgba(39, 48, 63, var(--text-opacity));
  }
  .sm\\:hover\\:text-cool-gray-900:hover {
    --text-opacity: 1;
    color: #1a202e;
    color: rgba(26, 32, 46, var(--text-opacity));
  }
  .sm\\:focus-within\\:text-current:focus-within {
    color: currentColor;
  }
  .sm\\:focus-within\\:text-transparent:focus-within {
    color: transparent;
  }
  .sm\\:focus-within\\:text-white:focus-within {
    --text-opacity: 1;
    color: #ffffff;
    color: rgba(255, 255, 255, var(--text-opacity));
  }
  .sm\\:focus-within\\:text-black:focus-within {
    --text-opacity: 1;
    color: #000000;
    color: rgba(0, 0, 0, var(--text-opacity));
  }
  .sm\\:focus-within\\:text-gray-50:focus-within {
    --text-opacity: 1;
    color: #f9fafb;
    color: rgba(249, 250, 251, var(--text-opacity));
  }
  .sm\\:focus-within\\:text-gray-100:focus-within {
    --text-opacity: 1;
    color: #f4f5f7;
    color: rgba(244, 245, 247, var(--text-opacity));
  }
  .sm\\:focus-within\\:text-gray-200:focus-within {
    --text-opacity: 1;
    color: #e5e7eb;
    color: rgba(229, 231, 235, var(--text-opacity));
  }
  .sm\\:focus-within\\:text-gray-300:focus-within {
    --text-opacity: 1;
    color: #d2d6dc;
    color: rgba(210, 214, 220, var(--text-opacity));
  }
  .sm\\:focus-within\\:text-gray-400:focus-within {
    --text-opacity: 1;
    color: #9fa6b2;
    color: rgba(159, 166, 178, var(--text-opacity));
  }
  .sm\\:focus-within\\:text-gray-500:focus-within {
    --text-opacity: 1;
    color: #6b7280;
    color: rgba(107, 114, 128, var(--text-opacity));
  }
  .sm\\:focus-within\\:text-gray-600:focus-within {
    --text-opacity: 1;
    color: #4b5563;
    color: rgba(75, 85, 99, var(--text-opacity));
  }
  .sm\\:focus-within\\:text-gray-700:focus-within {
    --text-opacity: 1;
    color: #374151;
    color: rgba(55, 65, 81, var(--text-opacity));
  }
  .sm\\:focus-within\\:text-gray-800:focus-within {
    --text-opacity: 1;
    color: #252f3f;
    color: rgba(37, 47, 63, var(--text-opacity));
  }
  .sm\\:focus-within\\:text-gray-900:focus-within {
    --text-opacity: 1;
    color: #161e2e;
    color: rgba(22, 30, 46, var(--text-opacity));
  }
  .sm\\:focus-within\\:text-red-50:focus-within {
    --text-opacity: 1;
    color: #fdf2f2;
    color: rgba(253, 242, 242, var(--text-opacity));
  }
  .sm\\:focus-within\\:text-red-100:focus-within {
    --text-opacity: 1;
    color: #fde8e8;
    color: rgba(253, 232, 232, var(--text-opacity));
  }
  .sm\\:focus-within\\:text-red-200:focus-within {
    --text-opacity: 1;
    color: #fbd5d5;
    color: rgba(251, 213, 213, var(--text-opacity));
  }
  .sm\\:focus-within\\:text-red-300:focus-within {
    --text-opacity: 1;
    color: #f8b4b4;
    color: rgba(248, 180, 180, var(--text-opacity));
  }
  .sm\\:focus-within\\:text-red-400:focus-within {
    --text-opacity: 1;
    color: #f98080;
    color: rgba(249, 128, 128, var(--text-opacity));
  }
  .sm\\:focus-within\\:text-red-500:focus-within {
    --text-opacity: 1;
    color: #f05252;
    color: rgba(240, 82, 82, var(--text-opacity));
  }
  .sm\\:focus-within\\:text-red-600:focus-within {
    --text-opacity: 1;
    color: #e02424;
    color: rgba(224, 36, 36, var(--text-opacity));
  }
  .sm\\:focus-within\\:text-red-700:focus-within {
    --text-opacity: 1;
    color: #c81e1e;
    color: rgba(200, 30, 30, var(--text-opacity));
  }
  .sm\\:focus-within\\:text-red-800:focus-within {
    --text-opacity: 1;
    color: #9b1c1c;
    color: rgba(155, 28, 28, var(--text-opacity));
  }
  .sm\\:focus-within\\:text-red-900:focus-within {
    --text-opacity: 1;
    color: #771d1d;
    color: rgba(119, 29, 29, var(--text-opacity));
  }
  .sm\\:focus-within\\:text-orange-50:focus-within {
    --text-opacity: 1;
    color: #fff8f1;
    color: rgba(255, 248, 241, var(--text-opacity));
  }
  .sm\\:focus-within\\:text-orange-100:focus-within {
    --text-opacity: 1;
    color: #feecdc;
    color: rgba(254, 236, 220, var(--text-opacity));
  }
  .sm\\:focus-within\\:text-orange-200:focus-within {
    --text-opacity: 1;
    color: #fcd9bd;
    color: rgba(252, 217, 189, var(--text-opacity));
  }
  .sm\\:focus-within\\:text-orange-300:focus-within {
    --text-opacity: 1;
    color: #fdba8c;
    color: rgba(253, 186, 140, var(--text-opacity));
  }
  .sm\\:focus-within\\:text-orange-400:focus-within {
    --text-opacity: 1;
    color: #ff8a4c;
    color: rgba(255, 138, 76, var(--text-opacity));
  }
  .sm\\:focus-within\\:text-orange-500:focus-within {
    --text-opacity: 1;
    color: #ff5a1f;
    color: rgba(255, 90, 31, var(--text-opacity));
  }
  .sm\\:focus-within\\:text-orange-600:focus-within {
    --text-opacity: 1;
    color: #d03801;
    color: rgba(208, 56, 1, var(--text-opacity));
  }
  .sm\\:focus-within\\:text-orange-700:focus-within {
    --text-opacity: 1;
    color: #b43403;
    color: rgba(180, 52, 3, var(--text-opacity));
  }
  .sm\\:focus-within\\:text-orange-800:focus-within {
    --text-opacity: 1;
    color: #8a2c0d;
    color: rgba(138, 44, 13, var(--text-opacity));
  }
  .sm\\:focus-within\\:text-orange-900:focus-within {
    --text-opacity: 1;
    color: #73230d;
    color: rgba(115, 35, 13, var(--text-opacity));
  }
  .sm\\:focus-within\\:text-yellow-50:focus-within {
    --text-opacity: 1;
    color: #fdfdea;
    color: rgba(253, 253, 234, var(--text-opacity));
  }
  .sm\\:focus-within\\:text-yellow-100:focus-within {
    --text-opacity: 1;
    color: #fdf6b2;
    color: rgba(253, 246, 178, var(--text-opacity));
  }
  .sm\\:focus-within\\:text-yellow-200:focus-within {
    --text-opacity: 1;
    color: #fce96a;
    color: rgba(252, 233, 106, var(--text-opacity));
  }
  .sm\\:focus-within\\:text-yellow-300:focus-within {
    --text-opacity: 1;
    color: #faca15;
    color: rgba(250, 202, 21, var(--text-opacity));
  }
  .sm\\:focus-within\\:text-yellow-400:focus-within {
    --text-opacity: 1;
    color: #e3a008;
    color: rgba(227, 160, 8, var(--text-opacity));
  }
  .sm\\:focus-within\\:text-yellow-500:focus-within {
    --text-opacity: 1;
    color: #c27803;
    color: rgba(194, 120, 3, var(--text-opacity));
  }
  .sm\\:focus-within\\:text-yellow-600:focus-within {
    --text-opacity: 1;
    color: #9f580a;
    color: rgba(159, 88, 10, var(--text-opacity));
  }
  .sm\\:focus-within\\:text-yellow-700:focus-within {
    --text-opacity: 1;
    color: #8e4b10;
    color: rgba(142, 75, 16, var(--text-opacity));
  }
  .sm\\:focus-within\\:text-yellow-800:focus-within {
    --text-opacity: 1;
    color: #723b13;
    color: rgba(114, 59, 19, var(--text-opacity));
  }
  .sm\\:focus-within\\:text-yellow-900:focus-within {
    --text-opacity: 1;
    color: #633112;
    color: rgba(99, 49, 18, var(--text-opacity));
  }
  .sm\\:focus-within\\:text-green-50:focus-within {
    --text-opacity: 1;
    color: #f3faf7;
    color: rgba(243, 250, 247, var(--text-opacity));
  }
  .sm\\:focus-within\\:text-green-100:focus-within {
    --text-opacity: 1;
    color: #def7ec;
    color: rgba(222, 247, 236, var(--text-opacity));
  }
  .sm\\:focus-within\\:text-green-200:focus-within {
    --text-opacity: 1;
    color: #bcf0da;
    color: rgba(188, 240, 218, var(--text-opacity));
  }
  .sm\\:focus-within\\:text-green-300:focus-within {
    --text-opacity: 1;
    color: #84e1bc;
    color: rgba(132, 225, 188, var(--text-opacity));
  }
  .sm\\:focus-within\\:text-green-400:focus-within {
    --text-opacity: 1;
    color: #31c48d;
    color: rgba(49, 196, 141, var(--text-opacity));
  }
  .sm\\:focus-within\\:text-green-500:focus-within {
    --text-opacity: 1;
    color: #0e9f6e;
    color: rgba(14, 159, 110, var(--text-opacity));
  }
  .sm\\:focus-within\\:text-green-600:focus-within {
    --text-opacity: 1;
    color: #057a55;
    color: rgba(5, 122, 85, var(--text-opacity));
  }
  .sm\\:focus-within\\:text-green-700:focus-within {
    --text-opacity: 1;
    color: #046c4e;
    color: rgba(4, 108, 78, var(--text-opacity));
  }
  .sm\\:focus-within\\:text-green-800:focus-within {
    --text-opacity: 1;
    color: #03543f;
    color: rgba(3, 84, 63, var(--text-opacity));
  }
  .sm\\:focus-within\\:text-green-900:focus-within {
    --text-opacity: 1;
    color: #014737;
    color: rgba(1, 71, 55, var(--text-opacity));
  }
  .sm\\:focus-within\\:text-teal-50:focus-within {
    --text-opacity: 1;
    color: #edfafa;
    color: rgba(237, 250, 250, var(--text-opacity));
  }
  .sm\\:focus-within\\:text-teal-100:focus-within {
    --text-opacity: 1;
    color: #d5f5f6;
    color: rgba(213, 245, 246, var(--text-opacity));
  }
  .sm\\:focus-within\\:text-teal-200:focus-within {
    --text-opacity: 1;
    color: #afecef;
    color: rgba(175, 236, 239, var(--text-opacity));
  }
  .sm\\:focus-within\\:text-teal-300:focus-within {
    --text-opacity: 1;
    color: #7edce2;
    color: rgba(126, 220, 226, var(--text-opacity));
  }
  .sm\\:focus-within\\:text-teal-400:focus-within {
    --text-opacity: 1;
    color: #16bdca;
    color: rgba(22, 189, 202, var(--text-opacity));
  }
  .sm\\:focus-within\\:text-teal-500:focus-within {
    --text-opacity: 1;
    color: #0694a2;
    color: rgba(6, 148, 162, var(--text-opacity));
  }
  .sm\\:focus-within\\:text-teal-600:focus-within {
    --text-opacity: 1;
    color: #047481;
    color: rgba(4, 116, 129, var(--text-opacity));
  }
  .sm\\:focus-within\\:text-teal-700:focus-within {
    --text-opacity: 1;
    color: #036672;
    color: rgba(3, 102, 114, var(--text-opacity));
  }
  .sm\\:focus-within\\:text-teal-800:focus-within {
    --text-opacity: 1;
    color: #05505c;
    color: rgba(5, 80, 92, var(--text-opacity));
  }
  .sm\\:focus-within\\:text-teal-900:focus-within {
    --text-opacity: 1;
    color: #014451;
    color: rgba(1, 68, 81, var(--text-opacity));
  }
  .sm\\:focus-within\\:text-blue-50:focus-within {
    --text-opacity: 1;
    color: #ebf5ff;
    color: rgba(235, 245, 255, var(--text-opacity));
  }
  .sm\\:focus-within\\:text-blue-100:focus-within {
    --text-opacity: 1;
    color: #e1effe;
    color: rgba(225, 239, 254, var(--text-opacity));
  }
  .sm\\:focus-within\\:text-blue-200:focus-within {
    --text-opacity: 1;
    color: #c3ddfd;
    color: rgba(195, 221, 253, var(--text-opacity));
  }
  .sm\\:focus-within\\:text-blue-300:focus-within {
    --text-opacity: 1;
    color: #a4cafe;
    color: rgba(164, 202, 254, var(--text-opacity));
  }
  .sm\\:focus-within\\:text-blue-400:focus-within {
    --text-opacity: 1;
    color: #76a9fa;
    color: rgba(118, 169, 250, var(--text-opacity));
  }
  .sm\\:focus-within\\:text-blue-500:focus-within {
    --text-opacity: 1;
    color: #3f83f8;
    color: rgba(63, 131, 248, var(--text-opacity));
  }
  .sm\\:focus-within\\:text-blue-600:focus-within {
    --text-opacity: 1;
    color: #1c64f2;
    color: rgba(28, 100, 242, var(--text-opacity));
  }
  .sm\\:focus-within\\:text-blue-700:focus-within {
    --text-opacity: 1;
    color: #1a56db;
    color: rgba(26, 86, 219, var(--text-opacity));
  }
  .sm\\:focus-within\\:text-blue-800:focus-within {
    --text-opacity: 1;
    color: #1e429f;
    color: rgba(30, 66, 159, var(--text-opacity));
  }
  .sm\\:focus-within\\:text-blue-900:focus-within {
    --text-opacity: 1;
    color: #233876;
    color: rgba(35, 56, 118, var(--text-opacity));
  }
  .sm\\:focus-within\\:text-indigo-50:focus-within {
    --text-opacity: 1;
    color: #f0f5ff;
    color: rgba(240, 245, 255, var(--text-opacity));
  }
  .sm\\:focus-within\\:text-indigo-100:focus-within {
    --text-opacity: 1;
    color: #e5edff;
    color: rgba(229, 237, 255, var(--text-opacity));
  }
  .sm\\:focus-within\\:text-indigo-200:focus-within {
    --text-opacity: 1;
    color: #cddbfe;
    color: rgba(205, 219, 254, var(--text-opacity));
  }
  .sm\\:focus-within\\:text-indigo-300:focus-within {
    --text-opacity: 1;
    color: #b4c6fc;
    color: rgba(180, 198, 252, var(--text-opacity));
  }
  .sm\\:focus-within\\:text-indigo-400:focus-within {
    --text-opacity: 1;
    color: #8da2fb;
    color: rgba(141, 162, 251, var(--text-opacity));
  }
  .sm\\:focus-within\\:text-indigo-500:focus-within {
    --text-opacity: 1;
    color: #6875f5;
    color: rgba(104, 117, 245, var(--text-opacity));
  }
  .sm\\:focus-within\\:text-indigo-600:focus-within {
    --text-opacity: 1;
    color: #5850ec;
    color: rgba(88, 80, 236, var(--text-opacity));
  }
  .sm\\:focus-within\\:text-indigo-700:focus-within {
    --text-opacity: 1;
    color: #5145cd;
    color: rgba(81, 69, 205, var(--text-opacity));
  }
  .sm\\:focus-within\\:text-indigo-800:focus-within {
    --text-opacity: 1;
    color: #42389d;
    color: rgba(66, 56, 157, var(--text-opacity));
  }
  .sm\\:focus-within\\:text-indigo-900:focus-within {
    --text-opacity: 1;
    color: #362f78;
    color: rgba(54, 47, 120, var(--text-opacity));
  }
  .sm\\:focus-within\\:text-purple-50:focus-within {
    --text-opacity: 1;
    color: #f6f5ff;
    color: rgba(246, 245, 255, var(--text-opacity));
  }
  .sm\\:focus-within\\:text-purple-100:focus-within {
    --text-opacity: 1;
    color: #edebfe;
    color: rgba(237, 235, 254, var(--text-opacity));
  }
  .sm\\:focus-within\\:text-purple-200:focus-within {
    --text-opacity: 1;
    color: #dcd7fe;
    color: rgba(220, 215, 254, var(--text-opacity));
  }
  .sm\\:focus-within\\:text-purple-300:focus-within {
    --text-opacity: 1;
    color: #cabffd;
    color: rgba(202, 191, 253, var(--text-opacity));
  }
  .sm\\:focus-within\\:text-purple-400:focus-within {
    --text-opacity: 1;
    color: #ac94fa;
    color: rgba(172, 148, 250, var(--text-opacity));
  }
  .sm\\:focus-within\\:text-purple-500:focus-within {
    --text-opacity: 1;
    color: #9061f9;
    color: rgba(144, 97, 249, var(--text-opacity));
  }
  .sm\\:focus-within\\:text-purple-600:focus-within {
    --text-opacity: 1;
    color: #7e3af2;
    color: rgba(126, 58, 242, var(--text-opacity));
  }
  .sm\\:focus-within\\:text-purple-700:focus-within {
    --text-opacity: 1;
    color: #6c2bd9;
    color: rgba(108, 43, 217, var(--text-opacity));
  }
  .sm\\:focus-within\\:text-purple-800:focus-within {
    --text-opacity: 1;
    color: #5521b5;
    color: rgba(85, 33, 181, var(--text-opacity));
  }
  .sm\\:focus-within\\:text-purple-900:focus-within {
    --text-opacity: 1;
    color: #4a1d96;
    color: rgba(74, 29, 150, var(--text-opacity));
  }
  .sm\\:focus-within\\:text-pink-50:focus-within {
    --text-opacity: 1;
    color: #fdf2f8;
    color: rgba(253, 242, 248, var(--text-opacity));
  }
  .sm\\:focus-within\\:text-pink-100:focus-within {
    --text-opacity: 1;
    color: #fce8f3;
    color: rgba(252, 232, 243, var(--text-opacity));
  }
  .sm\\:focus-within\\:text-pink-200:focus-within {
    --text-opacity: 1;
    color: #fad1e8;
    color: rgba(250, 209, 232, var(--text-opacity));
  }
  .sm\\:focus-within\\:text-pink-300:focus-within {
    --text-opacity: 1;
    color: #f8b4d9;
    color: rgba(248, 180, 217, var(--text-opacity));
  }
  .sm\\:focus-within\\:text-pink-400:focus-within {
    --text-opacity: 1;
    color: #f17eb8;
    color: rgba(241, 126, 184, var(--text-opacity));
  }
  .sm\\:focus-within\\:text-pink-500:focus-within {
    --text-opacity: 1;
    color: #e74694;
    color: rgba(231, 70, 148, var(--text-opacity));
  }
  .sm\\:focus-within\\:text-pink-600:focus-within {
    --text-opacity: 1;
    color: #d61f69;
    color: rgba(214, 31, 105, var(--text-opacity));
  }
  .sm\\:focus-within\\:text-pink-700:focus-within {
    --text-opacity: 1;
    color: #bf125d;
    color: rgba(191, 18, 93, var(--text-opacity));
  }
  .sm\\:focus-within\\:text-pink-800:focus-within {
    --text-opacity: 1;
    color: #99154b;
    color: rgba(153, 21, 75, var(--text-opacity));
  }
  .sm\\:focus-within\\:text-pink-900:focus-within {
    --text-opacity: 1;
    color: #751a3d;
    color: rgba(117, 26, 61, var(--text-opacity));
  }
  .sm\\:focus-within\\:text-cool-gray-50:focus-within {
    --text-opacity: 1;
    color: #f8fafc;
    color: rgba(248, 250, 252, var(--text-opacity));
  }
  .sm\\:focus-within\\:text-cool-gray-100:focus-within {
    --text-opacity: 1;
    color: #f1f5f9;
    color: rgba(241, 245, 249, var(--text-opacity));
  }
  .sm\\:focus-within\\:text-cool-gray-200:focus-within {
    --text-opacity: 1;
    color: #e2e8f0;
    color: rgba(226, 232, 240, var(--text-opacity));
  }
  .sm\\:focus-within\\:text-cool-gray-300:focus-within {
    --text-opacity: 1;
    color: #cfd8e3;
    color: rgba(207, 216, 227, var(--text-opacity));
  }
  .sm\\:focus-within\\:text-cool-gray-400:focus-within {
    --text-opacity: 1;
    color: #97a6ba;
    color: rgba(151, 166, 186, var(--text-opacity));
  }
  .sm\\:focus-within\\:text-cool-gray-500:focus-within {
    --text-opacity: 1;
    color: #64748b;
    color: rgba(100, 116, 139, var(--text-opacity));
  }
  .sm\\:focus-within\\:text-cool-gray-600:focus-within {
    --text-opacity: 1;
    color: #475569;
    color: rgba(71, 85, 105, var(--text-opacity));
  }
  .sm\\:focus-within\\:text-cool-gray-700:focus-within {
    --text-opacity: 1;
    color: #364152;
    color: rgba(54, 65, 82, var(--text-opacity));
  }
  .sm\\:focus-within\\:text-cool-gray-800:focus-within {
    --text-opacity: 1;
    color: #27303f;
    color: rgba(39, 48, 63, var(--text-opacity));
  }
  .sm\\:focus-within\\:text-cool-gray-900:focus-within {
    --text-opacity: 1;
    color: #1a202e;
    color: rgba(26, 32, 46, var(--text-opacity));
  }
  .sm\\:focus\\:text-current:focus {
    color: currentColor;
  }
  .sm\\:focus\\:text-transparent:focus {
    color: transparent;
  }
  .sm\\:focus\\:text-white:focus {
    --text-opacity: 1;
    color: #ffffff;
    color: rgba(255, 255, 255, var(--text-opacity));
  }
  .sm\\:focus\\:text-black:focus {
    --text-opacity: 1;
    color: #000000;
    color: rgba(0, 0, 0, var(--text-opacity));
  }
  .sm\\:focus\\:text-gray-50:focus {
    --text-opacity: 1;
    color: #f9fafb;
    color: rgba(249, 250, 251, var(--text-opacity));
  }
  .sm\\:focus\\:text-gray-100:focus {
    --text-opacity: 1;
    color: #f4f5f7;
    color: rgba(244, 245, 247, var(--text-opacity));
  }
  .sm\\:focus\\:text-gray-200:focus {
    --text-opacity: 1;
    color: #e5e7eb;
    color: rgba(229, 231, 235, var(--text-opacity));
  }
  .sm\\:focus\\:text-gray-300:focus {
    --text-opacity: 1;
    color: #d2d6dc;
    color: rgba(210, 214, 220, var(--text-opacity));
  }
  .sm\\:focus\\:text-gray-400:focus {
    --text-opacity: 1;
    color: #9fa6b2;
    color: rgba(159, 166, 178, var(--text-opacity));
  }
  .sm\\:focus\\:text-gray-500:focus {
    --text-opacity: 1;
    color: #6b7280;
    color: rgba(107, 114, 128, var(--text-opacity));
  }
  .sm\\:focus\\:text-gray-600:focus {
    --text-opacity: 1;
    color: #4b5563;
    color: rgba(75, 85, 99, var(--text-opacity));
  }
  .sm\\:focus\\:text-gray-700:focus {
    --text-opacity: 1;
    color: #374151;
    color: rgba(55, 65, 81, var(--text-opacity));
  }
  .sm\\:focus\\:text-gray-800:focus {
    --text-opacity: 1;
    color: #252f3f;
    color: rgba(37, 47, 63, var(--text-opacity));
  }
  .sm\\:focus\\:text-gray-900:focus {
    --text-opacity: 1;
    color: #161e2e;
    color: rgba(22, 30, 46, var(--text-opacity));
  }
  .sm\\:focus\\:text-red-50:focus {
    --text-opacity: 1;
    color: #fdf2f2;
    color: rgba(253, 242, 242, var(--text-opacity));
  }
  .sm\\:focus\\:text-red-100:focus {
    --text-opacity: 1;
    color: #fde8e8;
    color: rgba(253, 232, 232, var(--text-opacity));
  }
  .sm\\:focus\\:text-red-200:focus {
    --text-opacity: 1;
    color: #fbd5d5;
    color: rgba(251, 213, 213, var(--text-opacity));
  }
  .sm\\:focus\\:text-red-300:focus {
    --text-opacity: 1;
    color: #f8b4b4;
    color: rgba(248, 180, 180, var(--text-opacity));
  }
  .sm\\:focus\\:text-red-400:focus {
    --text-opacity: 1;
    color: #f98080;
    color: rgba(249, 128, 128, var(--text-opacity));
  }
  .sm\\:focus\\:text-red-500:focus {
    --text-opacity: 1;
    color: #f05252;
    color: rgba(240, 82, 82, var(--text-opacity));
  }
  .sm\\:focus\\:text-red-600:focus {
    --text-opacity: 1;
    color: #e02424;
    color: rgba(224, 36, 36, var(--text-opacity));
  }
  .sm\\:focus\\:text-red-700:focus {
    --text-opacity: 1;
    color: #c81e1e;
    color: rgba(200, 30, 30, var(--text-opacity));
  }
  .sm\\:focus\\:text-red-800:focus {
    --text-opacity: 1;
    color: #9b1c1c;
    color: rgba(155, 28, 28, var(--text-opacity));
  }
  .sm\\:focus\\:text-red-900:focus {
    --text-opacity: 1;
    color: #771d1d;
    color: rgba(119, 29, 29, var(--text-opacity));
  }
  .sm\\:focus\\:text-orange-50:focus {
    --text-opacity: 1;
    color: #fff8f1;
    color: rgba(255, 248, 241, var(--text-opacity));
  }
  .sm\\:focus\\:text-orange-100:focus {
    --text-opacity: 1;
    color: #feecdc;
    color: rgba(254, 236, 220, var(--text-opacity));
  }
  .sm\\:focus\\:text-orange-200:focus {
    --text-opacity: 1;
    color: #fcd9bd;
    color: rgba(252, 217, 189, var(--text-opacity));
  }
  .sm\\:focus\\:text-orange-300:focus {
    --text-opacity: 1;
    color: #fdba8c;
    color: rgba(253, 186, 140, var(--text-opacity));
  }
  .sm\\:focus\\:text-orange-400:focus {
    --text-opacity: 1;
    color: #ff8a4c;
    color: rgba(255, 138, 76, var(--text-opacity));
  }
  .sm\\:focus\\:text-orange-500:focus {
    --text-opacity: 1;
    color: #ff5a1f;
    color: rgba(255, 90, 31, var(--text-opacity));
  }
  .sm\\:focus\\:text-orange-600:focus {
    --text-opacity: 1;
    color: #d03801;
    color: rgba(208, 56, 1, var(--text-opacity));
  }
  .sm\\:focus\\:text-orange-700:focus {
    --text-opacity: 1;
    color: #b43403;
    color: rgba(180, 52, 3, var(--text-opacity));
  }
  .sm\\:focus\\:text-orange-800:focus {
    --text-opacity: 1;
    color: #8a2c0d;
    color: rgba(138, 44, 13, var(--text-opacity));
  }
  .sm\\:focus\\:text-orange-900:focus {
    --text-opacity: 1;
    color: #73230d;
    color: rgba(115, 35, 13, var(--text-opacity));
  }
  .sm\\:focus\\:text-yellow-50:focus {
    --text-opacity: 1;
    color: #fdfdea;
    color: rgba(253, 253, 234, var(--text-opacity));
  }
  .sm\\:focus\\:text-yellow-100:focus {
    --text-opacity: 1;
    color: #fdf6b2;
    color: rgba(253, 246, 178, var(--text-opacity));
  }
  .sm\\:focus\\:text-yellow-200:focus {
    --text-opacity: 1;
    color: #fce96a;
    color: rgba(252, 233, 106, var(--text-opacity));
  }
  .sm\\:focus\\:text-yellow-300:focus {
    --text-opacity: 1;
    color: #faca15;
    color: rgba(250, 202, 21, var(--text-opacity));
  }
  .sm\\:focus\\:text-yellow-400:focus {
    --text-opacity: 1;
    color: #e3a008;
    color: rgba(227, 160, 8, var(--text-opacity));
  }
  .sm\\:focus\\:text-yellow-500:focus {
    --text-opacity: 1;
    color: #c27803;
    color: rgba(194, 120, 3, var(--text-opacity));
  }
  .sm\\:focus\\:text-yellow-600:focus {
    --text-opacity: 1;
    color: #9f580a;
    color: rgba(159, 88, 10, var(--text-opacity));
  }
  .sm\\:focus\\:text-yellow-700:focus {
    --text-opacity: 1;
    color: #8e4b10;
    color: rgba(142, 75, 16, var(--text-opacity));
  }
  .sm\\:focus\\:text-yellow-800:focus {
    --text-opacity: 1;
    color: #723b13;
    color: rgba(114, 59, 19, var(--text-opacity));
  }
  .sm\\:focus\\:text-yellow-900:focus {
    --text-opacity: 1;
    color: #633112;
    color: rgba(99, 49, 18, var(--text-opacity));
  }
  .sm\\:focus\\:text-green-50:focus {
    --text-opacity: 1;
    color: #f3faf7;
    color: rgba(243, 250, 247, var(--text-opacity));
  }
  .sm\\:focus\\:text-green-100:focus {
    --text-opacity: 1;
    color: #def7ec;
    color: rgba(222, 247, 236, var(--text-opacity));
  }
  .sm\\:focus\\:text-green-200:focus {
    --text-opacity: 1;
    color: #bcf0da;
    color: rgba(188, 240, 218, var(--text-opacity));
  }
  .sm\\:focus\\:text-green-300:focus {
    --text-opacity: 1;
    color: #84e1bc;
    color: rgba(132, 225, 188, var(--text-opacity));
  }
  .sm\\:focus\\:text-green-400:focus {
    --text-opacity: 1;
    color: #31c48d;
    color: rgba(49, 196, 141, var(--text-opacity));
  }
  .sm\\:focus\\:text-green-500:focus {
    --text-opacity: 1;
    color: #0e9f6e;
    color: rgba(14, 159, 110, var(--text-opacity));
  }
  .sm\\:focus\\:text-green-600:focus {
    --text-opacity: 1;
    color: #057a55;
    color: rgba(5, 122, 85, var(--text-opacity));
  }
  .sm\\:focus\\:text-green-700:focus {
    --text-opacity: 1;
    color: #046c4e;
    color: rgba(4, 108, 78, var(--text-opacity));
  }
  .sm\\:focus\\:text-green-800:focus {
    --text-opacity: 1;
    color: #03543f;
    color: rgba(3, 84, 63, var(--text-opacity));
  }
  .sm\\:focus\\:text-green-900:focus {
    --text-opacity: 1;
    color: #014737;
    color: rgba(1, 71, 55, var(--text-opacity));
  }
  .sm\\:focus\\:text-teal-50:focus {
    --text-opacity: 1;
    color: #edfafa;
    color: rgba(237, 250, 250, var(--text-opacity));
  }
  .sm\\:focus\\:text-teal-100:focus {
    --text-opacity: 1;
    color: #d5f5f6;
    color: rgba(213, 245, 246, var(--text-opacity));
  }
  .sm\\:focus\\:text-teal-200:focus {
    --text-opacity: 1;
    color: #afecef;
    color: rgba(175, 236, 239, var(--text-opacity));
  }
  .sm\\:focus\\:text-teal-300:focus {
    --text-opacity: 1;
    color: #7edce2;
    color: rgba(126, 220, 226, var(--text-opacity));
  }
  .sm\\:focus\\:text-teal-400:focus {
    --text-opacity: 1;
    color: #16bdca;
    color: rgba(22, 189, 202, var(--text-opacity));
  }
  .sm\\:focus\\:text-teal-500:focus {
    --text-opacity: 1;
    color: #0694a2;
    color: rgba(6, 148, 162, var(--text-opacity));
  }
  .sm\\:focus\\:text-teal-600:focus {
    --text-opacity: 1;
    color: #047481;
    color: rgba(4, 116, 129, var(--text-opacity));
  }
  .sm\\:focus\\:text-teal-700:focus {
    --text-opacity: 1;
    color: #036672;
    color: rgba(3, 102, 114, var(--text-opacity));
  }
  .sm\\:focus\\:text-teal-800:focus {
    --text-opacity: 1;
    color: #05505c;
    color: rgba(5, 80, 92, var(--text-opacity));
  }
  .sm\\:focus\\:text-teal-900:focus {
    --text-opacity: 1;
    color: #014451;
    color: rgba(1, 68, 81, var(--text-opacity));
  }
  .sm\\:focus\\:text-blue-50:focus {
    --text-opacity: 1;
    color: #ebf5ff;
    color: rgba(235, 245, 255, var(--text-opacity));
  }
  .sm\\:focus\\:text-blue-100:focus {
    --text-opacity: 1;
    color: #e1effe;
    color: rgba(225, 239, 254, var(--text-opacity));
  }
  .sm\\:focus\\:text-blue-200:focus {
    --text-opacity: 1;
    color: #c3ddfd;
    color: rgba(195, 221, 253, var(--text-opacity));
  }
  .sm\\:focus\\:text-blue-300:focus {
    --text-opacity: 1;
    color: #a4cafe;
    color: rgba(164, 202, 254, var(--text-opacity));
  }
  .sm\\:focus\\:text-blue-400:focus {
    --text-opacity: 1;
    color: #76a9fa;
    color: rgba(118, 169, 250, var(--text-opacity));
  }
  .sm\\:focus\\:text-blue-500:focus {
    --text-opacity: 1;
    color: #3f83f8;
    color: rgba(63, 131, 248, var(--text-opacity));
  }
  .sm\\:focus\\:text-blue-600:focus {
    --text-opacity: 1;
    color: #1c64f2;
    color: rgba(28, 100, 242, var(--text-opacity));
  }
  .sm\\:focus\\:text-blue-700:focus {
    --text-opacity: 1;
    color: #1a56db;
    color: rgba(26, 86, 219, var(--text-opacity));
  }
  .sm\\:focus\\:text-blue-800:focus {
    --text-opacity: 1;
    color: #1e429f;
    color: rgba(30, 66, 159, var(--text-opacity));
  }
  .sm\\:focus\\:text-blue-900:focus {
    --text-opacity: 1;
    color: #233876;
    color: rgba(35, 56, 118, var(--text-opacity));
  }
  .sm\\:focus\\:text-indigo-50:focus {
    --text-opacity: 1;
    color: #f0f5ff;
    color: rgba(240, 245, 255, var(--text-opacity));
  }
  .sm\\:focus\\:text-indigo-100:focus {
    --text-opacity: 1;
    color: #e5edff;
    color: rgba(229, 237, 255, var(--text-opacity));
  }
  .sm\\:focus\\:text-indigo-200:focus {
    --text-opacity: 1;
    color: #cddbfe;
    color: rgba(205, 219, 254, var(--text-opacity));
  }
  .sm\\:focus\\:text-indigo-300:focus {
    --text-opacity: 1;
    color: #b4c6fc;
    color: rgba(180, 198, 252, var(--text-opacity));
  }
  .sm\\:focus\\:text-indigo-400:focus {
    --text-opacity: 1;
    color: #8da2fb;
    color: rgba(141, 162, 251, var(--text-opacity));
  }
  .sm\\:focus\\:text-indigo-500:focus {
    --text-opacity: 1;
    color: #6875f5;
    color: rgba(104, 117, 245, var(--text-opacity));
  }
  .sm\\:focus\\:text-indigo-600:focus {
    --text-opacity: 1;
    color: #5850ec;
    color: rgba(88, 80, 236, var(--text-opacity));
  }
  .sm\\:focus\\:text-indigo-700:focus {
    --text-opacity: 1;
    color: #5145cd;
    color: rgba(81, 69, 205, var(--text-opacity));
  }
  .sm\\:focus\\:text-indigo-800:focus {
    --text-opacity: 1;
    color: #42389d;
    color: rgba(66, 56, 157, var(--text-opacity));
  }
  .sm\\:focus\\:text-indigo-900:focus {
    --text-opacity: 1;
    color: #362f78;
    color: rgba(54, 47, 120, var(--text-opacity));
  }
  .sm\\:focus\\:text-purple-50:focus {
    --text-opacity: 1;
    color: #f6f5ff;
    color: rgba(246, 245, 255, var(--text-opacity));
  }
  .sm\\:focus\\:text-purple-100:focus {
    --text-opacity: 1;
    color: #edebfe;
    color: rgba(237, 235, 254, var(--text-opacity));
  }
  .sm\\:focus\\:text-purple-200:focus {
    --text-opacity: 1;
    color: #dcd7fe;
    color: rgba(220, 215, 254, var(--text-opacity));
  }
  .sm\\:focus\\:text-purple-300:focus {
    --text-opacity: 1;
    color: #cabffd;
    color: rgba(202, 191, 253, var(--text-opacity));
  }
  .sm\\:focus\\:text-purple-400:focus {
    --text-opacity: 1;
    color: #ac94fa;
    color: rgba(172, 148, 250, var(--text-opacity));
  }
  .sm\\:focus\\:text-purple-500:focus {
    --text-opacity: 1;
    color: #9061f9;
    color: rgba(144, 97, 249, var(--text-opacity));
  }
  .sm\\:focus\\:text-purple-600:focus {
    --text-opacity: 1;
    color: #7e3af2;
    color: rgba(126, 58, 242, var(--text-opacity));
  }
  .sm\\:focus\\:text-purple-700:focus {
    --text-opacity: 1;
    color: #6c2bd9;
    color: rgba(108, 43, 217, var(--text-opacity));
  }
  .sm\\:focus\\:text-purple-800:focus {
    --text-opacity: 1;
    color: #5521b5;
    color: rgba(85, 33, 181, var(--text-opacity));
  }
  .sm\\:focus\\:text-purple-900:focus {
    --text-opacity: 1;
    color: #4a1d96;
    color: rgba(74, 29, 150, var(--text-opacity));
  }
  .sm\\:focus\\:text-pink-50:focus {
    --text-opacity: 1;
    color: #fdf2f8;
    color: rgba(253, 242, 248, var(--text-opacity));
  }
  .sm\\:focus\\:text-pink-100:focus {
    --text-opacity: 1;
    color: #fce8f3;
    color: rgba(252, 232, 243, var(--text-opacity));
  }
  .sm\\:focus\\:text-pink-200:focus {
    --text-opacity: 1;
    color: #fad1e8;
    color: rgba(250, 209, 232, var(--text-opacity));
  }
  .sm\\:focus\\:text-pink-300:focus {
    --text-opacity: 1;
    color: #f8b4d9;
    color: rgba(248, 180, 217, var(--text-opacity));
  }
  .sm\\:focus\\:text-pink-400:focus {
    --text-opacity: 1;
    color: #f17eb8;
    color: rgba(241, 126, 184, var(--text-opacity));
  }
  .sm\\:focus\\:text-pink-500:focus {
    --text-opacity: 1;
    color: #e74694;
    color: rgba(231, 70, 148, var(--text-opacity));
  }
  .sm\\:focus\\:text-pink-600:focus {
    --text-opacity: 1;
    color: #d61f69;
    color: rgba(214, 31, 105, var(--text-opacity));
  }
  .sm\\:focus\\:text-pink-700:focus {
    --text-opacity: 1;
    color: #bf125d;
    color: rgba(191, 18, 93, var(--text-opacity));
  }
  .sm\\:focus\\:text-pink-800:focus {
    --text-opacity: 1;
    color: #99154b;
    color: rgba(153, 21, 75, var(--text-opacity));
  }
  .sm\\:focus\\:text-pink-900:focus {
    --text-opacity: 1;
    color: #751a3d;
    color: rgba(117, 26, 61, var(--text-opacity));
  }
  .sm\\:focus\\:text-cool-gray-50:focus {
    --text-opacity: 1;
    color: #f8fafc;
    color: rgba(248, 250, 252, var(--text-opacity));
  }
  .sm\\:focus\\:text-cool-gray-100:focus {
    --text-opacity: 1;
    color: #f1f5f9;
    color: rgba(241, 245, 249, var(--text-opacity));
  }
  .sm\\:focus\\:text-cool-gray-200:focus {
    --text-opacity: 1;
    color: #e2e8f0;
    color: rgba(226, 232, 240, var(--text-opacity));
  }
  .sm\\:focus\\:text-cool-gray-300:focus {
    --text-opacity: 1;
    color: #cfd8e3;
    color: rgba(207, 216, 227, var(--text-opacity));
  }
  .sm\\:focus\\:text-cool-gray-400:focus {
    --text-opacity: 1;
    color: #97a6ba;
    color: rgba(151, 166, 186, var(--text-opacity));
  }
  .sm\\:focus\\:text-cool-gray-500:focus {
    --text-opacity: 1;
    color: #64748b;
    color: rgba(100, 116, 139, var(--text-opacity));
  }
  .sm\\:focus\\:text-cool-gray-600:focus {
    --text-opacity: 1;
    color: #475569;
    color: rgba(71, 85, 105, var(--text-opacity));
  }
  .sm\\:focus\\:text-cool-gray-700:focus {
    --text-opacity: 1;
    color: #364152;
    color: rgba(54, 65, 82, var(--text-opacity));
  }
  .sm\\:focus\\:text-cool-gray-800:focus {
    --text-opacity: 1;
    color: #27303f;
    color: rgba(39, 48, 63, var(--text-opacity));
  }
  .sm\\:focus\\:text-cool-gray-900:focus {
    --text-opacity: 1;
    color: #1a202e;
    color: rgba(26, 32, 46, var(--text-opacity));
  }
  .sm\\:active\\:text-current:active {
    color: currentColor;
  }
  .sm\\:active\\:text-transparent:active {
    color: transparent;
  }
  .sm\\:active\\:text-white:active {
    --text-opacity: 1;
    color: #ffffff;
    color: rgba(255, 255, 255, var(--text-opacity));
  }
  .sm\\:active\\:text-black:active {
    --text-opacity: 1;
    color: #000000;
    color: rgba(0, 0, 0, var(--text-opacity));
  }
  .sm\\:active\\:text-gray-50:active {
    --text-opacity: 1;
    color: #f9fafb;
    color: rgba(249, 250, 251, var(--text-opacity));
  }
  .sm\\:active\\:text-gray-100:active {
    --text-opacity: 1;
    color: #f4f5f7;
    color: rgba(244, 245, 247, var(--text-opacity));
  }
  .sm\\:active\\:text-gray-200:active {
    --text-opacity: 1;
    color: #e5e7eb;
    color: rgba(229, 231, 235, var(--text-opacity));
  }
  .sm\\:active\\:text-gray-300:active {
    --text-opacity: 1;
    color: #d2d6dc;
    color: rgba(210, 214, 220, var(--text-opacity));
  }
  .sm\\:active\\:text-gray-400:active {
    --text-opacity: 1;
    color: #9fa6b2;
    color: rgba(159, 166, 178, var(--text-opacity));
  }
  .sm\\:active\\:text-gray-500:active {
    --text-opacity: 1;
    color: #6b7280;
    color: rgba(107, 114, 128, var(--text-opacity));
  }
  .sm\\:active\\:text-gray-600:active {
    --text-opacity: 1;
    color: #4b5563;
    color: rgba(75, 85, 99, var(--text-opacity));
  }
  .sm\\:active\\:text-gray-700:active {
    --text-opacity: 1;
    color: #374151;
    color: rgba(55, 65, 81, var(--text-opacity));
  }
  .sm\\:active\\:text-gray-800:active {
    --text-opacity: 1;
    color: #252f3f;
    color: rgba(37, 47, 63, var(--text-opacity));
  }
  .sm\\:active\\:text-gray-900:active {
    --text-opacity: 1;
    color: #161e2e;
    color: rgba(22, 30, 46, var(--text-opacity));
  }
  .sm\\:active\\:text-red-50:active {
    --text-opacity: 1;
    color: #fdf2f2;
    color: rgba(253, 242, 242, var(--text-opacity));
  }
  .sm\\:active\\:text-red-100:active {
    --text-opacity: 1;
    color: #fde8e8;
    color: rgba(253, 232, 232, var(--text-opacity));
  }
  .sm\\:active\\:text-red-200:active {
    --text-opacity: 1;
    color: #fbd5d5;
    color: rgba(251, 213, 213, var(--text-opacity));
  }
  .sm\\:active\\:text-red-300:active {
    --text-opacity: 1;
    color: #f8b4b4;
    color: rgba(248, 180, 180, var(--text-opacity));
  }
  .sm\\:active\\:text-red-400:active {
    --text-opacity: 1;
    color: #f98080;
    color: rgba(249, 128, 128, var(--text-opacity));
  }
  .sm\\:active\\:text-red-500:active {
    --text-opacity: 1;
    color: #f05252;
    color: rgba(240, 82, 82, var(--text-opacity));
  }
  .sm\\:active\\:text-red-600:active {
    --text-opacity: 1;
    color: #e02424;
    color: rgba(224, 36, 36, var(--text-opacity));
  }
  .sm\\:active\\:text-red-700:active {
    --text-opacity: 1;
    color: #c81e1e;
    color: rgba(200, 30, 30, var(--text-opacity));
  }
  .sm\\:active\\:text-red-800:active {
    --text-opacity: 1;
    color: #9b1c1c;
    color: rgba(155, 28, 28, var(--text-opacity));
  }
  .sm\\:active\\:text-red-900:active {
    --text-opacity: 1;
    color: #771d1d;
    color: rgba(119, 29, 29, var(--text-opacity));
  }
  .sm\\:active\\:text-orange-50:active {
    --text-opacity: 1;
    color: #fff8f1;
    color: rgba(255, 248, 241, var(--text-opacity));
  }
  .sm\\:active\\:text-orange-100:active {
    --text-opacity: 1;
    color: #feecdc;
    color: rgba(254, 236, 220, var(--text-opacity));
  }
  .sm\\:active\\:text-orange-200:active {
    --text-opacity: 1;
    color: #fcd9bd;
    color: rgba(252, 217, 189, var(--text-opacity));
  }
  .sm\\:active\\:text-orange-300:active {
    --text-opacity: 1;
    color: #fdba8c;
    color: rgba(253, 186, 140, var(--text-opacity));
  }
  .sm\\:active\\:text-orange-400:active {
    --text-opacity: 1;
    color: #ff8a4c;
    color: rgba(255, 138, 76, var(--text-opacity));
  }
  .sm\\:active\\:text-orange-500:active {
    --text-opacity: 1;
    color: #ff5a1f;
    color: rgba(255, 90, 31, var(--text-opacity));
  }
  .sm\\:active\\:text-orange-600:active {
    --text-opacity: 1;
    color: #d03801;
    color: rgba(208, 56, 1, var(--text-opacity));
  }
  .sm\\:active\\:text-orange-700:active {
    --text-opacity: 1;
    color: #b43403;
    color: rgba(180, 52, 3, var(--text-opacity));
  }
  .sm\\:active\\:text-orange-800:active {
    --text-opacity: 1;
    color: #8a2c0d;
    color: rgba(138, 44, 13, var(--text-opacity));
  }
  .sm\\:active\\:text-orange-900:active {
    --text-opacity: 1;
    color: #73230d;
    color: rgba(115, 35, 13, var(--text-opacity));
  }
  .sm\\:active\\:text-yellow-50:active {
    --text-opacity: 1;
    color: #fdfdea;
    color: rgba(253, 253, 234, var(--text-opacity));
  }
  .sm\\:active\\:text-yellow-100:active {
    --text-opacity: 1;
    color: #fdf6b2;
    color: rgba(253, 246, 178, var(--text-opacity));
  }
  .sm\\:active\\:text-yellow-200:active {
    --text-opacity: 1;
    color: #fce96a;
    color: rgba(252, 233, 106, var(--text-opacity));
  }
  .sm\\:active\\:text-yellow-300:active {
    --text-opacity: 1;
    color: #faca15;
    color: rgba(250, 202, 21, var(--text-opacity));
  }
  .sm\\:active\\:text-yellow-400:active {
    --text-opacity: 1;
    color: #e3a008;
    color: rgba(227, 160, 8, var(--text-opacity));
  }
  .sm\\:active\\:text-yellow-500:active {
    --text-opacity: 1;
    color: #c27803;
    color: rgba(194, 120, 3, var(--text-opacity));
  }
  .sm\\:active\\:text-yellow-600:active {
    --text-opacity: 1;
    color: #9f580a;
    color: rgba(159, 88, 10, var(--text-opacity));
  }
  .sm\\:active\\:text-yellow-700:active {
    --text-opacity: 1;
    color: #8e4b10;
    color: rgba(142, 75, 16, var(--text-opacity));
  }
  .sm\\:active\\:text-yellow-800:active {
    --text-opacity: 1;
    color: #723b13;
    color: rgba(114, 59, 19, var(--text-opacity));
  }
  .sm\\:active\\:text-yellow-900:active {
    --text-opacity: 1;
    color: #633112;
    color: rgba(99, 49, 18, var(--text-opacity));
  }
  .sm\\:active\\:text-green-50:active {
    --text-opacity: 1;
    color: #f3faf7;
    color: rgba(243, 250, 247, var(--text-opacity));
  }
  .sm\\:active\\:text-green-100:active {
    --text-opacity: 1;
    color: #def7ec;
    color: rgba(222, 247, 236, var(--text-opacity));
  }
  .sm\\:active\\:text-green-200:active {
    --text-opacity: 1;
    color: #bcf0da;
    color: rgba(188, 240, 218, var(--text-opacity));
  }
  .sm\\:active\\:text-green-300:active {
    --text-opacity: 1;
    color: #84e1bc;
    color: rgba(132, 225, 188, var(--text-opacity));
  }
  .sm\\:active\\:text-green-400:active {
    --text-opacity: 1;
    color: #31c48d;
    color: rgba(49, 196, 141, var(--text-opacity));
  }
  .sm\\:active\\:text-green-500:active {
    --text-opacity: 1;
    color: #0e9f6e;
    color: rgba(14, 159, 110, var(--text-opacity));
  }
  .sm\\:active\\:text-green-600:active {
    --text-opacity: 1;
    color: #057a55;
    color: rgba(5, 122, 85, var(--text-opacity));
  }
  .sm\\:active\\:text-green-700:active {
    --text-opacity: 1;
    color: #046c4e;
    color: rgba(4, 108, 78, var(--text-opacity));
  }
  .sm\\:active\\:text-green-800:active {
    --text-opacity: 1;
    color: #03543f;
    color: rgba(3, 84, 63, var(--text-opacity));
  }
  .sm\\:active\\:text-green-900:active {
    --text-opacity: 1;
    color: #014737;
    color: rgba(1, 71, 55, var(--text-opacity));
  }
  .sm\\:active\\:text-teal-50:active {
    --text-opacity: 1;
    color: #edfafa;
    color: rgba(237, 250, 250, var(--text-opacity));
  }
  .sm\\:active\\:text-teal-100:active {
    --text-opacity: 1;
    color: #d5f5f6;
    color: rgba(213, 245, 246, var(--text-opacity));
  }
  .sm\\:active\\:text-teal-200:active {
    --text-opacity: 1;
    color: #afecef;
    color: rgba(175, 236, 239, var(--text-opacity));
  }
  .sm\\:active\\:text-teal-300:active {
    --text-opacity: 1;
    color: #7edce2;
    color: rgba(126, 220, 226, var(--text-opacity));
  }
  .sm\\:active\\:text-teal-400:active {
    --text-opacity: 1;
    color: #16bdca;
    color: rgba(22, 189, 202, var(--text-opacity));
  }
  .sm\\:active\\:text-teal-500:active {
    --text-opacity: 1;
    color: #0694a2;
    color: rgba(6, 148, 162, var(--text-opacity));
  }
  .sm\\:active\\:text-teal-600:active {
    --text-opacity: 1;
    color: #047481;
    color: rgba(4, 116, 129, var(--text-opacity));
  }
  .sm\\:active\\:text-teal-700:active {
    --text-opacity: 1;
    color: #036672;
    color: rgba(3, 102, 114, var(--text-opacity));
  }
  .sm\\:active\\:text-teal-800:active {
    --text-opacity: 1;
    color: #05505c;
    color: rgba(5, 80, 92, var(--text-opacity));
  }
  .sm\\:active\\:text-teal-900:active {
    --text-opacity: 1;
    color: #014451;
    color: rgba(1, 68, 81, var(--text-opacity));
  }
  .sm\\:active\\:text-blue-50:active {
    --text-opacity: 1;
    color: #ebf5ff;
    color: rgba(235, 245, 255, var(--text-opacity));
  }
  .sm\\:active\\:text-blue-100:active {
    --text-opacity: 1;
    color: #e1effe;
    color: rgba(225, 239, 254, var(--text-opacity));
  }
  .sm\\:active\\:text-blue-200:active {
    --text-opacity: 1;
    color: #c3ddfd;
    color: rgba(195, 221, 253, var(--text-opacity));
  }
  .sm\\:active\\:text-blue-300:active {
    --text-opacity: 1;
    color: #a4cafe;
    color: rgba(164, 202, 254, var(--text-opacity));
  }
  .sm\\:active\\:text-blue-400:active {
    --text-opacity: 1;
    color: #76a9fa;
    color: rgba(118, 169, 250, var(--text-opacity));
  }
  .sm\\:active\\:text-blue-500:active {
    --text-opacity: 1;
    color: #3f83f8;
    color: rgba(63, 131, 248, var(--text-opacity));
  }
  .sm\\:active\\:text-blue-600:active {
    --text-opacity: 1;
    color: #1c64f2;
    color: rgba(28, 100, 242, var(--text-opacity));
  }
  .sm\\:active\\:text-blue-700:active {
    --text-opacity: 1;
    color: #1a56db;
    color: rgba(26, 86, 219, var(--text-opacity));
  }
  .sm\\:active\\:text-blue-800:active {
    --text-opacity: 1;
    color: #1e429f;
    color: rgba(30, 66, 159, var(--text-opacity));
  }
  .sm\\:active\\:text-blue-900:active {
    --text-opacity: 1;
    color: #233876;
    color: rgba(35, 56, 118, var(--text-opacity));
  }
  .sm\\:active\\:text-indigo-50:active {
    --text-opacity: 1;
    color: #f0f5ff;
    color: rgba(240, 245, 255, var(--text-opacity));
  }
  .sm\\:active\\:text-indigo-100:active {
    --text-opacity: 1;
    color: #e5edff;
    color: rgba(229, 237, 255, var(--text-opacity));
  }
  .sm\\:active\\:text-indigo-200:active {
    --text-opacity: 1;
    color: #cddbfe;
    color: rgba(205, 219, 254, var(--text-opacity));
  }
  .sm\\:active\\:text-indigo-300:active {
    --text-opacity: 1;
    color: #b4c6fc;
    color: rgba(180, 198, 252, var(--text-opacity));
  }
  .sm\\:active\\:text-indigo-400:active {
    --text-opacity: 1;
    color: #8da2fb;
    color: rgba(141, 162, 251, var(--text-opacity));
  }
  .sm\\:active\\:text-indigo-500:active {
    --text-opacity: 1;
    color: #6875f5;
    color: rgba(104, 117, 245, var(--text-opacity));
  }
  .sm\\:active\\:text-indigo-600:active {
    --text-opacity: 1;
    color: #5850ec;
    color: rgba(88, 80, 236, var(--text-opacity));
  }
  .sm\\:active\\:text-indigo-700:active {
    --text-opacity: 1;
    color: #5145cd;
    color: rgba(81, 69, 205, var(--text-opacity));
  }
  .sm\\:active\\:text-indigo-800:active {
    --text-opacity: 1;
    color: #42389d;
    color: rgba(66, 56, 157, var(--text-opacity));
  }
  .sm\\:active\\:text-indigo-900:active {
    --text-opacity: 1;
    color: #362f78;
    color: rgba(54, 47, 120, var(--text-opacity));
  }
  .sm\\:active\\:text-purple-50:active {
    --text-opacity: 1;
    color: #f6f5ff;
    color: rgba(246, 245, 255, var(--text-opacity));
  }
  .sm\\:active\\:text-purple-100:active {
    --text-opacity: 1;
    color: #edebfe;
    color: rgba(237, 235, 254, var(--text-opacity));
  }
  .sm\\:active\\:text-purple-200:active {
    --text-opacity: 1;
    color: #dcd7fe;
    color: rgba(220, 215, 254, var(--text-opacity));
  }
  .sm\\:active\\:text-purple-300:active {
    --text-opacity: 1;
    color: #cabffd;
    color: rgba(202, 191, 253, var(--text-opacity));
  }
  .sm\\:active\\:text-purple-400:active {
    --text-opacity: 1;
    color: #ac94fa;
    color: rgba(172, 148, 250, var(--text-opacity));
  }
  .sm\\:active\\:text-purple-500:active {
    --text-opacity: 1;
    color: #9061f9;
    color: rgba(144, 97, 249, var(--text-opacity));
  }
  .sm\\:active\\:text-purple-600:active {
    --text-opacity: 1;
    color: #7e3af2;
    color: rgba(126, 58, 242, var(--text-opacity));
  }
  .sm\\:active\\:text-purple-700:active {
    --text-opacity: 1;
    color: #6c2bd9;
    color: rgba(108, 43, 217, var(--text-opacity));
  }
  .sm\\:active\\:text-purple-800:active {
    --text-opacity: 1;
    color: #5521b5;
    color: rgba(85, 33, 181, var(--text-opacity));
  }
  .sm\\:active\\:text-purple-900:active {
    --text-opacity: 1;
    color: #4a1d96;
    color: rgba(74, 29, 150, var(--text-opacity));
  }
  .sm\\:active\\:text-pink-50:active {
    --text-opacity: 1;
    color: #fdf2f8;
    color: rgba(253, 242, 248, var(--text-opacity));
  }
  .sm\\:active\\:text-pink-100:active {
    --text-opacity: 1;
    color: #fce8f3;
    color: rgba(252, 232, 243, var(--text-opacity));
  }
  .sm\\:active\\:text-pink-200:active {
    --text-opacity: 1;
    color: #fad1e8;
    color: rgba(250, 209, 232, var(--text-opacity));
  }
  .sm\\:active\\:text-pink-300:active {
    --text-opacity: 1;
    color: #f8b4d9;
    color: rgba(248, 180, 217, var(--text-opacity));
  }
  .sm\\:active\\:text-pink-400:active {
    --text-opacity: 1;
    color: #f17eb8;
    color: rgba(241, 126, 184, var(--text-opacity));
  }
  .sm\\:active\\:text-pink-500:active {
    --text-opacity: 1;
    color: #e74694;
    color: rgba(231, 70, 148, var(--text-opacity));
  }
  .sm\\:active\\:text-pink-600:active {
    --text-opacity: 1;
    color: #d61f69;
    color: rgba(214, 31, 105, var(--text-opacity));
  }
  .sm\\:active\\:text-pink-700:active {
    --text-opacity: 1;
    color: #bf125d;
    color: rgba(191, 18, 93, var(--text-opacity));
  }
  .sm\\:active\\:text-pink-800:active {
    --text-opacity: 1;
    color: #99154b;
    color: rgba(153, 21, 75, var(--text-opacity));
  }
  .sm\\:active\\:text-pink-900:active {
    --text-opacity: 1;
    color: #751a3d;
    color: rgba(117, 26, 61, var(--text-opacity));
  }
  .sm\\:active\\:text-cool-gray-50:active {
    --text-opacity: 1;
    color: #f8fafc;
    color: rgba(248, 250, 252, var(--text-opacity));
  }
  .sm\\:active\\:text-cool-gray-100:active {
    --text-opacity: 1;
    color: #f1f5f9;
    color: rgba(241, 245, 249, var(--text-opacity));
  }
  .sm\\:active\\:text-cool-gray-200:active {
    --text-opacity: 1;
    color: #e2e8f0;
    color: rgba(226, 232, 240, var(--text-opacity));
  }
  .sm\\:active\\:text-cool-gray-300:active {
    --text-opacity: 1;
    color: #cfd8e3;
    color: rgba(207, 216, 227, var(--text-opacity));
  }
  .sm\\:active\\:text-cool-gray-400:active {
    --text-opacity: 1;
    color: #97a6ba;
    color: rgba(151, 166, 186, var(--text-opacity));
  }
  .sm\\:active\\:text-cool-gray-500:active {
    --text-opacity: 1;
    color: #64748b;
    color: rgba(100, 116, 139, var(--text-opacity));
  }
  .sm\\:active\\:text-cool-gray-600:active {
    --text-opacity: 1;
    color: #475569;
    color: rgba(71, 85, 105, var(--text-opacity));
  }
  .sm\\:active\\:text-cool-gray-700:active {
    --text-opacity: 1;
    color: #364152;
    color: rgba(54, 65, 82, var(--text-opacity));
  }
  .sm\\:active\\:text-cool-gray-800:active {
    --text-opacity: 1;
    color: #27303f;
    color: rgba(39, 48, 63, var(--text-opacity));
  }
  .sm\\:active\\:text-cool-gray-900:active {
    --text-opacity: 1;
    color: #1a202e;
    color: rgba(26, 32, 46, var(--text-opacity));
  }
  .sm\\:text-opacity-0 {
    --text-opacity: 0;
  }
  .sm\\:text-opacity-25 {
    --text-opacity: 0.25;
  }
  .sm\\:text-opacity-50 {
    --text-opacity: 0.5;
  }
  .sm\\:text-opacity-75 {
    --text-opacity: 0.75;
  }
  .sm\\:text-opacity-100 {
    --text-opacity: 1;
  }
  .sm\\:hover\\:text-opacity-0:hover {
    --text-opacity: 0;
  }
  .sm\\:hover\\:text-opacity-25:hover {
    --text-opacity: 0.25;
  }
  .sm\\:hover\\:text-opacity-50:hover {
    --text-opacity: 0.5;
  }
  .sm\\:hover\\:text-opacity-75:hover {
    --text-opacity: 0.75;
  }
  .sm\\:hover\\:text-opacity-100:hover {
    --text-opacity: 1;
  }
  .sm\\:focus\\:text-opacity-0:focus {
    --text-opacity: 0;
  }
  .sm\\:focus\\:text-opacity-25:focus {
    --text-opacity: 0.25;
  }
  .sm\\:focus\\:text-opacity-50:focus {
    --text-opacity: 0.5;
  }
  .sm\\:focus\\:text-opacity-75:focus {
    --text-opacity: 0.75;
  }
  .sm\\:focus\\:text-opacity-100:focus {
    --text-opacity: 1;
  }
  .sm\\:italic {
    font-style: italic;
  }
  .sm\\:not-italic {
    font-style: normal;
  }
  .sm\\:uppercase {
    text-transform: uppercase;
  }
  .sm\\:lowercase {
    text-transform: lowercase;
  }
  .sm\\:capitalize {
    text-transform: capitalize;
  }
  .sm\\:normal-case {
    text-transform: none;
  }
  .sm\\:underline {
    text-decoration: none;
  }
  .sm\\:line-through {
    text-decoration: line-through;
  }
  .sm\\:no-underline {
    text-decoration: none;
  }
  .group:hover .sm\\:group-hover\\:underline {
    text-decoration: none;
  }
  .group:hover .sm\\:group-hover\\:line-through {
    text-decoration: line-through;
  }
  .group:hover .sm\\:group-hover\\:no-underline {
    text-decoration: none;
  }
  .group:focus .sm\\:group-focus\\:underline {
    text-decoration: none;
  }
  .group:focus .sm\\:group-focus\\:line-through {
    text-decoration: line-through;
  }
  .group:focus .sm\\:group-focus\\:no-underline {
    text-decoration: none;
  }
  .sm\\:hover\\:underline:hover {
    text-decoration: none;
  }
  .sm\\:hover\\:line-through:hover {
    text-decoration: line-through;
  }
  .sm\\:hover\\:no-underline:hover {
    text-decoration: none;
  }
  .sm\\:focus\\:underline:focus {
    text-decoration: none;
  }
  .sm\\:focus\\:line-through:focus {
    text-decoration: line-through;
  }
  .sm\\:focus\\:no-underline:focus {
    text-decoration: none;
  }
  .sm\\:antialiased {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
  .sm\\:subpixel-antialiased {
    -webkit-font-smoothing: auto;
    -moz-osx-font-smoothing: auto;
  }
  .sm\\:ordinal, .sm\\:slashed-zero, .sm\\:lining-nums, .sm\\:oldstyle-nums, .sm\\:proportional-nums, .sm\\:tabular-nums, .sm\\:diagonal-fractions, .sm\\:stacked-fractions {
    --font-variant-numeric-ordinal: var(--tailwind-empty,
        /*!*/
        /*!*/
      );
    --font-variant-numeric-slashed-zero: var(--tailwind-empty,
        /*!*/
        /*!*/
      );
    --font-variant-numeric-figure: var(--tailwind-empty,
        /*!*/
        /*!*/
      );
    --font-variant-numeric-spacing: var(--tailwind-empty,
        /*!*/
        /*!*/
      );
    --font-variant-numeric-fraction: var(--tailwind-empty,
        /*!*/
        /*!*/
      );
    font-variant-numeric: var(--font-variant-numeric-ordinal) var(--font-variant-numeric-slashed-zero) var(--font-variant-numeric-figure) var(--font-variant-numeric-spacing) var(--font-variant-numeric-fraction);
  }
  .sm\\:normal-nums {
    font-variant-numeric: normal;
  }
  .sm\\:ordinal {
    --font-variant-numeric-ordinal: ordinal;
  }
  .sm\\:slashed-zero {
    --font-variant-numeric-slashed-zero: slashed-zero;
  }
  .sm\\:lining-nums {
    --font-variant-numeric-figure: lining-nums;
  }
  .sm\\:oldstyle-nums {
    --font-variant-numeric-figure: oldstyle-nums;
  }
  .sm\\:proportional-nums {
    --font-variant-numeric-spacing: proportional-nums;
  }
  .sm\\:tabular-nums {
    --font-variant-numeric-spacing: tabular-nums;
  }
  .sm\\:diagonal-fractions {
    --font-variant-numeric-fraction: diagonal-fractions;
  }
  .sm\\:stacked-fractions {
    --font-variant-numeric-fraction: stacked-fractions;
  }
  .sm\\:tracking-tighter {
    letter-spacing: -0.05em;
  }
  .sm\\:tracking-tight {
    letter-spacing: -0.025em;
  }
  .sm\\:tracking-normal {
    letter-spacing: 0;
  }
  .sm\\:tracking-wide {
    letter-spacing: 0.025em;
  }
  .sm\\:tracking-wider {
    letter-spacing: 0.05em;
  }
  .sm\\:tracking-widest {
    letter-spacing: 0.1em;
  }
  .sm\\:select-none {
    -webkit-user-select: none;
    user-select: none;
  }
  .sm\\:select-text {
    -webkit-user-select: text;
    user-select: text;
  }
  .sm\\:select-all {
    -webkit-user-select: all;
    user-select: all;
  }
  .sm\\:select-auto {
    -webkit-user-select: auto;
    user-select: auto;
  }
  .sm\\:align-baseline {
    vertical-align: baseline;
  }
  .sm\\:align-top {
    vertical-align: top;
  }
  .sm\\:align-middle {
    vertical-align: middle;
  }
  .sm\\:align-bottom {
    vertical-align: bottom;
  }
  .sm\\:align-text-top {
    vertical-align: text-top;
  }
  .sm\\:align-text-bottom {
    vertical-align: text-bottom;
  }
  .sm\\:visible {
    visibility: visible;
  }
  .sm\\:invisible {
    visibility: hidden;
  }
  .sm\\:whitespace-normal {
    white-space: normal;
  }
  .sm\\:whitespace-no-wrap {
    white-space: nowrap;
  }
  .sm\\:whitespace-pre {
    white-space: pre;
  }
  .sm\\:whitespace-pre-line {
    white-space: pre-line;
  }
  .sm\\:whitespace-pre-wrap {
    white-space: pre-wrap;
  }
  .sm\\:break-normal {
    word-wrap: normal;
    overflow-wrap: normal;
    word-break: normal;
  }
  .sm\\:break-words {
    word-wrap: break-word;
    overflow-wrap: break-word;
  }
  .sm\\:break-all {
    word-break: break-all;
  }
  .sm\\:truncate {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .sm\\:w-0 {
    width: 0;
  }
  .sm\\:w-1 {
    width: 0.25rem;
  }
  .sm\\:w-2 {
    width: 0.5rem;
  }
  .sm\\:w-3 {
    width: 0.75rem;
  }
  .sm\\:w-4 {
    width: 1rem;
  }
  .sm\\:w-5 {
    width: 1.25rem;
  }
  .sm\\:w-6 {
    width: 1.5rem;
  }
  .sm\\:w-7 {
    width: 1.75rem;
  }
  .sm\\:w-8 {
    width: 2rem;
  }
  .sm\\:w-9 {
    width: 2.25rem;
  }
  .sm\\:w-10 {
    width: 2.5rem;
  }
  .sm\\:w-11 {
    width: 2.75rem;
  }
  .sm\\:w-12 {
    width: 3rem;
  }
  .sm\\:w-13 {
    width: 3.25rem;
  }
  .sm\\:w-14 {
    width: 3.5rem;
  }
  .sm\\:w-15 {
    width: 3.75rem;
  }
  .sm\\:w-16 {
    width: 4rem;
  }
  .sm\\:w-20 {
    width: 5rem;
  }
  .sm\\:w-24 {
    width: 6rem;
  }
  .sm\\:w-28 {
    width: 7rem;
  }
  .sm\\:w-32 {
    width: 8rem;
  }
  .sm\\:w-36 {
    width: 9rem;
  }
  .sm\\:w-40 {
    width: 10rem;
  }
  .sm\\:w-44 {
    width: 11rem;
  }
  .sm\\:w-48 {
    width: 12rem;
  }
  .sm\\:w-52 {
    width: 13rem;
  }
  .sm\\:w-56 {
    width: 14rem;
  }
  .sm\\:w-60 {
    width: 15rem;
  }
  .sm\\:w-64 {
    width: 16rem;
  }
  .sm\\:w-72 {
    width: 18rem;
  }
  .sm\\:w-80 {
    width: 20rem;
  }
  .sm\\:w-96 {
    width: 24rem;
  }
  .sm\\:w-auto {
    width: auto;
  }
  .sm\\:w-px {
    width: 1px;
  }
  .sm\\:w-0\\.5 {
    width: 0.125rem;
  }
  .sm\\:w-1\\.5 {
    width: 0.375rem;
  }
  .sm\\:w-2\\.5 {
    width: 0.625rem;
  }
  .sm\\:w-3\\.5 {
    width: 0.875rem;
  }
  .sm\\:w-1\\/2 {
    width: 50%;
  }
  .sm\\:w-1\\/3 {
    width: 33.333333%;
  }
  .sm\\:w-2\\/3 {
    width: 66.666667%;
  }
  .sm\\:w-1\\/4 {
    width: 25%;
  }
  .sm\\:w-2\\/4 {
    width: 50%;
  }
  .sm\\:w-3\\/4 {
    width: 75%;
  }
  .sm\\:w-1\\/5 {
    width: 20%;
  }
  .sm\\:w-2\\/5 {
    width: 40%;
  }
  .sm\\:w-3\\/5 {
    width: 60%;
  }
  .sm\\:w-4\\/5 {
    width: 80%;
  }
  .sm\\:w-1\\/6 {
    width: 16.666667%;
  }
  .sm\\:w-2\\/6 {
    width: 33.333333%;
  }
  .sm\\:w-3\\/6 {
    width: 50%;
  }
  .sm\\:w-4\\/6 {
    width: 66.666667%;
  }
  .sm\\:w-5\\/6 {
    width: 83.333333%;
  }
  .sm\\:w-1\\/12 {
    width: 8.333333%;
  }
  .sm\\:w-2\\/12 {
    width: 16.666667%;
  }
  .sm\\:w-3\\/12 {
    width: 25%;
  }
  .sm\\:w-4\\/12 {
    width: 33.333333%;
  }
  .sm\\:w-5\\/12 {
    width: 41.666667%;
  }
  .sm\\:w-6\\/12 {
    width: 50%;
  }
  .sm\\:w-7\\/12 {
    width: 58.333333%;
  }
  .sm\\:w-8\\/12 {
    width: 66.666667%;
  }
  .sm\\:w-9\\/12 {
    width: 75%;
  }
  .sm\\:w-10\\/12 {
    width: 83.333333%;
  }
  .sm\\:w-11\\/12 {
    width: 91.666667%;
  }
  .sm\\:w-full {
    width: 100%;
  }
  .sm\\:w-screen {
    width: 100vw;
  }
  .sm\\:w-min-content {
    width: min-content;
  }
  .sm\\:w-max-content {
    width: max-content;
  }
  .sm\\:z-0 {
    z-index: 0;
  }
  .sm\\:z-10 {
    z-index: 10;
  }
  .sm\\:z-20 {
    z-index: 20;
  }
  .sm\\:z-30 {
    z-index: 30;
  }
  .sm\\:z-40 {
    z-index: 40;
  }
  .sm\\:z-50 {
    z-index: 50;
  }
  .sm\\:z-auto {
    z-index: auto;
  }
  .sm\\:focus-within\\:z-0:focus-within {
    z-index: 0;
  }
  .sm\\:focus-within\\:z-10:focus-within {
    z-index: 10;
  }
  .sm\\:focus-within\\:z-20:focus-within {
    z-index: 20;
  }
  .sm\\:focus-within\\:z-30:focus-within {
    z-index: 30;
  }
  .sm\\:focus-within\\:z-40:focus-within {
    z-index: 40;
  }
  .sm\\:focus-within\\:z-50:focus-within {
    z-index: 50;
  }
  .sm\\:focus-within\\:z-auto:focus-within {
    z-index: auto;
  }
  .sm\\:focus\\:z-0:focus {
    z-index: 0;
  }
  .sm\\:focus\\:z-10:focus {
    z-index: 10;
  }
  .sm\\:focus\\:z-20:focus {
    z-index: 20;
  }
  .sm\\:focus\\:z-30:focus {
    z-index: 30;
  }
  .sm\\:focus\\:z-40:focus {
    z-index: 40;
  }
  .sm\\:focus\\:z-50:focus {
    z-index: 50;
  }
  .sm\\:focus\\:z-auto:focus {
    z-index: auto;
  }
  .sm\\:gap-0 {
    grid-gap: 0;
    gap: 0;
  }
  .sm\\:gap-1 {
    grid-gap: 0.25rem;
    gap: 0.25rem;
  }
  .sm\\:gap-2 {
    grid-gap: 0.5rem;
    gap: 0.5rem;
  }
  .sm\\:gap-3 {
    grid-gap: 0.75rem;
    gap: 0.75rem;
  }
  .sm\\:gap-4 {
    grid-gap: 1rem;
    gap: 1rem;
  }
  .sm\\:gap-5 {
    grid-gap: 1.25rem;
    gap: 1.25rem;
  }
  .sm\\:gap-6 {
    grid-gap: 1.5rem;
    gap: 1.5rem;
  }
  .sm\\:gap-7 {
    grid-gap: 1.75rem;
    gap: 1.75rem;
  }
  .sm\\:gap-8 {
    grid-gap: 2rem;
    gap: 2rem;
  }
  .sm\\:gap-9 {
    grid-gap: 2.25rem;
    gap: 2.25rem;
  }
  .sm\\:gap-10 {
    grid-gap: 2.5rem;
    gap: 2.5rem;
  }
  .sm\\:gap-11 {
    grid-gap: 2.75rem;
    gap: 2.75rem;
  }
  .sm\\:gap-12 {
    grid-gap: 3rem;
    gap: 3rem;
  }
  .sm\\:gap-13 {
    grid-gap: 3.25rem;
    gap: 3.25rem;
  }
  .sm\\:gap-14 {
    grid-gap: 3.5rem;
    gap: 3.5rem;
  }
  .sm\\:gap-15 {
    grid-gap: 3.75rem;
    gap: 3.75rem;
  }
  .sm\\:gap-16 {
    grid-gap: 4rem;
    gap: 4rem;
  }
  .sm\\:gap-20 {
    grid-gap: 5rem;
    gap: 5rem;
  }
  .sm\\:gap-24 {
    grid-gap: 6rem;
    gap: 6rem;
  }
  .sm\\:gap-28 {
    grid-gap: 7rem;
    gap: 7rem;
  }
  .sm\\:gap-32 {
    grid-gap: 8rem;
    gap: 8rem;
  }
  .sm\\:gap-36 {
    grid-gap: 9rem;
    gap: 9rem;
  }
  .sm\\:gap-40 {
    grid-gap: 10rem;
    gap: 10rem;
  }
  .sm\\:gap-44 {
    grid-gap: 11rem;
    gap: 11rem;
  }
  .sm\\:gap-48 {
    grid-gap: 12rem;
    gap: 12rem;
  }
  .sm\\:gap-52 {
    grid-gap: 13rem;
    gap: 13rem;
  }
  .sm\\:gap-56 {
    grid-gap: 14rem;
    gap: 14rem;
  }
  .sm\\:gap-60 {
    grid-gap: 15rem;
    gap: 15rem;
  }
  .sm\\:gap-64 {
    grid-gap: 16rem;
    gap: 16rem;
  }
  .sm\\:gap-72 {
    grid-gap: 18rem;
    gap: 18rem;
  }
  .sm\\:gap-80 {
    grid-gap: 20rem;
    gap: 20rem;
  }
  .sm\\:gap-96 {
    grid-gap: 24rem;
    gap: 24rem;
  }
  .sm\\:gap-px {
    grid-gap: 1px;
    gap: 1px;
  }
  .sm\\:gap-0\\.5 {
    grid-gap: 0.125rem;
    gap: 0.125rem;
  }
  .sm\\:gap-1\\.5 {
    grid-gap: 0.375rem;
    gap: 0.375rem;
  }
  .sm\\:gap-2\\.5 {
    grid-gap: 0.625rem;
    gap: 0.625rem;
  }
  .sm\\:gap-3\\.5 {
    grid-gap: 0.875rem;
    gap: 0.875rem;
  }
  .sm\\:gap-1\\/2 {
    grid-gap: 50%;
    gap: 50%;
  }
  .sm\\:gap-1\\/3 {
    grid-gap: 33.333333%;
    gap: 33.333333%;
  }
  .sm\\:gap-2\\/3 {
    grid-gap: 66.666667%;
    gap: 66.666667%;
  }
  .sm\\:gap-1\\/4 {
    grid-gap: 25%;
    gap: 25%;
  }
  .sm\\:gap-2\\/4 {
    grid-gap: 50%;
    gap: 50%;
  }
  .sm\\:gap-3\\/4 {
    grid-gap: 75%;
    gap: 75%;
  }
  .sm\\:gap-1\\/5 {
    grid-gap: 20%;
    gap: 20%;
  }
  .sm\\:gap-2\\/5 {
    grid-gap: 40%;
    gap: 40%;
  }
  .sm\\:gap-3\\/5 {
    grid-gap: 60%;
    gap: 60%;
  }
  .sm\\:gap-4\\/5 {
    grid-gap: 80%;
    gap: 80%;
  }
  .sm\\:gap-1\\/6 {
    grid-gap: 16.666667%;
    gap: 16.666667%;
  }
  .sm\\:gap-2\\/6 {
    grid-gap: 33.333333%;
    gap: 33.333333%;
  }
  .sm\\:gap-3\\/6 {
    grid-gap: 50%;
    gap: 50%;
  }
  .sm\\:gap-4\\/6 {
    grid-gap: 66.666667%;
    gap: 66.666667%;
  }
  .sm\\:gap-5\\/6 {
    grid-gap: 83.333333%;
    gap: 83.333333%;
  }
  .sm\\:gap-1\\/12 {
    grid-gap: 8.333333%;
    gap: 8.333333%;
  }
  .sm\\:gap-2\\/12 {
    grid-gap: 16.666667%;
    gap: 16.666667%;
  }
  .sm\\:gap-3\\/12 {
    grid-gap: 25%;
    gap: 25%;
  }
  .sm\\:gap-4\\/12 {
    grid-gap: 33.333333%;
    gap: 33.333333%;
  }
  .sm\\:gap-5\\/12 {
    grid-gap: 41.666667%;
    gap: 41.666667%;
  }
  .sm\\:gap-6\\/12 {
    grid-gap: 50%;
    gap: 50%;
  }
  .sm\\:gap-7\\/12 {
    grid-gap: 58.333333%;
    gap: 58.333333%;
  }
  .sm\\:gap-8\\/12 {
    grid-gap: 66.666667%;
    gap: 66.666667%;
  }
  .sm\\:gap-9\\/12 {
    grid-gap: 75%;
    gap: 75%;
  }
  .sm\\:gap-10\\/12 {
    grid-gap: 83.333333%;
    gap: 83.333333%;
  }
  .sm\\:gap-11\\/12 {
    grid-gap: 91.666667%;
    gap: 91.666667%;
  }
  .sm\\:gap-full {
    grid-gap: 100%;
    gap: 100%;
  }
  .sm\\:col-gap-0 {
    grid-column-gap: 0;
    column-gap: 0;
  }
  .sm\\:col-gap-1 {
    grid-column-gap: 0.25rem;
    column-gap: 0.25rem;
  }
  .sm\\:col-gap-2 {
    grid-column-gap: 0.5rem;
    column-gap: 0.5rem;
  }
  .sm\\:col-gap-3 {
    grid-column-gap: 0.75rem;
    column-gap: 0.75rem;
  }
  .sm\\:col-gap-4 {
    grid-column-gap: 1rem;
    column-gap: 1rem;
  }
  .sm\\:col-gap-5 {
    grid-column-gap: 1.25rem;
    column-gap: 1.25rem;
  }
  .sm\\:col-gap-6 {
    grid-column-gap: 1.5rem;
    column-gap: 1.5rem;
  }
  .sm\\:col-gap-7 {
    grid-column-gap: 1.75rem;
    column-gap: 1.75rem;
  }
  .sm\\:col-gap-8 {
    grid-column-gap: 2rem;
    column-gap: 2rem;
  }
  .sm\\:col-gap-9 {
    grid-column-gap: 2.25rem;
    column-gap: 2.25rem;
  }
  .sm\\:col-gap-10 {
    grid-column-gap: 2.5rem;
    column-gap: 2.5rem;
  }
  .sm\\:col-gap-11 {
    grid-column-gap: 2.75rem;
    column-gap: 2.75rem;
  }
  .sm\\:col-gap-12 {
    grid-column-gap: 3rem;
    column-gap: 3rem;
  }
  .sm\\:col-gap-13 {
    grid-column-gap: 3.25rem;
    column-gap: 3.25rem;
  }
  .sm\\:col-gap-14 {
    grid-column-gap: 3.5rem;
    column-gap: 3.5rem;
  }
  .sm\\:col-gap-15 {
    grid-column-gap: 3.75rem;
    column-gap: 3.75rem;
  }
  .sm\\:col-gap-16 {
    grid-column-gap: 4rem;
    column-gap: 4rem;
  }
  .sm\\:col-gap-20 {
    grid-column-gap: 5rem;
    column-gap: 5rem;
  }
  .sm\\:col-gap-24 {
    grid-column-gap: 6rem;
    column-gap: 6rem;
  }
  .sm\\:col-gap-28 {
    grid-column-gap: 7rem;
    column-gap: 7rem;
  }
  .sm\\:col-gap-32 {
    grid-column-gap: 8rem;
    column-gap: 8rem;
  }
  .sm\\:col-gap-36 {
    grid-column-gap: 9rem;
    column-gap: 9rem;
  }
  .sm\\:col-gap-40 {
    grid-column-gap: 10rem;
    column-gap: 10rem;
  }
  .sm\\:col-gap-44 {
    grid-column-gap: 11rem;
    column-gap: 11rem;
  }
  .sm\\:col-gap-48 {
    grid-column-gap: 12rem;
    column-gap: 12rem;
  }
  .sm\\:col-gap-52 {
    grid-column-gap: 13rem;
    column-gap: 13rem;
  }
  .sm\\:col-gap-56 {
    grid-column-gap: 14rem;
    column-gap: 14rem;
  }
  .sm\\:col-gap-60 {
    grid-column-gap: 15rem;
    column-gap: 15rem;
  }
  .sm\\:col-gap-64 {
    grid-column-gap: 16rem;
    column-gap: 16rem;
  }
  .sm\\:col-gap-72 {
    grid-column-gap: 18rem;
    column-gap: 18rem;
  }
  .sm\\:col-gap-80 {
    grid-column-gap: 20rem;
    column-gap: 20rem;
  }
  .sm\\:col-gap-96 {
    grid-column-gap: 24rem;
    column-gap: 24rem;
  }
  .sm\\:col-gap-px {
    grid-column-gap: 1px;
    column-gap: 1px;
  }
  .sm\\:col-gap-0\\.5 {
    grid-column-gap: 0.125rem;
    column-gap: 0.125rem;
  }
  .sm\\:col-gap-1\\.5 {
    grid-column-gap: 0.375rem;
    column-gap: 0.375rem;
  }
  .sm\\:col-gap-2\\.5 {
    grid-column-gap: 0.625rem;
    column-gap: 0.625rem;
  }
  .sm\\:col-gap-3\\.5 {
    grid-column-gap: 0.875rem;
    column-gap: 0.875rem;
  }
  .sm\\:col-gap-1\\/2 {
    grid-column-gap: 50%;
    column-gap: 50%;
  }
  .sm\\:col-gap-1\\/3 {
    grid-column-gap: 33.333333%;
    column-gap: 33.333333%;
  }
  .sm\\:col-gap-2\\/3 {
    grid-column-gap: 66.666667%;
    column-gap: 66.666667%;
  }
  .sm\\:col-gap-1\\/4 {
    grid-column-gap: 25%;
    column-gap: 25%;
  }
  .sm\\:col-gap-2\\/4 {
    grid-column-gap: 50%;
    column-gap: 50%;
  }
  .sm\\:col-gap-3\\/4 {
    grid-column-gap: 75%;
    column-gap: 75%;
  }
  .sm\\:col-gap-1\\/5 {
    grid-column-gap: 20%;
    column-gap: 20%;
  }
  .sm\\:col-gap-2\\/5 {
    grid-column-gap: 40%;
    column-gap: 40%;
  }
  .sm\\:col-gap-3\\/5 {
    grid-column-gap: 60%;
    column-gap: 60%;
  }
  .sm\\:col-gap-4\\/5 {
    grid-column-gap: 80%;
    column-gap: 80%;
  }
  .sm\\:col-gap-1\\/6 {
    grid-column-gap: 16.666667%;
    column-gap: 16.666667%;
  }
  .sm\\:col-gap-2\\/6 {
    grid-column-gap: 33.333333%;
    column-gap: 33.333333%;
  }
  .sm\\:col-gap-3\\/6 {
    grid-column-gap: 50%;
    column-gap: 50%;
  }
  .sm\\:col-gap-4\\/6 {
    grid-column-gap: 66.666667%;
    column-gap: 66.666667%;
  }
  .sm\\:col-gap-5\\/6 {
    grid-column-gap: 83.333333%;
    column-gap: 83.333333%;
  }
  .sm\\:col-gap-1\\/12 {
    grid-column-gap: 8.333333%;
    column-gap: 8.333333%;
  }
  .sm\\:col-gap-2\\/12 {
    grid-column-gap: 16.666667%;
    column-gap: 16.666667%;
  }
  .sm\\:col-gap-3\\/12 {
    grid-column-gap: 25%;
    column-gap: 25%;
  }
  .sm\\:col-gap-4\\/12 {
    grid-column-gap: 33.333333%;
    column-gap: 33.333333%;
  }
  .sm\\:col-gap-5\\/12 {
    grid-column-gap: 41.666667%;
    column-gap: 41.666667%;
  }
  .sm\\:col-gap-6\\/12 {
    grid-column-gap: 50%;
    column-gap: 50%;
  }
  .sm\\:col-gap-7\\/12 {
    grid-column-gap: 58.333333%;
    column-gap: 58.333333%;
  }
  .sm\\:col-gap-8\\/12 {
    grid-column-gap: 66.666667%;
    column-gap: 66.666667%;
  }
  .sm\\:col-gap-9\\/12 {
    grid-column-gap: 75%;
    column-gap: 75%;
  }
  .sm\\:col-gap-10\\/12 {
    grid-column-gap: 83.333333%;
    column-gap: 83.333333%;
  }
  .sm\\:col-gap-11\\/12 {
    grid-column-gap: 91.666667%;
    column-gap: 91.666667%;
  }
  .sm\\:col-gap-full {
    grid-column-gap: 100%;
    column-gap: 100%;
  }
  .sm\\:gap-x-0 {
    grid-column-gap: 0;
    column-gap: 0;
  }
  .sm\\:gap-x-1 {
    grid-column-gap: 0.25rem;
    column-gap: 0.25rem;
  }
  .sm\\:gap-x-2 {
    grid-column-gap: 0.5rem;
    column-gap: 0.5rem;
  }
  .sm\\:gap-x-3 {
    grid-column-gap: 0.75rem;
    column-gap: 0.75rem;
  }
  .sm\\:gap-x-4 {
    grid-column-gap: 1rem;
    column-gap: 1rem;
  }
  .sm\\:gap-x-5 {
    grid-column-gap: 1.25rem;
    column-gap: 1.25rem;
  }
  .sm\\:gap-x-6 {
    grid-column-gap: 1.5rem;
    column-gap: 1.5rem;
  }
  .sm\\:gap-x-7 {
    grid-column-gap: 1.75rem;
    column-gap: 1.75rem;
  }
  .sm\\:gap-x-8 {
    grid-column-gap: 2rem;
    column-gap: 2rem;
  }
  .sm\\:gap-x-9 {
    grid-column-gap: 2.25rem;
    column-gap: 2.25rem;
  }
  .sm\\:gap-x-10 {
    grid-column-gap: 2.5rem;
    column-gap: 2.5rem;
  }
  .sm\\:gap-x-11 {
    grid-column-gap: 2.75rem;
    column-gap: 2.75rem;
  }
  .sm\\:gap-x-12 {
    grid-column-gap: 3rem;
    column-gap: 3rem;
  }
  .sm\\:gap-x-13 {
    grid-column-gap: 3.25rem;
    column-gap: 3.25rem;
  }
  .sm\\:gap-x-14 {
    grid-column-gap: 3.5rem;
    column-gap: 3.5rem;
  }
  .sm\\:gap-x-15 {
    grid-column-gap: 3.75rem;
    column-gap: 3.75rem;
  }
  .sm\\:gap-x-16 {
    grid-column-gap: 4rem;
    column-gap: 4rem;
  }
  .sm\\:gap-x-20 {
    grid-column-gap: 5rem;
    column-gap: 5rem;
  }
  .sm\\:gap-x-24 {
    grid-column-gap: 6rem;
    column-gap: 6rem;
  }
  .sm\\:gap-x-28 {
    grid-column-gap: 7rem;
    column-gap: 7rem;
  }
  .sm\\:gap-x-32 {
    grid-column-gap: 8rem;
    column-gap: 8rem;
  }
  .sm\\:gap-x-36 {
    grid-column-gap: 9rem;
    column-gap: 9rem;
  }
  .sm\\:gap-x-40 {
    grid-column-gap: 10rem;
    column-gap: 10rem;
  }
  .sm\\:gap-x-44 {
    grid-column-gap: 11rem;
    column-gap: 11rem;
  }
  .sm\\:gap-x-48 {
    grid-column-gap: 12rem;
    column-gap: 12rem;
  }
  .sm\\:gap-x-52 {
    grid-column-gap: 13rem;
    column-gap: 13rem;
  }
  .sm\\:gap-x-56 {
    grid-column-gap: 14rem;
    column-gap: 14rem;
  }
  .sm\\:gap-x-60 {
    grid-column-gap: 15rem;
    column-gap: 15rem;
  }
  .sm\\:gap-x-64 {
    grid-column-gap: 16rem;
    column-gap: 16rem;
  }
  .sm\\:gap-x-72 {
    grid-column-gap: 18rem;
    column-gap: 18rem;
  }
  .sm\\:gap-x-80 {
    grid-column-gap: 20rem;
    column-gap: 20rem;
  }
  .sm\\:gap-x-96 {
    grid-column-gap: 24rem;
    column-gap: 24rem;
  }
  .sm\\:gap-x-px {
    grid-column-gap: 1px;
    column-gap: 1px;
  }
  .sm\\:gap-x-0\\.5 {
    grid-column-gap: 0.125rem;
    column-gap: 0.125rem;
  }
  .sm\\:gap-x-1\\.5 {
    grid-column-gap: 0.375rem;
    column-gap: 0.375rem;
  }
  .sm\\:gap-x-2\\.5 {
    grid-column-gap: 0.625rem;
    column-gap: 0.625rem;
  }
  .sm\\:gap-x-3\\.5 {
    grid-column-gap: 0.875rem;
    column-gap: 0.875rem;
  }
  .sm\\:gap-x-1\\/2 {
    grid-column-gap: 50%;
    column-gap: 50%;
  }
  .sm\\:gap-x-1\\/3 {
    grid-column-gap: 33.333333%;
    column-gap: 33.333333%;
  }
  .sm\\:gap-x-2\\/3 {
    grid-column-gap: 66.666667%;
    column-gap: 66.666667%;
  }
  .sm\\:gap-x-1\\/4 {
    grid-column-gap: 25%;
    column-gap: 25%;
  }
  .sm\\:gap-x-2\\/4 {
    grid-column-gap: 50%;
    column-gap: 50%;
  }
  .sm\\:gap-x-3\\/4 {
    grid-column-gap: 75%;
    column-gap: 75%;
  }
  .sm\\:gap-x-1\\/5 {
    grid-column-gap: 20%;
    column-gap: 20%;
  }
  .sm\\:gap-x-2\\/5 {
    grid-column-gap: 40%;
    column-gap: 40%;
  }
  .sm\\:gap-x-3\\/5 {
    grid-column-gap: 60%;
    column-gap: 60%;
  }
  .sm\\:gap-x-4\\/5 {
    grid-column-gap: 80%;
    column-gap: 80%;
  }
  .sm\\:gap-x-1\\/6 {
    grid-column-gap: 16.666667%;
    column-gap: 16.666667%;
  }
  .sm\\:gap-x-2\\/6 {
    grid-column-gap: 33.333333%;
    column-gap: 33.333333%;
  }
  .sm\\:gap-x-3\\/6 {
    grid-column-gap: 50%;
    column-gap: 50%;
  }
  .sm\\:gap-x-4\\/6 {
    grid-column-gap: 66.666667%;
    column-gap: 66.666667%;
  }
  .sm\\:gap-x-5\\/6 {
    grid-column-gap: 83.333333%;
    column-gap: 83.333333%;
  }
  .sm\\:gap-x-1\\/12 {
    grid-column-gap: 8.333333%;
    column-gap: 8.333333%;
  }
  .sm\\:gap-x-2\\/12 {
    grid-column-gap: 16.666667%;
    column-gap: 16.666667%;
  }
  .sm\\:gap-x-3\\/12 {
    grid-column-gap: 25%;
    column-gap: 25%;
  }
  .sm\\:gap-x-4\\/12 {
    grid-column-gap: 33.333333%;
    column-gap: 33.333333%;
  }
  .sm\\:gap-x-5\\/12 {
    grid-column-gap: 41.666667%;
    column-gap: 41.666667%;
  }
  .sm\\:gap-x-6\\/12 {
    grid-column-gap: 50%;
    column-gap: 50%;
  }
  .sm\\:gap-x-7\\/12 {
    grid-column-gap: 58.333333%;
    column-gap: 58.333333%;
  }
  .sm\\:gap-x-8\\/12 {
    grid-column-gap: 66.666667%;
    column-gap: 66.666667%;
  }
  .sm\\:gap-x-9\\/12 {
    grid-column-gap: 75%;
    column-gap: 75%;
  }
  .sm\\:gap-x-10\\/12 {
    grid-column-gap: 83.333333%;
    column-gap: 83.333333%;
  }
  .sm\\:gap-x-11\\/12 {
    grid-column-gap: 91.666667%;
    column-gap: 91.666667%;
  }
  .sm\\:gap-x-full {
    grid-column-gap: 100%;
    column-gap: 100%;
  }
  .sm\\:row-gap-0 {
    grid-row-gap: 0;
    row-gap: 0;
  }
  .sm\\:row-gap-1 {
    grid-row-gap: 0.25rem;
    row-gap: 0.25rem;
  }
  .sm\\:row-gap-2 {
    grid-row-gap: 0.5rem;
    row-gap: 0.5rem;
  }
  .sm\\:row-gap-3 {
    grid-row-gap: 0.75rem;
    row-gap: 0.75rem;
  }
  .sm\\:row-gap-4 {
    grid-row-gap: 1rem;
    row-gap: 1rem;
  }
  .sm\\:row-gap-5 {
    grid-row-gap: 1.25rem;
    row-gap: 1.25rem;
  }
  .sm\\:row-gap-6 {
    grid-row-gap: 1.5rem;
    row-gap: 1.5rem;
  }
  .sm\\:row-gap-7 {
    grid-row-gap: 1.75rem;
    row-gap: 1.75rem;
  }
  .sm\\:row-gap-8 {
    grid-row-gap: 2rem;
    row-gap: 2rem;
  }
  .sm\\:row-gap-9 {
    grid-row-gap: 2.25rem;
    row-gap: 2.25rem;
  }
  .sm\\:row-gap-10 {
    grid-row-gap: 2.5rem;
    row-gap: 2.5rem;
  }
  .sm\\:row-gap-11 {
    grid-row-gap: 2.75rem;
    row-gap: 2.75rem;
  }
  .sm\\:row-gap-12 {
    grid-row-gap: 3rem;
    row-gap: 3rem;
  }
  .sm\\:row-gap-13 {
    grid-row-gap: 3.25rem;
    row-gap: 3.25rem;
  }
  .sm\\:row-gap-14 {
    grid-row-gap: 3.5rem;
    row-gap: 3.5rem;
  }
  .sm\\:row-gap-15 {
    grid-row-gap: 3.75rem;
    row-gap: 3.75rem;
  }
  .sm\\:row-gap-16 {
    grid-row-gap: 4rem;
    row-gap: 4rem;
  }
  .sm\\:row-gap-20 {
    grid-row-gap: 5rem;
    row-gap: 5rem;
  }
  .sm\\:row-gap-24 {
    grid-row-gap: 6rem;
    row-gap: 6rem;
  }
  .sm\\:row-gap-28 {
    grid-row-gap: 7rem;
    row-gap: 7rem;
  }
  .sm\\:row-gap-32 {
    grid-row-gap: 8rem;
    row-gap: 8rem;
  }
  .sm\\:row-gap-36 {
    grid-row-gap: 9rem;
    row-gap: 9rem;
  }
  .sm\\:row-gap-40 {
    grid-row-gap: 10rem;
    row-gap: 10rem;
  }
  .sm\\:row-gap-44 {
    grid-row-gap: 11rem;
    row-gap: 11rem;
  }
  .sm\\:row-gap-48 {
    grid-row-gap: 12rem;
    row-gap: 12rem;
  }
  .sm\\:row-gap-52 {
    grid-row-gap: 13rem;
    row-gap: 13rem;
  }
  .sm\\:row-gap-56 {
    grid-row-gap: 14rem;
    row-gap: 14rem;
  }
  .sm\\:row-gap-60 {
    grid-row-gap: 15rem;
    row-gap: 15rem;
  }
  .sm\\:row-gap-64 {
    grid-row-gap: 16rem;
    row-gap: 16rem;
  }
  .sm\\:row-gap-72 {
    grid-row-gap: 18rem;
    row-gap: 18rem;
  }
  .sm\\:row-gap-80 {
    grid-row-gap: 20rem;
    row-gap: 20rem;
  }
  .sm\\:row-gap-96 {
    grid-row-gap: 24rem;
    row-gap: 24rem;
  }
  .sm\\:row-gap-px {
    grid-row-gap: 1px;
    row-gap: 1px;
  }
  .sm\\:row-gap-0\\.5 {
    grid-row-gap: 0.125rem;
    row-gap: 0.125rem;
  }
  .sm\\:row-gap-1\\.5 {
    grid-row-gap: 0.375rem;
    row-gap: 0.375rem;
  }
  .sm\\:row-gap-2\\.5 {
    grid-row-gap: 0.625rem;
    row-gap: 0.625rem;
  }
  .sm\\:row-gap-3\\.5 {
    grid-row-gap: 0.875rem;
    row-gap: 0.875rem;
  }
  .sm\\:row-gap-1\\/2 {
    grid-row-gap: 50%;
    row-gap: 50%;
  }
  .sm\\:row-gap-1\\/3 {
    grid-row-gap: 33.333333%;
    row-gap: 33.333333%;
  }
  .sm\\:row-gap-2\\/3 {
    grid-row-gap: 66.666667%;
    row-gap: 66.666667%;
  }
  .sm\\:row-gap-1\\/4 {
    grid-row-gap: 25%;
    row-gap: 25%;
  }
  .sm\\:row-gap-2\\/4 {
    grid-row-gap: 50%;
    row-gap: 50%;
  }
  .sm\\:row-gap-3\\/4 {
    grid-row-gap: 75%;
    row-gap: 75%;
  }
  .sm\\:row-gap-1\\/5 {
    grid-row-gap: 20%;
    row-gap: 20%;
  }
  .sm\\:row-gap-2\\/5 {
    grid-row-gap: 40%;
    row-gap: 40%;
  }
  .sm\\:row-gap-3\\/5 {
    grid-row-gap: 60%;
    row-gap: 60%;
  }
  .sm\\:row-gap-4\\/5 {
    grid-row-gap: 80%;
    row-gap: 80%;
  }
  .sm\\:row-gap-1\\/6 {
    grid-row-gap: 16.666667%;
    row-gap: 16.666667%;
  }
  .sm\\:row-gap-2\\/6 {
    grid-row-gap: 33.333333%;
    row-gap: 33.333333%;
  }
  .sm\\:row-gap-3\\/6 {
    grid-row-gap: 50%;
    row-gap: 50%;
  }
  .sm\\:row-gap-4\\/6 {
    grid-row-gap: 66.666667%;
    row-gap: 66.666667%;
  }
  .sm\\:row-gap-5\\/6 {
    grid-row-gap: 83.333333%;
    row-gap: 83.333333%;
  }
  .sm\\:row-gap-1\\/12 {
    grid-row-gap: 8.333333%;
    row-gap: 8.333333%;
  }
  .sm\\:row-gap-2\\/12 {
    grid-row-gap: 16.666667%;
    row-gap: 16.666667%;
  }
  .sm\\:row-gap-3\\/12 {
    grid-row-gap: 25%;
    row-gap: 25%;
  }
  .sm\\:row-gap-4\\/12 {
    grid-row-gap: 33.333333%;
    row-gap: 33.333333%;
  }
  .sm\\:row-gap-5\\/12 {
    grid-row-gap: 41.666667%;
    row-gap: 41.666667%;
  }
  .sm\\:row-gap-6\\/12 {
    grid-row-gap: 50%;
    row-gap: 50%;
  }
  .sm\\:row-gap-7\\/12 {
    grid-row-gap: 58.333333%;
    row-gap: 58.333333%;
  }
  .sm\\:row-gap-8\\/12 {
    grid-row-gap: 66.666667%;
    row-gap: 66.666667%;
  }
  .sm\\:row-gap-9\\/12 {
    grid-row-gap: 75%;
    row-gap: 75%;
  }
  .sm\\:row-gap-10\\/12 {
    grid-row-gap: 83.333333%;
    row-gap: 83.333333%;
  }
  .sm\\:row-gap-11\\/12 {
    grid-row-gap: 91.666667%;
    row-gap: 91.666667%;
  }
  .sm\\:row-gap-full {
    grid-row-gap: 100%;
    row-gap: 100%;
  }
  .sm\\:gap-y-0 {
    grid-row-gap: 0;
    row-gap: 0;
  }
  .sm\\:gap-y-1 {
    grid-row-gap: 0.25rem;
    row-gap: 0.25rem;
  }
  .sm\\:gap-y-2 {
    grid-row-gap: 0.5rem;
    row-gap: 0.5rem;
  }
  .sm\\:gap-y-3 {
    grid-row-gap: 0.75rem;
    row-gap: 0.75rem;
  }
  .sm\\:gap-y-4 {
    grid-row-gap: 1rem;
    row-gap: 1rem;
  }
  .sm\\:gap-y-5 {
    grid-row-gap: 1.25rem;
    row-gap: 1.25rem;
  }
  .sm\\:gap-y-6 {
    grid-row-gap: 1.5rem;
    row-gap: 1.5rem;
  }
  .sm\\:gap-y-7 {
    grid-row-gap: 1.75rem;
    row-gap: 1.75rem;
  }
  .sm\\:gap-y-8 {
    grid-row-gap: 2rem;
    row-gap: 2rem;
  }
  .sm\\:gap-y-9 {
    grid-row-gap: 2.25rem;
    row-gap: 2.25rem;
  }
  .sm\\:gap-y-10 {
    grid-row-gap: 2.5rem;
    row-gap: 2.5rem;
  }
  .sm\\:gap-y-11 {
    grid-row-gap: 2.75rem;
    row-gap: 2.75rem;
  }
  .sm\\:gap-y-12 {
    grid-row-gap: 3rem;
    row-gap: 3rem;
  }
  .sm\\:gap-y-13 {
    grid-row-gap: 3.25rem;
    row-gap: 3.25rem;
  }
  .sm\\:gap-y-14 {
    grid-row-gap: 3.5rem;
    row-gap: 3.5rem;
  }
  .sm\\:gap-y-15 {
    grid-row-gap: 3.75rem;
    row-gap: 3.75rem;
  }
  .sm\\:gap-y-16 {
    grid-row-gap: 4rem;
    row-gap: 4rem;
  }
  .sm\\:gap-y-20 {
    grid-row-gap: 5rem;
    row-gap: 5rem;
  }
  .sm\\:gap-y-24 {
    grid-row-gap: 6rem;
    row-gap: 6rem;
  }
  .sm\\:gap-y-28 {
    grid-row-gap: 7rem;
    row-gap: 7rem;
  }
  .sm\\:gap-y-32 {
    grid-row-gap: 8rem;
    row-gap: 8rem;
  }
  .sm\\:gap-y-36 {
    grid-row-gap: 9rem;
    row-gap: 9rem;
  }
  .sm\\:gap-y-40 {
    grid-row-gap: 10rem;
    row-gap: 10rem;
  }
  .sm\\:gap-y-44 {
    grid-row-gap: 11rem;
    row-gap: 11rem;
  }
  .sm\\:gap-y-48 {
    grid-row-gap: 12rem;
    row-gap: 12rem;
  }
  .sm\\:gap-y-52 {
    grid-row-gap: 13rem;
    row-gap: 13rem;
  }
  .sm\\:gap-y-56 {
    grid-row-gap: 14rem;
    row-gap: 14rem;
  }
  .sm\\:gap-y-60 {
    grid-row-gap: 15rem;
    row-gap: 15rem;
  }
  .sm\\:gap-y-64 {
    grid-row-gap: 16rem;
    row-gap: 16rem;
  }
  .sm\\:gap-y-72 {
    grid-row-gap: 18rem;
    row-gap: 18rem;
  }
  .sm\\:gap-y-80 {
    grid-row-gap: 20rem;
    row-gap: 20rem;
  }
  .sm\\:gap-y-96 {
    grid-row-gap: 24rem;
    row-gap: 24rem;
  }
  .sm\\:gap-y-px {
    grid-row-gap: 1px;
    row-gap: 1px;
  }
  .sm\\:gap-y-0\\.5 {
    grid-row-gap: 0.125rem;
    row-gap: 0.125rem;
  }
  .sm\\:gap-y-1\\.5 {
    grid-row-gap: 0.375rem;
    row-gap: 0.375rem;
  }
  .sm\\:gap-y-2\\.5 {
    grid-row-gap: 0.625rem;
    row-gap: 0.625rem;
  }
  .sm\\:gap-y-3\\.5 {
    grid-row-gap: 0.875rem;
    row-gap: 0.875rem;
  }
  .sm\\:gap-y-1\\/2 {
    grid-row-gap: 50%;
    row-gap: 50%;
  }
  .sm\\:gap-y-1\\/3 {
    grid-row-gap: 33.333333%;
    row-gap: 33.333333%;
  }
  .sm\\:gap-y-2\\/3 {
    grid-row-gap: 66.666667%;
    row-gap: 66.666667%;
  }
  .sm\\:gap-y-1\\/4 {
    grid-row-gap: 25%;
    row-gap: 25%;
  }
  .sm\\:gap-y-2\\/4 {
    grid-row-gap: 50%;
    row-gap: 50%;
  }
  .sm\\:gap-y-3\\/4 {
    grid-row-gap: 75%;
    row-gap: 75%;
  }
  .sm\\:gap-y-1\\/5 {
    grid-row-gap: 20%;
    row-gap: 20%;
  }
  .sm\\:gap-y-2\\/5 {
    grid-row-gap: 40%;
    row-gap: 40%;
  }
  .sm\\:gap-y-3\\/5 {
    grid-row-gap: 60%;
    row-gap: 60%;
  }
  .sm\\:gap-y-4\\/5 {
    grid-row-gap: 80%;
    row-gap: 80%;
  }
  .sm\\:gap-y-1\\/6 {
    grid-row-gap: 16.666667%;
    row-gap: 16.666667%;
  }
  .sm\\:gap-y-2\\/6 {
    grid-row-gap: 33.333333%;
    row-gap: 33.333333%;
  }
  .sm\\:gap-y-3\\/6 {
    grid-row-gap: 50%;
    row-gap: 50%;
  }
  .sm\\:gap-y-4\\/6 {
    grid-row-gap: 66.666667%;
    row-gap: 66.666667%;
  }
  .sm\\:gap-y-5\\/6 {
    grid-row-gap: 83.333333%;
    row-gap: 83.333333%;
  }
  .sm\\:gap-y-1\\/12 {
    grid-row-gap: 8.333333%;
    row-gap: 8.333333%;
  }
  .sm\\:gap-y-2\\/12 {
    grid-row-gap: 16.666667%;
    row-gap: 16.666667%;
  }
  .sm\\:gap-y-3\\/12 {
    grid-row-gap: 25%;
    row-gap: 25%;
  }
  .sm\\:gap-y-4\\/12 {
    grid-row-gap: 33.333333%;
    row-gap: 33.333333%;
  }
  .sm\\:gap-y-5\\/12 {
    grid-row-gap: 41.666667%;
    row-gap: 41.666667%;
  }
  .sm\\:gap-y-6\\/12 {
    grid-row-gap: 50%;
    row-gap: 50%;
  }
  .sm\\:gap-y-7\\/12 {
    grid-row-gap: 58.333333%;
    row-gap: 58.333333%;
  }
  .sm\\:gap-y-8\\/12 {
    grid-row-gap: 66.666667%;
    row-gap: 66.666667%;
  }
  .sm\\:gap-y-9\\/12 {
    grid-row-gap: 75%;
    row-gap: 75%;
  }
  .sm\\:gap-y-10\\/12 {
    grid-row-gap: 83.333333%;
    row-gap: 83.333333%;
  }
  .sm\\:gap-y-11\\/12 {
    grid-row-gap: 91.666667%;
    row-gap: 91.666667%;
  }
  .sm\\:gap-y-full {
    grid-row-gap: 100%;
    row-gap: 100%;
  }
  .sm\\:grid-flow-row {
    grid-auto-flow: row;
  }
  .sm\\:grid-flow-col {
    grid-auto-flow: column;
  }
  .sm\\:grid-flow-row-dense {
    grid-auto-flow: row dense;
  }
  .sm\\:grid-flow-col-dense {
    grid-auto-flow: column dense;
  }
  .sm\\:grid-cols-1 {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }
  .sm\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .sm\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .sm\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
  .sm\\:grid-cols-5 {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }
  .sm\\:grid-cols-6 {
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }
  .sm\\:grid-cols-7 {
    grid-template-columns: repeat(7, minmax(0, 1fr));
  }
  .sm\\:grid-cols-8 {
    grid-template-columns: repeat(8, minmax(0, 1fr));
  }
  .sm\\:grid-cols-9 {
    grid-template-columns: repeat(9, minmax(0, 1fr));
  }
  .sm\\:grid-cols-10 {
    grid-template-columns: repeat(10, minmax(0, 1fr));
  }
  .sm\\:grid-cols-11 {
    grid-template-columns: repeat(11, minmax(0, 1fr));
  }
  .sm\\:grid-cols-12 {
    grid-template-columns: repeat(12, minmax(0, 1fr));
  }
  .sm\\:grid-cols-none {
    grid-template-columns: none;
  }
  .sm\\:auto-cols-auto {
    grid-auto-columns: auto;
  }
  .sm\\:auto-cols-min {
    grid-auto-columns: min-content;
  }
  .sm\\:auto-cols-max {
    grid-auto-columns: max-content;
  }
  .sm\\:auto-cols-fr {
    grid-auto-columns: minmax(0, 1fr);
  }
  .sm\\:col-auto {
    grid-column: auto;
  }
  .sm\\:col-span-1 {
    grid-column: span 1 / span 1;
  }
  .sm\\:col-span-2 {
    grid-column: span 2 / span 2;
  }
  .sm\\:col-span-3 {
    grid-column: span 3 / span 3;
  }
  .sm\\:col-span-4 {
    grid-column: span 4 / span 4;
  }
  .sm\\:col-span-5 {
    grid-column: span 5 / span 5;
  }
  .sm\\:col-span-6 {
    grid-column: span 6 / span 6;
  }
  .sm\\:col-span-7 {
    grid-column: span 7 / span 7;
  }
  .sm\\:col-span-8 {
    grid-column: span 8 / span 8;
  }
  .sm\\:col-span-9 {
    grid-column: span 9 / span 9;
  }
  .sm\\:col-span-10 {
    grid-column: span 10 / span 10;
  }
  .sm\\:col-span-11 {
    grid-column: span 11 / span 11;
  }
  .sm\\:col-span-12 {
    grid-column: span 12 / span 12;
  }
  .sm\\:col-span-full {
    grid-column: 1 / -1;
  }
  .sm\\:col-start-1 {
    grid-column-start: 1;
  }
  .sm\\:col-start-2 {
    grid-column-start: 2;
  }
  .sm\\:col-start-3 {
    grid-column-start: 3;
  }
  .sm\\:col-start-4 {
    grid-column-start: 4;
  }
  .sm\\:col-start-5 {
    grid-column-start: 5;
  }
  .sm\\:col-start-6 {
    grid-column-start: 6;
  }
  .sm\\:col-start-7 {
    grid-column-start: 7;
  }
  .sm\\:col-start-8 {
    grid-column-start: 8;
  }
  .sm\\:col-start-9 {
    grid-column-start: 9;
  }
  .sm\\:col-start-10 {
    grid-column-start: 10;
  }
  .sm\\:col-start-11 {
    grid-column-start: 11;
  }
  .sm\\:col-start-12 {
    grid-column-start: 12;
  }
  .sm\\:col-start-13 {
    grid-column-start: 13;
  }
  .sm\\:col-start-auto {
    grid-column-start: auto;
  }
  .sm\\:col-end-1 {
    grid-column-end: 1;
  }
  .sm\\:col-end-2 {
    grid-column-end: 2;
  }
  .sm\\:col-end-3 {
    grid-column-end: 3;
  }
  .sm\\:col-end-4 {
    grid-column-end: 4;
  }
  .sm\\:col-end-5 {
    grid-column-end: 5;
  }
  .sm\\:col-end-6 {
    grid-column-end: 6;
  }
  .sm\\:col-end-7 {
    grid-column-end: 7;
  }
  .sm\\:col-end-8 {
    grid-column-end: 8;
  }
  .sm\\:col-end-9 {
    grid-column-end: 9;
  }
  .sm\\:col-end-10 {
    grid-column-end: 10;
  }
  .sm\\:col-end-11 {
    grid-column-end: 11;
  }
  .sm\\:col-end-12 {
    grid-column-end: 12;
  }
  .sm\\:col-end-13 {
    grid-column-end: 13;
  }
  .sm\\:col-end-auto {
    grid-column-end: auto;
  }
  .sm\\:grid-rows-1 {
    grid-template-rows: repeat(1, minmax(0, 1fr));
  }
  .sm\\:grid-rows-2 {
    grid-template-rows: repeat(2, minmax(0, 1fr));
  }
  .sm\\:grid-rows-3 {
    grid-template-rows: repeat(3, minmax(0, 1fr));
  }
  .sm\\:grid-rows-4 {
    grid-template-rows: repeat(4, minmax(0, 1fr));
  }
  .sm\\:grid-rows-5 {
    grid-template-rows: repeat(5, minmax(0, 1fr));
  }
  .sm\\:grid-rows-6 {
    grid-template-rows: repeat(6, minmax(0, 1fr));
  }
  .sm\\:grid-rows-none {
    grid-template-rows: none;
  }
  .sm\\:auto-rows-auto {
    grid-auto-rows: auto;
  }
  .sm\\:auto-rows-min {
    grid-auto-rows: min-content;
  }
  .sm\\:auto-rows-max {
    grid-auto-rows: max-content;
  }
  .sm\\:auto-rows-fr {
    grid-auto-rows: minmax(0, 1fr);
  }
  .sm\\:row-auto {
    grid-row: auto;
  }
  .sm\\:row-span-1 {
    grid-row: span 1 / span 1;
  }
  .sm\\:row-span-2 {
    grid-row: span 2 / span 2;
  }
  .sm\\:row-span-3 {
    grid-row: span 3 / span 3;
  }
  .sm\\:row-span-4 {
    grid-row: span 4 / span 4;
  }
  .sm\\:row-span-5 {
    grid-row: span 5 / span 5;
  }
  .sm\\:row-span-6 {
    grid-row: span 6 / span 6;
  }
  .sm\\:row-span-full {
    grid-row: 1 / -1;
  }
  .sm\\:row-start-1 {
    grid-row-start: 1;
  }
  .sm\\:row-start-2 {
    grid-row-start: 2;
  }
  .sm\\:row-start-3 {
    grid-row-start: 3;
  }
  .sm\\:row-start-4 {
    grid-row-start: 4;
  }
  .sm\\:row-start-5 {
    grid-row-start: 5;
  }
  .sm\\:row-start-6 {
    grid-row-start: 6;
  }
  .sm\\:row-start-7 {
    grid-row-start: 7;
  }
  .sm\\:row-start-auto {
    grid-row-start: auto;
  }
  .sm\\:row-end-1 {
    grid-row-end: 1;
  }
  .sm\\:row-end-2 {
    grid-row-end: 2;
  }
  .sm\\:row-end-3 {
    grid-row-end: 3;
  }
  .sm\\:row-end-4 {
    grid-row-end: 4;
  }
  .sm\\:row-end-5 {
    grid-row-end: 5;
  }
  .sm\\:row-end-6 {
    grid-row-end: 6;
  }
  .sm\\:row-end-7 {
    grid-row-end: 7;
  }
  .sm\\:row-end-auto {
    grid-row-end: auto;
  }
  .sm\\:transform {
    --transform-translate-x: 0;
    --transform-translate-y: 0;
    --transform-rotate: 0;
    --transform-skew-x: 0;
    --transform-skew-y: 0;
    --transform-scale-x: 1;
    --transform-scale-y: 1;
    transform: translateX(var(--transform-translate-x)) translateY(var(--transform-translate-y)) rotate(var(--transform-rotate)) skewX(var(--transform-skew-x)) skewY(var(--transform-skew-y)) scaleX(var(--transform-scale-x)) scaleY(var(--transform-scale-y));
  }
  .sm\\:transform-none {
    transform: none;
  }
  .sm\\:origin-center {
    transform-origin: center;
  }
  .sm\\:origin-top {
    transform-origin: top;
  }
  .sm\\:origin-top-right {
    transform-origin: top right;
  }
  .sm\\:origin-right {
    transform-origin: right;
  }
  .sm\\:origin-bottom-right {
    transform-origin: bottom right;
  }
  .sm\\:origin-bottom {
    transform-origin: bottom;
  }
  .sm\\:origin-bottom-left {
    transform-origin: bottom left;
  }
  .sm\\:origin-left {
    transform-origin: left;
  }
  .sm\\:origin-top-left {
    transform-origin: top left;
  }
  .sm\\:scale-0 {
    --transform-scale-x: 0;
    --transform-scale-y: 0;
  }
  .sm\\:scale-50 {
    --transform-scale-x: .5;
    --transform-scale-y: .5;
  }
  .sm\\:scale-75 {
    --transform-scale-x: .75;
    --transform-scale-y: .75;
  }
  .sm\\:scale-90 {
    --transform-scale-x: .9;
    --transform-scale-y: .9;
  }
  .sm\\:scale-95 {
    --transform-scale-x: .95;
    --transform-scale-y: .95;
  }
  .sm\\:scale-100 {
    --transform-scale-x: 1;
    --transform-scale-y: 1;
  }
  .sm\\:scale-105 {
    --transform-scale-x: 1.05;
    --transform-scale-y: 1.05;
  }
  .sm\\:scale-110 {
    --transform-scale-x: 1.1;
    --transform-scale-y: 1.1;
  }
  .sm\\:scale-125 {
    --transform-scale-x: 1.25;
    --transform-scale-y: 1.25;
  }
  .sm\\:scale-150 {
    --transform-scale-x: 1.5;
    --transform-scale-y: 1.5;
  }
  .sm\\:scale-x-0 {
    --transform-scale-x: 0;
  }
  .sm\\:scale-x-50 {
    --transform-scale-x: .5;
  }
  .sm\\:scale-x-75 {
    --transform-scale-x: .75;
  }
  .sm\\:scale-x-90 {
    --transform-scale-x: .9;
  }
  .sm\\:scale-x-95 {
    --transform-scale-x: .95;
  }
  .sm\\:scale-x-100 {
    --transform-scale-x: 1;
  }
  .sm\\:scale-x-105 {
    --transform-scale-x: 1.05;
  }
  .sm\\:scale-x-110 {
    --transform-scale-x: 1.1;
  }
  .sm\\:scale-x-125 {
    --transform-scale-x: 1.25;
  }
  .sm\\:scale-x-150 {
    --transform-scale-x: 1.5;
  }
  .sm\\:scale-y-0 {
    --transform-scale-y: 0;
  }
  .sm\\:scale-y-50 {
    --transform-scale-y: .5;
  }
  .sm\\:scale-y-75 {
    --transform-scale-y: .75;
  }
  .sm\\:scale-y-90 {
    --transform-scale-y: .9;
  }
  .sm\\:scale-y-95 {
    --transform-scale-y: .95;
  }
  .sm\\:scale-y-100 {
    --transform-scale-y: 1;
  }
  .sm\\:scale-y-105 {
    --transform-scale-y: 1.05;
  }
  .sm\\:scale-y-110 {
    --transform-scale-y: 1.1;
  }
  .sm\\:scale-y-125 {
    --transform-scale-y: 1.25;
  }
  .sm\\:scale-y-150 {
    --transform-scale-y: 1.5;
  }
  .sm\\:hover\\:scale-0:hover {
    --transform-scale-x: 0;
    --transform-scale-y: 0;
  }
  .sm\\:hover\\:scale-50:hover {
    --transform-scale-x: .5;
    --transform-scale-y: .5;
  }
  .sm\\:hover\\:scale-75:hover {
    --transform-scale-x: .75;
    --transform-scale-y: .75;
  }
  .sm\\:hover\\:scale-90:hover {
    --transform-scale-x: .9;
    --transform-scale-y: .9;
  }
  .sm\\:hover\\:scale-95:hover {
    --transform-scale-x: .95;
    --transform-scale-y: .95;
  }
  .sm\\:hover\\:scale-100:hover {
    --transform-scale-x: 1;
    --transform-scale-y: 1;
  }
  .sm\\:hover\\:scale-105:hover {
    --transform-scale-x: 1.05;
    --transform-scale-y: 1.05;
  }
  .sm\\:hover\\:scale-110:hover {
    --transform-scale-x: 1.1;
    --transform-scale-y: 1.1;
  }
  .sm\\:hover\\:scale-125:hover {
    --transform-scale-x: 1.25;
    --transform-scale-y: 1.25;
  }
  .sm\\:hover\\:scale-150:hover {
    --transform-scale-x: 1.5;
    --transform-scale-y: 1.5;
  }
  .sm\\:hover\\:scale-x-0:hover {
    --transform-scale-x: 0;
  }
  .sm\\:hover\\:scale-x-50:hover {
    --transform-scale-x: .5;
  }
  .sm\\:hover\\:scale-x-75:hover {
    --transform-scale-x: .75;
  }
  .sm\\:hover\\:scale-x-90:hover {
    --transform-scale-x: .9;
  }
  .sm\\:hover\\:scale-x-95:hover {
    --transform-scale-x: .95;
  }
  .sm\\:hover\\:scale-x-100:hover {
    --transform-scale-x: 1;
  }
  .sm\\:hover\\:scale-x-105:hover {
    --transform-scale-x: 1.05;
  }
  .sm\\:hover\\:scale-x-110:hover {
    --transform-scale-x: 1.1;
  }
  .sm\\:hover\\:scale-x-125:hover {
    --transform-scale-x: 1.25;
  }
  .sm\\:hover\\:scale-x-150:hover {
    --transform-scale-x: 1.5;
  }
  .sm\\:hover\\:scale-y-0:hover {
    --transform-scale-y: 0;
  }
  .sm\\:hover\\:scale-y-50:hover {
    --transform-scale-y: .5;
  }
  .sm\\:hover\\:scale-y-75:hover {
    --transform-scale-y: .75;
  }
  .sm\\:hover\\:scale-y-90:hover {
    --transform-scale-y: .9;
  }
  .sm\\:hover\\:scale-y-95:hover {
    --transform-scale-y: .95;
  }
  .sm\\:hover\\:scale-y-100:hover {
    --transform-scale-y: 1;
  }
  .sm\\:hover\\:scale-y-105:hover {
    --transform-scale-y: 1.05;
  }
  .sm\\:hover\\:scale-y-110:hover {
    --transform-scale-y: 1.1;
  }
  .sm\\:hover\\:scale-y-125:hover {
    --transform-scale-y: 1.25;
  }
  .sm\\:hover\\:scale-y-150:hover {
    --transform-scale-y: 1.5;
  }
  .sm\\:focus\\:scale-0:focus {
    --transform-scale-x: 0;
    --transform-scale-y: 0;
  }
  .sm\\:focus\\:scale-50:focus {
    --transform-scale-x: .5;
    --transform-scale-y: .5;
  }
  .sm\\:focus\\:scale-75:focus {
    --transform-scale-x: .75;
    --transform-scale-y: .75;
  }
  .sm\\:focus\\:scale-90:focus {
    --transform-scale-x: .9;
    --transform-scale-y: .9;
  }
  .sm\\:focus\\:scale-95:focus {
    --transform-scale-x: .95;
    --transform-scale-y: .95;
  }
  .sm\\:focus\\:scale-100:focus {
    --transform-scale-x: 1;
    --transform-scale-y: 1;
  }
  .sm\\:focus\\:scale-105:focus {
    --transform-scale-x: 1.05;
    --transform-scale-y: 1.05;
  }
  .sm\\:focus\\:scale-110:focus {
    --transform-scale-x: 1.1;
    --transform-scale-y: 1.1;
  }
  .sm\\:focus\\:scale-125:focus {
    --transform-scale-x: 1.25;
    --transform-scale-y: 1.25;
  }
  .sm\\:focus\\:scale-150:focus {
    --transform-scale-x: 1.5;
    --transform-scale-y: 1.5;
  }
  .sm\\:focus\\:scale-x-0:focus {
    --transform-scale-x: 0;
  }
  .sm\\:focus\\:scale-x-50:focus {
    --transform-scale-x: .5;
  }
  .sm\\:focus\\:scale-x-75:focus {
    --transform-scale-x: .75;
  }
  .sm\\:focus\\:scale-x-90:focus {
    --transform-scale-x: .9;
  }
  .sm\\:focus\\:scale-x-95:focus {
    --transform-scale-x: .95;
  }
  .sm\\:focus\\:scale-x-100:focus {
    --transform-scale-x: 1;
  }
  .sm\\:focus\\:scale-x-105:focus {
    --transform-scale-x: 1.05;
  }
  .sm\\:focus\\:scale-x-110:focus {
    --transform-scale-x: 1.1;
  }
  .sm\\:focus\\:scale-x-125:focus {
    --transform-scale-x: 1.25;
  }
  .sm\\:focus\\:scale-x-150:focus {
    --transform-scale-x: 1.5;
  }
  .sm\\:focus\\:scale-y-0:focus {
    --transform-scale-y: 0;
  }
  .sm\\:focus\\:scale-y-50:focus {
    --transform-scale-y: .5;
  }
  .sm\\:focus\\:scale-y-75:focus {
    --transform-scale-y: .75;
  }
  .sm\\:focus\\:scale-y-90:focus {
    --transform-scale-y: .9;
  }
  .sm\\:focus\\:scale-y-95:focus {
    --transform-scale-y: .95;
  }
  .sm\\:focus\\:scale-y-100:focus {
    --transform-scale-y: 1;
  }
  .sm\\:focus\\:scale-y-105:focus {
    --transform-scale-y: 1.05;
  }
  .sm\\:focus\\:scale-y-110:focus {
    --transform-scale-y: 1.1;
  }
  .sm\\:focus\\:scale-y-125:focus {
    --transform-scale-y: 1.25;
  }
  .sm\\:focus\\:scale-y-150:focus {
    --transform-scale-y: 1.5;
  }
  .sm\\:rotate-0 {
    --transform-rotate: 0;
  }
  .sm\\:rotate-1 {
    --transform-rotate: 1deg;
  }
  .sm\\:rotate-2 {
    --transform-rotate: 2deg;
  }
  .sm\\:rotate-3 {
    --transform-rotate: 3deg;
  }
  .sm\\:rotate-6 {
    --transform-rotate: 6deg;
  }
  .sm\\:rotate-12 {
    --transform-rotate: 12deg;
  }
  .sm\\:rotate-45 {
    --transform-rotate: 45deg;
  }
  .sm\\:rotate-90 {
    --transform-rotate: 90deg;
  }
  .sm\\:rotate-180 {
    --transform-rotate: 180deg;
  }
  .sm\\:-rotate-180 {
    --transform-rotate: -180deg;
  }
  .sm\\:-rotate-90 {
    --transform-rotate: -90deg;
  }
  .sm\\:-rotate-45 {
    --transform-rotate: -45deg;
  }
  .sm\\:-rotate-12 {
    --transform-rotate: -12deg;
  }
  .sm\\:-rotate-6 {
    --transform-rotate: -6deg;
  }
  .sm\\:-rotate-3 {
    --transform-rotate: -3deg;
  }
  .sm\\:-rotate-2 {
    --transform-rotate: -2deg;
  }
  .sm\\:-rotate-1 {
    --transform-rotate: -1deg;
  }
  .sm\\:hover\\:rotate-0:hover {
    --transform-rotate: 0;
  }
  .sm\\:hover\\:rotate-1:hover {
    --transform-rotate: 1deg;
  }
  .sm\\:hover\\:rotate-2:hover {
    --transform-rotate: 2deg;
  }
  .sm\\:hover\\:rotate-3:hover {
    --transform-rotate: 3deg;
  }
  .sm\\:hover\\:rotate-6:hover {
    --transform-rotate: 6deg;
  }
  .sm\\:hover\\:rotate-12:hover {
    --transform-rotate: 12deg;
  }
  .sm\\:hover\\:rotate-45:hover {
    --transform-rotate: 45deg;
  }
  .sm\\:hover\\:rotate-90:hover {
    --transform-rotate: 90deg;
  }
  .sm\\:hover\\:rotate-180:hover {
    --transform-rotate: 180deg;
  }
  .sm\\:hover\\:-rotate-180:hover {
    --transform-rotate: -180deg;
  }
  .sm\\:hover\\:-rotate-90:hover {
    --transform-rotate: -90deg;
  }
  .sm\\:hover\\:-rotate-45:hover {
    --transform-rotate: -45deg;
  }
  .sm\\:hover\\:-rotate-12:hover {
    --transform-rotate: -12deg;
  }
  .sm\\:hover\\:-rotate-6:hover {
    --transform-rotate: -6deg;
  }
  .sm\\:hover\\:-rotate-3:hover {
    --transform-rotate: -3deg;
  }
  .sm\\:hover\\:-rotate-2:hover {
    --transform-rotate: -2deg;
  }
  .sm\\:hover\\:-rotate-1:hover {
    --transform-rotate: -1deg;
  }
  .sm\\:focus\\:rotate-0:focus {
    --transform-rotate: 0;
  }
  .sm\\:focus\\:rotate-1:focus {
    --transform-rotate: 1deg;
  }
  .sm\\:focus\\:rotate-2:focus {
    --transform-rotate: 2deg;
  }
  .sm\\:focus\\:rotate-3:focus {
    --transform-rotate: 3deg;
  }
  .sm\\:focus\\:rotate-6:focus {
    --transform-rotate: 6deg;
  }
  .sm\\:focus\\:rotate-12:focus {
    --transform-rotate: 12deg;
  }
  .sm\\:focus\\:rotate-45:focus {
    --transform-rotate: 45deg;
  }
  .sm\\:focus\\:rotate-90:focus {
    --transform-rotate: 90deg;
  }
  .sm\\:focus\\:rotate-180:focus {
    --transform-rotate: 180deg;
  }
  .sm\\:focus\\:-rotate-180:focus {
    --transform-rotate: -180deg;
  }
  .sm\\:focus\\:-rotate-90:focus {
    --transform-rotate: -90deg;
  }
  .sm\\:focus\\:-rotate-45:focus {
    --transform-rotate: -45deg;
  }
  .sm\\:focus\\:-rotate-12:focus {
    --transform-rotate: -12deg;
  }
  .sm\\:focus\\:-rotate-6:focus {
    --transform-rotate: -6deg;
  }
  .sm\\:focus\\:-rotate-3:focus {
    --transform-rotate: -3deg;
  }
  .sm\\:focus\\:-rotate-2:focus {
    --transform-rotate: -2deg;
  }
  .sm\\:focus\\:-rotate-1:focus {
    --transform-rotate: -1deg;
  }
  .sm\\:translate-x-0 {
    --transform-translate-x: 0;
  }
  .sm\\:translate-x-1 {
    --transform-translate-x: 0.25rem;
  }
  .sm\\:translate-x-2 {
    --transform-translate-x: 0.5rem;
  }
  .sm\\:translate-x-3 {
    --transform-translate-x: 0.75rem;
  }
  .sm\\:translate-x-4 {
    --transform-translate-x: 1rem;
  }
  .sm\\:translate-x-5 {
    --transform-translate-x: 1.25rem;
  }
  .sm\\:translate-x-6 {
    --transform-translate-x: 1.5rem;
  }
  .sm\\:translate-x-7 {
    --transform-translate-x: 1.75rem;
  }
  .sm\\:translate-x-8 {
    --transform-translate-x: 2rem;
  }
  .sm\\:translate-x-9 {
    --transform-translate-x: 2.25rem;
  }
  .sm\\:translate-x-10 {
    --transform-translate-x: 2.5rem;
  }
  .sm\\:translate-x-11 {
    --transform-translate-x: 2.75rem;
  }
  .sm\\:translate-x-12 {
    --transform-translate-x: 3rem;
  }
  .sm\\:translate-x-13 {
    --transform-translate-x: 3.25rem;
  }
  .sm\\:translate-x-14 {
    --transform-translate-x: 3.5rem;
  }
  .sm\\:translate-x-15 {
    --transform-translate-x: 3.75rem;
  }
  .sm\\:translate-x-16 {
    --transform-translate-x: 4rem;
  }
  .sm\\:translate-x-20 {
    --transform-translate-x: 5rem;
  }
  .sm\\:translate-x-24 {
    --transform-translate-x: 6rem;
  }
  .sm\\:translate-x-28 {
    --transform-translate-x: 7rem;
  }
  .sm\\:translate-x-32 {
    --transform-translate-x: 8rem;
  }
  .sm\\:translate-x-36 {
    --transform-translate-x: 9rem;
  }
  .sm\\:translate-x-40 {
    --transform-translate-x: 10rem;
  }
  .sm\\:translate-x-44 {
    --transform-translate-x: 11rem;
  }
  .sm\\:translate-x-48 {
    --transform-translate-x: 12rem;
  }
  .sm\\:translate-x-52 {
    --transform-translate-x: 13rem;
  }
  .sm\\:translate-x-56 {
    --transform-translate-x: 14rem;
  }
  .sm\\:translate-x-60 {
    --transform-translate-x: 15rem;
  }
  .sm\\:translate-x-64 {
    --transform-translate-x: 16rem;
  }
  .sm\\:translate-x-72 {
    --transform-translate-x: 18rem;
  }
  .sm\\:translate-x-80 {
    --transform-translate-x: 20rem;
  }
  .sm\\:translate-x-96 {
    --transform-translate-x: 24rem;
  }
  .sm\\:translate-x-px {
    --transform-translate-x: 1px;
  }
  .sm\\:translate-x-0\\.5 {
    --transform-translate-x: 0.125rem;
  }
  .sm\\:translate-x-1\\.5 {
    --transform-translate-x: 0.375rem;
  }
  .sm\\:translate-x-2\\.5 {
    --transform-translate-x: 0.625rem;
  }
  .sm\\:translate-x-3\\.5 {
    --transform-translate-x: 0.875rem;
  }
  .sm\\:translate-x-1\\/2 {
    --transform-translate-x: 50%;
  }
  .sm\\:translate-x-1\\/3 {
    --transform-translate-x: 33.333333%;
  }
  .sm\\:translate-x-2\\/3 {
    --transform-translate-x: 66.666667%;
  }
  .sm\\:translate-x-1\\/4 {
    --transform-translate-x: 25%;
  }
  .sm\\:translate-x-2\\/4 {
    --transform-translate-x: 50%;
  }
  .sm\\:translate-x-3\\/4 {
    --transform-translate-x: 75%;
  }
  .sm\\:translate-x-1\\/5 {
    --transform-translate-x: 20%;
  }
  .sm\\:translate-x-2\\/5 {
    --transform-translate-x: 40%;
  }
  .sm\\:translate-x-3\\/5 {
    --transform-translate-x: 60%;
  }
  .sm\\:translate-x-4\\/5 {
    --transform-translate-x: 80%;
  }
  .sm\\:translate-x-1\\/6 {
    --transform-translate-x: 16.666667%;
  }
  .sm\\:translate-x-2\\/6 {
    --transform-translate-x: 33.333333%;
  }
  .sm\\:translate-x-3\\/6 {
    --transform-translate-x: 50%;
  }
  .sm\\:translate-x-4\\/6 {
    --transform-translate-x: 66.666667%;
  }
  .sm\\:translate-x-5\\/6 {
    --transform-translate-x: 83.333333%;
  }
  .sm\\:translate-x-1\\/12 {
    --transform-translate-x: 8.333333%;
  }
  .sm\\:translate-x-2\\/12 {
    --transform-translate-x: 16.666667%;
  }
  .sm\\:translate-x-3\\/12 {
    --transform-translate-x: 25%;
  }
  .sm\\:translate-x-4\\/12 {
    --transform-translate-x: 33.333333%;
  }
  .sm\\:translate-x-5\\/12 {
    --transform-translate-x: 41.666667%;
  }
  .sm\\:translate-x-6\\/12 {
    --transform-translate-x: 50%;
  }
  .sm\\:translate-x-7\\/12 {
    --transform-translate-x: 58.333333%;
  }
  .sm\\:translate-x-8\\/12 {
    --transform-translate-x: 66.666667%;
  }
  .sm\\:translate-x-9\\/12 {
    --transform-translate-x: 75%;
  }
  .sm\\:translate-x-10\\/12 {
    --transform-translate-x: 83.333333%;
  }
  .sm\\:translate-x-11\\/12 {
    --transform-translate-x: 91.666667%;
  }
  .sm\\:translate-x-full {
    --transform-translate-x: 100%;
  }
  .sm\\:-translate-x-1 {
    --transform-translate-x: -0.25rem;
  }
  .sm\\:-translate-x-2 {
    --transform-translate-x: -0.5rem;
  }
  .sm\\:-translate-x-3 {
    --transform-translate-x: -0.75rem;
  }
  .sm\\:-translate-x-4 {
    --transform-translate-x: -1rem;
  }
  .sm\\:-translate-x-5 {
    --transform-translate-x: -1.25rem;
  }
  .sm\\:-translate-x-6 {
    --transform-translate-x: -1.5rem;
  }
  .sm\\:-translate-x-7 {
    --transform-translate-x: -1.75rem;
  }
  .sm\\:-translate-x-8 {
    --transform-translate-x: -2rem;
  }
  .sm\\:-translate-x-9 {
    --transform-translate-x: -2.25rem;
  }
  .sm\\:-translate-x-10 {
    --transform-translate-x: -2.5rem;
  }
  .sm\\:-translate-x-11 {
    --transform-translate-x: -2.75rem;
  }
  .sm\\:-translate-x-12 {
    --transform-translate-x: -3rem;
  }
  .sm\\:-translate-x-13 {
    --transform-translate-x: -3.25rem;
  }
  .sm\\:-translate-x-14 {
    --transform-translate-x: -3.5rem;
  }
  .sm\\:-translate-x-15 {
    --transform-translate-x: -3.75rem;
  }
  .sm\\:-translate-x-16 {
    --transform-translate-x: -4rem;
  }
  .sm\\:-translate-x-20 {
    --transform-translate-x: -5rem;
  }
  .sm\\:-translate-x-24 {
    --transform-translate-x: -6rem;
  }
  .sm\\:-translate-x-28 {
    --transform-translate-x: -7rem;
  }
  .sm\\:-translate-x-32 {
    --transform-translate-x: -8rem;
  }
  .sm\\:-translate-x-36 {
    --transform-translate-x: -9rem;
  }
  .sm\\:-translate-x-40 {
    --transform-translate-x: -10rem;
  }
  .sm\\:-translate-x-44 {
    --transform-translate-x: -11rem;
  }
  .sm\\:-translate-x-48 {
    --transform-translate-x: -12rem;
  }
  .sm\\:-translate-x-52 {
    --transform-translate-x: -13rem;
  }
  .sm\\:-translate-x-56 {
    --transform-translate-x: -14rem;
  }
  .sm\\:-translate-x-60 {
    --transform-translate-x: -15rem;
  }
  .sm\\:-translate-x-64 {
    --transform-translate-x: -16rem;
  }
  .sm\\:-translate-x-72 {
    --transform-translate-x: -18rem;
  }
  .sm\\:-translate-x-80 {
    --transform-translate-x: -20rem;
  }
  .sm\\:-translate-x-96 {
    --transform-translate-x: -24rem;
  }
  .sm\\:-translate-x-px {
    --transform-translate-x: -1px;
  }
  .sm\\:-translate-x-0\\.5 {
    --transform-translate-x: -0.125rem;
  }
  .sm\\:-translate-x-1\\.5 {
    --transform-translate-x: -0.375rem;
  }
  .sm\\:-translate-x-2\\.5 {
    --transform-translate-x: -0.625rem;
  }
  .sm\\:-translate-x-3\\.5 {
    --transform-translate-x: -0.875rem;
  }
  .sm\\:-translate-x-1\\/2 {
    --transform-translate-x: -50%;
  }
  .sm\\:-translate-x-1\\/3 {
    --transform-translate-x: -33.33333%;
  }
  .sm\\:-translate-x-2\\/3 {
    --transform-translate-x: -66.66667%;
  }
  .sm\\:-translate-x-1\\/4 {
    --transform-translate-x: -25%;
  }
  .sm\\:-translate-x-2\\/4 {
    --transform-translate-x: -50%;
  }
  .sm\\:-translate-x-3\\/4 {
    --transform-translate-x: -75%;
  }
  .sm\\:-translate-x-1\\/5 {
    --transform-translate-x: -20%;
  }
  .sm\\:-translate-x-2\\/5 {
    --transform-translate-x: -40%;
  }
  .sm\\:-translate-x-3\\/5 {
    --transform-translate-x: -60%;
  }
  .sm\\:-translate-x-4\\/5 {
    --transform-translate-x: -80%;
  }
  .sm\\:-translate-x-1\\/6 {
    --transform-translate-x: -16.66667%;
  }
  .sm\\:-translate-x-2\\/6 {
    --transform-translate-x: -33.33333%;
  }
  .sm\\:-translate-x-3\\/6 {
    --transform-translate-x: -50%;
  }
  .sm\\:-translate-x-4\\/6 {
    --transform-translate-x: -66.66667%;
  }
  .sm\\:-translate-x-5\\/6 {
    --transform-translate-x: -83.33333%;
  }
  .sm\\:-translate-x-1\\/12 {
    --transform-translate-x: -8.33333%;
  }
  .sm\\:-translate-x-2\\/12 {
    --transform-translate-x: -16.66667%;
  }
  .sm\\:-translate-x-3\\/12 {
    --transform-translate-x: -25%;
  }
  .sm\\:-translate-x-4\\/12 {
    --transform-translate-x: -33.33333%;
  }
  .sm\\:-translate-x-5\\/12 {
    --transform-translate-x: -41.66667%;
  }
  .sm\\:-translate-x-6\\/12 {
    --transform-translate-x: -50%;
  }
  .sm\\:-translate-x-7\\/12 {
    --transform-translate-x: -58.33333%;
  }
  .sm\\:-translate-x-8\\/12 {
    --transform-translate-x: -66.66667%;
  }
  .sm\\:-translate-x-9\\/12 {
    --transform-translate-x: -75%;
  }
  .sm\\:-translate-x-10\\/12 {
    --transform-translate-x: -83.33333%;
  }
  .sm\\:-translate-x-11\\/12 {
    --transform-translate-x: -91.66667%;
  }
  .sm\\:-translate-x-full {
    --transform-translate-x: -100%;
  }
  .sm\\:translate-y-0 {
    --transform-translate-y: 0;
  }
  .sm\\:translate-y-1 {
    --transform-translate-y: 0.25rem;
  }
  .sm\\:translate-y-2 {
    --transform-translate-y: 0.5rem;
  }
  .sm\\:translate-y-3 {
    --transform-translate-y: 0.75rem;
  }
  .sm\\:translate-y-4 {
    --transform-translate-y: 1rem;
  }
  .sm\\:translate-y-5 {
    --transform-translate-y: 1.25rem;
  }
  .sm\\:translate-y-6 {
    --transform-translate-y: 1.5rem;
  }
  .sm\\:translate-y-7 {
    --transform-translate-y: 1.75rem;
  }
  .sm\\:translate-y-8 {
    --transform-translate-y: 2rem;
  }
  .sm\\:translate-y-9 {
    --transform-translate-y: 2.25rem;
  }
  .sm\\:translate-y-10 {
    --transform-translate-y: 2.5rem;
  }
  .sm\\:translate-y-11 {
    --transform-translate-y: 2.75rem;
  }
  .sm\\:translate-y-12 {
    --transform-translate-y: 3rem;
  }
  .sm\\:translate-y-13 {
    --transform-translate-y: 3.25rem;
  }
  .sm\\:translate-y-14 {
    --transform-translate-y: 3.5rem;
  }
  .sm\\:translate-y-15 {
    --transform-translate-y: 3.75rem;
  }
  .sm\\:translate-y-16 {
    --transform-translate-y: 4rem;
  }
  .sm\\:translate-y-20 {
    --transform-translate-y: 5rem;
  }
  .sm\\:translate-y-24 {
    --transform-translate-y: 6rem;
  }
  .sm\\:translate-y-28 {
    --transform-translate-y: 7rem;
  }
  .sm\\:translate-y-32 {
    --transform-translate-y: 8rem;
  }
  .sm\\:translate-y-36 {
    --transform-translate-y: 9rem;
  }
  .sm\\:translate-y-40 {
    --transform-translate-y: 10rem;
  }
  .sm\\:translate-y-44 {
    --transform-translate-y: 11rem;
  }
  .sm\\:translate-y-48 {
    --transform-translate-y: 12rem;
  }
  .sm\\:translate-y-52 {
    --transform-translate-y: 13rem;
  }
  .sm\\:translate-y-56 {
    --transform-translate-y: 14rem;
  }
  .sm\\:translate-y-60 {
    --transform-translate-y: 15rem;
  }
  .sm\\:translate-y-64 {
    --transform-translate-y: 16rem;
  }
  .sm\\:translate-y-72 {
    --transform-translate-y: 18rem;
  }
  .sm\\:translate-y-80 {
    --transform-translate-y: 20rem;
  }
  .sm\\:translate-y-96 {
    --transform-translate-y: 24rem;
  }
  .sm\\:translate-y-px {
    --transform-translate-y: 1px;
  }
  .sm\\:translate-y-0\\.5 {
    --transform-translate-y: 0.125rem;
  }
  .sm\\:translate-y-1\\.5 {
    --transform-translate-y: 0.375rem;
  }
  .sm\\:translate-y-2\\.5 {
    --transform-translate-y: 0.625rem;
  }
  .sm\\:translate-y-3\\.5 {
    --transform-translate-y: 0.875rem;
  }
  .sm\\:translate-y-1\\/2 {
    --transform-translate-y: 50%;
  }
  .sm\\:translate-y-1\\/3 {
    --transform-translate-y: 33.333333%;
  }
  .sm\\:translate-y-2\\/3 {
    --transform-translate-y: 66.666667%;
  }
  .sm\\:translate-y-1\\/4 {
    --transform-translate-y: 25%;
  }
  .sm\\:translate-y-2\\/4 {
    --transform-translate-y: 50%;
  }
  .sm\\:translate-y-3\\/4 {
    --transform-translate-y: 75%;
  }
  .sm\\:translate-y-1\\/5 {
    --transform-translate-y: 20%;
  }
  .sm\\:translate-y-2\\/5 {
    --transform-translate-y: 40%;
  }
  .sm\\:translate-y-3\\/5 {
    --transform-translate-y: 60%;
  }
  .sm\\:translate-y-4\\/5 {
    --transform-translate-y: 80%;
  }
  .sm\\:translate-y-1\\/6 {
    --transform-translate-y: 16.666667%;
  }
  .sm\\:translate-y-2\\/6 {
    --transform-translate-y: 33.333333%;
  }
  .sm\\:translate-y-3\\/6 {
    --transform-translate-y: 50%;
  }
  .sm\\:translate-y-4\\/6 {
    --transform-translate-y: 66.666667%;
  }
  .sm\\:translate-y-5\\/6 {
    --transform-translate-y: 83.333333%;
  }
  .sm\\:translate-y-1\\/12 {
    --transform-translate-y: 8.333333%;
  }
  .sm\\:translate-y-2\\/12 {
    --transform-translate-y: 16.666667%;
  }
  .sm\\:translate-y-3\\/12 {
    --transform-translate-y: 25%;
  }
  .sm\\:translate-y-4\\/12 {
    --transform-translate-y: 33.333333%;
  }
  .sm\\:translate-y-5\\/12 {
    --transform-translate-y: 41.666667%;
  }
  .sm\\:translate-y-6\\/12 {
    --transform-translate-y: 50%;
  }
  .sm\\:translate-y-7\\/12 {
    --transform-translate-y: 58.333333%;
  }
  .sm\\:translate-y-8\\/12 {
    --transform-translate-y: 66.666667%;
  }
  .sm\\:translate-y-9\\/12 {
    --transform-translate-y: 75%;
  }
  .sm\\:translate-y-10\\/12 {
    --transform-translate-y: 83.333333%;
  }
  .sm\\:translate-y-11\\/12 {
    --transform-translate-y: 91.666667%;
  }
  .sm\\:translate-y-full {
    --transform-translate-y: 100%;
  }
  .sm\\:-translate-y-1 {
    --transform-translate-y: -0.25rem;
  }
  .sm\\:-translate-y-2 {
    --transform-translate-y: -0.5rem;
  }
  .sm\\:-translate-y-3 {
    --transform-translate-y: -0.75rem;
  }
  .sm\\:-translate-y-4 {
    --transform-translate-y: -1rem;
  }
  .sm\\:-translate-y-5 {
    --transform-translate-y: -1.25rem;
  }
  .sm\\:-translate-y-6 {
    --transform-translate-y: -1.5rem;
  }
  .sm\\:-translate-y-7 {
    --transform-translate-y: -1.75rem;
  }
  .sm\\:-translate-y-8 {
    --transform-translate-y: -2rem;
  }
  .sm\\:-translate-y-9 {
    --transform-translate-y: -2.25rem;
  }
  .sm\\:-translate-y-10 {
    --transform-translate-y: -2.5rem;
  }
  .sm\\:-translate-y-11 {
    --transform-translate-y: -2.75rem;
  }
  .sm\\:-translate-y-12 {
    --transform-translate-y: -3rem;
  }
  .sm\\:-translate-y-13 {
    --transform-translate-y: -3.25rem;
  }
  .sm\\:-translate-y-14 {
    --transform-translate-y: -3.5rem;
  }
  .sm\\:-translate-y-15 {
    --transform-translate-y: -3.75rem;
  }
  .sm\\:-translate-y-16 {
    --transform-translate-y: -4rem;
  }
  .sm\\:-translate-y-20 {
    --transform-translate-y: -5rem;
  }
  .sm\\:-translate-y-24 {
    --transform-translate-y: -6rem;
  }
  .sm\\:-translate-y-28 {
    --transform-translate-y: -7rem;
  }
  .sm\\:-translate-y-32 {
    --transform-translate-y: -8rem;
  }
  .sm\\:-translate-y-36 {
    --transform-translate-y: -9rem;
  }
  .sm\\:-translate-y-40 {
    --transform-translate-y: -10rem;
  }
  .sm\\:-translate-y-44 {
    --transform-translate-y: -11rem;
  }
  .sm\\:-translate-y-48 {
    --transform-translate-y: -12rem;
  }
  .sm\\:-translate-y-52 {
    --transform-translate-y: -13rem;
  }
  .sm\\:-translate-y-56 {
    --transform-translate-y: -14rem;
  }
  .sm\\:-translate-y-60 {
    --transform-translate-y: -15rem;
  }
  .sm\\:-translate-y-64 {
    --transform-translate-y: -16rem;
  }
  .sm\\:-translate-y-72 {
    --transform-translate-y: -18rem;
  }
  .sm\\:-translate-y-80 {
    --transform-translate-y: -20rem;
  }
  .sm\\:-translate-y-96 {
    --transform-translate-y: -24rem;
  }
  .sm\\:-translate-y-px {
    --transform-translate-y: -1px;
  }
  .sm\\:-translate-y-0\\.5 {
    --transform-translate-y: -0.125rem;
  }
  .sm\\:-translate-y-1\\.5 {
    --transform-translate-y: -0.375rem;
  }
  .sm\\:-translate-y-2\\.5 {
    --transform-translate-y: -0.625rem;
  }
  .sm\\:-translate-y-3\\.5 {
    --transform-translate-y: -0.875rem;
  }
  .sm\\:-translate-y-1\\/2 {
    --transform-translate-y: -50%;
  }
  .sm\\:-translate-y-1\\/3 {
    --transform-translate-y: -33.33333%;
  }
  .sm\\:-translate-y-2\\/3 {
    --transform-translate-y: -66.66667%;
  }
  .sm\\:-translate-y-1\\/4 {
    --transform-translate-y: -25%;
  }
  .sm\\:-translate-y-2\\/4 {
    --transform-translate-y: -50%;
  }
  .sm\\:-translate-y-3\\/4 {
    --transform-translate-y: -75%;
  }
  .sm\\:-translate-y-1\\/5 {
    --transform-translate-y: -20%;
  }
  .sm\\:-translate-y-2\\/5 {
    --transform-translate-y: -40%;
  }
  .sm\\:-translate-y-3\\/5 {
    --transform-translate-y: -60%;
  }
  .sm\\:-translate-y-4\\/5 {
    --transform-translate-y: -80%;
  }
  .sm\\:-translate-y-1\\/6 {
    --transform-translate-y: -16.66667%;
  }
  .sm\\:-translate-y-2\\/6 {
    --transform-translate-y: -33.33333%;
  }
  .sm\\:-translate-y-3\\/6 {
    --transform-translate-y: -50%;
  }
  .sm\\:-translate-y-4\\/6 {
    --transform-translate-y: -66.66667%;
  }
  .sm\\:-translate-y-5\\/6 {
    --transform-translate-y: -83.33333%;
  }
  .sm\\:-translate-y-1\\/12 {
    --transform-translate-y: -8.33333%;
  }
  .sm\\:-translate-y-2\\/12 {
    --transform-translate-y: -16.66667%;
  }
  .sm\\:-translate-y-3\\/12 {
    --transform-translate-y: -25%;
  }
  .sm\\:-translate-y-4\\/12 {
    --transform-translate-y: -33.33333%;
  }
  .sm\\:-translate-y-5\\/12 {
    --transform-translate-y: -41.66667%;
  }
  .sm\\:-translate-y-6\\/12 {
    --transform-translate-y: -50%;
  }
  .sm\\:-translate-y-7\\/12 {
    --transform-translate-y: -58.33333%;
  }
  .sm\\:-translate-y-8\\/12 {
    --transform-translate-y: -66.66667%;
  }
  .sm\\:-translate-y-9\\/12 {
    --transform-translate-y: -75%;
  }
  .sm\\:-translate-y-10\\/12 {
    --transform-translate-y: -83.33333%;
  }
  .sm\\:-translate-y-11\\/12 {
    --transform-translate-y: -91.66667%;
  }
  .sm\\:-translate-y-full {
    --transform-translate-y: -100%;
  }
  .sm\\:hover\\:translate-x-0:hover {
    --transform-translate-x: 0;
  }
  .sm\\:hover\\:translate-x-1:hover {
    --transform-translate-x: 0.25rem;
  }
  .sm\\:hover\\:translate-x-2:hover {
    --transform-translate-x: 0.5rem;
  }
  .sm\\:hover\\:translate-x-3:hover {
    --transform-translate-x: 0.75rem;
  }
  .sm\\:hover\\:translate-x-4:hover {
    --transform-translate-x: 1rem;
  }
  .sm\\:hover\\:translate-x-5:hover {
    --transform-translate-x: 1.25rem;
  }
  .sm\\:hover\\:translate-x-6:hover {
    --transform-translate-x: 1.5rem;
  }
  .sm\\:hover\\:translate-x-7:hover {
    --transform-translate-x: 1.75rem;
  }
  .sm\\:hover\\:translate-x-8:hover {
    --transform-translate-x: 2rem;
  }
  .sm\\:hover\\:translate-x-9:hover {
    --transform-translate-x: 2.25rem;
  }
  .sm\\:hover\\:translate-x-10:hover {
    --transform-translate-x: 2.5rem;
  }
  .sm\\:hover\\:translate-x-11:hover {
    --transform-translate-x: 2.75rem;
  }
  .sm\\:hover\\:translate-x-12:hover {
    --transform-translate-x: 3rem;
  }
  .sm\\:hover\\:translate-x-13:hover {
    --transform-translate-x: 3.25rem;
  }
  .sm\\:hover\\:translate-x-14:hover {
    --transform-translate-x: 3.5rem;
  }
  .sm\\:hover\\:translate-x-15:hover {
    --transform-translate-x: 3.75rem;
  }
  .sm\\:hover\\:translate-x-16:hover {
    --transform-translate-x: 4rem;
  }
  .sm\\:hover\\:translate-x-20:hover {
    --transform-translate-x: 5rem;
  }
  .sm\\:hover\\:translate-x-24:hover {
    --transform-translate-x: 6rem;
  }
  .sm\\:hover\\:translate-x-28:hover {
    --transform-translate-x: 7rem;
  }
  .sm\\:hover\\:translate-x-32:hover {
    --transform-translate-x: 8rem;
  }
  .sm\\:hover\\:translate-x-36:hover {
    --transform-translate-x: 9rem;
  }
  .sm\\:hover\\:translate-x-40:hover {
    --transform-translate-x: 10rem;
  }
  .sm\\:hover\\:translate-x-44:hover {
    --transform-translate-x: 11rem;
  }
  .sm\\:hover\\:translate-x-48:hover {
    --transform-translate-x: 12rem;
  }
  .sm\\:hover\\:translate-x-52:hover {
    --transform-translate-x: 13rem;
  }
  .sm\\:hover\\:translate-x-56:hover {
    --transform-translate-x: 14rem;
  }
  .sm\\:hover\\:translate-x-60:hover {
    --transform-translate-x: 15rem;
  }
  .sm\\:hover\\:translate-x-64:hover {
    --transform-translate-x: 16rem;
  }
  .sm\\:hover\\:translate-x-72:hover {
    --transform-translate-x: 18rem;
  }
  .sm\\:hover\\:translate-x-80:hover {
    --transform-translate-x: 20rem;
  }
  .sm\\:hover\\:translate-x-96:hover {
    --transform-translate-x: 24rem;
  }
  .sm\\:hover\\:translate-x-px:hover {
    --transform-translate-x: 1px;
  }
  .sm\\:hover\\:translate-x-0\\.5:hover {
    --transform-translate-x: 0.125rem;
  }
  .sm\\:hover\\:translate-x-1\\.5:hover {
    --transform-translate-x: 0.375rem;
  }
  .sm\\:hover\\:translate-x-2\\.5:hover {
    --transform-translate-x: 0.625rem;
  }
  .sm\\:hover\\:translate-x-3\\.5:hover {
    --transform-translate-x: 0.875rem;
  }
  .sm\\:hover\\:translate-x-1\\/2:hover {
    --transform-translate-x: 50%;
  }
  .sm\\:hover\\:translate-x-1\\/3:hover {
    --transform-translate-x: 33.333333%;
  }
  .sm\\:hover\\:translate-x-2\\/3:hover {
    --transform-translate-x: 66.666667%;
  }
  .sm\\:hover\\:translate-x-1\\/4:hover {
    --transform-translate-x: 25%;
  }
  .sm\\:hover\\:translate-x-2\\/4:hover {
    --transform-translate-x: 50%;
  }
  .sm\\:hover\\:translate-x-3\\/4:hover {
    --transform-translate-x: 75%;
  }
  .sm\\:hover\\:translate-x-1\\/5:hover {
    --transform-translate-x: 20%;
  }
  .sm\\:hover\\:translate-x-2\\/5:hover {
    --transform-translate-x: 40%;
  }
  .sm\\:hover\\:translate-x-3\\/5:hover {
    --transform-translate-x: 60%;
  }
  .sm\\:hover\\:translate-x-4\\/5:hover {
    --transform-translate-x: 80%;
  }
  .sm\\:hover\\:translate-x-1\\/6:hover {
    --transform-translate-x: 16.666667%;
  }
  .sm\\:hover\\:translate-x-2\\/6:hover {
    --transform-translate-x: 33.333333%;
  }
  .sm\\:hover\\:translate-x-3\\/6:hover {
    --transform-translate-x: 50%;
  }
  .sm\\:hover\\:translate-x-4\\/6:hover {
    --transform-translate-x: 66.666667%;
  }
  .sm\\:hover\\:translate-x-5\\/6:hover {
    --transform-translate-x: 83.333333%;
  }
  .sm\\:hover\\:translate-x-1\\/12:hover {
    --transform-translate-x: 8.333333%;
  }
  .sm\\:hover\\:translate-x-2\\/12:hover {
    --transform-translate-x: 16.666667%;
  }
  .sm\\:hover\\:translate-x-3\\/12:hover {
    --transform-translate-x: 25%;
  }
  .sm\\:hover\\:translate-x-4\\/12:hover {
    --transform-translate-x: 33.333333%;
  }
  .sm\\:hover\\:translate-x-5\\/12:hover {
    --transform-translate-x: 41.666667%;
  }
  .sm\\:hover\\:translate-x-6\\/12:hover {
    --transform-translate-x: 50%;
  }
  .sm\\:hover\\:translate-x-7\\/12:hover {
    --transform-translate-x: 58.333333%;
  }
  .sm\\:hover\\:translate-x-8\\/12:hover {
    --transform-translate-x: 66.666667%;
  }
  .sm\\:hover\\:translate-x-9\\/12:hover {
    --transform-translate-x: 75%;
  }
  .sm\\:hover\\:translate-x-10\\/12:hover {
    --transform-translate-x: 83.333333%;
  }
  .sm\\:hover\\:translate-x-11\\/12:hover {
    --transform-translate-x: 91.666667%;
  }
  .sm\\:hover\\:translate-x-full:hover {
    --transform-translate-x: 100%;
  }
  .sm\\:hover\\:-translate-x-1:hover {
    --transform-translate-x: -0.25rem;
  }
  .sm\\:hover\\:-translate-x-2:hover {
    --transform-translate-x: -0.5rem;
  }
  .sm\\:hover\\:-translate-x-3:hover {
    --transform-translate-x: -0.75rem;
  }
  .sm\\:hover\\:-translate-x-4:hover {
    --transform-translate-x: -1rem;
  }
  .sm\\:hover\\:-translate-x-5:hover {
    --transform-translate-x: -1.25rem;
  }
  .sm\\:hover\\:-translate-x-6:hover {
    --transform-translate-x: -1.5rem;
  }
  .sm\\:hover\\:-translate-x-7:hover {
    --transform-translate-x: -1.75rem;
  }
  .sm\\:hover\\:-translate-x-8:hover {
    --transform-translate-x: -2rem;
  }
  .sm\\:hover\\:-translate-x-9:hover {
    --transform-translate-x: -2.25rem;
  }
  .sm\\:hover\\:-translate-x-10:hover {
    --transform-translate-x: -2.5rem;
  }
  .sm\\:hover\\:-translate-x-11:hover {
    --transform-translate-x: -2.75rem;
  }
  .sm\\:hover\\:-translate-x-12:hover {
    --transform-translate-x: -3rem;
  }
  .sm\\:hover\\:-translate-x-13:hover {
    --transform-translate-x: -3.25rem;
  }
  .sm\\:hover\\:-translate-x-14:hover {
    --transform-translate-x: -3.5rem;
  }
  .sm\\:hover\\:-translate-x-15:hover {
    --transform-translate-x: -3.75rem;
  }
  .sm\\:hover\\:-translate-x-16:hover {
    --transform-translate-x: -4rem;
  }
  .sm\\:hover\\:-translate-x-20:hover {
    --transform-translate-x: -5rem;
  }
  .sm\\:hover\\:-translate-x-24:hover {
    --transform-translate-x: -6rem;
  }
  .sm\\:hover\\:-translate-x-28:hover {
    --transform-translate-x: -7rem;
  }
  .sm\\:hover\\:-translate-x-32:hover {
    --transform-translate-x: -8rem;
  }
  .sm\\:hover\\:-translate-x-36:hover {
    --transform-translate-x: -9rem;
  }
  .sm\\:hover\\:-translate-x-40:hover {
    --transform-translate-x: -10rem;
  }
  .sm\\:hover\\:-translate-x-44:hover {
    --transform-translate-x: -11rem;
  }
  .sm\\:hover\\:-translate-x-48:hover {
    --transform-translate-x: -12rem;
  }
  .sm\\:hover\\:-translate-x-52:hover {
    --transform-translate-x: -13rem;
  }
  .sm\\:hover\\:-translate-x-56:hover {
    --transform-translate-x: -14rem;
  }
  .sm\\:hover\\:-translate-x-60:hover {
    --transform-translate-x: -15rem;
  }
  .sm\\:hover\\:-translate-x-64:hover {
    --transform-translate-x: -16rem;
  }
  .sm\\:hover\\:-translate-x-72:hover {
    --transform-translate-x: -18rem;
  }
  .sm\\:hover\\:-translate-x-80:hover {
    --transform-translate-x: -20rem;
  }
  .sm\\:hover\\:-translate-x-96:hover {
    --transform-translate-x: -24rem;
  }
  .sm\\:hover\\:-translate-x-px:hover {
    --transform-translate-x: -1px;
  }
  .sm\\:hover\\:-translate-x-0\\.5:hover {
    --transform-translate-x: -0.125rem;
  }
  .sm\\:hover\\:-translate-x-1\\.5:hover {
    --transform-translate-x: -0.375rem;
  }
  .sm\\:hover\\:-translate-x-2\\.5:hover {
    --transform-translate-x: -0.625rem;
  }
  .sm\\:hover\\:-translate-x-3\\.5:hover {
    --transform-translate-x: -0.875rem;
  }
  .sm\\:hover\\:-translate-x-1\\/2:hover {
    --transform-translate-x: -50%;
  }
  .sm\\:hover\\:-translate-x-1\\/3:hover {
    --transform-translate-x: -33.33333%;
  }
  .sm\\:hover\\:-translate-x-2\\/3:hover {
    --transform-translate-x: -66.66667%;
  }
  .sm\\:hover\\:-translate-x-1\\/4:hover {
    --transform-translate-x: -25%;
  }
  .sm\\:hover\\:-translate-x-2\\/4:hover {
    --transform-translate-x: -50%;
  }
  .sm\\:hover\\:-translate-x-3\\/4:hover {
    --transform-translate-x: -75%;
  }
  .sm\\:hover\\:-translate-x-1\\/5:hover {
    --transform-translate-x: -20%;
  }
  .sm\\:hover\\:-translate-x-2\\/5:hover {
    --transform-translate-x: -40%;
  }
  .sm\\:hover\\:-translate-x-3\\/5:hover {
    --transform-translate-x: -60%;
  }
  .sm\\:hover\\:-translate-x-4\\/5:hover {
    --transform-translate-x: -80%;
  }
  .sm\\:hover\\:-translate-x-1\\/6:hover {
    --transform-translate-x: -16.66667%;
  }
  .sm\\:hover\\:-translate-x-2\\/6:hover {
    --transform-translate-x: -33.33333%;
  }
  .sm\\:hover\\:-translate-x-3\\/6:hover {
    --transform-translate-x: -50%;
  }
  .sm\\:hover\\:-translate-x-4\\/6:hover {
    --transform-translate-x: -66.66667%;
  }
  .sm\\:hover\\:-translate-x-5\\/6:hover {
    --transform-translate-x: -83.33333%;
  }
  .sm\\:hover\\:-translate-x-1\\/12:hover {
    --transform-translate-x: -8.33333%;
  }
  .sm\\:hover\\:-translate-x-2\\/12:hover {
    --transform-translate-x: -16.66667%;
  }
  .sm\\:hover\\:-translate-x-3\\/12:hover {
    --transform-translate-x: -25%;
  }
  .sm\\:hover\\:-translate-x-4\\/12:hover {
    --transform-translate-x: -33.33333%;
  }
  .sm\\:hover\\:-translate-x-5\\/12:hover {
    --transform-translate-x: -41.66667%;
  }
  .sm\\:hover\\:-translate-x-6\\/12:hover {
    --transform-translate-x: -50%;
  }
  .sm\\:hover\\:-translate-x-7\\/12:hover {
    --transform-translate-x: -58.33333%;
  }
  .sm\\:hover\\:-translate-x-8\\/12:hover {
    --transform-translate-x: -66.66667%;
  }
  .sm\\:hover\\:-translate-x-9\\/12:hover {
    --transform-translate-x: -75%;
  }
  .sm\\:hover\\:-translate-x-10\\/12:hover {
    --transform-translate-x: -83.33333%;
  }
  .sm\\:hover\\:-translate-x-11\\/12:hover {
    --transform-translate-x: -91.66667%;
  }
  .sm\\:hover\\:-translate-x-full:hover {
    --transform-translate-x: -100%;
  }
  .sm\\:hover\\:translate-y-0:hover {
    --transform-translate-y: 0;
  }
  .sm\\:hover\\:translate-y-1:hover {
    --transform-translate-y: 0.25rem;
  }
  .sm\\:hover\\:translate-y-2:hover {
    --transform-translate-y: 0.5rem;
  }
  .sm\\:hover\\:translate-y-3:hover {
    --transform-translate-y: 0.75rem;
  }
  .sm\\:hover\\:translate-y-4:hover {
    --transform-translate-y: 1rem;
  }
  .sm\\:hover\\:translate-y-5:hover {
    --transform-translate-y: 1.25rem;
  }
  .sm\\:hover\\:translate-y-6:hover {
    --transform-translate-y: 1.5rem;
  }
  .sm\\:hover\\:translate-y-7:hover {
    --transform-translate-y: 1.75rem;
  }
  .sm\\:hover\\:translate-y-8:hover {
    --transform-translate-y: 2rem;
  }
  .sm\\:hover\\:translate-y-9:hover {
    --transform-translate-y: 2.25rem;
  }
  .sm\\:hover\\:translate-y-10:hover {
    --transform-translate-y: 2.5rem;
  }
  .sm\\:hover\\:translate-y-11:hover {
    --transform-translate-y: 2.75rem;
  }
  .sm\\:hover\\:translate-y-12:hover {
    --transform-translate-y: 3rem;
  }
  .sm\\:hover\\:translate-y-13:hover {
    --transform-translate-y: 3.25rem;
  }
  .sm\\:hover\\:translate-y-14:hover {
    --transform-translate-y: 3.5rem;
  }
  .sm\\:hover\\:translate-y-15:hover {
    --transform-translate-y: 3.75rem;
  }
  .sm\\:hover\\:translate-y-16:hover {
    --transform-translate-y: 4rem;
  }
  .sm\\:hover\\:translate-y-20:hover {
    --transform-translate-y: 5rem;
  }
  .sm\\:hover\\:translate-y-24:hover {
    --transform-translate-y: 6rem;
  }
  .sm\\:hover\\:translate-y-28:hover {
    --transform-translate-y: 7rem;
  }
  .sm\\:hover\\:translate-y-32:hover {
    --transform-translate-y: 8rem;
  }
  .sm\\:hover\\:translate-y-36:hover {
    --transform-translate-y: 9rem;
  }
  .sm\\:hover\\:translate-y-40:hover {
    --transform-translate-y: 10rem;
  }
  .sm\\:hover\\:translate-y-44:hover {
    --transform-translate-y: 11rem;
  }
  .sm\\:hover\\:translate-y-48:hover {
    --transform-translate-y: 12rem;
  }
  .sm\\:hover\\:translate-y-52:hover {
    --transform-translate-y: 13rem;
  }
  .sm\\:hover\\:translate-y-56:hover {
    --transform-translate-y: 14rem;
  }
  .sm\\:hover\\:translate-y-60:hover {
    --transform-translate-y: 15rem;
  }
  .sm\\:hover\\:translate-y-64:hover {
    --transform-translate-y: 16rem;
  }
  .sm\\:hover\\:translate-y-72:hover {
    --transform-translate-y: 18rem;
  }
  .sm\\:hover\\:translate-y-80:hover {
    --transform-translate-y: 20rem;
  }
  .sm\\:hover\\:translate-y-96:hover {
    --transform-translate-y: 24rem;
  }
  .sm\\:hover\\:translate-y-px:hover {
    --transform-translate-y: 1px;
  }
  .sm\\:hover\\:translate-y-0\\.5:hover {
    --transform-translate-y: 0.125rem;
  }
  .sm\\:hover\\:translate-y-1\\.5:hover {
    --transform-translate-y: 0.375rem;
  }
  .sm\\:hover\\:translate-y-2\\.5:hover {
    --transform-translate-y: 0.625rem;
  }
  .sm\\:hover\\:translate-y-3\\.5:hover {
    --transform-translate-y: 0.875rem;
  }
  .sm\\:hover\\:translate-y-1\\/2:hover {
    --transform-translate-y: 50%;
  }
  .sm\\:hover\\:translate-y-1\\/3:hover {
    --transform-translate-y: 33.333333%;
  }
  .sm\\:hover\\:translate-y-2\\/3:hover {
    --transform-translate-y: 66.666667%;
  }
  .sm\\:hover\\:translate-y-1\\/4:hover {
    --transform-translate-y: 25%;
  }
  .sm\\:hover\\:translate-y-2\\/4:hover {
    --transform-translate-y: 50%;
  }
  .sm\\:hover\\:translate-y-3\\/4:hover {
    --transform-translate-y: 75%;
  }
  .sm\\:hover\\:translate-y-1\\/5:hover {
    --transform-translate-y: 20%;
  }
  .sm\\:hover\\:translate-y-2\\/5:hover {
    --transform-translate-y: 40%;
  }
  .sm\\:hover\\:translate-y-3\\/5:hover {
    --transform-translate-y: 60%;
  }
  .sm\\:hover\\:translate-y-4\\/5:hover {
    --transform-translate-y: 80%;
  }
  .sm\\:hover\\:translate-y-1\\/6:hover {
    --transform-translate-y: 16.666667%;
  }
  .sm\\:hover\\:translate-y-2\\/6:hover {
    --transform-translate-y: 33.333333%;
  }
  .sm\\:hover\\:translate-y-3\\/6:hover {
    --transform-translate-y: 50%;
  }
  .sm\\:hover\\:translate-y-4\\/6:hover {
    --transform-translate-y: 66.666667%;
  }
  .sm\\:hover\\:translate-y-5\\/6:hover {
    --transform-translate-y: 83.333333%;
  }
  .sm\\:hover\\:translate-y-1\\/12:hover {
    --transform-translate-y: 8.333333%;
  }
  .sm\\:hover\\:translate-y-2\\/12:hover {
    --transform-translate-y: 16.666667%;
  }
  .sm\\:hover\\:translate-y-3\\/12:hover {
    --transform-translate-y: 25%;
  }
  .sm\\:hover\\:translate-y-4\\/12:hover {
    --transform-translate-y: 33.333333%;
  }
  .sm\\:hover\\:translate-y-5\\/12:hover {
    --transform-translate-y: 41.666667%;
  }
  .sm\\:hover\\:translate-y-6\\/12:hover {
    --transform-translate-y: 50%;
  }
  .sm\\:hover\\:translate-y-7\\/12:hover {
    --transform-translate-y: 58.333333%;
  }
  .sm\\:hover\\:translate-y-8\\/12:hover {
    --transform-translate-y: 66.666667%;
  }
  .sm\\:hover\\:translate-y-9\\/12:hover {
    --transform-translate-y: 75%;
  }
  .sm\\:hover\\:translate-y-10\\/12:hover {
    --transform-translate-y: 83.333333%;
  }
  .sm\\:hover\\:translate-y-11\\/12:hover {
    --transform-translate-y: 91.666667%;
  }
  .sm\\:hover\\:translate-y-full:hover {
    --transform-translate-y: 100%;
  }
  .sm\\:hover\\:-translate-y-1:hover {
    --transform-translate-y: -0.25rem;
  }
  .sm\\:hover\\:-translate-y-2:hover {
    --transform-translate-y: -0.5rem;
  }
  .sm\\:hover\\:-translate-y-3:hover {
    --transform-translate-y: -0.75rem;
  }
  .sm\\:hover\\:-translate-y-4:hover {
    --transform-translate-y: -1rem;
  }
  .sm\\:hover\\:-translate-y-5:hover {
    --transform-translate-y: -1.25rem;
  }
  .sm\\:hover\\:-translate-y-6:hover {
    --transform-translate-y: -1.5rem;
  }
  .sm\\:hover\\:-translate-y-7:hover {
    --transform-translate-y: -1.75rem;
  }
  .sm\\:hover\\:-translate-y-8:hover {
    --transform-translate-y: -2rem;
  }
  .sm\\:hover\\:-translate-y-9:hover {
    --transform-translate-y: -2.25rem;
  }
  .sm\\:hover\\:-translate-y-10:hover {
    --transform-translate-y: -2.5rem;
  }
  .sm\\:hover\\:-translate-y-11:hover {
    --transform-translate-y: -2.75rem;
  }
  .sm\\:hover\\:-translate-y-12:hover {
    --transform-translate-y: -3rem;
  }
  .sm\\:hover\\:-translate-y-13:hover {
    --transform-translate-y: -3.25rem;
  }
  .sm\\:hover\\:-translate-y-14:hover {
    --transform-translate-y: -3.5rem;
  }
  .sm\\:hover\\:-translate-y-15:hover {
    --transform-translate-y: -3.75rem;
  }
  .sm\\:hover\\:-translate-y-16:hover {
    --transform-translate-y: -4rem;
  }
  .sm\\:hover\\:-translate-y-20:hover {
    --transform-translate-y: -5rem;
  }
  .sm\\:hover\\:-translate-y-24:hover {
    --transform-translate-y: -6rem;
  }
  .sm\\:hover\\:-translate-y-28:hover {
    --transform-translate-y: -7rem;
  }
  .sm\\:hover\\:-translate-y-32:hover {
    --transform-translate-y: -8rem;
  }
  .sm\\:hover\\:-translate-y-36:hover {
    --transform-translate-y: -9rem;
  }
  .sm\\:hover\\:-translate-y-40:hover {
    --transform-translate-y: -10rem;
  }
  .sm\\:hover\\:-translate-y-44:hover {
    --transform-translate-y: -11rem;
  }
  .sm\\:hover\\:-translate-y-48:hover {
    --transform-translate-y: -12rem;
  }
  .sm\\:hover\\:-translate-y-52:hover {
    --transform-translate-y: -13rem;
  }
  .sm\\:hover\\:-translate-y-56:hover {
    --transform-translate-y: -14rem;
  }
  .sm\\:hover\\:-translate-y-60:hover {
    --transform-translate-y: -15rem;
  }
  .sm\\:hover\\:-translate-y-64:hover {
    --transform-translate-y: -16rem;
  }
  .sm\\:hover\\:-translate-y-72:hover {
    --transform-translate-y: -18rem;
  }
  .sm\\:hover\\:-translate-y-80:hover {
    --transform-translate-y: -20rem;
  }
  .sm\\:hover\\:-translate-y-96:hover {
    --transform-translate-y: -24rem;
  }
  .sm\\:hover\\:-translate-y-px:hover {
    --transform-translate-y: -1px;
  }
  .sm\\:hover\\:-translate-y-0\\.5:hover {
    --transform-translate-y: -0.125rem;
  }
  .sm\\:hover\\:-translate-y-1\\.5:hover {
    --transform-translate-y: -0.375rem;
  }
  .sm\\:hover\\:-translate-y-2\\.5:hover {
    --transform-translate-y: -0.625rem;
  }
  .sm\\:hover\\:-translate-y-3\\.5:hover {
    --transform-translate-y: -0.875rem;
  }
  .sm\\:hover\\:-translate-y-1\\/2:hover {
    --transform-translate-y: -50%;
  }
  .sm\\:hover\\:-translate-y-1\\/3:hover {
    --transform-translate-y: -33.33333%;
  }
  .sm\\:hover\\:-translate-y-2\\/3:hover {
    --transform-translate-y: -66.66667%;
  }
  .sm\\:hover\\:-translate-y-1\\/4:hover {
    --transform-translate-y: -25%;
  }
  .sm\\:hover\\:-translate-y-2\\/4:hover {
    --transform-translate-y: -50%;
  }
  .sm\\:hover\\:-translate-y-3\\/4:hover {
    --transform-translate-y: -75%;
  }
  .sm\\:hover\\:-translate-y-1\\/5:hover {
    --transform-translate-y: -20%;
  }
  .sm\\:hover\\:-translate-y-2\\/5:hover {
    --transform-translate-y: -40%;
  }
  .sm\\:hover\\:-translate-y-3\\/5:hover {
    --transform-translate-y: -60%;
  }
  .sm\\:hover\\:-translate-y-4\\/5:hover {
    --transform-translate-y: -80%;
  }
  .sm\\:hover\\:-translate-y-1\\/6:hover {
    --transform-translate-y: -16.66667%;
  }
  .sm\\:hover\\:-translate-y-2\\/6:hover {
    --transform-translate-y: -33.33333%;
  }
  .sm\\:hover\\:-translate-y-3\\/6:hover {
    --transform-translate-y: -50%;
  }
  .sm\\:hover\\:-translate-y-4\\/6:hover {
    --transform-translate-y: -66.66667%;
  }
  .sm\\:hover\\:-translate-y-5\\/6:hover {
    --transform-translate-y: -83.33333%;
  }
  .sm\\:hover\\:-translate-y-1\\/12:hover {
    --transform-translate-y: -8.33333%;
  }
  .sm\\:hover\\:-translate-y-2\\/12:hover {
    --transform-translate-y: -16.66667%;
  }
  .sm\\:hover\\:-translate-y-3\\/12:hover {
    --transform-translate-y: -25%;
  }
  .sm\\:hover\\:-translate-y-4\\/12:hover {
    --transform-translate-y: -33.33333%;
  }
  .sm\\:hover\\:-translate-y-5\\/12:hover {
    --transform-translate-y: -41.66667%;
  }
  .sm\\:hover\\:-translate-y-6\\/12:hover {
    --transform-translate-y: -50%;
  }
  .sm\\:hover\\:-translate-y-7\\/12:hover {
    --transform-translate-y: -58.33333%;
  }
  .sm\\:hover\\:-translate-y-8\\/12:hover {
    --transform-translate-y: -66.66667%;
  }
  .sm\\:hover\\:-translate-y-9\\/12:hover {
    --transform-translate-y: -75%;
  }
  .sm\\:hover\\:-translate-y-10\\/12:hover {
    --transform-translate-y: -83.33333%;
  }
  .sm\\:hover\\:-translate-y-11\\/12:hover {
    --transform-translate-y: -91.66667%;
  }
  .sm\\:hover\\:-translate-y-full:hover {
    --transform-translate-y: -100%;
  }
  .sm\\:focus\\:translate-x-0:focus {
    --transform-translate-x: 0;
  }
  .sm\\:focus\\:translate-x-1:focus {
    --transform-translate-x: 0.25rem;
  }
  .sm\\:focus\\:translate-x-2:focus {
    --transform-translate-x: 0.5rem;
  }
  .sm\\:focus\\:translate-x-3:focus {
    --transform-translate-x: 0.75rem;
  }
  .sm\\:focus\\:translate-x-4:focus {
    --transform-translate-x: 1rem;
  }
  .sm\\:focus\\:translate-x-5:focus {
    --transform-translate-x: 1.25rem;
  }
  .sm\\:focus\\:translate-x-6:focus {
    --transform-translate-x: 1.5rem;
  }
  .sm\\:focus\\:translate-x-7:focus {
    --transform-translate-x: 1.75rem;
  }
  .sm\\:focus\\:translate-x-8:focus {
    --transform-translate-x: 2rem;
  }
  .sm\\:focus\\:translate-x-9:focus {
    --transform-translate-x: 2.25rem;
  }
  .sm\\:focus\\:translate-x-10:focus {
    --transform-translate-x: 2.5rem;
  }
  .sm\\:focus\\:translate-x-11:focus {
    --transform-translate-x: 2.75rem;
  }
  .sm\\:focus\\:translate-x-12:focus {
    --transform-translate-x: 3rem;
  }
  .sm\\:focus\\:translate-x-13:focus {
    --transform-translate-x: 3.25rem;
  }
  .sm\\:focus\\:translate-x-14:focus {
    --transform-translate-x: 3.5rem;
  }
  .sm\\:focus\\:translate-x-15:focus {
    --transform-translate-x: 3.75rem;
  }
  .sm\\:focus\\:translate-x-16:focus {
    --transform-translate-x: 4rem;
  }
  .sm\\:focus\\:translate-x-20:focus {
    --transform-translate-x: 5rem;
  }
  .sm\\:focus\\:translate-x-24:focus {
    --transform-translate-x: 6rem;
  }
  .sm\\:focus\\:translate-x-28:focus {
    --transform-translate-x: 7rem;
  }
  .sm\\:focus\\:translate-x-32:focus {
    --transform-translate-x: 8rem;
  }
  .sm\\:focus\\:translate-x-36:focus {
    --transform-translate-x: 9rem;
  }
  .sm\\:focus\\:translate-x-40:focus {
    --transform-translate-x: 10rem;
  }
  .sm\\:focus\\:translate-x-44:focus {
    --transform-translate-x: 11rem;
  }
  .sm\\:focus\\:translate-x-48:focus {
    --transform-translate-x: 12rem;
  }
  .sm\\:focus\\:translate-x-52:focus {
    --transform-translate-x: 13rem;
  }
  .sm\\:focus\\:translate-x-56:focus {
    --transform-translate-x: 14rem;
  }
  .sm\\:focus\\:translate-x-60:focus {
    --transform-translate-x: 15rem;
  }
  .sm\\:focus\\:translate-x-64:focus {
    --transform-translate-x: 16rem;
  }
  .sm\\:focus\\:translate-x-72:focus {
    --transform-translate-x: 18rem;
  }
  .sm\\:focus\\:translate-x-80:focus {
    --transform-translate-x: 20rem;
  }
  .sm\\:focus\\:translate-x-96:focus {
    --transform-translate-x: 24rem;
  }
  .sm\\:focus\\:translate-x-px:focus {
    --transform-translate-x: 1px;
  }
  .sm\\:focus\\:translate-x-0\\.5:focus {
    --transform-translate-x: 0.125rem;
  }
  .sm\\:focus\\:translate-x-1\\.5:focus {
    --transform-translate-x: 0.375rem;
  }
  .sm\\:focus\\:translate-x-2\\.5:focus {
    --transform-translate-x: 0.625rem;
  }
  .sm\\:focus\\:translate-x-3\\.5:focus {
    --transform-translate-x: 0.875rem;
  }
  .sm\\:focus\\:translate-x-1\\/2:focus {
    --transform-translate-x: 50%;
  }
  .sm\\:focus\\:translate-x-1\\/3:focus {
    --transform-translate-x: 33.333333%;
  }
  .sm\\:focus\\:translate-x-2\\/3:focus {
    --transform-translate-x: 66.666667%;
  }
  .sm\\:focus\\:translate-x-1\\/4:focus {
    --transform-translate-x: 25%;
  }
  .sm\\:focus\\:translate-x-2\\/4:focus {
    --transform-translate-x: 50%;
  }
  .sm\\:focus\\:translate-x-3\\/4:focus {
    --transform-translate-x: 75%;
  }
  .sm\\:focus\\:translate-x-1\\/5:focus {
    --transform-translate-x: 20%;
  }
  .sm\\:focus\\:translate-x-2\\/5:focus {
    --transform-translate-x: 40%;
  }
  .sm\\:focus\\:translate-x-3\\/5:focus {
    --transform-translate-x: 60%;
  }
  .sm\\:focus\\:translate-x-4\\/5:focus {
    --transform-translate-x: 80%;
  }
  .sm\\:focus\\:translate-x-1\\/6:focus {
    --transform-translate-x: 16.666667%;
  }
  .sm\\:focus\\:translate-x-2\\/6:focus {
    --transform-translate-x: 33.333333%;
  }
  .sm\\:focus\\:translate-x-3\\/6:focus {
    --transform-translate-x: 50%;
  }
  .sm\\:focus\\:translate-x-4\\/6:focus {
    --transform-translate-x: 66.666667%;
  }
  .sm\\:focus\\:translate-x-5\\/6:focus {
    --transform-translate-x: 83.333333%;
  }
  .sm\\:focus\\:translate-x-1\\/12:focus {
    --transform-translate-x: 8.333333%;
  }
  .sm\\:focus\\:translate-x-2\\/12:focus {
    --transform-translate-x: 16.666667%;
  }
  .sm\\:focus\\:translate-x-3\\/12:focus {
    --transform-translate-x: 25%;
  }
  .sm\\:focus\\:translate-x-4\\/12:focus {
    --transform-translate-x: 33.333333%;
  }
  .sm\\:focus\\:translate-x-5\\/12:focus {
    --transform-translate-x: 41.666667%;
  }
  .sm\\:focus\\:translate-x-6\\/12:focus {
    --transform-translate-x: 50%;
  }
  .sm\\:focus\\:translate-x-7\\/12:focus {
    --transform-translate-x: 58.333333%;
  }
  .sm\\:focus\\:translate-x-8\\/12:focus {
    --transform-translate-x: 66.666667%;
  }
  .sm\\:focus\\:translate-x-9\\/12:focus {
    --transform-translate-x: 75%;
  }
  .sm\\:focus\\:translate-x-10\\/12:focus {
    --transform-translate-x: 83.333333%;
  }
  .sm\\:focus\\:translate-x-11\\/12:focus {
    --transform-translate-x: 91.666667%;
  }
  .sm\\:focus\\:translate-x-full:focus {
    --transform-translate-x: 100%;
  }
  .sm\\:focus\\:-translate-x-1:focus {
    --transform-translate-x: -0.25rem;
  }
  .sm\\:focus\\:-translate-x-2:focus {
    --transform-translate-x: -0.5rem;
  }
  .sm\\:focus\\:-translate-x-3:focus {
    --transform-translate-x: -0.75rem;
  }
  .sm\\:focus\\:-translate-x-4:focus {
    --transform-translate-x: -1rem;
  }
  .sm\\:focus\\:-translate-x-5:focus {
    --transform-translate-x: -1.25rem;
  }
  .sm\\:focus\\:-translate-x-6:focus {
    --transform-translate-x: -1.5rem;
  }
  .sm\\:focus\\:-translate-x-7:focus {
    --transform-translate-x: -1.75rem;
  }
  .sm\\:focus\\:-translate-x-8:focus {
    --transform-translate-x: -2rem;
  }
  .sm\\:focus\\:-translate-x-9:focus {
    --transform-translate-x: -2.25rem;
  }
  .sm\\:focus\\:-translate-x-10:focus {
    --transform-translate-x: -2.5rem;
  }
  .sm\\:focus\\:-translate-x-11:focus {
    --transform-translate-x: -2.75rem;
  }
  .sm\\:focus\\:-translate-x-12:focus {
    --transform-translate-x: -3rem;
  }
  .sm\\:focus\\:-translate-x-13:focus {
    --transform-translate-x: -3.25rem;
  }
  .sm\\:focus\\:-translate-x-14:focus {
    --transform-translate-x: -3.5rem;
  }
  .sm\\:focus\\:-translate-x-15:focus {
    --transform-translate-x: -3.75rem;
  }
  .sm\\:focus\\:-translate-x-16:focus {
    --transform-translate-x: -4rem;
  }
  .sm\\:focus\\:-translate-x-20:focus {
    --transform-translate-x: -5rem;
  }
  .sm\\:focus\\:-translate-x-24:focus {
    --transform-translate-x: -6rem;
  }
  .sm\\:focus\\:-translate-x-28:focus {
    --transform-translate-x: -7rem;
  }
  .sm\\:focus\\:-translate-x-32:focus {
    --transform-translate-x: -8rem;
  }
  .sm\\:focus\\:-translate-x-36:focus {
    --transform-translate-x: -9rem;
  }
  .sm\\:focus\\:-translate-x-40:focus {
    --transform-translate-x: -10rem;
  }
  .sm\\:focus\\:-translate-x-44:focus {
    --transform-translate-x: -11rem;
  }
  .sm\\:focus\\:-translate-x-48:focus {
    --transform-translate-x: -12rem;
  }
  .sm\\:focus\\:-translate-x-52:focus {
    --transform-translate-x: -13rem;
  }
  .sm\\:focus\\:-translate-x-56:focus {
    --transform-translate-x: -14rem;
  }
  .sm\\:focus\\:-translate-x-60:focus {
    --transform-translate-x: -15rem;
  }
  .sm\\:focus\\:-translate-x-64:focus {
    --transform-translate-x: -16rem;
  }
  .sm\\:focus\\:-translate-x-72:focus {
    --transform-translate-x: -18rem;
  }
  .sm\\:focus\\:-translate-x-80:focus {
    --transform-translate-x: -20rem;
  }
  .sm\\:focus\\:-translate-x-96:focus {
    --transform-translate-x: -24rem;
  }
  .sm\\:focus\\:-translate-x-px:focus {
    --transform-translate-x: -1px;
  }
  .sm\\:focus\\:-translate-x-0\\.5:focus {
    --transform-translate-x: -0.125rem;
  }
  .sm\\:focus\\:-translate-x-1\\.5:focus {
    --transform-translate-x: -0.375rem;
  }
  .sm\\:focus\\:-translate-x-2\\.5:focus {
    --transform-translate-x: -0.625rem;
  }
  .sm\\:focus\\:-translate-x-3\\.5:focus {
    --transform-translate-x: -0.875rem;
  }
  .sm\\:focus\\:-translate-x-1\\/2:focus {
    --transform-translate-x: -50%;
  }
  .sm\\:focus\\:-translate-x-1\\/3:focus {
    --transform-translate-x: -33.33333%;
  }
  .sm\\:focus\\:-translate-x-2\\/3:focus {
    --transform-translate-x: -66.66667%;
  }
  .sm\\:focus\\:-translate-x-1\\/4:focus {
    --transform-translate-x: -25%;
  }
  .sm\\:focus\\:-translate-x-2\\/4:focus {
    --transform-translate-x: -50%;
  }
  .sm\\:focus\\:-translate-x-3\\/4:focus {
    --transform-translate-x: -75%;
  }
  .sm\\:focus\\:-translate-x-1\\/5:focus {
    --transform-translate-x: -20%;
  }
  .sm\\:focus\\:-translate-x-2\\/5:focus {
    --transform-translate-x: -40%;
  }
  .sm\\:focus\\:-translate-x-3\\/5:focus {
    --transform-translate-x: -60%;
  }
  .sm\\:focus\\:-translate-x-4\\/5:focus {
    --transform-translate-x: -80%;
  }
  .sm\\:focus\\:-translate-x-1\\/6:focus {
    --transform-translate-x: -16.66667%;
  }
  .sm\\:focus\\:-translate-x-2\\/6:focus {
    --transform-translate-x: -33.33333%;
  }
  .sm\\:focus\\:-translate-x-3\\/6:focus {
    --transform-translate-x: -50%;
  }
  .sm\\:focus\\:-translate-x-4\\/6:focus {
    --transform-translate-x: -66.66667%;
  }
  .sm\\:focus\\:-translate-x-5\\/6:focus {
    --transform-translate-x: -83.33333%;
  }
  .sm\\:focus\\:-translate-x-1\\/12:focus {
    --transform-translate-x: -8.33333%;
  }
  .sm\\:focus\\:-translate-x-2\\/12:focus {
    --transform-translate-x: -16.66667%;
  }
  .sm\\:focus\\:-translate-x-3\\/12:focus {
    --transform-translate-x: -25%;
  }
  .sm\\:focus\\:-translate-x-4\\/12:focus {
    --transform-translate-x: -33.33333%;
  }
  .sm\\:focus\\:-translate-x-5\\/12:focus {
    --transform-translate-x: -41.66667%;
  }
  .sm\\:focus\\:-translate-x-6\\/12:focus {
    --transform-translate-x: -50%;
  }
  .sm\\:focus\\:-translate-x-7\\/12:focus {
    --transform-translate-x: -58.33333%;
  }
  .sm\\:focus\\:-translate-x-8\\/12:focus {
    --transform-translate-x: -66.66667%;
  }
  .sm\\:focus\\:-translate-x-9\\/12:focus {
    --transform-translate-x: -75%;
  }
  .sm\\:focus\\:-translate-x-10\\/12:focus {
    --transform-translate-x: -83.33333%;
  }
  .sm\\:focus\\:-translate-x-11\\/12:focus {
    --transform-translate-x: -91.66667%;
  }
  .sm\\:focus\\:-translate-x-full:focus {
    --transform-translate-x: -100%;
  }
  .sm\\:focus\\:translate-y-0:focus {
    --transform-translate-y: 0;
  }
  .sm\\:focus\\:translate-y-1:focus {
    --transform-translate-y: 0.25rem;
  }
  .sm\\:focus\\:translate-y-2:focus {
    --transform-translate-y: 0.5rem;
  }
  .sm\\:focus\\:translate-y-3:focus {
    --transform-translate-y: 0.75rem;
  }
  .sm\\:focus\\:translate-y-4:focus {
    --transform-translate-y: 1rem;
  }
  .sm\\:focus\\:translate-y-5:focus {
    --transform-translate-y: 1.25rem;
  }
  .sm\\:focus\\:translate-y-6:focus {
    --transform-translate-y: 1.5rem;
  }
  .sm\\:focus\\:translate-y-7:focus {
    --transform-translate-y: 1.75rem;
  }
  .sm\\:focus\\:translate-y-8:focus {
    --transform-translate-y: 2rem;
  }
  .sm\\:focus\\:translate-y-9:focus {
    --transform-translate-y: 2.25rem;
  }
  .sm\\:focus\\:translate-y-10:focus {
    --transform-translate-y: 2.5rem;
  }
  .sm\\:focus\\:translate-y-11:focus {
    --transform-translate-y: 2.75rem;
  }
  .sm\\:focus\\:translate-y-12:focus {
    --transform-translate-y: 3rem;
  }
  .sm\\:focus\\:translate-y-13:focus {
    --transform-translate-y: 3.25rem;
  }
  .sm\\:focus\\:translate-y-14:focus {
    --transform-translate-y: 3.5rem;
  }
  .sm\\:focus\\:translate-y-15:focus {
    --transform-translate-y: 3.75rem;
  }
  .sm\\:focus\\:translate-y-16:focus {
    --transform-translate-y: 4rem;
  }
  .sm\\:focus\\:translate-y-20:focus {
    --transform-translate-y: 5rem;
  }
  .sm\\:focus\\:translate-y-24:focus {
    --transform-translate-y: 6rem;
  }
  .sm\\:focus\\:translate-y-28:focus {
    --transform-translate-y: 7rem;
  }
  .sm\\:focus\\:translate-y-32:focus {
    --transform-translate-y: 8rem;
  }
  .sm\\:focus\\:translate-y-36:focus {
    --transform-translate-y: 9rem;
  }
  .sm\\:focus\\:translate-y-40:focus {
    --transform-translate-y: 10rem;
  }
  .sm\\:focus\\:translate-y-44:focus {
    --transform-translate-y: 11rem;
  }
  .sm\\:focus\\:translate-y-48:focus {
    --transform-translate-y: 12rem;
  }
  .sm\\:focus\\:translate-y-52:focus {
    --transform-translate-y: 13rem;
  }
  .sm\\:focus\\:translate-y-56:focus {
    --transform-translate-y: 14rem;
  }
  .sm\\:focus\\:translate-y-60:focus {
    --transform-translate-y: 15rem;
  }
  .sm\\:focus\\:translate-y-64:focus {
    --transform-translate-y: 16rem;
  }
  .sm\\:focus\\:translate-y-72:focus {
    --transform-translate-y: 18rem;
  }
  .sm\\:focus\\:translate-y-80:focus {
    --transform-translate-y: 20rem;
  }
  .sm\\:focus\\:translate-y-96:focus {
    --transform-translate-y: 24rem;
  }
  .sm\\:focus\\:translate-y-px:focus {
    --transform-translate-y: 1px;
  }
  .sm\\:focus\\:translate-y-0\\.5:focus {
    --transform-translate-y: 0.125rem;
  }
  .sm\\:focus\\:translate-y-1\\.5:focus {
    --transform-translate-y: 0.375rem;
  }
  .sm\\:focus\\:translate-y-2\\.5:focus {
    --transform-translate-y: 0.625rem;
  }
  .sm\\:focus\\:translate-y-3\\.5:focus {
    --transform-translate-y: 0.875rem;
  }
  .sm\\:focus\\:translate-y-1\\/2:focus {
    --transform-translate-y: 50%;
  }
  .sm\\:focus\\:translate-y-1\\/3:focus {
    --transform-translate-y: 33.333333%;
  }
  .sm\\:focus\\:translate-y-2\\/3:focus {
    --transform-translate-y: 66.666667%;
  }
  .sm\\:focus\\:translate-y-1\\/4:focus {
    --transform-translate-y: 25%;
  }
  .sm\\:focus\\:translate-y-2\\/4:focus {
    --transform-translate-y: 50%;
  }
  .sm\\:focus\\:translate-y-3\\/4:focus {
    --transform-translate-y: 75%;
  }
  .sm\\:focus\\:translate-y-1\\/5:focus {
    --transform-translate-y: 20%;
  }
  .sm\\:focus\\:translate-y-2\\/5:focus {
    --transform-translate-y: 40%;
  }
  .sm\\:focus\\:translate-y-3\\/5:focus {
    --transform-translate-y: 60%;
  }
  .sm\\:focus\\:translate-y-4\\/5:focus {
    --transform-translate-y: 80%;
  }
  .sm\\:focus\\:translate-y-1\\/6:focus {
    --transform-translate-y: 16.666667%;
  }
  .sm\\:focus\\:translate-y-2\\/6:focus {
    --transform-translate-y: 33.333333%;
  }
  .sm\\:focus\\:translate-y-3\\/6:focus {
    --transform-translate-y: 50%;
  }
  .sm\\:focus\\:translate-y-4\\/6:focus {
    --transform-translate-y: 66.666667%;
  }
  .sm\\:focus\\:translate-y-5\\/6:focus {
    --transform-translate-y: 83.333333%;
  }
  .sm\\:focus\\:translate-y-1\\/12:focus {
    --transform-translate-y: 8.333333%;
  }
  .sm\\:focus\\:translate-y-2\\/12:focus {
    --transform-translate-y: 16.666667%;
  }
  .sm\\:focus\\:translate-y-3\\/12:focus {
    --transform-translate-y: 25%;
  }
  .sm\\:focus\\:translate-y-4\\/12:focus {
    --transform-translate-y: 33.333333%;
  }
  .sm\\:focus\\:translate-y-5\\/12:focus {
    --transform-translate-y: 41.666667%;
  }
  .sm\\:focus\\:translate-y-6\\/12:focus {
    --transform-translate-y: 50%;
  }
  .sm\\:focus\\:translate-y-7\\/12:focus {
    --transform-translate-y: 58.333333%;
  }
  .sm\\:focus\\:translate-y-8\\/12:focus {
    --transform-translate-y: 66.666667%;
  }
  .sm\\:focus\\:translate-y-9\\/12:focus {
    --transform-translate-y: 75%;
  }
  .sm\\:focus\\:translate-y-10\\/12:focus {
    --transform-translate-y: 83.333333%;
  }
  .sm\\:focus\\:translate-y-11\\/12:focus {
    --transform-translate-y: 91.666667%;
  }
  .sm\\:focus\\:translate-y-full:focus {
    --transform-translate-y: 100%;
  }
  .sm\\:focus\\:-translate-y-1:focus {
    --transform-translate-y: -0.25rem;
  }
  .sm\\:focus\\:-translate-y-2:focus {
    --transform-translate-y: -0.5rem;
  }
  .sm\\:focus\\:-translate-y-3:focus {
    --transform-translate-y: -0.75rem;
  }
  .sm\\:focus\\:-translate-y-4:focus {
    --transform-translate-y: -1rem;
  }
  .sm\\:focus\\:-translate-y-5:focus {
    --transform-translate-y: -1.25rem;
  }
  .sm\\:focus\\:-translate-y-6:focus {
    --transform-translate-y: -1.5rem;
  }
  .sm\\:focus\\:-translate-y-7:focus {
    --transform-translate-y: -1.75rem;
  }
  .sm\\:focus\\:-translate-y-8:focus {
    --transform-translate-y: -2rem;
  }
  .sm\\:focus\\:-translate-y-9:focus {
    --transform-translate-y: -2.25rem;
  }
  .sm\\:focus\\:-translate-y-10:focus {
    --transform-translate-y: -2.5rem;
  }
  .sm\\:focus\\:-translate-y-11:focus {
    --transform-translate-y: -2.75rem;
  }
  .sm\\:focus\\:-translate-y-12:focus {
    --transform-translate-y: -3rem;
  }
  .sm\\:focus\\:-translate-y-13:focus {
    --transform-translate-y: -3.25rem;
  }
  .sm\\:focus\\:-translate-y-14:focus {
    --transform-translate-y: -3.5rem;
  }
  .sm\\:focus\\:-translate-y-15:focus {
    --transform-translate-y: -3.75rem;
  }
  .sm\\:focus\\:-translate-y-16:focus {
    --transform-translate-y: -4rem;
  }
  .sm\\:focus\\:-translate-y-20:focus {
    --transform-translate-y: -5rem;
  }
  .sm\\:focus\\:-translate-y-24:focus {
    --transform-translate-y: -6rem;
  }
  .sm\\:focus\\:-translate-y-28:focus {
    --transform-translate-y: -7rem;
  }
  .sm\\:focus\\:-translate-y-32:focus {
    --transform-translate-y: -8rem;
  }
  .sm\\:focus\\:-translate-y-36:focus {
    --transform-translate-y: -9rem;
  }
  .sm\\:focus\\:-translate-y-40:focus {
    --transform-translate-y: -10rem;
  }
  .sm\\:focus\\:-translate-y-44:focus {
    --transform-translate-y: -11rem;
  }
  .sm\\:focus\\:-translate-y-48:focus {
    --transform-translate-y: -12rem;
  }
  .sm\\:focus\\:-translate-y-52:focus {
    --transform-translate-y: -13rem;
  }
  .sm\\:focus\\:-translate-y-56:focus {
    --transform-translate-y: -14rem;
  }
  .sm\\:focus\\:-translate-y-60:focus {
    --transform-translate-y: -15rem;
  }
  .sm\\:focus\\:-translate-y-64:focus {
    --transform-translate-y: -16rem;
  }
  .sm\\:focus\\:-translate-y-72:focus {
    --transform-translate-y: -18rem;
  }
  .sm\\:focus\\:-translate-y-80:focus {
    --transform-translate-y: -20rem;
  }
  .sm\\:focus\\:-translate-y-96:focus {
    --transform-translate-y: -24rem;
  }
  .sm\\:focus\\:-translate-y-px:focus {
    --transform-translate-y: -1px;
  }
  .sm\\:focus\\:-translate-y-0\\.5:focus {
    --transform-translate-y: -0.125rem;
  }
  .sm\\:focus\\:-translate-y-1\\.5:focus {
    --transform-translate-y: -0.375rem;
  }
  .sm\\:focus\\:-translate-y-2\\.5:focus {
    --transform-translate-y: -0.625rem;
  }
  .sm\\:focus\\:-translate-y-3\\.5:focus {
    --transform-translate-y: -0.875rem;
  }
  .sm\\:focus\\:-translate-y-1\\/2:focus {
    --transform-translate-y: -50%;
  }
  .sm\\:focus\\:-translate-y-1\\/3:focus {
    --transform-translate-y: -33.33333%;
  }
  .sm\\:focus\\:-translate-y-2\\/3:focus {
    --transform-translate-y: -66.66667%;
  }
  .sm\\:focus\\:-translate-y-1\\/4:focus {
    --transform-translate-y: -25%;
  }
  .sm\\:focus\\:-translate-y-2\\/4:focus {
    --transform-translate-y: -50%;
  }
  .sm\\:focus\\:-translate-y-3\\/4:focus {
    --transform-translate-y: -75%;
  }
  .sm\\:focus\\:-translate-y-1\\/5:focus {
    --transform-translate-y: -20%;
  }
  .sm\\:focus\\:-translate-y-2\\/5:focus {
    --transform-translate-y: -40%;
  }
  .sm\\:focus\\:-translate-y-3\\/5:focus {
    --transform-translate-y: -60%;
  }
  .sm\\:focus\\:-translate-y-4\\/5:focus {
    --transform-translate-y: -80%;
  }
  .sm\\:focus\\:-translate-y-1\\/6:focus {
    --transform-translate-y: -16.66667%;
  }
  .sm\\:focus\\:-translate-y-2\\/6:focus {
    --transform-translate-y: -33.33333%;
  }
  .sm\\:focus\\:-translate-y-3\\/6:focus {
    --transform-translate-y: -50%;
  }
  .sm\\:focus\\:-translate-y-4\\/6:focus {
    --transform-translate-y: -66.66667%;
  }
  .sm\\:focus\\:-translate-y-5\\/6:focus {
    --transform-translate-y: -83.33333%;
  }
  .sm\\:focus\\:-translate-y-1\\/12:focus {
    --transform-translate-y: -8.33333%;
  }
  .sm\\:focus\\:-translate-y-2\\/12:focus {
    --transform-translate-y: -16.66667%;
  }
  .sm\\:focus\\:-translate-y-3\\/12:focus {
    --transform-translate-y: -25%;
  }
  .sm\\:focus\\:-translate-y-4\\/12:focus {
    --transform-translate-y: -33.33333%;
  }
  .sm\\:focus\\:-translate-y-5\\/12:focus {
    --transform-translate-y: -41.66667%;
  }
  .sm\\:focus\\:-translate-y-6\\/12:focus {
    --transform-translate-y: -50%;
  }
  .sm\\:focus\\:-translate-y-7\\/12:focus {
    --transform-translate-y: -58.33333%;
  }
  .sm\\:focus\\:-translate-y-8\\/12:focus {
    --transform-translate-y: -66.66667%;
  }
  .sm\\:focus\\:-translate-y-9\\/12:focus {
    --transform-translate-y: -75%;
  }
  .sm\\:focus\\:-translate-y-10\\/12:focus {
    --transform-translate-y: -83.33333%;
  }
  .sm\\:focus\\:-translate-y-11\\/12:focus {
    --transform-translate-y: -91.66667%;
  }
  .sm\\:focus\\:-translate-y-full:focus {
    --transform-translate-y: -100%;
  }
  .sm\\:skew-x-0 {
    --transform-skew-x: 0;
  }
  .sm\\:skew-x-1 {
    --transform-skew-x: 1deg;
  }
  .sm\\:skew-x-2 {
    --transform-skew-x: 2deg;
  }
  .sm\\:skew-x-3 {
    --transform-skew-x: 3deg;
  }
  .sm\\:skew-x-6 {
    --transform-skew-x: 6deg;
  }
  .sm\\:skew-x-12 {
    --transform-skew-x: 12deg;
  }
  .sm\\:-skew-x-12 {
    --transform-skew-x: -12deg;
  }
  .sm\\:-skew-x-6 {
    --transform-skew-x: -6deg;
  }
  .sm\\:-skew-x-3 {
    --transform-skew-x: -3deg;
  }
  .sm\\:-skew-x-2 {
    --transform-skew-x: -2deg;
  }
  .sm\\:-skew-x-1 {
    --transform-skew-x: -1deg;
  }
  .sm\\:skew-y-0 {
    --transform-skew-y: 0;
  }
  .sm\\:skew-y-1 {
    --transform-skew-y: 1deg;
  }
  .sm\\:skew-y-2 {
    --transform-skew-y: 2deg;
  }
  .sm\\:skew-y-3 {
    --transform-skew-y: 3deg;
  }
  .sm\\:skew-y-6 {
    --transform-skew-y: 6deg;
  }
  .sm\\:skew-y-12 {
    --transform-skew-y: 12deg;
  }
  .sm\\:-skew-y-12 {
    --transform-skew-y: -12deg;
  }
  .sm\\:-skew-y-6 {
    --transform-skew-y: -6deg;
  }
  .sm\\:-skew-y-3 {
    --transform-skew-y: -3deg;
  }
  .sm\\:-skew-y-2 {
    --transform-skew-y: -2deg;
  }
  .sm\\:-skew-y-1 {
    --transform-skew-y: -1deg;
  }
  .sm\\:hover\\:skew-x-0:hover {
    --transform-skew-x: 0;
  }
  .sm\\:hover\\:skew-x-1:hover {
    --transform-skew-x: 1deg;
  }
  .sm\\:hover\\:skew-x-2:hover {
    --transform-skew-x: 2deg;
  }
  .sm\\:hover\\:skew-x-3:hover {
    --transform-skew-x: 3deg;
  }
  .sm\\:hover\\:skew-x-6:hover {
    --transform-skew-x: 6deg;
  }
  .sm\\:hover\\:skew-x-12:hover {
    --transform-skew-x: 12deg;
  }
  .sm\\:hover\\:-skew-x-12:hover {
    --transform-skew-x: -12deg;
  }
  .sm\\:hover\\:-skew-x-6:hover {
    --transform-skew-x: -6deg;
  }
  .sm\\:hover\\:-skew-x-3:hover {
    --transform-skew-x: -3deg;
  }
  .sm\\:hover\\:-skew-x-2:hover {
    --transform-skew-x: -2deg;
  }
  .sm\\:hover\\:-skew-x-1:hover {
    --transform-skew-x: -1deg;
  }
  .sm\\:hover\\:skew-y-0:hover {
    --transform-skew-y: 0;
  }
  .sm\\:hover\\:skew-y-1:hover {
    --transform-skew-y: 1deg;
  }
  .sm\\:hover\\:skew-y-2:hover {
    --transform-skew-y: 2deg;
  }
  .sm\\:hover\\:skew-y-3:hover {
    --transform-skew-y: 3deg;
  }
  .sm\\:hover\\:skew-y-6:hover {
    --transform-skew-y: 6deg;
  }
  .sm\\:hover\\:skew-y-12:hover {
    --transform-skew-y: 12deg;
  }
  .sm\\:hover\\:-skew-y-12:hover {
    --transform-skew-y: -12deg;
  }
  .sm\\:hover\\:-skew-y-6:hover {
    --transform-skew-y: -6deg;
  }
  .sm\\:hover\\:-skew-y-3:hover {
    --transform-skew-y: -3deg;
  }
  .sm\\:hover\\:-skew-y-2:hover {
    --transform-skew-y: -2deg;
  }
  .sm\\:hover\\:-skew-y-1:hover {
    --transform-skew-y: -1deg;
  }
  .sm\\:focus\\:skew-x-0:focus {
    --transform-skew-x: 0;
  }
  .sm\\:focus\\:skew-x-1:focus {
    --transform-skew-x: 1deg;
  }
  .sm\\:focus\\:skew-x-2:focus {
    --transform-skew-x: 2deg;
  }
  .sm\\:focus\\:skew-x-3:focus {
    --transform-skew-x: 3deg;
  }
  .sm\\:focus\\:skew-x-6:focus {
    --transform-skew-x: 6deg;
  }
  .sm\\:focus\\:skew-x-12:focus {
    --transform-skew-x: 12deg;
  }
  .sm\\:focus\\:-skew-x-12:focus {
    --transform-skew-x: -12deg;
  }
  .sm\\:focus\\:-skew-x-6:focus {
    --transform-skew-x: -6deg;
  }
  .sm\\:focus\\:-skew-x-3:focus {
    --transform-skew-x: -3deg;
  }
  .sm\\:focus\\:-skew-x-2:focus {
    --transform-skew-x: -2deg;
  }
  .sm\\:focus\\:-skew-x-1:focus {
    --transform-skew-x: -1deg;
  }
  .sm\\:focus\\:skew-y-0:focus {
    --transform-skew-y: 0;
  }
  .sm\\:focus\\:skew-y-1:focus {
    --transform-skew-y: 1deg;
  }
  .sm\\:focus\\:skew-y-2:focus {
    --transform-skew-y: 2deg;
  }
  .sm\\:focus\\:skew-y-3:focus {
    --transform-skew-y: 3deg;
  }
  .sm\\:focus\\:skew-y-6:focus {
    --transform-skew-y: 6deg;
  }
  .sm\\:focus\\:skew-y-12:focus {
    --transform-skew-y: 12deg;
  }
  .sm\\:focus\\:-skew-y-12:focus {
    --transform-skew-y: -12deg;
  }
  .sm\\:focus\\:-skew-y-6:focus {
    --transform-skew-y: -6deg;
  }
  .sm\\:focus\\:-skew-y-3:focus {
    --transform-skew-y: -3deg;
  }
  .sm\\:focus\\:-skew-y-2:focus {
    --transform-skew-y: -2deg;
  }
  .sm\\:focus\\:-skew-y-1:focus {
    --transform-skew-y: -1deg;
  }
  .sm\\:transition-none {
    transition-property: none;
  }
  .sm\\:transition-all {
    transition-property: all;
  }
  .sm\\:transition {
    transition-property: background-color, border-color, color, fill, stroke, opacity, box-shadow, transform;
  }
  .sm\\:transition-colors {
    transition-property: background-color, border-color, color, fill, stroke;
  }
  .sm\\:transition-opacity {
    transition-property: opacity;
  }
  .sm\\:transition-shadow {
    transition-property: box-shadow;
  }
  .sm\\:transition-transform {
    transition-property: transform;
  }
  .sm\\:ease-linear {
    transition-timing-function: linear;
  }
  .sm\\:ease-in {
    transition-timing-function: cubic-bezier(0.4, 0, 1, 1);
  }
  .sm\\:ease-out {
    transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
  }
  .sm\\:ease-in-out {
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  }
  .sm\\:duration-75 {
    transition-duration: 75ms;
  }
  .sm\\:duration-100 {
    transition-duration: 100ms;
  }
  .sm\\:duration-150 {
    transition-duration: 150ms;
  }
  .sm\\:duration-200 {
    transition-duration: 200ms;
  }
  .sm\\:duration-300 {
    transition-duration: 300ms;
  }
  .sm\\:duration-500 {
    transition-duration: 500ms;
  }
  .sm\\:duration-700 {
    transition-duration: 700ms;
  }
  .sm\\:duration-1000 {
    transition-duration: 1000ms;
  }
  .sm\\:delay-75 {
    transition-delay: 75ms;
  }
  .sm\\:delay-100 {
    transition-delay: 100ms;
  }
  .sm\\:delay-150 {
    transition-delay: 150ms;
  }
  .sm\\:delay-200 {
    transition-delay: 200ms;
  }
  .sm\\:delay-300 {
    transition-delay: 300ms;
  }
  .sm\\:delay-500 {
    transition-delay: 500ms;
  }
  .sm\\:delay-700 {
    transition-delay: 700ms;
  }
  .sm\\:delay-1000 {
    transition-delay: 1000ms;
  }
  .sm\\:animate-none {
    animation: none;
  }
  .sm\\:animate-spin {
    animation: spin 1s linear infinite;
  }
  .sm\\:animate-ping {
    animation: ping 1s cubic-bezier(0, 0, 0.2, 1) infinite;
  }
  .sm\\:animate-pulse {
    animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
  }
  .sm\\:animate-bounce {
    animation: bounce 1s infinite;
  }
}
@media (min-width: 768px) {
  .md\\:container {
    width: 100%;
  }
  @media (min-width: 640px) {
    .md\\:container {
      max-width: 640px;
    }
  }
  @media (min-width: 768px) {
    .md\\:container {
      max-width: 768px;
    }
  }
  @media (min-width: 1024px) {
    .md\\:container {
      max-width: 1024px;
    }
  }
  @media (min-width: 1280px) {
    .md\\:container {
      max-width: 1280px;
    }
  }
  .md\\:prose {
    color: #374151;
    max-width: 65ch;
  }
  .md\\:prose [class~="lead"] {
    color: #4b5563;
    font-size: 1.25em;
    line-height: 1.6;
    margin-top: 1.2em;
    margin-bottom: 1.2em;
  }
  .md\\:prose a {
    color: #5850ec;
    text-decoration: none;
    font-weight: 600;
  }
  .md\\:prose strong {
    color: #161e2e;
    font-weight: 600;
  }
  .md\\:prose ol {
    counter-reset: list-counter;
    margin-top: 1.25em;
    margin-bottom: 1.25em;
  }
  .md\\:prose ol>li {
    position: relative;
    counter-increment: list-counter;
    padding-left: 1.75em;
  }
  .md\\:prose ol>li::before {
    content: counter(list-counter) ".";
    position: absolute;
    font-weight: 400;
    color: #6b7280;
  }
  .md\\:prose ul>li {
    position: relative;
    padding-left: 1.75em;
  }
  .md\\:prose ul>li::before {
    content: "";
    position: absolute;
    background-color: #d2d6dc;
    border-radius: 50%;
    width: 0.375em;
    height: 0.375em;
    top: calc(0.875em - 0.1875em);
    left: 0.25em;
  }
  .md\\:prose hr {
    border-color: #e5e7eb;
    border-top-width: 1px;
    margin-top: 3em;
    margin-bottom: 3em;
  }
  .md\\:prose blockquote {
    font-weight: 500;
    font-style: italic;
    color: #161e2e;
    border-left-width: 0.25rem;
    border-left-color: #e5e7eb;
    quotes: "\\201C" "\\201D" "\\2018" "\\2019";
    margin-top: 1.6em;
    margin-bottom: 1.6em;
    padding-left: 1em;
  }
  .md\\:prose blockquote p:first-of-type::before {
    content: open-quote;
  }
  .md\\:prose blockquote p:last-of-type::after {
    content: close-quote;
  }
  .md\\:prose h1 {
    color: #1a202c;
    font-weight: 800;
    font-size: 2.25em;
    margin-top: 0;
    margin-bottom: 0.8888889em;
    line-height: 1.1111111;
  }
  .md\\:prose h2 {
    color: #1a202c;
    font-weight: 700;
    font-size: 1.5em;
    margin-top: 2em;
    margin-bottom: 1em;
    line-height: 1.3333333;
  }
  .md\\:prose h3 {
    color: #1a202c;
    font-weight: 600;
    font-size: 1.25em;
    margin-top: 1.6em;
    margin-bottom: 0.6em;
    line-height: 1.6;
  }
  .md\\:prose h4 {
    color: #1a202c;
    font-weight: 600;
    margin-top: 1.5em;
    margin-bottom: 0.5em;
    line-height: 1.5;
  }
  .md\\:prose figure figcaption {
    color: #6b7280;
    font-size: 0.875em;
    line-height: 1.4285714;
    margin-top: 0.8571429em;
  }
  .md\\:prose code {
    color: #161e2e;
    font-weight: 600;
    font-size: 0.875em;
  }
  .md\\:prose code::before {
    content: "\`";
  }
  .md\\:prose code::after {
    content: "\`";
  }
  .md\\:prose pre {
    color: #e5e7eb;
    background-color: #252f3f;
    overflow-x: auto;
    font-size: 0.875em;
    line-height: 1.7142857;
    margin-top: 1.7142857em;
    margin-bottom: 1.7142857em;
    border-radius: 0.375rem;
    padding-top: 0.8571429em;
    padding-right: 1.1428571em;
    padding-bottom: 0.8571429em;
    padding-left: 1.1428571em;
  }
  .md\\:prose pre code {
    background-color: transparent;
    border-width: 0;
    border-radius: 0;
    padding: 0;
    font-weight: 400;
    color: inherit;
    font-size: inherit;
    font-family: inherit;
    line-height: inherit;
  }
  .md\\:prose pre code::before {
    content: "";
  }
  .md\\:prose pre code::after {
    content: "";
  }
  .md\\:prose table {
    width: 100%;
    table-layout: auto;
    text-align: left;
    margin-top: 2em;
    margin-bottom: 2em;
    font-size: 0.875em;
    line-height: 1.7142857;
  }
  .md\\:prose thead {
    color: #161e2e;
    font-weight: 600;
    border-bottom-width: 1px;
    border-bottom-color: #d2d6dc;
  }
  .md\\:prose thead th {
    vertical-align: bottom;
    padding-right: 0.5714286em;
    padding-bottom: 0.5714286em;
    padding-left: 0.5714286em;
  }
  .md\\:prose tbody tr {
    border-bottom-width: 1px;
    border-bottom-color: #e5e7eb;
  }
  .md\\:prose tbody tr:last-child {
    border-bottom-width: 0;
  }
  .md\\:prose tbody td {
    vertical-align: top;
    padding-top: 0.5714286em;
    padding-right: 0.5714286em;
    padding-bottom: 0.5714286em;
    padding-left: 0.5714286em;
  }
  .md\\:prose {
    font-size: 1rem;
    line-height: 1.75;
  }
  .md\\:prose p {
    margin-top: 1.25em;
    margin-bottom: 1.25em;
  }
  .md\\:prose img {
    margin-top: 2em;
    margin-bottom: 2em;
  }
  .md\\:prose video {
    margin-top: 2em;
    margin-bottom: 2em;
  }
  .md\\:prose figure {
    margin-top: 2em;
    margin-bottom: 2em;
  }
  .md\\:prose figure>* {
    margin-top: 0;
    margin-bottom: 0;
  }
  .md\\:prose h2 code {
    font-size: 0.875em;
  }
  .md\\:prose h3 code {
    font-size: 0.9em;
  }
  .md\\:prose ul {
    margin-top: 1.25em;
    margin-bottom: 1.25em;
  }
  .md\\:prose li {
    margin-top: 0.5em;
    margin-bottom: 0.5em;
  }
  .md\\:prose ol>li:before {
    left: 0;
  }
  .md\\:prose>ul>li p {
    margin-top: 0.75em;
    margin-bottom: 0.75em;
  }
  .md\\:prose>ul>li>*:first-child {
    margin-top: 1.25em;
  }
  .md\\:prose>ul>li>*:last-child {
    margin-bottom: 1.25em;
  }
  .md\\:prose>ol>li>*:first-child {
    margin-top: 1.25em;
  }
  .md\\:prose>ol>li>*:last-child {
    margin-bottom: 1.25em;
  }
  .md\\:prose ul ul, .md\\:prose ul ol, .md\\:prose ol ul, .md\\:prose ol ol {
    margin-top: 0.75em;
    margin-bottom: 0.75em;
  }
  .md\\:prose hr+* {
    margin-top: 0;
  }
  .md\\:prose h2+* {
    margin-top: 0;
  }
  .md\\:prose h3+* {
    margin-top: 0;
  }
  .md\\:prose h4+* {
    margin-top: 0;
  }
  .md\\:prose thead th:first-child {
    padding-left: 0;
  }
  .md\\:prose thead th:last-child {
    padding-right: 0;
  }
  .md\\:prose tbody td:first-child {
    padding-left: 0;
  }
  .md\\:prose tbody td:last-child {
    padding-right: 0;
  }
  .md\\:prose> :first-child {
    margin-top: 0;
  }
  .md\\:prose> :last-child {
    margin-bottom: 0;
  }
  .md\\:prose h1, .md\\:prose h2, .md\\:prose h3, .md\\:prose h4 {
    color: #161e2e;
  }
  .md\\:prose-sm {
    font-size: 0.875rem;
    line-height: 1.7142857;
  }
  .md\\:prose-sm p {
    margin-top: 1.1428571em;
    margin-bottom: 1.1428571em;
  }
  .md\\:prose-sm [class~="lead"] {
    font-size: 1.2857143em;
    line-height: 1.5555556;
    margin-top: 0.8888889em;
    margin-bottom: 0.8888889em;
  }
  .md\\:prose-sm blockquote {
    margin-top: 1.3333333em;
    margin-bottom: 1.3333333em;
    padding-left: 1.1111111em;
  }
  .md\\:prose-sm h1 {
    font-size: 2.1428571em;
    margin-top: 0;
    margin-bottom: 0.8em;
    line-height: 1.2;
  }
  .md\\:prose-sm h2 {
    font-size: 1.4285714em;
    margin-top: 1.6em;
    margin-bottom: 0.8em;
    line-height: 1.4;
  }
  .md\\:prose-sm h3 {
    font-size: 1.2857143em;
    margin-top: 1.5555556em;
    margin-bottom: 0.4444444em;
    line-height: 1.5555556;
  }
  .md\\:prose-sm h4 {
    margin-top: 1.4285714em;
    margin-bottom: 0.5714286em;
    line-height: 1.4285714;
  }
  .md\\:prose-sm img {
    margin-top: 1.7142857em;
    margin-bottom: 1.7142857em;
  }
  .md\\:prose-sm video {
    margin-top: 1.7142857em;
    margin-bottom: 1.7142857em;
  }
  .md\\:prose-sm figure {
    margin-top: 1.7142857em;
    margin-bottom: 1.7142857em;
  }
  .md\\:prose-sm figure>* {
    margin-top: 0;
    margin-bottom: 0;
  }
  .md\\:prose-sm figure figcaption {
    font-size: 0.8571429em;
    line-height: 1.3333333;
    margin-top: 0.6666667em;
  }
  .md\\:prose-sm code {
    font-size: 0.8571429em;
  }
  .md\\:prose-sm h2 code {
    font-size: 0.9em;
  }
  .md\\:prose-sm h3 code {
    font-size: 0.8888889em;
  }
  .md\\:prose-sm pre {
    font-size: 0.8571429em;
    line-height: 1.6666667;
    margin-top: 1.6666667em;
    margin-bottom: 1.6666667em;
    border-radius: 0.25rem;
    padding-top: 0.6666667em;
    padding-right: 1em;
    padding-bottom: 0.6666667em;
    padding-left: 1em;
  }
  .md\\:prose-sm ol {
    margin-top: 1.1428571em;
    margin-bottom: 1.1428571em;
  }
  .md\\:prose-sm ul {
    margin-top: 1.1428571em;
    margin-bottom: 1.1428571em;
  }
  .md\\:prose-sm li {
    margin-top: 0.2857143em;
    margin-bottom: 0.2857143em;
  }
  .md\\:prose-sm ol>li {
    padding-left: 1.5714286em;
  }
  .md\\:prose-sm ol>li:before {
    left: 0;
  }
  .md\\:prose-sm ul>li {
    padding-left: 1.5714286em;
  }
  .md\\:prose-sm ul>li::before {
    height: 0.3571429em;
    width: 0.3571429em;
    top: calc(0.8571429em - 0.1785714em);
    left: 0.2142857em;
  }
  .md\\:prose-sm>ul>li p {
    margin-top: 0.5714286em;
    margin-bottom: 0.5714286em;
  }
  .md\\:prose-sm>ul>li>*:first-child {
    margin-top: 1.1428571em;
  }
  .md\\:prose-sm>ul>li>*:last-child {
    margin-bottom: 1.1428571em;
  }
  .md\\:prose-sm>ol>li>*:first-child {
    margin-top: 1.1428571em;
  }
  .md\\:prose-sm>ol>li>*:last-child {
    margin-bottom: 1.1428571em;
  }
  .md\\:prose-sm ul ul, .md\\:prose-sm ul ol, .md\\:prose-sm ol ul, .md\\:prose-sm ol ol {
    margin-top: 0.5714286em;
    margin-bottom: 0.5714286em;
  }
  .md\\:prose-sm hr {
    margin-top: 2.8571429em;
    margin-bottom: 2.8571429em;
  }
  .md\\:prose-sm hr+* {
    margin-top: 0;
  }
  .md\\:prose-sm h2+* {
    margin-top: 0;
  }
  .md\\:prose-sm h3+* {
    margin-top: 0;
  }
  .md\\:prose-sm h4+* {
    margin-top: 0;
  }
  .md\\:prose-sm table {
    font-size: 0.8571429em;
    line-height: 1.5;
  }
  .md\\:prose-sm thead th {
    padding-right: 1em;
    padding-bottom: 0.6666667em;
    padding-left: 1em;
  }
  .md\\:prose-sm thead th:first-child {
    padding-left: 0;
  }
  .md\\:prose-sm thead th:last-child {
    padding-right: 0;
  }
  .md\\:prose-sm tbody td {
    padding-top: 0.6666667em;
    padding-right: 1em;
    padding-bottom: 0.6666667em;
    padding-left: 1em;
  }
  .md\\:prose-sm tbody td:first-child {
    padding-left: 0;
  }
  .md\\:prose-sm tbody td:last-child {
    padding-right: 0;
  }
  .md\\:prose-sm> :first-child {
    margin-top: 0;
  }
  .md\\:prose-sm> :last-child {
    margin-bottom: 0;
  }
  .md\\:prose-lg {
    font-size: 1.125rem;
    line-height: 1.7777778;
  }
  .md\\:prose-lg p {
    margin-top: 1.3333333em;
    margin-bottom: 1.3333333em;
  }
  .md\\:prose-lg [class~="lead"] {
    font-size: 1.2222222em;
    line-height: 1.4545455;
    margin-top: 1.0909091em;
    margin-bottom: 1.0909091em;
  }
  .md\\:prose-lg blockquote {
    margin-top: 1.6666667em;
    margin-bottom: 1.6666667em;
    padding-left: 1em;
  }
  .md\\:prose-lg h1 {
    font-size: 2.6666667em;
    margin-top: 0;
    margin-bottom: 0.8333333em;
    line-height: 1;
  }
  .md\\:prose-lg h2 {
    font-size: 1.6666667em;
    margin-top: 1.8666667em;
    margin-bottom: 1.0666667em;
    line-height: 1.3333333;
  }
  .md\\:prose-lg h3 {
    font-size: 1.3333333em;
    margin-top: 1.6666667em;
    margin-bottom: 0.6666667em;
    line-height: 1.5;
  }
  .md\\:prose-lg h4 {
    margin-top: 1.7777778em;
    margin-bottom: 0.4444444em;
    line-height: 1.5555556;
  }
  .md\\:prose-lg img {
    margin-top: 1.7777778em;
    margin-bottom: 1.7777778em;
  }
  .md\\:prose-lg video {
    margin-top: 1.7777778em;
    margin-bottom: 1.7777778em;
  }
  .md\\:prose-lg figure {
    margin-top: 1.7777778em;
    margin-bottom: 1.7777778em;
  }
  .md\\:prose-lg figure>* {
    margin-top: 0;
    margin-bottom: 0;
  }
  .md\\:prose-lg figure figcaption {
    font-size: 0.8888889em;
    line-height: 1.5;
    margin-top: 1em;
  }
  .md\\:prose-lg code {
    font-size: 0.8888889em;
  }
  .md\\:prose-lg h2 code {
    font-size: 0.8666667em;
  }
  .md\\:prose-lg h3 code {
    font-size: 0.875em;
  }
  .md\\:prose-lg pre {
    font-size: 0.8888889em;
    line-height: 1.75;
    margin-top: 2em;
    margin-bottom: 2em;
    border-radius: 0.375rem;
    padding-top: 1em;
    padding-right: 1.5em;
    padding-bottom: 1em;
    padding-left: 1.5em;
  }
  .md\\:prose-lg ol {
    margin-top: 1.3333333em;
    margin-bottom: 1.3333333em;
  }
  .md\\:prose-lg ul {
    margin-top: 1.3333333em;
    margin-bottom: 1.3333333em;
  }
  .md\\:prose-lg li {
    margin-top: 0.6666667em;
    margin-bottom: 0.6666667em;
  }
  .md\\:prose-lg ol>li {
    padding-left: 1.6666667em;
  }
  .md\\:prose-lg ol>li:before {
    left: 0;
  }
  .md\\:prose-lg ul>li {
    padding-left: 1.6666667em;
  }
  .md\\:prose-lg ul>li::before {
    width: 0.3333333em;
    height: 0.3333333em;
    top: calc(0.8888889em - 0.1666667em);
    left: 0.2222222em;
  }
  .md\\:prose-lg>ul>li p {
    margin-top: 0.8888889em;
    margin-bottom: 0.8888889em;
  }
  .md\\:prose-lg>ul>li>*:first-child {
    margin-top: 1.3333333em;
  }
  .md\\:prose-lg>ul>li>*:last-child {
    margin-bottom: 1.3333333em;
  }
  .md\\:prose-lg>ol>li>*:first-child {
    margin-top: 1.3333333em;
  }
  .md\\:prose-lg>ol>li>*:last-child {
    margin-bottom: 1.3333333em;
  }
  .md\\:prose-lg ul ul, .md\\:prose-lg ul ol, .md\\:prose-lg ol ul, .md\\:prose-lg ol ol {
    margin-top: 0.8888889em;
    margin-bottom: 0.8888889em;
  }
  .md\\:prose-lg hr {
    margin-top: 3.1111111em;
    margin-bottom: 3.1111111em;
  }
  .md\\:prose-lg hr+* {
    margin-top: 0;
  }
  .md\\:prose-lg h2+* {
    margin-top: 0;
  }
  .md\\:prose-lg h3+* {
    margin-top: 0;
  }
  .md\\:prose-lg h4+* {
    margin-top: 0;
  }
  .md\\:prose-lg table {
    font-size: 0.8888889em;
    line-height: 1.5;
  }
  .md\\:prose-lg thead th {
    padding-right: 0.75em;
    padding-bottom: 0.75em;
    padding-left: 0.75em;
  }
  .md\\:prose-lg thead th:first-child {
    padding-left: 0;
  }
  .md\\:prose-lg thead th:last-child {
    padding-right: 0;
  }
  .md\\:prose-lg tbody td {
    padding-top: 0.75em;
    padding-right: 0.75em;
    padding-bottom: 0.75em;
    padding-left: 0.75em;
  }
  .md\\:prose-lg tbody td:first-child {
    padding-left: 0;
  }
  .md\\:prose-lg tbody td:last-child {
    padding-right: 0;
  }
  .md\\:prose-lg> :first-child {
    margin-top: 0;
  }
  .md\\:prose-lg> :last-child {
    margin-bottom: 0;
  }
  .md\\:prose-xl {
    font-size: 1.25rem;
    line-height: 1.8;
  }
  .md\\:prose-xl p {
    margin-top: 1.2em;
    margin-bottom: 1.2em;
  }
  .md\\:prose-xl [class~="lead"] {
    font-size: 1.2em;
    line-height: 1.5;
    margin-top: 1em;
    margin-bottom: 1em;
  }
  .md\\:prose-xl blockquote {
    margin-top: 1.6em;
    margin-bottom: 1.6em;
    padding-left: 1.0666667em;
  }
  .md\\:prose-xl h1 {
    font-size: 2.8em;
    margin-top: 0;
    margin-bottom: 0.8571429em;
    line-height: 1;
  }
  .md\\:prose-xl h2 {
    font-size: 1.8em;
    margin-top: 1.5555556em;
    margin-bottom: 0.8888889em;
    line-height: 1.1111111;
  }
  .md\\:prose-xl h3 {
    font-size: 1.5em;
    margin-top: 1.6em;
    margin-bottom: 0.6666667em;
    line-height: 1.3333333;
  }
  .md\\:prose-xl h4 {
    margin-top: 1.8em;
    margin-bottom: 0.6em;
    line-height: 1.6;
  }
  .md\\:prose-xl img {
    margin-top: 2em;
    margin-bottom: 2em;
  }
  .md\\:prose-xl video {
    margin-top: 2em;
    margin-bottom: 2em;
  }
  .md\\:prose-xl figure {
    margin-top: 2em;
    margin-bottom: 2em;
  }
  .md\\:prose-xl figure>* {
    margin-top: 0;
    margin-bottom: 0;
  }
  .md\\:prose-xl figure figcaption {
    font-size: 0.9em;
    line-height: 1.5555556;
    margin-top: 1em;
  }
  .md\\:prose-xl code {
    font-size: 0.9em;
  }
  .md\\:prose-xl h2 code {
    font-size: 0.8611111em;
  }
  .md\\:prose-xl h3 code {
    font-size: 0.9em;
  }
  .md\\:prose-xl pre {
    font-size: 0.9em;
    line-height: 1.7777778;
    margin-top: 2em;
    margin-bottom: 2em;
    border-radius: 0.5rem;
    padding-top: 1.1111111em;
    padding-right: 1.3333333em;
    padding-bottom: 1.1111111em;
    padding-left: 1.3333333em;
  }
  .md\\:prose-xl ol {
    margin-top: 1.2em;
    margin-bottom: 1.2em;
  }
  .md\\:prose-xl ul {
    margin-top: 1.2em;
    margin-bottom: 1.2em;
  }
  .md\\:prose-xl li {
    margin-top: 0.6em;
    margin-bottom: 0.6em;
  }
  .md\\:prose-xl ol>li {
    padding-left: 1.8em;
  }
  .md\\:prose-xl ol>li:before {
    left: 0;
  }
  .md\\:prose-xl ul>li {
    padding-left: 1.8em;
  }
  .md\\:prose-xl ul>li::before {
    width: 0.35em;
    height: 0.35em;
    top: calc(0.9em - 0.175em);
    left: 0.25em;
  }
  .md\\:prose-xl>ul>li p {
    margin-top: 0.8em;
    margin-bottom: 0.8em;
  }
  .md\\:prose-xl>ul>li>*:first-child {
    margin-top: 1.2em;
  }
  .md\\:prose-xl>ul>li>*:last-child {
    margin-bottom: 1.2em;
  }
  .md\\:prose-xl>ol>li>*:first-child {
    margin-top: 1.2em;
  }
  .md\\:prose-xl>ol>li>*:last-child {
    margin-bottom: 1.2em;
  }
  .md\\:prose-xl ul ul, .md\\:prose-xl ul ol, .md\\:prose-xl ol ul, .md\\:prose-xl ol ol {
    margin-top: 0.8em;
    margin-bottom: 0.8em;
  }
  .md\\:prose-xl hr {
    margin-top: 2.8em;
    margin-bottom: 2.8em;
  }
  .md\\:prose-xl hr+* {
    margin-top: 0;
  }
  .md\\:prose-xl h2+* {
    margin-top: 0;
  }
  .md\\:prose-xl h3+* {
    margin-top: 0;
  }
  .md\\:prose-xl h4+* {
    margin-top: 0;
  }
  .md\\:prose-xl table {
    font-size: 0.9em;
    line-height: 1.5555556;
  }
  .md\\:prose-xl thead th {
    padding-right: 0.6666667em;
    padding-bottom: 0.8888889em;
    padding-left: 0.6666667em;
  }
  .md\\:prose-xl thead th:first-child {
    padding-left: 0;
  }
  .md\\:prose-xl thead th:last-child {
    padding-right: 0;
  }
  .md\\:prose-xl tbody td {
    padding-top: 0.8888889em;
    padding-right: 0.6666667em;
    padding-bottom: 0.8888889em;
    padding-left: 0.6666667em;
  }
  .md\\:prose-xl tbody td:first-child {
    padding-left: 0;
  }
  .md\\:prose-xl tbody td:last-child {
    padding-right: 0;
  }
  .md\\:prose-xl> :first-child {
    margin-top: 0;
  }
  .md\\:prose-xl> :last-child {
    margin-bottom: 0;
  }
  .md\\:prose-2xl {
    font-size: 1.5rem;
    line-height: 1.6666667;
  }
  .md\\:prose-2xl p {
    margin-top: 1.3333333em;
    margin-bottom: 1.3333333em;
  }
  .md\\:prose-2xl [class~="lead"] {
    font-size: 1.25em;
    line-height: 1.4666667;
    margin-top: 1.0666667em;
    margin-bottom: 1.0666667em;
  }
  .md\\:prose-2xl blockquote {
    margin-top: 1.7777778em;
    margin-bottom: 1.7777778em;
    padding-left: 1.1111111em;
  }
  .md\\:prose-2xl h1 {
    font-size: 2.6666667em;
    margin-top: 0;
    margin-bottom: 0.875em;
    line-height: 1;
  }
  .md\\:prose-2xl h2 {
    font-size: 2em;
    margin-top: 1.5em;
    margin-bottom: 0.8333333em;
    line-height: 1.0833333;
  }
  .md\\:prose-2xl h3 {
    font-size: 1.5em;
    margin-top: 1.5555556em;
    margin-bottom: 0.6666667em;
    line-height: 1.2222222;
  }
  .md\\:prose-2xl h4 {
    margin-top: 1.6666667em;
    margin-bottom: 0.6666667em;
    line-height: 1.5;
  }
  .md\\:prose-2xl img {
    margin-top: 2em;
    margin-bottom: 2em;
  }
  .md\\:prose-2xl video {
    margin-top: 2em;
    margin-bottom: 2em;
  }
  .md\\:prose-2xl figure {
    margin-top: 2em;
    margin-bottom: 2em;
  }
  .md\\:prose-2xl figure>* {
    margin-top: 0;
    margin-bottom: 0;
  }
  .md\\:prose-2xl figure figcaption {
    font-size: 0.8333333em;
    line-height: 1.6;
    margin-top: 1em;
  }
  .md\\:prose-2xl code {
    font-size: 0.8333333em;
  }
  .md\\:prose-2xl h2 code {
    font-size: 0.875em;
  }
  .md\\:prose-2xl h3 code {
    font-size: 0.8888889em;
  }
  .md\\:prose-2xl pre {
    font-size: 0.8333333em;
    line-height: 1.8;
    margin-top: 2em;
    margin-bottom: 2em;
    border-radius: 0.5rem;
    padding-top: 1.2em;
    padding-right: 1.6em;
    padding-bottom: 1.2em;
    padding-left: 1.6em;
  }
  .md\\:prose-2xl ol {
    margin-top: 1.3333333em;
    margin-bottom: 1.3333333em;
  }
  .md\\:prose-2xl ul {
    margin-top: 1.3333333em;
    margin-bottom: 1.3333333em;
  }
  .md\\:prose-2xl li {
    margin-top: 0.5em;
    margin-bottom: 0.5em;
  }
  .md\\:prose-2xl ol>li {
    padding-left: 1.6666667em;
  }
  .md\\:prose-2xl ol>li:before {
    left: 0;
  }
  .md\\:prose-2xl ul>li {
    padding-left: 1.6666667em;
  }
  .md\\:prose-2xl ul>li::before {
    width: 0.3333333em;
    height: 0.3333333em;
    top: calc(0.8333333em - 0.1666667em);
    left: 0.25em;
  }
  .md\\:prose-2xl>ul>li p {
    margin-top: 0.8333333em;
    margin-bottom: 0.8333333em;
  }
  .md\\:prose-2xl>ul>li>*:first-child {
    margin-top: 1.3333333em;
  }
  .md\\:prose-2xl>ul>li>*:last-child {
    margin-bottom: 1.3333333em;
  }
  .md\\:prose-2xl>ol>li>*:first-child {
    margin-top: 1.3333333em;
  }
  .md\\:prose-2xl>ol>li>*:last-child {
    margin-bottom: 1.3333333em;
  }
  .md\\:prose-2xl ul ul, .md\\:prose-2xl ul ol, .md\\:prose-2xl ol ul, .md\\:prose-2xl ol ol {
    margin-top: 0.6666667em;
    margin-bottom: 0.6666667em;
  }
  .md\\:prose-2xl hr {
    margin-top: 3em;
    margin-bottom: 3em;
  }
  .md\\:prose-2xl hr+* {
    margin-top: 0;
  }
  .md\\:prose-2xl h2+* {
    margin-top: 0;
  }
  .md\\:prose-2xl h3+* {
    margin-top: 0;
  }
  .md\\:prose-2xl h4+* {
    margin-top: 0;
  }
  .md\\:prose-2xl table {
    font-size: 0.8333333em;
    line-height: 1.4;
  }
  .md\\:prose-2xl thead th {
    padding-right: 0.6em;
    padding-bottom: 0.8em;
    padding-left: 0.6em;
  }
  .md\\:prose-2xl thead th:first-child {
    padding-left: 0;
  }
  .md\\:prose-2xl thead th:last-child {
    padding-right: 0;
  }
  .md\\:prose-2xl tbody td {
    padding-top: 0.8em;
    padding-right: 0.6em;
    padding-bottom: 0.8em;
    padding-left: 0.6em;
  }
  .md\\:prose-2xl tbody td:first-child {
    padding-left: 0;
  }
  .md\\:prose-2xl tbody td:last-child {
    padding-right: 0;
  }
  .md\\:prose-2xl> :first-child {
    margin-top: 0;
  }
  .md\\:prose-2xl> :last-child {
    margin-bottom: 0;
  }
  .md\\:space-y-0> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(0px * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(0px * var(--space-y-reverse));
  }
  .md\\:space-x-0> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(0px * var(--space-x-reverse));
    margin-left: calc(0px * calc(1 - var(--space-x-reverse)));
  }
  .md\\:space-y-1> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(0.25rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(0.25rem * var(--space-y-reverse));
  }
  .md\\:space-x-1> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(0.25rem * var(--space-x-reverse));
    margin-left: calc(0.25rem * calc(1 - var(--space-x-reverse)));
  }
  .md\\:space-y-2> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(0.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(0.5rem * var(--space-y-reverse));
  }
  .md\\:space-x-2> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(0.5rem * var(--space-x-reverse));
    margin-left: calc(0.5rem * calc(1 - var(--space-x-reverse)));
  }
  .md\\:space-y-3> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(0.75rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(0.75rem * var(--space-y-reverse));
  }
  .md\\:space-x-3> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(0.75rem * var(--space-x-reverse));
    margin-left: calc(0.75rem * calc(1 - var(--space-x-reverse)));
  }
  .md\\:space-y-4> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(1rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(1rem * var(--space-y-reverse));
  }
  .md\\:space-x-4> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(1rem * var(--space-x-reverse));
    margin-left: calc(1rem * calc(1 - var(--space-x-reverse)));
  }
  .md\\:space-y-5> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(1.25rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(1.25rem * var(--space-y-reverse));
  }
  .md\\:space-x-5> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(1.25rem * var(--space-x-reverse));
    margin-left: calc(1.25rem * calc(1 - var(--space-x-reverse)));
  }
  .md\\:space-y-6> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(1.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(1.5rem * var(--space-y-reverse));
  }
  .md\\:space-x-6> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(1.5rem * var(--space-x-reverse));
    margin-left: calc(1.5rem * calc(1 - var(--space-x-reverse)));
  }
  .md\\:space-y-7> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(1.75rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(1.75rem * var(--space-y-reverse));
  }
  .md\\:space-x-7> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(1.75rem * var(--space-x-reverse));
    margin-left: calc(1.75rem * calc(1 - var(--space-x-reverse)));
  }
  .md\\:space-y-8> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(2rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(2rem * var(--space-y-reverse));
  }
  .md\\:space-x-8> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(2rem * var(--space-x-reverse));
    margin-left: calc(2rem * calc(1 - var(--space-x-reverse)));
  }
  .md\\:space-y-9> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(2.25rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(2.25rem * var(--space-y-reverse));
  }
  .md\\:space-x-9> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(2.25rem * var(--space-x-reverse));
    margin-left: calc(2.25rem * calc(1 - var(--space-x-reverse)));
  }
  .md\\:space-y-10> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(2.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(2.5rem * var(--space-y-reverse));
  }
  .md\\:space-x-10> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(2.5rem * var(--space-x-reverse));
    margin-left: calc(2.5rem * calc(1 - var(--space-x-reverse)));
  }
  .md\\:space-y-11> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(2.75rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(2.75rem * var(--space-y-reverse));
  }
  .md\\:space-x-11> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(2.75rem * var(--space-x-reverse));
    margin-left: calc(2.75rem * calc(1 - var(--space-x-reverse)));
  }
  .md\\:space-y-12> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(3rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(3rem * var(--space-y-reverse));
  }
  .md\\:space-x-12> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(3rem * var(--space-x-reverse));
    margin-left: calc(3rem * calc(1 - var(--space-x-reverse)));
  }
  .md\\:space-y-13> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(3.25rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(3.25rem * var(--space-y-reverse));
  }
  .md\\:space-x-13> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(3.25rem * var(--space-x-reverse));
    margin-left: calc(3.25rem * calc(1 - var(--space-x-reverse)));
  }
  .md\\:space-y-14> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(3.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(3.5rem * var(--space-y-reverse));
  }
  .md\\:space-x-14> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(3.5rem * var(--space-x-reverse));
    margin-left: calc(3.5rem * calc(1 - var(--space-x-reverse)));
  }
  .md\\:space-y-15> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(3.75rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(3.75rem * var(--space-y-reverse));
  }
  .md\\:space-x-15> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(3.75rem * var(--space-x-reverse));
    margin-left: calc(3.75rem * calc(1 - var(--space-x-reverse)));
  }
  .md\\:space-y-16> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(4rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(4rem * var(--space-y-reverse));
  }
  .md\\:space-x-16> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(4rem * var(--space-x-reverse));
    margin-left: calc(4rem * calc(1 - var(--space-x-reverse)));
  }
  .md\\:space-y-20> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(5rem * var(--space-y-reverse));
  }
  .md\\:space-x-20> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(5rem * var(--space-x-reverse));
    margin-left: calc(5rem * calc(1 - var(--space-x-reverse)));
  }
  .md\\:space-y-24> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(6rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(6rem * var(--space-y-reverse));
  }
  .md\\:space-x-24> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(6rem * var(--space-x-reverse));
    margin-left: calc(6rem * calc(1 - var(--space-x-reverse)));
  }
  .md\\:space-y-28> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(7rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(7rem * var(--space-y-reverse));
  }
  .md\\:space-x-28> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(7rem * var(--space-x-reverse));
    margin-left: calc(7rem * calc(1 - var(--space-x-reverse)));
  }
  .md\\:space-y-32> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(8rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(8rem * var(--space-y-reverse));
  }
  .md\\:space-x-32> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(8rem * var(--space-x-reverse));
    margin-left: calc(8rem * calc(1 - var(--space-x-reverse)));
  }
  .md\\:space-y-36> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(9rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(9rem * var(--space-y-reverse));
  }
  .md\\:space-x-36> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(9rem * var(--space-x-reverse));
    margin-left: calc(9rem * calc(1 - var(--space-x-reverse)));
  }
  .md\\:space-y-40> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(10rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(10rem * var(--space-y-reverse));
  }
  .md\\:space-x-40> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(10rem * var(--space-x-reverse));
    margin-left: calc(10rem * calc(1 - var(--space-x-reverse)));
  }
  .md\\:space-y-44> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(11rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(11rem * var(--space-y-reverse));
  }
  .md\\:space-x-44> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(11rem * var(--space-x-reverse));
    margin-left: calc(11rem * calc(1 - var(--space-x-reverse)));
  }
  .md\\:space-y-48> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(12rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(12rem * var(--space-y-reverse));
  }
  .md\\:space-x-48> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(12rem * var(--space-x-reverse));
    margin-left: calc(12rem * calc(1 - var(--space-x-reverse)));
  }
  .md\\:space-y-52> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(13rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(13rem * var(--space-y-reverse));
  }
  .md\\:space-x-52> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(13rem * var(--space-x-reverse));
    margin-left: calc(13rem * calc(1 - var(--space-x-reverse)));
  }
  .md\\:space-y-56> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(14rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(14rem * var(--space-y-reverse));
  }
  .md\\:space-x-56> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(14rem * var(--space-x-reverse));
    margin-left: calc(14rem * calc(1 - var(--space-x-reverse)));
  }
  .md\\:space-y-60> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(15rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(15rem * var(--space-y-reverse));
  }
  .md\\:space-x-60> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(15rem * var(--space-x-reverse));
    margin-left: calc(15rem * calc(1 - var(--space-x-reverse)));
  }
  .md\\:space-y-64> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(16rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(16rem * var(--space-y-reverse));
  }
  .md\\:space-x-64> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(16rem * var(--space-x-reverse));
    margin-left: calc(16rem * calc(1 - var(--space-x-reverse)));
  }
  .md\\:space-y-72> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(18rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(18rem * var(--space-y-reverse));
  }
  .md\\:space-x-72> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(18rem * var(--space-x-reverse));
    margin-left: calc(18rem * calc(1 - var(--space-x-reverse)));
  }
  .md\\:space-y-80> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(20rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(20rem * var(--space-y-reverse));
  }
  .md\\:space-x-80> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(20rem * var(--space-x-reverse));
    margin-left: calc(20rem * calc(1 - var(--space-x-reverse)));
  }
  .md\\:space-y-96> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(24rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(24rem * var(--space-y-reverse));
  }
  .md\\:space-x-96> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(24rem * var(--space-x-reverse));
    margin-left: calc(24rem * calc(1 - var(--space-x-reverse)));
  }
  .md\\:space-y-px> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(1px * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(1px * var(--space-y-reverse));
  }
  .md\\:space-x-px> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(1px * var(--space-x-reverse));
    margin-left: calc(1px * calc(1 - var(--space-x-reverse)));
  }
  .md\\:space-y-0\\.5> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(0.125rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(0.125rem * var(--space-y-reverse));
  }
  .md\\:space-x-0\\.5> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(0.125rem * var(--space-x-reverse));
    margin-left: calc(0.125rem * calc(1 - var(--space-x-reverse)));
  }
  .md\\:space-y-1\\.5> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(0.375rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(0.375rem * var(--space-y-reverse));
  }
  .md\\:space-x-1\\.5> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(0.375rem * var(--space-x-reverse));
    margin-left: calc(0.375rem * calc(1 - var(--space-x-reverse)));
  }
  .md\\:space-y-2\\.5> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(0.625rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(0.625rem * var(--space-y-reverse));
  }
  .md\\:space-x-2\\.5> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(0.625rem * var(--space-x-reverse));
    margin-left: calc(0.625rem * calc(1 - var(--space-x-reverse)));
  }
  .md\\:space-y-3\\.5> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(0.875rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(0.875rem * var(--space-y-reverse));
  }
  .md\\:space-x-3\\.5> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(0.875rem * var(--space-x-reverse));
    margin-left: calc(0.875rem * calc(1 - var(--space-x-reverse)));
  }
  .md\\:space-y-1\\/2> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(50% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(50% * var(--space-y-reverse));
  }
  .md\\:space-x-1\\/2> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(50% * var(--space-x-reverse));
    margin-left: calc(50% * calc(1 - var(--space-x-reverse)));
  }
  .md\\:space-y-1\\/3> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(33.333333% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(33.333333% * var(--space-y-reverse));
  }
  .md\\:space-x-1\\/3> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(33.333333% * var(--space-x-reverse));
    margin-left: calc(33.333333% * calc(1 - var(--space-x-reverse)));
  }
  .md\\:space-y-2\\/3> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(66.666667% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(66.666667% * var(--space-y-reverse));
  }
  .md\\:space-x-2\\/3> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(66.666667% * var(--space-x-reverse));
    margin-left: calc(66.666667% * calc(1 - var(--space-x-reverse)));
  }
  .md\\:space-y-1\\/4> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(25% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(25% * var(--space-y-reverse));
  }
  .md\\:space-x-1\\/4> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(25% * var(--space-x-reverse));
    margin-left: calc(25% * calc(1 - var(--space-x-reverse)));
  }
  .md\\:space-y-2\\/4> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(50% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(50% * var(--space-y-reverse));
  }
  .md\\:space-x-2\\/4> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(50% * var(--space-x-reverse));
    margin-left: calc(50% * calc(1 - var(--space-x-reverse)));
  }
  .md\\:space-y-3\\/4> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(75% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(75% * var(--space-y-reverse));
  }
  .md\\:space-x-3\\/4> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(75% * var(--space-x-reverse));
    margin-left: calc(75% * calc(1 - var(--space-x-reverse)));
  }
  .md\\:space-y-1\\/5> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(20% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(20% * var(--space-y-reverse));
  }
  .md\\:space-x-1\\/5> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(20% * var(--space-x-reverse));
    margin-left: calc(20% * calc(1 - var(--space-x-reverse)));
  }
  .md\\:space-y-2\\/5> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(40% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(40% * var(--space-y-reverse));
  }
  .md\\:space-x-2\\/5> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(40% * var(--space-x-reverse));
    margin-left: calc(40% * calc(1 - var(--space-x-reverse)));
  }
  .md\\:space-y-3\\/5> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(60% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(60% * var(--space-y-reverse));
  }
  .md\\:space-x-3\\/5> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(60% * var(--space-x-reverse));
    margin-left: calc(60% * calc(1 - var(--space-x-reverse)));
  }
  .md\\:space-y-4\\/5> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(80% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(80% * var(--space-y-reverse));
  }
  .md\\:space-x-4\\/5> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(80% * var(--space-x-reverse));
    margin-left: calc(80% * calc(1 - var(--space-x-reverse)));
  }
  .md\\:space-y-1\\/6> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(16.666667% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(16.666667% * var(--space-y-reverse));
  }
  .md\\:space-x-1\\/6> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(16.666667% * var(--space-x-reverse));
    margin-left: calc(16.666667% * calc(1 - var(--space-x-reverse)));
  }
  .md\\:space-y-2\\/6> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(33.333333% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(33.333333% * var(--space-y-reverse));
  }
  .md\\:space-x-2\\/6> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(33.333333% * var(--space-x-reverse));
    margin-left: calc(33.333333% * calc(1 - var(--space-x-reverse)));
  }
  .md\\:space-y-3\\/6> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(50% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(50% * var(--space-y-reverse));
  }
  .md\\:space-x-3\\/6> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(50% * var(--space-x-reverse));
    margin-left: calc(50% * calc(1 - var(--space-x-reverse)));
  }
  .md\\:space-y-4\\/6> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(66.666667% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(66.666667% * var(--space-y-reverse));
  }
  .md\\:space-x-4\\/6> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(66.666667% * var(--space-x-reverse));
    margin-left: calc(66.666667% * calc(1 - var(--space-x-reverse)));
  }
  .md\\:space-y-5\\/6> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(83.333333% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(83.333333% * var(--space-y-reverse));
  }
  .md\\:space-x-5\\/6> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(83.333333% * var(--space-x-reverse));
    margin-left: calc(83.333333% * calc(1 - var(--space-x-reverse)));
  }
  .md\\:space-y-1\\/12> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(8.333333% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(8.333333% * var(--space-y-reverse));
  }
  .md\\:space-x-1\\/12> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(8.333333% * var(--space-x-reverse));
    margin-left: calc(8.333333% * calc(1 - var(--space-x-reverse)));
  }
  .md\\:space-y-2\\/12> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(16.666667% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(16.666667% * var(--space-y-reverse));
  }
  .md\\:space-x-2\\/12> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(16.666667% * var(--space-x-reverse));
    margin-left: calc(16.666667% * calc(1 - var(--space-x-reverse)));
  }
  .md\\:space-y-3\\/12> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(25% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(25% * var(--space-y-reverse));
  }
  .md\\:space-x-3\\/12> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(25% * var(--space-x-reverse));
    margin-left: calc(25% * calc(1 - var(--space-x-reverse)));
  }
  .md\\:space-y-4\\/12> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(33.333333% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(33.333333% * var(--space-y-reverse));
  }
  .md\\:space-x-4\\/12> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(33.333333% * var(--space-x-reverse));
    margin-left: calc(33.333333% * calc(1 - var(--space-x-reverse)));
  }
  .md\\:space-y-5\\/12> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(41.666667% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(41.666667% * var(--space-y-reverse));
  }
  .md\\:space-x-5\\/12> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(41.666667% * var(--space-x-reverse));
    margin-left: calc(41.666667% * calc(1 - var(--space-x-reverse)));
  }
  .md\\:space-y-6\\/12> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(50% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(50% * var(--space-y-reverse));
  }
  .md\\:space-x-6\\/12> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(50% * var(--space-x-reverse));
    margin-left: calc(50% * calc(1 - var(--space-x-reverse)));
  }
  .md\\:space-y-7\\/12> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(58.333333% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(58.333333% * var(--space-y-reverse));
  }
  .md\\:space-x-7\\/12> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(58.333333% * var(--space-x-reverse));
    margin-left: calc(58.333333% * calc(1 - var(--space-x-reverse)));
  }
  .md\\:space-y-8\\/12> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(66.666667% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(66.666667% * var(--space-y-reverse));
  }
  .md\\:space-x-8\\/12> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(66.666667% * var(--space-x-reverse));
    margin-left: calc(66.666667% * calc(1 - var(--space-x-reverse)));
  }
  .md\\:space-y-9\\/12> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(75% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(75% * var(--space-y-reverse));
  }
  .md\\:space-x-9\\/12> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(75% * var(--space-x-reverse));
    margin-left: calc(75% * calc(1 - var(--space-x-reverse)));
  }
  .md\\:space-y-10\\/12> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(83.333333% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(83.333333% * var(--space-y-reverse));
  }
  .md\\:space-x-10\\/12> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(83.333333% * var(--space-x-reverse));
    margin-left: calc(83.333333% * calc(1 - var(--space-x-reverse)));
  }
  .md\\:space-y-11\\/12> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(91.666667% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(91.666667% * var(--space-y-reverse));
  }
  .md\\:space-x-11\\/12> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(91.666667% * var(--space-x-reverse));
    margin-left: calc(91.666667% * calc(1 - var(--space-x-reverse)));
  }
  .md\\:space-y-full> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(100% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(100% * var(--space-y-reverse));
  }
  .md\\:space-x-full> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(100% * var(--space-x-reverse));
    margin-left: calc(100% * calc(1 - var(--space-x-reverse)));
  }
  .md\\:-space-y-1> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-0.25rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-0.25rem * var(--space-y-reverse));
  }
  .md\\:-space-x-1> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-0.25rem * var(--space-x-reverse));
    margin-left: calc(-0.25rem * calc(1 - var(--space-x-reverse)));
  }
  .md\\:-space-y-2> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-0.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-0.5rem * var(--space-y-reverse));
  }
  .md\\:-space-x-2> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-0.5rem * var(--space-x-reverse));
    margin-left: calc(-0.5rem * calc(1 - var(--space-x-reverse)));
  }
  .md\\:-space-y-3> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-0.75rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-0.75rem * var(--space-y-reverse));
  }
  .md\\:-space-x-3> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-0.75rem * var(--space-x-reverse));
    margin-left: calc(-0.75rem * calc(1 - var(--space-x-reverse)));
  }
  .md\\:-space-y-4> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-1rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-1rem * var(--space-y-reverse));
  }
  .md\\:-space-x-4> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-1rem * var(--space-x-reverse));
    margin-left: calc(-1rem * calc(1 - var(--space-x-reverse)));
  }
  .md\\:-space-y-5> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-1.25rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-1.25rem * var(--space-y-reverse));
  }
  .md\\:-space-x-5> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-1.25rem * var(--space-x-reverse));
    margin-left: calc(-1.25rem * calc(1 - var(--space-x-reverse)));
  }
  .md\\:-space-y-6> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-1.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-1.5rem * var(--space-y-reverse));
  }
  .md\\:-space-x-6> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-1.5rem * var(--space-x-reverse));
    margin-left: calc(-1.5rem * calc(1 - var(--space-x-reverse)));
  }
  .md\\:-space-y-7> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-1.75rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-1.75rem * var(--space-y-reverse));
  }
  .md\\:-space-x-7> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-1.75rem * var(--space-x-reverse));
    margin-left: calc(-1.75rem * calc(1 - var(--space-x-reverse)));
  }
  .md\\:-space-y-8> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-2rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-2rem * var(--space-y-reverse));
  }
  .md\\:-space-x-8> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-2rem * var(--space-x-reverse));
    margin-left: calc(-2rem * calc(1 - var(--space-x-reverse)));
  }
  .md\\:-space-y-9> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-2.25rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-2.25rem * var(--space-y-reverse));
  }
  .md\\:-space-x-9> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-2.25rem * var(--space-x-reverse));
    margin-left: calc(-2.25rem * calc(1 - var(--space-x-reverse)));
  }
  .md\\:-space-y-10> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-2.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-2.5rem * var(--space-y-reverse));
  }
  .md\\:-space-x-10> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-2.5rem * var(--space-x-reverse));
    margin-left: calc(-2.5rem * calc(1 - var(--space-x-reverse)));
  }
  .md\\:-space-y-11> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-2.75rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-2.75rem * var(--space-y-reverse));
  }
  .md\\:-space-x-11> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-2.75rem * var(--space-x-reverse));
    margin-left: calc(-2.75rem * calc(1 - var(--space-x-reverse)));
  }
  .md\\:-space-y-12> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-3rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-3rem * var(--space-y-reverse));
  }
  .md\\:-space-x-12> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-3rem * var(--space-x-reverse));
    margin-left: calc(-3rem * calc(1 - var(--space-x-reverse)));
  }
  .md\\:-space-y-13> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-3.25rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-3.25rem * var(--space-y-reverse));
  }
  .md\\:-space-x-13> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-3.25rem * var(--space-x-reverse));
    margin-left: calc(-3.25rem * calc(1 - var(--space-x-reverse)));
  }
  .md\\:-space-y-14> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-3.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-3.5rem * var(--space-y-reverse));
  }
  .md\\:-space-x-14> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-3.5rem * var(--space-x-reverse));
    margin-left: calc(-3.5rem * calc(1 - var(--space-x-reverse)));
  }
  .md\\:-space-y-15> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-3.75rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-3.75rem * var(--space-y-reverse));
  }
  .md\\:-space-x-15> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-3.75rem * var(--space-x-reverse));
    margin-left: calc(-3.75rem * calc(1 - var(--space-x-reverse)));
  }
  .md\\:-space-y-16> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-4rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-4rem * var(--space-y-reverse));
  }
  .md\\:-space-x-16> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-4rem * var(--space-x-reverse));
    margin-left: calc(-4rem * calc(1 - var(--space-x-reverse)));
  }
  .md\\:-space-y-20> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-5rem * var(--space-y-reverse));
  }
  .md\\:-space-x-20> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-5rem * var(--space-x-reverse));
    margin-left: calc(-5rem * calc(1 - var(--space-x-reverse)));
  }
  .md\\:-space-y-24> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-6rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-6rem * var(--space-y-reverse));
  }
  .md\\:-space-x-24> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-6rem * var(--space-x-reverse));
    margin-left: calc(-6rem * calc(1 - var(--space-x-reverse)));
  }
  .md\\:-space-y-28> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-7rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-7rem * var(--space-y-reverse));
  }
  .md\\:-space-x-28> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-7rem * var(--space-x-reverse));
    margin-left: calc(-7rem * calc(1 - var(--space-x-reverse)));
  }
  .md\\:-space-y-32> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-8rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-8rem * var(--space-y-reverse));
  }
  .md\\:-space-x-32> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-8rem * var(--space-x-reverse));
    margin-left: calc(-8rem * calc(1 - var(--space-x-reverse)));
  }
  .md\\:-space-y-36> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-9rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-9rem * var(--space-y-reverse));
  }
  .md\\:-space-x-36> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-9rem * var(--space-x-reverse));
    margin-left: calc(-9rem * calc(1 - var(--space-x-reverse)));
  }
  .md\\:-space-y-40> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-10rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-10rem * var(--space-y-reverse));
  }
  .md\\:-space-x-40> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-10rem * var(--space-x-reverse));
    margin-left: calc(-10rem * calc(1 - var(--space-x-reverse)));
  }
  .md\\:-space-y-44> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-11rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-11rem * var(--space-y-reverse));
  }
  .md\\:-space-x-44> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-11rem * var(--space-x-reverse));
    margin-left: calc(-11rem * calc(1 - var(--space-x-reverse)));
  }
  .md\\:-space-y-48> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-12rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-12rem * var(--space-y-reverse));
  }
  .md\\:-space-x-48> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-12rem * var(--space-x-reverse));
    margin-left: calc(-12rem * calc(1 - var(--space-x-reverse)));
  }
  .md\\:-space-y-52> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-13rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-13rem * var(--space-y-reverse));
  }
  .md\\:-space-x-52> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-13rem * var(--space-x-reverse));
    margin-left: calc(-13rem * calc(1 - var(--space-x-reverse)));
  }
  .md\\:-space-y-56> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-14rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-14rem * var(--space-y-reverse));
  }
  .md\\:-space-x-56> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-14rem * var(--space-x-reverse));
    margin-left: calc(-14rem * calc(1 - var(--space-x-reverse)));
  }
  .md\\:-space-y-60> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-15rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-15rem * var(--space-y-reverse));
  }
  .md\\:-space-x-60> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-15rem * var(--space-x-reverse));
    margin-left: calc(-15rem * calc(1 - var(--space-x-reverse)));
  }
  .md\\:-space-y-64> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-16rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-16rem * var(--space-y-reverse));
  }
  .md\\:-space-x-64> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-16rem * var(--space-x-reverse));
    margin-left: calc(-16rem * calc(1 - var(--space-x-reverse)));
  }
  .md\\:-space-y-72> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-18rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-18rem * var(--space-y-reverse));
  }
  .md\\:-space-x-72> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-18rem * var(--space-x-reverse));
    margin-left: calc(-18rem * calc(1 - var(--space-x-reverse)));
  }
  .md\\:-space-y-80> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-20rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-20rem * var(--space-y-reverse));
  }
  .md\\:-space-x-80> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-20rem * var(--space-x-reverse));
    margin-left: calc(-20rem * calc(1 - var(--space-x-reverse)));
  }
  .md\\:-space-y-96> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-24rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-24rem * var(--space-y-reverse));
  }
  .md\\:-space-x-96> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-24rem * var(--space-x-reverse));
    margin-left: calc(-24rem * calc(1 - var(--space-x-reverse)));
  }
  .md\\:-space-y-px> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-1px * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-1px * var(--space-y-reverse));
  }
  .md\\:-space-x-px> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-1px * var(--space-x-reverse));
    margin-left: calc(-1px * calc(1 - var(--space-x-reverse)));
  }
  .md\\:-space-y-0\\.5> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-0.125rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-0.125rem * var(--space-y-reverse));
  }
  .md\\:-space-x-0\\.5> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-0.125rem * var(--space-x-reverse));
    margin-left: calc(-0.125rem * calc(1 - var(--space-x-reverse)));
  }
  .md\\:-space-y-1\\.5> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-0.375rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-0.375rem * var(--space-y-reverse));
  }
  .md\\:-space-x-1\\.5> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-0.375rem * var(--space-x-reverse));
    margin-left: calc(-0.375rem * calc(1 - var(--space-x-reverse)));
  }
  .md\\:-space-y-2\\.5> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-0.625rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-0.625rem * var(--space-y-reverse));
  }
  .md\\:-space-x-2\\.5> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-0.625rem * var(--space-x-reverse));
    margin-left: calc(-0.625rem * calc(1 - var(--space-x-reverse)));
  }
  .md\\:-space-y-3\\.5> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-0.875rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-0.875rem * var(--space-y-reverse));
  }
  .md\\:-space-x-3\\.5> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-0.875rem * var(--space-x-reverse));
    margin-left: calc(-0.875rem * calc(1 - var(--space-x-reverse)));
  }
  .md\\:-space-y-1\\/2> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-50% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-50% * var(--space-y-reverse));
  }
  .md\\:-space-x-1\\/2> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-50% * var(--space-x-reverse));
    margin-left: calc(-50% * calc(1 - var(--space-x-reverse)));
  }
  .md\\:-space-y-1\\/3> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-33.33333% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-33.33333% * var(--space-y-reverse));
  }
  .md\\:-space-x-1\\/3> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-33.33333% * var(--space-x-reverse));
    margin-left: calc(-33.33333% * calc(1 - var(--space-x-reverse)));
  }
  .md\\:-space-y-2\\/3> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-66.66667% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-66.66667% * var(--space-y-reverse));
  }
  .md\\:-space-x-2\\/3> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-66.66667% * var(--space-x-reverse));
    margin-left: calc(-66.66667% * calc(1 - var(--space-x-reverse)));
  }
  .md\\:-space-y-1\\/4> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-25% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-25% * var(--space-y-reverse));
  }
  .md\\:-space-x-1\\/4> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-25% * var(--space-x-reverse));
    margin-left: calc(-25% * calc(1 - var(--space-x-reverse)));
  }
  .md\\:-space-y-2\\/4> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-50% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-50% * var(--space-y-reverse));
  }
  .md\\:-space-x-2\\/4> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-50% * var(--space-x-reverse));
    margin-left: calc(-50% * calc(1 - var(--space-x-reverse)));
  }
  .md\\:-space-y-3\\/4> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-75% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-75% * var(--space-y-reverse));
  }
  .md\\:-space-x-3\\/4> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-75% * var(--space-x-reverse));
    margin-left: calc(-75% * calc(1 - var(--space-x-reverse)));
  }
  .md\\:-space-y-1\\/5> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-20% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-20% * var(--space-y-reverse));
  }
  .md\\:-space-x-1\\/5> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-20% * var(--space-x-reverse));
    margin-left: calc(-20% * calc(1 - var(--space-x-reverse)));
  }
  .md\\:-space-y-2\\/5> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-40% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-40% * var(--space-y-reverse));
  }
  .md\\:-space-x-2\\/5> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-40% * var(--space-x-reverse));
    margin-left: calc(-40% * calc(1 - var(--space-x-reverse)));
  }
  .md\\:-space-y-3\\/5> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-60% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-60% * var(--space-y-reverse));
  }
  .md\\:-space-x-3\\/5> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-60% * var(--space-x-reverse));
    margin-left: calc(-60% * calc(1 - var(--space-x-reverse)));
  }
  .md\\:-space-y-4\\/5> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-80% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-80% * var(--space-y-reverse));
  }
  .md\\:-space-x-4\\/5> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-80% * var(--space-x-reverse));
    margin-left: calc(-80% * calc(1 - var(--space-x-reverse)));
  }
  .md\\:-space-y-1\\/6> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-16.66667% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-16.66667% * var(--space-y-reverse));
  }
  .md\\:-space-x-1\\/6> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-16.66667% * var(--space-x-reverse));
    margin-left: calc(-16.66667% * calc(1 - var(--space-x-reverse)));
  }
  .md\\:-space-y-2\\/6> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-33.33333% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-33.33333% * var(--space-y-reverse));
  }
  .md\\:-space-x-2\\/6> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-33.33333% * var(--space-x-reverse));
    margin-left: calc(-33.33333% * calc(1 - var(--space-x-reverse)));
  }
  .md\\:-space-y-3\\/6> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-50% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-50% * var(--space-y-reverse));
  }
  .md\\:-space-x-3\\/6> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-50% * var(--space-x-reverse));
    margin-left: calc(-50% * calc(1 - var(--space-x-reverse)));
  }
  .md\\:-space-y-4\\/6> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-66.66667% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-66.66667% * var(--space-y-reverse));
  }
  .md\\:-space-x-4\\/6> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-66.66667% * var(--space-x-reverse));
    margin-left: calc(-66.66667% * calc(1 - var(--space-x-reverse)));
  }
  .md\\:-space-y-5\\/6> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-83.33333% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-83.33333% * var(--space-y-reverse));
  }
  .md\\:-space-x-5\\/6> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-83.33333% * var(--space-x-reverse));
    margin-left: calc(-83.33333% * calc(1 - var(--space-x-reverse)));
  }
  .md\\:-space-y-1\\/12> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-8.33333% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-8.33333% * var(--space-y-reverse));
  }
  .md\\:-space-x-1\\/12> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-8.33333% * var(--space-x-reverse));
    margin-left: calc(-8.33333% * calc(1 - var(--space-x-reverse)));
  }
  .md\\:-space-y-2\\/12> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-16.66667% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-16.66667% * var(--space-y-reverse));
  }
  .md\\:-space-x-2\\/12> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-16.66667% * var(--space-x-reverse));
    margin-left: calc(-16.66667% * calc(1 - var(--space-x-reverse)));
  }
  .md\\:-space-y-3\\/12> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-25% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-25% * var(--space-y-reverse));
  }
  .md\\:-space-x-3\\/12> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-25% * var(--space-x-reverse));
    margin-left: calc(-25% * calc(1 - var(--space-x-reverse)));
  }
  .md\\:-space-y-4\\/12> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-33.33333% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-33.33333% * var(--space-y-reverse));
  }
  .md\\:-space-x-4\\/12> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-33.33333% * var(--space-x-reverse));
    margin-left: calc(-33.33333% * calc(1 - var(--space-x-reverse)));
  }
  .md\\:-space-y-5\\/12> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-41.66667% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-41.66667% * var(--space-y-reverse));
  }
  .md\\:-space-x-5\\/12> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-41.66667% * var(--space-x-reverse));
    margin-left: calc(-41.66667% * calc(1 - var(--space-x-reverse)));
  }
  .md\\:-space-y-6\\/12> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-50% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-50% * var(--space-y-reverse));
  }
  .md\\:-space-x-6\\/12> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-50% * var(--space-x-reverse));
    margin-left: calc(-50% * calc(1 - var(--space-x-reverse)));
  }
  .md\\:-space-y-7\\/12> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-58.33333% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-58.33333% * var(--space-y-reverse));
  }
  .md\\:-space-x-7\\/12> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-58.33333% * var(--space-x-reverse));
    margin-left: calc(-58.33333% * calc(1 - var(--space-x-reverse)));
  }
  .md\\:-space-y-8\\/12> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-66.66667% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-66.66667% * var(--space-y-reverse));
  }
  .md\\:-space-x-8\\/12> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-66.66667% * var(--space-x-reverse));
    margin-left: calc(-66.66667% * calc(1 - var(--space-x-reverse)));
  }
  .md\\:-space-y-9\\/12> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-75% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-75% * var(--space-y-reverse));
  }
  .md\\:-space-x-9\\/12> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-75% * var(--space-x-reverse));
    margin-left: calc(-75% * calc(1 - var(--space-x-reverse)));
  }
  .md\\:-space-y-10\\/12> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-83.33333% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-83.33333% * var(--space-y-reverse));
  }
  .md\\:-space-x-10\\/12> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-83.33333% * var(--space-x-reverse));
    margin-left: calc(-83.33333% * calc(1 - var(--space-x-reverse)));
  }
  .md\\:-space-y-11\\/12> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-91.66667% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-91.66667% * var(--space-y-reverse));
  }
  .md\\:-space-x-11\\/12> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-91.66667% * var(--space-x-reverse));
    margin-left: calc(-91.66667% * calc(1 - var(--space-x-reverse)));
  }
  .md\\:-space-y-full> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-100% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-100% * var(--space-y-reverse));
  }
  .md\\:-space-x-full> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-100% * var(--space-x-reverse));
    margin-left: calc(-100% * calc(1 - var(--space-x-reverse)));
  }
  .md\\:space-y-reverse> :not(template)~ :not(template) {
    --space-y-reverse: 1;
  }
  .md\\:space-x-reverse> :not(template)~ :not(template) {
    --space-x-reverse: 1;
  }
  .md\\:divide-y-0> :not(template)~ :not(template) {
    --divide-y-reverse: 0;
    border-top-width: calc(0px * calc(1 - var(--divide-y-reverse)));
    border-bottom-width: calc(0px * var(--divide-y-reverse));
  }
  .md\\:divide-x-0> :not(template)~ :not(template) {
    --divide-x-reverse: 0;
    border-right-width: calc(0px * var(--divide-x-reverse));
    border-left-width: calc(0px * calc(1 - var(--divide-x-reverse)));
  }
  .md\\:divide-y-2> :not(template)~ :not(template) {
    --divide-y-reverse: 0;
    border-top-width: calc(2px * calc(1 - var(--divide-y-reverse)));
    border-bottom-width: calc(2px * var(--divide-y-reverse));
  }
  .md\\:divide-x-2> :not(template)~ :not(template) {
    --divide-x-reverse: 0;
    border-right-width: calc(2px * var(--divide-x-reverse));
    border-left-width: calc(2px * calc(1 - var(--divide-x-reverse)));
  }
  .md\\:divide-y-4> :not(template)~ :not(template) {
    --divide-y-reverse: 0;
    border-top-width: calc(4px * calc(1 - var(--divide-y-reverse)));
    border-bottom-width: calc(4px * var(--divide-y-reverse));
  }
  .md\\:divide-x-4> :not(template)~ :not(template) {
    --divide-x-reverse: 0;
    border-right-width: calc(4px * var(--divide-x-reverse));
    border-left-width: calc(4px * calc(1 - var(--divide-x-reverse)));
  }
  .md\\:divide-y-8> :not(template)~ :not(template) {
    --divide-y-reverse: 0;
    border-top-width: calc(8px * calc(1 - var(--divide-y-reverse)));
    border-bottom-width: calc(8px * var(--divide-y-reverse));
  }
  .md\\:divide-x-8> :not(template)~ :not(template) {
    --divide-x-reverse: 0;
    border-right-width: calc(8px * var(--divide-x-reverse));
    border-left-width: calc(8px * calc(1 - var(--divide-x-reverse)));
  }
  .md\\:divide-y> :not(template)~ :not(template) {
    --divide-y-reverse: 0;
    border-top-width: calc(1px * calc(1 - var(--divide-y-reverse)));
    border-bottom-width: calc(1px * var(--divide-y-reverse));
  }
  .md\\:divide-x> :not(template)~ :not(template) {
    --divide-x-reverse: 0;
    border-right-width: calc(1px * var(--divide-x-reverse));
    border-left-width: calc(1px * calc(1 - var(--divide-x-reverse)));
  }
  .md\\:divide-y-reverse> :not(template)~ :not(template) {
    --divide-y-reverse: 1;
  }
  .md\\:divide-x-reverse> :not(template)~ :not(template) {
    --divide-x-reverse: 1;
  }
  .md\\:divide-current> :not(template)~ :not(template) {
    border-color: currentColor;
  }
  .md\\:divide-transparent> :not(template)~ :not(template) {
    border-color: transparent;
  }
  .md\\:divide-white> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #ffffff;
    border-color: rgba(255, 255, 255, var(--divide-opacity));
  }
  .md\\:divide-black> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #000000;
    border-color: rgba(0, 0, 0, var(--divide-opacity));
  }
  .md\\:divide-gray-50> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #f9fafb;
    border-color: rgba(249, 250, 251, var(--divide-opacity));
  }
  .md\\:divide-gray-100> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #f4f5f7;
    border-color: rgba(244, 245, 247, var(--divide-opacity));
  }
  .md\\:divide-gray-200> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #e5e7eb;
    border-color: rgba(229, 231, 235, var(--divide-opacity));
  }
  .md\\:divide-gray-300> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #d2d6dc;
    border-color: rgba(210, 214, 220, var(--divide-opacity));
  }
  .md\\:divide-gray-400> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #9fa6b2;
    border-color: rgba(159, 166, 178, var(--divide-opacity));
  }
  .md\\:divide-gray-500> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #6b7280;
    border-color: rgba(107, 114, 128, var(--divide-opacity));
  }
  .md\\:divide-gray-600> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #4b5563;
    border-color: rgba(75, 85, 99, var(--divide-opacity));
  }
  .md\\:divide-gray-700> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #374151;
    border-color: rgba(55, 65, 81, var(--divide-opacity));
  }
  .md\\:divide-gray-800> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #252f3f;
    border-color: rgba(37, 47, 63, var(--divide-opacity));
  }
  .md\\:divide-gray-900> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #161e2e;
    border-color: rgba(22, 30, 46, var(--divide-opacity));
  }
  .md\\:divide-red-50> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #fdf2f2;
    border-color: rgba(253, 242, 242, var(--divide-opacity));
  }
  .md\\:divide-red-100> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #fde8e8;
    border-color: rgba(253, 232, 232, var(--divide-opacity));
  }
  .md\\:divide-red-200> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #fbd5d5;
    border-color: rgba(251, 213, 213, var(--divide-opacity));
  }
  .md\\:divide-red-300> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #f8b4b4;
    border-color: rgba(248, 180, 180, var(--divide-opacity));
  }
  .md\\:divide-red-400> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #f98080;
    border-color: rgba(249, 128, 128, var(--divide-opacity));
  }
  .md\\:divide-red-500> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #f05252;
    border-color: rgba(240, 82, 82, var(--divide-opacity));
  }
  .md\\:divide-red-600> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #e02424;
    border-color: rgba(224, 36, 36, var(--divide-opacity));
  }
  .md\\:divide-red-700> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #c81e1e;
    border-color: rgba(200, 30, 30, var(--divide-opacity));
  }
  .md\\:divide-red-800> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #9b1c1c;
    border-color: rgba(155, 28, 28, var(--divide-opacity));
  }
  .md\\:divide-red-900> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #771d1d;
    border-color: rgba(119, 29, 29, var(--divide-opacity));
  }
  .md\\:divide-orange-50> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #fff8f1;
    border-color: rgba(255, 248, 241, var(--divide-opacity));
  }
  .md\\:divide-orange-100> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #feecdc;
    border-color: rgba(254, 236, 220, var(--divide-opacity));
  }
  .md\\:divide-orange-200> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #fcd9bd;
    border-color: rgba(252, 217, 189, var(--divide-opacity));
  }
  .md\\:divide-orange-300> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #fdba8c;
    border-color: rgba(253, 186, 140, var(--divide-opacity));
  }
  .md\\:divide-orange-400> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #ff8a4c;
    border-color: rgba(255, 138, 76, var(--divide-opacity));
  }
  .md\\:divide-orange-500> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #ff5a1f;
    border-color: rgba(255, 90, 31, var(--divide-opacity));
  }
  .md\\:divide-orange-600> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #d03801;
    border-color: rgba(208, 56, 1, var(--divide-opacity));
  }
  .md\\:divide-orange-700> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #b43403;
    border-color: rgba(180, 52, 3, var(--divide-opacity));
  }
  .md\\:divide-orange-800> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #8a2c0d;
    border-color: rgba(138, 44, 13, var(--divide-opacity));
  }
  .md\\:divide-orange-900> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #73230d;
    border-color: rgba(115, 35, 13, var(--divide-opacity));
  }
  .md\\:divide-yellow-50> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #fdfdea;
    border-color: rgba(253, 253, 234, var(--divide-opacity));
  }
  .md\\:divide-yellow-100> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #fdf6b2;
    border-color: rgba(253, 246, 178, var(--divide-opacity));
  }
  .md\\:divide-yellow-200> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #fce96a;
    border-color: rgba(252, 233, 106, var(--divide-opacity));
  }
  .md\\:divide-yellow-300> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #faca15;
    border-color: rgba(250, 202, 21, var(--divide-opacity));
  }
  .md\\:divide-yellow-400> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #e3a008;
    border-color: rgba(227, 160, 8, var(--divide-opacity));
  }
  .md\\:divide-yellow-500> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #c27803;
    border-color: rgba(194, 120, 3, var(--divide-opacity));
  }
  .md\\:divide-yellow-600> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #9f580a;
    border-color: rgba(159, 88, 10, var(--divide-opacity));
  }
  .md\\:divide-yellow-700> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #8e4b10;
    border-color: rgba(142, 75, 16, var(--divide-opacity));
  }
  .md\\:divide-yellow-800> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #723b13;
    border-color: rgba(114, 59, 19, var(--divide-opacity));
  }
  .md\\:divide-yellow-900> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #633112;
    border-color: rgba(99, 49, 18, var(--divide-opacity));
  }
  .md\\:divide-green-50> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #f3faf7;
    border-color: rgba(243, 250, 247, var(--divide-opacity));
  }
  .md\\:divide-green-100> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #def7ec;
    border-color: rgba(222, 247, 236, var(--divide-opacity));
  }
  .md\\:divide-green-200> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #bcf0da;
    border-color: rgba(188, 240, 218, var(--divide-opacity));
  }
  .md\\:divide-green-300> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #84e1bc;
    border-color: rgba(132, 225, 188, var(--divide-opacity));
  }
  .md\\:divide-green-400> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #31c48d;
    border-color: rgba(49, 196, 141, var(--divide-opacity));
  }
  .md\\:divide-green-500> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #0e9f6e;
    border-color: rgba(14, 159, 110, var(--divide-opacity));
  }
  .md\\:divide-green-600> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #057a55;
    border-color: rgba(5, 122, 85, var(--divide-opacity));
  }
  .md\\:divide-green-700> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #046c4e;
    border-color: rgba(4, 108, 78, var(--divide-opacity));
  }
  .md\\:divide-green-800> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #03543f;
    border-color: rgba(3, 84, 63, var(--divide-opacity));
  }
  .md\\:divide-green-900> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #014737;
    border-color: rgba(1, 71, 55, var(--divide-opacity));
  }
  .md\\:divide-teal-50> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #edfafa;
    border-color: rgba(237, 250, 250, var(--divide-opacity));
  }
  .md\\:divide-teal-100> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #d5f5f6;
    border-color: rgba(213, 245, 246, var(--divide-opacity));
  }
  .md\\:divide-teal-200> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #afecef;
    border-color: rgba(175, 236, 239, var(--divide-opacity));
  }
  .md\\:divide-teal-300> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #7edce2;
    border-color: rgba(126, 220, 226, var(--divide-opacity));
  }
  .md\\:divide-teal-400> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #16bdca;
    border-color: rgba(22, 189, 202, var(--divide-opacity));
  }
  .md\\:divide-teal-500> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #0694a2;
    border-color: rgba(6, 148, 162, var(--divide-opacity));
  }
  .md\\:divide-teal-600> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #047481;
    border-color: rgba(4, 116, 129, var(--divide-opacity));
  }
  .md\\:divide-teal-700> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #036672;
    border-color: rgba(3, 102, 114, var(--divide-opacity));
  }
  .md\\:divide-teal-800> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #05505c;
    border-color: rgba(5, 80, 92, var(--divide-opacity));
  }
  .md\\:divide-teal-900> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #014451;
    border-color: rgba(1, 68, 81, var(--divide-opacity));
  }
  .md\\:divide-blue-50> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #ebf5ff;
    border-color: rgba(235, 245, 255, var(--divide-opacity));
  }
  .md\\:divide-blue-100> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #e1effe;
    border-color: rgba(225, 239, 254, var(--divide-opacity));
  }
  .md\\:divide-blue-200> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #c3ddfd;
    border-color: rgba(195, 221, 253, var(--divide-opacity));
  }
  .md\\:divide-blue-300> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #a4cafe;
    border-color: rgba(164, 202, 254, var(--divide-opacity));
  }
  .md\\:divide-blue-400> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #76a9fa;
    border-color: rgba(118, 169, 250, var(--divide-opacity));
  }
  .md\\:divide-blue-500> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #3f83f8;
    border-color: rgba(63, 131, 248, var(--divide-opacity));
  }
  .md\\:divide-blue-600> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #1c64f2;
    border-color: rgba(28, 100, 242, var(--divide-opacity));
  }
  .md\\:divide-blue-700> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #1a56db;
    border-color: rgba(26, 86, 219, var(--divide-opacity));
  }
  .md\\:divide-blue-800> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #1e429f;
    border-color: rgba(30, 66, 159, var(--divide-opacity));
  }
  .md\\:divide-blue-900> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #233876;
    border-color: rgba(35, 56, 118, var(--divide-opacity));
  }
  .md\\:divide-indigo-50> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #f0f5ff;
    border-color: rgba(240, 245, 255, var(--divide-opacity));
  }
  .md\\:divide-indigo-100> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #e5edff;
    border-color: rgba(229, 237, 255, var(--divide-opacity));
  }
  .md\\:divide-indigo-200> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #cddbfe;
    border-color: rgba(205, 219, 254, var(--divide-opacity));
  }
  .md\\:divide-indigo-300> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #b4c6fc;
    border-color: rgba(180, 198, 252, var(--divide-opacity));
  }
  .md\\:divide-indigo-400> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #8da2fb;
    border-color: rgba(141, 162, 251, var(--divide-opacity));
  }
  .md\\:divide-indigo-500> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #6875f5;
    border-color: rgba(104, 117, 245, var(--divide-opacity));
  }
  .md\\:divide-indigo-600> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #5850ec;
    border-color: rgba(88, 80, 236, var(--divide-opacity));
  }
  .md\\:divide-indigo-700> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #5145cd;
    border-color: rgba(81, 69, 205, var(--divide-opacity));
  }
  .md\\:divide-indigo-800> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #42389d;
    border-color: rgba(66, 56, 157, var(--divide-opacity));
  }
  .md\\:divide-indigo-900> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #362f78;
    border-color: rgba(54, 47, 120, var(--divide-opacity));
  }
  .md\\:divide-purple-50> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #f6f5ff;
    border-color: rgba(246, 245, 255, var(--divide-opacity));
  }
  .md\\:divide-purple-100> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #edebfe;
    border-color: rgba(237, 235, 254, var(--divide-opacity));
  }
  .md\\:divide-purple-200> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #dcd7fe;
    border-color: rgba(220, 215, 254, var(--divide-opacity));
  }
  .md\\:divide-purple-300> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #cabffd;
    border-color: rgba(202, 191, 253, var(--divide-opacity));
  }
  .md\\:divide-purple-400> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #ac94fa;
    border-color: rgba(172, 148, 250, var(--divide-opacity));
  }
  .md\\:divide-purple-500> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #9061f9;
    border-color: rgba(144, 97, 249, var(--divide-opacity));
  }
  .md\\:divide-purple-600> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #7e3af2;
    border-color: rgba(126, 58, 242, var(--divide-opacity));
  }
  .md\\:divide-purple-700> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #6c2bd9;
    border-color: rgba(108, 43, 217, var(--divide-opacity));
  }
  .md\\:divide-purple-800> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #5521b5;
    border-color: rgba(85, 33, 181, var(--divide-opacity));
  }
  .md\\:divide-purple-900> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #4a1d96;
    border-color: rgba(74, 29, 150, var(--divide-opacity));
  }
  .md\\:divide-pink-50> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #fdf2f8;
    border-color: rgba(253, 242, 248, var(--divide-opacity));
  }
  .md\\:divide-pink-100> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #fce8f3;
    border-color: rgba(252, 232, 243, var(--divide-opacity));
  }
  .md\\:divide-pink-200> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #fad1e8;
    border-color: rgba(250, 209, 232, var(--divide-opacity));
  }
  .md\\:divide-pink-300> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #f8b4d9;
    border-color: rgba(248, 180, 217, var(--divide-opacity));
  }
  .md\\:divide-pink-400> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #f17eb8;
    border-color: rgba(241, 126, 184, var(--divide-opacity));
  }
  .md\\:divide-pink-500> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #e74694;
    border-color: rgba(231, 70, 148, var(--divide-opacity));
  }
  .md\\:divide-pink-600> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #d61f69;
    border-color: rgba(214, 31, 105, var(--divide-opacity));
  }
  .md\\:divide-pink-700> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #bf125d;
    border-color: rgba(191, 18, 93, var(--divide-opacity));
  }
  .md\\:divide-pink-800> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #99154b;
    border-color: rgba(153, 21, 75, var(--divide-opacity));
  }
  .md\\:divide-pink-900> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #751a3d;
    border-color: rgba(117, 26, 61, var(--divide-opacity));
  }
  .md\\:divide-cool-gray-50> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #f8fafc;
    border-color: rgba(248, 250, 252, var(--divide-opacity));
  }
  .md\\:divide-cool-gray-100> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #f1f5f9;
    border-color: rgba(241, 245, 249, var(--divide-opacity));
  }
  .md\\:divide-cool-gray-200> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #e2e8f0;
    border-color: rgba(226, 232, 240, var(--divide-opacity));
  }
  .md\\:divide-cool-gray-300> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #cfd8e3;
    border-color: rgba(207, 216, 227, var(--divide-opacity));
  }
  .md\\:divide-cool-gray-400> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #97a6ba;
    border-color: rgba(151, 166, 186, var(--divide-opacity));
  }
  .md\\:divide-cool-gray-500> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #64748b;
    border-color: rgba(100, 116, 139, var(--divide-opacity));
  }
  .md\\:divide-cool-gray-600> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #475569;
    border-color: rgba(71, 85, 105, var(--divide-opacity));
  }
  .md\\:divide-cool-gray-700> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #364152;
    border-color: rgba(54, 65, 82, var(--divide-opacity));
  }
  .md\\:divide-cool-gray-800> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #27303f;
    border-color: rgba(39, 48, 63, var(--divide-opacity));
  }
  .md\\:divide-cool-gray-900> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #1a202e;
    border-color: rgba(26, 32, 46, var(--divide-opacity));
  }
  .md\\:divide-solid> :not(template)~ :not(template) {
    border-style: solid;
  }
  .md\\:divide-dashed> :not(template)~ :not(template) {
    border-style: dashed;
  }
  .md\\:divide-dotted> :not(template)~ :not(template) {
    border-style: dotted;
  }
  .md\\:divide-double> :not(template)~ :not(template) {
    border-style: double;
  }
  .md\\:divide-none> :not(template)~ :not(template) {
    border-style: none;
  }
  .md\\:divide-opacity-0> :not(template)~ :not(template) {
    --divide-opacity: 0;
  }
  .md\\:divide-opacity-25> :not(template)~ :not(template) {
    --divide-opacity: 0.25;
  }
  .md\\:divide-opacity-50> :not(template)~ :not(template) {
    --divide-opacity: 0.5;
  }
  .md\\:divide-opacity-75> :not(template)~ :not(template) {
    --divide-opacity: 0.75;
  }
  .md\\:divide-opacity-100> :not(template)~ :not(template) {
    --divide-opacity: 1;
  }
  .md\\:sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border-width: 0;
  }
  .md\\:not-sr-only {
    position: static;
    width: auto;
    height: auto;
    padding: 0;
    margin: 0;
    overflow: visible;
    clip: auto;
    white-space: normal;
  }
  .md\\:focus\\:sr-only:focus {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border-width: 0;
  }
  .md\\:focus\\:not-sr-only:focus {
    position: static;
    width: auto;
    height: auto;
    padding: 0;
    margin: 0;
    overflow: visible;
    clip: auto;
    white-space: normal;
  }
  .md\\:appearance-none {
    appearance: none;
  }
  .md\\:bg-fixed {
    background-attachment: fixed;
  }
  .md\\:bg-local {
    background-attachment: local;
  }
  .md\\:bg-scroll {
    background-attachment: scroll;
  }
  .md\\:bg-clip-border {
    background-clip: border-box;
  }
  .md\\:bg-clip-padding {
    background-clip: padding-box;
  }
  .md\\:bg-clip-content {
    background-clip: content-box;
  }
  .md\\:bg-clip-text {
    -webkit-background-clip: text;
    background-clip: text;
  }
  .md\\:bg-current {
    background-color: currentColor;
  }
  .md\\:bg-transparent {
    background-color: transparent;
  }
  .md\\:bg-white {
    --bg-opacity: 1;
    background-color: #ffffff;
    background-color: rgba(255, 255, 255, var(--bg-opacity));
  }
  .md\\:bg-black {
    --bg-opacity: 1;
    background-color: #000000;
    background-color: rgba(0, 0, 0, var(--bg-opacity));
  }
  .md\\:bg-gray-50 {
    --bg-opacity: 1;
    background-color: #f9fafb;
    background-color: rgba(249, 250, 251, var(--bg-opacity));
  }
  .md\\:bg-gray-100 {
    --bg-opacity: 1;
    background-color: #f4f5f7;
    background-color: rgba(244, 245, 247, var(--bg-opacity));
  }
  .md\\:bg-gray-200 {
    --bg-opacity: 1;
    background-color: #e5e7eb;
    background-color: rgba(229, 231, 235, var(--bg-opacity));
  }
  .md\\:bg-gray-300 {
    --bg-opacity: 1;
    background-color: #d2d6dc;
    background-color: rgba(210, 214, 220, var(--bg-opacity));
  }
  .md\\:bg-gray-400 {
    --bg-opacity: 1;
    background-color: #9fa6b2;
    background-color: rgba(159, 166, 178, var(--bg-opacity));
  }
  .md\\:bg-gray-500 {
    --bg-opacity: 1;
    background-color: #6b7280;
    background-color: rgba(107, 114, 128, var(--bg-opacity));
  }
  .md\\:bg-gray-600 {
    --bg-opacity: 1;
    background-color: #4b5563;
    background-color: rgba(75, 85, 99, var(--bg-opacity));
  }
  .md\\:bg-gray-700 {
    --bg-opacity: 1;
    background-color: #374151;
    background-color: rgba(55, 65, 81, var(--bg-opacity));
  }
  .md\\:bg-gray-800 {
    --bg-opacity: 1;
    background-color: #252f3f;
    background-color: rgba(37, 47, 63, var(--bg-opacity));
  }
  .md\\:bg-gray-900 {
    --bg-opacity: 1;
    background-color: #161e2e;
    background-color: rgba(22, 30, 46, var(--bg-opacity));
  }
  .md\\:bg-red-50 {
    --bg-opacity: 1;
    background-color: #fdf2f2;
    background-color: rgba(253, 242, 242, var(--bg-opacity));
  }
  .md\\:bg-red-100 {
    --bg-opacity: 1;
    background-color: #fde8e8;
    background-color: rgba(253, 232, 232, var(--bg-opacity));
  }
  .md\\:bg-red-200 {
    --bg-opacity: 1;
    background-color: #fbd5d5;
    background-color: rgba(251, 213, 213, var(--bg-opacity));
  }
  .md\\:bg-red-300 {
    --bg-opacity: 1;
    background-color: #f8b4b4;
    background-color: rgba(248, 180, 180, var(--bg-opacity));
  }
  .md\\:bg-red-400 {
    --bg-opacity: 1;
    background-color: #f98080;
    background-color: rgba(249, 128, 128, var(--bg-opacity));
  }
  .md\\:bg-red-500 {
    --bg-opacity: 1;
    background-color: #f05252;
    background-color: rgba(240, 82, 82, var(--bg-opacity));
  }
  .md\\:bg-red-600 {
    --bg-opacity: 1;
    background-color: #e02424;
    background-color: rgba(224, 36, 36, var(--bg-opacity));
  }
  .md\\:bg-red-700 {
    --bg-opacity: 1;
    background-color: #c81e1e;
    background-color: rgba(200, 30, 30, var(--bg-opacity));
  }
  .md\\:bg-red-800 {
    --bg-opacity: 1;
    background-color: #9b1c1c;
    background-color: rgba(155, 28, 28, var(--bg-opacity));
  }
  .md\\:bg-red-900 {
    --bg-opacity: 1;
    background-color: #771d1d;
    background-color: rgba(119, 29, 29, var(--bg-opacity));
  }
  .md\\:bg-orange-50 {
    --bg-opacity: 1;
    background-color: #fff8f1;
    background-color: rgba(255, 248, 241, var(--bg-opacity));
  }
  .md\\:bg-orange-100 {
    --bg-opacity: 1;
    background-color: #feecdc;
    background-color: rgba(254, 236, 220, var(--bg-opacity));
  }
  .md\\:bg-orange-200 {
    --bg-opacity: 1;
    background-color: #fcd9bd;
    background-color: rgba(252, 217, 189, var(--bg-opacity));
  }
  .md\\:bg-orange-300 {
    --bg-opacity: 1;
    background-color: #fdba8c;
    background-color: rgba(253, 186, 140, var(--bg-opacity));
  }
  .md\\:bg-orange-400 {
    --bg-opacity: 1;
    background-color: #ff8a4c;
    background-color: rgba(255, 138, 76, var(--bg-opacity));
  }
  .md\\:bg-orange-500 {
    --bg-opacity: 1;
    background-color: #ff5a1f;
    background-color: rgba(255, 90, 31, var(--bg-opacity));
  }
  .md\\:bg-orange-600 {
    --bg-opacity: 1;
    background-color: #d03801;
    background-color: rgba(208, 56, 1, var(--bg-opacity));
  }
  .md\\:bg-orange-700 {
    --bg-opacity: 1;
    background-color: #b43403;
    background-color: rgba(180, 52, 3, var(--bg-opacity));
  }
  .md\\:bg-orange-800 {
    --bg-opacity: 1;
    background-color: #8a2c0d;
    background-color: rgba(138, 44, 13, var(--bg-opacity));
  }
  .md\\:bg-orange-900 {
    --bg-opacity: 1;
    background-color: #73230d;
    background-color: rgba(115, 35, 13, var(--bg-opacity));
  }
  .md\\:bg-yellow-50 {
    --bg-opacity: 1;
    background-color: #fdfdea;
    background-color: rgba(253, 253, 234, var(--bg-opacity));
  }
  .md\\:bg-yellow-100 {
    --bg-opacity: 1;
    background-color: #fdf6b2;
    background-color: rgba(253, 246, 178, var(--bg-opacity));
  }
  .md\\:bg-yellow-200 {
    --bg-opacity: 1;
    background-color: #fce96a;
    background-color: rgba(252, 233, 106, var(--bg-opacity));
  }
  .md\\:bg-yellow-300 {
    --bg-opacity: 1;
    background-color: #faca15;
    background-color: rgba(250, 202, 21, var(--bg-opacity));
  }
  .md\\:bg-yellow-400 {
    --bg-opacity: 1;
    background-color: #e3a008;
    background-color: rgba(227, 160, 8, var(--bg-opacity));
  }
  .md\\:bg-yellow-500 {
    --bg-opacity: 1;
    background-color: #c27803;
    background-color: rgba(194, 120, 3, var(--bg-opacity));
  }
  .md\\:bg-yellow-600 {
    --bg-opacity: 1;
    background-color: #9f580a;
    background-color: rgba(159, 88, 10, var(--bg-opacity));
  }
  .md\\:bg-yellow-700 {
    --bg-opacity: 1;
    background-color: #8e4b10;
    background-color: rgba(142, 75, 16, var(--bg-opacity));
  }
  .md\\:bg-yellow-800 {
    --bg-opacity: 1;
    background-color: #723b13;
    background-color: rgba(114, 59, 19, var(--bg-opacity));
  }
  .md\\:bg-yellow-900 {
    --bg-opacity: 1;
    background-color: #633112;
    background-color: rgba(99, 49, 18, var(--bg-opacity));
  }
  .md\\:bg-green-50 {
    --bg-opacity: 1;
    background-color: #f3faf7;
    background-color: rgba(243, 250, 247, var(--bg-opacity));
  }
  .md\\:bg-green-100 {
    --bg-opacity: 1;
    background-color: #def7ec;
    background-color: rgba(222, 247, 236, var(--bg-opacity));
  }
  .md\\:bg-green-200 {
    --bg-opacity: 1;
    background-color: #bcf0da;
    background-color: rgba(188, 240, 218, var(--bg-opacity));
  }
  .md\\:bg-green-300 {
    --bg-opacity: 1;
    background-color: #84e1bc;
    background-color: rgba(132, 225, 188, var(--bg-opacity));
  }
  .md\\:bg-green-400 {
    --bg-opacity: 1;
    background-color: #31c48d;
    background-color: rgba(49, 196, 141, var(--bg-opacity));
  }
  .md\\:bg-green-500 {
    --bg-opacity: 1;
    background-color: #0e9f6e;
    background-color: rgba(14, 159, 110, var(--bg-opacity));
  }
  .md\\:bg-green-600 {
    --bg-opacity: 1;
    background-color: #057a55;
    background-color: rgba(5, 122, 85, var(--bg-opacity));
  }
  .md\\:bg-green-700 {
    --bg-opacity: 1;
    background-color: #046c4e;
    background-color: rgba(4, 108, 78, var(--bg-opacity));
  }
  .md\\:bg-green-800 {
    --bg-opacity: 1;
    background-color: #03543f;
    background-color: rgba(3, 84, 63, var(--bg-opacity));
  }
  .md\\:bg-green-900 {
    --bg-opacity: 1;
    background-color: #014737;
    background-color: rgba(1, 71, 55, var(--bg-opacity));
  }
  .md\\:bg-teal-50 {
    --bg-opacity: 1;
    background-color: #edfafa;
    background-color: rgba(237, 250, 250, var(--bg-opacity));
  }
  .md\\:bg-teal-100 {
    --bg-opacity: 1;
    background-color: #d5f5f6;
    background-color: rgba(213, 245, 246, var(--bg-opacity));
  }
  .md\\:bg-teal-200 {
    --bg-opacity: 1;
    background-color: #afecef;
    background-color: rgba(175, 236, 239, var(--bg-opacity));
  }
  .md\\:bg-teal-300 {
    --bg-opacity: 1;
    background-color: #7edce2;
    background-color: rgba(126, 220, 226, var(--bg-opacity));
  }
  .md\\:bg-teal-400 {
    --bg-opacity: 1;
    background-color: #16bdca;
    background-color: rgba(22, 189, 202, var(--bg-opacity));
  }
  .md\\:bg-teal-500 {
    --bg-opacity: 1;
    background-color: #0694a2;
    background-color: rgba(6, 148, 162, var(--bg-opacity));
  }
  .md\\:bg-teal-600 {
    --bg-opacity: 1;
    background-color: #047481;
    background-color: rgba(4, 116, 129, var(--bg-opacity));
  }
  .md\\:bg-teal-700 {
    --bg-opacity: 1;
    background-color: #036672;
    background-color: rgba(3, 102, 114, var(--bg-opacity));
  }
  .md\\:bg-teal-800 {
    --bg-opacity: 1;
    background-color: #05505c;
    background-color: rgba(5, 80, 92, var(--bg-opacity));
  }
  .md\\:bg-teal-900 {
    --bg-opacity: 1;
    background-color: #014451;
    background-color: rgba(1, 68, 81, var(--bg-opacity));
  }
  .md\\:bg-blue-50 {
    --bg-opacity: 1;
    background-color: #ebf5ff;
    background-color: rgba(235, 245, 255, var(--bg-opacity));
  }
  .md\\:bg-blue-100 {
    --bg-opacity: 1;
    background-color: #e1effe;
    background-color: rgba(225, 239, 254, var(--bg-opacity));
  }
  .md\\:bg-blue-200 {
    --bg-opacity: 1;
    background-color: #c3ddfd;
    background-color: rgba(195, 221, 253, var(--bg-opacity));
  }
  .md\\:bg-blue-300 {
    --bg-opacity: 1;
    background-color: #a4cafe;
    background-color: rgba(164, 202, 254, var(--bg-opacity));
  }
  .md\\:bg-blue-400 {
    --bg-opacity: 1;
    background-color: #76a9fa;
    background-color: rgba(118, 169, 250, var(--bg-opacity));
  }
  .md\\:bg-blue-500 {
    --bg-opacity: 1;
    background-color: #3f83f8;
    background-color: rgba(63, 131, 248, var(--bg-opacity));
  }
  .md\\:bg-blue-600 {
    --bg-opacity: 1;
    background-color: #1c64f2;
    background-color: rgba(28, 100, 242, var(--bg-opacity));
  }
  .md\\:bg-blue-700 {
    --bg-opacity: 1;
    background-color: #1a56db;
    background-color: rgba(26, 86, 219, var(--bg-opacity));
  }
  .md\\:bg-blue-800 {
    --bg-opacity: 1;
    background-color: #1e429f;
    background-color: rgba(30, 66, 159, var(--bg-opacity));
  }
  .md\\:bg-blue-900 {
    --bg-opacity: 1;
    background-color: #233876;
    background-color: rgba(35, 56, 118, var(--bg-opacity));
  }
  .md\\:bg-indigo-50 {
    --bg-opacity: 1;
    background-color: #f0f5ff;
    background-color: rgba(240, 245, 255, var(--bg-opacity));
  }
  .md\\:bg-indigo-100 {
    --bg-opacity: 1;
    background-color: #e5edff;
    background-color: rgba(229, 237, 255, var(--bg-opacity));
  }
  .md\\:bg-indigo-200 {
    --bg-opacity: 1;
    background-color: #cddbfe;
    background-color: rgba(205, 219, 254, var(--bg-opacity));
  }
  .md\\:bg-indigo-300 {
    --bg-opacity: 1;
    background-color: #b4c6fc;
    background-color: rgba(180, 198, 252, var(--bg-opacity));
  }
  .md\\:bg-indigo-400 {
    --bg-opacity: 1;
    background-color: #8da2fb;
    background-color: rgba(141, 162, 251, var(--bg-opacity));
  }
  .md\\:bg-indigo-500 {
    --bg-opacity: 1;
    background-color: #6875f5;
    background-color: rgba(104, 117, 245, var(--bg-opacity));
  }
  .md\\:bg-indigo-600 {
    --bg-opacity: 1;
    background-color: #5850ec;
    background-color: rgba(88, 80, 236, var(--bg-opacity));
  }
  .md\\:bg-indigo-700 {
    --bg-opacity: 1;
    background-color: #5145cd;
    background-color: rgba(81, 69, 205, var(--bg-opacity));
  }
  .md\\:bg-indigo-800 {
    --bg-opacity: 1;
    background-color: #42389d;
    background-color: rgba(66, 56, 157, var(--bg-opacity));
  }
  .md\\:bg-indigo-900 {
    --bg-opacity: 1;
    background-color: #362f78;
    background-color: rgba(54, 47, 120, var(--bg-opacity));
  }
  .md\\:bg-purple-50 {
    --bg-opacity: 1;
    background-color: #f6f5ff;
    background-color: rgba(246, 245, 255, var(--bg-opacity));
  }
  .md\\:bg-purple-100 {
    --bg-opacity: 1;
    background-color: #edebfe;
    background-color: rgba(237, 235, 254, var(--bg-opacity));
  }
  .md\\:bg-purple-200 {
    --bg-opacity: 1;
    background-color: #dcd7fe;
    background-color: rgba(220, 215, 254, var(--bg-opacity));
  }
  .md\\:bg-purple-300 {
    --bg-opacity: 1;
    background-color: #cabffd;
    background-color: rgba(202, 191, 253, var(--bg-opacity));
  }
  .md\\:bg-purple-400 {
    --bg-opacity: 1;
    background-color: #ac94fa;
    background-color: rgba(172, 148, 250, var(--bg-opacity));
  }
  .md\\:bg-purple-500 {
    --bg-opacity: 1;
    background-color: #9061f9;
    background-color: rgba(144, 97, 249, var(--bg-opacity));
  }
  .md\\:bg-purple-600 {
    --bg-opacity: 1;
    background-color: #7e3af2;
    background-color: rgba(126, 58, 242, var(--bg-opacity));
  }
  .md\\:bg-purple-700 {
    --bg-opacity: 1;
    background-color: #6c2bd9;
    background-color: rgba(108, 43, 217, var(--bg-opacity));
  }
  .md\\:bg-purple-800 {
    --bg-opacity: 1;
    background-color: #5521b5;
    background-color: rgba(85, 33, 181, var(--bg-opacity));
  }
  .md\\:bg-purple-900 {
    --bg-opacity: 1;
    background-color: #4a1d96;
    background-color: rgba(74, 29, 150, var(--bg-opacity));
  }
  .md\\:bg-pink-50 {
    --bg-opacity: 1;
    background-color: #fdf2f8;
    background-color: rgba(253, 242, 248, var(--bg-opacity));
  }
  .md\\:bg-pink-100 {
    --bg-opacity: 1;
    background-color: #fce8f3;
    background-color: rgba(252, 232, 243, var(--bg-opacity));
  }
  .md\\:bg-pink-200 {
    --bg-opacity: 1;
    background-color: #fad1e8;
    background-color: rgba(250, 209, 232, var(--bg-opacity));
  }
  .md\\:bg-pink-300 {
    --bg-opacity: 1;
    background-color: #f8b4d9;
    background-color: rgba(248, 180, 217, var(--bg-opacity));
  }
  .md\\:bg-pink-400 {
    --bg-opacity: 1;
    background-color: #f17eb8;
    background-color: rgba(241, 126, 184, var(--bg-opacity));
  }
  .md\\:bg-pink-500 {
    --bg-opacity: 1;
    background-color: #e74694;
    background-color: rgba(231, 70, 148, var(--bg-opacity));
  }
  .md\\:bg-pink-600 {
    --bg-opacity: 1;
    background-color: #d61f69;
    background-color: rgba(214, 31, 105, var(--bg-opacity));
  }
  .md\\:bg-pink-700 {
    --bg-opacity: 1;
    background-color: #bf125d;
    background-color: rgba(191, 18, 93, var(--bg-opacity));
  }
  .md\\:bg-pink-800 {
    --bg-opacity: 1;
    background-color: #99154b;
    background-color: rgba(153, 21, 75, var(--bg-opacity));
  }
  .md\\:bg-pink-900 {
    --bg-opacity: 1;
    background-color: #751a3d;
    background-color: rgba(117, 26, 61, var(--bg-opacity));
  }
  .md\\:bg-cool-gray-50 {
    --bg-opacity: 1;
    background-color: #f8fafc;
    background-color: rgba(248, 250, 252, var(--bg-opacity));
  }
  .md\\:bg-cool-gray-100 {
    --bg-opacity: 1;
    background-color: #f1f5f9;
    background-color: rgba(241, 245, 249, var(--bg-opacity));
  }
  .md\\:bg-cool-gray-200 {
    --bg-opacity: 1;
    background-color: #e2e8f0;
    background-color: rgba(226, 232, 240, var(--bg-opacity));
  }
  .md\\:bg-cool-gray-300 {
    --bg-opacity: 1;
    background-color: #cfd8e3;
    background-color: rgba(207, 216, 227, var(--bg-opacity));
  }
  .md\\:bg-cool-gray-400 {
    --bg-opacity: 1;
    background-color: #97a6ba;
    background-color: rgba(151, 166, 186, var(--bg-opacity));
  }
  .md\\:bg-cool-gray-500 {
    --bg-opacity: 1;
    background-color: #64748b;
    background-color: rgba(100, 116, 139, var(--bg-opacity));
  }
  .md\\:bg-cool-gray-600 {
    --bg-opacity: 1;
    background-color: #475569;
    background-color: rgba(71, 85, 105, var(--bg-opacity));
  }
  .md\\:bg-cool-gray-700 {
    --bg-opacity: 1;
    background-color: #364152;
    background-color: rgba(54, 65, 82, var(--bg-opacity));
  }
  .md\\:bg-cool-gray-800 {
    --bg-opacity: 1;
    background-color: #27303f;
    background-color: rgba(39, 48, 63, var(--bg-opacity));
  }
  .md\\:bg-cool-gray-900 {
    --bg-opacity: 1;
    background-color: #1a202e;
    background-color: rgba(26, 32, 46, var(--bg-opacity));
  }
  .group:hover .md\\:group-hover\\:bg-current {
    background-color: currentColor;
  }
  .group:hover .md\\:group-hover\\:bg-transparent {
    background-color: transparent;
  }
  .group:hover .md\\:group-hover\\:bg-white {
    --bg-opacity: 1;
    background-color: #ffffff;
    background-color: rgba(255, 255, 255, var(--bg-opacity));
  }
  .group:hover .md\\:group-hover\\:bg-black {
    --bg-opacity: 1;
    background-color: #000000;
    background-color: rgba(0, 0, 0, var(--bg-opacity));
  }
  .group:hover .md\\:group-hover\\:bg-gray-50 {
    --bg-opacity: 1;
    background-color: #f9fafb;
    background-color: rgba(249, 250, 251, var(--bg-opacity));
  }
  .group:hover .md\\:group-hover\\:bg-gray-100 {
    --bg-opacity: 1;
    background-color: #f4f5f7;
    background-color: rgba(244, 245, 247, var(--bg-opacity));
  }
  .group:hover .md\\:group-hover\\:bg-gray-200 {
    --bg-opacity: 1;
    background-color: #e5e7eb;
    background-color: rgba(229, 231, 235, var(--bg-opacity));
  }
  .group:hover .md\\:group-hover\\:bg-gray-300 {
    --bg-opacity: 1;
    background-color: #d2d6dc;
    background-color: rgba(210, 214, 220, var(--bg-opacity));
  }
  .group:hover .md\\:group-hover\\:bg-gray-400 {
    --bg-opacity: 1;
    background-color: #9fa6b2;
    background-color: rgba(159, 166, 178, var(--bg-opacity));
  }
  .group:hover .md\\:group-hover\\:bg-gray-500 {
    --bg-opacity: 1;
    background-color: #6b7280;
    background-color: rgba(107, 114, 128, var(--bg-opacity));
  }
  .group:hover .md\\:group-hover\\:bg-gray-600 {
    --bg-opacity: 1;
    background-color: #4b5563;
    background-color: rgba(75, 85, 99, var(--bg-opacity));
  }
  .group:hover .md\\:group-hover\\:bg-gray-700 {
    --bg-opacity: 1;
    background-color: #374151;
    background-color: rgba(55, 65, 81, var(--bg-opacity));
  }
  .group:hover .md\\:group-hover\\:bg-gray-800 {
    --bg-opacity: 1;
    background-color: #252f3f;
    background-color: rgba(37, 47, 63, var(--bg-opacity));
  }
  .group:hover .md\\:group-hover\\:bg-gray-900 {
    --bg-opacity: 1;
    background-color: #161e2e;
    background-color: rgba(22, 30, 46, var(--bg-opacity));
  }
  .group:hover .md\\:group-hover\\:bg-red-50 {
    --bg-opacity: 1;
    background-color: #fdf2f2;
    background-color: rgba(253, 242, 242, var(--bg-opacity));
  }
  .group:hover .md\\:group-hover\\:bg-red-100 {
    --bg-opacity: 1;
    background-color: #fde8e8;
    background-color: rgba(253, 232, 232, var(--bg-opacity));
  }
  .group:hover .md\\:group-hover\\:bg-red-200 {
    --bg-opacity: 1;
    background-color: #fbd5d5;
    background-color: rgba(251, 213, 213, var(--bg-opacity));
  }
  .group:hover .md\\:group-hover\\:bg-red-300 {
    --bg-opacity: 1;
    background-color: #f8b4b4;
    background-color: rgba(248, 180, 180, var(--bg-opacity));
  }
  .group:hover .md\\:group-hover\\:bg-red-400 {
    --bg-opacity: 1;
    background-color: #f98080;
    background-color: rgba(249, 128, 128, var(--bg-opacity));
  }
  .group:hover .md\\:group-hover\\:bg-red-500 {
    --bg-opacity: 1;
    background-color: #f05252;
    background-color: rgba(240, 82, 82, var(--bg-opacity));
  }
  .group:hover .md\\:group-hover\\:bg-red-600 {
    --bg-opacity: 1;
    background-color: #e02424;
    background-color: rgba(224, 36, 36, var(--bg-opacity));
  }
  .group:hover .md\\:group-hover\\:bg-red-700 {
    --bg-opacity: 1;
    background-color: #c81e1e;
    background-color: rgba(200, 30, 30, var(--bg-opacity));
  }
  .group:hover .md\\:group-hover\\:bg-red-800 {
    --bg-opacity: 1;
    background-color: #9b1c1c;
    background-color: rgba(155, 28, 28, var(--bg-opacity));
  }
  .group:hover .md\\:group-hover\\:bg-red-900 {
    --bg-opacity: 1;
    background-color: #771d1d;
    background-color: rgba(119, 29, 29, var(--bg-opacity));
  }
  .group:hover .md\\:group-hover\\:bg-orange-50 {
    --bg-opacity: 1;
    background-color: #fff8f1;
    background-color: rgba(255, 248, 241, var(--bg-opacity));
  }
  .group:hover .md\\:group-hover\\:bg-orange-100 {
    --bg-opacity: 1;
    background-color: #feecdc;
    background-color: rgba(254, 236, 220, var(--bg-opacity));
  }
  .group:hover .md\\:group-hover\\:bg-orange-200 {
    --bg-opacity: 1;
    background-color: #fcd9bd;
    background-color: rgba(252, 217, 189, var(--bg-opacity));
  }
  .group:hover .md\\:group-hover\\:bg-orange-300 {
    --bg-opacity: 1;
    background-color: #fdba8c;
    background-color: rgba(253, 186, 140, var(--bg-opacity));
  }
  .group:hover .md\\:group-hover\\:bg-orange-400 {
    --bg-opacity: 1;
    background-color: #ff8a4c;
    background-color: rgba(255, 138, 76, var(--bg-opacity));
  }
  .group:hover .md\\:group-hover\\:bg-orange-500 {
    --bg-opacity: 1;
    background-color: #ff5a1f;
    background-color: rgba(255, 90, 31, var(--bg-opacity));
  }
  .group:hover .md\\:group-hover\\:bg-orange-600 {
    --bg-opacity: 1;
    background-color: #d03801;
    background-color: rgba(208, 56, 1, var(--bg-opacity));
  }
  .group:hover .md\\:group-hover\\:bg-orange-700 {
    --bg-opacity: 1;
    background-color: #b43403;
    background-color: rgba(180, 52, 3, var(--bg-opacity));
  }
  .group:hover .md\\:group-hover\\:bg-orange-800 {
    --bg-opacity: 1;
    background-color: #8a2c0d;
    background-color: rgba(138, 44, 13, var(--bg-opacity));
  }
  .group:hover .md\\:group-hover\\:bg-orange-900 {
    --bg-opacity: 1;
    background-color: #73230d;
    background-color: rgba(115, 35, 13, var(--bg-opacity));
  }
  .group:hover .md\\:group-hover\\:bg-yellow-50 {
    --bg-opacity: 1;
    background-color: #fdfdea;
    background-color: rgba(253, 253, 234, var(--bg-opacity));
  }
  .group:hover .md\\:group-hover\\:bg-yellow-100 {
    --bg-opacity: 1;
    background-color: #fdf6b2;
    background-color: rgba(253, 246, 178, var(--bg-opacity));
  }
  .group:hover .md\\:group-hover\\:bg-yellow-200 {
    --bg-opacity: 1;
    background-color: #fce96a;
    background-color: rgba(252, 233, 106, var(--bg-opacity));
  }
  .group:hover .md\\:group-hover\\:bg-yellow-300 {
    --bg-opacity: 1;
    background-color: #faca15;
    background-color: rgba(250, 202, 21, var(--bg-opacity));
  }
  .group:hover .md\\:group-hover\\:bg-yellow-400 {
    --bg-opacity: 1;
    background-color: #e3a008;
    background-color: rgba(227, 160, 8, var(--bg-opacity));
  }
  .group:hover .md\\:group-hover\\:bg-yellow-500 {
    --bg-opacity: 1;
    background-color: #c27803;
    background-color: rgba(194, 120, 3, var(--bg-opacity));
  }
  .group:hover .md\\:group-hover\\:bg-yellow-600 {
    --bg-opacity: 1;
    background-color: #9f580a;
    background-color: rgba(159, 88, 10, var(--bg-opacity));
  }
  .group:hover .md\\:group-hover\\:bg-yellow-700 {
    --bg-opacity: 1;
    background-color: #8e4b10;
    background-color: rgba(142, 75, 16, var(--bg-opacity));
  }
  .group:hover .md\\:group-hover\\:bg-yellow-800 {
    --bg-opacity: 1;
    background-color: #723b13;
    background-color: rgba(114, 59, 19, var(--bg-opacity));
  }
  .group:hover .md\\:group-hover\\:bg-yellow-900 {
    --bg-opacity: 1;
    background-color: #633112;
    background-color: rgba(99, 49, 18, var(--bg-opacity));
  }
  .group:hover .md\\:group-hover\\:bg-green-50 {
    --bg-opacity: 1;
    background-color: #f3faf7;
    background-color: rgba(243, 250, 247, var(--bg-opacity));
  }
  .group:hover .md\\:group-hover\\:bg-green-100 {
    --bg-opacity: 1;
    background-color: #def7ec;
    background-color: rgba(222, 247, 236, var(--bg-opacity));
  }
  .group:hover .md\\:group-hover\\:bg-green-200 {
    --bg-opacity: 1;
    background-color: #bcf0da;
    background-color: rgba(188, 240, 218, var(--bg-opacity));
  }
  .group:hover .md\\:group-hover\\:bg-green-300 {
    --bg-opacity: 1;
    background-color: #84e1bc;
    background-color: rgba(132, 225, 188, var(--bg-opacity));
  }
  .group:hover .md\\:group-hover\\:bg-green-400 {
    --bg-opacity: 1;
    background-color: #31c48d;
    background-color: rgba(49, 196, 141, var(--bg-opacity));
  }
  .group:hover .md\\:group-hover\\:bg-green-500 {
    --bg-opacity: 1;
    background-color: #0e9f6e;
    background-color: rgba(14, 159, 110, var(--bg-opacity));
  }
  .group:hover .md\\:group-hover\\:bg-green-600 {
    --bg-opacity: 1;
    background-color: #057a55;
    background-color: rgba(5, 122, 85, var(--bg-opacity));
  }
  .group:hover .md\\:group-hover\\:bg-green-700 {
    --bg-opacity: 1;
    background-color: #046c4e;
    background-color: rgba(4, 108, 78, var(--bg-opacity));
  }
  .group:hover .md\\:group-hover\\:bg-green-800 {
    --bg-opacity: 1;
    background-color: #03543f;
    background-color: rgba(3, 84, 63, var(--bg-opacity));
  }
  .group:hover .md\\:group-hover\\:bg-green-900 {
    --bg-opacity: 1;
    background-color: #014737;
    background-color: rgba(1, 71, 55, var(--bg-opacity));
  }
  .group:hover .md\\:group-hover\\:bg-teal-50 {
    --bg-opacity: 1;
    background-color: #edfafa;
    background-color: rgba(237, 250, 250, var(--bg-opacity));
  }
  .group:hover .md\\:group-hover\\:bg-teal-100 {
    --bg-opacity: 1;
    background-color: #d5f5f6;
    background-color: rgba(213, 245, 246, var(--bg-opacity));
  }
  .group:hover .md\\:group-hover\\:bg-teal-200 {
    --bg-opacity: 1;
    background-color: #afecef;
    background-color: rgba(175, 236, 239, var(--bg-opacity));
  }
  .group:hover .md\\:group-hover\\:bg-teal-300 {
    --bg-opacity: 1;
    background-color: #7edce2;
    background-color: rgba(126, 220, 226, var(--bg-opacity));
  }
  .group:hover .md\\:group-hover\\:bg-teal-400 {
    --bg-opacity: 1;
    background-color: #16bdca;
    background-color: rgba(22, 189, 202, var(--bg-opacity));
  }
  .group:hover .md\\:group-hover\\:bg-teal-500 {
    --bg-opacity: 1;
    background-color: #0694a2;
    background-color: rgba(6, 148, 162, var(--bg-opacity));
  }
  .group:hover .md\\:group-hover\\:bg-teal-600 {
    --bg-opacity: 1;
    background-color: #047481;
    background-color: rgba(4, 116, 129, var(--bg-opacity));
  }
  .group:hover .md\\:group-hover\\:bg-teal-700 {
    --bg-opacity: 1;
    background-color: #036672;
    background-color: rgba(3, 102, 114, var(--bg-opacity));
  }
  .group:hover .md\\:group-hover\\:bg-teal-800 {
    --bg-opacity: 1;
    background-color: #05505c;
    background-color: rgba(5, 80, 92, var(--bg-opacity));
  }
  .group:hover .md\\:group-hover\\:bg-teal-900 {
    --bg-opacity: 1;
    background-color: #014451;
    background-color: rgba(1, 68, 81, var(--bg-opacity));
  }
  .group:hover .md\\:group-hover\\:bg-blue-50 {
    --bg-opacity: 1;
    background-color: #ebf5ff;
    background-color: rgba(235, 245, 255, var(--bg-opacity));
  }
  .group:hover .md\\:group-hover\\:bg-blue-100 {
    --bg-opacity: 1;
    background-color: #e1effe;
    background-color: rgba(225, 239, 254, var(--bg-opacity));
  }
  .group:hover .md\\:group-hover\\:bg-blue-200 {
    --bg-opacity: 1;
    background-color: #c3ddfd;
    background-color: rgba(195, 221, 253, var(--bg-opacity));
  }
  .group:hover .md\\:group-hover\\:bg-blue-300 {
    --bg-opacity: 1;
    background-color: #a4cafe;
    background-color: rgba(164, 202, 254, var(--bg-opacity));
  }
  .group:hover .md\\:group-hover\\:bg-blue-400 {
    --bg-opacity: 1;
    background-color: #76a9fa;
    background-color: rgba(118, 169, 250, var(--bg-opacity));
  }
  .group:hover .md\\:group-hover\\:bg-blue-500 {
    --bg-opacity: 1;
    background-color: #3f83f8;
    background-color: rgba(63, 131, 248, var(--bg-opacity));
  }
  .group:hover .md\\:group-hover\\:bg-blue-600 {
    --bg-opacity: 1;
    background-color: #1c64f2;
    background-color: rgba(28, 100, 242, var(--bg-opacity));
  }
  .group:hover .md\\:group-hover\\:bg-blue-700 {
    --bg-opacity: 1;
    background-color: #1a56db;
    background-color: rgba(26, 86, 219, var(--bg-opacity));
  }
  .group:hover .md\\:group-hover\\:bg-blue-800 {
    --bg-opacity: 1;
    background-color: #1e429f;
    background-color: rgba(30, 66, 159, var(--bg-opacity));
  }
  .group:hover .md\\:group-hover\\:bg-blue-900 {
    --bg-opacity: 1;
    background-color: #233876;
    background-color: rgba(35, 56, 118, var(--bg-opacity));
  }
  .group:hover .md\\:group-hover\\:bg-indigo-50 {
    --bg-opacity: 1;
    background-color: #f0f5ff;
    background-color: rgba(240, 245, 255, var(--bg-opacity));
  }
  .group:hover .md\\:group-hover\\:bg-indigo-100 {
    --bg-opacity: 1;
    background-color: #e5edff;
    background-color: rgba(229, 237, 255, var(--bg-opacity));
  }
  .group:hover .md\\:group-hover\\:bg-indigo-200 {
    --bg-opacity: 1;
    background-color: #cddbfe;
    background-color: rgba(205, 219, 254, var(--bg-opacity));
  }
  .group:hover .md\\:group-hover\\:bg-indigo-300 {
    --bg-opacity: 1;
    background-color: #b4c6fc;
    background-color: rgba(180, 198, 252, var(--bg-opacity));
  }
  .group:hover .md\\:group-hover\\:bg-indigo-400 {
    --bg-opacity: 1;
    background-color: #8da2fb;
    background-color: rgba(141, 162, 251, var(--bg-opacity));
  }
  .group:hover .md\\:group-hover\\:bg-indigo-500 {
    --bg-opacity: 1;
    background-color: #6875f5;
    background-color: rgba(104, 117, 245, var(--bg-opacity));
  }
  .group:hover .md\\:group-hover\\:bg-indigo-600 {
    --bg-opacity: 1;
    background-color: #5850ec;
    background-color: rgba(88, 80, 236, var(--bg-opacity));
  }
  .group:hover .md\\:group-hover\\:bg-indigo-700 {
    --bg-opacity: 1;
    background-color: #5145cd;
    background-color: rgba(81, 69, 205, var(--bg-opacity));
  }
  .group:hover .md\\:group-hover\\:bg-indigo-800 {
    --bg-opacity: 1;
    background-color: #42389d;
    background-color: rgba(66, 56, 157, var(--bg-opacity));
  }
  .group:hover .md\\:group-hover\\:bg-indigo-900 {
    --bg-opacity: 1;
    background-color: #362f78;
    background-color: rgba(54, 47, 120, var(--bg-opacity));
  }
  .group:hover .md\\:group-hover\\:bg-purple-50 {
    --bg-opacity: 1;
    background-color: #f6f5ff;
    background-color: rgba(246, 245, 255, var(--bg-opacity));
  }
  .group:hover .md\\:group-hover\\:bg-purple-100 {
    --bg-opacity: 1;
    background-color: #edebfe;
    background-color: rgba(237, 235, 254, var(--bg-opacity));
  }
  .group:hover .md\\:group-hover\\:bg-purple-200 {
    --bg-opacity: 1;
    background-color: #dcd7fe;
    background-color: rgba(220, 215, 254, var(--bg-opacity));
  }
  .group:hover .md\\:group-hover\\:bg-purple-300 {
    --bg-opacity: 1;
    background-color: #cabffd;
    background-color: rgba(202, 191, 253, var(--bg-opacity));
  }
  .group:hover .md\\:group-hover\\:bg-purple-400 {
    --bg-opacity: 1;
    background-color: #ac94fa;
    background-color: rgba(172, 148, 250, var(--bg-opacity));
  }
  .group:hover .md\\:group-hover\\:bg-purple-500 {
    --bg-opacity: 1;
    background-color: #9061f9;
    background-color: rgba(144, 97, 249, var(--bg-opacity));
  }
  .group:hover .md\\:group-hover\\:bg-purple-600 {
    --bg-opacity: 1;
    background-color: #7e3af2;
    background-color: rgba(126, 58, 242, var(--bg-opacity));
  }
  .group:hover .md\\:group-hover\\:bg-purple-700 {
    --bg-opacity: 1;
    background-color: #6c2bd9;
    background-color: rgba(108, 43, 217, var(--bg-opacity));
  }
  .group:hover .md\\:group-hover\\:bg-purple-800 {
    --bg-opacity: 1;
    background-color: #5521b5;
    background-color: rgba(85, 33, 181, var(--bg-opacity));
  }
  .group:hover .md\\:group-hover\\:bg-purple-900 {
    --bg-opacity: 1;
    background-color: #4a1d96;
    background-color: rgba(74, 29, 150, var(--bg-opacity));
  }
  .group:hover .md\\:group-hover\\:bg-pink-50 {
    --bg-opacity: 1;
    background-color: #fdf2f8;
    background-color: rgba(253, 242, 248, var(--bg-opacity));
  }
  .group:hover .md\\:group-hover\\:bg-pink-100 {
    --bg-opacity: 1;
    background-color: #fce8f3;
    background-color: rgba(252, 232, 243, var(--bg-opacity));
  }
  .group:hover .md\\:group-hover\\:bg-pink-200 {
    --bg-opacity: 1;
    background-color: #fad1e8;
    background-color: rgba(250, 209, 232, var(--bg-opacity));
  }
  .group:hover .md\\:group-hover\\:bg-pink-300 {
    --bg-opacity: 1;
    background-color: #f8b4d9;
    background-color: rgba(248, 180, 217, var(--bg-opacity));
  }
  .group:hover .md\\:group-hover\\:bg-pink-400 {
    --bg-opacity: 1;
    background-color: #f17eb8;
    background-color: rgba(241, 126, 184, var(--bg-opacity));
  }
  .group:hover .md\\:group-hover\\:bg-pink-500 {
    --bg-opacity: 1;
    background-color: #e74694;
    background-color: rgba(231, 70, 148, var(--bg-opacity));
  }
  .group:hover .md\\:group-hover\\:bg-pink-600 {
    --bg-opacity: 1;
    background-color: #d61f69;
    background-color: rgba(214, 31, 105, var(--bg-opacity));
  }
  .group:hover .md\\:group-hover\\:bg-pink-700 {
    --bg-opacity: 1;
    background-color: #bf125d;
    background-color: rgba(191, 18, 93, var(--bg-opacity));
  }
  .group:hover .md\\:group-hover\\:bg-pink-800 {
    --bg-opacity: 1;
    background-color: #99154b;
    background-color: rgba(153, 21, 75, var(--bg-opacity));
  }
  .group:hover .md\\:group-hover\\:bg-pink-900 {
    --bg-opacity: 1;
    background-color: #751a3d;
    background-color: rgba(117, 26, 61, var(--bg-opacity));
  }
  .group:hover .md\\:group-hover\\:bg-cool-gray-50 {
    --bg-opacity: 1;
    background-color: #f8fafc;
    background-color: rgba(248, 250, 252, var(--bg-opacity));
  }
  .group:hover .md\\:group-hover\\:bg-cool-gray-100 {
    --bg-opacity: 1;
    background-color: #f1f5f9;
    background-color: rgba(241, 245, 249, var(--bg-opacity));
  }
  .group:hover .md\\:group-hover\\:bg-cool-gray-200 {
    --bg-opacity: 1;
    background-color: #e2e8f0;
    background-color: rgba(226, 232, 240, var(--bg-opacity));
  }
  .group:hover .md\\:group-hover\\:bg-cool-gray-300 {
    --bg-opacity: 1;
    background-color: #cfd8e3;
    background-color: rgba(207, 216, 227, var(--bg-opacity));
  }
  .group:hover .md\\:group-hover\\:bg-cool-gray-400 {
    --bg-opacity: 1;
    background-color: #97a6ba;
    background-color: rgba(151, 166, 186, var(--bg-opacity));
  }
  .group:hover .md\\:group-hover\\:bg-cool-gray-500 {
    --bg-opacity: 1;
    background-color: #64748b;
    background-color: rgba(100, 116, 139, var(--bg-opacity));
  }
  .group:hover .md\\:group-hover\\:bg-cool-gray-600 {
    --bg-opacity: 1;
    background-color: #475569;
    background-color: rgba(71, 85, 105, var(--bg-opacity));
  }
  .group:hover .md\\:group-hover\\:bg-cool-gray-700 {
    --bg-opacity: 1;
    background-color: #364152;
    background-color: rgba(54, 65, 82, var(--bg-opacity));
  }
  .group:hover .md\\:group-hover\\:bg-cool-gray-800 {
    --bg-opacity: 1;
    background-color: #27303f;
    background-color: rgba(39, 48, 63, var(--bg-opacity));
  }
  .group:hover .md\\:group-hover\\:bg-cool-gray-900 {
    --bg-opacity: 1;
    background-color: #1a202e;
    background-color: rgba(26, 32, 46, var(--bg-opacity));
  }
  .group:focus .md\\:group-focus\\:bg-current {
    background-color: currentColor;
  }
  .group:focus .md\\:group-focus\\:bg-transparent {
    background-color: transparent;
  }
  .group:focus .md\\:group-focus\\:bg-white {
    --bg-opacity: 1;
    background-color: #ffffff;
    background-color: rgba(255, 255, 255, var(--bg-opacity));
  }
  .group:focus .md\\:group-focus\\:bg-black {
    --bg-opacity: 1;
    background-color: #000000;
    background-color: rgba(0, 0, 0, var(--bg-opacity));
  }
  .group:focus .md\\:group-focus\\:bg-gray-50 {
    --bg-opacity: 1;
    background-color: #f9fafb;
    background-color: rgba(249, 250, 251, var(--bg-opacity));
  }
  .group:focus .md\\:group-focus\\:bg-gray-100 {
    --bg-opacity: 1;
    background-color: #f4f5f7;
    background-color: rgba(244, 245, 247, var(--bg-opacity));
  }
  .group:focus .md\\:group-focus\\:bg-gray-200 {
    --bg-opacity: 1;
    background-color: #e5e7eb;
    background-color: rgba(229, 231, 235, var(--bg-opacity));
  }
  .group:focus .md\\:group-focus\\:bg-gray-300 {
    --bg-opacity: 1;
    background-color: #d2d6dc;
    background-color: rgba(210, 214, 220, var(--bg-opacity));
  }
  .group:focus .md\\:group-focus\\:bg-gray-400 {
    --bg-opacity: 1;
    background-color: #9fa6b2;
    background-color: rgba(159, 166, 178, var(--bg-opacity));
  }
  .group:focus .md\\:group-focus\\:bg-gray-500 {
    --bg-opacity: 1;
    background-color: #6b7280;
    background-color: rgba(107, 114, 128, var(--bg-opacity));
  }
  .group:focus .md\\:group-focus\\:bg-gray-600 {
    --bg-opacity: 1;
    background-color: #4b5563;
    background-color: rgba(75, 85, 99, var(--bg-opacity));
  }
  .group:focus .md\\:group-focus\\:bg-gray-700 {
    --bg-opacity: 1;
    background-color: #374151;
    background-color: rgba(55, 65, 81, var(--bg-opacity));
  }
  .group:focus .md\\:group-focus\\:bg-gray-800 {
    --bg-opacity: 1;
    background-color: #252f3f;
    background-color: rgba(37, 47, 63, var(--bg-opacity));
  }
  .group:focus .md\\:group-focus\\:bg-gray-900 {
    --bg-opacity: 1;
    background-color: #161e2e;
    background-color: rgba(22, 30, 46, var(--bg-opacity));
  }
  .group:focus .md\\:group-focus\\:bg-red-50 {
    --bg-opacity: 1;
    background-color: #fdf2f2;
    background-color: rgba(253, 242, 242, var(--bg-opacity));
  }
  .group:focus .md\\:group-focus\\:bg-red-100 {
    --bg-opacity: 1;
    background-color: #fde8e8;
    background-color: rgba(253, 232, 232, var(--bg-opacity));
  }
  .group:focus .md\\:group-focus\\:bg-red-200 {
    --bg-opacity: 1;
    background-color: #fbd5d5;
    background-color: rgba(251, 213, 213, var(--bg-opacity));
  }
  .group:focus .md\\:group-focus\\:bg-red-300 {
    --bg-opacity: 1;
    background-color: #f8b4b4;
    background-color: rgba(248, 180, 180, var(--bg-opacity));
  }
  .group:focus .md\\:group-focus\\:bg-red-400 {
    --bg-opacity: 1;
    background-color: #f98080;
    background-color: rgba(249, 128, 128, var(--bg-opacity));
  }
  .group:focus .md\\:group-focus\\:bg-red-500 {
    --bg-opacity: 1;
    background-color: #f05252;
    background-color: rgba(240, 82, 82, var(--bg-opacity));
  }
  .group:focus .md\\:group-focus\\:bg-red-600 {
    --bg-opacity: 1;
    background-color: #e02424;
    background-color: rgba(224, 36, 36, var(--bg-opacity));
  }
  .group:focus .md\\:group-focus\\:bg-red-700 {
    --bg-opacity: 1;
    background-color: #c81e1e;
    background-color: rgba(200, 30, 30, var(--bg-opacity));
  }
  .group:focus .md\\:group-focus\\:bg-red-800 {
    --bg-opacity: 1;
    background-color: #9b1c1c;
    background-color: rgba(155, 28, 28, var(--bg-opacity));
  }
  .group:focus .md\\:group-focus\\:bg-red-900 {
    --bg-opacity: 1;
    background-color: #771d1d;
    background-color: rgba(119, 29, 29, var(--bg-opacity));
  }
  .group:focus .md\\:group-focus\\:bg-orange-50 {
    --bg-opacity: 1;
    background-color: #fff8f1;
    background-color: rgba(255, 248, 241, var(--bg-opacity));
  }
  .group:focus .md\\:group-focus\\:bg-orange-100 {
    --bg-opacity: 1;
    background-color: #feecdc;
    background-color: rgba(254, 236, 220, var(--bg-opacity));
  }
  .group:focus .md\\:group-focus\\:bg-orange-200 {
    --bg-opacity: 1;
    background-color: #fcd9bd;
    background-color: rgba(252, 217, 189, var(--bg-opacity));
  }
  .group:focus .md\\:group-focus\\:bg-orange-300 {
    --bg-opacity: 1;
    background-color: #fdba8c;
    background-color: rgba(253, 186, 140, var(--bg-opacity));
  }
  .group:focus .md\\:group-focus\\:bg-orange-400 {
    --bg-opacity: 1;
    background-color: #ff8a4c;
    background-color: rgba(255, 138, 76, var(--bg-opacity));
  }
  .group:focus .md\\:group-focus\\:bg-orange-500 {
    --bg-opacity: 1;
    background-color: #ff5a1f;
    background-color: rgba(255, 90, 31, var(--bg-opacity));
  }
  .group:focus .md\\:group-focus\\:bg-orange-600 {
    --bg-opacity: 1;
    background-color: #d03801;
    background-color: rgba(208, 56, 1, var(--bg-opacity));
  }
  .group:focus .md\\:group-focus\\:bg-orange-700 {
    --bg-opacity: 1;
    background-color: #b43403;
    background-color: rgba(180, 52, 3, var(--bg-opacity));
  }
  .group:focus .md\\:group-focus\\:bg-orange-800 {
    --bg-opacity: 1;
    background-color: #8a2c0d;
    background-color: rgba(138, 44, 13, var(--bg-opacity));
  }
  .group:focus .md\\:group-focus\\:bg-orange-900 {
    --bg-opacity: 1;
    background-color: #73230d;
    background-color: rgba(115, 35, 13, var(--bg-opacity));
  }
  .group:focus .md\\:group-focus\\:bg-yellow-50 {
    --bg-opacity: 1;
    background-color: #fdfdea;
    background-color: rgba(253, 253, 234, var(--bg-opacity));
  }
  .group:focus .md\\:group-focus\\:bg-yellow-100 {
    --bg-opacity: 1;
    background-color: #fdf6b2;
    background-color: rgba(253, 246, 178, var(--bg-opacity));
  }
  .group:focus .md\\:group-focus\\:bg-yellow-200 {
    --bg-opacity: 1;
    background-color: #fce96a;
    background-color: rgba(252, 233, 106, var(--bg-opacity));
  }
  .group:focus .md\\:group-focus\\:bg-yellow-300 {
    --bg-opacity: 1;
    background-color: #faca15;
    background-color: rgba(250, 202, 21, var(--bg-opacity));
  }
  .group:focus .md\\:group-focus\\:bg-yellow-400 {
    --bg-opacity: 1;
    background-color: #e3a008;
    background-color: rgba(227, 160, 8, var(--bg-opacity));
  }
  .group:focus .md\\:group-focus\\:bg-yellow-500 {
    --bg-opacity: 1;
    background-color: #c27803;
    background-color: rgba(194, 120, 3, var(--bg-opacity));
  }
  .group:focus .md\\:group-focus\\:bg-yellow-600 {
    --bg-opacity: 1;
    background-color: #9f580a;
    background-color: rgba(159, 88, 10, var(--bg-opacity));
  }
  .group:focus .md\\:group-focus\\:bg-yellow-700 {
    --bg-opacity: 1;
    background-color: #8e4b10;
    background-color: rgba(142, 75, 16, var(--bg-opacity));
  }
  .group:focus .md\\:group-focus\\:bg-yellow-800 {
    --bg-opacity: 1;
    background-color: #723b13;
    background-color: rgba(114, 59, 19, var(--bg-opacity));
  }
  .group:focus .md\\:group-focus\\:bg-yellow-900 {
    --bg-opacity: 1;
    background-color: #633112;
    background-color: rgba(99, 49, 18, var(--bg-opacity));
  }
  .group:focus .md\\:group-focus\\:bg-green-50 {
    --bg-opacity: 1;
    background-color: #f3faf7;
    background-color: rgba(243, 250, 247, var(--bg-opacity));
  }
  .group:focus .md\\:group-focus\\:bg-green-100 {
    --bg-opacity: 1;
    background-color: #def7ec;
    background-color: rgba(222, 247, 236, var(--bg-opacity));
  }
  .group:focus .md\\:group-focus\\:bg-green-200 {
    --bg-opacity: 1;
    background-color: #bcf0da;
    background-color: rgba(188, 240, 218, var(--bg-opacity));
  }
  .group:focus .md\\:group-focus\\:bg-green-300 {
    --bg-opacity: 1;
    background-color: #84e1bc;
    background-color: rgba(132, 225, 188, var(--bg-opacity));
  }
  .group:focus .md\\:group-focus\\:bg-green-400 {
    --bg-opacity: 1;
    background-color: #31c48d;
    background-color: rgba(49, 196, 141, var(--bg-opacity));
  }
  .group:focus .md\\:group-focus\\:bg-green-500 {
    --bg-opacity: 1;
    background-color: #0e9f6e;
    background-color: rgba(14, 159, 110, var(--bg-opacity));
  }
  .group:focus .md\\:group-focus\\:bg-green-600 {
    --bg-opacity: 1;
    background-color: #057a55;
    background-color: rgba(5, 122, 85, var(--bg-opacity));
  }
  .group:focus .md\\:group-focus\\:bg-green-700 {
    --bg-opacity: 1;
    background-color: #046c4e;
    background-color: rgba(4, 108, 78, var(--bg-opacity));
  }
  .group:focus .md\\:group-focus\\:bg-green-800 {
    --bg-opacity: 1;
    background-color: #03543f;
    background-color: rgba(3, 84, 63, var(--bg-opacity));
  }
  .group:focus .md\\:group-focus\\:bg-green-900 {
    --bg-opacity: 1;
    background-color: #014737;
    background-color: rgba(1, 71, 55, var(--bg-opacity));
  }
  .group:focus .md\\:group-focus\\:bg-teal-50 {
    --bg-opacity: 1;
    background-color: #edfafa;
    background-color: rgba(237, 250, 250, var(--bg-opacity));
  }
  .group:focus .md\\:group-focus\\:bg-teal-100 {
    --bg-opacity: 1;
    background-color: #d5f5f6;
    background-color: rgba(213, 245, 246, var(--bg-opacity));
  }
  .group:focus .md\\:group-focus\\:bg-teal-200 {
    --bg-opacity: 1;
    background-color: #afecef;
    background-color: rgba(175, 236, 239, var(--bg-opacity));
  }
  .group:focus .md\\:group-focus\\:bg-teal-300 {
    --bg-opacity: 1;
    background-color: #7edce2;
    background-color: rgba(126, 220, 226, var(--bg-opacity));
  }
  .group:focus .md\\:group-focus\\:bg-teal-400 {
    --bg-opacity: 1;
    background-color: #16bdca;
    background-color: rgba(22, 189, 202, var(--bg-opacity));
  }
  .group:focus .md\\:group-focus\\:bg-teal-500 {
    --bg-opacity: 1;
    background-color: #0694a2;
    background-color: rgba(6, 148, 162, var(--bg-opacity));
  }
  .group:focus .md\\:group-focus\\:bg-teal-600 {
    --bg-opacity: 1;
    background-color: #047481;
    background-color: rgba(4, 116, 129, var(--bg-opacity));
  }
  .group:focus .md\\:group-focus\\:bg-teal-700 {
    --bg-opacity: 1;
    background-color: #036672;
    background-color: rgba(3, 102, 114, var(--bg-opacity));
  }
  .group:focus .md\\:group-focus\\:bg-teal-800 {
    --bg-opacity: 1;
    background-color: #05505c;
    background-color: rgba(5, 80, 92, var(--bg-opacity));
  }
  .group:focus .md\\:group-focus\\:bg-teal-900 {
    --bg-opacity: 1;
    background-color: #014451;
    background-color: rgba(1, 68, 81, var(--bg-opacity));
  }
  .group:focus .md\\:group-focus\\:bg-blue-50 {
    --bg-opacity: 1;
    background-color: #ebf5ff;
    background-color: rgba(235, 245, 255, var(--bg-opacity));
  }
  .group:focus .md\\:group-focus\\:bg-blue-100 {
    --bg-opacity: 1;
    background-color: #e1effe;
    background-color: rgba(225, 239, 254, var(--bg-opacity));
  }
  .group:focus .md\\:group-focus\\:bg-blue-200 {
    --bg-opacity: 1;
    background-color: #c3ddfd;
    background-color: rgba(195, 221, 253, var(--bg-opacity));
  }
  .group:focus .md\\:group-focus\\:bg-blue-300 {
    --bg-opacity: 1;
    background-color: #a4cafe;
    background-color: rgba(164, 202, 254, var(--bg-opacity));
  }
  .group:focus .md\\:group-focus\\:bg-blue-400 {
    --bg-opacity: 1;
    background-color: #76a9fa;
    background-color: rgba(118, 169, 250, var(--bg-opacity));
  }
  .group:focus .md\\:group-focus\\:bg-blue-500 {
    --bg-opacity: 1;
    background-color: #3f83f8;
    background-color: rgba(63, 131, 248, var(--bg-opacity));
  }
  .group:focus .md\\:group-focus\\:bg-blue-600 {
    --bg-opacity: 1;
    background-color: #1c64f2;
    background-color: rgba(28, 100, 242, var(--bg-opacity));
  }
  .group:focus .md\\:group-focus\\:bg-blue-700 {
    --bg-opacity: 1;
    background-color: #1a56db;
    background-color: rgba(26, 86, 219, var(--bg-opacity));
  }
  .group:focus .md\\:group-focus\\:bg-blue-800 {
    --bg-opacity: 1;
    background-color: #1e429f;
    background-color: rgba(30, 66, 159, var(--bg-opacity));
  }
  .group:focus .md\\:group-focus\\:bg-blue-900 {
    --bg-opacity: 1;
    background-color: #233876;
    background-color: rgba(35, 56, 118, var(--bg-opacity));
  }
  .group:focus .md\\:group-focus\\:bg-indigo-50 {
    --bg-opacity: 1;
    background-color: #f0f5ff;
    background-color: rgba(240, 245, 255, var(--bg-opacity));
  }
  .group:focus .md\\:group-focus\\:bg-indigo-100 {
    --bg-opacity: 1;
    background-color: #e5edff;
    background-color: rgba(229, 237, 255, var(--bg-opacity));
  }
  .group:focus .md\\:group-focus\\:bg-indigo-200 {
    --bg-opacity: 1;
    background-color: #cddbfe;
    background-color: rgba(205, 219, 254, var(--bg-opacity));
  }
  .group:focus .md\\:group-focus\\:bg-indigo-300 {
    --bg-opacity: 1;
    background-color: #b4c6fc;
    background-color: rgba(180, 198, 252, var(--bg-opacity));
  }
  .group:focus .md\\:group-focus\\:bg-indigo-400 {
    --bg-opacity: 1;
    background-color: #8da2fb;
    background-color: rgba(141, 162, 251, var(--bg-opacity));
  }
  .group:focus .md\\:group-focus\\:bg-indigo-500 {
    --bg-opacity: 1;
    background-color: #6875f5;
    background-color: rgba(104, 117, 245, var(--bg-opacity));
  }
  .group:focus .md\\:group-focus\\:bg-indigo-600 {
    --bg-opacity: 1;
    background-color: #5850ec;
    background-color: rgba(88, 80, 236, var(--bg-opacity));
  }
  .group:focus .md\\:group-focus\\:bg-indigo-700 {
    --bg-opacity: 1;
    background-color: #5145cd;
    background-color: rgba(81, 69, 205, var(--bg-opacity));
  }
  .group:focus .md\\:group-focus\\:bg-indigo-800 {
    --bg-opacity: 1;
    background-color: #42389d;
    background-color: rgba(66, 56, 157, var(--bg-opacity));
  }
  .group:focus .md\\:group-focus\\:bg-indigo-900 {
    --bg-opacity: 1;
    background-color: #362f78;
    background-color: rgba(54, 47, 120, var(--bg-opacity));
  }
  .group:focus .md\\:group-focus\\:bg-purple-50 {
    --bg-opacity: 1;
    background-color: #f6f5ff;
    background-color: rgba(246, 245, 255, var(--bg-opacity));
  }
  .group:focus .md\\:group-focus\\:bg-purple-100 {
    --bg-opacity: 1;
    background-color: #edebfe;
    background-color: rgba(237, 235, 254, var(--bg-opacity));
  }
  .group:focus .md\\:group-focus\\:bg-purple-200 {
    --bg-opacity: 1;
    background-color: #dcd7fe;
    background-color: rgba(220, 215, 254, var(--bg-opacity));
  }
  .group:focus .md\\:group-focus\\:bg-purple-300 {
    --bg-opacity: 1;
    background-color: #cabffd;
    background-color: rgba(202, 191, 253, var(--bg-opacity));
  }
  .group:focus .md\\:group-focus\\:bg-purple-400 {
    --bg-opacity: 1;
    background-color: #ac94fa;
    background-color: rgba(172, 148, 250, var(--bg-opacity));
  }
  .group:focus .md\\:group-focus\\:bg-purple-500 {
    --bg-opacity: 1;
    background-color: #9061f9;
    background-color: rgba(144, 97, 249, var(--bg-opacity));
  }
  .group:focus .md\\:group-focus\\:bg-purple-600 {
    --bg-opacity: 1;
    background-color: #7e3af2;
    background-color: rgba(126, 58, 242, var(--bg-opacity));
  }
  .group:focus .md\\:group-focus\\:bg-purple-700 {
    --bg-opacity: 1;
    background-color: #6c2bd9;
    background-color: rgba(108, 43, 217, var(--bg-opacity));
  }
  .group:focus .md\\:group-focus\\:bg-purple-800 {
    --bg-opacity: 1;
    background-color: #5521b5;
    background-color: rgba(85, 33, 181, var(--bg-opacity));
  }
  .group:focus .md\\:group-focus\\:bg-purple-900 {
    --bg-opacity: 1;
    background-color: #4a1d96;
    background-color: rgba(74, 29, 150, var(--bg-opacity));
  }
  .group:focus .md\\:group-focus\\:bg-pink-50 {
    --bg-opacity: 1;
    background-color: #fdf2f8;
    background-color: rgba(253, 242, 248, var(--bg-opacity));
  }
  .group:focus .md\\:group-focus\\:bg-pink-100 {
    --bg-opacity: 1;
    background-color: #fce8f3;
    background-color: rgba(252, 232, 243, var(--bg-opacity));
  }
  .group:focus .md\\:group-focus\\:bg-pink-200 {
    --bg-opacity: 1;
    background-color: #fad1e8;
    background-color: rgba(250, 209, 232, var(--bg-opacity));
  }
  .group:focus .md\\:group-focus\\:bg-pink-300 {
    --bg-opacity: 1;
    background-color: #f8b4d9;
    background-color: rgba(248, 180, 217, var(--bg-opacity));
  }
  .group:focus .md\\:group-focus\\:bg-pink-400 {
    --bg-opacity: 1;
    background-color: #f17eb8;
    background-color: rgba(241, 126, 184, var(--bg-opacity));
  }
  .group:focus .md\\:group-focus\\:bg-pink-500 {
    --bg-opacity: 1;
    background-color: #e74694;
    background-color: rgba(231, 70, 148, var(--bg-opacity));
  }
  .group:focus .md\\:group-focus\\:bg-pink-600 {
    --bg-opacity: 1;
    background-color: #d61f69;
    background-color: rgba(214, 31, 105, var(--bg-opacity));
  }
  .group:focus .md\\:group-focus\\:bg-pink-700 {
    --bg-opacity: 1;
    background-color: #bf125d;
    background-color: rgba(191, 18, 93, var(--bg-opacity));
  }
  .group:focus .md\\:group-focus\\:bg-pink-800 {
    --bg-opacity: 1;
    background-color: #99154b;
    background-color: rgba(153, 21, 75, var(--bg-opacity));
  }
  .group:focus .md\\:group-focus\\:bg-pink-900 {
    --bg-opacity: 1;
    background-color: #751a3d;
    background-color: rgba(117, 26, 61, var(--bg-opacity));
  }
  .group:focus .md\\:group-focus\\:bg-cool-gray-50 {
    --bg-opacity: 1;
    background-color: #f8fafc;
    background-color: rgba(248, 250, 252, var(--bg-opacity));
  }
  .group:focus .md\\:group-focus\\:bg-cool-gray-100 {
    --bg-opacity: 1;
    background-color: #f1f5f9;
    background-color: rgba(241, 245, 249, var(--bg-opacity));
  }
  .group:focus .md\\:group-focus\\:bg-cool-gray-200 {
    --bg-opacity: 1;
    background-color: #e2e8f0;
    background-color: rgba(226, 232, 240, var(--bg-opacity));
  }
  .group:focus .md\\:group-focus\\:bg-cool-gray-300 {
    --bg-opacity: 1;
    background-color: #cfd8e3;
    background-color: rgba(207, 216, 227, var(--bg-opacity));
  }
  .group:focus .md\\:group-focus\\:bg-cool-gray-400 {
    --bg-opacity: 1;
    background-color: #97a6ba;
    background-color: rgba(151, 166, 186, var(--bg-opacity));
  }
  .group:focus .md\\:group-focus\\:bg-cool-gray-500 {
    --bg-opacity: 1;
    background-color: #64748b;
    background-color: rgba(100, 116, 139, var(--bg-opacity));
  }
  .group:focus .md\\:group-focus\\:bg-cool-gray-600 {
    --bg-opacity: 1;
    background-color: #475569;
    background-color: rgba(71, 85, 105, var(--bg-opacity));
  }
  .group:focus .md\\:group-focus\\:bg-cool-gray-700 {
    --bg-opacity: 1;
    background-color: #364152;
    background-color: rgba(54, 65, 82, var(--bg-opacity));
  }
  .group:focus .md\\:group-focus\\:bg-cool-gray-800 {
    --bg-opacity: 1;
    background-color: #27303f;
    background-color: rgba(39, 48, 63, var(--bg-opacity));
  }
  .group:focus .md\\:group-focus\\:bg-cool-gray-900 {
    --bg-opacity: 1;
    background-color: #1a202e;
    background-color: rgba(26, 32, 46, var(--bg-opacity));
  }
  .md\\:hover\\:bg-current:hover {
    background-color: currentColor;
  }
  .md\\:hover\\:bg-transparent:hover {
    background-color: transparent;
  }
  .md\\:hover\\:bg-white:hover {
    --bg-opacity: 1;
    background-color: #ffffff;
    background-color: rgba(255, 255, 255, var(--bg-opacity));
  }
  .md\\:hover\\:bg-black:hover {
    --bg-opacity: 1;
    background-color: #000000;
    background-color: rgba(0, 0, 0, var(--bg-opacity));
  }
  .md\\:hover\\:bg-gray-50:hover {
    --bg-opacity: 1;
    background-color: #f9fafb;
    background-color: rgba(249, 250, 251, var(--bg-opacity));
  }
  .md\\:hover\\:bg-gray-100:hover {
    --bg-opacity: 1;
    background-color: #f4f5f7;
    background-color: rgba(244, 245, 247, var(--bg-opacity));
  }
  .md\\:hover\\:bg-gray-200:hover {
    --bg-opacity: 1;
    background-color: #e5e7eb;
    background-color: rgba(229, 231, 235, var(--bg-opacity));
  }
  .md\\:hover\\:bg-gray-300:hover {
    --bg-opacity: 1;
    background-color: #d2d6dc;
    background-color: rgba(210, 214, 220, var(--bg-opacity));
  }
  .md\\:hover\\:bg-gray-400:hover {
    --bg-opacity: 1;
    background-color: #9fa6b2;
    background-color: rgba(159, 166, 178, var(--bg-opacity));
  }
  .md\\:hover\\:bg-gray-500:hover {
    --bg-opacity: 1;
    background-color: #6b7280;
    background-color: rgba(107, 114, 128, var(--bg-opacity));
  }
  .md\\:hover\\:bg-gray-600:hover {
    --bg-opacity: 1;
    background-color: #4b5563;
    background-color: rgba(75, 85, 99, var(--bg-opacity));
  }
  .md\\:hover\\:bg-gray-700:hover {
    --bg-opacity: 1;
    background-color: #374151;
    background-color: rgba(55, 65, 81, var(--bg-opacity));
  }
  .md\\:hover\\:bg-gray-800:hover {
    --bg-opacity: 1;
    background-color: #252f3f;
    background-color: rgba(37, 47, 63, var(--bg-opacity));
  }
  .md\\:hover\\:bg-gray-900:hover {
    --bg-opacity: 1;
    background-color: #161e2e;
    background-color: rgba(22, 30, 46, var(--bg-opacity));
  }
  .md\\:hover\\:bg-red-50:hover {
    --bg-opacity: 1;
    background-color: #fdf2f2;
    background-color: rgba(253, 242, 242, var(--bg-opacity));
  }
  .md\\:hover\\:bg-red-100:hover {
    --bg-opacity: 1;
    background-color: #fde8e8;
    background-color: rgba(253, 232, 232, var(--bg-opacity));
  }
  .md\\:hover\\:bg-red-200:hover {
    --bg-opacity: 1;
    background-color: #fbd5d5;
    background-color: rgba(251, 213, 213, var(--bg-opacity));
  }
  .md\\:hover\\:bg-red-300:hover {
    --bg-opacity: 1;
    background-color: #f8b4b4;
    background-color: rgba(248, 180, 180, var(--bg-opacity));
  }
  .md\\:hover\\:bg-red-400:hover {
    --bg-opacity: 1;
    background-color: #f98080;
    background-color: rgba(249, 128, 128, var(--bg-opacity));
  }
  .md\\:hover\\:bg-red-500:hover {
    --bg-opacity: 1;
    background-color: #f05252;
    background-color: rgba(240, 82, 82, var(--bg-opacity));
  }
  .md\\:hover\\:bg-red-600:hover {
    --bg-opacity: 1;
    background-color: #e02424;
    background-color: rgba(224, 36, 36, var(--bg-opacity));
  }
  .md\\:hover\\:bg-red-700:hover {
    --bg-opacity: 1;
    background-color: #c81e1e;
    background-color: rgba(200, 30, 30, var(--bg-opacity));
  }
  .md\\:hover\\:bg-red-800:hover {
    --bg-opacity: 1;
    background-color: #9b1c1c;
    background-color: rgba(155, 28, 28, var(--bg-opacity));
  }
  .md\\:hover\\:bg-red-900:hover {
    --bg-opacity: 1;
    background-color: #771d1d;
    background-color: rgba(119, 29, 29, var(--bg-opacity));
  }
  .md\\:hover\\:bg-orange-50:hover {
    --bg-opacity: 1;
    background-color: #fff8f1;
    background-color: rgba(255, 248, 241, var(--bg-opacity));
  }
  .md\\:hover\\:bg-orange-100:hover {
    --bg-opacity: 1;
    background-color: #feecdc;
    background-color: rgba(254, 236, 220, var(--bg-opacity));
  }
  .md\\:hover\\:bg-orange-200:hover {
    --bg-opacity: 1;
    background-color: #fcd9bd;
    background-color: rgba(252, 217, 189, var(--bg-opacity));
  }
  .md\\:hover\\:bg-orange-300:hover {
    --bg-opacity: 1;
    background-color: #fdba8c;
    background-color: rgba(253, 186, 140, var(--bg-opacity));
  }
  .md\\:hover\\:bg-orange-400:hover {
    --bg-opacity: 1;
    background-color: #ff8a4c;
    background-color: rgba(255, 138, 76, var(--bg-opacity));
  }
  .md\\:hover\\:bg-orange-500:hover {
    --bg-opacity: 1;
    background-color: #ff5a1f;
    background-color: rgba(255, 90, 31, var(--bg-opacity));
  }
  .md\\:hover\\:bg-orange-600:hover {
    --bg-opacity: 1;
    background-color: #d03801;
    background-color: rgba(208, 56, 1, var(--bg-opacity));
  }
  .md\\:hover\\:bg-orange-700:hover {
    --bg-opacity: 1;
    background-color: #b43403;
    background-color: rgba(180, 52, 3, var(--bg-opacity));
  }
  .md\\:hover\\:bg-orange-800:hover {
    --bg-opacity: 1;
    background-color: #8a2c0d;
    background-color: rgba(138, 44, 13, var(--bg-opacity));
  }
  .md\\:hover\\:bg-orange-900:hover {
    --bg-opacity: 1;
    background-color: #73230d;
    background-color: rgba(115, 35, 13, var(--bg-opacity));
  }
  .md\\:hover\\:bg-yellow-50:hover {
    --bg-opacity: 1;
    background-color: #fdfdea;
    background-color: rgba(253, 253, 234, var(--bg-opacity));
  }
  .md\\:hover\\:bg-yellow-100:hover {
    --bg-opacity: 1;
    background-color: #fdf6b2;
    background-color: rgba(253, 246, 178, var(--bg-opacity));
  }
  .md\\:hover\\:bg-yellow-200:hover {
    --bg-opacity: 1;
    background-color: #fce96a;
    background-color: rgba(252, 233, 106, var(--bg-opacity));
  }
  .md\\:hover\\:bg-yellow-300:hover {
    --bg-opacity: 1;
    background-color: #faca15;
    background-color: rgba(250, 202, 21, var(--bg-opacity));
  }
  .md\\:hover\\:bg-yellow-400:hover {
    --bg-opacity: 1;
    background-color: #e3a008;
    background-color: rgba(227, 160, 8, var(--bg-opacity));
  }
  .md\\:hover\\:bg-yellow-500:hover {
    --bg-opacity: 1;
    background-color: #c27803;
    background-color: rgba(194, 120, 3, var(--bg-opacity));
  }
  .md\\:hover\\:bg-yellow-600:hover {
    --bg-opacity: 1;
    background-color: #9f580a;
    background-color: rgba(159, 88, 10, var(--bg-opacity));
  }
  .md\\:hover\\:bg-yellow-700:hover {
    --bg-opacity: 1;
    background-color: #8e4b10;
    background-color: rgba(142, 75, 16, var(--bg-opacity));
  }
  .md\\:hover\\:bg-yellow-800:hover {
    --bg-opacity: 1;
    background-color: #723b13;
    background-color: rgba(114, 59, 19, var(--bg-opacity));
  }
  .md\\:hover\\:bg-yellow-900:hover {
    --bg-opacity: 1;
    background-color: #633112;
    background-color: rgba(99, 49, 18, var(--bg-opacity));
  }
  .md\\:hover\\:bg-green-50:hover {
    --bg-opacity: 1;
    background-color: #f3faf7;
    background-color: rgba(243, 250, 247, var(--bg-opacity));
  }
  .md\\:hover\\:bg-green-100:hover {
    --bg-opacity: 1;
    background-color: #def7ec;
    background-color: rgba(222, 247, 236, var(--bg-opacity));
  }
  .md\\:hover\\:bg-green-200:hover {
    --bg-opacity: 1;
    background-color: #bcf0da;
    background-color: rgba(188, 240, 218, var(--bg-opacity));
  }
  .md\\:hover\\:bg-green-300:hover {
    --bg-opacity: 1;
    background-color: #84e1bc;
    background-color: rgba(132, 225, 188, var(--bg-opacity));
  }
  .md\\:hover\\:bg-green-400:hover {
    --bg-opacity: 1;
    background-color: #31c48d;
    background-color: rgba(49, 196, 141, var(--bg-opacity));
  }
  .md\\:hover\\:bg-green-500:hover {
    --bg-opacity: 1;
    background-color: #0e9f6e;
    background-color: rgba(14, 159, 110, var(--bg-opacity));
  }
  .md\\:hover\\:bg-green-600:hover {
    --bg-opacity: 1;
    background-color: #057a55;
    background-color: rgba(5, 122, 85, var(--bg-opacity));
  }
  .md\\:hover\\:bg-green-700:hover {
    --bg-opacity: 1;
    background-color: #046c4e;
    background-color: rgba(4, 108, 78, var(--bg-opacity));
  }
  .md\\:hover\\:bg-green-800:hover {
    --bg-opacity: 1;
    background-color: #03543f;
    background-color: rgba(3, 84, 63, var(--bg-opacity));
  }
  .md\\:hover\\:bg-green-900:hover {
    --bg-opacity: 1;
    background-color: #014737;
    background-color: rgba(1, 71, 55, var(--bg-opacity));
  }
  .md\\:hover\\:bg-teal-50:hover {
    --bg-opacity: 1;
    background-color: #edfafa;
    background-color: rgba(237, 250, 250, var(--bg-opacity));
  }
  .md\\:hover\\:bg-teal-100:hover {
    --bg-opacity: 1;
    background-color: #d5f5f6;
    background-color: rgba(213, 245, 246, var(--bg-opacity));
  }
  .md\\:hover\\:bg-teal-200:hover {
    --bg-opacity: 1;
    background-color: #afecef;
    background-color: rgba(175, 236, 239, var(--bg-opacity));
  }
  .md\\:hover\\:bg-teal-300:hover {
    --bg-opacity: 1;
    background-color: #7edce2;
    background-color: rgba(126, 220, 226, var(--bg-opacity));
  }
  .md\\:hover\\:bg-teal-400:hover {
    --bg-opacity: 1;
    background-color: #16bdca;
    background-color: rgba(22, 189, 202, var(--bg-opacity));
  }
  .md\\:hover\\:bg-teal-500:hover {
    --bg-opacity: 1;
    background-color: #0694a2;
    background-color: rgba(6, 148, 162, var(--bg-opacity));
  }
  .md\\:hover\\:bg-teal-600:hover {
    --bg-opacity: 1;
    background-color: #047481;
    background-color: rgba(4, 116, 129, var(--bg-opacity));
  }
  .md\\:hover\\:bg-teal-700:hover {
    --bg-opacity: 1;
    background-color: #036672;
    background-color: rgba(3, 102, 114, var(--bg-opacity));
  }
  .md\\:hover\\:bg-teal-800:hover {
    --bg-opacity: 1;
    background-color: #05505c;
    background-color: rgba(5, 80, 92, var(--bg-opacity));
  }
  .md\\:hover\\:bg-teal-900:hover {
    --bg-opacity: 1;
    background-color: #014451;
    background-color: rgba(1, 68, 81, var(--bg-opacity));
  }
  .md\\:hover\\:bg-blue-50:hover {
    --bg-opacity: 1;
    background-color: #ebf5ff;
    background-color: rgba(235, 245, 255, var(--bg-opacity));
  }
  .md\\:hover\\:bg-blue-100:hover {
    --bg-opacity: 1;
    background-color: #e1effe;
    background-color: rgba(225, 239, 254, var(--bg-opacity));
  }
  .md\\:hover\\:bg-blue-200:hover {
    --bg-opacity: 1;
    background-color: #c3ddfd;
    background-color: rgba(195, 221, 253, var(--bg-opacity));
  }
  .md\\:hover\\:bg-blue-300:hover {
    --bg-opacity: 1;
    background-color: #a4cafe;
    background-color: rgba(164, 202, 254, var(--bg-opacity));
  }
  .md\\:hover\\:bg-blue-400:hover {
    --bg-opacity: 1;
    background-color: #76a9fa;
    background-color: rgba(118, 169, 250, var(--bg-opacity));
  }
  .md\\:hover\\:bg-blue-500:hover {
    --bg-opacity: 1;
    background-color: #3f83f8;
    background-color: rgba(63, 131, 248, var(--bg-opacity));
  }
  .md\\:hover\\:bg-blue-600:hover {
    --bg-opacity: 1;
    background-color: #1c64f2;
    background-color: rgba(28, 100, 242, var(--bg-opacity));
  }
  .md\\:hover\\:bg-blue-700:hover {
    --bg-opacity: 1;
    background-color: #1a56db;
    background-color: rgba(26, 86, 219, var(--bg-opacity));
  }
  .md\\:hover\\:bg-blue-800:hover {
    --bg-opacity: 1;
    background-color: #1e429f;
    background-color: rgba(30, 66, 159, var(--bg-opacity));
  }
  .md\\:hover\\:bg-blue-900:hover {
    --bg-opacity: 1;
    background-color: #233876;
    background-color: rgba(35, 56, 118, var(--bg-opacity));
  }
  .md\\:hover\\:bg-indigo-50:hover {
    --bg-opacity: 1;
    background-color: #f0f5ff;
    background-color: rgba(240, 245, 255, var(--bg-opacity));
  }
  .md\\:hover\\:bg-indigo-100:hover {
    --bg-opacity: 1;
    background-color: #e5edff;
    background-color: rgba(229, 237, 255, var(--bg-opacity));
  }
  .md\\:hover\\:bg-indigo-200:hover {
    --bg-opacity: 1;
    background-color: #cddbfe;
    background-color: rgba(205, 219, 254, var(--bg-opacity));
  }
  .md\\:hover\\:bg-indigo-300:hover {
    --bg-opacity: 1;
    background-color: #b4c6fc;
    background-color: rgba(180, 198, 252, var(--bg-opacity));
  }
  .md\\:hover\\:bg-indigo-400:hover {
    --bg-opacity: 1;
    background-color: #8da2fb;
    background-color: rgba(141, 162, 251, var(--bg-opacity));
  }
  .md\\:hover\\:bg-indigo-500:hover {
    --bg-opacity: 1;
    background-color: #6875f5;
    background-color: rgba(104, 117, 245, var(--bg-opacity));
  }
  .md\\:hover\\:bg-indigo-600:hover {
    --bg-opacity: 1;
    background-color: #5850ec;
    background-color: rgba(88, 80, 236, var(--bg-opacity));
  }
  .md\\:hover\\:bg-indigo-700:hover {
    --bg-opacity: 1;
    background-color: #5145cd;
    background-color: rgba(81, 69, 205, var(--bg-opacity));
  }
  .md\\:hover\\:bg-indigo-800:hover {
    --bg-opacity: 1;
    background-color: #42389d;
    background-color: rgba(66, 56, 157, var(--bg-opacity));
  }
  .md\\:hover\\:bg-indigo-900:hover {
    --bg-opacity: 1;
    background-color: #362f78;
    background-color: rgba(54, 47, 120, var(--bg-opacity));
  }
  .md\\:hover\\:bg-purple-50:hover {
    --bg-opacity: 1;
    background-color: #f6f5ff;
    background-color: rgba(246, 245, 255, var(--bg-opacity));
  }
  .md\\:hover\\:bg-purple-100:hover {
    --bg-opacity: 1;
    background-color: #edebfe;
    background-color: rgba(237, 235, 254, var(--bg-opacity));
  }
  .md\\:hover\\:bg-purple-200:hover {
    --bg-opacity: 1;
    background-color: #dcd7fe;
    background-color: rgba(220, 215, 254, var(--bg-opacity));
  }
  .md\\:hover\\:bg-purple-300:hover {
    --bg-opacity: 1;
    background-color: #cabffd;
    background-color: rgba(202, 191, 253, var(--bg-opacity));
  }
  .md\\:hover\\:bg-purple-400:hover {
    --bg-opacity: 1;
    background-color: #ac94fa;
    background-color: rgba(172, 148, 250, var(--bg-opacity));
  }
  .md\\:hover\\:bg-purple-500:hover {
    --bg-opacity: 1;
    background-color: #9061f9;
    background-color: rgba(144, 97, 249, var(--bg-opacity));
  }
  .md\\:hover\\:bg-purple-600:hover {
    --bg-opacity: 1;
    background-color: #7e3af2;
    background-color: rgba(126, 58, 242, var(--bg-opacity));
  }
  .md\\:hover\\:bg-purple-700:hover {
    --bg-opacity: 1;
    background-color: #6c2bd9;
    background-color: rgba(108, 43, 217, var(--bg-opacity));
  }
  .md\\:hover\\:bg-purple-800:hover {
    --bg-opacity: 1;
    background-color: #5521b5;
    background-color: rgba(85, 33, 181, var(--bg-opacity));
  }
  .md\\:hover\\:bg-purple-900:hover {
    --bg-opacity: 1;
    background-color: #4a1d96;
    background-color: rgba(74, 29, 150, var(--bg-opacity));
  }
  .md\\:hover\\:bg-pink-50:hover {
    --bg-opacity: 1;
    background-color: #fdf2f8;
    background-color: rgba(253, 242, 248, var(--bg-opacity));
  }
  .md\\:hover\\:bg-pink-100:hover {
    --bg-opacity: 1;
    background-color: #fce8f3;
    background-color: rgba(252, 232, 243, var(--bg-opacity));
  }
  .md\\:hover\\:bg-pink-200:hover {
    --bg-opacity: 1;
    background-color: #fad1e8;
    background-color: rgba(250, 209, 232, var(--bg-opacity));
  }
  .md\\:hover\\:bg-pink-300:hover {
    --bg-opacity: 1;
    background-color: #f8b4d9;
    background-color: rgba(248, 180, 217, var(--bg-opacity));
  }
  .md\\:hover\\:bg-pink-400:hover {
    --bg-opacity: 1;
    background-color: #f17eb8;
    background-color: rgba(241, 126, 184, var(--bg-opacity));
  }
  .md\\:hover\\:bg-pink-500:hover {
    --bg-opacity: 1;
    background-color: #e74694;
    background-color: rgba(231, 70, 148, var(--bg-opacity));
  }
  .md\\:hover\\:bg-pink-600:hover {
    --bg-opacity: 1;
    background-color: #d61f69;
    background-color: rgba(214, 31, 105, var(--bg-opacity));
  }
  .md\\:hover\\:bg-pink-700:hover {
    --bg-opacity: 1;
    background-color: #bf125d;
    background-color: rgba(191, 18, 93, var(--bg-opacity));
  }
  .md\\:hover\\:bg-pink-800:hover {
    --bg-opacity: 1;
    background-color: #99154b;
    background-color: rgba(153, 21, 75, var(--bg-opacity));
  }
  .md\\:hover\\:bg-pink-900:hover {
    --bg-opacity: 1;
    background-color: #751a3d;
    background-color: rgba(117, 26, 61, var(--bg-opacity));
  }
  .md\\:hover\\:bg-cool-gray-50:hover {
    --bg-opacity: 1;
    background-color: #f8fafc;
    background-color: rgba(248, 250, 252, var(--bg-opacity));
  }
  .md\\:hover\\:bg-cool-gray-100:hover {
    --bg-opacity: 1;
    background-color: #f1f5f9;
    background-color: rgba(241, 245, 249, var(--bg-opacity));
  }
  .md\\:hover\\:bg-cool-gray-200:hover {
    --bg-opacity: 1;
    background-color: #e2e8f0;
    background-color: rgba(226, 232, 240, var(--bg-opacity));
  }
  .md\\:hover\\:bg-cool-gray-300:hover {
    --bg-opacity: 1;
    background-color: #cfd8e3;
    background-color: rgba(207, 216, 227, var(--bg-opacity));
  }
  .md\\:hover\\:bg-cool-gray-400:hover {
    --bg-opacity: 1;
    background-color: #97a6ba;
    background-color: rgba(151, 166, 186, var(--bg-opacity));
  }
  .md\\:hover\\:bg-cool-gray-500:hover {
    --bg-opacity: 1;
    background-color: #64748b;
    background-color: rgba(100, 116, 139, var(--bg-opacity));
  }
  .md\\:hover\\:bg-cool-gray-600:hover {
    --bg-opacity: 1;
    background-color: #475569;
    background-color: rgba(71, 85, 105, var(--bg-opacity));
  }
  .md\\:hover\\:bg-cool-gray-700:hover {
    --bg-opacity: 1;
    background-color: #364152;
    background-color: rgba(54, 65, 82, var(--bg-opacity));
  }
  .md\\:hover\\:bg-cool-gray-800:hover {
    --bg-opacity: 1;
    background-color: #27303f;
    background-color: rgba(39, 48, 63, var(--bg-opacity));
  }
  .md\\:hover\\:bg-cool-gray-900:hover {
    --bg-opacity: 1;
    background-color: #1a202e;
    background-color: rgba(26, 32, 46, var(--bg-opacity));
  }
  .md\\:focus\\:bg-current:focus {
    background-color: currentColor;
  }
  .md\\:focus\\:bg-transparent:focus {
    background-color: transparent;
  }
  .md\\:focus\\:bg-white:focus {
    --bg-opacity: 1;
    background-color: #ffffff;
    background-color: rgba(255, 255, 255, var(--bg-opacity));
  }
  .md\\:focus\\:bg-black:focus {
    --bg-opacity: 1;
    background-color: #000000;
    background-color: rgba(0, 0, 0, var(--bg-opacity));
  }
  .md\\:focus\\:bg-gray-50:focus {
    --bg-opacity: 1;
    background-color: #f9fafb;
    background-color: rgba(249, 250, 251, var(--bg-opacity));
  }
  .md\\:focus\\:bg-gray-100:focus {
    --bg-opacity: 1;
    background-color: #f4f5f7;
    background-color: rgba(244, 245, 247, var(--bg-opacity));
  }
  .md\\:focus\\:bg-gray-200:focus {
    --bg-opacity: 1;
    background-color: #e5e7eb;
    background-color: rgba(229, 231, 235, var(--bg-opacity));
  }
  .md\\:focus\\:bg-gray-300:focus {
    --bg-opacity: 1;
    background-color: #d2d6dc;
    background-color: rgba(210, 214, 220, var(--bg-opacity));
  }
  .md\\:focus\\:bg-gray-400:focus {
    --bg-opacity: 1;
    background-color: #9fa6b2;
    background-color: rgba(159, 166, 178, var(--bg-opacity));
  }
  .md\\:focus\\:bg-gray-500:focus {
    --bg-opacity: 1;
    background-color: #6b7280;
    background-color: rgba(107, 114, 128, var(--bg-opacity));
  }
  .md\\:focus\\:bg-gray-600:focus {
    --bg-opacity: 1;
    background-color: #4b5563;
    background-color: rgba(75, 85, 99, var(--bg-opacity));
  }
  .md\\:focus\\:bg-gray-700:focus {
    --bg-opacity: 1;
    background-color: #374151;
    background-color: rgba(55, 65, 81, var(--bg-opacity));
  }
  .md\\:focus\\:bg-gray-800:focus {
    --bg-opacity: 1;
    background-color: #252f3f;
    background-color: rgba(37, 47, 63, var(--bg-opacity));
  }
  .md\\:focus\\:bg-gray-900:focus {
    --bg-opacity: 1;
    background-color: #161e2e;
    background-color: rgba(22, 30, 46, var(--bg-opacity));
  }
  .md\\:focus\\:bg-red-50:focus {
    --bg-opacity: 1;
    background-color: #fdf2f2;
    background-color: rgba(253, 242, 242, var(--bg-opacity));
  }
  .md\\:focus\\:bg-red-100:focus {
    --bg-opacity: 1;
    background-color: #fde8e8;
    background-color: rgba(253, 232, 232, var(--bg-opacity));
  }
  .md\\:focus\\:bg-red-200:focus {
    --bg-opacity: 1;
    background-color: #fbd5d5;
    background-color: rgba(251, 213, 213, var(--bg-opacity));
  }
  .md\\:focus\\:bg-red-300:focus {
    --bg-opacity: 1;
    background-color: #f8b4b4;
    background-color: rgba(248, 180, 180, var(--bg-opacity));
  }
  .md\\:focus\\:bg-red-400:focus {
    --bg-opacity: 1;
    background-color: #f98080;
    background-color: rgba(249, 128, 128, var(--bg-opacity));
  }
  .md\\:focus\\:bg-red-500:focus {
    --bg-opacity: 1;
    background-color: #f05252;
    background-color: rgba(240, 82, 82, var(--bg-opacity));
  }
  .md\\:focus\\:bg-red-600:focus {
    --bg-opacity: 1;
    background-color: #e02424;
    background-color: rgba(224, 36, 36, var(--bg-opacity));
  }
  .md\\:focus\\:bg-red-700:focus {
    --bg-opacity: 1;
    background-color: #c81e1e;
    background-color: rgba(200, 30, 30, var(--bg-opacity));
  }
  .md\\:focus\\:bg-red-800:focus {
    --bg-opacity: 1;
    background-color: #9b1c1c;
    background-color: rgba(155, 28, 28, var(--bg-opacity));
  }
  .md\\:focus\\:bg-red-900:focus {
    --bg-opacity: 1;
    background-color: #771d1d;
    background-color: rgba(119, 29, 29, var(--bg-opacity));
  }
  .md\\:focus\\:bg-orange-50:focus {
    --bg-opacity: 1;
    background-color: #fff8f1;
    background-color: rgba(255, 248, 241, var(--bg-opacity));
  }
  .md\\:focus\\:bg-orange-100:focus {
    --bg-opacity: 1;
    background-color: #feecdc;
    background-color: rgba(254, 236, 220, var(--bg-opacity));
  }
  .md\\:focus\\:bg-orange-200:focus {
    --bg-opacity: 1;
    background-color: #fcd9bd;
    background-color: rgba(252, 217, 189, var(--bg-opacity));
  }
  .md\\:focus\\:bg-orange-300:focus {
    --bg-opacity: 1;
    background-color: #fdba8c;
    background-color: rgba(253, 186, 140, var(--bg-opacity));
  }
  .md\\:focus\\:bg-orange-400:focus {
    --bg-opacity: 1;
    background-color: #ff8a4c;
    background-color: rgba(255, 138, 76, var(--bg-opacity));
  }
  .md\\:focus\\:bg-orange-500:focus {
    --bg-opacity: 1;
    background-color: #ff5a1f;
    background-color: rgba(255, 90, 31, var(--bg-opacity));
  }
  .md\\:focus\\:bg-orange-600:focus {
    --bg-opacity: 1;
    background-color: #d03801;
    background-color: rgba(208, 56, 1, var(--bg-opacity));
  }
  .md\\:focus\\:bg-orange-700:focus {
    --bg-opacity: 1;
    background-color: #b43403;
    background-color: rgba(180, 52, 3, var(--bg-opacity));
  }
  .md\\:focus\\:bg-orange-800:focus {
    --bg-opacity: 1;
    background-color: #8a2c0d;
    background-color: rgba(138, 44, 13, var(--bg-opacity));
  }
  .md\\:focus\\:bg-orange-900:focus {
    --bg-opacity: 1;
    background-color: #73230d;
    background-color: rgba(115, 35, 13, var(--bg-opacity));
  }
  .md\\:focus\\:bg-yellow-50:focus {
    --bg-opacity: 1;
    background-color: #fdfdea;
    background-color: rgba(253, 253, 234, var(--bg-opacity));
  }
  .md\\:focus\\:bg-yellow-100:focus {
    --bg-opacity: 1;
    background-color: #fdf6b2;
    background-color: rgba(253, 246, 178, var(--bg-opacity));
  }
  .md\\:focus\\:bg-yellow-200:focus {
    --bg-opacity: 1;
    background-color: #fce96a;
    background-color: rgba(252, 233, 106, var(--bg-opacity));
  }
  .md\\:focus\\:bg-yellow-300:focus {
    --bg-opacity: 1;
    background-color: #faca15;
    background-color: rgba(250, 202, 21, var(--bg-opacity));
  }
  .md\\:focus\\:bg-yellow-400:focus {
    --bg-opacity: 1;
    background-color: #e3a008;
    background-color: rgba(227, 160, 8, var(--bg-opacity));
  }
  .md\\:focus\\:bg-yellow-500:focus {
    --bg-opacity: 1;
    background-color: #c27803;
    background-color: rgba(194, 120, 3, var(--bg-opacity));
  }
  .md\\:focus\\:bg-yellow-600:focus {
    --bg-opacity: 1;
    background-color: #9f580a;
    background-color: rgba(159, 88, 10, var(--bg-opacity));
  }
  .md\\:focus\\:bg-yellow-700:focus {
    --bg-opacity: 1;
    background-color: #8e4b10;
    background-color: rgba(142, 75, 16, var(--bg-opacity));
  }
  .md\\:focus\\:bg-yellow-800:focus {
    --bg-opacity: 1;
    background-color: #723b13;
    background-color: rgba(114, 59, 19, var(--bg-opacity));
  }
  .md\\:focus\\:bg-yellow-900:focus {
    --bg-opacity: 1;
    background-color: #633112;
    background-color: rgba(99, 49, 18, var(--bg-opacity));
  }
  .md\\:focus\\:bg-green-50:focus {
    --bg-opacity: 1;
    background-color: #f3faf7;
    background-color: rgba(243, 250, 247, var(--bg-opacity));
  }
  .md\\:focus\\:bg-green-100:focus {
    --bg-opacity: 1;
    background-color: #def7ec;
    background-color: rgba(222, 247, 236, var(--bg-opacity));
  }
  .md\\:focus\\:bg-green-200:focus {
    --bg-opacity: 1;
    background-color: #bcf0da;
    background-color: rgba(188, 240, 218, var(--bg-opacity));
  }
  .md\\:focus\\:bg-green-300:focus {
    --bg-opacity: 1;
    background-color: #84e1bc;
    background-color: rgba(132, 225, 188, var(--bg-opacity));
  }
  .md\\:focus\\:bg-green-400:focus {
    --bg-opacity: 1;
    background-color: #31c48d;
    background-color: rgba(49, 196, 141, var(--bg-opacity));
  }
  .md\\:focus\\:bg-green-500:focus {
    --bg-opacity: 1;
    background-color: #0e9f6e;
    background-color: rgba(14, 159, 110, var(--bg-opacity));
  }
  .md\\:focus\\:bg-green-600:focus {
    --bg-opacity: 1;
    background-color: #057a55;
    background-color: rgba(5, 122, 85, var(--bg-opacity));
  }
  .md\\:focus\\:bg-green-700:focus {
    --bg-opacity: 1;
    background-color: #046c4e;
    background-color: rgba(4, 108, 78, var(--bg-opacity));
  }
  .md\\:focus\\:bg-green-800:focus {
    --bg-opacity: 1;
    background-color: #03543f;
    background-color: rgba(3, 84, 63, var(--bg-opacity));
  }
  .md\\:focus\\:bg-green-900:focus {
    --bg-opacity: 1;
    background-color: #014737;
    background-color: rgba(1, 71, 55, var(--bg-opacity));
  }
  .md\\:focus\\:bg-teal-50:focus {
    --bg-opacity: 1;
    background-color: #edfafa;
    background-color: rgba(237, 250, 250, var(--bg-opacity));
  }
  .md\\:focus\\:bg-teal-100:focus {
    --bg-opacity: 1;
    background-color: #d5f5f6;
    background-color: rgba(213, 245, 246, var(--bg-opacity));
  }
  .md\\:focus\\:bg-teal-200:focus {
    --bg-opacity: 1;
    background-color: #afecef;
    background-color: rgba(175, 236, 239, var(--bg-opacity));
  }
  .md\\:focus\\:bg-teal-300:focus {
    --bg-opacity: 1;
    background-color: #7edce2;
    background-color: rgba(126, 220, 226, var(--bg-opacity));
  }
  .md\\:focus\\:bg-teal-400:focus {
    --bg-opacity: 1;
    background-color: #16bdca;
    background-color: rgba(22, 189, 202, var(--bg-opacity));
  }
  .md\\:focus\\:bg-teal-500:focus {
    --bg-opacity: 1;
    background-color: #0694a2;
    background-color: rgba(6, 148, 162, var(--bg-opacity));
  }
  .md\\:focus\\:bg-teal-600:focus {
    --bg-opacity: 1;
    background-color: #047481;
    background-color: rgba(4, 116, 129, var(--bg-opacity));
  }
  .md\\:focus\\:bg-teal-700:focus {
    --bg-opacity: 1;
    background-color: #036672;
    background-color: rgba(3, 102, 114, var(--bg-opacity));
  }
  .md\\:focus\\:bg-teal-800:focus {
    --bg-opacity: 1;
    background-color: #05505c;
    background-color: rgba(5, 80, 92, var(--bg-opacity));
  }
  .md\\:focus\\:bg-teal-900:focus {
    --bg-opacity: 1;
    background-color: #014451;
    background-color: rgba(1, 68, 81, var(--bg-opacity));
  }
  .md\\:focus\\:bg-blue-50:focus {
    --bg-opacity: 1;
    background-color: #ebf5ff;
    background-color: rgba(235, 245, 255, var(--bg-opacity));
  }
  .md\\:focus\\:bg-blue-100:focus {
    --bg-opacity: 1;
    background-color: #e1effe;
    background-color: rgba(225, 239, 254, var(--bg-opacity));
  }
  .md\\:focus\\:bg-blue-200:focus {
    --bg-opacity: 1;
    background-color: #c3ddfd;
    background-color: rgba(195, 221, 253, var(--bg-opacity));
  }
  .md\\:focus\\:bg-blue-300:focus {
    --bg-opacity: 1;
    background-color: #a4cafe;
    background-color: rgba(164, 202, 254, var(--bg-opacity));
  }
  .md\\:focus\\:bg-blue-400:focus {
    --bg-opacity: 1;
    background-color: #76a9fa;
    background-color: rgba(118, 169, 250, var(--bg-opacity));
  }
  .md\\:focus\\:bg-blue-500:focus {
    --bg-opacity: 1;
    background-color: #3f83f8;
    background-color: rgba(63, 131, 248, var(--bg-opacity));
  }
  .md\\:focus\\:bg-blue-600:focus {
    --bg-opacity: 1;
    background-color: #1c64f2;
    background-color: rgba(28, 100, 242, var(--bg-opacity));
  }
  .md\\:focus\\:bg-blue-700:focus {
    --bg-opacity: 1;
    background-color: #1a56db;
    background-color: rgba(26, 86, 219, var(--bg-opacity));
  }
  .md\\:focus\\:bg-blue-800:focus {
    --bg-opacity: 1;
    background-color: #1e429f;
    background-color: rgba(30, 66, 159, var(--bg-opacity));
  }
  .md\\:focus\\:bg-blue-900:focus {
    --bg-opacity: 1;
    background-color: #233876;
    background-color: rgba(35, 56, 118, var(--bg-opacity));
  }
  .md\\:focus\\:bg-indigo-50:focus {
    --bg-opacity: 1;
    background-color: #f0f5ff;
    background-color: rgba(240, 245, 255, var(--bg-opacity));
  }
  .md\\:focus\\:bg-indigo-100:focus {
    --bg-opacity: 1;
    background-color: #e5edff;
    background-color: rgba(229, 237, 255, var(--bg-opacity));
  }
  .md\\:focus\\:bg-indigo-200:focus {
    --bg-opacity: 1;
    background-color: #cddbfe;
    background-color: rgba(205, 219, 254, var(--bg-opacity));
  }
  .md\\:focus\\:bg-indigo-300:focus {
    --bg-opacity: 1;
    background-color: #b4c6fc;
    background-color: rgba(180, 198, 252, var(--bg-opacity));
  }
  .md\\:focus\\:bg-indigo-400:focus {
    --bg-opacity: 1;
    background-color: #8da2fb;
    background-color: rgba(141, 162, 251, var(--bg-opacity));
  }
  .md\\:focus\\:bg-indigo-500:focus {
    --bg-opacity: 1;
    background-color: #6875f5;
    background-color: rgba(104, 117, 245, var(--bg-opacity));
  }
  .md\\:focus\\:bg-indigo-600:focus {
    --bg-opacity: 1;
    background-color: #5850ec;
    background-color: rgba(88, 80, 236, var(--bg-opacity));
  }
  .md\\:focus\\:bg-indigo-700:focus {
    --bg-opacity: 1;
    background-color: #5145cd;
    background-color: rgba(81, 69, 205, var(--bg-opacity));
  }
  .md\\:focus\\:bg-indigo-800:focus {
    --bg-opacity: 1;
    background-color: #42389d;
    background-color: rgba(66, 56, 157, var(--bg-opacity));
  }
  .md\\:focus\\:bg-indigo-900:focus {
    --bg-opacity: 1;
    background-color: #362f78;
    background-color: rgba(54, 47, 120, var(--bg-opacity));
  }
  .md\\:focus\\:bg-purple-50:focus {
    --bg-opacity: 1;
    background-color: #f6f5ff;
    background-color: rgba(246, 245, 255, var(--bg-opacity));
  }
  .md\\:focus\\:bg-purple-100:focus {
    --bg-opacity: 1;
    background-color: #edebfe;
    background-color: rgba(237, 235, 254, var(--bg-opacity));
  }
  .md\\:focus\\:bg-purple-200:focus {
    --bg-opacity: 1;
    background-color: #dcd7fe;
    background-color: rgba(220, 215, 254, var(--bg-opacity));
  }
  .md\\:focus\\:bg-purple-300:focus {
    --bg-opacity: 1;
    background-color: #cabffd;
    background-color: rgba(202, 191, 253, var(--bg-opacity));
  }
  .md\\:focus\\:bg-purple-400:focus {
    --bg-opacity: 1;
    background-color: #ac94fa;
    background-color: rgba(172, 148, 250, var(--bg-opacity));
  }
  .md\\:focus\\:bg-purple-500:focus {
    --bg-opacity: 1;
    background-color: #9061f9;
    background-color: rgba(144, 97, 249, var(--bg-opacity));
  }
  .md\\:focus\\:bg-purple-600:focus {
    --bg-opacity: 1;
    background-color: #7e3af2;
    background-color: rgba(126, 58, 242, var(--bg-opacity));
  }
  .md\\:focus\\:bg-purple-700:focus {
    --bg-opacity: 1;
    background-color: #6c2bd9;
    background-color: rgba(108, 43, 217, var(--bg-opacity));
  }
  .md\\:focus\\:bg-purple-800:focus {
    --bg-opacity: 1;
    background-color: #5521b5;
    background-color: rgba(85, 33, 181, var(--bg-opacity));
  }
  .md\\:focus\\:bg-purple-900:focus {
    --bg-opacity: 1;
    background-color: #4a1d96;
    background-color: rgba(74, 29, 150, var(--bg-opacity));
  }
  .md\\:focus\\:bg-pink-50:focus {
    --bg-opacity: 1;
    background-color: #fdf2f8;
    background-color: rgba(253, 242, 248, var(--bg-opacity));
  }
  .md\\:focus\\:bg-pink-100:focus {
    --bg-opacity: 1;
    background-color: #fce8f3;
    background-color: rgba(252, 232, 243, var(--bg-opacity));
  }
  .md\\:focus\\:bg-pink-200:focus {
    --bg-opacity: 1;
    background-color: #fad1e8;
    background-color: rgba(250, 209, 232, var(--bg-opacity));
  }
  .md\\:focus\\:bg-pink-300:focus {
    --bg-opacity: 1;
    background-color: #f8b4d9;
    background-color: rgba(248, 180, 217, var(--bg-opacity));
  }
  .md\\:focus\\:bg-pink-400:focus {
    --bg-opacity: 1;
    background-color: #f17eb8;
    background-color: rgba(241, 126, 184, var(--bg-opacity));
  }
  .md\\:focus\\:bg-pink-500:focus {
    --bg-opacity: 1;
    background-color: #e74694;
    background-color: rgba(231, 70, 148, var(--bg-opacity));
  }
  .md\\:focus\\:bg-pink-600:focus {
    --bg-opacity: 1;
    background-color: #d61f69;
    background-color: rgba(214, 31, 105, var(--bg-opacity));
  }
  .md\\:focus\\:bg-pink-700:focus {
    --bg-opacity: 1;
    background-color: #bf125d;
    background-color: rgba(191, 18, 93, var(--bg-opacity));
  }
  .md\\:focus\\:bg-pink-800:focus {
    --bg-opacity: 1;
    background-color: #99154b;
    background-color: rgba(153, 21, 75, var(--bg-opacity));
  }
  .md\\:focus\\:bg-pink-900:focus {
    --bg-opacity: 1;
    background-color: #751a3d;
    background-color: rgba(117, 26, 61, var(--bg-opacity));
  }
  .md\\:focus\\:bg-cool-gray-50:focus {
    --bg-opacity: 1;
    background-color: #f8fafc;
    background-color: rgba(248, 250, 252, var(--bg-opacity));
  }
  .md\\:focus\\:bg-cool-gray-100:focus {
    --bg-opacity: 1;
    background-color: #f1f5f9;
    background-color: rgba(241, 245, 249, var(--bg-opacity));
  }
  .md\\:focus\\:bg-cool-gray-200:focus {
    --bg-opacity: 1;
    background-color: #e2e8f0;
    background-color: rgba(226, 232, 240, var(--bg-opacity));
  }
  .md\\:focus\\:bg-cool-gray-300:focus {
    --bg-opacity: 1;
    background-color: #cfd8e3;
    background-color: rgba(207, 216, 227, var(--bg-opacity));
  }
  .md\\:focus\\:bg-cool-gray-400:focus {
    --bg-opacity: 1;
    background-color: #97a6ba;
    background-color: rgba(151, 166, 186, var(--bg-opacity));
  }
  .md\\:focus\\:bg-cool-gray-500:focus {
    --bg-opacity: 1;
    background-color: #64748b;
    background-color: rgba(100, 116, 139, var(--bg-opacity));
  }
  .md\\:focus\\:bg-cool-gray-600:focus {
    --bg-opacity: 1;
    background-color: #475569;
    background-color: rgba(71, 85, 105, var(--bg-opacity));
  }
  .md\\:focus\\:bg-cool-gray-700:focus {
    --bg-opacity: 1;
    background-color: #364152;
    background-color: rgba(54, 65, 82, var(--bg-opacity));
  }
  .md\\:focus\\:bg-cool-gray-800:focus {
    --bg-opacity: 1;
    background-color: #27303f;
    background-color: rgba(39, 48, 63, var(--bg-opacity));
  }
  .md\\:focus\\:bg-cool-gray-900:focus {
    --bg-opacity: 1;
    background-color: #1a202e;
    background-color: rgba(26, 32, 46, var(--bg-opacity));
  }
  .md\\:active\\:bg-current:active {
    background-color: currentColor;
  }
  .md\\:active\\:bg-transparent:active {
    background-color: transparent;
  }
  .md\\:active\\:bg-white:active {
    --bg-opacity: 1;
    background-color: #ffffff;
    background-color: rgba(255, 255, 255, var(--bg-opacity));
  }
  .md\\:active\\:bg-black:active {
    --bg-opacity: 1;
    background-color: #000000;
    background-color: rgba(0, 0, 0, var(--bg-opacity));
  }
  .md\\:active\\:bg-gray-50:active {
    --bg-opacity: 1;
    background-color: #f9fafb;
    background-color: rgba(249, 250, 251, var(--bg-opacity));
  }
  .md\\:active\\:bg-gray-100:active {
    --bg-opacity: 1;
    background-color: #f4f5f7;
    background-color: rgba(244, 245, 247, var(--bg-opacity));
  }
  .md\\:active\\:bg-gray-200:active {
    --bg-opacity: 1;
    background-color: #e5e7eb;
    background-color: rgba(229, 231, 235, var(--bg-opacity));
  }
  .md\\:active\\:bg-gray-300:active {
    --bg-opacity: 1;
    background-color: #d2d6dc;
    background-color: rgba(210, 214, 220, var(--bg-opacity));
  }
  .md\\:active\\:bg-gray-400:active {
    --bg-opacity: 1;
    background-color: #9fa6b2;
    background-color: rgba(159, 166, 178, var(--bg-opacity));
  }
  .md\\:active\\:bg-gray-500:active {
    --bg-opacity: 1;
    background-color: #6b7280;
    background-color: rgba(107, 114, 128, var(--bg-opacity));
  }
  .md\\:active\\:bg-gray-600:active {
    --bg-opacity: 1;
    background-color: #4b5563;
    background-color: rgba(75, 85, 99, var(--bg-opacity));
  }
  .md\\:active\\:bg-gray-700:active {
    --bg-opacity: 1;
    background-color: #374151;
    background-color: rgba(55, 65, 81, var(--bg-opacity));
  }
  .md\\:active\\:bg-gray-800:active {
    --bg-opacity: 1;
    background-color: #252f3f;
    background-color: rgba(37, 47, 63, var(--bg-opacity));
  }
  .md\\:active\\:bg-gray-900:active {
    --bg-opacity: 1;
    background-color: #161e2e;
    background-color: rgba(22, 30, 46, var(--bg-opacity));
  }
  .md\\:active\\:bg-red-50:active {
    --bg-opacity: 1;
    background-color: #fdf2f2;
    background-color: rgba(253, 242, 242, var(--bg-opacity));
  }
  .md\\:active\\:bg-red-100:active {
    --bg-opacity: 1;
    background-color: #fde8e8;
    background-color: rgba(253, 232, 232, var(--bg-opacity));
  }
  .md\\:active\\:bg-red-200:active {
    --bg-opacity: 1;
    background-color: #fbd5d5;
    background-color: rgba(251, 213, 213, var(--bg-opacity));
  }
  .md\\:active\\:bg-red-300:active {
    --bg-opacity: 1;
    background-color: #f8b4b4;
    background-color: rgba(248, 180, 180, var(--bg-opacity));
  }
  .md\\:active\\:bg-red-400:active {
    --bg-opacity: 1;
    background-color: #f98080;
    background-color: rgba(249, 128, 128, var(--bg-opacity));
  }
  .md\\:active\\:bg-red-500:active {
    --bg-opacity: 1;
    background-color: #f05252;
    background-color: rgba(240, 82, 82, var(--bg-opacity));
  }
  .md\\:active\\:bg-red-600:active {
    --bg-opacity: 1;
    background-color: #e02424;
    background-color: rgba(224, 36, 36, var(--bg-opacity));
  }
  .md\\:active\\:bg-red-700:active {
    --bg-opacity: 1;
    background-color: #c81e1e;
    background-color: rgba(200, 30, 30, var(--bg-opacity));
  }
  .md\\:active\\:bg-red-800:active {
    --bg-opacity: 1;
    background-color: #9b1c1c;
    background-color: rgba(155, 28, 28, var(--bg-opacity));
  }
  .md\\:active\\:bg-red-900:active {
    --bg-opacity: 1;
    background-color: #771d1d;
    background-color: rgba(119, 29, 29, var(--bg-opacity));
  }
  .md\\:active\\:bg-orange-50:active {
    --bg-opacity: 1;
    background-color: #fff8f1;
    background-color: rgba(255, 248, 241, var(--bg-opacity));
  }
  .md\\:active\\:bg-orange-100:active {
    --bg-opacity: 1;
    background-color: #feecdc;
    background-color: rgba(254, 236, 220, var(--bg-opacity));
  }
  .md\\:active\\:bg-orange-200:active {
    --bg-opacity: 1;
    background-color: #fcd9bd;
    background-color: rgba(252, 217, 189, var(--bg-opacity));
  }
  .md\\:active\\:bg-orange-300:active {
    --bg-opacity: 1;
    background-color: #fdba8c;
    background-color: rgba(253, 186, 140, var(--bg-opacity));
  }
  .md\\:active\\:bg-orange-400:active {
    --bg-opacity: 1;
    background-color: #ff8a4c;
    background-color: rgba(255, 138, 76, var(--bg-opacity));
  }
  .md\\:active\\:bg-orange-500:active {
    --bg-opacity: 1;
    background-color: #ff5a1f;
    background-color: rgba(255, 90, 31, var(--bg-opacity));
  }
  .md\\:active\\:bg-orange-600:active {
    --bg-opacity: 1;
    background-color: #d03801;
    background-color: rgba(208, 56, 1, var(--bg-opacity));
  }
  .md\\:active\\:bg-orange-700:active {
    --bg-opacity: 1;
    background-color: #b43403;
    background-color: rgba(180, 52, 3, var(--bg-opacity));
  }
  .md\\:active\\:bg-orange-800:active {
    --bg-opacity: 1;
    background-color: #8a2c0d;
    background-color: rgba(138, 44, 13, var(--bg-opacity));
  }
  .md\\:active\\:bg-orange-900:active {
    --bg-opacity: 1;
    background-color: #73230d;
    background-color: rgba(115, 35, 13, var(--bg-opacity));
  }
  .md\\:active\\:bg-yellow-50:active {
    --bg-opacity: 1;
    background-color: #fdfdea;
    background-color: rgba(253, 253, 234, var(--bg-opacity));
  }
  .md\\:active\\:bg-yellow-100:active {
    --bg-opacity: 1;
    background-color: #fdf6b2;
    background-color: rgba(253, 246, 178, var(--bg-opacity));
  }
  .md\\:active\\:bg-yellow-200:active {
    --bg-opacity: 1;
    background-color: #fce96a;
    background-color: rgba(252, 233, 106, var(--bg-opacity));
  }
  .md\\:active\\:bg-yellow-300:active {
    --bg-opacity: 1;
    background-color: #faca15;
    background-color: rgba(250, 202, 21, var(--bg-opacity));
  }
  .md\\:active\\:bg-yellow-400:active {
    --bg-opacity: 1;
    background-color: #e3a008;
    background-color: rgba(227, 160, 8, var(--bg-opacity));
  }
  .md\\:active\\:bg-yellow-500:active {
    --bg-opacity: 1;
    background-color: #c27803;
    background-color: rgba(194, 120, 3, var(--bg-opacity));
  }
  .md\\:active\\:bg-yellow-600:active {
    --bg-opacity: 1;
    background-color: #9f580a;
    background-color: rgba(159, 88, 10, var(--bg-opacity));
  }
  .md\\:active\\:bg-yellow-700:active {
    --bg-opacity: 1;
    background-color: #8e4b10;
    background-color: rgba(142, 75, 16, var(--bg-opacity));
  }
  .md\\:active\\:bg-yellow-800:active {
    --bg-opacity: 1;
    background-color: #723b13;
    background-color: rgba(114, 59, 19, var(--bg-opacity));
  }
  .md\\:active\\:bg-yellow-900:active {
    --bg-opacity: 1;
    background-color: #633112;
    background-color: rgba(99, 49, 18, var(--bg-opacity));
  }
  .md\\:active\\:bg-green-50:active {
    --bg-opacity: 1;
    background-color: #f3faf7;
    background-color: rgba(243, 250, 247, var(--bg-opacity));
  }
  .md\\:active\\:bg-green-100:active {
    --bg-opacity: 1;
    background-color: #def7ec;
    background-color: rgba(222, 247, 236, var(--bg-opacity));
  }
  .md\\:active\\:bg-green-200:active {
    --bg-opacity: 1;
    background-color: #bcf0da;
    background-color: rgba(188, 240, 218, var(--bg-opacity));
  }
  .md\\:active\\:bg-green-300:active {
    --bg-opacity: 1;
    background-color: #84e1bc;
    background-color: rgba(132, 225, 188, var(--bg-opacity));
  }
  .md\\:active\\:bg-green-400:active {
    --bg-opacity: 1;
    background-color: #31c48d;
    background-color: rgba(49, 196, 141, var(--bg-opacity));
  }
  .md\\:active\\:bg-green-500:active {
    --bg-opacity: 1;
    background-color: #0e9f6e;
    background-color: rgba(14, 159, 110, var(--bg-opacity));
  }
  .md\\:active\\:bg-green-600:active {
    --bg-opacity: 1;
    background-color: #057a55;
    background-color: rgba(5, 122, 85, var(--bg-opacity));
  }
  .md\\:active\\:bg-green-700:active {
    --bg-opacity: 1;
    background-color: #046c4e;
    background-color: rgba(4, 108, 78, var(--bg-opacity));
  }
  .md\\:active\\:bg-green-800:active {
    --bg-opacity: 1;
    background-color: #03543f;
    background-color: rgba(3, 84, 63, var(--bg-opacity));
  }
  .md\\:active\\:bg-green-900:active {
    --bg-opacity: 1;
    background-color: #014737;
    background-color: rgba(1, 71, 55, var(--bg-opacity));
  }
  .md\\:active\\:bg-teal-50:active {
    --bg-opacity: 1;
    background-color: #edfafa;
    background-color: rgba(237, 250, 250, var(--bg-opacity));
  }
  .md\\:active\\:bg-teal-100:active {
    --bg-opacity: 1;
    background-color: #d5f5f6;
    background-color: rgba(213, 245, 246, var(--bg-opacity));
  }
  .md\\:active\\:bg-teal-200:active {
    --bg-opacity: 1;
    background-color: #afecef;
    background-color: rgba(175, 236, 239, var(--bg-opacity));
  }
  .md\\:active\\:bg-teal-300:active {
    --bg-opacity: 1;
    background-color: #7edce2;
    background-color: rgba(126, 220, 226, var(--bg-opacity));
  }
  .md\\:active\\:bg-teal-400:active {
    --bg-opacity: 1;
    background-color: #16bdca;
    background-color: rgba(22, 189, 202, var(--bg-opacity));
  }
  .md\\:active\\:bg-teal-500:active {
    --bg-opacity: 1;
    background-color: #0694a2;
    background-color: rgba(6, 148, 162, var(--bg-opacity));
  }
  .md\\:active\\:bg-teal-600:active {
    --bg-opacity: 1;
    background-color: #047481;
    background-color: rgba(4, 116, 129, var(--bg-opacity));
  }
  .md\\:active\\:bg-teal-700:active {
    --bg-opacity: 1;
    background-color: #036672;
    background-color: rgba(3, 102, 114, var(--bg-opacity));
  }
  .md\\:active\\:bg-teal-800:active {
    --bg-opacity: 1;
    background-color: #05505c;
    background-color: rgba(5, 80, 92, var(--bg-opacity));
  }
  .md\\:active\\:bg-teal-900:active {
    --bg-opacity: 1;
    background-color: #014451;
    background-color: rgba(1, 68, 81, var(--bg-opacity));
  }
  .md\\:active\\:bg-blue-50:active {
    --bg-opacity: 1;
    background-color: #ebf5ff;
    background-color: rgba(235, 245, 255, var(--bg-opacity));
  }
  .md\\:active\\:bg-blue-100:active {
    --bg-opacity: 1;
    background-color: #e1effe;
    background-color: rgba(225, 239, 254, var(--bg-opacity));
  }
  .md\\:active\\:bg-blue-200:active {
    --bg-opacity: 1;
    background-color: #c3ddfd;
    background-color: rgba(195, 221, 253, var(--bg-opacity));
  }
  .md\\:active\\:bg-blue-300:active {
    --bg-opacity: 1;
    background-color: #a4cafe;
    background-color: rgba(164, 202, 254, var(--bg-opacity));
  }
  .md\\:active\\:bg-blue-400:active {
    --bg-opacity: 1;
    background-color: #76a9fa;
    background-color: rgba(118, 169, 250, var(--bg-opacity));
  }
  .md\\:active\\:bg-blue-500:active {
    --bg-opacity: 1;
    background-color: #3f83f8;
    background-color: rgba(63, 131, 248, var(--bg-opacity));
  }
  .md\\:active\\:bg-blue-600:active {
    --bg-opacity: 1;
    background-color: #1c64f2;
    background-color: rgba(28, 100, 242, var(--bg-opacity));
  }
  .md\\:active\\:bg-blue-700:active {
    --bg-opacity: 1;
    background-color: #1a56db;
    background-color: rgba(26, 86, 219, var(--bg-opacity));
  }
  .md\\:active\\:bg-blue-800:active {
    --bg-opacity: 1;
    background-color: #1e429f;
    background-color: rgba(30, 66, 159, var(--bg-opacity));
  }
  .md\\:active\\:bg-blue-900:active {
    --bg-opacity: 1;
    background-color: #233876;
    background-color: rgba(35, 56, 118, var(--bg-opacity));
  }
  .md\\:active\\:bg-indigo-50:active {
    --bg-opacity: 1;
    background-color: #f0f5ff;
    background-color: rgba(240, 245, 255, var(--bg-opacity));
  }
  .md\\:active\\:bg-indigo-100:active {
    --bg-opacity: 1;
    background-color: #e5edff;
    background-color: rgba(229, 237, 255, var(--bg-opacity));
  }
  .md\\:active\\:bg-indigo-200:active {
    --bg-opacity: 1;
    background-color: #cddbfe;
    background-color: rgba(205, 219, 254, var(--bg-opacity));
  }
  .md\\:active\\:bg-indigo-300:active {
    --bg-opacity: 1;
    background-color: #b4c6fc;
    background-color: rgba(180, 198, 252, var(--bg-opacity));
  }
  .md\\:active\\:bg-indigo-400:active {
    --bg-opacity: 1;
    background-color: #8da2fb;
    background-color: rgba(141, 162, 251, var(--bg-opacity));
  }
  .md\\:active\\:bg-indigo-500:active {
    --bg-opacity: 1;
    background-color: #6875f5;
    background-color: rgba(104, 117, 245, var(--bg-opacity));
  }
  .md\\:active\\:bg-indigo-600:active {
    --bg-opacity: 1;
    background-color: #5850ec;
    background-color: rgba(88, 80, 236, var(--bg-opacity));
  }
  .md\\:active\\:bg-indigo-700:active {
    --bg-opacity: 1;
    background-color: #5145cd;
    background-color: rgba(81, 69, 205, var(--bg-opacity));
  }
  .md\\:active\\:bg-indigo-800:active {
    --bg-opacity: 1;
    background-color: #42389d;
    background-color: rgba(66, 56, 157, var(--bg-opacity));
  }
  .md\\:active\\:bg-indigo-900:active {
    --bg-opacity: 1;
    background-color: #362f78;
    background-color: rgba(54, 47, 120, var(--bg-opacity));
  }
  .md\\:active\\:bg-purple-50:active {
    --bg-opacity: 1;
    background-color: #f6f5ff;
    background-color: rgba(246, 245, 255, var(--bg-opacity));
  }
  .md\\:active\\:bg-purple-100:active {
    --bg-opacity: 1;
    background-color: #edebfe;
    background-color: rgba(237, 235, 254, var(--bg-opacity));
  }
  .md\\:active\\:bg-purple-200:active {
    --bg-opacity: 1;
    background-color: #dcd7fe;
    background-color: rgba(220, 215, 254, var(--bg-opacity));
  }
  .md\\:active\\:bg-purple-300:active {
    --bg-opacity: 1;
    background-color: #cabffd;
    background-color: rgba(202, 191, 253, var(--bg-opacity));
  }
  .md\\:active\\:bg-purple-400:active {
    --bg-opacity: 1;
    background-color: #ac94fa;
    background-color: rgba(172, 148, 250, var(--bg-opacity));
  }
  .md\\:active\\:bg-purple-500:active {
    --bg-opacity: 1;
    background-color: #9061f9;
    background-color: rgba(144, 97, 249, var(--bg-opacity));
  }
  .md\\:active\\:bg-purple-600:active {
    --bg-opacity: 1;
    background-color: #7e3af2;
    background-color: rgba(126, 58, 242, var(--bg-opacity));
  }
  .md\\:active\\:bg-purple-700:active {
    --bg-opacity: 1;
    background-color: #6c2bd9;
    background-color: rgba(108, 43, 217, var(--bg-opacity));
  }
  .md\\:active\\:bg-purple-800:active {
    --bg-opacity: 1;
    background-color: #5521b5;
    background-color: rgba(85, 33, 181, var(--bg-opacity));
  }
  .md\\:active\\:bg-purple-900:active {
    --bg-opacity: 1;
    background-color: #4a1d96;
    background-color: rgba(74, 29, 150, var(--bg-opacity));
  }
  .md\\:active\\:bg-pink-50:active {
    --bg-opacity: 1;
    background-color: #fdf2f8;
    background-color: rgba(253, 242, 248, var(--bg-opacity));
  }
  .md\\:active\\:bg-pink-100:active {
    --bg-opacity: 1;
    background-color: #fce8f3;
    background-color: rgba(252, 232, 243, var(--bg-opacity));
  }
  .md\\:active\\:bg-pink-200:active {
    --bg-opacity: 1;
    background-color: #fad1e8;
    background-color: rgba(250, 209, 232, var(--bg-opacity));
  }
  .md\\:active\\:bg-pink-300:active {
    --bg-opacity: 1;
    background-color: #f8b4d9;
    background-color: rgba(248, 180, 217, var(--bg-opacity));
  }
  .md\\:active\\:bg-pink-400:active {
    --bg-opacity: 1;
    background-color: #f17eb8;
    background-color: rgba(241, 126, 184, var(--bg-opacity));
  }
  .md\\:active\\:bg-pink-500:active {
    --bg-opacity: 1;
    background-color: #e74694;
    background-color: rgba(231, 70, 148, var(--bg-opacity));
  }
  .md\\:active\\:bg-pink-600:active {
    --bg-opacity: 1;
    background-color: #d61f69;
    background-color: rgba(214, 31, 105, var(--bg-opacity));
  }
  .md\\:active\\:bg-pink-700:active {
    --bg-opacity: 1;
    background-color: #bf125d;
    background-color: rgba(191, 18, 93, var(--bg-opacity));
  }
  .md\\:active\\:bg-pink-800:active {
    --bg-opacity: 1;
    background-color: #99154b;
    background-color: rgba(153, 21, 75, var(--bg-opacity));
  }
  .md\\:active\\:bg-pink-900:active {
    --bg-opacity: 1;
    background-color: #751a3d;
    background-color: rgba(117, 26, 61, var(--bg-opacity));
  }
  .md\\:active\\:bg-cool-gray-50:active {
    --bg-opacity: 1;
    background-color: #f8fafc;
    background-color: rgba(248, 250, 252, var(--bg-opacity));
  }
  .md\\:active\\:bg-cool-gray-100:active {
    --bg-opacity: 1;
    background-color: #f1f5f9;
    background-color: rgba(241, 245, 249, var(--bg-opacity));
  }
  .md\\:active\\:bg-cool-gray-200:active {
    --bg-opacity: 1;
    background-color: #e2e8f0;
    background-color: rgba(226, 232, 240, var(--bg-opacity));
  }
  .md\\:active\\:bg-cool-gray-300:active {
    --bg-opacity: 1;
    background-color: #cfd8e3;
    background-color: rgba(207, 216, 227, var(--bg-opacity));
  }
  .md\\:active\\:bg-cool-gray-400:active {
    --bg-opacity: 1;
    background-color: #97a6ba;
    background-color: rgba(151, 166, 186, var(--bg-opacity));
  }
  .md\\:active\\:bg-cool-gray-500:active {
    --bg-opacity: 1;
    background-color: #64748b;
    background-color: rgba(100, 116, 139, var(--bg-opacity));
  }
  .md\\:active\\:bg-cool-gray-600:active {
    --bg-opacity: 1;
    background-color: #475569;
    background-color: rgba(71, 85, 105, var(--bg-opacity));
  }
  .md\\:active\\:bg-cool-gray-700:active {
    --bg-opacity: 1;
    background-color: #364152;
    background-color: rgba(54, 65, 82, var(--bg-opacity));
  }
  .md\\:active\\:bg-cool-gray-800:active {
    --bg-opacity: 1;
    background-color: #27303f;
    background-color: rgba(39, 48, 63, var(--bg-opacity));
  }
  .md\\:active\\:bg-cool-gray-900:active {
    --bg-opacity: 1;
    background-color: #1a202e;
    background-color: rgba(26, 32, 46, var(--bg-opacity));
  }
  .md\\:bg-none {
    background-image: none;
  }
  .md\\:bg-gradient-to-t {
    background-image: linear-gradient(to top, var(--gradient-color-stops));
  }
  .md\\:bg-gradient-to-tr {
    background-image: linear-gradient(to top right, var(--gradient-color-stops));
  }
  .md\\:bg-gradient-to-r {
    background-image: linear-gradient(to right, var(--gradient-color-stops));
  }
  .md\\:bg-gradient-to-br {
    background-image: linear-gradient(to bottom right, var(--gradient-color-stops));
  }
  .md\\:bg-gradient-to-b {
    background-image: linear-gradient(to bottom, var(--gradient-color-stops));
  }
  .md\\:bg-gradient-to-bl {
    background-image: linear-gradient(to bottom left, var(--gradient-color-stops));
  }
  .md\\:bg-gradient-to-l {
    background-image: linear-gradient(to left, var(--gradient-color-stops));
  }
  .md\\:bg-gradient-to-tl {
    background-image: linear-gradient(to top left, var(--gradient-color-stops));
  }
  .md\\:from-current {
    --gradient-from-color: currentColor;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }
  .md\\:from-transparent {
    --gradient-from-color: transparent;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  }
  .md\\:from-white {
    --gradient-from-color: #ffffff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }
  .md\\:from-black {
    --gradient-from-color: #000000;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  }
  .md\\:from-gray-50 {
    --gradient-from-color: #f9fafb;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(249, 250, 251, 0));
  }
  .md\\:from-gray-100 {
    --gradient-from-color: #f4f5f7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(244, 245, 247, 0));
  }
  .md\\:from-gray-200 {
    --gradient-from-color: #e5e7eb;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(229, 231, 235, 0));
  }
  .md\\:from-gray-300 {
    --gradient-from-color: #d2d6dc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(210, 214, 220, 0));
  }
  .md\\:from-gray-400 {
    --gradient-from-color: #9fa6b2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(159, 166, 178, 0));
  }
  .md\\:from-gray-500 {
    --gradient-from-color: #6b7280;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(107, 114, 128, 0));
  }
  .md\\:from-gray-600 {
    --gradient-from-color: #4b5563;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(75, 85, 99, 0));
  }
  .md\\:from-gray-700 {
    --gradient-from-color: #374151;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(55, 65, 81, 0));
  }
  .md\\:from-gray-800 {
    --gradient-from-color: #252f3f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(37, 47, 63, 0));
  }
  .md\\:from-gray-900 {
    --gradient-from-color: #161e2e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(22, 30, 46, 0));
  }
  .md\\:from-red-50 {
    --gradient-from-color: #fdf2f2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 242, 242, 0));
  }
  .md\\:from-red-100 {
    --gradient-from-color: #fde8e8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 232, 232, 0));
  }
  .md\\:from-red-200 {
    --gradient-from-color: #fbd5d5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(251, 213, 213, 0));
  }
  .md\\:from-red-300 {
    --gradient-from-color: #f8b4b4;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(248, 180, 180, 0));
  }
  .md\\:from-red-400 {
    --gradient-from-color: #f98080;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(249, 128, 128, 0));
  }
  .md\\:from-red-500 {
    --gradient-from-color: #f05252;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(240, 82, 82, 0));
  }
  .md\\:from-red-600 {
    --gradient-from-color: #e02424;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(224, 36, 36, 0));
  }
  .md\\:from-red-700 {
    --gradient-from-color: #c81e1e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(200, 30, 30, 0));
  }
  .md\\:from-red-800 {
    --gradient-from-color: #9b1c1c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(155, 28, 28, 0));
  }
  .md\\:from-red-900 {
    --gradient-from-color: #771d1d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(119, 29, 29, 0));
  }
  .md\\:from-orange-50 {
    --gradient-from-color: #fff8f1;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 248, 241, 0));
  }
  .md\\:from-orange-100 {
    --gradient-from-color: #feecdc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 236, 220, 0));
  }
  .md\\:from-orange-200 {
    --gradient-from-color: #fcd9bd;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(252, 217, 189, 0));
  }
  .md\\:from-orange-300 {
    --gradient-from-color: #fdba8c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 186, 140, 0));
  }
  .md\\:from-orange-400 {
    --gradient-from-color: #ff8a4c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 138, 76, 0));
  }
  .md\\:from-orange-500 {
    --gradient-from-color: #ff5a1f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 90, 31, 0));
  }
  .md\\:from-orange-600 {
    --gradient-from-color: #d03801;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(208, 56, 1, 0));
  }
  .md\\:from-orange-700 {
    --gradient-from-color: #b43403;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(180, 52, 3, 0));
  }
  .md\\:from-orange-800 {
    --gradient-from-color: #8a2c0d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(138, 44, 13, 0));
  }
  .md\\:from-orange-900 {
    --gradient-from-color: #73230d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(115, 35, 13, 0));
  }
  .md\\:from-yellow-50 {
    --gradient-from-color: #fdfdea;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 253, 234, 0));
  }
  .md\\:from-yellow-100 {
    --gradient-from-color: #fdf6b2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 246, 178, 0));
  }
  .md\\:from-yellow-200 {
    --gradient-from-color: #fce96a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(252, 233, 106, 0));
  }
  .md\\:from-yellow-300 {
    --gradient-from-color: #faca15;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(250, 202, 21, 0));
  }
  .md\\:from-yellow-400 {
    --gradient-from-color: #e3a008;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(227, 160, 8, 0));
  }
  .md\\:from-yellow-500 {
    --gradient-from-color: #c27803;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(194, 120, 3, 0));
  }
  .md\\:from-yellow-600 {
    --gradient-from-color: #9f580a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(159, 88, 10, 0));
  }
  .md\\:from-yellow-700 {
    --gradient-from-color: #8e4b10;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(142, 75, 16, 0));
  }
  .md\\:from-yellow-800 {
    --gradient-from-color: #723b13;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(114, 59, 19, 0));
  }
  .md\\:from-yellow-900 {
    --gradient-from-color: #633112;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(99, 49, 18, 0));
  }
  .md\\:from-green-50 {
    --gradient-from-color: #f3faf7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(243, 250, 247, 0));
  }
  .md\\:from-green-100 {
    --gradient-from-color: #def7ec;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(222, 247, 236, 0));
  }
  .md\\:from-green-200 {
    --gradient-from-color: #bcf0da;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(188, 240, 218, 0));
  }
  .md\\:from-green-300 {
    --gradient-from-color: #84e1bc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(132, 225, 188, 0));
  }
  .md\\:from-green-400 {
    --gradient-from-color: #31c48d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(49, 196, 141, 0));
  }
  .md\\:from-green-500 {
    --gradient-from-color: #0e9f6e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(14, 159, 110, 0));
  }
  .md\\:from-green-600 {
    --gradient-from-color: #057a55;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(5, 122, 85, 0));
  }
  .md\\:from-green-700 {
    --gradient-from-color: #046c4e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(4, 108, 78, 0));
  }
  .md\\:from-green-800 {
    --gradient-from-color: #03543f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(3, 84, 63, 0));
  }
  .md\\:from-green-900 {
    --gradient-from-color: #014737;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(1, 71, 55, 0));
  }
  .md\\:from-teal-50 {
    --gradient-from-color: #edfafa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(237, 250, 250, 0));
  }
  .md\\:from-teal-100 {
    --gradient-from-color: #d5f5f6;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(213, 245, 246, 0));
  }
  .md\\:from-teal-200 {
    --gradient-from-color: #afecef;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(175, 236, 239, 0));
  }
  .md\\:from-teal-300 {
    --gradient-from-color: #7edce2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(126, 220, 226, 0));
  }
  .md\\:from-teal-400 {
    --gradient-from-color: #16bdca;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(22, 189, 202, 0));
  }
  .md\\:from-teal-500 {
    --gradient-from-color: #0694a2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(6, 148, 162, 0));
  }
  .md\\:from-teal-600 {
    --gradient-from-color: #047481;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(4, 116, 129, 0));
  }
  .md\\:from-teal-700 {
    --gradient-from-color: #036672;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(3, 102, 114, 0));
  }
  .md\\:from-teal-800 {
    --gradient-from-color: #05505c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(5, 80, 92, 0));
  }
  .md\\:from-teal-900 {
    --gradient-from-color: #014451;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(1, 68, 81, 0));
  }
  .md\\:from-blue-50 {
    --gradient-from-color: #ebf5ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(235, 245, 255, 0));
  }
  .md\\:from-blue-100 {
    --gradient-from-color: #e1effe;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(225, 239, 254, 0));
  }
  .md\\:from-blue-200 {
    --gradient-from-color: #c3ddfd;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(195, 221, 253, 0));
  }
  .md\\:from-blue-300 {
    --gradient-from-color: #a4cafe;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(164, 202, 254, 0));
  }
  .md\\:from-blue-400 {
    --gradient-from-color: #76a9fa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(118, 169, 250, 0));
  }
  .md\\:from-blue-500 {
    --gradient-from-color: #3f83f8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(63, 131, 248, 0));
  }
  .md\\:from-blue-600 {
    --gradient-from-color: #1c64f2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(28, 100, 242, 0));
  }
  .md\\:from-blue-700 {
    --gradient-from-color: #1a56db;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(26, 86, 219, 0));
  }
  .md\\:from-blue-800 {
    --gradient-from-color: #1e429f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(30, 66, 159, 0));
  }
  .md\\:from-blue-900 {
    --gradient-from-color: #233876;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(35, 56, 118, 0));
  }
  .md\\:from-indigo-50 {
    --gradient-from-color: #f0f5ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(240, 245, 255, 0));
  }
  .md\\:from-indigo-100 {
    --gradient-from-color: #e5edff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(229, 237, 255, 0));
  }
  .md\\:from-indigo-200 {
    --gradient-from-color: #cddbfe;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(205, 219, 254, 0));
  }
  .md\\:from-indigo-300 {
    --gradient-from-color: #b4c6fc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(180, 198, 252, 0));
  }
  .md\\:from-indigo-400 {
    --gradient-from-color: #8da2fb;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(141, 162, 251, 0));
  }
  .md\\:from-indigo-500 {
    --gradient-from-color: #6875f5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(104, 117, 245, 0));
  }
  .md\\:from-indigo-600 {
    --gradient-from-color: #5850ec;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(88, 80, 236, 0));
  }
  .md\\:from-indigo-700 {
    --gradient-from-color: #5145cd;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(81, 69, 205, 0));
  }
  .md\\:from-indigo-800 {
    --gradient-from-color: #42389d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(66, 56, 157, 0));
  }
  .md\\:from-indigo-900 {
    --gradient-from-color: #362f78;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(54, 47, 120, 0));
  }
  .md\\:from-purple-50 {
    --gradient-from-color: #f6f5ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(246, 245, 255, 0));
  }
  .md\\:from-purple-100 {
    --gradient-from-color: #edebfe;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(237, 235, 254, 0));
  }
  .md\\:from-purple-200 {
    --gradient-from-color: #dcd7fe;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(220, 215, 254, 0));
  }
  .md\\:from-purple-300 {
    --gradient-from-color: #cabffd;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(202, 191, 253, 0));
  }
  .md\\:from-purple-400 {
    --gradient-from-color: #ac94fa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(172, 148, 250, 0));
  }
  .md\\:from-purple-500 {
    --gradient-from-color: #9061f9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(144, 97, 249, 0));
  }
  .md\\:from-purple-600 {
    --gradient-from-color: #7e3af2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(126, 58, 242, 0));
  }
  .md\\:from-purple-700 {
    --gradient-from-color: #6c2bd9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(108, 43, 217, 0));
  }
  .md\\:from-purple-800 {
    --gradient-from-color: #5521b5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(85, 33, 181, 0));
  }
  .md\\:from-purple-900 {
    --gradient-from-color: #4a1d96;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(74, 29, 150, 0));
  }
  .md\\:from-pink-50 {
    --gradient-from-color: #fdf2f8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 242, 248, 0));
  }
  .md\\:from-pink-100 {
    --gradient-from-color: #fce8f3;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(252, 232, 243, 0));
  }
  .md\\:from-pink-200 {
    --gradient-from-color: #fad1e8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(250, 209, 232, 0));
  }
  .md\\:from-pink-300 {
    --gradient-from-color: #f8b4d9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(248, 180, 217, 0));
  }
  .md\\:from-pink-400 {
    --gradient-from-color: #f17eb8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(241, 126, 184, 0));
  }
  .md\\:from-pink-500 {
    --gradient-from-color: #e74694;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(231, 70, 148, 0));
  }
  .md\\:from-pink-600 {
    --gradient-from-color: #d61f69;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(214, 31, 105, 0));
  }
  .md\\:from-pink-700 {
    --gradient-from-color: #bf125d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(191, 18, 93, 0));
  }
  .md\\:from-pink-800 {
    --gradient-from-color: #99154b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(153, 21, 75, 0));
  }
  .md\\:from-pink-900 {
    --gradient-from-color: #751a3d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(117, 26, 61, 0));
  }
  .md\\:from-cool-gray-50 {
    --gradient-from-color: #f8fafc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(248, 250, 252, 0));
  }
  .md\\:from-cool-gray-100 {
    --gradient-from-color: #f1f5f9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(241, 245, 249, 0));
  }
  .md\\:from-cool-gray-200 {
    --gradient-from-color: #e2e8f0;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(226, 232, 240, 0));
  }
  .md\\:from-cool-gray-300 {
    --gradient-from-color: #cfd8e3;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(207, 216, 227, 0));
  }
  .md\\:from-cool-gray-400 {
    --gradient-from-color: #97a6ba;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(151, 166, 186, 0));
  }
  .md\\:from-cool-gray-500 {
    --gradient-from-color: #64748b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(100, 116, 139, 0));
  }
  .md\\:from-cool-gray-600 {
    --gradient-from-color: #475569;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(71, 85, 105, 0));
  }
  .md\\:from-cool-gray-700 {
    --gradient-from-color: #364152;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(54, 65, 82, 0));
  }
  .md\\:from-cool-gray-800 {
    --gradient-from-color: #27303f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(39, 48, 63, 0));
  }
  .md\\:from-cool-gray-900 {
    --gradient-from-color: #1a202e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(26, 32, 46, 0));
  }
  .md\\:via-current {
    --gradient-via-color: currentColor;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }
  .md\\:via-transparent {
    --gradient-via-color: transparent;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  }
  .md\\:via-white {
    --gradient-via-color: #ffffff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }
  .md\\:via-black {
    --gradient-via-color: #000000;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  }
  .md\\:via-gray-50 {
    --gradient-via-color: #f9fafb;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(249, 250, 251, 0));
  }
  .md\\:via-gray-100 {
    --gradient-via-color: #f4f5f7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(244, 245, 247, 0));
  }
  .md\\:via-gray-200 {
    --gradient-via-color: #e5e7eb;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(229, 231, 235, 0));
  }
  .md\\:via-gray-300 {
    --gradient-via-color: #d2d6dc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(210, 214, 220, 0));
  }
  .md\\:via-gray-400 {
    --gradient-via-color: #9fa6b2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(159, 166, 178, 0));
  }
  .md\\:via-gray-500 {
    --gradient-via-color: #6b7280;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(107, 114, 128, 0));
  }
  .md\\:via-gray-600 {
    --gradient-via-color: #4b5563;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(75, 85, 99, 0));
  }
  .md\\:via-gray-700 {
    --gradient-via-color: #374151;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(55, 65, 81, 0));
  }
  .md\\:via-gray-800 {
    --gradient-via-color: #252f3f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(37, 47, 63, 0));
  }
  .md\\:via-gray-900 {
    --gradient-via-color: #161e2e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(22, 30, 46, 0));
  }
  .md\\:via-red-50 {
    --gradient-via-color: #fdf2f2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 242, 242, 0));
  }
  .md\\:via-red-100 {
    --gradient-via-color: #fde8e8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 232, 232, 0));
  }
  .md\\:via-red-200 {
    --gradient-via-color: #fbd5d5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(251, 213, 213, 0));
  }
  .md\\:via-red-300 {
    --gradient-via-color: #f8b4b4;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(248, 180, 180, 0));
  }
  .md\\:via-red-400 {
    --gradient-via-color: #f98080;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(249, 128, 128, 0));
  }
  .md\\:via-red-500 {
    --gradient-via-color: #f05252;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(240, 82, 82, 0));
  }
  .md\\:via-red-600 {
    --gradient-via-color: #e02424;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(224, 36, 36, 0));
  }
  .md\\:via-red-700 {
    --gradient-via-color: #c81e1e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(200, 30, 30, 0));
  }
  .md\\:via-red-800 {
    --gradient-via-color: #9b1c1c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(155, 28, 28, 0));
  }
  .md\\:via-red-900 {
    --gradient-via-color: #771d1d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(119, 29, 29, 0));
  }
  .md\\:via-orange-50 {
    --gradient-via-color: #fff8f1;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 248, 241, 0));
  }
  .md\\:via-orange-100 {
    --gradient-via-color: #feecdc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 236, 220, 0));
  }
  .md\\:via-orange-200 {
    --gradient-via-color: #fcd9bd;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(252, 217, 189, 0));
  }
  .md\\:via-orange-300 {
    --gradient-via-color: #fdba8c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 186, 140, 0));
  }
  .md\\:via-orange-400 {
    --gradient-via-color: #ff8a4c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 138, 76, 0));
  }
  .md\\:via-orange-500 {
    --gradient-via-color: #ff5a1f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 90, 31, 0));
  }
  .md\\:via-orange-600 {
    --gradient-via-color: #d03801;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(208, 56, 1, 0));
  }
  .md\\:via-orange-700 {
    --gradient-via-color: #b43403;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(180, 52, 3, 0));
  }
  .md\\:via-orange-800 {
    --gradient-via-color: #8a2c0d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(138, 44, 13, 0));
  }
  .md\\:via-orange-900 {
    --gradient-via-color: #73230d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(115, 35, 13, 0));
  }
  .md\\:via-yellow-50 {
    --gradient-via-color: #fdfdea;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 253, 234, 0));
  }
  .md\\:via-yellow-100 {
    --gradient-via-color: #fdf6b2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 246, 178, 0));
  }
  .md\\:via-yellow-200 {
    --gradient-via-color: #fce96a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(252, 233, 106, 0));
  }
  .md\\:via-yellow-300 {
    --gradient-via-color: #faca15;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(250, 202, 21, 0));
  }
  .md\\:via-yellow-400 {
    --gradient-via-color: #e3a008;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(227, 160, 8, 0));
  }
  .md\\:via-yellow-500 {
    --gradient-via-color: #c27803;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(194, 120, 3, 0));
  }
  .md\\:via-yellow-600 {
    --gradient-via-color: #9f580a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(159, 88, 10, 0));
  }
  .md\\:via-yellow-700 {
    --gradient-via-color: #8e4b10;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(142, 75, 16, 0));
  }
  .md\\:via-yellow-800 {
    --gradient-via-color: #723b13;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(114, 59, 19, 0));
  }
  .md\\:via-yellow-900 {
    --gradient-via-color: #633112;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(99, 49, 18, 0));
  }
  .md\\:via-green-50 {
    --gradient-via-color: #f3faf7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(243, 250, 247, 0));
  }
  .md\\:via-green-100 {
    --gradient-via-color: #def7ec;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(222, 247, 236, 0));
  }
  .md\\:via-green-200 {
    --gradient-via-color: #bcf0da;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(188, 240, 218, 0));
  }
  .md\\:via-green-300 {
    --gradient-via-color: #84e1bc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(132, 225, 188, 0));
  }
  .md\\:via-green-400 {
    --gradient-via-color: #31c48d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(49, 196, 141, 0));
  }
  .md\\:via-green-500 {
    --gradient-via-color: #0e9f6e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(14, 159, 110, 0));
  }
  .md\\:via-green-600 {
    --gradient-via-color: #057a55;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(5, 122, 85, 0));
  }
  .md\\:via-green-700 {
    --gradient-via-color: #046c4e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(4, 108, 78, 0));
  }
  .md\\:via-green-800 {
    --gradient-via-color: #03543f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(3, 84, 63, 0));
  }
  .md\\:via-green-900 {
    --gradient-via-color: #014737;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(1, 71, 55, 0));
  }
  .md\\:via-teal-50 {
    --gradient-via-color: #edfafa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(237, 250, 250, 0));
  }
  .md\\:via-teal-100 {
    --gradient-via-color: #d5f5f6;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(213, 245, 246, 0));
  }
  .md\\:via-teal-200 {
    --gradient-via-color: #afecef;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(175, 236, 239, 0));
  }
  .md\\:via-teal-300 {
    --gradient-via-color: #7edce2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(126, 220, 226, 0));
  }
  .md\\:via-teal-400 {
    --gradient-via-color: #16bdca;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(22, 189, 202, 0));
  }
  .md\\:via-teal-500 {
    --gradient-via-color: #0694a2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(6, 148, 162, 0));
  }
  .md\\:via-teal-600 {
    --gradient-via-color: #047481;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(4, 116, 129, 0));
  }
  .md\\:via-teal-700 {
    --gradient-via-color: #036672;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(3, 102, 114, 0));
  }
  .md\\:via-teal-800 {
    --gradient-via-color: #05505c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(5, 80, 92, 0));
  }
  .md\\:via-teal-900 {
    --gradient-via-color: #014451;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(1, 68, 81, 0));
  }
  .md\\:via-blue-50 {
    --gradient-via-color: #ebf5ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(235, 245, 255, 0));
  }
  .md\\:via-blue-100 {
    --gradient-via-color: #e1effe;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(225, 239, 254, 0));
  }
  .md\\:via-blue-200 {
    --gradient-via-color: #c3ddfd;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(195, 221, 253, 0));
  }
  .md\\:via-blue-300 {
    --gradient-via-color: #a4cafe;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(164, 202, 254, 0));
  }
  .md\\:via-blue-400 {
    --gradient-via-color: #76a9fa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(118, 169, 250, 0));
  }
  .md\\:via-blue-500 {
    --gradient-via-color: #3f83f8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(63, 131, 248, 0));
  }
  .md\\:via-blue-600 {
    --gradient-via-color: #1c64f2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(28, 100, 242, 0));
  }
  .md\\:via-blue-700 {
    --gradient-via-color: #1a56db;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(26, 86, 219, 0));
  }
  .md\\:via-blue-800 {
    --gradient-via-color: #1e429f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(30, 66, 159, 0));
  }
  .md\\:via-blue-900 {
    --gradient-via-color: #233876;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(35, 56, 118, 0));
  }
  .md\\:via-indigo-50 {
    --gradient-via-color: #f0f5ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(240, 245, 255, 0));
  }
  .md\\:via-indigo-100 {
    --gradient-via-color: #e5edff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(229, 237, 255, 0));
  }
  .md\\:via-indigo-200 {
    --gradient-via-color: #cddbfe;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(205, 219, 254, 0));
  }
  .md\\:via-indigo-300 {
    --gradient-via-color: #b4c6fc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(180, 198, 252, 0));
  }
  .md\\:via-indigo-400 {
    --gradient-via-color: #8da2fb;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(141, 162, 251, 0));
  }
  .md\\:via-indigo-500 {
    --gradient-via-color: #6875f5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(104, 117, 245, 0));
  }
  .md\\:via-indigo-600 {
    --gradient-via-color: #5850ec;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(88, 80, 236, 0));
  }
  .md\\:via-indigo-700 {
    --gradient-via-color: #5145cd;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(81, 69, 205, 0));
  }
  .md\\:via-indigo-800 {
    --gradient-via-color: #42389d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(66, 56, 157, 0));
  }
  .md\\:via-indigo-900 {
    --gradient-via-color: #362f78;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(54, 47, 120, 0));
  }
  .md\\:via-purple-50 {
    --gradient-via-color: #f6f5ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(246, 245, 255, 0));
  }
  .md\\:via-purple-100 {
    --gradient-via-color: #edebfe;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(237, 235, 254, 0));
  }
  .md\\:via-purple-200 {
    --gradient-via-color: #dcd7fe;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(220, 215, 254, 0));
  }
  .md\\:via-purple-300 {
    --gradient-via-color: #cabffd;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(202, 191, 253, 0));
  }
  .md\\:via-purple-400 {
    --gradient-via-color: #ac94fa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(172, 148, 250, 0));
  }
  .md\\:via-purple-500 {
    --gradient-via-color: #9061f9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(144, 97, 249, 0));
  }
  .md\\:via-purple-600 {
    --gradient-via-color: #7e3af2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(126, 58, 242, 0));
  }
  .md\\:via-purple-700 {
    --gradient-via-color: #6c2bd9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(108, 43, 217, 0));
  }
  .md\\:via-purple-800 {
    --gradient-via-color: #5521b5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(85, 33, 181, 0));
  }
  .md\\:via-purple-900 {
    --gradient-via-color: #4a1d96;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(74, 29, 150, 0));
  }
  .md\\:via-pink-50 {
    --gradient-via-color: #fdf2f8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 242, 248, 0));
  }
  .md\\:via-pink-100 {
    --gradient-via-color: #fce8f3;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(252, 232, 243, 0));
  }
  .md\\:via-pink-200 {
    --gradient-via-color: #fad1e8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(250, 209, 232, 0));
  }
  .md\\:via-pink-300 {
    --gradient-via-color: #f8b4d9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(248, 180, 217, 0));
  }
  .md\\:via-pink-400 {
    --gradient-via-color: #f17eb8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(241, 126, 184, 0));
  }
  .md\\:via-pink-500 {
    --gradient-via-color: #e74694;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(231, 70, 148, 0));
  }
  .md\\:via-pink-600 {
    --gradient-via-color: #d61f69;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(214, 31, 105, 0));
  }
  .md\\:via-pink-700 {
    --gradient-via-color: #bf125d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(191, 18, 93, 0));
  }
  .md\\:via-pink-800 {
    --gradient-via-color: #99154b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(153, 21, 75, 0));
  }
  .md\\:via-pink-900 {
    --gradient-via-color: #751a3d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(117, 26, 61, 0));
  }
  .md\\:via-cool-gray-50 {
    --gradient-via-color: #f8fafc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(248, 250, 252, 0));
  }
  .md\\:via-cool-gray-100 {
    --gradient-via-color: #f1f5f9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(241, 245, 249, 0));
  }
  .md\\:via-cool-gray-200 {
    --gradient-via-color: #e2e8f0;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(226, 232, 240, 0));
  }
  .md\\:via-cool-gray-300 {
    --gradient-via-color: #cfd8e3;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(207, 216, 227, 0));
  }
  .md\\:via-cool-gray-400 {
    --gradient-via-color: #97a6ba;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(151, 166, 186, 0));
  }
  .md\\:via-cool-gray-500 {
    --gradient-via-color: #64748b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(100, 116, 139, 0));
  }
  .md\\:via-cool-gray-600 {
    --gradient-via-color: #475569;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(71, 85, 105, 0));
  }
  .md\\:via-cool-gray-700 {
    --gradient-via-color: #364152;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(54, 65, 82, 0));
  }
  .md\\:via-cool-gray-800 {
    --gradient-via-color: #27303f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(39, 48, 63, 0));
  }
  .md\\:via-cool-gray-900 {
    --gradient-via-color: #1a202e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(26, 32, 46, 0));
  }
  .md\\:to-current {
    --gradient-to-color: currentColor;
  }
  .md\\:to-transparent {
    --gradient-to-color: transparent;
  }
  .md\\:to-white {
    --gradient-to-color: #ffffff;
  }
  .md\\:to-black {
    --gradient-to-color: #000000;
  }
  .md\\:to-gray-50 {
    --gradient-to-color: #f9fafb;
  }
  .md\\:to-gray-100 {
    --gradient-to-color: #f4f5f7;
  }
  .md\\:to-gray-200 {
    --gradient-to-color: #e5e7eb;
  }
  .md\\:to-gray-300 {
    --gradient-to-color: #d2d6dc;
  }
  .md\\:to-gray-400 {
    --gradient-to-color: #9fa6b2;
  }
  .md\\:to-gray-500 {
    --gradient-to-color: #6b7280;
  }
  .md\\:to-gray-600 {
    --gradient-to-color: #4b5563;
  }
  .md\\:to-gray-700 {
    --gradient-to-color: #374151;
  }
  .md\\:to-gray-800 {
    --gradient-to-color: #252f3f;
  }
  .md\\:to-gray-900 {
    --gradient-to-color: #161e2e;
  }
  .md\\:to-red-50 {
    --gradient-to-color: #fdf2f2;
  }
  .md\\:to-red-100 {
    --gradient-to-color: #fde8e8;
  }
  .md\\:to-red-200 {
    --gradient-to-color: #fbd5d5;
  }
  .md\\:to-red-300 {
    --gradient-to-color: #f8b4b4;
  }
  .md\\:to-red-400 {
    --gradient-to-color: #f98080;
  }
  .md\\:to-red-500 {
    --gradient-to-color: #f05252;
  }
  .md\\:to-red-600 {
    --gradient-to-color: #e02424;
  }
  .md\\:to-red-700 {
    --gradient-to-color: #c81e1e;
  }
  .md\\:to-red-800 {
    --gradient-to-color: #9b1c1c;
  }
  .md\\:to-red-900 {
    --gradient-to-color: #771d1d;
  }
  .md\\:to-orange-50 {
    --gradient-to-color: #fff8f1;
  }
  .md\\:to-orange-100 {
    --gradient-to-color: #feecdc;
  }
  .md\\:to-orange-200 {
    --gradient-to-color: #fcd9bd;
  }
  .md\\:to-orange-300 {
    --gradient-to-color: #fdba8c;
  }
  .md\\:to-orange-400 {
    --gradient-to-color: #ff8a4c;
  }
  .md\\:to-orange-500 {
    --gradient-to-color: #ff5a1f;
  }
  .md\\:to-orange-600 {
    --gradient-to-color: #d03801;
  }
  .md\\:to-orange-700 {
    --gradient-to-color: #b43403;
  }
  .md\\:to-orange-800 {
    --gradient-to-color: #8a2c0d;
  }
  .md\\:to-orange-900 {
    --gradient-to-color: #73230d;
  }
  .md\\:to-yellow-50 {
    --gradient-to-color: #fdfdea;
  }
  .md\\:to-yellow-100 {
    --gradient-to-color: #fdf6b2;
  }
  .md\\:to-yellow-200 {
    --gradient-to-color: #fce96a;
  }
  .md\\:to-yellow-300 {
    --gradient-to-color: #faca15;
  }
  .md\\:to-yellow-400 {
    --gradient-to-color: #e3a008;
  }
  .md\\:to-yellow-500 {
    --gradient-to-color: #c27803;
  }
  .md\\:to-yellow-600 {
    --gradient-to-color: #9f580a;
  }
  .md\\:to-yellow-700 {
    --gradient-to-color: #8e4b10;
  }
  .md\\:to-yellow-800 {
    --gradient-to-color: #723b13;
  }
  .md\\:to-yellow-900 {
    --gradient-to-color: #633112;
  }
  .md\\:to-green-50 {
    --gradient-to-color: #f3faf7;
  }
  .md\\:to-green-100 {
    --gradient-to-color: #def7ec;
  }
  .md\\:to-green-200 {
    --gradient-to-color: #bcf0da;
  }
  .md\\:to-green-300 {
    --gradient-to-color: #84e1bc;
  }
  .md\\:to-green-400 {
    --gradient-to-color: #31c48d;
  }
  .md\\:to-green-500 {
    --gradient-to-color: #0e9f6e;
  }
  .md\\:to-green-600 {
    --gradient-to-color: #057a55;
  }
  .md\\:to-green-700 {
    --gradient-to-color: #046c4e;
  }
  .md\\:to-green-800 {
    --gradient-to-color: #03543f;
  }
  .md\\:to-green-900 {
    --gradient-to-color: #014737;
  }
  .md\\:to-teal-50 {
    --gradient-to-color: #edfafa;
  }
  .md\\:to-teal-100 {
    --gradient-to-color: #d5f5f6;
  }
  .md\\:to-teal-200 {
    --gradient-to-color: #afecef;
  }
  .md\\:to-teal-300 {
    --gradient-to-color: #7edce2;
  }
  .md\\:to-teal-400 {
    --gradient-to-color: #16bdca;
  }
  .md\\:to-teal-500 {
    --gradient-to-color: #0694a2;
  }
  .md\\:to-teal-600 {
    --gradient-to-color: #047481;
  }
  .md\\:to-teal-700 {
    --gradient-to-color: #036672;
  }
  .md\\:to-teal-800 {
    --gradient-to-color: #05505c;
  }
  .md\\:to-teal-900 {
    --gradient-to-color: #014451;
  }
  .md\\:to-blue-50 {
    --gradient-to-color: #ebf5ff;
  }
  .md\\:to-blue-100 {
    --gradient-to-color: #e1effe;
  }
  .md\\:to-blue-200 {
    --gradient-to-color: #c3ddfd;
  }
  .md\\:to-blue-300 {
    --gradient-to-color: #a4cafe;
  }
  .md\\:to-blue-400 {
    --gradient-to-color: #76a9fa;
  }
  .md\\:to-blue-500 {
    --gradient-to-color: #3f83f8;
  }
  .md\\:to-blue-600 {
    --gradient-to-color: #1c64f2;
  }
  .md\\:to-blue-700 {
    --gradient-to-color: #1a56db;
  }
  .md\\:to-blue-800 {
    --gradient-to-color: #1e429f;
  }
  .md\\:to-blue-900 {
    --gradient-to-color: #233876;
  }
  .md\\:to-indigo-50 {
    --gradient-to-color: #f0f5ff;
  }
  .md\\:to-indigo-100 {
    --gradient-to-color: #e5edff;
  }
  .md\\:to-indigo-200 {
    --gradient-to-color: #cddbfe;
  }
  .md\\:to-indigo-300 {
    --gradient-to-color: #b4c6fc;
  }
  .md\\:to-indigo-400 {
    --gradient-to-color: #8da2fb;
  }
  .md\\:to-indigo-500 {
    --gradient-to-color: #6875f5;
  }
  .md\\:to-indigo-600 {
    --gradient-to-color: #5850ec;
  }
  .md\\:to-indigo-700 {
    --gradient-to-color: #5145cd;
  }
  .md\\:to-indigo-800 {
    --gradient-to-color: #42389d;
  }
  .md\\:to-indigo-900 {
    --gradient-to-color: #362f78;
  }
  .md\\:to-purple-50 {
    --gradient-to-color: #f6f5ff;
  }
  .md\\:to-purple-100 {
    --gradient-to-color: #edebfe;
  }
  .md\\:to-purple-200 {
    --gradient-to-color: #dcd7fe;
  }
  .md\\:to-purple-300 {
    --gradient-to-color: #cabffd;
  }
  .md\\:to-purple-400 {
    --gradient-to-color: #ac94fa;
  }
  .md\\:to-purple-500 {
    --gradient-to-color: #9061f9;
  }
  .md\\:to-purple-600 {
    --gradient-to-color: #7e3af2;
  }
  .md\\:to-purple-700 {
    --gradient-to-color: #6c2bd9;
  }
  .md\\:to-purple-800 {
    --gradient-to-color: #5521b5;
  }
  .md\\:to-purple-900 {
    --gradient-to-color: #4a1d96;
  }
  .md\\:to-pink-50 {
    --gradient-to-color: #fdf2f8;
  }
  .md\\:to-pink-100 {
    --gradient-to-color: #fce8f3;
  }
  .md\\:to-pink-200 {
    --gradient-to-color: #fad1e8;
  }
  .md\\:to-pink-300 {
    --gradient-to-color: #f8b4d9;
  }
  .md\\:to-pink-400 {
    --gradient-to-color: #f17eb8;
  }
  .md\\:to-pink-500 {
    --gradient-to-color: #e74694;
  }
  .md\\:to-pink-600 {
    --gradient-to-color: #d61f69;
  }
  .md\\:to-pink-700 {
    --gradient-to-color: #bf125d;
  }
  .md\\:to-pink-800 {
    --gradient-to-color: #99154b;
  }
  .md\\:to-pink-900 {
    --gradient-to-color: #751a3d;
  }
  .md\\:to-cool-gray-50 {
    --gradient-to-color: #f8fafc;
  }
  .md\\:to-cool-gray-100 {
    --gradient-to-color: #f1f5f9;
  }
  .md\\:to-cool-gray-200 {
    --gradient-to-color: #e2e8f0;
  }
  .md\\:to-cool-gray-300 {
    --gradient-to-color: #cfd8e3;
  }
  .md\\:to-cool-gray-400 {
    --gradient-to-color: #97a6ba;
  }
  .md\\:to-cool-gray-500 {
    --gradient-to-color: #64748b;
  }
  .md\\:to-cool-gray-600 {
    --gradient-to-color: #475569;
  }
  .md\\:to-cool-gray-700 {
    --gradient-to-color: #364152;
  }
  .md\\:to-cool-gray-800 {
    --gradient-to-color: #27303f;
  }
  .md\\:to-cool-gray-900 {
    --gradient-to-color: #1a202e;
  }
  .md\\:hover\\:from-current:hover {
    --gradient-from-color: currentColor;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }
  .md\\:hover\\:from-transparent:hover {
    --gradient-from-color: transparent;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  }
  .md\\:hover\\:from-white:hover {
    --gradient-from-color: #ffffff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }
  .md\\:hover\\:from-black:hover {
    --gradient-from-color: #000000;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  }
  .md\\:hover\\:from-gray-50:hover {
    --gradient-from-color: #f9fafb;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(249, 250, 251, 0));
  }
  .md\\:hover\\:from-gray-100:hover {
    --gradient-from-color: #f4f5f7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(244, 245, 247, 0));
  }
  .md\\:hover\\:from-gray-200:hover {
    --gradient-from-color: #e5e7eb;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(229, 231, 235, 0));
  }
  .md\\:hover\\:from-gray-300:hover {
    --gradient-from-color: #d2d6dc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(210, 214, 220, 0));
  }
  .md\\:hover\\:from-gray-400:hover {
    --gradient-from-color: #9fa6b2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(159, 166, 178, 0));
  }
  .md\\:hover\\:from-gray-500:hover {
    --gradient-from-color: #6b7280;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(107, 114, 128, 0));
  }
  .md\\:hover\\:from-gray-600:hover {
    --gradient-from-color: #4b5563;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(75, 85, 99, 0));
  }
  .md\\:hover\\:from-gray-700:hover {
    --gradient-from-color: #374151;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(55, 65, 81, 0));
  }
  .md\\:hover\\:from-gray-800:hover {
    --gradient-from-color: #252f3f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(37, 47, 63, 0));
  }
  .md\\:hover\\:from-gray-900:hover {
    --gradient-from-color: #161e2e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(22, 30, 46, 0));
  }
  .md\\:hover\\:from-red-50:hover {
    --gradient-from-color: #fdf2f2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 242, 242, 0));
  }
  .md\\:hover\\:from-red-100:hover {
    --gradient-from-color: #fde8e8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 232, 232, 0));
  }
  .md\\:hover\\:from-red-200:hover {
    --gradient-from-color: #fbd5d5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(251, 213, 213, 0));
  }
  .md\\:hover\\:from-red-300:hover {
    --gradient-from-color: #f8b4b4;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(248, 180, 180, 0));
  }
  .md\\:hover\\:from-red-400:hover {
    --gradient-from-color: #f98080;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(249, 128, 128, 0));
  }
  .md\\:hover\\:from-red-500:hover {
    --gradient-from-color: #f05252;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(240, 82, 82, 0));
  }
  .md\\:hover\\:from-red-600:hover {
    --gradient-from-color: #e02424;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(224, 36, 36, 0));
  }
  .md\\:hover\\:from-red-700:hover {
    --gradient-from-color: #c81e1e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(200, 30, 30, 0));
  }
  .md\\:hover\\:from-red-800:hover {
    --gradient-from-color: #9b1c1c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(155, 28, 28, 0));
  }
  .md\\:hover\\:from-red-900:hover {
    --gradient-from-color: #771d1d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(119, 29, 29, 0));
  }
  .md\\:hover\\:from-orange-50:hover {
    --gradient-from-color: #fff8f1;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 248, 241, 0));
  }
  .md\\:hover\\:from-orange-100:hover {
    --gradient-from-color: #feecdc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 236, 220, 0));
  }
  .md\\:hover\\:from-orange-200:hover {
    --gradient-from-color: #fcd9bd;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(252, 217, 189, 0));
  }
  .md\\:hover\\:from-orange-300:hover {
    --gradient-from-color: #fdba8c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 186, 140, 0));
  }
  .md\\:hover\\:from-orange-400:hover {
    --gradient-from-color: #ff8a4c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 138, 76, 0));
  }
  .md\\:hover\\:from-orange-500:hover {
    --gradient-from-color: #ff5a1f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 90, 31, 0));
  }
  .md\\:hover\\:from-orange-600:hover {
    --gradient-from-color: #d03801;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(208, 56, 1, 0));
  }
  .md\\:hover\\:from-orange-700:hover {
    --gradient-from-color: #b43403;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(180, 52, 3, 0));
  }
  .md\\:hover\\:from-orange-800:hover {
    --gradient-from-color: #8a2c0d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(138, 44, 13, 0));
  }
  .md\\:hover\\:from-orange-900:hover {
    --gradient-from-color: #73230d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(115, 35, 13, 0));
  }
  .md\\:hover\\:from-yellow-50:hover {
    --gradient-from-color: #fdfdea;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 253, 234, 0));
  }
  .md\\:hover\\:from-yellow-100:hover {
    --gradient-from-color: #fdf6b2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 246, 178, 0));
  }
  .md\\:hover\\:from-yellow-200:hover {
    --gradient-from-color: #fce96a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(252, 233, 106, 0));
  }
  .md\\:hover\\:from-yellow-300:hover {
    --gradient-from-color: #faca15;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(250, 202, 21, 0));
  }
  .md\\:hover\\:from-yellow-400:hover {
    --gradient-from-color: #e3a008;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(227, 160, 8, 0));
  }
  .md\\:hover\\:from-yellow-500:hover {
    --gradient-from-color: #c27803;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(194, 120, 3, 0));
  }
  .md\\:hover\\:from-yellow-600:hover {
    --gradient-from-color: #9f580a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(159, 88, 10, 0));
  }
  .md\\:hover\\:from-yellow-700:hover {
    --gradient-from-color: #8e4b10;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(142, 75, 16, 0));
  }
  .md\\:hover\\:from-yellow-800:hover {
    --gradient-from-color: #723b13;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(114, 59, 19, 0));
  }
  .md\\:hover\\:from-yellow-900:hover {
    --gradient-from-color: #633112;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(99, 49, 18, 0));
  }
  .md\\:hover\\:from-green-50:hover {
    --gradient-from-color: #f3faf7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(243, 250, 247, 0));
  }
  .md\\:hover\\:from-green-100:hover {
    --gradient-from-color: #def7ec;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(222, 247, 236, 0));
  }
  .md\\:hover\\:from-green-200:hover {
    --gradient-from-color: #bcf0da;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(188, 240, 218, 0));
  }
  .md\\:hover\\:from-green-300:hover {
    --gradient-from-color: #84e1bc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(132, 225, 188, 0));
  }
  .md\\:hover\\:from-green-400:hover {
    --gradient-from-color: #31c48d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(49, 196, 141, 0));
  }
  .md\\:hover\\:from-green-500:hover {
    --gradient-from-color: #0e9f6e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(14, 159, 110, 0));
  }
  .md\\:hover\\:from-green-600:hover {
    --gradient-from-color: #057a55;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(5, 122, 85, 0));
  }
  .md\\:hover\\:from-green-700:hover {
    --gradient-from-color: #046c4e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(4, 108, 78, 0));
  }
  .md\\:hover\\:from-green-800:hover {
    --gradient-from-color: #03543f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(3, 84, 63, 0));
  }
  .md\\:hover\\:from-green-900:hover {
    --gradient-from-color: #014737;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(1, 71, 55, 0));
  }
  .md\\:hover\\:from-teal-50:hover {
    --gradient-from-color: #edfafa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(237, 250, 250, 0));
  }
  .md\\:hover\\:from-teal-100:hover {
    --gradient-from-color: #d5f5f6;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(213, 245, 246, 0));
  }
  .md\\:hover\\:from-teal-200:hover {
    --gradient-from-color: #afecef;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(175, 236, 239, 0));
  }
  .md\\:hover\\:from-teal-300:hover {
    --gradient-from-color: #7edce2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(126, 220, 226, 0));
  }
  .md\\:hover\\:from-teal-400:hover {
    --gradient-from-color: #16bdca;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(22, 189, 202, 0));
  }
  .md\\:hover\\:from-teal-500:hover {
    --gradient-from-color: #0694a2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(6, 148, 162, 0));
  }
  .md\\:hover\\:from-teal-600:hover {
    --gradient-from-color: #047481;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(4, 116, 129, 0));
  }
  .md\\:hover\\:from-teal-700:hover {
    --gradient-from-color: #036672;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(3, 102, 114, 0));
  }
  .md\\:hover\\:from-teal-800:hover {
    --gradient-from-color: #05505c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(5, 80, 92, 0));
  }
  .md\\:hover\\:from-teal-900:hover {
    --gradient-from-color: #014451;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(1, 68, 81, 0));
  }
  .md\\:hover\\:from-blue-50:hover {
    --gradient-from-color: #ebf5ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(235, 245, 255, 0));
  }
  .md\\:hover\\:from-blue-100:hover {
    --gradient-from-color: #e1effe;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(225, 239, 254, 0));
  }
  .md\\:hover\\:from-blue-200:hover {
    --gradient-from-color: #c3ddfd;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(195, 221, 253, 0));
  }
  .md\\:hover\\:from-blue-300:hover {
    --gradient-from-color: #a4cafe;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(164, 202, 254, 0));
  }
  .md\\:hover\\:from-blue-400:hover {
    --gradient-from-color: #76a9fa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(118, 169, 250, 0));
  }
  .md\\:hover\\:from-blue-500:hover {
    --gradient-from-color: #3f83f8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(63, 131, 248, 0));
  }
  .md\\:hover\\:from-blue-600:hover {
    --gradient-from-color: #1c64f2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(28, 100, 242, 0));
  }
  .md\\:hover\\:from-blue-700:hover {
    --gradient-from-color: #1a56db;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(26, 86, 219, 0));
  }
  .md\\:hover\\:from-blue-800:hover {
    --gradient-from-color: #1e429f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(30, 66, 159, 0));
  }
  .md\\:hover\\:from-blue-900:hover {
    --gradient-from-color: #233876;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(35, 56, 118, 0));
  }
  .md\\:hover\\:from-indigo-50:hover {
    --gradient-from-color: #f0f5ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(240, 245, 255, 0));
  }
  .md\\:hover\\:from-indigo-100:hover {
    --gradient-from-color: #e5edff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(229, 237, 255, 0));
  }
  .md\\:hover\\:from-indigo-200:hover {
    --gradient-from-color: #cddbfe;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(205, 219, 254, 0));
  }
  .md\\:hover\\:from-indigo-300:hover {
    --gradient-from-color: #b4c6fc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(180, 198, 252, 0));
  }
  .md\\:hover\\:from-indigo-400:hover {
    --gradient-from-color: #8da2fb;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(141, 162, 251, 0));
  }
  .md\\:hover\\:from-indigo-500:hover {
    --gradient-from-color: #6875f5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(104, 117, 245, 0));
  }
  .md\\:hover\\:from-indigo-600:hover {
    --gradient-from-color: #5850ec;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(88, 80, 236, 0));
  }
  .md\\:hover\\:from-indigo-700:hover {
    --gradient-from-color: #5145cd;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(81, 69, 205, 0));
  }
  .md\\:hover\\:from-indigo-800:hover {
    --gradient-from-color: #42389d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(66, 56, 157, 0));
  }
  .md\\:hover\\:from-indigo-900:hover {
    --gradient-from-color: #362f78;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(54, 47, 120, 0));
  }
  .md\\:hover\\:from-purple-50:hover {
    --gradient-from-color: #f6f5ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(246, 245, 255, 0));
  }
  .md\\:hover\\:from-purple-100:hover {
    --gradient-from-color: #edebfe;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(237, 235, 254, 0));
  }
  .md\\:hover\\:from-purple-200:hover {
    --gradient-from-color: #dcd7fe;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(220, 215, 254, 0));
  }
  .md\\:hover\\:from-purple-300:hover {
    --gradient-from-color: #cabffd;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(202, 191, 253, 0));
  }
  .md\\:hover\\:from-purple-400:hover {
    --gradient-from-color: #ac94fa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(172, 148, 250, 0));
  }
  .md\\:hover\\:from-purple-500:hover {
    --gradient-from-color: #9061f9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(144, 97, 249, 0));
  }
  .md\\:hover\\:from-purple-600:hover {
    --gradient-from-color: #7e3af2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(126, 58, 242, 0));
  }
  .md\\:hover\\:from-purple-700:hover {
    --gradient-from-color: #6c2bd9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(108, 43, 217, 0));
  }
  .md\\:hover\\:from-purple-800:hover {
    --gradient-from-color: #5521b5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(85, 33, 181, 0));
  }
  .md\\:hover\\:from-purple-900:hover {
    --gradient-from-color: #4a1d96;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(74, 29, 150, 0));
  }
  .md\\:hover\\:from-pink-50:hover {
    --gradient-from-color: #fdf2f8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 242, 248, 0));
  }
  .md\\:hover\\:from-pink-100:hover {
    --gradient-from-color: #fce8f3;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(252, 232, 243, 0));
  }
  .md\\:hover\\:from-pink-200:hover {
    --gradient-from-color: #fad1e8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(250, 209, 232, 0));
  }
  .md\\:hover\\:from-pink-300:hover {
    --gradient-from-color: #f8b4d9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(248, 180, 217, 0));
  }
  .md\\:hover\\:from-pink-400:hover {
    --gradient-from-color: #f17eb8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(241, 126, 184, 0));
  }
  .md\\:hover\\:from-pink-500:hover {
    --gradient-from-color: #e74694;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(231, 70, 148, 0));
  }
  .md\\:hover\\:from-pink-600:hover {
    --gradient-from-color: #d61f69;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(214, 31, 105, 0));
  }
  .md\\:hover\\:from-pink-700:hover {
    --gradient-from-color: #bf125d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(191, 18, 93, 0));
  }
  .md\\:hover\\:from-pink-800:hover {
    --gradient-from-color: #99154b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(153, 21, 75, 0));
  }
  .md\\:hover\\:from-pink-900:hover {
    --gradient-from-color: #751a3d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(117, 26, 61, 0));
  }
  .md\\:hover\\:from-cool-gray-50:hover {
    --gradient-from-color: #f8fafc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(248, 250, 252, 0));
  }
  .md\\:hover\\:from-cool-gray-100:hover {
    --gradient-from-color: #f1f5f9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(241, 245, 249, 0));
  }
  .md\\:hover\\:from-cool-gray-200:hover {
    --gradient-from-color: #e2e8f0;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(226, 232, 240, 0));
  }
  .md\\:hover\\:from-cool-gray-300:hover {
    --gradient-from-color: #cfd8e3;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(207, 216, 227, 0));
  }
  .md\\:hover\\:from-cool-gray-400:hover {
    --gradient-from-color: #97a6ba;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(151, 166, 186, 0));
  }
  .md\\:hover\\:from-cool-gray-500:hover {
    --gradient-from-color: #64748b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(100, 116, 139, 0));
  }
  .md\\:hover\\:from-cool-gray-600:hover {
    --gradient-from-color: #475569;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(71, 85, 105, 0));
  }
  .md\\:hover\\:from-cool-gray-700:hover {
    --gradient-from-color: #364152;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(54, 65, 82, 0));
  }
  .md\\:hover\\:from-cool-gray-800:hover {
    --gradient-from-color: #27303f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(39, 48, 63, 0));
  }
  .md\\:hover\\:from-cool-gray-900:hover {
    --gradient-from-color: #1a202e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(26, 32, 46, 0));
  }
  .md\\:hover\\:via-current:hover {
    --gradient-via-color: currentColor;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }
  .md\\:hover\\:via-transparent:hover {
    --gradient-via-color: transparent;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  }
  .md\\:hover\\:via-white:hover {
    --gradient-via-color: #ffffff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }
  .md\\:hover\\:via-black:hover {
    --gradient-via-color: #000000;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  }
  .md\\:hover\\:via-gray-50:hover {
    --gradient-via-color: #f9fafb;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(249, 250, 251, 0));
  }
  .md\\:hover\\:via-gray-100:hover {
    --gradient-via-color: #f4f5f7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(244, 245, 247, 0));
  }
  .md\\:hover\\:via-gray-200:hover {
    --gradient-via-color: #e5e7eb;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(229, 231, 235, 0));
  }
  .md\\:hover\\:via-gray-300:hover {
    --gradient-via-color: #d2d6dc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(210, 214, 220, 0));
  }
  .md\\:hover\\:via-gray-400:hover {
    --gradient-via-color: #9fa6b2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(159, 166, 178, 0));
  }
  .md\\:hover\\:via-gray-500:hover {
    --gradient-via-color: #6b7280;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(107, 114, 128, 0));
  }
  .md\\:hover\\:via-gray-600:hover {
    --gradient-via-color: #4b5563;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(75, 85, 99, 0));
  }
  .md\\:hover\\:via-gray-700:hover {
    --gradient-via-color: #374151;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(55, 65, 81, 0));
  }
  .md\\:hover\\:via-gray-800:hover {
    --gradient-via-color: #252f3f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(37, 47, 63, 0));
  }
  .md\\:hover\\:via-gray-900:hover {
    --gradient-via-color: #161e2e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(22, 30, 46, 0));
  }
  .md\\:hover\\:via-red-50:hover {
    --gradient-via-color: #fdf2f2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 242, 242, 0));
  }
  .md\\:hover\\:via-red-100:hover {
    --gradient-via-color: #fde8e8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 232, 232, 0));
  }
  .md\\:hover\\:via-red-200:hover {
    --gradient-via-color: #fbd5d5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(251, 213, 213, 0));
  }
  .md\\:hover\\:via-red-300:hover {
    --gradient-via-color: #f8b4b4;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(248, 180, 180, 0));
  }
  .md\\:hover\\:via-red-400:hover {
    --gradient-via-color: #f98080;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(249, 128, 128, 0));
  }
  .md\\:hover\\:via-red-500:hover {
    --gradient-via-color: #f05252;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(240, 82, 82, 0));
  }
  .md\\:hover\\:via-red-600:hover {
    --gradient-via-color: #e02424;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(224, 36, 36, 0));
  }
  .md\\:hover\\:via-red-700:hover {
    --gradient-via-color: #c81e1e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(200, 30, 30, 0));
  }
  .md\\:hover\\:via-red-800:hover {
    --gradient-via-color: #9b1c1c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(155, 28, 28, 0));
  }
  .md\\:hover\\:via-red-900:hover {
    --gradient-via-color: #771d1d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(119, 29, 29, 0));
  }
  .md\\:hover\\:via-orange-50:hover {
    --gradient-via-color: #fff8f1;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 248, 241, 0));
  }
  .md\\:hover\\:via-orange-100:hover {
    --gradient-via-color: #feecdc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 236, 220, 0));
  }
  .md\\:hover\\:via-orange-200:hover {
    --gradient-via-color: #fcd9bd;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(252, 217, 189, 0));
  }
  .md\\:hover\\:via-orange-300:hover {
    --gradient-via-color: #fdba8c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 186, 140, 0));
  }
  .md\\:hover\\:via-orange-400:hover {
    --gradient-via-color: #ff8a4c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 138, 76, 0));
  }
  .md\\:hover\\:via-orange-500:hover {
    --gradient-via-color: #ff5a1f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 90, 31, 0));
  }
  .md\\:hover\\:via-orange-600:hover {
    --gradient-via-color: #d03801;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(208, 56, 1, 0));
  }
  .md\\:hover\\:via-orange-700:hover {
    --gradient-via-color: #b43403;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(180, 52, 3, 0));
  }
  .md\\:hover\\:via-orange-800:hover {
    --gradient-via-color: #8a2c0d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(138, 44, 13, 0));
  }
  .md\\:hover\\:via-orange-900:hover {
    --gradient-via-color: #73230d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(115, 35, 13, 0));
  }
  .md\\:hover\\:via-yellow-50:hover {
    --gradient-via-color: #fdfdea;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 253, 234, 0));
  }
  .md\\:hover\\:via-yellow-100:hover {
    --gradient-via-color: #fdf6b2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 246, 178, 0));
  }
  .md\\:hover\\:via-yellow-200:hover {
    --gradient-via-color: #fce96a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(252, 233, 106, 0));
  }
  .md\\:hover\\:via-yellow-300:hover {
    --gradient-via-color: #faca15;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(250, 202, 21, 0));
  }
  .md\\:hover\\:via-yellow-400:hover {
    --gradient-via-color: #e3a008;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(227, 160, 8, 0));
  }
  .md\\:hover\\:via-yellow-500:hover {
    --gradient-via-color: #c27803;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(194, 120, 3, 0));
  }
  .md\\:hover\\:via-yellow-600:hover {
    --gradient-via-color: #9f580a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(159, 88, 10, 0));
  }
  .md\\:hover\\:via-yellow-700:hover {
    --gradient-via-color: #8e4b10;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(142, 75, 16, 0));
  }
  .md\\:hover\\:via-yellow-800:hover {
    --gradient-via-color: #723b13;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(114, 59, 19, 0));
  }
  .md\\:hover\\:via-yellow-900:hover {
    --gradient-via-color: #633112;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(99, 49, 18, 0));
  }
  .md\\:hover\\:via-green-50:hover {
    --gradient-via-color: #f3faf7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(243, 250, 247, 0));
  }
  .md\\:hover\\:via-green-100:hover {
    --gradient-via-color: #def7ec;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(222, 247, 236, 0));
  }
  .md\\:hover\\:via-green-200:hover {
    --gradient-via-color: #bcf0da;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(188, 240, 218, 0));
  }
  .md\\:hover\\:via-green-300:hover {
    --gradient-via-color: #84e1bc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(132, 225, 188, 0));
  }
  .md\\:hover\\:via-green-400:hover {
    --gradient-via-color: #31c48d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(49, 196, 141, 0));
  }
  .md\\:hover\\:via-green-500:hover {
    --gradient-via-color: #0e9f6e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(14, 159, 110, 0));
  }
  .md\\:hover\\:via-green-600:hover {
    --gradient-via-color: #057a55;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(5, 122, 85, 0));
  }
  .md\\:hover\\:via-green-700:hover {
    --gradient-via-color: #046c4e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(4, 108, 78, 0));
  }
  .md\\:hover\\:via-green-800:hover {
    --gradient-via-color: #03543f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(3, 84, 63, 0));
  }
  .md\\:hover\\:via-green-900:hover {
    --gradient-via-color: #014737;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(1, 71, 55, 0));
  }
  .md\\:hover\\:via-teal-50:hover {
    --gradient-via-color: #edfafa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(237, 250, 250, 0));
  }
  .md\\:hover\\:via-teal-100:hover {
    --gradient-via-color: #d5f5f6;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(213, 245, 246, 0));
  }
  .md\\:hover\\:via-teal-200:hover {
    --gradient-via-color: #afecef;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(175, 236, 239, 0));
  }
  .md\\:hover\\:via-teal-300:hover {
    --gradient-via-color: #7edce2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(126, 220, 226, 0));
  }
  .md\\:hover\\:via-teal-400:hover {
    --gradient-via-color: #16bdca;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(22, 189, 202, 0));
  }
  .md\\:hover\\:via-teal-500:hover {
    --gradient-via-color: #0694a2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(6, 148, 162, 0));
  }
  .md\\:hover\\:via-teal-600:hover {
    --gradient-via-color: #047481;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(4, 116, 129, 0));
  }
  .md\\:hover\\:via-teal-700:hover {
    --gradient-via-color: #036672;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(3, 102, 114, 0));
  }
  .md\\:hover\\:via-teal-800:hover {
    --gradient-via-color: #05505c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(5, 80, 92, 0));
  }
  .md\\:hover\\:via-teal-900:hover {
    --gradient-via-color: #014451;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(1, 68, 81, 0));
  }
  .md\\:hover\\:via-blue-50:hover {
    --gradient-via-color: #ebf5ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(235, 245, 255, 0));
  }
  .md\\:hover\\:via-blue-100:hover {
    --gradient-via-color: #e1effe;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(225, 239, 254, 0));
  }
  .md\\:hover\\:via-blue-200:hover {
    --gradient-via-color: #c3ddfd;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(195, 221, 253, 0));
  }
  .md\\:hover\\:via-blue-300:hover {
    --gradient-via-color: #a4cafe;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(164, 202, 254, 0));
  }
  .md\\:hover\\:via-blue-400:hover {
    --gradient-via-color: #76a9fa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(118, 169, 250, 0));
  }
  .md\\:hover\\:via-blue-500:hover {
    --gradient-via-color: #3f83f8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(63, 131, 248, 0));
  }
  .md\\:hover\\:via-blue-600:hover {
    --gradient-via-color: #1c64f2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(28, 100, 242, 0));
  }
  .md\\:hover\\:via-blue-700:hover {
    --gradient-via-color: #1a56db;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(26, 86, 219, 0));
  }
  .md\\:hover\\:via-blue-800:hover {
    --gradient-via-color: #1e429f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(30, 66, 159, 0));
  }
  .md\\:hover\\:via-blue-900:hover {
    --gradient-via-color: #233876;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(35, 56, 118, 0));
  }
  .md\\:hover\\:via-indigo-50:hover {
    --gradient-via-color: #f0f5ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(240, 245, 255, 0));
  }
  .md\\:hover\\:via-indigo-100:hover {
    --gradient-via-color: #e5edff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(229, 237, 255, 0));
  }
  .md\\:hover\\:via-indigo-200:hover {
    --gradient-via-color: #cddbfe;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(205, 219, 254, 0));
  }
  .md\\:hover\\:via-indigo-300:hover {
    --gradient-via-color: #b4c6fc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(180, 198, 252, 0));
  }
  .md\\:hover\\:via-indigo-400:hover {
    --gradient-via-color: #8da2fb;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(141, 162, 251, 0));
  }
  .md\\:hover\\:via-indigo-500:hover {
    --gradient-via-color: #6875f5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(104, 117, 245, 0));
  }
  .md\\:hover\\:via-indigo-600:hover {
    --gradient-via-color: #5850ec;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(88, 80, 236, 0));
  }
  .md\\:hover\\:via-indigo-700:hover {
    --gradient-via-color: #5145cd;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(81, 69, 205, 0));
  }
  .md\\:hover\\:via-indigo-800:hover {
    --gradient-via-color: #42389d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(66, 56, 157, 0));
  }
  .md\\:hover\\:via-indigo-900:hover {
    --gradient-via-color: #362f78;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(54, 47, 120, 0));
  }
  .md\\:hover\\:via-purple-50:hover {
    --gradient-via-color: #f6f5ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(246, 245, 255, 0));
  }
  .md\\:hover\\:via-purple-100:hover {
    --gradient-via-color: #edebfe;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(237, 235, 254, 0));
  }
  .md\\:hover\\:via-purple-200:hover {
    --gradient-via-color: #dcd7fe;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(220, 215, 254, 0));
  }
  .md\\:hover\\:via-purple-300:hover {
    --gradient-via-color: #cabffd;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(202, 191, 253, 0));
  }
  .md\\:hover\\:via-purple-400:hover {
    --gradient-via-color: #ac94fa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(172, 148, 250, 0));
  }
  .md\\:hover\\:via-purple-500:hover {
    --gradient-via-color: #9061f9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(144, 97, 249, 0));
  }
  .md\\:hover\\:via-purple-600:hover {
    --gradient-via-color: #7e3af2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(126, 58, 242, 0));
  }
  .md\\:hover\\:via-purple-700:hover {
    --gradient-via-color: #6c2bd9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(108, 43, 217, 0));
  }
  .md\\:hover\\:via-purple-800:hover {
    --gradient-via-color: #5521b5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(85, 33, 181, 0));
  }
  .md\\:hover\\:via-purple-900:hover {
    --gradient-via-color: #4a1d96;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(74, 29, 150, 0));
  }
  .md\\:hover\\:via-pink-50:hover {
    --gradient-via-color: #fdf2f8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 242, 248, 0));
  }
  .md\\:hover\\:via-pink-100:hover {
    --gradient-via-color: #fce8f3;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(252, 232, 243, 0));
  }
  .md\\:hover\\:via-pink-200:hover {
    --gradient-via-color: #fad1e8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(250, 209, 232, 0));
  }
  .md\\:hover\\:via-pink-300:hover {
    --gradient-via-color: #f8b4d9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(248, 180, 217, 0));
  }
  .md\\:hover\\:via-pink-400:hover {
    --gradient-via-color: #f17eb8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(241, 126, 184, 0));
  }
  .md\\:hover\\:via-pink-500:hover {
    --gradient-via-color: #e74694;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(231, 70, 148, 0));
  }
  .md\\:hover\\:via-pink-600:hover {
    --gradient-via-color: #d61f69;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(214, 31, 105, 0));
  }
  .md\\:hover\\:via-pink-700:hover {
    --gradient-via-color: #bf125d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(191, 18, 93, 0));
  }
  .md\\:hover\\:via-pink-800:hover {
    --gradient-via-color: #99154b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(153, 21, 75, 0));
  }
  .md\\:hover\\:via-pink-900:hover {
    --gradient-via-color: #751a3d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(117, 26, 61, 0));
  }
  .md\\:hover\\:via-cool-gray-50:hover {
    --gradient-via-color: #f8fafc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(248, 250, 252, 0));
  }
  .md\\:hover\\:via-cool-gray-100:hover {
    --gradient-via-color: #f1f5f9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(241, 245, 249, 0));
  }
  .md\\:hover\\:via-cool-gray-200:hover {
    --gradient-via-color: #e2e8f0;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(226, 232, 240, 0));
  }
  .md\\:hover\\:via-cool-gray-300:hover {
    --gradient-via-color: #cfd8e3;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(207, 216, 227, 0));
  }
  .md\\:hover\\:via-cool-gray-400:hover {
    --gradient-via-color: #97a6ba;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(151, 166, 186, 0));
  }
  .md\\:hover\\:via-cool-gray-500:hover {
    --gradient-via-color: #64748b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(100, 116, 139, 0));
  }
  .md\\:hover\\:via-cool-gray-600:hover {
    --gradient-via-color: #475569;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(71, 85, 105, 0));
  }
  .md\\:hover\\:via-cool-gray-700:hover {
    --gradient-via-color: #364152;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(54, 65, 82, 0));
  }
  .md\\:hover\\:via-cool-gray-800:hover {
    --gradient-via-color: #27303f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(39, 48, 63, 0));
  }
  .md\\:hover\\:via-cool-gray-900:hover {
    --gradient-via-color: #1a202e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(26, 32, 46, 0));
  }
  .md\\:hover\\:to-current:hover {
    --gradient-to-color: currentColor;
  }
  .md\\:hover\\:to-transparent:hover {
    --gradient-to-color: transparent;
  }
  .md\\:hover\\:to-white:hover {
    --gradient-to-color: #ffffff;
  }
  .md\\:hover\\:to-black:hover {
    --gradient-to-color: #000000;
  }
  .md\\:hover\\:to-gray-50:hover {
    --gradient-to-color: #f9fafb;
  }
  .md\\:hover\\:to-gray-100:hover {
    --gradient-to-color: #f4f5f7;
  }
  .md\\:hover\\:to-gray-200:hover {
    --gradient-to-color: #e5e7eb;
  }
  .md\\:hover\\:to-gray-300:hover {
    --gradient-to-color: #d2d6dc;
  }
  .md\\:hover\\:to-gray-400:hover {
    --gradient-to-color: #9fa6b2;
  }
  .md\\:hover\\:to-gray-500:hover {
    --gradient-to-color: #6b7280;
  }
  .md\\:hover\\:to-gray-600:hover {
    --gradient-to-color: #4b5563;
  }
  .md\\:hover\\:to-gray-700:hover {
    --gradient-to-color: #374151;
  }
  .md\\:hover\\:to-gray-800:hover {
    --gradient-to-color: #252f3f;
  }
  .md\\:hover\\:to-gray-900:hover {
    --gradient-to-color: #161e2e;
  }
  .md\\:hover\\:to-red-50:hover {
    --gradient-to-color: #fdf2f2;
  }
  .md\\:hover\\:to-red-100:hover {
    --gradient-to-color: #fde8e8;
  }
  .md\\:hover\\:to-red-200:hover {
    --gradient-to-color: #fbd5d5;
  }
  .md\\:hover\\:to-red-300:hover {
    --gradient-to-color: #f8b4b4;
  }
  .md\\:hover\\:to-red-400:hover {
    --gradient-to-color: #f98080;
  }
  .md\\:hover\\:to-red-500:hover {
    --gradient-to-color: #f05252;
  }
  .md\\:hover\\:to-red-600:hover {
    --gradient-to-color: #e02424;
  }
  .md\\:hover\\:to-red-700:hover {
    --gradient-to-color: #c81e1e;
  }
  .md\\:hover\\:to-red-800:hover {
    --gradient-to-color: #9b1c1c;
  }
  .md\\:hover\\:to-red-900:hover {
    --gradient-to-color: #771d1d;
  }
  .md\\:hover\\:to-orange-50:hover {
    --gradient-to-color: #fff8f1;
  }
  .md\\:hover\\:to-orange-100:hover {
    --gradient-to-color: #feecdc;
  }
  .md\\:hover\\:to-orange-200:hover {
    --gradient-to-color: #fcd9bd;
  }
  .md\\:hover\\:to-orange-300:hover {
    --gradient-to-color: #fdba8c;
  }
  .md\\:hover\\:to-orange-400:hover {
    --gradient-to-color: #ff8a4c;
  }
  .md\\:hover\\:to-orange-500:hover {
    --gradient-to-color: #ff5a1f;
  }
  .md\\:hover\\:to-orange-600:hover {
    --gradient-to-color: #d03801;
  }
  .md\\:hover\\:to-orange-700:hover {
    --gradient-to-color: #b43403;
  }
  .md\\:hover\\:to-orange-800:hover {
    --gradient-to-color: #8a2c0d;
  }
  .md\\:hover\\:to-orange-900:hover {
    --gradient-to-color: #73230d;
  }
  .md\\:hover\\:to-yellow-50:hover {
    --gradient-to-color: #fdfdea;
  }
  .md\\:hover\\:to-yellow-100:hover {
    --gradient-to-color: #fdf6b2;
  }
  .md\\:hover\\:to-yellow-200:hover {
    --gradient-to-color: #fce96a;
  }
  .md\\:hover\\:to-yellow-300:hover {
    --gradient-to-color: #faca15;
  }
  .md\\:hover\\:to-yellow-400:hover {
    --gradient-to-color: #e3a008;
  }
  .md\\:hover\\:to-yellow-500:hover {
    --gradient-to-color: #c27803;
  }
  .md\\:hover\\:to-yellow-600:hover {
    --gradient-to-color: #9f580a;
  }
  .md\\:hover\\:to-yellow-700:hover {
    --gradient-to-color: #8e4b10;
  }
  .md\\:hover\\:to-yellow-800:hover {
    --gradient-to-color: #723b13;
  }
  .md\\:hover\\:to-yellow-900:hover {
    --gradient-to-color: #633112;
  }
  .md\\:hover\\:to-green-50:hover {
    --gradient-to-color: #f3faf7;
  }
  .md\\:hover\\:to-green-100:hover {
    --gradient-to-color: #def7ec;
  }
  .md\\:hover\\:to-green-200:hover {
    --gradient-to-color: #bcf0da;
  }
  .md\\:hover\\:to-green-300:hover {
    --gradient-to-color: #84e1bc;
  }
  .md\\:hover\\:to-green-400:hover {
    --gradient-to-color: #31c48d;
  }
  .md\\:hover\\:to-green-500:hover {
    --gradient-to-color: #0e9f6e;
  }
  .md\\:hover\\:to-green-600:hover {
    --gradient-to-color: #057a55;
  }
  .md\\:hover\\:to-green-700:hover {
    --gradient-to-color: #046c4e;
  }
  .md\\:hover\\:to-green-800:hover {
    --gradient-to-color: #03543f;
  }
  .md\\:hover\\:to-green-900:hover {
    --gradient-to-color: #014737;
  }
  .md\\:hover\\:to-teal-50:hover {
    --gradient-to-color: #edfafa;
  }
  .md\\:hover\\:to-teal-100:hover {
    --gradient-to-color: #d5f5f6;
  }
  .md\\:hover\\:to-teal-200:hover {
    --gradient-to-color: #afecef;
  }
  .md\\:hover\\:to-teal-300:hover {
    --gradient-to-color: #7edce2;
  }
  .md\\:hover\\:to-teal-400:hover {
    --gradient-to-color: #16bdca;
  }
  .md\\:hover\\:to-teal-500:hover {
    --gradient-to-color: #0694a2;
  }
  .md\\:hover\\:to-teal-600:hover {
    --gradient-to-color: #047481;
  }
  .md\\:hover\\:to-teal-700:hover {
    --gradient-to-color: #036672;
  }
  .md\\:hover\\:to-teal-800:hover {
    --gradient-to-color: #05505c;
  }
  .md\\:hover\\:to-teal-900:hover {
    --gradient-to-color: #014451;
  }
  .md\\:hover\\:to-blue-50:hover {
    --gradient-to-color: #ebf5ff;
  }
  .md\\:hover\\:to-blue-100:hover {
    --gradient-to-color: #e1effe;
  }
  .md\\:hover\\:to-blue-200:hover {
    --gradient-to-color: #c3ddfd;
  }
  .md\\:hover\\:to-blue-300:hover {
    --gradient-to-color: #a4cafe;
  }
  .md\\:hover\\:to-blue-400:hover {
    --gradient-to-color: #76a9fa;
  }
  .md\\:hover\\:to-blue-500:hover {
    --gradient-to-color: #3f83f8;
  }
  .md\\:hover\\:to-blue-600:hover {
    --gradient-to-color: #1c64f2;
  }
  .md\\:hover\\:to-blue-700:hover {
    --gradient-to-color: #1a56db;
  }
  .md\\:hover\\:to-blue-800:hover {
    --gradient-to-color: #1e429f;
  }
  .md\\:hover\\:to-blue-900:hover {
    --gradient-to-color: #233876;
  }
  .md\\:hover\\:to-indigo-50:hover {
    --gradient-to-color: #f0f5ff;
  }
  .md\\:hover\\:to-indigo-100:hover {
    --gradient-to-color: #e5edff;
  }
  .md\\:hover\\:to-indigo-200:hover {
    --gradient-to-color: #cddbfe;
  }
  .md\\:hover\\:to-indigo-300:hover {
    --gradient-to-color: #b4c6fc;
  }
  .md\\:hover\\:to-indigo-400:hover {
    --gradient-to-color: #8da2fb;
  }
  .md\\:hover\\:to-indigo-500:hover {
    --gradient-to-color: #6875f5;
  }
  .md\\:hover\\:to-indigo-600:hover {
    --gradient-to-color: #5850ec;
  }
  .md\\:hover\\:to-indigo-700:hover {
    --gradient-to-color: #5145cd;
  }
  .md\\:hover\\:to-indigo-800:hover {
    --gradient-to-color: #42389d;
  }
  .md\\:hover\\:to-indigo-900:hover {
    --gradient-to-color: #362f78;
  }
  .md\\:hover\\:to-purple-50:hover {
    --gradient-to-color: #f6f5ff;
  }
  .md\\:hover\\:to-purple-100:hover {
    --gradient-to-color: #edebfe;
  }
  .md\\:hover\\:to-purple-200:hover {
    --gradient-to-color: #dcd7fe;
  }
  .md\\:hover\\:to-purple-300:hover {
    --gradient-to-color: #cabffd;
  }
  .md\\:hover\\:to-purple-400:hover {
    --gradient-to-color: #ac94fa;
  }
  .md\\:hover\\:to-purple-500:hover {
    --gradient-to-color: #9061f9;
  }
  .md\\:hover\\:to-purple-600:hover {
    --gradient-to-color: #7e3af2;
  }
  .md\\:hover\\:to-purple-700:hover {
    --gradient-to-color: #6c2bd9;
  }
  .md\\:hover\\:to-purple-800:hover {
    --gradient-to-color: #5521b5;
  }
  .md\\:hover\\:to-purple-900:hover {
    --gradient-to-color: #4a1d96;
  }
  .md\\:hover\\:to-pink-50:hover {
    --gradient-to-color: #fdf2f8;
  }
  .md\\:hover\\:to-pink-100:hover {
    --gradient-to-color: #fce8f3;
  }
  .md\\:hover\\:to-pink-200:hover {
    --gradient-to-color: #fad1e8;
  }
  .md\\:hover\\:to-pink-300:hover {
    --gradient-to-color: #f8b4d9;
  }
  .md\\:hover\\:to-pink-400:hover {
    --gradient-to-color: #f17eb8;
  }
  .md\\:hover\\:to-pink-500:hover {
    --gradient-to-color: #e74694;
  }
  .md\\:hover\\:to-pink-600:hover {
    --gradient-to-color: #d61f69;
  }
  .md\\:hover\\:to-pink-700:hover {
    --gradient-to-color: #bf125d;
  }
  .md\\:hover\\:to-pink-800:hover {
    --gradient-to-color: #99154b;
  }
  .md\\:hover\\:to-pink-900:hover {
    --gradient-to-color: #751a3d;
  }
  .md\\:hover\\:to-cool-gray-50:hover {
    --gradient-to-color: #f8fafc;
  }
  .md\\:hover\\:to-cool-gray-100:hover {
    --gradient-to-color: #f1f5f9;
  }
  .md\\:hover\\:to-cool-gray-200:hover {
    --gradient-to-color: #e2e8f0;
  }
  .md\\:hover\\:to-cool-gray-300:hover {
    --gradient-to-color: #cfd8e3;
  }
  .md\\:hover\\:to-cool-gray-400:hover {
    --gradient-to-color: #97a6ba;
  }
  .md\\:hover\\:to-cool-gray-500:hover {
    --gradient-to-color: #64748b;
  }
  .md\\:hover\\:to-cool-gray-600:hover {
    --gradient-to-color: #475569;
  }
  .md\\:hover\\:to-cool-gray-700:hover {
    --gradient-to-color: #364152;
  }
  .md\\:hover\\:to-cool-gray-800:hover {
    --gradient-to-color: #27303f;
  }
  .md\\:hover\\:to-cool-gray-900:hover {
    --gradient-to-color: #1a202e;
  }
  .md\\:focus\\:from-current:focus {
    --gradient-from-color: currentColor;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }
  .md\\:focus\\:from-transparent:focus {
    --gradient-from-color: transparent;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  }
  .md\\:focus\\:from-white:focus {
    --gradient-from-color: #ffffff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }
  .md\\:focus\\:from-black:focus {
    --gradient-from-color: #000000;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  }
  .md\\:focus\\:from-gray-50:focus {
    --gradient-from-color: #f9fafb;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(249, 250, 251, 0));
  }
  .md\\:focus\\:from-gray-100:focus {
    --gradient-from-color: #f4f5f7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(244, 245, 247, 0));
  }
  .md\\:focus\\:from-gray-200:focus {
    --gradient-from-color: #e5e7eb;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(229, 231, 235, 0));
  }
  .md\\:focus\\:from-gray-300:focus {
    --gradient-from-color: #d2d6dc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(210, 214, 220, 0));
  }
  .md\\:focus\\:from-gray-400:focus {
    --gradient-from-color: #9fa6b2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(159, 166, 178, 0));
  }
  .md\\:focus\\:from-gray-500:focus {
    --gradient-from-color: #6b7280;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(107, 114, 128, 0));
  }
  .md\\:focus\\:from-gray-600:focus {
    --gradient-from-color: #4b5563;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(75, 85, 99, 0));
  }
  .md\\:focus\\:from-gray-700:focus {
    --gradient-from-color: #374151;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(55, 65, 81, 0));
  }
  .md\\:focus\\:from-gray-800:focus {
    --gradient-from-color: #252f3f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(37, 47, 63, 0));
  }
  .md\\:focus\\:from-gray-900:focus {
    --gradient-from-color: #161e2e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(22, 30, 46, 0));
  }
  .md\\:focus\\:from-red-50:focus {
    --gradient-from-color: #fdf2f2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 242, 242, 0));
  }
  .md\\:focus\\:from-red-100:focus {
    --gradient-from-color: #fde8e8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 232, 232, 0));
  }
  .md\\:focus\\:from-red-200:focus {
    --gradient-from-color: #fbd5d5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(251, 213, 213, 0));
  }
  .md\\:focus\\:from-red-300:focus {
    --gradient-from-color: #f8b4b4;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(248, 180, 180, 0));
  }
  .md\\:focus\\:from-red-400:focus {
    --gradient-from-color: #f98080;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(249, 128, 128, 0));
  }
  .md\\:focus\\:from-red-500:focus {
    --gradient-from-color: #f05252;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(240, 82, 82, 0));
  }
  .md\\:focus\\:from-red-600:focus {
    --gradient-from-color: #e02424;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(224, 36, 36, 0));
  }
  .md\\:focus\\:from-red-700:focus {
    --gradient-from-color: #c81e1e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(200, 30, 30, 0));
  }
  .md\\:focus\\:from-red-800:focus {
    --gradient-from-color: #9b1c1c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(155, 28, 28, 0));
  }
  .md\\:focus\\:from-red-900:focus {
    --gradient-from-color: #771d1d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(119, 29, 29, 0));
  }
  .md\\:focus\\:from-orange-50:focus {
    --gradient-from-color: #fff8f1;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 248, 241, 0));
  }
  .md\\:focus\\:from-orange-100:focus {
    --gradient-from-color: #feecdc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 236, 220, 0));
  }
  .md\\:focus\\:from-orange-200:focus {
    --gradient-from-color: #fcd9bd;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(252, 217, 189, 0));
  }
  .md\\:focus\\:from-orange-300:focus {
    --gradient-from-color: #fdba8c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 186, 140, 0));
  }
  .md\\:focus\\:from-orange-400:focus {
    --gradient-from-color: #ff8a4c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 138, 76, 0));
  }
  .md\\:focus\\:from-orange-500:focus {
    --gradient-from-color: #ff5a1f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 90, 31, 0));
  }
  .md\\:focus\\:from-orange-600:focus {
    --gradient-from-color: #d03801;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(208, 56, 1, 0));
  }
  .md\\:focus\\:from-orange-700:focus {
    --gradient-from-color: #b43403;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(180, 52, 3, 0));
  }
  .md\\:focus\\:from-orange-800:focus {
    --gradient-from-color: #8a2c0d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(138, 44, 13, 0));
  }
  .md\\:focus\\:from-orange-900:focus {
    --gradient-from-color: #73230d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(115, 35, 13, 0));
  }
  .md\\:focus\\:from-yellow-50:focus {
    --gradient-from-color: #fdfdea;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 253, 234, 0));
  }
  .md\\:focus\\:from-yellow-100:focus {
    --gradient-from-color: #fdf6b2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 246, 178, 0));
  }
  .md\\:focus\\:from-yellow-200:focus {
    --gradient-from-color: #fce96a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(252, 233, 106, 0));
  }
  .md\\:focus\\:from-yellow-300:focus {
    --gradient-from-color: #faca15;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(250, 202, 21, 0));
  }
  .md\\:focus\\:from-yellow-400:focus {
    --gradient-from-color: #e3a008;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(227, 160, 8, 0));
  }
  .md\\:focus\\:from-yellow-500:focus {
    --gradient-from-color: #c27803;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(194, 120, 3, 0));
  }
  .md\\:focus\\:from-yellow-600:focus {
    --gradient-from-color: #9f580a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(159, 88, 10, 0));
  }
  .md\\:focus\\:from-yellow-700:focus {
    --gradient-from-color: #8e4b10;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(142, 75, 16, 0));
  }
  .md\\:focus\\:from-yellow-800:focus {
    --gradient-from-color: #723b13;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(114, 59, 19, 0));
  }
  .md\\:focus\\:from-yellow-900:focus {
    --gradient-from-color: #633112;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(99, 49, 18, 0));
  }
  .md\\:focus\\:from-green-50:focus {
    --gradient-from-color: #f3faf7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(243, 250, 247, 0));
  }
  .md\\:focus\\:from-green-100:focus {
    --gradient-from-color: #def7ec;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(222, 247, 236, 0));
  }
  .md\\:focus\\:from-green-200:focus {
    --gradient-from-color: #bcf0da;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(188, 240, 218, 0));
  }
  .md\\:focus\\:from-green-300:focus {
    --gradient-from-color: #84e1bc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(132, 225, 188, 0));
  }
  .md\\:focus\\:from-green-400:focus {
    --gradient-from-color: #31c48d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(49, 196, 141, 0));
  }
  .md\\:focus\\:from-green-500:focus {
    --gradient-from-color: #0e9f6e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(14, 159, 110, 0));
  }
  .md\\:focus\\:from-green-600:focus {
    --gradient-from-color: #057a55;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(5, 122, 85, 0));
  }
  .md\\:focus\\:from-green-700:focus {
    --gradient-from-color: #046c4e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(4, 108, 78, 0));
  }
  .md\\:focus\\:from-green-800:focus {
    --gradient-from-color: #03543f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(3, 84, 63, 0));
  }
  .md\\:focus\\:from-green-900:focus {
    --gradient-from-color: #014737;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(1, 71, 55, 0));
  }
  .md\\:focus\\:from-teal-50:focus {
    --gradient-from-color: #edfafa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(237, 250, 250, 0));
  }
  .md\\:focus\\:from-teal-100:focus {
    --gradient-from-color: #d5f5f6;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(213, 245, 246, 0));
  }
  .md\\:focus\\:from-teal-200:focus {
    --gradient-from-color: #afecef;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(175, 236, 239, 0));
  }
  .md\\:focus\\:from-teal-300:focus {
    --gradient-from-color: #7edce2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(126, 220, 226, 0));
  }
  .md\\:focus\\:from-teal-400:focus {
    --gradient-from-color: #16bdca;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(22, 189, 202, 0));
  }
  .md\\:focus\\:from-teal-500:focus {
    --gradient-from-color: #0694a2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(6, 148, 162, 0));
  }
  .md\\:focus\\:from-teal-600:focus {
    --gradient-from-color: #047481;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(4, 116, 129, 0));
  }
  .md\\:focus\\:from-teal-700:focus {
    --gradient-from-color: #036672;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(3, 102, 114, 0));
  }
  .md\\:focus\\:from-teal-800:focus {
    --gradient-from-color: #05505c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(5, 80, 92, 0));
  }
  .md\\:focus\\:from-teal-900:focus {
    --gradient-from-color: #014451;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(1, 68, 81, 0));
  }
  .md\\:focus\\:from-blue-50:focus {
    --gradient-from-color: #ebf5ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(235, 245, 255, 0));
  }
  .md\\:focus\\:from-blue-100:focus {
    --gradient-from-color: #e1effe;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(225, 239, 254, 0));
  }
  .md\\:focus\\:from-blue-200:focus {
    --gradient-from-color: #c3ddfd;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(195, 221, 253, 0));
  }
  .md\\:focus\\:from-blue-300:focus {
    --gradient-from-color: #a4cafe;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(164, 202, 254, 0));
  }
  .md\\:focus\\:from-blue-400:focus {
    --gradient-from-color: #76a9fa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(118, 169, 250, 0));
  }
  .md\\:focus\\:from-blue-500:focus {
    --gradient-from-color: #3f83f8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(63, 131, 248, 0));
  }
  .md\\:focus\\:from-blue-600:focus {
    --gradient-from-color: #1c64f2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(28, 100, 242, 0));
  }
  .md\\:focus\\:from-blue-700:focus {
    --gradient-from-color: #1a56db;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(26, 86, 219, 0));
  }
  .md\\:focus\\:from-blue-800:focus {
    --gradient-from-color: #1e429f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(30, 66, 159, 0));
  }
  .md\\:focus\\:from-blue-900:focus {
    --gradient-from-color: #233876;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(35, 56, 118, 0));
  }
  .md\\:focus\\:from-indigo-50:focus {
    --gradient-from-color: #f0f5ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(240, 245, 255, 0));
  }
  .md\\:focus\\:from-indigo-100:focus {
    --gradient-from-color: #e5edff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(229, 237, 255, 0));
  }
  .md\\:focus\\:from-indigo-200:focus {
    --gradient-from-color: #cddbfe;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(205, 219, 254, 0));
  }
  .md\\:focus\\:from-indigo-300:focus {
    --gradient-from-color: #b4c6fc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(180, 198, 252, 0));
  }
  .md\\:focus\\:from-indigo-400:focus {
    --gradient-from-color: #8da2fb;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(141, 162, 251, 0));
  }
  .md\\:focus\\:from-indigo-500:focus {
    --gradient-from-color: #6875f5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(104, 117, 245, 0));
  }
  .md\\:focus\\:from-indigo-600:focus {
    --gradient-from-color: #5850ec;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(88, 80, 236, 0));
  }
  .md\\:focus\\:from-indigo-700:focus {
    --gradient-from-color: #5145cd;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(81, 69, 205, 0));
  }
  .md\\:focus\\:from-indigo-800:focus {
    --gradient-from-color: #42389d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(66, 56, 157, 0));
  }
  .md\\:focus\\:from-indigo-900:focus {
    --gradient-from-color: #362f78;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(54, 47, 120, 0));
  }
  .md\\:focus\\:from-purple-50:focus {
    --gradient-from-color: #f6f5ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(246, 245, 255, 0));
  }
  .md\\:focus\\:from-purple-100:focus {
    --gradient-from-color: #edebfe;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(237, 235, 254, 0));
  }
  .md\\:focus\\:from-purple-200:focus {
    --gradient-from-color: #dcd7fe;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(220, 215, 254, 0));
  }
  .md\\:focus\\:from-purple-300:focus {
    --gradient-from-color: #cabffd;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(202, 191, 253, 0));
  }
  .md\\:focus\\:from-purple-400:focus {
    --gradient-from-color: #ac94fa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(172, 148, 250, 0));
  }
  .md\\:focus\\:from-purple-500:focus {
    --gradient-from-color: #9061f9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(144, 97, 249, 0));
  }
  .md\\:focus\\:from-purple-600:focus {
    --gradient-from-color: #7e3af2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(126, 58, 242, 0));
  }
  .md\\:focus\\:from-purple-700:focus {
    --gradient-from-color: #6c2bd9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(108, 43, 217, 0));
  }
  .md\\:focus\\:from-purple-800:focus {
    --gradient-from-color: #5521b5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(85, 33, 181, 0));
  }
  .md\\:focus\\:from-purple-900:focus {
    --gradient-from-color: #4a1d96;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(74, 29, 150, 0));
  }
  .md\\:focus\\:from-pink-50:focus {
    --gradient-from-color: #fdf2f8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 242, 248, 0));
  }
  .md\\:focus\\:from-pink-100:focus {
    --gradient-from-color: #fce8f3;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(252, 232, 243, 0));
  }
  .md\\:focus\\:from-pink-200:focus {
    --gradient-from-color: #fad1e8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(250, 209, 232, 0));
  }
  .md\\:focus\\:from-pink-300:focus {
    --gradient-from-color: #f8b4d9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(248, 180, 217, 0));
  }
  .md\\:focus\\:from-pink-400:focus {
    --gradient-from-color: #f17eb8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(241, 126, 184, 0));
  }
  .md\\:focus\\:from-pink-500:focus {
    --gradient-from-color: #e74694;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(231, 70, 148, 0));
  }
  .md\\:focus\\:from-pink-600:focus {
    --gradient-from-color: #d61f69;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(214, 31, 105, 0));
  }
  .md\\:focus\\:from-pink-700:focus {
    --gradient-from-color: #bf125d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(191, 18, 93, 0));
  }
  .md\\:focus\\:from-pink-800:focus {
    --gradient-from-color: #99154b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(153, 21, 75, 0));
  }
  .md\\:focus\\:from-pink-900:focus {
    --gradient-from-color: #751a3d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(117, 26, 61, 0));
  }
  .md\\:focus\\:from-cool-gray-50:focus {
    --gradient-from-color: #f8fafc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(248, 250, 252, 0));
  }
  .md\\:focus\\:from-cool-gray-100:focus {
    --gradient-from-color: #f1f5f9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(241, 245, 249, 0));
  }
  .md\\:focus\\:from-cool-gray-200:focus {
    --gradient-from-color: #e2e8f0;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(226, 232, 240, 0));
  }
  .md\\:focus\\:from-cool-gray-300:focus {
    --gradient-from-color: #cfd8e3;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(207, 216, 227, 0));
  }
  .md\\:focus\\:from-cool-gray-400:focus {
    --gradient-from-color: #97a6ba;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(151, 166, 186, 0));
  }
  .md\\:focus\\:from-cool-gray-500:focus {
    --gradient-from-color: #64748b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(100, 116, 139, 0));
  }
  .md\\:focus\\:from-cool-gray-600:focus {
    --gradient-from-color: #475569;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(71, 85, 105, 0));
  }
  .md\\:focus\\:from-cool-gray-700:focus {
    --gradient-from-color: #364152;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(54, 65, 82, 0));
  }
  .md\\:focus\\:from-cool-gray-800:focus {
    --gradient-from-color: #27303f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(39, 48, 63, 0));
  }
  .md\\:focus\\:from-cool-gray-900:focus {
    --gradient-from-color: #1a202e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(26, 32, 46, 0));
  }
  .md\\:focus\\:via-current:focus {
    --gradient-via-color: currentColor;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }
  .md\\:focus\\:via-transparent:focus {
    --gradient-via-color: transparent;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  }
  .md\\:focus\\:via-white:focus {
    --gradient-via-color: #ffffff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }
  .md\\:focus\\:via-black:focus {
    --gradient-via-color: #000000;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  }
  .md\\:focus\\:via-gray-50:focus {
    --gradient-via-color: #f9fafb;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(249, 250, 251, 0));
  }
  .md\\:focus\\:via-gray-100:focus {
    --gradient-via-color: #f4f5f7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(244, 245, 247, 0));
  }
  .md\\:focus\\:via-gray-200:focus {
    --gradient-via-color: #e5e7eb;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(229, 231, 235, 0));
  }
  .md\\:focus\\:via-gray-300:focus {
    --gradient-via-color: #d2d6dc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(210, 214, 220, 0));
  }
  .md\\:focus\\:via-gray-400:focus {
    --gradient-via-color: #9fa6b2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(159, 166, 178, 0));
  }
  .md\\:focus\\:via-gray-500:focus {
    --gradient-via-color: #6b7280;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(107, 114, 128, 0));
  }
  .md\\:focus\\:via-gray-600:focus {
    --gradient-via-color: #4b5563;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(75, 85, 99, 0));
  }
  .md\\:focus\\:via-gray-700:focus {
    --gradient-via-color: #374151;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(55, 65, 81, 0));
  }
  .md\\:focus\\:via-gray-800:focus {
    --gradient-via-color: #252f3f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(37, 47, 63, 0));
  }
  .md\\:focus\\:via-gray-900:focus {
    --gradient-via-color: #161e2e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(22, 30, 46, 0));
  }
  .md\\:focus\\:via-red-50:focus {
    --gradient-via-color: #fdf2f2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 242, 242, 0));
  }
  .md\\:focus\\:via-red-100:focus {
    --gradient-via-color: #fde8e8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 232, 232, 0));
  }
  .md\\:focus\\:via-red-200:focus {
    --gradient-via-color: #fbd5d5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(251, 213, 213, 0));
  }
  .md\\:focus\\:via-red-300:focus {
    --gradient-via-color: #f8b4b4;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(248, 180, 180, 0));
  }
  .md\\:focus\\:via-red-400:focus {
    --gradient-via-color: #f98080;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(249, 128, 128, 0));
  }
  .md\\:focus\\:via-red-500:focus {
    --gradient-via-color: #f05252;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(240, 82, 82, 0));
  }
  .md\\:focus\\:via-red-600:focus {
    --gradient-via-color: #e02424;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(224, 36, 36, 0));
  }
  .md\\:focus\\:via-red-700:focus {
    --gradient-via-color: #c81e1e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(200, 30, 30, 0));
  }
  .md\\:focus\\:via-red-800:focus {
    --gradient-via-color: #9b1c1c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(155, 28, 28, 0));
  }
  .md\\:focus\\:via-red-900:focus {
    --gradient-via-color: #771d1d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(119, 29, 29, 0));
  }
  .md\\:focus\\:via-orange-50:focus {
    --gradient-via-color: #fff8f1;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 248, 241, 0));
  }
  .md\\:focus\\:via-orange-100:focus {
    --gradient-via-color: #feecdc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 236, 220, 0));
  }
  .md\\:focus\\:via-orange-200:focus {
    --gradient-via-color: #fcd9bd;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(252, 217, 189, 0));
  }
  .md\\:focus\\:via-orange-300:focus {
    --gradient-via-color: #fdba8c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 186, 140, 0));
  }
  .md\\:focus\\:via-orange-400:focus {
    --gradient-via-color: #ff8a4c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 138, 76, 0));
  }
  .md\\:focus\\:via-orange-500:focus {
    --gradient-via-color: #ff5a1f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 90, 31, 0));
  }
  .md\\:focus\\:via-orange-600:focus {
    --gradient-via-color: #d03801;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(208, 56, 1, 0));
  }
  .md\\:focus\\:via-orange-700:focus {
    --gradient-via-color: #b43403;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(180, 52, 3, 0));
  }
  .md\\:focus\\:via-orange-800:focus {
    --gradient-via-color: #8a2c0d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(138, 44, 13, 0));
  }
  .md\\:focus\\:via-orange-900:focus {
    --gradient-via-color: #73230d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(115, 35, 13, 0));
  }
  .md\\:focus\\:via-yellow-50:focus {
    --gradient-via-color: #fdfdea;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 253, 234, 0));
  }
  .md\\:focus\\:via-yellow-100:focus {
    --gradient-via-color: #fdf6b2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 246, 178, 0));
  }
  .md\\:focus\\:via-yellow-200:focus {
    --gradient-via-color: #fce96a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(252, 233, 106, 0));
  }
  .md\\:focus\\:via-yellow-300:focus {
    --gradient-via-color: #faca15;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(250, 202, 21, 0));
  }
  .md\\:focus\\:via-yellow-400:focus {
    --gradient-via-color: #e3a008;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(227, 160, 8, 0));
  }
  .md\\:focus\\:via-yellow-500:focus {
    --gradient-via-color: #c27803;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(194, 120, 3, 0));
  }
  .md\\:focus\\:via-yellow-600:focus {
    --gradient-via-color: #9f580a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(159, 88, 10, 0));
  }
  .md\\:focus\\:via-yellow-700:focus {
    --gradient-via-color: #8e4b10;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(142, 75, 16, 0));
  }
  .md\\:focus\\:via-yellow-800:focus {
    --gradient-via-color: #723b13;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(114, 59, 19, 0));
  }
  .md\\:focus\\:via-yellow-900:focus {
    --gradient-via-color: #633112;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(99, 49, 18, 0));
  }
  .md\\:focus\\:via-green-50:focus {
    --gradient-via-color: #f3faf7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(243, 250, 247, 0));
  }
  .md\\:focus\\:via-green-100:focus {
    --gradient-via-color: #def7ec;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(222, 247, 236, 0));
  }
  .md\\:focus\\:via-green-200:focus {
    --gradient-via-color: #bcf0da;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(188, 240, 218, 0));
  }
  .md\\:focus\\:via-green-300:focus {
    --gradient-via-color: #84e1bc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(132, 225, 188, 0));
  }
  .md\\:focus\\:via-green-400:focus {
    --gradient-via-color: #31c48d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(49, 196, 141, 0));
  }
  .md\\:focus\\:via-green-500:focus {
    --gradient-via-color: #0e9f6e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(14, 159, 110, 0));
  }
  .md\\:focus\\:via-green-600:focus {
    --gradient-via-color: #057a55;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(5, 122, 85, 0));
  }
  .md\\:focus\\:via-green-700:focus {
    --gradient-via-color: #046c4e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(4, 108, 78, 0));
  }
  .md\\:focus\\:via-green-800:focus {
    --gradient-via-color: #03543f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(3, 84, 63, 0));
  }
  .md\\:focus\\:via-green-900:focus {
    --gradient-via-color: #014737;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(1, 71, 55, 0));
  }
  .md\\:focus\\:via-teal-50:focus {
    --gradient-via-color: #edfafa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(237, 250, 250, 0));
  }
  .md\\:focus\\:via-teal-100:focus {
    --gradient-via-color: #d5f5f6;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(213, 245, 246, 0));
  }
  .md\\:focus\\:via-teal-200:focus {
    --gradient-via-color: #afecef;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(175, 236, 239, 0));
  }
  .md\\:focus\\:via-teal-300:focus {
    --gradient-via-color: #7edce2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(126, 220, 226, 0));
  }
  .md\\:focus\\:via-teal-400:focus {
    --gradient-via-color: #16bdca;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(22, 189, 202, 0));
  }
  .md\\:focus\\:via-teal-500:focus {
    --gradient-via-color: #0694a2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(6, 148, 162, 0));
  }
  .md\\:focus\\:via-teal-600:focus {
    --gradient-via-color: #047481;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(4, 116, 129, 0));
  }
  .md\\:focus\\:via-teal-700:focus {
    --gradient-via-color: #036672;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(3, 102, 114, 0));
  }
  .md\\:focus\\:via-teal-800:focus {
    --gradient-via-color: #05505c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(5, 80, 92, 0));
  }
  .md\\:focus\\:via-teal-900:focus {
    --gradient-via-color: #014451;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(1, 68, 81, 0));
  }
  .md\\:focus\\:via-blue-50:focus {
    --gradient-via-color: #ebf5ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(235, 245, 255, 0));
  }
  .md\\:focus\\:via-blue-100:focus {
    --gradient-via-color: #e1effe;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(225, 239, 254, 0));
  }
  .md\\:focus\\:via-blue-200:focus {
    --gradient-via-color: #c3ddfd;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(195, 221, 253, 0));
  }
  .md\\:focus\\:via-blue-300:focus {
    --gradient-via-color: #a4cafe;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(164, 202, 254, 0));
  }
  .md\\:focus\\:via-blue-400:focus {
    --gradient-via-color: #76a9fa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(118, 169, 250, 0));
  }
  .md\\:focus\\:via-blue-500:focus {
    --gradient-via-color: #3f83f8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(63, 131, 248, 0));
  }
  .md\\:focus\\:via-blue-600:focus {
    --gradient-via-color: #1c64f2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(28, 100, 242, 0));
  }
  .md\\:focus\\:via-blue-700:focus {
    --gradient-via-color: #1a56db;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(26, 86, 219, 0));
  }
  .md\\:focus\\:via-blue-800:focus {
    --gradient-via-color: #1e429f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(30, 66, 159, 0));
  }
  .md\\:focus\\:via-blue-900:focus {
    --gradient-via-color: #233876;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(35, 56, 118, 0));
  }
  .md\\:focus\\:via-indigo-50:focus {
    --gradient-via-color: #f0f5ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(240, 245, 255, 0));
  }
  .md\\:focus\\:via-indigo-100:focus {
    --gradient-via-color: #e5edff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(229, 237, 255, 0));
  }
  .md\\:focus\\:via-indigo-200:focus {
    --gradient-via-color: #cddbfe;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(205, 219, 254, 0));
  }
  .md\\:focus\\:via-indigo-300:focus {
    --gradient-via-color: #b4c6fc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(180, 198, 252, 0));
  }
  .md\\:focus\\:via-indigo-400:focus {
    --gradient-via-color: #8da2fb;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(141, 162, 251, 0));
  }
  .md\\:focus\\:via-indigo-500:focus {
    --gradient-via-color: #6875f5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(104, 117, 245, 0));
  }
  .md\\:focus\\:via-indigo-600:focus {
    --gradient-via-color: #5850ec;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(88, 80, 236, 0));
  }
  .md\\:focus\\:via-indigo-700:focus {
    --gradient-via-color: #5145cd;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(81, 69, 205, 0));
  }
  .md\\:focus\\:via-indigo-800:focus {
    --gradient-via-color: #42389d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(66, 56, 157, 0));
  }
  .md\\:focus\\:via-indigo-900:focus {
    --gradient-via-color: #362f78;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(54, 47, 120, 0));
  }
  .md\\:focus\\:via-purple-50:focus {
    --gradient-via-color: #f6f5ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(246, 245, 255, 0));
  }
  .md\\:focus\\:via-purple-100:focus {
    --gradient-via-color: #edebfe;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(237, 235, 254, 0));
  }
  .md\\:focus\\:via-purple-200:focus {
    --gradient-via-color: #dcd7fe;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(220, 215, 254, 0));
  }
  .md\\:focus\\:via-purple-300:focus {
    --gradient-via-color: #cabffd;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(202, 191, 253, 0));
  }
  .md\\:focus\\:via-purple-400:focus {
    --gradient-via-color: #ac94fa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(172, 148, 250, 0));
  }
  .md\\:focus\\:via-purple-500:focus {
    --gradient-via-color: #9061f9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(144, 97, 249, 0));
  }
  .md\\:focus\\:via-purple-600:focus {
    --gradient-via-color: #7e3af2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(126, 58, 242, 0));
  }
  .md\\:focus\\:via-purple-700:focus {
    --gradient-via-color: #6c2bd9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(108, 43, 217, 0));
  }
  .md\\:focus\\:via-purple-800:focus {
    --gradient-via-color: #5521b5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(85, 33, 181, 0));
  }
  .md\\:focus\\:via-purple-900:focus {
    --gradient-via-color: #4a1d96;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(74, 29, 150, 0));
  }
  .md\\:focus\\:via-pink-50:focus {
    --gradient-via-color: #fdf2f8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 242, 248, 0));
  }
  .md\\:focus\\:via-pink-100:focus {
    --gradient-via-color: #fce8f3;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(252, 232, 243, 0));
  }
  .md\\:focus\\:via-pink-200:focus {
    --gradient-via-color: #fad1e8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(250, 209, 232, 0));
  }
  .md\\:focus\\:via-pink-300:focus {
    --gradient-via-color: #f8b4d9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(248, 180, 217, 0));
  }
  .md\\:focus\\:via-pink-400:focus {
    --gradient-via-color: #f17eb8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(241, 126, 184, 0));
  }
  .md\\:focus\\:via-pink-500:focus {
    --gradient-via-color: #e74694;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(231, 70, 148, 0));
  }
  .md\\:focus\\:via-pink-600:focus {
    --gradient-via-color: #d61f69;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(214, 31, 105, 0));
  }
  .md\\:focus\\:via-pink-700:focus {
    --gradient-via-color: #bf125d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(191, 18, 93, 0));
  }
  .md\\:focus\\:via-pink-800:focus {
    --gradient-via-color: #99154b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(153, 21, 75, 0));
  }
  .md\\:focus\\:via-pink-900:focus {
    --gradient-via-color: #751a3d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(117, 26, 61, 0));
  }
  .md\\:focus\\:via-cool-gray-50:focus {
    --gradient-via-color: #f8fafc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(248, 250, 252, 0));
  }
  .md\\:focus\\:via-cool-gray-100:focus {
    --gradient-via-color: #f1f5f9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(241, 245, 249, 0));
  }
  .md\\:focus\\:via-cool-gray-200:focus {
    --gradient-via-color: #e2e8f0;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(226, 232, 240, 0));
  }
  .md\\:focus\\:via-cool-gray-300:focus {
    --gradient-via-color: #cfd8e3;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(207, 216, 227, 0));
  }
  .md\\:focus\\:via-cool-gray-400:focus {
    --gradient-via-color: #97a6ba;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(151, 166, 186, 0));
  }
  .md\\:focus\\:via-cool-gray-500:focus {
    --gradient-via-color: #64748b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(100, 116, 139, 0));
  }
  .md\\:focus\\:via-cool-gray-600:focus {
    --gradient-via-color: #475569;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(71, 85, 105, 0));
  }
  .md\\:focus\\:via-cool-gray-700:focus {
    --gradient-via-color: #364152;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(54, 65, 82, 0));
  }
  .md\\:focus\\:via-cool-gray-800:focus {
    --gradient-via-color: #27303f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(39, 48, 63, 0));
  }
  .md\\:focus\\:via-cool-gray-900:focus {
    --gradient-via-color: #1a202e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(26, 32, 46, 0));
  }
  .md\\:focus\\:to-current:focus {
    --gradient-to-color: currentColor;
  }
  .md\\:focus\\:to-transparent:focus {
    --gradient-to-color: transparent;
  }
  .md\\:focus\\:to-white:focus {
    --gradient-to-color: #ffffff;
  }
  .md\\:focus\\:to-black:focus {
    --gradient-to-color: #000000;
  }
  .md\\:focus\\:to-gray-50:focus {
    --gradient-to-color: #f9fafb;
  }
  .md\\:focus\\:to-gray-100:focus {
    --gradient-to-color: #f4f5f7;
  }
  .md\\:focus\\:to-gray-200:focus {
    --gradient-to-color: #e5e7eb;
  }
  .md\\:focus\\:to-gray-300:focus {
    --gradient-to-color: #d2d6dc;
  }
  .md\\:focus\\:to-gray-400:focus {
    --gradient-to-color: #9fa6b2;
  }
  .md\\:focus\\:to-gray-500:focus {
    --gradient-to-color: #6b7280;
  }
  .md\\:focus\\:to-gray-600:focus {
    --gradient-to-color: #4b5563;
  }
  .md\\:focus\\:to-gray-700:focus {
    --gradient-to-color: #374151;
  }
  .md\\:focus\\:to-gray-800:focus {
    --gradient-to-color: #252f3f;
  }
  .md\\:focus\\:to-gray-900:focus {
    --gradient-to-color: #161e2e;
  }
  .md\\:focus\\:to-red-50:focus {
    --gradient-to-color: #fdf2f2;
  }
  .md\\:focus\\:to-red-100:focus {
    --gradient-to-color: #fde8e8;
  }
  .md\\:focus\\:to-red-200:focus {
    --gradient-to-color: #fbd5d5;
  }
  .md\\:focus\\:to-red-300:focus {
    --gradient-to-color: #f8b4b4;
  }
  .md\\:focus\\:to-red-400:focus {
    --gradient-to-color: #f98080;
  }
  .md\\:focus\\:to-red-500:focus {
    --gradient-to-color: #f05252;
  }
  .md\\:focus\\:to-red-600:focus {
    --gradient-to-color: #e02424;
  }
  .md\\:focus\\:to-red-700:focus {
    --gradient-to-color: #c81e1e;
  }
  .md\\:focus\\:to-red-800:focus {
    --gradient-to-color: #9b1c1c;
  }
  .md\\:focus\\:to-red-900:focus {
    --gradient-to-color: #771d1d;
  }
  .md\\:focus\\:to-orange-50:focus {
    --gradient-to-color: #fff8f1;
  }
  .md\\:focus\\:to-orange-100:focus {
    --gradient-to-color: #feecdc;
  }
  .md\\:focus\\:to-orange-200:focus {
    --gradient-to-color: #fcd9bd;
  }
  .md\\:focus\\:to-orange-300:focus {
    --gradient-to-color: #fdba8c;
  }
  .md\\:focus\\:to-orange-400:focus {
    --gradient-to-color: #ff8a4c;
  }
  .md\\:focus\\:to-orange-500:focus {
    --gradient-to-color: #ff5a1f;
  }
  .md\\:focus\\:to-orange-600:focus {
    --gradient-to-color: #d03801;
  }
  .md\\:focus\\:to-orange-700:focus {
    --gradient-to-color: #b43403;
  }
  .md\\:focus\\:to-orange-800:focus {
    --gradient-to-color: #8a2c0d;
  }
  .md\\:focus\\:to-orange-900:focus {
    --gradient-to-color: #73230d;
  }
  .md\\:focus\\:to-yellow-50:focus {
    --gradient-to-color: #fdfdea;
  }
  .md\\:focus\\:to-yellow-100:focus {
    --gradient-to-color: #fdf6b2;
  }
  .md\\:focus\\:to-yellow-200:focus {
    --gradient-to-color: #fce96a;
  }
  .md\\:focus\\:to-yellow-300:focus {
    --gradient-to-color: #faca15;
  }
  .md\\:focus\\:to-yellow-400:focus {
    --gradient-to-color: #e3a008;
  }
  .md\\:focus\\:to-yellow-500:focus {
    --gradient-to-color: #c27803;
  }
  .md\\:focus\\:to-yellow-600:focus {
    --gradient-to-color: #9f580a;
  }
  .md\\:focus\\:to-yellow-700:focus {
    --gradient-to-color: #8e4b10;
  }
  .md\\:focus\\:to-yellow-800:focus {
    --gradient-to-color: #723b13;
  }
  .md\\:focus\\:to-yellow-900:focus {
    --gradient-to-color: #633112;
  }
  .md\\:focus\\:to-green-50:focus {
    --gradient-to-color: #f3faf7;
  }
  .md\\:focus\\:to-green-100:focus {
    --gradient-to-color: #def7ec;
  }
  .md\\:focus\\:to-green-200:focus {
    --gradient-to-color: #bcf0da;
  }
  .md\\:focus\\:to-green-300:focus {
    --gradient-to-color: #84e1bc;
  }
  .md\\:focus\\:to-green-400:focus {
    --gradient-to-color: #31c48d;
  }
  .md\\:focus\\:to-green-500:focus {
    --gradient-to-color: #0e9f6e;
  }
  .md\\:focus\\:to-green-600:focus {
    --gradient-to-color: #057a55;
  }
  .md\\:focus\\:to-green-700:focus {
    --gradient-to-color: #046c4e;
  }
  .md\\:focus\\:to-green-800:focus {
    --gradient-to-color: #03543f;
  }
  .md\\:focus\\:to-green-900:focus {
    --gradient-to-color: #014737;
  }
  .md\\:focus\\:to-teal-50:focus {
    --gradient-to-color: #edfafa;
  }
  .md\\:focus\\:to-teal-100:focus {
    --gradient-to-color: #d5f5f6;
  }
  .md\\:focus\\:to-teal-200:focus {
    --gradient-to-color: #afecef;
  }
  .md\\:focus\\:to-teal-300:focus {
    --gradient-to-color: #7edce2;
  }
  .md\\:focus\\:to-teal-400:focus {
    --gradient-to-color: #16bdca;
  }
  .md\\:focus\\:to-teal-500:focus {
    --gradient-to-color: #0694a2;
  }
  .md\\:focus\\:to-teal-600:focus {
    --gradient-to-color: #047481;
  }
  .md\\:focus\\:to-teal-700:focus {
    --gradient-to-color: #036672;
  }
  .md\\:focus\\:to-teal-800:focus {
    --gradient-to-color: #05505c;
  }
  .md\\:focus\\:to-teal-900:focus {
    --gradient-to-color: #014451;
  }
  .md\\:focus\\:to-blue-50:focus {
    --gradient-to-color: #ebf5ff;
  }
  .md\\:focus\\:to-blue-100:focus {
    --gradient-to-color: #e1effe;
  }
  .md\\:focus\\:to-blue-200:focus {
    --gradient-to-color: #c3ddfd;
  }
  .md\\:focus\\:to-blue-300:focus {
    --gradient-to-color: #a4cafe;
  }
  .md\\:focus\\:to-blue-400:focus {
    --gradient-to-color: #76a9fa;
  }
  .md\\:focus\\:to-blue-500:focus {
    --gradient-to-color: #3f83f8;
  }
  .md\\:focus\\:to-blue-600:focus {
    --gradient-to-color: #1c64f2;
  }
  .md\\:focus\\:to-blue-700:focus {
    --gradient-to-color: #1a56db;
  }
  .md\\:focus\\:to-blue-800:focus {
    --gradient-to-color: #1e429f;
  }
  .md\\:focus\\:to-blue-900:focus {
    --gradient-to-color: #233876;
  }
  .md\\:focus\\:to-indigo-50:focus {
    --gradient-to-color: #f0f5ff;
  }
  .md\\:focus\\:to-indigo-100:focus {
    --gradient-to-color: #e5edff;
  }
  .md\\:focus\\:to-indigo-200:focus {
    --gradient-to-color: #cddbfe;
  }
  .md\\:focus\\:to-indigo-300:focus {
    --gradient-to-color: #b4c6fc;
  }
  .md\\:focus\\:to-indigo-400:focus {
    --gradient-to-color: #8da2fb;
  }
  .md\\:focus\\:to-indigo-500:focus {
    --gradient-to-color: #6875f5;
  }
  .md\\:focus\\:to-indigo-600:focus {
    --gradient-to-color: #5850ec;
  }
  .md\\:focus\\:to-indigo-700:focus {
    --gradient-to-color: #5145cd;
  }
  .md\\:focus\\:to-indigo-800:focus {
    --gradient-to-color: #42389d;
  }
  .md\\:focus\\:to-indigo-900:focus {
    --gradient-to-color: #362f78;
  }
  .md\\:focus\\:to-purple-50:focus {
    --gradient-to-color: #f6f5ff;
  }
  .md\\:focus\\:to-purple-100:focus {
    --gradient-to-color: #edebfe;
  }
  .md\\:focus\\:to-purple-200:focus {
    --gradient-to-color: #dcd7fe;
  }
  .md\\:focus\\:to-purple-300:focus {
    --gradient-to-color: #cabffd;
  }
  .md\\:focus\\:to-purple-400:focus {
    --gradient-to-color: #ac94fa;
  }
  .md\\:focus\\:to-purple-500:focus {
    --gradient-to-color: #9061f9;
  }
  .md\\:focus\\:to-purple-600:focus {
    --gradient-to-color: #7e3af2;
  }
  .md\\:focus\\:to-purple-700:focus {
    --gradient-to-color: #6c2bd9;
  }
  .md\\:focus\\:to-purple-800:focus {
    --gradient-to-color: #5521b5;
  }
  .md\\:focus\\:to-purple-900:focus {
    --gradient-to-color: #4a1d96;
  }
  .md\\:focus\\:to-pink-50:focus {
    --gradient-to-color: #fdf2f8;
  }
  .md\\:focus\\:to-pink-100:focus {
    --gradient-to-color: #fce8f3;
  }
  .md\\:focus\\:to-pink-200:focus {
    --gradient-to-color: #fad1e8;
  }
  .md\\:focus\\:to-pink-300:focus {
    --gradient-to-color: #f8b4d9;
  }
  .md\\:focus\\:to-pink-400:focus {
    --gradient-to-color: #f17eb8;
  }
  .md\\:focus\\:to-pink-500:focus {
    --gradient-to-color: #e74694;
  }
  .md\\:focus\\:to-pink-600:focus {
    --gradient-to-color: #d61f69;
  }
  .md\\:focus\\:to-pink-700:focus {
    --gradient-to-color: #bf125d;
  }
  .md\\:focus\\:to-pink-800:focus {
    --gradient-to-color: #99154b;
  }
  .md\\:focus\\:to-pink-900:focus {
    --gradient-to-color: #751a3d;
  }
  .md\\:focus\\:to-cool-gray-50:focus {
    --gradient-to-color: #f8fafc;
  }
  .md\\:focus\\:to-cool-gray-100:focus {
    --gradient-to-color: #f1f5f9;
  }
  .md\\:focus\\:to-cool-gray-200:focus {
    --gradient-to-color: #e2e8f0;
  }
  .md\\:focus\\:to-cool-gray-300:focus {
    --gradient-to-color: #cfd8e3;
  }
  .md\\:focus\\:to-cool-gray-400:focus {
    --gradient-to-color: #97a6ba;
  }
  .md\\:focus\\:to-cool-gray-500:focus {
    --gradient-to-color: #64748b;
  }
  .md\\:focus\\:to-cool-gray-600:focus {
    --gradient-to-color: #475569;
  }
  .md\\:focus\\:to-cool-gray-700:focus {
    --gradient-to-color: #364152;
  }
  .md\\:focus\\:to-cool-gray-800:focus {
    --gradient-to-color: #27303f;
  }
  .md\\:focus\\:to-cool-gray-900:focus {
    --gradient-to-color: #1a202e;
  }
  .md\\:bg-opacity-0 {
    --bg-opacity: 0;
  }
  .md\\:bg-opacity-25 {
    --bg-opacity: 0.25;
  }
  .md\\:bg-opacity-50 {
    --bg-opacity: 0.5;
  }
  .md\\:bg-opacity-75 {
    --bg-opacity: 0.75;
  }
  .md\\:bg-opacity-100 {
    --bg-opacity: 1;
  }
  .md\\:hover\\:bg-opacity-0:hover {
    --bg-opacity: 0;
  }
  .md\\:hover\\:bg-opacity-25:hover {
    --bg-opacity: 0.25;
  }
  .md\\:hover\\:bg-opacity-50:hover {
    --bg-opacity: 0.5;
  }
  .md\\:hover\\:bg-opacity-75:hover {
    --bg-opacity: 0.75;
  }
  .md\\:hover\\:bg-opacity-100:hover {
    --bg-opacity: 1;
  }
  .md\\:focus\\:bg-opacity-0:focus {
    --bg-opacity: 0;
  }
  .md\\:focus\\:bg-opacity-25:focus {
    --bg-opacity: 0.25;
  }
  .md\\:focus\\:bg-opacity-50:focus {
    --bg-opacity: 0.5;
  }
  .md\\:focus\\:bg-opacity-75:focus {
    --bg-opacity: 0.75;
  }
  .md\\:focus\\:bg-opacity-100:focus {
    --bg-opacity: 1;
  }
  .md\\:bg-bottom {
    background-position: bottom;
  }
  .md\\:bg-center {
    background-position: center;
  }
  .md\\:bg-left {
    background-position: left;
  }
  .md\\:bg-left-bottom {
    background-position: left bottom;
  }
  .md\\:bg-left-top {
    background-position: left top;
  }
  .md\\:bg-right {
    background-position: right;
  }
  .md\\:bg-right-bottom {
    background-position: right bottom;
  }
  .md\\:bg-right-top {
    background-position: right top;
  }
  .md\\:bg-top {
    background-position: top;
  }
  .md\\:bg-repeat {
    background-repeat: repeat;
  }
  .md\\:bg-no-repeat {
    background-repeat: no-repeat;
  }
  .md\\:bg-repeat-x {
    background-repeat: repeat-x;
  }
  .md\\:bg-repeat-y {
    background-repeat: repeat-y;
  }
  .md\\:bg-repeat-round {
    background-repeat: round;
  }
  .md\\:bg-repeat-space {
    background-repeat: space;
  }
  .md\\:bg-auto {
    background-size: auto;
  }
  .md\\:bg-cover {
    background-size: cover;
  }
  .md\\:bg-contain {
    background-size: contain;
  }
  .md\\:border-collapse {
    border-collapse: collapse;
  }
  .md\\:border-separate {
    border-collapse: separate;
  }
  .md\\:border-current {
    border-color: currentColor;
  }
  .md\\:border-transparent {
    border-color: transparent;
  }
  .md\\:border-white {
    --border-opacity: 1;
    border-color: #ffffff;
    border-color: rgba(255, 255, 255, var(--border-opacity));
  }
  .md\\:border-black {
    --border-opacity: 1;
    border-color: #000000;
    border-color: rgba(0, 0, 0, var(--border-opacity));
  }
  .md\\:border-gray-50 {
    --border-opacity: 1;
    border-color: #f9fafb;
    border-color: rgba(249, 250, 251, var(--border-opacity));
  }
  .md\\:border-gray-100 {
    --border-opacity: 1;
    border-color: #f4f5f7;
    border-color: rgba(244, 245, 247, var(--border-opacity));
  }
  .md\\:border-gray-200 {
    --border-opacity: 1;
    border-color: #e5e7eb;
    border-color: rgba(229, 231, 235, var(--border-opacity));
  }
  .md\\:border-gray-300 {
    --border-opacity: 1;
    border-color: #d2d6dc;
    border-color: rgba(210, 214, 220, var(--border-opacity));
  }
  .md\\:border-gray-400 {
    --border-opacity: 1;
    border-color: #9fa6b2;
    border-color: rgba(159, 166, 178, var(--border-opacity));
  }
  .md\\:border-gray-500 {
    --border-opacity: 1;
    border-color: #6b7280;
    border-color: rgba(107, 114, 128, var(--border-opacity));
  }
  .md\\:border-gray-600 {
    --border-opacity: 1;
    border-color: #4b5563;
    border-color: rgba(75, 85, 99, var(--border-opacity));
  }
  .md\\:border-gray-700 {
    --border-opacity: 1;
    border-color: #374151;
    border-color: rgba(55, 65, 81, var(--border-opacity));
  }
  .md\\:border-gray-800 {
    --border-opacity: 1;
    border-color: #252f3f;
    border-color: rgba(37, 47, 63, var(--border-opacity));
  }
  .md\\:border-gray-900 {
    --border-opacity: 1;
    border-color: #161e2e;
    border-color: rgba(22, 30, 46, var(--border-opacity));
  }
  .md\\:border-red-50 {
    --border-opacity: 1;
    border-color: #fdf2f2;
    border-color: rgba(253, 242, 242, var(--border-opacity));
  }
  .md\\:border-red-100 {
    --border-opacity: 1;
    border-color: #fde8e8;
    border-color: rgba(253, 232, 232, var(--border-opacity));
  }
  .md\\:border-red-200 {
    --border-opacity: 1;
    border-color: #fbd5d5;
    border-color: rgba(251, 213, 213, var(--border-opacity));
  }
  .md\\:border-red-300 {
    --border-opacity: 1;
    border-color: #f8b4b4;
    border-color: rgba(248, 180, 180, var(--border-opacity));
  }
  .md\\:border-red-400 {
    --border-opacity: 1;
    border-color: #f98080;
    border-color: rgba(249, 128, 128, var(--border-opacity));
  }
  .md\\:border-red-500 {
    --border-opacity: 1;
    border-color: #f05252;
    border-color: rgba(240, 82, 82, var(--border-opacity));
  }
  .md\\:border-red-600 {
    --border-opacity: 1;
    border-color: #e02424;
    border-color: rgba(224, 36, 36, var(--border-opacity));
  }
  .md\\:border-red-700 {
    --border-opacity: 1;
    border-color: #c81e1e;
    border-color: rgba(200, 30, 30, var(--border-opacity));
  }
  .md\\:border-red-800 {
    --border-opacity: 1;
    border-color: #9b1c1c;
    border-color: rgba(155, 28, 28, var(--border-opacity));
  }
  .md\\:border-red-900 {
    --border-opacity: 1;
    border-color: #771d1d;
    border-color: rgba(119, 29, 29, var(--border-opacity));
  }
  .md\\:border-orange-50 {
    --border-opacity: 1;
    border-color: #fff8f1;
    border-color: rgba(255, 248, 241, var(--border-opacity));
  }
  .md\\:border-orange-100 {
    --border-opacity: 1;
    border-color: #feecdc;
    border-color: rgba(254, 236, 220, var(--border-opacity));
  }
  .md\\:border-orange-200 {
    --border-opacity: 1;
    border-color: #fcd9bd;
    border-color: rgba(252, 217, 189, var(--border-opacity));
  }
  .md\\:border-orange-300 {
    --border-opacity: 1;
    border-color: #fdba8c;
    border-color: rgba(253, 186, 140, var(--border-opacity));
  }
  .md\\:border-orange-400 {
    --border-opacity: 1;
    border-color: #ff8a4c;
    border-color: rgba(255, 138, 76, var(--border-opacity));
  }
  .md\\:border-orange-500 {
    --border-opacity: 1;
    border-color: #ff5a1f;
    border-color: rgba(255, 90, 31, var(--border-opacity));
  }
  .md\\:border-orange-600 {
    --border-opacity: 1;
    border-color: #d03801;
    border-color: rgba(208, 56, 1, var(--border-opacity));
  }
  .md\\:border-orange-700 {
    --border-opacity: 1;
    border-color: #b43403;
    border-color: rgba(180, 52, 3, var(--border-opacity));
  }
  .md\\:border-orange-800 {
    --border-opacity: 1;
    border-color: #8a2c0d;
    border-color: rgba(138, 44, 13, var(--border-opacity));
  }
  .md\\:border-orange-900 {
    --border-opacity: 1;
    border-color: #73230d;
    border-color: rgba(115, 35, 13, var(--border-opacity));
  }
  .md\\:border-yellow-50 {
    --border-opacity: 1;
    border-color: #fdfdea;
    border-color: rgba(253, 253, 234, var(--border-opacity));
  }
  .md\\:border-yellow-100 {
    --border-opacity: 1;
    border-color: #fdf6b2;
    border-color: rgba(253, 246, 178, var(--border-opacity));
  }
  .md\\:border-yellow-200 {
    --border-opacity: 1;
    border-color: #fce96a;
    border-color: rgba(252, 233, 106, var(--border-opacity));
  }
  .md\\:border-yellow-300 {
    --border-opacity: 1;
    border-color: #faca15;
    border-color: rgba(250, 202, 21, var(--border-opacity));
  }
  .md\\:border-yellow-400 {
    --border-opacity: 1;
    border-color: #e3a008;
    border-color: rgba(227, 160, 8, var(--border-opacity));
  }
  .md\\:border-yellow-500 {
    --border-opacity: 1;
    border-color: #c27803;
    border-color: rgba(194, 120, 3, var(--border-opacity));
  }
  .md\\:border-yellow-600 {
    --border-opacity: 1;
    border-color: #9f580a;
    border-color: rgba(159, 88, 10, var(--border-opacity));
  }
  .md\\:border-yellow-700 {
    --border-opacity: 1;
    border-color: #8e4b10;
    border-color: rgba(142, 75, 16, var(--border-opacity));
  }
  .md\\:border-yellow-800 {
    --border-opacity: 1;
    border-color: #723b13;
    border-color: rgba(114, 59, 19, var(--border-opacity));
  }
  .md\\:border-yellow-900 {
    --border-opacity: 1;
    border-color: #633112;
    border-color: rgba(99, 49, 18, var(--border-opacity));
  }
  .md\\:border-green-50 {
    --border-opacity: 1;
    border-color: #f3faf7;
    border-color: rgba(243, 250, 247, var(--border-opacity));
  }
  .md\\:border-green-100 {
    --border-opacity: 1;
    border-color: #def7ec;
    border-color: rgba(222, 247, 236, var(--border-opacity));
  }
  .md\\:border-green-200 {
    --border-opacity: 1;
    border-color: #bcf0da;
    border-color: rgba(188, 240, 218, var(--border-opacity));
  }
  .md\\:border-green-300 {
    --border-opacity: 1;
    border-color: #84e1bc;
    border-color: rgba(132, 225, 188, var(--border-opacity));
  }
  .md\\:border-green-400 {
    --border-opacity: 1;
    border-color: #31c48d;
    border-color: rgba(49, 196, 141, var(--border-opacity));
  }
  .md\\:border-green-500 {
    --border-opacity: 1;
    border-color: #0e9f6e;
    border-color: rgba(14, 159, 110, var(--border-opacity));
  }
  .md\\:border-green-600 {
    --border-opacity: 1;
    border-color: #057a55;
    border-color: rgba(5, 122, 85, var(--border-opacity));
  }
  .md\\:border-green-700 {
    --border-opacity: 1;
    border-color: #046c4e;
    border-color: rgba(4, 108, 78, var(--border-opacity));
  }
  .md\\:border-green-800 {
    --border-opacity: 1;
    border-color: #03543f;
    border-color: rgba(3, 84, 63, var(--border-opacity));
  }
  .md\\:border-green-900 {
    --border-opacity: 1;
    border-color: #014737;
    border-color: rgba(1, 71, 55, var(--border-opacity));
  }
  .md\\:border-teal-50 {
    --border-opacity: 1;
    border-color: #edfafa;
    border-color: rgba(237, 250, 250, var(--border-opacity));
  }
  .md\\:border-teal-100 {
    --border-opacity: 1;
    border-color: #d5f5f6;
    border-color: rgba(213, 245, 246, var(--border-opacity));
  }
  .md\\:border-teal-200 {
    --border-opacity: 1;
    border-color: #afecef;
    border-color: rgba(175, 236, 239, var(--border-opacity));
  }
  .md\\:border-teal-300 {
    --border-opacity: 1;
    border-color: #7edce2;
    border-color: rgba(126, 220, 226, var(--border-opacity));
  }
  .md\\:border-teal-400 {
    --border-opacity: 1;
    border-color: #16bdca;
    border-color: rgba(22, 189, 202, var(--border-opacity));
  }
  .md\\:border-teal-500 {
    --border-opacity: 1;
    border-color: #0694a2;
    border-color: rgba(6, 148, 162, var(--border-opacity));
  }
  .md\\:border-teal-600 {
    --border-opacity: 1;
    border-color: #047481;
    border-color: rgba(4, 116, 129, var(--border-opacity));
  }
  .md\\:border-teal-700 {
    --border-opacity: 1;
    border-color: #036672;
    border-color: rgba(3, 102, 114, var(--border-opacity));
  }
  .md\\:border-teal-800 {
    --border-opacity: 1;
    border-color: #05505c;
    border-color: rgba(5, 80, 92, var(--border-opacity));
  }
  .md\\:border-teal-900 {
    --border-opacity: 1;
    border-color: #014451;
    border-color: rgba(1, 68, 81, var(--border-opacity));
  }
  .md\\:border-blue-50 {
    --border-opacity: 1;
    border-color: #ebf5ff;
    border-color: rgba(235, 245, 255, var(--border-opacity));
  }
  .md\\:border-blue-100 {
    --border-opacity: 1;
    border-color: #e1effe;
    border-color: rgba(225, 239, 254, var(--border-opacity));
  }
  .md\\:border-blue-200 {
    --border-opacity: 1;
    border-color: #c3ddfd;
    border-color: rgba(195, 221, 253, var(--border-opacity));
  }
  .md\\:border-blue-300 {
    --border-opacity: 1;
    border-color: #a4cafe;
    border-color: rgba(164, 202, 254, var(--border-opacity));
  }
  .md\\:border-blue-400 {
    --border-opacity: 1;
    border-color: #76a9fa;
    border-color: rgba(118, 169, 250, var(--border-opacity));
  }
  .md\\:border-blue-500 {
    --border-opacity: 1;
    border-color: #3f83f8;
    border-color: rgba(63, 131, 248, var(--border-opacity));
  }
  .md\\:border-blue-600 {
    --border-opacity: 1;
    border-color: #1c64f2;
    border-color: rgba(28, 100, 242, var(--border-opacity));
  }
  .md\\:border-blue-700 {
    --border-opacity: 1;
    border-color: #1a56db;
    border-color: rgba(26, 86, 219, var(--border-opacity));
  }
  .md\\:border-blue-800 {
    --border-opacity: 1;
    border-color: #1e429f;
    border-color: rgba(30, 66, 159, var(--border-opacity));
  }
  .md\\:border-blue-900 {
    --border-opacity: 1;
    border-color: #233876;
    border-color: rgba(35, 56, 118, var(--border-opacity));
  }
  .md\\:border-indigo-50 {
    --border-opacity: 1;
    border-color: #f0f5ff;
    border-color: rgba(240, 245, 255, var(--border-opacity));
  }
  .md\\:border-indigo-100 {
    --border-opacity: 1;
    border-color: #e5edff;
    border-color: rgba(229, 237, 255, var(--border-opacity));
  }
  .md\\:border-indigo-200 {
    --border-opacity: 1;
    border-color: #cddbfe;
    border-color: rgba(205, 219, 254, var(--border-opacity));
  }
  .md\\:border-indigo-300 {
    --border-opacity: 1;
    border-color: #b4c6fc;
    border-color: rgba(180, 198, 252, var(--border-opacity));
  }
  .md\\:border-indigo-400 {
    --border-opacity: 1;
    border-color: #8da2fb;
    border-color: rgba(141, 162, 251, var(--border-opacity));
  }
  .md\\:border-indigo-500 {
    --border-opacity: 1;
    border-color: #6875f5;
    border-color: rgba(104, 117, 245, var(--border-opacity));
  }
  .md\\:border-indigo-600 {
    --border-opacity: 1;
    border-color: #5850ec;
    border-color: rgba(88, 80, 236, var(--border-opacity));
  }
  .md\\:border-indigo-700 {
    --border-opacity: 1;
    border-color: #5145cd;
    border-color: rgba(81, 69, 205, var(--border-opacity));
  }
  .md\\:border-indigo-800 {
    --border-opacity: 1;
    border-color: #42389d;
    border-color: rgba(66, 56, 157, var(--border-opacity));
  }
  .md\\:border-indigo-900 {
    --border-opacity: 1;
    border-color: #362f78;
    border-color: rgba(54, 47, 120, var(--border-opacity));
  }
  .md\\:border-purple-50 {
    --border-opacity: 1;
    border-color: #f6f5ff;
    border-color: rgba(246, 245, 255, var(--border-opacity));
  }
  .md\\:border-purple-100 {
    --border-opacity: 1;
    border-color: #edebfe;
    border-color: rgba(237, 235, 254, var(--border-opacity));
  }
  .md\\:border-purple-200 {
    --border-opacity: 1;
    border-color: #dcd7fe;
    border-color: rgba(220, 215, 254, var(--border-opacity));
  }
  .md\\:border-purple-300 {
    --border-opacity: 1;
    border-color: #cabffd;
    border-color: rgba(202, 191, 253, var(--border-opacity));
  }
  .md\\:border-purple-400 {
    --border-opacity: 1;
    border-color: #ac94fa;
    border-color: rgba(172, 148, 250, var(--border-opacity));
  }
  .md\\:border-purple-500 {
    --border-opacity: 1;
    border-color: #9061f9;
    border-color: rgba(144, 97, 249, var(--border-opacity));
  }
  .md\\:border-purple-600 {
    --border-opacity: 1;
    border-color: #7e3af2;
    border-color: rgba(126, 58, 242, var(--border-opacity));
  }
  .md\\:border-purple-700 {
    --border-opacity: 1;
    border-color: #6c2bd9;
    border-color: rgba(108, 43, 217, var(--border-opacity));
  }
  .md\\:border-purple-800 {
    --border-opacity: 1;
    border-color: #5521b5;
    border-color: rgba(85, 33, 181, var(--border-opacity));
  }
  .md\\:border-purple-900 {
    --border-opacity: 1;
    border-color: #4a1d96;
    border-color: rgba(74, 29, 150, var(--border-opacity));
  }
  .md\\:border-pink-50 {
    --border-opacity: 1;
    border-color: #fdf2f8;
    border-color: rgba(253, 242, 248, var(--border-opacity));
  }
  .md\\:border-pink-100 {
    --border-opacity: 1;
    border-color: #fce8f3;
    border-color: rgba(252, 232, 243, var(--border-opacity));
  }
  .md\\:border-pink-200 {
    --border-opacity: 1;
    border-color: #fad1e8;
    border-color: rgba(250, 209, 232, var(--border-opacity));
  }
  .md\\:border-pink-300 {
    --border-opacity: 1;
    border-color: #f8b4d9;
    border-color: rgba(248, 180, 217, var(--border-opacity));
  }
  .md\\:border-pink-400 {
    --border-opacity: 1;
    border-color: #f17eb8;
    border-color: rgba(241, 126, 184, var(--border-opacity));
  }
  .md\\:border-pink-500 {
    --border-opacity: 1;
    border-color: #e74694;
    border-color: rgba(231, 70, 148, var(--border-opacity));
  }
  .md\\:border-pink-600 {
    --border-opacity: 1;
    border-color: #d61f69;
    border-color: rgba(214, 31, 105, var(--border-opacity));
  }
  .md\\:border-pink-700 {
    --border-opacity: 1;
    border-color: #bf125d;
    border-color: rgba(191, 18, 93, var(--border-opacity));
  }
  .md\\:border-pink-800 {
    --border-opacity: 1;
    border-color: #99154b;
    border-color: rgba(153, 21, 75, var(--border-opacity));
  }
  .md\\:border-pink-900 {
    --border-opacity: 1;
    border-color: #751a3d;
    border-color: rgba(117, 26, 61, var(--border-opacity));
  }
  .md\\:border-cool-gray-50 {
    --border-opacity: 1;
    border-color: #f8fafc;
    border-color: rgba(248, 250, 252, var(--border-opacity));
  }
  .md\\:border-cool-gray-100 {
    --border-opacity: 1;
    border-color: #f1f5f9;
    border-color: rgba(241, 245, 249, var(--border-opacity));
  }
  .md\\:border-cool-gray-200 {
    --border-opacity: 1;
    border-color: #e2e8f0;
    border-color: rgba(226, 232, 240, var(--border-opacity));
  }
  .md\\:border-cool-gray-300 {
    --border-opacity: 1;
    border-color: #cfd8e3;
    border-color: rgba(207, 216, 227, var(--border-opacity));
  }
  .md\\:border-cool-gray-400 {
    --border-opacity: 1;
    border-color: #97a6ba;
    border-color: rgba(151, 166, 186, var(--border-opacity));
  }
  .md\\:border-cool-gray-500 {
    --border-opacity: 1;
    border-color: #64748b;
    border-color: rgba(100, 116, 139, var(--border-opacity));
  }
  .md\\:border-cool-gray-600 {
    --border-opacity: 1;
    border-color: #475569;
    border-color: rgba(71, 85, 105, var(--border-opacity));
  }
  .md\\:border-cool-gray-700 {
    --border-opacity: 1;
    border-color: #364152;
    border-color: rgba(54, 65, 82, var(--border-opacity));
  }
  .md\\:border-cool-gray-800 {
    --border-opacity: 1;
    border-color: #27303f;
    border-color: rgba(39, 48, 63, var(--border-opacity));
  }
  .md\\:border-cool-gray-900 {
    --border-opacity: 1;
    border-color: #1a202e;
    border-color: rgba(26, 32, 46, var(--border-opacity));
  }
  .group:hover .md\\:group-hover\\:border-current {
    border-color: currentColor;
  }
  .group:hover .md\\:group-hover\\:border-transparent {
    border-color: transparent;
  }
  .group:hover .md\\:group-hover\\:border-white {
    --border-opacity: 1;
    border-color: #ffffff;
    border-color: rgba(255, 255, 255, var(--border-opacity));
  }
  .group:hover .md\\:group-hover\\:border-black {
    --border-opacity: 1;
    border-color: #000000;
    border-color: rgba(0, 0, 0, var(--border-opacity));
  }
  .group:hover .md\\:group-hover\\:border-gray-50 {
    --border-opacity: 1;
    border-color: #f9fafb;
    border-color: rgba(249, 250, 251, var(--border-opacity));
  }
  .group:hover .md\\:group-hover\\:border-gray-100 {
    --border-opacity: 1;
    border-color: #f4f5f7;
    border-color: rgba(244, 245, 247, var(--border-opacity));
  }
  .group:hover .md\\:group-hover\\:border-gray-200 {
    --border-opacity: 1;
    border-color: #e5e7eb;
    border-color: rgba(229, 231, 235, var(--border-opacity));
  }
  .group:hover .md\\:group-hover\\:border-gray-300 {
    --border-opacity: 1;
    border-color: #d2d6dc;
    border-color: rgba(210, 214, 220, var(--border-opacity));
  }
  .group:hover .md\\:group-hover\\:border-gray-400 {
    --border-opacity: 1;
    border-color: #9fa6b2;
    border-color: rgba(159, 166, 178, var(--border-opacity));
  }
  .group:hover .md\\:group-hover\\:border-gray-500 {
    --border-opacity: 1;
    border-color: #6b7280;
    border-color: rgba(107, 114, 128, var(--border-opacity));
  }
  .group:hover .md\\:group-hover\\:border-gray-600 {
    --border-opacity: 1;
    border-color: #4b5563;
    border-color: rgba(75, 85, 99, var(--border-opacity));
  }
  .group:hover .md\\:group-hover\\:border-gray-700 {
    --border-opacity: 1;
    border-color: #374151;
    border-color: rgba(55, 65, 81, var(--border-opacity));
  }
  .group:hover .md\\:group-hover\\:border-gray-800 {
    --border-opacity: 1;
    border-color: #252f3f;
    border-color: rgba(37, 47, 63, var(--border-opacity));
  }
  .group:hover .md\\:group-hover\\:border-gray-900 {
    --border-opacity: 1;
    border-color: #161e2e;
    border-color: rgba(22, 30, 46, var(--border-opacity));
  }
  .group:hover .md\\:group-hover\\:border-red-50 {
    --border-opacity: 1;
    border-color: #fdf2f2;
    border-color: rgba(253, 242, 242, var(--border-opacity));
  }
  .group:hover .md\\:group-hover\\:border-red-100 {
    --border-opacity: 1;
    border-color: #fde8e8;
    border-color: rgba(253, 232, 232, var(--border-opacity));
  }
  .group:hover .md\\:group-hover\\:border-red-200 {
    --border-opacity: 1;
    border-color: #fbd5d5;
    border-color: rgba(251, 213, 213, var(--border-opacity));
  }
  .group:hover .md\\:group-hover\\:border-red-300 {
    --border-opacity: 1;
    border-color: #f8b4b4;
    border-color: rgba(248, 180, 180, var(--border-opacity));
  }
  .group:hover .md\\:group-hover\\:border-red-400 {
    --border-opacity: 1;
    border-color: #f98080;
    border-color: rgba(249, 128, 128, var(--border-opacity));
  }
  .group:hover .md\\:group-hover\\:border-red-500 {
    --border-opacity: 1;
    border-color: #f05252;
    border-color: rgba(240, 82, 82, var(--border-opacity));
  }
  .group:hover .md\\:group-hover\\:border-red-600 {
    --border-opacity: 1;
    border-color: #e02424;
    border-color: rgba(224, 36, 36, var(--border-opacity));
  }
  .group:hover .md\\:group-hover\\:border-red-700 {
    --border-opacity: 1;
    border-color: #c81e1e;
    border-color: rgba(200, 30, 30, var(--border-opacity));
  }
  .group:hover .md\\:group-hover\\:border-red-800 {
    --border-opacity: 1;
    border-color: #9b1c1c;
    border-color: rgba(155, 28, 28, var(--border-opacity));
  }
  .group:hover .md\\:group-hover\\:border-red-900 {
    --border-opacity: 1;
    border-color: #771d1d;
    border-color: rgba(119, 29, 29, var(--border-opacity));
  }
  .group:hover .md\\:group-hover\\:border-orange-50 {
    --border-opacity: 1;
    border-color: #fff8f1;
    border-color: rgba(255, 248, 241, var(--border-opacity));
  }
  .group:hover .md\\:group-hover\\:border-orange-100 {
    --border-opacity: 1;
    border-color: #feecdc;
    border-color: rgba(254, 236, 220, var(--border-opacity));
  }
  .group:hover .md\\:group-hover\\:border-orange-200 {
    --border-opacity: 1;
    border-color: #fcd9bd;
    border-color: rgba(252, 217, 189, var(--border-opacity));
  }
  .group:hover .md\\:group-hover\\:border-orange-300 {
    --border-opacity: 1;
    border-color: #fdba8c;
    border-color: rgba(253, 186, 140, var(--border-opacity));
  }
  .group:hover .md\\:group-hover\\:border-orange-400 {
    --border-opacity: 1;
    border-color: #ff8a4c;
    border-color: rgba(255, 138, 76, var(--border-opacity));
  }
  .group:hover .md\\:group-hover\\:border-orange-500 {
    --border-opacity: 1;
    border-color: #ff5a1f;
    border-color: rgba(255, 90, 31, var(--border-opacity));
  }
  .group:hover .md\\:group-hover\\:border-orange-600 {
    --border-opacity: 1;
    border-color: #d03801;
    border-color: rgba(208, 56, 1, var(--border-opacity));
  }
  .group:hover .md\\:group-hover\\:border-orange-700 {
    --border-opacity: 1;
    border-color: #b43403;
    border-color: rgba(180, 52, 3, var(--border-opacity));
  }
  .group:hover .md\\:group-hover\\:border-orange-800 {
    --border-opacity: 1;
    border-color: #8a2c0d;
    border-color: rgba(138, 44, 13, var(--border-opacity));
  }
  .group:hover .md\\:group-hover\\:border-orange-900 {
    --border-opacity: 1;
    border-color: #73230d;
    border-color: rgba(115, 35, 13, var(--border-opacity));
  }
  .group:hover .md\\:group-hover\\:border-yellow-50 {
    --border-opacity: 1;
    border-color: #fdfdea;
    border-color: rgba(253, 253, 234, var(--border-opacity));
  }
  .group:hover .md\\:group-hover\\:border-yellow-100 {
    --border-opacity: 1;
    border-color: #fdf6b2;
    border-color: rgba(253, 246, 178, var(--border-opacity));
  }
  .group:hover .md\\:group-hover\\:border-yellow-200 {
    --border-opacity: 1;
    border-color: #fce96a;
    border-color: rgba(252, 233, 106, var(--border-opacity));
  }
  .group:hover .md\\:group-hover\\:border-yellow-300 {
    --border-opacity: 1;
    border-color: #faca15;
    border-color: rgba(250, 202, 21, var(--border-opacity));
  }
  .group:hover .md\\:group-hover\\:border-yellow-400 {
    --border-opacity: 1;
    border-color: #e3a008;
    border-color: rgba(227, 160, 8, var(--border-opacity));
  }
  .group:hover .md\\:group-hover\\:border-yellow-500 {
    --border-opacity: 1;
    border-color: #c27803;
    border-color: rgba(194, 120, 3, var(--border-opacity));
  }
  .group:hover .md\\:group-hover\\:border-yellow-600 {
    --border-opacity: 1;
    border-color: #9f580a;
    border-color: rgba(159, 88, 10, var(--border-opacity));
  }
  .group:hover .md\\:group-hover\\:border-yellow-700 {
    --border-opacity: 1;
    border-color: #8e4b10;
    border-color: rgba(142, 75, 16, var(--border-opacity));
  }
  .group:hover .md\\:group-hover\\:border-yellow-800 {
    --border-opacity: 1;
    border-color: #723b13;
    border-color: rgba(114, 59, 19, var(--border-opacity));
  }
  .group:hover .md\\:group-hover\\:border-yellow-900 {
    --border-opacity: 1;
    border-color: #633112;
    border-color: rgba(99, 49, 18, var(--border-opacity));
  }
  .group:hover .md\\:group-hover\\:border-green-50 {
    --border-opacity: 1;
    border-color: #f3faf7;
    border-color: rgba(243, 250, 247, var(--border-opacity));
  }
  .group:hover .md\\:group-hover\\:border-green-100 {
    --border-opacity: 1;
    border-color: #def7ec;
    border-color: rgba(222, 247, 236, var(--border-opacity));
  }
  .group:hover .md\\:group-hover\\:border-green-200 {
    --border-opacity: 1;
    border-color: #bcf0da;
    border-color: rgba(188, 240, 218, var(--border-opacity));
  }
  .group:hover .md\\:group-hover\\:border-green-300 {
    --border-opacity: 1;
    border-color: #84e1bc;
    border-color: rgba(132, 225, 188, var(--border-opacity));
  }
  .group:hover .md\\:group-hover\\:border-green-400 {
    --border-opacity: 1;
    border-color: #31c48d;
    border-color: rgba(49, 196, 141, var(--border-opacity));
  }
  .group:hover .md\\:group-hover\\:border-green-500 {
    --border-opacity: 1;
    border-color: #0e9f6e;
    border-color: rgba(14, 159, 110, var(--border-opacity));
  }
  .group:hover .md\\:group-hover\\:border-green-600 {
    --border-opacity: 1;
    border-color: #057a55;
    border-color: rgba(5, 122, 85, var(--border-opacity));
  }
  .group:hover .md\\:group-hover\\:border-green-700 {
    --border-opacity: 1;
    border-color: #046c4e;
    border-color: rgba(4, 108, 78, var(--border-opacity));
  }
  .group:hover .md\\:group-hover\\:border-green-800 {
    --border-opacity: 1;
    border-color: #03543f;
    border-color: rgba(3, 84, 63, var(--border-opacity));
  }
  .group:hover .md\\:group-hover\\:border-green-900 {
    --border-opacity: 1;
    border-color: #014737;
    border-color: rgba(1, 71, 55, var(--border-opacity));
  }
  .group:hover .md\\:group-hover\\:border-teal-50 {
    --border-opacity: 1;
    border-color: #edfafa;
    border-color: rgba(237, 250, 250, var(--border-opacity));
  }
  .group:hover .md\\:group-hover\\:border-teal-100 {
    --border-opacity: 1;
    border-color: #d5f5f6;
    border-color: rgba(213, 245, 246, var(--border-opacity));
  }
  .group:hover .md\\:group-hover\\:border-teal-200 {
    --border-opacity: 1;
    border-color: #afecef;
    border-color: rgba(175, 236, 239, var(--border-opacity));
  }
  .group:hover .md\\:group-hover\\:border-teal-300 {
    --border-opacity: 1;
    border-color: #7edce2;
    border-color: rgba(126, 220, 226, var(--border-opacity));
  }
  .group:hover .md\\:group-hover\\:border-teal-400 {
    --border-opacity: 1;
    border-color: #16bdca;
    border-color: rgba(22, 189, 202, var(--border-opacity));
  }
  .group:hover .md\\:group-hover\\:border-teal-500 {
    --border-opacity: 1;
    border-color: #0694a2;
    border-color: rgba(6, 148, 162, var(--border-opacity));
  }
  .group:hover .md\\:group-hover\\:border-teal-600 {
    --border-opacity: 1;
    border-color: #047481;
    border-color: rgba(4, 116, 129, var(--border-opacity));
  }
  .group:hover .md\\:group-hover\\:border-teal-700 {
    --border-opacity: 1;
    border-color: #036672;
    border-color: rgba(3, 102, 114, var(--border-opacity));
  }
  .group:hover .md\\:group-hover\\:border-teal-800 {
    --border-opacity: 1;
    border-color: #05505c;
    border-color: rgba(5, 80, 92, var(--border-opacity));
  }
  .group:hover .md\\:group-hover\\:border-teal-900 {
    --border-opacity: 1;
    border-color: #014451;
    border-color: rgba(1, 68, 81, var(--border-opacity));
  }
  .group:hover .md\\:group-hover\\:border-blue-50 {
    --border-opacity: 1;
    border-color: #ebf5ff;
    border-color: rgba(235, 245, 255, var(--border-opacity));
  }
  .group:hover .md\\:group-hover\\:border-blue-100 {
    --border-opacity: 1;
    border-color: #e1effe;
    border-color: rgba(225, 239, 254, var(--border-opacity));
  }
  .group:hover .md\\:group-hover\\:border-blue-200 {
    --border-opacity: 1;
    border-color: #c3ddfd;
    border-color: rgba(195, 221, 253, var(--border-opacity));
  }
  .group:hover .md\\:group-hover\\:border-blue-300 {
    --border-opacity: 1;
    border-color: #a4cafe;
    border-color: rgba(164, 202, 254, var(--border-opacity));
  }
  .group:hover .md\\:group-hover\\:border-blue-400 {
    --border-opacity: 1;
    border-color: #76a9fa;
    border-color: rgba(118, 169, 250, var(--border-opacity));
  }
  .group:hover .md\\:group-hover\\:border-blue-500 {
    --border-opacity: 1;
    border-color: #3f83f8;
    border-color: rgba(63, 131, 248, var(--border-opacity));
  }
  .group:hover .md\\:group-hover\\:border-blue-600 {
    --border-opacity: 1;
    border-color: #1c64f2;
    border-color: rgba(28, 100, 242, var(--border-opacity));
  }
  .group:hover .md\\:group-hover\\:border-blue-700 {
    --border-opacity: 1;
    border-color: #1a56db;
    border-color: rgba(26, 86, 219, var(--border-opacity));
  }
  .group:hover .md\\:group-hover\\:border-blue-800 {
    --border-opacity: 1;
    border-color: #1e429f;
    border-color: rgba(30, 66, 159, var(--border-opacity));
  }
  .group:hover .md\\:group-hover\\:border-blue-900 {
    --border-opacity: 1;
    border-color: #233876;
    border-color: rgba(35, 56, 118, var(--border-opacity));
  }
  .group:hover .md\\:group-hover\\:border-indigo-50 {
    --border-opacity: 1;
    border-color: #f0f5ff;
    border-color: rgba(240, 245, 255, var(--border-opacity));
  }
  .group:hover .md\\:group-hover\\:border-indigo-100 {
    --border-opacity: 1;
    border-color: #e5edff;
    border-color: rgba(229, 237, 255, var(--border-opacity));
  }
  .group:hover .md\\:group-hover\\:border-indigo-200 {
    --border-opacity: 1;
    border-color: #cddbfe;
    border-color: rgba(205, 219, 254, var(--border-opacity));
  }
  .group:hover .md\\:group-hover\\:border-indigo-300 {
    --border-opacity: 1;
    border-color: #b4c6fc;
    border-color: rgba(180, 198, 252, var(--border-opacity));
  }
  .group:hover .md\\:group-hover\\:border-indigo-400 {
    --border-opacity: 1;
    border-color: #8da2fb;
    border-color: rgba(141, 162, 251, var(--border-opacity));
  }
  .group:hover .md\\:group-hover\\:border-indigo-500 {
    --border-opacity: 1;
    border-color: #6875f5;
    border-color: rgba(104, 117, 245, var(--border-opacity));
  }
  .group:hover .md\\:group-hover\\:border-indigo-600 {
    --border-opacity: 1;
    border-color: #5850ec;
    border-color: rgba(88, 80, 236, var(--border-opacity));
  }
  .group:hover .md\\:group-hover\\:border-indigo-700 {
    --border-opacity: 1;
    border-color: #5145cd;
    border-color: rgba(81, 69, 205, var(--border-opacity));
  }
  .group:hover .md\\:group-hover\\:border-indigo-800 {
    --border-opacity: 1;
    border-color: #42389d;
    border-color: rgba(66, 56, 157, var(--border-opacity));
  }
  .group:hover .md\\:group-hover\\:border-indigo-900 {
    --border-opacity: 1;
    border-color: #362f78;
    border-color: rgba(54, 47, 120, var(--border-opacity));
  }
  .group:hover .md\\:group-hover\\:border-purple-50 {
    --border-opacity: 1;
    border-color: #f6f5ff;
    border-color: rgba(246, 245, 255, var(--border-opacity));
  }
  .group:hover .md\\:group-hover\\:border-purple-100 {
    --border-opacity: 1;
    border-color: #edebfe;
    border-color: rgba(237, 235, 254, var(--border-opacity));
  }
  .group:hover .md\\:group-hover\\:border-purple-200 {
    --border-opacity: 1;
    border-color: #dcd7fe;
    border-color: rgba(220, 215, 254, var(--border-opacity));
  }
  .group:hover .md\\:group-hover\\:border-purple-300 {
    --border-opacity: 1;
    border-color: #cabffd;
    border-color: rgba(202, 191, 253, var(--border-opacity));
  }
  .group:hover .md\\:group-hover\\:border-purple-400 {
    --border-opacity: 1;
    border-color: #ac94fa;
    border-color: rgba(172, 148, 250, var(--border-opacity));
  }
  .group:hover .md\\:group-hover\\:border-purple-500 {
    --border-opacity: 1;
    border-color: #9061f9;
    border-color: rgba(144, 97, 249, var(--border-opacity));
  }
  .group:hover .md\\:group-hover\\:border-purple-600 {
    --border-opacity: 1;
    border-color: #7e3af2;
    border-color: rgba(126, 58, 242, var(--border-opacity));
  }
  .group:hover .md\\:group-hover\\:border-purple-700 {
    --border-opacity: 1;
    border-color: #6c2bd9;
    border-color: rgba(108, 43, 217, var(--border-opacity));
  }
  .group:hover .md\\:group-hover\\:border-purple-800 {
    --border-opacity: 1;
    border-color: #5521b5;
    border-color: rgba(85, 33, 181, var(--border-opacity));
  }
  .group:hover .md\\:group-hover\\:border-purple-900 {
    --border-opacity: 1;
    border-color: #4a1d96;
    border-color: rgba(74, 29, 150, var(--border-opacity));
  }
  .group:hover .md\\:group-hover\\:border-pink-50 {
    --border-opacity: 1;
    border-color: #fdf2f8;
    border-color: rgba(253, 242, 248, var(--border-opacity));
  }
  .group:hover .md\\:group-hover\\:border-pink-100 {
    --border-opacity: 1;
    border-color: #fce8f3;
    border-color: rgba(252, 232, 243, var(--border-opacity));
  }
  .group:hover .md\\:group-hover\\:border-pink-200 {
    --border-opacity: 1;
    border-color: #fad1e8;
    border-color: rgba(250, 209, 232, var(--border-opacity));
  }
  .group:hover .md\\:group-hover\\:border-pink-300 {
    --border-opacity: 1;
    border-color: #f8b4d9;
    border-color: rgba(248, 180, 217, var(--border-opacity));
  }
  .group:hover .md\\:group-hover\\:border-pink-400 {
    --border-opacity: 1;
    border-color: #f17eb8;
    border-color: rgba(241, 126, 184, var(--border-opacity));
  }
  .group:hover .md\\:group-hover\\:border-pink-500 {
    --border-opacity: 1;
    border-color: #e74694;
    border-color: rgba(231, 70, 148, var(--border-opacity));
  }
  .group:hover .md\\:group-hover\\:border-pink-600 {
    --border-opacity: 1;
    border-color: #d61f69;
    border-color: rgba(214, 31, 105, var(--border-opacity));
  }
  .group:hover .md\\:group-hover\\:border-pink-700 {
    --border-opacity: 1;
    border-color: #bf125d;
    border-color: rgba(191, 18, 93, var(--border-opacity));
  }
  .group:hover .md\\:group-hover\\:border-pink-800 {
    --border-opacity: 1;
    border-color: #99154b;
    border-color: rgba(153, 21, 75, var(--border-opacity));
  }
  .group:hover .md\\:group-hover\\:border-pink-900 {
    --border-opacity: 1;
    border-color: #751a3d;
    border-color: rgba(117, 26, 61, var(--border-opacity));
  }
  .group:hover .md\\:group-hover\\:border-cool-gray-50 {
    --border-opacity: 1;
    border-color: #f8fafc;
    border-color: rgba(248, 250, 252, var(--border-opacity));
  }
  .group:hover .md\\:group-hover\\:border-cool-gray-100 {
    --border-opacity: 1;
    border-color: #f1f5f9;
    border-color: rgba(241, 245, 249, var(--border-opacity));
  }
  .group:hover .md\\:group-hover\\:border-cool-gray-200 {
    --border-opacity: 1;
    border-color: #e2e8f0;
    border-color: rgba(226, 232, 240, var(--border-opacity));
  }
  .group:hover .md\\:group-hover\\:border-cool-gray-300 {
    --border-opacity: 1;
    border-color: #cfd8e3;
    border-color: rgba(207, 216, 227, var(--border-opacity));
  }
  .group:hover .md\\:group-hover\\:border-cool-gray-400 {
    --border-opacity: 1;
    border-color: #97a6ba;
    border-color: rgba(151, 166, 186, var(--border-opacity));
  }
  .group:hover .md\\:group-hover\\:border-cool-gray-500 {
    --border-opacity: 1;
    border-color: #64748b;
    border-color: rgba(100, 116, 139, var(--border-opacity));
  }
  .group:hover .md\\:group-hover\\:border-cool-gray-600 {
    --border-opacity: 1;
    border-color: #475569;
    border-color: rgba(71, 85, 105, var(--border-opacity));
  }
  .group:hover .md\\:group-hover\\:border-cool-gray-700 {
    --border-opacity: 1;
    border-color: #364152;
    border-color: rgba(54, 65, 82, var(--border-opacity));
  }
  .group:hover .md\\:group-hover\\:border-cool-gray-800 {
    --border-opacity: 1;
    border-color: #27303f;
    border-color: rgba(39, 48, 63, var(--border-opacity));
  }
  .group:hover .md\\:group-hover\\:border-cool-gray-900 {
    --border-opacity: 1;
    border-color: #1a202e;
    border-color: rgba(26, 32, 46, var(--border-opacity));
  }
  .group:focus .md\\:group-focus\\:border-current {
    border-color: currentColor;
  }
  .group:focus .md\\:group-focus\\:border-transparent {
    border-color: transparent;
  }
  .group:focus .md\\:group-focus\\:border-white {
    --border-opacity: 1;
    border-color: #ffffff;
    border-color: rgba(255, 255, 255, var(--border-opacity));
  }
  .group:focus .md\\:group-focus\\:border-black {
    --border-opacity: 1;
    border-color: #000000;
    border-color: rgba(0, 0, 0, var(--border-opacity));
  }
  .group:focus .md\\:group-focus\\:border-gray-50 {
    --border-opacity: 1;
    border-color: #f9fafb;
    border-color: rgba(249, 250, 251, var(--border-opacity));
  }
  .group:focus .md\\:group-focus\\:border-gray-100 {
    --border-opacity: 1;
    border-color: #f4f5f7;
    border-color: rgba(244, 245, 247, var(--border-opacity));
  }
  .group:focus .md\\:group-focus\\:border-gray-200 {
    --border-opacity: 1;
    border-color: #e5e7eb;
    border-color: rgba(229, 231, 235, var(--border-opacity));
  }
  .group:focus .md\\:group-focus\\:border-gray-300 {
    --border-opacity: 1;
    border-color: #d2d6dc;
    border-color: rgba(210, 214, 220, var(--border-opacity));
  }
  .group:focus .md\\:group-focus\\:border-gray-400 {
    --border-opacity: 1;
    border-color: #9fa6b2;
    border-color: rgba(159, 166, 178, var(--border-opacity));
  }
  .group:focus .md\\:group-focus\\:border-gray-500 {
    --border-opacity: 1;
    border-color: #6b7280;
    border-color: rgba(107, 114, 128, var(--border-opacity));
  }
  .group:focus .md\\:group-focus\\:border-gray-600 {
    --border-opacity: 1;
    border-color: #4b5563;
    border-color: rgba(75, 85, 99, var(--border-opacity));
  }
  .group:focus .md\\:group-focus\\:border-gray-700 {
    --border-opacity: 1;
    border-color: #374151;
    border-color: rgba(55, 65, 81, var(--border-opacity));
  }
  .group:focus .md\\:group-focus\\:border-gray-800 {
    --border-opacity: 1;
    border-color: #252f3f;
    border-color: rgba(37, 47, 63, var(--border-opacity));
  }
  .group:focus .md\\:group-focus\\:border-gray-900 {
    --border-opacity: 1;
    border-color: #161e2e;
    border-color: rgba(22, 30, 46, var(--border-opacity));
  }
  .group:focus .md\\:group-focus\\:border-red-50 {
    --border-opacity: 1;
    border-color: #fdf2f2;
    border-color: rgba(253, 242, 242, var(--border-opacity));
  }
  .group:focus .md\\:group-focus\\:border-red-100 {
    --border-opacity: 1;
    border-color: #fde8e8;
    border-color: rgba(253, 232, 232, var(--border-opacity));
  }
  .group:focus .md\\:group-focus\\:border-red-200 {
    --border-opacity: 1;
    border-color: #fbd5d5;
    border-color: rgba(251, 213, 213, var(--border-opacity));
  }
  .group:focus .md\\:group-focus\\:border-red-300 {
    --border-opacity: 1;
    border-color: #f8b4b4;
    border-color: rgba(248, 180, 180, var(--border-opacity));
  }
  .group:focus .md\\:group-focus\\:border-red-400 {
    --border-opacity: 1;
    border-color: #f98080;
    border-color: rgba(249, 128, 128, var(--border-opacity));
  }
  .group:focus .md\\:group-focus\\:border-red-500 {
    --border-opacity: 1;
    border-color: #f05252;
    border-color: rgba(240, 82, 82, var(--border-opacity));
  }
  .group:focus .md\\:group-focus\\:border-red-600 {
    --border-opacity: 1;
    border-color: #e02424;
    border-color: rgba(224, 36, 36, var(--border-opacity));
  }
  .group:focus .md\\:group-focus\\:border-red-700 {
    --border-opacity: 1;
    border-color: #c81e1e;
    border-color: rgba(200, 30, 30, var(--border-opacity));
  }
  .group:focus .md\\:group-focus\\:border-red-800 {
    --border-opacity: 1;
    border-color: #9b1c1c;
    border-color: rgba(155, 28, 28, var(--border-opacity));
  }
  .group:focus .md\\:group-focus\\:border-red-900 {
    --border-opacity: 1;
    border-color: #771d1d;
    border-color: rgba(119, 29, 29, var(--border-opacity));
  }
  .group:focus .md\\:group-focus\\:border-orange-50 {
    --border-opacity: 1;
    border-color: #fff8f1;
    border-color: rgba(255, 248, 241, var(--border-opacity));
  }
  .group:focus .md\\:group-focus\\:border-orange-100 {
    --border-opacity: 1;
    border-color: #feecdc;
    border-color: rgba(254, 236, 220, var(--border-opacity));
  }
  .group:focus .md\\:group-focus\\:border-orange-200 {
    --border-opacity: 1;
    border-color: #fcd9bd;
    border-color: rgba(252, 217, 189, var(--border-opacity));
  }
  .group:focus .md\\:group-focus\\:border-orange-300 {
    --border-opacity: 1;
    border-color: #fdba8c;
    border-color: rgba(253, 186, 140, var(--border-opacity));
  }
  .group:focus .md\\:group-focus\\:border-orange-400 {
    --border-opacity: 1;
    border-color: #ff8a4c;
    border-color: rgba(255, 138, 76, var(--border-opacity));
  }
  .group:focus .md\\:group-focus\\:border-orange-500 {
    --border-opacity: 1;
    border-color: #ff5a1f;
    border-color: rgba(255, 90, 31, var(--border-opacity));
  }
  .group:focus .md\\:group-focus\\:border-orange-600 {
    --border-opacity: 1;
    border-color: #d03801;
    border-color: rgba(208, 56, 1, var(--border-opacity));
  }
  .group:focus .md\\:group-focus\\:border-orange-700 {
    --border-opacity: 1;
    border-color: #b43403;
    border-color: rgba(180, 52, 3, var(--border-opacity));
  }
  .group:focus .md\\:group-focus\\:border-orange-800 {
    --border-opacity: 1;
    border-color: #8a2c0d;
    border-color: rgba(138, 44, 13, var(--border-opacity));
  }
  .group:focus .md\\:group-focus\\:border-orange-900 {
    --border-opacity: 1;
    border-color: #73230d;
    border-color: rgba(115, 35, 13, var(--border-opacity));
  }
  .group:focus .md\\:group-focus\\:border-yellow-50 {
    --border-opacity: 1;
    border-color: #fdfdea;
    border-color: rgba(253, 253, 234, var(--border-opacity));
  }
  .group:focus .md\\:group-focus\\:border-yellow-100 {
    --border-opacity: 1;
    border-color: #fdf6b2;
    border-color: rgba(253, 246, 178, var(--border-opacity));
  }
  .group:focus .md\\:group-focus\\:border-yellow-200 {
    --border-opacity: 1;
    border-color: #fce96a;
    border-color: rgba(252, 233, 106, var(--border-opacity));
  }
  .group:focus .md\\:group-focus\\:border-yellow-300 {
    --border-opacity: 1;
    border-color: #faca15;
    border-color: rgba(250, 202, 21, var(--border-opacity));
  }
  .group:focus .md\\:group-focus\\:border-yellow-400 {
    --border-opacity: 1;
    border-color: #e3a008;
    border-color: rgba(227, 160, 8, var(--border-opacity));
  }
  .group:focus .md\\:group-focus\\:border-yellow-500 {
    --border-opacity: 1;
    border-color: #c27803;
    border-color: rgba(194, 120, 3, var(--border-opacity));
  }
  .group:focus .md\\:group-focus\\:border-yellow-600 {
    --border-opacity: 1;
    border-color: #9f580a;
    border-color: rgba(159, 88, 10, var(--border-opacity));
  }
  .group:focus .md\\:group-focus\\:border-yellow-700 {
    --border-opacity: 1;
    border-color: #8e4b10;
    border-color: rgba(142, 75, 16, var(--border-opacity));
  }
  .group:focus .md\\:group-focus\\:border-yellow-800 {
    --border-opacity: 1;
    border-color: #723b13;
    border-color: rgba(114, 59, 19, var(--border-opacity));
  }
  .group:focus .md\\:group-focus\\:border-yellow-900 {
    --border-opacity: 1;
    border-color: #633112;
    border-color: rgba(99, 49, 18, var(--border-opacity));
  }
  .group:focus .md\\:group-focus\\:border-green-50 {
    --border-opacity: 1;
    border-color: #f3faf7;
    border-color: rgba(243, 250, 247, var(--border-opacity));
  }
  .group:focus .md\\:group-focus\\:border-green-100 {
    --border-opacity: 1;
    border-color: #def7ec;
    border-color: rgba(222, 247, 236, var(--border-opacity));
  }
  .group:focus .md\\:group-focus\\:border-green-200 {
    --border-opacity: 1;
    border-color: #bcf0da;
    border-color: rgba(188, 240, 218, var(--border-opacity));
  }
  .group:focus .md\\:group-focus\\:border-green-300 {
    --border-opacity: 1;
    border-color: #84e1bc;
    border-color: rgba(132, 225, 188, var(--border-opacity));
  }
  .group:focus .md\\:group-focus\\:border-green-400 {
    --border-opacity: 1;
    border-color: #31c48d;
    border-color: rgba(49, 196, 141, var(--border-opacity));
  }
  .group:focus .md\\:group-focus\\:border-green-500 {
    --border-opacity: 1;
    border-color: #0e9f6e;
    border-color: rgba(14, 159, 110, var(--border-opacity));
  }
  .group:focus .md\\:group-focus\\:border-green-600 {
    --border-opacity: 1;
    border-color: #057a55;
    border-color: rgba(5, 122, 85, var(--border-opacity));
  }
  .group:focus .md\\:group-focus\\:border-green-700 {
    --border-opacity: 1;
    border-color: #046c4e;
    border-color: rgba(4, 108, 78, var(--border-opacity));
  }
  .group:focus .md\\:group-focus\\:border-green-800 {
    --border-opacity: 1;
    border-color: #03543f;
    border-color: rgba(3, 84, 63, var(--border-opacity));
  }
  .group:focus .md\\:group-focus\\:border-green-900 {
    --border-opacity: 1;
    border-color: #014737;
    border-color: rgba(1, 71, 55, var(--border-opacity));
  }
  .group:focus .md\\:group-focus\\:border-teal-50 {
    --border-opacity: 1;
    border-color: #edfafa;
    border-color: rgba(237, 250, 250, var(--border-opacity));
  }
  .group:focus .md\\:group-focus\\:border-teal-100 {
    --border-opacity: 1;
    border-color: #d5f5f6;
    border-color: rgba(213, 245, 246, var(--border-opacity));
  }
  .group:focus .md\\:group-focus\\:border-teal-200 {
    --border-opacity: 1;
    border-color: #afecef;
    border-color: rgba(175, 236, 239, var(--border-opacity));
  }
  .group:focus .md\\:group-focus\\:border-teal-300 {
    --border-opacity: 1;
    border-color: #7edce2;
    border-color: rgba(126, 220, 226, var(--border-opacity));
  }
  .group:focus .md\\:group-focus\\:border-teal-400 {
    --border-opacity: 1;
    border-color: #16bdca;
    border-color: rgba(22, 189, 202, var(--border-opacity));
  }
  .group:focus .md\\:group-focus\\:border-teal-500 {
    --border-opacity: 1;
    border-color: #0694a2;
    border-color: rgba(6, 148, 162, var(--border-opacity));
  }
  .group:focus .md\\:group-focus\\:border-teal-600 {
    --border-opacity: 1;
    border-color: #047481;
    border-color: rgba(4, 116, 129, var(--border-opacity));
  }
  .group:focus .md\\:group-focus\\:border-teal-700 {
    --border-opacity: 1;
    border-color: #036672;
    border-color: rgba(3, 102, 114, var(--border-opacity));
  }
  .group:focus .md\\:group-focus\\:border-teal-800 {
    --border-opacity: 1;
    border-color: #05505c;
    border-color: rgba(5, 80, 92, var(--border-opacity));
  }
  .group:focus .md\\:group-focus\\:border-teal-900 {
    --border-opacity: 1;
    border-color: #014451;
    border-color: rgba(1, 68, 81, var(--border-opacity));
  }
  .group:focus .md\\:group-focus\\:border-blue-50 {
    --border-opacity: 1;
    border-color: #ebf5ff;
    border-color: rgba(235, 245, 255, var(--border-opacity));
  }
  .group:focus .md\\:group-focus\\:border-blue-100 {
    --border-opacity: 1;
    border-color: #e1effe;
    border-color: rgba(225, 239, 254, var(--border-opacity));
  }
  .group:focus .md\\:group-focus\\:border-blue-200 {
    --border-opacity: 1;
    border-color: #c3ddfd;
    border-color: rgba(195, 221, 253, var(--border-opacity));
  }
  .group:focus .md\\:group-focus\\:border-blue-300 {
    --border-opacity: 1;
    border-color: #a4cafe;
    border-color: rgba(164, 202, 254, var(--border-opacity));
  }
  .group:focus .md\\:group-focus\\:border-blue-400 {
    --border-opacity: 1;
    border-color: #76a9fa;
    border-color: rgba(118, 169, 250, var(--border-opacity));
  }
  .group:focus .md\\:group-focus\\:border-blue-500 {
    --border-opacity: 1;
    border-color: #3f83f8;
    border-color: rgba(63, 131, 248, var(--border-opacity));
  }
  .group:focus .md\\:group-focus\\:border-blue-600 {
    --border-opacity: 1;
    border-color: #1c64f2;
    border-color: rgba(28, 100, 242, var(--border-opacity));
  }
  .group:focus .md\\:group-focus\\:border-blue-700 {
    --border-opacity: 1;
    border-color: #1a56db;
    border-color: rgba(26, 86, 219, var(--border-opacity));
  }
  .group:focus .md\\:group-focus\\:border-blue-800 {
    --border-opacity: 1;
    border-color: #1e429f;
    border-color: rgba(30, 66, 159, var(--border-opacity));
  }
  .group:focus .md\\:group-focus\\:border-blue-900 {
    --border-opacity: 1;
    border-color: #233876;
    border-color: rgba(35, 56, 118, var(--border-opacity));
  }
  .group:focus .md\\:group-focus\\:border-indigo-50 {
    --border-opacity: 1;
    border-color: #f0f5ff;
    border-color: rgba(240, 245, 255, var(--border-opacity));
  }
  .group:focus .md\\:group-focus\\:border-indigo-100 {
    --border-opacity: 1;
    border-color: #e5edff;
    border-color: rgba(229, 237, 255, var(--border-opacity));
  }
  .group:focus .md\\:group-focus\\:border-indigo-200 {
    --border-opacity: 1;
    border-color: #cddbfe;
    border-color: rgba(205, 219, 254, var(--border-opacity));
  }
  .group:focus .md\\:group-focus\\:border-indigo-300 {
    --border-opacity: 1;
    border-color: #b4c6fc;
    border-color: rgba(180, 198, 252, var(--border-opacity));
  }
  .group:focus .md\\:group-focus\\:border-indigo-400 {
    --border-opacity: 1;
    border-color: #8da2fb;
    border-color: rgba(141, 162, 251, var(--border-opacity));
  }
  .group:focus .md\\:group-focus\\:border-indigo-500 {
    --border-opacity: 1;
    border-color: #6875f5;
    border-color: rgba(104, 117, 245, var(--border-opacity));
  }
  .group:focus .md\\:group-focus\\:border-indigo-600 {
    --border-opacity: 1;
    border-color: #5850ec;
    border-color: rgba(88, 80, 236, var(--border-opacity));
  }
  .group:focus .md\\:group-focus\\:border-indigo-700 {
    --border-opacity: 1;
    border-color: #5145cd;
    border-color: rgba(81, 69, 205, var(--border-opacity));
  }
  .group:focus .md\\:group-focus\\:border-indigo-800 {
    --border-opacity: 1;
    border-color: #42389d;
    border-color: rgba(66, 56, 157, var(--border-opacity));
  }
  .group:focus .md\\:group-focus\\:border-indigo-900 {
    --border-opacity: 1;
    border-color: #362f78;
    border-color: rgba(54, 47, 120, var(--border-opacity));
  }
  .group:focus .md\\:group-focus\\:border-purple-50 {
    --border-opacity: 1;
    border-color: #f6f5ff;
    border-color: rgba(246, 245, 255, var(--border-opacity));
  }
  .group:focus .md\\:group-focus\\:border-purple-100 {
    --border-opacity: 1;
    border-color: #edebfe;
    border-color: rgba(237, 235, 254, var(--border-opacity));
  }
  .group:focus .md\\:group-focus\\:border-purple-200 {
    --border-opacity: 1;
    border-color: #dcd7fe;
    border-color: rgba(220, 215, 254, var(--border-opacity));
  }
  .group:focus .md\\:group-focus\\:border-purple-300 {
    --border-opacity: 1;
    border-color: #cabffd;
    border-color: rgba(202, 191, 253, var(--border-opacity));
  }
  .group:focus .md\\:group-focus\\:border-purple-400 {
    --border-opacity: 1;
    border-color: #ac94fa;
    border-color: rgba(172, 148, 250, var(--border-opacity));
  }
  .group:focus .md\\:group-focus\\:border-purple-500 {
    --border-opacity: 1;
    border-color: #9061f9;
    border-color: rgba(144, 97, 249, var(--border-opacity));
  }
  .group:focus .md\\:group-focus\\:border-purple-600 {
    --border-opacity: 1;
    border-color: #7e3af2;
    border-color: rgba(126, 58, 242, var(--border-opacity));
  }
  .group:focus .md\\:group-focus\\:border-purple-700 {
    --border-opacity: 1;
    border-color: #6c2bd9;
    border-color: rgba(108, 43, 217, var(--border-opacity));
  }
  .group:focus .md\\:group-focus\\:border-purple-800 {
    --border-opacity: 1;
    border-color: #5521b5;
    border-color: rgba(85, 33, 181, var(--border-opacity));
  }
  .group:focus .md\\:group-focus\\:border-purple-900 {
    --border-opacity: 1;
    border-color: #4a1d96;
    border-color: rgba(74, 29, 150, var(--border-opacity));
  }
  .group:focus .md\\:group-focus\\:border-pink-50 {
    --border-opacity: 1;
    border-color: #fdf2f8;
    border-color: rgba(253, 242, 248, var(--border-opacity));
  }
  .group:focus .md\\:group-focus\\:border-pink-100 {
    --border-opacity: 1;
    border-color: #fce8f3;
    border-color: rgba(252, 232, 243, var(--border-opacity));
  }
  .group:focus .md\\:group-focus\\:border-pink-200 {
    --border-opacity: 1;
    border-color: #fad1e8;
    border-color: rgba(250, 209, 232, var(--border-opacity));
  }
  .group:focus .md\\:group-focus\\:border-pink-300 {
    --border-opacity: 1;
    border-color: #f8b4d9;
    border-color: rgba(248, 180, 217, var(--border-opacity));
  }
  .group:focus .md\\:group-focus\\:border-pink-400 {
    --border-opacity: 1;
    border-color: #f17eb8;
    border-color: rgba(241, 126, 184, var(--border-opacity));
  }
  .group:focus .md\\:group-focus\\:border-pink-500 {
    --border-opacity: 1;
    border-color: #e74694;
    border-color: rgba(231, 70, 148, var(--border-opacity));
  }
  .group:focus .md\\:group-focus\\:border-pink-600 {
    --border-opacity: 1;
    border-color: #d61f69;
    border-color: rgba(214, 31, 105, var(--border-opacity));
  }
  .group:focus .md\\:group-focus\\:border-pink-700 {
    --border-opacity: 1;
    border-color: #bf125d;
    border-color: rgba(191, 18, 93, var(--border-opacity));
  }
  .group:focus .md\\:group-focus\\:border-pink-800 {
    --border-opacity: 1;
    border-color: #99154b;
    border-color: rgba(153, 21, 75, var(--border-opacity));
  }
  .group:focus .md\\:group-focus\\:border-pink-900 {
    --border-opacity: 1;
    border-color: #751a3d;
    border-color: rgba(117, 26, 61, var(--border-opacity));
  }
  .group:focus .md\\:group-focus\\:border-cool-gray-50 {
    --border-opacity: 1;
    border-color: #f8fafc;
    border-color: rgba(248, 250, 252, var(--border-opacity));
  }
  .group:focus .md\\:group-focus\\:border-cool-gray-100 {
    --border-opacity: 1;
    border-color: #f1f5f9;
    border-color: rgba(241, 245, 249, var(--border-opacity));
  }
  .group:focus .md\\:group-focus\\:border-cool-gray-200 {
    --border-opacity: 1;
    border-color: #e2e8f0;
    border-color: rgba(226, 232, 240, var(--border-opacity));
  }
  .group:focus .md\\:group-focus\\:border-cool-gray-300 {
    --border-opacity: 1;
    border-color: #cfd8e3;
    border-color: rgba(207, 216, 227, var(--border-opacity));
  }
  .group:focus .md\\:group-focus\\:border-cool-gray-400 {
    --border-opacity: 1;
    border-color: #97a6ba;
    border-color: rgba(151, 166, 186, var(--border-opacity));
  }
  .group:focus .md\\:group-focus\\:border-cool-gray-500 {
    --border-opacity: 1;
    border-color: #64748b;
    border-color: rgba(100, 116, 139, var(--border-opacity));
  }
  .group:focus .md\\:group-focus\\:border-cool-gray-600 {
    --border-opacity: 1;
    border-color: #475569;
    border-color: rgba(71, 85, 105, var(--border-opacity));
  }
  .group:focus .md\\:group-focus\\:border-cool-gray-700 {
    --border-opacity: 1;
    border-color: #364152;
    border-color: rgba(54, 65, 82, var(--border-opacity));
  }
  .group:focus .md\\:group-focus\\:border-cool-gray-800 {
    --border-opacity: 1;
    border-color: #27303f;
    border-color: rgba(39, 48, 63, var(--border-opacity));
  }
  .group:focus .md\\:group-focus\\:border-cool-gray-900 {
    --border-opacity: 1;
    border-color: #1a202e;
    border-color: rgba(26, 32, 46, var(--border-opacity));
  }
  .md\\:hover\\:border-current:hover {
    border-color: currentColor;
  }
  .md\\:hover\\:border-transparent:hover {
    border-color: transparent;
  }
  .md\\:hover\\:border-white:hover {
    --border-opacity: 1;
    border-color: #ffffff;
    border-color: rgba(255, 255, 255, var(--border-opacity));
  }
  .md\\:hover\\:border-black:hover {
    --border-opacity: 1;
    border-color: #000000;
    border-color: rgba(0, 0, 0, var(--border-opacity));
  }
  .md\\:hover\\:border-gray-50:hover {
    --border-opacity: 1;
    border-color: #f9fafb;
    border-color: rgba(249, 250, 251, var(--border-opacity));
  }
  .md\\:hover\\:border-gray-100:hover {
    --border-opacity: 1;
    border-color: #f4f5f7;
    border-color: rgba(244, 245, 247, var(--border-opacity));
  }
  .md\\:hover\\:border-gray-200:hover {
    --border-opacity: 1;
    border-color: #e5e7eb;
    border-color: rgba(229, 231, 235, var(--border-opacity));
  }
  .md\\:hover\\:border-gray-300:hover {
    --border-opacity: 1;
    border-color: #d2d6dc;
    border-color: rgba(210, 214, 220, var(--border-opacity));
  }
  .md\\:hover\\:border-gray-400:hover {
    --border-opacity: 1;
    border-color: #9fa6b2;
    border-color: rgba(159, 166, 178, var(--border-opacity));
  }
  .md\\:hover\\:border-gray-500:hover {
    --border-opacity: 1;
    border-color: #6b7280;
    border-color: rgba(107, 114, 128, var(--border-opacity));
  }
  .md\\:hover\\:border-gray-600:hover {
    --border-opacity: 1;
    border-color: #4b5563;
    border-color: rgba(75, 85, 99, var(--border-opacity));
  }
  .md\\:hover\\:border-gray-700:hover {
    --border-opacity: 1;
    border-color: #374151;
    border-color: rgba(55, 65, 81, var(--border-opacity));
  }
  .md\\:hover\\:border-gray-800:hover {
    --border-opacity: 1;
    border-color: #252f3f;
    border-color: rgba(37, 47, 63, var(--border-opacity));
  }
  .md\\:hover\\:border-gray-900:hover {
    --border-opacity: 1;
    border-color: #161e2e;
    border-color: rgba(22, 30, 46, var(--border-opacity));
  }
  .md\\:hover\\:border-red-50:hover {
    --border-opacity: 1;
    border-color: #fdf2f2;
    border-color: rgba(253, 242, 242, var(--border-opacity));
  }
  .md\\:hover\\:border-red-100:hover {
    --border-opacity: 1;
    border-color: #fde8e8;
    border-color: rgba(253, 232, 232, var(--border-opacity));
  }
  .md\\:hover\\:border-red-200:hover {
    --border-opacity: 1;
    border-color: #fbd5d5;
    border-color: rgba(251, 213, 213, var(--border-opacity));
  }
  .md\\:hover\\:border-red-300:hover {
    --border-opacity: 1;
    border-color: #f8b4b4;
    border-color: rgba(248, 180, 180, var(--border-opacity));
  }
  .md\\:hover\\:border-red-400:hover {
    --border-opacity: 1;
    border-color: #f98080;
    border-color: rgba(249, 128, 128, var(--border-opacity));
  }
  .md\\:hover\\:border-red-500:hover {
    --border-opacity: 1;
    border-color: #f05252;
    border-color: rgba(240, 82, 82, var(--border-opacity));
  }
  .md\\:hover\\:border-red-600:hover {
    --border-opacity: 1;
    border-color: #e02424;
    border-color: rgba(224, 36, 36, var(--border-opacity));
  }
  .md\\:hover\\:border-red-700:hover {
    --border-opacity: 1;
    border-color: #c81e1e;
    border-color: rgba(200, 30, 30, var(--border-opacity));
  }
  .md\\:hover\\:border-red-800:hover {
    --border-opacity: 1;
    border-color: #9b1c1c;
    border-color: rgba(155, 28, 28, var(--border-opacity));
  }
  .md\\:hover\\:border-red-900:hover {
    --border-opacity: 1;
    border-color: #771d1d;
    border-color: rgba(119, 29, 29, var(--border-opacity));
  }
  .md\\:hover\\:border-orange-50:hover {
    --border-opacity: 1;
    border-color: #fff8f1;
    border-color: rgba(255, 248, 241, var(--border-opacity));
  }
  .md\\:hover\\:border-orange-100:hover {
    --border-opacity: 1;
    border-color: #feecdc;
    border-color: rgba(254, 236, 220, var(--border-opacity));
  }
  .md\\:hover\\:border-orange-200:hover {
    --border-opacity: 1;
    border-color: #fcd9bd;
    border-color: rgba(252, 217, 189, var(--border-opacity));
  }
  .md\\:hover\\:border-orange-300:hover {
    --border-opacity: 1;
    border-color: #fdba8c;
    border-color: rgba(253, 186, 140, var(--border-opacity));
  }
  .md\\:hover\\:border-orange-400:hover {
    --border-opacity: 1;
    border-color: #ff8a4c;
    border-color: rgba(255, 138, 76, var(--border-opacity));
  }
  .md\\:hover\\:border-orange-500:hover {
    --border-opacity: 1;
    border-color: #ff5a1f;
    border-color: rgba(255, 90, 31, var(--border-opacity));
  }
  .md\\:hover\\:border-orange-600:hover {
    --border-opacity: 1;
    border-color: #d03801;
    border-color: rgba(208, 56, 1, var(--border-opacity));
  }
  .md\\:hover\\:border-orange-700:hover {
    --border-opacity: 1;
    border-color: #b43403;
    border-color: rgba(180, 52, 3, var(--border-opacity));
  }
  .md\\:hover\\:border-orange-800:hover {
    --border-opacity: 1;
    border-color: #8a2c0d;
    border-color: rgba(138, 44, 13, var(--border-opacity));
  }
  .md\\:hover\\:border-orange-900:hover {
    --border-opacity: 1;
    border-color: #73230d;
    border-color: rgba(115, 35, 13, var(--border-opacity));
  }
  .md\\:hover\\:border-yellow-50:hover {
    --border-opacity: 1;
    border-color: #fdfdea;
    border-color: rgba(253, 253, 234, var(--border-opacity));
  }
  .md\\:hover\\:border-yellow-100:hover {
    --border-opacity: 1;
    border-color: #fdf6b2;
    border-color: rgba(253, 246, 178, var(--border-opacity));
  }
  .md\\:hover\\:border-yellow-200:hover {
    --border-opacity: 1;
    border-color: #fce96a;
    border-color: rgba(252, 233, 106, var(--border-opacity));
  }
  .md\\:hover\\:border-yellow-300:hover {
    --border-opacity: 1;
    border-color: #faca15;
    border-color: rgba(250, 202, 21, var(--border-opacity));
  }
  .md\\:hover\\:border-yellow-400:hover {
    --border-opacity: 1;
    border-color: #e3a008;
    border-color: rgba(227, 160, 8, var(--border-opacity));
  }
  .md\\:hover\\:border-yellow-500:hover {
    --border-opacity: 1;
    border-color: #c27803;
    border-color: rgba(194, 120, 3, var(--border-opacity));
  }
  .md\\:hover\\:border-yellow-600:hover {
    --border-opacity: 1;
    border-color: #9f580a;
    border-color: rgba(159, 88, 10, var(--border-opacity));
  }
  .md\\:hover\\:border-yellow-700:hover {
    --border-opacity: 1;
    border-color: #8e4b10;
    border-color: rgba(142, 75, 16, var(--border-opacity));
  }
  .md\\:hover\\:border-yellow-800:hover {
    --border-opacity: 1;
    border-color: #723b13;
    border-color: rgba(114, 59, 19, var(--border-opacity));
  }
  .md\\:hover\\:border-yellow-900:hover {
    --border-opacity: 1;
    border-color: #633112;
    border-color: rgba(99, 49, 18, var(--border-opacity));
  }
  .md\\:hover\\:border-green-50:hover {
    --border-opacity: 1;
    border-color: #f3faf7;
    border-color: rgba(243, 250, 247, var(--border-opacity));
  }
  .md\\:hover\\:border-green-100:hover {
    --border-opacity: 1;
    border-color: #def7ec;
    border-color: rgba(222, 247, 236, var(--border-opacity));
  }
  .md\\:hover\\:border-green-200:hover {
    --border-opacity: 1;
    border-color: #bcf0da;
    border-color: rgba(188, 240, 218, var(--border-opacity));
  }
  .md\\:hover\\:border-green-300:hover {
    --border-opacity: 1;
    border-color: #84e1bc;
    border-color: rgba(132, 225, 188, var(--border-opacity));
  }
  .md\\:hover\\:border-green-400:hover {
    --border-opacity: 1;
    border-color: #31c48d;
    border-color: rgba(49, 196, 141, var(--border-opacity));
  }
  .md\\:hover\\:border-green-500:hover {
    --border-opacity: 1;
    border-color: #0e9f6e;
    border-color: rgba(14, 159, 110, var(--border-opacity));
  }
  .md\\:hover\\:border-green-600:hover {
    --border-opacity: 1;
    border-color: #057a55;
    border-color: rgba(5, 122, 85, var(--border-opacity));
  }
  .md\\:hover\\:border-green-700:hover {
    --border-opacity: 1;
    border-color: #046c4e;
    border-color: rgba(4, 108, 78, var(--border-opacity));
  }
  .md\\:hover\\:border-green-800:hover {
    --border-opacity: 1;
    border-color: #03543f;
    border-color: rgba(3, 84, 63, var(--border-opacity));
  }
  .md\\:hover\\:border-green-900:hover {
    --border-opacity: 1;
    border-color: #014737;
    border-color: rgba(1, 71, 55, var(--border-opacity));
  }
  .md\\:hover\\:border-teal-50:hover {
    --border-opacity: 1;
    border-color: #edfafa;
    border-color: rgba(237, 250, 250, var(--border-opacity));
  }
  .md\\:hover\\:border-teal-100:hover {
    --border-opacity: 1;
    border-color: #d5f5f6;
    border-color: rgba(213, 245, 246, var(--border-opacity));
  }
  .md\\:hover\\:border-teal-200:hover {
    --border-opacity: 1;
    border-color: #afecef;
    border-color: rgba(175, 236, 239, var(--border-opacity));
  }
  .md\\:hover\\:border-teal-300:hover {
    --border-opacity: 1;
    border-color: #7edce2;
    border-color: rgba(126, 220, 226, var(--border-opacity));
  }
  .md\\:hover\\:border-teal-400:hover {
    --border-opacity: 1;
    border-color: #16bdca;
    border-color: rgba(22, 189, 202, var(--border-opacity));
  }
  .md\\:hover\\:border-teal-500:hover {
    --border-opacity: 1;
    border-color: #0694a2;
    border-color: rgba(6, 148, 162, var(--border-opacity));
  }
  .md\\:hover\\:border-teal-600:hover {
    --border-opacity: 1;
    border-color: #047481;
    border-color: rgba(4, 116, 129, var(--border-opacity));
  }
  .md\\:hover\\:border-teal-700:hover {
    --border-opacity: 1;
    border-color: #036672;
    border-color: rgba(3, 102, 114, var(--border-opacity));
  }
  .md\\:hover\\:border-teal-800:hover {
    --border-opacity: 1;
    border-color: #05505c;
    border-color: rgba(5, 80, 92, var(--border-opacity));
  }
  .md\\:hover\\:border-teal-900:hover {
    --border-opacity: 1;
    border-color: #014451;
    border-color: rgba(1, 68, 81, var(--border-opacity));
  }
  .md\\:hover\\:border-blue-50:hover {
    --border-opacity: 1;
    border-color: #ebf5ff;
    border-color: rgba(235, 245, 255, var(--border-opacity));
  }
  .md\\:hover\\:border-blue-100:hover {
    --border-opacity: 1;
    border-color: #e1effe;
    border-color: rgba(225, 239, 254, var(--border-opacity));
  }
  .md\\:hover\\:border-blue-200:hover {
    --border-opacity: 1;
    border-color: #c3ddfd;
    border-color: rgba(195, 221, 253, var(--border-opacity));
  }
  .md\\:hover\\:border-blue-300:hover {
    --border-opacity: 1;
    border-color: #a4cafe;
    border-color: rgba(164, 202, 254, var(--border-opacity));
  }
  .md\\:hover\\:border-blue-400:hover {
    --border-opacity: 1;
    border-color: #76a9fa;
    border-color: rgba(118, 169, 250, var(--border-opacity));
  }
  .md\\:hover\\:border-blue-500:hover {
    --border-opacity: 1;
    border-color: #3f83f8;
    border-color: rgba(63, 131, 248, var(--border-opacity));
  }
  .md\\:hover\\:border-blue-600:hover {
    --border-opacity: 1;
    border-color: #1c64f2;
    border-color: rgba(28, 100, 242, var(--border-opacity));
  }
  .md\\:hover\\:border-blue-700:hover {
    --border-opacity: 1;
    border-color: #1a56db;
    border-color: rgba(26, 86, 219, var(--border-opacity));
  }
  .md\\:hover\\:border-blue-800:hover {
    --border-opacity: 1;
    border-color: #1e429f;
    border-color: rgba(30, 66, 159, var(--border-opacity));
  }
  .md\\:hover\\:border-blue-900:hover {
    --border-opacity: 1;
    border-color: #233876;
    border-color: rgba(35, 56, 118, var(--border-opacity));
  }
  .md\\:hover\\:border-indigo-50:hover {
    --border-opacity: 1;
    border-color: #f0f5ff;
    border-color: rgba(240, 245, 255, var(--border-opacity));
  }
  .md\\:hover\\:border-indigo-100:hover {
    --border-opacity: 1;
    border-color: #e5edff;
    border-color: rgba(229, 237, 255, var(--border-opacity));
  }
  .md\\:hover\\:border-indigo-200:hover {
    --border-opacity: 1;
    border-color: #cddbfe;
    border-color: rgba(205, 219, 254, var(--border-opacity));
  }
  .md\\:hover\\:border-indigo-300:hover {
    --border-opacity: 1;
    border-color: #b4c6fc;
    border-color: rgba(180, 198, 252, var(--border-opacity));
  }
  .md\\:hover\\:border-indigo-400:hover {
    --border-opacity: 1;
    border-color: #8da2fb;
    border-color: rgba(141, 162, 251, var(--border-opacity));
  }
  .md\\:hover\\:border-indigo-500:hover {
    --border-opacity: 1;
    border-color: #6875f5;
    border-color: rgba(104, 117, 245, var(--border-opacity));
  }
  .md\\:hover\\:border-indigo-600:hover {
    --border-opacity: 1;
    border-color: #5850ec;
    border-color: rgba(88, 80, 236, var(--border-opacity));
  }
  .md\\:hover\\:border-indigo-700:hover {
    --border-opacity: 1;
    border-color: #5145cd;
    border-color: rgba(81, 69, 205, var(--border-opacity));
  }
  .md\\:hover\\:border-indigo-800:hover {
    --border-opacity: 1;
    border-color: #42389d;
    border-color: rgba(66, 56, 157, var(--border-opacity));
  }
  .md\\:hover\\:border-indigo-900:hover {
    --border-opacity: 1;
    border-color: #362f78;
    border-color: rgba(54, 47, 120, var(--border-opacity));
  }
  .md\\:hover\\:border-purple-50:hover {
    --border-opacity: 1;
    border-color: #f6f5ff;
    border-color: rgba(246, 245, 255, var(--border-opacity));
  }
  .md\\:hover\\:border-purple-100:hover {
    --border-opacity: 1;
    border-color: #edebfe;
    border-color: rgba(237, 235, 254, var(--border-opacity));
  }
  .md\\:hover\\:border-purple-200:hover {
    --border-opacity: 1;
    border-color: #dcd7fe;
    border-color: rgba(220, 215, 254, var(--border-opacity));
  }
  .md\\:hover\\:border-purple-300:hover {
    --border-opacity: 1;
    border-color: #cabffd;
    border-color: rgba(202, 191, 253, var(--border-opacity));
  }
  .md\\:hover\\:border-purple-400:hover {
    --border-opacity: 1;
    border-color: #ac94fa;
    border-color: rgba(172, 148, 250, var(--border-opacity));
  }
  .md\\:hover\\:border-purple-500:hover {
    --border-opacity: 1;
    border-color: #9061f9;
    border-color: rgba(144, 97, 249, var(--border-opacity));
  }
  .md\\:hover\\:border-purple-600:hover {
    --border-opacity: 1;
    border-color: #7e3af2;
    border-color: rgba(126, 58, 242, var(--border-opacity));
  }
  .md\\:hover\\:border-purple-700:hover {
    --border-opacity: 1;
    border-color: #6c2bd9;
    border-color: rgba(108, 43, 217, var(--border-opacity));
  }
  .md\\:hover\\:border-purple-800:hover {
    --border-opacity: 1;
    border-color: #5521b5;
    border-color: rgba(85, 33, 181, var(--border-opacity));
  }
  .md\\:hover\\:border-purple-900:hover {
    --border-opacity: 1;
    border-color: #4a1d96;
    border-color: rgba(74, 29, 150, var(--border-opacity));
  }
  .md\\:hover\\:border-pink-50:hover {
    --border-opacity: 1;
    border-color: #fdf2f8;
    border-color: rgba(253, 242, 248, var(--border-opacity));
  }
  .md\\:hover\\:border-pink-100:hover {
    --border-opacity: 1;
    border-color: #fce8f3;
    border-color: rgba(252, 232, 243, var(--border-opacity));
  }
  .md\\:hover\\:border-pink-200:hover {
    --border-opacity: 1;
    border-color: #fad1e8;
    border-color: rgba(250, 209, 232, var(--border-opacity));
  }
  .md\\:hover\\:border-pink-300:hover {
    --border-opacity: 1;
    border-color: #f8b4d9;
    border-color: rgba(248, 180, 217, var(--border-opacity));
  }
  .md\\:hover\\:border-pink-400:hover {
    --border-opacity: 1;
    border-color: #f17eb8;
    border-color: rgba(241, 126, 184, var(--border-opacity));
  }
  .md\\:hover\\:border-pink-500:hover {
    --border-opacity: 1;
    border-color: #e74694;
    border-color: rgba(231, 70, 148, var(--border-opacity));
  }
  .md\\:hover\\:border-pink-600:hover {
    --border-opacity: 1;
    border-color: #d61f69;
    border-color: rgba(214, 31, 105, var(--border-opacity));
  }
  .md\\:hover\\:border-pink-700:hover {
    --border-opacity: 1;
    border-color: #bf125d;
    border-color: rgba(191, 18, 93, var(--border-opacity));
  }
  .md\\:hover\\:border-pink-800:hover {
    --border-opacity: 1;
    border-color: #99154b;
    border-color: rgba(153, 21, 75, var(--border-opacity));
  }
  .md\\:hover\\:border-pink-900:hover {
    --border-opacity: 1;
    border-color: #751a3d;
    border-color: rgba(117, 26, 61, var(--border-opacity));
  }
  .md\\:hover\\:border-cool-gray-50:hover {
    --border-opacity: 1;
    border-color: #f8fafc;
    border-color: rgba(248, 250, 252, var(--border-opacity));
  }
  .md\\:hover\\:border-cool-gray-100:hover {
    --border-opacity: 1;
    border-color: #f1f5f9;
    border-color: rgba(241, 245, 249, var(--border-opacity));
  }
  .md\\:hover\\:border-cool-gray-200:hover {
    --border-opacity: 1;
    border-color: #e2e8f0;
    border-color: rgba(226, 232, 240, var(--border-opacity));
  }
  .md\\:hover\\:border-cool-gray-300:hover {
    --border-opacity: 1;
    border-color: #cfd8e3;
    border-color: rgba(207, 216, 227, var(--border-opacity));
  }
  .md\\:hover\\:border-cool-gray-400:hover {
    --border-opacity: 1;
    border-color: #97a6ba;
    border-color: rgba(151, 166, 186, var(--border-opacity));
  }
  .md\\:hover\\:border-cool-gray-500:hover {
    --border-opacity: 1;
    border-color: #64748b;
    border-color: rgba(100, 116, 139, var(--border-opacity));
  }
  .md\\:hover\\:border-cool-gray-600:hover {
    --border-opacity: 1;
    border-color: #475569;
    border-color: rgba(71, 85, 105, var(--border-opacity));
  }
  .md\\:hover\\:border-cool-gray-700:hover {
    --border-opacity: 1;
    border-color: #364152;
    border-color: rgba(54, 65, 82, var(--border-opacity));
  }
  .md\\:hover\\:border-cool-gray-800:hover {
    --border-opacity: 1;
    border-color: #27303f;
    border-color: rgba(39, 48, 63, var(--border-opacity));
  }
  .md\\:hover\\:border-cool-gray-900:hover {
    --border-opacity: 1;
    border-color: #1a202e;
    border-color: rgba(26, 32, 46, var(--border-opacity));
  }
  .md\\:focus-within\\:border-current:focus-within {
    border-color: currentColor;
  }
  .md\\:focus-within\\:border-transparent:focus-within {
    border-color: transparent;
  }
  .md\\:focus-within\\:border-white:focus-within {
    --border-opacity: 1;
    border-color: #ffffff;
    border-color: rgba(255, 255, 255, var(--border-opacity));
  }
  .md\\:focus-within\\:border-black:focus-within {
    --border-opacity: 1;
    border-color: #000000;
    border-color: rgba(0, 0, 0, var(--border-opacity));
  }
  .md\\:focus-within\\:border-gray-50:focus-within {
    --border-opacity: 1;
    border-color: #f9fafb;
    border-color: rgba(249, 250, 251, var(--border-opacity));
  }
  .md\\:focus-within\\:border-gray-100:focus-within {
    --border-opacity: 1;
    border-color: #f4f5f7;
    border-color: rgba(244, 245, 247, var(--border-opacity));
  }
  .md\\:focus-within\\:border-gray-200:focus-within {
    --border-opacity: 1;
    border-color: #e5e7eb;
    border-color: rgba(229, 231, 235, var(--border-opacity));
  }
  .md\\:focus-within\\:border-gray-300:focus-within {
    --border-opacity: 1;
    border-color: #d2d6dc;
    border-color: rgba(210, 214, 220, var(--border-opacity));
  }
  .md\\:focus-within\\:border-gray-400:focus-within {
    --border-opacity: 1;
    border-color: #9fa6b2;
    border-color: rgba(159, 166, 178, var(--border-opacity));
  }
  .md\\:focus-within\\:border-gray-500:focus-within {
    --border-opacity: 1;
    border-color: #6b7280;
    border-color: rgba(107, 114, 128, var(--border-opacity));
  }
  .md\\:focus-within\\:border-gray-600:focus-within {
    --border-opacity: 1;
    border-color: #4b5563;
    border-color: rgba(75, 85, 99, var(--border-opacity));
  }
  .md\\:focus-within\\:border-gray-700:focus-within {
    --border-opacity: 1;
    border-color: #374151;
    border-color: rgba(55, 65, 81, var(--border-opacity));
  }
  .md\\:focus-within\\:border-gray-800:focus-within {
    --border-opacity: 1;
    border-color: #252f3f;
    border-color: rgba(37, 47, 63, var(--border-opacity));
  }
  .md\\:focus-within\\:border-gray-900:focus-within {
    --border-opacity: 1;
    border-color: #161e2e;
    border-color: rgba(22, 30, 46, var(--border-opacity));
  }
  .md\\:focus-within\\:border-red-50:focus-within {
    --border-opacity: 1;
    border-color: #fdf2f2;
    border-color: rgba(253, 242, 242, var(--border-opacity));
  }
  .md\\:focus-within\\:border-red-100:focus-within {
    --border-opacity: 1;
    border-color: #fde8e8;
    border-color: rgba(253, 232, 232, var(--border-opacity));
  }
  .md\\:focus-within\\:border-red-200:focus-within {
    --border-opacity: 1;
    border-color: #fbd5d5;
    border-color: rgba(251, 213, 213, var(--border-opacity));
  }
  .md\\:focus-within\\:border-red-300:focus-within {
    --border-opacity: 1;
    border-color: #f8b4b4;
    border-color: rgba(248, 180, 180, var(--border-opacity));
  }
  .md\\:focus-within\\:border-red-400:focus-within {
    --border-opacity: 1;
    border-color: #f98080;
    border-color: rgba(249, 128, 128, var(--border-opacity));
  }
  .md\\:focus-within\\:border-red-500:focus-within {
    --border-opacity: 1;
    border-color: #f05252;
    border-color: rgba(240, 82, 82, var(--border-opacity));
  }
  .md\\:focus-within\\:border-red-600:focus-within {
    --border-opacity: 1;
    border-color: #e02424;
    border-color: rgba(224, 36, 36, var(--border-opacity));
  }
  .md\\:focus-within\\:border-red-700:focus-within {
    --border-opacity: 1;
    border-color: #c81e1e;
    border-color: rgba(200, 30, 30, var(--border-opacity));
  }
  .md\\:focus-within\\:border-red-800:focus-within {
    --border-opacity: 1;
    border-color: #9b1c1c;
    border-color: rgba(155, 28, 28, var(--border-opacity));
  }
  .md\\:focus-within\\:border-red-900:focus-within {
    --border-opacity: 1;
    border-color: #771d1d;
    border-color: rgba(119, 29, 29, var(--border-opacity));
  }
  .md\\:focus-within\\:border-orange-50:focus-within {
    --border-opacity: 1;
    border-color: #fff8f1;
    border-color: rgba(255, 248, 241, var(--border-opacity));
  }
  .md\\:focus-within\\:border-orange-100:focus-within {
    --border-opacity: 1;
    border-color: #feecdc;
    border-color: rgba(254, 236, 220, var(--border-opacity));
  }
  .md\\:focus-within\\:border-orange-200:focus-within {
    --border-opacity: 1;
    border-color: #fcd9bd;
    border-color: rgba(252, 217, 189, var(--border-opacity));
  }
  .md\\:focus-within\\:border-orange-300:focus-within {
    --border-opacity: 1;
    border-color: #fdba8c;
    border-color: rgba(253, 186, 140, var(--border-opacity));
  }
  .md\\:focus-within\\:border-orange-400:focus-within {
    --border-opacity: 1;
    border-color: #ff8a4c;
    border-color: rgba(255, 138, 76, var(--border-opacity));
  }
  .md\\:focus-within\\:border-orange-500:focus-within {
    --border-opacity: 1;
    border-color: #ff5a1f;
    border-color: rgba(255, 90, 31, var(--border-opacity));
  }
  .md\\:focus-within\\:border-orange-600:focus-within {
    --border-opacity: 1;
    border-color: #d03801;
    border-color: rgba(208, 56, 1, var(--border-opacity));
  }
  .md\\:focus-within\\:border-orange-700:focus-within {
    --border-opacity: 1;
    border-color: #b43403;
    border-color: rgba(180, 52, 3, var(--border-opacity));
  }
  .md\\:focus-within\\:border-orange-800:focus-within {
    --border-opacity: 1;
    border-color: #8a2c0d;
    border-color: rgba(138, 44, 13, var(--border-opacity));
  }
  .md\\:focus-within\\:border-orange-900:focus-within {
    --border-opacity: 1;
    border-color: #73230d;
    border-color: rgba(115, 35, 13, var(--border-opacity));
  }
  .md\\:focus-within\\:border-yellow-50:focus-within {
    --border-opacity: 1;
    border-color: #fdfdea;
    border-color: rgba(253, 253, 234, var(--border-opacity));
  }
  .md\\:focus-within\\:border-yellow-100:focus-within {
    --border-opacity: 1;
    border-color: #fdf6b2;
    border-color: rgba(253, 246, 178, var(--border-opacity));
  }
  .md\\:focus-within\\:border-yellow-200:focus-within {
    --border-opacity: 1;
    border-color: #fce96a;
    border-color: rgba(252, 233, 106, var(--border-opacity));
  }
  .md\\:focus-within\\:border-yellow-300:focus-within {
    --border-opacity: 1;
    border-color: #faca15;
    border-color: rgba(250, 202, 21, var(--border-opacity));
  }
  .md\\:focus-within\\:border-yellow-400:focus-within {
    --border-opacity: 1;
    border-color: #e3a008;
    border-color: rgba(227, 160, 8, var(--border-opacity));
  }
  .md\\:focus-within\\:border-yellow-500:focus-within {
    --border-opacity: 1;
    border-color: #c27803;
    border-color: rgba(194, 120, 3, var(--border-opacity));
  }
  .md\\:focus-within\\:border-yellow-600:focus-within {
    --border-opacity: 1;
    border-color: #9f580a;
    border-color: rgba(159, 88, 10, var(--border-opacity));
  }
  .md\\:focus-within\\:border-yellow-700:focus-within {
    --border-opacity: 1;
    border-color: #8e4b10;
    border-color: rgba(142, 75, 16, var(--border-opacity));
  }
  .md\\:focus-within\\:border-yellow-800:focus-within {
    --border-opacity: 1;
    border-color: #723b13;
    border-color: rgba(114, 59, 19, var(--border-opacity));
  }
  .md\\:focus-within\\:border-yellow-900:focus-within {
    --border-opacity: 1;
    border-color: #633112;
    border-color: rgba(99, 49, 18, var(--border-opacity));
  }
  .md\\:focus-within\\:border-green-50:focus-within {
    --border-opacity: 1;
    border-color: #f3faf7;
    border-color: rgba(243, 250, 247, var(--border-opacity));
  }
  .md\\:focus-within\\:border-green-100:focus-within {
    --border-opacity: 1;
    border-color: #def7ec;
    border-color: rgba(222, 247, 236, var(--border-opacity));
  }
  .md\\:focus-within\\:border-green-200:focus-within {
    --border-opacity: 1;
    border-color: #bcf0da;
    border-color: rgba(188, 240, 218, var(--border-opacity));
  }
  .md\\:focus-within\\:border-green-300:focus-within {
    --border-opacity: 1;
    border-color: #84e1bc;
    border-color: rgba(132, 225, 188, var(--border-opacity));
  }
  .md\\:focus-within\\:border-green-400:focus-within {
    --border-opacity: 1;
    border-color: #31c48d;
    border-color: rgba(49, 196, 141, var(--border-opacity));
  }
  .md\\:focus-within\\:border-green-500:focus-within {
    --border-opacity: 1;
    border-color: #0e9f6e;
    border-color: rgba(14, 159, 110, var(--border-opacity));
  }
  .md\\:focus-within\\:border-green-600:focus-within {
    --border-opacity: 1;
    border-color: #057a55;
    border-color: rgba(5, 122, 85, var(--border-opacity));
  }
  .md\\:focus-within\\:border-green-700:focus-within {
    --border-opacity: 1;
    border-color: #046c4e;
    border-color: rgba(4, 108, 78, var(--border-opacity));
  }
  .md\\:focus-within\\:border-green-800:focus-within {
    --border-opacity: 1;
    border-color: #03543f;
    border-color: rgba(3, 84, 63, var(--border-opacity));
  }
  .md\\:focus-within\\:border-green-900:focus-within {
    --border-opacity: 1;
    border-color: #014737;
    border-color: rgba(1, 71, 55, var(--border-opacity));
  }
  .md\\:focus-within\\:border-teal-50:focus-within {
    --border-opacity: 1;
    border-color: #edfafa;
    border-color: rgba(237, 250, 250, var(--border-opacity));
  }
  .md\\:focus-within\\:border-teal-100:focus-within {
    --border-opacity: 1;
    border-color: #d5f5f6;
    border-color: rgba(213, 245, 246, var(--border-opacity));
  }
  .md\\:focus-within\\:border-teal-200:focus-within {
    --border-opacity: 1;
    border-color: #afecef;
    border-color: rgba(175, 236, 239, var(--border-opacity));
  }
  .md\\:focus-within\\:border-teal-300:focus-within {
    --border-opacity: 1;
    border-color: #7edce2;
    border-color: rgba(126, 220, 226, var(--border-opacity));
  }
  .md\\:focus-within\\:border-teal-400:focus-within {
    --border-opacity: 1;
    border-color: #16bdca;
    border-color: rgba(22, 189, 202, var(--border-opacity));
  }
  .md\\:focus-within\\:border-teal-500:focus-within {
    --border-opacity: 1;
    border-color: #0694a2;
    border-color: rgba(6, 148, 162, var(--border-opacity));
  }
  .md\\:focus-within\\:border-teal-600:focus-within {
    --border-opacity: 1;
    border-color: #047481;
    border-color: rgba(4, 116, 129, var(--border-opacity));
  }
  .md\\:focus-within\\:border-teal-700:focus-within {
    --border-opacity: 1;
    border-color: #036672;
    border-color: rgba(3, 102, 114, var(--border-opacity));
  }
  .md\\:focus-within\\:border-teal-800:focus-within {
    --border-opacity: 1;
    border-color: #05505c;
    border-color: rgba(5, 80, 92, var(--border-opacity));
  }
  .md\\:focus-within\\:border-teal-900:focus-within {
    --border-opacity: 1;
    border-color: #014451;
    border-color: rgba(1, 68, 81, var(--border-opacity));
  }
  .md\\:focus-within\\:border-blue-50:focus-within {
    --border-opacity: 1;
    border-color: #ebf5ff;
    border-color: rgba(235, 245, 255, var(--border-opacity));
  }
  .md\\:focus-within\\:border-blue-100:focus-within {
    --border-opacity: 1;
    border-color: #e1effe;
    border-color: rgba(225, 239, 254, var(--border-opacity));
  }
  .md\\:focus-within\\:border-blue-200:focus-within {
    --border-opacity: 1;
    border-color: #c3ddfd;
    border-color: rgba(195, 221, 253, var(--border-opacity));
  }
  .md\\:focus-within\\:border-blue-300:focus-within {
    --border-opacity: 1;
    border-color: #a4cafe;
    border-color: rgba(164, 202, 254, var(--border-opacity));
  }
  .md\\:focus-within\\:border-blue-400:focus-within {
    --border-opacity: 1;
    border-color: #76a9fa;
    border-color: rgba(118, 169, 250, var(--border-opacity));
  }
  .md\\:focus-within\\:border-blue-500:focus-within {
    --border-opacity: 1;
    border-color: #3f83f8;
    border-color: rgba(63, 131, 248, var(--border-opacity));
  }
  .md\\:focus-within\\:border-blue-600:focus-within {
    --border-opacity: 1;
    border-color: #1c64f2;
    border-color: rgba(28, 100, 242, var(--border-opacity));
  }
  .md\\:focus-within\\:border-blue-700:focus-within {
    --border-opacity: 1;
    border-color: #1a56db;
    border-color: rgba(26, 86, 219, var(--border-opacity));
  }
  .md\\:focus-within\\:border-blue-800:focus-within {
    --border-opacity: 1;
    border-color: #1e429f;
    border-color: rgba(30, 66, 159, var(--border-opacity));
  }
  .md\\:focus-within\\:border-blue-900:focus-within {
    --border-opacity: 1;
    border-color: #233876;
    border-color: rgba(35, 56, 118, var(--border-opacity));
  }
  .md\\:focus-within\\:border-indigo-50:focus-within {
    --border-opacity: 1;
    border-color: #f0f5ff;
    border-color: rgba(240, 245, 255, var(--border-opacity));
  }
  .md\\:focus-within\\:border-indigo-100:focus-within {
    --border-opacity: 1;
    border-color: #e5edff;
    border-color: rgba(229, 237, 255, var(--border-opacity));
  }
  .md\\:focus-within\\:border-indigo-200:focus-within {
    --border-opacity: 1;
    border-color: #cddbfe;
    border-color: rgba(205, 219, 254, var(--border-opacity));
  }
  .md\\:focus-within\\:border-indigo-300:focus-within {
    --border-opacity: 1;
    border-color: #b4c6fc;
    border-color: rgba(180, 198, 252, var(--border-opacity));
  }
  .md\\:focus-within\\:border-indigo-400:focus-within {
    --border-opacity: 1;
    border-color: #8da2fb;
    border-color: rgba(141, 162, 251, var(--border-opacity));
  }
  .md\\:focus-within\\:border-indigo-500:focus-within {
    --border-opacity: 1;
    border-color: #6875f5;
    border-color: rgba(104, 117, 245, var(--border-opacity));
  }
  .md\\:focus-within\\:border-indigo-600:focus-within {
    --border-opacity: 1;
    border-color: #5850ec;
    border-color: rgba(88, 80, 236, var(--border-opacity));
  }
  .md\\:focus-within\\:border-indigo-700:focus-within {
    --border-opacity: 1;
    border-color: #5145cd;
    border-color: rgba(81, 69, 205, var(--border-opacity));
  }
  .md\\:focus-within\\:border-indigo-800:focus-within {
    --border-opacity: 1;
    border-color: #42389d;
    border-color: rgba(66, 56, 157, var(--border-opacity));
  }
  .md\\:focus-within\\:border-indigo-900:focus-within {
    --border-opacity: 1;
    border-color: #362f78;
    border-color: rgba(54, 47, 120, var(--border-opacity));
  }
  .md\\:focus-within\\:border-purple-50:focus-within {
    --border-opacity: 1;
    border-color: #f6f5ff;
    border-color: rgba(246, 245, 255, var(--border-opacity));
  }
  .md\\:focus-within\\:border-purple-100:focus-within {
    --border-opacity: 1;
    border-color: #edebfe;
    border-color: rgba(237, 235, 254, var(--border-opacity));
  }
  .md\\:focus-within\\:border-purple-200:focus-within {
    --border-opacity: 1;
    border-color: #dcd7fe;
    border-color: rgba(220, 215, 254, var(--border-opacity));
  }
  .md\\:focus-within\\:border-purple-300:focus-within {
    --border-opacity: 1;
    border-color: #cabffd;
    border-color: rgba(202, 191, 253, var(--border-opacity));
  }
  .md\\:focus-within\\:border-purple-400:focus-within {
    --border-opacity: 1;
    border-color: #ac94fa;
    border-color: rgba(172, 148, 250, var(--border-opacity));
  }
  .md\\:focus-within\\:border-purple-500:focus-within {
    --border-opacity: 1;
    border-color: #9061f9;
    border-color: rgba(144, 97, 249, var(--border-opacity));
  }
  .md\\:focus-within\\:border-purple-600:focus-within {
    --border-opacity: 1;
    border-color: #7e3af2;
    border-color: rgba(126, 58, 242, var(--border-opacity));
  }
  .md\\:focus-within\\:border-purple-700:focus-within {
    --border-opacity: 1;
    border-color: #6c2bd9;
    border-color: rgba(108, 43, 217, var(--border-opacity));
  }
  .md\\:focus-within\\:border-purple-800:focus-within {
    --border-opacity: 1;
    border-color: #5521b5;
    border-color: rgba(85, 33, 181, var(--border-opacity));
  }
  .md\\:focus-within\\:border-purple-900:focus-within {
    --border-opacity: 1;
    border-color: #4a1d96;
    border-color: rgba(74, 29, 150, var(--border-opacity));
  }
  .md\\:focus-within\\:border-pink-50:focus-within {
    --border-opacity: 1;
    border-color: #fdf2f8;
    border-color: rgba(253, 242, 248, var(--border-opacity));
  }
  .md\\:focus-within\\:border-pink-100:focus-within {
    --border-opacity: 1;
    border-color: #fce8f3;
    border-color: rgba(252, 232, 243, var(--border-opacity));
  }
  .md\\:focus-within\\:border-pink-200:focus-within {
    --border-opacity: 1;
    border-color: #fad1e8;
    border-color: rgba(250, 209, 232, var(--border-opacity));
  }
  .md\\:focus-within\\:border-pink-300:focus-within {
    --border-opacity: 1;
    border-color: #f8b4d9;
    border-color: rgba(248, 180, 217, var(--border-opacity));
  }
  .md\\:focus-within\\:border-pink-400:focus-within {
    --border-opacity: 1;
    border-color: #f17eb8;
    border-color: rgba(241, 126, 184, var(--border-opacity));
  }
  .md\\:focus-within\\:border-pink-500:focus-within {
    --border-opacity: 1;
    border-color: #e74694;
    border-color: rgba(231, 70, 148, var(--border-opacity));
  }
  .md\\:focus-within\\:border-pink-600:focus-within {
    --border-opacity: 1;
    border-color: #d61f69;
    border-color: rgba(214, 31, 105, var(--border-opacity));
  }
  .md\\:focus-within\\:border-pink-700:focus-within {
    --border-opacity: 1;
    border-color: #bf125d;
    border-color: rgba(191, 18, 93, var(--border-opacity));
  }
  .md\\:focus-within\\:border-pink-800:focus-within {
    --border-opacity: 1;
    border-color: #99154b;
    border-color: rgba(153, 21, 75, var(--border-opacity));
  }
  .md\\:focus-within\\:border-pink-900:focus-within {
    --border-opacity: 1;
    border-color: #751a3d;
    border-color: rgba(117, 26, 61, var(--border-opacity));
  }
  .md\\:focus-within\\:border-cool-gray-50:focus-within {
    --border-opacity: 1;
    border-color: #f8fafc;
    border-color: rgba(248, 250, 252, var(--border-opacity));
  }
  .md\\:focus-within\\:border-cool-gray-100:focus-within {
    --border-opacity: 1;
    border-color: #f1f5f9;
    border-color: rgba(241, 245, 249, var(--border-opacity));
  }
  .md\\:focus-within\\:border-cool-gray-200:focus-within {
    --border-opacity: 1;
    border-color: #e2e8f0;
    border-color: rgba(226, 232, 240, var(--border-opacity));
  }
  .md\\:focus-within\\:border-cool-gray-300:focus-within {
    --border-opacity: 1;
    border-color: #cfd8e3;
    border-color: rgba(207, 216, 227, var(--border-opacity));
  }
  .md\\:focus-within\\:border-cool-gray-400:focus-within {
    --border-opacity: 1;
    border-color: #97a6ba;
    border-color: rgba(151, 166, 186, var(--border-opacity));
  }
  .md\\:focus-within\\:border-cool-gray-500:focus-within {
    --border-opacity: 1;
    border-color: #64748b;
    border-color: rgba(100, 116, 139, var(--border-opacity));
  }
  .md\\:focus-within\\:border-cool-gray-600:focus-within {
    --border-opacity: 1;
    border-color: #475569;
    border-color: rgba(71, 85, 105, var(--border-opacity));
  }
  .md\\:focus-within\\:border-cool-gray-700:focus-within {
    --border-opacity: 1;
    border-color: #364152;
    border-color: rgba(54, 65, 82, var(--border-opacity));
  }
  .md\\:focus-within\\:border-cool-gray-800:focus-within {
    --border-opacity: 1;
    border-color: #27303f;
    border-color: rgba(39, 48, 63, var(--border-opacity));
  }
  .md\\:focus-within\\:border-cool-gray-900:focus-within {
    --border-opacity: 1;
    border-color: #1a202e;
    border-color: rgba(26, 32, 46, var(--border-opacity));
  }
  .md\\:focus\\:border-current:focus {
    border-color: currentColor;
  }
  .md\\:focus\\:border-transparent:focus {
    border-color: transparent;
  }
  .md\\:focus\\:border-white:focus {
    --border-opacity: 1;
    border-color: #ffffff;
    border-color: rgba(255, 255, 255, var(--border-opacity));
  }
  .md\\:focus\\:border-black:focus {
    --border-opacity: 1;
    border-color: #000000;
    border-color: rgba(0, 0, 0, var(--border-opacity));
  }
  .md\\:focus\\:border-gray-50:focus {
    --border-opacity: 1;
    border-color: #f9fafb;
    border-color: rgba(249, 250, 251, var(--border-opacity));
  }
  .md\\:focus\\:border-gray-100:focus {
    --border-opacity: 1;
    border-color: #f4f5f7;
    border-color: rgba(244, 245, 247, var(--border-opacity));
  }
  .md\\:focus\\:border-gray-200:focus {
    --border-opacity: 1;
    border-color: #e5e7eb;
    border-color: rgba(229, 231, 235, var(--border-opacity));
  }
  .md\\:focus\\:border-gray-300:focus {
    --border-opacity: 1;
    border-color: #d2d6dc;
    border-color: rgba(210, 214, 220, var(--border-opacity));
  }
  .md\\:focus\\:border-gray-400:focus {
    --border-opacity: 1;
    border-color: #9fa6b2;
    border-color: rgba(159, 166, 178, var(--border-opacity));
  }
  .md\\:focus\\:border-gray-500:focus {
    --border-opacity: 1;
    border-color: #6b7280;
    border-color: rgba(107, 114, 128, var(--border-opacity));
  }
  .md\\:focus\\:border-gray-600:focus {
    --border-opacity: 1;
    border-color: #4b5563;
    border-color: rgba(75, 85, 99, var(--border-opacity));
  }
  .md\\:focus\\:border-gray-700:focus {
    --border-opacity: 1;
    border-color: #374151;
    border-color: rgba(55, 65, 81, var(--border-opacity));
  }
  .md\\:focus\\:border-gray-800:focus {
    --border-opacity: 1;
    border-color: #252f3f;
    border-color: rgba(37, 47, 63, var(--border-opacity));
  }
  .md\\:focus\\:border-gray-900:focus {
    --border-opacity: 1;
    border-color: #161e2e;
    border-color: rgba(22, 30, 46, var(--border-opacity));
  }
  .md\\:focus\\:border-red-50:focus {
    --border-opacity: 1;
    border-color: #fdf2f2;
    border-color: rgba(253, 242, 242, var(--border-opacity));
  }
  .md\\:focus\\:border-red-100:focus {
    --border-opacity: 1;
    border-color: #fde8e8;
    border-color: rgba(253, 232, 232, var(--border-opacity));
  }
  .md\\:focus\\:border-red-200:focus {
    --border-opacity: 1;
    border-color: #fbd5d5;
    border-color: rgba(251, 213, 213, var(--border-opacity));
  }
  .md\\:focus\\:border-red-300:focus {
    --border-opacity: 1;
    border-color: #f8b4b4;
    border-color: rgba(248, 180, 180, var(--border-opacity));
  }
  .md\\:focus\\:border-red-400:focus {
    --border-opacity: 1;
    border-color: #f98080;
    border-color: rgba(249, 128, 128, var(--border-opacity));
  }
  .md\\:focus\\:border-red-500:focus {
    --border-opacity: 1;
    border-color: #f05252;
    border-color: rgba(240, 82, 82, var(--border-opacity));
  }
  .md\\:focus\\:border-red-600:focus {
    --border-opacity: 1;
    border-color: #e02424;
    border-color: rgba(224, 36, 36, var(--border-opacity));
  }
  .md\\:focus\\:border-red-700:focus {
    --border-opacity: 1;
    border-color: #c81e1e;
    border-color: rgba(200, 30, 30, var(--border-opacity));
  }
  .md\\:focus\\:border-red-800:focus {
    --border-opacity: 1;
    border-color: #9b1c1c;
    border-color: rgba(155, 28, 28, var(--border-opacity));
  }
  .md\\:focus\\:border-red-900:focus {
    --border-opacity: 1;
    border-color: #771d1d;
    border-color: rgba(119, 29, 29, var(--border-opacity));
  }
  .md\\:focus\\:border-orange-50:focus {
    --border-opacity: 1;
    border-color: #fff8f1;
    border-color: rgba(255, 248, 241, var(--border-opacity));
  }
  .md\\:focus\\:border-orange-100:focus {
    --border-opacity: 1;
    border-color: #feecdc;
    border-color: rgba(254, 236, 220, var(--border-opacity));
  }
  .md\\:focus\\:border-orange-200:focus {
    --border-opacity: 1;
    border-color: #fcd9bd;
    border-color: rgba(252, 217, 189, var(--border-opacity));
  }
  .md\\:focus\\:border-orange-300:focus {
    --border-opacity: 1;
    border-color: #fdba8c;
    border-color: rgba(253, 186, 140, var(--border-opacity));
  }
  .md\\:focus\\:border-orange-400:focus {
    --border-opacity: 1;
    border-color: #ff8a4c;
    border-color: rgba(255, 138, 76, var(--border-opacity));
  }
  .md\\:focus\\:border-orange-500:focus {
    --border-opacity: 1;
    border-color: #ff5a1f;
    border-color: rgba(255, 90, 31, var(--border-opacity));
  }
  .md\\:focus\\:border-orange-600:focus {
    --border-opacity: 1;
    border-color: #d03801;
    border-color: rgba(208, 56, 1, var(--border-opacity));
  }
  .md\\:focus\\:border-orange-700:focus {
    --border-opacity: 1;
    border-color: #b43403;
    border-color: rgba(180, 52, 3, var(--border-opacity));
  }
  .md\\:focus\\:border-orange-800:focus {
    --border-opacity: 1;
    border-color: #8a2c0d;
    border-color: rgba(138, 44, 13, var(--border-opacity));
  }
  .md\\:focus\\:border-orange-900:focus {
    --border-opacity: 1;
    border-color: #73230d;
    border-color: rgba(115, 35, 13, var(--border-opacity));
  }
  .md\\:focus\\:border-yellow-50:focus {
    --border-opacity: 1;
    border-color: #fdfdea;
    border-color: rgba(253, 253, 234, var(--border-opacity));
  }
  .md\\:focus\\:border-yellow-100:focus {
    --border-opacity: 1;
    border-color: #fdf6b2;
    border-color: rgba(253, 246, 178, var(--border-opacity));
  }
  .md\\:focus\\:border-yellow-200:focus {
    --border-opacity: 1;
    border-color: #fce96a;
    border-color: rgba(252, 233, 106, var(--border-opacity));
  }
  .md\\:focus\\:border-yellow-300:focus {
    --border-opacity: 1;
    border-color: #faca15;
    border-color: rgba(250, 202, 21, var(--border-opacity));
  }
  .md\\:focus\\:border-yellow-400:focus {
    --border-opacity: 1;
    border-color: #e3a008;
    border-color: rgba(227, 160, 8, var(--border-opacity));
  }
  .md\\:focus\\:border-yellow-500:focus {
    --border-opacity: 1;
    border-color: #c27803;
    border-color: rgba(194, 120, 3, var(--border-opacity));
  }
  .md\\:focus\\:border-yellow-600:focus {
    --border-opacity: 1;
    border-color: #9f580a;
    border-color: rgba(159, 88, 10, var(--border-opacity));
  }
  .md\\:focus\\:border-yellow-700:focus {
    --border-opacity: 1;
    border-color: #8e4b10;
    border-color: rgba(142, 75, 16, var(--border-opacity));
  }
  .md\\:focus\\:border-yellow-800:focus {
    --border-opacity: 1;
    border-color: #723b13;
    border-color: rgba(114, 59, 19, var(--border-opacity));
  }
  .md\\:focus\\:border-yellow-900:focus {
    --border-opacity: 1;
    border-color: #633112;
    border-color: rgba(99, 49, 18, var(--border-opacity));
  }
  .md\\:focus\\:border-green-50:focus {
    --border-opacity: 1;
    border-color: #f3faf7;
    border-color: rgba(243, 250, 247, var(--border-opacity));
  }
  .md\\:focus\\:border-green-100:focus {
    --border-opacity: 1;
    border-color: #def7ec;
    border-color: rgba(222, 247, 236, var(--border-opacity));
  }
  .md\\:focus\\:border-green-200:focus {
    --border-opacity: 1;
    border-color: #bcf0da;
    border-color: rgba(188, 240, 218, var(--border-opacity));
  }
  .md\\:focus\\:border-green-300:focus {
    --border-opacity: 1;
    border-color: #84e1bc;
    border-color: rgba(132, 225, 188, var(--border-opacity));
  }
  .md\\:focus\\:border-green-400:focus {
    --border-opacity: 1;
    border-color: #31c48d;
    border-color: rgba(49, 196, 141, var(--border-opacity));
  }
  .md\\:focus\\:border-green-500:focus {
    --border-opacity: 1;
    border-color: #0e9f6e;
    border-color: rgba(14, 159, 110, var(--border-opacity));
  }
  .md\\:focus\\:border-green-600:focus {
    --border-opacity: 1;
    border-color: #057a55;
    border-color: rgba(5, 122, 85, var(--border-opacity));
  }
  .md\\:focus\\:border-green-700:focus {
    --border-opacity: 1;
    border-color: #046c4e;
    border-color: rgba(4, 108, 78, var(--border-opacity));
  }
  .md\\:focus\\:border-green-800:focus {
    --border-opacity: 1;
    border-color: #03543f;
    border-color: rgba(3, 84, 63, var(--border-opacity));
  }
  .md\\:focus\\:border-green-900:focus {
    --border-opacity: 1;
    border-color: #014737;
    border-color: rgba(1, 71, 55, var(--border-opacity));
  }
  .md\\:focus\\:border-teal-50:focus {
    --border-opacity: 1;
    border-color: #edfafa;
    border-color: rgba(237, 250, 250, var(--border-opacity));
  }
  .md\\:focus\\:border-teal-100:focus {
    --border-opacity: 1;
    border-color: #d5f5f6;
    border-color: rgba(213, 245, 246, var(--border-opacity));
  }
  .md\\:focus\\:border-teal-200:focus {
    --border-opacity: 1;
    border-color: #afecef;
    border-color: rgba(175, 236, 239, var(--border-opacity));
  }
  .md\\:focus\\:border-teal-300:focus {
    --border-opacity: 1;
    border-color: #7edce2;
    border-color: rgba(126, 220, 226, var(--border-opacity));
  }
  .md\\:focus\\:border-teal-400:focus {
    --border-opacity: 1;
    border-color: #16bdca;
    border-color: rgba(22, 189, 202, var(--border-opacity));
  }
  .md\\:focus\\:border-teal-500:focus {
    --border-opacity: 1;
    border-color: #0694a2;
    border-color: rgba(6, 148, 162, var(--border-opacity));
  }
  .md\\:focus\\:border-teal-600:focus {
    --border-opacity: 1;
    border-color: #047481;
    border-color: rgba(4, 116, 129, var(--border-opacity));
  }
  .md\\:focus\\:border-teal-700:focus {
    --border-opacity: 1;
    border-color: #036672;
    border-color: rgba(3, 102, 114, var(--border-opacity));
  }
  .md\\:focus\\:border-teal-800:focus {
    --border-opacity: 1;
    border-color: #05505c;
    border-color: rgba(5, 80, 92, var(--border-opacity));
  }
  .md\\:focus\\:border-teal-900:focus {
    --border-opacity: 1;
    border-color: #014451;
    border-color: rgba(1, 68, 81, var(--border-opacity));
  }
  .md\\:focus\\:border-blue-50:focus {
    --border-opacity: 1;
    border-color: #ebf5ff;
    border-color: rgba(235, 245, 255, var(--border-opacity));
  }
  .md\\:focus\\:border-blue-100:focus {
    --border-opacity: 1;
    border-color: #e1effe;
    border-color: rgba(225, 239, 254, var(--border-opacity));
  }
  .md\\:focus\\:border-blue-200:focus {
    --border-opacity: 1;
    border-color: #c3ddfd;
    border-color: rgba(195, 221, 253, var(--border-opacity));
  }
  .md\\:focus\\:border-blue-300:focus {
    --border-opacity: 1;
    border-color: #a4cafe;
    border-color: rgba(164, 202, 254, var(--border-opacity));
  }
  .md\\:focus\\:border-blue-400:focus {
    --border-opacity: 1;
    border-color: #76a9fa;
    border-color: rgba(118, 169, 250, var(--border-opacity));
  }
  .md\\:focus\\:border-blue-500:focus {
    --border-opacity: 1;
    border-color: #3f83f8;
    border-color: rgba(63, 131, 248, var(--border-opacity));
  }
  .md\\:focus\\:border-blue-600:focus {
    --border-opacity: 1;
    border-color: #1c64f2;
    border-color: rgba(28, 100, 242, var(--border-opacity));
  }
  .md\\:focus\\:border-blue-700:focus {
    --border-opacity: 1;
    border-color: #1a56db;
    border-color: rgba(26, 86, 219, var(--border-opacity));
  }
  .md\\:focus\\:border-blue-800:focus {
    --border-opacity: 1;
    border-color: #1e429f;
    border-color: rgba(30, 66, 159, var(--border-opacity));
  }
  .md\\:focus\\:border-blue-900:focus {
    --border-opacity: 1;
    border-color: #233876;
    border-color: rgba(35, 56, 118, var(--border-opacity));
  }
  .md\\:focus\\:border-indigo-50:focus {
    --border-opacity: 1;
    border-color: #f0f5ff;
    border-color: rgba(240, 245, 255, var(--border-opacity));
  }
  .md\\:focus\\:border-indigo-100:focus {
    --border-opacity: 1;
    border-color: #e5edff;
    border-color: rgba(229, 237, 255, var(--border-opacity));
  }
  .md\\:focus\\:border-indigo-200:focus {
    --border-opacity: 1;
    border-color: #cddbfe;
    border-color: rgba(205, 219, 254, var(--border-opacity));
  }
  .md\\:focus\\:border-indigo-300:focus {
    --border-opacity: 1;
    border-color: #b4c6fc;
    border-color: rgba(180, 198, 252, var(--border-opacity));
  }
  .md\\:focus\\:border-indigo-400:focus {
    --border-opacity: 1;
    border-color: #8da2fb;
    border-color: rgba(141, 162, 251, var(--border-opacity));
  }
  .md\\:focus\\:border-indigo-500:focus {
    --border-opacity: 1;
    border-color: #6875f5;
    border-color: rgba(104, 117, 245, var(--border-opacity));
  }
  .md\\:focus\\:border-indigo-600:focus {
    --border-opacity: 1;
    border-color: #5850ec;
    border-color: rgba(88, 80, 236, var(--border-opacity));
  }
  .md\\:focus\\:border-indigo-700:focus {
    --border-opacity: 1;
    border-color: #5145cd;
    border-color: rgba(81, 69, 205, var(--border-opacity));
  }
  .md\\:focus\\:border-indigo-800:focus {
    --border-opacity: 1;
    border-color: #42389d;
    border-color: rgba(66, 56, 157, var(--border-opacity));
  }
  .md\\:focus\\:border-indigo-900:focus {
    --border-opacity: 1;
    border-color: #362f78;
    border-color: rgba(54, 47, 120, var(--border-opacity));
  }
  .md\\:focus\\:border-purple-50:focus {
    --border-opacity: 1;
    border-color: #f6f5ff;
    border-color: rgba(246, 245, 255, var(--border-opacity));
  }
  .md\\:focus\\:border-purple-100:focus {
    --border-opacity: 1;
    border-color: #edebfe;
    border-color: rgba(237, 235, 254, var(--border-opacity));
  }
  .md\\:focus\\:border-purple-200:focus {
    --border-opacity: 1;
    border-color: #dcd7fe;
    border-color: rgba(220, 215, 254, var(--border-opacity));
  }
  .md\\:focus\\:border-purple-300:focus {
    --border-opacity: 1;
    border-color: #cabffd;
    border-color: rgba(202, 191, 253, var(--border-opacity));
  }
  .md\\:focus\\:border-purple-400:focus {
    --border-opacity: 1;
    border-color: #ac94fa;
    border-color: rgba(172, 148, 250, var(--border-opacity));
  }
  .md\\:focus\\:border-purple-500:focus {
    --border-opacity: 1;
    border-color: #9061f9;
    border-color: rgba(144, 97, 249, var(--border-opacity));
  }
  .md\\:focus\\:border-purple-600:focus {
    --border-opacity: 1;
    border-color: #7e3af2;
    border-color: rgba(126, 58, 242, var(--border-opacity));
  }
  .md\\:focus\\:border-purple-700:focus {
    --border-opacity: 1;
    border-color: #6c2bd9;
    border-color: rgba(108, 43, 217, var(--border-opacity));
  }
  .md\\:focus\\:border-purple-800:focus {
    --border-opacity: 1;
    border-color: #5521b5;
    border-color: rgba(85, 33, 181, var(--border-opacity));
  }
  .md\\:focus\\:border-purple-900:focus {
    --border-opacity: 1;
    border-color: #4a1d96;
    border-color: rgba(74, 29, 150, var(--border-opacity));
  }
  .md\\:focus\\:border-pink-50:focus {
    --border-opacity: 1;
    border-color: #fdf2f8;
    border-color: rgba(253, 242, 248, var(--border-opacity));
  }
  .md\\:focus\\:border-pink-100:focus {
    --border-opacity: 1;
    border-color: #fce8f3;
    border-color: rgba(252, 232, 243, var(--border-opacity));
  }
  .md\\:focus\\:border-pink-200:focus {
    --border-opacity: 1;
    border-color: #fad1e8;
    border-color: rgba(250, 209, 232, var(--border-opacity));
  }
  .md\\:focus\\:border-pink-300:focus {
    --border-opacity: 1;
    border-color: #f8b4d9;
    border-color: rgba(248, 180, 217, var(--border-opacity));
  }
  .md\\:focus\\:border-pink-400:focus {
    --border-opacity: 1;
    border-color: #f17eb8;
    border-color: rgba(241, 126, 184, var(--border-opacity));
  }
  .md\\:focus\\:border-pink-500:focus {
    --border-opacity: 1;
    border-color: #e74694;
    border-color: rgba(231, 70, 148, var(--border-opacity));
  }
  .md\\:focus\\:border-pink-600:focus {
    --border-opacity: 1;
    border-color: #d61f69;
    border-color: rgba(214, 31, 105, var(--border-opacity));
  }
  .md\\:focus\\:border-pink-700:focus {
    --border-opacity: 1;
    border-color: #bf125d;
    border-color: rgba(191, 18, 93, var(--border-opacity));
  }
  .md\\:focus\\:border-pink-800:focus {
    --border-opacity: 1;
    border-color: #99154b;
    border-color: rgba(153, 21, 75, var(--border-opacity));
  }
  .md\\:focus\\:border-pink-900:focus {
    --border-opacity: 1;
    border-color: #751a3d;
    border-color: rgba(117, 26, 61, var(--border-opacity));
  }
  .md\\:focus\\:border-cool-gray-50:focus {
    --border-opacity: 1;
    border-color: #f8fafc;
    border-color: rgba(248, 250, 252, var(--border-opacity));
  }
  .md\\:focus\\:border-cool-gray-100:focus {
    --border-opacity: 1;
    border-color: #f1f5f9;
    border-color: rgba(241, 245, 249, var(--border-opacity));
  }
  .md\\:focus\\:border-cool-gray-200:focus {
    --border-opacity: 1;
    border-color: #e2e8f0;
    border-color: rgba(226, 232, 240, var(--border-opacity));
  }
  .md\\:focus\\:border-cool-gray-300:focus {
    --border-opacity: 1;
    border-color: #cfd8e3;
    border-color: rgba(207, 216, 227, var(--border-opacity));
  }
  .md\\:focus\\:border-cool-gray-400:focus {
    --border-opacity: 1;
    border-color: #97a6ba;
    border-color: rgba(151, 166, 186, var(--border-opacity));
  }
  .md\\:focus\\:border-cool-gray-500:focus {
    --border-opacity: 1;
    border-color: #64748b;
    border-color: rgba(100, 116, 139, var(--border-opacity));
  }
  .md\\:focus\\:border-cool-gray-600:focus {
    --border-opacity: 1;
    border-color: #475569;
    border-color: rgba(71, 85, 105, var(--border-opacity));
  }
  .md\\:focus\\:border-cool-gray-700:focus {
    --border-opacity: 1;
    border-color: #364152;
    border-color: rgba(54, 65, 82, var(--border-opacity));
  }
  .md\\:focus\\:border-cool-gray-800:focus {
    --border-opacity: 1;
    border-color: #27303f;
    border-color: rgba(39, 48, 63, var(--border-opacity));
  }
  .md\\:focus\\:border-cool-gray-900:focus {
    --border-opacity: 1;
    border-color: #1a202e;
    border-color: rgba(26, 32, 46, var(--border-opacity));
  }
  .md\\:border-opacity-0 {
    --border-opacity: 0;
  }
  .md\\:border-opacity-25 {
    --border-opacity: 0.25;
  }
  .md\\:border-opacity-50 {
    --border-opacity: 0.5;
  }
  .md\\:border-opacity-75 {
    --border-opacity: 0.75;
  }
  .md\\:border-opacity-100 {
    --border-opacity: 1;
  }
  .md\\:hover\\:border-opacity-0:hover {
    --border-opacity: 0;
  }
  .md\\:hover\\:border-opacity-25:hover {
    --border-opacity: 0.25;
  }
  .md\\:hover\\:border-opacity-50:hover {
    --border-opacity: 0.5;
  }
  .md\\:hover\\:border-opacity-75:hover {
    --border-opacity: 0.75;
  }
  .md\\:hover\\:border-opacity-100:hover {
    --border-opacity: 1;
  }
  .md\\:focus\\:border-opacity-0:focus {
    --border-opacity: 0;
  }
  .md\\:focus\\:border-opacity-25:focus {
    --border-opacity: 0.25;
  }
  .md\\:focus\\:border-opacity-50:focus {
    --border-opacity: 0.5;
  }
  .md\\:focus\\:border-opacity-75:focus {
    --border-opacity: 0.75;
  }
  .md\\:focus\\:border-opacity-100:focus {
    --border-opacity: 1;
  }
  .md\\:rounded-none {
    border-radius: 0;
  }
  .md\\:rounded-sm {
    border-radius: 0.125rem;
  }
  .md\\:rounded {
    border-radius: 0.25rem;
  }
  .md\\:rounded-md {
    border-radius: 0.375rem;
  }
  .md\\:rounded-lg {
    border-radius: 0.5rem;
  }
  .md\\:rounded-xl {
    border-radius: 0.75rem;
  }
  .md\\:rounded-2xl {
    border-radius: 1rem;
  }
  .md\\:rounded-3xl {
    border-radius: 1.5rem;
  }
  .md\\:rounded-full {
    border-radius: 9999px;
  }
  .md\\:rounded-t-none {
    border-top-left-radius: 0;
    border-top-right-radius: 0;
  }
  .md\\:rounded-r-none {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
  .md\\:rounded-b-none {
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0;
  }
  .md\\:rounded-l-none {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
  .md\\:rounded-t-sm {
    border-top-left-radius: 0.125rem;
    border-top-right-radius: 0.125rem;
  }
  .md\\:rounded-r-sm {
    border-top-right-radius: 0.125rem;
    border-bottom-right-radius: 0.125rem;
  }
  .md\\:rounded-b-sm {
    border-bottom-right-radius: 0.125rem;
    border-bottom-left-radius: 0.125rem;
  }
  .md\\:rounded-l-sm {
    border-top-left-radius: 0.125rem;
    border-bottom-left-radius: 0.125rem;
  }
  .md\\:rounded-t {
    border-top-left-radius: 0.25rem;
    border-top-right-radius: 0.25rem;
  }
  .md\\:rounded-r {
    border-top-right-radius: 0.25rem;
    border-bottom-right-radius: 0.25rem;
  }
  .md\\:rounded-b {
    border-bottom-right-radius: 0.25rem;
    border-bottom-left-radius: 0.25rem;
  }
  .md\\:rounded-l {
    border-top-left-radius: 0.25rem;
    border-bottom-left-radius: 0.25rem;
  }
  .md\\:rounded-t-md {
    border-top-left-radius: 0.375rem;
    border-top-right-radius: 0.375rem;
  }
  .md\\:rounded-r-md {
    border-top-right-radius: 0.375rem;
    border-bottom-right-radius: 0.375rem;
  }
  .md\\:rounded-b-md {
    border-bottom-right-radius: 0.375rem;
    border-bottom-left-radius: 0.375rem;
  }
  .md\\:rounded-l-md {
    border-top-left-radius: 0.375rem;
    border-bottom-left-radius: 0.375rem;
  }
  .md\\:rounded-t-lg {
    border-top-left-radius: 0.5rem;
    border-top-right-radius: 0.5rem;
  }
  .md\\:rounded-r-lg {
    border-top-right-radius: 0.5rem;
    border-bottom-right-radius: 0.5rem;
  }
  .md\\:rounded-b-lg {
    border-bottom-right-radius: 0.5rem;
    border-bottom-left-radius: 0.5rem;
  }
  .md\\:rounded-l-lg {
    border-top-left-radius: 0.5rem;
    border-bottom-left-radius: 0.5rem;
  }
  .md\\:rounded-t-xl {
    border-top-left-radius: 0.75rem;
    border-top-right-radius: 0.75rem;
  }
  .md\\:rounded-r-xl {
    border-top-right-radius: 0.75rem;
    border-bottom-right-radius: 0.75rem;
  }
  .md\\:rounded-b-xl {
    border-bottom-right-radius: 0.75rem;
    border-bottom-left-radius: 0.75rem;
  }
  .md\\:rounded-l-xl {
    border-top-left-radius: 0.75rem;
    border-bottom-left-radius: 0.75rem;
  }
  .md\\:rounded-t-2xl {
    border-top-left-radius: 1rem;
    border-top-right-radius: 1rem;
  }
  .md\\:rounded-r-2xl {
    border-top-right-radius: 1rem;
    border-bottom-right-radius: 1rem;
  }
  .md\\:rounded-b-2xl {
    border-bottom-right-radius: 1rem;
    border-bottom-left-radius: 1rem;
  }
  .md\\:rounded-l-2xl {
    border-top-left-radius: 1rem;
    border-bottom-left-radius: 1rem;
  }
  .md\\:rounded-t-3xl {
    border-top-left-radius: 1.5rem;
    border-top-right-radius: 1.5rem;
  }
  .md\\:rounded-r-3xl {
    border-top-right-radius: 1.5rem;
    border-bottom-right-radius: 1.5rem;
  }
  .md\\:rounded-b-3xl {
    border-bottom-right-radius: 1.5rem;
    border-bottom-left-radius: 1.5rem;
  }
  .md\\:rounded-l-3xl {
    border-top-left-radius: 1.5rem;
    border-bottom-left-radius: 1.5rem;
  }
  .md\\:rounded-t-full {
    border-top-left-radius: 9999px;
    border-top-right-radius: 9999px;
  }
  .md\\:rounded-r-full {
    border-top-right-radius: 9999px;
    border-bottom-right-radius: 9999px;
  }
  .md\\:rounded-b-full {
    border-bottom-right-radius: 9999px;
    border-bottom-left-radius: 9999px;
  }
  .md\\:rounded-l-full {
    border-top-left-radius: 9999px;
    border-bottom-left-radius: 9999px;
  }
  .md\\:rounded-tl-none {
    border-top-left-radius: 0;
  }
  .md\\:rounded-tr-none {
    border-top-right-radius: 0;
  }
  .md\\:rounded-br-none {
    border-bottom-right-radius: 0;
  }
  .md\\:rounded-bl-none {
    border-bottom-left-radius: 0;
  }
  .md\\:rounded-tl-sm {
    border-top-left-radius: 0.125rem;
  }
  .md\\:rounded-tr-sm {
    border-top-right-radius: 0.125rem;
  }
  .md\\:rounded-br-sm {
    border-bottom-right-radius: 0.125rem;
  }
  .md\\:rounded-bl-sm {
    border-bottom-left-radius: 0.125rem;
  }
  .md\\:rounded-tl {
    border-top-left-radius: 0.25rem;
  }
  .md\\:rounded-tr {
    border-top-right-radius: 0.25rem;
  }
  .md\\:rounded-br {
    border-bottom-right-radius: 0.25rem;
  }
  .md\\:rounded-bl {
    border-bottom-left-radius: 0.25rem;
  }
  .md\\:rounded-tl-md {
    border-top-left-radius: 0.375rem;
  }
  .md\\:rounded-tr-md {
    border-top-right-radius: 0.375rem;
  }
  .md\\:rounded-br-md {
    border-bottom-right-radius: 0.375rem;
  }
  .md\\:rounded-bl-md {
    border-bottom-left-radius: 0.375rem;
  }
  .md\\:rounded-tl-lg {
    border-top-left-radius: 0.5rem;
  }
  .md\\:rounded-tr-lg {
    border-top-right-radius: 0.5rem;
  }
  .md\\:rounded-br-lg {
    border-bottom-right-radius: 0.5rem;
  }
  .md\\:rounded-bl-lg {
    border-bottom-left-radius: 0.5rem;
  }
  .md\\:rounded-tl-xl {
    border-top-left-radius: 0.75rem;
  }
  .md\\:rounded-tr-xl {
    border-top-right-radius: 0.75rem;
  }
  .md\\:rounded-br-xl {
    border-bottom-right-radius: 0.75rem;
  }
  .md\\:rounded-bl-xl {
    border-bottom-left-radius: 0.75rem;
  }
  .md\\:rounded-tl-2xl {
    border-top-left-radius: 1rem;
  }
  .md\\:rounded-tr-2xl {
    border-top-right-radius: 1rem;
  }
  .md\\:rounded-br-2xl {
    border-bottom-right-radius: 1rem;
  }
  .md\\:rounded-bl-2xl {
    border-bottom-left-radius: 1rem;
  }
  .md\\:rounded-tl-3xl {
    border-top-left-radius: 1.5rem;
  }
  .md\\:rounded-tr-3xl {
    border-top-right-radius: 1.5rem;
  }
  .md\\:rounded-br-3xl {
    border-bottom-right-radius: 1.5rem;
  }
  .md\\:rounded-bl-3xl {
    border-bottom-left-radius: 1.5rem;
  }
  .md\\:rounded-tl-full {
    border-top-left-radius: 9999px;
  }
  .md\\:rounded-tr-full {
    border-top-right-radius: 9999px;
  }
  .md\\:rounded-br-full {
    border-bottom-right-radius: 9999px;
  }
  .md\\:rounded-bl-full {
    border-bottom-left-radius: 9999px;
  }
  .md\\:border-solid {
    border-style: solid;
  }
  .md\\:border-dashed {
    border-style: dashed;
  }
  .md\\:border-dotted {
    border-style: dotted;
  }
  .md\\:border-double {
    border-style: double;
  }
  .md\\:border-none {
    border-style: none;
  }
  .md\\:border-0 {
    border-width: 0;
  }
  .md\\:border-2 {
    border-width: 2px;
  }
  .md\\:border-4 {
    border-width: 4px;
  }
  .md\\:border-8 {
    border-width: 8px;
  }
  .md\\:border {
    border-width: 1px;
  }
  .md\\:border-t-0 {
    border-top-width: 0;
  }
  .md\\:border-r-0 {
    border-right-width: 0;
  }
  .md\\:border-b-0 {
    border-bottom-width: 0;
  }
  .md\\:border-l-0 {
    border-left-width: 0;
  }
  .md\\:border-t-2 {
    border-top-width: 2px;
  }
  .md\\:border-r-2 {
    border-right-width: 2px;
  }
  .md\\:border-b-2 {
    border-bottom-width: 2px;
  }
  .md\\:border-l-2 {
    border-left-width: 2px;
  }
  .md\\:border-t-4 {
    border-top-width: 4px;
  }
  .md\\:border-r-4 {
    border-right-width: 4px;
  }
  .md\\:border-b-4 {
    border-bottom-width: 4px;
  }
  .md\\:border-l-4 {
    border-left-width: 4px;
  }
  .md\\:border-t-8 {
    border-top-width: 8px;
  }
  .md\\:border-r-8 {
    border-right-width: 8px;
  }
  .md\\:border-b-8 {
    border-bottom-width: 8px;
  }
  .md\\:border-l-8 {
    border-left-width: 8px;
  }
  .md\\:border-t {
    border-top-width: 1px;
  }
  .md\\:border-r {
    border-right-width: 1px;
  }
  .md\\:border-b {
    border-bottom-width: 1px;
  }
  .md\\:border-l {
    border-left-width: 1px;
  }
  .md\\:box-border {
    box-sizing: border-box;
  }
  .md\\:box-content {
    box-sizing: content-box;
  }
  .md\\:cursor-auto {
    cursor: auto;
  }
  .md\\:cursor-default {
    cursor: default;
  }
  .md\\:cursor-pointer {
    cursor: pointer;
  }
  .md\\:cursor-wait {
    cursor: wait;
  }
  .md\\:cursor-text {
    cursor: text;
  }
  .md\\:cursor-move {
    cursor: move;
  }
  .md\\:cursor-not-allowed {
    cursor: not-allowed;
  }
  .md\\:block {
    display: block;
  }
  .md\\:inline-block {
    display: inline-block;
  }
  .md\\:inline {
    display: inline;
  }
  .md\\:flex {
    display: flex;
  }
  .md\\:inline-flex {
    display: inline-flex;
  }
  .md\\:table {
    display: table;
  }
  .md\\:table-caption {
    display: table-caption;
  }
  .md\\:table-cell {
    display: table-cell;
  }
  .md\\:table-column {
    display: table-column;
  }
  .md\\:table-column-group {
    display: table-column-group;
  }
  .md\\:table-footer-group {
    display: table-footer-group;
  }
  .md\\:table-header-group {
    display: table-header-group;
  }
  .md\\:table-row-group {
    display: table-row-group;
  }
  .md\\:table-row {
    display: table-row;
  }
  .md\\:flow-root {
    display: flow-root;
  }
  .md\\:grid {
    display: grid;
  }
  .md\\:inline-grid {
    display: inline-grid;
  }
  .md\\:contents {
    display: contents;
  }
  .md\\:hidden {
    display: none;
  }
  .md\\:flex-row {
    flex-direction: row;
  }
  .md\\:flex-row-reverse {
    flex-direction: row-reverse;
  }
  .md\\:flex-col {
    flex-direction: column;
  }
  .md\\:flex-col-reverse {
    flex-direction: column-reverse;
  }
  .md\\:flex-wrap {
    flex-wrap: wrap;
  }
  .md\\:flex-wrap-reverse {
    flex-wrap: wrap-reverse;
  }
  .md\\:flex-no-wrap {
    flex-wrap: nowrap;
  }
  .md\\:place-items-auto {
    place-items: auto;
  }
  .md\\:place-items-start {
    place-items: start;
  }
  .md\\:place-items-end {
    place-items: end;
  }
  .md\\:place-items-center {
    place-items: center;
  }
  .md\\:place-items-stretch {
    place-items: stretch;
  }
  .md\\:place-content-center {
    place-content: center;
  }
  .md\\:place-content-start {
    place-content: start;
  }
  .md\\:place-content-end {
    place-content: end;
  }
  .md\\:place-content-between {
    place-content: space-between;
  }
  .md\\:place-content-around {
    place-content: space-around;
  }
  .md\\:place-content-evenly {
    place-content: space-evenly;
  }
  .md\\:place-content-stretch {
    place-content: stretch;
  }
  .md\\:place-self-auto {
    place-self: auto;
  }
  .md\\:place-self-start {
    place-self: start;
  }
  .md\\:place-self-end {
    place-self: end;
  }
  .md\\:place-self-center {
    place-self: center;
  }
  .md\\:place-self-stretch {
    place-self: stretch;
  }
  .md\\:items-start {
    align-items: flex-start;
  }
  .md\\:items-end {
    align-items: flex-end;
  }
  .md\\:items-center {
    align-items: center;
  }
  .md\\:items-baseline {
    align-items: baseline;
  }
  .md\\:items-stretch {
    align-items: stretch;
  }
  .md\\:content-center {
    align-content: center;
  }
  .md\\:content-start {
    align-content: flex-start;
  }
  .md\\:content-end {
    align-content: flex-end;
  }
  .md\\:content-between {
    align-content: space-between;
  }
  .md\\:content-around {
    align-content: space-around;
  }
  .md\\:content-evenly {
    align-content: space-evenly;
  }
  .md\\:self-auto {
    align-self: auto;
  }
  .md\\:self-start {
    align-self: flex-start;
  }
  .md\\:self-end {
    align-self: flex-end;
  }
  .md\\:self-center {
    align-self: center;
  }
  .md\\:self-stretch {
    align-self: stretch;
  }
  .md\\:justify-items-auto {
    justify-items: auto;
  }
  .md\\:justify-items-start {
    justify-items: start;
  }
  .md\\:justify-items-end {
    justify-items: end;
  }
  .md\\:justify-items-center {
    justify-items: center;
  }
  .md\\:justify-items-stretch {
    justify-items: stretch;
  }
  .md\\:justify-start {
    justify-content: flex-start;
  }
  .md\\:justify-end {
    justify-content: flex-end;
  }
  .md\\:justify-center {
    justify-content: center;
  }
  .md\\:justify-between {
    justify-content: space-between;
  }
  .md\\:justify-around {
    justify-content: space-around;
  }
  .md\\:justify-evenly {
    justify-content: space-evenly;
  }
  .md\\:justify-self-auto {
    justify-self: auto;
  }
  .md\\:justify-self-start {
    justify-self: start;
  }
  .md\\:justify-self-end {
    justify-self: end;
  }
  .md\\:justify-self-center {
    justify-self: center;
  }
  .md\\:justify-self-stretch {
    justify-self: stretch;
  }
  .md\\:flex-1 {
    flex: 1 1;
  }
  .md\\:flex-auto {
    flex: 1 1 auto;
  }
  .md\\:flex-initial {
    flex: 0 1 auto;
  }
  .md\\:flex-none {
    flex: none;
  }
  .md\\:flex-grow-0 {
    flex-grow: 0;
  }
  .md\\:flex-grow {
    flex-grow: 1;
  }
  .md\\:flex-shrink-0 {
    flex-shrink: 0;
  }
  .md\\:flex-shrink {
    flex-shrink: 1;
  }
  .md\\:order-1 {
    order: 1;
  }
  .md\\:order-2 {
    order: 2;
  }
  .md\\:order-3 {
    order: 3;
  }
  .md\\:order-4 {
    order: 4;
  }
  .md\\:order-5 {
    order: 5;
  }
  .md\\:order-6 {
    order: 6;
  }
  .md\\:order-7 {
    order: 7;
  }
  .md\\:order-8 {
    order: 8;
  }
  .md\\:order-9 {
    order: 9;
  }
  .md\\:order-10 {
    order: 10;
  }
  .md\\:order-11 {
    order: 11;
  }
  .md\\:order-12 {
    order: 12;
  }
  .md\\:order-first {
    order: -9999;
  }
  .md\\:order-last {
    order: 9999;
  }
  .md\\:order-none {
    order: 0;
  }
  .md\\:float-right {
    float: right;
  }
  .md\\:float-left {
    float: left;
  }
  .md\\:float-none {
    float: none;
  }
  .md\\:clearfix:after {
    content: "";
    display: table;
    clear: both;
  }
  .md\\:clear-left {
    clear: left;
  }
  .md\\:clear-right {
    clear: right;
  }
  .md\\:clear-both {
    clear: both;
  }
  .md\\:clear-none {
    clear: none;
  }
  .md\\:font-sans {
    font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  }
  .md\\:font-serif {
    font-family: Georgia, Cambria, "Times New Roman", Times, serif;
  }
  .md\\:font-mono {
    font-family: Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  }
  .md\\:font-hairline {
    font-weight: 100;
  }
  .md\\:font-thin {
    font-weight: 200;
  }
  .md\\:font-light {
    font-weight: 300;
  }
  .md\\:font-normal {
    font-weight: 400;
  }
  .md\\:font-medium {
    font-weight: 500;
  }
  .md\\:font-semibold {
    font-weight: 600;
  }
  .md\\:font-bold {
    font-weight: 700;
  }
  .md\\:font-extrabold {
    font-weight: 800;
  }
  .md\\:font-black {
    font-weight: 900;
  }
  .md\\:hover\\:font-hairline:hover {
    font-weight: 100;
  }
  .md\\:hover\\:font-thin:hover {
    font-weight: 200;
  }
  .md\\:hover\\:font-light:hover {
    font-weight: 300;
  }
  .md\\:hover\\:font-normal:hover {
    font-weight: 400;
  }
  .md\\:hover\\:font-medium:hover {
    font-weight: 500;
  }
  .md\\:hover\\:font-semibold:hover {
    font-weight: 600;
  }
  .md\\:hover\\:font-bold:hover {
    font-weight: 700;
  }
  .md\\:hover\\:font-extrabold:hover {
    font-weight: 800;
  }
  .md\\:hover\\:font-black:hover {
    font-weight: 900;
  }
  .md\\:focus\\:font-hairline:focus {
    font-weight: 100;
  }
  .md\\:focus\\:font-thin:focus {
    font-weight: 200;
  }
  .md\\:focus\\:font-light:focus {
    font-weight: 300;
  }
  .md\\:focus\\:font-normal:focus {
    font-weight: 400;
  }
  .md\\:focus\\:font-medium:focus {
    font-weight: 500;
  }
  .md\\:focus\\:font-semibold:focus {
    font-weight: 600;
  }
  .md\\:focus\\:font-bold:focus {
    font-weight: 700;
  }
  .md\\:focus\\:font-extrabold:focus {
    font-weight: 800;
  }
  .md\\:focus\\:font-black:focus {
    font-weight: 900;
  }
  .md\\:h-0 {
    height: 0;
  }
  .md\\:h-1 {
    height: 0.25rem;
  }
  .md\\:h-2 {
    height: 0.5rem;
  }
  .md\\:h-3 {
    height: 0.75rem;
  }
  .md\\:h-4 {
    height: 1rem;
  }
  .md\\:h-5 {
    height: 1.25rem;
  }
  .md\\:h-6 {
    height: 1.5rem;
  }
  .md\\:h-7 {
    height: 1.75rem;
  }
  .md\\:h-8 {
    height: 2rem;
  }
  .md\\:h-9 {
    height: 2.25rem;
  }
  .md\\:h-10 {
    height: 2.5rem;
  }
  .md\\:h-11 {
    height: 2.75rem;
  }
  .md\\:h-12 {
    height: 3rem;
  }
  .md\\:h-13 {
    height: 3.25rem;
  }
  .md\\:h-14 {
    height: 3.5rem;
  }
  .md\\:h-15 {
    height: 3.75rem;
  }
  .md\\:h-16 {
    height: 4rem;
  }
  .md\\:h-20 {
    height: 5rem;
  }
  .md\\:h-24 {
    height: 6rem;
  }
  .md\\:h-28 {
    height: 7rem;
  }
  .md\\:h-32 {
    height: 8rem;
  }
  .md\\:h-36 {
    height: 9rem;
  }
  .md\\:h-40 {
    height: 10rem;
  }
  .md\\:h-44 {
    height: 11rem;
  }
  .md\\:h-48 {
    height: 12rem;
  }
  .md\\:h-52 {
    height: 13rem;
  }
  .md\\:h-56 {
    height: 14rem;
  }
  .md\\:h-60 {
    height: 15rem;
  }
  .md\\:h-64 {
    height: 16rem;
  }
  .md\\:h-72 {
    height: 18rem;
  }
  .md\\:h-80 {
    height: 20rem;
  }
  .md\\:h-96 {
    height: 24rem;
  }
  .md\\:h-auto {
    height: auto;
  }
  .md\\:h-px {
    height: 1px;
  }
  .md\\:h-0\\.5 {
    height: 0.125rem;
  }
  .md\\:h-1\\.5 {
    height: 0.375rem;
  }
  .md\\:h-2\\.5 {
    height: 0.625rem;
  }
  .md\\:h-3\\.5 {
    height: 0.875rem;
  }
  .md\\:h-1\\/2 {
    height: 50%;
  }
  .md\\:h-1\\/3 {
    height: 33.333333%;
  }
  .md\\:h-2\\/3 {
    height: 66.666667%;
  }
  .md\\:h-1\\/4 {
    height: 25%;
  }
  .md\\:h-2\\/4 {
    height: 50%;
  }
  .md\\:h-3\\/4 {
    height: 75%;
  }
  .md\\:h-1\\/5 {
    height: 20%;
  }
  .md\\:h-2\\/5 {
    height: 40%;
  }
  .md\\:h-3\\/5 {
    height: 60%;
  }
  .md\\:h-4\\/5 {
    height: 80%;
  }
  .md\\:h-1\\/6 {
    height: 16.666667%;
  }
  .md\\:h-2\\/6 {
    height: 33.333333%;
  }
  .md\\:h-3\\/6 {
    height: 50%;
  }
  .md\\:h-4\\/6 {
    height: 66.666667%;
  }
  .md\\:h-5\\/6 {
    height: 83.333333%;
  }
  .md\\:h-1\\/12 {
    height: 8.333333%;
  }
  .md\\:h-2\\/12 {
    height: 16.666667%;
  }
  .md\\:h-3\\/12 {
    height: 25%;
  }
  .md\\:h-4\\/12 {
    height: 33.333333%;
  }
  .md\\:h-5\\/12 {
    height: 41.666667%;
  }
  .md\\:h-6\\/12 {
    height: 50%;
  }
  .md\\:h-7\\/12 {
    height: 58.333333%;
  }
  .md\\:h-8\\/12 {
    height: 66.666667%;
  }
  .md\\:h-9\\/12 {
    height: 75%;
  }
  .md\\:h-10\\/12 {
    height: 83.333333%;
  }
  .md\\:h-11\\/12 {
    height: 91.666667%;
  }
  .md\\:h-full {
    height: 100%;
  }
  .md\\:h-screen {
    height: 100vh;
  }
  .md\\:text-xs {
    font-size: 0.75rem;
  }
  .md\\:text-sm {
    font-size: 0.875rem;
  }
  .md\\:text-base {
    font-size: 1rem;
  }
  .md\\:text-lg {
    font-size: 1.125rem;
  }
  .md\\:text-xl {
    font-size: 1.25rem;
  }
  .md\\:text-2xl {
    font-size: 1.5rem;
  }
  .md\\:text-3xl {
    font-size: 1.875rem;
  }
  .md\\:text-4xl {
    font-size: 2.25rem;
  }
  .md\\:text-5xl {
    font-size: 3rem;
  }
  .md\\:text-6xl {
    font-size: 4rem;
  }
  .md\\:leading-3 {
    line-height: .75rem;
  }
  .md\\:leading-4 {
    line-height: 1rem;
  }
  .md\\:leading-5 {
    line-height: 1.25rem;
  }
  .md\\:leading-6 {
    line-height: 1.5rem;
  }
  .md\\:leading-7 {
    line-height: 1.75rem;
  }
  .md\\:leading-8 {
    line-height: 2rem;
  }
  .md\\:leading-9 {
    line-height: 2.25rem;
  }
  .md\\:leading-10 {
    line-height: 2.5rem;
  }
  .md\\:leading-none {
    line-height: 1;
  }
  .md\\:leading-tight {
    line-height: 1.25;
  }
  .md\\:leading-snug {
    line-height: 1.375;
  }
  .md\\:leading-normal {
    line-height: 1.5;
  }
  .md\\:leading-relaxed {
    line-height: 1.625;
  }
  .md\\:leading-loose {
    line-height: 2;
  }
  .md\\:list-inside {
    list-style-position: inside;
  }
  .md\\:list-outside {
    list-style-position: outside;
  }
  .md\\:list-none {
    list-style-type: none;
  }
  .md\\:list-disc {
    list-style-type: disc;
  }
  .md\\:list-decimal {
    list-style-type: decimal;
  }
  .md\\:m-0 {
    margin: 0;
  }
  .md\\:m-1 {
    margin: 0.25rem;
  }
  .md\\:m-2 {
    margin: 0.5rem;
  }
  .md\\:m-3 {
    margin: 0.75rem;
  }
  .md\\:m-4 {
    margin: 1rem;
  }
  .md\\:m-5 {
    margin: 1.25rem;
  }
  .md\\:m-6 {
    margin: 1.5rem;
  }
  .md\\:m-7 {
    margin: 1.75rem;
  }
  .md\\:m-8 {
    margin: 2rem;
  }
  .md\\:m-9 {
    margin: 2.25rem;
  }
  .md\\:m-10 {
    margin: 2.5rem;
  }
  .md\\:m-11 {
    margin: 2.75rem;
  }
  .md\\:m-12 {
    margin: 3rem;
  }
  .md\\:m-13 {
    margin: 3.25rem;
  }
  .md\\:m-14 {
    margin: 3.5rem;
  }
  .md\\:m-15 {
    margin: 3.75rem;
  }
  .md\\:m-16 {
    margin: 4rem;
  }
  .md\\:m-20 {
    margin: 5rem;
  }
  .md\\:m-24 {
    margin: 6rem;
  }
  .md\\:m-28 {
    margin: 7rem;
  }
  .md\\:m-32 {
    margin: 8rem;
  }
  .md\\:m-36 {
    margin: 9rem;
  }
  .md\\:m-40 {
    margin: 10rem;
  }
  .md\\:m-44 {
    margin: 11rem;
  }
  .md\\:m-48 {
    margin: 12rem;
  }
  .md\\:m-52 {
    margin: 13rem;
  }
  .md\\:m-56 {
    margin: 14rem;
  }
  .md\\:m-60 {
    margin: 15rem;
  }
  .md\\:m-64 {
    margin: 16rem;
  }
  .md\\:m-72 {
    margin: 18rem;
  }
  .md\\:m-80 {
    margin: 20rem;
  }
  .md\\:m-96 {
    margin: 24rem;
  }
  .md\\:m-auto {
    margin: auto;
  }
  .md\\:m-px {
    margin: 1px;
  }
  .md\\:m-0\\.5 {
    margin: 0.125rem;
  }
  .md\\:m-1\\.5 {
    margin: 0.375rem;
  }
  .md\\:m-2\\.5 {
    margin: 0.625rem;
  }
  .md\\:m-3\\.5 {
    margin: 0.875rem;
  }
  .md\\:m-1\\/2 {
    margin: 50%;
  }
  .md\\:m-1\\/3 {
    margin: 33.333333%;
  }
  .md\\:m-2\\/3 {
    margin: 66.666667%;
  }
  .md\\:m-1\\/4 {
    margin: 25%;
  }
  .md\\:m-2\\/4 {
    margin: 50%;
  }
  .md\\:m-3\\/4 {
    margin: 75%;
  }
  .md\\:m-1\\/5 {
    margin: 20%;
  }
  .md\\:m-2\\/5 {
    margin: 40%;
  }
  .md\\:m-3\\/5 {
    margin: 60%;
  }
  .md\\:m-4\\/5 {
    margin: 80%;
  }
  .md\\:m-1\\/6 {
    margin: 16.666667%;
  }
  .md\\:m-2\\/6 {
    margin: 33.333333%;
  }
  .md\\:m-3\\/6 {
    margin: 50%;
  }
  .md\\:m-4\\/6 {
    margin: 66.666667%;
  }
  .md\\:m-5\\/6 {
    margin: 83.333333%;
  }
  .md\\:m-1\\/12 {
    margin: 8.333333%;
  }
  .md\\:m-2\\/12 {
    margin: 16.666667%;
  }
  .md\\:m-3\\/12 {
    margin: 25%;
  }
  .md\\:m-4\\/12 {
    margin: 33.333333%;
  }
  .md\\:m-5\\/12 {
    margin: 41.666667%;
  }
  .md\\:m-6\\/12 {
    margin: 50%;
  }
  .md\\:m-7\\/12 {
    margin: 58.333333%;
  }
  .md\\:m-8\\/12 {
    margin: 66.666667%;
  }
  .md\\:m-9\\/12 {
    margin: 75%;
  }
  .md\\:m-10\\/12 {
    margin: 83.333333%;
  }
  .md\\:m-11\\/12 {
    margin: 91.666667%;
  }
  .md\\:m-full {
    margin: 100%;
  }
  .md\\:-m-1 {
    margin: -0.25rem;
  }
  .md\\:-m-2 {
    margin: -0.5rem;
  }
  .md\\:-m-3 {
    margin: -0.75rem;
  }
  .md\\:-m-4 {
    margin: -1rem;
  }
  .md\\:-m-5 {
    margin: -1.25rem;
  }
  .md\\:-m-6 {
    margin: -1.5rem;
  }
  .md\\:-m-7 {
    margin: -1.75rem;
  }
  .md\\:-m-8 {
    margin: -2rem;
  }
  .md\\:-m-9 {
    margin: -2.25rem;
  }
  .md\\:-m-10 {
    margin: -2.5rem;
  }
  .md\\:-m-11 {
    margin: -2.75rem;
  }
  .md\\:-m-12 {
    margin: -3rem;
  }
  .md\\:-m-13 {
    margin: -3.25rem;
  }
  .md\\:-m-14 {
    margin: -3.5rem;
  }
  .md\\:-m-15 {
    margin: -3.75rem;
  }
  .md\\:-m-16 {
    margin: -4rem;
  }
  .md\\:-m-20 {
    margin: -5rem;
  }
  .md\\:-m-24 {
    margin: -6rem;
  }
  .md\\:-m-28 {
    margin: -7rem;
  }
  .md\\:-m-32 {
    margin: -8rem;
  }
  .md\\:-m-36 {
    margin: -9rem;
  }
  .md\\:-m-40 {
    margin: -10rem;
  }
  .md\\:-m-44 {
    margin: -11rem;
  }
  .md\\:-m-48 {
    margin: -12rem;
  }
  .md\\:-m-52 {
    margin: -13rem;
  }
  .md\\:-m-56 {
    margin: -14rem;
  }
  .md\\:-m-60 {
    margin: -15rem;
  }
  .md\\:-m-64 {
    margin: -16rem;
  }
  .md\\:-m-72 {
    margin: -18rem;
  }
  .md\\:-m-80 {
    margin: -20rem;
  }
  .md\\:-m-96 {
    margin: -24rem;
  }
  .md\\:-m-px {
    margin: -1px;
  }
  .md\\:-m-0\\.5 {
    margin: -0.125rem;
  }
  .md\\:-m-1\\.5 {
    margin: -0.375rem;
  }
  .md\\:-m-2\\.5 {
    margin: -0.625rem;
  }
  .md\\:-m-3\\.5 {
    margin: -0.875rem;
  }
  .md\\:-m-1\\/2 {
    margin: -50%;
  }
  .md\\:-m-1\\/3 {
    margin: -33.33333%;
  }
  .md\\:-m-2\\/3 {
    margin: -66.66667%;
  }
  .md\\:-m-1\\/4 {
    margin: -25%;
  }
  .md\\:-m-2\\/4 {
    margin: -50%;
  }
  .md\\:-m-3\\/4 {
    margin: -75%;
  }
  .md\\:-m-1\\/5 {
    margin: -20%;
  }
  .md\\:-m-2\\/5 {
    margin: -40%;
  }
  .md\\:-m-3\\/5 {
    margin: -60%;
  }
  .md\\:-m-4\\/5 {
    margin: -80%;
  }
  .md\\:-m-1\\/6 {
    margin: -16.66667%;
  }
  .md\\:-m-2\\/6 {
    margin: -33.33333%;
  }
  .md\\:-m-3\\/6 {
    margin: -50%;
  }
  .md\\:-m-4\\/6 {
    margin: -66.66667%;
  }
  .md\\:-m-5\\/6 {
    margin: -83.33333%;
  }
  .md\\:-m-1\\/12 {
    margin: -8.33333%;
  }
  .md\\:-m-2\\/12 {
    margin: -16.66667%;
  }
  .md\\:-m-3\\/12 {
    margin: -25%;
  }
  .md\\:-m-4\\/12 {
    margin: -33.33333%;
  }
  .md\\:-m-5\\/12 {
    margin: -41.66667%;
  }
  .md\\:-m-6\\/12 {
    margin: -50%;
  }
  .md\\:-m-7\\/12 {
    margin: -58.33333%;
  }
  .md\\:-m-8\\/12 {
    margin: -66.66667%;
  }
  .md\\:-m-9\\/12 {
    margin: -75%;
  }
  .md\\:-m-10\\/12 {
    margin: -83.33333%;
  }
  .md\\:-m-11\\/12 {
    margin: -91.66667%;
  }
  .md\\:-m-full {
    margin: -100%;
  }
  .md\\:my-0 {
    margin-top: 0;
    margin-bottom: 0;
  }
  .md\\:mx-0 {
    margin-left: 0;
    margin-right: 0;
  }
  .md\\:my-1 {
    margin-top: 0.25rem;
    margin-bottom: 0.25rem;
  }
  .md\\:mx-1 {
    margin-left: 0.25rem;
    margin-right: 0.25rem;
  }
  .md\\:my-2 {
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
  }
  .md\\:mx-2 {
    margin-left: 0.5rem;
    margin-right: 0.5rem;
  }
  .md\\:my-3 {
    margin-top: 0.75rem;
    margin-bottom: 0.75rem;
  }
  .md\\:mx-3 {
    margin-left: 0.75rem;
    margin-right: 0.75rem;
  }
  .md\\:my-4 {
    margin-top: 1rem;
    margin-bottom: 1rem;
  }
  .md\\:mx-4 {
    margin-left: 1rem;
    margin-right: 1rem;
  }
  .md\\:my-5 {
    margin-top: 1.25rem;
    margin-bottom: 1.25rem;
  }
  .md\\:mx-5 {
    margin-left: 1.25rem;
    margin-right: 1.25rem;
  }
  .md\\:my-6 {
    margin-top: 1.5rem;
    margin-bottom: 1.5rem;
  }
  .md\\:mx-6 {
    margin-left: 1.5rem;
    margin-right: 1.5rem;
  }
  .md\\:my-7 {
    margin-top: 1.75rem;
    margin-bottom: 1.75rem;
  }
  .md\\:mx-7 {
    margin-left: 1.75rem;
    margin-right: 1.75rem;
  }
  .md\\:my-8 {
    margin-top: 2rem;
    margin-bottom: 2rem;
  }
  .md\\:mx-8 {
    margin-left: 2rem;
    margin-right: 2rem;
  }
  .md\\:my-9 {
    margin-top: 2.25rem;
    margin-bottom: 2.25rem;
  }
  .md\\:mx-9 {
    margin-left: 2.25rem;
    margin-right: 2.25rem;
  }
  .md\\:my-10 {
    margin-top: 2.5rem;
    margin-bottom: 2.5rem;
  }
  .md\\:mx-10 {
    margin-left: 2.5rem;
    margin-right: 2.5rem;
  }
  .md\\:my-11 {
    margin-top: 2.75rem;
    margin-bottom: 2.75rem;
  }
  .md\\:mx-11 {
    margin-left: 2.75rem;
    margin-right: 2.75rem;
  }
  .md\\:my-12 {
    margin-top: 3rem;
    margin-bottom: 3rem;
  }
  .md\\:mx-12 {
    margin-left: 3rem;
    margin-right: 3rem;
  }
  .md\\:my-13 {
    margin-top: 3.25rem;
    margin-bottom: 3.25rem;
  }
  .md\\:mx-13 {
    margin-left: 3.25rem;
    margin-right: 3.25rem;
  }
  .md\\:my-14 {
    margin-top: 3.5rem;
    margin-bottom: 3.5rem;
  }
  .md\\:mx-14 {
    margin-left: 3.5rem;
    margin-right: 3.5rem;
  }
  .md\\:my-15 {
    margin-top: 3.75rem;
    margin-bottom: 3.75rem;
  }
  .md\\:mx-15 {
    margin-left: 3.75rem;
    margin-right: 3.75rem;
  }
  .md\\:my-16 {
    margin-top: 4rem;
    margin-bottom: 4rem;
  }
  .md\\:mx-16 {
    margin-left: 4rem;
    margin-right: 4rem;
  }
  .md\\:my-20 {
    margin-top: 5rem;
    margin-bottom: 5rem;
  }
  .md\\:mx-20 {
    margin-left: 5rem;
    margin-right: 5rem;
  }
  .md\\:my-24 {
    margin-top: 6rem;
    margin-bottom: 6rem;
  }
  .md\\:mx-24 {
    margin-left: 6rem;
    margin-right: 6rem;
  }
  .md\\:my-28 {
    margin-top: 7rem;
    margin-bottom: 7rem;
  }
  .md\\:mx-28 {
    margin-left: 7rem;
    margin-right: 7rem;
  }
  .md\\:my-32 {
    margin-top: 8rem;
    margin-bottom: 8rem;
  }
  .md\\:mx-32 {
    margin-left: 8rem;
    margin-right: 8rem;
  }
  .md\\:my-36 {
    margin-top: 9rem;
    margin-bottom: 9rem;
  }
  .md\\:mx-36 {
    margin-left: 9rem;
    margin-right: 9rem;
  }
  .md\\:my-40 {
    margin-top: 10rem;
    margin-bottom: 10rem;
  }
  .md\\:mx-40 {
    margin-left: 10rem;
    margin-right: 10rem;
  }
  .md\\:my-44 {
    margin-top: 11rem;
    margin-bottom: 11rem;
  }
  .md\\:mx-44 {
    margin-left: 11rem;
    margin-right: 11rem;
  }
  .md\\:my-48 {
    margin-top: 12rem;
    margin-bottom: 12rem;
  }
  .md\\:mx-48 {
    margin-left: 12rem;
    margin-right: 12rem;
  }
  .md\\:my-52 {
    margin-top: 13rem;
    margin-bottom: 13rem;
  }
  .md\\:mx-52 {
    margin-left: 13rem;
    margin-right: 13rem;
  }
  .md\\:my-56 {
    margin-top: 14rem;
    margin-bottom: 14rem;
  }
  .md\\:mx-56 {
    margin-left: 14rem;
    margin-right: 14rem;
  }
  .md\\:my-60 {
    margin-top: 15rem;
    margin-bottom: 15rem;
  }
  .md\\:mx-60 {
    margin-left: 15rem;
    margin-right: 15rem;
  }
  .md\\:my-64 {
    margin-top: 16rem;
    margin-bottom: 16rem;
  }
  .md\\:mx-64 {
    margin-left: 16rem;
    margin-right: 16rem;
  }
  .md\\:my-72 {
    margin-top: 18rem;
    margin-bottom: 18rem;
  }
  .md\\:mx-72 {
    margin-left: 18rem;
    margin-right: 18rem;
  }
  .md\\:my-80 {
    margin-top: 20rem;
    margin-bottom: 20rem;
  }
  .md\\:mx-80 {
    margin-left: 20rem;
    margin-right: 20rem;
  }
  .md\\:my-96 {
    margin-top: 24rem;
    margin-bottom: 24rem;
  }
  .md\\:mx-96 {
    margin-left: 24rem;
    margin-right: 24rem;
  }
  .md\\:my-auto {
    margin-top: auto;
    margin-bottom: auto;
  }
  .md\\:mx-auto {
    margin-left: auto;
    margin-right: auto;
  }
  .md\\:my-px {
    margin-top: 1px;
    margin-bottom: 1px;
  }
  .md\\:mx-px {
    margin-left: 1px;
    margin-right: 1px;
  }
  .md\\:my-0\\.5 {
    margin-top: 0.125rem;
    margin-bottom: 0.125rem;
  }
  .md\\:mx-0\\.5 {
    margin-left: 0.125rem;
    margin-right: 0.125rem;
  }
  .md\\:my-1\\.5 {
    margin-top: 0.375rem;
    margin-bottom: 0.375rem;
  }
  .md\\:mx-1\\.5 {
    margin-left: 0.375rem;
    margin-right: 0.375rem;
  }
  .md\\:my-2\\.5 {
    margin-top: 0.625rem;
    margin-bottom: 0.625rem;
  }
  .md\\:mx-2\\.5 {
    margin-left: 0.625rem;
    margin-right: 0.625rem;
  }
  .md\\:my-3\\.5 {
    margin-top: 0.875rem;
    margin-bottom: 0.875rem;
  }
  .md\\:mx-3\\.5 {
    margin-left: 0.875rem;
    margin-right: 0.875rem;
  }
  .md\\:my-1\\/2 {
    margin-top: 50%;
    margin-bottom: 50%;
  }
  .md\\:mx-1\\/2 {
    margin-left: 50%;
    margin-right: 50%;
  }
  .md\\:my-1\\/3 {
    margin-top: 33.333333%;
    margin-bottom: 33.333333%;
  }
  .md\\:mx-1\\/3 {
    margin-left: 33.333333%;
    margin-right: 33.333333%;
  }
  .md\\:my-2\\/3 {
    margin-top: 66.666667%;
    margin-bottom: 66.666667%;
  }
  .md\\:mx-2\\/3 {
    margin-left: 66.666667%;
    margin-right: 66.666667%;
  }
  .md\\:my-1\\/4 {
    margin-top: 25%;
    margin-bottom: 25%;
  }
  .md\\:mx-1\\/4 {
    margin-left: 25%;
    margin-right: 25%;
  }
  .md\\:my-2\\/4 {
    margin-top: 50%;
    margin-bottom: 50%;
  }
  .md\\:mx-2\\/4 {
    margin-left: 50%;
    margin-right: 50%;
  }
  .md\\:my-3\\/4 {
    margin-top: 75%;
    margin-bottom: 75%;
  }
  .md\\:mx-3\\/4 {
    margin-left: 75%;
    margin-right: 75%;
  }
  .md\\:my-1\\/5 {
    margin-top: 20%;
    margin-bottom: 20%;
  }
  .md\\:mx-1\\/5 {
    margin-left: 20%;
    margin-right: 20%;
  }
  .md\\:my-2\\/5 {
    margin-top: 40%;
    margin-bottom: 40%;
  }
  .md\\:mx-2\\/5 {
    margin-left: 40%;
    margin-right: 40%;
  }
  .md\\:my-3\\/5 {
    margin-top: 60%;
    margin-bottom: 60%;
  }
  .md\\:mx-3\\/5 {
    margin-left: 60%;
    margin-right: 60%;
  }
  .md\\:my-4\\/5 {
    margin-top: 80%;
    margin-bottom: 80%;
  }
  .md\\:mx-4\\/5 {
    margin-left: 80%;
    margin-right: 80%;
  }
  .md\\:my-1\\/6 {
    margin-top: 16.666667%;
    margin-bottom: 16.666667%;
  }
  .md\\:mx-1\\/6 {
    margin-left: 16.666667%;
    margin-right: 16.666667%;
  }
  .md\\:my-2\\/6 {
    margin-top: 33.333333%;
    margin-bottom: 33.333333%;
  }
  .md\\:mx-2\\/6 {
    margin-left: 33.333333%;
    margin-right: 33.333333%;
  }
  .md\\:my-3\\/6 {
    margin-top: 50%;
    margin-bottom: 50%;
  }
  .md\\:mx-3\\/6 {
    margin-left: 50%;
    margin-right: 50%;
  }
  .md\\:my-4\\/6 {
    margin-top: 66.666667%;
    margin-bottom: 66.666667%;
  }
  .md\\:mx-4\\/6 {
    margin-left: 66.666667%;
    margin-right: 66.666667%;
  }
  .md\\:my-5\\/6 {
    margin-top: 83.333333%;
    margin-bottom: 83.333333%;
  }
  .md\\:mx-5\\/6 {
    margin-left: 83.333333%;
    margin-right: 83.333333%;
  }
  .md\\:my-1\\/12 {
    margin-top: 8.333333%;
    margin-bottom: 8.333333%;
  }
  .md\\:mx-1\\/12 {
    margin-left: 8.333333%;
    margin-right: 8.333333%;
  }
  .md\\:my-2\\/12 {
    margin-top: 16.666667%;
    margin-bottom: 16.666667%;
  }
  .md\\:mx-2\\/12 {
    margin-left: 16.666667%;
    margin-right: 16.666667%;
  }
  .md\\:my-3\\/12 {
    margin-top: 25%;
    margin-bottom: 25%;
  }
  .md\\:mx-3\\/12 {
    margin-left: 25%;
    margin-right: 25%;
  }
  .md\\:my-4\\/12 {
    margin-top: 33.333333%;
    margin-bottom: 33.333333%;
  }
  .md\\:mx-4\\/12 {
    margin-left: 33.333333%;
    margin-right: 33.333333%;
  }
  .md\\:my-5\\/12 {
    margin-top: 41.666667%;
    margin-bottom: 41.666667%;
  }
  .md\\:mx-5\\/12 {
    margin-left: 41.666667%;
    margin-right: 41.666667%;
  }
  .md\\:my-6\\/12 {
    margin-top: 50%;
    margin-bottom: 50%;
  }
  .md\\:mx-6\\/12 {
    margin-left: 50%;
    margin-right: 50%;
  }
  .md\\:my-7\\/12 {
    margin-top: 58.333333%;
    margin-bottom: 58.333333%;
  }
  .md\\:mx-7\\/12 {
    margin-left: 58.333333%;
    margin-right: 58.333333%;
  }
  .md\\:my-8\\/12 {
    margin-top: 66.666667%;
    margin-bottom: 66.666667%;
  }
  .md\\:mx-8\\/12 {
    margin-left: 66.666667%;
    margin-right: 66.666667%;
  }
  .md\\:my-9\\/12 {
    margin-top: 75%;
    margin-bottom: 75%;
  }
  .md\\:mx-9\\/12 {
    margin-left: 75%;
    margin-right: 75%;
  }
  .md\\:my-10\\/12 {
    margin-top: 83.333333%;
    margin-bottom: 83.333333%;
  }
  .md\\:mx-10\\/12 {
    margin-left: 83.333333%;
    margin-right: 83.333333%;
  }
  .md\\:my-11\\/12 {
    margin-top: 91.666667%;
    margin-bottom: 91.666667%;
  }
  .md\\:mx-11\\/12 {
    margin-left: 91.666667%;
    margin-right: 91.666667%;
  }
  .md\\:my-full {
    margin-top: 100%;
    margin-bottom: 100%;
  }
  .md\\:mx-full {
    margin-left: 100%;
    margin-right: 100%;
  }
  .md\\:-my-1 {
    margin-top: -0.25rem;
    margin-bottom: -0.25rem;
  }
  .md\\:-mx-1 {
    margin-left: -0.25rem;
    margin-right: -0.25rem;
  }
  .md\\:-my-2 {
    margin-top: -0.5rem;
    margin-bottom: -0.5rem;
  }
  .md\\:-mx-2 {
    margin-left: -0.5rem;
    margin-right: -0.5rem;
  }
  .md\\:-my-3 {
    margin-top: -0.75rem;
    margin-bottom: -0.75rem;
  }
  .md\\:-mx-3 {
    margin-left: -0.75rem;
    margin-right: -0.75rem;
  }
  .md\\:-my-4 {
    margin-top: -1rem;
    margin-bottom: -1rem;
  }
  .md\\:-mx-4 {
    margin-left: -1rem;
    margin-right: -1rem;
  }
  .md\\:-my-5 {
    margin-top: -1.25rem;
    margin-bottom: -1.25rem;
  }
  .md\\:-mx-5 {
    margin-left: -1.25rem;
    margin-right: -1.25rem;
  }
  .md\\:-my-6 {
    margin-top: -1.5rem;
    margin-bottom: -1.5rem;
  }
  .md\\:-mx-6 {
    margin-left: -1.5rem;
    margin-right: -1.5rem;
  }
  .md\\:-my-7 {
    margin-top: -1.75rem;
    margin-bottom: -1.75rem;
  }
  .md\\:-mx-7 {
    margin-left: -1.75rem;
    margin-right: -1.75rem;
  }
  .md\\:-my-8 {
    margin-top: -2rem;
    margin-bottom: -2rem;
  }
  .md\\:-mx-8 {
    margin-left: -2rem;
    margin-right: -2rem;
  }
  .md\\:-my-9 {
    margin-top: -2.25rem;
    margin-bottom: -2.25rem;
  }
  .md\\:-mx-9 {
    margin-left: -2.25rem;
    margin-right: -2.25rem;
  }
  .md\\:-my-10 {
    margin-top: -2.5rem;
    margin-bottom: -2.5rem;
  }
  .md\\:-mx-10 {
    margin-left: -2.5rem;
    margin-right: -2.5rem;
  }
  .md\\:-my-11 {
    margin-top: -2.75rem;
    margin-bottom: -2.75rem;
  }
  .md\\:-mx-11 {
    margin-left: -2.75rem;
    margin-right: -2.75rem;
  }
  .md\\:-my-12 {
    margin-top: -3rem;
    margin-bottom: -3rem;
  }
  .md\\:-mx-12 {
    margin-left: -3rem;
    margin-right: -3rem;
  }
  .md\\:-my-13 {
    margin-top: -3.25rem;
    margin-bottom: -3.25rem;
  }
  .md\\:-mx-13 {
    margin-left: -3.25rem;
    margin-right: -3.25rem;
  }
  .md\\:-my-14 {
    margin-top: -3.5rem;
    margin-bottom: -3.5rem;
  }
  .md\\:-mx-14 {
    margin-left: -3.5rem;
    margin-right: -3.5rem;
  }
  .md\\:-my-15 {
    margin-top: -3.75rem;
    margin-bottom: -3.75rem;
  }
  .md\\:-mx-15 {
    margin-left: -3.75rem;
    margin-right: -3.75rem;
  }
  .md\\:-my-16 {
    margin-top: -4rem;
    margin-bottom: -4rem;
  }
  .md\\:-mx-16 {
    margin-left: -4rem;
    margin-right: -4rem;
  }
  .md\\:-my-20 {
    margin-top: -5rem;
    margin-bottom: -5rem;
  }
  .md\\:-mx-20 {
    margin-left: -5rem;
    margin-right: -5rem;
  }
  .md\\:-my-24 {
    margin-top: -6rem;
    margin-bottom: -6rem;
  }
  .md\\:-mx-24 {
    margin-left: -6rem;
    margin-right: -6rem;
  }
  .md\\:-my-28 {
    margin-top: -7rem;
    margin-bottom: -7rem;
  }
  .md\\:-mx-28 {
    margin-left: -7rem;
    margin-right: -7rem;
  }
  .md\\:-my-32 {
    margin-top: -8rem;
    margin-bottom: -8rem;
  }
  .md\\:-mx-32 {
    margin-left: -8rem;
    margin-right: -8rem;
  }
  .md\\:-my-36 {
    margin-top: -9rem;
    margin-bottom: -9rem;
  }
  .md\\:-mx-36 {
    margin-left: -9rem;
    margin-right: -9rem;
  }
  .md\\:-my-40 {
    margin-top: -10rem;
    margin-bottom: -10rem;
  }
  .md\\:-mx-40 {
    margin-left: -10rem;
    margin-right: -10rem;
  }
  .md\\:-my-44 {
    margin-top: -11rem;
    margin-bottom: -11rem;
  }
  .md\\:-mx-44 {
    margin-left: -11rem;
    margin-right: -11rem;
  }
  .md\\:-my-48 {
    margin-top: -12rem;
    margin-bottom: -12rem;
  }
  .md\\:-mx-48 {
    margin-left: -12rem;
    margin-right: -12rem;
  }
  .md\\:-my-52 {
    margin-top: -13rem;
    margin-bottom: -13rem;
  }
  .md\\:-mx-52 {
    margin-left: -13rem;
    margin-right: -13rem;
  }
  .md\\:-my-56 {
    margin-top: -14rem;
    margin-bottom: -14rem;
  }
  .md\\:-mx-56 {
    margin-left: -14rem;
    margin-right: -14rem;
  }
  .md\\:-my-60 {
    margin-top: -15rem;
    margin-bottom: -15rem;
  }
  .md\\:-mx-60 {
    margin-left: -15rem;
    margin-right: -15rem;
  }
  .md\\:-my-64 {
    margin-top: -16rem;
    margin-bottom: -16rem;
  }
  .md\\:-mx-64 {
    margin-left: -16rem;
    margin-right: -16rem;
  }
  .md\\:-my-72 {
    margin-top: -18rem;
    margin-bottom: -18rem;
  }
  .md\\:-mx-72 {
    margin-left: -18rem;
    margin-right: -18rem;
  }
  .md\\:-my-80 {
    margin-top: -20rem;
    margin-bottom: -20rem;
  }
  .md\\:-mx-80 {
    margin-left: -20rem;
    margin-right: -20rem;
  }
  .md\\:-my-96 {
    margin-top: -24rem;
    margin-bottom: -24rem;
  }
  .md\\:-mx-96 {
    margin-left: -24rem;
    margin-right: -24rem;
  }
  .md\\:-my-px {
    margin-top: -1px;
    margin-bottom: -1px;
  }
  .md\\:-mx-px {
    margin-left: -1px;
    margin-right: -1px;
  }
  .md\\:-my-0\\.5 {
    margin-top: -0.125rem;
    margin-bottom: -0.125rem;
  }
  .md\\:-mx-0\\.5 {
    margin-left: -0.125rem;
    margin-right: -0.125rem;
  }
  .md\\:-my-1\\.5 {
    margin-top: -0.375rem;
    margin-bottom: -0.375rem;
  }
  .md\\:-mx-1\\.5 {
    margin-left: -0.375rem;
    margin-right: -0.375rem;
  }
  .md\\:-my-2\\.5 {
    margin-top: -0.625rem;
    margin-bottom: -0.625rem;
  }
  .md\\:-mx-2\\.5 {
    margin-left: -0.625rem;
    margin-right: -0.625rem;
  }
  .md\\:-my-3\\.5 {
    margin-top: -0.875rem;
    margin-bottom: -0.875rem;
  }
  .md\\:-mx-3\\.5 {
    margin-left: -0.875rem;
    margin-right: -0.875rem;
  }
  .md\\:-my-1\\/2 {
    margin-top: -50%;
    margin-bottom: -50%;
  }
  .md\\:-mx-1\\/2 {
    margin-left: -50%;
    margin-right: -50%;
  }
  .md\\:-my-1\\/3 {
    margin-top: -33.33333%;
    margin-bottom: -33.33333%;
  }
  .md\\:-mx-1\\/3 {
    margin-left: -33.33333%;
    margin-right: -33.33333%;
  }
  .md\\:-my-2\\/3 {
    margin-top: -66.66667%;
    margin-bottom: -66.66667%;
  }
  .md\\:-mx-2\\/3 {
    margin-left: -66.66667%;
    margin-right: -66.66667%;
  }
  .md\\:-my-1\\/4 {
    margin-top: -25%;
    margin-bottom: -25%;
  }
  .md\\:-mx-1\\/4 {
    margin-left: -25%;
    margin-right: -25%;
  }
  .md\\:-my-2\\/4 {
    margin-top: -50%;
    margin-bottom: -50%;
  }
  .md\\:-mx-2\\/4 {
    margin-left: -50%;
    margin-right: -50%;
  }
  .md\\:-my-3\\/4 {
    margin-top: -75%;
    margin-bottom: -75%;
  }
  .md\\:-mx-3\\/4 {
    margin-left: -75%;
    margin-right: -75%;
  }
  .md\\:-my-1\\/5 {
    margin-top: -20%;
    margin-bottom: -20%;
  }
  .md\\:-mx-1\\/5 {
    margin-left: -20%;
    margin-right: -20%;
  }
  .md\\:-my-2\\/5 {
    margin-top: -40%;
    margin-bottom: -40%;
  }
  .md\\:-mx-2\\/5 {
    margin-left: -40%;
    margin-right: -40%;
  }
  .md\\:-my-3\\/5 {
    margin-top: -60%;
    margin-bottom: -60%;
  }
  .md\\:-mx-3\\/5 {
    margin-left: -60%;
    margin-right: -60%;
  }
  .md\\:-my-4\\/5 {
    margin-top: -80%;
    margin-bottom: -80%;
  }
  .md\\:-mx-4\\/5 {
    margin-left: -80%;
    margin-right: -80%;
  }
  .md\\:-my-1\\/6 {
    margin-top: -16.66667%;
    margin-bottom: -16.66667%;
  }
  .md\\:-mx-1\\/6 {
    margin-left: -16.66667%;
    margin-right: -16.66667%;
  }
  .md\\:-my-2\\/6 {
    margin-top: -33.33333%;
    margin-bottom: -33.33333%;
  }
  .md\\:-mx-2\\/6 {
    margin-left: -33.33333%;
    margin-right: -33.33333%;
  }
  .md\\:-my-3\\/6 {
    margin-top: -50%;
    margin-bottom: -50%;
  }
  .md\\:-mx-3\\/6 {
    margin-left: -50%;
    margin-right: -50%;
  }
  .md\\:-my-4\\/6 {
    margin-top: -66.66667%;
    margin-bottom: -66.66667%;
  }
  .md\\:-mx-4\\/6 {
    margin-left: -66.66667%;
    margin-right: -66.66667%;
  }
  .md\\:-my-5\\/6 {
    margin-top: -83.33333%;
    margin-bottom: -83.33333%;
  }
  .md\\:-mx-5\\/6 {
    margin-left: -83.33333%;
    margin-right: -83.33333%;
  }
  .md\\:-my-1\\/12 {
    margin-top: -8.33333%;
    margin-bottom: -8.33333%;
  }
  .md\\:-mx-1\\/12 {
    margin-left: -8.33333%;
    margin-right: -8.33333%;
  }
  .md\\:-my-2\\/12 {
    margin-top: -16.66667%;
    margin-bottom: -16.66667%;
  }
  .md\\:-mx-2\\/12 {
    margin-left: -16.66667%;
    margin-right: -16.66667%;
  }
  .md\\:-my-3\\/12 {
    margin-top: -25%;
    margin-bottom: -25%;
  }
  .md\\:-mx-3\\/12 {
    margin-left: -25%;
    margin-right: -25%;
  }
  .md\\:-my-4\\/12 {
    margin-top: -33.33333%;
    margin-bottom: -33.33333%;
  }
  .md\\:-mx-4\\/12 {
    margin-left: -33.33333%;
    margin-right: -33.33333%;
  }
  .md\\:-my-5\\/12 {
    margin-top: -41.66667%;
    margin-bottom: -41.66667%;
  }
  .md\\:-mx-5\\/12 {
    margin-left: -41.66667%;
    margin-right: -41.66667%;
  }
  .md\\:-my-6\\/12 {
    margin-top: -50%;
    margin-bottom: -50%;
  }
  .md\\:-mx-6\\/12 {
    margin-left: -50%;
    margin-right: -50%;
  }
  .md\\:-my-7\\/12 {
    margin-top: -58.33333%;
    margin-bottom: -58.33333%;
  }
  .md\\:-mx-7\\/12 {
    margin-left: -58.33333%;
    margin-right: -58.33333%;
  }
  .md\\:-my-8\\/12 {
    margin-top: -66.66667%;
    margin-bottom: -66.66667%;
  }
  .md\\:-mx-8\\/12 {
    margin-left: -66.66667%;
    margin-right: -66.66667%;
  }
  .md\\:-my-9\\/12 {
    margin-top: -75%;
    margin-bottom: -75%;
  }
  .md\\:-mx-9\\/12 {
    margin-left: -75%;
    margin-right: -75%;
  }
  .md\\:-my-10\\/12 {
    margin-top: -83.33333%;
    margin-bottom: -83.33333%;
  }
  .md\\:-mx-10\\/12 {
    margin-left: -83.33333%;
    margin-right: -83.33333%;
  }
  .md\\:-my-11\\/12 {
    margin-top: -91.66667%;
    margin-bottom: -91.66667%;
  }
  .md\\:-mx-11\\/12 {
    margin-left: -91.66667%;
    margin-right: -91.66667%;
  }
  .md\\:-my-full {
    margin-top: -100%;
    margin-bottom: -100%;
  }
  .md\\:-mx-full {
    margin-left: -100%;
    margin-right: -100%;
  }
  .md\\:mt-0 {
    margin-top: 0;
  }
  .md\\:mr-0 {
    margin-right: 0;
  }
  .md\\:mb-0 {
    margin-bottom: 0;
  }
  .md\\:ml-0 {
    margin-left: 0;
  }
  .md\\:mt-1 {
    margin-top: 0.25rem;
  }
  .md\\:mr-1 {
    margin-right: 0.25rem;
  }
  .md\\:mb-1 {
    margin-bottom: 0.25rem;
  }
  .md\\:ml-1 {
    margin-left: 0.25rem;
  }
  .md\\:mt-2 {
    margin-top: 0.5rem;
  }
  .md\\:mr-2 {
    margin-right: 0.5rem;
  }
  .md\\:mb-2 {
    margin-bottom: 0.5rem;
  }
  .md\\:ml-2 {
    margin-left: 0.5rem;
  }
  .md\\:mt-3 {
    margin-top: 0.75rem;
  }
  .md\\:mr-3 {
    margin-right: 0.75rem;
  }
  .md\\:mb-3 {
    margin-bottom: 0.75rem;
  }
  .md\\:ml-3 {
    margin-left: 0.75rem;
  }
  .md\\:mt-4 {
    margin-top: 1rem;
  }
  .md\\:mr-4 {
    margin-right: 1rem;
  }
  .md\\:mb-4 {
    margin-bottom: 1rem;
  }
  .md\\:ml-4 {
    margin-left: 1rem;
  }
  .md\\:mt-5 {
    margin-top: 1.25rem;
  }
  .md\\:mr-5 {
    margin-right: 1.25rem;
  }
  .md\\:mb-5 {
    margin-bottom: 1.25rem;
  }
  .md\\:ml-5 {
    margin-left: 1.25rem;
  }
  .md\\:mt-6 {
    margin-top: 1.5rem;
  }
  .md\\:mr-6 {
    margin-right: 1.5rem;
  }
  .md\\:mb-6 {
    margin-bottom: 1.5rem;
  }
  .md\\:ml-6 {
    margin-left: 1.5rem;
  }
  .md\\:mt-7 {
    margin-top: 1.75rem;
  }
  .md\\:mr-7 {
    margin-right: 1.75rem;
  }
  .md\\:mb-7 {
    margin-bottom: 1.75rem;
  }
  .md\\:ml-7 {
    margin-left: 1.75rem;
  }
  .md\\:mt-8 {
    margin-top: 2rem;
  }
  .md\\:mr-8 {
    margin-right: 2rem;
  }
  .md\\:mb-8 {
    margin-bottom: 2rem;
  }
  .md\\:ml-8 {
    margin-left: 2rem;
  }
  .md\\:mt-9 {
    margin-top: 2.25rem;
  }
  .md\\:mr-9 {
    margin-right: 2.25rem;
  }
  .md\\:mb-9 {
    margin-bottom: 2.25rem;
  }
  .md\\:ml-9 {
    margin-left: 2.25rem;
  }
  .md\\:mt-10 {
    margin-top: 2.5rem;
  }
  .md\\:mr-10 {
    margin-right: 2.5rem;
  }
  .md\\:mb-10 {
    margin-bottom: 2.5rem;
  }
  .md\\:ml-10 {
    margin-left: 2.5rem;
  }
  .md\\:mt-11 {
    margin-top: 2.75rem;
  }
  .md\\:mr-11 {
    margin-right: 2.75rem;
  }
  .md\\:mb-11 {
    margin-bottom: 2.75rem;
  }
  .md\\:ml-11 {
    margin-left: 2.75rem;
  }
  .md\\:mt-12 {
    margin-top: 3rem;
  }
  .md\\:mr-12 {
    margin-right: 3rem;
  }
  .md\\:mb-12 {
    margin-bottom: 3rem;
  }
  .md\\:ml-12 {
    margin-left: 3rem;
  }
  .md\\:mt-13 {
    margin-top: 3.25rem;
  }
  .md\\:mr-13 {
    margin-right: 3.25rem;
  }
  .md\\:mb-13 {
    margin-bottom: 3.25rem;
  }
  .md\\:ml-13 {
    margin-left: 3.25rem;
  }
  .md\\:mt-14 {
    margin-top: 3.5rem;
  }
  .md\\:mr-14 {
    margin-right: 3.5rem;
  }
  .md\\:mb-14 {
    margin-bottom: 3.5rem;
  }
  .md\\:ml-14 {
    margin-left: 3.5rem;
  }
  .md\\:mt-15 {
    margin-top: 3.75rem;
  }
  .md\\:mr-15 {
    margin-right: 3.75rem;
  }
  .md\\:mb-15 {
    margin-bottom: 3.75rem;
  }
  .md\\:ml-15 {
    margin-left: 3.75rem;
  }
  .md\\:mt-16 {
    margin-top: 4rem;
  }
  .md\\:mr-16 {
    margin-right: 4rem;
  }
  .md\\:mb-16 {
    margin-bottom: 4rem;
  }
  .md\\:ml-16 {
    margin-left: 4rem;
  }
  .md\\:mt-20 {
    margin-top: 5rem;
  }
  .md\\:mr-20 {
    margin-right: 5rem;
  }
  .md\\:mb-20 {
    margin-bottom: 5rem;
  }
  .md\\:ml-20 {
    margin-left: 5rem;
  }
  .md\\:mt-24 {
    margin-top: 6rem;
  }
  .md\\:mr-24 {
    margin-right: 6rem;
  }
  .md\\:mb-24 {
    margin-bottom: 6rem;
  }
  .md\\:ml-24 {
    margin-left: 6rem;
  }
  .md\\:mt-28 {
    margin-top: 7rem;
  }
  .md\\:mr-28 {
    margin-right: 7rem;
  }
  .md\\:mb-28 {
    margin-bottom: 7rem;
  }
  .md\\:ml-28 {
    margin-left: 7rem;
  }
  .md\\:mt-32 {
    margin-top: 8rem;
  }
  .md\\:mr-32 {
    margin-right: 8rem;
  }
  .md\\:mb-32 {
    margin-bottom: 8rem;
  }
  .md\\:ml-32 {
    margin-left: 8rem;
  }
  .md\\:mt-36 {
    margin-top: 9rem;
  }
  .md\\:mr-36 {
    margin-right: 9rem;
  }
  .md\\:mb-36 {
    margin-bottom: 9rem;
  }
  .md\\:ml-36 {
    margin-left: 9rem;
  }
  .md\\:mt-40 {
    margin-top: 10rem;
  }
  .md\\:mr-40 {
    margin-right: 10rem;
  }
  .md\\:mb-40 {
    margin-bottom: 10rem;
  }
  .md\\:ml-40 {
    margin-left: 10rem;
  }
  .md\\:mt-44 {
    margin-top: 11rem;
  }
  .md\\:mr-44 {
    margin-right: 11rem;
  }
  .md\\:mb-44 {
    margin-bottom: 11rem;
  }
  .md\\:ml-44 {
    margin-left: 11rem;
  }
  .md\\:mt-48 {
    margin-top: 12rem;
  }
  .md\\:mr-48 {
    margin-right: 12rem;
  }
  .md\\:mb-48 {
    margin-bottom: 12rem;
  }
  .md\\:ml-48 {
    margin-left: 12rem;
  }
  .md\\:mt-52 {
    margin-top: 13rem;
  }
  .md\\:mr-52 {
    margin-right: 13rem;
  }
  .md\\:mb-52 {
    margin-bottom: 13rem;
  }
  .md\\:ml-52 {
    margin-left: 13rem;
  }
  .md\\:mt-56 {
    margin-top: 14rem;
  }
  .md\\:mr-56 {
    margin-right: 14rem;
  }
  .md\\:mb-56 {
    margin-bottom: 14rem;
  }
  .md\\:ml-56 {
    margin-left: 14rem;
  }
  .md\\:mt-60 {
    margin-top: 15rem;
  }
  .md\\:mr-60 {
    margin-right: 15rem;
  }
  .md\\:mb-60 {
    margin-bottom: 15rem;
  }
  .md\\:ml-60 {
    margin-left: 15rem;
  }
  .md\\:mt-64 {
    margin-top: 16rem;
  }
  .md\\:mr-64 {
    margin-right: 16rem;
  }
  .md\\:mb-64 {
    margin-bottom: 16rem;
  }
  .md\\:ml-64 {
    margin-left: 16rem;
  }
  .md\\:mt-72 {
    margin-top: 18rem;
  }
  .md\\:mr-72 {
    margin-right: 18rem;
  }
  .md\\:mb-72 {
    margin-bottom: 18rem;
  }
  .md\\:ml-72 {
    margin-left: 18rem;
  }
  .md\\:mt-80 {
    margin-top: 20rem;
  }
  .md\\:mr-80 {
    margin-right: 20rem;
  }
  .md\\:mb-80 {
    margin-bottom: 20rem;
  }
  .md\\:ml-80 {
    margin-left: 20rem;
  }
  .md\\:mt-96 {
    margin-top: 24rem;
  }
  .md\\:mr-96 {
    margin-right: 24rem;
  }
  .md\\:mb-96 {
    margin-bottom: 24rem;
  }
  .md\\:ml-96 {
    margin-left: 24rem;
  }
  .md\\:mt-auto {
    margin-top: auto;
  }
  .md\\:mr-auto {
    margin-right: auto;
  }
  .md\\:mb-auto {
    margin-bottom: auto;
  }
  .md\\:ml-auto {
    margin-left: auto;
  }
  .md\\:mt-px {
    margin-top: 1px;
  }
  .md\\:mr-px {
    margin-right: 1px;
  }
  .md\\:mb-px {
    margin-bottom: 1px;
  }
  .md\\:ml-px {
    margin-left: 1px;
  }
  .md\\:mt-0\\.5 {
    margin-top: 0.125rem;
  }
  .md\\:mr-0\\.5 {
    margin-right: 0.125rem;
  }
  .md\\:mb-0\\.5 {
    margin-bottom: 0.125rem;
  }
  .md\\:ml-0\\.5 {
    margin-left: 0.125rem;
  }
  .md\\:mt-1\\.5 {
    margin-top: 0.375rem;
  }
  .md\\:mr-1\\.5 {
    margin-right: 0.375rem;
  }
  .md\\:mb-1\\.5 {
    margin-bottom: 0.375rem;
  }
  .md\\:ml-1\\.5 {
    margin-left: 0.375rem;
  }
  .md\\:mt-2\\.5 {
    margin-top: 0.625rem;
  }
  .md\\:mr-2\\.5 {
    margin-right: 0.625rem;
  }
  .md\\:mb-2\\.5 {
    margin-bottom: 0.625rem;
  }
  .md\\:ml-2\\.5 {
    margin-left: 0.625rem;
  }
  .md\\:mt-3\\.5 {
    margin-top: 0.875rem;
  }
  .md\\:mr-3\\.5 {
    margin-right: 0.875rem;
  }
  .md\\:mb-3\\.5 {
    margin-bottom: 0.875rem;
  }
  .md\\:ml-3\\.5 {
    margin-left: 0.875rem;
  }
  .md\\:mt-1\\/2 {
    margin-top: 50%;
  }
  .md\\:mr-1\\/2 {
    margin-right: 50%;
  }
  .md\\:mb-1\\/2 {
    margin-bottom: 50%;
  }
  .md\\:ml-1\\/2 {
    margin-left: 50%;
  }
  .md\\:mt-1\\/3 {
    margin-top: 33.333333%;
  }
  .md\\:mr-1\\/3 {
    margin-right: 33.333333%;
  }
  .md\\:mb-1\\/3 {
    margin-bottom: 33.333333%;
  }
  .md\\:ml-1\\/3 {
    margin-left: 33.333333%;
  }
  .md\\:mt-2\\/3 {
    margin-top: 66.666667%;
  }
  .md\\:mr-2\\/3 {
    margin-right: 66.666667%;
  }
  .md\\:mb-2\\/3 {
    margin-bottom: 66.666667%;
  }
  .md\\:ml-2\\/3 {
    margin-left: 66.666667%;
  }
  .md\\:mt-1\\/4 {
    margin-top: 25%;
  }
  .md\\:mr-1\\/4 {
    margin-right: 25%;
  }
  .md\\:mb-1\\/4 {
    margin-bottom: 25%;
  }
  .md\\:ml-1\\/4 {
    margin-left: 25%;
  }
  .md\\:mt-2\\/4 {
    margin-top: 50%;
  }
  .md\\:mr-2\\/4 {
    margin-right: 50%;
  }
  .md\\:mb-2\\/4 {
    margin-bottom: 50%;
  }
  .md\\:ml-2\\/4 {
    margin-left: 50%;
  }
  .md\\:mt-3\\/4 {
    margin-top: 75%;
  }
  .md\\:mr-3\\/4 {
    margin-right: 75%;
  }
  .md\\:mb-3\\/4 {
    margin-bottom: 75%;
  }
  .md\\:ml-3\\/4 {
    margin-left: 75%;
  }
  .md\\:mt-1\\/5 {
    margin-top: 20%;
  }
  .md\\:mr-1\\/5 {
    margin-right: 20%;
  }
  .md\\:mb-1\\/5 {
    margin-bottom: 20%;
  }
  .md\\:ml-1\\/5 {
    margin-left: 20%;
  }
  .md\\:mt-2\\/5 {
    margin-top: 40%;
  }
  .md\\:mr-2\\/5 {
    margin-right: 40%;
  }
  .md\\:mb-2\\/5 {
    margin-bottom: 40%;
  }
  .md\\:ml-2\\/5 {
    margin-left: 40%;
  }
  .md\\:mt-3\\/5 {
    margin-top: 60%;
  }
  .md\\:mr-3\\/5 {
    margin-right: 60%;
  }
  .md\\:mb-3\\/5 {
    margin-bottom: 60%;
  }
  .md\\:ml-3\\/5 {
    margin-left: 60%;
  }
  .md\\:mt-4\\/5 {
    margin-top: 80%;
  }
  .md\\:mr-4\\/5 {
    margin-right: 80%;
  }
  .md\\:mb-4\\/5 {
    margin-bottom: 80%;
  }
  .md\\:ml-4\\/5 {
    margin-left: 80%;
  }
  .md\\:mt-1\\/6 {
    margin-top: 16.666667%;
  }
  .md\\:mr-1\\/6 {
    margin-right: 16.666667%;
  }
  .md\\:mb-1\\/6 {
    margin-bottom: 16.666667%;
  }
  .md\\:ml-1\\/6 {
    margin-left: 16.666667%;
  }
  .md\\:mt-2\\/6 {
    margin-top: 33.333333%;
  }
  .md\\:mr-2\\/6 {
    margin-right: 33.333333%;
  }
  .md\\:mb-2\\/6 {
    margin-bottom: 33.333333%;
  }
  .md\\:ml-2\\/6 {
    margin-left: 33.333333%;
  }
  .md\\:mt-3\\/6 {
    margin-top: 50%;
  }
  .md\\:mr-3\\/6 {
    margin-right: 50%;
  }
  .md\\:mb-3\\/6 {
    margin-bottom: 50%;
  }
  .md\\:ml-3\\/6 {
    margin-left: 50%;
  }
  .md\\:mt-4\\/6 {
    margin-top: 66.666667%;
  }
  .md\\:mr-4\\/6 {
    margin-right: 66.666667%;
  }
  .md\\:mb-4\\/6 {
    margin-bottom: 66.666667%;
  }
  .md\\:ml-4\\/6 {
    margin-left: 66.666667%;
  }
  .md\\:mt-5\\/6 {
    margin-top: 83.333333%;
  }
  .md\\:mr-5\\/6 {
    margin-right: 83.333333%;
  }
  .md\\:mb-5\\/6 {
    margin-bottom: 83.333333%;
  }
  .md\\:ml-5\\/6 {
    margin-left: 83.333333%;
  }
  .md\\:mt-1\\/12 {
    margin-top: 8.333333%;
  }
  .md\\:mr-1\\/12 {
    margin-right: 8.333333%;
  }
  .md\\:mb-1\\/12 {
    margin-bottom: 8.333333%;
  }
  .md\\:ml-1\\/12 {
    margin-left: 8.333333%;
  }
  .md\\:mt-2\\/12 {
    margin-top: 16.666667%;
  }
  .md\\:mr-2\\/12 {
    margin-right: 16.666667%;
  }
  .md\\:mb-2\\/12 {
    margin-bottom: 16.666667%;
  }
  .md\\:ml-2\\/12 {
    margin-left: 16.666667%;
  }
  .md\\:mt-3\\/12 {
    margin-top: 25%;
  }
  .md\\:mr-3\\/12 {
    margin-right: 25%;
  }
  .md\\:mb-3\\/12 {
    margin-bottom: 25%;
  }
  .md\\:ml-3\\/12 {
    margin-left: 25%;
  }
  .md\\:mt-4\\/12 {
    margin-top: 33.333333%;
  }
  .md\\:mr-4\\/12 {
    margin-right: 33.333333%;
  }
  .md\\:mb-4\\/12 {
    margin-bottom: 33.333333%;
  }
  .md\\:ml-4\\/12 {
    margin-left: 33.333333%;
  }
  .md\\:mt-5\\/12 {
    margin-top: 41.666667%;
  }
  .md\\:mr-5\\/12 {
    margin-right: 41.666667%;
  }
  .md\\:mb-5\\/12 {
    margin-bottom: 41.666667%;
  }
  .md\\:ml-5\\/12 {
    margin-left: 41.666667%;
  }
  .md\\:mt-6\\/12 {
    margin-top: 50%;
  }
  .md\\:mr-6\\/12 {
    margin-right: 50%;
  }
  .md\\:mb-6\\/12 {
    margin-bottom: 50%;
  }
  .md\\:ml-6\\/12 {
    margin-left: 50%;
  }
  .md\\:mt-7\\/12 {
    margin-top: 58.333333%;
  }
  .md\\:mr-7\\/12 {
    margin-right: 58.333333%;
  }
  .md\\:mb-7\\/12 {
    margin-bottom: 58.333333%;
  }
  .md\\:ml-7\\/12 {
    margin-left: 58.333333%;
  }
  .md\\:mt-8\\/12 {
    margin-top: 66.666667%;
  }
  .md\\:mr-8\\/12 {
    margin-right: 66.666667%;
  }
  .md\\:mb-8\\/12 {
    margin-bottom: 66.666667%;
  }
  .md\\:ml-8\\/12 {
    margin-left: 66.666667%;
  }
  .md\\:mt-9\\/12 {
    margin-top: 75%;
  }
  .md\\:mr-9\\/12 {
    margin-right: 75%;
  }
  .md\\:mb-9\\/12 {
    margin-bottom: 75%;
  }
  .md\\:ml-9\\/12 {
    margin-left: 75%;
  }
  .md\\:mt-10\\/12 {
    margin-top: 83.333333%;
  }
  .md\\:mr-10\\/12 {
    margin-right: 83.333333%;
  }
  .md\\:mb-10\\/12 {
    margin-bottom: 83.333333%;
  }
  .md\\:ml-10\\/12 {
    margin-left: 83.333333%;
  }
  .md\\:mt-11\\/12 {
    margin-top: 91.666667%;
  }
  .md\\:mr-11\\/12 {
    margin-right: 91.666667%;
  }
  .md\\:mb-11\\/12 {
    margin-bottom: 91.666667%;
  }
  .md\\:ml-11\\/12 {
    margin-left: 91.666667%;
  }
  .md\\:mt-full {
    margin-top: 100%;
  }
  .md\\:mr-full {
    margin-right: 100%;
  }
  .md\\:mb-full {
    margin-bottom: 100%;
  }
  .md\\:ml-full {
    margin-left: 100%;
  }
  .md\\:-mt-1 {
    margin-top: -0.25rem;
  }
  .md\\:-mr-1 {
    margin-right: -0.25rem;
  }
  .md\\:-mb-1 {
    margin-bottom: -0.25rem;
  }
  .md\\:-ml-1 {
    margin-left: -0.25rem;
  }
  .md\\:-mt-2 {
    margin-top: -0.5rem;
  }
  .md\\:-mr-2 {
    margin-right: -0.5rem;
  }
  .md\\:-mb-2 {
    margin-bottom: -0.5rem;
  }
  .md\\:-ml-2 {
    margin-left: -0.5rem;
  }
  .md\\:-mt-3 {
    margin-top: -0.75rem;
  }
  .md\\:-mr-3 {
    margin-right: -0.75rem;
  }
  .md\\:-mb-3 {
    margin-bottom: -0.75rem;
  }
  .md\\:-ml-3 {
    margin-left: -0.75rem;
  }
  .md\\:-mt-4 {
    margin-top: -1rem;
  }
  .md\\:-mr-4 {
    margin-right: -1rem;
  }
  .md\\:-mb-4 {
    margin-bottom: -1rem;
  }
  .md\\:-ml-4 {
    margin-left: -1rem;
  }
  .md\\:-mt-5 {
    margin-top: -1.25rem;
  }
  .md\\:-mr-5 {
    margin-right: -1.25rem;
  }
  .md\\:-mb-5 {
    margin-bottom: -1.25rem;
  }
  .md\\:-ml-5 {
    margin-left: -1.25rem;
  }
  .md\\:-mt-6 {
    margin-top: -1.5rem;
  }
  .md\\:-mr-6 {
    margin-right: -1.5rem;
  }
  .md\\:-mb-6 {
    margin-bottom: -1.5rem;
  }
  .md\\:-ml-6 {
    margin-left: -1.5rem;
  }
  .md\\:-mt-7 {
    margin-top: -1.75rem;
  }
  .md\\:-mr-7 {
    margin-right: -1.75rem;
  }
  .md\\:-mb-7 {
    margin-bottom: -1.75rem;
  }
  .md\\:-ml-7 {
    margin-left: -1.75rem;
  }
  .md\\:-mt-8 {
    margin-top: -2rem;
  }
  .md\\:-mr-8 {
    margin-right: -2rem;
  }
  .md\\:-mb-8 {
    margin-bottom: -2rem;
  }
  .md\\:-ml-8 {
    margin-left: -2rem;
  }
  .md\\:-mt-9 {
    margin-top: -2.25rem;
  }
  .md\\:-mr-9 {
    margin-right: -2.25rem;
  }
  .md\\:-mb-9 {
    margin-bottom: -2.25rem;
  }
  .md\\:-ml-9 {
    margin-left: -2.25rem;
  }
  .md\\:-mt-10 {
    margin-top: -2.5rem;
  }
  .md\\:-mr-10 {
    margin-right: -2.5rem;
  }
  .md\\:-mb-10 {
    margin-bottom: -2.5rem;
  }
  .md\\:-ml-10 {
    margin-left: -2.5rem;
  }
  .md\\:-mt-11 {
    margin-top: -2.75rem;
  }
  .md\\:-mr-11 {
    margin-right: -2.75rem;
  }
  .md\\:-mb-11 {
    margin-bottom: -2.75rem;
  }
  .md\\:-ml-11 {
    margin-left: -2.75rem;
  }
  .md\\:-mt-12 {
    margin-top: -3rem;
  }
  .md\\:-mr-12 {
    margin-right: -3rem;
  }
  .md\\:-mb-12 {
    margin-bottom: -3rem;
  }
  .md\\:-ml-12 {
    margin-left: -3rem;
  }
  .md\\:-mt-13 {
    margin-top: -3.25rem;
  }
  .md\\:-mr-13 {
    margin-right: -3.25rem;
  }
  .md\\:-mb-13 {
    margin-bottom: -3.25rem;
  }
  .md\\:-ml-13 {
    margin-left: -3.25rem;
  }
  .md\\:-mt-14 {
    margin-top: -3.5rem;
  }
  .md\\:-mr-14 {
    margin-right: -3.5rem;
  }
  .md\\:-mb-14 {
    margin-bottom: -3.5rem;
  }
  .md\\:-ml-14 {
    margin-left: -3.5rem;
  }
  .md\\:-mt-15 {
    margin-top: -3.75rem;
  }
  .md\\:-mr-15 {
    margin-right: -3.75rem;
  }
  .md\\:-mb-15 {
    margin-bottom: -3.75rem;
  }
  .md\\:-ml-15 {
    margin-left: -3.75rem;
  }
  .md\\:-mt-16 {
    margin-top: -4rem;
  }
  .md\\:-mr-16 {
    margin-right: -4rem;
  }
  .md\\:-mb-16 {
    margin-bottom: -4rem;
  }
  .md\\:-ml-16 {
    margin-left: -4rem;
  }
  .md\\:-mt-20 {
    margin-top: -5rem;
  }
  .md\\:-mr-20 {
    margin-right: -5rem;
  }
  .md\\:-mb-20 {
    margin-bottom: -5rem;
  }
  .md\\:-ml-20 {
    margin-left: -5rem;
  }
  .md\\:-mt-24 {
    margin-top: -6rem;
  }
  .md\\:-mr-24 {
    margin-right: -6rem;
  }
  .md\\:-mb-24 {
    margin-bottom: -6rem;
  }
  .md\\:-ml-24 {
    margin-left: -6rem;
  }
  .md\\:-mt-28 {
    margin-top: -7rem;
  }
  .md\\:-mr-28 {
    margin-right: -7rem;
  }
  .md\\:-mb-28 {
    margin-bottom: -7rem;
  }
  .md\\:-ml-28 {
    margin-left: -7rem;
  }
  .md\\:-mt-32 {
    margin-top: -8rem;
  }
  .md\\:-mr-32 {
    margin-right: -8rem;
  }
  .md\\:-mb-32 {
    margin-bottom: -8rem;
  }
  .md\\:-ml-32 {
    margin-left: -8rem;
  }
  .md\\:-mt-36 {
    margin-top: -9rem;
  }
  .md\\:-mr-36 {
    margin-right: -9rem;
  }
  .md\\:-mb-36 {
    margin-bottom: -9rem;
  }
  .md\\:-ml-36 {
    margin-left: -9rem;
  }
  .md\\:-mt-40 {
    margin-top: -10rem;
  }
  .md\\:-mr-40 {
    margin-right: -10rem;
  }
  .md\\:-mb-40 {
    margin-bottom: -10rem;
  }
  .md\\:-ml-40 {
    margin-left: -10rem;
  }
  .md\\:-mt-44 {
    margin-top: -11rem;
  }
  .md\\:-mr-44 {
    margin-right: -11rem;
  }
  .md\\:-mb-44 {
    margin-bottom: -11rem;
  }
  .md\\:-ml-44 {
    margin-left: -11rem;
  }
  .md\\:-mt-48 {
    margin-top: -12rem;
  }
  .md\\:-mr-48 {
    margin-right: -12rem;
  }
  .md\\:-mb-48 {
    margin-bottom: -12rem;
  }
  .md\\:-ml-48 {
    margin-left: -12rem;
  }
  .md\\:-mt-52 {
    margin-top: -13rem;
  }
  .md\\:-mr-52 {
    margin-right: -13rem;
  }
  .md\\:-mb-52 {
    margin-bottom: -13rem;
  }
  .md\\:-ml-52 {
    margin-left: -13rem;
  }
  .md\\:-mt-56 {
    margin-top: -14rem;
  }
  .md\\:-mr-56 {
    margin-right: -14rem;
  }
  .md\\:-mb-56 {
    margin-bottom: -14rem;
  }
  .md\\:-ml-56 {
    margin-left: -14rem;
  }
  .md\\:-mt-60 {
    margin-top: -15rem;
  }
  .md\\:-mr-60 {
    margin-right: -15rem;
  }
  .md\\:-mb-60 {
    margin-bottom: -15rem;
  }
  .md\\:-ml-60 {
    margin-left: -15rem;
  }
  .md\\:-mt-64 {
    margin-top: -16rem;
  }
  .md\\:-mr-64 {
    margin-right: -16rem;
  }
  .md\\:-mb-64 {
    margin-bottom: -16rem;
  }
  .md\\:-ml-64 {
    margin-left: -16rem;
  }
  .md\\:-mt-72 {
    margin-top: -18rem;
  }
  .md\\:-mr-72 {
    margin-right: -18rem;
  }
  .md\\:-mb-72 {
    margin-bottom: -18rem;
  }
  .md\\:-ml-72 {
    margin-left: -18rem;
  }
  .md\\:-mt-80 {
    margin-top: -20rem;
  }
  .md\\:-mr-80 {
    margin-right: -20rem;
  }
  .md\\:-mb-80 {
    margin-bottom: -20rem;
  }
  .md\\:-ml-80 {
    margin-left: -20rem;
  }
  .md\\:-mt-96 {
    margin-top: -24rem;
  }
  .md\\:-mr-96 {
    margin-right: -24rem;
  }
  .md\\:-mb-96 {
    margin-bottom: -24rem;
  }
  .md\\:-ml-96 {
    margin-left: -24rem;
  }
  .md\\:-mt-px {
    margin-top: -1px;
  }
  .md\\:-mr-px {
    margin-right: -1px;
  }
  .md\\:-mb-px {
    margin-bottom: -1px;
  }
  .md\\:-ml-px {
    margin-left: -1px;
  }
  .md\\:-mt-0\\.5 {
    margin-top: -0.125rem;
  }
  .md\\:-mr-0\\.5 {
    margin-right: -0.125rem;
  }
  .md\\:-mb-0\\.5 {
    margin-bottom: -0.125rem;
  }
  .md\\:-ml-0\\.5 {
    margin-left: -0.125rem;
  }
  .md\\:-mt-1\\.5 {
    margin-top: -0.375rem;
  }
  .md\\:-mr-1\\.5 {
    margin-right: -0.375rem;
  }
  .md\\:-mb-1\\.5 {
    margin-bottom: -0.375rem;
  }
  .md\\:-ml-1\\.5 {
    margin-left: -0.375rem;
  }
  .md\\:-mt-2\\.5 {
    margin-top: -0.625rem;
  }
  .md\\:-mr-2\\.5 {
    margin-right: -0.625rem;
  }
  .md\\:-mb-2\\.5 {
    margin-bottom: -0.625rem;
  }
  .md\\:-ml-2\\.5 {
    margin-left: -0.625rem;
  }
  .md\\:-mt-3\\.5 {
    margin-top: -0.875rem;
  }
  .md\\:-mr-3\\.5 {
    margin-right: -0.875rem;
  }
  .md\\:-mb-3\\.5 {
    margin-bottom: -0.875rem;
  }
  .md\\:-ml-3\\.5 {
    margin-left: -0.875rem;
  }
  .md\\:-mt-1\\/2 {
    margin-top: -50%;
  }
  .md\\:-mr-1\\/2 {
    margin-right: -50%;
  }
  .md\\:-mb-1\\/2 {
    margin-bottom: -50%;
  }
  .md\\:-ml-1\\/2 {
    margin-left: -50%;
  }
  .md\\:-mt-1\\/3 {
    margin-top: -33.33333%;
  }
  .md\\:-mr-1\\/3 {
    margin-right: -33.33333%;
  }
  .md\\:-mb-1\\/3 {
    margin-bottom: -33.33333%;
  }
  .md\\:-ml-1\\/3 {
    margin-left: -33.33333%;
  }
  .md\\:-mt-2\\/3 {
    margin-top: -66.66667%;
  }
  .md\\:-mr-2\\/3 {
    margin-right: -66.66667%;
  }
  .md\\:-mb-2\\/3 {
    margin-bottom: -66.66667%;
  }
  .md\\:-ml-2\\/3 {
    margin-left: -66.66667%;
  }
  .md\\:-mt-1\\/4 {
    margin-top: -25%;
  }
  .md\\:-mr-1\\/4 {
    margin-right: -25%;
  }
  .md\\:-mb-1\\/4 {
    margin-bottom: -25%;
  }
  .md\\:-ml-1\\/4 {
    margin-left: -25%;
  }
  .md\\:-mt-2\\/4 {
    margin-top: -50%;
  }
  .md\\:-mr-2\\/4 {
    margin-right: -50%;
  }
  .md\\:-mb-2\\/4 {
    margin-bottom: -50%;
  }
  .md\\:-ml-2\\/4 {
    margin-left: -50%;
  }
  .md\\:-mt-3\\/4 {
    margin-top: -75%;
  }
  .md\\:-mr-3\\/4 {
    margin-right: -75%;
  }
  .md\\:-mb-3\\/4 {
    margin-bottom: -75%;
  }
  .md\\:-ml-3\\/4 {
    margin-left: -75%;
  }
  .md\\:-mt-1\\/5 {
    margin-top: -20%;
  }
  .md\\:-mr-1\\/5 {
    margin-right: -20%;
  }
  .md\\:-mb-1\\/5 {
    margin-bottom: -20%;
  }
  .md\\:-ml-1\\/5 {
    margin-left: -20%;
  }
  .md\\:-mt-2\\/5 {
    margin-top: -40%;
  }
  .md\\:-mr-2\\/5 {
    margin-right: -40%;
  }
  .md\\:-mb-2\\/5 {
    margin-bottom: -40%;
  }
  .md\\:-ml-2\\/5 {
    margin-left: -40%;
  }
  .md\\:-mt-3\\/5 {
    margin-top: -60%;
  }
  .md\\:-mr-3\\/5 {
    margin-right: -60%;
  }
  .md\\:-mb-3\\/5 {
    margin-bottom: -60%;
  }
  .md\\:-ml-3\\/5 {
    margin-left: -60%;
  }
  .md\\:-mt-4\\/5 {
    margin-top: -80%;
  }
  .md\\:-mr-4\\/5 {
    margin-right: -80%;
  }
  .md\\:-mb-4\\/5 {
    margin-bottom: -80%;
  }
  .md\\:-ml-4\\/5 {
    margin-left: -80%;
  }
  .md\\:-mt-1\\/6 {
    margin-top: -16.66667%;
  }
  .md\\:-mr-1\\/6 {
    margin-right: -16.66667%;
  }
  .md\\:-mb-1\\/6 {
    margin-bottom: -16.66667%;
  }
  .md\\:-ml-1\\/6 {
    margin-left: -16.66667%;
  }
  .md\\:-mt-2\\/6 {
    margin-top: -33.33333%;
  }
  .md\\:-mr-2\\/6 {
    margin-right: -33.33333%;
  }
  .md\\:-mb-2\\/6 {
    margin-bottom: -33.33333%;
  }
  .md\\:-ml-2\\/6 {
    margin-left: -33.33333%;
  }
  .md\\:-mt-3\\/6 {
    margin-top: -50%;
  }
  .md\\:-mr-3\\/6 {
    margin-right: -50%;
  }
  .md\\:-mb-3\\/6 {
    margin-bottom: -50%;
  }
  .md\\:-ml-3\\/6 {
    margin-left: -50%;
  }
  .md\\:-mt-4\\/6 {
    margin-top: -66.66667%;
  }
  .md\\:-mr-4\\/6 {
    margin-right: -66.66667%;
  }
  .md\\:-mb-4\\/6 {
    margin-bottom: -66.66667%;
  }
  .md\\:-ml-4\\/6 {
    margin-left: -66.66667%;
  }
  .md\\:-mt-5\\/6 {
    margin-top: -83.33333%;
  }
  .md\\:-mr-5\\/6 {
    margin-right: -83.33333%;
  }
  .md\\:-mb-5\\/6 {
    margin-bottom: -83.33333%;
  }
  .md\\:-ml-5\\/6 {
    margin-left: -83.33333%;
  }
  .md\\:-mt-1\\/12 {
    margin-top: -8.33333%;
  }
  .md\\:-mr-1\\/12 {
    margin-right: -8.33333%;
  }
  .md\\:-mb-1\\/12 {
    margin-bottom: -8.33333%;
  }
  .md\\:-ml-1\\/12 {
    margin-left: -8.33333%;
  }
  .md\\:-mt-2\\/12 {
    margin-top: -16.66667%;
  }
  .md\\:-mr-2\\/12 {
    margin-right: -16.66667%;
  }
  .md\\:-mb-2\\/12 {
    margin-bottom: -16.66667%;
  }
  .md\\:-ml-2\\/12 {
    margin-left: -16.66667%;
  }
  .md\\:-mt-3\\/12 {
    margin-top: -25%;
  }
  .md\\:-mr-3\\/12 {
    margin-right: -25%;
  }
  .md\\:-mb-3\\/12 {
    margin-bottom: -25%;
  }
  .md\\:-ml-3\\/12 {
    margin-left: -25%;
  }
  .md\\:-mt-4\\/12 {
    margin-top: -33.33333%;
  }
  .md\\:-mr-4\\/12 {
    margin-right: -33.33333%;
  }
  .md\\:-mb-4\\/12 {
    margin-bottom: -33.33333%;
  }
  .md\\:-ml-4\\/12 {
    margin-left: -33.33333%;
  }
  .md\\:-mt-5\\/12 {
    margin-top: -41.66667%;
  }
  .md\\:-mr-5\\/12 {
    margin-right: -41.66667%;
  }
  .md\\:-mb-5\\/12 {
    margin-bottom: -41.66667%;
  }
  .md\\:-ml-5\\/12 {
    margin-left: -41.66667%;
  }
  .md\\:-mt-6\\/12 {
    margin-top: -50%;
  }
  .md\\:-mr-6\\/12 {
    margin-right: -50%;
  }
  .md\\:-mb-6\\/12 {
    margin-bottom: -50%;
  }
  .md\\:-ml-6\\/12 {
    margin-left: -50%;
  }
  .md\\:-mt-7\\/12 {
    margin-top: -58.33333%;
  }
  .md\\:-mr-7\\/12 {
    margin-right: -58.33333%;
  }
  .md\\:-mb-7\\/12 {
    margin-bottom: -58.33333%;
  }
  .md\\:-ml-7\\/12 {
    margin-left: -58.33333%;
  }
  .md\\:-mt-8\\/12 {
    margin-top: -66.66667%;
  }
  .md\\:-mr-8\\/12 {
    margin-right: -66.66667%;
  }
  .md\\:-mb-8\\/12 {
    margin-bottom: -66.66667%;
  }
  .md\\:-ml-8\\/12 {
    margin-left: -66.66667%;
  }
  .md\\:-mt-9\\/12 {
    margin-top: -75%;
  }
  .md\\:-mr-9\\/12 {
    margin-right: -75%;
  }
  .md\\:-mb-9\\/12 {
    margin-bottom: -75%;
  }
  .md\\:-ml-9\\/12 {
    margin-left: -75%;
  }
  .md\\:-mt-10\\/12 {
    margin-top: -83.33333%;
  }
  .md\\:-mr-10\\/12 {
    margin-right: -83.33333%;
  }
  .md\\:-mb-10\\/12 {
    margin-bottom: -83.33333%;
  }
  .md\\:-ml-10\\/12 {
    margin-left: -83.33333%;
  }
  .md\\:-mt-11\\/12 {
    margin-top: -91.66667%;
  }
  .md\\:-mr-11\\/12 {
    margin-right: -91.66667%;
  }
  .md\\:-mb-11\\/12 {
    margin-bottom: -91.66667%;
  }
  .md\\:-ml-11\\/12 {
    margin-left: -91.66667%;
  }
  .md\\:-mt-full {
    margin-top: -100%;
  }
  .md\\:-mr-full {
    margin-right: -100%;
  }
  .md\\:-mb-full {
    margin-bottom: -100%;
  }
  .md\\:-ml-full {
    margin-left: -100%;
  }
  .md\\:max-h-0 {
    max-height: 0;
  }
  .md\\:max-h-1 {
    max-height: 0.25rem;
  }
  .md\\:max-h-2 {
    max-height: 0.5rem;
  }
  .md\\:max-h-3 {
    max-height: 0.75rem;
  }
  .md\\:max-h-4 {
    max-height: 1rem;
  }
  .md\\:max-h-5 {
    max-height: 1.25rem;
  }
  .md\\:max-h-6 {
    max-height: 1.5rem;
  }
  .md\\:max-h-7 {
    max-height: 1.75rem;
  }
  .md\\:max-h-8 {
    max-height: 2rem;
  }
  .md\\:max-h-9 {
    max-height: 2.25rem;
  }
  .md\\:max-h-10 {
    max-height: 2.5rem;
  }
  .md\\:max-h-11 {
    max-height: 2.75rem;
  }
  .md\\:max-h-12 {
    max-height: 3rem;
  }
  .md\\:max-h-13 {
    max-height: 3.25rem;
  }
  .md\\:max-h-14 {
    max-height: 3.5rem;
  }
  .md\\:max-h-15 {
    max-height: 3.75rem;
  }
  .md\\:max-h-16 {
    max-height: 4rem;
  }
  .md\\:max-h-20 {
    max-height: 5rem;
  }
  .md\\:max-h-24 {
    max-height: 6rem;
  }
  .md\\:max-h-28 {
    max-height: 7rem;
  }
  .md\\:max-h-32 {
    max-height: 8rem;
  }
  .md\\:max-h-36 {
    max-height: 9rem;
  }
  .md\\:max-h-40 {
    max-height: 10rem;
  }
  .md\\:max-h-44 {
    max-height: 11rem;
  }
  .md\\:max-h-48 {
    max-height: 12rem;
  }
  .md\\:max-h-52 {
    max-height: 13rem;
  }
  .md\\:max-h-56 {
    max-height: 14rem;
  }
  .md\\:max-h-60 {
    max-height: 15rem;
  }
  .md\\:max-h-64 {
    max-height: 16rem;
  }
  .md\\:max-h-72 {
    max-height: 18rem;
  }
  .md\\:max-h-80 {
    max-height: 20rem;
  }
  .md\\:max-h-96 {
    max-height: 24rem;
  }
  .md\\:max-h-screen {
    max-height: 100vh;
  }
  .md\\:max-h-px {
    max-height: 1px;
  }
  .md\\:max-h-0\\.5 {
    max-height: 0.125rem;
  }
  .md\\:max-h-1\\.5 {
    max-height: 0.375rem;
  }
  .md\\:max-h-2\\.5 {
    max-height: 0.625rem;
  }
  .md\\:max-h-3\\.5 {
    max-height: 0.875rem;
  }
  .md\\:max-h-1\\/2 {
    max-height: 50%;
  }
  .md\\:max-h-1\\/3 {
    max-height: 33.333333%;
  }
  .md\\:max-h-2\\/3 {
    max-height: 66.666667%;
  }
  .md\\:max-h-1\\/4 {
    max-height: 25%;
  }
  .md\\:max-h-2\\/4 {
    max-height: 50%;
  }
  .md\\:max-h-3\\/4 {
    max-height: 75%;
  }
  .md\\:max-h-1\\/5 {
    max-height: 20%;
  }
  .md\\:max-h-2\\/5 {
    max-height: 40%;
  }
  .md\\:max-h-3\\/5 {
    max-height: 60%;
  }
  .md\\:max-h-4\\/5 {
    max-height: 80%;
  }
  .md\\:max-h-1\\/6 {
    max-height: 16.666667%;
  }
  .md\\:max-h-2\\/6 {
    max-height: 33.333333%;
  }
  .md\\:max-h-3\\/6 {
    max-height: 50%;
  }
  .md\\:max-h-4\\/6 {
    max-height: 66.666667%;
  }
  .md\\:max-h-5\\/6 {
    max-height: 83.333333%;
  }
  .md\\:max-h-1\\/12 {
    max-height: 8.333333%;
  }
  .md\\:max-h-2\\/12 {
    max-height: 16.666667%;
  }
  .md\\:max-h-3\\/12 {
    max-height: 25%;
  }
  .md\\:max-h-4\\/12 {
    max-height: 33.333333%;
  }
  .md\\:max-h-5\\/12 {
    max-height: 41.666667%;
  }
  .md\\:max-h-6\\/12 {
    max-height: 50%;
  }
  .md\\:max-h-7\\/12 {
    max-height: 58.333333%;
  }
  .md\\:max-h-8\\/12 {
    max-height: 66.666667%;
  }
  .md\\:max-h-9\\/12 {
    max-height: 75%;
  }
  .md\\:max-h-10\\/12 {
    max-height: 83.333333%;
  }
  .md\\:max-h-11\\/12 {
    max-height: 91.666667%;
  }
  .md\\:max-h-full {
    max-height: 100%;
  }
  .md\\:max-w-0 {
    max-width: 0rem;
  }
  .md\\:max-w-none {
    max-width: none;
  }
  .md\\:max-w-xs {
    max-width: 20rem;
  }
  .md\\:max-w-sm {
    max-width: 24rem;
  }
  .md\\:max-w-md {
    max-width: 28rem;
  }
  .md\\:max-w-lg {
    max-width: 32rem;
  }
  .md\\:max-w-xl {
    max-width: 36rem;
  }
  .md\\:max-w-2xl {
    max-width: 42rem;
  }
  .md\\:max-w-3xl {
    max-width: 48rem;
  }
  .md\\:max-w-4xl {
    max-width: 56rem;
  }
  .md\\:max-w-5xl {
    max-width: 64rem;
  }
  .md\\:max-w-6xl {
    max-width: 72rem;
  }
  .md\\:max-w-7xl {
    max-width: 80rem;
  }
  .md\\:max-w-full {
    max-width: 100%;
  }
  .md\\:max-w-min-content {
    max-width: min-content;
  }
  .md\\:max-w-max-content {
    max-width: max-content;
  }
  .md\\:max-w-prose {
    max-width: 65ch;
  }
  .md\\:max-w-screen-sm {
    max-width: 640px;
  }
  .md\\:max-w-screen-md {
    max-width: 768px;
  }
  .md\\:max-w-screen-lg {
    max-width: 1024px;
  }
  .md\\:max-w-screen-xl {
    max-width: 1280px;
  }
  .md\\:min-h-0 {
    min-height: 0;
  }
  .md\\:min-h-full {
    min-height: 100%;
  }
  .md\\:min-h-screen {
    min-height: 100vh;
  }
  .md\\:min-w-0 {
    min-width: 0;
  }
  .md\\:min-w-full {
    min-width: 100%;
  }
  .md\\:min-w-min-content {
    min-width: min-content;
  }
  .md\\:min-w-max-content {
    min-width: max-content;
  }
  .md\\:object-contain {
    object-fit: contain;
  }
  .md\\:object-cover {
    object-fit: cover;
  }
  .md\\:object-fill {
    object-fit: fill;
  }
  .md\\:object-none {
    object-fit: none;
  }
  .md\\:object-scale-down {
    object-fit: scale-down;
  }
  .md\\:object-bottom {
    object-position: bottom;
  }
  .md\\:object-center {
    object-position: center;
  }
  .md\\:object-left {
    object-position: left;
  }
  .md\\:object-left-bottom {
    object-position: left bottom;
  }
  .md\\:object-left-top {
    object-position: left top;
  }
  .md\\:object-right {
    object-position: right;
  }
  .md\\:object-right-bottom {
    object-position: right bottom;
  }
  .md\\:object-right-top {
    object-position: right top;
  }
  .md\\:object-top {
    object-position: top;
  }
  .md\\:opacity-0 {
    opacity: 0;
  }
  .md\\:opacity-25 {
    opacity: 0.25;
  }
  .md\\:opacity-50 {
    opacity: 0.5;
  }
  .md\\:opacity-75 {
    opacity: 0.75;
  }
  .md\\:opacity-100 {
    opacity: 1;
  }
  .md\\:focus-within\\:opacity-0:focus-within {
    opacity: 0;
  }
  .md\\:focus-within\\:opacity-25:focus-within {
    opacity: 0.25;
  }
  .md\\:focus-within\\:opacity-50:focus-within {
    opacity: 0.5;
  }
  .md\\:focus-within\\:opacity-75:focus-within {
    opacity: 0.75;
  }
  .md\\:focus-within\\:opacity-100:focus-within {
    opacity: 1;
  }
  .group:hover .md\\:group-hover\\:opacity-0 {
    opacity: 0;
  }
  .group:hover .md\\:group-hover\\:opacity-25 {
    opacity: 0.25;
  }
  .group:hover .md\\:group-hover\\:opacity-50 {
    opacity: 0.5;
  }
  .group:hover .md\\:group-hover\\:opacity-75 {
    opacity: 0.75;
  }
  .group:hover .md\\:group-hover\\:opacity-100 {
    opacity: 1;
  }
  .group:focus .md\\:group-focus\\:opacity-0 {
    opacity: 0;
  }
  .group:focus .md\\:group-focus\\:opacity-25 {
    opacity: 0.25;
  }
  .group:focus .md\\:group-focus\\:opacity-50 {
    opacity: 0.5;
  }
  .group:focus .md\\:group-focus\\:opacity-75 {
    opacity: 0.75;
  }
  .group:focus .md\\:group-focus\\:opacity-100 {
    opacity: 1;
  }
  .md\\:hover\\:opacity-0:hover {
    opacity: 0;
  }
  .md\\:hover\\:opacity-25:hover {
    opacity: 0.25;
  }
  .md\\:hover\\:opacity-50:hover {
    opacity: 0.5;
  }
  .md\\:hover\\:opacity-75:hover {
    opacity: 0.75;
  }
  .md\\:hover\\:opacity-100:hover {
    opacity: 1;
  }
  .md\\:focus\\:opacity-0:focus {
    opacity: 0;
  }
  .md\\:focus\\:opacity-25:focus {
    opacity: 0.25;
  }
  .md\\:focus\\:opacity-50:focus {
    opacity: 0.5;
  }
  .md\\:focus\\:opacity-75:focus {
    opacity: 0.75;
  }
  .md\\:focus\\:opacity-100:focus {
    opacity: 1;
  }
  .md\\:outline-none {
    outline: 2px solid transparent;
    outline-offset: 2px;
  }
  .md\\:outline-white {
    outline: 2px dotted white;
    outline-offset: 2px;
  }
  .md\\:outline-black {
    outline: 2px dotted black;
    outline-offset: 2px;
  }
  .md\\:focus\\:outline-none:focus {
    outline: 2px solid transparent;
    outline-offset: 2px;
  }
  .md\\:focus\\:outline-white:focus {
    outline: 2px dotted white;
    outline-offset: 2px;
  }
  .md\\:focus\\:outline-black:focus {
    outline: 2px dotted black;
    outline-offset: 2px;
  }
  .md\\:overflow-auto {
    overflow: auto;
  }
  .md\\:overflow-hidden {
    overflow: hidden;
  }
  .md\\:overflow-visible {
    overflow: visible;
  }
  .md\\:overflow-scroll {
    overflow: scroll;
  }
  .md\\:overflow-x-auto {
    overflow-x: auto;
  }
  .md\\:overflow-y-auto {
    overflow-y: auto;
  }
  .md\\:overflow-x-hidden {
    overflow-x: hidden;
  }
  .md\\:overflow-y-hidden {
    overflow-y: hidden;
  }
  .md\\:overflow-x-visible {
    overflow-x: visible;
  }
  .md\\:overflow-y-visible {
    overflow-y: visible;
  }
  .md\\:overflow-x-scroll {
    overflow-x: scroll;
  }
  .md\\:overflow-y-scroll {
    overflow-y: scroll;
  }
  .md\\:scrolling-touch {
    -webkit-overflow-scrolling: touch;
  }
  .md\\:scrolling-auto {
    -webkit-overflow-scrolling: auto;
  }
  .md\\:overscroll-auto {
    overscroll-behavior: auto;
  }
  .md\\:overscroll-contain {
    overscroll-behavior: contain;
  }
  .md\\:overscroll-none {
    overscroll-behavior: none;
  }
  .md\\:overscroll-y-auto {
    overscroll-behavior-y: auto;
  }
  .md\\:overscroll-y-contain {
    overscroll-behavior-y: contain;
  }
  .md\\:overscroll-y-none {
    overscroll-behavior-y: none;
  }
  .md\\:overscroll-x-auto {
    overscroll-behavior-x: auto;
  }
  .md\\:overscroll-x-contain {
    overscroll-behavior-x: contain;
  }
  .md\\:overscroll-x-none {
    overscroll-behavior-x: none;
  }
  .md\\:p-0 {
    padding: 0;
  }
  .md\\:p-1 {
    padding: 0.25rem;
  }
  .md\\:p-2 {
    padding: 0.5rem;
  }
  .md\\:p-3 {
    padding: 0.75rem;
  }
  .md\\:p-4 {
    padding: 1rem;
  }
  .md\\:p-5 {
    padding: 1.25rem;
  }
  .md\\:p-6 {
    padding: 1.5rem;
  }
  .md\\:p-7 {
    padding: 1.75rem;
  }
  .md\\:p-8 {
    padding: 2rem;
  }
  .md\\:p-9 {
    padding: 2.25rem;
  }
  .md\\:p-10 {
    padding: 2.5rem;
  }
  .md\\:p-11 {
    padding: 2.75rem;
  }
  .md\\:p-12 {
    padding: 3rem;
  }
  .md\\:p-13 {
    padding: 3.25rem;
  }
  .md\\:p-14 {
    padding: 3.5rem;
  }
  .md\\:p-15 {
    padding: 3.75rem;
  }
  .md\\:p-16 {
    padding: 4rem;
  }
  .md\\:p-20 {
    padding: 5rem;
  }
  .md\\:p-24 {
    padding: 6rem;
  }
  .md\\:p-28 {
    padding: 7rem;
  }
  .md\\:p-32 {
    padding: 8rem;
  }
  .md\\:p-36 {
    padding: 9rem;
  }
  .md\\:p-40 {
    padding: 10rem;
  }
  .md\\:p-44 {
    padding: 11rem;
  }
  .md\\:p-48 {
    padding: 12rem;
  }
  .md\\:p-52 {
    padding: 13rem;
  }
  .md\\:p-56 {
    padding: 14rem;
  }
  .md\\:p-60 {
    padding: 15rem;
  }
  .md\\:p-64 {
    padding: 16rem;
  }
  .md\\:p-72 {
    padding: 18rem;
  }
  .md\\:p-80 {
    padding: 20rem;
  }
  .md\\:p-96 {
    padding: 24rem;
  }
  .md\\:p-px {
    padding: 1px;
  }
  .md\\:p-0\\.5 {
    padding: 0.125rem;
  }
  .md\\:p-1\\.5 {
    padding: 0.375rem;
  }
  .md\\:p-2\\.5 {
    padding: 0.625rem;
  }
  .md\\:p-3\\.5 {
    padding: 0.875rem;
  }
  .md\\:p-1\\/2 {
    padding: 50%;
  }
  .md\\:p-1\\/3 {
    padding: 33.333333%;
  }
  .md\\:p-2\\/3 {
    padding: 66.666667%;
  }
  .md\\:p-1\\/4 {
    padding: 25%;
  }
  .md\\:p-2\\/4 {
    padding: 50%;
  }
  .md\\:p-3\\/4 {
    padding: 75%;
  }
  .md\\:p-1\\/5 {
    padding: 20%;
  }
  .md\\:p-2\\/5 {
    padding: 40%;
  }
  .md\\:p-3\\/5 {
    padding: 60%;
  }
  .md\\:p-4\\/5 {
    padding: 80%;
  }
  .md\\:p-1\\/6 {
    padding: 16.666667%;
  }
  .md\\:p-2\\/6 {
    padding: 33.333333%;
  }
  .md\\:p-3\\/6 {
    padding: 50%;
  }
  .md\\:p-4\\/6 {
    padding: 66.666667%;
  }
  .md\\:p-5\\/6 {
    padding: 83.333333%;
  }
  .md\\:p-1\\/12 {
    padding: 8.333333%;
  }
  .md\\:p-2\\/12 {
    padding: 16.666667%;
  }
  .md\\:p-3\\/12 {
    padding: 25%;
  }
  .md\\:p-4\\/12 {
    padding: 33.333333%;
  }
  .md\\:p-5\\/12 {
    padding: 41.666667%;
  }
  .md\\:p-6\\/12 {
    padding: 50%;
  }
  .md\\:p-7\\/12 {
    padding: 58.333333%;
  }
  .md\\:p-8\\/12 {
    padding: 66.666667%;
  }
  .md\\:p-9\\/12 {
    padding: 75%;
  }
  .md\\:p-10\\/12 {
    padding: 83.333333%;
  }
  .md\\:p-11\\/12 {
    padding: 91.666667%;
  }
  .md\\:p-full {
    padding: 100%;
  }
  .md\\:py-0 {
    padding-top: 0;
    padding-bottom: 0;
  }
  .md\\:px-0 {
    padding-left: 0;
    padding-right: 0;
  }
  .md\\:py-1 {
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
  }
  .md\\:px-1 {
    padding-left: 0.25rem;
    padding-right: 0.25rem;
  }
  .md\\:py-2 {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }
  .md\\:px-2 {
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }
  .md\\:py-3 {
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
  }
  .md\\:px-3 {
    padding-left: 0.75rem;
    padding-right: 0.75rem;
  }
  .md\\:py-4 {
    padding-top: 1rem;
    padding-bottom: 1rem;
  }
  .md\\:px-4 {
    padding-left: 1rem;
    padding-right: 1rem;
  }
  .md\\:py-5 {
    padding-top: 1.25rem;
    padding-bottom: 1.25rem;
  }
  .md\\:px-5 {
    padding-left: 1.25rem;
    padding-right: 1.25rem;
  }
  .md\\:py-6 {
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
  }
  .md\\:px-6 {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }
  .md\\:py-7 {
    padding-top: 1.75rem;
    padding-bottom: 1.75rem;
  }
  .md\\:px-7 {
    padding-left: 1.75rem;
    padding-right: 1.75rem;
  }
  .md\\:py-8 {
    padding-top: 2rem;
    padding-bottom: 2rem;
  }
  .md\\:px-8 {
    padding-left: 2rem;
    padding-right: 2rem;
  }
  .md\\:py-9 {
    padding-top: 2.25rem;
    padding-bottom: 2.25rem;
  }
  .md\\:px-9 {
    padding-left: 2.25rem;
    padding-right: 2.25rem;
  }
  .md\\:py-10 {
    padding-top: 2.5rem;
    padding-bottom: 2.5rem;
  }
  .md\\:px-10 {
    padding-left: 2.5rem;
    padding-right: 2.5rem;
  }
  .md\\:py-11 {
    padding-top: 2.75rem;
    padding-bottom: 2.75rem;
  }
  .md\\:px-11 {
    padding-left: 2.75rem;
    padding-right: 2.75rem;
  }
  .md\\:py-12 {
    padding-top: 3rem;
    padding-bottom: 3rem;
  }
  .md\\:px-12 {
    padding-left: 3rem;
    padding-right: 3rem;
  }
  .md\\:py-13 {
    padding-top: 3.25rem;
    padding-bottom: 3.25rem;
  }
  .md\\:px-13 {
    padding-left: 3.25rem;
    padding-right: 3.25rem;
  }
  .md\\:py-14 {
    padding-top: 3.5rem;
    padding-bottom: 3.5rem;
  }
  .md\\:px-14 {
    padding-left: 3.5rem;
    padding-right: 3.5rem;
  }
  .md\\:py-15 {
    padding-top: 3.75rem;
    padding-bottom: 3.75rem;
  }
  .md\\:px-15 {
    padding-left: 3.75rem;
    padding-right: 3.75rem;
  }
  .md\\:py-16 {
    padding-top: 4rem;
    padding-bottom: 4rem;
  }
  .md\\:px-16 {
    padding-left: 4rem;
    padding-right: 4rem;
  }
  .md\\:py-20 {
    padding-top: 5rem;
    padding-bottom: 5rem;
  }
  .md\\:px-20 {
    padding-left: 5rem;
    padding-right: 5rem;
  }
  .md\\:py-24 {
    padding-top: 6rem;
    padding-bottom: 6rem;
  }
  .md\\:px-24 {
    padding-left: 6rem;
    padding-right: 6rem;
  }
  .md\\:py-28 {
    padding-top: 7rem;
    padding-bottom: 7rem;
  }
  .md\\:px-28 {
    padding-left: 7rem;
    padding-right: 7rem;
  }
  .md\\:py-32 {
    padding-top: 8rem;
    padding-bottom: 8rem;
  }
  .md\\:px-32 {
    padding-left: 8rem;
    padding-right: 8rem;
  }
  .md\\:py-36 {
    padding-top: 9rem;
    padding-bottom: 9rem;
  }
  .md\\:px-36 {
    padding-left: 9rem;
    padding-right: 9rem;
  }
  .md\\:py-40 {
    padding-top: 10rem;
    padding-bottom: 10rem;
  }
  .md\\:px-40 {
    padding-left: 10rem;
    padding-right: 10rem;
  }
  .md\\:py-44 {
    padding-top: 11rem;
    padding-bottom: 11rem;
  }
  .md\\:px-44 {
    padding-left: 11rem;
    padding-right: 11rem;
  }
  .md\\:py-48 {
    padding-top: 12rem;
    padding-bottom: 12rem;
  }
  .md\\:px-48 {
    padding-left: 12rem;
    padding-right: 12rem;
  }
  .md\\:py-52 {
    padding-top: 13rem;
    padding-bottom: 13rem;
  }
  .md\\:px-52 {
    padding-left: 13rem;
    padding-right: 13rem;
  }
  .md\\:py-56 {
    padding-top: 14rem;
    padding-bottom: 14rem;
  }
  .md\\:px-56 {
    padding-left: 14rem;
    padding-right: 14rem;
  }
  .md\\:py-60 {
    padding-top: 15rem;
    padding-bottom: 15rem;
  }
  .md\\:px-60 {
    padding-left: 15rem;
    padding-right: 15rem;
  }
  .md\\:py-64 {
    padding-top: 16rem;
    padding-bottom: 16rem;
  }
  .md\\:px-64 {
    padding-left: 16rem;
    padding-right: 16rem;
  }
  .md\\:py-72 {
    padding-top: 18rem;
    padding-bottom: 18rem;
  }
  .md\\:px-72 {
    padding-left: 18rem;
    padding-right: 18rem;
  }
  .md\\:py-80 {
    padding-top: 20rem;
    padding-bottom: 20rem;
  }
  .md\\:px-80 {
    padding-left: 20rem;
    padding-right: 20rem;
  }
  .md\\:py-96 {
    padding-top: 24rem;
    padding-bottom: 24rem;
  }
  .md\\:px-96 {
    padding-left: 24rem;
    padding-right: 24rem;
  }
  .md\\:py-px {
    padding-top: 1px;
    padding-bottom: 1px;
  }
  .md\\:px-px {
    padding-left: 1px;
    padding-right: 1px;
  }
  .md\\:py-0\\.5 {
    padding-top: 0.125rem;
    padding-bottom: 0.125rem;
  }
  .md\\:px-0\\.5 {
    padding-left: 0.125rem;
    padding-right: 0.125rem;
  }
  .md\\:py-1\\.5 {
    padding-top: 0.375rem;
    padding-bottom: 0.375rem;
  }
  .md\\:px-1\\.5 {
    padding-left: 0.375rem;
    padding-right: 0.375rem;
  }
  .md\\:py-2\\.5 {
    padding-top: 0.625rem;
    padding-bottom: 0.625rem;
  }
  .md\\:px-2\\.5 {
    padding-left: 0.625rem;
    padding-right: 0.625rem;
  }
  .md\\:py-3\\.5 {
    padding-top: 0.875rem;
    padding-bottom: 0.875rem;
  }
  .md\\:px-3\\.5 {
    padding-left: 0.875rem;
    padding-right: 0.875rem;
  }
  .md\\:py-1\\/2 {
    padding-top: 50%;
    padding-bottom: 50%;
  }
  .md\\:px-1\\/2 {
    padding-left: 50%;
    padding-right: 50%;
  }
  .md\\:py-1\\/3 {
    padding-top: 33.333333%;
    padding-bottom: 33.333333%;
  }
  .md\\:px-1\\/3 {
    padding-left: 33.333333%;
    padding-right: 33.333333%;
  }
  .md\\:py-2\\/3 {
    padding-top: 66.666667%;
    padding-bottom: 66.666667%;
  }
  .md\\:px-2\\/3 {
    padding-left: 66.666667%;
    padding-right: 66.666667%;
  }
  .md\\:py-1\\/4 {
    padding-top: 25%;
    padding-bottom: 25%;
  }
  .md\\:px-1\\/4 {
    padding-left: 25%;
    padding-right: 25%;
  }
  .md\\:py-2\\/4 {
    padding-top: 50%;
    padding-bottom: 50%;
  }
  .md\\:px-2\\/4 {
    padding-left: 50%;
    padding-right: 50%;
  }
  .md\\:py-3\\/4 {
    padding-top: 75%;
    padding-bottom: 75%;
  }
  .md\\:px-3\\/4 {
    padding-left: 75%;
    padding-right: 75%;
  }
  .md\\:py-1\\/5 {
    padding-top: 20%;
    padding-bottom: 20%;
  }
  .md\\:px-1\\/5 {
    padding-left: 20%;
    padding-right: 20%;
  }
  .md\\:py-2\\/5 {
    padding-top: 40%;
    padding-bottom: 40%;
  }
  .md\\:px-2\\/5 {
    padding-left: 40%;
    padding-right: 40%;
  }
  .md\\:py-3\\/5 {
    padding-top: 60%;
    padding-bottom: 60%;
  }
  .md\\:px-3\\/5 {
    padding-left: 60%;
    padding-right: 60%;
  }
  .md\\:py-4\\/5 {
    padding-top: 80%;
    padding-bottom: 80%;
  }
  .md\\:px-4\\/5 {
    padding-left: 80%;
    padding-right: 80%;
  }
  .md\\:py-1\\/6 {
    padding-top: 16.666667%;
    padding-bottom: 16.666667%;
  }
  .md\\:px-1\\/6 {
    padding-left: 16.666667%;
    padding-right: 16.666667%;
  }
  .md\\:py-2\\/6 {
    padding-top: 33.333333%;
    padding-bottom: 33.333333%;
  }
  .md\\:px-2\\/6 {
    padding-left: 33.333333%;
    padding-right: 33.333333%;
  }
  .md\\:py-3\\/6 {
    padding-top: 50%;
    padding-bottom: 50%;
  }
  .md\\:px-3\\/6 {
    padding-left: 50%;
    padding-right: 50%;
  }
  .md\\:py-4\\/6 {
    padding-top: 66.666667%;
    padding-bottom: 66.666667%;
  }
  .md\\:px-4\\/6 {
    padding-left: 66.666667%;
    padding-right: 66.666667%;
  }
  .md\\:py-5\\/6 {
    padding-top: 83.333333%;
    padding-bottom: 83.333333%;
  }
  .md\\:px-5\\/6 {
    padding-left: 83.333333%;
    padding-right: 83.333333%;
  }
  .md\\:py-1\\/12 {
    padding-top: 8.333333%;
    padding-bottom: 8.333333%;
  }
  .md\\:px-1\\/12 {
    padding-left: 8.333333%;
    padding-right: 8.333333%;
  }
  .md\\:py-2\\/12 {
    padding-top: 16.666667%;
    padding-bottom: 16.666667%;
  }
  .md\\:px-2\\/12 {
    padding-left: 16.666667%;
    padding-right: 16.666667%;
  }
  .md\\:py-3\\/12 {
    padding-top: 25%;
    padding-bottom: 25%;
  }
  .md\\:px-3\\/12 {
    padding-left: 25%;
    padding-right: 25%;
  }
  .md\\:py-4\\/12 {
    padding-top: 33.333333%;
    padding-bottom: 33.333333%;
  }
  .md\\:px-4\\/12 {
    padding-left: 33.333333%;
    padding-right: 33.333333%;
  }
  .md\\:py-5\\/12 {
    padding-top: 41.666667%;
    padding-bottom: 41.666667%;
  }
  .md\\:px-5\\/12 {
    padding-left: 41.666667%;
    padding-right: 41.666667%;
  }
  .md\\:py-6\\/12 {
    padding-top: 50%;
    padding-bottom: 50%;
  }
  .md\\:px-6\\/12 {
    padding-left: 50%;
    padding-right: 50%;
  }
  .md\\:py-7\\/12 {
    padding-top: 58.333333%;
    padding-bottom: 58.333333%;
  }
  .md\\:px-7\\/12 {
    padding-left: 58.333333%;
    padding-right: 58.333333%;
  }
  .md\\:py-8\\/12 {
    padding-top: 66.666667%;
    padding-bottom: 66.666667%;
  }
  .md\\:px-8\\/12 {
    padding-left: 66.666667%;
    padding-right: 66.666667%;
  }
  .md\\:py-9\\/12 {
    padding-top: 75%;
    padding-bottom: 75%;
  }
  .md\\:px-9\\/12 {
    padding-left: 75%;
    padding-right: 75%;
  }
  .md\\:py-10\\/12 {
    padding-top: 83.333333%;
    padding-bottom: 83.333333%;
  }
  .md\\:px-10\\/12 {
    padding-left: 83.333333%;
    padding-right: 83.333333%;
  }
  .md\\:py-11\\/12 {
    padding-top: 91.666667%;
    padding-bottom: 91.666667%;
  }
  .md\\:px-11\\/12 {
    padding-left: 91.666667%;
    padding-right: 91.666667%;
  }
  .md\\:py-full {
    padding-top: 100%;
    padding-bottom: 100%;
  }
  .md\\:px-full {
    padding-left: 100%;
    padding-right: 100%;
  }
  .md\\:pt-0 {
    padding-top: 0;
  }
  .md\\:pr-0 {
    padding-right: 0;
  }
  .md\\:pb-0 {
    padding-bottom: 0;
  }
  .md\\:pl-0 {
    padding-left: 0;
  }
  .md\\:pt-1 {
    padding-top: 0.25rem;
  }
  .md\\:pr-1 {
    padding-right: 0.25rem;
  }
  .md\\:pb-1 {
    padding-bottom: 0.25rem;
  }
  .md\\:pl-1 {
    padding-left: 0.25rem;
  }
  .md\\:pt-2 {
    padding-top: 0.5rem;
  }
  .md\\:pr-2 {
    padding-right: 0.5rem;
  }
  .md\\:pb-2 {
    padding-bottom: 0.5rem;
  }
  .md\\:pl-2 {
    padding-left: 0.5rem;
  }
  .md\\:pt-3 {
    padding-top: 0.75rem;
  }
  .md\\:pr-3 {
    padding-right: 0.75rem;
  }
  .md\\:pb-3 {
    padding-bottom: 0.75rem;
  }
  .md\\:pl-3 {
    padding-left: 0.75rem;
  }
  .md\\:pt-4 {
    padding-top: 1rem;
  }
  .md\\:pr-4 {
    padding-right: 1rem;
  }
  .md\\:pb-4 {
    padding-bottom: 1rem;
  }
  .md\\:pl-4 {
    padding-left: 1rem;
  }
  .md\\:pt-5 {
    padding-top: 1.25rem;
  }
  .md\\:pr-5 {
    padding-right: 1.25rem;
  }
  .md\\:pb-5 {
    padding-bottom: 1.25rem;
  }
  .md\\:pl-5 {
    padding-left: 1.25rem;
  }
  .md\\:pt-6 {
    padding-top: 1.5rem;
  }
  .md\\:pr-6 {
    padding-right: 1.5rem;
  }
  .md\\:pb-6 {
    padding-bottom: 1.5rem;
  }
  .md\\:pl-6 {
    padding-left: 1.5rem;
  }
  .md\\:pt-7 {
    padding-top: 1.75rem;
  }
  .md\\:pr-7 {
    padding-right: 1.75rem;
  }
  .md\\:pb-7 {
    padding-bottom: 1.75rem;
  }
  .md\\:pl-7 {
    padding-left: 1.75rem;
  }
  .md\\:pt-8 {
    padding-top: 2rem;
  }
  .md\\:pr-8 {
    padding-right: 2rem;
  }
  .md\\:pb-8 {
    padding-bottom: 2rem;
  }
  .md\\:pl-8 {
    padding-left: 2rem;
  }
  .md\\:pt-9 {
    padding-top: 2.25rem;
  }
  .md\\:pr-9 {
    padding-right: 2.25rem;
  }
  .md\\:pb-9 {
    padding-bottom: 2.25rem;
  }
  .md\\:pl-9 {
    padding-left: 2.25rem;
  }
  .md\\:pt-10 {
    padding-top: 2.5rem;
  }
  .md\\:pr-10 {
    padding-right: 2.5rem;
  }
  .md\\:pb-10 {
    padding-bottom: 2.5rem;
  }
  .md\\:pl-10 {
    padding-left: 2.5rem;
  }
  .md\\:pt-11 {
    padding-top: 2.75rem;
  }
  .md\\:pr-11 {
    padding-right: 2.75rem;
  }
  .md\\:pb-11 {
    padding-bottom: 2.75rem;
  }
  .md\\:pl-11 {
    padding-left: 2.75rem;
  }
  .md\\:pt-12 {
    padding-top: 3rem;
  }
  .md\\:pr-12 {
    padding-right: 3rem;
  }
  .md\\:pb-12 {
    padding-bottom: 3rem;
  }
  .md\\:pl-12 {
    padding-left: 3rem;
  }
  .md\\:pt-13 {
    padding-top: 3.25rem;
  }
  .md\\:pr-13 {
    padding-right: 3.25rem;
  }
  .md\\:pb-13 {
    padding-bottom: 3.25rem;
  }
  .md\\:pl-13 {
    padding-left: 3.25rem;
  }
  .md\\:pt-14 {
    padding-top: 3.5rem;
  }
  .md\\:pr-14 {
    padding-right: 3.5rem;
  }
  .md\\:pb-14 {
    padding-bottom: 3.5rem;
  }
  .md\\:pl-14 {
    padding-left: 3.5rem;
  }
  .md\\:pt-15 {
    padding-top: 3.75rem;
  }
  .md\\:pr-15 {
    padding-right: 3.75rem;
  }
  .md\\:pb-15 {
    padding-bottom: 3.75rem;
  }
  .md\\:pl-15 {
    padding-left: 3.75rem;
  }
  .md\\:pt-16 {
    padding-top: 4rem;
  }
  .md\\:pr-16 {
    padding-right: 4rem;
  }
  .md\\:pb-16 {
    padding-bottom: 4rem;
  }
  .md\\:pl-16 {
    padding-left: 4rem;
  }
  .md\\:pt-20 {
    padding-top: 5rem;
  }
  .md\\:pr-20 {
    padding-right: 5rem;
  }
  .md\\:pb-20 {
    padding-bottom: 5rem;
  }
  .md\\:pl-20 {
    padding-left: 5rem;
  }
  .md\\:pt-24 {
    padding-top: 6rem;
  }
  .md\\:pr-24 {
    padding-right: 6rem;
  }
  .md\\:pb-24 {
    padding-bottom: 6rem;
  }
  .md\\:pl-24 {
    padding-left: 6rem;
  }
  .md\\:pt-28 {
    padding-top: 7rem;
  }
  .md\\:pr-28 {
    padding-right: 7rem;
  }
  .md\\:pb-28 {
    padding-bottom: 7rem;
  }
  .md\\:pl-28 {
    padding-left: 7rem;
  }
  .md\\:pt-32 {
    padding-top: 8rem;
  }
  .md\\:pr-32 {
    padding-right: 8rem;
  }
  .md\\:pb-32 {
    padding-bottom: 8rem;
  }
  .md\\:pl-32 {
    padding-left: 8rem;
  }
  .md\\:pt-36 {
    padding-top: 9rem;
  }
  .md\\:pr-36 {
    padding-right: 9rem;
  }
  .md\\:pb-36 {
    padding-bottom: 9rem;
  }
  .md\\:pl-36 {
    padding-left: 9rem;
  }
  .md\\:pt-40 {
    padding-top: 10rem;
  }
  .md\\:pr-40 {
    padding-right: 10rem;
  }
  .md\\:pb-40 {
    padding-bottom: 10rem;
  }
  .md\\:pl-40 {
    padding-left: 10rem;
  }
  .md\\:pt-44 {
    padding-top: 11rem;
  }
  .md\\:pr-44 {
    padding-right: 11rem;
  }
  .md\\:pb-44 {
    padding-bottom: 11rem;
  }
  .md\\:pl-44 {
    padding-left: 11rem;
  }
  .md\\:pt-48 {
    padding-top: 12rem;
  }
  .md\\:pr-48 {
    padding-right: 12rem;
  }
  .md\\:pb-48 {
    padding-bottom: 12rem;
  }
  .md\\:pl-48 {
    padding-left: 12rem;
  }
  .md\\:pt-52 {
    padding-top: 13rem;
  }
  .md\\:pr-52 {
    padding-right: 13rem;
  }
  .md\\:pb-52 {
    padding-bottom: 13rem;
  }
  .md\\:pl-52 {
    padding-left: 13rem;
  }
  .md\\:pt-56 {
    padding-top: 14rem;
  }
  .md\\:pr-56 {
    padding-right: 14rem;
  }
  .md\\:pb-56 {
    padding-bottom: 14rem;
  }
  .md\\:pl-56 {
    padding-left: 14rem;
  }
  .md\\:pt-60 {
    padding-top: 15rem;
  }
  .md\\:pr-60 {
    padding-right: 15rem;
  }
  .md\\:pb-60 {
    padding-bottom: 15rem;
  }
  .md\\:pl-60 {
    padding-left: 15rem;
  }
  .md\\:pt-64 {
    padding-top: 16rem;
  }
  .md\\:pr-64 {
    padding-right: 16rem;
  }
  .md\\:pb-64 {
    padding-bottom: 16rem;
  }
  .md\\:pl-64 {
    padding-left: 16rem;
  }
  .md\\:pt-72 {
    padding-top: 18rem;
  }
  .md\\:pr-72 {
    padding-right: 18rem;
  }
  .md\\:pb-72 {
    padding-bottom: 18rem;
  }
  .md\\:pl-72 {
    padding-left: 18rem;
  }
  .md\\:pt-80 {
    padding-top: 20rem;
  }
  .md\\:pr-80 {
    padding-right: 20rem;
  }
  .md\\:pb-80 {
    padding-bottom: 20rem;
  }
  .md\\:pl-80 {
    padding-left: 20rem;
  }
  .md\\:pt-96 {
    padding-top: 24rem;
  }
  .md\\:pr-96 {
    padding-right: 24rem;
  }
  .md\\:pb-96 {
    padding-bottom: 24rem;
  }
  .md\\:pl-96 {
    padding-left: 24rem;
  }
  .md\\:pt-px {
    padding-top: 1px;
  }
  .md\\:pr-px {
    padding-right: 1px;
  }
  .md\\:pb-px {
    padding-bottom: 1px;
  }
  .md\\:pl-px {
    padding-left: 1px;
  }
  .md\\:pt-0\\.5 {
    padding-top: 0.125rem;
  }
  .md\\:pr-0\\.5 {
    padding-right: 0.125rem;
  }
  .md\\:pb-0\\.5 {
    padding-bottom: 0.125rem;
  }
  .md\\:pl-0\\.5 {
    padding-left: 0.125rem;
  }
  .md\\:pt-1\\.5 {
    padding-top: 0.375rem;
  }
  .md\\:pr-1\\.5 {
    padding-right: 0.375rem;
  }
  .md\\:pb-1\\.5 {
    padding-bottom: 0.375rem;
  }
  .md\\:pl-1\\.5 {
    padding-left: 0.375rem;
  }
  .md\\:pt-2\\.5 {
    padding-top: 0.625rem;
  }
  .md\\:pr-2\\.5 {
    padding-right: 0.625rem;
  }
  .md\\:pb-2\\.5 {
    padding-bottom: 0.625rem;
  }
  .md\\:pl-2\\.5 {
    padding-left: 0.625rem;
  }
  .md\\:pt-3\\.5 {
    padding-top: 0.875rem;
  }
  .md\\:pr-3\\.5 {
    padding-right: 0.875rem;
  }
  .md\\:pb-3\\.5 {
    padding-bottom: 0.875rem;
  }
  .md\\:pl-3\\.5 {
    padding-left: 0.875rem;
  }
  .md\\:pt-1\\/2 {
    padding-top: 50%;
  }
  .md\\:pr-1\\/2 {
    padding-right: 50%;
  }
  .md\\:pb-1\\/2 {
    padding-bottom: 50%;
  }
  .md\\:pl-1\\/2 {
    padding-left: 50%;
  }
  .md\\:pt-1\\/3 {
    padding-top: 33.333333%;
  }
  .md\\:pr-1\\/3 {
    padding-right: 33.333333%;
  }
  .md\\:pb-1\\/3 {
    padding-bottom: 33.333333%;
  }
  .md\\:pl-1\\/3 {
    padding-left: 33.333333%;
  }
  .md\\:pt-2\\/3 {
    padding-top: 66.666667%;
  }
  .md\\:pr-2\\/3 {
    padding-right: 66.666667%;
  }
  .md\\:pb-2\\/3 {
    padding-bottom: 66.666667%;
  }
  .md\\:pl-2\\/3 {
    padding-left: 66.666667%;
  }
  .md\\:pt-1\\/4 {
    padding-top: 25%;
  }
  .md\\:pr-1\\/4 {
    padding-right: 25%;
  }
  .md\\:pb-1\\/4 {
    padding-bottom: 25%;
  }
  .md\\:pl-1\\/4 {
    padding-left: 25%;
  }
  .md\\:pt-2\\/4 {
    padding-top: 50%;
  }
  .md\\:pr-2\\/4 {
    padding-right: 50%;
  }
  .md\\:pb-2\\/4 {
    padding-bottom: 50%;
  }
  .md\\:pl-2\\/4 {
    padding-left: 50%;
  }
  .md\\:pt-3\\/4 {
    padding-top: 75%;
  }
  .md\\:pr-3\\/4 {
    padding-right: 75%;
  }
  .md\\:pb-3\\/4 {
    padding-bottom: 75%;
  }
  .md\\:pl-3\\/4 {
    padding-left: 75%;
  }
  .md\\:pt-1\\/5 {
    padding-top: 20%;
  }
  .md\\:pr-1\\/5 {
    padding-right: 20%;
  }
  .md\\:pb-1\\/5 {
    padding-bottom: 20%;
  }
  .md\\:pl-1\\/5 {
    padding-left: 20%;
  }
  .md\\:pt-2\\/5 {
    padding-top: 40%;
  }
  .md\\:pr-2\\/5 {
    padding-right: 40%;
  }
  .md\\:pb-2\\/5 {
    padding-bottom: 40%;
  }
  .md\\:pl-2\\/5 {
    padding-left: 40%;
  }
  .md\\:pt-3\\/5 {
    padding-top: 60%;
  }
  .md\\:pr-3\\/5 {
    padding-right: 60%;
  }
  .md\\:pb-3\\/5 {
    padding-bottom: 60%;
  }
  .md\\:pl-3\\/5 {
    padding-left: 60%;
  }
  .md\\:pt-4\\/5 {
    padding-top: 80%;
  }
  .md\\:pr-4\\/5 {
    padding-right: 80%;
  }
  .md\\:pb-4\\/5 {
    padding-bottom: 80%;
  }
  .md\\:pl-4\\/5 {
    padding-left: 80%;
  }
  .md\\:pt-1\\/6 {
    padding-top: 16.666667%;
  }
  .md\\:pr-1\\/6 {
    padding-right: 16.666667%;
  }
  .md\\:pb-1\\/6 {
    padding-bottom: 16.666667%;
  }
  .md\\:pl-1\\/6 {
    padding-left: 16.666667%;
  }
  .md\\:pt-2\\/6 {
    padding-top: 33.333333%;
  }
  .md\\:pr-2\\/6 {
    padding-right: 33.333333%;
  }
  .md\\:pb-2\\/6 {
    padding-bottom: 33.333333%;
  }
  .md\\:pl-2\\/6 {
    padding-left: 33.333333%;
  }
  .md\\:pt-3\\/6 {
    padding-top: 50%;
  }
  .md\\:pr-3\\/6 {
    padding-right: 50%;
  }
  .md\\:pb-3\\/6 {
    padding-bottom: 50%;
  }
  .md\\:pl-3\\/6 {
    padding-left: 50%;
  }
  .md\\:pt-4\\/6 {
    padding-top: 66.666667%;
  }
  .md\\:pr-4\\/6 {
    padding-right: 66.666667%;
  }
  .md\\:pb-4\\/6 {
    padding-bottom: 66.666667%;
  }
  .md\\:pl-4\\/6 {
    padding-left: 66.666667%;
  }
  .md\\:pt-5\\/6 {
    padding-top: 83.333333%;
  }
  .md\\:pr-5\\/6 {
    padding-right: 83.333333%;
  }
  .md\\:pb-5\\/6 {
    padding-bottom: 83.333333%;
  }
  .md\\:pl-5\\/6 {
    padding-left: 83.333333%;
  }
  .md\\:pt-1\\/12 {
    padding-top: 8.333333%;
  }
  .md\\:pr-1\\/12 {
    padding-right: 8.333333%;
  }
  .md\\:pb-1\\/12 {
    padding-bottom: 8.333333%;
  }
  .md\\:pl-1\\/12 {
    padding-left: 8.333333%;
  }
  .md\\:pt-2\\/12 {
    padding-top: 16.666667%;
  }
  .md\\:pr-2\\/12 {
    padding-right: 16.666667%;
  }
  .md\\:pb-2\\/12 {
    padding-bottom: 16.666667%;
  }
  .md\\:pl-2\\/12 {
    padding-left: 16.666667%;
  }
  .md\\:pt-3\\/12 {
    padding-top: 25%;
  }
  .md\\:pr-3\\/12 {
    padding-right: 25%;
  }
  .md\\:pb-3\\/12 {
    padding-bottom: 25%;
  }
  .md\\:pl-3\\/12 {
    padding-left: 25%;
  }
  .md\\:pt-4\\/12 {
    padding-top: 33.333333%;
  }
  .md\\:pr-4\\/12 {
    padding-right: 33.333333%;
  }
  .md\\:pb-4\\/12 {
    padding-bottom: 33.333333%;
  }
  .md\\:pl-4\\/12 {
    padding-left: 33.333333%;
  }
  .md\\:pt-5\\/12 {
    padding-top: 41.666667%;
  }
  .md\\:pr-5\\/12 {
    padding-right: 41.666667%;
  }
  .md\\:pb-5\\/12 {
    padding-bottom: 41.666667%;
  }
  .md\\:pl-5\\/12 {
    padding-left: 41.666667%;
  }
  .md\\:pt-6\\/12 {
    padding-top: 50%;
  }
  .md\\:pr-6\\/12 {
    padding-right: 50%;
  }
  .md\\:pb-6\\/12 {
    padding-bottom: 50%;
  }
  .md\\:pl-6\\/12 {
    padding-left: 50%;
  }
  .md\\:pt-7\\/12 {
    padding-top: 58.333333%;
  }
  .md\\:pr-7\\/12 {
    padding-right: 58.333333%;
  }
  .md\\:pb-7\\/12 {
    padding-bottom: 58.333333%;
  }
  .md\\:pl-7\\/12 {
    padding-left: 58.333333%;
  }
  .md\\:pt-8\\/12 {
    padding-top: 66.666667%;
  }
  .md\\:pr-8\\/12 {
    padding-right: 66.666667%;
  }
  .md\\:pb-8\\/12 {
    padding-bottom: 66.666667%;
  }
  .md\\:pl-8\\/12 {
    padding-left: 66.666667%;
  }
  .md\\:pt-9\\/12 {
    padding-top: 75%;
  }
  .md\\:pr-9\\/12 {
    padding-right: 75%;
  }
  .md\\:pb-9\\/12 {
    padding-bottom: 75%;
  }
  .md\\:pl-9\\/12 {
    padding-left: 75%;
  }
  .md\\:pt-10\\/12 {
    padding-top: 83.333333%;
  }
  .md\\:pr-10\\/12 {
    padding-right: 83.333333%;
  }
  .md\\:pb-10\\/12 {
    padding-bottom: 83.333333%;
  }
  .md\\:pl-10\\/12 {
    padding-left: 83.333333%;
  }
  .md\\:pt-11\\/12 {
    padding-top: 91.666667%;
  }
  .md\\:pr-11\\/12 {
    padding-right: 91.666667%;
  }
  .md\\:pb-11\\/12 {
    padding-bottom: 91.666667%;
  }
  .md\\:pl-11\\/12 {
    padding-left: 91.666667%;
  }
  .md\\:pt-full {
    padding-top: 100%;
  }
  .md\\:pr-full {
    padding-right: 100%;
  }
  .md\\:pb-full {
    padding-bottom: 100%;
  }
  .md\\:pl-full {
    padding-left: 100%;
  }
  .md\\:placeholder-current::placeholder {
    color: currentColor;
  }
  .md\\:placeholder-transparent::placeholder {
    color: transparent;
  }
  .md\\:placeholder-white::placeholder {
    --placeholder-opacity: 1;
    color: #ffffff;
    color: rgba(255, 255, 255, var(--placeholder-opacity));
  }
  .md\\:placeholder-black::placeholder {
    --placeholder-opacity: 1;
    color: #000000;
    color: rgba(0, 0, 0, var(--placeholder-opacity));
  }
  .md\\:placeholder-gray-50::placeholder {
    --placeholder-opacity: 1;
    color: #f9fafb;
    color: rgba(249, 250, 251, var(--placeholder-opacity));
  }
  .md\\:placeholder-gray-100::placeholder {
    --placeholder-opacity: 1;
    color: #f4f5f7;
    color: rgba(244, 245, 247, var(--placeholder-opacity));
  }
  .md\\:placeholder-gray-200::placeholder {
    --placeholder-opacity: 1;
    color: #e5e7eb;
    color: rgba(229, 231, 235, var(--placeholder-opacity));
  }
  .md\\:placeholder-gray-300::placeholder {
    --placeholder-opacity: 1;
    color: #d2d6dc;
    color: rgba(210, 214, 220, var(--placeholder-opacity));
  }
  .md\\:placeholder-gray-400::placeholder {
    --placeholder-opacity: 1;
    color: #9fa6b2;
    color: rgba(159, 166, 178, var(--placeholder-opacity));
  }
  .md\\:placeholder-gray-500::placeholder {
    --placeholder-opacity: 1;
    color: #6b7280;
    color: rgba(107, 114, 128, var(--placeholder-opacity));
  }
  .md\\:placeholder-gray-600::placeholder {
    --placeholder-opacity: 1;
    color: #4b5563;
    color: rgba(75, 85, 99, var(--placeholder-opacity));
  }
  .md\\:placeholder-gray-700::placeholder {
    --placeholder-opacity: 1;
    color: #374151;
    color: rgba(55, 65, 81, var(--placeholder-opacity));
  }
  .md\\:placeholder-gray-800::placeholder {
    --placeholder-opacity: 1;
    color: #252f3f;
    color: rgba(37, 47, 63, var(--placeholder-opacity));
  }
  .md\\:placeholder-gray-900::placeholder {
    --placeholder-opacity: 1;
    color: #161e2e;
    color: rgba(22, 30, 46, var(--placeholder-opacity));
  }
  .md\\:placeholder-red-50::placeholder {
    --placeholder-opacity: 1;
    color: #fdf2f2;
    color: rgba(253, 242, 242, var(--placeholder-opacity));
  }
  .md\\:placeholder-red-100::placeholder {
    --placeholder-opacity: 1;
    color: #fde8e8;
    color: rgba(253, 232, 232, var(--placeholder-opacity));
  }
  .md\\:placeholder-red-200::placeholder {
    --placeholder-opacity: 1;
    color: #fbd5d5;
    color: rgba(251, 213, 213, var(--placeholder-opacity));
  }
  .md\\:placeholder-red-300::placeholder {
    --placeholder-opacity: 1;
    color: #f8b4b4;
    color: rgba(248, 180, 180, var(--placeholder-opacity));
  }
  .md\\:placeholder-red-400::placeholder {
    --placeholder-opacity: 1;
    color: #f98080;
    color: rgba(249, 128, 128, var(--placeholder-opacity));
  }
  .md\\:placeholder-red-500::placeholder {
    --placeholder-opacity: 1;
    color: #f05252;
    color: rgba(240, 82, 82, var(--placeholder-opacity));
  }
  .md\\:placeholder-red-600::placeholder {
    --placeholder-opacity: 1;
    color: #e02424;
    color: rgba(224, 36, 36, var(--placeholder-opacity));
  }
  .md\\:placeholder-red-700::placeholder {
    --placeholder-opacity: 1;
    color: #c81e1e;
    color: rgba(200, 30, 30, var(--placeholder-opacity));
  }
  .md\\:placeholder-red-800::placeholder {
    --placeholder-opacity: 1;
    color: #9b1c1c;
    color: rgba(155, 28, 28, var(--placeholder-opacity));
  }
  .md\\:placeholder-red-900::placeholder {
    --placeholder-opacity: 1;
    color: #771d1d;
    color: rgba(119, 29, 29, var(--placeholder-opacity));
  }
  .md\\:placeholder-orange-50::placeholder {
    --placeholder-opacity: 1;
    color: #fff8f1;
    color: rgba(255, 248, 241, var(--placeholder-opacity));
  }
  .md\\:placeholder-orange-100::placeholder {
    --placeholder-opacity: 1;
    color: #feecdc;
    color: rgba(254, 236, 220, var(--placeholder-opacity));
  }
  .md\\:placeholder-orange-200::placeholder {
    --placeholder-opacity: 1;
    color: #fcd9bd;
    color: rgba(252, 217, 189, var(--placeholder-opacity));
  }
  .md\\:placeholder-orange-300::placeholder {
    --placeholder-opacity: 1;
    color: #fdba8c;
    color: rgba(253, 186, 140, var(--placeholder-opacity));
  }
  .md\\:placeholder-orange-400::placeholder {
    --placeholder-opacity: 1;
    color: #ff8a4c;
    color: rgba(255, 138, 76, var(--placeholder-opacity));
  }
  .md\\:placeholder-orange-500::placeholder {
    --placeholder-opacity: 1;
    color: #ff5a1f;
    color: rgba(255, 90, 31, var(--placeholder-opacity));
  }
  .md\\:placeholder-orange-600::placeholder {
    --placeholder-opacity: 1;
    color: #d03801;
    color: rgba(208, 56, 1, var(--placeholder-opacity));
  }
  .md\\:placeholder-orange-700::placeholder {
    --placeholder-opacity: 1;
    color: #b43403;
    color: rgba(180, 52, 3, var(--placeholder-opacity));
  }
  .md\\:placeholder-orange-800::placeholder {
    --placeholder-opacity: 1;
    color: #8a2c0d;
    color: rgba(138, 44, 13, var(--placeholder-opacity));
  }
  .md\\:placeholder-orange-900::placeholder {
    --placeholder-opacity: 1;
    color: #73230d;
    color: rgba(115, 35, 13, var(--placeholder-opacity));
  }
  .md\\:placeholder-yellow-50::placeholder {
    --placeholder-opacity: 1;
    color: #fdfdea;
    color: rgba(253, 253, 234, var(--placeholder-opacity));
  }
  .md\\:placeholder-yellow-100::placeholder {
    --placeholder-opacity: 1;
    color: #fdf6b2;
    color: rgba(253, 246, 178, var(--placeholder-opacity));
  }
  .md\\:placeholder-yellow-200::placeholder {
    --placeholder-opacity: 1;
    color: #fce96a;
    color: rgba(252, 233, 106, var(--placeholder-opacity));
  }
  .md\\:placeholder-yellow-300::placeholder {
    --placeholder-opacity: 1;
    color: #faca15;
    color: rgba(250, 202, 21, var(--placeholder-opacity));
  }
  .md\\:placeholder-yellow-400::placeholder {
    --placeholder-opacity: 1;
    color: #e3a008;
    color: rgba(227, 160, 8, var(--placeholder-opacity));
  }
  .md\\:placeholder-yellow-500::placeholder {
    --placeholder-opacity: 1;
    color: #c27803;
    color: rgba(194, 120, 3, var(--placeholder-opacity));
  }
  .md\\:placeholder-yellow-600::placeholder {
    --placeholder-opacity: 1;
    color: #9f580a;
    color: rgba(159, 88, 10, var(--placeholder-opacity));
  }
  .md\\:placeholder-yellow-700::placeholder {
    --placeholder-opacity: 1;
    color: #8e4b10;
    color: rgba(142, 75, 16, var(--placeholder-opacity));
  }
  .md\\:placeholder-yellow-800::placeholder {
    --placeholder-opacity: 1;
    color: #723b13;
    color: rgba(114, 59, 19, var(--placeholder-opacity));
  }
  .md\\:placeholder-yellow-900::placeholder {
    --placeholder-opacity: 1;
    color: #633112;
    color: rgba(99, 49, 18, var(--placeholder-opacity));
  }
  .md\\:placeholder-green-50::placeholder {
    --placeholder-opacity: 1;
    color: #f3faf7;
    color: rgba(243, 250, 247, var(--placeholder-opacity));
  }
  .md\\:placeholder-green-100::placeholder {
    --placeholder-opacity: 1;
    color: #def7ec;
    color: rgba(222, 247, 236, var(--placeholder-opacity));
  }
  .md\\:placeholder-green-200::placeholder {
    --placeholder-opacity: 1;
    color: #bcf0da;
    color: rgba(188, 240, 218, var(--placeholder-opacity));
  }
  .md\\:placeholder-green-300::placeholder {
    --placeholder-opacity: 1;
    color: #84e1bc;
    color: rgba(132, 225, 188, var(--placeholder-opacity));
  }
  .md\\:placeholder-green-400::placeholder {
    --placeholder-opacity: 1;
    color: #31c48d;
    color: rgba(49, 196, 141, var(--placeholder-opacity));
  }
  .md\\:placeholder-green-500::placeholder {
    --placeholder-opacity: 1;
    color: #0e9f6e;
    color: rgba(14, 159, 110, var(--placeholder-opacity));
  }
  .md\\:placeholder-green-600::placeholder {
    --placeholder-opacity: 1;
    color: #057a55;
    color: rgba(5, 122, 85, var(--placeholder-opacity));
  }
  .md\\:placeholder-green-700::placeholder {
    --placeholder-opacity: 1;
    color: #046c4e;
    color: rgba(4, 108, 78, var(--placeholder-opacity));
  }
  .md\\:placeholder-green-800::placeholder {
    --placeholder-opacity: 1;
    color: #03543f;
    color: rgba(3, 84, 63, var(--placeholder-opacity));
  }
  .md\\:placeholder-green-900::placeholder {
    --placeholder-opacity: 1;
    color: #014737;
    color: rgba(1, 71, 55, var(--placeholder-opacity));
  }
  .md\\:placeholder-teal-50::placeholder {
    --placeholder-opacity: 1;
    color: #edfafa;
    color: rgba(237, 250, 250, var(--placeholder-opacity));
  }
  .md\\:placeholder-teal-100::placeholder {
    --placeholder-opacity: 1;
    color: #d5f5f6;
    color: rgba(213, 245, 246, var(--placeholder-opacity));
  }
  .md\\:placeholder-teal-200::placeholder {
    --placeholder-opacity: 1;
    color: #afecef;
    color: rgba(175, 236, 239, var(--placeholder-opacity));
  }
  .md\\:placeholder-teal-300::placeholder {
    --placeholder-opacity: 1;
    color: #7edce2;
    color: rgba(126, 220, 226, var(--placeholder-opacity));
  }
  .md\\:placeholder-teal-400::placeholder {
    --placeholder-opacity: 1;
    color: #16bdca;
    color: rgba(22, 189, 202, var(--placeholder-opacity));
  }
  .md\\:placeholder-teal-500::placeholder {
    --placeholder-opacity: 1;
    color: #0694a2;
    color: rgba(6, 148, 162, var(--placeholder-opacity));
  }
  .md\\:placeholder-teal-600::placeholder {
    --placeholder-opacity: 1;
    color: #047481;
    color: rgba(4, 116, 129, var(--placeholder-opacity));
  }
  .md\\:placeholder-teal-700::placeholder {
    --placeholder-opacity: 1;
    color: #036672;
    color: rgba(3, 102, 114, var(--placeholder-opacity));
  }
  .md\\:placeholder-teal-800::placeholder {
    --placeholder-opacity: 1;
    color: #05505c;
    color: rgba(5, 80, 92, var(--placeholder-opacity));
  }
  .md\\:placeholder-teal-900::placeholder {
    --placeholder-opacity: 1;
    color: #014451;
    color: rgba(1, 68, 81, var(--placeholder-opacity));
  }
  .md\\:placeholder-blue-50::placeholder {
    --placeholder-opacity: 1;
    color: #ebf5ff;
    color: rgba(235, 245, 255, var(--placeholder-opacity));
  }
  .md\\:placeholder-blue-100::placeholder {
    --placeholder-opacity: 1;
    color: #e1effe;
    color: rgba(225, 239, 254, var(--placeholder-opacity));
  }
  .md\\:placeholder-blue-200::placeholder {
    --placeholder-opacity: 1;
    color: #c3ddfd;
    color: rgba(195, 221, 253, var(--placeholder-opacity));
  }
  .md\\:placeholder-blue-300::placeholder {
    --placeholder-opacity: 1;
    color: #a4cafe;
    color: rgba(164, 202, 254, var(--placeholder-opacity));
  }
  .md\\:placeholder-blue-400::placeholder {
    --placeholder-opacity: 1;
    color: #76a9fa;
    color: rgba(118, 169, 250, var(--placeholder-opacity));
  }
  .md\\:placeholder-blue-500::placeholder {
    --placeholder-opacity: 1;
    color: #3f83f8;
    color: rgba(63, 131, 248, var(--placeholder-opacity));
  }
  .md\\:placeholder-blue-600::placeholder {
    --placeholder-opacity: 1;
    color: #1c64f2;
    color: rgba(28, 100, 242, var(--placeholder-opacity));
  }
  .md\\:placeholder-blue-700::placeholder {
    --placeholder-opacity: 1;
    color: #1a56db;
    color: rgba(26, 86, 219, var(--placeholder-opacity));
  }
  .md\\:placeholder-blue-800::placeholder {
    --placeholder-opacity: 1;
    color: #1e429f;
    color: rgba(30, 66, 159, var(--placeholder-opacity));
  }
  .md\\:placeholder-blue-900::placeholder {
    --placeholder-opacity: 1;
    color: #233876;
    color: rgba(35, 56, 118, var(--placeholder-opacity));
  }
  .md\\:placeholder-indigo-50::placeholder {
    --placeholder-opacity: 1;
    color: #f0f5ff;
    color: rgba(240, 245, 255, var(--placeholder-opacity));
  }
  .md\\:placeholder-indigo-100::placeholder {
    --placeholder-opacity: 1;
    color: #e5edff;
    color: rgba(229, 237, 255, var(--placeholder-opacity));
  }
  .md\\:placeholder-indigo-200::placeholder {
    --placeholder-opacity: 1;
    color: #cddbfe;
    color: rgba(205, 219, 254, var(--placeholder-opacity));
  }
  .md\\:placeholder-indigo-300::placeholder {
    --placeholder-opacity: 1;
    color: #b4c6fc;
    color: rgba(180, 198, 252, var(--placeholder-opacity));
  }
  .md\\:placeholder-indigo-400::placeholder {
    --placeholder-opacity: 1;
    color: #8da2fb;
    color: rgba(141, 162, 251, var(--placeholder-opacity));
  }
  .md\\:placeholder-indigo-500::placeholder {
    --placeholder-opacity: 1;
    color: #6875f5;
    color: rgba(104, 117, 245, var(--placeholder-opacity));
  }
  .md\\:placeholder-indigo-600::placeholder {
    --placeholder-opacity: 1;
    color: #5850ec;
    color: rgba(88, 80, 236, var(--placeholder-opacity));
  }
  .md\\:placeholder-indigo-700::placeholder {
    --placeholder-opacity: 1;
    color: #5145cd;
    color: rgba(81, 69, 205, var(--placeholder-opacity));
  }
  .md\\:placeholder-indigo-800::placeholder {
    --placeholder-opacity: 1;
    color: #42389d;
    color: rgba(66, 56, 157, var(--placeholder-opacity));
  }
  .md\\:placeholder-indigo-900::placeholder {
    --placeholder-opacity: 1;
    color: #362f78;
    color: rgba(54, 47, 120, var(--placeholder-opacity));
  }
  .md\\:placeholder-purple-50::placeholder {
    --placeholder-opacity: 1;
    color: #f6f5ff;
    color: rgba(246, 245, 255, var(--placeholder-opacity));
  }
  .md\\:placeholder-purple-100::placeholder {
    --placeholder-opacity: 1;
    color: #edebfe;
    color: rgba(237, 235, 254, var(--placeholder-opacity));
  }
  .md\\:placeholder-purple-200::placeholder {
    --placeholder-opacity: 1;
    color: #dcd7fe;
    color: rgba(220, 215, 254, var(--placeholder-opacity));
  }
  .md\\:placeholder-purple-300::placeholder {
    --placeholder-opacity: 1;
    color: #cabffd;
    color: rgba(202, 191, 253, var(--placeholder-opacity));
  }
  .md\\:placeholder-purple-400::placeholder {
    --placeholder-opacity: 1;
    color: #ac94fa;
    color: rgba(172, 148, 250, var(--placeholder-opacity));
  }
  .md\\:placeholder-purple-500::placeholder {
    --placeholder-opacity: 1;
    color: #9061f9;
    color: rgba(144, 97, 249, var(--placeholder-opacity));
  }
  .md\\:placeholder-purple-600::placeholder {
    --placeholder-opacity: 1;
    color: #7e3af2;
    color: rgba(126, 58, 242, var(--placeholder-opacity));
  }
  .md\\:placeholder-purple-700::placeholder {
    --placeholder-opacity: 1;
    color: #6c2bd9;
    color: rgba(108, 43, 217, var(--placeholder-opacity));
  }
  .md\\:placeholder-purple-800::placeholder {
    --placeholder-opacity: 1;
    color: #5521b5;
    color: rgba(85, 33, 181, var(--placeholder-opacity));
  }
  .md\\:placeholder-purple-900::placeholder {
    --placeholder-opacity: 1;
    color: #4a1d96;
    color: rgba(74, 29, 150, var(--placeholder-opacity));
  }
  .md\\:placeholder-pink-50::placeholder {
    --placeholder-opacity: 1;
    color: #fdf2f8;
    color: rgba(253, 242, 248, var(--placeholder-opacity));
  }
  .md\\:placeholder-pink-100::placeholder {
    --placeholder-opacity: 1;
    color: #fce8f3;
    color: rgba(252, 232, 243, var(--placeholder-opacity));
  }
  .md\\:placeholder-pink-200::placeholder {
    --placeholder-opacity: 1;
    color: #fad1e8;
    color: rgba(250, 209, 232, var(--placeholder-opacity));
  }
  .md\\:placeholder-pink-300::placeholder {
    --placeholder-opacity: 1;
    color: #f8b4d9;
    color: rgba(248, 180, 217, var(--placeholder-opacity));
  }
  .md\\:placeholder-pink-400::placeholder {
    --placeholder-opacity: 1;
    color: #f17eb8;
    color: rgba(241, 126, 184, var(--placeholder-opacity));
  }
  .md\\:placeholder-pink-500::placeholder {
    --placeholder-opacity: 1;
    color: #e74694;
    color: rgba(231, 70, 148, var(--placeholder-opacity));
  }
  .md\\:placeholder-pink-600::placeholder {
    --placeholder-opacity: 1;
    color: #d61f69;
    color: rgba(214, 31, 105, var(--placeholder-opacity));
  }
  .md\\:placeholder-pink-700::placeholder {
    --placeholder-opacity: 1;
    color: #bf125d;
    color: rgba(191, 18, 93, var(--placeholder-opacity));
  }
  .md\\:placeholder-pink-800::placeholder {
    --placeholder-opacity: 1;
    color: #99154b;
    color: rgba(153, 21, 75, var(--placeholder-opacity));
  }
  .md\\:placeholder-pink-900::placeholder {
    --placeholder-opacity: 1;
    color: #751a3d;
    color: rgba(117, 26, 61, var(--placeholder-opacity));
  }
  .md\\:placeholder-cool-gray-50::placeholder {
    --placeholder-opacity: 1;
    color: #f8fafc;
    color: rgba(248, 250, 252, var(--placeholder-opacity));
  }
  .md\\:placeholder-cool-gray-100::placeholder {
    --placeholder-opacity: 1;
    color: #f1f5f9;
    color: rgba(241, 245, 249, var(--placeholder-opacity));
  }
  .md\\:placeholder-cool-gray-200::placeholder {
    --placeholder-opacity: 1;
    color: #e2e8f0;
    color: rgba(226, 232, 240, var(--placeholder-opacity));
  }
  .md\\:placeholder-cool-gray-300::placeholder {
    --placeholder-opacity: 1;
    color: #cfd8e3;
    color: rgba(207, 216, 227, var(--placeholder-opacity));
  }
  .md\\:placeholder-cool-gray-400::placeholder {
    --placeholder-opacity: 1;
    color: #97a6ba;
    color: rgba(151, 166, 186, var(--placeholder-opacity));
  }
  .md\\:placeholder-cool-gray-500::placeholder {
    --placeholder-opacity: 1;
    color: #64748b;
    color: rgba(100, 116, 139, var(--placeholder-opacity));
  }
  .md\\:placeholder-cool-gray-600::placeholder {
    --placeholder-opacity: 1;
    color: #475569;
    color: rgba(71, 85, 105, var(--placeholder-opacity));
  }
  .md\\:placeholder-cool-gray-700::placeholder {
    --placeholder-opacity: 1;
    color: #364152;
    color: rgba(54, 65, 82, var(--placeholder-opacity));
  }
  .md\\:placeholder-cool-gray-800::placeholder {
    --placeholder-opacity: 1;
    color: #27303f;
    color: rgba(39, 48, 63, var(--placeholder-opacity));
  }
  .md\\:placeholder-cool-gray-900::placeholder {
    --placeholder-opacity: 1;
    color: #1a202e;
    color: rgba(26, 32, 46, var(--placeholder-opacity));
  }
  .md\\:focus\\:placeholder-current:focus::placeholder {
    color: currentColor;
  }
  .md\\:focus\\:placeholder-transparent:focus::placeholder {
    color: transparent;
  }
  .md\\:focus\\:placeholder-white:focus::placeholder {
    --placeholder-opacity: 1;
    color: #ffffff;
    color: rgba(255, 255, 255, var(--placeholder-opacity));
  }
  .md\\:focus\\:placeholder-black:focus::placeholder {
    --placeholder-opacity: 1;
    color: #000000;
    color: rgba(0, 0, 0, var(--placeholder-opacity));
  }
  .md\\:focus\\:placeholder-gray-50:focus::placeholder {
    --placeholder-opacity: 1;
    color: #f9fafb;
    color: rgba(249, 250, 251, var(--placeholder-opacity));
  }
  .md\\:focus\\:placeholder-gray-100:focus::placeholder {
    --placeholder-opacity: 1;
    color: #f4f5f7;
    color: rgba(244, 245, 247, var(--placeholder-opacity));
  }
  .md\\:focus\\:placeholder-gray-200:focus::placeholder {
    --placeholder-opacity: 1;
    color: #e5e7eb;
    color: rgba(229, 231, 235, var(--placeholder-opacity));
  }
  .md\\:focus\\:placeholder-gray-300:focus::placeholder {
    --placeholder-opacity: 1;
    color: #d2d6dc;
    color: rgba(210, 214, 220, var(--placeholder-opacity));
  }
  .md\\:focus\\:placeholder-gray-400:focus::placeholder {
    --placeholder-opacity: 1;
    color: #9fa6b2;
    color: rgba(159, 166, 178, var(--placeholder-opacity));
  }
  .md\\:focus\\:placeholder-gray-500:focus::placeholder {
    --placeholder-opacity: 1;
    color: #6b7280;
    color: rgba(107, 114, 128, var(--placeholder-opacity));
  }
  .md\\:focus\\:placeholder-gray-600:focus::placeholder {
    --placeholder-opacity: 1;
    color: #4b5563;
    color: rgba(75, 85, 99, var(--placeholder-opacity));
  }
  .md\\:focus\\:placeholder-gray-700:focus::placeholder {
    --placeholder-opacity: 1;
    color: #374151;
    color: rgba(55, 65, 81, var(--placeholder-opacity));
  }
  .md\\:focus\\:placeholder-gray-800:focus::placeholder {
    --placeholder-opacity: 1;
    color: #252f3f;
    color: rgba(37, 47, 63, var(--placeholder-opacity));
  }
  .md\\:focus\\:placeholder-gray-900:focus::placeholder {
    --placeholder-opacity: 1;
    color: #161e2e;
    color: rgba(22, 30, 46, var(--placeholder-opacity));
  }
  .md\\:focus\\:placeholder-red-50:focus::placeholder {
    --placeholder-opacity: 1;
    color: #fdf2f2;
    color: rgba(253, 242, 242, var(--placeholder-opacity));
  }
  .md\\:focus\\:placeholder-red-100:focus::placeholder {
    --placeholder-opacity: 1;
    color: #fde8e8;
    color: rgba(253, 232, 232, var(--placeholder-opacity));
  }
  .md\\:focus\\:placeholder-red-200:focus::placeholder {
    --placeholder-opacity: 1;
    color: #fbd5d5;
    color: rgba(251, 213, 213, var(--placeholder-opacity));
  }
  .md\\:focus\\:placeholder-red-300:focus::placeholder {
    --placeholder-opacity: 1;
    color: #f8b4b4;
    color: rgba(248, 180, 180, var(--placeholder-opacity));
  }
  .md\\:focus\\:placeholder-red-400:focus::placeholder {
    --placeholder-opacity: 1;
    color: #f98080;
    color: rgba(249, 128, 128, var(--placeholder-opacity));
  }
  .md\\:focus\\:placeholder-red-500:focus::placeholder {
    --placeholder-opacity: 1;
    color: #f05252;
    color: rgba(240, 82, 82, var(--placeholder-opacity));
  }
  .md\\:focus\\:placeholder-red-600:focus::placeholder {
    --placeholder-opacity: 1;
    color: #e02424;
    color: rgba(224, 36, 36, var(--placeholder-opacity));
  }
  .md\\:focus\\:placeholder-red-700:focus::placeholder {
    --placeholder-opacity: 1;
    color: #c81e1e;
    color: rgba(200, 30, 30, var(--placeholder-opacity));
  }
  .md\\:focus\\:placeholder-red-800:focus::placeholder {
    --placeholder-opacity: 1;
    color: #9b1c1c;
    color: rgba(155, 28, 28, var(--placeholder-opacity));
  }
  .md\\:focus\\:placeholder-red-900:focus::placeholder {
    --placeholder-opacity: 1;
    color: #771d1d;
    color: rgba(119, 29, 29, var(--placeholder-opacity));
  }
  .md\\:focus\\:placeholder-orange-50:focus::placeholder {
    --placeholder-opacity: 1;
    color: #fff8f1;
    color: rgba(255, 248, 241, var(--placeholder-opacity));
  }
  .md\\:focus\\:placeholder-orange-100:focus::placeholder {
    --placeholder-opacity: 1;
    color: #feecdc;
    color: rgba(254, 236, 220, var(--placeholder-opacity));
  }
  .md\\:focus\\:placeholder-orange-200:focus::placeholder {
    --placeholder-opacity: 1;
    color: #fcd9bd;
    color: rgba(252, 217, 189, var(--placeholder-opacity));
  }
  .md\\:focus\\:placeholder-orange-300:focus::placeholder {
    --placeholder-opacity: 1;
    color: #fdba8c;
    color: rgba(253, 186, 140, var(--placeholder-opacity));
  }
  .md\\:focus\\:placeholder-orange-400:focus::placeholder {
    --placeholder-opacity: 1;
    color: #ff8a4c;
    color: rgba(255, 138, 76, var(--placeholder-opacity));
  }
  .md\\:focus\\:placeholder-orange-500:focus::placeholder {
    --placeholder-opacity: 1;
    color: #ff5a1f;
    color: rgba(255, 90, 31, var(--placeholder-opacity));
  }
  .md\\:focus\\:placeholder-orange-600:focus::placeholder {
    --placeholder-opacity: 1;
    color: #d03801;
    color: rgba(208, 56, 1, var(--placeholder-opacity));
  }
  .md\\:focus\\:placeholder-orange-700:focus::placeholder {
    --placeholder-opacity: 1;
    color: #b43403;
    color: rgba(180, 52, 3, var(--placeholder-opacity));
  }
  .md\\:focus\\:placeholder-orange-800:focus::placeholder {
    --placeholder-opacity: 1;
    color: #8a2c0d;
    color: rgba(138, 44, 13, var(--placeholder-opacity));
  }
  .md\\:focus\\:placeholder-orange-900:focus::placeholder {
    --placeholder-opacity: 1;
    color: #73230d;
    color: rgba(115, 35, 13, var(--placeholder-opacity));
  }
  .md\\:focus\\:placeholder-yellow-50:focus::placeholder {
    --placeholder-opacity: 1;
    color: #fdfdea;
    color: rgba(253, 253, 234, var(--placeholder-opacity));
  }
  .md\\:focus\\:placeholder-yellow-100:focus::placeholder {
    --placeholder-opacity: 1;
    color: #fdf6b2;
    color: rgba(253, 246, 178, var(--placeholder-opacity));
  }
  .md\\:focus\\:placeholder-yellow-200:focus::placeholder {
    --placeholder-opacity: 1;
    color: #fce96a;
    color: rgba(252, 233, 106, var(--placeholder-opacity));
  }
  .md\\:focus\\:placeholder-yellow-300:focus::placeholder {
    --placeholder-opacity: 1;
    color: #faca15;
    color: rgba(250, 202, 21, var(--placeholder-opacity));
  }
  .md\\:focus\\:placeholder-yellow-400:focus::placeholder {
    --placeholder-opacity: 1;
    color: #e3a008;
    color: rgba(227, 160, 8, var(--placeholder-opacity));
  }
  .md\\:focus\\:placeholder-yellow-500:focus::placeholder {
    --placeholder-opacity: 1;
    color: #c27803;
    color: rgba(194, 120, 3, var(--placeholder-opacity));
  }
  .md\\:focus\\:placeholder-yellow-600:focus::placeholder {
    --placeholder-opacity: 1;
    color: #9f580a;
    color: rgba(159, 88, 10, var(--placeholder-opacity));
  }
  .md\\:focus\\:placeholder-yellow-700:focus::placeholder {
    --placeholder-opacity: 1;
    color: #8e4b10;
    color: rgba(142, 75, 16, var(--placeholder-opacity));
  }
  .md\\:focus\\:placeholder-yellow-800:focus::placeholder {
    --placeholder-opacity: 1;
    color: #723b13;
    color: rgba(114, 59, 19, var(--placeholder-opacity));
  }
  .md\\:focus\\:placeholder-yellow-900:focus::placeholder {
    --placeholder-opacity: 1;
    color: #633112;
    color: rgba(99, 49, 18, var(--placeholder-opacity));
  }
  .md\\:focus\\:placeholder-green-50:focus::placeholder {
    --placeholder-opacity: 1;
    color: #f3faf7;
    color: rgba(243, 250, 247, var(--placeholder-opacity));
  }
  .md\\:focus\\:placeholder-green-100:focus::placeholder {
    --placeholder-opacity: 1;
    color: #def7ec;
    color: rgba(222, 247, 236, var(--placeholder-opacity));
  }
  .md\\:focus\\:placeholder-green-200:focus::placeholder {
    --placeholder-opacity: 1;
    color: #bcf0da;
    color: rgba(188, 240, 218, var(--placeholder-opacity));
  }
  .md\\:focus\\:placeholder-green-300:focus::placeholder {
    --placeholder-opacity: 1;
    color: #84e1bc;
    color: rgba(132, 225, 188, var(--placeholder-opacity));
  }
  .md\\:focus\\:placeholder-green-400:focus::placeholder {
    --placeholder-opacity: 1;
    color: #31c48d;
    color: rgba(49, 196, 141, var(--placeholder-opacity));
  }
  .md\\:focus\\:placeholder-green-500:focus::placeholder {
    --placeholder-opacity: 1;
    color: #0e9f6e;
    color: rgba(14, 159, 110, var(--placeholder-opacity));
  }
  .md\\:focus\\:placeholder-green-600:focus::placeholder {
    --placeholder-opacity: 1;
    color: #057a55;
    color: rgba(5, 122, 85, var(--placeholder-opacity));
  }
  .md\\:focus\\:placeholder-green-700:focus::placeholder {
    --placeholder-opacity: 1;
    color: #046c4e;
    color: rgba(4, 108, 78, var(--placeholder-opacity));
  }
  .md\\:focus\\:placeholder-green-800:focus::placeholder {
    --placeholder-opacity: 1;
    color: #03543f;
    color: rgba(3, 84, 63, var(--placeholder-opacity));
  }
  .md\\:focus\\:placeholder-green-900:focus::placeholder {
    --placeholder-opacity: 1;
    color: #014737;
    color: rgba(1, 71, 55, var(--placeholder-opacity));
  }
  .md\\:focus\\:placeholder-teal-50:focus::placeholder {
    --placeholder-opacity: 1;
    color: #edfafa;
    color: rgba(237, 250, 250, var(--placeholder-opacity));
  }
  .md\\:focus\\:placeholder-teal-100:focus::placeholder {
    --placeholder-opacity: 1;
    color: #d5f5f6;
    color: rgba(213, 245, 246, var(--placeholder-opacity));
  }
  .md\\:focus\\:placeholder-teal-200:focus::placeholder {
    --placeholder-opacity: 1;
    color: #afecef;
    color: rgba(175, 236, 239, var(--placeholder-opacity));
  }
  .md\\:focus\\:placeholder-teal-300:focus::placeholder {
    --placeholder-opacity: 1;
    color: #7edce2;
    color: rgba(126, 220, 226, var(--placeholder-opacity));
  }
  .md\\:focus\\:placeholder-teal-400:focus::placeholder {
    --placeholder-opacity: 1;
    color: #16bdca;
    color: rgba(22, 189, 202, var(--placeholder-opacity));
  }
  .md\\:focus\\:placeholder-teal-500:focus::placeholder {
    --placeholder-opacity: 1;
    color: #0694a2;
    color: rgba(6, 148, 162, var(--placeholder-opacity));
  }
  .md\\:focus\\:placeholder-teal-600:focus::placeholder {
    --placeholder-opacity: 1;
    color: #047481;
    color: rgba(4, 116, 129, var(--placeholder-opacity));
  }
  .md\\:focus\\:placeholder-teal-700:focus::placeholder {
    --placeholder-opacity: 1;
    color: #036672;
    color: rgba(3, 102, 114, var(--placeholder-opacity));
  }
  .md\\:focus\\:placeholder-teal-800:focus::placeholder {
    --placeholder-opacity: 1;
    color: #05505c;
    color: rgba(5, 80, 92, var(--placeholder-opacity));
  }
  .md\\:focus\\:placeholder-teal-900:focus::placeholder {
    --placeholder-opacity: 1;
    color: #014451;
    color: rgba(1, 68, 81, var(--placeholder-opacity));
  }
  .md\\:focus\\:placeholder-blue-50:focus::placeholder {
    --placeholder-opacity: 1;
    color: #ebf5ff;
    color: rgba(235, 245, 255, var(--placeholder-opacity));
  }
  .md\\:focus\\:placeholder-blue-100:focus::placeholder {
    --placeholder-opacity: 1;
    color: #e1effe;
    color: rgba(225, 239, 254, var(--placeholder-opacity));
  }
  .md\\:focus\\:placeholder-blue-200:focus::placeholder {
    --placeholder-opacity: 1;
    color: #c3ddfd;
    color: rgba(195, 221, 253, var(--placeholder-opacity));
  }
  .md\\:focus\\:placeholder-blue-300:focus::placeholder {
    --placeholder-opacity: 1;
    color: #a4cafe;
    color: rgba(164, 202, 254, var(--placeholder-opacity));
  }
  .md\\:focus\\:placeholder-blue-400:focus::placeholder {
    --placeholder-opacity: 1;
    color: #76a9fa;
    color: rgba(118, 169, 250, var(--placeholder-opacity));
  }
  .md\\:focus\\:placeholder-blue-500:focus::placeholder {
    --placeholder-opacity: 1;
    color: #3f83f8;
    color: rgba(63, 131, 248, var(--placeholder-opacity));
  }
  .md\\:focus\\:placeholder-blue-600:focus::placeholder {
    --placeholder-opacity: 1;
    color: #1c64f2;
    color: rgba(28, 100, 242, var(--placeholder-opacity));
  }
  .md\\:focus\\:placeholder-blue-700:focus::placeholder {
    --placeholder-opacity: 1;
    color: #1a56db;
    color: rgba(26, 86, 219, var(--placeholder-opacity));
  }
  .md\\:focus\\:placeholder-blue-800:focus::placeholder {
    --placeholder-opacity: 1;
    color: #1e429f;
    color: rgba(30, 66, 159, var(--placeholder-opacity));
  }
  .md\\:focus\\:placeholder-blue-900:focus::placeholder {
    --placeholder-opacity: 1;
    color: #233876;
    color: rgba(35, 56, 118, var(--placeholder-opacity));
  }
  .md\\:focus\\:placeholder-indigo-50:focus::placeholder {
    --placeholder-opacity: 1;
    color: #f0f5ff;
    color: rgba(240, 245, 255, var(--placeholder-opacity));
  }
  .md\\:focus\\:placeholder-indigo-100:focus::placeholder {
    --placeholder-opacity: 1;
    color: #e5edff;
    color: rgba(229, 237, 255, var(--placeholder-opacity));
  }
  .md\\:focus\\:placeholder-indigo-200:focus::placeholder {
    --placeholder-opacity: 1;
    color: #cddbfe;
    color: rgba(205, 219, 254, var(--placeholder-opacity));
  }
  .md\\:focus\\:placeholder-indigo-300:focus::placeholder {
    --placeholder-opacity: 1;
    color: #b4c6fc;
    color: rgba(180, 198, 252, var(--placeholder-opacity));
  }
  .md\\:focus\\:placeholder-indigo-400:focus::placeholder {
    --placeholder-opacity: 1;
    color: #8da2fb;
    color: rgba(141, 162, 251, var(--placeholder-opacity));
  }
  .md\\:focus\\:placeholder-indigo-500:focus::placeholder {
    --placeholder-opacity: 1;
    color: #6875f5;
    color: rgba(104, 117, 245, var(--placeholder-opacity));
  }
  .md\\:focus\\:placeholder-indigo-600:focus::placeholder {
    --placeholder-opacity: 1;
    color: #5850ec;
    color: rgba(88, 80, 236, var(--placeholder-opacity));
  }
  .md\\:focus\\:placeholder-indigo-700:focus::placeholder {
    --placeholder-opacity: 1;
    color: #5145cd;
    color: rgba(81, 69, 205, var(--placeholder-opacity));
  }
  .md\\:focus\\:placeholder-indigo-800:focus::placeholder {
    --placeholder-opacity: 1;
    color: #42389d;
    color: rgba(66, 56, 157, var(--placeholder-opacity));
  }
  .md\\:focus\\:placeholder-indigo-900:focus::placeholder {
    --placeholder-opacity: 1;
    color: #362f78;
    color: rgba(54, 47, 120, var(--placeholder-opacity));
  }
  .md\\:focus\\:placeholder-purple-50:focus::placeholder {
    --placeholder-opacity: 1;
    color: #f6f5ff;
    color: rgba(246, 245, 255, var(--placeholder-opacity));
  }
  .md\\:focus\\:placeholder-purple-100:focus::placeholder {
    --placeholder-opacity: 1;
    color: #edebfe;
    color: rgba(237, 235, 254, var(--placeholder-opacity));
  }
  .md\\:focus\\:placeholder-purple-200:focus::placeholder {
    --placeholder-opacity: 1;
    color: #dcd7fe;
    color: rgba(220, 215, 254, var(--placeholder-opacity));
  }
  .md\\:focus\\:placeholder-purple-300:focus::placeholder {
    --placeholder-opacity: 1;
    color: #cabffd;
    color: rgba(202, 191, 253, var(--placeholder-opacity));
  }
  .md\\:focus\\:placeholder-purple-400:focus::placeholder {
    --placeholder-opacity: 1;
    color: #ac94fa;
    color: rgba(172, 148, 250, var(--placeholder-opacity));
  }
  .md\\:focus\\:placeholder-purple-500:focus::placeholder {
    --placeholder-opacity: 1;
    color: #9061f9;
    color: rgba(144, 97, 249, var(--placeholder-opacity));
  }
  .md\\:focus\\:placeholder-purple-600:focus::placeholder {
    --placeholder-opacity: 1;
    color: #7e3af2;
    color: rgba(126, 58, 242, var(--placeholder-opacity));
  }
  .md\\:focus\\:placeholder-purple-700:focus::placeholder {
    --placeholder-opacity: 1;
    color: #6c2bd9;
    color: rgba(108, 43, 217, var(--placeholder-opacity));
  }
  .md\\:focus\\:placeholder-purple-800:focus::placeholder {
    --placeholder-opacity: 1;
    color: #5521b5;
    color: rgba(85, 33, 181, var(--placeholder-opacity));
  }
  .md\\:focus\\:placeholder-purple-900:focus::placeholder {
    --placeholder-opacity: 1;
    color: #4a1d96;
    color: rgba(74, 29, 150, var(--placeholder-opacity));
  }
  .md\\:focus\\:placeholder-pink-50:focus::placeholder {
    --placeholder-opacity: 1;
    color: #fdf2f8;
    color: rgba(253, 242, 248, var(--placeholder-opacity));
  }
  .md\\:focus\\:placeholder-pink-100:focus::placeholder {
    --placeholder-opacity: 1;
    color: #fce8f3;
    color: rgba(252, 232, 243, var(--placeholder-opacity));
  }
  .md\\:focus\\:placeholder-pink-200:focus::placeholder {
    --placeholder-opacity: 1;
    color: #fad1e8;
    color: rgba(250, 209, 232, var(--placeholder-opacity));
  }
  .md\\:focus\\:placeholder-pink-300:focus::placeholder {
    --placeholder-opacity: 1;
    color: #f8b4d9;
    color: rgba(248, 180, 217, var(--placeholder-opacity));
  }
  .md\\:focus\\:placeholder-pink-400:focus::placeholder {
    --placeholder-opacity: 1;
    color: #f17eb8;
    color: rgba(241, 126, 184, var(--placeholder-opacity));
  }
  .md\\:focus\\:placeholder-pink-500:focus::placeholder {
    --placeholder-opacity: 1;
    color: #e74694;
    color: rgba(231, 70, 148, var(--placeholder-opacity));
  }
  .md\\:focus\\:placeholder-pink-600:focus::placeholder {
    --placeholder-opacity: 1;
    color: #d61f69;
    color: rgba(214, 31, 105, var(--placeholder-opacity));
  }
  .md\\:focus\\:placeholder-pink-700:focus::placeholder {
    --placeholder-opacity: 1;
    color: #bf125d;
    color: rgba(191, 18, 93, var(--placeholder-opacity));
  }
  .md\\:focus\\:placeholder-pink-800:focus::placeholder {
    --placeholder-opacity: 1;
    color: #99154b;
    color: rgba(153, 21, 75, var(--placeholder-opacity));
  }
  .md\\:focus\\:placeholder-pink-900:focus::placeholder {
    --placeholder-opacity: 1;
    color: #751a3d;
    color: rgba(117, 26, 61, var(--placeholder-opacity));
  }
  .md\\:focus\\:placeholder-cool-gray-50:focus::placeholder {
    --placeholder-opacity: 1;
    color: #f8fafc;
    color: rgba(248, 250, 252, var(--placeholder-opacity));
  }
  .md\\:focus\\:placeholder-cool-gray-100:focus::placeholder {
    --placeholder-opacity: 1;
    color: #f1f5f9;
    color: rgba(241, 245, 249, var(--placeholder-opacity));
  }
  .md\\:focus\\:placeholder-cool-gray-200:focus::placeholder {
    --placeholder-opacity: 1;
    color: #e2e8f0;
    color: rgba(226, 232, 240, var(--placeholder-opacity));
  }
  .md\\:focus\\:placeholder-cool-gray-300:focus::placeholder {
    --placeholder-opacity: 1;
    color: #cfd8e3;
    color: rgba(207, 216, 227, var(--placeholder-opacity));
  }
  .md\\:focus\\:placeholder-cool-gray-400:focus::placeholder {
    --placeholder-opacity: 1;
    color: #97a6ba;
    color: rgba(151, 166, 186, var(--placeholder-opacity));
  }
  .md\\:focus\\:placeholder-cool-gray-500:focus::placeholder {
    --placeholder-opacity: 1;
    color: #64748b;
    color: rgba(100, 116, 139, var(--placeholder-opacity));
  }
  .md\\:focus\\:placeholder-cool-gray-600:focus::placeholder {
    --placeholder-opacity: 1;
    color: #475569;
    color: rgba(71, 85, 105, var(--placeholder-opacity));
  }
  .md\\:focus\\:placeholder-cool-gray-700:focus::placeholder {
    --placeholder-opacity: 1;
    color: #364152;
    color: rgba(54, 65, 82, var(--placeholder-opacity));
  }
  .md\\:focus\\:placeholder-cool-gray-800:focus::placeholder {
    --placeholder-opacity: 1;
    color: #27303f;
    color: rgba(39, 48, 63, var(--placeholder-opacity));
  }
  .md\\:focus\\:placeholder-cool-gray-900:focus::placeholder {
    --placeholder-opacity: 1;
    color: #1a202e;
    color: rgba(26, 32, 46, var(--placeholder-opacity));
  }
  .md\\:placeholder-opacity-0::placeholder {
    --placeholder-opacity: 0;
  }
  .md\\:placeholder-opacity-25::placeholder {
    --placeholder-opacity: 0.25;
  }
  .md\\:placeholder-opacity-50::placeholder {
    --placeholder-opacity: 0.5;
  }
  .md\\:placeholder-opacity-75::placeholder {
    --placeholder-opacity: 0.75;
  }
  .md\\:placeholder-opacity-100::placeholder {
    --placeholder-opacity: 1;
  }
  .md\\:focus\\:placeholder-opacity-0:focus::placeholder {
    --placeholder-opacity: 0;
  }
  .md\\:focus\\:placeholder-opacity-25:focus::placeholder {
    --placeholder-opacity: 0.25;
  }
  .md\\:focus\\:placeholder-opacity-50:focus::placeholder {
    --placeholder-opacity: 0.5;
  }
  .md\\:focus\\:placeholder-opacity-75:focus::placeholder {
    --placeholder-opacity: 0.75;
  }
  .md\\:focus\\:placeholder-opacity-100:focus::placeholder {
    --placeholder-opacity: 1;
  }
  .md\\:pointer-events-none {
    pointer-events: none;
  }
  .md\\:pointer-events-auto {
    pointer-events: auto;
  }
  .md\\:static {
    position: static;
  }
  .md\\:fixed {
    position: fixed;
  }
  .md\\:absolute {
    position: absolute;
  }
  .md\\:relative {
    position: relative;
  }
  .md\\:sticky {
    position: sticky;
  }
  .md\\:inset-0 {
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
  }
  .md\\:inset-1 {
    top: 0.25rem;
    right: 0.25rem;
    bottom: 0.25rem;
    left: 0.25rem;
  }
  .md\\:inset-2 {
    top: 0.5rem;
    right: 0.5rem;
    bottom: 0.5rem;
    left: 0.5rem;
  }
  .md\\:inset-3 {
    top: 0.75rem;
    right: 0.75rem;
    bottom: 0.75rem;
    left: 0.75rem;
  }
  .md\\:inset-4 {
    top: 1rem;
    right: 1rem;
    bottom: 1rem;
    left: 1rem;
  }
  .md\\:inset-5 {
    top: 1.25rem;
    right: 1.25rem;
    bottom: 1.25rem;
    left: 1.25rem;
  }
  .md\\:inset-6 {
    top: 1.5rem;
    right: 1.5rem;
    bottom: 1.5rem;
    left: 1.5rem;
  }
  .md\\:inset-7 {
    top: 1.75rem;
    right: 1.75rem;
    bottom: 1.75rem;
    left: 1.75rem;
  }
  .md\\:inset-8 {
    top: 2rem;
    right: 2rem;
    bottom: 2rem;
    left: 2rem;
  }
  .md\\:inset-9 {
    top: 2.25rem;
    right: 2.25rem;
    bottom: 2.25rem;
    left: 2.25rem;
  }
  .md\\:inset-10 {
    top: 2.5rem;
    right: 2.5rem;
    bottom: 2.5rem;
    left: 2.5rem;
  }
  .md\\:inset-11 {
    top: 2.75rem;
    right: 2.75rem;
    bottom: 2.75rem;
    left: 2.75rem;
  }
  .md\\:inset-12 {
    top: 3rem;
    right: 3rem;
    bottom: 3rem;
    left: 3rem;
  }
  .md\\:inset-13 {
    top: 3.25rem;
    right: 3.25rem;
    bottom: 3.25rem;
    left: 3.25rem;
  }
  .md\\:inset-14 {
    top: 3.5rem;
    right: 3.5rem;
    bottom: 3.5rem;
    left: 3.5rem;
  }
  .md\\:inset-15 {
    top: 3.75rem;
    right: 3.75rem;
    bottom: 3.75rem;
    left: 3.75rem;
  }
  .md\\:inset-16 {
    top: 4rem;
    right: 4rem;
    bottom: 4rem;
    left: 4rem;
  }
  .md\\:inset-20 {
    top: 5rem;
    right: 5rem;
    bottom: 5rem;
    left: 5rem;
  }
  .md\\:inset-24 {
    top: 6rem;
    right: 6rem;
    bottom: 6rem;
    left: 6rem;
  }
  .md\\:inset-28 {
    top: 7rem;
    right: 7rem;
    bottom: 7rem;
    left: 7rem;
  }
  .md\\:inset-32 {
    top: 8rem;
    right: 8rem;
    bottom: 8rem;
    left: 8rem;
  }
  .md\\:inset-36 {
    top: 9rem;
    right: 9rem;
    bottom: 9rem;
    left: 9rem;
  }
  .md\\:inset-40 {
    top: 10rem;
    right: 10rem;
    bottom: 10rem;
    left: 10rem;
  }
  .md\\:inset-44 {
    top: 11rem;
    right: 11rem;
    bottom: 11rem;
    left: 11rem;
  }
  .md\\:inset-48 {
    top: 12rem;
    right: 12rem;
    bottom: 12rem;
    left: 12rem;
  }
  .md\\:inset-52 {
    top: 13rem;
    right: 13rem;
    bottom: 13rem;
    left: 13rem;
  }
  .md\\:inset-56 {
    top: 14rem;
    right: 14rem;
    bottom: 14rem;
    left: 14rem;
  }
  .md\\:inset-60 {
    top: 15rem;
    right: 15rem;
    bottom: 15rem;
    left: 15rem;
  }
  .md\\:inset-64 {
    top: 16rem;
    right: 16rem;
    bottom: 16rem;
    left: 16rem;
  }
  .md\\:inset-72 {
    top: 18rem;
    right: 18rem;
    bottom: 18rem;
    left: 18rem;
  }
  .md\\:inset-80 {
    top: 20rem;
    right: 20rem;
    bottom: 20rem;
    left: 20rem;
  }
  .md\\:inset-96 {
    top: 24rem;
    right: 24rem;
    bottom: 24rem;
    left: 24rem;
  }
  .md\\:inset-auto {
    top: auto;
    right: auto;
    bottom: auto;
    left: auto;
  }
  .md\\:inset-px {
    top: 1px;
    right: 1px;
    bottom: 1px;
    left: 1px;
  }
  .md\\:inset-0\\.5 {
    top: 0.125rem;
    right: 0.125rem;
    bottom: 0.125rem;
    left: 0.125rem;
  }
  .md\\:inset-1\\.5 {
    top: 0.375rem;
    right: 0.375rem;
    bottom: 0.375rem;
    left: 0.375rem;
  }
  .md\\:inset-2\\.5 {
    top: 0.625rem;
    right: 0.625rem;
    bottom: 0.625rem;
    left: 0.625rem;
  }
  .md\\:inset-3\\.5 {
    top: 0.875rem;
    right: 0.875rem;
    bottom: 0.875rem;
    left: 0.875rem;
  }
  .md\\:inset-1\\/2 {
    top: 50%;
    right: 50%;
    bottom: 50%;
    left: 50%;
  }
  .md\\:inset-1\\/3 {
    top: 33.333333%;
    right: 33.333333%;
    bottom: 33.333333%;
    left: 33.333333%;
  }
  .md\\:inset-2\\/3 {
    top: 66.666667%;
    right: 66.666667%;
    bottom: 66.666667%;
    left: 66.666667%;
  }
  .md\\:inset-1\\/4 {
    top: 25%;
    right: 25%;
    bottom: 25%;
    left: 25%;
  }
  .md\\:inset-2\\/4 {
    top: 50%;
    right: 50%;
    bottom: 50%;
    left: 50%;
  }
  .md\\:inset-3\\/4 {
    top: 75%;
    right: 75%;
    bottom: 75%;
    left: 75%;
  }
  .md\\:inset-1\\/5 {
    top: 20%;
    right: 20%;
    bottom: 20%;
    left: 20%;
  }
  .md\\:inset-2\\/5 {
    top: 40%;
    right: 40%;
    bottom: 40%;
    left: 40%;
  }
  .md\\:inset-3\\/5 {
    top: 60%;
    right: 60%;
    bottom: 60%;
    left: 60%;
  }
  .md\\:inset-4\\/5 {
    top: 80%;
    right: 80%;
    bottom: 80%;
    left: 80%;
  }
  .md\\:inset-1\\/6 {
    top: 16.666667%;
    right: 16.666667%;
    bottom: 16.666667%;
    left: 16.666667%;
  }
  .md\\:inset-2\\/6 {
    top: 33.333333%;
    right: 33.333333%;
    bottom: 33.333333%;
    left: 33.333333%;
  }
  .md\\:inset-3\\/6 {
    top: 50%;
    right: 50%;
    bottom: 50%;
    left: 50%;
  }
  .md\\:inset-4\\/6 {
    top: 66.666667%;
    right: 66.666667%;
    bottom: 66.666667%;
    left: 66.666667%;
  }
  .md\\:inset-5\\/6 {
    top: 83.333333%;
    right: 83.333333%;
    bottom: 83.333333%;
    left: 83.333333%;
  }
  .md\\:inset-1\\/12 {
    top: 8.333333%;
    right: 8.333333%;
    bottom: 8.333333%;
    left: 8.333333%;
  }
  .md\\:inset-2\\/12 {
    top: 16.666667%;
    right: 16.666667%;
    bottom: 16.666667%;
    left: 16.666667%;
  }
  .md\\:inset-3\\/12 {
    top: 25%;
    right: 25%;
    bottom: 25%;
    left: 25%;
  }
  .md\\:inset-4\\/12 {
    top: 33.333333%;
    right: 33.333333%;
    bottom: 33.333333%;
    left: 33.333333%;
  }
  .md\\:inset-5\\/12 {
    top: 41.666667%;
    right: 41.666667%;
    bottom: 41.666667%;
    left: 41.666667%;
  }
  .md\\:inset-6\\/12 {
    top: 50%;
    right: 50%;
    bottom: 50%;
    left: 50%;
  }
  .md\\:inset-7\\/12 {
    top: 58.333333%;
    right: 58.333333%;
    bottom: 58.333333%;
    left: 58.333333%;
  }
  .md\\:inset-8\\/12 {
    top: 66.666667%;
    right: 66.666667%;
    bottom: 66.666667%;
    left: 66.666667%;
  }
  .md\\:inset-9\\/12 {
    top: 75%;
    right: 75%;
    bottom: 75%;
    left: 75%;
  }
  .md\\:inset-10\\/12 {
    top: 83.333333%;
    right: 83.333333%;
    bottom: 83.333333%;
    left: 83.333333%;
  }
  .md\\:inset-11\\/12 {
    top: 91.666667%;
    right: 91.666667%;
    bottom: 91.666667%;
    left: 91.666667%;
  }
  .md\\:inset-full {
    top: 100%;
    right: 100%;
    bottom: 100%;
    left: 100%;
  }
  .md\\:inset-y-0 {
    top: 0;
    bottom: 0;
  }
  .md\\:inset-x-0 {
    right: 0;
    left: 0;
  }
  .md\\:inset-y-1 {
    top: 0.25rem;
    bottom: 0.25rem;
  }
  .md\\:inset-x-1 {
    right: 0.25rem;
    left: 0.25rem;
  }
  .md\\:inset-y-2 {
    top: 0.5rem;
    bottom: 0.5rem;
  }
  .md\\:inset-x-2 {
    right: 0.5rem;
    left: 0.5rem;
  }
  .md\\:inset-y-3 {
    top: 0.75rem;
    bottom: 0.75rem;
  }
  .md\\:inset-x-3 {
    right: 0.75rem;
    left: 0.75rem;
  }
  .md\\:inset-y-4 {
    top: 1rem;
    bottom: 1rem;
  }
  .md\\:inset-x-4 {
    right: 1rem;
    left: 1rem;
  }
  .md\\:inset-y-5 {
    top: 1.25rem;
    bottom: 1.25rem;
  }
  .md\\:inset-x-5 {
    right: 1.25rem;
    left: 1.25rem;
  }
  .md\\:inset-y-6 {
    top: 1.5rem;
    bottom: 1.5rem;
  }
  .md\\:inset-x-6 {
    right: 1.5rem;
    left: 1.5rem;
  }
  .md\\:inset-y-7 {
    top: 1.75rem;
    bottom: 1.75rem;
  }
  .md\\:inset-x-7 {
    right: 1.75rem;
    left: 1.75rem;
  }
  .md\\:inset-y-8 {
    top: 2rem;
    bottom: 2rem;
  }
  .md\\:inset-x-8 {
    right: 2rem;
    left: 2rem;
  }
  .md\\:inset-y-9 {
    top: 2.25rem;
    bottom: 2.25rem;
  }
  .md\\:inset-x-9 {
    right: 2.25rem;
    left: 2.25rem;
  }
  .md\\:inset-y-10 {
    top: 2.5rem;
    bottom: 2.5rem;
  }
  .md\\:inset-x-10 {
    right: 2.5rem;
    left: 2.5rem;
  }
  .md\\:inset-y-11 {
    top: 2.75rem;
    bottom: 2.75rem;
  }
  .md\\:inset-x-11 {
    right: 2.75rem;
    left: 2.75rem;
  }
  .md\\:inset-y-12 {
    top: 3rem;
    bottom: 3rem;
  }
  .md\\:inset-x-12 {
    right: 3rem;
    left: 3rem;
  }
  .md\\:inset-y-13 {
    top: 3.25rem;
    bottom: 3.25rem;
  }
  .md\\:inset-x-13 {
    right: 3.25rem;
    left: 3.25rem;
  }
  .md\\:inset-y-14 {
    top: 3.5rem;
    bottom: 3.5rem;
  }
  .md\\:inset-x-14 {
    right: 3.5rem;
    left: 3.5rem;
  }
  .md\\:inset-y-15 {
    top: 3.75rem;
    bottom: 3.75rem;
  }
  .md\\:inset-x-15 {
    right: 3.75rem;
    left: 3.75rem;
  }
  .md\\:inset-y-16 {
    top: 4rem;
    bottom: 4rem;
  }
  .md\\:inset-x-16 {
    right: 4rem;
    left: 4rem;
  }
  .md\\:inset-y-20 {
    top: 5rem;
    bottom: 5rem;
  }
  .md\\:inset-x-20 {
    right: 5rem;
    left: 5rem;
  }
  .md\\:inset-y-24 {
    top: 6rem;
    bottom: 6rem;
  }
  .md\\:inset-x-24 {
    right: 6rem;
    left: 6rem;
  }
  .md\\:inset-y-28 {
    top: 7rem;
    bottom: 7rem;
  }
  .md\\:inset-x-28 {
    right: 7rem;
    left: 7rem;
  }
  .md\\:inset-y-32 {
    top: 8rem;
    bottom: 8rem;
  }
  .md\\:inset-x-32 {
    right: 8rem;
    left: 8rem;
  }
  .md\\:inset-y-36 {
    top: 9rem;
    bottom: 9rem;
  }
  .md\\:inset-x-36 {
    right: 9rem;
    left: 9rem;
  }
  .md\\:inset-y-40 {
    top: 10rem;
    bottom: 10rem;
  }
  .md\\:inset-x-40 {
    right: 10rem;
    left: 10rem;
  }
  .md\\:inset-y-44 {
    top: 11rem;
    bottom: 11rem;
  }
  .md\\:inset-x-44 {
    right: 11rem;
    left: 11rem;
  }
  .md\\:inset-y-48 {
    top: 12rem;
    bottom: 12rem;
  }
  .md\\:inset-x-48 {
    right: 12rem;
    left: 12rem;
  }
  .md\\:inset-y-52 {
    top: 13rem;
    bottom: 13rem;
  }
  .md\\:inset-x-52 {
    right: 13rem;
    left: 13rem;
  }
  .md\\:inset-y-56 {
    top: 14rem;
    bottom: 14rem;
  }
  .md\\:inset-x-56 {
    right: 14rem;
    left: 14rem;
  }
  .md\\:inset-y-60 {
    top: 15rem;
    bottom: 15rem;
  }
  .md\\:inset-x-60 {
    right: 15rem;
    left: 15rem;
  }
  .md\\:inset-y-64 {
    top: 16rem;
    bottom: 16rem;
  }
  .md\\:inset-x-64 {
    right: 16rem;
    left: 16rem;
  }
  .md\\:inset-y-72 {
    top: 18rem;
    bottom: 18rem;
  }
  .md\\:inset-x-72 {
    right: 18rem;
    left: 18rem;
  }
  .md\\:inset-y-80 {
    top: 20rem;
    bottom: 20rem;
  }
  .md\\:inset-x-80 {
    right: 20rem;
    left: 20rem;
  }
  .md\\:inset-y-96 {
    top: 24rem;
    bottom: 24rem;
  }
  .md\\:inset-x-96 {
    right: 24rem;
    left: 24rem;
  }
  .md\\:inset-y-auto {
    top: auto;
    bottom: auto;
  }
  .md\\:inset-x-auto {
    right: auto;
    left: auto;
  }
  .md\\:inset-y-px {
    top: 1px;
    bottom: 1px;
  }
  .md\\:inset-x-px {
    right: 1px;
    left: 1px;
  }
  .md\\:inset-y-0\\.5 {
    top: 0.125rem;
    bottom: 0.125rem;
  }
  .md\\:inset-x-0\\.5 {
    right: 0.125rem;
    left: 0.125rem;
  }
  .md\\:inset-y-1\\.5 {
    top: 0.375rem;
    bottom: 0.375rem;
  }
  .md\\:inset-x-1\\.5 {
    right: 0.375rem;
    left: 0.375rem;
  }
  .md\\:inset-y-2\\.5 {
    top: 0.625rem;
    bottom: 0.625rem;
  }
  .md\\:inset-x-2\\.5 {
    right: 0.625rem;
    left: 0.625rem;
  }
  .md\\:inset-y-3\\.5 {
    top: 0.875rem;
    bottom: 0.875rem;
  }
  .md\\:inset-x-3\\.5 {
    right: 0.875rem;
    left: 0.875rem;
  }
  .md\\:inset-y-1\\/2 {
    top: 50%;
    bottom: 50%;
  }
  .md\\:inset-x-1\\/2 {
    right: 50%;
    left: 50%;
  }
  .md\\:inset-y-1\\/3 {
    top: 33.333333%;
    bottom: 33.333333%;
  }
  .md\\:inset-x-1\\/3 {
    right: 33.333333%;
    left: 33.333333%;
  }
  .md\\:inset-y-2\\/3 {
    top: 66.666667%;
    bottom: 66.666667%;
  }
  .md\\:inset-x-2\\/3 {
    right: 66.666667%;
    left: 66.666667%;
  }
  .md\\:inset-y-1\\/4 {
    top: 25%;
    bottom: 25%;
  }
  .md\\:inset-x-1\\/4 {
    right: 25%;
    left: 25%;
  }
  .md\\:inset-y-2\\/4 {
    top: 50%;
    bottom: 50%;
  }
  .md\\:inset-x-2\\/4 {
    right: 50%;
    left: 50%;
  }
  .md\\:inset-y-3\\/4 {
    top: 75%;
    bottom: 75%;
  }
  .md\\:inset-x-3\\/4 {
    right: 75%;
    left: 75%;
  }
  .md\\:inset-y-1\\/5 {
    top: 20%;
    bottom: 20%;
  }
  .md\\:inset-x-1\\/5 {
    right: 20%;
    left: 20%;
  }
  .md\\:inset-y-2\\/5 {
    top: 40%;
    bottom: 40%;
  }
  .md\\:inset-x-2\\/5 {
    right: 40%;
    left: 40%;
  }
  .md\\:inset-y-3\\/5 {
    top: 60%;
    bottom: 60%;
  }
  .md\\:inset-x-3\\/5 {
    right: 60%;
    left: 60%;
  }
  .md\\:inset-y-4\\/5 {
    top: 80%;
    bottom: 80%;
  }
  .md\\:inset-x-4\\/5 {
    right: 80%;
    left: 80%;
  }
  .md\\:inset-y-1\\/6 {
    top: 16.666667%;
    bottom: 16.666667%;
  }
  .md\\:inset-x-1\\/6 {
    right: 16.666667%;
    left: 16.666667%;
  }
  .md\\:inset-y-2\\/6 {
    top: 33.333333%;
    bottom: 33.333333%;
  }
  .md\\:inset-x-2\\/6 {
    right: 33.333333%;
    left: 33.333333%;
  }
  .md\\:inset-y-3\\/6 {
    top: 50%;
    bottom: 50%;
  }
  .md\\:inset-x-3\\/6 {
    right: 50%;
    left: 50%;
  }
  .md\\:inset-y-4\\/6 {
    top: 66.666667%;
    bottom: 66.666667%;
  }
  .md\\:inset-x-4\\/6 {
    right: 66.666667%;
    left: 66.666667%;
  }
  .md\\:inset-y-5\\/6 {
    top: 83.333333%;
    bottom: 83.333333%;
  }
  .md\\:inset-x-5\\/6 {
    right: 83.333333%;
    left: 83.333333%;
  }
  .md\\:inset-y-1\\/12 {
    top: 8.333333%;
    bottom: 8.333333%;
  }
  .md\\:inset-x-1\\/12 {
    right: 8.333333%;
    left: 8.333333%;
  }
  .md\\:inset-y-2\\/12 {
    top: 16.666667%;
    bottom: 16.666667%;
  }
  .md\\:inset-x-2\\/12 {
    right: 16.666667%;
    left: 16.666667%;
  }
  .md\\:inset-y-3\\/12 {
    top: 25%;
    bottom: 25%;
  }
  .md\\:inset-x-3\\/12 {
    right: 25%;
    left: 25%;
  }
  .md\\:inset-y-4\\/12 {
    top: 33.333333%;
    bottom: 33.333333%;
  }
  .md\\:inset-x-4\\/12 {
    right: 33.333333%;
    left: 33.333333%;
  }
  .md\\:inset-y-5\\/12 {
    top: 41.666667%;
    bottom: 41.666667%;
  }
  .md\\:inset-x-5\\/12 {
    right: 41.666667%;
    left: 41.666667%;
  }
  .md\\:inset-y-6\\/12 {
    top: 50%;
    bottom: 50%;
  }
  .md\\:inset-x-6\\/12 {
    right: 50%;
    left: 50%;
  }
  .md\\:inset-y-7\\/12 {
    top: 58.333333%;
    bottom: 58.333333%;
  }
  .md\\:inset-x-7\\/12 {
    right: 58.333333%;
    left: 58.333333%;
  }
  .md\\:inset-y-8\\/12 {
    top: 66.666667%;
    bottom: 66.666667%;
  }
  .md\\:inset-x-8\\/12 {
    right: 66.666667%;
    left: 66.666667%;
  }
  .md\\:inset-y-9\\/12 {
    top: 75%;
    bottom: 75%;
  }
  .md\\:inset-x-9\\/12 {
    right: 75%;
    left: 75%;
  }
  .md\\:inset-y-10\\/12 {
    top: 83.333333%;
    bottom: 83.333333%;
  }
  .md\\:inset-x-10\\/12 {
    right: 83.333333%;
    left: 83.333333%;
  }
  .md\\:inset-y-11\\/12 {
    top: 91.666667%;
    bottom: 91.666667%;
  }
  .md\\:inset-x-11\\/12 {
    right: 91.666667%;
    left: 91.666667%;
  }
  .md\\:inset-y-full {
    top: 100%;
    bottom: 100%;
  }
  .md\\:inset-x-full {
    right: 100%;
    left: 100%;
  }
  .md\\:top-0 {
    top: 0;
  }
  .md\\:right-0 {
    right: 0;
  }
  .md\\:bottom-0 {
    bottom: 0;
  }
  .md\\:left-0 {
    left: 0;
  }
  .md\\:top-1 {
    top: 0.25rem;
  }
  .md\\:right-1 {
    right: 0.25rem;
  }
  .md\\:bottom-1 {
    bottom: 0.25rem;
  }
  .md\\:left-1 {
    left: 0.25rem;
  }
  .md\\:top-2 {
    top: 0.5rem;
  }
  .md\\:right-2 {
    right: 0.5rem;
  }
  .md\\:bottom-2 {
    bottom: 0.5rem;
  }
  .md\\:left-2 {
    left: 0.5rem;
  }
  .md\\:top-3 {
    top: 0.75rem;
  }
  .md\\:right-3 {
    right: 0.75rem;
  }
  .md\\:bottom-3 {
    bottom: 0.75rem;
  }
  .md\\:left-3 {
    left: 0.75rem;
  }
  .md\\:top-4 {
    top: 1rem;
  }
  .md\\:right-4 {
    right: 1rem;
  }
  .md\\:bottom-4 {
    bottom: 1rem;
  }
  .md\\:left-4 {
    left: 1rem;
  }
  .md\\:top-5 {
    top: 1.25rem;
  }
  .md\\:right-5 {
    right: 1.25rem;
  }
  .md\\:bottom-5 {
    bottom: 1.25rem;
  }
  .md\\:left-5 {
    left: 1.25rem;
  }
  .md\\:top-6 {
    top: 1.5rem;
  }
  .md\\:right-6 {
    right: 1.5rem;
  }
  .md\\:bottom-6 {
    bottom: 1.5rem;
  }
  .md\\:left-6 {
    left: 1.5rem;
  }
  .md\\:top-7 {
    top: 1.75rem;
  }
  .md\\:right-7 {
    right: 1.75rem;
  }
  .md\\:bottom-7 {
    bottom: 1.75rem;
  }
  .md\\:left-7 {
    left: 1.75rem;
  }
  .md\\:top-8 {
    top: 2rem;
  }
  .md\\:right-8 {
    right: 2rem;
  }
  .md\\:bottom-8 {
    bottom: 2rem;
  }
  .md\\:left-8 {
    left: 2rem;
  }
  .md\\:top-9 {
    top: 2.25rem;
  }
  .md\\:right-9 {
    right: 2.25rem;
  }
  .md\\:bottom-9 {
    bottom: 2.25rem;
  }
  .md\\:left-9 {
    left: 2.25rem;
  }
  .md\\:top-10 {
    top: 2.5rem;
  }
  .md\\:right-10 {
    right: 2.5rem;
  }
  .md\\:bottom-10 {
    bottom: 2.5rem;
  }
  .md\\:left-10 {
    left: 2.5rem;
  }
  .md\\:top-11 {
    top: 2.75rem;
  }
  .md\\:right-11 {
    right: 2.75rem;
  }
  .md\\:bottom-11 {
    bottom: 2.75rem;
  }
  .md\\:left-11 {
    left: 2.75rem;
  }
  .md\\:top-12 {
    top: 3rem;
  }
  .md\\:right-12 {
    right: 3rem;
  }
  .md\\:bottom-12 {
    bottom: 3rem;
  }
  .md\\:left-12 {
    left: 3rem;
  }
  .md\\:top-13 {
    top: 3.25rem;
  }
  .md\\:right-13 {
    right: 3.25rem;
  }
  .md\\:bottom-13 {
    bottom: 3.25rem;
  }
  .md\\:left-13 {
    left: 3.25rem;
  }
  .md\\:top-14 {
    top: 3.5rem;
  }
  .md\\:right-14 {
    right: 3.5rem;
  }
  .md\\:bottom-14 {
    bottom: 3.5rem;
  }
  .md\\:left-14 {
    left: 3.5rem;
  }
  .md\\:top-15 {
    top: 3.75rem;
  }
  .md\\:right-15 {
    right: 3.75rem;
  }
  .md\\:bottom-15 {
    bottom: 3.75rem;
  }
  .md\\:left-15 {
    left: 3.75rem;
  }
  .md\\:top-16 {
    top: 4rem;
  }
  .md\\:right-16 {
    right: 4rem;
  }
  .md\\:bottom-16 {
    bottom: 4rem;
  }
  .md\\:left-16 {
    left: 4rem;
  }
  .md\\:top-20 {
    top: 5rem;
  }
  .md\\:right-20 {
    right: 5rem;
  }
  .md\\:bottom-20 {
    bottom: 5rem;
  }
  .md\\:left-20 {
    left: 5rem;
  }
  .md\\:top-24 {
    top: 6rem;
  }
  .md\\:right-24 {
    right: 6rem;
  }
  .md\\:bottom-24 {
    bottom: 6rem;
  }
  .md\\:left-24 {
    left: 6rem;
  }
  .md\\:top-28 {
    top: 7rem;
  }
  .md\\:right-28 {
    right: 7rem;
  }
  .md\\:bottom-28 {
    bottom: 7rem;
  }
  .md\\:left-28 {
    left: 7rem;
  }
  .md\\:top-32 {
    top: 8rem;
  }
  .md\\:right-32 {
    right: 8rem;
  }
  .md\\:bottom-32 {
    bottom: 8rem;
  }
  .md\\:left-32 {
    left: 8rem;
  }
  .md\\:top-36 {
    top: 9rem;
  }
  .md\\:right-36 {
    right: 9rem;
  }
  .md\\:bottom-36 {
    bottom: 9rem;
  }
  .md\\:left-36 {
    left: 9rem;
  }
  .md\\:top-40 {
    top: 10rem;
  }
  .md\\:right-40 {
    right: 10rem;
  }
  .md\\:bottom-40 {
    bottom: 10rem;
  }
  .md\\:left-40 {
    left: 10rem;
  }
  .md\\:top-44 {
    top: 11rem;
  }
  .md\\:right-44 {
    right: 11rem;
  }
  .md\\:bottom-44 {
    bottom: 11rem;
  }
  .md\\:left-44 {
    left: 11rem;
  }
  .md\\:top-48 {
    top: 12rem;
  }
  .md\\:right-48 {
    right: 12rem;
  }
  .md\\:bottom-48 {
    bottom: 12rem;
  }
  .md\\:left-48 {
    left: 12rem;
  }
  .md\\:top-52 {
    top: 13rem;
  }
  .md\\:right-52 {
    right: 13rem;
  }
  .md\\:bottom-52 {
    bottom: 13rem;
  }
  .md\\:left-52 {
    left: 13rem;
  }
  .md\\:top-56 {
    top: 14rem;
  }
  .md\\:right-56 {
    right: 14rem;
  }
  .md\\:bottom-56 {
    bottom: 14rem;
  }
  .md\\:left-56 {
    left: 14rem;
  }
  .md\\:top-60 {
    top: 15rem;
  }
  .md\\:right-60 {
    right: 15rem;
  }
  .md\\:bottom-60 {
    bottom: 15rem;
  }
  .md\\:left-60 {
    left: 15rem;
  }
  .md\\:top-64 {
    top: 16rem;
  }
  .md\\:right-64 {
    right: 16rem;
  }
  .md\\:bottom-64 {
    bottom: 16rem;
  }
  .md\\:left-64 {
    left: 16rem;
  }
  .md\\:top-72 {
    top: 18rem;
  }
  .md\\:right-72 {
    right: 18rem;
  }
  .md\\:bottom-72 {
    bottom: 18rem;
  }
  .md\\:left-72 {
    left: 18rem;
  }
  .md\\:top-80 {
    top: 20rem;
  }
  .md\\:right-80 {
    right: 20rem;
  }
  .md\\:bottom-80 {
    bottom: 20rem;
  }
  .md\\:left-80 {
    left: 20rem;
  }
  .md\\:top-96 {
    top: 24rem;
  }
  .md\\:right-96 {
    right: 24rem;
  }
  .md\\:bottom-96 {
    bottom: 24rem;
  }
  .md\\:left-96 {
    left: 24rem;
  }
  .md\\:top-auto {
    top: auto;
  }
  .md\\:right-auto {
    right: auto;
  }
  .md\\:bottom-auto {
    bottom: auto;
  }
  .md\\:left-auto {
    left: auto;
  }
  .md\\:top-px {
    top: 1px;
  }
  .md\\:right-px {
    right: 1px;
  }
  .md\\:bottom-px {
    bottom: 1px;
  }
  .md\\:left-px {
    left: 1px;
  }
  .md\\:top-0\\.5 {
    top: 0.125rem;
  }
  .md\\:right-0\\.5 {
    right: 0.125rem;
  }
  .md\\:bottom-0\\.5 {
    bottom: 0.125rem;
  }
  .md\\:left-0\\.5 {
    left: 0.125rem;
  }
  .md\\:top-1\\.5 {
    top: 0.375rem;
  }
  .md\\:right-1\\.5 {
    right: 0.375rem;
  }
  .md\\:bottom-1\\.5 {
    bottom: 0.375rem;
  }
  .md\\:left-1\\.5 {
    left: 0.375rem;
  }
  .md\\:top-2\\.5 {
    top: 0.625rem;
  }
  .md\\:right-2\\.5 {
    right: 0.625rem;
  }
  .md\\:bottom-2\\.5 {
    bottom: 0.625rem;
  }
  .md\\:left-2\\.5 {
    left: 0.625rem;
  }
  .md\\:top-3\\.5 {
    top: 0.875rem;
  }
  .md\\:right-3\\.5 {
    right: 0.875rem;
  }
  .md\\:bottom-3\\.5 {
    bottom: 0.875rem;
  }
  .md\\:left-3\\.5 {
    left: 0.875rem;
  }
  .md\\:top-1\\/2 {
    top: 50%;
  }
  .md\\:right-1\\/2 {
    right: 50%;
  }
  .md\\:bottom-1\\/2 {
    bottom: 50%;
  }
  .md\\:left-1\\/2 {
    left: 50%;
  }
  .md\\:top-1\\/3 {
    top: 33.333333%;
  }
  .md\\:right-1\\/3 {
    right: 33.333333%;
  }
  .md\\:bottom-1\\/3 {
    bottom: 33.333333%;
  }
  .md\\:left-1\\/3 {
    left: 33.333333%;
  }
  .md\\:top-2\\/3 {
    top: 66.666667%;
  }
  .md\\:right-2\\/3 {
    right: 66.666667%;
  }
  .md\\:bottom-2\\/3 {
    bottom: 66.666667%;
  }
  .md\\:left-2\\/3 {
    left: 66.666667%;
  }
  .md\\:top-1\\/4 {
    top: 25%;
  }
  .md\\:right-1\\/4 {
    right: 25%;
  }
  .md\\:bottom-1\\/4 {
    bottom: 25%;
  }
  .md\\:left-1\\/4 {
    left: 25%;
  }
  .md\\:top-2\\/4 {
    top: 50%;
  }
  .md\\:right-2\\/4 {
    right: 50%;
  }
  .md\\:bottom-2\\/4 {
    bottom: 50%;
  }
  .md\\:left-2\\/4 {
    left: 50%;
  }
  .md\\:top-3\\/4 {
    top: 75%;
  }
  .md\\:right-3\\/4 {
    right: 75%;
  }
  .md\\:bottom-3\\/4 {
    bottom: 75%;
  }
  .md\\:left-3\\/4 {
    left: 75%;
  }
  .md\\:top-1\\/5 {
    top: 20%;
  }
  .md\\:right-1\\/5 {
    right: 20%;
  }
  .md\\:bottom-1\\/5 {
    bottom: 20%;
  }
  .md\\:left-1\\/5 {
    left: 20%;
  }
  .md\\:top-2\\/5 {
    top: 40%;
  }
  .md\\:right-2\\/5 {
    right: 40%;
  }
  .md\\:bottom-2\\/5 {
    bottom: 40%;
  }
  .md\\:left-2\\/5 {
    left: 40%;
  }
  .md\\:top-3\\/5 {
    top: 60%;
  }
  .md\\:right-3\\/5 {
    right: 60%;
  }
  .md\\:bottom-3\\/5 {
    bottom: 60%;
  }
  .md\\:left-3\\/5 {
    left: 60%;
  }
  .md\\:top-4\\/5 {
    top: 80%;
  }
  .md\\:right-4\\/5 {
    right: 80%;
  }
  .md\\:bottom-4\\/5 {
    bottom: 80%;
  }
  .md\\:left-4\\/5 {
    left: 80%;
  }
  .md\\:top-1\\/6 {
    top: 16.666667%;
  }
  .md\\:right-1\\/6 {
    right: 16.666667%;
  }
  .md\\:bottom-1\\/6 {
    bottom: 16.666667%;
  }
  .md\\:left-1\\/6 {
    left: 16.666667%;
  }
  .md\\:top-2\\/6 {
    top: 33.333333%;
  }
  .md\\:right-2\\/6 {
    right: 33.333333%;
  }
  .md\\:bottom-2\\/6 {
    bottom: 33.333333%;
  }
  .md\\:left-2\\/6 {
    left: 33.333333%;
  }
  .md\\:top-3\\/6 {
    top: 50%;
  }
  .md\\:right-3\\/6 {
    right: 50%;
  }
  .md\\:bottom-3\\/6 {
    bottom: 50%;
  }
  .md\\:left-3\\/6 {
    left: 50%;
  }
  .md\\:top-4\\/6 {
    top: 66.666667%;
  }
  .md\\:right-4\\/6 {
    right: 66.666667%;
  }
  .md\\:bottom-4\\/6 {
    bottom: 66.666667%;
  }
  .md\\:left-4\\/6 {
    left: 66.666667%;
  }
  .md\\:top-5\\/6 {
    top: 83.333333%;
  }
  .md\\:right-5\\/6 {
    right: 83.333333%;
  }
  .md\\:bottom-5\\/6 {
    bottom: 83.333333%;
  }
  .md\\:left-5\\/6 {
    left: 83.333333%;
  }
  .md\\:top-1\\/12 {
    top: 8.333333%;
  }
  .md\\:right-1\\/12 {
    right: 8.333333%;
  }
  .md\\:bottom-1\\/12 {
    bottom: 8.333333%;
  }
  .md\\:left-1\\/12 {
    left: 8.333333%;
  }
  .md\\:top-2\\/12 {
    top: 16.666667%;
  }
  .md\\:right-2\\/12 {
    right: 16.666667%;
  }
  .md\\:bottom-2\\/12 {
    bottom: 16.666667%;
  }
  .md\\:left-2\\/12 {
    left: 16.666667%;
  }
  .md\\:top-3\\/12 {
    top: 25%;
  }
  .md\\:right-3\\/12 {
    right: 25%;
  }
  .md\\:bottom-3\\/12 {
    bottom: 25%;
  }
  .md\\:left-3\\/12 {
    left: 25%;
  }
  .md\\:top-4\\/12 {
    top: 33.333333%;
  }
  .md\\:right-4\\/12 {
    right: 33.333333%;
  }
  .md\\:bottom-4\\/12 {
    bottom: 33.333333%;
  }
  .md\\:left-4\\/12 {
    left: 33.333333%;
  }
  .md\\:top-5\\/12 {
    top: 41.666667%;
  }
  .md\\:right-5\\/12 {
    right: 41.666667%;
  }
  .md\\:bottom-5\\/12 {
    bottom: 41.666667%;
  }
  .md\\:left-5\\/12 {
    left: 41.666667%;
  }
  .md\\:top-6\\/12 {
    top: 50%;
  }
  .md\\:right-6\\/12 {
    right: 50%;
  }
  .md\\:bottom-6\\/12 {
    bottom: 50%;
  }
  .md\\:left-6\\/12 {
    left: 50%;
  }
  .md\\:top-7\\/12 {
    top: 58.333333%;
  }
  .md\\:right-7\\/12 {
    right: 58.333333%;
  }
  .md\\:bottom-7\\/12 {
    bottom: 58.333333%;
  }
  .md\\:left-7\\/12 {
    left: 58.333333%;
  }
  .md\\:top-8\\/12 {
    top: 66.666667%;
  }
  .md\\:right-8\\/12 {
    right: 66.666667%;
  }
  .md\\:bottom-8\\/12 {
    bottom: 66.666667%;
  }
  .md\\:left-8\\/12 {
    left: 66.666667%;
  }
  .md\\:top-9\\/12 {
    top: 75%;
  }
  .md\\:right-9\\/12 {
    right: 75%;
  }
  .md\\:bottom-9\\/12 {
    bottom: 75%;
  }
  .md\\:left-9\\/12 {
    left: 75%;
  }
  .md\\:top-10\\/12 {
    top: 83.333333%;
  }
  .md\\:right-10\\/12 {
    right: 83.333333%;
  }
  .md\\:bottom-10\\/12 {
    bottom: 83.333333%;
  }
  .md\\:left-10\\/12 {
    left: 83.333333%;
  }
  .md\\:top-11\\/12 {
    top: 91.666667%;
  }
  .md\\:right-11\\/12 {
    right: 91.666667%;
  }
  .md\\:bottom-11\\/12 {
    bottom: 91.666667%;
  }
  .md\\:left-11\\/12 {
    left: 91.666667%;
  }
  .md\\:top-full {
    top: 100%;
  }
  .md\\:right-full {
    right: 100%;
  }
  .md\\:bottom-full {
    bottom: 100%;
  }
  .md\\:left-full {
    left: 100%;
  }
  .md\\:resize-none {
    resize: none;
  }
  .md\\:resize-y {
    resize: vertical;
  }
  .md\\:resize-x {
    resize: horizontal;
  }
  .md\\:resize {
    resize: both;
  }
  .md\\:shadow-xs {
    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.05);
  }
  .md\\:shadow-sm {
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  }
  .md\\:shadow {
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
  }
  .md\\:shadow-md {
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  }
  .md\\:shadow-lg {
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
  }
  .md\\:shadow-xl {
    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  }
  .md\\:shadow-2xl {
    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  }
  .md\\:shadow-inner {
    box-shadow: inset 0 2px 4px 0 rgba(0, 0, 0, 0.06);
  }
  .md\\:shadow-outline {
    box-shadow: 0 0 0 3px rgba(118, 169, 250, 0.45);
  }
  .md\\:shadow-none {
    box-shadow: none;
  }
  .md\\:shadow-solid {
    box-shadow: 0 0 0 2px currentColor;
  }
  .md\\:shadow-outline-gray {
    box-shadow: 0 0 0 3px rgba(159, 166, 178, 0.45);
  }
  .md\\:shadow-outline-blue {
    box-shadow: 0 0 0 3px rgba(164, 202, 254, 0.45);
  }
  .md\\:shadow-outline-teal {
    box-shadow: 0 0 0 3px rgba(126, 220, 226, 0.45);
  }
  .md\\:shadow-outline-green {
    box-shadow: 0 0 0 3px rgba(132, 225, 188, 0.45);
  }
  .md\\:shadow-outline-yellow {
    box-shadow: 0 0 0 3px rgba(250, 202, 21, 0.45);
  }
  .md\\:shadow-outline-orange {
    box-shadow: 0 0 0 3px rgba(253, 186, 140, 0.45);
  }
  .md\\:shadow-outline-red {
    box-shadow: 0 0 0 3px rgba(248, 180, 180, 0.45);
  }
  .md\\:shadow-outline-pink {
    box-shadow: 0 0 0 3px rgba(248, 180, 217, 0.45);
  }
  .md\\:shadow-outline-purple {
    box-shadow: 0 0 0 3px rgba(202, 191, 253, 0.45);
  }
  .md\\:shadow-outline-indigo {
    box-shadow: 0 0 0 3px rgba(180, 198, 252, 0.45);
  }
  .group:focus .md\\:group-focus\\:shadow-xs {
    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.05);
  }
  .group:focus .md\\:group-focus\\:shadow-sm {
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  }
  .group:focus .md\\:group-focus\\:shadow {
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
  }
  .group:focus .md\\:group-focus\\:shadow-md {
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  }
  .group:focus .md\\:group-focus\\:shadow-lg {
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
  }
  .group:focus .md\\:group-focus\\:shadow-xl {
    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  }
  .group:focus .md\\:group-focus\\:shadow-2xl {
    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  }
  .group:focus .md\\:group-focus\\:shadow-inner {
    box-shadow: inset 0 2px 4px 0 rgba(0, 0, 0, 0.06);
  }
  .group:focus .md\\:group-focus\\:shadow-outline {
    box-shadow: 0 0 0 3px rgba(118, 169, 250, 0.45);
  }
  .group:focus .md\\:group-focus\\:shadow-none {
    box-shadow: none;
  }
  .group:focus .md\\:group-focus\\:shadow-solid {
    box-shadow: 0 0 0 2px currentColor;
  }
  .group:focus .md\\:group-focus\\:shadow-outline-gray {
    box-shadow: 0 0 0 3px rgba(159, 166, 178, 0.45);
  }
  .group:focus .md\\:group-focus\\:shadow-outline-blue {
    box-shadow: 0 0 0 3px rgba(164, 202, 254, 0.45);
  }
  .group:focus .md\\:group-focus\\:shadow-outline-teal {
    box-shadow: 0 0 0 3px rgba(126, 220, 226, 0.45);
  }
  .group:focus .md\\:group-focus\\:shadow-outline-green {
    box-shadow: 0 0 0 3px rgba(132, 225, 188, 0.45);
  }
  .group:focus .md\\:group-focus\\:shadow-outline-yellow {
    box-shadow: 0 0 0 3px rgba(250, 202, 21, 0.45);
  }
  .group:focus .md\\:group-focus\\:shadow-outline-orange {
    box-shadow: 0 0 0 3px rgba(253, 186, 140, 0.45);
  }
  .group:focus .md\\:group-focus\\:shadow-outline-red {
    box-shadow: 0 0 0 3px rgba(248, 180, 180, 0.45);
  }
  .group:focus .md\\:group-focus\\:shadow-outline-pink {
    box-shadow: 0 0 0 3px rgba(248, 180, 217, 0.45);
  }
  .group:focus .md\\:group-focus\\:shadow-outline-purple {
    box-shadow: 0 0 0 3px rgba(202, 191, 253, 0.45);
  }
  .group:focus .md\\:group-focus\\:shadow-outline-indigo {
    box-shadow: 0 0 0 3px rgba(180, 198, 252, 0.45);
  }
  .md\\:hover\\:shadow-xs:hover {
    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.05);
  }
  .md\\:hover\\:shadow-sm:hover {
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  }
  .md\\:hover\\:shadow:hover {
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
  }
  .md\\:hover\\:shadow-md:hover {
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  }
  .md\\:hover\\:shadow-lg:hover {
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
  }
  .md\\:hover\\:shadow-xl:hover {
    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  }
  .md\\:hover\\:shadow-2xl:hover {
    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  }
  .md\\:hover\\:shadow-inner:hover {
    box-shadow: inset 0 2px 4px 0 rgba(0, 0, 0, 0.06);
  }
  .md\\:hover\\:shadow-outline:hover {
    box-shadow: 0 0 0 3px rgba(118, 169, 250, 0.45);
  }
  .md\\:hover\\:shadow-none:hover {
    box-shadow: none;
  }
  .md\\:hover\\:shadow-solid:hover {
    box-shadow: 0 0 0 2px currentColor;
  }
  .md\\:hover\\:shadow-outline-gray:hover {
    box-shadow: 0 0 0 3px rgba(159, 166, 178, 0.45);
  }
  .md\\:hover\\:shadow-outline-blue:hover {
    box-shadow: 0 0 0 3px rgba(164, 202, 254, 0.45);
  }
  .md\\:hover\\:shadow-outline-teal:hover {
    box-shadow: 0 0 0 3px rgba(126, 220, 226, 0.45);
  }
  .md\\:hover\\:shadow-outline-green:hover {
    box-shadow: 0 0 0 3px rgba(132, 225, 188, 0.45);
  }
  .md\\:hover\\:shadow-outline-yellow:hover {
    box-shadow: 0 0 0 3px rgba(250, 202, 21, 0.45);
  }
  .md\\:hover\\:shadow-outline-orange:hover {
    box-shadow: 0 0 0 3px rgba(253, 186, 140, 0.45);
  }
  .md\\:hover\\:shadow-outline-red:hover {
    box-shadow: 0 0 0 3px rgba(248, 180, 180, 0.45);
  }
  .md\\:hover\\:shadow-outline-pink:hover {
    box-shadow: 0 0 0 3px rgba(248, 180, 217, 0.45);
  }
  .md\\:hover\\:shadow-outline-purple:hover {
    box-shadow: 0 0 0 3px rgba(202, 191, 253, 0.45);
  }
  .md\\:hover\\:shadow-outline-indigo:hover {
    box-shadow: 0 0 0 3px rgba(180, 198, 252, 0.45);
  }
  .md\\:focus-within\\:shadow-xs:focus-within {
    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.05);
  }
  .md\\:focus-within\\:shadow-sm:focus-within {
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  }
  .md\\:focus-within\\:shadow:focus-within {
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
  }
  .md\\:focus-within\\:shadow-md:focus-within {
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  }
  .md\\:focus-within\\:shadow-lg:focus-within {
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
  }
  .md\\:focus-within\\:shadow-xl:focus-within {
    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  }
  .md\\:focus-within\\:shadow-2xl:focus-within {
    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  }
  .md\\:focus-within\\:shadow-inner:focus-within {
    box-shadow: inset 0 2px 4px 0 rgba(0, 0, 0, 0.06);
  }
  .md\\:focus-within\\:shadow-outline:focus-within {
    box-shadow: 0 0 0 3px rgba(118, 169, 250, 0.45);
  }
  .md\\:focus-within\\:shadow-none:focus-within {
    box-shadow: none;
  }
  .md\\:focus-within\\:shadow-solid:focus-within {
    box-shadow: 0 0 0 2px currentColor;
  }
  .md\\:focus-within\\:shadow-outline-gray:focus-within {
    box-shadow: 0 0 0 3px rgba(159, 166, 178, 0.45);
  }
  .md\\:focus-within\\:shadow-outline-blue:focus-within {
    box-shadow: 0 0 0 3px rgba(164, 202, 254, 0.45);
  }
  .md\\:focus-within\\:shadow-outline-teal:focus-within {
    box-shadow: 0 0 0 3px rgba(126, 220, 226, 0.45);
  }
  .md\\:focus-within\\:shadow-outline-green:focus-within {
    box-shadow: 0 0 0 3px rgba(132, 225, 188, 0.45);
  }
  .md\\:focus-within\\:shadow-outline-yellow:focus-within {
    box-shadow: 0 0 0 3px rgba(250, 202, 21, 0.45);
  }
  .md\\:focus-within\\:shadow-outline-orange:focus-within {
    box-shadow: 0 0 0 3px rgba(253, 186, 140, 0.45);
  }
  .md\\:focus-within\\:shadow-outline-red:focus-within {
    box-shadow: 0 0 0 3px rgba(248, 180, 180, 0.45);
  }
  .md\\:focus-within\\:shadow-outline-pink:focus-within {
    box-shadow: 0 0 0 3px rgba(248, 180, 217, 0.45);
  }
  .md\\:focus-within\\:shadow-outline-purple:focus-within {
    box-shadow: 0 0 0 3px rgba(202, 191, 253, 0.45);
  }
  .md\\:focus-within\\:shadow-outline-indigo:focus-within {
    box-shadow: 0 0 0 3px rgba(180, 198, 252, 0.45);
  }
  .md\\:focus\\:shadow-xs:focus {
    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.05);
  }
  .md\\:focus\\:shadow-sm:focus {
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  }
  .md\\:focus\\:shadow:focus {
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
  }
  .md\\:focus\\:shadow-md:focus {
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  }
  .md\\:focus\\:shadow-lg:focus {
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
  }
  .md\\:focus\\:shadow-xl:focus {
    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  }
  .md\\:focus\\:shadow-2xl:focus {
    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  }
  .md\\:focus\\:shadow-inner:focus {
    box-shadow: inset 0 2px 4px 0 rgba(0, 0, 0, 0.06);
  }
  .md\\:focus\\:shadow-outline:focus {
    box-shadow: 0 0 0 3px rgba(118, 169, 250, 0.45);
  }
  .md\\:focus\\:shadow-none:focus {
    box-shadow: none;
  }
  .md\\:focus\\:shadow-solid:focus {
    box-shadow: 0 0 0 2px currentColor;
  }
  .md\\:focus\\:shadow-outline-gray:focus {
    box-shadow: 0 0 0 3px rgba(159, 166, 178, 0.45);
  }
  .md\\:focus\\:shadow-outline-blue:focus {
    box-shadow: 0 0 0 3px rgba(164, 202, 254, 0.45);
  }
  .md\\:focus\\:shadow-outline-teal:focus {
    box-shadow: 0 0 0 3px rgba(126, 220, 226, 0.45);
  }
  .md\\:focus\\:shadow-outline-green:focus {
    box-shadow: 0 0 0 3px rgba(132, 225, 188, 0.45);
  }
  .md\\:focus\\:shadow-outline-yellow:focus {
    box-shadow: 0 0 0 3px rgba(250, 202, 21, 0.45);
  }
  .md\\:focus\\:shadow-outline-orange:focus {
    box-shadow: 0 0 0 3px rgba(253, 186, 140, 0.45);
  }
  .md\\:focus\\:shadow-outline-red:focus {
    box-shadow: 0 0 0 3px rgba(248, 180, 180, 0.45);
  }
  .md\\:focus\\:shadow-outline-pink:focus {
    box-shadow: 0 0 0 3px rgba(248, 180, 217, 0.45);
  }
  .md\\:focus\\:shadow-outline-purple:focus {
    box-shadow: 0 0 0 3px rgba(202, 191, 253, 0.45);
  }
  .md\\:focus\\:shadow-outline-indigo:focus {
    box-shadow: 0 0 0 3px rgba(180, 198, 252, 0.45);
  }
  .md\\:fill-current {
    fill: currentColor;
  }
  .md\\:stroke-current {
    stroke: currentColor;
  }
  .md\\:stroke-0 {
    stroke-width: 0;
  }
  .md\\:stroke-1 {
    stroke-width: 1;
  }
  .md\\:stroke-2 {
    stroke-width: 2;
  }
  .md\\:table-auto {
    table-layout: auto;
  }
  .md\\:table-fixed {
    table-layout: fixed;
  }
  .md\\:text-left {
    text-align: left;
  }
  .md\\:text-center {
    text-align: center;
  }
  .md\\:text-right {
    text-align: right;
  }
  .md\\:text-justify {
    text-align: justify;
  }
  .md\\:text-current {
    color: currentColor;
  }
  .md\\:text-transparent {
    color: transparent;
  }
  .md\\:text-white {
    --text-opacity: 1;
    color: #ffffff;
    color: rgba(255, 255, 255, var(--text-opacity));
  }
  .md\\:text-black {
    --text-opacity: 1;
    color: #000000;
    color: rgba(0, 0, 0, var(--text-opacity));
  }
  .md\\:text-gray-50 {
    --text-opacity: 1;
    color: #f9fafb;
    color: rgba(249, 250, 251, var(--text-opacity));
  }
  .md\\:text-gray-100 {
    --text-opacity: 1;
    color: #f4f5f7;
    color: rgba(244, 245, 247, var(--text-opacity));
  }
  .md\\:text-gray-200 {
    --text-opacity: 1;
    color: #e5e7eb;
    color: rgba(229, 231, 235, var(--text-opacity));
  }
  .md\\:text-gray-300 {
    --text-opacity: 1;
    color: #d2d6dc;
    color: rgba(210, 214, 220, var(--text-opacity));
  }
  .md\\:text-gray-400 {
    --text-opacity: 1;
    color: #9fa6b2;
    color: rgba(159, 166, 178, var(--text-opacity));
  }
  .md\\:text-gray-500 {
    --text-opacity: 1;
    color: #6b7280;
    color: rgba(107, 114, 128, var(--text-opacity));
  }
  .md\\:text-gray-600 {
    --text-opacity: 1;
    color: #4b5563;
    color: rgba(75, 85, 99, var(--text-opacity));
  }
  .md\\:text-gray-700 {
    --text-opacity: 1;
    color: #374151;
    color: rgba(55, 65, 81, var(--text-opacity));
  }
  .md\\:text-gray-800 {
    --text-opacity: 1;
    color: #252f3f;
    color: rgba(37, 47, 63, var(--text-opacity));
  }
  .md\\:text-gray-900 {
    --text-opacity: 1;
    color: #161e2e;
    color: rgba(22, 30, 46, var(--text-opacity));
  }
  .md\\:text-red-50 {
    --text-opacity: 1;
    color: #fdf2f2;
    color: rgba(253, 242, 242, var(--text-opacity));
  }
  .md\\:text-red-100 {
    --text-opacity: 1;
    color: #fde8e8;
    color: rgba(253, 232, 232, var(--text-opacity));
  }
  .md\\:text-red-200 {
    --text-opacity: 1;
    color: #fbd5d5;
    color: rgba(251, 213, 213, var(--text-opacity));
  }
  .md\\:text-red-300 {
    --text-opacity: 1;
    color: #f8b4b4;
    color: rgba(248, 180, 180, var(--text-opacity));
  }
  .md\\:text-red-400 {
    --text-opacity: 1;
    color: #f98080;
    color: rgba(249, 128, 128, var(--text-opacity));
  }
  .md\\:text-red-500 {
    --text-opacity: 1;
    color: #f05252;
    color: rgba(240, 82, 82, var(--text-opacity));
  }
  .md\\:text-red-600 {
    --text-opacity: 1;
    color: #e02424;
    color: rgba(224, 36, 36, var(--text-opacity));
  }
  .md\\:text-red-700 {
    --text-opacity: 1;
    color: #c81e1e;
    color: rgba(200, 30, 30, var(--text-opacity));
  }
  .md\\:text-red-800 {
    --text-opacity: 1;
    color: #9b1c1c;
    color: rgba(155, 28, 28, var(--text-opacity));
  }
  .md\\:text-red-900 {
    --text-opacity: 1;
    color: #771d1d;
    color: rgba(119, 29, 29, var(--text-opacity));
  }
  .md\\:text-orange-50 {
    --text-opacity: 1;
    color: #fff8f1;
    color: rgba(255, 248, 241, var(--text-opacity));
  }
  .md\\:text-orange-100 {
    --text-opacity: 1;
    color: #feecdc;
    color: rgba(254, 236, 220, var(--text-opacity));
  }
  .md\\:text-orange-200 {
    --text-opacity: 1;
    color: #fcd9bd;
    color: rgba(252, 217, 189, var(--text-opacity));
  }
  .md\\:text-orange-300 {
    --text-opacity: 1;
    color: #fdba8c;
    color: rgba(253, 186, 140, var(--text-opacity));
  }
  .md\\:text-orange-400 {
    --text-opacity: 1;
    color: #ff8a4c;
    color: rgba(255, 138, 76, var(--text-opacity));
  }
  .md\\:text-orange-500 {
    --text-opacity: 1;
    color: #ff5a1f;
    color: rgba(255, 90, 31, var(--text-opacity));
  }
  .md\\:text-orange-600 {
    --text-opacity: 1;
    color: #d03801;
    color: rgba(208, 56, 1, var(--text-opacity));
  }
  .md\\:text-orange-700 {
    --text-opacity: 1;
    color: #b43403;
    color: rgba(180, 52, 3, var(--text-opacity));
  }
  .md\\:text-orange-800 {
    --text-opacity: 1;
    color: #8a2c0d;
    color: rgba(138, 44, 13, var(--text-opacity));
  }
  .md\\:text-orange-900 {
    --text-opacity: 1;
    color: #73230d;
    color: rgba(115, 35, 13, var(--text-opacity));
  }
  .md\\:text-yellow-50 {
    --text-opacity: 1;
    color: #fdfdea;
    color: rgba(253, 253, 234, var(--text-opacity));
  }
  .md\\:text-yellow-100 {
    --text-opacity: 1;
    color: #fdf6b2;
    color: rgba(253, 246, 178, var(--text-opacity));
  }
  .md\\:text-yellow-200 {
    --text-opacity: 1;
    color: #fce96a;
    color: rgba(252, 233, 106, var(--text-opacity));
  }
  .md\\:text-yellow-300 {
    --text-opacity: 1;
    color: #faca15;
    color: rgba(250, 202, 21, var(--text-opacity));
  }
  .md\\:text-yellow-400 {
    --text-opacity: 1;
    color: #e3a008;
    color: rgba(227, 160, 8, var(--text-opacity));
  }
  .md\\:text-yellow-500 {
    --text-opacity: 1;
    color: #c27803;
    color: rgba(194, 120, 3, var(--text-opacity));
  }
  .md\\:text-yellow-600 {
    --text-opacity: 1;
    color: #9f580a;
    color: rgba(159, 88, 10, var(--text-opacity));
  }
  .md\\:text-yellow-700 {
    --text-opacity: 1;
    color: #8e4b10;
    color: rgba(142, 75, 16, var(--text-opacity));
  }
  .md\\:text-yellow-800 {
    --text-opacity: 1;
    color: #723b13;
    color: rgba(114, 59, 19, var(--text-opacity));
  }
  .md\\:text-yellow-900 {
    --text-opacity: 1;
    color: #633112;
    color: rgba(99, 49, 18, var(--text-opacity));
  }
  .md\\:text-green-50 {
    --text-opacity: 1;
    color: #f3faf7;
    color: rgba(243, 250, 247, var(--text-opacity));
  }
  .md\\:text-green-100 {
    --text-opacity: 1;
    color: #def7ec;
    color: rgba(222, 247, 236, var(--text-opacity));
  }
  .md\\:text-green-200 {
    --text-opacity: 1;
    color: #bcf0da;
    color: rgba(188, 240, 218, var(--text-opacity));
  }
  .md\\:text-green-300 {
    --text-opacity: 1;
    color: #84e1bc;
    color: rgba(132, 225, 188, var(--text-opacity));
  }
  .md\\:text-green-400 {
    --text-opacity: 1;
    color: #31c48d;
    color: rgba(49, 196, 141, var(--text-opacity));
  }
  .md\\:text-green-500 {
    --text-opacity: 1;
    color: #0e9f6e;
    color: rgba(14, 159, 110, var(--text-opacity));
  }
  .md\\:text-green-600 {
    --text-opacity: 1;
    color: #057a55;
    color: rgba(5, 122, 85, var(--text-opacity));
  }
  .md\\:text-green-700 {
    --text-opacity: 1;
    color: #046c4e;
    color: rgba(4, 108, 78, var(--text-opacity));
  }
  .md\\:text-green-800 {
    --text-opacity: 1;
    color: #03543f;
    color: rgba(3, 84, 63, var(--text-opacity));
  }
  .md\\:text-green-900 {
    --text-opacity: 1;
    color: #014737;
    color: rgba(1, 71, 55, var(--text-opacity));
  }
  .md\\:text-teal-50 {
    --text-opacity: 1;
    color: #edfafa;
    color: rgba(237, 250, 250, var(--text-opacity));
  }
  .md\\:text-teal-100 {
    --text-opacity: 1;
    color: #d5f5f6;
    color: rgba(213, 245, 246, var(--text-opacity));
  }
  .md\\:text-teal-200 {
    --text-opacity: 1;
    color: #afecef;
    color: rgba(175, 236, 239, var(--text-opacity));
  }
  .md\\:text-teal-300 {
    --text-opacity: 1;
    color: #7edce2;
    color: rgba(126, 220, 226, var(--text-opacity));
  }
  .md\\:text-teal-400 {
    --text-opacity: 1;
    color: #16bdca;
    color: rgba(22, 189, 202, var(--text-opacity));
  }
  .md\\:text-teal-500 {
    --text-opacity: 1;
    color: #0694a2;
    color: rgba(6, 148, 162, var(--text-opacity));
  }
  .md\\:text-teal-600 {
    --text-opacity: 1;
    color: #047481;
    color: rgba(4, 116, 129, var(--text-opacity));
  }
  .md\\:text-teal-700 {
    --text-opacity: 1;
    color: #036672;
    color: rgba(3, 102, 114, var(--text-opacity));
  }
  .md\\:text-teal-800 {
    --text-opacity: 1;
    color: #05505c;
    color: rgba(5, 80, 92, var(--text-opacity));
  }
  .md\\:text-teal-900 {
    --text-opacity: 1;
    color: #014451;
    color: rgba(1, 68, 81, var(--text-opacity));
  }
  .md\\:text-blue-50 {
    --text-opacity: 1;
    color: #ebf5ff;
    color: rgba(235, 245, 255, var(--text-opacity));
  }
  .md\\:text-blue-100 {
    --text-opacity: 1;
    color: #e1effe;
    color: rgba(225, 239, 254, var(--text-opacity));
  }
  .md\\:text-blue-200 {
    --text-opacity: 1;
    color: #c3ddfd;
    color: rgba(195, 221, 253, var(--text-opacity));
  }
  .md\\:text-blue-300 {
    --text-opacity: 1;
    color: #a4cafe;
    color: rgba(164, 202, 254, var(--text-opacity));
  }
  .md\\:text-blue-400 {
    --text-opacity: 1;
    color: #76a9fa;
    color: rgba(118, 169, 250, var(--text-opacity));
  }
  .md\\:text-blue-500 {
    --text-opacity: 1;
    color: #3f83f8;
    color: rgba(63, 131, 248, var(--text-opacity));
  }
  .md\\:text-blue-600 {
    --text-opacity: 1;
    color: #1c64f2;
    color: rgba(28, 100, 242, var(--text-opacity));
  }
  .md\\:text-blue-700 {
    --text-opacity: 1;
    color: #1a56db;
    color: rgba(26, 86, 219, var(--text-opacity));
  }
  .md\\:text-blue-800 {
    --text-opacity: 1;
    color: #1e429f;
    color: rgba(30, 66, 159, var(--text-opacity));
  }
  .md\\:text-blue-900 {
    --text-opacity: 1;
    color: #233876;
    color: rgba(35, 56, 118, var(--text-opacity));
  }
  .md\\:text-indigo-50 {
    --text-opacity: 1;
    color: #f0f5ff;
    color: rgba(240, 245, 255, var(--text-opacity));
  }
  .md\\:text-indigo-100 {
    --text-opacity: 1;
    color: #e5edff;
    color: rgba(229, 237, 255, var(--text-opacity));
  }
  .md\\:text-indigo-200 {
    --text-opacity: 1;
    color: #cddbfe;
    color: rgba(205, 219, 254, var(--text-opacity));
  }
  .md\\:text-indigo-300 {
    --text-opacity: 1;
    color: #b4c6fc;
    color: rgba(180, 198, 252, var(--text-opacity));
  }
  .md\\:text-indigo-400 {
    --text-opacity: 1;
    color: #8da2fb;
    color: rgba(141, 162, 251, var(--text-opacity));
  }
  .md\\:text-indigo-500 {
    --text-opacity: 1;
    color: #6875f5;
    color: rgba(104, 117, 245, var(--text-opacity));
  }
  .md\\:text-indigo-600 {
    --text-opacity: 1;
    color: #5850ec;
    color: rgba(88, 80, 236, var(--text-opacity));
  }
  .md\\:text-indigo-700 {
    --text-opacity: 1;
    color: #5145cd;
    color: rgba(81, 69, 205, var(--text-opacity));
  }
  .md\\:text-indigo-800 {
    --text-opacity: 1;
    color: #42389d;
    color: rgba(66, 56, 157, var(--text-opacity));
  }
  .md\\:text-indigo-900 {
    --text-opacity: 1;
    color: #362f78;
    color: rgba(54, 47, 120, var(--text-opacity));
  }
  .md\\:text-purple-50 {
    --text-opacity: 1;
    color: #f6f5ff;
    color: rgba(246, 245, 255, var(--text-opacity));
  }
  .md\\:text-purple-100 {
    --text-opacity: 1;
    color: #edebfe;
    color: rgba(237, 235, 254, var(--text-opacity));
  }
  .md\\:text-purple-200 {
    --text-opacity: 1;
    color: #dcd7fe;
    color: rgba(220, 215, 254, var(--text-opacity));
  }
  .md\\:text-purple-300 {
    --text-opacity: 1;
    color: #cabffd;
    color: rgba(202, 191, 253, var(--text-opacity));
  }
  .md\\:text-purple-400 {
    --text-opacity: 1;
    color: #ac94fa;
    color: rgba(172, 148, 250, var(--text-opacity));
  }
  .md\\:text-purple-500 {
    --text-opacity: 1;
    color: #9061f9;
    color: rgba(144, 97, 249, var(--text-opacity));
  }
  .md\\:text-purple-600 {
    --text-opacity: 1;
    color: #7e3af2;
    color: rgba(126, 58, 242, var(--text-opacity));
  }
  .md\\:text-purple-700 {
    --text-opacity: 1;
    color: #6c2bd9;
    color: rgba(108, 43, 217, var(--text-opacity));
  }
  .md\\:text-purple-800 {
    --text-opacity: 1;
    color: #5521b5;
    color: rgba(85, 33, 181, var(--text-opacity));
  }
  .md\\:text-purple-900 {
    --text-opacity: 1;
    color: #4a1d96;
    color: rgba(74, 29, 150, var(--text-opacity));
  }
  .md\\:text-pink-50 {
    --text-opacity: 1;
    color: #fdf2f8;
    color: rgba(253, 242, 248, var(--text-opacity));
  }
  .md\\:text-pink-100 {
    --text-opacity: 1;
    color: #fce8f3;
    color: rgba(252, 232, 243, var(--text-opacity));
  }
  .md\\:text-pink-200 {
    --text-opacity: 1;
    color: #fad1e8;
    color: rgba(250, 209, 232, var(--text-opacity));
  }
  .md\\:text-pink-300 {
    --text-opacity: 1;
    color: #f8b4d9;
    color: rgba(248, 180, 217, var(--text-opacity));
  }
  .md\\:text-pink-400 {
    --text-opacity: 1;
    color: #f17eb8;
    color: rgba(241, 126, 184, var(--text-opacity));
  }
  .md\\:text-pink-500 {
    --text-opacity: 1;
    color: #e74694;
    color: rgba(231, 70, 148, var(--text-opacity));
  }
  .md\\:text-pink-600 {
    --text-opacity: 1;
    color: #d61f69;
    color: rgba(214, 31, 105, var(--text-opacity));
  }
  .md\\:text-pink-700 {
    --text-opacity: 1;
    color: #bf125d;
    color: rgba(191, 18, 93, var(--text-opacity));
  }
  .md\\:text-pink-800 {
    --text-opacity: 1;
    color: #99154b;
    color: rgba(153, 21, 75, var(--text-opacity));
  }
  .md\\:text-pink-900 {
    --text-opacity: 1;
    color: #751a3d;
    color: rgba(117, 26, 61, var(--text-opacity));
  }
  .md\\:text-cool-gray-50 {
    --text-opacity: 1;
    color: #f8fafc;
    color: rgba(248, 250, 252, var(--text-opacity));
  }
  .md\\:text-cool-gray-100 {
    --text-opacity: 1;
    color: #f1f5f9;
    color: rgba(241, 245, 249, var(--text-opacity));
  }
  .md\\:text-cool-gray-200 {
    --text-opacity: 1;
    color: #e2e8f0;
    color: rgba(226, 232, 240, var(--text-opacity));
  }
  .md\\:text-cool-gray-300 {
    --text-opacity: 1;
    color: #cfd8e3;
    color: rgba(207, 216, 227, var(--text-opacity));
  }
  .md\\:text-cool-gray-400 {
    --text-opacity: 1;
    color: #97a6ba;
    color: rgba(151, 166, 186, var(--text-opacity));
  }
  .md\\:text-cool-gray-500 {
    --text-opacity: 1;
    color: #64748b;
    color: rgba(100, 116, 139, var(--text-opacity));
  }
  .md\\:text-cool-gray-600 {
    --text-opacity: 1;
    color: #475569;
    color: rgba(71, 85, 105, var(--text-opacity));
  }
  .md\\:text-cool-gray-700 {
    --text-opacity: 1;
    color: #364152;
    color: rgba(54, 65, 82, var(--text-opacity));
  }
  .md\\:text-cool-gray-800 {
    --text-opacity: 1;
    color: #27303f;
    color: rgba(39, 48, 63, var(--text-opacity));
  }
  .md\\:text-cool-gray-900 {
    --text-opacity: 1;
    color: #1a202e;
    color: rgba(26, 32, 46, var(--text-opacity));
  }
  .group:hover .md\\:group-hover\\:text-current {
    color: currentColor;
  }
  .group:hover .md\\:group-hover\\:text-transparent {
    color: transparent;
  }
  .group:hover .md\\:group-hover\\:text-white {
    --text-opacity: 1;
    color: #ffffff;
    color: rgba(255, 255, 255, var(--text-opacity));
  }
  .group:hover .md\\:group-hover\\:text-black {
    --text-opacity: 1;
    color: #000000;
    color: rgba(0, 0, 0, var(--text-opacity));
  }
  .group:hover .md\\:group-hover\\:text-gray-50 {
    --text-opacity: 1;
    color: #f9fafb;
    color: rgba(249, 250, 251, var(--text-opacity));
  }
  .group:hover .md\\:group-hover\\:text-gray-100 {
    --text-opacity: 1;
    color: #f4f5f7;
    color: rgba(244, 245, 247, var(--text-opacity));
  }
  .group:hover .md\\:group-hover\\:text-gray-200 {
    --text-opacity: 1;
    color: #e5e7eb;
    color: rgba(229, 231, 235, var(--text-opacity));
  }
  .group:hover .md\\:group-hover\\:text-gray-300 {
    --text-opacity: 1;
    color: #d2d6dc;
    color: rgba(210, 214, 220, var(--text-opacity));
  }
  .group:hover .md\\:group-hover\\:text-gray-400 {
    --text-opacity: 1;
    color: #9fa6b2;
    color: rgba(159, 166, 178, var(--text-opacity));
  }
  .group:hover .md\\:group-hover\\:text-gray-500 {
    --text-opacity: 1;
    color: #6b7280;
    color: rgba(107, 114, 128, var(--text-opacity));
  }
  .group:hover .md\\:group-hover\\:text-gray-600 {
    --text-opacity: 1;
    color: #4b5563;
    color: rgba(75, 85, 99, var(--text-opacity));
  }
  .group:hover .md\\:group-hover\\:text-gray-700 {
    --text-opacity: 1;
    color: #374151;
    color: rgba(55, 65, 81, var(--text-opacity));
  }
  .group:hover .md\\:group-hover\\:text-gray-800 {
    --text-opacity: 1;
    color: #252f3f;
    color: rgba(37, 47, 63, var(--text-opacity));
  }
  .group:hover .md\\:group-hover\\:text-gray-900 {
    --text-opacity: 1;
    color: #161e2e;
    color: rgba(22, 30, 46, var(--text-opacity));
  }
  .group:hover .md\\:group-hover\\:text-red-50 {
    --text-opacity: 1;
    color: #fdf2f2;
    color: rgba(253, 242, 242, var(--text-opacity));
  }
  .group:hover .md\\:group-hover\\:text-red-100 {
    --text-opacity: 1;
    color: #fde8e8;
    color: rgba(253, 232, 232, var(--text-opacity));
  }
  .group:hover .md\\:group-hover\\:text-red-200 {
    --text-opacity: 1;
    color: #fbd5d5;
    color: rgba(251, 213, 213, var(--text-opacity));
  }
  .group:hover .md\\:group-hover\\:text-red-300 {
    --text-opacity: 1;
    color: #f8b4b4;
    color: rgba(248, 180, 180, var(--text-opacity));
  }
  .group:hover .md\\:group-hover\\:text-red-400 {
    --text-opacity: 1;
    color: #f98080;
    color: rgba(249, 128, 128, var(--text-opacity));
  }
  .group:hover .md\\:group-hover\\:text-red-500 {
    --text-opacity: 1;
    color: #f05252;
    color: rgba(240, 82, 82, var(--text-opacity));
  }
  .group:hover .md\\:group-hover\\:text-red-600 {
    --text-opacity: 1;
    color: #e02424;
    color: rgba(224, 36, 36, var(--text-opacity));
  }
  .group:hover .md\\:group-hover\\:text-red-700 {
    --text-opacity: 1;
    color: #c81e1e;
    color: rgba(200, 30, 30, var(--text-opacity));
  }
  .group:hover .md\\:group-hover\\:text-red-800 {
    --text-opacity: 1;
    color: #9b1c1c;
    color: rgba(155, 28, 28, var(--text-opacity));
  }
  .group:hover .md\\:group-hover\\:text-red-900 {
    --text-opacity: 1;
    color: #771d1d;
    color: rgba(119, 29, 29, var(--text-opacity));
  }
  .group:hover .md\\:group-hover\\:text-orange-50 {
    --text-opacity: 1;
    color: #fff8f1;
    color: rgba(255, 248, 241, var(--text-opacity));
  }
  .group:hover .md\\:group-hover\\:text-orange-100 {
    --text-opacity: 1;
    color: #feecdc;
    color: rgba(254, 236, 220, var(--text-opacity));
  }
  .group:hover .md\\:group-hover\\:text-orange-200 {
    --text-opacity: 1;
    color: #fcd9bd;
    color: rgba(252, 217, 189, var(--text-opacity));
  }
  .group:hover .md\\:group-hover\\:text-orange-300 {
    --text-opacity: 1;
    color: #fdba8c;
    color: rgba(253, 186, 140, var(--text-opacity));
  }
  .group:hover .md\\:group-hover\\:text-orange-400 {
    --text-opacity: 1;
    color: #ff8a4c;
    color: rgba(255, 138, 76, var(--text-opacity));
  }
  .group:hover .md\\:group-hover\\:text-orange-500 {
    --text-opacity: 1;
    color: #ff5a1f;
    color: rgba(255, 90, 31, var(--text-opacity));
  }
  .group:hover .md\\:group-hover\\:text-orange-600 {
    --text-opacity: 1;
    color: #d03801;
    color: rgba(208, 56, 1, var(--text-opacity));
  }
  .group:hover .md\\:group-hover\\:text-orange-700 {
    --text-opacity: 1;
    color: #b43403;
    color: rgba(180, 52, 3, var(--text-opacity));
  }
  .group:hover .md\\:group-hover\\:text-orange-800 {
    --text-opacity: 1;
    color: #8a2c0d;
    color: rgba(138, 44, 13, var(--text-opacity));
  }
  .group:hover .md\\:group-hover\\:text-orange-900 {
    --text-opacity: 1;
    color: #73230d;
    color: rgba(115, 35, 13, var(--text-opacity));
  }
  .group:hover .md\\:group-hover\\:text-yellow-50 {
    --text-opacity: 1;
    color: #fdfdea;
    color: rgba(253, 253, 234, var(--text-opacity));
  }
  .group:hover .md\\:group-hover\\:text-yellow-100 {
    --text-opacity: 1;
    color: #fdf6b2;
    color: rgba(253, 246, 178, var(--text-opacity));
  }
  .group:hover .md\\:group-hover\\:text-yellow-200 {
    --text-opacity: 1;
    color: #fce96a;
    color: rgba(252, 233, 106, var(--text-opacity));
  }
  .group:hover .md\\:group-hover\\:text-yellow-300 {
    --text-opacity: 1;
    color: #faca15;
    color: rgba(250, 202, 21, var(--text-opacity));
  }
  .group:hover .md\\:group-hover\\:text-yellow-400 {
    --text-opacity: 1;
    color: #e3a008;
    color: rgba(227, 160, 8, var(--text-opacity));
  }
  .group:hover .md\\:group-hover\\:text-yellow-500 {
    --text-opacity: 1;
    color: #c27803;
    color: rgba(194, 120, 3, var(--text-opacity));
  }
  .group:hover .md\\:group-hover\\:text-yellow-600 {
    --text-opacity: 1;
    color: #9f580a;
    color: rgba(159, 88, 10, var(--text-opacity));
  }
  .group:hover .md\\:group-hover\\:text-yellow-700 {
    --text-opacity: 1;
    color: #8e4b10;
    color: rgba(142, 75, 16, var(--text-opacity));
  }
  .group:hover .md\\:group-hover\\:text-yellow-800 {
    --text-opacity: 1;
    color: #723b13;
    color: rgba(114, 59, 19, var(--text-opacity));
  }
  .group:hover .md\\:group-hover\\:text-yellow-900 {
    --text-opacity: 1;
    color: #633112;
    color: rgba(99, 49, 18, var(--text-opacity));
  }
  .group:hover .md\\:group-hover\\:text-green-50 {
    --text-opacity: 1;
    color: #f3faf7;
    color: rgba(243, 250, 247, var(--text-opacity));
  }
  .group:hover .md\\:group-hover\\:text-green-100 {
    --text-opacity: 1;
    color: #def7ec;
    color: rgba(222, 247, 236, var(--text-opacity));
  }
  .group:hover .md\\:group-hover\\:text-green-200 {
    --text-opacity: 1;
    color: #bcf0da;
    color: rgba(188, 240, 218, var(--text-opacity));
  }
  .group:hover .md\\:group-hover\\:text-green-300 {
    --text-opacity: 1;
    color: #84e1bc;
    color: rgba(132, 225, 188, var(--text-opacity));
  }
  .group:hover .md\\:group-hover\\:text-green-400 {
    --text-opacity: 1;
    color: #31c48d;
    color: rgba(49, 196, 141, var(--text-opacity));
  }
  .group:hover .md\\:group-hover\\:text-green-500 {
    --text-opacity: 1;
    color: #0e9f6e;
    color: rgba(14, 159, 110, var(--text-opacity));
  }
  .group:hover .md\\:group-hover\\:text-green-600 {
    --text-opacity: 1;
    color: #057a55;
    color: rgba(5, 122, 85, var(--text-opacity));
  }
  .group:hover .md\\:group-hover\\:text-green-700 {
    --text-opacity: 1;
    color: #046c4e;
    color: rgba(4, 108, 78, var(--text-opacity));
  }
  .group:hover .md\\:group-hover\\:text-green-800 {
    --text-opacity: 1;
    color: #03543f;
    color: rgba(3, 84, 63, var(--text-opacity));
  }
  .group:hover .md\\:group-hover\\:text-green-900 {
    --text-opacity: 1;
    color: #014737;
    color: rgba(1, 71, 55, var(--text-opacity));
  }
  .group:hover .md\\:group-hover\\:text-teal-50 {
    --text-opacity: 1;
    color: #edfafa;
    color: rgba(237, 250, 250, var(--text-opacity));
  }
  .group:hover .md\\:group-hover\\:text-teal-100 {
    --text-opacity: 1;
    color: #d5f5f6;
    color: rgba(213, 245, 246, var(--text-opacity));
  }
  .group:hover .md\\:group-hover\\:text-teal-200 {
    --text-opacity: 1;
    color: #afecef;
    color: rgba(175, 236, 239, var(--text-opacity));
  }
  .group:hover .md\\:group-hover\\:text-teal-300 {
    --text-opacity: 1;
    color: #7edce2;
    color: rgba(126, 220, 226, var(--text-opacity));
  }
  .group:hover .md\\:group-hover\\:text-teal-400 {
    --text-opacity: 1;
    color: #16bdca;
    color: rgba(22, 189, 202, var(--text-opacity));
  }
  .group:hover .md\\:group-hover\\:text-teal-500 {
    --text-opacity: 1;
    color: #0694a2;
    color: rgba(6, 148, 162, var(--text-opacity));
  }
  .group:hover .md\\:group-hover\\:text-teal-600 {
    --text-opacity: 1;
    color: #047481;
    color: rgba(4, 116, 129, var(--text-opacity));
  }
  .group:hover .md\\:group-hover\\:text-teal-700 {
    --text-opacity: 1;
    color: #036672;
    color: rgba(3, 102, 114, var(--text-opacity));
  }
  .group:hover .md\\:group-hover\\:text-teal-800 {
    --text-opacity: 1;
    color: #05505c;
    color: rgba(5, 80, 92, var(--text-opacity));
  }
  .group:hover .md\\:group-hover\\:text-teal-900 {
    --text-opacity: 1;
    color: #014451;
    color: rgba(1, 68, 81, var(--text-opacity));
  }
  .group:hover .md\\:group-hover\\:text-blue-50 {
    --text-opacity: 1;
    color: #ebf5ff;
    color: rgba(235, 245, 255, var(--text-opacity));
  }
  .group:hover .md\\:group-hover\\:text-blue-100 {
    --text-opacity: 1;
    color: #e1effe;
    color: rgba(225, 239, 254, var(--text-opacity));
  }
  .group:hover .md\\:group-hover\\:text-blue-200 {
    --text-opacity: 1;
    color: #c3ddfd;
    color: rgba(195, 221, 253, var(--text-opacity));
  }
  .group:hover .md\\:group-hover\\:text-blue-300 {
    --text-opacity: 1;
    color: #a4cafe;
    color: rgba(164, 202, 254, var(--text-opacity));
  }
  .group:hover .md\\:group-hover\\:text-blue-400 {
    --text-opacity: 1;
    color: #76a9fa;
    color: rgba(118, 169, 250, var(--text-opacity));
  }
  .group:hover .md\\:group-hover\\:text-blue-500 {
    --text-opacity: 1;
    color: #3f83f8;
    color: rgba(63, 131, 248, var(--text-opacity));
  }
  .group:hover .md\\:group-hover\\:text-blue-600 {
    --text-opacity: 1;
    color: #1c64f2;
    color: rgba(28, 100, 242, var(--text-opacity));
  }
  .group:hover .md\\:group-hover\\:text-blue-700 {
    --text-opacity: 1;
    color: #1a56db;
    color: rgba(26, 86, 219, var(--text-opacity));
  }
  .group:hover .md\\:group-hover\\:text-blue-800 {
    --text-opacity: 1;
    color: #1e429f;
    color: rgba(30, 66, 159, var(--text-opacity));
  }
  .group:hover .md\\:group-hover\\:text-blue-900 {
    --text-opacity: 1;
    color: #233876;
    color: rgba(35, 56, 118, var(--text-opacity));
  }
  .group:hover .md\\:group-hover\\:text-indigo-50 {
    --text-opacity: 1;
    color: #f0f5ff;
    color: rgba(240, 245, 255, var(--text-opacity));
  }
  .group:hover .md\\:group-hover\\:text-indigo-100 {
    --text-opacity: 1;
    color: #e5edff;
    color: rgba(229, 237, 255, var(--text-opacity));
  }
  .group:hover .md\\:group-hover\\:text-indigo-200 {
    --text-opacity: 1;
    color: #cddbfe;
    color: rgba(205, 219, 254, var(--text-opacity));
  }
  .group:hover .md\\:group-hover\\:text-indigo-300 {
    --text-opacity: 1;
    color: #b4c6fc;
    color: rgba(180, 198, 252, var(--text-opacity));
  }
  .group:hover .md\\:group-hover\\:text-indigo-400 {
    --text-opacity: 1;
    color: #8da2fb;
    color: rgba(141, 162, 251, var(--text-opacity));
  }
  .group:hover .md\\:group-hover\\:text-indigo-500 {
    --text-opacity: 1;
    color: #6875f5;
    color: rgba(104, 117, 245, var(--text-opacity));
  }
  .group:hover .md\\:group-hover\\:text-indigo-600 {
    --text-opacity: 1;
    color: #5850ec;
    color: rgba(88, 80, 236, var(--text-opacity));
  }
  .group:hover .md\\:group-hover\\:text-indigo-700 {
    --text-opacity: 1;
    color: #5145cd;
    color: rgba(81, 69, 205, var(--text-opacity));
  }
  .group:hover .md\\:group-hover\\:text-indigo-800 {
    --text-opacity: 1;
    color: #42389d;
    color: rgba(66, 56, 157, var(--text-opacity));
  }
  .group:hover .md\\:group-hover\\:text-indigo-900 {
    --text-opacity: 1;
    color: #362f78;
    color: rgba(54, 47, 120, var(--text-opacity));
  }
  .group:hover .md\\:group-hover\\:text-purple-50 {
    --text-opacity: 1;
    color: #f6f5ff;
    color: rgba(246, 245, 255, var(--text-opacity));
  }
  .group:hover .md\\:group-hover\\:text-purple-100 {
    --text-opacity: 1;
    color: #edebfe;
    color: rgba(237, 235, 254, var(--text-opacity));
  }
  .group:hover .md\\:group-hover\\:text-purple-200 {
    --text-opacity: 1;
    color: #dcd7fe;
    color: rgba(220, 215, 254, var(--text-opacity));
  }
  .group:hover .md\\:group-hover\\:text-purple-300 {
    --text-opacity: 1;
    color: #cabffd;
    color: rgba(202, 191, 253, var(--text-opacity));
  }
  .group:hover .md\\:group-hover\\:text-purple-400 {
    --text-opacity: 1;
    color: #ac94fa;
    color: rgba(172, 148, 250, var(--text-opacity));
  }
  .group:hover .md\\:group-hover\\:text-purple-500 {
    --text-opacity: 1;
    color: #9061f9;
    color: rgba(144, 97, 249, var(--text-opacity));
  }
  .group:hover .md\\:group-hover\\:text-purple-600 {
    --text-opacity: 1;
    color: #7e3af2;
    color: rgba(126, 58, 242, var(--text-opacity));
  }
  .group:hover .md\\:group-hover\\:text-purple-700 {
    --text-opacity: 1;
    color: #6c2bd9;
    color: rgba(108, 43, 217, var(--text-opacity));
  }
  .group:hover .md\\:group-hover\\:text-purple-800 {
    --text-opacity: 1;
    color: #5521b5;
    color: rgba(85, 33, 181, var(--text-opacity));
  }
  .group:hover .md\\:group-hover\\:text-purple-900 {
    --text-opacity: 1;
    color: #4a1d96;
    color: rgba(74, 29, 150, var(--text-opacity));
  }
  .group:hover .md\\:group-hover\\:text-pink-50 {
    --text-opacity: 1;
    color: #fdf2f8;
    color: rgba(253, 242, 248, var(--text-opacity));
  }
  .group:hover .md\\:group-hover\\:text-pink-100 {
    --text-opacity: 1;
    color: #fce8f3;
    color: rgba(252, 232, 243, var(--text-opacity));
  }
  .group:hover .md\\:group-hover\\:text-pink-200 {
    --text-opacity: 1;
    color: #fad1e8;
    color: rgba(250, 209, 232, var(--text-opacity));
  }
  .group:hover .md\\:group-hover\\:text-pink-300 {
    --text-opacity: 1;
    color: #f8b4d9;
    color: rgba(248, 180, 217, var(--text-opacity));
  }
  .group:hover .md\\:group-hover\\:text-pink-400 {
    --text-opacity: 1;
    color: #f17eb8;
    color: rgba(241, 126, 184, var(--text-opacity));
  }
  .group:hover .md\\:group-hover\\:text-pink-500 {
    --text-opacity: 1;
    color: #e74694;
    color: rgba(231, 70, 148, var(--text-opacity));
  }
  .group:hover .md\\:group-hover\\:text-pink-600 {
    --text-opacity: 1;
    color: #d61f69;
    color: rgba(214, 31, 105, var(--text-opacity));
  }
  .group:hover .md\\:group-hover\\:text-pink-700 {
    --text-opacity: 1;
    color: #bf125d;
    color: rgba(191, 18, 93, var(--text-opacity));
  }
  .group:hover .md\\:group-hover\\:text-pink-800 {
    --text-opacity: 1;
    color: #99154b;
    color: rgba(153, 21, 75, var(--text-opacity));
  }
  .group:hover .md\\:group-hover\\:text-pink-900 {
    --text-opacity: 1;
    color: #751a3d;
    color: rgba(117, 26, 61, var(--text-opacity));
  }
  .group:hover .md\\:group-hover\\:text-cool-gray-50 {
    --text-opacity: 1;
    color: #f8fafc;
    color: rgba(248, 250, 252, var(--text-opacity));
  }
  .group:hover .md\\:group-hover\\:text-cool-gray-100 {
    --text-opacity: 1;
    color: #f1f5f9;
    color: rgba(241, 245, 249, var(--text-opacity));
  }
  .group:hover .md\\:group-hover\\:text-cool-gray-200 {
    --text-opacity: 1;
    color: #e2e8f0;
    color: rgba(226, 232, 240, var(--text-opacity));
  }
  .group:hover .md\\:group-hover\\:text-cool-gray-300 {
    --text-opacity: 1;
    color: #cfd8e3;
    color: rgba(207, 216, 227, var(--text-opacity));
  }
  .group:hover .md\\:group-hover\\:text-cool-gray-400 {
    --text-opacity: 1;
    color: #97a6ba;
    color: rgba(151, 166, 186, var(--text-opacity));
  }
  .group:hover .md\\:group-hover\\:text-cool-gray-500 {
    --text-opacity: 1;
    color: #64748b;
    color: rgba(100, 116, 139, var(--text-opacity));
  }
  .group:hover .md\\:group-hover\\:text-cool-gray-600 {
    --text-opacity: 1;
    color: #475569;
    color: rgba(71, 85, 105, var(--text-opacity));
  }
  .group:hover .md\\:group-hover\\:text-cool-gray-700 {
    --text-opacity: 1;
    color: #364152;
    color: rgba(54, 65, 82, var(--text-opacity));
  }
  .group:hover .md\\:group-hover\\:text-cool-gray-800 {
    --text-opacity: 1;
    color: #27303f;
    color: rgba(39, 48, 63, var(--text-opacity));
  }
  .group:hover .md\\:group-hover\\:text-cool-gray-900 {
    --text-opacity: 1;
    color: #1a202e;
    color: rgba(26, 32, 46, var(--text-opacity));
  }
  .group:focus .md\\:group-focus\\:text-current {
    color: currentColor;
  }
  .group:focus .md\\:group-focus\\:text-transparent {
    color: transparent;
  }
  .group:focus .md\\:group-focus\\:text-white {
    --text-opacity: 1;
    color: #ffffff;
    color: rgba(255, 255, 255, var(--text-opacity));
  }
  .group:focus .md\\:group-focus\\:text-black {
    --text-opacity: 1;
    color: #000000;
    color: rgba(0, 0, 0, var(--text-opacity));
  }
  .group:focus .md\\:group-focus\\:text-gray-50 {
    --text-opacity: 1;
    color: #f9fafb;
    color: rgba(249, 250, 251, var(--text-opacity));
  }
  .group:focus .md\\:group-focus\\:text-gray-100 {
    --text-opacity: 1;
    color: #f4f5f7;
    color: rgba(244, 245, 247, var(--text-opacity));
  }
  .group:focus .md\\:group-focus\\:text-gray-200 {
    --text-opacity: 1;
    color: #e5e7eb;
    color: rgba(229, 231, 235, var(--text-opacity));
  }
  .group:focus .md\\:group-focus\\:text-gray-300 {
    --text-opacity: 1;
    color: #d2d6dc;
    color: rgba(210, 214, 220, var(--text-opacity));
  }
  .group:focus .md\\:group-focus\\:text-gray-400 {
    --text-opacity: 1;
    color: #9fa6b2;
    color: rgba(159, 166, 178, var(--text-opacity));
  }
  .group:focus .md\\:group-focus\\:text-gray-500 {
    --text-opacity: 1;
    color: #6b7280;
    color: rgba(107, 114, 128, var(--text-opacity));
  }
  .group:focus .md\\:group-focus\\:text-gray-600 {
    --text-opacity: 1;
    color: #4b5563;
    color: rgba(75, 85, 99, var(--text-opacity));
  }
  .group:focus .md\\:group-focus\\:text-gray-700 {
    --text-opacity: 1;
    color: #374151;
    color: rgba(55, 65, 81, var(--text-opacity));
  }
  .group:focus .md\\:group-focus\\:text-gray-800 {
    --text-opacity: 1;
    color: #252f3f;
    color: rgba(37, 47, 63, var(--text-opacity));
  }
  .group:focus .md\\:group-focus\\:text-gray-900 {
    --text-opacity: 1;
    color: #161e2e;
    color: rgba(22, 30, 46, var(--text-opacity));
  }
  .group:focus .md\\:group-focus\\:text-red-50 {
    --text-opacity: 1;
    color: #fdf2f2;
    color: rgba(253, 242, 242, var(--text-opacity));
  }
  .group:focus .md\\:group-focus\\:text-red-100 {
    --text-opacity: 1;
    color: #fde8e8;
    color: rgba(253, 232, 232, var(--text-opacity));
  }
  .group:focus .md\\:group-focus\\:text-red-200 {
    --text-opacity: 1;
    color: #fbd5d5;
    color: rgba(251, 213, 213, var(--text-opacity));
  }
  .group:focus .md\\:group-focus\\:text-red-300 {
    --text-opacity: 1;
    color: #f8b4b4;
    color: rgba(248, 180, 180, var(--text-opacity));
  }
  .group:focus .md\\:group-focus\\:text-red-400 {
    --text-opacity: 1;
    color: #f98080;
    color: rgba(249, 128, 128, var(--text-opacity));
  }
  .group:focus .md\\:group-focus\\:text-red-500 {
    --text-opacity: 1;
    color: #f05252;
    color: rgba(240, 82, 82, var(--text-opacity));
  }
  .group:focus .md\\:group-focus\\:text-red-600 {
    --text-opacity: 1;
    color: #e02424;
    color: rgba(224, 36, 36, var(--text-opacity));
  }
  .group:focus .md\\:group-focus\\:text-red-700 {
    --text-opacity: 1;
    color: #c81e1e;
    color: rgba(200, 30, 30, var(--text-opacity));
  }
  .group:focus .md\\:group-focus\\:text-red-800 {
    --text-opacity: 1;
    color: #9b1c1c;
    color: rgba(155, 28, 28, var(--text-opacity));
  }
  .group:focus .md\\:group-focus\\:text-red-900 {
    --text-opacity: 1;
    color: #771d1d;
    color: rgba(119, 29, 29, var(--text-opacity));
  }
  .group:focus .md\\:group-focus\\:text-orange-50 {
    --text-opacity: 1;
    color: #fff8f1;
    color: rgba(255, 248, 241, var(--text-opacity));
  }
  .group:focus .md\\:group-focus\\:text-orange-100 {
    --text-opacity: 1;
    color: #feecdc;
    color: rgba(254, 236, 220, var(--text-opacity));
  }
  .group:focus .md\\:group-focus\\:text-orange-200 {
    --text-opacity: 1;
    color: #fcd9bd;
    color: rgba(252, 217, 189, var(--text-opacity));
  }
  .group:focus .md\\:group-focus\\:text-orange-300 {
    --text-opacity: 1;
    color: #fdba8c;
    color: rgba(253, 186, 140, var(--text-opacity));
  }
  .group:focus .md\\:group-focus\\:text-orange-400 {
    --text-opacity: 1;
    color: #ff8a4c;
    color: rgba(255, 138, 76, var(--text-opacity));
  }
  .group:focus .md\\:group-focus\\:text-orange-500 {
    --text-opacity: 1;
    color: #ff5a1f;
    color: rgba(255, 90, 31, var(--text-opacity));
  }
  .group:focus .md\\:group-focus\\:text-orange-600 {
    --text-opacity: 1;
    color: #d03801;
    color: rgba(208, 56, 1, var(--text-opacity));
  }
  .group:focus .md\\:group-focus\\:text-orange-700 {
    --text-opacity: 1;
    color: #b43403;
    color: rgba(180, 52, 3, var(--text-opacity));
  }
  .group:focus .md\\:group-focus\\:text-orange-800 {
    --text-opacity: 1;
    color: #8a2c0d;
    color: rgba(138, 44, 13, var(--text-opacity));
  }
  .group:focus .md\\:group-focus\\:text-orange-900 {
    --text-opacity: 1;
    color: #73230d;
    color: rgba(115, 35, 13, var(--text-opacity));
  }
  .group:focus .md\\:group-focus\\:text-yellow-50 {
    --text-opacity: 1;
    color: #fdfdea;
    color: rgba(253, 253, 234, var(--text-opacity));
  }
  .group:focus .md\\:group-focus\\:text-yellow-100 {
    --text-opacity: 1;
    color: #fdf6b2;
    color: rgba(253, 246, 178, var(--text-opacity));
  }
  .group:focus .md\\:group-focus\\:text-yellow-200 {
    --text-opacity: 1;
    color: #fce96a;
    color: rgba(252, 233, 106, var(--text-opacity));
  }
  .group:focus .md\\:group-focus\\:text-yellow-300 {
    --text-opacity: 1;
    color: #faca15;
    color: rgba(250, 202, 21, var(--text-opacity));
  }
  .group:focus .md\\:group-focus\\:text-yellow-400 {
    --text-opacity: 1;
    color: #e3a008;
    color: rgba(227, 160, 8, var(--text-opacity));
  }
  .group:focus .md\\:group-focus\\:text-yellow-500 {
    --text-opacity: 1;
    color: #c27803;
    color: rgba(194, 120, 3, var(--text-opacity));
  }
  .group:focus .md\\:group-focus\\:text-yellow-600 {
    --text-opacity: 1;
    color: #9f580a;
    color: rgba(159, 88, 10, var(--text-opacity));
  }
  .group:focus .md\\:group-focus\\:text-yellow-700 {
    --text-opacity: 1;
    color: #8e4b10;
    color: rgba(142, 75, 16, var(--text-opacity));
  }
  .group:focus .md\\:group-focus\\:text-yellow-800 {
    --text-opacity: 1;
    color: #723b13;
    color: rgba(114, 59, 19, var(--text-opacity));
  }
  .group:focus .md\\:group-focus\\:text-yellow-900 {
    --text-opacity: 1;
    color: #633112;
    color: rgba(99, 49, 18, var(--text-opacity));
  }
  .group:focus .md\\:group-focus\\:text-green-50 {
    --text-opacity: 1;
    color: #f3faf7;
    color: rgba(243, 250, 247, var(--text-opacity));
  }
  .group:focus .md\\:group-focus\\:text-green-100 {
    --text-opacity: 1;
    color: #def7ec;
    color: rgba(222, 247, 236, var(--text-opacity));
  }
  .group:focus .md\\:group-focus\\:text-green-200 {
    --text-opacity: 1;
    color: #bcf0da;
    color: rgba(188, 240, 218, var(--text-opacity));
  }
  .group:focus .md\\:group-focus\\:text-green-300 {
    --text-opacity: 1;
    color: #84e1bc;
    color: rgba(132, 225, 188, var(--text-opacity));
  }
  .group:focus .md\\:group-focus\\:text-green-400 {
    --text-opacity: 1;
    color: #31c48d;
    color: rgba(49, 196, 141, var(--text-opacity));
  }
  .group:focus .md\\:group-focus\\:text-green-500 {
    --text-opacity: 1;
    color: #0e9f6e;
    color: rgba(14, 159, 110, var(--text-opacity));
  }
  .group:focus .md\\:group-focus\\:text-green-600 {
    --text-opacity: 1;
    color: #057a55;
    color: rgba(5, 122, 85, var(--text-opacity));
  }
  .group:focus .md\\:group-focus\\:text-green-700 {
    --text-opacity: 1;
    color: #046c4e;
    color: rgba(4, 108, 78, var(--text-opacity));
  }
  .group:focus .md\\:group-focus\\:text-green-800 {
    --text-opacity: 1;
    color: #03543f;
    color: rgba(3, 84, 63, var(--text-opacity));
  }
  .group:focus .md\\:group-focus\\:text-green-900 {
    --text-opacity: 1;
    color: #014737;
    color: rgba(1, 71, 55, var(--text-opacity));
  }
  .group:focus .md\\:group-focus\\:text-teal-50 {
    --text-opacity: 1;
    color: #edfafa;
    color: rgba(237, 250, 250, var(--text-opacity));
  }
  .group:focus .md\\:group-focus\\:text-teal-100 {
    --text-opacity: 1;
    color: #d5f5f6;
    color: rgba(213, 245, 246, var(--text-opacity));
  }
  .group:focus .md\\:group-focus\\:text-teal-200 {
    --text-opacity: 1;
    color: #afecef;
    color: rgba(175, 236, 239, var(--text-opacity));
  }
  .group:focus .md\\:group-focus\\:text-teal-300 {
    --text-opacity: 1;
    color: #7edce2;
    color: rgba(126, 220, 226, var(--text-opacity));
  }
  .group:focus .md\\:group-focus\\:text-teal-400 {
    --text-opacity: 1;
    color: #16bdca;
    color: rgba(22, 189, 202, var(--text-opacity));
  }
  .group:focus .md\\:group-focus\\:text-teal-500 {
    --text-opacity: 1;
    color: #0694a2;
    color: rgba(6, 148, 162, var(--text-opacity));
  }
  .group:focus .md\\:group-focus\\:text-teal-600 {
    --text-opacity: 1;
    color: #047481;
    color: rgba(4, 116, 129, var(--text-opacity));
  }
  .group:focus .md\\:group-focus\\:text-teal-700 {
    --text-opacity: 1;
    color: #036672;
    color: rgba(3, 102, 114, var(--text-opacity));
  }
  .group:focus .md\\:group-focus\\:text-teal-800 {
    --text-opacity: 1;
    color: #05505c;
    color: rgba(5, 80, 92, var(--text-opacity));
  }
  .group:focus .md\\:group-focus\\:text-teal-900 {
    --text-opacity: 1;
    color: #014451;
    color: rgba(1, 68, 81, var(--text-opacity));
  }
  .group:focus .md\\:group-focus\\:text-blue-50 {
    --text-opacity: 1;
    color: #ebf5ff;
    color: rgba(235, 245, 255, var(--text-opacity));
  }
  .group:focus .md\\:group-focus\\:text-blue-100 {
    --text-opacity: 1;
    color: #e1effe;
    color: rgba(225, 239, 254, var(--text-opacity));
  }
  .group:focus .md\\:group-focus\\:text-blue-200 {
    --text-opacity: 1;
    color: #c3ddfd;
    color: rgba(195, 221, 253, var(--text-opacity));
  }
  .group:focus .md\\:group-focus\\:text-blue-300 {
    --text-opacity: 1;
    color: #a4cafe;
    color: rgba(164, 202, 254, var(--text-opacity));
  }
  .group:focus .md\\:group-focus\\:text-blue-400 {
    --text-opacity: 1;
    color: #76a9fa;
    color: rgba(118, 169, 250, var(--text-opacity));
  }
  .group:focus .md\\:group-focus\\:text-blue-500 {
    --text-opacity: 1;
    color: #3f83f8;
    color: rgba(63, 131, 248, var(--text-opacity));
  }
  .group:focus .md\\:group-focus\\:text-blue-600 {
    --text-opacity: 1;
    color: #1c64f2;
    color: rgba(28, 100, 242, var(--text-opacity));
  }
  .group:focus .md\\:group-focus\\:text-blue-700 {
    --text-opacity: 1;
    color: #1a56db;
    color: rgba(26, 86, 219, var(--text-opacity));
  }
  .group:focus .md\\:group-focus\\:text-blue-800 {
    --text-opacity: 1;
    color: #1e429f;
    color: rgba(30, 66, 159, var(--text-opacity));
  }
  .group:focus .md\\:group-focus\\:text-blue-900 {
    --text-opacity: 1;
    color: #233876;
    color: rgba(35, 56, 118, var(--text-opacity));
  }
  .group:focus .md\\:group-focus\\:text-indigo-50 {
    --text-opacity: 1;
    color: #f0f5ff;
    color: rgba(240, 245, 255, var(--text-opacity));
  }
  .group:focus .md\\:group-focus\\:text-indigo-100 {
    --text-opacity: 1;
    color: #e5edff;
    color: rgba(229, 237, 255, var(--text-opacity));
  }
  .group:focus .md\\:group-focus\\:text-indigo-200 {
    --text-opacity: 1;
    color: #cddbfe;
    color: rgba(205, 219, 254, var(--text-opacity));
  }
  .group:focus .md\\:group-focus\\:text-indigo-300 {
    --text-opacity: 1;
    color: #b4c6fc;
    color: rgba(180, 198, 252, var(--text-opacity));
  }
  .group:focus .md\\:group-focus\\:text-indigo-400 {
    --text-opacity: 1;
    color: #8da2fb;
    color: rgba(141, 162, 251, var(--text-opacity));
  }
  .group:focus .md\\:group-focus\\:text-indigo-500 {
    --text-opacity: 1;
    color: #6875f5;
    color: rgba(104, 117, 245, var(--text-opacity));
  }
  .group:focus .md\\:group-focus\\:text-indigo-600 {
    --text-opacity: 1;
    color: #5850ec;
    color: rgba(88, 80, 236, var(--text-opacity));
  }
  .group:focus .md\\:group-focus\\:text-indigo-700 {
    --text-opacity: 1;
    color: #5145cd;
    color: rgba(81, 69, 205, var(--text-opacity));
  }
  .group:focus .md\\:group-focus\\:text-indigo-800 {
    --text-opacity: 1;
    color: #42389d;
    color: rgba(66, 56, 157, var(--text-opacity));
  }
  .group:focus .md\\:group-focus\\:text-indigo-900 {
    --text-opacity: 1;
    color: #362f78;
    color: rgba(54, 47, 120, var(--text-opacity));
  }
  .group:focus .md\\:group-focus\\:text-purple-50 {
    --text-opacity: 1;
    color: #f6f5ff;
    color: rgba(246, 245, 255, var(--text-opacity));
  }
  .group:focus .md\\:group-focus\\:text-purple-100 {
    --text-opacity: 1;
    color: #edebfe;
    color: rgba(237, 235, 254, var(--text-opacity));
  }
  .group:focus .md\\:group-focus\\:text-purple-200 {
    --text-opacity: 1;
    color: #dcd7fe;
    color: rgba(220, 215, 254, var(--text-opacity));
  }
  .group:focus .md\\:group-focus\\:text-purple-300 {
    --text-opacity: 1;
    color: #cabffd;
    color: rgba(202, 191, 253, var(--text-opacity));
  }
  .group:focus .md\\:group-focus\\:text-purple-400 {
    --text-opacity: 1;
    color: #ac94fa;
    color: rgba(172, 148, 250, var(--text-opacity));
  }
  .group:focus .md\\:group-focus\\:text-purple-500 {
    --text-opacity: 1;
    color: #9061f9;
    color: rgba(144, 97, 249, var(--text-opacity));
  }
  .group:focus .md\\:group-focus\\:text-purple-600 {
    --text-opacity: 1;
    color: #7e3af2;
    color: rgba(126, 58, 242, var(--text-opacity));
  }
  .group:focus .md\\:group-focus\\:text-purple-700 {
    --text-opacity: 1;
    color: #6c2bd9;
    color: rgba(108, 43, 217, var(--text-opacity));
  }
  .group:focus .md\\:group-focus\\:text-purple-800 {
    --text-opacity: 1;
    color: #5521b5;
    color: rgba(85, 33, 181, var(--text-opacity));
  }
  .group:focus .md\\:group-focus\\:text-purple-900 {
    --text-opacity: 1;
    color: #4a1d96;
    color: rgba(74, 29, 150, var(--text-opacity));
  }
  .group:focus .md\\:group-focus\\:text-pink-50 {
    --text-opacity: 1;
    color: #fdf2f8;
    color: rgba(253, 242, 248, var(--text-opacity));
  }
  .group:focus .md\\:group-focus\\:text-pink-100 {
    --text-opacity: 1;
    color: #fce8f3;
    color: rgba(252, 232, 243, var(--text-opacity));
  }
  .group:focus .md\\:group-focus\\:text-pink-200 {
    --text-opacity: 1;
    color: #fad1e8;
    color: rgba(250, 209, 232, var(--text-opacity));
  }
  .group:focus .md\\:group-focus\\:text-pink-300 {
    --text-opacity: 1;
    color: #f8b4d9;
    color: rgba(248, 180, 217, var(--text-opacity));
  }
  .group:focus .md\\:group-focus\\:text-pink-400 {
    --text-opacity: 1;
    color: #f17eb8;
    color: rgba(241, 126, 184, var(--text-opacity));
  }
  .group:focus .md\\:group-focus\\:text-pink-500 {
    --text-opacity: 1;
    color: #e74694;
    color: rgba(231, 70, 148, var(--text-opacity));
  }
  .group:focus .md\\:group-focus\\:text-pink-600 {
    --text-opacity: 1;
    color: #d61f69;
    color: rgba(214, 31, 105, var(--text-opacity));
  }
  .group:focus .md\\:group-focus\\:text-pink-700 {
    --text-opacity: 1;
    color: #bf125d;
    color: rgba(191, 18, 93, var(--text-opacity));
  }
  .group:focus .md\\:group-focus\\:text-pink-800 {
    --text-opacity: 1;
    color: #99154b;
    color: rgba(153, 21, 75, var(--text-opacity));
  }
  .group:focus .md\\:group-focus\\:text-pink-900 {
    --text-opacity: 1;
    color: #751a3d;
    color: rgba(117, 26, 61, var(--text-opacity));
  }
  .group:focus .md\\:group-focus\\:text-cool-gray-50 {
    --text-opacity: 1;
    color: #f8fafc;
    color: rgba(248, 250, 252, var(--text-opacity));
  }
  .group:focus .md\\:group-focus\\:text-cool-gray-100 {
    --text-opacity: 1;
    color: #f1f5f9;
    color: rgba(241, 245, 249, var(--text-opacity));
  }
  .group:focus .md\\:group-focus\\:text-cool-gray-200 {
    --text-opacity: 1;
    color: #e2e8f0;
    color: rgba(226, 232, 240, var(--text-opacity));
  }
  .group:focus .md\\:group-focus\\:text-cool-gray-300 {
    --text-opacity: 1;
    color: #cfd8e3;
    color: rgba(207, 216, 227, var(--text-opacity));
  }
  .group:focus .md\\:group-focus\\:text-cool-gray-400 {
    --text-opacity: 1;
    color: #97a6ba;
    color: rgba(151, 166, 186, var(--text-opacity));
  }
  .group:focus .md\\:group-focus\\:text-cool-gray-500 {
    --text-opacity: 1;
    color: #64748b;
    color: rgba(100, 116, 139, var(--text-opacity));
  }
  .group:focus .md\\:group-focus\\:text-cool-gray-600 {
    --text-opacity: 1;
    color: #475569;
    color: rgba(71, 85, 105, var(--text-opacity));
  }
  .group:focus .md\\:group-focus\\:text-cool-gray-700 {
    --text-opacity: 1;
    color: #364152;
    color: rgba(54, 65, 82, var(--text-opacity));
  }
  .group:focus .md\\:group-focus\\:text-cool-gray-800 {
    --text-opacity: 1;
    color: #27303f;
    color: rgba(39, 48, 63, var(--text-opacity));
  }
  .group:focus .md\\:group-focus\\:text-cool-gray-900 {
    --text-opacity: 1;
    color: #1a202e;
    color: rgba(26, 32, 46, var(--text-opacity));
  }
  .md\\:hover\\:text-current:hover {
    color: currentColor;
  }
  .md\\:hover\\:text-transparent:hover {
    color: transparent;
  }
  .md\\:hover\\:text-white:hover {
    --text-opacity: 1;
    color: #ffffff;
    color: rgba(255, 255, 255, var(--text-opacity));
  }
  .md\\:hover\\:text-black:hover {
    --text-opacity: 1;
    color: #000000;
    color: rgba(0, 0, 0, var(--text-opacity));
  }
  .md\\:hover\\:text-gray-50:hover {
    --text-opacity: 1;
    color: #f9fafb;
    color: rgba(249, 250, 251, var(--text-opacity));
  }
  .md\\:hover\\:text-gray-100:hover {
    --text-opacity: 1;
    color: #f4f5f7;
    color: rgba(244, 245, 247, var(--text-opacity));
  }
  .md\\:hover\\:text-gray-200:hover {
    --text-opacity: 1;
    color: #e5e7eb;
    color: rgba(229, 231, 235, var(--text-opacity));
  }
  .md\\:hover\\:text-gray-300:hover {
    --text-opacity: 1;
    color: #d2d6dc;
    color: rgba(210, 214, 220, var(--text-opacity));
  }
  .md\\:hover\\:text-gray-400:hover {
    --text-opacity: 1;
    color: #9fa6b2;
    color: rgba(159, 166, 178, var(--text-opacity));
  }
  .md\\:hover\\:text-gray-500:hover {
    --text-opacity: 1;
    color: #6b7280;
    color: rgba(107, 114, 128, var(--text-opacity));
  }
  .md\\:hover\\:text-gray-600:hover {
    --text-opacity: 1;
    color: #4b5563;
    color: rgba(75, 85, 99, var(--text-opacity));
  }
  .md\\:hover\\:text-gray-700:hover {
    --text-opacity: 1;
    color: #374151;
    color: rgba(55, 65, 81, var(--text-opacity));
  }
  .md\\:hover\\:text-gray-800:hover {
    --text-opacity: 1;
    color: #252f3f;
    color: rgba(37, 47, 63, var(--text-opacity));
  }
  .md\\:hover\\:text-gray-900:hover {
    --text-opacity: 1;
    color: #161e2e;
    color: rgba(22, 30, 46, var(--text-opacity));
  }
  .md\\:hover\\:text-red-50:hover {
    --text-opacity: 1;
    color: #fdf2f2;
    color: rgba(253, 242, 242, var(--text-opacity));
  }
  .md\\:hover\\:text-red-100:hover {
    --text-opacity: 1;
    color: #fde8e8;
    color: rgba(253, 232, 232, var(--text-opacity));
  }
  .md\\:hover\\:text-red-200:hover {
    --text-opacity: 1;
    color: #fbd5d5;
    color: rgba(251, 213, 213, var(--text-opacity));
  }
  .md\\:hover\\:text-red-300:hover {
    --text-opacity: 1;
    color: #f8b4b4;
    color: rgba(248, 180, 180, var(--text-opacity));
  }
  .md\\:hover\\:text-red-400:hover {
    --text-opacity: 1;
    color: #f98080;
    color: rgba(249, 128, 128, var(--text-opacity));
  }
  .md\\:hover\\:text-red-500:hover {
    --text-opacity: 1;
    color: #f05252;
    color: rgba(240, 82, 82, var(--text-opacity));
  }
  .md\\:hover\\:text-red-600:hover {
    --text-opacity: 1;
    color: #e02424;
    color: rgba(224, 36, 36, var(--text-opacity));
  }
  .md\\:hover\\:text-red-700:hover {
    --text-opacity: 1;
    color: #c81e1e;
    color: rgba(200, 30, 30, var(--text-opacity));
  }
  .md\\:hover\\:text-red-800:hover {
    --text-opacity: 1;
    color: #9b1c1c;
    color: rgba(155, 28, 28, var(--text-opacity));
  }
  .md\\:hover\\:text-red-900:hover {
    --text-opacity: 1;
    color: #771d1d;
    color: rgba(119, 29, 29, var(--text-opacity));
  }
  .md\\:hover\\:text-orange-50:hover {
    --text-opacity: 1;
    color: #fff8f1;
    color: rgba(255, 248, 241, var(--text-opacity));
  }
  .md\\:hover\\:text-orange-100:hover {
    --text-opacity: 1;
    color: #feecdc;
    color: rgba(254, 236, 220, var(--text-opacity));
  }
  .md\\:hover\\:text-orange-200:hover {
    --text-opacity: 1;
    color: #fcd9bd;
    color: rgba(252, 217, 189, var(--text-opacity));
  }
  .md\\:hover\\:text-orange-300:hover {
    --text-opacity: 1;
    color: #fdba8c;
    color: rgba(253, 186, 140, var(--text-opacity));
  }
  .md\\:hover\\:text-orange-400:hover {
    --text-opacity: 1;
    color: #ff8a4c;
    color: rgba(255, 138, 76, var(--text-opacity));
  }
  .md\\:hover\\:text-orange-500:hover {
    --text-opacity: 1;
    color: #ff5a1f;
    color: rgba(255, 90, 31, var(--text-opacity));
  }
  .md\\:hover\\:text-orange-600:hover {
    --text-opacity: 1;
    color: #d03801;
    color: rgba(208, 56, 1, var(--text-opacity));
  }
  .md\\:hover\\:text-orange-700:hover {
    --text-opacity: 1;
    color: #b43403;
    color: rgba(180, 52, 3, var(--text-opacity));
  }
  .md\\:hover\\:text-orange-800:hover {
    --text-opacity: 1;
    color: #8a2c0d;
    color: rgba(138, 44, 13, var(--text-opacity));
  }
  .md\\:hover\\:text-orange-900:hover {
    --text-opacity: 1;
    color: #73230d;
    color: rgba(115, 35, 13, var(--text-opacity));
  }
  .md\\:hover\\:text-yellow-50:hover {
    --text-opacity: 1;
    color: #fdfdea;
    color: rgba(253, 253, 234, var(--text-opacity));
  }
  .md\\:hover\\:text-yellow-100:hover {
    --text-opacity: 1;
    color: #fdf6b2;
    color: rgba(253, 246, 178, var(--text-opacity));
  }
  .md\\:hover\\:text-yellow-200:hover {
    --text-opacity: 1;
    color: #fce96a;
    color: rgba(252, 233, 106, var(--text-opacity));
  }
  .md\\:hover\\:text-yellow-300:hover {
    --text-opacity: 1;
    color: #faca15;
    color: rgba(250, 202, 21, var(--text-opacity));
  }
  .md\\:hover\\:text-yellow-400:hover {
    --text-opacity: 1;
    color: #e3a008;
    color: rgba(227, 160, 8, var(--text-opacity));
  }
  .md\\:hover\\:text-yellow-500:hover {
    --text-opacity: 1;
    color: #c27803;
    color: rgba(194, 120, 3, var(--text-opacity));
  }
  .md\\:hover\\:text-yellow-600:hover {
    --text-opacity: 1;
    color: #9f580a;
    color: rgba(159, 88, 10, var(--text-opacity));
  }
  .md\\:hover\\:text-yellow-700:hover {
    --text-opacity: 1;
    color: #8e4b10;
    color: rgba(142, 75, 16, var(--text-opacity));
  }
  .md\\:hover\\:text-yellow-800:hover {
    --text-opacity: 1;
    color: #723b13;
    color: rgba(114, 59, 19, var(--text-opacity));
  }
  .md\\:hover\\:text-yellow-900:hover {
    --text-opacity: 1;
    color: #633112;
    color: rgba(99, 49, 18, var(--text-opacity));
  }
  .md\\:hover\\:text-green-50:hover {
    --text-opacity: 1;
    color: #f3faf7;
    color: rgba(243, 250, 247, var(--text-opacity));
  }
  .md\\:hover\\:text-green-100:hover {
    --text-opacity: 1;
    color: #def7ec;
    color: rgba(222, 247, 236, var(--text-opacity));
  }
  .md\\:hover\\:text-green-200:hover {
    --text-opacity: 1;
    color: #bcf0da;
    color: rgba(188, 240, 218, var(--text-opacity));
  }
  .md\\:hover\\:text-green-300:hover {
    --text-opacity: 1;
    color: #84e1bc;
    color: rgba(132, 225, 188, var(--text-opacity));
  }
  .md\\:hover\\:text-green-400:hover {
    --text-opacity: 1;
    color: #31c48d;
    color: rgba(49, 196, 141, var(--text-opacity));
  }
  .md\\:hover\\:text-green-500:hover {
    --text-opacity: 1;
    color: #0e9f6e;
    color: rgba(14, 159, 110, var(--text-opacity));
  }
  .md\\:hover\\:text-green-600:hover {
    --text-opacity: 1;
    color: #057a55;
    color: rgba(5, 122, 85, var(--text-opacity));
  }
  .md\\:hover\\:text-green-700:hover {
    --text-opacity: 1;
    color: #046c4e;
    color: rgba(4, 108, 78, var(--text-opacity));
  }
  .md\\:hover\\:text-green-800:hover {
    --text-opacity: 1;
    color: #03543f;
    color: rgba(3, 84, 63, var(--text-opacity));
  }
  .md\\:hover\\:text-green-900:hover {
    --text-opacity: 1;
    color: #014737;
    color: rgba(1, 71, 55, var(--text-opacity));
  }
  .md\\:hover\\:text-teal-50:hover {
    --text-opacity: 1;
    color: #edfafa;
    color: rgba(237, 250, 250, var(--text-opacity));
  }
  .md\\:hover\\:text-teal-100:hover {
    --text-opacity: 1;
    color: #d5f5f6;
    color: rgba(213, 245, 246, var(--text-opacity));
  }
  .md\\:hover\\:text-teal-200:hover {
    --text-opacity: 1;
    color: #afecef;
    color: rgba(175, 236, 239, var(--text-opacity));
  }
  .md\\:hover\\:text-teal-300:hover {
    --text-opacity: 1;
    color: #7edce2;
    color: rgba(126, 220, 226, var(--text-opacity));
  }
  .md\\:hover\\:text-teal-400:hover {
    --text-opacity: 1;
    color: #16bdca;
    color: rgba(22, 189, 202, var(--text-opacity));
  }
  .md\\:hover\\:text-teal-500:hover {
    --text-opacity: 1;
    color: #0694a2;
    color: rgba(6, 148, 162, var(--text-opacity));
  }
  .md\\:hover\\:text-teal-600:hover {
    --text-opacity: 1;
    color: #047481;
    color: rgba(4, 116, 129, var(--text-opacity));
  }
  .md\\:hover\\:text-teal-700:hover {
    --text-opacity: 1;
    color: #036672;
    color: rgba(3, 102, 114, var(--text-opacity));
  }
  .md\\:hover\\:text-teal-800:hover {
    --text-opacity: 1;
    color: #05505c;
    color: rgba(5, 80, 92, var(--text-opacity));
  }
  .md\\:hover\\:text-teal-900:hover {
    --text-opacity: 1;
    color: #014451;
    color: rgba(1, 68, 81, var(--text-opacity));
  }
  .md\\:hover\\:text-blue-50:hover {
    --text-opacity: 1;
    color: #ebf5ff;
    color: rgba(235, 245, 255, var(--text-opacity));
  }
  .md\\:hover\\:text-blue-100:hover {
    --text-opacity: 1;
    color: #e1effe;
    color: rgba(225, 239, 254, var(--text-opacity));
  }
  .md\\:hover\\:text-blue-200:hover {
    --text-opacity: 1;
    color: #c3ddfd;
    color: rgba(195, 221, 253, var(--text-opacity));
  }
  .md\\:hover\\:text-blue-300:hover {
    --text-opacity: 1;
    color: #a4cafe;
    color: rgba(164, 202, 254, var(--text-opacity));
  }
  .md\\:hover\\:text-blue-400:hover {
    --text-opacity: 1;
    color: #76a9fa;
    color: rgba(118, 169, 250, var(--text-opacity));
  }
  .md\\:hover\\:text-blue-500:hover {
    --text-opacity: 1;
    color: #3f83f8;
    color: rgba(63, 131, 248, var(--text-opacity));
  }
  .md\\:hover\\:text-blue-600:hover {
    --text-opacity: 1;
    color: #1c64f2;
    color: rgba(28, 100, 242, var(--text-opacity));
  }
  .md\\:hover\\:text-blue-700:hover {
    --text-opacity: 1;
    color: #1a56db;
    color: rgba(26, 86, 219, var(--text-opacity));
  }
  .md\\:hover\\:text-blue-800:hover {
    --text-opacity: 1;
    color: #1e429f;
    color: rgba(30, 66, 159, var(--text-opacity));
  }
  .md\\:hover\\:text-blue-900:hover {
    --text-opacity: 1;
    color: #233876;
    color: rgba(35, 56, 118, var(--text-opacity));
  }
  .md\\:hover\\:text-indigo-50:hover {
    --text-opacity: 1;
    color: #f0f5ff;
    color: rgba(240, 245, 255, var(--text-opacity));
  }
  .md\\:hover\\:text-indigo-100:hover {
    --text-opacity: 1;
    color: #e5edff;
    color: rgba(229, 237, 255, var(--text-opacity));
  }
  .md\\:hover\\:text-indigo-200:hover {
    --text-opacity: 1;
    color: #cddbfe;
    color: rgba(205, 219, 254, var(--text-opacity));
  }
  .md\\:hover\\:text-indigo-300:hover {
    --text-opacity: 1;
    color: #b4c6fc;
    color: rgba(180, 198, 252, var(--text-opacity));
  }
  .md\\:hover\\:text-indigo-400:hover {
    --text-opacity: 1;
    color: #8da2fb;
    color: rgba(141, 162, 251, var(--text-opacity));
  }
  .md\\:hover\\:text-indigo-500:hover {
    --text-opacity: 1;
    color: #6875f5;
    color: rgba(104, 117, 245, var(--text-opacity));
  }
  .md\\:hover\\:text-indigo-600:hover {
    --text-opacity: 1;
    color: #5850ec;
    color: rgba(88, 80, 236, var(--text-opacity));
  }
  .md\\:hover\\:text-indigo-700:hover {
    --text-opacity: 1;
    color: #5145cd;
    color: rgba(81, 69, 205, var(--text-opacity));
  }
  .md\\:hover\\:text-indigo-800:hover {
    --text-opacity: 1;
    color: #42389d;
    color: rgba(66, 56, 157, var(--text-opacity));
  }
  .md\\:hover\\:text-indigo-900:hover {
    --text-opacity: 1;
    color: #362f78;
    color: rgba(54, 47, 120, var(--text-opacity));
  }
  .md\\:hover\\:text-purple-50:hover {
    --text-opacity: 1;
    color: #f6f5ff;
    color: rgba(246, 245, 255, var(--text-opacity));
  }
  .md\\:hover\\:text-purple-100:hover {
    --text-opacity: 1;
    color: #edebfe;
    color: rgba(237, 235, 254, var(--text-opacity));
  }
  .md\\:hover\\:text-purple-200:hover {
    --text-opacity: 1;
    color: #dcd7fe;
    color: rgba(220, 215, 254, var(--text-opacity));
  }
  .md\\:hover\\:text-purple-300:hover {
    --text-opacity: 1;
    color: #cabffd;
    color: rgba(202, 191, 253, var(--text-opacity));
  }
  .md\\:hover\\:text-purple-400:hover {
    --text-opacity: 1;
    color: #ac94fa;
    color: rgba(172, 148, 250, var(--text-opacity));
  }
  .md\\:hover\\:text-purple-500:hover {
    --text-opacity: 1;
    color: #9061f9;
    color: rgba(144, 97, 249, var(--text-opacity));
  }
  .md\\:hover\\:text-purple-600:hover {
    --text-opacity: 1;
    color: #7e3af2;
    color: rgba(126, 58, 242, var(--text-opacity));
  }
  .md\\:hover\\:text-purple-700:hover {
    --text-opacity: 1;
    color: #6c2bd9;
    color: rgba(108, 43, 217, var(--text-opacity));
  }
  .md\\:hover\\:text-purple-800:hover {
    --text-opacity: 1;
    color: #5521b5;
    color: rgba(85, 33, 181, var(--text-opacity));
  }
  .md\\:hover\\:text-purple-900:hover {
    --text-opacity: 1;
    color: #4a1d96;
    color: rgba(74, 29, 150, var(--text-opacity));
  }
  .md\\:hover\\:text-pink-50:hover {
    --text-opacity: 1;
    color: #fdf2f8;
    color: rgba(253, 242, 248, var(--text-opacity));
  }
  .md\\:hover\\:text-pink-100:hover {
    --text-opacity: 1;
    color: #fce8f3;
    color: rgba(252, 232, 243, var(--text-opacity));
  }
  .md\\:hover\\:text-pink-200:hover {
    --text-opacity: 1;
    color: #fad1e8;
    color: rgba(250, 209, 232, var(--text-opacity));
  }
  .md\\:hover\\:text-pink-300:hover {
    --text-opacity: 1;
    color: #f8b4d9;
    color: rgba(248, 180, 217, var(--text-opacity));
  }
  .md\\:hover\\:text-pink-400:hover {
    --text-opacity: 1;
    color: #f17eb8;
    color: rgba(241, 126, 184, var(--text-opacity));
  }
  .md\\:hover\\:text-pink-500:hover {
    --text-opacity: 1;
    color: #e74694;
    color: rgba(231, 70, 148, var(--text-opacity));
  }
  .md\\:hover\\:text-pink-600:hover {
    --text-opacity: 1;
    color: #d61f69;
    color: rgba(214, 31, 105, var(--text-opacity));
  }
  .md\\:hover\\:text-pink-700:hover {
    --text-opacity: 1;
    color: #bf125d;
    color: rgba(191, 18, 93, var(--text-opacity));
  }
  .md\\:hover\\:text-pink-800:hover {
    --text-opacity: 1;
    color: #99154b;
    color: rgba(153, 21, 75, var(--text-opacity));
  }
  .md\\:hover\\:text-pink-900:hover {
    --text-opacity: 1;
    color: #751a3d;
    color: rgba(117, 26, 61, var(--text-opacity));
  }
  .md\\:hover\\:text-cool-gray-50:hover {
    --text-opacity: 1;
    color: #f8fafc;
    color: rgba(248, 250, 252, var(--text-opacity));
  }
  .md\\:hover\\:text-cool-gray-100:hover {
    --text-opacity: 1;
    color: #f1f5f9;
    color: rgba(241, 245, 249, var(--text-opacity));
  }
  .md\\:hover\\:text-cool-gray-200:hover {
    --text-opacity: 1;
    color: #e2e8f0;
    color: rgba(226, 232, 240, var(--text-opacity));
  }
  .md\\:hover\\:text-cool-gray-300:hover {
    --text-opacity: 1;
    color: #cfd8e3;
    color: rgba(207, 216, 227, var(--text-opacity));
  }
  .md\\:hover\\:text-cool-gray-400:hover {
    --text-opacity: 1;
    color: #97a6ba;
    color: rgba(151, 166, 186, var(--text-opacity));
  }
  .md\\:hover\\:text-cool-gray-500:hover {
    --text-opacity: 1;
    color: #64748b;
    color: rgba(100, 116, 139, var(--text-opacity));
  }
  .md\\:hover\\:text-cool-gray-600:hover {
    --text-opacity: 1;
    color: #475569;
    color: rgba(71, 85, 105, var(--text-opacity));
  }
  .md\\:hover\\:text-cool-gray-700:hover {
    --text-opacity: 1;
    color: #364152;
    color: rgba(54, 65, 82, var(--text-opacity));
  }
  .md\\:hover\\:text-cool-gray-800:hover {
    --text-opacity: 1;
    color: #27303f;
    color: rgba(39, 48, 63, var(--text-opacity));
  }
  .md\\:hover\\:text-cool-gray-900:hover {
    --text-opacity: 1;
    color: #1a202e;
    color: rgba(26, 32, 46, var(--text-opacity));
  }
  .md\\:focus-within\\:text-current:focus-within {
    color: currentColor;
  }
  .md\\:focus-within\\:text-transparent:focus-within {
    color: transparent;
  }
  .md\\:focus-within\\:text-white:focus-within {
    --text-opacity: 1;
    color: #ffffff;
    color: rgba(255, 255, 255, var(--text-opacity));
  }
  .md\\:focus-within\\:text-black:focus-within {
    --text-opacity: 1;
    color: #000000;
    color: rgba(0, 0, 0, var(--text-opacity));
  }
  .md\\:focus-within\\:text-gray-50:focus-within {
    --text-opacity: 1;
    color: #f9fafb;
    color: rgba(249, 250, 251, var(--text-opacity));
  }
  .md\\:focus-within\\:text-gray-100:focus-within {
    --text-opacity: 1;
    color: #f4f5f7;
    color: rgba(244, 245, 247, var(--text-opacity));
  }
  .md\\:focus-within\\:text-gray-200:focus-within {
    --text-opacity: 1;
    color: #e5e7eb;
    color: rgba(229, 231, 235, var(--text-opacity));
  }
  .md\\:focus-within\\:text-gray-300:focus-within {
    --text-opacity: 1;
    color: #d2d6dc;
    color: rgba(210, 214, 220, var(--text-opacity));
  }
  .md\\:focus-within\\:text-gray-400:focus-within {
    --text-opacity: 1;
    color: #9fa6b2;
    color: rgba(159, 166, 178, var(--text-opacity));
  }
  .md\\:focus-within\\:text-gray-500:focus-within {
    --text-opacity: 1;
    color: #6b7280;
    color: rgba(107, 114, 128, var(--text-opacity));
  }
  .md\\:focus-within\\:text-gray-600:focus-within {
    --text-opacity: 1;
    color: #4b5563;
    color: rgba(75, 85, 99, var(--text-opacity));
  }
  .md\\:focus-within\\:text-gray-700:focus-within {
    --text-opacity: 1;
    color: #374151;
    color: rgba(55, 65, 81, var(--text-opacity));
  }
  .md\\:focus-within\\:text-gray-800:focus-within {
    --text-opacity: 1;
    color: #252f3f;
    color: rgba(37, 47, 63, var(--text-opacity));
  }
  .md\\:focus-within\\:text-gray-900:focus-within {
    --text-opacity: 1;
    color: #161e2e;
    color: rgba(22, 30, 46, var(--text-opacity));
  }
  .md\\:focus-within\\:text-red-50:focus-within {
    --text-opacity: 1;
    color: #fdf2f2;
    color: rgba(253, 242, 242, var(--text-opacity));
  }
  .md\\:focus-within\\:text-red-100:focus-within {
    --text-opacity: 1;
    color: #fde8e8;
    color: rgba(253, 232, 232, var(--text-opacity));
  }
  .md\\:focus-within\\:text-red-200:focus-within {
    --text-opacity: 1;
    color: #fbd5d5;
    color: rgba(251, 213, 213, var(--text-opacity));
  }
  .md\\:focus-within\\:text-red-300:focus-within {
    --text-opacity: 1;
    color: #f8b4b4;
    color: rgba(248, 180, 180, var(--text-opacity));
  }
  .md\\:focus-within\\:text-red-400:focus-within {
    --text-opacity: 1;
    color: #f98080;
    color: rgba(249, 128, 128, var(--text-opacity));
  }
  .md\\:focus-within\\:text-red-500:focus-within {
    --text-opacity: 1;
    color: #f05252;
    color: rgba(240, 82, 82, var(--text-opacity));
  }
  .md\\:focus-within\\:text-red-600:focus-within {
    --text-opacity: 1;
    color: #e02424;
    color: rgba(224, 36, 36, var(--text-opacity));
  }
  .md\\:focus-within\\:text-red-700:focus-within {
    --text-opacity: 1;
    color: #c81e1e;
    color: rgba(200, 30, 30, var(--text-opacity));
  }
  .md\\:focus-within\\:text-red-800:focus-within {
    --text-opacity: 1;
    color: #9b1c1c;
    color: rgba(155, 28, 28, var(--text-opacity));
  }
  .md\\:focus-within\\:text-red-900:focus-within {
    --text-opacity: 1;
    color: #771d1d;
    color: rgba(119, 29, 29, var(--text-opacity));
  }
  .md\\:focus-within\\:text-orange-50:focus-within {
    --text-opacity: 1;
    color: #fff8f1;
    color: rgba(255, 248, 241, var(--text-opacity));
  }
  .md\\:focus-within\\:text-orange-100:focus-within {
    --text-opacity: 1;
    color: #feecdc;
    color: rgba(254, 236, 220, var(--text-opacity));
  }
  .md\\:focus-within\\:text-orange-200:focus-within {
    --text-opacity: 1;
    color: #fcd9bd;
    color: rgba(252, 217, 189, var(--text-opacity));
  }
  .md\\:focus-within\\:text-orange-300:focus-within {
    --text-opacity: 1;
    color: #fdba8c;
    color: rgba(253, 186, 140, var(--text-opacity));
  }
  .md\\:focus-within\\:text-orange-400:focus-within {
    --text-opacity: 1;
    color: #ff8a4c;
    color: rgba(255, 138, 76, var(--text-opacity));
  }
  .md\\:focus-within\\:text-orange-500:focus-within {
    --text-opacity: 1;
    color: #ff5a1f;
    color: rgba(255, 90, 31, var(--text-opacity));
  }
  .md\\:focus-within\\:text-orange-600:focus-within {
    --text-opacity: 1;
    color: #d03801;
    color: rgba(208, 56, 1, var(--text-opacity));
  }
  .md\\:focus-within\\:text-orange-700:focus-within {
    --text-opacity: 1;
    color: #b43403;
    color: rgba(180, 52, 3, var(--text-opacity));
  }
  .md\\:focus-within\\:text-orange-800:focus-within {
    --text-opacity: 1;
    color: #8a2c0d;
    color: rgba(138, 44, 13, var(--text-opacity));
  }
  .md\\:focus-within\\:text-orange-900:focus-within {
    --text-opacity: 1;
    color: #73230d;
    color: rgba(115, 35, 13, var(--text-opacity));
  }
  .md\\:focus-within\\:text-yellow-50:focus-within {
    --text-opacity: 1;
    color: #fdfdea;
    color: rgba(253, 253, 234, var(--text-opacity));
  }
  .md\\:focus-within\\:text-yellow-100:focus-within {
    --text-opacity: 1;
    color: #fdf6b2;
    color: rgba(253, 246, 178, var(--text-opacity));
  }
  .md\\:focus-within\\:text-yellow-200:focus-within {
    --text-opacity: 1;
    color: #fce96a;
    color: rgba(252, 233, 106, var(--text-opacity));
  }
  .md\\:focus-within\\:text-yellow-300:focus-within {
    --text-opacity: 1;
    color: #faca15;
    color: rgba(250, 202, 21, var(--text-opacity));
  }
  .md\\:focus-within\\:text-yellow-400:focus-within {
    --text-opacity: 1;
    color: #e3a008;
    color: rgba(227, 160, 8, var(--text-opacity));
  }
  .md\\:focus-within\\:text-yellow-500:focus-within {
    --text-opacity: 1;
    color: #c27803;
    color: rgba(194, 120, 3, var(--text-opacity));
  }
  .md\\:focus-within\\:text-yellow-600:focus-within {
    --text-opacity: 1;
    color: #9f580a;
    color: rgba(159, 88, 10, var(--text-opacity));
  }
  .md\\:focus-within\\:text-yellow-700:focus-within {
    --text-opacity: 1;
    color: #8e4b10;
    color: rgba(142, 75, 16, var(--text-opacity));
  }
  .md\\:focus-within\\:text-yellow-800:focus-within {
    --text-opacity: 1;
    color: #723b13;
    color: rgba(114, 59, 19, var(--text-opacity));
  }
  .md\\:focus-within\\:text-yellow-900:focus-within {
    --text-opacity: 1;
    color: #633112;
    color: rgba(99, 49, 18, var(--text-opacity));
  }
  .md\\:focus-within\\:text-green-50:focus-within {
    --text-opacity: 1;
    color: #f3faf7;
    color: rgba(243, 250, 247, var(--text-opacity));
  }
  .md\\:focus-within\\:text-green-100:focus-within {
    --text-opacity: 1;
    color: #def7ec;
    color: rgba(222, 247, 236, var(--text-opacity));
  }
  .md\\:focus-within\\:text-green-200:focus-within {
    --text-opacity: 1;
    color: #bcf0da;
    color: rgba(188, 240, 218, var(--text-opacity));
  }
  .md\\:focus-within\\:text-green-300:focus-within {
    --text-opacity: 1;
    color: #84e1bc;
    color: rgba(132, 225, 188, var(--text-opacity));
  }
  .md\\:focus-within\\:text-green-400:focus-within {
    --text-opacity: 1;
    color: #31c48d;
    color: rgba(49, 196, 141, var(--text-opacity));
  }
  .md\\:focus-within\\:text-green-500:focus-within {
    --text-opacity: 1;
    color: #0e9f6e;
    color: rgba(14, 159, 110, var(--text-opacity));
  }
  .md\\:focus-within\\:text-green-600:focus-within {
    --text-opacity: 1;
    color: #057a55;
    color: rgba(5, 122, 85, var(--text-opacity));
  }
  .md\\:focus-within\\:text-green-700:focus-within {
    --text-opacity: 1;
    color: #046c4e;
    color: rgba(4, 108, 78, var(--text-opacity));
  }
  .md\\:focus-within\\:text-green-800:focus-within {
    --text-opacity: 1;
    color: #03543f;
    color: rgba(3, 84, 63, var(--text-opacity));
  }
  .md\\:focus-within\\:text-green-900:focus-within {
    --text-opacity: 1;
    color: #014737;
    color: rgba(1, 71, 55, var(--text-opacity));
  }
  .md\\:focus-within\\:text-teal-50:focus-within {
    --text-opacity: 1;
    color: #edfafa;
    color: rgba(237, 250, 250, var(--text-opacity));
  }
  .md\\:focus-within\\:text-teal-100:focus-within {
    --text-opacity: 1;
    color: #d5f5f6;
    color: rgba(213, 245, 246, var(--text-opacity));
  }
  .md\\:focus-within\\:text-teal-200:focus-within {
    --text-opacity: 1;
    color: #afecef;
    color: rgba(175, 236, 239, var(--text-opacity));
  }
  .md\\:focus-within\\:text-teal-300:focus-within {
    --text-opacity: 1;
    color: #7edce2;
    color: rgba(126, 220, 226, var(--text-opacity));
  }
  .md\\:focus-within\\:text-teal-400:focus-within {
    --text-opacity: 1;
    color: #16bdca;
    color: rgba(22, 189, 202, var(--text-opacity));
  }
  .md\\:focus-within\\:text-teal-500:focus-within {
    --text-opacity: 1;
    color: #0694a2;
    color: rgba(6, 148, 162, var(--text-opacity));
  }
  .md\\:focus-within\\:text-teal-600:focus-within {
    --text-opacity: 1;
    color: #047481;
    color: rgba(4, 116, 129, var(--text-opacity));
  }
  .md\\:focus-within\\:text-teal-700:focus-within {
    --text-opacity: 1;
    color: #036672;
    color: rgba(3, 102, 114, var(--text-opacity));
  }
  .md\\:focus-within\\:text-teal-800:focus-within {
    --text-opacity: 1;
    color: #05505c;
    color: rgba(5, 80, 92, var(--text-opacity));
  }
  .md\\:focus-within\\:text-teal-900:focus-within {
    --text-opacity: 1;
    color: #014451;
    color: rgba(1, 68, 81, var(--text-opacity));
  }
  .md\\:focus-within\\:text-blue-50:focus-within {
    --text-opacity: 1;
    color: #ebf5ff;
    color: rgba(235, 245, 255, var(--text-opacity));
  }
  .md\\:focus-within\\:text-blue-100:focus-within {
    --text-opacity: 1;
    color: #e1effe;
    color: rgba(225, 239, 254, var(--text-opacity));
  }
  .md\\:focus-within\\:text-blue-200:focus-within {
    --text-opacity: 1;
    color: #c3ddfd;
    color: rgba(195, 221, 253, var(--text-opacity));
  }
  .md\\:focus-within\\:text-blue-300:focus-within {
    --text-opacity: 1;
    color: #a4cafe;
    color: rgba(164, 202, 254, var(--text-opacity));
  }
  .md\\:focus-within\\:text-blue-400:focus-within {
    --text-opacity: 1;
    color: #76a9fa;
    color: rgba(118, 169, 250, var(--text-opacity));
  }
  .md\\:focus-within\\:text-blue-500:focus-within {
    --text-opacity: 1;
    color: #3f83f8;
    color: rgba(63, 131, 248, var(--text-opacity));
  }
  .md\\:focus-within\\:text-blue-600:focus-within {
    --text-opacity: 1;
    color: #1c64f2;
    color: rgba(28, 100, 242, var(--text-opacity));
  }
  .md\\:focus-within\\:text-blue-700:focus-within {
    --text-opacity: 1;
    color: #1a56db;
    color: rgba(26, 86, 219, var(--text-opacity));
  }
  .md\\:focus-within\\:text-blue-800:focus-within {
    --text-opacity: 1;
    color: #1e429f;
    color: rgba(30, 66, 159, var(--text-opacity));
  }
  .md\\:focus-within\\:text-blue-900:focus-within {
    --text-opacity: 1;
    color: #233876;
    color: rgba(35, 56, 118, var(--text-opacity));
  }
  .md\\:focus-within\\:text-indigo-50:focus-within {
    --text-opacity: 1;
    color: #f0f5ff;
    color: rgba(240, 245, 255, var(--text-opacity));
  }
  .md\\:focus-within\\:text-indigo-100:focus-within {
    --text-opacity: 1;
    color: #e5edff;
    color: rgba(229, 237, 255, var(--text-opacity));
  }
  .md\\:focus-within\\:text-indigo-200:focus-within {
    --text-opacity: 1;
    color: #cddbfe;
    color: rgba(205, 219, 254, var(--text-opacity));
  }
  .md\\:focus-within\\:text-indigo-300:focus-within {
    --text-opacity: 1;
    color: #b4c6fc;
    color: rgba(180, 198, 252, var(--text-opacity));
  }
  .md\\:focus-within\\:text-indigo-400:focus-within {
    --text-opacity: 1;
    color: #8da2fb;
    color: rgba(141, 162, 251, var(--text-opacity));
  }
  .md\\:focus-within\\:text-indigo-500:focus-within {
    --text-opacity: 1;
    color: #6875f5;
    color: rgba(104, 117, 245, var(--text-opacity));
  }
  .md\\:focus-within\\:text-indigo-600:focus-within {
    --text-opacity: 1;
    color: #5850ec;
    color: rgba(88, 80, 236, var(--text-opacity));
  }
  .md\\:focus-within\\:text-indigo-700:focus-within {
    --text-opacity: 1;
    color: #5145cd;
    color: rgba(81, 69, 205, var(--text-opacity));
  }
  .md\\:focus-within\\:text-indigo-800:focus-within {
    --text-opacity: 1;
    color: #42389d;
    color: rgba(66, 56, 157, var(--text-opacity));
  }
  .md\\:focus-within\\:text-indigo-900:focus-within {
    --text-opacity: 1;
    color: #362f78;
    color: rgba(54, 47, 120, var(--text-opacity));
  }
  .md\\:focus-within\\:text-purple-50:focus-within {
    --text-opacity: 1;
    color: #f6f5ff;
    color: rgba(246, 245, 255, var(--text-opacity));
  }
  .md\\:focus-within\\:text-purple-100:focus-within {
    --text-opacity: 1;
    color: #edebfe;
    color: rgba(237, 235, 254, var(--text-opacity));
  }
  .md\\:focus-within\\:text-purple-200:focus-within {
    --text-opacity: 1;
    color: #dcd7fe;
    color: rgba(220, 215, 254, var(--text-opacity));
  }
  .md\\:focus-within\\:text-purple-300:focus-within {
    --text-opacity: 1;
    color: #cabffd;
    color: rgba(202, 191, 253, var(--text-opacity));
  }
  .md\\:focus-within\\:text-purple-400:focus-within {
    --text-opacity: 1;
    color: #ac94fa;
    color: rgba(172, 148, 250, var(--text-opacity));
  }
  .md\\:focus-within\\:text-purple-500:focus-within {
    --text-opacity: 1;
    color: #9061f9;
    color: rgba(144, 97, 249, var(--text-opacity));
  }
  .md\\:focus-within\\:text-purple-600:focus-within {
    --text-opacity: 1;
    color: #7e3af2;
    color: rgba(126, 58, 242, var(--text-opacity));
  }
  .md\\:focus-within\\:text-purple-700:focus-within {
    --text-opacity: 1;
    color: #6c2bd9;
    color: rgba(108, 43, 217, var(--text-opacity));
  }
  .md\\:focus-within\\:text-purple-800:focus-within {
    --text-opacity: 1;
    color: #5521b5;
    color: rgba(85, 33, 181, var(--text-opacity));
  }
  .md\\:focus-within\\:text-purple-900:focus-within {
    --text-opacity: 1;
    color: #4a1d96;
    color: rgba(74, 29, 150, var(--text-opacity));
  }
  .md\\:focus-within\\:text-pink-50:focus-within {
    --text-opacity: 1;
    color: #fdf2f8;
    color: rgba(253, 242, 248, var(--text-opacity));
  }
  .md\\:focus-within\\:text-pink-100:focus-within {
    --text-opacity: 1;
    color: #fce8f3;
    color: rgba(252, 232, 243, var(--text-opacity));
  }
  .md\\:focus-within\\:text-pink-200:focus-within {
    --text-opacity: 1;
    color: #fad1e8;
    color: rgba(250, 209, 232, var(--text-opacity));
  }
  .md\\:focus-within\\:text-pink-300:focus-within {
    --text-opacity: 1;
    color: #f8b4d9;
    color: rgba(248, 180, 217, var(--text-opacity));
  }
  .md\\:focus-within\\:text-pink-400:focus-within {
    --text-opacity: 1;
    color: #f17eb8;
    color: rgba(241, 126, 184, var(--text-opacity));
  }
  .md\\:focus-within\\:text-pink-500:focus-within {
    --text-opacity: 1;
    color: #e74694;
    color: rgba(231, 70, 148, var(--text-opacity));
  }
  .md\\:focus-within\\:text-pink-600:focus-within {
    --text-opacity: 1;
    color: #d61f69;
    color: rgba(214, 31, 105, var(--text-opacity));
  }
  .md\\:focus-within\\:text-pink-700:focus-within {
    --text-opacity: 1;
    color: #bf125d;
    color: rgba(191, 18, 93, var(--text-opacity));
  }
  .md\\:focus-within\\:text-pink-800:focus-within {
    --text-opacity: 1;
    color: #99154b;
    color: rgba(153, 21, 75, var(--text-opacity));
  }
  .md\\:focus-within\\:text-pink-900:focus-within {
    --text-opacity: 1;
    color: #751a3d;
    color: rgba(117, 26, 61, var(--text-opacity));
  }
  .md\\:focus-within\\:text-cool-gray-50:focus-within {
    --text-opacity: 1;
    color: #f8fafc;
    color: rgba(248, 250, 252, var(--text-opacity));
  }
  .md\\:focus-within\\:text-cool-gray-100:focus-within {
    --text-opacity: 1;
    color: #f1f5f9;
    color: rgba(241, 245, 249, var(--text-opacity));
  }
  .md\\:focus-within\\:text-cool-gray-200:focus-within {
    --text-opacity: 1;
    color: #e2e8f0;
    color: rgba(226, 232, 240, var(--text-opacity));
  }
  .md\\:focus-within\\:text-cool-gray-300:focus-within {
    --text-opacity: 1;
    color: #cfd8e3;
    color: rgba(207, 216, 227, var(--text-opacity));
  }
  .md\\:focus-within\\:text-cool-gray-400:focus-within {
    --text-opacity: 1;
    color: #97a6ba;
    color: rgba(151, 166, 186, var(--text-opacity));
  }
  .md\\:focus-within\\:text-cool-gray-500:focus-within {
    --text-opacity: 1;
    color: #64748b;
    color: rgba(100, 116, 139, var(--text-opacity));
  }
  .md\\:focus-within\\:text-cool-gray-600:focus-within {
    --text-opacity: 1;
    color: #475569;
    color: rgba(71, 85, 105, var(--text-opacity));
  }
  .md\\:focus-within\\:text-cool-gray-700:focus-within {
    --text-opacity: 1;
    color: #364152;
    color: rgba(54, 65, 82, var(--text-opacity));
  }
  .md\\:focus-within\\:text-cool-gray-800:focus-within {
    --text-opacity: 1;
    color: #27303f;
    color: rgba(39, 48, 63, var(--text-opacity));
  }
  .md\\:focus-within\\:text-cool-gray-900:focus-within {
    --text-opacity: 1;
    color: #1a202e;
    color: rgba(26, 32, 46, var(--text-opacity));
  }
  .md\\:focus\\:text-current:focus {
    color: currentColor;
  }
  .md\\:focus\\:text-transparent:focus {
    color: transparent;
  }
  .md\\:focus\\:text-white:focus {
    --text-opacity: 1;
    color: #ffffff;
    color: rgba(255, 255, 255, var(--text-opacity));
  }
  .md\\:focus\\:text-black:focus {
    --text-opacity: 1;
    color: #000000;
    color: rgba(0, 0, 0, var(--text-opacity));
  }
  .md\\:focus\\:text-gray-50:focus {
    --text-opacity: 1;
    color: #f9fafb;
    color: rgba(249, 250, 251, var(--text-opacity));
  }
  .md\\:focus\\:text-gray-100:focus {
    --text-opacity: 1;
    color: #f4f5f7;
    color: rgba(244, 245, 247, var(--text-opacity));
  }
  .md\\:focus\\:text-gray-200:focus {
    --text-opacity: 1;
    color: #e5e7eb;
    color: rgba(229, 231, 235, var(--text-opacity));
  }
  .md\\:focus\\:text-gray-300:focus {
    --text-opacity: 1;
    color: #d2d6dc;
    color: rgba(210, 214, 220, var(--text-opacity));
  }
  .md\\:focus\\:text-gray-400:focus {
    --text-opacity: 1;
    color: #9fa6b2;
    color: rgba(159, 166, 178, var(--text-opacity));
  }
  .md\\:focus\\:text-gray-500:focus {
    --text-opacity: 1;
    color: #6b7280;
    color: rgba(107, 114, 128, var(--text-opacity));
  }
  .md\\:focus\\:text-gray-600:focus {
    --text-opacity: 1;
    color: #4b5563;
    color: rgba(75, 85, 99, var(--text-opacity));
  }
  .md\\:focus\\:text-gray-700:focus {
    --text-opacity: 1;
    color: #374151;
    color: rgba(55, 65, 81, var(--text-opacity));
  }
  .md\\:focus\\:text-gray-800:focus {
    --text-opacity: 1;
    color: #252f3f;
    color: rgba(37, 47, 63, var(--text-opacity));
  }
  .md\\:focus\\:text-gray-900:focus {
    --text-opacity: 1;
    color: #161e2e;
    color: rgba(22, 30, 46, var(--text-opacity));
  }
  .md\\:focus\\:text-red-50:focus {
    --text-opacity: 1;
    color: #fdf2f2;
    color: rgba(253, 242, 242, var(--text-opacity));
  }
  .md\\:focus\\:text-red-100:focus {
    --text-opacity: 1;
    color: #fde8e8;
    color: rgba(253, 232, 232, var(--text-opacity));
  }
  .md\\:focus\\:text-red-200:focus {
    --text-opacity: 1;
    color: #fbd5d5;
    color: rgba(251, 213, 213, var(--text-opacity));
  }
  .md\\:focus\\:text-red-300:focus {
    --text-opacity: 1;
    color: #f8b4b4;
    color: rgba(248, 180, 180, var(--text-opacity));
  }
  .md\\:focus\\:text-red-400:focus {
    --text-opacity: 1;
    color: #f98080;
    color: rgba(249, 128, 128, var(--text-opacity));
  }
  .md\\:focus\\:text-red-500:focus {
    --text-opacity: 1;
    color: #f05252;
    color: rgba(240, 82, 82, var(--text-opacity));
  }
  .md\\:focus\\:text-red-600:focus {
    --text-opacity: 1;
    color: #e02424;
    color: rgba(224, 36, 36, var(--text-opacity));
  }
  .md\\:focus\\:text-red-700:focus {
    --text-opacity: 1;
    color: #c81e1e;
    color: rgba(200, 30, 30, var(--text-opacity));
  }
  .md\\:focus\\:text-red-800:focus {
    --text-opacity: 1;
    color: #9b1c1c;
    color: rgba(155, 28, 28, var(--text-opacity));
  }
  .md\\:focus\\:text-red-900:focus {
    --text-opacity: 1;
    color: #771d1d;
    color: rgba(119, 29, 29, var(--text-opacity));
  }
  .md\\:focus\\:text-orange-50:focus {
    --text-opacity: 1;
    color: #fff8f1;
    color: rgba(255, 248, 241, var(--text-opacity));
  }
  .md\\:focus\\:text-orange-100:focus {
    --text-opacity: 1;
    color: #feecdc;
    color: rgba(254, 236, 220, var(--text-opacity));
  }
  .md\\:focus\\:text-orange-200:focus {
    --text-opacity: 1;
    color: #fcd9bd;
    color: rgba(252, 217, 189, var(--text-opacity));
  }
  .md\\:focus\\:text-orange-300:focus {
    --text-opacity: 1;
    color: #fdba8c;
    color: rgba(253, 186, 140, var(--text-opacity));
  }
  .md\\:focus\\:text-orange-400:focus {
    --text-opacity: 1;
    color: #ff8a4c;
    color: rgba(255, 138, 76, var(--text-opacity));
  }
  .md\\:focus\\:text-orange-500:focus {
    --text-opacity: 1;
    color: #ff5a1f;
    color: rgba(255, 90, 31, var(--text-opacity));
  }
  .md\\:focus\\:text-orange-600:focus {
    --text-opacity: 1;
    color: #d03801;
    color: rgba(208, 56, 1, var(--text-opacity));
  }
  .md\\:focus\\:text-orange-700:focus {
    --text-opacity: 1;
    color: #b43403;
    color: rgba(180, 52, 3, var(--text-opacity));
  }
  .md\\:focus\\:text-orange-800:focus {
    --text-opacity: 1;
    color: #8a2c0d;
    color: rgba(138, 44, 13, var(--text-opacity));
  }
  .md\\:focus\\:text-orange-900:focus {
    --text-opacity: 1;
    color: #73230d;
    color: rgba(115, 35, 13, var(--text-opacity));
  }
  .md\\:focus\\:text-yellow-50:focus {
    --text-opacity: 1;
    color: #fdfdea;
    color: rgba(253, 253, 234, var(--text-opacity));
  }
  .md\\:focus\\:text-yellow-100:focus {
    --text-opacity: 1;
    color: #fdf6b2;
    color: rgba(253, 246, 178, var(--text-opacity));
  }
  .md\\:focus\\:text-yellow-200:focus {
    --text-opacity: 1;
    color: #fce96a;
    color: rgba(252, 233, 106, var(--text-opacity));
  }
  .md\\:focus\\:text-yellow-300:focus {
    --text-opacity: 1;
    color: #faca15;
    color: rgba(250, 202, 21, var(--text-opacity));
  }
  .md\\:focus\\:text-yellow-400:focus {
    --text-opacity: 1;
    color: #e3a008;
    color: rgba(227, 160, 8, var(--text-opacity));
  }
  .md\\:focus\\:text-yellow-500:focus {
    --text-opacity: 1;
    color: #c27803;
    color: rgba(194, 120, 3, var(--text-opacity));
  }
  .md\\:focus\\:text-yellow-600:focus {
    --text-opacity: 1;
    color: #9f580a;
    color: rgba(159, 88, 10, var(--text-opacity));
  }
  .md\\:focus\\:text-yellow-700:focus {
    --text-opacity: 1;
    color: #8e4b10;
    color: rgba(142, 75, 16, var(--text-opacity));
  }
  .md\\:focus\\:text-yellow-800:focus {
    --text-opacity: 1;
    color: #723b13;
    color: rgba(114, 59, 19, var(--text-opacity));
  }
  .md\\:focus\\:text-yellow-900:focus {
    --text-opacity: 1;
    color: #633112;
    color: rgba(99, 49, 18, var(--text-opacity));
  }
  .md\\:focus\\:text-green-50:focus {
    --text-opacity: 1;
    color: #f3faf7;
    color: rgba(243, 250, 247, var(--text-opacity));
  }
  .md\\:focus\\:text-green-100:focus {
    --text-opacity: 1;
    color: #def7ec;
    color: rgba(222, 247, 236, var(--text-opacity));
  }
  .md\\:focus\\:text-green-200:focus {
    --text-opacity: 1;
    color: #bcf0da;
    color: rgba(188, 240, 218, var(--text-opacity));
  }
  .md\\:focus\\:text-green-300:focus {
    --text-opacity: 1;
    color: #84e1bc;
    color: rgba(132, 225, 188, var(--text-opacity));
  }
  .md\\:focus\\:text-green-400:focus {
    --text-opacity: 1;
    color: #31c48d;
    color: rgba(49, 196, 141, var(--text-opacity));
  }
  .md\\:focus\\:text-green-500:focus {
    --text-opacity: 1;
    color: #0e9f6e;
    color: rgba(14, 159, 110, var(--text-opacity));
  }
  .md\\:focus\\:text-green-600:focus {
    --text-opacity: 1;
    color: #057a55;
    color: rgba(5, 122, 85, var(--text-opacity));
  }
  .md\\:focus\\:text-green-700:focus {
    --text-opacity: 1;
    color: #046c4e;
    color: rgba(4, 108, 78, var(--text-opacity));
  }
  .md\\:focus\\:text-green-800:focus {
    --text-opacity: 1;
    color: #03543f;
    color: rgba(3, 84, 63, var(--text-opacity));
  }
  .md\\:focus\\:text-green-900:focus {
    --text-opacity: 1;
    color: #014737;
    color: rgba(1, 71, 55, var(--text-opacity));
  }
  .md\\:focus\\:text-teal-50:focus {
    --text-opacity: 1;
    color: #edfafa;
    color: rgba(237, 250, 250, var(--text-opacity));
  }
  .md\\:focus\\:text-teal-100:focus {
    --text-opacity: 1;
    color: #d5f5f6;
    color: rgba(213, 245, 246, var(--text-opacity));
  }
  .md\\:focus\\:text-teal-200:focus {
    --text-opacity: 1;
    color: #afecef;
    color: rgba(175, 236, 239, var(--text-opacity));
  }
  .md\\:focus\\:text-teal-300:focus {
    --text-opacity: 1;
    color: #7edce2;
    color: rgba(126, 220, 226, var(--text-opacity));
  }
  .md\\:focus\\:text-teal-400:focus {
    --text-opacity: 1;
    color: #16bdca;
    color: rgba(22, 189, 202, var(--text-opacity));
  }
  .md\\:focus\\:text-teal-500:focus {
    --text-opacity: 1;
    color: #0694a2;
    color: rgba(6, 148, 162, var(--text-opacity));
  }
  .md\\:focus\\:text-teal-600:focus {
    --text-opacity: 1;
    color: #047481;
    color: rgba(4, 116, 129, var(--text-opacity));
  }
  .md\\:focus\\:text-teal-700:focus {
    --text-opacity: 1;
    color: #036672;
    color: rgba(3, 102, 114, var(--text-opacity));
  }
  .md\\:focus\\:text-teal-800:focus {
    --text-opacity: 1;
    color: #05505c;
    color: rgba(5, 80, 92, var(--text-opacity));
  }
  .md\\:focus\\:text-teal-900:focus {
    --text-opacity: 1;
    color: #014451;
    color: rgba(1, 68, 81, var(--text-opacity));
  }
  .md\\:focus\\:text-blue-50:focus {
    --text-opacity: 1;
    color: #ebf5ff;
    color: rgba(235, 245, 255, var(--text-opacity));
  }
  .md\\:focus\\:text-blue-100:focus {
    --text-opacity: 1;
    color: #e1effe;
    color: rgba(225, 239, 254, var(--text-opacity));
  }
  .md\\:focus\\:text-blue-200:focus {
    --text-opacity: 1;
    color: #c3ddfd;
    color: rgba(195, 221, 253, var(--text-opacity));
  }
  .md\\:focus\\:text-blue-300:focus {
    --text-opacity: 1;
    color: #a4cafe;
    color: rgba(164, 202, 254, var(--text-opacity));
  }
  .md\\:focus\\:text-blue-400:focus {
    --text-opacity: 1;
    color: #76a9fa;
    color: rgba(118, 169, 250, var(--text-opacity));
  }
  .md\\:focus\\:text-blue-500:focus {
    --text-opacity: 1;
    color: #3f83f8;
    color: rgba(63, 131, 248, var(--text-opacity));
  }
  .md\\:focus\\:text-blue-600:focus {
    --text-opacity: 1;
    color: #1c64f2;
    color: rgba(28, 100, 242, var(--text-opacity));
  }
  .md\\:focus\\:text-blue-700:focus {
    --text-opacity: 1;
    color: #1a56db;
    color: rgba(26, 86, 219, var(--text-opacity));
  }
  .md\\:focus\\:text-blue-800:focus {
    --text-opacity: 1;
    color: #1e429f;
    color: rgba(30, 66, 159, var(--text-opacity));
  }
  .md\\:focus\\:text-blue-900:focus {
    --text-opacity: 1;
    color: #233876;
    color: rgba(35, 56, 118, var(--text-opacity));
  }
  .md\\:focus\\:text-indigo-50:focus {
    --text-opacity: 1;
    color: #f0f5ff;
    color: rgba(240, 245, 255, var(--text-opacity));
  }
  .md\\:focus\\:text-indigo-100:focus {
    --text-opacity: 1;
    color: #e5edff;
    color: rgba(229, 237, 255, var(--text-opacity));
  }
  .md\\:focus\\:text-indigo-200:focus {
    --text-opacity: 1;
    color: #cddbfe;
    color: rgba(205, 219, 254, var(--text-opacity));
  }
  .md\\:focus\\:text-indigo-300:focus {
    --text-opacity: 1;
    color: #b4c6fc;
    color: rgba(180, 198, 252, var(--text-opacity));
  }
  .md\\:focus\\:text-indigo-400:focus {
    --text-opacity: 1;
    color: #8da2fb;
    color: rgba(141, 162, 251, var(--text-opacity));
  }
  .md\\:focus\\:text-indigo-500:focus {
    --text-opacity: 1;
    color: #6875f5;
    color: rgba(104, 117, 245, var(--text-opacity));
  }
  .md\\:focus\\:text-indigo-600:focus {
    --text-opacity: 1;
    color: #5850ec;
    color: rgba(88, 80, 236, var(--text-opacity));
  }
  .md\\:focus\\:text-indigo-700:focus {
    --text-opacity: 1;
    color: #5145cd;
    color: rgba(81, 69, 205, var(--text-opacity));
  }
  .md\\:focus\\:text-indigo-800:focus {
    --text-opacity: 1;
    color: #42389d;
    color: rgba(66, 56, 157, var(--text-opacity));
  }
  .md\\:focus\\:text-indigo-900:focus {
    --text-opacity: 1;
    color: #362f78;
    color: rgba(54, 47, 120, var(--text-opacity));
  }
  .md\\:focus\\:text-purple-50:focus {
    --text-opacity: 1;
    color: #f6f5ff;
    color: rgba(246, 245, 255, var(--text-opacity));
  }
  .md\\:focus\\:text-purple-100:focus {
    --text-opacity: 1;
    color: #edebfe;
    color: rgba(237, 235, 254, var(--text-opacity));
  }
  .md\\:focus\\:text-purple-200:focus {
    --text-opacity: 1;
    color: #dcd7fe;
    color: rgba(220, 215, 254, var(--text-opacity));
  }
  .md\\:focus\\:text-purple-300:focus {
    --text-opacity: 1;
    color: #cabffd;
    color: rgba(202, 191, 253, var(--text-opacity));
  }
  .md\\:focus\\:text-purple-400:focus {
    --text-opacity: 1;
    color: #ac94fa;
    color: rgba(172, 148, 250, var(--text-opacity));
  }
  .md\\:focus\\:text-purple-500:focus {
    --text-opacity: 1;
    color: #9061f9;
    color: rgba(144, 97, 249, var(--text-opacity));
  }
  .md\\:focus\\:text-purple-600:focus {
    --text-opacity: 1;
    color: #7e3af2;
    color: rgba(126, 58, 242, var(--text-opacity));
  }
  .md\\:focus\\:text-purple-700:focus {
    --text-opacity: 1;
    color: #6c2bd9;
    color: rgba(108, 43, 217, var(--text-opacity));
  }
  .md\\:focus\\:text-purple-800:focus {
    --text-opacity: 1;
    color: #5521b5;
    color: rgba(85, 33, 181, var(--text-opacity));
  }
  .md\\:focus\\:text-purple-900:focus {
    --text-opacity: 1;
    color: #4a1d96;
    color: rgba(74, 29, 150, var(--text-opacity));
  }
  .md\\:focus\\:text-pink-50:focus {
    --text-opacity: 1;
    color: #fdf2f8;
    color: rgba(253, 242, 248, var(--text-opacity));
  }
  .md\\:focus\\:text-pink-100:focus {
    --text-opacity: 1;
    color: #fce8f3;
    color: rgba(252, 232, 243, var(--text-opacity));
  }
  .md\\:focus\\:text-pink-200:focus {
    --text-opacity: 1;
    color: #fad1e8;
    color: rgba(250, 209, 232, var(--text-opacity));
  }
  .md\\:focus\\:text-pink-300:focus {
    --text-opacity: 1;
    color: #f8b4d9;
    color: rgba(248, 180, 217, var(--text-opacity));
  }
  .md\\:focus\\:text-pink-400:focus {
    --text-opacity: 1;
    color: #f17eb8;
    color: rgba(241, 126, 184, var(--text-opacity));
  }
  .md\\:focus\\:text-pink-500:focus {
    --text-opacity: 1;
    color: #e74694;
    color: rgba(231, 70, 148, var(--text-opacity));
  }
  .md\\:focus\\:text-pink-600:focus {
    --text-opacity: 1;
    color: #d61f69;
    color: rgba(214, 31, 105, var(--text-opacity));
  }
  .md\\:focus\\:text-pink-700:focus {
    --text-opacity: 1;
    color: #bf125d;
    color: rgba(191, 18, 93, var(--text-opacity));
  }
  .md\\:focus\\:text-pink-800:focus {
    --text-opacity: 1;
    color: #99154b;
    color: rgba(153, 21, 75, var(--text-opacity));
  }
  .md\\:focus\\:text-pink-900:focus {
    --text-opacity: 1;
    color: #751a3d;
    color: rgba(117, 26, 61, var(--text-opacity));
  }
  .md\\:focus\\:text-cool-gray-50:focus {
    --text-opacity: 1;
    color: #f8fafc;
    color: rgba(248, 250, 252, var(--text-opacity));
  }
  .md\\:focus\\:text-cool-gray-100:focus {
    --text-opacity: 1;
    color: #f1f5f9;
    color: rgba(241, 245, 249, var(--text-opacity));
  }
  .md\\:focus\\:text-cool-gray-200:focus {
    --text-opacity: 1;
    color: #e2e8f0;
    color: rgba(226, 232, 240, var(--text-opacity));
  }
  .md\\:focus\\:text-cool-gray-300:focus {
    --text-opacity: 1;
    color: #cfd8e3;
    color: rgba(207, 216, 227, var(--text-opacity));
  }
  .md\\:focus\\:text-cool-gray-400:focus {
    --text-opacity: 1;
    color: #97a6ba;
    color: rgba(151, 166, 186, var(--text-opacity));
  }
  .md\\:focus\\:text-cool-gray-500:focus {
    --text-opacity: 1;
    color: #64748b;
    color: rgba(100, 116, 139, var(--text-opacity));
  }
  .md\\:focus\\:text-cool-gray-600:focus {
    --text-opacity: 1;
    color: #475569;
    color: rgba(71, 85, 105, var(--text-opacity));
  }
  .md\\:focus\\:text-cool-gray-700:focus {
    --text-opacity: 1;
    color: #364152;
    color: rgba(54, 65, 82, var(--text-opacity));
  }
  .md\\:focus\\:text-cool-gray-800:focus {
    --text-opacity: 1;
    color: #27303f;
    color: rgba(39, 48, 63, var(--text-opacity));
  }
  .md\\:focus\\:text-cool-gray-900:focus {
    --text-opacity: 1;
    color: #1a202e;
    color: rgba(26, 32, 46, var(--text-opacity));
  }
  .md\\:active\\:text-current:active {
    color: currentColor;
  }
  .md\\:active\\:text-transparent:active {
    color: transparent;
  }
  .md\\:active\\:text-white:active {
    --text-opacity: 1;
    color: #ffffff;
    color: rgba(255, 255, 255, var(--text-opacity));
  }
  .md\\:active\\:text-black:active {
    --text-opacity: 1;
    color: #000000;
    color: rgba(0, 0, 0, var(--text-opacity));
  }
  .md\\:active\\:text-gray-50:active {
    --text-opacity: 1;
    color: #f9fafb;
    color: rgba(249, 250, 251, var(--text-opacity));
  }
  .md\\:active\\:text-gray-100:active {
    --text-opacity: 1;
    color: #f4f5f7;
    color: rgba(244, 245, 247, var(--text-opacity));
  }
  .md\\:active\\:text-gray-200:active {
    --text-opacity: 1;
    color: #e5e7eb;
    color: rgba(229, 231, 235, var(--text-opacity));
  }
  .md\\:active\\:text-gray-300:active {
    --text-opacity: 1;
    color: #d2d6dc;
    color: rgba(210, 214, 220, var(--text-opacity));
  }
  .md\\:active\\:text-gray-400:active {
    --text-opacity: 1;
    color: #9fa6b2;
    color: rgba(159, 166, 178, var(--text-opacity));
  }
  .md\\:active\\:text-gray-500:active {
    --text-opacity: 1;
    color: #6b7280;
    color: rgba(107, 114, 128, var(--text-opacity));
  }
  .md\\:active\\:text-gray-600:active {
    --text-opacity: 1;
    color: #4b5563;
    color: rgba(75, 85, 99, var(--text-opacity));
  }
  .md\\:active\\:text-gray-700:active {
    --text-opacity: 1;
    color: #374151;
    color: rgba(55, 65, 81, var(--text-opacity));
  }
  .md\\:active\\:text-gray-800:active {
    --text-opacity: 1;
    color: #252f3f;
    color: rgba(37, 47, 63, var(--text-opacity));
  }
  .md\\:active\\:text-gray-900:active {
    --text-opacity: 1;
    color: #161e2e;
    color: rgba(22, 30, 46, var(--text-opacity));
  }
  .md\\:active\\:text-red-50:active {
    --text-opacity: 1;
    color: #fdf2f2;
    color: rgba(253, 242, 242, var(--text-opacity));
  }
  .md\\:active\\:text-red-100:active {
    --text-opacity: 1;
    color: #fde8e8;
    color: rgba(253, 232, 232, var(--text-opacity));
  }
  .md\\:active\\:text-red-200:active {
    --text-opacity: 1;
    color: #fbd5d5;
    color: rgba(251, 213, 213, var(--text-opacity));
  }
  .md\\:active\\:text-red-300:active {
    --text-opacity: 1;
    color: #f8b4b4;
    color: rgba(248, 180, 180, var(--text-opacity));
  }
  .md\\:active\\:text-red-400:active {
    --text-opacity: 1;
    color: #f98080;
    color: rgba(249, 128, 128, var(--text-opacity));
  }
  .md\\:active\\:text-red-500:active {
    --text-opacity: 1;
    color: #f05252;
    color: rgba(240, 82, 82, var(--text-opacity));
  }
  .md\\:active\\:text-red-600:active {
    --text-opacity: 1;
    color: #e02424;
    color: rgba(224, 36, 36, var(--text-opacity));
  }
  .md\\:active\\:text-red-700:active {
    --text-opacity: 1;
    color: #c81e1e;
    color: rgba(200, 30, 30, var(--text-opacity));
  }
  .md\\:active\\:text-red-800:active {
    --text-opacity: 1;
    color: #9b1c1c;
    color: rgba(155, 28, 28, var(--text-opacity));
  }
  .md\\:active\\:text-red-900:active {
    --text-opacity: 1;
    color: #771d1d;
    color: rgba(119, 29, 29, var(--text-opacity));
  }
  .md\\:active\\:text-orange-50:active {
    --text-opacity: 1;
    color: #fff8f1;
    color: rgba(255, 248, 241, var(--text-opacity));
  }
  .md\\:active\\:text-orange-100:active {
    --text-opacity: 1;
    color: #feecdc;
    color: rgba(254, 236, 220, var(--text-opacity));
  }
  .md\\:active\\:text-orange-200:active {
    --text-opacity: 1;
    color: #fcd9bd;
    color: rgba(252, 217, 189, var(--text-opacity));
  }
  .md\\:active\\:text-orange-300:active {
    --text-opacity: 1;
    color: #fdba8c;
    color: rgba(253, 186, 140, var(--text-opacity));
  }
  .md\\:active\\:text-orange-400:active {
    --text-opacity: 1;
    color: #ff8a4c;
    color: rgba(255, 138, 76, var(--text-opacity));
  }
  .md\\:active\\:text-orange-500:active {
    --text-opacity: 1;
    color: #ff5a1f;
    color: rgba(255, 90, 31, var(--text-opacity));
  }
  .md\\:active\\:text-orange-600:active {
    --text-opacity: 1;
    color: #d03801;
    color: rgba(208, 56, 1, var(--text-opacity));
  }
  .md\\:active\\:text-orange-700:active {
    --text-opacity: 1;
    color: #b43403;
    color: rgba(180, 52, 3, var(--text-opacity));
  }
  .md\\:active\\:text-orange-800:active {
    --text-opacity: 1;
    color: #8a2c0d;
    color: rgba(138, 44, 13, var(--text-opacity));
  }
  .md\\:active\\:text-orange-900:active {
    --text-opacity: 1;
    color: #73230d;
    color: rgba(115, 35, 13, var(--text-opacity));
  }
  .md\\:active\\:text-yellow-50:active {
    --text-opacity: 1;
    color: #fdfdea;
    color: rgba(253, 253, 234, var(--text-opacity));
  }
  .md\\:active\\:text-yellow-100:active {
    --text-opacity: 1;
    color: #fdf6b2;
    color: rgba(253, 246, 178, var(--text-opacity));
  }
  .md\\:active\\:text-yellow-200:active {
    --text-opacity: 1;
    color: #fce96a;
    color: rgba(252, 233, 106, var(--text-opacity));
  }
  .md\\:active\\:text-yellow-300:active {
    --text-opacity: 1;
    color: #faca15;
    color: rgba(250, 202, 21, var(--text-opacity));
  }
  .md\\:active\\:text-yellow-400:active {
    --text-opacity: 1;
    color: #e3a008;
    color: rgba(227, 160, 8, var(--text-opacity));
  }
  .md\\:active\\:text-yellow-500:active {
    --text-opacity: 1;
    color: #c27803;
    color: rgba(194, 120, 3, var(--text-opacity));
  }
  .md\\:active\\:text-yellow-600:active {
    --text-opacity: 1;
    color: #9f580a;
    color: rgba(159, 88, 10, var(--text-opacity));
  }
  .md\\:active\\:text-yellow-700:active {
    --text-opacity: 1;
    color: #8e4b10;
    color: rgba(142, 75, 16, var(--text-opacity));
  }
  .md\\:active\\:text-yellow-800:active {
    --text-opacity: 1;
    color: #723b13;
    color: rgba(114, 59, 19, var(--text-opacity));
  }
  .md\\:active\\:text-yellow-900:active {
    --text-opacity: 1;
    color: #633112;
    color: rgba(99, 49, 18, var(--text-opacity));
  }
  .md\\:active\\:text-green-50:active {
    --text-opacity: 1;
    color: #f3faf7;
    color: rgba(243, 250, 247, var(--text-opacity));
  }
  .md\\:active\\:text-green-100:active {
    --text-opacity: 1;
    color: #def7ec;
    color: rgba(222, 247, 236, var(--text-opacity));
  }
  .md\\:active\\:text-green-200:active {
    --text-opacity: 1;
    color: #bcf0da;
    color: rgba(188, 240, 218, var(--text-opacity));
  }
  .md\\:active\\:text-green-300:active {
    --text-opacity: 1;
    color: #84e1bc;
    color: rgba(132, 225, 188, var(--text-opacity));
  }
  .md\\:active\\:text-green-400:active {
    --text-opacity: 1;
    color: #31c48d;
    color: rgba(49, 196, 141, var(--text-opacity));
  }
  .md\\:active\\:text-green-500:active {
    --text-opacity: 1;
    color: #0e9f6e;
    color: rgba(14, 159, 110, var(--text-opacity));
  }
  .md\\:active\\:text-green-600:active {
    --text-opacity: 1;
    color: #057a55;
    color: rgba(5, 122, 85, var(--text-opacity));
  }
  .md\\:active\\:text-green-700:active {
    --text-opacity: 1;
    color: #046c4e;
    color: rgba(4, 108, 78, var(--text-opacity));
  }
  .md\\:active\\:text-green-800:active {
    --text-opacity: 1;
    color: #03543f;
    color: rgba(3, 84, 63, var(--text-opacity));
  }
  .md\\:active\\:text-green-900:active {
    --text-opacity: 1;
    color: #014737;
    color: rgba(1, 71, 55, var(--text-opacity));
  }
  .md\\:active\\:text-teal-50:active {
    --text-opacity: 1;
    color: #edfafa;
    color: rgba(237, 250, 250, var(--text-opacity));
  }
  .md\\:active\\:text-teal-100:active {
    --text-opacity: 1;
    color: #d5f5f6;
    color: rgba(213, 245, 246, var(--text-opacity));
  }
  .md\\:active\\:text-teal-200:active {
    --text-opacity: 1;
    color: #afecef;
    color: rgba(175, 236, 239, var(--text-opacity));
  }
  .md\\:active\\:text-teal-300:active {
    --text-opacity: 1;
    color: #7edce2;
    color: rgba(126, 220, 226, var(--text-opacity));
  }
  .md\\:active\\:text-teal-400:active {
    --text-opacity: 1;
    color: #16bdca;
    color: rgba(22, 189, 202, var(--text-opacity));
  }
  .md\\:active\\:text-teal-500:active {
    --text-opacity: 1;
    color: #0694a2;
    color: rgba(6, 148, 162, var(--text-opacity));
  }
  .md\\:active\\:text-teal-600:active {
    --text-opacity: 1;
    color: #047481;
    color: rgba(4, 116, 129, var(--text-opacity));
  }
  .md\\:active\\:text-teal-700:active {
    --text-opacity: 1;
    color: #036672;
    color: rgba(3, 102, 114, var(--text-opacity));
  }
  .md\\:active\\:text-teal-800:active {
    --text-opacity: 1;
    color: #05505c;
    color: rgba(5, 80, 92, var(--text-opacity));
  }
  .md\\:active\\:text-teal-900:active {
    --text-opacity: 1;
    color: #014451;
    color: rgba(1, 68, 81, var(--text-opacity));
  }
  .md\\:active\\:text-blue-50:active {
    --text-opacity: 1;
    color: #ebf5ff;
    color: rgba(235, 245, 255, var(--text-opacity));
  }
  .md\\:active\\:text-blue-100:active {
    --text-opacity: 1;
    color: #e1effe;
    color: rgba(225, 239, 254, var(--text-opacity));
  }
  .md\\:active\\:text-blue-200:active {
    --text-opacity: 1;
    color: #c3ddfd;
    color: rgba(195, 221, 253, var(--text-opacity));
  }
  .md\\:active\\:text-blue-300:active {
    --text-opacity: 1;
    color: #a4cafe;
    color: rgba(164, 202, 254, var(--text-opacity));
  }
  .md\\:active\\:text-blue-400:active {
    --text-opacity: 1;
    color: #76a9fa;
    color: rgba(118, 169, 250, var(--text-opacity));
  }
  .md\\:active\\:text-blue-500:active {
    --text-opacity: 1;
    color: #3f83f8;
    color: rgba(63, 131, 248, var(--text-opacity));
  }
  .md\\:active\\:text-blue-600:active {
    --text-opacity: 1;
    color: #1c64f2;
    color: rgba(28, 100, 242, var(--text-opacity));
  }
  .md\\:active\\:text-blue-700:active {
    --text-opacity: 1;
    color: #1a56db;
    color: rgba(26, 86, 219, var(--text-opacity));
  }
  .md\\:active\\:text-blue-800:active {
    --text-opacity: 1;
    color: #1e429f;
    color: rgba(30, 66, 159, var(--text-opacity));
  }
  .md\\:active\\:text-blue-900:active {
    --text-opacity: 1;
    color: #233876;
    color: rgba(35, 56, 118, var(--text-opacity));
  }
  .md\\:active\\:text-indigo-50:active {
    --text-opacity: 1;
    color: #f0f5ff;
    color: rgba(240, 245, 255, var(--text-opacity));
  }
  .md\\:active\\:text-indigo-100:active {
    --text-opacity: 1;
    color: #e5edff;
    color: rgba(229, 237, 255, var(--text-opacity));
  }
  .md\\:active\\:text-indigo-200:active {
    --text-opacity: 1;
    color: #cddbfe;
    color: rgba(205, 219, 254, var(--text-opacity));
  }
  .md\\:active\\:text-indigo-300:active {
    --text-opacity: 1;
    color: #b4c6fc;
    color: rgba(180, 198, 252, var(--text-opacity));
  }
  .md\\:active\\:text-indigo-400:active {
    --text-opacity: 1;
    color: #8da2fb;
    color: rgba(141, 162, 251, var(--text-opacity));
  }
  .md\\:active\\:text-indigo-500:active {
    --text-opacity: 1;
    color: #6875f5;
    color: rgba(104, 117, 245, var(--text-opacity));
  }
  .md\\:active\\:text-indigo-600:active {
    --text-opacity: 1;
    color: #5850ec;
    color: rgba(88, 80, 236, var(--text-opacity));
  }
  .md\\:active\\:text-indigo-700:active {
    --text-opacity: 1;
    color: #5145cd;
    color: rgba(81, 69, 205, var(--text-opacity));
  }
  .md\\:active\\:text-indigo-800:active {
    --text-opacity: 1;
    color: #42389d;
    color: rgba(66, 56, 157, var(--text-opacity));
  }
  .md\\:active\\:text-indigo-900:active {
    --text-opacity: 1;
    color: #362f78;
    color: rgba(54, 47, 120, var(--text-opacity));
  }
  .md\\:active\\:text-purple-50:active {
    --text-opacity: 1;
    color: #f6f5ff;
    color: rgba(246, 245, 255, var(--text-opacity));
  }
  .md\\:active\\:text-purple-100:active {
    --text-opacity: 1;
    color: #edebfe;
    color: rgba(237, 235, 254, var(--text-opacity));
  }
  .md\\:active\\:text-purple-200:active {
    --text-opacity: 1;
    color: #dcd7fe;
    color: rgba(220, 215, 254, var(--text-opacity));
  }
  .md\\:active\\:text-purple-300:active {
    --text-opacity: 1;
    color: #cabffd;
    color: rgba(202, 191, 253, var(--text-opacity));
  }
  .md\\:active\\:text-purple-400:active {
    --text-opacity: 1;
    color: #ac94fa;
    color: rgba(172, 148, 250, var(--text-opacity));
  }
  .md\\:active\\:text-purple-500:active {
    --text-opacity: 1;
    color: #9061f9;
    color: rgba(144, 97, 249, var(--text-opacity));
  }
  .md\\:active\\:text-purple-600:active {
    --text-opacity: 1;
    color: #7e3af2;
    color: rgba(126, 58, 242, var(--text-opacity));
  }
  .md\\:active\\:text-purple-700:active {
    --text-opacity: 1;
    color: #6c2bd9;
    color: rgba(108, 43, 217, var(--text-opacity));
  }
  .md\\:active\\:text-purple-800:active {
    --text-opacity: 1;
    color: #5521b5;
    color: rgba(85, 33, 181, var(--text-opacity));
  }
  .md\\:active\\:text-purple-900:active {
    --text-opacity: 1;
    color: #4a1d96;
    color: rgba(74, 29, 150, var(--text-opacity));
  }
  .md\\:active\\:text-pink-50:active {
    --text-opacity: 1;
    color: #fdf2f8;
    color: rgba(253, 242, 248, var(--text-opacity));
  }
  .md\\:active\\:text-pink-100:active {
    --text-opacity: 1;
    color: #fce8f3;
    color: rgba(252, 232, 243, var(--text-opacity));
  }
  .md\\:active\\:text-pink-200:active {
    --text-opacity: 1;
    color: #fad1e8;
    color: rgba(250, 209, 232, var(--text-opacity));
  }
  .md\\:active\\:text-pink-300:active {
    --text-opacity: 1;
    color: #f8b4d9;
    color: rgba(248, 180, 217, var(--text-opacity));
  }
  .md\\:active\\:text-pink-400:active {
    --text-opacity: 1;
    color: #f17eb8;
    color: rgba(241, 126, 184, var(--text-opacity));
  }
  .md\\:active\\:text-pink-500:active {
    --text-opacity: 1;
    color: #e74694;
    color: rgba(231, 70, 148, var(--text-opacity));
  }
  .md\\:active\\:text-pink-600:active {
    --text-opacity: 1;
    color: #d61f69;
    color: rgba(214, 31, 105, var(--text-opacity));
  }
  .md\\:active\\:text-pink-700:active {
    --text-opacity: 1;
    color: #bf125d;
    color: rgba(191, 18, 93, var(--text-opacity));
  }
  .md\\:active\\:text-pink-800:active {
    --text-opacity: 1;
    color: #99154b;
    color: rgba(153, 21, 75, var(--text-opacity));
  }
  .md\\:active\\:text-pink-900:active {
    --text-opacity: 1;
    color: #751a3d;
    color: rgba(117, 26, 61, var(--text-opacity));
  }
  .md\\:active\\:text-cool-gray-50:active {
    --text-opacity: 1;
    color: #f8fafc;
    color: rgba(248, 250, 252, var(--text-opacity));
  }
  .md\\:active\\:text-cool-gray-100:active {
    --text-opacity: 1;
    color: #f1f5f9;
    color: rgba(241, 245, 249, var(--text-opacity));
  }
  .md\\:active\\:text-cool-gray-200:active {
    --text-opacity: 1;
    color: #e2e8f0;
    color: rgba(226, 232, 240, var(--text-opacity));
  }
  .md\\:active\\:text-cool-gray-300:active {
    --text-opacity: 1;
    color: #cfd8e3;
    color: rgba(207, 216, 227, var(--text-opacity));
  }
  .md\\:active\\:text-cool-gray-400:active {
    --text-opacity: 1;
    color: #97a6ba;
    color: rgba(151, 166, 186, var(--text-opacity));
  }
  .md\\:active\\:text-cool-gray-500:active {
    --text-opacity: 1;
    color: #64748b;
    color: rgba(100, 116, 139, var(--text-opacity));
  }
  .md\\:active\\:text-cool-gray-600:active {
    --text-opacity: 1;
    color: #475569;
    color: rgba(71, 85, 105, var(--text-opacity));
  }
  .md\\:active\\:text-cool-gray-700:active {
    --text-opacity: 1;
    color: #364152;
    color: rgba(54, 65, 82, var(--text-opacity));
  }
  .md\\:active\\:text-cool-gray-800:active {
    --text-opacity: 1;
    color: #27303f;
    color: rgba(39, 48, 63, var(--text-opacity));
  }
  .md\\:active\\:text-cool-gray-900:active {
    --text-opacity: 1;
    color: #1a202e;
    color: rgba(26, 32, 46, var(--text-opacity));
  }
  .md\\:text-opacity-0 {
    --text-opacity: 0;
  }
  .md\\:text-opacity-25 {
    --text-opacity: 0.25;
  }
  .md\\:text-opacity-50 {
    --text-opacity: 0.5;
  }
  .md\\:text-opacity-75 {
    --text-opacity: 0.75;
  }
  .md\\:text-opacity-100 {
    --text-opacity: 1;
  }
  .md\\:hover\\:text-opacity-0:hover {
    --text-opacity: 0;
  }
  .md\\:hover\\:text-opacity-25:hover {
    --text-opacity: 0.25;
  }
  .md\\:hover\\:text-opacity-50:hover {
    --text-opacity: 0.5;
  }
  .md\\:hover\\:text-opacity-75:hover {
    --text-opacity: 0.75;
  }
  .md\\:hover\\:text-opacity-100:hover {
    --text-opacity: 1;
  }
  .md\\:focus\\:text-opacity-0:focus {
    --text-opacity: 0;
  }
  .md\\:focus\\:text-opacity-25:focus {
    --text-opacity: 0.25;
  }
  .md\\:focus\\:text-opacity-50:focus {
    --text-opacity: 0.5;
  }
  .md\\:focus\\:text-opacity-75:focus {
    --text-opacity: 0.75;
  }
  .md\\:focus\\:text-opacity-100:focus {
    --text-opacity: 1;
  }
  .md\\:italic {
    font-style: italic;
  }
  .md\\:not-italic {
    font-style: normal;
  }
  .md\\:uppercase {
    text-transform: uppercase;
  }
  .md\\:lowercase {
    text-transform: lowercase;
  }
  .md\\:capitalize {
    text-transform: capitalize;
  }
  .md\\:normal-case {
    text-transform: none;
  }
  .md\\:underline {
    text-decoration: none;
  }
  .md\\:line-through {
    text-decoration: line-through;
  }
  .md\\:no-underline {
    text-decoration: none;
  }
  .group:hover .md\\:group-hover\\:underline {
    text-decoration: none;
  }
  .group:hover .md\\:group-hover\\:line-through {
    text-decoration: line-through;
  }
  .group:hover .md\\:group-hover\\:no-underline {
    text-decoration: none;
  }
  .group:focus .md\\:group-focus\\:underline {
    text-decoration: none;
  }
  .group:focus .md\\:group-focus\\:line-through {
    text-decoration: line-through;
  }
  .group:focus .md\\:group-focus\\:no-underline {
    text-decoration: none;
  }
  .md\\:hover\\:underline:hover {
    text-decoration: none;
  }
  .md\\:hover\\:line-through:hover {
    text-decoration: line-through;
  }
  .md\\:hover\\:no-underline:hover {
    text-decoration: none;
  }
  .md\\:focus\\:underline:focus {
    text-decoration: none;
  }
  .md\\:focus\\:line-through:focus {
    text-decoration: line-through;
  }
  .md\\:focus\\:no-underline:focus {
    text-decoration: none;
  }
  .md\\:antialiased {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
  .md\\:subpixel-antialiased {
    -webkit-font-smoothing: auto;
    -moz-osx-font-smoothing: auto;
  }
  .md\\:ordinal, .md\\:slashed-zero, .md\\:lining-nums, .md\\:oldstyle-nums, .md\\:proportional-nums, .md\\:tabular-nums, .md\\:diagonal-fractions, .md\\:stacked-fractions {
    --font-variant-numeric-ordinal: var(--tailwind-empty,
        /*!*/
        /*!*/
      );
    --font-variant-numeric-slashed-zero: var(--tailwind-empty,
        /*!*/
        /*!*/
      );
    --font-variant-numeric-figure: var(--tailwind-empty,
        /*!*/
        /*!*/
      );
    --font-variant-numeric-spacing: var(--tailwind-empty,
        /*!*/
        /*!*/
      );
    --font-variant-numeric-fraction: var(--tailwind-empty,
        /*!*/
        /*!*/
      );
    font-variant-numeric: var(--font-variant-numeric-ordinal) var(--font-variant-numeric-slashed-zero) var(--font-variant-numeric-figure) var(--font-variant-numeric-spacing) var(--font-variant-numeric-fraction);
  }
  .md\\:normal-nums {
    font-variant-numeric: normal;
  }
  .md\\:ordinal {
    --font-variant-numeric-ordinal: ordinal;
  }
  .md\\:slashed-zero {
    --font-variant-numeric-slashed-zero: slashed-zero;
  }
  .md\\:lining-nums {
    --font-variant-numeric-figure: lining-nums;
  }
  .md\\:oldstyle-nums {
    --font-variant-numeric-figure: oldstyle-nums;
  }
  .md\\:proportional-nums {
    --font-variant-numeric-spacing: proportional-nums;
  }
  .md\\:tabular-nums {
    --font-variant-numeric-spacing: tabular-nums;
  }
  .md\\:diagonal-fractions {
    --font-variant-numeric-fraction: diagonal-fractions;
  }
  .md\\:stacked-fractions {
    --font-variant-numeric-fraction: stacked-fractions;
  }
  .md\\:tracking-tighter {
    letter-spacing: -0.05em;
  }
  .md\\:tracking-tight {
    letter-spacing: -0.025em;
  }
  .md\\:tracking-normal {
    letter-spacing: 0;
  }
  .md\\:tracking-wide {
    letter-spacing: 0.025em;
  }
  .md\\:tracking-wider {
    letter-spacing: 0.05em;
  }
  .md\\:tracking-widest {
    letter-spacing: 0.1em;
  }
  .md\\:select-none {
    -webkit-user-select: none;
    user-select: none;
  }
  .md\\:select-text {
    -webkit-user-select: text;
    user-select: text;
  }
  .md\\:select-all {
    -webkit-user-select: all;
    user-select: all;
  }
  .md\\:select-auto {
    -webkit-user-select: auto;
    user-select: auto;
  }
  .md\\:align-baseline {
    vertical-align: baseline;
  }
  .md\\:align-top {
    vertical-align: top;
  }
  .md\\:align-middle {
    vertical-align: middle;
  }
  .md\\:align-bottom {
    vertical-align: bottom;
  }
  .md\\:align-text-top {
    vertical-align: text-top;
  }
  .md\\:align-text-bottom {
    vertical-align: text-bottom;
  }
  .md\\:visible {
    visibility: visible;
  }
  .md\\:invisible {
    visibility: hidden;
  }
  .md\\:whitespace-normal {
    white-space: normal;
  }
  .md\\:whitespace-no-wrap {
    white-space: nowrap;
  }
  .md\\:whitespace-pre {
    white-space: pre;
  }
  .md\\:whitespace-pre-line {
    white-space: pre-line;
  }
  .md\\:whitespace-pre-wrap {
    white-space: pre-wrap;
  }
  .md\\:break-normal {
    word-wrap: normal;
    overflow-wrap: normal;
    word-break: normal;
  }
  .md\\:break-words {
    word-wrap: break-word;
    overflow-wrap: break-word;
  }
  .md\\:break-all {
    word-break: break-all;
  }
  .md\\:truncate {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .md\\:w-0 {
    width: 0;
  }
  .md\\:w-1 {
    width: 0.25rem;
  }
  .md\\:w-2 {
    width: 0.5rem;
  }
  .md\\:w-3 {
    width: 0.75rem;
  }
  .md\\:w-4 {
    width: 1rem;
  }
  .md\\:w-5 {
    width: 1.25rem;
  }
  .md\\:w-6 {
    width: 1.5rem;
  }
  .md\\:w-7 {
    width: 1.75rem;
  }
  .md\\:w-8 {
    width: 2rem;
  }
  .md\\:w-9 {
    width: 2.25rem;
  }
  .md\\:w-10 {
    width: 2.5rem;
  }
  .md\\:w-11 {
    width: 2.75rem;
  }
  .md\\:w-12 {
    width: 3rem;
  }
  .md\\:w-13 {
    width: 3.25rem;
  }
  .md\\:w-14 {
    width: 3.5rem;
  }
  .md\\:w-15 {
    width: 3.75rem;
  }
  .md\\:w-16 {
    width: 4rem;
  }
  .md\\:w-20 {
    width: 5rem;
  }
  .md\\:w-24 {
    width: 6rem;
  }
  .md\\:w-28 {
    width: 7rem;
  }
  .md\\:w-32 {
    width: 8rem;
  }
  .md\\:w-36 {
    width: 9rem;
  }
  .md\\:w-40 {
    width: 10rem;
  }
  .md\\:w-44 {
    width: 11rem;
  }
  .md\\:w-48 {
    width: 12rem;
  }
  .md\\:w-52 {
    width: 13rem;
  }
  .md\\:w-56 {
    width: 14rem;
  }
  .md\\:w-60 {
    width: 15rem;
  }
  .md\\:w-64 {
    width: 16rem;
  }
  .md\\:w-72 {
    width: 18rem;
  }
  .md\\:w-80 {
    width: 20rem;
  }
  .md\\:w-96 {
    width: 24rem;
  }
  .md\\:w-auto {
    width: auto;
  }
  .md\\:w-px {
    width: 1px;
  }
  .md\\:w-0\\.5 {
    width: 0.125rem;
  }
  .md\\:w-1\\.5 {
    width: 0.375rem;
  }
  .md\\:w-2\\.5 {
    width: 0.625rem;
  }
  .md\\:w-3\\.5 {
    width: 0.875rem;
  }
  .md\\:w-1\\/2 {
    width: 50%;
  }
  .md\\:w-1\\/3 {
    width: 33.333333%;
  }
  .md\\:w-2\\/3 {
    width: 66.666667%;
  }
  .md\\:w-1\\/4 {
    width: 25%;
  }
  .md\\:w-2\\/4 {
    width: 50%;
  }
  .md\\:w-3\\/4 {
    width: 75%;
  }
  .md\\:w-1\\/5 {
    width: 20%;
  }
  .md\\:w-2\\/5 {
    width: 40%;
  }
  .md\\:w-3\\/5 {
    width: 60%;
  }
  .md\\:w-4\\/5 {
    width: 80%;
  }
  .md\\:w-1\\/6 {
    width: 16.666667%;
  }
  .md\\:w-2\\/6 {
    width: 33.333333%;
  }
  .md\\:w-3\\/6 {
    width: 50%;
  }
  .md\\:w-4\\/6 {
    width: 66.666667%;
  }
  .md\\:w-5\\/6 {
    width: 83.333333%;
  }
  .md\\:w-1\\/12 {
    width: 8.333333%;
  }
  .md\\:w-2\\/12 {
    width: 16.666667%;
  }
  .md\\:w-3\\/12 {
    width: 25%;
  }
  .md\\:w-4\\/12 {
    width: 33.333333%;
  }
  .md\\:w-5\\/12 {
    width: 41.666667%;
  }
  .md\\:w-6\\/12 {
    width: 50%;
  }
  .md\\:w-7\\/12 {
    width: 58.333333%;
  }
  .md\\:w-8\\/12 {
    width: 66.666667%;
  }
  .md\\:w-9\\/12 {
    width: 75%;
  }
  .md\\:w-10\\/12 {
    width: 83.333333%;
  }
  .md\\:w-11\\/12 {
    width: 91.666667%;
  }
  .md\\:w-full {
    width: 100%;
  }
  .md\\:w-screen {
    width: 100vw;
  }
  .md\\:w-min-content {
    width: min-content;
  }
  .md\\:w-max-content {
    width: max-content;
  }
  .md\\:z-0 {
    z-index: 0;
  }
  .md\\:z-10 {
    z-index: 10;
  }
  .md\\:z-20 {
    z-index: 20;
  }
  .md\\:z-30 {
    z-index: 30;
  }
  .md\\:z-40 {
    z-index: 40;
  }
  .md\\:z-50 {
    z-index: 50;
  }
  .md\\:z-auto {
    z-index: auto;
  }
  .md\\:focus-within\\:z-0:focus-within {
    z-index: 0;
  }
  .md\\:focus-within\\:z-10:focus-within {
    z-index: 10;
  }
  .md\\:focus-within\\:z-20:focus-within {
    z-index: 20;
  }
  .md\\:focus-within\\:z-30:focus-within {
    z-index: 30;
  }
  .md\\:focus-within\\:z-40:focus-within {
    z-index: 40;
  }
  .md\\:focus-within\\:z-50:focus-within {
    z-index: 50;
  }
  .md\\:focus-within\\:z-auto:focus-within {
    z-index: auto;
  }
  .md\\:focus\\:z-0:focus {
    z-index: 0;
  }
  .md\\:focus\\:z-10:focus {
    z-index: 10;
  }
  .md\\:focus\\:z-20:focus {
    z-index: 20;
  }
  .md\\:focus\\:z-30:focus {
    z-index: 30;
  }
  .md\\:focus\\:z-40:focus {
    z-index: 40;
  }
  .md\\:focus\\:z-50:focus {
    z-index: 50;
  }
  .md\\:focus\\:z-auto:focus {
    z-index: auto;
  }
  .md\\:gap-0 {
    grid-gap: 0;
    gap: 0;
  }
  .md\\:gap-1 {
    grid-gap: 0.25rem;
    gap: 0.25rem;
  }
  .md\\:gap-2 {
    grid-gap: 0.5rem;
    gap: 0.5rem;
  }
  .md\\:gap-3 {
    grid-gap: 0.75rem;
    gap: 0.75rem;
  }
  .md\\:gap-4 {
    grid-gap: 1rem;
    gap: 1rem;
  }
  .md\\:gap-5 {
    grid-gap: 1.25rem;
    gap: 1.25rem;
  }
  .md\\:gap-6 {
    grid-gap: 1.5rem;
    gap: 1.5rem;
  }
  .md\\:gap-7 {
    grid-gap: 1.75rem;
    gap: 1.75rem;
  }
  .md\\:gap-8 {
    grid-gap: 2rem;
    gap: 2rem;
  }
  .md\\:gap-9 {
    grid-gap: 2.25rem;
    gap: 2.25rem;
  }
  .md\\:gap-10 {
    grid-gap: 2.5rem;
    gap: 2.5rem;
  }
  .md\\:gap-11 {
    grid-gap: 2.75rem;
    gap: 2.75rem;
  }
  .md\\:gap-12 {
    grid-gap: 3rem;
    gap: 3rem;
  }
  .md\\:gap-13 {
    grid-gap: 3.25rem;
    gap: 3.25rem;
  }
  .md\\:gap-14 {
    grid-gap: 3.5rem;
    gap: 3.5rem;
  }
  .md\\:gap-15 {
    grid-gap: 3.75rem;
    gap: 3.75rem;
  }
  .md\\:gap-16 {
    grid-gap: 4rem;
    gap: 4rem;
  }
  .md\\:gap-20 {
    grid-gap: 5rem;
    gap: 5rem;
  }
  .md\\:gap-24 {
    grid-gap: 6rem;
    gap: 6rem;
  }
  .md\\:gap-28 {
    grid-gap: 7rem;
    gap: 7rem;
  }
  .md\\:gap-32 {
    grid-gap: 8rem;
    gap: 8rem;
  }
  .md\\:gap-36 {
    grid-gap: 9rem;
    gap: 9rem;
  }
  .md\\:gap-40 {
    grid-gap: 10rem;
    gap: 10rem;
  }
  .md\\:gap-44 {
    grid-gap: 11rem;
    gap: 11rem;
  }
  .md\\:gap-48 {
    grid-gap: 12rem;
    gap: 12rem;
  }
  .md\\:gap-52 {
    grid-gap: 13rem;
    gap: 13rem;
  }
  .md\\:gap-56 {
    grid-gap: 14rem;
    gap: 14rem;
  }
  .md\\:gap-60 {
    grid-gap: 15rem;
    gap: 15rem;
  }
  .md\\:gap-64 {
    grid-gap: 16rem;
    gap: 16rem;
  }
  .md\\:gap-72 {
    grid-gap: 18rem;
    gap: 18rem;
  }
  .md\\:gap-80 {
    grid-gap: 20rem;
    gap: 20rem;
  }
  .md\\:gap-96 {
    grid-gap: 24rem;
    gap: 24rem;
  }
  .md\\:gap-px {
    grid-gap: 1px;
    gap: 1px;
  }
  .md\\:gap-0\\.5 {
    grid-gap: 0.125rem;
    gap: 0.125rem;
  }
  .md\\:gap-1\\.5 {
    grid-gap: 0.375rem;
    gap: 0.375rem;
  }
  .md\\:gap-2\\.5 {
    grid-gap: 0.625rem;
    gap: 0.625rem;
  }
  .md\\:gap-3\\.5 {
    grid-gap: 0.875rem;
    gap: 0.875rem;
  }
  .md\\:gap-1\\/2 {
    grid-gap: 50%;
    gap: 50%;
  }
  .md\\:gap-1\\/3 {
    grid-gap: 33.333333%;
    gap: 33.333333%;
  }
  .md\\:gap-2\\/3 {
    grid-gap: 66.666667%;
    gap: 66.666667%;
  }
  .md\\:gap-1\\/4 {
    grid-gap: 25%;
    gap: 25%;
  }
  .md\\:gap-2\\/4 {
    grid-gap: 50%;
    gap: 50%;
  }
  .md\\:gap-3\\/4 {
    grid-gap: 75%;
    gap: 75%;
  }
  .md\\:gap-1\\/5 {
    grid-gap: 20%;
    gap: 20%;
  }
  .md\\:gap-2\\/5 {
    grid-gap: 40%;
    gap: 40%;
  }
  .md\\:gap-3\\/5 {
    grid-gap: 60%;
    gap: 60%;
  }
  .md\\:gap-4\\/5 {
    grid-gap: 80%;
    gap: 80%;
  }
  .md\\:gap-1\\/6 {
    grid-gap: 16.666667%;
    gap: 16.666667%;
  }
  .md\\:gap-2\\/6 {
    grid-gap: 33.333333%;
    gap: 33.333333%;
  }
  .md\\:gap-3\\/6 {
    grid-gap: 50%;
    gap: 50%;
  }
  .md\\:gap-4\\/6 {
    grid-gap: 66.666667%;
    gap: 66.666667%;
  }
  .md\\:gap-5\\/6 {
    grid-gap: 83.333333%;
    gap: 83.333333%;
  }
  .md\\:gap-1\\/12 {
    grid-gap: 8.333333%;
    gap: 8.333333%;
  }
  .md\\:gap-2\\/12 {
    grid-gap: 16.666667%;
    gap: 16.666667%;
  }
  .md\\:gap-3\\/12 {
    grid-gap: 25%;
    gap: 25%;
  }
  .md\\:gap-4\\/12 {
    grid-gap: 33.333333%;
    gap: 33.333333%;
  }
  .md\\:gap-5\\/12 {
    grid-gap: 41.666667%;
    gap: 41.666667%;
  }
  .md\\:gap-6\\/12 {
    grid-gap: 50%;
    gap: 50%;
  }
  .md\\:gap-7\\/12 {
    grid-gap: 58.333333%;
    gap: 58.333333%;
  }
  .md\\:gap-8\\/12 {
    grid-gap: 66.666667%;
    gap: 66.666667%;
  }
  .md\\:gap-9\\/12 {
    grid-gap: 75%;
    gap: 75%;
  }
  .md\\:gap-10\\/12 {
    grid-gap: 83.333333%;
    gap: 83.333333%;
  }
  .md\\:gap-11\\/12 {
    grid-gap: 91.666667%;
    gap: 91.666667%;
  }
  .md\\:gap-full {
    grid-gap: 100%;
    gap: 100%;
  }
  .md\\:col-gap-0 {
    grid-column-gap: 0;
    column-gap: 0;
  }
  .md\\:col-gap-1 {
    grid-column-gap: 0.25rem;
    column-gap: 0.25rem;
  }
  .md\\:col-gap-2 {
    grid-column-gap: 0.5rem;
    column-gap: 0.5rem;
  }
  .md\\:col-gap-3 {
    grid-column-gap: 0.75rem;
    column-gap: 0.75rem;
  }
  .md\\:col-gap-4 {
    grid-column-gap: 1rem;
    column-gap: 1rem;
  }
  .md\\:col-gap-5 {
    grid-column-gap: 1.25rem;
    column-gap: 1.25rem;
  }
  .md\\:col-gap-6 {
    grid-column-gap: 1.5rem;
    column-gap: 1.5rem;
  }
  .md\\:col-gap-7 {
    grid-column-gap: 1.75rem;
    column-gap: 1.75rem;
  }
  .md\\:col-gap-8 {
    grid-column-gap: 2rem;
    column-gap: 2rem;
  }
  .md\\:col-gap-9 {
    grid-column-gap: 2.25rem;
    column-gap: 2.25rem;
  }
  .md\\:col-gap-10 {
    grid-column-gap: 2.5rem;
    column-gap: 2.5rem;
  }
  .md\\:col-gap-11 {
    grid-column-gap: 2.75rem;
    column-gap: 2.75rem;
  }
  .md\\:col-gap-12 {
    grid-column-gap: 3rem;
    column-gap: 3rem;
  }
  .md\\:col-gap-13 {
    grid-column-gap: 3.25rem;
    column-gap: 3.25rem;
  }
  .md\\:col-gap-14 {
    grid-column-gap: 3.5rem;
    column-gap: 3.5rem;
  }
  .md\\:col-gap-15 {
    grid-column-gap: 3.75rem;
    column-gap: 3.75rem;
  }
  .md\\:col-gap-16 {
    grid-column-gap: 4rem;
    column-gap: 4rem;
  }
  .md\\:col-gap-20 {
    grid-column-gap: 5rem;
    column-gap: 5rem;
  }
  .md\\:col-gap-24 {
    grid-column-gap: 6rem;
    column-gap: 6rem;
  }
  .md\\:col-gap-28 {
    grid-column-gap: 7rem;
    column-gap: 7rem;
  }
  .md\\:col-gap-32 {
    grid-column-gap: 8rem;
    column-gap: 8rem;
  }
  .md\\:col-gap-36 {
    grid-column-gap: 9rem;
    column-gap: 9rem;
  }
  .md\\:col-gap-40 {
    grid-column-gap: 10rem;
    column-gap: 10rem;
  }
  .md\\:col-gap-44 {
    grid-column-gap: 11rem;
    column-gap: 11rem;
  }
  .md\\:col-gap-48 {
    grid-column-gap: 12rem;
    column-gap: 12rem;
  }
  .md\\:col-gap-52 {
    grid-column-gap: 13rem;
    column-gap: 13rem;
  }
  .md\\:col-gap-56 {
    grid-column-gap: 14rem;
    column-gap: 14rem;
  }
  .md\\:col-gap-60 {
    grid-column-gap: 15rem;
    column-gap: 15rem;
  }
  .md\\:col-gap-64 {
    grid-column-gap: 16rem;
    column-gap: 16rem;
  }
  .md\\:col-gap-72 {
    grid-column-gap: 18rem;
    column-gap: 18rem;
  }
  .md\\:col-gap-80 {
    grid-column-gap: 20rem;
    column-gap: 20rem;
  }
  .md\\:col-gap-96 {
    grid-column-gap: 24rem;
    column-gap: 24rem;
  }
  .md\\:col-gap-px {
    grid-column-gap: 1px;
    column-gap: 1px;
  }
  .md\\:col-gap-0\\.5 {
    grid-column-gap: 0.125rem;
    column-gap: 0.125rem;
  }
  .md\\:col-gap-1\\.5 {
    grid-column-gap: 0.375rem;
    column-gap: 0.375rem;
  }
  .md\\:col-gap-2\\.5 {
    grid-column-gap: 0.625rem;
    column-gap: 0.625rem;
  }
  .md\\:col-gap-3\\.5 {
    grid-column-gap: 0.875rem;
    column-gap: 0.875rem;
  }
  .md\\:col-gap-1\\/2 {
    grid-column-gap: 50%;
    column-gap: 50%;
  }
  .md\\:col-gap-1\\/3 {
    grid-column-gap: 33.333333%;
    column-gap: 33.333333%;
  }
  .md\\:col-gap-2\\/3 {
    grid-column-gap: 66.666667%;
    column-gap: 66.666667%;
  }
  .md\\:col-gap-1\\/4 {
    grid-column-gap: 25%;
    column-gap: 25%;
  }
  .md\\:col-gap-2\\/4 {
    grid-column-gap: 50%;
    column-gap: 50%;
  }
  .md\\:col-gap-3\\/4 {
    grid-column-gap: 75%;
    column-gap: 75%;
  }
  .md\\:col-gap-1\\/5 {
    grid-column-gap: 20%;
    column-gap: 20%;
  }
  .md\\:col-gap-2\\/5 {
    grid-column-gap: 40%;
    column-gap: 40%;
  }
  .md\\:col-gap-3\\/5 {
    grid-column-gap: 60%;
    column-gap: 60%;
  }
  .md\\:col-gap-4\\/5 {
    grid-column-gap: 80%;
    column-gap: 80%;
  }
  .md\\:col-gap-1\\/6 {
    grid-column-gap: 16.666667%;
    column-gap: 16.666667%;
  }
  .md\\:col-gap-2\\/6 {
    grid-column-gap: 33.333333%;
    column-gap: 33.333333%;
  }
  .md\\:col-gap-3\\/6 {
    grid-column-gap: 50%;
    column-gap: 50%;
  }
  .md\\:col-gap-4\\/6 {
    grid-column-gap: 66.666667%;
    column-gap: 66.666667%;
  }
  .md\\:col-gap-5\\/6 {
    grid-column-gap: 83.333333%;
    column-gap: 83.333333%;
  }
  .md\\:col-gap-1\\/12 {
    grid-column-gap: 8.333333%;
    column-gap: 8.333333%;
  }
  .md\\:col-gap-2\\/12 {
    grid-column-gap: 16.666667%;
    column-gap: 16.666667%;
  }
  .md\\:col-gap-3\\/12 {
    grid-column-gap: 25%;
    column-gap: 25%;
  }
  .md\\:col-gap-4\\/12 {
    grid-column-gap: 33.333333%;
    column-gap: 33.333333%;
  }
  .md\\:col-gap-5\\/12 {
    grid-column-gap: 41.666667%;
    column-gap: 41.666667%;
  }
  .md\\:col-gap-6\\/12 {
    grid-column-gap: 50%;
    column-gap: 50%;
  }
  .md\\:col-gap-7\\/12 {
    grid-column-gap: 58.333333%;
    column-gap: 58.333333%;
  }
  .md\\:col-gap-8\\/12 {
    grid-column-gap: 66.666667%;
    column-gap: 66.666667%;
  }
  .md\\:col-gap-9\\/12 {
    grid-column-gap: 75%;
    column-gap: 75%;
  }
  .md\\:col-gap-10\\/12 {
    grid-column-gap: 83.333333%;
    column-gap: 83.333333%;
  }
  .md\\:col-gap-11\\/12 {
    grid-column-gap: 91.666667%;
    column-gap: 91.666667%;
  }
  .md\\:col-gap-full {
    grid-column-gap: 100%;
    column-gap: 100%;
  }
  .md\\:gap-x-0 {
    grid-column-gap: 0;
    column-gap: 0;
  }
  .md\\:gap-x-1 {
    grid-column-gap: 0.25rem;
    column-gap: 0.25rem;
  }
  .md\\:gap-x-2 {
    grid-column-gap: 0.5rem;
    column-gap: 0.5rem;
  }
  .md\\:gap-x-3 {
    grid-column-gap: 0.75rem;
    column-gap: 0.75rem;
  }
  .md\\:gap-x-4 {
    grid-column-gap: 1rem;
    column-gap: 1rem;
  }
  .md\\:gap-x-5 {
    grid-column-gap: 1.25rem;
    column-gap: 1.25rem;
  }
  .md\\:gap-x-6 {
    grid-column-gap: 1.5rem;
    column-gap: 1.5rem;
  }
  .md\\:gap-x-7 {
    grid-column-gap: 1.75rem;
    column-gap: 1.75rem;
  }
  .md\\:gap-x-8 {
    grid-column-gap: 2rem;
    column-gap: 2rem;
  }
  .md\\:gap-x-9 {
    grid-column-gap: 2.25rem;
    column-gap: 2.25rem;
  }
  .md\\:gap-x-10 {
    grid-column-gap: 2.5rem;
    column-gap: 2.5rem;
  }
  .md\\:gap-x-11 {
    grid-column-gap: 2.75rem;
    column-gap: 2.75rem;
  }
  .md\\:gap-x-12 {
    grid-column-gap: 3rem;
    column-gap: 3rem;
  }
  .md\\:gap-x-13 {
    grid-column-gap: 3.25rem;
    column-gap: 3.25rem;
  }
  .md\\:gap-x-14 {
    grid-column-gap: 3.5rem;
    column-gap: 3.5rem;
  }
  .md\\:gap-x-15 {
    grid-column-gap: 3.75rem;
    column-gap: 3.75rem;
  }
  .md\\:gap-x-16 {
    grid-column-gap: 4rem;
    column-gap: 4rem;
  }
  .md\\:gap-x-20 {
    grid-column-gap: 5rem;
    column-gap: 5rem;
  }
  .md\\:gap-x-24 {
    grid-column-gap: 6rem;
    column-gap: 6rem;
  }
  .md\\:gap-x-28 {
    grid-column-gap: 7rem;
    column-gap: 7rem;
  }
  .md\\:gap-x-32 {
    grid-column-gap: 8rem;
    column-gap: 8rem;
  }
  .md\\:gap-x-36 {
    grid-column-gap: 9rem;
    column-gap: 9rem;
  }
  .md\\:gap-x-40 {
    grid-column-gap: 10rem;
    column-gap: 10rem;
  }
  .md\\:gap-x-44 {
    grid-column-gap: 11rem;
    column-gap: 11rem;
  }
  .md\\:gap-x-48 {
    grid-column-gap: 12rem;
    column-gap: 12rem;
  }
  .md\\:gap-x-52 {
    grid-column-gap: 13rem;
    column-gap: 13rem;
  }
  .md\\:gap-x-56 {
    grid-column-gap: 14rem;
    column-gap: 14rem;
  }
  .md\\:gap-x-60 {
    grid-column-gap: 15rem;
    column-gap: 15rem;
  }
  .md\\:gap-x-64 {
    grid-column-gap: 16rem;
    column-gap: 16rem;
  }
  .md\\:gap-x-72 {
    grid-column-gap: 18rem;
    column-gap: 18rem;
  }
  .md\\:gap-x-80 {
    grid-column-gap: 20rem;
    column-gap: 20rem;
  }
  .md\\:gap-x-96 {
    grid-column-gap: 24rem;
    column-gap: 24rem;
  }
  .md\\:gap-x-px {
    grid-column-gap: 1px;
    column-gap: 1px;
  }
  .md\\:gap-x-0\\.5 {
    grid-column-gap: 0.125rem;
    column-gap: 0.125rem;
  }
  .md\\:gap-x-1\\.5 {
    grid-column-gap: 0.375rem;
    column-gap: 0.375rem;
  }
  .md\\:gap-x-2\\.5 {
    grid-column-gap: 0.625rem;
    column-gap: 0.625rem;
  }
  .md\\:gap-x-3\\.5 {
    grid-column-gap: 0.875rem;
    column-gap: 0.875rem;
  }
  .md\\:gap-x-1\\/2 {
    grid-column-gap: 50%;
    column-gap: 50%;
  }
  .md\\:gap-x-1\\/3 {
    grid-column-gap: 33.333333%;
    column-gap: 33.333333%;
  }
  .md\\:gap-x-2\\/3 {
    grid-column-gap: 66.666667%;
    column-gap: 66.666667%;
  }
  .md\\:gap-x-1\\/4 {
    grid-column-gap: 25%;
    column-gap: 25%;
  }
  .md\\:gap-x-2\\/4 {
    grid-column-gap: 50%;
    column-gap: 50%;
  }
  .md\\:gap-x-3\\/4 {
    grid-column-gap: 75%;
    column-gap: 75%;
  }
  .md\\:gap-x-1\\/5 {
    grid-column-gap: 20%;
    column-gap: 20%;
  }
  .md\\:gap-x-2\\/5 {
    grid-column-gap: 40%;
    column-gap: 40%;
  }
  .md\\:gap-x-3\\/5 {
    grid-column-gap: 60%;
    column-gap: 60%;
  }
  .md\\:gap-x-4\\/5 {
    grid-column-gap: 80%;
    column-gap: 80%;
  }
  .md\\:gap-x-1\\/6 {
    grid-column-gap: 16.666667%;
    column-gap: 16.666667%;
  }
  .md\\:gap-x-2\\/6 {
    grid-column-gap: 33.333333%;
    column-gap: 33.333333%;
  }
  .md\\:gap-x-3\\/6 {
    grid-column-gap: 50%;
    column-gap: 50%;
  }
  .md\\:gap-x-4\\/6 {
    grid-column-gap: 66.666667%;
    column-gap: 66.666667%;
  }
  .md\\:gap-x-5\\/6 {
    grid-column-gap: 83.333333%;
    column-gap: 83.333333%;
  }
  .md\\:gap-x-1\\/12 {
    grid-column-gap: 8.333333%;
    column-gap: 8.333333%;
  }
  .md\\:gap-x-2\\/12 {
    grid-column-gap: 16.666667%;
    column-gap: 16.666667%;
  }
  .md\\:gap-x-3\\/12 {
    grid-column-gap: 25%;
    column-gap: 25%;
  }
  .md\\:gap-x-4\\/12 {
    grid-column-gap: 33.333333%;
    column-gap: 33.333333%;
  }
  .md\\:gap-x-5\\/12 {
    grid-column-gap: 41.666667%;
    column-gap: 41.666667%;
  }
  .md\\:gap-x-6\\/12 {
    grid-column-gap: 50%;
    column-gap: 50%;
  }
  .md\\:gap-x-7\\/12 {
    grid-column-gap: 58.333333%;
    column-gap: 58.333333%;
  }
  .md\\:gap-x-8\\/12 {
    grid-column-gap: 66.666667%;
    column-gap: 66.666667%;
  }
  .md\\:gap-x-9\\/12 {
    grid-column-gap: 75%;
    column-gap: 75%;
  }
  .md\\:gap-x-10\\/12 {
    grid-column-gap: 83.333333%;
    column-gap: 83.333333%;
  }
  .md\\:gap-x-11\\/12 {
    grid-column-gap: 91.666667%;
    column-gap: 91.666667%;
  }
  .md\\:gap-x-full {
    grid-column-gap: 100%;
    column-gap: 100%;
  }
  .md\\:row-gap-0 {
    grid-row-gap: 0;
    row-gap: 0;
  }
  .md\\:row-gap-1 {
    grid-row-gap: 0.25rem;
    row-gap: 0.25rem;
  }
  .md\\:row-gap-2 {
    grid-row-gap: 0.5rem;
    row-gap: 0.5rem;
  }
  .md\\:row-gap-3 {
    grid-row-gap: 0.75rem;
    row-gap: 0.75rem;
  }
  .md\\:row-gap-4 {
    grid-row-gap: 1rem;
    row-gap: 1rem;
  }
  .md\\:row-gap-5 {
    grid-row-gap: 1.25rem;
    row-gap: 1.25rem;
  }
  .md\\:row-gap-6 {
    grid-row-gap: 1.5rem;
    row-gap: 1.5rem;
  }
  .md\\:row-gap-7 {
    grid-row-gap: 1.75rem;
    row-gap: 1.75rem;
  }
  .md\\:row-gap-8 {
    grid-row-gap: 2rem;
    row-gap: 2rem;
  }
  .md\\:row-gap-9 {
    grid-row-gap: 2.25rem;
    row-gap: 2.25rem;
  }
  .md\\:row-gap-10 {
    grid-row-gap: 2.5rem;
    row-gap: 2.5rem;
  }
  .md\\:row-gap-11 {
    grid-row-gap: 2.75rem;
    row-gap: 2.75rem;
  }
  .md\\:row-gap-12 {
    grid-row-gap: 3rem;
    row-gap: 3rem;
  }
  .md\\:row-gap-13 {
    grid-row-gap: 3.25rem;
    row-gap: 3.25rem;
  }
  .md\\:row-gap-14 {
    grid-row-gap: 3.5rem;
    row-gap: 3.5rem;
  }
  .md\\:row-gap-15 {
    grid-row-gap: 3.75rem;
    row-gap: 3.75rem;
  }
  .md\\:row-gap-16 {
    grid-row-gap: 4rem;
    row-gap: 4rem;
  }
  .md\\:row-gap-20 {
    grid-row-gap: 5rem;
    row-gap: 5rem;
  }
  .md\\:row-gap-24 {
    grid-row-gap: 6rem;
    row-gap: 6rem;
  }
  .md\\:row-gap-28 {
    grid-row-gap: 7rem;
    row-gap: 7rem;
  }
  .md\\:row-gap-32 {
    grid-row-gap: 8rem;
    row-gap: 8rem;
  }
  .md\\:row-gap-36 {
    grid-row-gap: 9rem;
    row-gap: 9rem;
  }
  .md\\:row-gap-40 {
    grid-row-gap: 10rem;
    row-gap: 10rem;
  }
  .md\\:row-gap-44 {
    grid-row-gap: 11rem;
    row-gap: 11rem;
  }
  .md\\:row-gap-48 {
    grid-row-gap: 12rem;
    row-gap: 12rem;
  }
  .md\\:row-gap-52 {
    grid-row-gap: 13rem;
    row-gap: 13rem;
  }
  .md\\:row-gap-56 {
    grid-row-gap: 14rem;
    row-gap: 14rem;
  }
  .md\\:row-gap-60 {
    grid-row-gap: 15rem;
    row-gap: 15rem;
  }
  .md\\:row-gap-64 {
    grid-row-gap: 16rem;
    row-gap: 16rem;
  }
  .md\\:row-gap-72 {
    grid-row-gap: 18rem;
    row-gap: 18rem;
  }
  .md\\:row-gap-80 {
    grid-row-gap: 20rem;
    row-gap: 20rem;
  }
  .md\\:row-gap-96 {
    grid-row-gap: 24rem;
    row-gap: 24rem;
  }
  .md\\:row-gap-px {
    grid-row-gap: 1px;
    row-gap: 1px;
  }
  .md\\:row-gap-0\\.5 {
    grid-row-gap: 0.125rem;
    row-gap: 0.125rem;
  }
  .md\\:row-gap-1\\.5 {
    grid-row-gap: 0.375rem;
    row-gap: 0.375rem;
  }
  .md\\:row-gap-2\\.5 {
    grid-row-gap: 0.625rem;
    row-gap: 0.625rem;
  }
  .md\\:row-gap-3\\.5 {
    grid-row-gap: 0.875rem;
    row-gap: 0.875rem;
  }
  .md\\:row-gap-1\\/2 {
    grid-row-gap: 50%;
    row-gap: 50%;
  }
  .md\\:row-gap-1\\/3 {
    grid-row-gap: 33.333333%;
    row-gap: 33.333333%;
  }
  .md\\:row-gap-2\\/3 {
    grid-row-gap: 66.666667%;
    row-gap: 66.666667%;
  }
  .md\\:row-gap-1\\/4 {
    grid-row-gap: 25%;
    row-gap: 25%;
  }
  .md\\:row-gap-2\\/4 {
    grid-row-gap: 50%;
    row-gap: 50%;
  }
  .md\\:row-gap-3\\/4 {
    grid-row-gap: 75%;
    row-gap: 75%;
  }
  .md\\:row-gap-1\\/5 {
    grid-row-gap: 20%;
    row-gap: 20%;
  }
  .md\\:row-gap-2\\/5 {
    grid-row-gap: 40%;
    row-gap: 40%;
  }
  .md\\:row-gap-3\\/5 {
    grid-row-gap: 60%;
    row-gap: 60%;
  }
  .md\\:row-gap-4\\/5 {
    grid-row-gap: 80%;
    row-gap: 80%;
  }
  .md\\:row-gap-1\\/6 {
    grid-row-gap: 16.666667%;
    row-gap: 16.666667%;
  }
  .md\\:row-gap-2\\/6 {
    grid-row-gap: 33.333333%;
    row-gap: 33.333333%;
  }
  .md\\:row-gap-3\\/6 {
    grid-row-gap: 50%;
    row-gap: 50%;
  }
  .md\\:row-gap-4\\/6 {
    grid-row-gap: 66.666667%;
    row-gap: 66.666667%;
  }
  .md\\:row-gap-5\\/6 {
    grid-row-gap: 83.333333%;
    row-gap: 83.333333%;
  }
  .md\\:row-gap-1\\/12 {
    grid-row-gap: 8.333333%;
    row-gap: 8.333333%;
  }
  .md\\:row-gap-2\\/12 {
    grid-row-gap: 16.666667%;
    row-gap: 16.666667%;
  }
  .md\\:row-gap-3\\/12 {
    grid-row-gap: 25%;
    row-gap: 25%;
  }
  .md\\:row-gap-4\\/12 {
    grid-row-gap: 33.333333%;
    row-gap: 33.333333%;
  }
  .md\\:row-gap-5\\/12 {
    grid-row-gap: 41.666667%;
    row-gap: 41.666667%;
  }
  .md\\:row-gap-6\\/12 {
    grid-row-gap: 50%;
    row-gap: 50%;
  }
  .md\\:row-gap-7\\/12 {
    grid-row-gap: 58.333333%;
    row-gap: 58.333333%;
  }
  .md\\:row-gap-8\\/12 {
    grid-row-gap: 66.666667%;
    row-gap: 66.666667%;
  }
  .md\\:row-gap-9\\/12 {
    grid-row-gap: 75%;
    row-gap: 75%;
  }
  .md\\:row-gap-10\\/12 {
    grid-row-gap: 83.333333%;
    row-gap: 83.333333%;
  }
  .md\\:row-gap-11\\/12 {
    grid-row-gap: 91.666667%;
    row-gap: 91.666667%;
  }
  .md\\:row-gap-full {
    grid-row-gap: 100%;
    row-gap: 100%;
  }
  .md\\:gap-y-0 {
    grid-row-gap: 0;
    row-gap: 0;
  }
  .md\\:gap-y-1 {
    grid-row-gap: 0.25rem;
    row-gap: 0.25rem;
  }
  .md\\:gap-y-2 {
    grid-row-gap: 0.5rem;
    row-gap: 0.5rem;
  }
  .md\\:gap-y-3 {
    grid-row-gap: 0.75rem;
    row-gap: 0.75rem;
  }
  .md\\:gap-y-4 {
    grid-row-gap: 1rem;
    row-gap: 1rem;
  }
  .md\\:gap-y-5 {
    grid-row-gap: 1.25rem;
    row-gap: 1.25rem;
  }
  .md\\:gap-y-6 {
    grid-row-gap: 1.5rem;
    row-gap: 1.5rem;
  }
  .md\\:gap-y-7 {
    grid-row-gap: 1.75rem;
    row-gap: 1.75rem;
  }
  .md\\:gap-y-8 {
    grid-row-gap: 2rem;
    row-gap: 2rem;
  }
  .md\\:gap-y-9 {
    grid-row-gap: 2.25rem;
    row-gap: 2.25rem;
  }
  .md\\:gap-y-10 {
    grid-row-gap: 2.5rem;
    row-gap: 2.5rem;
  }
  .md\\:gap-y-11 {
    grid-row-gap: 2.75rem;
    row-gap: 2.75rem;
  }
  .md\\:gap-y-12 {
    grid-row-gap: 3rem;
    row-gap: 3rem;
  }
  .md\\:gap-y-13 {
    grid-row-gap: 3.25rem;
    row-gap: 3.25rem;
  }
  .md\\:gap-y-14 {
    grid-row-gap: 3.5rem;
    row-gap: 3.5rem;
  }
  .md\\:gap-y-15 {
    grid-row-gap: 3.75rem;
    row-gap: 3.75rem;
  }
  .md\\:gap-y-16 {
    grid-row-gap: 4rem;
    row-gap: 4rem;
  }
  .md\\:gap-y-20 {
    grid-row-gap: 5rem;
    row-gap: 5rem;
  }
  .md\\:gap-y-24 {
    grid-row-gap: 6rem;
    row-gap: 6rem;
  }
  .md\\:gap-y-28 {
    grid-row-gap: 7rem;
    row-gap: 7rem;
  }
  .md\\:gap-y-32 {
    grid-row-gap: 8rem;
    row-gap: 8rem;
  }
  .md\\:gap-y-36 {
    grid-row-gap: 9rem;
    row-gap: 9rem;
  }
  .md\\:gap-y-40 {
    grid-row-gap: 10rem;
    row-gap: 10rem;
  }
  .md\\:gap-y-44 {
    grid-row-gap: 11rem;
    row-gap: 11rem;
  }
  .md\\:gap-y-48 {
    grid-row-gap: 12rem;
    row-gap: 12rem;
  }
  .md\\:gap-y-52 {
    grid-row-gap: 13rem;
    row-gap: 13rem;
  }
  .md\\:gap-y-56 {
    grid-row-gap: 14rem;
    row-gap: 14rem;
  }
  .md\\:gap-y-60 {
    grid-row-gap: 15rem;
    row-gap: 15rem;
  }
  .md\\:gap-y-64 {
    grid-row-gap: 16rem;
    row-gap: 16rem;
  }
  .md\\:gap-y-72 {
    grid-row-gap: 18rem;
    row-gap: 18rem;
  }
  .md\\:gap-y-80 {
    grid-row-gap: 20rem;
    row-gap: 20rem;
  }
  .md\\:gap-y-96 {
    grid-row-gap: 24rem;
    row-gap: 24rem;
  }
  .md\\:gap-y-px {
    grid-row-gap: 1px;
    row-gap: 1px;
  }
  .md\\:gap-y-0\\.5 {
    grid-row-gap: 0.125rem;
    row-gap: 0.125rem;
  }
  .md\\:gap-y-1\\.5 {
    grid-row-gap: 0.375rem;
    row-gap: 0.375rem;
  }
  .md\\:gap-y-2\\.5 {
    grid-row-gap: 0.625rem;
    row-gap: 0.625rem;
  }
  .md\\:gap-y-3\\.5 {
    grid-row-gap: 0.875rem;
    row-gap: 0.875rem;
  }
  .md\\:gap-y-1\\/2 {
    grid-row-gap: 50%;
    row-gap: 50%;
  }
  .md\\:gap-y-1\\/3 {
    grid-row-gap: 33.333333%;
    row-gap: 33.333333%;
  }
  .md\\:gap-y-2\\/3 {
    grid-row-gap: 66.666667%;
    row-gap: 66.666667%;
  }
  .md\\:gap-y-1\\/4 {
    grid-row-gap: 25%;
    row-gap: 25%;
  }
  .md\\:gap-y-2\\/4 {
    grid-row-gap: 50%;
    row-gap: 50%;
  }
  .md\\:gap-y-3\\/4 {
    grid-row-gap: 75%;
    row-gap: 75%;
  }
  .md\\:gap-y-1\\/5 {
    grid-row-gap: 20%;
    row-gap: 20%;
  }
  .md\\:gap-y-2\\/5 {
    grid-row-gap: 40%;
    row-gap: 40%;
  }
  .md\\:gap-y-3\\/5 {
    grid-row-gap: 60%;
    row-gap: 60%;
  }
  .md\\:gap-y-4\\/5 {
    grid-row-gap: 80%;
    row-gap: 80%;
  }
  .md\\:gap-y-1\\/6 {
    grid-row-gap: 16.666667%;
    row-gap: 16.666667%;
  }
  .md\\:gap-y-2\\/6 {
    grid-row-gap: 33.333333%;
    row-gap: 33.333333%;
  }
  .md\\:gap-y-3\\/6 {
    grid-row-gap: 50%;
    row-gap: 50%;
  }
  .md\\:gap-y-4\\/6 {
    grid-row-gap: 66.666667%;
    row-gap: 66.666667%;
  }
  .md\\:gap-y-5\\/6 {
    grid-row-gap: 83.333333%;
    row-gap: 83.333333%;
  }
  .md\\:gap-y-1\\/12 {
    grid-row-gap: 8.333333%;
    row-gap: 8.333333%;
  }
  .md\\:gap-y-2\\/12 {
    grid-row-gap: 16.666667%;
    row-gap: 16.666667%;
  }
  .md\\:gap-y-3\\/12 {
    grid-row-gap: 25%;
    row-gap: 25%;
  }
  .md\\:gap-y-4\\/12 {
    grid-row-gap: 33.333333%;
    row-gap: 33.333333%;
  }
  .md\\:gap-y-5\\/12 {
    grid-row-gap: 41.666667%;
    row-gap: 41.666667%;
  }
  .md\\:gap-y-6\\/12 {
    grid-row-gap: 50%;
    row-gap: 50%;
  }
  .md\\:gap-y-7\\/12 {
    grid-row-gap: 58.333333%;
    row-gap: 58.333333%;
  }
  .md\\:gap-y-8\\/12 {
    grid-row-gap: 66.666667%;
    row-gap: 66.666667%;
  }
  .md\\:gap-y-9\\/12 {
    grid-row-gap: 75%;
    row-gap: 75%;
  }
  .md\\:gap-y-10\\/12 {
    grid-row-gap: 83.333333%;
    row-gap: 83.333333%;
  }
  .md\\:gap-y-11\\/12 {
    grid-row-gap: 91.666667%;
    row-gap: 91.666667%;
  }
  .md\\:gap-y-full {
    grid-row-gap: 100%;
    row-gap: 100%;
  }
  .md\\:grid-flow-row {
    grid-auto-flow: row;
  }
  .md\\:grid-flow-col {
    grid-auto-flow: column;
  }
  .md\\:grid-flow-row-dense {
    grid-auto-flow: row dense;
  }
  .md\\:grid-flow-col-dense {
    grid-auto-flow: column dense;
  }
  .md\\:grid-cols-1 {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }
  .md\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .md\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .md\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
  .md\\:grid-cols-5 {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }
  .md\\:grid-cols-6 {
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }
  .md\\:grid-cols-7 {
    grid-template-columns: repeat(7, minmax(0, 1fr));
  }
  .md\\:grid-cols-8 {
    grid-template-columns: repeat(8, minmax(0, 1fr));
  }
  .md\\:grid-cols-9 {
    grid-template-columns: repeat(9, minmax(0, 1fr));
  }
  .md\\:grid-cols-10 {
    grid-template-columns: repeat(10, minmax(0, 1fr));
  }
  .md\\:grid-cols-11 {
    grid-template-columns: repeat(11, minmax(0, 1fr));
  }
  .md\\:grid-cols-12 {
    grid-template-columns: repeat(12, minmax(0, 1fr));
  }
  .md\\:grid-cols-none {
    grid-template-columns: none;
  }
  .md\\:auto-cols-auto {
    grid-auto-columns: auto;
  }
  .md\\:auto-cols-min {
    grid-auto-columns: min-content;
  }
  .md\\:auto-cols-max {
    grid-auto-columns: max-content;
  }
  .md\\:auto-cols-fr {
    grid-auto-columns: minmax(0, 1fr);
  }
  .md\\:col-auto {
    grid-column: auto;
  }
  .md\\:col-span-1 {
    grid-column: span 1 / span 1;
  }
  .md\\:col-span-2 {
    grid-column: span 2 / span 2;
  }
  .md\\:col-span-3 {
    grid-column: span 3 / span 3;
  }
  .md\\:col-span-4 {
    grid-column: span 4 / span 4;
  }
  .md\\:col-span-5 {
    grid-column: span 5 / span 5;
  }
  .md\\:col-span-6 {
    grid-column: span 6 / span 6;
  }
  .md\\:col-span-7 {
    grid-column: span 7 / span 7;
  }
  .md\\:col-span-8 {
    grid-column: span 8 / span 8;
  }
  .md\\:col-span-9 {
    grid-column: span 9 / span 9;
  }
  .md\\:col-span-10 {
    grid-column: span 10 / span 10;
  }
  .md\\:col-span-11 {
    grid-column: span 11 / span 11;
  }
  .md\\:col-span-12 {
    grid-column: span 12 / span 12;
  }
  .md\\:col-span-full {
    grid-column: 1 / -1;
  }
  .md\\:col-start-1 {
    grid-column-start: 1;
  }
  .md\\:col-start-2 {
    grid-column-start: 2;
  }
  .md\\:col-start-3 {
    grid-column-start: 3;
  }
  .md\\:col-start-4 {
    grid-column-start: 4;
  }
  .md\\:col-start-5 {
    grid-column-start: 5;
  }
  .md\\:col-start-6 {
    grid-column-start: 6;
  }
  .md\\:col-start-7 {
    grid-column-start: 7;
  }
  .md\\:col-start-8 {
    grid-column-start: 8;
  }
  .md\\:col-start-9 {
    grid-column-start: 9;
  }
  .md\\:col-start-10 {
    grid-column-start: 10;
  }
  .md\\:col-start-11 {
    grid-column-start: 11;
  }
  .md\\:col-start-12 {
    grid-column-start: 12;
  }
  .md\\:col-start-13 {
    grid-column-start: 13;
  }
  .md\\:col-start-auto {
    grid-column-start: auto;
  }
  .md\\:col-end-1 {
    grid-column-end: 1;
  }
  .md\\:col-end-2 {
    grid-column-end: 2;
  }
  .md\\:col-end-3 {
    grid-column-end: 3;
  }
  .md\\:col-end-4 {
    grid-column-end: 4;
  }
  .md\\:col-end-5 {
    grid-column-end: 5;
  }
  .md\\:col-end-6 {
    grid-column-end: 6;
  }
  .md\\:col-end-7 {
    grid-column-end: 7;
  }
  .md\\:col-end-8 {
    grid-column-end: 8;
  }
  .md\\:col-end-9 {
    grid-column-end: 9;
  }
  .md\\:col-end-10 {
    grid-column-end: 10;
  }
  .md\\:col-end-11 {
    grid-column-end: 11;
  }
  .md\\:col-end-12 {
    grid-column-end: 12;
  }
  .md\\:col-end-13 {
    grid-column-end: 13;
  }
  .md\\:col-end-auto {
    grid-column-end: auto;
  }
  .md\\:grid-rows-1 {
    grid-template-rows: repeat(1, minmax(0, 1fr));
  }
  .md\\:grid-rows-2 {
    grid-template-rows: repeat(2, minmax(0, 1fr));
  }
  .md\\:grid-rows-3 {
    grid-template-rows: repeat(3, minmax(0, 1fr));
  }
  .md\\:grid-rows-4 {
    grid-template-rows: repeat(4, minmax(0, 1fr));
  }
  .md\\:grid-rows-5 {
    grid-template-rows: repeat(5, minmax(0, 1fr));
  }
  .md\\:grid-rows-6 {
    grid-template-rows: repeat(6, minmax(0, 1fr));
  }
  .md\\:grid-rows-none {
    grid-template-rows: none;
  }
  .md\\:auto-rows-auto {
    grid-auto-rows: auto;
  }
  .md\\:auto-rows-min {
    grid-auto-rows: min-content;
  }
  .md\\:auto-rows-max {
    grid-auto-rows: max-content;
  }
  .md\\:auto-rows-fr {
    grid-auto-rows: minmax(0, 1fr);
  }
  .md\\:row-auto {
    grid-row: auto;
  }
  .md\\:row-span-1 {
    grid-row: span 1 / span 1;
  }
  .md\\:row-span-2 {
    grid-row: span 2 / span 2;
  }
  .md\\:row-span-3 {
    grid-row: span 3 / span 3;
  }
  .md\\:row-span-4 {
    grid-row: span 4 / span 4;
  }
  .md\\:row-span-5 {
    grid-row: span 5 / span 5;
  }
  .md\\:row-span-6 {
    grid-row: span 6 / span 6;
  }
  .md\\:row-span-full {
    grid-row: 1 / -1;
  }
  .md\\:row-start-1 {
    grid-row-start: 1;
  }
  .md\\:row-start-2 {
    grid-row-start: 2;
  }
  .md\\:row-start-3 {
    grid-row-start: 3;
  }
  .md\\:row-start-4 {
    grid-row-start: 4;
  }
  .md\\:row-start-5 {
    grid-row-start: 5;
  }
  .md\\:row-start-6 {
    grid-row-start: 6;
  }
  .md\\:row-start-7 {
    grid-row-start: 7;
  }
  .md\\:row-start-auto {
    grid-row-start: auto;
  }
  .md\\:row-end-1 {
    grid-row-end: 1;
  }
  .md\\:row-end-2 {
    grid-row-end: 2;
  }
  .md\\:row-end-3 {
    grid-row-end: 3;
  }
  .md\\:row-end-4 {
    grid-row-end: 4;
  }
  .md\\:row-end-5 {
    grid-row-end: 5;
  }
  .md\\:row-end-6 {
    grid-row-end: 6;
  }
  .md\\:row-end-7 {
    grid-row-end: 7;
  }
  .md\\:row-end-auto {
    grid-row-end: auto;
  }
  .md\\:transform {
    --transform-translate-x: 0;
    --transform-translate-y: 0;
    --transform-rotate: 0;
    --transform-skew-x: 0;
    --transform-skew-y: 0;
    --transform-scale-x: 1;
    --transform-scale-y: 1;
    transform: translateX(var(--transform-translate-x)) translateY(var(--transform-translate-y)) rotate(var(--transform-rotate)) skewX(var(--transform-skew-x)) skewY(var(--transform-skew-y)) scaleX(var(--transform-scale-x)) scaleY(var(--transform-scale-y));
  }
  .md\\:transform-none {
    transform: none;
  }
  .md\\:origin-center {
    transform-origin: center;
  }
  .md\\:origin-top {
    transform-origin: top;
  }
  .md\\:origin-top-right {
    transform-origin: top right;
  }
  .md\\:origin-right {
    transform-origin: right;
  }
  .md\\:origin-bottom-right {
    transform-origin: bottom right;
  }
  .md\\:origin-bottom {
    transform-origin: bottom;
  }
  .md\\:origin-bottom-left {
    transform-origin: bottom left;
  }
  .md\\:origin-left {
    transform-origin: left;
  }
  .md\\:origin-top-left {
    transform-origin: top left;
  }
  .md\\:scale-0 {
    --transform-scale-x: 0;
    --transform-scale-y: 0;
  }
  .md\\:scale-50 {
    --transform-scale-x: .5;
    --transform-scale-y: .5;
  }
  .md\\:scale-75 {
    --transform-scale-x: .75;
    --transform-scale-y: .75;
  }
  .md\\:scale-90 {
    --transform-scale-x: .9;
    --transform-scale-y: .9;
  }
  .md\\:scale-95 {
    --transform-scale-x: .95;
    --transform-scale-y: .95;
  }
  .md\\:scale-100 {
    --transform-scale-x: 1;
    --transform-scale-y: 1;
  }
  .md\\:scale-105 {
    --transform-scale-x: 1.05;
    --transform-scale-y: 1.05;
  }
  .md\\:scale-110 {
    --transform-scale-x: 1.1;
    --transform-scale-y: 1.1;
  }
  .md\\:scale-125 {
    --transform-scale-x: 1.25;
    --transform-scale-y: 1.25;
  }
  .md\\:scale-150 {
    --transform-scale-x: 1.5;
    --transform-scale-y: 1.5;
  }
  .md\\:scale-x-0 {
    --transform-scale-x: 0;
  }
  .md\\:scale-x-50 {
    --transform-scale-x: .5;
  }
  .md\\:scale-x-75 {
    --transform-scale-x: .75;
  }
  .md\\:scale-x-90 {
    --transform-scale-x: .9;
  }
  .md\\:scale-x-95 {
    --transform-scale-x: .95;
  }
  .md\\:scale-x-100 {
    --transform-scale-x: 1;
  }
  .md\\:scale-x-105 {
    --transform-scale-x: 1.05;
  }
  .md\\:scale-x-110 {
    --transform-scale-x: 1.1;
  }
  .md\\:scale-x-125 {
    --transform-scale-x: 1.25;
  }
  .md\\:scale-x-150 {
    --transform-scale-x: 1.5;
  }
  .md\\:scale-y-0 {
    --transform-scale-y: 0;
  }
  .md\\:scale-y-50 {
    --transform-scale-y: .5;
  }
  .md\\:scale-y-75 {
    --transform-scale-y: .75;
  }
  .md\\:scale-y-90 {
    --transform-scale-y: .9;
  }
  .md\\:scale-y-95 {
    --transform-scale-y: .95;
  }
  .md\\:scale-y-100 {
    --transform-scale-y: 1;
  }
  .md\\:scale-y-105 {
    --transform-scale-y: 1.05;
  }
  .md\\:scale-y-110 {
    --transform-scale-y: 1.1;
  }
  .md\\:scale-y-125 {
    --transform-scale-y: 1.25;
  }
  .md\\:scale-y-150 {
    --transform-scale-y: 1.5;
  }
  .md\\:hover\\:scale-0:hover {
    --transform-scale-x: 0;
    --transform-scale-y: 0;
  }
  .md\\:hover\\:scale-50:hover {
    --transform-scale-x: .5;
    --transform-scale-y: .5;
  }
  .md\\:hover\\:scale-75:hover {
    --transform-scale-x: .75;
    --transform-scale-y: .75;
  }
  .md\\:hover\\:scale-90:hover {
    --transform-scale-x: .9;
    --transform-scale-y: .9;
  }
  .md\\:hover\\:scale-95:hover {
    --transform-scale-x: .95;
    --transform-scale-y: .95;
  }
  .md\\:hover\\:scale-100:hover {
    --transform-scale-x: 1;
    --transform-scale-y: 1;
  }
  .md\\:hover\\:scale-105:hover {
    --transform-scale-x: 1.05;
    --transform-scale-y: 1.05;
  }
  .md\\:hover\\:scale-110:hover {
    --transform-scale-x: 1.1;
    --transform-scale-y: 1.1;
  }
  .md\\:hover\\:scale-125:hover {
    --transform-scale-x: 1.25;
    --transform-scale-y: 1.25;
  }
  .md\\:hover\\:scale-150:hover {
    --transform-scale-x: 1.5;
    --transform-scale-y: 1.5;
  }
  .md\\:hover\\:scale-x-0:hover {
    --transform-scale-x: 0;
  }
  .md\\:hover\\:scale-x-50:hover {
    --transform-scale-x: .5;
  }
  .md\\:hover\\:scale-x-75:hover {
    --transform-scale-x: .75;
  }
  .md\\:hover\\:scale-x-90:hover {
    --transform-scale-x: .9;
  }
  .md\\:hover\\:scale-x-95:hover {
    --transform-scale-x: .95;
  }
  .md\\:hover\\:scale-x-100:hover {
    --transform-scale-x: 1;
  }
  .md\\:hover\\:scale-x-105:hover {
    --transform-scale-x: 1.05;
  }
  .md\\:hover\\:scale-x-110:hover {
    --transform-scale-x: 1.1;
  }
  .md\\:hover\\:scale-x-125:hover {
    --transform-scale-x: 1.25;
  }
  .md\\:hover\\:scale-x-150:hover {
    --transform-scale-x: 1.5;
  }
  .md\\:hover\\:scale-y-0:hover {
    --transform-scale-y: 0;
  }
  .md\\:hover\\:scale-y-50:hover {
    --transform-scale-y: .5;
  }
  .md\\:hover\\:scale-y-75:hover {
    --transform-scale-y: .75;
  }
  .md\\:hover\\:scale-y-90:hover {
    --transform-scale-y: .9;
  }
  .md\\:hover\\:scale-y-95:hover {
    --transform-scale-y: .95;
  }
  .md\\:hover\\:scale-y-100:hover {
    --transform-scale-y: 1;
  }
  .md\\:hover\\:scale-y-105:hover {
    --transform-scale-y: 1.05;
  }
  .md\\:hover\\:scale-y-110:hover {
    --transform-scale-y: 1.1;
  }
  .md\\:hover\\:scale-y-125:hover {
    --transform-scale-y: 1.25;
  }
  .md\\:hover\\:scale-y-150:hover {
    --transform-scale-y: 1.5;
  }
  .md\\:focus\\:scale-0:focus {
    --transform-scale-x: 0;
    --transform-scale-y: 0;
  }
  .md\\:focus\\:scale-50:focus {
    --transform-scale-x: .5;
    --transform-scale-y: .5;
  }
  .md\\:focus\\:scale-75:focus {
    --transform-scale-x: .75;
    --transform-scale-y: .75;
  }
  .md\\:focus\\:scale-90:focus {
    --transform-scale-x: .9;
    --transform-scale-y: .9;
  }
  .md\\:focus\\:scale-95:focus {
    --transform-scale-x: .95;
    --transform-scale-y: .95;
  }
  .md\\:focus\\:scale-100:focus {
    --transform-scale-x: 1;
    --transform-scale-y: 1;
  }
  .md\\:focus\\:scale-105:focus {
    --transform-scale-x: 1.05;
    --transform-scale-y: 1.05;
  }
  .md\\:focus\\:scale-110:focus {
    --transform-scale-x: 1.1;
    --transform-scale-y: 1.1;
  }
  .md\\:focus\\:scale-125:focus {
    --transform-scale-x: 1.25;
    --transform-scale-y: 1.25;
  }
  .md\\:focus\\:scale-150:focus {
    --transform-scale-x: 1.5;
    --transform-scale-y: 1.5;
  }
  .md\\:focus\\:scale-x-0:focus {
    --transform-scale-x: 0;
  }
  .md\\:focus\\:scale-x-50:focus {
    --transform-scale-x: .5;
  }
  .md\\:focus\\:scale-x-75:focus {
    --transform-scale-x: .75;
  }
  .md\\:focus\\:scale-x-90:focus {
    --transform-scale-x: .9;
  }
  .md\\:focus\\:scale-x-95:focus {
    --transform-scale-x: .95;
  }
  .md\\:focus\\:scale-x-100:focus {
    --transform-scale-x: 1;
  }
  .md\\:focus\\:scale-x-105:focus {
    --transform-scale-x: 1.05;
  }
  .md\\:focus\\:scale-x-110:focus {
    --transform-scale-x: 1.1;
  }
  .md\\:focus\\:scale-x-125:focus {
    --transform-scale-x: 1.25;
  }
  .md\\:focus\\:scale-x-150:focus {
    --transform-scale-x: 1.5;
  }
  .md\\:focus\\:scale-y-0:focus {
    --transform-scale-y: 0;
  }
  .md\\:focus\\:scale-y-50:focus {
    --transform-scale-y: .5;
  }
  .md\\:focus\\:scale-y-75:focus {
    --transform-scale-y: .75;
  }
  .md\\:focus\\:scale-y-90:focus {
    --transform-scale-y: .9;
  }
  .md\\:focus\\:scale-y-95:focus {
    --transform-scale-y: .95;
  }
  .md\\:focus\\:scale-y-100:focus {
    --transform-scale-y: 1;
  }
  .md\\:focus\\:scale-y-105:focus {
    --transform-scale-y: 1.05;
  }
  .md\\:focus\\:scale-y-110:focus {
    --transform-scale-y: 1.1;
  }
  .md\\:focus\\:scale-y-125:focus {
    --transform-scale-y: 1.25;
  }
  .md\\:focus\\:scale-y-150:focus {
    --transform-scale-y: 1.5;
  }
  .md\\:rotate-0 {
    --transform-rotate: 0;
  }
  .md\\:rotate-1 {
    --transform-rotate: 1deg;
  }
  .md\\:rotate-2 {
    --transform-rotate: 2deg;
  }
  .md\\:rotate-3 {
    --transform-rotate: 3deg;
  }
  .md\\:rotate-6 {
    --transform-rotate: 6deg;
  }
  .md\\:rotate-12 {
    --transform-rotate: 12deg;
  }
  .md\\:rotate-45 {
    --transform-rotate: 45deg;
  }
  .md\\:rotate-90 {
    --transform-rotate: 90deg;
  }
  .md\\:rotate-180 {
    --transform-rotate: 180deg;
  }
  .md\\:-rotate-180 {
    --transform-rotate: -180deg;
  }
  .md\\:-rotate-90 {
    --transform-rotate: -90deg;
  }
  .md\\:-rotate-45 {
    --transform-rotate: -45deg;
  }
  .md\\:-rotate-12 {
    --transform-rotate: -12deg;
  }
  .md\\:-rotate-6 {
    --transform-rotate: -6deg;
  }
  .md\\:-rotate-3 {
    --transform-rotate: -3deg;
  }
  .md\\:-rotate-2 {
    --transform-rotate: -2deg;
  }
  .md\\:-rotate-1 {
    --transform-rotate: -1deg;
  }
  .md\\:hover\\:rotate-0:hover {
    --transform-rotate: 0;
  }
  .md\\:hover\\:rotate-1:hover {
    --transform-rotate: 1deg;
  }
  .md\\:hover\\:rotate-2:hover {
    --transform-rotate: 2deg;
  }
  .md\\:hover\\:rotate-3:hover {
    --transform-rotate: 3deg;
  }
  .md\\:hover\\:rotate-6:hover {
    --transform-rotate: 6deg;
  }
  .md\\:hover\\:rotate-12:hover {
    --transform-rotate: 12deg;
  }
  .md\\:hover\\:rotate-45:hover {
    --transform-rotate: 45deg;
  }
  .md\\:hover\\:rotate-90:hover {
    --transform-rotate: 90deg;
  }
  .md\\:hover\\:rotate-180:hover {
    --transform-rotate: 180deg;
  }
  .md\\:hover\\:-rotate-180:hover {
    --transform-rotate: -180deg;
  }
  .md\\:hover\\:-rotate-90:hover {
    --transform-rotate: -90deg;
  }
  .md\\:hover\\:-rotate-45:hover {
    --transform-rotate: -45deg;
  }
  .md\\:hover\\:-rotate-12:hover {
    --transform-rotate: -12deg;
  }
  .md\\:hover\\:-rotate-6:hover {
    --transform-rotate: -6deg;
  }
  .md\\:hover\\:-rotate-3:hover {
    --transform-rotate: -3deg;
  }
  .md\\:hover\\:-rotate-2:hover {
    --transform-rotate: -2deg;
  }
  .md\\:hover\\:-rotate-1:hover {
    --transform-rotate: -1deg;
  }
  .md\\:focus\\:rotate-0:focus {
    --transform-rotate: 0;
  }
  .md\\:focus\\:rotate-1:focus {
    --transform-rotate: 1deg;
  }
  .md\\:focus\\:rotate-2:focus {
    --transform-rotate: 2deg;
  }
  .md\\:focus\\:rotate-3:focus {
    --transform-rotate: 3deg;
  }
  .md\\:focus\\:rotate-6:focus {
    --transform-rotate: 6deg;
  }
  .md\\:focus\\:rotate-12:focus {
    --transform-rotate: 12deg;
  }
  .md\\:focus\\:rotate-45:focus {
    --transform-rotate: 45deg;
  }
  .md\\:focus\\:rotate-90:focus {
    --transform-rotate: 90deg;
  }
  .md\\:focus\\:rotate-180:focus {
    --transform-rotate: 180deg;
  }
  .md\\:focus\\:-rotate-180:focus {
    --transform-rotate: -180deg;
  }
  .md\\:focus\\:-rotate-90:focus {
    --transform-rotate: -90deg;
  }
  .md\\:focus\\:-rotate-45:focus {
    --transform-rotate: -45deg;
  }
  .md\\:focus\\:-rotate-12:focus {
    --transform-rotate: -12deg;
  }
  .md\\:focus\\:-rotate-6:focus {
    --transform-rotate: -6deg;
  }
  .md\\:focus\\:-rotate-3:focus {
    --transform-rotate: -3deg;
  }
  .md\\:focus\\:-rotate-2:focus {
    --transform-rotate: -2deg;
  }
  .md\\:focus\\:-rotate-1:focus {
    --transform-rotate: -1deg;
  }
  .md\\:translate-x-0 {
    --transform-translate-x: 0;
  }
  .md\\:translate-x-1 {
    --transform-translate-x: 0.25rem;
  }
  .md\\:translate-x-2 {
    --transform-translate-x: 0.5rem;
  }
  .md\\:translate-x-3 {
    --transform-translate-x: 0.75rem;
  }
  .md\\:translate-x-4 {
    --transform-translate-x: 1rem;
  }
  .md\\:translate-x-5 {
    --transform-translate-x: 1.25rem;
  }
  .md\\:translate-x-6 {
    --transform-translate-x: 1.5rem;
  }
  .md\\:translate-x-7 {
    --transform-translate-x: 1.75rem;
  }
  .md\\:translate-x-8 {
    --transform-translate-x: 2rem;
  }
  .md\\:translate-x-9 {
    --transform-translate-x: 2.25rem;
  }
  .md\\:translate-x-10 {
    --transform-translate-x: 2.5rem;
  }
  .md\\:translate-x-11 {
    --transform-translate-x: 2.75rem;
  }
  .md\\:translate-x-12 {
    --transform-translate-x: 3rem;
  }
  .md\\:translate-x-13 {
    --transform-translate-x: 3.25rem;
  }
  .md\\:translate-x-14 {
    --transform-translate-x: 3.5rem;
  }
  .md\\:translate-x-15 {
    --transform-translate-x: 3.75rem;
  }
  .md\\:translate-x-16 {
    --transform-translate-x: 4rem;
  }
  .md\\:translate-x-20 {
    --transform-translate-x: 5rem;
  }
  .md\\:translate-x-24 {
    --transform-translate-x: 6rem;
  }
  .md\\:translate-x-28 {
    --transform-translate-x: 7rem;
  }
  .md\\:translate-x-32 {
    --transform-translate-x: 8rem;
  }
  .md\\:translate-x-36 {
    --transform-translate-x: 9rem;
  }
  .md\\:translate-x-40 {
    --transform-translate-x: 10rem;
  }
  .md\\:translate-x-44 {
    --transform-translate-x: 11rem;
  }
  .md\\:translate-x-48 {
    --transform-translate-x: 12rem;
  }
  .md\\:translate-x-52 {
    --transform-translate-x: 13rem;
  }
  .md\\:translate-x-56 {
    --transform-translate-x: 14rem;
  }
  .md\\:translate-x-60 {
    --transform-translate-x: 15rem;
  }
  .md\\:translate-x-64 {
    --transform-translate-x: 16rem;
  }
  .md\\:translate-x-72 {
    --transform-translate-x: 18rem;
  }
  .md\\:translate-x-80 {
    --transform-translate-x: 20rem;
  }
  .md\\:translate-x-96 {
    --transform-translate-x: 24rem;
  }
  .md\\:translate-x-px {
    --transform-translate-x: 1px;
  }
  .md\\:translate-x-0\\.5 {
    --transform-translate-x: 0.125rem;
  }
  .md\\:translate-x-1\\.5 {
    --transform-translate-x: 0.375rem;
  }
  .md\\:translate-x-2\\.5 {
    --transform-translate-x: 0.625rem;
  }
  .md\\:translate-x-3\\.5 {
    --transform-translate-x: 0.875rem;
  }
  .md\\:translate-x-1\\/2 {
    --transform-translate-x: 50%;
  }
  .md\\:translate-x-1\\/3 {
    --transform-translate-x: 33.333333%;
  }
  .md\\:translate-x-2\\/3 {
    --transform-translate-x: 66.666667%;
  }
  .md\\:translate-x-1\\/4 {
    --transform-translate-x: 25%;
  }
  .md\\:translate-x-2\\/4 {
    --transform-translate-x: 50%;
  }
  .md\\:translate-x-3\\/4 {
    --transform-translate-x: 75%;
  }
  .md\\:translate-x-1\\/5 {
    --transform-translate-x: 20%;
  }
  .md\\:translate-x-2\\/5 {
    --transform-translate-x: 40%;
  }
  .md\\:translate-x-3\\/5 {
    --transform-translate-x: 60%;
  }
  .md\\:translate-x-4\\/5 {
    --transform-translate-x: 80%;
  }
  .md\\:translate-x-1\\/6 {
    --transform-translate-x: 16.666667%;
  }
  .md\\:translate-x-2\\/6 {
    --transform-translate-x: 33.333333%;
  }
  .md\\:translate-x-3\\/6 {
    --transform-translate-x: 50%;
  }
  .md\\:translate-x-4\\/6 {
    --transform-translate-x: 66.666667%;
  }
  .md\\:translate-x-5\\/6 {
    --transform-translate-x: 83.333333%;
  }
  .md\\:translate-x-1\\/12 {
    --transform-translate-x: 8.333333%;
  }
  .md\\:translate-x-2\\/12 {
    --transform-translate-x: 16.666667%;
  }
  .md\\:translate-x-3\\/12 {
    --transform-translate-x: 25%;
  }
  .md\\:translate-x-4\\/12 {
    --transform-translate-x: 33.333333%;
  }
  .md\\:translate-x-5\\/12 {
    --transform-translate-x: 41.666667%;
  }
  .md\\:translate-x-6\\/12 {
    --transform-translate-x: 50%;
  }
  .md\\:translate-x-7\\/12 {
    --transform-translate-x: 58.333333%;
  }
  .md\\:translate-x-8\\/12 {
    --transform-translate-x: 66.666667%;
  }
  .md\\:translate-x-9\\/12 {
    --transform-translate-x: 75%;
  }
  .md\\:translate-x-10\\/12 {
    --transform-translate-x: 83.333333%;
  }
  .md\\:translate-x-11\\/12 {
    --transform-translate-x: 91.666667%;
  }
  .md\\:translate-x-full {
    --transform-translate-x: 100%;
  }
  .md\\:-translate-x-1 {
    --transform-translate-x: -0.25rem;
  }
  .md\\:-translate-x-2 {
    --transform-translate-x: -0.5rem;
  }
  .md\\:-translate-x-3 {
    --transform-translate-x: -0.75rem;
  }
  .md\\:-translate-x-4 {
    --transform-translate-x: -1rem;
  }
  .md\\:-translate-x-5 {
    --transform-translate-x: -1.25rem;
  }
  .md\\:-translate-x-6 {
    --transform-translate-x: -1.5rem;
  }
  .md\\:-translate-x-7 {
    --transform-translate-x: -1.75rem;
  }
  .md\\:-translate-x-8 {
    --transform-translate-x: -2rem;
  }
  .md\\:-translate-x-9 {
    --transform-translate-x: -2.25rem;
  }
  .md\\:-translate-x-10 {
    --transform-translate-x: -2.5rem;
  }
  .md\\:-translate-x-11 {
    --transform-translate-x: -2.75rem;
  }
  .md\\:-translate-x-12 {
    --transform-translate-x: -3rem;
  }
  .md\\:-translate-x-13 {
    --transform-translate-x: -3.25rem;
  }
  .md\\:-translate-x-14 {
    --transform-translate-x: -3.5rem;
  }
  .md\\:-translate-x-15 {
    --transform-translate-x: -3.75rem;
  }
  .md\\:-translate-x-16 {
    --transform-translate-x: -4rem;
  }
  .md\\:-translate-x-20 {
    --transform-translate-x: -5rem;
  }
  .md\\:-translate-x-24 {
    --transform-translate-x: -6rem;
  }
  .md\\:-translate-x-28 {
    --transform-translate-x: -7rem;
  }
  .md\\:-translate-x-32 {
    --transform-translate-x: -8rem;
  }
  .md\\:-translate-x-36 {
    --transform-translate-x: -9rem;
  }
  .md\\:-translate-x-40 {
    --transform-translate-x: -10rem;
  }
  .md\\:-translate-x-44 {
    --transform-translate-x: -11rem;
  }
  .md\\:-translate-x-48 {
    --transform-translate-x: -12rem;
  }
  .md\\:-translate-x-52 {
    --transform-translate-x: -13rem;
  }
  .md\\:-translate-x-56 {
    --transform-translate-x: -14rem;
  }
  .md\\:-translate-x-60 {
    --transform-translate-x: -15rem;
  }
  .md\\:-translate-x-64 {
    --transform-translate-x: -16rem;
  }
  .md\\:-translate-x-72 {
    --transform-translate-x: -18rem;
  }
  .md\\:-translate-x-80 {
    --transform-translate-x: -20rem;
  }
  .md\\:-translate-x-96 {
    --transform-translate-x: -24rem;
  }
  .md\\:-translate-x-px {
    --transform-translate-x: -1px;
  }
  .md\\:-translate-x-0\\.5 {
    --transform-translate-x: -0.125rem;
  }
  .md\\:-translate-x-1\\.5 {
    --transform-translate-x: -0.375rem;
  }
  .md\\:-translate-x-2\\.5 {
    --transform-translate-x: -0.625rem;
  }
  .md\\:-translate-x-3\\.5 {
    --transform-translate-x: -0.875rem;
  }
  .md\\:-translate-x-1\\/2 {
    --transform-translate-x: -50%;
  }
  .md\\:-translate-x-1\\/3 {
    --transform-translate-x: -33.33333%;
  }
  .md\\:-translate-x-2\\/3 {
    --transform-translate-x: -66.66667%;
  }
  .md\\:-translate-x-1\\/4 {
    --transform-translate-x: -25%;
  }
  .md\\:-translate-x-2\\/4 {
    --transform-translate-x: -50%;
  }
  .md\\:-translate-x-3\\/4 {
    --transform-translate-x: -75%;
  }
  .md\\:-translate-x-1\\/5 {
    --transform-translate-x: -20%;
  }
  .md\\:-translate-x-2\\/5 {
    --transform-translate-x: -40%;
  }
  .md\\:-translate-x-3\\/5 {
    --transform-translate-x: -60%;
  }
  .md\\:-translate-x-4\\/5 {
    --transform-translate-x: -80%;
  }
  .md\\:-translate-x-1\\/6 {
    --transform-translate-x: -16.66667%;
  }
  .md\\:-translate-x-2\\/6 {
    --transform-translate-x: -33.33333%;
  }
  .md\\:-translate-x-3\\/6 {
    --transform-translate-x: -50%;
  }
  .md\\:-translate-x-4\\/6 {
    --transform-translate-x: -66.66667%;
  }
  .md\\:-translate-x-5\\/6 {
    --transform-translate-x: -83.33333%;
  }
  .md\\:-translate-x-1\\/12 {
    --transform-translate-x: -8.33333%;
  }
  .md\\:-translate-x-2\\/12 {
    --transform-translate-x: -16.66667%;
  }
  .md\\:-translate-x-3\\/12 {
    --transform-translate-x: -25%;
  }
  .md\\:-translate-x-4\\/12 {
    --transform-translate-x: -33.33333%;
  }
  .md\\:-translate-x-5\\/12 {
    --transform-translate-x: -41.66667%;
  }
  .md\\:-translate-x-6\\/12 {
    --transform-translate-x: -50%;
  }
  .md\\:-translate-x-7\\/12 {
    --transform-translate-x: -58.33333%;
  }
  .md\\:-translate-x-8\\/12 {
    --transform-translate-x: -66.66667%;
  }
  .md\\:-translate-x-9\\/12 {
    --transform-translate-x: -75%;
  }
  .md\\:-translate-x-10\\/12 {
    --transform-translate-x: -83.33333%;
  }
  .md\\:-translate-x-11\\/12 {
    --transform-translate-x: -91.66667%;
  }
  .md\\:-translate-x-full {
    --transform-translate-x: -100%;
  }
  .md\\:translate-y-0 {
    --transform-translate-y: 0;
  }
  .md\\:translate-y-1 {
    --transform-translate-y: 0.25rem;
  }
  .md\\:translate-y-2 {
    --transform-translate-y: 0.5rem;
  }
  .md\\:translate-y-3 {
    --transform-translate-y: 0.75rem;
  }
  .md\\:translate-y-4 {
    --transform-translate-y: 1rem;
  }
  .md\\:translate-y-5 {
    --transform-translate-y: 1.25rem;
  }
  .md\\:translate-y-6 {
    --transform-translate-y: 1.5rem;
  }
  .md\\:translate-y-7 {
    --transform-translate-y: 1.75rem;
  }
  .md\\:translate-y-8 {
    --transform-translate-y: 2rem;
  }
  .md\\:translate-y-9 {
    --transform-translate-y: 2.25rem;
  }
  .md\\:translate-y-10 {
    --transform-translate-y: 2.5rem;
  }
  .md\\:translate-y-11 {
    --transform-translate-y: 2.75rem;
  }
  .md\\:translate-y-12 {
    --transform-translate-y: 3rem;
  }
  .md\\:translate-y-13 {
    --transform-translate-y: 3.25rem;
  }
  .md\\:translate-y-14 {
    --transform-translate-y: 3.5rem;
  }
  .md\\:translate-y-15 {
    --transform-translate-y: 3.75rem;
  }
  .md\\:translate-y-16 {
    --transform-translate-y: 4rem;
  }
  .md\\:translate-y-20 {
    --transform-translate-y: 5rem;
  }
  .md\\:translate-y-24 {
    --transform-translate-y: 6rem;
  }
  .md\\:translate-y-28 {
    --transform-translate-y: 7rem;
  }
  .md\\:translate-y-32 {
    --transform-translate-y: 8rem;
  }
  .md\\:translate-y-36 {
    --transform-translate-y: 9rem;
  }
  .md\\:translate-y-40 {
    --transform-translate-y: 10rem;
  }
  .md\\:translate-y-44 {
    --transform-translate-y: 11rem;
  }
  .md\\:translate-y-48 {
    --transform-translate-y: 12rem;
  }
  .md\\:translate-y-52 {
    --transform-translate-y: 13rem;
  }
  .md\\:translate-y-56 {
    --transform-translate-y: 14rem;
  }
  .md\\:translate-y-60 {
    --transform-translate-y: 15rem;
  }
  .md\\:translate-y-64 {
    --transform-translate-y: 16rem;
  }
  .md\\:translate-y-72 {
    --transform-translate-y: 18rem;
  }
  .md\\:translate-y-80 {
    --transform-translate-y: 20rem;
  }
  .md\\:translate-y-96 {
    --transform-translate-y: 24rem;
  }
  .md\\:translate-y-px {
    --transform-translate-y: 1px;
  }
  .md\\:translate-y-0\\.5 {
    --transform-translate-y: 0.125rem;
  }
  .md\\:translate-y-1\\.5 {
    --transform-translate-y: 0.375rem;
  }
  .md\\:translate-y-2\\.5 {
    --transform-translate-y: 0.625rem;
  }
  .md\\:translate-y-3\\.5 {
    --transform-translate-y: 0.875rem;
  }
  .md\\:translate-y-1\\/2 {
    --transform-translate-y: 50%;
  }
  .md\\:translate-y-1\\/3 {
    --transform-translate-y: 33.333333%;
  }
  .md\\:translate-y-2\\/3 {
    --transform-translate-y: 66.666667%;
  }
  .md\\:translate-y-1\\/4 {
    --transform-translate-y: 25%;
  }
  .md\\:translate-y-2\\/4 {
    --transform-translate-y: 50%;
  }
  .md\\:translate-y-3\\/4 {
    --transform-translate-y: 75%;
  }
  .md\\:translate-y-1\\/5 {
    --transform-translate-y: 20%;
  }
  .md\\:translate-y-2\\/5 {
    --transform-translate-y: 40%;
  }
  .md\\:translate-y-3\\/5 {
    --transform-translate-y: 60%;
  }
  .md\\:translate-y-4\\/5 {
    --transform-translate-y: 80%;
  }
  .md\\:translate-y-1\\/6 {
    --transform-translate-y: 16.666667%;
  }
  .md\\:translate-y-2\\/6 {
    --transform-translate-y: 33.333333%;
  }
  .md\\:translate-y-3\\/6 {
    --transform-translate-y: 50%;
  }
  .md\\:translate-y-4\\/6 {
    --transform-translate-y: 66.666667%;
  }
  .md\\:translate-y-5\\/6 {
    --transform-translate-y: 83.333333%;
  }
  .md\\:translate-y-1\\/12 {
    --transform-translate-y: 8.333333%;
  }
  .md\\:translate-y-2\\/12 {
    --transform-translate-y: 16.666667%;
  }
  .md\\:translate-y-3\\/12 {
    --transform-translate-y: 25%;
  }
  .md\\:translate-y-4\\/12 {
    --transform-translate-y: 33.333333%;
  }
  .md\\:translate-y-5\\/12 {
    --transform-translate-y: 41.666667%;
  }
  .md\\:translate-y-6\\/12 {
    --transform-translate-y: 50%;
  }
  .md\\:translate-y-7\\/12 {
    --transform-translate-y: 58.333333%;
  }
  .md\\:translate-y-8\\/12 {
    --transform-translate-y: 66.666667%;
  }
  .md\\:translate-y-9\\/12 {
    --transform-translate-y: 75%;
  }
  .md\\:translate-y-10\\/12 {
    --transform-translate-y: 83.333333%;
  }
  .md\\:translate-y-11\\/12 {
    --transform-translate-y: 91.666667%;
  }
  .md\\:translate-y-full {
    --transform-translate-y: 100%;
  }
  .md\\:-translate-y-1 {
    --transform-translate-y: -0.25rem;
  }
  .md\\:-translate-y-2 {
    --transform-translate-y: -0.5rem;
  }
  .md\\:-translate-y-3 {
    --transform-translate-y: -0.75rem;
  }
  .md\\:-translate-y-4 {
    --transform-translate-y: -1rem;
  }
  .md\\:-translate-y-5 {
    --transform-translate-y: -1.25rem;
  }
  .md\\:-translate-y-6 {
    --transform-translate-y: -1.5rem;
  }
  .md\\:-translate-y-7 {
    --transform-translate-y: -1.75rem;
  }
  .md\\:-translate-y-8 {
    --transform-translate-y: -2rem;
  }
  .md\\:-translate-y-9 {
    --transform-translate-y: -2.25rem;
  }
  .md\\:-translate-y-10 {
    --transform-translate-y: -2.5rem;
  }
  .md\\:-translate-y-11 {
    --transform-translate-y: -2.75rem;
  }
  .md\\:-translate-y-12 {
    --transform-translate-y: -3rem;
  }
  .md\\:-translate-y-13 {
    --transform-translate-y: -3.25rem;
  }
  .md\\:-translate-y-14 {
    --transform-translate-y: -3.5rem;
  }
  .md\\:-translate-y-15 {
    --transform-translate-y: -3.75rem;
  }
  .md\\:-translate-y-16 {
    --transform-translate-y: -4rem;
  }
  .md\\:-translate-y-20 {
    --transform-translate-y: -5rem;
  }
  .md\\:-translate-y-24 {
    --transform-translate-y: -6rem;
  }
  .md\\:-translate-y-28 {
    --transform-translate-y: -7rem;
  }
  .md\\:-translate-y-32 {
    --transform-translate-y: -8rem;
  }
  .md\\:-translate-y-36 {
    --transform-translate-y: -9rem;
  }
  .md\\:-translate-y-40 {
    --transform-translate-y: -10rem;
  }
  .md\\:-translate-y-44 {
    --transform-translate-y: -11rem;
  }
  .md\\:-translate-y-48 {
    --transform-translate-y: -12rem;
  }
  .md\\:-translate-y-52 {
    --transform-translate-y: -13rem;
  }
  .md\\:-translate-y-56 {
    --transform-translate-y: -14rem;
  }
  .md\\:-translate-y-60 {
    --transform-translate-y: -15rem;
  }
  .md\\:-translate-y-64 {
    --transform-translate-y: -16rem;
  }
  .md\\:-translate-y-72 {
    --transform-translate-y: -18rem;
  }
  .md\\:-translate-y-80 {
    --transform-translate-y: -20rem;
  }
  .md\\:-translate-y-96 {
    --transform-translate-y: -24rem;
  }
  .md\\:-translate-y-px {
    --transform-translate-y: -1px;
  }
  .md\\:-translate-y-0\\.5 {
    --transform-translate-y: -0.125rem;
  }
  .md\\:-translate-y-1\\.5 {
    --transform-translate-y: -0.375rem;
  }
  .md\\:-translate-y-2\\.5 {
    --transform-translate-y: -0.625rem;
  }
  .md\\:-translate-y-3\\.5 {
    --transform-translate-y: -0.875rem;
  }
  .md\\:-translate-y-1\\/2 {
    --transform-translate-y: -50%;
  }
  .md\\:-translate-y-1\\/3 {
    --transform-translate-y: -33.33333%;
  }
  .md\\:-translate-y-2\\/3 {
    --transform-translate-y: -66.66667%;
  }
  .md\\:-translate-y-1\\/4 {
    --transform-translate-y: -25%;
  }
  .md\\:-translate-y-2\\/4 {
    --transform-translate-y: -50%;
  }
  .md\\:-translate-y-3\\/4 {
    --transform-translate-y: -75%;
  }
  .md\\:-translate-y-1\\/5 {
    --transform-translate-y: -20%;
  }
  .md\\:-translate-y-2\\/5 {
    --transform-translate-y: -40%;
  }
  .md\\:-translate-y-3\\/5 {
    --transform-translate-y: -60%;
  }
  .md\\:-translate-y-4\\/5 {
    --transform-translate-y: -80%;
  }
  .md\\:-translate-y-1\\/6 {
    --transform-translate-y: -16.66667%;
  }
  .md\\:-translate-y-2\\/6 {
    --transform-translate-y: -33.33333%;
  }
  .md\\:-translate-y-3\\/6 {
    --transform-translate-y: -50%;
  }
  .md\\:-translate-y-4\\/6 {
    --transform-translate-y: -66.66667%;
  }
  .md\\:-translate-y-5\\/6 {
    --transform-translate-y: -83.33333%;
  }
  .md\\:-translate-y-1\\/12 {
    --transform-translate-y: -8.33333%;
  }
  .md\\:-translate-y-2\\/12 {
    --transform-translate-y: -16.66667%;
  }
  .md\\:-translate-y-3\\/12 {
    --transform-translate-y: -25%;
  }
  .md\\:-translate-y-4\\/12 {
    --transform-translate-y: -33.33333%;
  }
  .md\\:-translate-y-5\\/12 {
    --transform-translate-y: -41.66667%;
  }
  .md\\:-translate-y-6\\/12 {
    --transform-translate-y: -50%;
  }
  .md\\:-translate-y-7\\/12 {
    --transform-translate-y: -58.33333%;
  }
  .md\\:-translate-y-8\\/12 {
    --transform-translate-y: -66.66667%;
  }
  .md\\:-translate-y-9\\/12 {
    --transform-translate-y: -75%;
  }
  .md\\:-translate-y-10\\/12 {
    --transform-translate-y: -83.33333%;
  }
  .md\\:-translate-y-11\\/12 {
    --transform-translate-y: -91.66667%;
  }
  .md\\:-translate-y-full {
    --transform-translate-y: -100%;
  }
  .md\\:hover\\:translate-x-0:hover {
    --transform-translate-x: 0;
  }
  .md\\:hover\\:translate-x-1:hover {
    --transform-translate-x: 0.25rem;
  }
  .md\\:hover\\:translate-x-2:hover {
    --transform-translate-x: 0.5rem;
  }
  .md\\:hover\\:translate-x-3:hover {
    --transform-translate-x: 0.75rem;
  }
  .md\\:hover\\:translate-x-4:hover {
    --transform-translate-x: 1rem;
  }
  .md\\:hover\\:translate-x-5:hover {
    --transform-translate-x: 1.25rem;
  }
  .md\\:hover\\:translate-x-6:hover {
    --transform-translate-x: 1.5rem;
  }
  .md\\:hover\\:translate-x-7:hover {
    --transform-translate-x: 1.75rem;
  }
  .md\\:hover\\:translate-x-8:hover {
    --transform-translate-x: 2rem;
  }
  .md\\:hover\\:translate-x-9:hover {
    --transform-translate-x: 2.25rem;
  }
  .md\\:hover\\:translate-x-10:hover {
    --transform-translate-x: 2.5rem;
  }
  .md\\:hover\\:translate-x-11:hover {
    --transform-translate-x: 2.75rem;
  }
  .md\\:hover\\:translate-x-12:hover {
    --transform-translate-x: 3rem;
  }
  .md\\:hover\\:translate-x-13:hover {
    --transform-translate-x: 3.25rem;
  }
  .md\\:hover\\:translate-x-14:hover {
    --transform-translate-x: 3.5rem;
  }
  .md\\:hover\\:translate-x-15:hover {
    --transform-translate-x: 3.75rem;
  }
  .md\\:hover\\:translate-x-16:hover {
    --transform-translate-x: 4rem;
  }
  .md\\:hover\\:translate-x-20:hover {
    --transform-translate-x: 5rem;
  }
  .md\\:hover\\:translate-x-24:hover {
    --transform-translate-x: 6rem;
  }
  .md\\:hover\\:translate-x-28:hover {
    --transform-translate-x: 7rem;
  }
  .md\\:hover\\:translate-x-32:hover {
    --transform-translate-x: 8rem;
  }
  .md\\:hover\\:translate-x-36:hover {
    --transform-translate-x: 9rem;
  }
  .md\\:hover\\:translate-x-40:hover {
    --transform-translate-x: 10rem;
  }
  .md\\:hover\\:translate-x-44:hover {
    --transform-translate-x: 11rem;
  }
  .md\\:hover\\:translate-x-48:hover {
    --transform-translate-x: 12rem;
  }
  .md\\:hover\\:translate-x-52:hover {
    --transform-translate-x: 13rem;
  }
  .md\\:hover\\:translate-x-56:hover {
    --transform-translate-x: 14rem;
  }
  .md\\:hover\\:translate-x-60:hover {
    --transform-translate-x: 15rem;
  }
  .md\\:hover\\:translate-x-64:hover {
    --transform-translate-x: 16rem;
  }
  .md\\:hover\\:translate-x-72:hover {
    --transform-translate-x: 18rem;
  }
  .md\\:hover\\:translate-x-80:hover {
    --transform-translate-x: 20rem;
  }
  .md\\:hover\\:translate-x-96:hover {
    --transform-translate-x: 24rem;
  }
  .md\\:hover\\:translate-x-px:hover {
    --transform-translate-x: 1px;
  }
  .md\\:hover\\:translate-x-0\\.5:hover {
    --transform-translate-x: 0.125rem;
  }
  .md\\:hover\\:translate-x-1\\.5:hover {
    --transform-translate-x: 0.375rem;
  }
  .md\\:hover\\:translate-x-2\\.5:hover {
    --transform-translate-x: 0.625rem;
  }
  .md\\:hover\\:translate-x-3\\.5:hover {
    --transform-translate-x: 0.875rem;
  }
  .md\\:hover\\:translate-x-1\\/2:hover {
    --transform-translate-x: 50%;
  }
  .md\\:hover\\:translate-x-1\\/3:hover {
    --transform-translate-x: 33.333333%;
  }
  .md\\:hover\\:translate-x-2\\/3:hover {
    --transform-translate-x: 66.666667%;
  }
  .md\\:hover\\:translate-x-1\\/4:hover {
    --transform-translate-x: 25%;
  }
  .md\\:hover\\:translate-x-2\\/4:hover {
    --transform-translate-x: 50%;
  }
  .md\\:hover\\:translate-x-3\\/4:hover {
    --transform-translate-x: 75%;
  }
  .md\\:hover\\:translate-x-1\\/5:hover {
    --transform-translate-x: 20%;
  }
  .md\\:hover\\:translate-x-2\\/5:hover {
    --transform-translate-x: 40%;
  }
  .md\\:hover\\:translate-x-3\\/5:hover {
    --transform-translate-x: 60%;
  }
  .md\\:hover\\:translate-x-4\\/5:hover {
    --transform-translate-x: 80%;
  }
  .md\\:hover\\:translate-x-1\\/6:hover {
    --transform-translate-x: 16.666667%;
  }
  .md\\:hover\\:translate-x-2\\/6:hover {
    --transform-translate-x: 33.333333%;
  }
  .md\\:hover\\:translate-x-3\\/6:hover {
    --transform-translate-x: 50%;
  }
  .md\\:hover\\:translate-x-4\\/6:hover {
    --transform-translate-x: 66.666667%;
  }
  .md\\:hover\\:translate-x-5\\/6:hover {
    --transform-translate-x: 83.333333%;
  }
  .md\\:hover\\:translate-x-1\\/12:hover {
    --transform-translate-x: 8.333333%;
  }
  .md\\:hover\\:translate-x-2\\/12:hover {
    --transform-translate-x: 16.666667%;
  }
  .md\\:hover\\:translate-x-3\\/12:hover {
    --transform-translate-x: 25%;
  }
  .md\\:hover\\:translate-x-4\\/12:hover {
    --transform-translate-x: 33.333333%;
  }
  .md\\:hover\\:translate-x-5\\/12:hover {
    --transform-translate-x: 41.666667%;
  }
  .md\\:hover\\:translate-x-6\\/12:hover {
    --transform-translate-x: 50%;
  }
  .md\\:hover\\:translate-x-7\\/12:hover {
    --transform-translate-x: 58.333333%;
  }
  .md\\:hover\\:translate-x-8\\/12:hover {
    --transform-translate-x: 66.666667%;
  }
  .md\\:hover\\:translate-x-9\\/12:hover {
    --transform-translate-x: 75%;
  }
  .md\\:hover\\:translate-x-10\\/12:hover {
    --transform-translate-x: 83.333333%;
  }
  .md\\:hover\\:translate-x-11\\/12:hover {
    --transform-translate-x: 91.666667%;
  }
  .md\\:hover\\:translate-x-full:hover {
    --transform-translate-x: 100%;
  }
  .md\\:hover\\:-translate-x-1:hover {
    --transform-translate-x: -0.25rem;
  }
  .md\\:hover\\:-translate-x-2:hover {
    --transform-translate-x: -0.5rem;
  }
  .md\\:hover\\:-translate-x-3:hover {
    --transform-translate-x: -0.75rem;
  }
  .md\\:hover\\:-translate-x-4:hover {
    --transform-translate-x: -1rem;
  }
  .md\\:hover\\:-translate-x-5:hover {
    --transform-translate-x: -1.25rem;
  }
  .md\\:hover\\:-translate-x-6:hover {
    --transform-translate-x: -1.5rem;
  }
  .md\\:hover\\:-translate-x-7:hover {
    --transform-translate-x: -1.75rem;
  }
  .md\\:hover\\:-translate-x-8:hover {
    --transform-translate-x: -2rem;
  }
  .md\\:hover\\:-translate-x-9:hover {
    --transform-translate-x: -2.25rem;
  }
  .md\\:hover\\:-translate-x-10:hover {
    --transform-translate-x: -2.5rem;
  }
  .md\\:hover\\:-translate-x-11:hover {
    --transform-translate-x: -2.75rem;
  }
  .md\\:hover\\:-translate-x-12:hover {
    --transform-translate-x: -3rem;
  }
  .md\\:hover\\:-translate-x-13:hover {
    --transform-translate-x: -3.25rem;
  }
  .md\\:hover\\:-translate-x-14:hover {
    --transform-translate-x: -3.5rem;
  }
  .md\\:hover\\:-translate-x-15:hover {
    --transform-translate-x: -3.75rem;
  }
  .md\\:hover\\:-translate-x-16:hover {
    --transform-translate-x: -4rem;
  }
  .md\\:hover\\:-translate-x-20:hover {
    --transform-translate-x: -5rem;
  }
  .md\\:hover\\:-translate-x-24:hover {
    --transform-translate-x: -6rem;
  }
  .md\\:hover\\:-translate-x-28:hover {
    --transform-translate-x: -7rem;
  }
  .md\\:hover\\:-translate-x-32:hover {
    --transform-translate-x: -8rem;
  }
  .md\\:hover\\:-translate-x-36:hover {
    --transform-translate-x: -9rem;
  }
  .md\\:hover\\:-translate-x-40:hover {
    --transform-translate-x: -10rem;
  }
  .md\\:hover\\:-translate-x-44:hover {
    --transform-translate-x: -11rem;
  }
  .md\\:hover\\:-translate-x-48:hover {
    --transform-translate-x: -12rem;
  }
  .md\\:hover\\:-translate-x-52:hover {
    --transform-translate-x: -13rem;
  }
  .md\\:hover\\:-translate-x-56:hover {
    --transform-translate-x: -14rem;
  }
  .md\\:hover\\:-translate-x-60:hover {
    --transform-translate-x: -15rem;
  }
  .md\\:hover\\:-translate-x-64:hover {
    --transform-translate-x: -16rem;
  }
  .md\\:hover\\:-translate-x-72:hover {
    --transform-translate-x: -18rem;
  }
  .md\\:hover\\:-translate-x-80:hover {
    --transform-translate-x: -20rem;
  }
  .md\\:hover\\:-translate-x-96:hover {
    --transform-translate-x: -24rem;
  }
  .md\\:hover\\:-translate-x-px:hover {
    --transform-translate-x: -1px;
  }
  .md\\:hover\\:-translate-x-0\\.5:hover {
    --transform-translate-x: -0.125rem;
  }
  .md\\:hover\\:-translate-x-1\\.5:hover {
    --transform-translate-x: -0.375rem;
  }
  .md\\:hover\\:-translate-x-2\\.5:hover {
    --transform-translate-x: -0.625rem;
  }
  .md\\:hover\\:-translate-x-3\\.5:hover {
    --transform-translate-x: -0.875rem;
  }
  .md\\:hover\\:-translate-x-1\\/2:hover {
    --transform-translate-x: -50%;
  }
  .md\\:hover\\:-translate-x-1\\/3:hover {
    --transform-translate-x: -33.33333%;
  }
  .md\\:hover\\:-translate-x-2\\/3:hover {
    --transform-translate-x: -66.66667%;
  }
  .md\\:hover\\:-translate-x-1\\/4:hover {
    --transform-translate-x: -25%;
  }
  .md\\:hover\\:-translate-x-2\\/4:hover {
    --transform-translate-x: -50%;
  }
  .md\\:hover\\:-translate-x-3\\/4:hover {
    --transform-translate-x: -75%;
  }
  .md\\:hover\\:-translate-x-1\\/5:hover {
    --transform-translate-x: -20%;
  }
  .md\\:hover\\:-translate-x-2\\/5:hover {
    --transform-translate-x: -40%;
  }
  .md\\:hover\\:-translate-x-3\\/5:hover {
    --transform-translate-x: -60%;
  }
  .md\\:hover\\:-translate-x-4\\/5:hover {
    --transform-translate-x: -80%;
  }
  .md\\:hover\\:-translate-x-1\\/6:hover {
    --transform-translate-x: -16.66667%;
  }
  .md\\:hover\\:-translate-x-2\\/6:hover {
    --transform-translate-x: -33.33333%;
  }
  .md\\:hover\\:-translate-x-3\\/6:hover {
    --transform-translate-x: -50%;
  }
  .md\\:hover\\:-translate-x-4\\/6:hover {
    --transform-translate-x: -66.66667%;
  }
  .md\\:hover\\:-translate-x-5\\/6:hover {
    --transform-translate-x: -83.33333%;
  }
  .md\\:hover\\:-translate-x-1\\/12:hover {
    --transform-translate-x: -8.33333%;
  }
  .md\\:hover\\:-translate-x-2\\/12:hover {
    --transform-translate-x: -16.66667%;
  }
  .md\\:hover\\:-translate-x-3\\/12:hover {
    --transform-translate-x: -25%;
  }
  .md\\:hover\\:-translate-x-4\\/12:hover {
    --transform-translate-x: -33.33333%;
  }
  .md\\:hover\\:-translate-x-5\\/12:hover {
    --transform-translate-x: -41.66667%;
  }
  .md\\:hover\\:-translate-x-6\\/12:hover {
    --transform-translate-x: -50%;
  }
  .md\\:hover\\:-translate-x-7\\/12:hover {
    --transform-translate-x: -58.33333%;
  }
  .md\\:hover\\:-translate-x-8\\/12:hover {
    --transform-translate-x: -66.66667%;
  }
  .md\\:hover\\:-translate-x-9\\/12:hover {
    --transform-translate-x: -75%;
  }
  .md\\:hover\\:-translate-x-10\\/12:hover {
    --transform-translate-x: -83.33333%;
  }
  .md\\:hover\\:-translate-x-11\\/12:hover {
    --transform-translate-x: -91.66667%;
  }
  .md\\:hover\\:-translate-x-full:hover {
    --transform-translate-x: -100%;
  }
  .md\\:hover\\:translate-y-0:hover {
    --transform-translate-y: 0;
  }
  .md\\:hover\\:translate-y-1:hover {
    --transform-translate-y: 0.25rem;
  }
  .md\\:hover\\:translate-y-2:hover {
    --transform-translate-y: 0.5rem;
  }
  .md\\:hover\\:translate-y-3:hover {
    --transform-translate-y: 0.75rem;
  }
  .md\\:hover\\:translate-y-4:hover {
    --transform-translate-y: 1rem;
  }
  .md\\:hover\\:translate-y-5:hover {
    --transform-translate-y: 1.25rem;
  }
  .md\\:hover\\:translate-y-6:hover {
    --transform-translate-y: 1.5rem;
  }
  .md\\:hover\\:translate-y-7:hover {
    --transform-translate-y: 1.75rem;
  }
  .md\\:hover\\:translate-y-8:hover {
    --transform-translate-y: 2rem;
  }
  .md\\:hover\\:translate-y-9:hover {
    --transform-translate-y: 2.25rem;
  }
  .md\\:hover\\:translate-y-10:hover {
    --transform-translate-y: 2.5rem;
  }
  .md\\:hover\\:translate-y-11:hover {
    --transform-translate-y: 2.75rem;
  }
  .md\\:hover\\:translate-y-12:hover {
    --transform-translate-y: 3rem;
  }
  .md\\:hover\\:translate-y-13:hover {
    --transform-translate-y: 3.25rem;
  }
  .md\\:hover\\:translate-y-14:hover {
    --transform-translate-y: 3.5rem;
  }
  .md\\:hover\\:translate-y-15:hover {
    --transform-translate-y: 3.75rem;
  }
  .md\\:hover\\:translate-y-16:hover {
    --transform-translate-y: 4rem;
  }
  .md\\:hover\\:translate-y-20:hover {
    --transform-translate-y: 5rem;
  }
  .md\\:hover\\:translate-y-24:hover {
    --transform-translate-y: 6rem;
  }
  .md\\:hover\\:translate-y-28:hover {
    --transform-translate-y: 7rem;
  }
  .md\\:hover\\:translate-y-32:hover {
    --transform-translate-y: 8rem;
  }
  .md\\:hover\\:translate-y-36:hover {
    --transform-translate-y: 9rem;
  }
  .md\\:hover\\:translate-y-40:hover {
    --transform-translate-y: 10rem;
  }
  .md\\:hover\\:translate-y-44:hover {
    --transform-translate-y: 11rem;
  }
  .md\\:hover\\:translate-y-48:hover {
    --transform-translate-y: 12rem;
  }
  .md\\:hover\\:translate-y-52:hover {
    --transform-translate-y: 13rem;
  }
  .md\\:hover\\:translate-y-56:hover {
    --transform-translate-y: 14rem;
  }
  .md\\:hover\\:translate-y-60:hover {
    --transform-translate-y: 15rem;
  }
  .md\\:hover\\:translate-y-64:hover {
    --transform-translate-y: 16rem;
  }
  .md\\:hover\\:translate-y-72:hover {
    --transform-translate-y: 18rem;
  }
  .md\\:hover\\:translate-y-80:hover {
    --transform-translate-y: 20rem;
  }
  .md\\:hover\\:translate-y-96:hover {
    --transform-translate-y: 24rem;
  }
  .md\\:hover\\:translate-y-px:hover {
    --transform-translate-y: 1px;
  }
  .md\\:hover\\:translate-y-0\\.5:hover {
    --transform-translate-y: 0.125rem;
  }
  .md\\:hover\\:translate-y-1\\.5:hover {
    --transform-translate-y: 0.375rem;
  }
  .md\\:hover\\:translate-y-2\\.5:hover {
    --transform-translate-y: 0.625rem;
  }
  .md\\:hover\\:translate-y-3\\.5:hover {
    --transform-translate-y: 0.875rem;
  }
  .md\\:hover\\:translate-y-1\\/2:hover {
    --transform-translate-y: 50%;
  }
  .md\\:hover\\:translate-y-1\\/3:hover {
    --transform-translate-y: 33.333333%;
  }
  .md\\:hover\\:translate-y-2\\/3:hover {
    --transform-translate-y: 66.666667%;
  }
  .md\\:hover\\:translate-y-1\\/4:hover {
    --transform-translate-y: 25%;
  }
  .md\\:hover\\:translate-y-2\\/4:hover {
    --transform-translate-y: 50%;
  }
  .md\\:hover\\:translate-y-3\\/4:hover {
    --transform-translate-y: 75%;
  }
  .md\\:hover\\:translate-y-1\\/5:hover {
    --transform-translate-y: 20%;
  }
  .md\\:hover\\:translate-y-2\\/5:hover {
    --transform-translate-y: 40%;
  }
  .md\\:hover\\:translate-y-3\\/5:hover {
    --transform-translate-y: 60%;
  }
  .md\\:hover\\:translate-y-4\\/5:hover {
    --transform-translate-y: 80%;
  }
  .md\\:hover\\:translate-y-1\\/6:hover {
    --transform-translate-y: 16.666667%;
  }
  .md\\:hover\\:translate-y-2\\/6:hover {
    --transform-translate-y: 33.333333%;
  }
  .md\\:hover\\:translate-y-3\\/6:hover {
    --transform-translate-y: 50%;
  }
  .md\\:hover\\:translate-y-4\\/6:hover {
    --transform-translate-y: 66.666667%;
  }
  .md\\:hover\\:translate-y-5\\/6:hover {
    --transform-translate-y: 83.333333%;
  }
  .md\\:hover\\:translate-y-1\\/12:hover {
    --transform-translate-y: 8.333333%;
  }
  .md\\:hover\\:translate-y-2\\/12:hover {
    --transform-translate-y: 16.666667%;
  }
  .md\\:hover\\:translate-y-3\\/12:hover {
    --transform-translate-y: 25%;
  }
  .md\\:hover\\:translate-y-4\\/12:hover {
    --transform-translate-y: 33.333333%;
  }
  .md\\:hover\\:translate-y-5\\/12:hover {
    --transform-translate-y: 41.666667%;
  }
  .md\\:hover\\:translate-y-6\\/12:hover {
    --transform-translate-y: 50%;
  }
  .md\\:hover\\:translate-y-7\\/12:hover {
    --transform-translate-y: 58.333333%;
  }
  .md\\:hover\\:translate-y-8\\/12:hover {
    --transform-translate-y: 66.666667%;
  }
  .md\\:hover\\:translate-y-9\\/12:hover {
    --transform-translate-y: 75%;
  }
  .md\\:hover\\:translate-y-10\\/12:hover {
    --transform-translate-y: 83.333333%;
  }
  .md\\:hover\\:translate-y-11\\/12:hover {
    --transform-translate-y: 91.666667%;
  }
  .md\\:hover\\:translate-y-full:hover {
    --transform-translate-y: 100%;
  }
  .md\\:hover\\:-translate-y-1:hover {
    --transform-translate-y: -0.25rem;
  }
  .md\\:hover\\:-translate-y-2:hover {
    --transform-translate-y: -0.5rem;
  }
  .md\\:hover\\:-translate-y-3:hover {
    --transform-translate-y: -0.75rem;
  }
  .md\\:hover\\:-translate-y-4:hover {
    --transform-translate-y: -1rem;
  }
  .md\\:hover\\:-translate-y-5:hover {
    --transform-translate-y: -1.25rem;
  }
  .md\\:hover\\:-translate-y-6:hover {
    --transform-translate-y: -1.5rem;
  }
  .md\\:hover\\:-translate-y-7:hover {
    --transform-translate-y: -1.75rem;
  }
  .md\\:hover\\:-translate-y-8:hover {
    --transform-translate-y: -2rem;
  }
  .md\\:hover\\:-translate-y-9:hover {
    --transform-translate-y: -2.25rem;
  }
  .md\\:hover\\:-translate-y-10:hover {
    --transform-translate-y: -2.5rem;
  }
  .md\\:hover\\:-translate-y-11:hover {
    --transform-translate-y: -2.75rem;
  }
  .md\\:hover\\:-translate-y-12:hover {
    --transform-translate-y: -3rem;
  }
  .md\\:hover\\:-translate-y-13:hover {
    --transform-translate-y: -3.25rem;
  }
  .md\\:hover\\:-translate-y-14:hover {
    --transform-translate-y: -3.5rem;
  }
  .md\\:hover\\:-translate-y-15:hover {
    --transform-translate-y: -3.75rem;
  }
  .md\\:hover\\:-translate-y-16:hover {
    --transform-translate-y: -4rem;
  }
  .md\\:hover\\:-translate-y-20:hover {
    --transform-translate-y: -5rem;
  }
  .md\\:hover\\:-translate-y-24:hover {
    --transform-translate-y: -6rem;
  }
  .md\\:hover\\:-translate-y-28:hover {
    --transform-translate-y: -7rem;
  }
  .md\\:hover\\:-translate-y-32:hover {
    --transform-translate-y: -8rem;
  }
  .md\\:hover\\:-translate-y-36:hover {
    --transform-translate-y: -9rem;
  }
  .md\\:hover\\:-translate-y-40:hover {
    --transform-translate-y: -10rem;
  }
  .md\\:hover\\:-translate-y-44:hover {
    --transform-translate-y: -11rem;
  }
  .md\\:hover\\:-translate-y-48:hover {
    --transform-translate-y: -12rem;
  }
  .md\\:hover\\:-translate-y-52:hover {
    --transform-translate-y: -13rem;
  }
  .md\\:hover\\:-translate-y-56:hover {
    --transform-translate-y: -14rem;
  }
  .md\\:hover\\:-translate-y-60:hover {
    --transform-translate-y: -15rem;
  }
  .md\\:hover\\:-translate-y-64:hover {
    --transform-translate-y: -16rem;
  }
  .md\\:hover\\:-translate-y-72:hover {
    --transform-translate-y: -18rem;
  }
  .md\\:hover\\:-translate-y-80:hover {
    --transform-translate-y: -20rem;
  }
  .md\\:hover\\:-translate-y-96:hover {
    --transform-translate-y: -24rem;
  }
  .md\\:hover\\:-translate-y-px:hover {
    --transform-translate-y: -1px;
  }
  .md\\:hover\\:-translate-y-0\\.5:hover {
    --transform-translate-y: -0.125rem;
  }
  .md\\:hover\\:-translate-y-1\\.5:hover {
    --transform-translate-y: -0.375rem;
  }
  .md\\:hover\\:-translate-y-2\\.5:hover {
    --transform-translate-y: -0.625rem;
  }
  .md\\:hover\\:-translate-y-3\\.5:hover {
    --transform-translate-y: -0.875rem;
  }
  .md\\:hover\\:-translate-y-1\\/2:hover {
    --transform-translate-y: -50%;
  }
  .md\\:hover\\:-translate-y-1\\/3:hover {
    --transform-translate-y: -33.33333%;
  }
  .md\\:hover\\:-translate-y-2\\/3:hover {
    --transform-translate-y: -66.66667%;
  }
  .md\\:hover\\:-translate-y-1\\/4:hover {
    --transform-translate-y: -25%;
  }
  .md\\:hover\\:-translate-y-2\\/4:hover {
    --transform-translate-y: -50%;
  }
  .md\\:hover\\:-translate-y-3\\/4:hover {
    --transform-translate-y: -75%;
  }
  .md\\:hover\\:-translate-y-1\\/5:hover {
    --transform-translate-y: -20%;
  }
  .md\\:hover\\:-translate-y-2\\/5:hover {
    --transform-translate-y: -40%;
  }
  .md\\:hover\\:-translate-y-3\\/5:hover {
    --transform-translate-y: -60%;
  }
  .md\\:hover\\:-translate-y-4\\/5:hover {
    --transform-translate-y: -80%;
  }
  .md\\:hover\\:-translate-y-1\\/6:hover {
    --transform-translate-y: -16.66667%;
  }
  .md\\:hover\\:-translate-y-2\\/6:hover {
    --transform-translate-y: -33.33333%;
  }
  .md\\:hover\\:-translate-y-3\\/6:hover {
    --transform-translate-y: -50%;
  }
  .md\\:hover\\:-translate-y-4\\/6:hover {
    --transform-translate-y: -66.66667%;
  }
  .md\\:hover\\:-translate-y-5\\/6:hover {
    --transform-translate-y: -83.33333%;
  }
  .md\\:hover\\:-translate-y-1\\/12:hover {
    --transform-translate-y: -8.33333%;
  }
  .md\\:hover\\:-translate-y-2\\/12:hover {
    --transform-translate-y: -16.66667%;
  }
  .md\\:hover\\:-translate-y-3\\/12:hover {
    --transform-translate-y: -25%;
  }
  .md\\:hover\\:-translate-y-4\\/12:hover {
    --transform-translate-y: -33.33333%;
  }
  .md\\:hover\\:-translate-y-5\\/12:hover {
    --transform-translate-y: -41.66667%;
  }
  .md\\:hover\\:-translate-y-6\\/12:hover {
    --transform-translate-y: -50%;
  }
  .md\\:hover\\:-translate-y-7\\/12:hover {
    --transform-translate-y: -58.33333%;
  }
  .md\\:hover\\:-translate-y-8\\/12:hover {
    --transform-translate-y: -66.66667%;
  }
  .md\\:hover\\:-translate-y-9\\/12:hover {
    --transform-translate-y: -75%;
  }
  .md\\:hover\\:-translate-y-10\\/12:hover {
    --transform-translate-y: -83.33333%;
  }
  .md\\:hover\\:-translate-y-11\\/12:hover {
    --transform-translate-y: -91.66667%;
  }
  .md\\:hover\\:-translate-y-full:hover {
    --transform-translate-y: -100%;
  }
  .md\\:focus\\:translate-x-0:focus {
    --transform-translate-x: 0;
  }
  .md\\:focus\\:translate-x-1:focus {
    --transform-translate-x: 0.25rem;
  }
  .md\\:focus\\:translate-x-2:focus {
    --transform-translate-x: 0.5rem;
  }
  .md\\:focus\\:translate-x-3:focus {
    --transform-translate-x: 0.75rem;
  }
  .md\\:focus\\:translate-x-4:focus {
    --transform-translate-x: 1rem;
  }
  .md\\:focus\\:translate-x-5:focus {
    --transform-translate-x: 1.25rem;
  }
  .md\\:focus\\:translate-x-6:focus {
    --transform-translate-x: 1.5rem;
  }
  .md\\:focus\\:translate-x-7:focus {
    --transform-translate-x: 1.75rem;
  }
  .md\\:focus\\:translate-x-8:focus {
    --transform-translate-x: 2rem;
  }
  .md\\:focus\\:translate-x-9:focus {
    --transform-translate-x: 2.25rem;
  }
  .md\\:focus\\:translate-x-10:focus {
    --transform-translate-x: 2.5rem;
  }
  .md\\:focus\\:translate-x-11:focus {
    --transform-translate-x: 2.75rem;
  }
  .md\\:focus\\:translate-x-12:focus {
    --transform-translate-x: 3rem;
  }
  .md\\:focus\\:translate-x-13:focus {
    --transform-translate-x: 3.25rem;
  }
  .md\\:focus\\:translate-x-14:focus {
    --transform-translate-x: 3.5rem;
  }
  .md\\:focus\\:translate-x-15:focus {
    --transform-translate-x: 3.75rem;
  }
  .md\\:focus\\:translate-x-16:focus {
    --transform-translate-x: 4rem;
  }
  .md\\:focus\\:translate-x-20:focus {
    --transform-translate-x: 5rem;
  }
  .md\\:focus\\:translate-x-24:focus {
    --transform-translate-x: 6rem;
  }
  .md\\:focus\\:translate-x-28:focus {
    --transform-translate-x: 7rem;
  }
  .md\\:focus\\:translate-x-32:focus {
    --transform-translate-x: 8rem;
  }
  .md\\:focus\\:translate-x-36:focus {
    --transform-translate-x: 9rem;
  }
  .md\\:focus\\:translate-x-40:focus {
    --transform-translate-x: 10rem;
  }
  .md\\:focus\\:translate-x-44:focus {
    --transform-translate-x: 11rem;
  }
  .md\\:focus\\:translate-x-48:focus {
    --transform-translate-x: 12rem;
  }
  .md\\:focus\\:translate-x-52:focus {
    --transform-translate-x: 13rem;
  }
  .md\\:focus\\:translate-x-56:focus {
    --transform-translate-x: 14rem;
  }
  .md\\:focus\\:translate-x-60:focus {
    --transform-translate-x: 15rem;
  }
  .md\\:focus\\:translate-x-64:focus {
    --transform-translate-x: 16rem;
  }
  .md\\:focus\\:translate-x-72:focus {
    --transform-translate-x: 18rem;
  }
  .md\\:focus\\:translate-x-80:focus {
    --transform-translate-x: 20rem;
  }
  .md\\:focus\\:translate-x-96:focus {
    --transform-translate-x: 24rem;
  }
  .md\\:focus\\:translate-x-px:focus {
    --transform-translate-x: 1px;
  }
  .md\\:focus\\:translate-x-0\\.5:focus {
    --transform-translate-x: 0.125rem;
  }
  .md\\:focus\\:translate-x-1\\.5:focus {
    --transform-translate-x: 0.375rem;
  }
  .md\\:focus\\:translate-x-2\\.5:focus {
    --transform-translate-x: 0.625rem;
  }
  .md\\:focus\\:translate-x-3\\.5:focus {
    --transform-translate-x: 0.875rem;
  }
  .md\\:focus\\:translate-x-1\\/2:focus {
    --transform-translate-x: 50%;
  }
  .md\\:focus\\:translate-x-1\\/3:focus {
    --transform-translate-x: 33.333333%;
  }
  .md\\:focus\\:translate-x-2\\/3:focus {
    --transform-translate-x: 66.666667%;
  }
  .md\\:focus\\:translate-x-1\\/4:focus {
    --transform-translate-x: 25%;
  }
  .md\\:focus\\:translate-x-2\\/4:focus {
    --transform-translate-x: 50%;
  }
  .md\\:focus\\:translate-x-3\\/4:focus {
    --transform-translate-x: 75%;
  }
  .md\\:focus\\:translate-x-1\\/5:focus {
    --transform-translate-x: 20%;
  }
  .md\\:focus\\:translate-x-2\\/5:focus {
    --transform-translate-x: 40%;
  }
  .md\\:focus\\:translate-x-3\\/5:focus {
    --transform-translate-x: 60%;
  }
  .md\\:focus\\:translate-x-4\\/5:focus {
    --transform-translate-x: 80%;
  }
  .md\\:focus\\:translate-x-1\\/6:focus {
    --transform-translate-x: 16.666667%;
  }
  .md\\:focus\\:translate-x-2\\/6:focus {
    --transform-translate-x: 33.333333%;
  }
  .md\\:focus\\:translate-x-3\\/6:focus {
    --transform-translate-x: 50%;
  }
  .md\\:focus\\:translate-x-4\\/6:focus {
    --transform-translate-x: 66.666667%;
  }
  .md\\:focus\\:translate-x-5\\/6:focus {
    --transform-translate-x: 83.333333%;
  }
  .md\\:focus\\:translate-x-1\\/12:focus {
    --transform-translate-x: 8.333333%;
  }
  .md\\:focus\\:translate-x-2\\/12:focus {
    --transform-translate-x: 16.666667%;
  }
  .md\\:focus\\:translate-x-3\\/12:focus {
    --transform-translate-x: 25%;
  }
  .md\\:focus\\:translate-x-4\\/12:focus {
    --transform-translate-x: 33.333333%;
  }
  .md\\:focus\\:translate-x-5\\/12:focus {
    --transform-translate-x: 41.666667%;
  }
  .md\\:focus\\:translate-x-6\\/12:focus {
    --transform-translate-x: 50%;
  }
  .md\\:focus\\:translate-x-7\\/12:focus {
    --transform-translate-x: 58.333333%;
  }
  .md\\:focus\\:translate-x-8\\/12:focus {
    --transform-translate-x: 66.666667%;
  }
  .md\\:focus\\:translate-x-9\\/12:focus {
    --transform-translate-x: 75%;
  }
  .md\\:focus\\:translate-x-10\\/12:focus {
    --transform-translate-x: 83.333333%;
  }
  .md\\:focus\\:translate-x-11\\/12:focus {
    --transform-translate-x: 91.666667%;
  }
  .md\\:focus\\:translate-x-full:focus {
    --transform-translate-x: 100%;
  }
  .md\\:focus\\:-translate-x-1:focus {
    --transform-translate-x: -0.25rem;
  }
  .md\\:focus\\:-translate-x-2:focus {
    --transform-translate-x: -0.5rem;
  }
  .md\\:focus\\:-translate-x-3:focus {
    --transform-translate-x: -0.75rem;
  }
  .md\\:focus\\:-translate-x-4:focus {
    --transform-translate-x: -1rem;
  }
  .md\\:focus\\:-translate-x-5:focus {
    --transform-translate-x: -1.25rem;
  }
  .md\\:focus\\:-translate-x-6:focus {
    --transform-translate-x: -1.5rem;
  }
  .md\\:focus\\:-translate-x-7:focus {
    --transform-translate-x: -1.75rem;
  }
  .md\\:focus\\:-translate-x-8:focus {
    --transform-translate-x: -2rem;
  }
  .md\\:focus\\:-translate-x-9:focus {
    --transform-translate-x: -2.25rem;
  }
  .md\\:focus\\:-translate-x-10:focus {
    --transform-translate-x: -2.5rem;
  }
  .md\\:focus\\:-translate-x-11:focus {
    --transform-translate-x: -2.75rem;
  }
  .md\\:focus\\:-translate-x-12:focus {
    --transform-translate-x: -3rem;
  }
  .md\\:focus\\:-translate-x-13:focus {
    --transform-translate-x: -3.25rem;
  }
  .md\\:focus\\:-translate-x-14:focus {
    --transform-translate-x: -3.5rem;
  }
  .md\\:focus\\:-translate-x-15:focus {
    --transform-translate-x: -3.75rem;
  }
  .md\\:focus\\:-translate-x-16:focus {
    --transform-translate-x: -4rem;
  }
  .md\\:focus\\:-translate-x-20:focus {
    --transform-translate-x: -5rem;
  }
  .md\\:focus\\:-translate-x-24:focus {
    --transform-translate-x: -6rem;
  }
  .md\\:focus\\:-translate-x-28:focus {
    --transform-translate-x: -7rem;
  }
  .md\\:focus\\:-translate-x-32:focus {
    --transform-translate-x: -8rem;
  }
  .md\\:focus\\:-translate-x-36:focus {
    --transform-translate-x: -9rem;
  }
  .md\\:focus\\:-translate-x-40:focus {
    --transform-translate-x: -10rem;
  }
  .md\\:focus\\:-translate-x-44:focus {
    --transform-translate-x: -11rem;
  }
  .md\\:focus\\:-translate-x-48:focus {
    --transform-translate-x: -12rem;
  }
  .md\\:focus\\:-translate-x-52:focus {
    --transform-translate-x: -13rem;
  }
  .md\\:focus\\:-translate-x-56:focus {
    --transform-translate-x: -14rem;
  }
  .md\\:focus\\:-translate-x-60:focus {
    --transform-translate-x: -15rem;
  }
  .md\\:focus\\:-translate-x-64:focus {
    --transform-translate-x: -16rem;
  }
  .md\\:focus\\:-translate-x-72:focus {
    --transform-translate-x: -18rem;
  }
  .md\\:focus\\:-translate-x-80:focus {
    --transform-translate-x: -20rem;
  }
  .md\\:focus\\:-translate-x-96:focus {
    --transform-translate-x: -24rem;
  }
  .md\\:focus\\:-translate-x-px:focus {
    --transform-translate-x: -1px;
  }
  .md\\:focus\\:-translate-x-0\\.5:focus {
    --transform-translate-x: -0.125rem;
  }
  .md\\:focus\\:-translate-x-1\\.5:focus {
    --transform-translate-x: -0.375rem;
  }
  .md\\:focus\\:-translate-x-2\\.5:focus {
    --transform-translate-x: -0.625rem;
  }
  .md\\:focus\\:-translate-x-3\\.5:focus {
    --transform-translate-x: -0.875rem;
  }
  .md\\:focus\\:-translate-x-1\\/2:focus {
    --transform-translate-x: -50%;
  }
  .md\\:focus\\:-translate-x-1\\/3:focus {
    --transform-translate-x: -33.33333%;
  }
  .md\\:focus\\:-translate-x-2\\/3:focus {
    --transform-translate-x: -66.66667%;
  }
  .md\\:focus\\:-translate-x-1\\/4:focus {
    --transform-translate-x: -25%;
  }
  .md\\:focus\\:-translate-x-2\\/4:focus {
    --transform-translate-x: -50%;
  }
  .md\\:focus\\:-translate-x-3\\/4:focus {
    --transform-translate-x: -75%;
  }
  .md\\:focus\\:-translate-x-1\\/5:focus {
    --transform-translate-x: -20%;
  }
  .md\\:focus\\:-translate-x-2\\/5:focus {
    --transform-translate-x: -40%;
  }
  .md\\:focus\\:-translate-x-3\\/5:focus {
    --transform-translate-x: -60%;
  }
  .md\\:focus\\:-translate-x-4\\/5:focus {
    --transform-translate-x: -80%;
  }
  .md\\:focus\\:-translate-x-1\\/6:focus {
    --transform-translate-x: -16.66667%;
  }
  .md\\:focus\\:-translate-x-2\\/6:focus {
    --transform-translate-x: -33.33333%;
  }
  .md\\:focus\\:-translate-x-3\\/6:focus {
    --transform-translate-x: -50%;
  }
  .md\\:focus\\:-translate-x-4\\/6:focus {
    --transform-translate-x: -66.66667%;
  }
  .md\\:focus\\:-translate-x-5\\/6:focus {
    --transform-translate-x: -83.33333%;
  }
  .md\\:focus\\:-translate-x-1\\/12:focus {
    --transform-translate-x: -8.33333%;
  }
  .md\\:focus\\:-translate-x-2\\/12:focus {
    --transform-translate-x: -16.66667%;
  }
  .md\\:focus\\:-translate-x-3\\/12:focus {
    --transform-translate-x: -25%;
  }
  .md\\:focus\\:-translate-x-4\\/12:focus {
    --transform-translate-x: -33.33333%;
  }
  .md\\:focus\\:-translate-x-5\\/12:focus {
    --transform-translate-x: -41.66667%;
  }
  .md\\:focus\\:-translate-x-6\\/12:focus {
    --transform-translate-x: -50%;
  }
  .md\\:focus\\:-translate-x-7\\/12:focus {
    --transform-translate-x: -58.33333%;
  }
  .md\\:focus\\:-translate-x-8\\/12:focus {
    --transform-translate-x: -66.66667%;
  }
  .md\\:focus\\:-translate-x-9\\/12:focus {
    --transform-translate-x: -75%;
  }
  .md\\:focus\\:-translate-x-10\\/12:focus {
    --transform-translate-x: -83.33333%;
  }
  .md\\:focus\\:-translate-x-11\\/12:focus {
    --transform-translate-x: -91.66667%;
  }
  .md\\:focus\\:-translate-x-full:focus {
    --transform-translate-x: -100%;
  }
  .md\\:focus\\:translate-y-0:focus {
    --transform-translate-y: 0;
  }
  .md\\:focus\\:translate-y-1:focus {
    --transform-translate-y: 0.25rem;
  }
  .md\\:focus\\:translate-y-2:focus {
    --transform-translate-y: 0.5rem;
  }
  .md\\:focus\\:translate-y-3:focus {
    --transform-translate-y: 0.75rem;
  }
  .md\\:focus\\:translate-y-4:focus {
    --transform-translate-y: 1rem;
  }
  .md\\:focus\\:translate-y-5:focus {
    --transform-translate-y: 1.25rem;
  }
  .md\\:focus\\:translate-y-6:focus {
    --transform-translate-y: 1.5rem;
  }
  .md\\:focus\\:translate-y-7:focus {
    --transform-translate-y: 1.75rem;
  }
  .md\\:focus\\:translate-y-8:focus {
    --transform-translate-y: 2rem;
  }
  .md\\:focus\\:translate-y-9:focus {
    --transform-translate-y: 2.25rem;
  }
  .md\\:focus\\:translate-y-10:focus {
    --transform-translate-y: 2.5rem;
  }
  .md\\:focus\\:translate-y-11:focus {
    --transform-translate-y: 2.75rem;
  }
  .md\\:focus\\:translate-y-12:focus {
    --transform-translate-y: 3rem;
  }
  .md\\:focus\\:translate-y-13:focus {
    --transform-translate-y: 3.25rem;
  }
  .md\\:focus\\:translate-y-14:focus {
    --transform-translate-y: 3.5rem;
  }
  .md\\:focus\\:translate-y-15:focus {
    --transform-translate-y: 3.75rem;
  }
  .md\\:focus\\:translate-y-16:focus {
    --transform-translate-y: 4rem;
  }
  .md\\:focus\\:translate-y-20:focus {
    --transform-translate-y: 5rem;
  }
  .md\\:focus\\:translate-y-24:focus {
    --transform-translate-y: 6rem;
  }
  .md\\:focus\\:translate-y-28:focus {
    --transform-translate-y: 7rem;
  }
  .md\\:focus\\:translate-y-32:focus {
    --transform-translate-y: 8rem;
  }
  .md\\:focus\\:translate-y-36:focus {
    --transform-translate-y: 9rem;
  }
  .md\\:focus\\:translate-y-40:focus {
    --transform-translate-y: 10rem;
  }
  .md\\:focus\\:translate-y-44:focus {
    --transform-translate-y: 11rem;
  }
  .md\\:focus\\:translate-y-48:focus {
    --transform-translate-y: 12rem;
  }
  .md\\:focus\\:translate-y-52:focus {
    --transform-translate-y: 13rem;
  }
  .md\\:focus\\:translate-y-56:focus {
    --transform-translate-y: 14rem;
  }
  .md\\:focus\\:translate-y-60:focus {
    --transform-translate-y: 15rem;
  }
  .md\\:focus\\:translate-y-64:focus {
    --transform-translate-y: 16rem;
  }
  .md\\:focus\\:translate-y-72:focus {
    --transform-translate-y: 18rem;
  }
  .md\\:focus\\:translate-y-80:focus {
    --transform-translate-y: 20rem;
  }
  .md\\:focus\\:translate-y-96:focus {
    --transform-translate-y: 24rem;
  }
  .md\\:focus\\:translate-y-px:focus {
    --transform-translate-y: 1px;
  }
  .md\\:focus\\:translate-y-0\\.5:focus {
    --transform-translate-y: 0.125rem;
  }
  .md\\:focus\\:translate-y-1\\.5:focus {
    --transform-translate-y: 0.375rem;
  }
  .md\\:focus\\:translate-y-2\\.5:focus {
    --transform-translate-y: 0.625rem;
  }
  .md\\:focus\\:translate-y-3\\.5:focus {
    --transform-translate-y: 0.875rem;
  }
  .md\\:focus\\:translate-y-1\\/2:focus {
    --transform-translate-y: 50%;
  }
  .md\\:focus\\:translate-y-1\\/3:focus {
    --transform-translate-y: 33.333333%;
  }
  .md\\:focus\\:translate-y-2\\/3:focus {
    --transform-translate-y: 66.666667%;
  }
  .md\\:focus\\:translate-y-1\\/4:focus {
    --transform-translate-y: 25%;
  }
  .md\\:focus\\:translate-y-2\\/4:focus {
    --transform-translate-y: 50%;
  }
  .md\\:focus\\:translate-y-3\\/4:focus {
    --transform-translate-y: 75%;
  }
  .md\\:focus\\:translate-y-1\\/5:focus {
    --transform-translate-y: 20%;
  }
  .md\\:focus\\:translate-y-2\\/5:focus {
    --transform-translate-y: 40%;
  }
  .md\\:focus\\:translate-y-3\\/5:focus {
    --transform-translate-y: 60%;
  }
  .md\\:focus\\:translate-y-4\\/5:focus {
    --transform-translate-y: 80%;
  }
  .md\\:focus\\:translate-y-1\\/6:focus {
    --transform-translate-y: 16.666667%;
  }
  .md\\:focus\\:translate-y-2\\/6:focus {
    --transform-translate-y: 33.333333%;
  }
  .md\\:focus\\:translate-y-3\\/6:focus {
    --transform-translate-y: 50%;
  }
  .md\\:focus\\:translate-y-4\\/6:focus {
    --transform-translate-y: 66.666667%;
  }
  .md\\:focus\\:translate-y-5\\/6:focus {
    --transform-translate-y: 83.333333%;
  }
  .md\\:focus\\:translate-y-1\\/12:focus {
    --transform-translate-y: 8.333333%;
  }
  .md\\:focus\\:translate-y-2\\/12:focus {
    --transform-translate-y: 16.666667%;
  }
  .md\\:focus\\:translate-y-3\\/12:focus {
    --transform-translate-y: 25%;
  }
  .md\\:focus\\:translate-y-4\\/12:focus {
    --transform-translate-y: 33.333333%;
  }
  .md\\:focus\\:translate-y-5\\/12:focus {
    --transform-translate-y: 41.666667%;
  }
  .md\\:focus\\:translate-y-6\\/12:focus {
    --transform-translate-y: 50%;
  }
  .md\\:focus\\:translate-y-7\\/12:focus {
    --transform-translate-y: 58.333333%;
  }
  .md\\:focus\\:translate-y-8\\/12:focus {
    --transform-translate-y: 66.666667%;
  }
  .md\\:focus\\:translate-y-9\\/12:focus {
    --transform-translate-y: 75%;
  }
  .md\\:focus\\:translate-y-10\\/12:focus {
    --transform-translate-y: 83.333333%;
  }
  .md\\:focus\\:translate-y-11\\/12:focus {
    --transform-translate-y: 91.666667%;
  }
  .md\\:focus\\:translate-y-full:focus {
    --transform-translate-y: 100%;
  }
  .md\\:focus\\:-translate-y-1:focus {
    --transform-translate-y: -0.25rem;
  }
  .md\\:focus\\:-translate-y-2:focus {
    --transform-translate-y: -0.5rem;
  }
  .md\\:focus\\:-translate-y-3:focus {
    --transform-translate-y: -0.75rem;
  }
  .md\\:focus\\:-translate-y-4:focus {
    --transform-translate-y: -1rem;
  }
  .md\\:focus\\:-translate-y-5:focus {
    --transform-translate-y: -1.25rem;
  }
  .md\\:focus\\:-translate-y-6:focus {
    --transform-translate-y: -1.5rem;
  }
  .md\\:focus\\:-translate-y-7:focus {
    --transform-translate-y: -1.75rem;
  }
  .md\\:focus\\:-translate-y-8:focus {
    --transform-translate-y: -2rem;
  }
  .md\\:focus\\:-translate-y-9:focus {
    --transform-translate-y: -2.25rem;
  }
  .md\\:focus\\:-translate-y-10:focus {
    --transform-translate-y: -2.5rem;
  }
  .md\\:focus\\:-translate-y-11:focus {
    --transform-translate-y: -2.75rem;
  }
  .md\\:focus\\:-translate-y-12:focus {
    --transform-translate-y: -3rem;
  }
  .md\\:focus\\:-translate-y-13:focus {
    --transform-translate-y: -3.25rem;
  }
  .md\\:focus\\:-translate-y-14:focus {
    --transform-translate-y: -3.5rem;
  }
  .md\\:focus\\:-translate-y-15:focus {
    --transform-translate-y: -3.75rem;
  }
  .md\\:focus\\:-translate-y-16:focus {
    --transform-translate-y: -4rem;
  }
  .md\\:focus\\:-translate-y-20:focus {
    --transform-translate-y: -5rem;
  }
  .md\\:focus\\:-translate-y-24:focus {
    --transform-translate-y: -6rem;
  }
  .md\\:focus\\:-translate-y-28:focus {
    --transform-translate-y: -7rem;
  }
  .md\\:focus\\:-translate-y-32:focus {
    --transform-translate-y: -8rem;
  }
  .md\\:focus\\:-translate-y-36:focus {
    --transform-translate-y: -9rem;
  }
  .md\\:focus\\:-translate-y-40:focus {
    --transform-translate-y: -10rem;
  }
  .md\\:focus\\:-translate-y-44:focus {
    --transform-translate-y: -11rem;
  }
  .md\\:focus\\:-translate-y-48:focus {
    --transform-translate-y: -12rem;
  }
  .md\\:focus\\:-translate-y-52:focus {
    --transform-translate-y: -13rem;
  }
  .md\\:focus\\:-translate-y-56:focus {
    --transform-translate-y: -14rem;
  }
  .md\\:focus\\:-translate-y-60:focus {
    --transform-translate-y: -15rem;
  }
  .md\\:focus\\:-translate-y-64:focus {
    --transform-translate-y: -16rem;
  }
  .md\\:focus\\:-translate-y-72:focus {
    --transform-translate-y: -18rem;
  }
  .md\\:focus\\:-translate-y-80:focus {
    --transform-translate-y: -20rem;
  }
  .md\\:focus\\:-translate-y-96:focus {
    --transform-translate-y: -24rem;
  }
  .md\\:focus\\:-translate-y-px:focus {
    --transform-translate-y: -1px;
  }
  .md\\:focus\\:-translate-y-0\\.5:focus {
    --transform-translate-y: -0.125rem;
  }
  .md\\:focus\\:-translate-y-1\\.5:focus {
    --transform-translate-y: -0.375rem;
  }
  .md\\:focus\\:-translate-y-2\\.5:focus {
    --transform-translate-y: -0.625rem;
  }
  .md\\:focus\\:-translate-y-3\\.5:focus {
    --transform-translate-y: -0.875rem;
  }
  .md\\:focus\\:-translate-y-1\\/2:focus {
    --transform-translate-y: -50%;
  }
  .md\\:focus\\:-translate-y-1\\/3:focus {
    --transform-translate-y: -33.33333%;
  }
  .md\\:focus\\:-translate-y-2\\/3:focus {
    --transform-translate-y: -66.66667%;
  }
  .md\\:focus\\:-translate-y-1\\/4:focus {
    --transform-translate-y: -25%;
  }
  .md\\:focus\\:-translate-y-2\\/4:focus {
    --transform-translate-y: -50%;
  }
  .md\\:focus\\:-translate-y-3\\/4:focus {
    --transform-translate-y: -75%;
  }
  .md\\:focus\\:-translate-y-1\\/5:focus {
    --transform-translate-y: -20%;
  }
  .md\\:focus\\:-translate-y-2\\/5:focus {
    --transform-translate-y: -40%;
  }
  .md\\:focus\\:-translate-y-3\\/5:focus {
    --transform-translate-y: -60%;
  }
  .md\\:focus\\:-translate-y-4\\/5:focus {
    --transform-translate-y: -80%;
  }
  .md\\:focus\\:-translate-y-1\\/6:focus {
    --transform-translate-y: -16.66667%;
  }
  .md\\:focus\\:-translate-y-2\\/6:focus {
    --transform-translate-y: -33.33333%;
  }
  .md\\:focus\\:-translate-y-3\\/6:focus {
    --transform-translate-y: -50%;
  }
  .md\\:focus\\:-translate-y-4\\/6:focus {
    --transform-translate-y: -66.66667%;
  }
  .md\\:focus\\:-translate-y-5\\/6:focus {
    --transform-translate-y: -83.33333%;
  }
  .md\\:focus\\:-translate-y-1\\/12:focus {
    --transform-translate-y: -8.33333%;
  }
  .md\\:focus\\:-translate-y-2\\/12:focus {
    --transform-translate-y: -16.66667%;
  }
  .md\\:focus\\:-translate-y-3\\/12:focus {
    --transform-translate-y: -25%;
  }
  .md\\:focus\\:-translate-y-4\\/12:focus {
    --transform-translate-y: -33.33333%;
  }
  .md\\:focus\\:-translate-y-5\\/12:focus {
    --transform-translate-y: -41.66667%;
  }
  .md\\:focus\\:-translate-y-6\\/12:focus {
    --transform-translate-y: -50%;
  }
  .md\\:focus\\:-translate-y-7\\/12:focus {
    --transform-translate-y: -58.33333%;
  }
  .md\\:focus\\:-translate-y-8\\/12:focus {
    --transform-translate-y: -66.66667%;
  }
  .md\\:focus\\:-translate-y-9\\/12:focus {
    --transform-translate-y: -75%;
  }
  .md\\:focus\\:-translate-y-10\\/12:focus {
    --transform-translate-y: -83.33333%;
  }
  .md\\:focus\\:-translate-y-11\\/12:focus {
    --transform-translate-y: -91.66667%;
  }
  .md\\:focus\\:-translate-y-full:focus {
    --transform-translate-y: -100%;
  }
  .md\\:skew-x-0 {
    --transform-skew-x: 0;
  }
  .md\\:skew-x-1 {
    --transform-skew-x: 1deg;
  }
  .md\\:skew-x-2 {
    --transform-skew-x: 2deg;
  }
  .md\\:skew-x-3 {
    --transform-skew-x: 3deg;
  }
  .md\\:skew-x-6 {
    --transform-skew-x: 6deg;
  }
  .md\\:skew-x-12 {
    --transform-skew-x: 12deg;
  }
  .md\\:-skew-x-12 {
    --transform-skew-x: -12deg;
  }
  .md\\:-skew-x-6 {
    --transform-skew-x: -6deg;
  }
  .md\\:-skew-x-3 {
    --transform-skew-x: -3deg;
  }
  .md\\:-skew-x-2 {
    --transform-skew-x: -2deg;
  }
  .md\\:-skew-x-1 {
    --transform-skew-x: -1deg;
  }
  .md\\:skew-y-0 {
    --transform-skew-y: 0;
  }
  .md\\:skew-y-1 {
    --transform-skew-y: 1deg;
  }
  .md\\:skew-y-2 {
    --transform-skew-y: 2deg;
  }
  .md\\:skew-y-3 {
    --transform-skew-y: 3deg;
  }
  .md\\:skew-y-6 {
    --transform-skew-y: 6deg;
  }
  .md\\:skew-y-12 {
    --transform-skew-y: 12deg;
  }
  .md\\:-skew-y-12 {
    --transform-skew-y: -12deg;
  }
  .md\\:-skew-y-6 {
    --transform-skew-y: -6deg;
  }
  .md\\:-skew-y-3 {
    --transform-skew-y: -3deg;
  }
  .md\\:-skew-y-2 {
    --transform-skew-y: -2deg;
  }
  .md\\:-skew-y-1 {
    --transform-skew-y: -1deg;
  }
  .md\\:hover\\:skew-x-0:hover {
    --transform-skew-x: 0;
  }
  .md\\:hover\\:skew-x-1:hover {
    --transform-skew-x: 1deg;
  }
  .md\\:hover\\:skew-x-2:hover {
    --transform-skew-x: 2deg;
  }
  .md\\:hover\\:skew-x-3:hover {
    --transform-skew-x: 3deg;
  }
  .md\\:hover\\:skew-x-6:hover {
    --transform-skew-x: 6deg;
  }
  .md\\:hover\\:skew-x-12:hover {
    --transform-skew-x: 12deg;
  }
  .md\\:hover\\:-skew-x-12:hover {
    --transform-skew-x: -12deg;
  }
  .md\\:hover\\:-skew-x-6:hover {
    --transform-skew-x: -6deg;
  }
  .md\\:hover\\:-skew-x-3:hover {
    --transform-skew-x: -3deg;
  }
  .md\\:hover\\:-skew-x-2:hover {
    --transform-skew-x: -2deg;
  }
  .md\\:hover\\:-skew-x-1:hover {
    --transform-skew-x: -1deg;
  }
  .md\\:hover\\:skew-y-0:hover {
    --transform-skew-y: 0;
  }
  .md\\:hover\\:skew-y-1:hover {
    --transform-skew-y: 1deg;
  }
  .md\\:hover\\:skew-y-2:hover {
    --transform-skew-y: 2deg;
  }
  .md\\:hover\\:skew-y-3:hover {
    --transform-skew-y: 3deg;
  }
  .md\\:hover\\:skew-y-6:hover {
    --transform-skew-y: 6deg;
  }
  .md\\:hover\\:skew-y-12:hover {
    --transform-skew-y: 12deg;
  }
  .md\\:hover\\:-skew-y-12:hover {
    --transform-skew-y: -12deg;
  }
  .md\\:hover\\:-skew-y-6:hover {
    --transform-skew-y: -6deg;
  }
  .md\\:hover\\:-skew-y-3:hover {
    --transform-skew-y: -3deg;
  }
  .md\\:hover\\:-skew-y-2:hover {
    --transform-skew-y: -2deg;
  }
  .md\\:hover\\:-skew-y-1:hover {
    --transform-skew-y: -1deg;
  }
  .md\\:focus\\:skew-x-0:focus {
    --transform-skew-x: 0;
  }
  .md\\:focus\\:skew-x-1:focus {
    --transform-skew-x: 1deg;
  }
  .md\\:focus\\:skew-x-2:focus {
    --transform-skew-x: 2deg;
  }
  .md\\:focus\\:skew-x-3:focus {
    --transform-skew-x: 3deg;
  }
  .md\\:focus\\:skew-x-6:focus {
    --transform-skew-x: 6deg;
  }
  .md\\:focus\\:skew-x-12:focus {
    --transform-skew-x: 12deg;
  }
  .md\\:focus\\:-skew-x-12:focus {
    --transform-skew-x: -12deg;
  }
  .md\\:focus\\:-skew-x-6:focus {
    --transform-skew-x: -6deg;
  }
  .md\\:focus\\:-skew-x-3:focus {
    --transform-skew-x: -3deg;
  }
  .md\\:focus\\:-skew-x-2:focus {
    --transform-skew-x: -2deg;
  }
  .md\\:focus\\:-skew-x-1:focus {
    --transform-skew-x: -1deg;
  }
  .md\\:focus\\:skew-y-0:focus {
    --transform-skew-y: 0;
  }
  .md\\:focus\\:skew-y-1:focus {
    --transform-skew-y: 1deg;
  }
  .md\\:focus\\:skew-y-2:focus {
    --transform-skew-y: 2deg;
  }
  .md\\:focus\\:skew-y-3:focus {
    --transform-skew-y: 3deg;
  }
  .md\\:focus\\:skew-y-6:focus {
    --transform-skew-y: 6deg;
  }
  .md\\:focus\\:skew-y-12:focus {
    --transform-skew-y: 12deg;
  }
  .md\\:focus\\:-skew-y-12:focus {
    --transform-skew-y: -12deg;
  }
  .md\\:focus\\:-skew-y-6:focus {
    --transform-skew-y: -6deg;
  }
  .md\\:focus\\:-skew-y-3:focus {
    --transform-skew-y: -3deg;
  }
  .md\\:focus\\:-skew-y-2:focus {
    --transform-skew-y: -2deg;
  }
  .md\\:focus\\:-skew-y-1:focus {
    --transform-skew-y: -1deg;
  }
  .md\\:transition-none {
    transition-property: none;
  }
  .md\\:transition-all {
    transition-property: all;
  }
  .md\\:transition {
    transition-property: background-color, border-color, color, fill, stroke, opacity, box-shadow, transform;
  }
  .md\\:transition-colors {
    transition-property: background-color, border-color, color, fill, stroke;
  }
  .md\\:transition-opacity {
    transition-property: opacity;
  }
  .md\\:transition-shadow {
    transition-property: box-shadow;
  }
  .md\\:transition-transform {
    transition-property: transform;
  }
  .md\\:ease-linear {
    transition-timing-function: linear;
  }
  .md\\:ease-in {
    transition-timing-function: cubic-bezier(0.4, 0, 1, 1);
  }
  .md\\:ease-out {
    transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
  }
  .md\\:ease-in-out {
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  }
  .md\\:duration-75 {
    transition-duration: 75ms;
  }
  .md\\:duration-100 {
    transition-duration: 100ms;
  }
  .md\\:duration-150 {
    transition-duration: 150ms;
  }
  .md\\:duration-200 {
    transition-duration: 200ms;
  }
  .md\\:duration-300 {
    transition-duration: 300ms;
  }
  .md\\:duration-500 {
    transition-duration: 500ms;
  }
  .md\\:duration-700 {
    transition-duration: 700ms;
  }
  .md\\:duration-1000 {
    transition-duration: 1000ms;
  }
  .md\\:delay-75 {
    transition-delay: 75ms;
  }
  .md\\:delay-100 {
    transition-delay: 100ms;
  }
  .md\\:delay-150 {
    transition-delay: 150ms;
  }
  .md\\:delay-200 {
    transition-delay: 200ms;
  }
  .md\\:delay-300 {
    transition-delay: 300ms;
  }
  .md\\:delay-500 {
    transition-delay: 500ms;
  }
  .md\\:delay-700 {
    transition-delay: 700ms;
  }
  .md\\:delay-1000 {
    transition-delay: 1000ms;
  }
  .md\\:animate-none {
    animation: none;
  }
  .md\\:animate-spin {
    animation: spin 1s linear infinite;
  }
  .md\\:animate-ping {
    animation: ping 1s cubic-bezier(0, 0, 0.2, 1) infinite;
  }
  .md\\:animate-pulse {
    animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
  }
  .md\\:animate-bounce {
    animation: bounce 1s infinite;
  }
}
@media (min-width: 1024px) {
  .lg\\:container {
    width: 100%;
  }
  @media (min-width: 640px) {
    .lg\\:container {
      max-width: 640px;
    }
  }
  @media (min-width: 768px) {
    .lg\\:container {
      max-width: 768px;
    }
  }
  @media (min-width: 1024px) {
    .lg\\:container {
      max-width: 1024px;
    }
  }
  @media (min-width: 1280px) {
    .lg\\:container {
      max-width: 1280px;
    }
  }
  .lg\\:prose {
    color: #374151;
    max-width: 65ch;
  }
  .lg\\:prose [class~="lead"] {
    color: #4b5563;
    font-size: 1.25em;
    line-height: 1.6;
    margin-top: 1.2em;
    margin-bottom: 1.2em;
  }
  .lg\\:prose a {
    color: #5850ec;
    text-decoration: none;
    font-weight: 600;
  }
  .lg\\:prose strong {
    color: #161e2e;
    font-weight: 600;
  }
  .lg\\:prose ol {
    counter-reset: list-counter;
    margin-top: 1.25em;
    margin-bottom: 1.25em;
  }
  .lg\\:prose ol>li {
    position: relative;
    counter-increment: list-counter;
    padding-left: 1.75em;
  }
  .lg\\:prose ol>li::before {
    content: counter(list-counter) ".";
    position: absolute;
    font-weight: 400;
    color: #6b7280;
  }
  .lg\\:prose ul>li {
    position: relative;
    padding-left: 1.75em;
  }
  .lg\\:prose ul>li::before {
    content: "";
    position: absolute;
    background-color: #d2d6dc;
    border-radius: 50%;
    width: 0.375em;
    height: 0.375em;
    top: calc(0.875em - 0.1875em);
    left: 0.25em;
  }
  .lg\\:prose hr {
    border-color: #e5e7eb;
    border-top-width: 1px;
    margin-top: 3em;
    margin-bottom: 3em;
  }
  .lg\\:prose blockquote {
    font-weight: 500;
    font-style: italic;
    color: #161e2e;
    border-left-width: 0.25rem;
    border-left-color: #e5e7eb;
    quotes: "\\201C" "\\201D" "\\2018" "\\2019";
    margin-top: 1.6em;
    margin-bottom: 1.6em;
    padding-left: 1em;
  }
  .lg\\:prose blockquote p:first-of-type::before {
    content: open-quote;
  }
  .lg\\:prose blockquote p:last-of-type::after {
    content: close-quote;
  }
  .lg\\:prose h1 {
    color: #1a202c;
    font-weight: 800;
    font-size: 2.25em;
    margin-top: 0;
    margin-bottom: 0.8888889em;
    line-height: 1.1111111;
  }
  .lg\\:prose h2 {
    color: #1a202c;
    font-weight: 700;
    font-size: 1.5em;
    margin-top: 2em;
    margin-bottom: 1em;
    line-height: 1.3333333;
  }
  .lg\\:prose h3 {
    color: #1a202c;
    font-weight: 600;
    font-size: 1.25em;
    margin-top: 1.6em;
    margin-bottom: 0.6em;
    line-height: 1.6;
  }
  .lg\\:prose h4 {
    color: #1a202c;
    font-weight: 600;
    margin-top: 1.5em;
    margin-bottom: 0.5em;
    line-height: 1.5;
  }
  .lg\\:prose figure figcaption {
    color: #6b7280;
    font-size: 0.875em;
    line-height: 1.4285714;
    margin-top: 0.8571429em;
  }
  .lg\\:prose code {
    color: #161e2e;
    font-weight: 600;
    font-size: 0.875em;
  }
  .lg\\:prose code::before {
    content: "\`";
  }
  .lg\\:prose code::after {
    content: "\`";
  }
  .lg\\:prose pre {
    color: #e5e7eb;
    background-color: #252f3f;
    overflow-x: auto;
    font-size: 0.875em;
    line-height: 1.7142857;
    margin-top: 1.7142857em;
    margin-bottom: 1.7142857em;
    border-radius: 0.375rem;
    padding-top: 0.8571429em;
    padding-right: 1.1428571em;
    padding-bottom: 0.8571429em;
    padding-left: 1.1428571em;
  }
  .lg\\:prose pre code {
    background-color: transparent;
    border-width: 0;
    border-radius: 0;
    padding: 0;
    font-weight: 400;
    color: inherit;
    font-size: inherit;
    font-family: inherit;
    line-height: inherit;
  }
  .lg\\:prose pre code::before {
    content: "";
  }
  .lg\\:prose pre code::after {
    content: "";
  }
  .lg\\:prose table {
    width: 100%;
    table-layout: auto;
    text-align: left;
    margin-top: 2em;
    margin-bottom: 2em;
    font-size: 0.875em;
    line-height: 1.7142857;
  }
  .lg\\:prose thead {
    color: #161e2e;
    font-weight: 600;
    border-bottom-width: 1px;
    border-bottom-color: #d2d6dc;
  }
  .lg\\:prose thead th {
    vertical-align: bottom;
    padding-right: 0.5714286em;
    padding-bottom: 0.5714286em;
    padding-left: 0.5714286em;
  }
  .lg\\:prose tbody tr {
    border-bottom-width: 1px;
    border-bottom-color: #e5e7eb;
  }
  .lg\\:prose tbody tr:last-child {
    border-bottom-width: 0;
  }
  .lg\\:prose tbody td {
    vertical-align: top;
    padding-top: 0.5714286em;
    padding-right: 0.5714286em;
    padding-bottom: 0.5714286em;
    padding-left: 0.5714286em;
  }
  .lg\\:prose {
    font-size: 1rem;
    line-height: 1.75;
  }
  .lg\\:prose p {
    margin-top: 1.25em;
    margin-bottom: 1.25em;
  }
  .lg\\:prose img {
    margin-top: 2em;
    margin-bottom: 2em;
  }
  .lg\\:prose video {
    margin-top: 2em;
    margin-bottom: 2em;
  }
  .lg\\:prose figure {
    margin-top: 2em;
    margin-bottom: 2em;
  }
  .lg\\:prose figure>* {
    margin-top: 0;
    margin-bottom: 0;
  }
  .lg\\:prose h2 code {
    font-size: 0.875em;
  }
  .lg\\:prose h3 code {
    font-size: 0.9em;
  }
  .lg\\:prose ul {
    margin-top: 1.25em;
    margin-bottom: 1.25em;
  }
  .lg\\:prose li {
    margin-top: 0.5em;
    margin-bottom: 0.5em;
  }
  .lg\\:prose ol>li:before {
    left: 0;
  }
  .lg\\:prose>ul>li p {
    margin-top: 0.75em;
    margin-bottom: 0.75em;
  }
  .lg\\:prose>ul>li>*:first-child {
    margin-top: 1.25em;
  }
  .lg\\:prose>ul>li>*:last-child {
    margin-bottom: 1.25em;
  }
  .lg\\:prose>ol>li>*:first-child {
    margin-top: 1.25em;
  }
  .lg\\:prose>ol>li>*:last-child {
    margin-bottom: 1.25em;
  }
  .lg\\:prose ul ul, .lg\\:prose ul ol, .lg\\:prose ol ul, .lg\\:prose ol ol {
    margin-top: 0.75em;
    margin-bottom: 0.75em;
  }
  .lg\\:prose hr+* {
    margin-top: 0;
  }
  .lg\\:prose h2+* {
    margin-top: 0;
  }
  .lg\\:prose h3+* {
    margin-top: 0;
  }
  .lg\\:prose h4+* {
    margin-top: 0;
  }
  .lg\\:prose thead th:first-child {
    padding-left: 0;
  }
  .lg\\:prose thead th:last-child {
    padding-right: 0;
  }
  .lg\\:prose tbody td:first-child {
    padding-left: 0;
  }
  .lg\\:prose tbody td:last-child {
    padding-right: 0;
  }
  .lg\\:prose> :first-child {
    margin-top: 0;
  }
  .lg\\:prose> :last-child {
    margin-bottom: 0;
  }
  .lg\\:prose h1, .lg\\:prose h2, .lg\\:prose h3, .lg\\:prose h4 {
    color: #161e2e;
  }
  .lg\\:prose-sm {
    font-size: 0.875rem;
    line-height: 1.7142857;
  }
  .lg\\:prose-sm p {
    margin-top: 1.1428571em;
    margin-bottom: 1.1428571em;
  }
  .lg\\:prose-sm [class~="lead"] {
    font-size: 1.2857143em;
    line-height: 1.5555556;
    margin-top: 0.8888889em;
    margin-bottom: 0.8888889em;
  }
  .lg\\:prose-sm blockquote {
    margin-top: 1.3333333em;
    margin-bottom: 1.3333333em;
    padding-left: 1.1111111em;
  }
  .lg\\:prose-sm h1 {
    font-size: 2.1428571em;
    margin-top: 0;
    margin-bottom: 0.8em;
    line-height: 1.2;
  }
  .lg\\:prose-sm h2 {
    font-size: 1.4285714em;
    margin-top: 1.6em;
    margin-bottom: 0.8em;
    line-height: 1.4;
  }
  .lg\\:prose-sm h3 {
    font-size: 1.2857143em;
    margin-top: 1.5555556em;
    margin-bottom: 0.4444444em;
    line-height: 1.5555556;
  }
  .lg\\:prose-sm h4 {
    margin-top: 1.4285714em;
    margin-bottom: 0.5714286em;
    line-height: 1.4285714;
  }
  .lg\\:prose-sm img {
    margin-top: 1.7142857em;
    margin-bottom: 1.7142857em;
  }
  .lg\\:prose-sm video {
    margin-top: 1.7142857em;
    margin-bottom: 1.7142857em;
  }
  .lg\\:prose-sm figure {
    margin-top: 1.7142857em;
    margin-bottom: 1.7142857em;
  }
  .lg\\:prose-sm figure>* {
    margin-top: 0;
    margin-bottom: 0;
  }
  .lg\\:prose-sm figure figcaption {
    font-size: 0.8571429em;
    line-height: 1.3333333;
    margin-top: 0.6666667em;
  }
  .lg\\:prose-sm code {
    font-size: 0.8571429em;
  }
  .lg\\:prose-sm h2 code {
    font-size: 0.9em;
  }
  .lg\\:prose-sm h3 code {
    font-size: 0.8888889em;
  }
  .lg\\:prose-sm pre {
    font-size: 0.8571429em;
    line-height: 1.6666667;
    margin-top: 1.6666667em;
    margin-bottom: 1.6666667em;
    border-radius: 0.25rem;
    padding-top: 0.6666667em;
    padding-right: 1em;
    padding-bottom: 0.6666667em;
    padding-left: 1em;
  }
  .lg\\:prose-sm ol {
    margin-top: 1.1428571em;
    margin-bottom: 1.1428571em;
  }
  .lg\\:prose-sm ul {
    margin-top: 1.1428571em;
    margin-bottom: 1.1428571em;
  }
  .lg\\:prose-sm li {
    margin-top: 0.2857143em;
    margin-bottom: 0.2857143em;
  }
  .lg\\:prose-sm ol>li {
    padding-left: 1.5714286em;
  }
  .lg\\:prose-sm ol>li:before {
    left: 0;
  }
  .lg\\:prose-sm ul>li {
    padding-left: 1.5714286em;
  }
  .lg\\:prose-sm ul>li::before {
    height: 0.3571429em;
    width: 0.3571429em;
    top: calc(0.8571429em - 0.1785714em);
    left: 0.2142857em;
  }
  .lg\\:prose-sm>ul>li p {
    margin-top: 0.5714286em;
    margin-bottom: 0.5714286em;
  }
  .lg\\:prose-sm>ul>li>*:first-child {
    margin-top: 1.1428571em;
  }
  .lg\\:prose-sm>ul>li>*:last-child {
    margin-bottom: 1.1428571em;
  }
  .lg\\:prose-sm>ol>li>*:first-child {
    margin-top: 1.1428571em;
  }
  .lg\\:prose-sm>ol>li>*:last-child {
    margin-bottom: 1.1428571em;
  }
  .lg\\:prose-sm ul ul, .lg\\:prose-sm ul ol, .lg\\:prose-sm ol ul, .lg\\:prose-sm ol ol {
    margin-top: 0.5714286em;
    margin-bottom: 0.5714286em;
  }
  .lg\\:prose-sm hr {
    margin-top: 2.8571429em;
    margin-bottom: 2.8571429em;
  }
  .lg\\:prose-sm hr+* {
    margin-top: 0;
  }
  .lg\\:prose-sm h2+* {
    margin-top: 0;
  }
  .lg\\:prose-sm h3+* {
    margin-top: 0;
  }
  .lg\\:prose-sm h4+* {
    margin-top: 0;
  }
  .lg\\:prose-sm table {
    font-size: 0.8571429em;
    line-height: 1.5;
  }
  .lg\\:prose-sm thead th {
    padding-right: 1em;
    padding-bottom: 0.6666667em;
    padding-left: 1em;
  }
  .lg\\:prose-sm thead th:first-child {
    padding-left: 0;
  }
  .lg\\:prose-sm thead th:last-child {
    padding-right: 0;
  }
  .lg\\:prose-sm tbody td {
    padding-top: 0.6666667em;
    padding-right: 1em;
    padding-bottom: 0.6666667em;
    padding-left: 1em;
  }
  .lg\\:prose-sm tbody td:first-child {
    padding-left: 0;
  }
  .lg\\:prose-sm tbody td:last-child {
    padding-right: 0;
  }
  .lg\\:prose-sm> :first-child {
    margin-top: 0;
  }
  .lg\\:prose-sm> :last-child {
    margin-bottom: 0;
  }
  .lg\\:prose-lg {
    font-size: 1.125rem;
    line-height: 1.7777778;
  }
  .lg\\:prose-lg p {
    margin-top: 1.3333333em;
    margin-bottom: 1.3333333em;
  }
  .lg\\:prose-lg [class~="lead"] {
    font-size: 1.2222222em;
    line-height: 1.4545455;
    margin-top: 1.0909091em;
    margin-bottom: 1.0909091em;
  }
  .lg\\:prose-lg blockquote {
    margin-top: 1.6666667em;
    margin-bottom: 1.6666667em;
    padding-left: 1em;
  }
  .lg\\:prose-lg h1 {
    font-size: 2.6666667em;
    margin-top: 0;
    margin-bottom: 0.8333333em;
    line-height: 1;
  }
  .lg\\:prose-lg h2 {
    font-size: 1.6666667em;
    margin-top: 1.8666667em;
    margin-bottom: 1.0666667em;
    line-height: 1.3333333;
  }
  .lg\\:prose-lg h3 {
    font-size: 1.3333333em;
    margin-top: 1.6666667em;
    margin-bottom: 0.6666667em;
    line-height: 1.5;
  }
  .lg\\:prose-lg h4 {
    margin-top: 1.7777778em;
    margin-bottom: 0.4444444em;
    line-height: 1.5555556;
  }
  .lg\\:prose-lg img {
    margin-top: 1.7777778em;
    margin-bottom: 1.7777778em;
  }
  .lg\\:prose-lg video {
    margin-top: 1.7777778em;
    margin-bottom: 1.7777778em;
  }
  .lg\\:prose-lg figure {
    margin-top: 1.7777778em;
    margin-bottom: 1.7777778em;
  }
  .lg\\:prose-lg figure>* {
    margin-top: 0;
    margin-bottom: 0;
  }
  .lg\\:prose-lg figure figcaption {
    font-size: 0.8888889em;
    line-height: 1.5;
    margin-top: 1em;
  }
  .lg\\:prose-lg code {
    font-size: 0.8888889em;
  }
  .lg\\:prose-lg h2 code {
    font-size: 0.8666667em;
  }
  .lg\\:prose-lg h3 code {
    font-size: 0.875em;
  }
  .lg\\:prose-lg pre {
    font-size: 0.8888889em;
    line-height: 1.75;
    margin-top: 2em;
    margin-bottom: 2em;
    border-radius: 0.375rem;
    padding-top: 1em;
    padding-right: 1.5em;
    padding-bottom: 1em;
    padding-left: 1.5em;
  }
  .lg\\:prose-lg ol {
    margin-top: 1.3333333em;
    margin-bottom: 1.3333333em;
  }
  .lg\\:prose-lg ul {
    margin-top: 1.3333333em;
    margin-bottom: 1.3333333em;
  }
  .lg\\:prose-lg li {
    margin-top: 0.6666667em;
    margin-bottom: 0.6666667em;
  }
  .lg\\:prose-lg ol>li {
    padding-left: 1.6666667em;
  }
  .lg\\:prose-lg ol>li:before {
    left: 0;
  }
  .lg\\:prose-lg ul>li {
    padding-left: 1.6666667em;
  }
  .lg\\:prose-lg ul>li::before {
    width: 0.3333333em;
    height: 0.3333333em;
    top: calc(0.8888889em - 0.1666667em);
    left: 0.2222222em;
  }
  .lg\\:prose-lg>ul>li p {
    margin-top: 0.8888889em;
    margin-bottom: 0.8888889em;
  }
  .lg\\:prose-lg>ul>li>*:first-child {
    margin-top: 1.3333333em;
  }
  .lg\\:prose-lg>ul>li>*:last-child {
    margin-bottom: 1.3333333em;
  }
  .lg\\:prose-lg>ol>li>*:first-child {
    margin-top: 1.3333333em;
  }
  .lg\\:prose-lg>ol>li>*:last-child {
    margin-bottom: 1.3333333em;
  }
  .lg\\:prose-lg ul ul, .lg\\:prose-lg ul ol, .lg\\:prose-lg ol ul, .lg\\:prose-lg ol ol {
    margin-top: 0.8888889em;
    margin-bottom: 0.8888889em;
  }
  .lg\\:prose-lg hr {
    margin-top: 3.1111111em;
    margin-bottom: 3.1111111em;
  }
  .lg\\:prose-lg hr+* {
    margin-top: 0;
  }
  .lg\\:prose-lg h2+* {
    margin-top: 0;
  }
  .lg\\:prose-lg h3+* {
    margin-top: 0;
  }
  .lg\\:prose-lg h4+* {
    margin-top: 0;
  }
  .lg\\:prose-lg table {
    font-size: 0.8888889em;
    line-height: 1.5;
  }
  .lg\\:prose-lg thead th {
    padding-right: 0.75em;
    padding-bottom: 0.75em;
    padding-left: 0.75em;
  }
  .lg\\:prose-lg thead th:first-child {
    padding-left: 0;
  }
  .lg\\:prose-lg thead th:last-child {
    padding-right: 0;
  }
  .lg\\:prose-lg tbody td {
    padding-top: 0.75em;
    padding-right: 0.75em;
    padding-bottom: 0.75em;
    padding-left: 0.75em;
  }
  .lg\\:prose-lg tbody td:first-child {
    padding-left: 0;
  }
  .lg\\:prose-lg tbody td:last-child {
    padding-right: 0;
  }
  .lg\\:prose-lg> :first-child {
    margin-top: 0;
  }
  .lg\\:prose-lg> :last-child {
    margin-bottom: 0;
  }
  .lg\\:prose-xl {
    font-size: 1.25rem;
    line-height: 1.8;
  }
  .lg\\:prose-xl p {
    margin-top: 1.2em;
    margin-bottom: 1.2em;
  }
  .lg\\:prose-xl [class~="lead"] {
    font-size: 1.2em;
    line-height: 1.5;
    margin-top: 1em;
    margin-bottom: 1em;
  }
  .lg\\:prose-xl blockquote {
    margin-top: 1.6em;
    margin-bottom: 1.6em;
    padding-left: 1.0666667em;
  }
  .lg\\:prose-xl h1 {
    font-size: 2.8em;
    margin-top: 0;
    margin-bottom: 0.8571429em;
    line-height: 1;
  }
  .lg\\:prose-xl h2 {
    font-size: 1.8em;
    margin-top: 1.5555556em;
    margin-bottom: 0.8888889em;
    line-height: 1.1111111;
  }
  .lg\\:prose-xl h3 {
    font-size: 1.5em;
    margin-top: 1.6em;
    margin-bottom: 0.6666667em;
    line-height: 1.3333333;
  }
  .lg\\:prose-xl h4 {
    margin-top: 1.8em;
    margin-bottom: 0.6em;
    line-height: 1.6;
  }
  .lg\\:prose-xl img {
    margin-top: 2em;
    margin-bottom: 2em;
  }
  .lg\\:prose-xl video {
    margin-top: 2em;
    margin-bottom: 2em;
  }
  .lg\\:prose-xl figure {
    margin-top: 2em;
    margin-bottom: 2em;
  }
  .lg\\:prose-xl figure>* {
    margin-top: 0;
    margin-bottom: 0;
  }
  .lg\\:prose-xl figure figcaption {
    font-size: 0.9em;
    line-height: 1.5555556;
    margin-top: 1em;
  }
  .lg\\:prose-xl code {
    font-size: 0.9em;
  }
  .lg\\:prose-xl h2 code {
    font-size: 0.8611111em;
  }
  .lg\\:prose-xl h3 code {
    font-size: 0.9em;
  }
  .lg\\:prose-xl pre {
    font-size: 0.9em;
    line-height: 1.7777778;
    margin-top: 2em;
    margin-bottom: 2em;
    border-radius: 0.5rem;
    padding-top: 1.1111111em;
    padding-right: 1.3333333em;
    padding-bottom: 1.1111111em;
    padding-left: 1.3333333em;
  }
  .lg\\:prose-xl ol {
    margin-top: 1.2em;
    margin-bottom: 1.2em;
  }
  .lg\\:prose-xl ul {
    margin-top: 1.2em;
    margin-bottom: 1.2em;
  }
  .lg\\:prose-xl li {
    margin-top: 0.6em;
    margin-bottom: 0.6em;
  }
  .lg\\:prose-xl ol>li {
    padding-left: 1.8em;
  }
  .lg\\:prose-xl ol>li:before {
    left: 0;
  }
  .lg\\:prose-xl ul>li {
    padding-left: 1.8em;
  }
  .lg\\:prose-xl ul>li::before {
    width: 0.35em;
    height: 0.35em;
    top: calc(0.9em - 0.175em);
    left: 0.25em;
  }
  .lg\\:prose-xl>ul>li p {
    margin-top: 0.8em;
    margin-bottom: 0.8em;
  }
  .lg\\:prose-xl>ul>li>*:first-child {
    margin-top: 1.2em;
  }
  .lg\\:prose-xl>ul>li>*:last-child {
    margin-bottom: 1.2em;
  }
  .lg\\:prose-xl>ol>li>*:first-child {
    margin-top: 1.2em;
  }
  .lg\\:prose-xl>ol>li>*:last-child {
    margin-bottom: 1.2em;
  }
  .lg\\:prose-xl ul ul, .lg\\:prose-xl ul ol, .lg\\:prose-xl ol ul, .lg\\:prose-xl ol ol {
    margin-top: 0.8em;
    margin-bottom: 0.8em;
  }
  .lg\\:prose-xl hr {
    margin-top: 2.8em;
    margin-bottom: 2.8em;
  }
  .lg\\:prose-xl hr+* {
    margin-top: 0;
  }
  .lg\\:prose-xl h2+* {
    margin-top: 0;
  }
  .lg\\:prose-xl h3+* {
    margin-top: 0;
  }
  .lg\\:prose-xl h4+* {
    margin-top: 0;
  }
  .lg\\:prose-xl table {
    font-size: 0.9em;
    line-height: 1.5555556;
  }
  .lg\\:prose-xl thead th {
    padding-right: 0.6666667em;
    padding-bottom: 0.8888889em;
    padding-left: 0.6666667em;
  }
  .lg\\:prose-xl thead th:first-child {
    padding-left: 0;
  }
  .lg\\:prose-xl thead th:last-child {
    padding-right: 0;
  }
  .lg\\:prose-xl tbody td {
    padding-top: 0.8888889em;
    padding-right: 0.6666667em;
    padding-bottom: 0.8888889em;
    padding-left: 0.6666667em;
  }
  .lg\\:prose-xl tbody td:first-child {
    padding-left: 0;
  }
  .lg\\:prose-xl tbody td:last-child {
    padding-right: 0;
  }
  .lg\\:prose-xl> :first-child {
    margin-top: 0;
  }
  .lg\\:prose-xl> :last-child {
    margin-bottom: 0;
  }
  .lg\\:prose-2xl {
    font-size: 1.5rem;
    line-height: 1.6666667;
  }
  .lg\\:prose-2xl p {
    margin-top: 1.3333333em;
    margin-bottom: 1.3333333em;
  }
  .lg\\:prose-2xl [class~="lead"] {
    font-size: 1.25em;
    line-height: 1.4666667;
    margin-top: 1.0666667em;
    margin-bottom: 1.0666667em;
  }
  .lg\\:prose-2xl blockquote {
    margin-top: 1.7777778em;
    margin-bottom: 1.7777778em;
    padding-left: 1.1111111em;
  }
  .lg\\:prose-2xl h1 {
    font-size: 2.6666667em;
    margin-top: 0;
    margin-bottom: 0.875em;
    line-height: 1;
  }
  .lg\\:prose-2xl h2 {
    font-size: 2em;
    margin-top: 1.5em;
    margin-bottom: 0.8333333em;
    line-height: 1.0833333;
  }
  .lg\\:prose-2xl h3 {
    font-size: 1.5em;
    margin-top: 1.5555556em;
    margin-bottom: 0.6666667em;
    line-height: 1.2222222;
  }
  .lg\\:prose-2xl h4 {
    margin-top: 1.6666667em;
    margin-bottom: 0.6666667em;
    line-height: 1.5;
  }
  .lg\\:prose-2xl img {
    margin-top: 2em;
    margin-bottom: 2em;
  }
  .lg\\:prose-2xl video {
    margin-top: 2em;
    margin-bottom: 2em;
  }
  .lg\\:prose-2xl figure {
    margin-top: 2em;
    margin-bottom: 2em;
  }
  .lg\\:prose-2xl figure>* {
    margin-top: 0;
    margin-bottom: 0;
  }
  .lg\\:prose-2xl figure figcaption {
    font-size: 0.8333333em;
    line-height: 1.6;
    margin-top: 1em;
  }
  .lg\\:prose-2xl code {
    font-size: 0.8333333em;
  }
  .lg\\:prose-2xl h2 code {
    font-size: 0.875em;
  }
  .lg\\:prose-2xl h3 code {
    font-size: 0.8888889em;
  }
  .lg\\:prose-2xl pre {
    font-size: 0.8333333em;
    line-height: 1.8;
    margin-top: 2em;
    margin-bottom: 2em;
    border-radius: 0.5rem;
    padding-top: 1.2em;
    padding-right: 1.6em;
    padding-bottom: 1.2em;
    padding-left: 1.6em;
  }
  .lg\\:prose-2xl ol {
    margin-top: 1.3333333em;
    margin-bottom: 1.3333333em;
  }
  .lg\\:prose-2xl ul {
    margin-top: 1.3333333em;
    margin-bottom: 1.3333333em;
  }
  .lg\\:prose-2xl li {
    margin-top: 0.5em;
    margin-bottom: 0.5em;
  }
  .lg\\:prose-2xl ol>li {
    padding-left: 1.6666667em;
  }
  .lg\\:prose-2xl ol>li:before {
    left: 0;
  }
  .lg\\:prose-2xl ul>li {
    padding-left: 1.6666667em;
  }
  .lg\\:prose-2xl ul>li::before {
    width: 0.3333333em;
    height: 0.3333333em;
    top: calc(0.8333333em - 0.1666667em);
    left: 0.25em;
  }
  .lg\\:prose-2xl>ul>li p {
    margin-top: 0.8333333em;
    margin-bottom: 0.8333333em;
  }
  .lg\\:prose-2xl>ul>li>*:first-child {
    margin-top: 1.3333333em;
  }
  .lg\\:prose-2xl>ul>li>*:last-child {
    margin-bottom: 1.3333333em;
  }
  .lg\\:prose-2xl>ol>li>*:first-child {
    margin-top: 1.3333333em;
  }
  .lg\\:prose-2xl>ol>li>*:last-child {
    margin-bottom: 1.3333333em;
  }
  .lg\\:prose-2xl ul ul, .lg\\:prose-2xl ul ol, .lg\\:prose-2xl ol ul, .lg\\:prose-2xl ol ol {
    margin-top: 0.6666667em;
    margin-bottom: 0.6666667em;
  }
  .lg\\:prose-2xl hr {
    margin-top: 3em;
    margin-bottom: 3em;
  }
  .lg\\:prose-2xl hr+* {
    margin-top: 0;
  }
  .lg\\:prose-2xl h2+* {
    margin-top: 0;
  }
  .lg\\:prose-2xl h3+* {
    margin-top: 0;
  }
  .lg\\:prose-2xl h4+* {
    margin-top: 0;
  }
  .lg\\:prose-2xl table {
    font-size: 0.8333333em;
    line-height: 1.4;
  }
  .lg\\:prose-2xl thead th {
    padding-right: 0.6em;
    padding-bottom: 0.8em;
    padding-left: 0.6em;
  }
  .lg\\:prose-2xl thead th:first-child {
    padding-left: 0;
  }
  .lg\\:prose-2xl thead th:last-child {
    padding-right: 0;
  }
  .lg\\:prose-2xl tbody td {
    padding-top: 0.8em;
    padding-right: 0.6em;
    padding-bottom: 0.8em;
    padding-left: 0.6em;
  }
  .lg\\:prose-2xl tbody td:first-child {
    padding-left: 0;
  }
  .lg\\:prose-2xl tbody td:last-child {
    padding-right: 0;
  }
  .lg\\:prose-2xl> :first-child {
    margin-top: 0;
  }
  .lg\\:prose-2xl> :last-child {
    margin-bottom: 0;
  }
  .lg\\:space-y-0> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(0px * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(0px * var(--space-y-reverse));
  }
  .lg\\:space-x-0> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(0px * var(--space-x-reverse));
    margin-left: calc(0px * calc(1 - var(--space-x-reverse)));
  }
  .lg\\:space-y-1> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(0.25rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(0.25rem * var(--space-y-reverse));
  }
  .lg\\:space-x-1> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(0.25rem * var(--space-x-reverse));
    margin-left: calc(0.25rem * calc(1 - var(--space-x-reverse)));
  }
  .lg\\:space-y-2> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(0.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(0.5rem * var(--space-y-reverse));
  }
  .lg\\:space-x-2> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(0.5rem * var(--space-x-reverse));
    margin-left: calc(0.5rem * calc(1 - var(--space-x-reverse)));
  }
  .lg\\:space-y-3> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(0.75rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(0.75rem * var(--space-y-reverse));
  }
  .lg\\:space-x-3> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(0.75rem * var(--space-x-reverse));
    margin-left: calc(0.75rem * calc(1 - var(--space-x-reverse)));
  }
  .lg\\:space-y-4> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(1rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(1rem * var(--space-y-reverse));
  }
  .lg\\:space-x-4> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(1rem * var(--space-x-reverse));
    margin-left: calc(1rem * calc(1 - var(--space-x-reverse)));
  }
  .lg\\:space-y-5> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(1.25rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(1.25rem * var(--space-y-reverse));
  }
  .lg\\:space-x-5> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(1.25rem * var(--space-x-reverse));
    margin-left: calc(1.25rem * calc(1 - var(--space-x-reverse)));
  }
  .lg\\:space-y-6> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(1.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(1.5rem * var(--space-y-reverse));
  }
  .lg\\:space-x-6> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(1.5rem * var(--space-x-reverse));
    margin-left: calc(1.5rem * calc(1 - var(--space-x-reverse)));
  }
  .lg\\:space-y-7> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(1.75rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(1.75rem * var(--space-y-reverse));
  }
  .lg\\:space-x-7> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(1.75rem * var(--space-x-reverse));
    margin-left: calc(1.75rem * calc(1 - var(--space-x-reverse)));
  }
  .lg\\:space-y-8> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(2rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(2rem * var(--space-y-reverse));
  }
  .lg\\:space-x-8> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(2rem * var(--space-x-reverse));
    margin-left: calc(2rem * calc(1 - var(--space-x-reverse)));
  }
  .lg\\:space-y-9> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(2.25rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(2.25rem * var(--space-y-reverse));
  }
  .lg\\:space-x-9> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(2.25rem * var(--space-x-reverse));
    margin-left: calc(2.25rem * calc(1 - var(--space-x-reverse)));
  }
  .lg\\:space-y-10> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(2.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(2.5rem * var(--space-y-reverse));
  }
  .lg\\:space-x-10> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(2.5rem * var(--space-x-reverse));
    margin-left: calc(2.5rem * calc(1 - var(--space-x-reverse)));
  }
  .lg\\:space-y-11> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(2.75rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(2.75rem * var(--space-y-reverse));
  }
  .lg\\:space-x-11> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(2.75rem * var(--space-x-reverse));
    margin-left: calc(2.75rem * calc(1 - var(--space-x-reverse)));
  }
  .lg\\:space-y-12> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(3rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(3rem * var(--space-y-reverse));
  }
  .lg\\:space-x-12> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(3rem * var(--space-x-reverse));
    margin-left: calc(3rem * calc(1 - var(--space-x-reverse)));
  }
  .lg\\:space-y-13> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(3.25rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(3.25rem * var(--space-y-reverse));
  }
  .lg\\:space-x-13> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(3.25rem * var(--space-x-reverse));
    margin-left: calc(3.25rem * calc(1 - var(--space-x-reverse)));
  }
  .lg\\:space-y-14> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(3.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(3.5rem * var(--space-y-reverse));
  }
  .lg\\:space-x-14> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(3.5rem * var(--space-x-reverse));
    margin-left: calc(3.5rem * calc(1 - var(--space-x-reverse)));
  }
  .lg\\:space-y-15> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(3.75rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(3.75rem * var(--space-y-reverse));
  }
  .lg\\:space-x-15> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(3.75rem * var(--space-x-reverse));
    margin-left: calc(3.75rem * calc(1 - var(--space-x-reverse)));
  }
  .lg\\:space-y-16> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(4rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(4rem * var(--space-y-reverse));
  }
  .lg\\:space-x-16> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(4rem * var(--space-x-reverse));
    margin-left: calc(4rem * calc(1 - var(--space-x-reverse)));
  }
  .lg\\:space-y-20> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(5rem * var(--space-y-reverse));
  }
  .lg\\:space-x-20> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(5rem * var(--space-x-reverse));
    margin-left: calc(5rem * calc(1 - var(--space-x-reverse)));
  }
  .lg\\:space-y-24> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(6rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(6rem * var(--space-y-reverse));
  }
  .lg\\:space-x-24> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(6rem * var(--space-x-reverse));
    margin-left: calc(6rem * calc(1 - var(--space-x-reverse)));
  }
  .lg\\:space-y-28> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(7rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(7rem * var(--space-y-reverse));
  }
  .lg\\:space-x-28> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(7rem * var(--space-x-reverse));
    margin-left: calc(7rem * calc(1 - var(--space-x-reverse)));
  }
  .lg\\:space-y-32> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(8rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(8rem * var(--space-y-reverse));
  }
  .lg\\:space-x-32> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(8rem * var(--space-x-reverse));
    margin-left: calc(8rem * calc(1 - var(--space-x-reverse)));
  }
  .lg\\:space-y-36> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(9rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(9rem * var(--space-y-reverse));
  }
  .lg\\:space-x-36> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(9rem * var(--space-x-reverse));
    margin-left: calc(9rem * calc(1 - var(--space-x-reverse)));
  }
  .lg\\:space-y-40> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(10rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(10rem * var(--space-y-reverse));
  }
  .lg\\:space-x-40> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(10rem * var(--space-x-reverse));
    margin-left: calc(10rem * calc(1 - var(--space-x-reverse)));
  }
  .lg\\:space-y-44> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(11rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(11rem * var(--space-y-reverse));
  }
  .lg\\:space-x-44> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(11rem * var(--space-x-reverse));
    margin-left: calc(11rem * calc(1 - var(--space-x-reverse)));
  }
  .lg\\:space-y-48> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(12rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(12rem * var(--space-y-reverse));
  }
  .lg\\:space-x-48> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(12rem * var(--space-x-reverse));
    margin-left: calc(12rem * calc(1 - var(--space-x-reverse)));
  }
  .lg\\:space-y-52> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(13rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(13rem * var(--space-y-reverse));
  }
  .lg\\:space-x-52> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(13rem * var(--space-x-reverse));
    margin-left: calc(13rem * calc(1 - var(--space-x-reverse)));
  }
  .lg\\:space-y-56> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(14rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(14rem * var(--space-y-reverse));
  }
  .lg\\:space-x-56> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(14rem * var(--space-x-reverse));
    margin-left: calc(14rem * calc(1 - var(--space-x-reverse)));
  }
  .lg\\:space-y-60> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(15rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(15rem * var(--space-y-reverse));
  }
  .lg\\:space-x-60> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(15rem * var(--space-x-reverse));
    margin-left: calc(15rem * calc(1 - var(--space-x-reverse)));
  }
  .lg\\:space-y-64> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(16rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(16rem * var(--space-y-reverse));
  }
  .lg\\:space-x-64> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(16rem * var(--space-x-reverse));
    margin-left: calc(16rem * calc(1 - var(--space-x-reverse)));
  }
  .lg\\:space-y-72> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(18rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(18rem * var(--space-y-reverse));
  }
  .lg\\:space-x-72> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(18rem * var(--space-x-reverse));
    margin-left: calc(18rem * calc(1 - var(--space-x-reverse)));
  }
  .lg\\:space-y-80> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(20rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(20rem * var(--space-y-reverse));
  }
  .lg\\:space-x-80> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(20rem * var(--space-x-reverse));
    margin-left: calc(20rem * calc(1 - var(--space-x-reverse)));
  }
  .lg\\:space-y-96> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(24rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(24rem * var(--space-y-reverse));
  }
  .lg\\:space-x-96> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(24rem * var(--space-x-reverse));
    margin-left: calc(24rem * calc(1 - var(--space-x-reverse)));
  }
  .lg\\:space-y-px> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(1px * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(1px * var(--space-y-reverse));
  }
  .lg\\:space-x-px> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(1px * var(--space-x-reverse));
    margin-left: calc(1px * calc(1 - var(--space-x-reverse)));
  }
  .lg\\:space-y-0\\.5> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(0.125rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(0.125rem * var(--space-y-reverse));
  }
  .lg\\:space-x-0\\.5> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(0.125rem * var(--space-x-reverse));
    margin-left: calc(0.125rem * calc(1 - var(--space-x-reverse)));
  }
  .lg\\:space-y-1\\.5> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(0.375rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(0.375rem * var(--space-y-reverse));
  }
  .lg\\:space-x-1\\.5> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(0.375rem * var(--space-x-reverse));
    margin-left: calc(0.375rem * calc(1 - var(--space-x-reverse)));
  }
  .lg\\:space-y-2\\.5> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(0.625rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(0.625rem * var(--space-y-reverse));
  }
  .lg\\:space-x-2\\.5> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(0.625rem * var(--space-x-reverse));
    margin-left: calc(0.625rem * calc(1 - var(--space-x-reverse)));
  }
  .lg\\:space-y-3\\.5> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(0.875rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(0.875rem * var(--space-y-reverse));
  }
  .lg\\:space-x-3\\.5> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(0.875rem * var(--space-x-reverse));
    margin-left: calc(0.875rem * calc(1 - var(--space-x-reverse)));
  }
  .lg\\:space-y-1\\/2> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(50% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(50% * var(--space-y-reverse));
  }
  .lg\\:space-x-1\\/2> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(50% * var(--space-x-reverse));
    margin-left: calc(50% * calc(1 - var(--space-x-reverse)));
  }
  .lg\\:space-y-1\\/3> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(33.333333% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(33.333333% * var(--space-y-reverse));
  }
  .lg\\:space-x-1\\/3> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(33.333333% * var(--space-x-reverse));
    margin-left: calc(33.333333% * calc(1 - var(--space-x-reverse)));
  }
  .lg\\:space-y-2\\/3> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(66.666667% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(66.666667% * var(--space-y-reverse));
  }
  .lg\\:space-x-2\\/3> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(66.666667% * var(--space-x-reverse));
    margin-left: calc(66.666667% * calc(1 - var(--space-x-reverse)));
  }
  .lg\\:space-y-1\\/4> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(25% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(25% * var(--space-y-reverse));
  }
  .lg\\:space-x-1\\/4> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(25% * var(--space-x-reverse));
    margin-left: calc(25% * calc(1 - var(--space-x-reverse)));
  }
  .lg\\:space-y-2\\/4> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(50% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(50% * var(--space-y-reverse));
  }
  .lg\\:space-x-2\\/4> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(50% * var(--space-x-reverse));
    margin-left: calc(50% * calc(1 - var(--space-x-reverse)));
  }
  .lg\\:space-y-3\\/4> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(75% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(75% * var(--space-y-reverse));
  }
  .lg\\:space-x-3\\/4> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(75% * var(--space-x-reverse));
    margin-left: calc(75% * calc(1 - var(--space-x-reverse)));
  }
  .lg\\:space-y-1\\/5> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(20% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(20% * var(--space-y-reverse));
  }
  .lg\\:space-x-1\\/5> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(20% * var(--space-x-reverse));
    margin-left: calc(20% * calc(1 - var(--space-x-reverse)));
  }
  .lg\\:space-y-2\\/5> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(40% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(40% * var(--space-y-reverse));
  }
  .lg\\:space-x-2\\/5> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(40% * var(--space-x-reverse));
    margin-left: calc(40% * calc(1 - var(--space-x-reverse)));
  }
  .lg\\:space-y-3\\/5> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(60% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(60% * var(--space-y-reverse));
  }
  .lg\\:space-x-3\\/5> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(60% * var(--space-x-reverse));
    margin-left: calc(60% * calc(1 - var(--space-x-reverse)));
  }
  .lg\\:space-y-4\\/5> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(80% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(80% * var(--space-y-reverse));
  }
  .lg\\:space-x-4\\/5> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(80% * var(--space-x-reverse));
    margin-left: calc(80% * calc(1 - var(--space-x-reverse)));
  }
  .lg\\:space-y-1\\/6> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(16.666667% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(16.666667% * var(--space-y-reverse));
  }
  .lg\\:space-x-1\\/6> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(16.666667% * var(--space-x-reverse));
    margin-left: calc(16.666667% * calc(1 - var(--space-x-reverse)));
  }
  .lg\\:space-y-2\\/6> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(33.333333% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(33.333333% * var(--space-y-reverse));
  }
  .lg\\:space-x-2\\/6> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(33.333333% * var(--space-x-reverse));
    margin-left: calc(33.333333% * calc(1 - var(--space-x-reverse)));
  }
  .lg\\:space-y-3\\/6> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(50% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(50% * var(--space-y-reverse));
  }
  .lg\\:space-x-3\\/6> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(50% * var(--space-x-reverse));
    margin-left: calc(50% * calc(1 - var(--space-x-reverse)));
  }
  .lg\\:space-y-4\\/6> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(66.666667% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(66.666667% * var(--space-y-reverse));
  }
  .lg\\:space-x-4\\/6> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(66.666667% * var(--space-x-reverse));
    margin-left: calc(66.666667% * calc(1 - var(--space-x-reverse)));
  }
  .lg\\:space-y-5\\/6> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(83.333333% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(83.333333% * var(--space-y-reverse));
  }
  .lg\\:space-x-5\\/6> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(83.333333% * var(--space-x-reverse));
    margin-left: calc(83.333333% * calc(1 - var(--space-x-reverse)));
  }
  .lg\\:space-y-1\\/12> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(8.333333% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(8.333333% * var(--space-y-reverse));
  }
  .lg\\:space-x-1\\/12> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(8.333333% * var(--space-x-reverse));
    margin-left: calc(8.333333% * calc(1 - var(--space-x-reverse)));
  }
  .lg\\:space-y-2\\/12> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(16.666667% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(16.666667% * var(--space-y-reverse));
  }
  .lg\\:space-x-2\\/12> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(16.666667% * var(--space-x-reverse));
    margin-left: calc(16.666667% * calc(1 - var(--space-x-reverse)));
  }
  .lg\\:space-y-3\\/12> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(25% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(25% * var(--space-y-reverse));
  }
  .lg\\:space-x-3\\/12> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(25% * var(--space-x-reverse));
    margin-left: calc(25% * calc(1 - var(--space-x-reverse)));
  }
  .lg\\:space-y-4\\/12> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(33.333333% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(33.333333% * var(--space-y-reverse));
  }
  .lg\\:space-x-4\\/12> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(33.333333% * var(--space-x-reverse));
    margin-left: calc(33.333333% * calc(1 - var(--space-x-reverse)));
  }
  .lg\\:space-y-5\\/12> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(41.666667% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(41.666667% * var(--space-y-reverse));
  }
  .lg\\:space-x-5\\/12> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(41.666667% * var(--space-x-reverse));
    margin-left: calc(41.666667% * calc(1 - var(--space-x-reverse)));
  }
  .lg\\:space-y-6\\/12> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(50% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(50% * var(--space-y-reverse));
  }
  .lg\\:space-x-6\\/12> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(50% * var(--space-x-reverse));
    margin-left: calc(50% * calc(1 - var(--space-x-reverse)));
  }
  .lg\\:space-y-7\\/12> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(58.333333% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(58.333333% * var(--space-y-reverse));
  }
  .lg\\:space-x-7\\/12> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(58.333333% * var(--space-x-reverse));
    margin-left: calc(58.333333% * calc(1 - var(--space-x-reverse)));
  }
  .lg\\:space-y-8\\/12> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(66.666667% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(66.666667% * var(--space-y-reverse));
  }
  .lg\\:space-x-8\\/12> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(66.666667% * var(--space-x-reverse));
    margin-left: calc(66.666667% * calc(1 - var(--space-x-reverse)));
  }
  .lg\\:space-y-9\\/12> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(75% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(75% * var(--space-y-reverse));
  }
  .lg\\:space-x-9\\/12> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(75% * var(--space-x-reverse));
    margin-left: calc(75% * calc(1 - var(--space-x-reverse)));
  }
  .lg\\:space-y-10\\/12> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(83.333333% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(83.333333% * var(--space-y-reverse));
  }
  .lg\\:space-x-10\\/12> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(83.333333% * var(--space-x-reverse));
    margin-left: calc(83.333333% * calc(1 - var(--space-x-reverse)));
  }
  .lg\\:space-y-11\\/12> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(91.666667% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(91.666667% * var(--space-y-reverse));
  }
  .lg\\:space-x-11\\/12> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(91.666667% * var(--space-x-reverse));
    margin-left: calc(91.666667% * calc(1 - var(--space-x-reverse)));
  }
  .lg\\:space-y-full> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(100% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(100% * var(--space-y-reverse));
  }
  .lg\\:space-x-full> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(100% * var(--space-x-reverse));
    margin-left: calc(100% * calc(1 - var(--space-x-reverse)));
  }
  .lg\\:-space-y-1> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-0.25rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-0.25rem * var(--space-y-reverse));
  }
  .lg\\:-space-x-1> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-0.25rem * var(--space-x-reverse));
    margin-left: calc(-0.25rem * calc(1 - var(--space-x-reverse)));
  }
  .lg\\:-space-y-2> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-0.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-0.5rem * var(--space-y-reverse));
  }
  .lg\\:-space-x-2> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-0.5rem * var(--space-x-reverse));
    margin-left: calc(-0.5rem * calc(1 - var(--space-x-reverse)));
  }
  .lg\\:-space-y-3> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-0.75rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-0.75rem * var(--space-y-reverse));
  }
  .lg\\:-space-x-3> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-0.75rem * var(--space-x-reverse));
    margin-left: calc(-0.75rem * calc(1 - var(--space-x-reverse)));
  }
  .lg\\:-space-y-4> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-1rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-1rem * var(--space-y-reverse));
  }
  .lg\\:-space-x-4> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-1rem * var(--space-x-reverse));
    margin-left: calc(-1rem * calc(1 - var(--space-x-reverse)));
  }
  .lg\\:-space-y-5> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-1.25rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-1.25rem * var(--space-y-reverse));
  }
  .lg\\:-space-x-5> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-1.25rem * var(--space-x-reverse));
    margin-left: calc(-1.25rem * calc(1 - var(--space-x-reverse)));
  }
  .lg\\:-space-y-6> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-1.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-1.5rem * var(--space-y-reverse));
  }
  .lg\\:-space-x-6> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-1.5rem * var(--space-x-reverse));
    margin-left: calc(-1.5rem * calc(1 - var(--space-x-reverse)));
  }
  .lg\\:-space-y-7> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-1.75rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-1.75rem * var(--space-y-reverse));
  }
  .lg\\:-space-x-7> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-1.75rem * var(--space-x-reverse));
    margin-left: calc(-1.75rem * calc(1 - var(--space-x-reverse)));
  }
  .lg\\:-space-y-8> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-2rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-2rem * var(--space-y-reverse));
  }
  .lg\\:-space-x-8> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-2rem * var(--space-x-reverse));
    margin-left: calc(-2rem * calc(1 - var(--space-x-reverse)));
  }
  .lg\\:-space-y-9> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-2.25rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-2.25rem * var(--space-y-reverse));
  }
  .lg\\:-space-x-9> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-2.25rem * var(--space-x-reverse));
    margin-left: calc(-2.25rem * calc(1 - var(--space-x-reverse)));
  }
  .lg\\:-space-y-10> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-2.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-2.5rem * var(--space-y-reverse));
  }
  .lg\\:-space-x-10> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-2.5rem * var(--space-x-reverse));
    margin-left: calc(-2.5rem * calc(1 - var(--space-x-reverse)));
  }
  .lg\\:-space-y-11> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-2.75rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-2.75rem * var(--space-y-reverse));
  }
  .lg\\:-space-x-11> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-2.75rem * var(--space-x-reverse));
    margin-left: calc(-2.75rem * calc(1 - var(--space-x-reverse)));
  }
  .lg\\:-space-y-12> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-3rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-3rem * var(--space-y-reverse));
  }
  .lg\\:-space-x-12> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-3rem * var(--space-x-reverse));
    margin-left: calc(-3rem * calc(1 - var(--space-x-reverse)));
  }
  .lg\\:-space-y-13> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-3.25rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-3.25rem * var(--space-y-reverse));
  }
  .lg\\:-space-x-13> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-3.25rem * var(--space-x-reverse));
    margin-left: calc(-3.25rem * calc(1 - var(--space-x-reverse)));
  }
  .lg\\:-space-y-14> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-3.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-3.5rem * var(--space-y-reverse));
  }
  .lg\\:-space-x-14> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-3.5rem * var(--space-x-reverse));
    margin-left: calc(-3.5rem * calc(1 - var(--space-x-reverse)));
  }
  .lg\\:-space-y-15> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-3.75rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-3.75rem * var(--space-y-reverse));
  }
  .lg\\:-space-x-15> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-3.75rem * var(--space-x-reverse));
    margin-left: calc(-3.75rem * calc(1 - var(--space-x-reverse)));
  }
  .lg\\:-space-y-16> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-4rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-4rem * var(--space-y-reverse));
  }
  .lg\\:-space-x-16> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-4rem * var(--space-x-reverse));
    margin-left: calc(-4rem * calc(1 - var(--space-x-reverse)));
  }
  .lg\\:-space-y-20> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-5rem * var(--space-y-reverse));
  }
  .lg\\:-space-x-20> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-5rem * var(--space-x-reverse));
    margin-left: calc(-5rem * calc(1 - var(--space-x-reverse)));
  }
  .lg\\:-space-y-24> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-6rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-6rem * var(--space-y-reverse));
  }
  .lg\\:-space-x-24> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-6rem * var(--space-x-reverse));
    margin-left: calc(-6rem * calc(1 - var(--space-x-reverse)));
  }
  .lg\\:-space-y-28> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-7rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-7rem * var(--space-y-reverse));
  }
  .lg\\:-space-x-28> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-7rem * var(--space-x-reverse));
    margin-left: calc(-7rem * calc(1 - var(--space-x-reverse)));
  }
  .lg\\:-space-y-32> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-8rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-8rem * var(--space-y-reverse));
  }
  .lg\\:-space-x-32> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-8rem * var(--space-x-reverse));
    margin-left: calc(-8rem * calc(1 - var(--space-x-reverse)));
  }
  .lg\\:-space-y-36> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-9rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-9rem * var(--space-y-reverse));
  }
  .lg\\:-space-x-36> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-9rem * var(--space-x-reverse));
    margin-left: calc(-9rem * calc(1 - var(--space-x-reverse)));
  }
  .lg\\:-space-y-40> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-10rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-10rem * var(--space-y-reverse));
  }
  .lg\\:-space-x-40> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-10rem * var(--space-x-reverse));
    margin-left: calc(-10rem * calc(1 - var(--space-x-reverse)));
  }
  .lg\\:-space-y-44> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-11rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-11rem * var(--space-y-reverse));
  }
  .lg\\:-space-x-44> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-11rem * var(--space-x-reverse));
    margin-left: calc(-11rem * calc(1 - var(--space-x-reverse)));
  }
  .lg\\:-space-y-48> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-12rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-12rem * var(--space-y-reverse));
  }
  .lg\\:-space-x-48> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-12rem * var(--space-x-reverse));
    margin-left: calc(-12rem * calc(1 - var(--space-x-reverse)));
  }
  .lg\\:-space-y-52> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-13rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-13rem * var(--space-y-reverse));
  }
  .lg\\:-space-x-52> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-13rem * var(--space-x-reverse));
    margin-left: calc(-13rem * calc(1 - var(--space-x-reverse)));
  }
  .lg\\:-space-y-56> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-14rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-14rem * var(--space-y-reverse));
  }
  .lg\\:-space-x-56> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-14rem * var(--space-x-reverse));
    margin-left: calc(-14rem * calc(1 - var(--space-x-reverse)));
  }
  .lg\\:-space-y-60> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-15rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-15rem * var(--space-y-reverse));
  }
  .lg\\:-space-x-60> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-15rem * var(--space-x-reverse));
    margin-left: calc(-15rem * calc(1 - var(--space-x-reverse)));
  }
  .lg\\:-space-y-64> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-16rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-16rem * var(--space-y-reverse));
  }
  .lg\\:-space-x-64> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-16rem * var(--space-x-reverse));
    margin-left: calc(-16rem * calc(1 - var(--space-x-reverse)));
  }
  .lg\\:-space-y-72> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-18rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-18rem * var(--space-y-reverse));
  }
  .lg\\:-space-x-72> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-18rem * var(--space-x-reverse));
    margin-left: calc(-18rem * calc(1 - var(--space-x-reverse)));
  }
  .lg\\:-space-y-80> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-20rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-20rem * var(--space-y-reverse));
  }
  .lg\\:-space-x-80> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-20rem * var(--space-x-reverse));
    margin-left: calc(-20rem * calc(1 - var(--space-x-reverse)));
  }
  .lg\\:-space-y-96> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-24rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-24rem * var(--space-y-reverse));
  }
  .lg\\:-space-x-96> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-24rem * var(--space-x-reverse));
    margin-left: calc(-24rem * calc(1 - var(--space-x-reverse)));
  }
  .lg\\:-space-y-px> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-1px * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-1px * var(--space-y-reverse));
  }
  .lg\\:-space-x-px> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-1px * var(--space-x-reverse));
    margin-left: calc(-1px * calc(1 - var(--space-x-reverse)));
  }
  .lg\\:-space-y-0\\.5> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-0.125rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-0.125rem * var(--space-y-reverse));
  }
  .lg\\:-space-x-0\\.5> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-0.125rem * var(--space-x-reverse));
    margin-left: calc(-0.125rem * calc(1 - var(--space-x-reverse)));
  }
  .lg\\:-space-y-1\\.5> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-0.375rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-0.375rem * var(--space-y-reverse));
  }
  .lg\\:-space-x-1\\.5> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-0.375rem * var(--space-x-reverse));
    margin-left: calc(-0.375rem * calc(1 - var(--space-x-reverse)));
  }
  .lg\\:-space-y-2\\.5> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-0.625rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-0.625rem * var(--space-y-reverse));
  }
  .lg\\:-space-x-2\\.5> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-0.625rem * var(--space-x-reverse));
    margin-left: calc(-0.625rem * calc(1 - var(--space-x-reverse)));
  }
  .lg\\:-space-y-3\\.5> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-0.875rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-0.875rem * var(--space-y-reverse));
  }
  .lg\\:-space-x-3\\.5> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-0.875rem * var(--space-x-reverse));
    margin-left: calc(-0.875rem * calc(1 - var(--space-x-reverse)));
  }
  .lg\\:-space-y-1\\/2> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-50% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-50% * var(--space-y-reverse));
  }
  .lg\\:-space-x-1\\/2> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-50% * var(--space-x-reverse));
    margin-left: calc(-50% * calc(1 - var(--space-x-reverse)));
  }
  .lg\\:-space-y-1\\/3> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-33.33333% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-33.33333% * var(--space-y-reverse));
  }
  .lg\\:-space-x-1\\/3> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-33.33333% * var(--space-x-reverse));
    margin-left: calc(-33.33333% * calc(1 - var(--space-x-reverse)));
  }
  .lg\\:-space-y-2\\/3> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-66.66667% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-66.66667% * var(--space-y-reverse));
  }
  .lg\\:-space-x-2\\/3> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-66.66667% * var(--space-x-reverse));
    margin-left: calc(-66.66667% * calc(1 - var(--space-x-reverse)));
  }
  .lg\\:-space-y-1\\/4> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-25% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-25% * var(--space-y-reverse));
  }
  .lg\\:-space-x-1\\/4> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-25% * var(--space-x-reverse));
    margin-left: calc(-25% * calc(1 - var(--space-x-reverse)));
  }
  .lg\\:-space-y-2\\/4> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-50% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-50% * var(--space-y-reverse));
  }
  .lg\\:-space-x-2\\/4> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-50% * var(--space-x-reverse));
    margin-left: calc(-50% * calc(1 - var(--space-x-reverse)));
  }
  .lg\\:-space-y-3\\/4> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-75% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-75% * var(--space-y-reverse));
  }
  .lg\\:-space-x-3\\/4> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-75% * var(--space-x-reverse));
    margin-left: calc(-75% * calc(1 - var(--space-x-reverse)));
  }
  .lg\\:-space-y-1\\/5> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-20% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-20% * var(--space-y-reverse));
  }
  .lg\\:-space-x-1\\/5> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-20% * var(--space-x-reverse));
    margin-left: calc(-20% * calc(1 - var(--space-x-reverse)));
  }
  .lg\\:-space-y-2\\/5> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-40% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-40% * var(--space-y-reverse));
  }
  .lg\\:-space-x-2\\/5> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-40% * var(--space-x-reverse));
    margin-left: calc(-40% * calc(1 - var(--space-x-reverse)));
  }
  .lg\\:-space-y-3\\/5> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-60% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-60% * var(--space-y-reverse));
  }
  .lg\\:-space-x-3\\/5> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-60% * var(--space-x-reverse));
    margin-left: calc(-60% * calc(1 - var(--space-x-reverse)));
  }
  .lg\\:-space-y-4\\/5> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-80% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-80% * var(--space-y-reverse));
  }
  .lg\\:-space-x-4\\/5> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-80% * var(--space-x-reverse));
    margin-left: calc(-80% * calc(1 - var(--space-x-reverse)));
  }
  .lg\\:-space-y-1\\/6> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-16.66667% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-16.66667% * var(--space-y-reverse));
  }
  .lg\\:-space-x-1\\/6> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-16.66667% * var(--space-x-reverse));
    margin-left: calc(-16.66667% * calc(1 - var(--space-x-reverse)));
  }
  .lg\\:-space-y-2\\/6> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-33.33333% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-33.33333% * var(--space-y-reverse));
  }
  .lg\\:-space-x-2\\/6> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-33.33333% * var(--space-x-reverse));
    margin-left: calc(-33.33333% * calc(1 - var(--space-x-reverse)));
  }
  .lg\\:-space-y-3\\/6> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-50% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-50% * var(--space-y-reverse));
  }
  .lg\\:-space-x-3\\/6> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-50% * var(--space-x-reverse));
    margin-left: calc(-50% * calc(1 - var(--space-x-reverse)));
  }
  .lg\\:-space-y-4\\/6> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-66.66667% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-66.66667% * var(--space-y-reverse));
  }
  .lg\\:-space-x-4\\/6> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-66.66667% * var(--space-x-reverse));
    margin-left: calc(-66.66667% * calc(1 - var(--space-x-reverse)));
  }
  .lg\\:-space-y-5\\/6> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-83.33333% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-83.33333% * var(--space-y-reverse));
  }
  .lg\\:-space-x-5\\/6> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-83.33333% * var(--space-x-reverse));
    margin-left: calc(-83.33333% * calc(1 - var(--space-x-reverse)));
  }
  .lg\\:-space-y-1\\/12> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-8.33333% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-8.33333% * var(--space-y-reverse));
  }
  .lg\\:-space-x-1\\/12> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-8.33333% * var(--space-x-reverse));
    margin-left: calc(-8.33333% * calc(1 - var(--space-x-reverse)));
  }
  .lg\\:-space-y-2\\/12> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-16.66667% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-16.66667% * var(--space-y-reverse));
  }
  .lg\\:-space-x-2\\/12> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-16.66667% * var(--space-x-reverse));
    margin-left: calc(-16.66667% * calc(1 - var(--space-x-reverse)));
  }
  .lg\\:-space-y-3\\/12> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-25% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-25% * var(--space-y-reverse));
  }
  .lg\\:-space-x-3\\/12> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-25% * var(--space-x-reverse));
    margin-left: calc(-25% * calc(1 - var(--space-x-reverse)));
  }
  .lg\\:-space-y-4\\/12> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-33.33333% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-33.33333% * var(--space-y-reverse));
  }
  .lg\\:-space-x-4\\/12> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-33.33333% * var(--space-x-reverse));
    margin-left: calc(-33.33333% * calc(1 - var(--space-x-reverse)));
  }
  .lg\\:-space-y-5\\/12> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-41.66667% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-41.66667% * var(--space-y-reverse));
  }
  .lg\\:-space-x-5\\/12> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-41.66667% * var(--space-x-reverse));
    margin-left: calc(-41.66667% * calc(1 - var(--space-x-reverse)));
  }
  .lg\\:-space-y-6\\/12> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-50% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-50% * var(--space-y-reverse));
  }
  .lg\\:-space-x-6\\/12> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-50% * var(--space-x-reverse));
    margin-left: calc(-50% * calc(1 - var(--space-x-reverse)));
  }
  .lg\\:-space-y-7\\/12> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-58.33333% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-58.33333% * var(--space-y-reverse));
  }
  .lg\\:-space-x-7\\/12> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-58.33333% * var(--space-x-reverse));
    margin-left: calc(-58.33333% * calc(1 - var(--space-x-reverse)));
  }
  .lg\\:-space-y-8\\/12> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-66.66667% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-66.66667% * var(--space-y-reverse));
  }
  .lg\\:-space-x-8\\/12> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-66.66667% * var(--space-x-reverse));
    margin-left: calc(-66.66667% * calc(1 - var(--space-x-reverse)));
  }
  .lg\\:-space-y-9\\/12> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-75% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-75% * var(--space-y-reverse));
  }
  .lg\\:-space-x-9\\/12> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-75% * var(--space-x-reverse));
    margin-left: calc(-75% * calc(1 - var(--space-x-reverse)));
  }
  .lg\\:-space-y-10\\/12> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-83.33333% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-83.33333% * var(--space-y-reverse));
  }
  .lg\\:-space-x-10\\/12> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-83.33333% * var(--space-x-reverse));
    margin-left: calc(-83.33333% * calc(1 - var(--space-x-reverse)));
  }
  .lg\\:-space-y-11\\/12> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-91.66667% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-91.66667% * var(--space-y-reverse));
  }
  .lg\\:-space-x-11\\/12> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-91.66667% * var(--space-x-reverse));
    margin-left: calc(-91.66667% * calc(1 - var(--space-x-reverse)));
  }
  .lg\\:-space-y-full> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-100% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-100% * var(--space-y-reverse));
  }
  .lg\\:-space-x-full> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-100% * var(--space-x-reverse));
    margin-left: calc(-100% * calc(1 - var(--space-x-reverse)));
  }
  .lg\\:space-y-reverse> :not(template)~ :not(template) {
    --space-y-reverse: 1;
  }
  .lg\\:space-x-reverse> :not(template)~ :not(template) {
    --space-x-reverse: 1;
  }
  .lg\\:divide-y-0> :not(template)~ :not(template) {
    --divide-y-reverse: 0;
    border-top-width: calc(0px * calc(1 - var(--divide-y-reverse)));
    border-bottom-width: calc(0px * var(--divide-y-reverse));
  }
  .lg\\:divide-x-0> :not(template)~ :not(template) {
    --divide-x-reverse: 0;
    border-right-width: calc(0px * var(--divide-x-reverse));
    border-left-width: calc(0px * calc(1 - var(--divide-x-reverse)));
  }
  .lg\\:divide-y-2> :not(template)~ :not(template) {
    --divide-y-reverse: 0;
    border-top-width: calc(2px * calc(1 - var(--divide-y-reverse)));
    border-bottom-width: calc(2px * var(--divide-y-reverse));
  }
  .lg\\:divide-x-2> :not(template)~ :not(template) {
    --divide-x-reverse: 0;
    border-right-width: calc(2px * var(--divide-x-reverse));
    border-left-width: calc(2px * calc(1 - var(--divide-x-reverse)));
  }
  .lg\\:divide-y-4> :not(template)~ :not(template) {
    --divide-y-reverse: 0;
    border-top-width: calc(4px * calc(1 - var(--divide-y-reverse)));
    border-bottom-width: calc(4px * var(--divide-y-reverse));
  }
  .lg\\:divide-x-4> :not(template)~ :not(template) {
    --divide-x-reverse: 0;
    border-right-width: calc(4px * var(--divide-x-reverse));
    border-left-width: calc(4px * calc(1 - var(--divide-x-reverse)));
  }
  .lg\\:divide-y-8> :not(template)~ :not(template) {
    --divide-y-reverse: 0;
    border-top-width: calc(8px * calc(1 - var(--divide-y-reverse)));
    border-bottom-width: calc(8px * var(--divide-y-reverse));
  }
  .lg\\:divide-x-8> :not(template)~ :not(template) {
    --divide-x-reverse: 0;
    border-right-width: calc(8px * var(--divide-x-reverse));
    border-left-width: calc(8px * calc(1 - var(--divide-x-reverse)));
  }
  .lg\\:divide-y> :not(template)~ :not(template) {
    --divide-y-reverse: 0;
    border-top-width: calc(1px * calc(1 - var(--divide-y-reverse)));
    border-bottom-width: calc(1px * var(--divide-y-reverse));
  }
  .lg\\:divide-x> :not(template)~ :not(template) {
    --divide-x-reverse: 0;
    border-right-width: calc(1px * var(--divide-x-reverse));
    border-left-width: calc(1px * calc(1 - var(--divide-x-reverse)));
  }
  .lg\\:divide-y-reverse> :not(template)~ :not(template) {
    --divide-y-reverse: 1;
  }
  .lg\\:divide-x-reverse> :not(template)~ :not(template) {
    --divide-x-reverse: 1;
  }
  .lg\\:divide-current> :not(template)~ :not(template) {
    border-color: currentColor;
  }
  .lg\\:divide-transparent> :not(template)~ :not(template) {
    border-color: transparent;
  }
  .lg\\:divide-white> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #ffffff;
    border-color: rgba(255, 255, 255, var(--divide-opacity));
  }
  .lg\\:divide-black> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #000000;
    border-color: rgba(0, 0, 0, var(--divide-opacity));
  }
  .lg\\:divide-gray-50> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #f9fafb;
    border-color: rgba(249, 250, 251, var(--divide-opacity));
  }
  .lg\\:divide-gray-100> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #f4f5f7;
    border-color: rgba(244, 245, 247, var(--divide-opacity));
  }
  .lg\\:divide-gray-200> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #e5e7eb;
    border-color: rgba(229, 231, 235, var(--divide-opacity));
  }
  .lg\\:divide-gray-300> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #d2d6dc;
    border-color: rgba(210, 214, 220, var(--divide-opacity));
  }
  .lg\\:divide-gray-400> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #9fa6b2;
    border-color: rgba(159, 166, 178, var(--divide-opacity));
  }
  .lg\\:divide-gray-500> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #6b7280;
    border-color: rgba(107, 114, 128, var(--divide-opacity));
  }
  .lg\\:divide-gray-600> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #4b5563;
    border-color: rgba(75, 85, 99, var(--divide-opacity));
  }
  .lg\\:divide-gray-700> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #374151;
    border-color: rgba(55, 65, 81, var(--divide-opacity));
  }
  .lg\\:divide-gray-800> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #252f3f;
    border-color: rgba(37, 47, 63, var(--divide-opacity));
  }
  .lg\\:divide-gray-900> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #161e2e;
    border-color: rgba(22, 30, 46, var(--divide-opacity));
  }
  .lg\\:divide-red-50> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #fdf2f2;
    border-color: rgba(253, 242, 242, var(--divide-opacity));
  }
  .lg\\:divide-red-100> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #fde8e8;
    border-color: rgba(253, 232, 232, var(--divide-opacity));
  }
  .lg\\:divide-red-200> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #fbd5d5;
    border-color: rgba(251, 213, 213, var(--divide-opacity));
  }
  .lg\\:divide-red-300> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #f8b4b4;
    border-color: rgba(248, 180, 180, var(--divide-opacity));
  }
  .lg\\:divide-red-400> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #f98080;
    border-color: rgba(249, 128, 128, var(--divide-opacity));
  }
  .lg\\:divide-red-500> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #f05252;
    border-color: rgba(240, 82, 82, var(--divide-opacity));
  }
  .lg\\:divide-red-600> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #e02424;
    border-color: rgba(224, 36, 36, var(--divide-opacity));
  }
  .lg\\:divide-red-700> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #c81e1e;
    border-color: rgba(200, 30, 30, var(--divide-opacity));
  }
  .lg\\:divide-red-800> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #9b1c1c;
    border-color: rgba(155, 28, 28, var(--divide-opacity));
  }
  .lg\\:divide-red-900> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #771d1d;
    border-color: rgba(119, 29, 29, var(--divide-opacity));
  }
  .lg\\:divide-orange-50> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #fff8f1;
    border-color: rgba(255, 248, 241, var(--divide-opacity));
  }
  .lg\\:divide-orange-100> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #feecdc;
    border-color: rgba(254, 236, 220, var(--divide-opacity));
  }
  .lg\\:divide-orange-200> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #fcd9bd;
    border-color: rgba(252, 217, 189, var(--divide-opacity));
  }
  .lg\\:divide-orange-300> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #fdba8c;
    border-color: rgba(253, 186, 140, var(--divide-opacity));
  }
  .lg\\:divide-orange-400> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #ff8a4c;
    border-color: rgba(255, 138, 76, var(--divide-opacity));
  }
  .lg\\:divide-orange-500> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #ff5a1f;
    border-color: rgba(255, 90, 31, var(--divide-opacity));
  }
  .lg\\:divide-orange-600> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #d03801;
    border-color: rgba(208, 56, 1, var(--divide-opacity));
  }
  .lg\\:divide-orange-700> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #b43403;
    border-color: rgba(180, 52, 3, var(--divide-opacity));
  }
  .lg\\:divide-orange-800> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #8a2c0d;
    border-color: rgba(138, 44, 13, var(--divide-opacity));
  }
  .lg\\:divide-orange-900> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #73230d;
    border-color: rgba(115, 35, 13, var(--divide-opacity));
  }
  .lg\\:divide-yellow-50> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #fdfdea;
    border-color: rgba(253, 253, 234, var(--divide-opacity));
  }
  .lg\\:divide-yellow-100> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #fdf6b2;
    border-color: rgba(253, 246, 178, var(--divide-opacity));
  }
  .lg\\:divide-yellow-200> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #fce96a;
    border-color: rgba(252, 233, 106, var(--divide-opacity));
  }
  .lg\\:divide-yellow-300> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #faca15;
    border-color: rgba(250, 202, 21, var(--divide-opacity));
  }
  .lg\\:divide-yellow-400> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #e3a008;
    border-color: rgba(227, 160, 8, var(--divide-opacity));
  }
  .lg\\:divide-yellow-500> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #c27803;
    border-color: rgba(194, 120, 3, var(--divide-opacity));
  }
  .lg\\:divide-yellow-600> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #9f580a;
    border-color: rgba(159, 88, 10, var(--divide-opacity));
  }
  .lg\\:divide-yellow-700> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #8e4b10;
    border-color: rgba(142, 75, 16, var(--divide-opacity));
  }
  .lg\\:divide-yellow-800> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #723b13;
    border-color: rgba(114, 59, 19, var(--divide-opacity));
  }
  .lg\\:divide-yellow-900> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #633112;
    border-color: rgba(99, 49, 18, var(--divide-opacity));
  }
  .lg\\:divide-green-50> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #f3faf7;
    border-color: rgba(243, 250, 247, var(--divide-opacity));
  }
  .lg\\:divide-green-100> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #def7ec;
    border-color: rgba(222, 247, 236, var(--divide-opacity));
  }
  .lg\\:divide-green-200> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #bcf0da;
    border-color: rgba(188, 240, 218, var(--divide-opacity));
  }
  .lg\\:divide-green-300> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #84e1bc;
    border-color: rgba(132, 225, 188, var(--divide-opacity));
  }
  .lg\\:divide-green-400> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #31c48d;
    border-color: rgba(49, 196, 141, var(--divide-opacity));
  }
  .lg\\:divide-green-500> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #0e9f6e;
    border-color: rgba(14, 159, 110, var(--divide-opacity));
  }
  .lg\\:divide-green-600> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #057a55;
    border-color: rgba(5, 122, 85, var(--divide-opacity));
  }
  .lg\\:divide-green-700> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #046c4e;
    border-color: rgba(4, 108, 78, var(--divide-opacity));
  }
  .lg\\:divide-green-800> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #03543f;
    border-color: rgba(3, 84, 63, var(--divide-opacity));
  }
  .lg\\:divide-green-900> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #014737;
    border-color: rgba(1, 71, 55, var(--divide-opacity));
  }
  .lg\\:divide-teal-50> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #edfafa;
    border-color: rgba(237, 250, 250, var(--divide-opacity));
  }
  .lg\\:divide-teal-100> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #d5f5f6;
    border-color: rgba(213, 245, 246, var(--divide-opacity));
  }
  .lg\\:divide-teal-200> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #afecef;
    border-color: rgba(175, 236, 239, var(--divide-opacity));
  }
  .lg\\:divide-teal-300> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #7edce2;
    border-color: rgba(126, 220, 226, var(--divide-opacity));
  }
  .lg\\:divide-teal-400> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #16bdca;
    border-color: rgba(22, 189, 202, var(--divide-opacity));
  }
  .lg\\:divide-teal-500> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #0694a2;
    border-color: rgba(6, 148, 162, var(--divide-opacity));
  }
  .lg\\:divide-teal-600> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #047481;
    border-color: rgba(4, 116, 129, var(--divide-opacity));
  }
  .lg\\:divide-teal-700> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #036672;
    border-color: rgba(3, 102, 114, var(--divide-opacity));
  }
  .lg\\:divide-teal-800> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #05505c;
    border-color: rgba(5, 80, 92, var(--divide-opacity));
  }
  .lg\\:divide-teal-900> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #014451;
    border-color: rgba(1, 68, 81, var(--divide-opacity));
  }
  .lg\\:divide-blue-50> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #ebf5ff;
    border-color: rgba(235, 245, 255, var(--divide-opacity));
  }
  .lg\\:divide-blue-100> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #e1effe;
    border-color: rgba(225, 239, 254, var(--divide-opacity));
  }
  .lg\\:divide-blue-200> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #c3ddfd;
    border-color: rgba(195, 221, 253, var(--divide-opacity));
  }
  .lg\\:divide-blue-300> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #a4cafe;
    border-color: rgba(164, 202, 254, var(--divide-opacity));
  }
  .lg\\:divide-blue-400> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #76a9fa;
    border-color: rgba(118, 169, 250, var(--divide-opacity));
  }
  .lg\\:divide-blue-500> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #3f83f8;
    border-color: rgba(63, 131, 248, var(--divide-opacity));
  }
  .lg\\:divide-blue-600> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #1c64f2;
    border-color: rgba(28, 100, 242, var(--divide-opacity));
  }
  .lg\\:divide-blue-700> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #1a56db;
    border-color: rgba(26, 86, 219, var(--divide-opacity));
  }
  .lg\\:divide-blue-800> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #1e429f;
    border-color: rgba(30, 66, 159, var(--divide-opacity));
  }
  .lg\\:divide-blue-900> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #233876;
    border-color: rgba(35, 56, 118, var(--divide-opacity));
  }
  .lg\\:divide-indigo-50> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #f0f5ff;
    border-color: rgba(240, 245, 255, var(--divide-opacity));
  }
  .lg\\:divide-indigo-100> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #e5edff;
    border-color: rgba(229, 237, 255, var(--divide-opacity));
  }
  .lg\\:divide-indigo-200> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #cddbfe;
    border-color: rgba(205, 219, 254, var(--divide-opacity));
  }
  .lg\\:divide-indigo-300> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #b4c6fc;
    border-color: rgba(180, 198, 252, var(--divide-opacity));
  }
  .lg\\:divide-indigo-400> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #8da2fb;
    border-color: rgba(141, 162, 251, var(--divide-opacity));
  }
  .lg\\:divide-indigo-500> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #6875f5;
    border-color: rgba(104, 117, 245, var(--divide-opacity));
  }
  .lg\\:divide-indigo-600> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #5850ec;
    border-color: rgba(88, 80, 236, var(--divide-opacity));
  }
  .lg\\:divide-indigo-700> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #5145cd;
    border-color: rgba(81, 69, 205, var(--divide-opacity));
  }
  .lg\\:divide-indigo-800> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #42389d;
    border-color: rgba(66, 56, 157, var(--divide-opacity));
  }
  .lg\\:divide-indigo-900> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #362f78;
    border-color: rgba(54, 47, 120, var(--divide-opacity));
  }
  .lg\\:divide-purple-50> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #f6f5ff;
    border-color: rgba(246, 245, 255, var(--divide-opacity));
  }
  .lg\\:divide-purple-100> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #edebfe;
    border-color: rgba(237, 235, 254, var(--divide-opacity));
  }
  .lg\\:divide-purple-200> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #dcd7fe;
    border-color: rgba(220, 215, 254, var(--divide-opacity));
  }
  .lg\\:divide-purple-300> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #cabffd;
    border-color: rgba(202, 191, 253, var(--divide-opacity));
  }
  .lg\\:divide-purple-400> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #ac94fa;
    border-color: rgba(172, 148, 250, var(--divide-opacity));
  }
  .lg\\:divide-purple-500> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #9061f9;
    border-color: rgba(144, 97, 249, var(--divide-opacity));
  }
  .lg\\:divide-purple-600> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #7e3af2;
    border-color: rgba(126, 58, 242, var(--divide-opacity));
  }
  .lg\\:divide-purple-700> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #6c2bd9;
    border-color: rgba(108, 43, 217, var(--divide-opacity));
  }
  .lg\\:divide-purple-800> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #5521b5;
    border-color: rgba(85, 33, 181, var(--divide-opacity));
  }
  .lg\\:divide-purple-900> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #4a1d96;
    border-color: rgba(74, 29, 150, var(--divide-opacity));
  }
  .lg\\:divide-pink-50> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #fdf2f8;
    border-color: rgba(253, 242, 248, var(--divide-opacity));
  }
  .lg\\:divide-pink-100> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #fce8f3;
    border-color: rgba(252, 232, 243, var(--divide-opacity));
  }
  .lg\\:divide-pink-200> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #fad1e8;
    border-color: rgba(250, 209, 232, var(--divide-opacity));
  }
  .lg\\:divide-pink-300> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #f8b4d9;
    border-color: rgba(248, 180, 217, var(--divide-opacity));
  }
  .lg\\:divide-pink-400> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #f17eb8;
    border-color: rgba(241, 126, 184, var(--divide-opacity));
  }
  .lg\\:divide-pink-500> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #e74694;
    border-color: rgba(231, 70, 148, var(--divide-opacity));
  }
  .lg\\:divide-pink-600> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #d61f69;
    border-color: rgba(214, 31, 105, var(--divide-opacity));
  }
  .lg\\:divide-pink-700> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #bf125d;
    border-color: rgba(191, 18, 93, var(--divide-opacity));
  }
  .lg\\:divide-pink-800> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #99154b;
    border-color: rgba(153, 21, 75, var(--divide-opacity));
  }
  .lg\\:divide-pink-900> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #751a3d;
    border-color: rgba(117, 26, 61, var(--divide-opacity));
  }
  .lg\\:divide-cool-gray-50> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #f8fafc;
    border-color: rgba(248, 250, 252, var(--divide-opacity));
  }
  .lg\\:divide-cool-gray-100> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #f1f5f9;
    border-color: rgba(241, 245, 249, var(--divide-opacity));
  }
  .lg\\:divide-cool-gray-200> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #e2e8f0;
    border-color: rgba(226, 232, 240, var(--divide-opacity));
  }
  .lg\\:divide-cool-gray-300> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #cfd8e3;
    border-color: rgba(207, 216, 227, var(--divide-opacity));
  }
  .lg\\:divide-cool-gray-400> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #97a6ba;
    border-color: rgba(151, 166, 186, var(--divide-opacity));
  }
  .lg\\:divide-cool-gray-500> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #64748b;
    border-color: rgba(100, 116, 139, var(--divide-opacity));
  }
  .lg\\:divide-cool-gray-600> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #475569;
    border-color: rgba(71, 85, 105, var(--divide-opacity));
  }
  .lg\\:divide-cool-gray-700> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #364152;
    border-color: rgba(54, 65, 82, var(--divide-opacity));
  }
  .lg\\:divide-cool-gray-800> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #27303f;
    border-color: rgba(39, 48, 63, var(--divide-opacity));
  }
  .lg\\:divide-cool-gray-900> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #1a202e;
    border-color: rgba(26, 32, 46, var(--divide-opacity));
  }
  .lg\\:divide-solid> :not(template)~ :not(template) {
    border-style: solid;
  }
  .lg\\:divide-dashed> :not(template)~ :not(template) {
    border-style: dashed;
  }
  .lg\\:divide-dotted> :not(template)~ :not(template) {
    border-style: dotted;
  }
  .lg\\:divide-double> :not(template)~ :not(template) {
    border-style: double;
  }
  .lg\\:divide-none> :not(template)~ :not(template) {
    border-style: none;
  }
  .lg\\:divide-opacity-0> :not(template)~ :not(template) {
    --divide-opacity: 0;
  }
  .lg\\:divide-opacity-25> :not(template)~ :not(template) {
    --divide-opacity: 0.25;
  }
  .lg\\:divide-opacity-50> :not(template)~ :not(template) {
    --divide-opacity: 0.5;
  }
  .lg\\:divide-opacity-75> :not(template)~ :not(template) {
    --divide-opacity: 0.75;
  }
  .lg\\:divide-opacity-100> :not(template)~ :not(template) {
    --divide-opacity: 1;
  }
  .lg\\:sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border-width: 0;
  }
  .lg\\:not-sr-only {
    position: static;
    width: auto;
    height: auto;
    padding: 0;
    margin: 0;
    overflow: visible;
    clip: auto;
    white-space: normal;
  }
  .lg\\:focus\\:sr-only:focus {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border-width: 0;
  }
  .lg\\:focus\\:not-sr-only:focus {
    position: static;
    width: auto;
    height: auto;
    padding: 0;
    margin: 0;
    overflow: visible;
    clip: auto;
    white-space: normal;
  }
  .lg\\:appearance-none {
    appearance: none;
  }
  .lg\\:bg-fixed {
    background-attachment: fixed;
  }
  .lg\\:bg-local {
    background-attachment: local;
  }
  .lg\\:bg-scroll {
    background-attachment: scroll;
  }
  .lg\\:bg-clip-border {
    background-clip: border-box;
  }
  .lg\\:bg-clip-padding {
    background-clip: padding-box;
  }
  .lg\\:bg-clip-content {
    background-clip: content-box;
  }
  .lg\\:bg-clip-text {
    -webkit-background-clip: text;
    background-clip: text;
  }
  .lg\\:bg-current {
    background-color: currentColor;
  }
  .lg\\:bg-transparent {
    background-color: transparent;
  }
  .lg\\:bg-white {
    --bg-opacity: 1;
    background-color: #ffffff;
    background-color: rgba(255, 255, 255, var(--bg-opacity));
  }
  .lg\\:bg-black {
    --bg-opacity: 1;
    background-color: #000000;
    background-color: rgba(0, 0, 0, var(--bg-opacity));
  }
  .lg\\:bg-gray-50 {
    --bg-opacity: 1;
    background-color: #f9fafb;
    background-color: rgba(249, 250, 251, var(--bg-opacity));
  }
  .lg\\:bg-gray-100 {
    --bg-opacity: 1;
    background-color: #f4f5f7;
    background-color: rgba(244, 245, 247, var(--bg-opacity));
  }
  .lg\\:bg-gray-200 {
    --bg-opacity: 1;
    background-color: #e5e7eb;
    background-color: rgba(229, 231, 235, var(--bg-opacity));
  }
  .lg\\:bg-gray-300 {
    --bg-opacity: 1;
    background-color: #d2d6dc;
    background-color: rgba(210, 214, 220, var(--bg-opacity));
  }
  .lg\\:bg-gray-400 {
    --bg-opacity: 1;
    background-color: #9fa6b2;
    background-color: rgba(159, 166, 178, var(--bg-opacity));
  }
  .lg\\:bg-gray-500 {
    --bg-opacity: 1;
    background-color: #6b7280;
    background-color: rgba(107, 114, 128, var(--bg-opacity));
  }
  .lg\\:bg-gray-600 {
    --bg-opacity: 1;
    background-color: #4b5563;
    background-color: rgba(75, 85, 99, var(--bg-opacity));
  }
  .lg\\:bg-gray-700 {
    --bg-opacity: 1;
    background-color: #374151;
    background-color: rgba(55, 65, 81, var(--bg-opacity));
  }
  .lg\\:bg-gray-800 {
    --bg-opacity: 1;
    background-color: #252f3f;
    background-color: rgba(37, 47, 63, var(--bg-opacity));
  }
  .lg\\:bg-gray-900 {
    --bg-opacity: 1;
    background-color: #161e2e;
    background-color: rgba(22, 30, 46, var(--bg-opacity));
  }
  .lg\\:bg-red-50 {
    --bg-opacity: 1;
    background-color: #fdf2f2;
    background-color: rgba(253, 242, 242, var(--bg-opacity));
  }
  .lg\\:bg-red-100 {
    --bg-opacity: 1;
    background-color: #fde8e8;
    background-color: rgba(253, 232, 232, var(--bg-opacity));
  }
  .lg\\:bg-red-200 {
    --bg-opacity: 1;
    background-color: #fbd5d5;
    background-color: rgba(251, 213, 213, var(--bg-opacity));
  }
  .lg\\:bg-red-300 {
    --bg-opacity: 1;
    background-color: #f8b4b4;
    background-color: rgba(248, 180, 180, var(--bg-opacity));
  }
  .lg\\:bg-red-400 {
    --bg-opacity: 1;
    background-color: #f98080;
    background-color: rgba(249, 128, 128, var(--bg-opacity));
  }
  .lg\\:bg-red-500 {
    --bg-opacity: 1;
    background-color: #f05252;
    background-color: rgba(240, 82, 82, var(--bg-opacity));
  }
  .lg\\:bg-red-600 {
    --bg-opacity: 1;
    background-color: #e02424;
    background-color: rgba(224, 36, 36, var(--bg-opacity));
  }
  .lg\\:bg-red-700 {
    --bg-opacity: 1;
    background-color: #c81e1e;
    background-color: rgba(200, 30, 30, var(--bg-opacity));
  }
  .lg\\:bg-red-800 {
    --bg-opacity: 1;
    background-color: #9b1c1c;
    background-color: rgba(155, 28, 28, var(--bg-opacity));
  }
  .lg\\:bg-red-900 {
    --bg-opacity: 1;
    background-color: #771d1d;
    background-color: rgba(119, 29, 29, var(--bg-opacity));
  }
  .lg\\:bg-orange-50 {
    --bg-opacity: 1;
    background-color: #fff8f1;
    background-color: rgba(255, 248, 241, var(--bg-opacity));
  }
  .lg\\:bg-orange-100 {
    --bg-opacity: 1;
    background-color: #feecdc;
    background-color: rgba(254, 236, 220, var(--bg-opacity));
  }
  .lg\\:bg-orange-200 {
    --bg-opacity: 1;
    background-color: #fcd9bd;
    background-color: rgba(252, 217, 189, var(--bg-opacity));
  }
  .lg\\:bg-orange-300 {
    --bg-opacity: 1;
    background-color: #fdba8c;
    background-color: rgba(253, 186, 140, var(--bg-opacity));
  }
  .lg\\:bg-orange-400 {
    --bg-opacity: 1;
    background-color: #ff8a4c;
    background-color: rgba(255, 138, 76, var(--bg-opacity));
  }
  .lg\\:bg-orange-500 {
    --bg-opacity: 1;
    background-color: #ff5a1f;
    background-color: rgba(255, 90, 31, var(--bg-opacity));
  }
  .lg\\:bg-orange-600 {
    --bg-opacity: 1;
    background-color: #d03801;
    background-color: rgba(208, 56, 1, var(--bg-opacity));
  }
  .lg\\:bg-orange-700 {
    --bg-opacity: 1;
    background-color: #b43403;
    background-color: rgba(180, 52, 3, var(--bg-opacity));
  }
  .lg\\:bg-orange-800 {
    --bg-opacity: 1;
    background-color: #8a2c0d;
    background-color: rgba(138, 44, 13, var(--bg-opacity));
  }
  .lg\\:bg-orange-900 {
    --bg-opacity: 1;
    background-color: #73230d;
    background-color: rgba(115, 35, 13, var(--bg-opacity));
  }
  .lg\\:bg-yellow-50 {
    --bg-opacity: 1;
    background-color: #fdfdea;
    background-color: rgba(253, 253, 234, var(--bg-opacity));
  }
  .lg\\:bg-yellow-100 {
    --bg-opacity: 1;
    background-color: #fdf6b2;
    background-color: rgba(253, 246, 178, var(--bg-opacity));
  }
  .lg\\:bg-yellow-200 {
    --bg-opacity: 1;
    background-color: #fce96a;
    background-color: rgba(252, 233, 106, var(--bg-opacity));
  }
  .lg\\:bg-yellow-300 {
    --bg-opacity: 1;
    background-color: #faca15;
    background-color: rgba(250, 202, 21, var(--bg-opacity));
  }
  .lg\\:bg-yellow-400 {
    --bg-opacity: 1;
    background-color: #e3a008;
    background-color: rgba(227, 160, 8, var(--bg-opacity));
  }
  .lg\\:bg-yellow-500 {
    --bg-opacity: 1;
    background-color: #c27803;
    background-color: rgba(194, 120, 3, var(--bg-opacity));
  }
  .lg\\:bg-yellow-600 {
    --bg-opacity: 1;
    background-color: #9f580a;
    background-color: rgba(159, 88, 10, var(--bg-opacity));
  }
  .lg\\:bg-yellow-700 {
    --bg-opacity: 1;
    background-color: #8e4b10;
    background-color: rgba(142, 75, 16, var(--bg-opacity));
  }
  .lg\\:bg-yellow-800 {
    --bg-opacity: 1;
    background-color: #723b13;
    background-color: rgba(114, 59, 19, var(--bg-opacity));
  }
  .lg\\:bg-yellow-900 {
    --bg-opacity: 1;
    background-color: #633112;
    background-color: rgba(99, 49, 18, var(--bg-opacity));
  }
  .lg\\:bg-green-50 {
    --bg-opacity: 1;
    background-color: #f3faf7;
    background-color: rgba(243, 250, 247, var(--bg-opacity));
  }
  .lg\\:bg-green-100 {
    --bg-opacity: 1;
    background-color: #def7ec;
    background-color: rgba(222, 247, 236, var(--bg-opacity));
  }
  .lg\\:bg-green-200 {
    --bg-opacity: 1;
    background-color: #bcf0da;
    background-color: rgba(188, 240, 218, var(--bg-opacity));
  }
  .lg\\:bg-green-300 {
    --bg-opacity: 1;
    background-color: #84e1bc;
    background-color: rgba(132, 225, 188, var(--bg-opacity));
  }
  .lg\\:bg-green-400 {
    --bg-opacity: 1;
    background-color: #31c48d;
    background-color: rgba(49, 196, 141, var(--bg-opacity));
  }
  .lg\\:bg-green-500 {
    --bg-opacity: 1;
    background-color: #0e9f6e;
    background-color: rgba(14, 159, 110, var(--bg-opacity));
  }
  .lg\\:bg-green-600 {
    --bg-opacity: 1;
    background-color: #057a55;
    background-color: rgba(5, 122, 85, var(--bg-opacity));
  }
  .lg\\:bg-green-700 {
    --bg-opacity: 1;
    background-color: #046c4e;
    background-color: rgba(4, 108, 78, var(--bg-opacity));
  }
  .lg\\:bg-green-800 {
    --bg-opacity: 1;
    background-color: #03543f;
    background-color: rgba(3, 84, 63, var(--bg-opacity));
  }
  .lg\\:bg-green-900 {
    --bg-opacity: 1;
    background-color: #014737;
    background-color: rgba(1, 71, 55, var(--bg-opacity));
  }
  .lg\\:bg-teal-50 {
    --bg-opacity: 1;
    background-color: #edfafa;
    background-color: rgba(237, 250, 250, var(--bg-opacity));
  }
  .lg\\:bg-teal-100 {
    --bg-opacity: 1;
    background-color: #d5f5f6;
    background-color: rgba(213, 245, 246, var(--bg-opacity));
  }
  .lg\\:bg-teal-200 {
    --bg-opacity: 1;
    background-color: #afecef;
    background-color: rgba(175, 236, 239, var(--bg-opacity));
  }
  .lg\\:bg-teal-300 {
    --bg-opacity: 1;
    background-color: #7edce2;
    background-color: rgba(126, 220, 226, var(--bg-opacity));
  }
  .lg\\:bg-teal-400 {
    --bg-opacity: 1;
    background-color: #16bdca;
    background-color: rgba(22, 189, 202, var(--bg-opacity));
  }
  .lg\\:bg-teal-500 {
    --bg-opacity: 1;
    background-color: #0694a2;
    background-color: rgba(6, 148, 162, var(--bg-opacity));
  }
  .lg\\:bg-teal-600 {
    --bg-opacity: 1;
    background-color: #047481;
    background-color: rgba(4, 116, 129, var(--bg-opacity));
  }
  .lg\\:bg-teal-700 {
    --bg-opacity: 1;
    background-color: #036672;
    background-color: rgba(3, 102, 114, var(--bg-opacity));
  }
  .lg\\:bg-teal-800 {
    --bg-opacity: 1;
    background-color: #05505c;
    background-color: rgba(5, 80, 92, var(--bg-opacity));
  }
  .lg\\:bg-teal-900 {
    --bg-opacity: 1;
    background-color: #014451;
    background-color: rgba(1, 68, 81, var(--bg-opacity));
  }
  .lg\\:bg-blue-50 {
    --bg-opacity: 1;
    background-color: #ebf5ff;
    background-color: rgba(235, 245, 255, var(--bg-opacity));
  }
  .lg\\:bg-blue-100 {
    --bg-opacity: 1;
    background-color: #e1effe;
    background-color: rgba(225, 239, 254, var(--bg-opacity));
  }
  .lg\\:bg-blue-200 {
    --bg-opacity: 1;
    background-color: #c3ddfd;
    background-color: rgba(195, 221, 253, var(--bg-opacity));
  }
  .lg\\:bg-blue-300 {
    --bg-opacity: 1;
    background-color: #a4cafe;
    background-color: rgba(164, 202, 254, var(--bg-opacity));
  }
  .lg\\:bg-blue-400 {
    --bg-opacity: 1;
    background-color: #76a9fa;
    background-color: rgba(118, 169, 250, var(--bg-opacity));
  }
  .lg\\:bg-blue-500 {
    --bg-opacity: 1;
    background-color: #3f83f8;
    background-color: rgba(63, 131, 248, var(--bg-opacity));
  }
  .lg\\:bg-blue-600 {
    --bg-opacity: 1;
    background-color: #1c64f2;
    background-color: rgba(28, 100, 242, var(--bg-opacity));
  }
  .lg\\:bg-blue-700 {
    --bg-opacity: 1;
    background-color: #1a56db;
    background-color: rgba(26, 86, 219, var(--bg-opacity));
  }
  .lg\\:bg-blue-800 {
    --bg-opacity: 1;
    background-color: #1e429f;
    background-color: rgba(30, 66, 159, var(--bg-opacity));
  }
  .lg\\:bg-blue-900 {
    --bg-opacity: 1;
    background-color: #233876;
    background-color: rgba(35, 56, 118, var(--bg-opacity));
  }
  .lg\\:bg-indigo-50 {
    --bg-opacity: 1;
    background-color: #f0f5ff;
    background-color: rgba(240, 245, 255, var(--bg-opacity));
  }
  .lg\\:bg-indigo-100 {
    --bg-opacity: 1;
    background-color: #e5edff;
    background-color: rgba(229, 237, 255, var(--bg-opacity));
  }
  .lg\\:bg-indigo-200 {
    --bg-opacity: 1;
    background-color: #cddbfe;
    background-color: rgba(205, 219, 254, var(--bg-opacity));
  }
  .lg\\:bg-indigo-300 {
    --bg-opacity: 1;
    background-color: #b4c6fc;
    background-color: rgba(180, 198, 252, var(--bg-opacity));
  }
  .lg\\:bg-indigo-400 {
    --bg-opacity: 1;
    background-color: #8da2fb;
    background-color: rgba(141, 162, 251, var(--bg-opacity));
  }
  .lg\\:bg-indigo-500 {
    --bg-opacity: 1;
    background-color: #6875f5;
    background-color: rgba(104, 117, 245, var(--bg-opacity));
  }
  .lg\\:bg-indigo-600 {
    --bg-opacity: 1;
    background-color: #5850ec;
    background-color: rgba(88, 80, 236, var(--bg-opacity));
  }
  .lg\\:bg-indigo-700 {
    --bg-opacity: 1;
    background-color: #5145cd;
    background-color: rgba(81, 69, 205, var(--bg-opacity));
  }
  .lg\\:bg-indigo-800 {
    --bg-opacity: 1;
    background-color: #42389d;
    background-color: rgba(66, 56, 157, var(--bg-opacity));
  }
  .lg\\:bg-indigo-900 {
    --bg-opacity: 1;
    background-color: #362f78;
    background-color: rgba(54, 47, 120, var(--bg-opacity));
  }
  .lg\\:bg-purple-50 {
    --bg-opacity: 1;
    background-color: #f6f5ff;
    background-color: rgba(246, 245, 255, var(--bg-opacity));
  }
  .lg\\:bg-purple-100 {
    --bg-opacity: 1;
    background-color: #edebfe;
    background-color: rgba(237, 235, 254, var(--bg-opacity));
  }
  .lg\\:bg-purple-200 {
    --bg-opacity: 1;
    background-color: #dcd7fe;
    background-color: rgba(220, 215, 254, var(--bg-opacity));
  }
  .lg\\:bg-purple-300 {
    --bg-opacity: 1;
    background-color: #cabffd;
    background-color: rgba(202, 191, 253, var(--bg-opacity));
  }
  .lg\\:bg-purple-400 {
    --bg-opacity: 1;
    background-color: #ac94fa;
    background-color: rgba(172, 148, 250, var(--bg-opacity));
  }
  .lg\\:bg-purple-500 {
    --bg-opacity: 1;
    background-color: #9061f9;
    background-color: rgba(144, 97, 249, var(--bg-opacity));
  }
  .lg\\:bg-purple-600 {
    --bg-opacity: 1;
    background-color: #7e3af2;
    background-color: rgba(126, 58, 242, var(--bg-opacity));
  }
  .lg\\:bg-purple-700 {
    --bg-opacity: 1;
    background-color: #6c2bd9;
    background-color: rgba(108, 43, 217, var(--bg-opacity));
  }
  .lg\\:bg-purple-800 {
    --bg-opacity: 1;
    background-color: #5521b5;
    background-color: rgba(85, 33, 181, var(--bg-opacity));
  }
  .lg\\:bg-purple-900 {
    --bg-opacity: 1;
    background-color: #4a1d96;
    background-color: rgba(74, 29, 150, var(--bg-opacity));
  }
  .lg\\:bg-pink-50 {
    --bg-opacity: 1;
    background-color: #fdf2f8;
    background-color: rgba(253, 242, 248, var(--bg-opacity));
  }
  .lg\\:bg-pink-100 {
    --bg-opacity: 1;
    background-color: #fce8f3;
    background-color: rgba(252, 232, 243, var(--bg-opacity));
  }
  .lg\\:bg-pink-200 {
    --bg-opacity: 1;
    background-color: #fad1e8;
    background-color: rgba(250, 209, 232, var(--bg-opacity));
  }
  .lg\\:bg-pink-300 {
    --bg-opacity: 1;
    background-color: #f8b4d9;
    background-color: rgba(248, 180, 217, var(--bg-opacity));
  }
  .lg\\:bg-pink-400 {
    --bg-opacity: 1;
    background-color: #f17eb8;
    background-color: rgba(241, 126, 184, var(--bg-opacity));
  }
  .lg\\:bg-pink-500 {
    --bg-opacity: 1;
    background-color: #e74694;
    background-color: rgba(231, 70, 148, var(--bg-opacity));
  }
  .lg\\:bg-pink-600 {
    --bg-opacity: 1;
    background-color: #d61f69;
    background-color: rgba(214, 31, 105, var(--bg-opacity));
  }
  .lg\\:bg-pink-700 {
    --bg-opacity: 1;
    background-color: #bf125d;
    background-color: rgba(191, 18, 93, var(--bg-opacity));
  }
  .lg\\:bg-pink-800 {
    --bg-opacity: 1;
    background-color: #99154b;
    background-color: rgba(153, 21, 75, var(--bg-opacity));
  }
  .lg\\:bg-pink-900 {
    --bg-opacity: 1;
    background-color: #751a3d;
    background-color: rgba(117, 26, 61, var(--bg-opacity));
  }
  .lg\\:bg-cool-gray-50 {
    --bg-opacity: 1;
    background-color: #f8fafc;
    background-color: rgba(248, 250, 252, var(--bg-opacity));
  }
  .lg\\:bg-cool-gray-100 {
    --bg-opacity: 1;
    background-color: #f1f5f9;
    background-color: rgba(241, 245, 249, var(--bg-opacity));
  }
  .lg\\:bg-cool-gray-200 {
    --bg-opacity: 1;
    background-color: #e2e8f0;
    background-color: rgba(226, 232, 240, var(--bg-opacity));
  }
  .lg\\:bg-cool-gray-300 {
    --bg-opacity: 1;
    background-color: #cfd8e3;
    background-color: rgba(207, 216, 227, var(--bg-opacity));
  }
  .lg\\:bg-cool-gray-400 {
    --bg-opacity: 1;
    background-color: #97a6ba;
    background-color: rgba(151, 166, 186, var(--bg-opacity));
  }
  .lg\\:bg-cool-gray-500 {
    --bg-opacity: 1;
    background-color: #64748b;
    background-color: rgba(100, 116, 139, var(--bg-opacity));
  }
  .lg\\:bg-cool-gray-600 {
    --bg-opacity: 1;
    background-color: #475569;
    background-color: rgba(71, 85, 105, var(--bg-opacity));
  }
  .lg\\:bg-cool-gray-700 {
    --bg-opacity: 1;
    background-color: #364152;
    background-color: rgba(54, 65, 82, var(--bg-opacity));
  }
  .lg\\:bg-cool-gray-800 {
    --bg-opacity: 1;
    background-color: #27303f;
    background-color: rgba(39, 48, 63, var(--bg-opacity));
  }
  .lg\\:bg-cool-gray-900 {
    --bg-opacity: 1;
    background-color: #1a202e;
    background-color: rgba(26, 32, 46, var(--bg-opacity));
  }
  .group:hover .lg\\:group-hover\\:bg-current {
    background-color: currentColor;
  }
  .group:hover .lg\\:group-hover\\:bg-transparent {
    background-color: transparent;
  }
  .group:hover .lg\\:group-hover\\:bg-white {
    --bg-opacity: 1;
    background-color: #ffffff;
    background-color: rgba(255, 255, 255, var(--bg-opacity));
  }
  .group:hover .lg\\:group-hover\\:bg-black {
    --bg-opacity: 1;
    background-color: #000000;
    background-color: rgba(0, 0, 0, var(--bg-opacity));
  }
  .group:hover .lg\\:group-hover\\:bg-gray-50 {
    --bg-opacity: 1;
    background-color: #f9fafb;
    background-color: rgba(249, 250, 251, var(--bg-opacity));
  }
  .group:hover .lg\\:group-hover\\:bg-gray-100 {
    --bg-opacity: 1;
    background-color: #f4f5f7;
    background-color: rgba(244, 245, 247, var(--bg-opacity));
  }
  .group:hover .lg\\:group-hover\\:bg-gray-200 {
    --bg-opacity: 1;
    background-color: #e5e7eb;
    background-color: rgba(229, 231, 235, var(--bg-opacity));
  }
  .group:hover .lg\\:group-hover\\:bg-gray-300 {
    --bg-opacity: 1;
    background-color: #d2d6dc;
    background-color: rgba(210, 214, 220, var(--bg-opacity));
  }
  .group:hover .lg\\:group-hover\\:bg-gray-400 {
    --bg-opacity: 1;
    background-color: #9fa6b2;
    background-color: rgba(159, 166, 178, var(--bg-opacity));
  }
  .group:hover .lg\\:group-hover\\:bg-gray-500 {
    --bg-opacity: 1;
    background-color: #6b7280;
    background-color: rgba(107, 114, 128, var(--bg-opacity));
  }
  .group:hover .lg\\:group-hover\\:bg-gray-600 {
    --bg-opacity: 1;
    background-color: #4b5563;
    background-color: rgba(75, 85, 99, var(--bg-opacity));
  }
  .group:hover .lg\\:group-hover\\:bg-gray-700 {
    --bg-opacity: 1;
    background-color: #374151;
    background-color: rgba(55, 65, 81, var(--bg-opacity));
  }
  .group:hover .lg\\:group-hover\\:bg-gray-800 {
    --bg-opacity: 1;
    background-color: #252f3f;
    background-color: rgba(37, 47, 63, var(--bg-opacity));
  }
  .group:hover .lg\\:group-hover\\:bg-gray-900 {
    --bg-opacity: 1;
    background-color: #161e2e;
    background-color: rgba(22, 30, 46, var(--bg-opacity));
  }
  .group:hover .lg\\:group-hover\\:bg-red-50 {
    --bg-opacity: 1;
    background-color: #fdf2f2;
    background-color: rgba(253, 242, 242, var(--bg-opacity));
  }
  .group:hover .lg\\:group-hover\\:bg-red-100 {
    --bg-opacity: 1;
    background-color: #fde8e8;
    background-color: rgba(253, 232, 232, var(--bg-opacity));
  }
  .group:hover .lg\\:group-hover\\:bg-red-200 {
    --bg-opacity: 1;
    background-color: #fbd5d5;
    background-color: rgba(251, 213, 213, var(--bg-opacity));
  }
  .group:hover .lg\\:group-hover\\:bg-red-300 {
    --bg-opacity: 1;
    background-color: #f8b4b4;
    background-color: rgba(248, 180, 180, var(--bg-opacity));
  }
  .group:hover .lg\\:group-hover\\:bg-red-400 {
    --bg-opacity: 1;
    background-color: #f98080;
    background-color: rgba(249, 128, 128, var(--bg-opacity));
  }
  .group:hover .lg\\:group-hover\\:bg-red-500 {
    --bg-opacity: 1;
    background-color: #f05252;
    background-color: rgba(240, 82, 82, var(--bg-opacity));
  }
  .group:hover .lg\\:group-hover\\:bg-red-600 {
    --bg-opacity: 1;
    background-color: #e02424;
    background-color: rgba(224, 36, 36, var(--bg-opacity));
  }
  .group:hover .lg\\:group-hover\\:bg-red-700 {
    --bg-opacity: 1;
    background-color: #c81e1e;
    background-color: rgba(200, 30, 30, var(--bg-opacity));
  }
  .group:hover .lg\\:group-hover\\:bg-red-800 {
    --bg-opacity: 1;
    background-color: #9b1c1c;
    background-color: rgba(155, 28, 28, var(--bg-opacity));
  }
  .group:hover .lg\\:group-hover\\:bg-red-900 {
    --bg-opacity: 1;
    background-color: #771d1d;
    background-color: rgba(119, 29, 29, var(--bg-opacity));
  }
  .group:hover .lg\\:group-hover\\:bg-orange-50 {
    --bg-opacity: 1;
    background-color: #fff8f1;
    background-color: rgba(255, 248, 241, var(--bg-opacity));
  }
  .group:hover .lg\\:group-hover\\:bg-orange-100 {
    --bg-opacity: 1;
    background-color: #feecdc;
    background-color: rgba(254, 236, 220, var(--bg-opacity));
  }
  .group:hover .lg\\:group-hover\\:bg-orange-200 {
    --bg-opacity: 1;
    background-color: #fcd9bd;
    background-color: rgba(252, 217, 189, var(--bg-opacity));
  }
  .group:hover .lg\\:group-hover\\:bg-orange-300 {
    --bg-opacity: 1;
    background-color: #fdba8c;
    background-color: rgba(253, 186, 140, var(--bg-opacity));
  }
  .group:hover .lg\\:group-hover\\:bg-orange-400 {
    --bg-opacity: 1;
    background-color: #ff8a4c;
    background-color: rgba(255, 138, 76, var(--bg-opacity));
  }
  .group:hover .lg\\:group-hover\\:bg-orange-500 {
    --bg-opacity: 1;
    background-color: #ff5a1f;
    background-color: rgba(255, 90, 31, var(--bg-opacity));
  }
  .group:hover .lg\\:group-hover\\:bg-orange-600 {
    --bg-opacity: 1;
    background-color: #d03801;
    background-color: rgba(208, 56, 1, var(--bg-opacity));
  }
  .group:hover .lg\\:group-hover\\:bg-orange-700 {
    --bg-opacity: 1;
    background-color: #b43403;
    background-color: rgba(180, 52, 3, var(--bg-opacity));
  }
  .group:hover .lg\\:group-hover\\:bg-orange-800 {
    --bg-opacity: 1;
    background-color: #8a2c0d;
    background-color: rgba(138, 44, 13, var(--bg-opacity));
  }
  .group:hover .lg\\:group-hover\\:bg-orange-900 {
    --bg-opacity: 1;
    background-color: #73230d;
    background-color: rgba(115, 35, 13, var(--bg-opacity));
  }
  .group:hover .lg\\:group-hover\\:bg-yellow-50 {
    --bg-opacity: 1;
    background-color: #fdfdea;
    background-color: rgba(253, 253, 234, var(--bg-opacity));
  }
  .group:hover .lg\\:group-hover\\:bg-yellow-100 {
    --bg-opacity: 1;
    background-color: #fdf6b2;
    background-color: rgba(253, 246, 178, var(--bg-opacity));
  }
  .group:hover .lg\\:group-hover\\:bg-yellow-200 {
    --bg-opacity: 1;
    background-color: #fce96a;
    background-color: rgba(252, 233, 106, var(--bg-opacity));
  }
  .group:hover .lg\\:group-hover\\:bg-yellow-300 {
    --bg-opacity: 1;
    background-color: #faca15;
    background-color: rgba(250, 202, 21, var(--bg-opacity));
  }
  .group:hover .lg\\:group-hover\\:bg-yellow-400 {
    --bg-opacity: 1;
    background-color: #e3a008;
    background-color: rgba(227, 160, 8, var(--bg-opacity));
  }
  .group:hover .lg\\:group-hover\\:bg-yellow-500 {
    --bg-opacity: 1;
    background-color: #c27803;
    background-color: rgba(194, 120, 3, var(--bg-opacity));
  }
  .group:hover .lg\\:group-hover\\:bg-yellow-600 {
    --bg-opacity: 1;
    background-color: #9f580a;
    background-color: rgba(159, 88, 10, var(--bg-opacity));
  }
  .group:hover .lg\\:group-hover\\:bg-yellow-700 {
    --bg-opacity: 1;
    background-color: #8e4b10;
    background-color: rgba(142, 75, 16, var(--bg-opacity));
  }
  .group:hover .lg\\:group-hover\\:bg-yellow-800 {
    --bg-opacity: 1;
    background-color: #723b13;
    background-color: rgba(114, 59, 19, var(--bg-opacity));
  }
  .group:hover .lg\\:group-hover\\:bg-yellow-900 {
    --bg-opacity: 1;
    background-color: #633112;
    background-color: rgba(99, 49, 18, var(--bg-opacity));
  }
  .group:hover .lg\\:group-hover\\:bg-green-50 {
    --bg-opacity: 1;
    background-color: #f3faf7;
    background-color: rgba(243, 250, 247, var(--bg-opacity));
  }
  .group:hover .lg\\:group-hover\\:bg-green-100 {
    --bg-opacity: 1;
    background-color: #def7ec;
    background-color: rgba(222, 247, 236, var(--bg-opacity));
  }
  .group:hover .lg\\:group-hover\\:bg-green-200 {
    --bg-opacity: 1;
    background-color: #bcf0da;
    background-color: rgba(188, 240, 218, var(--bg-opacity));
  }
  .group:hover .lg\\:group-hover\\:bg-green-300 {
    --bg-opacity: 1;
    background-color: #84e1bc;
    background-color: rgba(132, 225, 188, var(--bg-opacity));
  }
  .group:hover .lg\\:group-hover\\:bg-green-400 {
    --bg-opacity: 1;
    background-color: #31c48d;
    background-color: rgba(49, 196, 141, var(--bg-opacity));
  }
  .group:hover .lg\\:group-hover\\:bg-green-500 {
    --bg-opacity: 1;
    background-color: #0e9f6e;
    background-color: rgba(14, 159, 110, var(--bg-opacity));
  }
  .group:hover .lg\\:group-hover\\:bg-green-600 {
    --bg-opacity: 1;
    background-color: #057a55;
    background-color: rgba(5, 122, 85, var(--bg-opacity));
  }
  .group:hover .lg\\:group-hover\\:bg-green-700 {
    --bg-opacity: 1;
    background-color: #046c4e;
    background-color: rgba(4, 108, 78, var(--bg-opacity));
  }
  .group:hover .lg\\:group-hover\\:bg-green-800 {
    --bg-opacity: 1;
    background-color: #03543f;
    background-color: rgba(3, 84, 63, var(--bg-opacity));
  }
  .group:hover .lg\\:group-hover\\:bg-green-900 {
    --bg-opacity: 1;
    background-color: #014737;
    background-color: rgba(1, 71, 55, var(--bg-opacity));
  }
  .group:hover .lg\\:group-hover\\:bg-teal-50 {
    --bg-opacity: 1;
    background-color: #edfafa;
    background-color: rgba(237, 250, 250, var(--bg-opacity));
  }
  .group:hover .lg\\:group-hover\\:bg-teal-100 {
    --bg-opacity: 1;
    background-color: #d5f5f6;
    background-color: rgba(213, 245, 246, var(--bg-opacity));
  }
  .group:hover .lg\\:group-hover\\:bg-teal-200 {
    --bg-opacity: 1;
    background-color: #afecef;
    background-color: rgba(175, 236, 239, var(--bg-opacity));
  }
  .group:hover .lg\\:group-hover\\:bg-teal-300 {
    --bg-opacity: 1;
    background-color: #7edce2;
    background-color: rgba(126, 220, 226, var(--bg-opacity));
  }
  .group:hover .lg\\:group-hover\\:bg-teal-400 {
    --bg-opacity: 1;
    background-color: #16bdca;
    background-color: rgba(22, 189, 202, var(--bg-opacity));
  }
  .group:hover .lg\\:group-hover\\:bg-teal-500 {
    --bg-opacity: 1;
    background-color: #0694a2;
    background-color: rgba(6, 148, 162, var(--bg-opacity));
  }
  .group:hover .lg\\:group-hover\\:bg-teal-600 {
    --bg-opacity: 1;
    background-color: #047481;
    background-color: rgba(4, 116, 129, var(--bg-opacity));
  }
  .group:hover .lg\\:group-hover\\:bg-teal-700 {
    --bg-opacity: 1;
    background-color: #036672;
    background-color: rgba(3, 102, 114, var(--bg-opacity));
  }
  .group:hover .lg\\:group-hover\\:bg-teal-800 {
    --bg-opacity: 1;
    background-color: #05505c;
    background-color: rgba(5, 80, 92, var(--bg-opacity));
  }
  .group:hover .lg\\:group-hover\\:bg-teal-900 {
    --bg-opacity: 1;
    background-color: #014451;
    background-color: rgba(1, 68, 81, var(--bg-opacity));
  }
  .group:hover .lg\\:group-hover\\:bg-blue-50 {
    --bg-opacity: 1;
    background-color: #ebf5ff;
    background-color: rgba(235, 245, 255, var(--bg-opacity));
  }
  .group:hover .lg\\:group-hover\\:bg-blue-100 {
    --bg-opacity: 1;
    background-color: #e1effe;
    background-color: rgba(225, 239, 254, var(--bg-opacity));
  }
  .group:hover .lg\\:group-hover\\:bg-blue-200 {
    --bg-opacity: 1;
    background-color: #c3ddfd;
    background-color: rgba(195, 221, 253, var(--bg-opacity));
  }
  .group:hover .lg\\:group-hover\\:bg-blue-300 {
    --bg-opacity: 1;
    background-color: #a4cafe;
    background-color: rgba(164, 202, 254, var(--bg-opacity));
  }
  .group:hover .lg\\:group-hover\\:bg-blue-400 {
    --bg-opacity: 1;
    background-color: #76a9fa;
    background-color: rgba(118, 169, 250, var(--bg-opacity));
  }
  .group:hover .lg\\:group-hover\\:bg-blue-500 {
    --bg-opacity: 1;
    background-color: #3f83f8;
    background-color: rgba(63, 131, 248, var(--bg-opacity));
  }
  .group:hover .lg\\:group-hover\\:bg-blue-600 {
    --bg-opacity: 1;
    background-color: #1c64f2;
    background-color: rgba(28, 100, 242, var(--bg-opacity));
  }
  .group:hover .lg\\:group-hover\\:bg-blue-700 {
    --bg-opacity: 1;
    background-color: #1a56db;
    background-color: rgba(26, 86, 219, var(--bg-opacity));
  }
  .group:hover .lg\\:group-hover\\:bg-blue-800 {
    --bg-opacity: 1;
    background-color: #1e429f;
    background-color: rgba(30, 66, 159, var(--bg-opacity));
  }
  .group:hover .lg\\:group-hover\\:bg-blue-900 {
    --bg-opacity: 1;
    background-color: #233876;
    background-color: rgba(35, 56, 118, var(--bg-opacity));
  }
  .group:hover .lg\\:group-hover\\:bg-indigo-50 {
    --bg-opacity: 1;
    background-color: #f0f5ff;
    background-color: rgba(240, 245, 255, var(--bg-opacity));
  }
  .group:hover .lg\\:group-hover\\:bg-indigo-100 {
    --bg-opacity: 1;
    background-color: #e5edff;
    background-color: rgba(229, 237, 255, var(--bg-opacity));
  }
  .group:hover .lg\\:group-hover\\:bg-indigo-200 {
    --bg-opacity: 1;
    background-color: #cddbfe;
    background-color: rgba(205, 219, 254, var(--bg-opacity));
  }
  .group:hover .lg\\:group-hover\\:bg-indigo-300 {
    --bg-opacity: 1;
    background-color: #b4c6fc;
    background-color: rgba(180, 198, 252, var(--bg-opacity));
  }
  .group:hover .lg\\:group-hover\\:bg-indigo-400 {
    --bg-opacity: 1;
    background-color: #8da2fb;
    background-color: rgba(141, 162, 251, var(--bg-opacity));
  }
  .group:hover .lg\\:group-hover\\:bg-indigo-500 {
    --bg-opacity: 1;
    background-color: #6875f5;
    background-color: rgba(104, 117, 245, var(--bg-opacity));
  }
  .group:hover .lg\\:group-hover\\:bg-indigo-600 {
    --bg-opacity: 1;
    background-color: #5850ec;
    background-color: rgba(88, 80, 236, var(--bg-opacity));
  }
  .group:hover .lg\\:group-hover\\:bg-indigo-700 {
    --bg-opacity: 1;
    background-color: #5145cd;
    background-color: rgba(81, 69, 205, var(--bg-opacity));
  }
  .group:hover .lg\\:group-hover\\:bg-indigo-800 {
    --bg-opacity: 1;
    background-color: #42389d;
    background-color: rgba(66, 56, 157, var(--bg-opacity));
  }
  .group:hover .lg\\:group-hover\\:bg-indigo-900 {
    --bg-opacity: 1;
    background-color: #362f78;
    background-color: rgba(54, 47, 120, var(--bg-opacity));
  }
  .group:hover .lg\\:group-hover\\:bg-purple-50 {
    --bg-opacity: 1;
    background-color: #f6f5ff;
    background-color: rgba(246, 245, 255, var(--bg-opacity));
  }
  .group:hover .lg\\:group-hover\\:bg-purple-100 {
    --bg-opacity: 1;
    background-color: #edebfe;
    background-color: rgba(237, 235, 254, var(--bg-opacity));
  }
  .group:hover .lg\\:group-hover\\:bg-purple-200 {
    --bg-opacity: 1;
    background-color: #dcd7fe;
    background-color: rgba(220, 215, 254, var(--bg-opacity));
  }
  .group:hover .lg\\:group-hover\\:bg-purple-300 {
    --bg-opacity: 1;
    background-color: #cabffd;
    background-color: rgba(202, 191, 253, var(--bg-opacity));
  }
  .group:hover .lg\\:group-hover\\:bg-purple-400 {
    --bg-opacity: 1;
    background-color: #ac94fa;
    background-color: rgba(172, 148, 250, var(--bg-opacity));
  }
  .group:hover .lg\\:group-hover\\:bg-purple-500 {
    --bg-opacity: 1;
    background-color: #9061f9;
    background-color: rgba(144, 97, 249, var(--bg-opacity));
  }
  .group:hover .lg\\:group-hover\\:bg-purple-600 {
    --bg-opacity: 1;
    background-color: #7e3af2;
    background-color: rgba(126, 58, 242, var(--bg-opacity));
  }
  .group:hover .lg\\:group-hover\\:bg-purple-700 {
    --bg-opacity: 1;
    background-color: #6c2bd9;
    background-color: rgba(108, 43, 217, var(--bg-opacity));
  }
  .group:hover .lg\\:group-hover\\:bg-purple-800 {
    --bg-opacity: 1;
    background-color: #5521b5;
    background-color: rgba(85, 33, 181, var(--bg-opacity));
  }
  .group:hover .lg\\:group-hover\\:bg-purple-900 {
    --bg-opacity: 1;
    background-color: #4a1d96;
    background-color: rgba(74, 29, 150, var(--bg-opacity));
  }
  .group:hover .lg\\:group-hover\\:bg-pink-50 {
    --bg-opacity: 1;
    background-color: #fdf2f8;
    background-color: rgba(253, 242, 248, var(--bg-opacity));
  }
  .group:hover .lg\\:group-hover\\:bg-pink-100 {
    --bg-opacity: 1;
    background-color: #fce8f3;
    background-color: rgba(252, 232, 243, var(--bg-opacity));
  }
  .group:hover .lg\\:group-hover\\:bg-pink-200 {
    --bg-opacity: 1;
    background-color: #fad1e8;
    background-color: rgba(250, 209, 232, var(--bg-opacity));
  }
  .group:hover .lg\\:group-hover\\:bg-pink-300 {
    --bg-opacity: 1;
    background-color: #f8b4d9;
    background-color: rgba(248, 180, 217, var(--bg-opacity));
  }
  .group:hover .lg\\:group-hover\\:bg-pink-400 {
    --bg-opacity: 1;
    background-color: #f17eb8;
    background-color: rgba(241, 126, 184, var(--bg-opacity));
  }
  .group:hover .lg\\:group-hover\\:bg-pink-500 {
    --bg-opacity: 1;
    background-color: #e74694;
    background-color: rgba(231, 70, 148, var(--bg-opacity));
  }
  .group:hover .lg\\:group-hover\\:bg-pink-600 {
    --bg-opacity: 1;
    background-color: #d61f69;
    background-color: rgba(214, 31, 105, var(--bg-opacity));
  }
  .group:hover .lg\\:group-hover\\:bg-pink-700 {
    --bg-opacity: 1;
    background-color: #bf125d;
    background-color: rgba(191, 18, 93, var(--bg-opacity));
  }
  .group:hover .lg\\:group-hover\\:bg-pink-800 {
    --bg-opacity: 1;
    background-color: #99154b;
    background-color: rgba(153, 21, 75, var(--bg-opacity));
  }
  .group:hover .lg\\:group-hover\\:bg-pink-900 {
    --bg-opacity: 1;
    background-color: #751a3d;
    background-color: rgba(117, 26, 61, var(--bg-opacity));
  }
  .group:hover .lg\\:group-hover\\:bg-cool-gray-50 {
    --bg-opacity: 1;
    background-color: #f8fafc;
    background-color: rgba(248, 250, 252, var(--bg-opacity));
  }
  .group:hover .lg\\:group-hover\\:bg-cool-gray-100 {
    --bg-opacity: 1;
    background-color: #f1f5f9;
    background-color: rgba(241, 245, 249, var(--bg-opacity));
  }
  .group:hover .lg\\:group-hover\\:bg-cool-gray-200 {
    --bg-opacity: 1;
    background-color: #e2e8f0;
    background-color: rgba(226, 232, 240, var(--bg-opacity));
  }
  .group:hover .lg\\:group-hover\\:bg-cool-gray-300 {
    --bg-opacity: 1;
    background-color: #cfd8e3;
    background-color: rgba(207, 216, 227, var(--bg-opacity));
  }
  .group:hover .lg\\:group-hover\\:bg-cool-gray-400 {
    --bg-opacity: 1;
    background-color: #97a6ba;
    background-color: rgba(151, 166, 186, var(--bg-opacity));
  }
  .group:hover .lg\\:group-hover\\:bg-cool-gray-500 {
    --bg-opacity: 1;
    background-color: #64748b;
    background-color: rgba(100, 116, 139, var(--bg-opacity));
  }
  .group:hover .lg\\:group-hover\\:bg-cool-gray-600 {
    --bg-opacity: 1;
    background-color: #475569;
    background-color: rgba(71, 85, 105, var(--bg-opacity));
  }
  .group:hover .lg\\:group-hover\\:bg-cool-gray-700 {
    --bg-opacity: 1;
    background-color: #364152;
    background-color: rgba(54, 65, 82, var(--bg-opacity));
  }
  .group:hover .lg\\:group-hover\\:bg-cool-gray-800 {
    --bg-opacity: 1;
    background-color: #27303f;
    background-color: rgba(39, 48, 63, var(--bg-opacity));
  }
  .group:hover .lg\\:group-hover\\:bg-cool-gray-900 {
    --bg-opacity: 1;
    background-color: #1a202e;
    background-color: rgba(26, 32, 46, var(--bg-opacity));
  }
  .group:focus .lg\\:group-focus\\:bg-current {
    background-color: currentColor;
  }
  .group:focus .lg\\:group-focus\\:bg-transparent {
    background-color: transparent;
  }
  .group:focus .lg\\:group-focus\\:bg-white {
    --bg-opacity: 1;
    background-color: #ffffff;
    background-color: rgba(255, 255, 255, var(--bg-opacity));
  }
  .group:focus .lg\\:group-focus\\:bg-black {
    --bg-opacity: 1;
    background-color: #000000;
    background-color: rgba(0, 0, 0, var(--bg-opacity));
  }
  .group:focus .lg\\:group-focus\\:bg-gray-50 {
    --bg-opacity: 1;
    background-color: #f9fafb;
    background-color: rgba(249, 250, 251, var(--bg-opacity));
  }
  .group:focus .lg\\:group-focus\\:bg-gray-100 {
    --bg-opacity: 1;
    background-color: #f4f5f7;
    background-color: rgba(244, 245, 247, var(--bg-opacity));
  }
  .group:focus .lg\\:group-focus\\:bg-gray-200 {
    --bg-opacity: 1;
    background-color: #e5e7eb;
    background-color: rgba(229, 231, 235, var(--bg-opacity));
  }
  .group:focus .lg\\:group-focus\\:bg-gray-300 {
    --bg-opacity: 1;
    background-color: #d2d6dc;
    background-color: rgba(210, 214, 220, var(--bg-opacity));
  }
  .group:focus .lg\\:group-focus\\:bg-gray-400 {
    --bg-opacity: 1;
    background-color: #9fa6b2;
    background-color: rgba(159, 166, 178, var(--bg-opacity));
  }
  .group:focus .lg\\:group-focus\\:bg-gray-500 {
    --bg-opacity: 1;
    background-color: #6b7280;
    background-color: rgba(107, 114, 128, var(--bg-opacity));
  }
  .group:focus .lg\\:group-focus\\:bg-gray-600 {
    --bg-opacity: 1;
    background-color: #4b5563;
    background-color: rgba(75, 85, 99, var(--bg-opacity));
  }
  .group:focus .lg\\:group-focus\\:bg-gray-700 {
    --bg-opacity: 1;
    background-color: #374151;
    background-color: rgba(55, 65, 81, var(--bg-opacity));
  }
  .group:focus .lg\\:group-focus\\:bg-gray-800 {
    --bg-opacity: 1;
    background-color: #252f3f;
    background-color: rgba(37, 47, 63, var(--bg-opacity));
  }
  .group:focus .lg\\:group-focus\\:bg-gray-900 {
    --bg-opacity: 1;
    background-color: #161e2e;
    background-color: rgba(22, 30, 46, var(--bg-opacity));
  }
  .group:focus .lg\\:group-focus\\:bg-red-50 {
    --bg-opacity: 1;
    background-color: #fdf2f2;
    background-color: rgba(253, 242, 242, var(--bg-opacity));
  }
  .group:focus .lg\\:group-focus\\:bg-red-100 {
    --bg-opacity: 1;
    background-color: #fde8e8;
    background-color: rgba(253, 232, 232, var(--bg-opacity));
  }
  .group:focus .lg\\:group-focus\\:bg-red-200 {
    --bg-opacity: 1;
    background-color: #fbd5d5;
    background-color: rgba(251, 213, 213, var(--bg-opacity));
  }
  .group:focus .lg\\:group-focus\\:bg-red-300 {
    --bg-opacity: 1;
    background-color: #f8b4b4;
    background-color: rgba(248, 180, 180, var(--bg-opacity));
  }
  .group:focus .lg\\:group-focus\\:bg-red-400 {
    --bg-opacity: 1;
    background-color: #f98080;
    background-color: rgba(249, 128, 128, var(--bg-opacity));
  }
  .group:focus .lg\\:group-focus\\:bg-red-500 {
    --bg-opacity: 1;
    background-color: #f05252;
    background-color: rgba(240, 82, 82, var(--bg-opacity));
  }
  .group:focus .lg\\:group-focus\\:bg-red-600 {
    --bg-opacity: 1;
    background-color: #e02424;
    background-color: rgba(224, 36, 36, var(--bg-opacity));
  }
  .group:focus .lg\\:group-focus\\:bg-red-700 {
    --bg-opacity: 1;
    background-color: #c81e1e;
    background-color: rgba(200, 30, 30, var(--bg-opacity));
  }
  .group:focus .lg\\:group-focus\\:bg-red-800 {
    --bg-opacity: 1;
    background-color: #9b1c1c;
    background-color: rgba(155, 28, 28, var(--bg-opacity));
  }
  .group:focus .lg\\:group-focus\\:bg-red-900 {
    --bg-opacity: 1;
    background-color: #771d1d;
    background-color: rgba(119, 29, 29, var(--bg-opacity));
  }
  .group:focus .lg\\:group-focus\\:bg-orange-50 {
    --bg-opacity: 1;
    background-color: #fff8f1;
    background-color: rgba(255, 248, 241, var(--bg-opacity));
  }
  .group:focus .lg\\:group-focus\\:bg-orange-100 {
    --bg-opacity: 1;
    background-color: #feecdc;
    background-color: rgba(254, 236, 220, var(--bg-opacity));
  }
  .group:focus .lg\\:group-focus\\:bg-orange-200 {
    --bg-opacity: 1;
    background-color: #fcd9bd;
    background-color: rgba(252, 217, 189, var(--bg-opacity));
  }
  .group:focus .lg\\:group-focus\\:bg-orange-300 {
    --bg-opacity: 1;
    background-color: #fdba8c;
    background-color: rgba(253, 186, 140, var(--bg-opacity));
  }
  .group:focus .lg\\:group-focus\\:bg-orange-400 {
    --bg-opacity: 1;
    background-color: #ff8a4c;
    background-color: rgba(255, 138, 76, var(--bg-opacity));
  }
  .group:focus .lg\\:group-focus\\:bg-orange-500 {
    --bg-opacity: 1;
    background-color: #ff5a1f;
    background-color: rgba(255, 90, 31, var(--bg-opacity));
  }
  .group:focus .lg\\:group-focus\\:bg-orange-600 {
    --bg-opacity: 1;
    background-color: #d03801;
    background-color: rgba(208, 56, 1, var(--bg-opacity));
  }
  .group:focus .lg\\:group-focus\\:bg-orange-700 {
    --bg-opacity: 1;
    background-color: #b43403;
    background-color: rgba(180, 52, 3, var(--bg-opacity));
  }
  .group:focus .lg\\:group-focus\\:bg-orange-800 {
    --bg-opacity: 1;
    background-color: #8a2c0d;
    background-color: rgba(138, 44, 13, var(--bg-opacity));
  }
  .group:focus .lg\\:group-focus\\:bg-orange-900 {
    --bg-opacity: 1;
    background-color: #73230d;
    background-color: rgba(115, 35, 13, var(--bg-opacity));
  }
  .group:focus .lg\\:group-focus\\:bg-yellow-50 {
    --bg-opacity: 1;
    background-color: #fdfdea;
    background-color: rgba(253, 253, 234, var(--bg-opacity));
  }
  .group:focus .lg\\:group-focus\\:bg-yellow-100 {
    --bg-opacity: 1;
    background-color: #fdf6b2;
    background-color: rgba(253, 246, 178, var(--bg-opacity));
  }
  .group:focus .lg\\:group-focus\\:bg-yellow-200 {
    --bg-opacity: 1;
    background-color: #fce96a;
    background-color: rgba(252, 233, 106, var(--bg-opacity));
  }
  .group:focus .lg\\:group-focus\\:bg-yellow-300 {
    --bg-opacity: 1;
    background-color: #faca15;
    background-color: rgba(250, 202, 21, var(--bg-opacity));
  }
  .group:focus .lg\\:group-focus\\:bg-yellow-400 {
    --bg-opacity: 1;
    background-color: #e3a008;
    background-color: rgba(227, 160, 8, var(--bg-opacity));
  }
  .group:focus .lg\\:group-focus\\:bg-yellow-500 {
    --bg-opacity: 1;
    background-color: #c27803;
    background-color: rgba(194, 120, 3, var(--bg-opacity));
  }
  .group:focus .lg\\:group-focus\\:bg-yellow-600 {
    --bg-opacity: 1;
    background-color: #9f580a;
    background-color: rgba(159, 88, 10, var(--bg-opacity));
  }
  .group:focus .lg\\:group-focus\\:bg-yellow-700 {
    --bg-opacity: 1;
    background-color: #8e4b10;
    background-color: rgba(142, 75, 16, var(--bg-opacity));
  }
  .group:focus .lg\\:group-focus\\:bg-yellow-800 {
    --bg-opacity: 1;
    background-color: #723b13;
    background-color: rgba(114, 59, 19, var(--bg-opacity));
  }
  .group:focus .lg\\:group-focus\\:bg-yellow-900 {
    --bg-opacity: 1;
    background-color: #633112;
    background-color: rgba(99, 49, 18, var(--bg-opacity));
  }
  .group:focus .lg\\:group-focus\\:bg-green-50 {
    --bg-opacity: 1;
    background-color: #f3faf7;
    background-color: rgba(243, 250, 247, var(--bg-opacity));
  }
  .group:focus .lg\\:group-focus\\:bg-green-100 {
    --bg-opacity: 1;
    background-color: #def7ec;
    background-color: rgba(222, 247, 236, var(--bg-opacity));
  }
  .group:focus .lg\\:group-focus\\:bg-green-200 {
    --bg-opacity: 1;
    background-color: #bcf0da;
    background-color: rgba(188, 240, 218, var(--bg-opacity));
  }
  .group:focus .lg\\:group-focus\\:bg-green-300 {
    --bg-opacity: 1;
    background-color: #84e1bc;
    background-color: rgba(132, 225, 188, var(--bg-opacity));
  }
  .group:focus .lg\\:group-focus\\:bg-green-400 {
    --bg-opacity: 1;
    background-color: #31c48d;
    background-color: rgba(49, 196, 141, var(--bg-opacity));
  }
  .group:focus .lg\\:group-focus\\:bg-green-500 {
    --bg-opacity: 1;
    background-color: #0e9f6e;
    background-color: rgba(14, 159, 110, var(--bg-opacity));
  }
  .group:focus .lg\\:group-focus\\:bg-green-600 {
    --bg-opacity: 1;
    background-color: #057a55;
    background-color: rgba(5, 122, 85, var(--bg-opacity));
  }
  .group:focus .lg\\:group-focus\\:bg-green-700 {
    --bg-opacity: 1;
    background-color: #046c4e;
    background-color: rgba(4, 108, 78, var(--bg-opacity));
  }
  .group:focus .lg\\:group-focus\\:bg-green-800 {
    --bg-opacity: 1;
    background-color: #03543f;
    background-color: rgba(3, 84, 63, var(--bg-opacity));
  }
  .group:focus .lg\\:group-focus\\:bg-green-900 {
    --bg-opacity: 1;
    background-color: #014737;
    background-color: rgba(1, 71, 55, var(--bg-opacity));
  }
  .group:focus .lg\\:group-focus\\:bg-teal-50 {
    --bg-opacity: 1;
    background-color: #edfafa;
    background-color: rgba(237, 250, 250, var(--bg-opacity));
  }
  .group:focus .lg\\:group-focus\\:bg-teal-100 {
    --bg-opacity: 1;
    background-color: #d5f5f6;
    background-color: rgba(213, 245, 246, var(--bg-opacity));
  }
  .group:focus .lg\\:group-focus\\:bg-teal-200 {
    --bg-opacity: 1;
    background-color: #afecef;
    background-color: rgba(175, 236, 239, var(--bg-opacity));
  }
  .group:focus .lg\\:group-focus\\:bg-teal-300 {
    --bg-opacity: 1;
    background-color: #7edce2;
    background-color: rgba(126, 220, 226, var(--bg-opacity));
  }
  .group:focus .lg\\:group-focus\\:bg-teal-400 {
    --bg-opacity: 1;
    background-color: #16bdca;
    background-color: rgba(22, 189, 202, var(--bg-opacity));
  }
  .group:focus .lg\\:group-focus\\:bg-teal-500 {
    --bg-opacity: 1;
    background-color: #0694a2;
    background-color: rgba(6, 148, 162, var(--bg-opacity));
  }
  .group:focus .lg\\:group-focus\\:bg-teal-600 {
    --bg-opacity: 1;
    background-color: #047481;
    background-color: rgba(4, 116, 129, var(--bg-opacity));
  }
  .group:focus .lg\\:group-focus\\:bg-teal-700 {
    --bg-opacity: 1;
    background-color: #036672;
    background-color: rgba(3, 102, 114, var(--bg-opacity));
  }
  .group:focus .lg\\:group-focus\\:bg-teal-800 {
    --bg-opacity: 1;
    background-color: #05505c;
    background-color: rgba(5, 80, 92, var(--bg-opacity));
  }
  .group:focus .lg\\:group-focus\\:bg-teal-900 {
    --bg-opacity: 1;
    background-color: #014451;
    background-color: rgba(1, 68, 81, var(--bg-opacity));
  }
  .group:focus .lg\\:group-focus\\:bg-blue-50 {
    --bg-opacity: 1;
    background-color: #ebf5ff;
    background-color: rgba(235, 245, 255, var(--bg-opacity));
  }
  .group:focus .lg\\:group-focus\\:bg-blue-100 {
    --bg-opacity: 1;
    background-color: #e1effe;
    background-color: rgba(225, 239, 254, var(--bg-opacity));
  }
  .group:focus .lg\\:group-focus\\:bg-blue-200 {
    --bg-opacity: 1;
    background-color: #c3ddfd;
    background-color: rgba(195, 221, 253, var(--bg-opacity));
  }
  .group:focus .lg\\:group-focus\\:bg-blue-300 {
    --bg-opacity: 1;
    background-color: #a4cafe;
    background-color: rgba(164, 202, 254, var(--bg-opacity));
  }
  .group:focus .lg\\:group-focus\\:bg-blue-400 {
    --bg-opacity: 1;
    background-color: #76a9fa;
    background-color: rgba(118, 169, 250, var(--bg-opacity));
  }
  .group:focus .lg\\:group-focus\\:bg-blue-500 {
    --bg-opacity: 1;
    background-color: #3f83f8;
    background-color: rgba(63, 131, 248, var(--bg-opacity));
  }
  .group:focus .lg\\:group-focus\\:bg-blue-600 {
    --bg-opacity: 1;
    background-color: #1c64f2;
    background-color: rgba(28, 100, 242, var(--bg-opacity));
  }
  .group:focus .lg\\:group-focus\\:bg-blue-700 {
    --bg-opacity: 1;
    background-color: #1a56db;
    background-color: rgba(26, 86, 219, var(--bg-opacity));
  }
  .group:focus .lg\\:group-focus\\:bg-blue-800 {
    --bg-opacity: 1;
    background-color: #1e429f;
    background-color: rgba(30, 66, 159, var(--bg-opacity));
  }
  .group:focus .lg\\:group-focus\\:bg-blue-900 {
    --bg-opacity: 1;
    background-color: #233876;
    background-color: rgba(35, 56, 118, var(--bg-opacity));
  }
  .group:focus .lg\\:group-focus\\:bg-indigo-50 {
    --bg-opacity: 1;
    background-color: #f0f5ff;
    background-color: rgba(240, 245, 255, var(--bg-opacity));
  }
  .group:focus .lg\\:group-focus\\:bg-indigo-100 {
    --bg-opacity: 1;
    background-color: #e5edff;
    background-color: rgba(229, 237, 255, var(--bg-opacity));
  }
  .group:focus .lg\\:group-focus\\:bg-indigo-200 {
    --bg-opacity: 1;
    background-color: #cddbfe;
    background-color: rgba(205, 219, 254, var(--bg-opacity));
  }
  .group:focus .lg\\:group-focus\\:bg-indigo-300 {
    --bg-opacity: 1;
    background-color: #b4c6fc;
    background-color: rgba(180, 198, 252, var(--bg-opacity));
  }
  .group:focus .lg\\:group-focus\\:bg-indigo-400 {
    --bg-opacity: 1;
    background-color: #8da2fb;
    background-color: rgba(141, 162, 251, var(--bg-opacity));
  }
  .group:focus .lg\\:group-focus\\:bg-indigo-500 {
    --bg-opacity: 1;
    background-color: #6875f5;
    background-color: rgba(104, 117, 245, var(--bg-opacity));
  }
  .group:focus .lg\\:group-focus\\:bg-indigo-600 {
    --bg-opacity: 1;
    background-color: #5850ec;
    background-color: rgba(88, 80, 236, var(--bg-opacity));
  }
  .group:focus .lg\\:group-focus\\:bg-indigo-700 {
    --bg-opacity: 1;
    background-color: #5145cd;
    background-color: rgba(81, 69, 205, var(--bg-opacity));
  }
  .group:focus .lg\\:group-focus\\:bg-indigo-800 {
    --bg-opacity: 1;
    background-color: #42389d;
    background-color: rgba(66, 56, 157, var(--bg-opacity));
  }
  .group:focus .lg\\:group-focus\\:bg-indigo-900 {
    --bg-opacity: 1;
    background-color: #362f78;
    background-color: rgba(54, 47, 120, var(--bg-opacity));
  }
  .group:focus .lg\\:group-focus\\:bg-purple-50 {
    --bg-opacity: 1;
    background-color: #f6f5ff;
    background-color: rgba(246, 245, 255, var(--bg-opacity));
  }
  .group:focus .lg\\:group-focus\\:bg-purple-100 {
    --bg-opacity: 1;
    background-color: #edebfe;
    background-color: rgba(237, 235, 254, var(--bg-opacity));
  }
  .group:focus .lg\\:group-focus\\:bg-purple-200 {
    --bg-opacity: 1;
    background-color: #dcd7fe;
    background-color: rgba(220, 215, 254, var(--bg-opacity));
  }
  .group:focus .lg\\:group-focus\\:bg-purple-300 {
    --bg-opacity: 1;
    background-color: #cabffd;
    background-color: rgba(202, 191, 253, var(--bg-opacity));
  }
  .group:focus .lg\\:group-focus\\:bg-purple-400 {
    --bg-opacity: 1;
    background-color: #ac94fa;
    background-color: rgba(172, 148, 250, var(--bg-opacity));
  }
  .group:focus .lg\\:group-focus\\:bg-purple-500 {
    --bg-opacity: 1;
    background-color: #9061f9;
    background-color: rgba(144, 97, 249, var(--bg-opacity));
  }
  .group:focus .lg\\:group-focus\\:bg-purple-600 {
    --bg-opacity: 1;
    background-color: #7e3af2;
    background-color: rgba(126, 58, 242, var(--bg-opacity));
  }
  .group:focus .lg\\:group-focus\\:bg-purple-700 {
    --bg-opacity: 1;
    background-color: #6c2bd9;
    background-color: rgba(108, 43, 217, var(--bg-opacity));
  }
  .group:focus .lg\\:group-focus\\:bg-purple-800 {
    --bg-opacity: 1;
    background-color: #5521b5;
    background-color: rgba(85, 33, 181, var(--bg-opacity));
  }
  .group:focus .lg\\:group-focus\\:bg-purple-900 {
    --bg-opacity: 1;
    background-color: #4a1d96;
    background-color: rgba(74, 29, 150, var(--bg-opacity));
  }
  .group:focus .lg\\:group-focus\\:bg-pink-50 {
    --bg-opacity: 1;
    background-color: #fdf2f8;
    background-color: rgba(253, 242, 248, var(--bg-opacity));
  }
  .group:focus .lg\\:group-focus\\:bg-pink-100 {
    --bg-opacity: 1;
    background-color: #fce8f3;
    background-color: rgba(252, 232, 243, var(--bg-opacity));
  }
  .group:focus .lg\\:group-focus\\:bg-pink-200 {
    --bg-opacity: 1;
    background-color: #fad1e8;
    background-color: rgba(250, 209, 232, var(--bg-opacity));
  }
  .group:focus .lg\\:group-focus\\:bg-pink-300 {
    --bg-opacity: 1;
    background-color: #f8b4d9;
    background-color: rgba(248, 180, 217, var(--bg-opacity));
  }
  .group:focus .lg\\:group-focus\\:bg-pink-400 {
    --bg-opacity: 1;
    background-color: #f17eb8;
    background-color: rgba(241, 126, 184, var(--bg-opacity));
  }
  .group:focus .lg\\:group-focus\\:bg-pink-500 {
    --bg-opacity: 1;
    background-color: #e74694;
    background-color: rgba(231, 70, 148, var(--bg-opacity));
  }
  .group:focus .lg\\:group-focus\\:bg-pink-600 {
    --bg-opacity: 1;
    background-color: #d61f69;
    background-color: rgba(214, 31, 105, var(--bg-opacity));
  }
  .group:focus .lg\\:group-focus\\:bg-pink-700 {
    --bg-opacity: 1;
    background-color: #bf125d;
    background-color: rgba(191, 18, 93, var(--bg-opacity));
  }
  .group:focus .lg\\:group-focus\\:bg-pink-800 {
    --bg-opacity: 1;
    background-color: #99154b;
    background-color: rgba(153, 21, 75, var(--bg-opacity));
  }
  .group:focus .lg\\:group-focus\\:bg-pink-900 {
    --bg-opacity: 1;
    background-color: #751a3d;
    background-color: rgba(117, 26, 61, var(--bg-opacity));
  }
  .group:focus .lg\\:group-focus\\:bg-cool-gray-50 {
    --bg-opacity: 1;
    background-color: #f8fafc;
    background-color: rgba(248, 250, 252, var(--bg-opacity));
  }
  .group:focus .lg\\:group-focus\\:bg-cool-gray-100 {
    --bg-opacity: 1;
    background-color: #f1f5f9;
    background-color: rgba(241, 245, 249, var(--bg-opacity));
  }
  .group:focus .lg\\:group-focus\\:bg-cool-gray-200 {
    --bg-opacity: 1;
    background-color: #e2e8f0;
    background-color: rgba(226, 232, 240, var(--bg-opacity));
  }
  .group:focus .lg\\:group-focus\\:bg-cool-gray-300 {
    --bg-opacity: 1;
    background-color: #cfd8e3;
    background-color: rgba(207, 216, 227, var(--bg-opacity));
  }
  .group:focus .lg\\:group-focus\\:bg-cool-gray-400 {
    --bg-opacity: 1;
    background-color: #97a6ba;
    background-color: rgba(151, 166, 186, var(--bg-opacity));
  }
  .group:focus .lg\\:group-focus\\:bg-cool-gray-500 {
    --bg-opacity: 1;
    background-color: #64748b;
    background-color: rgba(100, 116, 139, var(--bg-opacity));
  }
  .group:focus .lg\\:group-focus\\:bg-cool-gray-600 {
    --bg-opacity: 1;
    background-color: #475569;
    background-color: rgba(71, 85, 105, var(--bg-opacity));
  }
  .group:focus .lg\\:group-focus\\:bg-cool-gray-700 {
    --bg-opacity: 1;
    background-color: #364152;
    background-color: rgba(54, 65, 82, var(--bg-opacity));
  }
  .group:focus .lg\\:group-focus\\:bg-cool-gray-800 {
    --bg-opacity: 1;
    background-color: #27303f;
    background-color: rgba(39, 48, 63, var(--bg-opacity));
  }
  .group:focus .lg\\:group-focus\\:bg-cool-gray-900 {
    --bg-opacity: 1;
    background-color: #1a202e;
    background-color: rgba(26, 32, 46, var(--bg-opacity));
  }
  .lg\\:hover\\:bg-current:hover {
    background-color: currentColor;
  }
  .lg\\:hover\\:bg-transparent:hover {
    background-color: transparent;
  }
  .lg\\:hover\\:bg-white:hover {
    --bg-opacity: 1;
    background-color: #ffffff;
    background-color: rgba(255, 255, 255, var(--bg-opacity));
  }
  .lg\\:hover\\:bg-black:hover {
    --bg-opacity: 1;
    background-color: #000000;
    background-color: rgba(0, 0, 0, var(--bg-opacity));
  }
  .lg\\:hover\\:bg-gray-50:hover {
    --bg-opacity: 1;
    background-color: #f9fafb;
    background-color: rgba(249, 250, 251, var(--bg-opacity));
  }
  .lg\\:hover\\:bg-gray-100:hover {
    --bg-opacity: 1;
    background-color: #f4f5f7;
    background-color: rgba(244, 245, 247, var(--bg-opacity));
  }
  .lg\\:hover\\:bg-gray-200:hover {
    --bg-opacity: 1;
    background-color: #e5e7eb;
    background-color: rgba(229, 231, 235, var(--bg-opacity));
  }
  .lg\\:hover\\:bg-gray-300:hover {
    --bg-opacity: 1;
    background-color: #d2d6dc;
    background-color: rgba(210, 214, 220, var(--bg-opacity));
  }
  .lg\\:hover\\:bg-gray-400:hover {
    --bg-opacity: 1;
    background-color: #9fa6b2;
    background-color: rgba(159, 166, 178, var(--bg-opacity));
  }
  .lg\\:hover\\:bg-gray-500:hover {
    --bg-opacity: 1;
    background-color: #6b7280;
    background-color: rgba(107, 114, 128, var(--bg-opacity));
  }
  .lg\\:hover\\:bg-gray-600:hover {
    --bg-opacity: 1;
    background-color: #4b5563;
    background-color: rgba(75, 85, 99, var(--bg-opacity));
  }
  .lg\\:hover\\:bg-gray-700:hover {
    --bg-opacity: 1;
    background-color: #374151;
    background-color: rgba(55, 65, 81, var(--bg-opacity));
  }
  .lg\\:hover\\:bg-gray-800:hover {
    --bg-opacity: 1;
    background-color: #252f3f;
    background-color: rgba(37, 47, 63, var(--bg-opacity));
  }
  .lg\\:hover\\:bg-gray-900:hover {
    --bg-opacity: 1;
    background-color: #161e2e;
    background-color: rgba(22, 30, 46, var(--bg-opacity));
  }
  .lg\\:hover\\:bg-red-50:hover {
    --bg-opacity: 1;
    background-color: #fdf2f2;
    background-color: rgba(253, 242, 242, var(--bg-opacity));
  }
  .lg\\:hover\\:bg-red-100:hover {
    --bg-opacity: 1;
    background-color: #fde8e8;
    background-color: rgba(253, 232, 232, var(--bg-opacity));
  }
  .lg\\:hover\\:bg-red-200:hover {
    --bg-opacity: 1;
    background-color: #fbd5d5;
    background-color: rgba(251, 213, 213, var(--bg-opacity));
  }
  .lg\\:hover\\:bg-red-300:hover {
    --bg-opacity: 1;
    background-color: #f8b4b4;
    background-color: rgba(248, 180, 180, var(--bg-opacity));
  }
  .lg\\:hover\\:bg-red-400:hover {
    --bg-opacity: 1;
    background-color: #f98080;
    background-color: rgba(249, 128, 128, var(--bg-opacity));
  }
  .lg\\:hover\\:bg-red-500:hover {
    --bg-opacity: 1;
    background-color: #f05252;
    background-color: rgba(240, 82, 82, var(--bg-opacity));
  }
  .lg\\:hover\\:bg-red-600:hover {
    --bg-opacity: 1;
    background-color: #e02424;
    background-color: rgba(224, 36, 36, var(--bg-opacity));
  }
  .lg\\:hover\\:bg-red-700:hover {
    --bg-opacity: 1;
    background-color: #c81e1e;
    background-color: rgba(200, 30, 30, var(--bg-opacity));
  }
  .lg\\:hover\\:bg-red-800:hover {
    --bg-opacity: 1;
    background-color: #9b1c1c;
    background-color: rgba(155, 28, 28, var(--bg-opacity));
  }
  .lg\\:hover\\:bg-red-900:hover {
    --bg-opacity: 1;
    background-color: #771d1d;
    background-color: rgba(119, 29, 29, var(--bg-opacity));
  }
  .lg\\:hover\\:bg-orange-50:hover {
    --bg-opacity: 1;
    background-color: #fff8f1;
    background-color: rgba(255, 248, 241, var(--bg-opacity));
  }
  .lg\\:hover\\:bg-orange-100:hover {
    --bg-opacity: 1;
    background-color: #feecdc;
    background-color: rgba(254, 236, 220, var(--bg-opacity));
  }
  .lg\\:hover\\:bg-orange-200:hover {
    --bg-opacity: 1;
    background-color: #fcd9bd;
    background-color: rgba(252, 217, 189, var(--bg-opacity));
  }
  .lg\\:hover\\:bg-orange-300:hover {
    --bg-opacity: 1;
    background-color: #fdba8c;
    background-color: rgba(253, 186, 140, var(--bg-opacity));
  }
  .lg\\:hover\\:bg-orange-400:hover {
    --bg-opacity: 1;
    background-color: #ff8a4c;
    background-color: rgba(255, 138, 76, var(--bg-opacity));
  }
  .lg\\:hover\\:bg-orange-500:hover {
    --bg-opacity: 1;
    background-color: #ff5a1f;
    background-color: rgba(255, 90, 31, var(--bg-opacity));
  }
  .lg\\:hover\\:bg-orange-600:hover {
    --bg-opacity: 1;
    background-color: #d03801;
    background-color: rgba(208, 56, 1, var(--bg-opacity));
  }
  .lg\\:hover\\:bg-orange-700:hover {
    --bg-opacity: 1;
    background-color: #b43403;
    background-color: rgba(180, 52, 3, var(--bg-opacity));
  }
  .lg\\:hover\\:bg-orange-800:hover {
    --bg-opacity: 1;
    background-color: #8a2c0d;
    background-color: rgba(138, 44, 13, var(--bg-opacity));
  }
  .lg\\:hover\\:bg-orange-900:hover {
    --bg-opacity: 1;
    background-color: #73230d;
    background-color: rgba(115, 35, 13, var(--bg-opacity));
  }
  .lg\\:hover\\:bg-yellow-50:hover {
    --bg-opacity: 1;
    background-color: #fdfdea;
    background-color: rgba(253, 253, 234, var(--bg-opacity));
  }
  .lg\\:hover\\:bg-yellow-100:hover {
    --bg-opacity: 1;
    background-color: #fdf6b2;
    background-color: rgba(253, 246, 178, var(--bg-opacity));
  }
  .lg\\:hover\\:bg-yellow-200:hover {
    --bg-opacity: 1;
    background-color: #fce96a;
    background-color: rgba(252, 233, 106, var(--bg-opacity));
  }
  .lg\\:hover\\:bg-yellow-300:hover {
    --bg-opacity: 1;
    background-color: #faca15;
    background-color: rgba(250, 202, 21, var(--bg-opacity));
  }
  .lg\\:hover\\:bg-yellow-400:hover {
    --bg-opacity: 1;
    background-color: #e3a008;
    background-color: rgba(227, 160, 8, var(--bg-opacity));
  }
  .lg\\:hover\\:bg-yellow-500:hover {
    --bg-opacity: 1;
    background-color: #c27803;
    background-color: rgba(194, 120, 3, var(--bg-opacity));
  }
  .lg\\:hover\\:bg-yellow-600:hover {
    --bg-opacity: 1;
    background-color: #9f580a;
    background-color: rgba(159, 88, 10, var(--bg-opacity));
  }
  .lg\\:hover\\:bg-yellow-700:hover {
    --bg-opacity: 1;
    background-color: #8e4b10;
    background-color: rgba(142, 75, 16, var(--bg-opacity));
  }
  .lg\\:hover\\:bg-yellow-800:hover {
    --bg-opacity: 1;
    background-color: #723b13;
    background-color: rgba(114, 59, 19, var(--bg-opacity));
  }
  .lg\\:hover\\:bg-yellow-900:hover {
    --bg-opacity: 1;
    background-color: #633112;
    background-color: rgba(99, 49, 18, var(--bg-opacity));
  }
  .lg\\:hover\\:bg-green-50:hover {
    --bg-opacity: 1;
    background-color: #f3faf7;
    background-color: rgba(243, 250, 247, var(--bg-opacity));
  }
  .lg\\:hover\\:bg-green-100:hover {
    --bg-opacity: 1;
    background-color: #def7ec;
    background-color: rgba(222, 247, 236, var(--bg-opacity));
  }
  .lg\\:hover\\:bg-green-200:hover {
    --bg-opacity: 1;
    background-color: #bcf0da;
    background-color: rgba(188, 240, 218, var(--bg-opacity));
  }
  .lg\\:hover\\:bg-green-300:hover {
    --bg-opacity: 1;
    background-color: #84e1bc;
    background-color: rgba(132, 225, 188, var(--bg-opacity));
  }
  .lg\\:hover\\:bg-green-400:hover {
    --bg-opacity: 1;
    background-color: #31c48d;
    background-color: rgba(49, 196, 141, var(--bg-opacity));
  }
  .lg\\:hover\\:bg-green-500:hover {
    --bg-opacity: 1;
    background-color: #0e9f6e;
    background-color: rgba(14, 159, 110, var(--bg-opacity));
  }
  .lg\\:hover\\:bg-green-600:hover {
    --bg-opacity: 1;
    background-color: #057a55;
    background-color: rgba(5, 122, 85, var(--bg-opacity));
  }
  .lg\\:hover\\:bg-green-700:hover {
    --bg-opacity: 1;
    background-color: #046c4e;
    background-color: rgba(4, 108, 78, var(--bg-opacity));
  }
  .lg\\:hover\\:bg-green-800:hover {
    --bg-opacity: 1;
    background-color: #03543f;
    background-color: rgba(3, 84, 63, var(--bg-opacity));
  }
  .lg\\:hover\\:bg-green-900:hover {
    --bg-opacity: 1;
    background-color: #014737;
    background-color: rgba(1, 71, 55, var(--bg-opacity));
  }
  .lg\\:hover\\:bg-teal-50:hover {
    --bg-opacity: 1;
    background-color: #edfafa;
    background-color: rgba(237, 250, 250, var(--bg-opacity));
  }
  .lg\\:hover\\:bg-teal-100:hover {
    --bg-opacity: 1;
    background-color: #d5f5f6;
    background-color: rgba(213, 245, 246, var(--bg-opacity));
  }
  .lg\\:hover\\:bg-teal-200:hover {
    --bg-opacity: 1;
    background-color: #afecef;
    background-color: rgba(175, 236, 239, var(--bg-opacity));
  }
  .lg\\:hover\\:bg-teal-300:hover {
    --bg-opacity: 1;
    background-color: #7edce2;
    background-color: rgba(126, 220, 226, var(--bg-opacity));
  }
  .lg\\:hover\\:bg-teal-400:hover {
    --bg-opacity: 1;
    background-color: #16bdca;
    background-color: rgba(22, 189, 202, var(--bg-opacity));
  }
  .lg\\:hover\\:bg-teal-500:hover {
    --bg-opacity: 1;
    background-color: #0694a2;
    background-color: rgba(6, 148, 162, var(--bg-opacity));
  }
  .lg\\:hover\\:bg-teal-600:hover {
    --bg-opacity: 1;
    background-color: #047481;
    background-color: rgba(4, 116, 129, var(--bg-opacity));
  }
  .lg\\:hover\\:bg-teal-700:hover {
    --bg-opacity: 1;
    background-color: #036672;
    background-color: rgba(3, 102, 114, var(--bg-opacity));
  }
  .lg\\:hover\\:bg-teal-800:hover {
    --bg-opacity: 1;
    background-color: #05505c;
    background-color: rgba(5, 80, 92, var(--bg-opacity));
  }
  .lg\\:hover\\:bg-teal-900:hover {
    --bg-opacity: 1;
    background-color: #014451;
    background-color: rgba(1, 68, 81, var(--bg-opacity));
  }
  .lg\\:hover\\:bg-blue-50:hover {
    --bg-opacity: 1;
    background-color: #ebf5ff;
    background-color: rgba(235, 245, 255, var(--bg-opacity));
  }
  .lg\\:hover\\:bg-blue-100:hover {
    --bg-opacity: 1;
    background-color: #e1effe;
    background-color: rgba(225, 239, 254, var(--bg-opacity));
  }
  .lg\\:hover\\:bg-blue-200:hover {
    --bg-opacity: 1;
    background-color: #c3ddfd;
    background-color: rgba(195, 221, 253, var(--bg-opacity));
  }
  .lg\\:hover\\:bg-blue-300:hover {
    --bg-opacity: 1;
    background-color: #a4cafe;
    background-color: rgba(164, 202, 254, var(--bg-opacity));
  }
  .lg\\:hover\\:bg-blue-400:hover {
    --bg-opacity: 1;
    background-color: #76a9fa;
    background-color: rgba(118, 169, 250, var(--bg-opacity));
  }
  .lg\\:hover\\:bg-blue-500:hover {
    --bg-opacity: 1;
    background-color: #3f83f8;
    background-color: rgba(63, 131, 248, var(--bg-opacity));
  }
  .lg\\:hover\\:bg-blue-600:hover {
    --bg-opacity: 1;
    background-color: #1c64f2;
    background-color: rgba(28, 100, 242, var(--bg-opacity));
  }
  .lg\\:hover\\:bg-blue-700:hover {
    --bg-opacity: 1;
    background-color: #1a56db;
    background-color: rgba(26, 86, 219, var(--bg-opacity));
  }
  .lg\\:hover\\:bg-blue-800:hover {
    --bg-opacity: 1;
    background-color: #1e429f;
    background-color: rgba(30, 66, 159, var(--bg-opacity));
  }
  .lg\\:hover\\:bg-blue-900:hover {
    --bg-opacity: 1;
    background-color: #233876;
    background-color: rgba(35, 56, 118, var(--bg-opacity));
  }
  .lg\\:hover\\:bg-indigo-50:hover {
    --bg-opacity: 1;
    background-color: #f0f5ff;
    background-color: rgba(240, 245, 255, var(--bg-opacity));
  }
  .lg\\:hover\\:bg-indigo-100:hover {
    --bg-opacity: 1;
    background-color: #e5edff;
    background-color: rgba(229, 237, 255, var(--bg-opacity));
  }
  .lg\\:hover\\:bg-indigo-200:hover {
    --bg-opacity: 1;
    background-color: #cddbfe;
    background-color: rgba(205, 219, 254, var(--bg-opacity));
  }
  .lg\\:hover\\:bg-indigo-300:hover {
    --bg-opacity: 1;
    background-color: #b4c6fc;
    background-color: rgba(180, 198, 252, var(--bg-opacity));
  }
  .lg\\:hover\\:bg-indigo-400:hover {
    --bg-opacity: 1;
    background-color: #8da2fb;
    background-color: rgba(141, 162, 251, var(--bg-opacity));
  }
  .lg\\:hover\\:bg-indigo-500:hover {
    --bg-opacity: 1;
    background-color: #6875f5;
    background-color: rgba(104, 117, 245, var(--bg-opacity));
  }
  .lg\\:hover\\:bg-indigo-600:hover {
    --bg-opacity: 1;
    background-color: #5850ec;
    background-color: rgba(88, 80, 236, var(--bg-opacity));
  }
  .lg\\:hover\\:bg-indigo-700:hover {
    --bg-opacity: 1;
    background-color: #5145cd;
    background-color: rgba(81, 69, 205, var(--bg-opacity));
  }
  .lg\\:hover\\:bg-indigo-800:hover {
    --bg-opacity: 1;
    background-color: #42389d;
    background-color: rgba(66, 56, 157, var(--bg-opacity));
  }
  .lg\\:hover\\:bg-indigo-900:hover {
    --bg-opacity: 1;
    background-color: #362f78;
    background-color: rgba(54, 47, 120, var(--bg-opacity));
  }
  .lg\\:hover\\:bg-purple-50:hover {
    --bg-opacity: 1;
    background-color: #f6f5ff;
    background-color: rgba(246, 245, 255, var(--bg-opacity));
  }
  .lg\\:hover\\:bg-purple-100:hover {
    --bg-opacity: 1;
    background-color: #edebfe;
    background-color: rgba(237, 235, 254, var(--bg-opacity));
  }
  .lg\\:hover\\:bg-purple-200:hover {
    --bg-opacity: 1;
    background-color: #dcd7fe;
    background-color: rgba(220, 215, 254, var(--bg-opacity));
  }
  .lg\\:hover\\:bg-purple-300:hover {
    --bg-opacity: 1;
    background-color: #cabffd;
    background-color: rgba(202, 191, 253, var(--bg-opacity));
  }
  .lg\\:hover\\:bg-purple-400:hover {
    --bg-opacity: 1;
    background-color: #ac94fa;
    background-color: rgba(172, 148, 250, var(--bg-opacity));
  }
  .lg\\:hover\\:bg-purple-500:hover {
    --bg-opacity: 1;
    background-color: #9061f9;
    background-color: rgba(144, 97, 249, var(--bg-opacity));
  }
  .lg\\:hover\\:bg-purple-600:hover {
    --bg-opacity: 1;
    background-color: #7e3af2;
    background-color: rgba(126, 58, 242, var(--bg-opacity));
  }
  .lg\\:hover\\:bg-purple-700:hover {
    --bg-opacity: 1;
    background-color: #6c2bd9;
    background-color: rgba(108, 43, 217, var(--bg-opacity));
  }
  .lg\\:hover\\:bg-purple-800:hover {
    --bg-opacity: 1;
    background-color: #5521b5;
    background-color: rgba(85, 33, 181, var(--bg-opacity));
  }
  .lg\\:hover\\:bg-purple-900:hover {
    --bg-opacity: 1;
    background-color: #4a1d96;
    background-color: rgba(74, 29, 150, var(--bg-opacity));
  }
  .lg\\:hover\\:bg-pink-50:hover {
    --bg-opacity: 1;
    background-color: #fdf2f8;
    background-color: rgba(253, 242, 248, var(--bg-opacity));
  }
  .lg\\:hover\\:bg-pink-100:hover {
    --bg-opacity: 1;
    background-color: #fce8f3;
    background-color: rgba(252, 232, 243, var(--bg-opacity));
  }
  .lg\\:hover\\:bg-pink-200:hover {
    --bg-opacity: 1;
    background-color: #fad1e8;
    background-color: rgba(250, 209, 232, var(--bg-opacity));
  }
  .lg\\:hover\\:bg-pink-300:hover {
    --bg-opacity: 1;
    background-color: #f8b4d9;
    background-color: rgba(248, 180, 217, var(--bg-opacity));
  }
  .lg\\:hover\\:bg-pink-400:hover {
    --bg-opacity: 1;
    background-color: #f17eb8;
    background-color: rgba(241, 126, 184, var(--bg-opacity));
  }
  .lg\\:hover\\:bg-pink-500:hover {
    --bg-opacity: 1;
    background-color: #e74694;
    background-color: rgba(231, 70, 148, var(--bg-opacity));
  }
  .lg\\:hover\\:bg-pink-600:hover {
    --bg-opacity: 1;
    background-color: #d61f69;
    background-color: rgba(214, 31, 105, var(--bg-opacity));
  }
  .lg\\:hover\\:bg-pink-700:hover {
    --bg-opacity: 1;
    background-color: #bf125d;
    background-color: rgba(191, 18, 93, var(--bg-opacity));
  }
  .lg\\:hover\\:bg-pink-800:hover {
    --bg-opacity: 1;
    background-color: #99154b;
    background-color: rgba(153, 21, 75, var(--bg-opacity));
  }
  .lg\\:hover\\:bg-pink-900:hover {
    --bg-opacity: 1;
    background-color: #751a3d;
    background-color: rgba(117, 26, 61, var(--bg-opacity));
  }
  .lg\\:hover\\:bg-cool-gray-50:hover {
    --bg-opacity: 1;
    background-color: #f8fafc;
    background-color: rgba(248, 250, 252, var(--bg-opacity));
  }
  .lg\\:hover\\:bg-cool-gray-100:hover {
    --bg-opacity: 1;
    background-color: #f1f5f9;
    background-color: rgba(241, 245, 249, var(--bg-opacity));
  }
  .lg\\:hover\\:bg-cool-gray-200:hover {
    --bg-opacity: 1;
    background-color: #e2e8f0;
    background-color: rgba(226, 232, 240, var(--bg-opacity));
  }
  .lg\\:hover\\:bg-cool-gray-300:hover {
    --bg-opacity: 1;
    background-color: #cfd8e3;
    background-color: rgba(207, 216, 227, var(--bg-opacity));
  }
  .lg\\:hover\\:bg-cool-gray-400:hover {
    --bg-opacity: 1;
    background-color: #97a6ba;
    background-color: rgba(151, 166, 186, var(--bg-opacity));
  }
  .lg\\:hover\\:bg-cool-gray-500:hover {
    --bg-opacity: 1;
    background-color: #64748b;
    background-color: rgba(100, 116, 139, var(--bg-opacity));
  }
  .lg\\:hover\\:bg-cool-gray-600:hover {
    --bg-opacity: 1;
    background-color: #475569;
    background-color: rgba(71, 85, 105, var(--bg-opacity));
  }
  .lg\\:hover\\:bg-cool-gray-700:hover {
    --bg-opacity: 1;
    background-color: #364152;
    background-color: rgba(54, 65, 82, var(--bg-opacity));
  }
  .lg\\:hover\\:bg-cool-gray-800:hover {
    --bg-opacity: 1;
    background-color: #27303f;
    background-color: rgba(39, 48, 63, var(--bg-opacity));
  }
  .lg\\:hover\\:bg-cool-gray-900:hover {
    --bg-opacity: 1;
    background-color: #1a202e;
    background-color: rgba(26, 32, 46, var(--bg-opacity));
  }
  .lg\\:focus\\:bg-current:focus {
    background-color: currentColor;
  }
  .lg\\:focus\\:bg-transparent:focus {
    background-color: transparent;
  }
  .lg\\:focus\\:bg-white:focus {
    --bg-opacity: 1;
    background-color: #ffffff;
    background-color: rgba(255, 255, 255, var(--bg-opacity));
  }
  .lg\\:focus\\:bg-black:focus {
    --bg-opacity: 1;
    background-color: #000000;
    background-color: rgba(0, 0, 0, var(--bg-opacity));
  }
  .lg\\:focus\\:bg-gray-50:focus {
    --bg-opacity: 1;
    background-color: #f9fafb;
    background-color: rgba(249, 250, 251, var(--bg-opacity));
  }
  .lg\\:focus\\:bg-gray-100:focus {
    --bg-opacity: 1;
    background-color: #f4f5f7;
    background-color: rgba(244, 245, 247, var(--bg-opacity));
  }
  .lg\\:focus\\:bg-gray-200:focus {
    --bg-opacity: 1;
    background-color: #e5e7eb;
    background-color: rgba(229, 231, 235, var(--bg-opacity));
  }
  .lg\\:focus\\:bg-gray-300:focus {
    --bg-opacity: 1;
    background-color: #d2d6dc;
    background-color: rgba(210, 214, 220, var(--bg-opacity));
  }
  .lg\\:focus\\:bg-gray-400:focus {
    --bg-opacity: 1;
    background-color: #9fa6b2;
    background-color: rgba(159, 166, 178, var(--bg-opacity));
  }
  .lg\\:focus\\:bg-gray-500:focus {
    --bg-opacity: 1;
    background-color: #6b7280;
    background-color: rgba(107, 114, 128, var(--bg-opacity));
  }
  .lg\\:focus\\:bg-gray-600:focus {
    --bg-opacity: 1;
    background-color: #4b5563;
    background-color: rgba(75, 85, 99, var(--bg-opacity));
  }
  .lg\\:focus\\:bg-gray-700:focus {
    --bg-opacity: 1;
    background-color: #374151;
    background-color: rgba(55, 65, 81, var(--bg-opacity));
  }
  .lg\\:focus\\:bg-gray-800:focus {
    --bg-opacity: 1;
    background-color: #252f3f;
    background-color: rgba(37, 47, 63, var(--bg-opacity));
  }
  .lg\\:focus\\:bg-gray-900:focus {
    --bg-opacity: 1;
    background-color: #161e2e;
    background-color: rgba(22, 30, 46, var(--bg-opacity));
  }
  .lg\\:focus\\:bg-red-50:focus {
    --bg-opacity: 1;
    background-color: #fdf2f2;
    background-color: rgba(253, 242, 242, var(--bg-opacity));
  }
  .lg\\:focus\\:bg-red-100:focus {
    --bg-opacity: 1;
    background-color: #fde8e8;
    background-color: rgba(253, 232, 232, var(--bg-opacity));
  }
  .lg\\:focus\\:bg-red-200:focus {
    --bg-opacity: 1;
    background-color: #fbd5d5;
    background-color: rgba(251, 213, 213, var(--bg-opacity));
  }
  .lg\\:focus\\:bg-red-300:focus {
    --bg-opacity: 1;
    background-color: #f8b4b4;
    background-color: rgba(248, 180, 180, var(--bg-opacity));
  }
  .lg\\:focus\\:bg-red-400:focus {
    --bg-opacity: 1;
    background-color: #f98080;
    background-color: rgba(249, 128, 128, var(--bg-opacity));
  }
  .lg\\:focus\\:bg-red-500:focus {
    --bg-opacity: 1;
    background-color: #f05252;
    background-color: rgba(240, 82, 82, var(--bg-opacity));
  }
  .lg\\:focus\\:bg-red-600:focus {
    --bg-opacity: 1;
    background-color: #e02424;
    background-color: rgba(224, 36, 36, var(--bg-opacity));
  }
  .lg\\:focus\\:bg-red-700:focus {
    --bg-opacity: 1;
    background-color: #c81e1e;
    background-color: rgba(200, 30, 30, var(--bg-opacity));
  }
  .lg\\:focus\\:bg-red-800:focus {
    --bg-opacity: 1;
    background-color: #9b1c1c;
    background-color: rgba(155, 28, 28, var(--bg-opacity));
  }
  .lg\\:focus\\:bg-red-900:focus {
    --bg-opacity: 1;
    background-color: #771d1d;
    background-color: rgba(119, 29, 29, var(--bg-opacity));
  }
  .lg\\:focus\\:bg-orange-50:focus {
    --bg-opacity: 1;
    background-color: #fff8f1;
    background-color: rgba(255, 248, 241, var(--bg-opacity));
  }
  .lg\\:focus\\:bg-orange-100:focus {
    --bg-opacity: 1;
    background-color: #feecdc;
    background-color: rgba(254, 236, 220, var(--bg-opacity));
  }
  .lg\\:focus\\:bg-orange-200:focus {
    --bg-opacity: 1;
    background-color: #fcd9bd;
    background-color: rgba(252, 217, 189, var(--bg-opacity));
  }
  .lg\\:focus\\:bg-orange-300:focus {
    --bg-opacity: 1;
    background-color: #fdba8c;
    background-color: rgba(253, 186, 140, var(--bg-opacity));
  }
  .lg\\:focus\\:bg-orange-400:focus {
    --bg-opacity: 1;
    background-color: #ff8a4c;
    background-color: rgba(255, 138, 76, var(--bg-opacity));
  }
  .lg\\:focus\\:bg-orange-500:focus {
    --bg-opacity: 1;
    background-color: #ff5a1f;
    background-color: rgba(255, 90, 31, var(--bg-opacity));
  }
  .lg\\:focus\\:bg-orange-600:focus {
    --bg-opacity: 1;
    background-color: #d03801;
    background-color: rgba(208, 56, 1, var(--bg-opacity));
  }
  .lg\\:focus\\:bg-orange-700:focus {
    --bg-opacity: 1;
    background-color: #b43403;
    background-color: rgba(180, 52, 3, var(--bg-opacity));
  }
  .lg\\:focus\\:bg-orange-800:focus {
    --bg-opacity: 1;
    background-color: #8a2c0d;
    background-color: rgba(138, 44, 13, var(--bg-opacity));
  }
  .lg\\:focus\\:bg-orange-900:focus {
    --bg-opacity: 1;
    background-color: #73230d;
    background-color: rgba(115, 35, 13, var(--bg-opacity));
  }
  .lg\\:focus\\:bg-yellow-50:focus {
    --bg-opacity: 1;
    background-color: #fdfdea;
    background-color: rgba(253, 253, 234, var(--bg-opacity));
  }
  .lg\\:focus\\:bg-yellow-100:focus {
    --bg-opacity: 1;
    background-color: #fdf6b2;
    background-color: rgba(253, 246, 178, var(--bg-opacity));
  }
  .lg\\:focus\\:bg-yellow-200:focus {
    --bg-opacity: 1;
    background-color: #fce96a;
    background-color: rgba(252, 233, 106, var(--bg-opacity));
  }
  .lg\\:focus\\:bg-yellow-300:focus {
    --bg-opacity: 1;
    background-color: #faca15;
    background-color: rgba(250, 202, 21, var(--bg-opacity));
  }
  .lg\\:focus\\:bg-yellow-400:focus {
    --bg-opacity: 1;
    background-color: #e3a008;
    background-color: rgba(227, 160, 8, var(--bg-opacity));
  }
  .lg\\:focus\\:bg-yellow-500:focus {
    --bg-opacity: 1;
    background-color: #c27803;
    background-color: rgba(194, 120, 3, var(--bg-opacity));
  }
  .lg\\:focus\\:bg-yellow-600:focus {
    --bg-opacity: 1;
    background-color: #9f580a;
    background-color: rgba(159, 88, 10, var(--bg-opacity));
  }
  .lg\\:focus\\:bg-yellow-700:focus {
    --bg-opacity: 1;
    background-color: #8e4b10;
    background-color: rgba(142, 75, 16, var(--bg-opacity));
  }
  .lg\\:focus\\:bg-yellow-800:focus {
    --bg-opacity: 1;
    background-color: #723b13;
    background-color: rgba(114, 59, 19, var(--bg-opacity));
  }
  .lg\\:focus\\:bg-yellow-900:focus {
    --bg-opacity: 1;
    background-color: #633112;
    background-color: rgba(99, 49, 18, var(--bg-opacity));
  }
  .lg\\:focus\\:bg-green-50:focus {
    --bg-opacity: 1;
    background-color: #f3faf7;
    background-color: rgba(243, 250, 247, var(--bg-opacity));
  }
  .lg\\:focus\\:bg-green-100:focus {
    --bg-opacity: 1;
    background-color: #def7ec;
    background-color: rgba(222, 247, 236, var(--bg-opacity));
  }
  .lg\\:focus\\:bg-green-200:focus {
    --bg-opacity: 1;
    background-color: #bcf0da;
    background-color: rgba(188, 240, 218, var(--bg-opacity));
  }
  .lg\\:focus\\:bg-green-300:focus {
    --bg-opacity: 1;
    background-color: #84e1bc;
    background-color: rgba(132, 225, 188, var(--bg-opacity));
  }
  .lg\\:focus\\:bg-green-400:focus {
    --bg-opacity: 1;
    background-color: #31c48d;
    background-color: rgba(49, 196, 141, var(--bg-opacity));
  }
  .lg\\:focus\\:bg-green-500:focus {
    --bg-opacity: 1;
    background-color: #0e9f6e;
    background-color: rgba(14, 159, 110, var(--bg-opacity));
  }
  .lg\\:focus\\:bg-green-600:focus {
    --bg-opacity: 1;
    background-color: #057a55;
    background-color: rgba(5, 122, 85, var(--bg-opacity));
  }
  .lg\\:focus\\:bg-green-700:focus {
    --bg-opacity: 1;
    background-color: #046c4e;
    background-color: rgba(4, 108, 78, var(--bg-opacity));
  }
  .lg\\:focus\\:bg-green-800:focus {
    --bg-opacity: 1;
    background-color: #03543f;
    background-color: rgba(3, 84, 63, var(--bg-opacity));
  }
  .lg\\:focus\\:bg-green-900:focus {
    --bg-opacity: 1;
    background-color: #014737;
    background-color: rgba(1, 71, 55, var(--bg-opacity));
  }
  .lg\\:focus\\:bg-teal-50:focus {
    --bg-opacity: 1;
    background-color: #edfafa;
    background-color: rgba(237, 250, 250, var(--bg-opacity));
  }
  .lg\\:focus\\:bg-teal-100:focus {
    --bg-opacity: 1;
    background-color: #d5f5f6;
    background-color: rgba(213, 245, 246, var(--bg-opacity));
  }
  .lg\\:focus\\:bg-teal-200:focus {
    --bg-opacity: 1;
    background-color: #afecef;
    background-color: rgba(175, 236, 239, var(--bg-opacity));
  }
  .lg\\:focus\\:bg-teal-300:focus {
    --bg-opacity: 1;
    background-color: #7edce2;
    background-color: rgba(126, 220, 226, var(--bg-opacity));
  }
  .lg\\:focus\\:bg-teal-400:focus {
    --bg-opacity: 1;
    background-color: #16bdca;
    background-color: rgba(22, 189, 202, var(--bg-opacity));
  }
  .lg\\:focus\\:bg-teal-500:focus {
    --bg-opacity: 1;
    background-color: #0694a2;
    background-color: rgba(6, 148, 162, var(--bg-opacity));
  }
  .lg\\:focus\\:bg-teal-600:focus {
    --bg-opacity: 1;
    background-color: #047481;
    background-color: rgba(4, 116, 129, var(--bg-opacity));
  }
  .lg\\:focus\\:bg-teal-700:focus {
    --bg-opacity: 1;
    background-color: #036672;
    background-color: rgba(3, 102, 114, var(--bg-opacity));
  }
  .lg\\:focus\\:bg-teal-800:focus {
    --bg-opacity: 1;
    background-color: #05505c;
    background-color: rgba(5, 80, 92, var(--bg-opacity));
  }
  .lg\\:focus\\:bg-teal-900:focus {
    --bg-opacity: 1;
    background-color: #014451;
    background-color: rgba(1, 68, 81, var(--bg-opacity));
  }
  .lg\\:focus\\:bg-blue-50:focus {
    --bg-opacity: 1;
    background-color: #ebf5ff;
    background-color: rgba(235, 245, 255, var(--bg-opacity));
  }
  .lg\\:focus\\:bg-blue-100:focus {
    --bg-opacity: 1;
    background-color: #e1effe;
    background-color: rgba(225, 239, 254, var(--bg-opacity));
  }
  .lg\\:focus\\:bg-blue-200:focus {
    --bg-opacity: 1;
    background-color: #c3ddfd;
    background-color: rgba(195, 221, 253, var(--bg-opacity));
  }
  .lg\\:focus\\:bg-blue-300:focus {
    --bg-opacity: 1;
    background-color: #a4cafe;
    background-color: rgba(164, 202, 254, var(--bg-opacity));
  }
  .lg\\:focus\\:bg-blue-400:focus {
    --bg-opacity: 1;
    background-color: #76a9fa;
    background-color: rgba(118, 169, 250, var(--bg-opacity));
  }
  .lg\\:focus\\:bg-blue-500:focus {
    --bg-opacity: 1;
    background-color: #3f83f8;
    background-color: rgba(63, 131, 248, var(--bg-opacity));
  }
  .lg\\:focus\\:bg-blue-600:focus {
    --bg-opacity: 1;
    background-color: #1c64f2;
    background-color: rgba(28, 100, 242, var(--bg-opacity));
  }
  .lg\\:focus\\:bg-blue-700:focus {
    --bg-opacity: 1;
    background-color: #1a56db;
    background-color: rgba(26, 86, 219, var(--bg-opacity));
  }
  .lg\\:focus\\:bg-blue-800:focus {
    --bg-opacity: 1;
    background-color: #1e429f;
    background-color: rgba(30, 66, 159, var(--bg-opacity));
  }
  .lg\\:focus\\:bg-blue-900:focus {
    --bg-opacity: 1;
    background-color: #233876;
    background-color: rgba(35, 56, 118, var(--bg-opacity));
  }
  .lg\\:focus\\:bg-indigo-50:focus {
    --bg-opacity: 1;
    background-color: #f0f5ff;
    background-color: rgba(240, 245, 255, var(--bg-opacity));
  }
  .lg\\:focus\\:bg-indigo-100:focus {
    --bg-opacity: 1;
    background-color: #e5edff;
    background-color: rgba(229, 237, 255, var(--bg-opacity));
  }
  .lg\\:focus\\:bg-indigo-200:focus {
    --bg-opacity: 1;
    background-color: #cddbfe;
    background-color: rgba(205, 219, 254, var(--bg-opacity));
  }
  .lg\\:focus\\:bg-indigo-300:focus {
    --bg-opacity: 1;
    background-color: #b4c6fc;
    background-color: rgba(180, 198, 252, var(--bg-opacity));
  }
  .lg\\:focus\\:bg-indigo-400:focus {
    --bg-opacity: 1;
    background-color: #8da2fb;
    background-color: rgba(141, 162, 251, var(--bg-opacity));
  }
  .lg\\:focus\\:bg-indigo-500:focus {
    --bg-opacity: 1;
    background-color: #6875f5;
    background-color: rgba(104, 117, 245, var(--bg-opacity));
  }
  .lg\\:focus\\:bg-indigo-600:focus {
    --bg-opacity: 1;
    background-color: #5850ec;
    background-color: rgba(88, 80, 236, var(--bg-opacity));
  }
  .lg\\:focus\\:bg-indigo-700:focus {
    --bg-opacity: 1;
    background-color: #5145cd;
    background-color: rgba(81, 69, 205, var(--bg-opacity));
  }
  .lg\\:focus\\:bg-indigo-800:focus {
    --bg-opacity: 1;
    background-color: #42389d;
    background-color: rgba(66, 56, 157, var(--bg-opacity));
  }
  .lg\\:focus\\:bg-indigo-900:focus {
    --bg-opacity: 1;
    background-color: #362f78;
    background-color: rgba(54, 47, 120, var(--bg-opacity));
  }
  .lg\\:focus\\:bg-purple-50:focus {
    --bg-opacity: 1;
    background-color: #f6f5ff;
    background-color: rgba(246, 245, 255, var(--bg-opacity));
  }
  .lg\\:focus\\:bg-purple-100:focus {
    --bg-opacity: 1;
    background-color: #edebfe;
    background-color: rgba(237, 235, 254, var(--bg-opacity));
  }
  .lg\\:focus\\:bg-purple-200:focus {
    --bg-opacity: 1;
    background-color: #dcd7fe;
    background-color: rgba(220, 215, 254, var(--bg-opacity));
  }
  .lg\\:focus\\:bg-purple-300:focus {
    --bg-opacity: 1;
    background-color: #cabffd;
    background-color: rgba(202, 191, 253, var(--bg-opacity));
  }
  .lg\\:focus\\:bg-purple-400:focus {
    --bg-opacity: 1;
    background-color: #ac94fa;
    background-color: rgba(172, 148, 250, var(--bg-opacity));
  }
  .lg\\:focus\\:bg-purple-500:focus {
    --bg-opacity: 1;
    background-color: #9061f9;
    background-color: rgba(144, 97, 249, var(--bg-opacity));
  }
  .lg\\:focus\\:bg-purple-600:focus {
    --bg-opacity: 1;
    background-color: #7e3af2;
    background-color: rgba(126, 58, 242, var(--bg-opacity));
  }
  .lg\\:focus\\:bg-purple-700:focus {
    --bg-opacity: 1;
    background-color: #6c2bd9;
    background-color: rgba(108, 43, 217, var(--bg-opacity));
  }
  .lg\\:focus\\:bg-purple-800:focus {
    --bg-opacity: 1;
    background-color: #5521b5;
    background-color: rgba(85, 33, 181, var(--bg-opacity));
  }
  .lg\\:focus\\:bg-purple-900:focus {
    --bg-opacity: 1;
    background-color: #4a1d96;
    background-color: rgba(74, 29, 150, var(--bg-opacity));
  }
  .lg\\:focus\\:bg-pink-50:focus {
    --bg-opacity: 1;
    background-color: #fdf2f8;
    background-color: rgba(253, 242, 248, var(--bg-opacity));
  }
  .lg\\:focus\\:bg-pink-100:focus {
    --bg-opacity: 1;
    background-color: #fce8f3;
    background-color: rgba(252, 232, 243, var(--bg-opacity));
  }
  .lg\\:focus\\:bg-pink-200:focus {
    --bg-opacity: 1;
    background-color: #fad1e8;
    background-color: rgba(250, 209, 232, var(--bg-opacity));
  }
  .lg\\:focus\\:bg-pink-300:focus {
    --bg-opacity: 1;
    background-color: #f8b4d9;
    background-color: rgba(248, 180, 217, var(--bg-opacity));
  }
  .lg\\:focus\\:bg-pink-400:focus {
    --bg-opacity: 1;
    background-color: #f17eb8;
    background-color: rgba(241, 126, 184, var(--bg-opacity));
  }
  .lg\\:focus\\:bg-pink-500:focus {
    --bg-opacity: 1;
    background-color: #e74694;
    background-color: rgba(231, 70, 148, var(--bg-opacity));
  }
  .lg\\:focus\\:bg-pink-600:focus {
    --bg-opacity: 1;
    background-color: #d61f69;
    background-color: rgba(214, 31, 105, var(--bg-opacity));
  }
  .lg\\:focus\\:bg-pink-700:focus {
    --bg-opacity: 1;
    background-color: #bf125d;
    background-color: rgba(191, 18, 93, var(--bg-opacity));
  }
  .lg\\:focus\\:bg-pink-800:focus {
    --bg-opacity: 1;
    background-color: #99154b;
    background-color: rgba(153, 21, 75, var(--bg-opacity));
  }
  .lg\\:focus\\:bg-pink-900:focus {
    --bg-opacity: 1;
    background-color: #751a3d;
    background-color: rgba(117, 26, 61, var(--bg-opacity));
  }
  .lg\\:focus\\:bg-cool-gray-50:focus {
    --bg-opacity: 1;
    background-color: #f8fafc;
    background-color: rgba(248, 250, 252, var(--bg-opacity));
  }
  .lg\\:focus\\:bg-cool-gray-100:focus {
    --bg-opacity: 1;
    background-color: #f1f5f9;
    background-color: rgba(241, 245, 249, var(--bg-opacity));
  }
  .lg\\:focus\\:bg-cool-gray-200:focus {
    --bg-opacity: 1;
    background-color: #e2e8f0;
    background-color: rgba(226, 232, 240, var(--bg-opacity));
  }
  .lg\\:focus\\:bg-cool-gray-300:focus {
    --bg-opacity: 1;
    background-color: #cfd8e3;
    background-color: rgba(207, 216, 227, var(--bg-opacity));
  }
  .lg\\:focus\\:bg-cool-gray-400:focus {
    --bg-opacity: 1;
    background-color: #97a6ba;
    background-color: rgba(151, 166, 186, var(--bg-opacity));
  }
  .lg\\:focus\\:bg-cool-gray-500:focus {
    --bg-opacity: 1;
    background-color: #64748b;
    background-color: rgba(100, 116, 139, var(--bg-opacity));
  }
  .lg\\:focus\\:bg-cool-gray-600:focus {
    --bg-opacity: 1;
    background-color: #475569;
    background-color: rgba(71, 85, 105, var(--bg-opacity));
  }
  .lg\\:focus\\:bg-cool-gray-700:focus {
    --bg-opacity: 1;
    background-color: #364152;
    background-color: rgba(54, 65, 82, var(--bg-opacity));
  }
  .lg\\:focus\\:bg-cool-gray-800:focus {
    --bg-opacity: 1;
    background-color: #27303f;
    background-color: rgba(39, 48, 63, var(--bg-opacity));
  }
  .lg\\:focus\\:bg-cool-gray-900:focus {
    --bg-opacity: 1;
    background-color: #1a202e;
    background-color: rgba(26, 32, 46, var(--bg-opacity));
  }
  .lg\\:active\\:bg-current:active {
    background-color: currentColor;
  }
  .lg\\:active\\:bg-transparent:active {
    background-color: transparent;
  }
  .lg\\:active\\:bg-white:active {
    --bg-opacity: 1;
    background-color: #ffffff;
    background-color: rgba(255, 255, 255, var(--bg-opacity));
  }
  .lg\\:active\\:bg-black:active {
    --bg-opacity: 1;
    background-color: #000000;
    background-color: rgba(0, 0, 0, var(--bg-opacity));
  }
  .lg\\:active\\:bg-gray-50:active {
    --bg-opacity: 1;
    background-color: #f9fafb;
    background-color: rgba(249, 250, 251, var(--bg-opacity));
  }
  .lg\\:active\\:bg-gray-100:active {
    --bg-opacity: 1;
    background-color: #f4f5f7;
    background-color: rgba(244, 245, 247, var(--bg-opacity));
  }
  .lg\\:active\\:bg-gray-200:active {
    --bg-opacity: 1;
    background-color: #e5e7eb;
    background-color: rgba(229, 231, 235, var(--bg-opacity));
  }
  .lg\\:active\\:bg-gray-300:active {
    --bg-opacity: 1;
    background-color: #d2d6dc;
    background-color: rgba(210, 214, 220, var(--bg-opacity));
  }
  .lg\\:active\\:bg-gray-400:active {
    --bg-opacity: 1;
    background-color: #9fa6b2;
    background-color: rgba(159, 166, 178, var(--bg-opacity));
  }
  .lg\\:active\\:bg-gray-500:active {
    --bg-opacity: 1;
    background-color: #6b7280;
    background-color: rgba(107, 114, 128, var(--bg-opacity));
  }
  .lg\\:active\\:bg-gray-600:active {
    --bg-opacity: 1;
    background-color: #4b5563;
    background-color: rgba(75, 85, 99, var(--bg-opacity));
  }
  .lg\\:active\\:bg-gray-700:active {
    --bg-opacity: 1;
    background-color: #374151;
    background-color: rgba(55, 65, 81, var(--bg-opacity));
  }
  .lg\\:active\\:bg-gray-800:active {
    --bg-opacity: 1;
    background-color: #252f3f;
    background-color: rgba(37, 47, 63, var(--bg-opacity));
  }
  .lg\\:active\\:bg-gray-900:active {
    --bg-opacity: 1;
    background-color: #161e2e;
    background-color: rgba(22, 30, 46, var(--bg-opacity));
  }
  .lg\\:active\\:bg-red-50:active {
    --bg-opacity: 1;
    background-color: #fdf2f2;
    background-color: rgba(253, 242, 242, var(--bg-opacity));
  }
  .lg\\:active\\:bg-red-100:active {
    --bg-opacity: 1;
    background-color: #fde8e8;
    background-color: rgba(253, 232, 232, var(--bg-opacity));
  }
  .lg\\:active\\:bg-red-200:active {
    --bg-opacity: 1;
    background-color: #fbd5d5;
    background-color: rgba(251, 213, 213, var(--bg-opacity));
  }
  .lg\\:active\\:bg-red-300:active {
    --bg-opacity: 1;
    background-color: #f8b4b4;
    background-color: rgba(248, 180, 180, var(--bg-opacity));
  }
  .lg\\:active\\:bg-red-400:active {
    --bg-opacity: 1;
    background-color: #f98080;
    background-color: rgba(249, 128, 128, var(--bg-opacity));
  }
  .lg\\:active\\:bg-red-500:active {
    --bg-opacity: 1;
    background-color: #f05252;
    background-color: rgba(240, 82, 82, var(--bg-opacity));
  }
  .lg\\:active\\:bg-red-600:active {
    --bg-opacity: 1;
    background-color: #e02424;
    background-color: rgba(224, 36, 36, var(--bg-opacity));
  }
  .lg\\:active\\:bg-red-700:active {
    --bg-opacity: 1;
    background-color: #c81e1e;
    background-color: rgba(200, 30, 30, var(--bg-opacity));
  }
  .lg\\:active\\:bg-red-800:active {
    --bg-opacity: 1;
    background-color: #9b1c1c;
    background-color: rgba(155, 28, 28, var(--bg-opacity));
  }
  .lg\\:active\\:bg-red-900:active {
    --bg-opacity: 1;
    background-color: #771d1d;
    background-color: rgba(119, 29, 29, var(--bg-opacity));
  }
  .lg\\:active\\:bg-orange-50:active {
    --bg-opacity: 1;
    background-color: #fff8f1;
    background-color: rgba(255, 248, 241, var(--bg-opacity));
  }
  .lg\\:active\\:bg-orange-100:active {
    --bg-opacity: 1;
    background-color: #feecdc;
    background-color: rgba(254, 236, 220, var(--bg-opacity));
  }
  .lg\\:active\\:bg-orange-200:active {
    --bg-opacity: 1;
    background-color: #fcd9bd;
    background-color: rgba(252, 217, 189, var(--bg-opacity));
  }
  .lg\\:active\\:bg-orange-300:active {
    --bg-opacity: 1;
    background-color: #fdba8c;
    background-color: rgba(253, 186, 140, var(--bg-opacity));
  }
  .lg\\:active\\:bg-orange-400:active {
    --bg-opacity: 1;
    background-color: #ff8a4c;
    background-color: rgba(255, 138, 76, var(--bg-opacity));
  }
  .lg\\:active\\:bg-orange-500:active {
    --bg-opacity: 1;
    background-color: #ff5a1f;
    background-color: rgba(255, 90, 31, var(--bg-opacity));
  }
  .lg\\:active\\:bg-orange-600:active {
    --bg-opacity: 1;
    background-color: #d03801;
    background-color: rgba(208, 56, 1, var(--bg-opacity));
  }
  .lg\\:active\\:bg-orange-700:active {
    --bg-opacity: 1;
    background-color: #b43403;
    background-color: rgba(180, 52, 3, var(--bg-opacity));
  }
  .lg\\:active\\:bg-orange-800:active {
    --bg-opacity: 1;
    background-color: #8a2c0d;
    background-color: rgba(138, 44, 13, var(--bg-opacity));
  }
  .lg\\:active\\:bg-orange-900:active {
    --bg-opacity: 1;
    background-color: #73230d;
    background-color: rgba(115, 35, 13, var(--bg-opacity));
  }
  .lg\\:active\\:bg-yellow-50:active {
    --bg-opacity: 1;
    background-color: #fdfdea;
    background-color: rgba(253, 253, 234, var(--bg-opacity));
  }
  .lg\\:active\\:bg-yellow-100:active {
    --bg-opacity: 1;
    background-color: #fdf6b2;
    background-color: rgba(253, 246, 178, var(--bg-opacity));
  }
  .lg\\:active\\:bg-yellow-200:active {
    --bg-opacity: 1;
    background-color: #fce96a;
    background-color: rgba(252, 233, 106, var(--bg-opacity));
  }
  .lg\\:active\\:bg-yellow-300:active {
    --bg-opacity: 1;
    background-color: #faca15;
    background-color: rgba(250, 202, 21, var(--bg-opacity));
  }
  .lg\\:active\\:bg-yellow-400:active {
    --bg-opacity: 1;
    background-color: #e3a008;
    background-color: rgba(227, 160, 8, var(--bg-opacity));
  }
  .lg\\:active\\:bg-yellow-500:active {
    --bg-opacity: 1;
    background-color: #c27803;
    background-color: rgba(194, 120, 3, var(--bg-opacity));
  }
  .lg\\:active\\:bg-yellow-600:active {
    --bg-opacity: 1;
    background-color: #9f580a;
    background-color: rgba(159, 88, 10, var(--bg-opacity));
  }
  .lg\\:active\\:bg-yellow-700:active {
    --bg-opacity: 1;
    background-color: #8e4b10;
    background-color: rgba(142, 75, 16, var(--bg-opacity));
  }
  .lg\\:active\\:bg-yellow-800:active {
    --bg-opacity: 1;
    background-color: #723b13;
    background-color: rgba(114, 59, 19, var(--bg-opacity));
  }
  .lg\\:active\\:bg-yellow-900:active {
    --bg-opacity: 1;
    background-color: #633112;
    background-color: rgba(99, 49, 18, var(--bg-opacity));
  }
  .lg\\:active\\:bg-green-50:active {
    --bg-opacity: 1;
    background-color: #f3faf7;
    background-color: rgba(243, 250, 247, var(--bg-opacity));
  }
  .lg\\:active\\:bg-green-100:active {
    --bg-opacity: 1;
    background-color: #def7ec;
    background-color: rgba(222, 247, 236, var(--bg-opacity));
  }
  .lg\\:active\\:bg-green-200:active {
    --bg-opacity: 1;
    background-color: #bcf0da;
    background-color: rgba(188, 240, 218, var(--bg-opacity));
  }
  .lg\\:active\\:bg-green-300:active {
    --bg-opacity: 1;
    background-color: #84e1bc;
    background-color: rgba(132, 225, 188, var(--bg-opacity));
  }
  .lg\\:active\\:bg-green-400:active {
    --bg-opacity: 1;
    background-color: #31c48d;
    background-color: rgba(49, 196, 141, var(--bg-opacity));
  }
  .lg\\:active\\:bg-green-500:active {
    --bg-opacity: 1;
    background-color: #0e9f6e;
    background-color: rgba(14, 159, 110, var(--bg-opacity));
  }
  .lg\\:active\\:bg-green-600:active {
    --bg-opacity: 1;
    background-color: #057a55;
    background-color: rgba(5, 122, 85, var(--bg-opacity));
  }
  .lg\\:active\\:bg-green-700:active {
    --bg-opacity: 1;
    background-color: #046c4e;
    background-color: rgba(4, 108, 78, var(--bg-opacity));
  }
  .lg\\:active\\:bg-green-800:active {
    --bg-opacity: 1;
    background-color: #03543f;
    background-color: rgba(3, 84, 63, var(--bg-opacity));
  }
  .lg\\:active\\:bg-green-900:active {
    --bg-opacity: 1;
    background-color: #014737;
    background-color: rgba(1, 71, 55, var(--bg-opacity));
  }
  .lg\\:active\\:bg-teal-50:active {
    --bg-opacity: 1;
    background-color: #edfafa;
    background-color: rgba(237, 250, 250, var(--bg-opacity));
  }
  .lg\\:active\\:bg-teal-100:active {
    --bg-opacity: 1;
    background-color: #d5f5f6;
    background-color: rgba(213, 245, 246, var(--bg-opacity));
  }
  .lg\\:active\\:bg-teal-200:active {
    --bg-opacity: 1;
    background-color: #afecef;
    background-color: rgba(175, 236, 239, var(--bg-opacity));
  }
  .lg\\:active\\:bg-teal-300:active {
    --bg-opacity: 1;
    background-color: #7edce2;
    background-color: rgba(126, 220, 226, var(--bg-opacity));
  }
  .lg\\:active\\:bg-teal-400:active {
    --bg-opacity: 1;
    background-color: #16bdca;
    background-color: rgba(22, 189, 202, var(--bg-opacity));
  }
  .lg\\:active\\:bg-teal-500:active {
    --bg-opacity: 1;
    background-color: #0694a2;
    background-color: rgba(6, 148, 162, var(--bg-opacity));
  }
  .lg\\:active\\:bg-teal-600:active {
    --bg-opacity: 1;
    background-color: #047481;
    background-color: rgba(4, 116, 129, var(--bg-opacity));
  }
  .lg\\:active\\:bg-teal-700:active {
    --bg-opacity: 1;
    background-color: #036672;
    background-color: rgba(3, 102, 114, var(--bg-opacity));
  }
  .lg\\:active\\:bg-teal-800:active {
    --bg-opacity: 1;
    background-color: #05505c;
    background-color: rgba(5, 80, 92, var(--bg-opacity));
  }
  .lg\\:active\\:bg-teal-900:active {
    --bg-opacity: 1;
    background-color: #014451;
    background-color: rgba(1, 68, 81, var(--bg-opacity));
  }
  .lg\\:active\\:bg-blue-50:active {
    --bg-opacity: 1;
    background-color: #ebf5ff;
    background-color: rgba(235, 245, 255, var(--bg-opacity));
  }
  .lg\\:active\\:bg-blue-100:active {
    --bg-opacity: 1;
    background-color: #e1effe;
    background-color: rgba(225, 239, 254, var(--bg-opacity));
  }
  .lg\\:active\\:bg-blue-200:active {
    --bg-opacity: 1;
    background-color: #c3ddfd;
    background-color: rgba(195, 221, 253, var(--bg-opacity));
  }
  .lg\\:active\\:bg-blue-300:active {
    --bg-opacity: 1;
    background-color: #a4cafe;
    background-color: rgba(164, 202, 254, var(--bg-opacity));
  }
  .lg\\:active\\:bg-blue-400:active {
    --bg-opacity: 1;
    background-color: #76a9fa;
    background-color: rgba(118, 169, 250, var(--bg-opacity));
  }
  .lg\\:active\\:bg-blue-500:active {
    --bg-opacity: 1;
    background-color: #3f83f8;
    background-color: rgba(63, 131, 248, var(--bg-opacity));
  }
  .lg\\:active\\:bg-blue-600:active {
    --bg-opacity: 1;
    background-color: #1c64f2;
    background-color: rgba(28, 100, 242, var(--bg-opacity));
  }
  .lg\\:active\\:bg-blue-700:active {
    --bg-opacity: 1;
    background-color: #1a56db;
    background-color: rgba(26, 86, 219, var(--bg-opacity));
  }
  .lg\\:active\\:bg-blue-800:active {
    --bg-opacity: 1;
    background-color: #1e429f;
    background-color: rgba(30, 66, 159, var(--bg-opacity));
  }
  .lg\\:active\\:bg-blue-900:active {
    --bg-opacity: 1;
    background-color: #233876;
    background-color: rgba(35, 56, 118, var(--bg-opacity));
  }
  .lg\\:active\\:bg-indigo-50:active {
    --bg-opacity: 1;
    background-color: #f0f5ff;
    background-color: rgba(240, 245, 255, var(--bg-opacity));
  }
  .lg\\:active\\:bg-indigo-100:active {
    --bg-opacity: 1;
    background-color: #e5edff;
    background-color: rgba(229, 237, 255, var(--bg-opacity));
  }
  .lg\\:active\\:bg-indigo-200:active {
    --bg-opacity: 1;
    background-color: #cddbfe;
    background-color: rgba(205, 219, 254, var(--bg-opacity));
  }
  .lg\\:active\\:bg-indigo-300:active {
    --bg-opacity: 1;
    background-color: #b4c6fc;
    background-color: rgba(180, 198, 252, var(--bg-opacity));
  }
  .lg\\:active\\:bg-indigo-400:active {
    --bg-opacity: 1;
    background-color: #8da2fb;
    background-color: rgba(141, 162, 251, var(--bg-opacity));
  }
  .lg\\:active\\:bg-indigo-500:active {
    --bg-opacity: 1;
    background-color: #6875f5;
    background-color: rgba(104, 117, 245, var(--bg-opacity));
  }
  .lg\\:active\\:bg-indigo-600:active {
    --bg-opacity: 1;
    background-color: #5850ec;
    background-color: rgba(88, 80, 236, var(--bg-opacity));
  }
  .lg\\:active\\:bg-indigo-700:active {
    --bg-opacity: 1;
    background-color: #5145cd;
    background-color: rgba(81, 69, 205, var(--bg-opacity));
  }
  .lg\\:active\\:bg-indigo-800:active {
    --bg-opacity: 1;
    background-color: #42389d;
    background-color: rgba(66, 56, 157, var(--bg-opacity));
  }
  .lg\\:active\\:bg-indigo-900:active {
    --bg-opacity: 1;
    background-color: #362f78;
    background-color: rgba(54, 47, 120, var(--bg-opacity));
  }
  .lg\\:active\\:bg-purple-50:active {
    --bg-opacity: 1;
    background-color: #f6f5ff;
    background-color: rgba(246, 245, 255, var(--bg-opacity));
  }
  .lg\\:active\\:bg-purple-100:active {
    --bg-opacity: 1;
    background-color: #edebfe;
    background-color: rgba(237, 235, 254, var(--bg-opacity));
  }
  .lg\\:active\\:bg-purple-200:active {
    --bg-opacity: 1;
    background-color: #dcd7fe;
    background-color: rgba(220, 215, 254, var(--bg-opacity));
  }
  .lg\\:active\\:bg-purple-300:active {
    --bg-opacity: 1;
    background-color: #cabffd;
    background-color: rgba(202, 191, 253, var(--bg-opacity));
  }
  .lg\\:active\\:bg-purple-400:active {
    --bg-opacity: 1;
    background-color: #ac94fa;
    background-color: rgba(172, 148, 250, var(--bg-opacity));
  }
  .lg\\:active\\:bg-purple-500:active {
    --bg-opacity: 1;
    background-color: #9061f9;
    background-color: rgba(144, 97, 249, var(--bg-opacity));
  }
  .lg\\:active\\:bg-purple-600:active {
    --bg-opacity: 1;
    background-color: #7e3af2;
    background-color: rgba(126, 58, 242, var(--bg-opacity));
  }
  .lg\\:active\\:bg-purple-700:active {
    --bg-opacity: 1;
    background-color: #6c2bd9;
    background-color: rgba(108, 43, 217, var(--bg-opacity));
  }
  .lg\\:active\\:bg-purple-800:active {
    --bg-opacity: 1;
    background-color: #5521b5;
    background-color: rgba(85, 33, 181, var(--bg-opacity));
  }
  .lg\\:active\\:bg-purple-900:active {
    --bg-opacity: 1;
    background-color: #4a1d96;
    background-color: rgba(74, 29, 150, var(--bg-opacity));
  }
  .lg\\:active\\:bg-pink-50:active {
    --bg-opacity: 1;
    background-color: #fdf2f8;
    background-color: rgba(253, 242, 248, var(--bg-opacity));
  }
  .lg\\:active\\:bg-pink-100:active {
    --bg-opacity: 1;
    background-color: #fce8f3;
    background-color: rgba(252, 232, 243, var(--bg-opacity));
  }
  .lg\\:active\\:bg-pink-200:active {
    --bg-opacity: 1;
    background-color: #fad1e8;
    background-color: rgba(250, 209, 232, var(--bg-opacity));
  }
  .lg\\:active\\:bg-pink-300:active {
    --bg-opacity: 1;
    background-color: #f8b4d9;
    background-color: rgba(248, 180, 217, var(--bg-opacity));
  }
  .lg\\:active\\:bg-pink-400:active {
    --bg-opacity: 1;
    background-color: #f17eb8;
    background-color: rgba(241, 126, 184, var(--bg-opacity));
  }
  .lg\\:active\\:bg-pink-500:active {
    --bg-opacity: 1;
    background-color: #e74694;
    background-color: rgba(231, 70, 148, var(--bg-opacity));
  }
  .lg\\:active\\:bg-pink-600:active {
    --bg-opacity: 1;
    background-color: #d61f69;
    background-color: rgba(214, 31, 105, var(--bg-opacity));
  }
  .lg\\:active\\:bg-pink-700:active {
    --bg-opacity: 1;
    background-color: #bf125d;
    background-color: rgba(191, 18, 93, var(--bg-opacity));
  }
  .lg\\:active\\:bg-pink-800:active {
    --bg-opacity: 1;
    background-color: #99154b;
    background-color: rgba(153, 21, 75, var(--bg-opacity));
  }
  .lg\\:active\\:bg-pink-900:active {
    --bg-opacity: 1;
    background-color: #751a3d;
    background-color: rgba(117, 26, 61, var(--bg-opacity));
  }
  .lg\\:active\\:bg-cool-gray-50:active {
    --bg-opacity: 1;
    background-color: #f8fafc;
    background-color: rgba(248, 250, 252, var(--bg-opacity));
  }
  .lg\\:active\\:bg-cool-gray-100:active {
    --bg-opacity: 1;
    background-color: #f1f5f9;
    background-color: rgba(241, 245, 249, var(--bg-opacity));
  }
  .lg\\:active\\:bg-cool-gray-200:active {
    --bg-opacity: 1;
    background-color: #e2e8f0;
    background-color: rgba(226, 232, 240, var(--bg-opacity));
  }
  .lg\\:active\\:bg-cool-gray-300:active {
    --bg-opacity: 1;
    background-color: #cfd8e3;
    background-color: rgba(207, 216, 227, var(--bg-opacity));
  }
  .lg\\:active\\:bg-cool-gray-400:active {
    --bg-opacity: 1;
    background-color: #97a6ba;
    background-color: rgba(151, 166, 186, var(--bg-opacity));
  }
  .lg\\:active\\:bg-cool-gray-500:active {
    --bg-opacity: 1;
    background-color: #64748b;
    background-color: rgba(100, 116, 139, var(--bg-opacity));
  }
  .lg\\:active\\:bg-cool-gray-600:active {
    --bg-opacity: 1;
    background-color: #475569;
    background-color: rgba(71, 85, 105, var(--bg-opacity));
  }
  .lg\\:active\\:bg-cool-gray-700:active {
    --bg-opacity: 1;
    background-color: #364152;
    background-color: rgba(54, 65, 82, var(--bg-opacity));
  }
  .lg\\:active\\:bg-cool-gray-800:active {
    --bg-opacity: 1;
    background-color: #27303f;
    background-color: rgba(39, 48, 63, var(--bg-opacity));
  }
  .lg\\:active\\:bg-cool-gray-900:active {
    --bg-opacity: 1;
    background-color: #1a202e;
    background-color: rgba(26, 32, 46, var(--bg-opacity));
  }
  .lg\\:bg-none {
    background-image: none;
  }
  .lg\\:bg-gradient-to-t {
    background-image: linear-gradient(to top, var(--gradient-color-stops));
  }
  .lg\\:bg-gradient-to-tr {
    background-image: linear-gradient(to top right, var(--gradient-color-stops));
  }
  .lg\\:bg-gradient-to-r {
    background-image: linear-gradient(to right, var(--gradient-color-stops));
  }
  .lg\\:bg-gradient-to-br {
    background-image: linear-gradient(to bottom right, var(--gradient-color-stops));
  }
  .lg\\:bg-gradient-to-b {
    background-image: linear-gradient(to bottom, var(--gradient-color-stops));
  }
  .lg\\:bg-gradient-to-bl {
    background-image: linear-gradient(to bottom left, var(--gradient-color-stops));
  }
  .lg\\:bg-gradient-to-l {
    background-image: linear-gradient(to left, var(--gradient-color-stops));
  }
  .lg\\:bg-gradient-to-tl {
    background-image: linear-gradient(to top left, var(--gradient-color-stops));
  }
  .lg\\:from-current {
    --gradient-from-color: currentColor;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }
  .lg\\:from-transparent {
    --gradient-from-color: transparent;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  }
  .lg\\:from-white {
    --gradient-from-color: #ffffff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }
  .lg\\:from-black {
    --gradient-from-color: #000000;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  }
  .lg\\:from-gray-50 {
    --gradient-from-color: #f9fafb;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(249, 250, 251, 0));
  }
  .lg\\:from-gray-100 {
    --gradient-from-color: #f4f5f7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(244, 245, 247, 0));
  }
  .lg\\:from-gray-200 {
    --gradient-from-color: #e5e7eb;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(229, 231, 235, 0));
  }
  .lg\\:from-gray-300 {
    --gradient-from-color: #d2d6dc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(210, 214, 220, 0));
  }
  .lg\\:from-gray-400 {
    --gradient-from-color: #9fa6b2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(159, 166, 178, 0));
  }
  .lg\\:from-gray-500 {
    --gradient-from-color: #6b7280;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(107, 114, 128, 0));
  }
  .lg\\:from-gray-600 {
    --gradient-from-color: #4b5563;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(75, 85, 99, 0));
  }
  .lg\\:from-gray-700 {
    --gradient-from-color: #374151;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(55, 65, 81, 0));
  }
  .lg\\:from-gray-800 {
    --gradient-from-color: #252f3f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(37, 47, 63, 0));
  }
  .lg\\:from-gray-900 {
    --gradient-from-color: #161e2e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(22, 30, 46, 0));
  }
  .lg\\:from-red-50 {
    --gradient-from-color: #fdf2f2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 242, 242, 0));
  }
  .lg\\:from-red-100 {
    --gradient-from-color: #fde8e8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 232, 232, 0));
  }
  .lg\\:from-red-200 {
    --gradient-from-color: #fbd5d5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(251, 213, 213, 0));
  }
  .lg\\:from-red-300 {
    --gradient-from-color: #f8b4b4;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(248, 180, 180, 0));
  }
  .lg\\:from-red-400 {
    --gradient-from-color: #f98080;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(249, 128, 128, 0));
  }
  .lg\\:from-red-500 {
    --gradient-from-color: #f05252;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(240, 82, 82, 0));
  }
  .lg\\:from-red-600 {
    --gradient-from-color: #e02424;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(224, 36, 36, 0));
  }
  .lg\\:from-red-700 {
    --gradient-from-color: #c81e1e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(200, 30, 30, 0));
  }
  .lg\\:from-red-800 {
    --gradient-from-color: #9b1c1c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(155, 28, 28, 0));
  }
  .lg\\:from-red-900 {
    --gradient-from-color: #771d1d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(119, 29, 29, 0));
  }
  .lg\\:from-orange-50 {
    --gradient-from-color: #fff8f1;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 248, 241, 0));
  }
  .lg\\:from-orange-100 {
    --gradient-from-color: #feecdc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 236, 220, 0));
  }
  .lg\\:from-orange-200 {
    --gradient-from-color: #fcd9bd;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(252, 217, 189, 0));
  }
  .lg\\:from-orange-300 {
    --gradient-from-color: #fdba8c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 186, 140, 0));
  }
  .lg\\:from-orange-400 {
    --gradient-from-color: #ff8a4c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 138, 76, 0));
  }
  .lg\\:from-orange-500 {
    --gradient-from-color: #ff5a1f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 90, 31, 0));
  }
  .lg\\:from-orange-600 {
    --gradient-from-color: #d03801;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(208, 56, 1, 0));
  }
  .lg\\:from-orange-700 {
    --gradient-from-color: #b43403;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(180, 52, 3, 0));
  }
  .lg\\:from-orange-800 {
    --gradient-from-color: #8a2c0d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(138, 44, 13, 0));
  }
  .lg\\:from-orange-900 {
    --gradient-from-color: #73230d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(115, 35, 13, 0));
  }
  .lg\\:from-yellow-50 {
    --gradient-from-color: #fdfdea;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 253, 234, 0));
  }
  .lg\\:from-yellow-100 {
    --gradient-from-color: #fdf6b2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 246, 178, 0));
  }
  .lg\\:from-yellow-200 {
    --gradient-from-color: #fce96a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(252, 233, 106, 0));
  }
  .lg\\:from-yellow-300 {
    --gradient-from-color: #faca15;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(250, 202, 21, 0));
  }
  .lg\\:from-yellow-400 {
    --gradient-from-color: #e3a008;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(227, 160, 8, 0));
  }
  .lg\\:from-yellow-500 {
    --gradient-from-color: #c27803;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(194, 120, 3, 0));
  }
  .lg\\:from-yellow-600 {
    --gradient-from-color: #9f580a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(159, 88, 10, 0));
  }
  .lg\\:from-yellow-700 {
    --gradient-from-color: #8e4b10;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(142, 75, 16, 0));
  }
  .lg\\:from-yellow-800 {
    --gradient-from-color: #723b13;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(114, 59, 19, 0));
  }
  .lg\\:from-yellow-900 {
    --gradient-from-color: #633112;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(99, 49, 18, 0));
  }
  .lg\\:from-green-50 {
    --gradient-from-color: #f3faf7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(243, 250, 247, 0));
  }
  .lg\\:from-green-100 {
    --gradient-from-color: #def7ec;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(222, 247, 236, 0));
  }
  .lg\\:from-green-200 {
    --gradient-from-color: #bcf0da;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(188, 240, 218, 0));
  }
  .lg\\:from-green-300 {
    --gradient-from-color: #84e1bc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(132, 225, 188, 0));
  }
  .lg\\:from-green-400 {
    --gradient-from-color: #31c48d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(49, 196, 141, 0));
  }
  .lg\\:from-green-500 {
    --gradient-from-color: #0e9f6e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(14, 159, 110, 0));
  }
  .lg\\:from-green-600 {
    --gradient-from-color: #057a55;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(5, 122, 85, 0));
  }
  .lg\\:from-green-700 {
    --gradient-from-color: #046c4e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(4, 108, 78, 0));
  }
  .lg\\:from-green-800 {
    --gradient-from-color: #03543f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(3, 84, 63, 0));
  }
  .lg\\:from-green-900 {
    --gradient-from-color: #014737;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(1, 71, 55, 0));
  }
  .lg\\:from-teal-50 {
    --gradient-from-color: #edfafa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(237, 250, 250, 0));
  }
  .lg\\:from-teal-100 {
    --gradient-from-color: #d5f5f6;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(213, 245, 246, 0));
  }
  .lg\\:from-teal-200 {
    --gradient-from-color: #afecef;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(175, 236, 239, 0));
  }
  .lg\\:from-teal-300 {
    --gradient-from-color: #7edce2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(126, 220, 226, 0));
  }
  .lg\\:from-teal-400 {
    --gradient-from-color: #16bdca;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(22, 189, 202, 0));
  }
  .lg\\:from-teal-500 {
    --gradient-from-color: #0694a2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(6, 148, 162, 0));
  }
  .lg\\:from-teal-600 {
    --gradient-from-color: #047481;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(4, 116, 129, 0));
  }
  .lg\\:from-teal-700 {
    --gradient-from-color: #036672;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(3, 102, 114, 0));
  }
  .lg\\:from-teal-800 {
    --gradient-from-color: #05505c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(5, 80, 92, 0));
  }
  .lg\\:from-teal-900 {
    --gradient-from-color: #014451;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(1, 68, 81, 0));
  }
  .lg\\:from-blue-50 {
    --gradient-from-color: #ebf5ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(235, 245, 255, 0));
  }
  .lg\\:from-blue-100 {
    --gradient-from-color: #e1effe;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(225, 239, 254, 0));
  }
  .lg\\:from-blue-200 {
    --gradient-from-color: #c3ddfd;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(195, 221, 253, 0));
  }
  .lg\\:from-blue-300 {
    --gradient-from-color: #a4cafe;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(164, 202, 254, 0));
  }
  .lg\\:from-blue-400 {
    --gradient-from-color: #76a9fa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(118, 169, 250, 0));
  }
  .lg\\:from-blue-500 {
    --gradient-from-color: #3f83f8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(63, 131, 248, 0));
  }
  .lg\\:from-blue-600 {
    --gradient-from-color: #1c64f2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(28, 100, 242, 0));
  }
  .lg\\:from-blue-700 {
    --gradient-from-color: #1a56db;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(26, 86, 219, 0));
  }
  .lg\\:from-blue-800 {
    --gradient-from-color: #1e429f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(30, 66, 159, 0));
  }
  .lg\\:from-blue-900 {
    --gradient-from-color: #233876;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(35, 56, 118, 0));
  }
  .lg\\:from-indigo-50 {
    --gradient-from-color: #f0f5ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(240, 245, 255, 0));
  }
  .lg\\:from-indigo-100 {
    --gradient-from-color: #e5edff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(229, 237, 255, 0));
  }
  .lg\\:from-indigo-200 {
    --gradient-from-color: #cddbfe;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(205, 219, 254, 0));
  }
  .lg\\:from-indigo-300 {
    --gradient-from-color: #b4c6fc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(180, 198, 252, 0));
  }
  .lg\\:from-indigo-400 {
    --gradient-from-color: #8da2fb;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(141, 162, 251, 0));
  }
  .lg\\:from-indigo-500 {
    --gradient-from-color: #6875f5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(104, 117, 245, 0));
  }
  .lg\\:from-indigo-600 {
    --gradient-from-color: #5850ec;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(88, 80, 236, 0));
  }
  .lg\\:from-indigo-700 {
    --gradient-from-color: #5145cd;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(81, 69, 205, 0));
  }
  .lg\\:from-indigo-800 {
    --gradient-from-color: #42389d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(66, 56, 157, 0));
  }
  .lg\\:from-indigo-900 {
    --gradient-from-color: #362f78;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(54, 47, 120, 0));
  }
  .lg\\:from-purple-50 {
    --gradient-from-color: #f6f5ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(246, 245, 255, 0));
  }
  .lg\\:from-purple-100 {
    --gradient-from-color: #edebfe;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(237, 235, 254, 0));
  }
  .lg\\:from-purple-200 {
    --gradient-from-color: #dcd7fe;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(220, 215, 254, 0));
  }
  .lg\\:from-purple-300 {
    --gradient-from-color: #cabffd;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(202, 191, 253, 0));
  }
  .lg\\:from-purple-400 {
    --gradient-from-color: #ac94fa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(172, 148, 250, 0));
  }
  .lg\\:from-purple-500 {
    --gradient-from-color: #9061f9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(144, 97, 249, 0));
  }
  .lg\\:from-purple-600 {
    --gradient-from-color: #7e3af2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(126, 58, 242, 0));
  }
  .lg\\:from-purple-700 {
    --gradient-from-color: #6c2bd9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(108, 43, 217, 0));
  }
  .lg\\:from-purple-800 {
    --gradient-from-color: #5521b5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(85, 33, 181, 0));
  }
  .lg\\:from-purple-900 {
    --gradient-from-color: #4a1d96;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(74, 29, 150, 0));
  }
  .lg\\:from-pink-50 {
    --gradient-from-color: #fdf2f8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 242, 248, 0));
  }
  .lg\\:from-pink-100 {
    --gradient-from-color: #fce8f3;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(252, 232, 243, 0));
  }
  .lg\\:from-pink-200 {
    --gradient-from-color: #fad1e8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(250, 209, 232, 0));
  }
  .lg\\:from-pink-300 {
    --gradient-from-color: #f8b4d9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(248, 180, 217, 0));
  }
  .lg\\:from-pink-400 {
    --gradient-from-color: #f17eb8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(241, 126, 184, 0));
  }
  .lg\\:from-pink-500 {
    --gradient-from-color: #e74694;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(231, 70, 148, 0));
  }
  .lg\\:from-pink-600 {
    --gradient-from-color: #d61f69;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(214, 31, 105, 0));
  }
  .lg\\:from-pink-700 {
    --gradient-from-color: #bf125d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(191, 18, 93, 0));
  }
  .lg\\:from-pink-800 {
    --gradient-from-color: #99154b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(153, 21, 75, 0));
  }
  .lg\\:from-pink-900 {
    --gradient-from-color: #751a3d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(117, 26, 61, 0));
  }
  .lg\\:from-cool-gray-50 {
    --gradient-from-color: #f8fafc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(248, 250, 252, 0));
  }
  .lg\\:from-cool-gray-100 {
    --gradient-from-color: #f1f5f9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(241, 245, 249, 0));
  }
  .lg\\:from-cool-gray-200 {
    --gradient-from-color: #e2e8f0;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(226, 232, 240, 0));
  }
  .lg\\:from-cool-gray-300 {
    --gradient-from-color: #cfd8e3;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(207, 216, 227, 0));
  }
  .lg\\:from-cool-gray-400 {
    --gradient-from-color: #97a6ba;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(151, 166, 186, 0));
  }
  .lg\\:from-cool-gray-500 {
    --gradient-from-color: #64748b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(100, 116, 139, 0));
  }
  .lg\\:from-cool-gray-600 {
    --gradient-from-color: #475569;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(71, 85, 105, 0));
  }
  .lg\\:from-cool-gray-700 {
    --gradient-from-color: #364152;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(54, 65, 82, 0));
  }
  .lg\\:from-cool-gray-800 {
    --gradient-from-color: #27303f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(39, 48, 63, 0));
  }
  .lg\\:from-cool-gray-900 {
    --gradient-from-color: #1a202e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(26, 32, 46, 0));
  }
  .lg\\:via-current {
    --gradient-via-color: currentColor;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }
  .lg\\:via-transparent {
    --gradient-via-color: transparent;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  }
  .lg\\:via-white {
    --gradient-via-color: #ffffff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }
  .lg\\:via-black {
    --gradient-via-color: #000000;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  }
  .lg\\:via-gray-50 {
    --gradient-via-color: #f9fafb;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(249, 250, 251, 0));
  }
  .lg\\:via-gray-100 {
    --gradient-via-color: #f4f5f7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(244, 245, 247, 0));
  }
  .lg\\:via-gray-200 {
    --gradient-via-color: #e5e7eb;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(229, 231, 235, 0));
  }
  .lg\\:via-gray-300 {
    --gradient-via-color: #d2d6dc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(210, 214, 220, 0));
  }
  .lg\\:via-gray-400 {
    --gradient-via-color: #9fa6b2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(159, 166, 178, 0));
  }
  .lg\\:via-gray-500 {
    --gradient-via-color: #6b7280;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(107, 114, 128, 0));
  }
  .lg\\:via-gray-600 {
    --gradient-via-color: #4b5563;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(75, 85, 99, 0));
  }
  .lg\\:via-gray-700 {
    --gradient-via-color: #374151;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(55, 65, 81, 0));
  }
  .lg\\:via-gray-800 {
    --gradient-via-color: #252f3f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(37, 47, 63, 0));
  }
  .lg\\:via-gray-900 {
    --gradient-via-color: #161e2e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(22, 30, 46, 0));
  }
  .lg\\:via-red-50 {
    --gradient-via-color: #fdf2f2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 242, 242, 0));
  }
  .lg\\:via-red-100 {
    --gradient-via-color: #fde8e8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 232, 232, 0));
  }
  .lg\\:via-red-200 {
    --gradient-via-color: #fbd5d5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(251, 213, 213, 0));
  }
  .lg\\:via-red-300 {
    --gradient-via-color: #f8b4b4;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(248, 180, 180, 0));
  }
  .lg\\:via-red-400 {
    --gradient-via-color: #f98080;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(249, 128, 128, 0));
  }
  .lg\\:via-red-500 {
    --gradient-via-color: #f05252;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(240, 82, 82, 0));
  }
  .lg\\:via-red-600 {
    --gradient-via-color: #e02424;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(224, 36, 36, 0));
  }
  .lg\\:via-red-700 {
    --gradient-via-color: #c81e1e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(200, 30, 30, 0));
  }
  .lg\\:via-red-800 {
    --gradient-via-color: #9b1c1c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(155, 28, 28, 0));
  }
  .lg\\:via-red-900 {
    --gradient-via-color: #771d1d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(119, 29, 29, 0));
  }
  .lg\\:via-orange-50 {
    --gradient-via-color: #fff8f1;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 248, 241, 0));
  }
  .lg\\:via-orange-100 {
    --gradient-via-color: #feecdc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 236, 220, 0));
  }
  .lg\\:via-orange-200 {
    --gradient-via-color: #fcd9bd;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(252, 217, 189, 0));
  }
  .lg\\:via-orange-300 {
    --gradient-via-color: #fdba8c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 186, 140, 0));
  }
  .lg\\:via-orange-400 {
    --gradient-via-color: #ff8a4c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 138, 76, 0));
  }
  .lg\\:via-orange-500 {
    --gradient-via-color: #ff5a1f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 90, 31, 0));
  }
  .lg\\:via-orange-600 {
    --gradient-via-color: #d03801;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(208, 56, 1, 0));
  }
  .lg\\:via-orange-700 {
    --gradient-via-color: #b43403;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(180, 52, 3, 0));
  }
  .lg\\:via-orange-800 {
    --gradient-via-color: #8a2c0d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(138, 44, 13, 0));
  }
  .lg\\:via-orange-900 {
    --gradient-via-color: #73230d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(115, 35, 13, 0));
  }
  .lg\\:via-yellow-50 {
    --gradient-via-color: #fdfdea;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 253, 234, 0));
  }
  .lg\\:via-yellow-100 {
    --gradient-via-color: #fdf6b2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 246, 178, 0));
  }
  .lg\\:via-yellow-200 {
    --gradient-via-color: #fce96a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(252, 233, 106, 0));
  }
  .lg\\:via-yellow-300 {
    --gradient-via-color: #faca15;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(250, 202, 21, 0));
  }
  .lg\\:via-yellow-400 {
    --gradient-via-color: #e3a008;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(227, 160, 8, 0));
  }
  .lg\\:via-yellow-500 {
    --gradient-via-color: #c27803;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(194, 120, 3, 0));
  }
  .lg\\:via-yellow-600 {
    --gradient-via-color: #9f580a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(159, 88, 10, 0));
  }
  .lg\\:via-yellow-700 {
    --gradient-via-color: #8e4b10;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(142, 75, 16, 0));
  }
  .lg\\:via-yellow-800 {
    --gradient-via-color: #723b13;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(114, 59, 19, 0));
  }
  .lg\\:via-yellow-900 {
    --gradient-via-color: #633112;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(99, 49, 18, 0));
  }
  .lg\\:via-green-50 {
    --gradient-via-color: #f3faf7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(243, 250, 247, 0));
  }
  .lg\\:via-green-100 {
    --gradient-via-color: #def7ec;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(222, 247, 236, 0));
  }
  .lg\\:via-green-200 {
    --gradient-via-color: #bcf0da;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(188, 240, 218, 0));
  }
  .lg\\:via-green-300 {
    --gradient-via-color: #84e1bc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(132, 225, 188, 0));
  }
  .lg\\:via-green-400 {
    --gradient-via-color: #31c48d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(49, 196, 141, 0));
  }
  .lg\\:via-green-500 {
    --gradient-via-color: #0e9f6e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(14, 159, 110, 0));
  }
  .lg\\:via-green-600 {
    --gradient-via-color: #057a55;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(5, 122, 85, 0));
  }
  .lg\\:via-green-700 {
    --gradient-via-color: #046c4e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(4, 108, 78, 0));
  }
  .lg\\:via-green-800 {
    --gradient-via-color: #03543f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(3, 84, 63, 0));
  }
  .lg\\:via-green-900 {
    --gradient-via-color: #014737;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(1, 71, 55, 0));
  }
  .lg\\:via-teal-50 {
    --gradient-via-color: #edfafa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(237, 250, 250, 0));
  }
  .lg\\:via-teal-100 {
    --gradient-via-color: #d5f5f6;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(213, 245, 246, 0));
  }
  .lg\\:via-teal-200 {
    --gradient-via-color: #afecef;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(175, 236, 239, 0));
  }
  .lg\\:via-teal-300 {
    --gradient-via-color: #7edce2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(126, 220, 226, 0));
  }
  .lg\\:via-teal-400 {
    --gradient-via-color: #16bdca;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(22, 189, 202, 0));
  }
  .lg\\:via-teal-500 {
    --gradient-via-color: #0694a2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(6, 148, 162, 0));
  }
  .lg\\:via-teal-600 {
    --gradient-via-color: #047481;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(4, 116, 129, 0));
  }
  .lg\\:via-teal-700 {
    --gradient-via-color: #036672;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(3, 102, 114, 0));
  }
  .lg\\:via-teal-800 {
    --gradient-via-color: #05505c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(5, 80, 92, 0));
  }
  .lg\\:via-teal-900 {
    --gradient-via-color: #014451;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(1, 68, 81, 0));
  }
  .lg\\:via-blue-50 {
    --gradient-via-color: #ebf5ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(235, 245, 255, 0));
  }
  .lg\\:via-blue-100 {
    --gradient-via-color: #e1effe;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(225, 239, 254, 0));
  }
  .lg\\:via-blue-200 {
    --gradient-via-color: #c3ddfd;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(195, 221, 253, 0));
  }
  .lg\\:via-blue-300 {
    --gradient-via-color: #a4cafe;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(164, 202, 254, 0));
  }
  .lg\\:via-blue-400 {
    --gradient-via-color: #76a9fa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(118, 169, 250, 0));
  }
  .lg\\:via-blue-500 {
    --gradient-via-color: #3f83f8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(63, 131, 248, 0));
  }
  .lg\\:via-blue-600 {
    --gradient-via-color: #1c64f2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(28, 100, 242, 0));
  }
  .lg\\:via-blue-700 {
    --gradient-via-color: #1a56db;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(26, 86, 219, 0));
  }
  .lg\\:via-blue-800 {
    --gradient-via-color: #1e429f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(30, 66, 159, 0));
  }
  .lg\\:via-blue-900 {
    --gradient-via-color: #233876;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(35, 56, 118, 0));
  }
  .lg\\:via-indigo-50 {
    --gradient-via-color: #f0f5ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(240, 245, 255, 0));
  }
  .lg\\:via-indigo-100 {
    --gradient-via-color: #e5edff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(229, 237, 255, 0));
  }
  .lg\\:via-indigo-200 {
    --gradient-via-color: #cddbfe;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(205, 219, 254, 0));
  }
  .lg\\:via-indigo-300 {
    --gradient-via-color: #b4c6fc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(180, 198, 252, 0));
  }
  .lg\\:via-indigo-400 {
    --gradient-via-color: #8da2fb;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(141, 162, 251, 0));
  }
  .lg\\:via-indigo-500 {
    --gradient-via-color: #6875f5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(104, 117, 245, 0));
  }
  .lg\\:via-indigo-600 {
    --gradient-via-color: #5850ec;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(88, 80, 236, 0));
  }
  .lg\\:via-indigo-700 {
    --gradient-via-color: #5145cd;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(81, 69, 205, 0));
  }
  .lg\\:via-indigo-800 {
    --gradient-via-color: #42389d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(66, 56, 157, 0));
  }
  .lg\\:via-indigo-900 {
    --gradient-via-color: #362f78;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(54, 47, 120, 0));
  }
  .lg\\:via-purple-50 {
    --gradient-via-color: #f6f5ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(246, 245, 255, 0));
  }
  .lg\\:via-purple-100 {
    --gradient-via-color: #edebfe;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(237, 235, 254, 0));
  }
  .lg\\:via-purple-200 {
    --gradient-via-color: #dcd7fe;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(220, 215, 254, 0));
  }
  .lg\\:via-purple-300 {
    --gradient-via-color: #cabffd;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(202, 191, 253, 0));
  }
  .lg\\:via-purple-400 {
    --gradient-via-color: #ac94fa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(172, 148, 250, 0));
  }
  .lg\\:via-purple-500 {
    --gradient-via-color: #9061f9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(144, 97, 249, 0));
  }
  .lg\\:via-purple-600 {
    --gradient-via-color: #7e3af2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(126, 58, 242, 0));
  }
  .lg\\:via-purple-700 {
    --gradient-via-color: #6c2bd9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(108, 43, 217, 0));
  }
  .lg\\:via-purple-800 {
    --gradient-via-color: #5521b5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(85, 33, 181, 0));
  }
  .lg\\:via-purple-900 {
    --gradient-via-color: #4a1d96;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(74, 29, 150, 0));
  }
  .lg\\:via-pink-50 {
    --gradient-via-color: #fdf2f8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 242, 248, 0));
  }
  .lg\\:via-pink-100 {
    --gradient-via-color: #fce8f3;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(252, 232, 243, 0));
  }
  .lg\\:via-pink-200 {
    --gradient-via-color: #fad1e8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(250, 209, 232, 0));
  }
  .lg\\:via-pink-300 {
    --gradient-via-color: #f8b4d9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(248, 180, 217, 0));
  }
  .lg\\:via-pink-400 {
    --gradient-via-color: #f17eb8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(241, 126, 184, 0));
  }
  .lg\\:via-pink-500 {
    --gradient-via-color: #e74694;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(231, 70, 148, 0));
  }
  .lg\\:via-pink-600 {
    --gradient-via-color: #d61f69;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(214, 31, 105, 0));
  }
  .lg\\:via-pink-700 {
    --gradient-via-color: #bf125d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(191, 18, 93, 0));
  }
  .lg\\:via-pink-800 {
    --gradient-via-color: #99154b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(153, 21, 75, 0));
  }
  .lg\\:via-pink-900 {
    --gradient-via-color: #751a3d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(117, 26, 61, 0));
  }
  .lg\\:via-cool-gray-50 {
    --gradient-via-color: #f8fafc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(248, 250, 252, 0));
  }
  .lg\\:via-cool-gray-100 {
    --gradient-via-color: #f1f5f9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(241, 245, 249, 0));
  }
  .lg\\:via-cool-gray-200 {
    --gradient-via-color: #e2e8f0;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(226, 232, 240, 0));
  }
  .lg\\:via-cool-gray-300 {
    --gradient-via-color: #cfd8e3;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(207, 216, 227, 0));
  }
  .lg\\:via-cool-gray-400 {
    --gradient-via-color: #97a6ba;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(151, 166, 186, 0));
  }
  .lg\\:via-cool-gray-500 {
    --gradient-via-color: #64748b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(100, 116, 139, 0));
  }
  .lg\\:via-cool-gray-600 {
    --gradient-via-color: #475569;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(71, 85, 105, 0));
  }
  .lg\\:via-cool-gray-700 {
    --gradient-via-color: #364152;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(54, 65, 82, 0));
  }
  .lg\\:via-cool-gray-800 {
    --gradient-via-color: #27303f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(39, 48, 63, 0));
  }
  .lg\\:via-cool-gray-900 {
    --gradient-via-color: #1a202e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(26, 32, 46, 0));
  }
  .lg\\:to-current {
    --gradient-to-color: currentColor;
  }
  .lg\\:to-transparent {
    --gradient-to-color: transparent;
  }
  .lg\\:to-white {
    --gradient-to-color: #ffffff;
  }
  .lg\\:to-black {
    --gradient-to-color: #000000;
  }
  .lg\\:to-gray-50 {
    --gradient-to-color: #f9fafb;
  }
  .lg\\:to-gray-100 {
    --gradient-to-color: #f4f5f7;
  }
  .lg\\:to-gray-200 {
    --gradient-to-color: #e5e7eb;
  }
  .lg\\:to-gray-300 {
    --gradient-to-color: #d2d6dc;
  }
  .lg\\:to-gray-400 {
    --gradient-to-color: #9fa6b2;
  }
  .lg\\:to-gray-500 {
    --gradient-to-color: #6b7280;
  }
  .lg\\:to-gray-600 {
    --gradient-to-color: #4b5563;
  }
  .lg\\:to-gray-700 {
    --gradient-to-color: #374151;
  }
  .lg\\:to-gray-800 {
    --gradient-to-color: #252f3f;
  }
  .lg\\:to-gray-900 {
    --gradient-to-color: #161e2e;
  }
  .lg\\:to-red-50 {
    --gradient-to-color: #fdf2f2;
  }
  .lg\\:to-red-100 {
    --gradient-to-color: #fde8e8;
  }
  .lg\\:to-red-200 {
    --gradient-to-color: #fbd5d5;
  }
  .lg\\:to-red-300 {
    --gradient-to-color: #f8b4b4;
  }
  .lg\\:to-red-400 {
    --gradient-to-color: #f98080;
  }
  .lg\\:to-red-500 {
    --gradient-to-color: #f05252;
  }
  .lg\\:to-red-600 {
    --gradient-to-color: #e02424;
  }
  .lg\\:to-red-700 {
    --gradient-to-color: #c81e1e;
  }
  .lg\\:to-red-800 {
    --gradient-to-color: #9b1c1c;
  }
  .lg\\:to-red-900 {
    --gradient-to-color: #771d1d;
  }
  .lg\\:to-orange-50 {
    --gradient-to-color: #fff8f1;
  }
  .lg\\:to-orange-100 {
    --gradient-to-color: #feecdc;
  }
  .lg\\:to-orange-200 {
    --gradient-to-color: #fcd9bd;
  }
  .lg\\:to-orange-300 {
    --gradient-to-color: #fdba8c;
  }
  .lg\\:to-orange-400 {
    --gradient-to-color: #ff8a4c;
  }
  .lg\\:to-orange-500 {
    --gradient-to-color: #ff5a1f;
  }
  .lg\\:to-orange-600 {
    --gradient-to-color: #d03801;
  }
  .lg\\:to-orange-700 {
    --gradient-to-color: #b43403;
  }
  .lg\\:to-orange-800 {
    --gradient-to-color: #8a2c0d;
  }
  .lg\\:to-orange-900 {
    --gradient-to-color: #73230d;
  }
  .lg\\:to-yellow-50 {
    --gradient-to-color: #fdfdea;
  }
  .lg\\:to-yellow-100 {
    --gradient-to-color: #fdf6b2;
  }
  .lg\\:to-yellow-200 {
    --gradient-to-color: #fce96a;
  }
  .lg\\:to-yellow-300 {
    --gradient-to-color: #faca15;
  }
  .lg\\:to-yellow-400 {
    --gradient-to-color: #e3a008;
  }
  .lg\\:to-yellow-500 {
    --gradient-to-color: #c27803;
  }
  .lg\\:to-yellow-600 {
    --gradient-to-color: #9f580a;
  }
  .lg\\:to-yellow-700 {
    --gradient-to-color: #8e4b10;
  }
  .lg\\:to-yellow-800 {
    --gradient-to-color: #723b13;
  }
  .lg\\:to-yellow-900 {
    --gradient-to-color: #633112;
  }
  .lg\\:to-green-50 {
    --gradient-to-color: #f3faf7;
  }
  .lg\\:to-green-100 {
    --gradient-to-color: #def7ec;
  }
  .lg\\:to-green-200 {
    --gradient-to-color: #bcf0da;
  }
  .lg\\:to-green-300 {
    --gradient-to-color: #84e1bc;
  }
  .lg\\:to-green-400 {
    --gradient-to-color: #31c48d;
  }
  .lg\\:to-green-500 {
    --gradient-to-color: #0e9f6e;
  }
  .lg\\:to-green-600 {
    --gradient-to-color: #057a55;
  }
  .lg\\:to-green-700 {
    --gradient-to-color: #046c4e;
  }
  .lg\\:to-green-800 {
    --gradient-to-color: #03543f;
  }
  .lg\\:to-green-900 {
    --gradient-to-color: #014737;
  }
  .lg\\:to-teal-50 {
    --gradient-to-color: #edfafa;
  }
  .lg\\:to-teal-100 {
    --gradient-to-color: #d5f5f6;
  }
  .lg\\:to-teal-200 {
    --gradient-to-color: #afecef;
  }
  .lg\\:to-teal-300 {
    --gradient-to-color: #7edce2;
  }
  .lg\\:to-teal-400 {
    --gradient-to-color: #16bdca;
  }
  .lg\\:to-teal-500 {
    --gradient-to-color: #0694a2;
  }
  .lg\\:to-teal-600 {
    --gradient-to-color: #047481;
  }
  .lg\\:to-teal-700 {
    --gradient-to-color: #036672;
  }
  .lg\\:to-teal-800 {
    --gradient-to-color: #05505c;
  }
  .lg\\:to-teal-900 {
    --gradient-to-color: #014451;
  }
  .lg\\:to-blue-50 {
    --gradient-to-color: #ebf5ff;
  }
  .lg\\:to-blue-100 {
    --gradient-to-color: #e1effe;
  }
  .lg\\:to-blue-200 {
    --gradient-to-color: #c3ddfd;
  }
  .lg\\:to-blue-300 {
    --gradient-to-color: #a4cafe;
  }
  .lg\\:to-blue-400 {
    --gradient-to-color: #76a9fa;
  }
  .lg\\:to-blue-500 {
    --gradient-to-color: #3f83f8;
  }
  .lg\\:to-blue-600 {
    --gradient-to-color: #1c64f2;
  }
  .lg\\:to-blue-700 {
    --gradient-to-color: #1a56db;
  }
  .lg\\:to-blue-800 {
    --gradient-to-color: #1e429f;
  }
  .lg\\:to-blue-900 {
    --gradient-to-color: #233876;
  }
  .lg\\:to-indigo-50 {
    --gradient-to-color: #f0f5ff;
  }
  .lg\\:to-indigo-100 {
    --gradient-to-color: #e5edff;
  }
  .lg\\:to-indigo-200 {
    --gradient-to-color: #cddbfe;
  }
  .lg\\:to-indigo-300 {
    --gradient-to-color: #b4c6fc;
  }
  .lg\\:to-indigo-400 {
    --gradient-to-color: #8da2fb;
  }
  .lg\\:to-indigo-500 {
    --gradient-to-color: #6875f5;
  }
  .lg\\:to-indigo-600 {
    --gradient-to-color: #5850ec;
  }
  .lg\\:to-indigo-700 {
    --gradient-to-color: #5145cd;
  }
  .lg\\:to-indigo-800 {
    --gradient-to-color: #42389d;
  }
  .lg\\:to-indigo-900 {
    --gradient-to-color: #362f78;
  }
  .lg\\:to-purple-50 {
    --gradient-to-color: #f6f5ff;
  }
  .lg\\:to-purple-100 {
    --gradient-to-color: #edebfe;
  }
  .lg\\:to-purple-200 {
    --gradient-to-color: #dcd7fe;
  }
  .lg\\:to-purple-300 {
    --gradient-to-color: #cabffd;
  }
  .lg\\:to-purple-400 {
    --gradient-to-color: #ac94fa;
  }
  .lg\\:to-purple-500 {
    --gradient-to-color: #9061f9;
  }
  .lg\\:to-purple-600 {
    --gradient-to-color: #7e3af2;
  }
  .lg\\:to-purple-700 {
    --gradient-to-color: #6c2bd9;
  }
  .lg\\:to-purple-800 {
    --gradient-to-color: #5521b5;
  }
  .lg\\:to-purple-900 {
    --gradient-to-color: #4a1d96;
  }
  .lg\\:to-pink-50 {
    --gradient-to-color: #fdf2f8;
  }
  .lg\\:to-pink-100 {
    --gradient-to-color: #fce8f3;
  }
  .lg\\:to-pink-200 {
    --gradient-to-color: #fad1e8;
  }
  .lg\\:to-pink-300 {
    --gradient-to-color: #f8b4d9;
  }
  .lg\\:to-pink-400 {
    --gradient-to-color: #f17eb8;
  }
  .lg\\:to-pink-500 {
    --gradient-to-color: #e74694;
  }
  .lg\\:to-pink-600 {
    --gradient-to-color: #d61f69;
  }
  .lg\\:to-pink-700 {
    --gradient-to-color: #bf125d;
  }
  .lg\\:to-pink-800 {
    --gradient-to-color: #99154b;
  }
  .lg\\:to-pink-900 {
    --gradient-to-color: #751a3d;
  }
  .lg\\:to-cool-gray-50 {
    --gradient-to-color: #f8fafc;
  }
  .lg\\:to-cool-gray-100 {
    --gradient-to-color: #f1f5f9;
  }
  .lg\\:to-cool-gray-200 {
    --gradient-to-color: #e2e8f0;
  }
  .lg\\:to-cool-gray-300 {
    --gradient-to-color: #cfd8e3;
  }
  .lg\\:to-cool-gray-400 {
    --gradient-to-color: #97a6ba;
  }
  .lg\\:to-cool-gray-500 {
    --gradient-to-color: #64748b;
  }
  .lg\\:to-cool-gray-600 {
    --gradient-to-color: #475569;
  }
  .lg\\:to-cool-gray-700 {
    --gradient-to-color: #364152;
  }
  .lg\\:to-cool-gray-800 {
    --gradient-to-color: #27303f;
  }
  .lg\\:to-cool-gray-900 {
    --gradient-to-color: #1a202e;
  }
  .lg\\:hover\\:from-current:hover {
    --gradient-from-color: currentColor;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }
  .lg\\:hover\\:from-transparent:hover {
    --gradient-from-color: transparent;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  }
  .lg\\:hover\\:from-white:hover {
    --gradient-from-color: #ffffff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }
  .lg\\:hover\\:from-black:hover {
    --gradient-from-color: #000000;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  }
  .lg\\:hover\\:from-gray-50:hover {
    --gradient-from-color: #f9fafb;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(249, 250, 251, 0));
  }
  .lg\\:hover\\:from-gray-100:hover {
    --gradient-from-color: #f4f5f7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(244, 245, 247, 0));
  }
  .lg\\:hover\\:from-gray-200:hover {
    --gradient-from-color: #e5e7eb;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(229, 231, 235, 0));
  }
  .lg\\:hover\\:from-gray-300:hover {
    --gradient-from-color: #d2d6dc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(210, 214, 220, 0));
  }
  .lg\\:hover\\:from-gray-400:hover {
    --gradient-from-color: #9fa6b2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(159, 166, 178, 0));
  }
  .lg\\:hover\\:from-gray-500:hover {
    --gradient-from-color: #6b7280;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(107, 114, 128, 0));
  }
  .lg\\:hover\\:from-gray-600:hover {
    --gradient-from-color: #4b5563;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(75, 85, 99, 0));
  }
  .lg\\:hover\\:from-gray-700:hover {
    --gradient-from-color: #374151;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(55, 65, 81, 0));
  }
  .lg\\:hover\\:from-gray-800:hover {
    --gradient-from-color: #252f3f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(37, 47, 63, 0));
  }
  .lg\\:hover\\:from-gray-900:hover {
    --gradient-from-color: #161e2e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(22, 30, 46, 0));
  }
  .lg\\:hover\\:from-red-50:hover {
    --gradient-from-color: #fdf2f2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 242, 242, 0));
  }
  .lg\\:hover\\:from-red-100:hover {
    --gradient-from-color: #fde8e8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 232, 232, 0));
  }
  .lg\\:hover\\:from-red-200:hover {
    --gradient-from-color: #fbd5d5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(251, 213, 213, 0));
  }
  .lg\\:hover\\:from-red-300:hover {
    --gradient-from-color: #f8b4b4;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(248, 180, 180, 0));
  }
  .lg\\:hover\\:from-red-400:hover {
    --gradient-from-color: #f98080;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(249, 128, 128, 0));
  }
  .lg\\:hover\\:from-red-500:hover {
    --gradient-from-color: #f05252;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(240, 82, 82, 0));
  }
  .lg\\:hover\\:from-red-600:hover {
    --gradient-from-color: #e02424;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(224, 36, 36, 0));
  }
  .lg\\:hover\\:from-red-700:hover {
    --gradient-from-color: #c81e1e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(200, 30, 30, 0));
  }
  .lg\\:hover\\:from-red-800:hover {
    --gradient-from-color: #9b1c1c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(155, 28, 28, 0));
  }
  .lg\\:hover\\:from-red-900:hover {
    --gradient-from-color: #771d1d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(119, 29, 29, 0));
  }
  .lg\\:hover\\:from-orange-50:hover {
    --gradient-from-color: #fff8f1;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 248, 241, 0));
  }
  .lg\\:hover\\:from-orange-100:hover {
    --gradient-from-color: #feecdc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 236, 220, 0));
  }
  .lg\\:hover\\:from-orange-200:hover {
    --gradient-from-color: #fcd9bd;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(252, 217, 189, 0));
  }
  .lg\\:hover\\:from-orange-300:hover {
    --gradient-from-color: #fdba8c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 186, 140, 0));
  }
  .lg\\:hover\\:from-orange-400:hover {
    --gradient-from-color: #ff8a4c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 138, 76, 0));
  }
  .lg\\:hover\\:from-orange-500:hover {
    --gradient-from-color: #ff5a1f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 90, 31, 0));
  }
  .lg\\:hover\\:from-orange-600:hover {
    --gradient-from-color: #d03801;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(208, 56, 1, 0));
  }
  .lg\\:hover\\:from-orange-700:hover {
    --gradient-from-color: #b43403;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(180, 52, 3, 0));
  }
  .lg\\:hover\\:from-orange-800:hover {
    --gradient-from-color: #8a2c0d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(138, 44, 13, 0));
  }
  .lg\\:hover\\:from-orange-900:hover {
    --gradient-from-color: #73230d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(115, 35, 13, 0));
  }
  .lg\\:hover\\:from-yellow-50:hover {
    --gradient-from-color: #fdfdea;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 253, 234, 0));
  }
  .lg\\:hover\\:from-yellow-100:hover {
    --gradient-from-color: #fdf6b2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 246, 178, 0));
  }
  .lg\\:hover\\:from-yellow-200:hover {
    --gradient-from-color: #fce96a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(252, 233, 106, 0));
  }
  .lg\\:hover\\:from-yellow-300:hover {
    --gradient-from-color: #faca15;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(250, 202, 21, 0));
  }
  .lg\\:hover\\:from-yellow-400:hover {
    --gradient-from-color: #e3a008;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(227, 160, 8, 0));
  }
  .lg\\:hover\\:from-yellow-500:hover {
    --gradient-from-color: #c27803;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(194, 120, 3, 0));
  }
  .lg\\:hover\\:from-yellow-600:hover {
    --gradient-from-color: #9f580a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(159, 88, 10, 0));
  }
  .lg\\:hover\\:from-yellow-700:hover {
    --gradient-from-color: #8e4b10;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(142, 75, 16, 0));
  }
  .lg\\:hover\\:from-yellow-800:hover {
    --gradient-from-color: #723b13;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(114, 59, 19, 0));
  }
  .lg\\:hover\\:from-yellow-900:hover {
    --gradient-from-color: #633112;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(99, 49, 18, 0));
  }
  .lg\\:hover\\:from-green-50:hover {
    --gradient-from-color: #f3faf7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(243, 250, 247, 0));
  }
  .lg\\:hover\\:from-green-100:hover {
    --gradient-from-color: #def7ec;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(222, 247, 236, 0));
  }
  .lg\\:hover\\:from-green-200:hover {
    --gradient-from-color: #bcf0da;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(188, 240, 218, 0));
  }
  .lg\\:hover\\:from-green-300:hover {
    --gradient-from-color: #84e1bc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(132, 225, 188, 0));
  }
  .lg\\:hover\\:from-green-400:hover {
    --gradient-from-color: #31c48d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(49, 196, 141, 0));
  }
  .lg\\:hover\\:from-green-500:hover {
    --gradient-from-color: #0e9f6e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(14, 159, 110, 0));
  }
  .lg\\:hover\\:from-green-600:hover {
    --gradient-from-color: #057a55;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(5, 122, 85, 0));
  }
  .lg\\:hover\\:from-green-700:hover {
    --gradient-from-color: #046c4e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(4, 108, 78, 0));
  }
  .lg\\:hover\\:from-green-800:hover {
    --gradient-from-color: #03543f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(3, 84, 63, 0));
  }
  .lg\\:hover\\:from-green-900:hover {
    --gradient-from-color: #014737;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(1, 71, 55, 0));
  }
  .lg\\:hover\\:from-teal-50:hover {
    --gradient-from-color: #edfafa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(237, 250, 250, 0));
  }
  .lg\\:hover\\:from-teal-100:hover {
    --gradient-from-color: #d5f5f6;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(213, 245, 246, 0));
  }
  .lg\\:hover\\:from-teal-200:hover {
    --gradient-from-color: #afecef;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(175, 236, 239, 0));
  }
  .lg\\:hover\\:from-teal-300:hover {
    --gradient-from-color: #7edce2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(126, 220, 226, 0));
  }
  .lg\\:hover\\:from-teal-400:hover {
    --gradient-from-color: #16bdca;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(22, 189, 202, 0));
  }
  .lg\\:hover\\:from-teal-500:hover {
    --gradient-from-color: #0694a2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(6, 148, 162, 0));
  }
  .lg\\:hover\\:from-teal-600:hover {
    --gradient-from-color: #047481;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(4, 116, 129, 0));
  }
  .lg\\:hover\\:from-teal-700:hover {
    --gradient-from-color: #036672;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(3, 102, 114, 0));
  }
  .lg\\:hover\\:from-teal-800:hover {
    --gradient-from-color: #05505c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(5, 80, 92, 0));
  }
  .lg\\:hover\\:from-teal-900:hover {
    --gradient-from-color: #014451;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(1, 68, 81, 0));
  }
  .lg\\:hover\\:from-blue-50:hover {
    --gradient-from-color: #ebf5ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(235, 245, 255, 0));
  }
  .lg\\:hover\\:from-blue-100:hover {
    --gradient-from-color: #e1effe;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(225, 239, 254, 0));
  }
  .lg\\:hover\\:from-blue-200:hover {
    --gradient-from-color: #c3ddfd;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(195, 221, 253, 0));
  }
  .lg\\:hover\\:from-blue-300:hover {
    --gradient-from-color: #a4cafe;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(164, 202, 254, 0));
  }
  .lg\\:hover\\:from-blue-400:hover {
    --gradient-from-color: #76a9fa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(118, 169, 250, 0));
  }
  .lg\\:hover\\:from-blue-500:hover {
    --gradient-from-color: #3f83f8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(63, 131, 248, 0));
  }
  .lg\\:hover\\:from-blue-600:hover {
    --gradient-from-color: #1c64f2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(28, 100, 242, 0));
  }
  .lg\\:hover\\:from-blue-700:hover {
    --gradient-from-color: #1a56db;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(26, 86, 219, 0));
  }
  .lg\\:hover\\:from-blue-800:hover {
    --gradient-from-color: #1e429f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(30, 66, 159, 0));
  }
  .lg\\:hover\\:from-blue-900:hover {
    --gradient-from-color: #233876;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(35, 56, 118, 0));
  }
  .lg\\:hover\\:from-indigo-50:hover {
    --gradient-from-color: #f0f5ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(240, 245, 255, 0));
  }
  .lg\\:hover\\:from-indigo-100:hover {
    --gradient-from-color: #e5edff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(229, 237, 255, 0));
  }
  .lg\\:hover\\:from-indigo-200:hover {
    --gradient-from-color: #cddbfe;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(205, 219, 254, 0));
  }
  .lg\\:hover\\:from-indigo-300:hover {
    --gradient-from-color: #b4c6fc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(180, 198, 252, 0));
  }
  .lg\\:hover\\:from-indigo-400:hover {
    --gradient-from-color: #8da2fb;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(141, 162, 251, 0));
  }
  .lg\\:hover\\:from-indigo-500:hover {
    --gradient-from-color: #6875f5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(104, 117, 245, 0));
  }
  .lg\\:hover\\:from-indigo-600:hover {
    --gradient-from-color: #5850ec;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(88, 80, 236, 0));
  }
  .lg\\:hover\\:from-indigo-700:hover {
    --gradient-from-color: #5145cd;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(81, 69, 205, 0));
  }
  .lg\\:hover\\:from-indigo-800:hover {
    --gradient-from-color: #42389d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(66, 56, 157, 0));
  }
  .lg\\:hover\\:from-indigo-900:hover {
    --gradient-from-color: #362f78;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(54, 47, 120, 0));
  }
  .lg\\:hover\\:from-purple-50:hover {
    --gradient-from-color: #f6f5ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(246, 245, 255, 0));
  }
  .lg\\:hover\\:from-purple-100:hover {
    --gradient-from-color: #edebfe;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(237, 235, 254, 0));
  }
  .lg\\:hover\\:from-purple-200:hover {
    --gradient-from-color: #dcd7fe;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(220, 215, 254, 0));
  }
  .lg\\:hover\\:from-purple-300:hover {
    --gradient-from-color: #cabffd;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(202, 191, 253, 0));
  }
  .lg\\:hover\\:from-purple-400:hover {
    --gradient-from-color: #ac94fa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(172, 148, 250, 0));
  }
  .lg\\:hover\\:from-purple-500:hover {
    --gradient-from-color: #9061f9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(144, 97, 249, 0));
  }
  .lg\\:hover\\:from-purple-600:hover {
    --gradient-from-color: #7e3af2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(126, 58, 242, 0));
  }
  .lg\\:hover\\:from-purple-700:hover {
    --gradient-from-color: #6c2bd9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(108, 43, 217, 0));
  }
  .lg\\:hover\\:from-purple-800:hover {
    --gradient-from-color: #5521b5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(85, 33, 181, 0));
  }
  .lg\\:hover\\:from-purple-900:hover {
    --gradient-from-color: #4a1d96;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(74, 29, 150, 0));
  }
  .lg\\:hover\\:from-pink-50:hover {
    --gradient-from-color: #fdf2f8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 242, 248, 0));
  }
  .lg\\:hover\\:from-pink-100:hover {
    --gradient-from-color: #fce8f3;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(252, 232, 243, 0));
  }
  .lg\\:hover\\:from-pink-200:hover {
    --gradient-from-color: #fad1e8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(250, 209, 232, 0));
  }
  .lg\\:hover\\:from-pink-300:hover {
    --gradient-from-color: #f8b4d9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(248, 180, 217, 0));
  }
  .lg\\:hover\\:from-pink-400:hover {
    --gradient-from-color: #f17eb8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(241, 126, 184, 0));
  }
  .lg\\:hover\\:from-pink-500:hover {
    --gradient-from-color: #e74694;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(231, 70, 148, 0));
  }
  .lg\\:hover\\:from-pink-600:hover {
    --gradient-from-color: #d61f69;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(214, 31, 105, 0));
  }
  .lg\\:hover\\:from-pink-700:hover {
    --gradient-from-color: #bf125d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(191, 18, 93, 0));
  }
  .lg\\:hover\\:from-pink-800:hover {
    --gradient-from-color: #99154b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(153, 21, 75, 0));
  }
  .lg\\:hover\\:from-pink-900:hover {
    --gradient-from-color: #751a3d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(117, 26, 61, 0));
  }
  .lg\\:hover\\:from-cool-gray-50:hover {
    --gradient-from-color: #f8fafc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(248, 250, 252, 0));
  }
  .lg\\:hover\\:from-cool-gray-100:hover {
    --gradient-from-color: #f1f5f9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(241, 245, 249, 0));
  }
  .lg\\:hover\\:from-cool-gray-200:hover {
    --gradient-from-color: #e2e8f0;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(226, 232, 240, 0));
  }
  .lg\\:hover\\:from-cool-gray-300:hover {
    --gradient-from-color: #cfd8e3;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(207, 216, 227, 0));
  }
  .lg\\:hover\\:from-cool-gray-400:hover {
    --gradient-from-color: #97a6ba;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(151, 166, 186, 0));
  }
  .lg\\:hover\\:from-cool-gray-500:hover {
    --gradient-from-color: #64748b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(100, 116, 139, 0));
  }
  .lg\\:hover\\:from-cool-gray-600:hover {
    --gradient-from-color: #475569;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(71, 85, 105, 0));
  }
  .lg\\:hover\\:from-cool-gray-700:hover {
    --gradient-from-color: #364152;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(54, 65, 82, 0));
  }
  .lg\\:hover\\:from-cool-gray-800:hover {
    --gradient-from-color: #27303f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(39, 48, 63, 0));
  }
  .lg\\:hover\\:from-cool-gray-900:hover {
    --gradient-from-color: #1a202e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(26, 32, 46, 0));
  }
  .lg\\:hover\\:via-current:hover {
    --gradient-via-color: currentColor;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }
  .lg\\:hover\\:via-transparent:hover {
    --gradient-via-color: transparent;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  }
  .lg\\:hover\\:via-white:hover {
    --gradient-via-color: #ffffff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }
  .lg\\:hover\\:via-black:hover {
    --gradient-via-color: #000000;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  }
  .lg\\:hover\\:via-gray-50:hover {
    --gradient-via-color: #f9fafb;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(249, 250, 251, 0));
  }
  .lg\\:hover\\:via-gray-100:hover {
    --gradient-via-color: #f4f5f7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(244, 245, 247, 0));
  }
  .lg\\:hover\\:via-gray-200:hover {
    --gradient-via-color: #e5e7eb;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(229, 231, 235, 0));
  }
  .lg\\:hover\\:via-gray-300:hover {
    --gradient-via-color: #d2d6dc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(210, 214, 220, 0));
  }
  .lg\\:hover\\:via-gray-400:hover {
    --gradient-via-color: #9fa6b2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(159, 166, 178, 0));
  }
  .lg\\:hover\\:via-gray-500:hover {
    --gradient-via-color: #6b7280;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(107, 114, 128, 0));
  }
  .lg\\:hover\\:via-gray-600:hover {
    --gradient-via-color: #4b5563;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(75, 85, 99, 0));
  }
  .lg\\:hover\\:via-gray-700:hover {
    --gradient-via-color: #374151;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(55, 65, 81, 0));
  }
  .lg\\:hover\\:via-gray-800:hover {
    --gradient-via-color: #252f3f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(37, 47, 63, 0));
  }
  .lg\\:hover\\:via-gray-900:hover {
    --gradient-via-color: #161e2e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(22, 30, 46, 0));
  }
  .lg\\:hover\\:via-red-50:hover {
    --gradient-via-color: #fdf2f2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 242, 242, 0));
  }
  .lg\\:hover\\:via-red-100:hover {
    --gradient-via-color: #fde8e8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 232, 232, 0));
  }
  .lg\\:hover\\:via-red-200:hover {
    --gradient-via-color: #fbd5d5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(251, 213, 213, 0));
  }
  .lg\\:hover\\:via-red-300:hover {
    --gradient-via-color: #f8b4b4;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(248, 180, 180, 0));
  }
  .lg\\:hover\\:via-red-400:hover {
    --gradient-via-color: #f98080;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(249, 128, 128, 0));
  }
  .lg\\:hover\\:via-red-500:hover {
    --gradient-via-color: #f05252;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(240, 82, 82, 0));
  }
  .lg\\:hover\\:via-red-600:hover {
    --gradient-via-color: #e02424;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(224, 36, 36, 0));
  }
  .lg\\:hover\\:via-red-700:hover {
    --gradient-via-color: #c81e1e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(200, 30, 30, 0));
  }
  .lg\\:hover\\:via-red-800:hover {
    --gradient-via-color: #9b1c1c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(155, 28, 28, 0));
  }
  .lg\\:hover\\:via-red-900:hover {
    --gradient-via-color: #771d1d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(119, 29, 29, 0));
  }
  .lg\\:hover\\:via-orange-50:hover {
    --gradient-via-color: #fff8f1;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 248, 241, 0));
  }
  .lg\\:hover\\:via-orange-100:hover {
    --gradient-via-color: #feecdc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 236, 220, 0));
  }
  .lg\\:hover\\:via-orange-200:hover {
    --gradient-via-color: #fcd9bd;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(252, 217, 189, 0));
  }
  .lg\\:hover\\:via-orange-300:hover {
    --gradient-via-color: #fdba8c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 186, 140, 0));
  }
  .lg\\:hover\\:via-orange-400:hover {
    --gradient-via-color: #ff8a4c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 138, 76, 0));
  }
  .lg\\:hover\\:via-orange-500:hover {
    --gradient-via-color: #ff5a1f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 90, 31, 0));
  }
  .lg\\:hover\\:via-orange-600:hover {
    --gradient-via-color: #d03801;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(208, 56, 1, 0));
  }
  .lg\\:hover\\:via-orange-700:hover {
    --gradient-via-color: #b43403;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(180, 52, 3, 0));
  }
  .lg\\:hover\\:via-orange-800:hover {
    --gradient-via-color: #8a2c0d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(138, 44, 13, 0));
  }
  .lg\\:hover\\:via-orange-900:hover {
    --gradient-via-color: #73230d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(115, 35, 13, 0));
  }
  .lg\\:hover\\:via-yellow-50:hover {
    --gradient-via-color: #fdfdea;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 253, 234, 0));
  }
  .lg\\:hover\\:via-yellow-100:hover {
    --gradient-via-color: #fdf6b2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 246, 178, 0));
  }
  .lg\\:hover\\:via-yellow-200:hover {
    --gradient-via-color: #fce96a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(252, 233, 106, 0));
  }
  .lg\\:hover\\:via-yellow-300:hover {
    --gradient-via-color: #faca15;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(250, 202, 21, 0));
  }
  .lg\\:hover\\:via-yellow-400:hover {
    --gradient-via-color: #e3a008;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(227, 160, 8, 0));
  }
  .lg\\:hover\\:via-yellow-500:hover {
    --gradient-via-color: #c27803;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(194, 120, 3, 0));
  }
  .lg\\:hover\\:via-yellow-600:hover {
    --gradient-via-color: #9f580a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(159, 88, 10, 0));
  }
  .lg\\:hover\\:via-yellow-700:hover {
    --gradient-via-color: #8e4b10;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(142, 75, 16, 0));
  }
  .lg\\:hover\\:via-yellow-800:hover {
    --gradient-via-color: #723b13;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(114, 59, 19, 0));
  }
  .lg\\:hover\\:via-yellow-900:hover {
    --gradient-via-color: #633112;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(99, 49, 18, 0));
  }
  .lg\\:hover\\:via-green-50:hover {
    --gradient-via-color: #f3faf7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(243, 250, 247, 0));
  }
  .lg\\:hover\\:via-green-100:hover {
    --gradient-via-color: #def7ec;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(222, 247, 236, 0));
  }
  .lg\\:hover\\:via-green-200:hover {
    --gradient-via-color: #bcf0da;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(188, 240, 218, 0));
  }
  .lg\\:hover\\:via-green-300:hover {
    --gradient-via-color: #84e1bc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(132, 225, 188, 0));
  }
  .lg\\:hover\\:via-green-400:hover {
    --gradient-via-color: #31c48d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(49, 196, 141, 0));
  }
  .lg\\:hover\\:via-green-500:hover {
    --gradient-via-color: #0e9f6e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(14, 159, 110, 0));
  }
  .lg\\:hover\\:via-green-600:hover {
    --gradient-via-color: #057a55;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(5, 122, 85, 0));
  }
  .lg\\:hover\\:via-green-700:hover {
    --gradient-via-color: #046c4e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(4, 108, 78, 0));
  }
  .lg\\:hover\\:via-green-800:hover {
    --gradient-via-color: #03543f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(3, 84, 63, 0));
  }
  .lg\\:hover\\:via-green-900:hover {
    --gradient-via-color: #014737;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(1, 71, 55, 0));
  }
  .lg\\:hover\\:via-teal-50:hover {
    --gradient-via-color: #edfafa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(237, 250, 250, 0));
  }
  .lg\\:hover\\:via-teal-100:hover {
    --gradient-via-color: #d5f5f6;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(213, 245, 246, 0));
  }
  .lg\\:hover\\:via-teal-200:hover {
    --gradient-via-color: #afecef;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(175, 236, 239, 0));
  }
  .lg\\:hover\\:via-teal-300:hover {
    --gradient-via-color: #7edce2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(126, 220, 226, 0));
  }
  .lg\\:hover\\:via-teal-400:hover {
    --gradient-via-color: #16bdca;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(22, 189, 202, 0));
  }
  .lg\\:hover\\:via-teal-500:hover {
    --gradient-via-color: #0694a2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(6, 148, 162, 0));
  }
  .lg\\:hover\\:via-teal-600:hover {
    --gradient-via-color: #047481;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(4, 116, 129, 0));
  }
  .lg\\:hover\\:via-teal-700:hover {
    --gradient-via-color: #036672;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(3, 102, 114, 0));
  }
  .lg\\:hover\\:via-teal-800:hover {
    --gradient-via-color: #05505c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(5, 80, 92, 0));
  }
  .lg\\:hover\\:via-teal-900:hover {
    --gradient-via-color: #014451;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(1, 68, 81, 0));
  }
  .lg\\:hover\\:via-blue-50:hover {
    --gradient-via-color: #ebf5ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(235, 245, 255, 0));
  }
  .lg\\:hover\\:via-blue-100:hover {
    --gradient-via-color: #e1effe;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(225, 239, 254, 0));
  }
  .lg\\:hover\\:via-blue-200:hover {
    --gradient-via-color: #c3ddfd;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(195, 221, 253, 0));
  }
  .lg\\:hover\\:via-blue-300:hover {
    --gradient-via-color: #a4cafe;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(164, 202, 254, 0));
  }
  .lg\\:hover\\:via-blue-400:hover {
    --gradient-via-color: #76a9fa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(118, 169, 250, 0));
  }
  .lg\\:hover\\:via-blue-500:hover {
    --gradient-via-color: #3f83f8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(63, 131, 248, 0));
  }
  .lg\\:hover\\:via-blue-600:hover {
    --gradient-via-color: #1c64f2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(28, 100, 242, 0));
  }
  .lg\\:hover\\:via-blue-700:hover {
    --gradient-via-color: #1a56db;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(26, 86, 219, 0));
  }
  .lg\\:hover\\:via-blue-800:hover {
    --gradient-via-color: #1e429f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(30, 66, 159, 0));
  }
  .lg\\:hover\\:via-blue-900:hover {
    --gradient-via-color: #233876;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(35, 56, 118, 0));
  }
  .lg\\:hover\\:via-indigo-50:hover {
    --gradient-via-color: #f0f5ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(240, 245, 255, 0));
  }
  .lg\\:hover\\:via-indigo-100:hover {
    --gradient-via-color: #e5edff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(229, 237, 255, 0));
  }
  .lg\\:hover\\:via-indigo-200:hover {
    --gradient-via-color: #cddbfe;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(205, 219, 254, 0));
  }
  .lg\\:hover\\:via-indigo-300:hover {
    --gradient-via-color: #b4c6fc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(180, 198, 252, 0));
  }
  .lg\\:hover\\:via-indigo-400:hover {
    --gradient-via-color: #8da2fb;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(141, 162, 251, 0));
  }
  .lg\\:hover\\:via-indigo-500:hover {
    --gradient-via-color: #6875f5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(104, 117, 245, 0));
  }
  .lg\\:hover\\:via-indigo-600:hover {
    --gradient-via-color: #5850ec;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(88, 80, 236, 0));
  }
  .lg\\:hover\\:via-indigo-700:hover {
    --gradient-via-color: #5145cd;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(81, 69, 205, 0));
  }
  .lg\\:hover\\:via-indigo-800:hover {
    --gradient-via-color: #42389d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(66, 56, 157, 0));
  }
  .lg\\:hover\\:via-indigo-900:hover {
    --gradient-via-color: #362f78;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(54, 47, 120, 0));
  }
  .lg\\:hover\\:via-purple-50:hover {
    --gradient-via-color: #f6f5ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(246, 245, 255, 0));
  }
  .lg\\:hover\\:via-purple-100:hover {
    --gradient-via-color: #edebfe;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(237, 235, 254, 0));
  }
  .lg\\:hover\\:via-purple-200:hover {
    --gradient-via-color: #dcd7fe;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(220, 215, 254, 0));
  }
  .lg\\:hover\\:via-purple-300:hover {
    --gradient-via-color: #cabffd;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(202, 191, 253, 0));
  }
  .lg\\:hover\\:via-purple-400:hover {
    --gradient-via-color: #ac94fa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(172, 148, 250, 0));
  }
  .lg\\:hover\\:via-purple-500:hover {
    --gradient-via-color: #9061f9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(144, 97, 249, 0));
  }
  .lg\\:hover\\:via-purple-600:hover {
    --gradient-via-color: #7e3af2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(126, 58, 242, 0));
  }
  .lg\\:hover\\:via-purple-700:hover {
    --gradient-via-color: #6c2bd9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(108, 43, 217, 0));
  }
  .lg\\:hover\\:via-purple-800:hover {
    --gradient-via-color: #5521b5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(85, 33, 181, 0));
  }
  .lg\\:hover\\:via-purple-900:hover {
    --gradient-via-color: #4a1d96;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(74, 29, 150, 0));
  }
  .lg\\:hover\\:via-pink-50:hover {
    --gradient-via-color: #fdf2f8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 242, 248, 0));
  }
  .lg\\:hover\\:via-pink-100:hover {
    --gradient-via-color: #fce8f3;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(252, 232, 243, 0));
  }
  .lg\\:hover\\:via-pink-200:hover {
    --gradient-via-color: #fad1e8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(250, 209, 232, 0));
  }
  .lg\\:hover\\:via-pink-300:hover {
    --gradient-via-color: #f8b4d9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(248, 180, 217, 0));
  }
  .lg\\:hover\\:via-pink-400:hover {
    --gradient-via-color: #f17eb8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(241, 126, 184, 0));
  }
  .lg\\:hover\\:via-pink-500:hover {
    --gradient-via-color: #e74694;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(231, 70, 148, 0));
  }
  .lg\\:hover\\:via-pink-600:hover {
    --gradient-via-color: #d61f69;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(214, 31, 105, 0));
  }
  .lg\\:hover\\:via-pink-700:hover {
    --gradient-via-color: #bf125d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(191, 18, 93, 0));
  }
  .lg\\:hover\\:via-pink-800:hover {
    --gradient-via-color: #99154b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(153, 21, 75, 0));
  }
  .lg\\:hover\\:via-pink-900:hover {
    --gradient-via-color: #751a3d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(117, 26, 61, 0));
  }
  .lg\\:hover\\:via-cool-gray-50:hover {
    --gradient-via-color: #f8fafc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(248, 250, 252, 0));
  }
  .lg\\:hover\\:via-cool-gray-100:hover {
    --gradient-via-color: #f1f5f9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(241, 245, 249, 0));
  }
  .lg\\:hover\\:via-cool-gray-200:hover {
    --gradient-via-color: #e2e8f0;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(226, 232, 240, 0));
  }
  .lg\\:hover\\:via-cool-gray-300:hover {
    --gradient-via-color: #cfd8e3;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(207, 216, 227, 0));
  }
  .lg\\:hover\\:via-cool-gray-400:hover {
    --gradient-via-color: #97a6ba;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(151, 166, 186, 0));
  }
  .lg\\:hover\\:via-cool-gray-500:hover {
    --gradient-via-color: #64748b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(100, 116, 139, 0));
  }
  .lg\\:hover\\:via-cool-gray-600:hover {
    --gradient-via-color: #475569;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(71, 85, 105, 0));
  }
  .lg\\:hover\\:via-cool-gray-700:hover {
    --gradient-via-color: #364152;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(54, 65, 82, 0));
  }
  .lg\\:hover\\:via-cool-gray-800:hover {
    --gradient-via-color: #27303f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(39, 48, 63, 0));
  }
  .lg\\:hover\\:via-cool-gray-900:hover {
    --gradient-via-color: #1a202e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(26, 32, 46, 0));
  }
  .lg\\:hover\\:to-current:hover {
    --gradient-to-color: currentColor;
  }
  .lg\\:hover\\:to-transparent:hover {
    --gradient-to-color: transparent;
  }
  .lg\\:hover\\:to-white:hover {
    --gradient-to-color: #ffffff;
  }
  .lg\\:hover\\:to-black:hover {
    --gradient-to-color: #000000;
  }
  .lg\\:hover\\:to-gray-50:hover {
    --gradient-to-color: #f9fafb;
  }
  .lg\\:hover\\:to-gray-100:hover {
    --gradient-to-color: #f4f5f7;
  }
  .lg\\:hover\\:to-gray-200:hover {
    --gradient-to-color: #e5e7eb;
  }
  .lg\\:hover\\:to-gray-300:hover {
    --gradient-to-color: #d2d6dc;
  }
  .lg\\:hover\\:to-gray-400:hover {
    --gradient-to-color: #9fa6b2;
  }
  .lg\\:hover\\:to-gray-500:hover {
    --gradient-to-color: #6b7280;
  }
  .lg\\:hover\\:to-gray-600:hover {
    --gradient-to-color: #4b5563;
  }
  .lg\\:hover\\:to-gray-700:hover {
    --gradient-to-color: #374151;
  }
  .lg\\:hover\\:to-gray-800:hover {
    --gradient-to-color: #252f3f;
  }
  .lg\\:hover\\:to-gray-900:hover {
    --gradient-to-color: #161e2e;
  }
  .lg\\:hover\\:to-red-50:hover {
    --gradient-to-color: #fdf2f2;
  }
  .lg\\:hover\\:to-red-100:hover {
    --gradient-to-color: #fde8e8;
  }
  .lg\\:hover\\:to-red-200:hover {
    --gradient-to-color: #fbd5d5;
  }
  .lg\\:hover\\:to-red-300:hover {
    --gradient-to-color: #f8b4b4;
  }
  .lg\\:hover\\:to-red-400:hover {
    --gradient-to-color: #f98080;
  }
  .lg\\:hover\\:to-red-500:hover {
    --gradient-to-color: #f05252;
  }
  .lg\\:hover\\:to-red-600:hover {
    --gradient-to-color: #e02424;
  }
  .lg\\:hover\\:to-red-700:hover {
    --gradient-to-color: #c81e1e;
  }
  .lg\\:hover\\:to-red-800:hover {
    --gradient-to-color: #9b1c1c;
  }
  .lg\\:hover\\:to-red-900:hover {
    --gradient-to-color: #771d1d;
  }
  .lg\\:hover\\:to-orange-50:hover {
    --gradient-to-color: #fff8f1;
  }
  .lg\\:hover\\:to-orange-100:hover {
    --gradient-to-color: #feecdc;
  }
  .lg\\:hover\\:to-orange-200:hover {
    --gradient-to-color: #fcd9bd;
  }
  .lg\\:hover\\:to-orange-300:hover {
    --gradient-to-color: #fdba8c;
  }
  .lg\\:hover\\:to-orange-400:hover {
    --gradient-to-color: #ff8a4c;
  }
  .lg\\:hover\\:to-orange-500:hover {
    --gradient-to-color: #ff5a1f;
  }
  .lg\\:hover\\:to-orange-600:hover {
    --gradient-to-color: #d03801;
  }
  .lg\\:hover\\:to-orange-700:hover {
    --gradient-to-color: #b43403;
  }
  .lg\\:hover\\:to-orange-800:hover {
    --gradient-to-color: #8a2c0d;
  }
  .lg\\:hover\\:to-orange-900:hover {
    --gradient-to-color: #73230d;
  }
  .lg\\:hover\\:to-yellow-50:hover {
    --gradient-to-color: #fdfdea;
  }
  .lg\\:hover\\:to-yellow-100:hover {
    --gradient-to-color: #fdf6b2;
  }
  .lg\\:hover\\:to-yellow-200:hover {
    --gradient-to-color: #fce96a;
  }
  .lg\\:hover\\:to-yellow-300:hover {
    --gradient-to-color: #faca15;
  }
  .lg\\:hover\\:to-yellow-400:hover {
    --gradient-to-color: #e3a008;
  }
  .lg\\:hover\\:to-yellow-500:hover {
    --gradient-to-color: #c27803;
  }
  .lg\\:hover\\:to-yellow-600:hover {
    --gradient-to-color: #9f580a;
  }
  .lg\\:hover\\:to-yellow-700:hover {
    --gradient-to-color: #8e4b10;
  }
  .lg\\:hover\\:to-yellow-800:hover {
    --gradient-to-color: #723b13;
  }
  .lg\\:hover\\:to-yellow-900:hover {
    --gradient-to-color: #633112;
  }
  .lg\\:hover\\:to-green-50:hover {
    --gradient-to-color: #f3faf7;
  }
  .lg\\:hover\\:to-green-100:hover {
    --gradient-to-color: #def7ec;
  }
  .lg\\:hover\\:to-green-200:hover {
    --gradient-to-color: #bcf0da;
  }
  .lg\\:hover\\:to-green-300:hover {
    --gradient-to-color: #84e1bc;
  }
  .lg\\:hover\\:to-green-400:hover {
    --gradient-to-color: #31c48d;
  }
  .lg\\:hover\\:to-green-500:hover {
    --gradient-to-color: #0e9f6e;
  }
  .lg\\:hover\\:to-green-600:hover {
    --gradient-to-color: #057a55;
  }
  .lg\\:hover\\:to-green-700:hover {
    --gradient-to-color: #046c4e;
  }
  .lg\\:hover\\:to-green-800:hover {
    --gradient-to-color: #03543f;
  }
  .lg\\:hover\\:to-green-900:hover {
    --gradient-to-color: #014737;
  }
  .lg\\:hover\\:to-teal-50:hover {
    --gradient-to-color: #edfafa;
  }
  .lg\\:hover\\:to-teal-100:hover {
    --gradient-to-color: #d5f5f6;
  }
  .lg\\:hover\\:to-teal-200:hover {
    --gradient-to-color: #afecef;
  }
  .lg\\:hover\\:to-teal-300:hover {
    --gradient-to-color: #7edce2;
  }
  .lg\\:hover\\:to-teal-400:hover {
    --gradient-to-color: #16bdca;
  }
  .lg\\:hover\\:to-teal-500:hover {
    --gradient-to-color: #0694a2;
  }
  .lg\\:hover\\:to-teal-600:hover {
    --gradient-to-color: #047481;
  }
  .lg\\:hover\\:to-teal-700:hover {
    --gradient-to-color: #036672;
  }
  .lg\\:hover\\:to-teal-800:hover {
    --gradient-to-color: #05505c;
  }
  .lg\\:hover\\:to-teal-900:hover {
    --gradient-to-color: #014451;
  }
  .lg\\:hover\\:to-blue-50:hover {
    --gradient-to-color: #ebf5ff;
  }
  .lg\\:hover\\:to-blue-100:hover {
    --gradient-to-color: #e1effe;
  }
  .lg\\:hover\\:to-blue-200:hover {
    --gradient-to-color: #c3ddfd;
  }
  .lg\\:hover\\:to-blue-300:hover {
    --gradient-to-color: #a4cafe;
  }
  .lg\\:hover\\:to-blue-400:hover {
    --gradient-to-color: #76a9fa;
  }
  .lg\\:hover\\:to-blue-500:hover {
    --gradient-to-color: #3f83f8;
  }
  .lg\\:hover\\:to-blue-600:hover {
    --gradient-to-color: #1c64f2;
  }
  .lg\\:hover\\:to-blue-700:hover {
    --gradient-to-color: #1a56db;
  }
  .lg\\:hover\\:to-blue-800:hover {
    --gradient-to-color: #1e429f;
  }
  .lg\\:hover\\:to-blue-900:hover {
    --gradient-to-color: #233876;
  }
  .lg\\:hover\\:to-indigo-50:hover {
    --gradient-to-color: #f0f5ff;
  }
  .lg\\:hover\\:to-indigo-100:hover {
    --gradient-to-color: #e5edff;
  }
  .lg\\:hover\\:to-indigo-200:hover {
    --gradient-to-color: #cddbfe;
  }
  .lg\\:hover\\:to-indigo-300:hover {
    --gradient-to-color: #b4c6fc;
  }
  .lg\\:hover\\:to-indigo-400:hover {
    --gradient-to-color: #8da2fb;
  }
  .lg\\:hover\\:to-indigo-500:hover {
    --gradient-to-color: #6875f5;
  }
  .lg\\:hover\\:to-indigo-600:hover {
    --gradient-to-color: #5850ec;
  }
  .lg\\:hover\\:to-indigo-700:hover {
    --gradient-to-color: #5145cd;
  }
  .lg\\:hover\\:to-indigo-800:hover {
    --gradient-to-color: #42389d;
  }
  .lg\\:hover\\:to-indigo-900:hover {
    --gradient-to-color: #362f78;
  }
  .lg\\:hover\\:to-purple-50:hover {
    --gradient-to-color: #f6f5ff;
  }
  .lg\\:hover\\:to-purple-100:hover {
    --gradient-to-color: #edebfe;
  }
  .lg\\:hover\\:to-purple-200:hover {
    --gradient-to-color: #dcd7fe;
  }
  .lg\\:hover\\:to-purple-300:hover {
    --gradient-to-color: #cabffd;
  }
  .lg\\:hover\\:to-purple-400:hover {
    --gradient-to-color: #ac94fa;
  }
  .lg\\:hover\\:to-purple-500:hover {
    --gradient-to-color: #9061f9;
  }
  .lg\\:hover\\:to-purple-600:hover {
    --gradient-to-color: #7e3af2;
  }
  .lg\\:hover\\:to-purple-700:hover {
    --gradient-to-color: #6c2bd9;
  }
  .lg\\:hover\\:to-purple-800:hover {
    --gradient-to-color: #5521b5;
  }
  .lg\\:hover\\:to-purple-900:hover {
    --gradient-to-color: #4a1d96;
  }
  .lg\\:hover\\:to-pink-50:hover {
    --gradient-to-color: #fdf2f8;
  }
  .lg\\:hover\\:to-pink-100:hover {
    --gradient-to-color: #fce8f3;
  }
  .lg\\:hover\\:to-pink-200:hover {
    --gradient-to-color: #fad1e8;
  }
  .lg\\:hover\\:to-pink-300:hover {
    --gradient-to-color: #f8b4d9;
  }
  .lg\\:hover\\:to-pink-400:hover {
    --gradient-to-color: #f17eb8;
  }
  .lg\\:hover\\:to-pink-500:hover {
    --gradient-to-color: #e74694;
  }
  .lg\\:hover\\:to-pink-600:hover {
    --gradient-to-color: #d61f69;
  }
  .lg\\:hover\\:to-pink-700:hover {
    --gradient-to-color: #bf125d;
  }
  .lg\\:hover\\:to-pink-800:hover {
    --gradient-to-color: #99154b;
  }
  .lg\\:hover\\:to-pink-900:hover {
    --gradient-to-color: #751a3d;
  }
  .lg\\:hover\\:to-cool-gray-50:hover {
    --gradient-to-color: #f8fafc;
  }
  .lg\\:hover\\:to-cool-gray-100:hover {
    --gradient-to-color: #f1f5f9;
  }
  .lg\\:hover\\:to-cool-gray-200:hover {
    --gradient-to-color: #e2e8f0;
  }
  .lg\\:hover\\:to-cool-gray-300:hover {
    --gradient-to-color: #cfd8e3;
  }
  .lg\\:hover\\:to-cool-gray-400:hover {
    --gradient-to-color: #97a6ba;
  }
  .lg\\:hover\\:to-cool-gray-500:hover {
    --gradient-to-color: #64748b;
  }
  .lg\\:hover\\:to-cool-gray-600:hover {
    --gradient-to-color: #475569;
  }
  .lg\\:hover\\:to-cool-gray-700:hover {
    --gradient-to-color: #364152;
  }
  .lg\\:hover\\:to-cool-gray-800:hover {
    --gradient-to-color: #27303f;
  }
  .lg\\:hover\\:to-cool-gray-900:hover {
    --gradient-to-color: #1a202e;
  }
  .lg\\:focus\\:from-current:focus {
    --gradient-from-color: currentColor;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }
  .lg\\:focus\\:from-transparent:focus {
    --gradient-from-color: transparent;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  }
  .lg\\:focus\\:from-white:focus {
    --gradient-from-color: #ffffff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }
  .lg\\:focus\\:from-black:focus {
    --gradient-from-color: #000000;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  }
  .lg\\:focus\\:from-gray-50:focus {
    --gradient-from-color: #f9fafb;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(249, 250, 251, 0));
  }
  .lg\\:focus\\:from-gray-100:focus {
    --gradient-from-color: #f4f5f7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(244, 245, 247, 0));
  }
  .lg\\:focus\\:from-gray-200:focus {
    --gradient-from-color: #e5e7eb;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(229, 231, 235, 0));
  }
  .lg\\:focus\\:from-gray-300:focus {
    --gradient-from-color: #d2d6dc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(210, 214, 220, 0));
  }
  .lg\\:focus\\:from-gray-400:focus {
    --gradient-from-color: #9fa6b2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(159, 166, 178, 0));
  }
  .lg\\:focus\\:from-gray-500:focus {
    --gradient-from-color: #6b7280;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(107, 114, 128, 0));
  }
  .lg\\:focus\\:from-gray-600:focus {
    --gradient-from-color: #4b5563;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(75, 85, 99, 0));
  }
  .lg\\:focus\\:from-gray-700:focus {
    --gradient-from-color: #374151;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(55, 65, 81, 0));
  }
  .lg\\:focus\\:from-gray-800:focus {
    --gradient-from-color: #252f3f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(37, 47, 63, 0));
  }
  .lg\\:focus\\:from-gray-900:focus {
    --gradient-from-color: #161e2e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(22, 30, 46, 0));
  }
  .lg\\:focus\\:from-red-50:focus {
    --gradient-from-color: #fdf2f2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 242, 242, 0));
  }
  .lg\\:focus\\:from-red-100:focus {
    --gradient-from-color: #fde8e8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 232, 232, 0));
  }
  .lg\\:focus\\:from-red-200:focus {
    --gradient-from-color: #fbd5d5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(251, 213, 213, 0));
  }
  .lg\\:focus\\:from-red-300:focus {
    --gradient-from-color: #f8b4b4;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(248, 180, 180, 0));
  }
  .lg\\:focus\\:from-red-400:focus {
    --gradient-from-color: #f98080;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(249, 128, 128, 0));
  }
  .lg\\:focus\\:from-red-500:focus {
    --gradient-from-color: #f05252;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(240, 82, 82, 0));
  }
  .lg\\:focus\\:from-red-600:focus {
    --gradient-from-color: #e02424;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(224, 36, 36, 0));
  }
  .lg\\:focus\\:from-red-700:focus {
    --gradient-from-color: #c81e1e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(200, 30, 30, 0));
  }
  .lg\\:focus\\:from-red-800:focus {
    --gradient-from-color: #9b1c1c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(155, 28, 28, 0));
  }
  .lg\\:focus\\:from-red-900:focus {
    --gradient-from-color: #771d1d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(119, 29, 29, 0));
  }
  .lg\\:focus\\:from-orange-50:focus {
    --gradient-from-color: #fff8f1;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 248, 241, 0));
  }
  .lg\\:focus\\:from-orange-100:focus {
    --gradient-from-color: #feecdc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 236, 220, 0));
  }
  .lg\\:focus\\:from-orange-200:focus {
    --gradient-from-color: #fcd9bd;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(252, 217, 189, 0));
  }
  .lg\\:focus\\:from-orange-300:focus {
    --gradient-from-color: #fdba8c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 186, 140, 0));
  }
  .lg\\:focus\\:from-orange-400:focus {
    --gradient-from-color: #ff8a4c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 138, 76, 0));
  }
  .lg\\:focus\\:from-orange-500:focus {
    --gradient-from-color: #ff5a1f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 90, 31, 0));
  }
  .lg\\:focus\\:from-orange-600:focus {
    --gradient-from-color: #d03801;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(208, 56, 1, 0));
  }
  .lg\\:focus\\:from-orange-700:focus {
    --gradient-from-color: #b43403;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(180, 52, 3, 0));
  }
  .lg\\:focus\\:from-orange-800:focus {
    --gradient-from-color: #8a2c0d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(138, 44, 13, 0));
  }
  .lg\\:focus\\:from-orange-900:focus {
    --gradient-from-color: #73230d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(115, 35, 13, 0));
  }
  .lg\\:focus\\:from-yellow-50:focus {
    --gradient-from-color: #fdfdea;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 253, 234, 0));
  }
  .lg\\:focus\\:from-yellow-100:focus {
    --gradient-from-color: #fdf6b2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 246, 178, 0));
  }
  .lg\\:focus\\:from-yellow-200:focus {
    --gradient-from-color: #fce96a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(252, 233, 106, 0));
  }
  .lg\\:focus\\:from-yellow-300:focus {
    --gradient-from-color: #faca15;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(250, 202, 21, 0));
  }
  .lg\\:focus\\:from-yellow-400:focus {
    --gradient-from-color: #e3a008;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(227, 160, 8, 0));
  }
  .lg\\:focus\\:from-yellow-500:focus {
    --gradient-from-color: #c27803;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(194, 120, 3, 0));
  }
  .lg\\:focus\\:from-yellow-600:focus {
    --gradient-from-color: #9f580a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(159, 88, 10, 0));
  }
  .lg\\:focus\\:from-yellow-700:focus {
    --gradient-from-color: #8e4b10;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(142, 75, 16, 0));
  }
  .lg\\:focus\\:from-yellow-800:focus {
    --gradient-from-color: #723b13;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(114, 59, 19, 0));
  }
  .lg\\:focus\\:from-yellow-900:focus {
    --gradient-from-color: #633112;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(99, 49, 18, 0));
  }
  .lg\\:focus\\:from-green-50:focus {
    --gradient-from-color: #f3faf7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(243, 250, 247, 0));
  }
  .lg\\:focus\\:from-green-100:focus {
    --gradient-from-color: #def7ec;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(222, 247, 236, 0));
  }
  .lg\\:focus\\:from-green-200:focus {
    --gradient-from-color: #bcf0da;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(188, 240, 218, 0));
  }
  .lg\\:focus\\:from-green-300:focus {
    --gradient-from-color: #84e1bc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(132, 225, 188, 0));
  }
  .lg\\:focus\\:from-green-400:focus {
    --gradient-from-color: #31c48d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(49, 196, 141, 0));
  }
  .lg\\:focus\\:from-green-500:focus {
    --gradient-from-color: #0e9f6e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(14, 159, 110, 0));
  }
  .lg\\:focus\\:from-green-600:focus {
    --gradient-from-color: #057a55;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(5, 122, 85, 0));
  }
  .lg\\:focus\\:from-green-700:focus {
    --gradient-from-color: #046c4e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(4, 108, 78, 0));
  }
  .lg\\:focus\\:from-green-800:focus {
    --gradient-from-color: #03543f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(3, 84, 63, 0));
  }
  .lg\\:focus\\:from-green-900:focus {
    --gradient-from-color: #014737;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(1, 71, 55, 0));
  }
  .lg\\:focus\\:from-teal-50:focus {
    --gradient-from-color: #edfafa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(237, 250, 250, 0));
  }
  .lg\\:focus\\:from-teal-100:focus {
    --gradient-from-color: #d5f5f6;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(213, 245, 246, 0));
  }
  .lg\\:focus\\:from-teal-200:focus {
    --gradient-from-color: #afecef;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(175, 236, 239, 0));
  }
  .lg\\:focus\\:from-teal-300:focus {
    --gradient-from-color: #7edce2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(126, 220, 226, 0));
  }
  .lg\\:focus\\:from-teal-400:focus {
    --gradient-from-color: #16bdca;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(22, 189, 202, 0));
  }
  .lg\\:focus\\:from-teal-500:focus {
    --gradient-from-color: #0694a2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(6, 148, 162, 0));
  }
  .lg\\:focus\\:from-teal-600:focus {
    --gradient-from-color: #047481;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(4, 116, 129, 0));
  }
  .lg\\:focus\\:from-teal-700:focus {
    --gradient-from-color: #036672;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(3, 102, 114, 0));
  }
  .lg\\:focus\\:from-teal-800:focus {
    --gradient-from-color: #05505c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(5, 80, 92, 0));
  }
  .lg\\:focus\\:from-teal-900:focus {
    --gradient-from-color: #014451;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(1, 68, 81, 0));
  }
  .lg\\:focus\\:from-blue-50:focus {
    --gradient-from-color: #ebf5ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(235, 245, 255, 0));
  }
  .lg\\:focus\\:from-blue-100:focus {
    --gradient-from-color: #e1effe;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(225, 239, 254, 0));
  }
  .lg\\:focus\\:from-blue-200:focus {
    --gradient-from-color: #c3ddfd;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(195, 221, 253, 0));
  }
  .lg\\:focus\\:from-blue-300:focus {
    --gradient-from-color: #a4cafe;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(164, 202, 254, 0));
  }
  .lg\\:focus\\:from-blue-400:focus {
    --gradient-from-color: #76a9fa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(118, 169, 250, 0));
  }
  .lg\\:focus\\:from-blue-500:focus {
    --gradient-from-color: #3f83f8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(63, 131, 248, 0));
  }
  .lg\\:focus\\:from-blue-600:focus {
    --gradient-from-color: #1c64f2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(28, 100, 242, 0));
  }
  .lg\\:focus\\:from-blue-700:focus {
    --gradient-from-color: #1a56db;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(26, 86, 219, 0));
  }
  .lg\\:focus\\:from-blue-800:focus {
    --gradient-from-color: #1e429f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(30, 66, 159, 0));
  }
  .lg\\:focus\\:from-blue-900:focus {
    --gradient-from-color: #233876;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(35, 56, 118, 0));
  }
  .lg\\:focus\\:from-indigo-50:focus {
    --gradient-from-color: #f0f5ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(240, 245, 255, 0));
  }
  .lg\\:focus\\:from-indigo-100:focus {
    --gradient-from-color: #e5edff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(229, 237, 255, 0));
  }
  .lg\\:focus\\:from-indigo-200:focus {
    --gradient-from-color: #cddbfe;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(205, 219, 254, 0));
  }
  .lg\\:focus\\:from-indigo-300:focus {
    --gradient-from-color: #b4c6fc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(180, 198, 252, 0));
  }
  .lg\\:focus\\:from-indigo-400:focus {
    --gradient-from-color: #8da2fb;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(141, 162, 251, 0));
  }
  .lg\\:focus\\:from-indigo-500:focus {
    --gradient-from-color: #6875f5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(104, 117, 245, 0));
  }
  .lg\\:focus\\:from-indigo-600:focus {
    --gradient-from-color: #5850ec;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(88, 80, 236, 0));
  }
  .lg\\:focus\\:from-indigo-700:focus {
    --gradient-from-color: #5145cd;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(81, 69, 205, 0));
  }
  .lg\\:focus\\:from-indigo-800:focus {
    --gradient-from-color: #42389d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(66, 56, 157, 0));
  }
  .lg\\:focus\\:from-indigo-900:focus {
    --gradient-from-color: #362f78;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(54, 47, 120, 0));
  }
  .lg\\:focus\\:from-purple-50:focus {
    --gradient-from-color: #f6f5ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(246, 245, 255, 0));
  }
  .lg\\:focus\\:from-purple-100:focus {
    --gradient-from-color: #edebfe;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(237, 235, 254, 0));
  }
  .lg\\:focus\\:from-purple-200:focus {
    --gradient-from-color: #dcd7fe;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(220, 215, 254, 0));
  }
  .lg\\:focus\\:from-purple-300:focus {
    --gradient-from-color: #cabffd;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(202, 191, 253, 0));
  }
  .lg\\:focus\\:from-purple-400:focus {
    --gradient-from-color: #ac94fa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(172, 148, 250, 0));
  }
  .lg\\:focus\\:from-purple-500:focus {
    --gradient-from-color: #9061f9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(144, 97, 249, 0));
  }
  .lg\\:focus\\:from-purple-600:focus {
    --gradient-from-color: #7e3af2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(126, 58, 242, 0));
  }
  .lg\\:focus\\:from-purple-700:focus {
    --gradient-from-color: #6c2bd9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(108, 43, 217, 0));
  }
  .lg\\:focus\\:from-purple-800:focus {
    --gradient-from-color: #5521b5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(85, 33, 181, 0));
  }
  .lg\\:focus\\:from-purple-900:focus {
    --gradient-from-color: #4a1d96;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(74, 29, 150, 0));
  }
  .lg\\:focus\\:from-pink-50:focus {
    --gradient-from-color: #fdf2f8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 242, 248, 0));
  }
  .lg\\:focus\\:from-pink-100:focus {
    --gradient-from-color: #fce8f3;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(252, 232, 243, 0));
  }
  .lg\\:focus\\:from-pink-200:focus {
    --gradient-from-color: #fad1e8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(250, 209, 232, 0));
  }
  .lg\\:focus\\:from-pink-300:focus {
    --gradient-from-color: #f8b4d9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(248, 180, 217, 0));
  }
  .lg\\:focus\\:from-pink-400:focus {
    --gradient-from-color: #f17eb8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(241, 126, 184, 0));
  }
  .lg\\:focus\\:from-pink-500:focus {
    --gradient-from-color: #e74694;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(231, 70, 148, 0));
  }
  .lg\\:focus\\:from-pink-600:focus {
    --gradient-from-color: #d61f69;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(214, 31, 105, 0));
  }
  .lg\\:focus\\:from-pink-700:focus {
    --gradient-from-color: #bf125d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(191, 18, 93, 0));
  }
  .lg\\:focus\\:from-pink-800:focus {
    --gradient-from-color: #99154b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(153, 21, 75, 0));
  }
  .lg\\:focus\\:from-pink-900:focus {
    --gradient-from-color: #751a3d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(117, 26, 61, 0));
  }
  .lg\\:focus\\:from-cool-gray-50:focus {
    --gradient-from-color: #f8fafc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(248, 250, 252, 0));
  }
  .lg\\:focus\\:from-cool-gray-100:focus {
    --gradient-from-color: #f1f5f9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(241, 245, 249, 0));
  }
  .lg\\:focus\\:from-cool-gray-200:focus {
    --gradient-from-color: #e2e8f0;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(226, 232, 240, 0));
  }
  .lg\\:focus\\:from-cool-gray-300:focus {
    --gradient-from-color: #cfd8e3;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(207, 216, 227, 0));
  }
  .lg\\:focus\\:from-cool-gray-400:focus {
    --gradient-from-color: #97a6ba;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(151, 166, 186, 0));
  }
  .lg\\:focus\\:from-cool-gray-500:focus {
    --gradient-from-color: #64748b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(100, 116, 139, 0));
  }
  .lg\\:focus\\:from-cool-gray-600:focus {
    --gradient-from-color: #475569;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(71, 85, 105, 0));
  }
  .lg\\:focus\\:from-cool-gray-700:focus {
    --gradient-from-color: #364152;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(54, 65, 82, 0));
  }
  .lg\\:focus\\:from-cool-gray-800:focus {
    --gradient-from-color: #27303f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(39, 48, 63, 0));
  }
  .lg\\:focus\\:from-cool-gray-900:focus {
    --gradient-from-color: #1a202e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(26, 32, 46, 0));
  }
  .lg\\:focus\\:via-current:focus {
    --gradient-via-color: currentColor;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }
  .lg\\:focus\\:via-transparent:focus {
    --gradient-via-color: transparent;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  }
  .lg\\:focus\\:via-white:focus {
    --gradient-via-color: #ffffff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }
  .lg\\:focus\\:via-black:focus {
    --gradient-via-color: #000000;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  }
  .lg\\:focus\\:via-gray-50:focus {
    --gradient-via-color: #f9fafb;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(249, 250, 251, 0));
  }
  .lg\\:focus\\:via-gray-100:focus {
    --gradient-via-color: #f4f5f7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(244, 245, 247, 0));
  }
  .lg\\:focus\\:via-gray-200:focus {
    --gradient-via-color: #e5e7eb;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(229, 231, 235, 0));
  }
  .lg\\:focus\\:via-gray-300:focus {
    --gradient-via-color: #d2d6dc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(210, 214, 220, 0));
  }
  .lg\\:focus\\:via-gray-400:focus {
    --gradient-via-color: #9fa6b2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(159, 166, 178, 0));
  }
  .lg\\:focus\\:via-gray-500:focus {
    --gradient-via-color: #6b7280;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(107, 114, 128, 0));
  }
  .lg\\:focus\\:via-gray-600:focus {
    --gradient-via-color: #4b5563;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(75, 85, 99, 0));
  }
  .lg\\:focus\\:via-gray-700:focus {
    --gradient-via-color: #374151;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(55, 65, 81, 0));
  }
  .lg\\:focus\\:via-gray-800:focus {
    --gradient-via-color: #252f3f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(37, 47, 63, 0));
  }
  .lg\\:focus\\:via-gray-900:focus {
    --gradient-via-color: #161e2e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(22, 30, 46, 0));
  }
  .lg\\:focus\\:via-red-50:focus {
    --gradient-via-color: #fdf2f2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 242, 242, 0));
  }
  .lg\\:focus\\:via-red-100:focus {
    --gradient-via-color: #fde8e8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 232, 232, 0));
  }
  .lg\\:focus\\:via-red-200:focus {
    --gradient-via-color: #fbd5d5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(251, 213, 213, 0));
  }
  .lg\\:focus\\:via-red-300:focus {
    --gradient-via-color: #f8b4b4;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(248, 180, 180, 0));
  }
  .lg\\:focus\\:via-red-400:focus {
    --gradient-via-color: #f98080;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(249, 128, 128, 0));
  }
  .lg\\:focus\\:via-red-500:focus {
    --gradient-via-color: #f05252;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(240, 82, 82, 0));
  }
  .lg\\:focus\\:via-red-600:focus {
    --gradient-via-color: #e02424;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(224, 36, 36, 0));
  }
  .lg\\:focus\\:via-red-700:focus {
    --gradient-via-color: #c81e1e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(200, 30, 30, 0));
  }
  .lg\\:focus\\:via-red-800:focus {
    --gradient-via-color: #9b1c1c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(155, 28, 28, 0));
  }
  .lg\\:focus\\:via-red-900:focus {
    --gradient-via-color: #771d1d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(119, 29, 29, 0));
  }
  .lg\\:focus\\:via-orange-50:focus {
    --gradient-via-color: #fff8f1;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 248, 241, 0));
  }
  .lg\\:focus\\:via-orange-100:focus {
    --gradient-via-color: #feecdc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 236, 220, 0));
  }
  .lg\\:focus\\:via-orange-200:focus {
    --gradient-via-color: #fcd9bd;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(252, 217, 189, 0));
  }
  .lg\\:focus\\:via-orange-300:focus {
    --gradient-via-color: #fdba8c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 186, 140, 0));
  }
  .lg\\:focus\\:via-orange-400:focus {
    --gradient-via-color: #ff8a4c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 138, 76, 0));
  }
  .lg\\:focus\\:via-orange-500:focus {
    --gradient-via-color: #ff5a1f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 90, 31, 0));
  }
  .lg\\:focus\\:via-orange-600:focus {
    --gradient-via-color: #d03801;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(208, 56, 1, 0));
  }
  .lg\\:focus\\:via-orange-700:focus {
    --gradient-via-color: #b43403;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(180, 52, 3, 0));
  }
  .lg\\:focus\\:via-orange-800:focus {
    --gradient-via-color: #8a2c0d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(138, 44, 13, 0));
  }
  .lg\\:focus\\:via-orange-900:focus {
    --gradient-via-color: #73230d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(115, 35, 13, 0));
  }
  .lg\\:focus\\:via-yellow-50:focus {
    --gradient-via-color: #fdfdea;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 253, 234, 0));
  }
  .lg\\:focus\\:via-yellow-100:focus {
    --gradient-via-color: #fdf6b2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 246, 178, 0));
  }
  .lg\\:focus\\:via-yellow-200:focus {
    --gradient-via-color: #fce96a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(252, 233, 106, 0));
  }
  .lg\\:focus\\:via-yellow-300:focus {
    --gradient-via-color: #faca15;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(250, 202, 21, 0));
  }
  .lg\\:focus\\:via-yellow-400:focus {
    --gradient-via-color: #e3a008;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(227, 160, 8, 0));
  }
  .lg\\:focus\\:via-yellow-500:focus {
    --gradient-via-color: #c27803;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(194, 120, 3, 0));
  }
  .lg\\:focus\\:via-yellow-600:focus {
    --gradient-via-color: #9f580a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(159, 88, 10, 0));
  }
  .lg\\:focus\\:via-yellow-700:focus {
    --gradient-via-color: #8e4b10;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(142, 75, 16, 0));
  }
  .lg\\:focus\\:via-yellow-800:focus {
    --gradient-via-color: #723b13;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(114, 59, 19, 0));
  }
  .lg\\:focus\\:via-yellow-900:focus {
    --gradient-via-color: #633112;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(99, 49, 18, 0));
  }
  .lg\\:focus\\:via-green-50:focus {
    --gradient-via-color: #f3faf7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(243, 250, 247, 0));
  }
  .lg\\:focus\\:via-green-100:focus {
    --gradient-via-color: #def7ec;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(222, 247, 236, 0));
  }
  .lg\\:focus\\:via-green-200:focus {
    --gradient-via-color: #bcf0da;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(188, 240, 218, 0));
  }
  .lg\\:focus\\:via-green-300:focus {
    --gradient-via-color: #84e1bc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(132, 225, 188, 0));
  }
  .lg\\:focus\\:via-green-400:focus {
    --gradient-via-color: #31c48d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(49, 196, 141, 0));
  }
  .lg\\:focus\\:via-green-500:focus {
    --gradient-via-color: #0e9f6e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(14, 159, 110, 0));
  }
  .lg\\:focus\\:via-green-600:focus {
    --gradient-via-color: #057a55;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(5, 122, 85, 0));
  }
  .lg\\:focus\\:via-green-700:focus {
    --gradient-via-color: #046c4e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(4, 108, 78, 0));
  }
  .lg\\:focus\\:via-green-800:focus {
    --gradient-via-color: #03543f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(3, 84, 63, 0));
  }
  .lg\\:focus\\:via-green-900:focus {
    --gradient-via-color: #014737;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(1, 71, 55, 0));
  }
  .lg\\:focus\\:via-teal-50:focus {
    --gradient-via-color: #edfafa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(237, 250, 250, 0));
  }
  .lg\\:focus\\:via-teal-100:focus {
    --gradient-via-color: #d5f5f6;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(213, 245, 246, 0));
  }
  .lg\\:focus\\:via-teal-200:focus {
    --gradient-via-color: #afecef;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(175, 236, 239, 0));
  }
  .lg\\:focus\\:via-teal-300:focus {
    --gradient-via-color: #7edce2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(126, 220, 226, 0));
  }
  .lg\\:focus\\:via-teal-400:focus {
    --gradient-via-color: #16bdca;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(22, 189, 202, 0));
  }
  .lg\\:focus\\:via-teal-500:focus {
    --gradient-via-color: #0694a2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(6, 148, 162, 0));
  }
  .lg\\:focus\\:via-teal-600:focus {
    --gradient-via-color: #047481;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(4, 116, 129, 0));
  }
  .lg\\:focus\\:via-teal-700:focus {
    --gradient-via-color: #036672;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(3, 102, 114, 0));
  }
  .lg\\:focus\\:via-teal-800:focus {
    --gradient-via-color: #05505c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(5, 80, 92, 0));
  }
  .lg\\:focus\\:via-teal-900:focus {
    --gradient-via-color: #014451;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(1, 68, 81, 0));
  }
  .lg\\:focus\\:via-blue-50:focus {
    --gradient-via-color: #ebf5ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(235, 245, 255, 0));
  }
  .lg\\:focus\\:via-blue-100:focus {
    --gradient-via-color: #e1effe;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(225, 239, 254, 0));
  }
  .lg\\:focus\\:via-blue-200:focus {
    --gradient-via-color: #c3ddfd;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(195, 221, 253, 0));
  }
  .lg\\:focus\\:via-blue-300:focus {
    --gradient-via-color: #a4cafe;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(164, 202, 254, 0));
  }
  .lg\\:focus\\:via-blue-400:focus {
    --gradient-via-color: #76a9fa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(118, 169, 250, 0));
  }
  .lg\\:focus\\:via-blue-500:focus {
    --gradient-via-color: #3f83f8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(63, 131, 248, 0));
  }
  .lg\\:focus\\:via-blue-600:focus {
    --gradient-via-color: #1c64f2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(28, 100, 242, 0));
  }
  .lg\\:focus\\:via-blue-700:focus {
    --gradient-via-color: #1a56db;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(26, 86, 219, 0));
  }
  .lg\\:focus\\:via-blue-800:focus {
    --gradient-via-color: #1e429f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(30, 66, 159, 0));
  }
  .lg\\:focus\\:via-blue-900:focus {
    --gradient-via-color: #233876;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(35, 56, 118, 0));
  }
  .lg\\:focus\\:via-indigo-50:focus {
    --gradient-via-color: #f0f5ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(240, 245, 255, 0));
  }
  .lg\\:focus\\:via-indigo-100:focus {
    --gradient-via-color: #e5edff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(229, 237, 255, 0));
  }
  .lg\\:focus\\:via-indigo-200:focus {
    --gradient-via-color: #cddbfe;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(205, 219, 254, 0));
  }
  .lg\\:focus\\:via-indigo-300:focus {
    --gradient-via-color: #b4c6fc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(180, 198, 252, 0));
  }
  .lg\\:focus\\:via-indigo-400:focus {
    --gradient-via-color: #8da2fb;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(141, 162, 251, 0));
  }
  .lg\\:focus\\:via-indigo-500:focus {
    --gradient-via-color: #6875f5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(104, 117, 245, 0));
  }
  .lg\\:focus\\:via-indigo-600:focus {
    --gradient-via-color: #5850ec;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(88, 80, 236, 0));
  }
  .lg\\:focus\\:via-indigo-700:focus {
    --gradient-via-color: #5145cd;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(81, 69, 205, 0));
  }
  .lg\\:focus\\:via-indigo-800:focus {
    --gradient-via-color: #42389d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(66, 56, 157, 0));
  }
  .lg\\:focus\\:via-indigo-900:focus {
    --gradient-via-color: #362f78;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(54, 47, 120, 0));
  }
  .lg\\:focus\\:via-purple-50:focus {
    --gradient-via-color: #f6f5ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(246, 245, 255, 0));
  }
  .lg\\:focus\\:via-purple-100:focus {
    --gradient-via-color: #edebfe;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(237, 235, 254, 0));
  }
  .lg\\:focus\\:via-purple-200:focus {
    --gradient-via-color: #dcd7fe;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(220, 215, 254, 0));
  }
  .lg\\:focus\\:via-purple-300:focus {
    --gradient-via-color: #cabffd;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(202, 191, 253, 0));
  }
  .lg\\:focus\\:via-purple-400:focus {
    --gradient-via-color: #ac94fa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(172, 148, 250, 0));
  }
  .lg\\:focus\\:via-purple-500:focus {
    --gradient-via-color: #9061f9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(144, 97, 249, 0));
  }
  .lg\\:focus\\:via-purple-600:focus {
    --gradient-via-color: #7e3af2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(126, 58, 242, 0));
  }
  .lg\\:focus\\:via-purple-700:focus {
    --gradient-via-color: #6c2bd9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(108, 43, 217, 0));
  }
  .lg\\:focus\\:via-purple-800:focus {
    --gradient-via-color: #5521b5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(85, 33, 181, 0));
  }
  .lg\\:focus\\:via-purple-900:focus {
    --gradient-via-color: #4a1d96;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(74, 29, 150, 0));
  }
  .lg\\:focus\\:via-pink-50:focus {
    --gradient-via-color: #fdf2f8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 242, 248, 0));
  }
  .lg\\:focus\\:via-pink-100:focus {
    --gradient-via-color: #fce8f3;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(252, 232, 243, 0));
  }
  .lg\\:focus\\:via-pink-200:focus {
    --gradient-via-color: #fad1e8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(250, 209, 232, 0));
  }
  .lg\\:focus\\:via-pink-300:focus {
    --gradient-via-color: #f8b4d9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(248, 180, 217, 0));
  }
  .lg\\:focus\\:via-pink-400:focus {
    --gradient-via-color: #f17eb8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(241, 126, 184, 0));
  }
  .lg\\:focus\\:via-pink-500:focus {
    --gradient-via-color: #e74694;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(231, 70, 148, 0));
  }
  .lg\\:focus\\:via-pink-600:focus {
    --gradient-via-color: #d61f69;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(214, 31, 105, 0));
  }
  .lg\\:focus\\:via-pink-700:focus {
    --gradient-via-color: #bf125d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(191, 18, 93, 0));
  }
  .lg\\:focus\\:via-pink-800:focus {
    --gradient-via-color: #99154b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(153, 21, 75, 0));
  }
  .lg\\:focus\\:via-pink-900:focus {
    --gradient-via-color: #751a3d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(117, 26, 61, 0));
  }
  .lg\\:focus\\:via-cool-gray-50:focus {
    --gradient-via-color: #f8fafc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(248, 250, 252, 0));
  }
  .lg\\:focus\\:via-cool-gray-100:focus {
    --gradient-via-color: #f1f5f9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(241, 245, 249, 0));
  }
  .lg\\:focus\\:via-cool-gray-200:focus {
    --gradient-via-color: #e2e8f0;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(226, 232, 240, 0));
  }
  .lg\\:focus\\:via-cool-gray-300:focus {
    --gradient-via-color: #cfd8e3;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(207, 216, 227, 0));
  }
  .lg\\:focus\\:via-cool-gray-400:focus {
    --gradient-via-color: #97a6ba;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(151, 166, 186, 0));
  }
  .lg\\:focus\\:via-cool-gray-500:focus {
    --gradient-via-color: #64748b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(100, 116, 139, 0));
  }
  .lg\\:focus\\:via-cool-gray-600:focus {
    --gradient-via-color: #475569;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(71, 85, 105, 0));
  }
  .lg\\:focus\\:via-cool-gray-700:focus {
    --gradient-via-color: #364152;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(54, 65, 82, 0));
  }
  .lg\\:focus\\:via-cool-gray-800:focus {
    --gradient-via-color: #27303f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(39, 48, 63, 0));
  }
  .lg\\:focus\\:via-cool-gray-900:focus {
    --gradient-via-color: #1a202e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(26, 32, 46, 0));
  }
  .lg\\:focus\\:to-current:focus {
    --gradient-to-color: currentColor;
  }
  .lg\\:focus\\:to-transparent:focus {
    --gradient-to-color: transparent;
  }
  .lg\\:focus\\:to-white:focus {
    --gradient-to-color: #ffffff;
  }
  .lg\\:focus\\:to-black:focus {
    --gradient-to-color: #000000;
  }
  .lg\\:focus\\:to-gray-50:focus {
    --gradient-to-color: #f9fafb;
  }
  .lg\\:focus\\:to-gray-100:focus {
    --gradient-to-color: #f4f5f7;
  }
  .lg\\:focus\\:to-gray-200:focus {
    --gradient-to-color: #e5e7eb;
  }
  .lg\\:focus\\:to-gray-300:focus {
    --gradient-to-color: #d2d6dc;
  }
  .lg\\:focus\\:to-gray-400:focus {
    --gradient-to-color: #9fa6b2;
  }
  .lg\\:focus\\:to-gray-500:focus {
    --gradient-to-color: #6b7280;
  }
  .lg\\:focus\\:to-gray-600:focus {
    --gradient-to-color: #4b5563;
  }
  .lg\\:focus\\:to-gray-700:focus {
    --gradient-to-color: #374151;
  }
  .lg\\:focus\\:to-gray-800:focus {
    --gradient-to-color: #252f3f;
  }
  .lg\\:focus\\:to-gray-900:focus {
    --gradient-to-color: #161e2e;
  }
  .lg\\:focus\\:to-red-50:focus {
    --gradient-to-color: #fdf2f2;
  }
  .lg\\:focus\\:to-red-100:focus {
    --gradient-to-color: #fde8e8;
  }
  .lg\\:focus\\:to-red-200:focus {
    --gradient-to-color: #fbd5d5;
  }
  .lg\\:focus\\:to-red-300:focus {
    --gradient-to-color: #f8b4b4;
  }
  .lg\\:focus\\:to-red-400:focus {
    --gradient-to-color: #f98080;
  }
  .lg\\:focus\\:to-red-500:focus {
    --gradient-to-color: #f05252;
  }
  .lg\\:focus\\:to-red-600:focus {
    --gradient-to-color: #e02424;
  }
  .lg\\:focus\\:to-red-700:focus {
    --gradient-to-color: #c81e1e;
  }
  .lg\\:focus\\:to-red-800:focus {
    --gradient-to-color: #9b1c1c;
  }
  .lg\\:focus\\:to-red-900:focus {
    --gradient-to-color: #771d1d;
  }
  .lg\\:focus\\:to-orange-50:focus {
    --gradient-to-color: #fff8f1;
  }
  .lg\\:focus\\:to-orange-100:focus {
    --gradient-to-color: #feecdc;
  }
  .lg\\:focus\\:to-orange-200:focus {
    --gradient-to-color: #fcd9bd;
  }
  .lg\\:focus\\:to-orange-300:focus {
    --gradient-to-color: #fdba8c;
  }
  .lg\\:focus\\:to-orange-400:focus {
    --gradient-to-color: #ff8a4c;
  }
  .lg\\:focus\\:to-orange-500:focus {
    --gradient-to-color: #ff5a1f;
  }
  .lg\\:focus\\:to-orange-600:focus {
    --gradient-to-color: #d03801;
  }
  .lg\\:focus\\:to-orange-700:focus {
    --gradient-to-color: #b43403;
  }
  .lg\\:focus\\:to-orange-800:focus {
    --gradient-to-color: #8a2c0d;
  }
  .lg\\:focus\\:to-orange-900:focus {
    --gradient-to-color: #73230d;
  }
  .lg\\:focus\\:to-yellow-50:focus {
    --gradient-to-color: #fdfdea;
  }
  .lg\\:focus\\:to-yellow-100:focus {
    --gradient-to-color: #fdf6b2;
  }
  .lg\\:focus\\:to-yellow-200:focus {
    --gradient-to-color: #fce96a;
  }
  .lg\\:focus\\:to-yellow-300:focus {
    --gradient-to-color: #faca15;
  }
  .lg\\:focus\\:to-yellow-400:focus {
    --gradient-to-color: #e3a008;
  }
  .lg\\:focus\\:to-yellow-500:focus {
    --gradient-to-color: #c27803;
  }
  .lg\\:focus\\:to-yellow-600:focus {
    --gradient-to-color: #9f580a;
  }
  .lg\\:focus\\:to-yellow-700:focus {
    --gradient-to-color: #8e4b10;
  }
  .lg\\:focus\\:to-yellow-800:focus {
    --gradient-to-color: #723b13;
  }
  .lg\\:focus\\:to-yellow-900:focus {
    --gradient-to-color: #633112;
  }
  .lg\\:focus\\:to-green-50:focus {
    --gradient-to-color: #f3faf7;
  }
  .lg\\:focus\\:to-green-100:focus {
    --gradient-to-color: #def7ec;
  }
  .lg\\:focus\\:to-green-200:focus {
    --gradient-to-color: #bcf0da;
  }
  .lg\\:focus\\:to-green-300:focus {
    --gradient-to-color: #84e1bc;
  }
  .lg\\:focus\\:to-green-400:focus {
    --gradient-to-color: #31c48d;
  }
  .lg\\:focus\\:to-green-500:focus {
    --gradient-to-color: #0e9f6e;
  }
  .lg\\:focus\\:to-green-600:focus {
    --gradient-to-color: #057a55;
  }
  .lg\\:focus\\:to-green-700:focus {
    --gradient-to-color: #046c4e;
  }
  .lg\\:focus\\:to-green-800:focus {
    --gradient-to-color: #03543f;
  }
  .lg\\:focus\\:to-green-900:focus {
    --gradient-to-color: #014737;
  }
  .lg\\:focus\\:to-teal-50:focus {
    --gradient-to-color: #edfafa;
  }
  .lg\\:focus\\:to-teal-100:focus {
    --gradient-to-color: #d5f5f6;
  }
  .lg\\:focus\\:to-teal-200:focus {
    --gradient-to-color: #afecef;
  }
  .lg\\:focus\\:to-teal-300:focus {
    --gradient-to-color: #7edce2;
  }
  .lg\\:focus\\:to-teal-400:focus {
    --gradient-to-color: #16bdca;
  }
  .lg\\:focus\\:to-teal-500:focus {
    --gradient-to-color: #0694a2;
  }
  .lg\\:focus\\:to-teal-600:focus {
    --gradient-to-color: #047481;
  }
  .lg\\:focus\\:to-teal-700:focus {
    --gradient-to-color: #036672;
  }
  .lg\\:focus\\:to-teal-800:focus {
    --gradient-to-color: #05505c;
  }
  .lg\\:focus\\:to-teal-900:focus {
    --gradient-to-color: #014451;
  }
  .lg\\:focus\\:to-blue-50:focus {
    --gradient-to-color: #ebf5ff;
  }
  .lg\\:focus\\:to-blue-100:focus {
    --gradient-to-color: #e1effe;
  }
  .lg\\:focus\\:to-blue-200:focus {
    --gradient-to-color: #c3ddfd;
  }
  .lg\\:focus\\:to-blue-300:focus {
    --gradient-to-color: #a4cafe;
  }
  .lg\\:focus\\:to-blue-400:focus {
    --gradient-to-color: #76a9fa;
  }
  .lg\\:focus\\:to-blue-500:focus {
    --gradient-to-color: #3f83f8;
  }
  .lg\\:focus\\:to-blue-600:focus {
    --gradient-to-color: #1c64f2;
  }
  .lg\\:focus\\:to-blue-700:focus {
    --gradient-to-color: #1a56db;
  }
  .lg\\:focus\\:to-blue-800:focus {
    --gradient-to-color: #1e429f;
  }
  .lg\\:focus\\:to-blue-900:focus {
    --gradient-to-color: #233876;
  }
  .lg\\:focus\\:to-indigo-50:focus {
    --gradient-to-color: #f0f5ff;
  }
  .lg\\:focus\\:to-indigo-100:focus {
    --gradient-to-color: #e5edff;
  }
  .lg\\:focus\\:to-indigo-200:focus {
    --gradient-to-color: #cddbfe;
  }
  .lg\\:focus\\:to-indigo-300:focus {
    --gradient-to-color: #b4c6fc;
  }
  .lg\\:focus\\:to-indigo-400:focus {
    --gradient-to-color: #8da2fb;
  }
  .lg\\:focus\\:to-indigo-500:focus {
    --gradient-to-color: #6875f5;
  }
  .lg\\:focus\\:to-indigo-600:focus {
    --gradient-to-color: #5850ec;
  }
  .lg\\:focus\\:to-indigo-700:focus {
    --gradient-to-color: #5145cd;
  }
  .lg\\:focus\\:to-indigo-800:focus {
    --gradient-to-color: #42389d;
  }
  .lg\\:focus\\:to-indigo-900:focus {
    --gradient-to-color: #362f78;
  }
  .lg\\:focus\\:to-purple-50:focus {
    --gradient-to-color: #f6f5ff;
  }
  .lg\\:focus\\:to-purple-100:focus {
    --gradient-to-color: #edebfe;
  }
  .lg\\:focus\\:to-purple-200:focus {
    --gradient-to-color: #dcd7fe;
  }
  .lg\\:focus\\:to-purple-300:focus {
    --gradient-to-color: #cabffd;
  }
  .lg\\:focus\\:to-purple-400:focus {
    --gradient-to-color: #ac94fa;
  }
  .lg\\:focus\\:to-purple-500:focus {
    --gradient-to-color: #9061f9;
  }
  .lg\\:focus\\:to-purple-600:focus {
    --gradient-to-color: #7e3af2;
  }
  .lg\\:focus\\:to-purple-700:focus {
    --gradient-to-color: #6c2bd9;
  }
  .lg\\:focus\\:to-purple-800:focus {
    --gradient-to-color: #5521b5;
  }
  .lg\\:focus\\:to-purple-900:focus {
    --gradient-to-color: #4a1d96;
  }
  .lg\\:focus\\:to-pink-50:focus {
    --gradient-to-color: #fdf2f8;
  }
  .lg\\:focus\\:to-pink-100:focus {
    --gradient-to-color: #fce8f3;
  }
  .lg\\:focus\\:to-pink-200:focus {
    --gradient-to-color: #fad1e8;
  }
  .lg\\:focus\\:to-pink-300:focus {
    --gradient-to-color: #f8b4d9;
  }
  .lg\\:focus\\:to-pink-400:focus {
    --gradient-to-color: #f17eb8;
  }
  .lg\\:focus\\:to-pink-500:focus {
    --gradient-to-color: #e74694;
  }
  .lg\\:focus\\:to-pink-600:focus {
    --gradient-to-color: #d61f69;
  }
  .lg\\:focus\\:to-pink-700:focus {
    --gradient-to-color: #bf125d;
  }
  .lg\\:focus\\:to-pink-800:focus {
    --gradient-to-color: #99154b;
  }
  .lg\\:focus\\:to-pink-900:focus {
    --gradient-to-color: #751a3d;
  }
  .lg\\:focus\\:to-cool-gray-50:focus {
    --gradient-to-color: #f8fafc;
  }
  .lg\\:focus\\:to-cool-gray-100:focus {
    --gradient-to-color: #f1f5f9;
  }
  .lg\\:focus\\:to-cool-gray-200:focus {
    --gradient-to-color: #e2e8f0;
  }
  .lg\\:focus\\:to-cool-gray-300:focus {
    --gradient-to-color: #cfd8e3;
  }
  .lg\\:focus\\:to-cool-gray-400:focus {
    --gradient-to-color: #97a6ba;
  }
  .lg\\:focus\\:to-cool-gray-500:focus {
    --gradient-to-color: #64748b;
  }
  .lg\\:focus\\:to-cool-gray-600:focus {
    --gradient-to-color: #475569;
  }
  .lg\\:focus\\:to-cool-gray-700:focus {
    --gradient-to-color: #364152;
  }
  .lg\\:focus\\:to-cool-gray-800:focus {
    --gradient-to-color: #27303f;
  }
  .lg\\:focus\\:to-cool-gray-900:focus {
    --gradient-to-color: #1a202e;
  }
  .lg\\:bg-opacity-0 {
    --bg-opacity: 0;
  }
  .lg\\:bg-opacity-25 {
    --bg-opacity: 0.25;
  }
  .lg\\:bg-opacity-50 {
    --bg-opacity: 0.5;
  }
  .lg\\:bg-opacity-75 {
    --bg-opacity: 0.75;
  }
  .lg\\:bg-opacity-100 {
    --bg-opacity: 1;
  }
  .lg\\:hover\\:bg-opacity-0:hover {
    --bg-opacity: 0;
  }
  .lg\\:hover\\:bg-opacity-25:hover {
    --bg-opacity: 0.25;
  }
  .lg\\:hover\\:bg-opacity-50:hover {
    --bg-opacity: 0.5;
  }
  .lg\\:hover\\:bg-opacity-75:hover {
    --bg-opacity: 0.75;
  }
  .lg\\:hover\\:bg-opacity-100:hover {
    --bg-opacity: 1;
  }
  .lg\\:focus\\:bg-opacity-0:focus {
    --bg-opacity: 0;
  }
  .lg\\:focus\\:bg-opacity-25:focus {
    --bg-opacity: 0.25;
  }
  .lg\\:focus\\:bg-opacity-50:focus {
    --bg-opacity: 0.5;
  }
  .lg\\:focus\\:bg-opacity-75:focus {
    --bg-opacity: 0.75;
  }
  .lg\\:focus\\:bg-opacity-100:focus {
    --bg-opacity: 1;
  }
  .lg\\:bg-bottom {
    background-position: bottom;
  }
  .lg\\:bg-center {
    background-position: center;
  }
  .lg\\:bg-left {
    background-position: left;
  }
  .lg\\:bg-left-bottom {
    background-position: left bottom;
  }
  .lg\\:bg-left-top {
    background-position: left top;
  }
  .lg\\:bg-right {
    background-position: right;
  }
  .lg\\:bg-right-bottom {
    background-position: right bottom;
  }
  .lg\\:bg-right-top {
    background-position: right top;
  }
  .lg\\:bg-top {
    background-position: top;
  }
  .lg\\:bg-repeat {
    background-repeat: repeat;
  }
  .lg\\:bg-no-repeat {
    background-repeat: no-repeat;
  }
  .lg\\:bg-repeat-x {
    background-repeat: repeat-x;
  }
  .lg\\:bg-repeat-y {
    background-repeat: repeat-y;
  }
  .lg\\:bg-repeat-round {
    background-repeat: round;
  }
  .lg\\:bg-repeat-space {
    background-repeat: space;
  }
  .lg\\:bg-auto {
    background-size: auto;
  }
  .lg\\:bg-cover {
    background-size: cover;
  }
  .lg\\:bg-contain {
    background-size: contain;
  }
  .lg\\:border-collapse {
    border-collapse: collapse;
  }
  .lg\\:border-separate {
    border-collapse: separate;
  }
  .lg\\:border-current {
    border-color: currentColor;
  }
  .lg\\:border-transparent {
    border-color: transparent;
  }
  .lg\\:border-white {
    --border-opacity: 1;
    border-color: #ffffff;
    border-color: rgba(255, 255, 255, var(--border-opacity));
  }
  .lg\\:border-black {
    --border-opacity: 1;
    border-color: #000000;
    border-color: rgba(0, 0, 0, var(--border-opacity));
  }
  .lg\\:border-gray-50 {
    --border-opacity: 1;
    border-color: #f9fafb;
    border-color: rgba(249, 250, 251, var(--border-opacity));
  }
  .lg\\:border-gray-100 {
    --border-opacity: 1;
    border-color: #f4f5f7;
    border-color: rgba(244, 245, 247, var(--border-opacity));
  }
  .lg\\:border-gray-200 {
    --border-opacity: 1;
    border-color: #e5e7eb;
    border-color: rgba(229, 231, 235, var(--border-opacity));
  }
  .lg\\:border-gray-300 {
    --border-opacity: 1;
    border-color: #d2d6dc;
    border-color: rgba(210, 214, 220, var(--border-opacity));
  }
  .lg\\:border-gray-400 {
    --border-opacity: 1;
    border-color: #9fa6b2;
    border-color: rgba(159, 166, 178, var(--border-opacity));
  }
  .lg\\:border-gray-500 {
    --border-opacity: 1;
    border-color: #6b7280;
    border-color: rgba(107, 114, 128, var(--border-opacity));
  }
  .lg\\:border-gray-600 {
    --border-opacity: 1;
    border-color: #4b5563;
    border-color: rgba(75, 85, 99, var(--border-opacity));
  }
  .lg\\:border-gray-700 {
    --border-opacity: 1;
    border-color: #374151;
    border-color: rgba(55, 65, 81, var(--border-opacity));
  }
  .lg\\:border-gray-800 {
    --border-opacity: 1;
    border-color: #252f3f;
    border-color: rgba(37, 47, 63, var(--border-opacity));
  }
  .lg\\:border-gray-900 {
    --border-opacity: 1;
    border-color: #161e2e;
    border-color: rgba(22, 30, 46, var(--border-opacity));
  }
  .lg\\:border-red-50 {
    --border-opacity: 1;
    border-color: #fdf2f2;
    border-color: rgba(253, 242, 242, var(--border-opacity));
  }
  .lg\\:border-red-100 {
    --border-opacity: 1;
    border-color: #fde8e8;
    border-color: rgba(253, 232, 232, var(--border-opacity));
  }
  .lg\\:border-red-200 {
    --border-opacity: 1;
    border-color: #fbd5d5;
    border-color: rgba(251, 213, 213, var(--border-opacity));
  }
  .lg\\:border-red-300 {
    --border-opacity: 1;
    border-color: #f8b4b4;
    border-color: rgba(248, 180, 180, var(--border-opacity));
  }
  .lg\\:border-red-400 {
    --border-opacity: 1;
    border-color: #f98080;
    border-color: rgba(249, 128, 128, var(--border-opacity));
  }
  .lg\\:border-red-500 {
    --border-opacity: 1;
    border-color: #f05252;
    border-color: rgba(240, 82, 82, var(--border-opacity));
  }
  .lg\\:border-red-600 {
    --border-opacity: 1;
    border-color: #e02424;
    border-color: rgba(224, 36, 36, var(--border-opacity));
  }
  .lg\\:border-red-700 {
    --border-opacity: 1;
    border-color: #c81e1e;
    border-color: rgba(200, 30, 30, var(--border-opacity));
  }
  .lg\\:border-red-800 {
    --border-opacity: 1;
    border-color: #9b1c1c;
    border-color: rgba(155, 28, 28, var(--border-opacity));
  }
  .lg\\:border-red-900 {
    --border-opacity: 1;
    border-color: #771d1d;
    border-color: rgba(119, 29, 29, var(--border-opacity));
  }
  .lg\\:border-orange-50 {
    --border-opacity: 1;
    border-color: #fff8f1;
    border-color: rgba(255, 248, 241, var(--border-opacity));
  }
  .lg\\:border-orange-100 {
    --border-opacity: 1;
    border-color: #feecdc;
    border-color: rgba(254, 236, 220, var(--border-opacity));
  }
  .lg\\:border-orange-200 {
    --border-opacity: 1;
    border-color: #fcd9bd;
    border-color: rgba(252, 217, 189, var(--border-opacity));
  }
  .lg\\:border-orange-300 {
    --border-opacity: 1;
    border-color: #fdba8c;
    border-color: rgba(253, 186, 140, var(--border-opacity));
  }
  .lg\\:border-orange-400 {
    --border-opacity: 1;
    border-color: #ff8a4c;
    border-color: rgba(255, 138, 76, var(--border-opacity));
  }
  .lg\\:border-orange-500 {
    --border-opacity: 1;
    border-color: #ff5a1f;
    border-color: rgba(255, 90, 31, var(--border-opacity));
  }
  .lg\\:border-orange-600 {
    --border-opacity: 1;
    border-color: #d03801;
    border-color: rgba(208, 56, 1, var(--border-opacity));
  }
  .lg\\:border-orange-700 {
    --border-opacity: 1;
    border-color: #b43403;
    border-color: rgba(180, 52, 3, var(--border-opacity));
  }
  .lg\\:border-orange-800 {
    --border-opacity: 1;
    border-color: #8a2c0d;
    border-color: rgba(138, 44, 13, var(--border-opacity));
  }
  .lg\\:border-orange-900 {
    --border-opacity: 1;
    border-color: #73230d;
    border-color: rgba(115, 35, 13, var(--border-opacity));
  }
  .lg\\:border-yellow-50 {
    --border-opacity: 1;
    border-color: #fdfdea;
    border-color: rgba(253, 253, 234, var(--border-opacity));
  }
  .lg\\:border-yellow-100 {
    --border-opacity: 1;
    border-color: #fdf6b2;
    border-color: rgba(253, 246, 178, var(--border-opacity));
  }
  .lg\\:border-yellow-200 {
    --border-opacity: 1;
    border-color: #fce96a;
    border-color: rgba(252, 233, 106, var(--border-opacity));
  }
  .lg\\:border-yellow-300 {
    --border-opacity: 1;
    border-color: #faca15;
    border-color: rgba(250, 202, 21, var(--border-opacity));
  }
  .lg\\:border-yellow-400 {
    --border-opacity: 1;
    border-color: #e3a008;
    border-color: rgba(227, 160, 8, var(--border-opacity));
  }
  .lg\\:border-yellow-500 {
    --border-opacity: 1;
    border-color: #c27803;
    border-color: rgba(194, 120, 3, var(--border-opacity));
  }
  .lg\\:border-yellow-600 {
    --border-opacity: 1;
    border-color: #9f580a;
    border-color: rgba(159, 88, 10, var(--border-opacity));
  }
  .lg\\:border-yellow-700 {
    --border-opacity: 1;
    border-color: #8e4b10;
    border-color: rgba(142, 75, 16, var(--border-opacity));
  }
  .lg\\:border-yellow-800 {
    --border-opacity: 1;
    border-color: #723b13;
    border-color: rgba(114, 59, 19, var(--border-opacity));
  }
  .lg\\:border-yellow-900 {
    --border-opacity: 1;
    border-color: #633112;
    border-color: rgba(99, 49, 18, var(--border-opacity));
  }
  .lg\\:border-green-50 {
    --border-opacity: 1;
    border-color: #f3faf7;
    border-color: rgba(243, 250, 247, var(--border-opacity));
  }
  .lg\\:border-green-100 {
    --border-opacity: 1;
    border-color: #def7ec;
    border-color: rgba(222, 247, 236, var(--border-opacity));
  }
  .lg\\:border-green-200 {
    --border-opacity: 1;
    border-color: #bcf0da;
    border-color: rgba(188, 240, 218, var(--border-opacity));
  }
  .lg\\:border-green-300 {
    --border-opacity: 1;
    border-color: #84e1bc;
    border-color: rgba(132, 225, 188, var(--border-opacity));
  }
  .lg\\:border-green-400 {
    --border-opacity: 1;
    border-color: #31c48d;
    border-color: rgba(49, 196, 141, var(--border-opacity));
  }
  .lg\\:border-green-500 {
    --border-opacity: 1;
    border-color: #0e9f6e;
    border-color: rgba(14, 159, 110, var(--border-opacity));
  }
  .lg\\:border-green-600 {
    --border-opacity: 1;
    border-color: #057a55;
    border-color: rgba(5, 122, 85, var(--border-opacity));
  }
  .lg\\:border-green-700 {
    --border-opacity: 1;
    border-color: #046c4e;
    border-color: rgba(4, 108, 78, var(--border-opacity));
  }
  .lg\\:border-green-800 {
    --border-opacity: 1;
    border-color: #03543f;
    border-color: rgba(3, 84, 63, var(--border-opacity));
  }
  .lg\\:border-green-900 {
    --border-opacity: 1;
    border-color: #014737;
    border-color: rgba(1, 71, 55, var(--border-opacity));
  }
  .lg\\:border-teal-50 {
    --border-opacity: 1;
    border-color: #edfafa;
    border-color: rgba(237, 250, 250, var(--border-opacity));
  }
  .lg\\:border-teal-100 {
    --border-opacity: 1;
    border-color: #d5f5f6;
    border-color: rgba(213, 245, 246, var(--border-opacity));
  }
  .lg\\:border-teal-200 {
    --border-opacity: 1;
    border-color: #afecef;
    border-color: rgba(175, 236, 239, var(--border-opacity));
  }
  .lg\\:border-teal-300 {
    --border-opacity: 1;
    border-color: #7edce2;
    border-color: rgba(126, 220, 226, var(--border-opacity));
  }
  .lg\\:border-teal-400 {
    --border-opacity: 1;
    border-color: #16bdca;
    border-color: rgba(22, 189, 202, var(--border-opacity));
  }
  .lg\\:border-teal-500 {
    --border-opacity: 1;
    border-color: #0694a2;
    border-color: rgba(6, 148, 162, var(--border-opacity));
  }
  .lg\\:border-teal-600 {
    --border-opacity: 1;
    border-color: #047481;
    border-color: rgba(4, 116, 129, var(--border-opacity));
  }
  .lg\\:border-teal-700 {
    --border-opacity: 1;
    border-color: #036672;
    border-color: rgba(3, 102, 114, var(--border-opacity));
  }
  .lg\\:border-teal-800 {
    --border-opacity: 1;
    border-color: #05505c;
    border-color: rgba(5, 80, 92, var(--border-opacity));
  }
  .lg\\:border-teal-900 {
    --border-opacity: 1;
    border-color: #014451;
    border-color: rgba(1, 68, 81, var(--border-opacity));
  }
  .lg\\:border-blue-50 {
    --border-opacity: 1;
    border-color: #ebf5ff;
    border-color: rgba(235, 245, 255, var(--border-opacity));
  }
  .lg\\:border-blue-100 {
    --border-opacity: 1;
    border-color: #e1effe;
    border-color: rgba(225, 239, 254, var(--border-opacity));
  }
  .lg\\:border-blue-200 {
    --border-opacity: 1;
    border-color: #c3ddfd;
    border-color: rgba(195, 221, 253, var(--border-opacity));
  }
  .lg\\:border-blue-300 {
    --border-opacity: 1;
    border-color: #a4cafe;
    border-color: rgba(164, 202, 254, var(--border-opacity));
  }
  .lg\\:border-blue-400 {
    --border-opacity: 1;
    border-color: #76a9fa;
    border-color: rgba(118, 169, 250, var(--border-opacity));
  }
  .lg\\:border-blue-500 {
    --border-opacity: 1;
    border-color: #3f83f8;
    border-color: rgba(63, 131, 248, var(--border-opacity));
  }
  .lg\\:border-blue-600 {
    --border-opacity: 1;
    border-color: #1c64f2;
    border-color: rgba(28, 100, 242, var(--border-opacity));
  }
  .lg\\:border-blue-700 {
    --border-opacity: 1;
    border-color: #1a56db;
    border-color: rgba(26, 86, 219, var(--border-opacity));
  }
  .lg\\:border-blue-800 {
    --border-opacity: 1;
    border-color: #1e429f;
    border-color: rgba(30, 66, 159, var(--border-opacity));
  }
  .lg\\:border-blue-900 {
    --border-opacity: 1;
    border-color: #233876;
    border-color: rgba(35, 56, 118, var(--border-opacity));
  }
  .lg\\:border-indigo-50 {
    --border-opacity: 1;
    border-color: #f0f5ff;
    border-color: rgba(240, 245, 255, var(--border-opacity));
  }
  .lg\\:border-indigo-100 {
    --border-opacity: 1;
    border-color: #e5edff;
    border-color: rgba(229, 237, 255, var(--border-opacity));
  }
  .lg\\:border-indigo-200 {
    --border-opacity: 1;
    border-color: #cddbfe;
    border-color: rgba(205, 219, 254, var(--border-opacity));
  }
  .lg\\:border-indigo-300 {
    --border-opacity: 1;
    border-color: #b4c6fc;
    border-color: rgba(180, 198, 252, var(--border-opacity));
  }
  .lg\\:border-indigo-400 {
    --border-opacity: 1;
    border-color: #8da2fb;
    border-color: rgba(141, 162, 251, var(--border-opacity));
  }
  .lg\\:border-indigo-500 {
    --border-opacity: 1;
    border-color: #6875f5;
    border-color: rgba(104, 117, 245, var(--border-opacity));
  }
  .lg\\:border-indigo-600 {
    --border-opacity: 1;
    border-color: #5850ec;
    border-color: rgba(88, 80, 236, var(--border-opacity));
  }
  .lg\\:border-indigo-700 {
    --border-opacity: 1;
    border-color: #5145cd;
    border-color: rgba(81, 69, 205, var(--border-opacity));
  }
  .lg\\:border-indigo-800 {
    --border-opacity: 1;
    border-color: #42389d;
    border-color: rgba(66, 56, 157, var(--border-opacity));
  }
  .lg\\:border-indigo-900 {
    --border-opacity: 1;
    border-color: #362f78;
    border-color: rgba(54, 47, 120, var(--border-opacity));
  }
  .lg\\:border-purple-50 {
    --border-opacity: 1;
    border-color: #f6f5ff;
    border-color: rgba(246, 245, 255, var(--border-opacity));
  }
  .lg\\:border-purple-100 {
    --border-opacity: 1;
    border-color: #edebfe;
    border-color: rgba(237, 235, 254, var(--border-opacity));
  }
  .lg\\:border-purple-200 {
    --border-opacity: 1;
    border-color: #dcd7fe;
    border-color: rgba(220, 215, 254, var(--border-opacity));
  }
  .lg\\:border-purple-300 {
    --border-opacity: 1;
    border-color: #cabffd;
    border-color: rgba(202, 191, 253, var(--border-opacity));
  }
  .lg\\:border-purple-400 {
    --border-opacity: 1;
    border-color: #ac94fa;
    border-color: rgba(172, 148, 250, var(--border-opacity));
  }
  .lg\\:border-purple-500 {
    --border-opacity: 1;
    border-color: #9061f9;
    border-color: rgba(144, 97, 249, var(--border-opacity));
  }
  .lg\\:border-purple-600 {
    --border-opacity: 1;
    border-color: #7e3af2;
    border-color: rgba(126, 58, 242, var(--border-opacity));
  }
  .lg\\:border-purple-700 {
    --border-opacity: 1;
    border-color: #6c2bd9;
    border-color: rgba(108, 43, 217, var(--border-opacity));
  }
  .lg\\:border-purple-800 {
    --border-opacity: 1;
    border-color: #5521b5;
    border-color: rgba(85, 33, 181, var(--border-opacity));
  }
  .lg\\:border-purple-900 {
    --border-opacity: 1;
    border-color: #4a1d96;
    border-color: rgba(74, 29, 150, var(--border-opacity));
  }
  .lg\\:border-pink-50 {
    --border-opacity: 1;
    border-color: #fdf2f8;
    border-color: rgba(253, 242, 248, var(--border-opacity));
  }
  .lg\\:border-pink-100 {
    --border-opacity: 1;
    border-color: #fce8f3;
    border-color: rgba(252, 232, 243, var(--border-opacity));
  }
  .lg\\:border-pink-200 {
    --border-opacity: 1;
    border-color: #fad1e8;
    border-color: rgba(250, 209, 232, var(--border-opacity));
  }
  .lg\\:border-pink-300 {
    --border-opacity: 1;
    border-color: #f8b4d9;
    border-color: rgba(248, 180, 217, var(--border-opacity));
  }
  .lg\\:border-pink-400 {
    --border-opacity: 1;
    border-color: #f17eb8;
    border-color: rgba(241, 126, 184, var(--border-opacity));
  }
  .lg\\:border-pink-500 {
    --border-opacity: 1;
    border-color: #e74694;
    border-color: rgba(231, 70, 148, var(--border-opacity));
  }
  .lg\\:border-pink-600 {
    --border-opacity: 1;
    border-color: #d61f69;
    border-color: rgba(214, 31, 105, var(--border-opacity));
  }
  .lg\\:border-pink-700 {
    --border-opacity: 1;
    border-color: #bf125d;
    border-color: rgba(191, 18, 93, var(--border-opacity));
  }
  .lg\\:border-pink-800 {
    --border-opacity: 1;
    border-color: #99154b;
    border-color: rgba(153, 21, 75, var(--border-opacity));
  }
  .lg\\:border-pink-900 {
    --border-opacity: 1;
    border-color: #751a3d;
    border-color: rgba(117, 26, 61, var(--border-opacity));
  }
  .lg\\:border-cool-gray-50 {
    --border-opacity: 1;
    border-color: #f8fafc;
    border-color: rgba(248, 250, 252, var(--border-opacity));
  }
  .lg\\:border-cool-gray-100 {
    --border-opacity: 1;
    border-color: #f1f5f9;
    border-color: rgba(241, 245, 249, var(--border-opacity));
  }
  .lg\\:border-cool-gray-200 {
    --border-opacity: 1;
    border-color: #e2e8f0;
    border-color: rgba(226, 232, 240, var(--border-opacity));
  }
  .lg\\:border-cool-gray-300 {
    --border-opacity: 1;
    border-color: #cfd8e3;
    border-color: rgba(207, 216, 227, var(--border-opacity));
  }
  .lg\\:border-cool-gray-400 {
    --border-opacity: 1;
    border-color: #97a6ba;
    border-color: rgba(151, 166, 186, var(--border-opacity));
  }
  .lg\\:border-cool-gray-500 {
    --border-opacity: 1;
    border-color: #64748b;
    border-color: rgba(100, 116, 139, var(--border-opacity));
  }
  .lg\\:border-cool-gray-600 {
    --border-opacity: 1;
    border-color: #475569;
    border-color: rgba(71, 85, 105, var(--border-opacity));
  }
  .lg\\:border-cool-gray-700 {
    --border-opacity: 1;
    border-color: #364152;
    border-color: rgba(54, 65, 82, var(--border-opacity));
  }
  .lg\\:border-cool-gray-800 {
    --border-opacity: 1;
    border-color: #27303f;
    border-color: rgba(39, 48, 63, var(--border-opacity));
  }
  .lg\\:border-cool-gray-900 {
    --border-opacity: 1;
    border-color: #1a202e;
    border-color: rgba(26, 32, 46, var(--border-opacity));
  }
  .group:hover .lg\\:group-hover\\:border-current {
    border-color: currentColor;
  }
  .group:hover .lg\\:group-hover\\:border-transparent {
    border-color: transparent;
  }
  .group:hover .lg\\:group-hover\\:border-white {
    --border-opacity: 1;
    border-color: #ffffff;
    border-color: rgba(255, 255, 255, var(--border-opacity));
  }
  .group:hover .lg\\:group-hover\\:border-black {
    --border-opacity: 1;
    border-color: #000000;
    border-color: rgba(0, 0, 0, var(--border-opacity));
  }
  .group:hover .lg\\:group-hover\\:border-gray-50 {
    --border-opacity: 1;
    border-color: #f9fafb;
    border-color: rgba(249, 250, 251, var(--border-opacity));
  }
  .group:hover .lg\\:group-hover\\:border-gray-100 {
    --border-opacity: 1;
    border-color: #f4f5f7;
    border-color: rgba(244, 245, 247, var(--border-opacity));
  }
  .group:hover .lg\\:group-hover\\:border-gray-200 {
    --border-opacity: 1;
    border-color: #e5e7eb;
    border-color: rgba(229, 231, 235, var(--border-opacity));
  }
  .group:hover .lg\\:group-hover\\:border-gray-300 {
    --border-opacity: 1;
    border-color: #d2d6dc;
    border-color: rgba(210, 214, 220, var(--border-opacity));
  }
  .group:hover .lg\\:group-hover\\:border-gray-400 {
    --border-opacity: 1;
    border-color: #9fa6b2;
    border-color: rgba(159, 166, 178, var(--border-opacity));
  }
  .group:hover .lg\\:group-hover\\:border-gray-500 {
    --border-opacity: 1;
    border-color: #6b7280;
    border-color: rgba(107, 114, 128, var(--border-opacity));
  }
  .group:hover .lg\\:group-hover\\:border-gray-600 {
    --border-opacity: 1;
    border-color: #4b5563;
    border-color: rgba(75, 85, 99, var(--border-opacity));
  }
  .group:hover .lg\\:group-hover\\:border-gray-700 {
    --border-opacity: 1;
    border-color: #374151;
    border-color: rgba(55, 65, 81, var(--border-opacity));
  }
  .group:hover .lg\\:group-hover\\:border-gray-800 {
    --border-opacity: 1;
    border-color: #252f3f;
    border-color: rgba(37, 47, 63, var(--border-opacity));
  }
  .group:hover .lg\\:group-hover\\:border-gray-900 {
    --border-opacity: 1;
    border-color: #161e2e;
    border-color: rgba(22, 30, 46, var(--border-opacity));
  }
  .group:hover .lg\\:group-hover\\:border-red-50 {
    --border-opacity: 1;
    border-color: #fdf2f2;
    border-color: rgba(253, 242, 242, var(--border-opacity));
  }
  .group:hover .lg\\:group-hover\\:border-red-100 {
    --border-opacity: 1;
    border-color: #fde8e8;
    border-color: rgba(253, 232, 232, var(--border-opacity));
  }
  .group:hover .lg\\:group-hover\\:border-red-200 {
    --border-opacity: 1;
    border-color: #fbd5d5;
    border-color: rgba(251, 213, 213, var(--border-opacity));
  }
  .group:hover .lg\\:group-hover\\:border-red-300 {
    --border-opacity: 1;
    border-color: #f8b4b4;
    border-color: rgba(248, 180, 180, var(--border-opacity));
  }
  .group:hover .lg\\:group-hover\\:border-red-400 {
    --border-opacity: 1;
    border-color: #f98080;
    border-color: rgba(249, 128, 128, var(--border-opacity));
  }
  .group:hover .lg\\:group-hover\\:border-red-500 {
    --border-opacity: 1;
    border-color: #f05252;
    border-color: rgba(240, 82, 82, var(--border-opacity));
  }
  .group:hover .lg\\:group-hover\\:border-red-600 {
    --border-opacity: 1;
    border-color: #e02424;
    border-color: rgba(224, 36, 36, var(--border-opacity));
  }
  .group:hover .lg\\:group-hover\\:border-red-700 {
    --border-opacity: 1;
    border-color: #c81e1e;
    border-color: rgba(200, 30, 30, var(--border-opacity));
  }
  .group:hover .lg\\:group-hover\\:border-red-800 {
    --border-opacity: 1;
    border-color: #9b1c1c;
    border-color: rgba(155, 28, 28, var(--border-opacity));
  }
  .group:hover .lg\\:group-hover\\:border-red-900 {
    --border-opacity: 1;
    border-color: #771d1d;
    border-color: rgba(119, 29, 29, var(--border-opacity));
  }
  .group:hover .lg\\:group-hover\\:border-orange-50 {
    --border-opacity: 1;
    border-color: #fff8f1;
    border-color: rgba(255, 248, 241, var(--border-opacity));
  }
  .group:hover .lg\\:group-hover\\:border-orange-100 {
    --border-opacity: 1;
    border-color: #feecdc;
    border-color: rgba(254, 236, 220, var(--border-opacity));
  }
  .group:hover .lg\\:group-hover\\:border-orange-200 {
    --border-opacity: 1;
    border-color: #fcd9bd;
    border-color: rgba(252, 217, 189, var(--border-opacity));
  }
  .group:hover .lg\\:group-hover\\:border-orange-300 {
    --border-opacity: 1;
    border-color: #fdba8c;
    border-color: rgba(253, 186, 140, var(--border-opacity));
  }
  .group:hover .lg\\:group-hover\\:border-orange-400 {
    --border-opacity: 1;
    border-color: #ff8a4c;
    border-color: rgba(255, 138, 76, var(--border-opacity));
  }
  .group:hover .lg\\:group-hover\\:border-orange-500 {
    --border-opacity: 1;
    border-color: #ff5a1f;
    border-color: rgba(255, 90, 31, var(--border-opacity));
  }
  .group:hover .lg\\:group-hover\\:border-orange-600 {
    --border-opacity: 1;
    border-color: #d03801;
    border-color: rgba(208, 56, 1, var(--border-opacity));
  }
  .group:hover .lg\\:group-hover\\:border-orange-700 {
    --border-opacity: 1;
    border-color: #b43403;
    border-color: rgba(180, 52, 3, var(--border-opacity));
  }
  .group:hover .lg\\:group-hover\\:border-orange-800 {
    --border-opacity: 1;
    border-color: #8a2c0d;
    border-color: rgba(138, 44, 13, var(--border-opacity));
  }
  .group:hover .lg\\:group-hover\\:border-orange-900 {
    --border-opacity: 1;
    border-color: #73230d;
    border-color: rgba(115, 35, 13, var(--border-opacity));
  }
  .group:hover .lg\\:group-hover\\:border-yellow-50 {
    --border-opacity: 1;
    border-color: #fdfdea;
    border-color: rgba(253, 253, 234, var(--border-opacity));
  }
  .group:hover .lg\\:group-hover\\:border-yellow-100 {
    --border-opacity: 1;
    border-color: #fdf6b2;
    border-color: rgba(253, 246, 178, var(--border-opacity));
  }
  .group:hover .lg\\:group-hover\\:border-yellow-200 {
    --border-opacity: 1;
    border-color: #fce96a;
    border-color: rgba(252, 233, 106, var(--border-opacity));
  }
  .group:hover .lg\\:group-hover\\:border-yellow-300 {
    --border-opacity: 1;
    border-color: #faca15;
    border-color: rgba(250, 202, 21, var(--border-opacity));
  }
  .group:hover .lg\\:group-hover\\:border-yellow-400 {
    --border-opacity: 1;
    border-color: #e3a008;
    border-color: rgba(227, 160, 8, var(--border-opacity));
  }
  .group:hover .lg\\:group-hover\\:border-yellow-500 {
    --border-opacity: 1;
    border-color: #c27803;
    border-color: rgba(194, 120, 3, var(--border-opacity));
  }
  .group:hover .lg\\:group-hover\\:border-yellow-600 {
    --border-opacity: 1;
    border-color: #9f580a;
    border-color: rgba(159, 88, 10, var(--border-opacity));
  }
  .group:hover .lg\\:group-hover\\:border-yellow-700 {
    --border-opacity: 1;
    border-color: #8e4b10;
    border-color: rgba(142, 75, 16, var(--border-opacity));
  }
  .group:hover .lg\\:group-hover\\:border-yellow-800 {
    --border-opacity: 1;
    border-color: #723b13;
    border-color: rgba(114, 59, 19, var(--border-opacity));
  }
  .group:hover .lg\\:group-hover\\:border-yellow-900 {
    --border-opacity: 1;
    border-color: #633112;
    border-color: rgba(99, 49, 18, var(--border-opacity));
  }
  .group:hover .lg\\:group-hover\\:border-green-50 {
    --border-opacity: 1;
    border-color: #f3faf7;
    border-color: rgba(243, 250, 247, var(--border-opacity));
  }
  .group:hover .lg\\:group-hover\\:border-green-100 {
    --border-opacity: 1;
    border-color: #def7ec;
    border-color: rgba(222, 247, 236, var(--border-opacity));
  }
  .group:hover .lg\\:group-hover\\:border-green-200 {
    --border-opacity: 1;
    border-color: #bcf0da;
    border-color: rgba(188, 240, 218, var(--border-opacity));
  }
  .group:hover .lg\\:group-hover\\:border-green-300 {
    --border-opacity: 1;
    border-color: #84e1bc;
    border-color: rgba(132, 225, 188, var(--border-opacity));
  }
  .group:hover .lg\\:group-hover\\:border-green-400 {
    --border-opacity: 1;
    border-color: #31c48d;
    border-color: rgba(49, 196, 141, var(--border-opacity));
  }
  .group:hover .lg\\:group-hover\\:border-green-500 {
    --border-opacity: 1;
    border-color: #0e9f6e;
    border-color: rgba(14, 159, 110, var(--border-opacity));
  }
  .group:hover .lg\\:group-hover\\:border-green-600 {
    --border-opacity: 1;
    border-color: #057a55;
    border-color: rgba(5, 122, 85, var(--border-opacity));
  }
  .group:hover .lg\\:group-hover\\:border-green-700 {
    --border-opacity: 1;
    border-color: #046c4e;
    border-color: rgba(4, 108, 78, var(--border-opacity));
  }
  .group:hover .lg\\:group-hover\\:border-green-800 {
    --border-opacity: 1;
    border-color: #03543f;
    border-color: rgba(3, 84, 63, var(--border-opacity));
  }
  .group:hover .lg\\:group-hover\\:border-green-900 {
    --border-opacity: 1;
    border-color: #014737;
    border-color: rgba(1, 71, 55, var(--border-opacity));
  }
  .group:hover .lg\\:group-hover\\:border-teal-50 {
    --border-opacity: 1;
    border-color: #edfafa;
    border-color: rgba(237, 250, 250, var(--border-opacity));
  }
  .group:hover .lg\\:group-hover\\:border-teal-100 {
    --border-opacity: 1;
    border-color: #d5f5f6;
    border-color: rgba(213, 245, 246, var(--border-opacity));
  }
  .group:hover .lg\\:group-hover\\:border-teal-200 {
    --border-opacity: 1;
    border-color: #afecef;
    border-color: rgba(175, 236, 239, var(--border-opacity));
  }
  .group:hover .lg\\:group-hover\\:border-teal-300 {
    --border-opacity: 1;
    border-color: #7edce2;
    border-color: rgba(126, 220, 226, var(--border-opacity));
  }
  .group:hover .lg\\:group-hover\\:border-teal-400 {
    --border-opacity: 1;
    border-color: #16bdca;
    border-color: rgba(22, 189, 202, var(--border-opacity));
  }
  .group:hover .lg\\:group-hover\\:border-teal-500 {
    --border-opacity: 1;
    border-color: #0694a2;
    border-color: rgba(6, 148, 162, var(--border-opacity));
  }
  .group:hover .lg\\:group-hover\\:border-teal-600 {
    --border-opacity: 1;
    border-color: #047481;
    border-color: rgba(4, 116, 129, var(--border-opacity));
  }
  .group:hover .lg\\:group-hover\\:border-teal-700 {
    --border-opacity: 1;
    border-color: #036672;
    border-color: rgba(3, 102, 114, var(--border-opacity));
  }
  .group:hover .lg\\:group-hover\\:border-teal-800 {
    --border-opacity: 1;
    border-color: #05505c;
    border-color: rgba(5, 80, 92, var(--border-opacity));
  }
  .group:hover .lg\\:group-hover\\:border-teal-900 {
    --border-opacity: 1;
    border-color: #014451;
    border-color: rgba(1, 68, 81, var(--border-opacity));
  }
  .group:hover .lg\\:group-hover\\:border-blue-50 {
    --border-opacity: 1;
    border-color: #ebf5ff;
    border-color: rgba(235, 245, 255, var(--border-opacity));
  }
  .group:hover .lg\\:group-hover\\:border-blue-100 {
    --border-opacity: 1;
    border-color: #e1effe;
    border-color: rgba(225, 239, 254, var(--border-opacity));
  }
  .group:hover .lg\\:group-hover\\:border-blue-200 {
    --border-opacity: 1;
    border-color: #c3ddfd;
    border-color: rgba(195, 221, 253, var(--border-opacity));
  }
  .group:hover .lg\\:group-hover\\:border-blue-300 {
    --border-opacity: 1;
    border-color: #a4cafe;
    border-color: rgba(164, 202, 254, var(--border-opacity));
  }
  .group:hover .lg\\:group-hover\\:border-blue-400 {
    --border-opacity: 1;
    border-color: #76a9fa;
    border-color: rgba(118, 169, 250, var(--border-opacity));
  }
  .group:hover .lg\\:group-hover\\:border-blue-500 {
    --border-opacity: 1;
    border-color: #3f83f8;
    border-color: rgba(63, 131, 248, var(--border-opacity));
  }
  .group:hover .lg\\:group-hover\\:border-blue-600 {
    --border-opacity: 1;
    border-color: #1c64f2;
    border-color: rgba(28, 100, 242, var(--border-opacity));
  }
  .group:hover .lg\\:group-hover\\:border-blue-700 {
    --border-opacity: 1;
    border-color: #1a56db;
    border-color: rgba(26, 86, 219, var(--border-opacity));
  }
  .group:hover .lg\\:group-hover\\:border-blue-800 {
    --border-opacity: 1;
    border-color: #1e429f;
    border-color: rgba(30, 66, 159, var(--border-opacity));
  }
  .group:hover .lg\\:group-hover\\:border-blue-900 {
    --border-opacity: 1;
    border-color: #233876;
    border-color: rgba(35, 56, 118, var(--border-opacity));
  }
  .group:hover .lg\\:group-hover\\:border-indigo-50 {
    --border-opacity: 1;
    border-color: #f0f5ff;
    border-color: rgba(240, 245, 255, var(--border-opacity));
  }
  .group:hover .lg\\:group-hover\\:border-indigo-100 {
    --border-opacity: 1;
    border-color: #e5edff;
    border-color: rgba(229, 237, 255, var(--border-opacity));
  }
  .group:hover .lg\\:group-hover\\:border-indigo-200 {
    --border-opacity: 1;
    border-color: #cddbfe;
    border-color: rgba(205, 219, 254, var(--border-opacity));
  }
  .group:hover .lg\\:group-hover\\:border-indigo-300 {
    --border-opacity: 1;
    border-color: #b4c6fc;
    border-color: rgba(180, 198, 252, var(--border-opacity));
  }
  .group:hover .lg\\:group-hover\\:border-indigo-400 {
    --border-opacity: 1;
    border-color: #8da2fb;
    border-color: rgba(141, 162, 251, var(--border-opacity));
  }
  .group:hover .lg\\:group-hover\\:border-indigo-500 {
    --border-opacity: 1;
    border-color: #6875f5;
    border-color: rgba(104, 117, 245, var(--border-opacity));
  }
  .group:hover .lg\\:group-hover\\:border-indigo-600 {
    --border-opacity: 1;
    border-color: #5850ec;
    border-color: rgba(88, 80, 236, var(--border-opacity));
  }
  .group:hover .lg\\:group-hover\\:border-indigo-700 {
    --border-opacity: 1;
    border-color: #5145cd;
    border-color: rgba(81, 69, 205, var(--border-opacity));
  }
  .group:hover .lg\\:group-hover\\:border-indigo-800 {
    --border-opacity: 1;
    border-color: #42389d;
    border-color: rgba(66, 56, 157, var(--border-opacity));
  }
  .group:hover .lg\\:group-hover\\:border-indigo-900 {
    --border-opacity: 1;
    border-color: #362f78;
    border-color: rgba(54, 47, 120, var(--border-opacity));
  }
  .group:hover .lg\\:group-hover\\:border-purple-50 {
    --border-opacity: 1;
    border-color: #f6f5ff;
    border-color: rgba(246, 245, 255, var(--border-opacity));
  }
  .group:hover .lg\\:group-hover\\:border-purple-100 {
    --border-opacity: 1;
    border-color: #edebfe;
    border-color: rgba(237, 235, 254, var(--border-opacity));
  }
  .group:hover .lg\\:group-hover\\:border-purple-200 {
    --border-opacity: 1;
    border-color: #dcd7fe;
    border-color: rgba(220, 215, 254, var(--border-opacity));
  }
  .group:hover .lg\\:group-hover\\:border-purple-300 {
    --border-opacity: 1;
    border-color: #cabffd;
    border-color: rgba(202, 191, 253, var(--border-opacity));
  }
  .group:hover .lg\\:group-hover\\:border-purple-400 {
    --border-opacity: 1;
    border-color: #ac94fa;
    border-color: rgba(172, 148, 250, var(--border-opacity));
  }
  .group:hover .lg\\:group-hover\\:border-purple-500 {
    --border-opacity: 1;
    border-color: #9061f9;
    border-color: rgba(144, 97, 249, var(--border-opacity));
  }
  .group:hover .lg\\:group-hover\\:border-purple-600 {
    --border-opacity: 1;
    border-color: #7e3af2;
    border-color: rgba(126, 58, 242, var(--border-opacity));
  }
  .group:hover .lg\\:group-hover\\:border-purple-700 {
    --border-opacity: 1;
    border-color: #6c2bd9;
    border-color: rgba(108, 43, 217, var(--border-opacity));
  }
  .group:hover .lg\\:group-hover\\:border-purple-800 {
    --border-opacity: 1;
    border-color: #5521b5;
    border-color: rgba(85, 33, 181, var(--border-opacity));
  }
  .group:hover .lg\\:group-hover\\:border-purple-900 {
    --border-opacity: 1;
    border-color: #4a1d96;
    border-color: rgba(74, 29, 150, var(--border-opacity));
  }
  .group:hover .lg\\:group-hover\\:border-pink-50 {
    --border-opacity: 1;
    border-color: #fdf2f8;
    border-color: rgba(253, 242, 248, var(--border-opacity));
  }
  .group:hover .lg\\:group-hover\\:border-pink-100 {
    --border-opacity: 1;
    border-color: #fce8f3;
    border-color: rgba(252, 232, 243, var(--border-opacity));
  }
  .group:hover .lg\\:group-hover\\:border-pink-200 {
    --border-opacity: 1;
    border-color: #fad1e8;
    border-color: rgba(250, 209, 232, var(--border-opacity));
  }
  .group:hover .lg\\:group-hover\\:border-pink-300 {
    --border-opacity: 1;
    border-color: #f8b4d9;
    border-color: rgba(248, 180, 217, var(--border-opacity));
  }
  .group:hover .lg\\:group-hover\\:border-pink-400 {
    --border-opacity: 1;
    border-color: #f17eb8;
    border-color: rgba(241, 126, 184, var(--border-opacity));
  }
  .group:hover .lg\\:group-hover\\:border-pink-500 {
    --border-opacity: 1;
    border-color: #e74694;
    border-color: rgba(231, 70, 148, var(--border-opacity));
  }
  .group:hover .lg\\:group-hover\\:border-pink-600 {
    --border-opacity: 1;
    border-color: #d61f69;
    border-color: rgba(214, 31, 105, var(--border-opacity));
  }
  .group:hover .lg\\:group-hover\\:border-pink-700 {
    --border-opacity: 1;
    border-color: #bf125d;
    border-color: rgba(191, 18, 93, var(--border-opacity));
  }
  .group:hover .lg\\:group-hover\\:border-pink-800 {
    --border-opacity: 1;
    border-color: #99154b;
    border-color: rgba(153, 21, 75, var(--border-opacity));
  }
  .group:hover .lg\\:group-hover\\:border-pink-900 {
    --border-opacity: 1;
    border-color: #751a3d;
    border-color: rgba(117, 26, 61, var(--border-opacity));
  }
  .group:hover .lg\\:group-hover\\:border-cool-gray-50 {
    --border-opacity: 1;
    border-color: #f8fafc;
    border-color: rgba(248, 250, 252, var(--border-opacity));
  }
  .group:hover .lg\\:group-hover\\:border-cool-gray-100 {
    --border-opacity: 1;
    border-color: #f1f5f9;
    border-color: rgba(241, 245, 249, var(--border-opacity));
  }
  .group:hover .lg\\:group-hover\\:border-cool-gray-200 {
    --border-opacity: 1;
    border-color: #e2e8f0;
    border-color: rgba(226, 232, 240, var(--border-opacity));
  }
  .group:hover .lg\\:group-hover\\:border-cool-gray-300 {
    --border-opacity: 1;
    border-color: #cfd8e3;
    border-color: rgba(207, 216, 227, var(--border-opacity));
  }
  .group:hover .lg\\:group-hover\\:border-cool-gray-400 {
    --border-opacity: 1;
    border-color: #97a6ba;
    border-color: rgba(151, 166, 186, var(--border-opacity));
  }
  .group:hover .lg\\:group-hover\\:border-cool-gray-500 {
    --border-opacity: 1;
    border-color: #64748b;
    border-color: rgba(100, 116, 139, var(--border-opacity));
  }
  .group:hover .lg\\:group-hover\\:border-cool-gray-600 {
    --border-opacity: 1;
    border-color: #475569;
    border-color: rgba(71, 85, 105, var(--border-opacity));
  }
  .group:hover .lg\\:group-hover\\:border-cool-gray-700 {
    --border-opacity: 1;
    border-color: #364152;
    border-color: rgba(54, 65, 82, var(--border-opacity));
  }
  .group:hover .lg\\:group-hover\\:border-cool-gray-800 {
    --border-opacity: 1;
    border-color: #27303f;
    border-color: rgba(39, 48, 63, var(--border-opacity));
  }
  .group:hover .lg\\:group-hover\\:border-cool-gray-900 {
    --border-opacity: 1;
    border-color: #1a202e;
    border-color: rgba(26, 32, 46, var(--border-opacity));
  }
  .group:focus .lg\\:group-focus\\:border-current {
    border-color: currentColor;
  }
  .group:focus .lg\\:group-focus\\:border-transparent {
    border-color: transparent;
  }
  .group:focus .lg\\:group-focus\\:border-white {
    --border-opacity: 1;
    border-color: #ffffff;
    border-color: rgba(255, 255, 255, var(--border-opacity));
  }
  .group:focus .lg\\:group-focus\\:border-black {
    --border-opacity: 1;
    border-color: #000000;
    border-color: rgba(0, 0, 0, var(--border-opacity));
  }
  .group:focus .lg\\:group-focus\\:border-gray-50 {
    --border-opacity: 1;
    border-color: #f9fafb;
    border-color: rgba(249, 250, 251, var(--border-opacity));
  }
  .group:focus .lg\\:group-focus\\:border-gray-100 {
    --border-opacity: 1;
    border-color: #f4f5f7;
    border-color: rgba(244, 245, 247, var(--border-opacity));
  }
  .group:focus .lg\\:group-focus\\:border-gray-200 {
    --border-opacity: 1;
    border-color: #e5e7eb;
    border-color: rgba(229, 231, 235, var(--border-opacity));
  }
  .group:focus .lg\\:group-focus\\:border-gray-300 {
    --border-opacity: 1;
    border-color: #d2d6dc;
    border-color: rgba(210, 214, 220, var(--border-opacity));
  }
  .group:focus .lg\\:group-focus\\:border-gray-400 {
    --border-opacity: 1;
    border-color: #9fa6b2;
    border-color: rgba(159, 166, 178, var(--border-opacity));
  }
  .group:focus .lg\\:group-focus\\:border-gray-500 {
    --border-opacity: 1;
    border-color: #6b7280;
    border-color: rgba(107, 114, 128, var(--border-opacity));
  }
  .group:focus .lg\\:group-focus\\:border-gray-600 {
    --border-opacity: 1;
    border-color: #4b5563;
    border-color: rgba(75, 85, 99, var(--border-opacity));
  }
  .group:focus .lg\\:group-focus\\:border-gray-700 {
    --border-opacity: 1;
    border-color: #374151;
    border-color: rgba(55, 65, 81, var(--border-opacity));
  }
  .group:focus .lg\\:group-focus\\:border-gray-800 {
    --border-opacity: 1;
    border-color: #252f3f;
    border-color: rgba(37, 47, 63, var(--border-opacity));
  }
  .group:focus .lg\\:group-focus\\:border-gray-900 {
    --border-opacity: 1;
    border-color: #161e2e;
    border-color: rgba(22, 30, 46, var(--border-opacity));
  }
  .group:focus .lg\\:group-focus\\:border-red-50 {
    --border-opacity: 1;
    border-color: #fdf2f2;
    border-color: rgba(253, 242, 242, var(--border-opacity));
  }
  .group:focus .lg\\:group-focus\\:border-red-100 {
    --border-opacity: 1;
    border-color: #fde8e8;
    border-color: rgba(253, 232, 232, var(--border-opacity));
  }
  .group:focus .lg\\:group-focus\\:border-red-200 {
    --border-opacity: 1;
    border-color: #fbd5d5;
    border-color: rgba(251, 213, 213, var(--border-opacity));
  }
  .group:focus .lg\\:group-focus\\:border-red-300 {
    --border-opacity: 1;
    border-color: #f8b4b4;
    border-color: rgba(248, 180, 180, var(--border-opacity));
  }
  .group:focus .lg\\:group-focus\\:border-red-400 {
    --border-opacity: 1;
    border-color: #f98080;
    border-color: rgba(249, 128, 128, var(--border-opacity));
  }
  .group:focus .lg\\:group-focus\\:border-red-500 {
    --border-opacity: 1;
    border-color: #f05252;
    border-color: rgba(240, 82, 82, var(--border-opacity));
  }
  .group:focus .lg\\:group-focus\\:border-red-600 {
    --border-opacity: 1;
    border-color: #e02424;
    border-color: rgba(224, 36, 36, var(--border-opacity));
  }
  .group:focus .lg\\:group-focus\\:border-red-700 {
    --border-opacity: 1;
    border-color: #c81e1e;
    border-color: rgba(200, 30, 30, var(--border-opacity));
  }
  .group:focus .lg\\:group-focus\\:border-red-800 {
    --border-opacity: 1;
    border-color: #9b1c1c;
    border-color: rgba(155, 28, 28, var(--border-opacity));
  }
  .group:focus .lg\\:group-focus\\:border-red-900 {
    --border-opacity: 1;
    border-color: #771d1d;
    border-color: rgba(119, 29, 29, var(--border-opacity));
  }
  .group:focus .lg\\:group-focus\\:border-orange-50 {
    --border-opacity: 1;
    border-color: #fff8f1;
    border-color: rgba(255, 248, 241, var(--border-opacity));
  }
  .group:focus .lg\\:group-focus\\:border-orange-100 {
    --border-opacity: 1;
    border-color: #feecdc;
    border-color: rgba(254, 236, 220, var(--border-opacity));
  }
  .group:focus .lg\\:group-focus\\:border-orange-200 {
    --border-opacity: 1;
    border-color: #fcd9bd;
    border-color: rgba(252, 217, 189, var(--border-opacity));
  }
  .group:focus .lg\\:group-focus\\:border-orange-300 {
    --border-opacity: 1;
    border-color: #fdba8c;
    border-color: rgba(253, 186, 140, var(--border-opacity));
  }
  .group:focus .lg\\:group-focus\\:border-orange-400 {
    --border-opacity: 1;
    border-color: #ff8a4c;
    border-color: rgba(255, 138, 76, var(--border-opacity));
  }
  .group:focus .lg\\:group-focus\\:border-orange-500 {
    --border-opacity: 1;
    border-color: #ff5a1f;
    border-color: rgba(255, 90, 31, var(--border-opacity));
  }
  .group:focus .lg\\:group-focus\\:border-orange-600 {
    --border-opacity: 1;
    border-color: #d03801;
    border-color: rgba(208, 56, 1, var(--border-opacity));
  }
  .group:focus .lg\\:group-focus\\:border-orange-700 {
    --border-opacity: 1;
    border-color: #b43403;
    border-color: rgba(180, 52, 3, var(--border-opacity));
  }
  .group:focus .lg\\:group-focus\\:border-orange-800 {
    --border-opacity: 1;
    border-color: #8a2c0d;
    border-color: rgba(138, 44, 13, var(--border-opacity));
  }
  .group:focus .lg\\:group-focus\\:border-orange-900 {
    --border-opacity: 1;
    border-color: #73230d;
    border-color: rgba(115, 35, 13, var(--border-opacity));
  }
  .group:focus .lg\\:group-focus\\:border-yellow-50 {
    --border-opacity: 1;
    border-color: #fdfdea;
    border-color: rgba(253, 253, 234, var(--border-opacity));
  }
  .group:focus .lg\\:group-focus\\:border-yellow-100 {
    --border-opacity: 1;
    border-color: #fdf6b2;
    border-color: rgba(253, 246, 178, var(--border-opacity));
  }
  .group:focus .lg\\:group-focus\\:border-yellow-200 {
    --border-opacity: 1;
    border-color: #fce96a;
    border-color: rgba(252, 233, 106, var(--border-opacity));
  }
  .group:focus .lg\\:group-focus\\:border-yellow-300 {
    --border-opacity: 1;
    border-color: #faca15;
    border-color: rgba(250, 202, 21, var(--border-opacity));
  }
  .group:focus .lg\\:group-focus\\:border-yellow-400 {
    --border-opacity: 1;
    border-color: #e3a008;
    border-color: rgba(227, 160, 8, var(--border-opacity));
  }
  .group:focus .lg\\:group-focus\\:border-yellow-500 {
    --border-opacity: 1;
    border-color: #c27803;
    border-color: rgba(194, 120, 3, var(--border-opacity));
  }
  .group:focus .lg\\:group-focus\\:border-yellow-600 {
    --border-opacity: 1;
    border-color: #9f580a;
    border-color: rgba(159, 88, 10, var(--border-opacity));
  }
  .group:focus .lg\\:group-focus\\:border-yellow-700 {
    --border-opacity: 1;
    border-color: #8e4b10;
    border-color: rgba(142, 75, 16, var(--border-opacity));
  }
  .group:focus .lg\\:group-focus\\:border-yellow-800 {
    --border-opacity: 1;
    border-color: #723b13;
    border-color: rgba(114, 59, 19, var(--border-opacity));
  }
  .group:focus .lg\\:group-focus\\:border-yellow-900 {
    --border-opacity: 1;
    border-color: #633112;
    border-color: rgba(99, 49, 18, var(--border-opacity));
  }
  .group:focus .lg\\:group-focus\\:border-green-50 {
    --border-opacity: 1;
    border-color: #f3faf7;
    border-color: rgba(243, 250, 247, var(--border-opacity));
  }
  .group:focus .lg\\:group-focus\\:border-green-100 {
    --border-opacity: 1;
    border-color: #def7ec;
    border-color: rgba(222, 247, 236, var(--border-opacity));
  }
  .group:focus .lg\\:group-focus\\:border-green-200 {
    --border-opacity: 1;
    border-color: #bcf0da;
    border-color: rgba(188, 240, 218, var(--border-opacity));
  }
  .group:focus .lg\\:group-focus\\:border-green-300 {
    --border-opacity: 1;
    border-color: #84e1bc;
    border-color: rgba(132, 225, 188, var(--border-opacity));
  }
  .group:focus .lg\\:group-focus\\:border-green-400 {
    --border-opacity: 1;
    border-color: #31c48d;
    border-color: rgba(49, 196, 141, var(--border-opacity));
  }
  .group:focus .lg\\:group-focus\\:border-green-500 {
    --border-opacity: 1;
    border-color: #0e9f6e;
    border-color: rgba(14, 159, 110, var(--border-opacity));
  }
  .group:focus .lg\\:group-focus\\:border-green-600 {
    --border-opacity: 1;
    border-color: #057a55;
    border-color: rgba(5, 122, 85, var(--border-opacity));
  }
  .group:focus .lg\\:group-focus\\:border-green-700 {
    --border-opacity: 1;
    border-color: #046c4e;
    border-color: rgba(4, 108, 78, var(--border-opacity));
  }
  .group:focus .lg\\:group-focus\\:border-green-800 {
    --border-opacity: 1;
    border-color: #03543f;
    border-color: rgba(3, 84, 63, var(--border-opacity));
  }
  .group:focus .lg\\:group-focus\\:border-green-900 {
    --border-opacity: 1;
    border-color: #014737;
    border-color: rgba(1, 71, 55, var(--border-opacity));
  }
  .group:focus .lg\\:group-focus\\:border-teal-50 {
    --border-opacity: 1;
    border-color: #edfafa;
    border-color: rgba(237, 250, 250, var(--border-opacity));
  }
  .group:focus .lg\\:group-focus\\:border-teal-100 {
    --border-opacity: 1;
    border-color: #d5f5f6;
    border-color: rgba(213, 245, 246, var(--border-opacity));
  }
  .group:focus .lg\\:group-focus\\:border-teal-200 {
    --border-opacity: 1;
    border-color: #afecef;
    border-color: rgba(175, 236, 239, var(--border-opacity));
  }
  .group:focus .lg\\:group-focus\\:border-teal-300 {
    --border-opacity: 1;
    border-color: #7edce2;
    border-color: rgba(126, 220, 226, var(--border-opacity));
  }
  .group:focus .lg\\:group-focus\\:border-teal-400 {
    --border-opacity: 1;
    border-color: #16bdca;
    border-color: rgba(22, 189, 202, var(--border-opacity));
  }
  .group:focus .lg\\:group-focus\\:border-teal-500 {
    --border-opacity: 1;
    border-color: #0694a2;
    border-color: rgba(6, 148, 162, var(--border-opacity));
  }
  .group:focus .lg\\:group-focus\\:border-teal-600 {
    --border-opacity: 1;
    border-color: #047481;
    border-color: rgba(4, 116, 129, var(--border-opacity));
  }
  .group:focus .lg\\:group-focus\\:border-teal-700 {
    --border-opacity: 1;
    border-color: #036672;
    border-color: rgba(3, 102, 114, var(--border-opacity));
  }
  .group:focus .lg\\:group-focus\\:border-teal-800 {
    --border-opacity: 1;
    border-color: #05505c;
    border-color: rgba(5, 80, 92, var(--border-opacity));
  }
  .group:focus .lg\\:group-focus\\:border-teal-900 {
    --border-opacity: 1;
    border-color: #014451;
    border-color: rgba(1, 68, 81, var(--border-opacity));
  }
  .group:focus .lg\\:group-focus\\:border-blue-50 {
    --border-opacity: 1;
    border-color: #ebf5ff;
    border-color: rgba(235, 245, 255, var(--border-opacity));
  }
  .group:focus .lg\\:group-focus\\:border-blue-100 {
    --border-opacity: 1;
    border-color: #e1effe;
    border-color: rgba(225, 239, 254, var(--border-opacity));
  }
  .group:focus .lg\\:group-focus\\:border-blue-200 {
    --border-opacity: 1;
    border-color: #c3ddfd;
    border-color: rgba(195, 221, 253, var(--border-opacity));
  }
  .group:focus .lg\\:group-focus\\:border-blue-300 {
    --border-opacity: 1;
    border-color: #a4cafe;
    border-color: rgba(164, 202, 254, var(--border-opacity));
  }
  .group:focus .lg\\:group-focus\\:border-blue-400 {
    --border-opacity: 1;
    border-color: #76a9fa;
    border-color: rgba(118, 169, 250, var(--border-opacity));
  }
  .group:focus .lg\\:group-focus\\:border-blue-500 {
    --border-opacity: 1;
    border-color: #3f83f8;
    border-color: rgba(63, 131, 248, var(--border-opacity));
  }
  .group:focus .lg\\:group-focus\\:border-blue-600 {
    --border-opacity: 1;
    border-color: #1c64f2;
    border-color: rgba(28, 100, 242, var(--border-opacity));
  }
  .group:focus .lg\\:group-focus\\:border-blue-700 {
    --border-opacity: 1;
    border-color: #1a56db;
    border-color: rgba(26, 86, 219, var(--border-opacity));
  }
  .group:focus .lg\\:group-focus\\:border-blue-800 {
    --border-opacity: 1;
    border-color: #1e429f;
    border-color: rgba(30, 66, 159, var(--border-opacity));
  }
  .group:focus .lg\\:group-focus\\:border-blue-900 {
    --border-opacity: 1;
    border-color: #233876;
    border-color: rgba(35, 56, 118, var(--border-opacity));
  }
  .group:focus .lg\\:group-focus\\:border-indigo-50 {
    --border-opacity: 1;
    border-color: #f0f5ff;
    border-color: rgba(240, 245, 255, var(--border-opacity));
  }
  .group:focus .lg\\:group-focus\\:border-indigo-100 {
    --border-opacity: 1;
    border-color: #e5edff;
    border-color: rgba(229, 237, 255, var(--border-opacity));
  }
  .group:focus .lg\\:group-focus\\:border-indigo-200 {
    --border-opacity: 1;
    border-color: #cddbfe;
    border-color: rgba(205, 219, 254, var(--border-opacity));
  }
  .group:focus .lg\\:group-focus\\:border-indigo-300 {
    --border-opacity: 1;
    border-color: #b4c6fc;
    border-color: rgba(180, 198, 252, var(--border-opacity));
  }
  .group:focus .lg\\:group-focus\\:border-indigo-400 {
    --border-opacity: 1;
    border-color: #8da2fb;
    border-color: rgba(141, 162, 251, var(--border-opacity));
  }
  .group:focus .lg\\:group-focus\\:border-indigo-500 {
    --border-opacity: 1;
    border-color: #6875f5;
    border-color: rgba(104, 117, 245, var(--border-opacity));
  }
  .group:focus .lg\\:group-focus\\:border-indigo-600 {
    --border-opacity: 1;
    border-color: #5850ec;
    border-color: rgba(88, 80, 236, var(--border-opacity));
  }
  .group:focus .lg\\:group-focus\\:border-indigo-700 {
    --border-opacity: 1;
    border-color: #5145cd;
    border-color: rgba(81, 69, 205, var(--border-opacity));
  }
  .group:focus .lg\\:group-focus\\:border-indigo-800 {
    --border-opacity: 1;
    border-color: #42389d;
    border-color: rgba(66, 56, 157, var(--border-opacity));
  }
  .group:focus .lg\\:group-focus\\:border-indigo-900 {
    --border-opacity: 1;
    border-color: #362f78;
    border-color: rgba(54, 47, 120, var(--border-opacity));
  }
  .group:focus .lg\\:group-focus\\:border-purple-50 {
    --border-opacity: 1;
    border-color: #f6f5ff;
    border-color: rgba(246, 245, 255, var(--border-opacity));
  }
  .group:focus .lg\\:group-focus\\:border-purple-100 {
    --border-opacity: 1;
    border-color: #edebfe;
    border-color: rgba(237, 235, 254, var(--border-opacity));
  }
  .group:focus .lg\\:group-focus\\:border-purple-200 {
    --border-opacity: 1;
    border-color: #dcd7fe;
    border-color: rgba(220, 215, 254, var(--border-opacity));
  }
  .group:focus .lg\\:group-focus\\:border-purple-300 {
    --border-opacity: 1;
    border-color: #cabffd;
    border-color: rgba(202, 191, 253, var(--border-opacity));
  }
  .group:focus .lg\\:group-focus\\:border-purple-400 {
    --border-opacity: 1;
    border-color: #ac94fa;
    border-color: rgba(172, 148, 250, var(--border-opacity));
  }
  .group:focus .lg\\:group-focus\\:border-purple-500 {
    --border-opacity: 1;
    border-color: #9061f9;
    border-color: rgba(144, 97, 249, var(--border-opacity));
  }
  .group:focus .lg\\:group-focus\\:border-purple-600 {
    --border-opacity: 1;
    border-color: #7e3af2;
    border-color: rgba(126, 58, 242, var(--border-opacity));
  }
  .group:focus .lg\\:group-focus\\:border-purple-700 {
    --border-opacity: 1;
    border-color: #6c2bd9;
    border-color: rgba(108, 43, 217, var(--border-opacity));
  }
  .group:focus .lg\\:group-focus\\:border-purple-800 {
    --border-opacity: 1;
    border-color: #5521b5;
    border-color: rgba(85, 33, 181, var(--border-opacity));
  }
  .group:focus .lg\\:group-focus\\:border-purple-900 {
    --border-opacity: 1;
    border-color: #4a1d96;
    border-color: rgba(74, 29, 150, var(--border-opacity));
  }
  .group:focus .lg\\:group-focus\\:border-pink-50 {
    --border-opacity: 1;
    border-color: #fdf2f8;
    border-color: rgba(253, 242, 248, var(--border-opacity));
  }
  .group:focus .lg\\:group-focus\\:border-pink-100 {
    --border-opacity: 1;
    border-color: #fce8f3;
    border-color: rgba(252, 232, 243, var(--border-opacity));
  }
  .group:focus .lg\\:group-focus\\:border-pink-200 {
    --border-opacity: 1;
    border-color: #fad1e8;
    border-color: rgba(250, 209, 232, var(--border-opacity));
  }
  .group:focus .lg\\:group-focus\\:border-pink-300 {
    --border-opacity: 1;
    border-color: #f8b4d9;
    border-color: rgba(248, 180, 217, var(--border-opacity));
  }
  .group:focus .lg\\:group-focus\\:border-pink-400 {
    --border-opacity: 1;
    border-color: #f17eb8;
    border-color: rgba(241, 126, 184, var(--border-opacity));
  }
  .group:focus .lg\\:group-focus\\:border-pink-500 {
    --border-opacity: 1;
    border-color: #e74694;
    border-color: rgba(231, 70, 148, var(--border-opacity));
  }
  .group:focus .lg\\:group-focus\\:border-pink-600 {
    --border-opacity: 1;
    border-color: #d61f69;
    border-color: rgba(214, 31, 105, var(--border-opacity));
  }
  .group:focus .lg\\:group-focus\\:border-pink-700 {
    --border-opacity: 1;
    border-color: #bf125d;
    border-color: rgba(191, 18, 93, var(--border-opacity));
  }
  .group:focus .lg\\:group-focus\\:border-pink-800 {
    --border-opacity: 1;
    border-color: #99154b;
    border-color: rgba(153, 21, 75, var(--border-opacity));
  }
  .group:focus .lg\\:group-focus\\:border-pink-900 {
    --border-opacity: 1;
    border-color: #751a3d;
    border-color: rgba(117, 26, 61, var(--border-opacity));
  }
  .group:focus .lg\\:group-focus\\:border-cool-gray-50 {
    --border-opacity: 1;
    border-color: #f8fafc;
    border-color: rgba(248, 250, 252, var(--border-opacity));
  }
  .group:focus .lg\\:group-focus\\:border-cool-gray-100 {
    --border-opacity: 1;
    border-color: #f1f5f9;
    border-color: rgba(241, 245, 249, var(--border-opacity));
  }
  .group:focus .lg\\:group-focus\\:border-cool-gray-200 {
    --border-opacity: 1;
    border-color: #e2e8f0;
    border-color: rgba(226, 232, 240, var(--border-opacity));
  }
  .group:focus .lg\\:group-focus\\:border-cool-gray-300 {
    --border-opacity: 1;
    border-color: #cfd8e3;
    border-color: rgba(207, 216, 227, var(--border-opacity));
  }
  .group:focus .lg\\:group-focus\\:border-cool-gray-400 {
    --border-opacity: 1;
    border-color: #97a6ba;
    border-color: rgba(151, 166, 186, var(--border-opacity));
  }
  .group:focus .lg\\:group-focus\\:border-cool-gray-500 {
    --border-opacity: 1;
    border-color: #64748b;
    border-color: rgba(100, 116, 139, var(--border-opacity));
  }
  .group:focus .lg\\:group-focus\\:border-cool-gray-600 {
    --border-opacity: 1;
    border-color: #475569;
    border-color: rgba(71, 85, 105, var(--border-opacity));
  }
  .group:focus .lg\\:group-focus\\:border-cool-gray-700 {
    --border-opacity: 1;
    border-color: #364152;
    border-color: rgba(54, 65, 82, var(--border-opacity));
  }
  .group:focus .lg\\:group-focus\\:border-cool-gray-800 {
    --border-opacity: 1;
    border-color: #27303f;
    border-color: rgba(39, 48, 63, var(--border-opacity));
  }
  .group:focus .lg\\:group-focus\\:border-cool-gray-900 {
    --border-opacity: 1;
    border-color: #1a202e;
    border-color: rgba(26, 32, 46, var(--border-opacity));
  }
  .lg\\:hover\\:border-current:hover {
    border-color: currentColor;
  }
  .lg\\:hover\\:border-transparent:hover {
    border-color: transparent;
  }
  .lg\\:hover\\:border-white:hover {
    --border-opacity: 1;
    border-color: #ffffff;
    border-color: rgba(255, 255, 255, var(--border-opacity));
  }
  .lg\\:hover\\:border-black:hover {
    --border-opacity: 1;
    border-color: #000000;
    border-color: rgba(0, 0, 0, var(--border-opacity));
  }
  .lg\\:hover\\:border-gray-50:hover {
    --border-opacity: 1;
    border-color: #f9fafb;
    border-color: rgba(249, 250, 251, var(--border-opacity));
  }
  .lg\\:hover\\:border-gray-100:hover {
    --border-opacity: 1;
    border-color: #f4f5f7;
    border-color: rgba(244, 245, 247, var(--border-opacity));
  }
  .lg\\:hover\\:border-gray-200:hover {
    --border-opacity: 1;
    border-color: #e5e7eb;
    border-color: rgba(229, 231, 235, var(--border-opacity));
  }
  .lg\\:hover\\:border-gray-300:hover {
    --border-opacity: 1;
    border-color: #d2d6dc;
    border-color: rgba(210, 214, 220, var(--border-opacity));
  }
  .lg\\:hover\\:border-gray-400:hover {
    --border-opacity: 1;
    border-color: #9fa6b2;
    border-color: rgba(159, 166, 178, var(--border-opacity));
  }
  .lg\\:hover\\:border-gray-500:hover {
    --border-opacity: 1;
    border-color: #6b7280;
    border-color: rgba(107, 114, 128, var(--border-opacity));
  }
  .lg\\:hover\\:border-gray-600:hover {
    --border-opacity: 1;
    border-color: #4b5563;
    border-color: rgba(75, 85, 99, var(--border-opacity));
  }
  .lg\\:hover\\:border-gray-700:hover {
    --border-opacity: 1;
    border-color: #374151;
    border-color: rgba(55, 65, 81, var(--border-opacity));
  }
  .lg\\:hover\\:border-gray-800:hover {
    --border-opacity: 1;
    border-color: #252f3f;
    border-color: rgba(37, 47, 63, var(--border-opacity));
  }
  .lg\\:hover\\:border-gray-900:hover {
    --border-opacity: 1;
    border-color: #161e2e;
    border-color: rgba(22, 30, 46, var(--border-opacity));
  }
  .lg\\:hover\\:border-red-50:hover {
    --border-opacity: 1;
    border-color: #fdf2f2;
    border-color: rgba(253, 242, 242, var(--border-opacity));
  }
  .lg\\:hover\\:border-red-100:hover {
    --border-opacity: 1;
    border-color: #fde8e8;
    border-color: rgba(253, 232, 232, var(--border-opacity));
  }
  .lg\\:hover\\:border-red-200:hover {
    --border-opacity: 1;
    border-color: #fbd5d5;
    border-color: rgba(251, 213, 213, var(--border-opacity));
  }
  .lg\\:hover\\:border-red-300:hover {
    --border-opacity: 1;
    border-color: #f8b4b4;
    border-color: rgba(248, 180, 180, var(--border-opacity));
  }
  .lg\\:hover\\:border-red-400:hover {
    --border-opacity: 1;
    border-color: #f98080;
    border-color: rgba(249, 128, 128, var(--border-opacity));
  }
  .lg\\:hover\\:border-red-500:hover {
    --border-opacity: 1;
    border-color: #f05252;
    border-color: rgba(240, 82, 82, var(--border-opacity));
  }
  .lg\\:hover\\:border-red-600:hover {
    --border-opacity: 1;
    border-color: #e02424;
    border-color: rgba(224, 36, 36, var(--border-opacity));
  }
  .lg\\:hover\\:border-red-700:hover {
    --border-opacity: 1;
    border-color: #c81e1e;
    border-color: rgba(200, 30, 30, var(--border-opacity));
  }
  .lg\\:hover\\:border-red-800:hover {
    --border-opacity: 1;
    border-color: #9b1c1c;
    border-color: rgba(155, 28, 28, var(--border-opacity));
  }
  .lg\\:hover\\:border-red-900:hover {
    --border-opacity: 1;
    border-color: #771d1d;
    border-color: rgba(119, 29, 29, var(--border-opacity));
  }
  .lg\\:hover\\:border-orange-50:hover {
    --border-opacity: 1;
    border-color: #fff8f1;
    border-color: rgba(255, 248, 241, var(--border-opacity));
  }
  .lg\\:hover\\:border-orange-100:hover {
    --border-opacity: 1;
    border-color: #feecdc;
    border-color: rgba(254, 236, 220, var(--border-opacity));
  }
  .lg\\:hover\\:border-orange-200:hover {
    --border-opacity: 1;
    border-color: #fcd9bd;
    border-color: rgba(252, 217, 189, var(--border-opacity));
  }
  .lg\\:hover\\:border-orange-300:hover {
    --border-opacity: 1;
    border-color: #fdba8c;
    border-color: rgba(253, 186, 140, var(--border-opacity));
  }
  .lg\\:hover\\:border-orange-400:hover {
    --border-opacity: 1;
    border-color: #ff8a4c;
    border-color: rgba(255, 138, 76, var(--border-opacity));
  }
  .lg\\:hover\\:border-orange-500:hover {
    --border-opacity: 1;
    border-color: #ff5a1f;
    border-color: rgba(255, 90, 31, var(--border-opacity));
  }
  .lg\\:hover\\:border-orange-600:hover {
    --border-opacity: 1;
    border-color: #d03801;
    border-color: rgba(208, 56, 1, var(--border-opacity));
  }
  .lg\\:hover\\:border-orange-700:hover {
    --border-opacity: 1;
    border-color: #b43403;
    border-color: rgba(180, 52, 3, var(--border-opacity));
  }
  .lg\\:hover\\:border-orange-800:hover {
    --border-opacity: 1;
    border-color: #8a2c0d;
    border-color: rgba(138, 44, 13, var(--border-opacity));
  }
  .lg\\:hover\\:border-orange-900:hover {
    --border-opacity: 1;
    border-color: #73230d;
    border-color: rgba(115, 35, 13, var(--border-opacity));
  }
  .lg\\:hover\\:border-yellow-50:hover {
    --border-opacity: 1;
    border-color: #fdfdea;
    border-color: rgba(253, 253, 234, var(--border-opacity));
  }
  .lg\\:hover\\:border-yellow-100:hover {
    --border-opacity: 1;
    border-color: #fdf6b2;
    border-color: rgba(253, 246, 178, var(--border-opacity));
  }
  .lg\\:hover\\:border-yellow-200:hover {
    --border-opacity: 1;
    border-color: #fce96a;
    border-color: rgba(252, 233, 106, var(--border-opacity));
  }
  .lg\\:hover\\:border-yellow-300:hover {
    --border-opacity: 1;
    border-color: #faca15;
    border-color: rgba(250, 202, 21, var(--border-opacity));
  }
  .lg\\:hover\\:border-yellow-400:hover {
    --border-opacity: 1;
    border-color: #e3a008;
    border-color: rgba(227, 160, 8, var(--border-opacity));
  }
  .lg\\:hover\\:border-yellow-500:hover {
    --border-opacity: 1;
    border-color: #c27803;
    border-color: rgba(194, 120, 3, var(--border-opacity));
  }
  .lg\\:hover\\:border-yellow-600:hover {
    --border-opacity: 1;
    border-color: #9f580a;
    border-color: rgba(159, 88, 10, var(--border-opacity));
  }
  .lg\\:hover\\:border-yellow-700:hover {
    --border-opacity: 1;
    border-color: #8e4b10;
    border-color: rgba(142, 75, 16, var(--border-opacity));
  }
  .lg\\:hover\\:border-yellow-800:hover {
    --border-opacity: 1;
    border-color: #723b13;
    border-color: rgba(114, 59, 19, var(--border-opacity));
  }
  .lg\\:hover\\:border-yellow-900:hover {
    --border-opacity: 1;
    border-color: #633112;
    border-color: rgba(99, 49, 18, var(--border-opacity));
  }
  .lg\\:hover\\:border-green-50:hover {
    --border-opacity: 1;
    border-color: #f3faf7;
    border-color: rgba(243, 250, 247, var(--border-opacity));
  }
  .lg\\:hover\\:border-green-100:hover {
    --border-opacity: 1;
    border-color: #def7ec;
    border-color: rgba(222, 247, 236, var(--border-opacity));
  }
  .lg\\:hover\\:border-green-200:hover {
    --border-opacity: 1;
    border-color: #bcf0da;
    border-color: rgba(188, 240, 218, var(--border-opacity));
  }
  .lg\\:hover\\:border-green-300:hover {
    --border-opacity: 1;
    border-color: #84e1bc;
    border-color: rgba(132, 225, 188, var(--border-opacity));
  }
  .lg\\:hover\\:border-green-400:hover {
    --border-opacity: 1;
    border-color: #31c48d;
    border-color: rgba(49, 196, 141, var(--border-opacity));
  }
  .lg\\:hover\\:border-green-500:hover {
    --border-opacity: 1;
    border-color: #0e9f6e;
    border-color: rgba(14, 159, 110, var(--border-opacity));
  }
  .lg\\:hover\\:border-green-600:hover {
    --border-opacity: 1;
    border-color: #057a55;
    border-color: rgba(5, 122, 85, var(--border-opacity));
  }
  .lg\\:hover\\:border-green-700:hover {
    --border-opacity: 1;
    border-color: #046c4e;
    border-color: rgba(4, 108, 78, var(--border-opacity));
  }
  .lg\\:hover\\:border-green-800:hover {
    --border-opacity: 1;
    border-color: #03543f;
    border-color: rgba(3, 84, 63, var(--border-opacity));
  }
  .lg\\:hover\\:border-green-900:hover {
    --border-opacity: 1;
    border-color: #014737;
    border-color: rgba(1, 71, 55, var(--border-opacity));
  }
  .lg\\:hover\\:border-teal-50:hover {
    --border-opacity: 1;
    border-color: #edfafa;
    border-color: rgba(237, 250, 250, var(--border-opacity));
  }
  .lg\\:hover\\:border-teal-100:hover {
    --border-opacity: 1;
    border-color: #d5f5f6;
    border-color: rgba(213, 245, 246, var(--border-opacity));
  }
  .lg\\:hover\\:border-teal-200:hover {
    --border-opacity: 1;
    border-color: #afecef;
    border-color: rgba(175, 236, 239, var(--border-opacity));
  }
  .lg\\:hover\\:border-teal-300:hover {
    --border-opacity: 1;
    border-color: #7edce2;
    border-color: rgba(126, 220, 226, var(--border-opacity));
  }
  .lg\\:hover\\:border-teal-400:hover {
    --border-opacity: 1;
    border-color: #16bdca;
    border-color: rgba(22, 189, 202, var(--border-opacity));
  }
  .lg\\:hover\\:border-teal-500:hover {
    --border-opacity: 1;
    border-color: #0694a2;
    border-color: rgba(6, 148, 162, var(--border-opacity));
  }
  .lg\\:hover\\:border-teal-600:hover {
    --border-opacity: 1;
    border-color: #047481;
    border-color: rgba(4, 116, 129, var(--border-opacity));
  }
  .lg\\:hover\\:border-teal-700:hover {
    --border-opacity: 1;
    border-color: #036672;
    border-color: rgba(3, 102, 114, var(--border-opacity));
  }
  .lg\\:hover\\:border-teal-800:hover {
    --border-opacity: 1;
    border-color: #05505c;
    border-color: rgba(5, 80, 92, var(--border-opacity));
  }
  .lg\\:hover\\:border-teal-900:hover {
    --border-opacity: 1;
    border-color: #014451;
    border-color: rgba(1, 68, 81, var(--border-opacity));
  }
  .lg\\:hover\\:border-blue-50:hover {
    --border-opacity: 1;
    border-color: #ebf5ff;
    border-color: rgba(235, 245, 255, var(--border-opacity));
  }
  .lg\\:hover\\:border-blue-100:hover {
    --border-opacity: 1;
    border-color: #e1effe;
    border-color: rgba(225, 239, 254, var(--border-opacity));
  }
  .lg\\:hover\\:border-blue-200:hover {
    --border-opacity: 1;
    border-color: #c3ddfd;
    border-color: rgba(195, 221, 253, var(--border-opacity));
  }
  .lg\\:hover\\:border-blue-300:hover {
    --border-opacity: 1;
    border-color: #a4cafe;
    border-color: rgba(164, 202, 254, var(--border-opacity));
  }
  .lg\\:hover\\:border-blue-400:hover {
    --border-opacity: 1;
    border-color: #76a9fa;
    border-color: rgba(118, 169, 250, var(--border-opacity));
  }
  .lg\\:hover\\:border-blue-500:hover {
    --border-opacity: 1;
    border-color: #3f83f8;
    border-color: rgba(63, 131, 248, var(--border-opacity));
  }
  .lg\\:hover\\:border-blue-600:hover {
    --border-opacity: 1;
    border-color: #1c64f2;
    border-color: rgba(28, 100, 242, var(--border-opacity));
  }
  .lg\\:hover\\:border-blue-700:hover {
    --border-opacity: 1;
    border-color: #1a56db;
    border-color: rgba(26, 86, 219, var(--border-opacity));
  }
  .lg\\:hover\\:border-blue-800:hover {
    --border-opacity: 1;
    border-color: #1e429f;
    border-color: rgba(30, 66, 159, var(--border-opacity));
  }
  .lg\\:hover\\:border-blue-900:hover {
    --border-opacity: 1;
    border-color: #233876;
    border-color: rgba(35, 56, 118, var(--border-opacity));
  }
  .lg\\:hover\\:border-indigo-50:hover {
    --border-opacity: 1;
    border-color: #f0f5ff;
    border-color: rgba(240, 245, 255, var(--border-opacity));
  }
  .lg\\:hover\\:border-indigo-100:hover {
    --border-opacity: 1;
    border-color: #e5edff;
    border-color: rgba(229, 237, 255, var(--border-opacity));
  }
  .lg\\:hover\\:border-indigo-200:hover {
    --border-opacity: 1;
    border-color: #cddbfe;
    border-color: rgba(205, 219, 254, var(--border-opacity));
  }
  .lg\\:hover\\:border-indigo-300:hover {
    --border-opacity: 1;
    border-color: #b4c6fc;
    border-color: rgba(180, 198, 252, var(--border-opacity));
  }
  .lg\\:hover\\:border-indigo-400:hover {
    --border-opacity: 1;
    border-color: #8da2fb;
    border-color: rgba(141, 162, 251, var(--border-opacity));
  }
  .lg\\:hover\\:border-indigo-500:hover {
    --border-opacity: 1;
    border-color: #6875f5;
    border-color: rgba(104, 117, 245, var(--border-opacity));
  }
  .lg\\:hover\\:border-indigo-600:hover {
    --border-opacity: 1;
    border-color: #5850ec;
    border-color: rgba(88, 80, 236, var(--border-opacity));
  }
  .lg\\:hover\\:border-indigo-700:hover {
    --border-opacity: 1;
    border-color: #5145cd;
    border-color: rgba(81, 69, 205, var(--border-opacity));
  }
  .lg\\:hover\\:border-indigo-800:hover {
    --border-opacity: 1;
    border-color: #42389d;
    border-color: rgba(66, 56, 157, var(--border-opacity));
  }
  .lg\\:hover\\:border-indigo-900:hover {
    --border-opacity: 1;
    border-color: #362f78;
    border-color: rgba(54, 47, 120, var(--border-opacity));
  }
  .lg\\:hover\\:border-purple-50:hover {
    --border-opacity: 1;
    border-color: #f6f5ff;
    border-color: rgba(246, 245, 255, var(--border-opacity));
  }
  .lg\\:hover\\:border-purple-100:hover {
    --border-opacity: 1;
    border-color: #edebfe;
    border-color: rgba(237, 235, 254, var(--border-opacity));
  }
  .lg\\:hover\\:border-purple-200:hover {
    --border-opacity: 1;
    border-color: #dcd7fe;
    border-color: rgba(220, 215, 254, var(--border-opacity));
  }
  .lg\\:hover\\:border-purple-300:hover {
    --border-opacity: 1;
    border-color: #cabffd;
    border-color: rgba(202, 191, 253, var(--border-opacity));
  }
  .lg\\:hover\\:border-purple-400:hover {
    --border-opacity: 1;
    border-color: #ac94fa;
    border-color: rgba(172, 148, 250, var(--border-opacity));
  }
  .lg\\:hover\\:border-purple-500:hover {
    --border-opacity: 1;
    border-color: #9061f9;
    border-color: rgba(144, 97, 249, var(--border-opacity));
  }
  .lg\\:hover\\:border-purple-600:hover {
    --border-opacity: 1;
    border-color: #7e3af2;
    border-color: rgba(126, 58, 242, var(--border-opacity));
  }
  .lg\\:hover\\:border-purple-700:hover {
    --border-opacity: 1;
    border-color: #6c2bd9;
    border-color: rgba(108, 43, 217, var(--border-opacity));
  }
  .lg\\:hover\\:border-purple-800:hover {
    --border-opacity: 1;
    border-color: #5521b5;
    border-color: rgba(85, 33, 181, var(--border-opacity));
  }
  .lg\\:hover\\:border-purple-900:hover {
    --border-opacity: 1;
    border-color: #4a1d96;
    border-color: rgba(74, 29, 150, var(--border-opacity));
  }
  .lg\\:hover\\:border-pink-50:hover {
    --border-opacity: 1;
    border-color: #fdf2f8;
    border-color: rgba(253, 242, 248, var(--border-opacity));
  }
  .lg\\:hover\\:border-pink-100:hover {
    --border-opacity: 1;
    border-color: #fce8f3;
    border-color: rgba(252, 232, 243, var(--border-opacity));
  }
  .lg\\:hover\\:border-pink-200:hover {
    --border-opacity: 1;
    border-color: #fad1e8;
    border-color: rgba(250, 209, 232, var(--border-opacity));
  }
  .lg\\:hover\\:border-pink-300:hover {
    --border-opacity: 1;
    border-color: #f8b4d9;
    border-color: rgba(248, 180, 217, var(--border-opacity));
  }
  .lg\\:hover\\:border-pink-400:hover {
    --border-opacity: 1;
    border-color: #f17eb8;
    border-color: rgba(241, 126, 184, var(--border-opacity));
  }
  .lg\\:hover\\:border-pink-500:hover {
    --border-opacity: 1;
    border-color: #e74694;
    border-color: rgba(231, 70, 148, var(--border-opacity));
  }
  .lg\\:hover\\:border-pink-600:hover {
    --border-opacity: 1;
    border-color: #d61f69;
    border-color: rgba(214, 31, 105, var(--border-opacity));
  }
  .lg\\:hover\\:border-pink-700:hover {
    --border-opacity: 1;
    border-color: #bf125d;
    border-color: rgba(191, 18, 93, var(--border-opacity));
  }
  .lg\\:hover\\:border-pink-800:hover {
    --border-opacity: 1;
    border-color: #99154b;
    border-color: rgba(153, 21, 75, var(--border-opacity));
  }
  .lg\\:hover\\:border-pink-900:hover {
    --border-opacity: 1;
    border-color: #751a3d;
    border-color: rgba(117, 26, 61, var(--border-opacity));
  }
  .lg\\:hover\\:border-cool-gray-50:hover {
    --border-opacity: 1;
    border-color: #f8fafc;
    border-color: rgba(248, 250, 252, var(--border-opacity));
  }
  .lg\\:hover\\:border-cool-gray-100:hover {
    --border-opacity: 1;
    border-color: #f1f5f9;
    border-color: rgba(241, 245, 249, var(--border-opacity));
  }
  .lg\\:hover\\:border-cool-gray-200:hover {
    --border-opacity: 1;
    border-color: #e2e8f0;
    border-color: rgba(226, 232, 240, var(--border-opacity));
  }
  .lg\\:hover\\:border-cool-gray-300:hover {
    --border-opacity: 1;
    border-color: #cfd8e3;
    border-color: rgba(207, 216, 227, var(--border-opacity));
  }
  .lg\\:hover\\:border-cool-gray-400:hover {
    --border-opacity: 1;
    border-color: #97a6ba;
    border-color: rgba(151, 166, 186, var(--border-opacity));
  }
  .lg\\:hover\\:border-cool-gray-500:hover {
    --border-opacity: 1;
    border-color: #64748b;
    border-color: rgba(100, 116, 139, var(--border-opacity));
  }
  .lg\\:hover\\:border-cool-gray-600:hover {
    --border-opacity: 1;
    border-color: #475569;
    border-color: rgba(71, 85, 105, var(--border-opacity));
  }
  .lg\\:hover\\:border-cool-gray-700:hover {
    --border-opacity: 1;
    border-color: #364152;
    border-color: rgba(54, 65, 82, var(--border-opacity));
  }
  .lg\\:hover\\:border-cool-gray-800:hover {
    --border-opacity: 1;
    border-color: #27303f;
    border-color: rgba(39, 48, 63, var(--border-opacity));
  }
  .lg\\:hover\\:border-cool-gray-900:hover {
    --border-opacity: 1;
    border-color: #1a202e;
    border-color: rgba(26, 32, 46, var(--border-opacity));
  }
  .lg\\:focus-within\\:border-current:focus-within {
    border-color: currentColor;
  }
  .lg\\:focus-within\\:border-transparent:focus-within {
    border-color: transparent;
  }
  .lg\\:focus-within\\:border-white:focus-within {
    --border-opacity: 1;
    border-color: #ffffff;
    border-color: rgba(255, 255, 255, var(--border-opacity));
  }
  .lg\\:focus-within\\:border-black:focus-within {
    --border-opacity: 1;
    border-color: #000000;
    border-color: rgba(0, 0, 0, var(--border-opacity));
  }
  .lg\\:focus-within\\:border-gray-50:focus-within {
    --border-opacity: 1;
    border-color: #f9fafb;
    border-color: rgba(249, 250, 251, var(--border-opacity));
  }
  .lg\\:focus-within\\:border-gray-100:focus-within {
    --border-opacity: 1;
    border-color: #f4f5f7;
    border-color: rgba(244, 245, 247, var(--border-opacity));
  }
  .lg\\:focus-within\\:border-gray-200:focus-within {
    --border-opacity: 1;
    border-color: #e5e7eb;
    border-color: rgba(229, 231, 235, var(--border-opacity));
  }
  .lg\\:focus-within\\:border-gray-300:focus-within {
    --border-opacity: 1;
    border-color: #d2d6dc;
    border-color: rgba(210, 214, 220, var(--border-opacity));
  }
  .lg\\:focus-within\\:border-gray-400:focus-within {
    --border-opacity: 1;
    border-color: #9fa6b2;
    border-color: rgba(159, 166, 178, var(--border-opacity));
  }
  .lg\\:focus-within\\:border-gray-500:focus-within {
    --border-opacity: 1;
    border-color: #6b7280;
    border-color: rgba(107, 114, 128, var(--border-opacity));
  }
  .lg\\:focus-within\\:border-gray-600:focus-within {
    --border-opacity: 1;
    border-color: #4b5563;
    border-color: rgba(75, 85, 99, var(--border-opacity));
  }
  .lg\\:focus-within\\:border-gray-700:focus-within {
    --border-opacity: 1;
    border-color: #374151;
    border-color: rgba(55, 65, 81, var(--border-opacity));
  }
  .lg\\:focus-within\\:border-gray-800:focus-within {
    --border-opacity: 1;
    border-color: #252f3f;
    border-color: rgba(37, 47, 63, var(--border-opacity));
  }
  .lg\\:focus-within\\:border-gray-900:focus-within {
    --border-opacity: 1;
    border-color: #161e2e;
    border-color: rgba(22, 30, 46, var(--border-opacity));
  }
  .lg\\:focus-within\\:border-red-50:focus-within {
    --border-opacity: 1;
    border-color: #fdf2f2;
    border-color: rgba(253, 242, 242, var(--border-opacity));
  }
  .lg\\:focus-within\\:border-red-100:focus-within {
    --border-opacity: 1;
    border-color: #fde8e8;
    border-color: rgba(253, 232, 232, var(--border-opacity));
  }
  .lg\\:focus-within\\:border-red-200:focus-within {
    --border-opacity: 1;
    border-color: #fbd5d5;
    border-color: rgba(251, 213, 213, var(--border-opacity));
  }
  .lg\\:focus-within\\:border-red-300:focus-within {
    --border-opacity: 1;
    border-color: #f8b4b4;
    border-color: rgba(248, 180, 180, var(--border-opacity));
  }
  .lg\\:focus-within\\:border-red-400:focus-within {
    --border-opacity: 1;
    border-color: #f98080;
    border-color: rgba(249, 128, 128, var(--border-opacity));
  }
  .lg\\:focus-within\\:border-red-500:focus-within {
    --border-opacity: 1;
    border-color: #f05252;
    border-color: rgba(240, 82, 82, var(--border-opacity));
  }
  .lg\\:focus-within\\:border-red-600:focus-within {
    --border-opacity: 1;
    border-color: #e02424;
    border-color: rgba(224, 36, 36, var(--border-opacity));
  }
  .lg\\:focus-within\\:border-red-700:focus-within {
    --border-opacity: 1;
    border-color: #c81e1e;
    border-color: rgba(200, 30, 30, var(--border-opacity));
  }
  .lg\\:focus-within\\:border-red-800:focus-within {
    --border-opacity: 1;
    border-color: #9b1c1c;
    border-color: rgba(155, 28, 28, var(--border-opacity));
  }
  .lg\\:focus-within\\:border-red-900:focus-within {
    --border-opacity: 1;
    border-color: #771d1d;
    border-color: rgba(119, 29, 29, var(--border-opacity));
  }
  .lg\\:focus-within\\:border-orange-50:focus-within {
    --border-opacity: 1;
    border-color: #fff8f1;
    border-color: rgba(255, 248, 241, var(--border-opacity));
  }
  .lg\\:focus-within\\:border-orange-100:focus-within {
    --border-opacity: 1;
    border-color: #feecdc;
    border-color: rgba(254, 236, 220, var(--border-opacity));
  }
  .lg\\:focus-within\\:border-orange-200:focus-within {
    --border-opacity: 1;
    border-color: #fcd9bd;
    border-color: rgba(252, 217, 189, var(--border-opacity));
  }
  .lg\\:focus-within\\:border-orange-300:focus-within {
    --border-opacity: 1;
    border-color: #fdba8c;
    border-color: rgba(253, 186, 140, var(--border-opacity));
  }
  .lg\\:focus-within\\:border-orange-400:focus-within {
    --border-opacity: 1;
    border-color: #ff8a4c;
    border-color: rgba(255, 138, 76, var(--border-opacity));
  }
  .lg\\:focus-within\\:border-orange-500:focus-within {
    --border-opacity: 1;
    border-color: #ff5a1f;
    border-color: rgba(255, 90, 31, var(--border-opacity));
  }
  .lg\\:focus-within\\:border-orange-600:focus-within {
    --border-opacity: 1;
    border-color: #d03801;
    border-color: rgba(208, 56, 1, var(--border-opacity));
  }
  .lg\\:focus-within\\:border-orange-700:focus-within {
    --border-opacity: 1;
    border-color: #b43403;
    border-color: rgba(180, 52, 3, var(--border-opacity));
  }
  .lg\\:focus-within\\:border-orange-800:focus-within {
    --border-opacity: 1;
    border-color: #8a2c0d;
    border-color: rgba(138, 44, 13, var(--border-opacity));
  }
  .lg\\:focus-within\\:border-orange-900:focus-within {
    --border-opacity: 1;
    border-color: #73230d;
    border-color: rgba(115, 35, 13, var(--border-opacity));
  }
  .lg\\:focus-within\\:border-yellow-50:focus-within {
    --border-opacity: 1;
    border-color: #fdfdea;
    border-color: rgba(253, 253, 234, var(--border-opacity));
  }
  .lg\\:focus-within\\:border-yellow-100:focus-within {
    --border-opacity: 1;
    border-color: #fdf6b2;
    border-color: rgba(253, 246, 178, var(--border-opacity));
  }
  .lg\\:focus-within\\:border-yellow-200:focus-within {
    --border-opacity: 1;
    border-color: #fce96a;
    border-color: rgba(252, 233, 106, var(--border-opacity));
  }
  .lg\\:focus-within\\:border-yellow-300:focus-within {
    --border-opacity: 1;
    border-color: #faca15;
    border-color: rgba(250, 202, 21, var(--border-opacity));
  }
  .lg\\:focus-within\\:border-yellow-400:focus-within {
    --border-opacity: 1;
    border-color: #e3a008;
    border-color: rgba(227, 160, 8, var(--border-opacity));
  }
  .lg\\:focus-within\\:border-yellow-500:focus-within {
    --border-opacity: 1;
    border-color: #c27803;
    border-color: rgba(194, 120, 3, var(--border-opacity));
  }
  .lg\\:focus-within\\:border-yellow-600:focus-within {
    --border-opacity: 1;
    border-color: #9f580a;
    border-color: rgba(159, 88, 10, var(--border-opacity));
  }
  .lg\\:focus-within\\:border-yellow-700:focus-within {
    --border-opacity: 1;
    border-color: #8e4b10;
    border-color: rgba(142, 75, 16, var(--border-opacity));
  }
  .lg\\:focus-within\\:border-yellow-800:focus-within {
    --border-opacity: 1;
    border-color: #723b13;
    border-color: rgba(114, 59, 19, var(--border-opacity));
  }
  .lg\\:focus-within\\:border-yellow-900:focus-within {
    --border-opacity: 1;
    border-color: #633112;
    border-color: rgba(99, 49, 18, var(--border-opacity));
  }
  .lg\\:focus-within\\:border-green-50:focus-within {
    --border-opacity: 1;
    border-color: #f3faf7;
    border-color: rgba(243, 250, 247, var(--border-opacity));
  }
  .lg\\:focus-within\\:border-green-100:focus-within {
    --border-opacity: 1;
    border-color: #def7ec;
    border-color: rgba(222, 247, 236, var(--border-opacity));
  }
  .lg\\:focus-within\\:border-green-200:focus-within {
    --border-opacity: 1;
    border-color: #bcf0da;
    border-color: rgba(188, 240, 218, var(--border-opacity));
  }
  .lg\\:focus-within\\:border-green-300:focus-within {
    --border-opacity: 1;
    border-color: #84e1bc;
    border-color: rgba(132, 225, 188, var(--border-opacity));
  }
  .lg\\:focus-within\\:border-green-400:focus-within {
    --border-opacity: 1;
    border-color: #31c48d;
    border-color: rgba(49, 196, 141, var(--border-opacity));
  }
  .lg\\:focus-within\\:border-green-500:focus-within {
    --border-opacity: 1;
    border-color: #0e9f6e;
    border-color: rgba(14, 159, 110, var(--border-opacity));
  }
  .lg\\:focus-within\\:border-green-600:focus-within {
    --border-opacity: 1;
    border-color: #057a55;
    border-color: rgba(5, 122, 85, var(--border-opacity));
  }
  .lg\\:focus-within\\:border-green-700:focus-within {
    --border-opacity: 1;
    border-color: #046c4e;
    border-color: rgba(4, 108, 78, var(--border-opacity));
  }
  .lg\\:focus-within\\:border-green-800:focus-within {
    --border-opacity: 1;
    border-color: #03543f;
    border-color: rgba(3, 84, 63, var(--border-opacity));
  }
  .lg\\:focus-within\\:border-green-900:focus-within {
    --border-opacity: 1;
    border-color: #014737;
    border-color: rgba(1, 71, 55, var(--border-opacity));
  }
  .lg\\:focus-within\\:border-teal-50:focus-within {
    --border-opacity: 1;
    border-color: #edfafa;
    border-color: rgba(237, 250, 250, var(--border-opacity));
  }
  .lg\\:focus-within\\:border-teal-100:focus-within {
    --border-opacity: 1;
    border-color: #d5f5f6;
    border-color: rgba(213, 245, 246, var(--border-opacity));
  }
  .lg\\:focus-within\\:border-teal-200:focus-within {
    --border-opacity: 1;
    border-color: #afecef;
    border-color: rgba(175, 236, 239, var(--border-opacity));
  }
  .lg\\:focus-within\\:border-teal-300:focus-within {
    --border-opacity: 1;
    border-color: #7edce2;
    border-color: rgba(126, 220, 226, var(--border-opacity));
  }
  .lg\\:focus-within\\:border-teal-400:focus-within {
    --border-opacity: 1;
    border-color: #16bdca;
    border-color: rgba(22, 189, 202, var(--border-opacity));
  }
  .lg\\:focus-within\\:border-teal-500:focus-within {
    --border-opacity: 1;
    border-color: #0694a2;
    border-color: rgba(6, 148, 162, var(--border-opacity));
  }
  .lg\\:focus-within\\:border-teal-600:focus-within {
    --border-opacity: 1;
    border-color: #047481;
    border-color: rgba(4, 116, 129, var(--border-opacity));
  }
  .lg\\:focus-within\\:border-teal-700:focus-within {
    --border-opacity: 1;
    border-color: #036672;
    border-color: rgba(3, 102, 114, var(--border-opacity));
  }
  .lg\\:focus-within\\:border-teal-800:focus-within {
    --border-opacity: 1;
    border-color: #05505c;
    border-color: rgba(5, 80, 92, var(--border-opacity));
  }
  .lg\\:focus-within\\:border-teal-900:focus-within {
    --border-opacity: 1;
    border-color: #014451;
    border-color: rgba(1, 68, 81, var(--border-opacity));
  }
  .lg\\:focus-within\\:border-blue-50:focus-within {
    --border-opacity: 1;
    border-color: #ebf5ff;
    border-color: rgba(235, 245, 255, var(--border-opacity));
  }
  .lg\\:focus-within\\:border-blue-100:focus-within {
    --border-opacity: 1;
    border-color: #e1effe;
    border-color: rgba(225, 239, 254, var(--border-opacity));
  }
  .lg\\:focus-within\\:border-blue-200:focus-within {
    --border-opacity: 1;
    border-color: #c3ddfd;
    border-color: rgba(195, 221, 253, var(--border-opacity));
  }
  .lg\\:focus-within\\:border-blue-300:focus-within {
    --border-opacity: 1;
    border-color: #a4cafe;
    border-color: rgba(164, 202, 254, var(--border-opacity));
  }
  .lg\\:focus-within\\:border-blue-400:focus-within {
    --border-opacity: 1;
    border-color: #76a9fa;
    border-color: rgba(118, 169, 250, var(--border-opacity));
  }
  .lg\\:focus-within\\:border-blue-500:focus-within {
    --border-opacity: 1;
    border-color: #3f83f8;
    border-color: rgba(63, 131, 248, var(--border-opacity));
  }
  .lg\\:focus-within\\:border-blue-600:focus-within {
    --border-opacity: 1;
    border-color: #1c64f2;
    border-color: rgba(28, 100, 242, var(--border-opacity));
  }
  .lg\\:focus-within\\:border-blue-700:focus-within {
    --border-opacity: 1;
    border-color: #1a56db;
    border-color: rgba(26, 86, 219, var(--border-opacity));
  }
  .lg\\:focus-within\\:border-blue-800:focus-within {
    --border-opacity: 1;
    border-color: #1e429f;
    border-color: rgba(30, 66, 159, var(--border-opacity));
  }
  .lg\\:focus-within\\:border-blue-900:focus-within {
    --border-opacity: 1;
    border-color: #233876;
    border-color: rgba(35, 56, 118, var(--border-opacity));
  }
  .lg\\:focus-within\\:border-indigo-50:focus-within {
    --border-opacity: 1;
    border-color: #f0f5ff;
    border-color: rgba(240, 245, 255, var(--border-opacity));
  }
  .lg\\:focus-within\\:border-indigo-100:focus-within {
    --border-opacity: 1;
    border-color: #e5edff;
    border-color: rgba(229, 237, 255, var(--border-opacity));
  }
  .lg\\:focus-within\\:border-indigo-200:focus-within {
    --border-opacity: 1;
    border-color: #cddbfe;
    border-color: rgba(205, 219, 254, var(--border-opacity));
  }
  .lg\\:focus-within\\:border-indigo-300:focus-within {
    --border-opacity: 1;
    border-color: #b4c6fc;
    border-color: rgba(180, 198, 252, var(--border-opacity));
  }
  .lg\\:focus-within\\:border-indigo-400:focus-within {
    --border-opacity: 1;
    border-color: #8da2fb;
    border-color: rgba(141, 162, 251, var(--border-opacity));
  }
  .lg\\:focus-within\\:border-indigo-500:focus-within {
    --border-opacity: 1;
    border-color: #6875f5;
    border-color: rgba(104, 117, 245, var(--border-opacity));
  }
  .lg\\:focus-within\\:border-indigo-600:focus-within {
    --border-opacity: 1;
    border-color: #5850ec;
    border-color: rgba(88, 80, 236, var(--border-opacity));
  }
  .lg\\:focus-within\\:border-indigo-700:focus-within {
    --border-opacity: 1;
    border-color: #5145cd;
    border-color: rgba(81, 69, 205, var(--border-opacity));
  }
  .lg\\:focus-within\\:border-indigo-800:focus-within {
    --border-opacity: 1;
    border-color: #42389d;
    border-color: rgba(66, 56, 157, var(--border-opacity));
  }
  .lg\\:focus-within\\:border-indigo-900:focus-within {
    --border-opacity: 1;
    border-color: #362f78;
    border-color: rgba(54, 47, 120, var(--border-opacity));
  }
  .lg\\:focus-within\\:border-purple-50:focus-within {
    --border-opacity: 1;
    border-color: #f6f5ff;
    border-color: rgba(246, 245, 255, var(--border-opacity));
  }
  .lg\\:focus-within\\:border-purple-100:focus-within {
    --border-opacity: 1;
    border-color: #edebfe;
    border-color: rgba(237, 235, 254, var(--border-opacity));
  }
  .lg\\:focus-within\\:border-purple-200:focus-within {
    --border-opacity: 1;
    border-color: #dcd7fe;
    border-color: rgba(220, 215, 254, var(--border-opacity));
  }
  .lg\\:focus-within\\:border-purple-300:focus-within {
    --border-opacity: 1;
    border-color: #cabffd;
    border-color: rgba(202, 191, 253, var(--border-opacity));
  }
  .lg\\:focus-within\\:border-purple-400:focus-within {
    --border-opacity: 1;
    border-color: #ac94fa;
    border-color: rgba(172, 148, 250, var(--border-opacity));
  }
  .lg\\:focus-within\\:border-purple-500:focus-within {
    --border-opacity: 1;
    border-color: #9061f9;
    border-color: rgba(144, 97, 249, var(--border-opacity));
  }
  .lg\\:focus-within\\:border-purple-600:focus-within {
    --border-opacity: 1;
    border-color: #7e3af2;
    border-color: rgba(126, 58, 242, var(--border-opacity));
  }
  .lg\\:focus-within\\:border-purple-700:focus-within {
    --border-opacity: 1;
    border-color: #6c2bd9;
    border-color: rgba(108, 43, 217, var(--border-opacity));
  }
  .lg\\:focus-within\\:border-purple-800:focus-within {
    --border-opacity: 1;
    border-color: #5521b5;
    border-color: rgba(85, 33, 181, var(--border-opacity));
  }
  .lg\\:focus-within\\:border-purple-900:focus-within {
    --border-opacity: 1;
    border-color: #4a1d96;
    border-color: rgba(74, 29, 150, var(--border-opacity));
  }
  .lg\\:focus-within\\:border-pink-50:focus-within {
    --border-opacity: 1;
    border-color: #fdf2f8;
    border-color: rgba(253, 242, 248, var(--border-opacity));
  }
  .lg\\:focus-within\\:border-pink-100:focus-within {
    --border-opacity: 1;
    border-color: #fce8f3;
    border-color: rgba(252, 232, 243, var(--border-opacity));
  }
  .lg\\:focus-within\\:border-pink-200:focus-within {
    --border-opacity: 1;
    border-color: #fad1e8;
    border-color: rgba(250, 209, 232, var(--border-opacity));
  }
  .lg\\:focus-within\\:border-pink-300:focus-within {
    --border-opacity: 1;
    border-color: #f8b4d9;
    border-color: rgba(248, 180, 217, var(--border-opacity));
  }
  .lg\\:focus-within\\:border-pink-400:focus-within {
    --border-opacity: 1;
    border-color: #f17eb8;
    border-color: rgba(241, 126, 184, var(--border-opacity));
  }
  .lg\\:focus-within\\:border-pink-500:focus-within {
    --border-opacity: 1;
    border-color: #e74694;
    border-color: rgba(231, 70, 148, var(--border-opacity));
  }
  .lg\\:focus-within\\:border-pink-600:focus-within {
    --border-opacity: 1;
    border-color: #d61f69;
    border-color: rgba(214, 31, 105, var(--border-opacity));
  }
  .lg\\:focus-within\\:border-pink-700:focus-within {
    --border-opacity: 1;
    border-color: #bf125d;
    border-color: rgba(191, 18, 93, var(--border-opacity));
  }
  .lg\\:focus-within\\:border-pink-800:focus-within {
    --border-opacity: 1;
    border-color: #99154b;
    border-color: rgba(153, 21, 75, var(--border-opacity));
  }
  .lg\\:focus-within\\:border-pink-900:focus-within {
    --border-opacity: 1;
    border-color: #751a3d;
    border-color: rgba(117, 26, 61, var(--border-opacity));
  }
  .lg\\:focus-within\\:border-cool-gray-50:focus-within {
    --border-opacity: 1;
    border-color: #f8fafc;
    border-color: rgba(248, 250, 252, var(--border-opacity));
  }
  .lg\\:focus-within\\:border-cool-gray-100:focus-within {
    --border-opacity: 1;
    border-color: #f1f5f9;
    border-color: rgba(241, 245, 249, var(--border-opacity));
  }
  .lg\\:focus-within\\:border-cool-gray-200:focus-within {
    --border-opacity: 1;
    border-color: #e2e8f0;
    border-color: rgba(226, 232, 240, var(--border-opacity));
  }
  .lg\\:focus-within\\:border-cool-gray-300:focus-within {
    --border-opacity: 1;
    border-color: #cfd8e3;
    border-color: rgba(207, 216, 227, var(--border-opacity));
  }
  .lg\\:focus-within\\:border-cool-gray-400:focus-within {
    --border-opacity: 1;
    border-color: #97a6ba;
    border-color: rgba(151, 166, 186, var(--border-opacity));
  }
  .lg\\:focus-within\\:border-cool-gray-500:focus-within {
    --border-opacity: 1;
    border-color: #64748b;
    border-color: rgba(100, 116, 139, var(--border-opacity));
  }
  .lg\\:focus-within\\:border-cool-gray-600:focus-within {
    --border-opacity: 1;
    border-color: #475569;
    border-color: rgba(71, 85, 105, var(--border-opacity));
  }
  .lg\\:focus-within\\:border-cool-gray-700:focus-within {
    --border-opacity: 1;
    border-color: #364152;
    border-color: rgba(54, 65, 82, var(--border-opacity));
  }
  .lg\\:focus-within\\:border-cool-gray-800:focus-within {
    --border-opacity: 1;
    border-color: #27303f;
    border-color: rgba(39, 48, 63, var(--border-opacity));
  }
  .lg\\:focus-within\\:border-cool-gray-900:focus-within {
    --border-opacity: 1;
    border-color: #1a202e;
    border-color: rgba(26, 32, 46, var(--border-opacity));
  }
  .lg\\:focus\\:border-current:focus {
    border-color: currentColor;
  }
  .lg\\:focus\\:border-transparent:focus {
    border-color: transparent;
  }
  .lg\\:focus\\:border-white:focus {
    --border-opacity: 1;
    border-color: #ffffff;
    border-color: rgba(255, 255, 255, var(--border-opacity));
  }
  .lg\\:focus\\:border-black:focus {
    --border-opacity: 1;
    border-color: #000000;
    border-color: rgba(0, 0, 0, var(--border-opacity));
  }
  .lg\\:focus\\:border-gray-50:focus {
    --border-opacity: 1;
    border-color: #f9fafb;
    border-color: rgba(249, 250, 251, var(--border-opacity));
  }
  .lg\\:focus\\:border-gray-100:focus {
    --border-opacity: 1;
    border-color: #f4f5f7;
    border-color: rgba(244, 245, 247, var(--border-opacity));
  }
  .lg\\:focus\\:border-gray-200:focus {
    --border-opacity: 1;
    border-color: #e5e7eb;
    border-color: rgba(229, 231, 235, var(--border-opacity));
  }
  .lg\\:focus\\:border-gray-300:focus {
    --border-opacity: 1;
    border-color: #d2d6dc;
    border-color: rgba(210, 214, 220, var(--border-opacity));
  }
  .lg\\:focus\\:border-gray-400:focus {
    --border-opacity: 1;
    border-color: #9fa6b2;
    border-color: rgba(159, 166, 178, var(--border-opacity));
  }
  .lg\\:focus\\:border-gray-500:focus {
    --border-opacity: 1;
    border-color: #6b7280;
    border-color: rgba(107, 114, 128, var(--border-opacity));
  }
  .lg\\:focus\\:border-gray-600:focus {
    --border-opacity: 1;
    border-color: #4b5563;
    border-color: rgba(75, 85, 99, var(--border-opacity));
  }
  .lg\\:focus\\:border-gray-700:focus {
    --border-opacity: 1;
    border-color: #374151;
    border-color: rgba(55, 65, 81, var(--border-opacity));
  }
  .lg\\:focus\\:border-gray-800:focus {
    --border-opacity: 1;
    border-color: #252f3f;
    border-color: rgba(37, 47, 63, var(--border-opacity));
  }
  .lg\\:focus\\:border-gray-900:focus {
    --border-opacity: 1;
    border-color: #161e2e;
    border-color: rgba(22, 30, 46, var(--border-opacity));
  }
  .lg\\:focus\\:border-red-50:focus {
    --border-opacity: 1;
    border-color: #fdf2f2;
    border-color: rgba(253, 242, 242, var(--border-opacity));
  }
  .lg\\:focus\\:border-red-100:focus {
    --border-opacity: 1;
    border-color: #fde8e8;
    border-color: rgba(253, 232, 232, var(--border-opacity));
  }
  .lg\\:focus\\:border-red-200:focus {
    --border-opacity: 1;
    border-color: #fbd5d5;
    border-color: rgba(251, 213, 213, var(--border-opacity));
  }
  .lg\\:focus\\:border-red-300:focus {
    --border-opacity: 1;
    border-color: #f8b4b4;
    border-color: rgba(248, 180, 180, var(--border-opacity));
  }
  .lg\\:focus\\:border-red-400:focus {
    --border-opacity: 1;
    border-color: #f98080;
    border-color: rgba(249, 128, 128, var(--border-opacity));
  }
  .lg\\:focus\\:border-red-500:focus {
    --border-opacity: 1;
    border-color: #f05252;
    border-color: rgba(240, 82, 82, var(--border-opacity));
  }
  .lg\\:focus\\:border-red-600:focus {
    --border-opacity: 1;
    border-color: #e02424;
    border-color: rgba(224, 36, 36, var(--border-opacity));
  }
  .lg\\:focus\\:border-red-700:focus {
    --border-opacity: 1;
    border-color: #c81e1e;
    border-color: rgba(200, 30, 30, var(--border-opacity));
  }
  .lg\\:focus\\:border-red-800:focus {
    --border-opacity: 1;
    border-color: #9b1c1c;
    border-color: rgba(155, 28, 28, var(--border-opacity));
  }
  .lg\\:focus\\:border-red-900:focus {
    --border-opacity: 1;
    border-color: #771d1d;
    border-color: rgba(119, 29, 29, var(--border-opacity));
  }
  .lg\\:focus\\:border-orange-50:focus {
    --border-opacity: 1;
    border-color: #fff8f1;
    border-color: rgba(255, 248, 241, var(--border-opacity));
  }
  .lg\\:focus\\:border-orange-100:focus {
    --border-opacity: 1;
    border-color: #feecdc;
    border-color: rgba(254, 236, 220, var(--border-opacity));
  }
  .lg\\:focus\\:border-orange-200:focus {
    --border-opacity: 1;
    border-color: #fcd9bd;
    border-color: rgba(252, 217, 189, var(--border-opacity));
  }
  .lg\\:focus\\:border-orange-300:focus {
    --border-opacity: 1;
    border-color: #fdba8c;
    border-color: rgba(253, 186, 140, var(--border-opacity));
  }
  .lg\\:focus\\:border-orange-400:focus {
    --border-opacity: 1;
    border-color: #ff8a4c;
    border-color: rgba(255, 138, 76, var(--border-opacity));
  }
  .lg\\:focus\\:border-orange-500:focus {
    --border-opacity: 1;
    border-color: #ff5a1f;
    border-color: rgba(255, 90, 31, var(--border-opacity));
  }
  .lg\\:focus\\:border-orange-600:focus {
    --border-opacity: 1;
    border-color: #d03801;
    border-color: rgba(208, 56, 1, var(--border-opacity));
  }
  .lg\\:focus\\:border-orange-700:focus {
    --border-opacity: 1;
    border-color: #b43403;
    border-color: rgba(180, 52, 3, var(--border-opacity));
  }
  .lg\\:focus\\:border-orange-800:focus {
    --border-opacity: 1;
    border-color: #8a2c0d;
    border-color: rgba(138, 44, 13, var(--border-opacity));
  }
  .lg\\:focus\\:border-orange-900:focus {
    --border-opacity: 1;
    border-color: #73230d;
    border-color: rgba(115, 35, 13, var(--border-opacity));
  }
  .lg\\:focus\\:border-yellow-50:focus {
    --border-opacity: 1;
    border-color: #fdfdea;
    border-color: rgba(253, 253, 234, var(--border-opacity));
  }
  .lg\\:focus\\:border-yellow-100:focus {
    --border-opacity: 1;
    border-color: #fdf6b2;
    border-color: rgba(253, 246, 178, var(--border-opacity));
  }
  .lg\\:focus\\:border-yellow-200:focus {
    --border-opacity: 1;
    border-color: #fce96a;
    border-color: rgba(252, 233, 106, var(--border-opacity));
  }
  .lg\\:focus\\:border-yellow-300:focus {
    --border-opacity: 1;
    border-color: #faca15;
    border-color: rgba(250, 202, 21, var(--border-opacity));
  }
  .lg\\:focus\\:border-yellow-400:focus {
    --border-opacity: 1;
    border-color: #e3a008;
    border-color: rgba(227, 160, 8, var(--border-opacity));
  }
  .lg\\:focus\\:border-yellow-500:focus {
    --border-opacity: 1;
    border-color: #c27803;
    border-color: rgba(194, 120, 3, var(--border-opacity));
  }
  .lg\\:focus\\:border-yellow-600:focus {
    --border-opacity: 1;
    border-color: #9f580a;
    border-color: rgba(159, 88, 10, var(--border-opacity));
  }
  .lg\\:focus\\:border-yellow-700:focus {
    --border-opacity: 1;
    border-color: #8e4b10;
    border-color: rgba(142, 75, 16, var(--border-opacity));
  }
  .lg\\:focus\\:border-yellow-800:focus {
    --border-opacity: 1;
    border-color: #723b13;
    border-color: rgba(114, 59, 19, var(--border-opacity));
  }
  .lg\\:focus\\:border-yellow-900:focus {
    --border-opacity: 1;
    border-color: #633112;
    border-color: rgba(99, 49, 18, var(--border-opacity));
  }
  .lg\\:focus\\:border-green-50:focus {
    --border-opacity: 1;
    border-color: #f3faf7;
    border-color: rgba(243, 250, 247, var(--border-opacity));
  }
  .lg\\:focus\\:border-green-100:focus {
    --border-opacity: 1;
    border-color: #def7ec;
    border-color: rgba(222, 247, 236, var(--border-opacity));
  }
  .lg\\:focus\\:border-green-200:focus {
    --border-opacity: 1;
    border-color: #bcf0da;
    border-color: rgba(188, 240, 218, var(--border-opacity));
  }
  .lg\\:focus\\:border-green-300:focus {
    --border-opacity: 1;
    border-color: #84e1bc;
    border-color: rgba(132, 225, 188, var(--border-opacity));
  }
  .lg\\:focus\\:border-green-400:focus {
    --border-opacity: 1;
    border-color: #31c48d;
    border-color: rgba(49, 196, 141, var(--border-opacity));
  }
  .lg\\:focus\\:border-green-500:focus {
    --border-opacity: 1;
    border-color: #0e9f6e;
    border-color: rgba(14, 159, 110, var(--border-opacity));
  }
  .lg\\:focus\\:border-green-600:focus {
    --border-opacity: 1;
    border-color: #057a55;
    border-color: rgba(5, 122, 85, var(--border-opacity));
  }
  .lg\\:focus\\:border-green-700:focus {
    --border-opacity: 1;
    border-color: #046c4e;
    border-color: rgba(4, 108, 78, var(--border-opacity));
  }
  .lg\\:focus\\:border-green-800:focus {
    --border-opacity: 1;
    border-color: #03543f;
    border-color: rgba(3, 84, 63, var(--border-opacity));
  }
  .lg\\:focus\\:border-green-900:focus {
    --border-opacity: 1;
    border-color: #014737;
    border-color: rgba(1, 71, 55, var(--border-opacity));
  }
  .lg\\:focus\\:border-teal-50:focus {
    --border-opacity: 1;
    border-color: #edfafa;
    border-color: rgba(237, 250, 250, var(--border-opacity));
  }
  .lg\\:focus\\:border-teal-100:focus {
    --border-opacity: 1;
    border-color: #d5f5f6;
    border-color: rgba(213, 245, 246, var(--border-opacity));
  }
  .lg\\:focus\\:border-teal-200:focus {
    --border-opacity: 1;
    border-color: #afecef;
    border-color: rgba(175, 236, 239, var(--border-opacity));
  }
  .lg\\:focus\\:border-teal-300:focus {
    --border-opacity: 1;
    border-color: #7edce2;
    border-color: rgba(126, 220, 226, var(--border-opacity));
  }
  .lg\\:focus\\:border-teal-400:focus {
    --border-opacity: 1;
    border-color: #16bdca;
    border-color: rgba(22, 189, 202, var(--border-opacity));
  }
  .lg\\:focus\\:border-teal-500:focus {
    --border-opacity: 1;
    border-color: #0694a2;
    border-color: rgba(6, 148, 162, var(--border-opacity));
  }
  .lg\\:focus\\:border-teal-600:focus {
    --border-opacity: 1;
    border-color: #047481;
    border-color: rgba(4, 116, 129, var(--border-opacity));
  }
  .lg\\:focus\\:border-teal-700:focus {
    --border-opacity: 1;
    border-color: #036672;
    border-color: rgba(3, 102, 114, var(--border-opacity));
  }
  .lg\\:focus\\:border-teal-800:focus {
    --border-opacity: 1;
    border-color: #05505c;
    border-color: rgba(5, 80, 92, var(--border-opacity));
  }
  .lg\\:focus\\:border-teal-900:focus {
    --border-opacity: 1;
    border-color: #014451;
    border-color: rgba(1, 68, 81, var(--border-opacity));
  }
  .lg\\:focus\\:border-blue-50:focus {
    --border-opacity: 1;
    border-color: #ebf5ff;
    border-color: rgba(235, 245, 255, var(--border-opacity));
  }
  .lg\\:focus\\:border-blue-100:focus {
    --border-opacity: 1;
    border-color: #e1effe;
    border-color: rgba(225, 239, 254, var(--border-opacity));
  }
  .lg\\:focus\\:border-blue-200:focus {
    --border-opacity: 1;
    border-color: #c3ddfd;
    border-color: rgba(195, 221, 253, var(--border-opacity));
  }
  .lg\\:focus\\:border-blue-300:focus {
    --border-opacity: 1;
    border-color: #a4cafe;
    border-color: rgba(164, 202, 254, var(--border-opacity));
  }
  .lg\\:focus\\:border-blue-400:focus {
    --border-opacity: 1;
    border-color: #76a9fa;
    border-color: rgba(118, 169, 250, var(--border-opacity));
  }
  .lg\\:focus\\:border-blue-500:focus {
    --border-opacity: 1;
    border-color: #3f83f8;
    border-color: rgba(63, 131, 248, var(--border-opacity));
  }
  .lg\\:focus\\:border-blue-600:focus {
    --border-opacity: 1;
    border-color: #1c64f2;
    border-color: rgba(28, 100, 242, var(--border-opacity));
  }
  .lg\\:focus\\:border-blue-700:focus {
    --border-opacity: 1;
    border-color: #1a56db;
    border-color: rgba(26, 86, 219, var(--border-opacity));
  }
  .lg\\:focus\\:border-blue-800:focus {
    --border-opacity: 1;
    border-color: #1e429f;
    border-color: rgba(30, 66, 159, var(--border-opacity));
  }
  .lg\\:focus\\:border-blue-900:focus {
    --border-opacity: 1;
    border-color: #233876;
    border-color: rgba(35, 56, 118, var(--border-opacity));
  }
  .lg\\:focus\\:border-indigo-50:focus {
    --border-opacity: 1;
    border-color: #f0f5ff;
    border-color: rgba(240, 245, 255, var(--border-opacity));
  }
  .lg\\:focus\\:border-indigo-100:focus {
    --border-opacity: 1;
    border-color: #e5edff;
    border-color: rgba(229, 237, 255, var(--border-opacity));
  }
  .lg\\:focus\\:border-indigo-200:focus {
    --border-opacity: 1;
    border-color: #cddbfe;
    border-color: rgba(205, 219, 254, var(--border-opacity));
  }
  .lg\\:focus\\:border-indigo-300:focus {
    --border-opacity: 1;
    border-color: #b4c6fc;
    border-color: rgba(180, 198, 252, var(--border-opacity));
  }
  .lg\\:focus\\:border-indigo-400:focus {
    --border-opacity: 1;
    border-color: #8da2fb;
    border-color: rgba(141, 162, 251, var(--border-opacity));
  }
  .lg\\:focus\\:border-indigo-500:focus {
    --border-opacity: 1;
    border-color: #6875f5;
    border-color: rgba(104, 117, 245, var(--border-opacity));
  }
  .lg\\:focus\\:border-indigo-600:focus {
    --border-opacity: 1;
    border-color: #5850ec;
    border-color: rgba(88, 80, 236, var(--border-opacity));
  }
  .lg\\:focus\\:border-indigo-700:focus {
    --border-opacity: 1;
    border-color: #5145cd;
    border-color: rgba(81, 69, 205, var(--border-opacity));
  }
  .lg\\:focus\\:border-indigo-800:focus {
    --border-opacity: 1;
    border-color: #42389d;
    border-color: rgba(66, 56, 157, var(--border-opacity));
  }
  .lg\\:focus\\:border-indigo-900:focus {
    --border-opacity: 1;
    border-color: #362f78;
    border-color: rgba(54, 47, 120, var(--border-opacity));
  }
  .lg\\:focus\\:border-purple-50:focus {
    --border-opacity: 1;
    border-color: #f6f5ff;
    border-color: rgba(246, 245, 255, var(--border-opacity));
  }
  .lg\\:focus\\:border-purple-100:focus {
    --border-opacity: 1;
    border-color: #edebfe;
    border-color: rgba(237, 235, 254, var(--border-opacity));
  }
  .lg\\:focus\\:border-purple-200:focus {
    --border-opacity: 1;
    border-color: #dcd7fe;
    border-color: rgba(220, 215, 254, var(--border-opacity));
  }
  .lg\\:focus\\:border-purple-300:focus {
    --border-opacity: 1;
    border-color: #cabffd;
    border-color: rgba(202, 191, 253, var(--border-opacity));
  }
  .lg\\:focus\\:border-purple-400:focus {
    --border-opacity: 1;
    border-color: #ac94fa;
    border-color: rgba(172, 148, 250, var(--border-opacity));
  }
  .lg\\:focus\\:border-purple-500:focus {
    --border-opacity: 1;
    border-color: #9061f9;
    border-color: rgba(144, 97, 249, var(--border-opacity));
  }
  .lg\\:focus\\:border-purple-600:focus {
    --border-opacity: 1;
    border-color: #7e3af2;
    border-color: rgba(126, 58, 242, var(--border-opacity));
  }
  .lg\\:focus\\:border-purple-700:focus {
    --border-opacity: 1;
    border-color: #6c2bd9;
    border-color: rgba(108, 43, 217, var(--border-opacity));
  }
  .lg\\:focus\\:border-purple-800:focus {
    --border-opacity: 1;
    border-color: #5521b5;
    border-color: rgba(85, 33, 181, var(--border-opacity));
  }
  .lg\\:focus\\:border-purple-900:focus {
    --border-opacity: 1;
    border-color: #4a1d96;
    border-color: rgba(74, 29, 150, var(--border-opacity));
  }
  .lg\\:focus\\:border-pink-50:focus {
    --border-opacity: 1;
    border-color: #fdf2f8;
    border-color: rgba(253, 242, 248, var(--border-opacity));
  }
  .lg\\:focus\\:border-pink-100:focus {
    --border-opacity: 1;
    border-color: #fce8f3;
    border-color: rgba(252, 232, 243, var(--border-opacity));
  }
  .lg\\:focus\\:border-pink-200:focus {
    --border-opacity: 1;
    border-color: #fad1e8;
    border-color: rgba(250, 209, 232, var(--border-opacity));
  }
  .lg\\:focus\\:border-pink-300:focus {
    --border-opacity: 1;
    border-color: #f8b4d9;
    border-color: rgba(248, 180, 217, var(--border-opacity));
  }
  .lg\\:focus\\:border-pink-400:focus {
    --border-opacity: 1;
    border-color: #f17eb8;
    border-color: rgba(241, 126, 184, var(--border-opacity));
  }
  .lg\\:focus\\:border-pink-500:focus {
    --border-opacity: 1;
    border-color: #e74694;
    border-color: rgba(231, 70, 148, var(--border-opacity));
  }
  .lg\\:focus\\:border-pink-600:focus {
    --border-opacity: 1;
    border-color: #d61f69;
    border-color: rgba(214, 31, 105, var(--border-opacity));
  }
  .lg\\:focus\\:border-pink-700:focus {
    --border-opacity: 1;
    border-color: #bf125d;
    border-color: rgba(191, 18, 93, var(--border-opacity));
  }
  .lg\\:focus\\:border-pink-800:focus {
    --border-opacity: 1;
    border-color: #99154b;
    border-color: rgba(153, 21, 75, var(--border-opacity));
  }
  .lg\\:focus\\:border-pink-900:focus {
    --border-opacity: 1;
    border-color: #751a3d;
    border-color: rgba(117, 26, 61, var(--border-opacity));
  }
  .lg\\:focus\\:border-cool-gray-50:focus {
    --border-opacity: 1;
    border-color: #f8fafc;
    border-color: rgba(248, 250, 252, var(--border-opacity));
  }
  .lg\\:focus\\:border-cool-gray-100:focus {
    --border-opacity: 1;
    border-color: #f1f5f9;
    border-color: rgba(241, 245, 249, var(--border-opacity));
  }
  .lg\\:focus\\:border-cool-gray-200:focus {
    --border-opacity: 1;
    border-color: #e2e8f0;
    border-color: rgba(226, 232, 240, var(--border-opacity));
  }
  .lg\\:focus\\:border-cool-gray-300:focus {
    --border-opacity: 1;
    border-color: #cfd8e3;
    border-color: rgba(207, 216, 227, var(--border-opacity));
  }
  .lg\\:focus\\:border-cool-gray-400:focus {
    --border-opacity: 1;
    border-color: #97a6ba;
    border-color: rgba(151, 166, 186, var(--border-opacity));
  }
  .lg\\:focus\\:border-cool-gray-500:focus {
    --border-opacity: 1;
    border-color: #64748b;
    border-color: rgba(100, 116, 139, var(--border-opacity));
  }
  .lg\\:focus\\:border-cool-gray-600:focus {
    --border-opacity: 1;
    border-color: #475569;
    border-color: rgba(71, 85, 105, var(--border-opacity));
  }
  .lg\\:focus\\:border-cool-gray-700:focus {
    --border-opacity: 1;
    border-color: #364152;
    border-color: rgba(54, 65, 82, var(--border-opacity));
  }
  .lg\\:focus\\:border-cool-gray-800:focus {
    --border-opacity: 1;
    border-color: #27303f;
    border-color: rgba(39, 48, 63, var(--border-opacity));
  }
  .lg\\:focus\\:border-cool-gray-900:focus {
    --border-opacity: 1;
    border-color: #1a202e;
    border-color: rgba(26, 32, 46, var(--border-opacity));
  }
  .lg\\:border-opacity-0 {
    --border-opacity: 0;
  }
  .lg\\:border-opacity-25 {
    --border-opacity: 0.25;
  }
  .lg\\:border-opacity-50 {
    --border-opacity: 0.5;
  }
  .lg\\:border-opacity-75 {
    --border-opacity: 0.75;
  }
  .lg\\:border-opacity-100 {
    --border-opacity: 1;
  }
  .lg\\:hover\\:border-opacity-0:hover {
    --border-opacity: 0;
  }
  .lg\\:hover\\:border-opacity-25:hover {
    --border-opacity: 0.25;
  }
  .lg\\:hover\\:border-opacity-50:hover {
    --border-opacity: 0.5;
  }
  .lg\\:hover\\:border-opacity-75:hover {
    --border-opacity: 0.75;
  }
  .lg\\:hover\\:border-opacity-100:hover {
    --border-opacity: 1;
  }
  .lg\\:focus\\:border-opacity-0:focus {
    --border-opacity: 0;
  }
  .lg\\:focus\\:border-opacity-25:focus {
    --border-opacity: 0.25;
  }
  .lg\\:focus\\:border-opacity-50:focus {
    --border-opacity: 0.5;
  }
  .lg\\:focus\\:border-opacity-75:focus {
    --border-opacity: 0.75;
  }
  .lg\\:focus\\:border-opacity-100:focus {
    --border-opacity: 1;
  }
  .lg\\:rounded-none {
    border-radius: 0;
  }
  .lg\\:rounded-sm {
    border-radius: 0.125rem;
  }
  .lg\\:rounded {
    border-radius: 0.25rem;
  }
  .lg\\:rounded-md {
    border-radius: 0.375rem;
  }
  .lg\\:rounded-lg {
    border-radius: 0.5rem;
  }
  .lg\\:rounded-xl {
    border-radius: 0.75rem;
  }
  .lg\\:rounded-2xl {
    border-radius: 1rem;
  }
  .lg\\:rounded-3xl {
    border-radius: 1.5rem;
  }
  .lg\\:rounded-full {
    border-radius: 9999px;
  }
  .lg\\:rounded-t-none {
    border-top-left-radius: 0;
    border-top-right-radius: 0;
  }
  .lg\\:rounded-r-none {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
  .lg\\:rounded-b-none {
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0;
  }
  .lg\\:rounded-l-none {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
  .lg\\:rounded-t-sm {
    border-top-left-radius: 0.125rem;
    border-top-right-radius: 0.125rem;
  }
  .lg\\:rounded-r-sm {
    border-top-right-radius: 0.125rem;
    border-bottom-right-radius: 0.125rem;
  }
  .lg\\:rounded-b-sm {
    border-bottom-right-radius: 0.125rem;
    border-bottom-left-radius: 0.125rem;
  }
  .lg\\:rounded-l-sm {
    border-top-left-radius: 0.125rem;
    border-bottom-left-radius: 0.125rem;
  }
  .lg\\:rounded-t {
    border-top-left-radius: 0.25rem;
    border-top-right-radius: 0.25rem;
  }
  .lg\\:rounded-r {
    border-top-right-radius: 0.25rem;
    border-bottom-right-radius: 0.25rem;
  }
  .lg\\:rounded-b {
    border-bottom-right-radius: 0.25rem;
    border-bottom-left-radius: 0.25rem;
  }
  .lg\\:rounded-l {
    border-top-left-radius: 0.25rem;
    border-bottom-left-radius: 0.25rem;
  }
  .lg\\:rounded-t-md {
    border-top-left-radius: 0.375rem;
    border-top-right-radius: 0.375rem;
  }
  .lg\\:rounded-r-md {
    border-top-right-radius: 0.375rem;
    border-bottom-right-radius: 0.375rem;
  }
  .lg\\:rounded-b-md {
    border-bottom-right-radius: 0.375rem;
    border-bottom-left-radius: 0.375rem;
  }
  .lg\\:rounded-l-md {
    border-top-left-radius: 0.375rem;
    border-bottom-left-radius: 0.375rem;
  }
  .lg\\:rounded-t-lg {
    border-top-left-radius: 0.5rem;
    border-top-right-radius: 0.5rem;
  }
  .lg\\:rounded-r-lg {
    border-top-right-radius: 0.5rem;
    border-bottom-right-radius: 0.5rem;
  }
  .lg\\:rounded-b-lg {
    border-bottom-right-radius: 0.5rem;
    border-bottom-left-radius: 0.5rem;
  }
  .lg\\:rounded-l-lg {
    border-top-left-radius: 0.5rem;
    border-bottom-left-radius: 0.5rem;
  }
  .lg\\:rounded-t-xl {
    border-top-left-radius: 0.75rem;
    border-top-right-radius: 0.75rem;
  }
  .lg\\:rounded-r-xl {
    border-top-right-radius: 0.75rem;
    border-bottom-right-radius: 0.75rem;
  }
  .lg\\:rounded-b-xl {
    border-bottom-right-radius: 0.75rem;
    border-bottom-left-radius: 0.75rem;
  }
  .lg\\:rounded-l-xl {
    border-top-left-radius: 0.75rem;
    border-bottom-left-radius: 0.75rem;
  }
  .lg\\:rounded-t-2xl {
    border-top-left-radius: 1rem;
    border-top-right-radius: 1rem;
  }
  .lg\\:rounded-r-2xl {
    border-top-right-radius: 1rem;
    border-bottom-right-radius: 1rem;
  }
  .lg\\:rounded-b-2xl {
    border-bottom-right-radius: 1rem;
    border-bottom-left-radius: 1rem;
  }
  .lg\\:rounded-l-2xl {
    border-top-left-radius: 1rem;
    border-bottom-left-radius: 1rem;
  }
  .lg\\:rounded-t-3xl {
    border-top-left-radius: 1.5rem;
    border-top-right-radius: 1.5rem;
  }
  .lg\\:rounded-r-3xl {
    border-top-right-radius: 1.5rem;
    border-bottom-right-radius: 1.5rem;
  }
  .lg\\:rounded-b-3xl {
    border-bottom-right-radius: 1.5rem;
    border-bottom-left-radius: 1.5rem;
  }
  .lg\\:rounded-l-3xl {
    border-top-left-radius: 1.5rem;
    border-bottom-left-radius: 1.5rem;
  }
  .lg\\:rounded-t-full {
    border-top-left-radius: 9999px;
    border-top-right-radius: 9999px;
  }
  .lg\\:rounded-r-full {
    border-top-right-radius: 9999px;
    border-bottom-right-radius: 9999px;
  }
  .lg\\:rounded-b-full {
    border-bottom-right-radius: 9999px;
    border-bottom-left-radius: 9999px;
  }
  .lg\\:rounded-l-full {
    border-top-left-radius: 9999px;
    border-bottom-left-radius: 9999px;
  }
  .lg\\:rounded-tl-none {
    border-top-left-radius: 0;
  }
  .lg\\:rounded-tr-none {
    border-top-right-radius: 0;
  }
  .lg\\:rounded-br-none {
    border-bottom-right-radius: 0;
  }
  .lg\\:rounded-bl-none {
    border-bottom-left-radius: 0;
  }
  .lg\\:rounded-tl-sm {
    border-top-left-radius: 0.125rem;
  }
  .lg\\:rounded-tr-sm {
    border-top-right-radius: 0.125rem;
  }
  .lg\\:rounded-br-sm {
    border-bottom-right-radius: 0.125rem;
  }
  .lg\\:rounded-bl-sm {
    border-bottom-left-radius: 0.125rem;
  }
  .lg\\:rounded-tl {
    border-top-left-radius: 0.25rem;
  }
  .lg\\:rounded-tr {
    border-top-right-radius: 0.25rem;
  }
  .lg\\:rounded-br {
    border-bottom-right-radius: 0.25rem;
  }
  .lg\\:rounded-bl {
    border-bottom-left-radius: 0.25rem;
  }
  .lg\\:rounded-tl-md {
    border-top-left-radius: 0.375rem;
  }
  .lg\\:rounded-tr-md {
    border-top-right-radius: 0.375rem;
  }
  .lg\\:rounded-br-md {
    border-bottom-right-radius: 0.375rem;
  }
  .lg\\:rounded-bl-md {
    border-bottom-left-radius: 0.375rem;
  }
  .lg\\:rounded-tl-lg {
    border-top-left-radius: 0.5rem;
  }
  .lg\\:rounded-tr-lg {
    border-top-right-radius: 0.5rem;
  }
  .lg\\:rounded-br-lg {
    border-bottom-right-radius: 0.5rem;
  }
  .lg\\:rounded-bl-lg {
    border-bottom-left-radius: 0.5rem;
  }
  .lg\\:rounded-tl-xl {
    border-top-left-radius: 0.75rem;
  }
  .lg\\:rounded-tr-xl {
    border-top-right-radius: 0.75rem;
  }
  .lg\\:rounded-br-xl {
    border-bottom-right-radius: 0.75rem;
  }
  .lg\\:rounded-bl-xl {
    border-bottom-left-radius: 0.75rem;
  }
  .lg\\:rounded-tl-2xl {
    border-top-left-radius: 1rem;
  }
  .lg\\:rounded-tr-2xl {
    border-top-right-radius: 1rem;
  }
  .lg\\:rounded-br-2xl {
    border-bottom-right-radius: 1rem;
  }
  .lg\\:rounded-bl-2xl {
    border-bottom-left-radius: 1rem;
  }
  .lg\\:rounded-tl-3xl {
    border-top-left-radius: 1.5rem;
  }
  .lg\\:rounded-tr-3xl {
    border-top-right-radius: 1.5rem;
  }
  .lg\\:rounded-br-3xl {
    border-bottom-right-radius: 1.5rem;
  }
  .lg\\:rounded-bl-3xl {
    border-bottom-left-radius: 1.5rem;
  }
  .lg\\:rounded-tl-full {
    border-top-left-radius: 9999px;
  }
  .lg\\:rounded-tr-full {
    border-top-right-radius: 9999px;
  }
  .lg\\:rounded-br-full {
    border-bottom-right-radius: 9999px;
  }
  .lg\\:rounded-bl-full {
    border-bottom-left-radius: 9999px;
  }
  .lg\\:border-solid {
    border-style: solid;
  }
  .lg\\:border-dashed {
    border-style: dashed;
  }
  .lg\\:border-dotted {
    border-style: dotted;
  }
  .lg\\:border-double {
    border-style: double;
  }
  .lg\\:border-none {
    border-style: none;
  }
  .lg\\:border-0 {
    border-width: 0;
  }
  .lg\\:border-2 {
    border-width: 2px;
  }
  .lg\\:border-4 {
    border-width: 4px;
  }
  .lg\\:border-8 {
    border-width: 8px;
  }
  .lg\\:border {
    border-width: 1px;
  }
  .lg\\:border-t-0 {
    border-top-width: 0;
  }
  .lg\\:border-r-0 {
    border-right-width: 0;
  }
  .lg\\:border-b-0 {
    border-bottom-width: 0;
  }
  .lg\\:border-l-0 {
    border-left-width: 0;
  }
  .lg\\:border-t-2 {
    border-top-width: 2px;
  }
  .lg\\:border-r-2 {
    border-right-width: 2px;
  }
  .lg\\:border-b-2 {
    border-bottom-width: 2px;
  }
  .lg\\:border-l-2 {
    border-left-width: 2px;
  }
  .lg\\:border-t-4 {
    border-top-width: 4px;
  }
  .lg\\:border-r-4 {
    border-right-width: 4px;
  }
  .lg\\:border-b-4 {
    border-bottom-width: 4px;
  }
  .lg\\:border-l-4 {
    border-left-width: 4px;
  }
  .lg\\:border-t-8 {
    border-top-width: 8px;
  }
  .lg\\:border-r-8 {
    border-right-width: 8px;
  }
  .lg\\:border-b-8 {
    border-bottom-width: 8px;
  }
  .lg\\:border-l-8 {
    border-left-width: 8px;
  }
  .lg\\:border-t {
    border-top-width: 1px;
  }
  .lg\\:border-r {
    border-right-width: 1px;
  }
  .lg\\:border-b {
    border-bottom-width: 1px;
  }
  .lg\\:border-l {
    border-left-width: 1px;
  }
  .lg\\:box-border {
    box-sizing: border-box;
  }
  .lg\\:box-content {
    box-sizing: content-box;
  }
  .lg\\:cursor-auto {
    cursor: auto;
  }
  .lg\\:cursor-default {
    cursor: default;
  }
  .lg\\:cursor-pointer {
    cursor: pointer;
  }
  .lg\\:cursor-wait {
    cursor: wait;
  }
  .lg\\:cursor-text {
    cursor: text;
  }
  .lg\\:cursor-move {
    cursor: move;
  }
  .lg\\:cursor-not-allowed {
    cursor: not-allowed;
  }
  .lg\\:block {
    display: block;
  }
  .lg\\:inline-block {
    display: inline-block;
  }
  .lg\\:inline {
    display: inline;
  }
  .lg\\:flex {
    display: flex;
  }
  .lg\\:inline-flex {
    display: inline-flex;
  }
  .lg\\:table {
    display: table;
  }
  .lg\\:table-caption {
    display: table-caption;
  }
  .lg\\:table-cell {
    display: table-cell;
  }
  .lg\\:table-column {
    display: table-column;
  }
  .lg\\:table-column-group {
    display: table-column-group;
  }
  .lg\\:table-footer-group {
    display: table-footer-group;
  }
  .lg\\:table-header-group {
    display: table-header-group;
  }
  .lg\\:table-row-group {
    display: table-row-group;
  }
  .lg\\:table-row {
    display: table-row;
  }
  .lg\\:flow-root {
    display: flow-root;
  }
  .lg\\:grid {
    display: grid;
  }
  .lg\\:inline-grid {
    display: inline-grid;
  }
  .lg\\:contents {
    display: contents;
  }
  .lg\\:hidden {
    display: none;
  }
  .lg\\:flex-row {
    flex-direction: row;
  }
  .lg\\:flex-row-reverse {
    flex-direction: row-reverse;
  }
  .lg\\:flex-col {
    flex-direction: column;
  }
  .lg\\:flex-col-reverse {
    flex-direction: column-reverse;
  }
  .lg\\:flex-wrap {
    flex-wrap: wrap;
  }
  .lg\\:flex-wrap-reverse {
    flex-wrap: wrap-reverse;
  }
  .lg\\:flex-no-wrap {
    flex-wrap: nowrap;
  }
  .lg\\:place-items-auto {
    place-items: auto;
  }
  .lg\\:place-items-start {
    place-items: start;
  }
  .lg\\:place-items-end {
    place-items: end;
  }
  .lg\\:place-items-center {
    place-items: center;
  }
  .lg\\:place-items-stretch {
    place-items: stretch;
  }
  .lg\\:place-content-center {
    place-content: center;
  }
  .lg\\:place-content-start {
    place-content: start;
  }
  .lg\\:place-content-end {
    place-content: end;
  }
  .lg\\:place-content-between {
    place-content: space-between;
  }
  .lg\\:place-content-around {
    place-content: space-around;
  }
  .lg\\:place-content-evenly {
    place-content: space-evenly;
  }
  .lg\\:place-content-stretch {
    place-content: stretch;
  }
  .lg\\:place-self-auto {
    place-self: auto;
  }
  .lg\\:place-self-start {
    place-self: start;
  }
  .lg\\:place-self-end {
    place-self: end;
  }
  .lg\\:place-self-center {
    place-self: center;
  }
  .lg\\:place-self-stretch {
    place-self: stretch;
  }
  .lg\\:items-start {
    align-items: flex-start;
  }
  .lg\\:items-end {
    align-items: flex-end;
  }
  .lg\\:items-center {
    align-items: center;
  }
  .lg\\:items-baseline {
    align-items: baseline;
  }
  .lg\\:items-stretch {
    align-items: stretch;
  }
  .lg\\:content-center {
    align-content: center;
  }
  .lg\\:content-start {
    align-content: flex-start;
  }
  .lg\\:content-end {
    align-content: flex-end;
  }
  .lg\\:content-between {
    align-content: space-between;
  }
  .lg\\:content-around {
    align-content: space-around;
  }
  .lg\\:content-evenly {
    align-content: space-evenly;
  }
  .lg\\:self-auto {
    align-self: auto;
  }
  .lg\\:self-start {
    align-self: flex-start;
  }
  .lg\\:self-end {
    align-self: flex-end;
  }
  .lg\\:self-center {
    align-self: center;
  }
  .lg\\:self-stretch {
    align-self: stretch;
  }
  .lg\\:justify-items-auto {
    justify-items: auto;
  }
  .lg\\:justify-items-start {
    justify-items: start;
  }
  .lg\\:justify-items-end {
    justify-items: end;
  }
  .lg\\:justify-items-center {
    justify-items: center;
  }
  .lg\\:justify-items-stretch {
    justify-items: stretch;
  }
  .lg\\:justify-start {
    justify-content: flex-start;
  }
  .lg\\:justify-end {
    justify-content: flex-end;
  }
  .lg\\:justify-center {
    justify-content: center;
  }
  .lg\\:justify-between {
    justify-content: space-between;
  }
  .lg\\:justify-around {
    justify-content: space-around;
  }
  .lg\\:justify-evenly {
    justify-content: space-evenly;
  }
  .lg\\:justify-self-auto {
    justify-self: auto;
  }
  .lg\\:justify-self-start {
    justify-self: start;
  }
  .lg\\:justify-self-end {
    justify-self: end;
  }
  .lg\\:justify-self-center {
    justify-self: center;
  }
  .lg\\:justify-self-stretch {
    justify-self: stretch;
  }
  .lg\\:flex-1 {
    flex: 1 1;
  }
  .lg\\:flex-auto {
    flex: 1 1 auto;
  }
  .lg\\:flex-initial {
    flex: 0 1 auto;
  }
  .lg\\:flex-none {
    flex: none;
  }
  .lg\\:flex-grow-0 {
    flex-grow: 0;
  }
  .lg\\:flex-grow {
    flex-grow: 1;
  }
  .lg\\:flex-shrink-0 {
    flex-shrink: 0;
  }
  .lg\\:flex-shrink {
    flex-shrink: 1;
  }
  .lg\\:order-1 {
    order: 1;
  }
  .lg\\:order-2 {
    order: 2;
  }
  .lg\\:order-3 {
    order: 3;
  }
  .lg\\:order-4 {
    order: 4;
  }
  .lg\\:order-5 {
    order: 5;
  }
  .lg\\:order-6 {
    order: 6;
  }
  .lg\\:order-7 {
    order: 7;
  }
  .lg\\:order-8 {
    order: 8;
  }
  .lg\\:order-9 {
    order: 9;
  }
  .lg\\:order-10 {
    order: 10;
  }
  .lg\\:order-11 {
    order: 11;
  }
  .lg\\:order-12 {
    order: 12;
  }
  .lg\\:order-first {
    order: -9999;
  }
  .lg\\:order-last {
    order: 9999;
  }
  .lg\\:order-none {
    order: 0;
  }
  .lg\\:float-right {
    float: right;
  }
  .lg\\:float-left {
    float: left;
  }
  .lg\\:float-none {
    float: none;
  }
  .lg\\:clearfix:after {
    content: "";
    display: table;
    clear: both;
  }
  .lg\\:clear-left {
    clear: left;
  }
  .lg\\:clear-right {
    clear: right;
  }
  .lg\\:clear-both {
    clear: both;
  }
  .lg\\:clear-none {
    clear: none;
  }
  .lg\\:font-sans {
    font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  }
  .lg\\:font-serif {
    font-family: Georgia, Cambria, "Times New Roman", Times, serif;
  }
  .lg\\:font-mono {
    font-family: Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  }
  .lg\\:font-hairline {
    font-weight: 100;
  }
  .lg\\:font-thin {
    font-weight: 200;
  }
  .lg\\:font-light {
    font-weight: 300;
  }
  .lg\\:font-normal {
    font-weight: 400;
  }
  .lg\\:font-medium {
    font-weight: 500;
  }
  .lg\\:font-semibold {
    font-weight: 600;
  }
  .lg\\:font-bold {
    font-weight: 700;
  }
  .lg\\:font-extrabold {
    font-weight: 800;
  }
  .lg\\:font-black {
    font-weight: 900;
  }
  .lg\\:hover\\:font-hairline:hover {
    font-weight: 100;
  }
  .lg\\:hover\\:font-thin:hover {
    font-weight: 200;
  }
  .lg\\:hover\\:font-light:hover {
    font-weight: 300;
  }
  .lg\\:hover\\:font-normal:hover {
    font-weight: 400;
  }
  .lg\\:hover\\:font-medium:hover {
    font-weight: 500;
  }
  .lg\\:hover\\:font-semibold:hover {
    font-weight: 600;
  }
  .lg\\:hover\\:font-bold:hover {
    font-weight: 700;
  }
  .lg\\:hover\\:font-extrabold:hover {
    font-weight: 800;
  }
  .lg\\:hover\\:font-black:hover {
    font-weight: 900;
  }
  .lg\\:focus\\:font-hairline:focus {
    font-weight: 100;
  }
  .lg\\:focus\\:font-thin:focus {
    font-weight: 200;
  }
  .lg\\:focus\\:font-light:focus {
    font-weight: 300;
  }
  .lg\\:focus\\:font-normal:focus {
    font-weight: 400;
  }
  .lg\\:focus\\:font-medium:focus {
    font-weight: 500;
  }
  .lg\\:focus\\:font-semibold:focus {
    font-weight: 600;
  }
  .lg\\:focus\\:font-bold:focus {
    font-weight: 700;
  }
  .lg\\:focus\\:font-extrabold:focus {
    font-weight: 800;
  }
  .lg\\:focus\\:font-black:focus {
    font-weight: 900;
  }
  .lg\\:h-0 {
    height: 0;
  }
  .lg\\:h-1 {
    height: 0.25rem;
  }
  .lg\\:h-2 {
    height: 0.5rem;
  }
  .lg\\:h-3 {
    height: 0.75rem;
  }
  .lg\\:h-4 {
    height: 1rem;
  }
  .lg\\:h-5 {
    height: 1.25rem;
  }
  .lg\\:h-6 {
    height: 1.5rem;
  }
  .lg\\:h-7 {
    height: 1.75rem;
  }
  .lg\\:h-8 {
    height: 2rem;
  }
  .lg\\:h-9 {
    height: 2.25rem;
  }
  .lg\\:h-10 {
    height: 2.5rem;
  }
  .lg\\:h-11 {
    height: 2.75rem;
  }
  .lg\\:h-12 {
    height: 3rem;
  }
  .lg\\:h-13 {
    height: 3.25rem;
  }
  .lg\\:h-14 {
    height: 3.5rem;
  }
  .lg\\:h-15 {
    height: 3.75rem;
  }
  .lg\\:h-16 {
    height: 4rem;
  }
  .lg\\:h-20 {
    height: 5rem;
  }
  .lg\\:h-24 {
    height: 6rem;
  }
  .lg\\:h-28 {
    height: 7rem;
  }
  .lg\\:h-32 {
    height: 8rem;
  }
  .lg\\:h-36 {
    height: 9rem;
  }
  .lg\\:h-40 {
    height: 10rem;
  }
  .lg\\:h-44 {
    height: 11rem;
  }
  .lg\\:h-48 {
    height: 12rem;
  }
  .lg\\:h-52 {
    height: 13rem;
  }
  .lg\\:h-56 {
    height: 14rem;
  }
  .lg\\:h-60 {
    height: 15rem;
  }
  .lg\\:h-64 {
    height: 16rem;
  }
  .lg\\:h-72 {
    height: 18rem;
  }
  .lg\\:h-80 {
    height: 20rem;
  }
  .lg\\:h-96 {
    height: 24rem;
  }
  .lg\\:h-auto {
    height: auto;
  }
  .lg\\:h-px {
    height: 1px;
  }
  .lg\\:h-0\\.5 {
    height: 0.125rem;
  }
  .lg\\:h-1\\.5 {
    height: 0.375rem;
  }
  .lg\\:h-2\\.5 {
    height: 0.625rem;
  }
  .lg\\:h-3\\.5 {
    height: 0.875rem;
  }
  .lg\\:h-1\\/2 {
    height: 50%;
  }
  .lg\\:h-1\\/3 {
    height: 33.333333%;
  }
  .lg\\:h-2\\/3 {
    height: 66.666667%;
  }
  .lg\\:h-1\\/4 {
    height: 25%;
  }
  .lg\\:h-2\\/4 {
    height: 50%;
  }
  .lg\\:h-3\\/4 {
    height: 75%;
  }
  .lg\\:h-1\\/5 {
    height: 20%;
  }
  .lg\\:h-2\\/5 {
    height: 40%;
  }
  .lg\\:h-3\\/5 {
    height: 60%;
  }
  .lg\\:h-4\\/5 {
    height: 80%;
  }
  .lg\\:h-1\\/6 {
    height: 16.666667%;
  }
  .lg\\:h-2\\/6 {
    height: 33.333333%;
  }
  .lg\\:h-3\\/6 {
    height: 50%;
  }
  .lg\\:h-4\\/6 {
    height: 66.666667%;
  }
  .lg\\:h-5\\/6 {
    height: 83.333333%;
  }
  .lg\\:h-1\\/12 {
    height: 8.333333%;
  }
  .lg\\:h-2\\/12 {
    height: 16.666667%;
  }
  .lg\\:h-3\\/12 {
    height: 25%;
  }
  .lg\\:h-4\\/12 {
    height: 33.333333%;
  }
  .lg\\:h-5\\/12 {
    height: 41.666667%;
  }
  .lg\\:h-6\\/12 {
    height: 50%;
  }
  .lg\\:h-7\\/12 {
    height: 58.333333%;
  }
  .lg\\:h-8\\/12 {
    height: 66.666667%;
  }
  .lg\\:h-9\\/12 {
    height: 75%;
  }
  .lg\\:h-10\\/12 {
    height: 83.333333%;
  }
  .lg\\:h-11\\/12 {
    height: 91.666667%;
  }
  .lg\\:h-full {
    height: 100%;
  }
  .lg\\:h-screen {
    height: 100vh;
  }
  .lg\\:text-xs {
    font-size: 0.75rem;
  }
  .lg\\:text-sm {
    font-size: 0.875rem;
  }
  .lg\\:text-base {
    font-size: 1rem;
  }
  .lg\\:text-lg {
    font-size: 1.125rem;
  }
  .lg\\:text-xl {
    font-size: 1.25rem;
  }
  .lg\\:text-2xl {
    font-size: 1.5rem;
  }
  .lg\\:text-3xl {
    font-size: 1.875rem;
  }
  .lg\\:text-4xl {
    font-size: 2.25rem;
  }
  .lg\\:text-5xl {
    font-size: 3rem;
  }
  .lg\\:text-6xl {
    font-size: 4rem;
  }
  .lg\\:leading-3 {
    line-height: .75rem;
  }
  .lg\\:leading-4 {
    line-height: 1rem;
  }
  .lg\\:leading-5 {
    line-height: 1.25rem;
  }
  .lg\\:leading-6 {
    line-height: 1.5rem;
  }
  .lg\\:leading-7 {
    line-height: 1.75rem;
  }
  .lg\\:leading-8 {
    line-height: 2rem;
  }
  .lg\\:leading-9 {
    line-height: 2.25rem;
  }
  .lg\\:leading-10 {
    line-height: 2.5rem;
  }
  .lg\\:leading-none {
    line-height: 1;
  }
  .lg\\:leading-tight {
    line-height: 1.25;
  }
  .lg\\:leading-snug {
    line-height: 1.375;
  }
  .lg\\:leading-normal {
    line-height: 1.5;
  }
  .lg\\:leading-relaxed {
    line-height: 1.625;
  }
  .lg\\:leading-loose {
    line-height: 2;
  }
  .lg\\:list-inside {
    list-style-position: inside;
  }
  .lg\\:list-outside {
    list-style-position: outside;
  }
  .lg\\:list-none {
    list-style-type: none;
  }
  .lg\\:list-disc {
    list-style-type: disc;
  }
  .lg\\:list-decimal {
    list-style-type: decimal;
  }
  .lg\\:m-0 {
    margin: 0;
  }
  .lg\\:m-1 {
    margin: 0.25rem;
  }
  .lg\\:m-2 {
    margin: 0.5rem;
  }
  .lg\\:m-3 {
    margin: 0.75rem;
  }
  .lg\\:m-4 {
    margin: 1rem;
  }
  .lg\\:m-5 {
    margin: 1.25rem;
  }
  .lg\\:m-6 {
    margin: 1.5rem;
  }
  .lg\\:m-7 {
    margin: 1.75rem;
  }
  .lg\\:m-8 {
    margin: 2rem;
  }
  .lg\\:m-9 {
    margin: 2.25rem;
  }
  .lg\\:m-10 {
    margin: 2.5rem;
  }
  .lg\\:m-11 {
    margin: 2.75rem;
  }
  .lg\\:m-12 {
    margin: 3rem;
  }
  .lg\\:m-13 {
    margin: 3.25rem;
  }
  .lg\\:m-14 {
    margin: 3.5rem;
  }
  .lg\\:m-15 {
    margin: 3.75rem;
  }
  .lg\\:m-16 {
    margin: 4rem;
  }
  .lg\\:m-20 {
    margin: 5rem;
  }
  .lg\\:m-24 {
    margin: 6rem;
  }
  .lg\\:m-28 {
    margin: 7rem;
  }
  .lg\\:m-32 {
    margin: 8rem;
  }
  .lg\\:m-36 {
    margin: 9rem;
  }
  .lg\\:m-40 {
    margin: 10rem;
  }
  .lg\\:m-44 {
    margin: 11rem;
  }
  .lg\\:m-48 {
    margin: 12rem;
  }
  .lg\\:m-52 {
    margin: 13rem;
  }
  .lg\\:m-56 {
    margin: 14rem;
  }
  .lg\\:m-60 {
    margin: 15rem;
  }
  .lg\\:m-64 {
    margin: 16rem;
  }
  .lg\\:m-72 {
    margin: 18rem;
  }
  .lg\\:m-80 {
    margin: 20rem;
  }
  .lg\\:m-96 {
    margin: 24rem;
  }
  .lg\\:m-auto {
    margin: auto;
  }
  .lg\\:m-px {
    margin: 1px;
  }
  .lg\\:m-0\\.5 {
    margin: 0.125rem;
  }
  .lg\\:m-1\\.5 {
    margin: 0.375rem;
  }
  .lg\\:m-2\\.5 {
    margin: 0.625rem;
  }
  .lg\\:m-3\\.5 {
    margin: 0.875rem;
  }
  .lg\\:m-1\\/2 {
    margin: 50%;
  }
  .lg\\:m-1\\/3 {
    margin: 33.333333%;
  }
  .lg\\:m-2\\/3 {
    margin: 66.666667%;
  }
  .lg\\:m-1\\/4 {
    margin: 25%;
  }
  .lg\\:m-2\\/4 {
    margin: 50%;
  }
  .lg\\:m-3\\/4 {
    margin: 75%;
  }
  .lg\\:m-1\\/5 {
    margin: 20%;
  }
  .lg\\:m-2\\/5 {
    margin: 40%;
  }
  .lg\\:m-3\\/5 {
    margin: 60%;
  }
  .lg\\:m-4\\/5 {
    margin: 80%;
  }
  .lg\\:m-1\\/6 {
    margin: 16.666667%;
  }
  .lg\\:m-2\\/6 {
    margin: 33.333333%;
  }
  .lg\\:m-3\\/6 {
    margin: 50%;
  }
  .lg\\:m-4\\/6 {
    margin: 66.666667%;
  }
  .lg\\:m-5\\/6 {
    margin: 83.333333%;
  }
  .lg\\:m-1\\/12 {
    margin: 8.333333%;
  }
  .lg\\:m-2\\/12 {
    margin: 16.666667%;
  }
  .lg\\:m-3\\/12 {
    margin: 25%;
  }
  .lg\\:m-4\\/12 {
    margin: 33.333333%;
  }
  .lg\\:m-5\\/12 {
    margin: 41.666667%;
  }
  .lg\\:m-6\\/12 {
    margin: 50%;
  }
  .lg\\:m-7\\/12 {
    margin: 58.333333%;
  }
  .lg\\:m-8\\/12 {
    margin: 66.666667%;
  }
  .lg\\:m-9\\/12 {
    margin: 75%;
  }
  .lg\\:m-10\\/12 {
    margin: 83.333333%;
  }
  .lg\\:m-11\\/12 {
    margin: 91.666667%;
  }
  .lg\\:m-full {
    margin: 100%;
  }
  .lg\\:-m-1 {
    margin: -0.25rem;
  }
  .lg\\:-m-2 {
    margin: -0.5rem;
  }
  .lg\\:-m-3 {
    margin: -0.75rem;
  }
  .lg\\:-m-4 {
    margin: -1rem;
  }
  .lg\\:-m-5 {
    margin: -1.25rem;
  }
  .lg\\:-m-6 {
    margin: -1.5rem;
  }
  .lg\\:-m-7 {
    margin: -1.75rem;
  }
  .lg\\:-m-8 {
    margin: -2rem;
  }
  .lg\\:-m-9 {
    margin: -2.25rem;
  }
  .lg\\:-m-10 {
    margin: -2.5rem;
  }
  .lg\\:-m-11 {
    margin: -2.75rem;
  }
  .lg\\:-m-12 {
    margin: -3rem;
  }
  .lg\\:-m-13 {
    margin: -3.25rem;
  }
  .lg\\:-m-14 {
    margin: -3.5rem;
  }
  .lg\\:-m-15 {
    margin: -3.75rem;
  }
  .lg\\:-m-16 {
    margin: -4rem;
  }
  .lg\\:-m-20 {
    margin: -5rem;
  }
  .lg\\:-m-24 {
    margin: -6rem;
  }
  .lg\\:-m-28 {
    margin: -7rem;
  }
  .lg\\:-m-32 {
    margin: -8rem;
  }
  .lg\\:-m-36 {
    margin: -9rem;
  }
  .lg\\:-m-40 {
    margin: -10rem;
  }
  .lg\\:-m-44 {
    margin: -11rem;
  }
  .lg\\:-m-48 {
    margin: -12rem;
  }
  .lg\\:-m-52 {
    margin: -13rem;
  }
  .lg\\:-m-56 {
    margin: -14rem;
  }
  .lg\\:-m-60 {
    margin: -15rem;
  }
  .lg\\:-m-64 {
    margin: -16rem;
  }
  .lg\\:-m-72 {
    margin: -18rem;
  }
  .lg\\:-m-80 {
    margin: -20rem;
  }
  .lg\\:-m-96 {
    margin: -24rem;
  }
  .lg\\:-m-px {
    margin: -1px;
  }
  .lg\\:-m-0\\.5 {
    margin: -0.125rem;
  }
  .lg\\:-m-1\\.5 {
    margin: -0.375rem;
  }
  .lg\\:-m-2\\.5 {
    margin: -0.625rem;
  }
  .lg\\:-m-3\\.5 {
    margin: -0.875rem;
  }
  .lg\\:-m-1\\/2 {
    margin: -50%;
  }
  .lg\\:-m-1\\/3 {
    margin: -33.33333%;
  }
  .lg\\:-m-2\\/3 {
    margin: -66.66667%;
  }
  .lg\\:-m-1\\/4 {
    margin: -25%;
  }
  .lg\\:-m-2\\/4 {
    margin: -50%;
  }
  .lg\\:-m-3\\/4 {
    margin: -75%;
  }
  .lg\\:-m-1\\/5 {
    margin: -20%;
  }
  .lg\\:-m-2\\/5 {
    margin: -40%;
  }
  .lg\\:-m-3\\/5 {
    margin: -60%;
  }
  .lg\\:-m-4\\/5 {
    margin: -80%;
  }
  .lg\\:-m-1\\/6 {
    margin: -16.66667%;
  }
  .lg\\:-m-2\\/6 {
    margin: -33.33333%;
  }
  .lg\\:-m-3\\/6 {
    margin: -50%;
  }
  .lg\\:-m-4\\/6 {
    margin: -66.66667%;
  }
  .lg\\:-m-5\\/6 {
    margin: -83.33333%;
  }
  .lg\\:-m-1\\/12 {
    margin: -8.33333%;
  }
  .lg\\:-m-2\\/12 {
    margin: -16.66667%;
  }
  .lg\\:-m-3\\/12 {
    margin: -25%;
  }
  .lg\\:-m-4\\/12 {
    margin: -33.33333%;
  }
  .lg\\:-m-5\\/12 {
    margin: -41.66667%;
  }
  .lg\\:-m-6\\/12 {
    margin: -50%;
  }
  .lg\\:-m-7\\/12 {
    margin: -58.33333%;
  }
  .lg\\:-m-8\\/12 {
    margin: -66.66667%;
  }
  .lg\\:-m-9\\/12 {
    margin: -75%;
  }
  .lg\\:-m-10\\/12 {
    margin: -83.33333%;
  }
  .lg\\:-m-11\\/12 {
    margin: -91.66667%;
  }
  .lg\\:-m-full {
    margin: -100%;
  }
  .lg\\:my-0 {
    margin-top: 0;
    margin-bottom: 0;
  }
  .lg\\:mx-0 {
    margin-left: 0;
    margin-right: 0;
  }
  .lg\\:my-1 {
    margin-top: 0.25rem;
    margin-bottom: 0.25rem;
  }
  .lg\\:mx-1 {
    margin-left: 0.25rem;
    margin-right: 0.25rem;
  }
  .lg\\:my-2 {
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
  }
  .lg\\:mx-2 {
    margin-left: 0.5rem;
    margin-right: 0.5rem;
  }
  .lg\\:my-3 {
    margin-top: 0.75rem;
    margin-bottom: 0.75rem;
  }
  .lg\\:mx-3 {
    margin-left: 0.75rem;
    margin-right: 0.75rem;
  }
  .lg\\:my-4 {
    margin-top: 1rem;
    margin-bottom: 1rem;
  }
  .lg\\:mx-4 {
    margin-left: 1rem;
    margin-right: 1rem;
  }
  .lg\\:my-5 {
    margin-top: 1.25rem;
    margin-bottom: 1.25rem;
  }
  .lg\\:mx-5 {
    margin-left: 1.25rem;
    margin-right: 1.25rem;
  }
  .lg\\:my-6 {
    margin-top: 1.5rem;
    margin-bottom: 1.5rem;
  }
  .lg\\:mx-6 {
    margin-left: 1.5rem;
    margin-right: 1.5rem;
  }
  .lg\\:my-7 {
    margin-top: 1.75rem;
    margin-bottom: 1.75rem;
  }
  .lg\\:mx-7 {
    margin-left: 1.75rem;
    margin-right: 1.75rem;
  }
  .lg\\:my-8 {
    margin-top: 2rem;
    margin-bottom: 2rem;
  }
  .lg\\:mx-8 {
    margin-left: 2rem;
    margin-right: 2rem;
  }
  .lg\\:my-9 {
    margin-top: 2.25rem;
    margin-bottom: 2.25rem;
  }
  .lg\\:mx-9 {
    margin-left: 2.25rem;
    margin-right: 2.25rem;
  }
  .lg\\:my-10 {
    margin-top: 2.5rem;
    margin-bottom: 2.5rem;
  }
  .lg\\:mx-10 {
    margin-left: 2.5rem;
    margin-right: 2.5rem;
  }
  .lg\\:my-11 {
    margin-top: 2.75rem;
    margin-bottom: 2.75rem;
  }
  .lg\\:mx-11 {
    margin-left: 2.75rem;
    margin-right: 2.75rem;
  }
  .lg\\:my-12 {
    margin-top: 3rem;
    margin-bottom: 3rem;
  }
  .lg\\:mx-12 {
    margin-left: 3rem;
    margin-right: 3rem;
  }
  .lg\\:my-13 {
    margin-top: 3.25rem;
    margin-bottom: 3.25rem;
  }
  .lg\\:mx-13 {
    margin-left: 3.25rem;
    margin-right: 3.25rem;
  }
  .lg\\:my-14 {
    margin-top: 3.5rem;
    margin-bottom: 3.5rem;
  }
  .lg\\:mx-14 {
    margin-left: 3.5rem;
    margin-right: 3.5rem;
  }
  .lg\\:my-15 {
    margin-top: 3.75rem;
    margin-bottom: 3.75rem;
  }
  .lg\\:mx-15 {
    margin-left: 3.75rem;
    margin-right: 3.75rem;
  }
  .lg\\:my-16 {
    margin-top: 4rem;
    margin-bottom: 4rem;
  }
  .lg\\:mx-16 {
    margin-left: 4rem;
    margin-right: 4rem;
  }
  .lg\\:my-20 {
    margin-top: 5rem;
    margin-bottom: 5rem;
  }
  .lg\\:mx-20 {
    margin-left: 5rem;
    margin-right: 5rem;
  }
  .lg\\:my-24 {
    margin-top: 6rem;
    margin-bottom: 6rem;
  }
  .lg\\:mx-24 {
    margin-left: 6rem;
    margin-right: 6rem;
  }
  .lg\\:my-28 {
    margin-top: 7rem;
    margin-bottom: 7rem;
  }
  .lg\\:mx-28 {
    margin-left: 7rem;
    margin-right: 7rem;
  }
  .lg\\:my-32 {
    margin-top: 8rem;
    margin-bottom: 8rem;
  }
  .lg\\:mx-32 {
    margin-left: 8rem;
    margin-right: 8rem;
  }
  .lg\\:my-36 {
    margin-top: 9rem;
    margin-bottom: 9rem;
  }
  .lg\\:mx-36 {
    margin-left: 9rem;
    margin-right: 9rem;
  }
  .lg\\:my-40 {
    margin-top: 10rem;
    margin-bottom: 10rem;
  }
  .lg\\:mx-40 {
    margin-left: 10rem;
    margin-right: 10rem;
  }
  .lg\\:my-44 {
    margin-top: 11rem;
    margin-bottom: 11rem;
  }
  .lg\\:mx-44 {
    margin-left: 11rem;
    margin-right: 11rem;
  }
  .lg\\:my-48 {
    margin-top: 12rem;
    margin-bottom: 12rem;
  }
  .lg\\:mx-48 {
    margin-left: 12rem;
    margin-right: 12rem;
  }
  .lg\\:my-52 {
    margin-top: 13rem;
    margin-bottom: 13rem;
  }
  .lg\\:mx-52 {
    margin-left: 13rem;
    margin-right: 13rem;
  }
  .lg\\:my-56 {
    margin-top: 14rem;
    margin-bottom: 14rem;
  }
  .lg\\:mx-56 {
    margin-left: 14rem;
    margin-right: 14rem;
  }
  .lg\\:my-60 {
    margin-top: 15rem;
    margin-bottom: 15rem;
  }
  .lg\\:mx-60 {
    margin-left: 15rem;
    margin-right: 15rem;
  }
  .lg\\:my-64 {
    margin-top: 16rem;
    margin-bottom: 16rem;
  }
  .lg\\:mx-64 {
    margin-left: 16rem;
    margin-right: 16rem;
  }
  .lg\\:my-72 {
    margin-top: 18rem;
    margin-bottom: 18rem;
  }
  .lg\\:mx-72 {
    margin-left: 18rem;
    margin-right: 18rem;
  }
  .lg\\:my-80 {
    margin-top: 20rem;
    margin-bottom: 20rem;
  }
  .lg\\:mx-80 {
    margin-left: 20rem;
    margin-right: 20rem;
  }
  .lg\\:my-96 {
    margin-top: 24rem;
    margin-bottom: 24rem;
  }
  .lg\\:mx-96 {
    margin-left: 24rem;
    margin-right: 24rem;
  }
  .lg\\:my-auto {
    margin-top: auto;
    margin-bottom: auto;
  }
  .lg\\:mx-auto {
    margin-left: auto;
    margin-right: auto;
  }
  .lg\\:my-px {
    margin-top: 1px;
    margin-bottom: 1px;
  }
  .lg\\:mx-px {
    margin-left: 1px;
    margin-right: 1px;
  }
  .lg\\:my-0\\.5 {
    margin-top: 0.125rem;
    margin-bottom: 0.125rem;
  }
  .lg\\:mx-0\\.5 {
    margin-left: 0.125rem;
    margin-right: 0.125rem;
  }
  .lg\\:my-1\\.5 {
    margin-top: 0.375rem;
    margin-bottom: 0.375rem;
  }
  .lg\\:mx-1\\.5 {
    margin-left: 0.375rem;
    margin-right: 0.375rem;
  }
  .lg\\:my-2\\.5 {
    margin-top: 0.625rem;
    margin-bottom: 0.625rem;
  }
  .lg\\:mx-2\\.5 {
    margin-left: 0.625rem;
    margin-right: 0.625rem;
  }
  .lg\\:my-3\\.5 {
    margin-top: 0.875rem;
    margin-bottom: 0.875rem;
  }
  .lg\\:mx-3\\.5 {
    margin-left: 0.875rem;
    margin-right: 0.875rem;
  }
  .lg\\:my-1\\/2 {
    margin-top: 50%;
    margin-bottom: 50%;
  }
  .lg\\:mx-1\\/2 {
    margin-left: 50%;
    margin-right: 50%;
  }
  .lg\\:my-1\\/3 {
    margin-top: 33.333333%;
    margin-bottom: 33.333333%;
  }
  .lg\\:mx-1\\/3 {
    margin-left: 33.333333%;
    margin-right: 33.333333%;
  }
  .lg\\:my-2\\/3 {
    margin-top: 66.666667%;
    margin-bottom: 66.666667%;
  }
  .lg\\:mx-2\\/3 {
    margin-left: 66.666667%;
    margin-right: 66.666667%;
  }
  .lg\\:my-1\\/4 {
    margin-top: 25%;
    margin-bottom: 25%;
  }
  .lg\\:mx-1\\/4 {
    margin-left: 25%;
    margin-right: 25%;
  }
  .lg\\:my-2\\/4 {
    margin-top: 50%;
    margin-bottom: 50%;
  }
  .lg\\:mx-2\\/4 {
    margin-left: 50%;
    margin-right: 50%;
  }
  .lg\\:my-3\\/4 {
    margin-top: 75%;
    margin-bottom: 75%;
  }
  .lg\\:mx-3\\/4 {
    margin-left: 75%;
    margin-right: 75%;
  }
  .lg\\:my-1\\/5 {
    margin-top: 20%;
    margin-bottom: 20%;
  }
  .lg\\:mx-1\\/5 {
    margin-left: 20%;
    margin-right: 20%;
  }
  .lg\\:my-2\\/5 {
    margin-top: 40%;
    margin-bottom: 40%;
  }
  .lg\\:mx-2\\/5 {
    margin-left: 40%;
    margin-right: 40%;
  }
  .lg\\:my-3\\/5 {
    margin-top: 60%;
    margin-bottom: 60%;
  }
  .lg\\:mx-3\\/5 {
    margin-left: 60%;
    margin-right: 60%;
  }
  .lg\\:my-4\\/5 {
    margin-top: 80%;
    margin-bottom: 80%;
  }
  .lg\\:mx-4\\/5 {
    margin-left: 80%;
    margin-right: 80%;
  }
  .lg\\:my-1\\/6 {
    margin-top: 16.666667%;
    margin-bottom: 16.666667%;
  }
  .lg\\:mx-1\\/6 {
    margin-left: 16.666667%;
    margin-right: 16.666667%;
  }
  .lg\\:my-2\\/6 {
    margin-top: 33.333333%;
    margin-bottom: 33.333333%;
  }
  .lg\\:mx-2\\/6 {
    margin-left: 33.333333%;
    margin-right: 33.333333%;
  }
  .lg\\:my-3\\/6 {
    margin-top: 50%;
    margin-bottom: 50%;
  }
  .lg\\:mx-3\\/6 {
    margin-left: 50%;
    margin-right: 50%;
  }
  .lg\\:my-4\\/6 {
    margin-top: 66.666667%;
    margin-bottom: 66.666667%;
  }
  .lg\\:mx-4\\/6 {
    margin-left: 66.666667%;
    margin-right: 66.666667%;
  }
  .lg\\:my-5\\/6 {
    margin-top: 83.333333%;
    margin-bottom: 83.333333%;
  }
  .lg\\:mx-5\\/6 {
    margin-left: 83.333333%;
    margin-right: 83.333333%;
  }
  .lg\\:my-1\\/12 {
    margin-top: 8.333333%;
    margin-bottom: 8.333333%;
  }
  .lg\\:mx-1\\/12 {
    margin-left: 8.333333%;
    margin-right: 8.333333%;
  }
  .lg\\:my-2\\/12 {
    margin-top: 16.666667%;
    margin-bottom: 16.666667%;
  }
  .lg\\:mx-2\\/12 {
    margin-left: 16.666667%;
    margin-right: 16.666667%;
  }
  .lg\\:my-3\\/12 {
    margin-top: 25%;
    margin-bottom: 25%;
  }
  .lg\\:mx-3\\/12 {
    margin-left: 25%;
    margin-right: 25%;
  }
  .lg\\:my-4\\/12 {
    margin-top: 33.333333%;
    margin-bottom: 33.333333%;
  }
  .lg\\:mx-4\\/12 {
    margin-left: 33.333333%;
    margin-right: 33.333333%;
  }
  .lg\\:my-5\\/12 {
    margin-top: 41.666667%;
    margin-bottom: 41.666667%;
  }
  .lg\\:mx-5\\/12 {
    margin-left: 41.666667%;
    margin-right: 41.666667%;
  }
  .lg\\:my-6\\/12 {
    margin-top: 50%;
    margin-bottom: 50%;
  }
  .lg\\:mx-6\\/12 {
    margin-left: 50%;
    margin-right: 50%;
  }
  .lg\\:my-7\\/12 {
    margin-top: 58.333333%;
    margin-bottom: 58.333333%;
  }
  .lg\\:mx-7\\/12 {
    margin-left: 58.333333%;
    margin-right: 58.333333%;
  }
  .lg\\:my-8\\/12 {
    margin-top: 66.666667%;
    margin-bottom: 66.666667%;
  }
  .lg\\:mx-8\\/12 {
    margin-left: 66.666667%;
    margin-right: 66.666667%;
  }
  .lg\\:my-9\\/12 {
    margin-top: 75%;
    margin-bottom: 75%;
  }
  .lg\\:mx-9\\/12 {
    margin-left: 75%;
    margin-right: 75%;
  }
  .lg\\:my-10\\/12 {
    margin-top: 83.333333%;
    margin-bottom: 83.333333%;
  }
  .lg\\:mx-10\\/12 {
    margin-left: 83.333333%;
    margin-right: 83.333333%;
  }
  .lg\\:my-11\\/12 {
    margin-top: 91.666667%;
    margin-bottom: 91.666667%;
  }
  .lg\\:mx-11\\/12 {
    margin-left: 91.666667%;
    margin-right: 91.666667%;
  }
  .lg\\:my-full {
    margin-top: 100%;
    margin-bottom: 100%;
  }
  .lg\\:mx-full {
    margin-left: 100%;
    margin-right: 100%;
  }
  .lg\\:-my-1 {
    margin-top: -0.25rem;
    margin-bottom: -0.25rem;
  }
  .lg\\:-mx-1 {
    margin-left: -0.25rem;
    margin-right: -0.25rem;
  }
  .lg\\:-my-2 {
    margin-top: -0.5rem;
    margin-bottom: -0.5rem;
  }
  .lg\\:-mx-2 {
    margin-left: -0.5rem;
    margin-right: -0.5rem;
  }
  .lg\\:-my-3 {
    margin-top: -0.75rem;
    margin-bottom: -0.75rem;
  }
  .lg\\:-mx-3 {
    margin-left: -0.75rem;
    margin-right: -0.75rem;
  }
  .lg\\:-my-4 {
    margin-top: -1rem;
    margin-bottom: -1rem;
  }
  .lg\\:-mx-4 {
    margin-left: -1rem;
    margin-right: -1rem;
  }
  .lg\\:-my-5 {
    margin-top: -1.25rem;
    margin-bottom: -1.25rem;
  }
  .lg\\:-mx-5 {
    margin-left: -1.25rem;
    margin-right: -1.25rem;
  }
  .lg\\:-my-6 {
    margin-top: -1.5rem;
    margin-bottom: -1.5rem;
  }
  .lg\\:-mx-6 {
    margin-left: -1.5rem;
    margin-right: -1.5rem;
  }
  .lg\\:-my-7 {
    margin-top: -1.75rem;
    margin-bottom: -1.75rem;
  }
  .lg\\:-mx-7 {
    margin-left: -1.75rem;
    margin-right: -1.75rem;
  }
  .lg\\:-my-8 {
    margin-top: -2rem;
    margin-bottom: -2rem;
  }
  .lg\\:-mx-8 {
    margin-left: -2rem;
    margin-right: -2rem;
  }
  .lg\\:-my-9 {
    margin-top: -2.25rem;
    margin-bottom: -2.25rem;
  }
  .lg\\:-mx-9 {
    margin-left: -2.25rem;
    margin-right: -2.25rem;
  }
  .lg\\:-my-10 {
    margin-top: -2.5rem;
    margin-bottom: -2.5rem;
  }
  .lg\\:-mx-10 {
    margin-left: -2.5rem;
    margin-right: -2.5rem;
  }
  .lg\\:-my-11 {
    margin-top: -2.75rem;
    margin-bottom: -2.75rem;
  }
  .lg\\:-mx-11 {
    margin-left: -2.75rem;
    margin-right: -2.75rem;
  }
  .lg\\:-my-12 {
    margin-top: -3rem;
    margin-bottom: -3rem;
  }
  .lg\\:-mx-12 {
    margin-left: -3rem;
    margin-right: -3rem;
  }
  .lg\\:-my-13 {
    margin-top: -3.25rem;
    margin-bottom: -3.25rem;
  }
  .lg\\:-mx-13 {
    margin-left: -3.25rem;
    margin-right: -3.25rem;
  }
  .lg\\:-my-14 {
    margin-top: -3.5rem;
    margin-bottom: -3.5rem;
  }
  .lg\\:-mx-14 {
    margin-left: -3.5rem;
    margin-right: -3.5rem;
  }
  .lg\\:-my-15 {
    margin-top: -3.75rem;
    margin-bottom: -3.75rem;
  }
  .lg\\:-mx-15 {
    margin-left: -3.75rem;
    margin-right: -3.75rem;
  }
  .lg\\:-my-16 {
    margin-top: -4rem;
    margin-bottom: -4rem;
  }
  .lg\\:-mx-16 {
    margin-left: -4rem;
    margin-right: -4rem;
  }
  .lg\\:-my-20 {
    margin-top: -5rem;
    margin-bottom: -5rem;
  }
  .lg\\:-mx-20 {
    margin-left: -5rem;
    margin-right: -5rem;
  }
  .lg\\:-my-24 {
    margin-top: -6rem;
    margin-bottom: -6rem;
  }
  .lg\\:-mx-24 {
    margin-left: -6rem;
    margin-right: -6rem;
  }
  .lg\\:-my-28 {
    margin-top: -7rem;
    margin-bottom: -7rem;
  }
  .lg\\:-mx-28 {
    margin-left: -7rem;
    margin-right: -7rem;
  }
  .lg\\:-my-32 {
    margin-top: -8rem;
    margin-bottom: -8rem;
  }
  .lg\\:-mx-32 {
    margin-left: -8rem;
    margin-right: -8rem;
  }
  .lg\\:-my-36 {
    margin-top: -9rem;
    margin-bottom: -9rem;
  }
  .lg\\:-mx-36 {
    margin-left: -9rem;
    margin-right: -9rem;
  }
  .lg\\:-my-40 {
    margin-top: -10rem;
    margin-bottom: -10rem;
  }
  .lg\\:-mx-40 {
    margin-left: -10rem;
    margin-right: -10rem;
  }
  .lg\\:-my-44 {
    margin-top: -11rem;
    margin-bottom: -11rem;
  }
  .lg\\:-mx-44 {
    margin-left: -11rem;
    margin-right: -11rem;
  }
  .lg\\:-my-48 {
    margin-top: -12rem;
    margin-bottom: -12rem;
  }
  .lg\\:-mx-48 {
    margin-left: -12rem;
    margin-right: -12rem;
  }
  .lg\\:-my-52 {
    margin-top: -13rem;
    margin-bottom: -13rem;
  }
  .lg\\:-mx-52 {
    margin-left: -13rem;
    margin-right: -13rem;
  }
  .lg\\:-my-56 {
    margin-top: -14rem;
    margin-bottom: -14rem;
  }
  .lg\\:-mx-56 {
    margin-left: -14rem;
    margin-right: -14rem;
  }
  .lg\\:-my-60 {
    margin-top: -15rem;
    margin-bottom: -15rem;
  }
  .lg\\:-mx-60 {
    margin-left: -15rem;
    margin-right: -15rem;
  }
  .lg\\:-my-64 {
    margin-top: -16rem;
    margin-bottom: -16rem;
  }
  .lg\\:-mx-64 {
    margin-left: -16rem;
    margin-right: -16rem;
  }
  .lg\\:-my-72 {
    margin-top: -18rem;
    margin-bottom: -18rem;
  }
  .lg\\:-mx-72 {
    margin-left: -18rem;
    margin-right: -18rem;
  }
  .lg\\:-my-80 {
    margin-top: -20rem;
    margin-bottom: -20rem;
  }
  .lg\\:-mx-80 {
    margin-left: -20rem;
    margin-right: -20rem;
  }
  .lg\\:-my-96 {
    margin-top: -24rem;
    margin-bottom: -24rem;
  }
  .lg\\:-mx-96 {
    margin-left: -24rem;
    margin-right: -24rem;
  }
  .lg\\:-my-px {
    margin-top: -1px;
    margin-bottom: -1px;
  }
  .lg\\:-mx-px {
    margin-left: -1px;
    margin-right: -1px;
  }
  .lg\\:-my-0\\.5 {
    margin-top: -0.125rem;
    margin-bottom: -0.125rem;
  }
  .lg\\:-mx-0\\.5 {
    margin-left: -0.125rem;
    margin-right: -0.125rem;
  }
  .lg\\:-my-1\\.5 {
    margin-top: -0.375rem;
    margin-bottom: -0.375rem;
  }
  .lg\\:-mx-1\\.5 {
    margin-left: -0.375rem;
    margin-right: -0.375rem;
  }
  .lg\\:-my-2\\.5 {
    margin-top: -0.625rem;
    margin-bottom: -0.625rem;
  }
  .lg\\:-mx-2\\.5 {
    margin-left: -0.625rem;
    margin-right: -0.625rem;
  }
  .lg\\:-my-3\\.5 {
    margin-top: -0.875rem;
    margin-bottom: -0.875rem;
  }
  .lg\\:-mx-3\\.5 {
    margin-left: -0.875rem;
    margin-right: -0.875rem;
  }
  .lg\\:-my-1\\/2 {
    margin-top: -50%;
    margin-bottom: -50%;
  }
  .lg\\:-mx-1\\/2 {
    margin-left: -50%;
    margin-right: -50%;
  }
  .lg\\:-my-1\\/3 {
    margin-top: -33.33333%;
    margin-bottom: -33.33333%;
  }
  .lg\\:-mx-1\\/3 {
    margin-left: -33.33333%;
    margin-right: -33.33333%;
  }
  .lg\\:-my-2\\/3 {
    margin-top: -66.66667%;
    margin-bottom: -66.66667%;
  }
  .lg\\:-mx-2\\/3 {
    margin-left: -66.66667%;
    margin-right: -66.66667%;
  }
  .lg\\:-my-1\\/4 {
    margin-top: -25%;
    margin-bottom: -25%;
  }
  .lg\\:-mx-1\\/4 {
    margin-left: -25%;
    margin-right: -25%;
  }
  .lg\\:-my-2\\/4 {
    margin-top: -50%;
    margin-bottom: -50%;
  }
  .lg\\:-mx-2\\/4 {
    margin-left: -50%;
    margin-right: -50%;
  }
  .lg\\:-my-3\\/4 {
    margin-top: -75%;
    margin-bottom: -75%;
  }
  .lg\\:-mx-3\\/4 {
    margin-left: -75%;
    margin-right: -75%;
  }
  .lg\\:-my-1\\/5 {
    margin-top: -20%;
    margin-bottom: -20%;
  }
  .lg\\:-mx-1\\/5 {
    margin-left: -20%;
    margin-right: -20%;
  }
  .lg\\:-my-2\\/5 {
    margin-top: -40%;
    margin-bottom: -40%;
  }
  .lg\\:-mx-2\\/5 {
    margin-left: -40%;
    margin-right: -40%;
  }
  .lg\\:-my-3\\/5 {
    margin-top: -60%;
    margin-bottom: -60%;
  }
  .lg\\:-mx-3\\/5 {
    margin-left: -60%;
    margin-right: -60%;
  }
  .lg\\:-my-4\\/5 {
    margin-top: -80%;
    margin-bottom: -80%;
  }
  .lg\\:-mx-4\\/5 {
    margin-left: -80%;
    margin-right: -80%;
  }
  .lg\\:-my-1\\/6 {
    margin-top: -16.66667%;
    margin-bottom: -16.66667%;
  }
  .lg\\:-mx-1\\/6 {
    margin-left: -16.66667%;
    margin-right: -16.66667%;
  }
  .lg\\:-my-2\\/6 {
    margin-top: -33.33333%;
    margin-bottom: -33.33333%;
  }
  .lg\\:-mx-2\\/6 {
    margin-left: -33.33333%;
    margin-right: -33.33333%;
  }
  .lg\\:-my-3\\/6 {
    margin-top: -50%;
    margin-bottom: -50%;
  }
  .lg\\:-mx-3\\/6 {
    margin-left: -50%;
    margin-right: -50%;
  }
  .lg\\:-my-4\\/6 {
    margin-top: -66.66667%;
    margin-bottom: -66.66667%;
  }
  .lg\\:-mx-4\\/6 {
    margin-left: -66.66667%;
    margin-right: -66.66667%;
  }
  .lg\\:-my-5\\/6 {
    margin-top: -83.33333%;
    margin-bottom: -83.33333%;
  }
  .lg\\:-mx-5\\/6 {
    margin-left: -83.33333%;
    margin-right: -83.33333%;
  }
  .lg\\:-my-1\\/12 {
    margin-top: -8.33333%;
    margin-bottom: -8.33333%;
  }
  .lg\\:-mx-1\\/12 {
    margin-left: -8.33333%;
    margin-right: -8.33333%;
  }
  .lg\\:-my-2\\/12 {
    margin-top: -16.66667%;
    margin-bottom: -16.66667%;
  }
  .lg\\:-mx-2\\/12 {
    margin-left: -16.66667%;
    margin-right: -16.66667%;
  }
  .lg\\:-my-3\\/12 {
    margin-top: -25%;
    margin-bottom: -25%;
  }
  .lg\\:-mx-3\\/12 {
    margin-left: -25%;
    margin-right: -25%;
  }
  .lg\\:-my-4\\/12 {
    margin-top: -33.33333%;
    margin-bottom: -33.33333%;
  }
  .lg\\:-mx-4\\/12 {
    margin-left: -33.33333%;
    margin-right: -33.33333%;
  }
  .lg\\:-my-5\\/12 {
    margin-top: -41.66667%;
    margin-bottom: -41.66667%;
  }
  .lg\\:-mx-5\\/12 {
    margin-left: -41.66667%;
    margin-right: -41.66667%;
  }
  .lg\\:-my-6\\/12 {
    margin-top: -50%;
    margin-bottom: -50%;
  }
  .lg\\:-mx-6\\/12 {
    margin-left: -50%;
    margin-right: -50%;
  }
  .lg\\:-my-7\\/12 {
    margin-top: -58.33333%;
    margin-bottom: -58.33333%;
  }
  .lg\\:-mx-7\\/12 {
    margin-left: -58.33333%;
    margin-right: -58.33333%;
  }
  .lg\\:-my-8\\/12 {
    margin-top: -66.66667%;
    margin-bottom: -66.66667%;
  }
  .lg\\:-mx-8\\/12 {
    margin-left: -66.66667%;
    margin-right: -66.66667%;
  }
  .lg\\:-my-9\\/12 {
    margin-top: -75%;
    margin-bottom: -75%;
  }
  .lg\\:-mx-9\\/12 {
    margin-left: -75%;
    margin-right: -75%;
  }
  .lg\\:-my-10\\/12 {
    margin-top: -83.33333%;
    margin-bottom: -83.33333%;
  }
  .lg\\:-mx-10\\/12 {
    margin-left: -83.33333%;
    margin-right: -83.33333%;
  }
  .lg\\:-my-11\\/12 {
    margin-top: -91.66667%;
    margin-bottom: -91.66667%;
  }
  .lg\\:-mx-11\\/12 {
    margin-left: -91.66667%;
    margin-right: -91.66667%;
  }
  .lg\\:-my-full {
    margin-top: -100%;
    margin-bottom: -100%;
  }
  .lg\\:-mx-full {
    margin-left: -100%;
    margin-right: -100%;
  }
  .lg\\:mt-0 {
    margin-top: 0;
  }
  .lg\\:mr-0 {
    margin-right: 0;
  }
  .lg\\:mb-0 {
    margin-bottom: 0;
  }
  .lg\\:ml-0 {
    margin-left: 0;
  }
  .lg\\:mt-1 {
    margin-top: 0.25rem;
  }
  .lg\\:mr-1 {
    margin-right: 0.25rem;
  }
  .lg\\:mb-1 {
    margin-bottom: 0.25rem;
  }
  .lg\\:ml-1 {
    margin-left: 0.25rem;
  }
  .lg\\:mt-2 {
    margin-top: 0.5rem;
  }
  .lg\\:mr-2 {
    margin-right: 0.5rem;
  }
  .lg\\:mb-2 {
    margin-bottom: 0.5rem;
  }
  .lg\\:ml-2 {
    margin-left: 0.5rem;
  }
  .lg\\:mt-3 {
    margin-top: 0.75rem;
  }
  .lg\\:mr-3 {
    margin-right: 0.75rem;
  }
  .lg\\:mb-3 {
    margin-bottom: 0.75rem;
  }
  .lg\\:ml-3 {
    margin-left: 0.75rem;
  }
  .lg\\:mt-4 {
    margin-top: 1rem;
  }
  .lg\\:mr-4 {
    margin-right: 1rem;
  }
  .lg\\:mb-4 {
    margin-bottom: 1rem;
  }
  .lg\\:ml-4 {
    margin-left: 1rem;
  }
  .lg\\:mt-5 {
    margin-top: 1.25rem;
  }
  .lg\\:mr-5 {
    margin-right: 1.25rem;
  }
  .lg\\:mb-5 {
    margin-bottom: 1.25rem;
  }
  .lg\\:ml-5 {
    margin-left: 1.25rem;
  }
  .lg\\:mt-6 {
    margin-top: 1.5rem;
  }
  .lg\\:mr-6 {
    margin-right: 1.5rem;
  }
  .lg\\:mb-6 {
    margin-bottom: 1.5rem;
  }
  .lg\\:ml-6 {
    margin-left: 1.5rem;
  }
  .lg\\:mt-7 {
    margin-top: 1.75rem;
  }
  .lg\\:mr-7 {
    margin-right: 1.75rem;
  }
  .lg\\:mb-7 {
    margin-bottom: 1.75rem;
  }
  .lg\\:ml-7 {
    margin-left: 1.75rem;
  }
  .lg\\:mt-8 {
    margin-top: 2rem;
  }
  .lg\\:mr-8 {
    margin-right: 2rem;
  }
  .lg\\:mb-8 {
    margin-bottom: 2rem;
  }
  .lg\\:ml-8 {
    margin-left: 2rem;
  }
  .lg\\:mt-9 {
    margin-top: 2.25rem;
  }
  .lg\\:mr-9 {
    margin-right: 2.25rem;
  }
  .lg\\:mb-9 {
    margin-bottom: 2.25rem;
  }
  .lg\\:ml-9 {
    margin-left: 2.25rem;
  }
  .lg\\:mt-10 {
    margin-top: 2.5rem;
  }
  .lg\\:mr-10 {
    margin-right: 2.5rem;
  }
  .lg\\:mb-10 {
    margin-bottom: 2.5rem;
  }
  .lg\\:ml-10 {
    margin-left: 2.5rem;
  }
  .lg\\:mt-11 {
    margin-top: 2.75rem;
  }
  .lg\\:mr-11 {
    margin-right: 2.75rem;
  }
  .lg\\:mb-11 {
    margin-bottom: 2.75rem;
  }
  .lg\\:ml-11 {
    margin-left: 2.75rem;
  }
  .lg\\:mt-12 {
    margin-top: 3rem;
  }
  .lg\\:mr-12 {
    margin-right: 3rem;
  }
  .lg\\:mb-12 {
    margin-bottom: 3rem;
  }
  .lg\\:ml-12 {
    margin-left: 3rem;
  }
  .lg\\:mt-13 {
    margin-top: 3.25rem;
  }
  .lg\\:mr-13 {
    margin-right: 3.25rem;
  }
  .lg\\:mb-13 {
    margin-bottom: 3.25rem;
  }
  .lg\\:ml-13 {
    margin-left: 3.25rem;
  }
  .lg\\:mt-14 {
    margin-top: 3.5rem;
  }
  .lg\\:mr-14 {
    margin-right: 3.5rem;
  }
  .lg\\:mb-14 {
    margin-bottom: 3.5rem;
  }
  .lg\\:ml-14 {
    margin-left: 3.5rem;
  }
  .lg\\:mt-15 {
    margin-top: 3.75rem;
  }
  .lg\\:mr-15 {
    margin-right: 3.75rem;
  }
  .lg\\:mb-15 {
    margin-bottom: 3.75rem;
  }
  .lg\\:ml-15 {
    margin-left: 3.75rem;
  }
  .lg\\:mt-16 {
    margin-top: 4rem;
  }
  .lg\\:mr-16 {
    margin-right: 4rem;
  }
  .lg\\:mb-16 {
    margin-bottom: 4rem;
  }
  .lg\\:ml-16 {
    margin-left: 4rem;
  }
  .lg\\:mt-20 {
    margin-top: 5rem;
  }
  .lg\\:mr-20 {
    margin-right: 5rem;
  }
  .lg\\:mb-20 {
    margin-bottom: 5rem;
  }
  .lg\\:ml-20 {
    margin-left: 5rem;
  }
  .lg\\:mt-24 {
    margin-top: 6rem;
  }
  .lg\\:mr-24 {
    margin-right: 6rem;
  }
  .lg\\:mb-24 {
    margin-bottom: 6rem;
  }
  .lg\\:ml-24 {
    margin-left: 6rem;
  }
  .lg\\:mt-28 {
    margin-top: 7rem;
  }
  .lg\\:mr-28 {
    margin-right: 7rem;
  }
  .lg\\:mb-28 {
    margin-bottom: 7rem;
  }
  .lg\\:ml-28 {
    margin-left: 7rem;
  }
  .lg\\:mt-32 {
    margin-top: 8rem;
  }
  .lg\\:mr-32 {
    margin-right: 8rem;
  }
  .lg\\:mb-32 {
    margin-bottom: 8rem;
  }
  .lg\\:ml-32 {
    margin-left: 8rem;
  }
  .lg\\:mt-36 {
    margin-top: 9rem;
  }
  .lg\\:mr-36 {
    margin-right: 9rem;
  }
  .lg\\:mb-36 {
    margin-bottom: 9rem;
  }
  .lg\\:ml-36 {
    margin-left: 9rem;
  }
  .lg\\:mt-40 {
    margin-top: 10rem;
  }
  .lg\\:mr-40 {
    margin-right: 10rem;
  }
  .lg\\:mb-40 {
    margin-bottom: 10rem;
  }
  .lg\\:ml-40 {
    margin-left: 10rem;
  }
  .lg\\:mt-44 {
    margin-top: 11rem;
  }
  .lg\\:mr-44 {
    margin-right: 11rem;
  }
  .lg\\:mb-44 {
    margin-bottom: 11rem;
  }
  .lg\\:ml-44 {
    margin-left: 11rem;
  }
  .lg\\:mt-48 {
    margin-top: 12rem;
  }
  .lg\\:mr-48 {
    margin-right: 12rem;
  }
  .lg\\:mb-48 {
    margin-bottom: 12rem;
  }
  .lg\\:ml-48 {
    margin-left: 12rem;
  }
  .lg\\:mt-52 {
    margin-top: 13rem;
  }
  .lg\\:mr-52 {
    margin-right: 13rem;
  }
  .lg\\:mb-52 {
    margin-bottom: 13rem;
  }
  .lg\\:ml-52 {
    margin-left: 13rem;
  }
  .lg\\:mt-56 {
    margin-top: 14rem;
  }
  .lg\\:mr-56 {
    margin-right: 14rem;
  }
  .lg\\:mb-56 {
    margin-bottom: 14rem;
  }
  .lg\\:ml-56 {
    margin-left: 14rem;
  }
  .lg\\:mt-60 {
    margin-top: 15rem;
  }
  .lg\\:mr-60 {
    margin-right: 15rem;
  }
  .lg\\:mb-60 {
    margin-bottom: 15rem;
  }
  .lg\\:ml-60 {
    margin-left: 15rem;
  }
  .lg\\:mt-64 {
    margin-top: 16rem;
  }
  .lg\\:mr-64 {
    margin-right: 16rem;
  }
  .lg\\:mb-64 {
    margin-bottom: 16rem;
  }
  .lg\\:ml-64 {
    margin-left: 16rem;
  }
  .lg\\:mt-72 {
    margin-top: 18rem;
  }
  .lg\\:mr-72 {
    margin-right: 18rem;
  }
  .lg\\:mb-72 {
    margin-bottom: 18rem;
  }
  .lg\\:ml-72 {
    margin-left: 18rem;
  }
  .lg\\:mt-80 {
    margin-top: 20rem;
  }
  .lg\\:mr-80 {
    margin-right: 20rem;
  }
  .lg\\:mb-80 {
    margin-bottom: 20rem;
  }
  .lg\\:ml-80 {
    margin-left: 20rem;
  }
  .lg\\:mt-96 {
    margin-top: 24rem;
  }
  .lg\\:mr-96 {
    margin-right: 24rem;
  }
  .lg\\:mb-96 {
    margin-bottom: 24rem;
  }
  .lg\\:ml-96 {
    margin-left: 24rem;
  }
  .lg\\:mt-auto {
    margin-top: auto;
  }
  .lg\\:mr-auto {
    margin-right: auto;
  }
  .lg\\:mb-auto {
    margin-bottom: auto;
  }
  .lg\\:ml-auto {
    margin-left: auto;
  }
  .lg\\:mt-px {
    margin-top: 1px;
  }
  .lg\\:mr-px {
    margin-right: 1px;
  }
  .lg\\:mb-px {
    margin-bottom: 1px;
  }
  .lg\\:ml-px {
    margin-left: 1px;
  }
  .lg\\:mt-0\\.5 {
    margin-top: 0.125rem;
  }
  .lg\\:mr-0\\.5 {
    margin-right: 0.125rem;
  }
  .lg\\:mb-0\\.5 {
    margin-bottom: 0.125rem;
  }
  .lg\\:ml-0\\.5 {
    margin-left: 0.125rem;
  }
  .lg\\:mt-1\\.5 {
    margin-top: 0.375rem;
  }
  .lg\\:mr-1\\.5 {
    margin-right: 0.375rem;
  }
  .lg\\:mb-1\\.5 {
    margin-bottom: 0.375rem;
  }
  .lg\\:ml-1\\.5 {
    margin-left: 0.375rem;
  }
  .lg\\:mt-2\\.5 {
    margin-top: 0.625rem;
  }
  .lg\\:mr-2\\.5 {
    margin-right: 0.625rem;
  }
  .lg\\:mb-2\\.5 {
    margin-bottom: 0.625rem;
  }
  .lg\\:ml-2\\.5 {
    margin-left: 0.625rem;
  }
  .lg\\:mt-3\\.5 {
    margin-top: 0.875rem;
  }
  .lg\\:mr-3\\.5 {
    margin-right: 0.875rem;
  }
  .lg\\:mb-3\\.5 {
    margin-bottom: 0.875rem;
  }
  .lg\\:ml-3\\.5 {
    margin-left: 0.875rem;
  }
  .lg\\:mt-1\\/2 {
    margin-top: 50%;
  }
  .lg\\:mr-1\\/2 {
    margin-right: 50%;
  }
  .lg\\:mb-1\\/2 {
    margin-bottom: 50%;
  }
  .lg\\:ml-1\\/2 {
    margin-left: 50%;
  }
  .lg\\:mt-1\\/3 {
    margin-top: 33.333333%;
  }
  .lg\\:mr-1\\/3 {
    margin-right: 33.333333%;
  }
  .lg\\:mb-1\\/3 {
    margin-bottom: 33.333333%;
  }
  .lg\\:ml-1\\/3 {
    margin-left: 33.333333%;
  }
  .lg\\:mt-2\\/3 {
    margin-top: 66.666667%;
  }
  .lg\\:mr-2\\/3 {
    margin-right: 66.666667%;
  }
  .lg\\:mb-2\\/3 {
    margin-bottom: 66.666667%;
  }
  .lg\\:ml-2\\/3 {
    margin-left: 66.666667%;
  }
  .lg\\:mt-1\\/4 {
    margin-top: 25%;
  }
  .lg\\:mr-1\\/4 {
    margin-right: 25%;
  }
  .lg\\:mb-1\\/4 {
    margin-bottom: 25%;
  }
  .lg\\:ml-1\\/4 {
    margin-left: 25%;
  }
  .lg\\:mt-2\\/4 {
    margin-top: 50%;
  }
  .lg\\:mr-2\\/4 {
    margin-right: 50%;
  }
  .lg\\:mb-2\\/4 {
    margin-bottom: 50%;
  }
  .lg\\:ml-2\\/4 {
    margin-left: 50%;
  }
  .lg\\:mt-3\\/4 {
    margin-top: 75%;
  }
  .lg\\:mr-3\\/4 {
    margin-right: 75%;
  }
  .lg\\:mb-3\\/4 {
    margin-bottom: 75%;
  }
  .lg\\:ml-3\\/4 {
    margin-left: 75%;
  }
  .lg\\:mt-1\\/5 {
    margin-top: 20%;
  }
  .lg\\:mr-1\\/5 {
    margin-right: 20%;
  }
  .lg\\:mb-1\\/5 {
    margin-bottom: 20%;
  }
  .lg\\:ml-1\\/5 {
    margin-left: 20%;
  }
  .lg\\:mt-2\\/5 {
    margin-top: 40%;
  }
  .lg\\:mr-2\\/5 {
    margin-right: 40%;
  }
  .lg\\:mb-2\\/5 {
    margin-bottom: 40%;
  }
  .lg\\:ml-2\\/5 {
    margin-left: 40%;
  }
  .lg\\:mt-3\\/5 {
    margin-top: 60%;
  }
  .lg\\:mr-3\\/5 {
    margin-right: 60%;
  }
  .lg\\:mb-3\\/5 {
    margin-bottom: 60%;
  }
  .lg\\:ml-3\\/5 {
    margin-left: 60%;
  }
  .lg\\:mt-4\\/5 {
    margin-top: 80%;
  }
  .lg\\:mr-4\\/5 {
    margin-right: 80%;
  }
  .lg\\:mb-4\\/5 {
    margin-bottom: 80%;
  }
  .lg\\:ml-4\\/5 {
    margin-left: 80%;
  }
  .lg\\:mt-1\\/6 {
    margin-top: 16.666667%;
  }
  .lg\\:mr-1\\/6 {
    margin-right: 16.666667%;
  }
  .lg\\:mb-1\\/6 {
    margin-bottom: 16.666667%;
  }
  .lg\\:ml-1\\/6 {
    margin-left: 16.666667%;
  }
  .lg\\:mt-2\\/6 {
    margin-top: 33.333333%;
  }
  .lg\\:mr-2\\/6 {
    margin-right: 33.333333%;
  }
  .lg\\:mb-2\\/6 {
    margin-bottom: 33.333333%;
  }
  .lg\\:ml-2\\/6 {
    margin-left: 33.333333%;
  }
  .lg\\:mt-3\\/6 {
    margin-top: 50%;
  }
  .lg\\:mr-3\\/6 {
    margin-right: 50%;
  }
  .lg\\:mb-3\\/6 {
    margin-bottom: 50%;
  }
  .lg\\:ml-3\\/6 {
    margin-left: 50%;
  }
  .lg\\:mt-4\\/6 {
    margin-top: 66.666667%;
  }
  .lg\\:mr-4\\/6 {
    margin-right: 66.666667%;
  }
  .lg\\:mb-4\\/6 {
    margin-bottom: 66.666667%;
  }
  .lg\\:ml-4\\/6 {
    margin-left: 66.666667%;
  }
  .lg\\:mt-5\\/6 {
    margin-top: 83.333333%;
  }
  .lg\\:mr-5\\/6 {
    margin-right: 83.333333%;
  }
  .lg\\:mb-5\\/6 {
    margin-bottom: 83.333333%;
  }
  .lg\\:ml-5\\/6 {
    margin-left: 83.333333%;
  }
  .lg\\:mt-1\\/12 {
    margin-top: 8.333333%;
  }
  .lg\\:mr-1\\/12 {
    margin-right: 8.333333%;
  }
  .lg\\:mb-1\\/12 {
    margin-bottom: 8.333333%;
  }
  .lg\\:ml-1\\/12 {
    margin-left: 8.333333%;
  }
  .lg\\:mt-2\\/12 {
    margin-top: 16.666667%;
  }
  .lg\\:mr-2\\/12 {
    margin-right: 16.666667%;
  }
  .lg\\:mb-2\\/12 {
    margin-bottom: 16.666667%;
  }
  .lg\\:ml-2\\/12 {
    margin-left: 16.666667%;
  }
  .lg\\:mt-3\\/12 {
    margin-top: 25%;
  }
  .lg\\:mr-3\\/12 {
    margin-right: 25%;
  }
  .lg\\:mb-3\\/12 {
    margin-bottom: 25%;
  }
  .lg\\:ml-3\\/12 {
    margin-left: 25%;
  }
  .lg\\:mt-4\\/12 {
    margin-top: 33.333333%;
  }
  .lg\\:mr-4\\/12 {
    margin-right: 33.333333%;
  }
  .lg\\:mb-4\\/12 {
    margin-bottom: 33.333333%;
  }
  .lg\\:ml-4\\/12 {
    margin-left: 33.333333%;
  }
  .lg\\:mt-5\\/12 {
    margin-top: 41.666667%;
  }
  .lg\\:mr-5\\/12 {
    margin-right: 41.666667%;
  }
  .lg\\:mb-5\\/12 {
    margin-bottom: 41.666667%;
  }
  .lg\\:ml-5\\/12 {
    margin-left: 41.666667%;
  }
  .lg\\:mt-6\\/12 {
    margin-top: 50%;
  }
  .lg\\:mr-6\\/12 {
    margin-right: 50%;
  }
  .lg\\:mb-6\\/12 {
    margin-bottom: 50%;
  }
  .lg\\:ml-6\\/12 {
    margin-left: 50%;
  }
  .lg\\:mt-7\\/12 {
    margin-top: 58.333333%;
  }
  .lg\\:mr-7\\/12 {
    margin-right: 58.333333%;
  }
  .lg\\:mb-7\\/12 {
    margin-bottom: 58.333333%;
  }
  .lg\\:ml-7\\/12 {
    margin-left: 58.333333%;
  }
  .lg\\:mt-8\\/12 {
    margin-top: 66.666667%;
  }
  .lg\\:mr-8\\/12 {
    margin-right: 66.666667%;
  }
  .lg\\:mb-8\\/12 {
    margin-bottom: 66.666667%;
  }
  .lg\\:ml-8\\/12 {
    margin-left: 66.666667%;
  }
  .lg\\:mt-9\\/12 {
    margin-top: 75%;
  }
  .lg\\:mr-9\\/12 {
    margin-right: 75%;
  }
  .lg\\:mb-9\\/12 {
    margin-bottom: 75%;
  }
  .lg\\:ml-9\\/12 {
    margin-left: 75%;
  }
  .lg\\:mt-10\\/12 {
    margin-top: 83.333333%;
  }
  .lg\\:mr-10\\/12 {
    margin-right: 83.333333%;
  }
  .lg\\:mb-10\\/12 {
    margin-bottom: 83.333333%;
  }
  .lg\\:ml-10\\/12 {
    margin-left: 83.333333%;
  }
  .lg\\:mt-11\\/12 {
    margin-top: 91.666667%;
  }
  .lg\\:mr-11\\/12 {
    margin-right: 91.666667%;
  }
  .lg\\:mb-11\\/12 {
    margin-bottom: 91.666667%;
  }
  .lg\\:ml-11\\/12 {
    margin-left: 91.666667%;
  }
  .lg\\:mt-full {
    margin-top: 100%;
  }
  .lg\\:mr-full {
    margin-right: 100%;
  }
  .lg\\:mb-full {
    margin-bottom: 100%;
  }
  .lg\\:ml-full {
    margin-left: 100%;
  }
  .lg\\:-mt-1 {
    margin-top: -0.25rem;
  }
  .lg\\:-mr-1 {
    margin-right: -0.25rem;
  }
  .lg\\:-mb-1 {
    margin-bottom: -0.25rem;
  }
  .lg\\:-ml-1 {
    margin-left: -0.25rem;
  }
  .lg\\:-mt-2 {
    margin-top: -0.5rem;
  }
  .lg\\:-mr-2 {
    margin-right: -0.5rem;
  }
  .lg\\:-mb-2 {
    margin-bottom: -0.5rem;
  }
  .lg\\:-ml-2 {
    margin-left: -0.5rem;
  }
  .lg\\:-mt-3 {
    margin-top: -0.75rem;
  }
  .lg\\:-mr-3 {
    margin-right: -0.75rem;
  }
  .lg\\:-mb-3 {
    margin-bottom: -0.75rem;
  }
  .lg\\:-ml-3 {
    margin-left: -0.75rem;
  }
  .lg\\:-mt-4 {
    margin-top: -1rem;
  }
  .lg\\:-mr-4 {
    margin-right: -1rem;
  }
  .lg\\:-mb-4 {
    margin-bottom: -1rem;
  }
  .lg\\:-ml-4 {
    margin-left: -1rem;
  }
  .lg\\:-mt-5 {
    margin-top: -1.25rem;
  }
  .lg\\:-mr-5 {
    margin-right: -1.25rem;
  }
  .lg\\:-mb-5 {
    margin-bottom: -1.25rem;
  }
  .lg\\:-ml-5 {
    margin-left: -1.25rem;
  }
  .lg\\:-mt-6 {
    margin-top: -1.5rem;
  }
  .lg\\:-mr-6 {
    margin-right: -1.5rem;
  }
  .lg\\:-mb-6 {
    margin-bottom: -1.5rem;
  }
  .lg\\:-ml-6 {
    margin-left: -1.5rem;
  }
  .lg\\:-mt-7 {
    margin-top: -1.75rem;
  }
  .lg\\:-mr-7 {
    margin-right: -1.75rem;
  }
  .lg\\:-mb-7 {
    margin-bottom: -1.75rem;
  }
  .lg\\:-ml-7 {
    margin-left: -1.75rem;
  }
  .lg\\:-mt-8 {
    margin-top: -2rem;
  }
  .lg\\:-mr-8 {
    margin-right: -2rem;
  }
  .lg\\:-mb-8 {
    margin-bottom: -2rem;
  }
  .lg\\:-ml-8 {
    margin-left: -2rem;
  }
  .lg\\:-mt-9 {
    margin-top: -2.25rem;
  }
  .lg\\:-mr-9 {
    margin-right: -2.25rem;
  }
  .lg\\:-mb-9 {
    margin-bottom: -2.25rem;
  }
  .lg\\:-ml-9 {
    margin-left: -2.25rem;
  }
  .lg\\:-mt-10 {
    margin-top: -2.5rem;
  }
  .lg\\:-mr-10 {
    margin-right: -2.5rem;
  }
  .lg\\:-mb-10 {
    margin-bottom: -2.5rem;
  }
  .lg\\:-ml-10 {
    margin-left: -2.5rem;
  }
  .lg\\:-mt-11 {
    margin-top: -2.75rem;
  }
  .lg\\:-mr-11 {
    margin-right: -2.75rem;
  }
  .lg\\:-mb-11 {
    margin-bottom: -2.75rem;
  }
  .lg\\:-ml-11 {
    margin-left: -2.75rem;
  }
  .lg\\:-mt-12 {
    margin-top: -3rem;
  }
  .lg\\:-mr-12 {
    margin-right: -3rem;
  }
  .lg\\:-mb-12 {
    margin-bottom: -3rem;
  }
  .lg\\:-ml-12 {
    margin-left: -3rem;
  }
  .lg\\:-mt-13 {
    margin-top: -3.25rem;
  }
  .lg\\:-mr-13 {
    margin-right: -3.25rem;
  }
  .lg\\:-mb-13 {
    margin-bottom: -3.25rem;
  }
  .lg\\:-ml-13 {
    margin-left: -3.25rem;
  }
  .lg\\:-mt-14 {
    margin-top: -3.5rem;
  }
  .lg\\:-mr-14 {
    margin-right: -3.5rem;
  }
  .lg\\:-mb-14 {
    margin-bottom: -3.5rem;
  }
  .lg\\:-ml-14 {
    margin-left: -3.5rem;
  }
  .lg\\:-mt-15 {
    margin-top: -3.75rem;
  }
  .lg\\:-mr-15 {
    margin-right: -3.75rem;
  }
  .lg\\:-mb-15 {
    margin-bottom: -3.75rem;
  }
  .lg\\:-ml-15 {
    margin-left: -3.75rem;
  }
  .lg\\:-mt-16 {
    margin-top: -4rem;
  }
  .lg\\:-mr-16 {
    margin-right: -4rem;
  }
  .lg\\:-mb-16 {
    margin-bottom: -4rem;
  }
  .lg\\:-ml-16 {
    margin-left: -4rem;
  }
  .lg\\:-mt-20 {
    margin-top: -5rem;
  }
  .lg\\:-mr-20 {
    margin-right: -5rem;
  }
  .lg\\:-mb-20 {
    margin-bottom: -5rem;
  }
  .lg\\:-ml-20 {
    margin-left: -5rem;
  }
  .lg\\:-mt-24 {
    margin-top: -6rem;
  }
  .lg\\:-mr-24 {
    margin-right: -6rem;
  }
  .lg\\:-mb-24 {
    margin-bottom: -6rem;
  }
  .lg\\:-ml-24 {
    margin-left: -6rem;
  }
  .lg\\:-mt-28 {
    margin-top: -7rem;
  }
  .lg\\:-mr-28 {
    margin-right: -7rem;
  }
  .lg\\:-mb-28 {
    margin-bottom: -7rem;
  }
  .lg\\:-ml-28 {
    margin-left: -7rem;
  }
  .lg\\:-mt-32 {
    margin-top: -8rem;
  }
  .lg\\:-mr-32 {
    margin-right: -8rem;
  }
  .lg\\:-mb-32 {
    margin-bottom: -8rem;
  }
  .lg\\:-ml-32 {
    margin-left: -8rem;
  }
  .lg\\:-mt-36 {
    margin-top: -9rem;
  }
  .lg\\:-mr-36 {
    margin-right: -9rem;
  }
  .lg\\:-mb-36 {
    margin-bottom: -9rem;
  }
  .lg\\:-ml-36 {
    margin-left: -9rem;
  }
  .lg\\:-mt-40 {
    margin-top: -10rem;
  }
  .lg\\:-mr-40 {
    margin-right: -10rem;
  }
  .lg\\:-mb-40 {
    margin-bottom: -10rem;
  }
  .lg\\:-ml-40 {
    margin-left: -10rem;
  }
  .lg\\:-mt-44 {
    margin-top: -11rem;
  }
  .lg\\:-mr-44 {
    margin-right: -11rem;
  }
  .lg\\:-mb-44 {
    margin-bottom: -11rem;
  }
  .lg\\:-ml-44 {
    margin-left: -11rem;
  }
  .lg\\:-mt-48 {
    margin-top: -12rem;
  }
  .lg\\:-mr-48 {
    margin-right: -12rem;
  }
  .lg\\:-mb-48 {
    margin-bottom: -12rem;
  }
  .lg\\:-ml-48 {
    margin-left: -12rem;
  }
  .lg\\:-mt-52 {
    margin-top: -13rem;
  }
  .lg\\:-mr-52 {
    margin-right: -13rem;
  }
  .lg\\:-mb-52 {
    margin-bottom: -13rem;
  }
  .lg\\:-ml-52 {
    margin-left: -13rem;
  }
  .lg\\:-mt-56 {
    margin-top: -14rem;
  }
  .lg\\:-mr-56 {
    margin-right: -14rem;
  }
  .lg\\:-mb-56 {
    margin-bottom: -14rem;
  }
  .lg\\:-ml-56 {
    margin-left: -14rem;
  }
  .lg\\:-mt-60 {
    margin-top: -15rem;
  }
  .lg\\:-mr-60 {
    margin-right: -15rem;
  }
  .lg\\:-mb-60 {
    margin-bottom: -15rem;
  }
  .lg\\:-ml-60 {
    margin-left: -15rem;
  }
  .lg\\:-mt-64 {
    margin-top: -16rem;
  }
  .lg\\:-mr-64 {
    margin-right: -16rem;
  }
  .lg\\:-mb-64 {
    margin-bottom: -16rem;
  }
  .lg\\:-ml-64 {
    margin-left: -16rem;
  }
  .lg\\:-mt-72 {
    margin-top: -18rem;
  }
  .lg\\:-mr-72 {
    margin-right: -18rem;
  }
  .lg\\:-mb-72 {
    margin-bottom: -18rem;
  }
  .lg\\:-ml-72 {
    margin-left: -18rem;
  }
  .lg\\:-mt-80 {
    margin-top: -20rem;
  }
  .lg\\:-mr-80 {
    margin-right: -20rem;
  }
  .lg\\:-mb-80 {
    margin-bottom: -20rem;
  }
  .lg\\:-ml-80 {
    margin-left: -20rem;
  }
  .lg\\:-mt-96 {
    margin-top: -24rem;
  }
  .lg\\:-mr-96 {
    margin-right: -24rem;
  }
  .lg\\:-mb-96 {
    margin-bottom: -24rem;
  }
  .lg\\:-ml-96 {
    margin-left: -24rem;
  }
  .lg\\:-mt-px {
    margin-top: -1px;
  }
  .lg\\:-mr-px {
    margin-right: -1px;
  }
  .lg\\:-mb-px {
    margin-bottom: -1px;
  }
  .lg\\:-ml-px {
    margin-left: -1px;
  }
  .lg\\:-mt-0\\.5 {
    margin-top: -0.125rem;
  }
  .lg\\:-mr-0\\.5 {
    margin-right: -0.125rem;
  }
  .lg\\:-mb-0\\.5 {
    margin-bottom: -0.125rem;
  }
  .lg\\:-ml-0\\.5 {
    margin-left: -0.125rem;
  }
  .lg\\:-mt-1\\.5 {
    margin-top: -0.375rem;
  }
  .lg\\:-mr-1\\.5 {
    margin-right: -0.375rem;
  }
  .lg\\:-mb-1\\.5 {
    margin-bottom: -0.375rem;
  }
  .lg\\:-ml-1\\.5 {
    margin-left: -0.375rem;
  }
  .lg\\:-mt-2\\.5 {
    margin-top: -0.625rem;
  }
  .lg\\:-mr-2\\.5 {
    margin-right: -0.625rem;
  }
  .lg\\:-mb-2\\.5 {
    margin-bottom: -0.625rem;
  }
  .lg\\:-ml-2\\.5 {
    margin-left: -0.625rem;
  }
  .lg\\:-mt-3\\.5 {
    margin-top: -0.875rem;
  }
  .lg\\:-mr-3\\.5 {
    margin-right: -0.875rem;
  }
  .lg\\:-mb-3\\.5 {
    margin-bottom: -0.875rem;
  }
  .lg\\:-ml-3\\.5 {
    margin-left: -0.875rem;
  }
  .lg\\:-mt-1\\/2 {
    margin-top: -50%;
  }
  .lg\\:-mr-1\\/2 {
    margin-right: -50%;
  }
  .lg\\:-mb-1\\/2 {
    margin-bottom: -50%;
  }
  .lg\\:-ml-1\\/2 {
    margin-left: -50%;
  }
  .lg\\:-mt-1\\/3 {
    margin-top: -33.33333%;
  }
  .lg\\:-mr-1\\/3 {
    margin-right: -33.33333%;
  }
  .lg\\:-mb-1\\/3 {
    margin-bottom: -33.33333%;
  }
  .lg\\:-ml-1\\/3 {
    margin-left: -33.33333%;
  }
  .lg\\:-mt-2\\/3 {
    margin-top: -66.66667%;
  }
  .lg\\:-mr-2\\/3 {
    margin-right: -66.66667%;
  }
  .lg\\:-mb-2\\/3 {
    margin-bottom: -66.66667%;
  }
  .lg\\:-ml-2\\/3 {
    margin-left: -66.66667%;
  }
  .lg\\:-mt-1\\/4 {
    margin-top: -25%;
  }
  .lg\\:-mr-1\\/4 {
    margin-right: -25%;
  }
  .lg\\:-mb-1\\/4 {
    margin-bottom: -25%;
  }
  .lg\\:-ml-1\\/4 {
    margin-left: -25%;
  }
  .lg\\:-mt-2\\/4 {
    margin-top: -50%;
  }
  .lg\\:-mr-2\\/4 {
    margin-right: -50%;
  }
  .lg\\:-mb-2\\/4 {
    margin-bottom: -50%;
  }
  .lg\\:-ml-2\\/4 {
    margin-left: -50%;
  }
  .lg\\:-mt-3\\/4 {
    margin-top: -75%;
  }
  .lg\\:-mr-3\\/4 {
    margin-right: -75%;
  }
  .lg\\:-mb-3\\/4 {
    margin-bottom: -75%;
  }
  .lg\\:-ml-3\\/4 {
    margin-left: -75%;
  }
  .lg\\:-mt-1\\/5 {
    margin-top: -20%;
  }
  .lg\\:-mr-1\\/5 {
    margin-right: -20%;
  }
  .lg\\:-mb-1\\/5 {
    margin-bottom: -20%;
  }
  .lg\\:-ml-1\\/5 {
    margin-left: -20%;
  }
  .lg\\:-mt-2\\/5 {
    margin-top: -40%;
  }
  .lg\\:-mr-2\\/5 {
    margin-right: -40%;
  }
  .lg\\:-mb-2\\/5 {
    margin-bottom: -40%;
  }
  .lg\\:-ml-2\\/5 {
    margin-left: -40%;
  }
  .lg\\:-mt-3\\/5 {
    margin-top: -60%;
  }
  .lg\\:-mr-3\\/5 {
    margin-right: -60%;
  }
  .lg\\:-mb-3\\/5 {
    margin-bottom: -60%;
  }
  .lg\\:-ml-3\\/5 {
    margin-left: -60%;
  }
  .lg\\:-mt-4\\/5 {
    margin-top: -80%;
  }
  .lg\\:-mr-4\\/5 {
    margin-right: -80%;
  }
  .lg\\:-mb-4\\/5 {
    margin-bottom: -80%;
  }
  .lg\\:-ml-4\\/5 {
    margin-left: -80%;
  }
  .lg\\:-mt-1\\/6 {
    margin-top: -16.66667%;
  }
  .lg\\:-mr-1\\/6 {
    margin-right: -16.66667%;
  }
  .lg\\:-mb-1\\/6 {
    margin-bottom: -16.66667%;
  }
  .lg\\:-ml-1\\/6 {
    margin-left: -16.66667%;
  }
  .lg\\:-mt-2\\/6 {
    margin-top: -33.33333%;
  }
  .lg\\:-mr-2\\/6 {
    margin-right: -33.33333%;
  }
  .lg\\:-mb-2\\/6 {
    margin-bottom: -33.33333%;
  }
  .lg\\:-ml-2\\/6 {
    margin-left: -33.33333%;
  }
  .lg\\:-mt-3\\/6 {
    margin-top: -50%;
  }
  .lg\\:-mr-3\\/6 {
    margin-right: -50%;
  }
  .lg\\:-mb-3\\/6 {
    margin-bottom: -50%;
  }
  .lg\\:-ml-3\\/6 {
    margin-left: -50%;
  }
  .lg\\:-mt-4\\/6 {
    margin-top: -66.66667%;
  }
  .lg\\:-mr-4\\/6 {
    margin-right: -66.66667%;
  }
  .lg\\:-mb-4\\/6 {
    margin-bottom: -66.66667%;
  }
  .lg\\:-ml-4\\/6 {
    margin-left: -66.66667%;
  }
  .lg\\:-mt-5\\/6 {
    margin-top: -83.33333%;
  }
  .lg\\:-mr-5\\/6 {
    margin-right: -83.33333%;
  }
  .lg\\:-mb-5\\/6 {
    margin-bottom: -83.33333%;
  }
  .lg\\:-ml-5\\/6 {
    margin-left: -83.33333%;
  }
  .lg\\:-mt-1\\/12 {
    margin-top: -8.33333%;
  }
  .lg\\:-mr-1\\/12 {
    margin-right: -8.33333%;
  }
  .lg\\:-mb-1\\/12 {
    margin-bottom: -8.33333%;
  }
  .lg\\:-ml-1\\/12 {
    margin-left: -8.33333%;
  }
  .lg\\:-mt-2\\/12 {
    margin-top: -16.66667%;
  }
  .lg\\:-mr-2\\/12 {
    margin-right: -16.66667%;
  }
  .lg\\:-mb-2\\/12 {
    margin-bottom: -16.66667%;
  }
  .lg\\:-ml-2\\/12 {
    margin-left: -16.66667%;
  }
  .lg\\:-mt-3\\/12 {
    margin-top: -25%;
  }
  .lg\\:-mr-3\\/12 {
    margin-right: -25%;
  }
  .lg\\:-mb-3\\/12 {
    margin-bottom: -25%;
  }
  .lg\\:-ml-3\\/12 {
    margin-left: -25%;
  }
  .lg\\:-mt-4\\/12 {
    margin-top: -33.33333%;
  }
  .lg\\:-mr-4\\/12 {
    margin-right: -33.33333%;
  }
  .lg\\:-mb-4\\/12 {
    margin-bottom: -33.33333%;
  }
  .lg\\:-ml-4\\/12 {
    margin-left: -33.33333%;
  }
  .lg\\:-mt-5\\/12 {
    margin-top: -41.66667%;
  }
  .lg\\:-mr-5\\/12 {
    margin-right: -41.66667%;
  }
  .lg\\:-mb-5\\/12 {
    margin-bottom: -41.66667%;
  }
  .lg\\:-ml-5\\/12 {
    margin-left: -41.66667%;
  }
  .lg\\:-mt-6\\/12 {
    margin-top: -50%;
  }
  .lg\\:-mr-6\\/12 {
    margin-right: -50%;
  }
  .lg\\:-mb-6\\/12 {
    margin-bottom: -50%;
  }
  .lg\\:-ml-6\\/12 {
    margin-left: -50%;
  }
  .lg\\:-mt-7\\/12 {
    margin-top: -58.33333%;
  }
  .lg\\:-mr-7\\/12 {
    margin-right: -58.33333%;
  }
  .lg\\:-mb-7\\/12 {
    margin-bottom: -58.33333%;
  }
  .lg\\:-ml-7\\/12 {
    margin-left: -58.33333%;
  }
  .lg\\:-mt-8\\/12 {
    margin-top: -66.66667%;
  }
  .lg\\:-mr-8\\/12 {
    margin-right: -66.66667%;
  }
  .lg\\:-mb-8\\/12 {
    margin-bottom: -66.66667%;
  }
  .lg\\:-ml-8\\/12 {
    margin-left: -66.66667%;
  }
  .lg\\:-mt-9\\/12 {
    margin-top: -75%;
  }
  .lg\\:-mr-9\\/12 {
    margin-right: -75%;
  }
  .lg\\:-mb-9\\/12 {
    margin-bottom: -75%;
  }
  .lg\\:-ml-9\\/12 {
    margin-left: -75%;
  }
  .lg\\:-mt-10\\/12 {
    margin-top: -83.33333%;
  }
  .lg\\:-mr-10\\/12 {
    margin-right: -83.33333%;
  }
  .lg\\:-mb-10\\/12 {
    margin-bottom: -83.33333%;
  }
  .lg\\:-ml-10\\/12 {
    margin-left: -83.33333%;
  }
  .lg\\:-mt-11\\/12 {
    margin-top: -91.66667%;
  }
  .lg\\:-mr-11\\/12 {
    margin-right: -91.66667%;
  }
  .lg\\:-mb-11\\/12 {
    margin-bottom: -91.66667%;
  }
  .lg\\:-ml-11\\/12 {
    margin-left: -91.66667%;
  }
  .lg\\:-mt-full {
    margin-top: -100%;
  }
  .lg\\:-mr-full {
    margin-right: -100%;
  }
  .lg\\:-mb-full {
    margin-bottom: -100%;
  }
  .lg\\:-ml-full {
    margin-left: -100%;
  }
  .lg\\:max-h-0 {
    max-height: 0;
  }
  .lg\\:max-h-1 {
    max-height: 0.25rem;
  }
  .lg\\:max-h-2 {
    max-height: 0.5rem;
  }
  .lg\\:max-h-3 {
    max-height: 0.75rem;
  }
  .lg\\:max-h-4 {
    max-height: 1rem;
  }
  .lg\\:max-h-5 {
    max-height: 1.25rem;
  }
  .lg\\:max-h-6 {
    max-height: 1.5rem;
  }
  .lg\\:max-h-7 {
    max-height: 1.75rem;
  }
  .lg\\:max-h-8 {
    max-height: 2rem;
  }
  .lg\\:max-h-9 {
    max-height: 2.25rem;
  }
  .lg\\:max-h-10 {
    max-height: 2.5rem;
  }
  .lg\\:max-h-11 {
    max-height: 2.75rem;
  }
  .lg\\:max-h-12 {
    max-height: 3rem;
  }
  .lg\\:max-h-13 {
    max-height: 3.25rem;
  }
  .lg\\:max-h-14 {
    max-height: 3.5rem;
  }
  .lg\\:max-h-15 {
    max-height: 3.75rem;
  }
  .lg\\:max-h-16 {
    max-height: 4rem;
  }
  .lg\\:max-h-20 {
    max-height: 5rem;
  }
  .lg\\:max-h-24 {
    max-height: 6rem;
  }
  .lg\\:max-h-28 {
    max-height: 7rem;
  }
  .lg\\:max-h-32 {
    max-height: 8rem;
  }
  .lg\\:max-h-36 {
    max-height: 9rem;
  }
  .lg\\:max-h-40 {
    max-height: 10rem;
  }
  .lg\\:max-h-44 {
    max-height: 11rem;
  }
  .lg\\:max-h-48 {
    max-height: 12rem;
  }
  .lg\\:max-h-52 {
    max-height: 13rem;
  }
  .lg\\:max-h-56 {
    max-height: 14rem;
  }
  .lg\\:max-h-60 {
    max-height: 15rem;
  }
  .lg\\:max-h-64 {
    max-height: 16rem;
  }
  .lg\\:max-h-72 {
    max-height: 18rem;
  }
  .lg\\:max-h-80 {
    max-height: 20rem;
  }
  .lg\\:max-h-96 {
    max-height: 24rem;
  }
  .lg\\:max-h-screen {
    max-height: 100vh;
  }
  .lg\\:max-h-px {
    max-height: 1px;
  }
  .lg\\:max-h-0\\.5 {
    max-height: 0.125rem;
  }
  .lg\\:max-h-1\\.5 {
    max-height: 0.375rem;
  }
  .lg\\:max-h-2\\.5 {
    max-height: 0.625rem;
  }
  .lg\\:max-h-3\\.5 {
    max-height: 0.875rem;
  }
  .lg\\:max-h-1\\/2 {
    max-height: 50%;
  }
  .lg\\:max-h-1\\/3 {
    max-height: 33.333333%;
  }
  .lg\\:max-h-2\\/3 {
    max-height: 66.666667%;
  }
  .lg\\:max-h-1\\/4 {
    max-height: 25%;
  }
  .lg\\:max-h-2\\/4 {
    max-height: 50%;
  }
  .lg\\:max-h-3\\/4 {
    max-height: 75%;
  }
  .lg\\:max-h-1\\/5 {
    max-height: 20%;
  }
  .lg\\:max-h-2\\/5 {
    max-height: 40%;
  }
  .lg\\:max-h-3\\/5 {
    max-height: 60%;
  }
  .lg\\:max-h-4\\/5 {
    max-height: 80%;
  }
  .lg\\:max-h-1\\/6 {
    max-height: 16.666667%;
  }
  .lg\\:max-h-2\\/6 {
    max-height: 33.333333%;
  }
  .lg\\:max-h-3\\/6 {
    max-height: 50%;
  }
  .lg\\:max-h-4\\/6 {
    max-height: 66.666667%;
  }
  .lg\\:max-h-5\\/6 {
    max-height: 83.333333%;
  }
  .lg\\:max-h-1\\/12 {
    max-height: 8.333333%;
  }
  .lg\\:max-h-2\\/12 {
    max-height: 16.666667%;
  }
  .lg\\:max-h-3\\/12 {
    max-height: 25%;
  }
  .lg\\:max-h-4\\/12 {
    max-height: 33.333333%;
  }
  .lg\\:max-h-5\\/12 {
    max-height: 41.666667%;
  }
  .lg\\:max-h-6\\/12 {
    max-height: 50%;
  }
  .lg\\:max-h-7\\/12 {
    max-height: 58.333333%;
  }
  .lg\\:max-h-8\\/12 {
    max-height: 66.666667%;
  }
  .lg\\:max-h-9\\/12 {
    max-height: 75%;
  }
  .lg\\:max-h-10\\/12 {
    max-height: 83.333333%;
  }
  .lg\\:max-h-11\\/12 {
    max-height: 91.666667%;
  }
  .lg\\:max-h-full {
    max-height: 100%;
  }
  .lg\\:max-w-0 {
    max-width: 0rem;
  }
  .lg\\:max-w-none {
    max-width: none;
  }
  .lg\\:max-w-xs {
    max-width: 20rem;
  }
  .lg\\:max-w-sm {
    max-width: 24rem;
  }
  .lg\\:max-w-md {
    max-width: 28rem;
  }
  .lg\\:max-w-lg {
    max-width: 32rem;
  }
  .lg\\:max-w-xl {
    max-width: 36rem;
  }
  .lg\\:max-w-2xl {
    max-width: 42rem;
  }
  .lg\\:max-w-3xl {
    max-width: 48rem;
  }
  .lg\\:max-w-4xl {
    max-width: 56rem;
  }
  .lg\\:max-w-5xl {
    max-width: 64rem;
  }
  .lg\\:max-w-6xl {
    max-width: 72rem;
  }
  .lg\\:max-w-7xl {
    max-width: 80rem;
  }
  .lg\\:max-w-full {
    max-width: 100%;
  }
  .lg\\:max-w-min-content {
    max-width: min-content;
  }
  .lg\\:max-w-max-content {
    max-width: max-content;
  }
  .lg\\:max-w-prose {
    max-width: 65ch;
  }
  .lg\\:max-w-screen-sm {
    max-width: 640px;
  }
  .lg\\:max-w-screen-md {
    max-width: 768px;
  }
  .lg\\:max-w-screen-lg {
    max-width: 1024px;
  }
  .lg\\:max-w-screen-xl {
    max-width: 1280px;
  }
  .lg\\:min-h-0 {
    min-height: 0;
  }
  .lg\\:min-h-full {
    min-height: 100%;
  }
  .lg\\:min-h-screen {
    min-height: 100vh;
  }
  .lg\\:min-w-0 {
    min-width: 0;
  }
  .lg\\:min-w-full {
    min-width: 100%;
  }
  .lg\\:min-w-min-content {
    min-width: min-content;
  }
  .lg\\:min-w-max-content {
    min-width: max-content;
  }
  .lg\\:object-contain {
    object-fit: contain;
  }
  .lg\\:object-cover {
    object-fit: cover;
  }
  .lg\\:object-fill {
    object-fit: fill;
  }
  .lg\\:object-none {
    object-fit: none;
  }
  .lg\\:object-scale-down {
    object-fit: scale-down;
  }
  .lg\\:object-bottom {
    object-position: bottom;
  }
  .lg\\:object-center {
    object-position: center;
  }
  .lg\\:object-left {
    object-position: left;
  }
  .lg\\:object-left-bottom {
    object-position: left bottom;
  }
  .lg\\:object-left-top {
    object-position: left top;
  }
  .lg\\:object-right {
    object-position: right;
  }
  .lg\\:object-right-bottom {
    object-position: right bottom;
  }
  .lg\\:object-right-top {
    object-position: right top;
  }
  .lg\\:object-top {
    object-position: top;
  }
  .lg\\:opacity-0 {
    opacity: 0;
  }
  .lg\\:opacity-25 {
    opacity: 0.25;
  }
  .lg\\:opacity-50 {
    opacity: 0.5;
  }
  .lg\\:opacity-75 {
    opacity: 0.75;
  }
  .lg\\:opacity-100 {
    opacity: 1;
  }
  .lg\\:focus-within\\:opacity-0:focus-within {
    opacity: 0;
  }
  .lg\\:focus-within\\:opacity-25:focus-within {
    opacity: 0.25;
  }
  .lg\\:focus-within\\:opacity-50:focus-within {
    opacity: 0.5;
  }
  .lg\\:focus-within\\:opacity-75:focus-within {
    opacity: 0.75;
  }
  .lg\\:focus-within\\:opacity-100:focus-within {
    opacity: 1;
  }
  .group:hover .lg\\:group-hover\\:opacity-0 {
    opacity: 0;
  }
  .group:hover .lg\\:group-hover\\:opacity-25 {
    opacity: 0.25;
  }
  .group:hover .lg\\:group-hover\\:opacity-50 {
    opacity: 0.5;
  }
  .group:hover .lg\\:group-hover\\:opacity-75 {
    opacity: 0.75;
  }
  .group:hover .lg\\:group-hover\\:opacity-100 {
    opacity: 1;
  }
  .group:focus .lg\\:group-focus\\:opacity-0 {
    opacity: 0;
  }
  .group:focus .lg\\:group-focus\\:opacity-25 {
    opacity: 0.25;
  }
  .group:focus .lg\\:group-focus\\:opacity-50 {
    opacity: 0.5;
  }
  .group:focus .lg\\:group-focus\\:opacity-75 {
    opacity: 0.75;
  }
  .group:focus .lg\\:group-focus\\:opacity-100 {
    opacity: 1;
  }
  .lg\\:hover\\:opacity-0:hover {
    opacity: 0;
  }
  .lg\\:hover\\:opacity-25:hover {
    opacity: 0.25;
  }
  .lg\\:hover\\:opacity-50:hover {
    opacity: 0.5;
  }
  .lg\\:hover\\:opacity-75:hover {
    opacity: 0.75;
  }
  .lg\\:hover\\:opacity-100:hover {
    opacity: 1;
  }
  .lg\\:focus\\:opacity-0:focus {
    opacity: 0;
  }
  .lg\\:focus\\:opacity-25:focus {
    opacity: 0.25;
  }
  .lg\\:focus\\:opacity-50:focus {
    opacity: 0.5;
  }
  .lg\\:focus\\:opacity-75:focus {
    opacity: 0.75;
  }
  .lg\\:focus\\:opacity-100:focus {
    opacity: 1;
  }
  .lg\\:outline-none {
    outline: 2px solid transparent;
    outline-offset: 2px;
  }
  .lg\\:outline-white {
    outline: 2px dotted white;
    outline-offset: 2px;
  }
  .lg\\:outline-black {
    outline: 2px dotted black;
    outline-offset: 2px;
  }
  .lg\\:focus\\:outline-none:focus {
    outline: 2px solid transparent;
    outline-offset: 2px;
  }
  .lg\\:focus\\:outline-white:focus {
    outline: 2px dotted white;
    outline-offset: 2px;
  }
  .lg\\:focus\\:outline-black:focus {
    outline: 2px dotted black;
    outline-offset: 2px;
  }
  .lg\\:overflow-auto {
    overflow: auto;
  }
  .lg\\:overflow-hidden {
    overflow: hidden;
  }
  .lg\\:overflow-visible {
    overflow: visible;
  }
  .lg\\:overflow-scroll {
    overflow: scroll;
  }
  .lg\\:overflow-x-auto {
    overflow-x: auto;
  }
  .lg\\:overflow-y-auto {
    overflow-y: auto;
  }
  .lg\\:overflow-x-hidden {
    overflow-x: hidden;
  }
  .lg\\:overflow-y-hidden {
    overflow-y: hidden;
  }
  .lg\\:overflow-x-visible {
    overflow-x: visible;
  }
  .lg\\:overflow-y-visible {
    overflow-y: visible;
  }
  .lg\\:overflow-x-scroll {
    overflow-x: scroll;
  }
  .lg\\:overflow-y-scroll {
    overflow-y: scroll;
  }
  .lg\\:scrolling-touch {
    -webkit-overflow-scrolling: touch;
  }
  .lg\\:scrolling-auto {
    -webkit-overflow-scrolling: auto;
  }
  .lg\\:overscroll-auto {
    overscroll-behavior: auto;
  }
  .lg\\:overscroll-contain {
    overscroll-behavior: contain;
  }
  .lg\\:overscroll-none {
    overscroll-behavior: none;
  }
  .lg\\:overscroll-y-auto {
    overscroll-behavior-y: auto;
  }
  .lg\\:overscroll-y-contain {
    overscroll-behavior-y: contain;
  }
  .lg\\:overscroll-y-none {
    overscroll-behavior-y: none;
  }
  .lg\\:overscroll-x-auto {
    overscroll-behavior-x: auto;
  }
  .lg\\:overscroll-x-contain {
    overscroll-behavior-x: contain;
  }
  .lg\\:overscroll-x-none {
    overscroll-behavior-x: none;
  }
  .lg\\:p-0 {
    padding: 0;
  }
  .lg\\:p-1 {
    padding: 0.25rem;
  }
  .lg\\:p-2 {
    padding: 0.5rem;
  }
  .lg\\:p-3 {
    padding: 0.75rem;
  }
  .lg\\:p-4 {
    padding: 1rem;
  }
  .lg\\:p-5 {
    padding: 1.25rem;
  }
  .lg\\:p-6 {
    padding: 1.5rem;
  }
  .lg\\:p-7 {
    padding: 1.75rem;
  }
  .lg\\:p-8 {
    padding: 2rem;
  }
  .lg\\:p-9 {
    padding: 2.25rem;
  }
  .lg\\:p-10 {
    padding: 2.5rem;
  }
  .lg\\:p-11 {
    padding: 2.75rem;
  }
  .lg\\:p-12 {
    padding: 3rem;
  }
  .lg\\:p-13 {
    padding: 3.25rem;
  }
  .lg\\:p-14 {
    padding: 3.5rem;
  }
  .lg\\:p-15 {
    padding: 3.75rem;
  }
  .lg\\:p-16 {
    padding: 4rem;
  }
  .lg\\:p-20 {
    padding: 5rem;
  }
  .lg\\:p-24 {
    padding: 6rem;
  }
  .lg\\:p-28 {
    padding: 7rem;
  }
  .lg\\:p-32 {
    padding: 8rem;
  }
  .lg\\:p-36 {
    padding: 9rem;
  }
  .lg\\:p-40 {
    padding: 10rem;
  }
  .lg\\:p-44 {
    padding: 11rem;
  }
  .lg\\:p-48 {
    padding: 12rem;
  }
  .lg\\:p-52 {
    padding: 13rem;
  }
  .lg\\:p-56 {
    padding: 14rem;
  }
  .lg\\:p-60 {
    padding: 15rem;
  }
  .lg\\:p-64 {
    padding: 16rem;
  }
  .lg\\:p-72 {
    padding: 18rem;
  }
  .lg\\:p-80 {
    padding: 20rem;
  }
  .lg\\:p-96 {
    padding: 24rem;
  }
  .lg\\:p-px {
    padding: 1px;
  }
  .lg\\:p-0\\.5 {
    padding: 0.125rem;
  }
  .lg\\:p-1\\.5 {
    padding: 0.375rem;
  }
  .lg\\:p-2\\.5 {
    padding: 0.625rem;
  }
  .lg\\:p-3\\.5 {
    padding: 0.875rem;
  }
  .lg\\:p-1\\/2 {
    padding: 50%;
  }
  .lg\\:p-1\\/3 {
    padding: 33.333333%;
  }
  .lg\\:p-2\\/3 {
    padding: 66.666667%;
  }
  .lg\\:p-1\\/4 {
    padding: 25%;
  }
  .lg\\:p-2\\/4 {
    padding: 50%;
  }
  .lg\\:p-3\\/4 {
    padding: 75%;
  }
  .lg\\:p-1\\/5 {
    padding: 20%;
  }
  .lg\\:p-2\\/5 {
    padding: 40%;
  }
  .lg\\:p-3\\/5 {
    padding: 60%;
  }
  .lg\\:p-4\\/5 {
    padding: 80%;
  }
  .lg\\:p-1\\/6 {
    padding: 16.666667%;
  }
  .lg\\:p-2\\/6 {
    padding: 33.333333%;
  }
  .lg\\:p-3\\/6 {
    padding: 50%;
  }
  .lg\\:p-4\\/6 {
    padding: 66.666667%;
  }
  .lg\\:p-5\\/6 {
    padding: 83.333333%;
  }
  .lg\\:p-1\\/12 {
    padding: 8.333333%;
  }
  .lg\\:p-2\\/12 {
    padding: 16.666667%;
  }
  .lg\\:p-3\\/12 {
    padding: 25%;
  }
  .lg\\:p-4\\/12 {
    padding: 33.333333%;
  }
  .lg\\:p-5\\/12 {
    padding: 41.666667%;
  }
  .lg\\:p-6\\/12 {
    padding: 50%;
  }
  .lg\\:p-7\\/12 {
    padding: 58.333333%;
  }
  .lg\\:p-8\\/12 {
    padding: 66.666667%;
  }
  .lg\\:p-9\\/12 {
    padding: 75%;
  }
  .lg\\:p-10\\/12 {
    padding: 83.333333%;
  }
  .lg\\:p-11\\/12 {
    padding: 91.666667%;
  }
  .lg\\:p-full {
    padding: 100%;
  }
  .lg\\:py-0 {
    padding-top: 0;
    padding-bottom: 0;
  }
  .lg\\:px-0 {
    padding-left: 0;
    padding-right: 0;
  }
  .lg\\:py-1 {
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
  }
  .lg\\:px-1 {
    padding-left: 0.25rem;
    padding-right: 0.25rem;
  }
  .lg\\:py-2 {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }
  .lg\\:px-2 {
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }
  .lg\\:py-3 {
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
  }
  .lg\\:px-3 {
    padding-left: 0.75rem;
    padding-right: 0.75rem;
  }
  .lg\\:py-4 {
    padding-top: 1rem;
    padding-bottom: 1rem;
  }
  .lg\\:px-4 {
    padding-left: 1rem;
    padding-right: 1rem;
  }
  .lg\\:py-5 {
    padding-top: 1.25rem;
    padding-bottom: 1.25rem;
  }
  .lg\\:px-5 {
    padding-left: 1.25rem;
    padding-right: 1.25rem;
  }
  .lg\\:py-6 {
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
  }
  .lg\\:px-6 {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }
  .lg\\:py-7 {
    padding-top: 1.75rem;
    padding-bottom: 1.75rem;
  }
  .lg\\:px-7 {
    padding-left: 1.75rem;
    padding-right: 1.75rem;
  }
  .lg\\:py-8 {
    padding-top: 2rem;
    padding-bottom: 2rem;
  }
  .lg\\:px-8 {
    padding-left: 2rem;
    padding-right: 2rem;
  }
  .lg\\:py-9 {
    padding-top: 2.25rem;
    padding-bottom: 2.25rem;
  }
  .lg\\:px-9 {
    padding-left: 2.25rem;
    padding-right: 2.25rem;
  }
  .lg\\:py-10 {
    padding-top: 2.5rem;
    padding-bottom: 2.5rem;
  }
  .lg\\:px-10 {
    padding-left: 2.5rem;
    padding-right: 2.5rem;
  }
  .lg\\:py-11 {
    padding-top: 2.75rem;
    padding-bottom: 2.75rem;
  }
  .lg\\:px-11 {
    padding-left: 2.75rem;
    padding-right: 2.75rem;
  }
  .lg\\:py-12 {
    padding-top: 3rem;
    padding-bottom: 3rem;
  }
  .lg\\:px-12 {
    padding-left: 3rem;
    padding-right: 3rem;
  }
  .lg\\:py-13 {
    padding-top: 3.25rem;
    padding-bottom: 3.25rem;
  }
  .lg\\:px-13 {
    padding-left: 3.25rem;
    padding-right: 3.25rem;
  }
  .lg\\:py-14 {
    padding-top: 3.5rem;
    padding-bottom: 3.5rem;
  }
  .lg\\:px-14 {
    padding-left: 3.5rem;
    padding-right: 3.5rem;
  }
  .lg\\:py-15 {
    padding-top: 3.75rem;
    padding-bottom: 3.75rem;
  }
  .lg\\:px-15 {
    padding-left: 3.75rem;
    padding-right: 3.75rem;
  }
  .lg\\:py-16 {
    padding-top: 4rem;
    padding-bottom: 4rem;
  }
  .lg\\:px-16 {
    padding-left: 4rem;
    padding-right: 4rem;
  }
  .lg\\:py-20 {
    padding-top: 5rem;
    padding-bottom: 5rem;
  }
  .lg\\:px-20 {
    padding-left: 5rem;
    padding-right: 5rem;
  }
  .lg\\:py-24 {
    padding-top: 6rem;
    padding-bottom: 6rem;
  }
  .lg\\:px-24 {
    padding-left: 6rem;
    padding-right: 6rem;
  }
  .lg\\:py-28 {
    padding-top: 7rem;
    padding-bottom: 7rem;
  }
  .lg\\:px-28 {
    padding-left: 7rem;
    padding-right: 7rem;
  }
  .lg\\:py-32 {
    padding-top: 8rem;
    padding-bottom: 8rem;
  }
  .lg\\:px-32 {
    padding-left: 8rem;
    padding-right: 8rem;
  }
  .lg\\:py-36 {
    padding-top: 9rem;
    padding-bottom: 9rem;
  }
  .lg\\:px-36 {
    padding-left: 9rem;
    padding-right: 9rem;
  }
  .lg\\:py-40 {
    padding-top: 10rem;
    padding-bottom: 10rem;
  }
  .lg\\:px-40 {
    padding-left: 10rem;
    padding-right: 10rem;
  }
  .lg\\:py-44 {
    padding-top: 11rem;
    padding-bottom: 11rem;
  }
  .lg\\:px-44 {
    padding-left: 11rem;
    padding-right: 11rem;
  }
  .lg\\:py-48 {
    padding-top: 12rem;
    padding-bottom: 12rem;
  }
  .lg\\:px-48 {
    padding-left: 12rem;
    padding-right: 12rem;
  }
  .lg\\:py-52 {
    padding-top: 13rem;
    padding-bottom: 13rem;
  }
  .lg\\:px-52 {
    padding-left: 13rem;
    padding-right: 13rem;
  }
  .lg\\:py-56 {
    padding-top: 14rem;
    padding-bottom: 14rem;
  }
  .lg\\:px-56 {
    padding-left: 14rem;
    padding-right: 14rem;
  }
  .lg\\:py-60 {
    padding-top: 15rem;
    padding-bottom: 15rem;
  }
  .lg\\:px-60 {
    padding-left: 15rem;
    padding-right: 15rem;
  }
  .lg\\:py-64 {
    padding-top: 16rem;
    padding-bottom: 16rem;
  }
  .lg\\:px-64 {
    padding-left: 16rem;
    padding-right: 16rem;
  }
  .lg\\:py-72 {
    padding-top: 18rem;
    padding-bottom: 18rem;
  }
  .lg\\:px-72 {
    padding-left: 18rem;
    padding-right: 18rem;
  }
  .lg\\:py-80 {
    padding-top: 20rem;
    padding-bottom: 20rem;
  }
  .lg\\:px-80 {
    padding-left: 20rem;
    padding-right: 20rem;
  }
  .lg\\:py-96 {
    padding-top: 24rem;
    padding-bottom: 24rem;
  }
  .lg\\:px-96 {
    padding-left: 24rem;
    padding-right: 24rem;
  }
  .lg\\:py-px {
    padding-top: 1px;
    padding-bottom: 1px;
  }
  .lg\\:px-px {
    padding-left: 1px;
    padding-right: 1px;
  }
  .lg\\:py-0\\.5 {
    padding-top: 0.125rem;
    padding-bottom: 0.125rem;
  }
  .lg\\:px-0\\.5 {
    padding-left: 0.125rem;
    padding-right: 0.125rem;
  }
  .lg\\:py-1\\.5 {
    padding-top: 0.375rem;
    padding-bottom: 0.375rem;
  }
  .lg\\:px-1\\.5 {
    padding-left: 0.375rem;
    padding-right: 0.375rem;
  }
  .lg\\:py-2\\.5 {
    padding-top: 0.625rem;
    padding-bottom: 0.625rem;
  }
  .lg\\:px-2\\.5 {
    padding-left: 0.625rem;
    padding-right: 0.625rem;
  }
  .lg\\:py-3\\.5 {
    padding-top: 0.875rem;
    padding-bottom: 0.875rem;
  }
  .lg\\:px-3\\.5 {
    padding-left: 0.875rem;
    padding-right: 0.875rem;
  }
  .lg\\:py-1\\/2 {
    padding-top: 50%;
    padding-bottom: 50%;
  }
  .lg\\:px-1\\/2 {
    padding-left: 50%;
    padding-right: 50%;
  }
  .lg\\:py-1\\/3 {
    padding-top: 33.333333%;
    padding-bottom: 33.333333%;
  }
  .lg\\:px-1\\/3 {
    padding-left: 33.333333%;
    padding-right: 33.333333%;
  }
  .lg\\:py-2\\/3 {
    padding-top: 66.666667%;
    padding-bottom: 66.666667%;
  }
  .lg\\:px-2\\/3 {
    padding-left: 66.666667%;
    padding-right: 66.666667%;
  }
  .lg\\:py-1\\/4 {
    padding-top: 25%;
    padding-bottom: 25%;
  }
  .lg\\:px-1\\/4 {
    padding-left: 25%;
    padding-right: 25%;
  }
  .lg\\:py-2\\/4 {
    padding-top: 50%;
    padding-bottom: 50%;
  }
  .lg\\:px-2\\/4 {
    padding-left: 50%;
    padding-right: 50%;
  }
  .lg\\:py-3\\/4 {
    padding-top: 75%;
    padding-bottom: 75%;
  }
  .lg\\:px-3\\/4 {
    padding-left: 75%;
    padding-right: 75%;
  }
  .lg\\:py-1\\/5 {
    padding-top: 20%;
    padding-bottom: 20%;
  }
  .lg\\:px-1\\/5 {
    padding-left: 20%;
    padding-right: 20%;
  }
  .lg\\:py-2\\/5 {
    padding-top: 40%;
    padding-bottom: 40%;
  }
  .lg\\:px-2\\/5 {
    padding-left: 40%;
    padding-right: 40%;
  }
  .lg\\:py-3\\/5 {
    padding-top: 60%;
    padding-bottom: 60%;
  }
  .lg\\:px-3\\/5 {
    padding-left: 60%;
    padding-right: 60%;
  }
  .lg\\:py-4\\/5 {
    padding-top: 80%;
    padding-bottom: 80%;
  }
  .lg\\:px-4\\/5 {
    padding-left: 80%;
    padding-right: 80%;
  }
  .lg\\:py-1\\/6 {
    padding-top: 16.666667%;
    padding-bottom: 16.666667%;
  }
  .lg\\:px-1\\/6 {
    padding-left: 16.666667%;
    padding-right: 16.666667%;
  }
  .lg\\:py-2\\/6 {
    padding-top: 33.333333%;
    padding-bottom: 33.333333%;
  }
  .lg\\:px-2\\/6 {
    padding-left: 33.333333%;
    padding-right: 33.333333%;
  }
  .lg\\:py-3\\/6 {
    padding-top: 50%;
    padding-bottom: 50%;
  }
  .lg\\:px-3\\/6 {
    padding-left: 50%;
    padding-right: 50%;
  }
  .lg\\:py-4\\/6 {
    padding-top: 66.666667%;
    padding-bottom: 66.666667%;
  }
  .lg\\:px-4\\/6 {
    padding-left: 66.666667%;
    padding-right: 66.666667%;
  }
  .lg\\:py-5\\/6 {
    padding-top: 83.333333%;
    padding-bottom: 83.333333%;
  }
  .lg\\:px-5\\/6 {
    padding-left: 83.333333%;
    padding-right: 83.333333%;
  }
  .lg\\:py-1\\/12 {
    padding-top: 8.333333%;
    padding-bottom: 8.333333%;
  }
  .lg\\:px-1\\/12 {
    padding-left: 8.333333%;
    padding-right: 8.333333%;
  }
  .lg\\:py-2\\/12 {
    padding-top: 16.666667%;
    padding-bottom: 16.666667%;
  }
  .lg\\:px-2\\/12 {
    padding-left: 16.666667%;
    padding-right: 16.666667%;
  }
  .lg\\:py-3\\/12 {
    padding-top: 25%;
    padding-bottom: 25%;
  }
  .lg\\:px-3\\/12 {
    padding-left: 25%;
    padding-right: 25%;
  }
  .lg\\:py-4\\/12 {
    padding-top: 33.333333%;
    padding-bottom: 33.333333%;
  }
  .lg\\:px-4\\/12 {
    padding-left: 33.333333%;
    padding-right: 33.333333%;
  }
  .lg\\:py-5\\/12 {
    padding-top: 41.666667%;
    padding-bottom: 41.666667%;
  }
  .lg\\:px-5\\/12 {
    padding-left: 41.666667%;
    padding-right: 41.666667%;
  }
  .lg\\:py-6\\/12 {
    padding-top: 50%;
    padding-bottom: 50%;
  }
  .lg\\:px-6\\/12 {
    padding-left: 50%;
    padding-right: 50%;
  }
  .lg\\:py-7\\/12 {
    padding-top: 58.333333%;
    padding-bottom: 58.333333%;
  }
  .lg\\:px-7\\/12 {
    padding-left: 58.333333%;
    padding-right: 58.333333%;
  }
  .lg\\:py-8\\/12 {
    padding-top: 66.666667%;
    padding-bottom: 66.666667%;
  }
  .lg\\:px-8\\/12 {
    padding-left: 66.666667%;
    padding-right: 66.666667%;
  }
  .lg\\:py-9\\/12 {
    padding-top: 75%;
    padding-bottom: 75%;
  }
  .lg\\:px-9\\/12 {
    padding-left: 75%;
    padding-right: 75%;
  }
  .lg\\:py-10\\/12 {
    padding-top: 83.333333%;
    padding-bottom: 83.333333%;
  }
  .lg\\:px-10\\/12 {
    padding-left: 83.333333%;
    padding-right: 83.333333%;
  }
  .lg\\:py-11\\/12 {
    padding-top: 91.666667%;
    padding-bottom: 91.666667%;
  }
  .lg\\:px-11\\/12 {
    padding-left: 91.666667%;
    padding-right: 91.666667%;
  }
  .lg\\:py-full {
    padding-top: 100%;
    padding-bottom: 100%;
  }
  .lg\\:px-full {
    padding-left: 100%;
    padding-right: 100%;
  }
  .lg\\:pt-0 {
    padding-top: 0;
  }
  .lg\\:pr-0 {
    padding-right: 0;
  }
  .lg\\:pb-0 {
    padding-bottom: 0;
  }
  .lg\\:pl-0 {
    padding-left: 0;
  }
  .lg\\:pt-1 {
    padding-top: 0.25rem;
  }
  .lg\\:pr-1 {
    padding-right: 0.25rem;
  }
  .lg\\:pb-1 {
    padding-bottom: 0.25rem;
  }
  .lg\\:pl-1 {
    padding-left: 0.25rem;
  }
  .lg\\:pt-2 {
    padding-top: 0.5rem;
  }
  .lg\\:pr-2 {
    padding-right: 0.5rem;
  }
  .lg\\:pb-2 {
    padding-bottom: 0.5rem;
  }
  .lg\\:pl-2 {
    padding-left: 0.5rem;
  }
  .lg\\:pt-3 {
    padding-top: 0.75rem;
  }
  .lg\\:pr-3 {
    padding-right: 0.75rem;
  }
  .lg\\:pb-3 {
    padding-bottom: 0.75rem;
  }
  .lg\\:pl-3 {
    padding-left: 0.75rem;
  }
  .lg\\:pt-4 {
    padding-top: 1rem;
  }
  .lg\\:pr-4 {
    padding-right: 1rem;
  }
  .lg\\:pb-4 {
    padding-bottom: 1rem;
  }
  .lg\\:pl-4 {
    padding-left: 1rem;
  }
  .lg\\:pt-5 {
    padding-top: 1.25rem;
  }
  .lg\\:pr-5 {
    padding-right: 1.25rem;
  }
  .lg\\:pb-5 {
    padding-bottom: 1.25rem;
  }
  .lg\\:pl-5 {
    padding-left: 1.25rem;
  }
  .lg\\:pt-6 {
    padding-top: 1.5rem;
  }
  .lg\\:pr-6 {
    padding-right: 1.5rem;
  }
  .lg\\:pb-6 {
    padding-bottom: 1.5rem;
  }
  .lg\\:pl-6 {
    padding-left: 1.5rem;
  }
  .lg\\:pt-7 {
    padding-top: 1.75rem;
  }
  .lg\\:pr-7 {
    padding-right: 1.75rem;
  }
  .lg\\:pb-7 {
    padding-bottom: 1.75rem;
  }
  .lg\\:pl-7 {
    padding-left: 1.75rem;
  }
  .lg\\:pt-8 {
    padding-top: 2rem;
  }
  .lg\\:pr-8 {
    padding-right: 2rem;
  }
  .lg\\:pb-8 {
    padding-bottom: 2rem;
  }
  .lg\\:pl-8 {
    padding-left: 2rem;
  }
  .lg\\:pt-9 {
    padding-top: 2.25rem;
  }
  .lg\\:pr-9 {
    padding-right: 2.25rem;
  }
  .lg\\:pb-9 {
    padding-bottom: 2.25rem;
  }
  .lg\\:pl-9 {
    padding-left: 2.25rem;
  }
  .lg\\:pt-10 {
    padding-top: 2.5rem;
  }
  .lg\\:pr-10 {
    padding-right: 2.5rem;
  }
  .lg\\:pb-10 {
    padding-bottom: 2.5rem;
  }
  .lg\\:pl-10 {
    padding-left: 2.5rem;
  }
  .lg\\:pt-11 {
    padding-top: 2.75rem;
  }
  .lg\\:pr-11 {
    padding-right: 2.75rem;
  }
  .lg\\:pb-11 {
    padding-bottom: 2.75rem;
  }
  .lg\\:pl-11 {
    padding-left: 2.75rem;
  }
  .lg\\:pt-12 {
    padding-top: 3rem;
  }
  .lg\\:pr-12 {
    padding-right: 3rem;
  }
  .lg\\:pb-12 {
    padding-bottom: 3rem;
  }
  .lg\\:pl-12 {
    padding-left: 3rem;
  }
  .lg\\:pt-13 {
    padding-top: 3.25rem;
  }
  .lg\\:pr-13 {
    padding-right: 3.25rem;
  }
  .lg\\:pb-13 {
    padding-bottom: 3.25rem;
  }
  .lg\\:pl-13 {
    padding-left: 3.25rem;
  }
  .lg\\:pt-14 {
    padding-top: 3.5rem;
  }
  .lg\\:pr-14 {
    padding-right: 3.5rem;
  }
  .lg\\:pb-14 {
    padding-bottom: 3.5rem;
  }
  .lg\\:pl-14 {
    padding-left: 3.5rem;
  }
  .lg\\:pt-15 {
    padding-top: 3.75rem;
  }
  .lg\\:pr-15 {
    padding-right: 3.75rem;
  }
  .lg\\:pb-15 {
    padding-bottom: 3.75rem;
  }
  .lg\\:pl-15 {
    padding-left: 3.75rem;
  }
  .lg\\:pt-16 {
    padding-top: 4rem;
  }
  .lg\\:pr-16 {
    padding-right: 4rem;
  }
  .lg\\:pb-16 {
    padding-bottom: 4rem;
  }
  .lg\\:pl-16 {
    padding-left: 4rem;
  }
  .lg\\:pt-20 {
    padding-top: 5rem;
  }
  .lg\\:pr-20 {
    padding-right: 5rem;
  }
  .lg\\:pb-20 {
    padding-bottom: 5rem;
  }
  .lg\\:pl-20 {
    padding-left: 5rem;
  }
  .lg\\:pt-24 {
    padding-top: 6rem;
  }
  .lg\\:pr-24 {
    padding-right: 6rem;
  }
  .lg\\:pb-24 {
    padding-bottom: 6rem;
  }
  .lg\\:pl-24 {
    padding-left: 6rem;
  }
  .lg\\:pt-28 {
    padding-top: 7rem;
  }
  .lg\\:pr-28 {
    padding-right: 7rem;
  }
  .lg\\:pb-28 {
    padding-bottom: 7rem;
  }
  .lg\\:pl-28 {
    padding-left: 7rem;
  }
  .lg\\:pt-32 {
    padding-top: 8rem;
  }
  .lg\\:pr-32 {
    padding-right: 8rem;
  }
  .lg\\:pb-32 {
    padding-bottom: 8rem;
  }
  .lg\\:pl-32 {
    padding-left: 8rem;
  }
  .lg\\:pt-36 {
    padding-top: 9rem;
  }
  .lg\\:pr-36 {
    padding-right: 9rem;
  }
  .lg\\:pb-36 {
    padding-bottom: 9rem;
  }
  .lg\\:pl-36 {
    padding-left: 9rem;
  }
  .lg\\:pt-40 {
    padding-top: 10rem;
  }
  .lg\\:pr-40 {
    padding-right: 10rem;
  }
  .lg\\:pb-40 {
    padding-bottom: 10rem;
  }
  .lg\\:pl-40 {
    padding-left: 10rem;
  }
  .lg\\:pt-44 {
    padding-top: 11rem;
  }
  .lg\\:pr-44 {
    padding-right: 11rem;
  }
  .lg\\:pb-44 {
    padding-bottom: 11rem;
  }
  .lg\\:pl-44 {
    padding-left: 11rem;
  }
  .lg\\:pt-48 {
    padding-top: 12rem;
  }
  .lg\\:pr-48 {
    padding-right: 12rem;
  }
  .lg\\:pb-48 {
    padding-bottom: 12rem;
  }
  .lg\\:pl-48 {
    padding-left: 12rem;
  }
  .lg\\:pt-52 {
    padding-top: 13rem;
  }
  .lg\\:pr-52 {
    padding-right: 13rem;
  }
  .lg\\:pb-52 {
    padding-bottom: 13rem;
  }
  .lg\\:pl-52 {
    padding-left: 13rem;
  }
  .lg\\:pt-56 {
    padding-top: 14rem;
  }
  .lg\\:pr-56 {
    padding-right: 14rem;
  }
  .lg\\:pb-56 {
    padding-bottom: 14rem;
  }
  .lg\\:pl-56 {
    padding-left: 14rem;
  }
  .lg\\:pt-60 {
    padding-top: 15rem;
  }
  .lg\\:pr-60 {
    padding-right: 15rem;
  }
  .lg\\:pb-60 {
    padding-bottom: 15rem;
  }
  .lg\\:pl-60 {
    padding-left: 15rem;
  }
  .lg\\:pt-64 {
    padding-top: 16rem;
  }
  .lg\\:pr-64 {
    padding-right: 16rem;
  }
  .lg\\:pb-64 {
    padding-bottom: 16rem;
  }
  .lg\\:pl-64 {
    padding-left: 16rem;
  }
  .lg\\:pt-72 {
    padding-top: 18rem;
  }
  .lg\\:pr-72 {
    padding-right: 18rem;
  }
  .lg\\:pb-72 {
    padding-bottom: 18rem;
  }
  .lg\\:pl-72 {
    padding-left: 18rem;
  }
  .lg\\:pt-80 {
    padding-top: 20rem;
  }
  .lg\\:pr-80 {
    padding-right: 20rem;
  }
  .lg\\:pb-80 {
    padding-bottom: 20rem;
  }
  .lg\\:pl-80 {
    padding-left: 20rem;
  }
  .lg\\:pt-96 {
    padding-top: 24rem;
  }
  .lg\\:pr-96 {
    padding-right: 24rem;
  }
  .lg\\:pb-96 {
    padding-bottom: 24rem;
  }
  .lg\\:pl-96 {
    padding-left: 24rem;
  }
  .lg\\:pt-px {
    padding-top: 1px;
  }
  .lg\\:pr-px {
    padding-right: 1px;
  }
  .lg\\:pb-px {
    padding-bottom: 1px;
  }
  .lg\\:pl-px {
    padding-left: 1px;
  }
  .lg\\:pt-0\\.5 {
    padding-top: 0.125rem;
  }
  .lg\\:pr-0\\.5 {
    padding-right: 0.125rem;
  }
  .lg\\:pb-0\\.5 {
    padding-bottom: 0.125rem;
  }
  .lg\\:pl-0\\.5 {
    padding-left: 0.125rem;
  }
  .lg\\:pt-1\\.5 {
    padding-top: 0.375rem;
  }
  .lg\\:pr-1\\.5 {
    padding-right: 0.375rem;
  }
  .lg\\:pb-1\\.5 {
    padding-bottom: 0.375rem;
  }
  .lg\\:pl-1\\.5 {
    padding-left: 0.375rem;
  }
  .lg\\:pt-2\\.5 {
    padding-top: 0.625rem;
  }
  .lg\\:pr-2\\.5 {
    padding-right: 0.625rem;
  }
  .lg\\:pb-2\\.5 {
    padding-bottom: 0.625rem;
  }
  .lg\\:pl-2\\.5 {
    padding-left: 0.625rem;
  }
  .lg\\:pt-3\\.5 {
    padding-top: 0.875rem;
  }
  .lg\\:pr-3\\.5 {
    padding-right: 0.875rem;
  }
  .lg\\:pb-3\\.5 {
    padding-bottom: 0.875rem;
  }
  .lg\\:pl-3\\.5 {
    padding-left: 0.875rem;
  }
  .lg\\:pt-1\\/2 {
    padding-top: 50%;
  }
  .lg\\:pr-1\\/2 {
    padding-right: 50%;
  }
  .lg\\:pb-1\\/2 {
    padding-bottom: 50%;
  }
  .lg\\:pl-1\\/2 {
    padding-left: 50%;
  }
  .lg\\:pt-1\\/3 {
    padding-top: 33.333333%;
  }
  .lg\\:pr-1\\/3 {
    padding-right: 33.333333%;
  }
  .lg\\:pb-1\\/3 {
    padding-bottom: 33.333333%;
  }
  .lg\\:pl-1\\/3 {
    padding-left: 33.333333%;
  }
  .lg\\:pt-2\\/3 {
    padding-top: 66.666667%;
  }
  .lg\\:pr-2\\/3 {
    padding-right: 66.666667%;
  }
  .lg\\:pb-2\\/3 {
    padding-bottom: 66.666667%;
  }
  .lg\\:pl-2\\/3 {
    padding-left: 66.666667%;
  }
  .lg\\:pt-1\\/4 {
    padding-top: 25%;
  }
  .lg\\:pr-1\\/4 {
    padding-right: 25%;
  }
  .lg\\:pb-1\\/4 {
    padding-bottom: 25%;
  }
  .lg\\:pl-1\\/4 {
    padding-left: 25%;
  }
  .lg\\:pt-2\\/4 {
    padding-top: 50%;
  }
  .lg\\:pr-2\\/4 {
    padding-right: 50%;
  }
  .lg\\:pb-2\\/4 {
    padding-bottom: 50%;
  }
  .lg\\:pl-2\\/4 {
    padding-left: 50%;
  }
  .lg\\:pt-3\\/4 {
    padding-top: 75%;
  }
  .lg\\:pr-3\\/4 {
    padding-right: 75%;
  }
  .lg\\:pb-3\\/4 {
    padding-bottom: 75%;
  }
  .lg\\:pl-3\\/4 {
    padding-left: 75%;
  }
  .lg\\:pt-1\\/5 {
    padding-top: 20%;
  }
  .lg\\:pr-1\\/5 {
    padding-right: 20%;
  }
  .lg\\:pb-1\\/5 {
    padding-bottom: 20%;
  }
  .lg\\:pl-1\\/5 {
    padding-left: 20%;
  }
  .lg\\:pt-2\\/5 {
    padding-top: 40%;
  }
  .lg\\:pr-2\\/5 {
    padding-right: 40%;
  }
  .lg\\:pb-2\\/5 {
    padding-bottom: 40%;
  }
  .lg\\:pl-2\\/5 {
    padding-left: 40%;
  }
  .lg\\:pt-3\\/5 {
    padding-top: 60%;
  }
  .lg\\:pr-3\\/5 {
    padding-right: 60%;
  }
  .lg\\:pb-3\\/5 {
    padding-bottom: 60%;
  }
  .lg\\:pl-3\\/5 {
    padding-left: 60%;
  }
  .lg\\:pt-4\\/5 {
    padding-top: 80%;
  }
  .lg\\:pr-4\\/5 {
    padding-right: 80%;
  }
  .lg\\:pb-4\\/5 {
    padding-bottom: 80%;
  }
  .lg\\:pl-4\\/5 {
    padding-left: 80%;
  }
  .lg\\:pt-1\\/6 {
    padding-top: 16.666667%;
  }
  .lg\\:pr-1\\/6 {
    padding-right: 16.666667%;
  }
  .lg\\:pb-1\\/6 {
    padding-bottom: 16.666667%;
  }
  .lg\\:pl-1\\/6 {
    padding-left: 16.666667%;
  }
  .lg\\:pt-2\\/6 {
    padding-top: 33.333333%;
  }
  .lg\\:pr-2\\/6 {
    padding-right: 33.333333%;
  }
  .lg\\:pb-2\\/6 {
    padding-bottom: 33.333333%;
  }
  .lg\\:pl-2\\/6 {
    padding-left: 33.333333%;
  }
  .lg\\:pt-3\\/6 {
    padding-top: 50%;
  }
  .lg\\:pr-3\\/6 {
    padding-right: 50%;
  }
  .lg\\:pb-3\\/6 {
    padding-bottom: 50%;
  }
  .lg\\:pl-3\\/6 {
    padding-left: 50%;
  }
  .lg\\:pt-4\\/6 {
    padding-top: 66.666667%;
  }
  .lg\\:pr-4\\/6 {
    padding-right: 66.666667%;
  }
  .lg\\:pb-4\\/6 {
    padding-bottom: 66.666667%;
  }
  .lg\\:pl-4\\/6 {
    padding-left: 66.666667%;
  }
  .lg\\:pt-5\\/6 {
    padding-top: 83.333333%;
  }
  .lg\\:pr-5\\/6 {
    padding-right: 83.333333%;
  }
  .lg\\:pb-5\\/6 {
    padding-bottom: 83.333333%;
  }
  .lg\\:pl-5\\/6 {
    padding-left: 83.333333%;
  }
  .lg\\:pt-1\\/12 {
    padding-top: 8.333333%;
  }
  .lg\\:pr-1\\/12 {
    padding-right: 8.333333%;
  }
  .lg\\:pb-1\\/12 {
    padding-bottom: 8.333333%;
  }
  .lg\\:pl-1\\/12 {
    padding-left: 8.333333%;
  }
  .lg\\:pt-2\\/12 {
    padding-top: 16.666667%;
  }
  .lg\\:pr-2\\/12 {
    padding-right: 16.666667%;
  }
  .lg\\:pb-2\\/12 {
    padding-bottom: 16.666667%;
  }
  .lg\\:pl-2\\/12 {
    padding-left: 16.666667%;
  }
  .lg\\:pt-3\\/12 {
    padding-top: 25%;
  }
  .lg\\:pr-3\\/12 {
    padding-right: 25%;
  }
  .lg\\:pb-3\\/12 {
    padding-bottom: 25%;
  }
  .lg\\:pl-3\\/12 {
    padding-left: 25%;
  }
  .lg\\:pt-4\\/12 {
    padding-top: 33.333333%;
  }
  .lg\\:pr-4\\/12 {
    padding-right: 33.333333%;
  }
  .lg\\:pb-4\\/12 {
    padding-bottom: 33.333333%;
  }
  .lg\\:pl-4\\/12 {
    padding-left: 33.333333%;
  }
  .lg\\:pt-5\\/12 {
    padding-top: 41.666667%;
  }
  .lg\\:pr-5\\/12 {
    padding-right: 41.666667%;
  }
  .lg\\:pb-5\\/12 {
    padding-bottom: 41.666667%;
  }
  .lg\\:pl-5\\/12 {
    padding-left: 41.666667%;
  }
  .lg\\:pt-6\\/12 {
    padding-top: 50%;
  }
  .lg\\:pr-6\\/12 {
    padding-right: 50%;
  }
  .lg\\:pb-6\\/12 {
    padding-bottom: 50%;
  }
  .lg\\:pl-6\\/12 {
    padding-left: 50%;
  }
  .lg\\:pt-7\\/12 {
    padding-top: 58.333333%;
  }
  .lg\\:pr-7\\/12 {
    padding-right: 58.333333%;
  }
  .lg\\:pb-7\\/12 {
    padding-bottom: 58.333333%;
  }
  .lg\\:pl-7\\/12 {
    padding-left: 58.333333%;
  }
  .lg\\:pt-8\\/12 {
    padding-top: 66.666667%;
  }
  .lg\\:pr-8\\/12 {
    padding-right: 66.666667%;
  }
  .lg\\:pb-8\\/12 {
    padding-bottom: 66.666667%;
  }
  .lg\\:pl-8\\/12 {
    padding-left: 66.666667%;
  }
  .lg\\:pt-9\\/12 {
    padding-top: 75%;
  }
  .lg\\:pr-9\\/12 {
    padding-right: 75%;
  }
  .lg\\:pb-9\\/12 {
    padding-bottom: 75%;
  }
  .lg\\:pl-9\\/12 {
    padding-left: 75%;
  }
  .lg\\:pt-10\\/12 {
    padding-top: 83.333333%;
  }
  .lg\\:pr-10\\/12 {
    padding-right: 83.333333%;
  }
  .lg\\:pb-10\\/12 {
    padding-bottom: 83.333333%;
  }
  .lg\\:pl-10\\/12 {
    padding-left: 83.333333%;
  }
  .lg\\:pt-11\\/12 {
    padding-top: 91.666667%;
  }
  .lg\\:pr-11\\/12 {
    padding-right: 91.666667%;
  }
  .lg\\:pb-11\\/12 {
    padding-bottom: 91.666667%;
  }
  .lg\\:pl-11\\/12 {
    padding-left: 91.666667%;
  }
  .lg\\:pt-full {
    padding-top: 100%;
  }
  .lg\\:pr-full {
    padding-right: 100%;
  }
  .lg\\:pb-full {
    padding-bottom: 100%;
  }
  .lg\\:pl-full {
    padding-left: 100%;
  }
  .lg\\:placeholder-current::placeholder {
    color: currentColor;
  }
  .lg\\:placeholder-transparent::placeholder {
    color: transparent;
  }
  .lg\\:placeholder-white::placeholder {
    --placeholder-opacity: 1;
    color: #ffffff;
    color: rgba(255, 255, 255, var(--placeholder-opacity));
  }
  .lg\\:placeholder-black::placeholder {
    --placeholder-opacity: 1;
    color: #000000;
    color: rgba(0, 0, 0, var(--placeholder-opacity));
  }
  .lg\\:placeholder-gray-50::placeholder {
    --placeholder-opacity: 1;
    color: #f9fafb;
    color: rgba(249, 250, 251, var(--placeholder-opacity));
  }
  .lg\\:placeholder-gray-100::placeholder {
    --placeholder-opacity: 1;
    color: #f4f5f7;
    color: rgba(244, 245, 247, var(--placeholder-opacity));
  }
  .lg\\:placeholder-gray-200::placeholder {
    --placeholder-opacity: 1;
    color: #e5e7eb;
    color: rgba(229, 231, 235, var(--placeholder-opacity));
  }
  .lg\\:placeholder-gray-300::placeholder {
    --placeholder-opacity: 1;
    color: #d2d6dc;
    color: rgba(210, 214, 220, var(--placeholder-opacity));
  }
  .lg\\:placeholder-gray-400::placeholder {
    --placeholder-opacity: 1;
    color: #9fa6b2;
    color: rgba(159, 166, 178, var(--placeholder-opacity));
  }
  .lg\\:placeholder-gray-500::placeholder {
    --placeholder-opacity: 1;
    color: #6b7280;
    color: rgba(107, 114, 128, var(--placeholder-opacity));
  }
  .lg\\:placeholder-gray-600::placeholder {
    --placeholder-opacity: 1;
    color: #4b5563;
    color: rgba(75, 85, 99, var(--placeholder-opacity));
  }
  .lg\\:placeholder-gray-700::placeholder {
    --placeholder-opacity: 1;
    color: #374151;
    color: rgba(55, 65, 81, var(--placeholder-opacity));
  }
  .lg\\:placeholder-gray-800::placeholder {
    --placeholder-opacity: 1;
    color: #252f3f;
    color: rgba(37, 47, 63, var(--placeholder-opacity));
  }
  .lg\\:placeholder-gray-900::placeholder {
    --placeholder-opacity: 1;
    color: #161e2e;
    color: rgba(22, 30, 46, var(--placeholder-opacity));
  }
  .lg\\:placeholder-red-50::placeholder {
    --placeholder-opacity: 1;
    color: #fdf2f2;
    color: rgba(253, 242, 242, var(--placeholder-opacity));
  }
  .lg\\:placeholder-red-100::placeholder {
    --placeholder-opacity: 1;
    color: #fde8e8;
    color: rgba(253, 232, 232, var(--placeholder-opacity));
  }
  .lg\\:placeholder-red-200::placeholder {
    --placeholder-opacity: 1;
    color: #fbd5d5;
    color: rgba(251, 213, 213, var(--placeholder-opacity));
  }
  .lg\\:placeholder-red-300::placeholder {
    --placeholder-opacity: 1;
    color: #f8b4b4;
    color: rgba(248, 180, 180, var(--placeholder-opacity));
  }
  .lg\\:placeholder-red-400::placeholder {
    --placeholder-opacity: 1;
    color: #f98080;
    color: rgba(249, 128, 128, var(--placeholder-opacity));
  }
  .lg\\:placeholder-red-500::placeholder {
    --placeholder-opacity: 1;
    color: #f05252;
    color: rgba(240, 82, 82, var(--placeholder-opacity));
  }
  .lg\\:placeholder-red-600::placeholder {
    --placeholder-opacity: 1;
    color: #e02424;
    color: rgba(224, 36, 36, var(--placeholder-opacity));
  }
  .lg\\:placeholder-red-700::placeholder {
    --placeholder-opacity: 1;
    color: #c81e1e;
    color: rgba(200, 30, 30, var(--placeholder-opacity));
  }
  .lg\\:placeholder-red-800::placeholder {
    --placeholder-opacity: 1;
    color: #9b1c1c;
    color: rgba(155, 28, 28, var(--placeholder-opacity));
  }
  .lg\\:placeholder-red-900::placeholder {
    --placeholder-opacity: 1;
    color: #771d1d;
    color: rgba(119, 29, 29, var(--placeholder-opacity));
  }
  .lg\\:placeholder-orange-50::placeholder {
    --placeholder-opacity: 1;
    color: #fff8f1;
    color: rgba(255, 248, 241, var(--placeholder-opacity));
  }
  .lg\\:placeholder-orange-100::placeholder {
    --placeholder-opacity: 1;
    color: #feecdc;
    color: rgba(254, 236, 220, var(--placeholder-opacity));
  }
  .lg\\:placeholder-orange-200::placeholder {
    --placeholder-opacity: 1;
    color: #fcd9bd;
    color: rgba(252, 217, 189, var(--placeholder-opacity));
  }
  .lg\\:placeholder-orange-300::placeholder {
    --placeholder-opacity: 1;
    color: #fdba8c;
    color: rgba(253, 186, 140, var(--placeholder-opacity));
  }
  .lg\\:placeholder-orange-400::placeholder {
    --placeholder-opacity: 1;
    color: #ff8a4c;
    color: rgba(255, 138, 76, var(--placeholder-opacity));
  }
  .lg\\:placeholder-orange-500::placeholder {
    --placeholder-opacity: 1;
    color: #ff5a1f;
    color: rgba(255, 90, 31, var(--placeholder-opacity));
  }
  .lg\\:placeholder-orange-600::placeholder {
    --placeholder-opacity: 1;
    color: #d03801;
    color: rgba(208, 56, 1, var(--placeholder-opacity));
  }
  .lg\\:placeholder-orange-700::placeholder {
    --placeholder-opacity: 1;
    color: #b43403;
    color: rgba(180, 52, 3, var(--placeholder-opacity));
  }
  .lg\\:placeholder-orange-800::placeholder {
    --placeholder-opacity: 1;
    color: #8a2c0d;
    color: rgba(138, 44, 13, var(--placeholder-opacity));
  }
  .lg\\:placeholder-orange-900::placeholder {
    --placeholder-opacity: 1;
    color: #73230d;
    color: rgba(115, 35, 13, var(--placeholder-opacity));
  }
  .lg\\:placeholder-yellow-50::placeholder {
    --placeholder-opacity: 1;
    color: #fdfdea;
    color: rgba(253, 253, 234, var(--placeholder-opacity));
  }
  .lg\\:placeholder-yellow-100::placeholder {
    --placeholder-opacity: 1;
    color: #fdf6b2;
    color: rgba(253, 246, 178, var(--placeholder-opacity));
  }
  .lg\\:placeholder-yellow-200::placeholder {
    --placeholder-opacity: 1;
    color: #fce96a;
    color: rgba(252, 233, 106, var(--placeholder-opacity));
  }
  .lg\\:placeholder-yellow-300::placeholder {
    --placeholder-opacity: 1;
    color: #faca15;
    color: rgba(250, 202, 21, var(--placeholder-opacity));
  }
  .lg\\:placeholder-yellow-400::placeholder {
    --placeholder-opacity: 1;
    color: #e3a008;
    color: rgba(227, 160, 8, var(--placeholder-opacity));
  }
  .lg\\:placeholder-yellow-500::placeholder {
    --placeholder-opacity: 1;
    color: #c27803;
    color: rgba(194, 120, 3, var(--placeholder-opacity));
  }
  .lg\\:placeholder-yellow-600::placeholder {
    --placeholder-opacity: 1;
    color: #9f580a;
    color: rgba(159, 88, 10, var(--placeholder-opacity));
  }
  .lg\\:placeholder-yellow-700::placeholder {
    --placeholder-opacity: 1;
    color: #8e4b10;
    color: rgba(142, 75, 16, var(--placeholder-opacity));
  }
  .lg\\:placeholder-yellow-800::placeholder {
    --placeholder-opacity: 1;
    color: #723b13;
    color: rgba(114, 59, 19, var(--placeholder-opacity));
  }
  .lg\\:placeholder-yellow-900::placeholder {
    --placeholder-opacity: 1;
    color: #633112;
    color: rgba(99, 49, 18, var(--placeholder-opacity));
  }
  .lg\\:placeholder-green-50::placeholder {
    --placeholder-opacity: 1;
    color: #f3faf7;
    color: rgba(243, 250, 247, var(--placeholder-opacity));
  }
  .lg\\:placeholder-green-100::placeholder {
    --placeholder-opacity: 1;
    color: #def7ec;
    color: rgba(222, 247, 236, var(--placeholder-opacity));
  }
  .lg\\:placeholder-green-200::placeholder {
    --placeholder-opacity: 1;
    color: #bcf0da;
    color: rgba(188, 240, 218, var(--placeholder-opacity));
  }
  .lg\\:placeholder-green-300::placeholder {
    --placeholder-opacity: 1;
    color: #84e1bc;
    color: rgba(132, 225, 188, var(--placeholder-opacity));
  }
  .lg\\:placeholder-green-400::placeholder {
    --placeholder-opacity: 1;
    color: #31c48d;
    color: rgba(49, 196, 141, var(--placeholder-opacity));
  }
  .lg\\:placeholder-green-500::placeholder {
    --placeholder-opacity: 1;
    color: #0e9f6e;
    color: rgba(14, 159, 110, var(--placeholder-opacity));
  }
  .lg\\:placeholder-green-600::placeholder {
    --placeholder-opacity: 1;
    color: #057a55;
    color: rgba(5, 122, 85, var(--placeholder-opacity));
  }
  .lg\\:placeholder-green-700::placeholder {
    --placeholder-opacity: 1;
    color: #046c4e;
    color: rgba(4, 108, 78, var(--placeholder-opacity));
  }
  .lg\\:placeholder-green-800::placeholder {
    --placeholder-opacity: 1;
    color: #03543f;
    color: rgba(3, 84, 63, var(--placeholder-opacity));
  }
  .lg\\:placeholder-green-900::placeholder {
    --placeholder-opacity: 1;
    color: #014737;
    color: rgba(1, 71, 55, var(--placeholder-opacity));
  }
  .lg\\:placeholder-teal-50::placeholder {
    --placeholder-opacity: 1;
    color: #edfafa;
    color: rgba(237, 250, 250, var(--placeholder-opacity));
  }
  .lg\\:placeholder-teal-100::placeholder {
    --placeholder-opacity: 1;
    color: #d5f5f6;
    color: rgba(213, 245, 246, var(--placeholder-opacity));
  }
  .lg\\:placeholder-teal-200::placeholder {
    --placeholder-opacity: 1;
    color: #afecef;
    color: rgba(175, 236, 239, var(--placeholder-opacity));
  }
  .lg\\:placeholder-teal-300::placeholder {
    --placeholder-opacity: 1;
    color: #7edce2;
    color: rgba(126, 220, 226, var(--placeholder-opacity));
  }
  .lg\\:placeholder-teal-400::placeholder {
    --placeholder-opacity: 1;
    color: #16bdca;
    color: rgba(22, 189, 202, var(--placeholder-opacity));
  }
  .lg\\:placeholder-teal-500::placeholder {
    --placeholder-opacity: 1;
    color: #0694a2;
    color: rgba(6, 148, 162, var(--placeholder-opacity));
  }
  .lg\\:placeholder-teal-600::placeholder {
    --placeholder-opacity: 1;
    color: #047481;
    color: rgba(4, 116, 129, var(--placeholder-opacity));
  }
  .lg\\:placeholder-teal-700::placeholder {
    --placeholder-opacity: 1;
    color: #036672;
    color: rgba(3, 102, 114, var(--placeholder-opacity));
  }
  .lg\\:placeholder-teal-800::placeholder {
    --placeholder-opacity: 1;
    color: #05505c;
    color: rgba(5, 80, 92, var(--placeholder-opacity));
  }
  .lg\\:placeholder-teal-900::placeholder {
    --placeholder-opacity: 1;
    color: #014451;
    color: rgba(1, 68, 81, var(--placeholder-opacity));
  }
  .lg\\:placeholder-blue-50::placeholder {
    --placeholder-opacity: 1;
    color: #ebf5ff;
    color: rgba(235, 245, 255, var(--placeholder-opacity));
  }
  .lg\\:placeholder-blue-100::placeholder {
    --placeholder-opacity: 1;
    color: #e1effe;
    color: rgba(225, 239, 254, var(--placeholder-opacity));
  }
  .lg\\:placeholder-blue-200::placeholder {
    --placeholder-opacity: 1;
    color: #c3ddfd;
    color: rgba(195, 221, 253, var(--placeholder-opacity));
  }
  .lg\\:placeholder-blue-300::placeholder {
    --placeholder-opacity: 1;
    color: #a4cafe;
    color: rgba(164, 202, 254, var(--placeholder-opacity));
  }
  .lg\\:placeholder-blue-400::placeholder {
    --placeholder-opacity: 1;
    color: #76a9fa;
    color: rgba(118, 169, 250, var(--placeholder-opacity));
  }
  .lg\\:placeholder-blue-500::placeholder {
    --placeholder-opacity: 1;
    color: #3f83f8;
    color: rgba(63, 131, 248, var(--placeholder-opacity));
  }
  .lg\\:placeholder-blue-600::placeholder {
    --placeholder-opacity: 1;
    color: #1c64f2;
    color: rgba(28, 100, 242, var(--placeholder-opacity));
  }
  .lg\\:placeholder-blue-700::placeholder {
    --placeholder-opacity: 1;
    color: #1a56db;
    color: rgba(26, 86, 219, var(--placeholder-opacity));
  }
  .lg\\:placeholder-blue-800::placeholder {
    --placeholder-opacity: 1;
    color: #1e429f;
    color: rgba(30, 66, 159, var(--placeholder-opacity));
  }
  .lg\\:placeholder-blue-900::placeholder {
    --placeholder-opacity: 1;
    color: #233876;
    color: rgba(35, 56, 118, var(--placeholder-opacity));
  }
  .lg\\:placeholder-indigo-50::placeholder {
    --placeholder-opacity: 1;
    color: #f0f5ff;
    color: rgba(240, 245, 255, var(--placeholder-opacity));
  }
  .lg\\:placeholder-indigo-100::placeholder {
    --placeholder-opacity: 1;
    color: #e5edff;
    color: rgba(229, 237, 255, var(--placeholder-opacity));
  }
  .lg\\:placeholder-indigo-200::placeholder {
    --placeholder-opacity: 1;
    color: #cddbfe;
    color: rgba(205, 219, 254, var(--placeholder-opacity));
  }
  .lg\\:placeholder-indigo-300::placeholder {
    --placeholder-opacity: 1;
    color: #b4c6fc;
    color: rgba(180, 198, 252, var(--placeholder-opacity));
  }
  .lg\\:placeholder-indigo-400::placeholder {
    --placeholder-opacity: 1;
    color: #8da2fb;
    color: rgba(141, 162, 251, var(--placeholder-opacity));
  }
  .lg\\:placeholder-indigo-500::placeholder {
    --placeholder-opacity: 1;
    color: #6875f5;
    color: rgba(104, 117, 245, var(--placeholder-opacity));
  }
  .lg\\:placeholder-indigo-600::placeholder {
    --placeholder-opacity: 1;
    color: #5850ec;
    color: rgba(88, 80, 236, var(--placeholder-opacity));
  }
  .lg\\:placeholder-indigo-700::placeholder {
    --placeholder-opacity: 1;
    color: #5145cd;
    color: rgba(81, 69, 205, var(--placeholder-opacity));
  }
  .lg\\:placeholder-indigo-800::placeholder {
    --placeholder-opacity: 1;
    color: #42389d;
    color: rgba(66, 56, 157, var(--placeholder-opacity));
  }
  .lg\\:placeholder-indigo-900::placeholder {
    --placeholder-opacity: 1;
    color: #362f78;
    color: rgba(54, 47, 120, var(--placeholder-opacity));
  }
  .lg\\:placeholder-purple-50::placeholder {
    --placeholder-opacity: 1;
    color: #f6f5ff;
    color: rgba(246, 245, 255, var(--placeholder-opacity));
  }
  .lg\\:placeholder-purple-100::placeholder {
    --placeholder-opacity: 1;
    color: #edebfe;
    color: rgba(237, 235, 254, var(--placeholder-opacity));
  }
  .lg\\:placeholder-purple-200::placeholder {
    --placeholder-opacity: 1;
    color: #dcd7fe;
    color: rgba(220, 215, 254, var(--placeholder-opacity));
  }
  .lg\\:placeholder-purple-300::placeholder {
    --placeholder-opacity: 1;
    color: #cabffd;
    color: rgba(202, 191, 253, var(--placeholder-opacity));
  }
  .lg\\:placeholder-purple-400::placeholder {
    --placeholder-opacity: 1;
    color: #ac94fa;
    color: rgba(172, 148, 250, var(--placeholder-opacity));
  }
  .lg\\:placeholder-purple-500::placeholder {
    --placeholder-opacity: 1;
    color: #9061f9;
    color: rgba(144, 97, 249, var(--placeholder-opacity));
  }
  .lg\\:placeholder-purple-600::placeholder {
    --placeholder-opacity: 1;
    color: #7e3af2;
    color: rgba(126, 58, 242, var(--placeholder-opacity));
  }
  .lg\\:placeholder-purple-700::placeholder {
    --placeholder-opacity: 1;
    color: #6c2bd9;
    color: rgba(108, 43, 217, var(--placeholder-opacity));
  }
  .lg\\:placeholder-purple-800::placeholder {
    --placeholder-opacity: 1;
    color: #5521b5;
    color: rgba(85, 33, 181, var(--placeholder-opacity));
  }
  .lg\\:placeholder-purple-900::placeholder {
    --placeholder-opacity: 1;
    color: #4a1d96;
    color: rgba(74, 29, 150, var(--placeholder-opacity));
  }
  .lg\\:placeholder-pink-50::placeholder {
    --placeholder-opacity: 1;
    color: #fdf2f8;
    color: rgba(253, 242, 248, var(--placeholder-opacity));
  }
  .lg\\:placeholder-pink-100::placeholder {
    --placeholder-opacity: 1;
    color: #fce8f3;
    color: rgba(252, 232, 243, var(--placeholder-opacity));
  }
  .lg\\:placeholder-pink-200::placeholder {
    --placeholder-opacity: 1;
    color: #fad1e8;
    color: rgba(250, 209, 232, var(--placeholder-opacity));
  }
  .lg\\:placeholder-pink-300::placeholder {
    --placeholder-opacity: 1;
    color: #f8b4d9;
    color: rgba(248, 180, 217, var(--placeholder-opacity));
  }
  .lg\\:placeholder-pink-400::placeholder {
    --placeholder-opacity: 1;
    color: #f17eb8;
    color: rgba(241, 126, 184, var(--placeholder-opacity));
  }
  .lg\\:placeholder-pink-500::placeholder {
    --placeholder-opacity: 1;
    color: #e74694;
    color: rgba(231, 70, 148, var(--placeholder-opacity));
  }
  .lg\\:placeholder-pink-600::placeholder {
    --placeholder-opacity: 1;
    color: #d61f69;
    color: rgba(214, 31, 105, var(--placeholder-opacity));
  }
  .lg\\:placeholder-pink-700::placeholder {
    --placeholder-opacity: 1;
    color: #bf125d;
    color: rgba(191, 18, 93, var(--placeholder-opacity));
  }
  .lg\\:placeholder-pink-800::placeholder {
    --placeholder-opacity: 1;
    color: #99154b;
    color: rgba(153, 21, 75, var(--placeholder-opacity));
  }
  .lg\\:placeholder-pink-900::placeholder {
    --placeholder-opacity: 1;
    color: #751a3d;
    color: rgba(117, 26, 61, var(--placeholder-opacity));
  }
  .lg\\:placeholder-cool-gray-50::placeholder {
    --placeholder-opacity: 1;
    color: #f8fafc;
    color: rgba(248, 250, 252, var(--placeholder-opacity));
  }
  .lg\\:placeholder-cool-gray-100::placeholder {
    --placeholder-opacity: 1;
    color: #f1f5f9;
    color: rgba(241, 245, 249, var(--placeholder-opacity));
  }
  .lg\\:placeholder-cool-gray-200::placeholder {
    --placeholder-opacity: 1;
    color: #e2e8f0;
    color: rgba(226, 232, 240, var(--placeholder-opacity));
  }
  .lg\\:placeholder-cool-gray-300::placeholder {
    --placeholder-opacity: 1;
    color: #cfd8e3;
    color: rgba(207, 216, 227, var(--placeholder-opacity));
  }
  .lg\\:placeholder-cool-gray-400::placeholder {
    --placeholder-opacity: 1;
    color: #97a6ba;
    color: rgba(151, 166, 186, var(--placeholder-opacity));
  }
  .lg\\:placeholder-cool-gray-500::placeholder {
    --placeholder-opacity: 1;
    color: #64748b;
    color: rgba(100, 116, 139, var(--placeholder-opacity));
  }
  .lg\\:placeholder-cool-gray-600::placeholder {
    --placeholder-opacity: 1;
    color: #475569;
    color: rgba(71, 85, 105, var(--placeholder-opacity));
  }
  .lg\\:placeholder-cool-gray-700::placeholder {
    --placeholder-opacity: 1;
    color: #364152;
    color: rgba(54, 65, 82, var(--placeholder-opacity));
  }
  .lg\\:placeholder-cool-gray-800::placeholder {
    --placeholder-opacity: 1;
    color: #27303f;
    color: rgba(39, 48, 63, var(--placeholder-opacity));
  }
  .lg\\:placeholder-cool-gray-900::placeholder {
    --placeholder-opacity: 1;
    color: #1a202e;
    color: rgba(26, 32, 46, var(--placeholder-opacity));
  }
  .lg\\:focus\\:placeholder-current:focus::placeholder {
    color: currentColor;
  }
  .lg\\:focus\\:placeholder-transparent:focus::placeholder {
    color: transparent;
  }
  .lg\\:focus\\:placeholder-white:focus::placeholder {
    --placeholder-opacity: 1;
    color: #ffffff;
    color: rgba(255, 255, 255, var(--placeholder-opacity));
  }
  .lg\\:focus\\:placeholder-black:focus::placeholder {
    --placeholder-opacity: 1;
    color: #000000;
    color: rgba(0, 0, 0, var(--placeholder-opacity));
  }
  .lg\\:focus\\:placeholder-gray-50:focus::placeholder {
    --placeholder-opacity: 1;
    color: #f9fafb;
    color: rgba(249, 250, 251, var(--placeholder-opacity));
  }
  .lg\\:focus\\:placeholder-gray-100:focus::placeholder {
    --placeholder-opacity: 1;
    color: #f4f5f7;
    color: rgba(244, 245, 247, var(--placeholder-opacity));
  }
  .lg\\:focus\\:placeholder-gray-200:focus::placeholder {
    --placeholder-opacity: 1;
    color: #e5e7eb;
    color: rgba(229, 231, 235, var(--placeholder-opacity));
  }
  .lg\\:focus\\:placeholder-gray-300:focus::placeholder {
    --placeholder-opacity: 1;
    color: #d2d6dc;
    color: rgba(210, 214, 220, var(--placeholder-opacity));
  }
  .lg\\:focus\\:placeholder-gray-400:focus::placeholder {
    --placeholder-opacity: 1;
    color: #9fa6b2;
    color: rgba(159, 166, 178, var(--placeholder-opacity));
  }
  .lg\\:focus\\:placeholder-gray-500:focus::placeholder {
    --placeholder-opacity: 1;
    color: #6b7280;
    color: rgba(107, 114, 128, var(--placeholder-opacity));
  }
  .lg\\:focus\\:placeholder-gray-600:focus::placeholder {
    --placeholder-opacity: 1;
    color: #4b5563;
    color: rgba(75, 85, 99, var(--placeholder-opacity));
  }
  .lg\\:focus\\:placeholder-gray-700:focus::placeholder {
    --placeholder-opacity: 1;
    color: #374151;
    color: rgba(55, 65, 81, var(--placeholder-opacity));
  }
  .lg\\:focus\\:placeholder-gray-800:focus::placeholder {
    --placeholder-opacity: 1;
    color: #252f3f;
    color: rgba(37, 47, 63, var(--placeholder-opacity));
  }
  .lg\\:focus\\:placeholder-gray-900:focus::placeholder {
    --placeholder-opacity: 1;
    color: #161e2e;
    color: rgba(22, 30, 46, var(--placeholder-opacity));
  }
  .lg\\:focus\\:placeholder-red-50:focus::placeholder {
    --placeholder-opacity: 1;
    color: #fdf2f2;
    color: rgba(253, 242, 242, var(--placeholder-opacity));
  }
  .lg\\:focus\\:placeholder-red-100:focus::placeholder {
    --placeholder-opacity: 1;
    color: #fde8e8;
    color: rgba(253, 232, 232, var(--placeholder-opacity));
  }
  .lg\\:focus\\:placeholder-red-200:focus::placeholder {
    --placeholder-opacity: 1;
    color: #fbd5d5;
    color: rgba(251, 213, 213, var(--placeholder-opacity));
  }
  .lg\\:focus\\:placeholder-red-300:focus::placeholder {
    --placeholder-opacity: 1;
    color: #f8b4b4;
    color: rgba(248, 180, 180, var(--placeholder-opacity));
  }
  .lg\\:focus\\:placeholder-red-400:focus::placeholder {
    --placeholder-opacity: 1;
    color: #f98080;
    color: rgba(249, 128, 128, var(--placeholder-opacity));
  }
  .lg\\:focus\\:placeholder-red-500:focus::placeholder {
    --placeholder-opacity: 1;
    color: #f05252;
    color: rgba(240, 82, 82, var(--placeholder-opacity));
  }
  .lg\\:focus\\:placeholder-red-600:focus::placeholder {
    --placeholder-opacity: 1;
    color: #e02424;
    color: rgba(224, 36, 36, var(--placeholder-opacity));
  }
  .lg\\:focus\\:placeholder-red-700:focus::placeholder {
    --placeholder-opacity: 1;
    color: #c81e1e;
    color: rgba(200, 30, 30, var(--placeholder-opacity));
  }
  .lg\\:focus\\:placeholder-red-800:focus::placeholder {
    --placeholder-opacity: 1;
    color: #9b1c1c;
    color: rgba(155, 28, 28, var(--placeholder-opacity));
  }
  .lg\\:focus\\:placeholder-red-900:focus::placeholder {
    --placeholder-opacity: 1;
    color: #771d1d;
    color: rgba(119, 29, 29, var(--placeholder-opacity));
  }
  .lg\\:focus\\:placeholder-orange-50:focus::placeholder {
    --placeholder-opacity: 1;
    color: #fff8f1;
    color: rgba(255, 248, 241, var(--placeholder-opacity));
  }
  .lg\\:focus\\:placeholder-orange-100:focus::placeholder {
    --placeholder-opacity: 1;
    color: #feecdc;
    color: rgba(254, 236, 220, var(--placeholder-opacity));
  }
  .lg\\:focus\\:placeholder-orange-200:focus::placeholder {
    --placeholder-opacity: 1;
    color: #fcd9bd;
    color: rgba(252, 217, 189, var(--placeholder-opacity));
  }
  .lg\\:focus\\:placeholder-orange-300:focus::placeholder {
    --placeholder-opacity: 1;
    color: #fdba8c;
    color: rgba(253, 186, 140, var(--placeholder-opacity));
  }
  .lg\\:focus\\:placeholder-orange-400:focus::placeholder {
    --placeholder-opacity: 1;
    color: #ff8a4c;
    color: rgba(255, 138, 76, var(--placeholder-opacity));
  }
  .lg\\:focus\\:placeholder-orange-500:focus::placeholder {
    --placeholder-opacity: 1;
    color: #ff5a1f;
    color: rgba(255, 90, 31, var(--placeholder-opacity));
  }
  .lg\\:focus\\:placeholder-orange-600:focus::placeholder {
    --placeholder-opacity: 1;
    color: #d03801;
    color: rgba(208, 56, 1, var(--placeholder-opacity));
  }
  .lg\\:focus\\:placeholder-orange-700:focus::placeholder {
    --placeholder-opacity: 1;
    color: #b43403;
    color: rgba(180, 52, 3, var(--placeholder-opacity));
  }
  .lg\\:focus\\:placeholder-orange-800:focus::placeholder {
    --placeholder-opacity: 1;
    color: #8a2c0d;
    color: rgba(138, 44, 13, var(--placeholder-opacity));
  }
  .lg\\:focus\\:placeholder-orange-900:focus::placeholder {
    --placeholder-opacity: 1;
    color: #73230d;
    color: rgba(115, 35, 13, var(--placeholder-opacity));
  }
  .lg\\:focus\\:placeholder-yellow-50:focus::placeholder {
    --placeholder-opacity: 1;
    color: #fdfdea;
    color: rgba(253, 253, 234, var(--placeholder-opacity));
  }
  .lg\\:focus\\:placeholder-yellow-100:focus::placeholder {
    --placeholder-opacity: 1;
    color: #fdf6b2;
    color: rgba(253, 246, 178, var(--placeholder-opacity));
  }
  .lg\\:focus\\:placeholder-yellow-200:focus::placeholder {
    --placeholder-opacity: 1;
    color: #fce96a;
    color: rgba(252, 233, 106, var(--placeholder-opacity));
  }
  .lg\\:focus\\:placeholder-yellow-300:focus::placeholder {
    --placeholder-opacity: 1;
    color: #faca15;
    color: rgba(250, 202, 21, var(--placeholder-opacity));
  }
  .lg\\:focus\\:placeholder-yellow-400:focus::placeholder {
    --placeholder-opacity: 1;
    color: #e3a008;
    color: rgba(227, 160, 8, var(--placeholder-opacity));
  }
  .lg\\:focus\\:placeholder-yellow-500:focus::placeholder {
    --placeholder-opacity: 1;
    color: #c27803;
    color: rgba(194, 120, 3, var(--placeholder-opacity));
  }
  .lg\\:focus\\:placeholder-yellow-600:focus::placeholder {
    --placeholder-opacity: 1;
    color: #9f580a;
    color: rgba(159, 88, 10, var(--placeholder-opacity));
  }
  .lg\\:focus\\:placeholder-yellow-700:focus::placeholder {
    --placeholder-opacity: 1;
    color: #8e4b10;
    color: rgba(142, 75, 16, var(--placeholder-opacity));
  }
  .lg\\:focus\\:placeholder-yellow-800:focus::placeholder {
    --placeholder-opacity: 1;
    color: #723b13;
    color: rgba(114, 59, 19, var(--placeholder-opacity));
  }
  .lg\\:focus\\:placeholder-yellow-900:focus::placeholder {
    --placeholder-opacity: 1;
    color: #633112;
    color: rgba(99, 49, 18, var(--placeholder-opacity));
  }
  .lg\\:focus\\:placeholder-green-50:focus::placeholder {
    --placeholder-opacity: 1;
    color: #f3faf7;
    color: rgba(243, 250, 247, var(--placeholder-opacity));
  }
  .lg\\:focus\\:placeholder-green-100:focus::placeholder {
    --placeholder-opacity: 1;
    color: #def7ec;
    color: rgba(222, 247, 236, var(--placeholder-opacity));
  }
  .lg\\:focus\\:placeholder-green-200:focus::placeholder {
    --placeholder-opacity: 1;
    color: #bcf0da;
    color: rgba(188, 240, 218, var(--placeholder-opacity));
  }
  .lg\\:focus\\:placeholder-green-300:focus::placeholder {
    --placeholder-opacity: 1;
    color: #84e1bc;
    color: rgba(132, 225, 188, var(--placeholder-opacity));
  }
  .lg\\:focus\\:placeholder-green-400:focus::placeholder {
    --placeholder-opacity: 1;
    color: #31c48d;
    color: rgba(49, 196, 141, var(--placeholder-opacity));
  }
  .lg\\:focus\\:placeholder-green-500:focus::placeholder {
    --placeholder-opacity: 1;
    color: #0e9f6e;
    color: rgba(14, 159, 110, var(--placeholder-opacity));
  }
  .lg\\:focus\\:placeholder-green-600:focus::placeholder {
    --placeholder-opacity: 1;
    color: #057a55;
    color: rgba(5, 122, 85, var(--placeholder-opacity));
  }
  .lg\\:focus\\:placeholder-green-700:focus::placeholder {
    --placeholder-opacity: 1;
    color: #046c4e;
    color: rgba(4, 108, 78, var(--placeholder-opacity));
  }
  .lg\\:focus\\:placeholder-green-800:focus::placeholder {
    --placeholder-opacity: 1;
    color: #03543f;
    color: rgba(3, 84, 63, var(--placeholder-opacity));
  }
  .lg\\:focus\\:placeholder-green-900:focus::placeholder {
    --placeholder-opacity: 1;
    color: #014737;
    color: rgba(1, 71, 55, var(--placeholder-opacity));
  }
  .lg\\:focus\\:placeholder-teal-50:focus::placeholder {
    --placeholder-opacity: 1;
    color: #edfafa;
    color: rgba(237, 250, 250, var(--placeholder-opacity));
  }
  .lg\\:focus\\:placeholder-teal-100:focus::placeholder {
    --placeholder-opacity: 1;
    color: #d5f5f6;
    color: rgba(213, 245, 246, var(--placeholder-opacity));
  }
  .lg\\:focus\\:placeholder-teal-200:focus::placeholder {
    --placeholder-opacity: 1;
    color: #afecef;
    color: rgba(175, 236, 239, var(--placeholder-opacity));
  }
  .lg\\:focus\\:placeholder-teal-300:focus::placeholder {
    --placeholder-opacity: 1;
    color: #7edce2;
    color: rgba(126, 220, 226, var(--placeholder-opacity));
  }
  .lg\\:focus\\:placeholder-teal-400:focus::placeholder {
    --placeholder-opacity: 1;
    color: #16bdca;
    color: rgba(22, 189, 202, var(--placeholder-opacity));
  }
  .lg\\:focus\\:placeholder-teal-500:focus::placeholder {
    --placeholder-opacity: 1;
    color: #0694a2;
    color: rgba(6, 148, 162, var(--placeholder-opacity));
  }
  .lg\\:focus\\:placeholder-teal-600:focus::placeholder {
    --placeholder-opacity: 1;
    color: #047481;
    color: rgba(4, 116, 129, var(--placeholder-opacity));
  }
  .lg\\:focus\\:placeholder-teal-700:focus::placeholder {
    --placeholder-opacity: 1;
    color: #036672;
    color: rgba(3, 102, 114, var(--placeholder-opacity));
  }
  .lg\\:focus\\:placeholder-teal-800:focus::placeholder {
    --placeholder-opacity: 1;
    color: #05505c;
    color: rgba(5, 80, 92, var(--placeholder-opacity));
  }
  .lg\\:focus\\:placeholder-teal-900:focus::placeholder {
    --placeholder-opacity: 1;
    color: #014451;
    color: rgba(1, 68, 81, var(--placeholder-opacity));
  }
  .lg\\:focus\\:placeholder-blue-50:focus::placeholder {
    --placeholder-opacity: 1;
    color: #ebf5ff;
    color: rgba(235, 245, 255, var(--placeholder-opacity));
  }
  .lg\\:focus\\:placeholder-blue-100:focus::placeholder {
    --placeholder-opacity: 1;
    color: #e1effe;
    color: rgba(225, 239, 254, var(--placeholder-opacity));
  }
  .lg\\:focus\\:placeholder-blue-200:focus::placeholder {
    --placeholder-opacity: 1;
    color: #c3ddfd;
    color: rgba(195, 221, 253, var(--placeholder-opacity));
  }
  .lg\\:focus\\:placeholder-blue-300:focus::placeholder {
    --placeholder-opacity: 1;
    color: #a4cafe;
    color: rgba(164, 202, 254, var(--placeholder-opacity));
  }
  .lg\\:focus\\:placeholder-blue-400:focus::placeholder {
    --placeholder-opacity: 1;
    color: #76a9fa;
    color: rgba(118, 169, 250, var(--placeholder-opacity));
  }
  .lg\\:focus\\:placeholder-blue-500:focus::placeholder {
    --placeholder-opacity: 1;
    color: #3f83f8;
    color: rgba(63, 131, 248, var(--placeholder-opacity));
  }
  .lg\\:focus\\:placeholder-blue-600:focus::placeholder {
    --placeholder-opacity: 1;
    color: #1c64f2;
    color: rgba(28, 100, 242, var(--placeholder-opacity));
  }
  .lg\\:focus\\:placeholder-blue-700:focus::placeholder {
    --placeholder-opacity: 1;
    color: #1a56db;
    color: rgba(26, 86, 219, var(--placeholder-opacity));
  }
  .lg\\:focus\\:placeholder-blue-800:focus::placeholder {
    --placeholder-opacity: 1;
    color: #1e429f;
    color: rgba(30, 66, 159, var(--placeholder-opacity));
  }
  .lg\\:focus\\:placeholder-blue-900:focus::placeholder {
    --placeholder-opacity: 1;
    color: #233876;
    color: rgba(35, 56, 118, var(--placeholder-opacity));
  }
  .lg\\:focus\\:placeholder-indigo-50:focus::placeholder {
    --placeholder-opacity: 1;
    color: #f0f5ff;
    color: rgba(240, 245, 255, var(--placeholder-opacity));
  }
  .lg\\:focus\\:placeholder-indigo-100:focus::placeholder {
    --placeholder-opacity: 1;
    color: #e5edff;
    color: rgba(229, 237, 255, var(--placeholder-opacity));
  }
  .lg\\:focus\\:placeholder-indigo-200:focus::placeholder {
    --placeholder-opacity: 1;
    color: #cddbfe;
    color: rgba(205, 219, 254, var(--placeholder-opacity));
  }
  .lg\\:focus\\:placeholder-indigo-300:focus::placeholder {
    --placeholder-opacity: 1;
    color: #b4c6fc;
    color: rgba(180, 198, 252, var(--placeholder-opacity));
  }
  .lg\\:focus\\:placeholder-indigo-400:focus::placeholder {
    --placeholder-opacity: 1;
    color: #8da2fb;
    color: rgba(141, 162, 251, var(--placeholder-opacity));
  }
  .lg\\:focus\\:placeholder-indigo-500:focus::placeholder {
    --placeholder-opacity: 1;
    color: #6875f5;
    color: rgba(104, 117, 245, var(--placeholder-opacity));
  }
  .lg\\:focus\\:placeholder-indigo-600:focus::placeholder {
    --placeholder-opacity: 1;
    color: #5850ec;
    color: rgba(88, 80, 236, var(--placeholder-opacity));
  }
  .lg\\:focus\\:placeholder-indigo-700:focus::placeholder {
    --placeholder-opacity: 1;
    color: #5145cd;
    color: rgba(81, 69, 205, var(--placeholder-opacity));
  }
  .lg\\:focus\\:placeholder-indigo-800:focus::placeholder {
    --placeholder-opacity: 1;
    color: #42389d;
    color: rgba(66, 56, 157, var(--placeholder-opacity));
  }
  .lg\\:focus\\:placeholder-indigo-900:focus::placeholder {
    --placeholder-opacity: 1;
    color: #362f78;
    color: rgba(54, 47, 120, var(--placeholder-opacity));
  }
  .lg\\:focus\\:placeholder-purple-50:focus::placeholder {
    --placeholder-opacity: 1;
    color: #f6f5ff;
    color: rgba(246, 245, 255, var(--placeholder-opacity));
  }
  .lg\\:focus\\:placeholder-purple-100:focus::placeholder {
    --placeholder-opacity: 1;
    color: #edebfe;
    color: rgba(237, 235, 254, var(--placeholder-opacity));
  }
  .lg\\:focus\\:placeholder-purple-200:focus::placeholder {
    --placeholder-opacity: 1;
    color: #dcd7fe;
    color: rgba(220, 215, 254, var(--placeholder-opacity));
  }
  .lg\\:focus\\:placeholder-purple-300:focus::placeholder {
    --placeholder-opacity: 1;
    color: #cabffd;
    color: rgba(202, 191, 253, var(--placeholder-opacity));
  }
  .lg\\:focus\\:placeholder-purple-400:focus::placeholder {
    --placeholder-opacity: 1;
    color: #ac94fa;
    color: rgba(172, 148, 250, var(--placeholder-opacity));
  }
  .lg\\:focus\\:placeholder-purple-500:focus::placeholder {
    --placeholder-opacity: 1;
    color: #9061f9;
    color: rgba(144, 97, 249, var(--placeholder-opacity));
  }
  .lg\\:focus\\:placeholder-purple-600:focus::placeholder {
    --placeholder-opacity: 1;
    color: #7e3af2;
    color: rgba(126, 58, 242, var(--placeholder-opacity));
  }
  .lg\\:focus\\:placeholder-purple-700:focus::placeholder {
    --placeholder-opacity: 1;
    color: #6c2bd9;
    color: rgba(108, 43, 217, var(--placeholder-opacity));
  }
  .lg\\:focus\\:placeholder-purple-800:focus::placeholder {
    --placeholder-opacity: 1;
    color: #5521b5;
    color: rgba(85, 33, 181, var(--placeholder-opacity));
  }
  .lg\\:focus\\:placeholder-purple-900:focus::placeholder {
    --placeholder-opacity: 1;
    color: #4a1d96;
    color: rgba(74, 29, 150, var(--placeholder-opacity));
  }
  .lg\\:focus\\:placeholder-pink-50:focus::placeholder {
    --placeholder-opacity: 1;
    color: #fdf2f8;
    color: rgba(253, 242, 248, var(--placeholder-opacity));
  }
  .lg\\:focus\\:placeholder-pink-100:focus::placeholder {
    --placeholder-opacity: 1;
    color: #fce8f3;
    color: rgba(252, 232, 243, var(--placeholder-opacity));
  }
  .lg\\:focus\\:placeholder-pink-200:focus::placeholder {
    --placeholder-opacity: 1;
    color: #fad1e8;
    color: rgba(250, 209, 232, var(--placeholder-opacity));
  }
  .lg\\:focus\\:placeholder-pink-300:focus::placeholder {
    --placeholder-opacity: 1;
    color: #f8b4d9;
    color: rgba(248, 180, 217, var(--placeholder-opacity));
  }
  .lg\\:focus\\:placeholder-pink-400:focus::placeholder {
    --placeholder-opacity: 1;
    color: #f17eb8;
    color: rgba(241, 126, 184, var(--placeholder-opacity));
  }
  .lg\\:focus\\:placeholder-pink-500:focus::placeholder {
    --placeholder-opacity: 1;
    color: #e74694;
    color: rgba(231, 70, 148, var(--placeholder-opacity));
  }
  .lg\\:focus\\:placeholder-pink-600:focus::placeholder {
    --placeholder-opacity: 1;
    color: #d61f69;
    color: rgba(214, 31, 105, var(--placeholder-opacity));
  }
  .lg\\:focus\\:placeholder-pink-700:focus::placeholder {
    --placeholder-opacity: 1;
    color: #bf125d;
    color: rgba(191, 18, 93, var(--placeholder-opacity));
  }
  .lg\\:focus\\:placeholder-pink-800:focus::placeholder {
    --placeholder-opacity: 1;
    color: #99154b;
    color: rgba(153, 21, 75, var(--placeholder-opacity));
  }
  .lg\\:focus\\:placeholder-pink-900:focus::placeholder {
    --placeholder-opacity: 1;
    color: #751a3d;
    color: rgba(117, 26, 61, var(--placeholder-opacity));
  }
  .lg\\:focus\\:placeholder-cool-gray-50:focus::placeholder {
    --placeholder-opacity: 1;
    color: #f8fafc;
    color: rgba(248, 250, 252, var(--placeholder-opacity));
  }
  .lg\\:focus\\:placeholder-cool-gray-100:focus::placeholder {
    --placeholder-opacity: 1;
    color: #f1f5f9;
    color: rgba(241, 245, 249, var(--placeholder-opacity));
  }
  .lg\\:focus\\:placeholder-cool-gray-200:focus::placeholder {
    --placeholder-opacity: 1;
    color: #e2e8f0;
    color: rgba(226, 232, 240, var(--placeholder-opacity));
  }
  .lg\\:focus\\:placeholder-cool-gray-300:focus::placeholder {
    --placeholder-opacity: 1;
    color: #cfd8e3;
    color: rgba(207, 216, 227, var(--placeholder-opacity));
  }
  .lg\\:focus\\:placeholder-cool-gray-400:focus::placeholder {
    --placeholder-opacity: 1;
    color: #97a6ba;
    color: rgba(151, 166, 186, var(--placeholder-opacity));
  }
  .lg\\:focus\\:placeholder-cool-gray-500:focus::placeholder {
    --placeholder-opacity: 1;
    color: #64748b;
    color: rgba(100, 116, 139, var(--placeholder-opacity));
  }
  .lg\\:focus\\:placeholder-cool-gray-600:focus::placeholder {
    --placeholder-opacity: 1;
    color: #475569;
    color: rgba(71, 85, 105, var(--placeholder-opacity));
  }
  .lg\\:focus\\:placeholder-cool-gray-700:focus::placeholder {
    --placeholder-opacity: 1;
    color: #364152;
    color: rgba(54, 65, 82, var(--placeholder-opacity));
  }
  .lg\\:focus\\:placeholder-cool-gray-800:focus::placeholder {
    --placeholder-opacity: 1;
    color: #27303f;
    color: rgba(39, 48, 63, var(--placeholder-opacity));
  }
  .lg\\:focus\\:placeholder-cool-gray-900:focus::placeholder {
    --placeholder-opacity: 1;
    color: #1a202e;
    color: rgba(26, 32, 46, var(--placeholder-opacity));
  }
  .lg\\:placeholder-opacity-0::placeholder {
    --placeholder-opacity: 0;
  }
  .lg\\:placeholder-opacity-25::placeholder {
    --placeholder-opacity: 0.25;
  }
  .lg\\:placeholder-opacity-50::placeholder {
    --placeholder-opacity: 0.5;
  }
  .lg\\:placeholder-opacity-75::placeholder {
    --placeholder-opacity: 0.75;
  }
  .lg\\:placeholder-opacity-100::placeholder {
    --placeholder-opacity: 1;
  }
  .lg\\:focus\\:placeholder-opacity-0:focus::placeholder {
    --placeholder-opacity: 0;
  }
  .lg\\:focus\\:placeholder-opacity-25:focus::placeholder {
    --placeholder-opacity: 0.25;
  }
  .lg\\:focus\\:placeholder-opacity-50:focus::placeholder {
    --placeholder-opacity: 0.5;
  }
  .lg\\:focus\\:placeholder-opacity-75:focus::placeholder {
    --placeholder-opacity: 0.75;
  }
  .lg\\:focus\\:placeholder-opacity-100:focus::placeholder {
    --placeholder-opacity: 1;
  }
  .lg\\:pointer-events-none {
    pointer-events: none;
  }
  .lg\\:pointer-events-auto {
    pointer-events: auto;
  }
  .lg\\:static {
    position: static;
  }
  .lg\\:fixed {
    position: fixed;
  }
  .lg\\:absolute {
    position: absolute;
  }
  .lg\\:relative {
    position: relative;
  }
  .lg\\:sticky {
    position: sticky;
  }
  .lg\\:inset-0 {
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
  }
  .lg\\:inset-1 {
    top: 0.25rem;
    right: 0.25rem;
    bottom: 0.25rem;
    left: 0.25rem;
  }
  .lg\\:inset-2 {
    top: 0.5rem;
    right: 0.5rem;
    bottom: 0.5rem;
    left: 0.5rem;
  }
  .lg\\:inset-3 {
    top: 0.75rem;
    right: 0.75rem;
    bottom: 0.75rem;
    left: 0.75rem;
  }
  .lg\\:inset-4 {
    top: 1rem;
    right: 1rem;
    bottom: 1rem;
    left: 1rem;
  }
  .lg\\:inset-5 {
    top: 1.25rem;
    right: 1.25rem;
    bottom: 1.25rem;
    left: 1.25rem;
  }
  .lg\\:inset-6 {
    top: 1.5rem;
    right: 1.5rem;
    bottom: 1.5rem;
    left: 1.5rem;
  }
  .lg\\:inset-7 {
    top: 1.75rem;
    right: 1.75rem;
    bottom: 1.75rem;
    left: 1.75rem;
  }
  .lg\\:inset-8 {
    top: 2rem;
    right: 2rem;
    bottom: 2rem;
    left: 2rem;
  }
  .lg\\:inset-9 {
    top: 2.25rem;
    right: 2.25rem;
    bottom: 2.25rem;
    left: 2.25rem;
  }
  .lg\\:inset-10 {
    top: 2.5rem;
    right: 2.5rem;
    bottom: 2.5rem;
    left: 2.5rem;
  }
  .lg\\:inset-11 {
    top: 2.75rem;
    right: 2.75rem;
    bottom: 2.75rem;
    left: 2.75rem;
  }
  .lg\\:inset-12 {
    top: 3rem;
    right: 3rem;
    bottom: 3rem;
    left: 3rem;
  }
  .lg\\:inset-13 {
    top: 3.25rem;
    right: 3.25rem;
    bottom: 3.25rem;
    left: 3.25rem;
  }
  .lg\\:inset-14 {
    top: 3.5rem;
    right: 3.5rem;
    bottom: 3.5rem;
    left: 3.5rem;
  }
  .lg\\:inset-15 {
    top: 3.75rem;
    right: 3.75rem;
    bottom: 3.75rem;
    left: 3.75rem;
  }
  .lg\\:inset-16 {
    top: 4rem;
    right: 4rem;
    bottom: 4rem;
    left: 4rem;
  }
  .lg\\:inset-20 {
    top: 5rem;
    right: 5rem;
    bottom: 5rem;
    left: 5rem;
  }
  .lg\\:inset-24 {
    top: 6rem;
    right: 6rem;
    bottom: 6rem;
    left: 6rem;
  }
  .lg\\:inset-28 {
    top: 7rem;
    right: 7rem;
    bottom: 7rem;
    left: 7rem;
  }
  .lg\\:inset-32 {
    top: 8rem;
    right: 8rem;
    bottom: 8rem;
    left: 8rem;
  }
  .lg\\:inset-36 {
    top: 9rem;
    right: 9rem;
    bottom: 9rem;
    left: 9rem;
  }
  .lg\\:inset-40 {
    top: 10rem;
    right: 10rem;
    bottom: 10rem;
    left: 10rem;
  }
  .lg\\:inset-44 {
    top: 11rem;
    right: 11rem;
    bottom: 11rem;
    left: 11rem;
  }
  .lg\\:inset-48 {
    top: 12rem;
    right: 12rem;
    bottom: 12rem;
    left: 12rem;
  }
  .lg\\:inset-52 {
    top: 13rem;
    right: 13rem;
    bottom: 13rem;
    left: 13rem;
  }
  .lg\\:inset-56 {
    top: 14rem;
    right: 14rem;
    bottom: 14rem;
    left: 14rem;
  }
  .lg\\:inset-60 {
    top: 15rem;
    right: 15rem;
    bottom: 15rem;
    left: 15rem;
  }
  .lg\\:inset-64 {
    top: 16rem;
    right: 16rem;
    bottom: 16rem;
    left: 16rem;
  }
  .lg\\:inset-72 {
    top: 18rem;
    right: 18rem;
    bottom: 18rem;
    left: 18rem;
  }
  .lg\\:inset-80 {
    top: 20rem;
    right: 20rem;
    bottom: 20rem;
    left: 20rem;
  }
  .lg\\:inset-96 {
    top: 24rem;
    right: 24rem;
    bottom: 24rem;
    left: 24rem;
  }
  .lg\\:inset-auto {
    top: auto;
    right: auto;
    bottom: auto;
    left: auto;
  }
  .lg\\:inset-px {
    top: 1px;
    right: 1px;
    bottom: 1px;
    left: 1px;
  }
  .lg\\:inset-0\\.5 {
    top: 0.125rem;
    right: 0.125rem;
    bottom: 0.125rem;
    left: 0.125rem;
  }
  .lg\\:inset-1\\.5 {
    top: 0.375rem;
    right: 0.375rem;
    bottom: 0.375rem;
    left: 0.375rem;
  }
  .lg\\:inset-2\\.5 {
    top: 0.625rem;
    right: 0.625rem;
    bottom: 0.625rem;
    left: 0.625rem;
  }
  .lg\\:inset-3\\.5 {
    top: 0.875rem;
    right: 0.875rem;
    bottom: 0.875rem;
    left: 0.875rem;
  }
  .lg\\:inset-1\\/2 {
    top: 50%;
    right: 50%;
    bottom: 50%;
    left: 50%;
  }
  .lg\\:inset-1\\/3 {
    top: 33.333333%;
    right: 33.333333%;
    bottom: 33.333333%;
    left: 33.333333%;
  }
  .lg\\:inset-2\\/3 {
    top: 66.666667%;
    right: 66.666667%;
    bottom: 66.666667%;
    left: 66.666667%;
  }
  .lg\\:inset-1\\/4 {
    top: 25%;
    right: 25%;
    bottom: 25%;
    left: 25%;
  }
  .lg\\:inset-2\\/4 {
    top: 50%;
    right: 50%;
    bottom: 50%;
    left: 50%;
  }
  .lg\\:inset-3\\/4 {
    top: 75%;
    right: 75%;
    bottom: 75%;
    left: 75%;
  }
  .lg\\:inset-1\\/5 {
    top: 20%;
    right: 20%;
    bottom: 20%;
    left: 20%;
  }
  .lg\\:inset-2\\/5 {
    top: 40%;
    right: 40%;
    bottom: 40%;
    left: 40%;
  }
  .lg\\:inset-3\\/5 {
    top: 60%;
    right: 60%;
    bottom: 60%;
    left: 60%;
  }
  .lg\\:inset-4\\/5 {
    top: 80%;
    right: 80%;
    bottom: 80%;
    left: 80%;
  }
  .lg\\:inset-1\\/6 {
    top: 16.666667%;
    right: 16.666667%;
    bottom: 16.666667%;
    left: 16.666667%;
  }
  .lg\\:inset-2\\/6 {
    top: 33.333333%;
    right: 33.333333%;
    bottom: 33.333333%;
    left: 33.333333%;
  }
  .lg\\:inset-3\\/6 {
    top: 50%;
    right: 50%;
    bottom: 50%;
    left: 50%;
  }
  .lg\\:inset-4\\/6 {
    top: 66.666667%;
    right: 66.666667%;
    bottom: 66.666667%;
    left: 66.666667%;
  }
  .lg\\:inset-5\\/6 {
    top: 83.333333%;
    right: 83.333333%;
    bottom: 83.333333%;
    left: 83.333333%;
  }
  .lg\\:inset-1\\/12 {
    top: 8.333333%;
    right: 8.333333%;
    bottom: 8.333333%;
    left: 8.333333%;
  }
  .lg\\:inset-2\\/12 {
    top: 16.666667%;
    right: 16.666667%;
    bottom: 16.666667%;
    left: 16.666667%;
  }
  .lg\\:inset-3\\/12 {
    top: 25%;
    right: 25%;
    bottom: 25%;
    left: 25%;
  }
  .lg\\:inset-4\\/12 {
    top: 33.333333%;
    right: 33.333333%;
    bottom: 33.333333%;
    left: 33.333333%;
  }
  .lg\\:inset-5\\/12 {
    top: 41.666667%;
    right: 41.666667%;
    bottom: 41.666667%;
    left: 41.666667%;
  }
  .lg\\:inset-6\\/12 {
    top: 50%;
    right: 50%;
    bottom: 50%;
    left: 50%;
  }
  .lg\\:inset-7\\/12 {
    top: 58.333333%;
    right: 58.333333%;
    bottom: 58.333333%;
    left: 58.333333%;
  }
  .lg\\:inset-8\\/12 {
    top: 66.666667%;
    right: 66.666667%;
    bottom: 66.666667%;
    left: 66.666667%;
  }
  .lg\\:inset-9\\/12 {
    top: 75%;
    right: 75%;
    bottom: 75%;
    left: 75%;
  }
  .lg\\:inset-10\\/12 {
    top: 83.333333%;
    right: 83.333333%;
    bottom: 83.333333%;
    left: 83.333333%;
  }
  .lg\\:inset-11\\/12 {
    top: 91.666667%;
    right: 91.666667%;
    bottom: 91.666667%;
    left: 91.666667%;
  }
  .lg\\:inset-full {
    top: 100%;
    right: 100%;
    bottom: 100%;
    left: 100%;
  }
  .lg\\:inset-y-0 {
    top: 0;
    bottom: 0;
  }
  .lg\\:inset-x-0 {
    right: 0;
    left: 0;
  }
  .lg\\:inset-y-1 {
    top: 0.25rem;
    bottom: 0.25rem;
  }
  .lg\\:inset-x-1 {
    right: 0.25rem;
    left: 0.25rem;
  }
  .lg\\:inset-y-2 {
    top: 0.5rem;
    bottom: 0.5rem;
  }
  .lg\\:inset-x-2 {
    right: 0.5rem;
    left: 0.5rem;
  }
  .lg\\:inset-y-3 {
    top: 0.75rem;
    bottom: 0.75rem;
  }
  .lg\\:inset-x-3 {
    right: 0.75rem;
    left: 0.75rem;
  }
  .lg\\:inset-y-4 {
    top: 1rem;
    bottom: 1rem;
  }
  .lg\\:inset-x-4 {
    right: 1rem;
    left: 1rem;
  }
  .lg\\:inset-y-5 {
    top: 1.25rem;
    bottom: 1.25rem;
  }
  .lg\\:inset-x-5 {
    right: 1.25rem;
    left: 1.25rem;
  }
  .lg\\:inset-y-6 {
    top: 1.5rem;
    bottom: 1.5rem;
  }
  .lg\\:inset-x-6 {
    right: 1.5rem;
    left: 1.5rem;
  }
  .lg\\:inset-y-7 {
    top: 1.75rem;
    bottom: 1.75rem;
  }
  .lg\\:inset-x-7 {
    right: 1.75rem;
    left: 1.75rem;
  }
  .lg\\:inset-y-8 {
    top: 2rem;
    bottom: 2rem;
  }
  .lg\\:inset-x-8 {
    right: 2rem;
    left: 2rem;
  }
  .lg\\:inset-y-9 {
    top: 2.25rem;
    bottom: 2.25rem;
  }
  .lg\\:inset-x-9 {
    right: 2.25rem;
    left: 2.25rem;
  }
  .lg\\:inset-y-10 {
    top: 2.5rem;
    bottom: 2.5rem;
  }
  .lg\\:inset-x-10 {
    right: 2.5rem;
    left: 2.5rem;
  }
  .lg\\:inset-y-11 {
    top: 2.75rem;
    bottom: 2.75rem;
  }
  .lg\\:inset-x-11 {
    right: 2.75rem;
    left: 2.75rem;
  }
  .lg\\:inset-y-12 {
    top: 3rem;
    bottom: 3rem;
  }
  .lg\\:inset-x-12 {
    right: 3rem;
    left: 3rem;
  }
  .lg\\:inset-y-13 {
    top: 3.25rem;
    bottom: 3.25rem;
  }
  .lg\\:inset-x-13 {
    right: 3.25rem;
    left: 3.25rem;
  }
  .lg\\:inset-y-14 {
    top: 3.5rem;
    bottom: 3.5rem;
  }
  .lg\\:inset-x-14 {
    right: 3.5rem;
    left: 3.5rem;
  }
  .lg\\:inset-y-15 {
    top: 3.75rem;
    bottom: 3.75rem;
  }
  .lg\\:inset-x-15 {
    right: 3.75rem;
    left: 3.75rem;
  }
  .lg\\:inset-y-16 {
    top: 4rem;
    bottom: 4rem;
  }
  .lg\\:inset-x-16 {
    right: 4rem;
    left: 4rem;
  }
  .lg\\:inset-y-20 {
    top: 5rem;
    bottom: 5rem;
  }
  .lg\\:inset-x-20 {
    right: 5rem;
    left: 5rem;
  }
  .lg\\:inset-y-24 {
    top: 6rem;
    bottom: 6rem;
  }
  .lg\\:inset-x-24 {
    right: 6rem;
    left: 6rem;
  }
  .lg\\:inset-y-28 {
    top: 7rem;
    bottom: 7rem;
  }
  .lg\\:inset-x-28 {
    right: 7rem;
    left: 7rem;
  }
  .lg\\:inset-y-32 {
    top: 8rem;
    bottom: 8rem;
  }
  .lg\\:inset-x-32 {
    right: 8rem;
    left: 8rem;
  }
  .lg\\:inset-y-36 {
    top: 9rem;
    bottom: 9rem;
  }
  .lg\\:inset-x-36 {
    right: 9rem;
    left: 9rem;
  }
  .lg\\:inset-y-40 {
    top: 10rem;
    bottom: 10rem;
  }
  .lg\\:inset-x-40 {
    right: 10rem;
    left: 10rem;
  }
  .lg\\:inset-y-44 {
    top: 11rem;
    bottom: 11rem;
  }
  .lg\\:inset-x-44 {
    right: 11rem;
    left: 11rem;
  }
  .lg\\:inset-y-48 {
    top: 12rem;
    bottom: 12rem;
  }
  .lg\\:inset-x-48 {
    right: 12rem;
    left: 12rem;
  }
  .lg\\:inset-y-52 {
    top: 13rem;
    bottom: 13rem;
  }
  .lg\\:inset-x-52 {
    right: 13rem;
    left: 13rem;
  }
  .lg\\:inset-y-56 {
    top: 14rem;
    bottom: 14rem;
  }
  .lg\\:inset-x-56 {
    right: 14rem;
    left: 14rem;
  }
  .lg\\:inset-y-60 {
    top: 15rem;
    bottom: 15rem;
  }
  .lg\\:inset-x-60 {
    right: 15rem;
    left: 15rem;
  }
  .lg\\:inset-y-64 {
    top: 16rem;
    bottom: 16rem;
  }
  .lg\\:inset-x-64 {
    right: 16rem;
    left: 16rem;
  }
  .lg\\:inset-y-72 {
    top: 18rem;
    bottom: 18rem;
  }
  .lg\\:inset-x-72 {
    right: 18rem;
    left: 18rem;
  }
  .lg\\:inset-y-80 {
    top: 20rem;
    bottom: 20rem;
  }
  .lg\\:inset-x-80 {
    right: 20rem;
    left: 20rem;
  }
  .lg\\:inset-y-96 {
    top: 24rem;
    bottom: 24rem;
  }
  .lg\\:inset-x-96 {
    right: 24rem;
    left: 24rem;
  }
  .lg\\:inset-y-auto {
    top: auto;
    bottom: auto;
  }
  .lg\\:inset-x-auto {
    right: auto;
    left: auto;
  }
  .lg\\:inset-y-px {
    top: 1px;
    bottom: 1px;
  }
  .lg\\:inset-x-px {
    right: 1px;
    left: 1px;
  }
  .lg\\:inset-y-0\\.5 {
    top: 0.125rem;
    bottom: 0.125rem;
  }
  .lg\\:inset-x-0\\.5 {
    right: 0.125rem;
    left: 0.125rem;
  }
  .lg\\:inset-y-1\\.5 {
    top: 0.375rem;
    bottom: 0.375rem;
  }
  .lg\\:inset-x-1\\.5 {
    right: 0.375rem;
    left: 0.375rem;
  }
  .lg\\:inset-y-2\\.5 {
    top: 0.625rem;
    bottom: 0.625rem;
  }
  .lg\\:inset-x-2\\.5 {
    right: 0.625rem;
    left: 0.625rem;
  }
  .lg\\:inset-y-3\\.5 {
    top: 0.875rem;
    bottom: 0.875rem;
  }
  .lg\\:inset-x-3\\.5 {
    right: 0.875rem;
    left: 0.875rem;
  }
  .lg\\:inset-y-1\\/2 {
    top: 50%;
    bottom: 50%;
  }
  .lg\\:inset-x-1\\/2 {
    right: 50%;
    left: 50%;
  }
  .lg\\:inset-y-1\\/3 {
    top: 33.333333%;
    bottom: 33.333333%;
  }
  .lg\\:inset-x-1\\/3 {
    right: 33.333333%;
    left: 33.333333%;
  }
  .lg\\:inset-y-2\\/3 {
    top: 66.666667%;
    bottom: 66.666667%;
  }
  .lg\\:inset-x-2\\/3 {
    right: 66.666667%;
    left: 66.666667%;
  }
  .lg\\:inset-y-1\\/4 {
    top: 25%;
    bottom: 25%;
  }
  .lg\\:inset-x-1\\/4 {
    right: 25%;
    left: 25%;
  }
  .lg\\:inset-y-2\\/4 {
    top: 50%;
    bottom: 50%;
  }
  .lg\\:inset-x-2\\/4 {
    right: 50%;
    left: 50%;
  }
  .lg\\:inset-y-3\\/4 {
    top: 75%;
    bottom: 75%;
  }
  .lg\\:inset-x-3\\/4 {
    right: 75%;
    left: 75%;
  }
  .lg\\:inset-y-1\\/5 {
    top: 20%;
    bottom: 20%;
  }
  .lg\\:inset-x-1\\/5 {
    right: 20%;
    left: 20%;
  }
  .lg\\:inset-y-2\\/5 {
    top: 40%;
    bottom: 40%;
  }
  .lg\\:inset-x-2\\/5 {
    right: 40%;
    left: 40%;
  }
  .lg\\:inset-y-3\\/5 {
    top: 60%;
    bottom: 60%;
  }
  .lg\\:inset-x-3\\/5 {
    right: 60%;
    left: 60%;
  }
  .lg\\:inset-y-4\\/5 {
    top: 80%;
    bottom: 80%;
  }
  .lg\\:inset-x-4\\/5 {
    right: 80%;
    left: 80%;
  }
  .lg\\:inset-y-1\\/6 {
    top: 16.666667%;
    bottom: 16.666667%;
  }
  .lg\\:inset-x-1\\/6 {
    right: 16.666667%;
    left: 16.666667%;
  }
  .lg\\:inset-y-2\\/6 {
    top: 33.333333%;
    bottom: 33.333333%;
  }
  .lg\\:inset-x-2\\/6 {
    right: 33.333333%;
    left: 33.333333%;
  }
  .lg\\:inset-y-3\\/6 {
    top: 50%;
    bottom: 50%;
  }
  .lg\\:inset-x-3\\/6 {
    right: 50%;
    left: 50%;
  }
  .lg\\:inset-y-4\\/6 {
    top: 66.666667%;
    bottom: 66.666667%;
  }
  .lg\\:inset-x-4\\/6 {
    right: 66.666667%;
    left: 66.666667%;
  }
  .lg\\:inset-y-5\\/6 {
    top: 83.333333%;
    bottom: 83.333333%;
  }
  .lg\\:inset-x-5\\/6 {
    right: 83.333333%;
    left: 83.333333%;
  }
  .lg\\:inset-y-1\\/12 {
    top: 8.333333%;
    bottom: 8.333333%;
  }
  .lg\\:inset-x-1\\/12 {
    right: 8.333333%;
    left: 8.333333%;
  }
  .lg\\:inset-y-2\\/12 {
    top: 16.666667%;
    bottom: 16.666667%;
  }
  .lg\\:inset-x-2\\/12 {
    right: 16.666667%;
    left: 16.666667%;
  }
  .lg\\:inset-y-3\\/12 {
    top: 25%;
    bottom: 25%;
  }
  .lg\\:inset-x-3\\/12 {
    right: 25%;
    left: 25%;
  }
  .lg\\:inset-y-4\\/12 {
    top: 33.333333%;
    bottom: 33.333333%;
  }
  .lg\\:inset-x-4\\/12 {
    right: 33.333333%;
    left: 33.333333%;
  }
  .lg\\:inset-y-5\\/12 {
    top: 41.666667%;
    bottom: 41.666667%;
  }
  .lg\\:inset-x-5\\/12 {
    right: 41.666667%;
    left: 41.666667%;
  }
  .lg\\:inset-y-6\\/12 {
    top: 50%;
    bottom: 50%;
  }
  .lg\\:inset-x-6\\/12 {
    right: 50%;
    left: 50%;
  }
  .lg\\:inset-y-7\\/12 {
    top: 58.333333%;
    bottom: 58.333333%;
  }
  .lg\\:inset-x-7\\/12 {
    right: 58.333333%;
    left: 58.333333%;
  }
  .lg\\:inset-y-8\\/12 {
    top: 66.666667%;
    bottom: 66.666667%;
  }
  .lg\\:inset-x-8\\/12 {
    right: 66.666667%;
    left: 66.666667%;
  }
  .lg\\:inset-y-9\\/12 {
    top: 75%;
    bottom: 75%;
  }
  .lg\\:inset-x-9\\/12 {
    right: 75%;
    left: 75%;
  }
  .lg\\:inset-y-10\\/12 {
    top: 83.333333%;
    bottom: 83.333333%;
  }
  .lg\\:inset-x-10\\/12 {
    right: 83.333333%;
    left: 83.333333%;
  }
  .lg\\:inset-y-11\\/12 {
    top: 91.666667%;
    bottom: 91.666667%;
  }
  .lg\\:inset-x-11\\/12 {
    right: 91.666667%;
    left: 91.666667%;
  }
  .lg\\:inset-y-full {
    top: 100%;
    bottom: 100%;
  }
  .lg\\:inset-x-full {
    right: 100%;
    left: 100%;
  }
  .lg\\:top-0 {
    top: 0;
  }
  .lg\\:right-0 {
    right: 0;
  }
  .lg\\:bottom-0 {
    bottom: 0;
  }
  .lg\\:left-0 {
    left: 0;
  }
  .lg\\:top-1 {
    top: 0.25rem;
  }
  .lg\\:right-1 {
    right: 0.25rem;
  }
  .lg\\:bottom-1 {
    bottom: 0.25rem;
  }
  .lg\\:left-1 {
    left: 0.25rem;
  }
  .lg\\:top-2 {
    top: 0.5rem;
  }
  .lg\\:right-2 {
    right: 0.5rem;
  }
  .lg\\:bottom-2 {
    bottom: 0.5rem;
  }
  .lg\\:left-2 {
    left: 0.5rem;
  }
  .lg\\:top-3 {
    top: 0.75rem;
  }
  .lg\\:right-3 {
    right: 0.75rem;
  }
  .lg\\:bottom-3 {
    bottom: 0.75rem;
  }
  .lg\\:left-3 {
    left: 0.75rem;
  }
  .lg\\:top-4 {
    top: 1rem;
  }
  .lg\\:right-4 {
    right: 1rem;
  }
  .lg\\:bottom-4 {
    bottom: 1rem;
  }
  .lg\\:left-4 {
    left: 1rem;
  }
  .lg\\:top-5 {
    top: 1.25rem;
  }
  .lg\\:right-5 {
    right: 1.25rem;
  }
  .lg\\:bottom-5 {
    bottom: 1.25rem;
  }
  .lg\\:left-5 {
    left: 1.25rem;
  }
  .lg\\:top-6 {
    top: 1.5rem;
  }
  .lg\\:right-6 {
    right: 1.5rem;
  }
  .lg\\:bottom-6 {
    bottom: 1.5rem;
  }
  .lg\\:left-6 {
    left: 1.5rem;
  }
  .lg\\:top-7 {
    top: 1.75rem;
  }
  .lg\\:right-7 {
    right: 1.75rem;
  }
  .lg\\:bottom-7 {
    bottom: 1.75rem;
  }
  .lg\\:left-7 {
    left: 1.75rem;
  }
  .lg\\:top-8 {
    top: 2rem;
  }
  .lg\\:right-8 {
    right: 2rem;
  }
  .lg\\:bottom-8 {
    bottom: 2rem;
  }
  .lg\\:left-8 {
    left: 2rem;
  }
  .lg\\:top-9 {
    top: 2.25rem;
  }
  .lg\\:right-9 {
    right: 2.25rem;
  }
  .lg\\:bottom-9 {
    bottom: 2.25rem;
  }
  .lg\\:left-9 {
    left: 2.25rem;
  }
  .lg\\:top-10 {
    top: 2.5rem;
  }
  .lg\\:right-10 {
    right: 2.5rem;
  }
  .lg\\:bottom-10 {
    bottom: 2.5rem;
  }
  .lg\\:left-10 {
    left: 2.5rem;
  }
  .lg\\:top-11 {
    top: 2.75rem;
  }
  .lg\\:right-11 {
    right: 2.75rem;
  }
  .lg\\:bottom-11 {
    bottom: 2.75rem;
  }
  .lg\\:left-11 {
    left: 2.75rem;
  }
  .lg\\:top-12 {
    top: 3rem;
  }
  .lg\\:right-12 {
    right: 3rem;
  }
  .lg\\:bottom-12 {
    bottom: 3rem;
  }
  .lg\\:left-12 {
    left: 3rem;
  }
  .lg\\:top-13 {
    top: 3.25rem;
  }
  .lg\\:right-13 {
    right: 3.25rem;
  }
  .lg\\:bottom-13 {
    bottom: 3.25rem;
  }
  .lg\\:left-13 {
    left: 3.25rem;
  }
  .lg\\:top-14 {
    top: 3.5rem;
  }
  .lg\\:right-14 {
    right: 3.5rem;
  }
  .lg\\:bottom-14 {
    bottom: 3.5rem;
  }
  .lg\\:left-14 {
    left: 3.5rem;
  }
  .lg\\:top-15 {
    top: 3.75rem;
  }
  .lg\\:right-15 {
    right: 3.75rem;
  }
  .lg\\:bottom-15 {
    bottom: 3.75rem;
  }
  .lg\\:left-15 {
    left: 3.75rem;
  }
  .lg\\:top-16 {
    top: 4rem;
  }
  .lg\\:right-16 {
    right: 4rem;
  }
  .lg\\:bottom-16 {
    bottom: 4rem;
  }
  .lg\\:left-16 {
    left: 4rem;
  }
  .lg\\:top-20 {
    top: 5rem;
  }
  .lg\\:right-20 {
    right: 5rem;
  }
  .lg\\:bottom-20 {
    bottom: 5rem;
  }
  .lg\\:left-20 {
    left: 5rem;
  }
  .lg\\:top-24 {
    top: 6rem;
  }
  .lg\\:right-24 {
    right: 6rem;
  }
  .lg\\:bottom-24 {
    bottom: 6rem;
  }
  .lg\\:left-24 {
    left: 6rem;
  }
  .lg\\:top-28 {
    top: 7rem;
  }
  .lg\\:right-28 {
    right: 7rem;
  }
  .lg\\:bottom-28 {
    bottom: 7rem;
  }
  .lg\\:left-28 {
    left: 7rem;
  }
  .lg\\:top-32 {
    top: 8rem;
  }
  .lg\\:right-32 {
    right: 8rem;
  }
  .lg\\:bottom-32 {
    bottom: 8rem;
  }
  .lg\\:left-32 {
    left: 8rem;
  }
  .lg\\:top-36 {
    top: 9rem;
  }
  .lg\\:right-36 {
    right: 9rem;
  }
  .lg\\:bottom-36 {
    bottom: 9rem;
  }
  .lg\\:left-36 {
    left: 9rem;
  }
  .lg\\:top-40 {
    top: 10rem;
  }
  .lg\\:right-40 {
    right: 10rem;
  }
  .lg\\:bottom-40 {
    bottom: 10rem;
  }
  .lg\\:left-40 {
    left: 10rem;
  }
  .lg\\:top-44 {
    top: 11rem;
  }
  .lg\\:right-44 {
    right: 11rem;
  }
  .lg\\:bottom-44 {
    bottom: 11rem;
  }
  .lg\\:left-44 {
    left: 11rem;
  }
  .lg\\:top-48 {
    top: 12rem;
  }
  .lg\\:right-48 {
    right: 12rem;
  }
  .lg\\:bottom-48 {
    bottom: 12rem;
  }
  .lg\\:left-48 {
    left: 12rem;
  }
  .lg\\:top-52 {
    top: 13rem;
  }
  .lg\\:right-52 {
    right: 13rem;
  }
  .lg\\:bottom-52 {
    bottom: 13rem;
  }
  .lg\\:left-52 {
    left: 13rem;
  }
  .lg\\:top-56 {
    top: 14rem;
  }
  .lg\\:right-56 {
    right: 14rem;
  }
  .lg\\:bottom-56 {
    bottom: 14rem;
  }
  .lg\\:left-56 {
    left: 14rem;
  }
  .lg\\:top-60 {
    top: 15rem;
  }
  .lg\\:right-60 {
    right: 15rem;
  }
  .lg\\:bottom-60 {
    bottom: 15rem;
  }
  .lg\\:left-60 {
    left: 15rem;
  }
  .lg\\:top-64 {
    top: 16rem;
  }
  .lg\\:right-64 {
    right: 16rem;
  }
  .lg\\:bottom-64 {
    bottom: 16rem;
  }
  .lg\\:left-64 {
    left: 16rem;
  }
  .lg\\:top-72 {
    top: 18rem;
  }
  .lg\\:right-72 {
    right: 18rem;
  }
  .lg\\:bottom-72 {
    bottom: 18rem;
  }
  .lg\\:left-72 {
    left: 18rem;
  }
  .lg\\:top-80 {
    top: 20rem;
  }
  .lg\\:right-80 {
    right: 20rem;
  }
  .lg\\:bottom-80 {
    bottom: 20rem;
  }
  .lg\\:left-80 {
    left: 20rem;
  }
  .lg\\:top-96 {
    top: 24rem;
  }
  .lg\\:right-96 {
    right: 24rem;
  }
  .lg\\:bottom-96 {
    bottom: 24rem;
  }
  .lg\\:left-96 {
    left: 24rem;
  }
  .lg\\:top-auto {
    top: auto;
  }
  .lg\\:right-auto {
    right: auto;
  }
  .lg\\:bottom-auto {
    bottom: auto;
  }
  .lg\\:left-auto {
    left: auto;
  }
  .lg\\:top-px {
    top: 1px;
  }
  .lg\\:right-px {
    right: 1px;
  }
  .lg\\:bottom-px {
    bottom: 1px;
  }
  .lg\\:left-px {
    left: 1px;
  }
  .lg\\:top-0\\.5 {
    top: 0.125rem;
  }
  .lg\\:right-0\\.5 {
    right: 0.125rem;
  }
  .lg\\:bottom-0\\.5 {
    bottom: 0.125rem;
  }
  .lg\\:left-0\\.5 {
    left: 0.125rem;
  }
  .lg\\:top-1\\.5 {
    top: 0.375rem;
  }
  .lg\\:right-1\\.5 {
    right: 0.375rem;
  }
  .lg\\:bottom-1\\.5 {
    bottom: 0.375rem;
  }
  .lg\\:left-1\\.5 {
    left: 0.375rem;
  }
  .lg\\:top-2\\.5 {
    top: 0.625rem;
  }
  .lg\\:right-2\\.5 {
    right: 0.625rem;
  }
  .lg\\:bottom-2\\.5 {
    bottom: 0.625rem;
  }
  .lg\\:left-2\\.5 {
    left: 0.625rem;
  }
  .lg\\:top-3\\.5 {
    top: 0.875rem;
  }
  .lg\\:right-3\\.5 {
    right: 0.875rem;
  }
  .lg\\:bottom-3\\.5 {
    bottom: 0.875rem;
  }
  .lg\\:left-3\\.5 {
    left: 0.875rem;
  }
  .lg\\:top-1\\/2 {
    top: 50%;
  }
  .lg\\:right-1\\/2 {
    right: 50%;
  }
  .lg\\:bottom-1\\/2 {
    bottom: 50%;
  }
  .lg\\:left-1\\/2 {
    left: 50%;
  }
  .lg\\:top-1\\/3 {
    top: 33.333333%;
  }
  .lg\\:right-1\\/3 {
    right: 33.333333%;
  }
  .lg\\:bottom-1\\/3 {
    bottom: 33.333333%;
  }
  .lg\\:left-1\\/3 {
    left: 33.333333%;
  }
  .lg\\:top-2\\/3 {
    top: 66.666667%;
  }
  .lg\\:right-2\\/3 {
    right: 66.666667%;
  }
  .lg\\:bottom-2\\/3 {
    bottom: 66.666667%;
  }
  .lg\\:left-2\\/3 {
    left: 66.666667%;
  }
  .lg\\:top-1\\/4 {
    top: 25%;
  }
  .lg\\:right-1\\/4 {
    right: 25%;
  }
  .lg\\:bottom-1\\/4 {
    bottom: 25%;
  }
  .lg\\:left-1\\/4 {
    left: 25%;
  }
  .lg\\:top-2\\/4 {
    top: 50%;
  }
  .lg\\:right-2\\/4 {
    right: 50%;
  }
  .lg\\:bottom-2\\/4 {
    bottom: 50%;
  }
  .lg\\:left-2\\/4 {
    left: 50%;
  }
  .lg\\:top-3\\/4 {
    top: 75%;
  }
  .lg\\:right-3\\/4 {
    right: 75%;
  }
  .lg\\:bottom-3\\/4 {
    bottom: 75%;
  }
  .lg\\:left-3\\/4 {
    left: 75%;
  }
  .lg\\:top-1\\/5 {
    top: 20%;
  }
  .lg\\:right-1\\/5 {
    right: 20%;
  }
  .lg\\:bottom-1\\/5 {
    bottom: 20%;
  }
  .lg\\:left-1\\/5 {
    left: 20%;
  }
  .lg\\:top-2\\/5 {
    top: 40%;
  }
  .lg\\:right-2\\/5 {
    right: 40%;
  }
  .lg\\:bottom-2\\/5 {
    bottom: 40%;
  }
  .lg\\:left-2\\/5 {
    left: 40%;
  }
  .lg\\:top-3\\/5 {
    top: 60%;
  }
  .lg\\:right-3\\/5 {
    right: 60%;
  }
  .lg\\:bottom-3\\/5 {
    bottom: 60%;
  }
  .lg\\:left-3\\/5 {
    left: 60%;
  }
  .lg\\:top-4\\/5 {
    top: 80%;
  }
  .lg\\:right-4\\/5 {
    right: 80%;
  }
  .lg\\:bottom-4\\/5 {
    bottom: 80%;
  }
  .lg\\:left-4\\/5 {
    left: 80%;
  }
  .lg\\:top-1\\/6 {
    top: 16.666667%;
  }
  .lg\\:right-1\\/6 {
    right: 16.666667%;
  }
  .lg\\:bottom-1\\/6 {
    bottom: 16.666667%;
  }
  .lg\\:left-1\\/6 {
    left: 16.666667%;
  }
  .lg\\:top-2\\/6 {
    top: 33.333333%;
  }
  .lg\\:right-2\\/6 {
    right: 33.333333%;
  }
  .lg\\:bottom-2\\/6 {
    bottom: 33.333333%;
  }
  .lg\\:left-2\\/6 {
    left: 33.333333%;
  }
  .lg\\:top-3\\/6 {
    top: 50%;
  }
  .lg\\:right-3\\/6 {
    right: 50%;
  }
  .lg\\:bottom-3\\/6 {
    bottom: 50%;
  }
  .lg\\:left-3\\/6 {
    left: 50%;
  }
  .lg\\:top-4\\/6 {
    top: 66.666667%;
  }
  .lg\\:right-4\\/6 {
    right: 66.666667%;
  }
  .lg\\:bottom-4\\/6 {
    bottom: 66.666667%;
  }
  .lg\\:left-4\\/6 {
    left: 66.666667%;
  }
  .lg\\:top-5\\/6 {
    top: 83.333333%;
  }
  .lg\\:right-5\\/6 {
    right: 83.333333%;
  }
  .lg\\:bottom-5\\/6 {
    bottom: 83.333333%;
  }
  .lg\\:left-5\\/6 {
    left: 83.333333%;
  }
  .lg\\:top-1\\/12 {
    top: 8.333333%;
  }
  .lg\\:right-1\\/12 {
    right: 8.333333%;
  }
  .lg\\:bottom-1\\/12 {
    bottom: 8.333333%;
  }
  .lg\\:left-1\\/12 {
    left: 8.333333%;
  }
  .lg\\:top-2\\/12 {
    top: 16.666667%;
  }
  .lg\\:right-2\\/12 {
    right: 16.666667%;
  }
  .lg\\:bottom-2\\/12 {
    bottom: 16.666667%;
  }
  .lg\\:left-2\\/12 {
    left: 16.666667%;
  }
  .lg\\:top-3\\/12 {
    top: 25%;
  }
  .lg\\:right-3\\/12 {
    right: 25%;
  }
  .lg\\:bottom-3\\/12 {
    bottom: 25%;
  }
  .lg\\:left-3\\/12 {
    left: 25%;
  }
  .lg\\:top-4\\/12 {
    top: 33.333333%;
  }
  .lg\\:right-4\\/12 {
    right: 33.333333%;
  }
  .lg\\:bottom-4\\/12 {
    bottom: 33.333333%;
  }
  .lg\\:left-4\\/12 {
    left: 33.333333%;
  }
  .lg\\:top-5\\/12 {
    top: 41.666667%;
  }
  .lg\\:right-5\\/12 {
    right: 41.666667%;
  }
  .lg\\:bottom-5\\/12 {
    bottom: 41.666667%;
  }
  .lg\\:left-5\\/12 {
    left: 41.666667%;
  }
  .lg\\:top-6\\/12 {
    top: 50%;
  }
  .lg\\:right-6\\/12 {
    right: 50%;
  }
  .lg\\:bottom-6\\/12 {
    bottom: 50%;
  }
  .lg\\:left-6\\/12 {
    left: 50%;
  }
  .lg\\:top-7\\/12 {
    top: 58.333333%;
  }
  .lg\\:right-7\\/12 {
    right: 58.333333%;
  }
  .lg\\:bottom-7\\/12 {
    bottom: 58.333333%;
  }
  .lg\\:left-7\\/12 {
    left: 58.333333%;
  }
  .lg\\:top-8\\/12 {
    top: 66.666667%;
  }
  .lg\\:right-8\\/12 {
    right: 66.666667%;
  }
  .lg\\:bottom-8\\/12 {
    bottom: 66.666667%;
  }
  .lg\\:left-8\\/12 {
    left: 66.666667%;
  }
  .lg\\:top-9\\/12 {
    top: 75%;
  }
  .lg\\:right-9\\/12 {
    right: 75%;
  }
  .lg\\:bottom-9\\/12 {
    bottom: 75%;
  }
  .lg\\:left-9\\/12 {
    left: 75%;
  }
  .lg\\:top-10\\/12 {
    top: 83.333333%;
  }
  .lg\\:right-10\\/12 {
    right: 83.333333%;
  }
  .lg\\:bottom-10\\/12 {
    bottom: 83.333333%;
  }
  .lg\\:left-10\\/12 {
    left: 83.333333%;
  }
  .lg\\:top-11\\/12 {
    top: 91.666667%;
  }
  .lg\\:right-11\\/12 {
    right: 91.666667%;
  }
  .lg\\:bottom-11\\/12 {
    bottom: 91.666667%;
  }
  .lg\\:left-11\\/12 {
    left: 91.666667%;
  }
  .lg\\:top-full {
    top: 100%;
  }
  .lg\\:right-full {
    right: 100%;
  }
  .lg\\:bottom-full {
    bottom: 100%;
  }
  .lg\\:left-full {
    left: 100%;
  }
  .lg\\:resize-none {
    resize: none;
  }
  .lg\\:resize-y {
    resize: vertical;
  }
  .lg\\:resize-x {
    resize: horizontal;
  }
  .lg\\:resize {
    resize: both;
  }
  .lg\\:shadow-xs {
    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.05);
  }
  .lg\\:shadow-sm {
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  }
  .lg\\:shadow {
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
  }
  .lg\\:shadow-md {
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  }
  .lg\\:shadow-lg {
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
  }
  .lg\\:shadow-xl {
    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  }
  .lg\\:shadow-2xl {
    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  }
  .lg\\:shadow-inner {
    box-shadow: inset 0 2px 4px 0 rgba(0, 0, 0, 0.06);
  }
  .lg\\:shadow-outline {
    box-shadow: 0 0 0 3px rgba(118, 169, 250, 0.45);
  }
  .lg\\:shadow-none {
    box-shadow: none;
  }
  .lg\\:shadow-solid {
    box-shadow: 0 0 0 2px currentColor;
  }
  .lg\\:shadow-outline-gray {
    box-shadow: 0 0 0 3px rgba(159, 166, 178, 0.45);
  }
  .lg\\:shadow-outline-blue {
    box-shadow: 0 0 0 3px rgba(164, 202, 254, 0.45);
  }
  .lg\\:shadow-outline-teal {
    box-shadow: 0 0 0 3px rgba(126, 220, 226, 0.45);
  }
  .lg\\:shadow-outline-green {
    box-shadow: 0 0 0 3px rgba(132, 225, 188, 0.45);
  }
  .lg\\:shadow-outline-yellow {
    box-shadow: 0 0 0 3px rgba(250, 202, 21, 0.45);
  }
  .lg\\:shadow-outline-orange {
    box-shadow: 0 0 0 3px rgba(253, 186, 140, 0.45);
  }
  .lg\\:shadow-outline-red {
    box-shadow: 0 0 0 3px rgba(248, 180, 180, 0.45);
  }
  .lg\\:shadow-outline-pink {
    box-shadow: 0 0 0 3px rgba(248, 180, 217, 0.45);
  }
  .lg\\:shadow-outline-purple {
    box-shadow: 0 0 0 3px rgba(202, 191, 253, 0.45);
  }
  .lg\\:shadow-outline-indigo {
    box-shadow: 0 0 0 3px rgba(180, 198, 252, 0.45);
  }
  .group:focus .lg\\:group-focus\\:shadow-xs {
    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.05);
  }
  .group:focus .lg\\:group-focus\\:shadow-sm {
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  }
  .group:focus .lg\\:group-focus\\:shadow {
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
  }
  .group:focus .lg\\:group-focus\\:shadow-md {
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  }
  .group:focus .lg\\:group-focus\\:shadow-lg {
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
  }
  .group:focus .lg\\:group-focus\\:shadow-xl {
    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  }
  .group:focus .lg\\:group-focus\\:shadow-2xl {
    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  }
  .group:focus .lg\\:group-focus\\:shadow-inner {
    box-shadow: inset 0 2px 4px 0 rgba(0, 0, 0, 0.06);
  }
  .group:focus .lg\\:group-focus\\:shadow-outline {
    box-shadow: 0 0 0 3px rgba(118, 169, 250, 0.45);
  }
  .group:focus .lg\\:group-focus\\:shadow-none {
    box-shadow: none;
  }
  .group:focus .lg\\:group-focus\\:shadow-solid {
    box-shadow: 0 0 0 2px currentColor;
  }
  .group:focus .lg\\:group-focus\\:shadow-outline-gray {
    box-shadow: 0 0 0 3px rgba(159, 166, 178, 0.45);
  }
  .group:focus .lg\\:group-focus\\:shadow-outline-blue {
    box-shadow: 0 0 0 3px rgba(164, 202, 254, 0.45);
  }
  .group:focus .lg\\:group-focus\\:shadow-outline-teal {
    box-shadow: 0 0 0 3px rgba(126, 220, 226, 0.45);
  }
  .group:focus .lg\\:group-focus\\:shadow-outline-green {
    box-shadow: 0 0 0 3px rgba(132, 225, 188, 0.45);
  }
  .group:focus .lg\\:group-focus\\:shadow-outline-yellow {
    box-shadow: 0 0 0 3px rgba(250, 202, 21, 0.45);
  }
  .group:focus .lg\\:group-focus\\:shadow-outline-orange {
    box-shadow: 0 0 0 3px rgba(253, 186, 140, 0.45);
  }
  .group:focus .lg\\:group-focus\\:shadow-outline-red {
    box-shadow: 0 0 0 3px rgba(248, 180, 180, 0.45);
  }
  .group:focus .lg\\:group-focus\\:shadow-outline-pink {
    box-shadow: 0 0 0 3px rgba(248, 180, 217, 0.45);
  }
  .group:focus .lg\\:group-focus\\:shadow-outline-purple {
    box-shadow: 0 0 0 3px rgba(202, 191, 253, 0.45);
  }
  .group:focus .lg\\:group-focus\\:shadow-outline-indigo {
    box-shadow: 0 0 0 3px rgba(180, 198, 252, 0.45);
  }
  .lg\\:hover\\:shadow-xs:hover {
    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.05);
  }
  .lg\\:hover\\:shadow-sm:hover {
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  }
  .lg\\:hover\\:shadow:hover {
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
  }
  .lg\\:hover\\:shadow-md:hover {
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  }
  .lg\\:hover\\:shadow-lg:hover {
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
  }
  .lg\\:hover\\:shadow-xl:hover {
    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  }
  .lg\\:hover\\:shadow-2xl:hover {
    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  }
  .lg\\:hover\\:shadow-inner:hover {
    box-shadow: inset 0 2px 4px 0 rgba(0, 0, 0, 0.06);
  }
  .lg\\:hover\\:shadow-outline:hover {
    box-shadow: 0 0 0 3px rgba(118, 169, 250, 0.45);
  }
  .lg\\:hover\\:shadow-none:hover {
    box-shadow: none;
  }
  .lg\\:hover\\:shadow-solid:hover {
    box-shadow: 0 0 0 2px currentColor;
  }
  .lg\\:hover\\:shadow-outline-gray:hover {
    box-shadow: 0 0 0 3px rgba(159, 166, 178, 0.45);
  }
  .lg\\:hover\\:shadow-outline-blue:hover {
    box-shadow: 0 0 0 3px rgba(164, 202, 254, 0.45);
  }
  .lg\\:hover\\:shadow-outline-teal:hover {
    box-shadow: 0 0 0 3px rgba(126, 220, 226, 0.45);
  }
  .lg\\:hover\\:shadow-outline-green:hover {
    box-shadow: 0 0 0 3px rgba(132, 225, 188, 0.45);
  }
  .lg\\:hover\\:shadow-outline-yellow:hover {
    box-shadow: 0 0 0 3px rgba(250, 202, 21, 0.45);
  }
  .lg\\:hover\\:shadow-outline-orange:hover {
    box-shadow: 0 0 0 3px rgba(253, 186, 140, 0.45);
  }
  .lg\\:hover\\:shadow-outline-red:hover {
    box-shadow: 0 0 0 3px rgba(248, 180, 180, 0.45);
  }
  .lg\\:hover\\:shadow-outline-pink:hover {
    box-shadow: 0 0 0 3px rgba(248, 180, 217, 0.45);
  }
  .lg\\:hover\\:shadow-outline-purple:hover {
    box-shadow: 0 0 0 3px rgba(202, 191, 253, 0.45);
  }
  .lg\\:hover\\:shadow-outline-indigo:hover {
    box-shadow: 0 0 0 3px rgba(180, 198, 252, 0.45);
  }
  .lg\\:focus-within\\:shadow-xs:focus-within {
    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.05);
  }
  .lg\\:focus-within\\:shadow-sm:focus-within {
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  }
  .lg\\:focus-within\\:shadow:focus-within {
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
  }
  .lg\\:focus-within\\:shadow-md:focus-within {
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  }
  .lg\\:focus-within\\:shadow-lg:focus-within {
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
  }
  .lg\\:focus-within\\:shadow-xl:focus-within {
    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  }
  .lg\\:focus-within\\:shadow-2xl:focus-within {
    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  }
  .lg\\:focus-within\\:shadow-inner:focus-within {
    box-shadow: inset 0 2px 4px 0 rgba(0, 0, 0, 0.06);
  }
  .lg\\:focus-within\\:shadow-outline:focus-within {
    box-shadow: 0 0 0 3px rgba(118, 169, 250, 0.45);
  }
  .lg\\:focus-within\\:shadow-none:focus-within {
    box-shadow: none;
  }
  .lg\\:focus-within\\:shadow-solid:focus-within {
    box-shadow: 0 0 0 2px currentColor;
  }
  .lg\\:focus-within\\:shadow-outline-gray:focus-within {
    box-shadow: 0 0 0 3px rgba(159, 166, 178, 0.45);
  }
  .lg\\:focus-within\\:shadow-outline-blue:focus-within {
    box-shadow: 0 0 0 3px rgba(164, 202, 254, 0.45);
  }
  .lg\\:focus-within\\:shadow-outline-teal:focus-within {
    box-shadow: 0 0 0 3px rgba(126, 220, 226, 0.45);
  }
  .lg\\:focus-within\\:shadow-outline-green:focus-within {
    box-shadow: 0 0 0 3px rgba(132, 225, 188, 0.45);
  }
  .lg\\:focus-within\\:shadow-outline-yellow:focus-within {
    box-shadow: 0 0 0 3px rgba(250, 202, 21, 0.45);
  }
  .lg\\:focus-within\\:shadow-outline-orange:focus-within {
    box-shadow: 0 0 0 3px rgba(253, 186, 140, 0.45);
  }
  .lg\\:focus-within\\:shadow-outline-red:focus-within {
    box-shadow: 0 0 0 3px rgba(248, 180, 180, 0.45);
  }
  .lg\\:focus-within\\:shadow-outline-pink:focus-within {
    box-shadow: 0 0 0 3px rgba(248, 180, 217, 0.45);
  }
  .lg\\:focus-within\\:shadow-outline-purple:focus-within {
    box-shadow: 0 0 0 3px rgba(202, 191, 253, 0.45);
  }
  .lg\\:focus-within\\:shadow-outline-indigo:focus-within {
    box-shadow: 0 0 0 3px rgba(180, 198, 252, 0.45);
  }
  .lg\\:focus\\:shadow-xs:focus {
    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.05);
  }
  .lg\\:focus\\:shadow-sm:focus {
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  }
  .lg\\:focus\\:shadow:focus {
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
  }
  .lg\\:focus\\:shadow-md:focus {
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  }
  .lg\\:focus\\:shadow-lg:focus {
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
  }
  .lg\\:focus\\:shadow-xl:focus {
    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  }
  .lg\\:focus\\:shadow-2xl:focus {
    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  }
  .lg\\:focus\\:shadow-inner:focus {
    box-shadow: inset 0 2px 4px 0 rgba(0, 0, 0, 0.06);
  }
  .lg\\:focus\\:shadow-outline:focus {
    box-shadow: 0 0 0 3px rgba(118, 169, 250, 0.45);
  }
  .lg\\:focus\\:shadow-none:focus {
    box-shadow: none;
  }
  .lg\\:focus\\:shadow-solid:focus {
    box-shadow: 0 0 0 2px currentColor;
  }
  .lg\\:focus\\:shadow-outline-gray:focus {
    box-shadow: 0 0 0 3px rgba(159, 166, 178, 0.45);
  }
  .lg\\:focus\\:shadow-outline-blue:focus {
    box-shadow: 0 0 0 3px rgba(164, 202, 254, 0.45);
  }
  .lg\\:focus\\:shadow-outline-teal:focus {
    box-shadow: 0 0 0 3px rgba(126, 220, 226, 0.45);
  }
  .lg\\:focus\\:shadow-outline-green:focus {
    box-shadow: 0 0 0 3px rgba(132, 225, 188, 0.45);
  }
  .lg\\:focus\\:shadow-outline-yellow:focus {
    box-shadow: 0 0 0 3px rgba(250, 202, 21, 0.45);
  }
  .lg\\:focus\\:shadow-outline-orange:focus {
    box-shadow: 0 0 0 3px rgba(253, 186, 140, 0.45);
  }
  .lg\\:focus\\:shadow-outline-red:focus {
    box-shadow: 0 0 0 3px rgba(248, 180, 180, 0.45);
  }
  .lg\\:focus\\:shadow-outline-pink:focus {
    box-shadow: 0 0 0 3px rgba(248, 180, 217, 0.45);
  }
  .lg\\:focus\\:shadow-outline-purple:focus {
    box-shadow: 0 0 0 3px rgba(202, 191, 253, 0.45);
  }
  .lg\\:focus\\:shadow-outline-indigo:focus {
    box-shadow: 0 0 0 3px rgba(180, 198, 252, 0.45);
  }
  .lg\\:fill-current {
    fill: currentColor;
  }
  .lg\\:stroke-current {
    stroke: currentColor;
  }
  .lg\\:stroke-0 {
    stroke-width: 0;
  }
  .lg\\:stroke-1 {
    stroke-width: 1;
  }
  .lg\\:stroke-2 {
    stroke-width: 2;
  }
  .lg\\:table-auto {
    table-layout: auto;
  }
  .lg\\:table-fixed {
    table-layout: fixed;
  }
  .lg\\:text-left {
    text-align: left;
  }
  .lg\\:text-center {
    text-align: center;
  }
  .lg\\:text-right {
    text-align: right;
  }
  .lg\\:text-justify {
    text-align: justify;
  }
  .lg\\:text-current {
    color: currentColor;
  }
  .lg\\:text-transparent {
    color: transparent;
  }
  .lg\\:text-white {
    --text-opacity: 1;
    color: #ffffff;
    color: rgba(255, 255, 255, var(--text-opacity));
  }
  .lg\\:text-black {
    --text-opacity: 1;
    color: #000000;
    color: rgba(0, 0, 0, var(--text-opacity));
  }
  .lg\\:text-gray-50 {
    --text-opacity: 1;
    color: #f9fafb;
    color: rgba(249, 250, 251, var(--text-opacity));
  }
  .lg\\:text-gray-100 {
    --text-opacity: 1;
    color: #f4f5f7;
    color: rgba(244, 245, 247, var(--text-opacity));
  }
  .lg\\:text-gray-200 {
    --text-opacity: 1;
    color: #e5e7eb;
    color: rgba(229, 231, 235, var(--text-opacity));
  }
  .lg\\:text-gray-300 {
    --text-opacity: 1;
    color: #d2d6dc;
    color: rgba(210, 214, 220, var(--text-opacity));
  }
  .lg\\:text-gray-400 {
    --text-opacity: 1;
    color: #9fa6b2;
    color: rgba(159, 166, 178, var(--text-opacity));
  }
  .lg\\:text-gray-500 {
    --text-opacity: 1;
    color: #6b7280;
    color: rgba(107, 114, 128, var(--text-opacity));
  }
  .lg\\:text-gray-600 {
    --text-opacity: 1;
    color: #4b5563;
    color: rgba(75, 85, 99, var(--text-opacity));
  }
  .lg\\:text-gray-700 {
    --text-opacity: 1;
    color: #374151;
    color: rgba(55, 65, 81, var(--text-opacity));
  }
  .lg\\:text-gray-800 {
    --text-opacity: 1;
    color: #252f3f;
    color: rgba(37, 47, 63, var(--text-opacity));
  }
  .lg\\:text-gray-900 {
    --text-opacity: 1;
    color: #161e2e;
    color: rgba(22, 30, 46, var(--text-opacity));
  }
  .lg\\:text-red-50 {
    --text-opacity: 1;
    color: #fdf2f2;
    color: rgba(253, 242, 242, var(--text-opacity));
  }
  .lg\\:text-red-100 {
    --text-opacity: 1;
    color: #fde8e8;
    color: rgba(253, 232, 232, var(--text-opacity));
  }
  .lg\\:text-red-200 {
    --text-opacity: 1;
    color: #fbd5d5;
    color: rgba(251, 213, 213, var(--text-opacity));
  }
  .lg\\:text-red-300 {
    --text-opacity: 1;
    color: #f8b4b4;
    color: rgba(248, 180, 180, var(--text-opacity));
  }
  .lg\\:text-red-400 {
    --text-opacity: 1;
    color: #f98080;
    color: rgba(249, 128, 128, var(--text-opacity));
  }
  .lg\\:text-red-500 {
    --text-opacity: 1;
    color: #f05252;
    color: rgba(240, 82, 82, var(--text-opacity));
  }
  .lg\\:text-red-600 {
    --text-opacity: 1;
    color: #e02424;
    color: rgba(224, 36, 36, var(--text-opacity));
  }
  .lg\\:text-red-700 {
    --text-opacity: 1;
    color: #c81e1e;
    color: rgba(200, 30, 30, var(--text-opacity));
  }
  .lg\\:text-red-800 {
    --text-opacity: 1;
    color: #9b1c1c;
    color: rgba(155, 28, 28, var(--text-opacity));
  }
  .lg\\:text-red-900 {
    --text-opacity: 1;
    color: #771d1d;
    color: rgba(119, 29, 29, var(--text-opacity));
  }
  .lg\\:text-orange-50 {
    --text-opacity: 1;
    color: #fff8f1;
    color: rgba(255, 248, 241, var(--text-opacity));
  }
  .lg\\:text-orange-100 {
    --text-opacity: 1;
    color: #feecdc;
    color: rgba(254, 236, 220, var(--text-opacity));
  }
  .lg\\:text-orange-200 {
    --text-opacity: 1;
    color: #fcd9bd;
    color: rgba(252, 217, 189, var(--text-opacity));
  }
  .lg\\:text-orange-300 {
    --text-opacity: 1;
    color: #fdba8c;
    color: rgba(253, 186, 140, var(--text-opacity));
  }
  .lg\\:text-orange-400 {
    --text-opacity: 1;
    color: #ff8a4c;
    color: rgba(255, 138, 76, var(--text-opacity));
  }
  .lg\\:text-orange-500 {
    --text-opacity: 1;
    color: #ff5a1f;
    color: rgba(255, 90, 31, var(--text-opacity));
  }
  .lg\\:text-orange-600 {
    --text-opacity: 1;
    color: #d03801;
    color: rgba(208, 56, 1, var(--text-opacity));
  }
  .lg\\:text-orange-700 {
    --text-opacity: 1;
    color: #b43403;
    color: rgba(180, 52, 3, var(--text-opacity));
  }
  .lg\\:text-orange-800 {
    --text-opacity: 1;
    color: #8a2c0d;
    color: rgba(138, 44, 13, var(--text-opacity));
  }
  .lg\\:text-orange-900 {
    --text-opacity: 1;
    color: #73230d;
    color: rgba(115, 35, 13, var(--text-opacity));
  }
  .lg\\:text-yellow-50 {
    --text-opacity: 1;
    color: #fdfdea;
    color: rgba(253, 253, 234, var(--text-opacity));
  }
  .lg\\:text-yellow-100 {
    --text-opacity: 1;
    color: #fdf6b2;
    color: rgba(253, 246, 178, var(--text-opacity));
  }
  .lg\\:text-yellow-200 {
    --text-opacity: 1;
    color: #fce96a;
    color: rgba(252, 233, 106, var(--text-opacity));
  }
  .lg\\:text-yellow-300 {
    --text-opacity: 1;
    color: #faca15;
    color: rgba(250, 202, 21, var(--text-opacity));
  }
  .lg\\:text-yellow-400 {
    --text-opacity: 1;
    color: #e3a008;
    color: rgba(227, 160, 8, var(--text-opacity));
  }
  .lg\\:text-yellow-500 {
    --text-opacity: 1;
    color: #c27803;
    color: rgba(194, 120, 3, var(--text-opacity));
  }
  .lg\\:text-yellow-600 {
    --text-opacity: 1;
    color: #9f580a;
    color: rgba(159, 88, 10, var(--text-opacity));
  }
  .lg\\:text-yellow-700 {
    --text-opacity: 1;
    color: #8e4b10;
    color: rgba(142, 75, 16, var(--text-opacity));
  }
  .lg\\:text-yellow-800 {
    --text-opacity: 1;
    color: #723b13;
    color: rgba(114, 59, 19, var(--text-opacity));
  }
  .lg\\:text-yellow-900 {
    --text-opacity: 1;
    color: #633112;
    color: rgba(99, 49, 18, var(--text-opacity));
  }
  .lg\\:text-green-50 {
    --text-opacity: 1;
    color: #f3faf7;
    color: rgba(243, 250, 247, var(--text-opacity));
  }
  .lg\\:text-green-100 {
    --text-opacity: 1;
    color: #def7ec;
    color: rgba(222, 247, 236, var(--text-opacity));
  }
  .lg\\:text-green-200 {
    --text-opacity: 1;
    color: #bcf0da;
    color: rgba(188, 240, 218, var(--text-opacity));
  }
  .lg\\:text-green-300 {
    --text-opacity: 1;
    color: #84e1bc;
    color: rgba(132, 225, 188, var(--text-opacity));
  }
  .lg\\:text-green-400 {
    --text-opacity: 1;
    color: #31c48d;
    color: rgba(49, 196, 141, var(--text-opacity));
  }
  .lg\\:text-green-500 {
    --text-opacity: 1;
    color: #0e9f6e;
    color: rgba(14, 159, 110, var(--text-opacity));
  }
  .lg\\:text-green-600 {
    --text-opacity: 1;
    color: #057a55;
    color: rgba(5, 122, 85, var(--text-opacity));
  }
  .lg\\:text-green-700 {
    --text-opacity: 1;
    color: #046c4e;
    color: rgba(4, 108, 78, var(--text-opacity));
  }
  .lg\\:text-green-800 {
    --text-opacity: 1;
    color: #03543f;
    color: rgba(3, 84, 63, var(--text-opacity));
  }
  .lg\\:text-green-900 {
    --text-opacity: 1;
    color: #014737;
    color: rgba(1, 71, 55, var(--text-opacity));
  }
  .lg\\:text-teal-50 {
    --text-opacity: 1;
    color: #edfafa;
    color: rgba(237, 250, 250, var(--text-opacity));
  }
  .lg\\:text-teal-100 {
    --text-opacity: 1;
    color: #d5f5f6;
    color: rgba(213, 245, 246, var(--text-opacity));
  }
  .lg\\:text-teal-200 {
    --text-opacity: 1;
    color: #afecef;
    color: rgba(175, 236, 239, var(--text-opacity));
  }
  .lg\\:text-teal-300 {
    --text-opacity: 1;
    color: #7edce2;
    color: rgba(126, 220, 226, var(--text-opacity));
  }
  .lg\\:text-teal-400 {
    --text-opacity: 1;
    color: #16bdca;
    color: rgba(22, 189, 202, var(--text-opacity));
  }
  .lg\\:text-teal-500 {
    --text-opacity: 1;
    color: #0694a2;
    color: rgba(6, 148, 162, var(--text-opacity));
  }
  .lg\\:text-teal-600 {
    --text-opacity: 1;
    color: #047481;
    color: rgba(4, 116, 129, var(--text-opacity));
  }
  .lg\\:text-teal-700 {
    --text-opacity: 1;
    color: #036672;
    color: rgba(3, 102, 114, var(--text-opacity));
  }
  .lg\\:text-teal-800 {
    --text-opacity: 1;
    color: #05505c;
    color: rgba(5, 80, 92, var(--text-opacity));
  }
  .lg\\:text-teal-900 {
    --text-opacity: 1;
    color: #014451;
    color: rgba(1, 68, 81, var(--text-opacity));
  }
  .lg\\:text-blue-50 {
    --text-opacity: 1;
    color: #ebf5ff;
    color: rgba(235, 245, 255, var(--text-opacity));
  }
  .lg\\:text-blue-100 {
    --text-opacity: 1;
    color: #e1effe;
    color: rgba(225, 239, 254, var(--text-opacity));
  }
  .lg\\:text-blue-200 {
    --text-opacity: 1;
    color: #c3ddfd;
    color: rgba(195, 221, 253, var(--text-opacity));
  }
  .lg\\:text-blue-300 {
    --text-opacity: 1;
    color: #a4cafe;
    color: rgba(164, 202, 254, var(--text-opacity));
  }
  .lg\\:text-blue-400 {
    --text-opacity: 1;
    color: #76a9fa;
    color: rgba(118, 169, 250, var(--text-opacity));
  }
  .lg\\:text-blue-500 {
    --text-opacity: 1;
    color: #3f83f8;
    color: rgba(63, 131, 248, var(--text-opacity));
  }
  .lg\\:text-blue-600 {
    --text-opacity: 1;
    color: #1c64f2;
    color: rgba(28, 100, 242, var(--text-opacity));
  }
  .lg\\:text-blue-700 {
    --text-opacity: 1;
    color: #1a56db;
    color: rgba(26, 86, 219, var(--text-opacity));
  }
  .lg\\:text-blue-800 {
    --text-opacity: 1;
    color: #1e429f;
    color: rgba(30, 66, 159, var(--text-opacity));
  }
  .lg\\:text-blue-900 {
    --text-opacity: 1;
    color: #233876;
    color: rgba(35, 56, 118, var(--text-opacity));
  }
  .lg\\:text-indigo-50 {
    --text-opacity: 1;
    color: #f0f5ff;
    color: rgba(240, 245, 255, var(--text-opacity));
  }
  .lg\\:text-indigo-100 {
    --text-opacity: 1;
    color: #e5edff;
    color: rgba(229, 237, 255, var(--text-opacity));
  }
  .lg\\:text-indigo-200 {
    --text-opacity: 1;
    color: #cddbfe;
    color: rgba(205, 219, 254, var(--text-opacity));
  }
  .lg\\:text-indigo-300 {
    --text-opacity: 1;
    color: #b4c6fc;
    color: rgba(180, 198, 252, var(--text-opacity));
  }
  .lg\\:text-indigo-400 {
    --text-opacity: 1;
    color: #8da2fb;
    color: rgba(141, 162, 251, var(--text-opacity));
  }
  .lg\\:text-indigo-500 {
    --text-opacity: 1;
    color: #6875f5;
    color: rgba(104, 117, 245, var(--text-opacity));
  }
  .lg\\:text-indigo-600 {
    --text-opacity: 1;
    color: #5850ec;
    color: rgba(88, 80, 236, var(--text-opacity));
  }
  .lg\\:text-indigo-700 {
    --text-opacity: 1;
    color: #5145cd;
    color: rgba(81, 69, 205, var(--text-opacity));
  }
  .lg\\:text-indigo-800 {
    --text-opacity: 1;
    color: #42389d;
    color: rgba(66, 56, 157, var(--text-opacity));
  }
  .lg\\:text-indigo-900 {
    --text-opacity: 1;
    color: #362f78;
    color: rgba(54, 47, 120, var(--text-opacity));
  }
  .lg\\:text-purple-50 {
    --text-opacity: 1;
    color: #f6f5ff;
    color: rgba(246, 245, 255, var(--text-opacity));
  }
  .lg\\:text-purple-100 {
    --text-opacity: 1;
    color: #edebfe;
    color: rgba(237, 235, 254, var(--text-opacity));
  }
  .lg\\:text-purple-200 {
    --text-opacity: 1;
    color: #dcd7fe;
    color: rgba(220, 215, 254, var(--text-opacity));
  }
  .lg\\:text-purple-300 {
    --text-opacity: 1;
    color: #cabffd;
    color: rgba(202, 191, 253, var(--text-opacity));
  }
  .lg\\:text-purple-400 {
    --text-opacity: 1;
    color: #ac94fa;
    color: rgba(172, 148, 250, var(--text-opacity));
  }
  .lg\\:text-purple-500 {
    --text-opacity: 1;
    color: #9061f9;
    color: rgba(144, 97, 249, var(--text-opacity));
  }
  .lg\\:text-purple-600 {
    --text-opacity: 1;
    color: #7e3af2;
    color: rgba(126, 58, 242, var(--text-opacity));
  }
  .lg\\:text-purple-700 {
    --text-opacity: 1;
    color: #6c2bd9;
    color: rgba(108, 43, 217, var(--text-opacity));
  }
  .lg\\:text-purple-800 {
    --text-opacity: 1;
    color: #5521b5;
    color: rgba(85, 33, 181, var(--text-opacity));
  }
  .lg\\:text-purple-900 {
    --text-opacity: 1;
    color: #4a1d96;
    color: rgba(74, 29, 150, var(--text-opacity));
  }
  .lg\\:text-pink-50 {
    --text-opacity: 1;
    color: #fdf2f8;
    color: rgba(253, 242, 248, var(--text-opacity));
  }
  .lg\\:text-pink-100 {
    --text-opacity: 1;
    color: #fce8f3;
    color: rgba(252, 232, 243, var(--text-opacity));
  }
  .lg\\:text-pink-200 {
    --text-opacity: 1;
    color: #fad1e8;
    color: rgba(250, 209, 232, var(--text-opacity));
  }
  .lg\\:text-pink-300 {
    --text-opacity: 1;
    color: #f8b4d9;
    color: rgba(248, 180, 217, var(--text-opacity));
  }
  .lg\\:text-pink-400 {
    --text-opacity: 1;
    color: #f17eb8;
    color: rgba(241, 126, 184, var(--text-opacity));
  }
  .lg\\:text-pink-500 {
    --text-opacity: 1;
    color: #e74694;
    color: rgba(231, 70, 148, var(--text-opacity));
  }
  .lg\\:text-pink-600 {
    --text-opacity: 1;
    color: #d61f69;
    color: rgba(214, 31, 105, var(--text-opacity));
  }
  .lg\\:text-pink-700 {
    --text-opacity: 1;
    color: #bf125d;
    color: rgba(191, 18, 93, var(--text-opacity));
  }
  .lg\\:text-pink-800 {
    --text-opacity: 1;
    color: #99154b;
    color: rgba(153, 21, 75, var(--text-opacity));
  }
  .lg\\:text-pink-900 {
    --text-opacity: 1;
    color: #751a3d;
    color: rgba(117, 26, 61, var(--text-opacity));
  }
  .lg\\:text-cool-gray-50 {
    --text-opacity: 1;
    color: #f8fafc;
    color: rgba(248, 250, 252, var(--text-opacity));
  }
  .lg\\:text-cool-gray-100 {
    --text-opacity: 1;
    color: #f1f5f9;
    color: rgba(241, 245, 249, var(--text-opacity));
  }
  .lg\\:text-cool-gray-200 {
    --text-opacity: 1;
    color: #e2e8f0;
    color: rgba(226, 232, 240, var(--text-opacity));
  }
  .lg\\:text-cool-gray-300 {
    --text-opacity: 1;
    color: #cfd8e3;
    color: rgba(207, 216, 227, var(--text-opacity));
  }
  .lg\\:text-cool-gray-400 {
    --text-opacity: 1;
    color: #97a6ba;
    color: rgba(151, 166, 186, var(--text-opacity));
  }
  .lg\\:text-cool-gray-500 {
    --text-opacity: 1;
    color: #64748b;
    color: rgba(100, 116, 139, var(--text-opacity));
  }
  .lg\\:text-cool-gray-600 {
    --text-opacity: 1;
    color: #475569;
    color: rgba(71, 85, 105, var(--text-opacity));
  }
  .lg\\:text-cool-gray-700 {
    --text-opacity: 1;
    color: #364152;
    color: rgba(54, 65, 82, var(--text-opacity));
  }
  .lg\\:text-cool-gray-800 {
    --text-opacity: 1;
    color: #27303f;
    color: rgba(39, 48, 63, var(--text-opacity));
  }
  .lg\\:text-cool-gray-900 {
    --text-opacity: 1;
    color: #1a202e;
    color: rgba(26, 32, 46, var(--text-opacity));
  }
  .group:hover .lg\\:group-hover\\:text-current {
    color: currentColor;
  }
  .group:hover .lg\\:group-hover\\:text-transparent {
    color: transparent;
  }
  .group:hover .lg\\:group-hover\\:text-white {
    --text-opacity: 1;
    color: #ffffff;
    color: rgba(255, 255, 255, var(--text-opacity));
  }
  .group:hover .lg\\:group-hover\\:text-black {
    --text-opacity: 1;
    color: #000000;
    color: rgba(0, 0, 0, var(--text-opacity));
  }
  .group:hover .lg\\:group-hover\\:text-gray-50 {
    --text-opacity: 1;
    color: #f9fafb;
    color: rgba(249, 250, 251, var(--text-opacity));
  }
  .group:hover .lg\\:group-hover\\:text-gray-100 {
    --text-opacity: 1;
    color: #f4f5f7;
    color: rgba(244, 245, 247, var(--text-opacity));
  }
  .group:hover .lg\\:group-hover\\:text-gray-200 {
    --text-opacity: 1;
    color: #e5e7eb;
    color: rgba(229, 231, 235, var(--text-opacity));
  }
  .group:hover .lg\\:group-hover\\:text-gray-300 {
    --text-opacity: 1;
    color: #d2d6dc;
    color: rgba(210, 214, 220, var(--text-opacity));
  }
  .group:hover .lg\\:group-hover\\:text-gray-400 {
    --text-opacity: 1;
    color: #9fa6b2;
    color: rgba(159, 166, 178, var(--text-opacity));
  }
  .group:hover .lg\\:group-hover\\:text-gray-500 {
    --text-opacity: 1;
    color: #6b7280;
    color: rgba(107, 114, 128, var(--text-opacity));
  }
  .group:hover .lg\\:group-hover\\:text-gray-600 {
    --text-opacity: 1;
    color: #4b5563;
    color: rgba(75, 85, 99, var(--text-opacity));
  }
  .group:hover .lg\\:group-hover\\:text-gray-700 {
    --text-opacity: 1;
    color: #374151;
    color: rgba(55, 65, 81, var(--text-opacity));
  }
  .group:hover .lg\\:group-hover\\:text-gray-800 {
    --text-opacity: 1;
    color: #252f3f;
    color: rgba(37, 47, 63, var(--text-opacity));
  }
  .group:hover .lg\\:group-hover\\:text-gray-900 {
    --text-opacity: 1;
    color: #161e2e;
    color: rgba(22, 30, 46, var(--text-opacity));
  }
  .group:hover .lg\\:group-hover\\:text-red-50 {
    --text-opacity: 1;
    color: #fdf2f2;
    color: rgba(253, 242, 242, var(--text-opacity));
  }
  .group:hover .lg\\:group-hover\\:text-red-100 {
    --text-opacity: 1;
    color: #fde8e8;
    color: rgba(253, 232, 232, var(--text-opacity));
  }
  .group:hover .lg\\:group-hover\\:text-red-200 {
    --text-opacity: 1;
    color: #fbd5d5;
    color: rgba(251, 213, 213, var(--text-opacity));
  }
  .group:hover .lg\\:group-hover\\:text-red-300 {
    --text-opacity: 1;
    color: #f8b4b4;
    color: rgba(248, 180, 180, var(--text-opacity));
  }
  .group:hover .lg\\:group-hover\\:text-red-400 {
    --text-opacity: 1;
    color: #f98080;
    color: rgba(249, 128, 128, var(--text-opacity));
  }
  .group:hover .lg\\:group-hover\\:text-red-500 {
    --text-opacity: 1;
    color: #f05252;
    color: rgba(240, 82, 82, var(--text-opacity));
  }
  .group:hover .lg\\:group-hover\\:text-red-600 {
    --text-opacity: 1;
    color: #e02424;
    color: rgba(224, 36, 36, var(--text-opacity));
  }
  .group:hover .lg\\:group-hover\\:text-red-700 {
    --text-opacity: 1;
    color: #c81e1e;
    color: rgba(200, 30, 30, var(--text-opacity));
  }
  .group:hover .lg\\:group-hover\\:text-red-800 {
    --text-opacity: 1;
    color: #9b1c1c;
    color: rgba(155, 28, 28, var(--text-opacity));
  }
  .group:hover .lg\\:group-hover\\:text-red-900 {
    --text-opacity: 1;
    color: #771d1d;
    color: rgba(119, 29, 29, var(--text-opacity));
  }
  .group:hover .lg\\:group-hover\\:text-orange-50 {
    --text-opacity: 1;
    color: #fff8f1;
    color: rgba(255, 248, 241, var(--text-opacity));
  }
  .group:hover .lg\\:group-hover\\:text-orange-100 {
    --text-opacity: 1;
    color: #feecdc;
    color: rgba(254, 236, 220, var(--text-opacity));
  }
  .group:hover .lg\\:group-hover\\:text-orange-200 {
    --text-opacity: 1;
    color: #fcd9bd;
    color: rgba(252, 217, 189, var(--text-opacity));
  }
  .group:hover .lg\\:group-hover\\:text-orange-300 {
    --text-opacity: 1;
    color: #fdba8c;
    color: rgba(253, 186, 140, var(--text-opacity));
  }
  .group:hover .lg\\:group-hover\\:text-orange-400 {
    --text-opacity: 1;
    color: #ff8a4c;
    color: rgba(255, 138, 76, var(--text-opacity));
  }
  .group:hover .lg\\:group-hover\\:text-orange-500 {
    --text-opacity: 1;
    color: #ff5a1f;
    color: rgba(255, 90, 31, var(--text-opacity));
  }
  .group:hover .lg\\:group-hover\\:text-orange-600 {
    --text-opacity: 1;
    color: #d03801;
    color: rgba(208, 56, 1, var(--text-opacity));
  }
  .group:hover .lg\\:group-hover\\:text-orange-700 {
    --text-opacity: 1;
    color: #b43403;
    color: rgba(180, 52, 3, var(--text-opacity));
  }
  .group:hover .lg\\:group-hover\\:text-orange-800 {
    --text-opacity: 1;
    color: #8a2c0d;
    color: rgba(138, 44, 13, var(--text-opacity));
  }
  .group:hover .lg\\:group-hover\\:text-orange-900 {
    --text-opacity: 1;
    color: #73230d;
    color: rgba(115, 35, 13, var(--text-opacity));
  }
  .group:hover .lg\\:group-hover\\:text-yellow-50 {
    --text-opacity: 1;
    color: #fdfdea;
    color: rgba(253, 253, 234, var(--text-opacity));
  }
  .group:hover .lg\\:group-hover\\:text-yellow-100 {
    --text-opacity: 1;
    color: #fdf6b2;
    color: rgba(253, 246, 178, var(--text-opacity));
  }
  .group:hover .lg\\:group-hover\\:text-yellow-200 {
    --text-opacity: 1;
    color: #fce96a;
    color: rgba(252, 233, 106, var(--text-opacity));
  }
  .group:hover .lg\\:group-hover\\:text-yellow-300 {
    --text-opacity: 1;
    color: #faca15;
    color: rgba(250, 202, 21, var(--text-opacity));
  }
  .group:hover .lg\\:group-hover\\:text-yellow-400 {
    --text-opacity: 1;
    color: #e3a008;
    color: rgba(227, 160, 8, var(--text-opacity));
  }
  .group:hover .lg\\:group-hover\\:text-yellow-500 {
    --text-opacity: 1;
    color: #c27803;
    color: rgba(194, 120, 3, var(--text-opacity));
  }
  .group:hover .lg\\:group-hover\\:text-yellow-600 {
    --text-opacity: 1;
    color: #9f580a;
    color: rgba(159, 88, 10, var(--text-opacity));
  }
  .group:hover .lg\\:group-hover\\:text-yellow-700 {
    --text-opacity: 1;
    color: #8e4b10;
    color: rgba(142, 75, 16, var(--text-opacity));
  }
  .group:hover .lg\\:group-hover\\:text-yellow-800 {
    --text-opacity: 1;
    color: #723b13;
    color: rgba(114, 59, 19, var(--text-opacity));
  }
  .group:hover .lg\\:group-hover\\:text-yellow-900 {
    --text-opacity: 1;
    color: #633112;
    color: rgba(99, 49, 18, var(--text-opacity));
  }
  .group:hover .lg\\:group-hover\\:text-green-50 {
    --text-opacity: 1;
    color: #f3faf7;
    color: rgba(243, 250, 247, var(--text-opacity));
  }
  .group:hover .lg\\:group-hover\\:text-green-100 {
    --text-opacity: 1;
    color: #def7ec;
    color: rgba(222, 247, 236, var(--text-opacity));
  }
  .group:hover .lg\\:group-hover\\:text-green-200 {
    --text-opacity: 1;
    color: #bcf0da;
    color: rgba(188, 240, 218, var(--text-opacity));
  }
  .group:hover .lg\\:group-hover\\:text-green-300 {
    --text-opacity: 1;
    color: #84e1bc;
    color: rgba(132, 225, 188, var(--text-opacity));
  }
  .group:hover .lg\\:group-hover\\:text-green-400 {
    --text-opacity: 1;
    color: #31c48d;
    color: rgba(49, 196, 141, var(--text-opacity));
  }
  .group:hover .lg\\:group-hover\\:text-green-500 {
    --text-opacity: 1;
    color: #0e9f6e;
    color: rgba(14, 159, 110, var(--text-opacity));
  }
  .group:hover .lg\\:group-hover\\:text-green-600 {
    --text-opacity: 1;
    color: #057a55;
    color: rgba(5, 122, 85, var(--text-opacity));
  }
  .group:hover .lg\\:group-hover\\:text-green-700 {
    --text-opacity: 1;
    color: #046c4e;
    color: rgba(4, 108, 78, var(--text-opacity));
  }
  .group:hover .lg\\:group-hover\\:text-green-800 {
    --text-opacity: 1;
    color: #03543f;
    color: rgba(3, 84, 63, var(--text-opacity));
  }
  .group:hover .lg\\:group-hover\\:text-green-900 {
    --text-opacity: 1;
    color: #014737;
    color: rgba(1, 71, 55, var(--text-opacity));
  }
  .group:hover .lg\\:group-hover\\:text-teal-50 {
    --text-opacity: 1;
    color: #edfafa;
    color: rgba(237, 250, 250, var(--text-opacity));
  }
  .group:hover .lg\\:group-hover\\:text-teal-100 {
    --text-opacity: 1;
    color: #d5f5f6;
    color: rgba(213, 245, 246, var(--text-opacity));
  }
  .group:hover .lg\\:group-hover\\:text-teal-200 {
    --text-opacity: 1;
    color: #afecef;
    color: rgba(175, 236, 239, var(--text-opacity));
  }
  .group:hover .lg\\:group-hover\\:text-teal-300 {
    --text-opacity: 1;
    color: #7edce2;
    color: rgba(126, 220, 226, var(--text-opacity));
  }
  .group:hover .lg\\:group-hover\\:text-teal-400 {
    --text-opacity: 1;
    color: #16bdca;
    color: rgba(22, 189, 202, var(--text-opacity));
  }
  .group:hover .lg\\:group-hover\\:text-teal-500 {
    --text-opacity: 1;
    color: #0694a2;
    color: rgba(6, 148, 162, var(--text-opacity));
  }
  .group:hover .lg\\:group-hover\\:text-teal-600 {
    --text-opacity: 1;
    color: #047481;
    color: rgba(4, 116, 129, var(--text-opacity));
  }
  .group:hover .lg\\:group-hover\\:text-teal-700 {
    --text-opacity: 1;
    color: #036672;
    color: rgba(3, 102, 114, var(--text-opacity));
  }
  .group:hover .lg\\:group-hover\\:text-teal-800 {
    --text-opacity: 1;
    color: #05505c;
    color: rgba(5, 80, 92, var(--text-opacity));
  }
  .group:hover .lg\\:group-hover\\:text-teal-900 {
    --text-opacity: 1;
    color: #014451;
    color: rgba(1, 68, 81, var(--text-opacity));
  }
  .group:hover .lg\\:group-hover\\:text-blue-50 {
    --text-opacity: 1;
    color: #ebf5ff;
    color: rgba(235, 245, 255, var(--text-opacity));
  }
  .group:hover .lg\\:group-hover\\:text-blue-100 {
    --text-opacity: 1;
    color: #e1effe;
    color: rgba(225, 239, 254, var(--text-opacity));
  }
  .group:hover .lg\\:group-hover\\:text-blue-200 {
    --text-opacity: 1;
    color: #c3ddfd;
    color: rgba(195, 221, 253, var(--text-opacity));
  }
  .group:hover .lg\\:group-hover\\:text-blue-300 {
    --text-opacity: 1;
    color: #a4cafe;
    color: rgba(164, 202, 254, var(--text-opacity));
  }
  .group:hover .lg\\:group-hover\\:text-blue-400 {
    --text-opacity: 1;
    color: #76a9fa;
    color: rgba(118, 169, 250, var(--text-opacity));
  }
  .group:hover .lg\\:group-hover\\:text-blue-500 {
    --text-opacity: 1;
    color: #3f83f8;
    color: rgba(63, 131, 248, var(--text-opacity));
  }
  .group:hover .lg\\:group-hover\\:text-blue-600 {
    --text-opacity: 1;
    color: #1c64f2;
    color: rgba(28, 100, 242, var(--text-opacity));
  }
  .group:hover .lg\\:group-hover\\:text-blue-700 {
    --text-opacity: 1;
    color: #1a56db;
    color: rgba(26, 86, 219, var(--text-opacity));
  }
  .group:hover .lg\\:group-hover\\:text-blue-800 {
    --text-opacity: 1;
    color: #1e429f;
    color: rgba(30, 66, 159, var(--text-opacity));
  }
  .group:hover .lg\\:group-hover\\:text-blue-900 {
    --text-opacity: 1;
    color: #233876;
    color: rgba(35, 56, 118, var(--text-opacity));
  }
  .group:hover .lg\\:group-hover\\:text-indigo-50 {
    --text-opacity: 1;
    color: #f0f5ff;
    color: rgba(240, 245, 255, var(--text-opacity));
  }
  .group:hover .lg\\:group-hover\\:text-indigo-100 {
    --text-opacity: 1;
    color: #e5edff;
    color: rgba(229, 237, 255, var(--text-opacity));
  }
  .group:hover .lg\\:group-hover\\:text-indigo-200 {
    --text-opacity: 1;
    color: #cddbfe;
    color: rgba(205, 219, 254, var(--text-opacity));
  }
  .group:hover .lg\\:group-hover\\:text-indigo-300 {
    --text-opacity: 1;
    color: #b4c6fc;
    color: rgba(180, 198, 252, var(--text-opacity));
  }
  .group:hover .lg\\:group-hover\\:text-indigo-400 {
    --text-opacity: 1;
    color: #8da2fb;
    color: rgba(141, 162, 251, var(--text-opacity));
  }
  .group:hover .lg\\:group-hover\\:text-indigo-500 {
    --text-opacity: 1;
    color: #6875f5;
    color: rgba(104, 117, 245, var(--text-opacity));
  }
  .group:hover .lg\\:group-hover\\:text-indigo-600 {
    --text-opacity: 1;
    color: #5850ec;
    color: rgba(88, 80, 236, var(--text-opacity));
  }
  .group:hover .lg\\:group-hover\\:text-indigo-700 {
    --text-opacity: 1;
    color: #5145cd;
    color: rgba(81, 69, 205, var(--text-opacity));
  }
  .group:hover .lg\\:group-hover\\:text-indigo-800 {
    --text-opacity: 1;
    color: #42389d;
    color: rgba(66, 56, 157, var(--text-opacity));
  }
  .group:hover .lg\\:group-hover\\:text-indigo-900 {
    --text-opacity: 1;
    color: #362f78;
    color: rgba(54, 47, 120, var(--text-opacity));
  }
  .group:hover .lg\\:group-hover\\:text-purple-50 {
    --text-opacity: 1;
    color: #f6f5ff;
    color: rgba(246, 245, 255, var(--text-opacity));
  }
  .group:hover .lg\\:group-hover\\:text-purple-100 {
    --text-opacity: 1;
    color: #edebfe;
    color: rgba(237, 235, 254, var(--text-opacity));
  }
  .group:hover .lg\\:group-hover\\:text-purple-200 {
    --text-opacity: 1;
    color: #dcd7fe;
    color: rgba(220, 215, 254, var(--text-opacity));
  }
  .group:hover .lg\\:group-hover\\:text-purple-300 {
    --text-opacity: 1;
    color: #cabffd;
    color: rgba(202, 191, 253, var(--text-opacity));
  }
  .group:hover .lg\\:group-hover\\:text-purple-400 {
    --text-opacity: 1;
    color: #ac94fa;
    color: rgba(172, 148, 250, var(--text-opacity));
  }
  .group:hover .lg\\:group-hover\\:text-purple-500 {
    --text-opacity: 1;
    color: #9061f9;
    color: rgba(144, 97, 249, var(--text-opacity));
  }
  .group:hover .lg\\:group-hover\\:text-purple-600 {
    --text-opacity: 1;
    color: #7e3af2;
    color: rgba(126, 58, 242, var(--text-opacity));
  }
  .group:hover .lg\\:group-hover\\:text-purple-700 {
    --text-opacity: 1;
    color: #6c2bd9;
    color: rgba(108, 43, 217, var(--text-opacity));
  }
  .group:hover .lg\\:group-hover\\:text-purple-800 {
    --text-opacity: 1;
    color: #5521b5;
    color: rgba(85, 33, 181, var(--text-opacity));
  }
  .group:hover .lg\\:group-hover\\:text-purple-900 {
    --text-opacity: 1;
    color: #4a1d96;
    color: rgba(74, 29, 150, var(--text-opacity));
  }
  .group:hover .lg\\:group-hover\\:text-pink-50 {
    --text-opacity: 1;
    color: #fdf2f8;
    color: rgba(253, 242, 248, var(--text-opacity));
  }
  .group:hover .lg\\:group-hover\\:text-pink-100 {
    --text-opacity: 1;
    color: #fce8f3;
    color: rgba(252, 232, 243, var(--text-opacity));
  }
  .group:hover .lg\\:group-hover\\:text-pink-200 {
    --text-opacity: 1;
    color: #fad1e8;
    color: rgba(250, 209, 232, var(--text-opacity));
  }
  .group:hover .lg\\:group-hover\\:text-pink-300 {
    --text-opacity: 1;
    color: #f8b4d9;
    color: rgba(248, 180, 217, var(--text-opacity));
  }
  .group:hover .lg\\:group-hover\\:text-pink-400 {
    --text-opacity: 1;
    color: #f17eb8;
    color: rgba(241, 126, 184, var(--text-opacity));
  }
  .group:hover .lg\\:group-hover\\:text-pink-500 {
    --text-opacity: 1;
    color: #e74694;
    color: rgba(231, 70, 148, var(--text-opacity));
  }
  .group:hover .lg\\:group-hover\\:text-pink-600 {
    --text-opacity: 1;
    color: #d61f69;
    color: rgba(214, 31, 105, var(--text-opacity));
  }
  .group:hover .lg\\:group-hover\\:text-pink-700 {
    --text-opacity: 1;
    color: #bf125d;
    color: rgba(191, 18, 93, var(--text-opacity));
  }
  .group:hover .lg\\:group-hover\\:text-pink-800 {
    --text-opacity: 1;
    color: #99154b;
    color: rgba(153, 21, 75, var(--text-opacity));
  }
  .group:hover .lg\\:group-hover\\:text-pink-900 {
    --text-opacity: 1;
    color: #751a3d;
    color: rgba(117, 26, 61, var(--text-opacity));
  }
  .group:hover .lg\\:group-hover\\:text-cool-gray-50 {
    --text-opacity: 1;
    color: #f8fafc;
    color: rgba(248, 250, 252, var(--text-opacity));
  }
  .group:hover .lg\\:group-hover\\:text-cool-gray-100 {
    --text-opacity: 1;
    color: #f1f5f9;
    color: rgba(241, 245, 249, var(--text-opacity));
  }
  .group:hover .lg\\:group-hover\\:text-cool-gray-200 {
    --text-opacity: 1;
    color: #e2e8f0;
    color: rgba(226, 232, 240, var(--text-opacity));
  }
  .group:hover .lg\\:group-hover\\:text-cool-gray-300 {
    --text-opacity: 1;
    color: #cfd8e3;
    color: rgba(207, 216, 227, var(--text-opacity));
  }
  .group:hover .lg\\:group-hover\\:text-cool-gray-400 {
    --text-opacity: 1;
    color: #97a6ba;
    color: rgba(151, 166, 186, var(--text-opacity));
  }
  .group:hover .lg\\:group-hover\\:text-cool-gray-500 {
    --text-opacity: 1;
    color: #64748b;
    color: rgba(100, 116, 139, var(--text-opacity));
  }
  .group:hover .lg\\:group-hover\\:text-cool-gray-600 {
    --text-opacity: 1;
    color: #475569;
    color: rgba(71, 85, 105, var(--text-opacity));
  }
  .group:hover .lg\\:group-hover\\:text-cool-gray-700 {
    --text-opacity: 1;
    color: #364152;
    color: rgba(54, 65, 82, var(--text-opacity));
  }
  .group:hover .lg\\:group-hover\\:text-cool-gray-800 {
    --text-opacity: 1;
    color: #27303f;
    color: rgba(39, 48, 63, var(--text-opacity));
  }
  .group:hover .lg\\:group-hover\\:text-cool-gray-900 {
    --text-opacity: 1;
    color: #1a202e;
    color: rgba(26, 32, 46, var(--text-opacity));
  }
  .group:focus .lg\\:group-focus\\:text-current {
    color: currentColor;
  }
  .group:focus .lg\\:group-focus\\:text-transparent {
    color: transparent;
  }
  .group:focus .lg\\:group-focus\\:text-white {
    --text-opacity: 1;
    color: #ffffff;
    color: rgba(255, 255, 255, var(--text-opacity));
  }
  .group:focus .lg\\:group-focus\\:text-black {
    --text-opacity: 1;
    color: #000000;
    color: rgba(0, 0, 0, var(--text-opacity));
  }
  .group:focus .lg\\:group-focus\\:text-gray-50 {
    --text-opacity: 1;
    color: #f9fafb;
    color: rgba(249, 250, 251, var(--text-opacity));
  }
  .group:focus .lg\\:group-focus\\:text-gray-100 {
    --text-opacity: 1;
    color: #f4f5f7;
    color: rgba(244, 245, 247, var(--text-opacity));
  }
  .group:focus .lg\\:group-focus\\:text-gray-200 {
    --text-opacity: 1;
    color: #e5e7eb;
    color: rgba(229, 231, 235, var(--text-opacity));
  }
  .group:focus .lg\\:group-focus\\:text-gray-300 {
    --text-opacity: 1;
    color: #d2d6dc;
    color: rgba(210, 214, 220, var(--text-opacity));
  }
  .group:focus .lg\\:group-focus\\:text-gray-400 {
    --text-opacity: 1;
    color: #9fa6b2;
    color: rgba(159, 166, 178, var(--text-opacity));
  }
  .group:focus .lg\\:group-focus\\:text-gray-500 {
    --text-opacity: 1;
    color: #6b7280;
    color: rgba(107, 114, 128, var(--text-opacity));
  }
  .group:focus .lg\\:group-focus\\:text-gray-600 {
    --text-opacity: 1;
    color: #4b5563;
    color: rgba(75, 85, 99, var(--text-opacity));
  }
  .group:focus .lg\\:group-focus\\:text-gray-700 {
    --text-opacity: 1;
    color: #374151;
    color: rgba(55, 65, 81, var(--text-opacity));
  }
  .group:focus .lg\\:group-focus\\:text-gray-800 {
    --text-opacity: 1;
    color: #252f3f;
    color: rgba(37, 47, 63, var(--text-opacity));
  }
  .group:focus .lg\\:group-focus\\:text-gray-900 {
    --text-opacity: 1;
    color: #161e2e;
    color: rgba(22, 30, 46, var(--text-opacity));
  }
  .group:focus .lg\\:group-focus\\:text-red-50 {
    --text-opacity: 1;
    color: #fdf2f2;
    color: rgba(253, 242, 242, var(--text-opacity));
  }
  .group:focus .lg\\:group-focus\\:text-red-100 {
    --text-opacity: 1;
    color: #fde8e8;
    color: rgba(253, 232, 232, var(--text-opacity));
  }
  .group:focus .lg\\:group-focus\\:text-red-200 {
    --text-opacity: 1;
    color: #fbd5d5;
    color: rgba(251, 213, 213, var(--text-opacity));
  }
  .group:focus .lg\\:group-focus\\:text-red-300 {
    --text-opacity: 1;
    color: #f8b4b4;
    color: rgba(248, 180, 180, var(--text-opacity));
  }
  .group:focus .lg\\:group-focus\\:text-red-400 {
    --text-opacity: 1;
    color: #f98080;
    color: rgba(249, 128, 128, var(--text-opacity));
  }
  .group:focus .lg\\:group-focus\\:text-red-500 {
    --text-opacity: 1;
    color: #f05252;
    color: rgba(240, 82, 82, var(--text-opacity));
  }
  .group:focus .lg\\:group-focus\\:text-red-600 {
    --text-opacity: 1;
    color: #e02424;
    color: rgba(224, 36, 36, var(--text-opacity));
  }
  .group:focus .lg\\:group-focus\\:text-red-700 {
    --text-opacity: 1;
    color: #c81e1e;
    color: rgba(200, 30, 30, var(--text-opacity));
  }
  .group:focus .lg\\:group-focus\\:text-red-800 {
    --text-opacity: 1;
    color: #9b1c1c;
    color: rgba(155, 28, 28, var(--text-opacity));
  }
  .group:focus .lg\\:group-focus\\:text-red-900 {
    --text-opacity: 1;
    color: #771d1d;
    color: rgba(119, 29, 29, var(--text-opacity));
  }
  .group:focus .lg\\:group-focus\\:text-orange-50 {
    --text-opacity: 1;
    color: #fff8f1;
    color: rgba(255, 248, 241, var(--text-opacity));
  }
  .group:focus .lg\\:group-focus\\:text-orange-100 {
    --text-opacity: 1;
    color: #feecdc;
    color: rgba(254, 236, 220, var(--text-opacity));
  }
  .group:focus .lg\\:group-focus\\:text-orange-200 {
    --text-opacity: 1;
    color: #fcd9bd;
    color: rgba(252, 217, 189, var(--text-opacity));
  }
  .group:focus .lg\\:group-focus\\:text-orange-300 {
    --text-opacity: 1;
    color: #fdba8c;
    color: rgba(253, 186, 140, var(--text-opacity));
  }
  .group:focus .lg\\:group-focus\\:text-orange-400 {
    --text-opacity: 1;
    color: #ff8a4c;
    color: rgba(255, 138, 76, var(--text-opacity));
  }
  .group:focus .lg\\:group-focus\\:text-orange-500 {
    --text-opacity: 1;
    color: #ff5a1f;
    color: rgba(255, 90, 31, var(--text-opacity));
  }
  .group:focus .lg\\:group-focus\\:text-orange-600 {
    --text-opacity: 1;
    color: #d03801;
    color: rgba(208, 56, 1, var(--text-opacity));
  }
  .group:focus .lg\\:group-focus\\:text-orange-700 {
    --text-opacity: 1;
    color: #b43403;
    color: rgba(180, 52, 3, var(--text-opacity));
  }
  .group:focus .lg\\:group-focus\\:text-orange-800 {
    --text-opacity: 1;
    color: #8a2c0d;
    color: rgba(138, 44, 13, var(--text-opacity));
  }
  .group:focus .lg\\:group-focus\\:text-orange-900 {
    --text-opacity: 1;
    color: #73230d;
    color: rgba(115, 35, 13, var(--text-opacity));
  }
  .group:focus .lg\\:group-focus\\:text-yellow-50 {
    --text-opacity: 1;
    color: #fdfdea;
    color: rgba(253, 253, 234, var(--text-opacity));
  }
  .group:focus .lg\\:group-focus\\:text-yellow-100 {
    --text-opacity: 1;
    color: #fdf6b2;
    color: rgba(253, 246, 178, var(--text-opacity));
  }
  .group:focus .lg\\:group-focus\\:text-yellow-200 {
    --text-opacity: 1;
    color: #fce96a;
    color: rgba(252, 233, 106, var(--text-opacity));
  }
  .group:focus .lg\\:group-focus\\:text-yellow-300 {
    --text-opacity: 1;
    color: #faca15;
    color: rgba(250, 202, 21, var(--text-opacity));
  }
  .group:focus .lg\\:group-focus\\:text-yellow-400 {
    --text-opacity: 1;
    color: #e3a008;
    color: rgba(227, 160, 8, var(--text-opacity));
  }
  .group:focus .lg\\:group-focus\\:text-yellow-500 {
    --text-opacity: 1;
    color: #c27803;
    color: rgba(194, 120, 3, var(--text-opacity));
  }
  .group:focus .lg\\:group-focus\\:text-yellow-600 {
    --text-opacity: 1;
    color: #9f580a;
    color: rgba(159, 88, 10, var(--text-opacity));
  }
  .group:focus .lg\\:group-focus\\:text-yellow-700 {
    --text-opacity: 1;
    color: #8e4b10;
    color: rgba(142, 75, 16, var(--text-opacity));
  }
  .group:focus .lg\\:group-focus\\:text-yellow-800 {
    --text-opacity: 1;
    color: #723b13;
    color: rgba(114, 59, 19, var(--text-opacity));
  }
  .group:focus .lg\\:group-focus\\:text-yellow-900 {
    --text-opacity: 1;
    color: #633112;
    color: rgba(99, 49, 18, var(--text-opacity));
  }
  .group:focus .lg\\:group-focus\\:text-green-50 {
    --text-opacity: 1;
    color: #f3faf7;
    color: rgba(243, 250, 247, var(--text-opacity));
  }
  .group:focus .lg\\:group-focus\\:text-green-100 {
    --text-opacity: 1;
    color: #def7ec;
    color: rgba(222, 247, 236, var(--text-opacity));
  }
  .group:focus .lg\\:group-focus\\:text-green-200 {
    --text-opacity: 1;
    color: #bcf0da;
    color: rgba(188, 240, 218, var(--text-opacity));
  }
  .group:focus .lg\\:group-focus\\:text-green-300 {
    --text-opacity: 1;
    color: #84e1bc;
    color: rgba(132, 225, 188, var(--text-opacity));
  }
  .group:focus .lg\\:group-focus\\:text-green-400 {
    --text-opacity: 1;
    color: #31c48d;
    color: rgba(49, 196, 141, var(--text-opacity));
  }
  .group:focus .lg\\:group-focus\\:text-green-500 {
    --text-opacity: 1;
    color: #0e9f6e;
    color: rgba(14, 159, 110, var(--text-opacity));
  }
  .group:focus .lg\\:group-focus\\:text-green-600 {
    --text-opacity: 1;
    color: #057a55;
    color: rgba(5, 122, 85, var(--text-opacity));
  }
  .group:focus .lg\\:group-focus\\:text-green-700 {
    --text-opacity: 1;
    color: #046c4e;
    color: rgba(4, 108, 78, var(--text-opacity));
  }
  .group:focus .lg\\:group-focus\\:text-green-800 {
    --text-opacity: 1;
    color: #03543f;
    color: rgba(3, 84, 63, var(--text-opacity));
  }
  .group:focus .lg\\:group-focus\\:text-green-900 {
    --text-opacity: 1;
    color: #014737;
    color: rgba(1, 71, 55, var(--text-opacity));
  }
  .group:focus .lg\\:group-focus\\:text-teal-50 {
    --text-opacity: 1;
    color: #edfafa;
    color: rgba(237, 250, 250, var(--text-opacity));
  }
  .group:focus .lg\\:group-focus\\:text-teal-100 {
    --text-opacity: 1;
    color: #d5f5f6;
    color: rgba(213, 245, 246, var(--text-opacity));
  }
  .group:focus .lg\\:group-focus\\:text-teal-200 {
    --text-opacity: 1;
    color: #afecef;
    color: rgba(175, 236, 239, var(--text-opacity));
  }
  .group:focus .lg\\:group-focus\\:text-teal-300 {
    --text-opacity: 1;
    color: #7edce2;
    color: rgba(126, 220, 226, var(--text-opacity));
  }
  .group:focus .lg\\:group-focus\\:text-teal-400 {
    --text-opacity: 1;
    color: #16bdca;
    color: rgba(22, 189, 202, var(--text-opacity));
  }
  .group:focus .lg\\:group-focus\\:text-teal-500 {
    --text-opacity: 1;
    color: #0694a2;
    color: rgba(6, 148, 162, var(--text-opacity));
  }
  .group:focus .lg\\:group-focus\\:text-teal-600 {
    --text-opacity: 1;
    color: #047481;
    color: rgba(4, 116, 129, var(--text-opacity));
  }
  .group:focus .lg\\:group-focus\\:text-teal-700 {
    --text-opacity: 1;
    color: #036672;
    color: rgba(3, 102, 114, var(--text-opacity));
  }
  .group:focus .lg\\:group-focus\\:text-teal-800 {
    --text-opacity: 1;
    color: #05505c;
    color: rgba(5, 80, 92, var(--text-opacity));
  }
  .group:focus .lg\\:group-focus\\:text-teal-900 {
    --text-opacity: 1;
    color: #014451;
    color: rgba(1, 68, 81, var(--text-opacity));
  }
  .group:focus .lg\\:group-focus\\:text-blue-50 {
    --text-opacity: 1;
    color: #ebf5ff;
    color: rgba(235, 245, 255, var(--text-opacity));
  }
  .group:focus .lg\\:group-focus\\:text-blue-100 {
    --text-opacity: 1;
    color: #e1effe;
    color: rgba(225, 239, 254, var(--text-opacity));
  }
  .group:focus .lg\\:group-focus\\:text-blue-200 {
    --text-opacity: 1;
    color: #c3ddfd;
    color: rgba(195, 221, 253, var(--text-opacity));
  }
  .group:focus .lg\\:group-focus\\:text-blue-300 {
    --text-opacity: 1;
    color: #a4cafe;
    color: rgba(164, 202, 254, var(--text-opacity));
  }
  .group:focus .lg\\:group-focus\\:text-blue-400 {
    --text-opacity: 1;
    color: #76a9fa;
    color: rgba(118, 169, 250, var(--text-opacity));
  }
  .group:focus .lg\\:group-focus\\:text-blue-500 {
    --text-opacity: 1;
    color: #3f83f8;
    color: rgba(63, 131, 248, var(--text-opacity));
  }
  .group:focus .lg\\:group-focus\\:text-blue-600 {
    --text-opacity: 1;
    color: #1c64f2;
    color: rgba(28, 100, 242, var(--text-opacity));
  }
  .group:focus .lg\\:group-focus\\:text-blue-700 {
    --text-opacity: 1;
    color: #1a56db;
    color: rgba(26, 86, 219, var(--text-opacity));
  }
  .group:focus .lg\\:group-focus\\:text-blue-800 {
    --text-opacity: 1;
    color: #1e429f;
    color: rgba(30, 66, 159, var(--text-opacity));
  }
  .group:focus .lg\\:group-focus\\:text-blue-900 {
    --text-opacity: 1;
    color: #233876;
    color: rgba(35, 56, 118, var(--text-opacity));
  }
  .group:focus .lg\\:group-focus\\:text-indigo-50 {
    --text-opacity: 1;
    color: #f0f5ff;
    color: rgba(240, 245, 255, var(--text-opacity));
  }
  .group:focus .lg\\:group-focus\\:text-indigo-100 {
    --text-opacity: 1;
    color: #e5edff;
    color: rgba(229, 237, 255, var(--text-opacity));
  }
  .group:focus .lg\\:group-focus\\:text-indigo-200 {
    --text-opacity: 1;
    color: #cddbfe;
    color: rgba(205, 219, 254, var(--text-opacity));
  }
  .group:focus .lg\\:group-focus\\:text-indigo-300 {
    --text-opacity: 1;
    color: #b4c6fc;
    color: rgba(180, 198, 252, var(--text-opacity));
  }
  .group:focus .lg\\:group-focus\\:text-indigo-400 {
    --text-opacity: 1;
    color: #8da2fb;
    color: rgba(141, 162, 251, var(--text-opacity));
  }
  .group:focus .lg\\:group-focus\\:text-indigo-500 {
    --text-opacity: 1;
    color: #6875f5;
    color: rgba(104, 117, 245, var(--text-opacity));
  }
  .group:focus .lg\\:group-focus\\:text-indigo-600 {
    --text-opacity: 1;
    color: #5850ec;
    color: rgba(88, 80, 236, var(--text-opacity));
  }
  .group:focus .lg\\:group-focus\\:text-indigo-700 {
    --text-opacity: 1;
    color: #5145cd;
    color: rgba(81, 69, 205, var(--text-opacity));
  }
  .group:focus .lg\\:group-focus\\:text-indigo-800 {
    --text-opacity: 1;
    color: #42389d;
    color: rgba(66, 56, 157, var(--text-opacity));
  }
  .group:focus .lg\\:group-focus\\:text-indigo-900 {
    --text-opacity: 1;
    color: #362f78;
    color: rgba(54, 47, 120, var(--text-opacity));
  }
  .group:focus .lg\\:group-focus\\:text-purple-50 {
    --text-opacity: 1;
    color: #f6f5ff;
    color: rgba(246, 245, 255, var(--text-opacity));
  }
  .group:focus .lg\\:group-focus\\:text-purple-100 {
    --text-opacity: 1;
    color: #edebfe;
    color: rgba(237, 235, 254, var(--text-opacity));
  }
  .group:focus .lg\\:group-focus\\:text-purple-200 {
    --text-opacity: 1;
    color: #dcd7fe;
    color: rgba(220, 215, 254, var(--text-opacity));
  }
  .group:focus .lg\\:group-focus\\:text-purple-300 {
    --text-opacity: 1;
    color: #cabffd;
    color: rgba(202, 191, 253, var(--text-opacity));
  }
  .group:focus .lg\\:group-focus\\:text-purple-400 {
    --text-opacity: 1;
    color: #ac94fa;
    color: rgba(172, 148, 250, var(--text-opacity));
  }
  .group:focus .lg\\:group-focus\\:text-purple-500 {
    --text-opacity: 1;
    color: #9061f9;
    color: rgba(144, 97, 249, var(--text-opacity));
  }
  .group:focus .lg\\:group-focus\\:text-purple-600 {
    --text-opacity: 1;
    color: #7e3af2;
    color: rgba(126, 58, 242, var(--text-opacity));
  }
  .group:focus .lg\\:group-focus\\:text-purple-700 {
    --text-opacity: 1;
    color: #6c2bd9;
    color: rgba(108, 43, 217, var(--text-opacity));
  }
  .group:focus .lg\\:group-focus\\:text-purple-800 {
    --text-opacity: 1;
    color: #5521b5;
    color: rgba(85, 33, 181, var(--text-opacity));
  }
  .group:focus .lg\\:group-focus\\:text-purple-900 {
    --text-opacity: 1;
    color: #4a1d96;
    color: rgba(74, 29, 150, var(--text-opacity));
  }
  .group:focus .lg\\:group-focus\\:text-pink-50 {
    --text-opacity: 1;
    color: #fdf2f8;
    color: rgba(253, 242, 248, var(--text-opacity));
  }
  .group:focus .lg\\:group-focus\\:text-pink-100 {
    --text-opacity: 1;
    color: #fce8f3;
    color: rgba(252, 232, 243, var(--text-opacity));
  }
  .group:focus .lg\\:group-focus\\:text-pink-200 {
    --text-opacity: 1;
    color: #fad1e8;
    color: rgba(250, 209, 232, var(--text-opacity));
  }
  .group:focus .lg\\:group-focus\\:text-pink-300 {
    --text-opacity: 1;
    color: #f8b4d9;
    color: rgba(248, 180, 217, var(--text-opacity));
  }
  .group:focus .lg\\:group-focus\\:text-pink-400 {
    --text-opacity: 1;
    color: #f17eb8;
    color: rgba(241, 126, 184, var(--text-opacity));
  }
  .group:focus .lg\\:group-focus\\:text-pink-500 {
    --text-opacity: 1;
    color: #e74694;
    color: rgba(231, 70, 148, var(--text-opacity));
  }
  .group:focus .lg\\:group-focus\\:text-pink-600 {
    --text-opacity: 1;
    color: #d61f69;
    color: rgba(214, 31, 105, var(--text-opacity));
  }
  .group:focus .lg\\:group-focus\\:text-pink-700 {
    --text-opacity: 1;
    color: #bf125d;
    color: rgba(191, 18, 93, var(--text-opacity));
  }
  .group:focus .lg\\:group-focus\\:text-pink-800 {
    --text-opacity: 1;
    color: #99154b;
    color: rgba(153, 21, 75, var(--text-opacity));
  }
  .group:focus .lg\\:group-focus\\:text-pink-900 {
    --text-opacity: 1;
    color: #751a3d;
    color: rgba(117, 26, 61, var(--text-opacity));
  }
  .group:focus .lg\\:group-focus\\:text-cool-gray-50 {
    --text-opacity: 1;
    color: #f8fafc;
    color: rgba(248, 250, 252, var(--text-opacity));
  }
  .group:focus .lg\\:group-focus\\:text-cool-gray-100 {
    --text-opacity: 1;
    color: #f1f5f9;
    color: rgba(241, 245, 249, var(--text-opacity));
  }
  .group:focus .lg\\:group-focus\\:text-cool-gray-200 {
    --text-opacity: 1;
    color: #e2e8f0;
    color: rgba(226, 232, 240, var(--text-opacity));
  }
  .group:focus .lg\\:group-focus\\:text-cool-gray-300 {
    --text-opacity: 1;
    color: #cfd8e3;
    color: rgba(207, 216, 227, var(--text-opacity));
  }
  .group:focus .lg\\:group-focus\\:text-cool-gray-400 {
    --text-opacity: 1;
    color: #97a6ba;
    color: rgba(151, 166, 186, var(--text-opacity));
  }
  .group:focus .lg\\:group-focus\\:text-cool-gray-500 {
    --text-opacity: 1;
    color: #64748b;
    color: rgba(100, 116, 139, var(--text-opacity));
  }
  .group:focus .lg\\:group-focus\\:text-cool-gray-600 {
    --text-opacity: 1;
    color: #475569;
    color: rgba(71, 85, 105, var(--text-opacity));
  }
  .group:focus .lg\\:group-focus\\:text-cool-gray-700 {
    --text-opacity: 1;
    color: #364152;
    color: rgba(54, 65, 82, var(--text-opacity));
  }
  .group:focus .lg\\:group-focus\\:text-cool-gray-800 {
    --text-opacity: 1;
    color: #27303f;
    color: rgba(39, 48, 63, var(--text-opacity));
  }
  .group:focus .lg\\:group-focus\\:text-cool-gray-900 {
    --text-opacity: 1;
    color: #1a202e;
    color: rgba(26, 32, 46, var(--text-opacity));
  }
  .lg\\:hover\\:text-current:hover {
    color: currentColor;
  }
  .lg\\:hover\\:text-transparent:hover {
    color: transparent;
  }
  .lg\\:hover\\:text-white:hover {
    --text-opacity: 1;
    color: #ffffff;
    color: rgba(255, 255, 255, var(--text-opacity));
  }
  .lg\\:hover\\:text-black:hover {
    --text-opacity: 1;
    color: #000000;
    color: rgba(0, 0, 0, var(--text-opacity));
  }
  .lg\\:hover\\:text-gray-50:hover {
    --text-opacity: 1;
    color: #f9fafb;
    color: rgba(249, 250, 251, var(--text-opacity));
  }
  .lg\\:hover\\:text-gray-100:hover {
    --text-opacity: 1;
    color: #f4f5f7;
    color: rgba(244, 245, 247, var(--text-opacity));
  }
  .lg\\:hover\\:text-gray-200:hover {
    --text-opacity: 1;
    color: #e5e7eb;
    color: rgba(229, 231, 235, var(--text-opacity));
  }
  .lg\\:hover\\:text-gray-300:hover {
    --text-opacity: 1;
    color: #d2d6dc;
    color: rgba(210, 214, 220, var(--text-opacity));
  }
  .lg\\:hover\\:text-gray-400:hover {
    --text-opacity: 1;
    color: #9fa6b2;
    color: rgba(159, 166, 178, var(--text-opacity));
  }
  .lg\\:hover\\:text-gray-500:hover {
    --text-opacity: 1;
    color: #6b7280;
    color: rgba(107, 114, 128, var(--text-opacity));
  }
  .lg\\:hover\\:text-gray-600:hover {
    --text-opacity: 1;
    color: #4b5563;
    color: rgba(75, 85, 99, var(--text-opacity));
  }
  .lg\\:hover\\:text-gray-700:hover {
    --text-opacity: 1;
    color: #374151;
    color: rgba(55, 65, 81, var(--text-opacity));
  }
  .lg\\:hover\\:text-gray-800:hover {
    --text-opacity: 1;
    color: #252f3f;
    color: rgba(37, 47, 63, var(--text-opacity));
  }
  .lg\\:hover\\:text-gray-900:hover {
    --text-opacity: 1;
    color: #161e2e;
    color: rgba(22, 30, 46, var(--text-opacity));
  }
  .lg\\:hover\\:text-red-50:hover {
    --text-opacity: 1;
    color: #fdf2f2;
    color: rgba(253, 242, 242, var(--text-opacity));
  }
  .lg\\:hover\\:text-red-100:hover {
    --text-opacity: 1;
    color: #fde8e8;
    color: rgba(253, 232, 232, var(--text-opacity));
  }
  .lg\\:hover\\:text-red-200:hover {
    --text-opacity: 1;
    color: #fbd5d5;
    color: rgba(251, 213, 213, var(--text-opacity));
  }
  .lg\\:hover\\:text-red-300:hover {
    --text-opacity: 1;
    color: #f8b4b4;
    color: rgba(248, 180, 180, var(--text-opacity));
  }
  .lg\\:hover\\:text-red-400:hover {
    --text-opacity: 1;
    color: #f98080;
    color: rgba(249, 128, 128, var(--text-opacity));
  }
  .lg\\:hover\\:text-red-500:hover {
    --text-opacity: 1;
    color: #f05252;
    color: rgba(240, 82, 82, var(--text-opacity));
  }
  .lg\\:hover\\:text-red-600:hover {
    --text-opacity: 1;
    color: #e02424;
    color: rgba(224, 36, 36, var(--text-opacity));
  }
  .lg\\:hover\\:text-red-700:hover {
    --text-opacity: 1;
    color: #c81e1e;
    color: rgba(200, 30, 30, var(--text-opacity));
  }
  .lg\\:hover\\:text-red-800:hover {
    --text-opacity: 1;
    color: #9b1c1c;
    color: rgba(155, 28, 28, var(--text-opacity));
  }
  .lg\\:hover\\:text-red-900:hover {
    --text-opacity: 1;
    color: #771d1d;
    color: rgba(119, 29, 29, var(--text-opacity));
  }
  .lg\\:hover\\:text-orange-50:hover {
    --text-opacity: 1;
    color: #fff8f1;
    color: rgba(255, 248, 241, var(--text-opacity));
  }
  .lg\\:hover\\:text-orange-100:hover {
    --text-opacity: 1;
    color: #feecdc;
    color: rgba(254, 236, 220, var(--text-opacity));
  }
  .lg\\:hover\\:text-orange-200:hover {
    --text-opacity: 1;
    color: #fcd9bd;
    color: rgba(252, 217, 189, var(--text-opacity));
  }
  .lg\\:hover\\:text-orange-300:hover {
    --text-opacity: 1;
    color: #fdba8c;
    color: rgba(253, 186, 140, var(--text-opacity));
  }
  .lg\\:hover\\:text-orange-400:hover {
    --text-opacity: 1;
    color: #ff8a4c;
    color: rgba(255, 138, 76, var(--text-opacity));
  }
  .lg\\:hover\\:text-orange-500:hover {
    --text-opacity: 1;
    color: #ff5a1f;
    color: rgba(255, 90, 31, var(--text-opacity));
  }
  .lg\\:hover\\:text-orange-600:hover {
    --text-opacity: 1;
    color: #d03801;
    color: rgba(208, 56, 1, var(--text-opacity));
  }
  .lg\\:hover\\:text-orange-700:hover {
    --text-opacity: 1;
    color: #b43403;
    color: rgba(180, 52, 3, var(--text-opacity));
  }
  .lg\\:hover\\:text-orange-800:hover {
    --text-opacity: 1;
    color: #8a2c0d;
    color: rgba(138, 44, 13, var(--text-opacity));
  }
  .lg\\:hover\\:text-orange-900:hover {
    --text-opacity: 1;
    color: #73230d;
    color: rgba(115, 35, 13, var(--text-opacity));
  }
  .lg\\:hover\\:text-yellow-50:hover {
    --text-opacity: 1;
    color: #fdfdea;
    color: rgba(253, 253, 234, var(--text-opacity));
  }
  .lg\\:hover\\:text-yellow-100:hover {
    --text-opacity: 1;
    color: #fdf6b2;
    color: rgba(253, 246, 178, var(--text-opacity));
  }
  .lg\\:hover\\:text-yellow-200:hover {
    --text-opacity: 1;
    color: #fce96a;
    color: rgba(252, 233, 106, var(--text-opacity));
  }
  .lg\\:hover\\:text-yellow-300:hover {
    --text-opacity: 1;
    color: #faca15;
    color: rgba(250, 202, 21, var(--text-opacity));
  }
  .lg\\:hover\\:text-yellow-400:hover {
    --text-opacity: 1;
    color: #e3a008;
    color: rgba(227, 160, 8, var(--text-opacity));
  }
  .lg\\:hover\\:text-yellow-500:hover {
    --text-opacity: 1;
    color: #c27803;
    color: rgba(194, 120, 3, var(--text-opacity));
  }
  .lg\\:hover\\:text-yellow-600:hover {
    --text-opacity: 1;
    color: #9f580a;
    color: rgba(159, 88, 10, var(--text-opacity));
  }
  .lg\\:hover\\:text-yellow-700:hover {
    --text-opacity: 1;
    color: #8e4b10;
    color: rgba(142, 75, 16, var(--text-opacity));
  }
  .lg\\:hover\\:text-yellow-800:hover {
    --text-opacity: 1;
    color: #723b13;
    color: rgba(114, 59, 19, var(--text-opacity));
  }
  .lg\\:hover\\:text-yellow-900:hover {
    --text-opacity: 1;
    color: #633112;
    color: rgba(99, 49, 18, var(--text-opacity));
  }
  .lg\\:hover\\:text-green-50:hover {
    --text-opacity: 1;
    color: #f3faf7;
    color: rgba(243, 250, 247, var(--text-opacity));
  }
  .lg\\:hover\\:text-green-100:hover {
    --text-opacity: 1;
    color: #def7ec;
    color: rgba(222, 247, 236, var(--text-opacity));
  }
  .lg\\:hover\\:text-green-200:hover {
    --text-opacity: 1;
    color: #bcf0da;
    color: rgba(188, 240, 218, var(--text-opacity));
  }
  .lg\\:hover\\:text-green-300:hover {
    --text-opacity: 1;
    color: #84e1bc;
    color: rgba(132, 225, 188, var(--text-opacity));
  }
  .lg\\:hover\\:text-green-400:hover {
    --text-opacity: 1;
    color: #31c48d;
    color: rgba(49, 196, 141, var(--text-opacity));
  }
  .lg\\:hover\\:text-green-500:hover {
    --text-opacity: 1;
    color: #0e9f6e;
    color: rgba(14, 159, 110, var(--text-opacity));
  }
  .lg\\:hover\\:text-green-600:hover {
    --text-opacity: 1;
    color: #057a55;
    color: rgba(5, 122, 85, var(--text-opacity));
  }
  .lg\\:hover\\:text-green-700:hover {
    --text-opacity: 1;
    color: #046c4e;
    color: rgba(4, 108, 78, var(--text-opacity));
  }
  .lg\\:hover\\:text-green-800:hover {
    --text-opacity: 1;
    color: #03543f;
    color: rgba(3, 84, 63, var(--text-opacity));
  }
  .lg\\:hover\\:text-green-900:hover {
    --text-opacity: 1;
    color: #014737;
    color: rgba(1, 71, 55, var(--text-opacity));
  }
  .lg\\:hover\\:text-teal-50:hover {
    --text-opacity: 1;
    color: #edfafa;
    color: rgba(237, 250, 250, var(--text-opacity));
  }
  .lg\\:hover\\:text-teal-100:hover {
    --text-opacity: 1;
    color: #d5f5f6;
    color: rgba(213, 245, 246, var(--text-opacity));
  }
  .lg\\:hover\\:text-teal-200:hover {
    --text-opacity: 1;
    color: #afecef;
    color: rgba(175, 236, 239, var(--text-opacity));
  }
  .lg\\:hover\\:text-teal-300:hover {
    --text-opacity: 1;
    color: #7edce2;
    color: rgba(126, 220, 226, var(--text-opacity));
  }
  .lg\\:hover\\:text-teal-400:hover {
    --text-opacity: 1;
    color: #16bdca;
    color: rgba(22, 189, 202, var(--text-opacity));
  }
  .lg\\:hover\\:text-teal-500:hover {
    --text-opacity: 1;
    color: #0694a2;
    color: rgba(6, 148, 162, var(--text-opacity));
  }
  .lg\\:hover\\:text-teal-600:hover {
    --text-opacity: 1;
    color: #047481;
    color: rgba(4, 116, 129, var(--text-opacity));
  }
  .lg\\:hover\\:text-teal-700:hover {
    --text-opacity: 1;
    color: #036672;
    color: rgba(3, 102, 114, var(--text-opacity));
  }
  .lg\\:hover\\:text-teal-800:hover {
    --text-opacity: 1;
    color: #05505c;
    color: rgba(5, 80, 92, var(--text-opacity));
  }
  .lg\\:hover\\:text-teal-900:hover {
    --text-opacity: 1;
    color: #014451;
    color: rgba(1, 68, 81, var(--text-opacity));
  }
  .lg\\:hover\\:text-blue-50:hover {
    --text-opacity: 1;
    color: #ebf5ff;
    color: rgba(235, 245, 255, var(--text-opacity));
  }
  .lg\\:hover\\:text-blue-100:hover {
    --text-opacity: 1;
    color: #e1effe;
    color: rgba(225, 239, 254, var(--text-opacity));
  }
  .lg\\:hover\\:text-blue-200:hover {
    --text-opacity: 1;
    color: #c3ddfd;
    color: rgba(195, 221, 253, var(--text-opacity));
  }
  .lg\\:hover\\:text-blue-300:hover {
    --text-opacity: 1;
    color: #a4cafe;
    color: rgba(164, 202, 254, var(--text-opacity));
  }
  .lg\\:hover\\:text-blue-400:hover {
    --text-opacity: 1;
    color: #76a9fa;
    color: rgba(118, 169, 250, var(--text-opacity));
  }
  .lg\\:hover\\:text-blue-500:hover {
    --text-opacity: 1;
    color: #3f83f8;
    color: rgba(63, 131, 248, var(--text-opacity));
  }
  .lg\\:hover\\:text-blue-600:hover {
    --text-opacity: 1;
    color: #1c64f2;
    color: rgba(28, 100, 242, var(--text-opacity));
  }
  .lg\\:hover\\:text-blue-700:hover {
    --text-opacity: 1;
    color: #1a56db;
    color: rgba(26, 86, 219, var(--text-opacity));
  }
  .lg\\:hover\\:text-blue-800:hover {
    --text-opacity: 1;
    color: #1e429f;
    color: rgba(30, 66, 159, var(--text-opacity));
  }
  .lg\\:hover\\:text-blue-900:hover {
    --text-opacity: 1;
    color: #233876;
    color: rgba(35, 56, 118, var(--text-opacity));
  }
  .lg\\:hover\\:text-indigo-50:hover {
    --text-opacity: 1;
    color: #f0f5ff;
    color: rgba(240, 245, 255, var(--text-opacity));
  }
  .lg\\:hover\\:text-indigo-100:hover {
    --text-opacity: 1;
    color: #e5edff;
    color: rgba(229, 237, 255, var(--text-opacity));
  }
  .lg\\:hover\\:text-indigo-200:hover {
    --text-opacity: 1;
    color: #cddbfe;
    color: rgba(205, 219, 254, var(--text-opacity));
  }
  .lg\\:hover\\:text-indigo-300:hover {
    --text-opacity: 1;
    color: #b4c6fc;
    color: rgba(180, 198, 252, var(--text-opacity));
  }
  .lg\\:hover\\:text-indigo-400:hover {
    --text-opacity: 1;
    color: #8da2fb;
    color: rgba(141, 162, 251, var(--text-opacity));
  }
  .lg\\:hover\\:text-indigo-500:hover {
    --text-opacity: 1;
    color: #6875f5;
    color: rgba(104, 117, 245, var(--text-opacity));
  }
  .lg\\:hover\\:text-indigo-600:hover {
    --text-opacity: 1;
    color: #5850ec;
    color: rgba(88, 80, 236, var(--text-opacity));
  }
  .lg\\:hover\\:text-indigo-700:hover {
    --text-opacity: 1;
    color: #5145cd;
    color: rgba(81, 69, 205, var(--text-opacity));
  }
  .lg\\:hover\\:text-indigo-800:hover {
    --text-opacity: 1;
    color: #42389d;
    color: rgba(66, 56, 157, var(--text-opacity));
  }
  .lg\\:hover\\:text-indigo-900:hover {
    --text-opacity: 1;
    color: #362f78;
    color: rgba(54, 47, 120, var(--text-opacity));
  }
  .lg\\:hover\\:text-purple-50:hover {
    --text-opacity: 1;
    color: #f6f5ff;
    color: rgba(246, 245, 255, var(--text-opacity));
  }
  .lg\\:hover\\:text-purple-100:hover {
    --text-opacity: 1;
    color: #edebfe;
    color: rgba(237, 235, 254, var(--text-opacity));
  }
  .lg\\:hover\\:text-purple-200:hover {
    --text-opacity: 1;
    color: #dcd7fe;
    color: rgba(220, 215, 254, var(--text-opacity));
  }
  .lg\\:hover\\:text-purple-300:hover {
    --text-opacity: 1;
    color: #cabffd;
    color: rgba(202, 191, 253, var(--text-opacity));
  }
  .lg\\:hover\\:text-purple-400:hover {
    --text-opacity: 1;
    color: #ac94fa;
    color: rgba(172, 148, 250, var(--text-opacity));
  }
  .lg\\:hover\\:text-purple-500:hover {
    --text-opacity: 1;
    color: #9061f9;
    color: rgba(144, 97, 249, var(--text-opacity));
  }
  .lg\\:hover\\:text-purple-600:hover {
    --text-opacity: 1;
    color: #7e3af2;
    color: rgba(126, 58, 242, var(--text-opacity));
  }
  .lg\\:hover\\:text-purple-700:hover {
    --text-opacity: 1;
    color: #6c2bd9;
    color: rgba(108, 43, 217, var(--text-opacity));
  }
  .lg\\:hover\\:text-purple-800:hover {
    --text-opacity: 1;
    color: #5521b5;
    color: rgba(85, 33, 181, var(--text-opacity));
  }
  .lg\\:hover\\:text-purple-900:hover {
    --text-opacity: 1;
    color: #4a1d96;
    color: rgba(74, 29, 150, var(--text-opacity));
  }
  .lg\\:hover\\:text-pink-50:hover {
    --text-opacity: 1;
    color: #fdf2f8;
    color: rgba(253, 242, 248, var(--text-opacity));
  }
  .lg\\:hover\\:text-pink-100:hover {
    --text-opacity: 1;
    color: #fce8f3;
    color: rgba(252, 232, 243, var(--text-opacity));
  }
  .lg\\:hover\\:text-pink-200:hover {
    --text-opacity: 1;
    color: #fad1e8;
    color: rgba(250, 209, 232, var(--text-opacity));
  }
  .lg\\:hover\\:text-pink-300:hover {
    --text-opacity: 1;
    color: #f8b4d9;
    color: rgba(248, 180, 217, var(--text-opacity));
  }
  .lg\\:hover\\:text-pink-400:hover {
    --text-opacity: 1;
    color: #f17eb8;
    color: rgba(241, 126, 184, var(--text-opacity));
  }
  .lg\\:hover\\:text-pink-500:hover {
    --text-opacity: 1;
    color: #e74694;
    color: rgba(231, 70, 148, var(--text-opacity));
  }
  .lg\\:hover\\:text-pink-600:hover {
    --text-opacity: 1;
    color: #d61f69;
    color: rgba(214, 31, 105, var(--text-opacity));
  }
  .lg\\:hover\\:text-pink-700:hover {
    --text-opacity: 1;
    color: #bf125d;
    color: rgba(191, 18, 93, var(--text-opacity));
  }
  .lg\\:hover\\:text-pink-800:hover {
    --text-opacity: 1;
    color: #99154b;
    color: rgba(153, 21, 75, var(--text-opacity));
  }
  .lg\\:hover\\:text-pink-900:hover {
    --text-opacity: 1;
    color: #751a3d;
    color: rgba(117, 26, 61, var(--text-opacity));
  }
  .lg\\:hover\\:text-cool-gray-50:hover {
    --text-opacity: 1;
    color: #f8fafc;
    color: rgba(248, 250, 252, var(--text-opacity));
  }
  .lg\\:hover\\:text-cool-gray-100:hover {
    --text-opacity: 1;
    color: #f1f5f9;
    color: rgba(241, 245, 249, var(--text-opacity));
  }
  .lg\\:hover\\:text-cool-gray-200:hover {
    --text-opacity: 1;
    color: #e2e8f0;
    color: rgba(226, 232, 240, var(--text-opacity));
  }
  .lg\\:hover\\:text-cool-gray-300:hover {
    --text-opacity: 1;
    color: #cfd8e3;
    color: rgba(207, 216, 227, var(--text-opacity));
  }
  .lg\\:hover\\:text-cool-gray-400:hover {
    --text-opacity: 1;
    color: #97a6ba;
    color: rgba(151, 166, 186, var(--text-opacity));
  }
  .lg\\:hover\\:text-cool-gray-500:hover {
    --text-opacity: 1;
    color: #64748b;
    color: rgba(100, 116, 139, var(--text-opacity));
  }
  .lg\\:hover\\:text-cool-gray-600:hover {
    --text-opacity: 1;
    color: #475569;
    color: rgba(71, 85, 105, var(--text-opacity));
  }
  .lg\\:hover\\:text-cool-gray-700:hover {
    --text-opacity: 1;
    color: #364152;
    color: rgba(54, 65, 82, var(--text-opacity));
  }
  .lg\\:hover\\:text-cool-gray-800:hover {
    --text-opacity: 1;
    color: #27303f;
    color: rgba(39, 48, 63, var(--text-opacity));
  }
  .lg\\:hover\\:text-cool-gray-900:hover {
    --text-opacity: 1;
    color: #1a202e;
    color: rgba(26, 32, 46, var(--text-opacity));
  }
  .lg\\:focus-within\\:text-current:focus-within {
    color: currentColor;
  }
  .lg\\:focus-within\\:text-transparent:focus-within {
    color: transparent;
  }
  .lg\\:focus-within\\:text-white:focus-within {
    --text-opacity: 1;
    color: #ffffff;
    color: rgba(255, 255, 255, var(--text-opacity));
  }
  .lg\\:focus-within\\:text-black:focus-within {
    --text-opacity: 1;
    color: #000000;
    color: rgba(0, 0, 0, var(--text-opacity));
  }
  .lg\\:focus-within\\:text-gray-50:focus-within {
    --text-opacity: 1;
    color: #f9fafb;
    color: rgba(249, 250, 251, var(--text-opacity));
  }
  .lg\\:focus-within\\:text-gray-100:focus-within {
    --text-opacity: 1;
    color: #f4f5f7;
    color: rgba(244, 245, 247, var(--text-opacity));
  }
  .lg\\:focus-within\\:text-gray-200:focus-within {
    --text-opacity: 1;
    color: #e5e7eb;
    color: rgba(229, 231, 235, var(--text-opacity));
  }
  .lg\\:focus-within\\:text-gray-300:focus-within {
    --text-opacity: 1;
    color: #d2d6dc;
    color: rgba(210, 214, 220, var(--text-opacity));
  }
  .lg\\:focus-within\\:text-gray-400:focus-within {
    --text-opacity: 1;
    color: #9fa6b2;
    color: rgba(159, 166, 178, var(--text-opacity));
  }
  .lg\\:focus-within\\:text-gray-500:focus-within {
    --text-opacity: 1;
    color: #6b7280;
    color: rgba(107, 114, 128, var(--text-opacity));
  }
  .lg\\:focus-within\\:text-gray-600:focus-within {
    --text-opacity: 1;
    color: #4b5563;
    color: rgba(75, 85, 99, var(--text-opacity));
  }
  .lg\\:focus-within\\:text-gray-700:focus-within {
    --text-opacity: 1;
    color: #374151;
    color: rgba(55, 65, 81, var(--text-opacity));
  }
  .lg\\:focus-within\\:text-gray-800:focus-within {
    --text-opacity: 1;
    color: #252f3f;
    color: rgba(37, 47, 63, var(--text-opacity));
  }
  .lg\\:focus-within\\:text-gray-900:focus-within {
    --text-opacity: 1;
    color: #161e2e;
    color: rgba(22, 30, 46, var(--text-opacity));
  }
  .lg\\:focus-within\\:text-red-50:focus-within {
    --text-opacity: 1;
    color: #fdf2f2;
    color: rgba(253, 242, 242, var(--text-opacity));
  }
  .lg\\:focus-within\\:text-red-100:focus-within {
    --text-opacity: 1;
    color: #fde8e8;
    color: rgba(253, 232, 232, var(--text-opacity));
  }
  .lg\\:focus-within\\:text-red-200:focus-within {
    --text-opacity: 1;
    color: #fbd5d5;
    color: rgba(251, 213, 213, var(--text-opacity));
  }
  .lg\\:focus-within\\:text-red-300:focus-within {
    --text-opacity: 1;
    color: #f8b4b4;
    color: rgba(248, 180, 180, var(--text-opacity));
  }
  .lg\\:focus-within\\:text-red-400:focus-within {
    --text-opacity: 1;
    color: #f98080;
    color: rgba(249, 128, 128, var(--text-opacity));
  }
  .lg\\:focus-within\\:text-red-500:focus-within {
    --text-opacity: 1;
    color: #f05252;
    color: rgba(240, 82, 82, var(--text-opacity));
  }
  .lg\\:focus-within\\:text-red-600:focus-within {
    --text-opacity: 1;
    color: #e02424;
    color: rgba(224, 36, 36, var(--text-opacity));
  }
  .lg\\:focus-within\\:text-red-700:focus-within {
    --text-opacity: 1;
    color: #c81e1e;
    color: rgba(200, 30, 30, var(--text-opacity));
  }
  .lg\\:focus-within\\:text-red-800:focus-within {
    --text-opacity: 1;
    color: #9b1c1c;
    color: rgba(155, 28, 28, var(--text-opacity));
  }
  .lg\\:focus-within\\:text-red-900:focus-within {
    --text-opacity: 1;
    color: #771d1d;
    color: rgba(119, 29, 29, var(--text-opacity));
  }
  .lg\\:focus-within\\:text-orange-50:focus-within {
    --text-opacity: 1;
    color: #fff8f1;
    color: rgba(255, 248, 241, var(--text-opacity));
  }
  .lg\\:focus-within\\:text-orange-100:focus-within {
    --text-opacity: 1;
    color: #feecdc;
    color: rgba(254, 236, 220, var(--text-opacity));
  }
  .lg\\:focus-within\\:text-orange-200:focus-within {
    --text-opacity: 1;
    color: #fcd9bd;
    color: rgba(252, 217, 189, var(--text-opacity));
  }
  .lg\\:focus-within\\:text-orange-300:focus-within {
    --text-opacity: 1;
    color: #fdba8c;
    color: rgba(253, 186, 140, var(--text-opacity));
  }
  .lg\\:focus-within\\:text-orange-400:focus-within {
    --text-opacity: 1;
    color: #ff8a4c;
    color: rgba(255, 138, 76, var(--text-opacity));
  }
  .lg\\:focus-within\\:text-orange-500:focus-within {
    --text-opacity: 1;
    color: #ff5a1f;
    color: rgba(255, 90, 31, var(--text-opacity));
  }
  .lg\\:focus-within\\:text-orange-600:focus-within {
    --text-opacity: 1;
    color: #d03801;
    color: rgba(208, 56, 1, var(--text-opacity));
  }
  .lg\\:focus-within\\:text-orange-700:focus-within {
    --text-opacity: 1;
    color: #b43403;
    color: rgba(180, 52, 3, var(--text-opacity));
  }
  .lg\\:focus-within\\:text-orange-800:focus-within {
    --text-opacity: 1;
    color: #8a2c0d;
    color: rgba(138, 44, 13, var(--text-opacity));
  }
  .lg\\:focus-within\\:text-orange-900:focus-within {
    --text-opacity: 1;
    color: #73230d;
    color: rgba(115, 35, 13, var(--text-opacity));
  }
  .lg\\:focus-within\\:text-yellow-50:focus-within {
    --text-opacity: 1;
    color: #fdfdea;
    color: rgba(253, 253, 234, var(--text-opacity));
  }
  .lg\\:focus-within\\:text-yellow-100:focus-within {
    --text-opacity: 1;
    color: #fdf6b2;
    color: rgba(253, 246, 178, var(--text-opacity));
  }
  .lg\\:focus-within\\:text-yellow-200:focus-within {
    --text-opacity: 1;
    color: #fce96a;
    color: rgba(252, 233, 106, var(--text-opacity));
  }
  .lg\\:focus-within\\:text-yellow-300:focus-within {
    --text-opacity: 1;
    color: #faca15;
    color: rgba(250, 202, 21, var(--text-opacity));
  }
  .lg\\:focus-within\\:text-yellow-400:focus-within {
    --text-opacity: 1;
    color: #e3a008;
    color: rgba(227, 160, 8, var(--text-opacity));
  }
  .lg\\:focus-within\\:text-yellow-500:focus-within {
    --text-opacity: 1;
    color: #c27803;
    color: rgba(194, 120, 3, var(--text-opacity));
  }
  .lg\\:focus-within\\:text-yellow-600:focus-within {
    --text-opacity: 1;
    color: #9f580a;
    color: rgba(159, 88, 10, var(--text-opacity));
  }
  .lg\\:focus-within\\:text-yellow-700:focus-within {
    --text-opacity: 1;
    color: #8e4b10;
    color: rgba(142, 75, 16, var(--text-opacity));
  }
  .lg\\:focus-within\\:text-yellow-800:focus-within {
    --text-opacity: 1;
    color: #723b13;
    color: rgba(114, 59, 19, var(--text-opacity));
  }
  .lg\\:focus-within\\:text-yellow-900:focus-within {
    --text-opacity: 1;
    color: #633112;
    color: rgba(99, 49, 18, var(--text-opacity));
  }
  .lg\\:focus-within\\:text-green-50:focus-within {
    --text-opacity: 1;
    color: #f3faf7;
    color: rgba(243, 250, 247, var(--text-opacity));
  }
  .lg\\:focus-within\\:text-green-100:focus-within {
    --text-opacity: 1;
    color: #def7ec;
    color: rgba(222, 247, 236, var(--text-opacity));
  }
  .lg\\:focus-within\\:text-green-200:focus-within {
    --text-opacity: 1;
    color: #bcf0da;
    color: rgba(188, 240, 218, var(--text-opacity));
  }
  .lg\\:focus-within\\:text-green-300:focus-within {
    --text-opacity: 1;
    color: #84e1bc;
    color: rgba(132, 225, 188, var(--text-opacity));
  }
  .lg\\:focus-within\\:text-green-400:focus-within {
    --text-opacity: 1;
    color: #31c48d;
    color: rgba(49, 196, 141, var(--text-opacity));
  }
  .lg\\:focus-within\\:text-green-500:focus-within {
    --text-opacity: 1;
    color: #0e9f6e;
    color: rgba(14, 159, 110, var(--text-opacity));
  }
  .lg\\:focus-within\\:text-green-600:focus-within {
    --text-opacity: 1;
    color: #057a55;
    color: rgba(5, 122, 85, var(--text-opacity));
  }
  .lg\\:focus-within\\:text-green-700:focus-within {
    --text-opacity: 1;
    color: #046c4e;
    color: rgba(4, 108, 78, var(--text-opacity));
  }
  .lg\\:focus-within\\:text-green-800:focus-within {
    --text-opacity: 1;
    color: #03543f;
    color: rgba(3, 84, 63, var(--text-opacity));
  }
  .lg\\:focus-within\\:text-green-900:focus-within {
    --text-opacity: 1;
    color: #014737;
    color: rgba(1, 71, 55, var(--text-opacity));
  }
  .lg\\:focus-within\\:text-teal-50:focus-within {
    --text-opacity: 1;
    color: #edfafa;
    color: rgba(237, 250, 250, var(--text-opacity));
  }
  .lg\\:focus-within\\:text-teal-100:focus-within {
    --text-opacity: 1;
    color: #d5f5f6;
    color: rgba(213, 245, 246, var(--text-opacity));
  }
  .lg\\:focus-within\\:text-teal-200:focus-within {
    --text-opacity: 1;
    color: #afecef;
    color: rgba(175, 236, 239, var(--text-opacity));
  }
  .lg\\:focus-within\\:text-teal-300:focus-within {
    --text-opacity: 1;
    color: #7edce2;
    color: rgba(126, 220, 226, var(--text-opacity));
  }
  .lg\\:focus-within\\:text-teal-400:focus-within {
    --text-opacity: 1;
    color: #16bdca;
    color: rgba(22, 189, 202, var(--text-opacity));
  }
  .lg\\:focus-within\\:text-teal-500:focus-within {
    --text-opacity: 1;
    color: #0694a2;
    color: rgba(6, 148, 162, var(--text-opacity));
  }
  .lg\\:focus-within\\:text-teal-600:focus-within {
    --text-opacity: 1;
    color: #047481;
    color: rgba(4, 116, 129, var(--text-opacity));
  }
  .lg\\:focus-within\\:text-teal-700:focus-within {
    --text-opacity: 1;
    color: #036672;
    color: rgba(3, 102, 114, var(--text-opacity));
  }
  .lg\\:focus-within\\:text-teal-800:focus-within {
    --text-opacity: 1;
    color: #05505c;
    color: rgba(5, 80, 92, var(--text-opacity));
  }
  .lg\\:focus-within\\:text-teal-900:focus-within {
    --text-opacity: 1;
    color: #014451;
    color: rgba(1, 68, 81, var(--text-opacity));
  }
  .lg\\:focus-within\\:text-blue-50:focus-within {
    --text-opacity: 1;
    color: #ebf5ff;
    color: rgba(235, 245, 255, var(--text-opacity));
  }
  .lg\\:focus-within\\:text-blue-100:focus-within {
    --text-opacity: 1;
    color: #e1effe;
    color: rgba(225, 239, 254, var(--text-opacity));
  }
  .lg\\:focus-within\\:text-blue-200:focus-within {
    --text-opacity: 1;
    color: #c3ddfd;
    color: rgba(195, 221, 253, var(--text-opacity));
  }
  .lg\\:focus-within\\:text-blue-300:focus-within {
    --text-opacity: 1;
    color: #a4cafe;
    color: rgba(164, 202, 254, var(--text-opacity));
  }
  .lg\\:focus-within\\:text-blue-400:focus-within {
    --text-opacity: 1;
    color: #76a9fa;
    color: rgba(118, 169, 250, var(--text-opacity));
  }
  .lg\\:focus-within\\:text-blue-500:focus-within {
    --text-opacity: 1;
    color: #3f83f8;
    color: rgba(63, 131, 248, var(--text-opacity));
  }
  .lg\\:focus-within\\:text-blue-600:focus-within {
    --text-opacity: 1;
    color: #1c64f2;
    color: rgba(28, 100, 242, var(--text-opacity));
  }
  .lg\\:focus-within\\:text-blue-700:focus-within {
    --text-opacity: 1;
    color: #1a56db;
    color: rgba(26, 86, 219, var(--text-opacity));
  }
  .lg\\:focus-within\\:text-blue-800:focus-within {
    --text-opacity: 1;
    color: #1e429f;
    color: rgba(30, 66, 159, var(--text-opacity));
  }
  .lg\\:focus-within\\:text-blue-900:focus-within {
    --text-opacity: 1;
    color: #233876;
    color: rgba(35, 56, 118, var(--text-opacity));
  }
  .lg\\:focus-within\\:text-indigo-50:focus-within {
    --text-opacity: 1;
    color: #f0f5ff;
    color: rgba(240, 245, 255, var(--text-opacity));
  }
  .lg\\:focus-within\\:text-indigo-100:focus-within {
    --text-opacity: 1;
    color: #e5edff;
    color: rgba(229, 237, 255, var(--text-opacity));
  }
  .lg\\:focus-within\\:text-indigo-200:focus-within {
    --text-opacity: 1;
    color: #cddbfe;
    color: rgba(205, 219, 254, var(--text-opacity));
  }
  .lg\\:focus-within\\:text-indigo-300:focus-within {
    --text-opacity: 1;
    color: #b4c6fc;
    color: rgba(180, 198, 252, var(--text-opacity));
  }
  .lg\\:focus-within\\:text-indigo-400:focus-within {
    --text-opacity: 1;
    color: #8da2fb;
    color: rgba(141, 162, 251, var(--text-opacity));
  }
  .lg\\:focus-within\\:text-indigo-500:focus-within {
    --text-opacity: 1;
    color: #6875f5;
    color: rgba(104, 117, 245, var(--text-opacity));
  }
  .lg\\:focus-within\\:text-indigo-600:focus-within {
    --text-opacity: 1;
    color: #5850ec;
    color: rgba(88, 80, 236, var(--text-opacity));
  }
  .lg\\:focus-within\\:text-indigo-700:focus-within {
    --text-opacity: 1;
    color: #5145cd;
    color: rgba(81, 69, 205, var(--text-opacity));
  }
  .lg\\:focus-within\\:text-indigo-800:focus-within {
    --text-opacity: 1;
    color: #42389d;
    color: rgba(66, 56, 157, var(--text-opacity));
  }
  .lg\\:focus-within\\:text-indigo-900:focus-within {
    --text-opacity: 1;
    color: #362f78;
    color: rgba(54, 47, 120, var(--text-opacity));
  }
  .lg\\:focus-within\\:text-purple-50:focus-within {
    --text-opacity: 1;
    color: #f6f5ff;
    color: rgba(246, 245, 255, var(--text-opacity));
  }
  .lg\\:focus-within\\:text-purple-100:focus-within {
    --text-opacity: 1;
    color: #edebfe;
    color: rgba(237, 235, 254, var(--text-opacity));
  }
  .lg\\:focus-within\\:text-purple-200:focus-within {
    --text-opacity: 1;
    color: #dcd7fe;
    color: rgba(220, 215, 254, var(--text-opacity));
  }
  .lg\\:focus-within\\:text-purple-300:focus-within {
    --text-opacity: 1;
    color: #cabffd;
    color: rgba(202, 191, 253, var(--text-opacity));
  }
  .lg\\:focus-within\\:text-purple-400:focus-within {
    --text-opacity: 1;
    color: #ac94fa;
    color: rgba(172, 148, 250, var(--text-opacity));
  }
  .lg\\:focus-within\\:text-purple-500:focus-within {
    --text-opacity: 1;
    color: #9061f9;
    color: rgba(144, 97, 249, var(--text-opacity));
  }
  .lg\\:focus-within\\:text-purple-600:focus-within {
    --text-opacity: 1;
    color: #7e3af2;
    color: rgba(126, 58, 242, var(--text-opacity));
  }
  .lg\\:focus-within\\:text-purple-700:focus-within {
    --text-opacity: 1;
    color: #6c2bd9;
    color: rgba(108, 43, 217, var(--text-opacity));
  }
  .lg\\:focus-within\\:text-purple-800:focus-within {
    --text-opacity: 1;
    color: #5521b5;
    color: rgba(85, 33, 181, var(--text-opacity));
  }
  .lg\\:focus-within\\:text-purple-900:focus-within {
    --text-opacity: 1;
    color: #4a1d96;
    color: rgba(74, 29, 150, var(--text-opacity));
  }
  .lg\\:focus-within\\:text-pink-50:focus-within {
    --text-opacity: 1;
    color: #fdf2f8;
    color: rgba(253, 242, 248, var(--text-opacity));
  }
  .lg\\:focus-within\\:text-pink-100:focus-within {
    --text-opacity: 1;
    color: #fce8f3;
    color: rgba(252, 232, 243, var(--text-opacity));
  }
  .lg\\:focus-within\\:text-pink-200:focus-within {
    --text-opacity: 1;
    color: #fad1e8;
    color: rgba(250, 209, 232, var(--text-opacity));
  }
  .lg\\:focus-within\\:text-pink-300:focus-within {
    --text-opacity: 1;
    color: #f8b4d9;
    color: rgba(248, 180, 217, var(--text-opacity));
  }
  .lg\\:focus-within\\:text-pink-400:focus-within {
    --text-opacity: 1;
    color: #f17eb8;
    color: rgba(241, 126, 184, var(--text-opacity));
  }
  .lg\\:focus-within\\:text-pink-500:focus-within {
    --text-opacity: 1;
    color: #e74694;
    color: rgba(231, 70, 148, var(--text-opacity));
  }
  .lg\\:focus-within\\:text-pink-600:focus-within {
    --text-opacity: 1;
    color: #d61f69;
    color: rgba(214, 31, 105, var(--text-opacity));
  }
  .lg\\:focus-within\\:text-pink-700:focus-within {
    --text-opacity: 1;
    color: #bf125d;
    color: rgba(191, 18, 93, var(--text-opacity));
  }
  .lg\\:focus-within\\:text-pink-800:focus-within {
    --text-opacity: 1;
    color: #99154b;
    color: rgba(153, 21, 75, var(--text-opacity));
  }
  .lg\\:focus-within\\:text-pink-900:focus-within {
    --text-opacity: 1;
    color: #751a3d;
    color: rgba(117, 26, 61, var(--text-opacity));
  }
  .lg\\:focus-within\\:text-cool-gray-50:focus-within {
    --text-opacity: 1;
    color: #f8fafc;
    color: rgba(248, 250, 252, var(--text-opacity));
  }
  .lg\\:focus-within\\:text-cool-gray-100:focus-within {
    --text-opacity: 1;
    color: #f1f5f9;
    color: rgba(241, 245, 249, var(--text-opacity));
  }
  .lg\\:focus-within\\:text-cool-gray-200:focus-within {
    --text-opacity: 1;
    color: #e2e8f0;
    color: rgba(226, 232, 240, var(--text-opacity));
  }
  .lg\\:focus-within\\:text-cool-gray-300:focus-within {
    --text-opacity: 1;
    color: #cfd8e3;
    color: rgba(207, 216, 227, var(--text-opacity));
  }
  .lg\\:focus-within\\:text-cool-gray-400:focus-within {
    --text-opacity: 1;
    color: #97a6ba;
    color: rgba(151, 166, 186, var(--text-opacity));
  }
  .lg\\:focus-within\\:text-cool-gray-500:focus-within {
    --text-opacity: 1;
    color: #64748b;
    color: rgba(100, 116, 139, var(--text-opacity));
  }
  .lg\\:focus-within\\:text-cool-gray-600:focus-within {
    --text-opacity: 1;
    color: #475569;
    color: rgba(71, 85, 105, var(--text-opacity));
  }
  .lg\\:focus-within\\:text-cool-gray-700:focus-within {
    --text-opacity: 1;
    color: #364152;
    color: rgba(54, 65, 82, var(--text-opacity));
  }
  .lg\\:focus-within\\:text-cool-gray-800:focus-within {
    --text-opacity: 1;
    color: #27303f;
    color: rgba(39, 48, 63, var(--text-opacity));
  }
  .lg\\:focus-within\\:text-cool-gray-900:focus-within {
    --text-opacity: 1;
    color: #1a202e;
    color: rgba(26, 32, 46, var(--text-opacity));
  }
  .lg\\:focus\\:text-current:focus {
    color: currentColor;
  }
  .lg\\:focus\\:text-transparent:focus {
    color: transparent;
  }
  .lg\\:focus\\:text-white:focus {
    --text-opacity: 1;
    color: #ffffff;
    color: rgba(255, 255, 255, var(--text-opacity));
  }
  .lg\\:focus\\:text-black:focus {
    --text-opacity: 1;
    color: #000000;
    color: rgba(0, 0, 0, var(--text-opacity));
  }
  .lg\\:focus\\:text-gray-50:focus {
    --text-opacity: 1;
    color: #f9fafb;
    color: rgba(249, 250, 251, var(--text-opacity));
  }
  .lg\\:focus\\:text-gray-100:focus {
    --text-opacity: 1;
    color: #f4f5f7;
    color: rgba(244, 245, 247, var(--text-opacity));
  }
  .lg\\:focus\\:text-gray-200:focus {
    --text-opacity: 1;
    color: #e5e7eb;
    color: rgba(229, 231, 235, var(--text-opacity));
  }
  .lg\\:focus\\:text-gray-300:focus {
    --text-opacity: 1;
    color: #d2d6dc;
    color: rgba(210, 214, 220, var(--text-opacity));
  }
  .lg\\:focus\\:text-gray-400:focus {
    --text-opacity: 1;
    color: #9fa6b2;
    color: rgba(159, 166, 178, var(--text-opacity));
  }
  .lg\\:focus\\:text-gray-500:focus {
    --text-opacity: 1;
    color: #6b7280;
    color: rgba(107, 114, 128, var(--text-opacity));
  }
  .lg\\:focus\\:text-gray-600:focus {
    --text-opacity: 1;
    color: #4b5563;
    color: rgba(75, 85, 99, var(--text-opacity));
  }
  .lg\\:focus\\:text-gray-700:focus {
    --text-opacity: 1;
    color: #374151;
    color: rgba(55, 65, 81, var(--text-opacity));
  }
  .lg\\:focus\\:text-gray-800:focus {
    --text-opacity: 1;
    color: #252f3f;
    color: rgba(37, 47, 63, var(--text-opacity));
  }
  .lg\\:focus\\:text-gray-900:focus {
    --text-opacity: 1;
    color: #161e2e;
    color: rgba(22, 30, 46, var(--text-opacity));
  }
  .lg\\:focus\\:text-red-50:focus {
    --text-opacity: 1;
    color: #fdf2f2;
    color: rgba(253, 242, 242, var(--text-opacity));
  }
  .lg\\:focus\\:text-red-100:focus {
    --text-opacity: 1;
    color: #fde8e8;
    color: rgba(253, 232, 232, var(--text-opacity));
  }
  .lg\\:focus\\:text-red-200:focus {
    --text-opacity: 1;
    color: #fbd5d5;
    color: rgba(251, 213, 213, var(--text-opacity));
  }
  .lg\\:focus\\:text-red-300:focus {
    --text-opacity: 1;
    color: #f8b4b4;
    color: rgba(248, 180, 180, var(--text-opacity));
  }
  .lg\\:focus\\:text-red-400:focus {
    --text-opacity: 1;
    color: #f98080;
    color: rgba(249, 128, 128, var(--text-opacity));
  }
  .lg\\:focus\\:text-red-500:focus {
    --text-opacity: 1;
    color: #f05252;
    color: rgba(240, 82, 82, var(--text-opacity));
  }
  .lg\\:focus\\:text-red-600:focus {
    --text-opacity: 1;
    color: #e02424;
    color: rgba(224, 36, 36, var(--text-opacity));
  }
  .lg\\:focus\\:text-red-700:focus {
    --text-opacity: 1;
    color: #c81e1e;
    color: rgba(200, 30, 30, var(--text-opacity));
  }
  .lg\\:focus\\:text-red-800:focus {
    --text-opacity: 1;
    color: #9b1c1c;
    color: rgba(155, 28, 28, var(--text-opacity));
  }
  .lg\\:focus\\:text-red-900:focus {
    --text-opacity: 1;
    color: #771d1d;
    color: rgba(119, 29, 29, var(--text-opacity));
  }
  .lg\\:focus\\:text-orange-50:focus {
    --text-opacity: 1;
    color: #fff8f1;
    color: rgba(255, 248, 241, var(--text-opacity));
  }
  .lg\\:focus\\:text-orange-100:focus {
    --text-opacity: 1;
    color: #feecdc;
    color: rgba(254, 236, 220, var(--text-opacity));
  }
  .lg\\:focus\\:text-orange-200:focus {
    --text-opacity: 1;
    color: #fcd9bd;
    color: rgba(252, 217, 189, var(--text-opacity));
  }
  .lg\\:focus\\:text-orange-300:focus {
    --text-opacity: 1;
    color: #fdba8c;
    color: rgba(253, 186, 140, var(--text-opacity));
  }
  .lg\\:focus\\:text-orange-400:focus {
    --text-opacity: 1;
    color: #ff8a4c;
    color: rgba(255, 138, 76, var(--text-opacity));
  }
  .lg\\:focus\\:text-orange-500:focus {
    --text-opacity: 1;
    color: #ff5a1f;
    color: rgba(255, 90, 31, var(--text-opacity));
  }
  .lg\\:focus\\:text-orange-600:focus {
    --text-opacity: 1;
    color: #d03801;
    color: rgba(208, 56, 1, var(--text-opacity));
  }
  .lg\\:focus\\:text-orange-700:focus {
    --text-opacity: 1;
    color: #b43403;
    color: rgba(180, 52, 3, var(--text-opacity));
  }
  .lg\\:focus\\:text-orange-800:focus {
    --text-opacity: 1;
    color: #8a2c0d;
    color: rgba(138, 44, 13, var(--text-opacity));
  }
  .lg\\:focus\\:text-orange-900:focus {
    --text-opacity: 1;
    color: #73230d;
    color: rgba(115, 35, 13, var(--text-opacity));
  }
  .lg\\:focus\\:text-yellow-50:focus {
    --text-opacity: 1;
    color: #fdfdea;
    color: rgba(253, 253, 234, var(--text-opacity));
  }
  .lg\\:focus\\:text-yellow-100:focus {
    --text-opacity: 1;
    color: #fdf6b2;
    color: rgba(253, 246, 178, var(--text-opacity));
  }
  .lg\\:focus\\:text-yellow-200:focus {
    --text-opacity: 1;
    color: #fce96a;
    color: rgba(252, 233, 106, var(--text-opacity));
  }
  .lg\\:focus\\:text-yellow-300:focus {
    --text-opacity: 1;
    color: #faca15;
    color: rgba(250, 202, 21, var(--text-opacity));
  }
  .lg\\:focus\\:text-yellow-400:focus {
    --text-opacity: 1;
    color: #e3a008;
    color: rgba(227, 160, 8, var(--text-opacity));
  }
  .lg\\:focus\\:text-yellow-500:focus {
    --text-opacity: 1;
    color: #c27803;
    color: rgba(194, 120, 3, var(--text-opacity));
  }
  .lg\\:focus\\:text-yellow-600:focus {
    --text-opacity: 1;
    color: #9f580a;
    color: rgba(159, 88, 10, var(--text-opacity));
  }
  .lg\\:focus\\:text-yellow-700:focus {
    --text-opacity: 1;
    color: #8e4b10;
    color: rgba(142, 75, 16, var(--text-opacity));
  }
  .lg\\:focus\\:text-yellow-800:focus {
    --text-opacity: 1;
    color: #723b13;
    color: rgba(114, 59, 19, var(--text-opacity));
  }
  .lg\\:focus\\:text-yellow-900:focus {
    --text-opacity: 1;
    color: #633112;
    color: rgba(99, 49, 18, var(--text-opacity));
  }
  .lg\\:focus\\:text-green-50:focus {
    --text-opacity: 1;
    color: #f3faf7;
    color: rgba(243, 250, 247, var(--text-opacity));
  }
  .lg\\:focus\\:text-green-100:focus {
    --text-opacity: 1;
    color: #def7ec;
    color: rgba(222, 247, 236, var(--text-opacity));
  }
  .lg\\:focus\\:text-green-200:focus {
    --text-opacity: 1;
    color: #bcf0da;
    color: rgba(188, 240, 218, var(--text-opacity));
  }
  .lg\\:focus\\:text-green-300:focus {
    --text-opacity: 1;
    color: #84e1bc;
    color: rgba(132, 225, 188, var(--text-opacity));
  }
  .lg\\:focus\\:text-green-400:focus {
    --text-opacity: 1;
    color: #31c48d;
    color: rgba(49, 196, 141, var(--text-opacity));
  }
  .lg\\:focus\\:text-green-500:focus {
    --text-opacity: 1;
    color: #0e9f6e;
    color: rgba(14, 159, 110, var(--text-opacity));
  }
  .lg\\:focus\\:text-green-600:focus {
    --text-opacity: 1;
    color: #057a55;
    color: rgba(5, 122, 85, var(--text-opacity));
  }
  .lg\\:focus\\:text-green-700:focus {
    --text-opacity: 1;
    color: #046c4e;
    color: rgba(4, 108, 78, var(--text-opacity));
  }
  .lg\\:focus\\:text-green-800:focus {
    --text-opacity: 1;
    color: #03543f;
    color: rgba(3, 84, 63, var(--text-opacity));
  }
  .lg\\:focus\\:text-green-900:focus {
    --text-opacity: 1;
    color: #014737;
    color: rgba(1, 71, 55, var(--text-opacity));
  }
  .lg\\:focus\\:text-teal-50:focus {
    --text-opacity: 1;
    color: #edfafa;
    color: rgba(237, 250, 250, var(--text-opacity));
  }
  .lg\\:focus\\:text-teal-100:focus {
    --text-opacity: 1;
    color: #d5f5f6;
    color: rgba(213, 245, 246, var(--text-opacity));
  }
  .lg\\:focus\\:text-teal-200:focus {
    --text-opacity: 1;
    color: #afecef;
    color: rgba(175, 236, 239, var(--text-opacity));
  }
  .lg\\:focus\\:text-teal-300:focus {
    --text-opacity: 1;
    color: #7edce2;
    color: rgba(126, 220, 226, var(--text-opacity));
  }
  .lg\\:focus\\:text-teal-400:focus {
    --text-opacity: 1;
    color: #16bdca;
    color: rgba(22, 189, 202, var(--text-opacity));
  }
  .lg\\:focus\\:text-teal-500:focus {
    --text-opacity: 1;
    color: #0694a2;
    color: rgba(6, 148, 162, var(--text-opacity));
  }
  .lg\\:focus\\:text-teal-600:focus {
    --text-opacity: 1;
    color: #047481;
    color: rgba(4, 116, 129, var(--text-opacity));
  }
  .lg\\:focus\\:text-teal-700:focus {
    --text-opacity: 1;
    color: #036672;
    color: rgba(3, 102, 114, var(--text-opacity));
  }
  .lg\\:focus\\:text-teal-800:focus {
    --text-opacity: 1;
    color: #05505c;
    color: rgba(5, 80, 92, var(--text-opacity));
  }
  .lg\\:focus\\:text-teal-900:focus {
    --text-opacity: 1;
    color: #014451;
    color: rgba(1, 68, 81, var(--text-opacity));
  }
  .lg\\:focus\\:text-blue-50:focus {
    --text-opacity: 1;
    color: #ebf5ff;
    color: rgba(235, 245, 255, var(--text-opacity));
  }
  .lg\\:focus\\:text-blue-100:focus {
    --text-opacity: 1;
    color: #e1effe;
    color: rgba(225, 239, 254, var(--text-opacity));
  }
  .lg\\:focus\\:text-blue-200:focus {
    --text-opacity: 1;
    color: #c3ddfd;
    color: rgba(195, 221, 253, var(--text-opacity));
  }
  .lg\\:focus\\:text-blue-300:focus {
    --text-opacity: 1;
    color: #a4cafe;
    color: rgba(164, 202, 254, var(--text-opacity));
  }
  .lg\\:focus\\:text-blue-400:focus {
    --text-opacity: 1;
    color: #76a9fa;
    color: rgba(118, 169, 250, var(--text-opacity));
  }
  .lg\\:focus\\:text-blue-500:focus {
    --text-opacity: 1;
    color: #3f83f8;
    color: rgba(63, 131, 248, var(--text-opacity));
  }
  .lg\\:focus\\:text-blue-600:focus {
    --text-opacity: 1;
    color: #1c64f2;
    color: rgba(28, 100, 242, var(--text-opacity));
  }
  .lg\\:focus\\:text-blue-700:focus {
    --text-opacity: 1;
    color: #1a56db;
    color: rgba(26, 86, 219, var(--text-opacity));
  }
  .lg\\:focus\\:text-blue-800:focus {
    --text-opacity: 1;
    color: #1e429f;
    color: rgba(30, 66, 159, var(--text-opacity));
  }
  .lg\\:focus\\:text-blue-900:focus {
    --text-opacity: 1;
    color: #233876;
    color: rgba(35, 56, 118, var(--text-opacity));
  }
  .lg\\:focus\\:text-indigo-50:focus {
    --text-opacity: 1;
    color: #f0f5ff;
    color: rgba(240, 245, 255, var(--text-opacity));
  }
  .lg\\:focus\\:text-indigo-100:focus {
    --text-opacity: 1;
    color: #e5edff;
    color: rgba(229, 237, 255, var(--text-opacity));
  }
  .lg\\:focus\\:text-indigo-200:focus {
    --text-opacity: 1;
    color: #cddbfe;
    color: rgba(205, 219, 254, var(--text-opacity));
  }
  .lg\\:focus\\:text-indigo-300:focus {
    --text-opacity: 1;
    color: #b4c6fc;
    color: rgba(180, 198, 252, var(--text-opacity));
  }
  .lg\\:focus\\:text-indigo-400:focus {
    --text-opacity: 1;
    color: #8da2fb;
    color: rgba(141, 162, 251, var(--text-opacity));
  }
  .lg\\:focus\\:text-indigo-500:focus {
    --text-opacity: 1;
    color: #6875f5;
    color: rgba(104, 117, 245, var(--text-opacity));
  }
  .lg\\:focus\\:text-indigo-600:focus {
    --text-opacity: 1;
    color: #5850ec;
    color: rgba(88, 80, 236, var(--text-opacity));
  }
  .lg\\:focus\\:text-indigo-700:focus {
    --text-opacity: 1;
    color: #5145cd;
    color: rgba(81, 69, 205, var(--text-opacity));
  }
  .lg\\:focus\\:text-indigo-800:focus {
    --text-opacity: 1;
    color: #42389d;
    color: rgba(66, 56, 157, var(--text-opacity));
  }
  .lg\\:focus\\:text-indigo-900:focus {
    --text-opacity: 1;
    color: #362f78;
    color: rgba(54, 47, 120, var(--text-opacity));
  }
  .lg\\:focus\\:text-purple-50:focus {
    --text-opacity: 1;
    color: #f6f5ff;
    color: rgba(246, 245, 255, var(--text-opacity));
  }
  .lg\\:focus\\:text-purple-100:focus {
    --text-opacity: 1;
    color: #edebfe;
    color: rgba(237, 235, 254, var(--text-opacity));
  }
  .lg\\:focus\\:text-purple-200:focus {
    --text-opacity: 1;
    color: #dcd7fe;
    color: rgba(220, 215, 254, var(--text-opacity));
  }
  .lg\\:focus\\:text-purple-300:focus {
    --text-opacity: 1;
    color: #cabffd;
    color: rgba(202, 191, 253, var(--text-opacity));
  }
  .lg\\:focus\\:text-purple-400:focus {
    --text-opacity: 1;
    color: #ac94fa;
    color: rgba(172, 148, 250, var(--text-opacity));
  }
  .lg\\:focus\\:text-purple-500:focus {
    --text-opacity: 1;
    color: #9061f9;
    color: rgba(144, 97, 249, var(--text-opacity));
  }
  .lg\\:focus\\:text-purple-600:focus {
    --text-opacity: 1;
    color: #7e3af2;
    color: rgba(126, 58, 242, var(--text-opacity));
  }
  .lg\\:focus\\:text-purple-700:focus {
    --text-opacity: 1;
    color: #6c2bd9;
    color: rgba(108, 43, 217, var(--text-opacity));
  }
  .lg\\:focus\\:text-purple-800:focus {
    --text-opacity: 1;
    color: #5521b5;
    color: rgba(85, 33, 181, var(--text-opacity));
  }
  .lg\\:focus\\:text-purple-900:focus {
    --text-opacity: 1;
    color: #4a1d96;
    color: rgba(74, 29, 150, var(--text-opacity));
  }
  .lg\\:focus\\:text-pink-50:focus {
    --text-opacity: 1;
    color: #fdf2f8;
    color: rgba(253, 242, 248, var(--text-opacity));
  }
  .lg\\:focus\\:text-pink-100:focus {
    --text-opacity: 1;
    color: #fce8f3;
    color: rgba(252, 232, 243, var(--text-opacity));
  }
  .lg\\:focus\\:text-pink-200:focus {
    --text-opacity: 1;
    color: #fad1e8;
    color: rgba(250, 209, 232, var(--text-opacity));
  }
  .lg\\:focus\\:text-pink-300:focus {
    --text-opacity: 1;
    color: #f8b4d9;
    color: rgba(248, 180, 217, var(--text-opacity));
  }
  .lg\\:focus\\:text-pink-400:focus {
    --text-opacity: 1;
    color: #f17eb8;
    color: rgba(241, 126, 184, var(--text-opacity));
  }
  .lg\\:focus\\:text-pink-500:focus {
    --text-opacity: 1;
    color: #e74694;
    color: rgba(231, 70, 148, var(--text-opacity));
  }
  .lg\\:focus\\:text-pink-600:focus {
    --text-opacity: 1;
    color: #d61f69;
    color: rgba(214, 31, 105, var(--text-opacity));
  }
  .lg\\:focus\\:text-pink-700:focus {
    --text-opacity: 1;
    color: #bf125d;
    color: rgba(191, 18, 93, var(--text-opacity));
  }
  .lg\\:focus\\:text-pink-800:focus {
    --text-opacity: 1;
    color: #99154b;
    color: rgba(153, 21, 75, var(--text-opacity));
  }
  .lg\\:focus\\:text-pink-900:focus {
    --text-opacity: 1;
    color: #751a3d;
    color: rgba(117, 26, 61, var(--text-opacity));
  }
  .lg\\:focus\\:text-cool-gray-50:focus {
    --text-opacity: 1;
    color: #f8fafc;
    color: rgba(248, 250, 252, var(--text-opacity));
  }
  .lg\\:focus\\:text-cool-gray-100:focus {
    --text-opacity: 1;
    color: #f1f5f9;
    color: rgba(241, 245, 249, var(--text-opacity));
  }
  .lg\\:focus\\:text-cool-gray-200:focus {
    --text-opacity: 1;
    color: #e2e8f0;
    color: rgba(226, 232, 240, var(--text-opacity));
  }
  .lg\\:focus\\:text-cool-gray-300:focus {
    --text-opacity: 1;
    color: #cfd8e3;
    color: rgba(207, 216, 227, var(--text-opacity));
  }
  .lg\\:focus\\:text-cool-gray-400:focus {
    --text-opacity: 1;
    color: #97a6ba;
    color: rgba(151, 166, 186, var(--text-opacity));
  }
  .lg\\:focus\\:text-cool-gray-500:focus {
    --text-opacity: 1;
    color: #64748b;
    color: rgba(100, 116, 139, var(--text-opacity));
  }
  .lg\\:focus\\:text-cool-gray-600:focus {
    --text-opacity: 1;
    color: #475569;
    color: rgba(71, 85, 105, var(--text-opacity));
  }
  .lg\\:focus\\:text-cool-gray-700:focus {
    --text-opacity: 1;
    color: #364152;
    color: rgba(54, 65, 82, var(--text-opacity));
  }
  .lg\\:focus\\:text-cool-gray-800:focus {
    --text-opacity: 1;
    color: #27303f;
    color: rgba(39, 48, 63, var(--text-opacity));
  }
  .lg\\:focus\\:text-cool-gray-900:focus {
    --text-opacity: 1;
    color: #1a202e;
    color: rgba(26, 32, 46, var(--text-opacity));
  }
  .lg\\:active\\:text-current:active {
    color: currentColor;
  }
  .lg\\:active\\:text-transparent:active {
    color: transparent;
  }
  .lg\\:active\\:text-white:active {
    --text-opacity: 1;
    color: #ffffff;
    color: rgba(255, 255, 255, var(--text-opacity));
  }
  .lg\\:active\\:text-black:active {
    --text-opacity: 1;
    color: #000000;
    color: rgba(0, 0, 0, var(--text-opacity));
  }
  .lg\\:active\\:text-gray-50:active {
    --text-opacity: 1;
    color: #f9fafb;
    color: rgba(249, 250, 251, var(--text-opacity));
  }
  .lg\\:active\\:text-gray-100:active {
    --text-opacity: 1;
    color: #f4f5f7;
    color: rgba(244, 245, 247, var(--text-opacity));
  }
  .lg\\:active\\:text-gray-200:active {
    --text-opacity: 1;
    color: #e5e7eb;
    color: rgba(229, 231, 235, var(--text-opacity));
  }
  .lg\\:active\\:text-gray-300:active {
    --text-opacity: 1;
    color: #d2d6dc;
    color: rgba(210, 214, 220, var(--text-opacity));
  }
  .lg\\:active\\:text-gray-400:active {
    --text-opacity: 1;
    color: #9fa6b2;
    color: rgba(159, 166, 178, var(--text-opacity));
  }
  .lg\\:active\\:text-gray-500:active {
    --text-opacity: 1;
    color: #6b7280;
    color: rgba(107, 114, 128, var(--text-opacity));
  }
  .lg\\:active\\:text-gray-600:active {
    --text-opacity: 1;
    color: #4b5563;
    color: rgba(75, 85, 99, var(--text-opacity));
  }
  .lg\\:active\\:text-gray-700:active {
    --text-opacity: 1;
    color: #374151;
    color: rgba(55, 65, 81, var(--text-opacity));
  }
  .lg\\:active\\:text-gray-800:active {
    --text-opacity: 1;
    color: #252f3f;
    color: rgba(37, 47, 63, var(--text-opacity));
  }
  .lg\\:active\\:text-gray-900:active {
    --text-opacity: 1;
    color: #161e2e;
    color: rgba(22, 30, 46, var(--text-opacity));
  }
  .lg\\:active\\:text-red-50:active {
    --text-opacity: 1;
    color: #fdf2f2;
    color: rgba(253, 242, 242, var(--text-opacity));
  }
  .lg\\:active\\:text-red-100:active {
    --text-opacity: 1;
    color: #fde8e8;
    color: rgba(253, 232, 232, var(--text-opacity));
  }
  .lg\\:active\\:text-red-200:active {
    --text-opacity: 1;
    color: #fbd5d5;
    color: rgba(251, 213, 213, var(--text-opacity));
  }
  .lg\\:active\\:text-red-300:active {
    --text-opacity: 1;
    color: #f8b4b4;
    color: rgba(248, 180, 180, var(--text-opacity));
  }
  .lg\\:active\\:text-red-400:active {
    --text-opacity: 1;
    color: #f98080;
    color: rgba(249, 128, 128, var(--text-opacity));
  }
  .lg\\:active\\:text-red-500:active {
    --text-opacity: 1;
    color: #f05252;
    color: rgba(240, 82, 82, var(--text-opacity));
  }
  .lg\\:active\\:text-red-600:active {
    --text-opacity: 1;
    color: #e02424;
    color: rgba(224, 36, 36, var(--text-opacity));
  }
  .lg\\:active\\:text-red-700:active {
    --text-opacity: 1;
    color: #c81e1e;
    color: rgba(200, 30, 30, var(--text-opacity));
  }
  .lg\\:active\\:text-red-800:active {
    --text-opacity: 1;
    color: #9b1c1c;
    color: rgba(155, 28, 28, var(--text-opacity));
  }
  .lg\\:active\\:text-red-900:active {
    --text-opacity: 1;
    color: #771d1d;
    color: rgba(119, 29, 29, var(--text-opacity));
  }
  .lg\\:active\\:text-orange-50:active {
    --text-opacity: 1;
    color: #fff8f1;
    color: rgba(255, 248, 241, var(--text-opacity));
  }
  .lg\\:active\\:text-orange-100:active {
    --text-opacity: 1;
    color: #feecdc;
    color: rgba(254, 236, 220, var(--text-opacity));
  }
  .lg\\:active\\:text-orange-200:active {
    --text-opacity: 1;
    color: #fcd9bd;
    color: rgba(252, 217, 189, var(--text-opacity));
  }
  .lg\\:active\\:text-orange-300:active {
    --text-opacity: 1;
    color: #fdba8c;
    color: rgba(253, 186, 140, var(--text-opacity));
  }
  .lg\\:active\\:text-orange-400:active {
    --text-opacity: 1;
    color: #ff8a4c;
    color: rgba(255, 138, 76, var(--text-opacity));
  }
  .lg\\:active\\:text-orange-500:active {
    --text-opacity: 1;
    color: #ff5a1f;
    color: rgba(255, 90, 31, var(--text-opacity));
  }
  .lg\\:active\\:text-orange-600:active {
    --text-opacity: 1;
    color: #d03801;
    color: rgba(208, 56, 1, var(--text-opacity));
  }
  .lg\\:active\\:text-orange-700:active {
    --text-opacity: 1;
    color: #b43403;
    color: rgba(180, 52, 3, var(--text-opacity));
  }
  .lg\\:active\\:text-orange-800:active {
    --text-opacity: 1;
    color: #8a2c0d;
    color: rgba(138, 44, 13, var(--text-opacity));
  }
  .lg\\:active\\:text-orange-900:active {
    --text-opacity: 1;
    color: #73230d;
    color: rgba(115, 35, 13, var(--text-opacity));
  }
  .lg\\:active\\:text-yellow-50:active {
    --text-opacity: 1;
    color: #fdfdea;
    color: rgba(253, 253, 234, var(--text-opacity));
  }
  .lg\\:active\\:text-yellow-100:active {
    --text-opacity: 1;
    color: #fdf6b2;
    color: rgba(253, 246, 178, var(--text-opacity));
  }
  .lg\\:active\\:text-yellow-200:active {
    --text-opacity: 1;
    color: #fce96a;
    color: rgba(252, 233, 106, var(--text-opacity));
  }
  .lg\\:active\\:text-yellow-300:active {
    --text-opacity: 1;
    color: #faca15;
    color: rgba(250, 202, 21, var(--text-opacity));
  }
  .lg\\:active\\:text-yellow-400:active {
    --text-opacity: 1;
    color: #e3a008;
    color: rgba(227, 160, 8, var(--text-opacity));
  }
  .lg\\:active\\:text-yellow-500:active {
    --text-opacity: 1;
    color: #c27803;
    color: rgba(194, 120, 3, var(--text-opacity));
  }
  .lg\\:active\\:text-yellow-600:active {
    --text-opacity: 1;
    color: #9f580a;
    color: rgba(159, 88, 10, var(--text-opacity));
  }
  .lg\\:active\\:text-yellow-700:active {
    --text-opacity: 1;
    color: #8e4b10;
    color: rgba(142, 75, 16, var(--text-opacity));
  }
  .lg\\:active\\:text-yellow-800:active {
    --text-opacity: 1;
    color: #723b13;
    color: rgba(114, 59, 19, var(--text-opacity));
  }
  .lg\\:active\\:text-yellow-900:active {
    --text-opacity: 1;
    color: #633112;
    color: rgba(99, 49, 18, var(--text-opacity));
  }
  .lg\\:active\\:text-green-50:active {
    --text-opacity: 1;
    color: #f3faf7;
    color: rgba(243, 250, 247, var(--text-opacity));
  }
  .lg\\:active\\:text-green-100:active {
    --text-opacity: 1;
    color: #def7ec;
    color: rgba(222, 247, 236, var(--text-opacity));
  }
  .lg\\:active\\:text-green-200:active {
    --text-opacity: 1;
    color: #bcf0da;
    color: rgba(188, 240, 218, var(--text-opacity));
  }
  .lg\\:active\\:text-green-300:active {
    --text-opacity: 1;
    color: #84e1bc;
    color: rgba(132, 225, 188, var(--text-opacity));
  }
  .lg\\:active\\:text-green-400:active {
    --text-opacity: 1;
    color: #31c48d;
    color: rgba(49, 196, 141, var(--text-opacity));
  }
  .lg\\:active\\:text-green-500:active {
    --text-opacity: 1;
    color: #0e9f6e;
    color: rgba(14, 159, 110, var(--text-opacity));
  }
  .lg\\:active\\:text-green-600:active {
    --text-opacity: 1;
    color: #057a55;
    color: rgba(5, 122, 85, var(--text-opacity));
  }
  .lg\\:active\\:text-green-700:active {
    --text-opacity: 1;
    color: #046c4e;
    color: rgba(4, 108, 78, var(--text-opacity));
  }
  .lg\\:active\\:text-green-800:active {
    --text-opacity: 1;
    color: #03543f;
    color: rgba(3, 84, 63, var(--text-opacity));
  }
  .lg\\:active\\:text-green-900:active {
    --text-opacity: 1;
    color: #014737;
    color: rgba(1, 71, 55, var(--text-opacity));
  }
  .lg\\:active\\:text-teal-50:active {
    --text-opacity: 1;
    color: #edfafa;
    color: rgba(237, 250, 250, var(--text-opacity));
  }
  .lg\\:active\\:text-teal-100:active {
    --text-opacity: 1;
    color: #d5f5f6;
    color: rgba(213, 245, 246, var(--text-opacity));
  }
  .lg\\:active\\:text-teal-200:active {
    --text-opacity: 1;
    color: #afecef;
    color: rgba(175, 236, 239, var(--text-opacity));
  }
  .lg\\:active\\:text-teal-300:active {
    --text-opacity: 1;
    color: #7edce2;
    color: rgba(126, 220, 226, var(--text-opacity));
  }
  .lg\\:active\\:text-teal-400:active {
    --text-opacity: 1;
    color: #16bdca;
    color: rgba(22, 189, 202, var(--text-opacity));
  }
  .lg\\:active\\:text-teal-500:active {
    --text-opacity: 1;
    color: #0694a2;
    color: rgba(6, 148, 162, var(--text-opacity));
  }
  .lg\\:active\\:text-teal-600:active {
    --text-opacity: 1;
    color: #047481;
    color: rgba(4, 116, 129, var(--text-opacity));
  }
  .lg\\:active\\:text-teal-700:active {
    --text-opacity: 1;
    color: #036672;
    color: rgba(3, 102, 114, var(--text-opacity));
  }
  .lg\\:active\\:text-teal-800:active {
    --text-opacity: 1;
    color: #05505c;
    color: rgba(5, 80, 92, var(--text-opacity));
  }
  .lg\\:active\\:text-teal-900:active {
    --text-opacity: 1;
    color: #014451;
    color: rgba(1, 68, 81, var(--text-opacity));
  }
  .lg\\:active\\:text-blue-50:active {
    --text-opacity: 1;
    color: #ebf5ff;
    color: rgba(235, 245, 255, var(--text-opacity));
  }
  .lg\\:active\\:text-blue-100:active {
    --text-opacity: 1;
    color: #e1effe;
    color: rgba(225, 239, 254, var(--text-opacity));
  }
  .lg\\:active\\:text-blue-200:active {
    --text-opacity: 1;
    color: #c3ddfd;
    color: rgba(195, 221, 253, var(--text-opacity));
  }
  .lg\\:active\\:text-blue-300:active {
    --text-opacity: 1;
    color: #a4cafe;
    color: rgba(164, 202, 254, var(--text-opacity));
  }
  .lg\\:active\\:text-blue-400:active {
    --text-opacity: 1;
    color: #76a9fa;
    color: rgba(118, 169, 250, var(--text-opacity));
  }
  .lg\\:active\\:text-blue-500:active {
    --text-opacity: 1;
    color: #3f83f8;
    color: rgba(63, 131, 248, var(--text-opacity));
  }
  .lg\\:active\\:text-blue-600:active {
    --text-opacity: 1;
    color: #1c64f2;
    color: rgba(28, 100, 242, var(--text-opacity));
  }
  .lg\\:active\\:text-blue-700:active {
    --text-opacity: 1;
    color: #1a56db;
    color: rgba(26, 86, 219, var(--text-opacity));
  }
  .lg\\:active\\:text-blue-800:active {
    --text-opacity: 1;
    color: #1e429f;
    color: rgba(30, 66, 159, var(--text-opacity));
  }
  .lg\\:active\\:text-blue-900:active {
    --text-opacity: 1;
    color: #233876;
    color: rgba(35, 56, 118, var(--text-opacity));
  }
  .lg\\:active\\:text-indigo-50:active {
    --text-opacity: 1;
    color: #f0f5ff;
    color: rgba(240, 245, 255, var(--text-opacity));
  }
  .lg\\:active\\:text-indigo-100:active {
    --text-opacity: 1;
    color: #e5edff;
    color: rgba(229, 237, 255, var(--text-opacity));
  }
  .lg\\:active\\:text-indigo-200:active {
    --text-opacity: 1;
    color: #cddbfe;
    color: rgba(205, 219, 254, var(--text-opacity));
  }
  .lg\\:active\\:text-indigo-300:active {
    --text-opacity: 1;
    color: #b4c6fc;
    color: rgba(180, 198, 252, var(--text-opacity));
  }
  .lg\\:active\\:text-indigo-400:active {
    --text-opacity: 1;
    color: #8da2fb;
    color: rgba(141, 162, 251, var(--text-opacity));
  }
  .lg\\:active\\:text-indigo-500:active {
    --text-opacity: 1;
    color: #6875f5;
    color: rgba(104, 117, 245, var(--text-opacity));
  }
  .lg\\:active\\:text-indigo-600:active {
    --text-opacity: 1;
    color: #5850ec;
    color: rgba(88, 80, 236, var(--text-opacity));
  }
  .lg\\:active\\:text-indigo-700:active {
    --text-opacity: 1;
    color: #5145cd;
    color: rgba(81, 69, 205, var(--text-opacity));
  }
  .lg\\:active\\:text-indigo-800:active {
    --text-opacity: 1;
    color: #42389d;
    color: rgba(66, 56, 157, var(--text-opacity));
  }
  .lg\\:active\\:text-indigo-900:active {
    --text-opacity: 1;
    color: #362f78;
    color: rgba(54, 47, 120, var(--text-opacity));
  }
  .lg\\:active\\:text-purple-50:active {
    --text-opacity: 1;
    color: #f6f5ff;
    color: rgba(246, 245, 255, var(--text-opacity));
  }
  .lg\\:active\\:text-purple-100:active {
    --text-opacity: 1;
    color: #edebfe;
    color: rgba(237, 235, 254, var(--text-opacity));
  }
  .lg\\:active\\:text-purple-200:active {
    --text-opacity: 1;
    color: #dcd7fe;
    color: rgba(220, 215, 254, var(--text-opacity));
  }
  .lg\\:active\\:text-purple-300:active {
    --text-opacity: 1;
    color: #cabffd;
    color: rgba(202, 191, 253, var(--text-opacity));
  }
  .lg\\:active\\:text-purple-400:active {
    --text-opacity: 1;
    color: #ac94fa;
    color: rgba(172, 148, 250, var(--text-opacity));
  }
  .lg\\:active\\:text-purple-500:active {
    --text-opacity: 1;
    color: #9061f9;
    color: rgba(144, 97, 249, var(--text-opacity));
  }
  .lg\\:active\\:text-purple-600:active {
    --text-opacity: 1;
    color: #7e3af2;
    color: rgba(126, 58, 242, var(--text-opacity));
  }
  .lg\\:active\\:text-purple-700:active {
    --text-opacity: 1;
    color: #6c2bd9;
    color: rgba(108, 43, 217, var(--text-opacity));
  }
  .lg\\:active\\:text-purple-800:active {
    --text-opacity: 1;
    color: #5521b5;
    color: rgba(85, 33, 181, var(--text-opacity));
  }
  .lg\\:active\\:text-purple-900:active {
    --text-opacity: 1;
    color: #4a1d96;
    color: rgba(74, 29, 150, var(--text-opacity));
  }
  .lg\\:active\\:text-pink-50:active {
    --text-opacity: 1;
    color: #fdf2f8;
    color: rgba(253, 242, 248, var(--text-opacity));
  }
  .lg\\:active\\:text-pink-100:active {
    --text-opacity: 1;
    color: #fce8f3;
    color: rgba(252, 232, 243, var(--text-opacity));
  }
  .lg\\:active\\:text-pink-200:active {
    --text-opacity: 1;
    color: #fad1e8;
    color: rgba(250, 209, 232, var(--text-opacity));
  }
  .lg\\:active\\:text-pink-300:active {
    --text-opacity: 1;
    color: #f8b4d9;
    color: rgba(248, 180, 217, var(--text-opacity));
  }
  .lg\\:active\\:text-pink-400:active {
    --text-opacity: 1;
    color: #f17eb8;
    color: rgba(241, 126, 184, var(--text-opacity));
  }
  .lg\\:active\\:text-pink-500:active {
    --text-opacity: 1;
    color: #e74694;
    color: rgba(231, 70, 148, var(--text-opacity));
  }
  .lg\\:active\\:text-pink-600:active {
    --text-opacity: 1;
    color: #d61f69;
    color: rgba(214, 31, 105, var(--text-opacity));
  }
  .lg\\:active\\:text-pink-700:active {
    --text-opacity: 1;
    color: #bf125d;
    color: rgba(191, 18, 93, var(--text-opacity));
  }
  .lg\\:active\\:text-pink-800:active {
    --text-opacity: 1;
    color: #99154b;
    color: rgba(153, 21, 75, var(--text-opacity));
  }
  .lg\\:active\\:text-pink-900:active {
    --text-opacity: 1;
    color: #751a3d;
    color: rgba(117, 26, 61, var(--text-opacity));
  }
  .lg\\:active\\:text-cool-gray-50:active {
    --text-opacity: 1;
    color: #f8fafc;
    color: rgba(248, 250, 252, var(--text-opacity));
  }
  .lg\\:active\\:text-cool-gray-100:active {
    --text-opacity: 1;
    color: #f1f5f9;
    color: rgba(241, 245, 249, var(--text-opacity));
  }
  .lg\\:active\\:text-cool-gray-200:active {
    --text-opacity: 1;
    color: #e2e8f0;
    color: rgba(226, 232, 240, var(--text-opacity));
  }
  .lg\\:active\\:text-cool-gray-300:active {
    --text-opacity: 1;
    color: #cfd8e3;
    color: rgba(207, 216, 227, var(--text-opacity));
  }
  .lg\\:active\\:text-cool-gray-400:active {
    --text-opacity: 1;
    color: #97a6ba;
    color: rgba(151, 166, 186, var(--text-opacity));
  }
  .lg\\:active\\:text-cool-gray-500:active {
    --text-opacity: 1;
    color: #64748b;
    color: rgba(100, 116, 139, var(--text-opacity));
  }
  .lg\\:active\\:text-cool-gray-600:active {
    --text-opacity: 1;
    color: #475569;
    color: rgba(71, 85, 105, var(--text-opacity));
  }
  .lg\\:active\\:text-cool-gray-700:active {
    --text-opacity: 1;
    color: #364152;
    color: rgba(54, 65, 82, var(--text-opacity));
  }
  .lg\\:active\\:text-cool-gray-800:active {
    --text-opacity: 1;
    color: #27303f;
    color: rgba(39, 48, 63, var(--text-opacity));
  }
  .lg\\:active\\:text-cool-gray-900:active {
    --text-opacity: 1;
    color: #1a202e;
    color: rgba(26, 32, 46, var(--text-opacity));
  }
  .lg\\:text-opacity-0 {
    --text-opacity: 0;
  }
  .lg\\:text-opacity-25 {
    --text-opacity: 0.25;
  }
  .lg\\:text-opacity-50 {
    --text-opacity: 0.5;
  }
  .lg\\:text-opacity-75 {
    --text-opacity: 0.75;
  }
  .lg\\:text-opacity-100 {
    --text-opacity: 1;
  }
  .lg\\:hover\\:text-opacity-0:hover {
    --text-opacity: 0;
  }
  .lg\\:hover\\:text-opacity-25:hover {
    --text-opacity: 0.25;
  }
  .lg\\:hover\\:text-opacity-50:hover {
    --text-opacity: 0.5;
  }
  .lg\\:hover\\:text-opacity-75:hover {
    --text-opacity: 0.75;
  }
  .lg\\:hover\\:text-opacity-100:hover {
    --text-opacity: 1;
  }
  .lg\\:focus\\:text-opacity-0:focus {
    --text-opacity: 0;
  }
  .lg\\:focus\\:text-opacity-25:focus {
    --text-opacity: 0.25;
  }
  .lg\\:focus\\:text-opacity-50:focus {
    --text-opacity: 0.5;
  }
  .lg\\:focus\\:text-opacity-75:focus {
    --text-opacity: 0.75;
  }
  .lg\\:focus\\:text-opacity-100:focus {
    --text-opacity: 1;
  }
  .lg\\:italic {
    font-style: italic;
  }
  .lg\\:not-italic {
    font-style: normal;
  }
  .lg\\:uppercase {
    text-transform: uppercase;
  }
  .lg\\:lowercase {
    text-transform: lowercase;
  }
  .lg\\:capitalize {
    text-transform: capitalize;
  }
  .lg\\:normal-case {
    text-transform: none;
  }
  .lg\\:underline {
    text-decoration: none;
  }
  .lg\\:line-through {
    text-decoration: line-through;
  }
  .lg\\:no-underline {
    text-decoration: none;
  }
  .group:hover .lg\\:group-hover\\:underline {
    text-decoration: none;
  }
  .group:hover .lg\\:group-hover\\:line-through {
    text-decoration: line-through;
  }
  .group:hover .lg\\:group-hover\\:no-underline {
    text-decoration: none;
  }
  .group:focus .lg\\:group-focus\\:underline {
    text-decoration: none;
  }
  .group:focus .lg\\:group-focus\\:line-through {
    text-decoration: line-through;
  }
  .group:focus .lg\\:group-focus\\:no-underline {
    text-decoration: none;
  }
  .lg\\:hover\\:underline:hover {
    text-decoration: none;
  }
  .lg\\:hover\\:line-through:hover {
    text-decoration: line-through;
  }
  .lg\\:hover\\:no-underline:hover {
    text-decoration: none;
  }
  .lg\\:focus\\:underline:focus {
    text-decoration: none;
  }
  .lg\\:focus\\:line-through:focus {
    text-decoration: line-through;
  }
  .lg\\:focus\\:no-underline:focus {
    text-decoration: none;
  }
  .lg\\:antialiased {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
  .lg\\:subpixel-antialiased {
    -webkit-font-smoothing: auto;
    -moz-osx-font-smoothing: auto;
  }
  .lg\\:ordinal, .lg\\:slashed-zero, .lg\\:lining-nums, .lg\\:oldstyle-nums, .lg\\:proportional-nums, .lg\\:tabular-nums, .lg\\:diagonal-fractions, .lg\\:stacked-fractions {
    --font-variant-numeric-ordinal: var(--tailwind-empty,
        /*!*/
        /*!*/
      );
    --font-variant-numeric-slashed-zero: var(--tailwind-empty,
        /*!*/
        /*!*/
      );
    --font-variant-numeric-figure: var(--tailwind-empty,
        /*!*/
        /*!*/
      );
    --font-variant-numeric-spacing: var(--tailwind-empty,
        /*!*/
        /*!*/
      );
    --font-variant-numeric-fraction: var(--tailwind-empty,
        /*!*/
        /*!*/
      );
    font-variant-numeric: var(--font-variant-numeric-ordinal) var(--font-variant-numeric-slashed-zero) var(--font-variant-numeric-figure) var(--font-variant-numeric-spacing) var(--font-variant-numeric-fraction);
  }
  .lg\\:normal-nums {
    font-variant-numeric: normal;
  }
  .lg\\:ordinal {
    --font-variant-numeric-ordinal: ordinal;
  }
  .lg\\:slashed-zero {
    --font-variant-numeric-slashed-zero: slashed-zero;
  }
  .lg\\:lining-nums {
    --font-variant-numeric-figure: lining-nums;
  }
  .lg\\:oldstyle-nums {
    --font-variant-numeric-figure: oldstyle-nums;
  }
  .lg\\:proportional-nums {
    --font-variant-numeric-spacing: proportional-nums;
  }
  .lg\\:tabular-nums {
    --font-variant-numeric-spacing: tabular-nums;
  }
  .lg\\:diagonal-fractions {
    --font-variant-numeric-fraction: diagonal-fractions;
  }
  .lg\\:stacked-fractions {
    --font-variant-numeric-fraction: stacked-fractions;
  }
  .lg\\:tracking-tighter {
    letter-spacing: -0.05em;
  }
  .lg\\:tracking-tight {
    letter-spacing: -0.025em;
  }
  .lg\\:tracking-normal {
    letter-spacing: 0;
  }
  .lg\\:tracking-wide {
    letter-spacing: 0.025em;
  }
  .lg\\:tracking-wider {
    letter-spacing: 0.05em;
  }
  .lg\\:tracking-widest {
    letter-spacing: 0.1em;
  }
  .lg\\:select-none {
    -webkit-user-select: none;
    user-select: none;
  }
  .lg\\:select-text {
    -webkit-user-select: text;
    user-select: text;
  }
  .lg\\:select-all {
    -webkit-user-select: all;
    user-select: all;
  }
  .lg\\:select-auto {
    -webkit-user-select: auto;
    user-select: auto;
  }
  .lg\\:align-baseline {
    vertical-align: baseline;
  }
  .lg\\:align-top {
    vertical-align: top;
  }
  .lg\\:align-middle {
    vertical-align: middle;
  }
  .lg\\:align-bottom {
    vertical-align: bottom;
  }
  .lg\\:align-text-top {
    vertical-align: text-top;
  }
  .lg\\:align-text-bottom {
    vertical-align: text-bottom;
  }
  .lg\\:visible {
    visibility: visible;
  }
  .lg\\:invisible {
    visibility: hidden;
  }
  .lg\\:whitespace-normal {
    white-space: normal;
  }
  .lg\\:whitespace-no-wrap {
    white-space: nowrap;
  }
  .lg\\:whitespace-pre {
    white-space: pre;
  }
  .lg\\:whitespace-pre-line {
    white-space: pre-line;
  }
  .lg\\:whitespace-pre-wrap {
    white-space: pre-wrap;
  }
  .lg\\:break-normal {
    word-wrap: normal;
    overflow-wrap: normal;
    word-break: normal;
  }
  .lg\\:break-words {
    word-wrap: break-word;
    overflow-wrap: break-word;
  }
  .lg\\:break-all {
    word-break: break-all;
  }
  .lg\\:truncate {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .lg\\:w-0 {
    width: 0;
  }
  .lg\\:w-1 {
    width: 0.25rem;
  }
  .lg\\:w-2 {
    width: 0.5rem;
  }
  .lg\\:w-3 {
    width: 0.75rem;
  }
  .lg\\:w-4 {
    width: 1rem;
  }
  .lg\\:w-5 {
    width: 1.25rem;
  }
  .lg\\:w-6 {
    width: 1.5rem;
  }
  .lg\\:w-7 {
    width: 1.75rem;
  }
  .lg\\:w-8 {
    width: 2rem;
  }
  .lg\\:w-9 {
    width: 2.25rem;
  }
  .lg\\:w-10 {
    width: 2.5rem;
  }
  .lg\\:w-11 {
    width: 2.75rem;
  }
  .lg\\:w-12 {
    width: 3rem;
  }
  .lg\\:w-13 {
    width: 3.25rem;
  }
  .lg\\:w-14 {
    width: 3.5rem;
  }
  .lg\\:w-15 {
    width: 3.75rem;
  }
  .lg\\:w-16 {
    width: 4rem;
  }
  .lg\\:w-20 {
    width: 5rem;
  }
  .lg\\:w-24 {
    width: 6rem;
  }
  .lg\\:w-28 {
    width: 7rem;
  }
  .lg\\:w-32 {
    width: 8rem;
  }
  .lg\\:w-36 {
    width: 9rem;
  }
  .lg\\:w-40 {
    width: 10rem;
  }
  .lg\\:w-44 {
    width: 11rem;
  }
  .lg\\:w-48 {
    width: 12rem;
  }
  .lg\\:w-52 {
    width: 13rem;
  }
  .lg\\:w-56 {
    width: 14rem;
  }
  .lg\\:w-60 {
    width: 15rem;
  }
  .lg\\:w-64 {
    width: 16rem;
  }
  .lg\\:w-72 {
    width: 18rem;
  }
  .lg\\:w-80 {
    width: 20rem;
  }
  .lg\\:w-96 {
    width: 24rem;
  }
  .lg\\:w-auto {
    width: auto;
  }
  .lg\\:w-px {
    width: 1px;
  }
  .lg\\:w-0\\.5 {
    width: 0.125rem;
  }
  .lg\\:w-1\\.5 {
    width: 0.375rem;
  }
  .lg\\:w-2\\.5 {
    width: 0.625rem;
  }
  .lg\\:w-3\\.5 {
    width: 0.875rem;
  }
  .lg\\:w-1\\/2 {
    width: 50%;
  }
  .lg\\:w-1\\/3 {
    width: 33.333333%;
  }
  .lg\\:w-2\\/3 {
    width: 66.666667%;
  }
  .lg\\:w-1\\/4 {
    width: 25%;
  }
  .lg\\:w-2\\/4 {
    width: 50%;
  }
  .lg\\:w-3\\/4 {
    width: 75%;
  }
  .lg\\:w-1\\/5 {
    width: 20%;
  }
  .lg\\:w-2\\/5 {
    width: 40%;
  }
  .lg\\:w-3\\/5 {
    width: 60%;
  }
  .lg\\:w-4\\/5 {
    width: 80%;
  }
  .lg\\:w-1\\/6 {
    width: 16.666667%;
  }
  .lg\\:w-2\\/6 {
    width: 33.333333%;
  }
  .lg\\:w-3\\/6 {
    width: 50%;
  }
  .lg\\:w-4\\/6 {
    width: 66.666667%;
  }
  .lg\\:w-5\\/6 {
    width: 83.333333%;
  }
  .lg\\:w-1\\/12 {
    width: 8.333333%;
  }
  .lg\\:w-2\\/12 {
    width: 16.666667%;
  }
  .lg\\:w-3\\/12 {
    width: 25%;
  }
  .lg\\:w-4\\/12 {
    width: 33.333333%;
  }
  .lg\\:w-5\\/12 {
    width: 41.666667%;
  }
  .lg\\:w-6\\/12 {
    width: 50%;
  }
  .lg\\:w-7\\/12 {
    width: 58.333333%;
  }
  .lg\\:w-8\\/12 {
    width: 66.666667%;
  }
  .lg\\:w-9\\/12 {
    width: 75%;
  }
  .lg\\:w-10\\/12 {
    width: 83.333333%;
  }
  .lg\\:w-11\\/12 {
    width: 91.666667%;
  }
  .lg\\:w-full {
    width: 100%;
  }
  .lg\\:w-screen {
    width: 100vw;
  }
  .lg\\:w-min-content {
    width: min-content;
  }
  .lg\\:w-max-content {
    width: max-content;
  }
  .lg\\:z-0 {
    z-index: 0;
  }
  .lg\\:z-10 {
    z-index: 10;
  }
  .lg\\:z-20 {
    z-index: 20;
  }
  .lg\\:z-30 {
    z-index: 30;
  }
  .lg\\:z-40 {
    z-index: 40;
  }
  .lg\\:z-50 {
    z-index: 50;
  }
  .lg\\:z-auto {
    z-index: auto;
  }
  .lg\\:focus-within\\:z-0:focus-within {
    z-index: 0;
  }
  .lg\\:focus-within\\:z-10:focus-within {
    z-index: 10;
  }
  .lg\\:focus-within\\:z-20:focus-within {
    z-index: 20;
  }
  .lg\\:focus-within\\:z-30:focus-within {
    z-index: 30;
  }
  .lg\\:focus-within\\:z-40:focus-within {
    z-index: 40;
  }
  .lg\\:focus-within\\:z-50:focus-within {
    z-index: 50;
  }
  .lg\\:focus-within\\:z-auto:focus-within {
    z-index: auto;
  }
  .lg\\:focus\\:z-0:focus {
    z-index: 0;
  }
  .lg\\:focus\\:z-10:focus {
    z-index: 10;
  }
  .lg\\:focus\\:z-20:focus {
    z-index: 20;
  }
  .lg\\:focus\\:z-30:focus {
    z-index: 30;
  }
  .lg\\:focus\\:z-40:focus {
    z-index: 40;
  }
  .lg\\:focus\\:z-50:focus {
    z-index: 50;
  }
  .lg\\:focus\\:z-auto:focus {
    z-index: auto;
  }
  .lg\\:gap-0 {
    grid-gap: 0;
    gap: 0;
  }
  .lg\\:gap-1 {
    grid-gap: 0.25rem;
    gap: 0.25rem;
  }
  .lg\\:gap-2 {
    grid-gap: 0.5rem;
    gap: 0.5rem;
  }
  .lg\\:gap-3 {
    grid-gap: 0.75rem;
    gap: 0.75rem;
  }
  .lg\\:gap-4 {
    grid-gap: 1rem;
    gap: 1rem;
  }
  .lg\\:gap-5 {
    grid-gap: 1.25rem;
    gap: 1.25rem;
  }
  .lg\\:gap-6 {
    grid-gap: 1.5rem;
    gap: 1.5rem;
  }
  .lg\\:gap-7 {
    grid-gap: 1.75rem;
    gap: 1.75rem;
  }
  .lg\\:gap-8 {
    grid-gap: 2rem;
    gap: 2rem;
  }
  .lg\\:gap-9 {
    grid-gap: 2.25rem;
    gap: 2.25rem;
  }
  .lg\\:gap-10 {
    grid-gap: 2.5rem;
    gap: 2.5rem;
  }
  .lg\\:gap-11 {
    grid-gap: 2.75rem;
    gap: 2.75rem;
  }
  .lg\\:gap-12 {
    grid-gap: 3rem;
    gap: 3rem;
  }
  .lg\\:gap-13 {
    grid-gap: 3.25rem;
    gap: 3.25rem;
  }
  .lg\\:gap-14 {
    grid-gap: 3.5rem;
    gap: 3.5rem;
  }
  .lg\\:gap-15 {
    grid-gap: 3.75rem;
    gap: 3.75rem;
  }
  .lg\\:gap-16 {
    grid-gap: 4rem;
    gap: 4rem;
  }
  .lg\\:gap-20 {
    grid-gap: 5rem;
    gap: 5rem;
  }
  .lg\\:gap-24 {
    grid-gap: 6rem;
    gap: 6rem;
  }
  .lg\\:gap-28 {
    grid-gap: 7rem;
    gap: 7rem;
  }
  .lg\\:gap-32 {
    grid-gap: 8rem;
    gap: 8rem;
  }
  .lg\\:gap-36 {
    grid-gap: 9rem;
    gap: 9rem;
  }
  .lg\\:gap-40 {
    grid-gap: 10rem;
    gap: 10rem;
  }
  .lg\\:gap-44 {
    grid-gap: 11rem;
    gap: 11rem;
  }
  .lg\\:gap-48 {
    grid-gap: 12rem;
    gap: 12rem;
  }
  .lg\\:gap-52 {
    grid-gap: 13rem;
    gap: 13rem;
  }
  .lg\\:gap-56 {
    grid-gap: 14rem;
    gap: 14rem;
  }
  .lg\\:gap-60 {
    grid-gap: 15rem;
    gap: 15rem;
  }
  .lg\\:gap-64 {
    grid-gap: 16rem;
    gap: 16rem;
  }
  .lg\\:gap-72 {
    grid-gap: 18rem;
    gap: 18rem;
  }
  .lg\\:gap-80 {
    grid-gap: 20rem;
    gap: 20rem;
  }
  .lg\\:gap-96 {
    grid-gap: 24rem;
    gap: 24rem;
  }
  .lg\\:gap-px {
    grid-gap: 1px;
    gap: 1px;
  }
  .lg\\:gap-0\\.5 {
    grid-gap: 0.125rem;
    gap: 0.125rem;
  }
  .lg\\:gap-1\\.5 {
    grid-gap: 0.375rem;
    gap: 0.375rem;
  }
  .lg\\:gap-2\\.5 {
    grid-gap: 0.625rem;
    gap: 0.625rem;
  }
  .lg\\:gap-3\\.5 {
    grid-gap: 0.875rem;
    gap: 0.875rem;
  }
  .lg\\:gap-1\\/2 {
    grid-gap: 50%;
    gap: 50%;
  }
  .lg\\:gap-1\\/3 {
    grid-gap: 33.333333%;
    gap: 33.333333%;
  }
  .lg\\:gap-2\\/3 {
    grid-gap: 66.666667%;
    gap: 66.666667%;
  }
  .lg\\:gap-1\\/4 {
    grid-gap: 25%;
    gap: 25%;
  }
  .lg\\:gap-2\\/4 {
    grid-gap: 50%;
    gap: 50%;
  }
  .lg\\:gap-3\\/4 {
    grid-gap: 75%;
    gap: 75%;
  }
  .lg\\:gap-1\\/5 {
    grid-gap: 20%;
    gap: 20%;
  }
  .lg\\:gap-2\\/5 {
    grid-gap: 40%;
    gap: 40%;
  }
  .lg\\:gap-3\\/5 {
    grid-gap: 60%;
    gap: 60%;
  }
  .lg\\:gap-4\\/5 {
    grid-gap: 80%;
    gap: 80%;
  }
  .lg\\:gap-1\\/6 {
    grid-gap: 16.666667%;
    gap: 16.666667%;
  }
  .lg\\:gap-2\\/6 {
    grid-gap: 33.333333%;
    gap: 33.333333%;
  }
  .lg\\:gap-3\\/6 {
    grid-gap: 50%;
    gap: 50%;
  }
  .lg\\:gap-4\\/6 {
    grid-gap: 66.666667%;
    gap: 66.666667%;
  }
  .lg\\:gap-5\\/6 {
    grid-gap: 83.333333%;
    gap: 83.333333%;
  }
  .lg\\:gap-1\\/12 {
    grid-gap: 8.333333%;
    gap: 8.333333%;
  }
  .lg\\:gap-2\\/12 {
    grid-gap: 16.666667%;
    gap: 16.666667%;
  }
  .lg\\:gap-3\\/12 {
    grid-gap: 25%;
    gap: 25%;
  }
  .lg\\:gap-4\\/12 {
    grid-gap: 33.333333%;
    gap: 33.333333%;
  }
  .lg\\:gap-5\\/12 {
    grid-gap: 41.666667%;
    gap: 41.666667%;
  }
  .lg\\:gap-6\\/12 {
    grid-gap: 50%;
    gap: 50%;
  }
  .lg\\:gap-7\\/12 {
    grid-gap: 58.333333%;
    gap: 58.333333%;
  }
  .lg\\:gap-8\\/12 {
    grid-gap: 66.666667%;
    gap: 66.666667%;
  }
  .lg\\:gap-9\\/12 {
    grid-gap: 75%;
    gap: 75%;
  }
  .lg\\:gap-10\\/12 {
    grid-gap: 83.333333%;
    gap: 83.333333%;
  }
  .lg\\:gap-11\\/12 {
    grid-gap: 91.666667%;
    gap: 91.666667%;
  }
  .lg\\:gap-full {
    grid-gap: 100%;
    gap: 100%;
  }
  .lg\\:col-gap-0 {
    grid-column-gap: 0;
    column-gap: 0;
  }
  .lg\\:col-gap-1 {
    grid-column-gap: 0.25rem;
    column-gap: 0.25rem;
  }
  .lg\\:col-gap-2 {
    grid-column-gap: 0.5rem;
    column-gap: 0.5rem;
  }
  .lg\\:col-gap-3 {
    grid-column-gap: 0.75rem;
    column-gap: 0.75rem;
  }
  .lg\\:col-gap-4 {
    grid-column-gap: 1rem;
    column-gap: 1rem;
  }
  .lg\\:col-gap-5 {
    grid-column-gap: 1.25rem;
    column-gap: 1.25rem;
  }
  .lg\\:col-gap-6 {
    grid-column-gap: 1.5rem;
    column-gap: 1.5rem;
  }
  .lg\\:col-gap-7 {
    grid-column-gap: 1.75rem;
    column-gap: 1.75rem;
  }
  .lg\\:col-gap-8 {
    grid-column-gap: 2rem;
    column-gap: 2rem;
  }
  .lg\\:col-gap-9 {
    grid-column-gap: 2.25rem;
    column-gap: 2.25rem;
  }
  .lg\\:col-gap-10 {
    grid-column-gap: 2.5rem;
    column-gap: 2.5rem;
  }
  .lg\\:col-gap-11 {
    grid-column-gap: 2.75rem;
    column-gap: 2.75rem;
  }
  .lg\\:col-gap-12 {
    grid-column-gap: 3rem;
    column-gap: 3rem;
  }
  .lg\\:col-gap-13 {
    grid-column-gap: 3.25rem;
    column-gap: 3.25rem;
  }
  .lg\\:col-gap-14 {
    grid-column-gap: 3.5rem;
    column-gap: 3.5rem;
  }
  .lg\\:col-gap-15 {
    grid-column-gap: 3.75rem;
    column-gap: 3.75rem;
  }
  .lg\\:col-gap-16 {
    grid-column-gap: 4rem;
    column-gap: 4rem;
  }
  .lg\\:col-gap-20 {
    grid-column-gap: 5rem;
    column-gap: 5rem;
  }
  .lg\\:col-gap-24 {
    grid-column-gap: 6rem;
    column-gap: 6rem;
  }
  .lg\\:col-gap-28 {
    grid-column-gap: 7rem;
    column-gap: 7rem;
  }
  .lg\\:col-gap-32 {
    grid-column-gap: 8rem;
    column-gap: 8rem;
  }
  .lg\\:col-gap-36 {
    grid-column-gap: 9rem;
    column-gap: 9rem;
  }
  .lg\\:col-gap-40 {
    grid-column-gap: 10rem;
    column-gap: 10rem;
  }
  .lg\\:col-gap-44 {
    grid-column-gap: 11rem;
    column-gap: 11rem;
  }
  .lg\\:col-gap-48 {
    grid-column-gap: 12rem;
    column-gap: 12rem;
  }
  .lg\\:col-gap-52 {
    grid-column-gap: 13rem;
    column-gap: 13rem;
  }
  .lg\\:col-gap-56 {
    grid-column-gap: 14rem;
    column-gap: 14rem;
  }
  .lg\\:col-gap-60 {
    grid-column-gap: 15rem;
    column-gap: 15rem;
  }
  .lg\\:col-gap-64 {
    grid-column-gap: 16rem;
    column-gap: 16rem;
  }
  .lg\\:col-gap-72 {
    grid-column-gap: 18rem;
    column-gap: 18rem;
  }
  .lg\\:col-gap-80 {
    grid-column-gap: 20rem;
    column-gap: 20rem;
  }
  .lg\\:col-gap-96 {
    grid-column-gap: 24rem;
    column-gap: 24rem;
  }
  .lg\\:col-gap-px {
    grid-column-gap: 1px;
    column-gap: 1px;
  }
  .lg\\:col-gap-0\\.5 {
    grid-column-gap: 0.125rem;
    column-gap: 0.125rem;
  }
  .lg\\:col-gap-1\\.5 {
    grid-column-gap: 0.375rem;
    column-gap: 0.375rem;
  }
  .lg\\:col-gap-2\\.5 {
    grid-column-gap: 0.625rem;
    column-gap: 0.625rem;
  }
  .lg\\:col-gap-3\\.5 {
    grid-column-gap: 0.875rem;
    column-gap: 0.875rem;
  }
  .lg\\:col-gap-1\\/2 {
    grid-column-gap: 50%;
    column-gap: 50%;
  }
  .lg\\:col-gap-1\\/3 {
    grid-column-gap: 33.333333%;
    column-gap: 33.333333%;
  }
  .lg\\:col-gap-2\\/3 {
    grid-column-gap: 66.666667%;
    column-gap: 66.666667%;
  }
  .lg\\:col-gap-1\\/4 {
    grid-column-gap: 25%;
    column-gap: 25%;
  }
  .lg\\:col-gap-2\\/4 {
    grid-column-gap: 50%;
    column-gap: 50%;
  }
  .lg\\:col-gap-3\\/4 {
    grid-column-gap: 75%;
    column-gap: 75%;
  }
  .lg\\:col-gap-1\\/5 {
    grid-column-gap: 20%;
    column-gap: 20%;
  }
  .lg\\:col-gap-2\\/5 {
    grid-column-gap: 40%;
    column-gap: 40%;
  }
  .lg\\:col-gap-3\\/5 {
    grid-column-gap: 60%;
    column-gap: 60%;
  }
  .lg\\:col-gap-4\\/5 {
    grid-column-gap: 80%;
    column-gap: 80%;
  }
  .lg\\:col-gap-1\\/6 {
    grid-column-gap: 16.666667%;
    column-gap: 16.666667%;
  }
  .lg\\:col-gap-2\\/6 {
    grid-column-gap: 33.333333%;
    column-gap: 33.333333%;
  }
  .lg\\:col-gap-3\\/6 {
    grid-column-gap: 50%;
    column-gap: 50%;
  }
  .lg\\:col-gap-4\\/6 {
    grid-column-gap: 66.666667%;
    column-gap: 66.666667%;
  }
  .lg\\:col-gap-5\\/6 {
    grid-column-gap: 83.333333%;
    column-gap: 83.333333%;
  }
  .lg\\:col-gap-1\\/12 {
    grid-column-gap: 8.333333%;
    column-gap: 8.333333%;
  }
  .lg\\:col-gap-2\\/12 {
    grid-column-gap: 16.666667%;
    column-gap: 16.666667%;
  }
  .lg\\:col-gap-3\\/12 {
    grid-column-gap: 25%;
    column-gap: 25%;
  }
  .lg\\:col-gap-4\\/12 {
    grid-column-gap: 33.333333%;
    column-gap: 33.333333%;
  }
  .lg\\:col-gap-5\\/12 {
    grid-column-gap: 41.666667%;
    column-gap: 41.666667%;
  }
  .lg\\:col-gap-6\\/12 {
    grid-column-gap: 50%;
    column-gap: 50%;
  }
  .lg\\:col-gap-7\\/12 {
    grid-column-gap: 58.333333%;
    column-gap: 58.333333%;
  }
  .lg\\:col-gap-8\\/12 {
    grid-column-gap: 66.666667%;
    column-gap: 66.666667%;
  }
  .lg\\:col-gap-9\\/12 {
    grid-column-gap: 75%;
    column-gap: 75%;
  }
  .lg\\:col-gap-10\\/12 {
    grid-column-gap: 83.333333%;
    column-gap: 83.333333%;
  }
  .lg\\:col-gap-11\\/12 {
    grid-column-gap: 91.666667%;
    column-gap: 91.666667%;
  }
  .lg\\:col-gap-full {
    grid-column-gap: 100%;
    column-gap: 100%;
  }
  .lg\\:gap-x-0 {
    grid-column-gap: 0;
    column-gap: 0;
  }
  .lg\\:gap-x-1 {
    grid-column-gap: 0.25rem;
    column-gap: 0.25rem;
  }
  .lg\\:gap-x-2 {
    grid-column-gap: 0.5rem;
    column-gap: 0.5rem;
  }
  .lg\\:gap-x-3 {
    grid-column-gap: 0.75rem;
    column-gap: 0.75rem;
  }
  .lg\\:gap-x-4 {
    grid-column-gap: 1rem;
    column-gap: 1rem;
  }
  .lg\\:gap-x-5 {
    grid-column-gap: 1.25rem;
    column-gap: 1.25rem;
  }
  .lg\\:gap-x-6 {
    grid-column-gap: 1.5rem;
    column-gap: 1.5rem;
  }
  .lg\\:gap-x-7 {
    grid-column-gap: 1.75rem;
    column-gap: 1.75rem;
  }
  .lg\\:gap-x-8 {
    grid-column-gap: 2rem;
    column-gap: 2rem;
  }
  .lg\\:gap-x-9 {
    grid-column-gap: 2.25rem;
    column-gap: 2.25rem;
  }
  .lg\\:gap-x-10 {
    grid-column-gap: 2.5rem;
    column-gap: 2.5rem;
  }
  .lg\\:gap-x-11 {
    grid-column-gap: 2.75rem;
    column-gap: 2.75rem;
  }
  .lg\\:gap-x-12 {
    grid-column-gap: 3rem;
    column-gap: 3rem;
  }
  .lg\\:gap-x-13 {
    grid-column-gap: 3.25rem;
    column-gap: 3.25rem;
  }
  .lg\\:gap-x-14 {
    grid-column-gap: 3.5rem;
    column-gap: 3.5rem;
  }
  .lg\\:gap-x-15 {
    grid-column-gap: 3.75rem;
    column-gap: 3.75rem;
  }
  .lg\\:gap-x-16 {
    grid-column-gap: 4rem;
    column-gap: 4rem;
  }
  .lg\\:gap-x-20 {
    grid-column-gap: 5rem;
    column-gap: 5rem;
  }
  .lg\\:gap-x-24 {
    grid-column-gap: 6rem;
    column-gap: 6rem;
  }
  .lg\\:gap-x-28 {
    grid-column-gap: 7rem;
    column-gap: 7rem;
  }
  .lg\\:gap-x-32 {
    grid-column-gap: 8rem;
    column-gap: 8rem;
  }
  .lg\\:gap-x-36 {
    grid-column-gap: 9rem;
    column-gap: 9rem;
  }
  .lg\\:gap-x-40 {
    grid-column-gap: 10rem;
    column-gap: 10rem;
  }
  .lg\\:gap-x-44 {
    grid-column-gap: 11rem;
    column-gap: 11rem;
  }
  .lg\\:gap-x-48 {
    grid-column-gap: 12rem;
    column-gap: 12rem;
  }
  .lg\\:gap-x-52 {
    grid-column-gap: 13rem;
    column-gap: 13rem;
  }
  .lg\\:gap-x-56 {
    grid-column-gap: 14rem;
    column-gap: 14rem;
  }
  .lg\\:gap-x-60 {
    grid-column-gap: 15rem;
    column-gap: 15rem;
  }
  .lg\\:gap-x-64 {
    grid-column-gap: 16rem;
    column-gap: 16rem;
  }
  .lg\\:gap-x-72 {
    grid-column-gap: 18rem;
    column-gap: 18rem;
  }
  .lg\\:gap-x-80 {
    grid-column-gap: 20rem;
    column-gap: 20rem;
  }
  .lg\\:gap-x-96 {
    grid-column-gap: 24rem;
    column-gap: 24rem;
  }
  .lg\\:gap-x-px {
    grid-column-gap: 1px;
    column-gap: 1px;
  }
  .lg\\:gap-x-0\\.5 {
    grid-column-gap: 0.125rem;
    column-gap: 0.125rem;
  }
  .lg\\:gap-x-1\\.5 {
    grid-column-gap: 0.375rem;
    column-gap: 0.375rem;
  }
  .lg\\:gap-x-2\\.5 {
    grid-column-gap: 0.625rem;
    column-gap: 0.625rem;
  }
  .lg\\:gap-x-3\\.5 {
    grid-column-gap: 0.875rem;
    column-gap: 0.875rem;
  }
  .lg\\:gap-x-1\\/2 {
    grid-column-gap: 50%;
    column-gap: 50%;
  }
  .lg\\:gap-x-1\\/3 {
    grid-column-gap: 33.333333%;
    column-gap: 33.333333%;
  }
  .lg\\:gap-x-2\\/3 {
    grid-column-gap: 66.666667%;
    column-gap: 66.666667%;
  }
  .lg\\:gap-x-1\\/4 {
    grid-column-gap: 25%;
    column-gap: 25%;
  }
  .lg\\:gap-x-2\\/4 {
    grid-column-gap: 50%;
    column-gap: 50%;
  }
  .lg\\:gap-x-3\\/4 {
    grid-column-gap: 75%;
    column-gap: 75%;
  }
  .lg\\:gap-x-1\\/5 {
    grid-column-gap: 20%;
    column-gap: 20%;
  }
  .lg\\:gap-x-2\\/5 {
    grid-column-gap: 40%;
    column-gap: 40%;
  }
  .lg\\:gap-x-3\\/5 {
    grid-column-gap: 60%;
    column-gap: 60%;
  }
  .lg\\:gap-x-4\\/5 {
    grid-column-gap: 80%;
    column-gap: 80%;
  }
  .lg\\:gap-x-1\\/6 {
    grid-column-gap: 16.666667%;
    column-gap: 16.666667%;
  }
  .lg\\:gap-x-2\\/6 {
    grid-column-gap: 33.333333%;
    column-gap: 33.333333%;
  }
  .lg\\:gap-x-3\\/6 {
    grid-column-gap: 50%;
    column-gap: 50%;
  }
  .lg\\:gap-x-4\\/6 {
    grid-column-gap: 66.666667%;
    column-gap: 66.666667%;
  }
  .lg\\:gap-x-5\\/6 {
    grid-column-gap: 83.333333%;
    column-gap: 83.333333%;
  }
  .lg\\:gap-x-1\\/12 {
    grid-column-gap: 8.333333%;
    column-gap: 8.333333%;
  }
  .lg\\:gap-x-2\\/12 {
    grid-column-gap: 16.666667%;
    column-gap: 16.666667%;
  }
  .lg\\:gap-x-3\\/12 {
    grid-column-gap: 25%;
    column-gap: 25%;
  }
  .lg\\:gap-x-4\\/12 {
    grid-column-gap: 33.333333%;
    column-gap: 33.333333%;
  }
  .lg\\:gap-x-5\\/12 {
    grid-column-gap: 41.666667%;
    column-gap: 41.666667%;
  }
  .lg\\:gap-x-6\\/12 {
    grid-column-gap: 50%;
    column-gap: 50%;
  }
  .lg\\:gap-x-7\\/12 {
    grid-column-gap: 58.333333%;
    column-gap: 58.333333%;
  }
  .lg\\:gap-x-8\\/12 {
    grid-column-gap: 66.666667%;
    column-gap: 66.666667%;
  }
  .lg\\:gap-x-9\\/12 {
    grid-column-gap: 75%;
    column-gap: 75%;
  }
  .lg\\:gap-x-10\\/12 {
    grid-column-gap: 83.333333%;
    column-gap: 83.333333%;
  }
  .lg\\:gap-x-11\\/12 {
    grid-column-gap: 91.666667%;
    column-gap: 91.666667%;
  }
  .lg\\:gap-x-full {
    grid-column-gap: 100%;
    column-gap: 100%;
  }
  .lg\\:row-gap-0 {
    grid-row-gap: 0;
    row-gap: 0;
  }
  .lg\\:row-gap-1 {
    grid-row-gap: 0.25rem;
    row-gap: 0.25rem;
  }
  .lg\\:row-gap-2 {
    grid-row-gap: 0.5rem;
    row-gap: 0.5rem;
  }
  .lg\\:row-gap-3 {
    grid-row-gap: 0.75rem;
    row-gap: 0.75rem;
  }
  .lg\\:row-gap-4 {
    grid-row-gap: 1rem;
    row-gap: 1rem;
  }
  .lg\\:row-gap-5 {
    grid-row-gap: 1.25rem;
    row-gap: 1.25rem;
  }
  .lg\\:row-gap-6 {
    grid-row-gap: 1.5rem;
    row-gap: 1.5rem;
  }
  .lg\\:row-gap-7 {
    grid-row-gap: 1.75rem;
    row-gap: 1.75rem;
  }
  .lg\\:row-gap-8 {
    grid-row-gap: 2rem;
    row-gap: 2rem;
  }
  .lg\\:row-gap-9 {
    grid-row-gap: 2.25rem;
    row-gap: 2.25rem;
  }
  .lg\\:row-gap-10 {
    grid-row-gap: 2.5rem;
    row-gap: 2.5rem;
  }
  .lg\\:row-gap-11 {
    grid-row-gap: 2.75rem;
    row-gap: 2.75rem;
  }
  .lg\\:row-gap-12 {
    grid-row-gap: 3rem;
    row-gap: 3rem;
  }
  .lg\\:row-gap-13 {
    grid-row-gap: 3.25rem;
    row-gap: 3.25rem;
  }
  .lg\\:row-gap-14 {
    grid-row-gap: 3.5rem;
    row-gap: 3.5rem;
  }
  .lg\\:row-gap-15 {
    grid-row-gap: 3.75rem;
    row-gap: 3.75rem;
  }
  .lg\\:row-gap-16 {
    grid-row-gap: 4rem;
    row-gap: 4rem;
  }
  .lg\\:row-gap-20 {
    grid-row-gap: 5rem;
    row-gap: 5rem;
  }
  .lg\\:row-gap-24 {
    grid-row-gap: 6rem;
    row-gap: 6rem;
  }
  .lg\\:row-gap-28 {
    grid-row-gap: 7rem;
    row-gap: 7rem;
  }
  .lg\\:row-gap-32 {
    grid-row-gap: 8rem;
    row-gap: 8rem;
  }
  .lg\\:row-gap-36 {
    grid-row-gap: 9rem;
    row-gap: 9rem;
  }
  .lg\\:row-gap-40 {
    grid-row-gap: 10rem;
    row-gap: 10rem;
  }
  .lg\\:row-gap-44 {
    grid-row-gap: 11rem;
    row-gap: 11rem;
  }
  .lg\\:row-gap-48 {
    grid-row-gap: 12rem;
    row-gap: 12rem;
  }
  .lg\\:row-gap-52 {
    grid-row-gap: 13rem;
    row-gap: 13rem;
  }
  .lg\\:row-gap-56 {
    grid-row-gap: 14rem;
    row-gap: 14rem;
  }
  .lg\\:row-gap-60 {
    grid-row-gap: 15rem;
    row-gap: 15rem;
  }
  .lg\\:row-gap-64 {
    grid-row-gap: 16rem;
    row-gap: 16rem;
  }
  .lg\\:row-gap-72 {
    grid-row-gap: 18rem;
    row-gap: 18rem;
  }
  .lg\\:row-gap-80 {
    grid-row-gap: 20rem;
    row-gap: 20rem;
  }
  .lg\\:row-gap-96 {
    grid-row-gap: 24rem;
    row-gap: 24rem;
  }
  .lg\\:row-gap-px {
    grid-row-gap: 1px;
    row-gap: 1px;
  }
  .lg\\:row-gap-0\\.5 {
    grid-row-gap: 0.125rem;
    row-gap: 0.125rem;
  }
  .lg\\:row-gap-1\\.5 {
    grid-row-gap: 0.375rem;
    row-gap: 0.375rem;
  }
  .lg\\:row-gap-2\\.5 {
    grid-row-gap: 0.625rem;
    row-gap: 0.625rem;
  }
  .lg\\:row-gap-3\\.5 {
    grid-row-gap: 0.875rem;
    row-gap: 0.875rem;
  }
  .lg\\:row-gap-1\\/2 {
    grid-row-gap: 50%;
    row-gap: 50%;
  }
  .lg\\:row-gap-1\\/3 {
    grid-row-gap: 33.333333%;
    row-gap: 33.333333%;
  }
  .lg\\:row-gap-2\\/3 {
    grid-row-gap: 66.666667%;
    row-gap: 66.666667%;
  }
  .lg\\:row-gap-1\\/4 {
    grid-row-gap: 25%;
    row-gap: 25%;
  }
  .lg\\:row-gap-2\\/4 {
    grid-row-gap: 50%;
    row-gap: 50%;
  }
  .lg\\:row-gap-3\\/4 {
    grid-row-gap: 75%;
    row-gap: 75%;
  }
  .lg\\:row-gap-1\\/5 {
    grid-row-gap: 20%;
    row-gap: 20%;
  }
  .lg\\:row-gap-2\\/5 {
    grid-row-gap: 40%;
    row-gap: 40%;
  }
  .lg\\:row-gap-3\\/5 {
    grid-row-gap: 60%;
    row-gap: 60%;
  }
  .lg\\:row-gap-4\\/5 {
    grid-row-gap: 80%;
    row-gap: 80%;
  }
  .lg\\:row-gap-1\\/6 {
    grid-row-gap: 16.666667%;
    row-gap: 16.666667%;
  }
  .lg\\:row-gap-2\\/6 {
    grid-row-gap: 33.333333%;
    row-gap: 33.333333%;
  }
  .lg\\:row-gap-3\\/6 {
    grid-row-gap: 50%;
    row-gap: 50%;
  }
  .lg\\:row-gap-4\\/6 {
    grid-row-gap: 66.666667%;
    row-gap: 66.666667%;
  }
  .lg\\:row-gap-5\\/6 {
    grid-row-gap: 83.333333%;
    row-gap: 83.333333%;
  }
  .lg\\:row-gap-1\\/12 {
    grid-row-gap: 8.333333%;
    row-gap: 8.333333%;
  }
  .lg\\:row-gap-2\\/12 {
    grid-row-gap: 16.666667%;
    row-gap: 16.666667%;
  }
  .lg\\:row-gap-3\\/12 {
    grid-row-gap: 25%;
    row-gap: 25%;
  }
  .lg\\:row-gap-4\\/12 {
    grid-row-gap: 33.333333%;
    row-gap: 33.333333%;
  }
  .lg\\:row-gap-5\\/12 {
    grid-row-gap: 41.666667%;
    row-gap: 41.666667%;
  }
  .lg\\:row-gap-6\\/12 {
    grid-row-gap: 50%;
    row-gap: 50%;
  }
  .lg\\:row-gap-7\\/12 {
    grid-row-gap: 58.333333%;
    row-gap: 58.333333%;
  }
  .lg\\:row-gap-8\\/12 {
    grid-row-gap: 66.666667%;
    row-gap: 66.666667%;
  }
  .lg\\:row-gap-9\\/12 {
    grid-row-gap: 75%;
    row-gap: 75%;
  }
  .lg\\:row-gap-10\\/12 {
    grid-row-gap: 83.333333%;
    row-gap: 83.333333%;
  }
  .lg\\:row-gap-11\\/12 {
    grid-row-gap: 91.666667%;
    row-gap: 91.666667%;
  }
  .lg\\:row-gap-full {
    grid-row-gap: 100%;
    row-gap: 100%;
  }
  .lg\\:gap-y-0 {
    grid-row-gap: 0;
    row-gap: 0;
  }
  .lg\\:gap-y-1 {
    grid-row-gap: 0.25rem;
    row-gap: 0.25rem;
  }
  .lg\\:gap-y-2 {
    grid-row-gap: 0.5rem;
    row-gap: 0.5rem;
  }
  .lg\\:gap-y-3 {
    grid-row-gap: 0.75rem;
    row-gap: 0.75rem;
  }
  .lg\\:gap-y-4 {
    grid-row-gap: 1rem;
    row-gap: 1rem;
  }
  .lg\\:gap-y-5 {
    grid-row-gap: 1.25rem;
    row-gap: 1.25rem;
  }
  .lg\\:gap-y-6 {
    grid-row-gap: 1.5rem;
    row-gap: 1.5rem;
  }
  .lg\\:gap-y-7 {
    grid-row-gap: 1.75rem;
    row-gap: 1.75rem;
  }
  .lg\\:gap-y-8 {
    grid-row-gap: 2rem;
    row-gap: 2rem;
  }
  .lg\\:gap-y-9 {
    grid-row-gap: 2.25rem;
    row-gap: 2.25rem;
  }
  .lg\\:gap-y-10 {
    grid-row-gap: 2.5rem;
    row-gap: 2.5rem;
  }
  .lg\\:gap-y-11 {
    grid-row-gap: 2.75rem;
    row-gap: 2.75rem;
  }
  .lg\\:gap-y-12 {
    grid-row-gap: 3rem;
    row-gap: 3rem;
  }
  .lg\\:gap-y-13 {
    grid-row-gap: 3.25rem;
    row-gap: 3.25rem;
  }
  .lg\\:gap-y-14 {
    grid-row-gap: 3.5rem;
    row-gap: 3.5rem;
  }
  .lg\\:gap-y-15 {
    grid-row-gap: 3.75rem;
    row-gap: 3.75rem;
  }
  .lg\\:gap-y-16 {
    grid-row-gap: 4rem;
    row-gap: 4rem;
  }
  .lg\\:gap-y-20 {
    grid-row-gap: 5rem;
    row-gap: 5rem;
  }
  .lg\\:gap-y-24 {
    grid-row-gap: 6rem;
    row-gap: 6rem;
  }
  .lg\\:gap-y-28 {
    grid-row-gap: 7rem;
    row-gap: 7rem;
  }
  .lg\\:gap-y-32 {
    grid-row-gap: 8rem;
    row-gap: 8rem;
  }
  .lg\\:gap-y-36 {
    grid-row-gap: 9rem;
    row-gap: 9rem;
  }
  .lg\\:gap-y-40 {
    grid-row-gap: 10rem;
    row-gap: 10rem;
  }
  .lg\\:gap-y-44 {
    grid-row-gap: 11rem;
    row-gap: 11rem;
  }
  .lg\\:gap-y-48 {
    grid-row-gap: 12rem;
    row-gap: 12rem;
  }
  .lg\\:gap-y-52 {
    grid-row-gap: 13rem;
    row-gap: 13rem;
  }
  .lg\\:gap-y-56 {
    grid-row-gap: 14rem;
    row-gap: 14rem;
  }
  .lg\\:gap-y-60 {
    grid-row-gap: 15rem;
    row-gap: 15rem;
  }
  .lg\\:gap-y-64 {
    grid-row-gap: 16rem;
    row-gap: 16rem;
  }
  .lg\\:gap-y-72 {
    grid-row-gap: 18rem;
    row-gap: 18rem;
  }
  .lg\\:gap-y-80 {
    grid-row-gap: 20rem;
    row-gap: 20rem;
  }
  .lg\\:gap-y-96 {
    grid-row-gap: 24rem;
    row-gap: 24rem;
  }
  .lg\\:gap-y-px {
    grid-row-gap: 1px;
    row-gap: 1px;
  }
  .lg\\:gap-y-0\\.5 {
    grid-row-gap: 0.125rem;
    row-gap: 0.125rem;
  }
  .lg\\:gap-y-1\\.5 {
    grid-row-gap: 0.375rem;
    row-gap: 0.375rem;
  }
  .lg\\:gap-y-2\\.5 {
    grid-row-gap: 0.625rem;
    row-gap: 0.625rem;
  }
  .lg\\:gap-y-3\\.5 {
    grid-row-gap: 0.875rem;
    row-gap: 0.875rem;
  }
  .lg\\:gap-y-1\\/2 {
    grid-row-gap: 50%;
    row-gap: 50%;
  }
  .lg\\:gap-y-1\\/3 {
    grid-row-gap: 33.333333%;
    row-gap: 33.333333%;
  }
  .lg\\:gap-y-2\\/3 {
    grid-row-gap: 66.666667%;
    row-gap: 66.666667%;
  }
  .lg\\:gap-y-1\\/4 {
    grid-row-gap: 25%;
    row-gap: 25%;
  }
  .lg\\:gap-y-2\\/4 {
    grid-row-gap: 50%;
    row-gap: 50%;
  }
  .lg\\:gap-y-3\\/4 {
    grid-row-gap: 75%;
    row-gap: 75%;
  }
  .lg\\:gap-y-1\\/5 {
    grid-row-gap: 20%;
    row-gap: 20%;
  }
  .lg\\:gap-y-2\\/5 {
    grid-row-gap: 40%;
    row-gap: 40%;
  }
  .lg\\:gap-y-3\\/5 {
    grid-row-gap: 60%;
    row-gap: 60%;
  }
  .lg\\:gap-y-4\\/5 {
    grid-row-gap: 80%;
    row-gap: 80%;
  }
  .lg\\:gap-y-1\\/6 {
    grid-row-gap: 16.666667%;
    row-gap: 16.666667%;
  }
  .lg\\:gap-y-2\\/6 {
    grid-row-gap: 33.333333%;
    row-gap: 33.333333%;
  }
  .lg\\:gap-y-3\\/6 {
    grid-row-gap: 50%;
    row-gap: 50%;
  }
  .lg\\:gap-y-4\\/6 {
    grid-row-gap: 66.666667%;
    row-gap: 66.666667%;
  }
  .lg\\:gap-y-5\\/6 {
    grid-row-gap: 83.333333%;
    row-gap: 83.333333%;
  }
  .lg\\:gap-y-1\\/12 {
    grid-row-gap: 8.333333%;
    row-gap: 8.333333%;
  }
  .lg\\:gap-y-2\\/12 {
    grid-row-gap: 16.666667%;
    row-gap: 16.666667%;
  }
  .lg\\:gap-y-3\\/12 {
    grid-row-gap: 25%;
    row-gap: 25%;
  }
  .lg\\:gap-y-4\\/12 {
    grid-row-gap: 33.333333%;
    row-gap: 33.333333%;
  }
  .lg\\:gap-y-5\\/12 {
    grid-row-gap: 41.666667%;
    row-gap: 41.666667%;
  }
  .lg\\:gap-y-6\\/12 {
    grid-row-gap: 50%;
    row-gap: 50%;
  }
  .lg\\:gap-y-7\\/12 {
    grid-row-gap: 58.333333%;
    row-gap: 58.333333%;
  }
  .lg\\:gap-y-8\\/12 {
    grid-row-gap: 66.666667%;
    row-gap: 66.666667%;
  }
  .lg\\:gap-y-9\\/12 {
    grid-row-gap: 75%;
    row-gap: 75%;
  }
  .lg\\:gap-y-10\\/12 {
    grid-row-gap: 83.333333%;
    row-gap: 83.333333%;
  }
  .lg\\:gap-y-11\\/12 {
    grid-row-gap: 91.666667%;
    row-gap: 91.666667%;
  }
  .lg\\:gap-y-full {
    grid-row-gap: 100%;
    row-gap: 100%;
  }
  .lg\\:grid-flow-row {
    grid-auto-flow: row;
  }
  .lg\\:grid-flow-col {
    grid-auto-flow: column;
  }
  .lg\\:grid-flow-row-dense {
    grid-auto-flow: row dense;
  }
  .lg\\:grid-flow-col-dense {
    grid-auto-flow: column dense;
  }
  .lg\\:grid-cols-1 {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }
  .lg\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .lg\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .lg\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
  .lg\\:grid-cols-5 {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }
  .lg\\:grid-cols-6 {
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }
  .lg\\:grid-cols-7 {
    grid-template-columns: repeat(7, minmax(0, 1fr));
  }
  .lg\\:grid-cols-8 {
    grid-template-columns: repeat(8, minmax(0, 1fr));
  }
  .lg\\:grid-cols-9 {
    grid-template-columns: repeat(9, minmax(0, 1fr));
  }
  .lg\\:grid-cols-10 {
    grid-template-columns: repeat(10, minmax(0, 1fr));
  }
  .lg\\:grid-cols-11 {
    grid-template-columns: repeat(11, minmax(0, 1fr));
  }
  .lg\\:grid-cols-12 {
    grid-template-columns: repeat(12, minmax(0, 1fr));
  }
  .lg\\:grid-cols-none {
    grid-template-columns: none;
  }
  .lg\\:auto-cols-auto {
    grid-auto-columns: auto;
  }
  .lg\\:auto-cols-min {
    grid-auto-columns: min-content;
  }
  .lg\\:auto-cols-max {
    grid-auto-columns: max-content;
  }
  .lg\\:auto-cols-fr {
    grid-auto-columns: minmax(0, 1fr);
  }
  .lg\\:col-auto {
    grid-column: auto;
  }
  .lg\\:col-span-1 {
    grid-column: span 1 / span 1;
  }
  .lg\\:col-span-2 {
    grid-column: span 2 / span 2;
  }
  .lg\\:col-span-3 {
    grid-column: span 3 / span 3;
  }
  .lg\\:col-span-4 {
    grid-column: span 4 / span 4;
  }
  .lg\\:col-span-5 {
    grid-column: span 5 / span 5;
  }
  .lg\\:col-span-6 {
    grid-column: span 6 / span 6;
  }
  .lg\\:col-span-7 {
    grid-column: span 7 / span 7;
  }
  .lg\\:col-span-8 {
    grid-column: span 8 / span 8;
  }
  .lg\\:col-span-9 {
    grid-column: span 9 / span 9;
  }
  .lg\\:col-span-10 {
    grid-column: span 10 / span 10;
  }
  .lg\\:col-span-11 {
    grid-column: span 11 / span 11;
  }
  .lg\\:col-span-12 {
    grid-column: span 12 / span 12;
  }
  .lg\\:col-span-full {
    grid-column: 1 / -1;
  }
  .lg\\:col-start-1 {
    grid-column-start: 1;
  }
  .lg\\:col-start-2 {
    grid-column-start: 2;
  }
  .lg\\:col-start-3 {
    grid-column-start: 3;
  }
  .lg\\:col-start-4 {
    grid-column-start: 4;
  }
  .lg\\:col-start-5 {
    grid-column-start: 5;
  }
  .lg\\:col-start-6 {
    grid-column-start: 6;
  }
  .lg\\:col-start-7 {
    grid-column-start: 7;
  }
  .lg\\:col-start-8 {
    grid-column-start: 8;
  }
  .lg\\:col-start-9 {
    grid-column-start: 9;
  }
  .lg\\:col-start-10 {
    grid-column-start: 10;
  }
  .lg\\:col-start-11 {
    grid-column-start: 11;
  }
  .lg\\:col-start-12 {
    grid-column-start: 12;
  }
  .lg\\:col-start-13 {
    grid-column-start: 13;
  }
  .lg\\:col-start-auto {
    grid-column-start: auto;
  }
  .lg\\:col-end-1 {
    grid-column-end: 1;
  }
  .lg\\:col-end-2 {
    grid-column-end: 2;
  }
  .lg\\:col-end-3 {
    grid-column-end: 3;
  }
  .lg\\:col-end-4 {
    grid-column-end: 4;
  }
  .lg\\:col-end-5 {
    grid-column-end: 5;
  }
  .lg\\:col-end-6 {
    grid-column-end: 6;
  }
  .lg\\:col-end-7 {
    grid-column-end: 7;
  }
  .lg\\:col-end-8 {
    grid-column-end: 8;
  }
  .lg\\:col-end-9 {
    grid-column-end: 9;
  }
  .lg\\:col-end-10 {
    grid-column-end: 10;
  }
  .lg\\:col-end-11 {
    grid-column-end: 11;
  }
  .lg\\:col-end-12 {
    grid-column-end: 12;
  }
  .lg\\:col-end-13 {
    grid-column-end: 13;
  }
  .lg\\:col-end-auto {
    grid-column-end: auto;
  }
  .lg\\:grid-rows-1 {
    grid-template-rows: repeat(1, minmax(0, 1fr));
  }
  .lg\\:grid-rows-2 {
    grid-template-rows: repeat(2, minmax(0, 1fr));
  }
  .lg\\:grid-rows-3 {
    grid-template-rows: repeat(3, minmax(0, 1fr));
  }
  .lg\\:grid-rows-4 {
    grid-template-rows: repeat(4, minmax(0, 1fr));
  }
  .lg\\:grid-rows-5 {
    grid-template-rows: repeat(5, minmax(0, 1fr));
  }
  .lg\\:grid-rows-6 {
    grid-template-rows: repeat(6, minmax(0, 1fr));
  }
  .lg\\:grid-rows-none {
    grid-template-rows: none;
  }
  .lg\\:auto-rows-auto {
    grid-auto-rows: auto;
  }
  .lg\\:auto-rows-min {
    grid-auto-rows: min-content;
  }
  .lg\\:auto-rows-max {
    grid-auto-rows: max-content;
  }
  .lg\\:auto-rows-fr {
    grid-auto-rows: minmax(0, 1fr);
  }
  .lg\\:row-auto {
    grid-row: auto;
  }
  .lg\\:row-span-1 {
    grid-row: span 1 / span 1;
  }
  .lg\\:row-span-2 {
    grid-row: span 2 / span 2;
  }
  .lg\\:row-span-3 {
    grid-row: span 3 / span 3;
  }
  .lg\\:row-span-4 {
    grid-row: span 4 / span 4;
  }
  .lg\\:row-span-5 {
    grid-row: span 5 / span 5;
  }
  .lg\\:row-span-6 {
    grid-row: span 6 / span 6;
  }
  .lg\\:row-span-full {
    grid-row: 1 / -1;
  }
  .lg\\:row-start-1 {
    grid-row-start: 1;
  }
  .lg\\:row-start-2 {
    grid-row-start: 2;
  }
  .lg\\:row-start-3 {
    grid-row-start: 3;
  }
  .lg\\:row-start-4 {
    grid-row-start: 4;
  }
  .lg\\:row-start-5 {
    grid-row-start: 5;
  }
  .lg\\:row-start-6 {
    grid-row-start: 6;
  }
  .lg\\:row-start-7 {
    grid-row-start: 7;
  }
  .lg\\:row-start-auto {
    grid-row-start: auto;
  }
  .lg\\:row-end-1 {
    grid-row-end: 1;
  }
  .lg\\:row-end-2 {
    grid-row-end: 2;
  }
  .lg\\:row-end-3 {
    grid-row-end: 3;
  }
  .lg\\:row-end-4 {
    grid-row-end: 4;
  }
  .lg\\:row-end-5 {
    grid-row-end: 5;
  }
  .lg\\:row-end-6 {
    grid-row-end: 6;
  }
  .lg\\:row-end-7 {
    grid-row-end: 7;
  }
  .lg\\:row-end-auto {
    grid-row-end: auto;
  }
  .lg\\:transform {
    --transform-translate-x: 0;
    --transform-translate-y: 0;
    --transform-rotate: 0;
    --transform-skew-x: 0;
    --transform-skew-y: 0;
    --transform-scale-x: 1;
    --transform-scale-y: 1;
    transform: translateX(var(--transform-translate-x)) translateY(var(--transform-translate-y)) rotate(var(--transform-rotate)) skewX(var(--transform-skew-x)) skewY(var(--transform-skew-y)) scaleX(var(--transform-scale-x)) scaleY(var(--transform-scale-y));
  }
  .lg\\:transform-none {
    transform: none;
  }
  .lg\\:origin-center {
    transform-origin: center;
  }
  .lg\\:origin-top {
    transform-origin: top;
  }
  .lg\\:origin-top-right {
    transform-origin: top right;
  }
  .lg\\:origin-right {
    transform-origin: right;
  }
  .lg\\:origin-bottom-right {
    transform-origin: bottom right;
  }
  .lg\\:origin-bottom {
    transform-origin: bottom;
  }
  .lg\\:origin-bottom-left {
    transform-origin: bottom left;
  }
  .lg\\:origin-left {
    transform-origin: left;
  }
  .lg\\:origin-top-left {
    transform-origin: top left;
  }
  .lg\\:scale-0 {
    --transform-scale-x: 0;
    --transform-scale-y: 0;
  }
  .lg\\:scale-50 {
    --transform-scale-x: .5;
    --transform-scale-y: .5;
  }
  .lg\\:scale-75 {
    --transform-scale-x: .75;
    --transform-scale-y: .75;
  }
  .lg\\:scale-90 {
    --transform-scale-x: .9;
    --transform-scale-y: .9;
  }
  .lg\\:scale-95 {
    --transform-scale-x: .95;
    --transform-scale-y: .95;
  }
  .lg\\:scale-100 {
    --transform-scale-x: 1;
    --transform-scale-y: 1;
  }
  .lg\\:scale-105 {
    --transform-scale-x: 1.05;
    --transform-scale-y: 1.05;
  }
  .lg\\:scale-110 {
    --transform-scale-x: 1.1;
    --transform-scale-y: 1.1;
  }
  .lg\\:scale-125 {
    --transform-scale-x: 1.25;
    --transform-scale-y: 1.25;
  }
  .lg\\:scale-150 {
    --transform-scale-x: 1.5;
    --transform-scale-y: 1.5;
  }
  .lg\\:scale-x-0 {
    --transform-scale-x: 0;
  }
  .lg\\:scale-x-50 {
    --transform-scale-x: .5;
  }
  .lg\\:scale-x-75 {
    --transform-scale-x: .75;
  }
  .lg\\:scale-x-90 {
    --transform-scale-x: .9;
  }
  .lg\\:scale-x-95 {
    --transform-scale-x: .95;
  }
  .lg\\:scale-x-100 {
    --transform-scale-x: 1;
  }
  .lg\\:scale-x-105 {
    --transform-scale-x: 1.05;
  }
  .lg\\:scale-x-110 {
    --transform-scale-x: 1.1;
  }
  .lg\\:scale-x-125 {
    --transform-scale-x: 1.25;
  }
  .lg\\:scale-x-150 {
    --transform-scale-x: 1.5;
  }
  .lg\\:scale-y-0 {
    --transform-scale-y: 0;
  }
  .lg\\:scale-y-50 {
    --transform-scale-y: .5;
  }
  .lg\\:scale-y-75 {
    --transform-scale-y: .75;
  }
  .lg\\:scale-y-90 {
    --transform-scale-y: .9;
  }
  .lg\\:scale-y-95 {
    --transform-scale-y: .95;
  }
  .lg\\:scale-y-100 {
    --transform-scale-y: 1;
  }
  .lg\\:scale-y-105 {
    --transform-scale-y: 1.05;
  }
  .lg\\:scale-y-110 {
    --transform-scale-y: 1.1;
  }
  .lg\\:scale-y-125 {
    --transform-scale-y: 1.25;
  }
  .lg\\:scale-y-150 {
    --transform-scale-y: 1.5;
  }
  .lg\\:hover\\:scale-0:hover {
    --transform-scale-x: 0;
    --transform-scale-y: 0;
  }
  .lg\\:hover\\:scale-50:hover {
    --transform-scale-x: .5;
    --transform-scale-y: .5;
  }
  .lg\\:hover\\:scale-75:hover {
    --transform-scale-x: .75;
    --transform-scale-y: .75;
  }
  .lg\\:hover\\:scale-90:hover {
    --transform-scale-x: .9;
    --transform-scale-y: .9;
  }
  .lg\\:hover\\:scale-95:hover {
    --transform-scale-x: .95;
    --transform-scale-y: .95;
  }
  .lg\\:hover\\:scale-100:hover {
    --transform-scale-x: 1;
    --transform-scale-y: 1;
  }
  .lg\\:hover\\:scale-105:hover {
    --transform-scale-x: 1.05;
    --transform-scale-y: 1.05;
  }
  .lg\\:hover\\:scale-110:hover {
    --transform-scale-x: 1.1;
    --transform-scale-y: 1.1;
  }
  .lg\\:hover\\:scale-125:hover {
    --transform-scale-x: 1.25;
    --transform-scale-y: 1.25;
  }
  .lg\\:hover\\:scale-150:hover {
    --transform-scale-x: 1.5;
    --transform-scale-y: 1.5;
  }
  .lg\\:hover\\:scale-x-0:hover {
    --transform-scale-x: 0;
  }
  .lg\\:hover\\:scale-x-50:hover {
    --transform-scale-x: .5;
  }
  .lg\\:hover\\:scale-x-75:hover {
    --transform-scale-x: .75;
  }
  .lg\\:hover\\:scale-x-90:hover {
    --transform-scale-x: .9;
  }
  .lg\\:hover\\:scale-x-95:hover {
    --transform-scale-x: .95;
  }
  .lg\\:hover\\:scale-x-100:hover {
    --transform-scale-x: 1;
  }
  .lg\\:hover\\:scale-x-105:hover {
    --transform-scale-x: 1.05;
  }
  .lg\\:hover\\:scale-x-110:hover {
    --transform-scale-x: 1.1;
  }
  .lg\\:hover\\:scale-x-125:hover {
    --transform-scale-x: 1.25;
  }
  .lg\\:hover\\:scale-x-150:hover {
    --transform-scale-x: 1.5;
  }
  .lg\\:hover\\:scale-y-0:hover {
    --transform-scale-y: 0;
  }
  .lg\\:hover\\:scale-y-50:hover {
    --transform-scale-y: .5;
  }
  .lg\\:hover\\:scale-y-75:hover {
    --transform-scale-y: .75;
  }
  .lg\\:hover\\:scale-y-90:hover {
    --transform-scale-y: .9;
  }
  .lg\\:hover\\:scale-y-95:hover {
    --transform-scale-y: .95;
  }
  .lg\\:hover\\:scale-y-100:hover {
    --transform-scale-y: 1;
  }
  .lg\\:hover\\:scale-y-105:hover {
    --transform-scale-y: 1.05;
  }
  .lg\\:hover\\:scale-y-110:hover {
    --transform-scale-y: 1.1;
  }
  .lg\\:hover\\:scale-y-125:hover {
    --transform-scale-y: 1.25;
  }
  .lg\\:hover\\:scale-y-150:hover {
    --transform-scale-y: 1.5;
  }
  .lg\\:focus\\:scale-0:focus {
    --transform-scale-x: 0;
    --transform-scale-y: 0;
  }
  .lg\\:focus\\:scale-50:focus {
    --transform-scale-x: .5;
    --transform-scale-y: .5;
  }
  .lg\\:focus\\:scale-75:focus {
    --transform-scale-x: .75;
    --transform-scale-y: .75;
  }
  .lg\\:focus\\:scale-90:focus {
    --transform-scale-x: .9;
    --transform-scale-y: .9;
  }
  .lg\\:focus\\:scale-95:focus {
    --transform-scale-x: .95;
    --transform-scale-y: .95;
  }
  .lg\\:focus\\:scale-100:focus {
    --transform-scale-x: 1;
    --transform-scale-y: 1;
  }
  .lg\\:focus\\:scale-105:focus {
    --transform-scale-x: 1.05;
    --transform-scale-y: 1.05;
  }
  .lg\\:focus\\:scale-110:focus {
    --transform-scale-x: 1.1;
    --transform-scale-y: 1.1;
  }
  .lg\\:focus\\:scale-125:focus {
    --transform-scale-x: 1.25;
    --transform-scale-y: 1.25;
  }
  .lg\\:focus\\:scale-150:focus {
    --transform-scale-x: 1.5;
    --transform-scale-y: 1.5;
  }
  .lg\\:focus\\:scale-x-0:focus {
    --transform-scale-x: 0;
  }
  .lg\\:focus\\:scale-x-50:focus {
    --transform-scale-x: .5;
  }
  .lg\\:focus\\:scale-x-75:focus {
    --transform-scale-x: .75;
  }
  .lg\\:focus\\:scale-x-90:focus {
    --transform-scale-x: .9;
  }
  .lg\\:focus\\:scale-x-95:focus {
    --transform-scale-x: .95;
  }
  .lg\\:focus\\:scale-x-100:focus {
    --transform-scale-x: 1;
  }
  .lg\\:focus\\:scale-x-105:focus {
    --transform-scale-x: 1.05;
  }
  .lg\\:focus\\:scale-x-110:focus {
    --transform-scale-x: 1.1;
  }
  .lg\\:focus\\:scale-x-125:focus {
    --transform-scale-x: 1.25;
  }
  .lg\\:focus\\:scale-x-150:focus {
    --transform-scale-x: 1.5;
  }
  .lg\\:focus\\:scale-y-0:focus {
    --transform-scale-y: 0;
  }
  .lg\\:focus\\:scale-y-50:focus {
    --transform-scale-y: .5;
  }
  .lg\\:focus\\:scale-y-75:focus {
    --transform-scale-y: .75;
  }
  .lg\\:focus\\:scale-y-90:focus {
    --transform-scale-y: .9;
  }
  .lg\\:focus\\:scale-y-95:focus {
    --transform-scale-y: .95;
  }
  .lg\\:focus\\:scale-y-100:focus {
    --transform-scale-y: 1;
  }
  .lg\\:focus\\:scale-y-105:focus {
    --transform-scale-y: 1.05;
  }
  .lg\\:focus\\:scale-y-110:focus {
    --transform-scale-y: 1.1;
  }
  .lg\\:focus\\:scale-y-125:focus {
    --transform-scale-y: 1.25;
  }
  .lg\\:focus\\:scale-y-150:focus {
    --transform-scale-y: 1.5;
  }
  .lg\\:rotate-0 {
    --transform-rotate: 0;
  }
  .lg\\:rotate-1 {
    --transform-rotate: 1deg;
  }
  .lg\\:rotate-2 {
    --transform-rotate: 2deg;
  }
  .lg\\:rotate-3 {
    --transform-rotate: 3deg;
  }
  .lg\\:rotate-6 {
    --transform-rotate: 6deg;
  }
  .lg\\:rotate-12 {
    --transform-rotate: 12deg;
  }
  .lg\\:rotate-45 {
    --transform-rotate: 45deg;
  }
  .lg\\:rotate-90 {
    --transform-rotate: 90deg;
  }
  .lg\\:rotate-180 {
    --transform-rotate: 180deg;
  }
  .lg\\:-rotate-180 {
    --transform-rotate: -180deg;
  }
  .lg\\:-rotate-90 {
    --transform-rotate: -90deg;
  }
  .lg\\:-rotate-45 {
    --transform-rotate: -45deg;
  }
  .lg\\:-rotate-12 {
    --transform-rotate: -12deg;
  }
  .lg\\:-rotate-6 {
    --transform-rotate: -6deg;
  }
  .lg\\:-rotate-3 {
    --transform-rotate: -3deg;
  }
  .lg\\:-rotate-2 {
    --transform-rotate: -2deg;
  }
  .lg\\:-rotate-1 {
    --transform-rotate: -1deg;
  }
  .lg\\:hover\\:rotate-0:hover {
    --transform-rotate: 0;
  }
  .lg\\:hover\\:rotate-1:hover {
    --transform-rotate: 1deg;
  }
  .lg\\:hover\\:rotate-2:hover {
    --transform-rotate: 2deg;
  }
  .lg\\:hover\\:rotate-3:hover {
    --transform-rotate: 3deg;
  }
  .lg\\:hover\\:rotate-6:hover {
    --transform-rotate: 6deg;
  }
  .lg\\:hover\\:rotate-12:hover {
    --transform-rotate: 12deg;
  }
  .lg\\:hover\\:rotate-45:hover {
    --transform-rotate: 45deg;
  }
  .lg\\:hover\\:rotate-90:hover {
    --transform-rotate: 90deg;
  }
  .lg\\:hover\\:rotate-180:hover {
    --transform-rotate: 180deg;
  }
  .lg\\:hover\\:-rotate-180:hover {
    --transform-rotate: -180deg;
  }
  .lg\\:hover\\:-rotate-90:hover {
    --transform-rotate: -90deg;
  }
  .lg\\:hover\\:-rotate-45:hover {
    --transform-rotate: -45deg;
  }
  .lg\\:hover\\:-rotate-12:hover {
    --transform-rotate: -12deg;
  }
  .lg\\:hover\\:-rotate-6:hover {
    --transform-rotate: -6deg;
  }
  .lg\\:hover\\:-rotate-3:hover {
    --transform-rotate: -3deg;
  }
  .lg\\:hover\\:-rotate-2:hover {
    --transform-rotate: -2deg;
  }
  .lg\\:hover\\:-rotate-1:hover {
    --transform-rotate: -1deg;
  }
  .lg\\:focus\\:rotate-0:focus {
    --transform-rotate: 0;
  }
  .lg\\:focus\\:rotate-1:focus {
    --transform-rotate: 1deg;
  }
  .lg\\:focus\\:rotate-2:focus {
    --transform-rotate: 2deg;
  }
  .lg\\:focus\\:rotate-3:focus {
    --transform-rotate: 3deg;
  }
  .lg\\:focus\\:rotate-6:focus {
    --transform-rotate: 6deg;
  }
  .lg\\:focus\\:rotate-12:focus {
    --transform-rotate: 12deg;
  }
  .lg\\:focus\\:rotate-45:focus {
    --transform-rotate: 45deg;
  }
  .lg\\:focus\\:rotate-90:focus {
    --transform-rotate: 90deg;
  }
  .lg\\:focus\\:rotate-180:focus {
    --transform-rotate: 180deg;
  }
  .lg\\:focus\\:-rotate-180:focus {
    --transform-rotate: -180deg;
  }
  .lg\\:focus\\:-rotate-90:focus {
    --transform-rotate: -90deg;
  }
  .lg\\:focus\\:-rotate-45:focus {
    --transform-rotate: -45deg;
  }
  .lg\\:focus\\:-rotate-12:focus {
    --transform-rotate: -12deg;
  }
  .lg\\:focus\\:-rotate-6:focus {
    --transform-rotate: -6deg;
  }
  .lg\\:focus\\:-rotate-3:focus {
    --transform-rotate: -3deg;
  }
  .lg\\:focus\\:-rotate-2:focus {
    --transform-rotate: -2deg;
  }
  .lg\\:focus\\:-rotate-1:focus {
    --transform-rotate: -1deg;
  }
  .lg\\:translate-x-0 {
    --transform-translate-x: 0;
  }
  .lg\\:translate-x-1 {
    --transform-translate-x: 0.25rem;
  }
  .lg\\:translate-x-2 {
    --transform-translate-x: 0.5rem;
  }
  .lg\\:translate-x-3 {
    --transform-translate-x: 0.75rem;
  }
  .lg\\:translate-x-4 {
    --transform-translate-x: 1rem;
  }
  .lg\\:translate-x-5 {
    --transform-translate-x: 1.25rem;
  }
  .lg\\:translate-x-6 {
    --transform-translate-x: 1.5rem;
  }
  .lg\\:translate-x-7 {
    --transform-translate-x: 1.75rem;
  }
  .lg\\:translate-x-8 {
    --transform-translate-x: 2rem;
  }
  .lg\\:translate-x-9 {
    --transform-translate-x: 2.25rem;
  }
  .lg\\:translate-x-10 {
    --transform-translate-x: 2.5rem;
  }
  .lg\\:translate-x-11 {
    --transform-translate-x: 2.75rem;
  }
  .lg\\:translate-x-12 {
    --transform-translate-x: 3rem;
  }
  .lg\\:translate-x-13 {
    --transform-translate-x: 3.25rem;
  }
  .lg\\:translate-x-14 {
    --transform-translate-x: 3.5rem;
  }
  .lg\\:translate-x-15 {
    --transform-translate-x: 3.75rem;
  }
  .lg\\:translate-x-16 {
    --transform-translate-x: 4rem;
  }
  .lg\\:translate-x-20 {
    --transform-translate-x: 5rem;
  }
  .lg\\:translate-x-24 {
    --transform-translate-x: 6rem;
  }
  .lg\\:translate-x-28 {
    --transform-translate-x: 7rem;
  }
  .lg\\:translate-x-32 {
    --transform-translate-x: 8rem;
  }
  .lg\\:translate-x-36 {
    --transform-translate-x: 9rem;
  }
  .lg\\:translate-x-40 {
    --transform-translate-x: 10rem;
  }
  .lg\\:translate-x-44 {
    --transform-translate-x: 11rem;
  }
  .lg\\:translate-x-48 {
    --transform-translate-x: 12rem;
  }
  .lg\\:translate-x-52 {
    --transform-translate-x: 13rem;
  }
  .lg\\:translate-x-56 {
    --transform-translate-x: 14rem;
  }
  .lg\\:translate-x-60 {
    --transform-translate-x: 15rem;
  }
  .lg\\:translate-x-64 {
    --transform-translate-x: 16rem;
  }
  .lg\\:translate-x-72 {
    --transform-translate-x: 18rem;
  }
  .lg\\:translate-x-80 {
    --transform-translate-x: 20rem;
  }
  .lg\\:translate-x-96 {
    --transform-translate-x: 24rem;
  }
  .lg\\:translate-x-px {
    --transform-translate-x: 1px;
  }
  .lg\\:translate-x-0\\.5 {
    --transform-translate-x: 0.125rem;
  }
  .lg\\:translate-x-1\\.5 {
    --transform-translate-x: 0.375rem;
  }
  .lg\\:translate-x-2\\.5 {
    --transform-translate-x: 0.625rem;
  }
  .lg\\:translate-x-3\\.5 {
    --transform-translate-x: 0.875rem;
  }
  .lg\\:translate-x-1\\/2 {
    --transform-translate-x: 50%;
  }
  .lg\\:translate-x-1\\/3 {
    --transform-translate-x: 33.333333%;
  }
  .lg\\:translate-x-2\\/3 {
    --transform-translate-x: 66.666667%;
  }
  .lg\\:translate-x-1\\/4 {
    --transform-translate-x: 25%;
  }
  .lg\\:translate-x-2\\/4 {
    --transform-translate-x: 50%;
  }
  .lg\\:translate-x-3\\/4 {
    --transform-translate-x: 75%;
  }
  .lg\\:translate-x-1\\/5 {
    --transform-translate-x: 20%;
  }
  .lg\\:translate-x-2\\/5 {
    --transform-translate-x: 40%;
  }
  .lg\\:translate-x-3\\/5 {
    --transform-translate-x: 60%;
  }
  .lg\\:translate-x-4\\/5 {
    --transform-translate-x: 80%;
  }
  .lg\\:translate-x-1\\/6 {
    --transform-translate-x: 16.666667%;
  }
  .lg\\:translate-x-2\\/6 {
    --transform-translate-x: 33.333333%;
  }
  .lg\\:translate-x-3\\/6 {
    --transform-translate-x: 50%;
  }
  .lg\\:translate-x-4\\/6 {
    --transform-translate-x: 66.666667%;
  }
  .lg\\:translate-x-5\\/6 {
    --transform-translate-x: 83.333333%;
  }
  .lg\\:translate-x-1\\/12 {
    --transform-translate-x: 8.333333%;
  }
  .lg\\:translate-x-2\\/12 {
    --transform-translate-x: 16.666667%;
  }
  .lg\\:translate-x-3\\/12 {
    --transform-translate-x: 25%;
  }
  .lg\\:translate-x-4\\/12 {
    --transform-translate-x: 33.333333%;
  }
  .lg\\:translate-x-5\\/12 {
    --transform-translate-x: 41.666667%;
  }
  .lg\\:translate-x-6\\/12 {
    --transform-translate-x: 50%;
  }
  .lg\\:translate-x-7\\/12 {
    --transform-translate-x: 58.333333%;
  }
  .lg\\:translate-x-8\\/12 {
    --transform-translate-x: 66.666667%;
  }
  .lg\\:translate-x-9\\/12 {
    --transform-translate-x: 75%;
  }
  .lg\\:translate-x-10\\/12 {
    --transform-translate-x: 83.333333%;
  }
  .lg\\:translate-x-11\\/12 {
    --transform-translate-x: 91.666667%;
  }
  .lg\\:translate-x-full {
    --transform-translate-x: 100%;
  }
  .lg\\:-translate-x-1 {
    --transform-translate-x: -0.25rem;
  }
  .lg\\:-translate-x-2 {
    --transform-translate-x: -0.5rem;
  }
  .lg\\:-translate-x-3 {
    --transform-translate-x: -0.75rem;
  }
  .lg\\:-translate-x-4 {
    --transform-translate-x: -1rem;
  }
  .lg\\:-translate-x-5 {
    --transform-translate-x: -1.25rem;
  }
  .lg\\:-translate-x-6 {
    --transform-translate-x: -1.5rem;
  }
  .lg\\:-translate-x-7 {
    --transform-translate-x: -1.75rem;
  }
  .lg\\:-translate-x-8 {
    --transform-translate-x: -2rem;
  }
  .lg\\:-translate-x-9 {
    --transform-translate-x: -2.25rem;
  }
  .lg\\:-translate-x-10 {
    --transform-translate-x: -2.5rem;
  }
  .lg\\:-translate-x-11 {
    --transform-translate-x: -2.75rem;
  }
  .lg\\:-translate-x-12 {
    --transform-translate-x: -3rem;
  }
  .lg\\:-translate-x-13 {
    --transform-translate-x: -3.25rem;
  }
  .lg\\:-translate-x-14 {
    --transform-translate-x: -3.5rem;
  }
  .lg\\:-translate-x-15 {
    --transform-translate-x: -3.75rem;
  }
  .lg\\:-translate-x-16 {
    --transform-translate-x: -4rem;
  }
  .lg\\:-translate-x-20 {
    --transform-translate-x: -5rem;
  }
  .lg\\:-translate-x-24 {
    --transform-translate-x: -6rem;
  }
  .lg\\:-translate-x-28 {
    --transform-translate-x: -7rem;
  }
  .lg\\:-translate-x-32 {
    --transform-translate-x: -8rem;
  }
  .lg\\:-translate-x-36 {
    --transform-translate-x: -9rem;
  }
  .lg\\:-translate-x-40 {
    --transform-translate-x: -10rem;
  }
  .lg\\:-translate-x-44 {
    --transform-translate-x: -11rem;
  }
  .lg\\:-translate-x-48 {
    --transform-translate-x: -12rem;
  }
  .lg\\:-translate-x-52 {
    --transform-translate-x: -13rem;
  }
  .lg\\:-translate-x-56 {
    --transform-translate-x: -14rem;
  }
  .lg\\:-translate-x-60 {
    --transform-translate-x: -15rem;
  }
  .lg\\:-translate-x-64 {
    --transform-translate-x: -16rem;
  }
  .lg\\:-translate-x-72 {
    --transform-translate-x: -18rem;
  }
  .lg\\:-translate-x-80 {
    --transform-translate-x: -20rem;
  }
  .lg\\:-translate-x-96 {
    --transform-translate-x: -24rem;
  }
  .lg\\:-translate-x-px {
    --transform-translate-x: -1px;
  }
  .lg\\:-translate-x-0\\.5 {
    --transform-translate-x: -0.125rem;
  }
  .lg\\:-translate-x-1\\.5 {
    --transform-translate-x: -0.375rem;
  }
  .lg\\:-translate-x-2\\.5 {
    --transform-translate-x: -0.625rem;
  }
  .lg\\:-translate-x-3\\.5 {
    --transform-translate-x: -0.875rem;
  }
  .lg\\:-translate-x-1\\/2 {
    --transform-translate-x: -50%;
  }
  .lg\\:-translate-x-1\\/3 {
    --transform-translate-x: -33.33333%;
  }
  .lg\\:-translate-x-2\\/3 {
    --transform-translate-x: -66.66667%;
  }
  .lg\\:-translate-x-1\\/4 {
    --transform-translate-x: -25%;
  }
  .lg\\:-translate-x-2\\/4 {
    --transform-translate-x: -50%;
  }
  .lg\\:-translate-x-3\\/4 {
    --transform-translate-x: -75%;
  }
  .lg\\:-translate-x-1\\/5 {
    --transform-translate-x: -20%;
  }
  .lg\\:-translate-x-2\\/5 {
    --transform-translate-x: -40%;
  }
  .lg\\:-translate-x-3\\/5 {
    --transform-translate-x: -60%;
  }
  .lg\\:-translate-x-4\\/5 {
    --transform-translate-x: -80%;
  }
  .lg\\:-translate-x-1\\/6 {
    --transform-translate-x: -16.66667%;
  }
  .lg\\:-translate-x-2\\/6 {
    --transform-translate-x: -33.33333%;
  }
  .lg\\:-translate-x-3\\/6 {
    --transform-translate-x: -50%;
  }
  .lg\\:-translate-x-4\\/6 {
    --transform-translate-x: -66.66667%;
  }
  .lg\\:-translate-x-5\\/6 {
    --transform-translate-x: -83.33333%;
  }
  .lg\\:-translate-x-1\\/12 {
    --transform-translate-x: -8.33333%;
  }
  .lg\\:-translate-x-2\\/12 {
    --transform-translate-x: -16.66667%;
  }
  .lg\\:-translate-x-3\\/12 {
    --transform-translate-x: -25%;
  }
  .lg\\:-translate-x-4\\/12 {
    --transform-translate-x: -33.33333%;
  }
  .lg\\:-translate-x-5\\/12 {
    --transform-translate-x: -41.66667%;
  }
  .lg\\:-translate-x-6\\/12 {
    --transform-translate-x: -50%;
  }
  .lg\\:-translate-x-7\\/12 {
    --transform-translate-x: -58.33333%;
  }
  .lg\\:-translate-x-8\\/12 {
    --transform-translate-x: -66.66667%;
  }
  .lg\\:-translate-x-9\\/12 {
    --transform-translate-x: -75%;
  }
  .lg\\:-translate-x-10\\/12 {
    --transform-translate-x: -83.33333%;
  }
  .lg\\:-translate-x-11\\/12 {
    --transform-translate-x: -91.66667%;
  }
  .lg\\:-translate-x-full {
    --transform-translate-x: -100%;
  }
  .lg\\:translate-y-0 {
    --transform-translate-y: 0;
  }
  .lg\\:translate-y-1 {
    --transform-translate-y: 0.25rem;
  }
  .lg\\:translate-y-2 {
    --transform-translate-y: 0.5rem;
  }
  .lg\\:translate-y-3 {
    --transform-translate-y: 0.75rem;
  }
  .lg\\:translate-y-4 {
    --transform-translate-y: 1rem;
  }
  .lg\\:translate-y-5 {
    --transform-translate-y: 1.25rem;
  }
  .lg\\:translate-y-6 {
    --transform-translate-y: 1.5rem;
  }
  .lg\\:translate-y-7 {
    --transform-translate-y: 1.75rem;
  }
  .lg\\:translate-y-8 {
    --transform-translate-y: 2rem;
  }
  .lg\\:translate-y-9 {
    --transform-translate-y: 2.25rem;
  }
  .lg\\:translate-y-10 {
    --transform-translate-y: 2.5rem;
  }
  .lg\\:translate-y-11 {
    --transform-translate-y: 2.75rem;
  }
  .lg\\:translate-y-12 {
    --transform-translate-y: 3rem;
  }
  .lg\\:translate-y-13 {
    --transform-translate-y: 3.25rem;
  }
  .lg\\:translate-y-14 {
    --transform-translate-y: 3.5rem;
  }
  .lg\\:translate-y-15 {
    --transform-translate-y: 3.75rem;
  }
  .lg\\:translate-y-16 {
    --transform-translate-y: 4rem;
  }
  .lg\\:translate-y-20 {
    --transform-translate-y: 5rem;
  }
  .lg\\:translate-y-24 {
    --transform-translate-y: 6rem;
  }
  .lg\\:translate-y-28 {
    --transform-translate-y: 7rem;
  }
  .lg\\:translate-y-32 {
    --transform-translate-y: 8rem;
  }
  .lg\\:translate-y-36 {
    --transform-translate-y: 9rem;
  }
  .lg\\:translate-y-40 {
    --transform-translate-y: 10rem;
  }
  .lg\\:translate-y-44 {
    --transform-translate-y: 11rem;
  }
  .lg\\:translate-y-48 {
    --transform-translate-y: 12rem;
  }
  .lg\\:translate-y-52 {
    --transform-translate-y: 13rem;
  }
  .lg\\:translate-y-56 {
    --transform-translate-y: 14rem;
  }
  .lg\\:translate-y-60 {
    --transform-translate-y: 15rem;
  }
  .lg\\:translate-y-64 {
    --transform-translate-y: 16rem;
  }
  .lg\\:translate-y-72 {
    --transform-translate-y: 18rem;
  }
  .lg\\:translate-y-80 {
    --transform-translate-y: 20rem;
  }
  .lg\\:translate-y-96 {
    --transform-translate-y: 24rem;
  }
  .lg\\:translate-y-px {
    --transform-translate-y: 1px;
  }
  .lg\\:translate-y-0\\.5 {
    --transform-translate-y: 0.125rem;
  }
  .lg\\:translate-y-1\\.5 {
    --transform-translate-y: 0.375rem;
  }
  .lg\\:translate-y-2\\.5 {
    --transform-translate-y: 0.625rem;
  }
  .lg\\:translate-y-3\\.5 {
    --transform-translate-y: 0.875rem;
  }
  .lg\\:translate-y-1\\/2 {
    --transform-translate-y: 50%;
  }
  .lg\\:translate-y-1\\/3 {
    --transform-translate-y: 33.333333%;
  }
  .lg\\:translate-y-2\\/3 {
    --transform-translate-y: 66.666667%;
  }
  .lg\\:translate-y-1\\/4 {
    --transform-translate-y: 25%;
  }
  .lg\\:translate-y-2\\/4 {
    --transform-translate-y: 50%;
  }
  .lg\\:translate-y-3\\/4 {
    --transform-translate-y: 75%;
  }
  .lg\\:translate-y-1\\/5 {
    --transform-translate-y: 20%;
  }
  .lg\\:translate-y-2\\/5 {
    --transform-translate-y: 40%;
  }
  .lg\\:translate-y-3\\/5 {
    --transform-translate-y: 60%;
  }
  .lg\\:translate-y-4\\/5 {
    --transform-translate-y: 80%;
  }
  .lg\\:translate-y-1\\/6 {
    --transform-translate-y: 16.666667%;
  }
  .lg\\:translate-y-2\\/6 {
    --transform-translate-y: 33.333333%;
  }
  .lg\\:translate-y-3\\/6 {
    --transform-translate-y: 50%;
  }
  .lg\\:translate-y-4\\/6 {
    --transform-translate-y: 66.666667%;
  }
  .lg\\:translate-y-5\\/6 {
    --transform-translate-y: 83.333333%;
  }
  .lg\\:translate-y-1\\/12 {
    --transform-translate-y: 8.333333%;
  }
  .lg\\:translate-y-2\\/12 {
    --transform-translate-y: 16.666667%;
  }
  .lg\\:translate-y-3\\/12 {
    --transform-translate-y: 25%;
  }
  .lg\\:translate-y-4\\/12 {
    --transform-translate-y: 33.333333%;
  }
  .lg\\:translate-y-5\\/12 {
    --transform-translate-y: 41.666667%;
  }
  .lg\\:translate-y-6\\/12 {
    --transform-translate-y: 50%;
  }
  .lg\\:translate-y-7\\/12 {
    --transform-translate-y: 58.333333%;
  }
  .lg\\:translate-y-8\\/12 {
    --transform-translate-y: 66.666667%;
  }
  .lg\\:translate-y-9\\/12 {
    --transform-translate-y: 75%;
  }
  .lg\\:translate-y-10\\/12 {
    --transform-translate-y: 83.333333%;
  }
  .lg\\:translate-y-11\\/12 {
    --transform-translate-y: 91.666667%;
  }
  .lg\\:translate-y-full {
    --transform-translate-y: 100%;
  }
  .lg\\:-translate-y-1 {
    --transform-translate-y: -0.25rem;
  }
  .lg\\:-translate-y-2 {
    --transform-translate-y: -0.5rem;
  }
  .lg\\:-translate-y-3 {
    --transform-translate-y: -0.75rem;
  }
  .lg\\:-translate-y-4 {
    --transform-translate-y: -1rem;
  }
  .lg\\:-translate-y-5 {
    --transform-translate-y: -1.25rem;
  }
  .lg\\:-translate-y-6 {
    --transform-translate-y: -1.5rem;
  }
  .lg\\:-translate-y-7 {
    --transform-translate-y: -1.75rem;
  }
  .lg\\:-translate-y-8 {
    --transform-translate-y: -2rem;
  }
  .lg\\:-translate-y-9 {
    --transform-translate-y: -2.25rem;
  }
  .lg\\:-translate-y-10 {
    --transform-translate-y: -2.5rem;
  }
  .lg\\:-translate-y-11 {
    --transform-translate-y: -2.75rem;
  }
  .lg\\:-translate-y-12 {
    --transform-translate-y: -3rem;
  }
  .lg\\:-translate-y-13 {
    --transform-translate-y: -3.25rem;
  }
  .lg\\:-translate-y-14 {
    --transform-translate-y: -3.5rem;
  }
  .lg\\:-translate-y-15 {
    --transform-translate-y: -3.75rem;
  }
  .lg\\:-translate-y-16 {
    --transform-translate-y: -4rem;
  }
  .lg\\:-translate-y-20 {
    --transform-translate-y: -5rem;
  }
  .lg\\:-translate-y-24 {
    --transform-translate-y: -6rem;
  }
  .lg\\:-translate-y-28 {
    --transform-translate-y: -7rem;
  }
  .lg\\:-translate-y-32 {
    --transform-translate-y: -8rem;
  }
  .lg\\:-translate-y-36 {
    --transform-translate-y: -9rem;
  }
  .lg\\:-translate-y-40 {
    --transform-translate-y: -10rem;
  }
  .lg\\:-translate-y-44 {
    --transform-translate-y: -11rem;
  }
  .lg\\:-translate-y-48 {
    --transform-translate-y: -12rem;
  }
  .lg\\:-translate-y-52 {
    --transform-translate-y: -13rem;
  }
  .lg\\:-translate-y-56 {
    --transform-translate-y: -14rem;
  }
  .lg\\:-translate-y-60 {
    --transform-translate-y: -15rem;
  }
  .lg\\:-translate-y-64 {
    --transform-translate-y: -16rem;
  }
  .lg\\:-translate-y-72 {
    --transform-translate-y: -18rem;
  }
  .lg\\:-translate-y-80 {
    --transform-translate-y: -20rem;
  }
  .lg\\:-translate-y-96 {
    --transform-translate-y: -24rem;
  }
  .lg\\:-translate-y-px {
    --transform-translate-y: -1px;
  }
  .lg\\:-translate-y-0\\.5 {
    --transform-translate-y: -0.125rem;
  }
  .lg\\:-translate-y-1\\.5 {
    --transform-translate-y: -0.375rem;
  }
  .lg\\:-translate-y-2\\.5 {
    --transform-translate-y: -0.625rem;
  }
  .lg\\:-translate-y-3\\.5 {
    --transform-translate-y: -0.875rem;
  }
  .lg\\:-translate-y-1\\/2 {
    --transform-translate-y: -50%;
  }
  .lg\\:-translate-y-1\\/3 {
    --transform-translate-y: -33.33333%;
  }
  .lg\\:-translate-y-2\\/3 {
    --transform-translate-y: -66.66667%;
  }
  .lg\\:-translate-y-1\\/4 {
    --transform-translate-y: -25%;
  }
  .lg\\:-translate-y-2\\/4 {
    --transform-translate-y: -50%;
  }
  .lg\\:-translate-y-3\\/4 {
    --transform-translate-y: -75%;
  }
  .lg\\:-translate-y-1\\/5 {
    --transform-translate-y: -20%;
  }
  .lg\\:-translate-y-2\\/5 {
    --transform-translate-y: -40%;
  }
  .lg\\:-translate-y-3\\/5 {
    --transform-translate-y: -60%;
  }
  .lg\\:-translate-y-4\\/5 {
    --transform-translate-y: -80%;
  }
  .lg\\:-translate-y-1\\/6 {
    --transform-translate-y: -16.66667%;
  }
  .lg\\:-translate-y-2\\/6 {
    --transform-translate-y: -33.33333%;
  }
  .lg\\:-translate-y-3\\/6 {
    --transform-translate-y: -50%;
  }
  .lg\\:-translate-y-4\\/6 {
    --transform-translate-y: -66.66667%;
  }
  .lg\\:-translate-y-5\\/6 {
    --transform-translate-y: -83.33333%;
  }
  .lg\\:-translate-y-1\\/12 {
    --transform-translate-y: -8.33333%;
  }
  .lg\\:-translate-y-2\\/12 {
    --transform-translate-y: -16.66667%;
  }
  .lg\\:-translate-y-3\\/12 {
    --transform-translate-y: -25%;
  }
  .lg\\:-translate-y-4\\/12 {
    --transform-translate-y: -33.33333%;
  }
  .lg\\:-translate-y-5\\/12 {
    --transform-translate-y: -41.66667%;
  }
  .lg\\:-translate-y-6\\/12 {
    --transform-translate-y: -50%;
  }
  .lg\\:-translate-y-7\\/12 {
    --transform-translate-y: -58.33333%;
  }
  .lg\\:-translate-y-8\\/12 {
    --transform-translate-y: -66.66667%;
  }
  .lg\\:-translate-y-9\\/12 {
    --transform-translate-y: -75%;
  }
  .lg\\:-translate-y-10\\/12 {
    --transform-translate-y: -83.33333%;
  }
  .lg\\:-translate-y-11\\/12 {
    --transform-translate-y: -91.66667%;
  }
  .lg\\:-translate-y-full {
    --transform-translate-y: -100%;
  }
  .lg\\:hover\\:translate-x-0:hover {
    --transform-translate-x: 0;
  }
  .lg\\:hover\\:translate-x-1:hover {
    --transform-translate-x: 0.25rem;
  }
  .lg\\:hover\\:translate-x-2:hover {
    --transform-translate-x: 0.5rem;
  }
  .lg\\:hover\\:translate-x-3:hover {
    --transform-translate-x: 0.75rem;
  }
  .lg\\:hover\\:translate-x-4:hover {
    --transform-translate-x: 1rem;
  }
  .lg\\:hover\\:translate-x-5:hover {
    --transform-translate-x: 1.25rem;
  }
  .lg\\:hover\\:translate-x-6:hover {
    --transform-translate-x: 1.5rem;
  }
  .lg\\:hover\\:translate-x-7:hover {
    --transform-translate-x: 1.75rem;
  }
  .lg\\:hover\\:translate-x-8:hover {
    --transform-translate-x: 2rem;
  }
  .lg\\:hover\\:translate-x-9:hover {
    --transform-translate-x: 2.25rem;
  }
  .lg\\:hover\\:translate-x-10:hover {
    --transform-translate-x: 2.5rem;
  }
  .lg\\:hover\\:translate-x-11:hover {
    --transform-translate-x: 2.75rem;
  }
  .lg\\:hover\\:translate-x-12:hover {
    --transform-translate-x: 3rem;
  }
  .lg\\:hover\\:translate-x-13:hover {
    --transform-translate-x: 3.25rem;
  }
  .lg\\:hover\\:translate-x-14:hover {
    --transform-translate-x: 3.5rem;
  }
  .lg\\:hover\\:translate-x-15:hover {
    --transform-translate-x: 3.75rem;
  }
  .lg\\:hover\\:translate-x-16:hover {
    --transform-translate-x: 4rem;
  }
  .lg\\:hover\\:translate-x-20:hover {
    --transform-translate-x: 5rem;
  }
  .lg\\:hover\\:translate-x-24:hover {
    --transform-translate-x: 6rem;
  }
  .lg\\:hover\\:translate-x-28:hover {
    --transform-translate-x: 7rem;
  }
  .lg\\:hover\\:translate-x-32:hover {
    --transform-translate-x: 8rem;
  }
  .lg\\:hover\\:translate-x-36:hover {
    --transform-translate-x: 9rem;
  }
  .lg\\:hover\\:translate-x-40:hover {
    --transform-translate-x: 10rem;
  }
  .lg\\:hover\\:translate-x-44:hover {
    --transform-translate-x: 11rem;
  }
  .lg\\:hover\\:translate-x-48:hover {
    --transform-translate-x: 12rem;
  }
  .lg\\:hover\\:translate-x-52:hover {
    --transform-translate-x: 13rem;
  }
  .lg\\:hover\\:translate-x-56:hover {
    --transform-translate-x: 14rem;
  }
  .lg\\:hover\\:translate-x-60:hover {
    --transform-translate-x: 15rem;
  }
  .lg\\:hover\\:translate-x-64:hover {
    --transform-translate-x: 16rem;
  }
  .lg\\:hover\\:translate-x-72:hover {
    --transform-translate-x: 18rem;
  }
  .lg\\:hover\\:translate-x-80:hover {
    --transform-translate-x: 20rem;
  }
  .lg\\:hover\\:translate-x-96:hover {
    --transform-translate-x: 24rem;
  }
  .lg\\:hover\\:translate-x-px:hover {
    --transform-translate-x: 1px;
  }
  .lg\\:hover\\:translate-x-0\\.5:hover {
    --transform-translate-x: 0.125rem;
  }
  .lg\\:hover\\:translate-x-1\\.5:hover {
    --transform-translate-x: 0.375rem;
  }
  .lg\\:hover\\:translate-x-2\\.5:hover {
    --transform-translate-x: 0.625rem;
  }
  .lg\\:hover\\:translate-x-3\\.5:hover {
    --transform-translate-x: 0.875rem;
  }
  .lg\\:hover\\:translate-x-1\\/2:hover {
    --transform-translate-x: 50%;
  }
  .lg\\:hover\\:translate-x-1\\/3:hover {
    --transform-translate-x: 33.333333%;
  }
  .lg\\:hover\\:translate-x-2\\/3:hover {
    --transform-translate-x: 66.666667%;
  }
  .lg\\:hover\\:translate-x-1\\/4:hover {
    --transform-translate-x: 25%;
  }
  .lg\\:hover\\:translate-x-2\\/4:hover {
    --transform-translate-x: 50%;
  }
  .lg\\:hover\\:translate-x-3\\/4:hover {
    --transform-translate-x: 75%;
  }
  .lg\\:hover\\:translate-x-1\\/5:hover {
    --transform-translate-x: 20%;
  }
  .lg\\:hover\\:translate-x-2\\/5:hover {
    --transform-translate-x: 40%;
  }
  .lg\\:hover\\:translate-x-3\\/5:hover {
    --transform-translate-x: 60%;
  }
  .lg\\:hover\\:translate-x-4\\/5:hover {
    --transform-translate-x: 80%;
  }
  .lg\\:hover\\:translate-x-1\\/6:hover {
    --transform-translate-x: 16.666667%;
  }
  .lg\\:hover\\:translate-x-2\\/6:hover {
    --transform-translate-x: 33.333333%;
  }
  .lg\\:hover\\:translate-x-3\\/6:hover {
    --transform-translate-x: 50%;
  }
  .lg\\:hover\\:translate-x-4\\/6:hover {
    --transform-translate-x: 66.666667%;
  }
  .lg\\:hover\\:translate-x-5\\/6:hover {
    --transform-translate-x: 83.333333%;
  }
  .lg\\:hover\\:translate-x-1\\/12:hover {
    --transform-translate-x: 8.333333%;
  }
  .lg\\:hover\\:translate-x-2\\/12:hover {
    --transform-translate-x: 16.666667%;
  }
  .lg\\:hover\\:translate-x-3\\/12:hover {
    --transform-translate-x: 25%;
  }
  .lg\\:hover\\:translate-x-4\\/12:hover {
    --transform-translate-x: 33.333333%;
  }
  .lg\\:hover\\:translate-x-5\\/12:hover {
    --transform-translate-x: 41.666667%;
  }
  .lg\\:hover\\:translate-x-6\\/12:hover {
    --transform-translate-x: 50%;
  }
  .lg\\:hover\\:translate-x-7\\/12:hover {
    --transform-translate-x: 58.333333%;
  }
  .lg\\:hover\\:translate-x-8\\/12:hover {
    --transform-translate-x: 66.666667%;
  }
  .lg\\:hover\\:translate-x-9\\/12:hover {
    --transform-translate-x: 75%;
  }
  .lg\\:hover\\:translate-x-10\\/12:hover {
    --transform-translate-x: 83.333333%;
  }
  .lg\\:hover\\:translate-x-11\\/12:hover {
    --transform-translate-x: 91.666667%;
  }
  .lg\\:hover\\:translate-x-full:hover {
    --transform-translate-x: 100%;
  }
  .lg\\:hover\\:-translate-x-1:hover {
    --transform-translate-x: -0.25rem;
  }
  .lg\\:hover\\:-translate-x-2:hover {
    --transform-translate-x: -0.5rem;
  }
  .lg\\:hover\\:-translate-x-3:hover {
    --transform-translate-x: -0.75rem;
  }
  .lg\\:hover\\:-translate-x-4:hover {
    --transform-translate-x: -1rem;
  }
  .lg\\:hover\\:-translate-x-5:hover {
    --transform-translate-x: -1.25rem;
  }
  .lg\\:hover\\:-translate-x-6:hover {
    --transform-translate-x: -1.5rem;
  }
  .lg\\:hover\\:-translate-x-7:hover {
    --transform-translate-x: -1.75rem;
  }
  .lg\\:hover\\:-translate-x-8:hover {
    --transform-translate-x: -2rem;
  }
  .lg\\:hover\\:-translate-x-9:hover {
    --transform-translate-x: -2.25rem;
  }
  .lg\\:hover\\:-translate-x-10:hover {
    --transform-translate-x: -2.5rem;
  }
  .lg\\:hover\\:-translate-x-11:hover {
    --transform-translate-x: -2.75rem;
  }
  .lg\\:hover\\:-translate-x-12:hover {
    --transform-translate-x: -3rem;
  }
  .lg\\:hover\\:-translate-x-13:hover {
    --transform-translate-x: -3.25rem;
  }
  .lg\\:hover\\:-translate-x-14:hover {
    --transform-translate-x: -3.5rem;
  }
  .lg\\:hover\\:-translate-x-15:hover {
    --transform-translate-x: -3.75rem;
  }
  .lg\\:hover\\:-translate-x-16:hover {
    --transform-translate-x: -4rem;
  }
  .lg\\:hover\\:-translate-x-20:hover {
    --transform-translate-x: -5rem;
  }
  .lg\\:hover\\:-translate-x-24:hover {
    --transform-translate-x: -6rem;
  }
  .lg\\:hover\\:-translate-x-28:hover {
    --transform-translate-x: -7rem;
  }
  .lg\\:hover\\:-translate-x-32:hover {
    --transform-translate-x: -8rem;
  }
  .lg\\:hover\\:-translate-x-36:hover {
    --transform-translate-x: -9rem;
  }
  .lg\\:hover\\:-translate-x-40:hover {
    --transform-translate-x: -10rem;
  }
  .lg\\:hover\\:-translate-x-44:hover {
    --transform-translate-x: -11rem;
  }
  .lg\\:hover\\:-translate-x-48:hover {
    --transform-translate-x: -12rem;
  }
  .lg\\:hover\\:-translate-x-52:hover {
    --transform-translate-x: -13rem;
  }
  .lg\\:hover\\:-translate-x-56:hover {
    --transform-translate-x: -14rem;
  }
  .lg\\:hover\\:-translate-x-60:hover {
    --transform-translate-x: -15rem;
  }
  .lg\\:hover\\:-translate-x-64:hover {
    --transform-translate-x: -16rem;
  }
  .lg\\:hover\\:-translate-x-72:hover {
    --transform-translate-x: -18rem;
  }
  .lg\\:hover\\:-translate-x-80:hover {
    --transform-translate-x: -20rem;
  }
  .lg\\:hover\\:-translate-x-96:hover {
    --transform-translate-x: -24rem;
  }
  .lg\\:hover\\:-translate-x-px:hover {
    --transform-translate-x: -1px;
  }
  .lg\\:hover\\:-translate-x-0\\.5:hover {
    --transform-translate-x: -0.125rem;
  }
  .lg\\:hover\\:-translate-x-1\\.5:hover {
    --transform-translate-x: -0.375rem;
  }
  .lg\\:hover\\:-translate-x-2\\.5:hover {
    --transform-translate-x: -0.625rem;
  }
  .lg\\:hover\\:-translate-x-3\\.5:hover {
    --transform-translate-x: -0.875rem;
  }
  .lg\\:hover\\:-translate-x-1\\/2:hover {
    --transform-translate-x: -50%;
  }
  .lg\\:hover\\:-translate-x-1\\/3:hover {
    --transform-translate-x: -33.33333%;
  }
  .lg\\:hover\\:-translate-x-2\\/3:hover {
    --transform-translate-x: -66.66667%;
  }
  .lg\\:hover\\:-translate-x-1\\/4:hover {
    --transform-translate-x: -25%;
  }
  .lg\\:hover\\:-translate-x-2\\/4:hover {
    --transform-translate-x: -50%;
  }
  .lg\\:hover\\:-translate-x-3\\/4:hover {
    --transform-translate-x: -75%;
  }
  .lg\\:hover\\:-translate-x-1\\/5:hover {
    --transform-translate-x: -20%;
  }
  .lg\\:hover\\:-translate-x-2\\/5:hover {
    --transform-translate-x: -40%;
  }
  .lg\\:hover\\:-translate-x-3\\/5:hover {
    --transform-translate-x: -60%;
  }
  .lg\\:hover\\:-translate-x-4\\/5:hover {
    --transform-translate-x: -80%;
  }
  .lg\\:hover\\:-translate-x-1\\/6:hover {
    --transform-translate-x: -16.66667%;
  }
  .lg\\:hover\\:-translate-x-2\\/6:hover {
    --transform-translate-x: -33.33333%;
  }
  .lg\\:hover\\:-translate-x-3\\/6:hover {
    --transform-translate-x: -50%;
  }
  .lg\\:hover\\:-translate-x-4\\/6:hover {
    --transform-translate-x: -66.66667%;
  }
  .lg\\:hover\\:-translate-x-5\\/6:hover {
    --transform-translate-x: -83.33333%;
  }
  .lg\\:hover\\:-translate-x-1\\/12:hover {
    --transform-translate-x: -8.33333%;
  }
  .lg\\:hover\\:-translate-x-2\\/12:hover {
    --transform-translate-x: -16.66667%;
  }
  .lg\\:hover\\:-translate-x-3\\/12:hover {
    --transform-translate-x: -25%;
  }
  .lg\\:hover\\:-translate-x-4\\/12:hover {
    --transform-translate-x: -33.33333%;
  }
  .lg\\:hover\\:-translate-x-5\\/12:hover {
    --transform-translate-x: -41.66667%;
  }
  .lg\\:hover\\:-translate-x-6\\/12:hover {
    --transform-translate-x: -50%;
  }
  .lg\\:hover\\:-translate-x-7\\/12:hover {
    --transform-translate-x: -58.33333%;
  }
  .lg\\:hover\\:-translate-x-8\\/12:hover {
    --transform-translate-x: -66.66667%;
  }
  .lg\\:hover\\:-translate-x-9\\/12:hover {
    --transform-translate-x: -75%;
  }
  .lg\\:hover\\:-translate-x-10\\/12:hover {
    --transform-translate-x: -83.33333%;
  }
  .lg\\:hover\\:-translate-x-11\\/12:hover {
    --transform-translate-x: -91.66667%;
  }
  .lg\\:hover\\:-translate-x-full:hover {
    --transform-translate-x: -100%;
  }
  .lg\\:hover\\:translate-y-0:hover {
    --transform-translate-y: 0;
  }
  .lg\\:hover\\:translate-y-1:hover {
    --transform-translate-y: 0.25rem;
  }
  .lg\\:hover\\:translate-y-2:hover {
    --transform-translate-y: 0.5rem;
  }
  .lg\\:hover\\:translate-y-3:hover {
    --transform-translate-y: 0.75rem;
  }
  .lg\\:hover\\:translate-y-4:hover {
    --transform-translate-y: 1rem;
  }
  .lg\\:hover\\:translate-y-5:hover {
    --transform-translate-y: 1.25rem;
  }
  .lg\\:hover\\:translate-y-6:hover {
    --transform-translate-y: 1.5rem;
  }
  .lg\\:hover\\:translate-y-7:hover {
    --transform-translate-y: 1.75rem;
  }
  .lg\\:hover\\:translate-y-8:hover {
    --transform-translate-y: 2rem;
  }
  .lg\\:hover\\:translate-y-9:hover {
    --transform-translate-y: 2.25rem;
  }
  .lg\\:hover\\:translate-y-10:hover {
    --transform-translate-y: 2.5rem;
  }
  .lg\\:hover\\:translate-y-11:hover {
    --transform-translate-y: 2.75rem;
  }
  .lg\\:hover\\:translate-y-12:hover {
    --transform-translate-y: 3rem;
  }
  .lg\\:hover\\:translate-y-13:hover {
    --transform-translate-y: 3.25rem;
  }
  .lg\\:hover\\:translate-y-14:hover {
    --transform-translate-y: 3.5rem;
  }
  .lg\\:hover\\:translate-y-15:hover {
    --transform-translate-y: 3.75rem;
  }
  .lg\\:hover\\:translate-y-16:hover {
    --transform-translate-y: 4rem;
  }
  .lg\\:hover\\:translate-y-20:hover {
    --transform-translate-y: 5rem;
  }
  .lg\\:hover\\:translate-y-24:hover {
    --transform-translate-y: 6rem;
  }
  .lg\\:hover\\:translate-y-28:hover {
    --transform-translate-y: 7rem;
  }
  .lg\\:hover\\:translate-y-32:hover {
    --transform-translate-y: 8rem;
  }
  .lg\\:hover\\:translate-y-36:hover {
    --transform-translate-y: 9rem;
  }
  .lg\\:hover\\:translate-y-40:hover {
    --transform-translate-y: 10rem;
  }
  .lg\\:hover\\:translate-y-44:hover {
    --transform-translate-y: 11rem;
  }
  .lg\\:hover\\:translate-y-48:hover {
    --transform-translate-y: 12rem;
  }
  .lg\\:hover\\:translate-y-52:hover {
    --transform-translate-y: 13rem;
  }
  .lg\\:hover\\:translate-y-56:hover {
    --transform-translate-y: 14rem;
  }
  .lg\\:hover\\:translate-y-60:hover {
    --transform-translate-y: 15rem;
  }
  .lg\\:hover\\:translate-y-64:hover {
    --transform-translate-y: 16rem;
  }
  .lg\\:hover\\:translate-y-72:hover {
    --transform-translate-y: 18rem;
  }
  .lg\\:hover\\:translate-y-80:hover {
    --transform-translate-y: 20rem;
  }
  .lg\\:hover\\:translate-y-96:hover {
    --transform-translate-y: 24rem;
  }
  .lg\\:hover\\:translate-y-px:hover {
    --transform-translate-y: 1px;
  }
  .lg\\:hover\\:translate-y-0\\.5:hover {
    --transform-translate-y: 0.125rem;
  }
  .lg\\:hover\\:translate-y-1\\.5:hover {
    --transform-translate-y: 0.375rem;
  }
  .lg\\:hover\\:translate-y-2\\.5:hover {
    --transform-translate-y: 0.625rem;
  }
  .lg\\:hover\\:translate-y-3\\.5:hover {
    --transform-translate-y: 0.875rem;
  }
  .lg\\:hover\\:translate-y-1\\/2:hover {
    --transform-translate-y: 50%;
  }
  .lg\\:hover\\:translate-y-1\\/3:hover {
    --transform-translate-y: 33.333333%;
  }
  .lg\\:hover\\:translate-y-2\\/3:hover {
    --transform-translate-y: 66.666667%;
  }
  .lg\\:hover\\:translate-y-1\\/4:hover {
    --transform-translate-y: 25%;
  }
  .lg\\:hover\\:translate-y-2\\/4:hover {
    --transform-translate-y: 50%;
  }
  .lg\\:hover\\:translate-y-3\\/4:hover {
    --transform-translate-y: 75%;
  }
  .lg\\:hover\\:translate-y-1\\/5:hover {
    --transform-translate-y: 20%;
  }
  .lg\\:hover\\:translate-y-2\\/5:hover {
    --transform-translate-y: 40%;
  }
  .lg\\:hover\\:translate-y-3\\/5:hover {
    --transform-translate-y: 60%;
  }
  .lg\\:hover\\:translate-y-4\\/5:hover {
    --transform-translate-y: 80%;
  }
  .lg\\:hover\\:translate-y-1\\/6:hover {
    --transform-translate-y: 16.666667%;
  }
  .lg\\:hover\\:translate-y-2\\/6:hover {
    --transform-translate-y: 33.333333%;
  }
  .lg\\:hover\\:translate-y-3\\/6:hover {
    --transform-translate-y: 50%;
  }
  .lg\\:hover\\:translate-y-4\\/6:hover {
    --transform-translate-y: 66.666667%;
  }
  .lg\\:hover\\:translate-y-5\\/6:hover {
    --transform-translate-y: 83.333333%;
  }
  .lg\\:hover\\:translate-y-1\\/12:hover {
    --transform-translate-y: 8.333333%;
  }
  .lg\\:hover\\:translate-y-2\\/12:hover {
    --transform-translate-y: 16.666667%;
  }
  .lg\\:hover\\:translate-y-3\\/12:hover {
    --transform-translate-y: 25%;
  }
  .lg\\:hover\\:translate-y-4\\/12:hover {
    --transform-translate-y: 33.333333%;
  }
  .lg\\:hover\\:translate-y-5\\/12:hover {
    --transform-translate-y: 41.666667%;
  }
  .lg\\:hover\\:translate-y-6\\/12:hover {
    --transform-translate-y: 50%;
  }
  .lg\\:hover\\:translate-y-7\\/12:hover {
    --transform-translate-y: 58.333333%;
  }
  .lg\\:hover\\:translate-y-8\\/12:hover {
    --transform-translate-y: 66.666667%;
  }
  .lg\\:hover\\:translate-y-9\\/12:hover {
    --transform-translate-y: 75%;
  }
  .lg\\:hover\\:translate-y-10\\/12:hover {
    --transform-translate-y: 83.333333%;
  }
  .lg\\:hover\\:translate-y-11\\/12:hover {
    --transform-translate-y: 91.666667%;
  }
  .lg\\:hover\\:translate-y-full:hover {
    --transform-translate-y: 100%;
  }
  .lg\\:hover\\:-translate-y-1:hover {
    --transform-translate-y: -0.25rem;
  }
  .lg\\:hover\\:-translate-y-2:hover {
    --transform-translate-y: -0.5rem;
  }
  .lg\\:hover\\:-translate-y-3:hover {
    --transform-translate-y: -0.75rem;
  }
  .lg\\:hover\\:-translate-y-4:hover {
    --transform-translate-y: -1rem;
  }
  .lg\\:hover\\:-translate-y-5:hover {
    --transform-translate-y: -1.25rem;
  }
  .lg\\:hover\\:-translate-y-6:hover {
    --transform-translate-y: -1.5rem;
  }
  .lg\\:hover\\:-translate-y-7:hover {
    --transform-translate-y: -1.75rem;
  }
  .lg\\:hover\\:-translate-y-8:hover {
    --transform-translate-y: -2rem;
  }
  .lg\\:hover\\:-translate-y-9:hover {
    --transform-translate-y: -2.25rem;
  }
  .lg\\:hover\\:-translate-y-10:hover {
    --transform-translate-y: -2.5rem;
  }
  .lg\\:hover\\:-translate-y-11:hover {
    --transform-translate-y: -2.75rem;
  }
  .lg\\:hover\\:-translate-y-12:hover {
    --transform-translate-y: -3rem;
  }
  .lg\\:hover\\:-translate-y-13:hover {
    --transform-translate-y: -3.25rem;
  }
  .lg\\:hover\\:-translate-y-14:hover {
    --transform-translate-y: -3.5rem;
  }
  .lg\\:hover\\:-translate-y-15:hover {
    --transform-translate-y: -3.75rem;
  }
  .lg\\:hover\\:-translate-y-16:hover {
    --transform-translate-y: -4rem;
  }
  .lg\\:hover\\:-translate-y-20:hover {
    --transform-translate-y: -5rem;
  }
  .lg\\:hover\\:-translate-y-24:hover {
    --transform-translate-y: -6rem;
  }
  .lg\\:hover\\:-translate-y-28:hover {
    --transform-translate-y: -7rem;
  }
  .lg\\:hover\\:-translate-y-32:hover {
    --transform-translate-y: -8rem;
  }
  .lg\\:hover\\:-translate-y-36:hover {
    --transform-translate-y: -9rem;
  }
  .lg\\:hover\\:-translate-y-40:hover {
    --transform-translate-y: -10rem;
  }
  .lg\\:hover\\:-translate-y-44:hover {
    --transform-translate-y: -11rem;
  }
  .lg\\:hover\\:-translate-y-48:hover {
    --transform-translate-y: -12rem;
  }
  .lg\\:hover\\:-translate-y-52:hover {
    --transform-translate-y: -13rem;
  }
  .lg\\:hover\\:-translate-y-56:hover {
    --transform-translate-y: -14rem;
  }
  .lg\\:hover\\:-translate-y-60:hover {
    --transform-translate-y: -15rem;
  }
  .lg\\:hover\\:-translate-y-64:hover {
    --transform-translate-y: -16rem;
  }
  .lg\\:hover\\:-translate-y-72:hover {
    --transform-translate-y: -18rem;
  }
  .lg\\:hover\\:-translate-y-80:hover {
    --transform-translate-y: -20rem;
  }
  .lg\\:hover\\:-translate-y-96:hover {
    --transform-translate-y: -24rem;
  }
  .lg\\:hover\\:-translate-y-px:hover {
    --transform-translate-y: -1px;
  }
  .lg\\:hover\\:-translate-y-0\\.5:hover {
    --transform-translate-y: -0.125rem;
  }
  .lg\\:hover\\:-translate-y-1\\.5:hover {
    --transform-translate-y: -0.375rem;
  }
  .lg\\:hover\\:-translate-y-2\\.5:hover {
    --transform-translate-y: -0.625rem;
  }
  .lg\\:hover\\:-translate-y-3\\.5:hover {
    --transform-translate-y: -0.875rem;
  }
  .lg\\:hover\\:-translate-y-1\\/2:hover {
    --transform-translate-y: -50%;
  }
  .lg\\:hover\\:-translate-y-1\\/3:hover {
    --transform-translate-y: -33.33333%;
  }
  .lg\\:hover\\:-translate-y-2\\/3:hover {
    --transform-translate-y: -66.66667%;
  }
  .lg\\:hover\\:-translate-y-1\\/4:hover {
    --transform-translate-y: -25%;
  }
  .lg\\:hover\\:-translate-y-2\\/4:hover {
    --transform-translate-y: -50%;
  }
  .lg\\:hover\\:-translate-y-3\\/4:hover {
    --transform-translate-y: -75%;
  }
  .lg\\:hover\\:-translate-y-1\\/5:hover {
    --transform-translate-y: -20%;
  }
  .lg\\:hover\\:-translate-y-2\\/5:hover {
    --transform-translate-y: -40%;
  }
  .lg\\:hover\\:-translate-y-3\\/5:hover {
    --transform-translate-y: -60%;
  }
  .lg\\:hover\\:-translate-y-4\\/5:hover {
    --transform-translate-y: -80%;
  }
  .lg\\:hover\\:-translate-y-1\\/6:hover {
    --transform-translate-y: -16.66667%;
  }
  .lg\\:hover\\:-translate-y-2\\/6:hover {
    --transform-translate-y: -33.33333%;
  }
  .lg\\:hover\\:-translate-y-3\\/6:hover {
    --transform-translate-y: -50%;
  }
  .lg\\:hover\\:-translate-y-4\\/6:hover {
    --transform-translate-y: -66.66667%;
  }
  .lg\\:hover\\:-translate-y-5\\/6:hover {
    --transform-translate-y: -83.33333%;
  }
  .lg\\:hover\\:-translate-y-1\\/12:hover {
    --transform-translate-y: -8.33333%;
  }
  .lg\\:hover\\:-translate-y-2\\/12:hover {
    --transform-translate-y: -16.66667%;
  }
  .lg\\:hover\\:-translate-y-3\\/12:hover {
    --transform-translate-y: -25%;
  }
  .lg\\:hover\\:-translate-y-4\\/12:hover {
    --transform-translate-y: -33.33333%;
  }
  .lg\\:hover\\:-translate-y-5\\/12:hover {
    --transform-translate-y: -41.66667%;
  }
  .lg\\:hover\\:-translate-y-6\\/12:hover {
    --transform-translate-y: -50%;
  }
  .lg\\:hover\\:-translate-y-7\\/12:hover {
    --transform-translate-y: -58.33333%;
  }
  .lg\\:hover\\:-translate-y-8\\/12:hover {
    --transform-translate-y: -66.66667%;
  }
  .lg\\:hover\\:-translate-y-9\\/12:hover {
    --transform-translate-y: -75%;
  }
  .lg\\:hover\\:-translate-y-10\\/12:hover {
    --transform-translate-y: -83.33333%;
  }
  .lg\\:hover\\:-translate-y-11\\/12:hover {
    --transform-translate-y: -91.66667%;
  }
  .lg\\:hover\\:-translate-y-full:hover {
    --transform-translate-y: -100%;
  }
  .lg\\:focus\\:translate-x-0:focus {
    --transform-translate-x: 0;
  }
  .lg\\:focus\\:translate-x-1:focus {
    --transform-translate-x: 0.25rem;
  }
  .lg\\:focus\\:translate-x-2:focus {
    --transform-translate-x: 0.5rem;
  }
  .lg\\:focus\\:translate-x-3:focus {
    --transform-translate-x: 0.75rem;
  }
  .lg\\:focus\\:translate-x-4:focus {
    --transform-translate-x: 1rem;
  }
  .lg\\:focus\\:translate-x-5:focus {
    --transform-translate-x: 1.25rem;
  }
  .lg\\:focus\\:translate-x-6:focus {
    --transform-translate-x: 1.5rem;
  }
  .lg\\:focus\\:translate-x-7:focus {
    --transform-translate-x: 1.75rem;
  }
  .lg\\:focus\\:translate-x-8:focus {
    --transform-translate-x: 2rem;
  }
  .lg\\:focus\\:translate-x-9:focus {
    --transform-translate-x: 2.25rem;
  }
  .lg\\:focus\\:translate-x-10:focus {
    --transform-translate-x: 2.5rem;
  }
  .lg\\:focus\\:translate-x-11:focus {
    --transform-translate-x: 2.75rem;
  }
  .lg\\:focus\\:translate-x-12:focus {
    --transform-translate-x: 3rem;
  }
  .lg\\:focus\\:translate-x-13:focus {
    --transform-translate-x: 3.25rem;
  }
  .lg\\:focus\\:translate-x-14:focus {
    --transform-translate-x: 3.5rem;
  }
  .lg\\:focus\\:translate-x-15:focus {
    --transform-translate-x: 3.75rem;
  }
  .lg\\:focus\\:translate-x-16:focus {
    --transform-translate-x: 4rem;
  }
  .lg\\:focus\\:translate-x-20:focus {
    --transform-translate-x: 5rem;
  }
  .lg\\:focus\\:translate-x-24:focus {
    --transform-translate-x: 6rem;
  }
  .lg\\:focus\\:translate-x-28:focus {
    --transform-translate-x: 7rem;
  }
  .lg\\:focus\\:translate-x-32:focus {
    --transform-translate-x: 8rem;
  }
  .lg\\:focus\\:translate-x-36:focus {
    --transform-translate-x: 9rem;
  }
  .lg\\:focus\\:translate-x-40:focus {
    --transform-translate-x: 10rem;
  }
  .lg\\:focus\\:translate-x-44:focus {
    --transform-translate-x: 11rem;
  }
  .lg\\:focus\\:translate-x-48:focus {
    --transform-translate-x: 12rem;
  }
  .lg\\:focus\\:translate-x-52:focus {
    --transform-translate-x: 13rem;
  }
  .lg\\:focus\\:translate-x-56:focus {
    --transform-translate-x: 14rem;
  }
  .lg\\:focus\\:translate-x-60:focus {
    --transform-translate-x: 15rem;
  }
  .lg\\:focus\\:translate-x-64:focus {
    --transform-translate-x: 16rem;
  }
  .lg\\:focus\\:translate-x-72:focus {
    --transform-translate-x: 18rem;
  }
  .lg\\:focus\\:translate-x-80:focus {
    --transform-translate-x: 20rem;
  }
  .lg\\:focus\\:translate-x-96:focus {
    --transform-translate-x: 24rem;
  }
  .lg\\:focus\\:translate-x-px:focus {
    --transform-translate-x: 1px;
  }
  .lg\\:focus\\:translate-x-0\\.5:focus {
    --transform-translate-x: 0.125rem;
  }
  .lg\\:focus\\:translate-x-1\\.5:focus {
    --transform-translate-x: 0.375rem;
  }
  .lg\\:focus\\:translate-x-2\\.5:focus {
    --transform-translate-x: 0.625rem;
  }
  .lg\\:focus\\:translate-x-3\\.5:focus {
    --transform-translate-x: 0.875rem;
  }
  .lg\\:focus\\:translate-x-1\\/2:focus {
    --transform-translate-x: 50%;
  }
  .lg\\:focus\\:translate-x-1\\/3:focus {
    --transform-translate-x: 33.333333%;
  }
  .lg\\:focus\\:translate-x-2\\/3:focus {
    --transform-translate-x: 66.666667%;
  }
  .lg\\:focus\\:translate-x-1\\/4:focus {
    --transform-translate-x: 25%;
  }
  .lg\\:focus\\:translate-x-2\\/4:focus {
    --transform-translate-x: 50%;
  }
  .lg\\:focus\\:translate-x-3\\/4:focus {
    --transform-translate-x: 75%;
  }
  .lg\\:focus\\:translate-x-1\\/5:focus {
    --transform-translate-x: 20%;
  }
  .lg\\:focus\\:translate-x-2\\/5:focus {
    --transform-translate-x: 40%;
  }
  .lg\\:focus\\:translate-x-3\\/5:focus {
    --transform-translate-x: 60%;
  }
  .lg\\:focus\\:translate-x-4\\/5:focus {
    --transform-translate-x: 80%;
  }
  .lg\\:focus\\:translate-x-1\\/6:focus {
    --transform-translate-x: 16.666667%;
  }
  .lg\\:focus\\:translate-x-2\\/6:focus {
    --transform-translate-x: 33.333333%;
  }
  .lg\\:focus\\:translate-x-3\\/6:focus {
    --transform-translate-x: 50%;
  }
  .lg\\:focus\\:translate-x-4\\/6:focus {
    --transform-translate-x: 66.666667%;
  }
  .lg\\:focus\\:translate-x-5\\/6:focus {
    --transform-translate-x: 83.333333%;
  }
  .lg\\:focus\\:translate-x-1\\/12:focus {
    --transform-translate-x: 8.333333%;
  }
  .lg\\:focus\\:translate-x-2\\/12:focus {
    --transform-translate-x: 16.666667%;
  }
  .lg\\:focus\\:translate-x-3\\/12:focus {
    --transform-translate-x: 25%;
  }
  .lg\\:focus\\:translate-x-4\\/12:focus {
    --transform-translate-x: 33.333333%;
  }
  .lg\\:focus\\:translate-x-5\\/12:focus {
    --transform-translate-x: 41.666667%;
  }
  .lg\\:focus\\:translate-x-6\\/12:focus {
    --transform-translate-x: 50%;
  }
  .lg\\:focus\\:translate-x-7\\/12:focus {
    --transform-translate-x: 58.333333%;
  }
  .lg\\:focus\\:translate-x-8\\/12:focus {
    --transform-translate-x: 66.666667%;
  }
  .lg\\:focus\\:translate-x-9\\/12:focus {
    --transform-translate-x: 75%;
  }
  .lg\\:focus\\:translate-x-10\\/12:focus {
    --transform-translate-x: 83.333333%;
  }
  .lg\\:focus\\:translate-x-11\\/12:focus {
    --transform-translate-x: 91.666667%;
  }
  .lg\\:focus\\:translate-x-full:focus {
    --transform-translate-x: 100%;
  }
  .lg\\:focus\\:-translate-x-1:focus {
    --transform-translate-x: -0.25rem;
  }
  .lg\\:focus\\:-translate-x-2:focus {
    --transform-translate-x: -0.5rem;
  }
  .lg\\:focus\\:-translate-x-3:focus {
    --transform-translate-x: -0.75rem;
  }
  .lg\\:focus\\:-translate-x-4:focus {
    --transform-translate-x: -1rem;
  }
  .lg\\:focus\\:-translate-x-5:focus {
    --transform-translate-x: -1.25rem;
  }
  .lg\\:focus\\:-translate-x-6:focus {
    --transform-translate-x: -1.5rem;
  }
  .lg\\:focus\\:-translate-x-7:focus {
    --transform-translate-x: -1.75rem;
  }
  .lg\\:focus\\:-translate-x-8:focus {
    --transform-translate-x: -2rem;
  }
  .lg\\:focus\\:-translate-x-9:focus {
    --transform-translate-x: -2.25rem;
  }
  .lg\\:focus\\:-translate-x-10:focus {
    --transform-translate-x: -2.5rem;
  }
  .lg\\:focus\\:-translate-x-11:focus {
    --transform-translate-x: -2.75rem;
  }
  .lg\\:focus\\:-translate-x-12:focus {
    --transform-translate-x: -3rem;
  }
  .lg\\:focus\\:-translate-x-13:focus {
    --transform-translate-x: -3.25rem;
  }
  .lg\\:focus\\:-translate-x-14:focus {
    --transform-translate-x: -3.5rem;
  }
  .lg\\:focus\\:-translate-x-15:focus {
    --transform-translate-x: -3.75rem;
  }
  .lg\\:focus\\:-translate-x-16:focus {
    --transform-translate-x: -4rem;
  }
  .lg\\:focus\\:-translate-x-20:focus {
    --transform-translate-x: -5rem;
  }
  .lg\\:focus\\:-translate-x-24:focus {
    --transform-translate-x: -6rem;
  }
  .lg\\:focus\\:-translate-x-28:focus {
    --transform-translate-x: -7rem;
  }
  .lg\\:focus\\:-translate-x-32:focus {
    --transform-translate-x: -8rem;
  }
  .lg\\:focus\\:-translate-x-36:focus {
    --transform-translate-x: -9rem;
  }
  .lg\\:focus\\:-translate-x-40:focus {
    --transform-translate-x: -10rem;
  }
  .lg\\:focus\\:-translate-x-44:focus {
    --transform-translate-x: -11rem;
  }
  .lg\\:focus\\:-translate-x-48:focus {
    --transform-translate-x: -12rem;
  }
  .lg\\:focus\\:-translate-x-52:focus {
    --transform-translate-x: -13rem;
  }
  .lg\\:focus\\:-translate-x-56:focus {
    --transform-translate-x: -14rem;
  }
  .lg\\:focus\\:-translate-x-60:focus {
    --transform-translate-x: -15rem;
  }
  .lg\\:focus\\:-translate-x-64:focus {
    --transform-translate-x: -16rem;
  }
  .lg\\:focus\\:-translate-x-72:focus {
    --transform-translate-x: -18rem;
  }
  .lg\\:focus\\:-translate-x-80:focus {
    --transform-translate-x: -20rem;
  }
  .lg\\:focus\\:-translate-x-96:focus {
    --transform-translate-x: -24rem;
  }
  .lg\\:focus\\:-translate-x-px:focus {
    --transform-translate-x: -1px;
  }
  .lg\\:focus\\:-translate-x-0\\.5:focus {
    --transform-translate-x: -0.125rem;
  }
  .lg\\:focus\\:-translate-x-1\\.5:focus {
    --transform-translate-x: -0.375rem;
  }
  .lg\\:focus\\:-translate-x-2\\.5:focus {
    --transform-translate-x: -0.625rem;
  }
  .lg\\:focus\\:-translate-x-3\\.5:focus {
    --transform-translate-x: -0.875rem;
  }
  .lg\\:focus\\:-translate-x-1\\/2:focus {
    --transform-translate-x: -50%;
  }
  .lg\\:focus\\:-translate-x-1\\/3:focus {
    --transform-translate-x: -33.33333%;
  }
  .lg\\:focus\\:-translate-x-2\\/3:focus {
    --transform-translate-x: -66.66667%;
  }
  .lg\\:focus\\:-translate-x-1\\/4:focus {
    --transform-translate-x: -25%;
  }
  .lg\\:focus\\:-translate-x-2\\/4:focus {
    --transform-translate-x: -50%;
  }
  .lg\\:focus\\:-translate-x-3\\/4:focus {
    --transform-translate-x: -75%;
  }
  .lg\\:focus\\:-translate-x-1\\/5:focus {
    --transform-translate-x: -20%;
  }
  .lg\\:focus\\:-translate-x-2\\/5:focus {
    --transform-translate-x: -40%;
  }
  .lg\\:focus\\:-translate-x-3\\/5:focus {
    --transform-translate-x: -60%;
  }
  .lg\\:focus\\:-translate-x-4\\/5:focus {
    --transform-translate-x: -80%;
  }
  .lg\\:focus\\:-translate-x-1\\/6:focus {
    --transform-translate-x: -16.66667%;
  }
  .lg\\:focus\\:-translate-x-2\\/6:focus {
    --transform-translate-x: -33.33333%;
  }
  .lg\\:focus\\:-translate-x-3\\/6:focus {
    --transform-translate-x: -50%;
  }
  .lg\\:focus\\:-translate-x-4\\/6:focus {
    --transform-translate-x: -66.66667%;
  }
  .lg\\:focus\\:-translate-x-5\\/6:focus {
    --transform-translate-x: -83.33333%;
  }
  .lg\\:focus\\:-translate-x-1\\/12:focus {
    --transform-translate-x: -8.33333%;
  }
  .lg\\:focus\\:-translate-x-2\\/12:focus {
    --transform-translate-x: -16.66667%;
  }
  .lg\\:focus\\:-translate-x-3\\/12:focus {
    --transform-translate-x: -25%;
  }
  .lg\\:focus\\:-translate-x-4\\/12:focus {
    --transform-translate-x: -33.33333%;
  }
  .lg\\:focus\\:-translate-x-5\\/12:focus {
    --transform-translate-x: -41.66667%;
  }
  .lg\\:focus\\:-translate-x-6\\/12:focus {
    --transform-translate-x: -50%;
  }
  .lg\\:focus\\:-translate-x-7\\/12:focus {
    --transform-translate-x: -58.33333%;
  }
  .lg\\:focus\\:-translate-x-8\\/12:focus {
    --transform-translate-x: -66.66667%;
  }
  .lg\\:focus\\:-translate-x-9\\/12:focus {
    --transform-translate-x: -75%;
  }
  .lg\\:focus\\:-translate-x-10\\/12:focus {
    --transform-translate-x: -83.33333%;
  }
  .lg\\:focus\\:-translate-x-11\\/12:focus {
    --transform-translate-x: -91.66667%;
  }
  .lg\\:focus\\:-translate-x-full:focus {
    --transform-translate-x: -100%;
  }
  .lg\\:focus\\:translate-y-0:focus {
    --transform-translate-y: 0;
  }
  .lg\\:focus\\:translate-y-1:focus {
    --transform-translate-y: 0.25rem;
  }
  .lg\\:focus\\:translate-y-2:focus {
    --transform-translate-y: 0.5rem;
  }
  .lg\\:focus\\:translate-y-3:focus {
    --transform-translate-y: 0.75rem;
  }
  .lg\\:focus\\:translate-y-4:focus {
    --transform-translate-y: 1rem;
  }
  .lg\\:focus\\:translate-y-5:focus {
    --transform-translate-y: 1.25rem;
  }
  .lg\\:focus\\:translate-y-6:focus {
    --transform-translate-y: 1.5rem;
  }
  .lg\\:focus\\:translate-y-7:focus {
    --transform-translate-y: 1.75rem;
  }
  .lg\\:focus\\:translate-y-8:focus {
    --transform-translate-y: 2rem;
  }
  .lg\\:focus\\:translate-y-9:focus {
    --transform-translate-y: 2.25rem;
  }
  .lg\\:focus\\:translate-y-10:focus {
    --transform-translate-y: 2.5rem;
  }
  .lg\\:focus\\:translate-y-11:focus {
    --transform-translate-y: 2.75rem;
  }
  .lg\\:focus\\:translate-y-12:focus {
    --transform-translate-y: 3rem;
  }
  .lg\\:focus\\:translate-y-13:focus {
    --transform-translate-y: 3.25rem;
  }
  .lg\\:focus\\:translate-y-14:focus {
    --transform-translate-y: 3.5rem;
  }
  .lg\\:focus\\:translate-y-15:focus {
    --transform-translate-y: 3.75rem;
  }
  .lg\\:focus\\:translate-y-16:focus {
    --transform-translate-y: 4rem;
  }
  .lg\\:focus\\:translate-y-20:focus {
    --transform-translate-y: 5rem;
  }
  .lg\\:focus\\:translate-y-24:focus {
    --transform-translate-y: 6rem;
  }
  .lg\\:focus\\:translate-y-28:focus {
    --transform-translate-y: 7rem;
  }
  .lg\\:focus\\:translate-y-32:focus {
    --transform-translate-y: 8rem;
  }
  .lg\\:focus\\:translate-y-36:focus {
    --transform-translate-y: 9rem;
  }
  .lg\\:focus\\:translate-y-40:focus {
    --transform-translate-y: 10rem;
  }
  .lg\\:focus\\:translate-y-44:focus {
    --transform-translate-y: 11rem;
  }
  .lg\\:focus\\:translate-y-48:focus {
    --transform-translate-y: 12rem;
  }
  .lg\\:focus\\:translate-y-52:focus {
    --transform-translate-y: 13rem;
  }
  .lg\\:focus\\:translate-y-56:focus {
    --transform-translate-y: 14rem;
  }
  .lg\\:focus\\:translate-y-60:focus {
    --transform-translate-y: 15rem;
  }
  .lg\\:focus\\:translate-y-64:focus {
    --transform-translate-y: 16rem;
  }
  .lg\\:focus\\:translate-y-72:focus {
    --transform-translate-y: 18rem;
  }
  .lg\\:focus\\:translate-y-80:focus {
    --transform-translate-y: 20rem;
  }
  .lg\\:focus\\:translate-y-96:focus {
    --transform-translate-y: 24rem;
  }
  .lg\\:focus\\:translate-y-px:focus {
    --transform-translate-y: 1px;
  }
  .lg\\:focus\\:translate-y-0\\.5:focus {
    --transform-translate-y: 0.125rem;
  }
  .lg\\:focus\\:translate-y-1\\.5:focus {
    --transform-translate-y: 0.375rem;
  }
  .lg\\:focus\\:translate-y-2\\.5:focus {
    --transform-translate-y: 0.625rem;
  }
  .lg\\:focus\\:translate-y-3\\.5:focus {
    --transform-translate-y: 0.875rem;
  }
  .lg\\:focus\\:translate-y-1\\/2:focus {
    --transform-translate-y: 50%;
  }
  .lg\\:focus\\:translate-y-1\\/3:focus {
    --transform-translate-y: 33.333333%;
  }
  .lg\\:focus\\:translate-y-2\\/3:focus {
    --transform-translate-y: 66.666667%;
  }
  .lg\\:focus\\:translate-y-1\\/4:focus {
    --transform-translate-y: 25%;
  }
  .lg\\:focus\\:translate-y-2\\/4:focus {
    --transform-translate-y: 50%;
  }
  .lg\\:focus\\:translate-y-3\\/4:focus {
    --transform-translate-y: 75%;
  }
  .lg\\:focus\\:translate-y-1\\/5:focus {
    --transform-translate-y: 20%;
  }
  .lg\\:focus\\:translate-y-2\\/5:focus {
    --transform-translate-y: 40%;
  }
  .lg\\:focus\\:translate-y-3\\/5:focus {
    --transform-translate-y: 60%;
  }
  .lg\\:focus\\:translate-y-4\\/5:focus {
    --transform-translate-y: 80%;
  }
  .lg\\:focus\\:translate-y-1\\/6:focus {
    --transform-translate-y: 16.666667%;
  }
  .lg\\:focus\\:translate-y-2\\/6:focus {
    --transform-translate-y: 33.333333%;
  }
  .lg\\:focus\\:translate-y-3\\/6:focus {
    --transform-translate-y: 50%;
  }
  .lg\\:focus\\:translate-y-4\\/6:focus {
    --transform-translate-y: 66.666667%;
  }
  .lg\\:focus\\:translate-y-5\\/6:focus {
    --transform-translate-y: 83.333333%;
  }
  .lg\\:focus\\:translate-y-1\\/12:focus {
    --transform-translate-y: 8.333333%;
  }
  .lg\\:focus\\:translate-y-2\\/12:focus {
    --transform-translate-y: 16.666667%;
  }
  .lg\\:focus\\:translate-y-3\\/12:focus {
    --transform-translate-y: 25%;
  }
  .lg\\:focus\\:translate-y-4\\/12:focus {
    --transform-translate-y: 33.333333%;
  }
  .lg\\:focus\\:translate-y-5\\/12:focus {
    --transform-translate-y: 41.666667%;
  }
  .lg\\:focus\\:translate-y-6\\/12:focus {
    --transform-translate-y: 50%;
  }
  .lg\\:focus\\:translate-y-7\\/12:focus {
    --transform-translate-y: 58.333333%;
  }
  .lg\\:focus\\:translate-y-8\\/12:focus {
    --transform-translate-y: 66.666667%;
  }
  .lg\\:focus\\:translate-y-9\\/12:focus {
    --transform-translate-y: 75%;
  }
  .lg\\:focus\\:translate-y-10\\/12:focus {
    --transform-translate-y: 83.333333%;
  }
  .lg\\:focus\\:translate-y-11\\/12:focus {
    --transform-translate-y: 91.666667%;
  }
  .lg\\:focus\\:translate-y-full:focus {
    --transform-translate-y: 100%;
  }
  .lg\\:focus\\:-translate-y-1:focus {
    --transform-translate-y: -0.25rem;
  }
  .lg\\:focus\\:-translate-y-2:focus {
    --transform-translate-y: -0.5rem;
  }
  .lg\\:focus\\:-translate-y-3:focus {
    --transform-translate-y: -0.75rem;
  }
  .lg\\:focus\\:-translate-y-4:focus {
    --transform-translate-y: -1rem;
  }
  .lg\\:focus\\:-translate-y-5:focus {
    --transform-translate-y: -1.25rem;
  }
  .lg\\:focus\\:-translate-y-6:focus {
    --transform-translate-y: -1.5rem;
  }
  .lg\\:focus\\:-translate-y-7:focus {
    --transform-translate-y: -1.75rem;
  }
  .lg\\:focus\\:-translate-y-8:focus {
    --transform-translate-y: -2rem;
  }
  .lg\\:focus\\:-translate-y-9:focus {
    --transform-translate-y: -2.25rem;
  }
  .lg\\:focus\\:-translate-y-10:focus {
    --transform-translate-y: -2.5rem;
  }
  .lg\\:focus\\:-translate-y-11:focus {
    --transform-translate-y: -2.75rem;
  }
  .lg\\:focus\\:-translate-y-12:focus {
    --transform-translate-y: -3rem;
  }
  .lg\\:focus\\:-translate-y-13:focus {
    --transform-translate-y: -3.25rem;
  }
  .lg\\:focus\\:-translate-y-14:focus {
    --transform-translate-y: -3.5rem;
  }
  .lg\\:focus\\:-translate-y-15:focus {
    --transform-translate-y: -3.75rem;
  }
  .lg\\:focus\\:-translate-y-16:focus {
    --transform-translate-y: -4rem;
  }
  .lg\\:focus\\:-translate-y-20:focus {
    --transform-translate-y: -5rem;
  }
  .lg\\:focus\\:-translate-y-24:focus {
    --transform-translate-y: -6rem;
  }
  .lg\\:focus\\:-translate-y-28:focus {
    --transform-translate-y: -7rem;
  }
  .lg\\:focus\\:-translate-y-32:focus {
    --transform-translate-y: -8rem;
  }
  .lg\\:focus\\:-translate-y-36:focus {
    --transform-translate-y: -9rem;
  }
  .lg\\:focus\\:-translate-y-40:focus {
    --transform-translate-y: -10rem;
  }
  .lg\\:focus\\:-translate-y-44:focus {
    --transform-translate-y: -11rem;
  }
  .lg\\:focus\\:-translate-y-48:focus {
    --transform-translate-y: -12rem;
  }
  .lg\\:focus\\:-translate-y-52:focus {
    --transform-translate-y: -13rem;
  }
  .lg\\:focus\\:-translate-y-56:focus {
    --transform-translate-y: -14rem;
  }
  .lg\\:focus\\:-translate-y-60:focus {
    --transform-translate-y: -15rem;
  }
  .lg\\:focus\\:-translate-y-64:focus {
    --transform-translate-y: -16rem;
  }
  .lg\\:focus\\:-translate-y-72:focus {
    --transform-translate-y: -18rem;
  }
  .lg\\:focus\\:-translate-y-80:focus {
    --transform-translate-y: -20rem;
  }
  .lg\\:focus\\:-translate-y-96:focus {
    --transform-translate-y: -24rem;
  }
  .lg\\:focus\\:-translate-y-px:focus {
    --transform-translate-y: -1px;
  }
  .lg\\:focus\\:-translate-y-0\\.5:focus {
    --transform-translate-y: -0.125rem;
  }
  .lg\\:focus\\:-translate-y-1\\.5:focus {
    --transform-translate-y: -0.375rem;
  }
  .lg\\:focus\\:-translate-y-2\\.5:focus {
    --transform-translate-y: -0.625rem;
  }
  .lg\\:focus\\:-translate-y-3\\.5:focus {
    --transform-translate-y: -0.875rem;
  }
  .lg\\:focus\\:-translate-y-1\\/2:focus {
    --transform-translate-y: -50%;
  }
  .lg\\:focus\\:-translate-y-1\\/3:focus {
    --transform-translate-y: -33.33333%;
  }
  .lg\\:focus\\:-translate-y-2\\/3:focus {
    --transform-translate-y: -66.66667%;
  }
  .lg\\:focus\\:-translate-y-1\\/4:focus {
    --transform-translate-y: -25%;
  }
  .lg\\:focus\\:-translate-y-2\\/4:focus {
    --transform-translate-y: -50%;
  }
  .lg\\:focus\\:-translate-y-3\\/4:focus {
    --transform-translate-y: -75%;
  }
  .lg\\:focus\\:-translate-y-1\\/5:focus {
    --transform-translate-y: -20%;
  }
  .lg\\:focus\\:-translate-y-2\\/5:focus {
    --transform-translate-y: -40%;
  }
  .lg\\:focus\\:-translate-y-3\\/5:focus {
    --transform-translate-y: -60%;
  }
  .lg\\:focus\\:-translate-y-4\\/5:focus {
    --transform-translate-y: -80%;
  }
  .lg\\:focus\\:-translate-y-1\\/6:focus {
    --transform-translate-y: -16.66667%;
  }
  .lg\\:focus\\:-translate-y-2\\/6:focus {
    --transform-translate-y: -33.33333%;
  }
  .lg\\:focus\\:-translate-y-3\\/6:focus {
    --transform-translate-y: -50%;
  }
  .lg\\:focus\\:-translate-y-4\\/6:focus {
    --transform-translate-y: -66.66667%;
  }
  .lg\\:focus\\:-translate-y-5\\/6:focus {
    --transform-translate-y: -83.33333%;
  }
  .lg\\:focus\\:-translate-y-1\\/12:focus {
    --transform-translate-y: -8.33333%;
  }
  .lg\\:focus\\:-translate-y-2\\/12:focus {
    --transform-translate-y: -16.66667%;
  }
  .lg\\:focus\\:-translate-y-3\\/12:focus {
    --transform-translate-y: -25%;
  }
  .lg\\:focus\\:-translate-y-4\\/12:focus {
    --transform-translate-y: -33.33333%;
  }
  .lg\\:focus\\:-translate-y-5\\/12:focus {
    --transform-translate-y: -41.66667%;
  }
  .lg\\:focus\\:-translate-y-6\\/12:focus {
    --transform-translate-y: -50%;
  }
  .lg\\:focus\\:-translate-y-7\\/12:focus {
    --transform-translate-y: -58.33333%;
  }
  .lg\\:focus\\:-translate-y-8\\/12:focus {
    --transform-translate-y: -66.66667%;
  }
  .lg\\:focus\\:-translate-y-9\\/12:focus {
    --transform-translate-y: -75%;
  }
  .lg\\:focus\\:-translate-y-10\\/12:focus {
    --transform-translate-y: -83.33333%;
  }
  .lg\\:focus\\:-translate-y-11\\/12:focus {
    --transform-translate-y: -91.66667%;
  }
  .lg\\:focus\\:-translate-y-full:focus {
    --transform-translate-y: -100%;
  }
  .lg\\:skew-x-0 {
    --transform-skew-x: 0;
  }
  .lg\\:skew-x-1 {
    --transform-skew-x: 1deg;
  }
  .lg\\:skew-x-2 {
    --transform-skew-x: 2deg;
  }
  .lg\\:skew-x-3 {
    --transform-skew-x: 3deg;
  }
  .lg\\:skew-x-6 {
    --transform-skew-x: 6deg;
  }
  .lg\\:skew-x-12 {
    --transform-skew-x: 12deg;
  }
  .lg\\:-skew-x-12 {
    --transform-skew-x: -12deg;
  }
  .lg\\:-skew-x-6 {
    --transform-skew-x: -6deg;
  }
  .lg\\:-skew-x-3 {
    --transform-skew-x: -3deg;
  }
  .lg\\:-skew-x-2 {
    --transform-skew-x: -2deg;
  }
  .lg\\:-skew-x-1 {
    --transform-skew-x: -1deg;
  }
  .lg\\:skew-y-0 {
    --transform-skew-y: 0;
  }
  .lg\\:skew-y-1 {
    --transform-skew-y: 1deg;
  }
  .lg\\:skew-y-2 {
    --transform-skew-y: 2deg;
  }
  .lg\\:skew-y-3 {
    --transform-skew-y: 3deg;
  }
  .lg\\:skew-y-6 {
    --transform-skew-y: 6deg;
  }
  .lg\\:skew-y-12 {
    --transform-skew-y: 12deg;
  }
  .lg\\:-skew-y-12 {
    --transform-skew-y: -12deg;
  }
  .lg\\:-skew-y-6 {
    --transform-skew-y: -6deg;
  }
  .lg\\:-skew-y-3 {
    --transform-skew-y: -3deg;
  }
  .lg\\:-skew-y-2 {
    --transform-skew-y: -2deg;
  }
  .lg\\:-skew-y-1 {
    --transform-skew-y: -1deg;
  }
  .lg\\:hover\\:skew-x-0:hover {
    --transform-skew-x: 0;
  }
  .lg\\:hover\\:skew-x-1:hover {
    --transform-skew-x: 1deg;
  }
  .lg\\:hover\\:skew-x-2:hover {
    --transform-skew-x: 2deg;
  }
  .lg\\:hover\\:skew-x-3:hover {
    --transform-skew-x: 3deg;
  }
  .lg\\:hover\\:skew-x-6:hover {
    --transform-skew-x: 6deg;
  }
  .lg\\:hover\\:skew-x-12:hover {
    --transform-skew-x: 12deg;
  }
  .lg\\:hover\\:-skew-x-12:hover {
    --transform-skew-x: -12deg;
  }
  .lg\\:hover\\:-skew-x-6:hover {
    --transform-skew-x: -6deg;
  }
  .lg\\:hover\\:-skew-x-3:hover {
    --transform-skew-x: -3deg;
  }
  .lg\\:hover\\:-skew-x-2:hover {
    --transform-skew-x: -2deg;
  }
  .lg\\:hover\\:-skew-x-1:hover {
    --transform-skew-x: -1deg;
  }
  .lg\\:hover\\:skew-y-0:hover {
    --transform-skew-y: 0;
  }
  .lg\\:hover\\:skew-y-1:hover {
    --transform-skew-y: 1deg;
  }
  .lg\\:hover\\:skew-y-2:hover {
    --transform-skew-y: 2deg;
  }
  .lg\\:hover\\:skew-y-3:hover {
    --transform-skew-y: 3deg;
  }
  .lg\\:hover\\:skew-y-6:hover {
    --transform-skew-y: 6deg;
  }
  .lg\\:hover\\:skew-y-12:hover {
    --transform-skew-y: 12deg;
  }
  .lg\\:hover\\:-skew-y-12:hover {
    --transform-skew-y: -12deg;
  }
  .lg\\:hover\\:-skew-y-6:hover {
    --transform-skew-y: -6deg;
  }
  .lg\\:hover\\:-skew-y-3:hover {
    --transform-skew-y: -3deg;
  }
  .lg\\:hover\\:-skew-y-2:hover {
    --transform-skew-y: -2deg;
  }
  .lg\\:hover\\:-skew-y-1:hover {
    --transform-skew-y: -1deg;
  }
  .lg\\:focus\\:skew-x-0:focus {
    --transform-skew-x: 0;
  }
  .lg\\:focus\\:skew-x-1:focus {
    --transform-skew-x: 1deg;
  }
  .lg\\:focus\\:skew-x-2:focus {
    --transform-skew-x: 2deg;
  }
  .lg\\:focus\\:skew-x-3:focus {
    --transform-skew-x: 3deg;
  }
  .lg\\:focus\\:skew-x-6:focus {
    --transform-skew-x: 6deg;
  }
  .lg\\:focus\\:skew-x-12:focus {
    --transform-skew-x: 12deg;
  }
  .lg\\:focus\\:-skew-x-12:focus {
    --transform-skew-x: -12deg;
  }
  .lg\\:focus\\:-skew-x-6:focus {
    --transform-skew-x: -6deg;
  }
  .lg\\:focus\\:-skew-x-3:focus {
    --transform-skew-x: -3deg;
  }
  .lg\\:focus\\:-skew-x-2:focus {
    --transform-skew-x: -2deg;
  }
  .lg\\:focus\\:-skew-x-1:focus {
    --transform-skew-x: -1deg;
  }
  .lg\\:focus\\:skew-y-0:focus {
    --transform-skew-y: 0;
  }
  .lg\\:focus\\:skew-y-1:focus {
    --transform-skew-y: 1deg;
  }
  .lg\\:focus\\:skew-y-2:focus {
    --transform-skew-y: 2deg;
  }
  .lg\\:focus\\:skew-y-3:focus {
    --transform-skew-y: 3deg;
  }
  .lg\\:focus\\:skew-y-6:focus {
    --transform-skew-y: 6deg;
  }
  .lg\\:focus\\:skew-y-12:focus {
    --transform-skew-y: 12deg;
  }
  .lg\\:focus\\:-skew-y-12:focus {
    --transform-skew-y: -12deg;
  }
  .lg\\:focus\\:-skew-y-6:focus {
    --transform-skew-y: -6deg;
  }
  .lg\\:focus\\:-skew-y-3:focus {
    --transform-skew-y: -3deg;
  }
  .lg\\:focus\\:-skew-y-2:focus {
    --transform-skew-y: -2deg;
  }
  .lg\\:focus\\:-skew-y-1:focus {
    --transform-skew-y: -1deg;
  }
  .lg\\:transition-none {
    transition-property: none;
  }
  .lg\\:transition-all {
    transition-property: all;
  }
  .lg\\:transition {
    transition-property: background-color, border-color, color, fill, stroke, opacity, box-shadow, transform;
  }
  .lg\\:transition-colors {
    transition-property: background-color, border-color, color, fill, stroke;
  }
  .lg\\:transition-opacity {
    transition-property: opacity;
  }
  .lg\\:transition-shadow {
    transition-property: box-shadow;
  }
  .lg\\:transition-transform {
    transition-property: transform;
  }
  .lg\\:ease-linear {
    transition-timing-function: linear;
  }
  .lg\\:ease-in {
    transition-timing-function: cubic-bezier(0.4, 0, 1, 1);
  }
  .lg\\:ease-out {
    transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
  }
  .lg\\:ease-in-out {
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  }
  .lg\\:duration-75 {
    transition-duration: 75ms;
  }
  .lg\\:duration-100 {
    transition-duration: 100ms;
  }
  .lg\\:duration-150 {
    transition-duration: 150ms;
  }
  .lg\\:duration-200 {
    transition-duration: 200ms;
  }
  .lg\\:duration-300 {
    transition-duration: 300ms;
  }
  .lg\\:duration-500 {
    transition-duration: 500ms;
  }
  .lg\\:duration-700 {
    transition-duration: 700ms;
  }
  .lg\\:duration-1000 {
    transition-duration: 1000ms;
  }
  .lg\\:delay-75 {
    transition-delay: 75ms;
  }
  .lg\\:delay-100 {
    transition-delay: 100ms;
  }
  .lg\\:delay-150 {
    transition-delay: 150ms;
  }
  .lg\\:delay-200 {
    transition-delay: 200ms;
  }
  .lg\\:delay-300 {
    transition-delay: 300ms;
  }
  .lg\\:delay-500 {
    transition-delay: 500ms;
  }
  .lg\\:delay-700 {
    transition-delay: 700ms;
  }
  .lg\\:delay-1000 {
    transition-delay: 1000ms;
  }
  .lg\\:animate-none {
    animation: none;
  }
  .lg\\:animate-spin {
    animation: spin 1s linear infinite;
  }
  .lg\\:animate-ping {
    animation: ping 1s cubic-bezier(0, 0, 0.2, 1) infinite;
  }
  .lg\\:animate-pulse {
    animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
  }
  .lg\\:animate-bounce {
    animation: bounce 1s infinite;
  }
}
@media (min-width: 1280px) {
  .xl\\:container {
    width: 100%;
  }
  @media (min-width: 640px) {
    .xl\\:container {
      max-width: 640px;
    }
  }
  @media (min-width: 768px) {
    .xl\\:container {
      max-width: 768px;
    }
  }
  @media (min-width: 1024px) {
    .xl\\:container {
      max-width: 1024px;
    }
  }
  @media (min-width: 1280px) {
    .xl\\:container {
      max-width: 1280px;
    }
  }
  .xl\\:prose {
    color: #374151;
    max-width: 65ch;
  }
  .xl\\:prose [class~="lead"] {
    color: #4b5563;
    font-size: 1.25em;
    line-height: 1.6;
    margin-top: 1.2em;
    margin-bottom: 1.2em;
  }
  .xl\\:prose a {
    color: #5850ec;
    text-decoration: none;
    font-weight: 600;
  }
  .xl\\:prose strong {
    color: #161e2e;
    font-weight: 600;
  }
  .xl\\:prose ol {
    counter-reset: list-counter;
    margin-top: 1.25em;
    margin-bottom: 1.25em;
  }
  .xl\\:prose ol>li {
    position: relative;
    counter-increment: list-counter;
    padding-left: 1.75em;
  }
  .xl\\:prose ol>li::before {
    content: counter(list-counter) ".";
    position: absolute;
    font-weight: 400;
    color: #6b7280;
  }
  .xl\\:prose ul>li {
    position: relative;
    padding-left: 1.75em;
  }
  .xl\\:prose ul>li::before {
    content: "";
    position: absolute;
    background-color: #d2d6dc;
    border-radius: 50%;
    width: 0.375em;
    height: 0.375em;
    top: calc(0.875em - 0.1875em);
    left: 0.25em;
  }
  .xl\\:prose hr {
    border-color: #e5e7eb;
    border-top-width: 1px;
    margin-top: 3em;
    margin-bottom: 3em;
  }
  .xl\\:prose blockquote {
    font-weight: 500;
    font-style: italic;
    color: #161e2e;
    border-left-width: 0.25rem;
    border-left-color: #e5e7eb;
    quotes: "\\201C" "\\201D" "\\2018" "\\2019";
    margin-top: 1.6em;
    margin-bottom: 1.6em;
    padding-left: 1em;
  }
  .xl\\:prose blockquote p:first-of-type::before {
    content: open-quote;
  }
  .xl\\:prose blockquote p:last-of-type::after {
    content: close-quote;
  }
  .xl\\:prose h1 {
    color: #1a202c;
    font-weight: 800;
    font-size: 2.25em;
    margin-top: 0;
    margin-bottom: 0.8888889em;
    line-height: 1.1111111;
  }
  .xl\\:prose h2 {
    color: #1a202c;
    font-weight: 700;
    font-size: 1.5em;
    margin-top: 2em;
    margin-bottom: 1em;
    line-height: 1.3333333;
  }
  .xl\\:prose h3 {
    color: #1a202c;
    font-weight: 600;
    font-size: 1.25em;
    margin-top: 1.6em;
    margin-bottom: 0.6em;
    line-height: 1.6;
  }
  .xl\\:prose h4 {
    color: #1a202c;
    font-weight: 600;
    margin-top: 1.5em;
    margin-bottom: 0.5em;
    line-height: 1.5;
  }
  .xl\\:prose figure figcaption {
    color: #6b7280;
    font-size: 0.875em;
    line-height: 1.4285714;
    margin-top: 0.8571429em;
  }
  .xl\\:prose code {
    color: #161e2e;
    font-weight: 600;
    font-size: 0.875em;
  }
  .xl\\:prose code::before {
    content: "\`";
  }
  .xl\\:prose code::after {
    content: "\`";
  }
  .xl\\:prose pre {
    color: #e5e7eb;
    background-color: #252f3f;
    overflow-x: auto;
    font-size: 0.875em;
    line-height: 1.7142857;
    margin-top: 1.7142857em;
    margin-bottom: 1.7142857em;
    border-radius: 0.375rem;
    padding-top: 0.8571429em;
    padding-right: 1.1428571em;
    padding-bottom: 0.8571429em;
    padding-left: 1.1428571em;
  }
  .xl\\:prose pre code {
    background-color: transparent;
    border-width: 0;
    border-radius: 0;
    padding: 0;
    font-weight: 400;
    color: inherit;
    font-size: inherit;
    font-family: inherit;
    line-height: inherit;
  }
  .xl\\:prose pre code::before {
    content: "";
  }
  .xl\\:prose pre code::after {
    content: "";
  }
  .xl\\:prose table {
    width: 100%;
    table-layout: auto;
    text-align: left;
    margin-top: 2em;
    margin-bottom: 2em;
    font-size: 0.875em;
    line-height: 1.7142857;
  }
  .xl\\:prose thead {
    color: #161e2e;
    font-weight: 600;
    border-bottom-width: 1px;
    border-bottom-color: #d2d6dc;
  }
  .xl\\:prose thead th {
    vertical-align: bottom;
    padding-right: 0.5714286em;
    padding-bottom: 0.5714286em;
    padding-left: 0.5714286em;
  }
  .xl\\:prose tbody tr {
    border-bottom-width: 1px;
    border-bottom-color: #e5e7eb;
  }
  .xl\\:prose tbody tr:last-child {
    border-bottom-width: 0;
  }
  .xl\\:prose tbody td {
    vertical-align: top;
    padding-top: 0.5714286em;
    padding-right: 0.5714286em;
    padding-bottom: 0.5714286em;
    padding-left: 0.5714286em;
  }
  .xl\\:prose {
    font-size: 1rem;
    line-height: 1.75;
  }
  .xl\\:prose p {
    margin-top: 1.25em;
    margin-bottom: 1.25em;
  }
  .xl\\:prose img {
    margin-top: 2em;
    margin-bottom: 2em;
  }
  .xl\\:prose video {
    margin-top: 2em;
    margin-bottom: 2em;
  }
  .xl\\:prose figure {
    margin-top: 2em;
    margin-bottom: 2em;
  }
  .xl\\:prose figure>* {
    margin-top: 0;
    margin-bottom: 0;
  }
  .xl\\:prose h2 code {
    font-size: 0.875em;
  }
  .xl\\:prose h3 code {
    font-size: 0.9em;
  }
  .xl\\:prose ul {
    margin-top: 1.25em;
    margin-bottom: 1.25em;
  }
  .xl\\:prose li {
    margin-top: 0.5em;
    margin-bottom: 0.5em;
  }
  .xl\\:prose ol>li:before {
    left: 0;
  }
  .xl\\:prose>ul>li p {
    margin-top: 0.75em;
    margin-bottom: 0.75em;
  }
  .xl\\:prose>ul>li>*:first-child {
    margin-top: 1.25em;
  }
  .xl\\:prose>ul>li>*:last-child {
    margin-bottom: 1.25em;
  }
  .xl\\:prose>ol>li>*:first-child {
    margin-top: 1.25em;
  }
  .xl\\:prose>ol>li>*:last-child {
    margin-bottom: 1.25em;
  }
  .xl\\:prose ul ul, .xl\\:prose ul ol, .xl\\:prose ol ul, .xl\\:prose ol ol {
    margin-top: 0.75em;
    margin-bottom: 0.75em;
  }
  .xl\\:prose hr+* {
    margin-top: 0;
  }
  .xl\\:prose h2+* {
    margin-top: 0;
  }
  .xl\\:prose h3+* {
    margin-top: 0;
  }
  .xl\\:prose h4+* {
    margin-top: 0;
  }
  .xl\\:prose thead th:first-child {
    padding-left: 0;
  }
  .xl\\:prose thead th:last-child {
    padding-right: 0;
  }
  .xl\\:prose tbody td:first-child {
    padding-left: 0;
  }
  .xl\\:prose tbody td:last-child {
    padding-right: 0;
  }
  .xl\\:prose> :first-child {
    margin-top: 0;
  }
  .xl\\:prose> :last-child {
    margin-bottom: 0;
  }
  .xl\\:prose h1, .xl\\:prose h2, .xl\\:prose h3, .xl\\:prose h4 {
    color: #161e2e;
  }
  .xl\\:prose-sm {
    font-size: 0.875rem;
    line-height: 1.7142857;
  }
  .xl\\:prose-sm p {
    margin-top: 1.1428571em;
    margin-bottom: 1.1428571em;
  }
  .xl\\:prose-sm [class~="lead"] {
    font-size: 1.2857143em;
    line-height: 1.5555556;
    margin-top: 0.8888889em;
    margin-bottom: 0.8888889em;
  }
  .xl\\:prose-sm blockquote {
    margin-top: 1.3333333em;
    margin-bottom: 1.3333333em;
    padding-left: 1.1111111em;
  }
  .xl\\:prose-sm h1 {
    font-size: 2.1428571em;
    margin-top: 0;
    margin-bottom: 0.8em;
    line-height: 1.2;
  }
  .xl\\:prose-sm h2 {
    font-size: 1.4285714em;
    margin-top: 1.6em;
    margin-bottom: 0.8em;
    line-height: 1.4;
  }
  .xl\\:prose-sm h3 {
    font-size: 1.2857143em;
    margin-top: 1.5555556em;
    margin-bottom: 0.4444444em;
    line-height: 1.5555556;
  }
  .xl\\:prose-sm h4 {
    margin-top: 1.4285714em;
    margin-bottom: 0.5714286em;
    line-height: 1.4285714;
  }
  .xl\\:prose-sm img {
    margin-top: 1.7142857em;
    margin-bottom: 1.7142857em;
  }
  .xl\\:prose-sm video {
    margin-top: 1.7142857em;
    margin-bottom: 1.7142857em;
  }
  .xl\\:prose-sm figure {
    margin-top: 1.7142857em;
    margin-bottom: 1.7142857em;
  }
  .xl\\:prose-sm figure>* {
    margin-top: 0;
    margin-bottom: 0;
  }
  .xl\\:prose-sm figure figcaption {
    font-size: 0.8571429em;
    line-height: 1.3333333;
    margin-top: 0.6666667em;
  }
  .xl\\:prose-sm code {
    font-size: 0.8571429em;
  }
  .xl\\:prose-sm h2 code {
    font-size: 0.9em;
  }
  .xl\\:prose-sm h3 code {
    font-size: 0.8888889em;
  }
  .xl\\:prose-sm pre {
    font-size: 0.8571429em;
    line-height: 1.6666667;
    margin-top: 1.6666667em;
    margin-bottom: 1.6666667em;
    border-radius: 0.25rem;
    padding-top: 0.6666667em;
    padding-right: 1em;
    padding-bottom: 0.6666667em;
    padding-left: 1em;
  }
  .xl\\:prose-sm ol {
    margin-top: 1.1428571em;
    margin-bottom: 1.1428571em;
  }
  .xl\\:prose-sm ul {
    margin-top: 1.1428571em;
    margin-bottom: 1.1428571em;
  }
  .xl\\:prose-sm li {
    margin-top: 0.2857143em;
    margin-bottom: 0.2857143em;
  }
  .xl\\:prose-sm ol>li {
    padding-left: 1.5714286em;
  }
  .xl\\:prose-sm ol>li:before {
    left: 0;
  }
  .xl\\:prose-sm ul>li {
    padding-left: 1.5714286em;
  }
  .xl\\:prose-sm ul>li::before {
    height: 0.3571429em;
    width: 0.3571429em;
    top: calc(0.8571429em - 0.1785714em);
    left: 0.2142857em;
  }
  .xl\\:prose-sm>ul>li p {
    margin-top: 0.5714286em;
    margin-bottom: 0.5714286em;
  }
  .xl\\:prose-sm>ul>li>*:first-child {
    margin-top: 1.1428571em;
  }
  .xl\\:prose-sm>ul>li>*:last-child {
    margin-bottom: 1.1428571em;
  }
  .xl\\:prose-sm>ol>li>*:first-child {
    margin-top: 1.1428571em;
  }
  .xl\\:prose-sm>ol>li>*:last-child {
    margin-bottom: 1.1428571em;
  }
  .xl\\:prose-sm ul ul, .xl\\:prose-sm ul ol, .xl\\:prose-sm ol ul, .xl\\:prose-sm ol ol {
    margin-top: 0.5714286em;
    margin-bottom: 0.5714286em;
  }
  .xl\\:prose-sm hr {
    margin-top: 2.8571429em;
    margin-bottom: 2.8571429em;
  }
  .xl\\:prose-sm hr+* {
    margin-top: 0;
  }
  .xl\\:prose-sm h2+* {
    margin-top: 0;
  }
  .xl\\:prose-sm h3+* {
    margin-top: 0;
  }
  .xl\\:prose-sm h4+* {
    margin-top: 0;
  }
  .xl\\:prose-sm table {
    font-size: 0.8571429em;
    line-height: 1.5;
  }
  .xl\\:prose-sm thead th {
    padding-right: 1em;
    padding-bottom: 0.6666667em;
    padding-left: 1em;
  }
  .xl\\:prose-sm thead th:first-child {
    padding-left: 0;
  }
  .xl\\:prose-sm thead th:last-child {
    padding-right: 0;
  }
  .xl\\:prose-sm tbody td {
    padding-top: 0.6666667em;
    padding-right: 1em;
    padding-bottom: 0.6666667em;
    padding-left: 1em;
  }
  .xl\\:prose-sm tbody td:first-child {
    padding-left: 0;
  }
  .xl\\:prose-sm tbody td:last-child {
    padding-right: 0;
  }
  .xl\\:prose-sm> :first-child {
    margin-top: 0;
  }
  .xl\\:prose-sm> :last-child {
    margin-bottom: 0;
  }
  .xl\\:prose-lg {
    font-size: 1.125rem;
    line-height: 1.7777778;
  }
  .xl\\:prose-lg p {
    margin-top: 1.3333333em;
    margin-bottom: 1.3333333em;
  }
  .xl\\:prose-lg [class~="lead"] {
    font-size: 1.2222222em;
    line-height: 1.4545455;
    margin-top: 1.0909091em;
    margin-bottom: 1.0909091em;
  }
  .xl\\:prose-lg blockquote {
    margin-top: 1.6666667em;
    margin-bottom: 1.6666667em;
    padding-left: 1em;
  }
  .xl\\:prose-lg h1 {
    font-size: 2.6666667em;
    margin-top: 0;
    margin-bottom: 0.8333333em;
    line-height: 1;
  }
  .xl\\:prose-lg h2 {
    font-size: 1.6666667em;
    margin-top: 1.8666667em;
    margin-bottom: 1.0666667em;
    line-height: 1.3333333;
  }
  .xl\\:prose-lg h3 {
    font-size: 1.3333333em;
    margin-top: 1.6666667em;
    margin-bottom: 0.6666667em;
    line-height: 1.5;
  }
  .xl\\:prose-lg h4 {
    margin-top: 1.7777778em;
    margin-bottom: 0.4444444em;
    line-height: 1.5555556;
  }
  .xl\\:prose-lg img {
    margin-top: 1.7777778em;
    margin-bottom: 1.7777778em;
  }
  .xl\\:prose-lg video {
    margin-top: 1.7777778em;
    margin-bottom: 1.7777778em;
  }
  .xl\\:prose-lg figure {
    margin-top: 1.7777778em;
    margin-bottom: 1.7777778em;
  }
  .xl\\:prose-lg figure>* {
    margin-top: 0;
    margin-bottom: 0;
  }
  .xl\\:prose-lg figure figcaption {
    font-size: 0.8888889em;
    line-height: 1.5;
    margin-top: 1em;
  }
  .xl\\:prose-lg code {
    font-size: 0.8888889em;
  }
  .xl\\:prose-lg h2 code {
    font-size: 0.8666667em;
  }
  .xl\\:prose-lg h3 code {
    font-size: 0.875em;
  }
  .xl\\:prose-lg pre {
    font-size: 0.8888889em;
    line-height: 1.75;
    margin-top: 2em;
    margin-bottom: 2em;
    border-radius: 0.375rem;
    padding-top: 1em;
    padding-right: 1.5em;
    padding-bottom: 1em;
    padding-left: 1.5em;
  }
  .xl\\:prose-lg ol {
    margin-top: 1.3333333em;
    margin-bottom: 1.3333333em;
  }
  .xl\\:prose-lg ul {
    margin-top: 1.3333333em;
    margin-bottom: 1.3333333em;
  }
  .xl\\:prose-lg li {
    margin-top: 0.6666667em;
    margin-bottom: 0.6666667em;
  }
  .xl\\:prose-lg ol>li {
    padding-left: 1.6666667em;
  }
  .xl\\:prose-lg ol>li:before {
    left: 0;
  }
  .xl\\:prose-lg ul>li {
    padding-left: 1.6666667em;
  }
  .xl\\:prose-lg ul>li::before {
    width: 0.3333333em;
    height: 0.3333333em;
    top: calc(0.8888889em - 0.1666667em);
    left: 0.2222222em;
  }
  .xl\\:prose-lg>ul>li p {
    margin-top: 0.8888889em;
    margin-bottom: 0.8888889em;
  }
  .xl\\:prose-lg>ul>li>*:first-child {
    margin-top: 1.3333333em;
  }
  .xl\\:prose-lg>ul>li>*:last-child {
    margin-bottom: 1.3333333em;
  }
  .xl\\:prose-lg>ol>li>*:first-child {
    margin-top: 1.3333333em;
  }
  .xl\\:prose-lg>ol>li>*:last-child {
    margin-bottom: 1.3333333em;
  }
  .xl\\:prose-lg ul ul, .xl\\:prose-lg ul ol, .xl\\:prose-lg ol ul, .xl\\:prose-lg ol ol {
    margin-top: 0.8888889em;
    margin-bottom: 0.8888889em;
  }
  .xl\\:prose-lg hr {
    margin-top: 3.1111111em;
    margin-bottom: 3.1111111em;
  }
  .xl\\:prose-lg hr+* {
    margin-top: 0;
  }
  .xl\\:prose-lg h2+* {
    margin-top: 0;
  }
  .xl\\:prose-lg h3+* {
    margin-top: 0;
  }
  .xl\\:prose-lg h4+* {
    margin-top: 0;
  }
  .xl\\:prose-lg table {
    font-size: 0.8888889em;
    line-height: 1.5;
  }
  .xl\\:prose-lg thead th {
    padding-right: 0.75em;
    padding-bottom: 0.75em;
    padding-left: 0.75em;
  }
  .xl\\:prose-lg thead th:first-child {
    padding-left: 0;
  }
  .xl\\:prose-lg thead th:last-child {
    padding-right: 0;
  }
  .xl\\:prose-lg tbody td {
    padding-top: 0.75em;
    padding-right: 0.75em;
    padding-bottom: 0.75em;
    padding-left: 0.75em;
  }
  .xl\\:prose-lg tbody td:first-child {
    padding-left: 0;
  }
  .xl\\:prose-lg tbody td:last-child {
    padding-right: 0;
  }
  .xl\\:prose-lg> :first-child {
    margin-top: 0;
  }
  .xl\\:prose-lg> :last-child {
    margin-bottom: 0;
  }
  .xl\\:prose-xl {
    font-size: 1.25rem;
    line-height: 1.8;
  }
  .xl\\:prose-xl p {
    margin-top: 1.2em;
    margin-bottom: 1.2em;
  }
  .xl\\:prose-xl [class~="lead"] {
    font-size: 1.2em;
    line-height: 1.5;
    margin-top: 1em;
    margin-bottom: 1em;
  }
  .xl\\:prose-xl blockquote {
    margin-top: 1.6em;
    margin-bottom: 1.6em;
    padding-left: 1.0666667em;
  }
  .xl\\:prose-xl h1 {
    font-size: 2.8em;
    margin-top: 0;
    margin-bottom: 0.8571429em;
    line-height: 1;
  }
  .xl\\:prose-xl h2 {
    font-size: 1.8em;
    margin-top: 1.5555556em;
    margin-bottom: 0.8888889em;
    line-height: 1.1111111;
  }
  .xl\\:prose-xl h3 {
    font-size: 1.5em;
    margin-top: 1.6em;
    margin-bottom: 0.6666667em;
    line-height: 1.3333333;
  }
  .xl\\:prose-xl h4 {
    margin-top: 1.8em;
    margin-bottom: 0.6em;
    line-height: 1.6;
  }
  .xl\\:prose-xl img {
    margin-top: 2em;
    margin-bottom: 2em;
  }
  .xl\\:prose-xl video {
    margin-top: 2em;
    margin-bottom: 2em;
  }
  .xl\\:prose-xl figure {
    margin-top: 2em;
    margin-bottom: 2em;
  }
  .xl\\:prose-xl figure>* {
    margin-top: 0;
    margin-bottom: 0;
  }
  .xl\\:prose-xl figure figcaption {
    font-size: 0.9em;
    line-height: 1.5555556;
    margin-top: 1em;
  }
  .xl\\:prose-xl code {
    font-size: 0.9em;
  }
  .xl\\:prose-xl h2 code {
    font-size: 0.8611111em;
  }
  .xl\\:prose-xl h3 code {
    font-size: 0.9em;
  }
  .xl\\:prose-xl pre {
    font-size: 0.9em;
    line-height: 1.7777778;
    margin-top: 2em;
    margin-bottom: 2em;
    border-radius: 0.5rem;
    padding-top: 1.1111111em;
    padding-right: 1.3333333em;
    padding-bottom: 1.1111111em;
    padding-left: 1.3333333em;
  }
  .xl\\:prose-xl ol {
    margin-top: 1.2em;
    margin-bottom: 1.2em;
  }
  .xl\\:prose-xl ul {
    margin-top: 1.2em;
    margin-bottom: 1.2em;
  }
  .xl\\:prose-xl li {
    margin-top: 0.6em;
    margin-bottom: 0.6em;
  }
  .xl\\:prose-xl ol>li {
    padding-left: 1.8em;
  }
  .xl\\:prose-xl ol>li:before {
    left: 0;
  }
  .xl\\:prose-xl ul>li {
    padding-left: 1.8em;
  }
  .xl\\:prose-xl ul>li::before {
    width: 0.35em;
    height: 0.35em;
    top: calc(0.9em - 0.175em);
    left: 0.25em;
  }
  .xl\\:prose-xl>ul>li p {
    margin-top: 0.8em;
    margin-bottom: 0.8em;
  }
  .xl\\:prose-xl>ul>li>*:first-child {
    margin-top: 1.2em;
  }
  .xl\\:prose-xl>ul>li>*:last-child {
    margin-bottom: 1.2em;
  }
  .xl\\:prose-xl>ol>li>*:first-child {
    margin-top: 1.2em;
  }
  .xl\\:prose-xl>ol>li>*:last-child {
    margin-bottom: 1.2em;
  }
  .xl\\:prose-xl ul ul, .xl\\:prose-xl ul ol, .xl\\:prose-xl ol ul, .xl\\:prose-xl ol ol {
    margin-top: 0.8em;
    margin-bottom: 0.8em;
  }
  .xl\\:prose-xl hr {
    margin-top: 2.8em;
    margin-bottom: 2.8em;
  }
  .xl\\:prose-xl hr+* {
    margin-top: 0;
  }
  .xl\\:prose-xl h2+* {
    margin-top: 0;
  }
  .xl\\:prose-xl h3+* {
    margin-top: 0;
  }
  .xl\\:prose-xl h4+* {
    margin-top: 0;
  }
  .xl\\:prose-xl table {
    font-size: 0.9em;
    line-height: 1.5555556;
  }
  .xl\\:prose-xl thead th {
    padding-right: 0.6666667em;
    padding-bottom: 0.8888889em;
    padding-left: 0.6666667em;
  }
  .xl\\:prose-xl thead th:first-child {
    padding-left: 0;
  }
  .xl\\:prose-xl thead th:last-child {
    padding-right: 0;
  }
  .xl\\:prose-xl tbody td {
    padding-top: 0.8888889em;
    padding-right: 0.6666667em;
    padding-bottom: 0.8888889em;
    padding-left: 0.6666667em;
  }
  .xl\\:prose-xl tbody td:first-child {
    padding-left: 0;
  }
  .xl\\:prose-xl tbody td:last-child {
    padding-right: 0;
  }
  .xl\\:prose-xl> :first-child {
    margin-top: 0;
  }
  .xl\\:prose-xl> :last-child {
    margin-bottom: 0;
  }
  .xl\\:prose-2xl {
    font-size: 1.5rem;
    line-height: 1.6666667;
  }
  .xl\\:prose-2xl p {
    margin-top: 1.3333333em;
    margin-bottom: 1.3333333em;
  }
  .xl\\:prose-2xl [class~="lead"] {
    font-size: 1.25em;
    line-height: 1.4666667;
    margin-top: 1.0666667em;
    margin-bottom: 1.0666667em;
  }
  .xl\\:prose-2xl blockquote {
    margin-top: 1.7777778em;
    margin-bottom: 1.7777778em;
    padding-left: 1.1111111em;
  }
  .xl\\:prose-2xl h1 {
    font-size: 2.6666667em;
    margin-top: 0;
    margin-bottom: 0.875em;
    line-height: 1;
  }
  .xl\\:prose-2xl h2 {
    font-size: 2em;
    margin-top: 1.5em;
    margin-bottom: 0.8333333em;
    line-height: 1.0833333;
  }
  .xl\\:prose-2xl h3 {
    font-size: 1.5em;
    margin-top: 1.5555556em;
    margin-bottom: 0.6666667em;
    line-height: 1.2222222;
  }
  .xl\\:prose-2xl h4 {
    margin-top: 1.6666667em;
    margin-bottom: 0.6666667em;
    line-height: 1.5;
  }
  .xl\\:prose-2xl img {
    margin-top: 2em;
    margin-bottom: 2em;
  }
  .xl\\:prose-2xl video {
    margin-top: 2em;
    margin-bottom: 2em;
  }
  .xl\\:prose-2xl figure {
    margin-top: 2em;
    margin-bottom: 2em;
  }
  .xl\\:prose-2xl figure>* {
    margin-top: 0;
    margin-bottom: 0;
  }
  .xl\\:prose-2xl figure figcaption {
    font-size: 0.8333333em;
    line-height: 1.6;
    margin-top: 1em;
  }
  .xl\\:prose-2xl code {
    font-size: 0.8333333em;
  }
  .xl\\:prose-2xl h2 code {
    font-size: 0.875em;
  }
  .xl\\:prose-2xl h3 code {
    font-size: 0.8888889em;
  }
  .xl\\:prose-2xl pre {
    font-size: 0.8333333em;
    line-height: 1.8;
    margin-top: 2em;
    margin-bottom: 2em;
    border-radius: 0.5rem;
    padding-top: 1.2em;
    padding-right: 1.6em;
    padding-bottom: 1.2em;
    padding-left: 1.6em;
  }
  .xl\\:prose-2xl ol {
    margin-top: 1.3333333em;
    margin-bottom: 1.3333333em;
  }
  .xl\\:prose-2xl ul {
    margin-top: 1.3333333em;
    margin-bottom: 1.3333333em;
  }
  .xl\\:prose-2xl li {
    margin-top: 0.5em;
    margin-bottom: 0.5em;
  }
  .xl\\:prose-2xl ol>li {
    padding-left: 1.6666667em;
  }
  .xl\\:prose-2xl ol>li:before {
    left: 0;
  }
  .xl\\:prose-2xl ul>li {
    padding-left: 1.6666667em;
  }
  .xl\\:prose-2xl ul>li::before {
    width: 0.3333333em;
    height: 0.3333333em;
    top: calc(0.8333333em - 0.1666667em);
    left: 0.25em;
  }
  .xl\\:prose-2xl>ul>li p {
    margin-top: 0.8333333em;
    margin-bottom: 0.8333333em;
  }
  .xl\\:prose-2xl>ul>li>*:first-child {
    margin-top: 1.3333333em;
  }
  .xl\\:prose-2xl>ul>li>*:last-child {
    margin-bottom: 1.3333333em;
  }
  .xl\\:prose-2xl>ol>li>*:first-child {
    margin-top: 1.3333333em;
  }
  .xl\\:prose-2xl>ol>li>*:last-child {
    margin-bottom: 1.3333333em;
  }
  .xl\\:prose-2xl ul ul, .xl\\:prose-2xl ul ol, .xl\\:prose-2xl ol ul, .xl\\:prose-2xl ol ol {
    margin-top: 0.6666667em;
    margin-bottom: 0.6666667em;
  }
  .xl\\:prose-2xl hr {
    margin-top: 3em;
    margin-bottom: 3em;
  }
  .xl\\:prose-2xl hr+* {
    margin-top: 0;
  }
  .xl\\:prose-2xl h2+* {
    margin-top: 0;
  }
  .xl\\:prose-2xl h3+* {
    margin-top: 0;
  }
  .xl\\:prose-2xl h4+* {
    margin-top: 0;
  }
  .xl\\:prose-2xl table {
    font-size: 0.8333333em;
    line-height: 1.4;
  }
  .xl\\:prose-2xl thead th {
    padding-right: 0.6em;
    padding-bottom: 0.8em;
    padding-left: 0.6em;
  }
  .xl\\:prose-2xl thead th:first-child {
    padding-left: 0;
  }
  .xl\\:prose-2xl thead th:last-child {
    padding-right: 0;
  }
  .xl\\:prose-2xl tbody td {
    padding-top: 0.8em;
    padding-right: 0.6em;
    padding-bottom: 0.8em;
    padding-left: 0.6em;
  }
  .xl\\:prose-2xl tbody td:first-child {
    padding-left: 0;
  }
  .xl\\:prose-2xl tbody td:last-child {
    padding-right: 0;
  }
  .xl\\:prose-2xl> :first-child {
    margin-top: 0;
  }
  .xl\\:prose-2xl> :last-child {
    margin-bottom: 0;
  }
  .xl\\:space-y-0> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(0px * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(0px * var(--space-y-reverse));
  }
  .xl\\:space-x-0> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(0px * var(--space-x-reverse));
    margin-left: calc(0px * calc(1 - var(--space-x-reverse)));
  }
  .xl\\:space-y-1> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(0.25rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(0.25rem * var(--space-y-reverse));
  }
  .xl\\:space-x-1> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(0.25rem * var(--space-x-reverse));
    margin-left: calc(0.25rem * calc(1 - var(--space-x-reverse)));
  }
  .xl\\:space-y-2> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(0.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(0.5rem * var(--space-y-reverse));
  }
  .xl\\:space-x-2> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(0.5rem * var(--space-x-reverse));
    margin-left: calc(0.5rem * calc(1 - var(--space-x-reverse)));
  }
  .xl\\:space-y-3> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(0.75rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(0.75rem * var(--space-y-reverse));
  }
  .xl\\:space-x-3> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(0.75rem * var(--space-x-reverse));
    margin-left: calc(0.75rem * calc(1 - var(--space-x-reverse)));
  }
  .xl\\:space-y-4> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(1rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(1rem * var(--space-y-reverse));
  }
  .xl\\:space-x-4> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(1rem * var(--space-x-reverse));
    margin-left: calc(1rem * calc(1 - var(--space-x-reverse)));
  }
  .xl\\:space-y-5> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(1.25rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(1.25rem * var(--space-y-reverse));
  }
  .xl\\:space-x-5> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(1.25rem * var(--space-x-reverse));
    margin-left: calc(1.25rem * calc(1 - var(--space-x-reverse)));
  }
  .xl\\:space-y-6> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(1.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(1.5rem * var(--space-y-reverse));
  }
  .xl\\:space-x-6> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(1.5rem * var(--space-x-reverse));
    margin-left: calc(1.5rem * calc(1 - var(--space-x-reverse)));
  }
  .xl\\:space-y-7> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(1.75rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(1.75rem * var(--space-y-reverse));
  }
  .xl\\:space-x-7> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(1.75rem * var(--space-x-reverse));
    margin-left: calc(1.75rem * calc(1 - var(--space-x-reverse)));
  }
  .xl\\:space-y-8> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(2rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(2rem * var(--space-y-reverse));
  }
  .xl\\:space-x-8> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(2rem * var(--space-x-reverse));
    margin-left: calc(2rem * calc(1 - var(--space-x-reverse)));
  }
  .xl\\:space-y-9> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(2.25rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(2.25rem * var(--space-y-reverse));
  }
  .xl\\:space-x-9> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(2.25rem * var(--space-x-reverse));
    margin-left: calc(2.25rem * calc(1 - var(--space-x-reverse)));
  }
  .xl\\:space-y-10> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(2.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(2.5rem * var(--space-y-reverse));
  }
  .xl\\:space-x-10> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(2.5rem * var(--space-x-reverse));
    margin-left: calc(2.5rem * calc(1 - var(--space-x-reverse)));
  }
  .xl\\:space-y-11> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(2.75rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(2.75rem * var(--space-y-reverse));
  }
  .xl\\:space-x-11> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(2.75rem * var(--space-x-reverse));
    margin-left: calc(2.75rem * calc(1 - var(--space-x-reverse)));
  }
  .xl\\:space-y-12> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(3rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(3rem * var(--space-y-reverse));
  }
  .xl\\:space-x-12> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(3rem * var(--space-x-reverse));
    margin-left: calc(3rem * calc(1 - var(--space-x-reverse)));
  }
  .xl\\:space-y-13> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(3.25rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(3.25rem * var(--space-y-reverse));
  }
  .xl\\:space-x-13> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(3.25rem * var(--space-x-reverse));
    margin-left: calc(3.25rem * calc(1 - var(--space-x-reverse)));
  }
  .xl\\:space-y-14> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(3.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(3.5rem * var(--space-y-reverse));
  }
  .xl\\:space-x-14> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(3.5rem * var(--space-x-reverse));
    margin-left: calc(3.5rem * calc(1 - var(--space-x-reverse)));
  }
  .xl\\:space-y-15> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(3.75rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(3.75rem * var(--space-y-reverse));
  }
  .xl\\:space-x-15> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(3.75rem * var(--space-x-reverse));
    margin-left: calc(3.75rem * calc(1 - var(--space-x-reverse)));
  }
  .xl\\:space-y-16> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(4rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(4rem * var(--space-y-reverse));
  }
  .xl\\:space-x-16> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(4rem * var(--space-x-reverse));
    margin-left: calc(4rem * calc(1 - var(--space-x-reverse)));
  }
  .xl\\:space-y-20> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(5rem * var(--space-y-reverse));
  }
  .xl\\:space-x-20> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(5rem * var(--space-x-reverse));
    margin-left: calc(5rem * calc(1 - var(--space-x-reverse)));
  }
  .xl\\:space-y-24> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(6rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(6rem * var(--space-y-reverse));
  }
  .xl\\:space-x-24> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(6rem * var(--space-x-reverse));
    margin-left: calc(6rem * calc(1 - var(--space-x-reverse)));
  }
  .xl\\:space-y-28> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(7rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(7rem * var(--space-y-reverse));
  }
  .xl\\:space-x-28> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(7rem * var(--space-x-reverse));
    margin-left: calc(7rem * calc(1 - var(--space-x-reverse)));
  }
  .xl\\:space-y-32> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(8rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(8rem * var(--space-y-reverse));
  }
  .xl\\:space-x-32> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(8rem * var(--space-x-reverse));
    margin-left: calc(8rem * calc(1 - var(--space-x-reverse)));
  }
  .xl\\:space-y-36> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(9rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(9rem * var(--space-y-reverse));
  }
  .xl\\:space-x-36> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(9rem * var(--space-x-reverse));
    margin-left: calc(9rem * calc(1 - var(--space-x-reverse)));
  }
  .xl\\:space-y-40> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(10rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(10rem * var(--space-y-reverse));
  }
  .xl\\:space-x-40> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(10rem * var(--space-x-reverse));
    margin-left: calc(10rem * calc(1 - var(--space-x-reverse)));
  }
  .xl\\:space-y-44> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(11rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(11rem * var(--space-y-reverse));
  }
  .xl\\:space-x-44> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(11rem * var(--space-x-reverse));
    margin-left: calc(11rem * calc(1 - var(--space-x-reverse)));
  }
  .xl\\:space-y-48> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(12rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(12rem * var(--space-y-reverse));
  }
  .xl\\:space-x-48> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(12rem * var(--space-x-reverse));
    margin-left: calc(12rem * calc(1 - var(--space-x-reverse)));
  }
  .xl\\:space-y-52> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(13rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(13rem * var(--space-y-reverse));
  }
  .xl\\:space-x-52> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(13rem * var(--space-x-reverse));
    margin-left: calc(13rem * calc(1 - var(--space-x-reverse)));
  }
  .xl\\:space-y-56> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(14rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(14rem * var(--space-y-reverse));
  }
  .xl\\:space-x-56> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(14rem * var(--space-x-reverse));
    margin-left: calc(14rem * calc(1 - var(--space-x-reverse)));
  }
  .xl\\:space-y-60> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(15rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(15rem * var(--space-y-reverse));
  }
  .xl\\:space-x-60> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(15rem * var(--space-x-reverse));
    margin-left: calc(15rem * calc(1 - var(--space-x-reverse)));
  }
  .xl\\:space-y-64> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(16rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(16rem * var(--space-y-reverse));
  }
  .xl\\:space-x-64> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(16rem * var(--space-x-reverse));
    margin-left: calc(16rem * calc(1 - var(--space-x-reverse)));
  }
  .xl\\:space-y-72> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(18rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(18rem * var(--space-y-reverse));
  }
  .xl\\:space-x-72> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(18rem * var(--space-x-reverse));
    margin-left: calc(18rem * calc(1 - var(--space-x-reverse)));
  }
  .xl\\:space-y-80> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(20rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(20rem * var(--space-y-reverse));
  }
  .xl\\:space-x-80> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(20rem * var(--space-x-reverse));
    margin-left: calc(20rem * calc(1 - var(--space-x-reverse)));
  }
  .xl\\:space-y-96> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(24rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(24rem * var(--space-y-reverse));
  }
  .xl\\:space-x-96> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(24rem * var(--space-x-reverse));
    margin-left: calc(24rem * calc(1 - var(--space-x-reverse)));
  }
  .xl\\:space-y-px> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(1px * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(1px * var(--space-y-reverse));
  }
  .xl\\:space-x-px> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(1px * var(--space-x-reverse));
    margin-left: calc(1px * calc(1 - var(--space-x-reverse)));
  }
  .xl\\:space-y-0\\.5> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(0.125rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(0.125rem * var(--space-y-reverse));
  }
  .xl\\:space-x-0\\.5> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(0.125rem * var(--space-x-reverse));
    margin-left: calc(0.125rem * calc(1 - var(--space-x-reverse)));
  }
  .xl\\:space-y-1\\.5> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(0.375rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(0.375rem * var(--space-y-reverse));
  }
  .xl\\:space-x-1\\.5> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(0.375rem * var(--space-x-reverse));
    margin-left: calc(0.375rem * calc(1 - var(--space-x-reverse)));
  }
  .xl\\:space-y-2\\.5> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(0.625rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(0.625rem * var(--space-y-reverse));
  }
  .xl\\:space-x-2\\.5> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(0.625rem * var(--space-x-reverse));
    margin-left: calc(0.625rem * calc(1 - var(--space-x-reverse)));
  }
  .xl\\:space-y-3\\.5> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(0.875rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(0.875rem * var(--space-y-reverse));
  }
  .xl\\:space-x-3\\.5> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(0.875rem * var(--space-x-reverse));
    margin-left: calc(0.875rem * calc(1 - var(--space-x-reverse)));
  }
  .xl\\:space-y-1\\/2> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(50% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(50% * var(--space-y-reverse));
  }
  .xl\\:space-x-1\\/2> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(50% * var(--space-x-reverse));
    margin-left: calc(50% * calc(1 - var(--space-x-reverse)));
  }
  .xl\\:space-y-1\\/3> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(33.333333% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(33.333333% * var(--space-y-reverse));
  }
  .xl\\:space-x-1\\/3> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(33.333333% * var(--space-x-reverse));
    margin-left: calc(33.333333% * calc(1 - var(--space-x-reverse)));
  }
  .xl\\:space-y-2\\/3> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(66.666667% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(66.666667% * var(--space-y-reverse));
  }
  .xl\\:space-x-2\\/3> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(66.666667% * var(--space-x-reverse));
    margin-left: calc(66.666667% * calc(1 - var(--space-x-reverse)));
  }
  .xl\\:space-y-1\\/4> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(25% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(25% * var(--space-y-reverse));
  }
  .xl\\:space-x-1\\/4> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(25% * var(--space-x-reverse));
    margin-left: calc(25% * calc(1 - var(--space-x-reverse)));
  }
  .xl\\:space-y-2\\/4> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(50% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(50% * var(--space-y-reverse));
  }
  .xl\\:space-x-2\\/4> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(50% * var(--space-x-reverse));
    margin-left: calc(50% * calc(1 - var(--space-x-reverse)));
  }
  .xl\\:space-y-3\\/4> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(75% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(75% * var(--space-y-reverse));
  }
  .xl\\:space-x-3\\/4> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(75% * var(--space-x-reverse));
    margin-left: calc(75% * calc(1 - var(--space-x-reverse)));
  }
  .xl\\:space-y-1\\/5> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(20% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(20% * var(--space-y-reverse));
  }
  .xl\\:space-x-1\\/5> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(20% * var(--space-x-reverse));
    margin-left: calc(20% * calc(1 - var(--space-x-reverse)));
  }
  .xl\\:space-y-2\\/5> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(40% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(40% * var(--space-y-reverse));
  }
  .xl\\:space-x-2\\/5> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(40% * var(--space-x-reverse));
    margin-left: calc(40% * calc(1 - var(--space-x-reverse)));
  }
  .xl\\:space-y-3\\/5> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(60% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(60% * var(--space-y-reverse));
  }
  .xl\\:space-x-3\\/5> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(60% * var(--space-x-reverse));
    margin-left: calc(60% * calc(1 - var(--space-x-reverse)));
  }
  .xl\\:space-y-4\\/5> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(80% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(80% * var(--space-y-reverse));
  }
  .xl\\:space-x-4\\/5> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(80% * var(--space-x-reverse));
    margin-left: calc(80% * calc(1 - var(--space-x-reverse)));
  }
  .xl\\:space-y-1\\/6> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(16.666667% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(16.666667% * var(--space-y-reverse));
  }
  .xl\\:space-x-1\\/6> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(16.666667% * var(--space-x-reverse));
    margin-left: calc(16.666667% * calc(1 - var(--space-x-reverse)));
  }
  .xl\\:space-y-2\\/6> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(33.333333% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(33.333333% * var(--space-y-reverse));
  }
  .xl\\:space-x-2\\/6> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(33.333333% * var(--space-x-reverse));
    margin-left: calc(33.333333% * calc(1 - var(--space-x-reverse)));
  }
  .xl\\:space-y-3\\/6> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(50% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(50% * var(--space-y-reverse));
  }
  .xl\\:space-x-3\\/6> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(50% * var(--space-x-reverse));
    margin-left: calc(50% * calc(1 - var(--space-x-reverse)));
  }
  .xl\\:space-y-4\\/6> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(66.666667% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(66.666667% * var(--space-y-reverse));
  }
  .xl\\:space-x-4\\/6> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(66.666667% * var(--space-x-reverse));
    margin-left: calc(66.666667% * calc(1 - var(--space-x-reverse)));
  }
  .xl\\:space-y-5\\/6> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(83.333333% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(83.333333% * var(--space-y-reverse));
  }
  .xl\\:space-x-5\\/6> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(83.333333% * var(--space-x-reverse));
    margin-left: calc(83.333333% * calc(1 - var(--space-x-reverse)));
  }
  .xl\\:space-y-1\\/12> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(8.333333% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(8.333333% * var(--space-y-reverse));
  }
  .xl\\:space-x-1\\/12> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(8.333333% * var(--space-x-reverse));
    margin-left: calc(8.333333% * calc(1 - var(--space-x-reverse)));
  }
  .xl\\:space-y-2\\/12> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(16.666667% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(16.666667% * var(--space-y-reverse));
  }
  .xl\\:space-x-2\\/12> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(16.666667% * var(--space-x-reverse));
    margin-left: calc(16.666667% * calc(1 - var(--space-x-reverse)));
  }
  .xl\\:space-y-3\\/12> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(25% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(25% * var(--space-y-reverse));
  }
  .xl\\:space-x-3\\/12> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(25% * var(--space-x-reverse));
    margin-left: calc(25% * calc(1 - var(--space-x-reverse)));
  }
  .xl\\:space-y-4\\/12> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(33.333333% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(33.333333% * var(--space-y-reverse));
  }
  .xl\\:space-x-4\\/12> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(33.333333% * var(--space-x-reverse));
    margin-left: calc(33.333333% * calc(1 - var(--space-x-reverse)));
  }
  .xl\\:space-y-5\\/12> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(41.666667% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(41.666667% * var(--space-y-reverse));
  }
  .xl\\:space-x-5\\/12> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(41.666667% * var(--space-x-reverse));
    margin-left: calc(41.666667% * calc(1 - var(--space-x-reverse)));
  }
  .xl\\:space-y-6\\/12> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(50% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(50% * var(--space-y-reverse));
  }
  .xl\\:space-x-6\\/12> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(50% * var(--space-x-reverse));
    margin-left: calc(50% * calc(1 - var(--space-x-reverse)));
  }
  .xl\\:space-y-7\\/12> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(58.333333% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(58.333333% * var(--space-y-reverse));
  }
  .xl\\:space-x-7\\/12> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(58.333333% * var(--space-x-reverse));
    margin-left: calc(58.333333% * calc(1 - var(--space-x-reverse)));
  }
  .xl\\:space-y-8\\/12> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(66.666667% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(66.666667% * var(--space-y-reverse));
  }
  .xl\\:space-x-8\\/12> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(66.666667% * var(--space-x-reverse));
    margin-left: calc(66.666667% * calc(1 - var(--space-x-reverse)));
  }
  .xl\\:space-y-9\\/12> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(75% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(75% * var(--space-y-reverse));
  }
  .xl\\:space-x-9\\/12> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(75% * var(--space-x-reverse));
    margin-left: calc(75% * calc(1 - var(--space-x-reverse)));
  }
  .xl\\:space-y-10\\/12> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(83.333333% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(83.333333% * var(--space-y-reverse));
  }
  .xl\\:space-x-10\\/12> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(83.333333% * var(--space-x-reverse));
    margin-left: calc(83.333333% * calc(1 - var(--space-x-reverse)));
  }
  .xl\\:space-y-11\\/12> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(91.666667% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(91.666667% * var(--space-y-reverse));
  }
  .xl\\:space-x-11\\/12> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(91.666667% * var(--space-x-reverse));
    margin-left: calc(91.666667% * calc(1 - var(--space-x-reverse)));
  }
  .xl\\:space-y-full> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(100% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(100% * var(--space-y-reverse));
  }
  .xl\\:space-x-full> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(100% * var(--space-x-reverse));
    margin-left: calc(100% * calc(1 - var(--space-x-reverse)));
  }
  .xl\\:-space-y-1> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-0.25rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-0.25rem * var(--space-y-reverse));
  }
  .xl\\:-space-x-1> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-0.25rem * var(--space-x-reverse));
    margin-left: calc(-0.25rem * calc(1 - var(--space-x-reverse)));
  }
  .xl\\:-space-y-2> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-0.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-0.5rem * var(--space-y-reverse));
  }
  .xl\\:-space-x-2> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-0.5rem * var(--space-x-reverse));
    margin-left: calc(-0.5rem * calc(1 - var(--space-x-reverse)));
  }
  .xl\\:-space-y-3> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-0.75rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-0.75rem * var(--space-y-reverse));
  }
  .xl\\:-space-x-3> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-0.75rem * var(--space-x-reverse));
    margin-left: calc(-0.75rem * calc(1 - var(--space-x-reverse)));
  }
  .xl\\:-space-y-4> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-1rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-1rem * var(--space-y-reverse));
  }
  .xl\\:-space-x-4> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-1rem * var(--space-x-reverse));
    margin-left: calc(-1rem * calc(1 - var(--space-x-reverse)));
  }
  .xl\\:-space-y-5> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-1.25rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-1.25rem * var(--space-y-reverse));
  }
  .xl\\:-space-x-5> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-1.25rem * var(--space-x-reverse));
    margin-left: calc(-1.25rem * calc(1 - var(--space-x-reverse)));
  }
  .xl\\:-space-y-6> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-1.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-1.5rem * var(--space-y-reverse));
  }
  .xl\\:-space-x-6> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-1.5rem * var(--space-x-reverse));
    margin-left: calc(-1.5rem * calc(1 - var(--space-x-reverse)));
  }
  .xl\\:-space-y-7> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-1.75rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-1.75rem * var(--space-y-reverse));
  }
  .xl\\:-space-x-7> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-1.75rem * var(--space-x-reverse));
    margin-left: calc(-1.75rem * calc(1 - var(--space-x-reverse)));
  }
  .xl\\:-space-y-8> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-2rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-2rem * var(--space-y-reverse));
  }
  .xl\\:-space-x-8> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-2rem * var(--space-x-reverse));
    margin-left: calc(-2rem * calc(1 - var(--space-x-reverse)));
  }
  .xl\\:-space-y-9> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-2.25rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-2.25rem * var(--space-y-reverse));
  }
  .xl\\:-space-x-9> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-2.25rem * var(--space-x-reverse));
    margin-left: calc(-2.25rem * calc(1 - var(--space-x-reverse)));
  }
  .xl\\:-space-y-10> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-2.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-2.5rem * var(--space-y-reverse));
  }
  .xl\\:-space-x-10> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-2.5rem * var(--space-x-reverse));
    margin-left: calc(-2.5rem * calc(1 - var(--space-x-reverse)));
  }
  .xl\\:-space-y-11> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-2.75rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-2.75rem * var(--space-y-reverse));
  }
  .xl\\:-space-x-11> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-2.75rem * var(--space-x-reverse));
    margin-left: calc(-2.75rem * calc(1 - var(--space-x-reverse)));
  }
  .xl\\:-space-y-12> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-3rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-3rem * var(--space-y-reverse));
  }
  .xl\\:-space-x-12> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-3rem * var(--space-x-reverse));
    margin-left: calc(-3rem * calc(1 - var(--space-x-reverse)));
  }
  .xl\\:-space-y-13> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-3.25rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-3.25rem * var(--space-y-reverse));
  }
  .xl\\:-space-x-13> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-3.25rem * var(--space-x-reverse));
    margin-left: calc(-3.25rem * calc(1 - var(--space-x-reverse)));
  }
  .xl\\:-space-y-14> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-3.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-3.5rem * var(--space-y-reverse));
  }
  .xl\\:-space-x-14> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-3.5rem * var(--space-x-reverse));
    margin-left: calc(-3.5rem * calc(1 - var(--space-x-reverse)));
  }
  .xl\\:-space-y-15> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-3.75rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-3.75rem * var(--space-y-reverse));
  }
  .xl\\:-space-x-15> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-3.75rem * var(--space-x-reverse));
    margin-left: calc(-3.75rem * calc(1 - var(--space-x-reverse)));
  }
  .xl\\:-space-y-16> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-4rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-4rem * var(--space-y-reverse));
  }
  .xl\\:-space-x-16> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-4rem * var(--space-x-reverse));
    margin-left: calc(-4rem * calc(1 - var(--space-x-reverse)));
  }
  .xl\\:-space-y-20> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-5rem * var(--space-y-reverse));
  }
  .xl\\:-space-x-20> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-5rem * var(--space-x-reverse));
    margin-left: calc(-5rem * calc(1 - var(--space-x-reverse)));
  }
  .xl\\:-space-y-24> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-6rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-6rem * var(--space-y-reverse));
  }
  .xl\\:-space-x-24> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-6rem * var(--space-x-reverse));
    margin-left: calc(-6rem * calc(1 - var(--space-x-reverse)));
  }
  .xl\\:-space-y-28> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-7rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-7rem * var(--space-y-reverse));
  }
  .xl\\:-space-x-28> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-7rem * var(--space-x-reverse));
    margin-left: calc(-7rem * calc(1 - var(--space-x-reverse)));
  }
  .xl\\:-space-y-32> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-8rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-8rem * var(--space-y-reverse));
  }
  .xl\\:-space-x-32> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-8rem * var(--space-x-reverse));
    margin-left: calc(-8rem * calc(1 - var(--space-x-reverse)));
  }
  .xl\\:-space-y-36> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-9rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-9rem * var(--space-y-reverse));
  }
  .xl\\:-space-x-36> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-9rem * var(--space-x-reverse));
    margin-left: calc(-9rem * calc(1 - var(--space-x-reverse)));
  }
  .xl\\:-space-y-40> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-10rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-10rem * var(--space-y-reverse));
  }
  .xl\\:-space-x-40> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-10rem * var(--space-x-reverse));
    margin-left: calc(-10rem * calc(1 - var(--space-x-reverse)));
  }
  .xl\\:-space-y-44> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-11rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-11rem * var(--space-y-reverse));
  }
  .xl\\:-space-x-44> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-11rem * var(--space-x-reverse));
    margin-left: calc(-11rem * calc(1 - var(--space-x-reverse)));
  }
  .xl\\:-space-y-48> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-12rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-12rem * var(--space-y-reverse));
  }
  .xl\\:-space-x-48> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-12rem * var(--space-x-reverse));
    margin-left: calc(-12rem * calc(1 - var(--space-x-reverse)));
  }
  .xl\\:-space-y-52> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-13rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-13rem * var(--space-y-reverse));
  }
  .xl\\:-space-x-52> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-13rem * var(--space-x-reverse));
    margin-left: calc(-13rem * calc(1 - var(--space-x-reverse)));
  }
  .xl\\:-space-y-56> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-14rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-14rem * var(--space-y-reverse));
  }
  .xl\\:-space-x-56> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-14rem * var(--space-x-reverse));
    margin-left: calc(-14rem * calc(1 - var(--space-x-reverse)));
  }
  .xl\\:-space-y-60> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-15rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-15rem * var(--space-y-reverse));
  }
  .xl\\:-space-x-60> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-15rem * var(--space-x-reverse));
    margin-left: calc(-15rem * calc(1 - var(--space-x-reverse)));
  }
  .xl\\:-space-y-64> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-16rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-16rem * var(--space-y-reverse));
  }
  .xl\\:-space-x-64> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-16rem * var(--space-x-reverse));
    margin-left: calc(-16rem * calc(1 - var(--space-x-reverse)));
  }
  .xl\\:-space-y-72> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-18rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-18rem * var(--space-y-reverse));
  }
  .xl\\:-space-x-72> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-18rem * var(--space-x-reverse));
    margin-left: calc(-18rem * calc(1 - var(--space-x-reverse)));
  }
  .xl\\:-space-y-80> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-20rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-20rem * var(--space-y-reverse));
  }
  .xl\\:-space-x-80> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-20rem * var(--space-x-reverse));
    margin-left: calc(-20rem * calc(1 - var(--space-x-reverse)));
  }
  .xl\\:-space-y-96> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-24rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-24rem * var(--space-y-reverse));
  }
  .xl\\:-space-x-96> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-24rem * var(--space-x-reverse));
    margin-left: calc(-24rem * calc(1 - var(--space-x-reverse)));
  }
  .xl\\:-space-y-px> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-1px * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-1px * var(--space-y-reverse));
  }
  .xl\\:-space-x-px> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-1px * var(--space-x-reverse));
    margin-left: calc(-1px * calc(1 - var(--space-x-reverse)));
  }
  .xl\\:-space-y-0\\.5> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-0.125rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-0.125rem * var(--space-y-reverse));
  }
  .xl\\:-space-x-0\\.5> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-0.125rem * var(--space-x-reverse));
    margin-left: calc(-0.125rem * calc(1 - var(--space-x-reverse)));
  }
  .xl\\:-space-y-1\\.5> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-0.375rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-0.375rem * var(--space-y-reverse));
  }
  .xl\\:-space-x-1\\.5> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-0.375rem * var(--space-x-reverse));
    margin-left: calc(-0.375rem * calc(1 - var(--space-x-reverse)));
  }
  .xl\\:-space-y-2\\.5> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-0.625rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-0.625rem * var(--space-y-reverse));
  }
  .xl\\:-space-x-2\\.5> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-0.625rem * var(--space-x-reverse));
    margin-left: calc(-0.625rem * calc(1 - var(--space-x-reverse)));
  }
  .xl\\:-space-y-3\\.5> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-0.875rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-0.875rem * var(--space-y-reverse));
  }
  .xl\\:-space-x-3\\.5> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-0.875rem * var(--space-x-reverse));
    margin-left: calc(-0.875rem * calc(1 - var(--space-x-reverse)));
  }
  .xl\\:-space-y-1\\/2> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-50% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-50% * var(--space-y-reverse));
  }
  .xl\\:-space-x-1\\/2> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-50% * var(--space-x-reverse));
    margin-left: calc(-50% * calc(1 - var(--space-x-reverse)));
  }
  .xl\\:-space-y-1\\/3> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-33.33333% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-33.33333% * var(--space-y-reverse));
  }
  .xl\\:-space-x-1\\/3> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-33.33333% * var(--space-x-reverse));
    margin-left: calc(-33.33333% * calc(1 - var(--space-x-reverse)));
  }
  .xl\\:-space-y-2\\/3> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-66.66667% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-66.66667% * var(--space-y-reverse));
  }
  .xl\\:-space-x-2\\/3> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-66.66667% * var(--space-x-reverse));
    margin-left: calc(-66.66667% * calc(1 - var(--space-x-reverse)));
  }
  .xl\\:-space-y-1\\/4> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-25% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-25% * var(--space-y-reverse));
  }
  .xl\\:-space-x-1\\/4> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-25% * var(--space-x-reverse));
    margin-left: calc(-25% * calc(1 - var(--space-x-reverse)));
  }
  .xl\\:-space-y-2\\/4> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-50% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-50% * var(--space-y-reverse));
  }
  .xl\\:-space-x-2\\/4> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-50% * var(--space-x-reverse));
    margin-left: calc(-50% * calc(1 - var(--space-x-reverse)));
  }
  .xl\\:-space-y-3\\/4> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-75% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-75% * var(--space-y-reverse));
  }
  .xl\\:-space-x-3\\/4> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-75% * var(--space-x-reverse));
    margin-left: calc(-75% * calc(1 - var(--space-x-reverse)));
  }
  .xl\\:-space-y-1\\/5> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-20% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-20% * var(--space-y-reverse));
  }
  .xl\\:-space-x-1\\/5> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-20% * var(--space-x-reverse));
    margin-left: calc(-20% * calc(1 - var(--space-x-reverse)));
  }
  .xl\\:-space-y-2\\/5> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-40% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-40% * var(--space-y-reverse));
  }
  .xl\\:-space-x-2\\/5> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-40% * var(--space-x-reverse));
    margin-left: calc(-40% * calc(1 - var(--space-x-reverse)));
  }
  .xl\\:-space-y-3\\/5> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-60% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-60% * var(--space-y-reverse));
  }
  .xl\\:-space-x-3\\/5> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-60% * var(--space-x-reverse));
    margin-left: calc(-60% * calc(1 - var(--space-x-reverse)));
  }
  .xl\\:-space-y-4\\/5> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-80% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-80% * var(--space-y-reverse));
  }
  .xl\\:-space-x-4\\/5> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-80% * var(--space-x-reverse));
    margin-left: calc(-80% * calc(1 - var(--space-x-reverse)));
  }
  .xl\\:-space-y-1\\/6> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-16.66667% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-16.66667% * var(--space-y-reverse));
  }
  .xl\\:-space-x-1\\/6> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-16.66667% * var(--space-x-reverse));
    margin-left: calc(-16.66667% * calc(1 - var(--space-x-reverse)));
  }
  .xl\\:-space-y-2\\/6> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-33.33333% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-33.33333% * var(--space-y-reverse));
  }
  .xl\\:-space-x-2\\/6> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-33.33333% * var(--space-x-reverse));
    margin-left: calc(-33.33333% * calc(1 - var(--space-x-reverse)));
  }
  .xl\\:-space-y-3\\/6> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-50% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-50% * var(--space-y-reverse));
  }
  .xl\\:-space-x-3\\/6> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-50% * var(--space-x-reverse));
    margin-left: calc(-50% * calc(1 - var(--space-x-reverse)));
  }
  .xl\\:-space-y-4\\/6> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-66.66667% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-66.66667% * var(--space-y-reverse));
  }
  .xl\\:-space-x-4\\/6> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-66.66667% * var(--space-x-reverse));
    margin-left: calc(-66.66667% * calc(1 - var(--space-x-reverse)));
  }
  .xl\\:-space-y-5\\/6> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-83.33333% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-83.33333% * var(--space-y-reverse));
  }
  .xl\\:-space-x-5\\/6> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-83.33333% * var(--space-x-reverse));
    margin-left: calc(-83.33333% * calc(1 - var(--space-x-reverse)));
  }
  .xl\\:-space-y-1\\/12> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-8.33333% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-8.33333% * var(--space-y-reverse));
  }
  .xl\\:-space-x-1\\/12> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-8.33333% * var(--space-x-reverse));
    margin-left: calc(-8.33333% * calc(1 - var(--space-x-reverse)));
  }
  .xl\\:-space-y-2\\/12> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-16.66667% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-16.66667% * var(--space-y-reverse));
  }
  .xl\\:-space-x-2\\/12> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-16.66667% * var(--space-x-reverse));
    margin-left: calc(-16.66667% * calc(1 - var(--space-x-reverse)));
  }
  .xl\\:-space-y-3\\/12> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-25% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-25% * var(--space-y-reverse));
  }
  .xl\\:-space-x-3\\/12> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-25% * var(--space-x-reverse));
    margin-left: calc(-25% * calc(1 - var(--space-x-reverse)));
  }
  .xl\\:-space-y-4\\/12> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-33.33333% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-33.33333% * var(--space-y-reverse));
  }
  .xl\\:-space-x-4\\/12> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-33.33333% * var(--space-x-reverse));
    margin-left: calc(-33.33333% * calc(1 - var(--space-x-reverse)));
  }
  .xl\\:-space-y-5\\/12> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-41.66667% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-41.66667% * var(--space-y-reverse));
  }
  .xl\\:-space-x-5\\/12> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-41.66667% * var(--space-x-reverse));
    margin-left: calc(-41.66667% * calc(1 - var(--space-x-reverse)));
  }
  .xl\\:-space-y-6\\/12> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-50% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-50% * var(--space-y-reverse));
  }
  .xl\\:-space-x-6\\/12> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-50% * var(--space-x-reverse));
    margin-left: calc(-50% * calc(1 - var(--space-x-reverse)));
  }
  .xl\\:-space-y-7\\/12> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-58.33333% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-58.33333% * var(--space-y-reverse));
  }
  .xl\\:-space-x-7\\/12> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-58.33333% * var(--space-x-reverse));
    margin-left: calc(-58.33333% * calc(1 - var(--space-x-reverse)));
  }
  .xl\\:-space-y-8\\/12> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-66.66667% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-66.66667% * var(--space-y-reverse));
  }
  .xl\\:-space-x-8\\/12> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-66.66667% * var(--space-x-reverse));
    margin-left: calc(-66.66667% * calc(1 - var(--space-x-reverse)));
  }
  .xl\\:-space-y-9\\/12> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-75% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-75% * var(--space-y-reverse));
  }
  .xl\\:-space-x-9\\/12> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-75% * var(--space-x-reverse));
    margin-left: calc(-75% * calc(1 - var(--space-x-reverse)));
  }
  .xl\\:-space-y-10\\/12> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-83.33333% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-83.33333% * var(--space-y-reverse));
  }
  .xl\\:-space-x-10\\/12> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-83.33333% * var(--space-x-reverse));
    margin-left: calc(-83.33333% * calc(1 - var(--space-x-reverse)));
  }
  .xl\\:-space-y-11\\/12> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-91.66667% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-91.66667% * var(--space-y-reverse));
  }
  .xl\\:-space-x-11\\/12> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-91.66667% * var(--space-x-reverse));
    margin-left: calc(-91.66667% * calc(1 - var(--space-x-reverse)));
  }
  .xl\\:-space-y-full> :not(template)~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-100% * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-100% * var(--space-y-reverse));
  }
  .xl\\:-space-x-full> :not(template)~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-100% * var(--space-x-reverse));
    margin-left: calc(-100% * calc(1 - var(--space-x-reverse)));
  }
  .xl\\:space-y-reverse> :not(template)~ :not(template) {
    --space-y-reverse: 1;
  }
  .xl\\:space-x-reverse> :not(template)~ :not(template) {
    --space-x-reverse: 1;
  }
  .xl\\:divide-y-0> :not(template)~ :not(template) {
    --divide-y-reverse: 0;
    border-top-width: calc(0px * calc(1 - var(--divide-y-reverse)));
    border-bottom-width: calc(0px * var(--divide-y-reverse));
  }
  .xl\\:divide-x-0> :not(template)~ :not(template) {
    --divide-x-reverse: 0;
    border-right-width: calc(0px * var(--divide-x-reverse));
    border-left-width: calc(0px * calc(1 - var(--divide-x-reverse)));
  }
  .xl\\:divide-y-2> :not(template)~ :not(template) {
    --divide-y-reverse: 0;
    border-top-width: calc(2px * calc(1 - var(--divide-y-reverse)));
    border-bottom-width: calc(2px * var(--divide-y-reverse));
  }
  .xl\\:divide-x-2> :not(template)~ :not(template) {
    --divide-x-reverse: 0;
    border-right-width: calc(2px * var(--divide-x-reverse));
    border-left-width: calc(2px * calc(1 - var(--divide-x-reverse)));
  }
  .xl\\:divide-y-4> :not(template)~ :not(template) {
    --divide-y-reverse: 0;
    border-top-width: calc(4px * calc(1 - var(--divide-y-reverse)));
    border-bottom-width: calc(4px * var(--divide-y-reverse));
  }
  .xl\\:divide-x-4> :not(template)~ :not(template) {
    --divide-x-reverse: 0;
    border-right-width: calc(4px * var(--divide-x-reverse));
    border-left-width: calc(4px * calc(1 - var(--divide-x-reverse)));
  }
  .xl\\:divide-y-8> :not(template)~ :not(template) {
    --divide-y-reverse: 0;
    border-top-width: calc(8px * calc(1 - var(--divide-y-reverse)));
    border-bottom-width: calc(8px * var(--divide-y-reverse));
  }
  .xl\\:divide-x-8> :not(template)~ :not(template) {
    --divide-x-reverse: 0;
    border-right-width: calc(8px * var(--divide-x-reverse));
    border-left-width: calc(8px * calc(1 - var(--divide-x-reverse)));
  }
  .xl\\:divide-y> :not(template)~ :not(template) {
    --divide-y-reverse: 0;
    border-top-width: calc(1px * calc(1 - var(--divide-y-reverse)));
    border-bottom-width: calc(1px * var(--divide-y-reverse));
  }
  .xl\\:divide-x> :not(template)~ :not(template) {
    --divide-x-reverse: 0;
    border-right-width: calc(1px * var(--divide-x-reverse));
    border-left-width: calc(1px * calc(1 - var(--divide-x-reverse)));
  }
  .xl\\:divide-y-reverse> :not(template)~ :not(template) {
    --divide-y-reverse: 1;
  }
  .xl\\:divide-x-reverse> :not(template)~ :not(template) {
    --divide-x-reverse: 1;
  }
  .xl\\:divide-current> :not(template)~ :not(template) {
    border-color: currentColor;
  }
  .xl\\:divide-transparent> :not(template)~ :not(template) {
    border-color: transparent;
  }
  .xl\\:divide-white> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #ffffff;
    border-color: rgba(255, 255, 255, var(--divide-opacity));
  }
  .xl\\:divide-black> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #000000;
    border-color: rgba(0, 0, 0, var(--divide-opacity));
  }
  .xl\\:divide-gray-50> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #f9fafb;
    border-color: rgba(249, 250, 251, var(--divide-opacity));
  }
  .xl\\:divide-gray-100> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #f4f5f7;
    border-color: rgba(244, 245, 247, var(--divide-opacity));
  }
  .xl\\:divide-gray-200> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #e5e7eb;
    border-color: rgba(229, 231, 235, var(--divide-opacity));
  }
  .xl\\:divide-gray-300> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #d2d6dc;
    border-color: rgba(210, 214, 220, var(--divide-opacity));
  }
  .xl\\:divide-gray-400> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #9fa6b2;
    border-color: rgba(159, 166, 178, var(--divide-opacity));
  }
  .xl\\:divide-gray-500> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #6b7280;
    border-color: rgba(107, 114, 128, var(--divide-opacity));
  }
  .xl\\:divide-gray-600> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #4b5563;
    border-color: rgba(75, 85, 99, var(--divide-opacity));
  }
  .xl\\:divide-gray-700> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #374151;
    border-color: rgba(55, 65, 81, var(--divide-opacity));
  }
  .xl\\:divide-gray-800> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #252f3f;
    border-color: rgba(37, 47, 63, var(--divide-opacity));
  }
  .xl\\:divide-gray-900> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #161e2e;
    border-color: rgba(22, 30, 46, var(--divide-opacity));
  }
  .xl\\:divide-red-50> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #fdf2f2;
    border-color: rgba(253, 242, 242, var(--divide-opacity));
  }
  .xl\\:divide-red-100> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #fde8e8;
    border-color: rgba(253, 232, 232, var(--divide-opacity));
  }
  .xl\\:divide-red-200> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #fbd5d5;
    border-color: rgba(251, 213, 213, var(--divide-opacity));
  }
  .xl\\:divide-red-300> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #f8b4b4;
    border-color: rgba(248, 180, 180, var(--divide-opacity));
  }
  .xl\\:divide-red-400> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #f98080;
    border-color: rgba(249, 128, 128, var(--divide-opacity));
  }
  .xl\\:divide-red-500> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #f05252;
    border-color: rgba(240, 82, 82, var(--divide-opacity));
  }
  .xl\\:divide-red-600> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #e02424;
    border-color: rgba(224, 36, 36, var(--divide-opacity));
  }
  .xl\\:divide-red-700> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #c81e1e;
    border-color: rgba(200, 30, 30, var(--divide-opacity));
  }
  .xl\\:divide-red-800> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #9b1c1c;
    border-color: rgba(155, 28, 28, var(--divide-opacity));
  }
  .xl\\:divide-red-900> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #771d1d;
    border-color: rgba(119, 29, 29, var(--divide-opacity));
  }
  .xl\\:divide-orange-50> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #fff8f1;
    border-color: rgba(255, 248, 241, var(--divide-opacity));
  }
  .xl\\:divide-orange-100> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #feecdc;
    border-color: rgba(254, 236, 220, var(--divide-opacity));
  }
  .xl\\:divide-orange-200> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #fcd9bd;
    border-color: rgba(252, 217, 189, var(--divide-opacity));
  }
  .xl\\:divide-orange-300> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #fdba8c;
    border-color: rgba(253, 186, 140, var(--divide-opacity));
  }
  .xl\\:divide-orange-400> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #ff8a4c;
    border-color: rgba(255, 138, 76, var(--divide-opacity));
  }
  .xl\\:divide-orange-500> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #ff5a1f;
    border-color: rgba(255, 90, 31, var(--divide-opacity));
  }
  .xl\\:divide-orange-600> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #d03801;
    border-color: rgba(208, 56, 1, var(--divide-opacity));
  }
  .xl\\:divide-orange-700> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #b43403;
    border-color: rgba(180, 52, 3, var(--divide-opacity));
  }
  .xl\\:divide-orange-800> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #8a2c0d;
    border-color: rgba(138, 44, 13, var(--divide-opacity));
  }
  .xl\\:divide-orange-900> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #73230d;
    border-color: rgba(115, 35, 13, var(--divide-opacity));
  }
  .xl\\:divide-yellow-50> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #fdfdea;
    border-color: rgba(253, 253, 234, var(--divide-opacity));
  }
  .xl\\:divide-yellow-100> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #fdf6b2;
    border-color: rgba(253, 246, 178, var(--divide-opacity));
  }
  .xl\\:divide-yellow-200> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #fce96a;
    border-color: rgba(252, 233, 106, var(--divide-opacity));
  }
  .xl\\:divide-yellow-300> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #faca15;
    border-color: rgba(250, 202, 21, var(--divide-opacity));
  }
  .xl\\:divide-yellow-400> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #e3a008;
    border-color: rgba(227, 160, 8, var(--divide-opacity));
  }
  .xl\\:divide-yellow-500> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #c27803;
    border-color: rgba(194, 120, 3, var(--divide-opacity));
  }
  .xl\\:divide-yellow-600> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #9f580a;
    border-color: rgba(159, 88, 10, var(--divide-opacity));
  }
  .xl\\:divide-yellow-700> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #8e4b10;
    border-color: rgba(142, 75, 16, var(--divide-opacity));
  }
  .xl\\:divide-yellow-800> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #723b13;
    border-color: rgba(114, 59, 19, var(--divide-opacity));
  }
  .xl\\:divide-yellow-900> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #633112;
    border-color: rgba(99, 49, 18, var(--divide-opacity));
  }
  .xl\\:divide-green-50> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #f3faf7;
    border-color: rgba(243, 250, 247, var(--divide-opacity));
  }
  .xl\\:divide-green-100> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #def7ec;
    border-color: rgba(222, 247, 236, var(--divide-opacity));
  }
  .xl\\:divide-green-200> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #bcf0da;
    border-color: rgba(188, 240, 218, var(--divide-opacity));
  }
  .xl\\:divide-green-300> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #84e1bc;
    border-color: rgba(132, 225, 188, var(--divide-opacity));
  }
  .xl\\:divide-green-400> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #31c48d;
    border-color: rgba(49, 196, 141, var(--divide-opacity));
  }
  .xl\\:divide-green-500> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #0e9f6e;
    border-color: rgba(14, 159, 110, var(--divide-opacity));
  }
  .xl\\:divide-green-600> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #057a55;
    border-color: rgba(5, 122, 85, var(--divide-opacity));
  }
  .xl\\:divide-green-700> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #046c4e;
    border-color: rgba(4, 108, 78, var(--divide-opacity));
  }
  .xl\\:divide-green-800> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #03543f;
    border-color: rgba(3, 84, 63, var(--divide-opacity));
  }
  .xl\\:divide-green-900> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #014737;
    border-color: rgba(1, 71, 55, var(--divide-opacity));
  }
  .xl\\:divide-teal-50> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #edfafa;
    border-color: rgba(237, 250, 250, var(--divide-opacity));
  }
  .xl\\:divide-teal-100> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #d5f5f6;
    border-color: rgba(213, 245, 246, var(--divide-opacity));
  }
  .xl\\:divide-teal-200> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #afecef;
    border-color: rgba(175, 236, 239, var(--divide-opacity));
  }
  .xl\\:divide-teal-300> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #7edce2;
    border-color: rgba(126, 220, 226, var(--divide-opacity));
  }
  .xl\\:divide-teal-400> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #16bdca;
    border-color: rgba(22, 189, 202, var(--divide-opacity));
  }
  .xl\\:divide-teal-500> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #0694a2;
    border-color: rgba(6, 148, 162, var(--divide-opacity));
  }
  .xl\\:divide-teal-600> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #047481;
    border-color: rgba(4, 116, 129, var(--divide-opacity));
  }
  .xl\\:divide-teal-700> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #036672;
    border-color: rgba(3, 102, 114, var(--divide-opacity));
  }
  .xl\\:divide-teal-800> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #05505c;
    border-color: rgba(5, 80, 92, var(--divide-opacity));
  }
  .xl\\:divide-teal-900> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #014451;
    border-color: rgba(1, 68, 81, var(--divide-opacity));
  }
  .xl\\:divide-blue-50> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #ebf5ff;
    border-color: rgba(235, 245, 255, var(--divide-opacity));
  }
  .xl\\:divide-blue-100> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #e1effe;
    border-color: rgba(225, 239, 254, var(--divide-opacity));
  }
  .xl\\:divide-blue-200> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #c3ddfd;
    border-color: rgba(195, 221, 253, var(--divide-opacity));
  }
  .xl\\:divide-blue-300> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #a4cafe;
    border-color: rgba(164, 202, 254, var(--divide-opacity));
  }
  .xl\\:divide-blue-400> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #76a9fa;
    border-color: rgba(118, 169, 250, var(--divide-opacity));
  }
  .xl\\:divide-blue-500> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #3f83f8;
    border-color: rgba(63, 131, 248, var(--divide-opacity));
  }
  .xl\\:divide-blue-600> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #1c64f2;
    border-color: rgba(28, 100, 242, var(--divide-opacity));
  }
  .xl\\:divide-blue-700> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #1a56db;
    border-color: rgba(26, 86, 219, var(--divide-opacity));
  }
  .xl\\:divide-blue-800> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #1e429f;
    border-color: rgba(30, 66, 159, var(--divide-opacity));
  }
  .xl\\:divide-blue-900> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #233876;
    border-color: rgba(35, 56, 118, var(--divide-opacity));
  }
  .xl\\:divide-indigo-50> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #f0f5ff;
    border-color: rgba(240, 245, 255, var(--divide-opacity));
  }
  .xl\\:divide-indigo-100> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #e5edff;
    border-color: rgba(229, 237, 255, var(--divide-opacity));
  }
  .xl\\:divide-indigo-200> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #cddbfe;
    border-color: rgba(205, 219, 254, var(--divide-opacity));
  }
  .xl\\:divide-indigo-300> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #b4c6fc;
    border-color: rgba(180, 198, 252, var(--divide-opacity));
  }
  .xl\\:divide-indigo-400> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #8da2fb;
    border-color: rgba(141, 162, 251, var(--divide-opacity));
  }
  .xl\\:divide-indigo-500> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #6875f5;
    border-color: rgba(104, 117, 245, var(--divide-opacity));
  }
  .xl\\:divide-indigo-600> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #5850ec;
    border-color: rgba(88, 80, 236, var(--divide-opacity));
  }
  .xl\\:divide-indigo-700> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #5145cd;
    border-color: rgba(81, 69, 205, var(--divide-opacity));
  }
  .xl\\:divide-indigo-800> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #42389d;
    border-color: rgba(66, 56, 157, var(--divide-opacity));
  }
  .xl\\:divide-indigo-900> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #362f78;
    border-color: rgba(54, 47, 120, var(--divide-opacity));
  }
  .xl\\:divide-purple-50> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #f6f5ff;
    border-color: rgba(246, 245, 255, var(--divide-opacity));
  }
  .xl\\:divide-purple-100> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #edebfe;
    border-color: rgba(237, 235, 254, var(--divide-opacity));
  }
  .xl\\:divide-purple-200> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #dcd7fe;
    border-color: rgba(220, 215, 254, var(--divide-opacity));
  }
  .xl\\:divide-purple-300> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #cabffd;
    border-color: rgba(202, 191, 253, var(--divide-opacity));
  }
  .xl\\:divide-purple-400> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #ac94fa;
    border-color: rgba(172, 148, 250, var(--divide-opacity));
  }
  .xl\\:divide-purple-500> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #9061f9;
    border-color: rgba(144, 97, 249, var(--divide-opacity));
  }
  .xl\\:divide-purple-600> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #7e3af2;
    border-color: rgba(126, 58, 242, var(--divide-opacity));
  }
  .xl\\:divide-purple-700> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #6c2bd9;
    border-color: rgba(108, 43, 217, var(--divide-opacity));
  }
  .xl\\:divide-purple-800> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #5521b5;
    border-color: rgba(85, 33, 181, var(--divide-opacity));
  }
  .xl\\:divide-purple-900> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #4a1d96;
    border-color: rgba(74, 29, 150, var(--divide-opacity));
  }
  .xl\\:divide-pink-50> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #fdf2f8;
    border-color: rgba(253, 242, 248, var(--divide-opacity));
  }
  .xl\\:divide-pink-100> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #fce8f3;
    border-color: rgba(252, 232, 243, var(--divide-opacity));
  }
  .xl\\:divide-pink-200> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #fad1e8;
    border-color: rgba(250, 209, 232, var(--divide-opacity));
  }
  .xl\\:divide-pink-300> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #f8b4d9;
    border-color: rgba(248, 180, 217, var(--divide-opacity));
  }
  .xl\\:divide-pink-400> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #f17eb8;
    border-color: rgba(241, 126, 184, var(--divide-opacity));
  }
  .xl\\:divide-pink-500> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #e74694;
    border-color: rgba(231, 70, 148, var(--divide-opacity));
  }
  .xl\\:divide-pink-600> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #d61f69;
    border-color: rgba(214, 31, 105, var(--divide-opacity));
  }
  .xl\\:divide-pink-700> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #bf125d;
    border-color: rgba(191, 18, 93, var(--divide-opacity));
  }
  .xl\\:divide-pink-800> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #99154b;
    border-color: rgba(153, 21, 75, var(--divide-opacity));
  }
  .xl\\:divide-pink-900> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #751a3d;
    border-color: rgba(117, 26, 61, var(--divide-opacity));
  }
  .xl\\:divide-cool-gray-50> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #f8fafc;
    border-color: rgba(248, 250, 252, var(--divide-opacity));
  }
  .xl\\:divide-cool-gray-100> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #f1f5f9;
    border-color: rgba(241, 245, 249, var(--divide-opacity));
  }
  .xl\\:divide-cool-gray-200> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #e2e8f0;
    border-color: rgba(226, 232, 240, var(--divide-opacity));
  }
  .xl\\:divide-cool-gray-300> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #cfd8e3;
    border-color: rgba(207, 216, 227, var(--divide-opacity));
  }
  .xl\\:divide-cool-gray-400> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #97a6ba;
    border-color: rgba(151, 166, 186, var(--divide-opacity));
  }
  .xl\\:divide-cool-gray-500> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #64748b;
    border-color: rgba(100, 116, 139, var(--divide-opacity));
  }
  .xl\\:divide-cool-gray-600> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #475569;
    border-color: rgba(71, 85, 105, var(--divide-opacity));
  }
  .xl\\:divide-cool-gray-700> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #364152;
    border-color: rgba(54, 65, 82, var(--divide-opacity));
  }
  .xl\\:divide-cool-gray-800> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #27303f;
    border-color: rgba(39, 48, 63, var(--divide-opacity));
  }
  .xl\\:divide-cool-gray-900> :not(template)~ :not(template) {
    --divide-opacity: 1;
    border-color: #1a202e;
    border-color: rgba(26, 32, 46, var(--divide-opacity));
  }
  .xl\\:divide-solid> :not(template)~ :not(template) {
    border-style: solid;
  }
  .xl\\:divide-dashed> :not(template)~ :not(template) {
    border-style: dashed;
  }
  .xl\\:divide-dotted> :not(template)~ :not(template) {
    border-style: dotted;
  }
  .xl\\:divide-double> :not(template)~ :not(template) {
    border-style: double;
  }
  .xl\\:divide-none> :not(template)~ :not(template) {
    border-style: none;
  }
  .xl\\:divide-opacity-0> :not(template)~ :not(template) {
    --divide-opacity: 0;
  }
  .xl\\:divide-opacity-25> :not(template)~ :not(template) {
    --divide-opacity: 0.25;
  }
  .xl\\:divide-opacity-50> :not(template)~ :not(template) {
    --divide-opacity: 0.5;
  }
  .xl\\:divide-opacity-75> :not(template)~ :not(template) {
    --divide-opacity: 0.75;
  }
  .xl\\:divide-opacity-100> :not(template)~ :not(template) {
    --divide-opacity: 1;
  }
  .xl\\:sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border-width: 0;
  }
  .xl\\:not-sr-only {
    position: static;
    width: auto;
    height: auto;
    padding: 0;
    margin: 0;
    overflow: visible;
    clip: auto;
    white-space: normal;
  }
  .xl\\:focus\\:sr-only:focus {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border-width: 0;
  }
  .xl\\:focus\\:not-sr-only:focus {
    position: static;
    width: auto;
    height: auto;
    padding: 0;
    margin: 0;
    overflow: visible;
    clip: auto;
    white-space: normal;
  }
  .xl\\:appearance-none {
    appearance: none;
  }
  .xl\\:bg-fixed {
    background-attachment: fixed;
  }
  .xl\\:bg-local {
    background-attachment: local;
  }
  .xl\\:bg-scroll {
    background-attachment: scroll;
  }
  .xl\\:bg-clip-border {
    background-clip: border-box;
  }
  .xl\\:bg-clip-padding {
    background-clip: padding-box;
  }
  .xl\\:bg-clip-content {
    background-clip: content-box;
  }
  .xl\\:bg-clip-text {
    -webkit-background-clip: text;
    background-clip: text;
  }
  .xl\\:bg-current {
    background-color: currentColor;
  }
  .xl\\:bg-transparent {
    background-color: transparent;
  }
  .xl\\:bg-white {
    --bg-opacity: 1;
    background-color: #ffffff;
    background-color: rgba(255, 255, 255, var(--bg-opacity));
  }
  .xl\\:bg-black {
    --bg-opacity: 1;
    background-color: #000000;
    background-color: rgba(0, 0, 0, var(--bg-opacity));
  }
  .xl\\:bg-gray-50 {
    --bg-opacity: 1;
    background-color: #f9fafb;
    background-color: rgba(249, 250, 251, var(--bg-opacity));
  }
  .xl\\:bg-gray-100 {
    --bg-opacity: 1;
    background-color: #f4f5f7;
    background-color: rgba(244, 245, 247, var(--bg-opacity));
  }
  .xl\\:bg-gray-200 {
    --bg-opacity: 1;
    background-color: #e5e7eb;
    background-color: rgba(229, 231, 235, var(--bg-opacity));
  }
  .xl\\:bg-gray-300 {
    --bg-opacity: 1;
    background-color: #d2d6dc;
    background-color: rgba(210, 214, 220, var(--bg-opacity));
  }
  .xl\\:bg-gray-400 {
    --bg-opacity: 1;
    background-color: #9fa6b2;
    background-color: rgba(159, 166, 178, var(--bg-opacity));
  }
  .xl\\:bg-gray-500 {
    --bg-opacity: 1;
    background-color: #6b7280;
    background-color: rgba(107, 114, 128, var(--bg-opacity));
  }
  .xl\\:bg-gray-600 {
    --bg-opacity: 1;
    background-color: #4b5563;
    background-color: rgba(75, 85, 99, var(--bg-opacity));
  }
  .xl\\:bg-gray-700 {
    --bg-opacity: 1;
    background-color: #374151;
    background-color: rgba(55, 65, 81, var(--bg-opacity));
  }
  .xl\\:bg-gray-800 {
    --bg-opacity: 1;
    background-color: #252f3f;
    background-color: rgba(37, 47, 63, var(--bg-opacity));
  }
  .xl\\:bg-gray-900 {
    --bg-opacity: 1;
    background-color: #161e2e;
    background-color: rgba(22, 30, 46, var(--bg-opacity));
  }
  .xl\\:bg-red-50 {
    --bg-opacity: 1;
    background-color: #fdf2f2;
    background-color: rgba(253, 242, 242, var(--bg-opacity));
  }
  .xl\\:bg-red-100 {
    --bg-opacity: 1;
    background-color: #fde8e8;
    background-color: rgba(253, 232, 232, var(--bg-opacity));
  }
  .xl\\:bg-red-200 {
    --bg-opacity: 1;
    background-color: #fbd5d5;
    background-color: rgba(251, 213, 213, var(--bg-opacity));
  }
  .xl\\:bg-red-300 {
    --bg-opacity: 1;
    background-color: #f8b4b4;
    background-color: rgba(248, 180, 180, var(--bg-opacity));
  }
  .xl\\:bg-red-400 {
    --bg-opacity: 1;
    background-color: #f98080;
    background-color: rgba(249, 128, 128, var(--bg-opacity));
  }
  .xl\\:bg-red-500 {
    --bg-opacity: 1;
    background-color: #f05252;
    background-color: rgba(240, 82, 82, var(--bg-opacity));
  }
  .xl\\:bg-red-600 {
    --bg-opacity: 1;
    background-color: #e02424;
    background-color: rgba(224, 36, 36, var(--bg-opacity));
  }
  .xl\\:bg-red-700 {
    --bg-opacity: 1;
    background-color: #c81e1e;
    background-color: rgba(200, 30, 30, var(--bg-opacity));
  }
  .xl\\:bg-red-800 {
    --bg-opacity: 1;
    background-color: #9b1c1c;
    background-color: rgba(155, 28, 28, var(--bg-opacity));
  }
  .xl\\:bg-red-900 {
    --bg-opacity: 1;
    background-color: #771d1d;
    background-color: rgba(119, 29, 29, var(--bg-opacity));
  }
  .xl\\:bg-orange-50 {
    --bg-opacity: 1;
    background-color: #fff8f1;
    background-color: rgba(255, 248, 241, var(--bg-opacity));
  }
  .xl\\:bg-orange-100 {
    --bg-opacity: 1;
    background-color: #feecdc;
    background-color: rgba(254, 236, 220, var(--bg-opacity));
  }
  .xl\\:bg-orange-200 {
    --bg-opacity: 1;
    background-color: #fcd9bd;
    background-color: rgba(252, 217, 189, var(--bg-opacity));
  }
  .xl\\:bg-orange-300 {
    --bg-opacity: 1;
    background-color: #fdba8c;
    background-color: rgba(253, 186, 140, var(--bg-opacity));
  }
  .xl\\:bg-orange-400 {
    --bg-opacity: 1;
    background-color: #ff8a4c;
    background-color: rgba(255, 138, 76, var(--bg-opacity));
  }
  .xl\\:bg-orange-500 {
    --bg-opacity: 1;
    background-color: #ff5a1f;
    background-color: rgba(255, 90, 31, var(--bg-opacity));
  }
  .xl\\:bg-orange-600 {
    --bg-opacity: 1;
    background-color: #d03801;
    background-color: rgba(208, 56, 1, var(--bg-opacity));
  }
  .xl\\:bg-orange-700 {
    --bg-opacity: 1;
    background-color: #b43403;
    background-color: rgba(180, 52, 3, var(--bg-opacity));
  }
  .xl\\:bg-orange-800 {
    --bg-opacity: 1;
    background-color: #8a2c0d;
    background-color: rgba(138, 44, 13, var(--bg-opacity));
  }
  .xl\\:bg-orange-900 {
    --bg-opacity: 1;
    background-color: #73230d;
    background-color: rgba(115, 35, 13, var(--bg-opacity));
  }
  .xl\\:bg-yellow-50 {
    --bg-opacity: 1;
    background-color: #fdfdea;
    background-color: rgba(253, 253, 234, var(--bg-opacity));
  }
  .xl\\:bg-yellow-100 {
    --bg-opacity: 1;
    background-color: #fdf6b2;
    background-color: rgba(253, 246, 178, var(--bg-opacity));
  }
  .xl\\:bg-yellow-200 {
    --bg-opacity: 1;
    background-color: #fce96a;
    background-color: rgba(252, 233, 106, var(--bg-opacity));
  }
  .xl\\:bg-yellow-300 {
    --bg-opacity: 1;
    background-color: #faca15;
    background-color: rgba(250, 202, 21, var(--bg-opacity));
  }
  .xl\\:bg-yellow-400 {
    --bg-opacity: 1;
    background-color: #e3a008;
    background-color: rgba(227, 160, 8, var(--bg-opacity));
  }
  .xl\\:bg-yellow-500 {
    --bg-opacity: 1;
    background-color: #c27803;
    background-color: rgba(194, 120, 3, var(--bg-opacity));
  }
  .xl\\:bg-yellow-600 {
    --bg-opacity: 1;
    background-color: #9f580a;
    background-color: rgba(159, 88, 10, var(--bg-opacity));
  }
  .xl\\:bg-yellow-700 {
    --bg-opacity: 1;
    background-color: #8e4b10;
    background-color: rgba(142, 75, 16, var(--bg-opacity));
  }
  .xl\\:bg-yellow-800 {
    --bg-opacity: 1;
    background-color: #723b13;
    background-color: rgba(114, 59, 19, var(--bg-opacity));
  }
  .xl\\:bg-yellow-900 {
    --bg-opacity: 1;
    background-color: #633112;
    background-color: rgba(99, 49, 18, var(--bg-opacity));
  }
  .xl\\:bg-green-50 {
    --bg-opacity: 1;
    background-color: #f3faf7;
    background-color: rgba(243, 250, 247, var(--bg-opacity));
  }
  .xl\\:bg-green-100 {
    --bg-opacity: 1;
    background-color: #def7ec;
    background-color: rgba(222, 247, 236, var(--bg-opacity));
  }
  .xl\\:bg-green-200 {
    --bg-opacity: 1;
    background-color: #bcf0da;
    background-color: rgba(188, 240, 218, var(--bg-opacity));
  }
  .xl\\:bg-green-300 {
    --bg-opacity: 1;
    background-color: #84e1bc;
    background-color: rgba(132, 225, 188, var(--bg-opacity));
  }
  .xl\\:bg-green-400 {
    --bg-opacity: 1;
    background-color: #31c48d;
    background-color: rgba(49, 196, 141, var(--bg-opacity));
  }
  .xl\\:bg-green-500 {
    --bg-opacity: 1;
    background-color: #0e9f6e;
    background-color: rgba(14, 159, 110, var(--bg-opacity));
  }
  .xl\\:bg-green-600 {
    --bg-opacity: 1;
    background-color: #057a55;
    background-color: rgba(5, 122, 85, var(--bg-opacity));
  }
  .xl\\:bg-green-700 {
    --bg-opacity: 1;
    background-color: #046c4e;
    background-color: rgba(4, 108, 78, var(--bg-opacity));
  }
  .xl\\:bg-green-800 {
    --bg-opacity: 1;
    background-color: #03543f;
    background-color: rgba(3, 84, 63, var(--bg-opacity));
  }
  .xl\\:bg-green-900 {
    --bg-opacity: 1;
    background-color: #014737;
    background-color: rgba(1, 71, 55, var(--bg-opacity));
  }
  .xl\\:bg-teal-50 {
    --bg-opacity: 1;
    background-color: #edfafa;
    background-color: rgba(237, 250, 250, var(--bg-opacity));
  }
  .xl\\:bg-teal-100 {
    --bg-opacity: 1;
    background-color: #d5f5f6;
    background-color: rgba(213, 245, 246, var(--bg-opacity));
  }
  .xl\\:bg-teal-200 {
    --bg-opacity: 1;
    background-color: #afecef;
    background-color: rgba(175, 236, 239, var(--bg-opacity));
  }
  .xl\\:bg-teal-300 {
    --bg-opacity: 1;
    background-color: #7edce2;
    background-color: rgba(126, 220, 226, var(--bg-opacity));
  }
  .xl\\:bg-teal-400 {
    --bg-opacity: 1;
    background-color: #16bdca;
    background-color: rgba(22, 189, 202, var(--bg-opacity));
  }
  .xl\\:bg-teal-500 {
    --bg-opacity: 1;
    background-color: #0694a2;
    background-color: rgba(6, 148, 162, var(--bg-opacity));
  }
  .xl\\:bg-teal-600 {
    --bg-opacity: 1;
    background-color: #047481;
    background-color: rgba(4, 116, 129, var(--bg-opacity));
  }
  .xl\\:bg-teal-700 {
    --bg-opacity: 1;
    background-color: #036672;
    background-color: rgba(3, 102, 114, var(--bg-opacity));
  }
  .xl\\:bg-teal-800 {
    --bg-opacity: 1;
    background-color: #05505c;
    background-color: rgba(5, 80, 92, var(--bg-opacity));
  }
  .xl\\:bg-teal-900 {
    --bg-opacity: 1;
    background-color: #014451;
    background-color: rgba(1, 68, 81, var(--bg-opacity));
  }
  .xl\\:bg-blue-50 {
    --bg-opacity: 1;
    background-color: #ebf5ff;
    background-color: rgba(235, 245, 255, var(--bg-opacity));
  }
  .xl\\:bg-blue-100 {
    --bg-opacity: 1;
    background-color: #e1effe;
    background-color: rgba(225, 239, 254, var(--bg-opacity));
  }
  .xl\\:bg-blue-200 {
    --bg-opacity: 1;
    background-color: #c3ddfd;
    background-color: rgba(195, 221, 253, var(--bg-opacity));
  }
  .xl\\:bg-blue-300 {
    --bg-opacity: 1;
    background-color: #a4cafe;
    background-color: rgba(164, 202, 254, var(--bg-opacity));
  }
  .xl\\:bg-blue-400 {
    --bg-opacity: 1;
    background-color: #76a9fa;
    background-color: rgba(118, 169, 250, var(--bg-opacity));
  }
  .xl\\:bg-blue-500 {
    --bg-opacity: 1;
    background-color: #3f83f8;
    background-color: rgba(63, 131, 248, var(--bg-opacity));
  }
  .xl\\:bg-blue-600 {
    --bg-opacity: 1;
    background-color: #1c64f2;
    background-color: rgba(28, 100, 242, var(--bg-opacity));
  }
  .xl\\:bg-blue-700 {
    --bg-opacity: 1;
    background-color: #1a56db;
    background-color: rgba(26, 86, 219, var(--bg-opacity));
  }
  .xl\\:bg-blue-800 {
    --bg-opacity: 1;
    background-color: #1e429f;
    background-color: rgba(30, 66, 159, var(--bg-opacity));
  }
  .xl\\:bg-blue-900 {
    --bg-opacity: 1;
    background-color: #233876;
    background-color: rgba(35, 56, 118, var(--bg-opacity));
  }
  .xl\\:bg-indigo-50 {
    --bg-opacity: 1;
    background-color: #f0f5ff;
    background-color: rgba(240, 245, 255, var(--bg-opacity));
  }
  .xl\\:bg-indigo-100 {
    --bg-opacity: 1;
    background-color: #e5edff;
    background-color: rgba(229, 237, 255, var(--bg-opacity));
  }
  .xl\\:bg-indigo-200 {
    --bg-opacity: 1;
    background-color: #cddbfe;
    background-color: rgba(205, 219, 254, var(--bg-opacity));
  }
  .xl\\:bg-indigo-300 {
    --bg-opacity: 1;
    background-color: #b4c6fc;
    background-color: rgba(180, 198, 252, var(--bg-opacity));
  }
  .xl\\:bg-indigo-400 {
    --bg-opacity: 1;
    background-color: #8da2fb;
    background-color: rgba(141, 162, 251, var(--bg-opacity));
  }
  .xl\\:bg-indigo-500 {
    --bg-opacity: 1;
    background-color: #6875f5;
    background-color: rgba(104, 117, 245, var(--bg-opacity));
  }
  .xl\\:bg-indigo-600 {
    --bg-opacity: 1;
    background-color: #5850ec;
    background-color: rgba(88, 80, 236, var(--bg-opacity));
  }
  .xl\\:bg-indigo-700 {
    --bg-opacity: 1;
    background-color: #5145cd;
    background-color: rgba(81, 69, 205, var(--bg-opacity));
  }
  .xl\\:bg-indigo-800 {
    --bg-opacity: 1;
    background-color: #42389d;
    background-color: rgba(66, 56, 157, var(--bg-opacity));
  }
  .xl\\:bg-indigo-900 {
    --bg-opacity: 1;
    background-color: #362f78;
    background-color: rgba(54, 47, 120, var(--bg-opacity));
  }
  .xl\\:bg-purple-50 {
    --bg-opacity: 1;
    background-color: #f6f5ff;
    background-color: rgba(246, 245, 255, var(--bg-opacity));
  }
  .xl\\:bg-purple-100 {
    --bg-opacity: 1;
    background-color: #edebfe;
    background-color: rgba(237, 235, 254, var(--bg-opacity));
  }
  .xl\\:bg-purple-200 {
    --bg-opacity: 1;
    background-color: #dcd7fe;
    background-color: rgba(220, 215, 254, var(--bg-opacity));
  }
  .xl\\:bg-purple-300 {
    --bg-opacity: 1;
    background-color: #cabffd;
    background-color: rgba(202, 191, 253, var(--bg-opacity));
  }
  .xl\\:bg-purple-400 {
    --bg-opacity: 1;
    background-color: #ac94fa;
    background-color: rgba(172, 148, 250, var(--bg-opacity));
  }
  .xl\\:bg-purple-500 {
    --bg-opacity: 1;
    background-color: #9061f9;
    background-color: rgba(144, 97, 249, var(--bg-opacity));
  }
  .xl\\:bg-purple-600 {
    --bg-opacity: 1;
    background-color: #7e3af2;
    background-color: rgba(126, 58, 242, var(--bg-opacity));
  }
  .xl\\:bg-purple-700 {
    --bg-opacity: 1;
    background-color: #6c2bd9;
    background-color: rgba(108, 43, 217, var(--bg-opacity));
  }
  .xl\\:bg-purple-800 {
    --bg-opacity: 1;
    background-color: #5521b5;
    background-color: rgba(85, 33, 181, var(--bg-opacity));
  }
  .xl\\:bg-purple-900 {
    --bg-opacity: 1;
    background-color: #4a1d96;
    background-color: rgba(74, 29, 150, var(--bg-opacity));
  }
  .xl\\:bg-pink-50 {
    --bg-opacity: 1;
    background-color: #fdf2f8;
    background-color: rgba(253, 242, 248, var(--bg-opacity));
  }
  .xl\\:bg-pink-100 {
    --bg-opacity: 1;
    background-color: #fce8f3;
    background-color: rgba(252, 232, 243, var(--bg-opacity));
  }
  .xl\\:bg-pink-200 {
    --bg-opacity: 1;
    background-color: #fad1e8;
    background-color: rgba(250, 209, 232, var(--bg-opacity));
  }
  .xl\\:bg-pink-300 {
    --bg-opacity: 1;
    background-color: #f8b4d9;
    background-color: rgba(248, 180, 217, var(--bg-opacity));
  }
  .xl\\:bg-pink-400 {
    --bg-opacity: 1;
    background-color: #f17eb8;
    background-color: rgba(241, 126, 184, var(--bg-opacity));
  }
  .xl\\:bg-pink-500 {
    --bg-opacity: 1;
    background-color: #e74694;
    background-color: rgba(231, 70, 148, var(--bg-opacity));
  }
  .xl\\:bg-pink-600 {
    --bg-opacity: 1;
    background-color: #d61f69;
    background-color: rgba(214, 31, 105, var(--bg-opacity));
  }
  .xl\\:bg-pink-700 {
    --bg-opacity: 1;
    background-color: #bf125d;
    background-color: rgba(191, 18, 93, var(--bg-opacity));
  }
  .xl\\:bg-pink-800 {
    --bg-opacity: 1;
    background-color: #99154b;
    background-color: rgba(153, 21, 75, var(--bg-opacity));
  }
  .xl\\:bg-pink-900 {
    --bg-opacity: 1;
    background-color: #751a3d;
    background-color: rgba(117, 26, 61, var(--bg-opacity));
  }
  .xl\\:bg-cool-gray-50 {
    --bg-opacity: 1;
    background-color: #f8fafc;
    background-color: rgba(248, 250, 252, var(--bg-opacity));
  }
  .xl\\:bg-cool-gray-100 {
    --bg-opacity: 1;
    background-color: #f1f5f9;
    background-color: rgba(241, 245, 249, var(--bg-opacity));
  }
  .xl\\:bg-cool-gray-200 {
    --bg-opacity: 1;
    background-color: #e2e8f0;
    background-color: rgba(226, 232, 240, var(--bg-opacity));
  }
  .xl\\:bg-cool-gray-300 {
    --bg-opacity: 1;
    background-color: #cfd8e3;
    background-color: rgba(207, 216, 227, var(--bg-opacity));
  }
  .xl\\:bg-cool-gray-400 {
    --bg-opacity: 1;
    background-color: #97a6ba;
    background-color: rgba(151, 166, 186, var(--bg-opacity));
  }
  .xl\\:bg-cool-gray-500 {
    --bg-opacity: 1;
    background-color: #64748b;
    background-color: rgba(100, 116, 139, var(--bg-opacity));
  }
  .xl\\:bg-cool-gray-600 {
    --bg-opacity: 1;
    background-color: #475569;
    background-color: rgba(71, 85, 105, var(--bg-opacity));
  }
  .xl\\:bg-cool-gray-700 {
    --bg-opacity: 1;
    background-color: #364152;
    background-color: rgba(54, 65, 82, var(--bg-opacity));
  }
  .xl\\:bg-cool-gray-800 {
    --bg-opacity: 1;
    background-color: #27303f;
    background-color: rgba(39, 48, 63, var(--bg-opacity));
  }
  .xl\\:bg-cool-gray-900 {
    --bg-opacity: 1;
    background-color: #1a202e;
    background-color: rgba(26, 32, 46, var(--bg-opacity));
  }
  .group:hover .xl\\:group-hover\\:bg-current {
    background-color: currentColor;
  }
  .group:hover .xl\\:group-hover\\:bg-transparent {
    background-color: transparent;
  }
  .group:hover .xl\\:group-hover\\:bg-white {
    --bg-opacity: 1;
    background-color: #ffffff;
    background-color: rgba(255, 255, 255, var(--bg-opacity));
  }
  .group:hover .xl\\:group-hover\\:bg-black {
    --bg-opacity: 1;
    background-color: #000000;
    background-color: rgba(0, 0, 0, var(--bg-opacity));
  }
  .group:hover .xl\\:group-hover\\:bg-gray-50 {
    --bg-opacity: 1;
    background-color: #f9fafb;
    background-color: rgba(249, 250, 251, var(--bg-opacity));
  }
  .group:hover .xl\\:group-hover\\:bg-gray-100 {
    --bg-opacity: 1;
    background-color: #f4f5f7;
    background-color: rgba(244, 245, 247, var(--bg-opacity));
  }
  .group:hover .xl\\:group-hover\\:bg-gray-200 {
    --bg-opacity: 1;
    background-color: #e5e7eb;
    background-color: rgba(229, 231, 235, var(--bg-opacity));
  }
  .group:hover .xl\\:group-hover\\:bg-gray-300 {
    --bg-opacity: 1;
    background-color: #d2d6dc;
    background-color: rgba(210, 214, 220, var(--bg-opacity));
  }
  .group:hover .xl\\:group-hover\\:bg-gray-400 {
    --bg-opacity: 1;
    background-color: #9fa6b2;
    background-color: rgba(159, 166, 178, var(--bg-opacity));
  }
  .group:hover .xl\\:group-hover\\:bg-gray-500 {
    --bg-opacity: 1;
    background-color: #6b7280;
    background-color: rgba(107, 114, 128, var(--bg-opacity));
  }
  .group:hover .xl\\:group-hover\\:bg-gray-600 {
    --bg-opacity: 1;
    background-color: #4b5563;
    background-color: rgba(75, 85, 99, var(--bg-opacity));
  }
  .group:hover .xl\\:group-hover\\:bg-gray-700 {
    --bg-opacity: 1;
    background-color: #374151;
    background-color: rgba(55, 65, 81, var(--bg-opacity));
  }
  .group:hover .xl\\:group-hover\\:bg-gray-800 {
    --bg-opacity: 1;
    background-color: #252f3f;
    background-color: rgba(37, 47, 63, var(--bg-opacity));
  }
  .group:hover .xl\\:group-hover\\:bg-gray-900 {
    --bg-opacity: 1;
    background-color: #161e2e;
    background-color: rgba(22, 30, 46, var(--bg-opacity));
  }
  .group:hover .xl\\:group-hover\\:bg-red-50 {
    --bg-opacity: 1;
    background-color: #fdf2f2;
    background-color: rgba(253, 242, 242, var(--bg-opacity));
  }
  .group:hover .xl\\:group-hover\\:bg-red-100 {
    --bg-opacity: 1;
    background-color: #fde8e8;
    background-color: rgba(253, 232, 232, var(--bg-opacity));
  }
  .group:hover .xl\\:group-hover\\:bg-red-200 {
    --bg-opacity: 1;
    background-color: #fbd5d5;
    background-color: rgba(251, 213, 213, var(--bg-opacity));
  }
  .group:hover .xl\\:group-hover\\:bg-red-300 {
    --bg-opacity: 1;
    background-color: #f8b4b4;
    background-color: rgba(248, 180, 180, var(--bg-opacity));
  }
  .group:hover .xl\\:group-hover\\:bg-red-400 {
    --bg-opacity: 1;
    background-color: #f98080;
    background-color: rgba(249, 128, 128, var(--bg-opacity));
  }
  .group:hover .xl\\:group-hover\\:bg-red-500 {
    --bg-opacity: 1;
    background-color: #f05252;
    background-color: rgba(240, 82, 82, var(--bg-opacity));
  }
  .group:hover .xl\\:group-hover\\:bg-red-600 {
    --bg-opacity: 1;
    background-color: #e02424;
    background-color: rgba(224, 36, 36, var(--bg-opacity));
  }
  .group:hover .xl\\:group-hover\\:bg-red-700 {
    --bg-opacity: 1;
    background-color: #c81e1e;
    background-color: rgba(200, 30, 30, var(--bg-opacity));
  }
  .group:hover .xl\\:group-hover\\:bg-red-800 {
    --bg-opacity: 1;
    background-color: #9b1c1c;
    background-color: rgba(155, 28, 28, var(--bg-opacity));
  }
  .group:hover .xl\\:group-hover\\:bg-red-900 {
    --bg-opacity: 1;
    background-color: #771d1d;
    background-color: rgba(119, 29, 29, var(--bg-opacity));
  }
  .group:hover .xl\\:group-hover\\:bg-orange-50 {
    --bg-opacity: 1;
    background-color: #fff8f1;
    background-color: rgba(255, 248, 241, var(--bg-opacity));
  }
  .group:hover .xl\\:group-hover\\:bg-orange-100 {
    --bg-opacity: 1;
    background-color: #feecdc;
    background-color: rgba(254, 236, 220, var(--bg-opacity));
  }
  .group:hover .xl\\:group-hover\\:bg-orange-200 {
    --bg-opacity: 1;
    background-color: #fcd9bd;
    background-color: rgba(252, 217, 189, var(--bg-opacity));
  }
  .group:hover .xl\\:group-hover\\:bg-orange-300 {
    --bg-opacity: 1;
    background-color: #fdba8c;
    background-color: rgba(253, 186, 140, var(--bg-opacity));
  }
  .group:hover .xl\\:group-hover\\:bg-orange-400 {
    --bg-opacity: 1;
    background-color: #ff8a4c;
    background-color: rgba(255, 138, 76, var(--bg-opacity));
  }
  .group:hover .xl\\:group-hover\\:bg-orange-500 {
    --bg-opacity: 1;
    background-color: #ff5a1f;
    background-color: rgba(255, 90, 31, var(--bg-opacity));
  }
  .group:hover .xl\\:group-hover\\:bg-orange-600 {
    --bg-opacity: 1;
    background-color: #d03801;
    background-color: rgba(208, 56, 1, var(--bg-opacity));
  }
  .group:hover .xl\\:group-hover\\:bg-orange-700 {
    --bg-opacity: 1;
    background-color: #b43403;
    background-color: rgba(180, 52, 3, var(--bg-opacity));
  }
  .group:hover .xl\\:group-hover\\:bg-orange-800 {
    --bg-opacity: 1;
    background-color: #8a2c0d;
    background-color: rgba(138, 44, 13, var(--bg-opacity));
  }
  .group:hover .xl\\:group-hover\\:bg-orange-900 {
    --bg-opacity: 1;
    background-color: #73230d;
    background-color: rgba(115, 35, 13, var(--bg-opacity));
  }
  .group:hover .xl\\:group-hover\\:bg-yellow-50 {
    --bg-opacity: 1;
    background-color: #fdfdea;
    background-color: rgba(253, 253, 234, var(--bg-opacity));
  }
  .group:hover .xl\\:group-hover\\:bg-yellow-100 {
    --bg-opacity: 1;
    background-color: #fdf6b2;
    background-color: rgba(253, 246, 178, var(--bg-opacity));
  }
  .group:hover .xl\\:group-hover\\:bg-yellow-200 {
    --bg-opacity: 1;
    background-color: #fce96a;
    background-color: rgba(252, 233, 106, var(--bg-opacity));
  }
  .group:hover .xl\\:group-hover\\:bg-yellow-300 {
    --bg-opacity: 1;
    background-color: #faca15;
    background-color: rgba(250, 202, 21, var(--bg-opacity));
  }
  .group:hover .xl\\:group-hover\\:bg-yellow-400 {
    --bg-opacity: 1;
    background-color: #e3a008;
    background-color: rgba(227, 160, 8, var(--bg-opacity));
  }
  .group:hover .xl\\:group-hover\\:bg-yellow-500 {
    --bg-opacity: 1;
    background-color: #c27803;
    background-color: rgba(194, 120, 3, var(--bg-opacity));
  }
  .group:hover .xl\\:group-hover\\:bg-yellow-600 {
    --bg-opacity: 1;
    background-color: #9f580a;
    background-color: rgba(159, 88, 10, var(--bg-opacity));
  }
  .group:hover .xl\\:group-hover\\:bg-yellow-700 {
    --bg-opacity: 1;
    background-color: #8e4b10;
    background-color: rgba(142, 75, 16, var(--bg-opacity));
  }
  .group:hover .xl\\:group-hover\\:bg-yellow-800 {
    --bg-opacity: 1;
    background-color: #723b13;
    background-color: rgba(114, 59, 19, var(--bg-opacity));
  }
  .group:hover .xl\\:group-hover\\:bg-yellow-900 {
    --bg-opacity: 1;
    background-color: #633112;
    background-color: rgba(99, 49, 18, var(--bg-opacity));
  }
  .group:hover .xl\\:group-hover\\:bg-green-50 {
    --bg-opacity: 1;
    background-color: #f3faf7;
    background-color: rgba(243, 250, 247, var(--bg-opacity));
  }
  .group:hover .xl\\:group-hover\\:bg-green-100 {
    --bg-opacity: 1;
    background-color: #def7ec;
    background-color: rgba(222, 247, 236, var(--bg-opacity));
  }
  .group:hover .xl\\:group-hover\\:bg-green-200 {
    --bg-opacity: 1;
    background-color: #bcf0da;
    background-color: rgba(188, 240, 218, var(--bg-opacity));
  }
  .group:hover .xl\\:group-hover\\:bg-green-300 {
    --bg-opacity: 1;
    background-color: #84e1bc;
    background-color: rgba(132, 225, 188, var(--bg-opacity));
  }
  .group:hover .xl\\:group-hover\\:bg-green-400 {
    --bg-opacity: 1;
    background-color: #31c48d;
    background-color: rgba(49, 196, 141, var(--bg-opacity));
  }
  .group:hover .xl\\:group-hover\\:bg-green-500 {
    --bg-opacity: 1;
    background-color: #0e9f6e;
    background-color: rgba(14, 159, 110, var(--bg-opacity));
  }
  .group:hover .xl\\:group-hover\\:bg-green-600 {
    --bg-opacity: 1;
    background-color: #057a55;
    background-color: rgba(5, 122, 85, var(--bg-opacity));
  }
  .group:hover .xl\\:group-hover\\:bg-green-700 {
    --bg-opacity: 1;
    background-color: #046c4e;
    background-color: rgba(4, 108, 78, var(--bg-opacity));
  }
  .group:hover .xl\\:group-hover\\:bg-green-800 {
    --bg-opacity: 1;
    background-color: #03543f;
    background-color: rgba(3, 84, 63, var(--bg-opacity));
  }
  .group:hover .xl\\:group-hover\\:bg-green-900 {
    --bg-opacity: 1;
    background-color: #014737;
    background-color: rgba(1, 71, 55, var(--bg-opacity));
  }
  .group:hover .xl\\:group-hover\\:bg-teal-50 {
    --bg-opacity: 1;
    background-color: #edfafa;
    background-color: rgba(237, 250, 250, var(--bg-opacity));
  }
  .group:hover .xl\\:group-hover\\:bg-teal-100 {
    --bg-opacity: 1;
    background-color: #d5f5f6;
    background-color: rgba(213, 245, 246, var(--bg-opacity));
  }
  .group:hover .xl\\:group-hover\\:bg-teal-200 {
    --bg-opacity: 1;
    background-color: #afecef;
    background-color: rgba(175, 236, 239, var(--bg-opacity));
  }
  .group:hover .xl\\:group-hover\\:bg-teal-300 {
    --bg-opacity: 1;
    background-color: #7edce2;
    background-color: rgba(126, 220, 226, var(--bg-opacity));
  }
  .group:hover .xl\\:group-hover\\:bg-teal-400 {
    --bg-opacity: 1;
    background-color: #16bdca;
    background-color: rgba(22, 189, 202, var(--bg-opacity));
  }
  .group:hover .xl\\:group-hover\\:bg-teal-500 {
    --bg-opacity: 1;
    background-color: #0694a2;
    background-color: rgba(6, 148, 162, var(--bg-opacity));
  }
  .group:hover .xl\\:group-hover\\:bg-teal-600 {
    --bg-opacity: 1;
    background-color: #047481;
    background-color: rgba(4, 116, 129, var(--bg-opacity));
  }
  .group:hover .xl\\:group-hover\\:bg-teal-700 {
    --bg-opacity: 1;
    background-color: #036672;
    background-color: rgba(3, 102, 114, var(--bg-opacity));
  }
  .group:hover .xl\\:group-hover\\:bg-teal-800 {
    --bg-opacity: 1;
    background-color: #05505c;
    background-color: rgba(5, 80, 92, var(--bg-opacity));
  }
  .group:hover .xl\\:group-hover\\:bg-teal-900 {
    --bg-opacity: 1;
    background-color: #014451;
    background-color: rgba(1, 68, 81, var(--bg-opacity));
  }
  .group:hover .xl\\:group-hover\\:bg-blue-50 {
    --bg-opacity: 1;
    background-color: #ebf5ff;
    background-color: rgba(235, 245, 255, var(--bg-opacity));
  }
  .group:hover .xl\\:group-hover\\:bg-blue-100 {
    --bg-opacity: 1;
    background-color: #e1effe;
    background-color: rgba(225, 239, 254, var(--bg-opacity));
  }
  .group:hover .xl\\:group-hover\\:bg-blue-200 {
    --bg-opacity: 1;
    background-color: #c3ddfd;
    background-color: rgba(195, 221, 253, var(--bg-opacity));
  }
  .group:hover .xl\\:group-hover\\:bg-blue-300 {
    --bg-opacity: 1;
    background-color: #a4cafe;
    background-color: rgba(164, 202, 254, var(--bg-opacity));
  }
  .group:hover .xl\\:group-hover\\:bg-blue-400 {
    --bg-opacity: 1;
    background-color: #76a9fa;
    background-color: rgba(118, 169, 250, var(--bg-opacity));
  }
  .group:hover .xl\\:group-hover\\:bg-blue-500 {
    --bg-opacity: 1;
    background-color: #3f83f8;
    background-color: rgba(63, 131, 248, var(--bg-opacity));
  }
  .group:hover .xl\\:group-hover\\:bg-blue-600 {
    --bg-opacity: 1;
    background-color: #1c64f2;
    background-color: rgba(28, 100, 242, var(--bg-opacity));
  }
  .group:hover .xl\\:group-hover\\:bg-blue-700 {
    --bg-opacity: 1;
    background-color: #1a56db;
    background-color: rgba(26, 86, 219, var(--bg-opacity));
  }
  .group:hover .xl\\:group-hover\\:bg-blue-800 {
    --bg-opacity: 1;
    background-color: #1e429f;
    background-color: rgba(30, 66, 159, var(--bg-opacity));
  }
  .group:hover .xl\\:group-hover\\:bg-blue-900 {
    --bg-opacity: 1;
    background-color: #233876;
    background-color: rgba(35, 56, 118, var(--bg-opacity));
  }
  .group:hover .xl\\:group-hover\\:bg-indigo-50 {
    --bg-opacity: 1;
    background-color: #f0f5ff;
    background-color: rgba(240, 245, 255, var(--bg-opacity));
  }
  .group:hover .xl\\:group-hover\\:bg-indigo-100 {
    --bg-opacity: 1;
    background-color: #e5edff;
    background-color: rgba(229, 237, 255, var(--bg-opacity));
  }
  .group:hover .xl\\:group-hover\\:bg-indigo-200 {
    --bg-opacity: 1;
    background-color: #cddbfe;
    background-color: rgba(205, 219, 254, var(--bg-opacity));
  }
  .group:hover .xl\\:group-hover\\:bg-indigo-300 {
    --bg-opacity: 1;
    background-color: #b4c6fc;
    background-color: rgba(180, 198, 252, var(--bg-opacity));
  }
  .group:hover .xl\\:group-hover\\:bg-indigo-400 {
    --bg-opacity: 1;
    background-color: #8da2fb;
    background-color: rgba(141, 162, 251, var(--bg-opacity));
  }
  .group:hover .xl\\:group-hover\\:bg-indigo-500 {
    --bg-opacity: 1;
    background-color: #6875f5;
    background-color: rgba(104, 117, 245, var(--bg-opacity));
  }
  .group:hover .xl\\:group-hover\\:bg-indigo-600 {
    --bg-opacity: 1;
    background-color: #5850ec;
    background-color: rgba(88, 80, 236, var(--bg-opacity));
  }
  .group:hover .xl\\:group-hover\\:bg-indigo-700 {
    --bg-opacity: 1;
    background-color: #5145cd;
    background-color: rgba(81, 69, 205, var(--bg-opacity));
  }
  .group:hover .xl\\:group-hover\\:bg-indigo-800 {
    --bg-opacity: 1;
    background-color: #42389d;
    background-color: rgba(66, 56, 157, var(--bg-opacity));
  }
  .group:hover .xl\\:group-hover\\:bg-indigo-900 {
    --bg-opacity: 1;
    background-color: #362f78;
    background-color: rgba(54, 47, 120, var(--bg-opacity));
  }
  .group:hover .xl\\:group-hover\\:bg-purple-50 {
    --bg-opacity: 1;
    background-color: #f6f5ff;
    background-color: rgba(246, 245, 255, var(--bg-opacity));
  }
  .group:hover .xl\\:group-hover\\:bg-purple-100 {
    --bg-opacity: 1;
    background-color: #edebfe;
    background-color: rgba(237, 235, 254, var(--bg-opacity));
  }
  .group:hover .xl\\:group-hover\\:bg-purple-200 {
    --bg-opacity: 1;
    background-color: #dcd7fe;
    background-color: rgba(220, 215, 254, var(--bg-opacity));
  }
  .group:hover .xl\\:group-hover\\:bg-purple-300 {
    --bg-opacity: 1;
    background-color: #cabffd;
    background-color: rgba(202, 191, 253, var(--bg-opacity));
  }
  .group:hover .xl\\:group-hover\\:bg-purple-400 {
    --bg-opacity: 1;
    background-color: #ac94fa;
    background-color: rgba(172, 148, 250, var(--bg-opacity));
  }
  .group:hover .xl\\:group-hover\\:bg-purple-500 {
    --bg-opacity: 1;
    background-color: #9061f9;
    background-color: rgba(144, 97, 249, var(--bg-opacity));
  }
  .group:hover .xl\\:group-hover\\:bg-purple-600 {
    --bg-opacity: 1;
    background-color: #7e3af2;
    background-color: rgba(126, 58, 242, var(--bg-opacity));
  }
  .group:hover .xl\\:group-hover\\:bg-purple-700 {
    --bg-opacity: 1;
    background-color: #6c2bd9;
    background-color: rgba(108, 43, 217, var(--bg-opacity));
  }
  .group:hover .xl\\:group-hover\\:bg-purple-800 {
    --bg-opacity: 1;
    background-color: #5521b5;
    background-color: rgba(85, 33, 181, var(--bg-opacity));
  }
  .group:hover .xl\\:group-hover\\:bg-purple-900 {
    --bg-opacity: 1;
    background-color: #4a1d96;
    background-color: rgba(74, 29, 150, var(--bg-opacity));
  }
  .group:hover .xl\\:group-hover\\:bg-pink-50 {
    --bg-opacity: 1;
    background-color: #fdf2f8;
    background-color: rgba(253, 242, 248, var(--bg-opacity));
  }
  .group:hover .xl\\:group-hover\\:bg-pink-100 {
    --bg-opacity: 1;
    background-color: #fce8f3;
    background-color: rgba(252, 232, 243, var(--bg-opacity));
  }
  .group:hover .xl\\:group-hover\\:bg-pink-200 {
    --bg-opacity: 1;
    background-color: #fad1e8;
    background-color: rgba(250, 209, 232, var(--bg-opacity));
  }
  .group:hover .xl\\:group-hover\\:bg-pink-300 {
    --bg-opacity: 1;
    background-color: #f8b4d9;
    background-color: rgba(248, 180, 217, var(--bg-opacity));
  }
  .group:hover .xl\\:group-hover\\:bg-pink-400 {
    --bg-opacity: 1;
    background-color: #f17eb8;
    background-color: rgba(241, 126, 184, var(--bg-opacity));
  }
  .group:hover .xl\\:group-hover\\:bg-pink-500 {
    --bg-opacity: 1;
    background-color: #e74694;
    background-color: rgba(231, 70, 148, var(--bg-opacity));
  }
  .group:hover .xl\\:group-hover\\:bg-pink-600 {
    --bg-opacity: 1;
    background-color: #d61f69;
    background-color: rgba(214, 31, 105, var(--bg-opacity));
  }
  .group:hover .xl\\:group-hover\\:bg-pink-700 {
    --bg-opacity: 1;
    background-color: #bf125d;
    background-color: rgba(191, 18, 93, var(--bg-opacity));
  }
  .group:hover .xl\\:group-hover\\:bg-pink-800 {
    --bg-opacity: 1;
    background-color: #99154b;
    background-color: rgba(153, 21, 75, var(--bg-opacity));
  }
  .group:hover .xl\\:group-hover\\:bg-pink-900 {
    --bg-opacity: 1;
    background-color: #751a3d;
    background-color: rgba(117, 26, 61, var(--bg-opacity));
  }
  .group:hover .xl\\:group-hover\\:bg-cool-gray-50 {
    --bg-opacity: 1;
    background-color: #f8fafc;
    background-color: rgba(248, 250, 252, var(--bg-opacity));
  }
  .group:hover .xl\\:group-hover\\:bg-cool-gray-100 {
    --bg-opacity: 1;
    background-color: #f1f5f9;
    background-color: rgba(241, 245, 249, var(--bg-opacity));
  }
  .group:hover .xl\\:group-hover\\:bg-cool-gray-200 {
    --bg-opacity: 1;
    background-color: #e2e8f0;
    background-color: rgba(226, 232, 240, var(--bg-opacity));
  }
  .group:hover .xl\\:group-hover\\:bg-cool-gray-300 {
    --bg-opacity: 1;
    background-color: #cfd8e3;
    background-color: rgba(207, 216, 227, var(--bg-opacity));
  }
  .group:hover .xl\\:group-hover\\:bg-cool-gray-400 {
    --bg-opacity: 1;
    background-color: #97a6ba;
    background-color: rgba(151, 166, 186, var(--bg-opacity));
  }
  .group:hover .xl\\:group-hover\\:bg-cool-gray-500 {
    --bg-opacity: 1;
    background-color: #64748b;
    background-color: rgba(100, 116, 139, var(--bg-opacity));
  }
  .group:hover .xl\\:group-hover\\:bg-cool-gray-600 {
    --bg-opacity: 1;
    background-color: #475569;
    background-color: rgba(71, 85, 105, var(--bg-opacity));
  }
  .group:hover .xl\\:group-hover\\:bg-cool-gray-700 {
    --bg-opacity: 1;
    background-color: #364152;
    background-color: rgba(54, 65, 82, var(--bg-opacity));
  }
  .group:hover .xl\\:group-hover\\:bg-cool-gray-800 {
    --bg-opacity: 1;
    background-color: #27303f;
    background-color: rgba(39, 48, 63, var(--bg-opacity));
  }
  .group:hover .xl\\:group-hover\\:bg-cool-gray-900 {
    --bg-opacity: 1;
    background-color: #1a202e;
    background-color: rgba(26, 32, 46, var(--bg-opacity));
  }
  .group:focus .xl\\:group-focus\\:bg-current {
    background-color: currentColor;
  }
  .group:focus .xl\\:group-focus\\:bg-transparent {
    background-color: transparent;
  }
  .group:focus .xl\\:group-focus\\:bg-white {
    --bg-opacity: 1;
    background-color: #ffffff;
    background-color: rgba(255, 255, 255, var(--bg-opacity));
  }
  .group:focus .xl\\:group-focus\\:bg-black {
    --bg-opacity: 1;
    background-color: #000000;
    background-color: rgba(0, 0, 0, var(--bg-opacity));
  }
  .group:focus .xl\\:group-focus\\:bg-gray-50 {
    --bg-opacity: 1;
    background-color: #f9fafb;
    background-color: rgba(249, 250, 251, var(--bg-opacity));
  }
  .group:focus .xl\\:group-focus\\:bg-gray-100 {
    --bg-opacity: 1;
    background-color: #f4f5f7;
    background-color: rgba(244, 245, 247, var(--bg-opacity));
  }
  .group:focus .xl\\:group-focus\\:bg-gray-200 {
    --bg-opacity: 1;
    background-color: #e5e7eb;
    background-color: rgba(229, 231, 235, var(--bg-opacity));
  }
  .group:focus .xl\\:group-focus\\:bg-gray-300 {
    --bg-opacity: 1;
    background-color: #d2d6dc;
    background-color: rgba(210, 214, 220, var(--bg-opacity));
  }
  .group:focus .xl\\:group-focus\\:bg-gray-400 {
    --bg-opacity: 1;
    background-color: #9fa6b2;
    background-color: rgba(159, 166, 178, var(--bg-opacity));
  }
  .group:focus .xl\\:group-focus\\:bg-gray-500 {
    --bg-opacity: 1;
    background-color: #6b7280;
    background-color: rgba(107, 114, 128, var(--bg-opacity));
  }
  .group:focus .xl\\:group-focus\\:bg-gray-600 {
    --bg-opacity: 1;
    background-color: #4b5563;
    background-color: rgba(75, 85, 99, var(--bg-opacity));
  }
  .group:focus .xl\\:group-focus\\:bg-gray-700 {
    --bg-opacity: 1;
    background-color: #374151;
    background-color: rgba(55, 65, 81, var(--bg-opacity));
  }
  .group:focus .xl\\:group-focus\\:bg-gray-800 {
    --bg-opacity: 1;
    background-color: #252f3f;
    background-color: rgba(37, 47, 63, var(--bg-opacity));
  }
  .group:focus .xl\\:group-focus\\:bg-gray-900 {
    --bg-opacity: 1;
    background-color: #161e2e;
    background-color: rgba(22, 30, 46, var(--bg-opacity));
  }
  .group:focus .xl\\:group-focus\\:bg-red-50 {
    --bg-opacity: 1;
    background-color: #fdf2f2;
    background-color: rgba(253, 242, 242, var(--bg-opacity));
  }
  .group:focus .xl\\:group-focus\\:bg-red-100 {
    --bg-opacity: 1;
    background-color: #fde8e8;
    background-color: rgba(253, 232, 232, var(--bg-opacity));
  }
  .group:focus .xl\\:group-focus\\:bg-red-200 {
    --bg-opacity: 1;
    background-color: #fbd5d5;
    background-color: rgba(251, 213, 213, var(--bg-opacity));
  }
  .group:focus .xl\\:group-focus\\:bg-red-300 {
    --bg-opacity: 1;
    background-color: #f8b4b4;
    background-color: rgba(248, 180, 180, var(--bg-opacity));
  }
  .group:focus .xl\\:group-focus\\:bg-red-400 {
    --bg-opacity: 1;
    background-color: #f98080;
    background-color: rgba(249, 128, 128, var(--bg-opacity));
  }
  .group:focus .xl\\:group-focus\\:bg-red-500 {
    --bg-opacity: 1;
    background-color: #f05252;
    background-color: rgba(240, 82, 82, var(--bg-opacity));
  }
  .group:focus .xl\\:group-focus\\:bg-red-600 {
    --bg-opacity: 1;
    background-color: #e02424;
    background-color: rgba(224, 36, 36, var(--bg-opacity));
  }
  .group:focus .xl\\:group-focus\\:bg-red-700 {
    --bg-opacity: 1;
    background-color: #c81e1e;
    background-color: rgba(200, 30, 30, var(--bg-opacity));
  }
  .group:focus .xl\\:group-focus\\:bg-red-800 {
    --bg-opacity: 1;
    background-color: #9b1c1c;
    background-color: rgba(155, 28, 28, var(--bg-opacity));
  }
  .group:focus .xl\\:group-focus\\:bg-red-900 {
    --bg-opacity: 1;
    background-color: #771d1d;
    background-color: rgba(119, 29, 29, var(--bg-opacity));
  }
  .group:focus .xl\\:group-focus\\:bg-orange-50 {
    --bg-opacity: 1;
    background-color: #fff8f1;
    background-color: rgba(255, 248, 241, var(--bg-opacity));
  }
  .group:focus .xl\\:group-focus\\:bg-orange-100 {
    --bg-opacity: 1;
    background-color: #feecdc;
    background-color: rgba(254, 236, 220, var(--bg-opacity));
  }
  .group:focus .xl\\:group-focus\\:bg-orange-200 {
    --bg-opacity: 1;
    background-color: #fcd9bd;
    background-color: rgba(252, 217, 189, var(--bg-opacity));
  }
  .group:focus .xl\\:group-focus\\:bg-orange-300 {
    --bg-opacity: 1;
    background-color: #fdba8c;
    background-color: rgba(253, 186, 140, var(--bg-opacity));
  }
  .group:focus .xl\\:group-focus\\:bg-orange-400 {
    --bg-opacity: 1;
    background-color: #ff8a4c;
    background-color: rgba(255, 138, 76, var(--bg-opacity));
  }
  .group:focus .xl\\:group-focus\\:bg-orange-500 {
    --bg-opacity: 1;
    background-color: #ff5a1f;
    background-color: rgba(255, 90, 31, var(--bg-opacity));
  }
  .group:focus .xl\\:group-focus\\:bg-orange-600 {
    --bg-opacity: 1;
    background-color: #d03801;
    background-color: rgba(208, 56, 1, var(--bg-opacity));
  }
  .group:focus .xl\\:group-focus\\:bg-orange-700 {
    --bg-opacity: 1;
    background-color: #b43403;
    background-color: rgba(180, 52, 3, var(--bg-opacity));
  }
  .group:focus .xl\\:group-focus\\:bg-orange-800 {
    --bg-opacity: 1;
    background-color: #8a2c0d;
    background-color: rgba(138, 44, 13, var(--bg-opacity));
  }
  .group:focus .xl\\:group-focus\\:bg-orange-900 {
    --bg-opacity: 1;
    background-color: #73230d;
    background-color: rgba(115, 35, 13, var(--bg-opacity));
  }
  .group:focus .xl\\:group-focus\\:bg-yellow-50 {
    --bg-opacity: 1;
    background-color: #fdfdea;
    background-color: rgba(253, 253, 234, var(--bg-opacity));
  }
  .group:focus .xl\\:group-focus\\:bg-yellow-100 {
    --bg-opacity: 1;
    background-color: #fdf6b2;
    background-color: rgba(253, 246, 178, var(--bg-opacity));
  }
  .group:focus .xl\\:group-focus\\:bg-yellow-200 {
    --bg-opacity: 1;
    background-color: #fce96a;
    background-color: rgba(252, 233, 106, var(--bg-opacity));
  }
  .group:focus .xl\\:group-focus\\:bg-yellow-300 {
    --bg-opacity: 1;
    background-color: #faca15;
    background-color: rgba(250, 202, 21, var(--bg-opacity));
  }
  .group:focus .xl\\:group-focus\\:bg-yellow-400 {
    --bg-opacity: 1;
    background-color: #e3a008;
    background-color: rgba(227, 160, 8, var(--bg-opacity));
  }
  .group:focus .xl\\:group-focus\\:bg-yellow-500 {
    --bg-opacity: 1;
    background-color: #c27803;
    background-color: rgba(194, 120, 3, var(--bg-opacity));
  }
  .group:focus .xl\\:group-focus\\:bg-yellow-600 {
    --bg-opacity: 1;
    background-color: #9f580a;
    background-color: rgba(159, 88, 10, var(--bg-opacity));
  }
  .group:focus .xl\\:group-focus\\:bg-yellow-700 {
    --bg-opacity: 1;
    background-color: #8e4b10;
    background-color: rgba(142, 75, 16, var(--bg-opacity));
  }
  .group:focus .xl\\:group-focus\\:bg-yellow-800 {
    --bg-opacity: 1;
    background-color: #723b13;
    background-color: rgba(114, 59, 19, var(--bg-opacity));
  }
  .group:focus .xl\\:group-focus\\:bg-yellow-900 {
    --bg-opacity: 1;
    background-color: #633112;
    background-color: rgba(99, 49, 18, var(--bg-opacity));
  }
  .group:focus .xl\\:group-focus\\:bg-green-50 {
    --bg-opacity: 1;
    background-color: #f3faf7;
    background-color: rgba(243, 250, 247, var(--bg-opacity));
  }
  .group:focus .xl\\:group-focus\\:bg-green-100 {
    --bg-opacity: 1;
    background-color: #def7ec;
    background-color: rgba(222, 247, 236, var(--bg-opacity));
  }
  .group:focus .xl\\:group-focus\\:bg-green-200 {
    --bg-opacity: 1;
    background-color: #bcf0da;
    background-color: rgba(188, 240, 218, var(--bg-opacity));
  }
  .group:focus .xl\\:group-focus\\:bg-green-300 {
    --bg-opacity: 1;
    background-color: #84e1bc;
    background-color: rgba(132, 225, 188, var(--bg-opacity));
  }
  .group:focus .xl\\:group-focus\\:bg-green-400 {
    --bg-opacity: 1;
    background-color: #31c48d;
    background-color: rgba(49, 196, 141, var(--bg-opacity));
  }
  .group:focus .xl\\:group-focus\\:bg-green-500 {
    --bg-opacity: 1;
    background-color: #0e9f6e;
    background-color: rgba(14, 159, 110, var(--bg-opacity));
  }
  .group:focus .xl\\:group-focus\\:bg-green-600 {
    --bg-opacity: 1;
    background-color: #057a55;
    background-color: rgba(5, 122, 85, var(--bg-opacity));
  }
  .group:focus .xl\\:group-focus\\:bg-green-700 {
    --bg-opacity: 1;
    background-color: #046c4e;
    background-color: rgba(4, 108, 78, var(--bg-opacity));
  }
  .group:focus .xl\\:group-focus\\:bg-green-800 {
    --bg-opacity: 1;
    background-color: #03543f;
    background-color: rgba(3, 84, 63, var(--bg-opacity));
  }
  .group:focus .xl\\:group-focus\\:bg-green-900 {
    --bg-opacity: 1;
    background-color: #014737;
    background-color: rgba(1, 71, 55, var(--bg-opacity));
  }
  .group:focus .xl\\:group-focus\\:bg-teal-50 {
    --bg-opacity: 1;
    background-color: #edfafa;
    background-color: rgba(237, 250, 250, var(--bg-opacity));
  }
  .group:focus .xl\\:group-focus\\:bg-teal-100 {
    --bg-opacity: 1;
    background-color: #d5f5f6;
    background-color: rgba(213, 245, 246, var(--bg-opacity));
  }
  .group:focus .xl\\:group-focus\\:bg-teal-200 {
    --bg-opacity: 1;
    background-color: #afecef;
    background-color: rgba(175, 236, 239, var(--bg-opacity));
  }
  .group:focus .xl\\:group-focus\\:bg-teal-300 {
    --bg-opacity: 1;
    background-color: #7edce2;
    background-color: rgba(126, 220, 226, var(--bg-opacity));
  }
  .group:focus .xl\\:group-focus\\:bg-teal-400 {
    --bg-opacity: 1;
    background-color: #16bdca;
    background-color: rgba(22, 189, 202, var(--bg-opacity));
  }
  .group:focus .xl\\:group-focus\\:bg-teal-500 {
    --bg-opacity: 1;
    background-color: #0694a2;
    background-color: rgba(6, 148, 162, var(--bg-opacity));
  }
  .group:focus .xl\\:group-focus\\:bg-teal-600 {
    --bg-opacity: 1;
    background-color: #047481;
    background-color: rgba(4, 116, 129, var(--bg-opacity));
  }
  .group:focus .xl\\:group-focus\\:bg-teal-700 {
    --bg-opacity: 1;
    background-color: #036672;
    background-color: rgba(3, 102, 114, var(--bg-opacity));
  }
  .group:focus .xl\\:group-focus\\:bg-teal-800 {
    --bg-opacity: 1;
    background-color: #05505c;
    background-color: rgba(5, 80, 92, var(--bg-opacity));
  }
  .group:focus .xl\\:group-focus\\:bg-teal-900 {
    --bg-opacity: 1;
    background-color: #014451;
    background-color: rgba(1, 68, 81, var(--bg-opacity));
  }
  .group:focus .xl\\:group-focus\\:bg-blue-50 {
    --bg-opacity: 1;
    background-color: #ebf5ff;
    background-color: rgba(235, 245, 255, var(--bg-opacity));
  }
  .group:focus .xl\\:group-focus\\:bg-blue-100 {
    --bg-opacity: 1;
    background-color: #e1effe;
    background-color: rgba(225, 239, 254, var(--bg-opacity));
  }
  .group:focus .xl\\:group-focus\\:bg-blue-200 {
    --bg-opacity: 1;
    background-color: #c3ddfd;
    background-color: rgba(195, 221, 253, var(--bg-opacity));
  }
  .group:focus .xl\\:group-focus\\:bg-blue-300 {
    --bg-opacity: 1;
    background-color: #a4cafe;
    background-color: rgba(164, 202, 254, var(--bg-opacity));
  }
  .group:focus .xl\\:group-focus\\:bg-blue-400 {
    --bg-opacity: 1;
    background-color: #76a9fa;
    background-color: rgba(118, 169, 250, var(--bg-opacity));
  }
  .group:focus .xl\\:group-focus\\:bg-blue-500 {
    --bg-opacity: 1;
    background-color: #3f83f8;
    background-color: rgba(63, 131, 248, var(--bg-opacity));
  }
  .group:focus .xl\\:group-focus\\:bg-blue-600 {
    --bg-opacity: 1;
    background-color: #1c64f2;
    background-color: rgba(28, 100, 242, var(--bg-opacity));
  }
  .group:focus .xl\\:group-focus\\:bg-blue-700 {
    --bg-opacity: 1;
    background-color: #1a56db;
    background-color: rgba(26, 86, 219, var(--bg-opacity));
  }
  .group:focus .xl\\:group-focus\\:bg-blue-800 {
    --bg-opacity: 1;
    background-color: #1e429f;
    background-color: rgba(30, 66, 159, var(--bg-opacity));
  }
  .group:focus .xl\\:group-focus\\:bg-blue-900 {
    --bg-opacity: 1;
    background-color: #233876;
    background-color: rgba(35, 56, 118, var(--bg-opacity));
  }
  .group:focus .xl\\:group-focus\\:bg-indigo-50 {
    --bg-opacity: 1;
    background-color: #f0f5ff;
    background-color: rgba(240, 245, 255, var(--bg-opacity));
  }
  .group:focus .xl\\:group-focus\\:bg-indigo-100 {
    --bg-opacity: 1;
    background-color: #e5edff;
    background-color: rgba(229, 237, 255, var(--bg-opacity));
  }
  .group:focus .xl\\:group-focus\\:bg-indigo-200 {
    --bg-opacity: 1;
    background-color: #cddbfe;
    background-color: rgba(205, 219, 254, var(--bg-opacity));
  }
  .group:focus .xl\\:group-focus\\:bg-indigo-300 {
    --bg-opacity: 1;
    background-color: #b4c6fc;
    background-color: rgba(180, 198, 252, var(--bg-opacity));
  }
  .group:focus .xl\\:group-focus\\:bg-indigo-400 {
    --bg-opacity: 1;
    background-color: #8da2fb;
    background-color: rgba(141, 162, 251, var(--bg-opacity));
  }
  .group:focus .xl\\:group-focus\\:bg-indigo-500 {
    --bg-opacity: 1;
    background-color: #6875f5;
    background-color: rgba(104, 117, 245, var(--bg-opacity));
  }
  .group:focus .xl\\:group-focus\\:bg-indigo-600 {
    --bg-opacity: 1;
    background-color: #5850ec;
    background-color: rgba(88, 80, 236, var(--bg-opacity));
  }
  .group:focus .xl\\:group-focus\\:bg-indigo-700 {
    --bg-opacity: 1;
    background-color: #5145cd;
    background-color: rgba(81, 69, 205, var(--bg-opacity));
  }
  .group:focus .xl\\:group-focus\\:bg-indigo-800 {
    --bg-opacity: 1;
    background-color: #42389d;
    background-color: rgba(66, 56, 157, var(--bg-opacity));
  }
  .group:focus .xl\\:group-focus\\:bg-indigo-900 {
    --bg-opacity: 1;
    background-color: #362f78;
    background-color: rgba(54, 47, 120, var(--bg-opacity));
  }
  .group:focus .xl\\:group-focus\\:bg-purple-50 {
    --bg-opacity: 1;
    background-color: #f6f5ff;
    background-color: rgba(246, 245, 255, var(--bg-opacity));
  }
  .group:focus .xl\\:group-focus\\:bg-purple-100 {
    --bg-opacity: 1;
    background-color: #edebfe;
    background-color: rgba(237, 235, 254, var(--bg-opacity));
  }
  .group:focus .xl\\:group-focus\\:bg-purple-200 {
    --bg-opacity: 1;
    background-color: #dcd7fe;
    background-color: rgba(220, 215, 254, var(--bg-opacity));
  }
  .group:focus .xl\\:group-focus\\:bg-purple-300 {
    --bg-opacity: 1;
    background-color: #cabffd;
    background-color: rgba(202, 191, 253, var(--bg-opacity));
  }
  .group:focus .xl\\:group-focus\\:bg-purple-400 {
    --bg-opacity: 1;
    background-color: #ac94fa;
    background-color: rgba(172, 148, 250, var(--bg-opacity));
  }
  .group:focus .xl\\:group-focus\\:bg-purple-500 {
    --bg-opacity: 1;
    background-color: #9061f9;
    background-color: rgba(144, 97, 249, var(--bg-opacity));
  }
  .group:focus .xl\\:group-focus\\:bg-purple-600 {
    --bg-opacity: 1;
    background-color: #7e3af2;
    background-color: rgba(126, 58, 242, var(--bg-opacity));
  }
  .group:focus .xl\\:group-focus\\:bg-purple-700 {
    --bg-opacity: 1;
    background-color: #6c2bd9;
    background-color: rgba(108, 43, 217, var(--bg-opacity));
  }
  .group:focus .xl\\:group-focus\\:bg-purple-800 {
    --bg-opacity: 1;
    background-color: #5521b5;
    background-color: rgba(85, 33, 181, var(--bg-opacity));
  }
  .group:focus .xl\\:group-focus\\:bg-purple-900 {
    --bg-opacity: 1;
    background-color: #4a1d96;
    background-color: rgba(74, 29, 150, var(--bg-opacity));
  }
  .group:focus .xl\\:group-focus\\:bg-pink-50 {
    --bg-opacity: 1;
    background-color: #fdf2f8;
    background-color: rgba(253, 242, 248, var(--bg-opacity));
  }
  .group:focus .xl\\:group-focus\\:bg-pink-100 {
    --bg-opacity: 1;
    background-color: #fce8f3;
    background-color: rgba(252, 232, 243, var(--bg-opacity));
  }
  .group:focus .xl\\:group-focus\\:bg-pink-200 {
    --bg-opacity: 1;
    background-color: #fad1e8;
    background-color: rgba(250, 209, 232, var(--bg-opacity));
  }
  .group:focus .xl\\:group-focus\\:bg-pink-300 {
    --bg-opacity: 1;
    background-color: #f8b4d9;
    background-color: rgba(248, 180, 217, var(--bg-opacity));
  }
  .group:focus .xl\\:group-focus\\:bg-pink-400 {
    --bg-opacity: 1;
    background-color: #f17eb8;
    background-color: rgba(241, 126, 184, var(--bg-opacity));
  }
  .group:focus .xl\\:group-focus\\:bg-pink-500 {
    --bg-opacity: 1;
    background-color: #e74694;
    background-color: rgba(231, 70, 148, var(--bg-opacity));
  }
  .group:focus .xl\\:group-focus\\:bg-pink-600 {
    --bg-opacity: 1;
    background-color: #d61f69;
    background-color: rgba(214, 31, 105, var(--bg-opacity));
  }
  .group:focus .xl\\:group-focus\\:bg-pink-700 {
    --bg-opacity: 1;
    background-color: #bf125d;
    background-color: rgba(191, 18, 93, var(--bg-opacity));
  }
  .group:focus .xl\\:group-focus\\:bg-pink-800 {
    --bg-opacity: 1;
    background-color: #99154b;
    background-color: rgba(153, 21, 75, var(--bg-opacity));
  }
  .group:focus .xl\\:group-focus\\:bg-pink-900 {
    --bg-opacity: 1;
    background-color: #751a3d;
    background-color: rgba(117, 26, 61, var(--bg-opacity));
  }
  .group:focus .xl\\:group-focus\\:bg-cool-gray-50 {
    --bg-opacity: 1;
    background-color: #f8fafc;
    background-color: rgba(248, 250, 252, var(--bg-opacity));
  }
  .group:focus .xl\\:group-focus\\:bg-cool-gray-100 {
    --bg-opacity: 1;
    background-color: #f1f5f9;
    background-color: rgba(241, 245, 249, var(--bg-opacity));
  }
  .group:focus .xl\\:group-focus\\:bg-cool-gray-200 {
    --bg-opacity: 1;
    background-color: #e2e8f0;
    background-color: rgba(226, 232, 240, var(--bg-opacity));
  }
  .group:focus .xl\\:group-focus\\:bg-cool-gray-300 {
    --bg-opacity: 1;
    background-color: #cfd8e3;
    background-color: rgba(207, 216, 227, var(--bg-opacity));
  }
  .group:focus .xl\\:group-focus\\:bg-cool-gray-400 {
    --bg-opacity: 1;
    background-color: #97a6ba;
    background-color: rgba(151, 166, 186, var(--bg-opacity));
  }
  .group:focus .xl\\:group-focus\\:bg-cool-gray-500 {
    --bg-opacity: 1;
    background-color: #64748b;
    background-color: rgba(100, 116, 139, var(--bg-opacity));
  }
  .group:focus .xl\\:group-focus\\:bg-cool-gray-600 {
    --bg-opacity: 1;
    background-color: #475569;
    background-color: rgba(71, 85, 105, var(--bg-opacity));
  }
  .group:focus .xl\\:group-focus\\:bg-cool-gray-700 {
    --bg-opacity: 1;
    background-color: #364152;
    background-color: rgba(54, 65, 82, var(--bg-opacity));
  }
  .group:focus .xl\\:group-focus\\:bg-cool-gray-800 {
    --bg-opacity: 1;
    background-color: #27303f;
    background-color: rgba(39, 48, 63, var(--bg-opacity));
  }
  .group:focus .xl\\:group-focus\\:bg-cool-gray-900 {
    --bg-opacity: 1;
    background-color: #1a202e;
    background-color: rgba(26, 32, 46, var(--bg-opacity));
  }
  .xl\\:hover\\:bg-current:hover {
    background-color: currentColor;
  }
  .xl\\:hover\\:bg-transparent:hover {
    background-color: transparent;
  }
  .xl\\:hover\\:bg-white:hover {
    --bg-opacity: 1;
    background-color: #ffffff;
    background-color: rgba(255, 255, 255, var(--bg-opacity));
  }
  .xl\\:hover\\:bg-black:hover {
    --bg-opacity: 1;
    background-color: #000000;
    background-color: rgba(0, 0, 0, var(--bg-opacity));
  }
  .xl\\:hover\\:bg-gray-50:hover {
    --bg-opacity: 1;
    background-color: #f9fafb;
    background-color: rgba(249, 250, 251, var(--bg-opacity));
  }
  .xl\\:hover\\:bg-gray-100:hover {
    --bg-opacity: 1;
    background-color: #f4f5f7;
    background-color: rgba(244, 245, 247, var(--bg-opacity));
  }
  .xl\\:hover\\:bg-gray-200:hover {
    --bg-opacity: 1;
    background-color: #e5e7eb;
    background-color: rgba(229, 231, 235, var(--bg-opacity));
  }
  .xl\\:hover\\:bg-gray-300:hover {
    --bg-opacity: 1;
    background-color: #d2d6dc;
    background-color: rgba(210, 214, 220, var(--bg-opacity));
  }
  .xl\\:hover\\:bg-gray-400:hover {
    --bg-opacity: 1;
    background-color: #9fa6b2;
    background-color: rgba(159, 166, 178, var(--bg-opacity));
  }
  .xl\\:hover\\:bg-gray-500:hover {
    --bg-opacity: 1;
    background-color: #6b7280;
    background-color: rgba(107, 114, 128, var(--bg-opacity));
  }
  .xl\\:hover\\:bg-gray-600:hover {
    --bg-opacity: 1;
    background-color: #4b5563;
    background-color: rgba(75, 85, 99, var(--bg-opacity));
  }
  .xl\\:hover\\:bg-gray-700:hover {
    --bg-opacity: 1;
    background-color: #374151;
    background-color: rgba(55, 65, 81, var(--bg-opacity));
  }
  .xl\\:hover\\:bg-gray-800:hover {
    --bg-opacity: 1;
    background-color: #252f3f;
    background-color: rgba(37, 47, 63, var(--bg-opacity));
  }
  .xl\\:hover\\:bg-gray-900:hover {
    --bg-opacity: 1;
    background-color: #161e2e;
    background-color: rgba(22, 30, 46, var(--bg-opacity));
  }
  .xl\\:hover\\:bg-red-50:hover {
    --bg-opacity: 1;
    background-color: #fdf2f2;
    background-color: rgba(253, 242, 242, var(--bg-opacity));
  }
  .xl\\:hover\\:bg-red-100:hover {
    --bg-opacity: 1;
    background-color: #fde8e8;
    background-color: rgba(253, 232, 232, var(--bg-opacity));
  }
  .xl\\:hover\\:bg-red-200:hover {
    --bg-opacity: 1;
    background-color: #fbd5d5;
    background-color: rgba(251, 213, 213, var(--bg-opacity));
  }
  .xl\\:hover\\:bg-red-300:hover {
    --bg-opacity: 1;
    background-color: #f8b4b4;
    background-color: rgba(248, 180, 180, var(--bg-opacity));
  }
  .xl\\:hover\\:bg-red-400:hover {
    --bg-opacity: 1;
    background-color: #f98080;
    background-color: rgba(249, 128, 128, var(--bg-opacity));
  }
  .xl\\:hover\\:bg-red-500:hover {
    --bg-opacity: 1;
    background-color: #f05252;
    background-color: rgba(240, 82, 82, var(--bg-opacity));
  }
  .xl\\:hover\\:bg-red-600:hover {
    --bg-opacity: 1;
    background-color: #e02424;
    background-color: rgba(224, 36, 36, var(--bg-opacity));
  }
  .xl\\:hover\\:bg-red-700:hover {
    --bg-opacity: 1;
    background-color: #c81e1e;
    background-color: rgba(200, 30, 30, var(--bg-opacity));
  }
  .xl\\:hover\\:bg-red-800:hover {
    --bg-opacity: 1;
    background-color: #9b1c1c;
    background-color: rgba(155, 28, 28, var(--bg-opacity));
  }
  .xl\\:hover\\:bg-red-900:hover {
    --bg-opacity: 1;
    background-color: #771d1d;
    background-color: rgba(119, 29, 29, var(--bg-opacity));
  }
  .xl\\:hover\\:bg-orange-50:hover {
    --bg-opacity: 1;
    background-color: #fff8f1;
    background-color: rgba(255, 248, 241, var(--bg-opacity));
  }
  .xl\\:hover\\:bg-orange-100:hover {
    --bg-opacity: 1;
    background-color: #feecdc;
    background-color: rgba(254, 236, 220, var(--bg-opacity));
  }
  .xl\\:hover\\:bg-orange-200:hover {
    --bg-opacity: 1;
    background-color: #fcd9bd;
    background-color: rgba(252, 217, 189, var(--bg-opacity));
  }
  .xl\\:hover\\:bg-orange-300:hover {
    --bg-opacity: 1;
    background-color: #fdba8c;
    background-color: rgba(253, 186, 140, var(--bg-opacity));
  }
  .xl\\:hover\\:bg-orange-400:hover {
    --bg-opacity: 1;
    background-color: #ff8a4c;
    background-color: rgba(255, 138, 76, var(--bg-opacity));
  }
  .xl\\:hover\\:bg-orange-500:hover {
    --bg-opacity: 1;
    background-color: #ff5a1f;
    background-color: rgba(255, 90, 31, var(--bg-opacity));
  }
  .xl\\:hover\\:bg-orange-600:hover {
    --bg-opacity: 1;
    background-color: #d03801;
    background-color: rgba(208, 56, 1, var(--bg-opacity));
  }
  .xl\\:hover\\:bg-orange-700:hover {
    --bg-opacity: 1;
    background-color: #b43403;
    background-color: rgba(180, 52, 3, var(--bg-opacity));
  }
  .xl\\:hover\\:bg-orange-800:hover {
    --bg-opacity: 1;
    background-color: #8a2c0d;
    background-color: rgba(138, 44, 13, var(--bg-opacity));
  }
  .xl\\:hover\\:bg-orange-900:hover {
    --bg-opacity: 1;
    background-color: #73230d;
    background-color: rgba(115, 35, 13, var(--bg-opacity));
  }
  .xl\\:hover\\:bg-yellow-50:hover {
    --bg-opacity: 1;
    background-color: #fdfdea;
    background-color: rgba(253, 253, 234, var(--bg-opacity));
  }
  .xl\\:hover\\:bg-yellow-100:hover {
    --bg-opacity: 1;
    background-color: #fdf6b2;
    background-color: rgba(253, 246, 178, var(--bg-opacity));
  }
  .xl\\:hover\\:bg-yellow-200:hover {
    --bg-opacity: 1;
    background-color: #fce96a;
    background-color: rgba(252, 233, 106, var(--bg-opacity));
  }
  .xl\\:hover\\:bg-yellow-300:hover {
    --bg-opacity: 1;
    background-color: #faca15;
    background-color: rgba(250, 202, 21, var(--bg-opacity));
  }
  .xl\\:hover\\:bg-yellow-400:hover {
    --bg-opacity: 1;
    background-color: #e3a008;
    background-color: rgba(227, 160, 8, var(--bg-opacity));
  }
  .xl\\:hover\\:bg-yellow-500:hover {
    --bg-opacity: 1;
    background-color: #c27803;
    background-color: rgba(194, 120, 3, var(--bg-opacity));
  }
  .xl\\:hover\\:bg-yellow-600:hover {
    --bg-opacity: 1;
    background-color: #9f580a;
    background-color: rgba(159, 88, 10, var(--bg-opacity));
  }
  .xl\\:hover\\:bg-yellow-700:hover {
    --bg-opacity: 1;
    background-color: #8e4b10;
    background-color: rgba(142, 75, 16, var(--bg-opacity));
  }
  .xl\\:hover\\:bg-yellow-800:hover {
    --bg-opacity: 1;
    background-color: #723b13;
    background-color: rgba(114, 59, 19, var(--bg-opacity));
  }
  .xl\\:hover\\:bg-yellow-900:hover {
    --bg-opacity: 1;
    background-color: #633112;
    background-color: rgba(99, 49, 18, var(--bg-opacity));
  }
  .xl\\:hover\\:bg-green-50:hover {
    --bg-opacity: 1;
    background-color: #f3faf7;
    background-color: rgba(243, 250, 247, var(--bg-opacity));
  }
  .xl\\:hover\\:bg-green-100:hover {
    --bg-opacity: 1;
    background-color: #def7ec;
    background-color: rgba(222, 247, 236, var(--bg-opacity));
  }
  .xl\\:hover\\:bg-green-200:hover {
    --bg-opacity: 1;
    background-color: #bcf0da;
    background-color: rgba(188, 240, 218, var(--bg-opacity));
  }
  .xl\\:hover\\:bg-green-300:hover {
    --bg-opacity: 1;
    background-color: #84e1bc;
    background-color: rgba(132, 225, 188, var(--bg-opacity));
  }
  .xl\\:hover\\:bg-green-400:hover {
    --bg-opacity: 1;
    background-color: #31c48d;
    background-color: rgba(49, 196, 141, var(--bg-opacity));
  }
  .xl\\:hover\\:bg-green-500:hover {
    --bg-opacity: 1;
    background-color: #0e9f6e;
    background-color: rgba(14, 159, 110, var(--bg-opacity));
  }
  .xl\\:hover\\:bg-green-600:hover {
    --bg-opacity: 1;
    background-color: #057a55;
    background-color: rgba(5, 122, 85, var(--bg-opacity));
  }
  .xl\\:hover\\:bg-green-700:hover {
    --bg-opacity: 1;
    background-color: #046c4e;
    background-color: rgba(4, 108, 78, var(--bg-opacity));
  }
  .xl\\:hover\\:bg-green-800:hover {
    --bg-opacity: 1;
    background-color: #03543f;
    background-color: rgba(3, 84, 63, var(--bg-opacity));
  }
  .xl\\:hover\\:bg-green-900:hover {
    --bg-opacity: 1;
    background-color: #014737;
    background-color: rgba(1, 71, 55, var(--bg-opacity));
  }
  .xl\\:hover\\:bg-teal-50:hover {
    --bg-opacity: 1;
    background-color: #edfafa;
    background-color: rgba(237, 250, 250, var(--bg-opacity));
  }
  .xl\\:hover\\:bg-teal-100:hover {
    --bg-opacity: 1;
    background-color: #d5f5f6;
    background-color: rgba(213, 245, 246, var(--bg-opacity));
  }
  .xl\\:hover\\:bg-teal-200:hover {
    --bg-opacity: 1;
    background-color: #afecef;
    background-color: rgba(175, 236, 239, var(--bg-opacity));
  }
  .xl\\:hover\\:bg-teal-300:hover {
    --bg-opacity: 1;
    background-color: #7edce2;
    background-color: rgba(126, 220, 226, var(--bg-opacity));
  }
  .xl\\:hover\\:bg-teal-400:hover {
    --bg-opacity: 1;
    background-color: #16bdca;
    background-color: rgba(22, 189, 202, var(--bg-opacity));
  }
  .xl\\:hover\\:bg-teal-500:hover {
    --bg-opacity: 1;
    background-color: #0694a2;
    background-color: rgba(6, 148, 162, var(--bg-opacity));
  }
  .xl\\:hover\\:bg-teal-600:hover {
    --bg-opacity: 1;
    background-color: #047481;
    background-color: rgba(4, 116, 129, var(--bg-opacity));
  }
  .xl\\:hover\\:bg-teal-700:hover {
    --bg-opacity: 1;
    background-color: #036672;
    background-color: rgba(3, 102, 114, var(--bg-opacity));
  }
  .xl\\:hover\\:bg-teal-800:hover {
    --bg-opacity: 1;
    background-color: #05505c;
    background-color: rgba(5, 80, 92, var(--bg-opacity));
  }
  .xl\\:hover\\:bg-teal-900:hover {
    --bg-opacity: 1;
    background-color: #014451;
    background-color: rgba(1, 68, 81, var(--bg-opacity));
  }
  .xl\\:hover\\:bg-blue-50:hover {
    --bg-opacity: 1;
    background-color: #ebf5ff;
    background-color: rgba(235, 245, 255, var(--bg-opacity));
  }
  .xl\\:hover\\:bg-blue-100:hover {
    --bg-opacity: 1;
    background-color: #e1effe;
    background-color: rgba(225, 239, 254, var(--bg-opacity));
  }
  .xl\\:hover\\:bg-blue-200:hover {
    --bg-opacity: 1;
    background-color: #c3ddfd;
    background-color: rgba(195, 221, 253, var(--bg-opacity));
  }
  .xl\\:hover\\:bg-blue-300:hover {
    --bg-opacity: 1;
    background-color: #a4cafe;
    background-color: rgba(164, 202, 254, var(--bg-opacity));
  }
  .xl\\:hover\\:bg-blue-400:hover {
    --bg-opacity: 1;
    background-color: #76a9fa;
    background-color: rgba(118, 169, 250, var(--bg-opacity));
  }
  .xl\\:hover\\:bg-blue-500:hover {
    --bg-opacity: 1;
    background-color: #3f83f8;
    background-color: rgba(63, 131, 248, var(--bg-opacity));
  }
  .xl\\:hover\\:bg-blue-600:hover {
    --bg-opacity: 1;
    background-color: #1c64f2;
    background-color: rgba(28, 100, 242, var(--bg-opacity));
  }
  .xl\\:hover\\:bg-blue-700:hover {
    --bg-opacity: 1;
    background-color: #1a56db;
    background-color: rgba(26, 86, 219, var(--bg-opacity));
  }
  .xl\\:hover\\:bg-blue-800:hover {
    --bg-opacity: 1;
    background-color: #1e429f;
    background-color: rgba(30, 66, 159, var(--bg-opacity));
  }
  .xl\\:hover\\:bg-blue-900:hover {
    --bg-opacity: 1;
    background-color: #233876;
    background-color: rgba(35, 56, 118, var(--bg-opacity));
  }
  .xl\\:hover\\:bg-indigo-50:hover {
    --bg-opacity: 1;
    background-color: #f0f5ff;
    background-color: rgba(240, 245, 255, var(--bg-opacity));
  }
  .xl\\:hover\\:bg-indigo-100:hover {
    --bg-opacity: 1;
    background-color: #e5edff;
    background-color: rgba(229, 237, 255, var(--bg-opacity));
  }
  .xl\\:hover\\:bg-indigo-200:hover {
    --bg-opacity: 1;
    background-color: #cddbfe;
    background-color: rgba(205, 219, 254, var(--bg-opacity));
  }
  .xl\\:hover\\:bg-indigo-300:hover {
    --bg-opacity: 1;
    background-color: #b4c6fc;
    background-color: rgba(180, 198, 252, var(--bg-opacity));
  }
  .xl\\:hover\\:bg-indigo-400:hover {
    --bg-opacity: 1;
    background-color: #8da2fb;
    background-color: rgba(141, 162, 251, var(--bg-opacity));
  }
  .xl\\:hover\\:bg-indigo-500:hover {
    --bg-opacity: 1;
    background-color: #6875f5;
    background-color: rgba(104, 117, 245, var(--bg-opacity));
  }
  .xl\\:hover\\:bg-indigo-600:hover {
    --bg-opacity: 1;
    background-color: #5850ec;
    background-color: rgba(88, 80, 236, var(--bg-opacity));
  }
  .xl\\:hover\\:bg-indigo-700:hover {
    --bg-opacity: 1;
    background-color: #5145cd;
    background-color: rgba(81, 69, 205, var(--bg-opacity));
  }
  .xl\\:hover\\:bg-indigo-800:hover {
    --bg-opacity: 1;
    background-color: #42389d;
    background-color: rgba(66, 56, 157, var(--bg-opacity));
  }
  .xl\\:hover\\:bg-indigo-900:hover {
    --bg-opacity: 1;
    background-color: #362f78;
    background-color: rgba(54, 47, 120, var(--bg-opacity));
  }
  .xl\\:hover\\:bg-purple-50:hover {
    --bg-opacity: 1;
    background-color: #f6f5ff;
    background-color: rgba(246, 245, 255, var(--bg-opacity));
  }
  .xl\\:hover\\:bg-purple-100:hover {
    --bg-opacity: 1;
    background-color: #edebfe;
    background-color: rgba(237, 235, 254, var(--bg-opacity));
  }
  .xl\\:hover\\:bg-purple-200:hover {
    --bg-opacity: 1;
    background-color: #dcd7fe;
    background-color: rgba(220, 215, 254, var(--bg-opacity));
  }
  .xl\\:hover\\:bg-purple-300:hover {
    --bg-opacity: 1;
    background-color: #cabffd;
    background-color: rgba(202, 191, 253, var(--bg-opacity));
  }
  .xl\\:hover\\:bg-purple-400:hover {
    --bg-opacity: 1;
    background-color: #ac94fa;
    background-color: rgba(172, 148, 250, var(--bg-opacity));
  }
  .xl\\:hover\\:bg-purple-500:hover {
    --bg-opacity: 1;
    background-color: #9061f9;
    background-color: rgba(144, 97, 249, var(--bg-opacity));
  }
  .xl\\:hover\\:bg-purple-600:hover {
    --bg-opacity: 1;
    background-color: #7e3af2;
    background-color: rgba(126, 58, 242, var(--bg-opacity));
  }
  .xl\\:hover\\:bg-purple-700:hover {
    --bg-opacity: 1;
    background-color: #6c2bd9;
    background-color: rgba(108, 43, 217, var(--bg-opacity));
  }
  .xl\\:hover\\:bg-purple-800:hover {
    --bg-opacity: 1;
    background-color: #5521b5;
    background-color: rgba(85, 33, 181, var(--bg-opacity));
  }
  .xl\\:hover\\:bg-purple-900:hover {
    --bg-opacity: 1;
    background-color: #4a1d96;
    background-color: rgba(74, 29, 150, var(--bg-opacity));
  }
  .xl\\:hover\\:bg-pink-50:hover {
    --bg-opacity: 1;
    background-color: #fdf2f8;
    background-color: rgba(253, 242, 248, var(--bg-opacity));
  }
  .xl\\:hover\\:bg-pink-100:hover {
    --bg-opacity: 1;
    background-color: #fce8f3;
    background-color: rgba(252, 232, 243, var(--bg-opacity));
  }
  .xl\\:hover\\:bg-pink-200:hover {
    --bg-opacity: 1;
    background-color: #fad1e8;
    background-color: rgba(250, 209, 232, var(--bg-opacity));
  }
  .xl\\:hover\\:bg-pink-300:hover {
    --bg-opacity: 1;
    background-color: #f8b4d9;
    background-color: rgba(248, 180, 217, var(--bg-opacity));
  }
  .xl\\:hover\\:bg-pink-400:hover {
    --bg-opacity: 1;
    background-color: #f17eb8;
    background-color: rgba(241, 126, 184, var(--bg-opacity));
  }
  .xl\\:hover\\:bg-pink-500:hover {
    --bg-opacity: 1;
    background-color: #e74694;
    background-color: rgba(231, 70, 148, var(--bg-opacity));
  }
  .xl\\:hover\\:bg-pink-600:hover {
    --bg-opacity: 1;
    background-color: #d61f69;
    background-color: rgba(214, 31, 105, var(--bg-opacity));
  }
  .xl\\:hover\\:bg-pink-700:hover {
    --bg-opacity: 1;
    background-color: #bf125d;
    background-color: rgba(191, 18, 93, var(--bg-opacity));
  }
  .xl\\:hover\\:bg-pink-800:hover {
    --bg-opacity: 1;
    background-color: #99154b;
    background-color: rgba(153, 21, 75, var(--bg-opacity));
  }
  .xl\\:hover\\:bg-pink-900:hover {
    --bg-opacity: 1;
    background-color: #751a3d;
    background-color: rgba(117, 26, 61, var(--bg-opacity));
  }
  .xl\\:hover\\:bg-cool-gray-50:hover {
    --bg-opacity: 1;
    background-color: #f8fafc;
    background-color: rgba(248, 250, 252, var(--bg-opacity));
  }
  .xl\\:hover\\:bg-cool-gray-100:hover {
    --bg-opacity: 1;
    background-color: #f1f5f9;
    background-color: rgba(241, 245, 249, var(--bg-opacity));
  }
  .xl\\:hover\\:bg-cool-gray-200:hover {
    --bg-opacity: 1;
    background-color: #e2e8f0;
    background-color: rgba(226, 232, 240, var(--bg-opacity));
  }
  .xl\\:hover\\:bg-cool-gray-300:hover {
    --bg-opacity: 1;
    background-color: #cfd8e3;
    background-color: rgba(207, 216, 227, var(--bg-opacity));
  }
  .xl\\:hover\\:bg-cool-gray-400:hover {
    --bg-opacity: 1;
    background-color: #97a6ba;
    background-color: rgba(151, 166, 186, var(--bg-opacity));
  }
  .xl\\:hover\\:bg-cool-gray-500:hover {
    --bg-opacity: 1;
    background-color: #64748b;
    background-color: rgba(100, 116, 139, var(--bg-opacity));
  }
  .xl\\:hover\\:bg-cool-gray-600:hover {
    --bg-opacity: 1;
    background-color: #475569;
    background-color: rgba(71, 85, 105, var(--bg-opacity));
  }
  .xl\\:hover\\:bg-cool-gray-700:hover {
    --bg-opacity: 1;
    background-color: #364152;
    background-color: rgba(54, 65, 82, var(--bg-opacity));
  }
  .xl\\:hover\\:bg-cool-gray-800:hover {
    --bg-opacity: 1;
    background-color: #27303f;
    background-color: rgba(39, 48, 63, var(--bg-opacity));
  }
  .xl\\:hover\\:bg-cool-gray-900:hover {
    --bg-opacity: 1;
    background-color: #1a202e;
    background-color: rgba(26, 32, 46, var(--bg-opacity));
  }
  .xl\\:focus\\:bg-current:focus {
    background-color: currentColor;
  }
  .xl\\:focus\\:bg-transparent:focus {
    background-color: transparent;
  }
  .xl\\:focus\\:bg-white:focus {
    --bg-opacity: 1;
    background-color: #ffffff;
    background-color: rgba(255, 255, 255, var(--bg-opacity));
  }
  .xl\\:focus\\:bg-black:focus {
    --bg-opacity: 1;
    background-color: #000000;
    background-color: rgba(0, 0, 0, var(--bg-opacity));
  }
  .xl\\:focus\\:bg-gray-50:focus {
    --bg-opacity: 1;
    background-color: #f9fafb;
    background-color: rgba(249, 250, 251, var(--bg-opacity));
  }
  .xl\\:focus\\:bg-gray-100:focus {
    --bg-opacity: 1;
    background-color: #f4f5f7;
    background-color: rgba(244, 245, 247, var(--bg-opacity));
  }
  .xl\\:focus\\:bg-gray-200:focus {
    --bg-opacity: 1;
    background-color: #e5e7eb;
    background-color: rgba(229, 231, 235, var(--bg-opacity));
  }
  .xl\\:focus\\:bg-gray-300:focus {
    --bg-opacity: 1;
    background-color: #d2d6dc;
    background-color: rgba(210, 214, 220, var(--bg-opacity));
  }
  .xl\\:focus\\:bg-gray-400:focus {
    --bg-opacity: 1;
    background-color: #9fa6b2;
    background-color: rgba(159, 166, 178, var(--bg-opacity));
  }
  .xl\\:focus\\:bg-gray-500:focus {
    --bg-opacity: 1;
    background-color: #6b7280;
    background-color: rgba(107, 114, 128, var(--bg-opacity));
  }
  .xl\\:focus\\:bg-gray-600:focus {
    --bg-opacity: 1;
    background-color: #4b5563;
    background-color: rgba(75, 85, 99, var(--bg-opacity));
  }
  .xl\\:focus\\:bg-gray-700:focus {
    --bg-opacity: 1;
    background-color: #374151;
    background-color: rgba(55, 65, 81, var(--bg-opacity));
  }
  .xl\\:focus\\:bg-gray-800:focus {
    --bg-opacity: 1;
    background-color: #252f3f;
    background-color: rgba(37, 47, 63, var(--bg-opacity));
  }
  .xl\\:focus\\:bg-gray-900:focus {
    --bg-opacity: 1;
    background-color: #161e2e;
    background-color: rgba(22, 30, 46, var(--bg-opacity));
  }
  .xl\\:focus\\:bg-red-50:focus {
    --bg-opacity: 1;
    background-color: #fdf2f2;
    background-color: rgba(253, 242, 242, var(--bg-opacity));
  }
  .xl\\:focus\\:bg-red-100:focus {
    --bg-opacity: 1;
    background-color: #fde8e8;
    background-color: rgba(253, 232, 232, var(--bg-opacity));
  }
  .xl\\:focus\\:bg-red-200:focus {
    --bg-opacity: 1;
    background-color: #fbd5d5;
    background-color: rgba(251, 213, 213, var(--bg-opacity));
  }
  .xl\\:focus\\:bg-red-300:focus {
    --bg-opacity: 1;
    background-color: #f8b4b4;
    background-color: rgba(248, 180, 180, var(--bg-opacity));
  }
  .xl\\:focus\\:bg-red-400:focus {
    --bg-opacity: 1;
    background-color: #f98080;
    background-color: rgba(249, 128, 128, var(--bg-opacity));
  }
  .xl\\:focus\\:bg-red-500:focus {
    --bg-opacity: 1;
    background-color: #f05252;
    background-color: rgba(240, 82, 82, var(--bg-opacity));
  }
  .xl\\:focus\\:bg-red-600:focus {
    --bg-opacity: 1;
    background-color: #e02424;
    background-color: rgba(224, 36, 36, var(--bg-opacity));
  }
  .xl\\:focus\\:bg-red-700:focus {
    --bg-opacity: 1;
    background-color: #c81e1e;
    background-color: rgba(200, 30, 30, var(--bg-opacity));
  }
  .xl\\:focus\\:bg-red-800:focus {
    --bg-opacity: 1;
    background-color: #9b1c1c;
    background-color: rgba(155, 28, 28, var(--bg-opacity));
  }
  .xl\\:focus\\:bg-red-900:focus {
    --bg-opacity: 1;
    background-color: #771d1d;
    background-color: rgba(119, 29, 29, var(--bg-opacity));
  }
  .xl\\:focus\\:bg-orange-50:focus {
    --bg-opacity: 1;
    background-color: #fff8f1;
    background-color: rgba(255, 248, 241, var(--bg-opacity));
  }
  .xl\\:focus\\:bg-orange-100:focus {
    --bg-opacity: 1;
    background-color: #feecdc;
    background-color: rgba(254, 236, 220, var(--bg-opacity));
  }
  .xl\\:focus\\:bg-orange-200:focus {
    --bg-opacity: 1;
    background-color: #fcd9bd;
    background-color: rgba(252, 217, 189, var(--bg-opacity));
  }
  .xl\\:focus\\:bg-orange-300:focus {
    --bg-opacity: 1;
    background-color: #fdba8c;
    background-color: rgba(253, 186, 140, var(--bg-opacity));
  }
  .xl\\:focus\\:bg-orange-400:focus {
    --bg-opacity: 1;
    background-color: #ff8a4c;
    background-color: rgba(255, 138, 76, var(--bg-opacity));
  }
  .xl\\:focus\\:bg-orange-500:focus {
    --bg-opacity: 1;
    background-color: #ff5a1f;
    background-color: rgba(255, 90, 31, var(--bg-opacity));
  }
  .xl\\:focus\\:bg-orange-600:focus {
    --bg-opacity: 1;
    background-color: #d03801;
    background-color: rgba(208, 56, 1, var(--bg-opacity));
  }
  .xl\\:focus\\:bg-orange-700:focus {
    --bg-opacity: 1;
    background-color: #b43403;
    background-color: rgba(180, 52, 3, var(--bg-opacity));
  }
  .xl\\:focus\\:bg-orange-800:focus {
    --bg-opacity: 1;
    background-color: #8a2c0d;
    background-color: rgba(138, 44, 13, var(--bg-opacity));
  }
  .xl\\:focus\\:bg-orange-900:focus {
    --bg-opacity: 1;
    background-color: #73230d;
    background-color: rgba(115, 35, 13, var(--bg-opacity));
  }
  .xl\\:focus\\:bg-yellow-50:focus {
    --bg-opacity: 1;
    background-color: #fdfdea;
    background-color: rgba(253, 253, 234, var(--bg-opacity));
  }
  .xl\\:focus\\:bg-yellow-100:focus {
    --bg-opacity: 1;
    background-color: #fdf6b2;
    background-color: rgba(253, 246, 178, var(--bg-opacity));
  }
  .xl\\:focus\\:bg-yellow-200:focus {
    --bg-opacity: 1;
    background-color: #fce96a;
    background-color: rgba(252, 233, 106, var(--bg-opacity));
  }
  .xl\\:focus\\:bg-yellow-300:focus {
    --bg-opacity: 1;
    background-color: #faca15;
    background-color: rgba(250, 202, 21, var(--bg-opacity));
  }
  .xl\\:focus\\:bg-yellow-400:focus {
    --bg-opacity: 1;
    background-color: #e3a008;
    background-color: rgba(227, 160, 8, var(--bg-opacity));
  }
  .xl\\:focus\\:bg-yellow-500:focus {
    --bg-opacity: 1;
    background-color: #c27803;
    background-color: rgba(194, 120, 3, var(--bg-opacity));
  }
  .xl\\:focus\\:bg-yellow-600:focus {
    --bg-opacity: 1;
    background-color: #9f580a;
    background-color: rgba(159, 88, 10, var(--bg-opacity));
  }
  .xl\\:focus\\:bg-yellow-700:focus {
    --bg-opacity: 1;
    background-color: #8e4b10;
    background-color: rgba(142, 75, 16, var(--bg-opacity));
  }
  .xl\\:focus\\:bg-yellow-800:focus {
    --bg-opacity: 1;
    background-color: #723b13;
    background-color: rgba(114, 59, 19, var(--bg-opacity));
  }
  .xl\\:focus\\:bg-yellow-900:focus {
    --bg-opacity: 1;
    background-color: #633112;
    background-color: rgba(99, 49, 18, var(--bg-opacity));
  }
  .xl\\:focus\\:bg-green-50:focus {
    --bg-opacity: 1;
    background-color: #f3faf7;
    background-color: rgba(243, 250, 247, var(--bg-opacity));
  }
  .xl\\:focus\\:bg-green-100:focus {
    --bg-opacity: 1;
    background-color: #def7ec;
    background-color: rgba(222, 247, 236, var(--bg-opacity));
  }
  .xl\\:focus\\:bg-green-200:focus {
    --bg-opacity: 1;
    background-color: #bcf0da;
    background-color: rgba(188, 240, 218, var(--bg-opacity));
  }
  .xl\\:focus\\:bg-green-300:focus {
    --bg-opacity: 1;
    background-color: #84e1bc;
    background-color: rgba(132, 225, 188, var(--bg-opacity));
  }
  .xl\\:focus\\:bg-green-400:focus {
    --bg-opacity: 1;
    background-color: #31c48d;
    background-color: rgba(49, 196, 141, var(--bg-opacity));
  }
  .xl\\:focus\\:bg-green-500:focus {
    --bg-opacity: 1;
    background-color: #0e9f6e;
    background-color: rgba(14, 159, 110, var(--bg-opacity));
  }
  .xl\\:focus\\:bg-green-600:focus {
    --bg-opacity: 1;
    background-color: #057a55;
    background-color: rgba(5, 122, 85, var(--bg-opacity));
  }
  .xl\\:focus\\:bg-green-700:focus {
    --bg-opacity: 1;
    background-color: #046c4e;
    background-color: rgba(4, 108, 78, var(--bg-opacity));
  }
  .xl\\:focus\\:bg-green-800:focus {
    --bg-opacity: 1;
    background-color: #03543f;
    background-color: rgba(3, 84, 63, var(--bg-opacity));
  }
  .xl\\:focus\\:bg-green-900:focus {
    --bg-opacity: 1;
    background-color: #014737;
    background-color: rgba(1, 71, 55, var(--bg-opacity));
  }
  .xl\\:focus\\:bg-teal-50:focus {
    --bg-opacity: 1;
    background-color: #edfafa;
    background-color: rgba(237, 250, 250, var(--bg-opacity));
  }
  .xl\\:focus\\:bg-teal-100:focus {
    --bg-opacity: 1;
    background-color: #d5f5f6;
    background-color: rgba(213, 245, 246, var(--bg-opacity));
  }
  .xl\\:focus\\:bg-teal-200:focus {
    --bg-opacity: 1;
    background-color: #afecef;
    background-color: rgba(175, 236, 239, var(--bg-opacity));
  }
  .xl\\:focus\\:bg-teal-300:focus {
    --bg-opacity: 1;
    background-color: #7edce2;
    background-color: rgba(126, 220, 226, var(--bg-opacity));
  }
  .xl\\:focus\\:bg-teal-400:focus {
    --bg-opacity: 1;
    background-color: #16bdca;
    background-color: rgba(22, 189, 202, var(--bg-opacity));
  }
  .xl\\:focus\\:bg-teal-500:focus {
    --bg-opacity: 1;
    background-color: #0694a2;
    background-color: rgba(6, 148, 162, var(--bg-opacity));
  }
  .xl\\:focus\\:bg-teal-600:focus {
    --bg-opacity: 1;
    background-color: #047481;
    background-color: rgba(4, 116, 129, var(--bg-opacity));
  }
  .xl\\:focus\\:bg-teal-700:focus {
    --bg-opacity: 1;
    background-color: #036672;
    background-color: rgba(3, 102, 114, var(--bg-opacity));
  }
  .xl\\:focus\\:bg-teal-800:focus {
    --bg-opacity: 1;
    background-color: #05505c;
    background-color: rgba(5, 80, 92, var(--bg-opacity));
  }
  .xl\\:focus\\:bg-teal-900:focus {
    --bg-opacity: 1;
    background-color: #014451;
    background-color: rgba(1, 68, 81, var(--bg-opacity));
  }
  .xl\\:focus\\:bg-blue-50:focus {
    --bg-opacity: 1;
    background-color: #ebf5ff;
    background-color: rgba(235, 245, 255, var(--bg-opacity));
  }
  .xl\\:focus\\:bg-blue-100:focus {
    --bg-opacity: 1;
    background-color: #e1effe;
    background-color: rgba(225, 239, 254, var(--bg-opacity));
  }
  .xl\\:focus\\:bg-blue-200:focus {
    --bg-opacity: 1;
    background-color: #c3ddfd;
    background-color: rgba(195, 221, 253, var(--bg-opacity));
  }
  .xl\\:focus\\:bg-blue-300:focus {
    --bg-opacity: 1;
    background-color: #a4cafe;
    background-color: rgba(164, 202, 254, var(--bg-opacity));
  }
  .xl\\:focus\\:bg-blue-400:focus {
    --bg-opacity: 1;
    background-color: #76a9fa;
    background-color: rgba(118, 169, 250, var(--bg-opacity));
  }
  .xl\\:focus\\:bg-blue-500:focus {
    --bg-opacity: 1;
    background-color: #3f83f8;
    background-color: rgba(63, 131, 248, var(--bg-opacity));
  }
  .xl\\:focus\\:bg-blue-600:focus {
    --bg-opacity: 1;
    background-color: #1c64f2;
    background-color: rgba(28, 100, 242, var(--bg-opacity));
  }
  .xl\\:focus\\:bg-blue-700:focus {
    --bg-opacity: 1;
    background-color: #1a56db;
    background-color: rgba(26, 86, 219, var(--bg-opacity));
  }
  .xl\\:focus\\:bg-blue-800:focus {
    --bg-opacity: 1;
    background-color: #1e429f;
    background-color: rgba(30, 66, 159, var(--bg-opacity));
  }
  .xl\\:focus\\:bg-blue-900:focus {
    --bg-opacity: 1;
    background-color: #233876;
    background-color: rgba(35, 56, 118, var(--bg-opacity));
  }
  .xl\\:focus\\:bg-indigo-50:focus {
    --bg-opacity: 1;
    background-color: #f0f5ff;
    background-color: rgba(240, 245, 255, var(--bg-opacity));
  }
  .xl\\:focus\\:bg-indigo-100:focus {
    --bg-opacity: 1;
    background-color: #e5edff;
    background-color: rgba(229, 237, 255, var(--bg-opacity));
  }
  .xl\\:focus\\:bg-indigo-200:focus {
    --bg-opacity: 1;
    background-color: #cddbfe;
    background-color: rgba(205, 219, 254, var(--bg-opacity));
  }
  .xl\\:focus\\:bg-indigo-300:focus {
    --bg-opacity: 1;
    background-color: #b4c6fc;
    background-color: rgba(180, 198, 252, var(--bg-opacity));
  }
  .xl\\:focus\\:bg-indigo-400:focus {
    --bg-opacity: 1;
    background-color: #8da2fb;
    background-color: rgba(141, 162, 251, var(--bg-opacity));
  }
  .xl\\:focus\\:bg-indigo-500:focus {
    --bg-opacity: 1;
    background-color: #6875f5;
    background-color: rgba(104, 117, 245, var(--bg-opacity));
  }
  .xl\\:focus\\:bg-indigo-600:focus {
    --bg-opacity: 1;
    background-color: #5850ec;
    background-color: rgba(88, 80, 236, var(--bg-opacity));
  }
  .xl\\:focus\\:bg-indigo-700:focus {
    --bg-opacity: 1;
    background-color: #5145cd;
    background-color: rgba(81, 69, 205, var(--bg-opacity));
  }
  .xl\\:focus\\:bg-indigo-800:focus {
    --bg-opacity: 1;
    background-color: #42389d;
    background-color: rgba(66, 56, 157, var(--bg-opacity));
  }
  .xl\\:focus\\:bg-indigo-900:focus {
    --bg-opacity: 1;
    background-color: #362f78;
    background-color: rgba(54, 47, 120, var(--bg-opacity));
  }
  .xl\\:focus\\:bg-purple-50:focus {
    --bg-opacity: 1;
    background-color: #f6f5ff;
    background-color: rgba(246, 245, 255, var(--bg-opacity));
  }
  .xl\\:focus\\:bg-purple-100:focus {
    --bg-opacity: 1;
    background-color: #edebfe;
    background-color: rgba(237, 235, 254, var(--bg-opacity));
  }
  .xl\\:focus\\:bg-purple-200:focus {
    --bg-opacity: 1;
    background-color: #dcd7fe;
    background-color: rgba(220, 215, 254, var(--bg-opacity));
  }
  .xl\\:focus\\:bg-purple-300:focus {
    --bg-opacity: 1;
    background-color: #cabffd;
    background-color: rgba(202, 191, 253, var(--bg-opacity));
  }
  .xl\\:focus\\:bg-purple-400:focus {
    --bg-opacity: 1;
    background-color: #ac94fa;
    background-color: rgba(172, 148, 250, var(--bg-opacity));
  }
  .xl\\:focus\\:bg-purple-500:focus {
    --bg-opacity: 1;
    background-color: #9061f9;
    background-color: rgba(144, 97, 249, var(--bg-opacity));
  }
  .xl\\:focus\\:bg-purple-600:focus {
    --bg-opacity: 1;
    background-color: #7e3af2;
    background-color: rgba(126, 58, 242, var(--bg-opacity));
  }
  .xl\\:focus\\:bg-purple-700:focus {
    --bg-opacity: 1;
    background-color: #6c2bd9;
    background-color: rgba(108, 43, 217, var(--bg-opacity));
  }
  .xl\\:focus\\:bg-purple-800:focus {
    --bg-opacity: 1;
    background-color: #5521b5;
    background-color: rgba(85, 33, 181, var(--bg-opacity));
  }
  .xl\\:focus\\:bg-purple-900:focus {
    --bg-opacity: 1;
    background-color: #4a1d96;
    background-color: rgba(74, 29, 150, var(--bg-opacity));
  }
  .xl\\:focus\\:bg-pink-50:focus {
    --bg-opacity: 1;
    background-color: #fdf2f8;
    background-color: rgba(253, 242, 248, var(--bg-opacity));
  }
  .xl\\:focus\\:bg-pink-100:focus {
    --bg-opacity: 1;
    background-color: #fce8f3;
    background-color: rgba(252, 232, 243, var(--bg-opacity));
  }
  .xl\\:focus\\:bg-pink-200:focus {
    --bg-opacity: 1;
    background-color: #fad1e8;
    background-color: rgba(250, 209, 232, var(--bg-opacity));
  }
  .xl\\:focus\\:bg-pink-300:focus {
    --bg-opacity: 1;
    background-color: #f8b4d9;
    background-color: rgba(248, 180, 217, var(--bg-opacity));
  }
  .xl\\:focus\\:bg-pink-400:focus {
    --bg-opacity: 1;
    background-color: #f17eb8;
    background-color: rgba(241, 126, 184, var(--bg-opacity));
  }
  .xl\\:focus\\:bg-pink-500:focus {
    --bg-opacity: 1;
    background-color: #e74694;
    background-color: rgba(231, 70, 148, var(--bg-opacity));
  }
  .xl\\:focus\\:bg-pink-600:focus {
    --bg-opacity: 1;
    background-color: #d61f69;
    background-color: rgba(214, 31, 105, var(--bg-opacity));
  }
  .xl\\:focus\\:bg-pink-700:focus {
    --bg-opacity: 1;
    background-color: #bf125d;
    background-color: rgba(191, 18, 93, var(--bg-opacity));
  }
  .xl\\:focus\\:bg-pink-800:focus {
    --bg-opacity: 1;
    background-color: #99154b;
    background-color: rgba(153, 21, 75, var(--bg-opacity));
  }
  .xl\\:focus\\:bg-pink-900:focus {
    --bg-opacity: 1;
    background-color: #751a3d;
    background-color: rgba(117, 26, 61, var(--bg-opacity));
  }
  .xl\\:focus\\:bg-cool-gray-50:focus {
    --bg-opacity: 1;
    background-color: #f8fafc;
    background-color: rgba(248, 250, 252, var(--bg-opacity));
  }
  .xl\\:focus\\:bg-cool-gray-100:focus {
    --bg-opacity: 1;
    background-color: #f1f5f9;
    background-color: rgba(241, 245, 249, var(--bg-opacity));
  }
  .xl\\:focus\\:bg-cool-gray-200:focus {
    --bg-opacity: 1;
    background-color: #e2e8f0;
    background-color: rgba(226, 232, 240, var(--bg-opacity));
  }
  .xl\\:focus\\:bg-cool-gray-300:focus {
    --bg-opacity: 1;
    background-color: #cfd8e3;
    background-color: rgba(207, 216, 227, var(--bg-opacity));
  }
  .xl\\:focus\\:bg-cool-gray-400:focus {
    --bg-opacity: 1;
    background-color: #97a6ba;
    background-color: rgba(151, 166, 186, var(--bg-opacity));
  }
  .xl\\:focus\\:bg-cool-gray-500:focus {
    --bg-opacity: 1;
    background-color: #64748b;
    background-color: rgba(100, 116, 139, var(--bg-opacity));
  }
  .xl\\:focus\\:bg-cool-gray-600:focus {
    --bg-opacity: 1;
    background-color: #475569;
    background-color: rgba(71, 85, 105, var(--bg-opacity));
  }
  .xl\\:focus\\:bg-cool-gray-700:focus {
    --bg-opacity: 1;
    background-color: #364152;
    background-color: rgba(54, 65, 82, var(--bg-opacity));
  }
  .xl\\:focus\\:bg-cool-gray-800:focus {
    --bg-opacity: 1;
    background-color: #27303f;
    background-color: rgba(39, 48, 63, var(--bg-opacity));
  }
  .xl\\:focus\\:bg-cool-gray-900:focus {
    --bg-opacity: 1;
    background-color: #1a202e;
    background-color: rgba(26, 32, 46, var(--bg-opacity));
  }
  .xl\\:active\\:bg-current:active {
    background-color: currentColor;
  }
  .xl\\:active\\:bg-transparent:active {
    background-color: transparent;
  }
  .xl\\:active\\:bg-white:active {
    --bg-opacity: 1;
    background-color: #ffffff;
    background-color: rgba(255, 255, 255, var(--bg-opacity));
  }
  .xl\\:active\\:bg-black:active {
    --bg-opacity: 1;
    background-color: #000000;
    background-color: rgba(0, 0, 0, var(--bg-opacity));
  }
  .xl\\:active\\:bg-gray-50:active {
    --bg-opacity: 1;
    background-color: #f9fafb;
    background-color: rgba(249, 250, 251, var(--bg-opacity));
  }
  .xl\\:active\\:bg-gray-100:active {
    --bg-opacity: 1;
    background-color: #f4f5f7;
    background-color: rgba(244, 245, 247, var(--bg-opacity));
  }
  .xl\\:active\\:bg-gray-200:active {
    --bg-opacity: 1;
    background-color: #e5e7eb;
    background-color: rgba(229, 231, 235, var(--bg-opacity));
  }
  .xl\\:active\\:bg-gray-300:active {
    --bg-opacity: 1;
    background-color: #d2d6dc;
    background-color: rgba(210, 214, 220, var(--bg-opacity));
  }
  .xl\\:active\\:bg-gray-400:active {
    --bg-opacity: 1;
    background-color: #9fa6b2;
    background-color: rgba(159, 166, 178, var(--bg-opacity));
  }
  .xl\\:active\\:bg-gray-500:active {
    --bg-opacity: 1;
    background-color: #6b7280;
    background-color: rgba(107, 114, 128, var(--bg-opacity));
  }
  .xl\\:active\\:bg-gray-600:active {
    --bg-opacity: 1;
    background-color: #4b5563;
    background-color: rgba(75, 85, 99, var(--bg-opacity));
  }
  .xl\\:active\\:bg-gray-700:active {
    --bg-opacity: 1;
    background-color: #374151;
    background-color: rgba(55, 65, 81, var(--bg-opacity));
  }
  .xl\\:active\\:bg-gray-800:active {
    --bg-opacity: 1;
    background-color: #252f3f;
    background-color: rgba(37, 47, 63, var(--bg-opacity));
  }
  .xl\\:active\\:bg-gray-900:active {
    --bg-opacity: 1;
    background-color: #161e2e;
    background-color: rgba(22, 30, 46, var(--bg-opacity));
  }
  .xl\\:active\\:bg-red-50:active {
    --bg-opacity: 1;
    background-color: #fdf2f2;
    background-color: rgba(253, 242, 242, var(--bg-opacity));
  }
  .xl\\:active\\:bg-red-100:active {
    --bg-opacity: 1;
    background-color: #fde8e8;
    background-color: rgba(253, 232, 232, var(--bg-opacity));
  }
  .xl\\:active\\:bg-red-200:active {
    --bg-opacity: 1;
    background-color: #fbd5d5;
    background-color: rgba(251, 213, 213, var(--bg-opacity));
  }
  .xl\\:active\\:bg-red-300:active {
    --bg-opacity: 1;
    background-color: #f8b4b4;
    background-color: rgba(248, 180, 180, var(--bg-opacity));
  }
  .xl\\:active\\:bg-red-400:active {
    --bg-opacity: 1;
    background-color: #f98080;
    background-color: rgba(249, 128, 128, var(--bg-opacity));
  }
  .xl\\:active\\:bg-red-500:active {
    --bg-opacity: 1;
    background-color: #f05252;
    background-color: rgba(240, 82, 82, var(--bg-opacity));
  }
  .xl\\:active\\:bg-red-600:active {
    --bg-opacity: 1;
    background-color: #e02424;
    background-color: rgba(224, 36, 36, var(--bg-opacity));
  }
  .xl\\:active\\:bg-red-700:active {
    --bg-opacity: 1;
    background-color: #c81e1e;
    background-color: rgba(200, 30, 30, var(--bg-opacity));
  }
  .xl\\:active\\:bg-red-800:active {
    --bg-opacity: 1;
    background-color: #9b1c1c;
    background-color: rgba(155, 28, 28, var(--bg-opacity));
  }
  .xl\\:active\\:bg-red-900:active {
    --bg-opacity: 1;
    background-color: #771d1d;
    background-color: rgba(119, 29, 29, var(--bg-opacity));
  }
  .xl\\:active\\:bg-orange-50:active {
    --bg-opacity: 1;
    background-color: #fff8f1;
    background-color: rgba(255, 248, 241, var(--bg-opacity));
  }
  .xl\\:active\\:bg-orange-100:active {
    --bg-opacity: 1;
    background-color: #feecdc;
    background-color: rgba(254, 236, 220, var(--bg-opacity));
  }
  .xl\\:active\\:bg-orange-200:active {
    --bg-opacity: 1;
    background-color: #fcd9bd;
    background-color: rgba(252, 217, 189, var(--bg-opacity));
  }
  .xl\\:active\\:bg-orange-300:active {
    --bg-opacity: 1;
    background-color: #fdba8c;
    background-color: rgba(253, 186, 140, var(--bg-opacity));
  }
  .xl\\:active\\:bg-orange-400:active {
    --bg-opacity: 1;
    background-color: #ff8a4c;
    background-color: rgba(255, 138, 76, var(--bg-opacity));
  }
  .xl\\:active\\:bg-orange-500:active {
    --bg-opacity: 1;
    background-color: #ff5a1f;
    background-color: rgba(255, 90, 31, var(--bg-opacity));
  }
  .xl\\:active\\:bg-orange-600:active {
    --bg-opacity: 1;
    background-color: #d03801;
    background-color: rgba(208, 56, 1, var(--bg-opacity));
  }
  .xl\\:active\\:bg-orange-700:active {
    --bg-opacity: 1;
    background-color: #b43403;
    background-color: rgba(180, 52, 3, var(--bg-opacity));
  }
  .xl\\:active\\:bg-orange-800:active {
    --bg-opacity: 1;
    background-color: #8a2c0d;
    background-color: rgba(138, 44, 13, var(--bg-opacity));
  }
  .xl\\:active\\:bg-orange-900:active {
    --bg-opacity: 1;
    background-color: #73230d;
    background-color: rgba(115, 35, 13, var(--bg-opacity));
  }
  .xl\\:active\\:bg-yellow-50:active {
    --bg-opacity: 1;
    background-color: #fdfdea;
    background-color: rgba(253, 253, 234, var(--bg-opacity));
  }
  .xl\\:active\\:bg-yellow-100:active {
    --bg-opacity: 1;
    background-color: #fdf6b2;
    background-color: rgba(253, 246, 178, var(--bg-opacity));
  }
  .xl\\:active\\:bg-yellow-200:active {
    --bg-opacity: 1;
    background-color: #fce96a;
    background-color: rgba(252, 233, 106, var(--bg-opacity));
  }
  .xl\\:active\\:bg-yellow-300:active {
    --bg-opacity: 1;
    background-color: #faca15;
    background-color: rgba(250, 202, 21, var(--bg-opacity));
  }
  .xl\\:active\\:bg-yellow-400:active {
    --bg-opacity: 1;
    background-color: #e3a008;
    background-color: rgba(227, 160, 8, var(--bg-opacity));
  }
  .xl\\:active\\:bg-yellow-500:active {
    --bg-opacity: 1;
    background-color: #c27803;
    background-color: rgba(194, 120, 3, var(--bg-opacity));
  }
  .xl\\:active\\:bg-yellow-600:active {
    --bg-opacity: 1;
    background-color: #9f580a;
    background-color: rgba(159, 88, 10, var(--bg-opacity));
  }
  .xl\\:active\\:bg-yellow-700:active {
    --bg-opacity: 1;
    background-color: #8e4b10;
    background-color: rgba(142, 75, 16, var(--bg-opacity));
  }
  .xl\\:active\\:bg-yellow-800:active {
    --bg-opacity: 1;
    background-color: #723b13;
    background-color: rgba(114, 59, 19, var(--bg-opacity));
  }
  .xl\\:active\\:bg-yellow-900:active {
    --bg-opacity: 1;
    background-color: #633112;
    background-color: rgba(99, 49, 18, var(--bg-opacity));
  }
  .xl\\:active\\:bg-green-50:active {
    --bg-opacity: 1;
    background-color: #f3faf7;
    background-color: rgba(243, 250, 247, var(--bg-opacity));
  }
  .xl\\:active\\:bg-green-100:active {
    --bg-opacity: 1;
    background-color: #def7ec;
    background-color: rgba(222, 247, 236, var(--bg-opacity));
  }
  .xl\\:active\\:bg-green-200:active {
    --bg-opacity: 1;
    background-color: #bcf0da;
    background-color: rgba(188, 240, 218, var(--bg-opacity));
  }
  .xl\\:active\\:bg-green-300:active {
    --bg-opacity: 1;
    background-color: #84e1bc;
    background-color: rgba(132, 225, 188, var(--bg-opacity));
  }
  .xl\\:active\\:bg-green-400:active {
    --bg-opacity: 1;
    background-color: #31c48d;
    background-color: rgba(49, 196, 141, var(--bg-opacity));
  }
  .xl\\:active\\:bg-green-500:active {
    --bg-opacity: 1;
    background-color: #0e9f6e;
    background-color: rgba(14, 159, 110, var(--bg-opacity));
  }
  .xl\\:active\\:bg-green-600:active {
    --bg-opacity: 1;
    background-color: #057a55;
    background-color: rgba(5, 122, 85, var(--bg-opacity));
  }
  .xl\\:active\\:bg-green-700:active {
    --bg-opacity: 1;
    background-color: #046c4e;
    background-color: rgba(4, 108, 78, var(--bg-opacity));
  }
  .xl\\:active\\:bg-green-800:active {
    --bg-opacity: 1;
    background-color: #03543f;
    background-color: rgba(3, 84, 63, var(--bg-opacity));
  }
  .xl\\:active\\:bg-green-900:active {
    --bg-opacity: 1;
    background-color: #014737;
    background-color: rgba(1, 71, 55, var(--bg-opacity));
  }
  .xl\\:active\\:bg-teal-50:active {
    --bg-opacity: 1;
    background-color: #edfafa;
    background-color: rgba(237, 250, 250, var(--bg-opacity));
  }
  .xl\\:active\\:bg-teal-100:active {
    --bg-opacity: 1;
    background-color: #d5f5f6;
    background-color: rgba(213, 245, 246, var(--bg-opacity));
  }
  .xl\\:active\\:bg-teal-200:active {
    --bg-opacity: 1;
    background-color: #afecef;
    background-color: rgba(175, 236, 239, var(--bg-opacity));
  }
  .xl\\:active\\:bg-teal-300:active {
    --bg-opacity: 1;
    background-color: #7edce2;
    background-color: rgba(126, 220, 226, var(--bg-opacity));
  }
  .xl\\:active\\:bg-teal-400:active {
    --bg-opacity: 1;
    background-color: #16bdca;
    background-color: rgba(22, 189, 202, var(--bg-opacity));
  }
  .xl\\:active\\:bg-teal-500:active {
    --bg-opacity: 1;
    background-color: #0694a2;
    background-color: rgba(6, 148, 162, var(--bg-opacity));
  }
  .xl\\:active\\:bg-teal-600:active {
    --bg-opacity: 1;
    background-color: #047481;
    background-color: rgba(4, 116, 129, var(--bg-opacity));
  }
  .xl\\:active\\:bg-teal-700:active {
    --bg-opacity: 1;
    background-color: #036672;
    background-color: rgba(3, 102, 114, var(--bg-opacity));
  }
  .xl\\:active\\:bg-teal-800:active {
    --bg-opacity: 1;
    background-color: #05505c;
    background-color: rgba(5, 80, 92, var(--bg-opacity));
  }
  .xl\\:active\\:bg-teal-900:active {
    --bg-opacity: 1;
    background-color: #014451;
    background-color: rgba(1, 68, 81, var(--bg-opacity));
  }
  .xl\\:active\\:bg-blue-50:active {
    --bg-opacity: 1;
    background-color: #ebf5ff;
    background-color: rgba(235, 245, 255, var(--bg-opacity));
  }
  .xl\\:active\\:bg-blue-100:active {
    --bg-opacity: 1;
    background-color: #e1effe;
    background-color: rgba(225, 239, 254, var(--bg-opacity));
  }
  .xl\\:active\\:bg-blue-200:active {
    --bg-opacity: 1;
    background-color: #c3ddfd;
    background-color: rgba(195, 221, 253, var(--bg-opacity));
  }
  .xl\\:active\\:bg-blue-300:active {
    --bg-opacity: 1;
    background-color: #a4cafe;
    background-color: rgba(164, 202, 254, var(--bg-opacity));
  }
  .xl\\:active\\:bg-blue-400:active {
    --bg-opacity: 1;
    background-color: #76a9fa;
    background-color: rgba(118, 169, 250, var(--bg-opacity));
  }
  .xl\\:active\\:bg-blue-500:active {
    --bg-opacity: 1;
    background-color: #3f83f8;
    background-color: rgba(63, 131, 248, var(--bg-opacity));
  }
  .xl\\:active\\:bg-blue-600:active {
    --bg-opacity: 1;
    background-color: #1c64f2;
    background-color: rgba(28, 100, 242, var(--bg-opacity));
  }
  .xl\\:active\\:bg-blue-700:active {
    --bg-opacity: 1;
    background-color: #1a56db;
    background-color: rgba(26, 86, 219, var(--bg-opacity));
  }
  .xl\\:active\\:bg-blue-800:active {
    --bg-opacity: 1;
    background-color: #1e429f;
    background-color: rgba(30, 66, 159, var(--bg-opacity));
  }
  .xl\\:active\\:bg-blue-900:active {
    --bg-opacity: 1;
    background-color: #233876;
    background-color: rgba(35, 56, 118, var(--bg-opacity));
  }
  .xl\\:active\\:bg-indigo-50:active {
    --bg-opacity: 1;
    background-color: #f0f5ff;
    background-color: rgba(240, 245, 255, var(--bg-opacity));
  }
  .xl\\:active\\:bg-indigo-100:active {
    --bg-opacity: 1;
    background-color: #e5edff;
    background-color: rgba(229, 237, 255, var(--bg-opacity));
  }
  .xl\\:active\\:bg-indigo-200:active {
    --bg-opacity: 1;
    background-color: #cddbfe;
    background-color: rgba(205, 219, 254, var(--bg-opacity));
  }
  .xl\\:active\\:bg-indigo-300:active {
    --bg-opacity: 1;
    background-color: #b4c6fc;
    background-color: rgba(180, 198, 252, var(--bg-opacity));
  }
  .xl\\:active\\:bg-indigo-400:active {
    --bg-opacity: 1;
    background-color: #8da2fb;
    background-color: rgba(141, 162, 251, var(--bg-opacity));
  }
  .xl\\:active\\:bg-indigo-500:active {
    --bg-opacity: 1;
    background-color: #6875f5;
    background-color: rgba(104, 117, 245, var(--bg-opacity));
  }
  .xl\\:active\\:bg-indigo-600:active {
    --bg-opacity: 1;
    background-color: #5850ec;
    background-color: rgba(88, 80, 236, var(--bg-opacity));
  }
  .xl\\:active\\:bg-indigo-700:active {
    --bg-opacity: 1;
    background-color: #5145cd;
    background-color: rgba(81, 69, 205, var(--bg-opacity));
  }
  .xl\\:active\\:bg-indigo-800:active {
    --bg-opacity: 1;
    background-color: #42389d;
    background-color: rgba(66, 56, 157, var(--bg-opacity));
  }
  .xl\\:active\\:bg-indigo-900:active {
    --bg-opacity: 1;
    background-color: #362f78;
    background-color: rgba(54, 47, 120, var(--bg-opacity));
  }
  .xl\\:active\\:bg-purple-50:active {
    --bg-opacity: 1;
    background-color: #f6f5ff;
    background-color: rgba(246, 245, 255, var(--bg-opacity));
  }
  .xl\\:active\\:bg-purple-100:active {
    --bg-opacity: 1;
    background-color: #edebfe;
    background-color: rgba(237, 235, 254, var(--bg-opacity));
  }
  .xl\\:active\\:bg-purple-200:active {
    --bg-opacity: 1;
    background-color: #dcd7fe;
    background-color: rgba(220, 215, 254, var(--bg-opacity));
  }
  .xl\\:active\\:bg-purple-300:active {
    --bg-opacity: 1;
    background-color: #cabffd;
    background-color: rgba(202, 191, 253, var(--bg-opacity));
  }
  .xl\\:active\\:bg-purple-400:active {
    --bg-opacity: 1;
    background-color: #ac94fa;
    background-color: rgba(172, 148, 250, var(--bg-opacity));
  }
  .xl\\:active\\:bg-purple-500:active {
    --bg-opacity: 1;
    background-color: #9061f9;
    background-color: rgba(144, 97, 249, var(--bg-opacity));
  }
  .xl\\:active\\:bg-purple-600:active {
    --bg-opacity: 1;
    background-color: #7e3af2;
    background-color: rgba(126, 58, 242, var(--bg-opacity));
  }
  .xl\\:active\\:bg-purple-700:active {
    --bg-opacity: 1;
    background-color: #6c2bd9;
    background-color: rgba(108, 43, 217, var(--bg-opacity));
  }
  .xl\\:active\\:bg-purple-800:active {
    --bg-opacity: 1;
    background-color: #5521b5;
    background-color: rgba(85, 33, 181, var(--bg-opacity));
  }
  .xl\\:active\\:bg-purple-900:active {
    --bg-opacity: 1;
    background-color: #4a1d96;
    background-color: rgba(74, 29, 150, var(--bg-opacity));
  }
  .xl\\:active\\:bg-pink-50:active {
    --bg-opacity: 1;
    background-color: #fdf2f8;
    background-color: rgba(253, 242, 248, var(--bg-opacity));
  }
  .xl\\:active\\:bg-pink-100:active {
    --bg-opacity: 1;
    background-color: #fce8f3;
    background-color: rgba(252, 232, 243, var(--bg-opacity));
  }
  .xl\\:active\\:bg-pink-200:active {
    --bg-opacity: 1;
    background-color: #fad1e8;
    background-color: rgba(250, 209, 232, var(--bg-opacity));
  }
  .xl\\:active\\:bg-pink-300:active {
    --bg-opacity: 1;
    background-color: #f8b4d9;
    background-color: rgba(248, 180, 217, var(--bg-opacity));
  }
  .xl\\:active\\:bg-pink-400:active {
    --bg-opacity: 1;
    background-color: #f17eb8;
    background-color: rgba(241, 126, 184, var(--bg-opacity));
  }
  .xl\\:active\\:bg-pink-500:active {
    --bg-opacity: 1;
    background-color: #e74694;
    background-color: rgba(231, 70, 148, var(--bg-opacity));
  }
  .xl\\:active\\:bg-pink-600:active {
    --bg-opacity: 1;
    background-color: #d61f69;
    background-color: rgba(214, 31, 105, var(--bg-opacity));
  }
  .xl\\:active\\:bg-pink-700:active {
    --bg-opacity: 1;
    background-color: #bf125d;
    background-color: rgba(191, 18, 93, var(--bg-opacity));
  }
  .xl\\:active\\:bg-pink-800:active {
    --bg-opacity: 1;
    background-color: #99154b;
    background-color: rgba(153, 21, 75, var(--bg-opacity));
  }
  .xl\\:active\\:bg-pink-900:active {
    --bg-opacity: 1;
    background-color: #751a3d;
    background-color: rgba(117, 26, 61, var(--bg-opacity));
  }
  .xl\\:active\\:bg-cool-gray-50:active {
    --bg-opacity: 1;
    background-color: #f8fafc;
    background-color: rgba(248, 250, 252, var(--bg-opacity));
  }
  .xl\\:active\\:bg-cool-gray-100:active {
    --bg-opacity: 1;
    background-color: #f1f5f9;
    background-color: rgba(241, 245, 249, var(--bg-opacity));
  }
  .xl\\:active\\:bg-cool-gray-200:active {
    --bg-opacity: 1;
    background-color: #e2e8f0;
    background-color: rgba(226, 232, 240, var(--bg-opacity));
  }
  .xl\\:active\\:bg-cool-gray-300:active {
    --bg-opacity: 1;
    background-color: #cfd8e3;
    background-color: rgba(207, 216, 227, var(--bg-opacity));
  }
  .xl\\:active\\:bg-cool-gray-400:active {
    --bg-opacity: 1;
    background-color: #97a6ba;
    background-color: rgba(151, 166, 186, var(--bg-opacity));
  }
  .xl\\:active\\:bg-cool-gray-500:active {
    --bg-opacity: 1;
    background-color: #64748b;
    background-color: rgba(100, 116, 139, var(--bg-opacity));
  }
  .xl\\:active\\:bg-cool-gray-600:active {
    --bg-opacity: 1;
    background-color: #475569;
    background-color: rgba(71, 85, 105, var(--bg-opacity));
  }
  .xl\\:active\\:bg-cool-gray-700:active {
    --bg-opacity: 1;
    background-color: #364152;
    background-color: rgba(54, 65, 82, var(--bg-opacity));
  }
  .xl\\:active\\:bg-cool-gray-800:active {
    --bg-opacity: 1;
    background-color: #27303f;
    background-color: rgba(39, 48, 63, var(--bg-opacity));
  }
  .xl\\:active\\:bg-cool-gray-900:active {
    --bg-opacity: 1;
    background-color: #1a202e;
    background-color: rgba(26, 32, 46, var(--bg-opacity));
  }
  .xl\\:bg-none {
    background-image: none;
  }
  .xl\\:bg-gradient-to-t {
    background-image: linear-gradient(to top, var(--gradient-color-stops));
  }
  .xl\\:bg-gradient-to-tr {
    background-image: linear-gradient(to top right, var(--gradient-color-stops));
  }
  .xl\\:bg-gradient-to-r {
    background-image: linear-gradient(to right, var(--gradient-color-stops));
  }
  .xl\\:bg-gradient-to-br {
    background-image: linear-gradient(to bottom right, var(--gradient-color-stops));
  }
  .xl\\:bg-gradient-to-b {
    background-image: linear-gradient(to bottom, var(--gradient-color-stops));
  }
  .xl\\:bg-gradient-to-bl {
    background-image: linear-gradient(to bottom left, var(--gradient-color-stops));
  }
  .xl\\:bg-gradient-to-l {
    background-image: linear-gradient(to left, var(--gradient-color-stops));
  }
  .xl\\:bg-gradient-to-tl {
    background-image: linear-gradient(to top left, var(--gradient-color-stops));
  }
  .xl\\:from-current {
    --gradient-from-color: currentColor;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }
  .xl\\:from-transparent {
    --gradient-from-color: transparent;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  }
  .xl\\:from-white {
    --gradient-from-color: #ffffff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }
  .xl\\:from-black {
    --gradient-from-color: #000000;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  }
  .xl\\:from-gray-50 {
    --gradient-from-color: #f9fafb;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(249, 250, 251, 0));
  }
  .xl\\:from-gray-100 {
    --gradient-from-color: #f4f5f7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(244, 245, 247, 0));
  }
  .xl\\:from-gray-200 {
    --gradient-from-color: #e5e7eb;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(229, 231, 235, 0));
  }
  .xl\\:from-gray-300 {
    --gradient-from-color: #d2d6dc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(210, 214, 220, 0));
  }
  .xl\\:from-gray-400 {
    --gradient-from-color: #9fa6b2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(159, 166, 178, 0));
  }
  .xl\\:from-gray-500 {
    --gradient-from-color: #6b7280;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(107, 114, 128, 0));
  }
  .xl\\:from-gray-600 {
    --gradient-from-color: #4b5563;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(75, 85, 99, 0));
  }
  .xl\\:from-gray-700 {
    --gradient-from-color: #374151;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(55, 65, 81, 0));
  }
  .xl\\:from-gray-800 {
    --gradient-from-color: #252f3f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(37, 47, 63, 0));
  }
  .xl\\:from-gray-900 {
    --gradient-from-color: #161e2e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(22, 30, 46, 0));
  }
  .xl\\:from-red-50 {
    --gradient-from-color: #fdf2f2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 242, 242, 0));
  }
  .xl\\:from-red-100 {
    --gradient-from-color: #fde8e8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 232, 232, 0));
  }
  .xl\\:from-red-200 {
    --gradient-from-color: #fbd5d5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(251, 213, 213, 0));
  }
  .xl\\:from-red-300 {
    --gradient-from-color: #f8b4b4;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(248, 180, 180, 0));
  }
  .xl\\:from-red-400 {
    --gradient-from-color: #f98080;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(249, 128, 128, 0));
  }
  .xl\\:from-red-500 {
    --gradient-from-color: #f05252;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(240, 82, 82, 0));
  }
  .xl\\:from-red-600 {
    --gradient-from-color: #e02424;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(224, 36, 36, 0));
  }
  .xl\\:from-red-700 {
    --gradient-from-color: #c81e1e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(200, 30, 30, 0));
  }
  .xl\\:from-red-800 {
    --gradient-from-color: #9b1c1c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(155, 28, 28, 0));
  }
  .xl\\:from-red-900 {
    --gradient-from-color: #771d1d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(119, 29, 29, 0));
  }
  .xl\\:from-orange-50 {
    --gradient-from-color: #fff8f1;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 248, 241, 0));
  }
  .xl\\:from-orange-100 {
    --gradient-from-color: #feecdc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 236, 220, 0));
  }
  .xl\\:from-orange-200 {
    --gradient-from-color: #fcd9bd;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(252, 217, 189, 0));
  }
  .xl\\:from-orange-300 {
    --gradient-from-color: #fdba8c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 186, 140, 0));
  }
  .xl\\:from-orange-400 {
    --gradient-from-color: #ff8a4c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 138, 76, 0));
  }
  .xl\\:from-orange-500 {
    --gradient-from-color: #ff5a1f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 90, 31, 0));
  }
  .xl\\:from-orange-600 {
    --gradient-from-color: #d03801;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(208, 56, 1, 0));
  }
  .xl\\:from-orange-700 {
    --gradient-from-color: #b43403;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(180, 52, 3, 0));
  }
  .xl\\:from-orange-800 {
    --gradient-from-color: #8a2c0d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(138, 44, 13, 0));
  }
  .xl\\:from-orange-900 {
    --gradient-from-color: #73230d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(115, 35, 13, 0));
  }
  .xl\\:from-yellow-50 {
    --gradient-from-color: #fdfdea;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 253, 234, 0));
  }
  .xl\\:from-yellow-100 {
    --gradient-from-color: #fdf6b2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 246, 178, 0));
  }
  .xl\\:from-yellow-200 {
    --gradient-from-color: #fce96a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(252, 233, 106, 0));
  }
  .xl\\:from-yellow-300 {
    --gradient-from-color: #faca15;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(250, 202, 21, 0));
  }
  .xl\\:from-yellow-400 {
    --gradient-from-color: #e3a008;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(227, 160, 8, 0));
  }
  .xl\\:from-yellow-500 {
    --gradient-from-color: #c27803;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(194, 120, 3, 0));
  }
  .xl\\:from-yellow-600 {
    --gradient-from-color: #9f580a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(159, 88, 10, 0));
  }
  .xl\\:from-yellow-700 {
    --gradient-from-color: #8e4b10;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(142, 75, 16, 0));
  }
  .xl\\:from-yellow-800 {
    --gradient-from-color: #723b13;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(114, 59, 19, 0));
  }
  .xl\\:from-yellow-900 {
    --gradient-from-color: #633112;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(99, 49, 18, 0));
  }
  .xl\\:from-green-50 {
    --gradient-from-color: #f3faf7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(243, 250, 247, 0));
  }
  .xl\\:from-green-100 {
    --gradient-from-color: #def7ec;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(222, 247, 236, 0));
  }
  .xl\\:from-green-200 {
    --gradient-from-color: #bcf0da;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(188, 240, 218, 0));
  }
  .xl\\:from-green-300 {
    --gradient-from-color: #84e1bc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(132, 225, 188, 0));
  }
  .xl\\:from-green-400 {
    --gradient-from-color: #31c48d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(49, 196, 141, 0));
  }
  .xl\\:from-green-500 {
    --gradient-from-color: #0e9f6e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(14, 159, 110, 0));
  }
  .xl\\:from-green-600 {
    --gradient-from-color: #057a55;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(5, 122, 85, 0));
  }
  .xl\\:from-green-700 {
    --gradient-from-color: #046c4e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(4, 108, 78, 0));
  }
  .xl\\:from-green-800 {
    --gradient-from-color: #03543f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(3, 84, 63, 0));
  }
  .xl\\:from-green-900 {
    --gradient-from-color: #014737;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(1, 71, 55, 0));
  }
  .xl\\:from-teal-50 {
    --gradient-from-color: #edfafa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(237, 250, 250, 0));
  }
  .xl\\:from-teal-100 {
    --gradient-from-color: #d5f5f6;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(213, 245, 246, 0));
  }
  .xl\\:from-teal-200 {
    --gradient-from-color: #afecef;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(175, 236, 239, 0));
  }
  .xl\\:from-teal-300 {
    --gradient-from-color: #7edce2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(126, 220, 226, 0));
  }
  .xl\\:from-teal-400 {
    --gradient-from-color: #16bdca;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(22, 189, 202, 0));
  }
  .xl\\:from-teal-500 {
    --gradient-from-color: #0694a2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(6, 148, 162, 0));
  }
  .xl\\:from-teal-600 {
    --gradient-from-color: #047481;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(4, 116, 129, 0));
  }
  .xl\\:from-teal-700 {
    --gradient-from-color: #036672;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(3, 102, 114, 0));
  }
  .xl\\:from-teal-800 {
    --gradient-from-color: #05505c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(5, 80, 92, 0));
  }
  .xl\\:from-teal-900 {
    --gradient-from-color: #014451;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(1, 68, 81, 0));
  }
  .xl\\:from-blue-50 {
    --gradient-from-color: #ebf5ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(235, 245, 255, 0));
  }
  .xl\\:from-blue-100 {
    --gradient-from-color: #e1effe;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(225, 239, 254, 0));
  }
  .xl\\:from-blue-200 {
    --gradient-from-color: #c3ddfd;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(195, 221, 253, 0));
  }
  .xl\\:from-blue-300 {
    --gradient-from-color: #a4cafe;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(164, 202, 254, 0));
  }
  .xl\\:from-blue-400 {
    --gradient-from-color: #76a9fa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(118, 169, 250, 0));
  }
  .xl\\:from-blue-500 {
    --gradient-from-color: #3f83f8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(63, 131, 248, 0));
  }
  .xl\\:from-blue-600 {
    --gradient-from-color: #1c64f2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(28, 100, 242, 0));
  }
  .xl\\:from-blue-700 {
    --gradient-from-color: #1a56db;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(26, 86, 219, 0));
  }
  .xl\\:from-blue-800 {
    --gradient-from-color: #1e429f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(30, 66, 159, 0));
  }
  .xl\\:from-blue-900 {
    --gradient-from-color: #233876;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(35, 56, 118, 0));
  }
  .xl\\:from-indigo-50 {
    --gradient-from-color: #f0f5ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(240, 245, 255, 0));
  }
  .xl\\:from-indigo-100 {
    --gradient-from-color: #e5edff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(229, 237, 255, 0));
  }
  .xl\\:from-indigo-200 {
    --gradient-from-color: #cddbfe;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(205, 219, 254, 0));
  }
  .xl\\:from-indigo-300 {
    --gradient-from-color: #b4c6fc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(180, 198, 252, 0));
  }
  .xl\\:from-indigo-400 {
    --gradient-from-color: #8da2fb;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(141, 162, 251, 0));
  }
  .xl\\:from-indigo-500 {
    --gradient-from-color: #6875f5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(104, 117, 245, 0));
  }
  .xl\\:from-indigo-600 {
    --gradient-from-color: #5850ec;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(88, 80, 236, 0));
  }
  .xl\\:from-indigo-700 {
    --gradient-from-color: #5145cd;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(81, 69, 205, 0));
  }
  .xl\\:from-indigo-800 {
    --gradient-from-color: #42389d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(66, 56, 157, 0));
  }
  .xl\\:from-indigo-900 {
    --gradient-from-color: #362f78;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(54, 47, 120, 0));
  }
  .xl\\:from-purple-50 {
    --gradient-from-color: #f6f5ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(246, 245, 255, 0));
  }
  .xl\\:from-purple-100 {
    --gradient-from-color: #edebfe;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(237, 235, 254, 0));
  }
  .xl\\:from-purple-200 {
    --gradient-from-color: #dcd7fe;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(220, 215, 254, 0));
  }
  .xl\\:from-purple-300 {
    --gradient-from-color: #cabffd;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(202, 191, 253, 0));
  }
  .xl\\:from-purple-400 {
    --gradient-from-color: #ac94fa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(172, 148, 250, 0));
  }
  .xl\\:from-purple-500 {
    --gradient-from-color: #9061f9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(144, 97, 249, 0));
  }
  .xl\\:from-purple-600 {
    --gradient-from-color: #7e3af2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(126, 58, 242, 0));
  }
  .xl\\:from-purple-700 {
    --gradient-from-color: #6c2bd9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(108, 43, 217, 0));
  }
  .xl\\:from-purple-800 {
    --gradient-from-color: #5521b5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(85, 33, 181, 0));
  }
  .xl\\:from-purple-900 {
    --gradient-from-color: #4a1d96;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(74, 29, 150, 0));
  }
  .xl\\:from-pink-50 {
    --gradient-from-color: #fdf2f8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 242, 248, 0));
  }
  .xl\\:from-pink-100 {
    --gradient-from-color: #fce8f3;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(252, 232, 243, 0));
  }
  .xl\\:from-pink-200 {
    --gradient-from-color: #fad1e8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(250, 209, 232, 0));
  }
  .xl\\:from-pink-300 {
    --gradient-from-color: #f8b4d9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(248, 180, 217, 0));
  }
  .xl\\:from-pink-400 {
    --gradient-from-color: #f17eb8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(241, 126, 184, 0));
  }
  .xl\\:from-pink-500 {
    --gradient-from-color: #e74694;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(231, 70, 148, 0));
  }
  .xl\\:from-pink-600 {
    --gradient-from-color: #d61f69;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(214, 31, 105, 0));
  }
  .xl\\:from-pink-700 {
    --gradient-from-color: #bf125d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(191, 18, 93, 0));
  }
  .xl\\:from-pink-800 {
    --gradient-from-color: #99154b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(153, 21, 75, 0));
  }
  .xl\\:from-pink-900 {
    --gradient-from-color: #751a3d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(117, 26, 61, 0));
  }
  .xl\\:from-cool-gray-50 {
    --gradient-from-color: #f8fafc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(248, 250, 252, 0));
  }
  .xl\\:from-cool-gray-100 {
    --gradient-from-color: #f1f5f9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(241, 245, 249, 0));
  }
  .xl\\:from-cool-gray-200 {
    --gradient-from-color: #e2e8f0;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(226, 232, 240, 0));
  }
  .xl\\:from-cool-gray-300 {
    --gradient-from-color: #cfd8e3;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(207, 216, 227, 0));
  }
  .xl\\:from-cool-gray-400 {
    --gradient-from-color: #97a6ba;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(151, 166, 186, 0));
  }
  .xl\\:from-cool-gray-500 {
    --gradient-from-color: #64748b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(100, 116, 139, 0));
  }
  .xl\\:from-cool-gray-600 {
    --gradient-from-color: #475569;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(71, 85, 105, 0));
  }
  .xl\\:from-cool-gray-700 {
    --gradient-from-color: #364152;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(54, 65, 82, 0));
  }
  .xl\\:from-cool-gray-800 {
    --gradient-from-color: #27303f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(39, 48, 63, 0));
  }
  .xl\\:from-cool-gray-900 {
    --gradient-from-color: #1a202e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(26, 32, 46, 0));
  }
  .xl\\:via-current {
    --gradient-via-color: currentColor;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }
  .xl\\:via-transparent {
    --gradient-via-color: transparent;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  }
  .xl\\:via-white {
    --gradient-via-color: #ffffff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }
  .xl\\:via-black {
    --gradient-via-color: #000000;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  }
  .xl\\:via-gray-50 {
    --gradient-via-color: #f9fafb;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(249, 250, 251, 0));
  }
  .xl\\:via-gray-100 {
    --gradient-via-color: #f4f5f7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(244, 245, 247, 0));
  }
  .xl\\:via-gray-200 {
    --gradient-via-color: #e5e7eb;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(229, 231, 235, 0));
  }
  .xl\\:via-gray-300 {
    --gradient-via-color: #d2d6dc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(210, 214, 220, 0));
  }
  .xl\\:via-gray-400 {
    --gradient-via-color: #9fa6b2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(159, 166, 178, 0));
  }
  .xl\\:via-gray-500 {
    --gradient-via-color: #6b7280;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(107, 114, 128, 0));
  }
  .xl\\:via-gray-600 {
    --gradient-via-color: #4b5563;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(75, 85, 99, 0));
  }
  .xl\\:via-gray-700 {
    --gradient-via-color: #374151;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(55, 65, 81, 0));
  }
  .xl\\:via-gray-800 {
    --gradient-via-color: #252f3f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(37, 47, 63, 0));
  }
  .xl\\:via-gray-900 {
    --gradient-via-color: #161e2e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(22, 30, 46, 0));
  }
  .xl\\:via-red-50 {
    --gradient-via-color: #fdf2f2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 242, 242, 0));
  }
  .xl\\:via-red-100 {
    --gradient-via-color: #fde8e8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 232, 232, 0));
  }
  .xl\\:via-red-200 {
    --gradient-via-color: #fbd5d5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(251, 213, 213, 0));
  }
  .xl\\:via-red-300 {
    --gradient-via-color: #f8b4b4;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(248, 180, 180, 0));
  }
  .xl\\:via-red-400 {
    --gradient-via-color: #f98080;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(249, 128, 128, 0));
  }
  .xl\\:via-red-500 {
    --gradient-via-color: #f05252;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(240, 82, 82, 0));
  }
  .xl\\:via-red-600 {
    --gradient-via-color: #e02424;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(224, 36, 36, 0));
  }
  .xl\\:via-red-700 {
    --gradient-via-color: #c81e1e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(200, 30, 30, 0));
  }
  .xl\\:via-red-800 {
    --gradient-via-color: #9b1c1c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(155, 28, 28, 0));
  }
  .xl\\:via-red-900 {
    --gradient-via-color: #771d1d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(119, 29, 29, 0));
  }
  .xl\\:via-orange-50 {
    --gradient-via-color: #fff8f1;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 248, 241, 0));
  }
  .xl\\:via-orange-100 {
    --gradient-via-color: #feecdc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 236, 220, 0));
  }
  .xl\\:via-orange-200 {
    --gradient-via-color: #fcd9bd;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(252, 217, 189, 0));
  }
  .xl\\:via-orange-300 {
    --gradient-via-color: #fdba8c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 186, 140, 0));
  }
  .xl\\:via-orange-400 {
    --gradient-via-color: #ff8a4c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 138, 76, 0));
  }
  .xl\\:via-orange-500 {
    --gradient-via-color: #ff5a1f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 90, 31, 0));
  }
  .xl\\:via-orange-600 {
    --gradient-via-color: #d03801;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(208, 56, 1, 0));
  }
  .xl\\:via-orange-700 {
    --gradient-via-color: #b43403;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(180, 52, 3, 0));
  }
  .xl\\:via-orange-800 {
    --gradient-via-color: #8a2c0d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(138, 44, 13, 0));
  }
  .xl\\:via-orange-900 {
    --gradient-via-color: #73230d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(115, 35, 13, 0));
  }
  .xl\\:via-yellow-50 {
    --gradient-via-color: #fdfdea;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 253, 234, 0));
  }
  .xl\\:via-yellow-100 {
    --gradient-via-color: #fdf6b2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 246, 178, 0));
  }
  .xl\\:via-yellow-200 {
    --gradient-via-color: #fce96a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(252, 233, 106, 0));
  }
  .xl\\:via-yellow-300 {
    --gradient-via-color: #faca15;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(250, 202, 21, 0));
  }
  .xl\\:via-yellow-400 {
    --gradient-via-color: #e3a008;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(227, 160, 8, 0));
  }
  .xl\\:via-yellow-500 {
    --gradient-via-color: #c27803;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(194, 120, 3, 0));
  }
  .xl\\:via-yellow-600 {
    --gradient-via-color: #9f580a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(159, 88, 10, 0));
  }
  .xl\\:via-yellow-700 {
    --gradient-via-color: #8e4b10;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(142, 75, 16, 0));
  }
  .xl\\:via-yellow-800 {
    --gradient-via-color: #723b13;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(114, 59, 19, 0));
  }
  .xl\\:via-yellow-900 {
    --gradient-via-color: #633112;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(99, 49, 18, 0));
  }
  .xl\\:via-green-50 {
    --gradient-via-color: #f3faf7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(243, 250, 247, 0));
  }
  .xl\\:via-green-100 {
    --gradient-via-color: #def7ec;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(222, 247, 236, 0));
  }
  .xl\\:via-green-200 {
    --gradient-via-color: #bcf0da;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(188, 240, 218, 0));
  }
  .xl\\:via-green-300 {
    --gradient-via-color: #84e1bc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(132, 225, 188, 0));
  }
  .xl\\:via-green-400 {
    --gradient-via-color: #31c48d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(49, 196, 141, 0));
  }
  .xl\\:via-green-500 {
    --gradient-via-color: #0e9f6e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(14, 159, 110, 0));
  }
  .xl\\:via-green-600 {
    --gradient-via-color: #057a55;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(5, 122, 85, 0));
  }
  .xl\\:via-green-700 {
    --gradient-via-color: #046c4e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(4, 108, 78, 0));
  }
  .xl\\:via-green-800 {
    --gradient-via-color: #03543f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(3, 84, 63, 0));
  }
  .xl\\:via-green-900 {
    --gradient-via-color: #014737;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(1, 71, 55, 0));
  }
  .xl\\:via-teal-50 {
    --gradient-via-color: #edfafa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(237, 250, 250, 0));
  }
  .xl\\:via-teal-100 {
    --gradient-via-color: #d5f5f6;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(213, 245, 246, 0));
  }
  .xl\\:via-teal-200 {
    --gradient-via-color: #afecef;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(175, 236, 239, 0));
  }
  .xl\\:via-teal-300 {
    --gradient-via-color: #7edce2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(126, 220, 226, 0));
  }
  .xl\\:via-teal-400 {
    --gradient-via-color: #16bdca;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(22, 189, 202, 0));
  }
  .xl\\:via-teal-500 {
    --gradient-via-color: #0694a2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(6, 148, 162, 0));
  }
  .xl\\:via-teal-600 {
    --gradient-via-color: #047481;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(4, 116, 129, 0));
  }
  .xl\\:via-teal-700 {
    --gradient-via-color: #036672;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(3, 102, 114, 0));
  }
  .xl\\:via-teal-800 {
    --gradient-via-color: #05505c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(5, 80, 92, 0));
  }
  .xl\\:via-teal-900 {
    --gradient-via-color: #014451;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(1, 68, 81, 0));
  }
  .xl\\:via-blue-50 {
    --gradient-via-color: #ebf5ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(235, 245, 255, 0));
  }
  .xl\\:via-blue-100 {
    --gradient-via-color: #e1effe;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(225, 239, 254, 0));
  }
  .xl\\:via-blue-200 {
    --gradient-via-color: #c3ddfd;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(195, 221, 253, 0));
  }
  .xl\\:via-blue-300 {
    --gradient-via-color: #a4cafe;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(164, 202, 254, 0));
  }
  .xl\\:via-blue-400 {
    --gradient-via-color: #76a9fa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(118, 169, 250, 0));
  }
  .xl\\:via-blue-500 {
    --gradient-via-color: #3f83f8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(63, 131, 248, 0));
  }
  .xl\\:via-blue-600 {
    --gradient-via-color: #1c64f2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(28, 100, 242, 0));
  }
  .xl\\:via-blue-700 {
    --gradient-via-color: #1a56db;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(26, 86, 219, 0));
  }
  .xl\\:via-blue-800 {
    --gradient-via-color: #1e429f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(30, 66, 159, 0));
  }
  .xl\\:via-blue-900 {
    --gradient-via-color: #233876;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(35, 56, 118, 0));
  }
  .xl\\:via-indigo-50 {
    --gradient-via-color: #f0f5ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(240, 245, 255, 0));
  }
  .xl\\:via-indigo-100 {
    --gradient-via-color: #e5edff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(229, 237, 255, 0));
  }
  .xl\\:via-indigo-200 {
    --gradient-via-color: #cddbfe;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(205, 219, 254, 0));
  }
  .xl\\:via-indigo-300 {
    --gradient-via-color: #b4c6fc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(180, 198, 252, 0));
  }
  .xl\\:via-indigo-400 {
    --gradient-via-color: #8da2fb;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(141, 162, 251, 0));
  }
  .xl\\:via-indigo-500 {
    --gradient-via-color: #6875f5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(104, 117, 245, 0));
  }
  .xl\\:via-indigo-600 {
    --gradient-via-color: #5850ec;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(88, 80, 236, 0));
  }
  .xl\\:via-indigo-700 {
    --gradient-via-color: #5145cd;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(81, 69, 205, 0));
  }
  .xl\\:via-indigo-800 {
    --gradient-via-color: #42389d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(66, 56, 157, 0));
  }
  .xl\\:via-indigo-900 {
    --gradient-via-color: #362f78;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(54, 47, 120, 0));
  }
  .xl\\:via-purple-50 {
    --gradient-via-color: #f6f5ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(246, 245, 255, 0));
  }
  .xl\\:via-purple-100 {
    --gradient-via-color: #edebfe;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(237, 235, 254, 0));
  }
  .xl\\:via-purple-200 {
    --gradient-via-color: #dcd7fe;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(220, 215, 254, 0));
  }
  .xl\\:via-purple-300 {
    --gradient-via-color: #cabffd;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(202, 191, 253, 0));
  }
  .xl\\:via-purple-400 {
    --gradient-via-color: #ac94fa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(172, 148, 250, 0));
  }
  .xl\\:via-purple-500 {
    --gradient-via-color: #9061f9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(144, 97, 249, 0));
  }
  .xl\\:via-purple-600 {
    --gradient-via-color: #7e3af2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(126, 58, 242, 0));
  }
  .xl\\:via-purple-700 {
    --gradient-via-color: #6c2bd9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(108, 43, 217, 0));
  }
  .xl\\:via-purple-800 {
    --gradient-via-color: #5521b5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(85, 33, 181, 0));
  }
  .xl\\:via-purple-900 {
    --gradient-via-color: #4a1d96;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(74, 29, 150, 0));
  }
  .xl\\:via-pink-50 {
    --gradient-via-color: #fdf2f8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 242, 248, 0));
  }
  .xl\\:via-pink-100 {
    --gradient-via-color: #fce8f3;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(252, 232, 243, 0));
  }
  .xl\\:via-pink-200 {
    --gradient-via-color: #fad1e8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(250, 209, 232, 0));
  }
  .xl\\:via-pink-300 {
    --gradient-via-color: #f8b4d9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(248, 180, 217, 0));
  }
  .xl\\:via-pink-400 {
    --gradient-via-color: #f17eb8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(241, 126, 184, 0));
  }
  .xl\\:via-pink-500 {
    --gradient-via-color: #e74694;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(231, 70, 148, 0));
  }
  .xl\\:via-pink-600 {
    --gradient-via-color: #d61f69;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(214, 31, 105, 0));
  }
  .xl\\:via-pink-700 {
    --gradient-via-color: #bf125d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(191, 18, 93, 0));
  }
  .xl\\:via-pink-800 {
    --gradient-via-color: #99154b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(153, 21, 75, 0));
  }
  .xl\\:via-pink-900 {
    --gradient-via-color: #751a3d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(117, 26, 61, 0));
  }
  .xl\\:via-cool-gray-50 {
    --gradient-via-color: #f8fafc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(248, 250, 252, 0));
  }
  .xl\\:via-cool-gray-100 {
    --gradient-via-color: #f1f5f9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(241, 245, 249, 0));
  }
  .xl\\:via-cool-gray-200 {
    --gradient-via-color: #e2e8f0;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(226, 232, 240, 0));
  }
  .xl\\:via-cool-gray-300 {
    --gradient-via-color: #cfd8e3;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(207, 216, 227, 0));
  }
  .xl\\:via-cool-gray-400 {
    --gradient-via-color: #97a6ba;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(151, 166, 186, 0));
  }
  .xl\\:via-cool-gray-500 {
    --gradient-via-color: #64748b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(100, 116, 139, 0));
  }
  .xl\\:via-cool-gray-600 {
    --gradient-via-color: #475569;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(71, 85, 105, 0));
  }
  .xl\\:via-cool-gray-700 {
    --gradient-via-color: #364152;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(54, 65, 82, 0));
  }
  .xl\\:via-cool-gray-800 {
    --gradient-via-color: #27303f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(39, 48, 63, 0));
  }
  .xl\\:via-cool-gray-900 {
    --gradient-via-color: #1a202e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(26, 32, 46, 0));
  }
  .xl\\:to-current {
    --gradient-to-color: currentColor;
  }
  .xl\\:to-transparent {
    --gradient-to-color: transparent;
  }
  .xl\\:to-white {
    --gradient-to-color: #ffffff;
  }
  .xl\\:to-black {
    --gradient-to-color: #000000;
  }
  .xl\\:to-gray-50 {
    --gradient-to-color: #f9fafb;
  }
  .xl\\:to-gray-100 {
    --gradient-to-color: #f4f5f7;
  }
  .xl\\:to-gray-200 {
    --gradient-to-color: #e5e7eb;
  }
  .xl\\:to-gray-300 {
    --gradient-to-color: #d2d6dc;
  }
  .xl\\:to-gray-400 {
    --gradient-to-color: #9fa6b2;
  }
  .xl\\:to-gray-500 {
    --gradient-to-color: #6b7280;
  }
  .xl\\:to-gray-600 {
    --gradient-to-color: #4b5563;
  }
  .xl\\:to-gray-700 {
    --gradient-to-color: #374151;
  }
  .xl\\:to-gray-800 {
    --gradient-to-color: #252f3f;
  }
  .xl\\:to-gray-900 {
    --gradient-to-color: #161e2e;
  }
  .xl\\:to-red-50 {
    --gradient-to-color: #fdf2f2;
  }
  .xl\\:to-red-100 {
    --gradient-to-color: #fde8e8;
  }
  .xl\\:to-red-200 {
    --gradient-to-color: #fbd5d5;
  }
  .xl\\:to-red-300 {
    --gradient-to-color: #f8b4b4;
  }
  .xl\\:to-red-400 {
    --gradient-to-color: #f98080;
  }
  .xl\\:to-red-500 {
    --gradient-to-color: #f05252;
  }
  .xl\\:to-red-600 {
    --gradient-to-color: #e02424;
  }
  .xl\\:to-red-700 {
    --gradient-to-color: #c81e1e;
  }
  .xl\\:to-red-800 {
    --gradient-to-color: #9b1c1c;
  }
  .xl\\:to-red-900 {
    --gradient-to-color: #771d1d;
  }
  .xl\\:to-orange-50 {
    --gradient-to-color: #fff8f1;
  }
  .xl\\:to-orange-100 {
    --gradient-to-color: #feecdc;
  }
  .xl\\:to-orange-200 {
    --gradient-to-color: #fcd9bd;
  }
  .xl\\:to-orange-300 {
    --gradient-to-color: #fdba8c;
  }
  .xl\\:to-orange-400 {
    --gradient-to-color: #ff8a4c;
  }
  .xl\\:to-orange-500 {
    --gradient-to-color: #ff5a1f;
  }
  .xl\\:to-orange-600 {
    --gradient-to-color: #d03801;
  }
  .xl\\:to-orange-700 {
    --gradient-to-color: #b43403;
  }
  .xl\\:to-orange-800 {
    --gradient-to-color: #8a2c0d;
  }
  .xl\\:to-orange-900 {
    --gradient-to-color: #73230d;
  }
  .xl\\:to-yellow-50 {
    --gradient-to-color: #fdfdea;
  }
  .xl\\:to-yellow-100 {
    --gradient-to-color: #fdf6b2;
  }
  .xl\\:to-yellow-200 {
    --gradient-to-color: #fce96a;
  }
  .xl\\:to-yellow-300 {
    --gradient-to-color: #faca15;
  }
  .xl\\:to-yellow-400 {
    --gradient-to-color: #e3a008;
  }
  .xl\\:to-yellow-500 {
    --gradient-to-color: #c27803;
  }
  .xl\\:to-yellow-600 {
    --gradient-to-color: #9f580a;
  }
  .xl\\:to-yellow-700 {
    --gradient-to-color: #8e4b10;
  }
  .xl\\:to-yellow-800 {
    --gradient-to-color: #723b13;
  }
  .xl\\:to-yellow-900 {
    --gradient-to-color: #633112;
  }
  .xl\\:to-green-50 {
    --gradient-to-color: #f3faf7;
  }
  .xl\\:to-green-100 {
    --gradient-to-color: #def7ec;
  }
  .xl\\:to-green-200 {
    --gradient-to-color: #bcf0da;
  }
  .xl\\:to-green-300 {
    --gradient-to-color: #84e1bc;
  }
  .xl\\:to-green-400 {
    --gradient-to-color: #31c48d;
  }
  .xl\\:to-green-500 {
    --gradient-to-color: #0e9f6e;
  }
  .xl\\:to-green-600 {
    --gradient-to-color: #057a55;
  }
  .xl\\:to-green-700 {
    --gradient-to-color: #046c4e;
  }
  .xl\\:to-green-800 {
    --gradient-to-color: #03543f;
  }
  .xl\\:to-green-900 {
    --gradient-to-color: #014737;
  }
  .xl\\:to-teal-50 {
    --gradient-to-color: #edfafa;
  }
  .xl\\:to-teal-100 {
    --gradient-to-color: #d5f5f6;
  }
  .xl\\:to-teal-200 {
    --gradient-to-color: #afecef;
  }
  .xl\\:to-teal-300 {
    --gradient-to-color: #7edce2;
  }
  .xl\\:to-teal-400 {
    --gradient-to-color: #16bdca;
  }
  .xl\\:to-teal-500 {
    --gradient-to-color: #0694a2;
  }
  .xl\\:to-teal-600 {
    --gradient-to-color: #047481;
  }
  .xl\\:to-teal-700 {
    --gradient-to-color: #036672;
  }
  .xl\\:to-teal-800 {
    --gradient-to-color: #05505c;
  }
  .xl\\:to-teal-900 {
    --gradient-to-color: #014451;
  }
  .xl\\:to-blue-50 {
    --gradient-to-color: #ebf5ff;
  }
  .xl\\:to-blue-100 {
    --gradient-to-color: #e1effe;
  }
  .xl\\:to-blue-200 {
    --gradient-to-color: #c3ddfd;
  }
  .xl\\:to-blue-300 {
    --gradient-to-color: #a4cafe;
  }
  .xl\\:to-blue-400 {
    --gradient-to-color: #76a9fa;
  }
  .xl\\:to-blue-500 {
    --gradient-to-color: #3f83f8;
  }
  .xl\\:to-blue-600 {
    --gradient-to-color: #1c64f2;
  }
  .xl\\:to-blue-700 {
    --gradient-to-color: #1a56db;
  }
  .xl\\:to-blue-800 {
    --gradient-to-color: #1e429f;
  }
  .xl\\:to-blue-900 {
    --gradient-to-color: #233876;
  }
  .xl\\:to-indigo-50 {
    --gradient-to-color: #f0f5ff;
  }
  .xl\\:to-indigo-100 {
    --gradient-to-color: #e5edff;
  }
  .xl\\:to-indigo-200 {
    --gradient-to-color: #cddbfe;
  }
  .xl\\:to-indigo-300 {
    --gradient-to-color: #b4c6fc;
  }
  .xl\\:to-indigo-400 {
    --gradient-to-color: #8da2fb;
  }
  .xl\\:to-indigo-500 {
    --gradient-to-color: #6875f5;
  }
  .xl\\:to-indigo-600 {
    --gradient-to-color: #5850ec;
  }
  .xl\\:to-indigo-700 {
    --gradient-to-color: #5145cd;
  }
  .xl\\:to-indigo-800 {
    --gradient-to-color: #42389d;
  }
  .xl\\:to-indigo-900 {
    --gradient-to-color: #362f78;
  }
  .xl\\:to-purple-50 {
    --gradient-to-color: #f6f5ff;
  }
  .xl\\:to-purple-100 {
    --gradient-to-color: #edebfe;
  }
  .xl\\:to-purple-200 {
    --gradient-to-color: #dcd7fe;
  }
  .xl\\:to-purple-300 {
    --gradient-to-color: #cabffd;
  }
  .xl\\:to-purple-400 {
    --gradient-to-color: #ac94fa;
  }
  .xl\\:to-purple-500 {
    --gradient-to-color: #9061f9;
  }
  .xl\\:to-purple-600 {
    --gradient-to-color: #7e3af2;
  }
  .xl\\:to-purple-700 {
    --gradient-to-color: #6c2bd9;
  }
  .xl\\:to-purple-800 {
    --gradient-to-color: #5521b5;
  }
  .xl\\:to-purple-900 {
    --gradient-to-color: #4a1d96;
  }
  .xl\\:to-pink-50 {
    --gradient-to-color: #fdf2f8;
  }
  .xl\\:to-pink-100 {
    --gradient-to-color: #fce8f3;
  }
  .xl\\:to-pink-200 {
    --gradient-to-color: #fad1e8;
  }
  .xl\\:to-pink-300 {
    --gradient-to-color: #f8b4d9;
  }
  .xl\\:to-pink-400 {
    --gradient-to-color: #f17eb8;
  }
  .xl\\:to-pink-500 {
    --gradient-to-color: #e74694;
  }
  .xl\\:to-pink-600 {
    --gradient-to-color: #d61f69;
  }
  .xl\\:to-pink-700 {
    --gradient-to-color: #bf125d;
  }
  .xl\\:to-pink-800 {
    --gradient-to-color: #99154b;
  }
  .xl\\:to-pink-900 {
    --gradient-to-color: #751a3d;
  }
  .xl\\:to-cool-gray-50 {
    --gradient-to-color: #f8fafc;
  }
  .xl\\:to-cool-gray-100 {
    --gradient-to-color: #f1f5f9;
  }
  .xl\\:to-cool-gray-200 {
    --gradient-to-color: #e2e8f0;
  }
  .xl\\:to-cool-gray-300 {
    --gradient-to-color: #cfd8e3;
  }
  .xl\\:to-cool-gray-400 {
    --gradient-to-color: #97a6ba;
  }
  .xl\\:to-cool-gray-500 {
    --gradient-to-color: #64748b;
  }
  .xl\\:to-cool-gray-600 {
    --gradient-to-color: #475569;
  }
  .xl\\:to-cool-gray-700 {
    --gradient-to-color: #364152;
  }
  .xl\\:to-cool-gray-800 {
    --gradient-to-color: #27303f;
  }
  .xl\\:to-cool-gray-900 {
    --gradient-to-color: #1a202e;
  }
  .xl\\:hover\\:from-current:hover {
    --gradient-from-color: currentColor;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }
  .xl\\:hover\\:from-transparent:hover {
    --gradient-from-color: transparent;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  }
  .xl\\:hover\\:from-white:hover {
    --gradient-from-color: #ffffff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }
  .xl\\:hover\\:from-black:hover {
    --gradient-from-color: #000000;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  }
  .xl\\:hover\\:from-gray-50:hover {
    --gradient-from-color: #f9fafb;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(249, 250, 251, 0));
  }
  .xl\\:hover\\:from-gray-100:hover {
    --gradient-from-color: #f4f5f7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(244, 245, 247, 0));
  }
  .xl\\:hover\\:from-gray-200:hover {
    --gradient-from-color: #e5e7eb;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(229, 231, 235, 0));
  }
  .xl\\:hover\\:from-gray-300:hover {
    --gradient-from-color: #d2d6dc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(210, 214, 220, 0));
  }
  .xl\\:hover\\:from-gray-400:hover {
    --gradient-from-color: #9fa6b2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(159, 166, 178, 0));
  }
  .xl\\:hover\\:from-gray-500:hover {
    --gradient-from-color: #6b7280;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(107, 114, 128, 0));
  }
  .xl\\:hover\\:from-gray-600:hover {
    --gradient-from-color: #4b5563;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(75, 85, 99, 0));
  }
  .xl\\:hover\\:from-gray-700:hover {
    --gradient-from-color: #374151;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(55, 65, 81, 0));
  }
  .xl\\:hover\\:from-gray-800:hover {
    --gradient-from-color: #252f3f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(37, 47, 63, 0));
  }
  .xl\\:hover\\:from-gray-900:hover {
    --gradient-from-color: #161e2e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(22, 30, 46, 0));
  }
  .xl\\:hover\\:from-red-50:hover {
    --gradient-from-color: #fdf2f2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 242, 242, 0));
  }
  .xl\\:hover\\:from-red-100:hover {
    --gradient-from-color: #fde8e8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 232, 232, 0));
  }
  .xl\\:hover\\:from-red-200:hover {
    --gradient-from-color: #fbd5d5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(251, 213, 213, 0));
  }
  .xl\\:hover\\:from-red-300:hover {
    --gradient-from-color: #f8b4b4;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(248, 180, 180, 0));
  }
  .xl\\:hover\\:from-red-400:hover {
    --gradient-from-color: #f98080;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(249, 128, 128, 0));
  }
  .xl\\:hover\\:from-red-500:hover {
    --gradient-from-color: #f05252;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(240, 82, 82, 0));
  }
  .xl\\:hover\\:from-red-600:hover {
    --gradient-from-color: #e02424;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(224, 36, 36, 0));
  }
  .xl\\:hover\\:from-red-700:hover {
    --gradient-from-color: #c81e1e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(200, 30, 30, 0));
  }
  .xl\\:hover\\:from-red-800:hover {
    --gradient-from-color: #9b1c1c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(155, 28, 28, 0));
  }
  .xl\\:hover\\:from-red-900:hover {
    --gradient-from-color: #771d1d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(119, 29, 29, 0));
  }
  .xl\\:hover\\:from-orange-50:hover {
    --gradient-from-color: #fff8f1;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 248, 241, 0));
  }
  .xl\\:hover\\:from-orange-100:hover {
    --gradient-from-color: #feecdc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 236, 220, 0));
  }
  .xl\\:hover\\:from-orange-200:hover {
    --gradient-from-color: #fcd9bd;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(252, 217, 189, 0));
  }
  .xl\\:hover\\:from-orange-300:hover {
    --gradient-from-color: #fdba8c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 186, 140, 0));
  }
  .xl\\:hover\\:from-orange-400:hover {
    --gradient-from-color: #ff8a4c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 138, 76, 0));
  }
  .xl\\:hover\\:from-orange-500:hover {
    --gradient-from-color: #ff5a1f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 90, 31, 0));
  }
  .xl\\:hover\\:from-orange-600:hover {
    --gradient-from-color: #d03801;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(208, 56, 1, 0));
  }
  .xl\\:hover\\:from-orange-700:hover {
    --gradient-from-color: #b43403;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(180, 52, 3, 0));
  }
  .xl\\:hover\\:from-orange-800:hover {
    --gradient-from-color: #8a2c0d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(138, 44, 13, 0));
  }
  .xl\\:hover\\:from-orange-900:hover {
    --gradient-from-color: #73230d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(115, 35, 13, 0));
  }
  .xl\\:hover\\:from-yellow-50:hover {
    --gradient-from-color: #fdfdea;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 253, 234, 0));
  }
  .xl\\:hover\\:from-yellow-100:hover {
    --gradient-from-color: #fdf6b2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 246, 178, 0));
  }
  .xl\\:hover\\:from-yellow-200:hover {
    --gradient-from-color: #fce96a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(252, 233, 106, 0));
  }
  .xl\\:hover\\:from-yellow-300:hover {
    --gradient-from-color: #faca15;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(250, 202, 21, 0));
  }
  .xl\\:hover\\:from-yellow-400:hover {
    --gradient-from-color: #e3a008;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(227, 160, 8, 0));
  }
  .xl\\:hover\\:from-yellow-500:hover {
    --gradient-from-color: #c27803;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(194, 120, 3, 0));
  }
  .xl\\:hover\\:from-yellow-600:hover {
    --gradient-from-color: #9f580a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(159, 88, 10, 0));
  }
  .xl\\:hover\\:from-yellow-700:hover {
    --gradient-from-color: #8e4b10;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(142, 75, 16, 0));
  }
  .xl\\:hover\\:from-yellow-800:hover {
    --gradient-from-color: #723b13;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(114, 59, 19, 0));
  }
  .xl\\:hover\\:from-yellow-900:hover {
    --gradient-from-color: #633112;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(99, 49, 18, 0));
  }
  .xl\\:hover\\:from-green-50:hover {
    --gradient-from-color: #f3faf7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(243, 250, 247, 0));
  }
  .xl\\:hover\\:from-green-100:hover {
    --gradient-from-color: #def7ec;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(222, 247, 236, 0));
  }
  .xl\\:hover\\:from-green-200:hover {
    --gradient-from-color: #bcf0da;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(188, 240, 218, 0));
  }
  .xl\\:hover\\:from-green-300:hover {
    --gradient-from-color: #84e1bc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(132, 225, 188, 0));
  }
  .xl\\:hover\\:from-green-400:hover {
    --gradient-from-color: #31c48d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(49, 196, 141, 0));
  }
  .xl\\:hover\\:from-green-500:hover {
    --gradient-from-color: #0e9f6e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(14, 159, 110, 0));
  }
  .xl\\:hover\\:from-green-600:hover {
    --gradient-from-color: #057a55;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(5, 122, 85, 0));
  }
  .xl\\:hover\\:from-green-700:hover {
    --gradient-from-color: #046c4e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(4, 108, 78, 0));
  }
  .xl\\:hover\\:from-green-800:hover {
    --gradient-from-color: #03543f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(3, 84, 63, 0));
  }
  .xl\\:hover\\:from-green-900:hover {
    --gradient-from-color: #014737;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(1, 71, 55, 0));
  }
  .xl\\:hover\\:from-teal-50:hover {
    --gradient-from-color: #edfafa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(237, 250, 250, 0));
  }
  .xl\\:hover\\:from-teal-100:hover {
    --gradient-from-color: #d5f5f6;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(213, 245, 246, 0));
  }
  .xl\\:hover\\:from-teal-200:hover {
    --gradient-from-color: #afecef;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(175, 236, 239, 0));
  }
  .xl\\:hover\\:from-teal-300:hover {
    --gradient-from-color: #7edce2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(126, 220, 226, 0));
  }
  .xl\\:hover\\:from-teal-400:hover {
    --gradient-from-color: #16bdca;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(22, 189, 202, 0));
  }
  .xl\\:hover\\:from-teal-500:hover {
    --gradient-from-color: #0694a2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(6, 148, 162, 0));
  }
  .xl\\:hover\\:from-teal-600:hover {
    --gradient-from-color: #047481;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(4, 116, 129, 0));
  }
  .xl\\:hover\\:from-teal-700:hover {
    --gradient-from-color: #036672;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(3, 102, 114, 0));
  }
  .xl\\:hover\\:from-teal-800:hover {
    --gradient-from-color: #05505c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(5, 80, 92, 0));
  }
  .xl\\:hover\\:from-teal-900:hover {
    --gradient-from-color: #014451;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(1, 68, 81, 0));
  }
  .xl\\:hover\\:from-blue-50:hover {
    --gradient-from-color: #ebf5ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(235, 245, 255, 0));
  }
  .xl\\:hover\\:from-blue-100:hover {
    --gradient-from-color: #e1effe;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(225, 239, 254, 0));
  }
  .xl\\:hover\\:from-blue-200:hover {
    --gradient-from-color: #c3ddfd;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(195, 221, 253, 0));
  }
  .xl\\:hover\\:from-blue-300:hover {
    --gradient-from-color: #a4cafe;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(164, 202, 254, 0));
  }
  .xl\\:hover\\:from-blue-400:hover {
    --gradient-from-color: #76a9fa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(118, 169, 250, 0));
  }
  .xl\\:hover\\:from-blue-500:hover {
    --gradient-from-color: #3f83f8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(63, 131, 248, 0));
  }
  .xl\\:hover\\:from-blue-600:hover {
    --gradient-from-color: #1c64f2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(28, 100, 242, 0));
  }
  .xl\\:hover\\:from-blue-700:hover {
    --gradient-from-color: #1a56db;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(26, 86, 219, 0));
  }
  .xl\\:hover\\:from-blue-800:hover {
    --gradient-from-color: #1e429f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(30, 66, 159, 0));
  }
  .xl\\:hover\\:from-blue-900:hover {
    --gradient-from-color: #233876;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(35, 56, 118, 0));
  }
  .xl\\:hover\\:from-indigo-50:hover {
    --gradient-from-color: #f0f5ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(240, 245, 255, 0));
  }
  .xl\\:hover\\:from-indigo-100:hover {
    --gradient-from-color: #e5edff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(229, 237, 255, 0));
  }
  .xl\\:hover\\:from-indigo-200:hover {
    --gradient-from-color: #cddbfe;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(205, 219, 254, 0));
  }
  .xl\\:hover\\:from-indigo-300:hover {
    --gradient-from-color: #b4c6fc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(180, 198, 252, 0));
  }
  .xl\\:hover\\:from-indigo-400:hover {
    --gradient-from-color: #8da2fb;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(141, 162, 251, 0));
  }
  .xl\\:hover\\:from-indigo-500:hover {
    --gradient-from-color: #6875f5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(104, 117, 245, 0));
  }
  .xl\\:hover\\:from-indigo-600:hover {
    --gradient-from-color: #5850ec;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(88, 80, 236, 0));
  }
  .xl\\:hover\\:from-indigo-700:hover {
    --gradient-from-color: #5145cd;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(81, 69, 205, 0));
  }
  .xl\\:hover\\:from-indigo-800:hover {
    --gradient-from-color: #42389d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(66, 56, 157, 0));
  }
  .xl\\:hover\\:from-indigo-900:hover {
    --gradient-from-color: #362f78;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(54, 47, 120, 0));
  }
  .xl\\:hover\\:from-purple-50:hover {
    --gradient-from-color: #f6f5ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(246, 245, 255, 0));
  }
  .xl\\:hover\\:from-purple-100:hover {
    --gradient-from-color: #edebfe;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(237, 235, 254, 0));
  }
  .xl\\:hover\\:from-purple-200:hover {
    --gradient-from-color: #dcd7fe;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(220, 215, 254, 0));
  }
  .xl\\:hover\\:from-purple-300:hover {
    --gradient-from-color: #cabffd;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(202, 191, 253, 0));
  }
  .xl\\:hover\\:from-purple-400:hover {
    --gradient-from-color: #ac94fa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(172, 148, 250, 0));
  }
  .xl\\:hover\\:from-purple-500:hover {
    --gradient-from-color: #9061f9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(144, 97, 249, 0));
  }
  .xl\\:hover\\:from-purple-600:hover {
    --gradient-from-color: #7e3af2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(126, 58, 242, 0));
  }
  .xl\\:hover\\:from-purple-700:hover {
    --gradient-from-color: #6c2bd9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(108, 43, 217, 0));
  }
  .xl\\:hover\\:from-purple-800:hover {
    --gradient-from-color: #5521b5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(85, 33, 181, 0));
  }
  .xl\\:hover\\:from-purple-900:hover {
    --gradient-from-color: #4a1d96;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(74, 29, 150, 0));
  }
  .xl\\:hover\\:from-pink-50:hover {
    --gradient-from-color: #fdf2f8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 242, 248, 0));
  }
  .xl\\:hover\\:from-pink-100:hover {
    --gradient-from-color: #fce8f3;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(252, 232, 243, 0));
  }
  .xl\\:hover\\:from-pink-200:hover {
    --gradient-from-color: #fad1e8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(250, 209, 232, 0));
  }
  .xl\\:hover\\:from-pink-300:hover {
    --gradient-from-color: #f8b4d9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(248, 180, 217, 0));
  }
  .xl\\:hover\\:from-pink-400:hover {
    --gradient-from-color: #f17eb8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(241, 126, 184, 0));
  }
  .xl\\:hover\\:from-pink-500:hover {
    --gradient-from-color: #e74694;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(231, 70, 148, 0));
  }
  .xl\\:hover\\:from-pink-600:hover {
    --gradient-from-color: #d61f69;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(214, 31, 105, 0));
  }
  .xl\\:hover\\:from-pink-700:hover {
    --gradient-from-color: #bf125d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(191, 18, 93, 0));
  }
  .xl\\:hover\\:from-pink-800:hover {
    --gradient-from-color: #99154b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(153, 21, 75, 0));
  }
  .xl\\:hover\\:from-pink-900:hover {
    --gradient-from-color: #751a3d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(117, 26, 61, 0));
  }
  .xl\\:hover\\:from-cool-gray-50:hover {
    --gradient-from-color: #f8fafc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(248, 250, 252, 0));
  }
  .xl\\:hover\\:from-cool-gray-100:hover {
    --gradient-from-color: #f1f5f9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(241, 245, 249, 0));
  }
  .xl\\:hover\\:from-cool-gray-200:hover {
    --gradient-from-color: #e2e8f0;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(226, 232, 240, 0));
  }
  .xl\\:hover\\:from-cool-gray-300:hover {
    --gradient-from-color: #cfd8e3;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(207, 216, 227, 0));
  }
  .xl\\:hover\\:from-cool-gray-400:hover {
    --gradient-from-color: #97a6ba;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(151, 166, 186, 0));
  }
  .xl\\:hover\\:from-cool-gray-500:hover {
    --gradient-from-color: #64748b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(100, 116, 139, 0));
  }
  .xl\\:hover\\:from-cool-gray-600:hover {
    --gradient-from-color: #475569;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(71, 85, 105, 0));
  }
  .xl\\:hover\\:from-cool-gray-700:hover {
    --gradient-from-color: #364152;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(54, 65, 82, 0));
  }
  .xl\\:hover\\:from-cool-gray-800:hover {
    --gradient-from-color: #27303f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(39, 48, 63, 0));
  }
  .xl\\:hover\\:from-cool-gray-900:hover {
    --gradient-from-color: #1a202e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(26, 32, 46, 0));
  }
  .xl\\:hover\\:via-current:hover {
    --gradient-via-color: currentColor;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }
  .xl\\:hover\\:via-transparent:hover {
    --gradient-via-color: transparent;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  }
  .xl\\:hover\\:via-white:hover {
    --gradient-via-color: #ffffff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }
  .xl\\:hover\\:via-black:hover {
    --gradient-via-color: #000000;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  }
  .xl\\:hover\\:via-gray-50:hover {
    --gradient-via-color: #f9fafb;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(249, 250, 251, 0));
  }
  .xl\\:hover\\:via-gray-100:hover {
    --gradient-via-color: #f4f5f7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(244, 245, 247, 0));
  }
  .xl\\:hover\\:via-gray-200:hover {
    --gradient-via-color: #e5e7eb;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(229, 231, 235, 0));
  }
  .xl\\:hover\\:via-gray-300:hover {
    --gradient-via-color: #d2d6dc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(210, 214, 220, 0));
  }
  .xl\\:hover\\:via-gray-400:hover {
    --gradient-via-color: #9fa6b2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(159, 166, 178, 0));
  }
  .xl\\:hover\\:via-gray-500:hover {
    --gradient-via-color: #6b7280;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(107, 114, 128, 0));
  }
  .xl\\:hover\\:via-gray-600:hover {
    --gradient-via-color: #4b5563;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(75, 85, 99, 0));
  }
  .xl\\:hover\\:via-gray-700:hover {
    --gradient-via-color: #374151;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(55, 65, 81, 0));
  }
  .xl\\:hover\\:via-gray-800:hover {
    --gradient-via-color: #252f3f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(37, 47, 63, 0));
  }
  .xl\\:hover\\:via-gray-900:hover {
    --gradient-via-color: #161e2e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(22, 30, 46, 0));
  }
  .xl\\:hover\\:via-red-50:hover {
    --gradient-via-color: #fdf2f2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 242, 242, 0));
  }
  .xl\\:hover\\:via-red-100:hover {
    --gradient-via-color: #fde8e8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 232, 232, 0));
  }
  .xl\\:hover\\:via-red-200:hover {
    --gradient-via-color: #fbd5d5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(251, 213, 213, 0));
  }
  .xl\\:hover\\:via-red-300:hover {
    --gradient-via-color: #f8b4b4;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(248, 180, 180, 0));
  }
  .xl\\:hover\\:via-red-400:hover {
    --gradient-via-color: #f98080;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(249, 128, 128, 0));
  }
  .xl\\:hover\\:via-red-500:hover {
    --gradient-via-color: #f05252;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(240, 82, 82, 0));
  }
  .xl\\:hover\\:via-red-600:hover {
    --gradient-via-color: #e02424;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(224, 36, 36, 0));
  }
  .xl\\:hover\\:via-red-700:hover {
    --gradient-via-color: #c81e1e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(200, 30, 30, 0));
  }
  .xl\\:hover\\:via-red-800:hover {
    --gradient-via-color: #9b1c1c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(155, 28, 28, 0));
  }
  .xl\\:hover\\:via-red-900:hover {
    --gradient-via-color: #771d1d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(119, 29, 29, 0));
  }
  .xl\\:hover\\:via-orange-50:hover {
    --gradient-via-color: #fff8f1;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 248, 241, 0));
  }
  .xl\\:hover\\:via-orange-100:hover {
    --gradient-via-color: #feecdc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 236, 220, 0));
  }
  .xl\\:hover\\:via-orange-200:hover {
    --gradient-via-color: #fcd9bd;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(252, 217, 189, 0));
  }
  .xl\\:hover\\:via-orange-300:hover {
    --gradient-via-color: #fdba8c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 186, 140, 0));
  }
  .xl\\:hover\\:via-orange-400:hover {
    --gradient-via-color: #ff8a4c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 138, 76, 0));
  }
  .xl\\:hover\\:via-orange-500:hover {
    --gradient-via-color: #ff5a1f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 90, 31, 0));
  }
  .xl\\:hover\\:via-orange-600:hover {
    --gradient-via-color: #d03801;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(208, 56, 1, 0));
  }
  .xl\\:hover\\:via-orange-700:hover {
    --gradient-via-color: #b43403;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(180, 52, 3, 0));
  }
  .xl\\:hover\\:via-orange-800:hover {
    --gradient-via-color: #8a2c0d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(138, 44, 13, 0));
  }
  .xl\\:hover\\:via-orange-900:hover {
    --gradient-via-color: #73230d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(115, 35, 13, 0));
  }
  .xl\\:hover\\:via-yellow-50:hover {
    --gradient-via-color: #fdfdea;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 253, 234, 0));
  }
  .xl\\:hover\\:via-yellow-100:hover {
    --gradient-via-color: #fdf6b2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 246, 178, 0));
  }
  .xl\\:hover\\:via-yellow-200:hover {
    --gradient-via-color: #fce96a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(252, 233, 106, 0));
  }
  .xl\\:hover\\:via-yellow-300:hover {
    --gradient-via-color: #faca15;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(250, 202, 21, 0));
  }
  .xl\\:hover\\:via-yellow-400:hover {
    --gradient-via-color: #e3a008;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(227, 160, 8, 0));
  }
  .xl\\:hover\\:via-yellow-500:hover {
    --gradient-via-color: #c27803;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(194, 120, 3, 0));
  }
  .xl\\:hover\\:via-yellow-600:hover {
    --gradient-via-color: #9f580a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(159, 88, 10, 0));
  }
  .xl\\:hover\\:via-yellow-700:hover {
    --gradient-via-color: #8e4b10;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(142, 75, 16, 0));
  }
  .xl\\:hover\\:via-yellow-800:hover {
    --gradient-via-color: #723b13;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(114, 59, 19, 0));
  }
  .xl\\:hover\\:via-yellow-900:hover {
    --gradient-via-color: #633112;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(99, 49, 18, 0));
  }
  .xl\\:hover\\:via-green-50:hover {
    --gradient-via-color: #f3faf7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(243, 250, 247, 0));
  }
  .xl\\:hover\\:via-green-100:hover {
    --gradient-via-color: #def7ec;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(222, 247, 236, 0));
  }
  .xl\\:hover\\:via-green-200:hover {
    --gradient-via-color: #bcf0da;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(188, 240, 218, 0));
  }
  .xl\\:hover\\:via-green-300:hover {
    --gradient-via-color: #84e1bc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(132, 225, 188, 0));
  }
  .xl\\:hover\\:via-green-400:hover {
    --gradient-via-color: #31c48d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(49, 196, 141, 0));
  }
  .xl\\:hover\\:via-green-500:hover {
    --gradient-via-color: #0e9f6e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(14, 159, 110, 0));
  }
  .xl\\:hover\\:via-green-600:hover {
    --gradient-via-color: #057a55;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(5, 122, 85, 0));
  }
  .xl\\:hover\\:via-green-700:hover {
    --gradient-via-color: #046c4e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(4, 108, 78, 0));
  }
  .xl\\:hover\\:via-green-800:hover {
    --gradient-via-color: #03543f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(3, 84, 63, 0));
  }
  .xl\\:hover\\:via-green-900:hover {
    --gradient-via-color: #014737;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(1, 71, 55, 0));
  }
  .xl\\:hover\\:via-teal-50:hover {
    --gradient-via-color: #edfafa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(237, 250, 250, 0));
  }
  .xl\\:hover\\:via-teal-100:hover {
    --gradient-via-color: #d5f5f6;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(213, 245, 246, 0));
  }
  .xl\\:hover\\:via-teal-200:hover {
    --gradient-via-color: #afecef;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(175, 236, 239, 0));
  }
  .xl\\:hover\\:via-teal-300:hover {
    --gradient-via-color: #7edce2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(126, 220, 226, 0));
  }
  .xl\\:hover\\:via-teal-400:hover {
    --gradient-via-color: #16bdca;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(22, 189, 202, 0));
  }
  .xl\\:hover\\:via-teal-500:hover {
    --gradient-via-color: #0694a2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(6, 148, 162, 0));
  }
  .xl\\:hover\\:via-teal-600:hover {
    --gradient-via-color: #047481;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(4, 116, 129, 0));
  }
  .xl\\:hover\\:via-teal-700:hover {
    --gradient-via-color: #036672;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(3, 102, 114, 0));
  }
  .xl\\:hover\\:via-teal-800:hover {
    --gradient-via-color: #05505c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(5, 80, 92, 0));
  }
  .xl\\:hover\\:via-teal-900:hover {
    --gradient-via-color: #014451;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(1, 68, 81, 0));
  }
  .xl\\:hover\\:via-blue-50:hover {
    --gradient-via-color: #ebf5ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(235, 245, 255, 0));
  }
  .xl\\:hover\\:via-blue-100:hover {
    --gradient-via-color: #e1effe;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(225, 239, 254, 0));
  }
  .xl\\:hover\\:via-blue-200:hover {
    --gradient-via-color: #c3ddfd;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(195, 221, 253, 0));
  }
  .xl\\:hover\\:via-blue-300:hover {
    --gradient-via-color: #a4cafe;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(164, 202, 254, 0));
  }
  .xl\\:hover\\:via-blue-400:hover {
    --gradient-via-color: #76a9fa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(118, 169, 250, 0));
  }
  .xl\\:hover\\:via-blue-500:hover {
    --gradient-via-color: #3f83f8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(63, 131, 248, 0));
  }
  .xl\\:hover\\:via-blue-600:hover {
    --gradient-via-color: #1c64f2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(28, 100, 242, 0));
  }
  .xl\\:hover\\:via-blue-700:hover {
    --gradient-via-color: #1a56db;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(26, 86, 219, 0));
  }
  .xl\\:hover\\:via-blue-800:hover {
    --gradient-via-color: #1e429f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(30, 66, 159, 0));
  }
  .xl\\:hover\\:via-blue-900:hover {
    --gradient-via-color: #233876;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(35, 56, 118, 0));
  }
  .xl\\:hover\\:via-indigo-50:hover {
    --gradient-via-color: #f0f5ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(240, 245, 255, 0));
  }
  .xl\\:hover\\:via-indigo-100:hover {
    --gradient-via-color: #e5edff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(229, 237, 255, 0));
  }
  .xl\\:hover\\:via-indigo-200:hover {
    --gradient-via-color: #cddbfe;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(205, 219, 254, 0));
  }
  .xl\\:hover\\:via-indigo-300:hover {
    --gradient-via-color: #b4c6fc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(180, 198, 252, 0));
  }
  .xl\\:hover\\:via-indigo-400:hover {
    --gradient-via-color: #8da2fb;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(141, 162, 251, 0));
  }
  .xl\\:hover\\:via-indigo-500:hover {
    --gradient-via-color: #6875f5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(104, 117, 245, 0));
  }
  .xl\\:hover\\:via-indigo-600:hover {
    --gradient-via-color: #5850ec;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(88, 80, 236, 0));
  }
  .xl\\:hover\\:via-indigo-700:hover {
    --gradient-via-color: #5145cd;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(81, 69, 205, 0));
  }
  .xl\\:hover\\:via-indigo-800:hover {
    --gradient-via-color: #42389d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(66, 56, 157, 0));
  }
  .xl\\:hover\\:via-indigo-900:hover {
    --gradient-via-color: #362f78;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(54, 47, 120, 0));
  }
  .xl\\:hover\\:via-purple-50:hover {
    --gradient-via-color: #f6f5ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(246, 245, 255, 0));
  }
  .xl\\:hover\\:via-purple-100:hover {
    --gradient-via-color: #edebfe;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(237, 235, 254, 0));
  }
  .xl\\:hover\\:via-purple-200:hover {
    --gradient-via-color: #dcd7fe;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(220, 215, 254, 0));
  }
  .xl\\:hover\\:via-purple-300:hover {
    --gradient-via-color: #cabffd;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(202, 191, 253, 0));
  }
  .xl\\:hover\\:via-purple-400:hover {
    --gradient-via-color: #ac94fa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(172, 148, 250, 0));
  }
  .xl\\:hover\\:via-purple-500:hover {
    --gradient-via-color: #9061f9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(144, 97, 249, 0));
  }
  .xl\\:hover\\:via-purple-600:hover {
    --gradient-via-color: #7e3af2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(126, 58, 242, 0));
  }
  .xl\\:hover\\:via-purple-700:hover {
    --gradient-via-color: #6c2bd9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(108, 43, 217, 0));
  }
  .xl\\:hover\\:via-purple-800:hover {
    --gradient-via-color: #5521b5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(85, 33, 181, 0));
  }
  .xl\\:hover\\:via-purple-900:hover {
    --gradient-via-color: #4a1d96;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(74, 29, 150, 0));
  }
  .xl\\:hover\\:via-pink-50:hover {
    --gradient-via-color: #fdf2f8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 242, 248, 0));
  }
  .xl\\:hover\\:via-pink-100:hover {
    --gradient-via-color: #fce8f3;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(252, 232, 243, 0));
  }
  .xl\\:hover\\:via-pink-200:hover {
    --gradient-via-color: #fad1e8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(250, 209, 232, 0));
  }
  .xl\\:hover\\:via-pink-300:hover {
    --gradient-via-color: #f8b4d9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(248, 180, 217, 0));
  }
  .xl\\:hover\\:via-pink-400:hover {
    --gradient-via-color: #f17eb8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(241, 126, 184, 0));
  }
  .xl\\:hover\\:via-pink-500:hover {
    --gradient-via-color: #e74694;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(231, 70, 148, 0));
  }
  .xl\\:hover\\:via-pink-600:hover {
    --gradient-via-color: #d61f69;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(214, 31, 105, 0));
  }
  .xl\\:hover\\:via-pink-700:hover {
    --gradient-via-color: #bf125d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(191, 18, 93, 0));
  }
  .xl\\:hover\\:via-pink-800:hover {
    --gradient-via-color: #99154b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(153, 21, 75, 0));
  }
  .xl\\:hover\\:via-pink-900:hover {
    --gradient-via-color: #751a3d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(117, 26, 61, 0));
  }
  .xl\\:hover\\:via-cool-gray-50:hover {
    --gradient-via-color: #f8fafc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(248, 250, 252, 0));
  }
  .xl\\:hover\\:via-cool-gray-100:hover {
    --gradient-via-color: #f1f5f9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(241, 245, 249, 0));
  }
  .xl\\:hover\\:via-cool-gray-200:hover {
    --gradient-via-color: #e2e8f0;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(226, 232, 240, 0));
  }
  .xl\\:hover\\:via-cool-gray-300:hover {
    --gradient-via-color: #cfd8e3;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(207, 216, 227, 0));
  }
  .xl\\:hover\\:via-cool-gray-400:hover {
    --gradient-via-color: #97a6ba;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(151, 166, 186, 0));
  }
  .xl\\:hover\\:via-cool-gray-500:hover {
    --gradient-via-color: #64748b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(100, 116, 139, 0));
  }
  .xl\\:hover\\:via-cool-gray-600:hover {
    --gradient-via-color: #475569;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(71, 85, 105, 0));
  }
  .xl\\:hover\\:via-cool-gray-700:hover {
    --gradient-via-color: #364152;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(54, 65, 82, 0));
  }
  .xl\\:hover\\:via-cool-gray-800:hover {
    --gradient-via-color: #27303f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(39, 48, 63, 0));
  }
  .xl\\:hover\\:via-cool-gray-900:hover {
    --gradient-via-color: #1a202e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(26, 32, 46, 0));
  }
  .xl\\:hover\\:to-current:hover {
    --gradient-to-color: currentColor;
  }
  .xl\\:hover\\:to-transparent:hover {
    --gradient-to-color: transparent;
  }
  .xl\\:hover\\:to-white:hover {
    --gradient-to-color: #ffffff;
  }
  .xl\\:hover\\:to-black:hover {
    --gradient-to-color: #000000;
  }
  .xl\\:hover\\:to-gray-50:hover {
    --gradient-to-color: #f9fafb;
  }
  .xl\\:hover\\:to-gray-100:hover {
    --gradient-to-color: #f4f5f7;
  }
  .xl\\:hover\\:to-gray-200:hover {
    --gradient-to-color: #e5e7eb;
  }
  .xl\\:hover\\:to-gray-300:hover {
    --gradient-to-color: #d2d6dc;
  }
  .xl\\:hover\\:to-gray-400:hover {
    --gradient-to-color: #9fa6b2;
  }
  .xl\\:hover\\:to-gray-500:hover {
    --gradient-to-color: #6b7280;
  }
  .xl\\:hover\\:to-gray-600:hover {
    --gradient-to-color: #4b5563;
  }
  .xl\\:hover\\:to-gray-700:hover {
    --gradient-to-color: #374151;
  }
  .xl\\:hover\\:to-gray-800:hover {
    --gradient-to-color: #252f3f;
  }
  .xl\\:hover\\:to-gray-900:hover {
    --gradient-to-color: #161e2e;
  }
  .xl\\:hover\\:to-red-50:hover {
    --gradient-to-color: #fdf2f2;
  }
  .xl\\:hover\\:to-red-100:hover {
    --gradient-to-color: #fde8e8;
  }
  .xl\\:hover\\:to-red-200:hover {
    --gradient-to-color: #fbd5d5;
  }
  .xl\\:hover\\:to-red-300:hover {
    --gradient-to-color: #f8b4b4;
  }
  .xl\\:hover\\:to-red-400:hover {
    --gradient-to-color: #f98080;
  }
  .xl\\:hover\\:to-red-500:hover {
    --gradient-to-color: #f05252;
  }
  .xl\\:hover\\:to-red-600:hover {
    --gradient-to-color: #e02424;
  }
  .xl\\:hover\\:to-red-700:hover {
    --gradient-to-color: #c81e1e;
  }
  .xl\\:hover\\:to-red-800:hover {
    --gradient-to-color: #9b1c1c;
  }
  .xl\\:hover\\:to-red-900:hover {
    --gradient-to-color: #771d1d;
  }
  .xl\\:hover\\:to-orange-50:hover {
    --gradient-to-color: #fff8f1;
  }
  .xl\\:hover\\:to-orange-100:hover {
    --gradient-to-color: #feecdc;
  }
  .xl\\:hover\\:to-orange-200:hover {
    --gradient-to-color: #fcd9bd;
  }
  .xl\\:hover\\:to-orange-300:hover {
    --gradient-to-color: #fdba8c;
  }
  .xl\\:hover\\:to-orange-400:hover {
    --gradient-to-color: #ff8a4c;
  }
  .xl\\:hover\\:to-orange-500:hover {
    --gradient-to-color: #ff5a1f;
  }
  .xl\\:hover\\:to-orange-600:hover {
    --gradient-to-color: #d03801;
  }
  .xl\\:hover\\:to-orange-700:hover {
    --gradient-to-color: #b43403;
  }
  .xl\\:hover\\:to-orange-800:hover {
    --gradient-to-color: #8a2c0d;
  }
  .xl\\:hover\\:to-orange-900:hover {
    --gradient-to-color: #73230d;
  }
  .xl\\:hover\\:to-yellow-50:hover {
    --gradient-to-color: #fdfdea;
  }
  .xl\\:hover\\:to-yellow-100:hover {
    --gradient-to-color: #fdf6b2;
  }
  .xl\\:hover\\:to-yellow-200:hover {
    --gradient-to-color: #fce96a;
  }
  .xl\\:hover\\:to-yellow-300:hover {
    --gradient-to-color: #faca15;
  }
  .xl\\:hover\\:to-yellow-400:hover {
    --gradient-to-color: #e3a008;
  }
  .xl\\:hover\\:to-yellow-500:hover {
    --gradient-to-color: #c27803;
  }
  .xl\\:hover\\:to-yellow-600:hover {
    --gradient-to-color: #9f580a;
  }
  .xl\\:hover\\:to-yellow-700:hover {
    --gradient-to-color: #8e4b10;
  }
  .xl\\:hover\\:to-yellow-800:hover {
    --gradient-to-color: #723b13;
  }
  .xl\\:hover\\:to-yellow-900:hover {
    --gradient-to-color: #633112;
  }
  .xl\\:hover\\:to-green-50:hover {
    --gradient-to-color: #f3faf7;
  }
  .xl\\:hover\\:to-green-100:hover {
    --gradient-to-color: #def7ec;
  }
  .xl\\:hover\\:to-green-200:hover {
    --gradient-to-color: #bcf0da;
  }
  .xl\\:hover\\:to-green-300:hover {
    --gradient-to-color: #84e1bc;
  }
  .xl\\:hover\\:to-green-400:hover {
    --gradient-to-color: #31c48d;
  }
  .xl\\:hover\\:to-green-500:hover {
    --gradient-to-color: #0e9f6e;
  }
  .xl\\:hover\\:to-green-600:hover {
    --gradient-to-color: #057a55;
  }
  .xl\\:hover\\:to-green-700:hover {
    --gradient-to-color: #046c4e;
  }
  .xl\\:hover\\:to-green-800:hover {
    --gradient-to-color: #03543f;
  }
  .xl\\:hover\\:to-green-900:hover {
    --gradient-to-color: #014737;
  }
  .xl\\:hover\\:to-teal-50:hover {
    --gradient-to-color: #edfafa;
  }
  .xl\\:hover\\:to-teal-100:hover {
    --gradient-to-color: #d5f5f6;
  }
  .xl\\:hover\\:to-teal-200:hover {
    --gradient-to-color: #afecef;
  }
  .xl\\:hover\\:to-teal-300:hover {
    --gradient-to-color: #7edce2;
  }
  .xl\\:hover\\:to-teal-400:hover {
    --gradient-to-color: #16bdca;
  }
  .xl\\:hover\\:to-teal-500:hover {
    --gradient-to-color: #0694a2;
  }
  .xl\\:hover\\:to-teal-600:hover {
    --gradient-to-color: #047481;
  }
  .xl\\:hover\\:to-teal-700:hover {
    --gradient-to-color: #036672;
  }
  .xl\\:hover\\:to-teal-800:hover {
    --gradient-to-color: #05505c;
  }
  .xl\\:hover\\:to-teal-900:hover {
    --gradient-to-color: #014451;
  }
  .xl\\:hover\\:to-blue-50:hover {
    --gradient-to-color: #ebf5ff;
  }
  .xl\\:hover\\:to-blue-100:hover {
    --gradient-to-color: #e1effe;
  }
  .xl\\:hover\\:to-blue-200:hover {
    --gradient-to-color: #c3ddfd;
  }
  .xl\\:hover\\:to-blue-300:hover {
    --gradient-to-color: #a4cafe;
  }
  .xl\\:hover\\:to-blue-400:hover {
    --gradient-to-color: #76a9fa;
  }
  .xl\\:hover\\:to-blue-500:hover {
    --gradient-to-color: #3f83f8;
  }
  .xl\\:hover\\:to-blue-600:hover {
    --gradient-to-color: #1c64f2;
  }
  .xl\\:hover\\:to-blue-700:hover {
    --gradient-to-color: #1a56db;
  }
  .xl\\:hover\\:to-blue-800:hover {
    --gradient-to-color: #1e429f;
  }
  .xl\\:hover\\:to-blue-900:hover {
    --gradient-to-color: #233876;
  }
  .xl\\:hover\\:to-indigo-50:hover {
    --gradient-to-color: #f0f5ff;
  }
  .xl\\:hover\\:to-indigo-100:hover {
    --gradient-to-color: #e5edff;
  }
  .xl\\:hover\\:to-indigo-200:hover {
    --gradient-to-color: #cddbfe;
  }
  .xl\\:hover\\:to-indigo-300:hover {
    --gradient-to-color: #b4c6fc;
  }
  .xl\\:hover\\:to-indigo-400:hover {
    --gradient-to-color: #8da2fb;
  }
  .xl\\:hover\\:to-indigo-500:hover {
    --gradient-to-color: #6875f5;
  }
  .xl\\:hover\\:to-indigo-600:hover {
    --gradient-to-color: #5850ec;
  }
  .xl\\:hover\\:to-indigo-700:hover {
    --gradient-to-color: #5145cd;
  }
  .xl\\:hover\\:to-indigo-800:hover {
    --gradient-to-color: #42389d;
  }
  .xl\\:hover\\:to-indigo-900:hover {
    --gradient-to-color: #362f78;
  }
  .xl\\:hover\\:to-purple-50:hover {
    --gradient-to-color: #f6f5ff;
  }
  .xl\\:hover\\:to-purple-100:hover {
    --gradient-to-color: #edebfe;
  }
  .xl\\:hover\\:to-purple-200:hover {
    --gradient-to-color: #dcd7fe;
  }
  .xl\\:hover\\:to-purple-300:hover {
    --gradient-to-color: #cabffd;
  }
  .xl\\:hover\\:to-purple-400:hover {
    --gradient-to-color: #ac94fa;
  }
  .xl\\:hover\\:to-purple-500:hover {
    --gradient-to-color: #9061f9;
  }
  .xl\\:hover\\:to-purple-600:hover {
    --gradient-to-color: #7e3af2;
  }
  .xl\\:hover\\:to-purple-700:hover {
    --gradient-to-color: #6c2bd9;
  }
  .xl\\:hover\\:to-purple-800:hover {
    --gradient-to-color: #5521b5;
  }
  .xl\\:hover\\:to-purple-900:hover {
    --gradient-to-color: #4a1d96;
  }
  .xl\\:hover\\:to-pink-50:hover {
    --gradient-to-color: #fdf2f8;
  }
  .xl\\:hover\\:to-pink-100:hover {
    --gradient-to-color: #fce8f3;
  }
  .xl\\:hover\\:to-pink-200:hover {
    --gradient-to-color: #fad1e8;
  }
  .xl\\:hover\\:to-pink-300:hover {
    --gradient-to-color: #f8b4d9;
  }
  .xl\\:hover\\:to-pink-400:hover {
    --gradient-to-color: #f17eb8;
  }
  .xl\\:hover\\:to-pink-500:hover {
    --gradient-to-color: #e74694;
  }
  .xl\\:hover\\:to-pink-600:hover {
    --gradient-to-color: #d61f69;
  }
  .xl\\:hover\\:to-pink-700:hover {
    --gradient-to-color: #bf125d;
  }
  .xl\\:hover\\:to-pink-800:hover {
    --gradient-to-color: #99154b;
  }
  .xl\\:hover\\:to-pink-900:hover {
    --gradient-to-color: #751a3d;
  }
  .xl\\:hover\\:to-cool-gray-50:hover {
    --gradient-to-color: #f8fafc;
  }
  .xl\\:hover\\:to-cool-gray-100:hover {
    --gradient-to-color: #f1f5f9;
  }
  .xl\\:hover\\:to-cool-gray-200:hover {
    --gradient-to-color: #e2e8f0;
  }
  .xl\\:hover\\:to-cool-gray-300:hover {
    --gradient-to-color: #cfd8e3;
  }
  .xl\\:hover\\:to-cool-gray-400:hover {
    --gradient-to-color: #97a6ba;
  }
  .xl\\:hover\\:to-cool-gray-500:hover {
    --gradient-to-color: #64748b;
  }
  .xl\\:hover\\:to-cool-gray-600:hover {
    --gradient-to-color: #475569;
  }
  .xl\\:hover\\:to-cool-gray-700:hover {
    --gradient-to-color: #364152;
  }
  .xl\\:hover\\:to-cool-gray-800:hover {
    --gradient-to-color: #27303f;
  }
  .xl\\:hover\\:to-cool-gray-900:hover {
    --gradient-to-color: #1a202e;
  }
  .xl\\:focus\\:from-current:focus {
    --gradient-from-color: currentColor;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }
  .xl\\:focus\\:from-transparent:focus {
    --gradient-from-color: transparent;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  }
  .xl\\:focus\\:from-white:focus {
    --gradient-from-color: #ffffff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }
  .xl\\:focus\\:from-black:focus {
    --gradient-from-color: #000000;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  }
  .xl\\:focus\\:from-gray-50:focus {
    --gradient-from-color: #f9fafb;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(249, 250, 251, 0));
  }
  .xl\\:focus\\:from-gray-100:focus {
    --gradient-from-color: #f4f5f7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(244, 245, 247, 0));
  }
  .xl\\:focus\\:from-gray-200:focus {
    --gradient-from-color: #e5e7eb;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(229, 231, 235, 0));
  }
  .xl\\:focus\\:from-gray-300:focus {
    --gradient-from-color: #d2d6dc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(210, 214, 220, 0));
  }
  .xl\\:focus\\:from-gray-400:focus {
    --gradient-from-color: #9fa6b2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(159, 166, 178, 0));
  }
  .xl\\:focus\\:from-gray-500:focus {
    --gradient-from-color: #6b7280;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(107, 114, 128, 0));
  }
  .xl\\:focus\\:from-gray-600:focus {
    --gradient-from-color: #4b5563;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(75, 85, 99, 0));
  }
  .xl\\:focus\\:from-gray-700:focus {
    --gradient-from-color: #374151;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(55, 65, 81, 0));
  }
  .xl\\:focus\\:from-gray-800:focus {
    --gradient-from-color: #252f3f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(37, 47, 63, 0));
  }
  .xl\\:focus\\:from-gray-900:focus {
    --gradient-from-color: #161e2e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(22, 30, 46, 0));
  }
  .xl\\:focus\\:from-red-50:focus {
    --gradient-from-color: #fdf2f2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 242, 242, 0));
  }
  .xl\\:focus\\:from-red-100:focus {
    --gradient-from-color: #fde8e8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 232, 232, 0));
  }
  .xl\\:focus\\:from-red-200:focus {
    --gradient-from-color: #fbd5d5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(251, 213, 213, 0));
  }
  .xl\\:focus\\:from-red-300:focus {
    --gradient-from-color: #f8b4b4;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(248, 180, 180, 0));
  }
  .xl\\:focus\\:from-red-400:focus {
    --gradient-from-color: #f98080;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(249, 128, 128, 0));
  }
  .xl\\:focus\\:from-red-500:focus {
    --gradient-from-color: #f05252;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(240, 82, 82, 0));
  }
  .xl\\:focus\\:from-red-600:focus {
    --gradient-from-color: #e02424;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(224, 36, 36, 0));
  }
  .xl\\:focus\\:from-red-700:focus {
    --gradient-from-color: #c81e1e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(200, 30, 30, 0));
  }
  .xl\\:focus\\:from-red-800:focus {
    --gradient-from-color: #9b1c1c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(155, 28, 28, 0));
  }
  .xl\\:focus\\:from-red-900:focus {
    --gradient-from-color: #771d1d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(119, 29, 29, 0));
  }
  .xl\\:focus\\:from-orange-50:focus {
    --gradient-from-color: #fff8f1;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 248, 241, 0));
  }
  .xl\\:focus\\:from-orange-100:focus {
    --gradient-from-color: #feecdc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 236, 220, 0));
  }
  .xl\\:focus\\:from-orange-200:focus {
    --gradient-from-color: #fcd9bd;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(252, 217, 189, 0));
  }
  .xl\\:focus\\:from-orange-300:focus {
    --gradient-from-color: #fdba8c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 186, 140, 0));
  }
  .xl\\:focus\\:from-orange-400:focus {
    --gradient-from-color: #ff8a4c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 138, 76, 0));
  }
  .xl\\:focus\\:from-orange-500:focus {
    --gradient-from-color: #ff5a1f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 90, 31, 0));
  }
  .xl\\:focus\\:from-orange-600:focus {
    --gradient-from-color: #d03801;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(208, 56, 1, 0));
  }
  .xl\\:focus\\:from-orange-700:focus {
    --gradient-from-color: #b43403;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(180, 52, 3, 0));
  }
  .xl\\:focus\\:from-orange-800:focus {
    --gradient-from-color: #8a2c0d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(138, 44, 13, 0));
  }
  .xl\\:focus\\:from-orange-900:focus {
    --gradient-from-color: #73230d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(115, 35, 13, 0));
  }
  .xl\\:focus\\:from-yellow-50:focus {
    --gradient-from-color: #fdfdea;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 253, 234, 0));
  }
  .xl\\:focus\\:from-yellow-100:focus {
    --gradient-from-color: #fdf6b2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 246, 178, 0));
  }
  .xl\\:focus\\:from-yellow-200:focus {
    --gradient-from-color: #fce96a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(252, 233, 106, 0));
  }
  .xl\\:focus\\:from-yellow-300:focus {
    --gradient-from-color: #faca15;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(250, 202, 21, 0));
  }
  .xl\\:focus\\:from-yellow-400:focus {
    --gradient-from-color: #e3a008;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(227, 160, 8, 0));
  }
  .xl\\:focus\\:from-yellow-500:focus {
    --gradient-from-color: #c27803;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(194, 120, 3, 0));
  }
  .xl\\:focus\\:from-yellow-600:focus {
    --gradient-from-color: #9f580a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(159, 88, 10, 0));
  }
  .xl\\:focus\\:from-yellow-700:focus {
    --gradient-from-color: #8e4b10;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(142, 75, 16, 0));
  }
  .xl\\:focus\\:from-yellow-800:focus {
    --gradient-from-color: #723b13;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(114, 59, 19, 0));
  }
  .xl\\:focus\\:from-yellow-900:focus {
    --gradient-from-color: #633112;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(99, 49, 18, 0));
  }
  .xl\\:focus\\:from-green-50:focus {
    --gradient-from-color: #f3faf7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(243, 250, 247, 0));
  }
  .xl\\:focus\\:from-green-100:focus {
    --gradient-from-color: #def7ec;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(222, 247, 236, 0));
  }
  .xl\\:focus\\:from-green-200:focus {
    --gradient-from-color: #bcf0da;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(188, 240, 218, 0));
  }
  .xl\\:focus\\:from-green-300:focus {
    --gradient-from-color: #84e1bc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(132, 225, 188, 0));
  }
  .xl\\:focus\\:from-green-400:focus {
    --gradient-from-color: #31c48d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(49, 196, 141, 0));
  }
  .xl\\:focus\\:from-green-500:focus {
    --gradient-from-color: #0e9f6e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(14, 159, 110, 0));
  }
  .xl\\:focus\\:from-green-600:focus {
    --gradient-from-color: #057a55;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(5, 122, 85, 0));
  }
  .xl\\:focus\\:from-green-700:focus {
    --gradient-from-color: #046c4e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(4, 108, 78, 0));
  }
  .xl\\:focus\\:from-green-800:focus {
    --gradient-from-color: #03543f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(3, 84, 63, 0));
  }
  .xl\\:focus\\:from-green-900:focus {
    --gradient-from-color: #014737;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(1, 71, 55, 0));
  }
  .xl\\:focus\\:from-teal-50:focus {
    --gradient-from-color: #edfafa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(237, 250, 250, 0));
  }
  .xl\\:focus\\:from-teal-100:focus {
    --gradient-from-color: #d5f5f6;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(213, 245, 246, 0));
  }
  .xl\\:focus\\:from-teal-200:focus {
    --gradient-from-color: #afecef;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(175, 236, 239, 0));
  }
  .xl\\:focus\\:from-teal-300:focus {
    --gradient-from-color: #7edce2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(126, 220, 226, 0));
  }
  .xl\\:focus\\:from-teal-400:focus {
    --gradient-from-color: #16bdca;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(22, 189, 202, 0));
  }
  .xl\\:focus\\:from-teal-500:focus {
    --gradient-from-color: #0694a2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(6, 148, 162, 0));
  }
  .xl\\:focus\\:from-teal-600:focus {
    --gradient-from-color: #047481;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(4, 116, 129, 0));
  }
  .xl\\:focus\\:from-teal-700:focus {
    --gradient-from-color: #036672;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(3, 102, 114, 0));
  }
  .xl\\:focus\\:from-teal-800:focus {
    --gradient-from-color: #05505c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(5, 80, 92, 0));
  }
  .xl\\:focus\\:from-teal-900:focus {
    --gradient-from-color: #014451;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(1, 68, 81, 0));
  }
  .xl\\:focus\\:from-blue-50:focus {
    --gradient-from-color: #ebf5ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(235, 245, 255, 0));
  }
  .xl\\:focus\\:from-blue-100:focus {
    --gradient-from-color: #e1effe;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(225, 239, 254, 0));
  }
  .xl\\:focus\\:from-blue-200:focus {
    --gradient-from-color: #c3ddfd;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(195, 221, 253, 0));
  }
  .xl\\:focus\\:from-blue-300:focus {
    --gradient-from-color: #a4cafe;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(164, 202, 254, 0));
  }
  .xl\\:focus\\:from-blue-400:focus {
    --gradient-from-color: #76a9fa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(118, 169, 250, 0));
  }
  .xl\\:focus\\:from-blue-500:focus {
    --gradient-from-color: #3f83f8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(63, 131, 248, 0));
  }
  .xl\\:focus\\:from-blue-600:focus {
    --gradient-from-color: #1c64f2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(28, 100, 242, 0));
  }
  .xl\\:focus\\:from-blue-700:focus {
    --gradient-from-color: #1a56db;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(26, 86, 219, 0));
  }
  .xl\\:focus\\:from-blue-800:focus {
    --gradient-from-color: #1e429f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(30, 66, 159, 0));
  }
  .xl\\:focus\\:from-blue-900:focus {
    --gradient-from-color: #233876;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(35, 56, 118, 0));
  }
  .xl\\:focus\\:from-indigo-50:focus {
    --gradient-from-color: #f0f5ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(240, 245, 255, 0));
  }
  .xl\\:focus\\:from-indigo-100:focus {
    --gradient-from-color: #e5edff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(229, 237, 255, 0));
  }
  .xl\\:focus\\:from-indigo-200:focus {
    --gradient-from-color: #cddbfe;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(205, 219, 254, 0));
  }
  .xl\\:focus\\:from-indigo-300:focus {
    --gradient-from-color: #b4c6fc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(180, 198, 252, 0));
  }
  .xl\\:focus\\:from-indigo-400:focus {
    --gradient-from-color: #8da2fb;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(141, 162, 251, 0));
  }
  .xl\\:focus\\:from-indigo-500:focus {
    --gradient-from-color: #6875f5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(104, 117, 245, 0));
  }
  .xl\\:focus\\:from-indigo-600:focus {
    --gradient-from-color: #5850ec;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(88, 80, 236, 0));
  }
  .xl\\:focus\\:from-indigo-700:focus {
    --gradient-from-color: #5145cd;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(81, 69, 205, 0));
  }
  .xl\\:focus\\:from-indigo-800:focus {
    --gradient-from-color: #42389d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(66, 56, 157, 0));
  }
  .xl\\:focus\\:from-indigo-900:focus {
    --gradient-from-color: #362f78;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(54, 47, 120, 0));
  }
  .xl\\:focus\\:from-purple-50:focus {
    --gradient-from-color: #f6f5ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(246, 245, 255, 0));
  }
  .xl\\:focus\\:from-purple-100:focus {
    --gradient-from-color: #edebfe;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(237, 235, 254, 0));
  }
  .xl\\:focus\\:from-purple-200:focus {
    --gradient-from-color: #dcd7fe;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(220, 215, 254, 0));
  }
  .xl\\:focus\\:from-purple-300:focus {
    --gradient-from-color: #cabffd;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(202, 191, 253, 0));
  }
  .xl\\:focus\\:from-purple-400:focus {
    --gradient-from-color: #ac94fa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(172, 148, 250, 0));
  }
  .xl\\:focus\\:from-purple-500:focus {
    --gradient-from-color: #9061f9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(144, 97, 249, 0));
  }
  .xl\\:focus\\:from-purple-600:focus {
    --gradient-from-color: #7e3af2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(126, 58, 242, 0));
  }
  .xl\\:focus\\:from-purple-700:focus {
    --gradient-from-color: #6c2bd9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(108, 43, 217, 0));
  }
  .xl\\:focus\\:from-purple-800:focus {
    --gradient-from-color: #5521b5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(85, 33, 181, 0));
  }
  .xl\\:focus\\:from-purple-900:focus {
    --gradient-from-color: #4a1d96;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(74, 29, 150, 0));
  }
  .xl\\:focus\\:from-pink-50:focus {
    --gradient-from-color: #fdf2f8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 242, 248, 0));
  }
  .xl\\:focus\\:from-pink-100:focus {
    --gradient-from-color: #fce8f3;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(252, 232, 243, 0));
  }
  .xl\\:focus\\:from-pink-200:focus {
    --gradient-from-color: #fad1e8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(250, 209, 232, 0));
  }
  .xl\\:focus\\:from-pink-300:focus {
    --gradient-from-color: #f8b4d9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(248, 180, 217, 0));
  }
  .xl\\:focus\\:from-pink-400:focus {
    --gradient-from-color: #f17eb8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(241, 126, 184, 0));
  }
  .xl\\:focus\\:from-pink-500:focus {
    --gradient-from-color: #e74694;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(231, 70, 148, 0));
  }
  .xl\\:focus\\:from-pink-600:focus {
    --gradient-from-color: #d61f69;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(214, 31, 105, 0));
  }
  .xl\\:focus\\:from-pink-700:focus {
    --gradient-from-color: #bf125d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(191, 18, 93, 0));
  }
  .xl\\:focus\\:from-pink-800:focus {
    --gradient-from-color: #99154b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(153, 21, 75, 0));
  }
  .xl\\:focus\\:from-pink-900:focus {
    --gradient-from-color: #751a3d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(117, 26, 61, 0));
  }
  .xl\\:focus\\:from-cool-gray-50:focus {
    --gradient-from-color: #f8fafc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(248, 250, 252, 0));
  }
  .xl\\:focus\\:from-cool-gray-100:focus {
    --gradient-from-color: #f1f5f9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(241, 245, 249, 0));
  }
  .xl\\:focus\\:from-cool-gray-200:focus {
    --gradient-from-color: #e2e8f0;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(226, 232, 240, 0));
  }
  .xl\\:focus\\:from-cool-gray-300:focus {
    --gradient-from-color: #cfd8e3;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(207, 216, 227, 0));
  }
  .xl\\:focus\\:from-cool-gray-400:focus {
    --gradient-from-color: #97a6ba;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(151, 166, 186, 0));
  }
  .xl\\:focus\\:from-cool-gray-500:focus {
    --gradient-from-color: #64748b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(100, 116, 139, 0));
  }
  .xl\\:focus\\:from-cool-gray-600:focus {
    --gradient-from-color: #475569;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(71, 85, 105, 0));
  }
  .xl\\:focus\\:from-cool-gray-700:focus {
    --gradient-from-color: #364152;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(54, 65, 82, 0));
  }
  .xl\\:focus\\:from-cool-gray-800:focus {
    --gradient-from-color: #27303f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(39, 48, 63, 0));
  }
  .xl\\:focus\\:from-cool-gray-900:focus {
    --gradient-from-color: #1a202e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(26, 32, 46, 0));
  }
  .xl\\:focus\\:via-current:focus {
    --gradient-via-color: currentColor;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }
  .xl\\:focus\\:via-transparent:focus {
    --gradient-via-color: transparent;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  }
  .xl\\:focus\\:via-white:focus {
    --gradient-via-color: #ffffff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }
  .xl\\:focus\\:via-black:focus {
    --gradient-via-color: #000000;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  }
  .xl\\:focus\\:via-gray-50:focus {
    --gradient-via-color: #f9fafb;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(249, 250, 251, 0));
  }
  .xl\\:focus\\:via-gray-100:focus {
    --gradient-via-color: #f4f5f7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(244, 245, 247, 0));
  }
  .xl\\:focus\\:via-gray-200:focus {
    --gradient-via-color: #e5e7eb;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(229, 231, 235, 0));
  }
  .xl\\:focus\\:via-gray-300:focus {
    --gradient-via-color: #d2d6dc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(210, 214, 220, 0));
  }
  .xl\\:focus\\:via-gray-400:focus {
    --gradient-via-color: #9fa6b2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(159, 166, 178, 0));
  }
  .xl\\:focus\\:via-gray-500:focus {
    --gradient-via-color: #6b7280;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(107, 114, 128, 0));
  }
  .xl\\:focus\\:via-gray-600:focus {
    --gradient-via-color: #4b5563;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(75, 85, 99, 0));
  }
  .xl\\:focus\\:via-gray-700:focus {
    --gradient-via-color: #374151;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(55, 65, 81, 0));
  }
  .xl\\:focus\\:via-gray-800:focus {
    --gradient-via-color: #252f3f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(37, 47, 63, 0));
  }
  .xl\\:focus\\:via-gray-900:focus {
    --gradient-via-color: #161e2e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(22, 30, 46, 0));
  }
  .xl\\:focus\\:via-red-50:focus {
    --gradient-via-color: #fdf2f2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 242, 242, 0));
  }
  .xl\\:focus\\:via-red-100:focus {
    --gradient-via-color: #fde8e8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 232, 232, 0));
  }
  .xl\\:focus\\:via-red-200:focus {
    --gradient-via-color: #fbd5d5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(251, 213, 213, 0));
  }
  .xl\\:focus\\:via-red-300:focus {
    --gradient-via-color: #f8b4b4;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(248, 180, 180, 0));
  }
  .xl\\:focus\\:via-red-400:focus {
    --gradient-via-color: #f98080;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(249, 128, 128, 0));
  }
  .xl\\:focus\\:via-red-500:focus {
    --gradient-via-color: #f05252;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(240, 82, 82, 0));
  }
  .xl\\:focus\\:via-red-600:focus {
    --gradient-via-color: #e02424;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(224, 36, 36, 0));
  }
  .xl\\:focus\\:via-red-700:focus {
    --gradient-via-color: #c81e1e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(200, 30, 30, 0));
  }
  .xl\\:focus\\:via-red-800:focus {
    --gradient-via-color: #9b1c1c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(155, 28, 28, 0));
  }
  .xl\\:focus\\:via-red-900:focus {
    --gradient-via-color: #771d1d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(119, 29, 29, 0));
  }
  .xl\\:focus\\:via-orange-50:focus {
    --gradient-via-color: #fff8f1;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 248, 241, 0));
  }
  .xl\\:focus\\:via-orange-100:focus {
    --gradient-via-color: #feecdc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 236, 220, 0));
  }
  .xl\\:focus\\:via-orange-200:focus {
    --gradient-via-color: #fcd9bd;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(252, 217, 189, 0));
  }
  .xl\\:focus\\:via-orange-300:focus {
    --gradient-via-color: #fdba8c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 186, 140, 0));
  }
  .xl\\:focus\\:via-orange-400:focus {
    --gradient-via-color: #ff8a4c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 138, 76, 0));
  }
  .xl\\:focus\\:via-orange-500:focus {
    --gradient-via-color: #ff5a1f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 90, 31, 0));
  }
  .xl\\:focus\\:via-orange-600:focus {
    --gradient-via-color: #d03801;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(208, 56, 1, 0));
  }
  .xl\\:focus\\:via-orange-700:focus {
    --gradient-via-color: #b43403;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(180, 52, 3, 0));
  }
  .xl\\:focus\\:via-orange-800:focus {
    --gradient-via-color: #8a2c0d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(138, 44, 13, 0));
  }
  .xl\\:focus\\:via-orange-900:focus {
    --gradient-via-color: #73230d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(115, 35, 13, 0));
  }
  .xl\\:focus\\:via-yellow-50:focus {
    --gradient-via-color: #fdfdea;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 253, 234, 0));
  }
  .xl\\:focus\\:via-yellow-100:focus {
    --gradient-via-color: #fdf6b2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 246, 178, 0));
  }
  .xl\\:focus\\:via-yellow-200:focus {
    --gradient-via-color: #fce96a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(252, 233, 106, 0));
  }
  .xl\\:focus\\:via-yellow-300:focus {
    --gradient-via-color: #faca15;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(250, 202, 21, 0));
  }
  .xl\\:focus\\:via-yellow-400:focus {
    --gradient-via-color: #e3a008;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(227, 160, 8, 0));
  }
  .xl\\:focus\\:via-yellow-500:focus {
    --gradient-via-color: #c27803;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(194, 120, 3, 0));
  }
  .xl\\:focus\\:via-yellow-600:focus {
    --gradient-via-color: #9f580a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(159, 88, 10, 0));
  }
  .xl\\:focus\\:via-yellow-700:focus {
    --gradient-via-color: #8e4b10;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(142, 75, 16, 0));
  }
  .xl\\:focus\\:via-yellow-800:focus {
    --gradient-via-color: #723b13;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(114, 59, 19, 0));
  }
  .xl\\:focus\\:via-yellow-900:focus {
    --gradient-via-color: #633112;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(99, 49, 18, 0));
  }
  .xl\\:focus\\:via-green-50:focus {
    --gradient-via-color: #f3faf7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(243, 250, 247, 0));
  }
  .xl\\:focus\\:via-green-100:focus {
    --gradient-via-color: #def7ec;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(222, 247, 236, 0));
  }
  .xl\\:focus\\:via-green-200:focus {
    --gradient-via-color: #bcf0da;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(188, 240, 218, 0));
  }
  .xl\\:focus\\:via-green-300:focus {
    --gradient-via-color: #84e1bc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(132, 225, 188, 0));
  }
  .xl\\:focus\\:via-green-400:focus {
    --gradient-via-color: #31c48d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(49, 196, 141, 0));
  }
  .xl\\:focus\\:via-green-500:focus {
    --gradient-via-color: #0e9f6e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(14, 159, 110, 0));
  }
  .xl\\:focus\\:via-green-600:focus {
    --gradient-via-color: #057a55;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(5, 122, 85, 0));
  }
  .xl\\:focus\\:via-green-700:focus {
    --gradient-via-color: #046c4e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(4, 108, 78, 0));
  }
  .xl\\:focus\\:via-green-800:focus {
    --gradient-via-color: #03543f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(3, 84, 63, 0));
  }
  .xl\\:focus\\:via-green-900:focus {
    --gradient-via-color: #014737;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(1, 71, 55, 0));
  }
  .xl\\:focus\\:via-teal-50:focus {
    --gradient-via-color: #edfafa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(237, 250, 250, 0));
  }
  .xl\\:focus\\:via-teal-100:focus {
    --gradient-via-color: #d5f5f6;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(213, 245, 246, 0));
  }
  .xl\\:focus\\:via-teal-200:focus {
    --gradient-via-color: #afecef;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(175, 236, 239, 0));
  }
  .xl\\:focus\\:via-teal-300:focus {
    --gradient-via-color: #7edce2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(126, 220, 226, 0));
  }
  .xl\\:focus\\:via-teal-400:focus {
    --gradient-via-color: #16bdca;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(22, 189, 202, 0));
  }
  .xl\\:focus\\:via-teal-500:focus {
    --gradient-via-color: #0694a2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(6, 148, 162, 0));
  }
  .xl\\:focus\\:via-teal-600:focus {
    --gradient-via-color: #047481;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(4, 116, 129, 0));
  }
  .xl\\:focus\\:via-teal-700:focus {
    --gradient-via-color: #036672;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(3, 102, 114, 0));
  }
  .xl\\:focus\\:via-teal-800:focus {
    --gradient-via-color: #05505c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(5, 80, 92, 0));
  }
  .xl\\:focus\\:via-teal-900:focus {
    --gradient-via-color: #014451;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(1, 68, 81, 0));
  }
  .xl\\:focus\\:via-blue-50:focus {
    --gradient-via-color: #ebf5ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(235, 245, 255, 0));
  }
  .xl\\:focus\\:via-blue-100:focus {
    --gradient-via-color: #e1effe;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(225, 239, 254, 0));
  }
  .xl\\:focus\\:via-blue-200:focus {
    --gradient-via-color: #c3ddfd;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(195, 221, 253, 0));
  }
  .xl\\:focus\\:via-blue-300:focus {
    --gradient-via-color: #a4cafe;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(164, 202, 254, 0));
  }
  .xl\\:focus\\:via-blue-400:focus {
    --gradient-via-color: #76a9fa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(118, 169, 250, 0));
  }
  .xl\\:focus\\:via-blue-500:focus {
    --gradient-via-color: #3f83f8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(63, 131, 248, 0));
  }
  .xl\\:focus\\:via-blue-600:focus {
    --gradient-via-color: #1c64f2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(28, 100, 242, 0));
  }
  .xl\\:focus\\:via-blue-700:focus {
    --gradient-via-color: #1a56db;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(26, 86, 219, 0));
  }
  .xl\\:focus\\:via-blue-800:focus {
    --gradient-via-color: #1e429f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(30, 66, 159, 0));
  }
  .xl\\:focus\\:via-blue-900:focus {
    --gradient-via-color: #233876;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(35, 56, 118, 0));
  }
  .xl\\:focus\\:via-indigo-50:focus {
    --gradient-via-color: #f0f5ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(240, 245, 255, 0));
  }
  .xl\\:focus\\:via-indigo-100:focus {
    --gradient-via-color: #e5edff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(229, 237, 255, 0));
  }
  .xl\\:focus\\:via-indigo-200:focus {
    --gradient-via-color: #cddbfe;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(205, 219, 254, 0));
  }
  .xl\\:focus\\:via-indigo-300:focus {
    --gradient-via-color: #b4c6fc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(180, 198, 252, 0));
  }
  .xl\\:focus\\:via-indigo-400:focus {
    --gradient-via-color: #8da2fb;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(141, 162, 251, 0));
  }
  .xl\\:focus\\:via-indigo-500:focus {
    --gradient-via-color: #6875f5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(104, 117, 245, 0));
  }
  .xl\\:focus\\:via-indigo-600:focus {
    --gradient-via-color: #5850ec;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(88, 80, 236, 0));
  }
  .xl\\:focus\\:via-indigo-700:focus {
    --gradient-via-color: #5145cd;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(81, 69, 205, 0));
  }
  .xl\\:focus\\:via-indigo-800:focus {
    --gradient-via-color: #42389d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(66, 56, 157, 0));
  }
  .xl\\:focus\\:via-indigo-900:focus {
    --gradient-via-color: #362f78;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(54, 47, 120, 0));
  }
  .xl\\:focus\\:via-purple-50:focus {
    --gradient-via-color: #f6f5ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(246, 245, 255, 0));
  }
  .xl\\:focus\\:via-purple-100:focus {
    --gradient-via-color: #edebfe;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(237, 235, 254, 0));
  }
  .xl\\:focus\\:via-purple-200:focus {
    --gradient-via-color: #dcd7fe;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(220, 215, 254, 0));
  }
  .xl\\:focus\\:via-purple-300:focus {
    --gradient-via-color: #cabffd;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(202, 191, 253, 0));
  }
  .xl\\:focus\\:via-purple-400:focus {
    --gradient-via-color: #ac94fa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(172, 148, 250, 0));
  }
  .xl\\:focus\\:via-purple-500:focus {
    --gradient-via-color: #9061f9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(144, 97, 249, 0));
  }
  .xl\\:focus\\:via-purple-600:focus {
    --gradient-via-color: #7e3af2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(126, 58, 242, 0));
  }
  .xl\\:focus\\:via-purple-700:focus {
    --gradient-via-color: #6c2bd9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(108, 43, 217, 0));
  }
  .xl\\:focus\\:via-purple-800:focus {
    --gradient-via-color: #5521b5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(85, 33, 181, 0));
  }
  .xl\\:focus\\:via-purple-900:focus {
    --gradient-via-color: #4a1d96;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(74, 29, 150, 0));
  }
  .xl\\:focus\\:via-pink-50:focus {
    --gradient-via-color: #fdf2f8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 242, 248, 0));
  }
  .xl\\:focus\\:via-pink-100:focus {
    --gradient-via-color: #fce8f3;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(252, 232, 243, 0));
  }
  .xl\\:focus\\:via-pink-200:focus {
    --gradient-via-color: #fad1e8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(250, 209, 232, 0));
  }
  .xl\\:focus\\:via-pink-300:focus {
    --gradient-via-color: #f8b4d9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(248, 180, 217, 0));
  }
  .xl\\:focus\\:via-pink-400:focus {
    --gradient-via-color: #f17eb8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(241, 126, 184, 0));
  }
  .xl\\:focus\\:via-pink-500:focus {
    --gradient-via-color: #e74694;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(231, 70, 148, 0));
  }
  .xl\\:focus\\:via-pink-600:focus {
    --gradient-via-color: #d61f69;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(214, 31, 105, 0));
  }
  .xl\\:focus\\:via-pink-700:focus {
    --gradient-via-color: #bf125d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(191, 18, 93, 0));
  }
  .xl\\:focus\\:via-pink-800:focus {
    --gradient-via-color: #99154b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(153, 21, 75, 0));
  }
  .xl\\:focus\\:via-pink-900:focus {
    --gradient-via-color: #751a3d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(117, 26, 61, 0));
  }
  .xl\\:focus\\:via-cool-gray-50:focus {
    --gradient-via-color: #f8fafc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(248, 250, 252, 0));
  }
  .xl\\:focus\\:via-cool-gray-100:focus {
    --gradient-via-color: #f1f5f9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(241, 245, 249, 0));
  }
  .xl\\:focus\\:via-cool-gray-200:focus {
    --gradient-via-color: #e2e8f0;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(226, 232, 240, 0));
  }
  .xl\\:focus\\:via-cool-gray-300:focus {
    --gradient-via-color: #cfd8e3;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(207, 216, 227, 0));
  }
  .xl\\:focus\\:via-cool-gray-400:focus {
    --gradient-via-color: #97a6ba;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(151, 166, 186, 0));
  }
  .xl\\:focus\\:via-cool-gray-500:focus {
    --gradient-via-color: #64748b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(100, 116, 139, 0));
  }
  .xl\\:focus\\:via-cool-gray-600:focus {
    --gradient-via-color: #475569;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(71, 85, 105, 0));
  }
  .xl\\:focus\\:via-cool-gray-700:focus {
    --gradient-via-color: #364152;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(54, 65, 82, 0));
  }
  .xl\\:focus\\:via-cool-gray-800:focus {
    --gradient-via-color: #27303f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(39, 48, 63, 0));
  }
  .xl\\:focus\\:via-cool-gray-900:focus {
    --gradient-via-color: #1a202e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(26, 32, 46, 0));
  }
  .xl\\:focus\\:to-current:focus {
    --gradient-to-color: currentColor;
  }
  .xl\\:focus\\:to-transparent:focus {
    --gradient-to-color: transparent;
  }
  .xl\\:focus\\:to-white:focus {
    --gradient-to-color: #ffffff;
  }
  .xl\\:focus\\:to-black:focus {
    --gradient-to-color: #000000;
  }
  .xl\\:focus\\:to-gray-50:focus {
    --gradient-to-color: #f9fafb;
  }
  .xl\\:focus\\:to-gray-100:focus {
    --gradient-to-color: #f4f5f7;
  }
  .xl\\:focus\\:to-gray-200:focus {
    --gradient-to-color: #e5e7eb;
  }
  .xl\\:focus\\:to-gray-300:focus {
    --gradient-to-color: #d2d6dc;
  }
  .xl\\:focus\\:to-gray-400:focus {
    --gradient-to-color: #9fa6b2;
  }
  .xl\\:focus\\:to-gray-500:focus {
    --gradient-to-color: #6b7280;
  }
  .xl\\:focus\\:to-gray-600:focus {
    --gradient-to-color: #4b5563;
  }
  .xl\\:focus\\:to-gray-700:focus {
    --gradient-to-color: #374151;
  }
  .xl\\:focus\\:to-gray-800:focus {
    --gradient-to-color: #252f3f;
  }
  .xl\\:focus\\:to-gray-900:focus {
    --gradient-to-color: #161e2e;
  }
  .xl\\:focus\\:to-red-50:focus {
    --gradient-to-color: #fdf2f2;
  }
  .xl\\:focus\\:to-red-100:focus {
    --gradient-to-color: #fde8e8;
  }
  .xl\\:focus\\:to-red-200:focus {
    --gradient-to-color: #fbd5d5;
  }
  .xl\\:focus\\:to-red-300:focus {
    --gradient-to-color: #f8b4b4;
  }
  .xl\\:focus\\:to-red-400:focus {
    --gradient-to-color: #f98080;
  }
  .xl\\:focus\\:to-red-500:focus {
    --gradient-to-color: #f05252;
  }
  .xl\\:focus\\:to-red-600:focus {
    --gradient-to-color: #e02424;
  }
  .xl\\:focus\\:to-red-700:focus {
    --gradient-to-color: #c81e1e;
  }
  .xl\\:focus\\:to-red-800:focus {
    --gradient-to-color: #9b1c1c;
  }
  .xl\\:focus\\:to-red-900:focus {
    --gradient-to-color: #771d1d;
  }
  .xl\\:focus\\:to-orange-50:focus {
    --gradient-to-color: #fff8f1;
  }
  .xl\\:focus\\:to-orange-100:focus {
    --gradient-to-color: #feecdc;
  }
  .xl\\:focus\\:to-orange-200:focus {
    --gradient-to-color: #fcd9bd;
  }
  .xl\\:focus\\:to-orange-300:focus {
    --gradient-to-color: #fdba8c;
  }
  .xl\\:focus\\:to-orange-400:focus {
    --gradient-to-color: #ff8a4c;
  }
  .xl\\:focus\\:to-orange-500:focus {
    --gradient-to-color: #ff5a1f;
  }
  .xl\\:focus\\:to-orange-600:focus {
    --gradient-to-color: #d03801;
  }
  .xl\\:focus\\:to-orange-700:focus {
    --gradient-to-color: #b43403;
  }
  .xl\\:focus\\:to-orange-800:focus {
    --gradient-to-color: #8a2c0d;
  }
  .xl\\:focus\\:to-orange-900:focus {
    --gradient-to-color: #73230d;
  }
  .xl\\:focus\\:to-yellow-50:focus {
    --gradient-to-color: #fdfdea;
  }
  .xl\\:focus\\:to-yellow-100:focus {
    --gradient-to-color: #fdf6b2;
  }
  .xl\\:focus\\:to-yellow-200:focus {
    --gradient-to-color: #fce96a;
  }
  .xl\\:focus\\:to-yellow-300:focus {
    --gradient-to-color: #faca15;
  }
  .xl\\:focus\\:to-yellow-400:focus {
    --gradient-to-color: #e3a008;
  }
  .xl\\:focus\\:to-yellow-500:focus {
    --gradient-to-color: #c27803;
  }
  .xl\\:focus\\:to-yellow-600:focus {
    --gradient-to-color: #9f580a;
  }
  .xl\\:focus\\:to-yellow-700:focus {
    --gradient-to-color: #8e4b10;
  }
  .xl\\:focus\\:to-yellow-800:focus {
    --gradient-to-color: #723b13;
  }
  .xl\\:focus\\:to-yellow-900:focus {
    --gradient-to-color: #633112;
  }
  .xl\\:focus\\:to-green-50:focus {
    --gradient-to-color: #f3faf7;
  }
  .xl\\:focus\\:to-green-100:focus {
    --gradient-to-color: #def7ec;
  }
  .xl\\:focus\\:to-green-200:focus {
    --gradient-to-color: #bcf0da;
  }
  .xl\\:focus\\:to-green-300:focus {
    --gradient-to-color: #84e1bc;
  }
  .xl\\:focus\\:to-green-400:focus {
    --gradient-to-color: #31c48d;
  }
  .xl\\:focus\\:to-green-500:focus {
    --gradient-to-color: #0e9f6e;
  }
  .xl\\:focus\\:to-green-600:focus {
    --gradient-to-color: #057a55;
  }
  .xl\\:focus\\:to-green-700:focus {
    --gradient-to-color: #046c4e;
  }
  .xl\\:focus\\:to-green-800:focus {
    --gradient-to-color: #03543f;
  }
  .xl\\:focus\\:to-green-900:focus {
    --gradient-to-color: #014737;
  }
  .xl\\:focus\\:to-teal-50:focus {
    --gradient-to-color: #edfafa;
  }
  .xl\\:focus\\:to-teal-100:focus {
    --gradient-to-color: #d5f5f6;
  }
  .xl\\:focus\\:to-teal-200:focus {
    --gradient-to-color: #afecef;
  }
  .xl\\:focus\\:to-teal-300:focus {
    --gradient-to-color: #7edce2;
  }
  .xl\\:focus\\:to-teal-400:focus {
    --gradient-to-color: #16bdca;
  }
  .xl\\:focus\\:to-teal-500:focus {
    --gradient-to-color: #0694a2;
  }
  .xl\\:focus\\:to-teal-600:focus {
    --gradient-to-color: #047481;
  }
  .xl\\:focus\\:to-teal-700:focus {
    --gradient-to-color: #036672;
  }
  .xl\\:focus\\:to-teal-800:focus {
    --gradient-to-color: #05505c;
  }
  .xl\\:focus\\:to-teal-900:focus {
    --gradient-to-color: #014451;
  }
  .xl\\:focus\\:to-blue-50:focus {
    --gradient-to-color: #ebf5ff;
  }
  .xl\\:focus\\:to-blue-100:focus {
    --gradient-to-color: #e1effe;
  }
  .xl\\:focus\\:to-blue-200:focus {
    --gradient-to-color: #c3ddfd;
  }
  .xl\\:focus\\:to-blue-300:focus {
    --gradient-to-color: #a4cafe;
  }
  .xl\\:focus\\:to-blue-400:focus {
    --gradient-to-color: #76a9fa;
  }
  .xl\\:focus\\:to-blue-500:focus {
    --gradient-to-color: #3f83f8;
  }
  .xl\\:focus\\:to-blue-600:focus {
    --gradient-to-color: #1c64f2;
  }
  .xl\\:focus\\:to-blue-700:focus {
    --gradient-to-color: #1a56db;
  }
  .xl\\:focus\\:to-blue-800:focus {
    --gradient-to-color: #1e429f;
  }
  .xl\\:focus\\:to-blue-900:focus {
    --gradient-to-color: #233876;
  }
  .xl\\:focus\\:to-indigo-50:focus {
    --gradient-to-color: #f0f5ff;
  }
  .xl\\:focus\\:to-indigo-100:focus {
    --gradient-to-color: #e5edff;
  }
  .xl\\:focus\\:to-indigo-200:focus {
    --gradient-to-color: #cddbfe;
  }
  .xl\\:focus\\:to-indigo-300:focus {
    --gradient-to-color: #b4c6fc;
  }
  .xl\\:focus\\:to-indigo-400:focus {
    --gradient-to-color: #8da2fb;
  }
  .xl\\:focus\\:to-indigo-500:focus {
    --gradient-to-color: #6875f5;
  }
  .xl\\:focus\\:to-indigo-600:focus {
    --gradient-to-color: #5850ec;
  }
  .xl\\:focus\\:to-indigo-700:focus {
    --gradient-to-color: #5145cd;
  }
  .xl\\:focus\\:to-indigo-800:focus {
    --gradient-to-color: #42389d;
  }
  .xl\\:focus\\:to-indigo-900:focus {
    --gradient-to-color: #362f78;
  }
  .xl\\:focus\\:to-purple-50:focus {
    --gradient-to-color: #f6f5ff;
  }
  .xl\\:focus\\:to-purple-100:focus {
    --gradient-to-color: #edebfe;
  }
  .xl\\:focus\\:to-purple-200:focus {
    --gradient-to-color: #dcd7fe;
  }
  .xl\\:focus\\:to-purple-300:focus {
    --gradient-to-color: #cabffd;
  }
  .xl\\:focus\\:to-purple-400:focus {
    --gradient-to-color: #ac94fa;
  }
  .xl\\:focus\\:to-purple-500:focus {
    --gradient-to-color: #9061f9;
  }
  .xl\\:focus\\:to-purple-600:focus {
    --gradient-to-color: #7e3af2;
  }
  .xl\\:focus\\:to-purple-700:focus {
    --gradient-to-color: #6c2bd9;
  }
  .xl\\:focus\\:to-purple-800:focus {
    --gradient-to-color: #5521b5;
  }
  .xl\\:focus\\:to-purple-900:focus {
    --gradient-to-color: #4a1d96;
  }
  .xl\\:focus\\:to-pink-50:focus {
    --gradient-to-color: #fdf2f8;
  }
  .xl\\:focus\\:to-pink-100:focus {
    --gradient-to-color: #fce8f3;
  }
  .xl\\:focus\\:to-pink-200:focus {
    --gradient-to-color: #fad1e8;
  }
  .xl\\:focus\\:to-pink-300:focus {
    --gradient-to-color: #f8b4d9;
  }
  .xl\\:focus\\:to-pink-400:focus {
    --gradient-to-color: #f17eb8;
  }
  .xl\\:focus\\:to-pink-500:focus {
    --gradient-to-color: #e74694;
  }
  .xl\\:focus\\:to-pink-600:focus {
    --gradient-to-color: #d61f69;
  }
  .xl\\:focus\\:to-pink-700:focus {
    --gradient-to-color: #bf125d;
  }
  .xl\\:focus\\:to-pink-800:focus {
    --gradient-to-color: #99154b;
  }
  .xl\\:focus\\:to-pink-900:focus {
    --gradient-to-color: #751a3d;
  }
  .xl\\:focus\\:to-cool-gray-50:focus {
    --gradient-to-color: #f8fafc;
  }
  .xl\\:focus\\:to-cool-gray-100:focus {
    --gradient-to-color: #f1f5f9;
  }
  .xl\\:focus\\:to-cool-gray-200:focus {
    --gradient-to-color: #e2e8f0;
  }
  .xl\\:focus\\:to-cool-gray-300:focus {
    --gradient-to-color: #cfd8e3;
  }
  .xl\\:focus\\:to-cool-gray-400:focus {
    --gradient-to-color: #97a6ba;
  }
  .xl\\:focus\\:to-cool-gray-500:focus {
    --gradient-to-color: #64748b;
  }
  .xl\\:focus\\:to-cool-gray-600:focus {
    --gradient-to-color: #475569;
  }
  .xl\\:focus\\:to-cool-gray-700:focus {
    --gradient-to-color: #364152;
  }
  .xl\\:focus\\:to-cool-gray-800:focus {
    --gradient-to-color: #27303f;
  }
  .xl\\:focus\\:to-cool-gray-900:focus {
    --gradient-to-color: #1a202e;
  }
  .xl\\:bg-opacity-0 {
    --bg-opacity: 0;
  }
  .xl\\:bg-opacity-25 {
    --bg-opacity: 0.25;
  }
  .xl\\:bg-opacity-50 {
    --bg-opacity: 0.5;
  }
  .xl\\:bg-opacity-75 {
    --bg-opacity: 0.75;
  }
  .xl\\:bg-opacity-100 {
    --bg-opacity: 1;
  }
  .xl\\:hover\\:bg-opacity-0:hover {
    --bg-opacity: 0;
  }
  .xl\\:hover\\:bg-opacity-25:hover {
    --bg-opacity: 0.25;
  }
  .xl\\:hover\\:bg-opacity-50:hover {
    --bg-opacity: 0.5;
  }
  .xl\\:hover\\:bg-opacity-75:hover {
    --bg-opacity: 0.75;
  }
  .xl\\:hover\\:bg-opacity-100:hover {
    --bg-opacity: 1;
  }
  .xl\\:focus\\:bg-opacity-0:focus {
    --bg-opacity: 0;
  }
  .xl\\:focus\\:bg-opacity-25:focus {
    --bg-opacity: 0.25;
  }
  .xl\\:focus\\:bg-opacity-50:focus {
    --bg-opacity: 0.5;
  }
  .xl\\:focus\\:bg-opacity-75:focus {
    --bg-opacity: 0.75;
  }
  .xl\\:focus\\:bg-opacity-100:focus {
    --bg-opacity: 1;
  }
  .xl\\:bg-bottom {
    background-position: bottom;
  }
  .xl\\:bg-center {
    background-position: center;
  }
  .xl\\:bg-left {
    background-position: left;
  }
  .xl\\:bg-left-bottom {
    background-position: left bottom;
  }
  .xl\\:bg-left-top {
    background-position: left top;
  }
  .xl\\:bg-right {
    background-position: right;
  }
  .xl\\:bg-right-bottom {
    background-position: right bottom;
  }
  .xl\\:bg-right-top {
    background-position: right top;
  }
  .xl\\:bg-top {
    background-position: top;
  }
  .xl\\:bg-repeat {
    background-repeat: repeat;
  }
  .xl\\:bg-no-repeat {
    background-repeat: no-repeat;
  }
  .xl\\:bg-repeat-x {
    background-repeat: repeat-x;
  }
  .xl\\:bg-repeat-y {
    background-repeat: repeat-y;
  }
  .xl\\:bg-repeat-round {
    background-repeat: round;
  }
  .xl\\:bg-repeat-space {
    background-repeat: space;
  }
  .xl\\:bg-auto {
    background-size: auto;
  }
  .xl\\:bg-cover {
    background-size: cover;
  }
  .xl\\:bg-contain {
    background-size: contain;
  }
  .xl\\:border-collapse {
    border-collapse: collapse;
  }
  .xl\\:border-separate {
    border-collapse: separate;
  }
  .xl\\:border-current {
    border-color: currentColor;
  }
  .xl\\:border-transparent {
    border-color: transparent;
  }
  .xl\\:border-white {
    --border-opacity: 1;
    border-color: #ffffff;
    border-color: rgba(255, 255, 255, var(--border-opacity));
  }
  .xl\\:border-black {
    --border-opacity: 1;
    border-color: #000000;
    border-color: rgba(0, 0, 0, var(--border-opacity));
  }
  .xl\\:border-gray-50 {
    --border-opacity: 1;
    border-color: #f9fafb;
    border-color: rgba(249, 250, 251, var(--border-opacity));
  }
  .xl\\:border-gray-100 {
    --border-opacity: 1;
    border-color: #f4f5f7;
    border-color: rgba(244, 245, 247, var(--border-opacity));
  }
  .xl\\:border-gray-200 {
    --border-opacity: 1;
    border-color: #e5e7eb;
    border-color: rgba(229, 231, 235, var(--border-opacity));
  }
  .xl\\:border-gray-300 {
    --border-opacity: 1;
    border-color: #d2d6dc;
    border-color: rgba(210, 214, 220, var(--border-opacity));
  }
  .xl\\:border-gray-400 {
    --border-opacity: 1;
    border-color: #9fa6b2;
    border-color: rgba(159, 166, 178, var(--border-opacity));
  }
  .xl\\:border-gray-500 {
    --border-opacity: 1;
    border-color: #6b7280;
    border-color: rgba(107, 114, 128, var(--border-opacity));
  }
  .xl\\:border-gray-600 {
    --border-opacity: 1;
    border-color: #4b5563;
    border-color: rgba(75, 85, 99, var(--border-opacity));
  }
  .xl\\:border-gray-700 {
    --border-opacity: 1;
    border-color: #374151;
    border-color: rgba(55, 65, 81, var(--border-opacity));
  }
  .xl\\:border-gray-800 {
    --border-opacity: 1;
    border-color: #252f3f;
    border-color: rgba(37, 47, 63, var(--border-opacity));
  }
  .xl\\:border-gray-900 {
    --border-opacity: 1;
    border-color: #161e2e;
    border-color: rgba(22, 30, 46, var(--border-opacity));
  }
  .xl\\:border-red-50 {
    --border-opacity: 1;
    border-color: #fdf2f2;
    border-color: rgba(253, 242, 242, var(--border-opacity));
  }
  .xl\\:border-red-100 {
    --border-opacity: 1;
    border-color: #fde8e8;
    border-color: rgba(253, 232, 232, var(--border-opacity));
  }
  .xl\\:border-red-200 {
    --border-opacity: 1;
    border-color: #fbd5d5;
    border-color: rgba(251, 213, 213, var(--border-opacity));
  }
  .xl\\:border-red-300 {
    --border-opacity: 1;
    border-color: #f8b4b4;
    border-color: rgba(248, 180, 180, var(--border-opacity));
  }
  .xl\\:border-red-400 {
    --border-opacity: 1;
    border-color: #f98080;
    border-color: rgba(249, 128, 128, var(--border-opacity));
  }
  .xl\\:border-red-500 {
    --border-opacity: 1;
    border-color: #f05252;
    border-color: rgba(240, 82, 82, var(--border-opacity));
  }
  .xl\\:border-red-600 {
    --border-opacity: 1;
    border-color: #e02424;
    border-color: rgba(224, 36, 36, var(--border-opacity));
  }
  .xl\\:border-red-700 {
    --border-opacity: 1;
    border-color: #c81e1e;
    border-color: rgba(200, 30, 30, var(--border-opacity));
  }
  .xl\\:border-red-800 {
    --border-opacity: 1;
    border-color: #9b1c1c;
    border-color: rgba(155, 28, 28, var(--border-opacity));
  }
  .xl\\:border-red-900 {
    --border-opacity: 1;
    border-color: #771d1d;
    border-color: rgba(119, 29, 29, var(--border-opacity));
  }
  .xl\\:border-orange-50 {
    --border-opacity: 1;
    border-color: #fff8f1;
    border-color: rgba(255, 248, 241, var(--border-opacity));
  }
  .xl\\:border-orange-100 {
    --border-opacity: 1;
    border-color: #feecdc;
    border-color: rgba(254, 236, 220, var(--border-opacity));
  }
  .xl\\:border-orange-200 {
    --border-opacity: 1;
    border-color: #fcd9bd;
    border-color: rgba(252, 217, 189, var(--border-opacity));
  }
  .xl\\:border-orange-300 {
    --border-opacity: 1;
    border-color: #fdba8c;
    border-color: rgba(253, 186, 140, var(--border-opacity));
  }
  .xl\\:border-orange-400 {
    --border-opacity: 1;
    border-color: #ff8a4c;
    border-color: rgba(255, 138, 76, var(--border-opacity));
  }
  .xl\\:border-orange-500 {
    --border-opacity: 1;
    border-color: #ff5a1f;
    border-color: rgba(255, 90, 31, var(--border-opacity));
  }
  .xl\\:border-orange-600 {
    --border-opacity: 1;
    border-color: #d03801;
    border-color: rgba(208, 56, 1, var(--border-opacity));
  }
  .xl\\:border-orange-700 {
    --border-opacity: 1;
    border-color: #b43403;
    border-color: rgba(180, 52, 3, var(--border-opacity));
  }
  .xl\\:border-orange-800 {
    --border-opacity: 1;
    border-color: #8a2c0d;
    border-color: rgba(138, 44, 13, var(--border-opacity));
  }
  .xl\\:border-orange-900 {
    --border-opacity: 1;
    border-color: #73230d;
    border-color: rgba(115, 35, 13, var(--border-opacity));
  }
  .xl\\:border-yellow-50 {
    --border-opacity: 1;
    border-color: #fdfdea;
    border-color: rgba(253, 253, 234, var(--border-opacity));
  }
  .xl\\:border-yellow-100 {
    --border-opacity: 1;
    border-color: #fdf6b2;
    border-color: rgba(253, 246, 178, var(--border-opacity));
  }
  .xl\\:border-yellow-200 {
    --border-opacity: 1;
    border-color: #fce96a;
    border-color: rgba(252, 233, 106, var(--border-opacity));
  }
  .xl\\:border-yellow-300 {
    --border-opacity: 1;
    border-color: #faca15;
    border-color: rgba(250, 202, 21, var(--border-opacity));
  }
  .xl\\:border-yellow-400 {
    --border-opacity: 1;
    border-color: #e3a008;
    border-color: rgba(227, 160, 8, var(--border-opacity));
  }
  .xl\\:border-yellow-500 {
    --border-opacity: 1;
    border-color: #c27803;
    border-color: rgba(194, 120, 3, var(--border-opacity));
  }
  .xl\\:border-yellow-600 {
    --border-opacity: 1;
    border-color: #9f580a;
    border-color: rgba(159, 88, 10, var(--border-opacity));
  }
  .xl\\:border-yellow-700 {
    --border-opacity: 1;
    border-color: #8e4b10;
    border-color: rgba(142, 75, 16, var(--border-opacity));
  }
  .xl\\:border-yellow-800 {
    --border-opacity: 1;
    border-color: #723b13;
    border-color: rgba(114, 59, 19, var(--border-opacity));
  }
  .xl\\:border-yellow-900 {
    --border-opacity: 1;
    border-color: #633112;
    border-color: rgba(99, 49, 18, var(--border-opacity));
  }
  .xl\\:border-green-50 {
    --border-opacity: 1;
    border-color: #f3faf7;
    border-color: rgba(243, 250, 247, var(--border-opacity));
  }
  .xl\\:border-green-100 {
    --border-opacity: 1;
    border-color: #def7ec;
    border-color: rgba(222, 247, 236, var(--border-opacity));
  }
  .xl\\:border-green-200 {
    --border-opacity: 1;
    border-color: #bcf0da;
    border-color: rgba(188, 240, 218, var(--border-opacity));
  }
  .xl\\:border-green-300 {
    --border-opacity: 1;
    border-color: #84e1bc;
    border-color: rgba(132, 225, 188, var(--border-opacity));
  }
  .xl\\:border-green-400 {
    --border-opacity: 1;
    border-color: #31c48d;
    border-color: rgba(49, 196, 141, var(--border-opacity));
  }
  .xl\\:border-green-500 {
    --border-opacity: 1;
    border-color: #0e9f6e;
    border-color: rgba(14, 159, 110, var(--border-opacity));
  }
  .xl\\:border-green-600 {
    --border-opacity: 1;
    border-color: #057a55;
    border-color: rgba(5, 122, 85, var(--border-opacity));
  }
  .xl\\:border-green-700 {
    --border-opacity: 1;
    border-color: #046c4e;
    border-color: rgba(4, 108, 78, var(--border-opacity));
  }
  .xl\\:border-green-800 {
    --border-opacity: 1;
    border-color: #03543f;
    border-color: rgba(3, 84, 63, var(--border-opacity));
  }
  .xl\\:border-green-900 {
    --border-opacity: 1;
    border-color: #014737;
    border-color: rgba(1, 71, 55, var(--border-opacity));
  }
  .xl\\:border-teal-50 {
    --border-opacity: 1;
    border-color: #edfafa;
    border-color: rgba(237, 250, 250, var(--border-opacity));
  }
  .xl\\:border-teal-100 {
    --border-opacity: 1;
    border-color: #d5f5f6;
    border-color: rgba(213, 245, 246, var(--border-opacity));
  }
  .xl\\:border-teal-200 {
    --border-opacity: 1;
    border-color: #afecef;
    border-color: rgba(175, 236, 239, var(--border-opacity));
  }
  .xl\\:border-teal-300 {
    --border-opacity: 1;
    border-color: #7edce2;
    border-color: rgba(126, 220, 226, var(--border-opacity));
  }
  .xl\\:border-teal-400 {
    --border-opacity: 1;
    border-color: #16bdca;
    border-color: rgba(22, 189, 202, var(--border-opacity));
  }
  .xl\\:border-teal-500 {
    --border-opacity: 1;
    border-color: #0694a2;
    border-color: rgba(6, 148, 162, var(--border-opacity));
  }
  .xl\\:border-teal-600 {
    --border-opacity: 1;
    border-color: #047481;
    border-color: rgba(4, 116, 129, var(--border-opacity));
  }
  .xl\\:border-teal-700 {
    --border-opacity: 1;
    border-color: #036672;
    border-color: rgba(3, 102, 114, var(--border-opacity));
  }
  .xl\\:border-teal-800 {
    --border-opacity: 1;
    border-color: #05505c;
    border-color: rgba(5, 80, 92, var(--border-opacity));
  }
  .xl\\:border-teal-900 {
    --border-opacity: 1;
    border-color: #014451;
    border-color: rgba(1, 68, 81, var(--border-opacity));
  }
  .xl\\:border-blue-50 {
    --border-opacity: 1;
    border-color: #ebf5ff;
    border-color: rgba(235, 245, 255, var(--border-opacity));
  }
  .xl\\:border-blue-100 {
    --border-opacity: 1;
    border-color: #e1effe;
    border-color: rgba(225, 239, 254, var(--border-opacity));
  }
  .xl\\:border-blue-200 {
    --border-opacity: 1;
    border-color: #c3ddfd;
    border-color: rgba(195, 221, 253, var(--border-opacity));
  }
  .xl\\:border-blue-300 {
    --border-opacity: 1;
    border-color: #a4cafe;
    border-color: rgba(164, 202, 254, var(--border-opacity));
  }
  .xl\\:border-blue-400 {
    --border-opacity: 1;
    border-color: #76a9fa;
    border-color: rgba(118, 169, 250, var(--border-opacity));
  }
  .xl\\:border-blue-500 {
    --border-opacity: 1;
    border-color: #3f83f8;
    border-color: rgba(63, 131, 248, var(--border-opacity));
  }
  .xl\\:border-blue-600 {
    --border-opacity: 1;
    border-color: #1c64f2;
    border-color: rgba(28, 100, 242, var(--border-opacity));
  }
  .xl\\:border-blue-700 {
    --border-opacity: 1;
    border-color: #1a56db;
    border-color: rgba(26, 86, 219, var(--border-opacity));
  }
  .xl\\:border-blue-800 {
    --border-opacity: 1;
    border-color: #1e429f;
    border-color: rgba(30, 66, 159, var(--border-opacity));
  }
  .xl\\:border-blue-900 {
    --border-opacity: 1;
    border-color: #233876;
    border-color: rgba(35, 56, 118, var(--border-opacity));
  }
  .xl\\:border-indigo-50 {
    --border-opacity: 1;
    border-color: #f0f5ff;
    border-color: rgba(240, 245, 255, var(--border-opacity));
  }
  .xl\\:border-indigo-100 {
    --border-opacity: 1;
    border-color: #e5edff;
    border-color: rgba(229, 237, 255, var(--border-opacity));
  }
  .xl\\:border-indigo-200 {
    --border-opacity: 1;
    border-color: #cddbfe;
    border-color: rgba(205, 219, 254, var(--border-opacity));
  }
  .xl\\:border-indigo-300 {
    --border-opacity: 1;
    border-color: #b4c6fc;
    border-color: rgba(180, 198, 252, var(--border-opacity));
  }
  .xl\\:border-indigo-400 {
    --border-opacity: 1;
    border-color: #8da2fb;
    border-color: rgba(141, 162, 251, var(--border-opacity));
  }
  .xl\\:border-indigo-500 {
    --border-opacity: 1;
    border-color: #6875f5;
    border-color: rgba(104, 117, 245, var(--border-opacity));
  }
  .xl\\:border-indigo-600 {
    --border-opacity: 1;
    border-color: #5850ec;
    border-color: rgba(88, 80, 236, var(--border-opacity));
  }
  .xl\\:border-indigo-700 {
    --border-opacity: 1;
    border-color: #5145cd;
    border-color: rgba(81, 69, 205, var(--border-opacity));
  }
  .xl\\:border-indigo-800 {
    --border-opacity: 1;
    border-color: #42389d;
    border-color: rgba(66, 56, 157, var(--border-opacity));
  }
  .xl\\:border-indigo-900 {
    --border-opacity: 1;
    border-color: #362f78;
    border-color: rgba(54, 47, 120, var(--border-opacity));
  }
  .xl\\:border-purple-50 {
    --border-opacity: 1;
    border-color: #f6f5ff;
    border-color: rgba(246, 245, 255, var(--border-opacity));
  }
  .xl\\:border-purple-100 {
    --border-opacity: 1;
    border-color: #edebfe;
    border-color: rgba(237, 235, 254, var(--border-opacity));
  }
  .xl\\:border-purple-200 {
    --border-opacity: 1;
    border-color: #dcd7fe;
    border-color: rgba(220, 215, 254, var(--border-opacity));
  }
  .xl\\:border-purple-300 {
    --border-opacity: 1;
    border-color: #cabffd;
    border-color: rgba(202, 191, 253, var(--border-opacity));
  }
  .xl\\:border-purple-400 {
    --border-opacity: 1;
    border-color: #ac94fa;
    border-color: rgba(172, 148, 250, var(--border-opacity));
  }
  .xl\\:border-purple-500 {
    --border-opacity: 1;
    border-color: #9061f9;
    border-color: rgba(144, 97, 249, var(--border-opacity));
  }
  .xl\\:border-purple-600 {
    --border-opacity: 1;
    border-color: #7e3af2;
    border-color: rgba(126, 58, 242, var(--border-opacity));
  }
  .xl\\:border-purple-700 {
    --border-opacity: 1;
    border-color: #6c2bd9;
    border-color: rgba(108, 43, 217, var(--border-opacity));
  }
  .xl\\:border-purple-800 {
    --border-opacity: 1;
    border-color: #5521b5;
    border-color: rgba(85, 33, 181, var(--border-opacity));
  }
  .xl\\:border-purple-900 {
    --border-opacity: 1;
    border-color: #4a1d96;
    border-color: rgba(74, 29, 150, var(--border-opacity));
  }
  .xl\\:border-pink-50 {
    --border-opacity: 1;
    border-color: #fdf2f8;
    border-color: rgba(253, 242, 248, var(--border-opacity));
  }
  .xl\\:border-pink-100 {
    --border-opacity: 1;
    border-color: #fce8f3;
    border-color: rgba(252, 232, 243, var(--border-opacity));
  }
  .xl\\:border-pink-200 {
    --border-opacity: 1;
    border-color: #fad1e8;
    border-color: rgba(250, 209, 232, var(--border-opacity));
  }
  .xl\\:border-pink-300 {
    --border-opacity: 1;
    border-color: #f8b4d9;
    border-color: rgba(248, 180, 217, var(--border-opacity));
  }
  .xl\\:border-pink-400 {
    --border-opacity: 1;
    border-color: #f17eb8;
    border-color: rgba(241, 126, 184, var(--border-opacity));
  }
  .xl\\:border-pink-500 {
    --border-opacity: 1;
    border-color: #e74694;
    border-color: rgba(231, 70, 148, var(--border-opacity));
  }
  .xl\\:border-pink-600 {
    --border-opacity: 1;
    border-color: #d61f69;
    border-color: rgba(214, 31, 105, var(--border-opacity));
  }
  .xl\\:border-pink-700 {
    --border-opacity: 1;
    border-color: #bf125d;
    border-color: rgba(191, 18, 93, var(--border-opacity));
  }
  .xl\\:border-pink-800 {
    --border-opacity: 1;
    border-color: #99154b;
    border-color: rgba(153, 21, 75, var(--border-opacity));
  }
  .xl\\:border-pink-900 {
    --border-opacity: 1;
    border-color: #751a3d;
    border-color: rgba(117, 26, 61, var(--border-opacity));
  }
  .xl\\:border-cool-gray-50 {
    --border-opacity: 1;
    border-color: #f8fafc;
    border-color: rgba(248, 250, 252, var(--border-opacity));
  }
  .xl\\:border-cool-gray-100 {
    --border-opacity: 1;
    border-color: #f1f5f9;
    border-color: rgba(241, 245, 249, var(--border-opacity));
  }
  .xl\\:border-cool-gray-200 {
    --border-opacity: 1;
    border-color: #e2e8f0;
    border-color: rgba(226, 232, 240, var(--border-opacity));
  }
  .xl\\:border-cool-gray-300 {
    --border-opacity: 1;
    border-color: #cfd8e3;
    border-color: rgba(207, 216, 227, var(--border-opacity));
  }
  .xl\\:border-cool-gray-400 {
    --border-opacity: 1;
    border-color: #97a6ba;
    border-color: rgba(151, 166, 186, var(--border-opacity));
  }
  .xl\\:border-cool-gray-500 {
    --border-opacity: 1;
    border-color: #64748b;
    border-color: rgba(100, 116, 139, var(--border-opacity));
  }
  .xl\\:border-cool-gray-600 {
    --border-opacity: 1;
    border-color: #475569;
    border-color: rgba(71, 85, 105, var(--border-opacity));
  }
  .xl\\:border-cool-gray-700 {
    --border-opacity: 1;
    border-color: #364152;
    border-color: rgba(54, 65, 82, var(--border-opacity));
  }
  .xl\\:border-cool-gray-800 {
    --border-opacity: 1;
    border-color: #27303f;
    border-color: rgba(39, 48, 63, var(--border-opacity));
  }
  .xl\\:border-cool-gray-900 {
    --border-opacity: 1;
    border-color: #1a202e;
    border-color: rgba(26, 32, 46, var(--border-opacity));
  }
  .group:hover .xl\\:group-hover\\:border-current {
    border-color: currentColor;
  }
  .group:hover .xl\\:group-hover\\:border-transparent {
    border-color: transparent;
  }
  .group:hover .xl\\:group-hover\\:border-white {
    --border-opacity: 1;
    border-color: #ffffff;
    border-color: rgba(255, 255, 255, var(--border-opacity));
  }
  .group:hover .xl\\:group-hover\\:border-black {
    --border-opacity: 1;
    border-color: #000000;
    border-color: rgba(0, 0, 0, var(--border-opacity));
  }
  .group:hover .xl\\:group-hover\\:border-gray-50 {
    --border-opacity: 1;
    border-color: #f9fafb;
    border-color: rgba(249, 250, 251, var(--border-opacity));
  }
  .group:hover .xl\\:group-hover\\:border-gray-100 {
    --border-opacity: 1;
    border-color: #f4f5f7;
    border-color: rgba(244, 245, 247, var(--border-opacity));
  }
  .group:hover .xl\\:group-hover\\:border-gray-200 {
    --border-opacity: 1;
    border-color: #e5e7eb;
    border-color: rgba(229, 231, 235, var(--border-opacity));
  }
  .group:hover .xl\\:group-hover\\:border-gray-300 {
    --border-opacity: 1;
    border-color: #d2d6dc;
    border-color: rgba(210, 214, 220, var(--border-opacity));
  }
  .group:hover .xl\\:group-hover\\:border-gray-400 {
    --border-opacity: 1;
    border-color: #9fa6b2;
    border-color: rgba(159, 166, 178, var(--border-opacity));
  }
  .group:hover .xl\\:group-hover\\:border-gray-500 {
    --border-opacity: 1;
    border-color: #6b7280;
    border-color: rgba(107, 114, 128, var(--border-opacity));
  }
  .group:hover .xl\\:group-hover\\:border-gray-600 {
    --border-opacity: 1;
    border-color: #4b5563;
    border-color: rgba(75, 85, 99, var(--border-opacity));
  }
  .group:hover .xl\\:group-hover\\:border-gray-700 {
    --border-opacity: 1;
    border-color: #374151;
    border-color: rgba(55, 65, 81, var(--border-opacity));
  }
  .group:hover .xl\\:group-hover\\:border-gray-800 {
    --border-opacity: 1;
    border-color: #252f3f;
    border-color: rgba(37, 47, 63, var(--border-opacity));
  }
  .group:hover .xl\\:group-hover\\:border-gray-900 {
    --border-opacity: 1;
    border-color: #161e2e;
    border-color: rgba(22, 30, 46, var(--border-opacity));
  }
  .group:hover .xl\\:group-hover\\:border-red-50 {
    --border-opacity: 1;
    border-color: #fdf2f2;
    border-color: rgba(253, 242, 242, var(--border-opacity));
  }
  .group:hover .xl\\:group-hover\\:border-red-100 {
    --border-opacity: 1;
    border-color: #fde8e8;
    border-color: rgba(253, 232, 232, var(--border-opacity));
  }
  .group:hover .xl\\:group-hover\\:border-red-200 {
    --border-opacity: 1;
    border-color: #fbd5d5;
    border-color: rgba(251, 213, 213, var(--border-opacity));
  }
  .group:hover .xl\\:group-hover\\:border-red-300 {
    --border-opacity: 1;
    border-color: #f8b4b4;
    border-color: rgba(248, 180, 180, var(--border-opacity));
  }
  .group:hover .xl\\:group-hover\\:border-red-400 {
    --border-opacity: 1;
    border-color: #f98080;
    border-color: rgba(249, 128, 128, var(--border-opacity));
  }
  .group:hover .xl\\:group-hover\\:border-red-500 {
    --border-opacity: 1;
    border-color: #f05252;
    border-color: rgba(240, 82, 82, var(--border-opacity));
  }
  .group:hover .xl\\:group-hover\\:border-red-600 {
    --border-opacity: 1;
    border-color: #e02424;
    border-color: rgba(224, 36, 36, var(--border-opacity));
  }
  .group:hover .xl\\:group-hover\\:border-red-700 {
    --border-opacity: 1;
    border-color: #c81e1e;
    border-color: rgba(200, 30, 30, var(--border-opacity));
  }
  .group:hover .xl\\:group-hover\\:border-red-800 {
    --border-opacity: 1;
    border-color: #9b1c1c;
    border-color: rgba(155, 28, 28, var(--border-opacity));
  }
  .group:hover .xl\\:group-hover\\:border-red-900 {
    --border-opacity: 1;
    border-color: #771d1d;
    border-color: rgba(119, 29, 29, var(--border-opacity));
  }
  .group:hover .xl\\:group-hover\\:border-orange-50 {
    --border-opacity: 1;
    border-color: #fff8f1;
    border-color: rgba(255, 248, 241, var(--border-opacity));
  }
  .group:hover .xl\\:group-hover\\:border-orange-100 {
    --border-opacity: 1;
    border-color: #feecdc;
    border-color: rgba(254, 236, 220, var(--border-opacity));
  }
  .group:hover .xl\\:group-hover\\:border-orange-200 {
    --border-opacity: 1;
    border-color: #fcd9bd;
    border-color: rgba(252, 217, 189, var(--border-opacity));
  }
  .group:hover .xl\\:group-hover\\:border-orange-300 {
    --border-opacity: 1;
    border-color: #fdba8c;
    border-color: rgba(253, 186, 140, var(--border-opacity));
  }
  .group:hover .xl\\:group-hover\\:border-orange-400 {
    --border-opacity: 1;
    border-color: #ff8a4c;
    border-color: rgba(255, 138, 76, var(--border-opacity));
  }
  .group:hover .xl\\:group-hover\\:border-orange-500 {
    --border-opacity: 1;
    border-color: #ff5a1f;
    border-color: rgba(255, 90, 31, var(--border-opacity));
  }
  .group:hover .xl\\:group-hover\\:border-orange-600 {
    --border-opacity: 1;
    border-color: #d03801;
    border-color: rgba(208, 56, 1, var(--border-opacity));
  }
  .group:hover .xl\\:group-hover\\:border-orange-700 {
    --border-opacity: 1;
    border-color: #b43403;
    border-color: rgba(180, 52, 3, var(--border-opacity));
  }
  .group:hover .xl\\:group-hover\\:border-orange-800 {
    --border-opacity: 1;
    border-color: #8a2c0d;
    border-color: rgba(138, 44, 13, var(--border-opacity));
  }
  .group:hover .xl\\:group-hover\\:border-orange-900 {
    --border-opacity: 1;
    border-color: #73230d;
    border-color: rgba(115, 35, 13, var(--border-opacity));
  }
  .group:hover .xl\\:group-hover\\:border-yellow-50 {
    --border-opacity: 1;
    border-color: #fdfdea;
    border-color: rgba(253, 253, 234, var(--border-opacity));
  }
  .group:hover .xl\\:group-hover\\:border-yellow-100 {
    --border-opacity: 1;
    border-color: #fdf6b2;
    border-color: rgba(253, 246, 178, var(--border-opacity));
  }
  .group:hover .xl\\:group-hover\\:border-yellow-200 {
    --border-opacity: 1;
    border-color: #fce96a;
    border-color: rgba(252, 233, 106, var(--border-opacity));
  }
  .group:hover .xl\\:group-hover\\:border-yellow-300 {
    --border-opacity: 1;
    border-color: #faca15;
    border-color: rgba(250, 202, 21, var(--border-opacity));
  }
  .group:hover .xl\\:group-hover\\:border-yellow-400 {
    --border-opacity: 1;
    border-color: #e3a008;
    border-color: rgba(227, 160, 8, var(--border-opacity));
  }
  .group:hover .xl\\:group-hover\\:border-yellow-500 {
    --border-opacity: 1;
    border-color: #c27803;
    border-color: rgba(194, 120, 3, var(--border-opacity));
  }
  .group:hover .xl\\:group-hover\\:border-yellow-600 {
    --border-opacity: 1;
    border-color: #9f580a;
    border-color: rgba(159, 88, 10, var(--border-opacity));
  }
  .group:hover .xl\\:group-hover\\:border-yellow-700 {
    --border-opacity: 1;
    border-color: #8e4b10;
    border-color: rgba(142, 75, 16, var(--border-opacity));
  }
  .group:hover .xl\\:group-hover\\:border-yellow-800 {
    --border-opacity: 1;
    border-color: #723b13;
    border-color: rgba(114, 59, 19, var(--border-opacity));
  }
  .group:hover .xl\\:group-hover\\:border-yellow-900 {
    --border-opacity: 1;
    border-color: #633112;
    border-color: rgba(99, 49, 18, var(--border-opacity));
  }
  .group:hover .xl\\:group-hover\\:border-green-50 {
    --border-opacity: 1;
    border-color: #f3faf7;
    border-color: rgba(243, 250, 247, var(--border-opacity));
  }
  .group:hover .xl\\:group-hover\\:border-green-100 {
    --border-opacity: 1;
    border-color: #def7ec;
    border-color: rgba(222, 247, 236, var(--border-opacity));
  }
  .group:hover .xl\\:group-hover\\:border-green-200 {
    --border-opacity: 1;
    border-color: #bcf0da;
    border-color: rgba(188, 240, 218, var(--border-opacity));
  }
  .group:hover .xl\\:group-hover\\:border-green-300 {
    --border-opacity: 1;
    border-color: #84e1bc;
    border-color: rgba(132, 225, 188, var(--border-opacity));
  }
  .group:hover .xl\\:group-hover\\:border-green-400 {
    --border-opacity: 1;
    border-color: #31c48d;
    border-color: rgba(49, 196, 141, var(--border-opacity));
  }
  .group:hover .xl\\:group-hover\\:border-green-500 {
    --border-opacity: 1;
    border-color: #0e9f6e;
    border-color: rgba(14, 159, 110, var(--border-opacity));
  }
  .group:hover .xl\\:group-hover\\:border-green-600 {
    --border-opacity: 1;
    border-color: #057a55;
    border-color: rgba(5, 122, 85, var(--border-opacity));
  }
  .group:hover .xl\\:group-hover\\:border-green-700 {
    --border-opacity: 1;
    border-color: #046c4e;
    border-color: rgba(4, 108, 78, var(--border-opacity));
  }
  .group:hover .xl\\:group-hover\\:border-green-800 {
    --border-opacity: 1;
    border-color: #03543f;
    border-color: rgba(3, 84, 63, var(--border-opacity));
  }
  .group:hover .xl\\:group-hover\\:border-green-900 {
    --border-opacity: 1;
    border-color: #014737;
    border-color: rgba(1, 71, 55, var(--border-opacity));
  }
  .group:hover .xl\\:group-hover\\:border-teal-50 {
    --border-opacity: 1;
    border-color: #edfafa;
    border-color: rgba(237, 250, 250, var(--border-opacity));
  }
  .group:hover .xl\\:group-hover\\:border-teal-100 {
    --border-opacity: 1;
    border-color: #d5f5f6;
    border-color: rgba(213, 245, 246, var(--border-opacity));
  }
  .group:hover .xl\\:group-hover\\:border-teal-200 {
    --border-opacity: 1;
    border-color: #afecef;
    border-color: rgba(175, 236, 239, var(--border-opacity));
  }
  .group:hover .xl\\:group-hover\\:border-teal-300 {
    --border-opacity: 1;
    border-color: #7edce2;
    border-color: rgba(126, 220, 226, var(--border-opacity));
  }
  .group:hover .xl\\:group-hover\\:border-teal-400 {
    --border-opacity: 1;
    border-color: #16bdca;
    border-color: rgba(22, 189, 202, var(--border-opacity));
  }
  .group:hover .xl\\:group-hover\\:border-teal-500 {
    --border-opacity: 1;
    border-color: #0694a2;
    border-color: rgba(6, 148, 162, var(--border-opacity));
  }
  .group:hover .xl\\:group-hover\\:border-teal-600 {
    --border-opacity: 1;
    border-color: #047481;
    border-color: rgba(4, 116, 129, var(--border-opacity));
  }
  .group:hover .xl\\:group-hover\\:border-teal-700 {
    --border-opacity: 1;
    border-color: #036672;
    border-color: rgba(3, 102, 114, var(--border-opacity));
  }
  .group:hover .xl\\:group-hover\\:border-teal-800 {
    --border-opacity: 1;
    border-color: #05505c;
    border-color: rgba(5, 80, 92, var(--border-opacity));
  }
  .group:hover .xl\\:group-hover\\:border-teal-900 {
    --border-opacity: 1;
    border-color: #014451;
    border-color: rgba(1, 68, 81, var(--border-opacity));
  }
  .group:hover .xl\\:group-hover\\:border-blue-50 {
    --border-opacity: 1;
    border-color: #ebf5ff;
    border-color: rgba(235, 245, 255, var(--border-opacity));
  }
  .group:hover .xl\\:group-hover\\:border-blue-100 {
    --border-opacity: 1;
    border-color: #e1effe;
    border-color: rgba(225, 239, 254, var(--border-opacity));
  }
  .group:hover .xl\\:group-hover\\:border-blue-200 {
    --border-opacity: 1;
    border-color: #c3ddfd;
    border-color: rgba(195, 221, 253, var(--border-opacity));
  }
  .group:hover .xl\\:group-hover\\:border-blue-300 {
    --border-opacity: 1;
    border-color: #a4cafe;
    border-color: rgba(164, 202, 254, var(--border-opacity));
  }
  .group:hover .xl\\:group-hover\\:border-blue-400 {
    --border-opacity: 1;
    border-color: #76a9fa;
    border-color: rgba(118, 169, 250, var(--border-opacity));
  }
  .group:hover .xl\\:group-hover\\:border-blue-500 {
    --border-opacity: 1;
    border-color: #3f83f8;
    border-color: rgba(63, 131, 248, var(--border-opacity));
  }
  .group:hover .xl\\:group-hover\\:border-blue-600 {
    --border-opacity: 1;
    border-color: #1c64f2;
    border-color: rgba(28, 100, 242, var(--border-opacity));
  }
  .group:hover .xl\\:group-hover\\:border-blue-700 {
    --border-opacity: 1;
    border-color: #1a56db;
    border-color: rgba(26, 86, 219, var(--border-opacity));
  }
  .group:hover .xl\\:group-hover\\:border-blue-800 {
    --border-opacity: 1;
    border-color: #1e429f;
    border-color: rgba(30, 66, 159, var(--border-opacity));
  }
  .group:hover .xl\\:group-hover\\:border-blue-900 {
    --border-opacity: 1;
    border-color: #233876;
    border-color: rgba(35, 56, 118, var(--border-opacity));
  }
  .group:hover .xl\\:group-hover\\:border-indigo-50 {
    --border-opacity: 1;
    border-color: #f0f5ff;
    border-color: rgba(240, 245, 255, var(--border-opacity));
  }
  .group:hover .xl\\:group-hover\\:border-indigo-100 {
    --border-opacity: 1;
    border-color: #e5edff;
    border-color: rgba(229, 237, 255, var(--border-opacity));
  }
  .group:hover .xl\\:group-hover\\:border-indigo-200 {
    --border-opacity: 1;
    border-color: #cddbfe;
    border-color: rgba(205, 219, 254, var(--border-opacity));
  }
  .group:hover .xl\\:group-hover\\:border-indigo-300 {
    --border-opacity: 1;
    border-color: #b4c6fc;
    border-color: rgba(180, 198, 252, var(--border-opacity));
  }
  .group:hover .xl\\:group-hover\\:border-indigo-400 {
    --border-opacity: 1;
    border-color: #8da2fb;
    border-color: rgba(141, 162, 251, var(--border-opacity));
  }
  .group:hover .xl\\:group-hover\\:border-indigo-500 {
    --border-opacity: 1;
    border-color: #6875f5;
    border-color: rgba(104, 117, 245, var(--border-opacity));
  }
  .group:hover .xl\\:group-hover\\:border-indigo-600 {
    --border-opacity: 1;
    border-color: #5850ec;
    border-color: rgba(88, 80, 236, var(--border-opacity));
  }
  .group:hover .xl\\:group-hover\\:border-indigo-700 {
    --border-opacity: 1;
    border-color: #5145cd;
    border-color: rgba(81, 69, 205, var(--border-opacity));
  }
  .group:hover .xl\\:group-hover\\:border-indigo-800 {
    --border-opacity: 1;
    border-color: #42389d;
    border-color: rgba(66, 56, 157, var(--border-opacity));
  }
  .group:hover .xl\\:group-hover\\:border-indigo-900 {
    --border-opacity: 1;
    border-color: #362f78;
    border-color: rgba(54, 47, 120, var(--border-opacity));
  }
  .group:hover .xl\\:group-hover\\:border-purple-50 {
    --border-opacity: 1;
    border-color: #f6f5ff;
    border-color: rgba(246, 245, 255, var(--border-opacity));
  }
  .group:hover .xl\\:group-hover\\:border-purple-100 {
    --border-opacity: 1;
    border-color: #edebfe;
    border-color: rgba(237, 235, 254, var(--border-opacity));
  }
  .group:hover .xl\\:group-hover\\:border-purple-200 {
    --border-opacity: 1;
    border-color: #dcd7fe;
    border-color: rgba(220, 215, 254, var(--border-opacity));
  }
  .group:hover .xl\\:group-hover\\:border-purple-300 {
    --border-opacity: 1;
    border-color: #cabffd;
    border-color: rgba(202, 191, 253, var(--border-opacity));
  }
  .group:hover .xl\\:group-hover\\:border-purple-400 {
    --border-opacity: 1;
    border-color: #ac94fa;
    border-color: rgba(172, 148, 250, var(--border-opacity));
  }
  .group:hover .xl\\:group-hover\\:border-purple-500 {
    --border-opacity: 1;
    border-color: #9061f9;
    border-color: rgba(144, 97, 249, var(--border-opacity));
  }
  .group:hover .xl\\:group-hover\\:border-purple-600 {
    --border-opacity: 1;
    border-color: #7e3af2;
    border-color: rgba(126, 58, 242, var(--border-opacity));
  }
  .group:hover .xl\\:group-hover\\:border-purple-700 {
    --border-opacity: 1;
    border-color: #6c2bd9;
    border-color: rgba(108, 43, 217, var(--border-opacity));
  }
  .group:hover .xl\\:group-hover\\:border-purple-800 {
    --border-opacity: 1;
    border-color: #5521b5;
    border-color: rgba(85, 33, 181, var(--border-opacity));
  }
  .group:hover .xl\\:group-hover\\:border-purple-900 {
    --border-opacity: 1;
    border-color: #4a1d96;
    border-color: rgba(74, 29, 150, var(--border-opacity));
  }
  .group:hover .xl\\:group-hover\\:border-pink-50 {
    --border-opacity: 1;
    border-color: #fdf2f8;
    border-color: rgba(253, 242, 248, var(--border-opacity));
  }
  .group:hover .xl\\:group-hover\\:border-pink-100 {
    --border-opacity: 1;
    border-color: #fce8f3;
    border-color: rgba(252, 232, 243, var(--border-opacity));
  }
  .group:hover .xl\\:group-hover\\:border-pink-200 {
    --border-opacity: 1;
    border-color: #fad1e8;
    border-color: rgba(250, 209, 232, var(--border-opacity));
  }
  .group:hover .xl\\:group-hover\\:border-pink-300 {
    --border-opacity: 1;
    border-color: #f8b4d9;
    border-color: rgba(248, 180, 217, var(--border-opacity));
  }
  .group:hover .xl\\:group-hover\\:border-pink-400 {
    --border-opacity: 1;
    border-color: #f17eb8;
    border-color: rgba(241, 126, 184, var(--border-opacity));
  }
  .group:hover .xl\\:group-hover\\:border-pink-500 {
    --border-opacity: 1;
    border-color: #e74694;
    border-color: rgba(231, 70, 148, var(--border-opacity));
  }
  .group:hover .xl\\:group-hover\\:border-pink-600 {
    --border-opacity: 1;
    border-color: #d61f69;
    border-color: rgba(214, 31, 105, var(--border-opacity));
  }
  .group:hover .xl\\:group-hover\\:border-pink-700 {
    --border-opacity: 1;
    border-color: #bf125d;
    border-color: rgba(191, 18, 93, var(--border-opacity));
  }
  .group:hover .xl\\:group-hover\\:border-pink-800 {
    --border-opacity: 1;
    border-color: #99154b;
    border-color: rgba(153, 21, 75, var(--border-opacity));
  }
  .group:hover .xl\\:group-hover\\:border-pink-900 {
    --border-opacity: 1;
    border-color: #751a3d;
    border-color: rgba(117, 26, 61, var(--border-opacity));
  }
  .group:hover .xl\\:group-hover\\:border-cool-gray-50 {
    --border-opacity: 1;
    border-color: #f8fafc;
    border-color: rgba(248, 250, 252, var(--border-opacity));
  }
  .group:hover .xl\\:group-hover\\:border-cool-gray-100 {
    --border-opacity: 1;
    border-color: #f1f5f9;
    border-color: rgba(241, 245, 249, var(--border-opacity));
  }
  .group:hover .xl\\:group-hover\\:border-cool-gray-200 {
    --border-opacity: 1;
    border-color: #e2e8f0;
    border-color: rgba(226, 232, 240, var(--border-opacity));
  }
  .group:hover .xl\\:group-hover\\:border-cool-gray-300 {
    --border-opacity: 1;
    border-color: #cfd8e3;
    border-color: rgba(207, 216, 227, var(--border-opacity));
  }
  .group:hover .xl\\:group-hover\\:border-cool-gray-400 {
    --border-opacity: 1;
    border-color: #97a6ba;
    border-color: rgba(151, 166, 186, var(--border-opacity));
  }
  .group:hover .xl\\:group-hover\\:border-cool-gray-500 {
    --border-opacity: 1;
    border-color: #64748b;
    border-color: rgba(100, 116, 139, var(--border-opacity));
  }
  .group:hover .xl\\:group-hover\\:border-cool-gray-600 {
    --border-opacity: 1;
    border-color: #475569;
    border-color: rgba(71, 85, 105, var(--border-opacity));
  }
  .group:hover .xl\\:group-hover\\:border-cool-gray-700 {
    --border-opacity: 1;
    border-color: #364152;
    border-color: rgba(54, 65, 82, var(--border-opacity));
  }
  .group:hover .xl\\:group-hover\\:border-cool-gray-800 {
    --border-opacity: 1;
    border-color: #27303f;
    border-color: rgba(39, 48, 63, var(--border-opacity));
  }
  .group:hover .xl\\:group-hover\\:border-cool-gray-900 {
    --border-opacity: 1;
    border-color: #1a202e;
    border-color: rgba(26, 32, 46, var(--border-opacity));
  }
  .group:focus .xl\\:group-focus\\:border-current {
    border-color: currentColor;
  }
  .group:focus .xl\\:group-focus\\:border-transparent {
    border-color: transparent;
  }
  .group:focus .xl\\:group-focus\\:border-white {
    --border-opacity: 1;
    border-color: #ffffff;
    border-color: rgba(255, 255, 255, var(--border-opacity));
  }
  .group:focus .xl\\:group-focus\\:border-black {
    --border-opacity: 1;
    border-color: #000000;
    border-color: rgba(0, 0, 0, var(--border-opacity));
  }
  .group:focus .xl\\:group-focus\\:border-gray-50 {
    --border-opacity: 1;
    border-color: #f9fafb;
    border-color: rgba(249, 250, 251, var(--border-opacity));
  }
  .group:focus .xl\\:group-focus\\:border-gray-100 {
    --border-opacity: 1;
    border-color: #f4f5f7;
    border-color: rgba(244, 245, 247, var(--border-opacity));
  }
  .group:focus .xl\\:group-focus\\:border-gray-200 {
    --border-opacity: 1;
    border-color: #e5e7eb;
    border-color: rgba(229, 231, 235, var(--border-opacity));
  }
  .group:focus .xl\\:group-focus\\:border-gray-300 {
    --border-opacity: 1;
    border-color: #d2d6dc;
    border-color: rgba(210, 214, 220, var(--border-opacity));
  }
  .group:focus .xl\\:group-focus\\:border-gray-400 {
    --border-opacity: 1;
    border-color: #9fa6b2;
    border-color: rgba(159, 166, 178, var(--border-opacity));
  }
  .group:focus .xl\\:group-focus\\:border-gray-500 {
    --border-opacity: 1;
    border-color: #6b7280;
    border-color: rgba(107, 114, 128, var(--border-opacity));
  }
  .group:focus .xl\\:group-focus\\:border-gray-600 {
    --border-opacity: 1;
    border-color: #4b5563;
    border-color: rgba(75, 85, 99, var(--border-opacity));
  }
  .group:focus .xl\\:group-focus\\:border-gray-700 {
    --border-opacity: 1;
    border-color: #374151;
    border-color: rgba(55, 65, 81, var(--border-opacity));
  }
  .group:focus .xl\\:group-focus\\:border-gray-800 {
    --border-opacity: 1;
    border-color: #252f3f;
    border-color: rgba(37, 47, 63, var(--border-opacity));
  }
  .group:focus .xl\\:group-focus\\:border-gray-900 {
    --border-opacity: 1;
    border-color: #161e2e;
    border-color: rgba(22, 30, 46, var(--border-opacity));
  }
  .group:focus .xl\\:group-focus\\:border-red-50 {
    --border-opacity: 1;
    border-color: #fdf2f2;
    border-color: rgba(253, 242, 242, var(--border-opacity));
  }
  .group:focus .xl\\:group-focus\\:border-red-100 {
    --border-opacity: 1;
    border-color: #fde8e8;
    border-color: rgba(253, 232, 232, var(--border-opacity));
  }
  .group:focus .xl\\:group-focus\\:border-red-200 {
    --border-opacity: 1;
    border-color: #fbd5d5;
    border-color: rgba(251, 213, 213, var(--border-opacity));
  }
  .group:focus .xl\\:group-focus\\:border-red-300 {
    --border-opacity: 1;
    border-color: #f8b4b4;
    border-color: rgba(248, 180, 180, var(--border-opacity));
  }
  .group:focus .xl\\:group-focus\\:border-red-400 {
    --border-opacity: 1;
    border-color: #f98080;
    border-color: rgba(249, 128, 128, var(--border-opacity));
  }
  .group:focus .xl\\:group-focus\\:border-red-500 {
    --border-opacity: 1;
    border-color: #f05252;
    border-color: rgba(240, 82, 82, var(--border-opacity));
  }
  .group:focus .xl\\:group-focus\\:border-red-600 {
    --border-opacity: 1;
    border-color: #e02424;
    border-color: rgba(224, 36, 36, var(--border-opacity));
  }
  .group:focus .xl\\:group-focus\\:border-red-700 {
    --border-opacity: 1;
    border-color: #c81e1e;
    border-color: rgba(200, 30, 30, var(--border-opacity));
  }
  .group:focus .xl\\:group-focus\\:border-red-800 {
    --border-opacity: 1;
    border-color: #9b1c1c;
    border-color: rgba(155, 28, 28, var(--border-opacity));
  }
  .group:focus .xl\\:group-focus\\:border-red-900 {
    --border-opacity: 1;
    border-color: #771d1d;
    border-color: rgba(119, 29, 29, var(--border-opacity));
  }
  .group:focus .xl\\:group-focus\\:border-orange-50 {
    --border-opacity: 1;
    border-color: #fff8f1;
    border-color: rgba(255, 248, 241, var(--border-opacity));
  }
  .group:focus .xl\\:group-focus\\:border-orange-100 {
    --border-opacity: 1;
    border-color: #feecdc;
    border-color: rgba(254, 236, 220, var(--border-opacity));
  }
  .group:focus .xl\\:group-focus\\:border-orange-200 {
    --border-opacity: 1;
    border-color: #fcd9bd;
    border-color: rgba(252, 217, 189, var(--border-opacity));
  }
  .group:focus .xl\\:group-focus\\:border-orange-300 {
    --border-opacity: 1;
    border-color: #fdba8c;
    border-color: rgba(253, 186, 140, var(--border-opacity));
  }
  .group:focus .xl\\:group-focus\\:border-orange-400 {
    --border-opacity: 1;
    border-color: #ff8a4c;
    border-color: rgba(255, 138, 76, var(--border-opacity));
  }
  .group:focus .xl\\:group-focus\\:border-orange-500 {
    --border-opacity: 1;
    border-color: #ff5a1f;
    border-color: rgba(255, 90, 31, var(--border-opacity));
  }
  .group:focus .xl\\:group-focus\\:border-orange-600 {
    --border-opacity: 1;
    border-color: #d03801;
    border-color: rgba(208, 56, 1, var(--border-opacity));
  }
  .group:focus .xl\\:group-focus\\:border-orange-700 {
    --border-opacity: 1;
    border-color: #b43403;
    border-color: rgba(180, 52, 3, var(--border-opacity));
  }
  .group:focus .xl\\:group-focus\\:border-orange-800 {
    --border-opacity: 1;
    border-color: #8a2c0d;
    border-color: rgba(138, 44, 13, var(--border-opacity));
  }
  .group:focus .xl\\:group-focus\\:border-orange-900 {
    --border-opacity: 1;
    border-color: #73230d;
    border-color: rgba(115, 35, 13, var(--border-opacity));
  }
  .group:focus .xl\\:group-focus\\:border-yellow-50 {
    --border-opacity: 1;
    border-color: #fdfdea;
    border-color: rgba(253, 253, 234, var(--border-opacity));
  }
  .group:focus .xl\\:group-focus\\:border-yellow-100 {
    --border-opacity: 1;
    border-color: #fdf6b2;
    border-color: rgba(253, 246, 178, var(--border-opacity));
  }
  .group:focus .xl\\:group-focus\\:border-yellow-200 {
    --border-opacity: 1;
    border-color: #fce96a;
    border-color: rgba(252, 233, 106, var(--border-opacity));
  }
  .group:focus .xl\\:group-focus\\:border-yellow-300 {
    --border-opacity: 1;
    border-color: #faca15;
    border-color: rgba(250, 202, 21, var(--border-opacity));
  }
  .group:focus .xl\\:group-focus\\:border-yellow-400 {
    --border-opacity: 1;
    border-color: #e3a008;
    border-color: rgba(227, 160, 8, var(--border-opacity));
  }
  .group:focus .xl\\:group-focus\\:border-yellow-500 {
    --border-opacity: 1;
    border-color: #c27803;
    border-color: rgba(194, 120, 3, var(--border-opacity));
  }
  .group:focus .xl\\:group-focus\\:border-yellow-600 {
    --border-opacity: 1;
    border-color: #9f580a;
    border-color: rgba(159, 88, 10, var(--border-opacity));
  }
  .group:focus .xl\\:group-focus\\:border-yellow-700 {
    --border-opacity: 1;
    border-color: #8e4b10;
    border-color: rgba(142, 75, 16, var(--border-opacity));
  }
  .group:focus .xl\\:group-focus\\:border-yellow-800 {
    --border-opacity: 1;
    border-color: #723b13;
    border-color: rgba(114, 59, 19, var(--border-opacity));
  }
  .group:focus .xl\\:group-focus\\:border-yellow-900 {
    --border-opacity: 1;
    border-color: #633112;
    border-color: rgba(99, 49, 18, var(--border-opacity));
  }
  .group:focus .xl\\:group-focus\\:border-green-50 {
    --border-opacity: 1;
    border-color: #f3faf7;
    border-color: rgba(243, 250, 247, var(--border-opacity));
  }
  .group:focus .xl\\:group-focus\\:border-green-100 {
    --border-opacity: 1;
    border-color: #def7ec;
    border-color: rgba(222, 247, 236, var(--border-opacity));
  }
  .group:focus .xl\\:group-focus\\:border-green-200 {
    --border-opacity: 1;
    border-color: #bcf0da;
    border-color: rgba(188, 240, 218, var(--border-opacity));
  }
  .group:focus .xl\\:group-focus\\:border-green-300 {
    --border-opacity: 1;
    border-color: #84e1bc;
    border-color: rgba(132, 225, 188, var(--border-opacity));
  }
  .group:focus .xl\\:group-focus\\:border-green-400 {
    --border-opacity: 1;
    border-color: #31c48d;
    border-color: rgba(49, 196, 141, var(--border-opacity));
  }
  .group:focus .xl\\:group-focus\\:border-green-500 {
    --border-opacity: 1;
    border-color: #0e9f6e;
    border-color: rgba(14, 159, 110, var(--border-opacity));
  }
  .group:focus .xl\\:group-focus\\:border-green-600 {
    --border-opacity: 1;
    border-color: #057a55;
    border-color: rgba(5, 122, 85, var(--border-opacity));
  }
  .group:focus .xl\\:group-focus\\:border-green-700 {
    --border-opacity: 1;
    border-color: #046c4e;
    border-color: rgba(4, 108, 78, var(--border-opacity));
  }
  .group:focus .xl\\:group-focus\\:border-green-800 {
    --border-opacity: 1;
    border-color: #03543f;
    border-color: rgba(3, 84, 63, var(--border-opacity));
  }
  .group:focus .xl\\:group-focus\\:border-green-900 {
    --border-opacity: 1;
    border-color: #014737;
    border-color: rgba(1, 71, 55, var(--border-opacity));
  }
  .group:focus .xl\\:group-focus\\:border-teal-50 {
    --border-opacity: 1;
    border-color: #edfafa;
    border-color: rgba(237, 250, 250, var(--border-opacity));
  }
  .group:focus .xl\\:group-focus\\:border-teal-100 {
    --border-opacity: 1;
    border-color: #d5f5f6;
    border-color: rgba(213, 245, 246, var(--border-opacity));
  }
  .group:focus .xl\\:group-focus\\:border-teal-200 {
    --border-opacity: 1;
    border-color: #afecef;
    border-color: rgba(175, 236, 239, var(--border-opacity));
  }
  .group:focus .xl\\:group-focus\\:border-teal-300 {
    --border-opacity: 1;
    border-color: #7edce2;
    border-color: rgba(126, 220, 226, var(--border-opacity));
  }
  .group:focus .xl\\:group-focus\\:border-teal-400 {
    --border-opacity: 1;
    border-color: #16bdca;
    border-color: rgba(22, 189, 202, var(--border-opacity));
  }
  .group:focus .xl\\:group-focus\\:border-teal-500 {
    --border-opacity: 1;
    border-color: #0694a2;
    border-color: rgba(6, 148, 162, var(--border-opacity));
  }
  .group:focus .xl\\:group-focus\\:border-teal-600 {
    --border-opacity: 1;
    border-color: #047481;
    border-color: rgba(4, 116, 129, var(--border-opacity));
  }
  .group:focus .xl\\:group-focus\\:border-teal-700 {
    --border-opacity: 1;
    border-color: #036672;
    border-color: rgba(3, 102, 114, var(--border-opacity));
  }
  .group:focus .xl\\:group-focus\\:border-teal-800 {
    --border-opacity: 1;
    border-color: #05505c;
    border-color: rgba(5, 80, 92, var(--border-opacity));
  }
  .group:focus .xl\\:group-focus\\:border-teal-900 {
    --border-opacity: 1;
    border-color: #014451;
    border-color: rgba(1, 68, 81, var(--border-opacity));
  }
  .group:focus .xl\\:group-focus\\:border-blue-50 {
    --border-opacity: 1;
    border-color: #ebf5ff;
    border-color: rgba(235, 245, 255, var(--border-opacity));
  }
  .group:focus .xl\\:group-focus\\:border-blue-100 {
    --border-opacity: 1;
    border-color: #e1effe;
    border-color: rgba(225, 239, 254, var(--border-opacity));
  }
  .group:focus .xl\\:group-focus\\:border-blue-200 {
    --border-opacity: 1;
    border-color: #c3ddfd;
    border-color: rgba(195, 221, 253, var(--border-opacity));
  }
  .group:focus .xl\\:group-focus\\:border-blue-300 {
    --border-opacity: 1;
    border-color: #a4cafe;
    border-color: rgba(164, 202, 254, var(--border-opacity));
  }
  .group:focus .xl\\:group-focus\\:border-blue-400 {
    --border-opacity: 1;
    border-color: #76a9fa;
    border-color: rgba(118, 169, 250, var(--border-opacity));
  }
  .group:focus .xl\\:group-focus\\:border-blue-500 {
    --border-opacity: 1;
    border-color: #3f83f8;
    border-color: rgba(63, 131, 248, var(--border-opacity));
  }
  .group:focus .xl\\:group-focus\\:border-blue-600 {
    --border-opacity: 1;
    border-color: #1c64f2;
    border-color: rgba(28, 100, 242, var(--border-opacity));
  }
  .group:focus .xl\\:group-focus\\:border-blue-700 {
    --border-opacity: 1;
    border-color: #1a56db;
    border-color: rgba(26, 86, 219, var(--border-opacity));
  }
  .group:focus .xl\\:group-focus\\:border-blue-800 {
    --border-opacity: 1;
    border-color: #1e429f;
    border-color: rgba(30, 66, 159, var(--border-opacity));
  }
  .group:focus .xl\\:group-focus\\:border-blue-900 {
    --border-opacity: 1;
    border-color: #233876;
    border-color: rgba(35, 56, 118, var(--border-opacity));
  }
  .group:focus .xl\\:group-focus\\:border-indigo-50 {
    --border-opacity: 1;
    border-color: #f0f5ff;
    border-color: rgba(240, 245, 255, var(--border-opacity));
  }
  .group:focus .xl\\:group-focus\\:border-indigo-100 {
    --border-opacity: 1;
    border-color: #e5edff;
    border-color: rgba(229, 237, 255, var(--border-opacity));
  }
  .group:focus .xl\\:group-focus\\:border-indigo-200 {
    --border-opacity: 1;
    border-color: #cddbfe;
    border-color: rgba(205, 219, 254, var(--border-opacity));
  }
  .group:focus .xl\\:group-focus\\:border-indigo-300 {
    --border-opacity: 1;
    border-color: #b4c6fc;
    border-color: rgba(180, 198, 252, var(--border-opacity));
  }
  .group:focus .xl\\:group-focus\\:border-indigo-400 {
    --border-opacity: 1;
    border-color: #8da2fb;
    border-color: rgba(141, 162, 251, var(--border-opacity));
  }
  .group:focus .xl\\:group-focus\\:border-indigo-500 {
    --border-opacity: 1;
    border-color: #6875f5;
    border-color: rgba(104, 117, 245, var(--border-opacity));
  }
  .group:focus .xl\\:group-focus\\:border-indigo-600 {
    --border-opacity: 1;
    border-color: #5850ec;
    border-color: rgba(88, 80, 236, var(--border-opacity));
  }
  .group:focus .xl\\:group-focus\\:border-indigo-700 {
    --border-opacity: 1;
    border-color: #5145cd;
    border-color: rgba(81, 69, 205, var(--border-opacity));
  }
  .group:focus .xl\\:group-focus\\:border-indigo-800 {
    --border-opacity: 1;
    border-color: #42389d;
    border-color: rgba(66, 56, 157, var(--border-opacity));
  }
  .group:focus .xl\\:group-focus\\:border-indigo-900 {
    --border-opacity: 1;
    border-color: #362f78;
    border-color: rgba(54, 47, 120, var(--border-opacity));
  }
  .group:focus .xl\\:group-focus\\:border-purple-50 {
    --border-opacity: 1;
    border-color: #f6f5ff;
    border-color: rgba(246, 245, 255, var(--border-opacity));
  }
  .group:focus .xl\\:group-focus\\:border-purple-100 {
    --border-opacity: 1;
    border-color: #edebfe;
    border-color: rgba(237, 235, 254, var(--border-opacity));
  }
  .group:focus .xl\\:group-focus\\:border-purple-200 {
    --border-opacity: 1;
    border-color: #dcd7fe;
    border-color: rgba(220, 215, 254, var(--border-opacity));
  }
  .group:focus .xl\\:group-focus\\:border-purple-300 {
    --border-opacity: 1;
    border-color: #cabffd;
    border-color: rgba(202, 191, 253, var(--border-opacity));
  }
  .group:focus .xl\\:group-focus\\:border-purple-400 {
    --border-opacity: 1;
    border-color: #ac94fa;
    border-color: rgba(172, 148, 250, var(--border-opacity));
  }
  .group:focus .xl\\:group-focus\\:border-purple-500 {
    --border-opacity: 1;
    border-color: #9061f9;
    border-color: rgba(144, 97, 249, var(--border-opacity));
  }
  .group:focus .xl\\:group-focus\\:border-purple-600 {
    --border-opacity: 1;
    border-color: #7e3af2;
    border-color: rgba(126, 58, 242, var(--border-opacity));
  }
  .group:focus .xl\\:group-focus\\:border-purple-700 {
    --border-opacity: 1;
    border-color: #6c2bd9;
    border-color: rgba(108, 43, 217, var(--border-opacity));
  }
  .group:focus .xl\\:group-focus\\:border-purple-800 {
    --border-opacity: 1;
    border-color: #5521b5;
    border-color: rgba(85, 33, 181, var(--border-opacity));
  }
  .group:focus .xl\\:group-focus\\:border-purple-900 {
    --border-opacity: 1;
    border-color: #4a1d96;
    border-color: rgba(74, 29, 150, var(--border-opacity));
  }
  .group:focus .xl\\:group-focus\\:border-pink-50 {
    --border-opacity: 1;
    border-color: #fdf2f8;
    border-color: rgba(253, 242, 248, var(--border-opacity));
  }
  .group:focus .xl\\:group-focus\\:border-pink-100 {
    --border-opacity: 1;
    border-color: #fce8f3;
    border-color: rgba(252, 232, 243, var(--border-opacity));
  }
  .group:focus .xl\\:group-focus\\:border-pink-200 {
    --border-opacity: 1;
    border-color: #fad1e8;
    border-color: rgba(250, 209, 232, var(--border-opacity));
  }
  .group:focus .xl\\:group-focus\\:border-pink-300 {
    --border-opacity: 1;
    border-color: #f8b4d9;
    border-color: rgba(248, 180, 217, var(--border-opacity));
  }
  .group:focus .xl\\:group-focus\\:border-pink-400 {
    --border-opacity: 1;
    border-color: #f17eb8;
    border-color: rgba(241, 126, 184, var(--border-opacity));
  }
  .group:focus .xl\\:group-focus\\:border-pink-500 {
    --border-opacity: 1;
    border-color: #e74694;
    border-color: rgba(231, 70, 148, var(--border-opacity));
  }
  .group:focus .xl\\:group-focus\\:border-pink-600 {
    --border-opacity: 1;
    border-color: #d61f69;
    border-color: rgba(214, 31, 105, var(--border-opacity));
  }
  .group:focus .xl\\:group-focus\\:border-pink-700 {
    --border-opacity: 1;
    border-color: #bf125d;
    border-color: rgba(191, 18, 93, var(--border-opacity));
  }
  .group:focus .xl\\:group-focus\\:border-pink-800 {
    --border-opacity: 1;
    border-color: #99154b;
    border-color: rgba(153, 21, 75, var(--border-opacity));
  }
  .group:focus .xl\\:group-focus\\:border-pink-900 {
    --border-opacity: 1;
    border-color: #751a3d;
    border-color: rgba(117, 26, 61, var(--border-opacity));
  }
  .group:focus .xl\\:group-focus\\:border-cool-gray-50 {
    --border-opacity: 1;
    border-color: #f8fafc;
    border-color: rgba(248, 250, 252, var(--border-opacity));
  }
  .group:focus .xl\\:group-focus\\:border-cool-gray-100 {
    --border-opacity: 1;
    border-color: #f1f5f9;
    border-color: rgba(241, 245, 249, var(--border-opacity));
  }
  .group:focus .xl\\:group-focus\\:border-cool-gray-200 {
    --border-opacity: 1;
    border-color: #e2e8f0;
    border-color: rgba(226, 232, 240, var(--border-opacity));
  }
  .group:focus .xl\\:group-focus\\:border-cool-gray-300 {
    --border-opacity: 1;
    border-color: #cfd8e3;
    border-color: rgba(207, 216, 227, var(--border-opacity));
  }
  .group:focus .xl\\:group-focus\\:border-cool-gray-400 {
    --border-opacity: 1;
    border-color: #97a6ba;
    border-color: rgba(151, 166, 186, var(--border-opacity));
  }
  .group:focus .xl\\:group-focus\\:border-cool-gray-500 {
    --border-opacity: 1;
    border-color: #64748b;
    border-color: rgba(100, 116, 139, var(--border-opacity));
  }
  .group:focus .xl\\:group-focus\\:border-cool-gray-600 {
    --border-opacity: 1;
    border-color: #475569;
    border-color: rgba(71, 85, 105, var(--border-opacity));
  }
  .group:focus .xl\\:group-focus\\:border-cool-gray-700 {
    --border-opacity: 1;
    border-color: #364152;
    border-color: rgba(54, 65, 82, var(--border-opacity));
  }
  .group:focus .xl\\:group-focus\\:border-cool-gray-800 {
    --border-opacity: 1;
    border-color: #27303f;
    border-color: rgba(39, 48, 63, var(--border-opacity));
  }
  .group:focus .xl\\:group-focus\\:border-cool-gray-900 {
    --border-opacity: 1;
    border-color: #1a202e;
    border-color: rgba(26, 32, 46, var(--border-opacity));
  }
  .xl\\:hover\\:border-current:hover {
    border-color: currentColor;
  }
  .xl\\:hover\\:border-transparent:hover {
    border-color: transparent;
  }
  .xl\\:hover\\:border-white:hover {
    --border-opacity: 1;
    border-color: #ffffff;
    border-color: rgba(255, 255, 255, var(--border-opacity));
  }
  .xl\\:hover\\:border-black:hover {
    --border-opacity: 1;
    border-color: #000000;
    border-color: rgba(0, 0, 0, var(--border-opacity));
  }
  .xl\\:hover\\:border-gray-50:hover {
    --border-opacity: 1;
    border-color: #f9fafb;
    border-color: rgba(249, 250, 251, var(--border-opacity));
  }
  .xl\\:hover\\:border-gray-100:hover {
    --border-opacity: 1;
    border-color: #f4f5f7;
    border-color: rgba(244, 245, 247, var(--border-opacity));
  }
  .xl\\:hover\\:border-gray-200:hover {
    --border-opacity: 1;
    border-color: #e5e7eb;
    border-color: rgba(229, 231, 235, var(--border-opacity));
  }
  .xl\\:hover\\:border-gray-300:hover {
    --border-opacity: 1;
    border-color: #d2d6dc;
    border-color: rgba(210, 214, 220, var(--border-opacity));
  }
  .xl\\:hover\\:border-gray-400:hover {
    --border-opacity: 1;
    border-color: #9fa6b2;
    border-color: rgba(159, 166, 178, var(--border-opacity));
  }
  .xl\\:hover\\:border-gray-500:hover {
    --border-opacity: 1;
    border-color: #6b7280;
    border-color: rgba(107, 114, 128, var(--border-opacity));
  }
  .xl\\:hover\\:border-gray-600:hover {
    --border-opacity: 1;
    border-color: #4b5563;
    border-color: rgba(75, 85, 99, var(--border-opacity));
  }
  .xl\\:hover\\:border-gray-700:hover {
    --border-opacity: 1;
    border-color: #374151;
    border-color: rgba(55, 65, 81, var(--border-opacity));
  }
  .xl\\:hover\\:border-gray-800:hover {
    --border-opacity: 1;
    border-color: #252f3f;
    border-color: rgba(37, 47, 63, var(--border-opacity));
  }
  .xl\\:hover\\:border-gray-900:hover {
    --border-opacity: 1;
    border-color: #161e2e;
    border-color: rgba(22, 30, 46, var(--border-opacity));
  }
  .xl\\:hover\\:border-red-50:hover {
    --border-opacity: 1;
    border-color: #fdf2f2;
    border-color: rgba(253, 242, 242, var(--border-opacity));
  }
  .xl\\:hover\\:border-red-100:hover {
    --border-opacity: 1;
    border-color: #fde8e8;
    border-color: rgba(253, 232, 232, var(--border-opacity));
  }
  .xl\\:hover\\:border-red-200:hover {
    --border-opacity: 1;
    border-color: #fbd5d5;
    border-color: rgba(251, 213, 213, var(--border-opacity));
  }
  .xl\\:hover\\:border-red-300:hover {
    --border-opacity: 1;
    border-color: #f8b4b4;
    border-color: rgba(248, 180, 180, var(--border-opacity));
  }
  .xl\\:hover\\:border-red-400:hover {
    --border-opacity: 1;
    border-color: #f98080;
    border-color: rgba(249, 128, 128, var(--border-opacity));
  }
  .xl\\:hover\\:border-red-500:hover {
    --border-opacity: 1;
    border-color: #f05252;
    border-color: rgba(240, 82, 82, var(--border-opacity));
  }
  .xl\\:hover\\:border-red-600:hover {
    --border-opacity: 1;
    border-color: #e02424;
    border-color: rgba(224, 36, 36, var(--border-opacity));
  }
  .xl\\:hover\\:border-red-700:hover {
    --border-opacity: 1;
    border-color: #c81e1e;
    border-color: rgba(200, 30, 30, var(--border-opacity));
  }
  .xl\\:hover\\:border-red-800:hover {
    --border-opacity: 1;
    border-color: #9b1c1c;
    border-color: rgba(155, 28, 28, var(--border-opacity));
  }
  .xl\\:hover\\:border-red-900:hover {
    --border-opacity: 1;
    border-color: #771d1d;
    border-color: rgba(119, 29, 29, var(--border-opacity));
  }
  .xl\\:hover\\:border-orange-50:hover {
    --border-opacity: 1;
    border-color: #fff8f1;
    border-color: rgba(255, 248, 241, var(--border-opacity));
  }
  .xl\\:hover\\:border-orange-100:hover {
    --border-opacity: 1;
    border-color: #feecdc;
    border-color: rgba(254, 236, 220, var(--border-opacity));
  }
  .xl\\:hover\\:border-orange-200:hover {
    --border-opacity: 1;
    border-color: #fcd9bd;
    border-color: rgba(252, 217, 189, var(--border-opacity));
  }
  .xl\\:hover\\:border-orange-300:hover {
    --border-opacity: 1;
    border-color: #fdba8c;
    border-color: rgba(253, 186, 140, var(--border-opacity));
  }
  .xl\\:hover\\:border-orange-400:hover {
    --border-opacity: 1;
    border-color: #ff8a4c;
    border-color: rgba(255, 138, 76, var(--border-opacity));
  }
  .xl\\:hover\\:border-orange-500:hover {
    --border-opacity: 1;
    border-color: #ff5a1f;
    border-color: rgba(255, 90, 31, var(--border-opacity));
  }
  .xl\\:hover\\:border-orange-600:hover {
    --border-opacity: 1;
    border-color: #d03801;
    border-color: rgba(208, 56, 1, var(--border-opacity));
  }
  .xl\\:hover\\:border-orange-700:hover {
    --border-opacity: 1;
    border-color: #b43403;
    border-color: rgba(180, 52, 3, var(--border-opacity));
  }
  .xl\\:hover\\:border-orange-800:hover {
    --border-opacity: 1;
    border-color: #8a2c0d;
    border-color: rgba(138, 44, 13, var(--border-opacity));
  }
  .xl\\:hover\\:border-orange-900:hover {
    --border-opacity: 1;
    border-color: #73230d;
    border-color: rgba(115, 35, 13, var(--border-opacity));
  }
  .xl\\:hover\\:border-yellow-50:hover {
    --border-opacity: 1;
    border-color: #fdfdea;
    border-color: rgba(253, 253, 234, var(--border-opacity));
  }
  .xl\\:hover\\:border-yellow-100:hover {
    --border-opacity: 1;
    border-color: #fdf6b2;
    border-color: rgba(253, 246, 178, var(--border-opacity));
  }
  .xl\\:hover\\:border-yellow-200:hover {
    --border-opacity: 1;
    border-color: #fce96a;
    border-color: rgba(252, 233, 106, var(--border-opacity));
  }
  .xl\\:hover\\:border-yellow-300:hover {
    --border-opacity: 1;
    border-color: #faca15;
    border-color: rgba(250, 202, 21, var(--border-opacity));
  }
  .xl\\:hover\\:border-yellow-400:hover {
    --border-opacity: 1;
    border-color: #e3a008;
    border-color: rgba(227, 160, 8, var(--border-opacity));
  }
  .xl\\:hover\\:border-yellow-500:hover {
    --border-opacity: 1;
    border-color: #c27803;
    border-color: rgba(194, 120, 3, var(--border-opacity));
  }
  .xl\\:hover\\:border-yellow-600:hover {
    --border-opacity: 1;
    border-color: #9f580a;
    border-color: rgba(159, 88, 10, var(--border-opacity));
  }
  .xl\\:hover\\:border-yellow-700:hover {
    --border-opacity: 1;
    border-color: #8e4b10;
    border-color: rgba(142, 75, 16, var(--border-opacity));
  }
  .xl\\:hover\\:border-yellow-800:hover {
    --border-opacity: 1;
    border-color: #723b13;
    border-color: rgba(114, 59, 19, var(--border-opacity));
  }
  .xl\\:hover\\:border-yellow-900:hover {
    --border-opacity: 1;
    border-color: #633112;
    border-color: rgba(99, 49, 18, var(--border-opacity));
  }
  .xl\\:hover\\:border-green-50:hover {
    --border-opacity: 1;
    border-color: #f3faf7;
    border-color: rgba(243, 250, 247, var(--border-opacity));
  }
  .xl\\:hover\\:border-green-100:hover {
    --border-opacity: 1;
    border-color: #def7ec;
    border-color: rgba(222, 247, 236, var(--border-opacity));
  }
  .xl\\:hover\\:border-green-200:hover {
    --border-opacity: 1;
    border-color: #bcf0da;
    border-color: rgba(188, 240, 218, var(--border-opacity));
  }
  .xl\\:hover\\:border-green-300:hover {
    --border-opacity: 1;
    border-color: #84e1bc;
    border-color: rgba(132, 225, 188, var(--border-opacity));
  }
  .xl\\:hover\\:border-green-400:hover {
    --border-opacity: 1;
    border-color: #31c48d;
    border-color: rgba(49, 196, 141, var(--border-opacity));
  }
  .xl\\:hover\\:border-green-500:hover {
    --border-opacity: 1;
    border-color: #0e9f6e;
    border-color: rgba(14, 159, 110, var(--border-opacity));
  }
  .xl\\:hover\\:border-green-600:hover {
    --border-opacity: 1;
    border-color: #057a55;
    border-color: rgba(5, 122, 85, var(--border-opacity));
  }
  .xl\\:hover\\:border-green-700:hover {
    --border-opacity: 1;
    border-color: #046c4e;
    border-color: rgba(4, 108, 78, var(--border-opacity));
  }
  .xl\\:hover\\:border-green-800:hover {
    --border-opacity: 1;
    border-color: #03543f;
    border-color: rgba(3, 84, 63, var(--border-opacity));
  }
  .xl\\:hover\\:border-green-900:hover {
    --border-opacity: 1;
    border-color: #014737;
    border-color: rgba(1, 71, 55, var(--border-opacity));
  }
  .xl\\:hover\\:border-teal-50:hover {
    --border-opacity: 1;
    border-color: #edfafa;
    border-color: rgba(237, 250, 250, var(--border-opacity));
  }
  .xl\\:hover\\:border-teal-100:hover {
    --border-opacity: 1;
    border-color: #d5f5f6;
    border-color: rgba(213, 245, 246, var(--border-opacity));
  }
  .xl\\:hover\\:border-teal-200:hover {
    --border-opacity: 1;
    border-color: #afecef;
    border-color: rgba(175, 236, 239, var(--border-opacity));
  }
  .xl\\:hover\\:border-teal-300:hover {
    --border-opacity: 1;
    border-color: #7edce2;
    border-color: rgba(126, 220, 226, var(--border-opacity));
  }
  .xl\\:hover\\:border-teal-400:hover {
    --border-opacity: 1;
    border-color: #16bdca;
    border-color: rgba(22, 189, 202, var(--border-opacity));
  }
  .xl\\:hover\\:border-teal-500:hover {
    --border-opacity: 1;
    border-color: #0694a2;
    border-color: rgba(6, 148, 162, var(--border-opacity));
  }
  .xl\\:hover\\:border-teal-600:hover {
    --border-opacity: 1;
    border-color: #047481;
    border-color: rgba(4, 116, 129, var(--border-opacity));
  }
  .xl\\:hover\\:border-teal-700:hover {
    --border-opacity: 1;
    border-color: #036672;
    border-color: rgba(3, 102, 114, var(--border-opacity));
  }
  .xl\\:hover\\:border-teal-800:hover {
    --border-opacity: 1;
    border-color: #05505c;
    border-color: rgba(5, 80, 92, var(--border-opacity));
  }
  .xl\\:hover\\:border-teal-900:hover {
    --border-opacity: 1;
    border-color: #014451;
    border-color: rgba(1, 68, 81, var(--border-opacity));
  }
  .xl\\:hover\\:border-blue-50:hover {
    --border-opacity: 1;
    border-color: #ebf5ff;
    border-color: rgba(235, 245, 255, var(--border-opacity));
  }
  .xl\\:hover\\:border-blue-100:hover {
    --border-opacity: 1;
    border-color: #e1effe;
    border-color: rgba(225, 239, 254, var(--border-opacity));
  }
  .xl\\:hover\\:border-blue-200:hover {
    --border-opacity: 1;
    border-color: #c3ddfd;
    border-color: rgba(195, 221, 253, var(--border-opacity));
  }
  .xl\\:hover\\:border-blue-300:hover {
    --border-opacity: 1;
    border-color: #a4cafe;
    border-color: rgba(164, 202, 254, var(--border-opacity));
  }
  .xl\\:hover\\:border-blue-400:hover {
    --border-opacity: 1;
    border-color: #76a9fa;
    border-color: rgba(118, 169, 250, var(--border-opacity));
  }
  .xl\\:hover\\:border-blue-500:hover {
    --border-opacity: 1;
    border-color: #3f83f8;
    border-color: rgba(63, 131, 248, var(--border-opacity));
  }
  .xl\\:hover\\:border-blue-600:hover {
    --border-opacity: 1;
    border-color: #1c64f2;
    border-color: rgba(28, 100, 242, var(--border-opacity));
  }
  .xl\\:hover\\:border-blue-700:hover {
    --border-opacity: 1;
    border-color: #1a56db;
    border-color: rgba(26, 86, 219, var(--border-opacity));
  }
  .xl\\:hover\\:border-blue-800:hover {
    --border-opacity: 1;
    border-color: #1e429f;
    border-color: rgba(30, 66, 159, var(--border-opacity));
  }
  .xl\\:hover\\:border-blue-900:hover {
    --border-opacity: 1;
    border-color: #233876;
    border-color: rgba(35, 56, 118, var(--border-opacity));
  }
  .xl\\:hover\\:border-indigo-50:hover {
    --border-opacity: 1;
    border-color: #f0f5ff;
    border-color: rgba(240, 245, 255, var(--border-opacity));
  }
  .xl\\:hover\\:border-indigo-100:hover {
    --border-opacity: 1;
    border-color: #e5edff;
    border-color: rgba(229, 237, 255, var(--border-opacity));
  }
  .xl\\:hover\\:border-indigo-200:hover {
    --border-opacity: 1;
    border-color: #cddbfe;
    border-color: rgba(205, 219, 254, var(--border-opacity));
  }
  .xl\\:hover\\:border-indigo-300:hover {
    --border-opacity: 1;
    border-color: #b4c6fc;
    border-color: rgba(180, 198, 252, var(--border-opacity));
  }
  .xl\\:hover\\:border-indigo-400:hover {
    --border-opacity: 1;
    border-color: #8da2fb;
    border-color: rgba(141, 162, 251, var(--border-opacity));
  }
  .xl\\:hover\\:border-indigo-500:hover {
    --border-opacity: 1;
    border-color: #6875f5;
    border-color: rgba(104, 117, 245, var(--border-opacity));
  }
  .xl\\:hover\\:border-indigo-600:hover {
    --border-opacity: 1;
    border-color: #5850ec;
    border-color: rgba(88, 80, 236, var(--border-opacity));
  }
  .xl\\:hover\\:border-indigo-700:hover {
    --border-opacity: 1;
    border-color: #5145cd;
    border-color: rgba(81, 69, 205, var(--border-opacity));
  }
  .xl\\:hover\\:border-indigo-800:hover {
    --border-opacity: 1;
    border-color: #42389d;
    border-color: rgba(66, 56, 157, var(--border-opacity));
  }
  .xl\\:hover\\:border-indigo-900:hover {
    --border-opacity: 1;
    border-color: #362f78;
    border-color: rgba(54, 47, 120, var(--border-opacity));
  }
  .xl\\:hover\\:border-purple-50:hover {
    --border-opacity: 1;
    border-color: #f6f5ff;
    border-color: rgba(246, 245, 255, var(--border-opacity));
  }
  .xl\\:hover\\:border-purple-100:hover {
    --border-opacity: 1;
    border-color: #edebfe;
    border-color: rgba(237, 235, 254, var(--border-opacity));
  }
  .xl\\:hover\\:border-purple-200:hover {
    --border-opacity: 1;
    border-color: #dcd7fe;
    border-color: rgba(220, 215, 254, var(--border-opacity));
  }
  .xl\\:hover\\:border-purple-300:hover {
    --border-opacity: 1;
    border-color: #cabffd;
    border-color: rgba(202, 191, 253, var(--border-opacity));
  }
  .xl\\:hover\\:border-purple-400:hover {
    --border-opacity: 1;
    border-color: #ac94fa;
    border-color: rgba(172, 148, 250, var(--border-opacity));
  }
  .xl\\:hover\\:border-purple-500:hover {
    --border-opacity: 1;
    border-color: #9061f9;
    border-color: rgba(144, 97, 249, var(--border-opacity));
  }
  .xl\\:hover\\:border-purple-600:hover {
    --border-opacity: 1;
    border-color: #7e3af2;
    border-color: rgba(126, 58, 242, var(--border-opacity));
  }
  .xl\\:hover\\:border-purple-700:hover {
    --border-opacity: 1;
    border-color: #6c2bd9;
    border-color: rgba(108, 43, 217, var(--border-opacity));
  }
  .xl\\:hover\\:border-purple-800:hover {
    --border-opacity: 1;
    border-color: #5521b5;
    border-color: rgba(85, 33, 181, var(--border-opacity));
  }
  .xl\\:hover\\:border-purple-900:hover {
    --border-opacity: 1;
    border-color: #4a1d96;
    border-color: rgba(74, 29, 150, var(--border-opacity));
  }
  .xl\\:hover\\:border-pink-50:hover {
    --border-opacity: 1;
    border-color: #fdf2f8;
    border-color: rgba(253, 242, 248, var(--border-opacity));
  }
  .xl\\:hover\\:border-pink-100:hover {
    --border-opacity: 1;
    border-color: #fce8f3;
    border-color: rgba(252, 232, 243, var(--border-opacity));
  }
  .xl\\:hover\\:border-pink-200:hover {
    --border-opacity: 1;
    border-color: #fad1e8;
    border-color: rgba(250, 209, 232, var(--border-opacity));
  }
  .xl\\:hover\\:border-pink-300:hover {
    --border-opacity: 1;
    border-color: #f8b4d9;
    border-color: rgba(248, 180, 217, var(--border-opacity));
  }
  .xl\\:hover\\:border-pink-400:hover {
    --border-opacity: 1;
    border-color: #f17eb8;
    border-color: rgba(241, 126, 184, var(--border-opacity));
  }
  .xl\\:hover\\:border-pink-500:hover {
    --border-opacity: 1;
    border-color: #e74694;
    border-color: rgba(231, 70, 148, var(--border-opacity));
  }
  .xl\\:hover\\:border-pink-600:hover {
    --border-opacity: 1;
    border-color: #d61f69;
    border-color: rgba(214, 31, 105, var(--border-opacity));
  }
  .xl\\:hover\\:border-pink-700:hover {
    --border-opacity: 1;
    border-color: #bf125d;
    border-color: rgba(191, 18, 93, var(--border-opacity));
  }
  .xl\\:hover\\:border-pink-800:hover {
    --border-opacity: 1;
    border-color: #99154b;
    border-color: rgba(153, 21, 75, var(--border-opacity));
  }
  .xl\\:hover\\:border-pink-900:hover {
    --border-opacity: 1;
    border-color: #751a3d;
    border-color: rgba(117, 26, 61, var(--border-opacity));
  }
  .xl\\:hover\\:border-cool-gray-50:hover {
    --border-opacity: 1;
    border-color: #f8fafc;
    border-color: rgba(248, 250, 252, var(--border-opacity));
  }
  .xl\\:hover\\:border-cool-gray-100:hover {
    --border-opacity: 1;
    border-color: #f1f5f9;
    border-color: rgba(241, 245, 249, var(--border-opacity));
  }
  .xl\\:hover\\:border-cool-gray-200:hover {
    --border-opacity: 1;
    border-color: #e2e8f0;
    border-color: rgba(226, 232, 240, var(--border-opacity));
  }
  .xl\\:hover\\:border-cool-gray-300:hover {
    --border-opacity: 1;
    border-color: #cfd8e3;
    border-color: rgba(207, 216, 227, var(--border-opacity));
  }
  .xl\\:hover\\:border-cool-gray-400:hover {
    --border-opacity: 1;
    border-color: #97a6ba;
    border-color: rgba(151, 166, 186, var(--border-opacity));
  }
  .xl\\:hover\\:border-cool-gray-500:hover {
    --border-opacity: 1;
    border-color: #64748b;
    border-color: rgba(100, 116, 139, var(--border-opacity));
  }
  .xl\\:hover\\:border-cool-gray-600:hover {
    --border-opacity: 1;
    border-color: #475569;
    border-color: rgba(71, 85, 105, var(--border-opacity));
  }
  .xl\\:hover\\:border-cool-gray-700:hover {
    --border-opacity: 1;
    border-color: #364152;
    border-color: rgba(54, 65, 82, var(--border-opacity));
  }
  .xl\\:hover\\:border-cool-gray-800:hover {
    --border-opacity: 1;
    border-color: #27303f;
    border-color: rgba(39, 48, 63, var(--border-opacity));
  }
  .xl\\:hover\\:border-cool-gray-900:hover {
    --border-opacity: 1;
    border-color: #1a202e;
    border-color: rgba(26, 32, 46, var(--border-opacity));
  }
  .xl\\:focus-within\\:border-current:focus-within {
    border-color: currentColor;
  }
  .xl\\:focus-within\\:border-transparent:focus-within {
    border-color: transparent;
  }
  .xl\\:focus-within\\:border-white:focus-within {
    --border-opacity: 1;
    border-color: #ffffff;
    border-color: rgba(255, 255, 255, var(--border-opacity));
  }
  .xl\\:focus-within\\:border-black:focus-within {
    --border-opacity: 1;
    border-color: #000000;
    border-color: rgba(0, 0, 0, var(--border-opacity));
  }
  .xl\\:focus-within\\:border-gray-50:focus-within {
    --border-opacity: 1;
    border-color: #f9fafb;
    border-color: rgba(249, 250, 251, var(--border-opacity));
  }
  .xl\\:focus-within\\:border-gray-100:focus-within {
    --border-opacity: 1;
    border-color: #f4f5f7;
    border-color: rgba(244, 245, 247, var(--border-opacity));
  }
  .xl\\:focus-within\\:border-gray-200:focus-within {
    --border-opacity: 1;
    border-color: #e5e7eb;
    border-color: rgba(229, 231, 235, var(--border-opacity));
  }
  .xl\\:focus-within\\:border-gray-300:focus-within {
    --border-opacity: 1;
    border-color: #d2d6dc;
    border-color: rgba(210, 214, 220, var(--border-opacity));
  }
  .xl\\:focus-within\\:border-gray-400:focus-within {
    --border-opacity: 1;
    border-color: #9fa6b2;
    border-color: rgba(159, 166, 178, var(--border-opacity));
  }
  .xl\\:focus-within\\:border-gray-500:focus-within {
    --border-opacity: 1;
    border-color: #6b7280;
    border-color: rgba(107, 114, 128, var(--border-opacity));
  }
  .xl\\:focus-within\\:border-gray-600:focus-within {
    --border-opacity: 1;
    border-color: #4b5563;
    border-color: rgba(75, 85, 99, var(--border-opacity));
  }
  .xl\\:focus-within\\:border-gray-700:focus-within {
    --border-opacity: 1;
    border-color: #374151;
    border-color: rgba(55, 65, 81, var(--border-opacity));
  }
  .xl\\:focus-within\\:border-gray-800:focus-within {
    --border-opacity: 1;
    border-color: #252f3f;
    border-color: rgba(37, 47, 63, var(--border-opacity));
  }
  .xl\\:focus-within\\:border-gray-900:focus-within {
    --border-opacity: 1;
    border-color: #161e2e;
    border-color: rgba(22, 30, 46, var(--border-opacity));
  }
  .xl\\:focus-within\\:border-red-50:focus-within {
    --border-opacity: 1;
    border-color: #fdf2f2;
    border-color: rgba(253, 242, 242, var(--border-opacity));
  }
  .xl\\:focus-within\\:border-red-100:focus-within {
    --border-opacity: 1;
    border-color: #fde8e8;
    border-color: rgba(253, 232, 232, var(--border-opacity));
  }
  .xl\\:focus-within\\:border-red-200:focus-within {
    --border-opacity: 1;
    border-color: #fbd5d5;
    border-color: rgba(251, 213, 213, var(--border-opacity));
  }
  .xl\\:focus-within\\:border-red-300:focus-within {
    --border-opacity: 1;
    border-color: #f8b4b4;
    border-color: rgba(248, 180, 180, var(--border-opacity));
  }
  .xl\\:focus-within\\:border-red-400:focus-within {
    --border-opacity: 1;
    border-color: #f98080;
    border-color: rgba(249, 128, 128, var(--border-opacity));
  }
  .xl\\:focus-within\\:border-red-500:focus-within {
    --border-opacity: 1;
    border-color: #f05252;
    border-color: rgba(240, 82, 82, var(--border-opacity));
  }
  .xl\\:focus-within\\:border-red-600:focus-within {
    --border-opacity: 1;
    border-color: #e02424;
    border-color: rgba(224, 36, 36, var(--border-opacity));
  }
  .xl\\:focus-within\\:border-red-700:focus-within {
    --border-opacity: 1;
    border-color: #c81e1e;
    border-color: rgba(200, 30, 30, var(--border-opacity));
  }
  .xl\\:focus-within\\:border-red-800:focus-within {
    --border-opacity: 1;
    border-color: #9b1c1c;
    border-color: rgba(155, 28, 28, var(--border-opacity));
  }
  .xl\\:focus-within\\:border-red-900:focus-within {
    --border-opacity: 1;
    border-color: #771d1d;
    border-color: rgba(119, 29, 29, var(--border-opacity));
  }
  .xl\\:focus-within\\:border-orange-50:focus-within {
    --border-opacity: 1;
    border-color: #fff8f1;
    border-color: rgba(255, 248, 241, var(--border-opacity));
  }
  .xl\\:focus-within\\:border-orange-100:focus-within {
    --border-opacity: 1;
    border-color: #feecdc;
    border-color: rgba(254, 236, 220, var(--border-opacity));
  }
  .xl\\:focus-within\\:border-orange-200:focus-within {
    --border-opacity: 1;
    border-color: #fcd9bd;
    border-color: rgba(252, 217, 189, var(--border-opacity));
  }
  .xl\\:focus-within\\:border-orange-300:focus-within {
    --border-opacity: 1;
    border-color: #fdba8c;
    border-color: rgba(253, 186, 140, var(--border-opacity));
  }
  .xl\\:focus-within\\:border-orange-400:focus-within {
    --border-opacity: 1;
    border-color: #ff8a4c;
    border-color: rgba(255, 138, 76, var(--border-opacity));
  }
  .xl\\:focus-within\\:border-orange-500:focus-within {
    --border-opacity: 1;
    border-color: #ff5a1f;
    border-color: rgba(255, 90, 31, var(--border-opacity));
  }
  .xl\\:focus-within\\:border-orange-600:focus-within {
    --border-opacity: 1;
    border-color: #d03801;
    border-color: rgba(208, 56, 1, var(--border-opacity));
  }
  .xl\\:focus-within\\:border-orange-700:focus-within {
    --border-opacity: 1;
    border-color: #b43403;
    border-color: rgba(180, 52, 3, var(--border-opacity));
  }
  .xl\\:focus-within\\:border-orange-800:focus-within {
    --border-opacity: 1;
    border-color: #8a2c0d;
    border-color: rgba(138, 44, 13, var(--border-opacity));
  }
  .xl\\:focus-within\\:border-orange-900:focus-within {
    --border-opacity: 1;
    border-color: #73230d;
    border-color: rgba(115, 35, 13, var(--border-opacity));
  }
  .xl\\:focus-within\\:border-yellow-50:focus-within {
    --border-opacity: 1;
    border-color: #fdfdea;
    border-color: rgba(253, 253, 234, var(--border-opacity));
  }
  .xl\\:focus-within\\:border-yellow-100:focus-within {
    --border-opacity: 1;
    border-color: #fdf6b2;
    border-color: rgba(253, 246, 178, var(--border-opacity));
  }
  .xl\\:focus-within\\:border-yellow-200:focus-within {
    --border-opacity: 1;
    border-color: #fce96a;
    border-color: rgba(252, 233, 106, var(--border-opacity));
  }
  .xl\\:focus-within\\:border-yellow-300:focus-within {
    --border-opacity: 1;
    border-color: #faca15;
    border-color: rgba(250, 202, 21, var(--border-opacity));
  }
  .xl\\:focus-within\\:border-yellow-400:focus-within {
    --border-opacity: 1;
    border-color: #e3a008;
    border-color: rgba(227, 160, 8, var(--border-opacity));
  }
  .xl\\:focus-within\\:border-yellow-500:focus-within {
    --border-opacity: 1;
    border-color: #c27803;
    border-color: rgba(194, 120, 3, var(--border-opacity));
  }
  .xl\\:focus-within\\:border-yellow-600:focus-within {
    --border-opacity: 1;
    border-color: #9f580a;
    border-color: rgba(159, 88, 10, var(--border-opacity));
  }
  .xl\\:focus-within\\:border-yellow-700:focus-within {
    --border-opacity: 1;
    border-color: #8e4b10;
    border-color: rgba(142, 75, 16, var(--border-opacity));
  }
  .xl\\:focus-within\\:border-yellow-800:focus-within {
    --border-opacity: 1;
    border-color: #723b13;
    border-color: rgba(114, 59, 19, var(--border-opacity));
  }
  .xl\\:focus-within\\:border-yellow-900:focus-within {
    --border-opacity: 1;
    border-color: #633112;
    border-color: rgba(99, 49, 18, var(--border-opacity));
  }
  .xl\\:focus-within\\:border-green-50:focus-within {
    --border-opacity: 1;
    border-color: #f3faf7;
    border-color: rgba(243, 250, 247, var(--border-opacity));
  }
  .xl\\:focus-within\\:border-green-100:focus-within {
    --border-opacity: 1;
    border-color: #def7ec;
    border-color: rgba(222, 247, 236, var(--border-opacity));
  }
  .xl\\:focus-within\\:border-green-200:focus-within {
    --border-opacity: 1;
    border-color: #bcf0da;
    border-color: rgba(188, 240, 218, var(--border-opacity));
  }
  .xl\\:focus-within\\:border-green-300:focus-within {
    --border-opacity: 1;
    border-color: #84e1bc;
    border-color: rgba(132, 225, 188, var(--border-opacity));
  }
  .xl\\:focus-within\\:border-green-400:focus-within {
    --border-opacity: 1;
    border-color: #31c48d;
    border-color: rgba(49, 196, 141, var(--border-opacity));
  }
  .xl\\:focus-within\\:border-green-500:focus-within {
    --border-opacity: 1;
    border-color: #0e9f6e;
    border-color: rgba(14, 159, 110, var(--border-opacity));
  }
  .xl\\:focus-within\\:border-green-600:focus-within {
    --border-opacity: 1;
    border-color: #057a55;
    border-color: rgba(5, 122, 85, var(--border-opacity));
  }
  .xl\\:focus-within\\:border-green-700:focus-within {
    --border-opacity: 1;
    border-color: #046c4e;
    border-color: rgba(4, 108, 78, var(--border-opacity));
  }
  .xl\\:focus-within\\:border-green-800:focus-within {
    --border-opacity: 1;
    border-color: #03543f;
    border-color: rgba(3, 84, 63, var(--border-opacity));
  }
  .xl\\:focus-within\\:border-green-900:focus-within {
    --border-opacity: 1;
    border-color: #014737;
    border-color: rgba(1, 71, 55, var(--border-opacity));
  }
  .xl\\:focus-within\\:border-teal-50:focus-within {
    --border-opacity: 1;
    border-color: #edfafa;
    border-color: rgba(237, 250, 250, var(--border-opacity));
  }
  .xl\\:focus-within\\:border-teal-100:focus-within {
    --border-opacity: 1;
    border-color: #d5f5f6;
    border-color: rgba(213, 245, 246, var(--border-opacity));
  }
  .xl\\:focus-within\\:border-teal-200:focus-within {
    --border-opacity: 1;
    border-color: #afecef;
    border-color: rgba(175, 236, 239, var(--border-opacity));
  }
  .xl\\:focus-within\\:border-teal-300:focus-within {
    --border-opacity: 1;
    border-color: #7edce2;
    border-color: rgba(126, 220, 226, var(--border-opacity));
  }
  .xl\\:focus-within\\:border-teal-400:focus-within {
    --border-opacity: 1;
    border-color: #16bdca;
    border-color: rgba(22, 189, 202, var(--border-opacity));
  }
  .xl\\:focus-within\\:border-teal-500:focus-within {
    --border-opacity: 1;
    border-color: #0694a2;
    border-color: rgba(6, 148, 162, var(--border-opacity));
  }
  .xl\\:focus-within\\:border-teal-600:focus-within {
    --border-opacity: 1;
    border-color: #047481;
    border-color: rgba(4, 116, 129, var(--border-opacity));
  }
  .xl\\:focus-within\\:border-teal-700:focus-within {
    --border-opacity: 1;
    border-color: #036672;
    border-color: rgba(3, 102, 114, var(--border-opacity));
  }
  .xl\\:focus-within\\:border-teal-800:focus-within {
    --border-opacity: 1;
    border-color: #05505c;
    border-color: rgba(5, 80, 92, var(--border-opacity));
  }
  .xl\\:focus-within\\:border-teal-900:focus-within {
    --border-opacity: 1;
    border-color: #014451;
    border-color: rgba(1, 68, 81, var(--border-opacity));
  }
  .xl\\:focus-within\\:border-blue-50:focus-within {
    --border-opacity: 1;
    border-color: #ebf5ff;
    border-color: rgba(235, 245, 255, var(--border-opacity));
  }
  .xl\\:focus-within\\:border-blue-100:focus-within {
    --border-opacity: 1;
    border-color: #e1effe;
    border-color: rgba(225, 239, 254, var(--border-opacity));
  }
  .xl\\:focus-within\\:border-blue-200:focus-within {
    --border-opacity: 1;
    border-color: #c3ddfd;
    border-color: rgba(195, 221, 253, var(--border-opacity));
  }
  .xl\\:focus-within\\:border-blue-300:focus-within {
    --border-opacity: 1;
    border-color: #a4cafe;
    border-color: rgba(164, 202, 254, var(--border-opacity));
  }
  .xl\\:focus-within\\:border-blue-400:focus-within {
    --border-opacity: 1;
    border-color: #76a9fa;
    border-color: rgba(118, 169, 250, var(--border-opacity));
  }
  .xl\\:focus-within\\:border-blue-500:focus-within {
    --border-opacity: 1;
    border-color: #3f83f8;
    border-color: rgba(63, 131, 248, var(--border-opacity));
  }
  .xl\\:focus-within\\:border-blue-600:focus-within {
    --border-opacity: 1;
    border-color: #1c64f2;
    border-color: rgba(28, 100, 242, var(--border-opacity));
  }
  .xl\\:focus-within\\:border-blue-700:focus-within {
    --border-opacity: 1;
    border-color: #1a56db;
    border-color: rgba(26, 86, 219, var(--border-opacity));
  }
  .xl\\:focus-within\\:border-blue-800:focus-within {
    --border-opacity: 1;
    border-color: #1e429f;
    border-color: rgba(30, 66, 159, var(--border-opacity));
  }
  .xl\\:focus-within\\:border-blue-900:focus-within {
    --border-opacity: 1;
    border-color: #233876;
    border-color: rgba(35, 56, 118, var(--border-opacity));
  }
  .xl\\:focus-within\\:border-indigo-50:focus-within {
    --border-opacity: 1;
    border-color: #f0f5ff;
    border-color: rgba(240, 245, 255, var(--border-opacity));
  }
  .xl\\:focus-within\\:border-indigo-100:focus-within {
    --border-opacity: 1;
    border-color: #e5edff;
    border-color: rgba(229, 237, 255, var(--border-opacity));
  }
  .xl\\:focus-within\\:border-indigo-200:focus-within {
    --border-opacity: 1;
    border-color: #cddbfe;
    border-color: rgba(205, 219, 254, var(--border-opacity));
  }
  .xl\\:focus-within\\:border-indigo-300:focus-within {
    --border-opacity: 1;
    border-color: #b4c6fc;
    border-color: rgba(180, 198, 252, var(--border-opacity));
  }
  .xl\\:focus-within\\:border-indigo-400:focus-within {
    --border-opacity: 1;
    border-color: #8da2fb;
    border-color: rgba(141, 162, 251, var(--border-opacity));
  }
  .xl\\:focus-within\\:border-indigo-500:focus-within {
    --border-opacity: 1;
    border-color: #6875f5;
    border-color: rgba(104, 117, 245, var(--border-opacity));
  }
  .xl\\:focus-within\\:border-indigo-600:focus-within {
    --border-opacity: 1;
    border-color: #5850ec;
    border-color: rgba(88, 80, 236, var(--border-opacity));
  }
  .xl\\:focus-within\\:border-indigo-700:focus-within {
    --border-opacity: 1;
    border-color: #5145cd;
    border-color: rgba(81, 69, 205, var(--border-opacity));
  }
  .xl\\:focus-within\\:border-indigo-800:focus-within {
    --border-opacity: 1;
    border-color: #42389d;
    border-color: rgba(66, 56, 157, var(--border-opacity));
  }
  .xl\\:focus-within\\:border-indigo-900:focus-within {
    --border-opacity: 1;
    border-color: #362f78;
    border-color: rgba(54, 47, 120, var(--border-opacity));
  }
  .xl\\:focus-within\\:border-purple-50:focus-within {
    --border-opacity: 1;
    border-color: #f6f5ff;
    border-color: rgba(246, 245, 255, var(--border-opacity));
  }
  .xl\\:focus-within\\:border-purple-100:focus-within {
    --border-opacity: 1;
    border-color: #edebfe;
    border-color: rgba(237, 235, 254, var(--border-opacity));
  }
  .xl\\:focus-within\\:border-purple-200:focus-within {
    --border-opacity: 1;
    border-color: #dcd7fe;
    border-color: rgba(220, 215, 254, var(--border-opacity));
  }
  .xl\\:focus-within\\:border-purple-300:focus-within {
    --border-opacity: 1;
    border-color: #cabffd;
    border-color: rgba(202, 191, 253, var(--border-opacity));
  }
  .xl\\:focus-within\\:border-purple-400:focus-within {
    --border-opacity: 1;
    border-color: #ac94fa;
    border-color: rgba(172, 148, 250, var(--border-opacity));
  }
  .xl\\:focus-within\\:border-purple-500:focus-within {
    --border-opacity: 1;
    border-color: #9061f9;
    border-color: rgba(144, 97, 249, var(--border-opacity));
  }
  .xl\\:focus-within\\:border-purple-600:focus-within {
    --border-opacity: 1;
    border-color: #7e3af2;
    border-color: rgba(126, 58, 242, var(--border-opacity));
  }
  .xl\\:focus-within\\:border-purple-700:focus-within {
    --border-opacity: 1;
    border-color: #6c2bd9;
    border-color: rgba(108, 43, 217, var(--border-opacity));
  }
  .xl\\:focus-within\\:border-purple-800:focus-within {
    --border-opacity: 1;
    border-color: #5521b5;
    border-color: rgba(85, 33, 181, var(--border-opacity));
  }
  .xl\\:focus-within\\:border-purple-900:focus-within {
    --border-opacity: 1;
    border-color: #4a1d96;
    border-color: rgba(74, 29, 150, var(--border-opacity));
  }
  .xl\\:focus-within\\:border-pink-50:focus-within {
    --border-opacity: 1;
    border-color: #fdf2f8;
    border-color: rgba(253, 242, 248, var(--border-opacity));
  }
  .xl\\:focus-within\\:border-pink-100:focus-within {
    --border-opacity: 1;
    border-color: #fce8f3;
    border-color: rgba(252, 232, 243, var(--border-opacity));
  }
  .xl\\:focus-within\\:border-pink-200:focus-within {
    --border-opacity: 1;
    border-color: #fad1e8;
    border-color: rgba(250, 209, 232, var(--border-opacity));
  }
  .xl\\:focus-within\\:border-pink-300:focus-within {
    --border-opacity: 1;
    border-color: #f8b4d9;
    border-color: rgba(248, 180, 217, var(--border-opacity));
  }
  .xl\\:focus-within\\:border-pink-400:focus-within {
    --border-opacity: 1;
    border-color: #f17eb8;
    border-color: rgba(241, 126, 184, var(--border-opacity));
  }
  .xl\\:focus-within\\:border-pink-500:focus-within {
    --border-opacity: 1;
    border-color: #e74694;
    border-color: rgba(231, 70, 148, var(--border-opacity));
  }
  .xl\\:focus-within\\:border-pink-600:focus-within {
    --border-opacity: 1;
    border-color: #d61f69;
    border-color: rgba(214, 31, 105, var(--border-opacity));
  }
  .xl\\:focus-within\\:border-pink-700:focus-within {
    --border-opacity: 1;
    border-color: #bf125d;
    border-color: rgba(191, 18, 93, var(--border-opacity));
  }
  .xl\\:focus-within\\:border-pink-800:focus-within {
    --border-opacity: 1;
    border-color: #99154b;
    border-color: rgba(153, 21, 75, var(--border-opacity));
  }
  .xl\\:focus-within\\:border-pink-900:focus-within {
    --border-opacity: 1;
    border-color: #751a3d;
    border-color: rgba(117, 26, 61, var(--border-opacity));
  }
  .xl\\:focus-within\\:border-cool-gray-50:focus-within {
    --border-opacity: 1;
    border-color: #f8fafc;
    border-color: rgba(248, 250, 252, var(--border-opacity));
  }
  .xl\\:focus-within\\:border-cool-gray-100:focus-within {
    --border-opacity: 1;
    border-color: #f1f5f9;
    border-color: rgba(241, 245, 249, var(--border-opacity));
  }
  .xl\\:focus-within\\:border-cool-gray-200:focus-within {
    --border-opacity: 1;
    border-color: #e2e8f0;
    border-color: rgba(226, 232, 240, var(--border-opacity));
  }
  .xl\\:focus-within\\:border-cool-gray-300:focus-within {
    --border-opacity: 1;
    border-color: #cfd8e3;
    border-color: rgba(207, 216, 227, var(--border-opacity));
  }
  .xl\\:focus-within\\:border-cool-gray-400:focus-within {
    --border-opacity: 1;
    border-color: #97a6ba;
    border-color: rgba(151, 166, 186, var(--border-opacity));
  }
  .xl\\:focus-within\\:border-cool-gray-500:focus-within {
    --border-opacity: 1;
    border-color: #64748b;
    border-color: rgba(100, 116, 139, var(--border-opacity));
  }
  .xl\\:focus-within\\:border-cool-gray-600:focus-within {
    --border-opacity: 1;
    border-color: #475569;
    border-color: rgba(71, 85, 105, var(--border-opacity));
  }
  .xl\\:focus-within\\:border-cool-gray-700:focus-within {
    --border-opacity: 1;
    border-color: #364152;
    border-color: rgba(54, 65, 82, var(--border-opacity));
  }
  .xl\\:focus-within\\:border-cool-gray-800:focus-within {
    --border-opacity: 1;
    border-color: #27303f;
    border-color: rgba(39, 48, 63, var(--border-opacity));
  }
  .xl\\:focus-within\\:border-cool-gray-900:focus-within {
    --border-opacity: 1;
    border-color: #1a202e;
    border-color: rgba(26, 32, 46, var(--border-opacity));
  }
  .xl\\:focus\\:border-current:focus {
    border-color: currentColor;
  }
  .xl\\:focus\\:border-transparent:focus {
    border-color: transparent;
  }
  .xl\\:focus\\:border-white:focus {
    --border-opacity: 1;
    border-color: #ffffff;
    border-color: rgba(255, 255, 255, var(--border-opacity));
  }
  .xl\\:focus\\:border-black:focus {
    --border-opacity: 1;
    border-color: #000000;
    border-color: rgba(0, 0, 0, var(--border-opacity));
  }
  .xl\\:focus\\:border-gray-50:focus {
    --border-opacity: 1;
    border-color: #f9fafb;
    border-color: rgba(249, 250, 251, var(--border-opacity));
  }
  .xl\\:focus\\:border-gray-100:focus {
    --border-opacity: 1;
    border-color: #f4f5f7;
    border-color: rgba(244, 245, 247, var(--border-opacity));
  }
  .xl\\:focus\\:border-gray-200:focus {
    --border-opacity: 1;
    border-color: #e5e7eb;
    border-color: rgba(229, 231, 235, var(--border-opacity));
  }
  .xl\\:focus\\:border-gray-300:focus {
    --border-opacity: 1;
    border-color: #d2d6dc;
    border-color: rgba(210, 214, 220, var(--border-opacity));
  }
  .xl\\:focus\\:border-gray-400:focus {
    --border-opacity: 1;
    border-color: #9fa6b2;
    border-color: rgba(159, 166, 178, var(--border-opacity));
  }
  .xl\\:focus\\:border-gray-500:focus {
    --border-opacity: 1;
    border-color: #6b7280;
    border-color: rgba(107, 114, 128, var(--border-opacity));
  }
  .xl\\:focus\\:border-gray-600:focus {
    --border-opacity: 1;
    border-color: #4b5563;
    border-color: rgba(75, 85, 99, var(--border-opacity));
  }
  .xl\\:focus\\:border-gray-700:focus {
    --border-opacity: 1;
    border-color: #374151;
    border-color: rgba(55, 65, 81, var(--border-opacity));
  }
  .xl\\:focus\\:border-gray-800:focus {
    --border-opacity: 1;
    border-color: #252f3f;
    border-color: rgba(37, 47, 63, var(--border-opacity));
  }
  .xl\\:focus\\:border-gray-900:focus {
    --border-opacity: 1;
    border-color: #161e2e;
    border-color: rgba(22, 30, 46, var(--border-opacity));
  }
  .xl\\:focus\\:border-red-50:focus {
    --border-opacity: 1;
    border-color: #fdf2f2;
    border-color: rgba(253, 242, 242, var(--border-opacity));
  }
  .xl\\:focus\\:border-red-100:focus {
    --border-opacity: 1;
    border-color: #fde8e8;
    border-color: rgba(253, 232, 232, var(--border-opacity));
  }
  .xl\\:focus\\:border-red-200:focus {
    --border-opacity: 1;
    border-color: #fbd5d5;
    border-color: rgba(251, 213, 213, var(--border-opacity));
  }
  .xl\\:focus\\:border-red-300:focus {
    --border-opacity: 1;
    border-color: #f8b4b4;
    border-color: rgba(248, 180, 180, var(--border-opacity));
  }
  .xl\\:focus\\:border-red-400:focus {
    --border-opacity: 1;
    border-color: #f98080;
    border-color: rgba(249, 128, 128, var(--border-opacity));
  }
  .xl\\:focus\\:border-red-500:focus {
    --border-opacity: 1;
    border-color: #f05252;
    border-color: rgba(240, 82, 82, var(--border-opacity));
  }
  .xl\\:focus\\:border-red-600:focus {
    --border-opacity: 1;
    border-color: #e02424;
    border-color: rgba(224, 36, 36, var(--border-opacity));
  }
  .xl\\:focus\\:border-red-700:focus {
    --border-opacity: 1;
    border-color: #c81e1e;
    border-color: rgba(200, 30, 30, var(--border-opacity));
  }
  .xl\\:focus\\:border-red-800:focus {
    --border-opacity: 1;
    border-color: #9b1c1c;
    border-color: rgba(155, 28, 28, var(--border-opacity));
  }
  .xl\\:focus\\:border-red-900:focus {
    --border-opacity: 1;
    border-color: #771d1d;
    border-color: rgba(119, 29, 29, var(--border-opacity));
  }
  .xl\\:focus\\:border-orange-50:focus {
    --border-opacity: 1;
    border-color: #fff8f1;
    border-color: rgba(255, 248, 241, var(--border-opacity));
  }
  .xl\\:focus\\:border-orange-100:focus {
    --border-opacity: 1;
    border-color: #feecdc;
    border-color: rgba(254, 236, 220, var(--border-opacity));
  }
  .xl\\:focus\\:border-orange-200:focus {
    --border-opacity: 1;
    border-color: #fcd9bd;
    border-color: rgba(252, 217, 189, var(--border-opacity));
  }
  .xl\\:focus\\:border-orange-300:focus {
    --border-opacity: 1;
    border-color: #fdba8c;
    border-color: rgba(253, 186, 140, var(--border-opacity));
  }
  .xl\\:focus\\:border-orange-400:focus {
    --border-opacity: 1;
    border-color: #ff8a4c;
    border-color: rgba(255, 138, 76, var(--border-opacity));
  }
  .xl\\:focus\\:border-orange-500:focus {
    --border-opacity: 1;
    border-color: #ff5a1f;
    border-color: rgba(255, 90, 31, var(--border-opacity));
  }
  .xl\\:focus\\:border-orange-600:focus {
    --border-opacity: 1;
    border-color: #d03801;
    border-color: rgba(208, 56, 1, var(--border-opacity));
  }
  .xl\\:focus\\:border-orange-700:focus {
    --border-opacity: 1;
    border-color: #b43403;
    border-color: rgba(180, 52, 3, var(--border-opacity));
  }
  .xl\\:focus\\:border-orange-800:focus {
    --border-opacity: 1;
    border-color: #8a2c0d;
    border-color: rgba(138, 44, 13, var(--border-opacity));
  }
  .xl\\:focus\\:border-orange-900:focus {
    --border-opacity: 1;
    border-color: #73230d;
    border-color: rgba(115, 35, 13, var(--border-opacity));
  }
  .xl\\:focus\\:border-yellow-50:focus {
    --border-opacity: 1;
    border-color: #fdfdea;
    border-color: rgba(253, 253, 234, var(--border-opacity));
  }
  .xl\\:focus\\:border-yellow-100:focus {
    --border-opacity: 1;
    border-color: #fdf6b2;
    border-color: rgba(253, 246, 178, var(--border-opacity));
  }
  .xl\\:focus\\:border-yellow-200:focus {
    --border-opacity: 1;
    border-color: #fce96a;
    border-color: rgba(252, 233, 106, var(--border-opacity));
  }
  .xl\\:focus\\:border-yellow-300:focus {
    --border-opacity: 1;
    border-color: #faca15;
    border-color: rgba(250, 202, 21, var(--border-opacity));
  }
  .xl\\:focus\\:border-yellow-400:focus {
    --border-opacity: 1;
    border-color: #e3a008;
    border-color: rgba(227, 160, 8, var(--border-opacity));
  }
  .xl\\:focus\\:border-yellow-500:focus {
    --border-opacity: 1;
    border-color: #c27803;
    border-color: rgba(194, 120, 3, var(--border-opacity));
  }
  .xl\\:focus\\:border-yellow-600:focus {
    --border-opacity: 1;
    border-color: #9f580a;
    border-color: rgba(159, 88, 10, var(--border-opacity));
  }
  .xl\\:focus\\:border-yellow-700:focus {
    --border-opacity: 1;
    border-color: #8e4b10;
    border-color: rgba(142, 75, 16, var(--border-opacity));
  }
  .xl\\:focus\\:border-yellow-800:focus {
    --border-opacity: 1;
    border-color: #723b13;
    border-color: rgba(114, 59, 19, var(--border-opacity));
  }
  .xl\\:focus\\:border-yellow-900:focus {
    --border-opacity: 1;
    border-color: #633112;
    border-color: rgba(99, 49, 18, var(--border-opacity));
  }
  .xl\\:focus\\:border-green-50:focus {
    --border-opacity: 1;
    border-color: #f3faf7;
    border-color: rgba(243, 250, 247, var(--border-opacity));
  }
  .xl\\:focus\\:border-green-100:focus {
    --border-opacity: 1;
    border-color: #def7ec;
    border-color: rgba(222, 247, 236, var(--border-opacity));
  }
  .xl\\:focus\\:border-green-200:focus {
    --border-opacity: 1;
    border-color: #bcf0da;
    border-color: rgba(188, 240, 218, var(--border-opacity));
  }
  .xl\\:focus\\:border-green-300:focus {
    --border-opacity: 1;
    border-color: #84e1bc;
    border-color: rgba(132, 225, 188, var(--border-opacity));
  }
  .xl\\:focus\\:border-green-400:focus {
    --border-opacity: 1;
    border-color: #31c48d;
    border-color: rgba(49, 196, 141, var(--border-opacity));
  }
  .xl\\:focus\\:border-green-500:focus {
    --border-opacity: 1;
    border-color: #0e9f6e;
    border-color: rgba(14, 159, 110, var(--border-opacity));
  }
  .xl\\:focus\\:border-green-600:focus {
    --border-opacity: 1;
    border-color: #057a55;
    border-color: rgba(5, 122, 85, var(--border-opacity));
  }
  .xl\\:focus\\:border-green-700:focus {
    --border-opacity: 1;
    border-color: #046c4e;
    border-color: rgba(4, 108, 78, var(--border-opacity));
  }
  .xl\\:focus\\:border-green-800:focus {
    --border-opacity: 1;
    border-color: #03543f;
    border-color: rgba(3, 84, 63, var(--border-opacity));
  }
  .xl\\:focus\\:border-green-900:focus {
    --border-opacity: 1;
    border-color: #014737;
    border-color: rgba(1, 71, 55, var(--border-opacity));
  }
  .xl\\:focus\\:border-teal-50:focus {
    --border-opacity: 1;
    border-color: #edfafa;
    border-color: rgba(237, 250, 250, var(--border-opacity));
  }
  .xl\\:focus\\:border-teal-100:focus {
    --border-opacity: 1;
    border-color: #d5f5f6;
    border-color: rgba(213, 245, 246, var(--border-opacity));
  }
  .xl\\:focus\\:border-teal-200:focus {
    --border-opacity: 1;
    border-color: #afecef;
    border-color: rgba(175, 236, 239, var(--border-opacity));
  }
  .xl\\:focus\\:border-teal-300:focus {
    --border-opacity: 1;
    border-color: #7edce2;
    border-color: rgba(126, 220, 226, var(--border-opacity));
  }
  .xl\\:focus\\:border-teal-400:focus {
    --border-opacity: 1;
    border-color: #16bdca;
    border-color: rgba(22, 189, 202, var(--border-opacity));
  }
  .xl\\:focus\\:border-teal-500:focus {
    --border-opacity: 1;
    border-color: #0694a2;
    border-color: rgba(6, 148, 162, var(--border-opacity));
  }
  .xl\\:focus\\:border-teal-600:focus {
    --border-opacity: 1;
    border-color: #047481;
    border-color: rgba(4, 116, 129, var(--border-opacity));
  }
  .xl\\:focus\\:border-teal-700:focus {
    --border-opacity: 1;
    border-color: #036672;
    border-color: rgba(3, 102, 114, var(--border-opacity));
  }
  .xl\\:focus\\:border-teal-800:focus {
    --border-opacity: 1;
    border-color: #05505c;
    border-color: rgba(5, 80, 92, var(--border-opacity));
  }
  .xl\\:focus\\:border-teal-900:focus {
    --border-opacity: 1;
    border-color: #014451;
    border-color: rgba(1, 68, 81, var(--border-opacity));
  }
  .xl\\:focus\\:border-blue-50:focus {
    --border-opacity: 1;
    border-color: #ebf5ff;
    border-color: rgba(235, 245, 255, var(--border-opacity));
  }
  .xl\\:focus\\:border-blue-100:focus {
    --border-opacity: 1;
    border-color: #e1effe;
    border-color: rgba(225, 239, 254, var(--border-opacity));
  }
  .xl\\:focus\\:border-blue-200:focus {
    --border-opacity: 1;
    border-color: #c3ddfd;
    border-color: rgba(195, 221, 253, var(--border-opacity));
  }
  .xl\\:focus\\:border-blue-300:focus {
    --border-opacity: 1;
    border-color: #a4cafe;
    border-color: rgba(164, 202, 254, var(--border-opacity));
  }
  .xl\\:focus\\:border-blue-400:focus {
    --border-opacity: 1;
    border-color: #76a9fa;
    border-color: rgba(118, 169, 250, var(--border-opacity));
  }
  .xl\\:focus\\:border-blue-500:focus {
    --border-opacity: 1;
    border-color: #3f83f8;
    border-color: rgba(63, 131, 248, var(--border-opacity));
  }
  .xl\\:focus\\:border-blue-600:focus {
    --border-opacity: 1;
    border-color: #1c64f2;
    border-color: rgba(28, 100, 242, var(--border-opacity));
  }
  .xl\\:focus\\:border-blue-700:focus {
    --border-opacity: 1;
    border-color: #1a56db;
    border-color: rgba(26, 86, 219, var(--border-opacity));
  }
  .xl\\:focus\\:border-blue-800:focus {
    --border-opacity: 1;
    border-color: #1e429f;
    border-color: rgba(30, 66, 159, var(--border-opacity));
  }
  .xl\\:focus\\:border-blue-900:focus {
    --border-opacity: 1;
    border-color: #233876;
    border-color: rgba(35, 56, 118, var(--border-opacity));
  }
  .xl\\:focus\\:border-indigo-50:focus {
    --border-opacity: 1;
    border-color: #f0f5ff;
    border-color: rgba(240, 245, 255, var(--border-opacity));
  }
  .xl\\:focus\\:border-indigo-100:focus {
    --border-opacity: 1;
    border-color: #e5edff;
    border-color: rgba(229, 237, 255, var(--border-opacity));
  }
  .xl\\:focus\\:border-indigo-200:focus {
    --border-opacity: 1;
    border-color: #cddbfe;
    border-color: rgba(205, 219, 254, var(--border-opacity));
  }
  .xl\\:focus\\:border-indigo-300:focus {
    --border-opacity: 1;
    border-color: #b4c6fc;
    border-color: rgba(180, 198, 252, var(--border-opacity));
  }
  .xl\\:focus\\:border-indigo-400:focus {
    --border-opacity: 1;
    border-color: #8da2fb;
    border-color: rgba(141, 162, 251, var(--border-opacity));
  }
  .xl\\:focus\\:border-indigo-500:focus {
    --border-opacity: 1;
    border-color: #6875f5;
    border-color: rgba(104, 117, 245, var(--border-opacity));
  }
  .xl\\:focus\\:border-indigo-600:focus {
    --border-opacity: 1;
    border-color: #5850ec;
    border-color: rgba(88, 80, 236, var(--border-opacity));
  }
  .xl\\:focus\\:border-indigo-700:focus {
    --border-opacity: 1;
    border-color: #5145cd;
    border-color: rgba(81, 69, 205, var(--border-opacity));
  }
  .xl\\:focus\\:border-indigo-800:focus {
    --border-opacity: 1;
    border-color: #42389d;
    border-color: rgba(66, 56, 157, var(--border-opacity));
  }
  .xl\\:focus\\:border-indigo-900:focus {
    --border-opacity: 1;
    border-color: #362f78;
    border-color: rgba(54, 47, 120, var(--border-opacity));
  }
  .xl\\:focus\\:border-purple-50:focus {
    --border-opacity: 1;
    border-color: #f6f5ff;
    border-color: rgba(246, 245, 255, var(--border-opacity));
  }
  .xl\\:focus\\:border-purple-100:focus {
    --border-opacity: 1;
    border-color: #edebfe;
    border-color: rgba(237, 235, 254, var(--border-opacity));
  }
  .xl\\:focus\\:border-purple-200:focus {
    --border-opacity: 1;
    border-color: #dcd7fe;
    border-color: rgba(220, 215, 254, var(--border-opacity));
  }
  .xl\\:focus\\:border-purple-300:focus {
    --border-opacity: 1;
    border-color: #cabffd;
    border-color: rgba(202, 191, 253, var(--border-opacity));
  }
  .xl\\:focus\\:border-purple-400:focus {
    --border-opacity: 1;
    border-color: #ac94fa;
    border-color: rgba(172, 148, 250, var(--border-opacity));
  }
  .xl\\:focus\\:border-purple-500:focus {
    --border-opacity: 1;
    border-color: #9061f9;
    border-color: rgba(144, 97, 249, var(--border-opacity));
  }
  .xl\\:focus\\:border-purple-600:focus {
    --border-opacity: 1;
    border-color: #7e3af2;
    border-color: rgba(126, 58, 242, var(--border-opacity));
  }
  .xl\\:focus\\:border-purple-700:focus {
    --border-opacity: 1;
    border-color: #6c2bd9;
    border-color: rgba(108, 43, 217, var(--border-opacity));
  }
  .xl\\:focus\\:border-purple-800:focus {
    --border-opacity: 1;
    border-color: #5521b5;
    border-color: rgba(85, 33, 181, var(--border-opacity));
  }
  .xl\\:focus\\:border-purple-900:focus {
    --border-opacity: 1;
    border-color: #4a1d96;
    border-color: rgba(74, 29, 150, var(--border-opacity));
  }
  .xl\\:focus\\:border-pink-50:focus {
    --border-opacity: 1;
    border-color: #fdf2f8;
    border-color: rgba(253, 242, 248, var(--border-opacity));
  }
  .xl\\:focus\\:border-pink-100:focus {
    --border-opacity: 1;
    border-color: #fce8f3;
    border-color: rgba(252, 232, 243, var(--border-opacity));
  }
  .xl\\:focus\\:border-pink-200:focus {
    --border-opacity: 1;
    border-color: #fad1e8;
    border-color: rgba(250, 209, 232, var(--border-opacity));
  }
  .xl\\:focus\\:border-pink-300:focus {
    --border-opacity: 1;
    border-color: #f8b4d9;
    border-color: rgba(248, 180, 217, var(--border-opacity));
  }
  .xl\\:focus\\:border-pink-400:focus {
    --border-opacity: 1;
    border-color: #f17eb8;
    border-color: rgba(241, 126, 184, var(--border-opacity));
  }
  .xl\\:focus\\:border-pink-500:focus {
    --border-opacity: 1;
    border-color: #e74694;
    border-color: rgba(231, 70, 148, var(--border-opacity));
  }
  .xl\\:focus\\:border-pink-600:focus {
    --border-opacity: 1;
    border-color: #d61f69;
    border-color: rgba(214, 31, 105, var(--border-opacity));
  }
  .xl\\:focus\\:border-pink-700:focus {
    --border-opacity: 1;
    border-color: #bf125d;
    border-color: rgba(191, 18, 93, var(--border-opacity));
  }
  .xl\\:focus\\:border-pink-800:focus {
    --border-opacity: 1;
    border-color: #99154b;
    border-color: rgba(153, 21, 75, var(--border-opacity));
  }
  .xl\\:focus\\:border-pink-900:focus {
    --border-opacity: 1;
    border-color: #751a3d;
    border-color: rgba(117, 26, 61, var(--border-opacity));
  }
  .xl\\:focus\\:border-cool-gray-50:focus {
    --border-opacity: 1;
    border-color: #f8fafc;
    border-color: rgba(248, 250, 252, var(--border-opacity));
  }
  .xl\\:focus\\:border-cool-gray-100:focus {
    --border-opacity: 1;
    border-color: #f1f5f9;
    border-color: rgba(241, 245, 249, var(--border-opacity));
  }
  .xl\\:focus\\:border-cool-gray-200:focus {
    --border-opacity: 1;
    border-color: #e2e8f0;
    border-color: rgba(226, 232, 240, var(--border-opacity));
  }
  .xl\\:focus\\:border-cool-gray-300:focus {
    --border-opacity: 1;
    border-color: #cfd8e3;
    border-color: rgba(207, 216, 227, var(--border-opacity));
  }
  .xl\\:focus\\:border-cool-gray-400:focus {
    --border-opacity: 1;
    border-color: #97a6ba;
    border-color: rgba(151, 166, 186, var(--border-opacity));
  }
  .xl\\:focus\\:border-cool-gray-500:focus {
    --border-opacity: 1;
    border-color: #64748b;
    border-color: rgba(100, 116, 139, var(--border-opacity));
  }
  .xl\\:focus\\:border-cool-gray-600:focus {
    --border-opacity: 1;
    border-color: #475569;
    border-color: rgba(71, 85, 105, var(--border-opacity));
  }
  .xl\\:focus\\:border-cool-gray-700:focus {
    --border-opacity: 1;
    border-color: #364152;
    border-color: rgba(54, 65, 82, var(--border-opacity));
  }
  .xl\\:focus\\:border-cool-gray-800:focus {
    --border-opacity: 1;
    border-color: #27303f;
    border-color: rgba(39, 48, 63, var(--border-opacity));
  }
  .xl\\:focus\\:border-cool-gray-900:focus {
    --border-opacity: 1;
    border-color: #1a202e;
    border-color: rgba(26, 32, 46, var(--border-opacity));
  }
  .xl\\:border-opacity-0 {
    --border-opacity: 0;
  }
  .xl\\:border-opacity-25 {
    --border-opacity: 0.25;
  }
  .xl\\:border-opacity-50 {
    --border-opacity: 0.5;
  }
  .xl\\:border-opacity-75 {
    --border-opacity: 0.75;
  }
  .xl\\:border-opacity-100 {
    --border-opacity: 1;
  }
  .xl\\:hover\\:border-opacity-0:hover {
    --border-opacity: 0;
  }
  .xl\\:hover\\:border-opacity-25:hover {
    --border-opacity: 0.25;
  }
  .xl\\:hover\\:border-opacity-50:hover {
    --border-opacity: 0.5;
  }
  .xl\\:hover\\:border-opacity-75:hover {
    --border-opacity: 0.75;
  }
  .xl\\:hover\\:border-opacity-100:hover {
    --border-opacity: 1;
  }
  .xl\\:focus\\:border-opacity-0:focus {
    --border-opacity: 0;
  }
  .xl\\:focus\\:border-opacity-25:focus {
    --border-opacity: 0.25;
  }
  .xl\\:focus\\:border-opacity-50:focus {
    --border-opacity: 0.5;
  }
  .xl\\:focus\\:border-opacity-75:focus {
    --border-opacity: 0.75;
  }
  .xl\\:focus\\:border-opacity-100:focus {
    --border-opacity: 1;
  }
  .xl\\:rounded-none {
    border-radius: 0;
  }
  .xl\\:rounded-sm {
    border-radius: 0.125rem;
  }
  .xl\\:rounded {
    border-radius: 0.25rem;
  }
  .xl\\:rounded-md {
    border-radius: 0.375rem;
  }
  .xl\\:rounded-lg {
    border-radius: 0.5rem;
  }
  .xl\\:rounded-xl {
    border-radius: 0.75rem;
  }
  .xl\\:rounded-2xl {
    border-radius: 1rem;
  }
  .xl\\:rounded-3xl {
    border-radius: 1.5rem;
  }
  .xl\\:rounded-full {
    border-radius: 9999px;
  }
  .xl\\:rounded-t-none {
    border-top-left-radius: 0;
    border-top-right-radius: 0;
  }
  .xl\\:rounded-r-none {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
  .xl\\:rounded-b-none {
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0;
  }
  .xl\\:rounded-l-none {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
  .xl\\:rounded-t-sm {
    border-top-left-radius: 0.125rem;
    border-top-right-radius: 0.125rem;
  }
  .xl\\:rounded-r-sm {
    border-top-right-radius: 0.125rem;
    border-bottom-right-radius: 0.125rem;
  }
  .xl\\:rounded-b-sm {
    border-bottom-right-radius: 0.125rem;
    border-bottom-left-radius: 0.125rem;
  }
  .xl\\:rounded-l-sm {
    border-top-left-radius: 0.125rem;
    border-bottom-left-radius: 0.125rem;
  }
  .xl\\:rounded-t {
    border-top-left-radius: 0.25rem;
    border-top-right-radius: 0.25rem;
  }
  .xl\\:rounded-r {
    border-top-right-radius: 0.25rem;
    border-bottom-right-radius: 0.25rem;
  }
  .xl\\:rounded-b {
    border-bottom-right-radius: 0.25rem;
    border-bottom-left-radius: 0.25rem;
  }
  .xl\\:rounded-l {
    border-top-left-radius: 0.25rem;
    border-bottom-left-radius: 0.25rem;
  }
  .xl\\:rounded-t-md {
    border-top-left-radius: 0.375rem;
    border-top-right-radius: 0.375rem;
  }
  .xl\\:rounded-r-md {
    border-top-right-radius: 0.375rem;
    border-bottom-right-radius: 0.375rem;
  }
  .xl\\:rounded-b-md {
    border-bottom-right-radius: 0.375rem;
    border-bottom-left-radius: 0.375rem;
  }
  .xl\\:rounded-l-md {
    border-top-left-radius: 0.375rem;
    border-bottom-left-radius: 0.375rem;
  }
  .xl\\:rounded-t-lg {
    border-top-left-radius: 0.5rem;
    border-top-right-radius: 0.5rem;
  }
  .xl\\:rounded-r-lg {
    border-top-right-radius: 0.5rem;
    border-bottom-right-radius: 0.5rem;
  }
  .xl\\:rounded-b-lg {
    border-bottom-right-radius: 0.5rem;
    border-bottom-left-radius: 0.5rem;
  }
  .xl\\:rounded-l-lg {
    border-top-left-radius: 0.5rem;
    border-bottom-left-radius: 0.5rem;
  }
  .xl\\:rounded-t-xl {
    border-top-left-radius: 0.75rem;
    border-top-right-radius: 0.75rem;
  }
  .xl\\:rounded-r-xl {
    border-top-right-radius: 0.75rem;
    border-bottom-right-radius: 0.75rem;
  }
  .xl\\:rounded-b-xl {
    border-bottom-right-radius: 0.75rem;
    border-bottom-left-radius: 0.75rem;
  }
  .xl\\:rounded-l-xl {
    border-top-left-radius: 0.75rem;
    border-bottom-left-radius: 0.75rem;
  }
  .xl\\:rounded-t-2xl {
    border-top-left-radius: 1rem;
    border-top-right-radius: 1rem;
  }
  .xl\\:rounded-r-2xl {
    border-top-right-radius: 1rem;
    border-bottom-right-radius: 1rem;
  }
  .xl\\:rounded-b-2xl {
    border-bottom-right-radius: 1rem;
    border-bottom-left-radius: 1rem;
  }
  .xl\\:rounded-l-2xl {
    border-top-left-radius: 1rem;
    border-bottom-left-radius: 1rem;
  }
  .xl\\:rounded-t-3xl {
    border-top-left-radius: 1.5rem;
    border-top-right-radius: 1.5rem;
  }
  .xl\\:rounded-r-3xl {
    border-top-right-radius: 1.5rem;
    border-bottom-right-radius: 1.5rem;
  }
  .xl\\:rounded-b-3xl {
    border-bottom-right-radius: 1.5rem;
    border-bottom-left-radius: 1.5rem;
  }
  .xl\\:rounded-l-3xl {
    border-top-left-radius: 1.5rem;
    border-bottom-left-radius: 1.5rem;
  }
  .xl\\:rounded-t-full {
    border-top-left-radius: 9999px;
    border-top-right-radius: 9999px;
  }
  .xl\\:rounded-r-full {
    border-top-right-radius: 9999px;
    border-bottom-right-radius: 9999px;
  }
  .xl\\:rounded-b-full {
    border-bottom-right-radius: 9999px;
    border-bottom-left-radius: 9999px;
  }
  .xl\\:rounded-l-full {
    border-top-left-radius: 9999px;
    border-bottom-left-radius: 9999px;
  }
  .xl\\:rounded-tl-none {
    border-top-left-radius: 0;
  }
  .xl\\:rounded-tr-none {
    border-top-right-radius: 0;
  }
  .xl\\:rounded-br-none {
    border-bottom-right-radius: 0;
  }
  .xl\\:rounded-bl-none {
    border-bottom-left-radius: 0;
  }
  .xl\\:rounded-tl-sm {
    border-top-left-radius: 0.125rem;
  }
  .xl\\:rounded-tr-sm {
    border-top-right-radius: 0.125rem;
  }
  .xl\\:rounded-br-sm {
    border-bottom-right-radius: 0.125rem;
  }
  .xl\\:rounded-bl-sm {
    border-bottom-left-radius: 0.125rem;
  }
  .xl\\:rounded-tl {
    border-top-left-radius: 0.25rem;
  }
  .xl\\:rounded-tr {
    border-top-right-radius: 0.25rem;
  }
  .xl\\:rounded-br {
    border-bottom-right-radius: 0.25rem;
  }
  .xl\\:rounded-bl {
    border-bottom-left-radius: 0.25rem;
  }
  .xl\\:rounded-tl-md {
    border-top-left-radius: 0.375rem;
  }
  .xl\\:rounded-tr-md {
    border-top-right-radius: 0.375rem;
  }
  .xl\\:rounded-br-md {
    border-bottom-right-radius: 0.375rem;
  }
  .xl\\:rounded-bl-md {
    border-bottom-left-radius: 0.375rem;
  }
  .xl\\:rounded-tl-lg {
    border-top-left-radius: 0.5rem;
  }
  .xl\\:rounded-tr-lg {
    border-top-right-radius: 0.5rem;
  }
  .xl\\:rounded-br-lg {
    border-bottom-right-radius: 0.5rem;
  }
  .xl\\:rounded-bl-lg {
    border-bottom-left-radius: 0.5rem;
  }
  .xl\\:rounded-tl-xl {
    border-top-left-radius: 0.75rem;
  }
  .xl\\:rounded-tr-xl {
    border-top-right-radius: 0.75rem;
  }
  .xl\\:rounded-br-xl {
    border-bottom-right-radius: 0.75rem;
  }
  .xl\\:rounded-bl-xl {
    border-bottom-left-radius: 0.75rem;
  }
  .xl\\:rounded-tl-2xl {
    border-top-left-radius: 1rem;
  }
  .xl\\:rounded-tr-2xl {
    border-top-right-radius: 1rem;
  }
  .xl\\:rounded-br-2xl {
    border-bottom-right-radius: 1rem;
  }
  .xl\\:rounded-bl-2xl {
    border-bottom-left-radius: 1rem;
  }
  .xl\\:rounded-tl-3xl {
    border-top-left-radius: 1.5rem;
  }
  .xl\\:rounded-tr-3xl {
    border-top-right-radius: 1.5rem;
  }
  .xl\\:rounded-br-3xl {
    border-bottom-right-radius: 1.5rem;
  }
  .xl\\:rounded-bl-3xl {
    border-bottom-left-radius: 1.5rem;
  }
  .xl\\:rounded-tl-full {
    border-top-left-radius: 9999px;
  }
  .xl\\:rounded-tr-full {
    border-top-right-radius: 9999px;
  }
  .xl\\:rounded-br-full {
    border-bottom-right-radius: 9999px;
  }
  .xl\\:rounded-bl-full {
    border-bottom-left-radius: 9999px;
  }
  .xl\\:border-solid {
    border-style: solid;
  }
  .xl\\:border-dashed {
    border-style: dashed;
  }
  .xl\\:border-dotted {
    border-style: dotted;
  }
  .xl\\:border-double {
    border-style: double;
  }
  .xl\\:border-none {
    border-style: none;
  }
  .xl\\:border-0 {
    border-width: 0;
  }
  .xl\\:border-2 {
    border-width: 2px;
  }
  .xl\\:border-4 {
    border-width: 4px;
  }
  .xl\\:border-8 {
    border-width: 8px;
  }
  .xl\\:border {
    border-width: 1px;
  }
  .xl\\:border-t-0 {
    border-top-width: 0;
  }
  .xl\\:border-r-0 {
    border-right-width: 0;
  }
  .xl\\:border-b-0 {
    border-bottom-width: 0;
  }
  .xl\\:border-l-0 {
    border-left-width: 0;
  }
  .xl\\:border-t-2 {
    border-top-width: 2px;
  }
  .xl\\:border-r-2 {
    border-right-width: 2px;
  }
  .xl\\:border-b-2 {
    border-bottom-width: 2px;
  }
  .xl\\:border-l-2 {
    border-left-width: 2px;
  }
  .xl\\:border-t-4 {
    border-top-width: 4px;
  }
  .xl\\:border-r-4 {
    border-right-width: 4px;
  }
  .xl\\:border-b-4 {
    border-bottom-width: 4px;
  }
  .xl\\:border-l-4 {
    border-left-width: 4px;
  }
  .xl\\:border-t-8 {
    border-top-width: 8px;
  }
  .xl\\:border-r-8 {
    border-right-width: 8px;
  }
  .xl\\:border-b-8 {
    border-bottom-width: 8px;
  }
  .xl\\:border-l-8 {
    border-left-width: 8px;
  }
  .xl\\:border-t {
    border-top-width: 1px;
  }
  .xl\\:border-r {
    border-right-width: 1px;
  }
  .xl\\:border-b {
    border-bottom-width: 1px;
  }
  .xl\\:border-l {
    border-left-width: 1px;
  }
  .xl\\:box-border {
    box-sizing: border-box;
  }
  .xl\\:box-content {
    box-sizing: content-box;
  }
  .xl\\:cursor-auto {
    cursor: auto;
  }
  .xl\\:cursor-default {
    cursor: default;
  }
  .xl\\:cursor-pointer {
    cursor: pointer;
  }
  .xl\\:cursor-wait {
    cursor: wait;
  }
  .xl\\:cursor-text {
    cursor: text;
  }
  .xl\\:cursor-move {
    cursor: move;
  }
  .xl\\:cursor-not-allowed {
    cursor: not-allowed;
  }
  .xl\\:block {
    display: block;
  }
  .xl\\:inline-block {
    display: inline-block;
  }
  .xl\\:inline {
    display: inline;
  }
  .xl\\:flex {
    display: flex;
  }
  .xl\\:inline-flex {
    display: inline-flex;
  }
  .xl\\:table {
    display: table;
  }
  .xl\\:table-caption {
    display: table-caption;
  }
  .xl\\:table-cell {
    display: table-cell;
  }
  .xl\\:table-column {
    display: table-column;
  }
  .xl\\:table-column-group {
    display: table-column-group;
  }
  .xl\\:table-footer-group {
    display: table-footer-group;
  }
  .xl\\:table-header-group {
    display: table-header-group;
  }
  .xl\\:table-row-group {
    display: table-row-group;
  }
  .xl\\:table-row {
    display: table-row;
  }
  .xl\\:flow-root {
    display: flow-root;
  }
  .xl\\:grid {
    display: grid;
  }
  .xl\\:inline-grid {
    display: inline-grid;
  }
  .xl\\:contents {
    display: contents;
  }
  .xl\\:hidden {
    display: none;
  }
  .xl\\:flex-row {
    flex-direction: row;
  }
  .xl\\:flex-row-reverse {
    flex-direction: row-reverse;
  }
  .xl\\:flex-col {
    flex-direction: column;
  }
  .xl\\:flex-col-reverse {
    flex-direction: column-reverse;
  }
  .xl\\:flex-wrap {
    flex-wrap: wrap;
  }
  .xl\\:flex-wrap-reverse {
    flex-wrap: wrap-reverse;
  }
  .xl\\:flex-no-wrap {
    flex-wrap: nowrap;
  }
  .xl\\:place-items-auto {
    place-items: auto;
  }
  .xl\\:place-items-start {
    place-items: start;
  }
  .xl\\:place-items-end {
    place-items: end;
  }
  .xl\\:place-items-center {
    place-items: center;
  }
  .xl\\:place-items-stretch {
    place-items: stretch;
  }
  .xl\\:place-content-center {
    place-content: center;
  }
  .xl\\:place-content-start {
    place-content: start;
  }
  .xl\\:place-content-end {
    place-content: end;
  }
  .xl\\:place-content-between {
    place-content: space-between;
  }
  .xl\\:place-content-around {
    place-content: space-around;
  }
  .xl\\:place-content-evenly {
    place-content: space-evenly;
  }
  .xl\\:place-content-stretch {
    place-content: stretch;
  }
  .xl\\:place-self-auto {
    place-self: auto;
  }
  .xl\\:place-self-start {
    place-self: start;
  }
  .xl\\:place-self-end {
    place-self: end;
  }
  .xl\\:place-self-center {
    place-self: center;
  }
  .xl\\:place-self-stretch {
    place-self: stretch;
  }
  .xl\\:items-start {
    align-items: flex-start;
  }
  .xl\\:items-end {
    align-items: flex-end;
  }
  .xl\\:items-center {
    align-items: center;
  }
  .xl\\:items-baseline {
    align-items: baseline;
  }
  .xl\\:items-stretch {
    align-items: stretch;
  }
  .xl\\:content-center {
    align-content: center;
  }
  .xl\\:content-start {
    align-content: flex-start;
  }
  .xl\\:content-end {
    align-content: flex-end;
  }
  .xl\\:content-between {
    align-content: space-between;
  }
  .xl\\:content-around {
    align-content: space-around;
  }
  .xl\\:content-evenly {
    align-content: space-evenly;
  }
  .xl\\:self-auto {
    align-self: auto;
  }
  .xl\\:self-start {
    align-self: flex-start;
  }
  .xl\\:self-end {
    align-self: flex-end;
  }
  .xl\\:self-center {
    align-self: center;
  }
  .xl\\:self-stretch {
    align-self: stretch;
  }
  .xl\\:justify-items-auto {
    justify-items: auto;
  }
  .xl\\:justify-items-start {
    justify-items: start;
  }
  .xl\\:justify-items-end {
    justify-items: end;
  }
  .xl\\:justify-items-center {
    justify-items: center;
  }
  .xl\\:justify-items-stretch {
    justify-items: stretch;
  }
  .xl\\:justify-start {
    justify-content: flex-start;
  }
  .xl\\:justify-end {
    justify-content: flex-end;
  }
  .xl\\:justify-center {
    justify-content: center;
  }
  .xl\\:justify-between {
    justify-content: space-between;
  }
  .xl\\:justify-around {
    justify-content: space-around;
  }
  .xl\\:justify-evenly {
    justify-content: space-evenly;
  }
  .xl\\:justify-self-auto {
    justify-self: auto;
  }
  .xl\\:justify-self-start {
    justify-self: start;
  }
  .xl\\:justify-self-end {
    justify-self: end;
  }
  .xl\\:justify-self-center {
    justify-self: center;
  }
  .xl\\:justify-self-stretch {
    justify-self: stretch;
  }
  .xl\\:flex-1 {
    flex: 1 1;
  }
  .xl\\:flex-auto {
    flex: 1 1 auto;
  }
  .xl\\:flex-initial {
    flex: 0 1 auto;
  }
  .xl\\:flex-none {
    flex: none;
  }
  .xl\\:flex-grow-0 {
    flex-grow: 0;
  }
  .xl\\:flex-grow {
    flex-grow: 1;
  }
  .xl\\:flex-shrink-0 {
    flex-shrink: 0;
  }
  .xl\\:flex-shrink {
    flex-shrink: 1;
  }
  .xl\\:order-1 {
    order: 1;
  }
  .xl\\:order-2 {
    order: 2;
  }
  .xl\\:order-3 {
    order: 3;
  }
  .xl\\:order-4 {
    order: 4;
  }
  .xl\\:order-5 {
    order: 5;
  }
  .xl\\:order-6 {
    order: 6;
  }
  .xl\\:order-7 {
    order: 7;
  }
  .xl\\:order-8 {
    order: 8;
  }
  .xl\\:order-9 {
    order: 9;
  }
  .xl\\:order-10 {
    order: 10;
  }
  .xl\\:order-11 {
    order: 11;
  }
  .xl\\:order-12 {
    order: 12;
  }
  .xl\\:order-first {
    order: -9999;
  }
  .xl\\:order-last {
    order: 9999;
  }
  .xl\\:order-none {
    order: 0;
  }
  .xl\\:float-right {
    float: right;
  }
  .xl\\:float-left {
    float: left;
  }
  .xl\\:float-none {
    float: none;
  }
  .xl\\:clearfix:after {
    content: "";
    display: table;
    clear: both;
  }
  .xl\\:clear-left {
    clear: left;
  }
  .xl\\:clear-right {
    clear: right;
  }
  .xl\\:clear-both {
    clear: both;
  }
  .xl\\:clear-none {
    clear: none;
  }
  .xl\\:font-sans {
    font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  }
  .xl\\:font-serif {
    font-family: Georgia, Cambria, "Times New Roman", Times, serif;
  }
  .xl\\:font-mono {
    font-family: Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  }
  .xl\\:font-hairline {
    font-weight: 100;
  }
  .xl\\:font-thin {
    font-weight: 200;
  }
  .xl\\:font-light {
    font-weight: 300;
  }
  .xl\\:font-normal {
    font-weight: 400;
  }
  .xl\\:font-medium {
    font-weight: 500;
  }
  .xl\\:font-semibold {
    font-weight: 600;
  }
  .xl\\:font-bold {
    font-weight: 700;
  }
  .xl\\:font-extrabold {
    font-weight: 800;
  }
  .xl\\:font-black {
    font-weight: 900;
  }
  .xl\\:hover\\:font-hairline:hover {
    font-weight: 100;
  }
  .xl\\:hover\\:font-thin:hover {
    font-weight: 200;
  }
  .xl\\:hover\\:font-light:hover {
    font-weight: 300;
  }
  .xl\\:hover\\:font-normal:hover {
    font-weight: 400;
  }
  .xl\\:hover\\:font-medium:hover {
    font-weight: 500;
  }
  .xl\\:hover\\:font-semibold:hover {
    font-weight: 600;
  }
  .xl\\:hover\\:font-bold:hover {
    font-weight: 700;
  }
  .xl\\:hover\\:font-extrabold:hover {
    font-weight: 800;
  }
  .xl\\:hover\\:font-black:hover {
    font-weight: 900;
  }
  .xl\\:focus\\:font-hairline:focus {
    font-weight: 100;
  }
  .xl\\:focus\\:font-thin:focus {
    font-weight: 200;
  }
  .xl\\:focus\\:font-light:focus {
    font-weight: 300;
  }
  .xl\\:focus\\:font-normal:focus {
    font-weight: 400;
  }
  .xl\\:focus\\:font-medium:focus {
    font-weight: 500;
  }
  .xl\\:focus\\:font-semibold:focus {
    font-weight: 600;
  }
  .xl\\:focus\\:font-bold:focus {
    font-weight: 700;
  }
  .xl\\:focus\\:font-extrabold:focus {
    font-weight: 800;
  }
  .xl\\:focus\\:font-black:focus {
    font-weight: 900;
  }
  .xl\\:h-0 {
    height: 0;
  }
  .xl\\:h-1 {
    height: 0.25rem;
  }
  .xl\\:h-2 {
    height: 0.5rem;
  }
  .xl\\:h-3 {
    height: 0.75rem;
  }
  .xl\\:h-4 {
    height: 1rem;
  }
  .xl\\:h-5 {
    height: 1.25rem;
  }
  .xl\\:h-6 {
    height: 1.5rem;
  }
  .xl\\:h-7 {
    height: 1.75rem;
  }
  .xl\\:h-8 {
    height: 2rem;
  }
  .xl\\:h-9 {
    height: 2.25rem;
  }
  .xl\\:h-10 {
    height: 2.5rem;
  }
  .xl\\:h-11 {
    height: 2.75rem;
  }
  .xl\\:h-12 {
    height: 3rem;
  }
  .xl\\:h-13 {
    height: 3.25rem;
  }
  .xl\\:h-14 {
    height: 3.5rem;
  }
  .xl\\:h-15 {
    height: 3.75rem;
  }
  .xl\\:h-16 {
    height: 4rem;
  }
  .xl\\:h-20 {
    height: 5rem;
  }
  .xl\\:h-24 {
    height: 6rem;
  }
  .xl\\:h-28 {
    height: 7rem;
  }
  .xl\\:h-32 {
    height: 8rem;
  }
  .xl\\:h-36 {
    height: 9rem;
  }
  .xl\\:h-40 {
    height: 10rem;
  }
  .xl\\:h-44 {
    height: 11rem;
  }
  .xl\\:h-48 {
    height: 12rem;
  }
  .xl\\:h-52 {
    height: 13rem;
  }
  .xl\\:h-56 {
    height: 14rem;
  }
  .xl\\:h-60 {
    height: 15rem;
  }
  .xl\\:h-64 {
    height: 16rem;
  }
  .xl\\:h-72 {
    height: 18rem;
  }
  .xl\\:h-80 {
    height: 20rem;
  }
  .xl\\:h-96 {
    height: 24rem;
  }
  .xl\\:h-auto {
    height: auto;
  }
  .xl\\:h-px {
    height: 1px;
  }
  .xl\\:h-0\\.5 {
    height: 0.125rem;
  }
  .xl\\:h-1\\.5 {
    height: 0.375rem;
  }
  .xl\\:h-2\\.5 {
    height: 0.625rem;
  }
  .xl\\:h-3\\.5 {
    height: 0.875rem;
  }
  .xl\\:h-1\\/2 {
    height: 50%;
  }
  .xl\\:h-1\\/3 {
    height: 33.333333%;
  }
  .xl\\:h-2\\/3 {
    height: 66.666667%;
  }
  .xl\\:h-1\\/4 {
    height: 25%;
  }
  .xl\\:h-2\\/4 {
    height: 50%;
  }
  .xl\\:h-3\\/4 {
    height: 75%;
  }
  .xl\\:h-1\\/5 {
    height: 20%;
  }
  .xl\\:h-2\\/5 {
    height: 40%;
  }
  .xl\\:h-3\\/5 {
    height: 60%;
  }
  .xl\\:h-4\\/5 {
    height: 80%;
  }
  .xl\\:h-1\\/6 {
    height: 16.666667%;
  }
  .xl\\:h-2\\/6 {
    height: 33.333333%;
  }
  .xl\\:h-3\\/6 {
    height: 50%;
  }
  .xl\\:h-4\\/6 {
    height: 66.666667%;
  }
  .xl\\:h-5\\/6 {
    height: 83.333333%;
  }
  .xl\\:h-1\\/12 {
    height: 8.333333%;
  }
  .xl\\:h-2\\/12 {
    height: 16.666667%;
  }
  .xl\\:h-3\\/12 {
    height: 25%;
  }
  .xl\\:h-4\\/12 {
    height: 33.333333%;
  }
  .xl\\:h-5\\/12 {
    height: 41.666667%;
  }
  .xl\\:h-6\\/12 {
    height: 50%;
  }
  .xl\\:h-7\\/12 {
    height: 58.333333%;
  }
  .xl\\:h-8\\/12 {
    height: 66.666667%;
  }
  .xl\\:h-9\\/12 {
    height: 75%;
  }
  .xl\\:h-10\\/12 {
    height: 83.333333%;
  }
  .xl\\:h-11\\/12 {
    height: 91.666667%;
  }
  .xl\\:h-full {
    height: 100%;
  }
  .xl\\:h-screen {
    height: 100vh;
  }
  .xl\\:text-xs {
    font-size: 0.75rem;
  }
  .xl\\:text-sm {
    font-size: 0.875rem;
  }
  .xl\\:text-base {
    font-size: 1rem;
  }
  .xl\\:text-lg {
    font-size: 1.125rem;
  }
  .xl\\:text-xl {
    font-size: 1.25rem;
  }
  .xl\\:text-2xl {
    font-size: 1.5rem;
  }
  .xl\\:text-3xl {
    font-size: 1.875rem;
  }
  .xl\\:text-4xl {
    font-size: 2.25rem;
  }
  .xl\\:text-5xl {
    font-size: 3rem;
  }
  .xl\\:text-6xl {
    font-size: 4rem;
  }
  .xl\\:leading-3 {
    line-height: .75rem;
  }
  .xl\\:leading-4 {
    line-height: 1rem;
  }
  .xl\\:leading-5 {
    line-height: 1.25rem;
  }
  .xl\\:leading-6 {
    line-height: 1.5rem;
  }
  .xl\\:leading-7 {
    line-height: 1.75rem;
  }
  .xl\\:leading-8 {
    line-height: 2rem;
  }
  .xl\\:leading-9 {
    line-height: 2.25rem;
  }
  .xl\\:leading-10 {
    line-height: 2.5rem;
  }
  .xl\\:leading-none {
    line-height: 1;
  }
  .xl\\:leading-tight {
    line-height: 1.25;
  }
  .xl\\:leading-snug {
    line-height: 1.375;
  }
  .xl\\:leading-normal {
    line-height: 1.5;
  }
  .xl\\:leading-relaxed {
    line-height: 1.625;
  }
  .xl\\:leading-loose {
    line-height: 2;
  }
  .xl\\:list-inside {
    list-style-position: inside;
  }
  .xl\\:list-outside {
    list-style-position: outside;
  }
  .xl\\:list-none {
    list-style-type: none;
  }
  .xl\\:list-disc {
    list-style-type: disc;
  }
  .xl\\:list-decimal {
    list-style-type: decimal;
  }
  .xl\\:m-0 {
    margin: 0;
  }
  .xl\\:m-1 {
    margin: 0.25rem;
  }
  .xl\\:m-2 {
    margin: 0.5rem;
  }
  .xl\\:m-3 {
    margin: 0.75rem;
  }
  .xl\\:m-4 {
    margin: 1rem;
  }
  .xl\\:m-5 {
    margin: 1.25rem;
  }
  .xl\\:m-6 {
    margin: 1.5rem;
  }
  .xl\\:m-7 {
    margin: 1.75rem;
  }
  .xl\\:m-8 {
    margin: 2rem;
  }
  .xl\\:m-9 {
    margin: 2.25rem;
  }
  .xl\\:m-10 {
    margin: 2.5rem;
  }
  .xl\\:m-11 {
    margin: 2.75rem;
  }
  .xl\\:m-12 {
    margin: 3rem;
  }
  .xl\\:m-13 {
    margin: 3.25rem;
  }
  .xl\\:m-14 {
    margin: 3.5rem;
  }
  .xl\\:m-15 {
    margin: 3.75rem;
  }
  .xl\\:m-16 {
    margin: 4rem;
  }
  .xl\\:m-20 {
    margin: 5rem;
  }
  .xl\\:m-24 {
    margin: 6rem;
  }
  .xl\\:m-28 {
    margin: 7rem;
  }
  .xl\\:m-32 {
    margin: 8rem;
  }
  .xl\\:m-36 {
    margin: 9rem;
  }
  .xl\\:m-40 {
    margin: 10rem;
  }
  .xl\\:m-44 {
    margin: 11rem;
  }
  .xl\\:m-48 {
    margin: 12rem;
  }
  .xl\\:m-52 {
    margin: 13rem;
  }
  .xl\\:m-56 {
    margin: 14rem;
  }
  .xl\\:m-60 {
    margin: 15rem;
  }
  .xl\\:m-64 {
    margin: 16rem;
  }
  .xl\\:m-72 {
    margin: 18rem;
  }
  .xl\\:m-80 {
    margin: 20rem;
  }
  .xl\\:m-96 {
    margin: 24rem;
  }
  .xl\\:m-auto {
    margin: auto;
  }
  .xl\\:m-px {
    margin: 1px;
  }
  .xl\\:m-0\\.5 {
    margin: 0.125rem;
  }
  .xl\\:m-1\\.5 {
    margin: 0.375rem;
  }
  .xl\\:m-2\\.5 {
    margin: 0.625rem;
  }
  .xl\\:m-3\\.5 {
    margin: 0.875rem;
  }
  .xl\\:m-1\\/2 {
    margin: 50%;
  }
  .xl\\:m-1\\/3 {
    margin: 33.333333%;
  }
  .xl\\:m-2\\/3 {
    margin: 66.666667%;
  }
  .xl\\:m-1\\/4 {
    margin: 25%;
  }
  .xl\\:m-2\\/4 {
    margin: 50%;
  }
  .xl\\:m-3\\/4 {
    margin: 75%;
  }
  .xl\\:m-1\\/5 {
    margin: 20%;
  }
  .xl\\:m-2\\/5 {
    margin: 40%;
  }
  .xl\\:m-3\\/5 {
    margin: 60%;
  }
  .xl\\:m-4\\/5 {
    margin: 80%;
  }
  .xl\\:m-1\\/6 {
    margin: 16.666667%;
  }
  .xl\\:m-2\\/6 {
    margin: 33.333333%;
  }
  .xl\\:m-3\\/6 {
    margin: 50%;
  }
  .xl\\:m-4\\/6 {
    margin: 66.666667%;
  }
  .xl\\:m-5\\/6 {
    margin: 83.333333%;
  }
  .xl\\:m-1\\/12 {
    margin: 8.333333%;
  }
  .xl\\:m-2\\/12 {
    margin: 16.666667%;
  }
  .xl\\:m-3\\/12 {
    margin: 25%;
  }
  .xl\\:m-4\\/12 {
    margin: 33.333333%;
  }
  .xl\\:m-5\\/12 {
    margin: 41.666667%;
  }
  .xl\\:m-6\\/12 {
    margin: 50%;
  }
  .xl\\:m-7\\/12 {
    margin: 58.333333%;
  }
  .xl\\:m-8\\/12 {
    margin: 66.666667%;
  }
  .xl\\:m-9\\/12 {
    margin: 75%;
  }
  .xl\\:m-10\\/12 {
    margin: 83.333333%;
  }
  .xl\\:m-11\\/12 {
    margin: 91.666667%;
  }
  .xl\\:m-full {
    margin: 100%;
  }
  .xl\\:-m-1 {
    margin: -0.25rem;
  }
  .xl\\:-m-2 {
    margin: -0.5rem;
  }
  .xl\\:-m-3 {
    margin: -0.75rem;
  }
  .xl\\:-m-4 {
    margin: -1rem;
  }
  .xl\\:-m-5 {
    margin: -1.25rem;
  }
  .xl\\:-m-6 {
    margin: -1.5rem;
  }
  .xl\\:-m-7 {
    margin: -1.75rem;
  }
  .xl\\:-m-8 {
    margin: -2rem;
  }
  .xl\\:-m-9 {
    margin: -2.25rem;
  }
  .xl\\:-m-10 {
    margin: -2.5rem;
  }
  .xl\\:-m-11 {
    margin: -2.75rem;
  }
  .xl\\:-m-12 {
    margin: -3rem;
  }
  .xl\\:-m-13 {
    margin: -3.25rem;
  }
  .xl\\:-m-14 {
    margin: -3.5rem;
  }
  .xl\\:-m-15 {
    margin: -3.75rem;
  }
  .xl\\:-m-16 {
    margin: -4rem;
  }
  .xl\\:-m-20 {
    margin: -5rem;
  }
  .xl\\:-m-24 {
    margin: -6rem;
  }
  .xl\\:-m-28 {
    margin: -7rem;
  }
  .xl\\:-m-32 {
    margin: -8rem;
  }
  .xl\\:-m-36 {
    margin: -9rem;
  }
  .xl\\:-m-40 {
    margin: -10rem;
  }
  .xl\\:-m-44 {
    margin: -11rem;
  }
  .xl\\:-m-48 {
    margin: -12rem;
  }
  .xl\\:-m-52 {
    margin: -13rem;
  }
  .xl\\:-m-56 {
    margin: -14rem;
  }
  .xl\\:-m-60 {
    margin: -15rem;
  }
  .xl\\:-m-64 {
    margin: -16rem;
  }
  .xl\\:-m-72 {
    margin: -18rem;
  }
  .xl\\:-m-80 {
    margin: -20rem;
  }
  .xl\\:-m-96 {
    margin: -24rem;
  }
  .xl\\:-m-px {
    margin: -1px;
  }
  .xl\\:-m-0\\.5 {
    margin: -0.125rem;
  }
  .xl\\:-m-1\\.5 {
    margin: -0.375rem;
  }
  .xl\\:-m-2\\.5 {
    margin: -0.625rem;
  }
  .xl\\:-m-3\\.5 {
    margin: -0.875rem;
  }
  .xl\\:-m-1\\/2 {
    margin: -50%;
  }
  .xl\\:-m-1\\/3 {
    margin: -33.33333%;
  }
  .xl\\:-m-2\\/3 {
    margin: -66.66667%;
  }
  .xl\\:-m-1\\/4 {
    margin: -25%;
  }
  .xl\\:-m-2\\/4 {
    margin: -50%;
  }
  .xl\\:-m-3\\/4 {
    margin: -75%;
  }
  .xl\\:-m-1\\/5 {
    margin: -20%;
  }
  .xl\\:-m-2\\/5 {
    margin: -40%;
  }
  .xl\\:-m-3\\/5 {
    margin: -60%;
  }
  .xl\\:-m-4\\/5 {
    margin: -80%;
  }
  .xl\\:-m-1\\/6 {
    margin: -16.66667%;
  }
  .xl\\:-m-2\\/6 {
    margin: -33.33333%;
  }
  .xl\\:-m-3\\/6 {
    margin: -50%;
  }
  .xl\\:-m-4\\/6 {
    margin: -66.66667%;
  }
  .xl\\:-m-5\\/6 {
    margin: -83.33333%;
  }
  .xl\\:-m-1\\/12 {
    margin: -8.33333%;
  }
  .xl\\:-m-2\\/12 {
    margin: -16.66667%;
  }
  .xl\\:-m-3\\/12 {
    margin: -25%;
  }
  .xl\\:-m-4\\/12 {
    margin: -33.33333%;
  }
  .xl\\:-m-5\\/12 {
    margin: -41.66667%;
  }
  .xl\\:-m-6\\/12 {
    margin: -50%;
  }
  .xl\\:-m-7\\/12 {
    margin: -58.33333%;
  }
  .xl\\:-m-8\\/12 {
    margin: -66.66667%;
  }
  .xl\\:-m-9\\/12 {
    margin: -75%;
  }
  .xl\\:-m-10\\/12 {
    margin: -83.33333%;
  }
  .xl\\:-m-11\\/12 {
    margin: -91.66667%;
  }
  .xl\\:-m-full {
    margin: -100%;
  }
  .xl\\:my-0 {
    margin-top: 0;
    margin-bottom: 0;
  }
  .xl\\:mx-0 {
    margin-left: 0;
    margin-right: 0;
  }
  .xl\\:my-1 {
    margin-top: 0.25rem;
    margin-bottom: 0.25rem;
  }
  .xl\\:mx-1 {
    margin-left: 0.25rem;
    margin-right: 0.25rem;
  }
  .xl\\:my-2 {
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
  }
  .xl\\:mx-2 {
    margin-left: 0.5rem;
    margin-right: 0.5rem;
  }
  .xl\\:my-3 {
    margin-top: 0.75rem;
    margin-bottom: 0.75rem;
  }
  .xl\\:mx-3 {
    margin-left: 0.75rem;
    margin-right: 0.75rem;
  }
  .xl\\:my-4 {
    margin-top: 1rem;
    margin-bottom: 1rem;
  }
  .xl\\:mx-4 {
    margin-left: 1rem;
    margin-right: 1rem;
  }
  .xl\\:my-5 {
    margin-top: 1.25rem;
    margin-bottom: 1.25rem;
  }
  .xl\\:mx-5 {
    margin-left: 1.25rem;
    margin-right: 1.25rem;
  }
  .xl\\:my-6 {
    margin-top: 1.5rem;
    margin-bottom: 1.5rem;
  }
  .xl\\:mx-6 {
    margin-left: 1.5rem;
    margin-right: 1.5rem;
  }
  .xl\\:my-7 {
    margin-top: 1.75rem;
    margin-bottom: 1.75rem;
  }
  .xl\\:mx-7 {
    margin-left: 1.75rem;
    margin-right: 1.75rem;
  }
  .xl\\:my-8 {
    margin-top: 2rem;
    margin-bottom: 2rem;
  }
  .xl\\:mx-8 {
    margin-left: 2rem;
    margin-right: 2rem;
  }
  .xl\\:my-9 {
    margin-top: 2.25rem;
    margin-bottom: 2.25rem;
  }
  .xl\\:mx-9 {
    margin-left: 2.25rem;
    margin-right: 2.25rem;
  }
  .xl\\:my-10 {
    margin-top: 2.5rem;
    margin-bottom: 2.5rem;
  }
  .xl\\:mx-10 {
    margin-left: 2.5rem;
    margin-right: 2.5rem;
  }
  .xl\\:my-11 {
    margin-top: 2.75rem;
    margin-bottom: 2.75rem;
  }
  .xl\\:mx-11 {
    margin-left: 2.75rem;
    margin-right: 2.75rem;
  }
  .xl\\:my-12 {
    margin-top: 3rem;
    margin-bottom: 3rem;
  }
  .xl\\:mx-12 {
    margin-left: 3rem;
    margin-right: 3rem;
  }
  .xl\\:my-13 {
    margin-top: 3.25rem;
    margin-bottom: 3.25rem;
  }
  .xl\\:mx-13 {
    margin-left: 3.25rem;
    margin-right: 3.25rem;
  }
  .xl\\:my-14 {
    margin-top: 3.5rem;
    margin-bottom: 3.5rem;
  }
  .xl\\:mx-14 {
    margin-left: 3.5rem;
    margin-right: 3.5rem;
  }
  .xl\\:my-15 {
    margin-top: 3.75rem;
    margin-bottom: 3.75rem;
  }
  .xl\\:mx-15 {
    margin-left: 3.75rem;
    margin-right: 3.75rem;
  }
  .xl\\:my-16 {
    margin-top: 4rem;
    margin-bottom: 4rem;
  }
  .xl\\:mx-16 {
    margin-left: 4rem;
    margin-right: 4rem;
  }
  .xl\\:my-20 {
    margin-top: 5rem;
    margin-bottom: 5rem;
  }
  .xl\\:mx-20 {
    margin-left: 5rem;
    margin-right: 5rem;
  }
  .xl\\:my-24 {
    margin-top: 6rem;
    margin-bottom: 6rem;
  }
  .xl\\:mx-24 {
    margin-left: 6rem;
    margin-right: 6rem;
  }
  .xl\\:my-28 {
    margin-top: 7rem;
    margin-bottom: 7rem;
  }
  .xl\\:mx-28 {
    margin-left: 7rem;
    margin-right: 7rem;
  }
  .xl\\:my-32 {
    margin-top: 8rem;
    margin-bottom: 8rem;
  }
  .xl\\:mx-32 {
    margin-left: 8rem;
    margin-right: 8rem;
  }
  .xl\\:my-36 {
    margin-top: 9rem;
    margin-bottom: 9rem;
  }
  .xl\\:mx-36 {
    margin-left: 9rem;
    margin-right: 9rem;
  }
  .xl\\:my-40 {
    margin-top: 10rem;
    margin-bottom: 10rem;
  }
  .xl\\:mx-40 {
    margin-left: 10rem;
    margin-right: 10rem;
  }
  .xl\\:my-44 {
    margin-top: 11rem;
    margin-bottom: 11rem;
  }
  .xl\\:mx-44 {
    margin-left: 11rem;
    margin-right: 11rem;
  }
  .xl\\:my-48 {
    margin-top: 12rem;
    margin-bottom: 12rem;
  }
  .xl\\:mx-48 {
    margin-left: 12rem;
    margin-right: 12rem;
  }
  .xl\\:my-52 {
    margin-top: 13rem;
    margin-bottom: 13rem;
  }
  .xl\\:mx-52 {
    margin-left: 13rem;
    margin-right: 13rem;
  }
  .xl\\:my-56 {
    margin-top: 14rem;
    margin-bottom: 14rem;
  }
  .xl\\:mx-56 {
    margin-left: 14rem;
    margin-right: 14rem;
  }
  .xl\\:my-60 {
    margin-top: 15rem;
    margin-bottom: 15rem;
  }
  .xl\\:mx-60 {
    margin-left: 15rem;
    margin-right: 15rem;
  }
  .xl\\:my-64 {
    margin-top: 16rem;
    margin-bottom: 16rem;
  }
  .xl\\:mx-64 {
    margin-left: 16rem;
    margin-right: 16rem;
  }
  .xl\\:my-72 {
    margin-top: 18rem;
    margin-bottom: 18rem;
  }
  .xl\\:mx-72 {
    margin-left: 18rem;
    margin-right: 18rem;
  }
  .xl\\:my-80 {
    margin-top: 20rem;
    margin-bottom: 20rem;
  }
  .xl\\:mx-80 {
    margin-left: 20rem;
    margin-right: 20rem;
  }
  .xl\\:my-96 {
    margin-top: 24rem;
    margin-bottom: 24rem;
  }
  .xl\\:mx-96 {
    margin-left: 24rem;
    margin-right: 24rem;
  }
  .xl\\:my-auto {
    margin-top: auto;
    margin-bottom: auto;
  }
  .xl\\:mx-auto {
    margin-left: auto;
    margin-right: auto;
  }
  .xl\\:my-px {
    margin-top: 1px;
    margin-bottom: 1px;
  }
  .xl\\:mx-px {
    margin-left: 1px;
    margin-right: 1px;
  }
  .xl\\:my-0\\.5 {
    margin-top: 0.125rem;
    margin-bottom: 0.125rem;
  }
  .xl\\:mx-0\\.5 {
    margin-left: 0.125rem;
    margin-right: 0.125rem;
  }
  .xl\\:my-1\\.5 {
    margin-top: 0.375rem;
    margin-bottom: 0.375rem;
  }
  .xl\\:mx-1\\.5 {
    margin-left: 0.375rem;
    margin-right: 0.375rem;
  }
  .xl\\:my-2\\.5 {
    margin-top: 0.625rem;
    margin-bottom: 0.625rem;
  }
  .xl\\:mx-2\\.5 {
    margin-left: 0.625rem;
    margin-right: 0.625rem;
  }
  .xl\\:my-3\\.5 {
    margin-top: 0.875rem;
    margin-bottom: 0.875rem;
  }
  .xl\\:mx-3\\.5 {
    margin-left: 0.875rem;
    margin-right: 0.875rem;
  }
  .xl\\:my-1\\/2 {
    margin-top: 50%;
    margin-bottom: 50%;
  }
  .xl\\:mx-1\\/2 {
    margin-left: 50%;
    margin-right: 50%;
  }
  .xl\\:my-1\\/3 {
    margin-top: 33.333333%;
    margin-bottom: 33.333333%;
  }
  .xl\\:mx-1\\/3 {
    margin-left: 33.333333%;
    margin-right: 33.333333%;
  }
  .xl\\:my-2\\/3 {
    margin-top: 66.666667%;
    margin-bottom: 66.666667%;
  }
  .xl\\:mx-2\\/3 {
    margin-left: 66.666667%;
    margin-right: 66.666667%;
  }
  .xl\\:my-1\\/4 {
    margin-top: 25%;
    margin-bottom: 25%;
  }
  .xl\\:mx-1\\/4 {
    margin-left: 25%;
    margin-right: 25%;
  }
  .xl\\:my-2\\/4 {
    margin-top: 50%;
    margin-bottom: 50%;
  }
  .xl\\:mx-2\\/4 {
    margin-left: 50%;
    margin-right: 50%;
  }
  .xl\\:my-3\\/4 {
    margin-top: 75%;
    margin-bottom: 75%;
  }
  .xl\\:mx-3\\/4 {
    margin-left: 75%;
    margin-right: 75%;
  }
  .xl\\:my-1\\/5 {
    margin-top: 20%;
    margin-bottom: 20%;
  }
  .xl\\:mx-1\\/5 {
    margin-left: 20%;
    margin-right: 20%;
  }
  .xl\\:my-2\\/5 {
    margin-top: 40%;
    margin-bottom: 40%;
  }
  .xl\\:mx-2\\/5 {
    margin-left: 40%;
    margin-right: 40%;
  }
  .xl\\:my-3\\/5 {
    margin-top: 60%;
    margin-bottom: 60%;
  }
  .xl\\:mx-3\\/5 {
    margin-left: 60%;
    margin-right: 60%;
  }
  .xl\\:my-4\\/5 {
    margin-top: 80%;
    margin-bottom: 80%;
  }
  .xl\\:mx-4\\/5 {
    margin-left: 80%;
    margin-right: 80%;
  }
  .xl\\:my-1\\/6 {
    margin-top: 16.666667%;
    margin-bottom: 16.666667%;
  }
  .xl\\:mx-1\\/6 {
    margin-left: 16.666667%;
    margin-right: 16.666667%;
  }
  .xl\\:my-2\\/6 {
    margin-top: 33.333333%;
    margin-bottom: 33.333333%;
  }
  .xl\\:mx-2\\/6 {
    margin-left: 33.333333%;
    margin-right: 33.333333%;
  }
  .xl\\:my-3\\/6 {
    margin-top: 50%;
    margin-bottom: 50%;
  }
  .xl\\:mx-3\\/6 {
    margin-left: 50%;
    margin-right: 50%;
  }
  .xl\\:my-4\\/6 {
    margin-top: 66.666667%;
    margin-bottom: 66.666667%;
  }
  .xl\\:mx-4\\/6 {
    margin-left: 66.666667%;
    margin-right: 66.666667%;
  }
  .xl\\:my-5\\/6 {
    margin-top: 83.333333%;
    margin-bottom: 83.333333%;
  }
  .xl\\:mx-5\\/6 {
    margin-left: 83.333333%;
    margin-right: 83.333333%;
  }
  .xl\\:my-1\\/12 {
    margin-top: 8.333333%;
    margin-bottom: 8.333333%;
  }
  .xl\\:mx-1\\/12 {
    margin-left: 8.333333%;
    margin-right: 8.333333%;
  }
  .xl\\:my-2\\/12 {
    margin-top: 16.666667%;
    margin-bottom: 16.666667%;
  }
  .xl\\:mx-2\\/12 {
    margin-left: 16.666667%;
    margin-right: 16.666667%;
  }
  .xl\\:my-3\\/12 {
    margin-top: 25%;
    margin-bottom: 25%;
  }
  .xl\\:mx-3\\/12 {
    margin-left: 25%;
    margin-right: 25%;
  }
  .xl\\:my-4\\/12 {
    margin-top: 33.333333%;
    margin-bottom: 33.333333%;
  }
  .xl\\:mx-4\\/12 {
    margin-left: 33.333333%;
    margin-right: 33.333333%;
  }
  .xl\\:my-5\\/12 {
    margin-top: 41.666667%;
    margin-bottom: 41.666667%;
  }
  .xl\\:mx-5\\/12 {
    margin-left: 41.666667%;
    margin-right: 41.666667%;
  }
  .xl\\:my-6\\/12 {
    margin-top: 50%;
    margin-bottom: 50%;
  }
  .xl\\:mx-6\\/12 {
    margin-left: 50%;
    margin-right: 50%;
  }
  .xl\\:my-7\\/12 {
    margin-top: 58.333333%;
    margin-bottom: 58.333333%;
  }
  .xl\\:mx-7\\/12 {
    margin-left: 58.333333%;
    margin-right: 58.333333%;
  }
  .xl\\:my-8\\/12 {
    margin-top: 66.666667%;
    margin-bottom: 66.666667%;
  }
  .xl\\:mx-8\\/12 {
    margin-left: 66.666667%;
    margin-right: 66.666667%;
  }
  .xl\\:my-9\\/12 {
    margin-top: 75%;
    margin-bottom: 75%;
  }
  .xl\\:mx-9\\/12 {
    margin-left: 75%;
    margin-right: 75%;
  }
  .xl\\:my-10\\/12 {
    margin-top: 83.333333%;
    margin-bottom: 83.333333%;
  }
  .xl\\:mx-10\\/12 {
    margin-left: 83.333333%;
    margin-right: 83.333333%;
  }
  .xl\\:my-11\\/12 {
    margin-top: 91.666667%;
    margin-bottom: 91.666667%;
  }
  .xl\\:mx-11\\/12 {
    margin-left: 91.666667%;
    margin-right: 91.666667%;
  }
  .xl\\:my-full {
    margin-top: 100%;
    margin-bottom: 100%;
  }
  .xl\\:mx-full {
    margin-left: 100%;
    margin-right: 100%;
  }
  .xl\\:-my-1 {
    margin-top: -0.25rem;
    margin-bottom: -0.25rem;
  }
  .xl\\:-mx-1 {
    margin-left: -0.25rem;
    margin-right: -0.25rem;
  }
  .xl\\:-my-2 {
    margin-top: -0.5rem;
    margin-bottom: -0.5rem;
  }
  .xl\\:-mx-2 {
    margin-left: -0.5rem;
    margin-right: -0.5rem;
  }
  .xl\\:-my-3 {
    margin-top: -0.75rem;
    margin-bottom: -0.75rem;
  }
  .xl\\:-mx-3 {
    margin-left: -0.75rem;
    margin-right: -0.75rem;
  }
  .xl\\:-my-4 {
    margin-top: -1rem;
    margin-bottom: -1rem;
  }
  .xl\\:-mx-4 {
    margin-left: -1rem;
    margin-right: -1rem;
  }
  .xl\\:-my-5 {
    margin-top: -1.25rem;
    margin-bottom: -1.25rem;
  }
  .xl\\:-mx-5 {
    margin-left: -1.25rem;
    margin-right: -1.25rem;
  }
  .xl\\:-my-6 {
    margin-top: -1.5rem;
    margin-bottom: -1.5rem;
  }
  .xl\\:-mx-6 {
    margin-left: -1.5rem;
    margin-right: -1.5rem;
  }
  .xl\\:-my-7 {
    margin-top: -1.75rem;
    margin-bottom: -1.75rem;
  }
  .xl\\:-mx-7 {
    margin-left: -1.75rem;
    margin-right: -1.75rem;
  }
  .xl\\:-my-8 {
    margin-top: -2rem;
    margin-bottom: -2rem;
  }
  .xl\\:-mx-8 {
    margin-left: -2rem;
    margin-right: -2rem;
  }
  .xl\\:-my-9 {
    margin-top: -2.25rem;
    margin-bottom: -2.25rem;
  }
  .xl\\:-mx-9 {
    margin-left: -2.25rem;
    margin-right: -2.25rem;
  }
  .xl\\:-my-10 {
    margin-top: -2.5rem;
    margin-bottom: -2.5rem;
  }
  .xl\\:-mx-10 {
    margin-left: -2.5rem;
    margin-right: -2.5rem;
  }
  .xl\\:-my-11 {
    margin-top: -2.75rem;
    margin-bottom: -2.75rem;
  }
  .xl\\:-mx-11 {
    margin-left: -2.75rem;
    margin-right: -2.75rem;
  }
  .xl\\:-my-12 {
    margin-top: -3rem;
    margin-bottom: -3rem;
  }
  .xl\\:-mx-12 {
    margin-left: -3rem;
    margin-right: -3rem;
  }
  .xl\\:-my-13 {
    margin-top: -3.25rem;
    margin-bottom: -3.25rem;
  }
  .xl\\:-mx-13 {
    margin-left: -3.25rem;
    margin-right: -3.25rem;
  }
  .xl\\:-my-14 {
    margin-top: -3.5rem;
    margin-bottom: -3.5rem;
  }
  .xl\\:-mx-14 {
    margin-left: -3.5rem;
    margin-right: -3.5rem;
  }
  .xl\\:-my-15 {
    margin-top: -3.75rem;
    margin-bottom: -3.75rem;
  }
  .xl\\:-mx-15 {
    margin-left: -3.75rem;
    margin-right: -3.75rem;
  }
  .xl\\:-my-16 {
    margin-top: -4rem;
    margin-bottom: -4rem;
  }
  .xl\\:-mx-16 {
    margin-left: -4rem;
    margin-right: -4rem;
  }
  .xl\\:-my-20 {
    margin-top: -5rem;
    margin-bottom: -5rem;
  }
  .xl\\:-mx-20 {
    margin-left: -5rem;
    margin-right: -5rem;
  }
  .xl\\:-my-24 {
    margin-top: -6rem;
    margin-bottom: -6rem;
  }
  .xl\\:-mx-24 {
    margin-left: -6rem;
    margin-right: -6rem;
  }
  .xl\\:-my-28 {
    margin-top: -7rem;
    margin-bottom: -7rem;
  }
  .xl\\:-mx-28 {
    margin-left: -7rem;
    margin-right: -7rem;
  }
  .xl\\:-my-32 {
    margin-top: -8rem;
    margin-bottom: -8rem;
  }
  .xl\\:-mx-32 {
    margin-left: -8rem;
    margin-right: -8rem;
  }
  .xl\\:-my-36 {
    margin-top: -9rem;
    margin-bottom: -9rem;
  }
  .xl\\:-mx-36 {
    margin-left: -9rem;
    margin-right: -9rem;
  }
  .xl\\:-my-40 {
    margin-top: -10rem;
    margin-bottom: -10rem;
  }
  .xl\\:-mx-40 {
    margin-left: -10rem;
    margin-right: -10rem;
  }
  .xl\\:-my-44 {
    margin-top: -11rem;
    margin-bottom: -11rem;
  }
  .xl\\:-mx-44 {
    margin-left: -11rem;
    margin-right: -11rem;
  }
  .xl\\:-my-48 {
    margin-top: -12rem;
    margin-bottom: -12rem;
  }
  .xl\\:-mx-48 {
    margin-left: -12rem;
    margin-right: -12rem;
  }
  .xl\\:-my-52 {
    margin-top: -13rem;
    margin-bottom: -13rem;
  }
  .xl\\:-mx-52 {
    margin-left: -13rem;
    margin-right: -13rem;
  }
  .xl\\:-my-56 {
    margin-top: -14rem;
    margin-bottom: -14rem;
  }
  .xl\\:-mx-56 {
    margin-left: -14rem;
    margin-right: -14rem;
  }
  .xl\\:-my-60 {
    margin-top: -15rem;
    margin-bottom: -15rem;
  }
  .xl\\:-mx-60 {
    margin-left: -15rem;
    margin-right: -15rem;
  }
  .xl\\:-my-64 {
    margin-top: -16rem;
    margin-bottom: -16rem;
  }
  .xl\\:-mx-64 {
    margin-left: -16rem;
    margin-right: -16rem;
  }
  .xl\\:-my-72 {
    margin-top: -18rem;
    margin-bottom: -18rem;
  }
  .xl\\:-mx-72 {
    margin-left: -18rem;
    margin-right: -18rem;
  }
  .xl\\:-my-80 {
    margin-top: -20rem;
    margin-bottom: -20rem;
  }
  .xl\\:-mx-80 {
    margin-left: -20rem;
    margin-right: -20rem;
  }
  .xl\\:-my-96 {
    margin-top: -24rem;
    margin-bottom: -24rem;
  }
  .xl\\:-mx-96 {
    margin-left: -24rem;
    margin-right: -24rem;
  }
  .xl\\:-my-px {
    margin-top: -1px;
    margin-bottom: -1px;
  }
  .xl\\:-mx-px {
    margin-left: -1px;
    margin-right: -1px;
  }
  .xl\\:-my-0\\.5 {
    margin-top: -0.125rem;
    margin-bottom: -0.125rem;
  }
  .xl\\:-mx-0\\.5 {
    margin-left: -0.125rem;
    margin-right: -0.125rem;
  }
  .xl\\:-my-1\\.5 {
    margin-top: -0.375rem;
    margin-bottom: -0.375rem;
  }
  .xl\\:-mx-1\\.5 {
    margin-left: -0.375rem;
    margin-right: -0.375rem;
  }
  .xl\\:-my-2\\.5 {
    margin-top: -0.625rem;
    margin-bottom: -0.625rem;
  }
  .xl\\:-mx-2\\.5 {
    margin-left: -0.625rem;
    margin-right: -0.625rem;
  }
  .xl\\:-my-3\\.5 {
    margin-top: -0.875rem;
    margin-bottom: -0.875rem;
  }
  .xl\\:-mx-3\\.5 {
    margin-left: -0.875rem;
    margin-right: -0.875rem;
  }
  .xl\\:-my-1\\/2 {
    margin-top: -50%;
    margin-bottom: -50%;
  }
  .xl\\:-mx-1\\/2 {
    margin-left: -50%;
    margin-right: -50%;
  }
  .xl\\:-my-1\\/3 {
    margin-top: -33.33333%;
    margin-bottom: -33.33333%;
  }
  .xl\\:-mx-1\\/3 {
    margin-left: -33.33333%;
    margin-right: -33.33333%;
  }
  .xl\\:-my-2\\/3 {
    margin-top: -66.66667%;
    margin-bottom: -66.66667%;
  }
  .xl\\:-mx-2\\/3 {
    margin-left: -66.66667%;
    margin-right: -66.66667%;
  }
  .xl\\:-my-1\\/4 {
    margin-top: -25%;
    margin-bottom: -25%;
  }
  .xl\\:-mx-1\\/4 {
    margin-left: -25%;
    margin-right: -25%;
  }
  .xl\\:-my-2\\/4 {
    margin-top: -50%;
    margin-bottom: -50%;
  }
  .xl\\:-mx-2\\/4 {
    margin-left: -50%;
    margin-right: -50%;
  }
  .xl\\:-my-3\\/4 {
    margin-top: -75%;
    margin-bottom: -75%;
  }
  .xl\\:-mx-3\\/4 {
    margin-left: -75%;
    margin-right: -75%;
  }
  .xl\\:-my-1\\/5 {
    margin-top: -20%;
    margin-bottom: -20%;
  }
  .xl\\:-mx-1\\/5 {
    margin-left: -20%;
    margin-right: -20%;
  }
  .xl\\:-my-2\\/5 {
    margin-top: -40%;
    margin-bottom: -40%;
  }
  .xl\\:-mx-2\\/5 {
    margin-left: -40%;
    margin-right: -40%;
  }
  .xl\\:-my-3\\/5 {
    margin-top: -60%;
    margin-bottom: -60%;
  }
  .xl\\:-mx-3\\/5 {
    margin-left: -60%;
    margin-right: -60%;
  }
  .xl\\:-my-4\\/5 {
    margin-top: -80%;
    margin-bottom: -80%;
  }
  .xl\\:-mx-4\\/5 {
    margin-left: -80%;
    margin-right: -80%;
  }
  .xl\\:-my-1\\/6 {
    margin-top: -16.66667%;
    margin-bottom: -16.66667%;
  }
  .xl\\:-mx-1\\/6 {
    margin-left: -16.66667%;
    margin-right: -16.66667%;
  }
  .xl\\:-my-2\\/6 {
    margin-top: -33.33333%;
    margin-bottom: -33.33333%;
  }
  .xl\\:-mx-2\\/6 {
    margin-left: -33.33333%;
    margin-right: -33.33333%;
  }
  .xl\\:-my-3\\/6 {
    margin-top: -50%;
    margin-bottom: -50%;
  }
  .xl\\:-mx-3\\/6 {
    margin-left: -50%;
    margin-right: -50%;
  }
  .xl\\:-my-4\\/6 {
    margin-top: -66.66667%;
    margin-bottom: -66.66667%;
  }
  .xl\\:-mx-4\\/6 {
    margin-left: -66.66667%;
    margin-right: -66.66667%;
  }
  .xl\\:-my-5\\/6 {
    margin-top: -83.33333%;
    margin-bottom: -83.33333%;
  }
  .xl\\:-mx-5\\/6 {
    margin-left: -83.33333%;
    margin-right: -83.33333%;
  }
  .xl\\:-my-1\\/12 {
    margin-top: -8.33333%;
    margin-bottom: -8.33333%;
  }
  .xl\\:-mx-1\\/12 {
    margin-left: -8.33333%;
    margin-right: -8.33333%;
  }
  .xl\\:-my-2\\/12 {
    margin-top: -16.66667%;
    margin-bottom: -16.66667%;
  }
  .xl\\:-mx-2\\/12 {
    margin-left: -16.66667%;
    margin-right: -16.66667%;
  }
  .xl\\:-my-3\\/12 {
    margin-top: -25%;
    margin-bottom: -25%;
  }
  .xl\\:-mx-3\\/12 {
    margin-left: -25%;
    margin-right: -25%;
  }
  .xl\\:-my-4\\/12 {
    margin-top: -33.33333%;
    margin-bottom: -33.33333%;
  }
  .xl\\:-mx-4\\/12 {
    margin-left: -33.33333%;
    margin-right: -33.33333%;
  }
  .xl\\:-my-5\\/12 {
    margin-top: -41.66667%;
    margin-bottom: -41.66667%;
  }
  .xl\\:-mx-5\\/12 {
    margin-left: -41.66667%;
    margin-right: -41.66667%;
  }
  .xl\\:-my-6\\/12 {
    margin-top: -50%;
    margin-bottom: -50%;
  }
  .xl\\:-mx-6\\/12 {
    margin-left: -50%;
    margin-right: -50%;
  }
  .xl\\:-my-7\\/12 {
    margin-top: -58.33333%;
    margin-bottom: -58.33333%;
  }
  .xl\\:-mx-7\\/12 {
    margin-left: -58.33333%;
    margin-right: -58.33333%;
  }
  .xl\\:-my-8\\/12 {
    margin-top: -66.66667%;
    margin-bottom: -66.66667%;
  }
  .xl\\:-mx-8\\/12 {
    margin-left: -66.66667%;
    margin-right: -66.66667%;
  }
  .xl\\:-my-9\\/12 {
    margin-top: -75%;
    margin-bottom: -75%;
  }
  .xl\\:-mx-9\\/12 {
    margin-left: -75%;
    margin-right: -75%;
  }
  .xl\\:-my-10\\/12 {
    margin-top: -83.33333%;
    margin-bottom: -83.33333%;
  }
  .xl\\:-mx-10\\/12 {
    margin-left: -83.33333%;
    margin-right: -83.33333%;
  }
  .xl\\:-my-11\\/12 {
    margin-top: -91.66667%;
    margin-bottom: -91.66667%;
  }
  .xl\\:-mx-11\\/12 {
    margin-left: -91.66667%;
    margin-right: -91.66667%;
  }
  .xl\\:-my-full {
    margin-top: -100%;
    margin-bottom: -100%;
  }
  .xl\\:-mx-full {
    margin-left: -100%;
    margin-right: -100%;
  }
  .xl\\:mt-0 {
    margin-top: 0;
  }
  .xl\\:mr-0 {
    margin-right: 0;
  }
  .xl\\:mb-0 {
    margin-bottom: 0;
  }
  .xl\\:ml-0 {
    margin-left: 0;
  }
  .xl\\:mt-1 {
    margin-top: 0.25rem;
  }
  .xl\\:mr-1 {
    margin-right: 0.25rem;
  }
  .xl\\:mb-1 {
    margin-bottom: 0.25rem;
  }
  .xl\\:ml-1 {
    margin-left: 0.25rem;
  }
  .xl\\:mt-2 {
    margin-top: 0.5rem;
  }
  .xl\\:mr-2 {
    margin-right: 0.5rem;
  }
  .xl\\:mb-2 {
    margin-bottom: 0.5rem;
  }
  .xl\\:ml-2 {
    margin-left: 0.5rem;
  }
  .xl\\:mt-3 {
    margin-top: 0.75rem;
  }
  .xl\\:mr-3 {
    margin-right: 0.75rem;
  }
  .xl\\:mb-3 {
    margin-bottom: 0.75rem;
  }
  .xl\\:ml-3 {
    margin-left: 0.75rem;
  }
  .xl\\:mt-4 {
    margin-top: 1rem;
  }
  .xl\\:mr-4 {
    margin-right: 1rem;
  }
  .xl\\:mb-4 {
    margin-bottom: 1rem;
  }
  .xl\\:ml-4 {
    margin-left: 1rem;
  }
  .xl\\:mt-5 {
    margin-top: 1.25rem;
  }
  .xl\\:mr-5 {
    margin-right: 1.25rem;
  }
  .xl\\:mb-5 {
    margin-bottom: 1.25rem;
  }
  .xl\\:ml-5 {
    margin-left: 1.25rem;
  }
  .xl\\:mt-6 {
    margin-top: 1.5rem;
  }
  .xl\\:mr-6 {
    margin-right: 1.5rem;
  }
  .xl\\:mb-6 {
    margin-bottom: 1.5rem;
  }
  .xl\\:ml-6 {
    margin-left: 1.5rem;
  }
  .xl\\:mt-7 {
    margin-top: 1.75rem;
  }
  .xl\\:mr-7 {
    margin-right: 1.75rem;
  }
  .xl\\:mb-7 {
    margin-bottom: 1.75rem;
  }
  .xl\\:ml-7 {
    margin-left: 1.75rem;
  }
  .xl\\:mt-8 {
    margin-top: 2rem;
  }
  .xl\\:mr-8 {
    margin-right: 2rem;
  }
  .xl\\:mb-8 {
    margin-bottom: 2rem;
  }
  .xl\\:ml-8 {
    margin-left: 2rem;
  }
  .xl\\:mt-9 {
    margin-top: 2.25rem;
  }
  .xl\\:mr-9 {
    margin-right: 2.25rem;
  }
  .xl\\:mb-9 {
    margin-bottom: 2.25rem;
  }
  .xl\\:ml-9 {
    margin-left: 2.25rem;
  }
  .xl\\:mt-10 {
    margin-top: 2.5rem;
  }
  .xl\\:mr-10 {
    margin-right: 2.5rem;
  }
  .xl\\:mb-10 {
    margin-bottom: 2.5rem;
  }
  .xl\\:ml-10 {
    margin-left: 2.5rem;
  }
  .xl\\:mt-11 {
    margin-top: 2.75rem;
  }
  .xl\\:mr-11 {
    margin-right: 2.75rem;
  }
  .xl\\:mb-11 {
    margin-bottom: 2.75rem;
  }
  .xl\\:ml-11 {
    margin-left: 2.75rem;
  }
  .xl\\:mt-12 {
    margin-top: 3rem;
  }
  .xl\\:mr-12 {
    margin-right: 3rem;
  }
  .xl\\:mb-12 {
    margin-bottom: 3rem;
  }
  .xl\\:ml-12 {
    margin-left: 3rem;
  }
  .xl\\:mt-13 {
    margin-top: 3.25rem;
  }
  .xl\\:mr-13 {
    margin-right: 3.25rem;
  }
  .xl\\:mb-13 {
    margin-bottom: 3.25rem;
  }
  .xl\\:ml-13 {
    margin-left: 3.25rem;
  }
  .xl\\:mt-14 {
    margin-top: 3.5rem;
  }
  .xl\\:mr-14 {
    margin-right: 3.5rem;
  }
  .xl\\:mb-14 {
    margin-bottom: 3.5rem;
  }
  .xl\\:ml-14 {
    margin-left: 3.5rem;
  }
  .xl\\:mt-15 {
    margin-top: 3.75rem;
  }
  .xl\\:mr-15 {
    margin-right: 3.75rem;
  }
  .xl\\:mb-15 {
    margin-bottom: 3.75rem;
  }
  .xl\\:ml-15 {
    margin-left: 3.75rem;
  }
  .xl\\:mt-16 {
    margin-top: 4rem;
  }
  .xl\\:mr-16 {
    margin-right: 4rem;
  }
  .xl\\:mb-16 {
    margin-bottom: 4rem;
  }
  .xl\\:ml-16 {
    margin-left: 4rem;
  }
  .xl\\:mt-20 {
    margin-top: 5rem;
  }
  .xl\\:mr-20 {
    margin-right: 5rem;
  }
  .xl\\:mb-20 {
    margin-bottom: 5rem;
  }
  .xl\\:ml-20 {
    margin-left: 5rem;
  }
  .xl\\:mt-24 {
    margin-top: 6rem;
  }
  .xl\\:mr-24 {
    margin-right: 6rem;
  }
  .xl\\:mb-24 {
    margin-bottom: 6rem;
  }
  .xl\\:ml-24 {
    margin-left: 6rem;
  }
  .xl\\:mt-28 {
    margin-top: 7rem;
  }
  .xl\\:mr-28 {
    margin-right: 7rem;
  }
  .xl\\:mb-28 {
    margin-bottom: 7rem;
  }
  .xl\\:ml-28 {
    margin-left: 7rem;
  }
  .xl\\:mt-32 {
    margin-top: 8rem;
  }
  .xl\\:mr-32 {
    margin-right: 8rem;
  }
  .xl\\:mb-32 {
    margin-bottom: 8rem;
  }
  .xl\\:ml-32 {
    margin-left: 8rem;
  }
  .xl\\:mt-36 {
    margin-top: 9rem;
  }
  .xl\\:mr-36 {
    margin-right: 9rem;
  }
  .xl\\:mb-36 {
    margin-bottom: 9rem;
  }
  .xl\\:ml-36 {
    margin-left: 9rem;
  }
  .xl\\:mt-40 {
    margin-top: 10rem;
  }
  .xl\\:mr-40 {
    margin-right: 10rem;
  }
  .xl\\:mb-40 {
    margin-bottom: 10rem;
  }
  .xl\\:ml-40 {
    margin-left: 10rem;
  }
  .xl\\:mt-44 {
    margin-top: 11rem;
  }
  .xl\\:mr-44 {
    margin-right: 11rem;
  }
  .xl\\:mb-44 {
    margin-bottom: 11rem;
  }
  .xl\\:ml-44 {
    margin-left: 11rem;
  }
  .xl\\:mt-48 {
    margin-top: 12rem;
  }
  .xl\\:mr-48 {
    margin-right: 12rem;
  }
  .xl\\:mb-48 {
    margin-bottom: 12rem;
  }
  .xl\\:ml-48 {
    margin-left: 12rem;
  }
  .xl\\:mt-52 {
    margin-top: 13rem;
  }
  .xl\\:mr-52 {
    margin-right: 13rem;
  }
  .xl\\:mb-52 {
    margin-bottom: 13rem;
  }
  .xl\\:ml-52 {
    margin-left: 13rem;
  }
  .xl\\:mt-56 {
    margin-top: 14rem;
  }
  .xl\\:mr-56 {
    margin-right: 14rem;
  }
  .xl\\:mb-56 {
    margin-bottom: 14rem;
  }
  .xl\\:ml-56 {
    margin-left: 14rem;
  }
  .xl\\:mt-60 {
    margin-top: 15rem;
  }
  .xl\\:mr-60 {
    margin-right: 15rem;
  }
  .xl\\:mb-60 {
    margin-bottom: 15rem;
  }
  .xl\\:ml-60 {
    margin-left: 15rem;
  }
  .xl\\:mt-64 {
    margin-top: 16rem;
  }
  .xl\\:mr-64 {
    margin-right: 16rem;
  }
  .xl\\:mb-64 {
    margin-bottom: 16rem;
  }
  .xl\\:ml-64 {
    margin-left: 16rem;
  }
  .xl\\:mt-72 {
    margin-top: 18rem;
  }
  .xl\\:mr-72 {
    margin-right: 18rem;
  }
  .xl\\:mb-72 {
    margin-bottom: 18rem;
  }
  .xl\\:ml-72 {
    margin-left: 18rem;
  }
  .xl\\:mt-80 {
    margin-top: 20rem;
  }
  .xl\\:mr-80 {
    margin-right: 20rem;
  }
  .xl\\:mb-80 {
    margin-bottom: 20rem;
  }
  .xl\\:ml-80 {
    margin-left: 20rem;
  }
  .xl\\:mt-96 {
    margin-top: 24rem;
  }
  .xl\\:mr-96 {
    margin-right: 24rem;
  }
  .xl\\:mb-96 {
    margin-bottom: 24rem;
  }
  .xl\\:ml-96 {
    margin-left: 24rem;
  }
  .xl\\:mt-auto {
    margin-top: auto;
  }
  .xl\\:mr-auto {
    margin-right: auto;
  }
  .xl\\:mb-auto {
    margin-bottom: auto;
  }
  .xl\\:ml-auto {
    margin-left: auto;
  }
  .xl\\:mt-px {
    margin-top: 1px;
  }
  .xl\\:mr-px {
    margin-right: 1px;
  }
  .xl\\:mb-px {
    margin-bottom: 1px;
  }
  .xl\\:ml-px {
    margin-left: 1px;
  }
  .xl\\:mt-0\\.5 {
    margin-top: 0.125rem;
  }
  .xl\\:mr-0\\.5 {
    margin-right: 0.125rem;
  }
  .xl\\:mb-0\\.5 {
    margin-bottom: 0.125rem;
  }
  .xl\\:ml-0\\.5 {
    margin-left: 0.125rem;
  }
  .xl\\:mt-1\\.5 {
    margin-top: 0.375rem;
  }
  .xl\\:mr-1\\.5 {
    margin-right: 0.375rem;
  }
  .xl\\:mb-1\\.5 {
    margin-bottom: 0.375rem;
  }
  .xl\\:ml-1\\.5 {
    margin-left: 0.375rem;
  }
  .xl\\:mt-2\\.5 {
    margin-top: 0.625rem;
  }
  .xl\\:mr-2\\.5 {
    margin-right: 0.625rem;
  }
  .xl\\:mb-2\\.5 {
    margin-bottom: 0.625rem;
  }
  .xl\\:ml-2\\.5 {
    margin-left: 0.625rem;
  }
  .xl\\:mt-3\\.5 {
    margin-top: 0.875rem;
  }
  .xl\\:mr-3\\.5 {
    margin-right: 0.875rem;
  }
  .xl\\:mb-3\\.5 {
    margin-bottom: 0.875rem;
  }
  .xl\\:ml-3\\.5 {
    margin-left: 0.875rem;
  }
  .xl\\:mt-1\\/2 {
    margin-top: 50%;
  }
  .xl\\:mr-1\\/2 {
    margin-right: 50%;
  }
  .xl\\:mb-1\\/2 {
    margin-bottom: 50%;
  }
  .xl\\:ml-1\\/2 {
    margin-left: 50%;
  }
  .xl\\:mt-1\\/3 {
    margin-top: 33.333333%;
  }
  .xl\\:mr-1\\/3 {
    margin-right: 33.333333%;
  }
  .xl\\:mb-1\\/3 {
    margin-bottom: 33.333333%;
  }
  .xl\\:ml-1\\/3 {
    margin-left: 33.333333%;
  }
  .xl\\:mt-2\\/3 {
    margin-top: 66.666667%;
  }
  .xl\\:mr-2\\/3 {
    margin-right: 66.666667%;
  }
  .xl\\:mb-2\\/3 {
    margin-bottom: 66.666667%;
  }
  .xl\\:ml-2\\/3 {
    margin-left: 66.666667%;
  }
  .xl\\:mt-1\\/4 {
    margin-top: 25%;
  }
  .xl\\:mr-1\\/4 {
    margin-right: 25%;
  }
  .xl\\:mb-1\\/4 {
    margin-bottom: 25%;
  }
  .xl\\:ml-1\\/4 {
    margin-left: 25%;
  }
  .xl\\:mt-2\\/4 {
    margin-top: 50%;
  }
  .xl\\:mr-2\\/4 {
    margin-right: 50%;
  }
  .xl\\:mb-2\\/4 {
    margin-bottom: 50%;
  }
  .xl\\:ml-2\\/4 {
    margin-left: 50%;
  }
  .xl\\:mt-3\\/4 {
    margin-top: 75%;
  }
  .xl\\:mr-3\\/4 {
    margin-right: 75%;
  }
  .xl\\:mb-3\\/4 {
    margin-bottom: 75%;
  }
  .xl\\:ml-3\\/4 {
    margin-left: 75%;
  }
  .xl\\:mt-1\\/5 {
    margin-top: 20%;
  }
  .xl\\:mr-1\\/5 {
    margin-right: 20%;
  }
  .xl\\:mb-1\\/5 {
    margin-bottom: 20%;
  }
  .xl\\:ml-1\\/5 {
    margin-left: 20%;
  }
  .xl\\:mt-2\\/5 {
    margin-top: 40%;
  }
  .xl\\:mr-2\\/5 {
    margin-right: 40%;
  }
  .xl\\:mb-2\\/5 {
    margin-bottom: 40%;
  }
  .xl\\:ml-2\\/5 {
    margin-left: 40%;
  }
  .xl\\:mt-3\\/5 {
    margin-top: 60%;
  }
  .xl\\:mr-3\\/5 {
    margin-right: 60%;
  }
  .xl\\:mb-3\\/5 {
    margin-bottom: 60%;
  }
  .xl\\:ml-3\\/5 {
    margin-left: 60%;
  }
  .xl\\:mt-4\\/5 {
    margin-top: 80%;
  }
  .xl\\:mr-4\\/5 {
    margin-right: 80%;
  }
  .xl\\:mb-4\\/5 {
    margin-bottom: 80%;
  }
  .xl\\:ml-4\\/5 {
    margin-left: 80%;
  }
  .xl\\:mt-1\\/6 {
    margin-top: 16.666667%;
  }
  .xl\\:mr-1\\/6 {
    margin-right: 16.666667%;
  }
  .xl\\:mb-1\\/6 {
    margin-bottom: 16.666667%;
  }
  .xl\\:ml-1\\/6 {
    margin-left: 16.666667%;
  }
  .xl\\:mt-2\\/6 {
    margin-top: 33.333333%;
  }
  .xl\\:mr-2\\/6 {
    margin-right: 33.333333%;
  }
  .xl\\:mb-2\\/6 {
    margin-bottom: 33.333333%;
  }
  .xl\\:ml-2\\/6 {
    margin-left: 33.333333%;
  }
  .xl\\:mt-3\\/6 {
    margin-top: 50%;
  }
  .xl\\:mr-3\\/6 {
    margin-right: 50%;
  }
  .xl\\:mb-3\\/6 {
    margin-bottom: 50%;
  }
  .xl\\:ml-3\\/6 {
    margin-left: 50%;
  }
  .xl\\:mt-4\\/6 {
    margin-top: 66.666667%;
  }
  .xl\\:mr-4\\/6 {
    margin-right: 66.666667%;
  }
  .xl\\:mb-4\\/6 {
    margin-bottom: 66.666667%;
  }
  .xl\\:ml-4\\/6 {
    margin-left: 66.666667%;
  }
  .xl\\:mt-5\\/6 {
    margin-top: 83.333333%;
  }
  .xl\\:mr-5\\/6 {
    margin-right: 83.333333%;
  }
  .xl\\:mb-5\\/6 {
    margin-bottom: 83.333333%;
  }
  .xl\\:ml-5\\/6 {
    margin-left: 83.333333%;
  }
  .xl\\:mt-1\\/12 {
    margin-top: 8.333333%;
  }
  .xl\\:mr-1\\/12 {
    margin-right: 8.333333%;
  }
  .xl\\:mb-1\\/12 {
    margin-bottom: 8.333333%;
  }
  .xl\\:ml-1\\/12 {
    margin-left: 8.333333%;
  }
  .xl\\:mt-2\\/12 {
    margin-top: 16.666667%;
  }
  .xl\\:mr-2\\/12 {
    margin-right: 16.666667%;
  }
  .xl\\:mb-2\\/12 {
    margin-bottom: 16.666667%;
  }
  .xl\\:ml-2\\/12 {
    margin-left: 16.666667%;
  }
  .xl\\:mt-3\\/12 {
    margin-top: 25%;
  }
  .xl\\:mr-3\\/12 {
    margin-right: 25%;
  }
  .xl\\:mb-3\\/12 {
    margin-bottom: 25%;
  }
  .xl\\:ml-3\\/12 {
    margin-left: 25%;
  }
  .xl\\:mt-4\\/12 {
    margin-top: 33.333333%;
  }
  .xl\\:mr-4\\/12 {
    margin-right: 33.333333%;
  }
  .xl\\:mb-4\\/12 {
    margin-bottom: 33.333333%;
  }
  .xl\\:ml-4\\/12 {
    margin-left: 33.333333%;
  }
  .xl\\:mt-5\\/12 {
    margin-top: 41.666667%;
  }
  .xl\\:mr-5\\/12 {
    margin-right: 41.666667%;
  }
  .xl\\:mb-5\\/12 {
    margin-bottom: 41.666667%;
  }
  .xl\\:ml-5\\/12 {
    margin-left: 41.666667%;
  }
  .xl\\:mt-6\\/12 {
    margin-top: 50%;
  }
  .xl\\:mr-6\\/12 {
    margin-right: 50%;
  }
  .xl\\:mb-6\\/12 {
    margin-bottom: 50%;
  }
  .xl\\:ml-6\\/12 {
    margin-left: 50%;
  }
  .xl\\:mt-7\\/12 {
    margin-top: 58.333333%;
  }
  .xl\\:mr-7\\/12 {
    margin-right: 58.333333%;
  }
  .xl\\:mb-7\\/12 {
    margin-bottom: 58.333333%;
  }
  .xl\\:ml-7\\/12 {
    margin-left: 58.333333%;
  }
  .xl\\:mt-8\\/12 {
    margin-top: 66.666667%;
  }
  .xl\\:mr-8\\/12 {
    margin-right: 66.666667%;
  }
  .xl\\:mb-8\\/12 {
    margin-bottom: 66.666667%;
  }
  .xl\\:ml-8\\/12 {
    margin-left: 66.666667%;
  }
  .xl\\:mt-9\\/12 {
    margin-top: 75%;
  }
  .xl\\:mr-9\\/12 {
    margin-right: 75%;
  }
  .xl\\:mb-9\\/12 {
    margin-bottom: 75%;
  }
  .xl\\:ml-9\\/12 {
    margin-left: 75%;
  }
  .xl\\:mt-10\\/12 {
    margin-top: 83.333333%;
  }
  .xl\\:mr-10\\/12 {
    margin-right: 83.333333%;
  }
  .xl\\:mb-10\\/12 {
    margin-bottom: 83.333333%;
  }
  .xl\\:ml-10\\/12 {
    margin-left: 83.333333%;
  }
  .xl\\:mt-11\\/12 {
    margin-top: 91.666667%;
  }
  .xl\\:mr-11\\/12 {
    margin-right: 91.666667%;
  }
  .xl\\:mb-11\\/12 {
    margin-bottom: 91.666667%;
  }
  .xl\\:ml-11\\/12 {
    margin-left: 91.666667%;
  }
  .xl\\:mt-full {
    margin-top: 100%;
  }
  .xl\\:mr-full {
    margin-right: 100%;
  }
  .xl\\:mb-full {
    margin-bottom: 100%;
  }
  .xl\\:ml-full {
    margin-left: 100%;
  }
  .xl\\:-mt-1 {
    margin-top: -0.25rem;
  }
  .xl\\:-mr-1 {
    margin-right: -0.25rem;
  }
  .xl\\:-mb-1 {
    margin-bottom: -0.25rem;
  }
  .xl\\:-ml-1 {
    margin-left: -0.25rem;
  }
  .xl\\:-mt-2 {
    margin-top: -0.5rem;
  }
  .xl\\:-mr-2 {
    margin-right: -0.5rem;
  }
  .xl\\:-mb-2 {
    margin-bottom: -0.5rem;
  }
  .xl\\:-ml-2 {
    margin-left: -0.5rem;
  }
  .xl\\:-mt-3 {
    margin-top: -0.75rem;
  }
  .xl\\:-mr-3 {
    margin-right: -0.75rem;
  }
  .xl\\:-mb-3 {
    margin-bottom: -0.75rem;
  }
  .xl\\:-ml-3 {
    margin-left: -0.75rem;
  }
  .xl\\:-mt-4 {
    margin-top: -1rem;
  }
  .xl\\:-mr-4 {
    margin-right: -1rem;
  }
  .xl\\:-mb-4 {
    margin-bottom: -1rem;
  }
  .xl\\:-ml-4 {
    margin-left: -1rem;
  }
  .xl\\:-mt-5 {
    margin-top: -1.25rem;
  }
  .xl\\:-mr-5 {
    margin-right: -1.25rem;
  }
  .xl\\:-mb-5 {
    margin-bottom: -1.25rem;
  }
  .xl\\:-ml-5 {
    margin-left: -1.25rem;
  }
  .xl\\:-mt-6 {
    margin-top: -1.5rem;
  }
  .xl\\:-mr-6 {
    margin-right: -1.5rem;
  }
  .xl\\:-mb-6 {
    margin-bottom: -1.5rem;
  }
  .xl\\:-ml-6 {
    margin-left: -1.5rem;
  }
  .xl\\:-mt-7 {
    margin-top: -1.75rem;
  }
  .xl\\:-mr-7 {
    margin-right: -1.75rem;
  }
  .xl\\:-mb-7 {
    margin-bottom: -1.75rem;
  }
  .xl\\:-ml-7 {
    margin-left: -1.75rem;
  }
  .xl\\:-mt-8 {
    margin-top: -2rem;
  }
  .xl\\:-mr-8 {
    margin-right: -2rem;
  }
  .xl\\:-mb-8 {
    margin-bottom: -2rem;
  }
  .xl\\:-ml-8 {
    margin-left: -2rem;
  }
  .xl\\:-mt-9 {
    margin-top: -2.25rem;
  }
  .xl\\:-mr-9 {
    margin-right: -2.25rem;
  }
  .xl\\:-mb-9 {
    margin-bottom: -2.25rem;
  }
  .xl\\:-ml-9 {
    margin-left: -2.25rem;
  }
  .xl\\:-mt-10 {
    margin-top: -2.5rem;
  }
  .xl\\:-mr-10 {
    margin-right: -2.5rem;
  }
  .xl\\:-mb-10 {
    margin-bottom: -2.5rem;
  }
  .xl\\:-ml-10 {
    margin-left: -2.5rem;
  }
  .xl\\:-mt-11 {
    margin-top: -2.75rem;
  }
  .xl\\:-mr-11 {
    margin-right: -2.75rem;
  }
  .xl\\:-mb-11 {
    margin-bottom: -2.75rem;
  }
  .xl\\:-ml-11 {
    margin-left: -2.75rem;
  }
  .xl\\:-mt-12 {
    margin-top: -3rem;
  }
  .xl\\:-mr-12 {
    margin-right: -3rem;
  }
  .xl\\:-mb-12 {
    margin-bottom: -3rem;
  }
  .xl\\:-ml-12 {
    margin-left: -3rem;
  }
  .xl\\:-mt-13 {
    margin-top: -3.25rem;
  }
  .xl\\:-mr-13 {
    margin-right: -3.25rem;
  }
  .xl\\:-mb-13 {
    margin-bottom: -3.25rem;
  }
  .xl\\:-ml-13 {
    margin-left: -3.25rem;
  }
  .xl\\:-mt-14 {
    margin-top: -3.5rem;
  }
  .xl\\:-mr-14 {
    margin-right: -3.5rem;
  }
  .xl\\:-mb-14 {
    margin-bottom: -3.5rem;
  }
  .xl\\:-ml-14 {
    margin-left: -3.5rem;
  }
  .xl\\:-mt-15 {
    margin-top: -3.75rem;
  }
  .xl\\:-mr-15 {
    margin-right: -3.75rem;
  }
  .xl\\:-mb-15 {
    margin-bottom: -3.75rem;
  }
  .xl\\:-ml-15 {
    margin-left: -3.75rem;
  }
  .xl\\:-mt-16 {
    margin-top: -4rem;
  }
  .xl\\:-mr-16 {
    margin-right: -4rem;
  }
  .xl\\:-mb-16 {
    margin-bottom: -4rem;
  }
  .xl\\:-ml-16 {
    margin-left: -4rem;
  }
  .xl\\:-mt-20 {
    margin-top: -5rem;
  }
  .xl\\:-mr-20 {
    margin-right: -5rem;
  }
  .xl\\:-mb-20 {
    margin-bottom: -5rem;
  }
  .xl\\:-ml-20 {
    margin-left: -5rem;
  }
  .xl\\:-mt-24 {
    margin-top: -6rem;
  }
  .xl\\:-mr-24 {
    margin-right: -6rem;
  }
  .xl\\:-mb-24 {
    margin-bottom: -6rem;
  }
  .xl\\:-ml-24 {
    margin-left: -6rem;
  }
  .xl\\:-mt-28 {
    margin-top: -7rem;
  }
  .xl\\:-mr-28 {
    margin-right: -7rem;
  }
  .xl\\:-mb-28 {
    margin-bottom: -7rem;
  }
  .xl\\:-ml-28 {
    margin-left: -7rem;
  }
  .xl\\:-mt-32 {
    margin-top: -8rem;
  }
  .xl\\:-mr-32 {
    margin-right: -8rem;
  }
  .xl\\:-mb-32 {
    margin-bottom: -8rem;
  }
  .xl\\:-ml-32 {
    margin-left: -8rem;
  }
  .xl\\:-mt-36 {
    margin-top: -9rem;
  }
  .xl\\:-mr-36 {
    margin-right: -9rem;
  }
  .xl\\:-mb-36 {
    margin-bottom: -9rem;
  }
  .xl\\:-ml-36 {
    margin-left: -9rem;
  }
  .xl\\:-mt-40 {
    margin-top: -10rem;
  }
  .xl\\:-mr-40 {
    margin-right: -10rem;
  }
  .xl\\:-mb-40 {
    margin-bottom: -10rem;
  }
  .xl\\:-ml-40 {
    margin-left: -10rem;
  }
  .xl\\:-mt-44 {
    margin-top: -11rem;
  }
  .xl\\:-mr-44 {
    margin-right: -11rem;
  }
  .xl\\:-mb-44 {
    margin-bottom: -11rem;
  }
  .xl\\:-ml-44 {
    margin-left: -11rem;
  }
  .xl\\:-mt-48 {
    margin-top: -12rem;
  }
  .xl\\:-mr-48 {
    margin-right: -12rem;
  }
  .xl\\:-mb-48 {
    margin-bottom: -12rem;
  }
  .xl\\:-ml-48 {
    margin-left: -12rem;
  }
  .xl\\:-mt-52 {
    margin-top: -13rem;
  }
  .xl\\:-mr-52 {
    margin-right: -13rem;
  }
  .xl\\:-mb-52 {
    margin-bottom: -13rem;
  }
  .xl\\:-ml-52 {
    margin-left: -13rem;
  }
  .xl\\:-mt-56 {
    margin-top: -14rem;
  }
  .xl\\:-mr-56 {
    margin-right: -14rem;
  }
  .xl\\:-mb-56 {
    margin-bottom: -14rem;
  }
  .xl\\:-ml-56 {
    margin-left: -14rem;
  }
  .xl\\:-mt-60 {
    margin-top: -15rem;
  }
  .xl\\:-mr-60 {
    margin-right: -15rem;
  }
  .xl\\:-mb-60 {
    margin-bottom: -15rem;
  }
  .xl\\:-ml-60 {
    margin-left: -15rem;
  }
  .xl\\:-mt-64 {
    margin-top: -16rem;
  }
  .xl\\:-mr-64 {
    margin-right: -16rem;
  }
  .xl\\:-mb-64 {
    margin-bottom: -16rem;
  }
  .xl\\:-ml-64 {
    margin-left: -16rem;
  }
  .xl\\:-mt-72 {
    margin-top: -18rem;
  }
  .xl\\:-mr-72 {
    margin-right: -18rem;
  }
  .xl\\:-mb-72 {
    margin-bottom: -18rem;
  }
  .xl\\:-ml-72 {
    margin-left: -18rem;
  }
  .xl\\:-mt-80 {
    margin-top: -20rem;
  }
  .xl\\:-mr-80 {
    margin-right: -20rem;
  }
  .xl\\:-mb-80 {
    margin-bottom: -20rem;
  }
  .xl\\:-ml-80 {
    margin-left: -20rem;
  }
  .xl\\:-mt-96 {
    margin-top: -24rem;
  }
  .xl\\:-mr-96 {
    margin-right: -24rem;
  }
  .xl\\:-mb-96 {
    margin-bottom: -24rem;
  }
  .xl\\:-ml-96 {
    margin-left: -24rem;
  }
  .xl\\:-mt-px {
    margin-top: -1px;
  }
  .xl\\:-mr-px {
    margin-right: -1px;
  }
  .xl\\:-mb-px {
    margin-bottom: -1px;
  }
  .xl\\:-ml-px {
    margin-left: -1px;
  }
  .xl\\:-mt-0\\.5 {
    margin-top: -0.125rem;
  }
  .xl\\:-mr-0\\.5 {
    margin-right: -0.125rem;
  }
  .xl\\:-mb-0\\.5 {
    margin-bottom: -0.125rem;
  }
  .xl\\:-ml-0\\.5 {
    margin-left: -0.125rem;
  }
  .xl\\:-mt-1\\.5 {
    margin-top: -0.375rem;
  }
  .xl\\:-mr-1\\.5 {
    margin-right: -0.375rem;
  }
  .xl\\:-mb-1\\.5 {
    margin-bottom: -0.375rem;
  }
  .xl\\:-ml-1\\.5 {
    margin-left: -0.375rem;
  }
  .xl\\:-mt-2\\.5 {
    margin-top: -0.625rem;
  }
  .xl\\:-mr-2\\.5 {
    margin-right: -0.625rem;
  }
  .xl\\:-mb-2\\.5 {
    margin-bottom: -0.625rem;
  }
  .xl\\:-ml-2\\.5 {
    margin-left: -0.625rem;
  }
  .xl\\:-mt-3\\.5 {
    margin-top: -0.875rem;
  }
  .xl\\:-mr-3\\.5 {
    margin-right: -0.875rem;
  }
  .xl\\:-mb-3\\.5 {
    margin-bottom: -0.875rem;
  }
  .xl\\:-ml-3\\.5 {
    margin-left: -0.875rem;
  }
  .xl\\:-mt-1\\/2 {
    margin-top: -50%;
  }
  .xl\\:-mr-1\\/2 {
    margin-right: -50%;
  }
  .xl\\:-mb-1\\/2 {
    margin-bottom: -50%;
  }
  .xl\\:-ml-1\\/2 {
    margin-left: -50%;
  }
  .xl\\:-mt-1\\/3 {
    margin-top: -33.33333%;
  }
  .xl\\:-mr-1\\/3 {
    margin-right: -33.33333%;
  }
  .xl\\:-mb-1\\/3 {
    margin-bottom: -33.33333%;
  }
  .xl\\:-ml-1\\/3 {
    margin-left: -33.33333%;
  }
  .xl\\:-mt-2\\/3 {
    margin-top: -66.66667%;
  }
  .xl\\:-mr-2\\/3 {
    margin-right: -66.66667%;
  }
  .xl\\:-mb-2\\/3 {
    margin-bottom: -66.66667%;
  }
  .xl\\:-ml-2\\/3 {
    margin-left: -66.66667%;
  }
  .xl\\:-mt-1\\/4 {
    margin-top: -25%;
  }
  .xl\\:-mr-1\\/4 {
    margin-right: -25%;
  }
  .xl\\:-mb-1\\/4 {
    margin-bottom: -25%;
  }
  .xl\\:-ml-1\\/4 {
    margin-left: -25%;
  }
  .xl\\:-mt-2\\/4 {
    margin-top: -50%;
  }
  .xl\\:-mr-2\\/4 {
    margin-right: -50%;
  }
  .xl\\:-mb-2\\/4 {
    margin-bottom: -50%;
  }
  .xl\\:-ml-2\\/4 {
    margin-left: -50%;
  }
  .xl\\:-mt-3\\/4 {
    margin-top: -75%;
  }
  .xl\\:-mr-3\\/4 {
    margin-right: -75%;
  }
  .xl\\:-mb-3\\/4 {
    margin-bottom: -75%;
  }
  .xl\\:-ml-3\\/4 {
    margin-left: -75%;
  }
  .xl\\:-mt-1\\/5 {
    margin-top: -20%;
  }
  .xl\\:-mr-1\\/5 {
    margin-right: -20%;
  }
  .xl\\:-mb-1\\/5 {
    margin-bottom: -20%;
  }
  .xl\\:-ml-1\\/5 {
    margin-left: -20%;
  }
  .xl\\:-mt-2\\/5 {
    margin-top: -40%;
  }
  .xl\\:-mr-2\\/5 {
    margin-right: -40%;
  }
  .xl\\:-mb-2\\/5 {
    margin-bottom: -40%;
  }
  .xl\\:-ml-2\\/5 {
    margin-left: -40%;
  }
  .xl\\:-mt-3\\/5 {
    margin-top: -60%;
  }
  .xl\\:-mr-3\\/5 {
    margin-right: -60%;
  }
  .xl\\:-mb-3\\/5 {
    margin-bottom: -60%;
  }
  .xl\\:-ml-3\\/5 {
    margin-left: -60%;
  }
  .xl\\:-mt-4\\/5 {
    margin-top: -80%;
  }
  .xl\\:-mr-4\\/5 {
    margin-right: -80%;
  }
  .xl\\:-mb-4\\/5 {
    margin-bottom: -80%;
  }
  .xl\\:-ml-4\\/5 {
    margin-left: -80%;
  }
  .xl\\:-mt-1\\/6 {
    margin-top: -16.66667%;
  }
  .xl\\:-mr-1\\/6 {
    margin-right: -16.66667%;
  }
  .xl\\:-mb-1\\/6 {
    margin-bottom: -16.66667%;
  }
  .xl\\:-ml-1\\/6 {
    margin-left: -16.66667%;
  }
  .xl\\:-mt-2\\/6 {
    margin-top: -33.33333%;
  }
  .xl\\:-mr-2\\/6 {
    margin-right: -33.33333%;
  }
  .xl\\:-mb-2\\/6 {
    margin-bottom: -33.33333%;
  }
  .xl\\:-ml-2\\/6 {
    margin-left: -33.33333%;
  }
  .xl\\:-mt-3\\/6 {
    margin-top: -50%;
  }
  .xl\\:-mr-3\\/6 {
    margin-right: -50%;
  }
  .xl\\:-mb-3\\/6 {
    margin-bottom: -50%;
  }
  .xl\\:-ml-3\\/6 {
    margin-left: -50%;
  }
  .xl\\:-mt-4\\/6 {
    margin-top: -66.66667%;
  }
  .xl\\:-mr-4\\/6 {
    margin-right: -66.66667%;
  }
  .xl\\:-mb-4\\/6 {
    margin-bottom: -66.66667%;
  }
  .xl\\:-ml-4\\/6 {
    margin-left: -66.66667%;
  }
  .xl\\:-mt-5\\/6 {
    margin-top: -83.33333%;
  }
  .xl\\:-mr-5\\/6 {
    margin-right: -83.33333%;
  }
  .xl\\:-mb-5\\/6 {
    margin-bottom: -83.33333%;
  }
  .xl\\:-ml-5\\/6 {
    margin-left: -83.33333%;
  }
  .xl\\:-mt-1\\/12 {
    margin-top: -8.33333%;
  }
  .xl\\:-mr-1\\/12 {
    margin-right: -8.33333%;
  }
  .xl\\:-mb-1\\/12 {
    margin-bottom: -8.33333%;
  }
  .xl\\:-ml-1\\/12 {
    margin-left: -8.33333%;
  }
  .xl\\:-mt-2\\/12 {
    margin-top: -16.66667%;
  }
  .xl\\:-mr-2\\/12 {
    margin-right: -16.66667%;
  }
  .xl\\:-mb-2\\/12 {
    margin-bottom: -16.66667%;
  }
  .xl\\:-ml-2\\/12 {
    margin-left: -16.66667%;
  }
  .xl\\:-mt-3\\/12 {
    margin-top: -25%;
  }
  .xl\\:-mr-3\\/12 {
    margin-right: -25%;
  }
  .xl\\:-mb-3\\/12 {
    margin-bottom: -25%;
  }
  .xl\\:-ml-3\\/12 {
    margin-left: -25%;
  }
  .xl\\:-mt-4\\/12 {
    margin-top: -33.33333%;
  }
  .xl\\:-mr-4\\/12 {
    margin-right: -33.33333%;
  }
  .xl\\:-mb-4\\/12 {
    margin-bottom: -33.33333%;
  }
  .xl\\:-ml-4\\/12 {
    margin-left: -33.33333%;
  }
  .xl\\:-mt-5\\/12 {
    margin-top: -41.66667%;
  }
  .xl\\:-mr-5\\/12 {
    margin-right: -41.66667%;
  }
  .xl\\:-mb-5\\/12 {
    margin-bottom: -41.66667%;
  }
  .xl\\:-ml-5\\/12 {
    margin-left: -41.66667%;
  }
  .xl\\:-mt-6\\/12 {
    margin-top: -50%;
  }
  .xl\\:-mr-6\\/12 {
    margin-right: -50%;
  }
  .xl\\:-mb-6\\/12 {
    margin-bottom: -50%;
  }
  .xl\\:-ml-6\\/12 {
    margin-left: -50%;
  }
  .xl\\:-mt-7\\/12 {
    margin-top: -58.33333%;
  }
  .xl\\:-mr-7\\/12 {
    margin-right: -58.33333%;
  }
  .xl\\:-mb-7\\/12 {
    margin-bottom: -58.33333%;
  }
  .xl\\:-ml-7\\/12 {
    margin-left: -58.33333%;
  }
  .xl\\:-mt-8\\/12 {
    margin-top: -66.66667%;
  }
  .xl\\:-mr-8\\/12 {
    margin-right: -66.66667%;
  }
  .xl\\:-mb-8\\/12 {
    margin-bottom: -66.66667%;
  }
  .xl\\:-ml-8\\/12 {
    margin-left: -66.66667%;
  }
  .xl\\:-mt-9\\/12 {
    margin-top: -75%;
  }
  .xl\\:-mr-9\\/12 {
    margin-right: -75%;
  }
  .xl\\:-mb-9\\/12 {
    margin-bottom: -75%;
  }
  .xl\\:-ml-9\\/12 {
    margin-left: -75%;
  }
  .xl\\:-mt-10\\/12 {
    margin-top: -83.33333%;
  }
  .xl\\:-mr-10\\/12 {
    margin-right: -83.33333%;
  }
  .xl\\:-mb-10\\/12 {
    margin-bottom: -83.33333%;
  }
  .xl\\:-ml-10\\/12 {
    margin-left: -83.33333%;
  }
  .xl\\:-mt-11\\/12 {
    margin-top: -91.66667%;
  }
  .xl\\:-mr-11\\/12 {
    margin-right: -91.66667%;
  }
  .xl\\:-mb-11\\/12 {
    margin-bottom: -91.66667%;
  }
  .xl\\:-ml-11\\/12 {
    margin-left: -91.66667%;
  }
  .xl\\:-mt-full {
    margin-top: -100%;
  }
  .xl\\:-mr-full {
    margin-right: -100%;
  }
  .xl\\:-mb-full {
    margin-bottom: -100%;
  }
  .xl\\:-ml-full {
    margin-left: -100%;
  }
  .xl\\:max-h-0 {
    max-height: 0;
  }
  .xl\\:max-h-1 {
    max-height: 0.25rem;
  }
  .xl\\:max-h-2 {
    max-height: 0.5rem;
  }
  .xl\\:max-h-3 {
    max-height: 0.75rem;
  }
  .xl\\:max-h-4 {
    max-height: 1rem;
  }
  .xl\\:max-h-5 {
    max-height: 1.25rem;
  }
  .xl\\:max-h-6 {
    max-height: 1.5rem;
  }
  .xl\\:max-h-7 {
    max-height: 1.75rem;
  }
  .xl\\:max-h-8 {
    max-height: 2rem;
  }
  .xl\\:max-h-9 {
    max-height: 2.25rem;
  }
  .xl\\:max-h-10 {
    max-height: 2.5rem;
  }
  .xl\\:max-h-11 {
    max-height: 2.75rem;
  }
  .xl\\:max-h-12 {
    max-height: 3rem;
  }
  .xl\\:max-h-13 {
    max-height: 3.25rem;
  }
  .xl\\:max-h-14 {
    max-height: 3.5rem;
  }
  .xl\\:max-h-15 {
    max-height: 3.75rem;
  }
  .xl\\:max-h-16 {
    max-height: 4rem;
  }
  .xl\\:max-h-20 {
    max-height: 5rem;
  }
  .xl\\:max-h-24 {
    max-height: 6rem;
  }
  .xl\\:max-h-28 {
    max-height: 7rem;
  }
  .xl\\:max-h-32 {
    max-height: 8rem;
  }
  .xl\\:max-h-36 {
    max-height: 9rem;
  }
  .xl\\:max-h-40 {
    max-height: 10rem;
  }
  .xl\\:max-h-44 {
    max-height: 11rem;
  }
  .xl\\:max-h-48 {
    max-height: 12rem;
  }
  .xl\\:max-h-52 {
    max-height: 13rem;
  }
  .xl\\:max-h-56 {
    max-height: 14rem;
  }
  .xl\\:max-h-60 {
    max-height: 15rem;
  }
  .xl\\:max-h-64 {
    max-height: 16rem;
  }
  .xl\\:max-h-72 {
    max-height: 18rem;
  }
  .xl\\:max-h-80 {
    max-height: 20rem;
  }
  .xl\\:max-h-96 {
    max-height: 24rem;
  }
  .xl\\:max-h-screen {
    max-height: 100vh;
  }
  .xl\\:max-h-px {
    max-height: 1px;
  }
  .xl\\:max-h-0\\.5 {
    max-height: 0.125rem;
  }
  .xl\\:max-h-1\\.5 {
    max-height: 0.375rem;
  }
  .xl\\:max-h-2\\.5 {
    max-height: 0.625rem;
  }
  .xl\\:max-h-3\\.5 {
    max-height: 0.875rem;
  }
  .xl\\:max-h-1\\/2 {
    max-height: 50%;
  }
  .xl\\:max-h-1\\/3 {
    max-height: 33.333333%;
  }
  .xl\\:max-h-2\\/3 {
    max-height: 66.666667%;
  }
  .xl\\:max-h-1\\/4 {
    max-height: 25%;
  }
  .xl\\:max-h-2\\/4 {
    max-height: 50%;
  }
  .xl\\:max-h-3\\/4 {
    max-height: 75%;
  }
  .xl\\:max-h-1\\/5 {
    max-height: 20%;
  }
  .xl\\:max-h-2\\/5 {
    max-height: 40%;
  }
  .xl\\:max-h-3\\/5 {
    max-height: 60%;
  }
  .xl\\:max-h-4\\/5 {
    max-height: 80%;
  }
  .xl\\:max-h-1\\/6 {
    max-height: 16.666667%;
  }
  .xl\\:max-h-2\\/6 {
    max-height: 33.333333%;
  }
  .xl\\:max-h-3\\/6 {
    max-height: 50%;
  }
  .xl\\:max-h-4\\/6 {
    max-height: 66.666667%;
  }
  .xl\\:max-h-5\\/6 {
    max-height: 83.333333%;
  }
  .xl\\:max-h-1\\/12 {
    max-height: 8.333333%;
  }
  .xl\\:max-h-2\\/12 {
    max-height: 16.666667%;
  }
  .xl\\:max-h-3\\/12 {
    max-height: 25%;
  }
  .xl\\:max-h-4\\/12 {
    max-height: 33.333333%;
  }
  .xl\\:max-h-5\\/12 {
    max-height: 41.666667%;
  }
  .xl\\:max-h-6\\/12 {
    max-height: 50%;
  }
  .xl\\:max-h-7\\/12 {
    max-height: 58.333333%;
  }
  .xl\\:max-h-8\\/12 {
    max-height: 66.666667%;
  }
  .xl\\:max-h-9\\/12 {
    max-height: 75%;
  }
  .xl\\:max-h-10\\/12 {
    max-height: 83.333333%;
  }
  .xl\\:max-h-11\\/12 {
    max-height: 91.666667%;
  }
  .xl\\:max-h-full {
    max-height: 100%;
  }
  .xl\\:max-w-0 {
    max-width: 0rem;
  }
  .xl\\:max-w-none {
    max-width: none;
  }
  .xl\\:max-w-xs {
    max-width: 20rem;
  }
  .xl\\:max-w-sm {
    max-width: 24rem;
  }
  .xl\\:max-w-md {
    max-width: 28rem;
  }
  .xl\\:max-w-lg {
    max-width: 32rem;
  }
  .xl\\:max-w-xl {
    max-width: 36rem;
  }
  .xl\\:max-w-2xl {
    max-width: 42rem;
  }
  .xl\\:max-w-3xl {
    max-width: 48rem;
  }
  .xl\\:max-w-4xl {
    max-width: 56rem;
  }
  .xl\\:max-w-5xl {
    max-width: 64rem;
  }
  .xl\\:max-w-6xl {
    max-width: 72rem;
  }
  .xl\\:max-w-7xl {
    max-width: 80rem;
  }
  .xl\\:max-w-full {
    max-width: 100%;
  }
  .xl\\:max-w-min-content {
    max-width: min-content;
  }
  .xl\\:max-w-max-content {
    max-width: max-content;
  }
  .xl\\:max-w-prose {
    max-width: 65ch;
  }
  .xl\\:max-w-screen-sm {
    max-width: 640px;
  }
  .xl\\:max-w-screen-md {
    max-width: 768px;
  }
  .xl\\:max-w-screen-lg {
    max-width: 1024px;
  }
  .xl\\:max-w-screen-xl {
    max-width: 1280px;
  }
  .xl\\:min-h-0 {
    min-height: 0;
  }
  .xl\\:min-h-full {
    min-height: 100%;
  }
  .xl\\:min-h-screen {
    min-height: 100vh;
  }
  .xl\\:min-w-0 {
    min-width: 0;
  }
  .xl\\:min-w-full {
    min-width: 100%;
  }
  .xl\\:min-w-min-content {
    min-width: min-content;
  }
  .xl\\:min-w-max-content {
    min-width: max-content;
  }
  .xl\\:object-contain {
    object-fit: contain;
  }
  .xl\\:object-cover {
    object-fit: cover;
  }
  .xl\\:object-fill {
    object-fit: fill;
  }
  .xl\\:object-none {
    object-fit: none;
  }
  .xl\\:object-scale-down {
    object-fit: scale-down;
  }
  .xl\\:object-bottom {
    object-position: bottom;
  }
  .xl\\:object-center {
    object-position: center;
  }
  .xl\\:object-left {
    object-position: left;
  }
  .xl\\:object-left-bottom {
    object-position: left bottom;
  }
  .xl\\:object-left-top {
    object-position: left top;
  }
  .xl\\:object-right {
    object-position: right;
  }
  .xl\\:object-right-bottom {
    object-position: right bottom;
  }
  .xl\\:object-right-top {
    object-position: right top;
  }
  .xl\\:object-top {
    object-position: top;
  }
  .xl\\:opacity-0 {
    opacity: 0;
  }
  .xl\\:opacity-25 {
    opacity: 0.25;
  }
  .xl\\:opacity-50 {
    opacity: 0.5;
  }
  .xl\\:opacity-75 {
    opacity: 0.75;
  }
  .xl\\:opacity-100 {
    opacity: 1;
  }
  .xl\\:focus-within\\:opacity-0:focus-within {
    opacity: 0;
  }
  .xl\\:focus-within\\:opacity-25:focus-within {
    opacity: 0.25;
  }
  .xl\\:focus-within\\:opacity-50:focus-within {
    opacity: 0.5;
  }
  .xl\\:focus-within\\:opacity-75:focus-within {
    opacity: 0.75;
  }
  .xl\\:focus-within\\:opacity-100:focus-within {
    opacity: 1;
  }
  .group:hover .xl\\:group-hover\\:opacity-0 {
    opacity: 0;
  }
  .group:hover .xl\\:group-hover\\:opacity-25 {
    opacity: 0.25;
  }
  .group:hover .xl\\:group-hover\\:opacity-50 {
    opacity: 0.5;
  }
  .group:hover .xl\\:group-hover\\:opacity-75 {
    opacity: 0.75;
  }
  .group:hover .xl\\:group-hover\\:opacity-100 {
    opacity: 1;
  }
  .group:focus .xl\\:group-focus\\:opacity-0 {
    opacity: 0;
  }
  .group:focus .xl\\:group-focus\\:opacity-25 {
    opacity: 0.25;
  }
  .group:focus .xl\\:group-focus\\:opacity-50 {
    opacity: 0.5;
  }
  .group:focus .xl\\:group-focus\\:opacity-75 {
    opacity: 0.75;
  }
  .group:focus .xl\\:group-focus\\:opacity-100 {
    opacity: 1;
  }
  .xl\\:hover\\:opacity-0:hover {
    opacity: 0;
  }
  .xl\\:hover\\:opacity-25:hover {
    opacity: 0.25;
  }
  .xl\\:hover\\:opacity-50:hover {
    opacity: 0.5;
  }
  .xl\\:hover\\:opacity-75:hover {
    opacity: 0.75;
  }
  .xl\\:hover\\:opacity-100:hover {
    opacity: 1;
  }
  .xl\\:focus\\:opacity-0:focus {
    opacity: 0;
  }
  .xl\\:focus\\:opacity-25:focus {
    opacity: 0.25;
  }
  .xl\\:focus\\:opacity-50:focus {
    opacity: 0.5;
  }
  .xl\\:focus\\:opacity-75:focus {
    opacity: 0.75;
  }
  .xl\\:focus\\:opacity-100:focus {
    opacity: 1;
  }
  .xl\\:outline-none {
    outline: 2px solid transparent;
    outline-offset: 2px;
  }
  .xl\\:outline-white {
    outline: 2px dotted white;
    outline-offset: 2px;
  }
  .xl\\:outline-black {
    outline: 2px dotted black;
    outline-offset: 2px;
  }
  .xl\\:focus\\:outline-none:focus {
    outline: 2px solid transparent;
    outline-offset: 2px;
  }
  .xl\\:focus\\:outline-white:focus {
    outline: 2px dotted white;
    outline-offset: 2px;
  }
  .xl\\:focus\\:outline-black:focus {
    outline: 2px dotted black;
    outline-offset: 2px;
  }
  .xl\\:overflow-auto {
    overflow: auto;
  }
  .xl\\:overflow-hidden {
    overflow: hidden;
  }
  .xl\\:overflow-visible {
    overflow: visible;
  }
  .xl\\:overflow-scroll {
    overflow: scroll;
  }
  .xl\\:overflow-x-auto {
    overflow-x: hidden;
  }
  .xl\\:overflow-y-auto {
    overflow-y: auto;
  }
  .xl\\:overflow-x-hidden {
    overflow-x: hidden;
  }
  .xl\\:overflow-y-hidden {
    overflow-y: hidden;
  }
  .xl\\:overflow-x-visible {
    overflow-x: visible;
  }
  .xl\\:overflow-y-visible {
    overflow-y: visible;
  }
  .xl\\:overflow-x-scroll {
    overflow-x: hidden;
  }
  .xl\\:overflow-y-scroll {
    overflow-y: scroll;
  }
  .xl\\:scrolling-touch {
    -webkit-overflow-scrolling: touch;
  }
  .xl\\:scrolling-auto {
    -webkit-overflow-scrolling: auto;
  }
  .xl\\:overscroll-auto {
    overscroll-behavior: auto;
  }
  .xl\\:overscroll-contain {
    overscroll-behavior: contain;
  }
  .xl\\:overscroll-none {
    overscroll-behavior: none;
  }
  .xl\\:overscroll-y-auto {
    overscroll-behavior-y: auto;
  }
  .xl\\:overscroll-y-contain {
    overscroll-behavior-y: contain;
  }
  .xl\\:overscroll-y-none {
    overscroll-behavior-y: none;
  }
  .xl\\:overscroll-x-auto {
    overscroll-behavior-x: auto;
  }
  .xl\\:overscroll-x-contain {
    overscroll-behavior-x: contain;
  }
  .xl\\:overscroll-x-none {
    overscroll-behavior-x: none;
  }
  .xl\\:p-0 {
    padding: 0;
  }
  .xl\\:p-1 {
    padding: 0.25rem;
  }
  .xl\\:p-2 {
    padding: 0.5rem;
  }
  .xl\\:p-3 {
    padding: 0.75rem;
  }
  .xl\\:p-4 {
    padding: 1rem;
  }
  .xl\\:p-5 {
    padding: 1.25rem;
  }
  .xl\\:p-6 {
    padding: 1.5rem;
  }
  .xl\\:p-7 {
    padding: 1.75rem;
  }
  .xl\\:p-8 {
    padding: 2rem;
  }
  .xl\\:p-9 {
    padding: 2.25rem;
  }
  .xl\\:p-10 {
    padding: 2.5rem;
  }
  .xl\\:p-11 {
    padding: 2.75rem;
  }
  .xl\\:p-12 {
    padding: 3rem;
  }
  .xl\\:p-13 {
    padding: 3.25rem;
  }
  .xl\\:p-14 {
    padding: 3.5rem;
  }
  .xl\\:p-15 {
    padding: 3.75rem;
  }
  .xl\\:p-16 {
    padding: 4rem;
  }
  .xl\\:p-20 {
    padding: 5rem;
  }
  .xl\\:p-24 {
    padding: 6rem;
  }
  .xl\\:p-28 {
    padding: 7rem;
  }
  .xl\\:p-32 {
    padding: 8rem;
  }
  .xl\\:p-36 {
    padding: 9rem;
  }
  .xl\\:p-40 {
    padding: 10rem;
  }
  .xl\\:p-44 {
    padding: 11rem;
  }
  .xl\\:p-48 {
    padding: 12rem;
  }
  .xl\\:p-52 {
    padding: 13rem;
  }
  .xl\\:p-56 {
    padding: 14rem;
  }
  .xl\\:p-60 {
    padding: 15rem;
  }
  .xl\\:p-64 {
    padding: 16rem;
  }
  .xl\\:p-72 {
    padding: 18rem;
  }
  .xl\\:p-80 {
    padding: 20rem;
  }
  .xl\\:p-96 {
    padding: 24rem;
  }
  .xl\\:p-px {
    padding: 1px;
  }
  .xl\\:p-0\\.5 {
    padding: 0.125rem;
  }
  .xl\\:p-1\\.5 {
    padding: 0.375rem;
  }
  .xl\\:p-2\\.5 {
    padding: 0.625rem;
  }
  .xl\\:p-3\\.5 {
    padding: 0.875rem;
  }
  .xl\\:p-1\\/2 {
    padding: 50%;
  }
  .xl\\:p-1\\/3 {
    padding: 33.333333%;
  }
  .xl\\:p-2\\/3 {
    padding: 66.666667%;
  }
  .xl\\:p-1\\/4 {
    padding: 25%;
  }
  .xl\\:p-2\\/4 {
    padding: 50%;
  }
  .xl\\:p-3\\/4 {
    padding: 75%;
  }
  .xl\\:p-1\\/5 {
    padding: 20%;
  }
  .xl\\:p-2\\/5 {
    padding: 40%;
  }
  .xl\\:p-3\\/5 {
    padding: 60%;
  }
  .xl\\:p-4\\/5 {
    padding: 80%;
  }
  .xl\\:p-1\\/6 {
    padding: 16.666667%;
  }
  .xl\\:p-2\\/6 {
    padding: 33.333333%;
  }
  .xl\\:p-3\\/6 {
    padding: 50%;
  }
  .xl\\:p-4\\/6 {
    padding: 66.666667%;
  }
  .xl\\:p-5\\/6 {
    padding: 83.333333%;
  }
  .xl\\:p-1\\/12 {
    padding: 8.333333%;
  }
  .xl\\:p-2\\/12 {
    padding: 16.666667%;
  }
  .xl\\:p-3\\/12 {
    padding: 25%;
  }
  .xl\\:p-4\\/12 {
    padding: 33.333333%;
  }
  .xl\\:p-5\\/12 {
    padding: 41.666667%;
  }
  .xl\\:p-6\\/12 {
    padding: 50%;
  }
  .xl\\:p-7\\/12 {
    padding: 58.333333%;
  }
  .xl\\:p-8\\/12 {
    padding: 66.666667%;
  }
  .xl\\:p-9\\/12 {
    padding: 75%;
  }
  .xl\\:p-10\\/12 {
    padding: 83.333333%;
  }
  .xl\\:p-11\\/12 {
    padding: 91.666667%;
  }
  .xl\\:p-full {
    padding: 100%;
  }
  .xl\\:py-0 {
    padding-top: 0;
    padding-bottom: 0;
  }
  .xl\\:px-0 {
    padding-left: 0;
    padding-right: 0;
  }
  .xl\\:py-1 {
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
  }
  .xl\\:px-1 {
    padding-left: 0.25rem;
    padding-right: 0.25rem;
  }
  .xl\\:py-2 {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }
  .xl\\:px-2 {
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }
  .xl\\:py-3 {
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
  }
  .xl\\:px-3 {
    padding-left: 0.75rem;
    padding-right: 0.75rem;
  }
  .xl\\:py-4 {
    padding-top: 1rem;
    padding-bottom: 1rem;
  }
  .xl\\:px-4 {
    padding-left: 1rem;
    padding-right: 1rem;
  }
  .xl\\:py-5 {
    padding-top: 1.25rem;
    padding-bottom: 1.25rem;
  }
  .xl\\:px-5 {
    padding-left: 1.25rem;
    padding-right: 1.25rem;
  }
  .xl\\:py-6 {
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
  }
  .xl\\:px-6 {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }
  .xl\\:py-7 {
    padding-top: 1.75rem;
    padding-bottom: 1.75rem;
  }
  .xl\\:px-7 {
    padding-left: 1.75rem;
    padding-right: 1.75rem;
  }
  .xl\\:py-8 {
    padding-top: 2rem;
    padding-bottom: 2rem;
  }
  .xl\\:px-8 {
    padding-left: 2rem;
    padding-right: 2rem;
  }
  .xl\\:py-9 {
    padding-top: 2.25rem;
    padding-bottom: 2.25rem;
  }
  .xl\\:px-9 {
    padding-left: 2.25rem;
    padding-right: 2.25rem;
  }
  .xl\\:py-10 {
    padding-top: 2.5rem;
    padding-bottom: 2.5rem;
  }
  .xl\\:px-10 {
    padding-left: 2.5rem;
    padding-right: 2.5rem;
  }
  .xl\\:py-11 {
    padding-top: 2.75rem;
    padding-bottom: 2.75rem;
  }
  .xl\\:px-11 {
    padding-left: 2.75rem;
    padding-right: 2.75rem;
  }
  .xl\\:py-12 {
    padding-top: 3rem;
    padding-bottom: 3rem;
  }
  .xl\\:px-12 {
    padding-left: 3rem;
    padding-right: 3rem;
  }
  .xl\\:py-13 {
    padding-top: 3.25rem;
    padding-bottom: 3.25rem;
  }
  .xl\\:px-13 {
    padding-left: 3.25rem;
    padding-right: 3.25rem;
  }
  .xl\\:py-14 {
    padding-top: 3.5rem;
    padding-bottom: 3.5rem;
  }
  .xl\\:px-14 {
    padding-left: 3.5rem;
    padding-right: 3.5rem;
  }
  .xl\\:py-15 {
    padding-top: 3.75rem;
    padding-bottom: 3.75rem;
  }
  .xl\\:px-15 {
    padding-left: 3.75rem;
    padding-right: 3.75rem;
  }
  .xl\\:py-16 {
    padding-top: 4rem;
    padding-bottom: 4rem;
  }
  .xl\\:px-16 {
    padding-left: 4rem;
    padding-right: 4rem;
  }
  .xl\\:py-20 {
    padding-top: 5rem;
    padding-bottom: 5rem;
  }
  .xl\\:px-20 {
    padding-left: 5rem;
    padding-right: 5rem;
  }
  .xl\\:py-24 {
    padding-top: 6rem;
    padding-bottom: 6rem;
  }
  .xl\\:px-24 {
    padding-left: 6rem;
    padding-right: 6rem;
  }
  .xl\\:py-28 {
    padding-top: 7rem;
    padding-bottom: 7rem;
  }
  .xl\\:px-28 {
    padding-left: 7rem;
    padding-right: 7rem;
  }
  .xl\\:py-32 {
    padding-top: 8rem;
    padding-bottom: 8rem;
  }
  .xl\\:px-32 {
    padding-left: 8rem;
    padding-right: 8rem;
  }
  .xl\\:py-36 {
    padding-top: 9rem;
    padding-bottom: 9rem;
  }
  .xl\\:px-36 {
    padding-left: 9rem;
    padding-right: 9rem;
  }
  .xl\\:py-40 {
    padding-top: 10rem;
    padding-bottom: 10rem;
  }
  .xl\\:px-40 {
    padding-left: 10rem;
    padding-right: 10rem;
  }
  .xl\\:py-44 {
    padding-top: 11rem;
    padding-bottom: 11rem;
  }
  .xl\\:px-44 {
    padding-left: 11rem;
    padding-right: 11rem;
  }
  .xl\\:py-48 {
    padding-top: 12rem;
    padding-bottom: 12rem;
  }
  .xl\\:px-48 {
    padding-left: 12rem;
    padding-right: 12rem;
  }
  .xl\\:py-52 {
    padding-top: 13rem;
    padding-bottom: 13rem;
  }
  .xl\\:px-52 {
    padding-left: 13rem;
    padding-right: 13rem;
  }
  .xl\\:py-56 {
    padding-top: 14rem;
    padding-bottom: 14rem;
  }
  .xl\\:px-56 {
    padding-left: 14rem;
    padding-right: 14rem;
  }
  .xl\\:py-60 {
    padding-top: 15rem;
    padding-bottom: 15rem;
  }
  .xl\\:px-60 {
    padding-left: 15rem;
    padding-right: 15rem;
  }
  .xl\\:py-64 {
    padding-top: 16rem;
    padding-bottom: 16rem;
  }
  .xl\\:px-64 {
    padding-left: 16rem;
    padding-right: 16rem;
  }
  .xl\\:py-72 {
    padding-top: 18rem;
    padding-bottom: 18rem;
  }
  .xl\\:px-72 {
    padding-left: 18rem;
    padding-right: 18rem;
  }
  .xl\\:py-80 {
    padding-top: 20rem;
    padding-bottom: 20rem;
  }
  .xl\\:px-80 {
    padding-left: 20rem;
    padding-right: 20rem;
  }
  .xl\\:py-96 {
    padding-top: 24rem;
    padding-bottom: 24rem;
  }
  .xl\\:px-96 {
    padding-left: 24rem;
    padding-right: 24rem;
  }
  .xl\\:py-px {
    padding-top: 1px;
    padding-bottom: 1px;
  }
  .xl\\:px-px {
    padding-left: 1px;
    padding-right: 1px;
  }
  .xl\\:py-0\\.5 {
    padding-top: 0.125rem;
    padding-bottom: 0.125rem;
  }
  .xl\\:px-0\\.5 {
    padding-left: 0.125rem;
    padding-right: 0.125rem;
  }
  .xl\\:py-1\\.5 {
    padding-top: 0.375rem;
    padding-bottom: 0.375rem;
  }
  .xl\\:px-1\\.5 {
    padding-left: 0.375rem;
    padding-right: 0.375rem;
  }
  .xl\\:py-2\\.5 {
    padding-top: 0.625rem;
    padding-bottom: 0.625rem;
  }
  .xl\\:px-2\\.5 {
    padding-left: 0.625rem;
    padding-right: 0.625rem;
  }
  .xl\\:py-3\\.5 {
    padding-top: 0.875rem;
    padding-bottom: 0.875rem;
  }
  .xl\\:px-3\\.5 {
    padding-left: 0.875rem;
    padding-right: 0.875rem;
  }
  .xl\\:py-1\\/2 {
    padding-top: 50%;
    padding-bottom: 50%;
  }
  .xl\\:px-1\\/2 {
    padding-left: 50%;
    padding-right: 50%;
  }
  .xl\\:py-1\\/3 {
    padding-top: 33.333333%;
    padding-bottom: 33.333333%;
  }
  .xl\\:px-1\\/3 {
    padding-left: 33.333333%;
    padding-right: 33.333333%;
  }
  .xl\\:py-2\\/3 {
    padding-top: 66.666667%;
    padding-bottom: 66.666667%;
  }
  .xl\\:px-2\\/3 {
    padding-left: 66.666667%;
    padding-right: 66.666667%;
  }
  .xl\\:py-1\\/4 {
    padding-top: 25%;
    padding-bottom: 25%;
  }
  .xl\\:px-1\\/4 {
    padding-left: 25%;
    padding-right: 25%;
  }
  .xl\\:py-2\\/4 {
    padding-top: 50%;
    padding-bottom: 50%;
  }
  .xl\\:px-2\\/4 {
    padding-left: 50%;
    padding-right: 50%;
  }
  .xl\\:py-3\\/4 {
    padding-top: 75%;
    padding-bottom: 75%;
  }
  .xl\\:px-3\\/4 {
    padding-left: 75%;
    padding-right: 75%;
  }
  .xl\\:py-1\\/5 {
    padding-top: 20%;
    padding-bottom: 20%;
  }
  .xl\\:px-1\\/5 {
    padding-left: 20%;
    padding-right: 20%;
  }
  .xl\\:py-2\\/5 {
    padding-top: 40%;
    padding-bottom: 40%;
  }
  .xl\\:px-2\\/5 {
    padding-left: 40%;
    padding-right: 40%;
  }
  .xl\\:py-3\\/5 {
    padding-top: 60%;
    padding-bottom: 60%;
  }
  .xl\\:px-3\\/5 {
    padding-left: 60%;
    padding-right: 60%;
  }
  .xl\\:py-4\\/5 {
    padding-top: 80%;
    padding-bottom: 80%;
  }
  .xl\\:px-4\\/5 {
    padding-left: 80%;
    padding-right: 80%;
  }
  .xl\\:py-1\\/6 {
    padding-top: 16.666667%;
    padding-bottom: 16.666667%;
  }
  .xl\\:px-1\\/6 {
    padding-left: 16.666667%;
    padding-right: 16.666667%;
  }
  .xl\\:py-2\\/6 {
    padding-top: 33.333333%;
    padding-bottom: 33.333333%;
  }
  .xl\\:px-2\\/6 {
    padding-left: 33.333333%;
    padding-right: 33.333333%;
  }
  .xl\\:py-3\\/6 {
    padding-top: 50%;
    padding-bottom: 50%;
  }
  .xl\\:px-3\\/6 {
    padding-left: 50%;
    padding-right: 50%;
  }
  .xl\\:py-4\\/6 {
    padding-top: 66.666667%;
    padding-bottom: 66.666667%;
  }
  .xl\\:px-4\\/6 {
    padding-left: 66.666667%;
    padding-right: 66.666667%;
  }
  .xl\\:py-5\\/6 {
    padding-top: 83.333333%;
    padding-bottom: 83.333333%;
  }
  .xl\\:px-5\\/6 {
    padding-left: 83.333333%;
    padding-right: 83.333333%;
  }
  .xl\\:py-1\\/12 {
    padding-top: 8.333333%;
    padding-bottom: 8.333333%;
  }
  .xl\\:px-1\\/12 {
    padding-left: 8.333333%;
    padding-right: 8.333333%;
  }
  .xl\\:py-2\\/12 {
    padding-top: 16.666667%;
    padding-bottom: 16.666667%;
  }
  .xl\\:px-2\\/12 {
    padding-left: 16.666667%;
    padding-right: 16.666667%;
  }
  .xl\\:py-3\\/12 {
    padding-top: 25%;
    padding-bottom: 25%;
  }
  .xl\\:px-3\\/12 {
    padding-left: 25%;
    padding-right: 25%;
  }
  .xl\\:py-4\\/12 {
    padding-top: 33.333333%;
    padding-bottom: 33.333333%;
  }
  .xl\\:px-4\\/12 {
    padding-left: 33.333333%;
    padding-right: 33.333333%;
  }
  .xl\\:py-5\\/12 {
    padding-top: 41.666667%;
    padding-bottom: 41.666667%;
  }
  .xl\\:px-5\\/12 {
    padding-left: 41.666667%;
    padding-right: 41.666667%;
  }
  .xl\\:py-6\\/12 {
    padding-top: 50%;
    padding-bottom: 50%;
  }
  .xl\\:px-6\\/12 {
    padding-left: 50%;
    padding-right: 50%;
  }
  .xl\\:py-7\\/12 {
    padding-top: 58.333333%;
    padding-bottom: 58.333333%;
  }
  .xl\\:px-7\\/12 {
    padding-left: 58.333333%;
    padding-right: 58.333333%;
  }
  .xl\\:py-8\\/12 {
    padding-top: 66.666667%;
    padding-bottom: 66.666667%;
  }
  .xl\\:px-8\\/12 {
    padding-left: 66.666667%;
    padding-right: 66.666667%;
  }
  .xl\\:py-9\\/12 {
    padding-top: 75%;
    padding-bottom: 75%;
  }
  .xl\\:px-9\\/12 {
    padding-left: 75%;
    padding-right: 75%;
  }
  .xl\\:py-10\\/12 {
    padding-top: 83.333333%;
    padding-bottom: 83.333333%;
  }
  .xl\\:px-10\\/12 {
    padding-left: 83.333333%;
    padding-right: 83.333333%;
  }
  .xl\\:py-11\\/12 {
    padding-top: 91.666667%;
    padding-bottom: 91.666667%;
  }
  .xl\\:px-11\\/12 {
    padding-left: 91.666667%;
    padding-right: 91.666667%;
  }
  .xl\\:py-full {
    padding-top: 100%;
    padding-bottom: 100%;
  }
  .xl\\:px-full {
    padding-left: 100%;
    padding-right: 100%;
  }
  .xl\\:pt-0 {
    padding-top: 0;
  }
  .xl\\:pr-0 {
    padding-right: 0;
  }
  .xl\\:pb-0 {
    padding-bottom: 0;
  }
  .xl\\:pl-0 {
    padding-left: 0;
  }
  .xl\\:pt-1 {
    padding-top: 0.25rem;
  }
  .xl\\:pr-1 {
    padding-right: 0.25rem;
  }
  .xl\\:pb-1 {
    padding-bottom: 0.25rem;
  }
  .xl\\:pl-1 {
    padding-left: 0.25rem;
  }
  .xl\\:pt-2 {
    padding-top: 0.5rem;
  }
  .xl\\:pr-2 {
    padding-right: 0.5rem;
  }
  .xl\\:pb-2 {
    padding-bottom: 0.5rem;
  }
  .xl\\:pl-2 {
    padding-left: 0.5rem;
  }
  .xl\\:pt-3 {
    padding-top: 0.75rem;
  }
  .xl\\:pr-3 {
    padding-right: 0.75rem;
  }
  .xl\\:pb-3 {
    padding-bottom: 0.75rem;
  }
  .xl\\:pl-3 {
    padding-left: 0.75rem;
  }
  .xl\\:pt-4 {
    padding-top: 1rem;
  }
  .xl\\:pr-4 {
    padding-right: 1rem;
  }
  .xl\\:pb-4 {
    padding-bottom: 1rem;
  }
  .xl\\:pl-4 {
    padding-left: 1rem;
  }
  .xl\\:pt-5 {
    padding-top: 1.25rem;
  }
  .xl\\:pr-5 {
    padding-right: 1.25rem;
  }
  .xl\\:pb-5 {
    padding-bottom: 1.25rem;
  }
  .xl\\:pl-5 {
    padding-left: 1.25rem;
  }
  .xl\\:pt-6 {
    padding-top: 1.5rem;
  }
  .xl\\:pr-6 {
    padding-right: 1.5rem;
  }
  .xl\\:pb-6 {
    padding-bottom: 1.5rem;
  }
  .xl\\:pl-6 {
    padding-left: 1.5rem;
  }
  .xl\\:pt-7 {
    padding-top: 1.75rem;
  }
  .xl\\:pr-7 {
    padding-right: 1.75rem;
  }
  .xl\\:pb-7 {
    padding-bottom: 1.75rem;
  }
  .xl\\:pl-7 {
    padding-left: 1.75rem;
  }
  .xl\\:pt-8 {
    padding-top: 2rem;
  }
  .xl\\:pr-8 {
    padding-right: 2rem;
  }
  .xl\\:pb-8 {
    padding-bottom: 2rem;
  }
  .xl\\:pl-8 {
    padding-left: 2rem;
  }
  .xl\\:pt-9 {
    padding-top: 2.25rem;
  }
  .xl\\:pr-9 {
    padding-right: 2.25rem;
  }
  .xl\\:pb-9 {
    padding-bottom: 2.25rem;
  }
  .xl\\:pl-9 {
    padding-left: 2.25rem;
  }
  .xl\\:pt-10 {
    padding-top: 2.5rem;
  }
  .xl\\:pr-10 {
    padding-right: 2.5rem;
  }
  .xl\\:pb-10 {
    padding-bottom: 2.5rem;
  }
  .xl\\:pl-10 {
    padding-left: 2.5rem;
  }
  .xl\\:pt-11 {
    padding-top: 2.75rem;
  }
  .xl\\:pr-11 {
    padding-right: 2.75rem;
  }
  .xl\\:pb-11 {
    padding-bottom: 2.75rem;
  }
  .xl\\:pl-11 {
    padding-left: 2.75rem;
  }
  .xl\\:pt-12 {
    padding-top: 3rem;
  }
  .xl\\:pr-12 {
    padding-right: 3rem;
  }
  .xl\\:pb-12 {
    padding-bottom: 3rem;
  }
  .xl\\:pl-12 {
    padding-left: 3rem;
  }
  .xl\\:pt-13 {
    padding-top: 3.25rem;
  }
  .xl\\:pr-13 {
    padding-right: 3.25rem;
  }
  .xl\\:pb-13 {
    padding-bottom: 3.25rem;
  }
  .xl\\:pl-13 {
    padding-left: 3.25rem;
  }
  .xl\\:pt-14 {
    padding-top: 3.5rem;
  }
  .xl\\:pr-14 {
    padding-right: 3.5rem;
  }
  .xl\\:pb-14 {
    padding-bottom: 3.5rem;
  }
  .xl\\:pl-14 {
    padding-left: 3.5rem;
  }
  .xl\\:pt-15 {
    padding-top: 3.75rem;
  }
  .xl\\:pr-15 {
    padding-right: 3.75rem;
  }
  .xl\\:pb-15 {
    padding-bottom: 3.75rem;
  }
  .xl\\:pl-15 {
    padding-left: 3.75rem;
  }
  .xl\\:pt-16 {
    padding-top: 4rem;
  }
  .xl\\:pr-16 {
    padding-right: 4rem;
  }
  .xl\\:pb-16 {
    padding-bottom: 4rem;
  }
  .xl\\:pl-16 {
    padding-left: 4rem;
  }
  .xl\\:pt-20 {
    padding-top: 5rem;
  }
  .xl\\:pr-20 {
    padding-right: 5rem;
  }
  .xl\\:pb-20 {
    padding-bottom: 5rem;
  }
  .xl\\:pl-20 {
    padding-left: 5rem;
  }
  .xl\\:pt-24 {
    padding-top: 6rem;
  }
  .xl\\:pr-24 {
    padding-right: 6rem;
  }
  .xl\\:pb-24 {
    padding-bottom: 6rem;
  }
  .xl\\:pl-24 {
    padding-left: 6rem;
  }
  .xl\\:pt-28 {
    padding-top: 7rem;
  }
  .xl\\:pr-28 {
    padding-right: 7rem;
  }
  .xl\\:pb-28 {
    padding-bottom: 7rem;
  }
  .xl\\:pl-28 {
    padding-left: 7rem;
  }
  .xl\\:pt-32 {
    padding-top: 8rem;
  }
  .xl\\:pr-32 {
    padding-right: 8rem;
  }
  .xl\\:pb-32 {
    padding-bottom: 8rem;
  }
  .xl\\:pl-32 {
    padding-left: 8rem;
  }
  .xl\\:pt-36 {
    padding-top: 9rem;
  }
  .xl\\:pr-36 {
    padding-right: 9rem;
  }
  .xl\\:pb-36 {
    padding-bottom: 9rem;
  }
  .xl\\:pl-36 {
    padding-left: 9rem;
  }
  .xl\\:pt-40 {
    padding-top: 10rem;
  }
  .xl\\:pr-40 {
    padding-right: 10rem;
  }
  .xl\\:pb-40 {
    padding-bottom: 10rem;
  }
  .xl\\:pl-40 {
    padding-left: 10rem;
  }
  .xl\\:pt-44 {
    padding-top: 11rem;
  }
  .xl\\:pr-44 {
    padding-right: 11rem;
  }
  .xl\\:pb-44 {
    padding-bottom: 11rem;
  }
  .xl\\:pl-44 {
    padding-left: 11rem;
  }
  .xl\\:pt-48 {
    padding-top: 12rem;
  }
  .xl\\:pr-48 {
    padding-right: 12rem;
  }
  .xl\\:pb-48 {
    padding-bottom: 12rem;
  }
  .xl\\:pl-48 {
    padding-left: 12rem;
  }
  .xl\\:pt-52 {
    padding-top: 13rem;
  }
  .xl\\:pr-52 {
    padding-right: 13rem;
  }
  .xl\\:pb-52 {
    padding-bottom: 13rem;
  }
  .xl\\:pl-52 {
    padding-left: 13rem;
  }
  .xl\\:pt-56 {
    padding-top: 14rem;
  }
  .xl\\:pr-56 {
    padding-right: 14rem;
  }
  .xl\\:pb-56 {
    padding-bottom: 14rem;
  }
  .xl\\:pl-56 {
    padding-left: 14rem;
  }
  .xl\\:pt-60 {
    padding-top: 15rem;
  }
  .xl\\:pr-60 {
    padding-right: 15rem;
  }
  .xl\\:pb-60 {
    padding-bottom: 15rem;
  }
  .xl\\:pl-60 {
    padding-left: 15rem;
  }
  .xl\\:pt-64 {
    padding-top: 16rem;
  }
  .xl\\:pr-64 {
    padding-right: 16rem;
  }
  .xl\\:pb-64 {
    padding-bottom: 16rem;
  }
  .xl\\:pl-64 {
    padding-left: 16rem;
  }
  .xl\\:pt-72 {
    padding-top: 18rem;
  }
  .xl\\:pr-72 {
    padding-right: 18rem;
  }
  .xl\\:pb-72 {
    padding-bottom: 18rem;
  }
  .xl\\:pl-72 {
    padding-left: 18rem;
  }
  .xl\\:pt-80 {
    padding-top: 20rem;
  }
  .xl\\:pr-80 {
    padding-right: 20rem;
  }
  .xl\\:pb-80 {
    padding-bottom: 20rem;
  }
  .xl\\:pl-80 {
    padding-left: 20rem;
  }
  .xl\\:pt-96 {
    padding-top: 24rem;
  }
  .xl\\:pr-96 {
    padding-right: 24rem;
  }
  .xl\\:pb-96 {
    padding-bottom: 24rem;
  }
  .xl\\:pl-96 {
    padding-left: 24rem;
  }
  .xl\\:pt-px {
    padding-top: 1px;
  }
  .xl\\:pr-px {
    padding-right: 1px;
  }
  .xl\\:pb-px {
    padding-bottom: 1px;
  }
  .xl\\:pl-px {
    padding-left: 1px;
  }
  .xl\\:pt-0\\.5 {
    padding-top: 0.125rem;
  }
  .xl\\:pr-0\\.5 {
    padding-right: 0.125rem;
  }
  .xl\\:pb-0\\.5 {
    padding-bottom: 0.125rem;
  }
  .xl\\:pl-0\\.5 {
    padding-left: 0.125rem;
  }
  .xl\\:pt-1\\.5 {
    padding-top: 0.375rem;
  }
  .xl\\:pr-1\\.5 {
    padding-right: 0.375rem;
  }
  .xl\\:pb-1\\.5 {
    padding-bottom: 0.375rem;
  }
  .xl\\:pl-1\\.5 {
    padding-left: 0.375rem;
  }
  .xl\\:pt-2\\.5 {
    padding-top: 0.625rem;
  }
  .xl\\:pr-2\\.5 {
    padding-right: 0.625rem;
  }
  .xl\\:pb-2\\.5 {
    padding-bottom: 0.625rem;
  }
  .xl\\:pl-2\\.5 {
    padding-left: 0.625rem;
  }
  .xl\\:pt-3\\.5 {
    padding-top: 0.875rem;
  }
  .xl\\:pr-3\\.5 {
    padding-right: 0.875rem;
  }
  .xl\\:pb-3\\.5 {
    padding-bottom: 0.875rem;
  }
  .xl\\:pl-3\\.5 {
    padding-left: 0.875rem;
  }
  .xl\\:pt-1\\/2 {
    padding-top: 50%;
  }
  .xl\\:pr-1\\/2 {
    padding-right: 50%;
  }
  .xl\\:pb-1\\/2 {
    padding-bottom: 50%;
  }
  .xl\\:pl-1\\/2 {
    padding-left: 50%;
  }
  .xl\\:pt-1\\/3 {
    padding-top: 33.333333%;
  }
  .xl\\:pr-1\\/3 {
    padding-right: 33.333333%;
  }
  .xl\\:pb-1\\/3 {
    padding-bottom: 33.333333%;
  }
  .xl\\:pl-1\\/3 {
    padding-left: 33.333333%;
  }
  .xl\\:pt-2\\/3 {
    padding-top: 66.666667%;
  }
  .xl\\:pr-2\\/3 {
    padding-right: 66.666667%;
  }
  .xl\\:pb-2\\/3 {
    padding-bottom: 66.666667%;
  }
  .xl\\:pl-2\\/3 {
    padding-left: 66.666667%;
  }
  .xl\\:pt-1\\/4 {
    padding-top: 25%;
  }
  .xl\\:pr-1\\/4 {
    padding-right: 25%;
  }
  .xl\\:pb-1\\/4 {
    padding-bottom: 25%;
  }
  .xl\\:pl-1\\/4 {
    padding-left: 25%;
  }
  .xl\\:pt-2\\/4 {
    padding-top: 50%;
  }
  .xl\\:pr-2\\/4 {
    padding-right: 50%;
  }
  .xl\\:pb-2\\/4 {
    padding-bottom: 50%;
  }
  .xl\\:pl-2\\/4 {
    padding-left: 50%;
  }
  .xl\\:pt-3\\/4 {
    padding-top: 75%;
  }
  .xl\\:pr-3\\/4 {
    padding-right: 75%;
  }
  .xl\\:pb-3\\/4 {
    padding-bottom: 75%;
  }
  .xl\\:pl-3\\/4 {
    padding-left: 75%;
  }
  .xl\\:pt-1\\/5 {
    padding-top: 20%;
  }
  .xl\\:pr-1\\/5 {
    padding-right: 20%;
  }
  .xl\\:pb-1\\/5 {
    padding-bottom: 20%;
  }
  .xl\\:pl-1\\/5 {
    padding-left: 20%;
  }
  .xl\\:pt-2\\/5 {
    padding-top: 40%;
  }
  .xl\\:pr-2\\/5 {
    padding-right: 40%;
  }
  .xl\\:pb-2\\/5 {
    padding-bottom: 40%;
  }
  .xl\\:pl-2\\/5 {
    padding-left: 40%;
  }
  .xl\\:pt-3\\/5 {
    padding-top: 60%;
  }
  .xl\\:pr-3\\/5 {
    padding-right: 60%;
  }
  .xl\\:pb-3\\/5 {
    padding-bottom: 60%;
  }
  .xl\\:pl-3\\/5 {
    padding-left: 60%;
  }
  .xl\\:pt-4\\/5 {
    padding-top: 80%;
  }
  .xl\\:pr-4\\/5 {
    padding-right: 80%;
  }
  .xl\\:pb-4\\/5 {
    padding-bottom: 80%;
  }
  .xl\\:pl-4\\/5 {
    padding-left: 80%;
  }
  .xl\\:pt-1\\/6 {
    padding-top: 16.666667%;
  }
  .xl\\:pr-1\\/6 {
    padding-right: 16.666667%;
  }
  .xl\\:pb-1\\/6 {
    padding-bottom: 16.666667%;
  }
  .xl\\:pl-1\\/6 {
    padding-left: 16.666667%;
  }
  .xl\\:pt-2\\/6 {
    padding-top: 33.333333%;
  }
  .xl\\:pr-2\\/6 {
    padding-right: 33.333333%;
  }
  .xl\\:pb-2\\/6 {
    padding-bottom: 33.333333%;
  }
  .xl\\:pl-2\\/6 {
    padding-left: 33.333333%;
  }
  .xl\\:pt-3\\/6 {
    padding-top: 50%;
  }
  .xl\\:pr-3\\/6 {
    padding-right: 50%;
  }
  .xl\\:pb-3\\/6 {
    padding-bottom: 50%;
  }
  .xl\\:pl-3\\/6 {
    padding-left: 50%;
  }
  .xl\\:pt-4\\/6 {
    padding-top: 66.666667%;
  }
  .xl\\:pr-4\\/6 {
    padding-right: 66.666667%;
  }
  .xl\\:pb-4\\/6 {
    padding-bottom: 66.666667%;
  }
  .xl\\:pl-4\\/6 {
    padding-left: 66.666667%;
  }
  .xl\\:pt-5\\/6 {
    padding-top: 83.333333%;
  }
  .xl\\:pr-5\\/6 {
    padding-right: 83.333333%;
  }
  .xl\\:pb-5\\/6 {
    padding-bottom: 83.333333%;
  }
  .xl\\:pl-5\\/6 {
    padding-left: 83.333333%;
  }
  .xl\\:pt-1\\/12 {
    padding-top: 8.333333%;
  }
  .xl\\:pr-1\\/12 {
    padding-right: 8.333333%;
  }
  .xl\\:pb-1\\/12 {
    padding-bottom: 8.333333%;
  }
  .xl\\:pl-1\\/12 {
    padding-left: 8.333333%;
  }
  .xl\\:pt-2\\/12 {
    padding-top: 16.666667%;
  }
  .xl\\:pr-2\\/12 {
    padding-right: 16.666667%;
  }
  .xl\\:pb-2\\/12 {
    padding-bottom: 16.666667%;
  }
  .xl\\:pl-2\\/12 {
    padding-left: 16.666667%;
  }
  .xl\\:pt-3\\/12 {
    padding-top: 25%;
  }
  .xl\\:pr-3\\/12 {
    padding-right: 25%;
  }
  .xl\\:pb-3\\/12 {
    padding-bottom: 25%;
  }
  .xl\\:pl-3\\/12 {
    padding-left: 25%;
  }
  .xl\\:pt-4\\/12 {
    padding-top: 33.333333%;
  }
  .xl\\:pr-4\\/12 {
    padding-right: 33.333333%;
  }
  .xl\\:pb-4\\/12 {
    padding-bottom: 33.333333%;
  }
  .xl\\:pl-4\\/12 {
    padding-left: 33.333333%;
  }
  .xl\\:pt-5\\/12 {
    padding-top: 41.666667%;
  }
  .xl\\:pr-5\\/12 {
    padding-right: 41.666667%;
  }
  .xl\\:pb-5\\/12 {
    padding-bottom: 41.666667%;
  }
  .xl\\:pl-5\\/12 {
    padding-left: 41.666667%;
  }
  .xl\\:pt-6\\/12 {
    padding-top: 50%;
  }
  .xl\\:pr-6\\/12 {
    padding-right: 50%;
  }
  .xl\\:pb-6\\/12 {
    padding-bottom: 50%;
  }
  .xl\\:pl-6\\/12 {
    padding-left: 50%;
  }
  .xl\\:pt-7\\/12 {
    padding-top: 58.333333%;
  }
  .xl\\:pr-7\\/12 {
    padding-right: 58.333333%;
  }
  .xl\\:pb-7\\/12 {
    padding-bottom: 58.333333%;
  }
  .xl\\:pl-7\\/12 {
    padding-left: 58.333333%;
  }
  .xl\\:pt-8\\/12 {
    padding-top: 66.666667%;
  }
  .xl\\:pr-8\\/12 {
    padding-right: 66.666667%;
  }
  .xl\\:pb-8\\/12 {
    padding-bottom: 66.666667%;
  }
  .xl\\:pl-8\\/12 {
    padding-left: 66.666667%;
  }
  .xl\\:pt-9\\/12 {
    padding-top: 75%;
  }
  .xl\\:pr-9\\/12 {
    padding-right: 75%;
  }
  .xl\\:pb-9\\/12 {
    padding-bottom: 75%;
  }
  .xl\\:pl-9\\/12 {
    padding-left: 75%;
  }
  .xl\\:pt-10\\/12 {
    padding-top: 83.333333%;
  }
  .xl\\:pr-10\\/12 {
    padding-right: 83.333333%;
  }
  .xl\\:pb-10\\/12 {
    padding-bottom: 83.333333%;
  }
  .xl\\:pl-10\\/12 {
    padding-left: 83.333333%;
  }
  .xl\\:pt-11\\/12 {
    padding-top: 91.666667%;
  }
  .xl\\:pr-11\\/12 {
    padding-right: 91.666667%;
  }
  .xl\\:pb-11\\/12 {
    padding-bottom: 91.666667%;
  }
  .xl\\:pl-11\\/12 {
    padding-left: 91.666667%;
  }
  .xl\\:pt-full {
    padding-top: 100%;
  }
  .xl\\:pr-full {
    padding-right: 100%;
  }
  .xl\\:pb-full {
    padding-bottom: 100%;
  }
  .xl\\:pl-full {
    padding-left: 100%;
  }
  .xl\\:placeholder-current::placeholder {
    color: currentColor;
  }
  .xl\\:placeholder-transparent::placeholder {
    color: transparent;
  }
  .xl\\:placeholder-white::placeholder {
    --placeholder-opacity: 1;
    color: #ffffff;
    color: rgba(255, 255, 255, var(--placeholder-opacity));
  }
  .xl\\:placeholder-black::placeholder {
    --placeholder-opacity: 1;
    color: #000000;
    color: rgba(0, 0, 0, var(--placeholder-opacity));
  }
  .xl\\:placeholder-gray-50::placeholder {
    --placeholder-opacity: 1;
    color: #f9fafb;
    color: rgba(249, 250, 251, var(--placeholder-opacity));
  }
  .xl\\:placeholder-gray-100::placeholder {
    --placeholder-opacity: 1;
    color: #f4f5f7;
    color: rgba(244, 245, 247, var(--placeholder-opacity));
  }
  .xl\\:placeholder-gray-200::placeholder {
    --placeholder-opacity: 1;
    color: #e5e7eb;
    color: rgba(229, 231, 235, var(--placeholder-opacity));
  }
  .xl\\:placeholder-gray-300::placeholder {
    --placeholder-opacity: 1;
    color: #d2d6dc;
    color: rgba(210, 214, 220, var(--placeholder-opacity));
  }
  .xl\\:placeholder-gray-400::placeholder {
    --placeholder-opacity: 1;
    color: #9fa6b2;
    color: rgba(159, 166, 178, var(--placeholder-opacity));
  }
  .xl\\:placeholder-gray-500::placeholder {
    --placeholder-opacity: 1;
    color: #6b7280;
    color: rgba(107, 114, 128, var(--placeholder-opacity));
  }
  .xl\\:placeholder-gray-600::placeholder {
    --placeholder-opacity: 1;
    color: #4b5563;
    color: rgba(75, 85, 99, var(--placeholder-opacity));
  }
  .xl\\:placeholder-gray-700::placeholder {
    --placeholder-opacity: 1;
    color: #374151;
    color: rgba(55, 65, 81, var(--placeholder-opacity));
  }
  .xl\\:placeholder-gray-800::placeholder {
    --placeholder-opacity: 1;
    color: #252f3f;
    color: rgba(37, 47, 63, var(--placeholder-opacity));
  }
  .xl\\:placeholder-gray-900::placeholder {
    --placeholder-opacity: 1;
    color: #161e2e;
    color: rgba(22, 30, 46, var(--placeholder-opacity));
  }
  .xl\\:placeholder-red-50::placeholder {
    --placeholder-opacity: 1;
    color: #fdf2f2;
    color: rgba(253, 242, 242, var(--placeholder-opacity));
  }
  .xl\\:placeholder-red-100::placeholder {
    --placeholder-opacity: 1;
    color: #fde8e8;
    color: rgba(253, 232, 232, var(--placeholder-opacity));
  }
  .xl\\:placeholder-red-200::placeholder {
    --placeholder-opacity: 1;
    color: #fbd5d5;
    color: rgba(251, 213, 213, var(--placeholder-opacity));
  }
  .xl\\:placeholder-red-300::placeholder {
    --placeholder-opacity: 1;
    color: #f8b4b4;
    color: rgba(248, 180, 180, var(--placeholder-opacity));
  }
  .xl\\:placeholder-red-400::placeholder {
    --placeholder-opacity: 1;
    color: #f98080;
    color: rgba(249, 128, 128, var(--placeholder-opacity));
  }
  .xl\\:placeholder-red-500::placeholder {
    --placeholder-opacity: 1;
    color: #f05252;
    color: rgba(240, 82, 82, var(--placeholder-opacity));
  }
  .xl\\:placeholder-red-600::placeholder {
    --placeholder-opacity: 1;
    color: #e02424;
    color: rgba(224, 36, 36, var(--placeholder-opacity));
  }
  .xl\\:placeholder-red-700::placeholder {
    --placeholder-opacity: 1;
    color: #c81e1e;
    color: rgba(200, 30, 30, var(--placeholder-opacity));
  }
  .xl\\:placeholder-red-800::placeholder {
    --placeholder-opacity: 1;
    color: #9b1c1c;
    color: rgba(155, 28, 28, var(--placeholder-opacity));
  }
  .xl\\:placeholder-red-900::placeholder {
    --placeholder-opacity: 1;
    color: #771d1d;
    color: rgba(119, 29, 29, var(--placeholder-opacity));
  }
  .xl\\:placeholder-orange-50::placeholder {
    --placeholder-opacity: 1;
    color: #fff8f1;
    color: rgba(255, 248, 241, var(--placeholder-opacity));
  }
  .xl\\:placeholder-orange-100::placeholder {
    --placeholder-opacity: 1;
    color: #feecdc;
    color: rgba(254, 236, 220, var(--placeholder-opacity));
  }
  .xl\\:placeholder-orange-200::placeholder {
    --placeholder-opacity: 1;
    color: #fcd9bd;
    color: rgba(252, 217, 189, var(--placeholder-opacity));
  }
  .xl\\:placeholder-orange-300::placeholder {
    --placeholder-opacity: 1;
    color: #fdba8c;
    color: rgba(253, 186, 140, var(--placeholder-opacity));
  }
  .xl\\:placeholder-orange-400::placeholder {
    --placeholder-opacity: 1;
    color: #ff8a4c;
    color: rgba(255, 138, 76, var(--placeholder-opacity));
  }
  .xl\\:placeholder-orange-500::placeholder {
    --placeholder-opacity: 1;
    color: #ff5a1f;
    color: rgba(255, 90, 31, var(--placeholder-opacity));
  }
  .xl\\:placeholder-orange-600::placeholder {
    --placeholder-opacity: 1;
    color: #d03801;
    color: rgba(208, 56, 1, var(--placeholder-opacity));
  }
  .xl\\:placeholder-orange-700::placeholder {
    --placeholder-opacity: 1;
    color: #b43403;
    color: rgba(180, 52, 3, var(--placeholder-opacity));
  }
  .xl\\:placeholder-orange-800::placeholder {
    --placeholder-opacity: 1;
    color: #8a2c0d;
    color: rgba(138, 44, 13, var(--placeholder-opacity));
  }
  .xl\\:placeholder-orange-900::placeholder {
    --placeholder-opacity: 1;
    color: #73230d;
    color: rgba(115, 35, 13, var(--placeholder-opacity));
  }
  .xl\\:placeholder-yellow-50::placeholder {
    --placeholder-opacity: 1;
    color: #fdfdea;
    color: rgba(253, 253, 234, var(--placeholder-opacity));
  }
  .xl\\:placeholder-yellow-100::placeholder {
    --placeholder-opacity: 1;
    color: #fdf6b2;
    color: rgba(253, 246, 178, var(--placeholder-opacity));
  }
  .xl\\:placeholder-yellow-200::placeholder {
    --placeholder-opacity: 1;
    color: #fce96a;
    color: rgba(252, 233, 106, var(--placeholder-opacity));
  }
  .xl\\:placeholder-yellow-300::placeholder {
    --placeholder-opacity: 1;
    color: #faca15;
    color: rgba(250, 202, 21, var(--placeholder-opacity));
  }
  .xl\\:placeholder-yellow-400::placeholder {
    --placeholder-opacity: 1;
    color: #e3a008;
    color: rgba(227, 160, 8, var(--placeholder-opacity));
  }
  .xl\\:placeholder-yellow-500::placeholder {
    --placeholder-opacity: 1;
    color: #c27803;
    color: rgba(194, 120, 3, var(--placeholder-opacity));
  }
  .xl\\:placeholder-yellow-600::placeholder {
    --placeholder-opacity: 1;
    color: #9f580a;
    color: rgba(159, 88, 10, var(--placeholder-opacity));
  }
  .xl\\:placeholder-yellow-700::placeholder {
    --placeholder-opacity: 1;
    color: #8e4b10;
    color: rgba(142, 75, 16, var(--placeholder-opacity));
  }
  .xl\\:placeholder-yellow-800::placeholder {
    --placeholder-opacity: 1;
    color: #723b13;
    color: rgba(114, 59, 19, var(--placeholder-opacity));
  }
  .xl\\:placeholder-yellow-900::placeholder {
    --placeholder-opacity: 1;
    color: #633112;
    color: rgba(99, 49, 18, var(--placeholder-opacity));
  }
  .xl\\:placeholder-green-50::placeholder {
    --placeholder-opacity: 1;
    color: #f3faf7;
    color: rgba(243, 250, 247, var(--placeholder-opacity));
  }
  .xl\\:placeholder-green-100::placeholder {
    --placeholder-opacity: 1;
    color: #def7ec;
    color: rgba(222, 247, 236, var(--placeholder-opacity));
  }
  .xl\\:placeholder-green-200::placeholder {
    --placeholder-opacity: 1;
    color: #bcf0da;
    color: rgba(188, 240, 218, var(--placeholder-opacity));
  }
  .xl\\:placeholder-green-300::placeholder {
    --placeholder-opacity: 1;
    color: #84e1bc;
    color: rgba(132, 225, 188, var(--placeholder-opacity));
  }
  .xl\\:placeholder-green-400::placeholder {
    --placeholder-opacity: 1;
    color: #31c48d;
    color: rgba(49, 196, 141, var(--placeholder-opacity));
  }
  .xl\\:placeholder-green-500::placeholder {
    --placeholder-opacity: 1;
    color: #0e9f6e;
    color: rgba(14, 159, 110, var(--placeholder-opacity));
  }
  .xl\\:placeholder-green-600::placeholder {
    --placeholder-opacity: 1;
    color: #057a55;
    color: rgba(5, 122, 85, var(--placeholder-opacity));
  }
  .xl\\:placeholder-green-700::placeholder {
    --placeholder-opacity: 1;
    color: #046c4e;
    color: rgba(4, 108, 78, var(--placeholder-opacity));
  }
  .xl\\:placeholder-green-800::placeholder {
    --placeholder-opacity: 1;
    color: #03543f;
    color: rgba(3, 84, 63, var(--placeholder-opacity));
  }
  .xl\\:placeholder-green-900::placeholder {
    --placeholder-opacity: 1;
    color: #014737;
    color: rgba(1, 71, 55, var(--placeholder-opacity));
  }
  .xl\\:placeholder-teal-50::placeholder {
    --placeholder-opacity: 1;
    color: #edfafa;
    color: rgba(237, 250, 250, var(--placeholder-opacity));
  }
  .xl\\:placeholder-teal-100::placeholder {
    --placeholder-opacity: 1;
    color: #d5f5f6;
    color: rgba(213, 245, 246, var(--placeholder-opacity));
  }
  .xl\\:placeholder-teal-200::placeholder {
    --placeholder-opacity: 1;
    color: #afecef;
    color: rgba(175, 236, 239, var(--placeholder-opacity));
  }
  .xl\\:placeholder-teal-300::placeholder {
    --placeholder-opacity: 1;
    color: #7edce2;
    color: rgba(126, 220, 226, var(--placeholder-opacity));
  }
  .xl\\:placeholder-teal-400::placeholder {
    --placeholder-opacity: 1;
    color: #16bdca;
    color: rgba(22, 189, 202, var(--placeholder-opacity));
  }
  .xl\\:placeholder-teal-500::placeholder {
    --placeholder-opacity: 1;
    color: #0694a2;
    color: rgba(6, 148, 162, var(--placeholder-opacity));
  }
  .xl\\:placeholder-teal-600::placeholder {
    --placeholder-opacity: 1;
    color: #047481;
    color: rgba(4, 116, 129, var(--placeholder-opacity));
  }
  .xl\\:placeholder-teal-700::placeholder {
    --placeholder-opacity: 1;
    color: #036672;
    color: rgba(3, 102, 114, var(--placeholder-opacity));
  }
  .xl\\:placeholder-teal-800::placeholder {
    --placeholder-opacity: 1;
    color: #05505c;
    color: rgba(5, 80, 92, var(--placeholder-opacity));
  }
  .xl\\:placeholder-teal-900::placeholder {
    --placeholder-opacity: 1;
    color: #014451;
    color: rgba(1, 68, 81, var(--placeholder-opacity));
  }
  .xl\\:placeholder-blue-50::placeholder {
    --placeholder-opacity: 1;
    color: #ebf5ff;
    color: rgba(235, 245, 255, var(--placeholder-opacity));
  }
  .xl\\:placeholder-blue-100::placeholder {
    --placeholder-opacity: 1;
    color: #e1effe;
    color: rgba(225, 239, 254, var(--placeholder-opacity));
  }
  .xl\\:placeholder-blue-200::placeholder {
    --placeholder-opacity: 1;
    color: #c3ddfd;
    color: rgba(195, 221, 253, var(--placeholder-opacity));
  }
  .xl\\:placeholder-blue-300::placeholder {
    --placeholder-opacity: 1;
    color: #a4cafe;
    color: rgba(164, 202, 254, var(--placeholder-opacity));
  }
  .xl\\:placeholder-blue-400::placeholder {
    --placeholder-opacity: 1;
    color: #76a9fa;
    color: rgba(118, 169, 250, var(--placeholder-opacity));
  }
  .xl\\:placeholder-blue-500::placeholder {
    --placeholder-opacity: 1;
    color: #3f83f8;
    color: rgba(63, 131, 248, var(--placeholder-opacity));
  }
  .xl\\:placeholder-blue-600::placeholder {
    --placeholder-opacity: 1;
    color: #1c64f2;
    color: rgba(28, 100, 242, var(--placeholder-opacity));
  }
  .xl\\:placeholder-blue-700::placeholder {
    --placeholder-opacity: 1;
    color: #1a56db;
    color: rgba(26, 86, 219, var(--placeholder-opacity));
  }
  .xl\\:placeholder-blue-800::placeholder {
    --placeholder-opacity: 1;
    color: #1e429f;
    color: rgba(30, 66, 159, var(--placeholder-opacity));
  }
  .xl\\:placeholder-blue-900::placeholder {
    --placeholder-opacity: 1;
    color: #233876;
    color: rgba(35, 56, 118, var(--placeholder-opacity));
  }
  .xl\\:placeholder-indigo-50::placeholder {
    --placeholder-opacity: 1;
    color: #f0f5ff;
    color: rgba(240, 245, 255, var(--placeholder-opacity));
  }
  .xl\\:placeholder-indigo-100::placeholder {
    --placeholder-opacity: 1;
    color: #e5edff;
    color: rgba(229, 237, 255, var(--placeholder-opacity));
  }
  .xl\\:placeholder-indigo-200::placeholder {
    --placeholder-opacity: 1;
    color: #cddbfe;
    color: rgba(205, 219, 254, var(--placeholder-opacity));
  }
  .xl\\:placeholder-indigo-300::placeholder {
    --placeholder-opacity: 1;
    color: #b4c6fc;
    color: rgba(180, 198, 252, var(--placeholder-opacity));
  }
  .xl\\:placeholder-indigo-400::placeholder {
    --placeholder-opacity: 1;
    color: #8da2fb;
    color: rgba(141, 162, 251, var(--placeholder-opacity));
  }
  .xl\\:placeholder-indigo-500::placeholder {
    --placeholder-opacity: 1;
    color: #6875f5;
    color: rgba(104, 117, 245, var(--placeholder-opacity));
  }
  .xl\\:placeholder-indigo-600::placeholder {
    --placeholder-opacity: 1;
    color: #5850ec;
    color: rgba(88, 80, 236, var(--placeholder-opacity));
  }
  .xl\\:placeholder-indigo-700::placeholder {
    --placeholder-opacity: 1;
    color: #5145cd;
    color: rgba(81, 69, 205, var(--placeholder-opacity));
  }
  .xl\\:placeholder-indigo-800::placeholder {
    --placeholder-opacity: 1;
    color: #42389d;
    color: rgba(66, 56, 157, var(--placeholder-opacity));
  }
  .xl\\:placeholder-indigo-900::placeholder {
    --placeholder-opacity: 1;
    color: #362f78;
    color: rgba(54, 47, 120, var(--placeholder-opacity));
  }
  .xl\\:placeholder-purple-50::placeholder {
    --placeholder-opacity: 1;
    color: #f6f5ff;
    color: rgba(246, 245, 255, var(--placeholder-opacity));
  }
  .xl\\:placeholder-purple-100::placeholder {
    --placeholder-opacity: 1;
    color: #edebfe;
    color: rgba(237, 235, 254, var(--placeholder-opacity));
  }
  .xl\\:placeholder-purple-200::placeholder {
    --placeholder-opacity: 1;
    color: #dcd7fe;
    color: rgba(220, 215, 254, var(--placeholder-opacity));
  }
  .xl\\:placeholder-purple-300::placeholder {
    --placeholder-opacity: 1;
    color: #cabffd;
    color: rgba(202, 191, 253, var(--placeholder-opacity));
  }
  .xl\\:placeholder-purple-400::placeholder {
    --placeholder-opacity: 1;
    color: #ac94fa;
    color: rgba(172, 148, 250, var(--placeholder-opacity));
  }
  .xl\\:placeholder-purple-500::placeholder {
    --placeholder-opacity: 1;
    color: #9061f9;
    color: rgba(144, 97, 249, var(--placeholder-opacity));
  }
  .xl\\:placeholder-purple-600::placeholder {
    --placeholder-opacity: 1;
    color: #7e3af2;
    color: rgba(126, 58, 242, var(--placeholder-opacity));
  }
  .xl\\:placeholder-purple-700::placeholder {
    --placeholder-opacity: 1;
    color: #6c2bd9;
    color: rgba(108, 43, 217, var(--placeholder-opacity));
  }
  .xl\\:placeholder-purple-800::placeholder {
    --placeholder-opacity: 1;
    color: #5521b5;
    color: rgba(85, 33, 181, var(--placeholder-opacity));
  }
  .xl\\:placeholder-purple-900::placeholder {
    --placeholder-opacity: 1;
    color: #4a1d96;
    color: rgba(74, 29, 150, var(--placeholder-opacity));
  }
  .xl\\:placeholder-pink-50::placeholder {
    --placeholder-opacity: 1;
    color: #fdf2f8;
    color: rgba(253, 242, 248, var(--placeholder-opacity));
  }
  .xl\\:placeholder-pink-100::placeholder {
    --placeholder-opacity: 1;
    color: #fce8f3;
    color: rgba(252, 232, 243, var(--placeholder-opacity));
  }
  .xl\\:placeholder-pink-200::placeholder {
    --placeholder-opacity: 1;
    color: #fad1e8;
    color: rgba(250, 209, 232, var(--placeholder-opacity));
  }
  .xl\\:placeholder-pink-300::placeholder {
    --placeholder-opacity: 1;
    color: #f8b4d9;
    color: rgba(248, 180, 217, var(--placeholder-opacity));
  }
  .xl\\:placeholder-pink-400::placeholder {
    --placeholder-opacity: 1;
    color: #f17eb8;
    color: rgba(241, 126, 184, var(--placeholder-opacity));
  }
  .xl\\:placeholder-pink-500::placeholder {
    --placeholder-opacity: 1;
    color: #e74694;
    color: rgba(231, 70, 148, var(--placeholder-opacity));
  }
  .xl\\:placeholder-pink-600::placeholder {
    --placeholder-opacity: 1;
    color: #d61f69;
    color: rgba(214, 31, 105, var(--placeholder-opacity));
  }
  .xl\\:placeholder-pink-700::placeholder {
    --placeholder-opacity: 1;
    color: #bf125d;
    color: rgba(191, 18, 93, var(--placeholder-opacity));
  }
  .xl\\:placeholder-pink-800::placeholder {
    --placeholder-opacity: 1;
    color: #99154b;
    color: rgba(153, 21, 75, var(--placeholder-opacity));
  }
  .xl\\:placeholder-pink-900::placeholder {
    --placeholder-opacity: 1;
    color: #751a3d;
    color: rgba(117, 26, 61, var(--placeholder-opacity));
  }
  .xl\\:placeholder-cool-gray-50::placeholder {
    --placeholder-opacity: 1;
    color: #f8fafc;
    color: rgba(248, 250, 252, var(--placeholder-opacity));
  }
  .xl\\:placeholder-cool-gray-100::placeholder {
    --placeholder-opacity: 1;
    color: #f1f5f9;
    color: rgba(241, 245, 249, var(--placeholder-opacity));
  }
  .xl\\:placeholder-cool-gray-200::placeholder {
    --placeholder-opacity: 1;
    color: #e2e8f0;
    color: rgba(226, 232, 240, var(--placeholder-opacity));
  }
  .xl\\:placeholder-cool-gray-300::placeholder {
    --placeholder-opacity: 1;
    color: #cfd8e3;
    color: rgba(207, 216, 227, var(--placeholder-opacity));
  }
  .xl\\:placeholder-cool-gray-400::placeholder {
    --placeholder-opacity: 1;
    color: #97a6ba;
    color: rgba(151, 166, 186, var(--placeholder-opacity));
  }
  .xl\\:placeholder-cool-gray-500::placeholder {
    --placeholder-opacity: 1;
    color: #64748b;
    color: rgba(100, 116, 139, var(--placeholder-opacity));
  }
  .xl\\:placeholder-cool-gray-600::placeholder {
    --placeholder-opacity: 1;
    color: #475569;
    color: rgba(71, 85, 105, var(--placeholder-opacity));
  }
  .xl\\:placeholder-cool-gray-700::placeholder {
    --placeholder-opacity: 1;
    color: #364152;
    color: rgba(54, 65, 82, var(--placeholder-opacity));
  }
  .xl\\:placeholder-cool-gray-800::placeholder {
    --placeholder-opacity: 1;
    color: #27303f;
    color: rgba(39, 48, 63, var(--placeholder-opacity));
  }
  .xl\\:placeholder-cool-gray-900::placeholder {
    --placeholder-opacity: 1;
    color: #1a202e;
    color: rgba(26, 32, 46, var(--placeholder-opacity));
  }
  .xl\\:focus\\:placeholder-current:focus::placeholder {
    color: currentColor;
  }
  .xl\\:focus\\:placeholder-transparent:focus::placeholder {
    color: transparent;
  }
  .xl\\:focus\\:placeholder-white:focus::placeholder {
    --placeholder-opacity: 1;
    color: #ffffff;
    color: rgba(255, 255, 255, var(--placeholder-opacity));
  }
  .xl\\:focus\\:placeholder-black:focus::placeholder {
    --placeholder-opacity: 1;
    color: #000000;
    color: rgba(0, 0, 0, var(--placeholder-opacity));
  }
  .xl\\:focus\\:placeholder-gray-50:focus::placeholder {
    --placeholder-opacity: 1;
    color: #f9fafb;
    color: rgba(249, 250, 251, var(--placeholder-opacity));
  }
  .xl\\:focus\\:placeholder-gray-100:focus::placeholder {
    --placeholder-opacity: 1;
    color: #f4f5f7;
    color: rgba(244, 245, 247, var(--placeholder-opacity));
  }
  .xl\\:focus\\:placeholder-gray-200:focus::placeholder {
    --placeholder-opacity: 1;
    color: #e5e7eb;
    color: rgba(229, 231, 235, var(--placeholder-opacity));
  }
  .xl\\:focus\\:placeholder-gray-300:focus::placeholder {
    --placeholder-opacity: 1;
    color: #d2d6dc;
    color: rgba(210, 214, 220, var(--placeholder-opacity));
  }
  .xl\\:focus\\:placeholder-gray-400:focus::placeholder {
    --placeholder-opacity: 1;
    color: #9fa6b2;
    color: rgba(159, 166, 178, var(--placeholder-opacity));
  }
  .xl\\:focus\\:placeholder-gray-500:focus::placeholder {
    --placeholder-opacity: 1;
    color: #6b7280;
    color: rgba(107, 114, 128, var(--placeholder-opacity));
  }
  .xl\\:focus\\:placeholder-gray-600:focus::placeholder {
    --placeholder-opacity: 1;
    color: #4b5563;
    color: rgba(75, 85, 99, var(--placeholder-opacity));
  }
  .xl\\:focus\\:placeholder-gray-700:focus::placeholder {
    --placeholder-opacity: 1;
    color: #374151;
    color: rgba(55, 65, 81, var(--placeholder-opacity));
  }
  .xl\\:focus\\:placeholder-gray-800:focus::placeholder {
    --placeholder-opacity: 1;
    color: #252f3f;
    color: rgba(37, 47, 63, var(--placeholder-opacity));
  }
  .xl\\:focus\\:placeholder-gray-900:focus::placeholder {
    --placeholder-opacity: 1;
    color: #161e2e;
    color: rgba(22, 30, 46, var(--placeholder-opacity));
  }
  .xl\\:focus\\:placeholder-red-50:focus::placeholder {
    --placeholder-opacity: 1;
    color: #fdf2f2;
    color: rgba(253, 242, 242, var(--placeholder-opacity));
  }
  .xl\\:focus\\:placeholder-red-100:focus::placeholder {
    --placeholder-opacity: 1;
    color: #fde8e8;
    color: rgba(253, 232, 232, var(--placeholder-opacity));
  }
  .xl\\:focus\\:placeholder-red-200:focus::placeholder {
    --placeholder-opacity: 1;
    color: #fbd5d5;
    color: rgba(251, 213, 213, var(--placeholder-opacity));
  }
  .xl\\:focus\\:placeholder-red-300:focus::placeholder {
    --placeholder-opacity: 1;
    color: #f8b4b4;
    color: rgba(248, 180, 180, var(--placeholder-opacity));
  }
  .xl\\:focus\\:placeholder-red-400:focus::placeholder {
    --placeholder-opacity: 1;
    color: #f98080;
    color: rgba(249, 128, 128, var(--placeholder-opacity));
  }
  .xl\\:focus\\:placeholder-red-500:focus::placeholder {
    --placeholder-opacity: 1;
    color: #f05252;
    color: rgba(240, 82, 82, var(--placeholder-opacity));
  }
  .xl\\:focus\\:placeholder-red-600:focus::placeholder {
    --placeholder-opacity: 1;
    color: #e02424;
    color: rgba(224, 36, 36, var(--placeholder-opacity));
  }
  .xl\\:focus\\:placeholder-red-700:focus::placeholder {
    --placeholder-opacity: 1;
    color: #c81e1e;
    color: rgba(200, 30, 30, var(--placeholder-opacity));
  }
  .xl\\:focus\\:placeholder-red-800:focus::placeholder {
    --placeholder-opacity: 1;
    color: #9b1c1c;
    color: rgba(155, 28, 28, var(--placeholder-opacity));
  }
  .xl\\:focus\\:placeholder-red-900:focus::placeholder {
    --placeholder-opacity: 1;
    color: #771d1d;
    color: rgba(119, 29, 29, var(--placeholder-opacity));
  }
  .xl\\:focus\\:placeholder-orange-50:focus::placeholder {
    --placeholder-opacity: 1;
    color: #fff8f1;
    color: rgba(255, 248, 241, var(--placeholder-opacity));
  }
  .xl\\:focus\\:placeholder-orange-100:focus::placeholder {
    --placeholder-opacity: 1;
    color: #feecdc;
    color: rgba(254, 236, 220, var(--placeholder-opacity));
  }
  .xl\\:focus\\:placeholder-orange-200:focus::placeholder {
    --placeholder-opacity: 1;
    color: #fcd9bd;
    color: rgba(252, 217, 189, var(--placeholder-opacity));
  }
  .xl\\:focus\\:placeholder-orange-300:focus::placeholder {
    --placeholder-opacity: 1;
    color: #fdba8c;
    color: rgba(253, 186, 140, var(--placeholder-opacity));
  }
  .xl\\:focus\\:placeholder-orange-400:focus::placeholder {
    --placeholder-opacity: 1;
    color: #ff8a4c;
    color: rgba(255, 138, 76, var(--placeholder-opacity));
  }
  .xl\\:focus\\:placeholder-orange-500:focus::placeholder {
    --placeholder-opacity: 1;
    color: #ff5a1f;
    color: rgba(255, 90, 31, var(--placeholder-opacity));
  }
  .xl\\:focus\\:placeholder-orange-600:focus::placeholder {
    --placeholder-opacity: 1;
    color: #d03801;
    color: rgba(208, 56, 1, var(--placeholder-opacity));
  }
  .xl\\:focus\\:placeholder-orange-700:focus::placeholder {
    --placeholder-opacity: 1;
    color: #b43403;
    color: rgba(180, 52, 3, var(--placeholder-opacity));
  }
  .xl\\:focus\\:placeholder-orange-800:focus::placeholder {
    --placeholder-opacity: 1;
    color: #8a2c0d;
    color: rgba(138, 44, 13, var(--placeholder-opacity));
  }
  .xl\\:focus\\:placeholder-orange-900:focus::placeholder {
    --placeholder-opacity: 1;
    color: #73230d;
    color: rgba(115, 35, 13, var(--placeholder-opacity));
  }
  .xl\\:focus\\:placeholder-yellow-50:focus::placeholder {
    --placeholder-opacity: 1;
    color: #fdfdea;
    color: rgba(253, 253, 234, var(--placeholder-opacity));
  }
  .xl\\:focus\\:placeholder-yellow-100:focus::placeholder {
    --placeholder-opacity: 1;
    color: #fdf6b2;
    color: rgba(253, 246, 178, var(--placeholder-opacity));
  }
  .xl\\:focus\\:placeholder-yellow-200:focus::placeholder {
    --placeholder-opacity: 1;
    color: #fce96a;
    color: rgba(252, 233, 106, var(--placeholder-opacity));
  }
  .xl\\:focus\\:placeholder-yellow-300:focus::placeholder {
    --placeholder-opacity: 1;
    color: #faca15;
    color: rgba(250, 202, 21, var(--placeholder-opacity));
  }
  .xl\\:focus\\:placeholder-yellow-400:focus::placeholder {
    --placeholder-opacity: 1;
    color: #e3a008;
    color: rgba(227, 160, 8, var(--placeholder-opacity));
  }
  .xl\\:focus\\:placeholder-yellow-500:focus::placeholder {
    --placeholder-opacity: 1;
    color: #c27803;
    color: rgba(194, 120, 3, var(--placeholder-opacity));
  }
  .xl\\:focus\\:placeholder-yellow-600:focus::placeholder {
    --placeholder-opacity: 1;
    color: #9f580a;
    color: rgba(159, 88, 10, var(--placeholder-opacity));
  }
  .xl\\:focus\\:placeholder-yellow-700:focus::placeholder {
    --placeholder-opacity: 1;
    color: #8e4b10;
    color: rgba(142, 75, 16, var(--placeholder-opacity));
  }
  .xl\\:focus\\:placeholder-yellow-800:focus::placeholder {
    --placeholder-opacity: 1;
    color: #723b13;
    color: rgba(114, 59, 19, var(--placeholder-opacity));
  }
  .xl\\:focus\\:placeholder-yellow-900:focus::placeholder {
    --placeholder-opacity: 1;
    color: #633112;
    color: rgba(99, 49, 18, var(--placeholder-opacity));
  }
  .xl\\:focus\\:placeholder-green-50:focus::placeholder {
    --placeholder-opacity: 1;
    color: #f3faf7;
    color: rgba(243, 250, 247, var(--placeholder-opacity));
  }
  .xl\\:focus\\:placeholder-green-100:focus::placeholder {
    --placeholder-opacity: 1;
    color: #def7ec;
    color: rgba(222, 247, 236, var(--placeholder-opacity));
  }
  .xl\\:focus\\:placeholder-green-200:focus::placeholder {
    --placeholder-opacity: 1;
    color: #bcf0da;
    color: rgba(188, 240, 218, var(--placeholder-opacity));
  }
  .xl\\:focus\\:placeholder-green-300:focus::placeholder {
    --placeholder-opacity: 1;
    color: #84e1bc;
    color: rgba(132, 225, 188, var(--placeholder-opacity));
  }
  .xl\\:focus\\:placeholder-green-400:focus::placeholder {
    --placeholder-opacity: 1;
    color: #31c48d;
    color: rgba(49, 196, 141, var(--placeholder-opacity));
  }
  .xl\\:focus\\:placeholder-green-500:focus::placeholder {
    --placeholder-opacity: 1;
    color: #0e9f6e;
    color: rgba(14, 159, 110, var(--placeholder-opacity));
  }
  .xl\\:focus\\:placeholder-green-600:focus::placeholder {
    --placeholder-opacity: 1;
    color: #057a55;
    color: rgba(5, 122, 85, var(--placeholder-opacity));
  }
  .xl\\:focus\\:placeholder-green-700:focus::placeholder {
    --placeholder-opacity: 1;
    color: #046c4e;
    color: rgba(4, 108, 78, var(--placeholder-opacity));
  }
  .xl\\:focus\\:placeholder-green-800:focus::placeholder {
    --placeholder-opacity: 1;
    color: #03543f;
    color: rgba(3, 84, 63, var(--placeholder-opacity));
  }
  .xl\\:focus\\:placeholder-green-900:focus::placeholder {
    --placeholder-opacity: 1;
    color: #014737;
    color: rgba(1, 71, 55, var(--placeholder-opacity));
  }
  .xl\\:focus\\:placeholder-teal-50:focus::placeholder {
    --placeholder-opacity: 1;
    color: #edfafa;
    color: rgba(237, 250, 250, var(--placeholder-opacity));
  }
  .xl\\:focus\\:placeholder-teal-100:focus::placeholder {
    --placeholder-opacity: 1;
    color: #d5f5f6;
    color: rgba(213, 245, 246, var(--placeholder-opacity));
  }
  .xl\\:focus\\:placeholder-teal-200:focus::placeholder {
    --placeholder-opacity: 1;
    color: #afecef;
    color: rgba(175, 236, 239, var(--placeholder-opacity));
  }
  .xl\\:focus\\:placeholder-teal-300:focus::placeholder {
    --placeholder-opacity: 1;
    color: #7edce2;
    color: rgba(126, 220, 226, var(--placeholder-opacity));
  }
  .xl\\:focus\\:placeholder-teal-400:focus::placeholder {
    --placeholder-opacity: 1;
    color: #16bdca;
    color: rgba(22, 189, 202, var(--placeholder-opacity));
  }
  .xl\\:focus\\:placeholder-teal-500:focus::placeholder {
    --placeholder-opacity: 1;
    color: #0694a2;
    color: rgba(6, 148, 162, var(--placeholder-opacity));
  }
  .xl\\:focus\\:placeholder-teal-600:focus::placeholder {
    --placeholder-opacity: 1;
    color: #047481;
    color: rgba(4, 116, 129, var(--placeholder-opacity));
  }
  .xl\\:focus\\:placeholder-teal-700:focus::placeholder {
    --placeholder-opacity: 1;
    color: #036672;
    color: rgba(3, 102, 114, var(--placeholder-opacity));
  }
  .xl\\:focus\\:placeholder-teal-800:focus::placeholder {
    --placeholder-opacity: 1;
    color: #05505c;
    color: rgba(5, 80, 92, var(--placeholder-opacity));
  }
  .xl\\:focus\\:placeholder-teal-900:focus::placeholder {
    --placeholder-opacity: 1;
    color: #014451;
    color: rgba(1, 68, 81, var(--placeholder-opacity));
  }
  .xl\\:focus\\:placeholder-blue-50:focus::placeholder {
    --placeholder-opacity: 1;
    color: #ebf5ff;
    color: rgba(235, 245, 255, var(--placeholder-opacity));
  }
  .xl\\:focus\\:placeholder-blue-100:focus::placeholder {
    --placeholder-opacity: 1;
    color: #e1effe;
    color: rgba(225, 239, 254, var(--placeholder-opacity));
  }
  .xl\\:focus\\:placeholder-blue-200:focus::placeholder {
    --placeholder-opacity: 1;
    color: #c3ddfd;
    color: rgba(195, 221, 253, var(--placeholder-opacity));
  }
  .xl\\:focus\\:placeholder-blue-300:focus::placeholder {
    --placeholder-opacity: 1;
    color: #a4cafe;
    color: rgba(164, 202, 254, var(--placeholder-opacity));
  }
  .xl\\:focus\\:placeholder-blue-400:focus::placeholder {
    --placeholder-opacity: 1;
    color: #76a9fa;
    color: rgba(118, 169, 250, var(--placeholder-opacity));
  }
  .xl\\:focus\\:placeholder-blue-500:focus::placeholder {
    --placeholder-opacity: 1;
    color: #3f83f8;
    color: rgba(63, 131, 248, var(--placeholder-opacity));
  }
  .xl\\:focus\\:placeholder-blue-600:focus::placeholder {
    --placeholder-opacity: 1;
    color: #1c64f2;
    color: rgba(28, 100, 242, var(--placeholder-opacity));
  }
  .xl\\:focus\\:placeholder-blue-700:focus::placeholder {
    --placeholder-opacity: 1;
    color: #1a56db;
    color: rgba(26, 86, 219, var(--placeholder-opacity));
  }
  .xl\\:focus\\:placeholder-blue-800:focus::placeholder {
    --placeholder-opacity: 1;
    color: #1e429f;
    color: rgba(30, 66, 159, var(--placeholder-opacity));
  }
  .xl\\:focus\\:placeholder-blue-900:focus::placeholder {
    --placeholder-opacity: 1;
    color: #233876;
    color: rgba(35, 56, 118, var(--placeholder-opacity));
  }
  .xl\\:focus\\:placeholder-indigo-50:focus::placeholder {
    --placeholder-opacity: 1;
    color: #f0f5ff;
    color: rgba(240, 245, 255, var(--placeholder-opacity));
  }
  .xl\\:focus\\:placeholder-indigo-100:focus::placeholder {
    --placeholder-opacity: 1;
    color: #e5edff;
    color: rgba(229, 237, 255, var(--placeholder-opacity));
  }
  .xl\\:focus\\:placeholder-indigo-200:focus::placeholder {
    --placeholder-opacity: 1;
    color: #cddbfe;
    color: rgba(205, 219, 254, var(--placeholder-opacity));
  }
  .xl\\:focus\\:placeholder-indigo-300:focus::placeholder {
    --placeholder-opacity: 1;
    color: #b4c6fc;
    color: rgba(180, 198, 252, var(--placeholder-opacity));
  }
  .xl\\:focus\\:placeholder-indigo-400:focus::placeholder {
    --placeholder-opacity: 1;
    color: #8da2fb;
    color: rgba(141, 162, 251, var(--placeholder-opacity));
  }
  .xl\\:focus\\:placeholder-indigo-500:focus::placeholder {
    --placeholder-opacity: 1;
    color: #6875f5;
    color: rgba(104, 117, 245, var(--placeholder-opacity));
  }
  .xl\\:focus\\:placeholder-indigo-600:focus::placeholder {
    --placeholder-opacity: 1;
    color: #5850ec;
    color: rgba(88, 80, 236, var(--placeholder-opacity));
  }
  .xl\\:focus\\:placeholder-indigo-700:focus::placeholder {
    --placeholder-opacity: 1;
    color: #5145cd;
    color: rgba(81, 69, 205, var(--placeholder-opacity));
  }
  .xl\\:focus\\:placeholder-indigo-800:focus::placeholder {
    --placeholder-opacity: 1;
    color: #42389d;
    color: rgba(66, 56, 157, var(--placeholder-opacity));
  }
  .xl\\:focus\\:placeholder-indigo-900:focus::placeholder {
    --placeholder-opacity: 1;
    color: #362f78;
    color: rgba(54, 47, 120, var(--placeholder-opacity));
  }
  .xl\\:focus\\:placeholder-purple-50:focus::placeholder {
    --placeholder-opacity: 1;
    color: #f6f5ff;
    color: rgba(246, 245, 255, var(--placeholder-opacity));
  }
  .xl\\:focus\\:placeholder-purple-100:focus::placeholder {
    --placeholder-opacity: 1;
    color: #edebfe;
    color: rgba(237, 235, 254, var(--placeholder-opacity));
  }
  .xl\\:focus\\:placeholder-purple-200:focus::placeholder {
    --placeholder-opacity: 1;
    color: #dcd7fe;
    color: rgba(220, 215, 254, var(--placeholder-opacity));
  }
  .xl\\:focus\\:placeholder-purple-300:focus::placeholder {
    --placeholder-opacity: 1;
    color: #cabffd;
    color: rgba(202, 191, 253, var(--placeholder-opacity));
  }
  .xl\\:focus\\:placeholder-purple-400:focus::placeholder {
    --placeholder-opacity: 1;
    color: #ac94fa;
    color: rgba(172, 148, 250, var(--placeholder-opacity));
  }
  .xl\\:focus\\:placeholder-purple-500:focus::placeholder {
    --placeholder-opacity: 1;
    color: #9061f9;
    color: rgba(144, 97, 249, var(--placeholder-opacity));
  }
  .xl\\:focus\\:placeholder-purple-600:focus::placeholder {
    --placeholder-opacity: 1;
    color: #7e3af2;
    color: rgba(126, 58, 242, var(--placeholder-opacity));
  }
  .xl\\:focus\\:placeholder-purple-700:focus::placeholder {
    --placeholder-opacity: 1;
    color: #6c2bd9;
    color: rgba(108, 43, 217, var(--placeholder-opacity));
  }
  .xl\\:focus\\:placeholder-purple-800:focus::placeholder {
    --placeholder-opacity: 1;
    color: #5521b5;
    color: rgba(85, 33, 181, var(--placeholder-opacity));
  }
  .xl\\:focus\\:placeholder-purple-900:focus::placeholder {
    --placeholder-opacity: 1;
    color: #4a1d96;
    color: rgba(74, 29, 150, var(--placeholder-opacity));
  }
  .xl\\:focus\\:placeholder-pink-50:focus::placeholder {
    --placeholder-opacity: 1;
    color: #fdf2f8;
    color: rgba(253, 242, 248, var(--placeholder-opacity));
  }
  .xl\\:focus\\:placeholder-pink-100:focus::placeholder {
    --placeholder-opacity: 1;
    color: #fce8f3;
    color: rgba(252, 232, 243, var(--placeholder-opacity));
  }
  .xl\\:focus\\:placeholder-pink-200:focus::placeholder {
    --placeholder-opacity: 1;
    color: #fad1e8;
    color: rgba(250, 209, 232, var(--placeholder-opacity));
  }
  .xl\\:focus\\:placeholder-pink-300:focus::placeholder {
    --placeholder-opacity: 1;
    color: #f8b4d9;
    color: rgba(248, 180, 217, var(--placeholder-opacity));
  }
  .xl\\:focus\\:placeholder-pink-400:focus::placeholder {
    --placeholder-opacity: 1;
    color: #f17eb8;
    color: rgba(241, 126, 184, var(--placeholder-opacity));
  }
  .xl\\:focus\\:placeholder-pink-500:focus::placeholder {
    --placeholder-opacity: 1;
    color: #e74694;
    color: rgba(231, 70, 148, var(--placeholder-opacity));
  }
  .xl\\:focus\\:placeholder-pink-600:focus::placeholder {
    --placeholder-opacity: 1;
    color: #d61f69;
    color: rgba(214, 31, 105, var(--placeholder-opacity));
  }
  .xl\\:focus\\:placeholder-pink-700:focus::placeholder {
    --placeholder-opacity: 1;
    color: #bf125d;
    color: rgba(191, 18, 93, var(--placeholder-opacity));
  }
  .xl\\:focus\\:placeholder-pink-800:focus::placeholder {
    --placeholder-opacity: 1;
    color: #99154b;
    color: rgba(153, 21, 75, var(--placeholder-opacity));
  }
  .xl\\:focus\\:placeholder-pink-900:focus::placeholder {
    --placeholder-opacity: 1;
    color: #751a3d;
    color: rgba(117, 26, 61, var(--placeholder-opacity));
  }
  .xl\\:focus\\:placeholder-cool-gray-50:focus::placeholder {
    --placeholder-opacity: 1;
    color: #f8fafc;
    color: rgba(248, 250, 252, var(--placeholder-opacity));
  }
  .xl\\:focus\\:placeholder-cool-gray-100:focus::placeholder {
    --placeholder-opacity: 1;
    color: #f1f5f9;
    color: rgba(241, 245, 249, var(--placeholder-opacity));
  }
  .xl\\:focus\\:placeholder-cool-gray-200:focus::placeholder {
    --placeholder-opacity: 1;
    color: #e2e8f0;
    color: rgba(226, 232, 240, var(--placeholder-opacity));
  }
  .xl\\:focus\\:placeholder-cool-gray-300:focus::placeholder {
    --placeholder-opacity: 1;
    color: #cfd8e3;
    color: rgba(207, 216, 227, var(--placeholder-opacity));
  }
  .xl\\:focus\\:placeholder-cool-gray-400:focus::placeholder {
    --placeholder-opacity: 1;
    color: #97a6ba;
    color: rgba(151, 166, 186, var(--placeholder-opacity));
  }
  .xl\\:focus\\:placeholder-cool-gray-500:focus::placeholder {
    --placeholder-opacity: 1;
    color: #64748b;
    color: rgba(100, 116, 139, var(--placeholder-opacity));
  }
  .xl\\:focus\\:placeholder-cool-gray-600:focus::placeholder {
    --placeholder-opacity: 1;
    color: #475569;
    color: rgba(71, 85, 105, var(--placeholder-opacity));
  }
  .xl\\:focus\\:placeholder-cool-gray-700:focus::placeholder {
    --placeholder-opacity: 1;
    color: #364152;
    color: rgba(54, 65, 82, var(--placeholder-opacity));
  }
  .xl\\:focus\\:placeholder-cool-gray-800:focus::placeholder {
    --placeholder-opacity: 1;
    color: #27303f;
    color: rgba(39, 48, 63, var(--placeholder-opacity));
  }
  .xl\\:focus\\:placeholder-cool-gray-900:focus::placeholder {
    --placeholder-opacity: 1;
    color: #1a202e;
    color: rgba(26, 32, 46, var(--placeholder-opacity));
  }
  .xl\\:placeholder-opacity-0::placeholder {
    --placeholder-opacity: 0;
  }
  .xl\\:placeholder-opacity-25::placeholder {
    --placeholder-opacity: 0.25;
  }
  .xl\\:placeholder-opacity-50::placeholder {
    --placeholder-opacity: 0.5;
  }
  .xl\\:placeholder-opacity-75::placeholder {
    --placeholder-opacity: 0.75;
  }
  .xl\\:placeholder-opacity-100::placeholder {
    --placeholder-opacity: 1;
  }
  .xl\\:focus\\:placeholder-opacity-0:focus::placeholder {
    --placeholder-opacity: 0;
  }
  .xl\\:focus\\:placeholder-opacity-25:focus::placeholder {
    --placeholder-opacity: 0.25;
  }
  .xl\\:focus\\:placeholder-opacity-50:focus::placeholder {
    --placeholder-opacity: 0.5;
  }
  .xl\\:focus\\:placeholder-opacity-75:focus::placeholder {
    --placeholder-opacity: 0.75;
  }
  .xl\\:focus\\:placeholder-opacity-100:focus::placeholder {
    --placeholder-opacity: 1;
  }
  .xl\\:pointer-events-none {
    pointer-events: none;
  }
  .xl\\:pointer-events-auto {
    pointer-events: auto;
  }
  .xl\\:static {
    position: static;
  }
  .xl\\:fixed {
    position: fixed;
  }
  .xl\\:absolute {
    position: absolute;
  }
  .xl\\:relative {
    position: relative;
  }
  .xl\\:sticky {
    position: sticky;
  }
  .xl\\:inset-0 {
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
  }
  .xl\\:inset-1 {
    top: 0.25rem;
    right: 0.25rem;
    bottom: 0.25rem;
    left: 0.25rem;
  }
  .xl\\:inset-2 {
    top: 0.5rem;
    right: 0.5rem;
    bottom: 0.5rem;
    left: 0.5rem;
  }
  .xl\\:inset-3 {
    top: 0.75rem;
    right: 0.75rem;
    bottom: 0.75rem;
    left: 0.75rem;
  }
  .xl\\:inset-4 {
    top: 1rem;
    right: 1rem;
    bottom: 1rem;
    left: 1rem;
  }
  .xl\\:inset-5 {
    top: 1.25rem;
    right: 1.25rem;
    bottom: 1.25rem;
    left: 1.25rem;
  }
  .xl\\:inset-6 {
    top: 1.5rem;
    right: 1.5rem;
    bottom: 1.5rem;
    left: 1.5rem;
  }
  .xl\\:inset-7 {
    top: 1.75rem;
    right: 1.75rem;
    bottom: 1.75rem;
    left: 1.75rem;
  }
  .xl\\:inset-8 {
    top: 2rem;
    right: 2rem;
    bottom: 2rem;
    left: 2rem;
  }
  .xl\\:inset-9 {
    top: 2.25rem;
    right: 2.25rem;
    bottom: 2.25rem;
    left: 2.25rem;
  }
  .xl\\:inset-10 {
    top: 2.5rem;
    right: 2.5rem;
    bottom: 2.5rem;
    left: 2.5rem;
  }
  .xl\\:inset-11 {
    top: 2.75rem;
    right: 2.75rem;
    bottom: 2.75rem;
    left: 2.75rem;
  }
  .xl\\:inset-12 {
    top: 3rem;
    right: 3rem;
    bottom: 3rem;
    left: 3rem;
  }
  .xl\\:inset-13 {
    top: 3.25rem;
    right: 3.25rem;
    bottom: 3.25rem;
    left: 3.25rem;
  }
  .xl\\:inset-14 {
    top: 3.5rem;
    right: 3.5rem;
    bottom: 3.5rem;
    left: 3.5rem;
  }
  .xl\\:inset-15 {
    top: 3.75rem;
    right: 3.75rem;
    bottom: 3.75rem;
    left: 3.75rem;
  }
  .xl\\:inset-16 {
    top: 4rem;
    right: 4rem;
    bottom: 4rem;
    left: 4rem;
  }
  .xl\\:inset-20 {
    top: 5rem;
    right: 5rem;
    bottom: 5rem;
    left: 5rem;
  }
  .xl\\:inset-24 {
    top: 6rem;
    right: 6rem;
    bottom: 6rem;
    left: 6rem;
  }
  .xl\\:inset-28 {
    top: 7rem;
    right: 7rem;
    bottom: 7rem;
    left: 7rem;
  }
  .xl\\:inset-32 {
    top: 8rem;
    right: 8rem;
    bottom: 8rem;
    left: 8rem;
  }
  .xl\\:inset-36 {
    top: 9rem;
    right: 9rem;
    bottom: 9rem;
    left: 9rem;
  }
  .xl\\:inset-40 {
    top: 10rem;
    right: 10rem;
    bottom: 10rem;
    left: 10rem;
  }
  .xl\\:inset-44 {
    top: 11rem;
    right: 11rem;
    bottom: 11rem;
    left: 11rem;
  }
  .xl\\:inset-48 {
    top: 12rem;
    right: 12rem;
    bottom: 12rem;
    left: 12rem;
  }
  .xl\\:inset-52 {
    top: 13rem;
    right: 13rem;
    bottom: 13rem;
    left: 13rem;
  }
  .xl\\:inset-56 {
    top: 14rem;
    right: 14rem;
    bottom: 14rem;
    left: 14rem;
  }
  .xl\\:inset-60 {
    top: 15rem;
    right: 15rem;
    bottom: 15rem;
    left: 15rem;
  }
  .xl\\:inset-64 {
    top: 16rem;
    right: 16rem;
    bottom: 16rem;
    left: 16rem;
  }
  .xl\\:inset-72 {
    top: 18rem;
    right: 18rem;
    bottom: 18rem;
    left: 18rem;
  }
  .xl\\:inset-80 {
    top: 20rem;
    right: 20rem;
    bottom: 20rem;
    left: 20rem;
  }
  .xl\\:inset-96 {
    top: 24rem;
    right: 24rem;
    bottom: 24rem;
    left: 24rem;
  }
  .xl\\:inset-auto {
    top: auto;
    right: auto;
    bottom: auto;
    left: auto;
  }
  .xl\\:inset-px {
    top: 1px;
    right: 1px;
    bottom: 1px;
    left: 1px;
  }
  .xl\\:inset-0\\.5 {
    top: 0.125rem;
    right: 0.125rem;
    bottom: 0.125rem;
    left: 0.125rem;
  }
  .xl\\:inset-1\\.5 {
    top: 0.375rem;
    right: 0.375rem;
    bottom: 0.375rem;
    left: 0.375rem;
  }
  .xl\\:inset-2\\.5 {
    top: 0.625rem;
    right: 0.625rem;
    bottom: 0.625rem;
    left: 0.625rem;
  }
  .xl\\:inset-3\\.5 {
    top: 0.875rem;
    right: 0.875rem;
    bottom: 0.875rem;
    left: 0.875rem;
  }
  .xl\\:inset-1\\/2 {
    top: 50%;
    right: 50%;
    bottom: 50%;
    left: 50%;
  }
  .xl\\:inset-1\\/3 {
    top: 33.333333%;
    right: 33.333333%;
    bottom: 33.333333%;
    left: 33.333333%;
  }
  .xl\\:inset-2\\/3 {
    top: 66.666667%;
    right: 66.666667%;
    bottom: 66.666667%;
    left: 66.666667%;
  }
  .xl\\:inset-1\\/4 {
    top: 25%;
    right: 25%;
    bottom: 25%;
    left: 25%;
  }
  .xl\\:inset-2\\/4 {
    top: 50%;
    right: 50%;
    bottom: 50%;
    left: 50%;
  }
  .xl\\:inset-3\\/4 {
    top: 75%;
    right: 75%;
    bottom: 75%;
    left: 75%;
  }
  .xl\\:inset-1\\/5 {
    top: 20%;
    right: 20%;
    bottom: 20%;
    left: 20%;
  }
  .xl\\:inset-2\\/5 {
    top: 40%;
    right: 40%;
    bottom: 40%;
    left: 40%;
  }
  .xl\\:inset-3\\/5 {
    top: 60%;
    right: 60%;
    bottom: 60%;
    left: 60%;
  }
  .xl\\:inset-4\\/5 {
    top: 80%;
    right: 80%;
    bottom: 80%;
    left: 80%;
  }
  .xl\\:inset-1\\/6 {
    top: 16.666667%;
    right: 16.666667%;
    bottom: 16.666667%;
    left: 16.666667%;
  }
  .xl\\:inset-2\\/6 {
    top: 33.333333%;
    right: 33.333333%;
    bottom: 33.333333%;
    left: 33.333333%;
  }
  .xl\\:inset-3\\/6 {
    top: 50%;
    right: 50%;
    bottom: 50%;
    left: 50%;
  }
  .xl\\:inset-4\\/6 {
    top: 66.666667%;
    right: 66.666667%;
    bottom: 66.666667%;
    left: 66.666667%;
  }
  .xl\\:inset-5\\/6 {
    top: 83.333333%;
    right: 83.333333%;
    bottom: 83.333333%;
    left: 83.333333%;
  }
  .xl\\:inset-1\\/12 {
    top: 8.333333%;
    right: 8.333333%;
    bottom: 8.333333%;
    left: 8.333333%;
  }
  .xl\\:inset-2\\/12 {
    top: 16.666667%;
    right: 16.666667%;
    bottom: 16.666667%;
    left: 16.666667%;
  }
  .xl\\:inset-3\\/12 {
    top: 25%;
    right: 25%;
    bottom: 25%;
    left: 25%;
  }
  .xl\\:inset-4\\/12 {
    top: 33.333333%;
    right: 33.333333%;
    bottom: 33.333333%;
    left: 33.333333%;
  }
  .xl\\:inset-5\\/12 {
    top: 41.666667%;
    right: 41.666667%;
    bottom: 41.666667%;
    left: 41.666667%;
  }
  .xl\\:inset-6\\/12 {
    top: 50%;
    right: 50%;
    bottom: 50%;
    left: 50%;
  }
  .xl\\:inset-7\\/12 {
    top: 58.333333%;
    right: 58.333333%;
    bottom: 58.333333%;
    left: 58.333333%;
  }
  .xl\\:inset-8\\/12 {
    top: 66.666667%;
    right: 66.666667%;
    bottom: 66.666667%;
    left: 66.666667%;
  }
  .xl\\:inset-9\\/12 {
    top: 75%;
    right: 75%;
    bottom: 75%;
    left: 75%;
  }
  .xl\\:inset-10\\/12 {
    top: 83.333333%;
    right: 83.333333%;
    bottom: 83.333333%;
    left: 83.333333%;
  }
  .xl\\:inset-11\\/12 {
    top: 91.666667%;
    right: 91.666667%;
    bottom: 91.666667%;
    left: 91.666667%;
  }
  .xl\\:inset-full {
    top: 100%;
    right: 100%;
    bottom: 100%;
    left: 100%;
  }
  .xl\\:inset-y-0 {
    top: 0;
    bottom: 0;
  }
  .xl\\:inset-x-0 {
    right: 0;
    left: 0;
  }
  .xl\\:inset-y-1 {
    top: 0.25rem;
    bottom: 0.25rem;
  }
  .xl\\:inset-x-1 {
    right: 0.25rem;
    left: 0.25rem;
  }
  .xl\\:inset-y-2 {
    top: 0.5rem;
    bottom: 0.5rem;
  }
  .xl\\:inset-x-2 {
    right: 0.5rem;
    left: 0.5rem;
  }
  .xl\\:inset-y-3 {
    top: 0.75rem;
    bottom: 0.75rem;
  }
  .xl\\:inset-x-3 {
    right: 0.75rem;
    left: 0.75rem;
  }
  .xl\\:inset-y-4 {
    top: 1rem;
    bottom: 1rem;
  }
  .xl\\:inset-x-4 {
    right: 1rem;
    left: 1rem;
  }
  .xl\\:inset-y-5 {
    top: 1.25rem;
    bottom: 1.25rem;
  }
  .xl\\:inset-x-5 {
    right: 1.25rem;
    left: 1.25rem;
  }
  .xl\\:inset-y-6 {
    top: 1.5rem;
    bottom: 1.5rem;
  }
  .xl\\:inset-x-6 {
    right: 1.5rem;
    left: 1.5rem;
  }
  .xl\\:inset-y-7 {
    top: 1.75rem;
    bottom: 1.75rem;
  }
  .xl\\:inset-x-7 {
    right: 1.75rem;
    left: 1.75rem;
  }
  .xl\\:inset-y-8 {
    top: 2rem;
    bottom: 2rem;
  }
  .xl\\:inset-x-8 {
    right: 2rem;
    left: 2rem;
  }
  .xl\\:inset-y-9 {
    top: 2.25rem;
    bottom: 2.25rem;
  }
  .xl\\:inset-x-9 {
    right: 2.25rem;
    left: 2.25rem;
  }
  .xl\\:inset-y-10 {
    top: 2.5rem;
    bottom: 2.5rem;
  }
  .xl\\:inset-x-10 {
    right: 2.5rem;
    left: 2.5rem;
  }
  .xl\\:inset-y-11 {
    top: 2.75rem;
    bottom: 2.75rem;
  }
  .xl\\:inset-x-11 {
    right: 2.75rem;
    left: 2.75rem;
  }
  .xl\\:inset-y-12 {
    top: 3rem;
    bottom: 3rem;
  }
  .xl\\:inset-x-12 {
    right: 3rem;
    left: 3rem;
  }
  .xl\\:inset-y-13 {
    top: 3.25rem;
    bottom: 3.25rem;
  }
  .xl\\:inset-x-13 {
    right: 3.25rem;
    left: 3.25rem;
  }
  .xl\\:inset-y-14 {
    top: 3.5rem;
    bottom: 3.5rem;
  }
  .xl\\:inset-x-14 {
    right: 3.5rem;
    left: 3.5rem;
  }
  .xl\\:inset-y-15 {
    top: 3.75rem;
    bottom: 3.75rem;
  }
  .xl\\:inset-x-15 {
    right: 3.75rem;
    left: 3.75rem;
  }
  .xl\\:inset-y-16 {
    top: 4rem;
    bottom: 4rem;
  }
  .xl\\:inset-x-16 {
    right: 4rem;
    left: 4rem;
  }
  .xl\\:inset-y-20 {
    top: 5rem;
    bottom: 5rem;
  }
  .xl\\:inset-x-20 {
    right: 5rem;
    left: 5rem;
  }
  .xl\\:inset-y-24 {
    top: 6rem;
    bottom: 6rem;
  }
  .xl\\:inset-x-24 {
    right: 6rem;
    left: 6rem;
  }
  .xl\\:inset-y-28 {
    top: 7rem;
    bottom: 7rem;
  }
  .xl\\:inset-x-28 {
    right: 7rem;
    left: 7rem;
  }
  .xl\\:inset-y-32 {
    top: 8rem;
    bottom: 8rem;
  }
  .xl\\:inset-x-32 {
    right: 8rem;
    left: 8rem;
  }
  .xl\\:inset-y-36 {
    top: 9rem;
    bottom: 9rem;
  }
  .xl\\:inset-x-36 {
    right: 9rem;
    left: 9rem;
  }
  .xl\\:inset-y-40 {
    top: 10rem;
    bottom: 10rem;
  }
  .xl\\:inset-x-40 {
    right: 10rem;
    left: 10rem;
  }
  .xl\\:inset-y-44 {
    top: 11rem;
    bottom: 11rem;
  }
  .xl\\:inset-x-44 {
    right: 11rem;
    left: 11rem;
  }
  .xl\\:inset-y-48 {
    top: 12rem;
    bottom: 12rem;
  }
  .xl\\:inset-x-48 {
    right: 12rem;
    left: 12rem;
  }
  .xl\\:inset-y-52 {
    top: 13rem;
    bottom: 13rem;
  }
  .xl\\:inset-x-52 {
    right: 13rem;
    left: 13rem;
  }
  .xl\\:inset-y-56 {
    top: 14rem;
    bottom: 14rem;
  }
  .xl\\:inset-x-56 {
    right: 14rem;
    left: 14rem;
  }
  .xl\\:inset-y-60 {
    top: 15rem;
    bottom: 15rem;
  }
  .xl\\:inset-x-60 {
    right: 15rem;
    left: 15rem;
  }
  .xl\\:inset-y-64 {
    top: 16rem;
    bottom: 16rem;
  }
  .xl\\:inset-x-64 {
    right: 16rem;
    left: 16rem;
  }
  .xl\\:inset-y-72 {
    top: 18rem;
    bottom: 18rem;
  }
  .xl\\:inset-x-72 {
    right: 18rem;
    left: 18rem;
  }
  .xl\\:inset-y-80 {
    top: 20rem;
    bottom: 20rem;
  }
  .xl\\:inset-x-80 {
    right: 20rem;
    left: 20rem;
  }
  .xl\\:inset-y-96 {
    top: 24rem;
    bottom: 24rem;
  }
  .xl\\:inset-x-96 {
    right: 24rem;
    left: 24rem;
  }
  .xl\\:inset-y-auto {
    top: auto;
    bottom: auto;
  }
  .xl\\:inset-x-auto {
    right: auto;
    left: auto;
  }
  .xl\\:inset-y-px {
    top: 1px;
    bottom: 1px;
  }
  .xl\\:inset-x-px {
    right: 1px;
    left: 1px;
  }
  .xl\\:inset-y-0\\.5 {
    top: 0.125rem;
    bottom: 0.125rem;
  }
  .xl\\:inset-x-0\\.5 {
    right: 0.125rem;
    left: 0.125rem;
  }
  .xl\\:inset-y-1\\.5 {
    top: 0.375rem;
    bottom: 0.375rem;
  }
  .xl\\:inset-x-1\\.5 {
    right: 0.375rem;
    left: 0.375rem;
  }
  .xl\\:inset-y-2\\.5 {
    top: 0.625rem;
    bottom: 0.625rem;
  }
  .xl\\:inset-x-2\\.5 {
    right: 0.625rem;
    left: 0.625rem;
  }
  .xl\\:inset-y-3\\.5 {
    top: 0.875rem;
    bottom: 0.875rem;
  }
  .xl\\:inset-x-3\\.5 {
    right: 0.875rem;
    left: 0.875rem;
  }
  .xl\\:inset-y-1\\/2 {
    top: 50%;
    bottom: 50%;
  }
  .xl\\:inset-x-1\\/2 {
    right: 50%;
    left: 50%;
  }
  .xl\\:inset-y-1\\/3 {
    top: 33.333333%;
    bottom: 33.333333%;
  }
  .xl\\:inset-x-1\\/3 {
    right: 33.333333%;
    left: 33.333333%;
  }
  .xl\\:inset-y-2\\/3 {
    top: 66.666667%;
    bottom: 66.666667%;
  }
  .xl\\:inset-x-2\\/3 {
    right: 66.666667%;
    left: 66.666667%;
  }
  .xl\\:inset-y-1\\/4 {
    top: 25%;
    bottom: 25%;
  }
  .xl\\:inset-x-1\\/4 {
    right: 25%;
    left: 25%;
  }
  .xl\\:inset-y-2\\/4 {
    top: 50%;
    bottom: 50%;
  }
  .xl\\:inset-x-2\\/4 {
    right: 50%;
    left: 50%;
  }
  .xl\\:inset-y-3\\/4 {
    top: 75%;
    bottom: 75%;
  }
  .xl\\:inset-x-3\\/4 {
    right: 75%;
    left: 75%;
  }
  .xl\\:inset-y-1\\/5 {
    top: 20%;
    bottom: 20%;
  }
  .xl\\:inset-x-1\\/5 {
    right: 20%;
    left: 20%;
  }
  .xl\\:inset-y-2\\/5 {
    top: 40%;
    bottom: 40%;
  }
  .xl\\:inset-x-2\\/5 {
    right: 40%;
    left: 40%;
  }
  .xl\\:inset-y-3\\/5 {
    top: 60%;
    bottom: 60%;
  }
  .xl\\:inset-x-3\\/5 {
    right: 60%;
    left: 60%;
  }
  .xl\\:inset-y-4\\/5 {
    top: 80%;
    bottom: 80%;
  }
  .xl\\:inset-x-4\\/5 {
    right: 80%;
    left: 80%;
  }
  .xl\\:inset-y-1\\/6 {
    top: 16.666667%;
    bottom: 16.666667%;
  }
  .xl\\:inset-x-1\\/6 {
    right: 16.666667%;
    left: 16.666667%;
  }
  .xl\\:inset-y-2\\/6 {
    top: 33.333333%;
    bottom: 33.333333%;
  }
  .xl\\:inset-x-2\\/6 {
    right: 33.333333%;
    left: 33.333333%;
  }
  .xl\\:inset-y-3\\/6 {
    top: 50%;
    bottom: 50%;
  }
  .xl\\:inset-x-3\\/6 {
    right: 50%;
    left: 50%;
  }
  .xl\\:inset-y-4\\/6 {
    top: 66.666667%;
    bottom: 66.666667%;
  }
  .xl\\:inset-x-4\\/6 {
    right: 66.666667%;
    left: 66.666667%;
  }
  .xl\\:inset-y-5\\/6 {
    top: 83.333333%;
    bottom: 83.333333%;
  }
  .xl\\:inset-x-5\\/6 {
    right: 83.333333%;
    left: 83.333333%;
  }
  .xl\\:inset-y-1\\/12 {
    top: 8.333333%;
    bottom: 8.333333%;
  }
  .xl\\:inset-x-1\\/12 {
    right: 8.333333%;
    left: 8.333333%;
  }
  .xl\\:inset-y-2\\/12 {
    top: 16.666667%;
    bottom: 16.666667%;
  }
  .xl\\:inset-x-2\\/12 {
    right: 16.666667%;
    left: 16.666667%;
  }
  .xl\\:inset-y-3\\/12 {
    top: 25%;
    bottom: 25%;
  }
  .xl\\:inset-x-3\\/12 {
    right: 25%;
    left: 25%;
  }
  .xl\\:inset-y-4\\/12 {
    top: 33.333333%;
    bottom: 33.333333%;
  }
  .xl\\:inset-x-4\\/12 {
    right: 33.333333%;
    left: 33.333333%;
  }
  .xl\\:inset-y-5\\/12 {
    top: 41.666667%;
    bottom: 41.666667%;
  }
  .xl\\:inset-x-5\\/12 {
    right: 41.666667%;
    left: 41.666667%;
  }
  .xl\\:inset-y-6\\/12 {
    top: 50%;
    bottom: 50%;
  }
  .xl\\:inset-x-6\\/12 {
    right: 50%;
    left: 50%;
  }
  .xl\\:inset-y-7\\/12 {
    top: 58.333333%;
    bottom: 58.333333%;
  }
  .xl\\:inset-x-7\\/12 {
    right: 58.333333%;
    left: 58.333333%;
  }
  .xl\\:inset-y-8\\/12 {
    top: 66.666667%;
    bottom: 66.666667%;
  }
  .xl\\:inset-x-8\\/12 {
    right: 66.666667%;
    left: 66.666667%;
  }
  .xl\\:inset-y-9\\/12 {
    top: 75%;
    bottom: 75%;
  }
  .xl\\:inset-x-9\\/12 {
    right: 75%;
    left: 75%;
  }
  .xl\\:inset-y-10\\/12 {
    top: 83.333333%;
    bottom: 83.333333%;
  }
  .xl\\:inset-x-10\\/12 {
    right: 83.333333%;
    left: 83.333333%;
  }
  .xl\\:inset-y-11\\/12 {
    top: 91.666667%;
    bottom: 91.666667%;
  }
  .xl\\:inset-x-11\\/12 {
    right: 91.666667%;
    left: 91.666667%;
  }
  .xl\\:inset-y-full {
    top: 100%;
    bottom: 100%;
  }
  .xl\\:inset-x-full {
    right: 100%;
    left: 100%;
  }
  .xl\\:top-0 {
    top: 0;
  }
  .xl\\:right-0 {
    right: 0;
  }
  .xl\\:bottom-0 {
    bottom: 0;
  }
  .xl\\:left-0 {
    left: 0;
  }
  .xl\\:top-1 {
    top: 0.25rem;
  }
  .xl\\:right-1 {
    right: 0.25rem;
  }
  .xl\\:bottom-1 {
    bottom: 0.25rem;
  }
  .xl\\:left-1 {
    left: 0.25rem;
  }
  .xl\\:top-2 {
    top: 0.5rem;
  }
  .xl\\:right-2 {
    right: 0.5rem;
  }
  .xl\\:bottom-2 {
    bottom: 0.5rem;
  }
  .xl\\:left-2 {
    left: 0.5rem;
  }
  .xl\\:top-3 {
    top: 0.75rem;
  }
  .xl\\:right-3 {
    right: 0.75rem;
  }
  .xl\\:bottom-3 {
    bottom: 0.75rem;
  }
  .xl\\:left-3 {
    left: 0.75rem;
  }
  .xl\\:top-4 {
    top: 1rem;
  }
  .xl\\:right-4 {
    right: 1rem;
  }
  .xl\\:bottom-4 {
    bottom: 1rem;
  }
  .xl\\:left-4 {
    left: 1rem;
  }
  .xl\\:top-5 {
    top: 1.25rem;
  }
  .xl\\:right-5 {
    right: 1.25rem;
  }
  .xl\\:bottom-5 {
    bottom: 1.25rem;
  }
  .xl\\:left-5 {
    left: 1.25rem;
  }
  .xl\\:top-6 {
    top: 1.5rem;
  }
  .xl\\:right-6 {
    right: 1.5rem;
  }
  .xl\\:bottom-6 {
    bottom: 1.5rem;
  }
  .xl\\:left-6 {
    left: 1.5rem;
  }
  .xl\\:top-7 {
    top: 1.75rem;
  }
  .xl\\:right-7 {
    right: 1.75rem;
  }
  .xl\\:bottom-7 {
    bottom: 1.75rem;
  }
  .xl\\:left-7 {
    left: 1.75rem;
  }
  .xl\\:top-8 {
    top: 2rem;
  }
  .xl\\:right-8 {
    right: 2rem;
  }
  .xl\\:bottom-8 {
    bottom: 2rem;
  }
  .xl\\:left-8 {
    left: 2rem;
  }
  .xl\\:top-9 {
    top: 2.25rem;
  }
  .xl\\:right-9 {
    right: 2.25rem;
  }
  .xl\\:bottom-9 {
    bottom: 2.25rem;
  }
  .xl\\:left-9 {
    left: 2.25rem;
  }
  .xl\\:top-10 {
    top: 2.5rem;
  }
  .xl\\:right-10 {
    right: 2.5rem;
  }
  .xl\\:bottom-10 {
    bottom: 2.5rem;
  }
  .xl\\:left-10 {
    left: 2.5rem;
  }
  .xl\\:top-11 {
    top: 2.75rem;
  }
  .xl\\:right-11 {
    right: 2.75rem;
  }
  .xl\\:bottom-11 {
    bottom: 2.75rem;
  }
  .xl\\:left-11 {
    left: 2.75rem;
  }
  .xl\\:top-12 {
    top: 3rem;
  }
  .xl\\:right-12 {
    right: 3rem;
  }
  .xl\\:bottom-12 {
    bottom: 3rem;
  }
  .xl\\:left-12 {
    left: 3rem;
  }
  .xl\\:top-13 {
    top: 3.25rem;
  }
  .xl\\:right-13 {
    right: 3.25rem;
  }
  .xl\\:bottom-13 {
    bottom: 3.25rem;
  }
  .xl\\:left-13 {
    left: 3.25rem;
  }
  .xl\\:top-14 {
    top: 3.5rem;
  }
  .xl\\:right-14 {
    right: 3.5rem;
  }
  .xl\\:bottom-14 {
    bottom: 3.5rem;
  }
  .xl\\:left-14 {
    left: 3.5rem;
  }
  .xl\\:top-15 {
    top: 3.75rem;
  }
  .xl\\:right-15 {
    right: 3.75rem;
  }
  .xl\\:bottom-15 {
    bottom: 3.75rem;
  }
  .xl\\:left-15 {
    left: 3.75rem;
  }
  .xl\\:top-16 {
    top: 4rem;
  }
  .xl\\:right-16 {
    right: 4rem;
  }
  .xl\\:bottom-16 {
    bottom: 4rem;
  }
  .xl\\:left-16 {
    left: 4rem;
  }
  .xl\\:top-20 {
    top: 5rem;
  }
  .xl\\:right-20 {
    right: 5rem;
  }
  .xl\\:bottom-20 {
    bottom: 5rem;
  }
  .xl\\:left-20 {
    left: 5rem;
  }
  .xl\\:top-24 {
    top: 6rem;
  }
  .xl\\:right-24 {
    right: 6rem;
  }
  .xl\\:bottom-24 {
    bottom: 6rem;
  }
  .xl\\:left-24 {
    left: 6rem;
  }
  .xl\\:top-28 {
    top: 7rem;
  }
  .xl\\:right-28 {
    right: 7rem;
  }
  .xl\\:bottom-28 {
    bottom: 7rem;
  }
  .xl\\:left-28 {
    left: 7rem;
  }
  .xl\\:top-32 {
    top: 8rem;
  }
  .xl\\:right-32 {
    right: 8rem;
  }
  .xl\\:bottom-32 {
    bottom: 8rem;
  }
  .xl\\:left-32 {
    left: 8rem;
  }
  .xl\\:top-36 {
    top: 9rem;
  }
  .xl\\:right-36 {
    right: 9rem;
  }
  .xl\\:bottom-36 {
    bottom: 9rem;
  }
  .xl\\:left-36 {
    left: 9rem;
  }
  .xl\\:top-40 {
    top: 10rem;
  }
  .xl\\:right-40 {
    right: 10rem;
  }
  .xl\\:bottom-40 {
    bottom: 10rem;
  }
  .xl\\:left-40 {
    left: 10rem;
  }
  .xl\\:top-44 {
    top: 11rem;
  }
  .xl\\:right-44 {
    right: 11rem;
  }
  .xl\\:bottom-44 {
    bottom: 11rem;
  }
  .xl\\:left-44 {
    left: 11rem;
  }
  .xl\\:top-48 {
    top: 12rem;
  }
  .xl\\:right-48 {
    right: 12rem;
  }
  .xl\\:bottom-48 {
    bottom: 12rem;
  }
  .xl\\:left-48 {
    left: 12rem;
  }
  .xl\\:top-52 {
    top: 13rem;
  }
  .xl\\:right-52 {
    right: 13rem;
  }
  .xl\\:bottom-52 {
    bottom: 13rem;
  }
  .xl\\:left-52 {
    left: 13rem;
  }
  .xl\\:top-56 {
    top: 14rem;
  }
  .xl\\:right-56 {
    right: 14rem;
  }
  .xl\\:bottom-56 {
    bottom: 14rem;
  }
  .xl\\:left-56 {
    left: 14rem;
  }
  .xl\\:top-60 {
    top: 15rem;
  }
  .xl\\:right-60 {
    right: 15rem;
  }
  .xl\\:bottom-60 {
    bottom: 15rem;
  }
  .xl\\:left-60 {
    left: 15rem;
  }
  .xl\\:top-64 {
    top: 16rem;
  }
  .xl\\:right-64 {
    right: 16rem;
  }
  .xl\\:bottom-64 {
    bottom: 16rem;
  }
  .xl\\:left-64 {
    left: 16rem;
  }
  .xl\\:top-72 {
    top: 18rem;
  }
  .xl\\:right-72 {
    right: 18rem;
  }
  .xl\\:bottom-72 {
    bottom: 18rem;
  }
  .xl\\:left-72 {
    left: 18rem;
  }
  .xl\\:top-80 {
    top: 20rem;
  }
  .xl\\:right-80 {
    right: 20rem;
  }
  .xl\\:bottom-80 {
    bottom: 20rem;
  }
  .xl\\:left-80 {
    left: 20rem;
  }
  .xl\\:top-96 {
    top: 24rem;
  }
  .xl\\:right-96 {
    right: 24rem;
  }
  .xl\\:bottom-96 {
    bottom: 24rem;
  }
  .xl\\:left-96 {
    left: 24rem;
  }
  .xl\\:top-auto {
    top: auto;
  }
  .xl\\:right-auto {
    right: auto;
  }
  .xl\\:bottom-auto {
    bottom: auto;
  }
  .xl\\:left-auto {
    left: auto;
  }
  .xl\\:top-px {
    top: 1px;
  }
  .xl\\:right-px {
    right: 1px;
  }
  .xl\\:bottom-px {
    bottom: 1px;
  }
  .xl\\:left-px {
    left: 1px;
  }
  .xl\\:top-0\\.5 {
    top: 0.125rem;
  }
  .xl\\:right-0\\.5 {
    right: 0.125rem;
  }
  .xl\\:bottom-0\\.5 {
    bottom: 0.125rem;
  }
  .xl\\:left-0\\.5 {
    left: 0.125rem;
  }
  .xl\\:top-1\\.5 {
    top: 0.375rem;
  }
  .xl\\:right-1\\.5 {
    right: 0.375rem;
  }
  .xl\\:bottom-1\\.5 {
    bottom: 0.375rem;
  }
  .xl\\:left-1\\.5 {
    left: 0.375rem;
  }
  .xl\\:top-2\\.5 {
    top: 0.625rem;
  }
  .xl\\:right-2\\.5 {
    right: 0.625rem;
  }
  .xl\\:bottom-2\\.5 {
    bottom: 0.625rem;
  }
  .xl\\:left-2\\.5 {
    left: 0.625rem;
  }
  .xl\\:top-3\\.5 {
    top: 0.875rem;
  }
  .xl\\:right-3\\.5 {
    right: 0.875rem;
  }
  .xl\\:bottom-3\\.5 {
    bottom: 0.875rem;
  }
  .xl\\:left-3\\.5 {
    left: 0.875rem;
  }
  .xl\\:top-1\\/2 {
    top: 50%;
  }
  .xl\\:right-1\\/2 {
    right: 50%;
  }
  .xl\\:bottom-1\\/2 {
    bottom: 50%;
  }
  .xl\\:left-1\\/2 {
    left: 50%;
  }
  .xl\\:top-1\\/3 {
    top: 33.333333%;
  }
  .xl\\:right-1\\/3 {
    right: 33.333333%;
  }
  .xl\\:bottom-1\\/3 {
    bottom: 33.333333%;
  }
  .xl\\:left-1\\/3 {
    left: 33.333333%;
  }
  .xl\\:top-2\\/3 {
    top: 66.666667%;
  }
  .xl\\:right-2\\/3 {
    right: 66.666667%;
  }
  .xl\\:bottom-2\\/3 {
    bottom: 66.666667%;
  }
  .xl\\:left-2\\/3 {
    left: 66.666667%;
  }
  .xl\\:top-1\\/4 {
    top: 25%;
  }
  .xl\\:right-1\\/4 {
    right: 25%;
  }
  .xl\\:bottom-1\\/4 {
    bottom: 25%;
  }
  .xl\\:left-1\\/4 {
    left: 25%;
  }
  .xl\\:top-2\\/4 {
    top: 50%;
  }
  .xl\\:right-2\\/4 {
    right: 50%;
  }
  .xl\\:bottom-2\\/4 {
    bottom: 50%;
  }
  .xl\\:left-2\\/4 {
    left: 50%;
  }
  .xl\\:top-3\\/4 {
    top: 75%;
  }
  .xl\\:right-3\\/4 {
    right: 75%;
  }
  .xl\\:bottom-3\\/4 {
    bottom: 75%;
  }
  .xl\\:left-3\\/4 {
    left: 75%;
  }
  .xl\\:top-1\\/5 {
    top: 20%;
  }
  .xl\\:right-1\\/5 {
    right: 20%;
  }
  .xl\\:bottom-1\\/5 {
    bottom: 20%;
  }
  .xl\\:left-1\\/5 {
    left: 20%;
  }
  .xl\\:top-2\\/5 {
    top: 40%;
  }
  .xl\\:right-2\\/5 {
    right: 40%;
  }
  .xl\\:bottom-2\\/5 {
    bottom: 40%;
  }
  .xl\\:left-2\\/5 {
    left: 40%;
  }
  .xl\\:top-3\\/5 {
    top: 60%;
  }
  .xl\\:right-3\\/5 {
    right: 60%;
  }
  .xl\\:bottom-3\\/5 {
    bottom: 60%;
  }
  .xl\\:left-3\\/5 {
    left: 60%;
  }
  .xl\\:top-4\\/5 {
    top: 80%;
  }
  .xl\\:right-4\\/5 {
    right: 80%;
  }
  .xl\\:bottom-4\\/5 {
    bottom: 80%;
  }
  .xl\\:left-4\\/5 {
    left: 80%;
  }
  .xl\\:top-1\\/6 {
    top: 16.666667%;
  }
  .xl\\:right-1\\/6 {
    right: 16.666667%;
  }
  .xl\\:bottom-1\\/6 {
    bottom: 16.666667%;
  }
  .xl\\:left-1\\/6 {
    left: 16.666667%;
  }
  .xl\\:top-2\\/6 {
    top: 33.333333%;
  }
  .xl\\:right-2\\/6 {
    right: 33.333333%;
  }
  .xl\\:bottom-2\\/6 {
    bottom: 33.333333%;
  }
  .xl\\:left-2\\/6 {
    left: 33.333333%;
  }
  .xl\\:top-3\\/6 {
    top: 50%;
  }
  .xl\\:right-3\\/6 {
    right: 50%;
  }
  .xl\\:bottom-3\\/6 {
    bottom: 50%;
  }
  .xl\\:left-3\\/6 {
    left: 50%;
  }
  .xl\\:top-4\\/6 {
    top: 66.666667%;
  }
  .xl\\:right-4\\/6 {
    right: 66.666667%;
  }
  .xl\\:bottom-4\\/6 {
    bottom: 66.666667%;
  }
  .xl\\:left-4\\/6 {
    left: 66.666667%;
  }
  .xl\\:top-5\\/6 {
    top: 83.333333%;
  }
  .xl\\:right-5\\/6 {
    right: 83.333333%;
  }
  .xl\\:bottom-5\\/6 {
    bottom: 83.333333%;
  }
  .xl\\:left-5\\/6 {
    left: 83.333333%;
  }
  .xl\\:top-1\\/12 {
    top: 8.333333%;
  }
  .xl\\:right-1\\/12 {
    right: 8.333333%;
  }
  .xl\\:bottom-1\\/12 {
    bottom: 8.333333%;
  }
  .xl\\:left-1\\/12 {
    left: 8.333333%;
  }
  .xl\\:top-2\\/12 {
    top: 16.666667%;
  }
  .xl\\:right-2\\/12 {
    right: 16.666667%;
  }
  .xl\\:bottom-2\\/12 {
    bottom: 16.666667%;
  }
  .xl\\:left-2\\/12 {
    left: 16.666667%;
  }
  .xl\\:top-3\\/12 {
    top: 25%;
  }
  .xl\\:right-3\\/12 {
    right: 25%;
  }
  .xl\\:bottom-3\\/12 {
    bottom: 25%;
  }
  .xl\\:left-3\\/12 {
    left: 25%;
  }
  .xl\\:top-4\\/12 {
    top: 33.333333%;
  }
  .xl\\:right-4\\/12 {
    right: 33.333333%;
  }
  .xl\\:bottom-4\\/12 {
    bottom: 33.333333%;
  }
  .xl\\:left-4\\/12 {
    left: 33.333333%;
  }
  .xl\\:top-5\\/12 {
    top: 41.666667%;
  }
  .xl\\:right-5\\/12 {
    right: 41.666667%;
  }
  .xl\\:bottom-5\\/12 {
    bottom: 41.666667%;
  }
  .xl\\:left-5\\/12 {
    left: 41.666667%;
  }
  .xl\\:top-6\\/12 {
    top: 50%;
  }
  .xl\\:right-6\\/12 {
    right: 50%;
  }
  .xl\\:bottom-6\\/12 {
    bottom: 50%;
  }
  .xl\\:left-6\\/12 {
    left: 50%;
  }
  .xl\\:top-7\\/12 {
    top: 58.333333%;
  }
  .xl\\:right-7\\/12 {
    right: 58.333333%;
  }
  .xl\\:bottom-7\\/12 {
    bottom: 58.333333%;
  }
  .xl\\:left-7\\/12 {
    left: 58.333333%;
  }
  .xl\\:top-8\\/12 {
    top: 66.666667%;
  }
  .xl\\:right-8\\/12 {
    right: 66.666667%;
  }
  .xl\\:bottom-8\\/12 {
    bottom: 66.666667%;
  }
  .xl\\:left-8\\/12 {
    left: 66.666667%;
  }
  .xl\\:top-9\\/12 {
    top: 75%;
  }
  .xl\\:right-9\\/12 {
    right: 75%;
  }
  .xl\\:bottom-9\\/12 {
    bottom: 75%;
  }
  .xl\\:left-9\\/12 {
    left: 75%;
  }
  .xl\\:top-10\\/12 {
    top: 83.333333%;
  }
  .xl\\:right-10\\/12 {
    right: 83.333333%;
  }
  .xl\\:bottom-10\\/12 {
    bottom: 83.333333%;
  }
  .xl\\:left-10\\/12 {
    left: 83.333333%;
  }
  .xl\\:top-11\\/12 {
    top: 91.666667%;
  }
  .xl\\:right-11\\/12 {
    right: 91.666667%;
  }
  .xl\\:bottom-11\\/12 {
    bottom: 91.666667%;
  }
  .xl\\:left-11\\/12 {
    left: 91.666667%;
  }
  .xl\\:top-full {
    top: 100%;
  }
  .xl\\:right-full {
    right: 100%;
  }
  .xl\\:bottom-full {
    bottom: 100%;
  }
  .xl\\:left-full {
    left: 100%;
  }
  .xl\\:resize-none {
    resize: none;
  }
  .xl\\:resize-y {
    resize: vertical;
  }
  .xl\\:resize-x {
    resize: horizontal;
  }
  .xl\\:resize {
    resize: both;
  }
  .xl\\:shadow-xs {
    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.05);
  }
  .xl\\:shadow-sm {
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  }
  .xl\\:shadow {
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
  }
  .xl\\:shadow-md {
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  }
  .xl\\:shadow-lg {
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
  }
  .xl\\:shadow-xl {
    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  }
  .xl\\:shadow-2xl {
    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  }
  .xl\\:shadow-inner {
    box-shadow: inset 0 2px 4px 0 rgba(0, 0, 0, 0.06);
  }
  .xl\\:shadow-outline {
    box-shadow: 0 0 0 3px rgba(118, 169, 250, 0.45);
  }
  .xl\\:shadow-none {
    box-shadow: none;
  }
  .xl\\:shadow-solid {
    box-shadow: 0 0 0 2px currentColor;
  }
  .xl\\:shadow-outline-gray {
    box-shadow: 0 0 0 3px rgba(159, 166, 178, 0.45);
  }
  .xl\\:shadow-outline-blue {
    box-shadow: 0 0 0 3px rgba(164, 202, 254, 0.45);
  }
  .xl\\:shadow-outline-teal {
    box-shadow: 0 0 0 3px rgba(126, 220, 226, 0.45);
  }
  .xl\\:shadow-outline-green {
    box-shadow: 0 0 0 3px rgba(132, 225, 188, 0.45);
  }
  .xl\\:shadow-outline-yellow {
    box-shadow: 0 0 0 3px rgba(250, 202, 21, 0.45);
  }
  .xl\\:shadow-outline-orange {
    box-shadow: 0 0 0 3px rgba(253, 186, 140, 0.45);
  }
  .xl\\:shadow-outline-red {
    box-shadow: 0 0 0 3px rgba(248, 180, 180, 0.45);
  }
  .xl\\:shadow-outline-pink {
    box-shadow: 0 0 0 3px rgba(248, 180, 217, 0.45);
  }
  .xl\\:shadow-outline-purple {
    box-shadow: 0 0 0 3px rgba(202, 191, 253, 0.45);
  }
  .xl\\:shadow-outline-indigo {
    box-shadow: 0 0 0 3px rgba(180, 198, 252, 0.45);
  }
  .group:focus .xl\\:group-focus\\:shadow-xs {
    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.05);
  }
  .group:focus .xl\\:group-focus\\:shadow-sm {
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  }
  .group:focus .xl\\:group-focus\\:shadow {
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
  }
  .group:focus .xl\\:group-focus\\:shadow-md {
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  }
  .group:focus .xl\\:group-focus\\:shadow-lg {
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
  }
  .group:focus .xl\\:group-focus\\:shadow-xl {
    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  }
  .group:focus .xl\\:group-focus\\:shadow-2xl {
    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  }
  .group:focus .xl\\:group-focus\\:shadow-inner {
    box-shadow: inset 0 2px 4px 0 rgba(0, 0, 0, 0.06);
  }
  .group:focus .xl\\:group-focus\\:shadow-outline {
    box-shadow: 0 0 0 3px rgba(118, 169, 250, 0.45);
  }
  .group:focus .xl\\:group-focus\\:shadow-none {
    box-shadow: none;
  }
  .group:focus .xl\\:group-focus\\:shadow-solid {
    box-shadow: 0 0 0 2px currentColor;
  }
  .group:focus .xl\\:group-focus\\:shadow-outline-gray {
    box-shadow: 0 0 0 3px rgba(159, 166, 178, 0.45);
  }
  .group:focus .xl\\:group-focus\\:shadow-outline-blue {
    box-shadow: 0 0 0 3px rgba(164, 202, 254, 0.45);
  }
  .group:focus .xl\\:group-focus\\:shadow-outline-teal {
    box-shadow: 0 0 0 3px rgba(126, 220, 226, 0.45);
  }
  .group:focus .xl\\:group-focus\\:shadow-outline-green {
    box-shadow: 0 0 0 3px rgba(132, 225, 188, 0.45);
  }
  .group:focus .xl\\:group-focus\\:shadow-outline-yellow {
    box-shadow: 0 0 0 3px rgba(250, 202, 21, 0.45);
  }
  .group:focus .xl\\:group-focus\\:shadow-outline-orange {
    box-shadow: 0 0 0 3px rgba(253, 186, 140, 0.45);
  }
  .group:focus .xl\\:group-focus\\:shadow-outline-red {
    box-shadow: 0 0 0 3px rgba(248, 180, 180, 0.45);
  }
  .group:focus .xl\\:group-focus\\:shadow-outline-pink {
    box-shadow: 0 0 0 3px rgba(248, 180, 217, 0.45);
  }
  .group:focus .xl\\:group-focus\\:shadow-outline-purple {
    box-shadow: 0 0 0 3px rgba(202, 191, 253, 0.45);
  }
  .group:focus .xl\\:group-focus\\:shadow-outline-indigo {
    box-shadow: 0 0 0 3px rgba(180, 198, 252, 0.45);
  }
  .xl\\:hover\\:shadow-xs:hover {
    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.05);
  }
  .xl\\:hover\\:shadow-sm:hover {
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  }
  .xl\\:hover\\:shadow:hover {
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
  }
  .xl\\:hover\\:shadow-md:hover {
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  }
  .xl\\:hover\\:shadow-lg:hover {
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
  }
  .xl\\:hover\\:shadow-xl:hover {
    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  }
  .xl\\:hover\\:shadow-2xl:hover {
    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  }
  .xl\\:hover\\:shadow-inner:hover {
    box-shadow: inset 0 2px 4px 0 rgba(0, 0, 0, 0.06);
  }
  .xl\\:hover\\:shadow-outline:hover {
    box-shadow: 0 0 0 3px rgba(118, 169, 250, 0.45);
  }
  .xl\\:hover\\:shadow-none:hover {
    box-shadow: none;
  }
  .xl\\:hover\\:shadow-solid:hover {
    box-shadow: 0 0 0 2px currentColor;
  }
  .xl\\:hover\\:shadow-outline-gray:hover {
    box-shadow: 0 0 0 3px rgba(159, 166, 178, 0.45);
  }
  .xl\\:hover\\:shadow-outline-blue:hover {
    box-shadow: 0 0 0 3px rgba(164, 202, 254, 0.45);
  }
  .xl\\:hover\\:shadow-outline-teal:hover {
    box-shadow: 0 0 0 3px rgba(126, 220, 226, 0.45);
  }
  .xl\\:hover\\:shadow-outline-green:hover {
    box-shadow: 0 0 0 3px rgba(132, 225, 188, 0.45);
  }
  .xl\\:hover\\:shadow-outline-yellow:hover {
    box-shadow: 0 0 0 3px rgba(250, 202, 21, 0.45);
  }
  .xl\\:hover\\:shadow-outline-orange:hover {
    box-shadow: 0 0 0 3px rgba(253, 186, 140, 0.45);
  }
  .xl\\:hover\\:shadow-outline-red:hover {
    box-shadow: 0 0 0 3px rgba(248, 180, 180, 0.45);
  }
  .xl\\:hover\\:shadow-outline-pink:hover {
    box-shadow: 0 0 0 3px rgba(248, 180, 217, 0.45);
  }
  .xl\\:hover\\:shadow-outline-purple:hover {
    box-shadow: 0 0 0 3px rgba(202, 191, 253, 0.45);
  }
  .xl\\:hover\\:shadow-outline-indigo:hover {
    box-shadow: 0 0 0 3px rgba(180, 198, 252, 0.45);
  }
  .xl\\:focus-within\\:shadow-xs:focus-within {
    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.05);
  }
  .xl\\:focus-within\\:shadow-sm:focus-within {
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  }
  .xl\\:focus-within\\:shadow:focus-within {
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
  }
  .xl\\:focus-within\\:shadow-md:focus-within {
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  }
  .xl\\:focus-within\\:shadow-lg:focus-within {
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
  }
  .xl\\:focus-within\\:shadow-xl:focus-within {
    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  }
  .xl\\:focus-within\\:shadow-2xl:focus-within {
    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  }
  .xl\\:focus-within\\:shadow-inner:focus-within {
    box-shadow: inset 0 2px 4px 0 rgba(0, 0, 0, 0.06);
  }
  .xl\\:focus-within\\:shadow-outline:focus-within {
    box-shadow: 0 0 0 3px rgba(118, 169, 250, 0.45);
  }
  .xl\\:focus-within\\:shadow-none:focus-within {
    box-shadow: none;
  }
  .xl\\:focus-within\\:shadow-solid:focus-within {
    box-shadow: 0 0 0 2px currentColor;
  }
  .xl\\:focus-within\\:shadow-outline-gray:focus-within {
    box-shadow: 0 0 0 3px rgba(159, 166, 178, 0.45);
  }
  .xl\\:focus-within\\:shadow-outline-blue:focus-within {
    box-shadow: 0 0 0 3px rgba(164, 202, 254, 0.45);
  }
  .xl\\:focus-within\\:shadow-outline-teal:focus-within {
    box-shadow: 0 0 0 3px rgba(126, 220, 226, 0.45);
  }
  .xl\\:focus-within\\:shadow-outline-green:focus-within {
    box-shadow: 0 0 0 3px rgba(132, 225, 188, 0.45);
  }
  .xl\\:focus-within\\:shadow-outline-yellow:focus-within {
    box-shadow: 0 0 0 3px rgba(250, 202, 21, 0.45);
  }
  .xl\\:focus-within\\:shadow-outline-orange:focus-within {
    box-shadow: 0 0 0 3px rgba(253, 186, 140, 0.45);
  }
  .xl\\:focus-within\\:shadow-outline-red:focus-within {
    box-shadow: 0 0 0 3px rgba(248, 180, 180, 0.45);
  }
  .xl\\:focus-within\\:shadow-outline-pink:focus-within {
    box-shadow: 0 0 0 3px rgba(248, 180, 217, 0.45);
  }
  .xl\\:focus-within\\:shadow-outline-purple:focus-within {
    box-shadow: 0 0 0 3px rgba(202, 191, 253, 0.45);
  }
  .xl\\:focus-within\\:shadow-outline-indigo:focus-within {
    box-shadow: 0 0 0 3px rgba(180, 198, 252, 0.45);
  }
  .xl\\:focus\\:shadow-xs:focus {
    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.05);
  }
  .xl\\:focus\\:shadow-sm:focus {
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  }
  .xl\\:focus\\:shadow:focus {
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
  }
  .xl\\:focus\\:shadow-md:focus {
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  }
  .xl\\:focus\\:shadow-lg:focus {
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
  }
  .xl\\:focus\\:shadow-xl:focus {
    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  }
  .xl\\:focus\\:shadow-2xl:focus {
    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  }
  .xl\\:focus\\:shadow-inner:focus {
    box-shadow: inset 0 2px 4px 0 rgba(0, 0, 0, 0.06);
  }
  .xl\\:focus\\:shadow-outline:focus {
    box-shadow: 0 0 0 3px rgba(118, 169, 250, 0.45);
  }
  .xl\\:focus\\:shadow-none:focus {
    box-shadow: none;
  }
  .xl\\:focus\\:shadow-solid:focus {
    box-shadow: 0 0 0 2px currentColor;
  }
  .xl\\:focus\\:shadow-outline-gray:focus {
    box-shadow: 0 0 0 3px rgba(159, 166, 178, 0.45);
  }
  .xl\\:focus\\:shadow-outline-blue:focus {
    box-shadow: 0 0 0 3px rgba(164, 202, 254, 0.45);
  }
  .xl\\:focus\\:shadow-outline-teal:focus {
    box-shadow: 0 0 0 3px rgba(126, 220, 226, 0.45);
  }
  .xl\\:focus\\:shadow-outline-green:focus {
    box-shadow: 0 0 0 3px rgba(132, 225, 188, 0.45);
  }
  .xl\\:focus\\:shadow-outline-yellow:focus {
    box-shadow: 0 0 0 3px rgba(250, 202, 21, 0.45);
  }
  .xl\\:focus\\:shadow-outline-orange:focus {
    box-shadow: 0 0 0 3px rgba(253, 186, 140, 0.45);
  }
  .xl\\:focus\\:shadow-outline-red:focus {
    box-shadow: 0 0 0 3px rgba(248, 180, 180, 0.45);
  }
  .xl\\:focus\\:shadow-outline-pink:focus {
    box-shadow: 0 0 0 3px rgba(248, 180, 217, 0.45);
  }
  .xl\\:focus\\:shadow-outline-purple:focus {
    box-shadow: 0 0 0 3px rgba(202, 191, 253, 0.45);
  }
  .xl\\:focus\\:shadow-outline-indigo:focus {
    box-shadow: 0 0 0 3px rgba(180, 198, 252, 0.45);
  }
  .xl\\:fill-current {
    fill: currentColor;
  }
  .xl\\:stroke-current {
    stroke: currentColor;
  }
  .xl\\:stroke-0 {
    stroke-width: 0;
  }
  .xl\\:stroke-1 {
    stroke-width: 1;
  }
  .xl\\:stroke-2 {
    stroke-width: 2;
  }
  .xl\\:table-auto {
    table-layout: auto;
  }
  .xl\\:table-fixed {
    table-layout: fixed;
  }
  .xl\\:text-left {
    text-align: left;
  }
  .xl\\:text-center {
    text-align: center;
  }
  .xl\\:text-right {
    text-align: right;
  }
  .xl\\:text-justify {
    text-align: justify;
  }
  .xl\\:text-current {
    color: currentColor;
  }
  .xl\\:text-transparent {
    color: transparent;
  }
  .xl\\:text-white {
    --text-opacity: 1;
    color: #ffffff;
    color: rgba(255, 255, 255, var(--text-opacity));
  }
  .xl\\:text-black {
    --text-opacity: 1;
    color: #000000;
    color: rgba(0, 0, 0, var(--text-opacity));
  }
  .xl\\:text-gray-50 {
    --text-opacity: 1;
    color: #f9fafb;
    color: rgba(249, 250, 251, var(--text-opacity));
  }
  .xl\\:text-gray-100 {
    --text-opacity: 1;
    color: #f4f5f7;
    color: rgba(244, 245, 247, var(--text-opacity));
  }
  .xl\\:text-gray-200 {
    --text-opacity: 1;
    color: #e5e7eb;
    color: rgba(229, 231, 235, var(--text-opacity));
  }
  .xl\\:text-gray-300 {
    --text-opacity: 1;
    color: #d2d6dc;
    color: rgba(210, 214, 220, var(--text-opacity));
  }
  .xl\\:text-gray-400 {
    --text-opacity: 1;
    color: #9fa6b2;
    color: rgba(159, 166, 178, var(--text-opacity));
  }
  .xl\\:text-gray-500 {
    --text-opacity: 1;
    color: #6b7280;
    color: rgba(107, 114, 128, var(--text-opacity));
  }
  .xl\\:text-gray-600 {
    --text-opacity: 1;
    color: #4b5563;
    color: rgba(75, 85, 99, var(--text-opacity));
  }
  .xl\\:text-gray-700 {
    --text-opacity: 1;
    color: #374151;
    color: rgba(55, 65, 81, var(--text-opacity));
  }
  .xl\\:text-gray-800 {
    --text-opacity: 1;
    color: #252f3f;
    color: rgba(37, 47, 63, var(--text-opacity));
  }
  .xl\\:text-gray-900 {
    --text-opacity: 1;
    color: #161e2e;
    color: rgba(22, 30, 46, var(--text-opacity));
  }
  .xl\\:text-red-50 {
    --text-opacity: 1;
    color: #fdf2f2;
    color: rgba(253, 242, 242, var(--text-opacity));
  }
  .xl\\:text-red-100 {
    --text-opacity: 1;
    color: #fde8e8;
    color: rgba(253, 232, 232, var(--text-opacity));
  }
  .xl\\:text-red-200 {
    --text-opacity: 1;
    color: #fbd5d5;
    color: rgba(251, 213, 213, var(--text-opacity));
  }
  .xl\\:text-red-300 {
    --text-opacity: 1;
    color: #f8b4b4;
    color: rgba(248, 180, 180, var(--text-opacity));
  }
  .xl\\:text-red-400 {
    --text-opacity: 1;
    color: #f98080;
    color: rgba(249, 128, 128, var(--text-opacity));
  }
  .xl\\:text-red-500 {
    --text-opacity: 1;
    color: #f05252;
    color: rgba(240, 82, 82, var(--text-opacity));
  }
  .xl\\:text-red-600 {
    --text-opacity: 1;
    color: #e02424;
    color: rgba(224, 36, 36, var(--text-opacity));
  }
  .xl\\:text-red-700 {
    --text-opacity: 1;
    color: #c81e1e;
    color: rgba(200, 30, 30, var(--text-opacity));
  }
  .xl\\:text-red-800 {
    --text-opacity: 1;
    color: #9b1c1c;
    color: rgba(155, 28, 28, var(--text-opacity));
  }
  .xl\\:text-red-900 {
    --text-opacity: 1;
    color: #771d1d;
    color: rgba(119, 29, 29, var(--text-opacity));
  }
  .xl\\:text-orange-50 {
    --text-opacity: 1;
    color: #fff8f1;
    color: rgba(255, 248, 241, var(--text-opacity));
  }
  .xl\\:text-orange-100 {
    --text-opacity: 1;
    color: #feecdc;
    color: rgba(254, 236, 220, var(--text-opacity));
  }
  .xl\\:text-orange-200 {
    --text-opacity: 1;
    color: #fcd9bd;
    color: rgba(252, 217, 189, var(--text-opacity));
  }
  .xl\\:text-orange-300 {
    --text-opacity: 1;
    color: #fdba8c;
    color: rgba(253, 186, 140, var(--text-opacity));
  }
  .xl\\:text-orange-400 {
    --text-opacity: 1;
    color: #ff8a4c;
    color: rgba(255, 138, 76, var(--text-opacity));
  }
  .xl\\:text-orange-500 {
    --text-opacity: 1;
    color: #ff5a1f;
    color: rgba(255, 90, 31, var(--text-opacity));
  }
  .xl\\:text-orange-600 {
    --text-opacity: 1;
    color: #d03801;
    color: rgba(208, 56, 1, var(--text-opacity));
  }
  .xl\\:text-orange-700 {
    --text-opacity: 1;
    color: #b43403;
    color: rgba(180, 52, 3, var(--text-opacity));
  }
  .xl\\:text-orange-800 {
    --text-opacity: 1;
    color: #8a2c0d;
    color: rgba(138, 44, 13, var(--text-opacity));
  }
  .xl\\:text-orange-900 {
    --text-opacity: 1;
    color: #73230d;
    color: rgba(115, 35, 13, var(--text-opacity));
  }
  .xl\\:text-yellow-50 {
    --text-opacity: 1;
    color: #fdfdea;
    color: rgba(253, 253, 234, var(--text-opacity));
  }
  .xl\\:text-yellow-100 {
    --text-opacity: 1;
    color: #fdf6b2;
    color: rgba(253, 246, 178, var(--text-opacity));
  }
  .xl\\:text-yellow-200 {
    --text-opacity: 1;
    color: #fce96a;
    color: rgba(252, 233, 106, var(--text-opacity));
  }
  .xl\\:text-yellow-300 {
    --text-opacity: 1;
    color: #faca15;
    color: rgba(250, 202, 21, var(--text-opacity));
  }
  .xl\\:text-yellow-400 {
    --text-opacity: 1;
    color: #e3a008;
    color: rgba(227, 160, 8, var(--text-opacity));
  }
  .xl\\:text-yellow-500 {
    --text-opacity: 1;
    color: #c27803;
    color: rgba(194, 120, 3, var(--text-opacity));
  }
  .xl\\:text-yellow-600 {
    --text-opacity: 1;
    color: #9f580a;
    color: rgba(159, 88, 10, var(--text-opacity));
  }
  .xl\\:text-yellow-700 {
    --text-opacity: 1;
    color: #8e4b10;
    color: rgba(142, 75, 16, var(--text-opacity));
  }
  .xl\\:text-yellow-800 {
    --text-opacity: 1;
    color: #723b13;
    color: rgba(114, 59, 19, var(--text-opacity));
  }
  .xl\\:text-yellow-900 {
    --text-opacity: 1;
    color: #633112;
    color: rgba(99, 49, 18, var(--text-opacity));
  }
  .xl\\:text-green-50 {
    --text-opacity: 1;
    color: #f3faf7;
    color: rgba(243, 250, 247, var(--text-opacity));
  }
  .xl\\:text-green-100 {
    --text-opacity: 1;
    color: #def7ec;
    color: rgba(222, 247, 236, var(--text-opacity));
  }
  .xl\\:text-green-200 {
    --text-opacity: 1;
    color: #bcf0da;
    color: rgba(188, 240, 218, var(--text-opacity));
  }
  .xl\\:text-green-300 {
    --text-opacity: 1;
    color: #84e1bc;
    color: rgba(132, 225, 188, var(--text-opacity));
  }
  .xl\\:text-green-400 {
    --text-opacity: 1;
    color: #31c48d;
    color: rgba(49, 196, 141, var(--text-opacity));
  }
  .xl\\:text-green-500 {
    --text-opacity: 1;
    color: #0e9f6e;
    color: rgba(14, 159, 110, var(--text-opacity));
  }
  .xl\\:text-green-600 {
    --text-opacity: 1;
    color: #057a55;
    color: rgba(5, 122, 85, var(--text-opacity));
  }
  .xl\\:text-green-700 {
    --text-opacity: 1;
    color: #046c4e;
    color: rgba(4, 108, 78, var(--text-opacity));
  }
  .xl\\:text-green-800 {
    --text-opacity: 1;
    color: #03543f;
    color: rgba(3, 84, 63, var(--text-opacity));
  }
  .xl\\:text-green-900 {
    --text-opacity: 1;
    color: #014737;
    color: rgba(1, 71, 55, var(--text-opacity));
  }
  .xl\\:text-teal-50 {
    --text-opacity: 1;
    color: #edfafa;
    color: rgba(237, 250, 250, var(--text-opacity));
  }
  .xl\\:text-teal-100 {
    --text-opacity: 1;
    color: #d5f5f6;
    color: rgba(213, 245, 246, var(--text-opacity));
  }
  .xl\\:text-teal-200 {
    --text-opacity: 1;
    color: #afecef;
    color: rgba(175, 236, 239, var(--text-opacity));
  }
  .xl\\:text-teal-300 {
    --text-opacity: 1;
    color: #7edce2;
    color: rgba(126, 220, 226, var(--text-opacity));
  }
  .xl\\:text-teal-400 {
    --text-opacity: 1;
    color: #16bdca;
    color: rgba(22, 189, 202, var(--text-opacity));
  }
  .xl\\:text-teal-500 {
    --text-opacity: 1;
    color: #0694a2;
    color: rgba(6, 148, 162, var(--text-opacity));
  }
  .xl\\:text-teal-600 {
    --text-opacity: 1;
    color: #047481;
    color: rgba(4, 116, 129, var(--text-opacity));
  }
  .xl\\:text-teal-700 {
    --text-opacity: 1;
    color: #036672;
    color: rgba(3, 102, 114, var(--text-opacity));
  }
  .xl\\:text-teal-800 {
    --text-opacity: 1;
    color: #05505c;
    color: rgba(5, 80, 92, var(--text-opacity));
  }
  .xl\\:text-teal-900 {
    --text-opacity: 1;
    color: #014451;
    color: rgba(1, 68, 81, var(--text-opacity));
  }
  .xl\\:text-blue-50 {
    --text-opacity: 1;
    color: #ebf5ff;
    color: rgba(235, 245, 255, var(--text-opacity));
  }
  .xl\\:text-blue-100 {
    --text-opacity: 1;
    color: #e1effe;
    color: rgba(225, 239, 254, var(--text-opacity));
  }
  .xl\\:text-blue-200 {
    --text-opacity: 1;
    color: #c3ddfd;
    color: rgba(195, 221, 253, var(--text-opacity));
  }
  .xl\\:text-blue-300 {
    --text-opacity: 1;
    color: #a4cafe;
    color: rgba(164, 202, 254, var(--text-opacity));
  }
  .xl\\:text-blue-400 {
    --text-opacity: 1;
    color: #76a9fa;
    color: rgba(118, 169, 250, var(--text-opacity));
  }
  .xl\\:text-blue-500 {
    --text-opacity: 1;
    color: #3f83f8;
    color: rgba(63, 131, 248, var(--text-opacity));
  }
  .xl\\:text-blue-600 {
    --text-opacity: 1;
    color: #1c64f2;
    color: rgba(28, 100, 242, var(--text-opacity));
  }
  .xl\\:text-blue-700 {
    --text-opacity: 1;
    color: #1a56db;
    color: rgba(26, 86, 219, var(--text-opacity));
  }
  .xl\\:text-blue-800 {
    --text-opacity: 1;
    color: #1e429f;
    color: rgba(30, 66, 159, var(--text-opacity));
  }
  .xl\\:text-blue-900 {
    --text-opacity: 1;
    color: #233876;
    color: rgba(35, 56, 118, var(--text-opacity));
  }
  .xl\\:text-indigo-50 {
    --text-opacity: 1;
    color: #f0f5ff;
    color: rgba(240, 245, 255, var(--text-opacity));
  }
  .xl\\:text-indigo-100 {
    --text-opacity: 1;
    color: #e5edff;
    color: rgba(229, 237, 255, var(--text-opacity));
  }
  .xl\\:text-indigo-200 {
    --text-opacity: 1;
    color: #cddbfe;
    color: rgba(205, 219, 254, var(--text-opacity));
  }
  .xl\\:text-indigo-300 {
    --text-opacity: 1;
    color: #b4c6fc;
    color: rgba(180, 198, 252, var(--text-opacity));
  }
  .xl\\:text-indigo-400 {
    --text-opacity: 1;
    color: #8da2fb;
    color: rgba(141, 162, 251, var(--text-opacity));
  }
  .xl\\:text-indigo-500 {
    --text-opacity: 1;
    color: #6875f5;
    color: rgba(104, 117, 245, var(--text-opacity));
  }
  .xl\\:text-indigo-600 {
    --text-opacity: 1;
    color: #5850ec;
    color: rgba(88, 80, 236, var(--text-opacity));
  }
  .xl\\:text-indigo-700 {
    --text-opacity: 1;
    color: #5145cd;
    color: rgba(81, 69, 205, var(--text-opacity));
  }
  .xl\\:text-indigo-800 {
    --text-opacity: 1;
    color: #42389d;
    color: rgba(66, 56, 157, var(--text-opacity));
  }
  .xl\\:text-indigo-900 {
    --text-opacity: 1;
    color: #362f78;
    color: rgba(54, 47, 120, var(--text-opacity));
  }
  .xl\\:text-purple-50 {
    --text-opacity: 1;
    color: #f6f5ff;
    color: rgba(246, 245, 255, var(--text-opacity));
  }
  .xl\\:text-purple-100 {
    --text-opacity: 1;
    color: #edebfe;
    color: rgba(237, 235, 254, var(--text-opacity));
  }
  .xl\\:text-purple-200 {
    --text-opacity: 1;
    color: #dcd7fe;
    color: rgba(220, 215, 254, var(--text-opacity));
  }
  .xl\\:text-purple-300 {
    --text-opacity: 1;
    color: #cabffd;
    color: rgba(202, 191, 253, var(--text-opacity));
  }
  .xl\\:text-purple-400 {
    --text-opacity: 1;
    color: #ac94fa;
    color: rgba(172, 148, 250, var(--text-opacity));
  }
  .xl\\:text-purple-500 {
    --text-opacity: 1;
    color: #9061f9;
    color: rgba(144, 97, 249, var(--text-opacity));
  }
  .xl\\:text-purple-600 {
    --text-opacity: 1;
    color: #7e3af2;
    color: rgba(126, 58, 242, var(--text-opacity));
  }
  .xl\\:text-purple-700 {
    --text-opacity: 1;
    color: #6c2bd9;
    color: rgba(108, 43, 217, var(--text-opacity));
  }
  .xl\\:text-purple-800 {
    --text-opacity: 1;
    color: #5521b5;
    color: rgba(85, 33, 181, var(--text-opacity));
  }
  .xl\\:text-purple-900 {
    --text-opacity: 1;
    color: #4a1d96;
    color: rgba(74, 29, 150, var(--text-opacity));
  }
  .xl\\:text-pink-50 {
    --text-opacity: 1;
    color: #fdf2f8;
    color: rgba(253, 242, 248, var(--text-opacity));
  }
  .xl\\:text-pink-100 {
    --text-opacity: 1;
    color: #fce8f3;
    color: rgba(252, 232, 243, var(--text-opacity));
  }
  .xl\\:text-pink-200 {
    --text-opacity: 1;
    color: #fad1e8;
    color: rgba(250, 209, 232, var(--text-opacity));
  }
  .xl\\:text-pink-300 {
    --text-opacity: 1;
    color: #f8b4d9;
    color: rgba(248, 180, 217, var(--text-opacity));
  }
  .xl\\:text-pink-400 {
    --text-opacity: 1;
    color: #f17eb8;
    color: rgba(241, 126, 184, var(--text-opacity));
  }
  .xl\\:text-pink-500 {
    --text-opacity: 1;
    color: #e74694;
    color: rgba(231, 70, 148, var(--text-opacity));
  }
  .xl\\:text-pink-600 {
    --text-opacity: 1;
    color: #d61f69;
    color: rgba(214, 31, 105, var(--text-opacity));
  }
  .xl\\:text-pink-700 {
    --text-opacity: 1;
    color: #bf125d;
    color: rgba(191, 18, 93, var(--text-opacity));
  }
  .xl\\:text-pink-800 {
    --text-opacity: 1;
    color: #99154b;
    color: rgba(153, 21, 75, var(--text-opacity));
  }
  .xl\\:text-pink-900 {
    --text-opacity: 1;
    color: #751a3d;
    color: rgba(117, 26, 61, var(--text-opacity));
  }
  .xl\\:text-cool-gray-50 {
    --text-opacity: 1;
    color: #f8fafc;
    color: rgba(248, 250, 252, var(--text-opacity));
  }
  .xl\\:text-cool-gray-100 {
    --text-opacity: 1;
    color: #f1f5f9;
    color: rgba(241, 245, 249, var(--text-opacity));
  }
  .xl\\:text-cool-gray-200 {
    --text-opacity: 1;
    color: #e2e8f0;
    color: rgba(226, 232, 240, var(--text-opacity));
  }
  .xl\\:text-cool-gray-300 {
    --text-opacity: 1;
    color: #cfd8e3;
    color: rgba(207, 216, 227, var(--text-opacity));
  }
  .xl\\:text-cool-gray-400 {
    --text-opacity: 1;
    color: #97a6ba;
    color: rgba(151, 166, 186, var(--text-opacity));
  }
  .xl\\:text-cool-gray-500 {
    --text-opacity: 1;
    color: #64748b;
    color: rgba(100, 116, 139, var(--text-opacity));
  }
  .xl\\:text-cool-gray-600 {
    --text-opacity: 1;
    color: #475569;
    color: rgba(71, 85, 105, var(--text-opacity));
  }
  .xl\\:text-cool-gray-700 {
    --text-opacity: 1;
    color: #364152;
    color: rgba(54, 65, 82, var(--text-opacity));
  }
  .xl\\:text-cool-gray-800 {
    --text-opacity: 1;
    color: #27303f;
    color: rgba(39, 48, 63, var(--text-opacity));
  }
  .xl\\:text-cool-gray-900 {
    --text-opacity: 1;
    color: #1a202e;
    color: rgba(26, 32, 46, var(--text-opacity));
  }
  .group:hover .xl\\:group-hover\\:text-current {
    color: currentColor;
  }
  .group:hover .xl\\:group-hover\\:text-transparent {
    color: transparent;
  }
  .group:hover .xl\\:group-hover\\:text-white {
    --text-opacity: 1;
    color: #ffffff;
    color: rgba(255, 255, 255, var(--text-opacity));
  }
  .group:hover .xl\\:group-hover\\:text-black {
    --text-opacity: 1;
    color: #000000;
    color: rgba(0, 0, 0, var(--text-opacity));
  }
  .group:hover .xl\\:group-hover\\:text-gray-50 {
    --text-opacity: 1;
    color: #f9fafb;
    color: rgba(249, 250, 251, var(--text-opacity));
  }
  .group:hover .xl\\:group-hover\\:text-gray-100 {
    --text-opacity: 1;
    color: #f4f5f7;
    color: rgba(244, 245, 247, var(--text-opacity));
  }
  .group:hover .xl\\:group-hover\\:text-gray-200 {
    --text-opacity: 1;
    color: #e5e7eb;
    color: rgba(229, 231, 235, var(--text-opacity));
  }
  .group:hover .xl\\:group-hover\\:text-gray-300 {
    --text-opacity: 1;
    color: #d2d6dc;
    color: rgba(210, 214, 220, var(--text-opacity));
  }
  .group:hover .xl\\:group-hover\\:text-gray-400 {
    --text-opacity: 1;
    color: #9fa6b2;
    color: rgba(159, 166, 178, var(--text-opacity));
  }
  .group:hover .xl\\:group-hover\\:text-gray-500 {
    --text-opacity: 1;
    color: #6b7280;
    color: rgba(107, 114, 128, var(--text-opacity));
  }
  .group:hover .xl\\:group-hover\\:text-gray-600 {
    --text-opacity: 1;
    color: #4b5563;
    color: rgba(75, 85, 99, var(--text-opacity));
  }
  .group:hover .xl\\:group-hover\\:text-gray-700 {
    --text-opacity: 1;
    color: #374151;
    color: rgba(55, 65, 81, var(--text-opacity));
  }
  .group:hover .xl\\:group-hover\\:text-gray-800 {
    --text-opacity: 1;
    color: #252f3f;
    color: rgba(37, 47, 63, var(--text-opacity));
  }
  .group:hover .xl\\:group-hover\\:text-gray-900 {
    --text-opacity: 1;
    color: #161e2e;
    color: rgba(22, 30, 46, var(--text-opacity));
  }
  .group:hover .xl\\:group-hover\\:text-red-50 {
    --text-opacity: 1;
    color: #fdf2f2;
    color: rgba(253, 242, 242, var(--text-opacity));
  }
  .group:hover .xl\\:group-hover\\:text-red-100 {
    --text-opacity: 1;
    color: #fde8e8;
    color: rgba(253, 232, 232, var(--text-opacity));
  }
  .group:hover .xl\\:group-hover\\:text-red-200 {
    --text-opacity: 1;
    color: #fbd5d5;
    color: rgba(251, 213, 213, var(--text-opacity));
  }
  .group:hover .xl\\:group-hover\\:text-red-300 {
    --text-opacity: 1;
    color: #f8b4b4;
    color: rgba(248, 180, 180, var(--text-opacity));
  }
  .group:hover .xl\\:group-hover\\:text-red-400 {
    --text-opacity: 1;
    color: #f98080;
    color: rgba(249, 128, 128, var(--text-opacity));
  }
  .group:hover .xl\\:group-hover\\:text-red-500 {
    --text-opacity: 1;
    color: #f05252;
    color: rgba(240, 82, 82, var(--text-opacity));
  }
  .group:hover .xl\\:group-hover\\:text-red-600 {
    --text-opacity: 1;
    color: #e02424;
    color: rgba(224, 36, 36, var(--text-opacity));
  }
  .group:hover .xl\\:group-hover\\:text-red-700 {
    --text-opacity: 1;
    color: #c81e1e;
    color: rgba(200, 30, 30, var(--text-opacity));
  }
  .group:hover .xl\\:group-hover\\:text-red-800 {
    --text-opacity: 1;
    color: #9b1c1c;
    color: rgba(155, 28, 28, var(--text-opacity));
  }
  .group:hover .xl\\:group-hover\\:text-red-900 {
    --text-opacity: 1;
    color: #771d1d;
    color: rgba(119, 29, 29, var(--text-opacity));
  }
  .group:hover .xl\\:group-hover\\:text-orange-50 {
    --text-opacity: 1;
    color: #fff8f1;
    color: rgba(255, 248, 241, var(--text-opacity));
  }
  .group:hover .xl\\:group-hover\\:text-orange-100 {
    --text-opacity: 1;
    color: #feecdc;
    color: rgba(254, 236, 220, var(--text-opacity));
  }
  .group:hover .xl\\:group-hover\\:text-orange-200 {
    --text-opacity: 1;
    color: #fcd9bd;
    color: rgba(252, 217, 189, var(--text-opacity));
  }
  .group:hover .xl\\:group-hover\\:text-orange-300 {
    --text-opacity: 1;
    color: #fdba8c;
    color: rgba(253, 186, 140, var(--text-opacity));
  }
  .group:hover .xl\\:group-hover\\:text-orange-400 {
    --text-opacity: 1;
    color: #ff8a4c;
    color: rgba(255, 138, 76, var(--text-opacity));
  }
  .group:hover .xl\\:group-hover\\:text-orange-500 {
    --text-opacity: 1;
    color: #ff5a1f;
    color: rgba(255, 90, 31, var(--text-opacity));
  }
  .group:hover .xl\\:group-hover\\:text-orange-600 {
    --text-opacity: 1;
    color: #d03801;
    color: rgba(208, 56, 1, var(--text-opacity));
  }
  .group:hover .xl\\:group-hover\\:text-orange-700 {
    --text-opacity: 1;
    color: #b43403;
    color: rgba(180, 52, 3, var(--text-opacity));
  }
  .group:hover .xl\\:group-hover\\:text-orange-800 {
    --text-opacity: 1;
    color: #8a2c0d;
    color: rgba(138, 44, 13, var(--text-opacity));
  }
  .group:hover .xl\\:group-hover\\:text-orange-900 {
    --text-opacity: 1;
    color: #73230d;
    color: rgba(115, 35, 13, var(--text-opacity));
  }
  .group:hover .xl\\:group-hover\\:text-yellow-50 {
    --text-opacity: 1;
    color: #fdfdea;
    color: rgba(253, 253, 234, var(--text-opacity));
  }
  .group:hover .xl\\:group-hover\\:text-yellow-100 {
    --text-opacity: 1;
    color: #fdf6b2;
    color: rgba(253, 246, 178, var(--text-opacity));
  }
  .group:hover .xl\\:group-hover\\:text-yellow-200 {
    --text-opacity: 1;
    color: #fce96a;
    color: rgba(252, 233, 106, var(--text-opacity));
  }
  .group:hover .xl\\:group-hover\\:text-yellow-300 {
    --text-opacity: 1;
    color: #faca15;
    color: rgba(250, 202, 21, var(--text-opacity));
  }
  .group:hover .xl\\:group-hover\\:text-yellow-400 {
    --text-opacity: 1;
    color: #e3a008;
    color: rgba(227, 160, 8, var(--text-opacity));
  }
  .group:hover .xl\\:group-hover\\:text-yellow-500 {
    --text-opacity: 1;
    color: #c27803;
    color: rgba(194, 120, 3, var(--text-opacity));
  }
  .group:hover .xl\\:group-hover\\:text-yellow-600 {
    --text-opacity: 1;
    color: #9f580a;
    color: rgba(159, 88, 10, var(--text-opacity));
  }
  .group:hover .xl\\:group-hover\\:text-yellow-700 {
    --text-opacity: 1;
    color: #8e4b10;
    color: rgba(142, 75, 16, var(--text-opacity));
  }
  .group:hover .xl\\:group-hover\\:text-yellow-800 {
    --text-opacity: 1;
    color: #723b13;
    color: rgba(114, 59, 19, var(--text-opacity));
  }
  .group:hover .xl\\:group-hover\\:text-yellow-900 {
    --text-opacity: 1;
    color: #633112;
    color: rgba(99, 49, 18, var(--text-opacity));
  }
  .group:hover .xl\\:group-hover\\:text-green-50 {
    --text-opacity: 1;
    color: #f3faf7;
    color: rgba(243, 250, 247, var(--text-opacity));
  }
  .group:hover .xl\\:group-hover\\:text-green-100 {
    --text-opacity: 1;
    color: #def7ec;
    color: rgba(222, 247, 236, var(--text-opacity));
  }
  .group:hover .xl\\:group-hover\\:text-green-200 {
    --text-opacity: 1;
    color: #bcf0da;
    color: rgba(188, 240, 218, var(--text-opacity));
  }
  .group:hover .xl\\:group-hover\\:text-green-300 {
    --text-opacity: 1;
    color: #84e1bc;
    color: rgba(132, 225, 188, var(--text-opacity));
  }
  .group:hover .xl\\:group-hover\\:text-green-400 {
    --text-opacity: 1;
    color: #31c48d;
    color: rgba(49, 196, 141, var(--text-opacity));
  }
  .group:hover .xl\\:group-hover\\:text-green-500 {
    --text-opacity: 1;
    color: #0e9f6e;
    color: rgba(14, 159, 110, var(--text-opacity));
  }
  .group:hover .xl\\:group-hover\\:text-green-600 {
    --text-opacity: 1;
    color: #057a55;
    color: rgba(5, 122, 85, var(--text-opacity));
  }
  .group:hover .xl\\:group-hover\\:text-green-700 {
    --text-opacity: 1;
    color: #046c4e;
    color: rgba(4, 108, 78, var(--text-opacity));
  }
  .group:hover .xl\\:group-hover\\:text-green-800 {
    --text-opacity: 1;
    color: #03543f;
    color: rgba(3, 84, 63, var(--text-opacity));
  }
  .group:hover .xl\\:group-hover\\:text-green-900 {
    --text-opacity: 1;
    color: #014737;
    color: rgba(1, 71, 55, var(--text-opacity));
  }
  .group:hover .xl\\:group-hover\\:text-teal-50 {
    --text-opacity: 1;
    color: #edfafa;
    color: rgba(237, 250, 250, var(--text-opacity));
  }
  .group:hover .xl\\:group-hover\\:text-teal-100 {
    --text-opacity: 1;
    color: #d5f5f6;
    color: rgba(213, 245, 246, var(--text-opacity));
  }
  .group:hover .xl\\:group-hover\\:text-teal-200 {
    --text-opacity: 1;
    color: #afecef;
    color: rgba(175, 236, 239, var(--text-opacity));
  }
  .group:hover .xl\\:group-hover\\:text-teal-300 {
    --text-opacity: 1;
    color: #7edce2;
    color: rgba(126, 220, 226, var(--text-opacity));
  }
  .group:hover .xl\\:group-hover\\:text-teal-400 {
    --text-opacity: 1;
    color: #16bdca;
    color: rgba(22, 189, 202, var(--text-opacity));
  }
  .group:hover .xl\\:group-hover\\:text-teal-500 {
    --text-opacity: 1;
    color: #0694a2;
    color: rgba(6, 148, 162, var(--text-opacity));
  }
  .group:hover .xl\\:group-hover\\:text-teal-600 {
    --text-opacity: 1;
    color: #047481;
    color: rgba(4, 116, 129, var(--text-opacity));
  }
  .group:hover .xl\\:group-hover\\:text-teal-700 {
    --text-opacity: 1;
    color: #036672;
    color: rgba(3, 102, 114, var(--text-opacity));
  }
  .group:hover .xl\\:group-hover\\:text-teal-800 {
    --text-opacity: 1;
    color: #05505c;
    color: rgba(5, 80, 92, var(--text-opacity));
  }
  .group:hover .xl\\:group-hover\\:text-teal-900 {
    --text-opacity: 1;
    color: #014451;
    color: rgba(1, 68, 81, var(--text-opacity));
  }
  .group:hover .xl\\:group-hover\\:text-blue-50 {
    --text-opacity: 1;
    color: #ebf5ff;
    color: rgba(235, 245, 255, var(--text-opacity));
  }
  .group:hover .xl\\:group-hover\\:text-blue-100 {
    --text-opacity: 1;
    color: #e1effe;
    color: rgba(225, 239, 254, var(--text-opacity));
  }
  .group:hover .xl\\:group-hover\\:text-blue-200 {
    --text-opacity: 1;
    color: #c3ddfd;
    color: rgba(195, 221, 253, var(--text-opacity));
  }
  .group:hover .xl\\:group-hover\\:text-blue-300 {
    --text-opacity: 1;
    color: #a4cafe;
    color: rgba(164, 202, 254, var(--text-opacity));
  }
  .group:hover .xl\\:group-hover\\:text-blue-400 {
    --text-opacity: 1;
    color: #76a9fa;
    color: rgba(118, 169, 250, var(--text-opacity));
  }
  .group:hover .xl\\:group-hover\\:text-blue-500 {
    --text-opacity: 1;
    color: #3f83f8;
    color: rgba(63, 131, 248, var(--text-opacity));
  }
  .group:hover .xl\\:group-hover\\:text-blue-600 {
    --text-opacity: 1;
    color: #1c64f2;
    color: rgba(28, 100, 242, var(--text-opacity));
  }
  .group:hover .xl\\:group-hover\\:text-blue-700 {
    --text-opacity: 1;
    color: #1a56db;
    color: rgba(26, 86, 219, var(--text-opacity));
  }
  .group:hover .xl\\:group-hover\\:text-blue-800 {
    --text-opacity: 1;
    color: #1e429f;
    color: rgba(30, 66, 159, var(--text-opacity));
  }
  .group:hover .xl\\:group-hover\\:text-blue-900 {
    --text-opacity: 1;
    color: #233876;
    color: rgba(35, 56, 118, var(--text-opacity));
  }
  .group:hover .xl\\:group-hover\\:text-indigo-50 {
    --text-opacity: 1;
    color: #f0f5ff;
    color: rgba(240, 245, 255, var(--text-opacity));
  }
  .group:hover .xl\\:group-hover\\:text-indigo-100 {
    --text-opacity: 1;
    color: #e5edff;
    color: rgba(229, 237, 255, var(--text-opacity));
  }
  .group:hover .xl\\:group-hover\\:text-indigo-200 {
    --text-opacity: 1;
    color: #cddbfe;
    color: rgba(205, 219, 254, var(--text-opacity));
  }
  .group:hover .xl\\:group-hover\\:text-indigo-300 {
    --text-opacity: 1;
    color: #b4c6fc;
    color: rgba(180, 198, 252, var(--text-opacity));
  }
  .group:hover .xl\\:group-hover\\:text-indigo-400 {
    --text-opacity: 1;
    color: #8da2fb;
    color: rgba(141, 162, 251, var(--text-opacity));
  }
  .group:hover .xl\\:group-hover\\:text-indigo-500 {
    --text-opacity: 1;
    color: #6875f5;
    color: rgba(104, 117, 245, var(--text-opacity));
  }
  .group:hover .xl\\:group-hover\\:text-indigo-600 {
    --text-opacity: 1;
    color: #5850ec;
    color: rgba(88, 80, 236, var(--text-opacity));
  }
  .group:hover .xl\\:group-hover\\:text-indigo-700 {
    --text-opacity: 1;
    color: #5145cd;
    color: rgba(81, 69, 205, var(--text-opacity));
  }
  .group:hover .xl\\:group-hover\\:text-indigo-800 {
    --text-opacity: 1;
    color: #42389d;
    color: rgba(66, 56, 157, var(--text-opacity));
  }
  .group:hover .xl\\:group-hover\\:text-indigo-900 {
    --text-opacity: 1;
    color: #362f78;
    color: rgba(54, 47, 120, var(--text-opacity));
  }
  .group:hover .xl\\:group-hover\\:text-purple-50 {
    --text-opacity: 1;
    color: #f6f5ff;
    color: rgba(246, 245, 255, var(--text-opacity));
  }
  .group:hover .xl\\:group-hover\\:text-purple-100 {
    --text-opacity: 1;
    color: #edebfe;
    color: rgba(237, 235, 254, var(--text-opacity));
  }
  .group:hover .xl\\:group-hover\\:text-purple-200 {
    --text-opacity: 1;
    color: #dcd7fe;
    color: rgba(220, 215, 254, var(--text-opacity));
  }
  .group:hover .xl\\:group-hover\\:text-purple-300 {
    --text-opacity: 1;
    color: #cabffd;
    color: rgba(202, 191, 253, var(--text-opacity));
  }
  .group:hover .xl\\:group-hover\\:text-purple-400 {
    --text-opacity: 1;
    color: #ac94fa;
    color: rgba(172, 148, 250, var(--text-opacity));
  }
  .group:hover .xl\\:group-hover\\:text-purple-500 {
    --text-opacity: 1;
    color: #9061f9;
    color: rgba(144, 97, 249, var(--text-opacity));
  }
  .group:hover .xl\\:group-hover\\:text-purple-600 {
    --text-opacity: 1;
    color: #7e3af2;
    color: rgba(126, 58, 242, var(--text-opacity));
  }
  .group:hover .xl\\:group-hover\\:text-purple-700 {
    --text-opacity: 1;
    color: #6c2bd9;
    color: rgba(108, 43, 217, var(--text-opacity));
  }
  .group:hover .xl\\:group-hover\\:text-purple-800 {
    --text-opacity: 1;
    color: #5521b5;
    color: rgba(85, 33, 181, var(--text-opacity));
  }
  .group:hover .xl\\:group-hover\\:text-purple-900 {
    --text-opacity: 1;
    color: #4a1d96;
    color: rgba(74, 29, 150, var(--text-opacity));
  }
  .group:hover .xl\\:group-hover\\:text-pink-50 {
    --text-opacity: 1;
    color: #fdf2f8;
    color: rgba(253, 242, 248, var(--text-opacity));
  }
  .group:hover .xl\\:group-hover\\:text-pink-100 {
    --text-opacity: 1;
    color: #fce8f3;
    color: rgba(252, 232, 243, var(--text-opacity));
  }
  .group:hover .xl\\:group-hover\\:text-pink-200 {
    --text-opacity: 1;
    color: #fad1e8;
    color: rgba(250, 209, 232, var(--text-opacity));
  }
  .group:hover .xl\\:group-hover\\:text-pink-300 {
    --text-opacity: 1;
    color: #f8b4d9;
    color: rgba(248, 180, 217, var(--text-opacity));
  }
  .group:hover .xl\\:group-hover\\:text-pink-400 {
    --text-opacity: 1;
    color: #f17eb8;
    color: rgba(241, 126, 184, var(--text-opacity));
  }
  .group:hover .xl\\:group-hover\\:text-pink-500 {
    --text-opacity: 1;
    color: #e74694;
    color: rgba(231, 70, 148, var(--text-opacity));
  }
  .group:hover .xl\\:group-hover\\:text-pink-600 {
    --text-opacity: 1;
    color: #d61f69;
    color: rgba(214, 31, 105, var(--text-opacity));
  }
  .group:hover .xl\\:group-hover\\:text-pink-700 {
    --text-opacity: 1;
    color: #bf125d;
    color: rgba(191, 18, 93, var(--text-opacity));
  }
  .group:hover .xl\\:group-hover\\:text-pink-800 {
    --text-opacity: 1;
    color: #99154b;
    color: rgba(153, 21, 75, var(--text-opacity));
  }
  .group:hover .xl\\:group-hover\\:text-pink-900 {
    --text-opacity: 1;
    color: #751a3d;
    color: rgba(117, 26, 61, var(--text-opacity));
  }
  .group:hover .xl\\:group-hover\\:text-cool-gray-50 {
    --text-opacity: 1;
    color: #f8fafc;
    color: rgba(248, 250, 252, var(--text-opacity));
  }
  .group:hover .xl\\:group-hover\\:text-cool-gray-100 {
    --text-opacity: 1;
    color: #f1f5f9;
    color: rgba(241, 245, 249, var(--text-opacity));
  }
  .group:hover .xl\\:group-hover\\:text-cool-gray-200 {
    --text-opacity: 1;
    color: #e2e8f0;
    color: rgba(226, 232, 240, var(--text-opacity));
  }
  .group:hover .xl\\:group-hover\\:text-cool-gray-300 {
    --text-opacity: 1;
    color: #cfd8e3;
    color: rgba(207, 216, 227, var(--text-opacity));
  }
  .group:hover .xl\\:group-hover\\:text-cool-gray-400 {
    --text-opacity: 1;
    color: #97a6ba;
    color: rgba(151, 166, 186, var(--text-opacity));
  }
  .group:hover .xl\\:group-hover\\:text-cool-gray-500 {
    --text-opacity: 1;
    color: #64748b;
    color: rgba(100, 116, 139, var(--text-opacity));
  }
  .group:hover .xl\\:group-hover\\:text-cool-gray-600 {
    --text-opacity: 1;
    color: #475569;
    color: rgba(71, 85, 105, var(--text-opacity));
  }
  .group:hover .xl\\:group-hover\\:text-cool-gray-700 {
    --text-opacity: 1;
    color: #364152;
    color: rgba(54, 65, 82, var(--text-opacity));
  }
  .group:hover .xl\\:group-hover\\:text-cool-gray-800 {
    --text-opacity: 1;
    color: #27303f;
    color: rgba(39, 48, 63, var(--text-opacity));
  }
  .group:hover .xl\\:group-hover\\:text-cool-gray-900 {
    --text-opacity: 1;
    color: #1a202e;
    color: rgba(26, 32, 46, var(--text-opacity));
  }
  .group:focus .xl\\:group-focus\\:text-current {
    color: currentColor;
  }
  .group:focus .xl\\:group-focus\\:text-transparent {
    color: transparent;
  }
  .group:focus .xl\\:group-focus\\:text-white {
    --text-opacity: 1;
    color: #ffffff;
    color: rgba(255, 255, 255, var(--text-opacity));
  }
  .group:focus .xl\\:group-focus\\:text-black {
    --text-opacity: 1;
    color: #000000;
    color: rgba(0, 0, 0, var(--text-opacity));
  }
  .group:focus .xl\\:group-focus\\:text-gray-50 {
    --text-opacity: 1;
    color: #f9fafb;
    color: rgba(249, 250, 251, var(--text-opacity));
  }
  .group:focus .xl\\:group-focus\\:text-gray-100 {
    --text-opacity: 1;
    color: #f4f5f7;
    color: rgba(244, 245, 247, var(--text-opacity));
  }
  .group:focus .xl\\:group-focus\\:text-gray-200 {
    --text-opacity: 1;
    color: #e5e7eb;
    color: rgba(229, 231, 235, var(--text-opacity));
  }
  .group:focus .xl\\:group-focus\\:text-gray-300 {
    --text-opacity: 1;
    color: #d2d6dc;
    color: rgba(210, 214, 220, var(--text-opacity));
  }
  .group:focus .xl\\:group-focus\\:text-gray-400 {
    --text-opacity: 1;
    color: #9fa6b2;
    color: rgba(159, 166, 178, var(--text-opacity));
  }
  .group:focus .xl\\:group-focus\\:text-gray-500 {
    --text-opacity: 1;
    color: #6b7280;
    color: rgba(107, 114, 128, var(--text-opacity));
  }
  .group:focus .xl\\:group-focus\\:text-gray-600 {
    --text-opacity: 1;
    color: #4b5563;
    color: rgba(75, 85, 99, var(--text-opacity));
  }
  .group:focus .xl\\:group-focus\\:text-gray-700 {
    --text-opacity: 1;
    color: #374151;
    color: rgba(55, 65, 81, var(--text-opacity));
  }
  .group:focus .xl\\:group-focus\\:text-gray-800 {
    --text-opacity: 1;
    color: #252f3f;
    color: rgba(37, 47, 63, var(--text-opacity));
  }
  .group:focus .xl\\:group-focus\\:text-gray-900 {
    --text-opacity: 1;
    color: #161e2e;
    color: rgba(22, 30, 46, var(--text-opacity));
  }
  .group:focus .xl\\:group-focus\\:text-red-50 {
    --text-opacity: 1;
    color: #fdf2f2;
    color: rgba(253, 242, 242, var(--text-opacity));
  }
  .group:focus .xl\\:group-focus\\:text-red-100 {
    --text-opacity: 1;
    color: #fde8e8;
    color: rgba(253, 232, 232, var(--text-opacity));
  }
  .group:focus .xl\\:group-focus\\:text-red-200 {
    --text-opacity: 1;
    color: #fbd5d5;
    color: rgba(251, 213, 213, var(--text-opacity));
  }
  .group:focus .xl\\:group-focus\\:text-red-300 {
    --text-opacity: 1;
    color: #f8b4b4;
    color: rgba(248, 180, 180, var(--text-opacity));
  }
  .group:focus .xl\\:group-focus\\:text-red-400 {
    --text-opacity: 1;
    color: #f98080;
    color: rgba(249, 128, 128, var(--text-opacity));
  }
  .group:focus .xl\\:group-focus\\:text-red-500 {
    --text-opacity: 1;
    color: #f05252;
    color: rgba(240, 82, 82, var(--text-opacity));
  }
  .group:focus .xl\\:group-focus\\:text-red-600 {
    --text-opacity: 1;
    color: #e02424;
    color: rgba(224, 36, 36, var(--text-opacity));
  }
  .group:focus .xl\\:group-focus\\:text-red-700 {
    --text-opacity: 1;
    color: #c81e1e;
    color: rgba(200, 30, 30, var(--text-opacity));
  }
  .group:focus .xl\\:group-focus\\:text-red-800 {
    --text-opacity: 1;
    color: #9b1c1c;
    color: rgba(155, 28, 28, var(--text-opacity));
  }
  .group:focus .xl\\:group-focus\\:text-red-900 {
    --text-opacity: 1;
    color: #771d1d;
    color: rgba(119, 29, 29, var(--text-opacity));
  }
  .group:focus .xl\\:group-focus\\:text-orange-50 {
    --text-opacity: 1;
    color: #fff8f1;
    color: rgba(255, 248, 241, var(--text-opacity));
  }
  .group:focus .xl\\:group-focus\\:text-orange-100 {
    --text-opacity: 1;
    color: #feecdc;
    color: rgba(254, 236, 220, var(--text-opacity));
  }
  .group:focus .xl\\:group-focus\\:text-orange-200 {
    --text-opacity: 1;
    color: #fcd9bd;
    color: rgba(252, 217, 189, var(--text-opacity));
  }
  .group:focus .xl\\:group-focus\\:text-orange-300 {
    --text-opacity: 1;
    color: #fdba8c;
    color: rgba(253, 186, 140, var(--text-opacity));
  }
  .group:focus .xl\\:group-focus\\:text-orange-400 {
    --text-opacity: 1;
    color: #ff8a4c;
    color: rgba(255, 138, 76, var(--text-opacity));
  }
  .group:focus .xl\\:group-focus\\:text-orange-500 {
    --text-opacity: 1;
    color: #ff5a1f;
    color: rgba(255, 90, 31, var(--text-opacity));
  }
  .group:focus .xl\\:group-focus\\:text-orange-600 {
    --text-opacity: 1;
    color: #d03801;
    color: rgba(208, 56, 1, var(--text-opacity));
  }
  .group:focus .xl\\:group-focus\\:text-orange-700 {
    --text-opacity: 1;
    color: #b43403;
    color: rgba(180, 52, 3, var(--text-opacity));
  }
  .group:focus .xl\\:group-focus\\:text-orange-800 {
    --text-opacity: 1;
    color: #8a2c0d;
    color: rgba(138, 44, 13, var(--text-opacity));
  }
  .group:focus .xl\\:group-focus\\:text-orange-900 {
    --text-opacity: 1;
    color: #73230d;
    color: rgba(115, 35, 13, var(--text-opacity));
  }
  .group:focus .xl\\:group-focus\\:text-yellow-50 {
    --text-opacity: 1;
    color: #fdfdea;
    color: rgba(253, 253, 234, var(--text-opacity));
  }
  .group:focus .xl\\:group-focus\\:text-yellow-100 {
    --text-opacity: 1;
    color: #fdf6b2;
    color: rgba(253, 246, 178, var(--text-opacity));
  }
  .group:focus .xl\\:group-focus\\:text-yellow-200 {
    --text-opacity: 1;
    color: #fce96a;
    color: rgba(252, 233, 106, var(--text-opacity));
  }
  .group:focus .xl\\:group-focus\\:text-yellow-300 {
    --text-opacity: 1;
    color: #faca15;
    color: rgba(250, 202, 21, var(--text-opacity));
  }
  .group:focus .xl\\:group-focus\\:text-yellow-400 {
    --text-opacity: 1;
    color: #e3a008;
    color: rgba(227, 160, 8, var(--text-opacity));
  }
  .group:focus .xl\\:group-focus\\:text-yellow-500 {
    --text-opacity: 1;
    color: #c27803;
    color: rgba(194, 120, 3, var(--text-opacity));
  }
  .group:focus .xl\\:group-focus\\:text-yellow-600 {
    --text-opacity: 1;
    color: #9f580a;
    color: rgba(159, 88, 10, var(--text-opacity));
  }
  .group:focus .xl\\:group-focus\\:text-yellow-700 {
    --text-opacity: 1;
    color: #8e4b10;
    color: rgba(142, 75, 16, var(--text-opacity));
  }
  .group:focus .xl\\:group-focus\\:text-yellow-800 {
    --text-opacity: 1;
    color: #723b13;
    color: rgba(114, 59, 19, var(--text-opacity));
  }
  .group:focus .xl\\:group-focus\\:text-yellow-900 {
    --text-opacity: 1;
    color: #633112;
    color: rgba(99, 49, 18, var(--text-opacity));
  }
  .group:focus .xl\\:group-focus\\:text-green-50 {
    --text-opacity: 1;
    color: #f3faf7;
    color: rgba(243, 250, 247, var(--text-opacity));
  }
  .group:focus .xl\\:group-focus\\:text-green-100 {
    --text-opacity: 1;
    color: #def7ec;
    color: rgba(222, 247, 236, var(--text-opacity));
  }
  .group:focus .xl\\:group-focus\\:text-green-200 {
    --text-opacity: 1;
    color: #bcf0da;
    color: rgba(188, 240, 218, var(--text-opacity));
  }
  .group:focus .xl\\:group-focus\\:text-green-300 {
    --text-opacity: 1;
    color: #84e1bc;
    color: rgba(132, 225, 188, var(--text-opacity));
  }
  .group:focus .xl\\:group-focus\\:text-green-400 {
    --text-opacity: 1;
    color: #31c48d;
    color: rgba(49, 196, 141, var(--text-opacity));
  }
  .group:focus .xl\\:group-focus\\:text-green-500 {
    --text-opacity: 1;
    color: #0e9f6e;
    color: rgba(14, 159, 110, var(--text-opacity));
  }
  .group:focus .xl\\:group-focus\\:text-green-600 {
    --text-opacity: 1;
    color: #057a55;
    color: rgba(5, 122, 85, var(--text-opacity));
  }
  .group:focus .xl\\:group-focus\\:text-green-700 {
    --text-opacity: 1;
    color: #046c4e;
    color: rgba(4, 108, 78, var(--text-opacity));
  }
  .group:focus .xl\\:group-focus\\:text-green-800 {
    --text-opacity: 1;
    color: #03543f;
    color: rgba(3, 84, 63, var(--text-opacity));
  }
  .group:focus .xl\\:group-focus\\:text-green-900 {
    --text-opacity: 1;
    color: #014737;
    color: rgba(1, 71, 55, var(--text-opacity));
  }
  .group:focus .xl\\:group-focus\\:text-teal-50 {
    --text-opacity: 1;
    color: #edfafa;
    color: rgba(237, 250, 250, var(--text-opacity));
  }
  .group:focus .xl\\:group-focus\\:text-teal-100 {
    --text-opacity: 1;
    color: #d5f5f6;
    color: rgba(213, 245, 246, var(--text-opacity));
  }
  .group:focus .xl\\:group-focus\\:text-teal-200 {
    --text-opacity: 1;
    color: #afecef;
    color: rgba(175, 236, 239, var(--text-opacity));
  }
  .group:focus .xl\\:group-focus\\:text-teal-300 {
    --text-opacity: 1;
    color: #7edce2;
    color: rgba(126, 220, 226, var(--text-opacity));
  }
  .group:focus .xl\\:group-focus\\:text-teal-400 {
    --text-opacity: 1;
    color: #16bdca;
    color: rgba(22, 189, 202, var(--text-opacity));
  }
  .group:focus .xl\\:group-focus\\:text-teal-500 {
    --text-opacity: 1;
    color: #0694a2;
    color: rgba(6, 148, 162, var(--text-opacity));
  }
  .group:focus .xl\\:group-focus\\:text-teal-600 {
    --text-opacity: 1;
    color: #047481;
    color: rgba(4, 116, 129, var(--text-opacity));
  }
  .group:focus .xl\\:group-focus\\:text-teal-700 {
    --text-opacity: 1;
    color: #036672;
    color: rgba(3, 102, 114, var(--text-opacity));
  }
  .group:focus .xl\\:group-focus\\:text-teal-800 {
    --text-opacity: 1;
    color: #05505c;
    color: rgba(5, 80, 92, var(--text-opacity));
  }
  .group:focus .xl\\:group-focus\\:text-teal-900 {
    --text-opacity: 1;
    color: #014451;
    color: rgba(1, 68, 81, var(--text-opacity));
  }
  .group:focus .xl\\:group-focus\\:text-blue-50 {
    --text-opacity: 1;
    color: #ebf5ff;
    color: rgba(235, 245, 255, var(--text-opacity));
  }
  .group:focus .xl\\:group-focus\\:text-blue-100 {
    --text-opacity: 1;
    color: #e1effe;
    color: rgba(225, 239, 254, var(--text-opacity));
  }
  .group:focus .xl\\:group-focus\\:text-blue-200 {
    --text-opacity: 1;
    color: #c3ddfd;
    color: rgba(195, 221, 253, var(--text-opacity));
  }
  .group:focus .xl\\:group-focus\\:text-blue-300 {
    --text-opacity: 1;
    color: #a4cafe;
    color: rgba(164, 202, 254, var(--text-opacity));
  }
  .group:focus .xl\\:group-focus\\:text-blue-400 {
    --text-opacity: 1;
    color: #76a9fa;
    color: rgba(118, 169, 250, var(--text-opacity));
  }
  .group:focus .xl\\:group-focus\\:text-blue-500 {
    --text-opacity: 1;
    color: #3f83f8;
    color: rgba(63, 131, 248, var(--text-opacity));
  }
  .group:focus .xl\\:group-focus\\:text-blue-600 {
    --text-opacity: 1;
    color: #1c64f2;
    color: rgba(28, 100, 242, var(--text-opacity));
  }
  .group:focus .xl\\:group-focus\\:text-blue-700 {
    --text-opacity: 1;
    color: #1a56db;
    color: rgba(26, 86, 219, var(--text-opacity));
  }
  .group:focus .xl\\:group-focus\\:text-blue-800 {
    --text-opacity: 1;
    color: #1e429f;
    color: rgba(30, 66, 159, var(--text-opacity));
  }
  .group:focus .xl\\:group-focus\\:text-blue-900 {
    --text-opacity: 1;
    color: #233876;
    color: rgba(35, 56, 118, var(--text-opacity));
  }
  .group:focus .xl\\:group-focus\\:text-indigo-50 {
    --text-opacity: 1;
    color: #f0f5ff;
    color: rgba(240, 245, 255, var(--text-opacity));
  }
  .group:focus .xl\\:group-focus\\:text-indigo-100 {
    --text-opacity: 1;
    color: #e5edff;
    color: rgba(229, 237, 255, var(--text-opacity));
  }
  .group:focus .xl\\:group-focus\\:text-indigo-200 {
    --text-opacity: 1;
    color: #cddbfe;
    color: rgba(205, 219, 254, var(--text-opacity));
  }
  .group:focus .xl\\:group-focus\\:text-indigo-300 {
    --text-opacity: 1;
    color: #b4c6fc;
    color: rgba(180, 198, 252, var(--text-opacity));
  }
  .group:focus .xl\\:group-focus\\:text-indigo-400 {
    --text-opacity: 1;
    color: #8da2fb;
    color: rgba(141, 162, 251, var(--text-opacity));
  }
  .group:focus .xl\\:group-focus\\:text-indigo-500 {
    --text-opacity: 1;
    color: #6875f5;
    color: rgba(104, 117, 245, var(--text-opacity));
  }
  .group:focus .xl\\:group-focus\\:text-indigo-600 {
    --text-opacity: 1;
    color: #5850ec;
    color: rgba(88, 80, 236, var(--text-opacity));
  }
  .group:focus .xl\\:group-focus\\:text-indigo-700 {
    --text-opacity: 1;
    color: #5145cd;
    color: rgba(81, 69, 205, var(--text-opacity));
  }
  .group:focus .xl\\:group-focus\\:text-indigo-800 {
    --text-opacity: 1;
    color: #42389d;
    color: rgba(66, 56, 157, var(--text-opacity));
  }
  .group:focus .xl\\:group-focus\\:text-indigo-900 {
    --text-opacity: 1;
    color: #362f78;
    color: rgba(54, 47, 120, var(--text-opacity));
  }
  .group:focus .xl\\:group-focus\\:text-purple-50 {
    --text-opacity: 1;
    color: #f6f5ff;
    color: rgba(246, 245, 255, var(--text-opacity));
  }
  .group:focus .xl\\:group-focus\\:text-purple-100 {
    --text-opacity: 1;
    color: #edebfe;
    color: rgba(237, 235, 254, var(--text-opacity));
  }
  .group:focus .xl\\:group-focus\\:text-purple-200 {
    --text-opacity: 1;
    color: #dcd7fe;
    color: rgba(220, 215, 254, var(--text-opacity));
  }
  .group:focus .xl\\:group-focus\\:text-purple-300 {
    --text-opacity: 1;
    color: #cabffd;
    color: rgba(202, 191, 253, var(--text-opacity));
  }
  .group:focus .xl\\:group-focus\\:text-purple-400 {
    --text-opacity: 1;
    color: #ac94fa;
    color: rgba(172, 148, 250, var(--text-opacity));
  }
  .group:focus .xl\\:group-focus\\:text-purple-500 {
    --text-opacity: 1;
    color: #9061f9;
    color: rgba(144, 97, 249, var(--text-opacity));
  }
  .group:focus .xl\\:group-focus\\:text-purple-600 {
    --text-opacity: 1;
    color: #7e3af2;
    color: rgba(126, 58, 242, var(--text-opacity));
  }
  .group:focus .xl\\:group-focus\\:text-purple-700 {
    --text-opacity: 1;
    color: #6c2bd9;
    color: rgba(108, 43, 217, var(--text-opacity));
  }
  .group:focus .xl\\:group-focus\\:text-purple-800 {
    --text-opacity: 1;
    color: #5521b5;
    color: rgba(85, 33, 181, var(--text-opacity));
  }
  .group:focus .xl\\:group-focus\\:text-purple-900 {
    --text-opacity: 1;
    color: #4a1d96;
    color: rgba(74, 29, 150, var(--text-opacity));
  }
  .group:focus .xl\\:group-focus\\:text-pink-50 {
    --text-opacity: 1;
    color: #fdf2f8;
    color: rgba(253, 242, 248, var(--text-opacity));
  }
  .group:focus .xl\\:group-focus\\:text-pink-100 {
    --text-opacity: 1;
    color: #fce8f3;
    color: rgba(252, 232, 243, var(--text-opacity));
  }
  .group:focus .xl\\:group-focus\\:text-pink-200 {
    --text-opacity: 1;
    color: #fad1e8;
    color: rgba(250, 209, 232, var(--text-opacity));
  }
  .group:focus .xl\\:group-focus\\:text-pink-300 {
    --text-opacity: 1;
    color: #f8b4d9;
    color: rgba(248, 180, 217, var(--text-opacity));
  }
  .group:focus .xl\\:group-focus\\:text-pink-400 {
    --text-opacity: 1;
    color: #f17eb8;
    color: rgba(241, 126, 184, var(--text-opacity));
  }
  .group:focus .xl\\:group-focus\\:text-pink-500 {
    --text-opacity: 1;
    color: #e74694;
    color: rgba(231, 70, 148, var(--text-opacity));
  }
  .group:focus .xl\\:group-focus\\:text-pink-600 {
    --text-opacity: 1;
    color: #d61f69;
    color: rgba(214, 31, 105, var(--text-opacity));
  }
  .group:focus .xl\\:group-focus\\:text-pink-700 {
    --text-opacity: 1;
    color: #bf125d;
    color: rgba(191, 18, 93, var(--text-opacity));
  }
  .group:focus .xl\\:group-focus\\:text-pink-800 {
    --text-opacity: 1;
    color: #99154b;
    color: rgba(153, 21, 75, var(--text-opacity));
  }
  .group:focus .xl\\:group-focus\\:text-pink-900 {
    --text-opacity: 1;
    color: #751a3d;
    color: rgba(117, 26, 61, var(--text-opacity));
  }
  .group:focus .xl\\:group-focus\\:text-cool-gray-50 {
    --text-opacity: 1;
    color: #f8fafc;
    color: rgba(248, 250, 252, var(--text-opacity));
  }
  .group:focus .xl\\:group-focus\\:text-cool-gray-100 {
    --text-opacity: 1;
    color: #f1f5f9;
    color: rgba(241, 245, 249, var(--text-opacity));
  }
  .group:focus .xl\\:group-focus\\:text-cool-gray-200 {
    --text-opacity: 1;
    color: #e2e8f0;
    color: rgba(226, 232, 240, var(--text-opacity));
  }
  .group:focus .xl\\:group-focus\\:text-cool-gray-300 {
    --text-opacity: 1;
    color: #cfd8e3;
    color: rgba(207, 216, 227, var(--text-opacity));
  }
  .group:focus .xl\\:group-focus\\:text-cool-gray-400 {
    --text-opacity: 1;
    color: #97a6ba;
    color: rgba(151, 166, 186, var(--text-opacity));
  }
  .group:focus .xl\\:group-focus\\:text-cool-gray-500 {
    --text-opacity: 1;
    color: #64748b;
    color: rgba(100, 116, 139, var(--text-opacity));
  }
  .group:focus .xl\\:group-focus\\:text-cool-gray-600 {
    --text-opacity: 1;
    color: #475569;
    color: rgba(71, 85, 105, var(--text-opacity));
  }
  .group:focus .xl\\:group-focus\\:text-cool-gray-700 {
    --text-opacity: 1;
    color: #364152;
    color: rgba(54, 65, 82, var(--text-opacity));
  }
  .group:focus .xl\\:group-focus\\:text-cool-gray-800 {
    --text-opacity: 1;
    color: #27303f;
    color: rgba(39, 48, 63, var(--text-opacity));
  }
  .group:focus .xl\\:group-focus\\:text-cool-gray-900 {
    --text-opacity: 1;
    color: #1a202e;
    color: rgba(26, 32, 46, var(--text-opacity));
  }
  .xl\\:hover\\:text-current:hover {
    color: currentColor;
  }
  .xl\\:hover\\:text-transparent:hover {
    color: transparent;
  }
  .xl\\:hover\\:text-white:hover {
    --text-opacity: 1;
    color: #ffffff;
    color: rgba(255, 255, 255, var(--text-opacity));
  }
  .xl\\:hover\\:text-black:hover {
    --text-opacity: 1;
    color: #000000;
    color: rgba(0, 0, 0, var(--text-opacity));
  }
  .xl\\:hover\\:text-gray-50:hover {
    --text-opacity: 1;
    color: #f9fafb;
    color: rgba(249, 250, 251, var(--text-opacity));
  }
  .xl\\:hover\\:text-gray-100:hover {
    --text-opacity: 1;
    color: #f4f5f7;
    color: rgba(244, 245, 247, var(--text-opacity));
  }
  .xl\\:hover\\:text-gray-200:hover {
    --text-opacity: 1;
    color: #e5e7eb;
    color: rgba(229, 231, 235, var(--text-opacity));
  }
  .xl\\:hover\\:text-gray-300:hover {
    --text-opacity: 1;
    color: #d2d6dc;
    color: rgba(210, 214, 220, var(--text-opacity));
  }
  .xl\\:hover\\:text-gray-400:hover {
    --text-opacity: 1;
    color: #9fa6b2;
    color: rgba(159, 166, 178, var(--text-opacity));
  }
  .xl\\:hover\\:text-gray-500:hover {
    --text-opacity: 1;
    color: #6b7280;
    color: rgba(107, 114, 128, var(--text-opacity));
  }
  .xl\\:hover\\:text-gray-600:hover {
    --text-opacity: 1;
    color: #4b5563;
    color: rgba(75, 85, 99, var(--text-opacity));
  }
  .xl\\:hover\\:text-gray-700:hover {
    --text-opacity: 1;
    color: #374151;
    color: rgba(55, 65, 81, var(--text-opacity));
  }
  .xl\\:hover\\:text-gray-800:hover {
    --text-opacity: 1;
    color: #252f3f;
    color: rgba(37, 47, 63, var(--text-opacity));
  }
  .xl\\:hover\\:text-gray-900:hover {
    --text-opacity: 1;
    color: #161e2e;
    color: rgba(22, 30, 46, var(--text-opacity));
  }
  .xl\\:hover\\:text-red-50:hover {
    --text-opacity: 1;
    color: #fdf2f2;
    color: rgba(253, 242, 242, var(--text-opacity));
  }
  .xl\\:hover\\:text-red-100:hover {
    --text-opacity: 1;
    color: #fde8e8;
    color: rgba(253, 232, 232, var(--text-opacity));
  }
  .xl\\:hover\\:text-red-200:hover {
    --text-opacity: 1;
    color: #fbd5d5;
    color: rgba(251, 213, 213, var(--text-opacity));
  }
  .xl\\:hover\\:text-red-300:hover {
    --text-opacity: 1;
    color: #f8b4b4;
    color: rgba(248, 180, 180, var(--text-opacity));
  }
  .xl\\:hover\\:text-red-400:hover {
    --text-opacity: 1;
    color: #f98080;
    color: rgba(249, 128, 128, var(--text-opacity));
  }
  .xl\\:hover\\:text-red-500:hover {
    --text-opacity: 1;
    color: #f05252;
    color: rgba(240, 82, 82, var(--text-opacity));
  }
  .xl\\:hover\\:text-red-600:hover {
    --text-opacity: 1;
    color: #e02424;
    color: rgba(224, 36, 36, var(--text-opacity));
  }
  .xl\\:hover\\:text-red-700:hover {
    --text-opacity: 1;
    color: #c81e1e;
    color: rgba(200, 30, 30, var(--text-opacity));
  }
  .xl\\:hover\\:text-red-800:hover {
    --text-opacity: 1;
    color: #9b1c1c;
    color: rgba(155, 28, 28, var(--text-opacity));
  }
  .xl\\:hover\\:text-red-900:hover {
    --text-opacity: 1;
    color: #771d1d;
    color: rgba(119, 29, 29, var(--text-opacity));
  }
  .xl\\:hover\\:text-orange-50:hover {
    --text-opacity: 1;
    color: #fff8f1;
    color: rgba(255, 248, 241, var(--text-opacity));
  }
  .xl\\:hover\\:text-orange-100:hover {
    --text-opacity: 1;
    color: #feecdc;
    color: rgba(254, 236, 220, var(--text-opacity));
  }
  .xl\\:hover\\:text-orange-200:hover {
    --text-opacity: 1;
    color: #fcd9bd;
    color: rgba(252, 217, 189, var(--text-opacity));
  }
  .xl\\:hover\\:text-orange-300:hover {
    --text-opacity: 1;
    color: #fdba8c;
    color: rgba(253, 186, 140, var(--text-opacity));
  }
  .xl\\:hover\\:text-orange-400:hover {
    --text-opacity: 1;
    color: #ff8a4c;
    color: rgba(255, 138, 76, var(--text-opacity));
  }
  .xl\\:hover\\:text-orange-500:hover {
    --text-opacity: 1;
    color: #ff5a1f;
    color: rgba(255, 90, 31, var(--text-opacity));
  }
  .xl\\:hover\\:text-orange-600:hover {
    --text-opacity: 1;
    color: #d03801;
    color: rgba(208, 56, 1, var(--text-opacity));
  }
  .xl\\:hover\\:text-orange-700:hover {
    --text-opacity: 1;
    color: #b43403;
    color: rgba(180, 52, 3, var(--text-opacity));
  }
  .xl\\:hover\\:text-orange-800:hover {
    --text-opacity: 1;
    color: #8a2c0d;
    color: rgba(138, 44, 13, var(--text-opacity));
  }
  .xl\\:hover\\:text-orange-900:hover {
    --text-opacity: 1;
    color: #73230d;
    color: rgba(115, 35, 13, var(--text-opacity));
  }
  .xl\\:hover\\:text-yellow-50:hover {
    --text-opacity: 1;
    color: #fdfdea;
    color: rgba(253, 253, 234, var(--text-opacity));
  }
  .xl\\:hover\\:text-yellow-100:hover {
    --text-opacity: 1;
    color: #fdf6b2;
    color: rgba(253, 246, 178, var(--text-opacity));
  }
  .xl\\:hover\\:text-yellow-200:hover {
    --text-opacity: 1;
    color: #fce96a;
    color: rgba(252, 233, 106, var(--text-opacity));
  }
  .xl\\:hover\\:text-yellow-300:hover {
    --text-opacity: 1;
    color: #faca15;
    color: rgba(250, 202, 21, var(--text-opacity));
  }
  .xl\\:hover\\:text-yellow-400:hover {
    --text-opacity: 1;
    color: #e3a008;
    color: rgba(227, 160, 8, var(--text-opacity));
  }
  .xl\\:hover\\:text-yellow-500:hover {
    --text-opacity: 1;
    color: #c27803;
    color: rgba(194, 120, 3, var(--text-opacity));
  }
  .xl\\:hover\\:text-yellow-600:hover {
    --text-opacity: 1;
    color: #9f580a;
    color: rgba(159, 88, 10, var(--text-opacity));
  }
  .xl\\:hover\\:text-yellow-700:hover {
    --text-opacity: 1;
    color: #8e4b10;
    color: rgba(142, 75, 16, var(--text-opacity));
  }
  .xl\\:hover\\:text-yellow-800:hover {
    --text-opacity: 1;
    color: #723b13;
    color: rgba(114, 59, 19, var(--text-opacity));
  }
  .xl\\:hover\\:text-yellow-900:hover {
    --text-opacity: 1;
    color: #633112;
    color: rgba(99, 49, 18, var(--text-opacity));
  }
  .xl\\:hover\\:text-green-50:hover {
    --text-opacity: 1;
    color: #f3faf7;
    color: rgba(243, 250, 247, var(--text-opacity));
  }
  .xl\\:hover\\:text-green-100:hover {
    --text-opacity: 1;
    color: #def7ec;
    color: rgba(222, 247, 236, var(--text-opacity));
  }
  .xl\\:hover\\:text-green-200:hover {
    --text-opacity: 1;
    color: #bcf0da;
    color: rgba(188, 240, 218, var(--text-opacity));
  }
  .xl\\:hover\\:text-green-300:hover {
    --text-opacity: 1;
    color: #84e1bc;
    color: rgba(132, 225, 188, var(--text-opacity));
  }
  .xl\\:hover\\:text-green-400:hover {
    --text-opacity: 1;
    color: #31c48d;
    color: rgba(49, 196, 141, var(--text-opacity));
  }
  .xl\\:hover\\:text-green-500:hover {
    --text-opacity: 1;
    color: #0e9f6e;
    color: rgba(14, 159, 110, var(--text-opacity));
  }
  .xl\\:hover\\:text-green-600:hover {
    --text-opacity: 1;
    color: #057a55;
    color: rgba(5, 122, 85, var(--text-opacity));
  }
  .xl\\:hover\\:text-green-700:hover {
    --text-opacity: 1;
    color: #046c4e;
    color: rgba(4, 108, 78, var(--text-opacity));
  }
  .xl\\:hover\\:text-green-800:hover {
    --text-opacity: 1;
    color: #03543f;
    color: rgba(3, 84, 63, var(--text-opacity));
  }
  .xl\\:hover\\:text-green-900:hover {
    --text-opacity: 1;
    color: #014737;
    color: rgba(1, 71, 55, var(--text-opacity));
  }
  .xl\\:hover\\:text-teal-50:hover {
    --text-opacity: 1;
    color: #edfafa;
    color: rgba(237, 250, 250, var(--text-opacity));
  }
  .xl\\:hover\\:text-teal-100:hover {
    --text-opacity: 1;
    color: #d5f5f6;
    color: rgba(213, 245, 246, var(--text-opacity));
  }
  .xl\\:hover\\:text-teal-200:hover {
    --text-opacity: 1;
    color: #afecef;
    color: rgba(175, 236, 239, var(--text-opacity));
  }
  .xl\\:hover\\:text-teal-300:hover {
    --text-opacity: 1;
    color: #7edce2;
    color: rgba(126, 220, 226, var(--text-opacity));
  }
  .xl\\:hover\\:text-teal-400:hover {
    --text-opacity: 1;
    color: #16bdca;
    color: rgba(22, 189, 202, var(--text-opacity));
  }
  .xl\\:hover\\:text-teal-500:hover {
    --text-opacity: 1;
    color: #0694a2;
    color: rgba(6, 148, 162, var(--text-opacity));
  }
  .xl\\:hover\\:text-teal-600:hover {
    --text-opacity: 1;
    color: #047481;
    color: rgba(4, 116, 129, var(--text-opacity));
  }
  .xl\\:hover\\:text-teal-700:hover {
    --text-opacity: 1;
    color: #036672;
    color: rgba(3, 102, 114, var(--text-opacity));
  }
  .xl\\:hover\\:text-teal-800:hover {
    --text-opacity: 1;
    color: #05505c;
    color: rgba(5, 80, 92, var(--text-opacity));
  }
  .xl\\:hover\\:text-teal-900:hover {
    --text-opacity: 1;
    color: #014451;
    color: rgba(1, 68, 81, var(--text-opacity));
  }
  .xl\\:hover\\:text-blue-50:hover {
    --text-opacity: 1;
    color: #ebf5ff;
    color: rgba(235, 245, 255, var(--text-opacity));
  }
  .xl\\:hover\\:text-blue-100:hover {
    --text-opacity: 1;
    color: #e1effe;
    color: rgba(225, 239, 254, var(--text-opacity));
  }
  .xl\\:hover\\:text-blue-200:hover {
    --text-opacity: 1;
    color: #c3ddfd;
    color: rgba(195, 221, 253, var(--text-opacity));
  }
  .xl\\:hover\\:text-blue-300:hover {
    --text-opacity: 1;
    color: #a4cafe;
    color: rgba(164, 202, 254, var(--text-opacity));
  }
  .xl\\:hover\\:text-blue-400:hover {
    --text-opacity: 1;
    color: #76a9fa;
    color: rgba(118, 169, 250, var(--text-opacity));
  }
  .xl\\:hover\\:text-blue-500:hover {
    --text-opacity: 1;
    color: #3f83f8;
    color: rgba(63, 131, 248, var(--text-opacity));
  }
  .xl\\:hover\\:text-blue-600:hover {
    --text-opacity: 1;
    color: #1c64f2;
    color: rgba(28, 100, 242, var(--text-opacity));
  }
  .xl\\:hover\\:text-blue-700:hover {
    --text-opacity: 1;
    color: #1a56db;
    color: rgba(26, 86, 219, var(--text-opacity));
  }
  .xl\\:hover\\:text-blue-800:hover {
    --text-opacity: 1;
    color: #1e429f;
    color: rgba(30, 66, 159, var(--text-opacity));
  }
  .xl\\:hover\\:text-blue-900:hover {
    --text-opacity: 1;
    color: #233876;
    color: rgba(35, 56, 118, var(--text-opacity));
  }
  .xl\\:hover\\:text-indigo-50:hover {
    --text-opacity: 1;
    color: #f0f5ff;
    color: rgba(240, 245, 255, var(--text-opacity));
  }
  .xl\\:hover\\:text-indigo-100:hover {
    --text-opacity: 1;
    color: #e5edff;
    color: rgba(229, 237, 255, var(--text-opacity));
  }
  .xl\\:hover\\:text-indigo-200:hover {
    --text-opacity: 1;
    color: #cddbfe;
    color: rgba(205, 219, 254, var(--text-opacity));
  }
  .xl\\:hover\\:text-indigo-300:hover {
    --text-opacity: 1;
    color: #b4c6fc;
    color: rgba(180, 198, 252, var(--text-opacity));
  }
  .xl\\:hover\\:text-indigo-400:hover {
    --text-opacity: 1;
    color: #8da2fb;
    color: rgba(141, 162, 251, var(--text-opacity));
  }
  .xl\\:hover\\:text-indigo-500:hover {
    --text-opacity: 1;
    color: #6875f5;
    color: rgba(104, 117, 245, var(--text-opacity));
  }
  .xl\\:hover\\:text-indigo-600:hover {
    --text-opacity: 1;
    color: #5850ec;
    color: rgba(88, 80, 236, var(--text-opacity));
  }
  .xl\\:hover\\:text-indigo-700:hover {
    --text-opacity: 1;
    color: #5145cd;
    color: rgba(81, 69, 205, var(--text-opacity));
  }
  .xl\\:hover\\:text-indigo-800:hover {
    --text-opacity: 1;
    color: #42389d;
    color: rgba(66, 56, 157, var(--text-opacity));
  }
  .xl\\:hover\\:text-indigo-900:hover {
    --text-opacity: 1;
    color: #362f78;
    color: rgba(54, 47, 120, var(--text-opacity));
  }
  .xl\\:hover\\:text-purple-50:hover {
    --text-opacity: 1;
    color: #f6f5ff;
    color: rgba(246, 245, 255, var(--text-opacity));
  }
  .xl\\:hover\\:text-purple-100:hover {
    --text-opacity: 1;
    color: #edebfe;
    color: rgba(237, 235, 254, var(--text-opacity));
  }
  .xl\\:hover\\:text-purple-200:hover {
    --text-opacity: 1;
    color: #dcd7fe;
    color: rgba(220, 215, 254, var(--text-opacity));
  }
  .xl\\:hover\\:text-purple-300:hover {
    --text-opacity: 1;
    color: #cabffd;
    color: rgba(202, 191, 253, var(--text-opacity));
  }
  .xl\\:hover\\:text-purple-400:hover {
    --text-opacity: 1;
    color: #ac94fa;
    color: rgba(172, 148, 250, var(--text-opacity));
  }
  .xl\\:hover\\:text-purple-500:hover {
    --text-opacity: 1;
    color: #9061f9;
    color: rgba(144, 97, 249, var(--text-opacity));
  }
  .xl\\:hover\\:text-purple-600:hover {
    --text-opacity: 1;
    color: #7e3af2;
    color: rgba(126, 58, 242, var(--text-opacity));
  }
  .xl\\:hover\\:text-purple-700:hover {
    --text-opacity: 1;
    color: #6c2bd9;
    color: rgba(108, 43, 217, var(--text-opacity));
  }
  .xl\\:hover\\:text-purple-800:hover {
    --text-opacity: 1;
    color: #5521b5;
    color: rgba(85, 33, 181, var(--text-opacity));
  }
  .xl\\:hover\\:text-purple-900:hover {
    --text-opacity: 1;
    color: #4a1d96;
    color: rgba(74, 29, 150, var(--text-opacity));
  }
  .xl\\:hover\\:text-pink-50:hover {
    --text-opacity: 1;
    color: #fdf2f8;
    color: rgba(253, 242, 248, var(--text-opacity));
  }
  .xl\\:hover\\:text-pink-100:hover {
    --text-opacity: 1;
    color: #fce8f3;
    color: rgba(252, 232, 243, var(--text-opacity));
  }
  .xl\\:hover\\:text-pink-200:hover {
    --text-opacity: 1;
    color: #fad1e8;
    color: rgba(250, 209, 232, var(--text-opacity));
  }
  .xl\\:hover\\:text-pink-300:hover {
    --text-opacity: 1;
    color: #f8b4d9;
    color: rgba(248, 180, 217, var(--text-opacity));
  }
  .xl\\:hover\\:text-pink-400:hover {
    --text-opacity: 1;
    color: #f17eb8;
    color: rgba(241, 126, 184, var(--text-opacity));
  }
  .xl\\:hover\\:text-pink-500:hover {
    --text-opacity: 1;
    color: #e74694;
    color: rgba(231, 70, 148, var(--text-opacity));
  }
  .xl\\:hover\\:text-pink-600:hover {
    --text-opacity: 1;
    color: #d61f69;
    color: rgba(214, 31, 105, var(--text-opacity));
  }
  .xl\\:hover\\:text-pink-700:hover {
    --text-opacity: 1;
    color: #bf125d;
    color: rgba(191, 18, 93, var(--text-opacity));
  }
  .xl\\:hover\\:text-pink-800:hover {
    --text-opacity: 1;
    color: #99154b;
    color: rgba(153, 21, 75, var(--text-opacity));
  }
  .xl\\:hover\\:text-pink-900:hover {
    --text-opacity: 1;
    color: #751a3d;
    color: rgba(117, 26, 61, var(--text-opacity));
  }
  .xl\\:hover\\:text-cool-gray-50:hover {
    --text-opacity: 1;
    color: #f8fafc;
    color: rgba(248, 250, 252, var(--text-opacity));
  }
  .xl\\:hover\\:text-cool-gray-100:hover {
    --text-opacity: 1;
    color: #f1f5f9;
    color: rgba(241, 245, 249, var(--text-opacity));
  }
  .xl\\:hover\\:text-cool-gray-200:hover {
    --text-opacity: 1;
    color: #e2e8f0;
    color: rgba(226, 232, 240, var(--text-opacity));
  }
  .xl\\:hover\\:text-cool-gray-300:hover {
    --text-opacity: 1;
    color: #cfd8e3;
    color: rgba(207, 216, 227, var(--text-opacity));
  }
  .xl\\:hover\\:text-cool-gray-400:hover {
    --text-opacity: 1;
    color: #97a6ba;
    color: rgba(151, 166, 186, var(--text-opacity));
  }
  .xl\\:hover\\:text-cool-gray-500:hover {
    --text-opacity: 1;
    color: #64748b;
    color: rgba(100, 116, 139, var(--text-opacity));
  }
  .xl\\:hover\\:text-cool-gray-600:hover {
    --text-opacity: 1;
    color: #475569;
    color: rgba(71, 85, 105, var(--text-opacity));
  }
  .xl\\:hover\\:text-cool-gray-700:hover {
    --text-opacity: 1;
    color: #364152;
    color: rgba(54, 65, 82, var(--text-opacity));
  }
  .xl\\:hover\\:text-cool-gray-800:hover {
    --text-opacity: 1;
    color: #27303f;
    color: rgba(39, 48, 63, var(--text-opacity));
  }
  .xl\\:hover\\:text-cool-gray-900:hover {
    --text-opacity: 1;
    color: #1a202e;
    color: rgba(26, 32, 46, var(--text-opacity));
  }
  .xl\\:focus-within\\:text-current:focus-within {
    color: currentColor;
  }
  .xl\\:focus-within\\:text-transparent:focus-within {
    color: transparent;
  }
  .xl\\:focus-within\\:text-white:focus-within {
    --text-opacity: 1;
    color: #ffffff;
    color: rgba(255, 255, 255, var(--text-opacity));
  }
  .xl\\:focus-within\\:text-black:focus-within {
    --text-opacity: 1;
    color: #000000;
    color: rgba(0, 0, 0, var(--text-opacity));
  }
  .xl\\:focus-within\\:text-gray-50:focus-within {
    --text-opacity: 1;
    color: #f9fafb;
    color: rgba(249, 250, 251, var(--text-opacity));
  }
  .xl\\:focus-within\\:text-gray-100:focus-within {
    --text-opacity: 1;
    color: #f4f5f7;
    color: rgba(244, 245, 247, var(--text-opacity));
  }
  .xl\\:focus-within\\:text-gray-200:focus-within {
    --text-opacity: 1;
    color: #e5e7eb;
    color: rgba(229, 231, 235, var(--text-opacity));
  }
  .xl\\:focus-within\\:text-gray-300:focus-within {
    --text-opacity: 1;
    color: #d2d6dc;
    color: rgba(210, 214, 220, var(--text-opacity));
  }
  .xl\\:focus-within\\:text-gray-400:focus-within {
    --text-opacity: 1;
    color: #9fa6b2;
    color: rgba(159, 166, 178, var(--text-opacity));
  }
  .xl\\:focus-within\\:text-gray-500:focus-within {
    --text-opacity: 1;
    color: #6b7280;
    color: rgba(107, 114, 128, var(--text-opacity));
  }
  .xl\\:focus-within\\:text-gray-600:focus-within {
    --text-opacity: 1;
    color: #4b5563;
    color: rgba(75, 85, 99, var(--text-opacity));
  }
  .xl\\:focus-within\\:text-gray-700:focus-within {
    --text-opacity: 1;
    color: #374151;
    color: rgba(55, 65, 81, var(--text-opacity));
  }
  .xl\\:focus-within\\:text-gray-800:focus-within {
    --text-opacity: 1;
    color: #252f3f;
    color: rgba(37, 47, 63, var(--text-opacity));
  }
  .xl\\:focus-within\\:text-gray-900:focus-within {
    --text-opacity: 1;
    color: #161e2e;
    color: rgba(22, 30, 46, var(--text-opacity));
  }
  .xl\\:focus-within\\:text-red-50:focus-within {
    --text-opacity: 1;
    color: #fdf2f2;
    color: rgba(253, 242, 242, var(--text-opacity));
  }
  .xl\\:focus-within\\:text-red-100:focus-within {
    --text-opacity: 1;
    color: #fde8e8;
    color: rgba(253, 232, 232, var(--text-opacity));
  }
  .xl\\:focus-within\\:text-red-200:focus-within {
    --text-opacity: 1;
    color: #fbd5d5;
    color: rgba(251, 213, 213, var(--text-opacity));
  }
  .xl\\:focus-within\\:text-red-300:focus-within {
    --text-opacity: 1;
    color: #f8b4b4;
    color: rgba(248, 180, 180, var(--text-opacity));
  }
  .xl\\:focus-within\\:text-red-400:focus-within {
    --text-opacity: 1;
    color: #f98080;
    color: rgba(249, 128, 128, var(--text-opacity));
  }
  .xl\\:focus-within\\:text-red-500:focus-within {
    --text-opacity: 1;
    color: #f05252;
    color: rgba(240, 82, 82, var(--text-opacity));
  }
  .xl\\:focus-within\\:text-red-600:focus-within {
    --text-opacity: 1;
    color: #e02424;
    color: rgba(224, 36, 36, var(--text-opacity));
  }
  .xl\\:focus-within\\:text-red-700:focus-within {
    --text-opacity: 1;
    color: #c81e1e;
    color: rgba(200, 30, 30, var(--text-opacity));
  }
  .xl\\:focus-within\\:text-red-800:focus-within {
    --text-opacity: 1;
    color: #9b1c1c;
    color: rgba(155, 28, 28, var(--text-opacity));
  }
  .xl\\:focus-within\\:text-red-900:focus-within {
    --text-opacity: 1;
    color: #771d1d;
    color: rgba(119, 29, 29, var(--text-opacity));
  }
  .xl\\:focus-within\\:text-orange-50:focus-within {
    --text-opacity: 1;
    color: #fff8f1;
    color: rgba(255, 248, 241, var(--text-opacity));
  }
  .xl\\:focus-within\\:text-orange-100:focus-within {
    --text-opacity: 1;
    color: #feecdc;
    color: rgba(254, 236, 220, var(--text-opacity));
  }
  .xl\\:focus-within\\:text-orange-200:focus-within {
    --text-opacity: 1;
    color: #fcd9bd;
    color: rgba(252, 217, 189, var(--text-opacity));
  }
  .xl\\:focus-within\\:text-orange-300:focus-within {
    --text-opacity: 1;
    color: #fdba8c;
    color: rgba(253, 186, 140, var(--text-opacity));
  }
  .xl\\:focus-within\\:text-orange-400:focus-within {
    --text-opacity: 1;
    color: #ff8a4c;
    color: rgba(255, 138, 76, var(--text-opacity));
  }
  .xl\\:focus-within\\:text-orange-500:focus-within {
    --text-opacity: 1;
    color: #ff5a1f;
    color: rgba(255, 90, 31, var(--text-opacity));
  }
  .xl\\:focus-within\\:text-orange-600:focus-within {
    --text-opacity: 1;
    color: #d03801;
    color: rgba(208, 56, 1, var(--text-opacity));
  }
  .xl\\:focus-within\\:text-orange-700:focus-within {
    --text-opacity: 1;
    color: #b43403;
    color: rgba(180, 52, 3, var(--text-opacity));
  }
  .xl\\:focus-within\\:text-orange-800:focus-within {
    --text-opacity: 1;
    color: #8a2c0d;
    color: rgba(138, 44, 13, var(--text-opacity));
  }
  .xl\\:focus-within\\:text-orange-900:focus-within {
    --text-opacity: 1;
    color: #73230d;
    color: rgba(115, 35, 13, var(--text-opacity));
  }
  .xl\\:focus-within\\:text-yellow-50:focus-within {
    --text-opacity: 1;
    color: #fdfdea;
    color: rgba(253, 253, 234, var(--text-opacity));
  }
  .xl\\:focus-within\\:text-yellow-100:focus-within {
    --text-opacity: 1;
    color: #fdf6b2;
    color: rgba(253, 246, 178, var(--text-opacity));
  }
  .xl\\:focus-within\\:text-yellow-200:focus-within {
    --text-opacity: 1;
    color: #fce96a;
    color: rgba(252, 233, 106, var(--text-opacity));
  }
  .xl\\:focus-within\\:text-yellow-300:focus-within {
    --text-opacity: 1;
    color: #faca15;
    color: rgba(250, 202, 21, var(--text-opacity));
  }
  .xl\\:focus-within\\:text-yellow-400:focus-within {
    --text-opacity: 1;
    color: #e3a008;
    color: rgba(227, 160, 8, var(--text-opacity));
  }
  .xl\\:focus-within\\:text-yellow-500:focus-within {
    --text-opacity: 1;
    color: #c27803;
    color: rgba(194, 120, 3, var(--text-opacity));
  }
  .xl\\:focus-within\\:text-yellow-600:focus-within {
    --text-opacity: 1;
    color: #9f580a;
    color: rgba(159, 88, 10, var(--text-opacity));
  }
  .xl\\:focus-within\\:text-yellow-700:focus-within {
    --text-opacity: 1;
    color: #8e4b10;
    color: rgba(142, 75, 16, var(--text-opacity));
  }
  .xl\\:focus-within\\:text-yellow-800:focus-within {
    --text-opacity: 1;
    color: #723b13;
    color: rgba(114, 59, 19, var(--text-opacity));
  }
  .xl\\:focus-within\\:text-yellow-900:focus-within {
    --text-opacity: 1;
    color: #633112;
    color: rgba(99, 49, 18, var(--text-opacity));
  }
  .xl\\:focus-within\\:text-green-50:focus-within {
    --text-opacity: 1;
    color: #f3faf7;
    color: rgba(243, 250, 247, var(--text-opacity));
  }
  .xl\\:focus-within\\:text-green-100:focus-within {
    --text-opacity: 1;
    color: #def7ec;
    color: rgba(222, 247, 236, var(--text-opacity));
  }
  .xl\\:focus-within\\:text-green-200:focus-within {
    --text-opacity: 1;
    color: #bcf0da;
    color: rgba(188, 240, 218, var(--text-opacity));
  }
  .xl\\:focus-within\\:text-green-300:focus-within {
    --text-opacity: 1;
    color: #84e1bc;
    color: rgba(132, 225, 188, var(--text-opacity));
  }
  .xl\\:focus-within\\:text-green-400:focus-within {
    --text-opacity: 1;
    color: #31c48d;
    color: rgba(49, 196, 141, var(--text-opacity));
  }
  .xl\\:focus-within\\:text-green-500:focus-within {
    --text-opacity: 1;
    color: #0e9f6e;
    color: rgba(14, 159, 110, var(--text-opacity));
  }
  .xl\\:focus-within\\:text-green-600:focus-within {
    --text-opacity: 1;
    color: #057a55;
    color: rgba(5, 122, 85, var(--text-opacity));
  }
  .xl\\:focus-within\\:text-green-700:focus-within {
    --text-opacity: 1;
    color: #046c4e;
    color: rgba(4, 108, 78, var(--text-opacity));
  }
  .xl\\:focus-within\\:text-green-800:focus-within {
    --text-opacity: 1;
    color: #03543f;
    color: rgba(3, 84, 63, var(--text-opacity));
  }
  .xl\\:focus-within\\:text-green-900:focus-within {
    --text-opacity: 1;
    color: #014737;
    color: rgba(1, 71, 55, var(--text-opacity));
  }
  .xl\\:focus-within\\:text-teal-50:focus-within {
    --text-opacity: 1;
    color: #edfafa;
    color: rgba(237, 250, 250, var(--text-opacity));
  }
  .xl\\:focus-within\\:text-teal-100:focus-within {
    --text-opacity: 1;
    color: #d5f5f6;
    color: rgba(213, 245, 246, var(--text-opacity));
  }
  .xl\\:focus-within\\:text-teal-200:focus-within {
    --text-opacity: 1;
    color: #afecef;
    color: rgba(175, 236, 239, var(--text-opacity));
  }
  .xl\\:focus-within\\:text-teal-300:focus-within {
    --text-opacity: 1;
    color: #7edce2;
    color: rgba(126, 220, 226, var(--text-opacity));
  }
  .xl\\:focus-within\\:text-teal-400:focus-within {
    --text-opacity: 1;
    color: #16bdca;
    color: rgba(22, 189, 202, var(--text-opacity));
  }
  .xl\\:focus-within\\:text-teal-500:focus-within {
    --text-opacity: 1;
    color: #0694a2;
    color: rgba(6, 148, 162, var(--text-opacity));
  }
  .xl\\:focus-within\\:text-teal-600:focus-within {
    --text-opacity: 1;
    color: #047481;
    color: rgba(4, 116, 129, var(--text-opacity));
  }
  .xl\\:focus-within\\:text-teal-700:focus-within {
    --text-opacity: 1;
    color: #036672;
    color: rgba(3, 102, 114, var(--text-opacity));
  }
  .xl\\:focus-within\\:text-teal-800:focus-within {
    --text-opacity: 1;
    color: #05505c;
    color: rgba(5, 80, 92, var(--text-opacity));
  }
  .xl\\:focus-within\\:text-teal-900:focus-within {
    --text-opacity: 1;
    color: #014451;
    color: rgba(1, 68, 81, var(--text-opacity));
  }
  .xl\\:focus-within\\:text-blue-50:focus-within {
    --text-opacity: 1;
    color: #ebf5ff;
    color: rgba(235, 245, 255, var(--text-opacity));
  }
  .xl\\:focus-within\\:text-blue-100:focus-within {
    --text-opacity: 1;
    color: #e1effe;
    color: rgba(225, 239, 254, var(--text-opacity));
  }
  .xl\\:focus-within\\:text-blue-200:focus-within {
    --text-opacity: 1;
    color: #c3ddfd;
    color: rgba(195, 221, 253, var(--text-opacity));
  }
  .xl\\:focus-within\\:text-blue-300:focus-within {
    --text-opacity: 1;
    color: #a4cafe;
    color: rgba(164, 202, 254, var(--text-opacity));
  }
  .xl\\:focus-within\\:text-blue-400:focus-within {
    --text-opacity: 1;
    color: #76a9fa;
    color: rgba(118, 169, 250, var(--text-opacity));
  }
  .xl\\:focus-within\\:text-blue-500:focus-within {
    --text-opacity: 1;
    color: #3f83f8;
    color: rgba(63, 131, 248, var(--text-opacity));
  }
  .xl\\:focus-within\\:text-blue-600:focus-within {
    --text-opacity: 1;
    color: #1c64f2;
    color: rgba(28, 100, 242, var(--text-opacity));
  }
  .xl\\:focus-within\\:text-blue-700:focus-within {
    --text-opacity: 1;
    color: #1a56db;
    color: rgba(26, 86, 219, var(--text-opacity));
  }
  .xl\\:focus-within\\:text-blue-800:focus-within {
    --text-opacity: 1;
    color: #1e429f;
    color: rgba(30, 66, 159, var(--text-opacity));
  }
  .xl\\:focus-within\\:text-blue-900:focus-within {
    --text-opacity: 1;
    color: #233876;
    color: rgba(35, 56, 118, var(--text-opacity));
  }
  .xl\\:focus-within\\:text-indigo-50:focus-within {
    --text-opacity: 1;
    color: #f0f5ff;
    color: rgba(240, 245, 255, var(--text-opacity));
  }
  .xl\\:focus-within\\:text-indigo-100:focus-within {
    --text-opacity: 1;
    color: #e5edff;
    color: rgba(229, 237, 255, var(--text-opacity));
  }
  .xl\\:focus-within\\:text-indigo-200:focus-within {
    --text-opacity: 1;
    color: #cddbfe;
    color: rgba(205, 219, 254, var(--text-opacity));
  }
  .xl\\:focus-within\\:text-indigo-300:focus-within {
    --text-opacity: 1;
    color: #b4c6fc;
    color: rgba(180, 198, 252, var(--text-opacity));
  }
  .xl\\:focus-within\\:text-indigo-400:focus-within {
    --text-opacity: 1;
    color: #8da2fb;
    color: rgba(141, 162, 251, var(--text-opacity));
  }
  .xl\\:focus-within\\:text-indigo-500:focus-within {
    --text-opacity: 1;
    color: #6875f5;
    color: rgba(104, 117, 245, var(--text-opacity));
  }
  .xl\\:focus-within\\:text-indigo-600:focus-within {
    --text-opacity: 1;
    color: #5850ec;
    color: rgba(88, 80, 236, var(--text-opacity));
  }
  .xl\\:focus-within\\:text-indigo-700:focus-within {
    --text-opacity: 1;
    color: #5145cd;
    color: rgba(81, 69, 205, var(--text-opacity));
  }
  .xl\\:focus-within\\:text-indigo-800:focus-within {
    --text-opacity: 1;
    color: #42389d;
    color: rgba(66, 56, 157, var(--text-opacity));
  }
  .xl\\:focus-within\\:text-indigo-900:focus-within {
    --text-opacity: 1;
    color: #362f78;
    color: rgba(54, 47, 120, var(--text-opacity));
  }
  .xl\\:focus-within\\:text-purple-50:focus-within {
    --text-opacity: 1;
    color: #f6f5ff;
    color: rgba(246, 245, 255, var(--text-opacity));
  }
  .xl\\:focus-within\\:text-purple-100:focus-within {
    --text-opacity: 1;
    color: #edebfe;
    color: rgba(237, 235, 254, var(--text-opacity));
  }
  .xl\\:focus-within\\:text-purple-200:focus-within {
    --text-opacity: 1;
    color: #dcd7fe;
    color: rgba(220, 215, 254, var(--text-opacity));
  }
  .xl\\:focus-within\\:text-purple-300:focus-within {
    --text-opacity: 1;
    color: #cabffd;
    color: rgba(202, 191, 253, var(--text-opacity));
  }
  .xl\\:focus-within\\:text-purple-400:focus-within {
    --text-opacity: 1;
    color: #ac94fa;
    color: rgba(172, 148, 250, var(--text-opacity));
  }
  .xl\\:focus-within\\:text-purple-500:focus-within {
    --text-opacity: 1;
    color: #9061f9;
    color: rgba(144, 97, 249, var(--text-opacity));
  }
  .xl\\:focus-within\\:text-purple-600:focus-within {
    --text-opacity: 1;
    color: #7e3af2;
    color: rgba(126, 58, 242, var(--text-opacity));
  }
  .xl\\:focus-within\\:text-purple-700:focus-within {
    --text-opacity: 1;
    color: #6c2bd9;
    color: rgba(108, 43, 217, var(--text-opacity));
  }
  .xl\\:focus-within\\:text-purple-800:focus-within {
    --text-opacity: 1;
    color: #5521b5;
    color: rgba(85, 33, 181, var(--text-opacity));
  }
  .xl\\:focus-within\\:text-purple-900:focus-within {
    --text-opacity: 1;
    color: #4a1d96;
    color: rgba(74, 29, 150, var(--text-opacity));
  }
  .xl\\:focus-within\\:text-pink-50:focus-within {
    --text-opacity: 1;
    color: #fdf2f8;
    color: rgba(253, 242, 248, var(--text-opacity));
  }
  .xl\\:focus-within\\:text-pink-100:focus-within {
    --text-opacity: 1;
    color: #fce8f3;
    color: rgba(252, 232, 243, var(--text-opacity));
  }
  .xl\\:focus-within\\:text-pink-200:focus-within {
    --text-opacity: 1;
    color: #fad1e8;
    color: rgba(250, 209, 232, var(--text-opacity));
  }
  .xl\\:focus-within\\:text-pink-300:focus-within {
    --text-opacity: 1;
    color: #f8b4d9;
    color: rgba(248, 180, 217, var(--text-opacity));
  }
  .xl\\:focus-within\\:text-pink-400:focus-within {
    --text-opacity: 1;
    color: #f17eb8;
    color: rgba(241, 126, 184, var(--text-opacity));
  }
  .xl\\:focus-within\\:text-pink-500:focus-within {
    --text-opacity: 1;
    color: #e74694;
    color: rgba(231, 70, 148, var(--text-opacity));
  }
  .xl\\:focus-within\\:text-pink-600:focus-within {
    --text-opacity: 1;
    color: #d61f69;
    color: rgba(214, 31, 105, var(--text-opacity));
  }
  .xl\\:focus-within\\:text-pink-700:focus-within {
    --text-opacity: 1;
    color: #bf125d;
    color: rgba(191, 18, 93, var(--text-opacity));
  }
  .xl\\:focus-within\\:text-pink-800:focus-within {
    --text-opacity: 1;
    color: #99154b;
    color: rgba(153, 21, 75, var(--text-opacity));
  }
  .xl\\:focus-within\\:text-pink-900:focus-within {
    --text-opacity: 1;
    color: #751a3d;
    color: rgba(117, 26, 61, var(--text-opacity));
  }
  .xl\\:focus-within\\:text-cool-gray-50:focus-within {
    --text-opacity: 1;
    color: #f8fafc;
    color: rgba(248, 250, 252, var(--text-opacity));
  }
  .xl\\:focus-within\\:text-cool-gray-100:focus-within {
    --text-opacity: 1;
    color: #f1f5f9;
    color: rgba(241, 245, 249, var(--text-opacity));
  }
  .xl\\:focus-within\\:text-cool-gray-200:focus-within {
    --text-opacity: 1;
    color: #e2e8f0;
    color: rgba(226, 232, 240, var(--text-opacity));
  }
  .xl\\:focus-within\\:text-cool-gray-300:focus-within {
    --text-opacity: 1;
    color: #cfd8e3;
    color: rgba(207, 216, 227, var(--text-opacity));
  }
  .xl\\:focus-within\\:text-cool-gray-400:focus-within {
    --text-opacity: 1;
    color: #97a6ba;
    color: rgba(151, 166, 186, var(--text-opacity));
  }
  .xl\\:focus-within\\:text-cool-gray-500:focus-within {
    --text-opacity: 1;
    color: #64748b;
    color: rgba(100, 116, 139, var(--text-opacity));
  }
  .xl\\:focus-within\\:text-cool-gray-600:focus-within {
    --text-opacity: 1;
    color: #475569;
    color: rgba(71, 85, 105, var(--text-opacity));
  }
  .xl\\:focus-within\\:text-cool-gray-700:focus-within {
    --text-opacity: 1;
    color: #364152;
    color: rgba(54, 65, 82, var(--text-opacity));
  }
  .xl\\:focus-within\\:text-cool-gray-800:focus-within {
    --text-opacity: 1;
    color: #27303f;
    color: rgba(39, 48, 63, var(--text-opacity));
  }
  .xl\\:focus-within\\:text-cool-gray-900:focus-within {
    --text-opacity: 1;
    color: #1a202e;
    color: rgba(26, 32, 46, var(--text-opacity));
  }
  .xl\\:focus\\:text-current:focus {
    color: currentColor;
  }
  .xl\\:focus\\:text-transparent:focus {
    color: transparent;
  }
  .xl\\:focus\\:text-white:focus {
    --text-opacity: 1;
    color: #ffffff;
    color: rgba(255, 255, 255, var(--text-opacity));
  }
  .xl\\:focus\\:text-black:focus {
    --text-opacity: 1;
    color: #000000;
    color: rgba(0, 0, 0, var(--text-opacity));
  }
  .xl\\:focus\\:text-gray-50:focus {
    --text-opacity: 1;
    color: #f9fafb;
    color: rgba(249, 250, 251, var(--text-opacity));
  }
  .xl\\:focus\\:text-gray-100:focus {
    --text-opacity: 1;
    color: #f4f5f7;
    color: rgba(244, 245, 247, var(--text-opacity));
  }
  .xl\\:focus\\:text-gray-200:focus {
    --text-opacity: 1;
    color: #e5e7eb;
    color: rgba(229, 231, 235, var(--text-opacity));
  }
  .xl\\:focus\\:text-gray-300:focus {
    --text-opacity: 1;
    color: #d2d6dc;
    color: rgba(210, 214, 220, var(--text-opacity));
  }
  .xl\\:focus\\:text-gray-400:focus {
    --text-opacity: 1;
    color: #9fa6b2;
    color: rgba(159, 166, 178, var(--text-opacity));
  }
  .xl\\:focus\\:text-gray-500:focus {
    --text-opacity: 1;
    color: #6b7280;
    color: rgba(107, 114, 128, var(--text-opacity));
  }
  .xl\\:focus\\:text-gray-600:focus {
    --text-opacity: 1;
    color: #4b5563;
    color: rgba(75, 85, 99, var(--text-opacity));
  }
  .xl\\:focus\\:text-gray-700:focus {
    --text-opacity: 1;
    color: #374151;
    color: rgba(55, 65, 81, var(--text-opacity));
  }
  .xl\\:focus\\:text-gray-800:focus {
    --text-opacity: 1;
    color: #252f3f;
    color: rgba(37, 47, 63, var(--text-opacity));
  }
  .xl\\:focus\\:text-gray-900:focus {
    --text-opacity: 1;
    color: #161e2e;
    color: rgba(22, 30, 46, var(--text-opacity));
  }
  .xl\\:focus\\:text-red-50:focus {
    --text-opacity: 1;
    color: #fdf2f2;
    color: rgba(253, 242, 242, var(--text-opacity));
  }
  .xl\\:focus\\:text-red-100:focus {
    --text-opacity: 1;
    color: #fde8e8;
    color: rgba(253, 232, 232, var(--text-opacity));
  }
  .xl\\:focus\\:text-red-200:focus {
    --text-opacity: 1;
    color: #fbd5d5;
    color: rgba(251, 213, 213, var(--text-opacity));
  }
  .xl\\:focus\\:text-red-300:focus {
    --text-opacity: 1;
    color: #f8b4b4;
    color: rgba(248, 180, 180, var(--text-opacity));
  }
  .xl\\:focus\\:text-red-400:focus {
    --text-opacity: 1;
    color: #f98080;
    color: rgba(249, 128, 128, var(--text-opacity));
  }
  .xl\\:focus\\:text-red-500:focus {
    --text-opacity: 1;
    color: #f05252;
    color: rgba(240, 82, 82, var(--text-opacity));
  }
  .xl\\:focus\\:text-red-600:focus {
    --text-opacity: 1;
    color: #e02424;
    color: rgba(224, 36, 36, var(--text-opacity));
  }
  .xl\\:focus\\:text-red-700:focus {
    --text-opacity: 1;
    color: #c81e1e;
    color: rgba(200, 30, 30, var(--text-opacity));
  }
  .xl\\:focus\\:text-red-800:focus {
    --text-opacity: 1;
    color: #9b1c1c;
    color: rgba(155, 28, 28, var(--text-opacity));
  }
  .xl\\:focus\\:text-red-900:focus {
    --text-opacity: 1;
    color: #771d1d;
    color: rgba(119, 29, 29, var(--text-opacity));
  }
  .xl\\:focus\\:text-orange-50:focus {
    --text-opacity: 1;
    color: #fff8f1;
    color: rgba(255, 248, 241, var(--text-opacity));
  }
  .xl\\:focus\\:text-orange-100:focus {
    --text-opacity: 1;
    color: #feecdc;
    color: rgba(254, 236, 220, var(--text-opacity));
  }
  .xl\\:focus\\:text-orange-200:focus {
    --text-opacity: 1;
    color: #fcd9bd;
    color: rgba(252, 217, 189, var(--text-opacity));
  }
  .xl\\:focus\\:text-orange-300:focus {
    --text-opacity: 1;
    color: #fdba8c;
    color: rgba(253, 186, 140, var(--text-opacity));
  }
  .xl\\:focus\\:text-orange-400:focus {
    --text-opacity: 1;
    color: #ff8a4c;
    color: rgba(255, 138, 76, var(--text-opacity));
  }
  .xl\\:focus\\:text-orange-500:focus {
    --text-opacity: 1;
    color: #ff5a1f;
    color: rgba(255, 90, 31, var(--text-opacity));
  }
  .xl\\:focus\\:text-orange-600:focus {
    --text-opacity: 1;
    color: #d03801;
    color: rgba(208, 56, 1, var(--text-opacity));
  }
  .xl\\:focus\\:text-orange-700:focus {
    --text-opacity: 1;
    color: #b43403;
    color: rgba(180, 52, 3, var(--text-opacity));
  }
  .xl\\:focus\\:text-orange-800:focus {
    --text-opacity: 1;
    color: #8a2c0d;
    color: rgba(138, 44, 13, var(--text-opacity));
  }
  .xl\\:focus\\:text-orange-900:focus {
    --text-opacity: 1;
    color: #73230d;
    color: rgba(115, 35, 13, var(--text-opacity));
  }
  .xl\\:focus\\:text-yellow-50:focus {
    --text-opacity: 1;
    color: #fdfdea;
    color: rgba(253, 253, 234, var(--text-opacity));
  }
  .xl\\:focus\\:text-yellow-100:focus {
    --text-opacity: 1;
    color: #fdf6b2;
    color: rgba(253, 246, 178, var(--text-opacity));
  }
  .xl\\:focus\\:text-yellow-200:focus {
    --text-opacity: 1;
    color: #fce96a;
    color: rgba(252, 233, 106, var(--text-opacity));
  }
  .xl\\:focus\\:text-yellow-300:focus {
    --text-opacity: 1;
    color: #faca15;
    color: rgba(250, 202, 21, var(--text-opacity));
  }
  .xl\\:focus\\:text-yellow-400:focus {
    --text-opacity: 1;
    color: #e3a008;
    color: rgba(227, 160, 8, var(--text-opacity));
  }
  .xl\\:focus\\:text-yellow-500:focus {
    --text-opacity: 1;
    color: #c27803;
    color: rgba(194, 120, 3, var(--text-opacity));
  }
  .xl\\:focus\\:text-yellow-600:focus {
    --text-opacity: 1;
    color: #9f580a;
    color: rgba(159, 88, 10, var(--text-opacity));
  }
  .xl\\:focus\\:text-yellow-700:focus {
    --text-opacity: 1;
    color: #8e4b10;
    color: rgba(142, 75, 16, var(--text-opacity));
  }
  .xl\\:focus\\:text-yellow-800:focus {
    --text-opacity: 1;
    color: #723b13;
    color: rgba(114, 59, 19, var(--text-opacity));
  }
  .xl\\:focus\\:text-yellow-900:focus {
    --text-opacity: 1;
    color: #633112;
    color: rgba(99, 49, 18, var(--text-opacity));
  }
  .xl\\:focus\\:text-green-50:focus {
    --text-opacity: 1;
    color: #f3faf7;
    color: rgba(243, 250, 247, var(--text-opacity));
  }
  .xl\\:focus\\:text-green-100:focus {
    --text-opacity: 1;
    color: #def7ec;
    color: rgba(222, 247, 236, var(--text-opacity));
  }
  .xl\\:focus\\:text-green-200:focus {
    --text-opacity: 1;
    color: #bcf0da;
    color: rgba(188, 240, 218, var(--text-opacity));
  }
  .xl\\:focus\\:text-green-300:focus {
    --text-opacity: 1;
    color: #84e1bc;
    color: rgba(132, 225, 188, var(--text-opacity));
  }
  .xl\\:focus\\:text-green-400:focus {
    --text-opacity: 1;
    color: #31c48d;
    color: rgba(49, 196, 141, var(--text-opacity));
  }
  .xl\\:focus\\:text-green-500:focus {
    --text-opacity: 1;
    color: #0e9f6e;
    color: rgba(14, 159, 110, var(--text-opacity));
  }
  .xl\\:focus\\:text-green-600:focus {
    --text-opacity: 1;
    color: #057a55;
    color: rgba(5, 122, 85, var(--text-opacity));
  }
  .xl\\:focus\\:text-green-700:focus {
    --text-opacity: 1;
    color: #046c4e;
    color: rgba(4, 108, 78, var(--text-opacity));
  }
  .xl\\:focus\\:text-green-800:focus {
    --text-opacity: 1;
    color: #03543f;
    color: rgba(3, 84, 63, var(--text-opacity));
  }
  .xl\\:focus\\:text-green-900:focus {
    --text-opacity: 1;
    color: #014737;
    color: rgba(1, 71, 55, var(--text-opacity));
  }
  .xl\\:focus\\:text-teal-50:focus {
    --text-opacity: 1;
    color: #edfafa;
    color: rgba(237, 250, 250, var(--text-opacity));
  }
  .xl\\:focus\\:text-teal-100:focus {
    --text-opacity: 1;
    color: #d5f5f6;
    color: rgba(213, 245, 246, var(--text-opacity));
  }
  .xl\\:focus\\:text-teal-200:focus {
    --text-opacity: 1;
    color: #afecef;
    color: rgba(175, 236, 239, var(--text-opacity));
  }
  .xl\\:focus\\:text-teal-300:focus {
    --text-opacity: 1;
    color: #7edce2;
    color: rgba(126, 220, 226, var(--text-opacity));
  }
  .xl\\:focus\\:text-teal-400:focus {
    --text-opacity: 1;
    color: #16bdca;
    color: rgba(22, 189, 202, var(--text-opacity));
  }
  .xl\\:focus\\:text-teal-500:focus {
    --text-opacity: 1;
    color: #0694a2;
    color: rgba(6, 148, 162, var(--text-opacity));
  }
  .xl\\:focus\\:text-teal-600:focus {
    --text-opacity: 1;
    color: #047481;
    color: rgba(4, 116, 129, var(--text-opacity));
  }
  .xl\\:focus\\:text-teal-700:focus {
    --text-opacity: 1;
    color: #036672;
    color: rgba(3, 102, 114, var(--text-opacity));
  }
  .xl\\:focus\\:text-teal-800:focus {
    --text-opacity: 1;
    color: #05505c;
    color: rgba(5, 80, 92, var(--text-opacity));
  }
  .xl\\:focus\\:text-teal-900:focus {
    --text-opacity: 1;
    color: #014451;
    color: rgba(1, 68, 81, var(--text-opacity));
  }
  .xl\\:focus\\:text-blue-50:focus {
    --text-opacity: 1;
    color: #ebf5ff;
    color: rgba(235, 245, 255, var(--text-opacity));
  }
  .xl\\:focus\\:text-blue-100:focus {
    --text-opacity: 1;
    color: #e1effe;
    color: rgba(225, 239, 254, var(--text-opacity));
  }
  .xl\\:focus\\:text-blue-200:focus {
    --text-opacity: 1;
    color: #c3ddfd;
    color: rgba(195, 221, 253, var(--text-opacity));
  }
  .xl\\:focus\\:text-blue-300:focus {
    --text-opacity: 1;
    color: #a4cafe;
    color: rgba(164, 202, 254, var(--text-opacity));
  }
  .xl\\:focus\\:text-blue-400:focus {
    --text-opacity: 1;
    color: #76a9fa;
    color: rgba(118, 169, 250, var(--text-opacity));
  }
  .xl\\:focus\\:text-blue-500:focus {
    --text-opacity: 1;
    color: #3f83f8;
    color: rgba(63, 131, 248, var(--text-opacity));
  }
  .xl\\:focus\\:text-blue-600:focus {
    --text-opacity: 1;
    color: #1c64f2;
    color: rgba(28, 100, 242, var(--text-opacity));
  }
  .xl\\:focus\\:text-blue-700:focus {
    --text-opacity: 1;
    color: #1a56db;
    color: rgba(26, 86, 219, var(--text-opacity));
  }
  .xl\\:focus\\:text-blue-800:focus {
    --text-opacity: 1;
    color: #1e429f;
    color: rgba(30, 66, 159, var(--text-opacity));
  }
  .xl\\:focus\\:text-blue-900:focus {
    --text-opacity: 1;
    color: #233876;
    color: rgba(35, 56, 118, var(--text-opacity));
  }
  .xl\\:focus\\:text-indigo-50:focus {
    --text-opacity: 1;
    color: #f0f5ff;
    color: rgba(240, 245, 255, var(--text-opacity));
  }
  .xl\\:focus\\:text-indigo-100:focus {
    --text-opacity: 1;
    color: #e5edff;
    color: rgba(229, 237, 255, var(--text-opacity));
  }
  .xl\\:focus\\:text-indigo-200:focus {
    --text-opacity: 1;
    color: #cddbfe;
    color: rgba(205, 219, 254, var(--text-opacity));
  }
  .xl\\:focus\\:text-indigo-300:focus {
    --text-opacity: 1;
    color: #b4c6fc;
    color: rgba(180, 198, 252, var(--text-opacity));
  }
  .xl\\:focus\\:text-indigo-400:focus {
    --text-opacity: 1;
    color: #8da2fb;
    color: rgba(141, 162, 251, var(--text-opacity));
  }
  .xl\\:focus\\:text-indigo-500:focus {
    --text-opacity: 1;
    color: #6875f5;
    color: rgba(104, 117, 245, var(--text-opacity));
  }
  .xl\\:focus\\:text-indigo-600:focus {
    --text-opacity: 1;
    color: #5850ec;
    color: rgba(88, 80, 236, var(--text-opacity));
  }
  .xl\\:focus\\:text-indigo-700:focus {
    --text-opacity: 1;
    color: #5145cd;
    color: rgba(81, 69, 205, var(--text-opacity));
  }
  .xl\\:focus\\:text-indigo-800:focus {
    --text-opacity: 1;
    color: #42389d;
    color: rgba(66, 56, 157, var(--text-opacity));
  }
  .xl\\:focus\\:text-indigo-900:focus {
    --text-opacity: 1;
    color: #362f78;
    color: rgba(54, 47, 120, var(--text-opacity));
  }
  .xl\\:focus\\:text-purple-50:focus {
    --text-opacity: 1;
    color: #f6f5ff;
    color: rgba(246, 245, 255, var(--text-opacity));
  }
  .xl\\:focus\\:text-purple-100:focus {
    --text-opacity: 1;
    color: #edebfe;
    color: rgba(237, 235, 254, var(--text-opacity));
  }
  .xl\\:focus\\:text-purple-200:focus {
    --text-opacity: 1;
    color: #dcd7fe;
    color: rgba(220, 215, 254, var(--text-opacity));
  }
  .xl\\:focus\\:text-purple-300:focus {
    --text-opacity: 1;
    color: #cabffd;
    color: rgba(202, 191, 253, var(--text-opacity));
  }
  .xl\\:focus\\:text-purple-400:focus {
    --text-opacity: 1;
    color: #ac94fa;
    color: rgba(172, 148, 250, var(--text-opacity));
  }
  .xl\\:focus\\:text-purple-500:focus {
    --text-opacity: 1;
    color: #9061f9;
    color: rgba(144, 97, 249, var(--text-opacity));
  }
  .xl\\:focus\\:text-purple-600:focus {
    --text-opacity: 1;
    color: #7e3af2;
    color: rgba(126, 58, 242, var(--text-opacity));
  }
  .xl\\:focus\\:text-purple-700:focus {
    --text-opacity: 1;
    color: #6c2bd9;
    color: rgba(108, 43, 217, var(--text-opacity));
  }
  .xl\\:focus\\:text-purple-800:focus {
    --text-opacity: 1;
    color: #5521b5;
    color: rgba(85, 33, 181, var(--text-opacity));
  }
  .xl\\:focus\\:text-purple-900:focus {
    --text-opacity: 1;
    color: #4a1d96;
    color: rgba(74, 29, 150, var(--text-opacity));
  }
  .xl\\:focus\\:text-pink-50:focus {
    --text-opacity: 1;
    color: #fdf2f8;
    color: rgba(253, 242, 248, var(--text-opacity));
  }
  .xl\\:focus\\:text-pink-100:focus {
    --text-opacity: 1;
    color: #fce8f3;
    color: rgba(252, 232, 243, var(--text-opacity));
  }
  .xl\\:focus\\:text-pink-200:focus {
    --text-opacity: 1;
    color: #fad1e8;
    color: rgba(250, 209, 232, var(--text-opacity));
  }
  .xl\\:focus\\:text-pink-300:focus {
    --text-opacity: 1;
    color: #f8b4d9;
    color: rgba(248, 180, 217, var(--text-opacity));
  }
  .xl\\:focus\\:text-pink-400:focus {
    --text-opacity: 1;
    color: #f17eb8;
    color: rgba(241, 126, 184, var(--text-opacity));
  }
  .xl\\:focus\\:text-pink-500:focus {
    --text-opacity: 1;
    color: #e74694;
    color: rgba(231, 70, 148, var(--text-opacity));
  }
  .xl\\:focus\\:text-pink-600:focus {
    --text-opacity: 1;
    color: #d61f69;
    color: rgba(214, 31, 105, var(--text-opacity));
  }
  .xl\\:focus\\:text-pink-700:focus {
    --text-opacity: 1;
    color: #bf125d;
    color: rgba(191, 18, 93, var(--text-opacity));
  }
  .xl\\:focus\\:text-pink-800:focus {
    --text-opacity: 1;
    color: #99154b;
    color: rgba(153, 21, 75, var(--text-opacity));
  }
  .xl\\:focus\\:text-pink-900:focus {
    --text-opacity: 1;
    color: #751a3d;
    color: rgba(117, 26, 61, var(--text-opacity));
  }
  .xl\\:focus\\:text-cool-gray-50:focus {
    --text-opacity: 1;
    color: #f8fafc;
    color: rgba(248, 250, 252, var(--text-opacity));
  }
  .xl\\:focus\\:text-cool-gray-100:focus {
    --text-opacity: 1;
    color: #f1f5f9;
    color: rgba(241, 245, 249, var(--text-opacity));
  }
  .xl\\:focus\\:text-cool-gray-200:focus {
    --text-opacity: 1;
    color: #e2e8f0;
    color: rgba(226, 232, 240, var(--text-opacity));
  }
  .xl\\:focus\\:text-cool-gray-300:focus {
    --text-opacity: 1;
    color: #cfd8e3;
    color: rgba(207, 216, 227, var(--text-opacity));
  }
  .xl\\:focus\\:text-cool-gray-400:focus {
    --text-opacity: 1;
    color: #97a6ba;
    color: rgba(151, 166, 186, var(--text-opacity));
  }
  .xl\\:focus\\:text-cool-gray-500:focus {
    --text-opacity: 1;
    color: #64748b;
    color: rgba(100, 116, 139, var(--text-opacity));
  }
  .xl\\:focus\\:text-cool-gray-600:focus {
    --text-opacity: 1;
    color: #475569;
    color: rgba(71, 85, 105, var(--text-opacity));
  }
  .xl\\:focus\\:text-cool-gray-700:focus {
    --text-opacity: 1;
    color: #364152;
    color: rgba(54, 65, 82, var(--text-opacity));
  }
  .xl\\:focus\\:text-cool-gray-800:focus {
    --text-opacity: 1;
    color: #27303f;
    color: rgba(39, 48, 63, var(--text-opacity));
  }
  .xl\\:focus\\:text-cool-gray-900:focus {
    --text-opacity: 1;
    color: #1a202e;
    color: rgba(26, 32, 46, var(--text-opacity));
  }
  .xl\\:active\\:text-current:active {
    color: currentColor;
  }
  .xl\\:active\\:text-transparent:active {
    color: transparent;
  }
  .xl\\:active\\:text-white:active {
    --text-opacity: 1;
    color: #ffffff;
    color: rgba(255, 255, 255, var(--text-opacity));
  }
  .xl\\:active\\:text-black:active {
    --text-opacity: 1;
    color: #000000;
    color: rgba(0, 0, 0, var(--text-opacity));
  }
  .xl\\:active\\:text-gray-50:active {
    --text-opacity: 1;
    color: #f9fafb;
    color: rgba(249, 250, 251, var(--text-opacity));
  }
  .xl\\:active\\:text-gray-100:active {
    --text-opacity: 1;
    color: #f4f5f7;
    color: rgba(244, 245, 247, var(--text-opacity));
  }
  .xl\\:active\\:text-gray-200:active {
    --text-opacity: 1;
    color: #e5e7eb;
    color: rgba(229, 231, 235, var(--text-opacity));
  }
  .xl\\:active\\:text-gray-300:active {
    --text-opacity: 1;
    color: #d2d6dc;
    color: rgba(210, 214, 220, var(--text-opacity));
  }
  .xl\\:active\\:text-gray-400:active {
    --text-opacity: 1;
    color: #9fa6b2;
    color: rgba(159, 166, 178, var(--text-opacity));
  }
  .xl\\:active\\:text-gray-500:active {
    --text-opacity: 1;
    color: #6b7280;
    color: rgba(107, 114, 128, var(--text-opacity));
  }
  .xl\\:active\\:text-gray-600:active {
    --text-opacity: 1;
    color: #4b5563;
    color: rgba(75, 85, 99, var(--text-opacity));
  }
  .xl\\:active\\:text-gray-700:active {
    --text-opacity: 1;
    color: #374151;
    color: rgba(55, 65, 81, var(--text-opacity));
  }
  .xl\\:active\\:text-gray-800:active {
    --text-opacity: 1;
    color: #252f3f;
    color: rgba(37, 47, 63, var(--text-opacity));
  }
  .xl\\:active\\:text-gray-900:active {
    --text-opacity: 1;
    color: #161e2e;
    color: rgba(22, 30, 46, var(--text-opacity));
  }
  .xl\\:active\\:text-red-50:active {
    --text-opacity: 1;
    color: #fdf2f2;
    color: rgba(253, 242, 242, var(--text-opacity));
  }
  .xl\\:active\\:text-red-100:active {
    --text-opacity: 1;
    color: #fde8e8;
    color: rgba(253, 232, 232, var(--text-opacity));
  }
  .xl\\:active\\:text-red-200:active {
    --text-opacity: 1;
    color: #fbd5d5;
    color: rgba(251, 213, 213, var(--text-opacity));
  }
  .xl\\:active\\:text-red-300:active {
    --text-opacity: 1;
    color: #f8b4b4;
    color: rgba(248, 180, 180, var(--text-opacity));
  }
  .xl\\:active\\:text-red-400:active {
    --text-opacity: 1;
    color: #f98080;
    color: rgba(249, 128, 128, var(--text-opacity));
  }
  .xl\\:active\\:text-red-500:active {
    --text-opacity: 1;
    color: #f05252;
    color: rgba(240, 82, 82, var(--text-opacity));
  }
  .xl\\:active\\:text-red-600:active {
    --text-opacity: 1;
    color: #e02424;
    color: rgba(224, 36, 36, var(--text-opacity));
  }
  .xl\\:active\\:text-red-700:active {
    --text-opacity: 1;
    color: #c81e1e;
    color: rgba(200, 30, 30, var(--text-opacity));
  }
  .xl\\:active\\:text-red-800:active {
    --text-opacity: 1;
    color: #9b1c1c;
    color: rgba(155, 28, 28, var(--text-opacity));
  }
  .xl\\:active\\:text-red-900:active {
    --text-opacity: 1;
    color: #771d1d;
    color: rgba(119, 29, 29, var(--text-opacity));
  }
  .xl\\:active\\:text-orange-50:active {
    --text-opacity: 1;
    color: #fff8f1;
    color: rgba(255, 248, 241, var(--text-opacity));
  }
  .xl\\:active\\:text-orange-100:active {
    --text-opacity: 1;
    color: #feecdc;
    color: rgba(254, 236, 220, var(--text-opacity));
  }
  .xl\\:active\\:text-orange-200:active {
    --text-opacity: 1;
    color: #fcd9bd;
    color: rgba(252, 217, 189, var(--text-opacity));
  }
  .xl\\:active\\:text-orange-300:active {
    --text-opacity: 1;
    color: #fdba8c;
    color: rgba(253, 186, 140, var(--text-opacity));
  }
  .xl\\:active\\:text-orange-400:active {
    --text-opacity: 1;
    color: #ff8a4c;
    color: rgba(255, 138, 76, var(--text-opacity));
  }
  .xl\\:active\\:text-orange-500:active {
    --text-opacity: 1;
    color: #ff5a1f;
    color: rgba(255, 90, 31, var(--text-opacity));
  }
  .xl\\:active\\:text-orange-600:active {
    --text-opacity: 1;
    color: #d03801;
    color: rgba(208, 56, 1, var(--text-opacity));
  }
  .xl\\:active\\:text-orange-700:active {
    --text-opacity: 1;
    color: #b43403;
    color: rgba(180, 52, 3, var(--text-opacity));
  }
  .xl\\:active\\:text-orange-800:active {
    --text-opacity: 1;
    color: #8a2c0d;
    color: rgba(138, 44, 13, var(--text-opacity));
  }
  .xl\\:active\\:text-orange-900:active {
    --text-opacity: 1;
    color: #73230d;
    color: rgba(115, 35, 13, var(--text-opacity));
  }
  .xl\\:active\\:text-yellow-50:active {
    --text-opacity: 1;
    color: #fdfdea;
    color: rgba(253, 253, 234, var(--text-opacity));
  }
  .xl\\:active\\:text-yellow-100:active {
    --text-opacity: 1;
    color: #fdf6b2;
    color: rgba(253, 246, 178, var(--text-opacity));
  }
  .xl\\:active\\:text-yellow-200:active {
    --text-opacity: 1;
    color: #fce96a;
    color: rgba(252, 233, 106, var(--text-opacity));
  }
  .xl\\:active\\:text-yellow-300:active {
    --text-opacity: 1;
    color: #faca15;
    color: rgba(250, 202, 21, var(--text-opacity));
  }
  .xl\\:active\\:text-yellow-400:active {
    --text-opacity: 1;
    color: #e3a008;
    color: rgba(227, 160, 8, var(--text-opacity));
  }
  .xl\\:active\\:text-yellow-500:active {
    --text-opacity: 1;
    color: #c27803;
    color: rgba(194, 120, 3, var(--text-opacity));
  }
  .xl\\:active\\:text-yellow-600:active {
    --text-opacity: 1;
    color: #9f580a;
    color: rgba(159, 88, 10, var(--text-opacity));
  }
  .xl\\:active\\:text-yellow-700:active {
    --text-opacity: 1;
    color: #8e4b10;
    color: rgba(142, 75, 16, var(--text-opacity));
  }
  .xl\\:active\\:text-yellow-800:active {
    --text-opacity: 1;
    color: #723b13;
    color: rgba(114, 59, 19, var(--text-opacity));
  }
  .xl\\:active\\:text-yellow-900:active {
    --text-opacity: 1;
    color: #633112;
    color: rgba(99, 49, 18, var(--text-opacity));
  }
  .xl\\:active\\:text-green-50:active {
    --text-opacity: 1;
    color: #f3faf7;
    color: rgba(243, 250, 247, var(--text-opacity));
  }
  .xl\\:active\\:text-green-100:active {
    --text-opacity: 1;
    color: #def7ec;
    color: rgba(222, 247, 236, var(--text-opacity));
  }
  .xl\\:active\\:text-green-200:active {
    --text-opacity: 1;
    color: #bcf0da;
    color: rgba(188, 240, 218, var(--text-opacity));
  }
  .xl\\:active\\:text-green-300:active {
    --text-opacity: 1;
    color: #84e1bc;
    color: rgba(132, 225, 188, var(--text-opacity));
  }
  .xl\\:active\\:text-green-400:active {
    --text-opacity: 1;
    color: #31c48d;
    color: rgba(49, 196, 141, var(--text-opacity));
  }
  .xl\\:active\\:text-green-500:active {
    --text-opacity: 1;
    color: #0e9f6e;
    color: rgba(14, 159, 110, var(--text-opacity));
  }
  .xl\\:active\\:text-green-600:active {
    --text-opacity: 1;
    color: #057a55;
    color: rgba(5, 122, 85, var(--text-opacity));
  }
  .xl\\:active\\:text-green-700:active {
    --text-opacity: 1;
    color: #046c4e;
    color: rgba(4, 108, 78, var(--text-opacity));
  }
  .xl\\:active\\:text-green-800:active {
    --text-opacity: 1;
    color: #03543f;
    color: rgba(3, 84, 63, var(--text-opacity));
  }
  .xl\\:active\\:text-green-900:active {
    --text-opacity: 1;
    color: #014737;
    color: rgba(1, 71, 55, var(--text-opacity));
  }
  .xl\\:active\\:text-teal-50:active {
    --text-opacity: 1;
    color: #edfafa;
    color: rgba(237, 250, 250, var(--text-opacity));
  }
  .xl\\:active\\:text-teal-100:active {
    --text-opacity: 1;
    color: #d5f5f6;
    color: rgba(213, 245, 246, var(--text-opacity));
  }
  .xl\\:active\\:text-teal-200:active {
    --text-opacity: 1;
    color: #afecef;
    color: rgba(175, 236, 239, var(--text-opacity));
  }
  .xl\\:active\\:text-teal-300:active {
    --text-opacity: 1;
    color: #7edce2;
    color: rgba(126, 220, 226, var(--text-opacity));
  }
  .xl\\:active\\:text-teal-400:active {
    --text-opacity: 1;
    color: #16bdca;
    color: rgba(22, 189, 202, var(--text-opacity));
  }
  .xl\\:active\\:text-teal-500:active {
    --text-opacity: 1;
    color: #0694a2;
    color: rgba(6, 148, 162, var(--text-opacity));
  }
  .xl\\:active\\:text-teal-600:active {
    --text-opacity: 1;
    color: #047481;
    color: rgba(4, 116, 129, var(--text-opacity));
  }
  .xl\\:active\\:text-teal-700:active {
    --text-opacity: 1;
    color: #036672;
    color: rgba(3, 102, 114, var(--text-opacity));
  }
  .xl\\:active\\:text-teal-800:active {
    --text-opacity: 1;
    color: #05505c;
    color: rgba(5, 80, 92, var(--text-opacity));
  }
  .xl\\:active\\:text-teal-900:active {
    --text-opacity: 1;
    color: #014451;
    color: rgba(1, 68, 81, var(--text-opacity));
  }
  .xl\\:active\\:text-blue-50:active {
    --text-opacity: 1;
    color: #ebf5ff;
    color: rgba(235, 245, 255, var(--text-opacity));
  }
  .xl\\:active\\:text-blue-100:active {
    --text-opacity: 1;
    color: #e1effe;
    color: rgba(225, 239, 254, var(--text-opacity));
  }
  .xl\\:active\\:text-blue-200:active {
    --text-opacity: 1;
    color: #c3ddfd;
    color: rgba(195, 221, 253, var(--text-opacity));
  }
  .xl\\:active\\:text-blue-300:active {
    --text-opacity: 1;
    color: #a4cafe;
    color: rgba(164, 202, 254, var(--text-opacity));
  }
  .xl\\:active\\:text-blue-400:active {
    --text-opacity: 1;
    color: #76a9fa;
    color: rgba(118, 169, 250, var(--text-opacity));
  }
  .xl\\:active\\:text-blue-500:active {
    --text-opacity: 1;
    color: #3f83f8;
    color: rgba(63, 131, 248, var(--text-opacity));
  }
  .xl\\:active\\:text-blue-600:active {
    --text-opacity: 1;
    color: #1c64f2;
    color: rgba(28, 100, 242, var(--text-opacity));
  }
  .xl\\:active\\:text-blue-700:active {
    --text-opacity: 1;
    color: #1a56db;
    color: rgba(26, 86, 219, var(--text-opacity));
  }
  .xl\\:active\\:text-blue-800:active {
    --text-opacity: 1;
    color: #1e429f;
    color: rgba(30, 66, 159, var(--text-opacity));
  }
  .xl\\:active\\:text-blue-900:active {
    --text-opacity: 1;
    color: #233876;
    color: rgba(35, 56, 118, var(--text-opacity));
  }
  .xl\\:active\\:text-indigo-50:active {
    --text-opacity: 1;
    color: #f0f5ff;
    color: rgba(240, 245, 255, var(--text-opacity));
  }
  .xl\\:active\\:text-indigo-100:active {
    --text-opacity: 1;
    color: #e5edff;
    color: rgba(229, 237, 255, var(--text-opacity));
  }
  .xl\\:active\\:text-indigo-200:active {
    --text-opacity: 1;
    color: #cddbfe;
    color: rgba(205, 219, 254, var(--text-opacity));
  }
  .xl\\:active\\:text-indigo-300:active {
    --text-opacity: 1;
    color: #b4c6fc;
    color: rgba(180, 198, 252, var(--text-opacity));
  }
  .xl\\:active\\:text-indigo-400:active {
    --text-opacity: 1;
    color: #8da2fb;
    color: rgba(141, 162, 251, var(--text-opacity));
  }
  .xl\\:active\\:text-indigo-500:active {
    --text-opacity: 1;
    color: #6875f5;
    color: rgba(104, 117, 245, var(--text-opacity));
  }
  .xl\\:active\\:text-indigo-600:active {
    --text-opacity: 1;
    color: #5850ec;
    color: rgba(88, 80, 236, var(--text-opacity));
  }
  .xl\\:active\\:text-indigo-700:active {
    --text-opacity: 1;
    color: #5145cd;
    color: rgba(81, 69, 205, var(--text-opacity));
  }
  .xl\\:active\\:text-indigo-800:active {
    --text-opacity: 1;
    color: #42389d;
    color: rgba(66, 56, 157, var(--text-opacity));
  }
  .xl\\:active\\:text-indigo-900:active {
    --text-opacity: 1;
    color: #362f78;
    color: rgba(54, 47, 120, var(--text-opacity));
  }
  .xl\\:active\\:text-purple-50:active {
    --text-opacity: 1;
    color: #f6f5ff;
    color: rgba(246, 245, 255, var(--text-opacity));
  }
  .xl\\:active\\:text-purple-100:active {
    --text-opacity: 1;
    color: #edebfe;
    color: rgba(237, 235, 254, var(--text-opacity));
  }
  .xl\\:active\\:text-purple-200:active {
    --text-opacity: 1;
    color: #dcd7fe;
    color: rgba(220, 215, 254, var(--text-opacity));
  }
  .xl\\:active\\:text-purple-300:active {
    --text-opacity: 1;
    color: #cabffd;
    color: rgba(202, 191, 253, var(--text-opacity));
  }
  .xl\\:active\\:text-purple-400:active {
    --text-opacity: 1;
    color: #ac94fa;
    color: rgba(172, 148, 250, var(--text-opacity));
  }
  .xl\\:active\\:text-purple-500:active {
    --text-opacity: 1;
    color: #9061f9;
    color: rgba(144, 97, 249, var(--text-opacity));
  }
  .xl\\:active\\:text-purple-600:active {
    --text-opacity: 1;
    color: #7e3af2;
    color: rgba(126, 58, 242, var(--text-opacity));
  }
  .xl\\:active\\:text-purple-700:active {
    --text-opacity: 1;
    color: #6c2bd9;
    color: rgba(108, 43, 217, var(--text-opacity));
  }
  .xl\\:active\\:text-purple-800:active {
    --text-opacity: 1;
    color: #5521b5;
    color: rgba(85, 33, 181, var(--text-opacity));
  }
  .xl\\:active\\:text-purple-900:active {
    --text-opacity: 1;
    color: #4a1d96;
    color: rgba(74, 29, 150, var(--text-opacity));
  }
  .xl\\:active\\:text-pink-50:active {
    --text-opacity: 1;
    color: #fdf2f8;
    color: rgba(253, 242, 248, var(--text-opacity));
  }
  .xl\\:active\\:text-pink-100:active {
    --text-opacity: 1;
    color: #fce8f3;
    color: rgba(252, 232, 243, var(--text-opacity));
  }
  .xl\\:active\\:text-pink-200:active {
    --text-opacity: 1;
    color: #fad1e8;
    color: rgba(250, 209, 232, var(--text-opacity));
  }
  .xl\\:active\\:text-pink-300:active {
    --text-opacity: 1;
    color: #f8b4d9;
    color: rgba(248, 180, 217, var(--text-opacity));
  }
  .xl\\:active\\:text-pink-400:active {
    --text-opacity: 1;
    color: #f17eb8;
    color: rgba(241, 126, 184, var(--text-opacity));
  }
  .xl\\:active\\:text-pink-500:active {
    --text-opacity: 1;
    color: #e74694;
    color: rgba(231, 70, 148, var(--text-opacity));
  }
  .xl\\:active\\:text-pink-600:active {
    --text-opacity: 1;
    color: #d61f69;
    color: rgba(214, 31, 105, var(--text-opacity));
  }
  .xl\\:active\\:text-pink-700:active {
    --text-opacity: 1;
    color: #bf125d;
    color: rgba(191, 18, 93, var(--text-opacity));
  }
  .xl\\:active\\:text-pink-800:active {
    --text-opacity: 1;
    color: #99154b;
    color: rgba(153, 21, 75, var(--text-opacity));
  }
  .xl\\:active\\:text-pink-900:active {
    --text-opacity: 1;
    color: #751a3d;
    color: rgba(117, 26, 61, var(--text-opacity));
  }
  .xl\\:active\\:text-cool-gray-50:active {
    --text-opacity: 1;
    color: #f8fafc;
    color: rgba(248, 250, 252, var(--text-opacity));
  }
  .xl\\:active\\:text-cool-gray-100:active {
    --text-opacity: 1;
    color: #f1f5f9;
    color: rgba(241, 245, 249, var(--text-opacity));
  }
  .xl\\:active\\:text-cool-gray-200:active {
    --text-opacity: 1;
    color: #e2e8f0;
    color: rgba(226, 232, 240, var(--text-opacity));
  }
  .xl\\:active\\:text-cool-gray-300:active {
    --text-opacity: 1;
    color: #cfd8e3;
    color: rgba(207, 216, 227, var(--text-opacity));
  }
  .xl\\:active\\:text-cool-gray-400:active {
    --text-opacity: 1;
    color: #97a6ba;
    color: rgba(151, 166, 186, var(--text-opacity));
  }
  .xl\\:active\\:text-cool-gray-500:active {
    --text-opacity: 1;
    color: #64748b;
    color: rgba(100, 116, 139, var(--text-opacity));
  }
  .xl\\:active\\:text-cool-gray-600:active {
    --text-opacity: 1;
    color: #475569;
    color: rgba(71, 85, 105, var(--text-opacity));
  }
  .xl\\:active\\:text-cool-gray-700:active {
    --text-opacity: 1;
    color: #364152;
    color: rgba(54, 65, 82, var(--text-opacity));
  }
  .xl\\:active\\:text-cool-gray-800:active {
    --text-opacity: 1;
    color: #27303f;
    color: rgba(39, 48, 63, var(--text-opacity));
  }
  .xl\\:active\\:text-cool-gray-900:active {
    --text-opacity: 1;
    color: #1a202e;
    color: rgba(26, 32, 46, var(--text-opacity));
  }
  .xl\\:text-opacity-0 {
    --text-opacity: 0;
  }
  .xl\\:text-opacity-25 {
    --text-opacity: 0.25;
  }
  .xl\\:text-opacity-50 {
    --text-opacity: 0.5;
  }
  .xl\\:text-opacity-75 {
    --text-opacity: 0.75;
  }
  .xl\\:text-opacity-100 {
    --text-opacity: 1;
  }
  .xl\\:hover\\:text-opacity-0:hover {
    --text-opacity: 0;
  }
  .xl\\:hover\\:text-opacity-25:hover {
    --text-opacity: 0.25;
  }
  .xl\\:hover\\:text-opacity-50:hover {
    --text-opacity: 0.5;
  }
  .xl\\:hover\\:text-opacity-75:hover {
    --text-opacity: 0.75;
  }
  .xl\\:hover\\:text-opacity-100:hover {
    --text-opacity: 1;
  }
  .xl\\:focus\\:text-opacity-0:focus {
    --text-opacity: 0;
  }
  .xl\\:focus\\:text-opacity-25:focus {
    --text-opacity: 0.25;
  }
  .xl\\:focus\\:text-opacity-50:focus {
    --text-opacity: 0.5;
  }
  .xl\\:focus\\:text-opacity-75:focus {
    --text-opacity: 0.75;
  }
  .xl\\:focus\\:text-opacity-100:focus {
    --text-opacity: 1;
  }
  .xl\\:italic {
    font-style: italic;
  }
  .xl\\:not-italic {
    font-style: normal;
  }
  .xl\\:uppercase {
    text-transform: uppercase;
  }
  .xl\\:lowercase {
    text-transform: lowercase;
  }
  .xl\\:capitalize {
    text-transform: capitalize;
  }
  .xl\\:normal-case {
    text-transform: none;
  }
  .xl\\:underline {
    text-decoration: none;
  }
  .xl\\:line-through {
    text-decoration: line-through;
  }
  .xl\\:no-underline {
    text-decoration: none;
  }
  .group:hover .xl\\:group-hover\\:underline {
    text-decoration: none;
  }
  .group:hover .xl\\:group-hover\\:line-through {
    text-decoration: line-through;
  }
  .group:hover .xl\\:group-hover\\:no-underline {
    text-decoration: none;
  }
  .group:focus .xl\\:group-focus\\:underline {
    text-decoration: none;
  }
  .group:focus .xl\\:group-focus\\:line-through {
    text-decoration: line-through;
  }
  .group:focus .xl\\:group-focus\\:no-underline {
    text-decoration: none;
  }
  .xl\\:hover\\:underline:hover {
    text-decoration: none;
  }
  .xl\\:hover\\:line-through:hover {
    text-decoration: line-through;
  }
  .xl\\:hover\\:no-underline:hover {
    text-decoration: none;
  }
  .xl\\:focus\\:underline:focus {
    text-decoration: none;
  }
  .xl\\:focus\\:line-through:focus {
    text-decoration: line-through;
  }
  .xl\\:focus\\:no-underline:focus {
    text-decoration: none;
  }
  .xl\\:antialiased {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
  .xl\\:subpixel-antialiased {
    -webkit-font-smoothing: auto;
    -moz-osx-font-smoothing: auto;
  }
  .xl\\:ordinal, .xl\\:slashed-zero, .xl\\:lining-nums, .xl\\:oldstyle-nums, .xl\\:proportional-nums, .xl\\:tabular-nums, .xl\\:diagonal-fractions, .xl\\:stacked-fractions {
    --font-variant-numeric-ordinal: var(--tailwind-empty,
        /*!*/
        /*!*/
      );
    --font-variant-numeric-slashed-zero: var(--tailwind-empty,
        /*!*/
        /*!*/
      );
    --font-variant-numeric-figure: var(--tailwind-empty,
        /*!*/
        /*!*/
      );
    --font-variant-numeric-spacing: var(--tailwind-empty,
        /*!*/
        /*!*/
      );
    --font-variant-numeric-fraction: var(--tailwind-empty,
        /*!*/
        /*!*/
      );
    font-variant-numeric: var(--font-variant-numeric-ordinal) var(--font-variant-numeric-slashed-zero) var(--font-variant-numeric-figure) var(--font-variant-numeric-spacing) var(--font-variant-numeric-fraction);
  }
  .xl\\:normal-nums {
    font-variant-numeric: normal;
  }
  .xl\\:ordinal {
    --font-variant-numeric-ordinal: ordinal;
  }
  .xl\\:slashed-zero {
    --font-variant-numeric-slashed-zero: slashed-zero;
  }
  .xl\\:lining-nums {
    --font-variant-numeric-figure: lining-nums;
  }
  .xl\\:oldstyle-nums {
    --font-variant-numeric-figure: oldstyle-nums;
  }
  .xl\\:proportional-nums {
    --font-variant-numeric-spacing: proportional-nums;
  }
  .xl\\:tabular-nums {
    --font-variant-numeric-spacing: tabular-nums;
  }
  .xl\\:diagonal-fractions {
    --font-variant-numeric-fraction: diagonal-fractions;
  }
  .xl\\:stacked-fractions {
    --font-variant-numeric-fraction: stacked-fractions;
  }
  .xl\\:tracking-tighter {
    letter-spacing: -0.05em;
  }
  .xl\\:tracking-tight {
    letter-spacing: -0.025em;
  }
  .xl\\:tracking-normal {
    letter-spacing: 0;
  }
  .xl\\:tracking-wide {
    letter-spacing: 0.025em;
  }
  .xl\\:tracking-wider {
    letter-spacing: 0.05em;
  }
  .xl\\:tracking-widest {
    letter-spacing: 0.1em;
  }
  .xl\\:select-none {
    -webkit-user-select: none;
    user-select: none;
  }
  .xl\\:select-text {
    -webkit-user-select: text;
    user-select: text;
  }
  .xl\\:select-all {
    -webkit-user-select: all;
    user-select: all;
  }
  .xl\\:select-auto {
    -webkit-user-select: auto;
    user-select: auto;
  }
  .xl\\:align-baseline {
    vertical-align: baseline;
  }
  .xl\\:align-top {
    vertical-align: top;
  }
  .xl\\:align-middle {
    vertical-align: middle;
  }
  .xl\\:align-bottom {
    vertical-align: bottom;
  }
  .xl\\:align-text-top {
    vertical-align: text-top;
  }
  .xl\\:align-text-bottom {
    vertical-align: text-bottom;
  }
  .xl\\:visible {
    visibility: visible;
  }
  .xl\\:invisible {
    visibility: hidden;
  }
  .xl\\:whitespace-normal {
    white-space: normal;
  }
  .xl\\:whitespace-no-wrap {
    white-space: nowrap;
  }
  .xl\\:whitespace-pre {
    white-space: pre;
  }
  .xl\\:whitespace-pre-line {
    white-space: pre-line;
  }
  .xl\\:whitespace-pre-wrap {
    white-space: pre-wrap;
  }
  .xl\\:break-normal {
    word-wrap: normal;
    overflow-wrap: normal;
    word-break: normal;
  }
  .xl\\:break-words {
    word-wrap: break-word;
    overflow-wrap: break-word;
  }
  .xl\\:break-all {
    word-break: break-all;
  }
  .xl\\:truncate {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .xl\\:w-0 {
    width: 0;
  }
  .xl\\:w-1 {
    width: 0.25rem;
  }
  .xl\\:w-2 {
    width: 0.5rem;
  }
  .xl\\:w-3 {
    width: 0.75rem;
  }
  .xl\\:w-4 {
    width: 1rem;
  }
  .xl\\:w-5 {
    width: 1.25rem;
  }
  .xl\\:w-6 {
    width: 1.5rem;
  }
  .xl\\:w-7 {
    width: 1.75rem;
  }
  .xl\\:w-8 {
    width: 2rem;
  }
  .xl\\:w-9 {
    width: 2.25rem;
  }
  .xl\\:w-10 {
    width: 2.5rem;
  }
  .xl\\:w-11 {
    width: 2.75rem;
  }
  .xl\\:w-12 {
    width: 3rem;
  }
  .xl\\:w-13 {
    width: 3.25rem;
  }
  .xl\\:w-14 {
    width: 3.5rem;
  }
  .xl\\:w-15 {
    width: 3.75rem;
  }
  .xl\\:w-16 {
    width: 4rem;
  }
  .xl\\:w-20 {
    width: 5rem;
  }
  .xl\\:w-24 {
    width: 6rem;
  }
  .xl\\:w-28 {
    width: 7rem;
  }
  .xl\\:w-32 {
    width: 8rem;
  }
  .xl\\:w-36 {
    width: 9rem;
  }
  .xl\\:w-40 {
    width: 10rem;
  }
  .xl\\:w-44 {
    width: 11rem;
  }
  .xl\\:w-48 {
    width: 12rem;
  }
  .xl\\:w-52 {
    width: 13rem;
  }
  .xl\\:w-56 {
    width: 14rem;
  }
  .xl\\:w-60 {
    width: 15rem;
  }
  .xl\\:w-64 {
    width: 16rem;
  }
  .xl\\:w-72 {
    width: 18rem;
  }
  .xl\\:w-80 {
    width: 20rem;
  }
  .xl\\:w-96 {
    width: 24rem;
  }
  .xl\\:w-auto {
    width: auto;
  }
  .xl\\:w-px {
    width: 1px;
  }
  .xl\\:w-0\\.5 {
    width: 0.125rem;
  }
  .xl\\:w-1\\.5 {
    width: 0.375rem;
  }
  .xl\\:w-2\\.5 {
    width: 0.625rem;
  }
  .xl\\:w-3\\.5 {
    width: 0.875rem;
  }
  .xl\\:w-1\\/2 {
    width: 50%;
  }
  .xl\\:w-1\\/3 {
    width: 33.333333%;
  }
  .xl\\:w-2\\/3 {
    width: 66.666667%;
  }
  .xl\\:w-1\\/4 {
    width: 25%;
  }
  .xl\\:w-2\\/4 {
    width: 50%;
  }
  .xl\\:w-3\\/4 {
    width: 75%;
  }
  .xl\\:w-1\\/5 {
    width: 20%;
  }
  .xl\\:w-2\\/5 {
    width: 40%;
  }
  .xl\\:w-3\\/5 {
    width: 60%;
  }
  .xl\\:w-4\\/5 {
    width: 80%;
  }
  .xl\\:w-1\\/6 {
    width: 16.666667%;
  }
  .xl\\:w-2\\/6 {
    width: 33.333333%;
  }
  .xl\\:w-3\\/6 {
    width: 50%;
  }
  .xl\\:w-4\\/6 {
    width: 66.666667%;
  }
  .xl\\:w-5\\/6 {
    width: 83.333333%;
  }
  .xl\\:w-1\\/12 {
    width: 8.333333%;
  }
  .xl\\:w-2\\/12 {
    width: 16.666667%;
  }
  .xl\\:w-3\\/12 {
    width: 25%;
  }
  .xl\\:w-4\\/12 {
    width: 33.333333%;
  }
  .xl\\:w-5\\/12 {
    width: 41.666667%;
  }
  .xl\\:w-6\\/12 {
    width: 50%;
  }
  .xl\\:w-7\\/12 {
    width: 58.333333%;
  }
  .xl\\:w-8\\/12 {
    width: 66.666667%;
  }
  .xl\\:w-9\\/12 {
    width: 75%;
  }
  .xl\\:w-10\\/12 {
    width: 83.333333%;
  }
  .xl\\:w-11\\/12 {
    width: 91.666667%;
  }
  .xl\\:w-full {
    width: 100%;
  }
  .xl\\:w-screen {
    width: 100vw;
  }
  .xl\\:w-min-content {
    width: min-content;
  }
  .xl\\:w-max-content {
    width: max-content;
  }
  .xl\\:z-0 {
    z-index: 0;
  }
  .xl\\:z-10 {
    z-index: 10;
  }
  .xl\\:z-20 {
    z-index: 20;
  }
  .xl\\:z-30 {
    z-index: 30;
  }
  .xl\\:z-40 {
    z-index: 40;
  }
  .xl\\:z-50 {
    z-index: 50;
  }
  .xl\\:z-auto {
    z-index: auto;
  }
  .xl\\:focus-within\\:z-0:focus-within {
    z-index: 0;
  }
  .xl\\:focus-within\\:z-10:focus-within {
    z-index: 10;
  }
  .xl\\:focus-within\\:z-20:focus-within {
    z-index: 20;
  }
  .xl\\:focus-within\\:z-30:focus-within {
    z-index: 30;
  }
  .xl\\:focus-within\\:z-40:focus-within {
    z-index: 40;
  }
  .xl\\:focus-within\\:z-50:focus-within {
    z-index: 50;
  }
  .xl\\:focus-within\\:z-auto:focus-within {
    z-index: auto;
  }
  .xl\\:focus\\:z-0:focus {
    z-index: 0;
  }
  .xl\\:focus\\:z-10:focus {
    z-index: 10;
  }
  .xl\\:focus\\:z-20:focus {
    z-index: 20;
  }
  .xl\\:focus\\:z-30:focus {
    z-index: 30;
  }
  .xl\\:focus\\:z-40:focus {
    z-index: 40;
  }
  .xl\\:focus\\:z-50:focus {
    z-index: 50;
  }
  .xl\\:focus\\:z-auto:focus {
    z-index: auto;
  }
  .xl\\:gap-0 {
    grid-gap: 0;
    gap: 0;
  }
  .xl\\:gap-1 {
    grid-gap: 0.25rem;
    gap: 0.25rem;
  }
  .xl\\:gap-2 {
    grid-gap: 0.5rem;
    gap: 0.5rem;
  }
  .xl\\:gap-3 {
    grid-gap: 0.75rem;
    gap: 0.75rem;
  }
  .xl\\:gap-4 {
    grid-gap: 1rem;
    gap: 1rem;
  }
  .xl\\:gap-5 {
    grid-gap: 1.25rem;
    gap: 1.25rem;
  }
  .xl\\:gap-6 {
    grid-gap: 1.5rem;
    gap: 1.5rem;
  }
  .xl\\:gap-7 {
    grid-gap: 1.75rem;
    gap: 1.75rem;
  }
  .xl\\:gap-8 {
    grid-gap: 2rem;
    gap: 2rem;
  }
  .xl\\:gap-9 {
    grid-gap: 2.25rem;
    gap: 2.25rem;
  }
  .xl\\:gap-10 {
    grid-gap: 2.5rem;
    gap: 2.5rem;
  }
  .xl\\:gap-11 {
    grid-gap: 2.75rem;
    gap: 2.75rem;
  }
  .xl\\:gap-12 {
    grid-gap: 3rem;
    gap: 3rem;
  }
  .xl\\:gap-13 {
    grid-gap: 3.25rem;
    gap: 3.25rem;
  }
  .xl\\:gap-14 {
    grid-gap: 3.5rem;
    gap: 3.5rem;
  }
  .xl\\:gap-15 {
    grid-gap: 3.75rem;
    gap: 3.75rem;
  }
  .xl\\:gap-16 {
    grid-gap: 4rem;
    gap: 4rem;
  }
  .xl\\:gap-20 {
    grid-gap: 5rem;
    gap: 5rem;
  }
  .xl\\:gap-24 {
    grid-gap: 6rem;
    gap: 6rem;
  }
  .xl\\:gap-28 {
    grid-gap: 7rem;
    gap: 7rem;
  }
  .xl\\:gap-32 {
    grid-gap: 8rem;
    gap: 8rem;
  }
  .xl\\:gap-36 {
    grid-gap: 9rem;
    gap: 9rem;
  }
  .xl\\:gap-40 {
    grid-gap: 10rem;
    gap: 10rem;
  }
  .xl\\:gap-44 {
    grid-gap: 11rem;
    gap: 11rem;
  }
  .xl\\:gap-48 {
    grid-gap: 12rem;
    gap: 12rem;
  }
  .xl\\:gap-52 {
    grid-gap: 13rem;
    gap: 13rem;
  }
  .xl\\:gap-56 {
    grid-gap: 14rem;
    gap: 14rem;
  }
  .xl\\:gap-60 {
    grid-gap: 15rem;
    gap: 15rem;
  }
  .xl\\:gap-64 {
    grid-gap: 16rem;
    gap: 16rem;
  }
  .xl\\:gap-72 {
    grid-gap: 18rem;
    gap: 18rem;
  }
  .xl\\:gap-80 {
    grid-gap: 20rem;
    gap: 20rem;
  }
  .xl\\:gap-96 {
    grid-gap: 24rem;
    gap: 24rem;
  }
  .xl\\:gap-px {
    grid-gap: 1px;
    gap: 1px;
  }
  .xl\\:gap-0\\.5 {
    grid-gap: 0.125rem;
    gap: 0.125rem;
  }
  .xl\\:gap-1\\.5 {
    grid-gap: 0.375rem;
    gap: 0.375rem;
  }
  .xl\\:gap-2\\.5 {
    grid-gap: 0.625rem;
    gap: 0.625rem;
  }
  .xl\\:gap-3\\.5 {
    grid-gap: 0.875rem;
    gap: 0.875rem;
  }
  .xl\\:gap-1\\/2 {
    grid-gap: 50%;
    gap: 50%;
  }
  .xl\\:gap-1\\/3 {
    grid-gap: 33.333333%;
    gap: 33.333333%;
  }
  .xl\\:gap-2\\/3 {
    grid-gap: 66.666667%;
    gap: 66.666667%;
  }
  .xl\\:gap-1\\/4 {
    grid-gap: 25%;
    gap: 25%;
  }
  .xl\\:gap-2\\/4 {
    grid-gap: 50%;
    gap: 50%;
  }
  .xl\\:gap-3\\/4 {
    grid-gap: 75%;
    gap: 75%;
  }
  .xl\\:gap-1\\/5 {
    grid-gap: 20%;
    gap: 20%;
  }
  .xl\\:gap-2\\/5 {
    grid-gap: 40%;
    gap: 40%;
  }
  .xl\\:gap-3\\/5 {
    grid-gap: 60%;
    gap: 60%;
  }
  .xl\\:gap-4\\/5 {
    grid-gap: 80%;
    gap: 80%;
  }
  .xl\\:gap-1\\/6 {
    grid-gap: 16.666667%;
    gap: 16.666667%;
  }
  .xl\\:gap-2\\/6 {
    grid-gap: 33.333333%;
    gap: 33.333333%;
  }
  .xl\\:gap-3\\/6 {
    grid-gap: 50%;
    gap: 50%;
  }
  .xl\\:gap-4\\/6 {
    grid-gap: 66.666667%;
    gap: 66.666667%;
  }
  .xl\\:gap-5\\/6 {
    grid-gap: 83.333333%;
    gap: 83.333333%;
  }
  .xl\\:gap-1\\/12 {
    grid-gap: 8.333333%;
    gap: 8.333333%;
  }
  .xl\\:gap-2\\/12 {
    grid-gap: 16.666667%;
    gap: 16.666667%;
  }
  .xl\\:gap-3\\/12 {
    grid-gap: 25%;
    gap: 25%;
  }
  .xl\\:gap-4\\/12 {
    grid-gap: 33.333333%;
    gap: 33.333333%;
  }
  .xl\\:gap-5\\/12 {
    grid-gap: 41.666667%;
    gap: 41.666667%;
  }
  .xl\\:gap-6\\/12 {
    grid-gap: 50%;
    gap: 50%;
  }
  .xl\\:gap-7\\/12 {
    grid-gap: 58.333333%;
    gap: 58.333333%;
  }
  .xl\\:gap-8\\/12 {
    grid-gap: 66.666667%;
    gap: 66.666667%;
  }
  .xl\\:gap-9\\/12 {
    grid-gap: 75%;
    gap: 75%;
  }
  .xl\\:gap-10\\/12 {
    grid-gap: 83.333333%;
    gap: 83.333333%;
  }
  .xl\\:gap-11\\/12 {
    grid-gap: 91.666667%;
    gap: 91.666667%;
  }
  .xl\\:gap-full {
    grid-gap: 100%;
    gap: 100%;
  }
  .xl\\:col-gap-0 {
    grid-column-gap: 0;
    column-gap: 0;
  }
  .xl\\:col-gap-1 {
    grid-column-gap: 0.25rem;
    column-gap: 0.25rem;
  }
  .xl\\:col-gap-2 {
    grid-column-gap: 0.5rem;
    column-gap: 0.5rem;
  }
  .xl\\:col-gap-3 {
    grid-column-gap: 0.75rem;
    column-gap: 0.75rem;
  }
  .xl\\:col-gap-4 {
    grid-column-gap: 1rem;
    column-gap: 1rem;
  }
  .xl\\:col-gap-5 {
    grid-column-gap: 1.25rem;
    column-gap: 1.25rem;
  }
  .xl\\:col-gap-6 {
    grid-column-gap: 1.5rem;
    column-gap: 1.5rem;
  }
  .xl\\:col-gap-7 {
    grid-column-gap: 1.75rem;
    column-gap: 1.75rem;
  }
  .xl\\:col-gap-8 {
    grid-column-gap: 2rem;
    column-gap: 2rem;
  }
  .xl\\:col-gap-9 {
    grid-column-gap: 2.25rem;
    column-gap: 2.25rem;
  }
  .xl\\:col-gap-10 {
    grid-column-gap: 2.5rem;
    column-gap: 2.5rem;
  }
  .xl\\:col-gap-11 {
    grid-column-gap: 2.75rem;
    column-gap: 2.75rem;
  }
  .xl\\:col-gap-12 {
    grid-column-gap: 3rem;
    column-gap: 3rem;
  }
  .xl\\:col-gap-13 {
    grid-column-gap: 3.25rem;
    column-gap: 3.25rem;
  }
  .xl\\:col-gap-14 {
    grid-column-gap: 3.5rem;
    column-gap: 3.5rem;
  }
  .xl\\:col-gap-15 {
    grid-column-gap: 3.75rem;
    column-gap: 3.75rem;
  }
  .xl\\:col-gap-16 {
    grid-column-gap: 4rem;
    column-gap: 4rem;
  }
  .xl\\:col-gap-20 {
    grid-column-gap: 5rem;
    column-gap: 5rem;
  }
  .xl\\:col-gap-24 {
    grid-column-gap: 6rem;
    column-gap: 6rem;
  }
  .xl\\:col-gap-28 {
    grid-column-gap: 7rem;
    column-gap: 7rem;
  }
  .xl\\:col-gap-32 {
    grid-column-gap: 8rem;
    column-gap: 8rem;
  }
  .xl\\:col-gap-36 {
    grid-column-gap: 9rem;
    column-gap: 9rem;
  }
  .xl\\:col-gap-40 {
    grid-column-gap: 10rem;
    column-gap: 10rem;
  }
  .xl\\:col-gap-44 {
    grid-column-gap: 11rem;
    column-gap: 11rem;
  }
  .xl\\:col-gap-48 {
    grid-column-gap: 12rem;
    column-gap: 12rem;
  }
  .xl\\:col-gap-52 {
    grid-column-gap: 13rem;
    column-gap: 13rem;
  }
  .xl\\:col-gap-56 {
    grid-column-gap: 14rem;
    column-gap: 14rem;
  }
  .xl\\:col-gap-60 {
    grid-column-gap: 15rem;
    column-gap: 15rem;
  }
  .xl\\:col-gap-64 {
    grid-column-gap: 16rem;
    column-gap: 16rem;
  }
  .xl\\:col-gap-72 {
    grid-column-gap: 18rem;
    column-gap: 18rem;
  }
  .xl\\:col-gap-80 {
    grid-column-gap: 20rem;
    column-gap: 20rem;
  }
  .xl\\:col-gap-96 {
    grid-column-gap: 24rem;
    column-gap: 24rem;
  }
  .xl\\:col-gap-px {
    grid-column-gap: 1px;
    column-gap: 1px;
  }
  .xl\\:col-gap-0\\.5 {
    grid-column-gap: 0.125rem;
    column-gap: 0.125rem;
  }
  .xl\\:col-gap-1\\.5 {
    grid-column-gap: 0.375rem;
    column-gap: 0.375rem;
  }
  .xl\\:col-gap-2\\.5 {
    grid-column-gap: 0.625rem;
    column-gap: 0.625rem;
  }
  .xl\\:col-gap-3\\.5 {
    grid-column-gap: 0.875rem;
    column-gap: 0.875rem;
  }
  .xl\\:col-gap-1\\/2 {
    grid-column-gap: 50%;
    column-gap: 50%;
  }
  .xl\\:col-gap-1\\/3 {
    grid-column-gap: 33.333333%;
    column-gap: 33.333333%;
  }
  .xl\\:col-gap-2\\/3 {
    grid-column-gap: 66.666667%;
    column-gap: 66.666667%;
  }
  .xl\\:col-gap-1\\/4 {
    grid-column-gap: 25%;
    column-gap: 25%;
  }
  .xl\\:col-gap-2\\/4 {
    grid-column-gap: 50%;
    column-gap: 50%;
  }
  .xl\\:col-gap-3\\/4 {
    grid-column-gap: 75%;
    column-gap: 75%;
  }
  .xl\\:col-gap-1\\/5 {
    grid-column-gap: 20%;
    column-gap: 20%;
  }
  .xl\\:col-gap-2\\/5 {
    grid-column-gap: 40%;
    column-gap: 40%;
  }
  .xl\\:col-gap-3\\/5 {
    grid-column-gap: 60%;
    column-gap: 60%;
  }
  .xl\\:col-gap-4\\/5 {
    grid-column-gap: 80%;
    column-gap: 80%;
  }
  .xl\\:col-gap-1\\/6 {
    grid-column-gap: 16.666667%;
    column-gap: 16.666667%;
  }
  .xl\\:col-gap-2\\/6 {
    grid-column-gap: 33.333333%;
    column-gap: 33.333333%;
  }
  .xl\\:col-gap-3\\/6 {
    grid-column-gap: 50%;
    column-gap: 50%;
  }
  .xl\\:col-gap-4\\/6 {
    grid-column-gap: 66.666667%;
    column-gap: 66.666667%;
  }
  .xl\\:col-gap-5\\/6 {
    grid-column-gap: 83.333333%;
    column-gap: 83.333333%;
  }
  .xl\\:col-gap-1\\/12 {
    grid-column-gap: 8.333333%;
    column-gap: 8.333333%;
  }
  .xl\\:col-gap-2\\/12 {
    grid-column-gap: 16.666667%;
    column-gap: 16.666667%;
  }
  .xl\\:col-gap-3\\/12 {
    grid-column-gap: 25%;
    column-gap: 25%;
  }
  .xl\\:col-gap-4\\/12 {
    grid-column-gap: 33.333333%;
    column-gap: 33.333333%;
  }
  .xl\\:col-gap-5\\/12 {
    grid-column-gap: 41.666667%;
    column-gap: 41.666667%;
  }
  .xl\\:col-gap-6\\/12 {
    grid-column-gap: 50%;
    column-gap: 50%;
  }
  .xl\\:col-gap-7\\/12 {
    grid-column-gap: 58.333333%;
    column-gap: 58.333333%;
  }
  .xl\\:col-gap-8\\/12 {
    grid-column-gap: 66.666667%;
    column-gap: 66.666667%;
  }
  .xl\\:col-gap-9\\/12 {
    grid-column-gap: 75%;
    column-gap: 75%;
  }
  .xl\\:col-gap-10\\/12 {
    grid-column-gap: 83.333333%;
    column-gap: 83.333333%;
  }
  .xl\\:col-gap-11\\/12 {
    grid-column-gap: 91.666667%;
    column-gap: 91.666667%;
  }
  .xl\\:col-gap-full {
    grid-column-gap: 100%;
    column-gap: 100%;
  }
  .xl\\:gap-x-0 {
    grid-column-gap: 0;
    column-gap: 0;
  }
  .xl\\:gap-x-1 {
    grid-column-gap: 0.25rem;
    column-gap: 0.25rem;
  }
  .xl\\:gap-x-2 {
    grid-column-gap: 0.5rem;
    column-gap: 0.5rem;
  }
  .xl\\:gap-x-3 {
    grid-column-gap: 0.75rem;
    column-gap: 0.75rem;
  }
  .xl\\:gap-x-4 {
    grid-column-gap: 1rem;
    column-gap: 1rem;
  }
  .xl\\:gap-x-5 {
    grid-column-gap: 1.25rem;
    column-gap: 1.25rem;
  }
  .xl\\:gap-x-6 {
    grid-column-gap: 1.5rem;
    column-gap: 1.5rem;
  }
  .xl\\:gap-x-7 {
    grid-column-gap: 1.75rem;
    column-gap: 1.75rem;
  }
  .xl\\:gap-x-8 {
    grid-column-gap: 2rem;
    column-gap: 2rem;
  }
  .xl\\:gap-x-9 {
    grid-column-gap: 2.25rem;
    column-gap: 2.25rem;
  }
  .xl\\:gap-x-10 {
    grid-column-gap: 2.5rem;
    column-gap: 2.5rem;
  }
  .xl\\:gap-x-11 {
    grid-column-gap: 2.75rem;
    column-gap: 2.75rem;
  }
  .xl\\:gap-x-12 {
    grid-column-gap: 3rem;
    column-gap: 3rem;
  }
  .xl\\:gap-x-13 {
    grid-column-gap: 3.25rem;
    column-gap: 3.25rem;
  }
  .xl\\:gap-x-14 {
    grid-column-gap: 3.5rem;
    column-gap: 3.5rem;
  }
  .xl\\:gap-x-15 {
    grid-column-gap: 3.75rem;
    column-gap: 3.75rem;
  }
  .xl\\:gap-x-16 {
    grid-column-gap: 4rem;
    column-gap: 4rem;
  }
  .xl\\:gap-x-20 {
    grid-column-gap: 5rem;
    column-gap: 5rem;
  }
  .xl\\:gap-x-24 {
    grid-column-gap: 6rem;
    column-gap: 6rem;
  }
  .xl\\:gap-x-28 {
    grid-column-gap: 7rem;
    column-gap: 7rem;
  }
  .xl\\:gap-x-32 {
    grid-column-gap: 8rem;
    column-gap: 8rem;
  }
  .xl\\:gap-x-36 {
    grid-column-gap: 9rem;
    column-gap: 9rem;
  }
  .xl\\:gap-x-40 {
    grid-column-gap: 10rem;
    column-gap: 10rem;
  }
  .xl\\:gap-x-44 {
    grid-column-gap: 11rem;
    column-gap: 11rem;
  }
  .xl\\:gap-x-48 {
    grid-column-gap: 12rem;
    column-gap: 12rem;
  }
  .xl\\:gap-x-52 {
    grid-column-gap: 13rem;
    column-gap: 13rem;
  }
  .xl\\:gap-x-56 {
    grid-column-gap: 14rem;
    column-gap: 14rem;
  }
  .xl\\:gap-x-60 {
    grid-column-gap: 15rem;
    column-gap: 15rem;
  }
  .xl\\:gap-x-64 {
    grid-column-gap: 16rem;
    column-gap: 16rem;
  }
  .xl\\:gap-x-72 {
    grid-column-gap: 18rem;
    column-gap: 18rem;
  }
  .xl\\:gap-x-80 {
    grid-column-gap: 20rem;
    column-gap: 20rem;
  }
  .xl\\:gap-x-96 {
    grid-column-gap: 24rem;
    column-gap: 24rem;
  }
  .xl\\:gap-x-px {
    grid-column-gap: 1px;
    column-gap: 1px;
  }
  .xl\\:gap-x-0\\.5 {
    grid-column-gap: 0.125rem;
    column-gap: 0.125rem;
  }
  .xl\\:gap-x-1\\.5 {
    grid-column-gap: 0.375rem;
    column-gap: 0.375rem;
  }
  .xl\\:gap-x-2\\.5 {
    grid-column-gap: 0.625rem;
    column-gap: 0.625rem;
  }
  .xl\\:gap-x-3\\.5 {
    grid-column-gap: 0.875rem;
    column-gap: 0.875rem;
  }
  .xl\\:gap-x-1\\/2 {
    grid-column-gap: 50%;
    column-gap: 50%;
  }
  .xl\\:gap-x-1\\/3 {
    grid-column-gap: 33.333333%;
    column-gap: 33.333333%;
  }
  .xl\\:gap-x-2\\/3 {
    grid-column-gap: 66.666667%;
    column-gap: 66.666667%;
  }
  .xl\\:gap-x-1\\/4 {
    grid-column-gap: 25%;
    column-gap: 25%;
  }
  .xl\\:gap-x-2\\/4 {
    grid-column-gap: 50%;
    column-gap: 50%;
  }
  .xl\\:gap-x-3\\/4 {
    grid-column-gap: 75%;
    column-gap: 75%;
  }
  .xl\\:gap-x-1\\/5 {
    grid-column-gap: 20%;
    column-gap: 20%;
  }
  .xl\\:gap-x-2\\/5 {
    grid-column-gap: 40%;
    column-gap: 40%;
  }
  .xl\\:gap-x-3\\/5 {
    grid-column-gap: 60%;
    column-gap: 60%;
  }
  .xl\\:gap-x-4\\/5 {
    grid-column-gap: 80%;
    column-gap: 80%;
  }
  .xl\\:gap-x-1\\/6 {
    grid-column-gap: 16.666667%;
    column-gap: 16.666667%;
  }
  .xl\\:gap-x-2\\/6 {
    grid-column-gap: 33.333333%;
    column-gap: 33.333333%;
  }
  .xl\\:gap-x-3\\/6 {
    grid-column-gap: 50%;
    column-gap: 50%;
  }
  .xl\\:gap-x-4\\/6 {
    grid-column-gap: 66.666667%;
    column-gap: 66.666667%;
  }
  .xl\\:gap-x-5\\/6 {
    grid-column-gap: 83.333333%;
    column-gap: 83.333333%;
  }
  .xl\\:gap-x-1\\/12 {
    grid-column-gap: 8.333333%;
    column-gap: 8.333333%;
  }
  .xl\\:gap-x-2\\/12 {
    grid-column-gap: 16.666667%;
    column-gap: 16.666667%;
  }
  .xl\\:gap-x-3\\/12 {
    grid-column-gap: 25%;
    column-gap: 25%;
  }
  .xl\\:gap-x-4\\/12 {
    grid-column-gap: 33.333333%;
    column-gap: 33.333333%;
  }
  .xl\\:gap-x-5\\/12 {
    grid-column-gap: 41.666667%;
    column-gap: 41.666667%;
  }
  .xl\\:gap-x-6\\/12 {
    grid-column-gap: 50%;
    column-gap: 50%;
  }
  .xl\\:gap-x-7\\/12 {
    grid-column-gap: 58.333333%;
    column-gap: 58.333333%;
  }
  .xl\\:gap-x-8\\/12 {
    grid-column-gap: 66.666667%;
    column-gap: 66.666667%;
  }
  .xl\\:gap-x-9\\/12 {
    grid-column-gap: 75%;
    column-gap: 75%;
  }
  .xl\\:gap-x-10\\/12 {
    grid-column-gap: 83.333333%;
    column-gap: 83.333333%;
  }
  .xl\\:gap-x-11\\/12 {
    grid-column-gap: 91.666667%;
    column-gap: 91.666667%;
  }
  .xl\\:gap-x-full {
    grid-column-gap: 100%;
    column-gap: 100%;
  }
  .xl\\:row-gap-0 {
    grid-row-gap: 0;
    row-gap: 0;
  }
  .xl\\:row-gap-1 {
    grid-row-gap: 0.25rem;
    row-gap: 0.25rem;
  }
  .xl\\:row-gap-2 {
    grid-row-gap: 0.5rem;
    row-gap: 0.5rem;
  }
  .xl\\:row-gap-3 {
    grid-row-gap: 0.75rem;
    row-gap: 0.75rem;
  }
  .xl\\:row-gap-4 {
    grid-row-gap: 1rem;
    row-gap: 1rem;
  }
  .xl\\:row-gap-5 {
    grid-row-gap: 1.25rem;
    row-gap: 1.25rem;
  }
  .xl\\:row-gap-6 {
    grid-row-gap: 1.5rem;
    row-gap: 1.5rem;
  }
  .xl\\:row-gap-7 {
    grid-row-gap: 1.75rem;
    row-gap: 1.75rem;
  }
  .xl\\:row-gap-8 {
    grid-row-gap: 2rem;
    row-gap: 2rem;
  }
  .xl\\:row-gap-9 {
    grid-row-gap: 2.25rem;
    row-gap: 2.25rem;
  }
  .xl\\:row-gap-10 {
    grid-row-gap: 2.5rem;
    row-gap: 2.5rem;
  }
  .xl\\:row-gap-11 {
    grid-row-gap: 2.75rem;
    row-gap: 2.75rem;
  }
  .xl\\:row-gap-12 {
    grid-row-gap: 3rem;
    row-gap: 3rem;
  }
  .xl\\:row-gap-13 {
    grid-row-gap: 3.25rem;
    row-gap: 3.25rem;
  }
  .xl\\:row-gap-14 {
    grid-row-gap: 3.5rem;
    row-gap: 3.5rem;
  }
  .xl\\:row-gap-15 {
    grid-row-gap: 3.75rem;
    row-gap: 3.75rem;
  }
  .xl\\:row-gap-16 {
    grid-row-gap: 4rem;
    row-gap: 4rem;
  }
  .xl\\:row-gap-20 {
    grid-row-gap: 5rem;
    row-gap: 5rem;
  }
  .xl\\:row-gap-24 {
    grid-row-gap: 6rem;
    row-gap: 6rem;
  }
  .xl\\:row-gap-28 {
    grid-row-gap: 7rem;
    row-gap: 7rem;
  }
  .xl\\:row-gap-32 {
    grid-row-gap: 8rem;
    row-gap: 8rem;
  }
  .xl\\:row-gap-36 {
    grid-row-gap: 9rem;
    row-gap: 9rem;
  }
  .xl\\:row-gap-40 {
    grid-row-gap: 10rem;
    row-gap: 10rem;
  }
  .xl\\:row-gap-44 {
    grid-row-gap: 11rem;
    row-gap: 11rem;
  }
  .xl\\:row-gap-48 {
    grid-row-gap: 12rem;
    row-gap: 12rem;
  }
  .xl\\:row-gap-52 {
    grid-row-gap: 13rem;
    row-gap: 13rem;
  }
  .xl\\:row-gap-56 {
    grid-row-gap: 14rem;
    row-gap: 14rem;
  }
  .xl\\:row-gap-60 {
    grid-row-gap: 15rem;
    row-gap: 15rem;
  }
  .xl\\:row-gap-64 {
    grid-row-gap: 16rem;
    row-gap: 16rem;
  }
  .xl\\:row-gap-72 {
    grid-row-gap: 18rem;
    row-gap: 18rem;
  }
  .xl\\:row-gap-80 {
    grid-row-gap: 20rem;
    row-gap: 20rem;
  }
  .xl\\:row-gap-96 {
    grid-row-gap: 24rem;
    row-gap: 24rem;
  }
  .xl\\:row-gap-px {
    grid-row-gap: 1px;
    row-gap: 1px;
  }
  .xl\\:row-gap-0\\.5 {
    grid-row-gap: 0.125rem;
    row-gap: 0.125rem;
  }
  .xl\\:row-gap-1\\.5 {
    grid-row-gap: 0.375rem;
    row-gap: 0.375rem;
  }
  .xl\\:row-gap-2\\.5 {
    grid-row-gap: 0.625rem;
    row-gap: 0.625rem;
  }
  .xl\\:row-gap-3\\.5 {
    grid-row-gap: 0.875rem;
    row-gap: 0.875rem;
  }
  .xl\\:row-gap-1\\/2 {
    grid-row-gap: 50%;
    row-gap: 50%;
  }
  .xl\\:row-gap-1\\/3 {
    grid-row-gap: 33.333333%;
    row-gap: 33.333333%;
  }
  .xl\\:row-gap-2\\/3 {
    grid-row-gap: 66.666667%;
    row-gap: 66.666667%;
  }
  .xl\\:row-gap-1\\/4 {
    grid-row-gap: 25%;
    row-gap: 25%;
  }
  .xl\\:row-gap-2\\/4 {
    grid-row-gap: 50%;
    row-gap: 50%;
  }
  .xl\\:row-gap-3\\/4 {
    grid-row-gap: 75%;
    row-gap: 75%;
  }
  .xl\\:row-gap-1\\/5 {
    grid-row-gap: 20%;
    row-gap: 20%;
  }
  .xl\\:row-gap-2\\/5 {
    grid-row-gap: 40%;
    row-gap: 40%;
  }
  .xl\\:row-gap-3\\/5 {
    grid-row-gap: 60%;
    row-gap: 60%;
  }
  .xl\\:row-gap-4\\/5 {
    grid-row-gap: 80%;
    row-gap: 80%;
  }
  .xl\\:row-gap-1\\/6 {
    grid-row-gap: 16.666667%;
    row-gap: 16.666667%;
  }
  .xl\\:row-gap-2\\/6 {
    grid-row-gap: 33.333333%;
    row-gap: 33.333333%;
  }
  .xl\\:row-gap-3\\/6 {
    grid-row-gap: 50%;
    row-gap: 50%;
  }
  .xl\\:row-gap-4\\/6 {
    grid-row-gap: 66.666667%;
    row-gap: 66.666667%;
  }
  .xl\\:row-gap-5\\/6 {
    grid-row-gap: 83.333333%;
    row-gap: 83.333333%;
  }
  .xl\\:row-gap-1\\/12 {
    grid-row-gap: 8.333333%;
    row-gap: 8.333333%;
  }
  .xl\\:row-gap-2\\/12 {
    grid-row-gap: 16.666667%;
    row-gap: 16.666667%;
  }
  .xl\\:row-gap-3\\/12 {
    grid-row-gap: 25%;
    row-gap: 25%;
  }
  .xl\\:row-gap-4\\/12 {
    grid-row-gap: 33.333333%;
    row-gap: 33.333333%;
  }
  .xl\\:row-gap-5\\/12 {
    grid-row-gap: 41.666667%;
    row-gap: 41.666667%;
  }
  .xl\\:row-gap-6\\/12 {
    grid-row-gap: 50%;
    row-gap: 50%;
  }
  .xl\\:row-gap-7\\/12 {
    grid-row-gap: 58.333333%;
    row-gap: 58.333333%;
  }
  .xl\\:row-gap-8\\/12 {
    grid-row-gap: 66.666667%;
    row-gap: 66.666667%;
  }
  .xl\\:row-gap-9\\/12 {
    grid-row-gap: 75%;
    row-gap: 75%;
  }
  .xl\\:row-gap-10\\/12 {
    grid-row-gap: 83.333333%;
    row-gap: 83.333333%;
  }
  .xl\\:row-gap-11\\/12 {
    grid-row-gap: 91.666667%;
    row-gap: 91.666667%;
  }
  .xl\\:row-gap-full {
    grid-row-gap: 100%;
    row-gap: 100%;
  }
  .xl\\:gap-y-0 {
    grid-row-gap: 0;
    row-gap: 0;
  }
  .xl\\:gap-y-1 {
    grid-row-gap: 0.25rem;
    row-gap: 0.25rem;
  }
  .xl\\:gap-y-2 {
    grid-row-gap: 0.5rem;
    row-gap: 0.5rem;
  }
  .xl\\:gap-y-3 {
    grid-row-gap: 0.75rem;
    row-gap: 0.75rem;
  }
  .xl\\:gap-y-4 {
    grid-row-gap: 1rem;
    row-gap: 1rem;
  }
  .xl\\:gap-y-5 {
    grid-row-gap: 1.25rem;
    row-gap: 1.25rem;
  }
  .xl\\:gap-y-6 {
    grid-row-gap: 1.5rem;
    row-gap: 1.5rem;
  }
  .xl\\:gap-y-7 {
    grid-row-gap: 1.75rem;
    row-gap: 1.75rem;
  }
  .xl\\:gap-y-8 {
    grid-row-gap: 2rem;
    row-gap: 2rem;
  }
  .xl\\:gap-y-9 {
    grid-row-gap: 2.25rem;
    row-gap: 2.25rem;
  }
  .xl\\:gap-y-10 {
    grid-row-gap: 2.5rem;
    row-gap: 2.5rem;
  }
  .xl\\:gap-y-11 {
    grid-row-gap: 2.75rem;
    row-gap: 2.75rem;
  }
  .xl\\:gap-y-12 {
    grid-row-gap: 3rem;
    row-gap: 3rem;
  }
  .xl\\:gap-y-13 {
    grid-row-gap: 3.25rem;
    row-gap: 3.25rem;
  }
  .xl\\:gap-y-14 {
    grid-row-gap: 3.5rem;
    row-gap: 3.5rem;
  }
  .xl\\:gap-y-15 {
    grid-row-gap: 3.75rem;
    row-gap: 3.75rem;
  }
  .xl\\:gap-y-16 {
    grid-row-gap: 4rem;
    row-gap: 4rem;
  }
  .xl\\:gap-y-20 {
    grid-row-gap: 5rem;
    row-gap: 5rem;
  }
  .xl\\:gap-y-24 {
    grid-row-gap: 6rem;
    row-gap: 6rem;
  }
  .xl\\:gap-y-28 {
    grid-row-gap: 7rem;
    row-gap: 7rem;
  }
  .xl\\:gap-y-32 {
    grid-row-gap: 8rem;
    row-gap: 8rem;
  }
  .xl\\:gap-y-36 {
    grid-row-gap: 9rem;
    row-gap: 9rem;
  }
  .xl\\:gap-y-40 {
    grid-row-gap: 10rem;
    row-gap: 10rem;
  }
  .xl\\:gap-y-44 {
    grid-row-gap: 11rem;
    row-gap: 11rem;
  }
  .xl\\:gap-y-48 {
    grid-row-gap: 12rem;
    row-gap: 12rem;
  }
  .xl\\:gap-y-52 {
    grid-row-gap: 13rem;
    row-gap: 13rem;
  }
  .xl\\:gap-y-56 {
    grid-row-gap: 14rem;
    row-gap: 14rem;
  }
  .xl\\:gap-y-60 {
    grid-row-gap: 15rem;
    row-gap: 15rem;
  }
  .xl\\:gap-y-64 {
    grid-row-gap: 16rem;
    row-gap: 16rem;
  }
  .xl\\:gap-y-72 {
    grid-row-gap: 18rem;
    row-gap: 18rem;
  }
  .xl\\:gap-y-80 {
    grid-row-gap: 20rem;
    row-gap: 20rem;
  }
  .xl\\:gap-y-96 {
    grid-row-gap: 24rem;
    row-gap: 24rem;
  }
  .xl\\:gap-y-px {
    grid-row-gap: 1px;
    row-gap: 1px;
  }
  .xl\\:gap-y-0\\.5 {
    grid-row-gap: 0.125rem;
    row-gap: 0.125rem;
  }
  .xl\\:gap-y-1\\.5 {
    grid-row-gap: 0.375rem;
    row-gap: 0.375rem;
  }
  .xl\\:gap-y-2\\.5 {
    grid-row-gap: 0.625rem;
    row-gap: 0.625rem;
  }
  .xl\\:gap-y-3\\.5 {
    grid-row-gap: 0.875rem;
    row-gap: 0.875rem;
  }
  .xl\\:gap-y-1\\/2 {
    grid-row-gap: 50%;
    row-gap: 50%;
  }
  .xl\\:gap-y-1\\/3 {
    grid-row-gap: 33.333333%;
    row-gap: 33.333333%;
  }
  .xl\\:gap-y-2\\/3 {
    grid-row-gap: 66.666667%;
    row-gap: 66.666667%;
  }
  .xl\\:gap-y-1\\/4 {
    grid-row-gap: 25%;
    row-gap: 25%;
  }
  .xl\\:gap-y-2\\/4 {
    grid-row-gap: 50%;
    row-gap: 50%;
  }
  .xl\\:gap-y-3\\/4 {
    grid-row-gap: 75%;
    row-gap: 75%;
  }
  .xl\\:gap-y-1\\/5 {
    grid-row-gap: 20%;
    row-gap: 20%;
  }
  .xl\\:gap-y-2\\/5 {
    grid-row-gap: 40%;
    row-gap: 40%;
  }
  .xl\\:gap-y-3\\/5 {
    grid-row-gap: 60%;
    row-gap: 60%;
  }
  .xl\\:gap-y-4\\/5 {
    grid-row-gap: 80%;
    row-gap: 80%;
  }
  .xl\\:gap-y-1\\/6 {
    grid-row-gap: 16.666667%;
    row-gap: 16.666667%;
  }
  .xl\\:gap-y-2\\/6 {
    grid-row-gap: 33.333333%;
    row-gap: 33.333333%;
  }
  .xl\\:gap-y-3\\/6 {
    grid-row-gap: 50%;
    row-gap: 50%;
  }
  .xl\\:gap-y-4\\/6 {
    grid-row-gap: 66.666667%;
    row-gap: 66.666667%;
  }
  .xl\\:gap-y-5\\/6 {
    grid-row-gap: 83.333333%;
    row-gap: 83.333333%;
  }
  .xl\\:gap-y-1\\/12 {
    grid-row-gap: 8.333333%;
    row-gap: 8.333333%;
  }
  .xl\\:gap-y-2\\/12 {
    grid-row-gap: 16.666667%;
    row-gap: 16.666667%;
  }
  .xl\\:gap-y-3\\/12 {
    grid-row-gap: 25%;
    row-gap: 25%;
  }
  .xl\\:gap-y-4\\/12 {
    grid-row-gap: 33.333333%;
    row-gap: 33.333333%;
  }
  .xl\\:gap-y-5\\/12 {
    grid-row-gap: 41.666667%;
    row-gap: 41.666667%;
  }
  .xl\\:gap-y-6\\/12 {
    grid-row-gap: 50%;
    row-gap: 50%;
  }
  .xl\\:gap-y-7\\/12 {
    grid-row-gap: 58.333333%;
    row-gap: 58.333333%;
  }
  .xl\\:gap-y-8\\/12 {
    grid-row-gap: 66.666667%;
    row-gap: 66.666667%;
  }
  .xl\\:gap-y-9\\/12 {
    grid-row-gap: 75%;
    row-gap: 75%;
  }
  .xl\\:gap-y-10\\/12 {
    grid-row-gap: 83.333333%;
    row-gap: 83.333333%;
  }
  .xl\\:gap-y-11\\/12 {
    grid-row-gap: 91.666667%;
    row-gap: 91.666667%;
  }
  .xl\\:gap-y-full {
    grid-row-gap: 100%;
    row-gap: 100%;
  }
  .xl\\:grid-flow-row {
    grid-auto-flow: row;
  }
  .xl\\:grid-flow-col {
    grid-auto-flow: column;
  }
  .xl\\:grid-flow-row-dense {
    grid-auto-flow: row dense;
  }
  .xl\\:grid-flow-col-dense {
    grid-auto-flow: column dense;
  }
  .xl\\:grid-cols-1 {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }
  .xl\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .xl\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .xl\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
  .xl\\:grid-cols-5 {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }
  .xl\\:grid-cols-6 {
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }
  .xl\\:grid-cols-7 {
    grid-template-columns: repeat(7, minmax(0, 1fr));
  }
  .xl\\:grid-cols-8 {
    grid-template-columns: repeat(8, minmax(0, 1fr));
  }
  .xl\\:grid-cols-9 {
    grid-template-columns: repeat(9, minmax(0, 1fr));
  }
  .xl\\:grid-cols-10 {
    grid-template-columns: repeat(10, minmax(0, 1fr));
  }
  .xl\\:grid-cols-11 {
    grid-template-columns: repeat(11, minmax(0, 1fr));
  }
  .xl\\:grid-cols-12 {
    grid-template-columns: repeat(12, minmax(0, 1fr));
  }
  .xl\\:grid-cols-none {
    grid-template-columns: none;
  }
  .xl\\:auto-cols-auto {
    grid-auto-columns: auto;
  }
  .xl\\:auto-cols-min {
    grid-auto-columns: min-content;
  }
  .xl\\:auto-cols-max {
    grid-auto-columns: max-content;
  }
  .xl\\:auto-cols-fr {
    grid-auto-columns: minmax(0, 1fr);
  }
  .xl\\:col-auto {
    grid-column: auto;
  }
  .xl\\:col-span-1 {
    grid-column: span 1 / span 1;
  }
  .xl\\:col-span-2 {
    grid-column: span 2 / span 2;
  }
  .xl\\:col-span-3 {
    grid-column: span 3 / span 3;
  }
  .xl\\:col-span-4 {
    grid-column: span 4 / span 4;
  }
  .xl\\:col-span-5 {
    grid-column: span 5 / span 5;
  }
  .xl\\:col-span-6 {
    grid-column: span 6 / span 6;
  }
  .xl\\:col-span-7 {
    grid-column: span 7 / span 7;
  }
  .xl\\:col-span-8 {
    grid-column: span 8 / span 8;
  }
  .xl\\:col-span-9 {
    grid-column: span 9 / span 9;
  }
  .xl\\:col-span-10 {
    grid-column: span 10 / span 10;
  }
  .xl\\:col-span-11 {
    grid-column: span 11 / span 11;
  }
  .xl\\:col-span-12 {
    grid-column: span 12 / span 12;
  }
  .xl\\:col-span-full {
    grid-column: 1 / -1;
  }
  .xl\\:col-start-1 {
    grid-column-start: 1;
  }
  .xl\\:col-start-2 {
    grid-column-start: 2;
  }
  .xl\\:col-start-3 {
    grid-column-start: 3;
  }
  .xl\\:col-start-4 {
    grid-column-start: 4;
  }
  .xl\\:col-start-5 {
    grid-column-start: 5;
  }
  .xl\\:col-start-6 {
    grid-column-start: 6;
  }
  .xl\\:col-start-7 {
    grid-column-start: 7;
  }
  .xl\\:col-start-8 {
    grid-column-start: 8;
  }
  .xl\\:col-start-9 {
    grid-column-start: 9;
  }
  .xl\\:col-start-10 {
    grid-column-start: 10;
  }
  .xl\\:col-start-11 {
    grid-column-start: 11;
  }
  .xl\\:col-start-12 {
    grid-column-start: 12;
  }
  .xl\\:col-start-13 {
    grid-column-start: 13;
  }
  .xl\\:col-start-auto {
    grid-column-start: auto;
  }
  .xl\\:col-end-1 {
    grid-column-end: 1;
  }
  .xl\\:col-end-2 {
    grid-column-end: 2;
  }
  .xl\\:col-end-3 {
    grid-column-end: 3;
  }
  .xl\\:col-end-4 {
    grid-column-end: 4;
  }
  .xl\\:col-end-5 {
    grid-column-end: 5;
  }
  .xl\\:col-end-6 {
    grid-column-end: 6;
  }
  .xl\\:col-end-7 {
    grid-column-end: 7;
  }
  .xl\\:col-end-8 {
    grid-column-end: 8;
  }
  .xl\\:col-end-9 {
    grid-column-end: 9;
  }
  .xl\\:col-end-10 {
    grid-column-end: 10;
  }
  .xl\\:col-end-11 {
    grid-column-end: 11;
  }
  .xl\\:col-end-12 {
    grid-column-end: 12;
  }
  .xl\\:col-end-13 {
    grid-column-end: 13;
  }
  .xl\\:col-end-auto {
    grid-column-end: auto;
  }
  .xl\\:grid-rows-1 {
    grid-template-rows: repeat(1, minmax(0, 1fr));
  }
  .xl\\:grid-rows-2 {
    grid-template-rows: repeat(2, minmax(0, 1fr));
  }
  .xl\\:grid-rows-3 {
    grid-template-rows: repeat(3, minmax(0, 1fr));
  }
  .xl\\:grid-rows-4 {
    grid-template-rows: repeat(4, minmax(0, 1fr));
  }
  .xl\\:grid-rows-5 {
    grid-template-rows: repeat(5, minmax(0, 1fr));
  }
  .xl\\:grid-rows-6 {
    grid-template-rows: repeat(6, minmax(0, 1fr));
  }
  .xl\\:grid-rows-none {
    grid-template-rows: none;
  }
  .xl\\:auto-rows-auto {
    grid-auto-rows: auto;
  }
  .xl\\:auto-rows-min {
    grid-auto-rows: min-content;
  }
  .xl\\:auto-rows-max {
    grid-auto-rows: max-content;
  }
  .xl\\:auto-rows-fr {
    grid-auto-rows: minmax(0, 1fr);
  }
  .xl\\:row-auto {
    grid-row: auto;
  }
  .xl\\:row-span-1 {
    grid-row: span 1 / span 1;
  }
  .xl\\:row-span-2 {
    grid-row: span 2 / span 2;
  }
  .xl\\:row-span-3 {
    grid-row: span 3 / span 3;
  }
  .xl\\:row-span-4 {
    grid-row: span 4 / span 4;
  }
  .xl\\:row-span-5 {
    grid-row: span 5 / span 5;
  }
  .xl\\:row-span-6 {
    grid-row: span 6 / span 6;
  }
  .xl\\:row-span-full {
    grid-row: 1 / -1;
  }
  .xl\\:row-start-1 {
    grid-row-start: 1;
  }
  .xl\\:row-start-2 {
    grid-row-start: 2;
  }
  .xl\\:row-start-3 {
    grid-row-start: 3;
  }
  .xl\\:row-start-4 {
    grid-row-start: 4;
  }
  .xl\\:row-start-5 {
    grid-row-start: 5;
  }
  .xl\\:row-start-6 {
    grid-row-start: 6;
  }
  .xl\\:row-start-7 {
    grid-row-start: 7;
  }
  .xl\\:row-start-auto {
    grid-row-start: auto;
  }
  .xl\\:row-end-1 {
    grid-row-end: 1;
  }
  .xl\\:row-end-2 {
    grid-row-end: 2;
  }
  .xl\\:row-end-3 {
    grid-row-end: 3;
  }
  .xl\\:row-end-4 {
    grid-row-end: 4;
  }
  .xl\\:row-end-5 {
    grid-row-end: 5;
  }
  .xl\\:row-end-6 {
    grid-row-end: 6;
  }
  .xl\\:row-end-7 {
    grid-row-end: 7;
  }
  .xl\\:row-end-auto {
    grid-row-end: auto;
  }
  .xl\\:transform {
    --transform-translate-x: 0;
    --transform-translate-y: 0;
    --transform-rotate: 0;
    --transform-skew-x: 0;
    --transform-skew-y: 0;
    --transform-scale-x: 1;
    --transform-scale-y: 1;
    transform: translateX(var(--transform-translate-x)) translateY(var(--transform-translate-y)) rotate(var(--transform-rotate)) skewX(var(--transform-skew-x)) skewY(var(--transform-skew-y)) scaleX(var(--transform-scale-x)) scaleY(var(--transform-scale-y));
  }
  .xl\\:transform-none {
    transform: none;
  }
  .xl\\:origin-center {
    transform-origin: center;
  }
  .xl\\:origin-top {
    transform-origin: top;
  }
  .xl\\:origin-top-right {
    transform-origin: top right;
  }
  .xl\\:origin-right {
    transform-origin: right;
  }
  .xl\\:origin-bottom-right {
    transform-origin: bottom right;
  }
  .xl\\:origin-bottom {
    transform-origin: bottom;
  }
  .xl\\:origin-bottom-left {
    transform-origin: bottom left;
  }
  .xl\\:origin-left {
    transform-origin: left;
  }
  .xl\\:origin-top-left {
    transform-origin: top left;
  }
  .xl\\:scale-0 {
    --transform-scale-x: 0;
    --transform-scale-y: 0;
  }
  .xl\\:scale-50 {
    --transform-scale-x: .5;
    --transform-scale-y: .5;
  }
  .xl\\:scale-75 {
    --transform-scale-x: .75;
    --transform-scale-y: .75;
  }
  .xl\\:scale-90 {
    --transform-scale-x: .9;
    --transform-scale-y: .9;
  }
  .xl\\:scale-95 {
    --transform-scale-x: .95;
    --transform-scale-y: .95;
  }
  .xl\\:scale-100 {
    --transform-scale-x: 1;
    --transform-scale-y: 1;
  }
  .xl\\:scale-105 {
    --transform-scale-x: 1.05;
    --transform-scale-y: 1.05;
  }
  .xl\\:scale-110 {
    --transform-scale-x: 1.1;
    --transform-scale-y: 1.1;
  }
  .xl\\:scale-125 {
    --transform-scale-x: 1.25;
    --transform-scale-y: 1.25;
  }
  .xl\\:scale-150 {
    --transform-scale-x: 1.5;
    --transform-scale-y: 1.5;
  }
  .xl\\:scale-x-0 {
    --transform-scale-x: 0;
  }
  .xl\\:scale-x-50 {
    --transform-scale-x: .5;
  }
  .xl\\:scale-x-75 {
    --transform-scale-x: .75;
  }
  .xl\\:scale-x-90 {
    --transform-scale-x: .9;
  }
  .xl\\:scale-x-95 {
    --transform-scale-x: .95;
  }
  .xl\\:scale-x-100 {
    --transform-scale-x: 1;
  }
  .xl\\:scale-x-105 {
    --transform-scale-x: 1.05;
  }
  .xl\\:scale-x-110 {
    --transform-scale-x: 1.1;
  }
  .xl\\:scale-x-125 {
    --transform-scale-x: 1.25;
  }
  .xl\\:scale-x-150 {
    --transform-scale-x: 1.5;
  }
  .xl\\:scale-y-0 {
    --transform-scale-y: 0;
  }
  .xl\\:scale-y-50 {
    --transform-scale-y: .5;
  }
  .xl\\:scale-y-75 {
    --transform-scale-y: .75;
  }
  .xl\\:scale-y-90 {
    --transform-scale-y: .9;
  }
  .xl\\:scale-y-95 {
    --transform-scale-y: .95;
  }
  .xl\\:scale-y-100 {
    --transform-scale-y: 1;
  }
  .xl\\:scale-y-105 {
    --transform-scale-y: 1.05;
  }
  .xl\\:scale-y-110 {
    --transform-scale-y: 1.1;
  }
  .xl\\:scale-y-125 {
    --transform-scale-y: 1.25;
  }
  .xl\\:scale-y-150 {
    --transform-scale-y: 1.5;
  }
  .xl\\:hover\\:scale-0:hover {
    --transform-scale-x: 0;
    --transform-scale-y: 0;
  }
  .xl\\:hover\\:scale-50:hover {
    --transform-scale-x: .5;
    --transform-scale-y: .5;
  }
  .xl\\:hover\\:scale-75:hover {
    --transform-scale-x: .75;
    --transform-scale-y: .75;
  }
  .xl\\:hover\\:scale-90:hover {
    --transform-scale-x: .9;
    --transform-scale-y: .9;
  }
  .xl\\:hover\\:scale-95:hover {
    --transform-scale-x: .95;
    --transform-scale-y: .95;
  }
  .xl\\:hover\\:scale-100:hover {
    --transform-scale-x: 1;
    --transform-scale-y: 1;
  }
  .xl\\:hover\\:scale-105:hover {
    --transform-scale-x: 1.05;
    --transform-scale-y: 1.05;
  }
  .xl\\:hover\\:scale-110:hover {
    --transform-scale-x: 1.1;
    --transform-scale-y: 1.1;
  }
  .xl\\:hover\\:scale-125:hover {
    --transform-scale-x: 1.25;
    --transform-scale-y: 1.25;
  }
  .xl\\:hover\\:scale-150:hover {
    --transform-scale-x: 1.5;
    --transform-scale-y: 1.5;
  }
  .xl\\:hover\\:scale-x-0:hover {
    --transform-scale-x: 0;
  }
  .xl\\:hover\\:scale-x-50:hover {
    --transform-scale-x: .5;
  }
  .xl\\:hover\\:scale-x-75:hover {
    --transform-scale-x: .75;
  }
  .xl\\:hover\\:scale-x-90:hover {
    --transform-scale-x: .9;
  }
  .xl\\:hover\\:scale-x-95:hover {
    --transform-scale-x: .95;
  }
  .xl\\:hover\\:scale-x-100:hover {
    --transform-scale-x: 1;
  }
  .xl\\:hover\\:scale-x-105:hover {
    --transform-scale-x: 1.05;
  }
  .xl\\:hover\\:scale-x-110:hover {
    --transform-scale-x: 1.1;
  }
  .xl\\:hover\\:scale-x-125:hover {
    --transform-scale-x: 1.25;
  }
  .xl\\:hover\\:scale-x-150:hover {
    --transform-scale-x: 1.5;
  }
  .xl\\:hover\\:scale-y-0:hover {
    --transform-scale-y: 0;
  }
  .xl\\:hover\\:scale-y-50:hover {
    --transform-scale-y: .5;
  }
  .xl\\:hover\\:scale-y-75:hover {
    --transform-scale-y: .75;
  }
  .xl\\:hover\\:scale-y-90:hover {
    --transform-scale-y: .9;
  }
  .xl\\:hover\\:scale-y-95:hover {
    --transform-scale-y: .95;
  }
  .xl\\:hover\\:scale-y-100:hover {
    --transform-scale-y: 1;
  }
  .xl\\:hover\\:scale-y-105:hover {
    --transform-scale-y: 1.05;
  }
  .xl\\:hover\\:scale-y-110:hover {
    --transform-scale-y: 1.1;
  }
  .xl\\:hover\\:scale-y-125:hover {
    --transform-scale-y: 1.25;
  }
  .xl\\:hover\\:scale-y-150:hover {
    --transform-scale-y: 1.5;
  }
  .xl\\:focus\\:scale-0:focus {
    --transform-scale-x: 0;
    --transform-scale-y: 0;
  }
  .xl\\:focus\\:scale-50:focus {
    --transform-scale-x: .5;
    --transform-scale-y: .5;
  }
  .xl\\:focus\\:scale-75:focus {
    --transform-scale-x: .75;
    --transform-scale-y: .75;
  }
  .xl\\:focus\\:scale-90:focus {
    --transform-scale-x: .9;
    --transform-scale-y: .9;
  }
  .xl\\:focus\\:scale-95:focus {
    --transform-scale-x: .95;
    --transform-scale-y: .95;
  }
  .xl\\:focus\\:scale-100:focus {
    --transform-scale-x: 1;
    --transform-scale-y: 1;
  }
  .xl\\:focus\\:scale-105:focus {
    --transform-scale-x: 1.05;
    --transform-scale-y: 1.05;
  }
  .xl\\:focus\\:scale-110:focus {
    --transform-scale-x: 1.1;
    --transform-scale-y: 1.1;
  }
  .xl\\:focus\\:scale-125:focus {
    --transform-scale-x: 1.25;
    --transform-scale-y: 1.25;
  }
  .xl\\:focus\\:scale-150:focus {
    --transform-scale-x: 1.5;
    --transform-scale-y: 1.5;
  }
  .xl\\:focus\\:scale-x-0:focus {
    --transform-scale-x: 0;
  }
  .xl\\:focus\\:scale-x-50:focus {
    --transform-scale-x: .5;
  }
  .xl\\:focus\\:scale-x-75:focus {
    --transform-scale-x: .75;
  }
  .xl\\:focus\\:scale-x-90:focus {
    --transform-scale-x: .9;
  }
  .xl\\:focus\\:scale-x-95:focus {
    --transform-scale-x: .95;
  }
  .xl\\:focus\\:scale-x-100:focus {
    --transform-scale-x: 1;
  }
  .xl\\:focus\\:scale-x-105:focus {
    --transform-scale-x: 1.05;
  }
  .xl\\:focus\\:scale-x-110:focus {
    --transform-scale-x: 1.1;
  }
  .xl\\:focus\\:scale-x-125:focus {
    --transform-scale-x: 1.25;
  }
  .xl\\:focus\\:scale-x-150:focus {
    --transform-scale-x: 1.5;
  }
  .xl\\:focus\\:scale-y-0:focus {
    --transform-scale-y: 0;
  }
  .xl\\:focus\\:scale-y-50:focus {
    --transform-scale-y: .5;
  }
  .xl\\:focus\\:scale-y-75:focus {
    --transform-scale-y: .75;
  }
  .xl\\:focus\\:scale-y-90:focus {
    --transform-scale-y: .9;
  }
  .xl\\:focus\\:scale-y-95:focus {
    --transform-scale-y: .95;
  }
  .xl\\:focus\\:scale-y-100:focus {
    --transform-scale-y: 1;
  }
  .xl\\:focus\\:scale-y-105:focus {
    --transform-scale-y: 1.05;
  }
  .xl\\:focus\\:scale-y-110:focus {
    --transform-scale-y: 1.1;
  }
  .xl\\:focus\\:scale-y-125:focus {
    --transform-scale-y: 1.25;
  }
  .xl\\:focus\\:scale-y-150:focus {
    --transform-scale-y: 1.5;
  }
  .xl\\:rotate-0 {
    --transform-rotate: 0;
  }
  .xl\\:rotate-1 {
    --transform-rotate: 1deg;
  }
  .xl\\:rotate-2 {
    --transform-rotate: 2deg;
  }
  .xl\\:rotate-3 {
    --transform-rotate: 3deg;
  }
  .xl\\:rotate-6 {
    --transform-rotate: 6deg;
  }
  .xl\\:rotate-12 {
    --transform-rotate: 12deg;
  }
  .xl\\:rotate-45 {
    --transform-rotate: 45deg;
  }
  .xl\\:rotate-90 {
    --transform-rotate: 90deg;
  }
  .xl\\:rotate-180 {
    --transform-rotate: 180deg;
  }
  .xl\\:-rotate-180 {
    --transform-rotate: -180deg;
  }
  .xl\\:-rotate-90 {
    --transform-rotate: -90deg;
  }
  .xl\\:-rotate-45 {
    --transform-rotate: -45deg;
  }
  .xl\\:-rotate-12 {
    --transform-rotate: -12deg;
  }
  .xl\\:-rotate-6 {
    --transform-rotate: -6deg;
  }
  .xl\\:-rotate-3 {
    --transform-rotate: -3deg;
  }
  .xl\\:-rotate-2 {
    --transform-rotate: -2deg;
  }
  .xl\\:-rotate-1 {
    --transform-rotate: -1deg;
  }
  .xl\\:hover\\:rotate-0:hover {
    --transform-rotate: 0;
  }
  .xl\\:hover\\:rotate-1:hover {
    --transform-rotate: 1deg;
  }
  .xl\\:hover\\:rotate-2:hover {
    --transform-rotate: 2deg;
  }
  .xl\\:hover\\:rotate-3:hover {
    --transform-rotate: 3deg;
  }
  .xl\\:hover\\:rotate-6:hover {
    --transform-rotate: 6deg;
  }
  .xl\\:hover\\:rotate-12:hover {
    --transform-rotate: 12deg;
  }
  .xl\\:hover\\:rotate-45:hover {
    --transform-rotate: 45deg;
  }
  .xl\\:hover\\:rotate-90:hover {
    --transform-rotate: 90deg;
  }
  .xl\\:hover\\:rotate-180:hover {
    --transform-rotate: 180deg;
  }
  .xl\\:hover\\:-rotate-180:hover {
    --transform-rotate: -180deg;
  }
  .xl\\:hover\\:-rotate-90:hover {
    --transform-rotate: -90deg;
  }
  .xl\\:hover\\:-rotate-45:hover {
    --transform-rotate: -45deg;
  }
  .xl\\:hover\\:-rotate-12:hover {
    --transform-rotate: -12deg;
  }
  .xl\\:hover\\:-rotate-6:hover {
    --transform-rotate: -6deg;
  }
  .xl\\:hover\\:-rotate-3:hover {
    --transform-rotate: -3deg;
  }
  .xl\\:hover\\:-rotate-2:hover {
    --transform-rotate: -2deg;
  }
  .xl\\:hover\\:-rotate-1:hover {
    --transform-rotate: -1deg;
  }
  .xl\\:focus\\:rotate-0:focus {
    --transform-rotate: 0;
  }
  .xl\\:focus\\:rotate-1:focus {
    --transform-rotate: 1deg;
  }
  .xl\\:focus\\:rotate-2:focus {
    --transform-rotate: 2deg;
  }
  .xl\\:focus\\:rotate-3:focus {
    --transform-rotate: 3deg;
  }
  .xl\\:focus\\:rotate-6:focus {
    --transform-rotate: 6deg;
  }
  .xl\\:focus\\:rotate-12:focus {
    --transform-rotate: 12deg;
  }
  .xl\\:focus\\:rotate-45:focus {
    --transform-rotate: 45deg;
  }
  .xl\\:focus\\:rotate-90:focus {
    --transform-rotate: 90deg;
  }
  .xl\\:focus\\:rotate-180:focus {
    --transform-rotate: 180deg;
  }
  .xl\\:focus\\:-rotate-180:focus {
    --transform-rotate: -180deg;
  }
  .xl\\:focus\\:-rotate-90:focus {
    --transform-rotate: -90deg;
  }
  .xl\\:focus\\:-rotate-45:focus {
    --transform-rotate: -45deg;
  }
  .xl\\:focus\\:-rotate-12:focus {
    --transform-rotate: -12deg;
  }
  .xl\\:focus\\:-rotate-6:focus {
    --transform-rotate: -6deg;
  }
  .xl\\:focus\\:-rotate-3:focus {
    --transform-rotate: -3deg;
  }
  .xl\\:focus\\:-rotate-2:focus {
    --transform-rotate: -2deg;
  }
  .xl\\:focus\\:-rotate-1:focus {
    --transform-rotate: -1deg;
  }
  .xl\\:translate-x-0 {
    --transform-translate-x: 0;
  }
  .xl\\:translate-x-1 {
    --transform-translate-x: 0.25rem;
  }
  .xl\\:translate-x-2 {
    --transform-translate-x: 0.5rem;
  }
  .xl\\:translate-x-3 {
    --transform-translate-x: 0.75rem;
  }
  .xl\\:translate-x-4 {
    --transform-translate-x: 1rem;
  }
  .xl\\:translate-x-5 {
    --transform-translate-x: 1.25rem;
  }
  .xl\\:translate-x-6 {
    --transform-translate-x: 1.5rem;
  }
  .xl\\:translate-x-7 {
    --transform-translate-x: 1.75rem;
  }
  .xl\\:translate-x-8 {
    --transform-translate-x: 2rem;
  }
  .xl\\:translate-x-9 {
    --transform-translate-x: 2.25rem;
  }
  .xl\\:translate-x-10 {
    --transform-translate-x: 2.5rem;
  }
  .xl\\:translate-x-11 {
    --transform-translate-x: 2.75rem;
  }
  .xl\\:translate-x-12 {
    --transform-translate-x: 3rem;
  }
  .xl\\:translate-x-13 {
    --transform-translate-x: 3.25rem;
  }
  .xl\\:translate-x-14 {
    --transform-translate-x: 3.5rem;
  }
  .xl\\:translate-x-15 {
    --transform-translate-x: 3.75rem;
  }
  .xl\\:translate-x-16 {
    --transform-translate-x: 4rem;
  }
  .xl\\:translate-x-20 {
    --transform-translate-x: 5rem;
  }
  .xl\\:translate-x-24 {
    --transform-translate-x: 6rem;
  }
  .xl\\:translate-x-28 {
    --transform-translate-x: 7rem;
  }
  .xl\\:translate-x-32 {
    --transform-translate-x: 8rem;
  }
  .xl\\:translate-x-36 {
    --transform-translate-x: 9rem;
  }
  .xl\\:translate-x-40 {
    --transform-translate-x: 10rem;
  }
  .xl\\:translate-x-44 {
    --transform-translate-x: 11rem;
  }
  .xl\\:translate-x-48 {
    --transform-translate-x: 12rem;
  }
  .xl\\:translate-x-52 {
    --transform-translate-x: 13rem;
  }
  .xl\\:translate-x-56 {
    --transform-translate-x: 14rem;
  }
  .xl\\:translate-x-60 {
    --transform-translate-x: 15rem;
  }
  .xl\\:translate-x-64 {
    --transform-translate-x: 16rem;
  }
  .xl\\:translate-x-72 {
    --transform-translate-x: 18rem;
  }
  .xl\\:translate-x-80 {
    --transform-translate-x: 20rem;
  }
  .xl\\:translate-x-96 {
    --transform-translate-x: 24rem;
  }
  .xl\\:translate-x-px {
    --transform-translate-x: 1px;
  }
  .xl\\:translate-x-0\\.5 {
    --transform-translate-x: 0.125rem;
  }
  .xl\\:translate-x-1\\.5 {
    --transform-translate-x: 0.375rem;
  }
  .xl\\:translate-x-2\\.5 {
    --transform-translate-x: 0.625rem;
  }
  .xl\\:translate-x-3\\.5 {
    --transform-translate-x: 0.875rem;
  }
  .xl\\:translate-x-1\\/2 {
    --transform-translate-x: 50%;
  }
  .xl\\:translate-x-1\\/3 {
    --transform-translate-x: 33.333333%;
  }
  .xl\\:translate-x-2\\/3 {
    --transform-translate-x: 66.666667%;
  }
  .xl\\:translate-x-1\\/4 {
    --transform-translate-x: 25%;
  }
  .xl\\:translate-x-2\\/4 {
    --transform-translate-x: 50%;
  }
  .xl\\:translate-x-3\\/4 {
    --transform-translate-x: 75%;
  }
  .xl\\:translate-x-1\\/5 {
    --transform-translate-x: 20%;
  }
  .xl\\:translate-x-2\\/5 {
    --transform-translate-x: 40%;
  }
  .xl\\:translate-x-3\\/5 {
    --transform-translate-x: 60%;
  }
  .xl\\:translate-x-4\\/5 {
    --transform-translate-x: 80%;
  }
  .xl\\:translate-x-1\\/6 {
    --transform-translate-x: 16.666667%;
  }
  .xl\\:translate-x-2\\/6 {
    --transform-translate-x: 33.333333%;
  }
  .xl\\:translate-x-3\\/6 {
    --transform-translate-x: 50%;
  }
  .xl\\:translate-x-4\\/6 {
    --transform-translate-x: 66.666667%;
  }
  .xl\\:translate-x-5\\/6 {
    --transform-translate-x: 83.333333%;
  }
  .xl\\:translate-x-1\\/12 {
    --transform-translate-x: 8.333333%;
  }
  .xl\\:translate-x-2\\/12 {
    --transform-translate-x: 16.666667%;
  }
  .xl\\:translate-x-3\\/12 {
    --transform-translate-x: 25%;
  }
  .xl\\:translate-x-4\\/12 {
    --transform-translate-x: 33.333333%;
  }
  .xl\\:translate-x-5\\/12 {
    --transform-translate-x: 41.666667%;
  }
  .xl\\:translate-x-6\\/12 {
    --transform-translate-x: 50%;
  }
  .xl\\:translate-x-7\\/12 {
    --transform-translate-x: 58.333333%;
  }
  .xl\\:translate-x-8\\/12 {
    --transform-translate-x: 66.666667%;
  }
  .xl\\:translate-x-9\\/12 {
    --transform-translate-x: 75%;
  }
  .xl\\:translate-x-10\\/12 {
    --transform-translate-x: 83.333333%;
  }
  .xl\\:translate-x-11\\/12 {
    --transform-translate-x: 91.666667%;
  }
  .xl\\:translate-x-full {
    --transform-translate-x: 100%;
  }
  .xl\\:-translate-x-1 {
    --transform-translate-x: -0.25rem;
  }
  .xl\\:-translate-x-2 {
    --transform-translate-x: -0.5rem;
  }
  .xl\\:-translate-x-3 {
    --transform-translate-x: -0.75rem;
  }
  .xl\\:-translate-x-4 {
    --transform-translate-x: -1rem;
  }
  .xl\\:-translate-x-5 {
    --transform-translate-x: -1.25rem;
  }
  .xl\\:-translate-x-6 {
    --transform-translate-x: -1.5rem;
  }
  .xl\\:-translate-x-7 {
    --transform-translate-x: -1.75rem;
  }
  .xl\\:-translate-x-8 {
    --transform-translate-x: -2rem;
  }
  .xl\\:-translate-x-9 {
    --transform-translate-x: -2.25rem;
  }
  .xl\\:-translate-x-10 {
    --transform-translate-x: -2.5rem;
  }
  .xl\\:-translate-x-11 {
    --transform-translate-x: -2.75rem;
  }
  .xl\\:-translate-x-12 {
    --transform-translate-x: -3rem;
  }
  .xl\\:-translate-x-13 {
    --transform-translate-x: -3.25rem;
  }
  .xl\\:-translate-x-14 {
    --transform-translate-x: -3.5rem;
  }
  .xl\\:-translate-x-15 {
    --transform-translate-x: -3.75rem;
  }
  .xl\\:-translate-x-16 {
    --transform-translate-x: -4rem;
  }
  .xl\\:-translate-x-20 {
    --transform-translate-x: -5rem;
  }
  .xl\\:-translate-x-24 {
    --transform-translate-x: -6rem;
  }
  .xl\\:-translate-x-28 {
    --transform-translate-x: -7rem;
  }
  .xl\\:-translate-x-32 {
    --transform-translate-x: -8rem;
  }
  .xl\\:-translate-x-36 {
    --transform-translate-x: -9rem;
  }
  .xl\\:-translate-x-40 {
    --transform-translate-x: -10rem;
  }
  .xl\\:-translate-x-44 {
    --transform-translate-x: -11rem;
  }
  .xl\\:-translate-x-48 {
    --transform-translate-x: -12rem;
  }
  .xl\\:-translate-x-52 {
    --transform-translate-x: -13rem;
  }
  .xl\\:-translate-x-56 {
    --transform-translate-x: -14rem;
  }
  .xl\\:-translate-x-60 {
    --transform-translate-x: -15rem;
  }
  .xl\\:-translate-x-64 {
    --transform-translate-x: -16rem;
  }
  .xl\\:-translate-x-72 {
    --transform-translate-x: -18rem;
  }
  .xl\\:-translate-x-80 {
    --transform-translate-x: -20rem;
  }
  .xl\\:-translate-x-96 {
    --transform-translate-x: -24rem;
  }
  .xl\\:-translate-x-px {
    --transform-translate-x: -1px;
  }
  .xl\\:-translate-x-0\\.5 {
    --transform-translate-x: -0.125rem;
  }
  .xl\\:-translate-x-1\\.5 {
    --transform-translate-x: -0.375rem;
  }
  .xl\\:-translate-x-2\\.5 {
    --transform-translate-x: -0.625rem;
  }
  .xl\\:-translate-x-3\\.5 {
    --transform-translate-x: -0.875rem;
  }
  .xl\\:-translate-x-1\\/2 {
    --transform-translate-x: -50%;
  }
  .xl\\:-translate-x-1\\/3 {
    --transform-translate-x: -33.33333%;
  }
  .xl\\:-translate-x-2\\/3 {
    --transform-translate-x: -66.66667%;
  }
  .xl\\:-translate-x-1\\/4 {
    --transform-translate-x: -25%;
  }
  .xl\\:-translate-x-2\\/4 {
    --transform-translate-x: -50%;
  }
  .xl\\:-translate-x-3\\/4 {
    --transform-translate-x: -75%;
  }
  .xl\\:-translate-x-1\\/5 {
    --transform-translate-x: -20%;
  }
  .xl\\:-translate-x-2\\/5 {
    --transform-translate-x: -40%;
  }
  .xl\\:-translate-x-3\\/5 {
    --transform-translate-x: -60%;
  }
  .xl\\:-translate-x-4\\/5 {
    --transform-translate-x: -80%;
  }
  .xl\\:-translate-x-1\\/6 {
    --transform-translate-x: -16.66667%;
  }
  .xl\\:-translate-x-2\\/6 {
    --transform-translate-x: -33.33333%;
  }
  .xl\\:-translate-x-3\\/6 {
    --transform-translate-x: -50%;
  }
  .xl\\:-translate-x-4\\/6 {
    --transform-translate-x: -66.66667%;
  }
  .xl\\:-translate-x-5\\/6 {
    --transform-translate-x: -83.33333%;
  }
  .xl\\:-translate-x-1\\/12 {
    --transform-translate-x: -8.33333%;
  }
  .xl\\:-translate-x-2\\/12 {
    --transform-translate-x: -16.66667%;
  }
  .xl\\:-translate-x-3\\/12 {
    --transform-translate-x: -25%;
  }
  .xl\\:-translate-x-4\\/12 {
    --transform-translate-x: -33.33333%;
  }
  .xl\\:-translate-x-5\\/12 {
    --transform-translate-x: -41.66667%;
  }
  .xl\\:-translate-x-6\\/12 {
    --transform-translate-x: -50%;
  }
  .xl\\:-translate-x-7\\/12 {
    --transform-translate-x: -58.33333%;
  }
  .xl\\:-translate-x-8\\/12 {
    --transform-translate-x: -66.66667%;
  }
  .xl\\:-translate-x-9\\/12 {
    --transform-translate-x: -75%;
  }
  .xl\\:-translate-x-10\\/12 {
    --transform-translate-x: -83.33333%;
  }
  .xl\\:-translate-x-11\\/12 {
    --transform-translate-x: -91.66667%;
  }
  .xl\\:-translate-x-full {
    --transform-translate-x: -100%;
  }
  .xl\\:translate-y-0 {
    --transform-translate-y: 0;
  }
  .xl\\:translate-y-1 {
    --transform-translate-y: 0.25rem;
  }
  .xl\\:translate-y-2 {
    --transform-translate-y: 0.5rem;
  }
  .xl\\:translate-y-3 {
    --transform-translate-y: 0.75rem;
  }
  .xl\\:translate-y-4 {
    --transform-translate-y: 1rem;
  }
  .xl\\:translate-y-5 {
    --transform-translate-y: 1.25rem;
  }
  .xl\\:translate-y-6 {
    --transform-translate-y: 1.5rem;
  }
  .xl\\:translate-y-7 {
    --transform-translate-y: 1.75rem;
  }
  .xl\\:translate-y-8 {
    --transform-translate-y: 2rem;
  }
  .xl\\:translate-y-9 {
    --transform-translate-y: 2.25rem;
  }
  .xl\\:translate-y-10 {
    --transform-translate-y: 2.5rem;
  }
  .xl\\:translate-y-11 {
    --transform-translate-y: 2.75rem;
  }
  .xl\\:translate-y-12 {
    --transform-translate-y: 3rem;
  }
  .xl\\:translate-y-13 {
    --transform-translate-y: 3.25rem;
  }
  .xl\\:translate-y-14 {
    --transform-translate-y: 3.5rem;
  }
  .xl\\:translate-y-15 {
    --transform-translate-y: 3.75rem;
  }
  .xl\\:translate-y-16 {
    --transform-translate-y: 4rem;
  }
  .xl\\:translate-y-20 {
    --transform-translate-y: 5rem;
  }
  .xl\\:translate-y-24 {
    --transform-translate-y: 6rem;
  }
  .xl\\:translate-y-28 {
    --transform-translate-y: 7rem;
  }
  .xl\\:translate-y-32 {
    --transform-translate-y: 8rem;
  }
  .xl\\:translate-y-36 {
    --transform-translate-y: 9rem;
  }
  .xl\\:translate-y-40 {
    --transform-translate-y: 10rem;
  }
  .xl\\:translate-y-44 {
    --transform-translate-y: 11rem;
  }
  .xl\\:translate-y-48 {
    --transform-translate-y: 12rem;
  }
  .xl\\:translate-y-52 {
    --transform-translate-y: 13rem;
  }
  .xl\\:translate-y-56 {
    --transform-translate-y: 14rem;
  }
  .xl\\:translate-y-60 {
    --transform-translate-y: 15rem;
  }
  .xl\\:translate-y-64 {
    --transform-translate-y: 16rem;
  }
  .xl\\:translate-y-72 {
    --transform-translate-y: 18rem;
  }
  .xl\\:translate-y-80 {
    --transform-translate-y: 20rem;
  }
  .xl\\:translate-y-96 {
    --transform-translate-y: 24rem;
  }
  .xl\\:translate-y-px {
    --transform-translate-y: 1px;
  }
  .xl\\:translate-y-0\\.5 {
    --transform-translate-y: 0.125rem;
  }
  .xl\\:translate-y-1\\.5 {
    --transform-translate-y: 0.375rem;
  }
  .xl\\:translate-y-2\\.5 {
    --transform-translate-y: 0.625rem;
  }
  .xl\\:translate-y-3\\.5 {
    --transform-translate-y: 0.875rem;
  }
  .xl\\:translate-y-1\\/2 {
    --transform-translate-y: 50%;
  }
  .xl\\:translate-y-1\\/3 {
    --transform-translate-y: 33.333333%;
  }
  .xl\\:translate-y-2\\/3 {
    --transform-translate-y: 66.666667%;
  }
  .xl\\:translate-y-1\\/4 {
    --transform-translate-y: 25%;
  }
  .xl\\:translate-y-2\\/4 {
    --transform-translate-y: 50%;
  }
  .xl\\:translate-y-3\\/4 {
    --transform-translate-y: 75%;
  }
  .xl\\:translate-y-1\\/5 {
    --transform-translate-y: 20%;
  }
  .xl\\:translate-y-2\\/5 {
    --transform-translate-y: 40%;
  }
  .xl\\:translate-y-3\\/5 {
    --transform-translate-y: 60%;
  }
  .xl\\:translate-y-4\\/5 {
    --transform-translate-y: 80%;
  }
  .xl\\:translate-y-1\\/6 {
    --transform-translate-y: 16.666667%;
  }
  .xl\\:translate-y-2\\/6 {
    --transform-translate-y: 33.333333%;
  }
  .xl\\:translate-y-3\\/6 {
    --transform-translate-y: 50%;
  }
  .xl\\:translate-y-4\\/6 {
    --transform-translate-y: 66.666667%;
  }
  .xl\\:translate-y-5\\/6 {
    --transform-translate-y: 83.333333%;
  }
  .xl\\:translate-y-1\\/12 {
    --transform-translate-y: 8.333333%;
  }
  .xl\\:translate-y-2\\/12 {
    --transform-translate-y: 16.666667%;
  }
  .xl\\:translate-y-3\\/12 {
    --transform-translate-y: 25%;
  }
  .xl\\:translate-y-4\\/12 {
    --transform-translate-y: 33.333333%;
  }
  .xl\\:translate-y-5\\/12 {
    --transform-translate-y: 41.666667%;
  }
  .xl\\:translate-y-6\\/12 {
    --transform-translate-y: 50%;
  }
  .xl\\:translate-y-7\\/12 {
    --transform-translate-y: 58.333333%;
  }
  .xl\\:translate-y-8\\/12 {
    --transform-translate-y: 66.666667%;
  }
  .xl\\:translate-y-9\\/12 {
    --transform-translate-y: 75%;
  }
  .xl\\:translate-y-10\\/12 {
    --transform-translate-y: 83.333333%;
  }
  .xl\\:translate-y-11\\/12 {
    --transform-translate-y: 91.666667%;
  }
  .xl\\:translate-y-full {
    --transform-translate-y: 100%;
  }
  .xl\\:-translate-y-1 {
    --transform-translate-y: -0.25rem;
  }
  .xl\\:-translate-y-2 {
    --transform-translate-y: -0.5rem;
  }
  .xl\\:-translate-y-3 {
    --transform-translate-y: -0.75rem;
  }
  .xl\\:-translate-y-4 {
    --transform-translate-y: -1rem;
  }
  .xl\\:-translate-y-5 {
    --transform-translate-y: -1.25rem;
  }
  .xl\\:-translate-y-6 {
    --transform-translate-y: -1.5rem;
  }
  .xl\\:-translate-y-7 {
    --transform-translate-y: -1.75rem;
  }
  .xl\\:-translate-y-8 {
    --transform-translate-y: -2rem;
  }
  .xl\\:-translate-y-9 {
    --transform-translate-y: -2.25rem;
  }
  .xl\\:-translate-y-10 {
    --transform-translate-y: -2.5rem;
  }
  .xl\\:-translate-y-11 {
    --transform-translate-y: -2.75rem;
  }
  .xl\\:-translate-y-12 {
    --transform-translate-y: -3rem;
  }
  .xl\\:-translate-y-13 {
    --transform-translate-y: -3.25rem;
  }
  .xl\\:-translate-y-14 {
    --transform-translate-y: -3.5rem;
  }
  .xl\\:-translate-y-15 {
    --transform-translate-y: -3.75rem;
  }
  .xl\\:-translate-y-16 {
    --transform-translate-y: -4rem;
  }
  .xl\\:-translate-y-20 {
    --transform-translate-y: -5rem;
  }
  .xl\\:-translate-y-24 {
    --transform-translate-y: -6rem;
  }
  .xl\\:-translate-y-28 {
    --transform-translate-y: -7rem;
  }
  .xl\\:-translate-y-32 {
    --transform-translate-y: -8rem;
  }
  .xl\\:-translate-y-36 {
    --transform-translate-y: -9rem;
  }
  .xl\\:-translate-y-40 {
    --transform-translate-y: -10rem;
  }
  .xl\\:-translate-y-44 {
    --transform-translate-y: -11rem;
  }
  .xl\\:-translate-y-48 {
    --transform-translate-y: -12rem;
  }
  .xl\\:-translate-y-52 {
    --transform-translate-y: -13rem;
  }
  .xl\\:-translate-y-56 {
    --transform-translate-y: -14rem;
  }
  .xl\\:-translate-y-60 {
    --transform-translate-y: -15rem;
  }
  .xl\\:-translate-y-64 {
    --transform-translate-y: -16rem;
  }
  .xl\\:-translate-y-72 {
    --transform-translate-y: -18rem;
  }
  .xl\\:-translate-y-80 {
    --transform-translate-y: -20rem;
  }
  .xl\\:-translate-y-96 {
    --transform-translate-y: -24rem;
  }
  .xl\\:-translate-y-px {
    --transform-translate-y: -1px;
  }
  .xl\\:-translate-y-0\\.5 {
    --transform-translate-y: -0.125rem;
  }
  .xl\\:-translate-y-1\\.5 {
    --transform-translate-y: -0.375rem;
  }
  .xl\\:-translate-y-2\\.5 {
    --transform-translate-y: -0.625rem;
  }
  .xl\\:-translate-y-3\\.5 {
    --transform-translate-y: -0.875rem;
  }
  .xl\\:-translate-y-1\\/2 {
    --transform-translate-y: -50%;
  }
  .xl\\:-translate-y-1\\/3 {
    --transform-translate-y: -33.33333%;
  }
  .xl\\:-translate-y-2\\/3 {
    --transform-translate-y: -66.66667%;
  }
  .xl\\:-translate-y-1\\/4 {
    --transform-translate-y: -25%;
  }
  .xl\\:-translate-y-2\\/4 {
    --transform-translate-y: -50%;
  }
  .xl\\:-translate-y-3\\/4 {
    --transform-translate-y: -75%;
  }
  .xl\\:-translate-y-1\\/5 {
    --transform-translate-y: -20%;
  }
  .xl\\:-translate-y-2\\/5 {
    --transform-translate-y: -40%;
  }
  .xl\\:-translate-y-3\\/5 {
    --transform-translate-y: -60%;
  }
  .xl\\:-translate-y-4\\/5 {
    --transform-translate-y: -80%;
  }
  .xl\\:-translate-y-1\\/6 {
    --transform-translate-y: -16.66667%;
  }
  .xl\\:-translate-y-2\\/6 {
    --transform-translate-y: -33.33333%;
  }
  .xl\\:-translate-y-3\\/6 {
    --transform-translate-y: -50%;
  }
  .xl\\:-translate-y-4\\/6 {
    --transform-translate-y: -66.66667%;
  }
  .xl\\:-translate-y-5\\/6 {
    --transform-translate-y: -83.33333%;
  }
  .xl\\:-translate-y-1\\/12 {
    --transform-translate-y: -8.33333%;
  }
  .xl\\:-translate-y-2\\/12 {
    --transform-translate-y: -16.66667%;
  }
  .xl\\:-translate-y-3\\/12 {
    --transform-translate-y: -25%;
  }
  .xl\\:-translate-y-4\\/12 {
    --transform-translate-y: -33.33333%;
  }
  .xl\\:-translate-y-5\\/12 {
    --transform-translate-y: -41.66667%;
  }
  .xl\\:-translate-y-6\\/12 {
    --transform-translate-y: -50%;
  }
  .xl\\:-translate-y-7\\/12 {
    --transform-translate-y: -58.33333%;
  }
  .xl\\:-translate-y-8\\/12 {
    --transform-translate-y: -66.66667%;
  }
  .xl\\:-translate-y-9\\/12 {
    --transform-translate-y: -75%;
  }
  .xl\\:-translate-y-10\\/12 {
    --transform-translate-y: -83.33333%;
  }
  .xl\\:-translate-y-11\\/12 {
    --transform-translate-y: -91.66667%;
  }
  .xl\\:-translate-y-full {
    --transform-translate-y: -100%;
  }
  .xl\\:hover\\:translate-x-0:hover {
    --transform-translate-x: 0;
  }
  .xl\\:hover\\:translate-x-1:hover {
    --transform-translate-x: 0.25rem;
  }
  .xl\\:hover\\:translate-x-2:hover {
    --transform-translate-x: 0.5rem;
  }
  .xl\\:hover\\:translate-x-3:hover {
    --transform-translate-x: 0.75rem;
  }
  .xl\\:hover\\:translate-x-4:hover {
    --transform-translate-x: 1rem;
  }
  .xl\\:hover\\:translate-x-5:hover {
    --transform-translate-x: 1.25rem;
  }
  .xl\\:hover\\:translate-x-6:hover {
    --transform-translate-x: 1.5rem;
  }
  .xl\\:hover\\:translate-x-7:hover {
    --transform-translate-x: 1.75rem;
  }
  .xl\\:hover\\:translate-x-8:hover {
    --transform-translate-x: 2rem;
  }
  .xl\\:hover\\:translate-x-9:hover {
    --transform-translate-x: 2.25rem;
  }
  .xl\\:hover\\:translate-x-10:hover {
    --transform-translate-x: 2.5rem;
  }
  .xl\\:hover\\:translate-x-11:hover {
    --transform-translate-x: 2.75rem;
  }
  .xl\\:hover\\:translate-x-12:hover {
    --transform-translate-x: 3rem;
  }
  .xl\\:hover\\:translate-x-13:hover {
    --transform-translate-x: 3.25rem;
  }
  .xl\\:hover\\:translate-x-14:hover {
    --transform-translate-x: 3.5rem;
  }
  .xl\\:hover\\:translate-x-15:hover {
    --transform-translate-x: 3.75rem;
  }
  .xl\\:hover\\:translate-x-16:hover {
    --transform-translate-x: 4rem;
  }
  .xl\\:hover\\:translate-x-20:hover {
    --transform-translate-x: 5rem;
  }
  .xl\\:hover\\:translate-x-24:hover {
    --transform-translate-x: 6rem;
  }
  .xl\\:hover\\:translate-x-28:hover {
    --transform-translate-x: 7rem;
  }
  .xl\\:hover\\:translate-x-32:hover {
    --transform-translate-x: 8rem;
  }
  .xl\\:hover\\:translate-x-36:hover {
    --transform-translate-x: 9rem;
  }
  .xl\\:hover\\:translate-x-40:hover {
    --transform-translate-x: 10rem;
  }
  .xl\\:hover\\:translate-x-44:hover {
    --transform-translate-x: 11rem;
  }
  .xl\\:hover\\:translate-x-48:hover {
    --transform-translate-x: 12rem;
  }
  .xl\\:hover\\:translate-x-52:hover {
    --transform-translate-x: 13rem;
  }
  .xl\\:hover\\:translate-x-56:hover {
    --transform-translate-x: 14rem;
  }
  .xl\\:hover\\:translate-x-60:hover {
    --transform-translate-x: 15rem;
  }
  .xl\\:hover\\:translate-x-64:hover {
    --transform-translate-x: 16rem;
  }
  .xl\\:hover\\:translate-x-72:hover {
    --transform-translate-x: 18rem;
  }
  .xl\\:hover\\:translate-x-80:hover {
    --transform-translate-x: 20rem;
  }
  .xl\\:hover\\:translate-x-96:hover {
    --transform-translate-x: 24rem;
  }
  .xl\\:hover\\:translate-x-px:hover {
    --transform-translate-x: 1px;
  }
  .xl\\:hover\\:translate-x-0\\.5:hover {
    --transform-translate-x: 0.125rem;
  }
  .xl\\:hover\\:translate-x-1\\.5:hover {
    --transform-translate-x: 0.375rem;
  }
  .xl\\:hover\\:translate-x-2\\.5:hover {
    --transform-translate-x: 0.625rem;
  }
  .xl\\:hover\\:translate-x-3\\.5:hover {
    --transform-translate-x: 0.875rem;
  }
  .xl\\:hover\\:translate-x-1\\/2:hover {
    --transform-translate-x: 50%;
  }
  .xl\\:hover\\:translate-x-1\\/3:hover {
    --transform-translate-x: 33.333333%;
  }
  .xl\\:hover\\:translate-x-2\\/3:hover {
    --transform-translate-x: 66.666667%;
  }
  .xl\\:hover\\:translate-x-1\\/4:hover {
    --transform-translate-x: 25%;
  }
  .xl\\:hover\\:translate-x-2\\/4:hover {
    --transform-translate-x: 50%;
  }
  .xl\\:hover\\:translate-x-3\\/4:hover {
    --transform-translate-x: 75%;
  }
  .xl\\:hover\\:translate-x-1\\/5:hover {
    --transform-translate-x: 20%;
  }
  .xl\\:hover\\:translate-x-2\\/5:hover {
    --transform-translate-x: 40%;
  }
  .xl\\:hover\\:translate-x-3\\/5:hover {
    --transform-translate-x: 60%;
  }
  .xl\\:hover\\:translate-x-4\\/5:hover {
    --transform-translate-x: 80%;
  }
  .xl\\:hover\\:translate-x-1\\/6:hover {
    --transform-translate-x: 16.666667%;
  }
  .xl\\:hover\\:translate-x-2\\/6:hover {
    --transform-translate-x: 33.333333%;
  }
  .xl\\:hover\\:translate-x-3\\/6:hover {
    --transform-translate-x: 50%;
  }
  .xl\\:hover\\:translate-x-4\\/6:hover {
    --transform-translate-x: 66.666667%;
  }
  .xl\\:hover\\:translate-x-5\\/6:hover {
    --transform-translate-x: 83.333333%;
  }
  .xl\\:hover\\:translate-x-1\\/12:hover {
    --transform-translate-x: 8.333333%;
  }
  .xl\\:hover\\:translate-x-2\\/12:hover {
    --transform-translate-x: 16.666667%;
  }
  .xl\\:hover\\:translate-x-3\\/12:hover {
    --transform-translate-x: 25%;
  }
  .xl\\:hover\\:translate-x-4\\/12:hover {
    --transform-translate-x: 33.333333%;
  }
  .xl\\:hover\\:translate-x-5\\/12:hover {
    --transform-translate-x: 41.666667%;
  }
  .xl\\:hover\\:translate-x-6\\/12:hover {
    --transform-translate-x: 50%;
  }
  .xl\\:hover\\:translate-x-7\\/12:hover {
    --transform-translate-x: 58.333333%;
  }
  .xl\\:hover\\:translate-x-8\\/12:hover {
    --transform-translate-x: 66.666667%;
  }
  .xl\\:hover\\:translate-x-9\\/12:hover {
    --transform-translate-x: 75%;
  }
  .xl\\:hover\\:translate-x-10\\/12:hover {
    --transform-translate-x: 83.333333%;
  }
  .xl\\:hover\\:translate-x-11\\/12:hover {
    --transform-translate-x: 91.666667%;
  }
  .xl\\:hover\\:translate-x-full:hover {
    --transform-translate-x: 100%;
  }
  .xl\\:hover\\:-translate-x-1:hover {
    --transform-translate-x: -0.25rem;
  }
  .xl\\:hover\\:-translate-x-2:hover {
    --transform-translate-x: -0.5rem;
  }
  .xl\\:hover\\:-translate-x-3:hover {
    --transform-translate-x: -0.75rem;
  }
  .xl\\:hover\\:-translate-x-4:hover {
    --transform-translate-x: -1rem;
  }
  .xl\\:hover\\:-translate-x-5:hover {
    --transform-translate-x: -1.25rem;
  }
  .xl\\:hover\\:-translate-x-6:hover {
    --transform-translate-x: -1.5rem;
  }
  .xl\\:hover\\:-translate-x-7:hover {
    --transform-translate-x: -1.75rem;
  }
  .xl\\:hover\\:-translate-x-8:hover {
    --transform-translate-x: -2rem;
  }
  .xl\\:hover\\:-translate-x-9:hover {
    --transform-translate-x: -2.25rem;
  }
  .xl\\:hover\\:-translate-x-10:hover {
    --transform-translate-x: -2.5rem;
  }
  .xl\\:hover\\:-translate-x-11:hover {
    --transform-translate-x: -2.75rem;
  }
  .xl\\:hover\\:-translate-x-12:hover {
    --transform-translate-x: -3rem;
  }
  .xl\\:hover\\:-translate-x-13:hover {
    --transform-translate-x: -3.25rem;
  }
  .xl\\:hover\\:-translate-x-14:hover {
    --transform-translate-x: -3.5rem;
  }
  .xl\\:hover\\:-translate-x-15:hover {
    --transform-translate-x: -3.75rem;
  }
  .xl\\:hover\\:-translate-x-16:hover {
    --transform-translate-x: -4rem;
  }
  .xl\\:hover\\:-translate-x-20:hover {
    --transform-translate-x: -5rem;
  }
  .xl\\:hover\\:-translate-x-24:hover {
    --transform-translate-x: -6rem;
  }
  .xl\\:hover\\:-translate-x-28:hover {
    --transform-translate-x: -7rem;
  }
  .xl\\:hover\\:-translate-x-32:hover {
    --transform-translate-x: -8rem;
  }
  .xl\\:hover\\:-translate-x-36:hover {
    --transform-translate-x: -9rem;
  }
  .xl\\:hover\\:-translate-x-40:hover {
    --transform-translate-x: -10rem;
  }
  .xl\\:hover\\:-translate-x-44:hover {
    --transform-translate-x: -11rem;
  }
  .xl\\:hover\\:-translate-x-48:hover {
    --transform-translate-x: -12rem;
  }
  .xl\\:hover\\:-translate-x-52:hover {
    --transform-translate-x: -13rem;
  }
  .xl\\:hover\\:-translate-x-56:hover {
    --transform-translate-x: -14rem;
  }
  .xl\\:hover\\:-translate-x-60:hover {
    --transform-translate-x: -15rem;
  }
  .xl\\:hover\\:-translate-x-64:hover {
    --transform-translate-x: -16rem;
  }
  .xl\\:hover\\:-translate-x-72:hover {
    --transform-translate-x: -18rem;
  }
  .xl\\:hover\\:-translate-x-80:hover {
    --transform-translate-x: -20rem;
  }
  .xl\\:hover\\:-translate-x-96:hover {
    --transform-translate-x: -24rem;
  }
  .xl\\:hover\\:-translate-x-px:hover {
    --transform-translate-x: -1px;
  }
  .xl\\:hover\\:-translate-x-0\\.5:hover {
    --transform-translate-x: -0.125rem;
  }
  .xl\\:hover\\:-translate-x-1\\.5:hover {
    --transform-translate-x: -0.375rem;
  }
  .xl\\:hover\\:-translate-x-2\\.5:hover {
    --transform-translate-x: -0.625rem;
  }
  .xl\\:hover\\:-translate-x-3\\.5:hover {
    --transform-translate-x: -0.875rem;
  }
  .xl\\:hover\\:-translate-x-1\\/2:hover {
    --transform-translate-x: -50%;
  }
  .xl\\:hover\\:-translate-x-1\\/3:hover {
    --transform-translate-x: -33.33333%;
  }
  .xl\\:hover\\:-translate-x-2\\/3:hover {
    --transform-translate-x: -66.66667%;
  }
  .xl\\:hover\\:-translate-x-1\\/4:hover {
    --transform-translate-x: -25%;
  }
  .xl\\:hover\\:-translate-x-2\\/4:hover {
    --transform-translate-x: -50%;
  }
  .xl\\:hover\\:-translate-x-3\\/4:hover {
    --transform-translate-x: -75%;
  }
  .xl\\:hover\\:-translate-x-1\\/5:hover {
    --transform-translate-x: -20%;
  }
  .xl\\:hover\\:-translate-x-2\\/5:hover {
    --transform-translate-x: -40%;
  }
  .xl\\:hover\\:-translate-x-3\\/5:hover {
    --transform-translate-x: -60%;
  }
  .xl\\:hover\\:-translate-x-4\\/5:hover {
    --transform-translate-x: -80%;
  }
  .xl\\:hover\\:-translate-x-1\\/6:hover {
    --transform-translate-x: -16.66667%;
  }
  .xl\\:hover\\:-translate-x-2\\/6:hover {
    --transform-translate-x: -33.33333%;
  }
  .xl\\:hover\\:-translate-x-3\\/6:hover {
    --transform-translate-x: -50%;
  }
  .xl\\:hover\\:-translate-x-4\\/6:hover {
    --transform-translate-x: -66.66667%;
  }
  .xl\\:hover\\:-translate-x-5\\/6:hover {
    --transform-translate-x: -83.33333%;
  }
  .xl\\:hover\\:-translate-x-1\\/12:hover {
    --transform-translate-x: -8.33333%;
  }
  .xl\\:hover\\:-translate-x-2\\/12:hover {
    --transform-translate-x: -16.66667%;
  }
  .xl\\:hover\\:-translate-x-3\\/12:hover {
    --transform-translate-x: -25%;
  }
  .xl\\:hover\\:-translate-x-4\\/12:hover {
    --transform-translate-x: -33.33333%;
  }
  .xl\\:hover\\:-translate-x-5\\/12:hover {
    --transform-translate-x: -41.66667%;
  }
  .xl\\:hover\\:-translate-x-6\\/12:hover {
    --transform-translate-x: -50%;
  }
  .xl\\:hover\\:-translate-x-7\\/12:hover {
    --transform-translate-x: -58.33333%;
  }
  .xl\\:hover\\:-translate-x-8\\/12:hover {
    --transform-translate-x: -66.66667%;
  }
  .xl\\:hover\\:-translate-x-9\\/12:hover {
    --transform-translate-x: -75%;
  }
  .xl\\:hover\\:-translate-x-10\\/12:hover {
    --transform-translate-x: -83.33333%;
  }
  .xl\\:hover\\:-translate-x-11\\/12:hover {
    --transform-translate-x: -91.66667%;
  }
  .xl\\:hover\\:-translate-x-full:hover {
    --transform-translate-x: -100%;
  }
  .xl\\:hover\\:translate-y-0:hover {
    --transform-translate-y: 0;
  }
  .xl\\:hover\\:translate-y-1:hover {
    --transform-translate-y: 0.25rem;
  }
  .xl\\:hover\\:translate-y-2:hover {
    --transform-translate-y: 0.5rem;
  }
  .xl\\:hover\\:translate-y-3:hover {
    --transform-translate-y: 0.75rem;
  }
  .xl\\:hover\\:translate-y-4:hover {
    --transform-translate-y: 1rem;
  }
  .xl\\:hover\\:translate-y-5:hover {
    --transform-translate-y: 1.25rem;
  }
  .xl\\:hover\\:translate-y-6:hover {
    --transform-translate-y: 1.5rem;
  }
  .xl\\:hover\\:translate-y-7:hover {
    --transform-translate-y: 1.75rem;
  }
  .xl\\:hover\\:translate-y-8:hover {
    --transform-translate-y: 2rem;
  }
  .xl\\:hover\\:translate-y-9:hover {
    --transform-translate-y: 2.25rem;
  }
  .xl\\:hover\\:translate-y-10:hover {
    --transform-translate-y: 2.5rem;
  }
  .xl\\:hover\\:translate-y-11:hover {
    --transform-translate-y: 2.75rem;
  }
  .xl\\:hover\\:translate-y-12:hover {
    --transform-translate-y: 3rem;
  }
  .xl\\:hover\\:translate-y-13:hover {
    --transform-translate-y: 3.25rem;
  }
  .xl\\:hover\\:translate-y-14:hover {
    --transform-translate-y: 3.5rem;
  }
  .xl\\:hover\\:translate-y-15:hover {
    --transform-translate-y: 3.75rem;
  }
  .xl\\:hover\\:translate-y-16:hover {
    --transform-translate-y: 4rem;
  }
  .xl\\:hover\\:translate-y-20:hover {
    --transform-translate-y: 5rem;
  }
  .xl\\:hover\\:translate-y-24:hover {
    --transform-translate-y: 6rem;
  }
  .xl\\:hover\\:translate-y-28:hover {
    --transform-translate-y: 7rem;
  }
  .xl\\:hover\\:translate-y-32:hover {
    --transform-translate-y: 8rem;
  }
  .xl\\:hover\\:translate-y-36:hover {
    --transform-translate-y: 9rem;
  }
  .xl\\:hover\\:translate-y-40:hover {
    --transform-translate-y: 10rem;
  }
  .xl\\:hover\\:translate-y-44:hover {
    --transform-translate-y: 11rem;
  }
  .xl\\:hover\\:translate-y-48:hover {
    --transform-translate-y: 12rem;
  }
  .xl\\:hover\\:translate-y-52:hover {
    --transform-translate-y: 13rem;
  }
  .xl\\:hover\\:translate-y-56:hover {
    --transform-translate-y: 14rem;
  }
  .xl\\:hover\\:translate-y-60:hover {
    --transform-translate-y: 15rem;
  }
  .xl\\:hover\\:translate-y-64:hover {
    --transform-translate-y: 16rem;
  }
  .xl\\:hover\\:translate-y-72:hover {
    --transform-translate-y: 18rem;
  }
  .xl\\:hover\\:translate-y-80:hover {
    --transform-translate-y: 20rem;
  }
  .xl\\:hover\\:translate-y-96:hover {
    --transform-translate-y: 24rem;
  }
  .xl\\:hover\\:translate-y-px:hover {
    --transform-translate-y: 1px;
  }
  .xl\\:hover\\:translate-y-0\\.5:hover {
    --transform-translate-y: 0.125rem;
  }
  .xl\\:hover\\:translate-y-1\\.5:hover {
    --transform-translate-y: 0.375rem;
  }
  .xl\\:hover\\:translate-y-2\\.5:hover {
    --transform-translate-y: 0.625rem;
  }
  .xl\\:hover\\:translate-y-3\\.5:hover {
    --transform-translate-y: 0.875rem;
  }
  .xl\\:hover\\:translate-y-1\\/2:hover {
    --transform-translate-y: 50%;
  }
  .xl\\:hover\\:translate-y-1\\/3:hover {
    --transform-translate-y: 33.333333%;
  }
  .xl\\:hover\\:translate-y-2\\/3:hover {
    --transform-translate-y: 66.666667%;
  }
  .xl\\:hover\\:translate-y-1\\/4:hover {
    --transform-translate-y: 25%;
  }
  .xl\\:hover\\:translate-y-2\\/4:hover {
    --transform-translate-y: 50%;
  }
  .xl\\:hover\\:translate-y-3\\/4:hover {
    --transform-translate-y: 75%;
  }
  .xl\\:hover\\:translate-y-1\\/5:hover {
    --transform-translate-y: 20%;
  }
  .xl\\:hover\\:translate-y-2\\/5:hover {
    --transform-translate-y: 40%;
  }
  .xl\\:hover\\:translate-y-3\\/5:hover {
    --transform-translate-y: 60%;
  }
  .xl\\:hover\\:translate-y-4\\/5:hover {
    --transform-translate-y: 80%;
  }
  .xl\\:hover\\:translate-y-1\\/6:hover {
    --transform-translate-y: 16.666667%;
  }
  .xl\\:hover\\:translate-y-2\\/6:hover {
    --transform-translate-y: 33.333333%;
  }
  .xl\\:hover\\:translate-y-3\\/6:hover {
    --transform-translate-y: 50%;
  }
  .xl\\:hover\\:translate-y-4\\/6:hover {
    --transform-translate-y: 66.666667%;
  }
  .xl\\:hover\\:translate-y-5\\/6:hover {
    --transform-translate-y: 83.333333%;
  }
  .xl\\:hover\\:translate-y-1\\/12:hover {
    --transform-translate-y: 8.333333%;
  }
  .xl\\:hover\\:translate-y-2\\/12:hover {
    --transform-translate-y: 16.666667%;
  }
  .xl\\:hover\\:translate-y-3\\/12:hover {
    --transform-translate-y: 25%;
  }
  .xl\\:hover\\:translate-y-4\\/12:hover {
    --transform-translate-y: 33.333333%;
  }
  .xl\\:hover\\:translate-y-5\\/12:hover {
    --transform-translate-y: 41.666667%;
  }
  .xl\\:hover\\:translate-y-6\\/12:hover {
    --transform-translate-y: 50%;
  }
  .xl\\:hover\\:translate-y-7\\/12:hover {
    --transform-translate-y: 58.333333%;
  }
  .xl\\:hover\\:translate-y-8\\/12:hover {
    --transform-translate-y: 66.666667%;
  }
  .xl\\:hover\\:translate-y-9\\/12:hover {
    --transform-translate-y: 75%;
  }
  .xl\\:hover\\:translate-y-10\\/12:hover {
    --transform-translate-y: 83.333333%;
  }
  .xl\\:hover\\:translate-y-11\\/12:hover {
    --transform-translate-y: 91.666667%;
  }
  .xl\\:hover\\:translate-y-full:hover {
    --transform-translate-y: 100%;
  }
  .xl\\:hover\\:-translate-y-1:hover {
    --transform-translate-y: -0.25rem;
  }
  .xl\\:hover\\:-translate-y-2:hover {
    --transform-translate-y: -0.5rem;
  }
  .xl\\:hover\\:-translate-y-3:hover {
    --transform-translate-y: -0.75rem;
  }
  .xl\\:hover\\:-translate-y-4:hover {
    --transform-translate-y: -1rem;
  }
  .xl\\:hover\\:-translate-y-5:hover {
    --transform-translate-y: -1.25rem;
  }
  .xl\\:hover\\:-translate-y-6:hover {
    --transform-translate-y: -1.5rem;
  }
  .xl\\:hover\\:-translate-y-7:hover {
    --transform-translate-y: -1.75rem;
  }
  .xl\\:hover\\:-translate-y-8:hover {
    --transform-translate-y: -2rem;
  }
  .xl\\:hover\\:-translate-y-9:hover {
    --transform-translate-y: -2.25rem;
  }
  .xl\\:hover\\:-translate-y-10:hover {
    --transform-translate-y: -2.5rem;
  }
  .xl\\:hover\\:-translate-y-11:hover {
    --transform-translate-y: -2.75rem;
  }
  .xl\\:hover\\:-translate-y-12:hover {
    --transform-translate-y: -3rem;
  }
  .xl\\:hover\\:-translate-y-13:hover {
    --transform-translate-y: -3.25rem;
  }
  .xl\\:hover\\:-translate-y-14:hover {
    --transform-translate-y: -3.5rem;
  }
  .xl\\:hover\\:-translate-y-15:hover {
    --transform-translate-y: -3.75rem;
  }
  .xl\\:hover\\:-translate-y-16:hover {
    --transform-translate-y: -4rem;
  }
  .xl\\:hover\\:-translate-y-20:hover {
    --transform-translate-y: -5rem;
  }
  .xl\\:hover\\:-translate-y-24:hover {
    --transform-translate-y: -6rem;
  }
  .xl\\:hover\\:-translate-y-28:hover {
    --transform-translate-y: -7rem;
  }
  .xl\\:hover\\:-translate-y-32:hover {
    --transform-translate-y: -8rem;
  }
  .xl\\:hover\\:-translate-y-36:hover {
    --transform-translate-y: -9rem;
  }
  .xl\\:hover\\:-translate-y-40:hover {
    --transform-translate-y: -10rem;
  }
  .xl\\:hover\\:-translate-y-44:hover {
    --transform-translate-y: -11rem;
  }
  .xl\\:hover\\:-translate-y-48:hover {
    --transform-translate-y: -12rem;
  }
  .xl\\:hover\\:-translate-y-52:hover {
    --transform-translate-y: -13rem;
  }
  .xl\\:hover\\:-translate-y-56:hover {
    --transform-translate-y: -14rem;
  }
  .xl\\:hover\\:-translate-y-60:hover {
    --transform-translate-y: -15rem;
  }
  .xl\\:hover\\:-translate-y-64:hover {
    --transform-translate-y: -16rem;
  }
  .xl\\:hover\\:-translate-y-72:hover {
    --transform-translate-y: -18rem;
  }
  .xl\\:hover\\:-translate-y-80:hover {
    --transform-translate-y: -20rem;
  }
  .xl\\:hover\\:-translate-y-96:hover {
    --transform-translate-y: -24rem;
  }
  .xl\\:hover\\:-translate-y-px:hover {
    --transform-translate-y: -1px;
  }
  .xl\\:hover\\:-translate-y-0\\.5:hover {
    --transform-translate-y: -0.125rem;
  }
  .xl\\:hover\\:-translate-y-1\\.5:hover {
    --transform-translate-y: -0.375rem;
  }
  .xl\\:hover\\:-translate-y-2\\.5:hover {
    --transform-translate-y: -0.625rem;
  }
  .xl\\:hover\\:-translate-y-3\\.5:hover {
    --transform-translate-y: -0.875rem;
  }
  .xl\\:hover\\:-translate-y-1\\/2:hover {
    --transform-translate-y: -50%;
  }
  .xl\\:hover\\:-translate-y-1\\/3:hover {
    --transform-translate-y: -33.33333%;
  }
  .xl\\:hover\\:-translate-y-2\\/3:hover {
    --transform-translate-y: -66.66667%;
  }
  .xl\\:hover\\:-translate-y-1\\/4:hover {
    --transform-translate-y: -25%;
  }
  .xl\\:hover\\:-translate-y-2\\/4:hover {
    --transform-translate-y: -50%;
  }
  .xl\\:hover\\:-translate-y-3\\/4:hover {
    --transform-translate-y: -75%;
  }
  .xl\\:hover\\:-translate-y-1\\/5:hover {
    --transform-translate-y: -20%;
  }
  .xl\\:hover\\:-translate-y-2\\/5:hover {
    --transform-translate-y: -40%;
  }
  .xl\\:hover\\:-translate-y-3\\/5:hover {
    --transform-translate-y: -60%;
  }
  .xl\\:hover\\:-translate-y-4\\/5:hover {
    --transform-translate-y: -80%;
  }
  .xl\\:hover\\:-translate-y-1\\/6:hover {
    --transform-translate-y: -16.66667%;
  }
  .xl\\:hover\\:-translate-y-2\\/6:hover {
    --transform-translate-y: -33.33333%;
  }
  .xl\\:hover\\:-translate-y-3\\/6:hover {
    --transform-translate-y: -50%;
  }
  .xl\\:hover\\:-translate-y-4\\/6:hover {
    --transform-translate-y: -66.66667%;
  }
  .xl\\:hover\\:-translate-y-5\\/6:hover {
    --transform-translate-y: -83.33333%;
  }
  .xl\\:hover\\:-translate-y-1\\/12:hover {
    --transform-translate-y: -8.33333%;
  }
  .xl\\:hover\\:-translate-y-2\\/12:hover {
    --transform-translate-y: -16.66667%;
  }
  .xl\\:hover\\:-translate-y-3\\/12:hover {
    --transform-translate-y: -25%;
  }
  .xl\\:hover\\:-translate-y-4\\/12:hover {
    --transform-translate-y: -33.33333%;
  }
  .xl\\:hover\\:-translate-y-5\\/12:hover {
    --transform-translate-y: -41.66667%;
  }
  .xl\\:hover\\:-translate-y-6\\/12:hover {
    --transform-translate-y: -50%;
  }
  .xl\\:hover\\:-translate-y-7\\/12:hover {
    --transform-translate-y: -58.33333%;
  }
  .xl\\:hover\\:-translate-y-8\\/12:hover {
    --transform-translate-y: -66.66667%;
  }
  .xl\\:hover\\:-translate-y-9\\/12:hover {
    --transform-translate-y: -75%;
  }
  .xl\\:hover\\:-translate-y-10\\/12:hover {
    --transform-translate-y: -83.33333%;
  }
  .xl\\:hover\\:-translate-y-11\\/12:hover {
    --transform-translate-y: -91.66667%;
  }
  .xl\\:hover\\:-translate-y-full:hover {
    --transform-translate-y: -100%;
  }
  .xl\\:focus\\:translate-x-0:focus {
    --transform-translate-x: 0;
  }
  .xl\\:focus\\:translate-x-1:focus {
    --transform-translate-x: 0.25rem;
  }
  .xl\\:focus\\:translate-x-2:focus {
    --transform-translate-x: 0.5rem;
  }
  .xl\\:focus\\:translate-x-3:focus {
    --transform-translate-x: 0.75rem;
  }
  .xl\\:focus\\:translate-x-4:focus {
    --transform-translate-x: 1rem;
  }
  .xl\\:focus\\:translate-x-5:focus {
    --transform-translate-x: 1.25rem;
  }
  .xl\\:focus\\:translate-x-6:focus {
    --transform-translate-x: 1.5rem;
  }
  .xl\\:focus\\:translate-x-7:focus {
    --transform-translate-x: 1.75rem;
  }
  .xl\\:focus\\:translate-x-8:focus {
    --transform-translate-x: 2rem;
  }
  .xl\\:focus\\:translate-x-9:focus {
    --transform-translate-x: 2.25rem;
  }
  .xl\\:focus\\:translate-x-10:focus {
    --transform-translate-x: 2.5rem;
  }
  .xl\\:focus\\:translate-x-11:focus {
    --transform-translate-x: 2.75rem;
  }
  .xl\\:focus\\:translate-x-12:focus {
    --transform-translate-x: 3rem;
  }
  .xl\\:focus\\:translate-x-13:focus {
    --transform-translate-x: 3.25rem;
  }
  .xl\\:focus\\:translate-x-14:focus {
    --transform-translate-x: 3.5rem;
  }
  .xl\\:focus\\:translate-x-15:focus {
    --transform-translate-x: 3.75rem;
  }
  .xl\\:focus\\:translate-x-16:focus {
    --transform-translate-x: 4rem;
  }
  .xl\\:focus\\:translate-x-20:focus {
    --transform-translate-x: 5rem;
  }
  .xl\\:focus\\:translate-x-24:focus {
    --transform-translate-x: 6rem;
  }
  .xl\\:focus\\:translate-x-28:focus {
    --transform-translate-x: 7rem;
  }
  .xl\\:focus\\:translate-x-32:focus {
    --transform-translate-x: 8rem;
  }
  .xl\\:focus\\:translate-x-36:focus {
    --transform-translate-x: 9rem;
  }
  .xl\\:focus\\:translate-x-40:focus {
    --transform-translate-x: 10rem;
  }
  .xl\\:focus\\:translate-x-44:focus {
    --transform-translate-x: 11rem;
  }
  .xl\\:focus\\:translate-x-48:focus {
    --transform-translate-x: 12rem;
  }
  .xl\\:focus\\:translate-x-52:focus {
    --transform-translate-x: 13rem;
  }
  .xl\\:focus\\:translate-x-56:focus {
    --transform-translate-x: 14rem;
  }
  .xl\\:focus\\:translate-x-60:focus {
    --transform-translate-x: 15rem;
  }
  .xl\\:focus\\:translate-x-64:focus {
    --transform-translate-x: 16rem;
  }
  .xl\\:focus\\:translate-x-72:focus {
    --transform-translate-x: 18rem;
  }
  .xl\\:focus\\:translate-x-80:focus {
    --transform-translate-x: 20rem;
  }
  .xl\\:focus\\:translate-x-96:focus {
    --transform-translate-x: 24rem;
  }
  .xl\\:focus\\:translate-x-px:focus {
    --transform-translate-x: 1px;
  }
  .xl\\:focus\\:translate-x-0\\.5:focus {
    --transform-translate-x: 0.125rem;
  }
  .xl\\:focus\\:translate-x-1\\.5:focus {
    --transform-translate-x: 0.375rem;
  }
  .xl\\:focus\\:translate-x-2\\.5:focus {
    --transform-translate-x: 0.625rem;
  }
  .xl\\:focus\\:translate-x-3\\.5:focus {
    --transform-translate-x: 0.875rem;
  }
  .xl\\:focus\\:translate-x-1\\/2:focus {
    --transform-translate-x: 50%;
  }
  .xl\\:focus\\:translate-x-1\\/3:focus {
    --transform-translate-x: 33.333333%;
  }
  .xl\\:focus\\:translate-x-2\\/3:focus {
    --transform-translate-x: 66.666667%;
  }
  .xl\\:focus\\:translate-x-1\\/4:focus {
    --transform-translate-x: 25%;
  }
  .xl\\:focus\\:translate-x-2\\/4:focus {
    --transform-translate-x: 50%;
  }
  .xl\\:focus\\:translate-x-3\\/4:focus {
    --transform-translate-x: 75%;
  }
  .xl\\:focus\\:translate-x-1\\/5:focus {
    --transform-translate-x: 20%;
  }
  .xl\\:focus\\:translate-x-2\\/5:focus {
    --transform-translate-x: 40%;
  }
  .xl\\:focus\\:translate-x-3\\/5:focus {
    --transform-translate-x: 60%;
  }
  .xl\\:focus\\:translate-x-4\\/5:focus {
    --transform-translate-x: 80%;
  }
  .xl\\:focus\\:translate-x-1\\/6:focus {
    --transform-translate-x: 16.666667%;
  }
  .xl\\:focus\\:translate-x-2\\/6:focus {
    --transform-translate-x: 33.333333%;
  }
  .xl\\:focus\\:translate-x-3\\/6:focus {
    --transform-translate-x: 50%;
  }
  .xl\\:focus\\:translate-x-4\\/6:focus {
    --transform-translate-x: 66.666667%;
  }
  .xl\\:focus\\:translate-x-5\\/6:focus {
    --transform-translate-x: 83.333333%;
  }
  .xl\\:focus\\:translate-x-1\\/12:focus {
    --transform-translate-x: 8.333333%;
  }
  .xl\\:focus\\:translate-x-2\\/12:focus {
    --transform-translate-x: 16.666667%;
  }
  .xl\\:focus\\:translate-x-3\\/12:focus {
    --transform-translate-x: 25%;
  }
  .xl\\:focus\\:translate-x-4\\/12:focus {
    --transform-translate-x: 33.333333%;
  }
  .xl\\:focus\\:translate-x-5\\/12:focus {
    --transform-translate-x: 41.666667%;
  }
  .xl\\:focus\\:translate-x-6\\/12:focus {
    --transform-translate-x: 50%;
  }
  .xl\\:focus\\:translate-x-7\\/12:focus {
    --transform-translate-x: 58.333333%;
  }
  .xl\\:focus\\:translate-x-8\\/12:focus {
    --transform-translate-x: 66.666667%;
  }
  .xl\\:focus\\:translate-x-9\\/12:focus {
    --transform-translate-x: 75%;
  }
  .xl\\:focus\\:translate-x-10\\/12:focus {
    --transform-translate-x: 83.333333%;
  }
  .xl\\:focus\\:translate-x-11\\/12:focus {
    --transform-translate-x: 91.666667%;
  }
  .xl\\:focus\\:translate-x-full:focus {
    --transform-translate-x: 100%;
  }
  .xl\\:focus\\:-translate-x-1:focus {
    --transform-translate-x: -0.25rem;
  }
  .xl\\:focus\\:-translate-x-2:focus {
    --transform-translate-x: -0.5rem;
  }
  .xl\\:focus\\:-translate-x-3:focus {
    --transform-translate-x: -0.75rem;
  }
  .xl\\:focus\\:-translate-x-4:focus {
    --transform-translate-x: -1rem;
  }
  .xl\\:focus\\:-translate-x-5:focus {
    --transform-translate-x: -1.25rem;
  }
  .xl\\:focus\\:-translate-x-6:focus {
    --transform-translate-x: -1.5rem;
  }
  .xl\\:focus\\:-translate-x-7:focus {
    --transform-translate-x: -1.75rem;
  }
  .xl\\:focus\\:-translate-x-8:focus {
    --transform-translate-x: -2rem;
  }
  .xl\\:focus\\:-translate-x-9:focus {
    --transform-translate-x: -2.25rem;
  }
  .xl\\:focus\\:-translate-x-10:focus {
    --transform-translate-x: -2.5rem;
  }
  .xl\\:focus\\:-translate-x-11:focus {
    --transform-translate-x: -2.75rem;
  }
  .xl\\:focus\\:-translate-x-12:focus {
    --transform-translate-x: -3rem;
  }
  .xl\\:focus\\:-translate-x-13:focus {
    --transform-translate-x: -3.25rem;
  }
  .xl\\:focus\\:-translate-x-14:focus {
    --transform-translate-x: -3.5rem;
  }
  .xl\\:focus\\:-translate-x-15:focus {
    --transform-translate-x: -3.75rem;
  }
  .xl\\:focus\\:-translate-x-16:focus {
    --transform-translate-x: -4rem;
  }
  .xl\\:focus\\:-translate-x-20:focus {
    --transform-translate-x: -5rem;
  }
  .xl\\:focus\\:-translate-x-24:focus {
    --transform-translate-x: -6rem;
  }
  .xl\\:focus\\:-translate-x-28:focus {
    --transform-translate-x: -7rem;
  }
  .xl\\:focus\\:-translate-x-32:focus {
    --transform-translate-x: -8rem;
  }
  .xl\\:focus\\:-translate-x-36:focus {
    --transform-translate-x: -9rem;
  }
  .xl\\:focus\\:-translate-x-40:focus {
    --transform-translate-x: -10rem;
  }
  .xl\\:focus\\:-translate-x-44:focus {
    --transform-translate-x: -11rem;
  }
  .xl\\:focus\\:-translate-x-48:focus {
    --transform-translate-x: -12rem;
  }
  .xl\\:focus\\:-translate-x-52:focus {
    --transform-translate-x: -13rem;
  }
  .xl\\:focus\\:-translate-x-56:focus {
    --transform-translate-x: -14rem;
  }
  .xl\\:focus\\:-translate-x-60:focus {
    --transform-translate-x: -15rem;
  }
  .xl\\:focus\\:-translate-x-64:focus {
    --transform-translate-x: -16rem;
  }
  .xl\\:focus\\:-translate-x-72:focus {
    --transform-translate-x: -18rem;
  }
  .xl\\:focus\\:-translate-x-80:focus {
    --transform-translate-x: -20rem;
  }
  .xl\\:focus\\:-translate-x-96:focus {
    --transform-translate-x: -24rem;
  }
  .xl\\:focus\\:-translate-x-px:focus {
    --transform-translate-x: -1px;
  }
  .xl\\:focus\\:-translate-x-0\\.5:focus {
    --transform-translate-x: -0.125rem;
  }
  .xl\\:focus\\:-translate-x-1\\.5:focus {
    --transform-translate-x: -0.375rem;
  }
  .xl\\:focus\\:-translate-x-2\\.5:focus {
    --transform-translate-x: -0.625rem;
  }
  .xl\\:focus\\:-translate-x-3\\.5:focus {
    --transform-translate-x: -0.875rem;
  }
  .xl\\:focus\\:-translate-x-1\\/2:focus {
    --transform-translate-x: -50%;
  }
  .xl\\:focus\\:-translate-x-1\\/3:focus {
    --transform-translate-x: -33.33333%;
  }
  .xl\\:focus\\:-translate-x-2\\/3:focus {
    --transform-translate-x: -66.66667%;
  }
  .xl\\:focus\\:-translate-x-1\\/4:focus {
    --transform-translate-x: -25%;
  }
  .xl\\:focus\\:-translate-x-2\\/4:focus {
    --transform-translate-x: -50%;
  }
  .xl\\:focus\\:-translate-x-3\\/4:focus {
    --transform-translate-x: -75%;
  }
  .xl\\:focus\\:-translate-x-1\\/5:focus {
    --transform-translate-x: -20%;
  }
  .xl\\:focus\\:-translate-x-2\\/5:focus {
    --transform-translate-x: -40%;
  }
  .xl\\:focus\\:-translate-x-3\\/5:focus {
    --transform-translate-x: -60%;
  }
  .xl\\:focus\\:-translate-x-4\\/5:focus {
    --transform-translate-x: -80%;
  }
  .xl\\:focus\\:-translate-x-1\\/6:focus {
    --transform-translate-x: -16.66667%;
  }
  .xl\\:focus\\:-translate-x-2\\/6:focus {
    --transform-translate-x: -33.33333%;
  }
  .xl\\:focus\\:-translate-x-3\\/6:focus {
    --transform-translate-x: -50%;
  }
  .xl\\:focus\\:-translate-x-4\\/6:focus {
    --transform-translate-x: -66.66667%;
  }
  .xl\\:focus\\:-translate-x-5\\/6:focus {
    --transform-translate-x: -83.33333%;
  }
  .xl\\:focus\\:-translate-x-1\\/12:focus {
    --transform-translate-x: -8.33333%;
  }
  .xl\\:focus\\:-translate-x-2\\/12:focus {
    --transform-translate-x: -16.66667%;
  }
  .xl\\:focus\\:-translate-x-3\\/12:focus {
    --transform-translate-x: -25%;
  }
  .xl\\:focus\\:-translate-x-4\\/12:focus {
    --transform-translate-x: -33.33333%;
  }
  .xl\\:focus\\:-translate-x-5\\/12:focus {
    --transform-translate-x: -41.66667%;
  }
  .xl\\:focus\\:-translate-x-6\\/12:focus {
    --transform-translate-x: -50%;
  }
  .xl\\:focus\\:-translate-x-7\\/12:focus {
    --transform-translate-x: -58.33333%;
  }
  .xl\\:focus\\:-translate-x-8\\/12:focus {
    --transform-translate-x: -66.66667%;
  }
  .xl\\:focus\\:-translate-x-9\\/12:focus {
    --transform-translate-x: -75%;
  }
  .xl\\:focus\\:-translate-x-10\\/12:focus {
    --transform-translate-x: -83.33333%;
  }
  .xl\\:focus\\:-translate-x-11\\/12:focus {
    --transform-translate-x: -91.66667%;
  }
  .xl\\:focus\\:-translate-x-full:focus {
    --transform-translate-x: -100%;
  }
  .xl\\:focus\\:translate-y-0:focus {
    --transform-translate-y: 0;
  }
  .xl\\:focus\\:translate-y-1:focus {
    --transform-translate-y: 0.25rem;
  }
  .xl\\:focus\\:translate-y-2:focus {
    --transform-translate-y: 0.5rem;
  }
  .xl\\:focus\\:translate-y-3:focus {
    --transform-translate-y: 0.75rem;
  }
  .xl\\:focus\\:translate-y-4:focus {
    --transform-translate-y: 1rem;
  }
  .xl\\:focus\\:translate-y-5:focus {
    --transform-translate-y: 1.25rem;
  }
  .xl\\:focus\\:translate-y-6:focus {
    --transform-translate-y: 1.5rem;
  }
  .xl\\:focus\\:translate-y-7:focus {
    --transform-translate-y: 1.75rem;
  }
  .xl\\:focus\\:translate-y-8:focus {
    --transform-translate-y: 2rem;
  }
  .xl\\:focus\\:translate-y-9:focus {
    --transform-translate-y: 2.25rem;
  }
  .xl\\:focus\\:translate-y-10:focus {
    --transform-translate-y: 2.5rem;
  }
  .xl\\:focus\\:translate-y-11:focus {
    --transform-translate-y: 2.75rem;
  }
  .xl\\:focus\\:translate-y-12:focus {
    --transform-translate-y: 3rem;
  }
  .xl\\:focus\\:translate-y-13:focus {
    --transform-translate-y: 3.25rem;
  }
  .xl\\:focus\\:translate-y-14:focus {
    --transform-translate-y: 3.5rem;
  }
  .xl\\:focus\\:translate-y-15:focus {
    --transform-translate-y: 3.75rem;
  }
  .xl\\:focus\\:translate-y-16:focus {
    --transform-translate-y: 4rem;
  }
  .xl\\:focus\\:translate-y-20:focus {
    --transform-translate-y: 5rem;
  }
  .xl\\:focus\\:translate-y-24:focus {
    --transform-translate-y: 6rem;
  }
  .xl\\:focus\\:translate-y-28:focus {
    --transform-translate-y: 7rem;
  }
  .xl\\:focus\\:translate-y-32:focus {
    --transform-translate-y: 8rem;
  }
  .xl\\:focus\\:translate-y-36:focus {
    --transform-translate-y: 9rem;
  }
  .xl\\:focus\\:translate-y-40:focus {
    --transform-translate-y: 10rem;
  }
  .xl\\:focus\\:translate-y-44:focus {
    --transform-translate-y: 11rem;
  }
  .xl\\:focus\\:translate-y-48:focus {
    --transform-translate-y: 12rem;
  }
  .xl\\:focus\\:translate-y-52:focus {
    --transform-translate-y: 13rem;
  }
  .xl\\:focus\\:translate-y-56:focus {
    --transform-translate-y: 14rem;
  }
  .xl\\:focus\\:translate-y-60:focus {
    --transform-translate-y: 15rem;
  }
  .xl\\:focus\\:translate-y-64:focus {
    --transform-translate-y: 16rem;
  }
  .xl\\:focus\\:translate-y-72:focus {
    --transform-translate-y: 18rem;
  }
  .xl\\:focus\\:translate-y-80:focus {
    --transform-translate-y: 20rem;
  }
  .xl\\:focus\\:translate-y-96:focus {
    --transform-translate-y: 24rem;
  }
  .xl\\:focus\\:translate-y-px:focus {
    --transform-translate-y: 1px;
  }
  .xl\\:focus\\:translate-y-0\\.5:focus {
    --transform-translate-y: 0.125rem;
  }
  .xl\\:focus\\:translate-y-1\\.5:focus {
    --transform-translate-y: 0.375rem;
  }
  .xl\\:focus\\:translate-y-2\\.5:focus {
    --transform-translate-y: 0.625rem;
  }
  .xl\\:focus\\:translate-y-3\\.5:focus {
    --transform-translate-y: 0.875rem;
  }
  .xl\\:focus\\:translate-y-1\\/2:focus {
    --transform-translate-y: 50%;
  }
  .xl\\:focus\\:translate-y-1\\/3:focus {
    --transform-translate-y: 33.333333%;
  }
  .xl\\:focus\\:translate-y-2\\/3:focus {
    --transform-translate-y: 66.666667%;
  }
  .xl\\:focus\\:translate-y-1\\/4:focus {
    --transform-translate-y: 25%;
  }
  .xl\\:focus\\:translate-y-2\\/4:focus {
    --transform-translate-y: 50%;
  }
  .xl\\:focus\\:translate-y-3\\/4:focus {
    --transform-translate-y: 75%;
  }
  .xl\\:focus\\:translate-y-1\\/5:focus {
    --transform-translate-y: 20%;
  }
  .xl\\:focus\\:translate-y-2\\/5:focus {
    --transform-translate-y: 40%;
  }
  .xl\\:focus\\:translate-y-3\\/5:focus {
    --transform-translate-y: 60%;
  }
  .xl\\:focus\\:translate-y-4\\/5:focus {
    --transform-translate-y: 80%;
  }
  .xl\\:focus\\:translate-y-1\\/6:focus {
    --transform-translate-y: 16.666667%;
  }
  .xl\\:focus\\:translate-y-2\\/6:focus {
    --transform-translate-y: 33.333333%;
  }
  .xl\\:focus\\:translate-y-3\\/6:focus {
    --transform-translate-y: 50%;
  }
  .xl\\:focus\\:translate-y-4\\/6:focus {
    --transform-translate-y: 66.666667%;
  }
  .xl\\:focus\\:translate-y-5\\/6:focus {
    --transform-translate-y: 83.333333%;
  }
  .xl\\:focus\\:translate-y-1\\/12:focus {
    --transform-translate-y: 8.333333%;
  }
  .xl\\:focus\\:translate-y-2\\/12:focus {
    --transform-translate-y: 16.666667%;
  }
  .xl\\:focus\\:translate-y-3\\/12:focus {
    --transform-translate-y: 25%;
  }
  .xl\\:focus\\:translate-y-4\\/12:focus {
    --transform-translate-y: 33.333333%;
  }
  .xl\\:focus\\:translate-y-5\\/12:focus {
    --transform-translate-y: 41.666667%;
  }
  .xl\\:focus\\:translate-y-6\\/12:focus {
    --transform-translate-y: 50%;
  }
  .xl\\:focus\\:translate-y-7\\/12:focus {
    --transform-translate-y: 58.333333%;
  }
  .xl\\:focus\\:translate-y-8\\/12:focus {
    --transform-translate-y: 66.666667%;
  }
  .xl\\:focus\\:translate-y-9\\/12:focus {
    --transform-translate-y: 75%;
  }
  .xl\\:focus\\:translate-y-10\\/12:focus {
    --transform-translate-y: 83.333333%;
  }
  .xl\\:focus\\:translate-y-11\\/12:focus {
    --transform-translate-y: 91.666667%;
  }
  .xl\\:focus\\:translate-y-full:focus {
    --transform-translate-y: 100%;
  }
  .xl\\:focus\\:-translate-y-1:focus {
    --transform-translate-y: -0.25rem;
  }
  .xl\\:focus\\:-translate-y-2:focus {
    --transform-translate-y: -0.5rem;
  }
  .xl\\:focus\\:-translate-y-3:focus {
    --transform-translate-y: -0.75rem;
  }
  .xl\\:focus\\:-translate-y-4:focus {
    --transform-translate-y: -1rem;
  }
  .xl\\:focus\\:-translate-y-5:focus {
    --transform-translate-y: -1.25rem;
  }
  .xl\\:focus\\:-translate-y-6:focus {
    --transform-translate-y: -1.5rem;
  }
  .xl\\:focus\\:-translate-y-7:focus {
    --transform-translate-y: -1.75rem;
  }
  .xl\\:focus\\:-translate-y-8:focus {
    --transform-translate-y: -2rem;
  }
  .xl\\:focus\\:-translate-y-9:focus {
    --transform-translate-y: -2.25rem;
  }
  .xl\\:focus\\:-translate-y-10:focus {
    --transform-translate-y: -2.5rem;
  }
  .xl\\:focus\\:-translate-y-11:focus {
    --transform-translate-y: -2.75rem;
  }
  .xl\\:focus\\:-translate-y-12:focus {
    --transform-translate-y: -3rem;
  }
  .xl\\:focus\\:-translate-y-13:focus {
    --transform-translate-y: -3.25rem;
  }
  .xl\\:focus\\:-translate-y-14:focus {
    --transform-translate-y: -3.5rem;
  }
  .xl\\:focus\\:-translate-y-15:focus {
    --transform-translate-y: -3.75rem;
  }
  .xl\\:focus\\:-translate-y-16:focus {
    --transform-translate-y: -4rem;
  }
  .xl\\:focus\\:-translate-y-20:focus {
    --transform-translate-y: -5rem;
  }
  .xl\\:focus\\:-translate-y-24:focus {
    --transform-translate-y: -6rem;
  }
  .xl\\:focus\\:-translate-y-28:focus {
    --transform-translate-y: -7rem;
  }
  .xl\\:focus\\:-translate-y-32:focus {
    --transform-translate-y: -8rem;
  }
  .xl\\:focus\\:-translate-y-36:focus {
    --transform-translate-y: -9rem;
  }
  .xl\\:focus\\:-translate-y-40:focus {
    --transform-translate-y: -10rem;
  }
  .xl\\:focus\\:-translate-y-44:focus {
    --transform-translate-y: -11rem;
  }
  .xl\\:focus\\:-translate-y-48:focus {
    --transform-translate-y: -12rem;
  }
  .xl\\:focus\\:-translate-y-52:focus {
    --transform-translate-y: -13rem;
  }
  .xl\\:focus\\:-translate-y-56:focus {
    --transform-translate-y: -14rem;
  }
  .xl\\:focus\\:-translate-y-60:focus {
    --transform-translate-y: -15rem;
  }
  .xl\\:focus\\:-translate-y-64:focus {
    --transform-translate-y: -16rem;
  }
  .xl\\:focus\\:-translate-y-72:focus {
    --transform-translate-y: -18rem;
  }
  .xl\\:focus\\:-translate-y-80:focus {
    --transform-translate-y: -20rem;
  }
  .xl\\:focus\\:-translate-y-96:focus {
    --transform-translate-y: -24rem;
  }
  .xl\\:focus\\:-translate-y-px:focus {
    --transform-translate-y: -1px;
  }
  .xl\\:focus\\:-translate-y-0\\.5:focus {
    --transform-translate-y: -0.125rem;
  }
  .xl\\:focus\\:-translate-y-1\\.5:focus {
    --transform-translate-y: -0.375rem;
  }
  .xl\\:focus\\:-translate-y-2\\.5:focus {
    --transform-translate-y: -0.625rem;
  }
  .xl\\:focus\\:-translate-y-3\\.5:focus {
    --transform-translate-y: -0.875rem;
  }
  .xl\\:focus\\:-translate-y-1\\/2:focus {
    --transform-translate-y: -50%;
  }
  .xl\\:focus\\:-translate-y-1\\/3:focus {
    --transform-translate-y: -33.33333%;
  }
  .xl\\:focus\\:-translate-y-2\\/3:focus {
    --transform-translate-y: -66.66667%;
  }
  .xl\\:focus\\:-translate-y-1\\/4:focus {
    --transform-translate-y: -25%;
  }
  .xl\\:focus\\:-translate-y-2\\/4:focus {
    --transform-translate-y: -50%;
  }
  .xl\\:focus\\:-translate-y-3\\/4:focus {
    --transform-translate-y: -75%;
  }
  .xl\\:focus\\:-translate-y-1\\/5:focus {
    --transform-translate-y: -20%;
  }
  .xl\\:focus\\:-translate-y-2\\/5:focus {
    --transform-translate-y: -40%;
  }
  .xl\\:focus\\:-translate-y-3\\/5:focus {
    --transform-translate-y: -60%;
  }
  .xl\\:focus\\:-translate-y-4\\/5:focus {
    --transform-translate-y: -80%;
  }
  .xl\\:focus\\:-translate-y-1\\/6:focus {
    --transform-translate-y: -16.66667%;
  }
  .xl\\:focus\\:-translate-y-2\\/6:focus {
    --transform-translate-y: -33.33333%;
  }
  .xl\\:focus\\:-translate-y-3\\/6:focus {
    --transform-translate-y: -50%;
  }
  .xl\\:focus\\:-translate-y-4\\/6:focus {
    --transform-translate-y: -66.66667%;
  }
  .xl\\:focus\\:-translate-y-5\\/6:focus {
    --transform-translate-y: -83.33333%;
  }
  .xl\\:focus\\:-translate-y-1\\/12:focus {
    --transform-translate-y: -8.33333%;
  }
  .xl\\:focus\\:-translate-y-2\\/12:focus {
    --transform-translate-y: -16.66667%;
  }
  .xl\\:focus\\:-translate-y-3\\/12:focus {
    --transform-translate-y: -25%;
  }
  .xl\\:focus\\:-translate-y-4\\/12:focus {
    --transform-translate-y: -33.33333%;
  }
  .xl\\:focus\\:-translate-y-5\\/12:focus {
    --transform-translate-y: -41.66667%;
  }
  .xl\\:focus\\:-translate-y-6\\/12:focus {
    --transform-translate-y: -50%;
  }
  .xl\\:focus\\:-translate-y-7\\/12:focus {
    --transform-translate-y: -58.33333%;
  }
  .xl\\:focus\\:-translate-y-8\\/12:focus {
    --transform-translate-y: -66.66667%;
  }
  .xl\\:focus\\:-translate-y-9\\/12:focus {
    --transform-translate-y: -75%;
  }
  .xl\\:focus\\:-translate-y-10\\/12:focus {
    --transform-translate-y: -83.33333%;
  }
  .xl\\:focus\\:-translate-y-11\\/12:focus {
    --transform-translate-y: -91.66667%;
  }
  .xl\\:focus\\:-translate-y-full:focus {
    --transform-translate-y: -100%;
  }
  .xl\\:skew-x-0 {
    --transform-skew-x: 0;
  }
  .xl\\:skew-x-1 {
    --transform-skew-x: 1deg;
  }
  .xl\\:skew-x-2 {
    --transform-skew-x: 2deg;
  }
  .xl\\:skew-x-3 {
    --transform-skew-x: 3deg;
  }
  .xl\\:skew-x-6 {
    --transform-skew-x: 6deg;
  }
  .xl\\:skew-x-12 {
    --transform-skew-x: 12deg;
  }
  .xl\\:-skew-x-12 {
    --transform-skew-x: -12deg;
  }
  .xl\\:-skew-x-6 {
    --transform-skew-x: -6deg;
  }
  .xl\\:-skew-x-3 {
    --transform-skew-x: -3deg;
  }
  .xl\\:-skew-x-2 {
    --transform-skew-x: -2deg;
  }
  .xl\\:-skew-x-1 {
    --transform-skew-x: -1deg;
  }
  .xl\\:skew-y-0 {
    --transform-skew-y: 0;
  }
  .xl\\:skew-y-1 {
    --transform-skew-y: 1deg;
  }
  .xl\\:skew-y-2 {
    --transform-skew-y: 2deg;
  }
  .xl\\:skew-y-3 {
    --transform-skew-y: 3deg;
  }
  .xl\\:skew-y-6 {
    --transform-skew-y: 6deg;
  }
  .xl\\:skew-y-12 {
    --transform-skew-y: 12deg;
  }
  .xl\\:-skew-y-12 {
    --transform-skew-y: -12deg;
  }
  .xl\\:-skew-y-6 {
    --transform-skew-y: -6deg;
  }
  .xl\\:-skew-y-3 {
    --transform-skew-y: -3deg;
  }
  .xl\\:-skew-y-2 {
    --transform-skew-y: -2deg;
  }
  .xl\\:-skew-y-1 {
    --transform-skew-y: -1deg;
  }
  .xl\\:hover\\:skew-x-0:hover {
    --transform-skew-x: 0;
  }
  .xl\\:hover\\:skew-x-1:hover {
    --transform-skew-x: 1deg;
  }
  .xl\\:hover\\:skew-x-2:hover {
    --transform-skew-x: 2deg;
  }
  .xl\\:hover\\:skew-x-3:hover {
    --transform-skew-x: 3deg;
  }
  .xl\\:hover\\:skew-x-6:hover {
    --transform-skew-x: 6deg;
  }
  .xl\\:hover\\:skew-x-12:hover {
    --transform-skew-x: 12deg;
  }
  .xl\\:hover\\:-skew-x-12:hover {
    --transform-skew-x: -12deg;
  }
  .xl\\:hover\\:-skew-x-6:hover {
    --transform-skew-x: -6deg;
  }
  .xl\\:hover\\:-skew-x-3:hover {
    --transform-skew-x: -3deg;
  }
  .xl\\:hover\\:-skew-x-2:hover {
    --transform-skew-x: -2deg;
  }
  .xl\\:hover\\:-skew-x-1:hover {
    --transform-skew-x: -1deg;
  }
  .xl\\:hover\\:skew-y-0:hover {
    --transform-skew-y: 0;
  }
  .xl\\:hover\\:skew-y-1:hover {
    --transform-skew-y: 1deg;
  }
  .xl\\:hover\\:skew-y-2:hover {
    --transform-skew-y: 2deg;
  }
  .xl\\:hover\\:skew-y-3:hover {
    --transform-skew-y: 3deg;
  }
  .xl\\:hover\\:skew-y-6:hover {
    --transform-skew-y: 6deg;
  }
  .xl\\:hover\\:skew-y-12:hover {
    --transform-skew-y: 12deg;
  }
  .xl\\:hover\\:-skew-y-12:hover {
    --transform-skew-y: -12deg;
  }
  .xl\\:hover\\:-skew-y-6:hover {
    --transform-skew-y: -6deg;
  }
  .xl\\:hover\\:-skew-y-3:hover {
    --transform-skew-y: -3deg;
  }
  .xl\\:hover\\:-skew-y-2:hover {
    --transform-skew-y: -2deg;
  }
  .xl\\:hover\\:-skew-y-1:hover {
    --transform-skew-y: -1deg;
  }
  .xl\\:focus\\:skew-x-0:focus {
    --transform-skew-x: 0;
  }
  .xl\\:focus\\:skew-x-1:focus {
    --transform-skew-x: 1deg;
  }
  .xl\\:focus\\:skew-x-2:focus {
    --transform-skew-x: 2deg;
  }
  .xl\\:focus\\:skew-x-3:focus {
    --transform-skew-x: 3deg;
  }
  .xl\\:focus\\:skew-x-6:focus {
    --transform-skew-x: 6deg;
  }
  .xl\\:focus\\:skew-x-12:focus {
    --transform-skew-x: 12deg;
  }
  .xl\\:focus\\:-skew-x-12:focus {
    --transform-skew-x: -12deg;
  }
  .xl\\:focus\\:-skew-x-6:focus {
    --transform-skew-x: -6deg;
  }
  .xl\\:focus\\:-skew-x-3:focus {
    --transform-skew-x: -3deg;
  }
  .xl\\:focus\\:-skew-x-2:focus {
    --transform-skew-x: -2deg;
  }
  .xl\\:focus\\:-skew-x-1:focus {
    --transform-skew-x: -1deg;
  }
  .xl\\:focus\\:skew-y-0:focus {
    --transform-skew-y: 0;
  }
  .xl\\:focus\\:skew-y-1:focus {
    --transform-skew-y: 1deg;
  }
  .xl\\:focus\\:skew-y-2:focus {
    --transform-skew-y: 2deg;
  }
  .xl\\:focus\\:skew-y-3:focus {
    --transform-skew-y: 3deg;
  }
  .xl\\:focus\\:skew-y-6:focus {
    --transform-skew-y: 6deg;
  }
  .xl\\:focus\\:skew-y-12:focus {
    --transform-skew-y: 12deg;
  }
  .xl\\:focus\\:-skew-y-12:focus {
    --transform-skew-y: -12deg;
  }
  .xl\\:focus\\:-skew-y-6:focus {
    --transform-skew-y: -6deg;
  }
  .xl\\:focus\\:-skew-y-3:focus {
    --transform-skew-y: -3deg;
  }
  .xl\\:focus\\:-skew-y-2:focus {
    --transform-skew-y: -2deg;
  }
  .xl\\:focus\\:-skew-y-1:focus {
    --transform-skew-y: -1deg;
  }
  .xl\\:transition-none {
    transition-property: none;
  }
  .xl\\:transition-all {
    transition-property: all;
  }
  .xl\\:transition {
    transition-property: background-color, border-color, color, fill, stroke, opacity, box-shadow, transform;
  }
  .xl\\:transition-colors {
    transition-property: background-color, border-color, color, fill, stroke;
  }
  .xl\\:transition-opacity {
    transition-property: opacity;
  }
  .xl\\:transition-shadow {
    transition-property: box-shadow;
  }
  .xl\\:transition-transform {
    transition-property: transform;
  }
  .xl\\:ease-linear {
    transition-timing-function: linear;
  }
  .xl\\:ease-in {
    transition-timing-function: cubic-bezier(0.4, 0, 1, 1);
  }
  .xl\\:ease-out {
    transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
  }
  .xl\\:ease-in-out {
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  }
  .xl\\:duration-75 {
    transition-duration: 75ms;
  }
  .xl\\:duration-100 {
    transition-duration: 100ms;
  }
  .xl\\:duration-150 {
    transition-duration: 150ms;
  }
  .xl\\:duration-200 {
    transition-duration: 200ms;
  }
  .xl\\:duration-300 {
    transition-duration: 300ms;
  }
  .xl\\:duration-500 {
    transition-duration: 500ms;
  }
  .xl\\:duration-700 {
    transition-duration: 700ms;
  }
  .xl\\:duration-1000 {
    transition-duration: 1000ms;
  }
  .xl\\:delay-75 {
    transition-delay: 75ms;
  }
  .xl\\:delay-100 {
    transition-delay: 100ms;
  }
  .xl\\:delay-150 {
    transition-delay: 150ms;
  }
  .xl\\:delay-200 {
    transition-delay: 200ms;
  }
  .xl\\:delay-300 {
    transition-delay: 300ms;
  }
  .xl\\:delay-500 {
    transition-delay: 500ms;
  }
  .xl\\:delay-700 {
    transition-delay: 700ms;
  }
  .xl\\:delay-1000 {
    transition-delay: 1000ms;
  }
  .xl\\:animate-none {
    animation: none;
  }
  .xl\\:animate-spin {
    animation: spin 1s linear infinite;
  }
  .xl\\:animate-ping {
    animation: ping 1s cubic-bezier(0, 0, 0.2, 1) infinite;
  }
  .xl\\:animate-pulse {
    animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
  }
  .xl\\:animate-bounce {
    animation: bounce 1s infinite;
  }
}
@property --tw-translate-x {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
@property --tw-translate-y {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
@property --tw-translate-z {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
@property --tw-scale-x {
  syntax: "*";
  inherits: false;
  initial-value: 1;
}
@property --tw-scale-y {
  syntax: "*";
  inherits: false;
  initial-value: 1;
}
@property --tw-scale-z {
  syntax: "*";
  inherits: false;
  initial-value: 1;
}
@property --tw-rotate-x {
  syntax: "*";
  inherits: false;
  initial-value: rotateX(0);
}
@property --tw-rotate-y {
  syntax: "*";
  inherits: false;
  initial-value: rotateY(0);
}
@property --tw-rotate-z {
  syntax: "*";
  inherits: false;
  initial-value: rotateZ(0);
}
@property --tw-skew-x {
  syntax: "*";
  inherits: false;
  initial-value: skewX(0);
}
@property --tw-skew-y {
  syntax: "*";
  inherits: false;
  initial-value: skewY(0);
}
@property --tw-space-y-reverse {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
@property --tw-space-x-reverse {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
@property --tw-divide-y-reverse {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
@property --tw-border-style {
  syntax: "*";
  inherits: false;
  initial-value: solid;
}
@property --tw-leading {
  syntax: "*";
  inherits: false;
}
@property --tw-font-weight {
  syntax: "*";
  inherits: false;
}
@property --tw-tracking {
  syntax: "*";
  inherits: false;
}
@property --tw-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-shadow-color {
  syntax: "*";
  inherits: false;
}
@property --tw-inset-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-inset-shadow-color {
  syntax: "*";
  inherits: false;
}
@property --tw-ring-color {
  syntax: "*";
  inherits: false;
}
@property --tw-ring-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-inset-ring-color {
  syntax: "*";
  inherits: false;
}
@property --tw-inset-ring-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-ring-inset {
  syntax: "*";
  inherits: false;
}
@property --tw-ring-offset-width {
  syntax: "<length>";
  inherits: false;
  initial-value: 0px;
}
@property --tw-ring-offset-color {
  syntax: "*";
  inherits: false;
  initial-value: #fff;
}
@property --tw-ring-offset-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-outline-style {
  syntax: "*";
  inherits: false;
  initial-value: solid;
}
@property --tw-blur {
  syntax: "*";
  inherits: false;
}
@property --tw-brightness {
  syntax: "*";
  inherits: false;
}
@property --tw-contrast {
  syntax: "*";
  inherits: false;
}
@property --tw-grayscale {
  syntax: "*";
  inherits: false;
}
@property --tw-hue-rotate {
  syntax: "*";
  inherits: false;
}
@property --tw-invert {
  syntax: "*";
  inherits: false;
}
@property --tw-opacity {
  syntax: "*";
  inherits: false;
}
@property --tw-saturate {
  syntax: "*";
  inherits: false;
}
@property --tw-sepia {
  syntax: "*";
  inherits: false;
}
@property --tw-drop-shadow {
  syntax: "*";
  inherits: false;
}
@property --tw-duration {
  syntax: "*";
  inherits: false;
}
@property --tw-ease {
  syntax: "*";
  inherits: false;
}
@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
@keyframes ping {
  75%, 100% {
    transform: scale(2);
    opacity: 0;
  }
}
@keyframes pulse {
  50% {
    opacity: 0.5;
  }
}
@keyframes bounce {
  0%, 100% {
    transform: translateY(-25%);
    animation-timing-function: cubic-bezier(0.8, 0, 1, 1);
  }
  50% {
    transform: none;
    animation-timing-function: cubic-bezier(0, 0, 0.2, 1);
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/tailwind.css"],"names":[],"mappings":"AAAA,iEAAiE;AACjE,2EAA2E;AAC3E,yCAAyC;AACzC;EACE;IACE;6DACyD;IACzD;8BAC0B;IAC1B,6CAA6C;IAC7C,4CAA4C;IAC5C,4CAA4C;IAC5C,6CAA6C;IAC7C,6CAA6C;IAC7C,6CAA6C;IAC7C,6CAA6C;IAC7C,6CAA6C;IAC7C,8CAA8C;IAC9C,8CAA8C;IAC9C,6CAA6C;IAC7C,2CAA2C;IAC3C,4CAA4C;IAC5C,4CAA4C;IAC5C,2CAA2C;IAC3C,4CAA4C;IAC5C,4CAA4C;IAC5C,2CAA2C;IAC3C,4CAA4C;IAC5C,4CAA4C;IAC5C,2CAA2C;IAC3C,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,qBAAqB;IACrB,sBAAsB;IACtB,sBAAsB;IACtB,sBAAsB;IACtB,kBAAkB;IAClB,sCAAsC;IACtC,mBAAmB;IACnB,0CAA0C;IAC1C,iBAAiB;IACjB,uCAAuC;IACvC,mBAAmB;IACnB,0CAA0C;IAC1C,kBAAkB;IAClB,sCAAsC;IACtC,oBAAoB;IACpB,2CAA2C;IAC3C,mBAAmB;IACnB,yCAAyC;IACzC,yBAAyB;IACzB,2BAA2B;IAC3B,uBAAuB;IACvB,4BAA4B;IAC5B,0BAA0B;IAC1B,qBAAqB;IACrB,mBAAmB;IACnB,oBAAoB;IACpB,kBAAkB;IAClB,oBAAoB;IACpB,qCAAqC;IACrC,sCAAsC;IACtC,2CAA2C;IAC3C,oCAAoC;IACpC,kEAAkE;IAClE,uCAAuC;IACvC,4CAA4C;EAC9C;AACF;AACA;EACE;IACE,sBAAsB;IACtB,SAAS;IACT,UAAU;IACV,eAAe;EACjB;EACA;IACE,gBAAgB;IAChB,8BAA8B;IAC9B,WAAW;IACX,2JAA2J;IAC3J,mEAAmE;IACnE,uEAAuE;IACvE,wCAAwC;EAC1C;EACA;IACE,SAAS;IACT,cAAc;IACd,qBAAqB;EACvB;EACA;IACE,yCAAyC;IACzC,iCAAiC;EACnC;EACA;IACE,kBAAkB;IAClB,oBAAoB;EACtB;EACA;IACE,cAAc;IACd,gCAAgC;IAChC,wBAAwB;EAC1B;EACA;IACE,mBAAmB;EACrB;EACA;IACE,gJAAgJ;IAChJ,wEAAwE;IACxE,4EAA4E;IAC5E,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;IACd,cAAc;IACd,kBAAkB;IAClB,wBAAwB;EAC1B;EACA;IACE,eAAe;EACjB;EACA;IACE,WAAW;EACb;EACA;IACE,cAAc;IACd,qBAAqB;IACrB,yBAAyB;EAC3B;EACA;IACE,aAAa;EACf;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,cAAc;IACd,sBAAsB;EACxB;EACA;IACE,eAAe;IACf,YAAY;EACd;EACA;IACE,aAAa;IACb,8BAA8B;IAC9B,gCAAgC;IAChC,uBAAuB;IACvB,cAAc;IACd,gBAAgB;IAChB,6BAA6B;IAC7B,UAAU;EACZ;EACA;IACE,mBAAmB;EACrB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,UAAU;EACZ;EACA;IACE;MACE,yDAAyD;IAC3D;EACF;EACA;IACE,gBAAgB;EAClB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,eAAe;IACf,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,UAAU;EACZ;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,YAAY;EACd;EACA;IACE,wBAAwB;EAC1B;AACF;AACA;EACE;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,UAAU;IACV,YAAY;IACZ,gBAAgB;IAChB,sBAAsB;IACtB,mBAAmB;IACnB,eAAe;EACjB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,+BAA+B;EACjC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,SAAS;EACX;EACA;IACE,+BAA+B;EACjC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,YAAY;EACd;EACA;IACE,WAAW;EACb;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,oBAAoB;EACtB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,WAAW;IACX;MACE,gBAAgB;IAClB;IACA;MACE,gBAAgB;IAClB;IACA;MACE,gBAAgB;IAClB;IACA;MACE,gBAAgB;IAClB;IACA;MACE,gBAAgB;IAClB;EACF;EACA;IACE,iCAAiC;EACnC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,wCAAwC;EAC1C;EACA;IACE,mBAAmB;EACrB;EACA;IACE,sCAAsC;EACxC;EACA;IACE,uCAAuC;EACzC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,sCAAsC;EACxC;EACA;IACE,sCAAsC;EACxC;EACA;IACE,sCAAsC;EACxC;EACA;IACE,uCAAuC;EACzC;EACA;IACE,wCAAwC;EAC1C;EACA;IACE,wCAAwC;EAC1C;EACA;IACE,wCAAwC;EAC1C;EACA;IACE,qCAAqC;EACvC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,cAAc;EAChB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,eAAe;EACjB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,+BAA+B;IAC/B,gCAAgC;EAClC;EACA;IACE,gCAAgC;IAChC,iCAAiC;EACnC;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,gCAAgC;EAClC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,YAAY;EACd;EACA;IACE,aAAa;EACf;EACA;IACE,gBAAgB;EAClB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,kBAAkB;EACpB;EACA;IACE,WAAW;EACb;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,SAAO;EACT;EACA;IACE,cAAc;EAChB;EACA;IACE,YAAY;EACd;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,uBAAuB;IACvB,sDAAsD;EACxD;EACA;IACE,0CAA0C;IAC1C,sDAAsD;EACxD;EACA;IACE,sBAAsB;IACtB,sDAAsD;EACxD;EACA;IACE,iBAAiB;IACjB,iBAAiB;IACjB,iBAAiB;IACjB,0CAA0C;EAC5C;EACA;IACE,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,0CAA0C;EAC5C;EACA;IACE,qGAAqG;EACvG;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,eAAe;EACjB;EACA;IACE,YAAY;EACd;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gDAAgD;EAClD;EACA;IACE,gDAAgD;EAClD;EACA;IACE,gDAAgD;EAClD;EACA;IACE,gDAAgD;EAClD;EACA;IACE,sBAAsB;EACxB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,8BAA8B;EAChC;EACA;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE;MACE,uBAAuB;MACvB,8EAA8E;MAC9E,sFAAsF;IACxF;EACF;EACA;IACE;MACE,uBAAuB;MACvB,8EAA8E;MAC9E,sFAAsF;IACxF;EACF;EACA;IACE;MACE,uBAAuB;MACvB,8EAA8E;MAC9E,sFAAsF;IACxF;EACF;EACA;IACE;MACE,uBAAuB;MACvB,8EAA8E;MAC9E,sFAAsF;IACxF;EACF;EACA;IACE;MACE,uBAAuB;MACvB,8EAA8E;MAC9E,sFAAsF;IACxF;EACF;EACA;IACE,sCAAsC;EACxC;EACA;IACE,oCAAoC;EACtC;EACA;IACE;MACE,uBAAuB;MACvB,+EAA+E;MAC/E,uFAAuF;IACzF;EACF;EACA;IACE;MACE,uBAAuB;MACvB,+EAA+E;MAC/E,uFAAuF;IACzF;EACF;EACA;IACE;MACE,wBAAwB;MACxB,2CAA2C;MAC3C,wCAAwC;MACxC,wDAAwD;MACxD,qEAAqE;IACvE;EACF;EACA;IACE;MACE,mCAAmC;IACrC;EACF;EACA;IACE,kBAAkB;EACpB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,gCAAgC;EAClC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,oCAAoC;IACpC,iBAAiB;EACnB;EACA;IACE,oCAAoC;IACpC,iBAAiB;EACnB;EACA;IACE,oCAAoC;IACpC,kBAAkB;EACpB;EACA;IACE,wCAAwC;IACxC,qBAAqB;EACvB;EACA;IACE,2CAA2C;IAC3C,wBAAwB;EAC1B;EACA;IACE,yCAAyC;IACzC,sBAAsB;EACxB;EACA;IACE,uBAAuB;IACvB,kBAAkB;EACpB;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,sCAAsC;EACxC;EACA;IACE,uCAAuC;EACzC;EACA;IACE,uCAAuC;EACzC;EACA;IACE,uCAAuC;EACzC;EACA;IACE,wCAAwC;EAC1C;EACA;IACE,wCAAwC;EAC1C;EACA;IACE,wCAAwC;EAC1C;EACA;IACE,wCAAwC;EAC1C;EACA;IACE,yCAAyC;EAC3C;EACA;IACE,yCAAyC;EAC3C;EACA;IACE,yCAAyC;EAC3C;EACA;IACE,oCAAoC;EACtC;EACA;IACE,aAAa;EACf;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iCAAiC;EACnC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,wCAAwC;EAC1C;EACA;IACE,0CAA0C;EAC5C;EACA;IACE,wCAAwC;EAC1C;EACA;IACE,0CAA0C;EAC5C;EACA;IACE,wCAAwC;EAC1C;EACA;IACE,wCAAwC;EAC1C;EACA;IACE,wCAAwC;EAC1C;EACA;IACE,wCAAwC;EAC1C;EACA;IACE,uCAAuC;EACzC;EACA;IACE,yCAAyC;EAC3C;EACA;IACE,uCAAuC;EACzC;EACA;IACE,uCAAuC;EACzC;EACA;IACE,uCAAuC;EACzC;EACA;IACE,uCAAuC;EACzC;EACA;IACE,wCAAwC;EAC1C;EACA;IACE,qCAAqC;EACvC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,sCAAsC;EACxC;EACA;IACE,uCAAuC;EACzC;EACA;IACE,uCAAuC;EACzC;EACA;IACE,uCAAuC;EACzC;EACA;IACE,wCAAwC;EAC1C;EACA;IACE,wCAAwC;EAC1C;EACA;IACE,yCAAyC;EAC3C;EACA;IACE,sCAAsC;EACxC;EACA;IACE,sCAAsC;EACxC;EACA;IACE,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,0BAA0B;IAC1B,4DAA4D;EAC9D;EACA;IACE,0BAA0B;IAC1B,4DAA4D;EAC9D;EACA;IACE,2BAA2B;IAC3B,6DAA6D;EAC/D;EACA;IACE,yBAAyB;IACzB,2DAA2D;EAC7D;EACA;IACE,yBAAyB;IACzB,2DAA2D;EAC7D;EACA;IACE,yBAAyB;IACzB,2DAA2D;EAC7D;EACA;IACE,sCAAsC;IACtC,qCAAqC;EACvC;EACA;IACE,sCAAsC;IACtC,qCAAqC;EACvC;EACA;IACE,sCAAsC;IACtC,qCAAqC;EACvC;EACA;IACE,yCAAyC;IACzC,oCAAoC;EACtC;EACA;IACE,8CAA8C;IAC9C,yCAAyC;EAC3C;EACA;IACE,2CAA2C;IAC3C,sCAAsC;EACxC;EACA;IACE,6CAA6C;IAC7C,wCAAwC;EAC1C;EACA;IACE,oCAAoC;IACpC,qCAAqC;EACvC;EACA;IACE,eAAe;EACjB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,8BAA8B;EAChC;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,+BAA+B;EACjC;EACA;IACE,WAAW;EACb;EACA;IACE,YAAY;EACd;EACA;IACE,aAAa;EACf;EACA;IACE,0HAA0H;IAC1H,sIAAsI;EACxI;EACA;IACE,wEAAwE;IACxE,sIAAsI;EACxI;EACA;IACE,+HAA+H;IAC/H,sIAAsI;EACxI;EACA;IACE,6HAA6H;IAC7H,sIAAsI;EACxI;EACA;IACE,0HAA0H;IAC1H,sIAAsI;EACxI;EACA;IACE,wHAAwH;IACxH,sIAAsI;EACxI;EACA;IACE,mCAAmC;EACrC;EACA;IACE,sCAAsC;EACxC;EACA;IACE,sCAAsC;EACxC;EACA;IACE,sCAAsC;IACtC,kBAAkB;EACpB;EACA;IACE,sCAAsC;IACtC,kBAAkB;EACpB;EACA;IACE,8BAA8B;EAChC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,0LAA0L;EAC5L;EACA;IACE,0PAAmR;IACnR,qFAAqF;IACrF,2EAA2E;EAC7E;EACA;IACE,4BAA4B;IAC5B,qFAAqF;IACrF,2EAA2E;EAC7E;EACA;IACE,mBAAmB;IACnB,yBAAyB;EAC3B;EACA;IACE,oBAAoB;IACpB,0BAA0B;EAC5B;EACA;IACE,oBAAoB;IACpB,0BAA0B;EAC5B;EACA;IACE,oBAAoB;IACpB,0BAA0B;EAC5B;EACA;IACE,qBAAqB;IACrB,2BAA2B;EAC7B;EACA;IACE,yBAAyB;IACzB,0CAA0C;EAC5C;EACA;IACE,6BAA6B;IAC7B,8CAA8C;EAChD;EACA;IACE,0BAA0B;IAC1B,2CAA2C;EAC7C;EACA;IACE,sBAAsB;EACxB;EACA;IACE;MACE,4BAA4B;IAC9B;EACF;EACA;IACE;MACE;QACE,sCAAsC;MACxC;IACF;EACF;EACA;IACE;MACE;QACE,uCAAuC;MACzC;IACF;EACF;EACA;IACE;MACE;QACE,wCAAwC;MAC1C;IACF;EACF;EACA;IACE;MACE;QACE,yCAAyC;MAC3C;IACF;EACF;EACA;IACE;MACE;QACE,yCAAyC;MAC3C;IACF;EACF;EACA;IACE;MACE;QACE,4BAA4B;MAC9B;IACF;EACF;EACA;IACE;MACE;QACE,4BAA4B;MAC9B;IACF;EACF;EACA;IACE;MACE;QACE,6BAA6B;MAC/B;IACF;EACF;EACA;IACE;MACE;QACE,8BAA8B;MAChC;IACF;EACF;EACA;IACE;MACE,wHAAwH;MACxH,sIAAsI;IACxI;EACF;EACA;IACE;MACE,uCAAuC;IACzC;EACF;EACA;IACE;MACE,wCAAwC;IAC1C;EACF;EACA;IACE;MACE,wCAAwC;IAC1C;EACF;EACA;IACE;MACE,2BAA2B;MAC3B,4GAA4G;IAC9G;EACF;EACA;IACE;MACE,4CAA4C;IAC9C;EACF;EACA;IACE;MACE,sCAAsC;MACtC,kBAAkB;IACpB;EACF;EACA;IACE;MACE,sCAAsC;MACtC,kBAAkB;IACpB;EACF;EACA;IACE;MACE,8BAA8B;IAChC;EACF;EACA;IACE;MACE,sCAAsC;IACxC;EACF;EACA;IACE;MACE,wBAAwB;MACxB,mBAAmB;IACrB;EACF;EACA;IACE;MACE,sBAAsB;IACxB;EACF;EACA;IACE;MACE,4BAA4B;IAC9B;EACF;EACA;IACE;MACE,sCAAsC;MACtC,kBAAkB;IACpB;EACF;EACA;IACE;MACE,sCAAsC;MACtC,kBAAkB;IACpB;EACF;EACA;IACE;MACE,mBAAmB;IACrB;EACF;EACA;IACE;MACE,sCAAsC;IACxC;EACF;EACA;IACE;MACE,mBAAmB;IACrB;EACF;EACA;IACE;MACE,oCAAoC;IACtC;EACF;EACA;IACE;MACE,qCAAqC;IACvC;EACF;EACA;IACE;MACE,qCAAqC;IACvC;EACF;EACA;IACE;MACE,aAAa;IACf;EACF;EACA;IACE;MACE,aAAa;IACf;EACF;EACA;IACE;MACE,+BAA+B;MAC/B,gCAAgC;IAClC;EACF;EACA;IACE;MACE,gCAAgC;MAChC,iCAAiC;IACnC;EACF;EACA;IACE;MACE,WAAW;IACb;EACF;EACA;IACE;MACE,gBAAgB;IAClB;EACF;EACA;IACE;MACE,8BAA8B;IAChC;EACF;EACA;IACE;MACE,gDAAgD;IAClD;EACF;EACA;IACE;MACE,oCAAoC;IACtC;EACF;EACA;IACE;MACE,+BAA+B;IACjC;EACF;EACA;IACE;MACE,iCAAiC;IACnC;EACF;EACA;IACE;MACE,wCAAwC;IAC1C;EACF;EACA;IACE;MACE,yCAAyC;IAC3C;EACF;EACA;IACE;MACE,wCAAwC;IAC1C;EACF;EACA;IACE;MACE,uCAAuC;IACzC;EACF;EACA;IACE;MACE,uCAAuC;IACzC;EACF;EACA;IACE;MACE,0BAA0B;MAC1B,4DAA4D;IAC9D;EACF;EACA;IACE;MACE,yBAAyB;MACzB,2DAA2D;IAC7D;EACF;EACA;IACE;MACE,yBAAyB;MACzB,qCAAqC;IACvC;EACF;EACA;IACE;MACE,sCAAsC;MACtC,qCAAqC;IACvC;EACF;EACA;IACE;MACE,gDAAgD;IAClD;EACF;EACA;IACE;MACE,iCAAiC;IACnC;EACF;EACA;IACE;MACE,wCAAwC;IAC1C;EACF;EACA;IACE;MACE,wCAAwC;IAC1C;EACF;EACA;IACE;MACE,qCAAqC;IACvC;EACF;EACA;IACE;MACE,gBAAgB;IAClB;EACF;EACA;IACE;MACE,4BAA4B;IAC9B;EACF;EACA;IACE;MACE,4BAA4B;IAC9B;EACF;EACA;IACE;MACE,oCAAoC;IACtC;EACF;EACA;IACE;MACE,aAAa;IACf;EACF;EACA;IACE;MACE,uBAAuB;IACzB;EACF;EACA;IACE;MACE,+BAA+B;IACjC;EACF;EACA;IACE;MACE,iDAAiD;IACnD;EACF;EACA;IACE;MACE,uBAAuB;IACzB;EACF;EACA;IACE;MACE,qCAAqC;IACvC;EACF;EACA;IACE;MACE,iCAAiC;IACnC;EACF;EACA;IACE;MACE,wCAAwC;IAC1C;EACF;EACA;IACE;MACE,qCAAqC;IACvC;EACF;AACF;AACA;EACE;IACE,iDAAiD;EACnD;AACF;AACA;EACE,iBAAiB;EACjB,8BAA8B;AAChC;AACA;EACE,SAAS;AACX;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,uBAAuB;EACvB,SAAS;EACT,iBAAiB;AACnB;AACA;EACE,iCAAiC;EACjC,cAAc;AAChB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,oCAAoC;EACpC,4BAA4B;AAC9B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,iCAAiC;EACjC,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,wBAAwB;AAC1B;AACA;EACE,eAAe;AACjB;AACA;EACE,WAAW;AACb;AACA;EACE,kBAAkB;AACpB;AACA;EACE,oBAAoB;EACpB,eAAe;EACf,iBAAiB;EACjB,SAAS;AACX;AACA;EACE,iBAAiB;AACnB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,sBAAsB;EACtB,cAAc;EACd,cAAc;EACd,eAAe;EACf,UAAU;EACV,mBAAmB;AACrB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,cAAc;AAChB;AACA;EACE,sBAAsB;EACtB,UAAU;AACZ;AACA;EACE,YAAY;AACd;AACA;EACE,6BAA6B;EAC7B,oBAAoB;AACtB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,0BAA0B;EAC1B,aAAa;AACf;AACA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,SAAS;AACX;AACA;EACE,6BAA6B;EAC7B,sBAAsB;AACxB;AACA;EACE,mBAAmB;EACnB,0CAA0C;AAC5C;AACA;EACE,SAAS;EACT,UAAU;AACZ;AACA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;AACA;EACE,6MAA6M;EAC7M,gBAAgB;AAClB;AACA;EACE,sBAAsB;EACtB,eAAe;EACf,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AAIA;EACE,cAAc;AAChB;AACA;EACE,eAAe;AACjB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;AACA;EACE,UAAU;EACV,oBAAoB;EACpB,cAAc;AAChB;AACA;EACE,iFAAiF;AACnF;AACA;EACE,cAAc;EACd,sBAAsB;AACxB;AACA;EACE,eAAe;EACf,YAAY;AACd;AACA;EACE,WAAW;AACb;AACA;EACE;IACE,gBAAgB;EAClB;AACF;AACA;EACE;IACE,gBAAgB;EAClB;AACF;AACA;EACE;IACE,iBAAiB;EACnB;AACF;AACA;EACE;IACE,iBAAiB;EACnB;AACF;AACA;EAGE,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,sBAAsB;EACtB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;AAClB;AAKA;EACE,cAAc;EACd,UAAU;AACZ;AACA;EACE,aAAa;EACb,+CAA+C;EAC/C,qBAAqB;AACvB;AACA;EAGE,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,sBAAsB;EACtB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;AAClB;AAKA;EACE,cAAc;EACd,UAAU;AACZ;AACA;EACE,aAAa;EACb,+CAA+C;EAC/C,qBAAqB;AACvB;AACA;EAGE,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,sBAAsB;EACtB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,+CAA+C;EAC/C,qBAAqB;AACvB;AACA;EACE,yDAAgQ;EAGhQ,gBAAgB;EAChB,iCAAiC;EACjC,yBAAyB;EACzB,4BAA4B;EAC5B,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;EACnB,qBAAqB;EACrB,sBAAsB;EACtB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,wCAAwC;EACxC,4BAA4B;AAC9B;AACA;EACE,cAAc;EACd,YAAY;AACd;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE;IACE,sBAAsB;EACxB;AACF;AACA;EACE,aAAa;EACb,+CAA+C;EAC/C,qBAAqB;AACvB;AACA;EACE,yDAA0P;EAC1P,yBAAyB;EACzB,8BAA8B;EAC9B,0BAA0B;EAC1B,2BAA2B;EAC3B,4BAA4B;AAC9B;AACA;EACE;IACE,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,qBAAqB;IACrB,sBAAsB;EACxB;AACF;AACA;EAGE,gBAAgB;EAChB,iCAAiC;EACjC,yBAAyB;EACzB,qBAAqB;EACrB,sBAAsB;EACtB,6BAA6B;EAC7B,yBAAyB;EAEzB,iBAAiB;EACjB,cAAc;EACd,YAAY;EACZ,WAAW;EACX,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,+CAA+C;EAC/C,qBAAqB;AACvB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yDAAoK;EACpK,yBAAyB;EACzB,8BAA8B;EAC9B,0BAA0B;EAC1B,2BAA2B;EAC3B,4BAA4B;AAC9B;AACA;EACE;IACE,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,qBAAqB;IACrB,sBAAsB;EACxB;AACF;AACA;EAGE,gBAAgB;EAChB,iCAAiC;EACjC,yBAAyB;EACzB,qBAAqB;EACrB,sBAAsB;EACtB,6BAA6B;EAC7B,yBAAyB;EAEzB,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,+CAA+C;EAC/C,qBAAqB;AACvB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,oBAAoB;AACtB;AACA;EACE,kCAAkC;EAClC,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,6BAA6B;EAC7B,YAAY;AACd;AACA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,0BAA0B;EAC1B,0BAA0B;EAC1B,uCAAuC;EACvC,iBAAiB;EACjB,oBAAoB;EACpB,iBAAiB;AACnB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,0BAA0B;EAC1B,sBAAsB;AACxB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,sBAAsB;AACxB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,cAAc;EACd,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,uBAAuB;EACvB,0BAA0B;EAC1B,uBAAuB;EACvB,wBAAwB;EACxB,0BAA0B;EAC1B,2BAA2B;EAC3B,yBAAyB;AAC3B;AACA;EACE,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,oBAAoB;EACpB,oBAAoB;AACtB;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;AACxB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,wBAAwB;EACxB,4BAA4B;AAC9B;AACA;EACE,sBAAsB;EACtB,0BAA0B;EAC1B,2BAA2B;EAC3B,yBAAyB;AAC3B;AACA;EACE,wBAAwB;EACxB,4BAA4B;AAC9B;AACA;EACE,sBAAsB;AACxB;AACA;EACE,mBAAmB;EACnB,wBAAwB;EACxB,0BAA0B;EAC1B,2BAA2B;EAC3B,yBAAyB;AAC3B;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;AACA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,OAAO;AACT;AACA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE,uBAAuB;EACvB,0BAA0B;AAC5B;AACA;EACE,sBAAsB;EACtB,sBAAsB;EACtB,uBAAuB;EACvB,0BAA0B;AAC5B;AACA;EACE,uBAAuB;EACvB,0BAA0B;EAC1B,yBAAyB;AAC3B;AACA;EACE,sBAAsB;EACtB,aAAa;EACb,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,0BAA0B;EAC1B,sBAAsB;AACxB;AACA;EACE,uBAAuB;EACvB,0BAA0B;EAC1B,sBAAsB;AACxB;AACA;EACE,uBAAuB;EACvB,0BAA0B;AAC5B;AACA;EACE,uBAAuB;EACvB,0BAA0B;AAC5B;AACA;EACE,uBAAuB;EACvB,0BAA0B;AAC5B;AACA;EACE,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,sBAAsB;EACtB,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;EACtB,sBAAsB;EACtB,uBAAuB;EACvB,0BAA0B;EAC1B,sBAAsB;EACtB,wBAAwB;EACxB,kBAAkB;EAClB,2BAA2B;EAC3B,iBAAiB;AACnB;AACA;EACE,uBAAuB;EACvB,0BAA0B;AAC5B;AACA;EACE,uBAAuB;EACvB,0BAA0B;AAC5B;AACA;EACE,uBAAuB;EACvB,0BAA0B;AAC5B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,OAAO;AACT;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,oCAAoC;EACpC,iBAAiB;AACnB;AACA;EACE,uBAAuB;EACvB,0BAA0B;AAC5B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,uBAAuB;EACvB,0BAA0B;AAC5B;AACA;EACE,uBAAuB;EACvB,0BAA0B;AAC5B;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,iBAAiB;AACnB;AACA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,2BAA2B;EAC3B,iBAAiB;AACnB;AACA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE,uBAAuB;EACvB,0BAA0B;AAC5B;AACA;EACE,sBAAsB;EACtB,sBAAsB;EACtB,uBAAuB;EACvB,0BAA0B;AAC5B;AACA;EACE,uBAAuB;EACvB,0BAA0B;EAC1B,iBAAiB;AACnB;AACA;EACE,sBAAsB;EACtB,aAAa;EACb,0BAA0B;EAC1B,cAAc;AAChB;AACA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,0BAA0B;EAC1B,sBAAsB;AACxB;AACA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,0BAA0B;EAC1B,gBAAgB;AAClB;AACA;EACE,uBAAuB;EACvB,0BAA0B;EAC1B,sBAAsB;AACxB;AACA;EACE,uBAAuB;EACvB,0BAA0B;AAC5B;AACA;EACE,uBAAuB;EACvB,0BAA0B;AAC5B;AACA;EACE,uBAAuB;EACvB,0BAA0B;AAC5B;AACA;EACE,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,uBAAuB;EACvB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,uBAAuB;EACvB,0BAA0B;AAC5B;AACA;EACE,uBAAuB;EACvB,0BAA0B;AAC5B;AACA;EACE,uBAAuB;EACvB,0BAA0B;AAC5B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,OAAO;AACT;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,oCAAoC;EACpC,iBAAiB;AACnB;AACA;EACE,uBAAuB;EACvB,0BAA0B;AAC5B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,uBAAuB;EACvB,0BAA0B;AAC5B;AACA;EACE,uBAAuB;EACvB,0BAA0B;AAC5B;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,oBAAoB;AACtB;AACA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sBAAsB;EACtB,oBAAoB;AACtB;AACA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,0BAA0B;EAC1B,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,0BAA0B;EAC1B,sBAAsB;AACxB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;EAC1B,sBAAsB;AACxB;AACA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,qBAAqB;EACrB,wBAAwB;EACxB,0BAA0B;EAC1B,2BAA2B;EAC3B,yBAAyB;AAC3B;AACA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,OAAO;AACT;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,cAAc;EACd,0BAA0B;EAC1B,YAAY;AACd;AACA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,sBAAsB;AACxB;AACA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,yBAAyB;AAC3B;AACA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,wBAAwB;EACxB,0BAA0B;EAC1B,2BAA2B;EAC3B,yBAAyB;AAC3B;AACA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,sBAAsB;AACxB;AACA;EACE,uBAAuB;EACvB,0BAA0B;AAC5B;AACA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,uBAAuB;EACvB,0BAA0B;AAC5B;AACA;EACE,uBAAuB;EACvB,0BAA0B;EAC1B,yBAAyB;AAC3B;AACA;EACE,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,cAAc;AAChB;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,0BAA0B;EAC1B,sBAAsB;AACxB;AACA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,0BAA0B;EAC1B,sBAAsB;AACxB;AACA;EACE,uBAAuB;EACvB,0BAA0B;EAC1B,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;EAClB,oBAAoB;EACpB,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,uBAAuB;EACvB,0BAA0B;AAC5B;AACA;EACE,uBAAuB;EACvB,0BAA0B;AAC5B;AACA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,OAAO;AACT;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,oCAAoC;EACpC,YAAY;AACd;AACA;EACE,uBAAuB;EACvB,0BAA0B;AAC5B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,uBAAuB;EACvB,0BAA0B;AAC5B;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE,gBAAgB;AAClB;AACA;EACE,oBAAoB;EACpB,wDAAwD;EACxD,iDAAiD;AACnD;AACA;EACE,oBAAoB;EACpB,gDAAgD;EAChD,yDAAyD;AAC3D;AACA;EACE,oBAAoB;EACpB,4DAA4D;EAC5D,qDAAqD;AACvD;AACA;EACE,oBAAoB;EACpB,oDAAoD;EACpD,6DAA6D;AAC/D;AACA;EACE,oBAAoB;EACpB,2DAA2D;EAC3D,oDAAoD;AACtD;AACA;EACE,oBAAoB;EACpB,mDAAmD;EACnD,4DAA4D;AAC9D;AACA;EACE,oBAAoB;EACpB,4DAA4D;EAC5D,qDAAqD;AACvD;AACA;EACE,oBAAoB;EACpB,oDAAoD;EACpD,6DAA6D;AAC/D;AACA;EACE,oBAAoB;EACpB,yDAAyD;EACzD,kDAAkD;AACpD;AACA;EACE,oBAAoB;EACpB,iDAAiD;EACjD,0DAA0D;AAC5D;AACA;EACE,oBAAoB;EACpB,4DAA4D;EAC5D,qDAAqD;AACvD;AACA;EACE,oBAAoB;EACpB,oDAAoD;EACpD,6DAA6D;AAC/D;AACA;EACE,oBAAoB;EACpB,2DAA2D;EAC3D,oDAAoD;AACtD;AACA;EACE,oBAAoB;EACpB,mDAAmD;EACnD,4DAA4D;AAC9D;AACA;EACE,oBAAoB;EACpB,4DAA4D;EAC5D,qDAAqD;AACvD;AACA;EACE,oBAAoB;EACpB,oDAAoD;EACpD,6DAA6D;AAC/D;AACA;EACE,oBAAoB;EACpB,yDAAyD;EACzD,kDAAkD;AACpD;AACA;EACE,oBAAoB;EACpB,iDAAiD;EACjD,0DAA0D;AAC5D;AACA;EACE,oBAAoB;EACpB,4DAA4D;EAC5D,qDAAqD;AACvD;AACA;EACE,oBAAoB;EACpB,oDAAoD;EACpD,6DAA6D;AAC/D;AACA;EACE,oBAAoB;EACpB,2DAA2D;EAC3D,oDAAoD;AACtD;AACA;EACE,oBAAoB;EACpB,mDAAmD;EACnD,4DAA4D;AAC9D;AACA;EACE,oBAAoB;EACpB,4DAA4D;EAC5D,qDAAqD;AACvD;AACA;EACE,oBAAoB;EACpB,oDAAoD;EACpD,6DAA6D;AAC/D;AACA;EACE,oBAAoB;EACpB,yDAAyD;EACzD,kDAAkD;AACpD;AACA;EACE,oBAAoB;EACpB,iDAAiD;EACjD,0DAA0D;AAC5D;AACA;EACE,oBAAoB;EACpB,4DAA4D;EAC5D,qDAAqD;AACvD;AACA;EACE,oBAAoB;EACpB,oDAAoD;EACpD,6DAA6D;AAC/D;AACA;EACE,oBAAoB;EACpB,2DAA2D;EAC3D,oDAAoD;AACtD;AACA;EACE,oBAAoB;EACpB,mDAAmD;EACnD,4DAA4D;AAC9D;AACA;EACE,oBAAoB;EACpB,4DAA4D;EAC5D,qDAAqD;AACvD;AACA;EACE,oBAAoB;EACpB,oDAAoD;EACpD,6DAA6D;AAC/D;AACA;EACE,oBAAoB;EACpB,yDAAyD;EACzD,kDAAkD;AACpD;AACA;EACE,oBAAoB;EACpB,iDAAiD;EACjD,0DAA0D;AAC5D;AACA;EACE,oBAAoB;EACpB,yDAAyD;EACzD,kDAAkD;AACpD;AACA;EACE,oBAAoB;EACpB,iDAAiD;EACjD,0DAA0D;AAC5D;AACA;EACE,oBAAoB;EACpB,yDAAyD;EACzD,kDAAkD;AACpD;AACA;EACE,oBAAoB;EACpB,iDAAiD;EACjD,0DAA0D;AAC5D;AACA;EACE,oBAAoB;EACpB,yDAAyD;EACzD,kDAAkD;AACpD;AACA;EACE,oBAAoB;EACpB,iDAAiD;EACjD,0DAA0D;AAC5D;AACA;EACE,oBAAoB;EACpB,yDAAyD;EACzD,kDAAkD;AACpD;AACA;EACE,oBAAoB;EACpB,iDAAiD;EACjD,0DAA0D;AAC5D;AACA;EACE,oBAAoB;EACpB,yDAAyD;EACzD,kDAAkD;AACpD;AACA;EACE,oBAAoB;EACpB,iDAAiD;EACjD,0DAA0D;AAC5D;AACA;EACE,oBAAoB;EACpB,0DAA0D;EAC1D,mDAAmD;AACrD;AACA;EACE,oBAAoB;EACpB,kDAAkD;EAClD,2DAA2D;AAC7D;AACA;EACE,oBAAoB;EACpB,0DAA0D;EAC1D,mDAAmD;AACrD;AACA;EACE,oBAAoB;EACpB,kDAAkD;EAClD,2DAA2D;AAC7D;AACA;EACE,oBAAoB;EACpB,0DAA0D;EAC1D,mDAAmD;AACrD;AACA;EACE,oBAAoB;EACpB,kDAAkD;EAClD,2DAA2D;AAC7D;AACA;EACE,oBAAoB;EACpB,0DAA0D;EAC1D,mDAAmD;AACrD;AACA;EACE,oBAAoB;EACpB,kDAAkD;EAClD,2DAA2D;AAC7D;AACA;EACE,oBAAoB;EACpB,0DAA0D;EAC1D,mDAAmD;AACrD;AACA;EACE,oBAAoB;EACpB,kDAAkD;EAClD,2DAA2D;AAC7D;AACA;EACE,oBAAoB;EACpB,0DAA0D;EAC1D,mDAAmD;AACrD;AACA;EACE,oBAAoB;EACpB,kDAAkD;EAClD,2DAA2D;AAC7D;AACA;EACE,oBAAoB;EACpB,0DAA0D;EAC1D,mDAAmD;AACrD;AACA;EACE,oBAAoB;EACpB,kDAAkD;EAClD,2DAA2D;AAC7D;AACA;EACE,oBAAoB;EACpB,0DAA0D;EAC1D,mDAAmD;AACrD;AACA;EACE,oBAAoB;EACpB,kDAAkD;EAClD,2DAA2D;AAC7D;AACA;EACE,oBAAoB;EACpB,0DAA0D;EAC1D,mDAAmD;AACrD;AACA;EACE,oBAAoB;EACpB,kDAAkD;EAClD,2DAA2D;AAC7D;AACA;EACE,oBAAoB;EACpB,0DAA0D;EAC1D,mDAAmD;AACrD;AACA;EACE,oBAAoB;EACpB,kDAAkD;EAClD,2DAA2D;AAC7D;AACA;EACE,oBAAoB;EACpB,wDAAwD;EACxD,iDAAiD;AACnD;AACA;EACE,oBAAoB;EACpB,gDAAgD;EAChD,yDAAyD;AAC3D;AACA;EACE,oBAAoB;EACpB,6DAA6D;EAC7D,sDAAsD;AACxD;AACA;EACE,oBAAoB;EACpB,qDAAqD;EACrD,8DAA8D;AAChE;AACA;EACE,oBAAoB;EACpB,6DAA6D;EAC7D,sDAAsD;AACxD;AACA;EACE,oBAAoB;EACpB,qDAAqD;EACrD,8DAA8D;AAChE;AACA;EACE,oBAAoB;EACpB,6DAA6D;EAC7D,sDAAsD;AACxD;AACA;EACE,oBAAoB;EACpB,qDAAqD;EACrD,8DAA8D;AAChE;AACA;EACE,oBAAoB;EACpB,6DAA6D;EAC7D,sDAAsD;AACxD;AACA;EACE,oBAAoB;EACpB,qDAAqD;EACrD,8DAA8D;AAChE;AACA;EACE,oBAAoB;EACpB,wDAAwD;EACxD,iDAAiD;AACnD;AACA;EACE,oBAAoB;EACpB,gDAAgD;EAChD,yDAAyD;AAC3D;AACA;EACE,oBAAoB;EACpB,+DAA+D;EAC/D,wDAAwD;AAC1D;AACA;EACE,oBAAoB;EACpB,uDAAuD;EACvD,gEAAgE;AAClE;AACA;EACE,oBAAoB;EACpB,+DAA+D;EAC/D,wDAAwD;AAC1D;AACA;EACE,oBAAoB;EACpB,uDAAuD;EACvD,gEAAgE;AAClE;AACA;EACE,oBAAoB;EACpB,wDAAwD;EACxD,iDAAiD;AACnD;AACA;EACE,oBAAoB;EACpB,gDAAgD;EAChD,yDAAyD;AAC3D;AACA;EACE,oBAAoB;EACpB,wDAAwD;EACxD,iDAAiD;AACnD;AACA;EACE,oBAAoB;EACpB,gDAAgD;EAChD,yDAAyD;AAC3D;AACA;EACE,oBAAoB;EACpB,wDAAwD;EACxD,iDAAiD;AACnD;AACA;EACE,oBAAoB;EACpB,gDAAgD;EAChD,yDAAyD;AAC3D;AACA;EACE,oBAAoB;EACpB,wDAAwD;EACxD,iDAAiD;AACnD;AACA;EACE,oBAAoB;EACpB,gDAAgD;EAChD,yDAAyD;AAC3D;AACA;EACE,oBAAoB;EACpB,wDAAwD;EACxD,iDAAiD;AACnD;AACA;EACE,oBAAoB;EACpB,gDAAgD;EAChD,yDAAyD;AAC3D;AACA;EACE,oBAAoB;EACpB,wDAAwD;EACxD,iDAAiD;AACnD;AACA;EACE,oBAAoB;EACpB,gDAAgD;EAChD,yDAAyD;AAC3D;AACA;EACE,oBAAoB;EACpB,wDAAwD;EACxD,iDAAiD;AACnD;AACA;EACE,oBAAoB;EACpB,gDAAgD;EAChD,yDAAyD;AAC3D;AACA;EACE,oBAAoB;EACpB,+DAA+D;EAC/D,wDAAwD;AAC1D;AACA;EACE,oBAAoB;EACpB,uDAAuD;EACvD,gEAAgE;AAClE;AACA;EACE,oBAAoB;EACpB,+DAA+D;EAC/D,wDAAwD;AAC1D;AACA;EACE,oBAAoB;EACpB,uDAAuD;EACvD,gEAAgE;AAClE;AACA;EACE,oBAAoB;EACpB,wDAAwD;EACxD,iDAAiD;AACnD;AACA;EACE,oBAAoB;EACpB,gDAAgD;EAChD,yDAAyD;AAC3D;AACA;EACE,oBAAoB;EACpB,+DAA+D;EAC/D,wDAAwD;AAC1D;AACA;EACE,oBAAoB;EACpB,uDAAuD;EACvD,gEAAgE;AAClE;AACA;EACE,oBAAoB;EACpB,+DAA+D;EAC/D,wDAAwD;AAC1D;AACA;EACE,oBAAoB;EACpB,uDAAuD;EACvD,gEAAgE;AAClE;AACA;EACE,oBAAoB;EACpB,8DAA8D;EAC9D,uDAAuD;AACzD;AACA;EACE,oBAAoB;EACpB,sDAAsD;EACtD,+DAA+D;AACjE;AACA;EACE,oBAAoB;EACpB,+DAA+D;EAC/D,wDAAwD;AAC1D;AACA;EACE,oBAAoB;EACpB,uDAAuD;EACvD,gEAAgE;AAClE;AACA;EACE,oBAAoB;EACpB,wDAAwD;EACxD,iDAAiD;AACnD;AACA;EACE,oBAAoB;EACpB,gDAAgD;EAChD,yDAAyD;AAC3D;AACA;EACE,oBAAoB;EACpB,+DAA+D;EAC/D,wDAAwD;AAC1D;AACA;EACE,oBAAoB;EACpB,uDAAuD;EACvD,gEAAgE;AAClE;AACA;EACE,oBAAoB;EACpB,+DAA+D;EAC/D,wDAAwD;AAC1D;AACA;EACE,oBAAoB;EACpB,uDAAuD;EACvD,gEAAgE;AAClE;AACA;EACE,oBAAoB;EACpB,wDAAwD;EACxD,iDAAiD;AACnD;AACA;EACE,oBAAoB;EACpB,gDAAgD;EAChD,yDAAyD;AAC3D;AACA;EACE,oBAAoB;EACpB,+DAA+D;EAC/D,wDAAwD;AAC1D;AACA;EACE,oBAAoB;EACpB,uDAAuD;EACvD,gEAAgE;AAClE;AACA;EACE,oBAAoB;EACpB,+DAA+D;EAC/D,wDAAwD;AAC1D;AACA;EACE,oBAAoB;EACpB,uDAAuD;EACvD,gEAAgE;AAClE;AACA;EACE,oBAAoB;EACpB,wDAAwD;EACxD,iDAAiD;AACnD;AACA;EACE,oBAAoB;EACpB,gDAAgD;EAChD,yDAAyD;AAC3D;AACA;EACE,oBAAoB;EACpB,+DAA+D;EAC/D,wDAAwD;AAC1D;AACA;EACE,oBAAoB;EACpB,uDAAuD;EACvD,gEAAgE;AAClE;AACA;EACE,oBAAoB;EACpB,+DAA+D;EAC/D,wDAAwD;AAC1D;AACA;EACE,oBAAoB;EACpB,uDAAuD;EACvD,gEAAgE;AAClE;AACA;EACE,oBAAoB;EACpB,yDAAyD;EACzD,kDAAkD;AACpD;AACA;EACE,oBAAoB;EACpB,iDAAiD;EACjD,0DAA0D;AAC5D;AACA;EACE,oBAAoB;EACpB,6DAA6D;EAC7D,sDAAsD;AACxD;AACA;EACE,oBAAoB;EACpB,qDAAqD;EACrD,8DAA8D;AAChE;AACA;EACE,oBAAoB;EACpB,4DAA4D;EAC5D,qDAAqD;AACvD;AACA;EACE,oBAAoB;EACpB,oDAAoD;EACpD,6DAA6D;AAC/D;AACA;EACE,oBAAoB;EACpB,6DAA6D;EAC7D,sDAAsD;AACxD;AACA;EACE,oBAAoB;EACpB,qDAAqD;EACrD,8DAA8D;AAChE;AACA;EACE,oBAAoB;EACpB,0DAA0D;EAC1D,mDAAmD;AACrD;AACA;EACE,oBAAoB;EACpB,kDAAkD;EAClD,2DAA2D;AAC7D;AACA;EACE,oBAAoB;EACpB,6DAA6D;EAC7D,sDAAsD;AACxD;AACA;EACE,oBAAoB;EACpB,qDAAqD;EACrD,8DAA8D;AAChE;AACA;EACE,oBAAoB;EACpB,4DAA4D;EAC5D,qDAAqD;AACvD;AACA;EACE,oBAAoB;EACpB,oDAAoD;EACpD,6DAA6D;AAC/D;AACA;EACE,oBAAoB;EACpB,6DAA6D;EAC7D,sDAAsD;AACxD;AACA;EACE,oBAAoB;EACpB,qDAAqD;EACrD,8DAA8D;AAChE;AACA;EACE,oBAAoB;EACpB,0DAA0D;EAC1D,mDAAmD;AACrD;AACA;EACE,oBAAoB;EACpB,kDAAkD;EAClD,2DAA2D;AAC7D;AACA;EACE,oBAAoB;EACpB,6DAA6D;EAC7D,sDAAsD;AACxD;AACA;EACE,oBAAoB;EACpB,qDAAqD;EACrD,8DAA8D;AAChE;AACA;EACE,oBAAoB;EACpB,4DAA4D;EAC5D,qDAAqD;AACvD;AACA;EACE,oBAAoB;EACpB,oDAAoD;EACpD,6DAA6D;AAC/D;AACA;EACE,oBAAoB;EACpB,6DAA6D;EAC7D,sDAAsD;AACxD;AACA;EACE,oBAAoB;EACpB,qDAAqD;EACrD,8DAA8D;AAChE;AACA;EACE,oBAAoB;EACpB,0DAA0D;EAC1D,mDAAmD;AACrD;AACA;EACE,oBAAoB;EACpB,kDAAkD;EAClD,2DAA2D;AAC7D;AACA;EACE,oBAAoB;EACpB,6DAA6D;EAC7D,sDAAsD;AACxD;AACA;EACE,oBAAoB;EACpB,qDAAqD;EACrD,8DAA8D;AAChE;AACA;EACE,oBAAoB;EACpB,4DAA4D;EAC5D,qDAAqD;AACvD;AACA;EACE,oBAAoB;EACpB,oDAAoD;EACpD,6DAA6D;AAC/D;AACA;EACE,oBAAoB;EACpB,6DAA6D;EAC7D,sDAAsD;AACxD;AACA;EACE,oBAAoB;EACpB,qDAAqD;EACrD,8DAA8D;AAChE;AACA;EACE,oBAAoB;EACpB,0DAA0D;EAC1D,mDAAmD;AACrD;AACA;EACE,oBAAoB;EACpB,kDAAkD;EAClD,2DAA2D;AAC7D;AACA;EACE,oBAAoB;EACpB,0DAA0D;EAC1D,mDAAmD;AACrD;AACA;EACE,oBAAoB;EACpB,kDAAkD;EAClD,2DAA2D;AAC7D;AACA;EACE,oBAAoB;EACpB,0DAA0D;EAC1D,mDAAmD;AACrD;AACA;EACE,oBAAoB;EACpB,kDAAkD;EAClD,2DAA2D;AAC7D;AACA;EACE,oBAAoB;EACpB,0DAA0D;EAC1D,mDAAmD;AACrD;AACA;EACE,oBAAoB;EACpB,kDAAkD;EAClD,2DAA2D;AAC7D;AACA;EACE,oBAAoB;EACpB,0DAA0D;EAC1D,mDAAmD;AACrD;AACA;EACE,oBAAoB;EACpB,kDAAkD;EAClD,2DAA2D;AAC7D;AACA;EACE,oBAAoB;EACpB,0DAA0D;EAC1D,mDAAmD;AACrD;AACA;EACE,oBAAoB;EACpB,kDAAkD;EAClD,2DAA2D;AAC7D;AACA;EACE,oBAAoB;EACpB,2DAA2D;EAC3D,oDAAoD;AACtD;AACA;EACE,oBAAoB;EACpB,mDAAmD;EACnD,4DAA4D;AAC9D;AACA;EACE,oBAAoB;EACpB,2DAA2D;EAC3D,oDAAoD;AACtD;AACA;EACE,oBAAoB;EACpB,mDAAmD;EACnD,4DAA4D;AAC9D;AACA;EACE,oBAAoB;EACpB,2DAA2D;EAC3D,oDAAoD;AACtD;AACA;EACE,oBAAoB;EACpB,mDAAmD;EACnD,4DAA4D;AAC9D;AACA;EACE,oBAAoB;EACpB,2DAA2D;EAC3D,oDAAoD;AACtD;AACA;EACE,oBAAoB;EACpB,mDAAmD;EACnD,4DAA4D;AAC9D;AACA;EACE,oBAAoB;EACpB,2DAA2D;EAC3D,oDAAoD;AACtD;AACA;EACE,oBAAoB;EACpB,mDAAmD;EACnD,4DAA4D;AAC9D;AACA;EACE,oBAAoB;EACpB,2DAA2D;EAC3D,oDAAoD;AACtD;AACA;EACE,oBAAoB;EACpB,mDAAmD;EACnD,4DAA4D;AAC9D;AACA;EACE,oBAAoB;EACpB,2DAA2D;EAC3D,oDAAoD;AACtD;AACA;EACE,oBAAoB;EACpB,mDAAmD;EACnD,4DAA4D;AAC9D;AACA;EACE,oBAAoB;EACpB,2DAA2D;EAC3D,oDAAoD;AACtD;AACA;EACE,oBAAoB;EACpB,mDAAmD;EACnD,4DAA4D;AAC9D;AACA;EACE,oBAAoB;EACpB,2DAA2D;EAC3D,oDAAoD;AACtD;AACA;EACE,oBAAoB;EACpB,mDAAmD;EACnD,4DAA4D;AAC9D;AACA;EACE,oBAAoB;EACpB,2DAA2D;EAC3D,oDAAoD;AACtD;AACA;EACE,oBAAoB;EACpB,mDAAmD;EACnD,4DAA4D;AAC9D;AACA;EACE,oBAAoB;EACpB,yDAAyD;EACzD,kDAAkD;AACpD;AACA;EACE,oBAAoB;EACpB,iDAAiD;EACjD,0DAA0D;AAC5D;AACA;EACE,oBAAoB;EACpB,8DAA8D;EAC9D,uDAAuD;AACzD;AACA;EACE,oBAAoB;EACpB,sDAAsD;EACtD,+DAA+D;AACjE;AACA;EACE,oBAAoB;EACpB,8DAA8D;EAC9D,uDAAuD;AACzD;AACA;EACE,oBAAoB;EACpB,sDAAsD;EACtD,+DAA+D;AACjE;AACA;EACE,oBAAoB;EACpB,8DAA8D;EAC9D,uDAAuD;AACzD;AACA;EACE,oBAAoB;EACpB,sDAAsD;EACtD,+DAA+D;AACjE;AACA;EACE,oBAAoB;EACpB,8DAA8D;EAC9D,uDAAuD;AACzD;AACA;EACE,oBAAoB;EACpB,sDAAsD;EACtD,+DAA+D;AACjE;AACA;EACE,oBAAoB;EACpB,yDAAyD;EACzD,kDAAkD;AACpD;AACA;EACE,oBAAoB;EACpB,iDAAiD;EACjD,0DAA0D;AAC5D;AACA;EACE,oBAAoB;EACpB,+DAA+D;EAC/D,wDAAwD;AAC1D;AACA;EACE,oBAAoB;EACpB,uDAAuD;EACvD,gEAAgE;AAClE;AACA;EACE,oBAAoB;EACpB,+DAA+D;EAC/D,wDAAwD;AAC1D;AACA;EACE,oBAAoB;EACpB,uDAAuD;EACvD,gEAAgE;AAClE;AACA;EACE,oBAAoB;EACpB,yDAAyD;EACzD,kDAAkD;AACpD;AACA;EACE,oBAAoB;EACpB,iDAAiD;EACjD,0DAA0D;AAC5D;AACA;EACE,oBAAoB;EACpB,yDAAyD;EACzD,kDAAkD;AACpD;AACA;EACE,oBAAoB;EACpB,iDAAiD;EACjD,0DAA0D;AAC5D;AACA;EACE,oBAAoB;EACpB,yDAAyD;EACzD,kDAAkD;AACpD;AACA;EACE,oBAAoB;EACpB,iDAAiD;EACjD,0DAA0D;AAC5D;AACA;EACE,oBAAoB;EACpB,yDAAyD;EACzD,kDAAkD;AACpD;AACA;EACE,oBAAoB;EACpB,iDAAiD;EACjD,0DAA0D;AAC5D;AACA;EACE,oBAAoB;EACpB,yDAAyD;EACzD,kDAAkD;AACpD;AACA;EACE,oBAAoB;EACpB,iDAAiD;EACjD,0DAA0D;AAC5D;AACA;EACE,oBAAoB;EACpB,yDAAyD;EACzD,kDAAkD;AACpD;AACA;EACE,oBAAoB;EACpB,iDAAiD;EACjD,0DAA0D;AAC5D;AACA;EACE,oBAAoB;EACpB,yDAAyD;EACzD,kDAAkD;AACpD;AACA;EACE,oBAAoB;EACpB,iDAAiD;EACjD,0DAA0D;AAC5D;AACA;EACE,oBAAoB;EACpB,+DAA+D;EAC/D,wDAAwD;AAC1D;AACA;EACE,oBAAoB;EACpB,uDAAuD;EACvD,gEAAgE;AAClE;AACA;EACE,oBAAoB;EACpB,+DAA+D;EAC/D,wDAAwD;AAC1D;AACA;EACE,oBAAoB;EACpB,uDAAuD;EACvD,gEAAgE;AAClE;AACA;EACE,oBAAoB;EACpB,yDAAyD;EACzD,kDAAkD;AACpD;AACA;EACE,oBAAoB;EACpB,iDAAiD;EACjD,0DAA0D;AAC5D;AACA;EACE,oBAAoB;EACpB,+DAA+D;EAC/D,wDAAwD;AAC1D;AACA;EACE,oBAAoB;EACpB,uDAAuD;EACvD,gEAAgE;AAClE;AACA;EACE,oBAAoB;EACpB,+DAA+D;EAC/D,wDAAwD;AAC1D;AACA;EACE,oBAAoB;EACpB,uDAAuD;EACvD,gEAAgE;AAClE;AACA;EACE,oBAAoB;EACpB,8DAA8D;EAC9D,uDAAuD;AACzD;AACA;EACE,oBAAoB;EACpB,sDAAsD;EACtD,+DAA+D;AACjE;AACA;EACE,oBAAoB;EACpB,+DAA+D;EAC/D,wDAAwD;AAC1D;AACA;EACE,oBAAoB;EACpB,uDAAuD;EACvD,gEAAgE;AAClE;AACA;EACE,oBAAoB;EACpB,yDAAyD;EACzD,kDAAkD;AACpD;AACA;EACE,oBAAoB;EACpB,iDAAiD;EACjD,0DAA0D;AAC5D;AACA;EACE,oBAAoB;EACpB,+DAA+D;EAC/D,wDAAwD;AAC1D;AACA;EACE,oBAAoB;EACpB,uDAAuD;EACvD,gEAAgE;AAClE;AACA;EACE,oBAAoB;EACpB,+DAA+D;EAC/D,wDAAwD;AAC1D;AACA;EACE,oBAAoB;EACpB,uDAAuD;EACvD,gEAAgE;AAClE;AACA;EACE,oBAAoB;EACpB,yDAAyD;EACzD,kDAAkD;AACpD;AACA;EACE,oBAAoB;EACpB,iDAAiD;EACjD,0DAA0D;AAC5D;AACA;EACE,oBAAoB;EACpB,+DAA+D;EAC/D,wDAAwD;AAC1D;AACA;EACE,oBAAoB;EACpB,uDAAuD;EACvD,gEAAgE;AAClE;AACA;EACE,oBAAoB;EACpB,+DAA+D;EAC/D,wDAAwD;AAC1D;AACA;EACE,oBAAoB;EACpB,uDAAuD;EACvD,gEAAgE;AAClE;AACA;EACE,oBAAoB;EACpB,yDAAyD;EACzD,kDAAkD;AACpD;AACA;EACE,oBAAoB;EACpB,iDAAiD;EACjD,0DAA0D;AAC5D;AACA;EACE,oBAAoB;EACpB,+DAA+D;EAC/D,wDAAwD;AAC1D;AACA;EACE,oBAAoB;EACpB,uDAAuD;EACvD,gEAAgE;AAClE;AACA;EACE,oBAAoB;EACpB,+DAA+D;EAC/D,wDAAwD;AAC1D;AACA;EACE,oBAAoB;EACpB,uDAAuD;EACvD,gEAAgE;AAClE;AACA;EACE,oBAAoB;EACpB,0DAA0D;EAC1D,mDAAmD;AACrD;AACA;EACE,oBAAoB;EACpB,kDAAkD;EAClD,2DAA2D;AAC7D;AACA;EACE,oBAAoB;AACtB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,qBAAqB;EACrB,+DAA+D;EAC/D,wDAAwD;AAC1D;AACA;EACE,qBAAqB;EACrB,uDAAuD;EACvD,gEAAgE;AAClE;AACA;EACE,qBAAqB;EACrB,+DAA+D;EAC/D,wDAAwD;AAC1D;AACA;EACE,qBAAqB;EACrB,uDAAuD;EACvD,gEAAgE;AAClE;AACA;EACE,qBAAqB;EACrB,+DAA+D;EAC/D,wDAAwD;AAC1D;AACA;EACE,qBAAqB;EACrB,uDAAuD;EACvD,gEAAgE;AAClE;AACA;EACE,qBAAqB;EACrB,+DAA+D;EAC/D,wDAAwD;AAC1D;AACA;EACE,qBAAqB;EACrB,uDAAuD;EACvD,gEAAgE;AAClE;AACA;EACE,qBAAqB;EACrB,+DAA+D;EAC/D,wDAAwD;AAC1D;AACA;EACE,qBAAqB;EACrB,uDAAuD;EACvD,gEAAgE;AAClE;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,kDAAkD;AACpD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,qDAAqD;AACvD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,qDAAqD;AACvD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,qDAAqD;AACvD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,qDAAqD;AACvD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,uDAAuD;AACzD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,qDAAqD;AACvD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,qDAAqD;AACvD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,uDAAuD;AACzD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,qDAAqD;AACvD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,uDAAuD;AACzD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,uDAAuD;AACzD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,qDAAqD;AACvD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,qDAAqD;AACvD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,oDAAoD;AACtD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,oDAAoD;AACtD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,uDAAuD;AACzD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,oDAAoD;AACtD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,oDAAoD;AACtD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,uDAAuD;AACzD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,uDAAuD;AACzD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,uDAAuD;AACzD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,uDAAuD;AACzD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,uDAAuD;AACzD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,uDAAuD;AACzD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,uDAAuD;AACzD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,qDAAqD;AACvD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,qDAAqD;AACvD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,qDAAqD;AACvD;AACA;EACE,mBAAmB;AACrB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,SAAS;EACT,iBAAiB;EACjB,UAAU;EACV,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,SAAS;EACT,iBAAiB;EACjB,UAAU;EACV,mBAAmB;AACrB;AACA;EAGE,gBAAgB;AAClB;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,6BAA6B;EAC7B,qBAAqB;AACvB;AACA;EACE,8BAA8B;AAChC;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,kDAAkD;AACpD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,qDAAqD;AACvD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,qDAAqD;AACvD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,qDAAqD;AACvD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,qDAAqD;AACvD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,uDAAuD;AACzD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,qDAAqD;AACvD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,qDAAqD;AACvD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,uDAAuD;AACzD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,qDAAqD;AACvD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,uDAAuD;AACzD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,uDAAuD;AACzD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,qDAAqD;AACvD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,qDAAqD;AACvD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,oDAAoD;AACtD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,oDAAoD;AACtD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,uDAAuD;AACzD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,oDAAoD;AACtD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,oDAAoD;AACtD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,uDAAuD;AACzD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,uDAAuD;AACzD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,uDAAuD;AACzD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,uDAAuD;AACzD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,uDAAuD;AACzD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,uDAAuD;AACzD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,uDAAuD;AACzD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,qDAAqD;AACvD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,qDAAqD;AACvD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,qDAAqD;AACvD;AACA;EACE,8BAA8B;AAChC;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,kDAAkD;AACpD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,qDAAqD;AACvD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,qDAAqD;AACvD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,qDAAqD;AACvD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,qDAAqD;AACvD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,uDAAuD;AACzD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,qDAAqD;AACvD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,qDAAqD;AACvD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,uDAAuD;AACzD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,qDAAqD;AACvD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,uDAAuD;AACzD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,uDAAuD;AACzD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,qDAAqD;AACvD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,qDAAqD;AACvD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,oDAAoD;AACtD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,oDAAoD;AACtD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,uDAAuD;AACzD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,oDAAoD;AACtD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,oDAAoD;AACtD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,uDAAuD;AACzD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,uDAAuD;AACzD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,uDAAuD;AACzD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,uDAAuD;AACzD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,uDAAuD;AACzD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,uDAAuD;AACzD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,uDAAuD;AACzD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,qDAAqD;AACvD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,qDAAqD;AACvD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,qDAAqD;AACvD;AACA;EACE,8BAA8B;AAChC;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,kDAAkD;AACpD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,qDAAqD;AACvD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,qDAAqD;AACvD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,qDAAqD;AACvD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,qDAAqD;AACvD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,uDAAuD;AACzD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,qDAAqD;AACvD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,qDAAqD;AACvD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,uDAAuD;AACzD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,qDAAqD;AACvD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,uDAAuD;AACzD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,uDAAuD;AACzD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,qDAAqD;AACvD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,qDAAqD;AACvD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,oDAAoD;AACtD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,oDAAoD;AACtD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,uDAAuD;AACzD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,oDAAoD;AACtD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,oDAAoD;AACtD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,uDAAuD;AACzD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,uDAAuD;AACzD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,uDAAuD;AACzD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,uDAAuD;AACzD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,uDAAuD;AACzD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,uDAAuD;AACzD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,uDAAuD;AACzD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,qDAAqD;AACvD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,qDAAqD;AACvD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,qDAAqD;AACvD;AACA;EACE,8BAA8B;AAChC;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,kDAAkD;AACpD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,qDAAqD;AACvD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,qDAAqD;AACvD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,qDAAqD;AACvD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,qDAAqD;AACvD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,uDAAuD;AACzD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,qDAAqD;AACvD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,qDAAqD;AACvD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,uDAAuD;AACzD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,qDAAqD;AACvD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,uDAAuD;AACzD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,uDAAuD;AACzD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,qDAAqD;AACvD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,qDAAqD;AACvD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,oDAAoD;AACtD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,oDAAoD;AACtD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,uDAAuD;AACzD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,oDAAoD;AACtD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,oDAAoD;AACtD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,uDAAuD;AACzD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,uDAAuD;AACzD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,uDAAuD;AACzD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,uDAAuD;AACzD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,uDAAuD;AACzD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,uDAAuD;AACzD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,uDAAuD;AACzD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,qDAAqD;AACvD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,qDAAqD;AACvD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,qDAAqD;AACvD;AACA;EACE,8BAA8B;AAChC;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,kDAAkD;AACpD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,qDAAqD;AACvD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,qDAAqD;AACvD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,qDAAqD;AACvD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,qDAAqD;AACvD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,uDAAuD;AACzD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,qDAAqD;AACvD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,qDAAqD;AACvD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,uDAAuD;AACzD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,qDAAqD;AACvD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,uDAAuD;AACzD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,uDAAuD;AACzD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,qDAAqD;AACvD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,qDAAqD;AACvD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,oDAAoD;AACtD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,oDAAoD;AACtD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,uDAAuD;AACzD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,oDAAoD;AACtD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,oDAAoD;AACtD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,uDAAuD;AACzD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,uDAAuD;AACzD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,uDAAuD;AACzD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,uDAAuD;AACzD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,uDAAuD;AACzD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,uDAAuD;AACzD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,uDAAuD;AACzD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,qDAAqD;AACvD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,qDAAqD;AACvD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,qDAAqD;AACvD;AACA;EACE,8BAA8B;AAChC;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,kDAAkD;AACpD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,qDAAqD;AACvD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,qDAAqD;AACvD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,qDAAqD;AACvD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,qDAAqD;AACvD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,uDAAuD;AACzD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,qDAAqD;AACvD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,qDAAqD;AACvD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,uDAAuD;AACzD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,qDAAqD;AACvD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,uDAAuD;AACzD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,uDAAuD;AACzD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,qDAAqD;AACvD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,qDAAqD;AACvD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,oDAAoD;AACtD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,oDAAoD;AACtD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,uDAAuD;AACzD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,oDAAoD;AACtD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,oDAAoD;AACtD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,uDAAuD;AACzD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,uDAAuD;AACzD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,uDAAuD;AACzD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,uDAAuD;AACzD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,uDAAuD;AACzD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,uDAAuD;AACzD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,uDAAuD;AACzD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,qDAAqD;AACvD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,qDAAqD;AACvD;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,qDAAqD;AACvD;AACA;EACE,sBAAsB;AACxB;AACA;EACE,sEAAsE;AACxE;AACA;EACE,4EAA4E;AAC9E;AACA;EACE,wEAAwE;AAC1E;AACA;EACE,+EAA+E;AACjF;AACA;EACE,yEAAyE;AAC3E;AACA;EACE,8EAA8E;AAChF;AACA;EACE,uEAAuE;AACzE;AACA;EACE,2EAA2E;AAC7E;AACA;EACE,mCAAmC;EACnC,oGAAoG;AACtG;AACA;EACE,kCAAkC;EAClC,8FAA8F;AAChG;AACA;EACE,8BAA8B;EAC9B,oGAAoG;AACtG;AACA;EACE,8BAA8B;EAC9B,8FAA8F;AAChG;AACA;EACE,8BAA8B;EAC9B,oGAAoG;AACtG;AACA;EACE,8BAA8B;EAC9B,oGAAoG;AACtG;AACA;EACE,8BAA8B;EAC9B,oGAAoG;AACtG;AACA;EACE,8BAA8B;EAC9B,oGAAoG;AACtG;AACA;EACE,8BAA8B;EAC9B,oGAAoG;AACtG;AACA;EACE,8BAA8B;EAC9B,oGAAoG;AACtG;AACA;EACE,8BAA8B;EAC9B,iGAAiG;AACnG;AACA;EACE,8BAA8B;EAC9B,iGAAiG;AACnG;AACA;EACE,8BAA8B;EAC9B,iGAAiG;AACnG;AACA;EACE,8BAA8B;EAC9B,iGAAiG;AACnG;AACA;EACE,8BAA8B;EAC9B,oGAAoG;AACtG;AACA;EACE,8BAA8B;EAC9B,oGAAoG;AACtG;AACA;EACE,8BAA8B;EAC9B,oGAAoG;AACtG;AACA;EACE,8BAA8B;EAC9B,oGAAoG;AACtG;AACA;EACE,8BAA8B;EAC9B,oGAAoG;AACtG;AACA;EACE,8BAA8B;EAC9B,kGAAkG;AACpG;AACA;EACE,8BAA8B;EAC9B,kGAAkG;AACpG;AACA;EACE,8BAA8B;EAC9B,kGAAkG;AACpG;AACA;EACE,8BAA8B;EAC9B,kGAAkG;AACpG;AACA;EACE,8BAA8B;EAC9B,kGAAkG;AACpG;AACA;EACE,8BAA8B;EAC9B,oGAAoG;AACtG;AACA;EACE,8BAA8B;EAC9B,oGAAoG;AACtG;AACA;EACE,8BAA8B;EAC9B,oGAAoG;AACtG;AACA;EACE,8BAA8B;EAC9B,oGAAoG;AACtG;AACA;EACE,8BAA8B;EAC9B,mGAAmG;AACrG;AACA;EACE,8BAA8B;EAC9B,kGAAkG;AACpG;AACA;EACE,8BAA8B;EAC9B,iGAAiG;AACnG;AACA;EACE,8BAA8B;EAC9B,iGAAiG;AACnG;AACA;EACE,8BAA8B;EAC9B,kGAAkG;AACpG;AACA;EACE,8BAA8B;EAC9B,kGAAkG;AACpG;AACA;EACE,8BAA8B;EAC9B,oGAAoG;AACtG;AACA;EACE,8BAA8B;EAC9B,oGAAoG;AACtG;AACA;EACE,8BAA8B;EAC9B,oGAAoG;AACtG;AACA;EACE,8BAA8B;EAC9B,mGAAmG;AACrG;AACA;EACE,8BAA8B;EAC9B,kGAAkG;AACpG;AACA;EACE,8BAA8B;EAC9B,kGAAkG;AACpG;AACA;EACE,8BAA8B;EAC9B,kGAAkG;AACpG;AACA;EACE,8BAA8B;EAC9B,kGAAkG;AACpG;AACA;EACE,8BAA8B;EAC9B,kGAAkG;AACpG;AACA;EACE,8BAA8B;EAC9B,iGAAiG;AACnG;AACA;EACE,8BAA8B;EAC9B,oGAAoG;AACtG;AACA;EACE,8BAA8B;EAC9B,oGAAoG;AACtG;AACA;EACE,8BAA8B;EAC9B,oGAAoG;AACtG;AACA;EACE,8BAA8B;EAC9B,oGAAoG;AACtG;AACA;EACE,8BAA8B;EAC9B,mGAAmG;AACrG;AACA;EACE,8BAA8B;EAC9B,mGAAmG;AACrG;AACA;EACE,8BAA8B;EAC9B,iGAAiG;AACnG;AACA;EACE,8BAA8B;EAC9B,iGAAiG;AACnG;AACA;EACE,8BAA8B;EAC9B,gGAAgG;AAClG;AACA;EACE,8BAA8B;EAC9B,gGAAgG;AAClG;AACA;EACE,8BAA8B;EAC9B,oGAAoG;AACtG;AACA;EACE,8BAA8B;EAC9B,oGAAoG;AACtG;AACA;EACE,8BAA8B;EAC9B,oGAAoG;AACtG;AACA;EACE,8BAA8B;EAC9B,oGAAoG;AACtG;AACA;EACE,8BAA8B;EAC9B,mGAAmG;AACrG;AACA;EACE,8BAA8B;EAC9B,kGAAkG;AACpG;AACA;EACE,8BAA8B;EAC9B,kGAAkG;AACpG;AACA;EACE,8BAA8B;EAC9B,kGAAkG;AACpG;AACA;EACE,8BAA8B;EAC9B,gGAAgG;AAClG;AACA;EACE,8BAA8B;EAC9B,gGAAgG;AAClG;AACA;EACE,8BAA8B;EAC9B,oGAAoG;AACtG;AACA;EACE,8BAA8B;EAC9B,oGAAoG;AACtG;AACA;EACE,8BAA8B;EAC9B,oGAAoG;AACtG;AACA;EACE,8BAA8B;EAC9B,oGAAoG;AACtG;AACA;EACE,8BAA8B;EAC9B,oGAAoG;AACtG;AACA;EACE,8BAA8B;EAC9B,mGAAmG;AACrG;AACA;EACE,8BAA8B;EAC9B,mGAAmG;AACrG;AACA;EACE,8BAA8B;EAC9B,kGAAkG;AACpG;AACA;EACE,8BAA8B;EAC9B,kGAAkG;AACpG;AACA;EACE,8BAA8B;EAC9B,kGAAkG;AACpG;AACA;EACE,8BAA8B;EAC9B,oGAAoG;AACtG;AACA;EACE,8BAA8B;EAC9B,oGAAoG;AACtG;AACA;EACE,8BAA8B;EAC9B,oGAAoG;AACtG;AACA;EACE,8BAA8B;EAC9B,oGAAoG;AACtG;AACA;EACE,8BAA8B;EAC9B,oGAAoG;AACtG;AACA;EACE,8BAA8B;EAC9B,oGAAoG;AACtG;AACA;EACE,8BAA8B;EAC9B,kGAAkG;AACpG;AACA;EACE,8BAA8B;EAC9B,kGAAkG;AACpG;AACA;EACE,8BAA8B;EAC9B,kGAAkG;AACpG;AACA;EACE,8BAA8B;EAC9B,kGAAkG;AACpG;AACA;EACE,8BAA8B;EAC9B,oGAAoG;AACtG;AACA;EACE,8BAA8B;EAC9B,oGAAoG;AACtG;AACA;EACE,8BAA8B;EAC9B,oGAAoG;AACtG;AACA;EACE,8BAA8B;EAC9B,oGAAoG;AACtG;AACA;EACE,8BAA8B;EAC9B,oGAAoG;AACtG;AACA;EACE,8BAA8B;EAC9B,mGAAmG;AACrG;AACA;EACE,8BAA8B;EAC9B,mGAAmG;AACrG;AACA;EACE,8BAA8B;EAC9B,mGAAmG;AACrG;AACA;EACE,8BAA8B;EAC9B,kGAAkG;AACpG;AACA;EACE,8BAA8B;EAC9B,kGAAkG;AACpG;AACA;EACE,8BAA8B;EAC9B,oGAAoG;AACtG;AACA;EACE,8BAA8B;EAC9B,oGAAoG;AACtG;AACA;EACE,8BAA8B;EAC9B,oGAAoG;AACtG;AACA;EACE,8BAA8B;EAC9B,oGAAoG;AACtG;AACA;EACE,8BAA8B;EAC9B,oGAAoG;AACtG;AACA;EACE,8BAA8B;EAC9B,mGAAmG;AACrG;AACA;EACE,8BAA8B;EAC9B,mGAAmG;AACrG;AACA;EACE,8BAA8B;EAC9B,kGAAkG;AACpG;AACA;EACE,8BAA8B;EAC9B,kGAAkG;AACpG;AACA;EACE,8BAA8B;EAC9B,kGAAkG;AACpG;AACA;EACE,8BAA8B;EAC9B,oGAAoG;AACtG;AACA;EACE,8BAA8B;EAC9B,oGAAoG;AACtG;AACA;EACE,8BAA8B;EAC9B,oGAAoG;AACtG;AACA;EACE,8BAA8B;EAC9B,oGAAoG;AACtG;AACA;EACE,8BAA8B;EAC9B,oGAAoG;AACtG;AACA;EACE,8BAA8B;EAC9B,oGAAoG;AACtG;AACA;EACE,8BAA8B;EAC9B,kGAAkG;AACpG;AACA;EACE,8BAA8B;EAC9B,iGAAiG;AACnG;AACA;EACE,8BAA8B;EAC9B,iGAAiG;AACnG;AACA;EACE,8BAA8B;EAC9B,iGAAiG;AACnG;AACA;EACE,kCAAkC;EAClC,+HAA+H;AACjI;AACA;EACE,iCAAiC;EACjC,yHAAyH;AAC3H;AACA;EACE,6BAA6B;EAC7B,+HAA+H;AACjI;AACA;EACE,6BAA6B;EAC7B,yHAAyH;AAC3H;AACA;EACE,6BAA6B;EAC7B,+HAA+H;AACjI;AACA;EACE,6BAA6B;EAC7B,+HAA+H;AACjI;AACA;EACE,6BAA6B;EAC7B,+HAA+H;AACjI;AACA;EACE,6BAA6B;EAC7B,+HAA+H;AACjI;AACA;EACE,6BAA6B;EAC7B,+HAA+H;AACjI;AACA;EACE,6BAA6B;EAC7B,+HAA+H;AACjI;AACA;EACE,6BAA6B;EAC7B,4HAA4H;AAC9H;AACA;EACE,6BAA6B;EAC7B,4HAA4H;AAC9H;AACA;EACE,6BAA6B;EAC7B,4HAA4H;AAC9H;AACA;EACE,6BAA6B;EAC7B,4HAA4H;AAC9H;AACA;EACE,6BAA6B;EAC7B,+HAA+H;AACjI;AACA;EACE,6BAA6B;EAC7B,+HAA+H;AACjI;AACA;EACE,6BAA6B;EAC7B,+HAA+H;AACjI;AACA;EACE,6BAA6B;EAC7B,+HAA+H;AACjI;AACA;EACE,6BAA6B;EAC7B,+HAA+H;AACjI;AACA;EACE,6BAA6B;EAC7B,6HAA6H;AAC/H;AACA;EACE,6BAA6B;EAC7B,6HAA6H;AAC/H;AACA;EACE,6BAA6B;EAC7B,6HAA6H;AAC/H;AACA;EACE,6BAA6B;EAC7B,6HAA6H;AAC/H;AACA;EACE,6BAA6B;EAC7B,6HAA6H;AAC/H;AACA;EACE,6BAA6B;EAC7B,+HAA+H;AACjI;AACA;EACE,6BAA6B;EAC7B,+HAA+H;AACjI;AACA;EACE,6BAA6B;EAC7B,+HAA+H;AACjI;AACA;EACE,6BAA6B;EAC7B,+HAA+H;AACjI;AACA;EACE,6BAA6B;EAC7B,8HAA8H;AAChI;AACA;EACE,6BAA6B;EAC7B,6HAA6H;AAC/H;AACA;EACE,6BAA6B;EAC7B,4HAA4H;AAC9H;AACA;EACE,6BAA6B;EAC7B,4HAA4H;AAC9H;AACA;EACE,6BAA6B;EAC7B,6HAA6H;AAC/H;AACA;EACE,6BAA6B;EAC7B,6HAA6H;AAC/H;AACA;EACE,6BAA6B;EAC7B,+HAA+H;AACjI;AACA;EACE,6BAA6B;EAC7B,+HAA+H;AACjI;AACA;EACE,6BAA6B;EAC7B,+HAA+H;AACjI;AACA;EACE,6BAA6B;EAC7B,8HAA8H;AAChI;AACA;EACE,6BAA6B;EAC7B,6HAA6H;AAC/H;AACA;EACE,6BAA6B;EAC7B,6HAA6H;AAC/H;AACA;EACE,6BAA6B;EAC7B,6HAA6H;AAC/H;AACA;EACE,6BAA6B;EAC7B,6HAA6H;AAC/H;AACA;EACE,6BAA6B;EAC7B,6HAA6H;AAC/H;AACA;EACE,6BAA6B;EAC7B,4HAA4H;AAC9H;AACA;EACE,6BAA6B;EAC7B,+HAA+H;AACjI;AACA;EACE,6BAA6B;EAC7B,+HAA+H;AACjI;AACA;EACE,6BAA6B;EAC7B,+HAA+H;AACjI;AACA;EACE,6BAA6B;EAC7B,+HAA+H;AACjI;AACA;EACE,6BAA6B;EAC7B,8HAA8H;AAChI;AACA;EACE,6BAA6B;EAC7B,8HAA8H;AAChI;AACA;EACE,6BAA6B;EAC7B,4HAA4H;AAC9H;AACA;EACE,6BAA6B;EAC7B,4HAA4H;AAC9H;AACA;EACE,6BAA6B;EAC7B,2HAA2H;AAC7H;AACA;EACE,6BAA6B;EAC7B,2HAA2H;AAC7H;AACA;EACE,6BAA6B;EAC7B,+HAA+H;AACjI;AACA;EACE,6BAA6B;EAC7B,+HAA+H;AACjI;AACA;EACE,6BAA6B;EAC7B,+HAA+H;AACjI;AACA;EACE,6BAA6B;EAC7B,+HAA+H;AACjI;AACA;EACE,6BAA6B;EAC7B,8HAA8H;AAChI;AACA;EACE,6BAA6B;EAC7B,6HAA6H;AAC/H;AACA;EACE,6BAA6B;EAC7B,6HAA6H;AAC/H;AACA;EACE,6BAA6B;EAC7B,6HAA6H;AAC/H;AACA;EACE,6BAA6B;EAC7B,2HAA2H;AAC7H;AACA;EACE,6BAA6B;EAC7B,2HAA2H;AAC7H;AACA;EACE,6BAA6B;EAC7B,+HAA+H;AACjI;AACA;EACE,6BAA6B;EAC7B,+HAA+H;AACjI;AACA;EACE,6BAA6B;EAC7B,+HAA+H;AACjI;AACA;EACE,6BAA6B;EAC7B,+HAA+H;AACjI;AACA;EACE,6BAA6B;EAC7B,+HAA+H;AACjI;AACA;EACE,6BAA6B;EAC7B,8HAA8H;AAChI;AACA;EACE,6BAA6B;EAC7B,8HAA8H;AAChI;AACA;EACE,6BAA6B;EAC7B,6HAA6H;AAC/H;AACA;EACE,6BAA6B;EAC7B,6HAA6H;AAC/H;AACA;EACE,6BAA6B;EAC7B,6HAA6H;AAC/H;AACA;EACE,6BAA6B;EAC7B,+HAA+H;AACjI;AACA;EACE,6BAA6B;EAC7B,+HAA+H;AACjI;AACA;EACE,6BAA6B;EAC7B,+HAA+H;AACjI;AACA;EACE,6BAA6B;EAC7B,+HAA+H;AACjI;AACA;EACE,6BAA6B;EAC7B,+HAA+H;AACjI;AACA;EACE,6BAA6B;EAC7B,+HAA+H;AACjI;AACA;EACE,6BAA6B;EAC7B,6HAA6H;AAC/H;AACA;EACE,6BAA6B;EAC7B,6HAA6H;AAC/H;AACA;EACE,6BAA6B;EAC7B,6HAA6H;AAC/H;AACA;EACE,6BAA6B;EAC7B,6HAA6H;AAC/H;AACA;EACE,6BAA6B;EAC7B,+HAA+H;AACjI;AACA;EACE,6BAA6B;EAC7B,+HAA+H;AACjI;AACA;EACE,6BAA6B;EAC7B,+HAA+H;AACjI;AACA;EACE,6BAA6B;EAC7B,+HAA+H;AACjI;AACA;EACE,6BAA6B;EAC7B,+HAA+H;AACjI;AACA;EACE,6BAA6B;EAC7B,8HAA8H;AAChI;AACA;EACE,6BAA6B;EAC7B,8HAA8H;AAChI;AACA;EACE,6BAA6B;EAC7B,8HAA8H;AAChI;AACA;EACE,6BAA6B;EAC7B,6HAA6H;AAC/H;AACA;EACE,6BAA6B;EAC7B,6HAA6H;AAC/H;AACA;EACE,6BAA6B;EAC7B,+HAA+H;AACjI;AACA;EACE,6BAA6B;EAC7B,+HAA+H;AACjI;AACA;EACE,6BAA6B;EAC7B,+HAA+H;AACjI;AACA;EACE,6BAA6B;EAC7B,+HAA+H;AACjI;AACA;EACE,6BAA6B;EAC7B,+HAA+H;AACjI;AACA;EACE,6BAA6B;EAC7B,8HAA8H;AAChI;AACA;EACE,6BAA6B;EAC7B,8HAA8H;AAChI;AACA;EACE,6BAA6B;EAC7B,6HAA6H;AAC/H;AACA;EACE,6BAA6B;EAC7B,6HAA6H;AAC/H;AACA;EACE,6BAA6B;EAC7B,6HAA6H;AAC/H;AACA;EACE,6BAA6B;EAC7B,+HAA+H;AACjI;AACA;EACE,6BAA6B;EAC7B,+HAA+H;AACjI;AACA;EACE,6BAA6B;EAC7B,+HAA+H;AACjI;AACA;EACE,6BAA6B;EAC7B,+HAA+H;AACjI;AACA;EACE,6BAA6B;EAC7B,+HAA+H;AACjI;AACA;EACE,6BAA6B;EAC7B,+HAA+H;AACjI;AACA;EACE,6BAA6B;EAC7B,6HAA6H;AAC/H;AACA;EACE,6BAA6B;EAC7B,4HAA4H;AAC9H;AACA;EACE,6BAA6B;EAC7B,4HAA4H;AAC9H;AACA;EACE,6BAA6B;EAC7B,4HAA4H;AAC9H;AACA;EACE,iCAAiC;AACnC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,mCAAmC;EACnC,oGAAoG;AACtG;AACA;EACE,kCAAkC;EAClC,8FAA8F;AAChG;AACA;EACE,8BAA8B;EAC9B,oGAAoG;AACtG;AACA;EACE,8BAA8B;EAC9B,8FAA8F;AAChG;AACA;EACE,8BAA8B;EAC9B,oGAAoG;AACtG;AACA;EACE,8BAA8B;EAC9B,oGAAoG;AACtG;AACA;EACE,8BAA8B;EAC9B,oGAAoG;AACtG;AACA;EACE,8BAA8B;EAC9B,oGAAoG;AACtG;AACA;EACE,8BAA8B;EAC9B,oGAAoG;AACtG;AACA;EACE,8BAA8B;EAC9B,oGAAoG;AACtG;AACA;EACE,8BAA8B;EAC9B,iGAAiG;AACnG;AACA;EACE,8BAA8B;EAC9B,iGAAiG;AACnG;AACA;EACE,8BAA8B;EAC9B,iGAAiG;AACnG;AACA;EACE,8BAA8B;EAC9B,iGAAiG;AACnG;AACA;EACE,8BAA8B;EAC9B,oGAAoG;AACtG;AACA;EACE,8BAA8B;EAC9B,oGAAoG;AACtG;AACA;EACE,8BAA8B;EAC9B,oGAAoG;AACtG;AACA;EACE,8BAA8B;EAC9B,oGAAoG;AACtG;AACA;EACE,8BAA8B;EAC9B,oGAAoG;AACtG;AACA;EACE,8BAA8B;EAC9B,kGAAkG;AACpG;AACA;EACE,8BAA8B;EAC9B,kGAAkG;AACpG;AACA;EACE,8BAA8B;EAC9B,kGAAkG;AACpG;AACA;EACE,8BAA8B;EAC9B,kGAAkG;AACpG;AACA;EACE,8BAA8B;EAC9B,kGAAkG;AACpG;AACA;EACE,8BAA8B;EAC9B,oGAAoG;AACtG;AACA;EACE,8BAA8B;EAC9B,oGAAoG;AACtG;AACA;EACE,8BAA8B;EAC9B,oGAAoG;AACtG;AACA;EACE,8BAA8B;EAC9B,oGAAoG;AACtG;AACA;EACE,8BAA8B;EAC9B,mGAAmG;AACrG;AACA;EACE,8BAA8B;EAC9B,kGAAkG;AACpG;AACA;EACE,8BAA8B;EAC9B,iGAAiG;AACnG;AACA;EACE,8BAA8B;EAC9B,iGAAiG;AACnG;AACA;EACE,8BAA8B;EAC9B,kGAAkG;AACpG;AACA;EACE,8BAA8B;EAC9B,kGAAkG;AACpG;AACA;EACE,8BAA8B;EAC9B,oGAAoG;AACtG;AACA;EACE,8BAA8B;EAC9B,oGAAoG;AACtG;AACA;EACE,8BAA8B;EAC9B,oGAAoG;AACtG;AACA;EACE,8BAA8B;EAC9B,mGAAmG;AACrG;AACA;EACE,8BAA8B;EAC9B,kGAAkG;AACpG;AACA;EACE,8BAA8B;EAC9B,kGAAkG;AACpG;AACA;EACE,8BAA8B;EAC9B,kGAAkG;AACpG;AACA;EACE,8BAA8B;EAC9B,kGAAkG;AACpG;AACA;EACE,8BAA8B;EAC9B,kGAAkG;AACpG;AACA;EACE,8BAA8B;EAC9B,iGAAiG;AACnG;AACA;EACE,8BAA8B;EAC9B,oGAAoG;AACtG;AACA;EACE,8BAA8B;EAC9B,oGAAoG;AACtG;AACA;EACE,8BAA8B;EAC9B,oGAAoG;AACtG;AACA;EACE,8BAA8B;EAC9B,oGAAoG;AACtG;AACA;EACE,8BAA8B;EAC9B,mGAAmG;AACrG;AACA;EACE,8BAA8B;EAC9B,mGAAmG;AACrG;AACA;EACE,8BAA8B;EAC9B,iGAAiG;AACnG;AACA;EACE,8BAA8B;EAC9B,iGAAiG;AACnG;AACA;EACE,8BAA8B;EAC9B,gGAAgG;AAClG;AACA;EACE,8BAA8B;EAC9B,gGAAgG;AAClG;AACA;EACE,8BAA8B;EAC9B,oGAAoG;AACtG;AACA;EACE,8BAA8B;EAC9B,oGAAoG;AACtG;AACA;EACE,8BAA8B;EAC9B,oGAAoG;AACtG;AACA;EACE,8BAA8B;EAC9B,oGAAoG;AACtG;AACA;EACE,8BAA8B;EAC9B,mGAAmG;AACrG;AACA;EACE,8BAA8B;EAC9B,kGAAkG;AACpG;AACA;EACE,8BAA8B;EAC9B,kGAAkG;AACpG;AACA;EACE,8BAA8B;EAC9B,kGAAkG;AACpG;AACA;EACE,8BAA8B;EAC9B,gGAAgG;AAClG;AACA;EACE,8BAA8B;EAC9B,gGAAgG;AAClG;AACA;EACE,8BAA8B;EAC9B,oGAAoG;AACtG;AACA;EACE,8BAA8B;EAC9B,oGAAoG;AACtG;AACA;EACE,8BAA8B;EAC9B,oGAAoG;AACtG;AACA;EACE,8BAA8B;EAC9B,oGAAoG;AACtG;AACA;EACE,8BAA8B;EAC9B,oGAAoG;AACtG;AACA;EACE,8BAA8B;EAC9B,mGAAmG;AACrG;AACA;EACE,8BAA8B;EAC9B,mGAAmG;AACrG;AACA;EACE,8BAA8B;EAC9B,kGAAkG;AACpG;AACA;EACE,8BAA8B;EAC9B,kGAAkG;AACpG;AACA;EACE,8BAA8B;EAC9B,kGAAkG;AACpG;AACA;EACE,8BAA8B;EAC9B,oGAAoG;AACtG;AACA;EACE,8BAA8B;EAC9B,oGAAoG;AACtG;AACA;EACE,8BAA8B;EAC9B,oGAAoG;AACtG;AACA;EACE,8BAA8B;EAC9B,oGAAoG;AACtG;AACA;EACE,8BAA8B;EAC9B,oGAAoG;AACtG;AACA;EACE,8BAA8B;EAC9B,oGAAoG;AACtG;AACA;EACE,8BAA8B;EAC9B,kGAAkG;AACpG;AACA;EACE,8BAA8B;EAC9B,kGAAkG;AACpG;AACA;EACE,8BAA8B;EAC9B,kGAAkG;AACpG;AACA;EACE,8BAA8B;EAC9B,kGAAkG;AACpG;AACA;EACE,8BAA8B;EAC9B,oGAAoG;AACtG;AACA;EACE,8BAA8B;EAC9B,oGAAoG;AACtG;AACA;EACE,8BAA8B;EAC9B,oGAAoG;AACtG;AACA;EACE,8BAA8B;EAC9B,oGAAoG;AACtG;AACA;EACE,8BAA8B;EAC9B,oGAAoG;AACtG;AACA;EACE,8BAA8B;EAC9B,mGAAmG;AACrG;AACA;EACE,8BAA8B;EAC9B,mGAAmG;AACrG;AACA;EACE,8BAA8B;EAC9B,mGAAmG;AACrG;AACA;EACE,8BAA8B;EAC9B,kGAAkG;AACpG;AACA;EACE,8BAA8B;EAC9B,kGAAkG;AACpG;AACA;EACE,8BAA8B;EAC9B,oGAAoG;AACtG;AACA;EACE,8BAA8B;EAC9B,oGAAoG;AACtG;AACA;EACE,8BAA8B;EAC9B,oGAAoG;AACtG;AACA;EACE,8BAA8B;EAC9B,oGAAoG;AACtG;AACA;EACE,8BAA8B;EAC9B,oGAAoG;AACtG;AACA;EACE,8BAA8B;EAC9B,mGAAmG;AACrG;AACA;EACE,8BAA8B;EAC9B,mGAAmG;AACrG;AACA;EACE,8BAA8B;EAC9B,kGAAkG;AACpG;AACA;EACE,8BAA8B;EAC9B,kGAAkG;AACpG;AACA;EACE,8BAA8B;EAC9B,kGAAkG;AACpG;AACA;EACE,8BAA8B;EAC9B,oGAAoG;AACtG;AACA;EACE,8BAA8B;EAC9B,oGAAoG;AACtG;AACA;EACE,8BAA8B;EAC9B,oGAAoG;AACtG;AACA;EACE,8BAA8B;EAC9B,oGAAoG;AACtG;AACA;EACE,8BAA8B;EAC9B,oGAAoG;AACtG;AACA;EACE,8BAA8B;EAC9B,oGAAoG;AACtG;AACA;EACE,8BAA8B;EAC9B,kGAAkG;AACpG;AACA;EACE,8BAA8B;EAC9B,iGAAiG;AACnG;AACA;EACE,8BAA8B;EAC9B,iGAAiG;AACnG;AACA;EACE,8BAA8B;EAC9B,iGAAiG;AACnG;AACA;EACE,kCAAkC;EAClC,+HAA+H;AACjI;AACA;EACE,iCAAiC;EACjC,yHAAyH;AAC3H;AACA;EACE,6BAA6B;EAC7B,+HAA+H;AACjI;AACA;EACE,6BAA6B;EAC7B,yHAAyH;AAC3H;AACA;EACE,6BAA6B;EAC7B,+HAA+H;AACjI;AACA;EACE,6BAA6B;EAC7B,+HAA+H;AACjI;AACA;EACE,6BAA6B;EAC7B,+HAA+H;AACjI;AACA;EACE,6BAA6B;EAC7B,+HAA+H;AACjI;AACA;EACE,6BAA6B;EAC7B,+HAA+H;AACjI;AACA;EACE,6BAA6B;EAC7B,+HAA+H;AACjI;AACA;EACE,6BAA6B;EAC7B,4HAA4H;AAC9H;AACA;EACE,6BAA6B;EAC7B,4HAA4H;AAC9H;AACA;EACE,6BAA6B;EAC7B,4HAA4H;AAC9H;AACA;EACE,6BAA6B;EAC7B,4HAA4H;AAC9H;AACA;EACE,6BAA6B;EAC7B,+HAA+H;AACjI;AACA;EACE,6BAA6B;EAC7B,+HAA+H;AACjI;AACA;EACE,6BAA6B;EAC7B,+HAA+H;AACjI;AACA;EACE,6BAA6B;EAC7B,+HAA+H;AACjI;AACA;EACE,6BAA6B;EAC7B,+HAA+H;AACjI;AACA;EACE,6BAA6B;EAC7B,6HAA6H;AAC/H;AACA;EACE,6BAA6B;EAC7B,6HAA6H;AAC/H;AACA;EACE,6BAA6B;EAC7B,6HAA6H;AAC/H;AACA;EACE,6BAA6B;EAC7B,6HAA6H;AAC/H;AACA;EACE,6BAA6B;EAC7B,6HAA6H;AAC/H;AACA;EACE,6BAA6B;EAC7B,+HAA+H;AACjI;AACA;EACE,6BAA6B;EAC7B,+HAA+H;AACjI;AACA;EACE,6BAA6B;EAC7B,+HAA+H;AACjI;AACA;EACE,6BAA6B;EAC7B,+HAA+H;AACjI;AACA;EACE,6BAA6B;EAC7B,8HAA8H;AAChI;AACA;EACE,6BAA6B;EAC7B,6HAA6H;AAC/H;AACA;EACE,6BAA6B;EAC7B,4HAA4H;AAC9H;AACA;EACE,6BAA6B;EAC7B,4HAA4H;AAC9H;AACA;EACE,6BAA6B;EAC7B,6HAA6H;AAC/H;AACA;EACE,6BAA6B;EAC7B,6HAA6H;AAC/H;AACA;EACE,6BAA6B;EAC7B,+HAA+H;AACjI;AACA;EACE,6BAA6B;EAC7B,+HAA+H;AACjI;AACA;EACE,6BAA6B;EAC7B,+HAA+H;AACjI;AACA;EACE,6BAA6B;EAC7B,8HAA8H;AAChI;AACA;EACE,6BAA6B;EAC7B,6HAA6H;AAC/H;AACA;EACE,6BAA6B;EAC7B,6HAA6H;AAC/H;AACA;EACE,6BAA6B;EAC7B,6HAA6H;AAC/H;AACA;EACE,6BAA6B;EAC7B,6HAA6H;AAC/H;AACA;EACE,6BAA6B;EAC7B,6HAA6H;AAC/H;AACA;EACE,6BAA6B;EAC7B,4HAA4H;AAC9H;AACA;EACE,6BAA6B;EAC7B,+HAA+H;AACjI;AACA;EACE,6BAA6B;EAC7B,+HAA+H;AACjI;AACA;EACE,6BAA6B;EAC7B,+HAA+H;AACjI;AACA;EACE,6BAA6B;EAC7B,+HAA+H;AACjI;AACA;EACE,6BAA6B;EAC7B,8HAA8H;AAChI;AACA;EACE,6BAA6B;EAC7B,8HAA8H;AAChI;AACA;EACE,6BAA6B;EAC7B,4HAA4H;AAC9H;AACA;EACE,6BAA6B;EAC7B,4HAA4H;AAC9H;AACA;EACE,6BAA6B;EAC7B,2HAA2H;AAC7H;AACA;EACE,6BAA6B;EAC7B,2HAA2H;AAC7H;AACA;EACE,6BAA6B;EAC7B,+HAA+H;AACjI;AACA;EACE,6BAA6B;EAC7B,+HAA+H;AACjI;AACA;EACE,6BAA6B;EAC7B,+HAA+H;AACjI;AACA;EACE,6BAA6B;EAC7B,+HAA+H;AACjI;AACA;EACE,6BAA6B;EAC7B,8HAA8H;AAChI;AACA;EACE,6BAA6B;EAC7B,6HAA6H;AAC/H;AACA;EACE,6BAA6B;EAC7B,6HAA6H;AAC/H;AACA;EACE,6BAA6B;EAC7B,6HAA6H;AAC/H;AACA;EACE,6BAA6B;EAC7B,2HAA2H;AAC7H;AACA;EACE,6BAA6B;EAC7B,2HAA2H;AAC7H;AACA;EACE,6BAA6B;EAC7B,+HAA+H;AACjI;AACA;EACE,6BAA6B;EAC7B,+HAA+H;AACjI;AACA;EACE,6BAA6B;EAC7B,+HAA+H;AACjI;AACA;EACE,6BAA6B;EAC7B,+HAA+H;AACjI;AACA;EACE,6BAA6B;EAC7B,+HAA+H;AACjI;AACA;EACE,6BAA6B;EAC7B,8HAA8H;AAChI;AACA;EACE,6BAA6B;EAC7B,8HAA8H;AAChI;AACA;EACE,6BAA6B;EAC7B,6HAA6H;AAC/H;AACA;EACE,6BAA6B;EAC7B,6HAA6H;AAC/H;AACA;EACE,6BAA6B;EAC7B,6HAA6H;AAC/H;AACA;EACE,6BAA6B;EAC7B,+HAA+H;AACjI;AACA;EACE,6BAA6B;EAC7B,+HAA+H;AACjI;AACA;EACE,6BAA6B;EAC7B,+HAA+H;AACjI;AACA;EACE,6BAA6B;EAC7B,+HAA+H;AACjI;AACA;EACE,6BAA6B;EAC7B,+HAA+H;AACjI;AACA;EACE,6BAA6B;EAC7B,+HAA+H;AACjI;AACA;EACE,6BAA6B;EAC7B,6HAA6H;AAC/H;AACA;EACE,6BAA6B;EAC7B,6HAA6H;AAC/H;AACA;EACE,6BAA6B;EAC7B,6HAA6H;AAC/H;AACA;EACE,6BAA6B;EAC7B,6HAA6H;AAC/H;AACA;EACE,6BAA6B;EAC7B,+HAA+H;AACjI;AACA;EACE,6BAA6B;EAC7B,+HAA+H;AACjI;AACA;EACE,6BAA6B;EAC7B,+HAA+H;AACjI;AACA;EACE,6BAA6B;EAC7B,+HAA+H;AACjI;AACA;EACE,6BAA6B;EAC7B,+HAA+H;AACjI;AACA;EACE,6BAA6B;EAC7B,8HAA8H;AAChI;AACA;EACE,6BAA6B;EAC7B,8HAA8H;AAChI;AACA;EACE,6BAA6B;EAC7B,8HAA8H;AAChI;AACA;EACE,6BAA6B;EAC7B,6HAA6H;AAC/H;AACA;EACE,6BAA6B;EAC7B,6HAA6H;AAC/H;AACA;EACE,6BAA6B;EAC7B,+HAA+H;AACjI;AACA;EACE,6BAA6B;EAC7B,+HAA+H;AACjI;AACA;EACE,6BAA6B;EAC7B,+HAA+H;AACjI;AACA;EACE,6BAA6B;EAC7B,+HAA+H;AACjI;AACA;EACE,6BAA6B;EAC7B,+HAA+H;AACjI;AACA;EACE,6BAA6B;EAC7B,8HAA8H;AAChI;AACA;EACE,6BAA6B;EAC7B,8HAA8H;AAChI;AACA;EACE,6BAA6B;EAC7B,6HAA6H;AAC/H;AACA;EACE,6BAA6B;EAC7B,6HAA6H;AAC/H;AACA;EACE,6BAA6B;EAC7B,6HAA6H;AAC/H;AACA;EACE,6BAA6B;EAC7B,+HAA+H;AACjI;AACA;EACE,6BAA6B;EAC7B,+HAA+H;AACjI;AACA;EACE,6BAA6B;EAC7B,+HAA+H;AACjI;AACA;EACE,6BAA6B;EAC7B,+HAA+H;AACjI;AACA;EACE,6BAA6B;EAC7B,+HAA+H;AACjI;AACA;EACE,6BAA6B;EAC7B,+HAA+H;AACjI;AACA;EACE,6BAA6B;EAC7B,6HAA6H;AAC/H;AACA;EACE,6BAA6B;EAC7B,4HAA4H;AAC9H;AACA;EACE,6BAA6B;EAC7B,4HAA4H;AAC9H;AACA;EACE,6BAA6B;EAC7B,4HAA4H;AAC9H;AACA;EACE,iCAAiC;AACnC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,mCAAmC;EACnC,oGAAoG;AACtG;AACA;EACE,kCAAkC;EAClC,8FAA8F;AAChG;AACA;EACE,8BAA8B;EAC9B,oGAAoG;AACtG;AACA;EACE,8BAA8B;EAC9B,8FAA8F;AAChG;AACA;EACE,8BAA8B;EAC9B,oGAAoG;AACtG;AACA;EACE,8BAA8B;EAC9B,oGAAoG;AACtG;AACA;EACE,8BAA8B;EAC9B,oGAAoG;AACtG;AACA;EACE,8BAA8B;EAC9B,oGAAoG;AACtG;AACA;EACE,8BAA8B;EAC9B,oGAAoG;AACtG;AACA;EACE,8BAA8B;EAC9B,oGAAoG;AACtG;AACA;EACE,8BAA8B;EAC9B,iGAAiG;AACnG;AACA;EACE,8BAA8B;EAC9B,iGAAiG;AACnG;AACA;EACE,8BAA8B;EAC9B,iGAAiG;AACnG;AACA;EACE,8BAA8B;EAC9B,iGAAiG;AACnG;AACA;EACE,8BAA8B;EAC9B,oGAAoG;AACtG;AACA;EACE,8BAA8B;EAC9B,oGAAoG;AACtG;AACA;EACE,8BAA8B;EAC9B,oGAAoG;AACtG;AACA;EACE,8BAA8B;EAC9B,oGAAoG;AACtG;AACA;EACE,8BAA8B;EAC9B,oGAAoG;AACtG;AACA;EACE,8BAA8B;EAC9B,kGAAkG;AACpG;AACA;EACE,8BAA8B;EAC9B,kGAAkG;AACpG;AACA;EACE,8BAA8B;EAC9B,kGAAkG;AACpG;AACA;EACE,8BAA8B;EAC9B,kGAAkG;AACpG;AACA;EACE,8BAA8B;EAC9B,kGAAkG;AACpG;AACA;EACE,8BAA8B;EAC9B,oGAAoG;AACtG;AACA;EACE,8BAA8B;EAC9B,oGAAoG;AACtG;AACA;EACE,8BAA8B;EAC9B,oGAAoG;AACtG;AACA;EACE,8BAA8B;EAC9B,oGAAoG;AACtG;AACA;EACE,8BAA8B;EAC9B,mGAAmG;AACrG;AACA;EACE,8BAA8B;EAC9B,kGAAkG;AACpG;AACA;EACE,8BAA8B;EAC9B,iGAAiG;AACnG;AACA;EACE,8BAA8B;EAC9B,iGAAiG;AACnG;AACA;EACE,8BAA8B;EAC9B,kGAAkG;AACpG;AACA;EACE,8BAA8B;EAC9B,kGAAkG;AACpG;AACA;EACE,8BAA8B;EAC9B,oGAAoG;AACtG;AACA;EACE,8BAA8B;EAC9B,oGAAoG;AACtG;AACA;EACE,8BAA8B;EAC9B,oGAAoG;AACtG;AACA;EACE,8BAA8B;EAC9B,mGAAmG;AACrG;AACA;EACE,8BAA8B;EAC9B,kGAAkG;AACpG;AACA;EACE,8BAA8B;EAC9B,kGAAkG;AACpG;AACA;EACE,8BAA8B;EAC9B,kGAAkG;AACpG;AACA;EACE,8BAA8B;EAC9B,kGAAkG;AACpG;AACA;EACE,8BAA8B;EAC9B,kGAAkG;AACpG;AACA;EACE,8BAA8B;EAC9B,iGAAiG;AACnG;AACA;EACE,8BAA8B;EAC9B,oGAAoG;AACtG;AACA;EACE,8BAA8B;EAC9B,oGAAoG;AACtG;AACA;EACE,8BAA8B;EAC9B,oGAAoG;AACtG;AACA;EACE,8BAA8B;EAC9B,oGAAoG;AACtG;AACA;EACE,8BAA8B;EAC9B,mGAAmG;AACrG;AACA;EACE,8BAA8B;EAC9B,mGAAmG;AACrG;AACA;EACE,8BAA8B;EAC9B,iGAAiG;AACnG;AACA;EACE,8BAA8B;EAC9B,iGAAiG;AACnG;AACA;EACE,8BAA8B;EAC9B,gGAAgG;AAClG;AACA;EACE,8BAA8B;EAC9B,gGAAgG;AAClG;AACA;EACE,8BAA8B;EAC9B,oGAAoG;AACtG;AACA;EACE,8BAA8B;EAC9B,oGAAoG;AACtG;AACA;EACE,8BAA8B;EAC9B,oGAAoG;AACtG;AACA;EACE,8BAA8B;EAC9B,oGAAoG;AACtG;AACA;EACE,8BAA8B;EAC9B,mGAAmG;AACrG;AACA;EACE,8BAA8B;EAC9B,kGAAkG;AACpG;AACA;EACE,8BAA8B;EAC9B,kGAAkG;AACpG;AACA;EACE,8BAA8B;EAC9B,kGAAkG;AACpG;AACA;EACE,8BAA8B;EAC9B,gGAAgG;AAClG;AACA;EACE,8BAA8B;EAC9B,gGAAgG;AAClG;AACA;EACE,8BAA8B;EAC9B,oGAAoG;AACtG;AACA;EACE,8BAA8B;EAC9B,oGAAoG;AACtG;AACA;EACE,8BAA8B;EAC9B,oGAAoG;AACtG;AACA;EACE,8BAA8B;EAC9B,oGAAoG;AACtG;AACA;EACE,8BAA8B;EAC9B,oGAAoG;AACtG;AACA;EACE,8BAA8B;EAC9B,mGAAmG;AACrG;AACA;EACE,8BAA8B;EAC9B,mGAAmG;AACrG;AACA;EACE,8BAA8B;EAC9B,kGAAkG;AACpG;AACA;EACE,8BAA8B;EAC9B,kGAAkG;AACpG;AACA;EACE,8BAA8B;EAC9B,kGAAkG;AACpG;AACA;EACE,8BAA8B;EAC9B,oGAAoG;AACtG;AACA;EACE,8BAA8B;EAC9B,oGAAoG;AACtG;AACA;EACE,8BAA8B;EAC9B,oGAAoG;AACtG;AACA;EACE,8BAA8B;EAC9B,oGAAoG;AACtG;AACA;EACE,8BAA8B;EAC9B,oGAAoG;AACtG;AACA;EACE,8BAA8B;EAC9B,oGAAoG;AACtG;AACA;EACE,8BAA8B;EAC9B,kGAAkG;AACpG;AACA;EACE,8BAA8B;EAC9B,kGAAkG;AACpG;AACA;EACE,8BAA8B;EAC9B,kGAAkG;AACpG;AACA;EACE,8BAA8B;EAC9B,kGAAkG;AACpG;AACA;EACE,8BAA8B;EAC9B,oGAAoG;AACtG;AACA;EACE,8BAA8B;EAC9B,oGAAoG;AACtG;AACA;EACE,8BAA8B;EAC9B,oGAAoG;AACtG;AACA;EACE,8BAA8B;EAC9B,oGAAoG;AACtG;AACA;EACE,8BAA8B;EAC9B,oGAAoG;AACtG;AACA;EACE,8BAA8B;EAC9B,mGAAmG;AACrG;AACA;EACE,8BAA8B;EAC9B,mGAAmG;AACrG;AACA;EACE,8BAA8B;EAC9B,mGAAmG;AACrG;AACA;EACE,8BAA8B;EAC9B,kGAAkG;AACpG;AACA;EACE,8BAA8B;EAC9B,kGAAkG;AACpG;AACA;EACE,8BAA8B;EAC9B,oGAAoG;AACtG;AACA;EACE,8BAA8B;EAC9B,oGAAoG;AACtG;AACA;EACE,8BAA8B;EAC9B,oGAAoG;AACtG;AACA;EACE,8BAA8B;EAC9B,oGAAoG;AACtG;AACA;EACE,8BAA8B;EAC9B,oGAAoG;AACtG;AACA;EACE,8BAA8B;EAC9B,mGAAmG;AACrG;AACA;EACE,8BAA8B;EAC9B,mGAAmG;AACrG;AACA;EACE,8BAA8B;EAC9B,kGAAkG;AACpG;AACA;EACE,8BAA8B;EAC9B,kGAAkG;AACpG;AACA;EACE,8BAA8B;EAC9B,kGAAkG;AACpG;AACA;EACE,8BAA8B;EAC9B,oGAAoG;AACtG;AACA;EACE,8BAA8B;EAC9B,oGAAoG;AACtG;AACA;EACE,8BAA8B;EAC9B,oGAAoG;AACtG;AACA;EACE,8BAA8B;EAC9B,oGAAoG;AACtG;AACA;EACE,8BAA8B;EAC9B,oGAAoG;AACtG;AACA;EACE,8BAA8B;EAC9B,oGAAoG;AACtG;AACA;EACE,8BAA8B;EAC9B,kGAAkG;AACpG;AACA;EACE,8BAA8B;EAC9B,iGAAiG;AACnG;AACA;EACE,8BAA8B;EAC9B,iGAAiG;AACnG;AACA;EACE,8BAA8B;EAC9B,iGAAiG;AACnG;AACA;EACE,kCAAkC;EAClC,+HAA+H;AACjI;AACA;EACE,iCAAiC;EACjC,yHAAyH;AAC3H;AACA;EACE,6BAA6B;EAC7B,+HAA+H;AACjI;AACA;EACE,6BAA6B;EAC7B,yHAAyH;AAC3H;AACA;EACE,6BAA6B;EAC7B,+HAA+H;AACjI;AACA;EACE,6BAA6B;EAC7B,+HAA+H;AACjI;AACA;EACE,6BAA6B;EAC7B,+HAA+H;AACjI;AACA;EACE,6BAA6B;EAC7B,+HAA+H;AACjI;AACA;EACE,6BAA6B;EAC7B,+HAA+H;AACjI;AACA;EACE,6BAA6B;EAC7B,+HAA+H;AACjI;AACA;EACE,6BAA6B;EAC7B,4HAA4H;AAC9H;AACA;EACE,6BAA6B;EAC7B,4HAA4H;AAC9H;AACA;EACE,6BAA6B;EAC7B,4HAA4H;AAC9H;AACA;EACE,6BAA6B;EAC7B,4HAA4H;AAC9H;AACA;EACE,6BAA6B;EAC7B,+HAA+H;AACjI;AACA;EACE,6BAA6B;EAC7B,+HAA+H;AACjI;AACA;EACE,6BAA6B;EAC7B,+HAA+H;AACjI;AACA;EACE,6BAA6B;EAC7B,+HAA+H;AACjI;AACA;EACE,6BAA6B;EAC7B,+HAA+H;AACjI;AACA;EACE,6BAA6B;EAC7B,6HAA6H;AAC/H;AACA;EACE,6BAA6B;EAC7B,6HAA6H;AAC/H;AACA;EACE,6BAA6B;EAC7B,6HAA6H;AAC/H;AACA;EACE,6BAA6B;EAC7B,6HAA6H;AAC/H;AACA;EACE,6BAA6B;EAC7B,6HAA6H;AAC/H;AACA;EACE,6BAA6B;EAC7B,+HAA+H;AACjI;AACA;EACE,6BAA6B;EAC7B,+HAA+H;AACjI;AACA;EACE,6BAA6B;EAC7B,+HAA+H;AACjI;AACA;EACE,6BAA6B;EAC7B,+HAA+H;AACjI;AACA;EACE,6BAA6B;EAC7B,8HAA8H;AAChI;AACA;EACE,6BAA6B;EAC7B,6HAA6H;AAC/H;AACA;EACE,6BAA6B;EAC7B,4HAA4H;AAC9H;AACA;EACE,6BAA6B;EAC7B,4HAA4H;AAC9H;AACA;EACE,6BAA6B;EAC7B,6HAA6H;AAC/H;AACA;EACE,6BAA6B;EAC7B,6HAA6H;AAC/H;AACA;EACE,6BAA6B;EAC7B,+HAA+H;AACjI;AACA;EACE,6BAA6B;EAC7B,+HAA+H;AACjI;AACA;EACE,6BAA6B;EAC7B,+HAA+H;AACjI;AACA;EACE,6BAA6B;EAC7B,8HAA8H;AAChI;AACA;EACE,6BAA6B;EAC7B,6HAA6H;AAC/H;AACA;EACE,6BAA6B;EAC7B,6HAA6H;AAC/H;AACA;EACE,6BAA6B;EAC7B,6HAA6H;AAC/H;AACA;EACE,6BAA6B;EAC7B,6HAA6H;AAC/H;AACA;EACE,6BAA6B;EAC7B,6HAA6H;AAC/H;AACA;EACE,6BAA6B;EAC7B,4HAA4H;AAC9H;AACA;EACE,6BAA6B;EAC7B,+HAA+H;AACjI;AACA;EACE,6BAA6B;EAC7B,+HAA+H;AACjI;AACA;EACE,6BAA6B;EAC7B,+HAA+H;AACjI;AACA;EACE,6BAA6B;EAC7B,+HAA+H;AACjI;AACA;EACE,6BAA6B;EAC7B,8HAA8H;AAChI;AACA;EACE,6BAA6B;EAC7B,8HAA8H;AAChI;AACA;EACE,6BAA6B;EAC7B,4HAA4H;AAC9H;AACA;EACE,6BAA6B;EAC7B,4HAA4H;AAC9H;AACA;EACE,6BAA6B;EAC7B,2HAA2H;AAC7H;AACA;EACE,6BAA6B;EAC7B,2HAA2H;AAC7H;AACA;EACE,6BAA6B;EAC7B,+HAA+H;AACjI;AACA;EACE,6BAA6B;EAC7B,+HAA+H;AACjI;AACA;EACE,6BAA6B;EAC7B,+HAA+H;AACjI;AACA;EACE,6BAA6B;EAC7B,+HAA+H;AACjI;AACA;EACE,6BAA6B;EAC7B,8HAA8H;AAChI;AACA;EACE,6BAA6B;EAC7B,6HAA6H;AAC/H;AACA;EACE,6BAA6B;EAC7B,6HAA6H;AAC/H;AACA;EACE,6BAA6B;EAC7B,6HAA6H;AAC/H;AACA;EACE,6BAA6B;EAC7B,2HAA2H;AAC7H;AACA;EACE,6BAA6B;EAC7B,2HAA2H;AAC7H;AACA;EACE,6BAA6B;EAC7B,+HAA+H;AACjI;AACA;EACE,6BAA6B;EAC7B,+HAA+H;AACjI;AACA;EACE,6BAA6B;EAC7B,+HAA+H;AACjI;AACA;EACE,6BAA6B;EAC7B,+HAA+H;AACjI;AACA;EACE,6BAA6B;EAC7B,+HAA+H;AACjI;AACA;EACE,6BAA6B;EAC7B,8HAA8H;AAChI;AACA;EACE,6BAA6B;EAC7B,8HAA8H;AAChI;AACA;EACE,6BAA6B;EAC7B,6HAA6H;AAC/H;AACA;EACE,6BAA6B;EAC7B,6HAA6H;AAC/H;AACA;EACE,6BAA6B;EAC7B,6HAA6H;AAC/H;AACA;EACE,6BAA6B;EAC7B,+HAA+H;AACjI;AACA;EACE,6BAA6B;EAC7B,+HAA+H;AACjI;AACA;EACE,6BAA6B;EAC7B,+HAA+H;AACjI;AACA;EACE,6BAA6B;EAC7B,+HAA+H;AACjI;AACA;EACE,6BAA6B;EAC7B,+HAA+H;AACjI;AACA;EACE,6BAA6B;EAC7B,+HAA+H;AACjI;AACA;EACE,6BAA6B;EAC7B,6HAA6H;AAC/H;AACA;EACE,6BAA6B;EAC7B,6HAA6H;AAC/H;AACA;EACE,6BAA6B;EAC7B,6HAA6H;AAC/H;AACA;EACE,6BAA6B;EAC7B,6HAA6H;AAC/H;AACA;EACE,6BAA6B;EAC7B,+HAA+H;AACjI;AACA;EACE,6BAA6B;EAC7B,+HAA+H;AACjI;AACA;EACE,6BAA6B;EAC7B,+HAA+H;AACjI;AACA;EACE,6BAA6B;EAC7B,+HAA+H;AACjI;AACA;EACE,6BAA6B;EAC7B,+HAA+H;AACjI;AACA;EACE,6BAA6B;EAC7B,8HAA8H;AAChI;AACA;EACE,6BAA6B;EAC7B,8HAA8H;AAChI;AACA;EACE,6BAA6B;EAC7B,8HAA8H;AAChI;AACA;EACE,6BAA6B;EAC7B,6HAA6H;AAC/H;AACA;EACE,6BAA6B;EAC7B,6HAA6H;AAC/H;AACA;EACE,6BAA6B;EAC7B,+HAA+H;AACjI;AACA;EACE,6BAA6B;EAC7B,+HAA+H;AACjI;AACA;EACE,6BAA6B;EAC7B,+HAA+H;AACjI;AACA;EACE,6BAA6B;EAC7B,+HAA+H;AACjI;AACA;EACE,6BAA6B;EAC7B,+HAA+H;AACjI;AACA;EACE,6BAA6B;EAC7B,8HAA8H;AAChI;AACA;EACE,6BAA6B;EAC7B,8HAA8H;AAChI;AACA;EACE,6BAA6B;EAC7B,6HAA6H;AAC/H;AACA;EACE,6BAA6B;EAC7B,6HAA6H;AAC/H;AACA;EACE,6BAA6B;EAC7B,6HAA6H;AAC/H;AACA;EACE,6BAA6B;EAC7B,+HAA+H;AACjI;AACA;EACE,6BAA6B;EAC7B,+HAA+H;AACjI;AACA;EACE,6BAA6B;EAC7B,+HAA+H;AACjI;AACA;EACE,6BAA6B;EAC7B,+HAA+H;AACjI;AACA;EACE,6BAA6B;EAC7B,+HAA+H;AACjI;AACA;EACE,6BAA6B;EAC7B,+HAA+H;AACjI;AACA;EACE,6BAA6B;EAC7B,6HAA6H;AAC/H;AACA;EACE,6BAA6B;EAC7B,4HAA4H;AAC9H;AACA;EACE,6BAA6B;EAC7B,4HAA4H;AAC9H;AACA;EACE,6BAA6B;EAC7B,4HAA4H;AAC9H;AACA;EACE,iCAAiC;AACnC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,gCAAgC;AAClC;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,iCAAiC;AACnC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,qBAAqB;AACvB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,kDAAkD;AACpD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,qDAAqD;AACvD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,qDAAqD;AACvD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,qDAAqD;AACvD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,qDAAqD;AACvD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,uDAAuD;AACzD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,qDAAqD;AACvD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,qDAAqD;AACvD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,uDAAuD;AACzD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,qDAAqD;AACvD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,uDAAuD;AACzD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,uDAAuD;AACzD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,qDAAqD;AACvD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,qDAAqD;AACvD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,oDAAoD;AACtD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,oDAAoD;AACtD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,uDAAuD;AACzD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,oDAAoD;AACtD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,oDAAoD;AACtD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,uDAAuD;AACzD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,uDAAuD;AACzD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,uDAAuD;AACzD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,uDAAuD;AACzD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,uDAAuD;AACzD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,uDAAuD;AACzD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,uDAAuD;AACzD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,qDAAqD;AACvD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,qDAAqD;AACvD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,qDAAqD;AACvD;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,kDAAkD;AACpD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,qDAAqD;AACvD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,qDAAqD;AACvD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,qDAAqD;AACvD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,qDAAqD;AACvD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,uDAAuD;AACzD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,qDAAqD;AACvD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,qDAAqD;AACvD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,uDAAuD;AACzD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,qDAAqD;AACvD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,uDAAuD;AACzD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,uDAAuD;AACzD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,qDAAqD;AACvD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,qDAAqD;AACvD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,oDAAoD;AACtD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,oDAAoD;AACtD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,uDAAuD;AACzD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,oDAAoD;AACtD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,oDAAoD;AACtD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,uDAAuD;AACzD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,uDAAuD;AACzD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,uDAAuD;AACzD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,uDAAuD;AACzD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,uDAAuD;AACzD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,uDAAuD;AACzD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,uDAAuD;AACzD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,qDAAqD;AACvD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,qDAAqD;AACvD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,qDAAqD;AACvD;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,kDAAkD;AACpD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,qDAAqD;AACvD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,qDAAqD;AACvD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,qDAAqD;AACvD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,qDAAqD;AACvD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,uDAAuD;AACzD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,qDAAqD;AACvD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,qDAAqD;AACvD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,uDAAuD;AACzD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,qDAAqD;AACvD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,uDAAuD;AACzD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,uDAAuD;AACzD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,qDAAqD;AACvD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,qDAAqD;AACvD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,oDAAoD;AACtD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,oDAAoD;AACtD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,uDAAuD;AACzD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,oDAAoD;AACtD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,oDAAoD;AACtD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,uDAAuD;AACzD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,uDAAuD;AACzD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,uDAAuD;AACzD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,uDAAuD;AACzD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,uDAAuD;AACzD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,uDAAuD;AACzD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,uDAAuD;AACzD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,qDAAqD;AACvD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,qDAAqD;AACvD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,qDAAqD;AACvD;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,kDAAkD;AACpD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,qDAAqD;AACvD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,qDAAqD;AACvD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,qDAAqD;AACvD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,qDAAqD;AACvD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,uDAAuD;AACzD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,qDAAqD;AACvD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,qDAAqD;AACvD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,uDAAuD;AACzD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,qDAAqD;AACvD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,uDAAuD;AACzD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,uDAAuD;AACzD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,qDAAqD;AACvD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,qDAAqD;AACvD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,oDAAoD;AACtD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,oDAAoD;AACtD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,uDAAuD;AACzD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,oDAAoD;AACtD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,oDAAoD;AACtD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,uDAAuD;AACzD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,uDAAuD;AACzD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,uDAAuD;AACzD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,uDAAuD;AACzD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,uDAAuD;AACzD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,uDAAuD;AACzD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,uDAAuD;AACzD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,qDAAqD;AACvD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,qDAAqD;AACvD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,qDAAqD;AACvD;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,kDAAkD;AACpD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,qDAAqD;AACvD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,qDAAqD;AACvD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,qDAAqD;AACvD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,qDAAqD;AACvD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,uDAAuD;AACzD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,qDAAqD;AACvD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,qDAAqD;AACvD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,uDAAuD;AACzD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,qDAAqD;AACvD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,uDAAuD;AACzD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,uDAAuD;AACzD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,qDAAqD;AACvD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,qDAAqD;AACvD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,oDAAoD;AACtD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,oDAAoD;AACtD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,uDAAuD;AACzD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,oDAAoD;AACtD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,oDAAoD;AACtD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,uDAAuD;AACzD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,uDAAuD;AACzD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,uDAAuD;AACzD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,uDAAuD;AACzD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,uDAAuD;AACzD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,uDAAuD;AACzD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,uDAAuD;AACzD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,qDAAqD;AACvD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,qDAAqD;AACvD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,qDAAqD;AACvD;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,kDAAkD;AACpD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,qDAAqD;AACvD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,qDAAqD;AACvD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,qDAAqD;AACvD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,qDAAqD;AACvD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,uDAAuD;AACzD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,qDAAqD;AACvD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,qDAAqD;AACvD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,uDAAuD;AACzD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,qDAAqD;AACvD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,uDAAuD;AACzD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,uDAAuD;AACzD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,qDAAqD;AACvD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,qDAAqD;AACvD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,oDAAoD;AACtD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,oDAAoD;AACtD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,uDAAuD;AACzD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,oDAAoD;AACtD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,oDAAoD;AACtD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,uDAAuD;AACzD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,uDAAuD;AACzD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,uDAAuD;AACzD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,uDAAuD;AACzD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,uDAAuD;AACzD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,uDAAuD;AACzD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,uDAAuD;AACzD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,qDAAqD;AACvD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,qDAAqD;AACvD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,qDAAqD;AACvD;AACA;EACE,mBAAmB;AACrB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;AACA;EACE,0BAA0B;EAC1B,6BAA6B;AAC/B;AACA;EACE,6BAA6B;EAC7B,4BAA4B;AAC9B;AACA;EACE,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;EACE,gCAAgC;EAChC,iCAAiC;AACnC;AACA;EACE,iCAAiC;EACjC,oCAAoC;AACtC;AACA;EACE,oCAAoC;EACpC,mCAAmC;AACrC;AACA;EACE,gCAAgC;EAChC,mCAAmC;AACrC;AACA;EACE,+BAA+B;EAC/B,gCAAgC;AAClC;AACA;EACE,gCAAgC;EAChC,mCAAmC;AACrC;AACA;EACE,mCAAmC;EACnC,kCAAkC;AACpC;AACA;EACE,+BAA+B;EAC/B,kCAAkC;AACpC;AACA;EACE,gCAAgC;EAChC,iCAAiC;AACnC;AACA;EACE,iCAAiC;EACjC,oCAAoC;AACtC;AACA;EACE,oCAAoC;EACpC,mCAAmC;AACrC;AACA;EACE,gCAAgC;EAChC,mCAAmC;AACrC;AACA;EACE,8BAA8B;EAC9B,+BAA+B;AACjC;AACA;EACE,+BAA+B;EAC/B,kCAAkC;AACpC;AACA;EACE,kCAAkC;EAClC,iCAAiC;AACnC;AACA;EACE,8BAA8B;EAC9B,iCAAiC;AACnC;AACA;EACE,+BAA+B;EAC/B,gCAAgC;AAClC;AACA;EACE,gCAAgC;EAChC,mCAAmC;AACrC;AACA;EACE,mCAAmC;EACnC,kCAAkC;AACpC;AACA;EACE,+BAA+B;EAC/B,kCAAkC;AACpC;AACA;EACE,4BAA4B;EAC5B,6BAA6B;AAC/B;AACA;EACE,6BAA6B;EAC7B,gCAAgC;AAClC;AACA;EACE,gCAAgC;EAChC,+BAA+B;AACjC;AACA;EACE,4BAA4B;EAC5B,+BAA+B;AACjC;AACA;EACE,8BAA8B;EAC9B,+BAA+B;AACjC;AACA;EACE,+BAA+B;EAC/B,kCAAkC;AACpC;AACA;EACE,kCAAkC;EAClC,iCAAiC;AACnC;AACA;EACE,8BAA8B;EAC9B,iCAAiC;AACnC;AACA;EACE,8BAA8B;EAC9B,+BAA+B;AACjC;AACA;EACE,+BAA+B;EAC/B,kCAAkC;AACpC;AACA;EACE,kCAAkC;EAClC,iCAAiC;AACnC;AACA;EACE,8BAA8B;EAC9B,iCAAiC;AACnC;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,gCAAgC;AAClC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,kCAAkC;AACpC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,kCAAkC;AACpC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,kCAAkC;AACpC;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,gCAAgC;AAClC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,kCAAkC;AACpC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,kCAAkC;AACpC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,mBAAmB;AACrB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,sBAAsB;AACxB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,sBAAsB;AACxB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,sBAAsB;AACxB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,YAAY;AACd;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;AACf;AACA;EACE,oBAAoB;AACtB;AACA;EACE,cAAc;AAChB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;AACf;AACA;EACE,oBAAoB;AACtB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,aAAa;AACf;AACA;EACE,mBAAmB;AACrB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,sBAAsB;AACxB;AACA;EACE,8BAA8B;AAChC;AACA;EACE,eAAe;AACjB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,sBAAsB;AACxB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,8BAA8B;AAChC;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,SAAY;AACd;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,UAAU;AACZ;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,QAAQ;AACV;AACA;EACE,QAAQ;AACV;AACA;EACE,QAAQ;AACV;AACA;EACE,QAAQ;AACV;AACA;EACE,QAAQ;AACV;AACA;EACE,QAAQ;AACV;AACA;EACE,QAAQ;AACV;AACA;EACE,QAAQ;AACV;AACA;EACE,QAAQ;AACV;AACA;EACE,SAAS;AACX;AACA;EACE,SAAS;AACX;AACA;EACE,SAAS;AACX;AACA;EACE,YAAY;AACd;AACA;EACE,WAAW;AACb;AACA;EACE,QAAQ;AACV;AACA;EACE,YAAY;AACd;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;EACX,cAAc;EACd,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,YAAY;AACd;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,6MAA6M;AAC/M;AACA;EACE,8DAA8D;AAChE;AACA;EACE,iFAAiF;AACnF;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,SAAS;AACX;AACA;EACE,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;AACjB;AACA;EACE,YAAY;AACd;AACA;EACE,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;AACjB;AACA;EACE,YAAY;AACd;AACA;EACE,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;AACjB;AACA;EACE,YAAY;AACd;AACA;EACE,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;AACjB;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,YAAY;AACd;AACA;EACE,WAAW;AACb;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;AACb;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;AACb;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;AACb;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;AACb;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;AACb;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,YAAY;AACd;AACA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,cAAc;AAChB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,SAAS;AACX;AACA;EACE,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;AACjB;AACA;EACE,YAAY;AACd;AACA;EACE,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;AACjB;AACA;EACE,YAAY;AACd;AACA;EACE,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;AACjB;AACA;EACE,YAAY;AACd;AACA;EACE,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;AACjB;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,YAAY;AACd;AACA;EACE,WAAW;AACb;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;AACb;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;AACb;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;AACb;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;AACb;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;AACb;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,YAAY;AACd;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,YAAY;AACd;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,YAAY;AACd;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,YAAY;AACd;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,YAAY;AACd;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,YAAY;AACd;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE,oBAAoB;EACpB,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;AACA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE,oBAAoB;EACpB,qBAAqB;AACvB;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE,oBAAoB;EACpB,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;AACA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE,oBAAoB;EACpB,qBAAqB;AACvB;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE,oBAAoB;EACpB,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;AACA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE,oBAAoB;EACpB,qBAAqB;AACvB;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE,oBAAoB;EACpB,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;AACA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE,oBAAoB;EACpB,qBAAqB;AACvB;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,oBAAoB;EACpB,uBAAuB;AACzB;AACA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;AACA;EACE,oBAAoB;EACpB,uBAAuB;AACzB;AACA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;AACA;EACE,oBAAoB;EACpB,uBAAuB;AACzB;AACA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;AACA;EACE,oBAAoB;EACpB,uBAAuB;AACzB;AACA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,sBAAsB;EACtB,yBAAyB;AAC3B;AACA;EACE,uBAAuB;EACvB,wBAAwB;AAC1B;AACA;EACE,sBAAsB;EACtB,yBAAyB;AAC3B;AACA;EACE,uBAAuB;EACvB,wBAAwB;AAC1B;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,sBAAsB;EACtB,yBAAyB;AAC3B;AACA;EACE,uBAAuB;EACvB,wBAAwB;AAC1B;AACA;EACE,sBAAsB;EACtB,yBAAyB;AAC3B;AACA;EACE,uBAAuB;EACvB,wBAAwB;AAC1B;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,sBAAsB;EACtB,yBAAyB;AAC3B;AACA;EACE,uBAAuB;EACvB,wBAAwB;AAC1B;AACA;EACE,sBAAsB;EACtB,yBAAyB;AAC3B;AACA;EACE,uBAAuB;EACvB,wBAAwB;AAC1B;AACA;EACE,qBAAqB;EACrB,wBAAwB;AAC1B;AACA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE,sBAAsB;EACtB,yBAAyB;AAC3B;AACA;EACE,uBAAuB;EACvB,wBAAwB;AAC1B;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,sBAAsB;EACtB,yBAAyB;AAC3B;AACA;EACE,uBAAuB;EACvB,wBAAwB;AAC1B;AACA;EACE,sBAAsB;EACtB,yBAAyB;AAC3B;AACA;EACE,uBAAuB;EACvB,wBAAwB;AAC1B;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,sBAAsB;EACtB,yBAAyB;AAC3B;AACA;EACE,uBAAuB;EACvB,wBAAwB;AAC1B;AACA;EACE,sBAAsB;EACtB,yBAAyB;AAC3B;AACA;EACE,uBAAuB;EACvB,wBAAwB;AAC1B;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,sBAAsB;EACtB,yBAAyB;AAC3B;AACA;EACE,uBAAuB;EACvB,wBAAwB;AAC1B;AACA;EACE,sBAAsB;EACtB,yBAAyB;AAC3B;AACA;EACE,uBAAuB;EACvB,wBAAwB;AAC1B;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,oBAAoB;EACpB,uBAAuB;AACzB;AACA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;AACA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE,oBAAoB;EACpB,qBAAqB;AACvB;AACA;EACE,oBAAoB;EACpB,uBAAuB;AACzB;AACA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;AACA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,oBAAoB;EACpB,uBAAuB;AACzB;AACA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;AACA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE,oBAAoB;EACpB,qBAAqB;AACvB;AACA;EACE,oBAAoB;EACpB,uBAAuB;AACzB;AACA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;AACA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,oBAAoB;EACpB,uBAAuB;AACzB;AACA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;AACA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE,oBAAoB;EACpB,qBAAqB;AACvB;AACA;EACE,oBAAoB;EACpB,uBAAuB;AACzB;AACA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;AACA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,oBAAoB;EACpB,uBAAuB;AACzB;AACA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;AACA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE,oBAAoB;EACpB,qBAAqB;AACvB;AACA;EACE,oBAAoB;EACpB,uBAAuB;AACzB;AACA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;AACA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;AACA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;AACA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;AACA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;AACA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;AACA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;AACA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;AACA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;AACA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;AACA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;AACA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,wBAAwB;AAC1B;AACA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE,qBAAqB;EACrB,wBAAwB;AAC1B;AACA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE,qBAAqB;EACrB,wBAAwB;AAC1B;AACA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE,qBAAqB;EACrB,wBAAwB;AAC1B;AACA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,sBAAsB;EACtB,yBAAyB;AAC3B;AACA;EACE,uBAAuB;EACvB,wBAAwB;AAC1B;AACA;EACE,sBAAsB;EACtB,yBAAyB;AAC3B;AACA;EACE,uBAAuB;EACvB,wBAAwB;AAC1B;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,sBAAsB;EACtB,yBAAyB;AAC3B;AACA;EACE,uBAAuB;EACvB,wBAAwB;AAC1B;AACA;EACE,sBAAsB;EACtB,yBAAyB;AAC3B;AACA;EACE,uBAAuB;EACvB,wBAAwB;AAC1B;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,sBAAsB;EACtB,yBAAyB;AAC3B;AACA;EACE,uBAAuB;EACvB,wBAAwB;AAC1B;AACA;EACE,sBAAsB;EACtB,yBAAyB;AAC3B;AACA;EACE,uBAAuB;EACvB,wBAAwB;AAC1B;AACA;EACE,qBAAqB;EACrB,wBAAwB;AAC1B;AACA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE,sBAAsB;EACtB,yBAAyB;AAC3B;AACA;EACE,uBAAuB;EACvB,wBAAwB;AAC1B;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,sBAAsB;EACtB,yBAAyB;AAC3B;AACA;EACE,uBAAuB;EACvB,wBAAwB;AAC1B;AACA;EACE,sBAAsB;EACtB,yBAAyB;AAC3B;AACA;EACE,uBAAuB;EACvB,wBAAwB;AAC1B;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,sBAAsB;EACtB,yBAAyB;AAC3B;AACA;EACE,uBAAuB;EACvB,wBAAwB;AAC1B;AACA;EACE,sBAAsB;EACtB,yBAAyB;AAC3B;AACA;EACE,uBAAuB;EACvB,wBAAwB;AAC1B;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,sBAAsB;EACtB,yBAAyB;AAC3B;AACA;EACE,uBAAuB;EACvB,wBAAwB;AAC1B;AACA;EACE,sBAAsB;EACtB,yBAAyB;AAC3B;AACA;EACE,uBAAuB;EACvB,wBAAwB;AAC1B;AACA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,aAAa;AACf;AACA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,eAAe;AACjB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,eAAe;AACjB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,eAAe;AACjB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,eAAe;AACjB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,eAAe;AACjB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,eAAe;AACjB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,eAAe;AACjB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,sBAAsB;AACxB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,sBAAsB;AACxB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,sBAAsB;AACxB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,sBAAsB;AACxB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;AACf;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,eAAe;AACjB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,eAAe;AACjB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,eAAe;AACjB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,eAAe;AACjB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,eAAe;AACjB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,eAAe;AACjB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;EAEE,sBAAsB;AACxB;AACA;EAEE,sBAAsB;AACxB;AACA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,aAAa;AACf;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,YAAY;AACd;AACA;EACE,eAAe;AACjB;AACA;EAEE,sBAAsB;AACxB;AACA;EAEE,sBAAsB;AACxB;AACA;EAEE,mBAAmB;AACrB;AACA;EAEE,iBAAiB;AACnB;AACA;EAEE,gBAAgB;AAClB;AACA;EAEE,gBAAgB;AAClB;AACA;EAEE,sBAAsB;AACxB;AACA;EAEE,uBAAuB;AACzB;AACA;EAEE,uBAAuB;AACzB;AACA;EAEE,qBAAqB;AACvB;AACA;EAEE,4BAA4B;AAC9B;AACA;EAEE,yBAAyB;AAC3B;AACA;EAEE,sBAAsB;AACxB;AACA;EAEE,6BAA6B;AAC/B;AACA;EAEE,0BAA0B;AAC5B;AACA;EAEE,oBAAoB;AACtB;AACA;EACE,UAAU;AACZ;AACA;EACE,aAAa;AACf;AACA;EACE,YAAY;AACd;AACA;EACE,aAAa;AACf;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,aAAa;AACf;AACA;EACE,YAAY;AACd;AACA;EACE,aAAa;AACf;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,aAAa;AACf;AACA;EACE,YAAY;AACd;AACA;EACE,aAAa;AACf;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,aAAa;AACf;AACA;EACE,YAAY;AACd;AACA;EACE,aAAa;AACf;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,aAAa;AACf;AACA;EACE,YAAY;AACd;AACA;EACE,aAAa;AACf;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,aAAa;AACf;AACA;EACE,YAAY;AACd;AACA;EACE,aAAa;AACf;AACA;EACE,UAAU;AACZ;AACA;EACE,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,iCAAiC;AACnC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,8BAA8B;AAChC;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,8BAA8B;AAChC;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,UAAU;AACZ;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,YAAY;AACd;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,YAAY;AACd;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,YAAY;AACd;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,YAAY;AACd;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,YAAY;AACd;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,YAAY;AACd;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;AACf;AACA;EACE,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,oBAAoB;EACpB,uBAAuB;AACzB;AACA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;AACA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE,oBAAoB;EACpB,qBAAqB;AACvB;AACA;EACE,oBAAoB;EACpB,uBAAuB;AACzB;AACA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;AACA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,oBAAoB;EACpB,uBAAuB;AACzB;AACA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;AACA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE,oBAAoB;EACpB,qBAAqB;AACvB;AACA;EACE,oBAAoB;EACpB,uBAAuB;AACzB;AACA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;AACA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,oBAAoB;EACpB,uBAAuB;AACzB;AACA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;AACA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE,oBAAoB;EACpB,qBAAqB;AACvB;AACA;EACE,oBAAoB;EACpB,uBAAuB;AACzB;AACA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;AACA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,oBAAoB;EACpB,uBAAuB;AACzB;AACA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;AACA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE,oBAAoB;EACpB,qBAAqB;AACvB;AACA;EACE,oBAAoB;EACpB,uBAAuB;AACzB;AACA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;AACA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;AACA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;AACA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;AACA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;AACA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;AACA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;AACA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;AACA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;AACA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;AACA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;AACA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,wBAAwB;AAC1B;AACA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE,qBAAqB;EACrB,wBAAwB;AAC1B;AACA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE,qBAAqB;EACrB,wBAAwB;AAC1B;AACA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE,qBAAqB;EACrB,wBAAwB;AAC1B;AACA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,uBAAuB;EACvB,0BAA0B;AAC5B;AACA;EACE,wBAAwB;EACxB,yBAAyB;AAC3B;AACA;EACE,uBAAuB;EACvB,0BAA0B;AAC5B;AACA;EACE,wBAAwB;EACxB,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,uBAAuB;EACvB,0BAA0B;AAC5B;AACA;EACE,wBAAwB;EACxB,yBAAyB;AAC3B;AACA;EACE,uBAAuB;EACvB,0BAA0B;AAC5B;AACA;EACE,wBAAwB;EACxB,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,uBAAuB;EACvB,0BAA0B;AAC5B;AACA;EACE,wBAAwB;EACxB,yBAAyB;AAC3B;AACA;EACE,uBAAuB;EACvB,0BAA0B;AAC5B;AACA;EACE,wBAAwB;EACxB,yBAAyB;AAC3B;AACA;EACE,sBAAsB;EACtB,yBAAyB;AAC3B;AACA;EACE,uBAAuB;EACvB,wBAAwB;AAC1B;AACA;EACE,uBAAuB;EACvB,0BAA0B;AAC5B;AACA;EACE,wBAAwB;EACxB,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,uBAAuB;EACvB,0BAA0B;AAC5B;AACA;EACE,wBAAwB;EACxB,yBAAyB;AAC3B;AACA;EACE,uBAAuB;EACvB,0BAA0B;AAC5B;AACA;EACE,wBAAwB;EACxB,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,uBAAuB;EACvB,0BAA0B;AAC5B;AACA;EACE,wBAAwB;EACxB,yBAAyB;AAC3B;AACA;EACE,uBAAuB;EACvB,0BAA0B;AAC5B;AACA;EACE,wBAAwB;EACxB,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,uBAAuB;EACvB,0BAA0B;AAC5B;AACA;EACE,wBAAwB;EACxB,yBAAyB;AAC3B;AACA;EACE,uBAAuB;EACvB,0BAA0B;AAC5B;AACA;EACE,wBAAwB;EACxB,yBAAyB;AAC3B;AACA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,eAAe;AACjB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,sBAAsB;AACxB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,sBAAsB;AACxB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,sBAAsB;AACxB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,sBAAsB;AACxB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,sBAAsB;AACxB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,iBAAiB;AACnB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,kBAAkB;AACpB;AAIA;EACE,mBAAmB;AACrB;AAIA;EACE,kBAAkB;AACpB;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,sDAAsD;AACxD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,gDAAgD;AAClD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,sDAAsD;AACxD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,sDAAsD;AACxD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,sDAAsD;AACxD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,sDAAsD;AACxD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,sDAAsD;AACxD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,sDAAsD;AACxD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,mDAAmD;AACrD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,mDAAmD;AACrD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,mDAAmD;AACrD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,mDAAmD;AACrD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,sDAAsD;AACxD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,sDAAsD;AACxD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,sDAAsD;AACxD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,sDAAsD;AACxD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,sDAAsD;AACxD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,oDAAoD;AACtD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,oDAAoD;AACtD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,oDAAoD;AACtD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,oDAAoD;AACtD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,oDAAoD;AACtD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,sDAAsD;AACxD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,sDAAsD;AACxD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,sDAAsD;AACxD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,sDAAsD;AACxD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,qDAAqD;AACvD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,oDAAoD;AACtD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,mDAAmD;AACrD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,mDAAmD;AACrD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,oDAAoD;AACtD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,oDAAoD;AACtD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,sDAAsD;AACxD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,sDAAsD;AACxD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,sDAAsD;AACxD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,qDAAqD;AACvD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,oDAAoD;AACtD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,oDAAoD;AACtD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,oDAAoD;AACtD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,oDAAoD;AACtD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,oDAAoD;AACtD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,mDAAmD;AACrD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,sDAAsD;AACxD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,sDAAsD;AACxD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,sDAAsD;AACxD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,sDAAsD;AACxD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,qDAAqD;AACvD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,qDAAqD;AACvD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,mDAAmD;AACrD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,mDAAmD;AACrD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,kDAAkD;AACpD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,kDAAkD;AACpD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,sDAAsD;AACxD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,sDAAsD;AACxD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,sDAAsD;AACxD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,sDAAsD;AACxD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,qDAAqD;AACvD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,oDAAoD;AACtD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,oDAAoD;AACtD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,oDAAoD;AACtD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,kDAAkD;AACpD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,kDAAkD;AACpD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,sDAAsD;AACxD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,sDAAsD;AACxD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,sDAAsD;AACxD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,sDAAsD;AACxD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,sDAAsD;AACxD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,qDAAqD;AACvD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,qDAAqD;AACvD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,oDAAoD;AACtD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,oDAAoD;AACtD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,oDAAoD;AACtD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,sDAAsD;AACxD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,sDAAsD;AACxD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,sDAAsD;AACxD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,sDAAsD;AACxD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,sDAAsD;AACxD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,sDAAsD;AACxD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,oDAAoD;AACtD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,oDAAoD;AACtD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,oDAAoD;AACtD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,oDAAoD;AACtD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,sDAAsD;AACxD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,sDAAsD;AACxD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,sDAAsD;AACxD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,sDAAsD;AACxD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,sDAAsD;AACxD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,qDAAqD;AACvD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,qDAAqD;AACvD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,qDAAqD;AACvD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,oDAAoD;AACtD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,oDAAoD;AACtD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,sDAAsD;AACxD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,sDAAsD;AACxD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,sDAAsD;AACxD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,sDAAsD;AACxD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,sDAAsD;AACxD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,qDAAqD;AACvD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,qDAAqD;AACvD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,oDAAoD;AACtD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,oDAAoD;AACtD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,oDAAoD;AACtD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,sDAAsD;AACxD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,sDAAsD;AACxD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,sDAAsD;AACxD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,sDAAsD;AACxD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,sDAAsD;AACxD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,sDAAsD;AACxD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,oDAAoD;AACtD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,mDAAmD;AACrD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,mDAAmD;AACrD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,mDAAmD;AACrD;AAIA;EACE,mBAAmB;AACrB;AAIA;EACE,kBAAkB;AACpB;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,sDAAsD;AACxD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,gDAAgD;AAClD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,sDAAsD;AACxD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,sDAAsD;AACxD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,sDAAsD;AACxD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,sDAAsD;AACxD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,sDAAsD;AACxD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,sDAAsD;AACxD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,mDAAmD;AACrD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,mDAAmD;AACrD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,mDAAmD;AACrD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,mDAAmD;AACrD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,sDAAsD;AACxD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,sDAAsD;AACxD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,sDAAsD;AACxD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,sDAAsD;AACxD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,sDAAsD;AACxD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,oDAAoD;AACtD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,oDAAoD;AACtD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,oDAAoD;AACtD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,oDAAoD;AACtD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,oDAAoD;AACtD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,sDAAsD;AACxD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,sDAAsD;AACxD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,sDAAsD;AACxD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,sDAAsD;AACxD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,qDAAqD;AACvD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,oDAAoD;AACtD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,mDAAmD;AACrD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,mDAAmD;AACrD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,oDAAoD;AACtD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,oDAAoD;AACtD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,sDAAsD;AACxD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,sDAAsD;AACxD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,sDAAsD;AACxD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,qDAAqD;AACvD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,oDAAoD;AACtD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,oDAAoD;AACtD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,oDAAoD;AACtD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,oDAAoD;AACtD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,oDAAoD;AACtD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,mDAAmD;AACrD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,sDAAsD;AACxD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,sDAAsD;AACxD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,sDAAsD;AACxD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,sDAAsD;AACxD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,qDAAqD;AACvD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,qDAAqD;AACvD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,mDAAmD;AACrD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,mDAAmD;AACrD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,kDAAkD;AACpD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,kDAAkD;AACpD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,sDAAsD;AACxD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,sDAAsD;AACxD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,sDAAsD;AACxD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,sDAAsD;AACxD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,qDAAqD;AACvD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,oDAAoD;AACtD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,oDAAoD;AACtD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,oDAAoD;AACtD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,kDAAkD;AACpD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,kDAAkD;AACpD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,sDAAsD;AACxD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,sDAAsD;AACxD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,sDAAsD;AACxD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,sDAAsD;AACxD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,sDAAsD;AACxD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,qDAAqD;AACvD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,qDAAqD;AACvD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,oDAAoD;AACtD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,oDAAoD;AACtD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,oDAAoD;AACtD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,sDAAsD;AACxD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,sDAAsD;AACxD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,sDAAsD;AACxD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,sDAAsD;AACxD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,sDAAsD;AACxD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,sDAAsD;AACxD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,oDAAoD;AACtD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,oDAAoD;AACtD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,oDAAoD;AACtD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,oDAAoD;AACtD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,sDAAsD;AACxD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,sDAAsD;AACxD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,sDAAsD;AACxD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,sDAAsD;AACxD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,sDAAsD;AACxD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,qDAAqD;AACvD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,qDAAqD;AACvD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,qDAAqD;AACvD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,oDAAoD;AACtD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,oDAAoD;AACtD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,sDAAsD;AACxD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,sDAAsD;AACxD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,sDAAsD;AACxD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,sDAAsD;AACxD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,sDAAsD;AACxD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,qDAAqD;AACvD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,qDAAqD;AACvD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,oDAAoD;AACtD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,oDAAoD;AACtD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,oDAAoD;AACtD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,sDAAsD;AACxD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,sDAAsD;AACxD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,sDAAsD;AACxD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,sDAAsD;AACxD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,sDAAsD;AACxD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,sDAAsD;AACxD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,oDAAoD;AACtD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,mDAAmD;AACrD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,mDAAmD;AACrD;AAMA;EACE,wBAAwB;EACxB,cAAc;EACd,mDAAmD;AACrD;AAIA;EACE,wBAAwB;AAC1B;AAIA;EACE,2BAA2B;AAC7B;AAIA;EACE,0BAA0B;AAC5B;AAIA;EACE,2BAA2B;AAC7B;AAIA;EACE,wBAAwB;AAC1B;AAIA;EACE,wBAAwB;AAC1B;AAIA;EACE,2BAA2B;AAC7B;AAIA;EACE,0BAA0B;AAC5B;AAIA;EACE,2BAA2B;AAC7B;AAIA;EACE,wBAAwB;AAC1B;AACA;EACE,oBAAoB;AACtB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;AACT;AACA;EACE,YAAY;EACZ,cAAc;EACd,eAAe;EACf,aAAa;AACf;AACA;EACE,WAAW;EACX,aAAa;EACb,cAAc;EACd,YAAY;AACd;AACA;EACE,YAAY;EACZ,cAAc;EACd,eAAe;EACf,aAAa;AACf;AACA;EACE,SAAS;EACT,WAAW;EACX,YAAY;EACZ,UAAU;AACZ;AACA;EACE,YAAY;EACZ,cAAc;EACd,eAAe;EACf,aAAa;AACf;AACA;EACE,WAAW;EACX,aAAa;EACb,cAAc;EACd,YAAY;AACd;AACA;EACE,YAAY;EACZ,cAAc;EACd,eAAe;EACf,aAAa;AACf;AACA;EACE,SAAS;EACT,WAAW;EACX,YAAY;EACZ,UAAU;AACZ;AACA;EACE,YAAY;EACZ,cAAc;EACd,eAAe;EACf,aAAa;AACf;AACA;EACE,WAAW;EACX,aAAa;EACb,cAAc;EACd,YAAY;AACd;AACA;EACE,YAAY;EACZ,cAAc;EACd,eAAe;EACf,aAAa;AACf;AACA;EACE,SAAS;EACT,WAAW;EACX,YAAY;EACZ,UAAU;AACZ;AACA;EACE,YAAY;EACZ,cAAc;EACd,eAAe;EACf,aAAa;AACf;AACA;EACE,WAAW;EACX,aAAa;EACb,cAAc;EACd,YAAY;AACd;AACA;EACE,YAAY;EACZ,cAAc;EACd,eAAe;EACf,aAAa;AACf;AACA;EACE,SAAS;EACT,WAAW;EACX,YAAY;EACZ,UAAU;AACZ;AACA;EACE,SAAS;EACT,WAAW;EACX,YAAY;EACZ,UAAU;AACZ;AACA;EACE,SAAS;EACT,WAAW;EACX,YAAY;EACZ,UAAU;AACZ;AACA;EACE,SAAS;EACT,WAAW;EACX,YAAY;EACZ,UAAU;AACZ;AACA;EACE,SAAS;EACT,WAAW;EACX,YAAY;EACZ,UAAU;AACZ;AACA;EACE,SAAS;EACT,WAAW;EACX,YAAY;EACZ,UAAU;AACZ;AACA;EACE,UAAU;EACV,YAAY;EACZ,aAAa;EACb,WAAW;AACb;AACA;EACE,UAAU;EACV,YAAY;EACZ,aAAa;EACb,WAAW;AACb;AACA;EACE,UAAU;EACV,YAAY;EACZ,aAAa;EACb,WAAW;AACb;AACA;EACE,UAAU;EACV,YAAY;EACZ,aAAa;EACb,WAAW;AACb;AACA;EACE,UAAU;EACV,YAAY;EACZ,aAAa;EACb,WAAW;AACb;AACA;EACE,UAAU;EACV,YAAY;EACZ,aAAa;EACb,WAAW;AACb;AACA;EACE,UAAU;EACV,YAAY;EACZ,aAAa;EACb,WAAW;AACb;AACA;EACE,UAAU;EACV,YAAY;EACZ,aAAa;EACb,WAAW;AACb;AACA;EACE,UAAU;EACV,YAAY;EACZ,aAAa;EACb,WAAW;AACb;AACA;EACE,UAAU;EACV,YAAY;EACZ,aAAa;EACb,WAAW;AACb;AACA;EACE,SAAS;EACT,WAAW;EACX,YAAY;EACZ,UAAU;AACZ;AACA;EACE,QAAQ;EACR,UAAU;EACV,WAAW;EACX,SAAS;AACX;AACA;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,QAAQ;EACR,UAAU;EACV,WAAW;EACX,SAAS;AACX;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,QAAQ;EACR,UAAU;EACV,WAAW;EACX,SAAS;AACX;AACA;EACE,QAAQ;EACR,UAAU;EACV,WAAW;EACX,SAAS;AACX;AACA;EACE,QAAQ;EACR,UAAU;EACV,WAAW;EACX,SAAS;AACX;AACA;EACE,QAAQ;EACR,UAAU;EACV,WAAW;EACX,SAAS;AACX;AACA;EACE,QAAQ;EACR,UAAU;EACV,WAAW;EACX,SAAS;AACX;AACA;EACE,QAAQ;EACR,UAAU;EACV,WAAW;EACX,SAAS;AACX;AACA;EACE,QAAQ;EACR,UAAU;EACV,WAAW;EACX,SAAS;AACX;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,QAAQ;EACR,UAAU;EACV,WAAW;EACX,SAAS;AACX;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,QAAQ;EACR,UAAU;EACV,WAAW;EACX,SAAS;AACX;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,QAAQ;EACR,UAAU;EACV,WAAW;EACX,SAAS;AACX;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,QAAQ;EACR,UAAU;EACV,WAAW;EACX,SAAS;AACX;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,SAAS;EACT,WAAW;EACX,YAAY;EACZ,UAAU;AACZ;AACA;EACE,MAAM;EACN,SAAS;AACX;AACA;EACE,QAAQ;EACR,OAAO;AACT;AACA;EACE,YAAY;EACZ,eAAe;AACjB;AACA;EACE,cAAc;EACd,aAAa;AACf;AACA;EACE,WAAW;EACX,cAAc;AAChB;AACA;EACE,aAAa;EACb,YAAY;AACd;AACA;EACE,YAAY;EACZ,eAAe;AACjB;AACA;EACE,cAAc;EACd,aAAa;AACf;AACA;EACE,SAAS;EACT,YAAY;AACd;AACA;EACE,WAAW;EACX,UAAU;AACZ;AACA;EACE,YAAY;EACZ,eAAe;AACjB;AACA;EACE,cAAc;EACd,aAAa;AACf;AACA;EACE,WAAW;EACX,cAAc;AAChB;AACA;EACE,aAAa;EACb,YAAY;AACd;AACA;EACE,YAAY;EACZ,eAAe;AACjB;AACA;EACE,cAAc;EACd,aAAa;AACf;AACA;EACE,SAAS;EACT,YAAY;AACd;AACA;EACE,WAAW;EACX,UAAU;AACZ;AACA;EACE,YAAY;EACZ,eAAe;AACjB;AACA;EACE,cAAc;EACd,aAAa;AACf;AACA;EACE,WAAW;EACX,cAAc;AAChB;AACA;EACE,aAAa;EACb,YAAY;AACd;AACA;EACE,YAAY;EACZ,eAAe;AACjB;AACA;EACE,cAAc;EACd,aAAa;AACf;AACA;EACE,SAAS;EACT,YAAY;AACd;AACA;EACE,WAAW;EACX,UAAU;AACZ;AACA;EACE,YAAY;EACZ,eAAe;AACjB;AACA;EACE,cAAc;EACd,aAAa;AACf;AACA;EACE,WAAW;EACX,cAAc;AAChB;AACA;EACE,aAAa;EACb,YAAY;AACd;AACA;EACE,YAAY;EACZ,eAAe;AACjB;AACA;EACE,cAAc;EACd,aAAa;AACf;AACA;EACE,SAAS;EACT,YAAY;AACd;AACA;EACE,WAAW;EACX,UAAU;AACZ;AACA;EACE,SAAS;EACT,YAAY;AACd;AACA;EACE,WAAW;EACX,UAAU;AACZ;AACA;EACE,SAAS;EACT,YAAY;AACd;AACA;EACE,WAAW;EACX,UAAU;AACZ;AACA;EACE,SAAS;EACT,YAAY;AACd;AACA;EACE,WAAW;EACX,UAAU;AACZ;AACA;EACE,SAAS;EACT,YAAY;AACd;AACA;EACE,WAAW;EACX,UAAU;AACZ;AACA;EACE,SAAS;EACT,YAAY;AACd;AACA;EACE,WAAW;EACX,UAAU;AACZ;AACA;EACE,UAAU;EACV,aAAa;AACf;AACA;EACE,YAAY;EACZ,WAAW;AACb;AACA;EACE,UAAU;EACV,aAAa;AACf;AACA;EACE,YAAY;EACZ,WAAW;AACb;AACA;EACE,UAAU;EACV,aAAa;AACf;AACA;EACE,YAAY;EACZ,WAAW;AACb;AACA;EACE,UAAU;EACV,aAAa;AACf;AACA;EACE,YAAY;EACZ,WAAW;AACb;AACA;EACE,UAAU;EACV,aAAa;AACf;AACA;EACE,YAAY;EACZ,WAAW;AACb;AACA;EACE,UAAU;EACV,aAAa;AACf;AACA;EACE,YAAY;EACZ,WAAW;AACb;AACA;EACE,UAAU;EACV,aAAa;AACf;AACA;EACE,YAAY;EACZ,WAAW;AACb;AACA;EACE,UAAU;EACV,aAAa;AACf;AACA;EACE,YAAY;EACZ,WAAW;AACb;AACA;EACE,UAAU;EACV,aAAa;AACf;AACA;EACE,YAAY;EACZ,WAAW;AACb;AACA;EACE,UAAU;EACV,aAAa;AACf;AACA;EACE,YAAY;EACZ,WAAW;AACb;AACA;EACE,SAAS;EACT,YAAY;AACd;AACA;EACE,WAAW;EACX,UAAU;AACZ;AACA;EACE,QAAQ;EACR,WAAW;AACb;AACA;EACE,UAAU;EACV,SAAS;AACX;AACA;EACE,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,QAAQ;EACR,WAAW;AACb;AACA;EACE,UAAU;EACV,SAAS;AACX;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,QAAQ;EACR,WAAW;AACb;AACA;EACE,UAAU;EACV,SAAS;AACX;AACA;EACE,QAAQ;EACR,WAAW;AACb;AACA;EACE,UAAU;EACV,SAAS;AACX;AACA;EACE,QAAQ;EACR,WAAW;AACb;AACA;EACE,UAAU;EACV,SAAS;AACX;AACA;EACE,QAAQ;EACR,WAAW;AACb;AACA;EACE,UAAU;EACV,SAAS;AACX;AACA;EACE,QAAQ;EACR,WAAW;AACb;AACA;EACE,UAAU;EACV,SAAS;AACX;AACA;EACE,QAAQ;EACR,WAAW;AACb;AACA;EACE,UAAU;EACV,SAAS;AACX;AACA;EACE,QAAQ;EACR,WAAW;AACb;AACA;EACE,UAAU;EACV,SAAS;AACX;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,QAAQ;EACR,WAAW;AACb;AACA;EACE,UAAU;EACV,SAAS;AACX;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,QAAQ;EACR,WAAW;AACb;AACA;EACE,UAAU;EACV,SAAS;AACX;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,QAAQ;EACR,WAAW;AACb;AACA;EACE,UAAU;EACV,SAAS;AACX;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,QAAQ;EACR,WAAW;AACb;AACA;EACE,UAAU;EACV,SAAS;AACX;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,SAAS;EACT,YAAY;AACd;AACA;EACE,WAAW;EACX,UAAU;AACZ;AACA;EACE,MAAM;AACR;AACA;EACE,QAAQ;AACV;AACA;EACE,SAAS;AACX;AACA;EACE,OAAO;AACT;AACA;EACE,YAAY;AACd;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;AACf;AACA;EACE,WAAW;AACb;AACA;EACE,aAAa;AACf;AACA;EACE,cAAc;AAChB;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;AACf;AACA;EACE,SAAS;AACX;AACA;EACE,WAAW;AACb;AACA;EACE,YAAY;AACd;AACA;EACE,UAAU;AACZ;AACA;EACE,YAAY;AACd;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;AACf;AACA;EACE,WAAW;AACb;AACA;EACE,aAAa;AACf;AACA;EACE,cAAc;AAChB;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;AACf;AACA;EACE,SAAS;AACX;AACA;EACE,WAAW;AACb;AACA;EACE,YAAY;AACd;AACA;EACE,UAAU;AACZ;AACA;EACE,YAAY;AACd;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;AACf;AACA;EACE,WAAW;AACb;AACA;EACE,aAAa;AACf;AACA;EACE,cAAc;AAChB;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;AACf;AACA;EACE,SAAS;AACX;AACA;EACE,WAAW;AACb;AACA;EACE,YAAY;AACd;AACA;EACE,UAAU;AACZ;AACA;EACE,YAAY;AACd;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;AACf;AACA;EACE,WAAW;AACb;AACA;EACE,aAAa;AACf;AACA;EACE,cAAc;AAChB;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;AACf;AACA;EACE,SAAS;AACX;AACA;EACE,WAAW;AACb;AACA;EACE,YAAY;AACd;AACA;EACE,UAAU;AACZ;AACA;EACE,SAAS;AACX;AACA;EACE,WAAW;AACb;AACA;EACE,YAAY;AACd;AACA;EACE,UAAU;AACZ;AACA;EACE,SAAS;AACX;AACA;EACE,WAAW;AACb;AACA;EACE,YAAY;AACd;AACA;EACE,UAAU;AACZ;AACA;EACE,SAAS;AACX;AACA;EACE,WAAW;AACb;AACA;EACE,YAAY;AACd;AACA;EACE,UAAU;AACZ;AACA;EACE,SAAS;AACX;AACA;EACE,WAAW;AACb;AACA;EACE,YAAY;AACd;AACA;EACE,UAAU;AACZ;AACA;EACE,SAAS;AACX;AACA;EACE,WAAW;AACb;AACA;EACE,YAAY;AACd;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,YAAY;AACd;AACA;EACE,aAAa;AACf;AACA;EACE,WAAW;AACb;AACA;EACE,UAAU;AACZ;AACA;EACE,YAAY;AACd;AACA;EACE,aAAa;AACf;AACA;EACE,WAAW;AACb;AACA;EACE,UAAU;AACZ;AACA;EACE,YAAY;AACd;AACA;EACE,aAAa;AACf;AACA;EACE,WAAW;AACb;AACA;EACE,UAAU;AACZ;AACA;EACE,YAAY;AACd;AACA;EACE,aAAa;AACf;AACA;EACE,WAAW;AACb;AACA;EACE,UAAU;AACZ;AACA;EACE,YAAY;AACd;AACA;EACE,aAAa;AACf;AACA;EACE,WAAW;AACb;AACA;EACE,UAAU;AACZ;AACA;EACE,YAAY;AACd;AACA;EACE,aAAa;AACf;AACA;EACE,WAAW;AACb;AACA;EACE,UAAU;AACZ;AACA;EACE,YAAY;AACd;AACA;EACE,aAAa;AACf;AACA;EACE,WAAW;AACb;AACA;EACE,UAAU;AACZ;AACA;EACE,YAAY;AACd;AACA;EACE,aAAa;AACf;AACA;EACE,WAAW;AACb;AACA;EACE,UAAU;AACZ;AACA;EACE,YAAY;AACd;AACA;EACE,aAAa;AACf;AACA;EACE,WAAW;AACb;AACA;EACE,UAAU;AACZ;AACA;EACE,YAAY;AACd;AACA;EACE,aAAa;AACf;AACA;EACE,WAAW;AACb;AACA;EACE,SAAS;AACX;AACA;EACE,WAAW;AACb;AACA;EACE,YAAY;AACd;AACA;EACE,UAAU;AACZ;AACA;EACE,QAAQ;AACV;AACA;EACE,UAAU;AACZ;AACA;EACE,WAAW;AACb;AACA;EACE,SAAS;AACX;AACA;EACE,aAAa;AACf;AACA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,QAAQ;AACV;AACA;EACE,UAAU;AACZ;AACA;EACE,WAAW;AACb;AACA;EACE,SAAS;AACX;AACA;EACE,eAAe;AACjB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,QAAQ;AACV;AACA;EACE,UAAU;AACZ;AACA;EACE,WAAW;AACb;AACA;EACE,SAAS;AACX;AACA;EACE,QAAQ;AACV;AACA;EACE,UAAU;AACZ;AACA;EACE,WAAW;AACb;AACA;EACE,SAAS;AACX;AACA;EACE,QAAQ;AACV;AACA;EACE,UAAU;AACZ;AACA;EACE,WAAW;AACb;AACA;EACE,SAAS;AACX;AACA;EACE,QAAQ;AACV;AACA;EACE,UAAU;AACZ;AACA;EACE,WAAW;AACb;AACA;EACE,SAAS;AACX;AACA;EACE,QAAQ;AACV;AACA;EACE,UAAU;AACZ;AACA;EACE,WAAW;AACb;AACA;EACE,SAAS;AACX;AACA;EACE,QAAQ;AACV;AACA;EACE,UAAU;AACZ;AACA;EACE,WAAW;AACb;AACA;EACE,SAAS;AACX;AACA;EACE,QAAQ;AACV;AACA;EACE,UAAU;AACZ;AACA;EACE,WAAW;AACb;AACA;EACE,SAAS;AACX;AACA;EACE,eAAe;AACjB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,QAAQ;AACV;AACA;EACE,UAAU;AACZ;AACA;EACE,WAAW;AACb;AACA;EACE,SAAS;AACX;AACA;EACE,eAAe;AACjB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,QAAQ;AACV;AACA;EACE,UAAU;AACZ;AACA;EACE,WAAW;AACb;AACA;EACE,SAAS;AACX;AACA;EACE,eAAe;AACjB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,QAAQ;AACV;AACA;EACE,UAAU;AACZ;AACA;EACE,WAAW;AACb;AACA;EACE,SAAS;AACX;AACA;EACE,eAAe;AACjB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,QAAQ;AACV;AACA;EACE,UAAU;AACZ;AACA;EACE,WAAW;AACb;AACA;EACE,SAAS;AACX;AACA;EACE,eAAe;AACjB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,SAAS;AACX;AACA;EACE,WAAW;AACb;AACA;EACE,YAAY;AACd;AACA;EACE,UAAU;AACZ;AACA;EACE,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,YAAY;AACd;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,2CAA2C;AAC7C;AACA;EACE,2EAA2E;AAC7E;AACA;EACE,iFAAiF;AACnF;AACA;EACE,mFAAmF;AACrF;AACA;EACE,qFAAqF;AACvF;AACA;EACE,iDAAiD;AACnD;AACA;EACE,iDAAiD;AACnD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kCAAkC;AACpC;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,8CAA8C;AAChD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,2CAA2C;AAC7C;AACA;EACE,2EAA2E;AAC7E;AACA;EACE,iFAAiF;AACnF;AACA;EACE,mFAAmF;AACrF;AACA;EACE,qFAAqF;AACvF;AACA;EACE,iDAAiD;AACnD;AACA;EACE,iDAAiD;AACnD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kCAAkC;AACpC;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,8CAA8C;AAChD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,2CAA2C;AAC7C;AACA;EACE,2EAA2E;AAC7E;AACA;EACE,iFAAiF;AACnF;AACA;EACE,mFAAmF;AACrF;AACA;EACE,qFAAqF;AACvF;AACA;EACE,iDAAiD;AACnD;AACA;EACE,iDAAiD;AACnD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kCAAkC;AACpC;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,8CAA8C;AAChD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,2CAA2C;AAC7C;AACA;EACE,2EAA2E;AAC7E;AACA;EACE,iFAAiF;AACnF;AACA;EACE,mFAAmF;AACrF;AACA;EACE,qFAAqF;AACvF;AACA;EACE,iDAAiD;AACnD;AACA;EACE,iDAAiD;AACnD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kCAAkC;AACpC;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,8CAA8C;AAChD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,2CAA2C;AAC7C;AACA;EACE,2EAA2E;AAC7E;AACA;EACE,iFAAiF;AACnF;AACA;EACE,mFAAmF;AACrF;AACA;EACE,qFAAqF;AACvF;AACA;EACE,iDAAiD;AACnD;AACA;EACE,iDAAiD;AACnD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kCAAkC;AACpC;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,8CAA8C;AAChD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,kBAAkB;AACpB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,yCAAyC;AAC3C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,4CAA4C;AAC9C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,4CAA4C;AAC9C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,4CAA4C;AAC9C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,4CAA4C;AAC9C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,8CAA8C;AAChD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,4CAA4C;AAC9C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,4CAA4C;AAC9C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,8CAA8C;AAChD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,4CAA4C;AAC9C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,8CAA8C;AAChD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,8CAA8C;AAChD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,4CAA4C;AAC9C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,4CAA4C;AAC9C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,2CAA2C;AAC7C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,2CAA2C;AAC7C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,8CAA8C;AAChD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,2CAA2C;AAC7C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,2CAA2C;AAC7C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,8CAA8C;AAChD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,8CAA8C;AAChD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,8CAA8C;AAChD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,8CAA8C;AAChD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,8CAA8C;AAChD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,8CAA8C;AAChD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,8CAA8C;AAChD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,4CAA4C;AAC9C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,4CAA4C;AAC9C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,4CAA4C;AAC9C;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,yCAAyC;AAC3C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,4CAA4C;AAC9C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,4CAA4C;AAC9C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,4CAA4C;AAC9C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,4CAA4C;AAC9C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,8CAA8C;AAChD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,4CAA4C;AAC9C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,4CAA4C;AAC9C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,8CAA8C;AAChD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,4CAA4C;AAC9C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,8CAA8C;AAChD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,8CAA8C;AAChD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,4CAA4C;AAC9C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,4CAA4C;AAC9C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,2CAA2C;AAC7C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,2CAA2C;AAC7C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,8CAA8C;AAChD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,2CAA2C;AAC7C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,2CAA2C;AAC7C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,8CAA8C;AAChD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,8CAA8C;AAChD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,8CAA8C;AAChD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,8CAA8C;AAChD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,8CAA8C;AAChD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,8CAA8C;AAChD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,8CAA8C;AAChD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,4CAA4C;AAC9C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,4CAA4C;AAC9C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,4CAA4C;AAC9C;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,yCAAyC;AAC3C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,4CAA4C;AAC9C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,4CAA4C;AAC9C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,4CAA4C;AAC9C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,4CAA4C;AAC9C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,8CAA8C;AAChD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,4CAA4C;AAC9C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,4CAA4C;AAC9C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,8CAA8C;AAChD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,4CAA4C;AAC9C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,8CAA8C;AAChD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,8CAA8C;AAChD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,4CAA4C;AAC9C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,4CAA4C;AAC9C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,2CAA2C;AAC7C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,2CAA2C;AAC7C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,8CAA8C;AAChD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,2CAA2C;AAC7C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,2CAA2C;AAC7C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,8CAA8C;AAChD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,8CAA8C;AAChD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,8CAA8C;AAChD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,8CAA8C;AAChD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,8CAA8C;AAChD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,8CAA8C;AAChD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,8CAA8C;AAChD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,4CAA4C;AAC9C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,4CAA4C;AAC9C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,4CAA4C;AAC9C;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,yCAAyC;AAC3C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,4CAA4C;AAC9C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,4CAA4C;AAC9C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,4CAA4C;AAC9C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,4CAA4C;AAC9C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,8CAA8C;AAChD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,4CAA4C;AAC9C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,4CAA4C;AAC9C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,8CAA8C;AAChD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,4CAA4C;AAC9C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,8CAA8C;AAChD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,8CAA8C;AAChD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,4CAA4C;AAC9C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,4CAA4C;AAC9C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,2CAA2C;AAC7C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,2CAA2C;AAC7C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,8CAA8C;AAChD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,2CAA2C;AAC7C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,2CAA2C;AAC7C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,8CAA8C;AAChD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,8CAA8C;AAChD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,8CAA8C;AAChD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,8CAA8C;AAChD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,8CAA8C;AAChD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,8CAA8C;AAChD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,8CAA8C;AAChD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,4CAA4C;AAC9C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,4CAA4C;AAC9C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,4CAA4C;AAC9C;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,yCAAyC;AAC3C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,4CAA4C;AAC9C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,4CAA4C;AAC9C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,4CAA4C;AAC9C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,4CAA4C;AAC9C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,8CAA8C;AAChD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,4CAA4C;AAC9C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,4CAA4C;AAC9C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,8CAA8C;AAChD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,4CAA4C;AAC9C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,8CAA8C;AAChD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,8CAA8C;AAChD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,4CAA4C;AAC9C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,4CAA4C;AAC9C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,2CAA2C;AAC7C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,2CAA2C;AAC7C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,8CAA8C;AAChD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,2CAA2C;AAC7C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,2CAA2C;AAC7C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,8CAA8C;AAChD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,8CAA8C;AAChD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,8CAA8C;AAChD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,8CAA8C;AAChD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,8CAA8C;AAChD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,8CAA8C;AAChD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,8CAA8C;AAChD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,4CAA4C;AAC9C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,4CAA4C;AAC9C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,4CAA4C;AAC9C;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,yCAAyC;AAC3C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,4CAA4C;AAC9C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,4CAA4C;AAC9C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,4CAA4C;AAC9C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,4CAA4C;AAC9C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,8CAA8C;AAChD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,4CAA4C;AAC9C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,4CAA4C;AAC9C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,8CAA8C;AAChD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,4CAA4C;AAC9C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,8CAA8C;AAChD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,8CAA8C;AAChD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,4CAA4C;AAC9C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,4CAA4C;AAC9C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,2CAA2C;AAC7C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,2CAA2C;AAC7C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,8CAA8C;AAChD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,2CAA2C;AAC7C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,2CAA2C;AAC7C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,8CAA8C;AAChD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,8CAA8C;AAChD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,8CAA8C;AAChD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,8CAA8C;AAChD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,8CAA8C;AAChD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,8CAA8C;AAChD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,8CAA8C;AAChD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,4CAA4C;AAC9C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,4CAA4C;AAC9C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,4CAA4C;AAC9C;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,yCAAyC;AAC3C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,4CAA4C;AAC9C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,4CAA4C;AAC9C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,4CAA4C;AAC9C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,4CAA4C;AAC9C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,8CAA8C;AAChD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,4CAA4C;AAC9C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,4CAA4C;AAC9C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,8CAA8C;AAChD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,4CAA4C;AAC9C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,8CAA8C;AAChD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,8CAA8C;AAChD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,4CAA4C;AAC9C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,4CAA4C;AAC9C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,2CAA2C;AAC7C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,2CAA2C;AAC7C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,8CAA8C;AAChD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,2CAA2C;AAC7C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,2CAA2C;AAC7C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,8CAA8C;AAChD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,8CAA8C;AAChD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,8CAA8C;AAChD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,8CAA8C;AAChD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,8CAA8C;AAChD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,8CAA8C;AAChD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,8CAA8C;AAChD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,4CAA4C;AAC9C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,4CAA4C;AAC9C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,4CAA4C;AAC9C;AACA;EACE,iBAAiB;AACnB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,oBAAoB;AACtB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,qBAAqB;AACvB;AACA;EACE,mCAAmC;EACnC,kCAAkC;AACpC;AACA;EACE,4BAA4B;EAC5B,6BAA6B;AAC/B;AACA;EACE;;;KAGG;EACH;;;KAGG;EACH;;;KAGG;EACH;;;KAGG;EACH;;;KAGG;EACH,8MAA8M;AAChN;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,uCAAuC;AACzC;AACA;EACE,iDAAiD;AACnD;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,4CAA4C;AAC9C;AACA;EACE,iDAAiD;AACnD;AACA;EACE,4CAA4C;AAC9C;AACA;EACE,mDAAmD;AACrD;AACA;EACE,kDAAkD;AACpD;AACA;EACE,uBAAuB;AACzB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,iBAAiB;AACnB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,yBAAyB;EAEzB,iBAAiB;AACnB;AACA;EACE,yBAAyB;EAEzB,iBAAiB;AACnB;AACA;EACE,wBAAwB;EAExB,gBAAgB;AAClB;AACA;EACE,yBAAyB;EAEzB,iBAAiB;AACnB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;AACA;EACE,qBAAqB;AACvB;AACA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,QAAQ;AACV;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;EACE,cAAc;AAChB;AACA;EACE,WAAW;AACb;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;EACE,cAAc;AAChB;AACA;EACE,WAAW;AACb;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;EACE,cAAc;AAChB;AACA;EACE,WAAW;AACb;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;EACE,cAAc;AAChB;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,WAAW;AACb;AACA;EACE,UAAU;AACZ;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,UAAU;AACZ;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,UAAU;AACZ;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,UAAU;AACZ;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,UAAU;AACZ;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,UAAU;AACZ;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,WAAW;AACb;AACA;EACE,YAAY;AACd;AACA;EAEE,kBAAkB;AACpB;AACA;EAEE,kBAAkB;AACpB;AACA;EACE,UAAU;AACZ;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,aAAa;AACf;AACA;EACE,UAAU;AACZ;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,aAAa;AACf;AACA;EACE,UAAU;AACZ;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,aAAa;AACf;AACA;EACE,WAAW;EACX,MAAM;AACR;AACA;EACE,iBAAiB;EACjB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,iBAAiB;EACjB,YAAY;AACd;AACA;EACE,cAAc;EACd,SAAS;AACX;AACA;EACE,iBAAiB;EACjB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,iBAAiB;EACjB,YAAY;AACd;AACA;EACE,cAAc;EACd,SAAS;AACX;AACA;EACE,iBAAiB;EACjB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,iBAAiB;EACjB,YAAY;AACd;AACA;EACE,cAAc;EACd,SAAS;AACX;AACA;EACE,iBAAiB;EACjB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,iBAAiB;EACjB,YAAY;AACd;AACA;EACE,cAAc;EACd,SAAS;AACX;AACA;EACE,cAAc;EACd,SAAS;AACX;AACA;EACE,cAAc;EACd,SAAS;AACX;AACA;EACE,cAAc;EACd,SAAS;AACX;AACA;EACE,cAAc;EACd,SAAS;AACX;AACA;EACE,cAAc;EACd,SAAS;AACX;AACA;EACE,eAAe;EACf,UAAU;AACZ;AACA;EACE,eAAe;EACf,UAAU;AACZ;AACA;EACE,eAAe;EACf,UAAU;AACZ;AACA;EACE,eAAe;EACf,UAAU;AACZ;AACA;EACE,eAAe;EACf,UAAU;AACZ;AACA;EACE,eAAe;EACf,UAAU;AACZ;AACA;EACE,eAAe;EACf,UAAU;AACZ;AACA;EACE,eAAe;EACf,UAAU;AACZ;AACA;EACE,eAAe;EACf,UAAU;AACZ;AACA;EACE,eAAe;EACf,UAAU;AACZ;AACA;EACE,aAAa;EACb,QAAQ;AACV;AACA;EACE,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,aAAa;EACb,QAAQ;AACV;AACA;EACE,oBAAoB;EACpB,eAAe;AACjB;AACA;EACE,oBAAoB;EACpB,eAAe;AACjB;AACA;EACE,aAAa;EACb,QAAQ;AACV;AACA;EACE,aAAa;EACb,QAAQ;AACV;AACA;EACE,aAAa;EACb,QAAQ;AACV;AACA;EACE,aAAa;EACb,QAAQ;AACV;AACA;EACE,aAAa;EACb,QAAQ;AACV;AACA;EACE,aAAa;EACb,QAAQ;AACV;AACA;EACE,aAAa;EACb,QAAQ;AACV;AACA;EACE,oBAAoB;EACpB,eAAe;AACjB;AACA;EACE,oBAAoB;EACpB,eAAe;AACjB;AACA;EACE,aAAa;EACb,QAAQ;AACV;AACA;EACE,oBAAoB;EACpB,eAAe;AACjB;AACA;EACE,oBAAoB;EACpB,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,oBAAoB;EACpB,eAAe;AACjB;AACA;EACE,aAAa;EACb,QAAQ;AACV;AACA;EACE,oBAAoB;EACpB,eAAe;AACjB;AACA;EACE,oBAAoB;EACpB,eAAe;AACjB;AACA;EACE,aAAa;EACb,QAAQ;AACV;AACA;EACE,oBAAoB;EACpB,eAAe;AACjB;AACA;EACE,oBAAoB;EACpB,eAAe;AACjB;AACA;EACE,aAAa;EACb,QAAQ;AACV;AACA;EACE,oBAAoB;EACpB,eAAe;AACjB;AACA;EACE,oBAAoB;EACpB,eAAe;AACjB;AACA;EACE,cAAc;EACd,SAAS;AACX;AACA;EACE,kBAAkB;EAElB,aAAa;AACf;AACA;EACE,wBAAwB;EAExB,mBAAmB;AACrB;AACA;EACE,uBAAuB;EAEvB,kBAAkB;AACpB;AACA;EACE,wBAAwB;EAExB,mBAAmB;AACrB;AACA;EACE,qBAAqB;EAErB,gBAAgB;AAClB;AACA;EACE,wBAAwB;EAExB,mBAAmB;AACrB;AACA;EACE,uBAAuB;EAEvB,kBAAkB;AACpB;AACA;EACE,wBAAwB;EAExB,mBAAmB;AACrB;AACA;EACE,qBAAqB;EAErB,gBAAgB;AAClB;AACA;EACE,wBAAwB;EAExB,mBAAmB;AACrB;AACA;EACE,uBAAuB;EAEvB,kBAAkB;AACpB;AACA;EACE,wBAAwB;EAExB,mBAAmB;AACrB;AACA;EACE,qBAAqB;EAErB,gBAAgB;AAClB;AACA;EACE,wBAAwB;EAExB,mBAAmB;AACrB;AACA;EACE,uBAAuB;EAEvB,kBAAkB;AACpB;AACA;EACE,wBAAwB;EAExB,mBAAmB;AACrB;AACA;EACE,qBAAqB;EAErB,gBAAgB;AAClB;AACA;EACE,qBAAqB;EAErB,gBAAgB;AAClB;AACA;EACE,qBAAqB;EAErB,gBAAgB;AAClB;AACA;EACE,qBAAqB;EAErB,gBAAgB;AAClB;AACA;EACE,qBAAqB;EAErB,gBAAgB;AAClB;AACA;EACE,qBAAqB;EAErB,gBAAgB;AAClB;AACA;EACE,sBAAsB;EAEtB,iBAAiB;AACnB;AACA;EACE,sBAAsB;EAEtB,iBAAiB;AACnB;AACA;EACE,sBAAsB;EAEtB,iBAAiB;AACnB;AACA;EACE,sBAAsB;EAEtB,iBAAiB;AACnB;AACA;EACE,sBAAsB;EAEtB,iBAAiB;AACnB;AACA;EACE,sBAAsB;EAEtB,iBAAiB;AACnB;AACA;EACE,sBAAsB;EAEtB,iBAAiB;AACnB;AACA;EACE,sBAAsB;EAEtB,iBAAiB;AACnB;AACA;EACE,sBAAsB;EAEtB,iBAAiB;AACnB;AACA;EACE,sBAAsB;EAEtB,iBAAiB;AACnB;AACA;EACE,oBAAoB;EAEpB,eAAe;AACjB;AACA;EACE,yBAAyB;EAEzB,oBAAoB;AACtB;AACA;EACE,yBAAyB;EAEzB,oBAAoB;AACtB;AACA;EACE,yBAAyB;EAEzB,oBAAoB;AACtB;AACA;EACE,yBAAyB;EAEzB,oBAAoB;AACtB;AACA;EACE,oBAAoB;EAEpB,eAAe;AACjB;AACA;EACE,2BAA2B;EAE3B,sBAAsB;AACxB;AACA;EACE,2BAA2B;EAE3B,sBAAsB;AACxB;AACA;EACE,oBAAoB;EAEpB,eAAe;AACjB;AACA;EACE,oBAAoB;EAEpB,eAAe;AACjB;AACA;EACE,oBAAoB;EAEpB,eAAe;AACjB;AACA;EACE,oBAAoB;EAEpB,eAAe;AACjB;AACA;EACE,oBAAoB;EAEpB,eAAe;AACjB;AACA;EACE,oBAAoB;EAEpB,eAAe;AACjB;AACA;EACE,oBAAoB;EAEpB,eAAe;AACjB;AACA;EACE,2BAA2B;EAE3B,sBAAsB;AACxB;AACA;EACE,2BAA2B;EAE3B,sBAAsB;AACxB;AACA;EACE,oBAAoB;EAEpB,eAAe;AACjB;AACA;EACE,2BAA2B;EAE3B,sBAAsB;AACxB;AACA;EACE,2BAA2B;EAE3B,sBAAsB;AACxB;AACA;EACE,0BAA0B;EAE1B,qBAAqB;AACvB;AACA;EACE,2BAA2B;EAE3B,sBAAsB;AACxB;AACA;EACE,oBAAoB;EAEpB,eAAe;AACjB;AACA;EACE,2BAA2B;EAE3B,sBAAsB;AACxB;AACA;EACE,2BAA2B;EAE3B,sBAAsB;AACxB;AACA;EACE,oBAAoB;EAEpB,eAAe;AACjB;AACA;EACE,2BAA2B;EAE3B,sBAAsB;AACxB;AACA;EACE,2BAA2B;EAE3B,sBAAsB;AACxB;AACA;EACE,oBAAoB;EAEpB,eAAe;AACjB;AACA;EACE,2BAA2B;EAE3B,sBAAsB;AACxB;AACA;EACE,2BAA2B;EAE3B,sBAAsB;AACxB;AACA;EACE,qBAAqB;EAErB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAElB,aAAa;AACf;AACA;EACE,wBAAwB;EAExB,mBAAmB;AACrB;AACA;EACE,uBAAuB;EAEvB,kBAAkB;AACpB;AACA;EACE,wBAAwB;EAExB,mBAAmB;AACrB;AACA;EACE,qBAAqB;EAErB,gBAAgB;AAClB;AACA;EACE,wBAAwB;EAExB,mBAAmB;AACrB;AACA;EACE,uBAAuB;EAEvB,kBAAkB;AACpB;AACA;EACE,wBAAwB;EAExB,mBAAmB;AACrB;AACA;EACE,qBAAqB;EAErB,gBAAgB;AAClB;AACA;EACE,wBAAwB;EAExB,mBAAmB;AACrB;AACA;EACE,uBAAuB;EAEvB,kBAAkB;AACpB;AACA;EACE,wBAAwB;EAExB,mBAAmB;AACrB;AACA;EACE,qBAAqB;EAErB,gBAAgB;AAClB;AACA;EACE,wBAAwB;EAExB,mBAAmB;AACrB;AACA;EACE,uBAAuB;EAEvB,kBAAkB;AACpB;AACA;EACE,wBAAwB;EAExB,mBAAmB;AACrB;AACA;EACE,qBAAqB;EAErB,gBAAgB;AAClB;AACA;EACE,qBAAqB;EAErB,gBAAgB;AAClB;AACA;EACE,qBAAqB;EAErB,gBAAgB;AAClB;AACA;EACE,qBAAqB;EAErB,gBAAgB;AAClB;AACA;EACE,qBAAqB;EAErB,gBAAgB;AAClB;AACA;EACE,qBAAqB;EAErB,gBAAgB;AAClB;AACA;EACE,sBAAsB;EAEtB,iBAAiB;AACnB;AACA;EACE,sBAAsB;EAEtB,iBAAiB;AACnB;AACA;EACE,sBAAsB;EAEtB,iBAAiB;AACnB;AACA;EACE,sBAAsB;EAEtB,iBAAiB;AACnB;AACA;EACE,sBAAsB;EAEtB,iBAAiB;AACnB;AACA;EACE,sBAAsB;EAEtB,iBAAiB;AACnB;AACA;EACE,sBAAsB;EAEtB,iBAAiB;AACnB;AACA;EACE,sBAAsB;EAEtB,iBAAiB;AACnB;AACA;EACE,sBAAsB;EAEtB,iBAAiB;AACnB;AACA;EACE,sBAAsB;EAEtB,iBAAiB;AACnB;AACA;EACE,oBAAoB;EAEpB,eAAe;AACjB;AACA;EACE,yBAAyB;EAEzB,oBAAoB;AACtB;AACA;EACE,yBAAyB;EAEzB,oBAAoB;AACtB;AACA;EACE,yBAAyB;EAEzB,oBAAoB;AACtB;AACA;EACE,yBAAyB;EAEzB,oBAAoB;AACtB;AACA;EACE,oBAAoB;EAEpB,eAAe;AACjB;AACA;EACE,2BAA2B;EAE3B,sBAAsB;AACxB;AACA;EACE,2BAA2B;EAE3B,sBAAsB;AACxB;AACA;EACE,oBAAoB;EAEpB,eAAe;AACjB;AACA;EACE,oBAAoB;EAEpB,eAAe;AACjB;AACA;EACE,oBAAoB;EAEpB,eAAe;AACjB;AACA;EACE,oBAAoB;EAEpB,eAAe;AACjB;AACA;EACE,oBAAoB;EAEpB,eAAe;AACjB;AACA;EACE,oBAAoB;EAEpB,eAAe;AACjB;AACA;EACE,oBAAoB;EAEpB,eAAe;AACjB;AACA;EACE,2BAA2B;EAE3B,sBAAsB;AACxB;AACA;EACE,2BAA2B;EAE3B,sBAAsB;AACxB;AACA;EACE,oBAAoB;EAEpB,eAAe;AACjB;AACA;EACE,2BAA2B;EAE3B,sBAAsB;AACxB;AACA;EACE,2BAA2B;EAE3B,sBAAsB;AACxB;AACA;EACE,0BAA0B;EAE1B,qBAAqB;AACvB;AACA;EACE,2BAA2B;EAE3B,sBAAsB;AACxB;AACA;EACE,oBAAoB;EAEpB,eAAe;AACjB;AACA;EACE,2BAA2B;EAE3B,sBAAsB;AACxB;AACA;EACE,2BAA2B;EAE3B,sBAAsB;AACxB;AACA;EACE,oBAAoB;EAEpB,eAAe;AACjB;AACA;EACE,2BAA2B;EAE3B,sBAAsB;AACxB;AACA;EACE,2BAA2B;EAE3B,sBAAsB;AACxB;AACA;EACE,oBAAoB;EAEpB,eAAe;AACjB;AACA;EACE,2BAA2B;EAE3B,sBAAsB;AACxB;AACA;EACE,2BAA2B;EAE3B,sBAAsB;AACxB;AACA;EACE,qBAAqB;EAErB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,UAAU;AACZ;AACA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,oBAAoB;EACpB,eAAe;AACjB;AACA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,oBAAoB;EACpB,eAAe;AACjB;AACA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,oBAAoB;EACpB,eAAe;AACjB;AACA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,oBAAoB;EACpB,eAAe;AACjB;AACA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,YAAY;AACd;AACA;EACE,sBAAsB;EACtB,iBAAiB;AACnB;AACA;EACE,sBAAsB;EACtB,iBAAiB;AACnB;AACA;EACE,sBAAsB;EACtB,iBAAiB;AACnB;AACA;EACE,sBAAsB;EACtB,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,YAAY;AACd;AACA;EACE,wBAAwB;EACxB,mBAAmB;AACrB;AACA;EACE,wBAAwB;EACxB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,YAAY;AACd;AACA;EACE,iBAAiB;EACjB,YAAY;AACd;AACA;EACE,iBAAiB;EACjB,YAAY;AACd;AACA;EACE,iBAAiB;EACjB,YAAY;AACd;AACA;EACE,iBAAiB;EACjB,YAAY;AACd;AACA;EACE,iBAAiB;EACjB,YAAY;AACd;AACA;EACE,iBAAiB;EACjB,YAAY;AACd;AACA;EACE,wBAAwB;EACxB,mBAAmB;AACrB;AACA;EACE,wBAAwB;EACxB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,YAAY;AACd;AACA;EACE,wBAAwB;EACxB,mBAAmB;AACrB;AACA;EACE,wBAAwB;EACxB,mBAAmB;AACrB;AACA;EACE,uBAAuB;EACvB,kBAAkB;AACpB;AACA;EACE,wBAAwB;EACxB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,YAAY;AACd;AACA;EACE,wBAAwB;EACxB,mBAAmB;AACrB;AACA;EACE,wBAAwB;EACxB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,YAAY;AACd;AACA;EACE,wBAAwB;EACxB,mBAAmB;AACrB;AACA;EACE,wBAAwB;EACxB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,YAAY;AACd;AACA;EACE,wBAAwB;EACxB,mBAAmB;AACrB;AACA;EACE,wBAAwB;EACxB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,eAAe;EACf,UAAU;AACZ;AACA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,oBAAoB;EACpB,eAAe;AACjB;AACA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,oBAAoB;EACpB,eAAe;AACjB;AACA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,oBAAoB;EACpB,eAAe;AACjB;AACA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,oBAAoB;EACpB,eAAe;AACjB;AACA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,YAAY;AACd;AACA;EACE,sBAAsB;EACtB,iBAAiB;AACnB;AACA;EACE,sBAAsB;EACtB,iBAAiB;AACnB;AACA;EACE,sBAAsB;EACtB,iBAAiB;AACnB;AACA;EACE,sBAAsB;EACtB,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,YAAY;AACd;AACA;EACE,wBAAwB;EACxB,mBAAmB;AACrB;AACA;EACE,wBAAwB;EACxB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,YAAY;AACd;AACA;EACE,iBAAiB;EACjB,YAAY;AACd;AACA;EACE,iBAAiB;EACjB,YAAY;AACd;AACA;EACE,iBAAiB;EACjB,YAAY;AACd;AACA;EACE,iBAAiB;EACjB,YAAY;AACd;AACA;EACE,iBAAiB;EACjB,YAAY;AACd;AACA;EACE,iBAAiB;EACjB,YAAY;AACd;AACA;EACE,wBAAwB;EACxB,mBAAmB;AACrB;AACA;EACE,wBAAwB;EACxB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,YAAY;AACd;AACA;EACE,wBAAwB;EACxB,mBAAmB;AACrB;AACA;EACE,wBAAwB;EACxB,mBAAmB;AACrB;AACA;EACE,uBAAuB;EACvB,kBAAkB;AACpB;AACA;EACE,wBAAwB;EACxB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,YAAY;AACd;AACA;EACE,wBAAwB;EACxB,mBAAmB;AACrB;AACA;EACE,wBAAwB;EACxB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,YAAY;AACd;AACA;EACE,wBAAwB;EACxB,mBAAmB;AACrB;AACA;EACE,wBAAwB;EACxB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,YAAY;AACd;AACA;EACE,wBAAwB;EACxB,mBAAmB;AACrB;AACA;EACE,wBAAwB;EACxB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,mBAAmB;AACrB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,iDAAiD;AACnD;AACA;EACE,iDAAiD;AACnD;AACA;EACE,iDAAiD;AACnD;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,iBAAiB;AACnB;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,mBAAmB;AACrB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,6CAA6C;AAC/C;AACA;EACE,6CAA6C;AAC/C;AACA;EACE,6CAA6C;AAC/C;AACA;EACE,6CAA6C;AAC/C;AACA;EACE,6CAA6C;AAC/C;AACA;EACE,6CAA6C;AAC/C;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,oBAAoB;AACtB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,8BAA8B;AAChC;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,0BAA0B;EAC1B,0BAA0B;EAC1B,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;EACrB,sBAAsB;EACtB,sBAAsB;EACtB,4PAA4P;AAC9P;AACA;EACE,eAAe;AACjB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,qBAAqB;AACvB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,8BAA8B;AAChC;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,sBAAsB;AACxB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,sBAAsB;EACtB,sBAAsB;AACxB;AACA;EACE,uBAAuB;EACvB,uBAAuB;AACzB;AACA;EACE,wBAAwB;EACxB,wBAAwB;AAC1B;AACA;EACE,uBAAuB;EACvB,uBAAuB;AACzB;AACA;EACE,wBAAwB;EACxB,wBAAwB;AAC1B;AACA;EACE,sBAAsB;EACtB,sBAAsB;AACxB;AACA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;AACA;EACE,wBAAwB;EACxB,wBAAwB;AAC1B;AACA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;AACA;EACE,wBAAwB;EACxB,wBAAwB;AAC1B;AACA;EACE,sBAAsB;AACxB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,sBAAsB;AACxB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,sBAAsB;AACxB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,sBAAsB;AACxB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,sBAAsB;EACtB,sBAAsB;AACxB;AACA;EACE,uBAAuB;EACvB,uBAAuB;AACzB;AACA;EACE,wBAAwB;EACxB,wBAAwB;AAC1B;AACA;EACE,uBAAuB;EACvB,uBAAuB;AACzB;AACA;EACE,wBAAwB;EACxB,wBAAwB;AAC1B;AACA;EACE,sBAAsB;EACtB,sBAAsB;AACxB;AACA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;AACA;EACE,wBAAwB;EACxB,wBAAwB;AAC1B;AACA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;AACA;EACE,wBAAwB;EACxB,wBAAwB;AAC1B;AACA;EACE,sBAAsB;AACxB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,sBAAsB;AACxB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,sBAAsB;AACxB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,sBAAsB;AACxB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,sBAAsB;EACtB,sBAAsB;AACxB;AACA;EACE,uBAAuB;EACvB,uBAAuB;AACzB;AACA;EACE,wBAAwB;EACxB,wBAAwB;AAC1B;AACA;EACE,uBAAuB;EACvB,uBAAuB;AACzB;AACA;EACE,wBAAwB;EACxB,wBAAwB;AAC1B;AACA;EACE,sBAAsB;EACtB,sBAAsB;AACxB;AACA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;AACA;EACE,wBAAwB;EACxB,wBAAwB;AAC1B;AACA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;AACA;EACE,wBAAwB;EACxB,wBAAwB;AAC1B;AACA;EACE,sBAAsB;AACxB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,sBAAsB;AACxB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,sBAAsB;AACxB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,sBAAsB;AACxB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,qBAAqB;AACvB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,qBAAqB;AACvB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,qBAAqB;AACvB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,gCAAgC;AAClC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,gCAAgC;AAClC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,gCAAgC;AAClC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,gCAAgC;AAClC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,iCAAiC;AACnC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,mCAAmC;AACrC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,mCAAmC;AACrC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,mCAAmC;AACrC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,kCAAkC;AACpC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,mCAAmC;AACrC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,mCAAmC;AACrC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,mCAAmC;AACrC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,iCAAiC;AACnC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,kCAAkC;AACpC;AACA;EACE,kCAAkC;AACpC;AACA;EACE,kCAAkC;AACpC;AACA;EACE,kCAAkC;AACpC;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,mCAAmC;AACrC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,mCAAmC;AACrC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,mCAAmC;AACrC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,kCAAkC;AACpC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,mCAAmC;AACrC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,mCAAmC;AACrC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,mCAAmC;AACrC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,gCAAgC;AAClC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,gCAAgC;AAClC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,gCAAgC;AAClC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,gCAAgC;AAClC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,iCAAiC;AACnC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,mCAAmC;AACrC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,mCAAmC;AACrC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,mCAAmC;AACrC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,kCAAkC;AACpC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,mCAAmC;AACrC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,mCAAmC;AACrC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,mCAAmC;AACrC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,iCAAiC;AACnC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,kCAAkC;AACpC;AACA;EACE,kCAAkC;AACpC;AACA;EACE,kCAAkC;AACpC;AACA;EACE,kCAAkC;AACpC;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,mCAAmC;AACrC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,mCAAmC;AACrC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,mCAAmC;AACrC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,kCAAkC;AACpC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,mCAAmC;AACrC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,mCAAmC;AACrC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,mCAAmC;AACrC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,gCAAgC;AAClC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,gCAAgC;AAClC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,gCAAgC;AAClC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,gCAAgC;AAClC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,iCAAiC;AACnC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,mCAAmC;AACrC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,mCAAmC;AACrC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,mCAAmC;AACrC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,kCAAkC;AACpC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,mCAAmC;AACrC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,mCAAmC;AACrC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,mCAAmC;AACrC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,iCAAiC;AACnC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,kCAAkC;AACpC;AACA;EACE,kCAAkC;AACpC;AACA;EACE,kCAAkC;AACpC;AACA;EACE,kCAAkC;AACpC;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,mCAAmC;AACrC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,mCAAmC;AACrC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,mCAAmC;AACrC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,kCAAkC;AACpC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,mCAAmC;AACrC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,mCAAmC;AACrC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,mCAAmC;AACrC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,gCAAgC;AAClC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,gCAAgC;AAClC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,gCAAgC;AAClC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,gCAAgC;AAClC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,iCAAiC;AACnC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,mCAAmC;AACrC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,mCAAmC;AACrC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,mCAAmC;AACrC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,kCAAkC;AACpC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,mCAAmC;AACrC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,mCAAmC;AACrC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,mCAAmC;AACrC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,iCAAiC;AACnC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,kCAAkC;AACpC;AACA;EACE,kCAAkC;AACpC;AACA;EACE,kCAAkC;AACpC;AACA;EACE,kCAAkC;AACpC;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,mCAAmC;AACrC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,mCAAmC;AACrC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,mCAAmC;AACrC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,kCAAkC;AACpC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,mCAAmC;AACrC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,mCAAmC;AACrC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,mCAAmC;AACrC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,gCAAgC;AAClC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,gCAAgC;AAClC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,gCAAgC;AAClC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,gCAAgC;AAClC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,iCAAiC;AACnC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,mCAAmC;AACrC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,mCAAmC;AACrC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,mCAAmC;AACrC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,kCAAkC;AACpC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,mCAAmC;AACrC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,mCAAmC;AACrC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,mCAAmC;AACrC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,iCAAiC;AACnC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,kCAAkC;AACpC;AACA;EACE,kCAAkC;AACpC;AACA;EACE,kCAAkC;AACpC;AACA;EACE,kCAAkC;AACpC;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,mCAAmC;AACrC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,mCAAmC;AACrC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,mCAAmC;AACrC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,kCAAkC;AACpC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,mCAAmC;AACrC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,mCAAmC;AACrC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,mCAAmC;AACrC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,gCAAgC;AAClC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,gCAAgC;AAClC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,gCAAgC;AAClC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,gCAAgC;AAClC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,iCAAiC;AACnC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,mCAAmC;AACrC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,mCAAmC;AACrC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,mCAAmC;AACrC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,kCAAkC;AACpC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,mCAAmC;AACrC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,mCAAmC;AACrC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,mCAAmC;AACrC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,iCAAiC;AACnC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,kCAAkC;AACpC;AACA;EACE,kCAAkC;AACpC;AACA;EACE,kCAAkC;AACpC;AACA;EACE,kCAAkC;AACpC;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,mCAAmC;AACrC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,mCAAmC;AACrC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,mCAAmC;AACrC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,kCAAkC;AACpC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,mCAAmC;AACrC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,mCAAmC;AACrC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,mCAAmC;AACrC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,qBAAqB;AACvB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,qBAAqB;AACvB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,qBAAqB;AACvB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,qBAAqB;AACvB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,qBAAqB;AACvB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,qBAAqB;AACvB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,wGAAwG;AAC1G;AACA;EACE,wEAAwE;AAC1E;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,+BAA+B;AACjC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,kCAAkC;AACpC;AACA;EACE,sDAAsD;AACxD;AACA;EACE,sDAAsD;AACxD;AACA;EACE,wDAAwD;AAC1D;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,sBAAsB;AACxB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE;IACE,yBAAyB;EAC3B;AACF;AACA;EACE;IACE,mBAAmB;IACnB,UAAU;EACZ;AACF;AACA;EACE;IACE,WAAW;EACb;AACF;AACA;EACE;IACE,2BAA2B;IAC3B,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,qDAAqD;EACvD;AACF;AACA;EACE,eAAe;AACjB;AACA;EACE,kCAAkC;AACpC;AACA;EACE,sDAAsD;AACxD;AACA;EACE,yDAAyD;AAC3D;AACA;EACE,6BAA6B;AAC/B;AACA;EACE;IACE,WAAW;EACb;EACA;IACE;MACE,gBAAgB;IAClB;EACF;EACA;IACE;MACE,gBAAgB;IAClB;EACF;EACA;IACE;MACE,iBAAiB;IACnB;EACF;EACA;IACE;MACE,iBAAiB;IACnB;EACF;EACA;IACE,cAAc;IACd,eAAe;EACjB;EACA;IACE,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,cAAc;IACd,qBAAqB;IACrB,gBAAgB;EAClB;EACA;IACE,cAAc;IACd,gBAAgB;EAClB;EACA;IACE,2BAA2B;IAC3B,kBAAkB;IAClB,qBAAqB;EACvB;EACA;IACE,kBAAkB;IAClB,+BAA+B;IAC/B,oBAAoB;EACtB;EACA;IACE,kCAAkC;IAClC,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;EAChB;EACA;IACE,kBAAkB;IAClB,oBAAoB;EACtB;EACA;IACE,WAAW;IACX,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,6BAA6B;IAC7B,YAAY;EACd;EACA;IACE,qBAAqB;IACrB,qBAAqB;IACrB,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;IACd,0BAA0B;IAC1B,0BAA0B;IAC1B,uCAAuC;IACvC,iBAAiB;IACjB,oBAAoB;IACpB,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,cAAc;IACd,gBAAgB;IAChB,iBAAiB;IACjB,aAAa;IACb,0BAA0B;IAC1B,sBAAsB;EACxB;EACA;IACE,cAAc;IACd,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,sBAAsB;EACxB;EACA;IACE,cAAc;IACd,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;IACjB,oBAAoB;IACpB,gBAAgB;EAClB;EACA;IACE,cAAc;IACd,gBAAgB;IAChB,iBAAiB;IACjB,oBAAoB;IACpB,gBAAgB;EAClB;EACA;IACE,cAAc;IACd,kBAAkB;IAClB,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,cAAc;IACd,gBAAgB;IAChB,kBAAkB;EACpB;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,cAAc;IACd,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;IAClB,sBAAsB;IACtB,uBAAuB;IACvB,0BAA0B;IAC1B,uBAAuB;IACvB,wBAAwB;IACxB,0BAA0B;IAC1B,2BAA2B;IAC3B,yBAAyB;EAC3B;EACA;IACE,6BAA6B;IAC7B,eAAe;IACf,gBAAgB;IAChB,UAAU;IACV,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,oBAAoB;IACpB,oBAAoB;EACtB;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,kBAAkB;IAClB,sBAAsB;EACxB;EACA;IACE,cAAc;IACd,gBAAgB;IAChB,wBAAwB;IACxB,4BAA4B;EAC9B;EACA;IACE,sBAAsB;IACtB,0BAA0B;IAC1B,2BAA2B;IAC3B,yBAAyB;EAC3B;EACA;IACE,wBAAwB;IACxB,4BAA4B;EAC9B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,mBAAmB;IACnB,wBAAwB;IACxB,0BAA0B;IAC1B,2BAA2B;IAC3B,yBAAyB;EAC3B;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,aAAa;IACb,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,OAAO;EACT;EACA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,aAAa;EACf;EACA;IACE,gBAAgB;EAClB;EACA;IACE,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,sBAAsB;EACxB;EACA;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,sBAAsB;IACtB,sBAAsB;IACtB,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,uBAAuB;IACvB,0BAA0B;IAC1B,yBAAyB;EAC3B;EACA;IACE,sBAAsB;IACtB,aAAa;IACb,oBAAoB;IACpB,gBAAgB;EAClB;EACA;IACE,sBAAsB;IACtB,iBAAiB;IACjB,oBAAoB;IACpB,gBAAgB;EAClB;EACA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,0BAA0B;IAC1B,sBAAsB;EACxB;EACA;IACE,uBAAuB;IACvB,0BAA0B;IAC1B,sBAAsB;EACxB;EACA;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,aAAa;IACb,gBAAgB;EAClB;EACA;IACE,sBAAsB;IACtB,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;IACtB,sBAAsB;IACtB,uBAAuB;IACvB,0BAA0B;IAC1B,sBAAsB;IACtB,wBAAwB;IACxB,kBAAkB;IAClB,2BAA2B;IAC3B,iBAAiB;EACnB;EACA;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,OAAO;EACT;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,mBAAmB;IACnB,kBAAkB;IAClB,oCAAoC;IACpC,iBAAiB;EACnB;EACA;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,sBAAsB;IACtB,gBAAgB;EAClB;EACA;IACE,kBAAkB;IAClB,2BAA2B;IAC3B,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,wBAAwB;IACxB,kBAAkB;IAClB,2BAA2B;IAC3B,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,aAAa;EACf;EACA;IACE,gBAAgB;EAClB;EACA;IACE,mBAAmB;IACnB,sBAAsB;EACxB;EACA;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,sBAAsB;IACtB,sBAAsB;IACtB,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,uBAAuB;IACvB,0BAA0B;IAC1B,iBAAiB;EACnB;EACA;IACE,sBAAsB;IACtB,aAAa;IACb,0BAA0B;IAC1B,cAAc;EAChB;EACA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,0BAA0B;IAC1B,sBAAsB;EACxB;EACA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,0BAA0B;IAC1B,gBAAgB;EAClB;EACA;IACE,uBAAuB;IACvB,0BAA0B;IAC1B,sBAAsB;EACxB;EACA;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,aAAa;IACb,gBAAgB;EAClB;EACA;IACE,sBAAsB;IACtB,gBAAgB;IAChB,eAAe;EACjB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,sBAAsB;IACtB,iBAAiB;IACjB,eAAe;IACf,kBAAkB;IAClB,uBAAuB;IACvB,gBAAgB;IAChB,oBAAoB;IACpB,mBAAmB;IACnB,mBAAmB;EACrB;EACA;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,OAAO;EACT;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,oCAAoC;IACpC,iBAAiB;EACnB;EACA;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,sBAAsB;IACtB,gBAAgB;EAClB;EACA;IACE,qBAAqB;IACrB,sBAAsB;IACtB,oBAAoB;EACtB;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sBAAsB;IACtB,oBAAoB;EACtB;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,aAAa;EACf;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,iBAAiB;IACjB,oBAAoB;IACpB,yBAAyB;EAC3B;EACA;IACE,gBAAgB;IAChB,aAAa;IACb,0BAA0B;IAC1B,cAAc;EAChB;EACA;IACE,gBAAgB;IAChB,uBAAuB;IACvB,0BAA0B;IAC1B,sBAAsB;EACxB;EACA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,0BAA0B;IAC1B,sBAAsB;EACxB;EACA;IACE,iBAAiB;IACjB,oBAAoB;IACpB,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,aAAa;IACb,gBAAgB;EAClB;EACA;IACE,gBAAgB;IAChB,sBAAsB;IACtB,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;IAChB,sBAAsB;IACtB,eAAe;IACf,kBAAkB;IAClB,qBAAqB;IACrB,wBAAwB;IACxB,0BAA0B;IAC1B,2BAA2B;IAC3B,yBAAyB;EAC3B;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,OAAO;EACT;EACA;IACE,mBAAmB;EACrB;EACA;IACE,aAAa;IACb,cAAc;IACd,0BAA0B;IAC1B,YAAY;EACd;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,gBAAgB;IAChB,sBAAsB;EACxB;EACA;IACE,0BAA0B;IAC1B,2BAA2B;IAC3B,yBAAyB;EAC3B;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,wBAAwB;IACxB,0BAA0B;IAC1B,2BAA2B;IAC3B,yBAAyB;EAC3B;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,aAAa;EACf;EACA;IACE,gBAAgB;EAClB;EACA;IACE,iBAAiB;IACjB,sBAAsB;EACxB;EACA;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,iBAAiB;IACjB,sBAAsB;IACtB,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,uBAAuB;IACvB,0BAA0B;IAC1B,yBAAyB;EAC3B;EACA;IACE,sBAAsB;IACtB,aAAa;IACb,sBAAsB;IACtB,cAAc;EAChB;EACA;IACE,cAAc;IACd,iBAAiB;IACjB,0BAA0B;IAC1B,sBAAsB;EACxB;EACA;IACE,gBAAgB;IAChB,uBAAuB;IACvB,0BAA0B;IAC1B,sBAAsB;EACxB;EACA;IACE,uBAAuB;IACvB,0BAA0B;IAC1B,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,aAAa;IACb,gBAAgB;EAClB;EACA;IACE,sBAAsB;IACtB,gBAAgB;IAChB,eAAe;EACjB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;IACtB,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,qBAAqB;IACrB,kBAAkB;IAClB,oBAAoB;IACpB,qBAAqB;IACrB,mBAAmB;EACrB;EACA;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,OAAO;EACT;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,oCAAoC;IACpC,YAAY;EACd;EACA;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,sBAAsB;IACtB,gBAAgB;EAClB;EACA;IACE,oBAAoB;IACpB,qBAAqB;IACrB,mBAAmB;EACrB;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;IAClB,oBAAoB;IACpB,qBAAqB;IACrB,mBAAmB;EACrB;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,aAAa;EACf;EACA;IACE,gBAAgB;EAClB;EACA;IACE,oBAAoB;IACpB,wDAAwD;IACxD,iDAAiD;EACnD;EACA;IACE,oBAAoB;IACpB,gDAAgD;IAChD,yDAAyD;EAC3D;EACA;IACE,oBAAoB;IACpB,4DAA4D;IAC5D,qDAAqD;EACvD;EACA;IACE,oBAAoB;IACpB,oDAAoD;IACpD,6DAA6D;EAC/D;EACA;IACE,oBAAoB;IACpB,2DAA2D;IAC3D,oDAAoD;EACtD;EACA;IACE,oBAAoB;IACpB,mDAAmD;IACnD,4DAA4D;EAC9D;EACA;IACE,oBAAoB;IACpB,4DAA4D;IAC5D,qDAAqD;EACvD;EACA;IACE,oBAAoB;IACpB,oDAAoD;IACpD,6DAA6D;EAC/D;EACA;IACE,oBAAoB;IACpB,yDAAyD;IACzD,kDAAkD;EACpD;EACA;IACE,oBAAoB;IACpB,iDAAiD;IACjD,0DAA0D;EAC5D;EACA;IACE,oBAAoB;IACpB,4DAA4D;IAC5D,qDAAqD;EACvD;EACA;IACE,oBAAoB;IACpB,oDAAoD;IACpD,6DAA6D;EAC/D;EACA;IACE,oBAAoB;IACpB,2DAA2D;IAC3D,oDAAoD;EACtD;EACA;IACE,oBAAoB;IACpB,mDAAmD;IACnD,4DAA4D;EAC9D;EACA;IACE,oBAAoB;IACpB,4DAA4D;IAC5D,qDAAqD;EACvD;EACA;IACE,oBAAoB;IACpB,oDAAoD;IACpD,6DAA6D;EAC/D;EACA;IACE,oBAAoB;IACpB,yDAAyD;IACzD,kDAAkD;EACpD;EACA;IACE,oBAAoB;IACpB,iDAAiD;IACjD,0DAA0D;EAC5D;EACA;IACE,oBAAoB;IACpB,4DAA4D;IAC5D,qDAAqD;EACvD;EACA;IACE,oBAAoB;IACpB,oDAAoD;IACpD,6DAA6D;EAC/D;EACA;IACE,oBAAoB;IACpB,2DAA2D;IAC3D,oDAAoD;EACtD;EACA;IACE,oBAAoB;IACpB,mDAAmD;IACnD,4DAA4D;EAC9D;EACA;IACE,oBAAoB;IACpB,4DAA4D;IAC5D,qDAAqD;EACvD;EACA;IACE,oBAAoB;IACpB,oDAAoD;IACpD,6DAA6D;EAC/D;EACA;IACE,oBAAoB;IACpB,yDAAyD;IACzD,kDAAkD;EACpD;EACA;IACE,oBAAoB;IACpB,iDAAiD;IACjD,0DAA0D;EAC5D;EACA;IACE,oBAAoB;IACpB,4DAA4D;IAC5D,qDAAqD;EACvD;EACA;IACE,oBAAoB;IACpB,oDAAoD;IACpD,6DAA6D;EAC/D;EACA;IACE,oBAAoB;IACpB,2DAA2D;IAC3D,oDAAoD;EACtD;EACA;IACE,oBAAoB;IACpB,mDAAmD;IACnD,4DAA4D;EAC9D;EACA;IACE,oBAAoB;IACpB,4DAA4D;IAC5D,qDAAqD;EACvD;EACA;IACE,oBAAoB;IACpB,oDAAoD;IACpD,6DAA6D;EAC/D;EACA;IACE,oBAAoB;IACpB,yDAAyD;IACzD,kDAAkD;EACpD;EACA;IACE,oBAAoB;IACpB,iDAAiD;IACjD,0DAA0D;EAC5D;EACA;IACE,oBAAoB;IACpB,yDAAyD;IACzD,kDAAkD;EACpD;EACA;IACE,oBAAoB;IACpB,iDAAiD;IACjD,0DAA0D;EAC5D;EACA;IACE,oBAAoB;IACpB,yDAAyD;IACzD,kDAAkD;EACpD;EACA;IACE,oBAAoB;IACpB,iDAAiD;IACjD,0DAA0D;EAC5D;EACA;IACE,oBAAoB;IACpB,yDAAyD;IACzD,kDAAkD;EACpD;EACA;IACE,oBAAoB;IACpB,iDAAiD;IACjD,0DAA0D;EAC5D;EACA;IACE,oBAAoB;IACpB,yDAAyD;IACzD,kDAAkD;EACpD;EACA;IACE,oBAAoB;IACpB,iDAAiD;IACjD,0DAA0D;EAC5D;EACA;IACE,oBAAoB;IACpB,yDAAyD;IACzD,kDAAkD;EACpD;EACA;IACE,oBAAoB;IACpB,iDAAiD;IACjD,0DAA0D;EAC5D;EACA;IACE,oBAAoB;IACpB,0DAA0D;IAC1D,mDAAmD;EACrD;EACA;IACE,oBAAoB;IACpB,kDAAkD;IAClD,2DAA2D;EAC7D;EACA;IACE,oBAAoB;IACpB,0DAA0D;IAC1D,mDAAmD;EACrD;EACA;IACE,oBAAoB;IACpB,kDAAkD;IAClD,2DAA2D;EAC7D;EACA;IACE,oBAAoB;IACpB,0DAA0D;IAC1D,mDAAmD;EACrD;EACA;IACE,oBAAoB;IACpB,kDAAkD;IAClD,2DAA2D;EAC7D;EACA;IACE,oBAAoB;IACpB,0DAA0D;IAC1D,mDAAmD;EACrD;EACA;IACE,oBAAoB;IACpB,kDAAkD;IAClD,2DAA2D;EAC7D;EACA;IACE,oBAAoB;IACpB,0DAA0D;IAC1D,mDAAmD;EACrD;EACA;IACE,oBAAoB;IACpB,kDAAkD;IAClD,2DAA2D;EAC7D;EACA;IACE,oBAAoB;IACpB,0DAA0D;IAC1D,mDAAmD;EACrD;EACA;IACE,oBAAoB;IACpB,kDAAkD;IAClD,2DAA2D;EAC7D;EACA;IACE,oBAAoB;IACpB,0DAA0D;IAC1D,mDAAmD;EACrD;EACA;IACE,oBAAoB;IACpB,kDAAkD;IAClD,2DAA2D;EAC7D;EACA;IACE,oBAAoB;IACpB,0DAA0D;IAC1D,mDAAmD;EACrD;EACA;IACE,oBAAoB;IACpB,kDAAkD;IAClD,2DAA2D;EAC7D;EACA;IACE,oBAAoB;IACpB,0DAA0D;IAC1D,mDAAmD;EACrD;EACA;IACE,oBAAoB;IACpB,kDAAkD;IAClD,2DAA2D;EAC7D;EACA;IACE,oBAAoB;IACpB,0DAA0D;IAC1D,mDAAmD;EACrD;EACA;IACE,oBAAoB;IACpB,kDAAkD;IAClD,2DAA2D;EAC7D;EACA;IACE,oBAAoB;IACpB,wDAAwD;IACxD,iDAAiD;EACnD;EACA;IACE,oBAAoB;IACpB,gDAAgD;IAChD,yDAAyD;EAC3D;EACA;IACE,oBAAoB;IACpB,6DAA6D;IAC7D,sDAAsD;EACxD;EACA;IACE,oBAAoB;IACpB,qDAAqD;IACrD,8DAA8D;EAChE;EACA;IACE,oBAAoB;IACpB,6DAA6D;IAC7D,sDAAsD;EACxD;EACA;IACE,oBAAoB;IACpB,qDAAqD;IACrD,8DAA8D;EAChE;EACA;IACE,oBAAoB;IACpB,6DAA6D;IAC7D,sDAAsD;EACxD;EACA;IACE,oBAAoB;IACpB,qDAAqD;IACrD,8DAA8D;EAChE;EACA;IACE,oBAAoB;IACpB,6DAA6D;IAC7D,sDAAsD;EACxD;EACA;IACE,oBAAoB;IACpB,qDAAqD;IACrD,8DAA8D;EAChE;EACA;IACE,oBAAoB;IACpB,wDAAwD;IACxD,iDAAiD;EACnD;EACA;IACE,oBAAoB;IACpB,gDAAgD;IAChD,yDAAyD;EAC3D;EACA;IACE,oBAAoB;IACpB,+DAA+D;IAC/D,wDAAwD;EAC1D;EACA;IACE,oBAAoB;IACpB,uDAAuD;IACvD,gEAAgE;EAClE;EACA;IACE,oBAAoB;IACpB,+DAA+D;IAC/D,wDAAwD;EAC1D;EACA;IACE,oBAAoB;IACpB,uDAAuD;IACvD,gEAAgE;EAClE;EACA;IACE,oBAAoB;IACpB,wDAAwD;IACxD,iDAAiD;EACnD;EACA;IACE,oBAAoB;IACpB,gDAAgD;IAChD,yDAAyD;EAC3D;EACA;IACE,oBAAoB;IACpB,wDAAwD;IACxD,iDAAiD;EACnD;EACA;IACE,oBAAoB;IACpB,gDAAgD;IAChD,yDAAyD;EAC3D;EACA;IACE,oBAAoB;IACpB,wDAAwD;IACxD,iDAAiD;EACnD;EACA;IACE,oBAAoB;IACpB,gDAAgD;IAChD,yDAAyD;EAC3D;EACA;IACE,oBAAoB;IACpB,wDAAwD;IACxD,iDAAiD;EACnD;EACA;IACE,oBAAoB;IACpB,gDAAgD;IAChD,yDAAyD;EAC3D;EACA;IACE,oBAAoB;IACpB,wDAAwD;IACxD,iDAAiD;EACnD;EACA;IACE,oBAAoB;IACpB,gDAAgD;IAChD,yDAAyD;EAC3D;EACA;IACE,oBAAoB;IACpB,wDAAwD;IACxD,iDAAiD;EACnD;EACA;IACE,oBAAoB;IACpB,gDAAgD;IAChD,yDAAyD;EAC3D;EACA;IACE,oBAAoB;IACpB,wDAAwD;IACxD,iDAAiD;EACnD;EACA;IACE,oBAAoB;IACpB,gDAAgD;IAChD,yDAAyD;EAC3D;EACA;IACE,oBAAoB;IACpB,+DAA+D;IAC/D,wDAAwD;EAC1D;EACA;IACE,oBAAoB;IACpB,uDAAuD;IACvD,gEAAgE;EAClE;EACA;IACE,oBAAoB;IACpB,+DAA+D;IAC/D,wDAAwD;EAC1D;EACA;IACE,oBAAoB;IACpB,uDAAuD;IACvD,gEAAgE;EAClE;EACA;IACE,oBAAoB;IACpB,wDAAwD;IACxD,iDAAiD;EACnD;EACA;IACE,oBAAoB;IACpB,gDAAgD;IAChD,yDAAyD;EAC3D;EACA;IACE,oBAAoB;IACpB,+DAA+D;IAC/D,wDAAwD;EAC1D;EACA;IACE,oBAAoB;IACpB,uDAAuD;IACvD,gEAAgE;EAClE;EACA;IACE,oBAAoB;IACpB,+DAA+D;IAC/D,wDAAwD;EAC1D;EACA;IACE,oBAAoB;IACpB,uDAAuD;IACvD,gEAAgE;EAClE;EACA;IACE,oBAAoB;IACpB,8DAA8D;IAC9D,uDAAuD;EACzD;EACA;IACE,oBAAoB;IACpB,sDAAsD;IACtD,+DAA+D;EACjE;EACA;IACE,oBAAoB;IACpB,+DAA+D;IAC/D,wDAAwD;EAC1D;EACA;IACE,oBAAoB;IACpB,uDAAuD;IACvD,gEAAgE;EAClE;EACA;IACE,oBAAoB;IACpB,wDAAwD;IACxD,iDAAiD;EACnD;EACA;IACE,oBAAoB;IACpB,gDAAgD;IAChD,yDAAyD;EAC3D;EACA;IACE,oBAAoB;IACpB,+DAA+D;IAC/D,wDAAwD;EAC1D;EACA;IACE,oBAAoB;IACpB,uDAAuD;IACvD,gEAAgE;EAClE;EACA;IACE,oBAAoB;IACpB,+DAA+D;IAC/D,wDAAwD;EAC1D;EACA;IACE,oBAAoB;IACpB,uDAAuD;IACvD,gEAAgE;EAClE;EACA;IACE,oBAAoB;IACpB,wDAAwD;IACxD,iDAAiD;EACnD;EACA;IACE,oBAAoB;IACpB,gDAAgD;IAChD,yDAAyD;EAC3D;EACA;IACE,oBAAoB;IACpB,+DAA+D;IAC/D,wDAAwD;EAC1D;EACA;IACE,oBAAoB;IACpB,uDAAuD;IACvD,gEAAgE;EAClE;EACA;IACE,oBAAoB;IACpB,+DAA+D;IAC/D,wDAAwD;EAC1D;EACA;IACE,oBAAoB;IACpB,uDAAuD;IACvD,gEAAgE;EAClE;EACA;IACE,oBAAoB;IACpB,wDAAwD;IACxD,iDAAiD;EACnD;EACA;IACE,oBAAoB;IACpB,gDAAgD;IAChD,yDAAyD;EAC3D;EACA;IACE,oBAAoB;IACpB,+DAA+D;IAC/D,wDAAwD;EAC1D;EACA;IACE,oBAAoB;IACpB,uDAAuD;IACvD,gEAAgE;EAClE;EACA;IACE,oBAAoB;IACpB,+DAA+D;IAC/D,wDAAwD;EAC1D;EACA;IACE,oBAAoB;IACpB,uDAAuD;IACvD,gEAAgE;EAClE;EACA;IACE,oBAAoB;IACpB,yDAAyD;IACzD,kDAAkD;EACpD;EACA;IACE,oBAAoB;IACpB,iDAAiD;IACjD,0DAA0D;EAC5D;EACA;IACE,oBAAoB;IACpB,6DAA6D;IAC7D,sDAAsD;EACxD;EACA;IACE,oBAAoB;IACpB,qDAAqD;IACrD,8DAA8D;EAChE;EACA;IACE,oBAAoB;IACpB,4DAA4D;IAC5D,qDAAqD;EACvD;EACA;IACE,oBAAoB;IACpB,oDAAoD;IACpD,6DAA6D;EAC/D;EACA;IACE,oBAAoB;IACpB,6DAA6D;IAC7D,sDAAsD;EACxD;EACA;IACE,oBAAoB;IACpB,qDAAqD;IACrD,8DAA8D;EAChE;EACA;IACE,oBAAoB;IACpB,0DAA0D;IAC1D,mDAAmD;EACrD;EACA;IACE,oBAAoB;IACpB,kDAAkD;IAClD,2DAA2D;EAC7D;EACA;IACE,oBAAoB;IACpB,6DAA6D;IAC7D,sDAAsD;EACxD;EACA;IACE,oBAAoB;IACpB,qDAAqD;IACrD,8DAA8D;EAChE;EACA;IACE,oBAAoB;IACpB,4DAA4D;IAC5D,qDAAqD;EACvD;EACA;IACE,oBAAoB;IACpB,oDAAoD;IACpD,6DAA6D;EAC/D;EACA;IACE,oBAAoB;IACpB,6DAA6D;IAC7D,sDAAsD;EACxD;EACA;IACE,oBAAoB;IACpB,qDAAqD;IACrD,8DAA8D;EAChE;EACA;IACE,oBAAoB;IACpB,0DAA0D;IAC1D,mDAAmD;EACrD;EACA;IACE,oBAAoB;IACpB,kDAAkD;IAClD,2DAA2D;EAC7D;EACA;IACE,oBAAoB;IACpB,6DAA6D;IAC7D,sDAAsD;EACxD;EACA;IACE,oBAAoB;IACpB,qDAAqD;IACrD,8DAA8D;EAChE;EACA;IACE,oBAAoB;IACpB,4DAA4D;IAC5D,qDAAqD;EACvD;EACA;IACE,oBAAoB;IACpB,oDAAoD;IACpD,6DAA6D;EAC/D;EACA;IACE,oBAAoB;IACpB,6DAA6D;IAC7D,sDAAsD;EACxD;EACA;IACE,oBAAoB;IACpB,qDAAqD;IACrD,8DAA8D;EAChE;EACA;IACE,oBAAoB;IACpB,0DAA0D;IAC1D,mDAAmD;EACrD;EACA;IACE,oBAAoB;IACpB,kDAAkD;IAClD,2DAA2D;EAC7D;EACA;IACE,oBAAoB;IACpB,6DAA6D;IAC7D,sDAAsD;EACxD;EACA;IACE,oBAAoB;IACpB,qDAAqD;IACrD,8DAA8D;EAChE;EACA;IACE,oBAAoB;IACpB,4DAA4D;IAC5D,qDAAqD;EACvD;EACA;IACE,oBAAoB;IACpB,oDAAoD;IACpD,6DAA6D;EAC/D;EACA;IACE,oBAAoB;IACpB,6DAA6D;IAC7D,sDAAsD;EACxD;EACA;IACE,oBAAoB;IACpB,qDAAqD;IACrD,8DAA8D;EAChE;EACA;IACE,oBAAoB;IACpB,0DAA0D;IAC1D,mDAAmD;EACrD;EACA;IACE,oBAAoB;IACpB,kDAAkD;IAClD,2DAA2D;EAC7D;EACA;IACE,oBAAoB;IACpB,0DAA0D;IAC1D,mDAAmD;EACrD;EACA;IACE,oBAAoB;IACpB,kDAAkD;IAClD,2DAA2D;EAC7D;EACA;IACE,oBAAoB;IACpB,0DAA0D;IAC1D,mDAAmD;EACrD;EACA;IACE,oBAAoB;IACpB,kDAAkD;IAClD,2DAA2D;EAC7D;EACA;IACE,oBAAoB;IACpB,0DAA0D;IAC1D,mDAAmD;EACrD;EACA;IACE,oBAAoB;IACpB,kDAAkD;IAClD,2DAA2D;EAC7D;EACA;IACE,oBAAoB;IACpB,0DAA0D;IAC1D,mDAAmD;EACrD;EACA;IACE,oBAAoB;IACpB,kDAAkD;IAClD,2DAA2D;EAC7D;EACA;IACE,oBAAoB;IACpB,0DAA0D;IAC1D,mDAAmD;EACrD;EACA;IACE,oBAAoB;IACpB,kDAAkD;IAClD,2DAA2D;EAC7D;EACA;IACE,oBAAoB;IACpB,2DAA2D;IAC3D,oDAAoD;EACtD;EACA;IACE,oBAAoB;IACpB,mDAAmD;IACnD,4DAA4D;EAC9D;EACA;IACE,oBAAoB;IACpB,2DAA2D;IAC3D,oDAAoD;EACtD;EACA;IACE,oBAAoB;IACpB,mDAAmD;IACnD,4DAA4D;EAC9D;EACA;IACE,oBAAoB;IACpB,2DAA2D;IAC3D,oDAAoD;EACtD;EACA;IACE,oBAAoB;IACpB,mDAAmD;IACnD,4DAA4D;EAC9D;EACA;IACE,oBAAoB;IACpB,2DAA2D;IAC3D,oDAAoD;EACtD;EACA;IACE,oBAAoB;IACpB,mDAAmD;IACnD,4DAA4D;EAC9D;EACA;IACE,oBAAoB;IACpB,2DAA2D;IAC3D,oDAAoD;EACtD;EACA;IACE,oBAAoB;IACpB,mDAAmD;IACnD,4DAA4D;EAC9D;EACA;IACE,oBAAoB;IACpB,2DAA2D;IAC3D,oDAAoD;EACtD;EACA;IACE,oBAAoB;IACpB,mDAAmD;IACnD,4DAA4D;EAC9D;EACA;IACE,oBAAoB;IACpB,2DAA2D;IAC3D,oDAAoD;EACtD;EACA;IACE,oBAAoB;IACpB,mDAAmD;IACnD,4DAA4D;EAC9D;EACA;IACE,oBAAoB;IACpB,2DAA2D;IAC3D,oDAAoD;EACtD;EACA;IACE,oBAAoB;IACpB,mDAAmD;IACnD,4DAA4D;EAC9D;EACA;IACE,oBAAoB;IACpB,2DAA2D;IAC3D,oDAAoD;EACtD;EACA;IACE,oBAAoB;IACpB,mDAAmD;IACnD,4DAA4D;EAC9D;EACA;IACE,oBAAoB;IACpB,2DAA2D;IAC3D,oDAAoD;EACtD;EACA;IACE,oBAAoB;IACpB,mDAAmD;IACnD,4DAA4D;EAC9D;EACA;IACE,oBAAoB;IACpB,yDAAyD;IACzD,kDAAkD;EACpD;EACA;IACE,oBAAoB;IACpB,iDAAiD;IACjD,0DAA0D;EAC5D;EACA;IACE,oBAAoB;IACpB,8DAA8D;IAC9D,uDAAuD;EACzD;EACA;IACE,oBAAoB;IACpB,sDAAsD;IACtD,+DAA+D;EACjE;EACA;IACE,oBAAoB;IACpB,8DAA8D;IAC9D,uDAAuD;EACzD;EACA;IACE,oBAAoB;IACpB,sDAAsD;IACtD,+DAA+D;EACjE;EACA;IACE,oBAAoB;IACpB,8DAA8D;IAC9D,uDAAuD;EACzD;EACA;IACE,oBAAoB;IACpB,sDAAsD;IACtD,+DAA+D;EACjE;EACA;IACE,oBAAoB;IACpB,8DAA8D;IAC9D,uDAAuD;EACzD;EACA;IACE,oBAAoB;IACpB,sDAAsD;IACtD,+DAA+D;EACjE;EACA;IACE,oBAAoB;IACpB,yDAAyD;IACzD,kDAAkD;EACpD;EACA;IACE,oBAAoB;IACpB,iDAAiD;IACjD,0DAA0D;EAC5D;EACA;IACE,oBAAoB;IACpB,+DAA+D;IAC/D,wDAAwD;EAC1D;EACA;IACE,oBAAoB;IACpB,uDAAuD;IACvD,gEAAgE;EAClE;EACA;IACE,oBAAoB;IACpB,+DAA+D;IAC/D,wDAAwD;EAC1D;EACA;IACE,oBAAoB;IACpB,uDAAuD;IACvD,gEAAgE;EAClE;EACA;IACE,oBAAoB;IACpB,yDAAyD;IACzD,kDAAkD;EACpD;EACA;IACE,oBAAoB;IACpB,iDAAiD;IACjD,0DAA0D;EAC5D;EACA;IACE,oBAAoB;IACpB,yDAAyD;IACzD,kDAAkD;EACpD;EACA;IACE,oBAAoB;IACpB,iDAAiD;IACjD,0DAA0D;EAC5D;EACA;IACE,oBAAoB;IACpB,yDAAyD;IACzD,kDAAkD;EACpD;EACA;IACE,oBAAoB;IACpB,iDAAiD;IACjD,0DAA0D;EAC5D;EACA;IACE,oBAAoB;IACpB,yDAAyD;IACzD,kDAAkD;EACpD;EACA;IACE,oBAAoB;IACpB,iDAAiD;IACjD,0DAA0D;EAC5D;EACA;IACE,oBAAoB;IACpB,yDAAyD;IACzD,kDAAkD;EACpD;EACA;IACE,oBAAoB;IACpB,iDAAiD;IACjD,0DAA0D;EAC5D;EACA;IACE,oBAAoB;IACpB,yDAAyD;IACzD,kDAAkD;EACpD;EACA;IACE,oBAAoB;IACpB,iDAAiD;IACjD,0DAA0D;EAC5D;EACA;IACE,oBAAoB;IACpB,yDAAyD;IACzD,kDAAkD;EACpD;EACA;IACE,oBAAoB;IACpB,iDAAiD;IACjD,0DAA0D;EAC5D;EACA;IACE,oBAAoB;IACpB,+DAA+D;IAC/D,wDAAwD;EAC1D;EACA;IACE,oBAAoB;IACpB,uDAAuD;IACvD,gEAAgE;EAClE;EACA;IACE,oBAAoB;IACpB,+DAA+D;IAC/D,wDAAwD;EAC1D;EACA;IACE,oBAAoB;IACpB,uDAAuD;IACvD,gEAAgE;EAClE;EACA;IACE,oBAAoB;IACpB,yDAAyD;IACzD,kDAAkD;EACpD;EACA;IACE,oBAAoB;IACpB,iDAAiD;IACjD,0DAA0D;EAC5D;EACA;IACE,oBAAoB;IACpB,+DAA+D;IAC/D,wDAAwD;EAC1D;EACA;IACE,oBAAoB;IACpB,uDAAuD;IACvD,gEAAgE;EAClE;EACA;IACE,oBAAoB;IACpB,+DAA+D;IAC/D,wDAAwD;EAC1D;EACA;IACE,oBAAoB;IACpB,uDAAuD;IACvD,gEAAgE;EAClE;EACA;IACE,oBAAoB;IACpB,8DAA8D;IAC9D,uDAAuD;EACzD;EACA;IACE,oBAAoB;IACpB,sDAAsD;IACtD,+DAA+D;EACjE;EACA;IACE,oBAAoB;IACpB,+DAA+D;IAC/D,wDAAwD;EAC1D;EACA;IACE,oBAAoB;IACpB,uDAAuD;IACvD,gEAAgE;EAClE;EACA;IACE,oBAAoB;IACpB,yDAAyD;IACzD,kDAAkD;EACpD;EACA;IACE,oBAAoB;IACpB,iDAAiD;IACjD,0DAA0D;EAC5D;EACA;IACE,oBAAoB;IACpB,+DAA+D;IAC/D,wDAAwD;EAC1D;EACA;IACE,oBAAoB;IACpB,uDAAuD;IACvD,gEAAgE;EAClE;EACA;IACE,oBAAoB;IACpB,+DAA+D;IAC/D,wDAAwD;EAC1D;EACA;IACE,oBAAoB;IACpB,uDAAuD;IACvD,gEAAgE;EAClE;EACA;IACE,oBAAoB;IACpB,yDAAyD;IACzD,kDAAkD;EACpD;EACA;IACE,oBAAoB;IACpB,iDAAiD;IACjD,0DAA0D;EAC5D;EACA;IACE,oBAAoB;IACpB,+DAA+D;IAC/D,wDAAwD;EAC1D;EACA;IACE,oBAAoB;IACpB,uDAAuD;IACvD,gEAAgE;EAClE;EACA;IACE,oBAAoB;IACpB,+DAA+D;IAC/D,wDAAwD;EAC1D;EACA;IACE,oBAAoB;IACpB,uDAAuD;IACvD,gEAAgE;EAClE;EACA;IACE,oBAAoB;IACpB,yDAAyD;IACzD,kDAAkD;EACpD;EACA;IACE,oBAAoB;IACpB,iDAAiD;IACjD,0DAA0D;EAC5D;EACA;IACE,oBAAoB;IACpB,+DAA+D;IAC/D,wDAAwD;EAC1D;EACA;IACE,oBAAoB;IACpB,uDAAuD;IACvD,gEAAgE;EAClE;EACA;IACE,oBAAoB;IACpB,+DAA+D;IAC/D,wDAAwD;EAC1D;EACA;IACE,oBAAoB;IACpB,uDAAuD;IACvD,gEAAgE;EAClE;EACA;IACE,oBAAoB;IACpB,0DAA0D;IAC1D,mDAAmD;EACrD;EACA;IACE,oBAAoB;IACpB,kDAAkD;IAClD,2DAA2D;EAC7D;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,qBAAqB;IACrB,+DAA+D;IAC/D,wDAAwD;EAC1D;EACA;IACE,qBAAqB;IACrB,uDAAuD;IACvD,gEAAgE;EAClE;EACA;IACE,qBAAqB;IACrB,+DAA+D;IAC/D,wDAAwD;EAC1D;EACA;IACE,qBAAqB;IACrB,uDAAuD;IACvD,gEAAgE;EAClE;EACA;IACE,qBAAqB;IACrB,+DAA+D;IAC/D,wDAAwD;EAC1D;EACA;IACE,qBAAqB;IACrB,uDAAuD;IACvD,gEAAgE;EAClE;EACA;IACE,qBAAqB;IACrB,+DAA+D;IAC/D,wDAAwD;EAC1D;EACA;IACE,qBAAqB;IACrB,uDAAuD;IACvD,gEAAgE;EAClE;EACA;IACE,qBAAqB;IACrB,+DAA+D;IAC/D,wDAAwD;EAC1D;EACA;IACE,qBAAqB;IACrB,uDAAuD;IACvD,gEAAgE;EAClE;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,kDAAkD;EACpD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,oDAAoD;EACtD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,oDAAoD;EACtD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,oDAAoD;EACtD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,oDAAoD;EACtD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,UAAU;IACV,YAAY;IACZ,gBAAgB;IAChB,sBAAsB;IACtB,mBAAmB;IACnB,eAAe;EACjB;EACA;IACE,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,UAAU;IACV,SAAS;IACT,iBAAiB;IACjB,UAAU;IACV,mBAAmB;EACrB;EACA;IACE,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,UAAU;IACV,YAAY;IACZ,gBAAgB;IAChB,sBAAsB;IACtB,mBAAmB;IACnB,eAAe;EACjB;EACA;IACE,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,UAAU;IACV,SAAS;IACT,iBAAiB;IACjB,UAAU;IACV,mBAAmB;EACrB;EACA;IAGE,gBAAgB;EAClB;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,6BAA6B;IAC7B,qBAAqB;EACvB;EACA;IACE,8BAA8B;EAChC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,kDAAkD;EACpD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,oDAAoD;EACtD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,oDAAoD;EACtD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,oDAAoD;EACtD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,oDAAoD;EACtD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,8BAA8B;EAChC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,kDAAkD;EACpD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,oDAAoD;EACtD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,oDAAoD;EACtD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,oDAAoD;EACtD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,oDAAoD;EACtD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,8BAA8B;EAChC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,kDAAkD;EACpD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,oDAAoD;EACtD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,oDAAoD;EACtD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,oDAAoD;EACtD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,oDAAoD;EACtD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,8BAA8B;EAChC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,kDAAkD;EACpD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,oDAAoD;EACtD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,oDAAoD;EACtD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,oDAAoD;EACtD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,oDAAoD;EACtD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,8BAA8B;EAChC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,kDAAkD;EACpD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,oDAAoD;EACtD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,oDAAoD;EACtD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,oDAAoD;EACtD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,oDAAoD;EACtD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,8BAA8B;EAChC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,kDAAkD;EACpD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,oDAAoD;EACtD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,oDAAoD;EACtD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,oDAAoD;EACtD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,oDAAoD;EACtD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sEAAsE;EACxE;EACA;IACE,4EAA4E;EAC9E;EACA;IACE,wEAAwE;EAC1E;EACA;IACE,+EAA+E;EACjF;EACA;IACE,yEAAyE;EAC3E;EACA;IACE,8EAA8E;EAChF;EACA;IACE,uEAAuE;EACzE;EACA;IACE,2EAA2E;EAC7E;EACA;IACE,mCAAmC;IACnC,oGAAoG;EACtG;EACA;IACE,kCAAkC;IAClC,8FAA8F;EAChG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,8FAA8F;EAChG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,iGAAiG;EACnG;EACA;IACE,8BAA8B;IAC9B,iGAAiG;EACnG;EACA;IACE,8BAA8B;IAC9B,iGAAiG;EACnG;EACA;IACE,8BAA8B;IAC9B,iGAAiG;EACnG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,mGAAmG;EACrG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,iGAAiG;EACnG;EACA;IACE,8BAA8B;IAC9B,iGAAiG;EACnG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,mGAAmG;EACrG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,iGAAiG;EACnG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,mGAAmG;EACrG;EACA;IACE,8BAA8B;IAC9B,mGAAmG;EACrG;EACA;IACE,8BAA8B;IAC9B,iGAAiG;EACnG;EACA;IACE,8BAA8B;IAC9B,iGAAiG;EACnG;EACA;IACE,8BAA8B;IAC9B,gGAAgG;EAClG;EACA;IACE,8BAA8B;IAC9B,gGAAgG;EAClG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,mGAAmG;EACrG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,gGAAgG;EAClG;EACA;IACE,8BAA8B;IAC9B,gGAAgG;EAClG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,mGAAmG;EACrG;EACA;IACE,8BAA8B;IAC9B,mGAAmG;EACrG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,mGAAmG;EACrG;EACA;IACE,8BAA8B;IAC9B,mGAAmG;EACrG;EACA;IACE,8BAA8B;IAC9B,mGAAmG;EACrG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,mGAAmG;EACrG;EACA;IACE,8BAA8B;IAC9B,mGAAmG;EACrG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,iGAAiG;EACnG;EACA;IACE,8BAA8B;IAC9B,iGAAiG;EACnG;EACA;IACE,8BAA8B;IAC9B,iGAAiG;EACnG;EACA;IACE,kCAAkC;IAClC,+HAA+H;EACjI;EACA;IACE,iCAAiC;IACjC,yHAAyH;EAC3H;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,yHAAyH;EAC3H;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,4HAA4H;EAC9H;EACA;IACE,6BAA6B;IAC7B,4HAA4H;EAC9H;EACA;IACE,6BAA6B;IAC7B,4HAA4H;EAC9H;EACA;IACE,6BAA6B;IAC7B,4HAA4H;EAC9H;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,8HAA8H;EAChI;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,4HAA4H;EAC9H;EACA;IACE,6BAA6B;IAC7B,4HAA4H;EAC9H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,8HAA8H;EAChI;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,4HAA4H;EAC9H;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,8HAA8H;EAChI;EACA;IACE,6BAA6B;IAC7B,8HAA8H;EAChI;EACA;IACE,6BAA6B;IAC7B,4HAA4H;EAC9H;EACA;IACE,6BAA6B;IAC7B,4HAA4H;EAC9H;EACA;IACE,6BAA6B;IAC7B,2HAA2H;EAC7H;EACA;IACE,6BAA6B;IAC7B,2HAA2H;EAC7H;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,8HAA8H;EAChI;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,2HAA2H;EAC7H;EACA;IACE,6BAA6B;IAC7B,2HAA2H;EAC7H;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,8HAA8H;EAChI;EACA;IACE,6BAA6B;IAC7B,8HAA8H;EAChI;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,8HAA8H;EAChI;EACA;IACE,6BAA6B;IAC7B,8HAA8H;EAChI;EACA;IACE,6BAA6B;IAC7B,8HAA8H;EAChI;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,8HAA8H;EAChI;EACA;IACE,6BAA6B;IAC7B,8HAA8H;EAChI;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,4HAA4H;EAC9H;EACA;IACE,6BAA6B;IAC7B,4HAA4H;EAC9H;EACA;IACE,6BAA6B;IAC7B,4HAA4H;EAC9H;EACA;IACE,iCAAiC;EACnC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,mCAAmC;IACnC,oGAAoG;EACtG;EACA;IACE,kCAAkC;IAClC,8FAA8F;EAChG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,8FAA8F;EAChG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,iGAAiG;EACnG;EACA;IACE,8BAA8B;IAC9B,iGAAiG;EACnG;EACA;IACE,8BAA8B;IAC9B,iGAAiG;EACnG;EACA;IACE,8BAA8B;IAC9B,iGAAiG;EACnG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,mGAAmG;EACrG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,iGAAiG;EACnG;EACA;IACE,8BAA8B;IAC9B,iGAAiG;EACnG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,mGAAmG;EACrG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,iGAAiG;EACnG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,mGAAmG;EACrG;EACA;IACE,8BAA8B;IAC9B,mGAAmG;EACrG;EACA;IACE,8BAA8B;IAC9B,iGAAiG;EACnG;EACA;IACE,8BAA8B;IAC9B,iGAAiG;EACnG;EACA;IACE,8BAA8B;IAC9B,gGAAgG;EAClG;EACA;IACE,8BAA8B;IAC9B,gGAAgG;EAClG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,mGAAmG;EACrG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,gGAAgG;EAClG;EACA;IACE,8BAA8B;IAC9B,gGAAgG;EAClG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,mGAAmG;EACrG;EACA;IACE,8BAA8B;IAC9B,mGAAmG;EACrG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,mGAAmG;EACrG;EACA;IACE,8BAA8B;IAC9B,mGAAmG;EACrG;EACA;IACE,8BAA8B;IAC9B,mGAAmG;EACrG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,mGAAmG;EACrG;EACA;IACE,8BAA8B;IAC9B,mGAAmG;EACrG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,iGAAiG;EACnG;EACA;IACE,8BAA8B;IAC9B,iGAAiG;EACnG;EACA;IACE,8BAA8B;IAC9B,iGAAiG;EACnG;EACA;IACE,kCAAkC;IAClC,+HAA+H;EACjI;EACA;IACE,iCAAiC;IACjC,yHAAyH;EAC3H;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,yHAAyH;EAC3H;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,4HAA4H;EAC9H;EACA;IACE,6BAA6B;IAC7B,4HAA4H;EAC9H;EACA;IACE,6BAA6B;IAC7B,4HAA4H;EAC9H;EACA;IACE,6BAA6B;IAC7B,4HAA4H;EAC9H;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,8HAA8H;EAChI;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,4HAA4H;EAC9H;EACA;IACE,6BAA6B;IAC7B,4HAA4H;EAC9H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,8HAA8H;EAChI;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,4HAA4H;EAC9H;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,8HAA8H;EAChI;EACA;IACE,6BAA6B;IAC7B,8HAA8H;EAChI;EACA;IACE,6BAA6B;IAC7B,4HAA4H;EAC9H;EACA;IACE,6BAA6B;IAC7B,4HAA4H;EAC9H;EACA;IACE,6BAA6B;IAC7B,2HAA2H;EAC7H;EACA;IACE,6BAA6B;IAC7B,2HAA2H;EAC7H;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,8HAA8H;EAChI;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,2HAA2H;EAC7H;EACA;IACE,6BAA6B;IAC7B,2HAA2H;EAC7H;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,8HAA8H;EAChI;EACA;IACE,6BAA6B;IAC7B,8HAA8H;EAChI;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,8HAA8H;EAChI;EACA;IACE,6BAA6B;IAC7B,8HAA8H;EAChI;EACA;IACE,6BAA6B;IAC7B,8HAA8H;EAChI;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,8HAA8H;EAChI;EACA;IACE,6BAA6B;IAC7B,8HAA8H;EAChI;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,4HAA4H;EAC9H;EACA;IACE,6BAA6B;IAC7B,4HAA4H;EAC9H;EACA;IACE,6BAA6B;IAC7B,4HAA4H;EAC9H;EACA;IACE,iCAAiC;EACnC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,mCAAmC;IACnC,oGAAoG;EACtG;EACA;IACE,kCAAkC;IAClC,8FAA8F;EAChG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,8FAA8F;EAChG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,iGAAiG;EACnG;EACA;IACE,8BAA8B;IAC9B,iGAAiG;EACnG;EACA;IACE,8BAA8B;IAC9B,iGAAiG;EACnG;EACA;IACE,8BAA8B;IAC9B,iGAAiG;EACnG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,mGAAmG;EACrG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,iGAAiG;EACnG;EACA;IACE,8BAA8B;IAC9B,iGAAiG;EACnG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,mGAAmG;EACrG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,iGAAiG;EACnG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,mGAAmG;EACrG;EACA;IACE,8BAA8B;IAC9B,mGAAmG;EACrG;EACA;IACE,8BAA8B;IAC9B,iGAAiG;EACnG;EACA;IACE,8BAA8B;IAC9B,iGAAiG;EACnG;EACA;IACE,8BAA8B;IAC9B,gGAAgG;EAClG;EACA;IACE,8BAA8B;IAC9B,gGAAgG;EAClG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,mGAAmG;EACrG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,gGAAgG;EAClG;EACA;IACE,8BAA8B;IAC9B,gGAAgG;EAClG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,mGAAmG;EACrG;EACA;IACE,8BAA8B;IAC9B,mGAAmG;EACrG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,mGAAmG;EACrG;EACA;IACE,8BAA8B;IAC9B,mGAAmG;EACrG;EACA;IACE,8BAA8B;IAC9B,mGAAmG;EACrG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,mGAAmG;EACrG;EACA;IACE,8BAA8B;IAC9B,mGAAmG;EACrG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,iGAAiG;EACnG;EACA;IACE,8BAA8B;IAC9B,iGAAiG;EACnG;EACA;IACE,8BAA8B;IAC9B,iGAAiG;EACnG;EACA;IACE,kCAAkC;IAClC,+HAA+H;EACjI;EACA;IACE,iCAAiC;IACjC,yHAAyH;EAC3H;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,yHAAyH;EAC3H;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,4HAA4H;EAC9H;EACA;IACE,6BAA6B;IAC7B,4HAA4H;EAC9H;EACA;IACE,6BAA6B;IAC7B,4HAA4H;EAC9H;EACA;IACE,6BAA6B;IAC7B,4HAA4H;EAC9H;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,8HAA8H;EAChI;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,4HAA4H;EAC9H;EACA;IACE,6BAA6B;IAC7B,4HAA4H;EAC9H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,8HAA8H;EAChI;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,4HAA4H;EAC9H;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,8HAA8H;EAChI;EACA;IACE,6BAA6B;IAC7B,8HAA8H;EAChI;EACA;IACE,6BAA6B;IAC7B,4HAA4H;EAC9H;EACA;IACE,6BAA6B;IAC7B,4HAA4H;EAC9H;EACA;IACE,6BAA6B;IAC7B,2HAA2H;EAC7H;EACA;IACE,6BAA6B;IAC7B,2HAA2H;EAC7H;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,8HAA8H;EAChI;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,2HAA2H;EAC7H;EACA;IACE,6BAA6B;IAC7B,2HAA2H;EAC7H;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,8HAA8H;EAChI;EACA;IACE,6BAA6B;IAC7B,8HAA8H;EAChI;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,8HAA8H;EAChI;EACA;IACE,6BAA6B;IAC7B,8HAA8H;EAChI;EACA;IACE,6BAA6B;IAC7B,8HAA8H;EAChI;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,8HAA8H;EAChI;EACA;IACE,6BAA6B;IAC7B,8HAA8H;EAChI;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,4HAA4H;EAC9H;EACA;IACE,6BAA6B;IAC7B,4HAA4H;EAC9H;EACA;IACE,6BAA6B;IAC7B,4HAA4H;EAC9H;EACA;IACE,iCAAiC;EACnC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,eAAe;EACjB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,eAAe;EACjB;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,gCAAgC;EAClC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,iCAAiC;EACnC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,qBAAqB;EACvB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,kDAAkD;EACpD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,oDAAoD;EACtD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,oDAAoD;EACtD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,oDAAoD;EACtD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,oDAAoD;EACtD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,kDAAkD;EACpD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,oDAAoD;EACtD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,oDAAoD;EACtD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,oDAAoD;EACtD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,oDAAoD;EACtD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,kDAAkD;EACpD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,oDAAoD;EACtD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,oDAAoD;EACtD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,oDAAoD;EACtD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,oDAAoD;EACtD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,kDAAkD;EACpD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,oDAAoD;EACtD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,oDAAoD;EACtD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,oDAAoD;EACtD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,oDAAoD;EACtD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,kDAAkD;EACpD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,oDAAoD;EACtD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,oDAAoD;EACtD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,oDAAoD;EACtD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,oDAAoD;EACtD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,kDAAkD;EACpD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,oDAAoD;EACtD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,oDAAoD;EACtD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,oDAAoD;EACtD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,oDAAoD;EACtD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;EACrB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,yBAAyB;IACzB,0BAA0B;EAC5B;EACA;IACE,0BAA0B;IAC1B,6BAA6B;EAC/B;EACA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;EACA;IACE,yBAAyB;IACzB,4BAA4B;EAC9B;EACA;IACE,gCAAgC;IAChC,iCAAiC;EACnC;EACA;IACE,iCAAiC;IACjC,oCAAoC;EACtC;EACA;IACE,oCAAoC;IACpC,mCAAmC;EACrC;EACA;IACE,gCAAgC;IAChC,mCAAmC;EACrC;EACA;IACE,+BAA+B;IAC/B,gCAAgC;EAClC;EACA;IACE,gCAAgC;IAChC,mCAAmC;EACrC;EACA;IACE,mCAAmC;IACnC,kCAAkC;EACpC;EACA;IACE,+BAA+B;IAC/B,kCAAkC;EACpC;EACA;IACE,gCAAgC;IAChC,iCAAiC;EACnC;EACA;IACE,iCAAiC;IACjC,oCAAoC;EACtC;EACA;IACE,oCAAoC;IACpC,mCAAmC;EACrC;EACA;IACE,gCAAgC;IAChC,mCAAmC;EACrC;EACA;IACE,8BAA8B;IAC9B,+BAA+B;EACjC;EACA;IACE,+BAA+B;IAC/B,kCAAkC;EACpC;EACA;IACE,kCAAkC;IAClC,iCAAiC;EACnC;EACA;IACE,8BAA8B;IAC9B,iCAAiC;EACnC;EACA;IACE,+BAA+B;IAC/B,gCAAgC;EAClC;EACA;IACE,gCAAgC;IAChC,mCAAmC;EACrC;EACA;IACE,mCAAmC;IACnC,kCAAkC;EACpC;EACA;IACE,+BAA+B;IAC/B,kCAAkC;EACpC;EACA;IACE,4BAA4B;IAC5B,6BAA6B;EAC/B;EACA;IACE,6BAA6B;IAC7B,gCAAgC;EAClC;EACA;IACE,gCAAgC;IAChC,+BAA+B;EACjC;EACA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;EACA;IACE,8BAA8B;IAC9B,+BAA+B;EACjC;EACA;IACE,+BAA+B;IAC/B,kCAAkC;EACpC;EACA;IACE,kCAAkC;IAClC,iCAAiC;EACnC;EACA;IACE,8BAA8B;IAC9B,iCAAiC;EACnC;EACA;IACE,8BAA8B;IAC9B,+BAA+B;EACjC;EACA;IACE,+BAA+B;IAC/B,kCAAkC;EACpC;EACA;IACE,kCAAkC;IAClC,iCAAiC;EACnC;EACA;IACE,8BAA8B;IAC9B,iCAAiC;EACnC;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,gCAAgC;EAClC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,gCAAgC;EAClC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,YAAY;EACd;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,mBAAmB;EACrB;EACA;IACE,cAAc;EAChB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;EACf;EACA;IACE,oBAAoB;EACtB;EACA;IACE,cAAc;EAChB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,aAAa;EACf;EACA;IACE,oBAAoB;EACtB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,aAAa;EACf;EACA;IACE,mBAAmB;EACrB;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,8BAA8B;EAChC;EACA;IACE,eAAe;EACjB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,gBAAgB;EAClB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,8BAA8B;EAChC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,SAAY;EACd;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA;IACE,UAAU;EACZ;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA;IACE,QAAQ;EACV;EACA;IACE,QAAQ;EACV;EACA;IACE,QAAQ;EACV;EACA;IACE,QAAQ;EACV;EACA;IACE,QAAQ;EACV;EACA;IACE,QAAQ;EACV;EACA;IACE,QAAQ;EACV;EACA;IACE,QAAQ;EACV;EACA;IACE,QAAQ;EACV;EACA;IACE,SAAS;EACX;EACA;IACE,SAAS;EACX;EACA;IACE,SAAS;EACX;EACA;IACE,YAAY;EACd;EACA;IACE,WAAW;EACb;EACA;IACE,QAAQ;EACV;EACA;IACE,YAAY;EACd;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;IACX,cAAc;IACd,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,YAAY;EACd;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,6MAA6M;EAC/M;EACA;IACE,8DAA8D;EAChE;EACA;IACE,iFAAiF;EACnF;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,SAAS;EACX;EACA;IACE,eAAe;EACjB;EACA;IACE,cAAc;EAChB;EACA;IACE,eAAe;EACjB;EACA;IACE,YAAY;EACd;EACA;IACE,eAAe;EACjB;EACA;IACE,cAAc;EAChB;EACA;IACE,eAAe;EACjB;EACA;IACE,YAAY;EACd;EACA;IACE,eAAe;EACjB;EACA;IACE,cAAc;EAChB;EACA;IACE,eAAe;EACjB;EACA;IACE,YAAY;EACd;EACA;IACE,eAAe;EACjB;EACA;IACE,cAAc;EAChB;EACA;IACE,eAAe;EACjB;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,YAAY;EACd;EACA;IACE,WAAW;EACb;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,WAAW;EACb;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,WAAW;EACb;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,WAAW;EACb;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,WAAW;EACb;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,WAAW;EACb;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,YAAY;EACd;EACA;IACE,aAAa;EACf;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,eAAe;EACjB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,cAAc;EAChB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,cAAc;EAChB;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,SAAS;EACX;EACA;IACE,eAAe;EACjB;EACA;IACE,cAAc;EAChB;EACA;IACE,eAAe;EACjB;EACA;IACE,YAAY;EACd;EACA;IACE,eAAe;EACjB;EACA;IACE,cAAc;EAChB;EACA;IACE,eAAe;EACjB;EACA;IACE,YAAY;EACd;EACA;IACE,eAAe;EACjB;EACA;IACE,cAAc;EAChB;EACA;IACE,eAAe;EACjB;EACA;IACE,YAAY;EACd;EACA;IACE,eAAe;EACjB;EACA;IACE,cAAc;EAChB;EACA;IACE,eAAe;EACjB;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,YAAY;EACd;EACA;IACE,WAAW;EACb;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,WAAW;EACb;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,WAAW;EACb;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,WAAW;EACb;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,WAAW;EACb;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,WAAW;EACb;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,YAAY;EACd;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,aAAa;EACf;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,aAAa;EACf;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,aAAa;EACf;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA;IACE,YAAY;EACd;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,YAAY;EACd;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,YAAY;EACd;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,YAAY;EACd;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,YAAY;EACd;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,YAAY;EACd;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;IACb,gBAAgB;EAClB;EACA;IACE,cAAc;IACd,eAAe;EACjB;EACA;IACE,mBAAmB;IACnB,sBAAsB;EACxB;EACA;IACE,oBAAoB;IACpB,qBAAqB;EACvB;EACA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;EACA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;EACA;IACE,mBAAmB;IACnB,sBAAsB;EACxB;EACA;IACE,oBAAoB;IACpB,qBAAqB;EACvB;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,mBAAmB;IACnB,sBAAsB;EACxB;EACA;IACE,oBAAoB;IACpB,qBAAqB;EACvB;EACA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;EACA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;EACA;IACE,mBAAmB;IACnB,sBAAsB;EACxB;EACA;IACE,oBAAoB;IACpB,qBAAqB;EACvB;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,mBAAmB;IACnB,sBAAsB;EACxB;EACA;IACE,oBAAoB;IACpB,qBAAqB;EACvB;EACA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;EACA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;EACA;IACE,mBAAmB;IACnB,sBAAsB;EACxB;EACA;IACE,oBAAoB;IACpB,qBAAqB;EACvB;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,mBAAmB;IACnB,sBAAsB;EACxB;EACA;IACE,oBAAoB;IACpB,qBAAqB;EACvB;EACA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;EACA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;EACA;IACE,mBAAmB;IACnB,sBAAsB;EACxB;EACA;IACE,oBAAoB;IACpB,qBAAqB;EACvB;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE,oBAAoB;IACpB,uBAAuB;EACzB;EACA;IACE,qBAAqB;IACrB,sBAAsB;EACxB;EACA;IACE,oBAAoB;IACpB,uBAAuB;EACzB;EACA;IACE,qBAAqB;IACrB,sBAAsB;EACxB;EACA;IACE,oBAAoB;IACpB,uBAAuB;EACzB;EACA;IACE,qBAAqB;IACrB,sBAAsB;EACxB;EACA;IACE,oBAAoB;IACpB,uBAAuB;EACzB;EACA;IACE,qBAAqB;IACrB,sBAAsB;EACxB;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE,sBAAsB;IACtB,yBAAyB;EAC3B;EACA;IACE,uBAAuB;IACvB,wBAAwB;EAC1B;EACA;IACE,sBAAsB;IACtB,yBAAyB;EAC3B;EACA;IACE,uBAAuB;IACvB,wBAAwB;EAC1B;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE,sBAAsB;IACtB,yBAAyB;EAC3B;EACA;IACE,uBAAuB;IACvB,wBAAwB;EAC1B;EACA;IACE,sBAAsB;IACtB,yBAAyB;EAC3B;EACA;IACE,uBAAuB;IACvB,wBAAwB;EAC1B;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE,sBAAsB;IACtB,yBAAyB;EAC3B;EACA;IACE,uBAAuB;IACvB,wBAAwB;EAC1B;EACA;IACE,sBAAsB;IACtB,yBAAyB;EAC3B;EACA;IACE,uBAAuB;IACvB,wBAAwB;EAC1B;EACA;IACE,qBAAqB;IACrB,wBAAwB;EAC1B;EACA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,sBAAsB;IACtB,yBAAyB;EAC3B;EACA;IACE,uBAAuB;IACvB,wBAAwB;EAC1B;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE,sBAAsB;IACtB,yBAAyB;EAC3B;EACA;IACE,uBAAuB;IACvB,wBAAwB;EAC1B;EACA;IACE,sBAAsB;IACtB,yBAAyB;EAC3B;EACA;IACE,uBAAuB;IACvB,wBAAwB;EAC1B;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE,sBAAsB;IACtB,yBAAyB;EAC3B;EACA;IACE,uBAAuB;IACvB,wBAAwB;EAC1B;EACA;IACE,sBAAsB;IACtB,yBAAyB;EAC3B;EACA;IACE,uBAAuB;IACvB,wBAAwB;EAC1B;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE,sBAAsB;IACtB,yBAAyB;EAC3B;EACA;IACE,uBAAuB;IACvB,wBAAwB;EAC1B;EACA;IACE,sBAAsB;IACtB,yBAAyB;EAC3B;EACA;IACE,uBAAuB;IACvB,wBAAwB;EAC1B;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,oBAAoB;IACpB,uBAAuB;EACzB;EACA;IACE,qBAAqB;IACrB,sBAAsB;EACxB;EACA;IACE,mBAAmB;IACnB,sBAAsB;EACxB;EACA;IACE,oBAAoB;IACpB,qBAAqB;EACvB;EACA;IACE,oBAAoB;IACpB,uBAAuB;EACzB;EACA;IACE,qBAAqB;IACrB,sBAAsB;EACxB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,oBAAoB;IACpB,uBAAuB;EACzB;EACA;IACE,qBAAqB;IACrB,sBAAsB;EACxB;EACA;IACE,mBAAmB;IACnB,sBAAsB;EACxB;EACA;IACE,oBAAoB;IACpB,qBAAqB;EACvB;EACA;IACE,oBAAoB;IACpB,uBAAuB;EACzB;EACA;IACE,qBAAqB;IACrB,sBAAsB;EACxB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,oBAAoB;IACpB,uBAAuB;EACzB;EACA;IACE,qBAAqB;IACrB,sBAAsB;EACxB;EACA;IACE,mBAAmB;IACnB,sBAAsB;EACxB;EACA;IACE,oBAAoB;IACpB,qBAAqB;EACvB;EACA;IACE,oBAAoB;IACpB,uBAAuB;EACzB;EACA;IACE,qBAAqB;IACrB,sBAAsB;EACxB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,oBAAoB;IACpB,uBAAuB;EACzB;EACA;IACE,qBAAqB;IACrB,sBAAsB;EACxB;EACA;IACE,mBAAmB;IACnB,sBAAsB;EACxB;EACA;IACE,oBAAoB;IACpB,qBAAqB;EACvB;EACA;IACE,oBAAoB;IACpB,uBAAuB;EACzB;EACA;IACE,qBAAqB;IACrB,sBAAsB;EACxB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;EACA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;EACA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;EACA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;EACA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;EACA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;EACA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;EACA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;EACA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;EACA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;EACA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,qBAAqB;IACrB,wBAAwB;EAC1B;EACA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,qBAAqB;IACrB,wBAAwB;EAC1B;EACA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,qBAAqB;IACrB,wBAAwB;EAC1B;EACA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,qBAAqB;IACrB,wBAAwB;EAC1B;EACA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,sBAAsB;IACtB,yBAAyB;EAC3B;EACA;IACE,uBAAuB;IACvB,wBAAwB;EAC1B;EACA;IACE,sBAAsB;IACtB,yBAAyB;EAC3B;EACA;IACE,uBAAuB;IACvB,wBAAwB;EAC1B;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,sBAAsB;IACtB,yBAAyB;EAC3B;EACA;IACE,uBAAuB;IACvB,wBAAwB;EAC1B;EACA;IACE,sBAAsB;IACtB,yBAAyB;EAC3B;EACA;IACE,uBAAuB;IACvB,wBAAwB;EAC1B;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,sBAAsB;IACtB,yBAAyB;EAC3B;EACA;IACE,uBAAuB;IACvB,wBAAwB;EAC1B;EACA;IACE,sBAAsB;IACtB,yBAAyB;EAC3B;EACA;IACE,uBAAuB;IACvB,wBAAwB;EAC1B;EACA;IACE,qBAAqB;IACrB,wBAAwB;EAC1B;EACA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,sBAAsB;IACtB,yBAAyB;EAC3B;EACA;IACE,uBAAuB;IACvB,wBAAwB;EAC1B;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,sBAAsB;IACtB,yBAAyB;EAC3B;EACA;IACE,uBAAuB;IACvB,wBAAwB;EAC1B;EACA;IACE,sBAAsB;IACtB,yBAAyB;EAC3B;EACA;IACE,uBAAuB;IACvB,wBAAwB;EAC1B;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,sBAAsB;IACtB,yBAAyB;EAC3B;EACA;IACE,uBAAuB;IACvB,wBAAwB;EAC1B;EACA;IACE,sBAAsB;IACtB,yBAAyB;EAC3B;EACA;IACE,uBAAuB;IACvB,wBAAwB;EAC1B;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,sBAAsB;IACtB,yBAAyB;EAC3B;EACA;IACE,uBAAuB;IACvB,wBAAwB;EAC1B;EACA;IACE,sBAAsB;IACtB,yBAAyB;EAC3B;EACA;IACE,uBAAuB;IACvB,wBAAwB;EAC1B;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,aAAa;EACf;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,cAAc;EAChB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,aAAa;EACf;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,eAAe;EACjB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,eAAe;EACjB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,eAAe;EACjB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,eAAe;EACjB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,eAAe;EACjB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IAEE,sBAAsB;EACxB;EACA;IAEE,sBAAsB;EACxB;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,aAAa;EACf;EACA;IACE,gBAAgB;EAClB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,YAAY;EACd;EACA;IACE,eAAe;EACjB;EACA;IAEE,sBAAsB;EACxB;EACA;IAEE,sBAAsB;EACxB;EACA;IAEE,mBAAmB;EACrB;EACA;IAEE,iBAAiB;EACnB;EACA;IAEE,gBAAgB;EAClB;EACA;IAEE,gBAAgB;EAClB;EACA;IAEE,sBAAsB;EACxB;EACA;IAEE,uBAAuB;EACzB;EACA;IAEE,uBAAuB;EACzB;EACA;IAEE,qBAAqB;EACvB;EACA;IAEE,4BAA4B;EAC9B;EACA;IAEE,yBAAyB;EAC3B;EACA;IAEE,sBAAsB;EACxB;EACA;IAEE,6BAA6B;EAC/B;EACA;IAEE,0BAA0B;EAC5B;EACA;IAEE,oBAAoB;EACtB;EACA;IACE,UAAU;EACZ;EACA;IACE,aAAa;EACf;EACA;IACE,YAAY;EACd;EACA;IACE,aAAa;EACf;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,aAAa;EACf;EACA;IACE,YAAY;EACd;EACA;IACE,aAAa;EACf;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,aAAa;EACf;EACA;IACE,YAAY;EACd;EACA;IACE,aAAa;EACf;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,aAAa;EACf;EACA;IACE,YAAY;EACd;EACA;IACE,aAAa;EACf;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,aAAa;EACf;EACA;IACE,YAAY;EACd;EACA;IACE,aAAa;EACf;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,aAAa;EACf;EACA;IACE,YAAY;EACd;EACA;IACE,aAAa;EACf;EACA;IACE,UAAU;EACZ;EACA;IACE,8BAA8B;IAC9B,mBAAmB;EACrB;EACA;IACE,yBAAyB;IACzB,mBAAmB;EACrB;EACA;IACE,yBAAyB;IACzB,mBAAmB;EACrB;EACA;IACE,8BAA8B;IAC9B,mBAAmB;EACrB;EACA;IACE,yBAAyB;IACzB,mBAAmB;EACrB;EACA;IACE,yBAAyB;IACzB,mBAAmB;EACrB;EACA;IACE,cAAc;EAChB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iCAAiC;EACnC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,8BAA8B;EAChC;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,8BAA8B;EAChC;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,UAAU;EACZ;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,aAAa;EACf;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,aAAa;EACf;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,aAAa;EACf;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA;IACE,YAAY;EACd;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,YAAY;EACd;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,YAAY;EACd;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,YAAY;EACd;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,YAAY;EACd;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,YAAY;EACd;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,aAAa;EACf;EACA;IACE,cAAc;IACd,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,oBAAoB;IACpB,uBAAuB;EACzB;EACA;IACE,qBAAqB;IACrB,sBAAsB;EACxB;EACA;IACE,mBAAmB;IACnB,sBAAsB;EACxB;EACA;IACE,oBAAoB;IACpB,qBAAqB;EACvB;EACA;IACE,oBAAoB;IACpB,uBAAuB;EACzB;EACA;IACE,qBAAqB;IACrB,sBAAsB;EACxB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,oBAAoB;IACpB,uBAAuB;EACzB;EACA;IACE,qBAAqB;IACrB,sBAAsB;EACxB;EACA;IACE,mBAAmB;IACnB,sBAAsB;EACxB;EACA;IACE,oBAAoB;IACpB,qBAAqB;EACvB;EACA;IACE,oBAAoB;IACpB,uBAAuB;EACzB;EACA;IACE,qBAAqB;IACrB,sBAAsB;EACxB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,oBAAoB;IACpB,uBAAuB;EACzB;EACA;IACE,qBAAqB;IACrB,sBAAsB;EACxB;EACA;IACE,mBAAmB;IACnB,sBAAsB;EACxB;EACA;IACE,oBAAoB;IACpB,qBAAqB;EACvB;EACA;IACE,oBAAoB;IACpB,uBAAuB;EACzB;EACA;IACE,qBAAqB;IACrB,sBAAsB;EACxB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,oBAAoB;IACpB,uBAAuB;EACzB;EACA;IACE,qBAAqB;IACrB,sBAAsB;EACxB;EACA;IACE,mBAAmB;IACnB,sBAAsB;EACxB;EACA;IACE,oBAAoB;IACpB,qBAAqB;EACvB;EACA;IACE,oBAAoB;IACpB,uBAAuB;EACzB;EACA;IACE,qBAAqB;IACrB,sBAAsB;EACxB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;EACA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;EACA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;EACA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;EACA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;EACA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;EACA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;EACA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;EACA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;EACA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;EACA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,qBAAqB;IACrB,wBAAwB;EAC1B;EACA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,qBAAqB;IACrB,wBAAwB;EAC1B;EACA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,qBAAqB;IACrB,wBAAwB;EAC1B;EACA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,qBAAqB;IACrB,wBAAwB;EAC1B;EACA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,wBAAwB;IACxB,yBAAyB;EAC3B;EACA;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,wBAAwB;IACxB,yBAAyB;EAC3B;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,wBAAwB;IACxB,yBAAyB;EAC3B;EACA;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,wBAAwB;IACxB,yBAAyB;EAC3B;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,wBAAwB;IACxB,yBAAyB;EAC3B;EACA;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,wBAAwB;IACxB,yBAAyB;EAC3B;EACA;IACE,sBAAsB;IACtB,yBAAyB;EAC3B;EACA;IACE,uBAAuB;IACvB,wBAAwB;EAC1B;EACA;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,wBAAwB;IACxB,yBAAyB;EAC3B;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,wBAAwB;IACxB,yBAAyB;EAC3B;EACA;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,wBAAwB;IACxB,yBAAyB;EAC3B;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,wBAAwB;IACxB,yBAAyB;EAC3B;EACA;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,wBAAwB;IACxB,yBAAyB;EAC3B;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,wBAAwB;IACxB,yBAAyB;EAC3B;EACA;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,wBAAwB;IACxB,yBAAyB;EAC3B;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,cAAc;EAChB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EAIA;IACE,mBAAmB;EACrB;EAIA;IACE,kBAAkB;EACpB;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,gDAAgD;EAClD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,mDAAmD;EACrD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,mDAAmD;EACrD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,mDAAmD;EACrD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,mDAAmD;EACrD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,qDAAqD;EACvD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,mDAAmD;EACrD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,mDAAmD;EACrD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,qDAAqD;EACvD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,mDAAmD;EACrD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,qDAAqD;EACvD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,qDAAqD;EACvD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,mDAAmD;EACrD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,mDAAmD;EACrD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,kDAAkD;EACpD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,kDAAkD;EACpD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,qDAAqD;EACvD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,kDAAkD;EACpD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,kDAAkD;EACpD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,qDAAqD;EACvD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,qDAAqD;EACvD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,qDAAqD;EACvD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,qDAAqD;EACvD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,qDAAqD;EACvD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,qDAAqD;EACvD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,qDAAqD;EACvD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,mDAAmD;EACrD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,mDAAmD;EACrD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,mDAAmD;EACrD;EAIA;IACE,mBAAmB;EACrB;EAIA;IACE,kBAAkB;EACpB;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,gDAAgD;EAClD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,mDAAmD;EACrD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,mDAAmD;EACrD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,mDAAmD;EACrD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,mDAAmD;EACrD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,qDAAqD;EACvD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,mDAAmD;EACrD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,mDAAmD;EACrD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,qDAAqD;EACvD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,mDAAmD;EACrD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,qDAAqD;EACvD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,qDAAqD;EACvD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,mDAAmD;EACrD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,mDAAmD;EACrD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,kDAAkD;EACpD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,kDAAkD;EACpD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,qDAAqD;EACvD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,kDAAkD;EACpD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,kDAAkD;EACpD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,qDAAqD;EACvD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,qDAAqD;EACvD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,qDAAqD;EACvD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,qDAAqD;EACvD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,qDAAqD;EACvD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,qDAAqD;EACvD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,qDAAqD;EACvD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,mDAAmD;EACrD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,mDAAmD;EACrD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,mDAAmD;EACrD;EAIA;IACE,wBAAwB;EAC1B;EAIA;IACE,2BAA2B;EAC7B;EAIA;IACE,0BAA0B;EAC5B;EAIA;IACE,2BAA2B;EAC7B;EAIA;IACE,wBAAwB;EAC1B;EAIA;IACE,wBAAwB;EAC1B;EAIA;IACE,2BAA2B;EAC7B;EAIA;IACE,0BAA0B;EAC5B;EAIA;IACE,2BAA2B;EAC7B;EAIA;IACE,wBAAwB;EAC1B;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,MAAM;IACN,QAAQ;IACR,SAAS;IACT,OAAO;EACT;EACA;IACE,YAAY;IACZ,cAAc;IACd,eAAe;IACf,aAAa;EACf;EACA;IACE,WAAW;IACX,aAAa;IACb,cAAc;IACd,YAAY;EACd;EACA;IACE,YAAY;IACZ,cAAc;IACd,eAAe;IACf,aAAa;EACf;EACA;IACE,SAAS;IACT,WAAW;IACX,YAAY;IACZ,UAAU;EACZ;EACA;IACE,YAAY;IACZ,cAAc;IACd,eAAe;IACf,aAAa;EACf;EACA;IACE,WAAW;IACX,aAAa;IACb,cAAc;IACd,YAAY;EACd;EACA;IACE,YAAY;IACZ,cAAc;IACd,eAAe;IACf,aAAa;EACf;EACA;IACE,SAAS;IACT,WAAW;IACX,YAAY;IACZ,UAAU;EACZ;EACA;IACE,YAAY;IACZ,cAAc;IACd,eAAe;IACf,aAAa;EACf;EACA;IACE,WAAW;IACX,aAAa;IACb,cAAc;IACd,YAAY;EACd;EACA;IACE,YAAY;IACZ,cAAc;IACd,eAAe;IACf,aAAa;EACf;EACA;IACE,SAAS;IACT,WAAW;IACX,YAAY;IACZ,UAAU;EACZ;EACA;IACE,YAAY;IACZ,cAAc;IACd,eAAe;IACf,aAAa;EACf;EACA;IACE,WAAW;IACX,aAAa;IACb,cAAc;IACd,YAAY;EACd;EACA;IACE,YAAY;IACZ,cAAc;IACd,eAAe;IACf,aAAa;EACf;EACA;IACE,SAAS;IACT,WAAW;IACX,YAAY;IACZ,UAAU;EACZ;EACA;IACE,SAAS;IACT,WAAW;IACX,YAAY;IACZ,UAAU;EACZ;EACA;IACE,SAAS;IACT,WAAW;IACX,YAAY;IACZ,UAAU;EACZ;EACA;IACE,SAAS;IACT,WAAW;IACX,YAAY;IACZ,UAAU;EACZ;EACA;IACE,SAAS;IACT,WAAW;IACX,YAAY;IACZ,UAAU;EACZ;EACA;IACE,SAAS;IACT,WAAW;IACX,YAAY;IACZ,UAAU;EACZ;EACA;IACE,UAAU;IACV,YAAY;IACZ,aAAa;IACb,WAAW;EACb;EACA;IACE,UAAU;IACV,YAAY;IACZ,aAAa;IACb,WAAW;EACb;EACA;IACE,UAAU;IACV,YAAY;IACZ,aAAa;IACb,WAAW;EACb;EACA;IACE,UAAU;IACV,YAAY;IACZ,aAAa;IACb,WAAW;EACb;EACA;IACE,UAAU;IACV,YAAY;IACZ,aAAa;IACb,WAAW;EACb;EACA;IACE,UAAU;IACV,YAAY;IACZ,aAAa;IACb,WAAW;EACb;EACA;IACE,UAAU;IACV,YAAY;IACZ,aAAa;IACb,WAAW;EACb;EACA;IACE,UAAU;IACV,YAAY;IACZ,aAAa;IACb,WAAW;EACb;EACA;IACE,UAAU;IACV,YAAY;IACZ,aAAa;IACb,WAAW;EACb;EACA;IACE,UAAU;IACV,YAAY;IACZ,aAAa;IACb,WAAW;EACb;EACA;IACE,SAAS;IACT,WAAW;IACX,YAAY;IACZ,UAAU;EACZ;EACA;IACE,QAAQ;IACR,UAAU;IACV,WAAW;IACX,SAAS;EACX;EACA;IACE,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,cAAc;EAChB;EACA;IACE,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,cAAc;EAChB;EACA;IACE,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,cAAc;EAChB;EACA;IACE,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,cAAc;EAChB;EACA;IACE,QAAQ;IACR,UAAU;IACV,WAAW;IACX,SAAS;EACX;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;EAClB;EACA;IACE,QAAQ;IACR,UAAU;IACV,WAAW;IACX,SAAS;EACX;EACA;IACE,QAAQ;IACR,UAAU;IACV,WAAW;IACX,SAAS;EACX;EACA;IACE,QAAQ;IACR,UAAU;IACV,WAAW;IACX,SAAS;EACX;EACA;IACE,QAAQ;IACR,UAAU;IACV,WAAW;IACX,SAAS;EACX;EACA;IACE,QAAQ;IACR,UAAU;IACV,WAAW;IACX,SAAS;EACX;EACA;IACE,QAAQ;IACR,UAAU;IACV,WAAW;IACX,SAAS;EACX;EACA;IACE,QAAQ;IACR,UAAU;IACV,WAAW;IACX,SAAS;EACX;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;EAClB;EACA;IACE,QAAQ;IACR,UAAU;IACV,WAAW;IACX,SAAS;EACX;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;EAClB;EACA;IACE,cAAc;IACd,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;EACjB;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;EAClB;EACA;IACE,QAAQ;IACR,UAAU;IACV,WAAW;IACX,SAAS;EACX;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;EAClB;EACA;IACE,QAAQ;IACR,UAAU;IACV,WAAW;IACX,SAAS;EACX;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;EAClB;EACA;IACE,QAAQ;IACR,UAAU;IACV,WAAW;IACX,SAAS;EACX;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;EAClB;EACA;IACE,SAAS;IACT,WAAW;IACX,YAAY;IACZ,UAAU;EACZ;EACA;IACE,MAAM;IACN,SAAS;EACX;EACA;IACE,QAAQ;IACR,OAAO;EACT;EACA;IACE,YAAY;IACZ,eAAe;EACjB;EACA;IACE,cAAc;IACd,aAAa;EACf;EACA;IACE,WAAW;IACX,cAAc;EAChB;EACA;IACE,aAAa;IACb,YAAY;EACd;EACA;IACE,YAAY;IACZ,eAAe;EACjB;EACA;IACE,cAAc;IACd,aAAa;EACf;EACA;IACE,SAAS;IACT,YAAY;EACd;EACA;IACE,WAAW;IACX,UAAU;EACZ;EACA;IACE,YAAY;IACZ,eAAe;EACjB;EACA;IACE,cAAc;IACd,aAAa;EACf;EACA;IACE,WAAW;IACX,cAAc;EAChB;EACA;IACE,aAAa;IACb,YAAY;EACd;EACA;IACE,YAAY;IACZ,eAAe;EACjB;EACA;IACE,cAAc;IACd,aAAa;EACf;EACA;IACE,SAAS;IACT,YAAY;EACd;EACA;IACE,WAAW;IACX,UAAU;EACZ;EACA;IACE,YAAY;IACZ,eAAe;EACjB;EACA;IACE,cAAc;IACd,aAAa;EACf;EACA;IACE,WAAW;IACX,cAAc;EAChB;EACA;IACE,aAAa;IACb,YAAY;EACd;EACA;IACE,YAAY;IACZ,eAAe;EACjB;EACA;IACE,cAAc;IACd,aAAa;EACf;EACA;IACE,SAAS;IACT,YAAY;EACd;EACA;IACE,WAAW;IACX,UAAU;EACZ;EACA;IACE,YAAY;IACZ,eAAe;EACjB;EACA;IACE,cAAc;IACd,aAAa;EACf;EACA;IACE,WAAW;IACX,cAAc;EAChB;EACA;IACE,aAAa;IACb,YAAY;EACd;EACA;IACE,YAAY;IACZ,eAAe;EACjB;EACA;IACE,cAAc;IACd,aAAa;EACf;EACA;IACE,SAAS;IACT,YAAY;EACd;EACA;IACE,WAAW;IACX,UAAU;EACZ;EACA;IACE,SAAS;IACT,YAAY;EACd;EACA;IACE,WAAW;IACX,UAAU;EACZ;EACA;IACE,SAAS;IACT,YAAY;EACd;EACA;IACE,WAAW;IACX,UAAU;EACZ;EACA;IACE,SAAS;IACT,YAAY;EACd;EACA;IACE,WAAW;IACX,UAAU;EACZ;EACA;IACE,SAAS;IACT,YAAY;EACd;EACA;IACE,WAAW;IACX,UAAU;EACZ;EACA;IACE,SAAS;IACT,YAAY;EACd;EACA;IACE,WAAW;IACX,UAAU;EACZ;EACA;IACE,UAAU;IACV,aAAa;EACf;EACA;IACE,YAAY;IACZ,WAAW;EACb;EACA;IACE,UAAU;IACV,aAAa;EACf;EACA;IACE,YAAY;IACZ,WAAW;EACb;EACA;IACE,UAAU;IACV,aAAa;EACf;EACA;IACE,YAAY;IACZ,WAAW;EACb;EACA;IACE,UAAU;IACV,aAAa;EACf;EACA;IACE,YAAY;IACZ,WAAW;EACb;EACA;IACE,UAAU;IACV,aAAa;EACf;EACA;IACE,YAAY;IACZ,WAAW;EACb;EACA;IACE,UAAU;IACV,aAAa;EACf;EACA;IACE,YAAY;IACZ,WAAW;EACb;EACA;IACE,UAAU;IACV,aAAa;EACf;EACA;IACE,YAAY;IACZ,WAAW;EACb;EACA;IACE,UAAU;IACV,aAAa;EACf;EACA;IACE,YAAY;IACZ,WAAW;EACb;EACA;IACE,UAAU;IACV,aAAa;EACf;EACA;IACE,YAAY;IACZ,WAAW;EACb;EACA;IACE,UAAU;IACV,aAAa;EACf;EACA;IACE,YAAY;IACZ,WAAW;EACb;EACA;IACE,SAAS;IACT,YAAY;EACd;EACA;IACE,WAAW;IACX,UAAU;EACZ;EACA;IACE,QAAQ;IACR,WAAW;EACb;EACA;IACE,UAAU;IACV,SAAS;EACX;EACA;IACE,aAAa;IACb,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,cAAc;EAChB;EACA;IACE,aAAa;IACb,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,cAAc;EAChB;EACA;IACE,aAAa;IACb,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,cAAc;EAChB;EACA;IACE,aAAa;IACb,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,cAAc;EAChB;EACA;IACE,QAAQ;IACR,WAAW;EACb;EACA;IACE,UAAU;IACV,SAAS;EACX;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;EACA;IACE,QAAQ;IACR,WAAW;EACb;EACA;IACE,UAAU;IACV,SAAS;EACX;EACA;IACE,QAAQ;IACR,WAAW;EACb;EACA;IACE,UAAU;IACV,SAAS;EACX;EACA;IACE,QAAQ;IACR,WAAW;EACb;EACA;IACE,UAAU;IACV,SAAS;EACX;EACA;IACE,QAAQ;IACR,WAAW;EACb;EACA;IACE,UAAU;IACV,SAAS;EACX;EACA;IACE,QAAQ;IACR,WAAW;EACb;EACA;IACE,UAAU;IACV,SAAS;EACX;EACA;IACE,QAAQ;IACR,WAAW;EACb;EACA;IACE,UAAU;IACV,SAAS;EACX;EACA;IACE,QAAQ;IACR,WAAW;EACb;EACA;IACE,UAAU;IACV,SAAS;EACX;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;EACA;IACE,QAAQ;IACR,WAAW;EACb;EACA;IACE,UAAU;IACV,SAAS;EACX;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;EACA;IACE,cAAc;IACd,iBAAiB;EACnB;EACA;IACE,gBAAgB;IAChB,eAAe;EACjB;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;EACA;IACE,QAAQ;IACR,WAAW;EACb;EACA;IACE,UAAU;IACV,SAAS;EACX;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;EACA;IACE,QAAQ;IACR,WAAW;EACb;EACA;IACE,UAAU;IACV,SAAS;EACX;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;EACA;IACE,QAAQ;IACR,WAAW;EACb;EACA;IACE,UAAU;IACV,SAAS;EACX;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;EACA;IACE,SAAS;IACT,YAAY;EACd;EACA;IACE,WAAW;IACX,UAAU;EACZ;EACA;IACE,MAAM;EACR;EACA;IACE,QAAQ;EACV;EACA;IACE,SAAS;EACX;EACA;IACE,OAAO;EACT;EACA;IACE,YAAY;EACd;EACA;IACE,cAAc;EAChB;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;EACf;EACA;IACE,WAAW;EACb;EACA;IACE,aAAa;EACf;EACA;IACE,cAAc;EAChB;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,cAAc;EAChB;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;EACf;EACA;IACE,SAAS;EACX;EACA;IACE,WAAW;EACb;EACA;IACE,YAAY;EACd;EACA;IACE,UAAU;EACZ;EACA;IACE,YAAY;EACd;EACA;IACE,cAAc;EAChB;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;EACf;EACA;IACE,WAAW;EACb;EACA;IACE,aAAa;EACf;EACA;IACE,cAAc;EAChB;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,cAAc;EAChB;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;EACf;EACA;IACE,SAAS;EACX;EACA;IACE,WAAW;EACb;EACA;IACE,YAAY;EACd;EACA;IACE,UAAU;EACZ;EACA;IACE,YAAY;EACd;EACA;IACE,cAAc;EAChB;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;EACf;EACA;IACE,WAAW;EACb;EACA;IACE,aAAa;EACf;EACA;IACE,cAAc;EAChB;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,cAAc;EAChB;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;EACf;EACA;IACE,SAAS;EACX;EACA;IACE,WAAW;EACb;EACA;IACE,YAAY;EACd;EACA;IACE,UAAU;EACZ;EACA;IACE,YAAY;EACd;EACA;IACE,cAAc;EAChB;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;EACf;EACA;IACE,WAAW;EACb;EACA;IACE,aAAa;EACf;EACA;IACE,cAAc;EAChB;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,cAAc;EAChB;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;EACf;EACA;IACE,SAAS;EACX;EACA;IACE,WAAW;EACb;EACA;IACE,YAAY;EACd;EACA;IACE,UAAU;EACZ;EACA;IACE,SAAS;EACX;EACA;IACE,WAAW;EACb;EACA;IACE,YAAY;EACd;EACA;IACE,UAAU;EACZ;EACA;IACE,SAAS;EACX;EACA;IACE,WAAW;EACb;EACA;IACE,YAAY;EACd;EACA;IACE,UAAU;EACZ;EACA;IACE,SAAS;EACX;EACA;IACE,WAAW;EACb;EACA;IACE,YAAY;EACd;EACA;IACE,UAAU;EACZ;EACA;IACE,SAAS;EACX;EACA;IACE,WAAW;EACb;EACA;IACE,YAAY;EACd;EACA;IACE,UAAU;EACZ;EACA;IACE,SAAS;EACX;EACA;IACE,WAAW;EACb;EACA;IACE,YAAY;EACd;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,YAAY;EACd;EACA;IACE,aAAa;EACf;EACA;IACE,WAAW;EACb;EACA;IACE,UAAU;EACZ;EACA;IACE,YAAY;EACd;EACA;IACE,aAAa;EACf;EACA;IACE,WAAW;EACb;EACA;IACE,UAAU;EACZ;EACA;IACE,YAAY;EACd;EACA;IACE,aAAa;EACf;EACA;IACE,WAAW;EACb;EACA;IACE,UAAU;EACZ;EACA;IACE,YAAY;EACd;EACA;IACE,aAAa;EACf;EACA;IACE,WAAW;EACb;EACA;IACE,UAAU;EACZ;EACA;IACE,YAAY;EACd;EACA;IACE,aAAa;EACf;EACA;IACE,WAAW;EACb;EACA;IACE,UAAU;EACZ;EACA;IACE,YAAY;EACd;EACA;IACE,aAAa;EACf;EACA;IACE,WAAW;EACb;EACA;IACE,UAAU;EACZ;EACA;IACE,YAAY;EACd;EACA;IACE,aAAa;EACf;EACA;IACE,WAAW;EACb;EACA;IACE,UAAU;EACZ;EACA;IACE,YAAY;EACd;EACA;IACE,aAAa;EACf;EACA;IACE,WAAW;EACb;EACA;IACE,UAAU;EACZ;EACA;IACE,YAAY;EACd;EACA;IACE,aAAa;EACf;EACA;IACE,WAAW;EACb;EACA;IACE,UAAU;EACZ;EACA;IACE,YAAY;EACd;EACA;IACE,aAAa;EACf;EACA;IACE,WAAW;EACb;EACA;IACE,SAAS;EACX;EACA;IACE,WAAW;EACb;EACA;IACE,YAAY;EACd;EACA;IACE,UAAU;EACZ;EACA;IACE,QAAQ;EACV;EACA;IACE,UAAU;EACZ;EACA;IACE,WAAW;EACb;EACA;IACE,SAAS;EACX;EACA;IACE,aAAa;EACf;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,cAAc;EAChB;EACA;IACE,aAAa;EACf;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,cAAc;EAChB;EACA;IACE,aAAa;EACf;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,cAAc;EAChB;EACA;IACE,aAAa;EACf;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,cAAc;EAChB;EACA;IACE,QAAQ;EACV;EACA;IACE,UAAU;EACZ;EACA;IACE,WAAW;EACb;EACA;IACE,SAAS;EACX;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,QAAQ;EACV;EACA;IACE,UAAU;EACZ;EACA;IACE,WAAW;EACb;EACA;IACE,SAAS;EACX;EACA;IACE,QAAQ;EACV;EACA;IACE,UAAU;EACZ;EACA;IACE,WAAW;EACb;EACA;IACE,SAAS;EACX;EACA;IACE,QAAQ;EACV;EACA;IACE,UAAU;EACZ;EACA;IACE,WAAW;EACb;EACA;IACE,SAAS;EACX;EACA;IACE,QAAQ;EACV;EACA;IACE,UAAU;EACZ;EACA;IACE,WAAW;EACb;EACA;IACE,SAAS;EACX;EACA;IACE,QAAQ;EACV;EACA;IACE,UAAU;EACZ;EACA;IACE,WAAW;EACb;EACA;IACE,SAAS;EACX;EACA;IACE,QAAQ;EACV;EACA;IACE,UAAU;EACZ;EACA;IACE,WAAW;EACb;EACA;IACE,SAAS;EACX;EACA;IACE,QAAQ;EACV;EACA;IACE,UAAU;EACZ;EACA;IACE,WAAW;EACb;EACA;IACE,SAAS;EACX;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,QAAQ;EACV;EACA;IACE,UAAU;EACZ;EACA;IACE,WAAW;EACb;EACA;IACE,SAAS;EACX;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,cAAc;EAChB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,QAAQ;EACV;EACA;IACE,UAAU;EACZ;EACA;IACE,WAAW;EACb;EACA;IACE,SAAS;EACX;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,QAAQ;EACV;EACA;IACE,UAAU;EACZ;EACA;IACE,WAAW;EACb;EACA;IACE,SAAS;EACX;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,QAAQ;EACV;EACA;IACE,UAAU;EACZ;EACA;IACE,WAAW;EACb;EACA;IACE,SAAS;EACX;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,SAAS;EACX;EACA;IACE,WAAW;EACb;EACA;IACE,YAAY;EACd;EACA;IACE,UAAU;EACZ;EACA;IACE,YAAY;EACd;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,YAAY;EACd;EACA;IACE,yCAAyC;EAC3C;EACA;IACE,2CAA2C;EAC7C;EACA;IACE,2EAA2E;EAC7E;EACA;IACE,iFAAiF;EACnF;EACA;IACE,mFAAmF;EACrF;EACA;IACE,qFAAqF;EACvF;EACA;IACE,iDAAiD;EACnD;EACA;IACE,iDAAiD;EACnD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kCAAkC;EACpC;EACA;IACE,+CAA+C;EACjD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,8CAA8C;EAChD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,yCAAyC;EAC3C;EACA;IACE,2CAA2C;EAC7C;EACA;IACE,2EAA2E;EAC7E;EACA;IACE,iFAAiF;EACnF;EACA;IACE,mFAAmF;EACrF;EACA;IACE,qFAAqF;EACvF;EACA;IACE,iDAAiD;EACnD;EACA;IACE,iDAAiD;EACnD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kCAAkC;EACpC;EACA;IACE,+CAA+C;EACjD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,8CAA8C;EAChD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,yCAAyC;EAC3C;EACA;IACE,2CAA2C;EAC7C;EACA;IACE,2EAA2E;EAC7E;EACA;IACE,iFAAiF;EACnF;EACA;IACE,mFAAmF;EACrF;EACA;IACE,qFAAqF;EACvF;EACA;IACE,iDAAiD;EACnD;EACA;IACE,iDAAiD;EACnD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kCAAkC;EACpC;EACA;IACE,+CAA+C;EACjD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,8CAA8C;EAChD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,yCAAyC;EAC3C;EACA;IACE,2CAA2C;EAC7C;EACA;IACE,2EAA2E;EAC7E;EACA;IACE,iFAAiF;EACnF;EACA;IACE,mFAAmF;EACrF;EACA;IACE,qFAAqF;EACvF;EACA;IACE,iDAAiD;EACnD;EACA;IACE,iDAAiD;EACnD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kCAAkC;EACpC;EACA;IACE,+CAA+C;EACjD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,8CAA8C;EAChD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,yCAAyC;EAC3C;EACA;IACE,2CAA2C;EAC7C;EACA;IACE,2EAA2E;EAC7E;EACA;IACE,iFAAiF;EACnF;EACA;IACE,mFAAmF;EACrF;EACA;IACE,qFAAqF;EACvF;EACA;IACE,iDAAiD;EACnD;EACA;IACE,iDAAiD;EACnD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kCAAkC;EACpC;EACA;IACE,+CAA+C;EACjD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,8CAA8C;EAChD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,kBAAkB;EACpB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,yCAAyC;EAC3C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,2CAA2C;EAC7C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,2CAA2C;EAC7C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,2CAA2C;EAC7C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,2CAA2C;EAC7C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,yCAAyC;EAC3C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,2CAA2C;EAC7C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,2CAA2C;EAC7C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,2CAA2C;EAC7C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,2CAA2C;EAC7C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,yCAAyC;EAC3C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,2CAA2C;EAC7C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,2CAA2C;EAC7C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,2CAA2C;EAC7C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,2CAA2C;EAC7C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,yCAAyC;EAC3C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,2CAA2C;EAC7C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,2CAA2C;EAC7C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,2CAA2C;EAC7C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,2CAA2C;EAC7C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,yCAAyC;EAC3C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,2CAA2C;EAC7C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,2CAA2C;EAC7C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,2CAA2C;EAC7C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,2CAA2C;EAC7C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,yCAAyC;EAC3C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,2CAA2C;EAC7C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,2CAA2C;EAC7C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,2CAA2C;EAC7C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,2CAA2C;EAC7C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,yCAAyC;EAC3C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,2CAA2C;EAC7C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,2CAA2C;EAC7C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,2CAA2C;EAC7C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,2CAA2C;EAC7C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;EACnB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,oBAAoB;EACtB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mCAAmC;IACnC,kCAAkC;EACpC;EACA;IACE,4BAA4B;IAC5B,6BAA6B;EAC/B;EACA;IACE;;;OAGG;IACH;;;OAGG;IACH;;;OAGG;IACH;;;OAGG;IACH;;;OAGG;IACH,8MAA8M;EAChN;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,uCAAuC;EACzC;EACA;IACE,iDAAiD;EACnD;EACA;IACE,0CAA0C;EAC5C;EACA;IACE,4CAA4C;EAC9C;EACA;IACE,iDAAiD;EACnD;EACA;IACE,4CAA4C;EAC9C;EACA;IACE,mDAAmD;EACrD;EACA;IACE,kDAAkD;EACpD;EACA;IACE,uBAAuB;EACzB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,iBAAiB;EACnB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,yBAAyB;IAEzB,iBAAiB;EACnB;EACA;IACE,yBAAyB;IAEzB,iBAAiB;EACnB;EACA;IACE,wBAAwB;IAExB,gBAAgB;EAClB;EACA;IACE,yBAAyB;IAEzB,iBAAiB;EACnB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,mBAAmB;EACrB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,iBAAiB;IACjB,qBAAqB;IACrB,kBAAkB;EACpB;EACA;IACE,qBAAqB;IACrB,yBAAyB;EAC3B;EACA;IACE,qBAAqB;EACvB;EACA;IACE,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;EACrB;EACA;IACE,QAAQ;EACV;EACA;IACE,cAAc;EAChB;EACA;IACE,aAAa;EACf;EACA;IACE,cAAc;EAChB;EACA;IACE,WAAW;EACb;EACA;IACE,cAAc;EAChB;EACA;IACE,aAAa;EACf;EACA;IACE,cAAc;EAChB;EACA;IACE,WAAW;EACb;EACA;IACE,cAAc;EAChB;EACA;IACE,aAAa;EACf;EACA;IACE,cAAc;EAChB;EACA;IACE,WAAW;EACb;EACA;IACE,cAAc;EAChB;EACA;IACE,aAAa;EACf;EACA;IACE,cAAc;EAChB;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,WAAW;EACb;EACA;IACE,UAAU;EACZ;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,UAAU;EACZ;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,UAAU;EACZ;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,UAAU;EACZ;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,UAAU;EACZ;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,UAAU;EACZ;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,WAAW;EACb;EACA;IACE,YAAY;EACd;EACA;IAEE,kBAAkB;EACpB;EACA;IAEE,kBAAkB;EACpB;EACA;IACE,UAAU;EACZ;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,aAAa;EACf;EACA;IACE,UAAU;EACZ;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,aAAa;EACf;EACA;IACE,UAAU;EACZ;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,aAAa;EACf;EACA;IACE,WAAW;IACX,MAAM;EACR;EACA;IACE,iBAAiB;IACjB,YAAY;EACd;EACA;IACE,gBAAgB;IAChB,WAAW;EACb;EACA;IACE,iBAAiB;IACjB,YAAY;EACd;EACA;IACE,cAAc;IACd,SAAS;EACX;EACA;IACE,iBAAiB;IACjB,YAAY;EACd;EACA;IACE,gBAAgB;IAChB,WAAW;EACb;EACA;IACE,iBAAiB;IACjB,YAAY;EACd;EACA;IACE,cAAc;IACd,SAAS;EACX;EACA;IACE,iBAAiB;IACjB,YAAY;EACd;EACA;IACE,gBAAgB;IAChB,WAAW;EACb;EACA;IACE,iBAAiB;IACjB,YAAY;EACd;EACA;IACE,cAAc;IACd,SAAS;EACX;EACA;IACE,iBAAiB;IACjB,YAAY;EACd;EACA;IACE,gBAAgB;IAChB,WAAW;EACb;EACA;IACE,iBAAiB;IACjB,YAAY;EACd;EACA;IACE,cAAc;IACd,SAAS;EACX;EACA;IACE,cAAc;IACd,SAAS;EACX;EACA;IACE,cAAc;IACd,SAAS;EACX;EACA;IACE,cAAc;IACd,SAAS;EACX;EACA;IACE,cAAc;IACd,SAAS;EACX;EACA;IACE,cAAc;IACd,SAAS;EACX;EACA;IACE,eAAe;IACf,UAAU;EACZ;EACA;IACE,eAAe;IACf,UAAU;EACZ;EACA;IACE,eAAe;IACf,UAAU;EACZ;EACA;IACE,eAAe;IACf,UAAU;EACZ;EACA;IACE,eAAe;IACf,UAAU;EACZ;EACA;IACE,eAAe;IACf,UAAU;EACZ;EACA;IACE,eAAe;IACf,UAAU;EACZ;EACA;IACE,eAAe;IACf,UAAU;EACZ;EACA;IACE,eAAe;IACf,UAAU;EACZ;EACA;IACE,eAAe;IACf,UAAU;EACZ;EACA;IACE,aAAa;IACb,QAAQ;EACV;EACA;IACE,kBAAkB;IAClB,aAAa;EACf;EACA;IACE,kBAAkB;IAClB,aAAa;EACf;EACA;IACE,kBAAkB;IAClB,aAAa;EACf;EACA;IACE,kBAAkB;IAClB,aAAa;EACf;EACA;IACE,aAAa;IACb,QAAQ;EACV;EACA;IACE,oBAAoB;IACpB,eAAe;EACjB;EACA;IACE,oBAAoB;IACpB,eAAe;EACjB;EACA;IACE,aAAa;IACb,QAAQ;EACV;EACA;IACE,aAAa;IACb,QAAQ;EACV;EACA;IACE,aAAa;IACb,QAAQ;EACV;EACA;IACE,aAAa;IACb,QAAQ;EACV;EACA;IACE,aAAa;IACb,QAAQ;EACV;EACA;IACE,aAAa;IACb,QAAQ;EACV;EACA;IACE,aAAa;IACb,QAAQ;EACV;EACA;IACE,oBAAoB;IACpB,eAAe;EACjB;EACA;IACE,oBAAoB;IACpB,eAAe;EACjB;EACA;IACE,aAAa;IACb,QAAQ;EACV;EACA;IACE,oBAAoB;IACpB,eAAe;EACjB;EACA;IACE,oBAAoB;IACpB,eAAe;EACjB;EACA;IACE,mBAAmB;IACnB,cAAc;EAChB;EACA;IACE,oBAAoB;IACpB,eAAe;EACjB;EACA;IACE,aAAa;IACb,QAAQ;EACV;EACA;IACE,oBAAoB;IACpB,eAAe;EACjB;EACA;IACE,oBAAoB;IACpB,eAAe;EACjB;EACA;IACE,aAAa;IACb,QAAQ;EACV;EACA;IACE,oBAAoB;IACpB,eAAe;EACjB;EACA;IACE,oBAAoB;IACpB,eAAe;EACjB;EACA;IACE,aAAa;IACb,QAAQ;EACV;EACA;IACE,oBAAoB;IACpB,eAAe;EACjB;EACA;IACE,oBAAoB;IACpB,eAAe;EACjB;EACA;IACE,cAAc;IACd,SAAS;EACX;EACA;IACE,kBAAkB;IAElB,aAAa;EACf;EACA;IACE,wBAAwB;IAExB,mBAAmB;EACrB;EACA;IACE,uBAAuB;IAEvB,kBAAkB;EACpB;EACA;IACE,wBAAwB;IAExB,mBAAmB;EACrB;EACA;IACE,qBAAqB;IAErB,gBAAgB;EAClB;EACA;IACE,wBAAwB;IAExB,mBAAmB;EACrB;EACA;IACE,uBAAuB;IAEvB,kBAAkB;EACpB;EACA;IACE,wBAAwB;IAExB,mBAAmB;EACrB;EACA;IACE,qBAAqB;IAErB,gBAAgB;EAClB;EACA;IACE,wBAAwB;IAExB,mBAAmB;EACrB;EACA;IACE,uBAAuB;IAEvB,kBAAkB;EACpB;EACA;IACE,wBAAwB;IAExB,mBAAmB;EACrB;EACA;IACE,qBAAqB;IAErB,gBAAgB;EAClB;EACA;IACE,wBAAwB;IAExB,mBAAmB;EACrB;EACA;IACE,uBAAuB;IAEvB,kBAAkB;EACpB;EACA;IACE,wBAAwB;IAExB,mBAAmB;EACrB;EACA;IACE,qBAAqB;IAErB,gBAAgB;EAClB;EACA;IACE,qBAAqB;IAErB,gBAAgB;EAClB;EACA;IACE,qBAAqB;IAErB,gBAAgB;EAClB;EACA;IACE,qBAAqB;IAErB,gBAAgB;EAClB;EACA;IACE,qBAAqB;IAErB,gBAAgB;EAClB;EACA;IACE,qBAAqB;IAErB,gBAAgB;EAClB;EACA;IACE,sBAAsB;IAEtB,iBAAiB;EACnB;EACA;IACE,sBAAsB;IAEtB,iBAAiB;EACnB;EACA;IACE,sBAAsB;IAEtB,iBAAiB;EACnB;EACA;IACE,sBAAsB;IAEtB,iBAAiB;EACnB;EACA;IACE,sBAAsB;IAEtB,iBAAiB;EACnB;EACA;IACE,sBAAsB;IAEtB,iBAAiB;EACnB;EACA;IACE,sBAAsB;IAEtB,iBAAiB;EACnB;EACA;IACE,sBAAsB;IAEtB,iBAAiB;EACnB;EACA;IACE,sBAAsB;IAEtB,iBAAiB;EACnB;EACA;IACE,sBAAsB;IAEtB,iBAAiB;EACnB;EACA;IACE,oBAAoB;IAEpB,eAAe;EACjB;EACA;IACE,yBAAyB;IAEzB,oBAAoB;EACtB;EACA;IACE,yBAAyB;IAEzB,oBAAoB;EACtB;EACA;IACE,yBAAyB;IAEzB,oBAAoB;EACtB;EACA;IACE,yBAAyB;IAEzB,oBAAoB;EACtB;EACA;IACE,oBAAoB;IAEpB,eAAe;EACjB;EACA;IACE,2BAA2B;IAE3B,sBAAsB;EACxB;EACA;IACE,2BAA2B;IAE3B,sBAAsB;EACxB;EACA;IACE,oBAAoB;IAEpB,eAAe;EACjB;EACA;IACE,oBAAoB;IAEpB,eAAe;EACjB;EACA;IACE,oBAAoB;IAEpB,eAAe;EACjB;EACA;IACE,oBAAoB;IAEpB,eAAe;EACjB;EACA;IACE,oBAAoB;IAEpB,eAAe;EACjB;EACA;IACE,oBAAoB;IAEpB,eAAe;EACjB;EACA;IACE,oBAAoB;IAEpB,eAAe;EACjB;EACA;IACE,2BAA2B;IAE3B,sBAAsB;EACxB;EACA;IACE,2BAA2B;IAE3B,sBAAsB;EACxB;EACA;IACE,oBAAoB;IAEpB,eAAe;EACjB;EACA;IACE,2BAA2B;IAE3B,sBAAsB;EACxB;EACA;IACE,2BAA2B;IAE3B,sBAAsB;EACxB;EACA;IACE,0BAA0B;IAE1B,qBAAqB;EACvB;EACA;IACE,2BAA2B;IAE3B,sBAAsB;EACxB;EACA;IACE,oBAAoB;IAEpB,eAAe;EACjB;EACA;IACE,2BAA2B;IAE3B,sBAAsB;EACxB;EACA;IACE,2BAA2B;IAE3B,sBAAsB;EACxB;EACA;IACE,oBAAoB;IAEpB,eAAe;EACjB;EACA;IACE,2BAA2B;IAE3B,sBAAsB;EACxB;EACA;IACE,2BAA2B;IAE3B,sBAAsB;EACxB;EACA;IACE,oBAAoB;IAEpB,eAAe;EACjB;EACA;IACE,2BAA2B;IAE3B,sBAAsB;EACxB;EACA;IACE,2BAA2B;IAE3B,sBAAsB;EACxB;EACA;IACE,qBAAqB;IAErB,gBAAgB;EAClB;EACA;IACE,kBAAkB;IAElB,aAAa;EACf;EACA;IACE,wBAAwB;IAExB,mBAAmB;EACrB;EACA;IACE,uBAAuB;IAEvB,kBAAkB;EACpB;EACA;IACE,wBAAwB;IAExB,mBAAmB;EACrB;EACA;IACE,qBAAqB;IAErB,gBAAgB;EAClB;EACA;IACE,wBAAwB;IAExB,mBAAmB;EACrB;EACA;IACE,uBAAuB;IAEvB,kBAAkB;EACpB;EACA;IACE,wBAAwB;IAExB,mBAAmB;EACrB;EACA;IACE,qBAAqB;IAErB,gBAAgB;EAClB;EACA;IACE,wBAAwB;IAExB,mBAAmB;EACrB;EACA;IACE,uBAAuB;IAEvB,kBAAkB;EACpB;EACA;IACE,wBAAwB;IAExB,mBAAmB;EACrB;EACA;IACE,qBAAqB;IAErB,gBAAgB;EAClB;EACA;IACE,wBAAwB;IAExB,mBAAmB;EACrB;EACA;IACE,uBAAuB;IAEvB,kBAAkB;EACpB;EACA;IACE,wBAAwB;IAExB,mBAAmB;EACrB;EACA;IACE,qBAAqB;IAErB,gBAAgB;EAClB;EACA;IACE,qBAAqB;IAErB,gBAAgB;EAClB;EACA;IACE,qBAAqB;IAErB,gBAAgB;EAClB;EACA;IACE,qBAAqB;IAErB,gBAAgB;EAClB;EACA;IACE,qBAAqB;IAErB,gBAAgB;EAClB;EACA;IACE,qBAAqB;IAErB,gBAAgB;EAClB;EACA;IACE,sBAAsB;IAEtB,iBAAiB;EACnB;EACA;IACE,sBAAsB;IAEtB,iBAAiB;EACnB;EACA;IACE,sBAAsB;IAEtB,iBAAiB;EACnB;EACA;IACE,sBAAsB;IAEtB,iBAAiB;EACnB;EACA;IACE,sBAAsB;IAEtB,iBAAiB;EACnB;EACA;IACE,sBAAsB;IAEtB,iBAAiB;EACnB;EACA;IACE,sBAAsB;IAEtB,iBAAiB;EACnB;EACA;IACE,sBAAsB;IAEtB,iBAAiB;EACnB;EACA;IACE,sBAAsB;IAEtB,iBAAiB;EACnB;EACA;IACE,sBAAsB;IAEtB,iBAAiB;EACnB;EACA;IACE,oBAAoB;IAEpB,eAAe;EACjB;EACA;IACE,yBAAyB;IAEzB,oBAAoB;EACtB;EACA;IACE,yBAAyB;IAEzB,oBAAoB;EACtB;EACA;IACE,yBAAyB;IAEzB,oBAAoB;EACtB;EACA;IACE,yBAAyB;IAEzB,oBAAoB;EACtB;EACA;IACE,oBAAoB;IAEpB,eAAe;EACjB;EACA;IACE,2BAA2B;IAE3B,sBAAsB;EACxB;EACA;IACE,2BAA2B;IAE3B,sBAAsB;EACxB;EACA;IACE,oBAAoB;IAEpB,eAAe;EACjB;EACA;IACE,oBAAoB;IAEpB,eAAe;EACjB;EACA;IACE,oBAAoB;IAEpB,eAAe;EACjB;EACA;IACE,oBAAoB;IAEpB,eAAe;EACjB;EACA;IACE,oBAAoB;IAEpB,eAAe;EACjB;EACA;IACE,oBAAoB;IAEpB,eAAe;EACjB;EACA;IACE,oBAAoB;IAEpB,eAAe;EACjB;EACA;IACE,2BAA2B;IAE3B,sBAAsB;EACxB;EACA;IACE,2BAA2B;IAE3B,sBAAsB;EACxB;EACA;IACE,oBAAoB;IAEpB,eAAe;EACjB;EACA;IACE,2BAA2B;IAE3B,sBAAsB;EACxB;EACA;IACE,2BAA2B;IAE3B,sBAAsB;EACxB;EACA;IACE,0BAA0B;IAE1B,qBAAqB;EACvB;EACA;IACE,2BAA2B;IAE3B,sBAAsB;EACxB;EACA;IACE,oBAAoB;IAEpB,eAAe;EACjB;EACA;IACE,2BAA2B;IAE3B,sBAAsB;EACxB;EACA;IACE,2BAA2B;IAE3B,sBAAsB;EACxB;EACA;IACE,oBAAoB;IAEpB,eAAe;EACjB;EACA;IACE,2BAA2B;IAE3B,sBAAsB;EACxB;EACA;IACE,2BAA2B;IAE3B,sBAAsB;EACxB;EACA;IACE,oBAAoB;IAEpB,eAAe;EACjB;EACA;IACE,2BAA2B;IAE3B,sBAAsB;EACxB;EACA;IACE,2BAA2B;IAE3B,sBAAsB;EACxB;EACA;IACE,qBAAqB;IAErB,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,UAAU;EACZ;EACA;IACE,qBAAqB;IACrB,gBAAgB;EAClB;EACA;IACE,oBAAoB;IACpB,eAAe;EACjB;EACA;IACE,qBAAqB;IACrB,gBAAgB;EAClB;EACA;IACE,kBAAkB;IAClB,aAAa;EACf;EACA;IACE,qBAAqB;IACrB,gBAAgB;EAClB;EACA;IACE,oBAAoB;IACpB,eAAe;EACjB;EACA;IACE,qBAAqB;IACrB,gBAAgB;EAClB;EACA;IACE,kBAAkB;IAClB,aAAa;EACf;EACA;IACE,qBAAqB;IACrB,gBAAgB;EAClB;EACA;IACE,oBAAoB;IACpB,eAAe;EACjB;EACA;IACE,qBAAqB;IACrB,gBAAgB;EAClB;EACA;IACE,kBAAkB;IAClB,aAAa;EACf;EACA;IACE,qBAAqB;IACrB,gBAAgB;EAClB;EACA;IACE,oBAAoB;IACpB,eAAe;EACjB;EACA;IACE,qBAAqB;IACrB,gBAAgB;EAClB;EACA;IACE,kBAAkB;IAClB,aAAa;EACf;EACA;IACE,kBAAkB;IAClB,aAAa;EACf;EACA;IACE,kBAAkB;IAClB,aAAa;EACf;EACA;IACE,kBAAkB;IAClB,aAAa;EACf;EACA;IACE,kBAAkB;IAClB,aAAa;EACf;EACA;IACE,kBAAkB;IAClB,aAAa;EACf;EACA;IACE,mBAAmB;IACnB,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,cAAc;EAChB;EACA;IACE,iBAAiB;IACjB,YAAY;EACd;EACA;IACE,sBAAsB;IACtB,iBAAiB;EACnB;EACA;IACE,sBAAsB;IACtB,iBAAiB;EACnB;EACA;IACE,sBAAsB;IACtB,iBAAiB;EACnB;EACA;IACE,sBAAsB;IACtB,iBAAiB;EACnB;EACA;IACE,iBAAiB;IACjB,YAAY;EACd;EACA;IACE,wBAAwB;IACxB,mBAAmB;EACrB;EACA;IACE,wBAAwB;IACxB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,YAAY;EACd;EACA;IACE,iBAAiB;IACjB,YAAY;EACd;EACA;IACE,iBAAiB;IACjB,YAAY;EACd;EACA;IACE,iBAAiB;IACjB,YAAY;EACd;EACA;IACE,iBAAiB;IACjB,YAAY;EACd;EACA;IACE,iBAAiB;IACjB,YAAY;EACd;EACA;IACE,iBAAiB;IACjB,YAAY;EACd;EACA;IACE,wBAAwB;IACxB,mBAAmB;EACrB;EACA;IACE,wBAAwB;IACxB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,YAAY;EACd;EACA;IACE,wBAAwB;IACxB,mBAAmB;EACrB;EACA;IACE,wBAAwB;IACxB,mBAAmB;EACrB;EACA;IACE,uBAAuB;IACvB,kBAAkB;EACpB;EACA;IACE,wBAAwB;IACxB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,YAAY;EACd;EACA;IACE,wBAAwB;IACxB,mBAAmB;EACrB;EACA;IACE,wBAAwB;IACxB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,YAAY;EACd;EACA;IACE,wBAAwB;IACxB,mBAAmB;EACrB;EACA;IACE,wBAAwB;IACxB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,YAAY;EACd;EACA;IACE,wBAAwB;IACxB,mBAAmB;EACrB;EACA;IACE,wBAAwB;IACxB,mBAAmB;EACrB;EACA;IACE,kBAAkB;IAClB,aAAa;EACf;EACA;IACE,eAAe;IACf,UAAU;EACZ;EACA;IACE,qBAAqB;IACrB,gBAAgB;EAClB;EACA;IACE,oBAAoB;IACpB,eAAe;EACjB;EACA;IACE,qBAAqB;IACrB,gBAAgB;EAClB;EACA;IACE,kBAAkB;IAClB,aAAa;EACf;EACA;IACE,qBAAqB;IACrB,gBAAgB;EAClB;EACA;IACE,oBAAoB;IACpB,eAAe;EACjB;EACA;IACE,qBAAqB;IACrB,gBAAgB;EAClB;EACA;IACE,kBAAkB;IAClB,aAAa;EACf;EACA;IACE,qBAAqB;IACrB,gBAAgB;EAClB;EACA;IACE,oBAAoB;IACpB,eAAe;EACjB;EACA;IACE,qBAAqB;IACrB,gBAAgB;EAClB;EACA;IACE,kBAAkB;IAClB,aAAa;EACf;EACA;IACE,qBAAqB;IACrB,gBAAgB;EAClB;EACA;IACE,oBAAoB;IACpB,eAAe;EACjB;EACA;IACE,qBAAqB;IACrB,gBAAgB;EAClB;EACA;IACE,kBAAkB;IAClB,aAAa;EACf;EACA;IACE,kBAAkB;IAClB,aAAa;EACf;EACA;IACE,kBAAkB;IAClB,aAAa;EACf;EACA;IACE,kBAAkB;IAClB,aAAa;EACf;EACA;IACE,kBAAkB;IAClB,aAAa;EACf;EACA;IACE,kBAAkB;IAClB,aAAa;EACf;EACA;IACE,mBAAmB;IACnB,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,cAAc;EAChB;EACA;IACE,iBAAiB;IACjB,YAAY;EACd;EACA;IACE,sBAAsB;IACtB,iBAAiB;EACnB;EACA;IACE,sBAAsB;IACtB,iBAAiB;EACnB;EACA;IACE,sBAAsB;IACtB,iBAAiB;EACnB;EACA;IACE,sBAAsB;IACtB,iBAAiB;EACnB;EACA;IACE,iBAAiB;IACjB,YAAY;EACd;EACA;IACE,wBAAwB;IACxB,mBAAmB;EACrB;EACA;IACE,wBAAwB;IACxB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,YAAY;EACd;EACA;IACE,iBAAiB;IACjB,YAAY;EACd;EACA;IACE,iBAAiB;IACjB,YAAY;EACd;EACA;IACE,iBAAiB;IACjB,YAAY;EACd;EACA;IACE,iBAAiB;IACjB,YAAY;EACd;EACA;IACE,iBAAiB;IACjB,YAAY;EACd;EACA;IACE,iBAAiB;IACjB,YAAY;EACd;EACA;IACE,wBAAwB;IACxB,mBAAmB;EACrB;EACA;IACE,wBAAwB;IACxB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,YAAY;EACd;EACA;IACE,wBAAwB;IACxB,mBAAmB;EACrB;EACA;IACE,wBAAwB;IACxB,mBAAmB;EACrB;EACA;IACE,uBAAuB;IACvB,kBAAkB;EACpB;EACA;IACE,wBAAwB;IACxB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,YAAY;EACd;EACA;IACE,wBAAwB;IACxB,mBAAmB;EACrB;EACA;IACE,wBAAwB;IACxB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,YAAY;EACd;EACA;IACE,wBAAwB;IACxB,mBAAmB;EACrB;EACA;IACE,wBAAwB;IACxB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,YAAY;EACd;EACA;IACE,wBAAwB;IACxB,mBAAmB;EACrB;EACA;IACE,wBAAwB;IACxB,mBAAmB;EACrB;EACA;IACE,kBAAkB;IAClB,aAAa;EACf;EACA;IACE,mBAAmB;EACrB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,gDAAgD;EAClD;EACA;IACE,gDAAgD;EAClD;EACA;IACE,gDAAgD;EAClD;EACA;IACE,gDAAgD;EAClD;EACA;IACE,gDAAgD;EAClD;EACA;IACE,gDAAgD;EAClD;EACA;IACE,gDAAgD;EAClD;EACA;IACE,gDAAgD;EAClD;EACA;IACE,gDAAgD;EAClD;EACA;IACE,iDAAiD;EACnD;EACA;IACE,iDAAiD;EACnD;EACA;IACE,iDAAiD;EACnD;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,iBAAiB;EACnB;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,6CAA6C;EAC/C;EACA;IACE,6CAA6C;EAC/C;EACA;IACE,6CAA6C;EAC/C;EACA;IACE,6CAA6C;EAC/C;EACA;IACE,6CAA6C;EAC/C;EACA;IACE,6CAA6C;EAC/C;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,oBAAoB;EACtB;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,8BAA8B;EAChC;EACA;IACE,cAAc;EAChB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,gBAAgB;EAClB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,0BAA0B;IAC1B,0BAA0B;IAC1B,qBAAqB;IACrB,qBAAqB;IACrB,qBAAqB;IACrB,sBAAsB;IACtB,sBAAsB;IACtB,4PAA4P;EAC9P;EACA;IACE,eAAe;EACjB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,qBAAqB;EACvB;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,8BAA8B;EAChC;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,sBAAsB;IACtB,sBAAsB;EACxB;EACA;IACE,uBAAuB;IACvB,uBAAuB;EACzB;EACA;IACE,wBAAwB;IACxB,wBAAwB;EAC1B;EACA;IACE,uBAAuB;IACvB,uBAAuB;EACzB;EACA;IACE,wBAAwB;IACxB,wBAAwB;EAC1B;EACA;IACE,sBAAsB;IACtB,sBAAsB;EACxB;EACA;IACE,yBAAyB;IACzB,yBAAyB;EAC3B;EACA;IACE,wBAAwB;IACxB,wBAAwB;EAC1B;EACA;IACE,yBAAyB;IACzB,yBAAyB;EAC3B;EACA;IACE,wBAAwB;IACxB,wBAAwB;EAC1B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,sBAAsB;IACtB,sBAAsB;EACxB;EACA;IACE,uBAAuB;IACvB,uBAAuB;EACzB;EACA;IACE,wBAAwB;IACxB,wBAAwB;EAC1B;EACA;IACE,uBAAuB;IACvB,uBAAuB;EACzB;EACA;IACE,wBAAwB;IACxB,wBAAwB;EAC1B;EACA;IACE,sBAAsB;IACtB,sBAAsB;EACxB;EACA;IACE,yBAAyB;IACzB,yBAAyB;EAC3B;EACA;IACE,wBAAwB;IACxB,wBAAwB;EAC1B;EACA;IACE,yBAAyB;IACzB,yBAAyB;EAC3B;EACA;IACE,wBAAwB;IACxB,wBAAwB;EAC1B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,sBAAsB;IACtB,sBAAsB;EACxB;EACA;IACE,uBAAuB;IACvB,uBAAuB;EACzB;EACA;IACE,wBAAwB;IACxB,wBAAwB;EAC1B;EACA;IACE,uBAAuB;IACvB,uBAAuB;EACzB;EACA;IACE,wBAAwB;IACxB,wBAAwB;EAC1B;EACA;IACE,sBAAsB;IACtB,sBAAsB;EACxB;EACA;IACE,yBAAyB;IACzB,yBAAyB;EAC3B;EACA;IACE,wBAAwB;IACxB,wBAAwB;EAC1B;EACA;IACE,yBAAyB;IACzB,yBAAyB;EAC3B;EACA;IACE,wBAAwB;IACxB,wBAAwB;EAC1B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,qBAAqB;EACvB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,qBAAqB;EACvB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,qBAAqB;EACvB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,gCAAgC;EAClC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,gCAAgC;EAClC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,gCAAgC;EAClC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,gCAAgC;EAClC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,iCAAiC;EACnC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,iCAAiC;EACnC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,gCAAgC;EAClC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,gCAAgC;EAClC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,gCAAgC;EAClC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,gCAAgC;EAClC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,iCAAiC;EACnC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,iCAAiC;EACnC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,gCAAgC;EAClC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,gCAAgC;EAClC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,gCAAgC;EAClC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,gCAAgC;EAClC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,iCAAiC;EACnC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,iCAAiC;EACnC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,gCAAgC;EAClC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,gCAAgC;EAClC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,gCAAgC;EAClC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,gCAAgC;EAClC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,iCAAiC;EACnC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,iCAAiC;EACnC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,gCAAgC;EAClC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,gCAAgC;EAClC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,gCAAgC;EAClC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,gCAAgC;EAClC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,iCAAiC;EACnC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,iCAAiC;EACnC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,gCAAgC;EAClC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,gCAAgC;EAClC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,gCAAgC;EAClC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,gCAAgC;EAClC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,iCAAiC;EACnC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,iCAAiC;EACnC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,qBAAqB;EACvB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,qBAAqB;EACvB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,qBAAqB;EACvB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,qBAAqB;EACvB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,qBAAqB;EACvB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,qBAAqB;EACvB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wGAAwG;EAC1G;EACA;IACE,wEAAwE;EAC1E;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,+BAA+B;EACjC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,sDAAsD;EACxD;EACA;IACE,sDAAsD;EACxD;EACA;IACE,wDAAwD;EAC1D;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,eAAe;EACjB;EACA;IACE,kCAAkC;EACpC;EACA;IACE,sDAAsD;EACxD;EACA;IACE,yDAAyD;EAC3D;EACA;IACE,6BAA6B;EAC/B;AACF;AACA;EACE;IACE,WAAW;EACb;EACA;IACE;MACE,gBAAgB;IAClB;EACF;EACA;IACE;MACE,gBAAgB;IAClB;EACF;EACA;IACE;MACE,iBAAiB;IACnB;EACF;EACA;IACE;MACE,iBAAiB;IACnB;EACF;EACA;IACE,cAAc;IACd,eAAe;EACjB;EACA;IACE,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,cAAc;IACd,qBAAqB;IACrB,gBAAgB;EAClB;EACA;IACE,cAAc;IACd,gBAAgB;EAClB;EACA;IACE,2BAA2B;IAC3B,kBAAkB;IAClB,qBAAqB;EACvB;EACA;IACE,kBAAkB;IAClB,+BAA+B;IAC/B,oBAAoB;EACtB;EACA;IACE,kCAAkC;IAClC,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;EAChB;EACA;IACE,kBAAkB;IAClB,oBAAoB;EACtB;EACA;IACE,WAAW;IACX,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,6BAA6B;IAC7B,YAAY;EACd;EACA;IACE,qBAAqB;IACrB,qBAAqB;IACrB,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;IACd,0BAA0B;IAC1B,0BAA0B;IAC1B,uCAAuC;IACvC,iBAAiB;IACjB,oBAAoB;IACpB,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,cAAc;IACd,gBAAgB;IAChB,iBAAiB;IACjB,aAAa;IACb,0BAA0B;IAC1B,sBAAsB;EACxB;EACA;IACE,cAAc;IACd,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,sBAAsB;EACxB;EACA;IACE,cAAc;IACd,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;IACjB,oBAAoB;IACpB,gBAAgB;EAClB;EACA;IACE,cAAc;IACd,gBAAgB;IAChB,iBAAiB;IACjB,oBAAoB;IACpB,gBAAgB;EAClB;EACA;IACE,cAAc;IACd,kBAAkB;IAClB,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,cAAc;IACd,gBAAgB;IAChB,kBAAkB;EACpB;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,cAAc;IACd,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;IAClB,sBAAsB;IACtB,uBAAuB;IACvB,0BAA0B;IAC1B,uBAAuB;IACvB,wBAAwB;IACxB,0BAA0B;IAC1B,2BAA2B;IAC3B,yBAAyB;EAC3B;EACA;IACE,6BAA6B;IAC7B,eAAe;IACf,gBAAgB;IAChB,UAAU;IACV,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,oBAAoB;IACpB,oBAAoB;EACtB;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,kBAAkB;IAClB,sBAAsB;EACxB;EACA;IACE,cAAc;IACd,gBAAgB;IAChB,wBAAwB;IACxB,4BAA4B;EAC9B;EACA;IACE,sBAAsB;IACtB,0BAA0B;IAC1B,2BAA2B;IAC3B,yBAAyB;EAC3B;EACA;IACE,wBAAwB;IACxB,4BAA4B;EAC9B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,mBAAmB;IACnB,wBAAwB;IACxB,0BAA0B;IAC1B,2BAA2B;IAC3B,yBAAyB;EAC3B;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,aAAa;IACb,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,OAAO;EACT;EACA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,aAAa;EACf;EACA;IACE,gBAAgB;EAClB;EACA;IACE,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,sBAAsB;EACxB;EACA;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,sBAAsB;IACtB,sBAAsB;IACtB,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,uBAAuB;IACvB,0BAA0B;IAC1B,yBAAyB;EAC3B;EACA;IACE,sBAAsB;IACtB,aAAa;IACb,oBAAoB;IACpB,gBAAgB;EAClB;EACA;IACE,sBAAsB;IACtB,iBAAiB;IACjB,oBAAoB;IACpB,gBAAgB;EAClB;EACA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,0BAA0B;IAC1B,sBAAsB;EACxB;EACA;IACE,uBAAuB;IACvB,0BAA0B;IAC1B,sBAAsB;EACxB;EACA;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,aAAa;IACb,gBAAgB;EAClB;EACA;IACE,sBAAsB;IACtB,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;IACtB,sBAAsB;IACtB,uBAAuB;IACvB,0BAA0B;IAC1B,sBAAsB;IACtB,wBAAwB;IACxB,kBAAkB;IAClB,2BAA2B;IAC3B,iBAAiB;EACnB;EACA;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,OAAO;EACT;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,mBAAmB;IACnB,kBAAkB;IAClB,oCAAoC;IACpC,iBAAiB;EACnB;EACA;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,sBAAsB;IACtB,gBAAgB;EAClB;EACA;IACE,kBAAkB;IAClB,2BAA2B;IAC3B,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,wBAAwB;IACxB,kBAAkB;IAClB,2BAA2B;IAC3B,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,aAAa;EACf;EACA;IACE,gBAAgB;EAClB;EACA;IACE,mBAAmB;IACnB,sBAAsB;EACxB;EACA;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,sBAAsB;IACtB,sBAAsB;IACtB,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,uBAAuB;IACvB,0BAA0B;IAC1B,iBAAiB;EACnB;EACA;IACE,sBAAsB;IACtB,aAAa;IACb,0BAA0B;IAC1B,cAAc;EAChB;EACA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,0BAA0B;IAC1B,sBAAsB;EACxB;EACA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,0BAA0B;IAC1B,gBAAgB;EAClB;EACA;IACE,uBAAuB;IACvB,0BAA0B;IAC1B,sBAAsB;EACxB;EACA;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,aAAa;IACb,gBAAgB;EAClB;EACA;IACE,sBAAsB;IACtB,gBAAgB;IAChB,eAAe;EACjB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,sBAAsB;IACtB,iBAAiB;IACjB,eAAe;IACf,kBAAkB;IAClB,uBAAuB;IACvB,gBAAgB;IAChB,oBAAoB;IACpB,mBAAmB;IACnB,mBAAmB;EACrB;EACA;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,OAAO;EACT;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,oCAAoC;IACpC,iBAAiB;EACnB;EACA;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,sBAAsB;IACtB,gBAAgB;EAClB;EACA;IACE,qBAAqB;IACrB,sBAAsB;IACtB,oBAAoB;EACtB;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sBAAsB;IACtB,oBAAoB;EACtB;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,aAAa;EACf;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,iBAAiB;IACjB,oBAAoB;IACpB,yBAAyB;EAC3B;EACA;IACE,gBAAgB;IAChB,aAAa;IACb,0BAA0B;IAC1B,cAAc;EAChB;EACA;IACE,gBAAgB;IAChB,uBAAuB;IACvB,0BAA0B;IAC1B,sBAAsB;EACxB;EACA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,0BAA0B;IAC1B,sBAAsB;EACxB;EACA;IACE,iBAAiB;IACjB,oBAAoB;IACpB,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,aAAa;IACb,gBAAgB;EAClB;EACA;IACE,gBAAgB;IAChB,sBAAsB;IACtB,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;IAChB,sBAAsB;IACtB,eAAe;IACf,kBAAkB;IAClB,qBAAqB;IACrB,wBAAwB;IACxB,0BAA0B;IAC1B,2BAA2B;IAC3B,yBAAyB;EAC3B;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,OAAO;EACT;EACA;IACE,mBAAmB;EACrB;EACA;IACE,aAAa;IACb,cAAc;IACd,0BAA0B;IAC1B,YAAY;EACd;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,gBAAgB;IAChB,sBAAsB;EACxB;EACA;IACE,0BAA0B;IAC1B,2BAA2B;IAC3B,yBAAyB;EAC3B;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,wBAAwB;IACxB,0BAA0B;IAC1B,2BAA2B;IAC3B,yBAAyB;EAC3B;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,aAAa;EACf;EACA;IACE,gBAAgB;EAClB;EACA;IACE,iBAAiB;IACjB,sBAAsB;EACxB;EACA;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,iBAAiB;IACjB,sBAAsB;IACtB,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,uBAAuB;IACvB,0BAA0B;IAC1B,yBAAyB;EAC3B;EACA;IACE,sBAAsB;IACtB,aAAa;IACb,sBAAsB;IACtB,cAAc;EAChB;EACA;IACE,cAAc;IACd,iBAAiB;IACjB,0BAA0B;IAC1B,sBAAsB;EACxB;EACA;IACE,gBAAgB;IAChB,uBAAuB;IACvB,0BAA0B;IAC1B,sBAAsB;EACxB;EACA;IACE,uBAAuB;IACvB,0BAA0B;IAC1B,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,aAAa;IACb,gBAAgB;EAClB;EACA;IACE,sBAAsB;IACtB,gBAAgB;IAChB,eAAe;EACjB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;IACtB,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,qBAAqB;IACrB,kBAAkB;IAClB,oBAAoB;IACpB,qBAAqB;IACrB,mBAAmB;EACrB;EACA;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,OAAO;EACT;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,oCAAoC;IACpC,YAAY;EACd;EACA;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,sBAAsB;IACtB,gBAAgB;EAClB;EACA;IACE,oBAAoB;IACpB,qBAAqB;IACrB,mBAAmB;EACrB;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;IAClB,oBAAoB;IACpB,qBAAqB;IACrB,mBAAmB;EACrB;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,aAAa;EACf;EACA;IACE,gBAAgB;EAClB;EACA;IACE,oBAAoB;IACpB,wDAAwD;IACxD,iDAAiD;EACnD;EACA;IACE,oBAAoB;IACpB,gDAAgD;IAChD,yDAAyD;EAC3D;EACA;IACE,oBAAoB;IACpB,4DAA4D;IAC5D,qDAAqD;EACvD;EACA;IACE,oBAAoB;IACpB,oDAAoD;IACpD,6DAA6D;EAC/D;EACA;IACE,oBAAoB;IACpB,2DAA2D;IAC3D,oDAAoD;EACtD;EACA;IACE,oBAAoB;IACpB,mDAAmD;IACnD,4DAA4D;EAC9D;EACA;IACE,oBAAoB;IACpB,4DAA4D;IAC5D,qDAAqD;EACvD;EACA;IACE,oBAAoB;IACpB,oDAAoD;IACpD,6DAA6D;EAC/D;EACA;IACE,oBAAoB;IACpB,yDAAyD;IACzD,kDAAkD;EACpD;EACA;IACE,oBAAoB;IACpB,iDAAiD;IACjD,0DAA0D;EAC5D;EACA;IACE,oBAAoB;IACpB,4DAA4D;IAC5D,qDAAqD;EACvD;EACA;IACE,oBAAoB;IACpB,oDAAoD;IACpD,6DAA6D;EAC/D;EACA;IACE,oBAAoB;IACpB,2DAA2D;IAC3D,oDAAoD;EACtD;EACA;IACE,oBAAoB;IACpB,mDAAmD;IACnD,4DAA4D;EAC9D;EACA;IACE,oBAAoB;IACpB,4DAA4D;IAC5D,qDAAqD;EACvD;EACA;IACE,oBAAoB;IACpB,oDAAoD;IACpD,6DAA6D;EAC/D;EACA;IACE,oBAAoB;IACpB,yDAAyD;IACzD,kDAAkD;EACpD;EACA;IACE,oBAAoB;IACpB,iDAAiD;IACjD,0DAA0D;EAC5D;EACA;IACE,oBAAoB;IACpB,4DAA4D;IAC5D,qDAAqD;EACvD;EACA;IACE,oBAAoB;IACpB,oDAAoD;IACpD,6DAA6D;EAC/D;EACA;IACE,oBAAoB;IACpB,2DAA2D;IAC3D,oDAAoD;EACtD;EACA;IACE,oBAAoB;IACpB,mDAAmD;IACnD,4DAA4D;EAC9D;EACA;IACE,oBAAoB;IACpB,4DAA4D;IAC5D,qDAAqD;EACvD;EACA;IACE,oBAAoB;IACpB,oDAAoD;IACpD,6DAA6D;EAC/D;EACA;IACE,oBAAoB;IACpB,yDAAyD;IACzD,kDAAkD;EACpD;EACA;IACE,oBAAoB;IACpB,iDAAiD;IACjD,0DAA0D;EAC5D;EACA;IACE,oBAAoB;IACpB,4DAA4D;IAC5D,qDAAqD;EACvD;EACA;IACE,oBAAoB;IACpB,oDAAoD;IACpD,6DAA6D;EAC/D;EACA;IACE,oBAAoB;IACpB,2DAA2D;IAC3D,oDAAoD;EACtD;EACA;IACE,oBAAoB;IACpB,mDAAmD;IACnD,4DAA4D;EAC9D;EACA;IACE,oBAAoB;IACpB,4DAA4D;IAC5D,qDAAqD;EACvD;EACA;IACE,oBAAoB;IACpB,oDAAoD;IACpD,6DAA6D;EAC/D;EACA;IACE,oBAAoB;IACpB,yDAAyD;IACzD,kDAAkD;EACpD;EACA;IACE,oBAAoB;IACpB,iDAAiD;IACjD,0DAA0D;EAC5D;EACA;IACE,oBAAoB;IACpB,yDAAyD;IACzD,kDAAkD;EACpD;EACA;IACE,oBAAoB;IACpB,iDAAiD;IACjD,0DAA0D;EAC5D;EACA;IACE,oBAAoB;IACpB,yDAAyD;IACzD,kDAAkD;EACpD;EACA;IACE,oBAAoB;IACpB,iDAAiD;IACjD,0DAA0D;EAC5D;EACA;IACE,oBAAoB;IACpB,yDAAyD;IACzD,kDAAkD;EACpD;EACA;IACE,oBAAoB;IACpB,iDAAiD;IACjD,0DAA0D;EAC5D;EACA;IACE,oBAAoB;IACpB,yDAAyD;IACzD,kDAAkD;EACpD;EACA;IACE,oBAAoB;IACpB,iDAAiD;IACjD,0DAA0D;EAC5D;EACA;IACE,oBAAoB;IACpB,yDAAyD;IACzD,kDAAkD;EACpD;EACA;IACE,oBAAoB;IACpB,iDAAiD;IACjD,0DAA0D;EAC5D;EACA;IACE,oBAAoB;IACpB,0DAA0D;IAC1D,mDAAmD;EACrD;EACA;IACE,oBAAoB;IACpB,kDAAkD;IAClD,2DAA2D;EAC7D;EACA;IACE,oBAAoB;IACpB,0DAA0D;IAC1D,mDAAmD;EACrD;EACA;IACE,oBAAoB;IACpB,kDAAkD;IAClD,2DAA2D;EAC7D;EACA;IACE,oBAAoB;IACpB,0DAA0D;IAC1D,mDAAmD;EACrD;EACA;IACE,oBAAoB;IACpB,kDAAkD;IAClD,2DAA2D;EAC7D;EACA;IACE,oBAAoB;IACpB,0DAA0D;IAC1D,mDAAmD;EACrD;EACA;IACE,oBAAoB;IACpB,kDAAkD;IAClD,2DAA2D;EAC7D;EACA;IACE,oBAAoB;IACpB,0DAA0D;IAC1D,mDAAmD;EACrD;EACA;IACE,oBAAoB;IACpB,kDAAkD;IAClD,2DAA2D;EAC7D;EACA;IACE,oBAAoB;IACpB,0DAA0D;IAC1D,mDAAmD;EACrD;EACA;IACE,oBAAoB;IACpB,kDAAkD;IAClD,2DAA2D;EAC7D;EACA;IACE,oBAAoB;IACpB,0DAA0D;IAC1D,mDAAmD;EACrD;EACA;IACE,oBAAoB;IACpB,kDAAkD;IAClD,2DAA2D;EAC7D;EACA;IACE,oBAAoB;IACpB,0DAA0D;IAC1D,mDAAmD;EACrD;EACA;IACE,oBAAoB;IACpB,kDAAkD;IAClD,2DAA2D;EAC7D;EACA;IACE,oBAAoB;IACpB,0DAA0D;IAC1D,mDAAmD;EACrD;EACA;IACE,oBAAoB;IACpB,kDAAkD;IAClD,2DAA2D;EAC7D;EACA;IACE,oBAAoB;IACpB,0DAA0D;IAC1D,mDAAmD;EACrD;EACA;IACE,oBAAoB;IACpB,kDAAkD;IAClD,2DAA2D;EAC7D;EACA;IACE,oBAAoB;IACpB,wDAAwD;IACxD,iDAAiD;EACnD;EACA;IACE,oBAAoB;IACpB,gDAAgD;IAChD,yDAAyD;EAC3D;EACA;IACE,oBAAoB;IACpB,6DAA6D;IAC7D,sDAAsD;EACxD;EACA;IACE,oBAAoB;IACpB,qDAAqD;IACrD,8DAA8D;EAChE;EACA;IACE,oBAAoB;IACpB,6DAA6D;IAC7D,sDAAsD;EACxD;EACA;IACE,oBAAoB;IACpB,qDAAqD;IACrD,8DAA8D;EAChE;EACA;IACE,oBAAoB;IACpB,6DAA6D;IAC7D,sDAAsD;EACxD;EACA;IACE,oBAAoB;IACpB,qDAAqD;IACrD,8DAA8D;EAChE;EACA;IACE,oBAAoB;IACpB,6DAA6D;IAC7D,sDAAsD;EACxD;EACA;IACE,oBAAoB;IACpB,qDAAqD;IACrD,8DAA8D;EAChE;EACA;IACE,oBAAoB;IACpB,wDAAwD;IACxD,iDAAiD;EACnD;EACA;IACE,oBAAoB;IACpB,gDAAgD;IAChD,yDAAyD;EAC3D;EACA;IACE,oBAAoB;IACpB,+DAA+D;IAC/D,wDAAwD;EAC1D;EACA;IACE,oBAAoB;IACpB,uDAAuD;IACvD,gEAAgE;EAClE;EACA;IACE,oBAAoB;IACpB,+DAA+D;IAC/D,wDAAwD;EAC1D;EACA;IACE,oBAAoB;IACpB,uDAAuD;IACvD,gEAAgE;EAClE;EACA;IACE,oBAAoB;IACpB,wDAAwD;IACxD,iDAAiD;EACnD;EACA;IACE,oBAAoB;IACpB,gDAAgD;IAChD,yDAAyD;EAC3D;EACA;IACE,oBAAoB;IACpB,wDAAwD;IACxD,iDAAiD;EACnD;EACA;IACE,oBAAoB;IACpB,gDAAgD;IAChD,yDAAyD;EAC3D;EACA;IACE,oBAAoB;IACpB,wDAAwD;IACxD,iDAAiD;EACnD;EACA;IACE,oBAAoB;IACpB,gDAAgD;IAChD,yDAAyD;EAC3D;EACA;IACE,oBAAoB;IACpB,wDAAwD;IACxD,iDAAiD;EACnD;EACA;IACE,oBAAoB;IACpB,gDAAgD;IAChD,yDAAyD;EAC3D;EACA;IACE,oBAAoB;IACpB,wDAAwD;IACxD,iDAAiD;EACnD;EACA;IACE,oBAAoB;IACpB,gDAAgD;IAChD,yDAAyD;EAC3D;EACA;IACE,oBAAoB;IACpB,wDAAwD;IACxD,iDAAiD;EACnD;EACA;IACE,oBAAoB;IACpB,gDAAgD;IAChD,yDAAyD;EAC3D;EACA;IACE,oBAAoB;IACpB,wDAAwD;IACxD,iDAAiD;EACnD;EACA;IACE,oBAAoB;IACpB,gDAAgD;IAChD,yDAAyD;EAC3D;EACA;IACE,oBAAoB;IACpB,+DAA+D;IAC/D,wDAAwD;EAC1D;EACA;IACE,oBAAoB;IACpB,uDAAuD;IACvD,gEAAgE;EAClE;EACA;IACE,oBAAoB;IACpB,+DAA+D;IAC/D,wDAAwD;EAC1D;EACA;IACE,oBAAoB;IACpB,uDAAuD;IACvD,gEAAgE;EAClE;EACA;IACE,oBAAoB;IACpB,wDAAwD;IACxD,iDAAiD;EACnD;EACA;IACE,oBAAoB;IACpB,gDAAgD;IAChD,yDAAyD;EAC3D;EACA;IACE,oBAAoB;IACpB,+DAA+D;IAC/D,wDAAwD;EAC1D;EACA;IACE,oBAAoB;IACpB,uDAAuD;IACvD,gEAAgE;EAClE;EACA;IACE,oBAAoB;IACpB,+DAA+D;IAC/D,wDAAwD;EAC1D;EACA;IACE,oBAAoB;IACpB,uDAAuD;IACvD,gEAAgE;EAClE;EACA;IACE,oBAAoB;IACpB,8DAA8D;IAC9D,uDAAuD;EACzD;EACA;IACE,oBAAoB;IACpB,sDAAsD;IACtD,+DAA+D;EACjE;EACA;IACE,oBAAoB;IACpB,+DAA+D;IAC/D,wDAAwD;EAC1D;EACA;IACE,oBAAoB;IACpB,uDAAuD;IACvD,gEAAgE;EAClE;EACA;IACE,oBAAoB;IACpB,wDAAwD;IACxD,iDAAiD;EACnD;EACA;IACE,oBAAoB;IACpB,gDAAgD;IAChD,yDAAyD;EAC3D;EACA;IACE,oBAAoB;IACpB,+DAA+D;IAC/D,wDAAwD;EAC1D;EACA;IACE,oBAAoB;IACpB,uDAAuD;IACvD,gEAAgE;EAClE;EACA;IACE,oBAAoB;IACpB,+DAA+D;IAC/D,wDAAwD;EAC1D;EACA;IACE,oBAAoB;IACpB,uDAAuD;IACvD,gEAAgE;EAClE;EACA;IACE,oBAAoB;IACpB,wDAAwD;IACxD,iDAAiD;EACnD;EACA;IACE,oBAAoB;IACpB,gDAAgD;IAChD,yDAAyD;EAC3D;EACA;IACE,oBAAoB;IACpB,+DAA+D;IAC/D,wDAAwD;EAC1D;EACA;IACE,oBAAoB;IACpB,uDAAuD;IACvD,gEAAgE;EAClE;EACA;IACE,oBAAoB;IACpB,+DAA+D;IAC/D,wDAAwD;EAC1D;EACA;IACE,oBAAoB;IACpB,uDAAuD;IACvD,gEAAgE;EAClE;EACA;IACE,oBAAoB;IACpB,wDAAwD;IACxD,iDAAiD;EACnD;EACA;IACE,oBAAoB;IACpB,gDAAgD;IAChD,yDAAyD;EAC3D;EACA;IACE,oBAAoB;IACpB,+DAA+D;IAC/D,wDAAwD;EAC1D;EACA;IACE,oBAAoB;IACpB,uDAAuD;IACvD,gEAAgE;EAClE;EACA;IACE,oBAAoB;IACpB,+DAA+D;IAC/D,wDAAwD;EAC1D;EACA;IACE,oBAAoB;IACpB,uDAAuD;IACvD,gEAAgE;EAClE;EACA;IACE,oBAAoB;IACpB,yDAAyD;IACzD,kDAAkD;EACpD;EACA;IACE,oBAAoB;IACpB,iDAAiD;IACjD,0DAA0D;EAC5D;EACA;IACE,oBAAoB;IACpB,6DAA6D;IAC7D,sDAAsD;EACxD;EACA;IACE,oBAAoB;IACpB,qDAAqD;IACrD,8DAA8D;EAChE;EACA;IACE,oBAAoB;IACpB,4DAA4D;IAC5D,qDAAqD;EACvD;EACA;IACE,oBAAoB;IACpB,oDAAoD;IACpD,6DAA6D;EAC/D;EACA;IACE,oBAAoB;IACpB,6DAA6D;IAC7D,sDAAsD;EACxD;EACA;IACE,oBAAoB;IACpB,qDAAqD;IACrD,8DAA8D;EAChE;EACA;IACE,oBAAoB;IACpB,0DAA0D;IAC1D,mDAAmD;EACrD;EACA;IACE,oBAAoB;IACpB,kDAAkD;IAClD,2DAA2D;EAC7D;EACA;IACE,oBAAoB;IACpB,6DAA6D;IAC7D,sDAAsD;EACxD;EACA;IACE,oBAAoB;IACpB,qDAAqD;IACrD,8DAA8D;EAChE;EACA;IACE,oBAAoB;IACpB,4DAA4D;IAC5D,qDAAqD;EACvD;EACA;IACE,oBAAoB;IACpB,oDAAoD;IACpD,6DAA6D;EAC/D;EACA;IACE,oBAAoB;IACpB,6DAA6D;IAC7D,sDAAsD;EACxD;EACA;IACE,oBAAoB;IACpB,qDAAqD;IACrD,8DAA8D;EAChE;EACA;IACE,oBAAoB;IACpB,0DAA0D;IAC1D,mDAAmD;EACrD;EACA;IACE,oBAAoB;IACpB,kDAAkD;IAClD,2DAA2D;EAC7D;EACA;IACE,oBAAoB;IACpB,6DAA6D;IAC7D,sDAAsD;EACxD;EACA;IACE,oBAAoB;IACpB,qDAAqD;IACrD,8DAA8D;EAChE;EACA;IACE,oBAAoB;IACpB,4DAA4D;IAC5D,qDAAqD;EACvD;EACA;IACE,oBAAoB;IACpB,oDAAoD;IACpD,6DAA6D;EAC/D;EACA;IACE,oBAAoB;IACpB,6DAA6D;IAC7D,sDAAsD;EACxD;EACA;IACE,oBAAoB;IACpB,qDAAqD;IACrD,8DAA8D;EAChE;EACA;IACE,oBAAoB;IACpB,0DAA0D;IAC1D,mDAAmD;EACrD;EACA;IACE,oBAAoB;IACpB,kDAAkD;IAClD,2DAA2D;EAC7D;EACA;IACE,oBAAoB;IACpB,6DAA6D;IAC7D,sDAAsD;EACxD;EACA;IACE,oBAAoB;IACpB,qDAAqD;IACrD,8DAA8D;EAChE;EACA;IACE,oBAAoB;IACpB,4DAA4D;IAC5D,qDAAqD;EACvD;EACA;IACE,oBAAoB;IACpB,oDAAoD;IACpD,6DAA6D;EAC/D;EACA;IACE,oBAAoB;IACpB,6DAA6D;IAC7D,sDAAsD;EACxD;EACA;IACE,oBAAoB;IACpB,qDAAqD;IACrD,8DAA8D;EAChE;EACA;IACE,oBAAoB;IACpB,0DAA0D;IAC1D,mDAAmD;EACrD;EACA;IACE,oBAAoB;IACpB,kDAAkD;IAClD,2DAA2D;EAC7D;EACA;IACE,oBAAoB;IACpB,0DAA0D;IAC1D,mDAAmD;EACrD;EACA;IACE,oBAAoB;IACpB,kDAAkD;IAClD,2DAA2D;EAC7D;EACA;IACE,oBAAoB;IACpB,0DAA0D;IAC1D,mDAAmD;EACrD;EACA;IACE,oBAAoB;IACpB,kDAAkD;IAClD,2DAA2D;EAC7D;EACA;IACE,oBAAoB;IACpB,0DAA0D;IAC1D,mDAAmD;EACrD;EACA;IACE,oBAAoB;IACpB,kDAAkD;IAClD,2DAA2D;EAC7D;EACA;IACE,oBAAoB;IACpB,0DAA0D;IAC1D,mDAAmD;EACrD;EACA;IACE,oBAAoB;IACpB,kDAAkD;IAClD,2DAA2D;EAC7D;EACA;IACE,oBAAoB;IACpB,0DAA0D;IAC1D,mDAAmD;EACrD;EACA;IACE,oBAAoB;IACpB,kDAAkD;IAClD,2DAA2D;EAC7D;EACA;IACE,oBAAoB;IACpB,2DAA2D;IAC3D,oDAAoD;EACtD;EACA;IACE,oBAAoB;IACpB,mDAAmD;IACnD,4DAA4D;EAC9D;EACA;IACE,oBAAoB;IACpB,2DAA2D;IAC3D,oDAAoD;EACtD;EACA;IACE,oBAAoB;IACpB,mDAAmD;IACnD,4DAA4D;EAC9D;EACA;IACE,oBAAoB;IACpB,2DAA2D;IAC3D,oDAAoD;EACtD;EACA;IACE,oBAAoB;IACpB,mDAAmD;IACnD,4DAA4D;EAC9D;EACA;IACE,oBAAoB;IACpB,2DAA2D;IAC3D,oDAAoD;EACtD;EACA;IACE,oBAAoB;IACpB,mDAAmD;IACnD,4DAA4D;EAC9D;EACA;IACE,oBAAoB;IACpB,2DAA2D;IAC3D,oDAAoD;EACtD;EACA;IACE,oBAAoB;IACpB,mDAAmD;IACnD,4DAA4D;EAC9D;EACA;IACE,oBAAoB;IACpB,2DAA2D;IAC3D,oDAAoD;EACtD;EACA;IACE,oBAAoB;IACpB,mDAAmD;IACnD,4DAA4D;EAC9D;EACA;IACE,oBAAoB;IACpB,2DAA2D;IAC3D,oDAAoD;EACtD;EACA;IACE,oBAAoB;IACpB,mDAAmD;IACnD,4DAA4D;EAC9D;EACA;IACE,oBAAoB;IACpB,2DAA2D;IAC3D,oDAAoD;EACtD;EACA;IACE,oBAAoB;IACpB,mDAAmD;IACnD,4DAA4D;EAC9D;EACA;IACE,oBAAoB;IACpB,2DAA2D;IAC3D,oDAAoD;EACtD;EACA;IACE,oBAAoB;IACpB,mDAAmD;IACnD,4DAA4D;EAC9D;EACA;IACE,oBAAoB;IACpB,2DAA2D;IAC3D,oDAAoD;EACtD;EACA;IACE,oBAAoB;IACpB,mDAAmD;IACnD,4DAA4D;EAC9D;EACA;IACE,oBAAoB;IACpB,yDAAyD;IACzD,kDAAkD;EACpD;EACA;IACE,oBAAoB;IACpB,iDAAiD;IACjD,0DAA0D;EAC5D;EACA;IACE,oBAAoB;IACpB,8DAA8D;IAC9D,uDAAuD;EACzD;EACA;IACE,oBAAoB;IACpB,sDAAsD;IACtD,+DAA+D;EACjE;EACA;IACE,oBAAoB;IACpB,8DAA8D;IAC9D,uDAAuD;EACzD;EACA;IACE,oBAAoB;IACpB,sDAAsD;IACtD,+DAA+D;EACjE;EACA;IACE,oBAAoB;IACpB,8DAA8D;IAC9D,uDAAuD;EACzD;EACA;IACE,oBAAoB;IACpB,sDAAsD;IACtD,+DAA+D;EACjE;EACA;IACE,oBAAoB;IACpB,8DAA8D;IAC9D,uDAAuD;EACzD;EACA;IACE,oBAAoB;IACpB,sDAAsD;IACtD,+DAA+D;EACjE;EACA;IACE,oBAAoB;IACpB,yDAAyD;IACzD,kDAAkD;EACpD;EACA;IACE,oBAAoB;IACpB,iDAAiD;IACjD,0DAA0D;EAC5D;EACA;IACE,oBAAoB;IACpB,+DAA+D;IAC/D,wDAAwD;EAC1D;EACA;IACE,oBAAoB;IACpB,uDAAuD;IACvD,gEAAgE;EAClE;EACA;IACE,oBAAoB;IACpB,+DAA+D;IAC/D,wDAAwD;EAC1D;EACA;IACE,oBAAoB;IACpB,uDAAuD;IACvD,gEAAgE;EAClE;EACA;IACE,oBAAoB;IACpB,yDAAyD;IACzD,kDAAkD;EACpD;EACA;IACE,oBAAoB;IACpB,iDAAiD;IACjD,0DAA0D;EAC5D;EACA;IACE,oBAAoB;IACpB,yDAAyD;IACzD,kDAAkD;EACpD;EACA;IACE,oBAAoB;IACpB,iDAAiD;IACjD,0DAA0D;EAC5D;EACA;IACE,oBAAoB;IACpB,yDAAyD;IACzD,kDAAkD;EACpD;EACA;IACE,oBAAoB;IACpB,iDAAiD;IACjD,0DAA0D;EAC5D;EACA;IACE,oBAAoB;IACpB,yDAAyD;IACzD,kDAAkD;EACpD;EACA;IACE,oBAAoB;IACpB,iDAAiD;IACjD,0DAA0D;EAC5D;EACA;IACE,oBAAoB;IACpB,yDAAyD;IACzD,kDAAkD;EACpD;EACA;IACE,oBAAoB;IACpB,iDAAiD;IACjD,0DAA0D;EAC5D;EACA;IACE,oBAAoB;IACpB,yDAAyD;IACzD,kDAAkD;EACpD;EACA;IACE,oBAAoB;IACpB,iDAAiD;IACjD,0DAA0D;EAC5D;EACA;IACE,oBAAoB;IACpB,yDAAyD;IACzD,kDAAkD;EACpD;EACA;IACE,oBAAoB;IACpB,iDAAiD;IACjD,0DAA0D;EAC5D;EACA;IACE,oBAAoB;IACpB,+DAA+D;IAC/D,wDAAwD;EAC1D;EACA;IACE,oBAAoB;IACpB,uDAAuD;IACvD,gEAAgE;EAClE;EACA;IACE,oBAAoB;IACpB,+DAA+D;IAC/D,wDAAwD;EAC1D;EACA;IACE,oBAAoB;IACpB,uDAAuD;IACvD,gEAAgE;EAClE;EACA;IACE,oBAAoB;IACpB,yDAAyD;IACzD,kDAAkD;EACpD;EACA;IACE,oBAAoB;IACpB,iDAAiD;IACjD,0DAA0D;EAC5D;EACA;IACE,oBAAoB;IACpB,+DAA+D;IAC/D,wDAAwD;EAC1D;EACA;IACE,oBAAoB;IACpB,uDAAuD;IACvD,gEAAgE;EAClE;EACA;IACE,oBAAoB;IACpB,+DAA+D;IAC/D,wDAAwD;EAC1D;EACA;IACE,oBAAoB;IACpB,uDAAuD;IACvD,gEAAgE;EAClE;EACA;IACE,oBAAoB;IACpB,8DAA8D;IAC9D,uDAAuD;EACzD;EACA;IACE,oBAAoB;IACpB,sDAAsD;IACtD,+DAA+D;EACjE;EACA;IACE,oBAAoB;IACpB,+DAA+D;IAC/D,wDAAwD;EAC1D;EACA;IACE,oBAAoB;IACpB,uDAAuD;IACvD,gEAAgE;EAClE;EACA;IACE,oBAAoB;IACpB,yDAAyD;IACzD,kDAAkD;EACpD;EACA;IACE,oBAAoB;IACpB,iDAAiD;IACjD,0DAA0D;EAC5D;EACA;IACE,oBAAoB;IACpB,+DAA+D;IAC/D,wDAAwD;EAC1D;EACA;IACE,oBAAoB;IACpB,uDAAuD;IACvD,gEAAgE;EAClE;EACA;IACE,oBAAoB;IACpB,+DAA+D;IAC/D,wDAAwD;EAC1D;EACA;IACE,oBAAoB;IACpB,uDAAuD;IACvD,gEAAgE;EAClE;EACA;IACE,oBAAoB;IACpB,yDAAyD;IACzD,kDAAkD;EACpD;EACA;IACE,oBAAoB;IACpB,iDAAiD;IACjD,0DAA0D;EAC5D;EACA;IACE,oBAAoB;IACpB,+DAA+D;IAC/D,wDAAwD;EAC1D;EACA;IACE,oBAAoB;IACpB,uDAAuD;IACvD,gEAAgE;EAClE;EACA;IACE,oBAAoB;IACpB,+DAA+D;IAC/D,wDAAwD;EAC1D;EACA;IACE,oBAAoB;IACpB,uDAAuD;IACvD,gEAAgE;EAClE;EACA;IACE,oBAAoB;IACpB,yDAAyD;IACzD,kDAAkD;EACpD;EACA;IACE,oBAAoB;IACpB,iDAAiD;IACjD,0DAA0D;EAC5D;EACA;IACE,oBAAoB;IACpB,+DAA+D;IAC/D,wDAAwD;EAC1D;EACA;IACE,oBAAoB;IACpB,uDAAuD;IACvD,gEAAgE;EAClE;EACA;IACE,oBAAoB;IACpB,+DAA+D;IAC/D,wDAAwD;EAC1D;EACA;IACE,oBAAoB;IACpB,uDAAuD;IACvD,gEAAgE;EAClE;EACA;IACE,oBAAoB;IACpB,0DAA0D;IAC1D,mDAAmD;EACrD;EACA;IACE,oBAAoB;IACpB,kDAAkD;IAClD,2DAA2D;EAC7D;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,qBAAqB;IACrB,+DAA+D;IAC/D,wDAAwD;EAC1D;EACA;IACE,qBAAqB;IACrB,uDAAuD;IACvD,gEAAgE;EAClE;EACA;IACE,qBAAqB;IACrB,+DAA+D;IAC/D,wDAAwD;EAC1D;EACA;IACE,qBAAqB;IACrB,uDAAuD;IACvD,gEAAgE;EAClE;EACA;IACE,qBAAqB;IACrB,+DAA+D;IAC/D,wDAAwD;EAC1D;EACA;IACE,qBAAqB;IACrB,uDAAuD;IACvD,gEAAgE;EAClE;EACA;IACE,qBAAqB;IACrB,+DAA+D;IAC/D,wDAAwD;EAC1D;EACA;IACE,qBAAqB;IACrB,uDAAuD;IACvD,gEAAgE;EAClE;EACA;IACE,qBAAqB;IACrB,+DAA+D;IAC/D,wDAAwD;EAC1D;EACA;IACE,qBAAqB;IACrB,uDAAuD;IACvD,gEAAgE;EAClE;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,kDAAkD;EACpD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,oDAAoD;EACtD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,oDAAoD;EACtD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,oDAAoD;EACtD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,oDAAoD;EACtD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,UAAU;IACV,YAAY;IACZ,gBAAgB;IAChB,sBAAsB;IACtB,mBAAmB;IACnB,eAAe;EACjB;EACA;IACE,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,UAAU;IACV,SAAS;IACT,iBAAiB;IACjB,UAAU;IACV,mBAAmB;EACrB;EACA;IACE,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,UAAU;IACV,YAAY;IACZ,gBAAgB;IAChB,sBAAsB;IACtB,mBAAmB;IACnB,eAAe;EACjB;EACA;IACE,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,UAAU;IACV,SAAS;IACT,iBAAiB;IACjB,UAAU;IACV,mBAAmB;EACrB;EACA;IAGE,gBAAgB;EAClB;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,6BAA6B;IAC7B,qBAAqB;EACvB;EACA;IACE,8BAA8B;EAChC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,kDAAkD;EACpD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,oDAAoD;EACtD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,oDAAoD;EACtD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,oDAAoD;EACtD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,oDAAoD;EACtD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,8BAA8B;EAChC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,kDAAkD;EACpD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,oDAAoD;EACtD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,oDAAoD;EACtD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,oDAAoD;EACtD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,oDAAoD;EACtD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,8BAA8B;EAChC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,kDAAkD;EACpD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,oDAAoD;EACtD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,oDAAoD;EACtD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,oDAAoD;EACtD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,oDAAoD;EACtD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,8BAA8B;EAChC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,kDAAkD;EACpD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,oDAAoD;EACtD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,oDAAoD;EACtD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,oDAAoD;EACtD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,oDAAoD;EACtD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,8BAA8B;EAChC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,kDAAkD;EACpD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,oDAAoD;EACtD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,oDAAoD;EACtD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,oDAAoD;EACtD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,oDAAoD;EACtD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,8BAA8B;EAChC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,kDAAkD;EACpD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,oDAAoD;EACtD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,oDAAoD;EACtD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,oDAAoD;EACtD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,oDAAoD;EACtD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sEAAsE;EACxE;EACA;IACE,4EAA4E;EAC9E;EACA;IACE,wEAAwE;EAC1E;EACA;IACE,+EAA+E;EACjF;EACA;IACE,yEAAyE;EAC3E;EACA;IACE,8EAA8E;EAChF;EACA;IACE,uEAAuE;EACzE;EACA;IACE,2EAA2E;EAC7E;EACA;IACE,mCAAmC;IACnC,oGAAoG;EACtG;EACA;IACE,kCAAkC;IAClC,8FAA8F;EAChG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,8FAA8F;EAChG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,iGAAiG;EACnG;EACA;IACE,8BAA8B;IAC9B,iGAAiG;EACnG;EACA;IACE,8BAA8B;IAC9B,iGAAiG;EACnG;EACA;IACE,8BAA8B;IAC9B,iGAAiG;EACnG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,mGAAmG;EACrG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,iGAAiG;EACnG;EACA;IACE,8BAA8B;IAC9B,iGAAiG;EACnG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,mGAAmG;EACrG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,iGAAiG;EACnG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,mGAAmG;EACrG;EACA;IACE,8BAA8B;IAC9B,mGAAmG;EACrG;EACA;IACE,8BAA8B;IAC9B,iGAAiG;EACnG;EACA;IACE,8BAA8B;IAC9B,iGAAiG;EACnG;EACA;IACE,8BAA8B;IAC9B,gGAAgG;EAClG;EACA;IACE,8BAA8B;IAC9B,gGAAgG;EAClG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,mGAAmG;EACrG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,gGAAgG;EAClG;EACA;IACE,8BAA8B;IAC9B,gGAAgG;EAClG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,mGAAmG;EACrG;EACA;IACE,8BAA8B;IAC9B,mGAAmG;EACrG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,mGAAmG;EACrG;EACA;IACE,8BAA8B;IAC9B,mGAAmG;EACrG;EACA;IACE,8BAA8B;IAC9B,mGAAmG;EACrG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,mGAAmG;EACrG;EACA;IACE,8BAA8B;IAC9B,mGAAmG;EACrG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,iGAAiG;EACnG;EACA;IACE,8BAA8B;IAC9B,iGAAiG;EACnG;EACA;IACE,8BAA8B;IAC9B,iGAAiG;EACnG;EACA;IACE,kCAAkC;IAClC,+HAA+H;EACjI;EACA;IACE,iCAAiC;IACjC,yHAAyH;EAC3H;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,yHAAyH;EAC3H;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,4HAA4H;EAC9H;EACA;IACE,6BAA6B;IAC7B,4HAA4H;EAC9H;EACA;IACE,6BAA6B;IAC7B,4HAA4H;EAC9H;EACA;IACE,6BAA6B;IAC7B,4HAA4H;EAC9H;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,8HAA8H;EAChI;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,4HAA4H;EAC9H;EACA;IACE,6BAA6B;IAC7B,4HAA4H;EAC9H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,8HAA8H;EAChI;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,4HAA4H;EAC9H;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,8HAA8H;EAChI;EACA;IACE,6BAA6B;IAC7B,8HAA8H;EAChI;EACA;IACE,6BAA6B;IAC7B,4HAA4H;EAC9H;EACA;IACE,6BAA6B;IAC7B,4HAA4H;EAC9H;EACA;IACE,6BAA6B;IAC7B,2HAA2H;EAC7H;EACA;IACE,6BAA6B;IAC7B,2HAA2H;EAC7H;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,8HAA8H;EAChI;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,2HAA2H;EAC7H;EACA;IACE,6BAA6B;IAC7B,2HAA2H;EAC7H;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,8HAA8H;EAChI;EACA;IACE,6BAA6B;IAC7B,8HAA8H;EAChI;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,8HAA8H;EAChI;EACA;IACE,6BAA6B;IAC7B,8HAA8H;EAChI;EACA;IACE,6BAA6B;IAC7B,8HAA8H;EAChI;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,8HAA8H;EAChI;EACA;IACE,6BAA6B;IAC7B,8HAA8H;EAChI;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,4HAA4H;EAC9H;EACA;IACE,6BAA6B;IAC7B,4HAA4H;EAC9H;EACA;IACE,6BAA6B;IAC7B,4HAA4H;EAC9H;EACA;IACE,iCAAiC;EACnC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,mCAAmC;IACnC,oGAAoG;EACtG;EACA;IACE,kCAAkC;IAClC,8FAA8F;EAChG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,8FAA8F;EAChG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,iGAAiG;EACnG;EACA;IACE,8BAA8B;IAC9B,iGAAiG;EACnG;EACA;IACE,8BAA8B;IAC9B,iGAAiG;EACnG;EACA;IACE,8BAA8B;IAC9B,iGAAiG;EACnG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,mGAAmG;EACrG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,iGAAiG;EACnG;EACA;IACE,8BAA8B;IAC9B,iGAAiG;EACnG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,mGAAmG;EACrG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,iGAAiG;EACnG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,mGAAmG;EACrG;EACA;IACE,8BAA8B;IAC9B,mGAAmG;EACrG;EACA;IACE,8BAA8B;IAC9B,iGAAiG;EACnG;EACA;IACE,8BAA8B;IAC9B,iGAAiG;EACnG;EACA;IACE,8BAA8B;IAC9B,gGAAgG;EAClG;EACA;IACE,8BAA8B;IAC9B,gGAAgG;EAClG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,mGAAmG;EACrG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,gGAAgG;EAClG;EACA;IACE,8BAA8B;IAC9B,gGAAgG;EAClG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,mGAAmG;EACrG;EACA;IACE,8BAA8B;IAC9B,mGAAmG;EACrG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,mGAAmG;EACrG;EACA;IACE,8BAA8B;IAC9B,mGAAmG;EACrG;EACA;IACE,8BAA8B;IAC9B,mGAAmG;EACrG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,mGAAmG;EACrG;EACA;IACE,8BAA8B;IAC9B,mGAAmG;EACrG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,iGAAiG;EACnG;EACA;IACE,8BAA8B;IAC9B,iGAAiG;EACnG;EACA;IACE,8BAA8B;IAC9B,iGAAiG;EACnG;EACA;IACE,kCAAkC;IAClC,+HAA+H;EACjI;EACA;IACE,iCAAiC;IACjC,yHAAyH;EAC3H;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,yHAAyH;EAC3H;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,4HAA4H;EAC9H;EACA;IACE,6BAA6B;IAC7B,4HAA4H;EAC9H;EACA;IACE,6BAA6B;IAC7B,4HAA4H;EAC9H;EACA;IACE,6BAA6B;IAC7B,4HAA4H;EAC9H;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,8HAA8H;EAChI;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,4HAA4H;EAC9H;EACA;IACE,6BAA6B;IAC7B,4HAA4H;EAC9H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,8HAA8H;EAChI;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,4HAA4H;EAC9H;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,8HAA8H;EAChI;EACA;IACE,6BAA6B;IAC7B,8HAA8H;EAChI;EACA;IACE,6BAA6B;IAC7B,4HAA4H;EAC9H;EACA;IACE,6BAA6B;IAC7B,4HAA4H;EAC9H;EACA;IACE,6BAA6B;IAC7B,2HAA2H;EAC7H;EACA;IACE,6BAA6B;IAC7B,2HAA2H;EAC7H;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,8HAA8H;EAChI;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,2HAA2H;EAC7H;EACA;IACE,6BAA6B;IAC7B,2HAA2H;EAC7H;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,8HAA8H;EAChI;EACA;IACE,6BAA6B;IAC7B,8HAA8H;EAChI;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,8HAA8H;EAChI;EACA;IACE,6BAA6B;IAC7B,8HAA8H;EAChI;EACA;IACE,6BAA6B;IAC7B,8HAA8H;EAChI;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,8HAA8H;EAChI;EACA;IACE,6BAA6B;IAC7B,8HAA8H;EAChI;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,4HAA4H;EAC9H;EACA;IACE,6BAA6B;IAC7B,4HAA4H;EAC9H;EACA;IACE,6BAA6B;IAC7B,4HAA4H;EAC9H;EACA;IACE,iCAAiC;EACnC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,mCAAmC;IACnC,oGAAoG;EACtG;EACA;IACE,kCAAkC;IAClC,8FAA8F;EAChG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,8FAA8F;EAChG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,iGAAiG;EACnG;EACA;IACE,8BAA8B;IAC9B,iGAAiG;EACnG;EACA;IACE,8BAA8B;IAC9B,iGAAiG;EACnG;EACA;IACE,8BAA8B;IAC9B,iGAAiG;EACnG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,mGAAmG;EACrG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,iGAAiG;EACnG;EACA;IACE,8BAA8B;IAC9B,iGAAiG;EACnG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,mGAAmG;EACrG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,iGAAiG;EACnG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,mGAAmG;EACrG;EACA;IACE,8BAA8B;IAC9B,mGAAmG;EACrG;EACA;IACE,8BAA8B;IAC9B,iGAAiG;EACnG;EACA;IACE,8BAA8B;IAC9B,iGAAiG;EACnG;EACA;IACE,8BAA8B;IAC9B,gGAAgG;EAClG;EACA;IACE,8BAA8B;IAC9B,gGAAgG;EAClG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,mGAAmG;EACrG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,gGAAgG;EAClG;EACA;IACE,8BAA8B;IAC9B,gGAAgG;EAClG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,mGAAmG;EACrG;EACA;IACE,8BAA8B;IAC9B,mGAAmG;EACrG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,mGAAmG;EACrG;EACA;IACE,8BAA8B;IAC9B,mGAAmG;EACrG;EACA;IACE,8BAA8B;IAC9B,mGAAmG;EACrG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,mGAAmG;EACrG;EACA;IACE,8BAA8B;IAC9B,mGAAmG;EACrG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,iGAAiG;EACnG;EACA;IACE,8BAA8B;IAC9B,iGAAiG;EACnG;EACA;IACE,8BAA8B;IAC9B,iGAAiG;EACnG;EACA;IACE,kCAAkC;IAClC,+HAA+H;EACjI;EACA;IACE,iCAAiC;IACjC,yHAAyH;EAC3H;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,yHAAyH;EAC3H;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,4HAA4H;EAC9H;EACA;IACE,6BAA6B;IAC7B,4HAA4H;EAC9H;EACA;IACE,6BAA6B;IAC7B,4HAA4H;EAC9H;EACA;IACE,6BAA6B;IAC7B,4HAA4H;EAC9H;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,8HAA8H;EAChI;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,4HAA4H;EAC9H;EACA;IACE,6BAA6B;IAC7B,4HAA4H;EAC9H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,8HAA8H;EAChI;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,4HAA4H;EAC9H;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,8HAA8H;EAChI;EACA;IACE,6BAA6B;IAC7B,8HAA8H;EAChI;EACA;IACE,6BAA6B;IAC7B,4HAA4H;EAC9H;EACA;IACE,6BAA6B;IAC7B,4HAA4H;EAC9H;EACA;IACE,6BAA6B;IAC7B,2HAA2H;EAC7H;EACA;IACE,6BAA6B;IAC7B,2HAA2H;EAC7H;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,8HAA8H;EAChI;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,2HAA2H;EAC7H;EACA;IACE,6BAA6B;IAC7B,2HAA2H;EAC7H;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,8HAA8H;EAChI;EACA;IACE,6BAA6B;IAC7B,8HAA8H;EAChI;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,8HAA8H;EAChI;EACA;IACE,6BAA6B;IAC7B,8HAA8H;EAChI;EACA;IACE,6BAA6B;IAC7B,8HAA8H;EAChI;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,8HAA8H;EAChI;EACA;IACE,6BAA6B;IAC7B,8HAA8H;EAChI;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,4HAA4H;EAC9H;EACA;IACE,6BAA6B;IAC7B,4HAA4H;EAC9H;EACA;IACE,6BAA6B;IAC7B,4HAA4H;EAC9H;EACA;IACE,iCAAiC;EACnC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,eAAe;EACjB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,eAAe;EACjB;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,gCAAgC;EAClC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,iCAAiC;EACnC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,qBAAqB;EACvB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,kDAAkD;EACpD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,oDAAoD;EACtD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,oDAAoD;EACtD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,oDAAoD;EACtD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,oDAAoD;EACtD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,kDAAkD;EACpD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,oDAAoD;EACtD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,oDAAoD;EACtD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,oDAAoD;EACtD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,oDAAoD;EACtD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,kDAAkD;EACpD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,oDAAoD;EACtD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,oDAAoD;EACtD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,oDAAoD;EACtD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,oDAAoD;EACtD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,kDAAkD;EACpD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,oDAAoD;EACtD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,oDAAoD;EACtD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,oDAAoD;EACtD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,oDAAoD;EACtD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,kDAAkD;EACpD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,oDAAoD;EACtD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,oDAAoD;EACtD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,oDAAoD;EACtD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,oDAAoD;EACtD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,kDAAkD;EACpD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,oDAAoD;EACtD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,oDAAoD;EACtD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,oDAAoD;EACtD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,oDAAoD;EACtD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;EACrB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,yBAAyB;IACzB,0BAA0B;EAC5B;EACA;IACE,0BAA0B;IAC1B,6BAA6B;EAC/B;EACA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;EACA;IACE,yBAAyB;IACzB,4BAA4B;EAC9B;EACA;IACE,gCAAgC;IAChC,iCAAiC;EACnC;EACA;IACE,iCAAiC;IACjC,oCAAoC;EACtC;EACA;IACE,oCAAoC;IACpC,mCAAmC;EACrC;EACA;IACE,gCAAgC;IAChC,mCAAmC;EACrC;EACA;IACE,+BAA+B;IAC/B,gCAAgC;EAClC;EACA;IACE,gCAAgC;IAChC,mCAAmC;EACrC;EACA;IACE,mCAAmC;IACnC,kCAAkC;EACpC;EACA;IACE,+BAA+B;IAC/B,kCAAkC;EACpC;EACA;IACE,gCAAgC;IAChC,iCAAiC;EACnC;EACA;IACE,iCAAiC;IACjC,oCAAoC;EACtC;EACA;IACE,oCAAoC;IACpC,mCAAmC;EACrC;EACA;IACE,gCAAgC;IAChC,mCAAmC;EACrC;EACA;IACE,8BAA8B;IAC9B,+BAA+B;EACjC;EACA;IACE,+BAA+B;IAC/B,kCAAkC;EACpC;EACA;IACE,kCAAkC;IAClC,iCAAiC;EACnC;EACA;IACE,8BAA8B;IAC9B,iCAAiC;EACnC;EACA;IACE,+BAA+B;IAC/B,gCAAgC;EAClC;EACA;IACE,gCAAgC;IAChC,mCAAmC;EACrC;EACA;IACE,mCAAmC;IACnC,kCAAkC;EACpC;EACA;IACE,+BAA+B;IAC/B,kCAAkC;EACpC;EACA;IACE,4BAA4B;IAC5B,6BAA6B;EAC/B;EACA;IACE,6BAA6B;IAC7B,gCAAgC;EAClC;EACA;IACE,gCAAgC;IAChC,+BAA+B;EACjC;EACA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;EACA;IACE,8BAA8B;IAC9B,+BAA+B;EACjC;EACA;IACE,+BAA+B;IAC/B,kCAAkC;EACpC;EACA;IACE,kCAAkC;IAClC,iCAAiC;EACnC;EACA;IACE,8BAA8B;IAC9B,iCAAiC;EACnC;EACA;IACE,8BAA8B;IAC9B,+BAA+B;EACjC;EACA;IACE,+BAA+B;IAC/B,kCAAkC;EACpC;EACA;IACE,kCAAkC;IAClC,iCAAiC;EACnC;EACA;IACE,8BAA8B;IAC9B,iCAAiC;EACnC;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,gCAAgC;EAClC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,gCAAgC;EAClC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,YAAY;EACd;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,mBAAmB;EACrB;EACA;IACE,cAAc;EAChB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;EACf;EACA;IACE,oBAAoB;EACtB;EACA;IACE,cAAc;EAChB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,aAAa;EACf;EACA;IACE,oBAAoB;EACtB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,aAAa;EACf;EACA;IACE,mBAAmB;EACrB;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,8BAA8B;EAChC;EACA;IACE,eAAe;EACjB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,gBAAgB;EAClB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,8BAA8B;EAChC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,SAAY;EACd;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA;IACE,UAAU;EACZ;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA;IACE,QAAQ;EACV;EACA;IACE,QAAQ;EACV;EACA;IACE,QAAQ;EACV;EACA;IACE,QAAQ;EACV;EACA;IACE,QAAQ;EACV;EACA;IACE,QAAQ;EACV;EACA;IACE,QAAQ;EACV;EACA;IACE,QAAQ;EACV;EACA;IACE,QAAQ;EACV;EACA;IACE,SAAS;EACX;EACA;IACE,SAAS;EACX;EACA;IACE,SAAS;EACX;EACA;IACE,YAAY;EACd;EACA;IACE,WAAW;EACb;EACA;IACE,QAAQ;EACV;EACA;IACE,YAAY;EACd;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;IACX,cAAc;IACd,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,YAAY;EACd;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,6MAA6M;EAC/M;EACA;IACE,8DAA8D;EAChE;EACA;IACE,iFAAiF;EACnF;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,SAAS;EACX;EACA;IACE,eAAe;EACjB;EACA;IACE,cAAc;EAChB;EACA;IACE,eAAe;EACjB;EACA;IACE,YAAY;EACd;EACA;IACE,eAAe;EACjB;EACA;IACE,cAAc;EAChB;EACA;IACE,eAAe;EACjB;EACA;IACE,YAAY;EACd;EACA;IACE,eAAe;EACjB;EACA;IACE,cAAc;EAChB;EACA;IACE,eAAe;EACjB;EACA;IACE,YAAY;EACd;EACA;IACE,eAAe;EACjB;EACA;IACE,cAAc;EAChB;EACA;IACE,eAAe;EACjB;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,YAAY;EACd;EACA;IACE,WAAW;EACb;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,WAAW;EACb;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,WAAW;EACb;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,WAAW;EACb;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,WAAW;EACb;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,WAAW;EACb;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,YAAY;EACd;EACA;IACE,aAAa;EACf;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,eAAe;EACjB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,cAAc;EAChB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,cAAc;EAChB;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,SAAS;EACX;EACA;IACE,eAAe;EACjB;EACA;IACE,cAAc;EAChB;EACA;IACE,eAAe;EACjB;EACA;IACE,YAAY;EACd;EACA;IACE,eAAe;EACjB;EACA;IACE,cAAc;EAChB;EACA;IACE,eAAe;EACjB;EACA;IACE,YAAY;EACd;EACA;IACE,eAAe;EACjB;EACA;IACE,cAAc;EAChB;EACA;IACE,eAAe;EACjB;EACA;IACE,YAAY;EACd;EACA;IACE,eAAe;EACjB;EACA;IACE,cAAc;EAChB;EACA;IACE,eAAe;EACjB;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,YAAY;EACd;EACA;IACE,WAAW;EACb;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,WAAW;EACb;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,WAAW;EACb;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,WAAW;EACb;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,WAAW;EACb;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,WAAW;EACb;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,YAAY;EACd;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,aAAa;EACf;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,aAAa;EACf;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,aAAa;EACf;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA;IACE,YAAY;EACd;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,YAAY;EACd;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,YAAY;EACd;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,YAAY;EACd;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,YAAY;EACd;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,YAAY;EACd;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;IACb,gBAAgB;EAClB;EACA;IACE,cAAc;IACd,eAAe;EACjB;EACA;IACE,mBAAmB;IACnB,sBAAsB;EACxB;EACA;IACE,oBAAoB;IACpB,qBAAqB;EACvB;EACA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;EACA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;EACA;IACE,mBAAmB;IACnB,sBAAsB;EACxB;EACA;IACE,oBAAoB;IACpB,qBAAqB;EACvB;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,mBAAmB;IACnB,sBAAsB;EACxB;EACA;IACE,oBAAoB;IACpB,qBAAqB;EACvB;EACA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;EACA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;EACA;IACE,mBAAmB;IACnB,sBAAsB;EACxB;EACA;IACE,oBAAoB;IACpB,qBAAqB;EACvB;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,mBAAmB;IACnB,sBAAsB;EACxB;EACA;IACE,oBAAoB;IACpB,qBAAqB;EACvB;EACA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;EACA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;EACA;IACE,mBAAmB;IACnB,sBAAsB;EACxB;EACA;IACE,oBAAoB;IACpB,qBAAqB;EACvB;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,mBAAmB;IACnB,sBAAsB;EACxB;EACA;IACE,oBAAoB;IACpB,qBAAqB;EACvB;EACA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;EACA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;EACA;IACE,mBAAmB;IACnB,sBAAsB;EACxB;EACA;IACE,oBAAoB;IACpB,qBAAqB;EACvB;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE,oBAAoB;IACpB,uBAAuB;EACzB;EACA;IACE,qBAAqB;IACrB,sBAAsB;EACxB;EACA;IACE,oBAAoB;IACpB,uBAAuB;EACzB;EACA;IACE,qBAAqB;IACrB,sBAAsB;EACxB;EACA;IACE,oBAAoB;IACpB,uBAAuB;EACzB;EACA;IACE,qBAAqB;IACrB,sBAAsB;EACxB;EACA;IACE,oBAAoB;IACpB,uBAAuB;EACzB;EACA;IACE,qBAAqB;IACrB,sBAAsB;EACxB;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE,sBAAsB;IACtB,yBAAyB;EAC3B;EACA;IACE,uBAAuB;IACvB,wBAAwB;EAC1B;EACA;IACE,sBAAsB;IACtB,yBAAyB;EAC3B;EACA;IACE,uBAAuB;IACvB,wBAAwB;EAC1B;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE,sBAAsB;IACtB,yBAAyB;EAC3B;EACA;IACE,uBAAuB;IACvB,wBAAwB;EAC1B;EACA;IACE,sBAAsB;IACtB,yBAAyB;EAC3B;EACA;IACE,uBAAuB;IACvB,wBAAwB;EAC1B;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE,sBAAsB;IACtB,yBAAyB;EAC3B;EACA;IACE,uBAAuB;IACvB,wBAAwB;EAC1B;EACA;IACE,sBAAsB;IACtB,yBAAyB;EAC3B;EACA;IACE,uBAAuB;IACvB,wBAAwB;EAC1B;EACA;IACE,qBAAqB;IACrB,wBAAwB;EAC1B;EACA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,sBAAsB;IACtB,yBAAyB;EAC3B;EACA;IACE,uBAAuB;IACvB,wBAAwB;EAC1B;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE,sBAAsB;IACtB,yBAAyB;EAC3B;EACA;IACE,uBAAuB;IACvB,wBAAwB;EAC1B;EACA;IACE,sBAAsB;IACtB,yBAAyB;EAC3B;EACA;IACE,uBAAuB;IACvB,wBAAwB;EAC1B;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE,sBAAsB;IACtB,yBAAyB;EAC3B;EACA;IACE,uBAAuB;IACvB,wBAAwB;EAC1B;EACA;IACE,sBAAsB;IACtB,yBAAyB;EAC3B;EACA;IACE,uBAAuB;IACvB,wBAAwB;EAC1B;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE,sBAAsB;IACtB,yBAAyB;EAC3B;EACA;IACE,uBAAuB;IACvB,wBAAwB;EAC1B;EACA;IACE,sBAAsB;IACtB,yBAAyB;EAC3B;EACA;IACE,uBAAuB;IACvB,wBAAwB;EAC1B;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,oBAAoB;IACpB,uBAAuB;EACzB;EACA;IACE,qBAAqB;IACrB,sBAAsB;EACxB;EACA;IACE,mBAAmB;IACnB,sBAAsB;EACxB;EACA;IACE,oBAAoB;IACpB,qBAAqB;EACvB;EACA;IACE,oBAAoB;IACpB,uBAAuB;EACzB;EACA;IACE,qBAAqB;IACrB,sBAAsB;EACxB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,oBAAoB;IACpB,uBAAuB;EACzB;EACA;IACE,qBAAqB;IACrB,sBAAsB;EACxB;EACA;IACE,mBAAmB;IACnB,sBAAsB;EACxB;EACA;IACE,oBAAoB;IACpB,qBAAqB;EACvB;EACA;IACE,oBAAoB;IACpB,uBAAuB;EACzB;EACA;IACE,qBAAqB;IACrB,sBAAsB;EACxB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,oBAAoB;IACpB,uBAAuB;EACzB;EACA;IACE,qBAAqB;IACrB,sBAAsB;EACxB;EACA;IACE,mBAAmB;IACnB,sBAAsB;EACxB;EACA;IACE,oBAAoB;IACpB,qBAAqB;EACvB;EACA;IACE,oBAAoB;IACpB,uBAAuB;EACzB;EACA;IACE,qBAAqB;IACrB,sBAAsB;EACxB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,oBAAoB;IACpB,uBAAuB;EACzB;EACA;IACE,qBAAqB;IACrB,sBAAsB;EACxB;EACA;IACE,mBAAmB;IACnB,sBAAsB;EACxB;EACA;IACE,oBAAoB;IACpB,qBAAqB;EACvB;EACA;IACE,oBAAoB;IACpB,uBAAuB;EACzB;EACA;IACE,qBAAqB;IACrB,sBAAsB;EACxB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;EACA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;EACA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;EACA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;EACA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;EACA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;EACA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;EACA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;EACA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;EACA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;EACA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,qBAAqB;IACrB,wBAAwB;EAC1B;EACA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,qBAAqB;IACrB,wBAAwB;EAC1B;EACA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,qBAAqB;IACrB,wBAAwB;EAC1B;EACA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,qBAAqB;IACrB,wBAAwB;EAC1B;EACA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,sBAAsB;IACtB,yBAAyB;EAC3B;EACA;IACE,uBAAuB;IACvB,wBAAwB;EAC1B;EACA;IACE,sBAAsB;IACtB,yBAAyB;EAC3B;EACA;IACE,uBAAuB;IACvB,wBAAwB;EAC1B;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,sBAAsB;IACtB,yBAAyB;EAC3B;EACA;IACE,uBAAuB;IACvB,wBAAwB;EAC1B;EACA;IACE,sBAAsB;IACtB,yBAAyB;EAC3B;EACA;IACE,uBAAuB;IACvB,wBAAwB;EAC1B;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,sBAAsB;IACtB,yBAAyB;EAC3B;EACA;IACE,uBAAuB;IACvB,wBAAwB;EAC1B;EACA;IACE,sBAAsB;IACtB,yBAAyB;EAC3B;EACA;IACE,uBAAuB;IACvB,wBAAwB;EAC1B;EACA;IACE,qBAAqB;IACrB,wBAAwB;EAC1B;EACA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,sBAAsB;IACtB,yBAAyB;EAC3B;EACA;IACE,uBAAuB;IACvB,wBAAwB;EAC1B;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,sBAAsB;IACtB,yBAAyB;EAC3B;EACA;IACE,uBAAuB;IACvB,wBAAwB;EAC1B;EACA;IACE,sBAAsB;IACtB,yBAAyB;EAC3B;EACA;IACE,uBAAuB;IACvB,wBAAwB;EAC1B;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,sBAAsB;IACtB,yBAAyB;EAC3B;EACA;IACE,uBAAuB;IACvB,wBAAwB;EAC1B;EACA;IACE,sBAAsB;IACtB,yBAAyB;EAC3B;EACA;IACE,uBAAuB;IACvB,wBAAwB;EAC1B;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,sBAAsB;IACtB,yBAAyB;EAC3B;EACA;IACE,uBAAuB;IACvB,wBAAwB;EAC1B;EACA;IACE,sBAAsB;IACtB,yBAAyB;EAC3B;EACA;IACE,uBAAuB;IACvB,wBAAwB;EAC1B;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,aAAa;EACf;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,cAAc;EAChB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,aAAa;EACf;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,eAAe;EACjB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,eAAe;EACjB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,eAAe;EACjB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,eAAe;EACjB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,eAAe;EACjB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IAEE,sBAAsB;EACxB;EACA;IAEE,sBAAsB;EACxB;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,aAAa;EACf;EACA;IACE,gBAAgB;EAClB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,YAAY;EACd;EACA;IACE,eAAe;EACjB;EACA;IAEE,sBAAsB;EACxB;EACA;IAEE,sBAAsB;EACxB;EACA;IAEE,mBAAmB;EACrB;EACA;IAEE,iBAAiB;EACnB;EACA;IAEE,gBAAgB;EAClB;EACA;IAEE,gBAAgB;EAClB;EACA;IAEE,sBAAsB;EACxB;EACA;IAEE,uBAAuB;EACzB;EACA;IAEE,uBAAuB;EACzB;EACA;IAEE,qBAAqB;EACvB;EACA;IAEE,4BAA4B;EAC9B;EACA;IAEE,yBAAyB;EAC3B;EACA;IAEE,sBAAsB;EACxB;EACA;IAEE,6BAA6B;EAC/B;EACA;IAEE,0BAA0B;EAC5B;EACA;IAEE,oBAAoB;EACtB;EACA;IACE,UAAU;EACZ;EACA;IACE,aAAa;EACf;EACA;IACE,YAAY;EACd;EACA;IACE,aAAa;EACf;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,aAAa;EACf;EACA;IACE,YAAY;EACd;EACA;IACE,aAAa;EACf;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,aAAa;EACf;EACA;IACE,YAAY;EACd;EACA;IACE,aAAa;EACf;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,aAAa;EACf;EACA;IACE,YAAY;EACd;EACA;IACE,aAAa;EACf;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,aAAa;EACf;EACA;IACE,YAAY;EACd;EACA;IACE,aAAa;EACf;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,aAAa;EACf;EACA;IACE,YAAY;EACd;EACA;IACE,aAAa;EACf;EACA;IACE,UAAU;EACZ;EACA;IACE,8BAA8B;IAC9B,mBAAmB;EACrB;EACA;IACE,yBAAyB;IACzB,mBAAmB;EACrB;EACA;IACE,yBAAyB;IACzB,mBAAmB;EACrB;EACA;IACE,8BAA8B;IAC9B,mBAAmB;EACrB;EACA;IACE,yBAAyB;IACzB,mBAAmB;EACrB;EACA;IACE,yBAAyB;IACzB,mBAAmB;EACrB;EACA;IACE,cAAc;EAChB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iCAAiC;EACnC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,8BAA8B;EAChC;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,8BAA8B;EAChC;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,UAAU;EACZ;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,aAAa;EACf;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,aAAa;EACf;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,aAAa;EACf;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA;IACE,YAAY;EACd;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,YAAY;EACd;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,YAAY;EACd;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,YAAY;EACd;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,YAAY;EACd;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,YAAY;EACd;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,aAAa;EACf;EACA;IACE,cAAc;IACd,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,oBAAoB;IACpB,uBAAuB;EACzB;EACA;IACE,qBAAqB;IACrB,sBAAsB;EACxB;EACA;IACE,mBAAmB;IACnB,sBAAsB;EACxB;EACA;IACE,oBAAoB;IACpB,qBAAqB;EACvB;EACA;IACE,oBAAoB;IACpB,uBAAuB;EACzB;EACA;IACE,qBAAqB;IACrB,sBAAsB;EACxB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,oBAAoB;IACpB,uBAAuB;EACzB;EACA;IACE,qBAAqB;IACrB,sBAAsB;EACxB;EACA;IACE,mBAAmB;IACnB,sBAAsB;EACxB;EACA;IACE,oBAAoB;IACpB,qBAAqB;EACvB;EACA;IACE,oBAAoB;IACpB,uBAAuB;EACzB;EACA;IACE,qBAAqB;IACrB,sBAAsB;EACxB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,oBAAoB;IACpB,uBAAuB;EACzB;EACA;IACE,qBAAqB;IACrB,sBAAsB;EACxB;EACA;IACE,mBAAmB;IACnB,sBAAsB;EACxB;EACA;IACE,oBAAoB;IACpB,qBAAqB;EACvB;EACA;IACE,oBAAoB;IACpB,uBAAuB;EACzB;EACA;IACE,qBAAqB;IACrB,sBAAsB;EACxB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,oBAAoB;IACpB,uBAAuB;EACzB;EACA;IACE,qBAAqB;IACrB,sBAAsB;EACxB;EACA;IACE,mBAAmB;IACnB,sBAAsB;EACxB;EACA;IACE,oBAAoB;IACpB,qBAAqB;EACvB;EACA;IACE,oBAAoB;IACpB,uBAAuB;EACzB;EACA;IACE,qBAAqB;IACrB,sBAAsB;EACxB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;EACA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;EACA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;EACA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;EACA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;EACA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;EACA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;EACA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;EACA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;EACA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;EACA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,qBAAqB;IACrB,wBAAwB;EAC1B;EACA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,qBAAqB;IACrB,wBAAwB;EAC1B;EACA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,qBAAqB;IACrB,wBAAwB;EAC1B;EACA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,qBAAqB;IACrB,wBAAwB;EAC1B;EACA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,wBAAwB;IACxB,yBAAyB;EAC3B;EACA;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,wBAAwB;IACxB,yBAAyB;EAC3B;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,wBAAwB;IACxB,yBAAyB;EAC3B;EACA;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,wBAAwB;IACxB,yBAAyB;EAC3B;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,wBAAwB;IACxB,yBAAyB;EAC3B;EACA;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,wBAAwB;IACxB,yBAAyB;EAC3B;EACA;IACE,sBAAsB;IACtB,yBAAyB;EAC3B;EACA;IACE,uBAAuB;IACvB,wBAAwB;EAC1B;EACA;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,wBAAwB;IACxB,yBAAyB;EAC3B;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,wBAAwB;IACxB,yBAAyB;EAC3B;EACA;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,wBAAwB;IACxB,yBAAyB;EAC3B;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,wBAAwB;IACxB,yBAAyB;EAC3B;EACA;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,wBAAwB;IACxB,yBAAyB;EAC3B;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,wBAAwB;IACxB,yBAAyB;EAC3B;EACA;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,wBAAwB;IACxB,yBAAyB;EAC3B;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,cAAc;EAChB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EAIA;IACE,mBAAmB;EACrB;EAIA;IACE,kBAAkB;EACpB;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,gDAAgD;EAClD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,mDAAmD;EACrD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,mDAAmD;EACrD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,mDAAmD;EACrD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,mDAAmD;EACrD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,qDAAqD;EACvD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,mDAAmD;EACrD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,mDAAmD;EACrD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,qDAAqD;EACvD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,mDAAmD;EACrD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,qDAAqD;EACvD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,qDAAqD;EACvD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,mDAAmD;EACrD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,mDAAmD;EACrD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,kDAAkD;EACpD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,kDAAkD;EACpD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,qDAAqD;EACvD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,kDAAkD;EACpD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,kDAAkD;EACpD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,qDAAqD;EACvD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,qDAAqD;EACvD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,qDAAqD;EACvD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,qDAAqD;EACvD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,qDAAqD;EACvD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,qDAAqD;EACvD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,qDAAqD;EACvD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,mDAAmD;EACrD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,mDAAmD;EACrD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,mDAAmD;EACrD;EAIA;IACE,mBAAmB;EACrB;EAIA;IACE,kBAAkB;EACpB;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,gDAAgD;EAClD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,mDAAmD;EACrD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,mDAAmD;EACrD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,mDAAmD;EACrD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,mDAAmD;EACrD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,qDAAqD;EACvD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,mDAAmD;EACrD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,mDAAmD;EACrD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,qDAAqD;EACvD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,mDAAmD;EACrD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,qDAAqD;EACvD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,qDAAqD;EACvD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,mDAAmD;EACrD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,mDAAmD;EACrD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,kDAAkD;EACpD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,kDAAkD;EACpD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,qDAAqD;EACvD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,kDAAkD;EACpD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,kDAAkD;EACpD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,qDAAqD;EACvD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,qDAAqD;EACvD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,qDAAqD;EACvD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,qDAAqD;EACvD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,qDAAqD;EACvD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,qDAAqD;EACvD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,qDAAqD;EACvD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,mDAAmD;EACrD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,mDAAmD;EACrD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,mDAAmD;EACrD;EAIA;IACE,wBAAwB;EAC1B;EAIA;IACE,2BAA2B;EAC7B;EAIA;IACE,0BAA0B;EAC5B;EAIA;IACE,2BAA2B;EAC7B;EAIA;IACE,wBAAwB;EAC1B;EAIA;IACE,wBAAwB;EAC1B;EAIA;IACE,2BAA2B;EAC7B;EAIA;IACE,0BAA0B;EAC5B;EAIA;IACE,2BAA2B;EAC7B;EAIA;IACE,wBAAwB;EAC1B;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,MAAM;IACN,QAAQ;IACR,SAAS;IACT,OAAO;EACT;EACA;IACE,YAAY;IACZ,cAAc;IACd,eAAe;IACf,aAAa;EACf;EACA;IACE,WAAW;IACX,aAAa;IACb,cAAc;IACd,YAAY;EACd;EACA;IACE,YAAY;IACZ,cAAc;IACd,eAAe;IACf,aAAa;EACf;EACA;IACE,SAAS;IACT,WAAW;IACX,YAAY;IACZ,UAAU;EACZ;EACA;IACE,YAAY;IACZ,cAAc;IACd,eAAe;IACf,aAAa;EACf;EACA;IACE,WAAW;IACX,aAAa;IACb,cAAc;IACd,YAAY;EACd;EACA;IACE,YAAY;IACZ,cAAc;IACd,eAAe;IACf,aAAa;EACf;EACA;IACE,SAAS;IACT,WAAW;IACX,YAAY;IACZ,UAAU;EACZ;EACA;IACE,YAAY;IACZ,cAAc;IACd,eAAe;IACf,aAAa;EACf;EACA;IACE,WAAW;IACX,aAAa;IACb,cAAc;IACd,YAAY;EACd;EACA;IACE,YAAY;IACZ,cAAc;IACd,eAAe;IACf,aAAa;EACf;EACA;IACE,SAAS;IACT,WAAW;IACX,YAAY;IACZ,UAAU;EACZ;EACA;IACE,YAAY;IACZ,cAAc;IACd,eAAe;IACf,aAAa;EACf;EACA;IACE,WAAW;IACX,aAAa;IACb,cAAc;IACd,YAAY;EACd;EACA;IACE,YAAY;IACZ,cAAc;IACd,eAAe;IACf,aAAa;EACf;EACA;IACE,SAAS;IACT,WAAW;IACX,YAAY;IACZ,UAAU;EACZ;EACA;IACE,SAAS;IACT,WAAW;IACX,YAAY;IACZ,UAAU;EACZ;EACA;IACE,SAAS;IACT,WAAW;IACX,YAAY;IACZ,UAAU;EACZ;EACA;IACE,SAAS;IACT,WAAW;IACX,YAAY;IACZ,UAAU;EACZ;EACA;IACE,SAAS;IACT,WAAW;IACX,YAAY;IACZ,UAAU;EACZ;EACA;IACE,SAAS;IACT,WAAW;IACX,YAAY;IACZ,UAAU;EACZ;EACA;IACE,UAAU;IACV,YAAY;IACZ,aAAa;IACb,WAAW;EACb;EACA;IACE,UAAU;IACV,YAAY;IACZ,aAAa;IACb,WAAW;EACb;EACA;IACE,UAAU;IACV,YAAY;IACZ,aAAa;IACb,WAAW;EACb;EACA;IACE,UAAU;IACV,YAAY;IACZ,aAAa;IACb,WAAW;EACb;EACA;IACE,UAAU;IACV,YAAY;IACZ,aAAa;IACb,WAAW;EACb;EACA;IACE,UAAU;IACV,YAAY;IACZ,aAAa;IACb,WAAW;EACb;EACA;IACE,UAAU;IACV,YAAY;IACZ,aAAa;IACb,WAAW;EACb;EACA;IACE,UAAU;IACV,YAAY;IACZ,aAAa;IACb,WAAW;EACb;EACA;IACE,UAAU;IACV,YAAY;IACZ,aAAa;IACb,WAAW;EACb;EACA;IACE,UAAU;IACV,YAAY;IACZ,aAAa;IACb,WAAW;EACb;EACA;IACE,SAAS;IACT,WAAW;IACX,YAAY;IACZ,UAAU;EACZ;EACA;IACE,QAAQ;IACR,UAAU;IACV,WAAW;IACX,SAAS;EACX;EACA;IACE,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,cAAc;EAChB;EACA;IACE,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,cAAc;EAChB;EACA;IACE,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,cAAc;EAChB;EACA;IACE,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,cAAc;EAChB;EACA;IACE,QAAQ;IACR,UAAU;IACV,WAAW;IACX,SAAS;EACX;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;EAClB;EACA;IACE,QAAQ;IACR,UAAU;IACV,WAAW;IACX,SAAS;EACX;EACA;IACE,QAAQ;IACR,UAAU;IACV,WAAW;IACX,SAAS;EACX;EACA;IACE,QAAQ;IACR,UAAU;IACV,WAAW;IACX,SAAS;EACX;EACA;IACE,QAAQ;IACR,UAAU;IACV,WAAW;IACX,SAAS;EACX;EACA;IACE,QAAQ;IACR,UAAU;IACV,WAAW;IACX,SAAS;EACX;EACA;IACE,QAAQ;IACR,UAAU;IACV,WAAW;IACX,SAAS;EACX;EACA;IACE,QAAQ;IACR,UAAU;IACV,WAAW;IACX,SAAS;EACX;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;EAClB;EACA;IACE,QAAQ;IACR,UAAU;IACV,WAAW;IACX,SAAS;EACX;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;EAClB;EACA;IACE,cAAc;IACd,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;EACjB;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;EAClB;EACA;IACE,QAAQ;IACR,UAAU;IACV,WAAW;IACX,SAAS;EACX;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;EAClB;EACA;IACE,QAAQ;IACR,UAAU;IACV,WAAW;IACX,SAAS;EACX;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;EAClB;EACA;IACE,QAAQ;IACR,UAAU;IACV,WAAW;IACX,SAAS;EACX;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;EAClB;EACA;IACE,SAAS;IACT,WAAW;IACX,YAAY;IACZ,UAAU;EACZ;EACA;IACE,MAAM;IACN,SAAS;EACX;EACA;IACE,QAAQ;IACR,OAAO;EACT;EACA;IACE,YAAY;IACZ,eAAe;EACjB;EACA;IACE,cAAc;IACd,aAAa;EACf;EACA;IACE,WAAW;IACX,cAAc;EAChB;EACA;IACE,aAAa;IACb,YAAY;EACd;EACA;IACE,YAAY;IACZ,eAAe;EACjB;EACA;IACE,cAAc;IACd,aAAa;EACf;EACA;IACE,SAAS;IACT,YAAY;EACd;EACA;IACE,WAAW;IACX,UAAU;EACZ;EACA;IACE,YAAY;IACZ,eAAe;EACjB;EACA;IACE,cAAc;IACd,aAAa;EACf;EACA;IACE,WAAW;IACX,cAAc;EAChB;EACA;IACE,aAAa;IACb,YAAY;EACd;EACA;IACE,YAAY;IACZ,eAAe;EACjB;EACA;IACE,cAAc;IACd,aAAa;EACf;EACA;IACE,SAAS;IACT,YAAY;EACd;EACA;IACE,WAAW;IACX,UAAU;EACZ;EACA;IACE,YAAY;IACZ,eAAe;EACjB;EACA;IACE,cAAc;IACd,aAAa;EACf;EACA;IACE,WAAW;IACX,cAAc;EAChB;EACA;IACE,aAAa;IACb,YAAY;EACd;EACA;IACE,YAAY;IACZ,eAAe;EACjB;EACA;IACE,cAAc;IACd,aAAa;EACf;EACA;IACE,SAAS;IACT,YAAY;EACd;EACA;IACE,WAAW;IACX,UAAU;EACZ;EACA;IACE,YAAY;IACZ,eAAe;EACjB;EACA;IACE,cAAc;IACd,aAAa;EACf;EACA;IACE,WAAW;IACX,cAAc;EAChB;EACA;IACE,aAAa;IACb,YAAY;EACd;EACA;IACE,YAAY;IACZ,eAAe;EACjB;EACA;IACE,cAAc;IACd,aAAa;EACf;EACA;IACE,SAAS;IACT,YAAY;EACd;EACA;IACE,WAAW;IACX,UAAU;EACZ;EACA;IACE,SAAS;IACT,YAAY;EACd;EACA;IACE,WAAW;IACX,UAAU;EACZ;EACA;IACE,SAAS;IACT,YAAY;EACd;EACA;IACE,WAAW;IACX,UAAU;EACZ;EACA;IACE,SAAS;IACT,YAAY;EACd;EACA;IACE,WAAW;IACX,UAAU;EACZ;EACA;IACE,SAAS;IACT,YAAY;EACd;EACA;IACE,WAAW;IACX,UAAU;EACZ;EACA;IACE,SAAS;IACT,YAAY;EACd;EACA;IACE,WAAW;IACX,UAAU;EACZ;EACA;IACE,UAAU;IACV,aAAa;EACf;EACA;IACE,YAAY;IACZ,WAAW;EACb;EACA;IACE,UAAU;IACV,aAAa;EACf;EACA;IACE,YAAY;IACZ,WAAW;EACb;EACA;IACE,UAAU;IACV,aAAa;EACf;EACA;IACE,YAAY;IACZ,WAAW;EACb;EACA;IACE,UAAU;IACV,aAAa;EACf;EACA;IACE,YAAY;IACZ,WAAW;EACb;EACA;IACE,UAAU;IACV,aAAa;EACf;EACA;IACE,YAAY;IACZ,WAAW;EACb;EACA;IACE,UAAU;IACV,aAAa;EACf;EACA;IACE,YAAY;IACZ,WAAW;EACb;EACA;IACE,UAAU;IACV,aAAa;EACf;EACA;IACE,YAAY;IACZ,WAAW;EACb;EACA;IACE,UAAU;IACV,aAAa;EACf;EACA;IACE,YAAY;IACZ,WAAW;EACb;EACA;IACE,UAAU;IACV,aAAa;EACf;EACA;IACE,YAAY;IACZ,WAAW;EACb;EACA;IACE,UAAU;IACV,aAAa;EACf;EACA;IACE,YAAY;IACZ,WAAW;EACb;EACA;IACE,SAAS;IACT,YAAY;EACd;EACA;IACE,WAAW;IACX,UAAU;EACZ;EACA;IACE,QAAQ;IACR,WAAW;EACb;EACA;IACE,UAAU;IACV,SAAS;EACX;EACA;IACE,aAAa;IACb,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,cAAc;EAChB;EACA;IACE,aAAa;IACb,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,cAAc;EAChB;EACA;IACE,aAAa;IACb,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,cAAc;EAChB;EACA;IACE,aAAa;IACb,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,cAAc;EAChB;EACA;IACE,QAAQ;IACR,WAAW;EACb;EACA;IACE,UAAU;IACV,SAAS;EACX;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;EACA;IACE,QAAQ;IACR,WAAW;EACb;EACA;IACE,UAAU;IACV,SAAS;EACX;EACA;IACE,QAAQ;IACR,WAAW;EACb;EACA;IACE,UAAU;IACV,SAAS;EACX;EACA;IACE,QAAQ;IACR,WAAW;EACb;EACA;IACE,UAAU;IACV,SAAS;EACX;EACA;IACE,QAAQ;IACR,WAAW;EACb;EACA;IACE,UAAU;IACV,SAAS;EACX;EACA;IACE,QAAQ;IACR,WAAW;EACb;EACA;IACE,UAAU;IACV,SAAS;EACX;EACA;IACE,QAAQ;IACR,WAAW;EACb;EACA;IACE,UAAU;IACV,SAAS;EACX;EACA;IACE,QAAQ;IACR,WAAW;EACb;EACA;IACE,UAAU;IACV,SAAS;EACX;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;EACA;IACE,QAAQ;IACR,WAAW;EACb;EACA;IACE,UAAU;IACV,SAAS;EACX;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;EACA;IACE,cAAc;IACd,iBAAiB;EACnB;EACA;IACE,gBAAgB;IAChB,eAAe;EACjB;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;EACA;IACE,QAAQ;IACR,WAAW;EACb;EACA;IACE,UAAU;IACV,SAAS;EACX;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;EACA;IACE,QAAQ;IACR,WAAW;EACb;EACA;IACE,UAAU;IACV,SAAS;EACX;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;EACA;IACE,QAAQ;IACR,WAAW;EACb;EACA;IACE,UAAU;IACV,SAAS;EACX;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;EACA;IACE,SAAS;IACT,YAAY;EACd;EACA;IACE,WAAW;IACX,UAAU;EACZ;EACA;IACE,MAAM;EACR;EACA;IACE,QAAQ;EACV;EACA;IACE,SAAS;EACX;EACA;IACE,OAAO;EACT;EACA;IACE,YAAY;EACd;EACA;IACE,cAAc;EAChB;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;EACf;EACA;IACE,WAAW;EACb;EACA;IACE,aAAa;EACf;EACA;IACE,cAAc;EAChB;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,cAAc;EAChB;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;EACf;EACA;IACE,SAAS;EACX;EACA;IACE,WAAW;EACb;EACA;IACE,YAAY;EACd;EACA;IACE,UAAU;EACZ;EACA;IACE,YAAY;EACd;EACA;IACE,cAAc;EAChB;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;EACf;EACA;IACE,WAAW;EACb;EACA;IACE,aAAa;EACf;EACA;IACE,cAAc;EAChB;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,cAAc;EAChB;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;EACf;EACA;IACE,SAAS;EACX;EACA;IACE,WAAW;EACb;EACA;IACE,YAAY;EACd;EACA;IACE,UAAU;EACZ;EACA;IACE,YAAY;EACd;EACA;IACE,cAAc;EAChB;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;EACf;EACA;IACE,WAAW;EACb;EACA;IACE,aAAa;EACf;EACA;IACE,cAAc;EAChB;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,cAAc;EAChB;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;EACf;EACA;IACE,SAAS;EACX;EACA;IACE,WAAW;EACb;EACA;IACE,YAAY;EACd;EACA;IACE,UAAU;EACZ;EACA;IACE,YAAY;EACd;EACA;IACE,cAAc;EAChB;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;EACf;EACA;IACE,WAAW;EACb;EACA;IACE,aAAa;EACf;EACA;IACE,cAAc;EAChB;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,cAAc;EAChB;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;EACf;EACA;IACE,SAAS;EACX;EACA;IACE,WAAW;EACb;EACA;IACE,YAAY;EACd;EACA;IACE,UAAU;EACZ;EACA;IACE,SAAS;EACX;EACA;IACE,WAAW;EACb;EACA;IACE,YAAY;EACd;EACA;IACE,UAAU;EACZ;EACA;IACE,SAAS;EACX;EACA;IACE,WAAW;EACb;EACA;IACE,YAAY;EACd;EACA;IACE,UAAU;EACZ;EACA;IACE,SAAS;EACX;EACA;IACE,WAAW;EACb;EACA;IACE,YAAY;EACd;EACA;IACE,UAAU;EACZ;EACA;IACE,SAAS;EACX;EACA;IACE,WAAW;EACb;EACA;IACE,YAAY;EACd;EACA;IACE,UAAU;EACZ;EACA;IACE,SAAS;EACX;EACA;IACE,WAAW;EACb;EACA;IACE,YAAY;EACd;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,YAAY;EACd;EACA;IACE,aAAa;EACf;EACA;IACE,WAAW;EACb;EACA;IACE,UAAU;EACZ;EACA;IACE,YAAY;EACd;EACA;IACE,aAAa;EACf;EACA;IACE,WAAW;EACb;EACA;IACE,UAAU;EACZ;EACA;IACE,YAAY;EACd;EACA;IACE,aAAa;EACf;EACA;IACE,WAAW;EACb;EACA;IACE,UAAU;EACZ;EACA;IACE,YAAY;EACd;EACA;IACE,aAAa;EACf;EACA;IACE,WAAW;EACb;EACA;IACE,UAAU;EACZ;EACA;IACE,YAAY;EACd;EACA;IACE,aAAa;EACf;EACA;IACE,WAAW;EACb;EACA;IACE,UAAU;EACZ;EACA;IACE,YAAY;EACd;EACA;IACE,aAAa;EACf;EACA;IACE,WAAW;EACb;EACA;IACE,UAAU;EACZ;EACA;IACE,YAAY;EACd;EACA;IACE,aAAa;EACf;EACA;IACE,WAAW;EACb;EACA;IACE,UAAU;EACZ;EACA;IACE,YAAY;EACd;EACA;IACE,aAAa;EACf;EACA;IACE,WAAW;EACb;EACA;IACE,UAAU;EACZ;EACA;IACE,YAAY;EACd;EACA;IACE,aAAa;EACf;EACA;IACE,WAAW;EACb;EACA;IACE,UAAU;EACZ;EACA;IACE,YAAY;EACd;EACA;IACE,aAAa;EACf;EACA;IACE,WAAW;EACb;EACA;IACE,SAAS;EACX;EACA;IACE,WAAW;EACb;EACA;IACE,YAAY;EACd;EACA;IACE,UAAU;EACZ;EACA;IACE,QAAQ;EACV;EACA;IACE,UAAU;EACZ;EACA;IACE,WAAW;EACb;EACA;IACE,SAAS;EACX;EACA;IACE,aAAa;EACf;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,cAAc;EAChB;EACA;IACE,aAAa;EACf;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,cAAc;EAChB;EACA;IACE,aAAa;EACf;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,cAAc;EAChB;EACA;IACE,aAAa;EACf;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,cAAc;EAChB;EACA;IACE,QAAQ;EACV;EACA;IACE,UAAU;EACZ;EACA;IACE,WAAW;EACb;EACA;IACE,SAAS;EACX;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,QAAQ;EACV;EACA;IACE,UAAU;EACZ;EACA;IACE,WAAW;EACb;EACA;IACE,SAAS;EACX;EACA;IACE,QAAQ;EACV;EACA;IACE,UAAU;EACZ;EACA;IACE,WAAW;EACb;EACA;IACE,SAAS;EACX;EACA;IACE,QAAQ;EACV;EACA;IACE,UAAU;EACZ;EACA;IACE,WAAW;EACb;EACA;IACE,SAAS;EACX;EACA;IACE,QAAQ;EACV;EACA;IACE,UAAU;EACZ;EACA;IACE,WAAW;EACb;EACA;IACE,SAAS;EACX;EACA;IACE,QAAQ;EACV;EACA;IACE,UAAU;EACZ;EACA;IACE,WAAW;EACb;EACA;IACE,SAAS;EACX;EACA;IACE,QAAQ;EACV;EACA;IACE,UAAU;EACZ;EACA;IACE,WAAW;EACb;EACA;IACE,SAAS;EACX;EACA;IACE,QAAQ;EACV;EACA;IACE,UAAU;EACZ;EACA;IACE,WAAW;EACb;EACA;IACE,SAAS;EACX;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,QAAQ;EACV;EACA;IACE,UAAU;EACZ;EACA;IACE,WAAW;EACb;EACA;IACE,SAAS;EACX;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,cAAc;EAChB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,QAAQ;EACV;EACA;IACE,UAAU;EACZ;EACA;IACE,WAAW;EACb;EACA;IACE,SAAS;EACX;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,QAAQ;EACV;EACA;IACE,UAAU;EACZ;EACA;IACE,WAAW;EACb;EACA;IACE,SAAS;EACX;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,QAAQ;EACV;EACA;IACE,UAAU;EACZ;EACA;IACE,WAAW;EACb;EACA;IACE,SAAS;EACX;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,SAAS;EACX;EACA;IACE,WAAW;EACb;EACA;IACE,YAAY;EACd;EACA;IACE,UAAU;EACZ;EACA;IACE,YAAY;EACd;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,YAAY;EACd;EACA;IACE,yCAAyC;EAC3C;EACA;IACE,2CAA2C;EAC7C;EACA;IACE,2EAA2E;EAC7E;EACA;IACE,iFAAiF;EACnF;EACA;IACE,mFAAmF;EACrF;EACA;IACE,qFAAqF;EACvF;EACA;IACE,iDAAiD;EACnD;EACA;IACE,iDAAiD;EACnD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kCAAkC;EACpC;EACA;IACE,+CAA+C;EACjD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,8CAA8C;EAChD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,yCAAyC;EAC3C;EACA;IACE,2CAA2C;EAC7C;EACA;IACE,2EAA2E;EAC7E;EACA;IACE,iFAAiF;EACnF;EACA;IACE,mFAAmF;EACrF;EACA;IACE,qFAAqF;EACvF;EACA;IACE,iDAAiD;EACnD;EACA;IACE,iDAAiD;EACnD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kCAAkC;EACpC;EACA;IACE,+CAA+C;EACjD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,8CAA8C;EAChD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,yCAAyC;EAC3C;EACA;IACE,2CAA2C;EAC7C;EACA;IACE,2EAA2E;EAC7E;EACA;IACE,iFAAiF;EACnF;EACA;IACE,mFAAmF;EACrF;EACA;IACE,qFAAqF;EACvF;EACA;IACE,iDAAiD;EACnD;EACA;IACE,iDAAiD;EACnD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kCAAkC;EACpC;EACA;IACE,+CAA+C;EACjD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,8CAA8C;EAChD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,yCAAyC;EAC3C;EACA;IACE,2CAA2C;EAC7C;EACA;IACE,2EAA2E;EAC7E;EACA;IACE,iFAAiF;EACnF;EACA;IACE,mFAAmF;EACrF;EACA;IACE,qFAAqF;EACvF;EACA;IACE,iDAAiD;EACnD;EACA;IACE,iDAAiD;EACnD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kCAAkC;EACpC;EACA;IACE,+CAA+C;EACjD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,8CAA8C;EAChD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,yCAAyC;EAC3C;EACA;IACE,2CAA2C;EAC7C;EACA;IACE,2EAA2E;EAC7E;EACA;IACE,iFAAiF;EACnF;EACA;IACE,mFAAmF;EACrF;EACA;IACE,qFAAqF;EACvF;EACA;IACE,iDAAiD;EACnD;EACA;IACE,iDAAiD;EACnD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kCAAkC;EACpC;EACA;IACE,+CAA+C;EACjD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,8CAA8C;EAChD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,kBAAkB;EACpB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,yCAAyC;EAC3C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,2CAA2C;EAC7C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,2CAA2C;EAC7C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,2CAA2C;EAC7C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,2CAA2C;EAC7C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,yCAAyC;EAC3C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,2CAA2C;EAC7C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,2CAA2C;EAC7C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,2CAA2C;EAC7C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,2CAA2C;EAC7C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,yCAAyC;EAC3C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,2CAA2C;EAC7C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,2CAA2C;EAC7C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,2CAA2C;EAC7C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,2CAA2C;EAC7C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,yCAAyC;EAC3C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,2CAA2C;EAC7C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,2CAA2C;EAC7C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,2CAA2C;EAC7C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,2CAA2C;EAC7C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,yCAAyC;EAC3C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,2CAA2C;EAC7C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,2CAA2C;EAC7C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,2CAA2C;EAC7C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,2CAA2C;EAC7C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,yCAAyC;EAC3C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,2CAA2C;EAC7C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,2CAA2C;EAC7C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,2CAA2C;EAC7C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,2CAA2C;EAC7C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,yCAAyC;EAC3C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,2CAA2C;EAC7C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,2CAA2C;EAC7C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,2CAA2C;EAC7C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,2CAA2C;EAC7C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;EACnB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,oBAAoB;EACtB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mCAAmC;IACnC,kCAAkC;EACpC;EACA;IACE,4BAA4B;IAC5B,6BAA6B;EAC/B;EACA;IACE;;;OAGG;IACH;;;OAGG;IACH;;;OAGG;IACH;;;OAGG;IACH;;;OAGG;IACH,8MAA8M;EAChN;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,uCAAuC;EACzC;EACA;IACE,iDAAiD;EACnD;EACA;IACE,0CAA0C;EAC5C;EACA;IACE,4CAA4C;EAC9C;EACA;IACE,iDAAiD;EACnD;EACA;IACE,4CAA4C;EAC9C;EACA;IACE,mDAAmD;EACrD;EACA;IACE,kDAAkD;EACpD;EACA;IACE,uBAAuB;EACzB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,iBAAiB;EACnB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,yBAAyB;IAEzB,iBAAiB;EACnB;EACA;IACE,yBAAyB;IAEzB,iBAAiB;EACnB;EACA;IACE,wBAAwB;IAExB,gBAAgB;EAClB;EACA;IACE,yBAAyB;IAEzB,iBAAiB;EACnB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,mBAAmB;EACrB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,iBAAiB;IACjB,qBAAqB;IACrB,kBAAkB;EACpB;EACA;IACE,qBAAqB;IACrB,yBAAyB;EAC3B;EACA;IACE,qBAAqB;EACvB;EACA;IACE,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;EACrB;EACA;IACE,QAAQ;EACV;EACA;IACE,cAAc;EAChB;EACA;IACE,aAAa;EACf;EACA;IACE,cAAc;EAChB;EACA;IACE,WAAW;EACb;EACA;IACE,cAAc;EAChB;EACA;IACE,aAAa;EACf;EACA;IACE,cAAc;EAChB;EACA;IACE,WAAW;EACb;EACA;IACE,cAAc;EAChB;EACA;IACE,aAAa;EACf;EACA;IACE,cAAc;EAChB;EACA;IACE,WAAW;EACb;EACA;IACE,cAAc;EAChB;EACA;IACE,aAAa;EACf;EACA;IACE,cAAc;EAChB;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,WAAW;EACb;EACA;IACE,UAAU;EACZ;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,UAAU;EACZ;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,UAAU;EACZ;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,UAAU;EACZ;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,UAAU;EACZ;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,UAAU;EACZ;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,WAAW;EACb;EACA;IACE,YAAY;EACd;EACA;IAEE,kBAAkB;EACpB;EACA;IAEE,kBAAkB;EACpB;EACA;IACE,UAAU;EACZ;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,aAAa;EACf;EACA;IACE,UAAU;EACZ;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,aAAa;EACf;EACA;IACE,UAAU;EACZ;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,aAAa;EACf;EACA;IACE,WAAW;IACX,MAAM;EACR;EACA;IACE,iBAAiB;IACjB,YAAY;EACd;EACA;IACE,gBAAgB;IAChB,WAAW;EACb;EACA;IACE,iBAAiB;IACjB,YAAY;EACd;EACA;IACE,cAAc;IACd,SAAS;EACX;EACA;IACE,iBAAiB;IACjB,YAAY;EACd;EACA;IACE,gBAAgB;IAChB,WAAW;EACb;EACA;IACE,iBAAiB;IACjB,YAAY;EACd;EACA;IACE,cAAc;IACd,SAAS;EACX;EACA;IACE,iBAAiB;IACjB,YAAY;EACd;EACA;IACE,gBAAgB;IAChB,WAAW;EACb;EACA;IACE,iBAAiB;IACjB,YAAY;EACd;EACA;IACE,cAAc;IACd,SAAS;EACX;EACA;IACE,iBAAiB;IACjB,YAAY;EACd;EACA;IACE,gBAAgB;IAChB,WAAW;EACb;EACA;IACE,iBAAiB;IACjB,YAAY;EACd;EACA;IACE,cAAc;IACd,SAAS;EACX;EACA;IACE,cAAc;IACd,SAAS;EACX;EACA;IACE,cAAc;IACd,SAAS;EACX;EACA;IACE,cAAc;IACd,SAAS;EACX;EACA;IACE,cAAc;IACd,SAAS;EACX;EACA;IACE,cAAc;IACd,SAAS;EACX;EACA;IACE,eAAe;IACf,UAAU;EACZ;EACA;IACE,eAAe;IACf,UAAU;EACZ;EACA;IACE,eAAe;IACf,UAAU;EACZ;EACA;IACE,eAAe;IACf,UAAU;EACZ;EACA;IACE,eAAe;IACf,UAAU;EACZ;EACA;IACE,eAAe;IACf,UAAU;EACZ;EACA;IACE,eAAe;IACf,UAAU;EACZ;EACA;IACE,eAAe;IACf,UAAU;EACZ;EACA;IACE,eAAe;IACf,UAAU;EACZ;EACA;IACE,eAAe;IACf,UAAU;EACZ;EACA;IACE,aAAa;IACb,QAAQ;EACV;EACA;IACE,kBAAkB;IAClB,aAAa;EACf;EACA;IACE,kBAAkB;IAClB,aAAa;EACf;EACA;IACE,kBAAkB;IAClB,aAAa;EACf;EACA;IACE,kBAAkB;IAClB,aAAa;EACf;EACA;IACE,aAAa;IACb,QAAQ;EACV;EACA;IACE,oBAAoB;IACpB,eAAe;EACjB;EACA;IACE,oBAAoB;IACpB,eAAe;EACjB;EACA;IACE,aAAa;IACb,QAAQ;EACV;EACA;IACE,aAAa;IACb,QAAQ;EACV;EACA;IACE,aAAa;IACb,QAAQ;EACV;EACA;IACE,aAAa;IACb,QAAQ;EACV;EACA;IACE,aAAa;IACb,QAAQ;EACV;EACA;IACE,aAAa;IACb,QAAQ;EACV;EACA;IACE,aAAa;IACb,QAAQ;EACV;EACA;IACE,oBAAoB;IACpB,eAAe;EACjB;EACA;IACE,oBAAoB;IACpB,eAAe;EACjB;EACA;IACE,aAAa;IACb,QAAQ;EACV;EACA;IACE,oBAAoB;IACpB,eAAe;EACjB;EACA;IACE,oBAAoB;IACpB,eAAe;EACjB;EACA;IACE,mBAAmB;IACnB,cAAc;EAChB;EACA;IACE,oBAAoB;IACpB,eAAe;EACjB;EACA;IACE,aAAa;IACb,QAAQ;EACV;EACA;IACE,oBAAoB;IACpB,eAAe;EACjB;EACA;IACE,oBAAoB;IACpB,eAAe;EACjB;EACA;IACE,aAAa;IACb,QAAQ;EACV;EACA;IACE,oBAAoB;IACpB,eAAe;EACjB;EACA;IACE,oBAAoB;IACpB,eAAe;EACjB;EACA;IACE,aAAa;IACb,QAAQ;EACV;EACA;IACE,oBAAoB;IACpB,eAAe;EACjB;EACA;IACE,oBAAoB;IACpB,eAAe;EACjB;EACA;IACE,cAAc;IACd,SAAS;EACX;EACA;IACE,kBAAkB;IAElB,aAAa;EACf;EACA;IACE,wBAAwB;IAExB,mBAAmB;EACrB;EACA;IACE,uBAAuB;IAEvB,kBAAkB;EACpB;EACA;IACE,wBAAwB;IAExB,mBAAmB;EACrB;EACA;IACE,qBAAqB;IAErB,gBAAgB;EAClB;EACA;IACE,wBAAwB;IAExB,mBAAmB;EACrB;EACA;IACE,uBAAuB;IAEvB,kBAAkB;EACpB;EACA;IACE,wBAAwB;IAExB,mBAAmB;EACrB;EACA;IACE,qBAAqB;IAErB,gBAAgB;EAClB;EACA;IACE,wBAAwB;IAExB,mBAAmB;EACrB;EACA;IACE,uBAAuB;IAEvB,kBAAkB;EACpB;EACA;IACE,wBAAwB;IAExB,mBAAmB;EACrB;EACA;IACE,qBAAqB;IAErB,gBAAgB;EAClB;EACA;IACE,wBAAwB;IAExB,mBAAmB;EACrB;EACA;IACE,uBAAuB;IAEvB,kBAAkB;EACpB;EACA;IACE,wBAAwB;IAExB,mBAAmB;EACrB;EACA;IACE,qBAAqB;IAErB,gBAAgB;EAClB;EACA;IACE,qBAAqB;IAErB,gBAAgB;EAClB;EACA;IACE,qBAAqB;IAErB,gBAAgB;EAClB;EACA;IACE,qBAAqB;IAErB,gBAAgB;EAClB;EACA;IACE,qBAAqB;IAErB,gBAAgB;EAClB;EACA;IACE,qBAAqB;IAErB,gBAAgB;EAClB;EACA;IACE,sBAAsB;IAEtB,iBAAiB;EACnB;EACA;IACE,sBAAsB;IAEtB,iBAAiB;EACnB;EACA;IACE,sBAAsB;IAEtB,iBAAiB;EACnB;EACA;IACE,sBAAsB;IAEtB,iBAAiB;EACnB;EACA;IACE,sBAAsB;IAEtB,iBAAiB;EACnB;EACA;IACE,sBAAsB;IAEtB,iBAAiB;EACnB;EACA;IACE,sBAAsB;IAEtB,iBAAiB;EACnB;EACA;IACE,sBAAsB;IAEtB,iBAAiB;EACnB;EACA;IACE,sBAAsB;IAEtB,iBAAiB;EACnB;EACA;IACE,sBAAsB;IAEtB,iBAAiB;EACnB;EACA;IACE,oBAAoB;IAEpB,eAAe;EACjB;EACA;IACE,yBAAyB;IAEzB,oBAAoB;EACtB;EACA;IACE,yBAAyB;IAEzB,oBAAoB;EACtB;EACA;IACE,yBAAyB;IAEzB,oBAAoB;EACtB;EACA;IACE,yBAAyB;IAEzB,oBAAoB;EACtB;EACA;IACE,oBAAoB;IAEpB,eAAe;EACjB;EACA;IACE,2BAA2B;IAE3B,sBAAsB;EACxB;EACA;IACE,2BAA2B;IAE3B,sBAAsB;EACxB;EACA;IACE,oBAAoB;IAEpB,eAAe;EACjB;EACA;IACE,oBAAoB;IAEpB,eAAe;EACjB;EACA;IACE,oBAAoB;IAEpB,eAAe;EACjB;EACA;IACE,oBAAoB;IAEpB,eAAe;EACjB;EACA;IACE,oBAAoB;IAEpB,eAAe;EACjB;EACA;IACE,oBAAoB;IAEpB,eAAe;EACjB;EACA;IACE,oBAAoB;IAEpB,eAAe;EACjB;EACA;IACE,2BAA2B;IAE3B,sBAAsB;EACxB;EACA;IACE,2BAA2B;IAE3B,sBAAsB;EACxB;EACA;IACE,oBAAoB;IAEpB,eAAe;EACjB;EACA;IACE,2BAA2B;IAE3B,sBAAsB;EACxB;EACA;IACE,2BAA2B;IAE3B,sBAAsB;EACxB;EACA;IACE,0BAA0B;IAE1B,qBAAqB;EACvB;EACA;IACE,2BAA2B;IAE3B,sBAAsB;EACxB;EACA;IACE,oBAAoB;IAEpB,eAAe;EACjB;EACA;IACE,2BAA2B;IAE3B,sBAAsB;EACxB;EACA;IACE,2BAA2B;IAE3B,sBAAsB;EACxB;EACA;IACE,oBAAoB;IAEpB,eAAe;EACjB;EACA;IACE,2BAA2B;IAE3B,sBAAsB;EACxB;EACA;IACE,2BAA2B;IAE3B,sBAAsB;EACxB;EACA;IACE,oBAAoB;IAEpB,eAAe;EACjB;EACA;IACE,2BAA2B;IAE3B,sBAAsB;EACxB;EACA;IACE,2BAA2B;IAE3B,sBAAsB;EACxB;EACA;IACE,qBAAqB;IAErB,gBAAgB;EAClB;EACA;IACE,kBAAkB;IAElB,aAAa;EACf;EACA;IACE,wBAAwB;IAExB,mBAAmB;EACrB;EACA;IACE,uBAAuB;IAEvB,kBAAkB;EACpB;EACA;IACE,wBAAwB;IAExB,mBAAmB;EACrB;EACA;IACE,qBAAqB;IAErB,gBAAgB;EAClB;EACA;IACE,wBAAwB;IAExB,mBAAmB;EACrB;EACA;IACE,uBAAuB;IAEvB,kBAAkB;EACpB;EACA;IACE,wBAAwB;IAExB,mBAAmB;EACrB;EACA;IACE,qBAAqB;IAErB,gBAAgB;EAClB;EACA;IACE,wBAAwB;IAExB,mBAAmB;EACrB;EACA;IACE,uBAAuB;IAEvB,kBAAkB;EACpB;EACA;IACE,wBAAwB;IAExB,mBAAmB;EACrB;EACA;IACE,qBAAqB;IAErB,gBAAgB;EAClB;EACA;IACE,wBAAwB;IAExB,mBAAmB;EACrB;EACA;IACE,uBAAuB;IAEvB,kBAAkB;EACpB;EACA;IACE,wBAAwB;IAExB,mBAAmB;EACrB;EACA;IACE,qBAAqB;IAErB,gBAAgB;EAClB;EACA;IACE,qBAAqB;IAErB,gBAAgB;EAClB;EACA;IACE,qBAAqB;IAErB,gBAAgB;EAClB;EACA;IACE,qBAAqB;IAErB,gBAAgB;EAClB;EACA;IACE,qBAAqB;IAErB,gBAAgB;EAClB;EACA;IACE,qBAAqB;IAErB,gBAAgB;EAClB;EACA;IACE,sBAAsB;IAEtB,iBAAiB;EACnB;EACA;IACE,sBAAsB;IAEtB,iBAAiB;EACnB;EACA;IACE,sBAAsB;IAEtB,iBAAiB;EACnB;EACA;IACE,sBAAsB;IAEtB,iBAAiB;EACnB;EACA;IACE,sBAAsB;IAEtB,iBAAiB;EACnB;EACA;IACE,sBAAsB;IAEtB,iBAAiB;EACnB;EACA;IACE,sBAAsB;IAEtB,iBAAiB;EACnB;EACA;IACE,sBAAsB;IAEtB,iBAAiB;EACnB;EACA;IACE,sBAAsB;IAEtB,iBAAiB;EACnB;EACA;IACE,sBAAsB;IAEtB,iBAAiB;EACnB;EACA;IACE,oBAAoB;IAEpB,eAAe;EACjB;EACA;IACE,yBAAyB;IAEzB,oBAAoB;EACtB;EACA;IACE,yBAAyB;IAEzB,oBAAoB;EACtB;EACA;IACE,yBAAyB;IAEzB,oBAAoB;EACtB;EACA;IACE,yBAAyB;IAEzB,oBAAoB;EACtB;EACA;IACE,oBAAoB;IAEpB,eAAe;EACjB;EACA;IACE,2BAA2B;IAE3B,sBAAsB;EACxB;EACA;IACE,2BAA2B;IAE3B,sBAAsB;EACxB;EACA;IACE,oBAAoB;IAEpB,eAAe;EACjB;EACA;IACE,oBAAoB;IAEpB,eAAe;EACjB;EACA;IACE,oBAAoB;IAEpB,eAAe;EACjB;EACA;IACE,oBAAoB;IAEpB,eAAe;EACjB;EACA;IACE,oBAAoB;IAEpB,eAAe;EACjB;EACA;IACE,oBAAoB;IAEpB,eAAe;EACjB;EACA;IACE,oBAAoB;IAEpB,eAAe;EACjB;EACA;IACE,2BAA2B;IAE3B,sBAAsB;EACxB;EACA;IACE,2BAA2B;IAE3B,sBAAsB;EACxB;EACA;IACE,oBAAoB;IAEpB,eAAe;EACjB;EACA;IACE,2BAA2B;IAE3B,sBAAsB;EACxB;EACA;IACE,2BAA2B;IAE3B,sBAAsB;EACxB;EACA;IACE,0BAA0B;IAE1B,qBAAqB;EACvB;EACA;IACE,2BAA2B;IAE3B,sBAAsB;EACxB;EACA;IACE,oBAAoB;IAEpB,eAAe;EACjB;EACA;IACE,2BAA2B;IAE3B,sBAAsB;EACxB;EACA;IACE,2BAA2B;IAE3B,sBAAsB;EACxB;EACA;IACE,oBAAoB;IAEpB,eAAe;EACjB;EACA;IACE,2BAA2B;IAE3B,sBAAsB;EACxB;EACA;IACE,2BAA2B;IAE3B,sBAAsB;EACxB;EACA;IACE,oBAAoB;IAEpB,eAAe;EACjB;EACA;IACE,2BAA2B;IAE3B,sBAAsB;EACxB;EACA;IACE,2BAA2B;IAE3B,sBAAsB;EACxB;EACA;IACE,qBAAqB;IAErB,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,UAAU;EACZ;EACA;IACE,qBAAqB;IACrB,gBAAgB;EAClB;EACA;IACE,oBAAoB;IACpB,eAAe;EACjB;EACA;IACE,qBAAqB;IACrB,gBAAgB;EAClB;EACA;IACE,kBAAkB;IAClB,aAAa;EACf;EACA;IACE,qBAAqB;IACrB,gBAAgB;EAClB;EACA;IACE,oBAAoB;IACpB,eAAe;EACjB;EACA;IACE,qBAAqB;IACrB,gBAAgB;EAClB;EACA;IACE,kBAAkB;IAClB,aAAa;EACf;EACA;IACE,qBAAqB;IACrB,gBAAgB;EAClB;EACA;IACE,oBAAoB;IACpB,eAAe;EACjB;EACA;IACE,qBAAqB;IACrB,gBAAgB;EAClB;EACA;IACE,kBAAkB;IAClB,aAAa;EACf;EACA;IACE,qBAAqB;IACrB,gBAAgB;EAClB;EACA;IACE,oBAAoB;IACpB,eAAe;EACjB;EACA;IACE,qBAAqB;IACrB,gBAAgB;EAClB;EACA;IACE,kBAAkB;IAClB,aAAa;EACf;EACA;IACE,kBAAkB;IAClB,aAAa;EACf;EACA;IACE,kBAAkB;IAClB,aAAa;EACf;EACA;IACE,kBAAkB;IAClB,aAAa;EACf;EACA;IACE,kBAAkB;IAClB,aAAa;EACf;EACA;IACE,kBAAkB;IAClB,aAAa;EACf;EACA;IACE,mBAAmB;IACnB,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,cAAc;EAChB;EACA;IACE,iBAAiB;IACjB,YAAY;EACd;EACA;IACE,sBAAsB;IACtB,iBAAiB;EACnB;EACA;IACE,sBAAsB;IACtB,iBAAiB;EACnB;EACA;IACE,sBAAsB;IACtB,iBAAiB;EACnB;EACA;IACE,sBAAsB;IACtB,iBAAiB;EACnB;EACA;IACE,iBAAiB;IACjB,YAAY;EACd;EACA;IACE,wBAAwB;IACxB,mBAAmB;EACrB;EACA;IACE,wBAAwB;IACxB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,YAAY;EACd;EACA;IACE,iBAAiB;IACjB,YAAY;EACd;EACA;IACE,iBAAiB;IACjB,YAAY;EACd;EACA;IACE,iBAAiB;IACjB,YAAY;EACd;EACA;IACE,iBAAiB;IACjB,YAAY;EACd;EACA;IACE,iBAAiB;IACjB,YAAY;EACd;EACA;IACE,iBAAiB;IACjB,YAAY;EACd;EACA;IACE,wBAAwB;IACxB,mBAAmB;EACrB;EACA;IACE,wBAAwB;IACxB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,YAAY;EACd;EACA;IACE,wBAAwB;IACxB,mBAAmB;EACrB;EACA;IACE,wBAAwB;IACxB,mBAAmB;EACrB;EACA;IACE,uBAAuB;IACvB,kBAAkB;EACpB;EACA;IACE,wBAAwB;IACxB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,YAAY;EACd;EACA;IACE,wBAAwB;IACxB,mBAAmB;EACrB;EACA;IACE,wBAAwB;IACxB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,YAAY;EACd;EACA;IACE,wBAAwB;IACxB,mBAAmB;EACrB;EACA;IACE,wBAAwB;IACxB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,YAAY;EACd;EACA;IACE,wBAAwB;IACxB,mBAAmB;EACrB;EACA;IACE,wBAAwB;IACxB,mBAAmB;EACrB;EACA;IACE,kBAAkB;IAClB,aAAa;EACf;EACA;IACE,eAAe;IACf,UAAU;EACZ;EACA;IACE,qBAAqB;IACrB,gBAAgB;EAClB;EACA;IACE,oBAAoB;IACpB,eAAe;EACjB;EACA;IACE,qBAAqB;IACrB,gBAAgB;EAClB;EACA;IACE,kBAAkB;IAClB,aAAa;EACf;EACA;IACE,qBAAqB;IACrB,gBAAgB;EAClB;EACA;IACE,oBAAoB;IACpB,eAAe;EACjB;EACA;IACE,qBAAqB;IACrB,gBAAgB;EAClB;EACA;IACE,kBAAkB;IAClB,aAAa;EACf;EACA;IACE,qBAAqB;IACrB,gBAAgB;EAClB;EACA;IACE,oBAAoB;IACpB,eAAe;EACjB;EACA;IACE,qBAAqB;IACrB,gBAAgB;EAClB;EACA;IACE,kBAAkB;IAClB,aAAa;EACf;EACA;IACE,qBAAqB;IACrB,gBAAgB;EAClB;EACA;IACE,oBAAoB;IACpB,eAAe;EACjB;EACA;IACE,qBAAqB;IACrB,gBAAgB;EAClB;EACA;IACE,kBAAkB;IAClB,aAAa;EACf;EACA;IACE,kBAAkB;IAClB,aAAa;EACf;EACA;IACE,kBAAkB;IAClB,aAAa;EACf;EACA;IACE,kBAAkB;IAClB,aAAa;EACf;EACA;IACE,kBAAkB;IAClB,aAAa;EACf;EACA;IACE,kBAAkB;IAClB,aAAa;EACf;EACA;IACE,mBAAmB;IACnB,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,cAAc;EAChB;EACA;IACE,iBAAiB;IACjB,YAAY;EACd;EACA;IACE,sBAAsB;IACtB,iBAAiB;EACnB;EACA;IACE,sBAAsB;IACtB,iBAAiB;EACnB;EACA;IACE,sBAAsB;IACtB,iBAAiB;EACnB;EACA;IACE,sBAAsB;IACtB,iBAAiB;EACnB;EACA;IACE,iBAAiB;IACjB,YAAY;EACd;EACA;IACE,wBAAwB;IACxB,mBAAmB;EACrB;EACA;IACE,wBAAwB;IACxB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,YAAY;EACd;EACA;IACE,iBAAiB;IACjB,YAAY;EACd;EACA;IACE,iBAAiB;IACjB,YAAY;EACd;EACA;IACE,iBAAiB;IACjB,YAAY;EACd;EACA;IACE,iBAAiB;IACjB,YAAY;EACd;EACA;IACE,iBAAiB;IACjB,YAAY;EACd;EACA;IACE,iBAAiB;IACjB,YAAY;EACd;EACA;IACE,wBAAwB;IACxB,mBAAmB;EACrB;EACA;IACE,wBAAwB;IACxB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,YAAY;EACd;EACA;IACE,wBAAwB;IACxB,mBAAmB;EACrB;EACA;IACE,wBAAwB;IACxB,mBAAmB;EACrB;EACA;IACE,uBAAuB;IACvB,kBAAkB;EACpB;EACA;IACE,wBAAwB;IACxB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,YAAY;EACd;EACA;IACE,wBAAwB;IACxB,mBAAmB;EACrB;EACA;IACE,wBAAwB;IACxB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,YAAY;EACd;EACA;IACE,wBAAwB;IACxB,mBAAmB;EACrB;EACA;IACE,wBAAwB;IACxB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,YAAY;EACd;EACA;IACE,wBAAwB;IACxB,mBAAmB;EACrB;EACA;IACE,wBAAwB;IACxB,mBAAmB;EACrB;EACA;IACE,kBAAkB;IAClB,aAAa;EACf;EACA;IACE,mBAAmB;EACrB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,gDAAgD;EAClD;EACA;IACE,gDAAgD;EAClD;EACA;IACE,gDAAgD;EAClD;EACA;IACE,gDAAgD;EAClD;EACA;IACE,gDAAgD;EAClD;EACA;IACE,gDAAgD;EAClD;EACA;IACE,gDAAgD;EAClD;EACA;IACE,gDAAgD;EAClD;EACA;IACE,gDAAgD;EAClD;EACA;IACE,iDAAiD;EACnD;EACA;IACE,iDAAiD;EACnD;EACA;IACE,iDAAiD;EACnD;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,iBAAiB;EACnB;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,6CAA6C;EAC/C;EACA;IACE,6CAA6C;EAC/C;EACA;IACE,6CAA6C;EAC/C;EACA;IACE,6CAA6C;EAC/C;EACA;IACE,6CAA6C;EAC/C;EACA;IACE,6CAA6C;EAC/C;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,oBAAoB;EACtB;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,8BAA8B;EAChC;EACA;IACE,cAAc;EAChB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,gBAAgB;EAClB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,0BAA0B;IAC1B,0BAA0B;IAC1B,qBAAqB;IACrB,qBAAqB;IACrB,qBAAqB;IACrB,sBAAsB;IACtB,sBAAsB;IACtB,4PAA4P;EAC9P;EACA;IACE,eAAe;EACjB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,qBAAqB;EACvB;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,8BAA8B;EAChC;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,sBAAsB;IACtB,sBAAsB;EACxB;EACA;IACE,uBAAuB;IACvB,uBAAuB;EACzB;EACA;IACE,wBAAwB;IACxB,wBAAwB;EAC1B;EACA;IACE,uBAAuB;IACvB,uBAAuB;EACzB;EACA;IACE,wBAAwB;IACxB,wBAAwB;EAC1B;EACA;IACE,sBAAsB;IACtB,sBAAsB;EACxB;EACA;IACE,yBAAyB;IACzB,yBAAyB;EAC3B;EACA;IACE,wBAAwB;IACxB,wBAAwB;EAC1B;EACA;IACE,yBAAyB;IACzB,yBAAyB;EAC3B;EACA;IACE,wBAAwB;IACxB,wBAAwB;EAC1B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,sBAAsB;IACtB,sBAAsB;EACxB;EACA;IACE,uBAAuB;IACvB,uBAAuB;EACzB;EACA;IACE,wBAAwB;IACxB,wBAAwB;EAC1B;EACA;IACE,uBAAuB;IACvB,uBAAuB;EACzB;EACA;IACE,wBAAwB;IACxB,wBAAwB;EAC1B;EACA;IACE,sBAAsB;IACtB,sBAAsB;EACxB;EACA;IACE,yBAAyB;IACzB,yBAAyB;EAC3B;EACA;IACE,wBAAwB;IACxB,wBAAwB;EAC1B;EACA;IACE,yBAAyB;IACzB,yBAAyB;EAC3B;EACA;IACE,wBAAwB;IACxB,wBAAwB;EAC1B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,sBAAsB;IACtB,sBAAsB;EACxB;EACA;IACE,uBAAuB;IACvB,uBAAuB;EACzB;EACA;IACE,wBAAwB;IACxB,wBAAwB;EAC1B;EACA;IACE,uBAAuB;IACvB,uBAAuB;EACzB;EACA;IACE,wBAAwB;IACxB,wBAAwB;EAC1B;EACA;IACE,sBAAsB;IACtB,sBAAsB;EACxB;EACA;IACE,yBAAyB;IACzB,yBAAyB;EAC3B;EACA;IACE,wBAAwB;IACxB,wBAAwB;EAC1B;EACA;IACE,yBAAyB;IACzB,yBAAyB;EAC3B;EACA;IACE,wBAAwB;IACxB,wBAAwB;EAC1B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,qBAAqB;EACvB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,qBAAqB;EACvB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,qBAAqB;EACvB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,gCAAgC;EAClC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,gCAAgC;EAClC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,gCAAgC;EAClC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,gCAAgC;EAClC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,iCAAiC;EACnC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,iCAAiC;EACnC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,gCAAgC;EAClC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,gCAAgC;EAClC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,gCAAgC;EAClC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,gCAAgC;EAClC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,iCAAiC;EACnC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,iCAAiC;EACnC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,gCAAgC;EAClC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,gCAAgC;EAClC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,gCAAgC;EAClC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,gCAAgC;EAClC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,iCAAiC;EACnC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,iCAAiC;EACnC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,gCAAgC;EAClC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,gCAAgC;EAClC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,gCAAgC;EAClC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,gCAAgC;EAClC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,iCAAiC;EACnC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,iCAAiC;EACnC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,gCAAgC;EAClC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,gCAAgC;EAClC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,gCAAgC;EAClC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,gCAAgC;EAClC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,iCAAiC;EACnC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,iCAAiC;EACnC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,gCAAgC;EAClC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,gCAAgC;EAClC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,gCAAgC;EAClC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,gCAAgC;EAClC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,iCAAiC;EACnC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,iCAAiC;EACnC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,qBAAqB;EACvB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,qBAAqB;EACvB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,qBAAqB;EACvB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,qBAAqB;EACvB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,qBAAqB;EACvB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,qBAAqB;EACvB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wGAAwG;EAC1G;EACA;IACE,wEAAwE;EAC1E;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,+BAA+B;EACjC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,sDAAsD;EACxD;EACA;IACE,sDAAsD;EACxD;EACA;IACE,wDAAwD;EAC1D;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,eAAe;EACjB;EACA;IACE,kCAAkC;EACpC;EACA;IACE,sDAAsD;EACxD;EACA;IACE,yDAAyD;EAC3D;EACA;IACE,6BAA6B;EAC/B;AACF;AACA;EACE;IACE,WAAW;EACb;EACA;IACE;MACE,gBAAgB;IAClB;EACF;EACA;IACE;MACE,gBAAgB;IAClB;EACF;EACA;IACE;MACE,iBAAiB;IACnB;EACF;EACA;IACE;MACE,iBAAiB;IACnB;EACF;EACA;IACE,cAAc;IACd,eAAe;EACjB;EACA;IACE,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,cAAc;IACd,qBAAqB;IACrB,gBAAgB;EAClB;EACA;IACE,cAAc;IACd,gBAAgB;EAClB;EACA;IACE,2BAA2B;IAC3B,kBAAkB;IAClB,qBAAqB;EACvB;EACA;IACE,kBAAkB;IAClB,+BAA+B;IAC/B,oBAAoB;EACtB;EACA;IACE,kCAAkC;IAClC,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;EAChB;EACA;IACE,kBAAkB;IAClB,oBAAoB;EACtB;EACA;IACE,WAAW;IACX,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,6BAA6B;IAC7B,YAAY;EACd;EACA;IACE,qBAAqB;IACrB,qBAAqB;IACrB,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;IACd,0BAA0B;IAC1B,0BAA0B;IAC1B,uCAAuC;IACvC,iBAAiB;IACjB,oBAAoB;IACpB,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,cAAc;IACd,gBAAgB;IAChB,iBAAiB;IACjB,aAAa;IACb,0BAA0B;IAC1B,sBAAsB;EACxB;EACA;IACE,cAAc;IACd,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,sBAAsB;EACxB;EACA;IACE,cAAc;IACd,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;IACjB,oBAAoB;IACpB,gBAAgB;EAClB;EACA;IACE,cAAc;IACd,gBAAgB;IAChB,iBAAiB;IACjB,oBAAoB;IACpB,gBAAgB;EAClB;EACA;IACE,cAAc;IACd,kBAAkB;IAClB,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,cAAc;IACd,gBAAgB;IAChB,kBAAkB;EACpB;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,cAAc;IACd,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;IAClB,sBAAsB;IACtB,uBAAuB;IACvB,0BAA0B;IAC1B,uBAAuB;IACvB,wBAAwB;IACxB,0BAA0B;IAC1B,2BAA2B;IAC3B,yBAAyB;EAC3B;EACA;IACE,6BAA6B;IAC7B,eAAe;IACf,gBAAgB;IAChB,UAAU;IACV,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,oBAAoB;IACpB,oBAAoB;EACtB;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,kBAAkB;IAClB,sBAAsB;EACxB;EACA;IACE,cAAc;IACd,gBAAgB;IAChB,wBAAwB;IACxB,4BAA4B;EAC9B;EACA;IACE,sBAAsB;IACtB,0BAA0B;IAC1B,2BAA2B;IAC3B,yBAAyB;EAC3B;EACA;IACE,wBAAwB;IACxB,4BAA4B;EAC9B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,mBAAmB;IACnB,wBAAwB;IACxB,0BAA0B;IAC1B,2BAA2B;IAC3B,yBAAyB;EAC3B;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,aAAa;IACb,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,OAAO;EACT;EACA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,aAAa;EACf;EACA;IACE,gBAAgB;EAClB;EACA;IACE,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,sBAAsB;EACxB;EACA;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,sBAAsB;IACtB,sBAAsB;IACtB,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,uBAAuB;IACvB,0BAA0B;IAC1B,yBAAyB;EAC3B;EACA;IACE,sBAAsB;IACtB,aAAa;IACb,oBAAoB;IACpB,gBAAgB;EAClB;EACA;IACE,sBAAsB;IACtB,iBAAiB;IACjB,oBAAoB;IACpB,gBAAgB;EAClB;EACA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,0BAA0B;IAC1B,sBAAsB;EACxB;EACA;IACE,uBAAuB;IACvB,0BAA0B;IAC1B,sBAAsB;EACxB;EACA;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,aAAa;IACb,gBAAgB;EAClB;EACA;IACE,sBAAsB;IACtB,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;IACtB,sBAAsB;IACtB,uBAAuB;IACvB,0BAA0B;IAC1B,sBAAsB;IACtB,wBAAwB;IACxB,kBAAkB;IAClB,2BAA2B;IAC3B,iBAAiB;EACnB;EACA;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,OAAO;EACT;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,mBAAmB;IACnB,kBAAkB;IAClB,oCAAoC;IACpC,iBAAiB;EACnB;EACA;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,sBAAsB;IACtB,gBAAgB;EAClB;EACA;IACE,kBAAkB;IAClB,2BAA2B;IAC3B,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,wBAAwB;IACxB,kBAAkB;IAClB,2BAA2B;IAC3B,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,aAAa;EACf;EACA;IACE,gBAAgB;EAClB;EACA;IACE,mBAAmB;IACnB,sBAAsB;EACxB;EACA;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,sBAAsB;IACtB,sBAAsB;IACtB,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,uBAAuB;IACvB,0BAA0B;IAC1B,iBAAiB;EACnB;EACA;IACE,sBAAsB;IACtB,aAAa;IACb,0BAA0B;IAC1B,cAAc;EAChB;EACA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,0BAA0B;IAC1B,sBAAsB;EACxB;EACA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,0BAA0B;IAC1B,gBAAgB;EAClB;EACA;IACE,uBAAuB;IACvB,0BAA0B;IAC1B,sBAAsB;EACxB;EACA;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,aAAa;IACb,gBAAgB;EAClB;EACA;IACE,sBAAsB;IACtB,gBAAgB;IAChB,eAAe;EACjB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,sBAAsB;IACtB,iBAAiB;IACjB,eAAe;IACf,kBAAkB;IAClB,uBAAuB;IACvB,gBAAgB;IAChB,oBAAoB;IACpB,mBAAmB;IACnB,mBAAmB;EACrB;EACA;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,OAAO;EACT;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,oCAAoC;IACpC,iBAAiB;EACnB;EACA;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,sBAAsB;IACtB,gBAAgB;EAClB;EACA;IACE,qBAAqB;IACrB,sBAAsB;IACtB,oBAAoB;EACtB;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sBAAsB;IACtB,oBAAoB;EACtB;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,aAAa;EACf;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,iBAAiB;IACjB,oBAAoB;IACpB,yBAAyB;EAC3B;EACA;IACE,gBAAgB;IAChB,aAAa;IACb,0BAA0B;IAC1B,cAAc;EAChB;EACA;IACE,gBAAgB;IAChB,uBAAuB;IACvB,0BAA0B;IAC1B,sBAAsB;EACxB;EACA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,0BAA0B;IAC1B,sBAAsB;EACxB;EACA;IACE,iBAAiB;IACjB,oBAAoB;IACpB,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,aAAa;IACb,gBAAgB;EAClB;EACA;IACE,gBAAgB;IAChB,sBAAsB;IACtB,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;IAChB,sBAAsB;IACtB,eAAe;IACf,kBAAkB;IAClB,qBAAqB;IACrB,wBAAwB;IACxB,0BAA0B;IAC1B,2BAA2B;IAC3B,yBAAyB;EAC3B;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,OAAO;EACT;EACA;IACE,mBAAmB;EACrB;EACA;IACE,aAAa;IACb,cAAc;IACd,0BAA0B;IAC1B,YAAY;EACd;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,gBAAgB;IAChB,sBAAsB;EACxB;EACA;IACE,0BAA0B;IAC1B,2BAA2B;IAC3B,yBAAyB;EAC3B;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,wBAAwB;IACxB,0BAA0B;IAC1B,2BAA2B;IAC3B,yBAAyB;EAC3B;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,aAAa;EACf;EACA;IACE,gBAAgB;EAClB;EACA;IACE,iBAAiB;IACjB,sBAAsB;EACxB;EACA;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,iBAAiB;IACjB,sBAAsB;IACtB,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,uBAAuB;IACvB,0BAA0B;IAC1B,yBAAyB;EAC3B;EACA;IACE,sBAAsB;IACtB,aAAa;IACb,sBAAsB;IACtB,cAAc;EAChB;EACA;IACE,cAAc;IACd,iBAAiB;IACjB,0BAA0B;IAC1B,sBAAsB;EACxB;EACA;IACE,gBAAgB;IAChB,uBAAuB;IACvB,0BAA0B;IAC1B,sBAAsB;EACxB;EACA;IACE,uBAAuB;IACvB,0BAA0B;IAC1B,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,aAAa;IACb,gBAAgB;EAClB;EACA;IACE,sBAAsB;IACtB,gBAAgB;IAChB,eAAe;EACjB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;IACtB,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,qBAAqB;IACrB,kBAAkB;IAClB,oBAAoB;IACpB,qBAAqB;IACrB,mBAAmB;EACrB;EACA;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,OAAO;EACT;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,oCAAoC;IACpC,YAAY;EACd;EACA;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,sBAAsB;IACtB,gBAAgB;EAClB;EACA;IACE,oBAAoB;IACpB,qBAAqB;IACrB,mBAAmB;EACrB;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;IAClB,oBAAoB;IACpB,qBAAqB;IACrB,mBAAmB;EACrB;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,aAAa;EACf;EACA;IACE,gBAAgB;EAClB;EACA;IACE,oBAAoB;IACpB,wDAAwD;IACxD,iDAAiD;EACnD;EACA;IACE,oBAAoB;IACpB,gDAAgD;IAChD,yDAAyD;EAC3D;EACA;IACE,oBAAoB;IACpB,4DAA4D;IAC5D,qDAAqD;EACvD;EACA;IACE,oBAAoB;IACpB,oDAAoD;IACpD,6DAA6D;EAC/D;EACA;IACE,oBAAoB;IACpB,2DAA2D;IAC3D,oDAAoD;EACtD;EACA;IACE,oBAAoB;IACpB,mDAAmD;IACnD,4DAA4D;EAC9D;EACA;IACE,oBAAoB;IACpB,4DAA4D;IAC5D,qDAAqD;EACvD;EACA;IACE,oBAAoB;IACpB,oDAAoD;IACpD,6DAA6D;EAC/D;EACA;IACE,oBAAoB;IACpB,yDAAyD;IACzD,kDAAkD;EACpD;EACA;IACE,oBAAoB;IACpB,iDAAiD;IACjD,0DAA0D;EAC5D;EACA;IACE,oBAAoB;IACpB,4DAA4D;IAC5D,qDAAqD;EACvD;EACA;IACE,oBAAoB;IACpB,oDAAoD;IACpD,6DAA6D;EAC/D;EACA;IACE,oBAAoB;IACpB,2DAA2D;IAC3D,oDAAoD;EACtD;EACA;IACE,oBAAoB;IACpB,mDAAmD;IACnD,4DAA4D;EAC9D;EACA;IACE,oBAAoB;IACpB,4DAA4D;IAC5D,qDAAqD;EACvD;EACA;IACE,oBAAoB;IACpB,oDAAoD;IACpD,6DAA6D;EAC/D;EACA;IACE,oBAAoB;IACpB,yDAAyD;IACzD,kDAAkD;EACpD;EACA;IACE,oBAAoB;IACpB,iDAAiD;IACjD,0DAA0D;EAC5D;EACA;IACE,oBAAoB;IACpB,4DAA4D;IAC5D,qDAAqD;EACvD;EACA;IACE,oBAAoB;IACpB,oDAAoD;IACpD,6DAA6D;EAC/D;EACA;IACE,oBAAoB;IACpB,2DAA2D;IAC3D,oDAAoD;EACtD;EACA;IACE,oBAAoB;IACpB,mDAAmD;IACnD,4DAA4D;EAC9D;EACA;IACE,oBAAoB;IACpB,4DAA4D;IAC5D,qDAAqD;EACvD;EACA;IACE,oBAAoB;IACpB,oDAAoD;IACpD,6DAA6D;EAC/D;EACA;IACE,oBAAoB;IACpB,yDAAyD;IACzD,kDAAkD;EACpD;EACA;IACE,oBAAoB;IACpB,iDAAiD;IACjD,0DAA0D;EAC5D;EACA;IACE,oBAAoB;IACpB,4DAA4D;IAC5D,qDAAqD;EACvD;EACA;IACE,oBAAoB;IACpB,oDAAoD;IACpD,6DAA6D;EAC/D;EACA;IACE,oBAAoB;IACpB,2DAA2D;IAC3D,oDAAoD;EACtD;EACA;IACE,oBAAoB;IACpB,mDAAmD;IACnD,4DAA4D;EAC9D;EACA;IACE,oBAAoB;IACpB,4DAA4D;IAC5D,qDAAqD;EACvD;EACA;IACE,oBAAoB;IACpB,oDAAoD;IACpD,6DAA6D;EAC/D;EACA;IACE,oBAAoB;IACpB,yDAAyD;IACzD,kDAAkD;EACpD;EACA;IACE,oBAAoB;IACpB,iDAAiD;IACjD,0DAA0D;EAC5D;EACA;IACE,oBAAoB;IACpB,yDAAyD;IACzD,kDAAkD;EACpD;EACA;IACE,oBAAoB;IACpB,iDAAiD;IACjD,0DAA0D;EAC5D;EACA;IACE,oBAAoB;IACpB,yDAAyD;IACzD,kDAAkD;EACpD;EACA;IACE,oBAAoB;IACpB,iDAAiD;IACjD,0DAA0D;EAC5D;EACA;IACE,oBAAoB;IACpB,yDAAyD;IACzD,kDAAkD;EACpD;EACA;IACE,oBAAoB;IACpB,iDAAiD;IACjD,0DAA0D;EAC5D;EACA;IACE,oBAAoB;IACpB,yDAAyD;IACzD,kDAAkD;EACpD;EACA;IACE,oBAAoB;IACpB,iDAAiD;IACjD,0DAA0D;EAC5D;EACA;IACE,oBAAoB;IACpB,yDAAyD;IACzD,kDAAkD;EACpD;EACA;IACE,oBAAoB;IACpB,iDAAiD;IACjD,0DAA0D;EAC5D;EACA;IACE,oBAAoB;IACpB,0DAA0D;IAC1D,mDAAmD;EACrD;EACA;IACE,oBAAoB;IACpB,kDAAkD;IAClD,2DAA2D;EAC7D;EACA;IACE,oBAAoB;IACpB,0DAA0D;IAC1D,mDAAmD;EACrD;EACA;IACE,oBAAoB;IACpB,kDAAkD;IAClD,2DAA2D;EAC7D;EACA;IACE,oBAAoB;IACpB,0DAA0D;IAC1D,mDAAmD;EACrD;EACA;IACE,oBAAoB;IACpB,kDAAkD;IAClD,2DAA2D;EAC7D;EACA;IACE,oBAAoB;IACpB,0DAA0D;IAC1D,mDAAmD;EACrD;EACA;IACE,oBAAoB;IACpB,kDAAkD;IAClD,2DAA2D;EAC7D;EACA;IACE,oBAAoB;IACpB,0DAA0D;IAC1D,mDAAmD;EACrD;EACA;IACE,oBAAoB;IACpB,kDAAkD;IAClD,2DAA2D;EAC7D;EACA;IACE,oBAAoB;IACpB,0DAA0D;IAC1D,mDAAmD;EACrD;EACA;IACE,oBAAoB;IACpB,kDAAkD;IAClD,2DAA2D;EAC7D;EACA;IACE,oBAAoB;IACpB,0DAA0D;IAC1D,mDAAmD;EACrD;EACA;IACE,oBAAoB;IACpB,kDAAkD;IAClD,2DAA2D;EAC7D;EACA;IACE,oBAAoB;IACpB,0DAA0D;IAC1D,mDAAmD;EACrD;EACA;IACE,oBAAoB;IACpB,kDAAkD;IAClD,2DAA2D;EAC7D;EACA;IACE,oBAAoB;IACpB,0DAA0D;IAC1D,mDAAmD;EACrD;EACA;IACE,oBAAoB;IACpB,kDAAkD;IAClD,2DAA2D;EAC7D;EACA;IACE,oBAAoB;IACpB,0DAA0D;IAC1D,mDAAmD;EACrD;EACA;IACE,oBAAoB;IACpB,kDAAkD;IAClD,2DAA2D;EAC7D;EACA;IACE,oBAAoB;IACpB,wDAAwD;IACxD,iDAAiD;EACnD;EACA;IACE,oBAAoB;IACpB,gDAAgD;IAChD,yDAAyD;EAC3D;EACA;IACE,oBAAoB;IACpB,6DAA6D;IAC7D,sDAAsD;EACxD;EACA;IACE,oBAAoB;IACpB,qDAAqD;IACrD,8DAA8D;EAChE;EACA;IACE,oBAAoB;IACpB,6DAA6D;IAC7D,sDAAsD;EACxD;EACA;IACE,oBAAoB;IACpB,qDAAqD;IACrD,8DAA8D;EAChE;EACA;IACE,oBAAoB;IACpB,6DAA6D;IAC7D,sDAAsD;EACxD;EACA;IACE,oBAAoB;IACpB,qDAAqD;IACrD,8DAA8D;EAChE;EACA;IACE,oBAAoB;IACpB,6DAA6D;IAC7D,sDAAsD;EACxD;EACA;IACE,oBAAoB;IACpB,qDAAqD;IACrD,8DAA8D;EAChE;EACA;IACE,oBAAoB;IACpB,wDAAwD;IACxD,iDAAiD;EACnD;EACA;IACE,oBAAoB;IACpB,gDAAgD;IAChD,yDAAyD;EAC3D;EACA;IACE,oBAAoB;IACpB,+DAA+D;IAC/D,wDAAwD;EAC1D;EACA;IACE,oBAAoB;IACpB,uDAAuD;IACvD,gEAAgE;EAClE;EACA;IACE,oBAAoB;IACpB,+DAA+D;IAC/D,wDAAwD;EAC1D;EACA;IACE,oBAAoB;IACpB,uDAAuD;IACvD,gEAAgE;EAClE;EACA;IACE,oBAAoB;IACpB,wDAAwD;IACxD,iDAAiD;EACnD;EACA;IACE,oBAAoB;IACpB,gDAAgD;IAChD,yDAAyD;EAC3D;EACA;IACE,oBAAoB;IACpB,wDAAwD;IACxD,iDAAiD;EACnD;EACA;IACE,oBAAoB;IACpB,gDAAgD;IAChD,yDAAyD;EAC3D;EACA;IACE,oBAAoB;IACpB,wDAAwD;IACxD,iDAAiD;EACnD;EACA;IACE,oBAAoB;IACpB,gDAAgD;IAChD,yDAAyD;EAC3D;EACA;IACE,oBAAoB;IACpB,wDAAwD;IACxD,iDAAiD;EACnD;EACA;IACE,oBAAoB;IACpB,gDAAgD;IAChD,yDAAyD;EAC3D;EACA;IACE,oBAAoB;IACpB,wDAAwD;IACxD,iDAAiD;EACnD;EACA;IACE,oBAAoB;IACpB,gDAAgD;IAChD,yDAAyD;EAC3D;EACA;IACE,oBAAoB;IACpB,wDAAwD;IACxD,iDAAiD;EACnD;EACA;IACE,oBAAoB;IACpB,gDAAgD;IAChD,yDAAyD;EAC3D;EACA;IACE,oBAAoB;IACpB,wDAAwD;IACxD,iDAAiD;EACnD;EACA;IACE,oBAAoB;IACpB,gDAAgD;IAChD,yDAAyD;EAC3D;EACA;IACE,oBAAoB;IACpB,+DAA+D;IAC/D,wDAAwD;EAC1D;EACA;IACE,oBAAoB;IACpB,uDAAuD;IACvD,gEAAgE;EAClE;EACA;IACE,oBAAoB;IACpB,+DAA+D;IAC/D,wDAAwD;EAC1D;EACA;IACE,oBAAoB;IACpB,uDAAuD;IACvD,gEAAgE;EAClE;EACA;IACE,oBAAoB;IACpB,wDAAwD;IACxD,iDAAiD;EACnD;EACA;IACE,oBAAoB;IACpB,gDAAgD;IAChD,yDAAyD;EAC3D;EACA;IACE,oBAAoB;IACpB,+DAA+D;IAC/D,wDAAwD;EAC1D;EACA;IACE,oBAAoB;IACpB,uDAAuD;IACvD,gEAAgE;EAClE;EACA;IACE,oBAAoB;IACpB,+DAA+D;IAC/D,wDAAwD;EAC1D;EACA;IACE,oBAAoB;IACpB,uDAAuD;IACvD,gEAAgE;EAClE;EACA;IACE,oBAAoB;IACpB,8DAA8D;IAC9D,uDAAuD;EACzD;EACA;IACE,oBAAoB;IACpB,sDAAsD;IACtD,+DAA+D;EACjE;EACA;IACE,oBAAoB;IACpB,+DAA+D;IAC/D,wDAAwD;EAC1D;EACA;IACE,oBAAoB;IACpB,uDAAuD;IACvD,gEAAgE;EAClE;EACA;IACE,oBAAoB;IACpB,wDAAwD;IACxD,iDAAiD;EACnD;EACA;IACE,oBAAoB;IACpB,gDAAgD;IAChD,yDAAyD;EAC3D;EACA;IACE,oBAAoB;IACpB,+DAA+D;IAC/D,wDAAwD;EAC1D;EACA;IACE,oBAAoB;IACpB,uDAAuD;IACvD,gEAAgE;EAClE;EACA;IACE,oBAAoB;IACpB,+DAA+D;IAC/D,wDAAwD;EAC1D;EACA;IACE,oBAAoB;IACpB,uDAAuD;IACvD,gEAAgE;EAClE;EACA;IACE,oBAAoB;IACpB,wDAAwD;IACxD,iDAAiD;EACnD;EACA;IACE,oBAAoB;IACpB,gDAAgD;IAChD,yDAAyD;EAC3D;EACA;IACE,oBAAoB;IACpB,+DAA+D;IAC/D,wDAAwD;EAC1D;EACA;IACE,oBAAoB;IACpB,uDAAuD;IACvD,gEAAgE;EAClE;EACA;IACE,oBAAoB;IACpB,+DAA+D;IAC/D,wDAAwD;EAC1D;EACA;IACE,oBAAoB;IACpB,uDAAuD;IACvD,gEAAgE;EAClE;EACA;IACE,oBAAoB;IACpB,wDAAwD;IACxD,iDAAiD;EACnD;EACA;IACE,oBAAoB;IACpB,gDAAgD;IAChD,yDAAyD;EAC3D;EACA;IACE,oBAAoB;IACpB,+DAA+D;IAC/D,wDAAwD;EAC1D;EACA;IACE,oBAAoB;IACpB,uDAAuD;IACvD,gEAAgE;EAClE;EACA;IACE,oBAAoB;IACpB,+DAA+D;IAC/D,wDAAwD;EAC1D;EACA;IACE,oBAAoB;IACpB,uDAAuD;IACvD,gEAAgE;EAClE;EACA;IACE,oBAAoB;IACpB,yDAAyD;IACzD,kDAAkD;EACpD;EACA;IACE,oBAAoB;IACpB,iDAAiD;IACjD,0DAA0D;EAC5D;EACA;IACE,oBAAoB;IACpB,6DAA6D;IAC7D,sDAAsD;EACxD;EACA;IACE,oBAAoB;IACpB,qDAAqD;IACrD,8DAA8D;EAChE;EACA;IACE,oBAAoB;IACpB,4DAA4D;IAC5D,qDAAqD;EACvD;EACA;IACE,oBAAoB;IACpB,oDAAoD;IACpD,6DAA6D;EAC/D;EACA;IACE,oBAAoB;IACpB,6DAA6D;IAC7D,sDAAsD;EACxD;EACA;IACE,oBAAoB;IACpB,qDAAqD;IACrD,8DAA8D;EAChE;EACA;IACE,oBAAoB;IACpB,0DAA0D;IAC1D,mDAAmD;EACrD;EACA;IACE,oBAAoB;IACpB,kDAAkD;IAClD,2DAA2D;EAC7D;EACA;IACE,oBAAoB;IACpB,6DAA6D;IAC7D,sDAAsD;EACxD;EACA;IACE,oBAAoB;IACpB,qDAAqD;IACrD,8DAA8D;EAChE;EACA;IACE,oBAAoB;IACpB,4DAA4D;IAC5D,qDAAqD;EACvD;EACA;IACE,oBAAoB;IACpB,oDAAoD;IACpD,6DAA6D;EAC/D;EACA;IACE,oBAAoB;IACpB,6DAA6D;IAC7D,sDAAsD;EACxD;EACA;IACE,oBAAoB;IACpB,qDAAqD;IACrD,8DAA8D;EAChE;EACA;IACE,oBAAoB;IACpB,0DAA0D;IAC1D,mDAAmD;EACrD;EACA;IACE,oBAAoB;IACpB,kDAAkD;IAClD,2DAA2D;EAC7D;EACA;IACE,oBAAoB;IACpB,6DAA6D;IAC7D,sDAAsD;EACxD;EACA;IACE,oBAAoB;IACpB,qDAAqD;IACrD,8DAA8D;EAChE;EACA;IACE,oBAAoB;IACpB,4DAA4D;IAC5D,qDAAqD;EACvD;EACA;IACE,oBAAoB;IACpB,oDAAoD;IACpD,6DAA6D;EAC/D;EACA;IACE,oBAAoB;IACpB,6DAA6D;IAC7D,sDAAsD;EACxD;EACA;IACE,oBAAoB;IACpB,qDAAqD;IACrD,8DAA8D;EAChE;EACA;IACE,oBAAoB;IACpB,0DAA0D;IAC1D,mDAAmD;EACrD;EACA;IACE,oBAAoB;IACpB,kDAAkD;IAClD,2DAA2D;EAC7D;EACA;IACE,oBAAoB;IACpB,6DAA6D;IAC7D,sDAAsD;EACxD;EACA;IACE,oBAAoB;IACpB,qDAAqD;IACrD,8DAA8D;EAChE;EACA;IACE,oBAAoB;IACpB,4DAA4D;IAC5D,qDAAqD;EACvD;EACA;IACE,oBAAoB;IACpB,oDAAoD;IACpD,6DAA6D;EAC/D;EACA;IACE,oBAAoB;IACpB,6DAA6D;IAC7D,sDAAsD;EACxD;EACA;IACE,oBAAoB;IACpB,qDAAqD;IACrD,8DAA8D;EAChE;EACA;IACE,oBAAoB;IACpB,0DAA0D;IAC1D,mDAAmD;EACrD;EACA;IACE,oBAAoB;IACpB,kDAAkD;IAClD,2DAA2D;EAC7D;EACA;IACE,oBAAoB;IACpB,0DAA0D;IAC1D,mDAAmD;EACrD;EACA;IACE,oBAAoB;IACpB,kDAAkD;IAClD,2DAA2D;EAC7D;EACA;IACE,oBAAoB;IACpB,0DAA0D;IAC1D,mDAAmD;EACrD;EACA;IACE,oBAAoB;IACpB,kDAAkD;IAClD,2DAA2D;EAC7D;EACA;IACE,oBAAoB;IACpB,0DAA0D;IAC1D,mDAAmD;EACrD;EACA;IACE,oBAAoB;IACpB,kDAAkD;IAClD,2DAA2D;EAC7D;EACA;IACE,oBAAoB;IACpB,0DAA0D;IAC1D,mDAAmD;EACrD;EACA;IACE,oBAAoB;IACpB,kDAAkD;IAClD,2DAA2D;EAC7D;EACA;IACE,oBAAoB;IACpB,0DAA0D;IAC1D,mDAAmD;EACrD;EACA;IACE,oBAAoB;IACpB,kDAAkD;IAClD,2DAA2D;EAC7D;EACA;IACE,oBAAoB;IACpB,2DAA2D;IAC3D,oDAAoD;EACtD;EACA;IACE,oBAAoB;IACpB,mDAAmD;IACnD,4DAA4D;EAC9D;EACA;IACE,oBAAoB;IACpB,2DAA2D;IAC3D,oDAAoD;EACtD;EACA;IACE,oBAAoB;IACpB,mDAAmD;IACnD,4DAA4D;EAC9D;EACA;IACE,oBAAoB;IACpB,2DAA2D;IAC3D,oDAAoD;EACtD;EACA;IACE,oBAAoB;IACpB,mDAAmD;IACnD,4DAA4D;EAC9D;EACA;IACE,oBAAoB;IACpB,2DAA2D;IAC3D,oDAAoD;EACtD;EACA;IACE,oBAAoB;IACpB,mDAAmD;IACnD,4DAA4D;EAC9D;EACA;IACE,oBAAoB;IACpB,2DAA2D;IAC3D,oDAAoD;EACtD;EACA;IACE,oBAAoB;IACpB,mDAAmD;IACnD,4DAA4D;EAC9D;EACA;IACE,oBAAoB;IACpB,2DAA2D;IAC3D,oDAAoD;EACtD;EACA;IACE,oBAAoB;IACpB,mDAAmD;IACnD,4DAA4D;EAC9D;EACA;IACE,oBAAoB;IACpB,2DAA2D;IAC3D,oDAAoD;EACtD;EACA;IACE,oBAAoB;IACpB,mDAAmD;IACnD,4DAA4D;EAC9D;EACA;IACE,oBAAoB;IACpB,2DAA2D;IAC3D,oDAAoD;EACtD;EACA;IACE,oBAAoB;IACpB,mDAAmD;IACnD,4DAA4D;EAC9D;EACA;IACE,oBAAoB;IACpB,2DAA2D;IAC3D,oDAAoD;EACtD;EACA;IACE,oBAAoB;IACpB,mDAAmD;IACnD,4DAA4D;EAC9D;EACA;IACE,oBAAoB;IACpB,2DAA2D;IAC3D,oDAAoD;EACtD;EACA;IACE,oBAAoB;IACpB,mDAAmD;IACnD,4DAA4D;EAC9D;EACA;IACE,oBAAoB;IACpB,yDAAyD;IACzD,kDAAkD;EACpD;EACA;IACE,oBAAoB;IACpB,iDAAiD;IACjD,0DAA0D;EAC5D;EACA;IACE,oBAAoB;IACpB,8DAA8D;IAC9D,uDAAuD;EACzD;EACA;IACE,oBAAoB;IACpB,sDAAsD;IACtD,+DAA+D;EACjE;EACA;IACE,oBAAoB;IACpB,8DAA8D;IAC9D,uDAAuD;EACzD;EACA;IACE,oBAAoB;IACpB,sDAAsD;IACtD,+DAA+D;EACjE;EACA;IACE,oBAAoB;IACpB,8DAA8D;IAC9D,uDAAuD;EACzD;EACA;IACE,oBAAoB;IACpB,sDAAsD;IACtD,+DAA+D;EACjE;EACA;IACE,oBAAoB;IACpB,8DAA8D;IAC9D,uDAAuD;EACzD;EACA;IACE,oBAAoB;IACpB,sDAAsD;IACtD,+DAA+D;EACjE;EACA;IACE,oBAAoB;IACpB,yDAAyD;IACzD,kDAAkD;EACpD;EACA;IACE,oBAAoB;IACpB,iDAAiD;IACjD,0DAA0D;EAC5D;EACA;IACE,oBAAoB;IACpB,+DAA+D;IAC/D,wDAAwD;EAC1D;EACA;IACE,oBAAoB;IACpB,uDAAuD;IACvD,gEAAgE;EAClE;EACA;IACE,oBAAoB;IACpB,+DAA+D;IAC/D,wDAAwD;EAC1D;EACA;IACE,oBAAoB;IACpB,uDAAuD;IACvD,gEAAgE;EAClE;EACA;IACE,oBAAoB;IACpB,yDAAyD;IACzD,kDAAkD;EACpD;EACA;IACE,oBAAoB;IACpB,iDAAiD;IACjD,0DAA0D;EAC5D;EACA;IACE,oBAAoB;IACpB,yDAAyD;IACzD,kDAAkD;EACpD;EACA;IACE,oBAAoB;IACpB,iDAAiD;IACjD,0DAA0D;EAC5D;EACA;IACE,oBAAoB;IACpB,yDAAyD;IACzD,kDAAkD;EACpD;EACA;IACE,oBAAoB;IACpB,iDAAiD;IACjD,0DAA0D;EAC5D;EACA;IACE,oBAAoB;IACpB,yDAAyD;IACzD,kDAAkD;EACpD;EACA;IACE,oBAAoB;IACpB,iDAAiD;IACjD,0DAA0D;EAC5D;EACA;IACE,oBAAoB;IACpB,yDAAyD;IACzD,kDAAkD;EACpD;EACA;IACE,oBAAoB;IACpB,iDAAiD;IACjD,0DAA0D;EAC5D;EACA;IACE,oBAAoB;IACpB,yDAAyD;IACzD,kDAAkD;EACpD;EACA;IACE,oBAAoB;IACpB,iDAAiD;IACjD,0DAA0D;EAC5D;EACA;IACE,oBAAoB;IACpB,yDAAyD;IACzD,kDAAkD;EACpD;EACA;IACE,oBAAoB;IACpB,iDAAiD;IACjD,0DAA0D;EAC5D;EACA;IACE,oBAAoB;IACpB,+DAA+D;IAC/D,wDAAwD;EAC1D;EACA;IACE,oBAAoB;IACpB,uDAAuD;IACvD,gEAAgE;EAClE;EACA;IACE,oBAAoB;IACpB,+DAA+D;IAC/D,wDAAwD;EAC1D;EACA;IACE,oBAAoB;IACpB,uDAAuD;IACvD,gEAAgE;EAClE;EACA;IACE,oBAAoB;IACpB,yDAAyD;IACzD,kDAAkD;EACpD;EACA;IACE,oBAAoB;IACpB,iDAAiD;IACjD,0DAA0D;EAC5D;EACA;IACE,oBAAoB;IACpB,+DAA+D;IAC/D,wDAAwD;EAC1D;EACA;IACE,oBAAoB;IACpB,uDAAuD;IACvD,gEAAgE;EAClE;EACA;IACE,oBAAoB;IACpB,+DAA+D;IAC/D,wDAAwD;EAC1D;EACA;IACE,oBAAoB;IACpB,uDAAuD;IACvD,gEAAgE;EAClE;EACA;IACE,oBAAoB;IACpB,8DAA8D;IAC9D,uDAAuD;EACzD;EACA;IACE,oBAAoB;IACpB,sDAAsD;IACtD,+DAA+D;EACjE;EACA;IACE,oBAAoB;IACpB,+DAA+D;IAC/D,wDAAwD;EAC1D;EACA;IACE,oBAAoB;IACpB,uDAAuD;IACvD,gEAAgE;EAClE;EACA;IACE,oBAAoB;IACpB,yDAAyD;IACzD,kDAAkD;EACpD;EACA;IACE,oBAAoB;IACpB,iDAAiD;IACjD,0DAA0D;EAC5D;EACA;IACE,oBAAoB;IACpB,+DAA+D;IAC/D,wDAAwD;EAC1D;EACA;IACE,oBAAoB;IACpB,uDAAuD;IACvD,gEAAgE;EAClE;EACA;IACE,oBAAoB;IACpB,+DAA+D;IAC/D,wDAAwD;EAC1D;EACA;IACE,oBAAoB;IACpB,uDAAuD;IACvD,gEAAgE;EAClE;EACA;IACE,oBAAoB;IACpB,yDAAyD;IACzD,kDAAkD;EACpD;EACA;IACE,oBAAoB;IACpB,iDAAiD;IACjD,0DAA0D;EAC5D;EACA;IACE,oBAAoB;IACpB,+DAA+D;IAC/D,wDAAwD;EAC1D;EACA;IACE,oBAAoB;IACpB,uDAAuD;IACvD,gEAAgE;EAClE;EACA;IACE,oBAAoB;IACpB,+DAA+D;IAC/D,wDAAwD;EAC1D;EACA;IACE,oBAAoB;IACpB,uDAAuD;IACvD,gEAAgE;EAClE;EACA;IACE,oBAAoB;IACpB,yDAAyD;IACzD,kDAAkD;EACpD;EACA;IACE,oBAAoB;IACpB,iDAAiD;IACjD,0DAA0D;EAC5D;EACA;IACE,oBAAoB;IACpB,+DAA+D;IAC/D,wDAAwD;EAC1D;EACA;IACE,oBAAoB;IACpB,uDAAuD;IACvD,gEAAgE;EAClE;EACA;IACE,oBAAoB;IACpB,+DAA+D;IAC/D,wDAAwD;EAC1D;EACA;IACE,oBAAoB;IACpB,uDAAuD;IACvD,gEAAgE;EAClE;EACA;IACE,oBAAoB;IACpB,0DAA0D;IAC1D,mDAAmD;EACrD;EACA;IACE,oBAAoB;IACpB,kDAAkD;IAClD,2DAA2D;EAC7D;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,qBAAqB;IACrB,+DAA+D;IAC/D,wDAAwD;EAC1D;EACA;IACE,qBAAqB;IACrB,uDAAuD;IACvD,gEAAgE;EAClE;EACA;IACE,qBAAqB;IACrB,+DAA+D;IAC/D,wDAAwD;EAC1D;EACA;IACE,qBAAqB;IACrB,uDAAuD;IACvD,gEAAgE;EAClE;EACA;IACE,qBAAqB;IACrB,+DAA+D;IAC/D,wDAAwD;EAC1D;EACA;IACE,qBAAqB;IACrB,uDAAuD;IACvD,gEAAgE;EAClE;EACA;IACE,qBAAqB;IACrB,+DAA+D;IAC/D,wDAAwD;EAC1D;EACA;IACE,qBAAqB;IACrB,uDAAuD;IACvD,gEAAgE;EAClE;EACA;IACE,qBAAqB;IACrB,+DAA+D;IAC/D,wDAAwD;EAC1D;EACA;IACE,qBAAqB;IACrB,uDAAuD;IACvD,gEAAgE;EAClE;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,kDAAkD;EACpD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,oDAAoD;EACtD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,oDAAoD;EACtD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,oDAAoD;EACtD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,oDAAoD;EACtD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,UAAU;IACV,YAAY;IACZ,gBAAgB;IAChB,sBAAsB;IACtB,mBAAmB;IACnB,eAAe;EACjB;EACA;IACE,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,UAAU;IACV,SAAS;IACT,iBAAiB;IACjB,UAAU;IACV,mBAAmB;EACrB;EACA;IACE,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,UAAU;IACV,YAAY;IACZ,gBAAgB;IAChB,sBAAsB;IACtB,mBAAmB;IACnB,eAAe;EACjB;EACA;IACE,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,UAAU;IACV,SAAS;IACT,iBAAiB;IACjB,UAAU;IACV,mBAAmB;EACrB;EACA;IAGE,gBAAgB;EAClB;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,6BAA6B;IAC7B,qBAAqB;EACvB;EACA;IACE,8BAA8B;EAChC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,kDAAkD;EACpD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,oDAAoD;EACtD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,oDAAoD;EACtD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,oDAAoD;EACtD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,oDAAoD;EACtD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,8BAA8B;EAChC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,kDAAkD;EACpD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,oDAAoD;EACtD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,oDAAoD;EACtD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,oDAAoD;EACtD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,oDAAoD;EACtD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,8BAA8B;EAChC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,kDAAkD;EACpD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,oDAAoD;EACtD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,oDAAoD;EACtD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,oDAAoD;EACtD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,oDAAoD;EACtD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,8BAA8B;EAChC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,kDAAkD;EACpD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,oDAAoD;EACtD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,oDAAoD;EACtD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,oDAAoD;EACtD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,oDAAoD;EACtD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,8BAA8B;EAChC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,kDAAkD;EACpD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,oDAAoD;EACtD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,oDAAoD;EACtD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,oDAAoD;EACtD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,oDAAoD;EACtD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,8BAA8B;EAChC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,kDAAkD;EACpD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,oDAAoD;EACtD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,oDAAoD;EACtD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,oDAAoD;EACtD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,oDAAoD;EACtD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sEAAsE;EACxE;EACA;IACE,4EAA4E;EAC9E;EACA;IACE,wEAAwE;EAC1E;EACA;IACE,+EAA+E;EACjF;EACA;IACE,yEAAyE;EAC3E;EACA;IACE,8EAA8E;EAChF;EACA;IACE,uEAAuE;EACzE;EACA;IACE,2EAA2E;EAC7E;EACA;IACE,mCAAmC;IACnC,oGAAoG;EACtG;EACA;IACE,kCAAkC;IAClC,8FAA8F;EAChG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,8FAA8F;EAChG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,iGAAiG;EACnG;EACA;IACE,8BAA8B;IAC9B,iGAAiG;EACnG;EACA;IACE,8BAA8B;IAC9B,iGAAiG;EACnG;EACA;IACE,8BAA8B;IAC9B,iGAAiG;EACnG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,mGAAmG;EACrG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,iGAAiG;EACnG;EACA;IACE,8BAA8B;IAC9B,iGAAiG;EACnG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,mGAAmG;EACrG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,iGAAiG;EACnG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,mGAAmG;EACrG;EACA;IACE,8BAA8B;IAC9B,mGAAmG;EACrG;EACA;IACE,8BAA8B;IAC9B,iGAAiG;EACnG;EACA;IACE,8BAA8B;IAC9B,iGAAiG;EACnG;EACA;IACE,8BAA8B;IAC9B,gGAAgG;EAClG;EACA;IACE,8BAA8B;IAC9B,gGAAgG;EAClG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,mGAAmG;EACrG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,gGAAgG;EAClG;EACA;IACE,8BAA8B;IAC9B,gGAAgG;EAClG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,mGAAmG;EACrG;EACA;IACE,8BAA8B;IAC9B,mGAAmG;EACrG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,mGAAmG;EACrG;EACA;IACE,8BAA8B;IAC9B,mGAAmG;EACrG;EACA;IACE,8BAA8B;IAC9B,mGAAmG;EACrG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,mGAAmG;EACrG;EACA;IACE,8BAA8B;IAC9B,mGAAmG;EACrG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,iGAAiG;EACnG;EACA;IACE,8BAA8B;IAC9B,iGAAiG;EACnG;EACA;IACE,8BAA8B;IAC9B,iGAAiG;EACnG;EACA;IACE,kCAAkC;IAClC,+HAA+H;EACjI;EACA;IACE,iCAAiC;IACjC,yHAAyH;EAC3H;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,yHAAyH;EAC3H;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,4HAA4H;EAC9H;EACA;IACE,6BAA6B;IAC7B,4HAA4H;EAC9H;EACA;IACE,6BAA6B;IAC7B,4HAA4H;EAC9H;EACA;IACE,6BAA6B;IAC7B,4HAA4H;EAC9H;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,8HAA8H;EAChI;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,4HAA4H;EAC9H;EACA;IACE,6BAA6B;IAC7B,4HAA4H;EAC9H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,8HAA8H;EAChI;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,4HAA4H;EAC9H;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,8HAA8H;EAChI;EACA;IACE,6BAA6B;IAC7B,8HAA8H;EAChI;EACA;IACE,6BAA6B;IAC7B,4HAA4H;EAC9H;EACA;IACE,6BAA6B;IAC7B,4HAA4H;EAC9H;EACA;IACE,6BAA6B;IAC7B,2HAA2H;EAC7H;EACA;IACE,6BAA6B;IAC7B,2HAA2H;EAC7H;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,8HAA8H;EAChI;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,2HAA2H;EAC7H;EACA;IACE,6BAA6B;IAC7B,2HAA2H;EAC7H;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,8HAA8H;EAChI;EACA;IACE,6BAA6B;IAC7B,8HAA8H;EAChI;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,8HAA8H;EAChI;EACA;IACE,6BAA6B;IAC7B,8HAA8H;EAChI;EACA;IACE,6BAA6B;IAC7B,8HAA8H;EAChI;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,8HAA8H;EAChI;EACA;IACE,6BAA6B;IAC7B,8HAA8H;EAChI;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,4HAA4H;EAC9H;EACA;IACE,6BAA6B;IAC7B,4HAA4H;EAC9H;EACA;IACE,6BAA6B;IAC7B,4HAA4H;EAC9H;EACA;IACE,iCAAiC;EACnC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,mCAAmC;IACnC,oGAAoG;EACtG;EACA;IACE,kCAAkC;IAClC,8FAA8F;EAChG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,8FAA8F;EAChG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,iGAAiG;EACnG;EACA;IACE,8BAA8B;IAC9B,iGAAiG;EACnG;EACA;IACE,8BAA8B;IAC9B,iGAAiG;EACnG;EACA;IACE,8BAA8B;IAC9B,iGAAiG;EACnG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,mGAAmG;EACrG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,iGAAiG;EACnG;EACA;IACE,8BAA8B;IAC9B,iGAAiG;EACnG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,mGAAmG;EACrG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,iGAAiG;EACnG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,mGAAmG;EACrG;EACA;IACE,8BAA8B;IAC9B,mGAAmG;EACrG;EACA;IACE,8BAA8B;IAC9B,iGAAiG;EACnG;EACA;IACE,8BAA8B;IAC9B,iGAAiG;EACnG;EACA;IACE,8BAA8B;IAC9B,gGAAgG;EAClG;EACA;IACE,8BAA8B;IAC9B,gGAAgG;EAClG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,mGAAmG;EACrG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,gGAAgG;EAClG;EACA;IACE,8BAA8B;IAC9B,gGAAgG;EAClG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,mGAAmG;EACrG;EACA;IACE,8BAA8B;IAC9B,mGAAmG;EACrG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,mGAAmG;EACrG;EACA;IACE,8BAA8B;IAC9B,mGAAmG;EACrG;EACA;IACE,8BAA8B;IAC9B,mGAAmG;EACrG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,mGAAmG;EACrG;EACA;IACE,8BAA8B;IAC9B,mGAAmG;EACrG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,iGAAiG;EACnG;EACA;IACE,8BAA8B;IAC9B,iGAAiG;EACnG;EACA;IACE,8BAA8B;IAC9B,iGAAiG;EACnG;EACA;IACE,kCAAkC;IAClC,+HAA+H;EACjI;EACA;IACE,iCAAiC;IACjC,yHAAyH;EAC3H;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,yHAAyH;EAC3H;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,4HAA4H;EAC9H;EACA;IACE,6BAA6B;IAC7B,4HAA4H;EAC9H;EACA;IACE,6BAA6B;IAC7B,4HAA4H;EAC9H;EACA;IACE,6BAA6B;IAC7B,4HAA4H;EAC9H;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,8HAA8H;EAChI;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,4HAA4H;EAC9H;EACA;IACE,6BAA6B;IAC7B,4HAA4H;EAC9H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,8HAA8H;EAChI;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,4HAA4H;EAC9H;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,8HAA8H;EAChI;EACA;IACE,6BAA6B;IAC7B,8HAA8H;EAChI;EACA;IACE,6BAA6B;IAC7B,4HAA4H;EAC9H;EACA;IACE,6BAA6B;IAC7B,4HAA4H;EAC9H;EACA;IACE,6BAA6B;IAC7B,2HAA2H;EAC7H;EACA;IACE,6BAA6B;IAC7B,2HAA2H;EAC7H;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,8HAA8H;EAChI;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,2HAA2H;EAC7H;EACA;IACE,6BAA6B;IAC7B,2HAA2H;EAC7H;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,8HAA8H;EAChI;EACA;IACE,6BAA6B;IAC7B,8HAA8H;EAChI;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,8HAA8H;EAChI;EACA;IACE,6BAA6B;IAC7B,8HAA8H;EAChI;EACA;IACE,6BAA6B;IAC7B,8HAA8H;EAChI;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,8HAA8H;EAChI;EACA;IACE,6BAA6B;IAC7B,8HAA8H;EAChI;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,4HAA4H;EAC9H;EACA;IACE,6BAA6B;IAC7B,4HAA4H;EAC9H;EACA;IACE,6BAA6B;IAC7B,4HAA4H;EAC9H;EACA;IACE,iCAAiC;EACnC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,mCAAmC;IACnC,oGAAoG;EACtG;EACA;IACE,kCAAkC;IAClC,8FAA8F;EAChG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,8FAA8F;EAChG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,iGAAiG;EACnG;EACA;IACE,8BAA8B;IAC9B,iGAAiG;EACnG;EACA;IACE,8BAA8B;IAC9B,iGAAiG;EACnG;EACA;IACE,8BAA8B;IAC9B,iGAAiG;EACnG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,mGAAmG;EACrG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,iGAAiG;EACnG;EACA;IACE,8BAA8B;IAC9B,iGAAiG;EACnG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,mGAAmG;EACrG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,iGAAiG;EACnG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,mGAAmG;EACrG;EACA;IACE,8BAA8B;IAC9B,mGAAmG;EACrG;EACA;IACE,8BAA8B;IAC9B,iGAAiG;EACnG;EACA;IACE,8BAA8B;IAC9B,iGAAiG;EACnG;EACA;IACE,8BAA8B;IAC9B,gGAAgG;EAClG;EACA;IACE,8BAA8B;IAC9B,gGAAgG;EAClG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,mGAAmG;EACrG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,gGAAgG;EAClG;EACA;IACE,8BAA8B;IAC9B,gGAAgG;EAClG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,mGAAmG;EACrG;EACA;IACE,8BAA8B;IAC9B,mGAAmG;EACrG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,mGAAmG;EACrG;EACA;IACE,8BAA8B;IAC9B,mGAAmG;EACrG;EACA;IACE,8BAA8B;IAC9B,mGAAmG;EACrG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,mGAAmG;EACrG;EACA;IACE,8BAA8B;IAC9B,mGAAmG;EACrG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,iGAAiG;EACnG;EACA;IACE,8BAA8B;IAC9B,iGAAiG;EACnG;EACA;IACE,8BAA8B;IAC9B,iGAAiG;EACnG;EACA;IACE,kCAAkC;IAClC,+HAA+H;EACjI;EACA;IACE,iCAAiC;IACjC,yHAAyH;EAC3H;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,yHAAyH;EAC3H;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,4HAA4H;EAC9H;EACA;IACE,6BAA6B;IAC7B,4HAA4H;EAC9H;EACA;IACE,6BAA6B;IAC7B,4HAA4H;EAC9H;EACA;IACE,6BAA6B;IAC7B,4HAA4H;EAC9H;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,8HAA8H;EAChI;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,4HAA4H;EAC9H;EACA;IACE,6BAA6B;IAC7B,4HAA4H;EAC9H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,8HAA8H;EAChI;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,4HAA4H;EAC9H;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,8HAA8H;EAChI;EACA;IACE,6BAA6B;IAC7B,8HAA8H;EAChI;EACA;IACE,6BAA6B;IAC7B,4HAA4H;EAC9H;EACA;IACE,6BAA6B;IAC7B,4HAA4H;EAC9H;EACA;IACE,6BAA6B;IAC7B,2HAA2H;EAC7H;EACA;IACE,6BAA6B;IAC7B,2HAA2H;EAC7H;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,8HAA8H;EAChI;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,2HAA2H;EAC7H;EACA;IACE,6BAA6B;IAC7B,2HAA2H;EAC7H;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,8HAA8H;EAChI;EACA;IACE,6BAA6B;IAC7B,8HAA8H;EAChI;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,8HAA8H;EAChI;EACA;IACE,6BAA6B;IAC7B,8HAA8H;EAChI;EACA;IACE,6BAA6B;IAC7B,8HAA8H;EAChI;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,8HAA8H;EAChI;EACA;IACE,6BAA6B;IAC7B,8HAA8H;EAChI;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,4HAA4H;EAC9H;EACA;IACE,6BAA6B;IAC7B,4HAA4H;EAC9H;EACA;IACE,6BAA6B;IAC7B,4HAA4H;EAC9H;EACA;IACE,iCAAiC;EACnC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,eAAe;EACjB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,eAAe;EACjB;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,gCAAgC;EAClC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,iCAAiC;EACnC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,qBAAqB;EACvB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,kDAAkD;EACpD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,oDAAoD;EACtD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,oDAAoD;EACtD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,oDAAoD;EACtD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,oDAAoD;EACtD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,kDAAkD;EACpD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,oDAAoD;EACtD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,oDAAoD;EACtD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,oDAAoD;EACtD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,oDAAoD;EACtD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,kDAAkD;EACpD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,oDAAoD;EACtD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,oDAAoD;EACtD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,oDAAoD;EACtD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,oDAAoD;EACtD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,kDAAkD;EACpD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,oDAAoD;EACtD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,oDAAoD;EACtD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,oDAAoD;EACtD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,oDAAoD;EACtD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,kDAAkD;EACpD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,oDAAoD;EACtD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,oDAAoD;EACtD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,oDAAoD;EACtD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,oDAAoD;EACtD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,kDAAkD;EACpD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,oDAAoD;EACtD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,oDAAoD;EACtD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,oDAAoD;EACtD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,oDAAoD;EACtD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;EACrB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,yBAAyB;IACzB,0BAA0B;EAC5B;EACA;IACE,0BAA0B;IAC1B,6BAA6B;EAC/B;EACA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;EACA;IACE,yBAAyB;IACzB,4BAA4B;EAC9B;EACA;IACE,gCAAgC;IAChC,iCAAiC;EACnC;EACA;IACE,iCAAiC;IACjC,oCAAoC;EACtC;EACA;IACE,oCAAoC;IACpC,mCAAmC;EACrC;EACA;IACE,gCAAgC;IAChC,mCAAmC;EACrC;EACA;IACE,+BAA+B;IAC/B,gCAAgC;EAClC;EACA;IACE,gCAAgC;IAChC,mCAAmC;EACrC;EACA;IACE,mCAAmC;IACnC,kCAAkC;EACpC;EACA;IACE,+BAA+B;IAC/B,kCAAkC;EACpC;EACA;IACE,gCAAgC;IAChC,iCAAiC;EACnC;EACA;IACE,iCAAiC;IACjC,oCAAoC;EACtC;EACA;IACE,oCAAoC;IACpC,mCAAmC;EACrC;EACA;IACE,gCAAgC;IAChC,mCAAmC;EACrC;EACA;IACE,8BAA8B;IAC9B,+BAA+B;EACjC;EACA;IACE,+BAA+B;IAC/B,kCAAkC;EACpC;EACA;IACE,kCAAkC;IAClC,iCAAiC;EACnC;EACA;IACE,8BAA8B;IAC9B,iCAAiC;EACnC;EACA;IACE,+BAA+B;IAC/B,gCAAgC;EAClC;EACA;IACE,gCAAgC;IAChC,mCAAmC;EACrC;EACA;IACE,mCAAmC;IACnC,kCAAkC;EACpC;EACA;IACE,+BAA+B;IAC/B,kCAAkC;EACpC;EACA;IACE,4BAA4B;IAC5B,6BAA6B;EAC/B;EACA;IACE,6BAA6B;IAC7B,gCAAgC;EAClC;EACA;IACE,gCAAgC;IAChC,+BAA+B;EACjC;EACA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;EACA;IACE,8BAA8B;IAC9B,+BAA+B;EACjC;EACA;IACE,+BAA+B;IAC/B,kCAAkC;EACpC;EACA;IACE,kCAAkC;IAClC,iCAAiC;EACnC;EACA;IACE,8BAA8B;IAC9B,iCAAiC;EACnC;EACA;IACE,8BAA8B;IAC9B,+BAA+B;EACjC;EACA;IACE,+BAA+B;IAC/B,kCAAkC;EACpC;EACA;IACE,kCAAkC;IAClC,iCAAiC;EACnC;EACA;IACE,8BAA8B;IAC9B,iCAAiC;EACnC;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,gCAAgC;EAClC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,gCAAgC;EAClC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,YAAY;EACd;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,mBAAmB;EACrB;EACA;IACE,cAAc;EAChB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;EACf;EACA;IACE,oBAAoB;EACtB;EACA;IACE,cAAc;EAChB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,aAAa;EACf;EACA;IACE,oBAAoB;EACtB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,aAAa;EACf;EACA;IACE,mBAAmB;EACrB;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,8BAA8B;EAChC;EACA;IACE,eAAe;EACjB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,gBAAgB;EAClB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,8BAA8B;EAChC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,SAAY;EACd;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA;IACE,UAAU;EACZ;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA;IACE,QAAQ;EACV;EACA;IACE,QAAQ;EACV;EACA;IACE,QAAQ;EACV;EACA;IACE,QAAQ;EACV;EACA;IACE,QAAQ;EACV;EACA;IACE,QAAQ;EACV;EACA;IACE,QAAQ;EACV;EACA;IACE,QAAQ;EACV;EACA;IACE,QAAQ;EACV;EACA;IACE,SAAS;EACX;EACA;IACE,SAAS;EACX;EACA;IACE,SAAS;EACX;EACA;IACE,YAAY;EACd;EACA;IACE,WAAW;EACb;EACA;IACE,QAAQ;EACV;EACA;IACE,YAAY;EACd;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;IACX,cAAc;IACd,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,YAAY;EACd;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,6MAA6M;EAC/M;EACA;IACE,8DAA8D;EAChE;EACA;IACE,iFAAiF;EACnF;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,SAAS;EACX;EACA;IACE,eAAe;EACjB;EACA;IACE,cAAc;EAChB;EACA;IACE,eAAe;EACjB;EACA;IACE,YAAY;EACd;EACA;IACE,eAAe;EACjB;EACA;IACE,cAAc;EAChB;EACA;IACE,eAAe;EACjB;EACA;IACE,YAAY;EACd;EACA;IACE,eAAe;EACjB;EACA;IACE,cAAc;EAChB;EACA;IACE,eAAe;EACjB;EACA;IACE,YAAY;EACd;EACA;IACE,eAAe;EACjB;EACA;IACE,cAAc;EAChB;EACA;IACE,eAAe;EACjB;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,YAAY;EACd;EACA;IACE,WAAW;EACb;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,WAAW;EACb;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,WAAW;EACb;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,WAAW;EACb;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,WAAW;EACb;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,WAAW;EACb;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,YAAY;EACd;EACA;IACE,aAAa;EACf;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,eAAe;EACjB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,cAAc;EAChB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,cAAc;EAChB;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,SAAS;EACX;EACA;IACE,eAAe;EACjB;EACA;IACE,cAAc;EAChB;EACA;IACE,eAAe;EACjB;EACA;IACE,YAAY;EACd;EACA;IACE,eAAe;EACjB;EACA;IACE,cAAc;EAChB;EACA;IACE,eAAe;EACjB;EACA;IACE,YAAY;EACd;EACA;IACE,eAAe;EACjB;EACA;IACE,cAAc;EAChB;EACA;IACE,eAAe;EACjB;EACA;IACE,YAAY;EACd;EACA;IACE,eAAe;EACjB;EACA;IACE,cAAc;EAChB;EACA;IACE,eAAe;EACjB;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,YAAY;EACd;EACA;IACE,WAAW;EACb;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,WAAW;EACb;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,WAAW;EACb;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,WAAW;EACb;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,WAAW;EACb;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,WAAW;EACb;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,YAAY;EACd;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,aAAa;EACf;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,aAAa;EACf;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,aAAa;EACf;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA;IACE,YAAY;EACd;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,YAAY;EACd;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,YAAY;EACd;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,YAAY;EACd;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,YAAY;EACd;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,YAAY;EACd;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;IACb,gBAAgB;EAClB;EACA;IACE,cAAc;IACd,eAAe;EACjB;EACA;IACE,mBAAmB;IACnB,sBAAsB;EACxB;EACA;IACE,oBAAoB;IACpB,qBAAqB;EACvB;EACA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;EACA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;EACA;IACE,mBAAmB;IACnB,sBAAsB;EACxB;EACA;IACE,oBAAoB;IACpB,qBAAqB;EACvB;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,mBAAmB;IACnB,sBAAsB;EACxB;EACA;IACE,oBAAoB;IACpB,qBAAqB;EACvB;EACA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;EACA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;EACA;IACE,mBAAmB;IACnB,sBAAsB;EACxB;EACA;IACE,oBAAoB;IACpB,qBAAqB;EACvB;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,mBAAmB;IACnB,sBAAsB;EACxB;EACA;IACE,oBAAoB;IACpB,qBAAqB;EACvB;EACA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;EACA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;EACA;IACE,mBAAmB;IACnB,sBAAsB;EACxB;EACA;IACE,oBAAoB;IACpB,qBAAqB;EACvB;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,mBAAmB;IACnB,sBAAsB;EACxB;EACA;IACE,oBAAoB;IACpB,qBAAqB;EACvB;EACA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;EACA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;EACA;IACE,mBAAmB;IACnB,sBAAsB;EACxB;EACA;IACE,oBAAoB;IACpB,qBAAqB;EACvB;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE,oBAAoB;IACpB,uBAAuB;EACzB;EACA;IACE,qBAAqB;IACrB,sBAAsB;EACxB;EACA;IACE,oBAAoB;IACpB,uBAAuB;EACzB;EACA;IACE,qBAAqB;IACrB,sBAAsB;EACxB;EACA;IACE,oBAAoB;IACpB,uBAAuB;EACzB;EACA;IACE,qBAAqB;IACrB,sBAAsB;EACxB;EACA;IACE,oBAAoB;IACpB,uBAAuB;EACzB;EACA;IACE,qBAAqB;IACrB,sBAAsB;EACxB;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE,sBAAsB;IACtB,yBAAyB;EAC3B;EACA;IACE,uBAAuB;IACvB,wBAAwB;EAC1B;EACA;IACE,sBAAsB;IACtB,yBAAyB;EAC3B;EACA;IACE,uBAAuB;IACvB,wBAAwB;EAC1B;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE,sBAAsB;IACtB,yBAAyB;EAC3B;EACA;IACE,uBAAuB;IACvB,wBAAwB;EAC1B;EACA;IACE,sBAAsB;IACtB,yBAAyB;EAC3B;EACA;IACE,uBAAuB;IACvB,wBAAwB;EAC1B;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE,sBAAsB;IACtB,yBAAyB;EAC3B;EACA;IACE,uBAAuB;IACvB,wBAAwB;EAC1B;EACA;IACE,sBAAsB;IACtB,yBAAyB;EAC3B;EACA;IACE,uBAAuB;IACvB,wBAAwB;EAC1B;EACA;IACE,qBAAqB;IACrB,wBAAwB;EAC1B;EACA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,sBAAsB;IACtB,yBAAyB;EAC3B;EACA;IACE,uBAAuB;IACvB,wBAAwB;EAC1B;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE,sBAAsB;IACtB,yBAAyB;EAC3B;EACA;IACE,uBAAuB;IACvB,wBAAwB;EAC1B;EACA;IACE,sBAAsB;IACtB,yBAAyB;EAC3B;EACA;IACE,uBAAuB;IACvB,wBAAwB;EAC1B;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE,sBAAsB;IACtB,yBAAyB;EAC3B;EACA;IACE,uBAAuB;IACvB,wBAAwB;EAC1B;EACA;IACE,sBAAsB;IACtB,yBAAyB;EAC3B;EACA;IACE,uBAAuB;IACvB,wBAAwB;EAC1B;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE,sBAAsB;IACtB,yBAAyB;EAC3B;EACA;IACE,uBAAuB;IACvB,wBAAwB;EAC1B;EACA;IACE,sBAAsB;IACtB,yBAAyB;EAC3B;EACA;IACE,uBAAuB;IACvB,wBAAwB;EAC1B;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,oBAAoB;IACpB,uBAAuB;EACzB;EACA;IACE,qBAAqB;IACrB,sBAAsB;EACxB;EACA;IACE,mBAAmB;IACnB,sBAAsB;EACxB;EACA;IACE,oBAAoB;IACpB,qBAAqB;EACvB;EACA;IACE,oBAAoB;IACpB,uBAAuB;EACzB;EACA;IACE,qBAAqB;IACrB,sBAAsB;EACxB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,oBAAoB;IACpB,uBAAuB;EACzB;EACA;IACE,qBAAqB;IACrB,sBAAsB;EACxB;EACA;IACE,mBAAmB;IACnB,sBAAsB;EACxB;EACA;IACE,oBAAoB;IACpB,qBAAqB;EACvB;EACA;IACE,oBAAoB;IACpB,uBAAuB;EACzB;EACA;IACE,qBAAqB;IACrB,sBAAsB;EACxB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,oBAAoB;IACpB,uBAAuB;EACzB;EACA;IACE,qBAAqB;IACrB,sBAAsB;EACxB;EACA;IACE,mBAAmB;IACnB,sBAAsB;EACxB;EACA;IACE,oBAAoB;IACpB,qBAAqB;EACvB;EACA;IACE,oBAAoB;IACpB,uBAAuB;EACzB;EACA;IACE,qBAAqB;IACrB,sBAAsB;EACxB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,oBAAoB;IACpB,uBAAuB;EACzB;EACA;IACE,qBAAqB;IACrB,sBAAsB;EACxB;EACA;IACE,mBAAmB;IACnB,sBAAsB;EACxB;EACA;IACE,oBAAoB;IACpB,qBAAqB;EACvB;EACA;IACE,oBAAoB;IACpB,uBAAuB;EACzB;EACA;IACE,qBAAqB;IACrB,sBAAsB;EACxB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;EACA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;EACA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;EACA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;EACA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;EACA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;EACA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;EACA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;EACA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;EACA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;EACA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,qBAAqB;IACrB,wBAAwB;EAC1B;EACA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,qBAAqB;IACrB,wBAAwB;EAC1B;EACA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,qBAAqB;IACrB,wBAAwB;EAC1B;EACA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,qBAAqB;IACrB,wBAAwB;EAC1B;EACA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,sBAAsB;IACtB,yBAAyB;EAC3B;EACA;IACE,uBAAuB;IACvB,wBAAwB;EAC1B;EACA;IACE,sBAAsB;IACtB,yBAAyB;EAC3B;EACA;IACE,uBAAuB;IACvB,wBAAwB;EAC1B;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,sBAAsB;IACtB,yBAAyB;EAC3B;EACA;IACE,uBAAuB;IACvB,wBAAwB;EAC1B;EACA;IACE,sBAAsB;IACtB,yBAAyB;EAC3B;EACA;IACE,uBAAuB;IACvB,wBAAwB;EAC1B;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,sBAAsB;IACtB,yBAAyB;EAC3B;EACA;IACE,uBAAuB;IACvB,wBAAwB;EAC1B;EACA;IACE,sBAAsB;IACtB,yBAAyB;EAC3B;EACA;IACE,uBAAuB;IACvB,wBAAwB;EAC1B;EACA;IACE,qBAAqB;IACrB,wBAAwB;EAC1B;EACA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,sBAAsB;IACtB,yBAAyB;EAC3B;EACA;IACE,uBAAuB;IACvB,wBAAwB;EAC1B;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,sBAAsB;IACtB,yBAAyB;EAC3B;EACA;IACE,uBAAuB;IACvB,wBAAwB;EAC1B;EACA;IACE,sBAAsB;IACtB,yBAAyB;EAC3B;EACA;IACE,uBAAuB;IACvB,wBAAwB;EAC1B;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,sBAAsB;IACtB,yBAAyB;EAC3B;EACA;IACE,uBAAuB;IACvB,wBAAwB;EAC1B;EACA;IACE,sBAAsB;IACtB,yBAAyB;EAC3B;EACA;IACE,uBAAuB;IACvB,wBAAwB;EAC1B;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,sBAAsB;IACtB,yBAAyB;EAC3B;EACA;IACE,uBAAuB;IACvB,wBAAwB;EAC1B;EACA;IACE,sBAAsB;IACtB,yBAAyB;EAC3B;EACA;IACE,uBAAuB;IACvB,wBAAwB;EAC1B;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,aAAa;EACf;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,cAAc;EAChB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,aAAa;EACf;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,eAAe;EACjB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,eAAe;EACjB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,eAAe;EACjB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,eAAe;EACjB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,eAAe;EACjB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IAEE,sBAAsB;EACxB;EACA;IAEE,sBAAsB;EACxB;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,aAAa;EACf;EACA;IACE,gBAAgB;EAClB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,YAAY;EACd;EACA;IACE,eAAe;EACjB;EACA;IAEE,sBAAsB;EACxB;EACA;IAEE,sBAAsB;EACxB;EACA;IAEE,mBAAmB;EACrB;EACA;IAEE,iBAAiB;EACnB;EACA;IAEE,gBAAgB;EAClB;EACA;IAEE,gBAAgB;EAClB;EACA;IAEE,sBAAsB;EACxB;EACA;IAEE,uBAAuB;EACzB;EACA;IAEE,uBAAuB;EACzB;EACA;IAEE,qBAAqB;EACvB;EACA;IAEE,4BAA4B;EAC9B;EACA;IAEE,yBAAyB;EAC3B;EACA;IAEE,sBAAsB;EACxB;EACA;IAEE,6BAA6B;EAC/B;EACA;IAEE,0BAA0B;EAC5B;EACA;IAEE,oBAAoB;EACtB;EACA;IACE,UAAU;EACZ;EACA;IACE,aAAa;EACf;EACA;IACE,YAAY;EACd;EACA;IACE,aAAa;EACf;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,aAAa;EACf;EACA;IACE,YAAY;EACd;EACA;IACE,aAAa;EACf;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,aAAa;EACf;EACA;IACE,YAAY;EACd;EACA;IACE,aAAa;EACf;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,aAAa;EACf;EACA;IACE,YAAY;EACd;EACA;IACE,aAAa;EACf;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,aAAa;EACf;EACA;IACE,YAAY;EACd;EACA;IACE,aAAa;EACf;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,aAAa;EACf;EACA;IACE,YAAY;EACd;EACA;IACE,aAAa;EACf;EACA;IACE,UAAU;EACZ;EACA;IACE,8BAA8B;IAC9B,mBAAmB;EACrB;EACA;IACE,yBAAyB;IACzB,mBAAmB;EACrB;EACA;IACE,yBAAyB;IACzB,mBAAmB;EACrB;EACA;IACE,8BAA8B;IAC9B,mBAAmB;EACrB;EACA;IACE,yBAAyB;IACzB,mBAAmB;EACrB;EACA;IACE,yBAAyB;IACzB,mBAAmB;EACrB;EACA;IACE,cAAc;EAChB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iCAAiC;EACnC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,8BAA8B;EAChC;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,8BAA8B;EAChC;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,UAAU;EACZ;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,aAAa;EACf;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,aAAa;EACf;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,aAAa;EACf;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA;IACE,YAAY;EACd;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,YAAY;EACd;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,YAAY;EACd;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,YAAY;EACd;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,YAAY;EACd;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,YAAY;EACd;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,aAAa;EACf;EACA;IACE,cAAc;IACd,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,oBAAoB;IACpB,uBAAuB;EACzB;EACA;IACE,qBAAqB;IACrB,sBAAsB;EACxB;EACA;IACE,mBAAmB;IACnB,sBAAsB;EACxB;EACA;IACE,oBAAoB;IACpB,qBAAqB;EACvB;EACA;IACE,oBAAoB;IACpB,uBAAuB;EACzB;EACA;IACE,qBAAqB;IACrB,sBAAsB;EACxB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,oBAAoB;IACpB,uBAAuB;EACzB;EACA;IACE,qBAAqB;IACrB,sBAAsB;EACxB;EACA;IACE,mBAAmB;IACnB,sBAAsB;EACxB;EACA;IACE,oBAAoB;IACpB,qBAAqB;EACvB;EACA;IACE,oBAAoB;IACpB,uBAAuB;EACzB;EACA;IACE,qBAAqB;IACrB,sBAAsB;EACxB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,oBAAoB;IACpB,uBAAuB;EACzB;EACA;IACE,qBAAqB;IACrB,sBAAsB;EACxB;EACA;IACE,mBAAmB;IACnB,sBAAsB;EACxB;EACA;IACE,oBAAoB;IACpB,qBAAqB;EACvB;EACA;IACE,oBAAoB;IACpB,uBAAuB;EACzB;EACA;IACE,qBAAqB;IACrB,sBAAsB;EACxB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,oBAAoB;IACpB,uBAAuB;EACzB;EACA;IACE,qBAAqB;IACrB,sBAAsB;EACxB;EACA;IACE,mBAAmB;IACnB,sBAAsB;EACxB;EACA;IACE,oBAAoB;IACpB,qBAAqB;EACvB;EACA;IACE,oBAAoB;IACpB,uBAAuB;EACzB;EACA;IACE,qBAAqB;IACrB,sBAAsB;EACxB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;EACA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;EACA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;EACA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;EACA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;EACA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;EACA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;EACA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;EACA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;EACA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;EACA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,qBAAqB;IACrB,wBAAwB;EAC1B;EACA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,qBAAqB;IACrB,wBAAwB;EAC1B;EACA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,qBAAqB;IACrB,wBAAwB;EAC1B;EACA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,qBAAqB;IACrB,wBAAwB;EAC1B;EACA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,wBAAwB;IACxB,yBAAyB;EAC3B;EACA;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,wBAAwB;IACxB,yBAAyB;EAC3B;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,wBAAwB;IACxB,yBAAyB;EAC3B;EACA;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,wBAAwB;IACxB,yBAAyB;EAC3B;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,wBAAwB;IACxB,yBAAyB;EAC3B;EACA;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,wBAAwB;IACxB,yBAAyB;EAC3B;EACA;IACE,sBAAsB;IACtB,yBAAyB;EAC3B;EACA;IACE,uBAAuB;IACvB,wBAAwB;EAC1B;EACA;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,wBAAwB;IACxB,yBAAyB;EAC3B;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,wBAAwB;IACxB,yBAAyB;EAC3B;EACA;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,wBAAwB;IACxB,yBAAyB;EAC3B;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,wBAAwB;IACxB,yBAAyB;EAC3B;EACA;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,wBAAwB;IACxB,yBAAyB;EAC3B;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,wBAAwB;IACxB,yBAAyB;EAC3B;EACA;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,wBAAwB;IACxB,yBAAyB;EAC3B;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,cAAc;EAChB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EAIA;IACE,mBAAmB;EACrB;EAIA;IACE,kBAAkB;EACpB;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,gDAAgD;EAClD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,mDAAmD;EACrD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,mDAAmD;EACrD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,mDAAmD;EACrD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,mDAAmD;EACrD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,qDAAqD;EACvD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,mDAAmD;EACrD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,mDAAmD;EACrD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,qDAAqD;EACvD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,mDAAmD;EACrD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,qDAAqD;EACvD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,qDAAqD;EACvD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,mDAAmD;EACrD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,mDAAmD;EACrD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,kDAAkD;EACpD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,kDAAkD;EACpD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,qDAAqD;EACvD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,kDAAkD;EACpD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,kDAAkD;EACpD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,qDAAqD;EACvD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,qDAAqD;EACvD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,qDAAqD;EACvD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,qDAAqD;EACvD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,qDAAqD;EACvD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,qDAAqD;EACvD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,qDAAqD;EACvD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,mDAAmD;EACrD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,mDAAmD;EACrD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,mDAAmD;EACrD;EAIA;IACE,mBAAmB;EACrB;EAIA;IACE,kBAAkB;EACpB;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,gDAAgD;EAClD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,mDAAmD;EACrD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,mDAAmD;EACrD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,mDAAmD;EACrD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,mDAAmD;EACrD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,qDAAqD;EACvD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,mDAAmD;EACrD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,mDAAmD;EACrD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,qDAAqD;EACvD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,mDAAmD;EACrD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,qDAAqD;EACvD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,qDAAqD;EACvD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,mDAAmD;EACrD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,mDAAmD;EACrD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,kDAAkD;EACpD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,kDAAkD;EACpD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,qDAAqD;EACvD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,kDAAkD;EACpD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,kDAAkD;EACpD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,qDAAqD;EACvD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,qDAAqD;EACvD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,qDAAqD;EACvD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,qDAAqD;EACvD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,qDAAqD;EACvD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,qDAAqD;EACvD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,qDAAqD;EACvD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,mDAAmD;EACrD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,mDAAmD;EACrD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,mDAAmD;EACrD;EAIA;IACE,wBAAwB;EAC1B;EAIA;IACE,2BAA2B;EAC7B;EAIA;IACE,0BAA0B;EAC5B;EAIA;IACE,2BAA2B;EAC7B;EAIA;IACE,wBAAwB;EAC1B;EAIA;IACE,wBAAwB;EAC1B;EAIA;IACE,2BAA2B;EAC7B;EAIA;IACE,0BAA0B;EAC5B;EAIA;IACE,2BAA2B;EAC7B;EAIA;IACE,wBAAwB;EAC1B;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,MAAM;IACN,QAAQ;IACR,SAAS;IACT,OAAO;EACT;EACA;IACE,YAAY;IACZ,cAAc;IACd,eAAe;IACf,aAAa;EACf;EACA;IACE,WAAW;IACX,aAAa;IACb,cAAc;IACd,YAAY;EACd;EACA;IACE,YAAY;IACZ,cAAc;IACd,eAAe;IACf,aAAa;EACf;EACA;IACE,SAAS;IACT,WAAW;IACX,YAAY;IACZ,UAAU;EACZ;EACA;IACE,YAAY;IACZ,cAAc;IACd,eAAe;IACf,aAAa;EACf;EACA;IACE,WAAW;IACX,aAAa;IACb,cAAc;IACd,YAAY;EACd;EACA;IACE,YAAY;IACZ,cAAc;IACd,eAAe;IACf,aAAa;EACf;EACA;IACE,SAAS;IACT,WAAW;IACX,YAAY;IACZ,UAAU;EACZ;EACA;IACE,YAAY;IACZ,cAAc;IACd,eAAe;IACf,aAAa;EACf;EACA;IACE,WAAW;IACX,aAAa;IACb,cAAc;IACd,YAAY;EACd;EACA;IACE,YAAY;IACZ,cAAc;IACd,eAAe;IACf,aAAa;EACf;EACA;IACE,SAAS;IACT,WAAW;IACX,YAAY;IACZ,UAAU;EACZ;EACA;IACE,YAAY;IACZ,cAAc;IACd,eAAe;IACf,aAAa;EACf;EACA;IACE,WAAW;IACX,aAAa;IACb,cAAc;IACd,YAAY;EACd;EACA;IACE,YAAY;IACZ,cAAc;IACd,eAAe;IACf,aAAa;EACf;EACA;IACE,SAAS;IACT,WAAW;IACX,YAAY;IACZ,UAAU;EACZ;EACA;IACE,SAAS;IACT,WAAW;IACX,YAAY;IACZ,UAAU;EACZ;EACA;IACE,SAAS;IACT,WAAW;IACX,YAAY;IACZ,UAAU;EACZ;EACA;IACE,SAAS;IACT,WAAW;IACX,YAAY;IACZ,UAAU;EACZ;EACA;IACE,SAAS;IACT,WAAW;IACX,YAAY;IACZ,UAAU;EACZ;EACA;IACE,SAAS;IACT,WAAW;IACX,YAAY;IACZ,UAAU;EACZ;EACA;IACE,UAAU;IACV,YAAY;IACZ,aAAa;IACb,WAAW;EACb;EACA;IACE,UAAU;IACV,YAAY;IACZ,aAAa;IACb,WAAW;EACb;EACA;IACE,UAAU;IACV,YAAY;IACZ,aAAa;IACb,WAAW;EACb;EACA;IACE,UAAU;IACV,YAAY;IACZ,aAAa;IACb,WAAW;EACb;EACA;IACE,UAAU;IACV,YAAY;IACZ,aAAa;IACb,WAAW;EACb;EACA;IACE,UAAU;IACV,YAAY;IACZ,aAAa;IACb,WAAW;EACb;EACA;IACE,UAAU;IACV,YAAY;IACZ,aAAa;IACb,WAAW;EACb;EACA;IACE,UAAU;IACV,YAAY;IACZ,aAAa;IACb,WAAW;EACb;EACA;IACE,UAAU;IACV,YAAY;IACZ,aAAa;IACb,WAAW;EACb;EACA;IACE,UAAU;IACV,YAAY;IACZ,aAAa;IACb,WAAW;EACb;EACA;IACE,SAAS;IACT,WAAW;IACX,YAAY;IACZ,UAAU;EACZ;EACA;IACE,QAAQ;IACR,UAAU;IACV,WAAW;IACX,SAAS;EACX;EACA;IACE,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,cAAc;EAChB;EACA;IACE,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,cAAc;EAChB;EACA;IACE,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,cAAc;EAChB;EACA;IACE,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,cAAc;EAChB;EACA;IACE,QAAQ;IACR,UAAU;IACV,WAAW;IACX,SAAS;EACX;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;EAClB;EACA;IACE,QAAQ;IACR,UAAU;IACV,WAAW;IACX,SAAS;EACX;EACA;IACE,QAAQ;IACR,UAAU;IACV,WAAW;IACX,SAAS;EACX;EACA;IACE,QAAQ;IACR,UAAU;IACV,WAAW;IACX,SAAS;EACX;EACA;IACE,QAAQ;IACR,UAAU;IACV,WAAW;IACX,SAAS;EACX;EACA;IACE,QAAQ;IACR,UAAU;IACV,WAAW;IACX,SAAS;EACX;EACA;IACE,QAAQ;IACR,UAAU;IACV,WAAW;IACX,SAAS;EACX;EACA;IACE,QAAQ;IACR,UAAU;IACV,WAAW;IACX,SAAS;EACX;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;EAClB;EACA;IACE,QAAQ;IACR,UAAU;IACV,WAAW;IACX,SAAS;EACX;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;EAClB;EACA;IACE,cAAc;IACd,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;EACjB;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;EAClB;EACA;IACE,QAAQ;IACR,UAAU;IACV,WAAW;IACX,SAAS;EACX;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;EAClB;EACA;IACE,QAAQ;IACR,UAAU;IACV,WAAW;IACX,SAAS;EACX;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;EAClB;EACA;IACE,QAAQ;IACR,UAAU;IACV,WAAW;IACX,SAAS;EACX;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;EAClB;EACA;IACE,SAAS;IACT,WAAW;IACX,YAAY;IACZ,UAAU;EACZ;EACA;IACE,MAAM;IACN,SAAS;EACX;EACA;IACE,QAAQ;IACR,OAAO;EACT;EACA;IACE,YAAY;IACZ,eAAe;EACjB;EACA;IACE,cAAc;IACd,aAAa;EACf;EACA;IACE,WAAW;IACX,cAAc;EAChB;EACA;IACE,aAAa;IACb,YAAY;EACd;EACA;IACE,YAAY;IACZ,eAAe;EACjB;EACA;IACE,cAAc;IACd,aAAa;EACf;EACA;IACE,SAAS;IACT,YAAY;EACd;EACA;IACE,WAAW;IACX,UAAU;EACZ;EACA;IACE,YAAY;IACZ,eAAe;EACjB;EACA;IACE,cAAc;IACd,aAAa;EACf;EACA;IACE,WAAW;IACX,cAAc;EAChB;EACA;IACE,aAAa;IACb,YAAY;EACd;EACA;IACE,YAAY;IACZ,eAAe;EACjB;EACA;IACE,cAAc;IACd,aAAa;EACf;EACA;IACE,SAAS;IACT,YAAY;EACd;EACA;IACE,WAAW;IACX,UAAU;EACZ;EACA;IACE,YAAY;IACZ,eAAe;EACjB;EACA;IACE,cAAc;IACd,aAAa;EACf;EACA;IACE,WAAW;IACX,cAAc;EAChB;EACA;IACE,aAAa;IACb,YAAY;EACd;EACA;IACE,YAAY;IACZ,eAAe;EACjB;EACA;IACE,cAAc;IACd,aAAa;EACf;EACA;IACE,SAAS;IACT,YAAY;EACd;EACA;IACE,WAAW;IACX,UAAU;EACZ;EACA;IACE,YAAY;IACZ,eAAe;EACjB;EACA;IACE,cAAc;IACd,aAAa;EACf;EACA;IACE,WAAW;IACX,cAAc;EAChB;EACA;IACE,aAAa;IACb,YAAY;EACd;EACA;IACE,YAAY;IACZ,eAAe;EACjB;EACA;IACE,cAAc;IACd,aAAa;EACf;EACA;IACE,SAAS;IACT,YAAY;EACd;EACA;IACE,WAAW;IACX,UAAU;EACZ;EACA;IACE,SAAS;IACT,YAAY;EACd;EACA;IACE,WAAW;IACX,UAAU;EACZ;EACA;IACE,SAAS;IACT,YAAY;EACd;EACA;IACE,WAAW;IACX,UAAU;EACZ;EACA;IACE,SAAS;IACT,YAAY;EACd;EACA;IACE,WAAW;IACX,UAAU;EACZ;EACA;IACE,SAAS;IACT,YAAY;EACd;EACA;IACE,WAAW;IACX,UAAU;EACZ;EACA;IACE,SAAS;IACT,YAAY;EACd;EACA;IACE,WAAW;IACX,UAAU;EACZ;EACA;IACE,UAAU;IACV,aAAa;EACf;EACA;IACE,YAAY;IACZ,WAAW;EACb;EACA;IACE,UAAU;IACV,aAAa;EACf;EACA;IACE,YAAY;IACZ,WAAW;EACb;EACA;IACE,UAAU;IACV,aAAa;EACf;EACA;IACE,YAAY;IACZ,WAAW;EACb;EACA;IACE,UAAU;IACV,aAAa;EACf;EACA;IACE,YAAY;IACZ,WAAW;EACb;EACA;IACE,UAAU;IACV,aAAa;EACf;EACA;IACE,YAAY;IACZ,WAAW;EACb;EACA;IACE,UAAU;IACV,aAAa;EACf;EACA;IACE,YAAY;IACZ,WAAW;EACb;EACA;IACE,UAAU;IACV,aAAa;EACf;EACA;IACE,YAAY;IACZ,WAAW;EACb;EACA;IACE,UAAU;IACV,aAAa;EACf;EACA;IACE,YAAY;IACZ,WAAW;EACb;EACA;IACE,UAAU;IACV,aAAa;EACf;EACA;IACE,YAAY;IACZ,WAAW;EACb;EACA;IACE,UAAU;IACV,aAAa;EACf;EACA;IACE,YAAY;IACZ,WAAW;EACb;EACA;IACE,SAAS;IACT,YAAY;EACd;EACA;IACE,WAAW;IACX,UAAU;EACZ;EACA;IACE,QAAQ;IACR,WAAW;EACb;EACA;IACE,UAAU;IACV,SAAS;EACX;EACA;IACE,aAAa;IACb,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,cAAc;EAChB;EACA;IACE,aAAa;IACb,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,cAAc;EAChB;EACA;IACE,aAAa;IACb,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,cAAc;EAChB;EACA;IACE,aAAa;IACb,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,cAAc;EAChB;EACA;IACE,QAAQ;IACR,WAAW;EACb;EACA;IACE,UAAU;IACV,SAAS;EACX;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;EACA;IACE,QAAQ;IACR,WAAW;EACb;EACA;IACE,UAAU;IACV,SAAS;EACX;EACA;IACE,QAAQ;IACR,WAAW;EACb;EACA;IACE,UAAU;IACV,SAAS;EACX;EACA;IACE,QAAQ;IACR,WAAW;EACb;EACA;IACE,UAAU;IACV,SAAS;EACX;EACA;IACE,QAAQ;IACR,WAAW;EACb;EACA;IACE,UAAU;IACV,SAAS;EACX;EACA;IACE,QAAQ;IACR,WAAW;EACb;EACA;IACE,UAAU;IACV,SAAS;EACX;EACA;IACE,QAAQ;IACR,WAAW;EACb;EACA;IACE,UAAU;IACV,SAAS;EACX;EACA;IACE,QAAQ;IACR,WAAW;EACb;EACA;IACE,UAAU;IACV,SAAS;EACX;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;EACA;IACE,QAAQ;IACR,WAAW;EACb;EACA;IACE,UAAU;IACV,SAAS;EACX;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;EACA;IACE,cAAc;IACd,iBAAiB;EACnB;EACA;IACE,gBAAgB;IAChB,eAAe;EACjB;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;EACA;IACE,QAAQ;IACR,WAAW;EACb;EACA;IACE,UAAU;IACV,SAAS;EACX;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;EACA;IACE,QAAQ;IACR,WAAW;EACb;EACA;IACE,UAAU;IACV,SAAS;EACX;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;EACA;IACE,QAAQ;IACR,WAAW;EACb;EACA;IACE,UAAU;IACV,SAAS;EACX;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;EACA;IACE,SAAS;IACT,YAAY;EACd;EACA;IACE,WAAW;IACX,UAAU;EACZ;EACA;IACE,MAAM;EACR;EACA;IACE,QAAQ;EACV;EACA;IACE,SAAS;EACX;EACA;IACE,OAAO;EACT;EACA;IACE,YAAY;EACd;EACA;IACE,cAAc;EAChB;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;EACf;EACA;IACE,WAAW;EACb;EACA;IACE,aAAa;EACf;EACA;IACE,cAAc;EAChB;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,cAAc;EAChB;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;EACf;EACA;IACE,SAAS;EACX;EACA;IACE,WAAW;EACb;EACA;IACE,YAAY;EACd;EACA;IACE,UAAU;EACZ;EACA;IACE,YAAY;EACd;EACA;IACE,cAAc;EAChB;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;EACf;EACA;IACE,WAAW;EACb;EACA;IACE,aAAa;EACf;EACA;IACE,cAAc;EAChB;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,cAAc;EAChB;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;EACf;EACA;IACE,SAAS;EACX;EACA;IACE,WAAW;EACb;EACA;IACE,YAAY;EACd;EACA;IACE,UAAU;EACZ;EACA;IACE,YAAY;EACd;EACA;IACE,cAAc;EAChB;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;EACf;EACA;IACE,WAAW;EACb;EACA;IACE,aAAa;EACf;EACA;IACE,cAAc;EAChB;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,cAAc;EAChB;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;EACf;EACA;IACE,SAAS;EACX;EACA;IACE,WAAW;EACb;EACA;IACE,YAAY;EACd;EACA;IACE,UAAU;EACZ;EACA;IACE,YAAY;EACd;EACA;IACE,cAAc;EAChB;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;EACf;EACA;IACE,WAAW;EACb;EACA;IACE,aAAa;EACf;EACA;IACE,cAAc;EAChB;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,cAAc;EAChB;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;EACf;EACA;IACE,SAAS;EACX;EACA;IACE,WAAW;EACb;EACA;IACE,YAAY;EACd;EACA;IACE,UAAU;EACZ;EACA;IACE,SAAS;EACX;EACA;IACE,WAAW;EACb;EACA;IACE,YAAY;EACd;EACA;IACE,UAAU;EACZ;EACA;IACE,SAAS;EACX;EACA;IACE,WAAW;EACb;EACA;IACE,YAAY;EACd;EACA;IACE,UAAU;EACZ;EACA;IACE,SAAS;EACX;EACA;IACE,WAAW;EACb;EACA;IACE,YAAY;EACd;EACA;IACE,UAAU;EACZ;EACA;IACE,SAAS;EACX;EACA;IACE,WAAW;EACb;EACA;IACE,YAAY;EACd;EACA;IACE,UAAU;EACZ;EACA;IACE,SAAS;EACX;EACA;IACE,WAAW;EACb;EACA;IACE,YAAY;EACd;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,YAAY;EACd;EACA;IACE,aAAa;EACf;EACA;IACE,WAAW;EACb;EACA;IACE,UAAU;EACZ;EACA;IACE,YAAY;EACd;EACA;IACE,aAAa;EACf;EACA;IACE,WAAW;EACb;EACA;IACE,UAAU;EACZ;EACA;IACE,YAAY;EACd;EACA;IACE,aAAa;EACf;EACA;IACE,WAAW;EACb;EACA;IACE,UAAU;EACZ;EACA;IACE,YAAY;EACd;EACA;IACE,aAAa;EACf;EACA;IACE,WAAW;EACb;EACA;IACE,UAAU;EACZ;EACA;IACE,YAAY;EACd;EACA;IACE,aAAa;EACf;EACA;IACE,WAAW;EACb;EACA;IACE,UAAU;EACZ;EACA;IACE,YAAY;EACd;EACA;IACE,aAAa;EACf;EACA;IACE,WAAW;EACb;EACA;IACE,UAAU;EACZ;EACA;IACE,YAAY;EACd;EACA;IACE,aAAa;EACf;EACA;IACE,WAAW;EACb;EACA;IACE,UAAU;EACZ;EACA;IACE,YAAY;EACd;EACA;IACE,aAAa;EACf;EACA;IACE,WAAW;EACb;EACA;IACE,UAAU;EACZ;EACA;IACE,YAAY;EACd;EACA;IACE,aAAa;EACf;EACA;IACE,WAAW;EACb;EACA;IACE,UAAU;EACZ;EACA;IACE,YAAY;EACd;EACA;IACE,aAAa;EACf;EACA;IACE,WAAW;EACb;EACA;IACE,SAAS;EACX;EACA;IACE,WAAW;EACb;EACA;IACE,YAAY;EACd;EACA;IACE,UAAU;EACZ;EACA;IACE,QAAQ;EACV;EACA;IACE,UAAU;EACZ;EACA;IACE,WAAW;EACb;EACA;IACE,SAAS;EACX;EACA;IACE,aAAa;EACf;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,cAAc;EAChB;EACA;IACE,aAAa;EACf;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,cAAc;EAChB;EACA;IACE,aAAa;EACf;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,cAAc;EAChB;EACA;IACE,aAAa;EACf;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,cAAc;EAChB;EACA;IACE,QAAQ;EACV;EACA;IACE,UAAU;EACZ;EACA;IACE,WAAW;EACb;EACA;IACE,SAAS;EACX;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,QAAQ;EACV;EACA;IACE,UAAU;EACZ;EACA;IACE,WAAW;EACb;EACA;IACE,SAAS;EACX;EACA;IACE,QAAQ;EACV;EACA;IACE,UAAU;EACZ;EACA;IACE,WAAW;EACb;EACA;IACE,SAAS;EACX;EACA;IACE,QAAQ;EACV;EACA;IACE,UAAU;EACZ;EACA;IACE,WAAW;EACb;EACA;IACE,SAAS;EACX;EACA;IACE,QAAQ;EACV;EACA;IACE,UAAU;EACZ;EACA;IACE,WAAW;EACb;EACA;IACE,SAAS;EACX;EACA;IACE,QAAQ;EACV;EACA;IACE,UAAU;EACZ;EACA;IACE,WAAW;EACb;EACA;IACE,SAAS;EACX;EACA;IACE,QAAQ;EACV;EACA;IACE,UAAU;EACZ;EACA;IACE,WAAW;EACb;EACA;IACE,SAAS;EACX;EACA;IACE,QAAQ;EACV;EACA;IACE,UAAU;EACZ;EACA;IACE,WAAW;EACb;EACA;IACE,SAAS;EACX;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,QAAQ;EACV;EACA;IACE,UAAU;EACZ;EACA;IACE,WAAW;EACb;EACA;IACE,SAAS;EACX;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,cAAc;EAChB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,QAAQ;EACV;EACA;IACE,UAAU;EACZ;EACA;IACE,WAAW;EACb;EACA;IACE,SAAS;EACX;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,QAAQ;EACV;EACA;IACE,UAAU;EACZ;EACA;IACE,WAAW;EACb;EACA;IACE,SAAS;EACX;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,QAAQ;EACV;EACA;IACE,UAAU;EACZ;EACA;IACE,WAAW;EACb;EACA;IACE,SAAS;EACX;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,SAAS;EACX;EACA;IACE,WAAW;EACb;EACA;IACE,YAAY;EACd;EACA;IACE,UAAU;EACZ;EACA;IACE,YAAY;EACd;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,YAAY;EACd;EACA;IACE,yCAAyC;EAC3C;EACA;IACE,2CAA2C;EAC7C;EACA;IACE,2EAA2E;EAC7E;EACA;IACE,iFAAiF;EACnF;EACA;IACE,mFAAmF;EACrF;EACA;IACE,qFAAqF;EACvF;EACA;IACE,iDAAiD;EACnD;EACA;IACE,iDAAiD;EACnD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kCAAkC;EACpC;EACA;IACE,+CAA+C;EACjD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,8CAA8C;EAChD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,yCAAyC;EAC3C;EACA;IACE,2CAA2C;EAC7C;EACA;IACE,2EAA2E;EAC7E;EACA;IACE,iFAAiF;EACnF;EACA;IACE,mFAAmF;EACrF;EACA;IACE,qFAAqF;EACvF;EACA;IACE,iDAAiD;EACnD;EACA;IACE,iDAAiD;EACnD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kCAAkC;EACpC;EACA;IACE,+CAA+C;EACjD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,8CAA8C;EAChD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,yCAAyC;EAC3C;EACA;IACE,2CAA2C;EAC7C;EACA;IACE,2EAA2E;EAC7E;EACA;IACE,iFAAiF;EACnF;EACA;IACE,mFAAmF;EACrF;EACA;IACE,qFAAqF;EACvF;EACA;IACE,iDAAiD;EACnD;EACA;IACE,iDAAiD;EACnD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kCAAkC;EACpC;EACA;IACE,+CAA+C;EACjD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,8CAA8C;EAChD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,yCAAyC;EAC3C;EACA;IACE,2CAA2C;EAC7C;EACA;IACE,2EAA2E;EAC7E;EACA;IACE,iFAAiF;EACnF;EACA;IACE,mFAAmF;EACrF;EACA;IACE,qFAAqF;EACvF;EACA;IACE,iDAAiD;EACnD;EACA;IACE,iDAAiD;EACnD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kCAAkC;EACpC;EACA;IACE,+CAA+C;EACjD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,8CAA8C;EAChD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,yCAAyC;EAC3C;EACA;IACE,2CAA2C;EAC7C;EACA;IACE,2EAA2E;EAC7E;EACA;IACE,iFAAiF;EACnF;EACA;IACE,mFAAmF;EACrF;EACA;IACE,qFAAqF;EACvF;EACA;IACE,iDAAiD;EACnD;EACA;IACE,iDAAiD;EACnD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kCAAkC;EACpC;EACA;IACE,+CAA+C;EACjD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,8CAA8C;EAChD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,kBAAkB;EACpB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,yCAAyC;EAC3C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,2CAA2C;EAC7C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,2CAA2C;EAC7C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,2CAA2C;EAC7C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,2CAA2C;EAC7C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,yCAAyC;EAC3C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,2CAA2C;EAC7C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,2CAA2C;EAC7C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,2CAA2C;EAC7C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,2CAA2C;EAC7C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,yCAAyC;EAC3C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,2CAA2C;EAC7C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,2CAA2C;EAC7C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,2CAA2C;EAC7C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,2CAA2C;EAC7C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,yCAAyC;EAC3C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,2CAA2C;EAC7C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,2CAA2C;EAC7C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,2CAA2C;EAC7C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,2CAA2C;EAC7C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,yCAAyC;EAC3C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,2CAA2C;EAC7C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,2CAA2C;EAC7C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,2CAA2C;EAC7C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,2CAA2C;EAC7C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,yCAAyC;EAC3C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,2CAA2C;EAC7C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,2CAA2C;EAC7C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,2CAA2C;EAC7C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,2CAA2C;EAC7C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,yCAAyC;EAC3C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,2CAA2C;EAC7C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,2CAA2C;EAC7C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,2CAA2C;EAC7C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,2CAA2C;EAC7C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;EACnB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,oBAAoB;EACtB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mCAAmC;IACnC,kCAAkC;EACpC;EACA;IACE,4BAA4B;IAC5B,6BAA6B;EAC/B;EACA;IACE;;;OAGG;IACH;;;OAGG;IACH;;;OAGG;IACH;;;OAGG;IACH;;;OAGG;IACH,8MAA8M;EAChN;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,uCAAuC;EACzC;EACA;IACE,iDAAiD;EACnD;EACA;IACE,0CAA0C;EAC5C;EACA;IACE,4CAA4C;EAC9C;EACA;IACE,iDAAiD;EACnD;EACA;IACE,4CAA4C;EAC9C;EACA;IACE,mDAAmD;EACrD;EACA;IACE,kDAAkD;EACpD;EACA;IACE,uBAAuB;EACzB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,iBAAiB;EACnB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,yBAAyB;IAEzB,iBAAiB;EACnB;EACA;IACE,yBAAyB;IAEzB,iBAAiB;EACnB;EACA;IACE,wBAAwB;IAExB,gBAAgB;EAClB;EACA;IACE,yBAAyB;IAEzB,iBAAiB;EACnB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,mBAAmB;EACrB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,iBAAiB;IACjB,qBAAqB;IACrB,kBAAkB;EACpB;EACA;IACE,qBAAqB;IACrB,yBAAyB;EAC3B;EACA;IACE,qBAAqB;EACvB;EACA;IACE,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;EACrB;EACA;IACE,QAAQ;EACV;EACA;IACE,cAAc;EAChB;EACA;IACE,aAAa;EACf;EACA;IACE,cAAc;EAChB;EACA;IACE,WAAW;EACb;EACA;IACE,cAAc;EAChB;EACA;IACE,aAAa;EACf;EACA;IACE,cAAc;EAChB;EACA;IACE,WAAW;EACb;EACA;IACE,cAAc;EAChB;EACA;IACE,aAAa;EACf;EACA;IACE,cAAc;EAChB;EACA;IACE,WAAW;EACb;EACA;IACE,cAAc;EAChB;EACA;IACE,aAAa;EACf;EACA;IACE,cAAc;EAChB;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,WAAW;EACb;EACA;IACE,UAAU;EACZ;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,UAAU;EACZ;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,UAAU;EACZ;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,UAAU;EACZ;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,UAAU;EACZ;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,UAAU;EACZ;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,WAAW;EACb;EACA;IACE,YAAY;EACd;EACA;IAEE,kBAAkB;EACpB;EACA;IAEE,kBAAkB;EACpB;EACA;IACE,UAAU;EACZ;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,aAAa;EACf;EACA;IACE,UAAU;EACZ;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,aAAa;EACf;EACA;IACE,UAAU;EACZ;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,aAAa;EACf;EACA;IACE,WAAW;IACX,MAAM;EACR;EACA;IACE,iBAAiB;IACjB,YAAY;EACd;EACA;IACE,gBAAgB;IAChB,WAAW;EACb;EACA;IACE,iBAAiB;IACjB,YAAY;EACd;EACA;IACE,cAAc;IACd,SAAS;EACX;EACA;IACE,iBAAiB;IACjB,YAAY;EACd;EACA;IACE,gBAAgB;IAChB,WAAW;EACb;EACA;IACE,iBAAiB;IACjB,YAAY;EACd;EACA;IACE,cAAc;IACd,SAAS;EACX;EACA;IACE,iBAAiB;IACjB,YAAY;EACd;EACA;IACE,gBAAgB;IAChB,WAAW;EACb;EACA;IACE,iBAAiB;IACjB,YAAY;EACd;EACA;IACE,cAAc;IACd,SAAS;EACX;EACA;IACE,iBAAiB;IACjB,YAAY;EACd;EACA;IACE,gBAAgB;IAChB,WAAW;EACb;EACA;IACE,iBAAiB;IACjB,YAAY;EACd;EACA;IACE,cAAc;IACd,SAAS;EACX;EACA;IACE,cAAc;IACd,SAAS;EACX;EACA;IACE,cAAc;IACd,SAAS;EACX;EACA;IACE,cAAc;IACd,SAAS;EACX;EACA;IACE,cAAc;IACd,SAAS;EACX;EACA;IACE,cAAc;IACd,SAAS;EACX;EACA;IACE,eAAe;IACf,UAAU;EACZ;EACA;IACE,eAAe;IACf,UAAU;EACZ;EACA;IACE,eAAe;IACf,UAAU;EACZ;EACA;IACE,eAAe;IACf,UAAU;EACZ;EACA;IACE,eAAe;IACf,UAAU;EACZ;EACA;IACE,eAAe;IACf,UAAU;EACZ;EACA;IACE,eAAe;IACf,UAAU;EACZ;EACA;IACE,eAAe;IACf,UAAU;EACZ;EACA;IACE,eAAe;IACf,UAAU;EACZ;EACA;IACE,eAAe;IACf,UAAU;EACZ;EACA;IACE,aAAa;IACb,QAAQ;EACV;EACA;IACE,kBAAkB;IAClB,aAAa;EACf;EACA;IACE,kBAAkB;IAClB,aAAa;EACf;EACA;IACE,kBAAkB;IAClB,aAAa;EACf;EACA;IACE,kBAAkB;IAClB,aAAa;EACf;EACA;IACE,aAAa;IACb,QAAQ;EACV;EACA;IACE,oBAAoB;IACpB,eAAe;EACjB;EACA;IACE,oBAAoB;IACpB,eAAe;EACjB;EACA;IACE,aAAa;IACb,QAAQ;EACV;EACA;IACE,aAAa;IACb,QAAQ;EACV;EACA;IACE,aAAa;IACb,QAAQ;EACV;EACA;IACE,aAAa;IACb,QAAQ;EACV;EACA;IACE,aAAa;IACb,QAAQ;EACV;EACA;IACE,aAAa;IACb,QAAQ;EACV;EACA;IACE,aAAa;IACb,QAAQ;EACV;EACA;IACE,oBAAoB;IACpB,eAAe;EACjB;EACA;IACE,oBAAoB;IACpB,eAAe;EACjB;EACA;IACE,aAAa;IACb,QAAQ;EACV;EACA;IACE,oBAAoB;IACpB,eAAe;EACjB;EACA;IACE,oBAAoB;IACpB,eAAe;EACjB;EACA;IACE,mBAAmB;IACnB,cAAc;EAChB;EACA;IACE,oBAAoB;IACpB,eAAe;EACjB;EACA;IACE,aAAa;IACb,QAAQ;EACV;EACA;IACE,oBAAoB;IACpB,eAAe;EACjB;EACA;IACE,oBAAoB;IACpB,eAAe;EACjB;EACA;IACE,aAAa;IACb,QAAQ;EACV;EACA;IACE,oBAAoB;IACpB,eAAe;EACjB;EACA;IACE,oBAAoB;IACpB,eAAe;EACjB;EACA;IACE,aAAa;IACb,QAAQ;EACV;EACA;IACE,oBAAoB;IACpB,eAAe;EACjB;EACA;IACE,oBAAoB;IACpB,eAAe;EACjB;EACA;IACE,cAAc;IACd,SAAS;EACX;EACA;IACE,kBAAkB;IAElB,aAAa;EACf;EACA;IACE,wBAAwB;IAExB,mBAAmB;EACrB;EACA;IACE,uBAAuB;IAEvB,kBAAkB;EACpB;EACA;IACE,wBAAwB;IAExB,mBAAmB;EACrB;EACA;IACE,qBAAqB;IAErB,gBAAgB;EAClB;EACA;IACE,wBAAwB;IAExB,mBAAmB;EACrB;EACA;IACE,uBAAuB;IAEvB,kBAAkB;EACpB;EACA;IACE,wBAAwB;IAExB,mBAAmB;EACrB;EACA;IACE,qBAAqB;IAErB,gBAAgB;EAClB;EACA;IACE,wBAAwB;IAExB,mBAAmB;EACrB;EACA;IACE,uBAAuB;IAEvB,kBAAkB;EACpB;EACA;IACE,wBAAwB;IAExB,mBAAmB;EACrB;EACA;IACE,qBAAqB;IAErB,gBAAgB;EAClB;EACA;IACE,wBAAwB;IAExB,mBAAmB;EACrB;EACA;IACE,uBAAuB;IAEvB,kBAAkB;EACpB;EACA;IACE,wBAAwB;IAExB,mBAAmB;EACrB;EACA;IACE,qBAAqB;IAErB,gBAAgB;EAClB;EACA;IACE,qBAAqB;IAErB,gBAAgB;EAClB;EACA;IACE,qBAAqB;IAErB,gBAAgB;EAClB;EACA;IACE,qBAAqB;IAErB,gBAAgB;EAClB;EACA;IACE,qBAAqB;IAErB,gBAAgB;EAClB;EACA;IACE,qBAAqB;IAErB,gBAAgB;EAClB;EACA;IACE,sBAAsB;IAEtB,iBAAiB;EACnB;EACA;IACE,sBAAsB;IAEtB,iBAAiB;EACnB;EACA;IACE,sBAAsB;IAEtB,iBAAiB;EACnB;EACA;IACE,sBAAsB;IAEtB,iBAAiB;EACnB;EACA;IACE,sBAAsB;IAEtB,iBAAiB;EACnB;EACA;IACE,sBAAsB;IAEtB,iBAAiB;EACnB;EACA;IACE,sBAAsB;IAEtB,iBAAiB;EACnB;EACA;IACE,sBAAsB;IAEtB,iBAAiB;EACnB;EACA;IACE,sBAAsB;IAEtB,iBAAiB;EACnB;EACA;IACE,sBAAsB;IAEtB,iBAAiB;EACnB;EACA;IACE,oBAAoB;IAEpB,eAAe;EACjB;EACA;IACE,yBAAyB;IAEzB,oBAAoB;EACtB;EACA;IACE,yBAAyB;IAEzB,oBAAoB;EACtB;EACA;IACE,yBAAyB;IAEzB,oBAAoB;EACtB;EACA;IACE,yBAAyB;IAEzB,oBAAoB;EACtB;EACA;IACE,oBAAoB;IAEpB,eAAe;EACjB;EACA;IACE,2BAA2B;IAE3B,sBAAsB;EACxB;EACA;IACE,2BAA2B;IAE3B,sBAAsB;EACxB;EACA;IACE,oBAAoB;IAEpB,eAAe;EACjB;EACA;IACE,oBAAoB;IAEpB,eAAe;EACjB;EACA;IACE,oBAAoB;IAEpB,eAAe;EACjB;EACA;IACE,oBAAoB;IAEpB,eAAe;EACjB;EACA;IACE,oBAAoB;IAEpB,eAAe;EACjB;EACA;IACE,oBAAoB;IAEpB,eAAe;EACjB;EACA;IACE,oBAAoB;IAEpB,eAAe;EACjB;EACA;IACE,2BAA2B;IAE3B,sBAAsB;EACxB;EACA;IACE,2BAA2B;IAE3B,sBAAsB;EACxB;EACA;IACE,oBAAoB;IAEpB,eAAe;EACjB;EACA;IACE,2BAA2B;IAE3B,sBAAsB;EACxB;EACA;IACE,2BAA2B;IAE3B,sBAAsB;EACxB;EACA;IACE,0BAA0B;IAE1B,qBAAqB;EACvB;EACA;IACE,2BAA2B;IAE3B,sBAAsB;EACxB;EACA;IACE,oBAAoB;IAEpB,eAAe;EACjB;EACA;IACE,2BAA2B;IAE3B,sBAAsB;EACxB;EACA;IACE,2BAA2B;IAE3B,sBAAsB;EACxB;EACA;IACE,oBAAoB;IAEpB,eAAe;EACjB;EACA;IACE,2BAA2B;IAE3B,sBAAsB;EACxB;EACA;IACE,2BAA2B;IAE3B,sBAAsB;EACxB;EACA;IACE,oBAAoB;IAEpB,eAAe;EACjB;EACA;IACE,2BAA2B;IAE3B,sBAAsB;EACxB;EACA;IACE,2BAA2B;IAE3B,sBAAsB;EACxB;EACA;IACE,qBAAqB;IAErB,gBAAgB;EAClB;EACA;IACE,kBAAkB;IAElB,aAAa;EACf;EACA;IACE,wBAAwB;IAExB,mBAAmB;EACrB;EACA;IACE,uBAAuB;IAEvB,kBAAkB;EACpB;EACA;IACE,wBAAwB;IAExB,mBAAmB;EACrB;EACA;IACE,qBAAqB;IAErB,gBAAgB;EAClB;EACA;IACE,wBAAwB;IAExB,mBAAmB;EACrB;EACA;IACE,uBAAuB;IAEvB,kBAAkB;EACpB;EACA;IACE,wBAAwB;IAExB,mBAAmB;EACrB;EACA;IACE,qBAAqB;IAErB,gBAAgB;EAClB;EACA;IACE,wBAAwB;IAExB,mBAAmB;EACrB;EACA;IACE,uBAAuB;IAEvB,kBAAkB;EACpB;EACA;IACE,wBAAwB;IAExB,mBAAmB;EACrB;EACA;IACE,qBAAqB;IAErB,gBAAgB;EAClB;EACA;IACE,wBAAwB;IAExB,mBAAmB;EACrB;EACA;IACE,uBAAuB;IAEvB,kBAAkB;EACpB;EACA;IACE,wBAAwB;IAExB,mBAAmB;EACrB;EACA;IACE,qBAAqB;IAErB,gBAAgB;EAClB;EACA;IACE,qBAAqB;IAErB,gBAAgB;EAClB;EACA;IACE,qBAAqB;IAErB,gBAAgB;EAClB;EACA;IACE,qBAAqB;IAErB,gBAAgB;EAClB;EACA;IACE,qBAAqB;IAErB,gBAAgB;EAClB;EACA;IACE,qBAAqB;IAErB,gBAAgB;EAClB;EACA;IACE,sBAAsB;IAEtB,iBAAiB;EACnB;EACA;IACE,sBAAsB;IAEtB,iBAAiB;EACnB;EACA;IACE,sBAAsB;IAEtB,iBAAiB;EACnB;EACA;IACE,sBAAsB;IAEtB,iBAAiB;EACnB;EACA;IACE,sBAAsB;IAEtB,iBAAiB;EACnB;EACA;IACE,sBAAsB;IAEtB,iBAAiB;EACnB;EACA;IACE,sBAAsB;IAEtB,iBAAiB;EACnB;EACA;IACE,sBAAsB;IAEtB,iBAAiB;EACnB;EACA;IACE,sBAAsB;IAEtB,iBAAiB;EACnB;EACA;IACE,sBAAsB;IAEtB,iBAAiB;EACnB;EACA;IACE,oBAAoB;IAEpB,eAAe;EACjB;EACA;IACE,yBAAyB;IAEzB,oBAAoB;EACtB;EACA;IACE,yBAAyB;IAEzB,oBAAoB;EACtB;EACA;IACE,yBAAyB;IAEzB,oBAAoB;EACtB;EACA;IACE,yBAAyB;IAEzB,oBAAoB;EACtB;EACA;IACE,oBAAoB;IAEpB,eAAe;EACjB;EACA;IACE,2BAA2B;IAE3B,sBAAsB;EACxB;EACA;IACE,2BAA2B;IAE3B,sBAAsB;EACxB;EACA;IACE,oBAAoB;IAEpB,eAAe;EACjB;EACA;IACE,oBAAoB;IAEpB,eAAe;EACjB;EACA;IACE,oBAAoB;IAEpB,eAAe;EACjB;EACA;IACE,oBAAoB;IAEpB,eAAe;EACjB;EACA;IACE,oBAAoB;IAEpB,eAAe;EACjB;EACA;IACE,oBAAoB;IAEpB,eAAe;EACjB;EACA;IACE,oBAAoB;IAEpB,eAAe;EACjB;EACA;IACE,2BAA2B;IAE3B,sBAAsB;EACxB;EACA;IACE,2BAA2B;IAE3B,sBAAsB;EACxB;EACA;IACE,oBAAoB;IAEpB,eAAe;EACjB;EACA;IACE,2BAA2B;IAE3B,sBAAsB;EACxB;EACA;IACE,2BAA2B;IAE3B,sBAAsB;EACxB;EACA;IACE,0BAA0B;IAE1B,qBAAqB;EACvB;EACA;IACE,2BAA2B;IAE3B,sBAAsB;EACxB;EACA;IACE,oBAAoB;IAEpB,eAAe;EACjB;EACA;IACE,2BAA2B;IAE3B,sBAAsB;EACxB;EACA;IACE,2BAA2B;IAE3B,sBAAsB;EACxB;EACA;IACE,oBAAoB;IAEpB,eAAe;EACjB;EACA;IACE,2BAA2B;IAE3B,sBAAsB;EACxB;EACA;IACE,2BAA2B;IAE3B,sBAAsB;EACxB;EACA;IACE,oBAAoB;IAEpB,eAAe;EACjB;EACA;IACE,2BAA2B;IAE3B,sBAAsB;EACxB;EACA;IACE,2BAA2B;IAE3B,sBAAsB;EACxB;EACA;IACE,qBAAqB;IAErB,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,UAAU;EACZ;EACA;IACE,qBAAqB;IACrB,gBAAgB;EAClB;EACA;IACE,oBAAoB;IACpB,eAAe;EACjB;EACA;IACE,qBAAqB;IACrB,gBAAgB;EAClB;EACA;IACE,kBAAkB;IAClB,aAAa;EACf;EACA;IACE,qBAAqB;IACrB,gBAAgB;EAClB;EACA;IACE,oBAAoB;IACpB,eAAe;EACjB;EACA;IACE,qBAAqB;IACrB,gBAAgB;EAClB;EACA;IACE,kBAAkB;IAClB,aAAa;EACf;EACA;IACE,qBAAqB;IACrB,gBAAgB;EAClB;EACA;IACE,oBAAoB;IACpB,eAAe;EACjB;EACA;IACE,qBAAqB;IACrB,gBAAgB;EAClB;EACA;IACE,kBAAkB;IAClB,aAAa;EACf;EACA;IACE,qBAAqB;IACrB,gBAAgB;EAClB;EACA;IACE,oBAAoB;IACpB,eAAe;EACjB;EACA;IACE,qBAAqB;IACrB,gBAAgB;EAClB;EACA;IACE,kBAAkB;IAClB,aAAa;EACf;EACA;IACE,kBAAkB;IAClB,aAAa;EACf;EACA;IACE,kBAAkB;IAClB,aAAa;EACf;EACA;IACE,kBAAkB;IAClB,aAAa;EACf;EACA;IACE,kBAAkB;IAClB,aAAa;EACf;EACA;IACE,kBAAkB;IAClB,aAAa;EACf;EACA;IACE,mBAAmB;IACnB,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,cAAc;EAChB;EACA;IACE,iBAAiB;IACjB,YAAY;EACd;EACA;IACE,sBAAsB;IACtB,iBAAiB;EACnB;EACA;IACE,sBAAsB;IACtB,iBAAiB;EACnB;EACA;IACE,sBAAsB;IACtB,iBAAiB;EACnB;EACA;IACE,sBAAsB;IACtB,iBAAiB;EACnB;EACA;IACE,iBAAiB;IACjB,YAAY;EACd;EACA;IACE,wBAAwB;IACxB,mBAAmB;EACrB;EACA;IACE,wBAAwB;IACxB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,YAAY;EACd;EACA;IACE,iBAAiB;IACjB,YAAY;EACd;EACA;IACE,iBAAiB;IACjB,YAAY;EACd;EACA;IACE,iBAAiB;IACjB,YAAY;EACd;EACA;IACE,iBAAiB;IACjB,YAAY;EACd;EACA;IACE,iBAAiB;IACjB,YAAY;EACd;EACA;IACE,iBAAiB;IACjB,YAAY;EACd;EACA;IACE,wBAAwB;IACxB,mBAAmB;EACrB;EACA;IACE,wBAAwB;IACxB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,YAAY;EACd;EACA;IACE,wBAAwB;IACxB,mBAAmB;EACrB;EACA;IACE,wBAAwB;IACxB,mBAAmB;EACrB;EACA;IACE,uBAAuB;IACvB,kBAAkB;EACpB;EACA;IACE,wBAAwB;IACxB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,YAAY;EACd;EACA;IACE,wBAAwB;IACxB,mBAAmB;EACrB;EACA;IACE,wBAAwB;IACxB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,YAAY;EACd;EACA;IACE,wBAAwB;IACxB,mBAAmB;EACrB;EACA;IACE,wBAAwB;IACxB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,YAAY;EACd;EACA;IACE,wBAAwB;IACxB,mBAAmB;EACrB;EACA;IACE,wBAAwB;IACxB,mBAAmB;EACrB;EACA;IACE,kBAAkB;IAClB,aAAa;EACf;EACA;IACE,eAAe;IACf,UAAU;EACZ;EACA;IACE,qBAAqB;IACrB,gBAAgB;EAClB;EACA;IACE,oBAAoB;IACpB,eAAe;EACjB;EACA;IACE,qBAAqB;IACrB,gBAAgB;EAClB;EACA;IACE,kBAAkB;IAClB,aAAa;EACf;EACA;IACE,qBAAqB;IACrB,gBAAgB;EAClB;EACA;IACE,oBAAoB;IACpB,eAAe;EACjB;EACA;IACE,qBAAqB;IACrB,gBAAgB;EAClB;EACA;IACE,kBAAkB;IAClB,aAAa;EACf;EACA;IACE,qBAAqB;IACrB,gBAAgB;EAClB;EACA;IACE,oBAAoB;IACpB,eAAe;EACjB;EACA;IACE,qBAAqB;IACrB,gBAAgB;EAClB;EACA;IACE,kBAAkB;IAClB,aAAa;EACf;EACA;IACE,qBAAqB;IACrB,gBAAgB;EAClB;EACA;IACE,oBAAoB;IACpB,eAAe;EACjB;EACA;IACE,qBAAqB;IACrB,gBAAgB;EAClB;EACA;IACE,kBAAkB;IAClB,aAAa;EACf;EACA;IACE,kBAAkB;IAClB,aAAa;EACf;EACA;IACE,kBAAkB;IAClB,aAAa;EACf;EACA;IACE,kBAAkB;IAClB,aAAa;EACf;EACA;IACE,kBAAkB;IAClB,aAAa;EACf;EACA;IACE,kBAAkB;IAClB,aAAa;EACf;EACA;IACE,mBAAmB;IACnB,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,cAAc;EAChB;EACA;IACE,iBAAiB;IACjB,YAAY;EACd;EACA;IACE,sBAAsB;IACtB,iBAAiB;EACnB;EACA;IACE,sBAAsB;IACtB,iBAAiB;EACnB;EACA;IACE,sBAAsB;IACtB,iBAAiB;EACnB;EACA;IACE,sBAAsB;IACtB,iBAAiB;EACnB;EACA;IACE,iBAAiB;IACjB,YAAY;EACd;EACA;IACE,wBAAwB;IACxB,mBAAmB;EACrB;EACA;IACE,wBAAwB;IACxB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,YAAY;EACd;EACA;IACE,iBAAiB;IACjB,YAAY;EACd;EACA;IACE,iBAAiB;IACjB,YAAY;EACd;EACA;IACE,iBAAiB;IACjB,YAAY;EACd;EACA;IACE,iBAAiB;IACjB,YAAY;EACd;EACA;IACE,iBAAiB;IACjB,YAAY;EACd;EACA;IACE,iBAAiB;IACjB,YAAY;EACd;EACA;IACE,wBAAwB;IACxB,mBAAmB;EACrB;EACA;IACE,wBAAwB;IACxB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,YAAY;EACd;EACA;IACE,wBAAwB;IACxB,mBAAmB;EACrB;EACA;IACE,wBAAwB;IACxB,mBAAmB;EACrB;EACA;IACE,uBAAuB;IACvB,kBAAkB;EACpB;EACA;IACE,wBAAwB;IACxB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,YAAY;EACd;EACA;IACE,wBAAwB;IACxB,mBAAmB;EACrB;EACA;IACE,wBAAwB;IACxB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,YAAY;EACd;EACA;IACE,wBAAwB;IACxB,mBAAmB;EACrB;EACA;IACE,wBAAwB;IACxB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,YAAY;EACd;EACA;IACE,wBAAwB;IACxB,mBAAmB;EACrB;EACA;IACE,wBAAwB;IACxB,mBAAmB;EACrB;EACA;IACE,kBAAkB;IAClB,aAAa;EACf;EACA;IACE,mBAAmB;EACrB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,gDAAgD;EAClD;EACA;IACE,gDAAgD;EAClD;EACA;IACE,gDAAgD;EAClD;EACA;IACE,gDAAgD;EAClD;EACA;IACE,gDAAgD;EAClD;EACA;IACE,gDAAgD;EAClD;EACA;IACE,gDAAgD;EAClD;EACA;IACE,gDAAgD;EAClD;EACA;IACE,gDAAgD;EAClD;EACA;IACE,iDAAiD;EACnD;EACA;IACE,iDAAiD;EACnD;EACA;IACE,iDAAiD;EACnD;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,iBAAiB;EACnB;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,6CAA6C;EAC/C;EACA;IACE,6CAA6C;EAC/C;EACA;IACE,6CAA6C;EAC/C;EACA;IACE,6CAA6C;EAC/C;EACA;IACE,6CAA6C;EAC/C;EACA;IACE,6CAA6C;EAC/C;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,oBAAoB;EACtB;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,8BAA8B;EAChC;EACA;IACE,cAAc;EAChB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,gBAAgB;EAClB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,0BAA0B;IAC1B,0BAA0B;IAC1B,qBAAqB;IACrB,qBAAqB;IACrB,qBAAqB;IACrB,sBAAsB;IACtB,sBAAsB;IACtB,4PAA4P;EAC9P;EACA;IACE,eAAe;EACjB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,qBAAqB;EACvB;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,8BAA8B;EAChC;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,sBAAsB;IACtB,sBAAsB;EACxB;EACA;IACE,uBAAuB;IACvB,uBAAuB;EACzB;EACA;IACE,wBAAwB;IACxB,wBAAwB;EAC1B;EACA;IACE,uBAAuB;IACvB,uBAAuB;EACzB;EACA;IACE,wBAAwB;IACxB,wBAAwB;EAC1B;EACA;IACE,sBAAsB;IACtB,sBAAsB;EACxB;EACA;IACE,yBAAyB;IACzB,yBAAyB;EAC3B;EACA;IACE,wBAAwB;IACxB,wBAAwB;EAC1B;EACA;IACE,yBAAyB;IACzB,yBAAyB;EAC3B;EACA;IACE,wBAAwB;IACxB,wBAAwB;EAC1B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,sBAAsB;IACtB,sBAAsB;EACxB;EACA;IACE,uBAAuB;IACvB,uBAAuB;EACzB;EACA;IACE,wBAAwB;IACxB,wBAAwB;EAC1B;EACA;IACE,uBAAuB;IACvB,uBAAuB;EACzB;EACA;IACE,wBAAwB;IACxB,wBAAwB;EAC1B;EACA;IACE,sBAAsB;IACtB,sBAAsB;EACxB;EACA;IACE,yBAAyB;IACzB,yBAAyB;EAC3B;EACA;IACE,wBAAwB;IACxB,wBAAwB;EAC1B;EACA;IACE,yBAAyB;IACzB,yBAAyB;EAC3B;EACA;IACE,wBAAwB;IACxB,wBAAwB;EAC1B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,sBAAsB;IACtB,sBAAsB;EACxB;EACA;IACE,uBAAuB;IACvB,uBAAuB;EACzB;EACA;IACE,wBAAwB;IACxB,wBAAwB;EAC1B;EACA;IACE,uBAAuB;IACvB,uBAAuB;EACzB;EACA;IACE,wBAAwB;IACxB,wBAAwB;EAC1B;EACA;IACE,sBAAsB;IACtB,sBAAsB;EACxB;EACA;IACE,yBAAyB;IACzB,yBAAyB;EAC3B;EACA;IACE,wBAAwB;IACxB,wBAAwB;EAC1B;EACA;IACE,yBAAyB;IACzB,yBAAyB;EAC3B;EACA;IACE,wBAAwB;IACxB,wBAAwB;EAC1B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,qBAAqB;EACvB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,qBAAqB;EACvB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,qBAAqB;EACvB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,gCAAgC;EAClC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,gCAAgC;EAClC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,gCAAgC;EAClC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,gCAAgC;EAClC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,iCAAiC;EACnC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,iCAAiC;EACnC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,gCAAgC;EAClC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,gCAAgC;EAClC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,gCAAgC;EAClC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,gCAAgC;EAClC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,iCAAiC;EACnC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,iCAAiC;EACnC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,gCAAgC;EAClC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,gCAAgC;EAClC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,gCAAgC;EAClC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,gCAAgC;EAClC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,iCAAiC;EACnC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,iCAAiC;EACnC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,gCAAgC;EAClC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,gCAAgC;EAClC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,gCAAgC;EAClC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,gCAAgC;EAClC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,iCAAiC;EACnC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,iCAAiC;EACnC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,gCAAgC;EAClC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,gCAAgC;EAClC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,gCAAgC;EAClC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,gCAAgC;EAClC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,iCAAiC;EACnC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,iCAAiC;EACnC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,gCAAgC;EAClC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,gCAAgC;EAClC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,gCAAgC;EAClC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,gCAAgC;EAClC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,iCAAiC;EACnC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,iCAAiC;EACnC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,qBAAqB;EACvB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,qBAAqB;EACvB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,qBAAqB;EACvB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,qBAAqB;EACvB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,qBAAqB;EACvB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,qBAAqB;EACvB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wGAAwG;EAC1G;EACA;IACE,wEAAwE;EAC1E;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,+BAA+B;EACjC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,sDAAsD;EACxD;EACA;IACE,sDAAsD;EACxD;EACA;IACE,wDAAwD;EAC1D;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,eAAe;EACjB;EACA;IACE,kCAAkC;EACpC;EACA;IACE,sDAAsD;EACxD;EACA;IACE,yDAAyD;EAC3D;EACA;IACE,6BAA6B;EAC/B;AACF;AACA;EACE;IACE,WAAW;EACb;EACA;IACE;MACE,gBAAgB;IAClB;EACF;EACA;IACE;MACE,gBAAgB;IAClB;EACF;EACA;IACE;MACE,iBAAiB;IACnB;EACF;EACA;IACE;MACE,iBAAiB;IACnB;EACF;EACA;IACE,cAAc;IACd,eAAe;EACjB;EACA;IACE,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,cAAc;IACd,qBAAqB;IACrB,gBAAgB;EAClB;EACA;IACE,cAAc;IACd,gBAAgB;EAClB;EACA;IACE,2BAA2B;IAC3B,kBAAkB;IAClB,qBAAqB;EACvB;EACA;IACE,kBAAkB;IAClB,+BAA+B;IAC/B,oBAAoB;EACtB;EACA;IACE,kCAAkC;IAClC,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;EAChB;EACA;IACE,kBAAkB;IAClB,oBAAoB;EACtB;EACA;IACE,WAAW;IACX,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,6BAA6B;IAC7B,YAAY;EACd;EACA;IACE,qBAAqB;IACrB,qBAAqB;IACrB,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;IACd,0BAA0B;IAC1B,0BAA0B;IAC1B,uCAAuC;IACvC,iBAAiB;IACjB,oBAAoB;IACpB,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,cAAc;IACd,gBAAgB;IAChB,iBAAiB;IACjB,aAAa;IACb,0BAA0B;IAC1B,sBAAsB;EACxB;EACA;IACE,cAAc;IACd,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,sBAAsB;EACxB;EACA;IACE,cAAc;IACd,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;IACjB,oBAAoB;IACpB,gBAAgB;EAClB;EACA;IACE,cAAc;IACd,gBAAgB;IAChB,iBAAiB;IACjB,oBAAoB;IACpB,gBAAgB;EAClB;EACA;IACE,cAAc;IACd,kBAAkB;IAClB,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,cAAc;IACd,gBAAgB;IAChB,kBAAkB;EACpB;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,cAAc;IACd,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;IAClB,sBAAsB;IACtB,uBAAuB;IACvB,0BAA0B;IAC1B,uBAAuB;IACvB,wBAAwB;IACxB,0BAA0B;IAC1B,2BAA2B;IAC3B,yBAAyB;EAC3B;EACA;IACE,6BAA6B;IAC7B,eAAe;IACf,gBAAgB;IAChB,UAAU;IACV,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,oBAAoB;IACpB,oBAAoB;EACtB;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,kBAAkB;IAClB,sBAAsB;EACxB;EACA;IACE,cAAc;IACd,gBAAgB;IAChB,wBAAwB;IACxB,4BAA4B;EAC9B;EACA;IACE,sBAAsB;IACtB,0BAA0B;IAC1B,2BAA2B;IAC3B,yBAAyB;EAC3B;EACA;IACE,wBAAwB;IACxB,4BAA4B;EAC9B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,mBAAmB;IACnB,wBAAwB;IACxB,0BAA0B;IAC1B,2BAA2B;IAC3B,yBAAyB;EAC3B;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,aAAa;IACb,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,OAAO;EACT;EACA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,aAAa;EACf;EACA;IACE,gBAAgB;EAClB;EACA;IACE,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,sBAAsB;EACxB;EACA;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,sBAAsB;IACtB,sBAAsB;IACtB,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,uBAAuB;IACvB,0BAA0B;IAC1B,yBAAyB;EAC3B;EACA;IACE,sBAAsB;IACtB,aAAa;IACb,oBAAoB;IACpB,gBAAgB;EAClB;EACA;IACE,sBAAsB;IACtB,iBAAiB;IACjB,oBAAoB;IACpB,gBAAgB;EAClB;EACA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,0BAA0B;IAC1B,sBAAsB;EACxB;EACA;IACE,uBAAuB;IACvB,0BAA0B;IAC1B,sBAAsB;EACxB;EACA;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,aAAa;IACb,gBAAgB;EAClB;EACA;IACE,sBAAsB;IACtB,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;IACtB,sBAAsB;IACtB,uBAAuB;IACvB,0BAA0B;IAC1B,sBAAsB;IACtB,wBAAwB;IACxB,kBAAkB;IAClB,2BAA2B;IAC3B,iBAAiB;EACnB;EACA;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,OAAO;EACT;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,mBAAmB;IACnB,kBAAkB;IAClB,oCAAoC;IACpC,iBAAiB;EACnB;EACA;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,sBAAsB;IACtB,gBAAgB;EAClB;EACA;IACE,kBAAkB;IAClB,2BAA2B;IAC3B,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,wBAAwB;IACxB,kBAAkB;IAClB,2BAA2B;IAC3B,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,aAAa;EACf;EACA;IACE,gBAAgB;EAClB;EACA;IACE,mBAAmB;IACnB,sBAAsB;EACxB;EACA;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,sBAAsB;IACtB,sBAAsB;IACtB,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,uBAAuB;IACvB,0BAA0B;IAC1B,iBAAiB;EACnB;EACA;IACE,sBAAsB;IACtB,aAAa;IACb,0BAA0B;IAC1B,cAAc;EAChB;EACA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,0BAA0B;IAC1B,sBAAsB;EACxB;EACA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,0BAA0B;IAC1B,gBAAgB;EAClB;EACA;IACE,uBAAuB;IACvB,0BAA0B;IAC1B,sBAAsB;EACxB;EACA;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,aAAa;IACb,gBAAgB;EAClB;EACA;IACE,sBAAsB;IACtB,gBAAgB;IAChB,eAAe;EACjB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,sBAAsB;IACtB,iBAAiB;IACjB,eAAe;IACf,kBAAkB;IAClB,uBAAuB;IACvB,gBAAgB;IAChB,oBAAoB;IACpB,mBAAmB;IACnB,mBAAmB;EACrB;EACA;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,OAAO;EACT;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,oCAAoC;IACpC,iBAAiB;EACnB;EACA;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,sBAAsB;IACtB,gBAAgB;EAClB;EACA;IACE,qBAAqB;IACrB,sBAAsB;IACtB,oBAAoB;EACtB;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sBAAsB;IACtB,oBAAoB;EACtB;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,aAAa;EACf;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,iBAAiB;IACjB,oBAAoB;IACpB,yBAAyB;EAC3B;EACA;IACE,gBAAgB;IAChB,aAAa;IACb,0BAA0B;IAC1B,cAAc;EAChB;EACA;IACE,gBAAgB;IAChB,uBAAuB;IACvB,0BAA0B;IAC1B,sBAAsB;EACxB;EACA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,0BAA0B;IAC1B,sBAAsB;EACxB;EACA;IACE,iBAAiB;IACjB,oBAAoB;IACpB,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,aAAa;IACb,gBAAgB;EAClB;EACA;IACE,gBAAgB;IAChB,sBAAsB;IACtB,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;IAChB,sBAAsB;IACtB,eAAe;IACf,kBAAkB;IAClB,qBAAqB;IACrB,wBAAwB;IACxB,0BAA0B;IAC1B,2BAA2B;IAC3B,yBAAyB;EAC3B;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,OAAO;EACT;EACA;IACE,mBAAmB;EACrB;EACA;IACE,aAAa;IACb,cAAc;IACd,0BAA0B;IAC1B,YAAY;EACd;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,gBAAgB;IAChB,sBAAsB;EACxB;EACA;IACE,0BAA0B;IAC1B,2BAA2B;IAC3B,yBAAyB;EAC3B;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,wBAAwB;IACxB,0BAA0B;IAC1B,2BAA2B;IAC3B,yBAAyB;EAC3B;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,aAAa;EACf;EACA;IACE,gBAAgB;EAClB;EACA;IACE,iBAAiB;IACjB,sBAAsB;EACxB;EACA;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,iBAAiB;IACjB,sBAAsB;IACtB,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,uBAAuB;IACvB,0BAA0B;IAC1B,yBAAyB;EAC3B;EACA;IACE,sBAAsB;IACtB,aAAa;IACb,sBAAsB;IACtB,cAAc;EAChB;EACA;IACE,cAAc;IACd,iBAAiB;IACjB,0BAA0B;IAC1B,sBAAsB;EACxB;EACA;IACE,gBAAgB;IAChB,uBAAuB;IACvB,0BAA0B;IAC1B,sBAAsB;EACxB;EACA;IACE,uBAAuB;IACvB,0BAA0B;IAC1B,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,aAAa;IACb,gBAAgB;EAClB;EACA;IACE,sBAAsB;IACtB,gBAAgB;IAChB,eAAe;EACjB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;IACtB,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,qBAAqB;IACrB,kBAAkB;IAClB,oBAAoB;IACpB,qBAAqB;IACrB,mBAAmB;EACrB;EACA;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,OAAO;EACT;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,oCAAoC;IACpC,YAAY;EACd;EACA;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,sBAAsB;IACtB,gBAAgB;EAClB;EACA;IACE,oBAAoB;IACpB,qBAAqB;IACrB,mBAAmB;EACrB;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;IAClB,oBAAoB;IACpB,qBAAqB;IACrB,mBAAmB;EACrB;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,aAAa;EACf;EACA;IACE,gBAAgB;EAClB;EACA;IACE,oBAAoB;IACpB,wDAAwD;IACxD,iDAAiD;EACnD;EACA;IACE,oBAAoB;IACpB,gDAAgD;IAChD,yDAAyD;EAC3D;EACA;IACE,oBAAoB;IACpB,4DAA4D;IAC5D,qDAAqD;EACvD;EACA;IACE,oBAAoB;IACpB,oDAAoD;IACpD,6DAA6D;EAC/D;EACA;IACE,oBAAoB;IACpB,2DAA2D;IAC3D,oDAAoD;EACtD;EACA;IACE,oBAAoB;IACpB,mDAAmD;IACnD,4DAA4D;EAC9D;EACA;IACE,oBAAoB;IACpB,4DAA4D;IAC5D,qDAAqD;EACvD;EACA;IACE,oBAAoB;IACpB,oDAAoD;IACpD,6DAA6D;EAC/D;EACA;IACE,oBAAoB;IACpB,yDAAyD;IACzD,kDAAkD;EACpD;EACA;IACE,oBAAoB;IACpB,iDAAiD;IACjD,0DAA0D;EAC5D;EACA;IACE,oBAAoB;IACpB,4DAA4D;IAC5D,qDAAqD;EACvD;EACA;IACE,oBAAoB;IACpB,oDAAoD;IACpD,6DAA6D;EAC/D;EACA;IACE,oBAAoB;IACpB,2DAA2D;IAC3D,oDAAoD;EACtD;EACA;IACE,oBAAoB;IACpB,mDAAmD;IACnD,4DAA4D;EAC9D;EACA;IACE,oBAAoB;IACpB,4DAA4D;IAC5D,qDAAqD;EACvD;EACA;IACE,oBAAoB;IACpB,oDAAoD;IACpD,6DAA6D;EAC/D;EACA;IACE,oBAAoB;IACpB,yDAAyD;IACzD,kDAAkD;EACpD;EACA;IACE,oBAAoB;IACpB,iDAAiD;IACjD,0DAA0D;EAC5D;EACA;IACE,oBAAoB;IACpB,4DAA4D;IAC5D,qDAAqD;EACvD;EACA;IACE,oBAAoB;IACpB,oDAAoD;IACpD,6DAA6D;EAC/D;EACA;IACE,oBAAoB;IACpB,2DAA2D;IAC3D,oDAAoD;EACtD;EACA;IACE,oBAAoB;IACpB,mDAAmD;IACnD,4DAA4D;EAC9D;EACA;IACE,oBAAoB;IACpB,4DAA4D;IAC5D,qDAAqD;EACvD;EACA;IACE,oBAAoB;IACpB,oDAAoD;IACpD,6DAA6D;EAC/D;EACA;IACE,oBAAoB;IACpB,yDAAyD;IACzD,kDAAkD;EACpD;EACA;IACE,oBAAoB;IACpB,iDAAiD;IACjD,0DAA0D;EAC5D;EACA;IACE,oBAAoB;IACpB,4DAA4D;IAC5D,qDAAqD;EACvD;EACA;IACE,oBAAoB;IACpB,oDAAoD;IACpD,6DAA6D;EAC/D;EACA;IACE,oBAAoB;IACpB,2DAA2D;IAC3D,oDAAoD;EACtD;EACA;IACE,oBAAoB;IACpB,mDAAmD;IACnD,4DAA4D;EAC9D;EACA;IACE,oBAAoB;IACpB,4DAA4D;IAC5D,qDAAqD;EACvD;EACA;IACE,oBAAoB;IACpB,oDAAoD;IACpD,6DAA6D;EAC/D;EACA;IACE,oBAAoB;IACpB,yDAAyD;IACzD,kDAAkD;EACpD;EACA;IACE,oBAAoB;IACpB,iDAAiD;IACjD,0DAA0D;EAC5D;EACA;IACE,oBAAoB;IACpB,yDAAyD;IACzD,kDAAkD;EACpD;EACA;IACE,oBAAoB;IACpB,iDAAiD;IACjD,0DAA0D;EAC5D;EACA;IACE,oBAAoB;IACpB,yDAAyD;IACzD,kDAAkD;EACpD;EACA;IACE,oBAAoB;IACpB,iDAAiD;IACjD,0DAA0D;EAC5D;EACA;IACE,oBAAoB;IACpB,yDAAyD;IACzD,kDAAkD;EACpD;EACA;IACE,oBAAoB;IACpB,iDAAiD;IACjD,0DAA0D;EAC5D;EACA;IACE,oBAAoB;IACpB,yDAAyD;IACzD,kDAAkD;EACpD;EACA;IACE,oBAAoB;IACpB,iDAAiD;IACjD,0DAA0D;EAC5D;EACA;IACE,oBAAoB;IACpB,yDAAyD;IACzD,kDAAkD;EACpD;EACA;IACE,oBAAoB;IACpB,iDAAiD;IACjD,0DAA0D;EAC5D;EACA;IACE,oBAAoB;IACpB,0DAA0D;IAC1D,mDAAmD;EACrD;EACA;IACE,oBAAoB;IACpB,kDAAkD;IAClD,2DAA2D;EAC7D;EACA;IACE,oBAAoB;IACpB,0DAA0D;IAC1D,mDAAmD;EACrD;EACA;IACE,oBAAoB;IACpB,kDAAkD;IAClD,2DAA2D;EAC7D;EACA;IACE,oBAAoB;IACpB,0DAA0D;IAC1D,mDAAmD;EACrD;EACA;IACE,oBAAoB;IACpB,kDAAkD;IAClD,2DAA2D;EAC7D;EACA;IACE,oBAAoB;IACpB,0DAA0D;IAC1D,mDAAmD;EACrD;EACA;IACE,oBAAoB;IACpB,kDAAkD;IAClD,2DAA2D;EAC7D;EACA;IACE,oBAAoB;IACpB,0DAA0D;IAC1D,mDAAmD;EACrD;EACA;IACE,oBAAoB;IACpB,kDAAkD;IAClD,2DAA2D;EAC7D;EACA;IACE,oBAAoB;IACpB,0DAA0D;IAC1D,mDAAmD;EACrD;EACA;IACE,oBAAoB;IACpB,kDAAkD;IAClD,2DAA2D;EAC7D;EACA;IACE,oBAAoB;IACpB,0DAA0D;IAC1D,mDAAmD;EACrD;EACA;IACE,oBAAoB;IACpB,kDAAkD;IAClD,2DAA2D;EAC7D;EACA;IACE,oBAAoB;IACpB,0DAA0D;IAC1D,mDAAmD;EACrD;EACA;IACE,oBAAoB;IACpB,kDAAkD;IAClD,2DAA2D;EAC7D;EACA;IACE,oBAAoB;IACpB,0DAA0D;IAC1D,mDAAmD;EACrD;EACA;IACE,oBAAoB;IACpB,kDAAkD;IAClD,2DAA2D;EAC7D;EACA;IACE,oBAAoB;IACpB,0DAA0D;IAC1D,mDAAmD;EACrD;EACA;IACE,oBAAoB;IACpB,kDAAkD;IAClD,2DAA2D;EAC7D;EACA;IACE,oBAAoB;IACpB,wDAAwD;IACxD,iDAAiD;EACnD;EACA;IACE,oBAAoB;IACpB,gDAAgD;IAChD,yDAAyD;EAC3D;EACA;IACE,oBAAoB;IACpB,6DAA6D;IAC7D,sDAAsD;EACxD;EACA;IACE,oBAAoB;IACpB,qDAAqD;IACrD,8DAA8D;EAChE;EACA;IACE,oBAAoB;IACpB,6DAA6D;IAC7D,sDAAsD;EACxD;EACA;IACE,oBAAoB;IACpB,qDAAqD;IACrD,8DAA8D;EAChE;EACA;IACE,oBAAoB;IACpB,6DAA6D;IAC7D,sDAAsD;EACxD;EACA;IACE,oBAAoB;IACpB,qDAAqD;IACrD,8DAA8D;EAChE;EACA;IACE,oBAAoB;IACpB,6DAA6D;IAC7D,sDAAsD;EACxD;EACA;IACE,oBAAoB;IACpB,qDAAqD;IACrD,8DAA8D;EAChE;EACA;IACE,oBAAoB;IACpB,wDAAwD;IACxD,iDAAiD;EACnD;EACA;IACE,oBAAoB;IACpB,gDAAgD;IAChD,yDAAyD;EAC3D;EACA;IACE,oBAAoB;IACpB,+DAA+D;IAC/D,wDAAwD;EAC1D;EACA;IACE,oBAAoB;IACpB,uDAAuD;IACvD,gEAAgE;EAClE;EACA;IACE,oBAAoB;IACpB,+DAA+D;IAC/D,wDAAwD;EAC1D;EACA;IACE,oBAAoB;IACpB,uDAAuD;IACvD,gEAAgE;EAClE;EACA;IACE,oBAAoB;IACpB,wDAAwD;IACxD,iDAAiD;EACnD;EACA;IACE,oBAAoB;IACpB,gDAAgD;IAChD,yDAAyD;EAC3D;EACA;IACE,oBAAoB;IACpB,wDAAwD;IACxD,iDAAiD;EACnD;EACA;IACE,oBAAoB;IACpB,gDAAgD;IAChD,yDAAyD;EAC3D;EACA;IACE,oBAAoB;IACpB,wDAAwD;IACxD,iDAAiD;EACnD;EACA;IACE,oBAAoB;IACpB,gDAAgD;IAChD,yDAAyD;EAC3D;EACA;IACE,oBAAoB;IACpB,wDAAwD;IACxD,iDAAiD;EACnD;EACA;IACE,oBAAoB;IACpB,gDAAgD;IAChD,yDAAyD;EAC3D;EACA;IACE,oBAAoB;IACpB,wDAAwD;IACxD,iDAAiD;EACnD;EACA;IACE,oBAAoB;IACpB,gDAAgD;IAChD,yDAAyD;EAC3D;EACA;IACE,oBAAoB;IACpB,wDAAwD;IACxD,iDAAiD;EACnD;EACA;IACE,oBAAoB;IACpB,gDAAgD;IAChD,yDAAyD;EAC3D;EACA;IACE,oBAAoB;IACpB,wDAAwD;IACxD,iDAAiD;EACnD;EACA;IACE,oBAAoB;IACpB,gDAAgD;IAChD,yDAAyD;EAC3D;EACA;IACE,oBAAoB;IACpB,+DAA+D;IAC/D,wDAAwD;EAC1D;EACA;IACE,oBAAoB;IACpB,uDAAuD;IACvD,gEAAgE;EAClE;EACA;IACE,oBAAoB;IACpB,+DAA+D;IAC/D,wDAAwD;EAC1D;EACA;IACE,oBAAoB;IACpB,uDAAuD;IACvD,gEAAgE;EAClE;EACA;IACE,oBAAoB;IACpB,wDAAwD;IACxD,iDAAiD;EACnD;EACA;IACE,oBAAoB;IACpB,gDAAgD;IAChD,yDAAyD;EAC3D;EACA;IACE,oBAAoB;IACpB,+DAA+D;IAC/D,wDAAwD;EAC1D;EACA;IACE,oBAAoB;IACpB,uDAAuD;IACvD,gEAAgE;EAClE;EACA;IACE,oBAAoB;IACpB,+DAA+D;IAC/D,wDAAwD;EAC1D;EACA;IACE,oBAAoB;IACpB,uDAAuD;IACvD,gEAAgE;EAClE;EACA;IACE,oBAAoB;IACpB,8DAA8D;IAC9D,uDAAuD;EACzD;EACA;IACE,oBAAoB;IACpB,sDAAsD;IACtD,+DAA+D;EACjE;EACA;IACE,oBAAoB;IACpB,+DAA+D;IAC/D,wDAAwD;EAC1D;EACA;IACE,oBAAoB;IACpB,uDAAuD;IACvD,gEAAgE;EAClE;EACA;IACE,oBAAoB;IACpB,wDAAwD;IACxD,iDAAiD;EACnD;EACA;IACE,oBAAoB;IACpB,gDAAgD;IAChD,yDAAyD;EAC3D;EACA;IACE,oBAAoB;IACpB,+DAA+D;IAC/D,wDAAwD;EAC1D;EACA;IACE,oBAAoB;IACpB,uDAAuD;IACvD,gEAAgE;EAClE;EACA;IACE,oBAAoB;IACpB,+DAA+D;IAC/D,wDAAwD;EAC1D;EACA;IACE,oBAAoB;IACpB,uDAAuD;IACvD,gEAAgE;EAClE;EACA;IACE,oBAAoB;IACpB,wDAAwD;IACxD,iDAAiD;EACnD;EACA;IACE,oBAAoB;IACpB,gDAAgD;IAChD,yDAAyD;EAC3D;EACA;IACE,oBAAoB;IACpB,+DAA+D;IAC/D,wDAAwD;EAC1D;EACA;IACE,oBAAoB;IACpB,uDAAuD;IACvD,gEAAgE;EAClE;EACA;IACE,oBAAoB;IACpB,+DAA+D;IAC/D,wDAAwD;EAC1D;EACA;IACE,oBAAoB;IACpB,uDAAuD;IACvD,gEAAgE;EAClE;EACA;IACE,oBAAoB;IACpB,wDAAwD;IACxD,iDAAiD;EACnD;EACA;IACE,oBAAoB;IACpB,gDAAgD;IAChD,yDAAyD;EAC3D;EACA;IACE,oBAAoB;IACpB,+DAA+D;IAC/D,wDAAwD;EAC1D;EACA;IACE,oBAAoB;IACpB,uDAAuD;IACvD,gEAAgE;EAClE;EACA;IACE,oBAAoB;IACpB,+DAA+D;IAC/D,wDAAwD;EAC1D;EACA;IACE,oBAAoB;IACpB,uDAAuD;IACvD,gEAAgE;EAClE;EACA;IACE,oBAAoB;IACpB,yDAAyD;IACzD,kDAAkD;EACpD;EACA;IACE,oBAAoB;IACpB,iDAAiD;IACjD,0DAA0D;EAC5D;EACA;IACE,oBAAoB;IACpB,6DAA6D;IAC7D,sDAAsD;EACxD;EACA;IACE,oBAAoB;IACpB,qDAAqD;IACrD,8DAA8D;EAChE;EACA;IACE,oBAAoB;IACpB,4DAA4D;IAC5D,qDAAqD;EACvD;EACA;IACE,oBAAoB;IACpB,oDAAoD;IACpD,6DAA6D;EAC/D;EACA;IACE,oBAAoB;IACpB,6DAA6D;IAC7D,sDAAsD;EACxD;EACA;IACE,oBAAoB;IACpB,qDAAqD;IACrD,8DAA8D;EAChE;EACA;IACE,oBAAoB;IACpB,0DAA0D;IAC1D,mDAAmD;EACrD;EACA;IACE,oBAAoB;IACpB,kDAAkD;IAClD,2DAA2D;EAC7D;EACA;IACE,oBAAoB;IACpB,6DAA6D;IAC7D,sDAAsD;EACxD;EACA;IACE,oBAAoB;IACpB,qDAAqD;IACrD,8DAA8D;EAChE;EACA;IACE,oBAAoB;IACpB,4DAA4D;IAC5D,qDAAqD;EACvD;EACA;IACE,oBAAoB;IACpB,oDAAoD;IACpD,6DAA6D;EAC/D;EACA;IACE,oBAAoB;IACpB,6DAA6D;IAC7D,sDAAsD;EACxD;EACA;IACE,oBAAoB;IACpB,qDAAqD;IACrD,8DAA8D;EAChE;EACA;IACE,oBAAoB;IACpB,0DAA0D;IAC1D,mDAAmD;EACrD;EACA;IACE,oBAAoB;IACpB,kDAAkD;IAClD,2DAA2D;EAC7D;EACA;IACE,oBAAoB;IACpB,6DAA6D;IAC7D,sDAAsD;EACxD;EACA;IACE,oBAAoB;IACpB,qDAAqD;IACrD,8DAA8D;EAChE;EACA;IACE,oBAAoB;IACpB,4DAA4D;IAC5D,qDAAqD;EACvD;EACA;IACE,oBAAoB;IACpB,oDAAoD;IACpD,6DAA6D;EAC/D;EACA;IACE,oBAAoB;IACpB,6DAA6D;IAC7D,sDAAsD;EACxD;EACA;IACE,oBAAoB;IACpB,qDAAqD;IACrD,8DAA8D;EAChE;EACA;IACE,oBAAoB;IACpB,0DAA0D;IAC1D,mDAAmD;EACrD;EACA;IACE,oBAAoB;IACpB,kDAAkD;IAClD,2DAA2D;EAC7D;EACA;IACE,oBAAoB;IACpB,6DAA6D;IAC7D,sDAAsD;EACxD;EACA;IACE,oBAAoB;IACpB,qDAAqD;IACrD,8DAA8D;EAChE;EACA;IACE,oBAAoB;IACpB,4DAA4D;IAC5D,qDAAqD;EACvD;EACA;IACE,oBAAoB;IACpB,oDAAoD;IACpD,6DAA6D;EAC/D;EACA;IACE,oBAAoB;IACpB,6DAA6D;IAC7D,sDAAsD;EACxD;EACA;IACE,oBAAoB;IACpB,qDAAqD;IACrD,8DAA8D;EAChE;EACA;IACE,oBAAoB;IACpB,0DAA0D;IAC1D,mDAAmD;EACrD;EACA;IACE,oBAAoB;IACpB,kDAAkD;IAClD,2DAA2D;EAC7D;EACA;IACE,oBAAoB;IACpB,0DAA0D;IAC1D,mDAAmD;EACrD;EACA;IACE,oBAAoB;IACpB,kDAAkD;IAClD,2DAA2D;EAC7D;EACA;IACE,oBAAoB;IACpB,0DAA0D;IAC1D,mDAAmD;EACrD;EACA;IACE,oBAAoB;IACpB,kDAAkD;IAClD,2DAA2D;EAC7D;EACA;IACE,oBAAoB;IACpB,0DAA0D;IAC1D,mDAAmD;EACrD;EACA;IACE,oBAAoB;IACpB,kDAAkD;IAClD,2DAA2D;EAC7D;EACA;IACE,oBAAoB;IACpB,0DAA0D;IAC1D,mDAAmD;EACrD;EACA;IACE,oBAAoB;IACpB,kDAAkD;IAClD,2DAA2D;EAC7D;EACA;IACE,oBAAoB;IACpB,0DAA0D;IAC1D,mDAAmD;EACrD;EACA;IACE,oBAAoB;IACpB,kDAAkD;IAClD,2DAA2D;EAC7D;EACA;IACE,oBAAoB;IACpB,2DAA2D;IAC3D,oDAAoD;EACtD;EACA;IACE,oBAAoB;IACpB,mDAAmD;IACnD,4DAA4D;EAC9D;EACA;IACE,oBAAoB;IACpB,2DAA2D;IAC3D,oDAAoD;EACtD;EACA;IACE,oBAAoB;IACpB,mDAAmD;IACnD,4DAA4D;EAC9D;EACA;IACE,oBAAoB;IACpB,2DAA2D;IAC3D,oDAAoD;EACtD;EACA;IACE,oBAAoB;IACpB,mDAAmD;IACnD,4DAA4D;EAC9D;EACA;IACE,oBAAoB;IACpB,2DAA2D;IAC3D,oDAAoD;EACtD;EACA;IACE,oBAAoB;IACpB,mDAAmD;IACnD,4DAA4D;EAC9D;EACA;IACE,oBAAoB;IACpB,2DAA2D;IAC3D,oDAAoD;EACtD;EACA;IACE,oBAAoB;IACpB,mDAAmD;IACnD,4DAA4D;EAC9D;EACA;IACE,oBAAoB;IACpB,2DAA2D;IAC3D,oDAAoD;EACtD;EACA;IACE,oBAAoB;IACpB,mDAAmD;IACnD,4DAA4D;EAC9D;EACA;IACE,oBAAoB;IACpB,2DAA2D;IAC3D,oDAAoD;EACtD;EACA;IACE,oBAAoB;IACpB,mDAAmD;IACnD,4DAA4D;EAC9D;EACA;IACE,oBAAoB;IACpB,2DAA2D;IAC3D,oDAAoD;EACtD;EACA;IACE,oBAAoB;IACpB,mDAAmD;IACnD,4DAA4D;EAC9D;EACA;IACE,oBAAoB;IACpB,2DAA2D;IAC3D,oDAAoD;EACtD;EACA;IACE,oBAAoB;IACpB,mDAAmD;IACnD,4DAA4D;EAC9D;EACA;IACE,oBAAoB;IACpB,2DAA2D;IAC3D,oDAAoD;EACtD;EACA;IACE,oBAAoB;IACpB,mDAAmD;IACnD,4DAA4D;EAC9D;EACA;IACE,oBAAoB;IACpB,yDAAyD;IACzD,kDAAkD;EACpD;EACA;IACE,oBAAoB;IACpB,iDAAiD;IACjD,0DAA0D;EAC5D;EACA;IACE,oBAAoB;IACpB,8DAA8D;IAC9D,uDAAuD;EACzD;EACA;IACE,oBAAoB;IACpB,sDAAsD;IACtD,+DAA+D;EACjE;EACA;IACE,oBAAoB;IACpB,8DAA8D;IAC9D,uDAAuD;EACzD;EACA;IACE,oBAAoB;IACpB,sDAAsD;IACtD,+DAA+D;EACjE;EACA;IACE,oBAAoB;IACpB,8DAA8D;IAC9D,uDAAuD;EACzD;EACA;IACE,oBAAoB;IACpB,sDAAsD;IACtD,+DAA+D;EACjE;EACA;IACE,oBAAoB;IACpB,8DAA8D;IAC9D,uDAAuD;EACzD;EACA;IACE,oBAAoB;IACpB,sDAAsD;IACtD,+DAA+D;EACjE;EACA;IACE,oBAAoB;IACpB,yDAAyD;IACzD,kDAAkD;EACpD;EACA;IACE,oBAAoB;IACpB,iDAAiD;IACjD,0DAA0D;EAC5D;EACA;IACE,oBAAoB;IACpB,+DAA+D;IAC/D,wDAAwD;EAC1D;EACA;IACE,oBAAoB;IACpB,uDAAuD;IACvD,gEAAgE;EAClE;EACA;IACE,oBAAoB;IACpB,+DAA+D;IAC/D,wDAAwD;EAC1D;EACA;IACE,oBAAoB;IACpB,uDAAuD;IACvD,gEAAgE;EAClE;EACA;IACE,oBAAoB;IACpB,yDAAyD;IACzD,kDAAkD;EACpD;EACA;IACE,oBAAoB;IACpB,iDAAiD;IACjD,0DAA0D;EAC5D;EACA;IACE,oBAAoB;IACpB,yDAAyD;IACzD,kDAAkD;EACpD;EACA;IACE,oBAAoB;IACpB,iDAAiD;IACjD,0DAA0D;EAC5D;EACA;IACE,oBAAoB;IACpB,yDAAyD;IACzD,kDAAkD;EACpD;EACA;IACE,oBAAoB;IACpB,iDAAiD;IACjD,0DAA0D;EAC5D;EACA;IACE,oBAAoB;IACpB,yDAAyD;IACzD,kDAAkD;EACpD;EACA;IACE,oBAAoB;IACpB,iDAAiD;IACjD,0DAA0D;EAC5D;EACA;IACE,oBAAoB;IACpB,yDAAyD;IACzD,kDAAkD;EACpD;EACA;IACE,oBAAoB;IACpB,iDAAiD;IACjD,0DAA0D;EAC5D;EACA;IACE,oBAAoB;IACpB,yDAAyD;IACzD,kDAAkD;EACpD;EACA;IACE,oBAAoB;IACpB,iDAAiD;IACjD,0DAA0D;EAC5D;EACA;IACE,oBAAoB;IACpB,yDAAyD;IACzD,kDAAkD;EACpD;EACA;IACE,oBAAoB;IACpB,iDAAiD;IACjD,0DAA0D;EAC5D;EACA;IACE,oBAAoB;IACpB,+DAA+D;IAC/D,wDAAwD;EAC1D;EACA;IACE,oBAAoB;IACpB,uDAAuD;IACvD,gEAAgE;EAClE;EACA;IACE,oBAAoB;IACpB,+DAA+D;IAC/D,wDAAwD;EAC1D;EACA;IACE,oBAAoB;IACpB,uDAAuD;IACvD,gEAAgE;EAClE;EACA;IACE,oBAAoB;IACpB,yDAAyD;IACzD,kDAAkD;EACpD;EACA;IACE,oBAAoB;IACpB,iDAAiD;IACjD,0DAA0D;EAC5D;EACA;IACE,oBAAoB;IACpB,+DAA+D;IAC/D,wDAAwD;EAC1D;EACA;IACE,oBAAoB;IACpB,uDAAuD;IACvD,gEAAgE;EAClE;EACA;IACE,oBAAoB;IACpB,+DAA+D;IAC/D,wDAAwD;EAC1D;EACA;IACE,oBAAoB;IACpB,uDAAuD;IACvD,gEAAgE;EAClE;EACA;IACE,oBAAoB;IACpB,8DAA8D;IAC9D,uDAAuD;EACzD;EACA;IACE,oBAAoB;IACpB,sDAAsD;IACtD,+DAA+D;EACjE;EACA;IACE,oBAAoB;IACpB,+DAA+D;IAC/D,wDAAwD;EAC1D;EACA;IACE,oBAAoB;IACpB,uDAAuD;IACvD,gEAAgE;EAClE;EACA;IACE,oBAAoB;IACpB,yDAAyD;IACzD,kDAAkD;EACpD;EACA;IACE,oBAAoB;IACpB,iDAAiD;IACjD,0DAA0D;EAC5D;EACA;IACE,oBAAoB;IACpB,+DAA+D;IAC/D,wDAAwD;EAC1D;EACA;IACE,oBAAoB;IACpB,uDAAuD;IACvD,gEAAgE;EAClE;EACA;IACE,oBAAoB;IACpB,+DAA+D;IAC/D,wDAAwD;EAC1D;EACA;IACE,oBAAoB;IACpB,uDAAuD;IACvD,gEAAgE;EAClE;EACA;IACE,oBAAoB;IACpB,yDAAyD;IACzD,kDAAkD;EACpD;EACA;IACE,oBAAoB;IACpB,iDAAiD;IACjD,0DAA0D;EAC5D;EACA;IACE,oBAAoB;IACpB,+DAA+D;IAC/D,wDAAwD;EAC1D;EACA;IACE,oBAAoB;IACpB,uDAAuD;IACvD,gEAAgE;EAClE;EACA;IACE,oBAAoB;IACpB,+DAA+D;IAC/D,wDAAwD;EAC1D;EACA;IACE,oBAAoB;IACpB,uDAAuD;IACvD,gEAAgE;EAClE;EACA;IACE,oBAAoB;IACpB,yDAAyD;IACzD,kDAAkD;EACpD;EACA;IACE,oBAAoB;IACpB,iDAAiD;IACjD,0DAA0D;EAC5D;EACA;IACE,oBAAoB;IACpB,+DAA+D;IAC/D,wDAAwD;EAC1D;EACA;IACE,oBAAoB;IACpB,uDAAuD;IACvD,gEAAgE;EAClE;EACA;IACE,oBAAoB;IACpB,+DAA+D;IAC/D,wDAAwD;EAC1D;EACA;IACE,oBAAoB;IACpB,uDAAuD;IACvD,gEAAgE;EAClE;EACA;IACE,oBAAoB;IACpB,0DAA0D;IAC1D,mDAAmD;EACrD;EACA;IACE,oBAAoB;IACpB,kDAAkD;IAClD,2DAA2D;EAC7D;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,qBAAqB;IACrB,+DAA+D;IAC/D,wDAAwD;EAC1D;EACA;IACE,qBAAqB;IACrB,uDAAuD;IACvD,gEAAgE;EAClE;EACA;IACE,qBAAqB;IACrB,+DAA+D;IAC/D,wDAAwD;EAC1D;EACA;IACE,qBAAqB;IACrB,uDAAuD;IACvD,gEAAgE;EAClE;EACA;IACE,qBAAqB;IACrB,+DAA+D;IAC/D,wDAAwD;EAC1D;EACA;IACE,qBAAqB;IACrB,uDAAuD;IACvD,gEAAgE;EAClE;EACA;IACE,qBAAqB;IACrB,+DAA+D;IAC/D,wDAAwD;EAC1D;EACA;IACE,qBAAqB;IACrB,uDAAuD;IACvD,gEAAgE;EAClE;EACA;IACE,qBAAqB;IACrB,+DAA+D;IAC/D,wDAAwD;EAC1D;EACA;IACE,qBAAqB;IACrB,uDAAuD;IACvD,gEAAgE;EAClE;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,kDAAkD;EACpD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,oDAAoD;EACtD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,oDAAoD;EACtD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,oDAAoD;EACtD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,oDAAoD;EACtD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,UAAU;IACV,YAAY;IACZ,gBAAgB;IAChB,sBAAsB;IACtB,mBAAmB;IACnB,eAAe;EACjB;EACA;IACE,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,UAAU;IACV,SAAS;IACT,iBAAiB;IACjB,UAAU;IACV,mBAAmB;EACrB;EACA;IACE,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,UAAU;IACV,YAAY;IACZ,gBAAgB;IAChB,sBAAsB;IACtB,mBAAmB;IACnB,eAAe;EACjB;EACA;IACE,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,UAAU;IACV,SAAS;IACT,iBAAiB;IACjB,UAAU;IACV,mBAAmB;EACrB;EACA;IAGE,gBAAgB;EAClB;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,6BAA6B;IAC7B,qBAAqB;EACvB;EACA;IACE,8BAA8B;EAChC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,kDAAkD;EACpD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,oDAAoD;EACtD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,oDAAoD;EACtD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,oDAAoD;EACtD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,oDAAoD;EACtD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,8BAA8B;EAChC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,kDAAkD;EACpD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,oDAAoD;EACtD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,oDAAoD;EACtD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,oDAAoD;EACtD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,oDAAoD;EACtD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,8BAA8B;EAChC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,kDAAkD;EACpD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,oDAAoD;EACtD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,oDAAoD;EACtD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,oDAAoD;EACtD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,oDAAoD;EACtD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,8BAA8B;EAChC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,kDAAkD;EACpD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,oDAAoD;EACtD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,oDAAoD;EACtD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,oDAAoD;EACtD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,oDAAoD;EACtD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,8BAA8B;EAChC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,kDAAkD;EACpD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,oDAAoD;EACtD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,oDAAoD;EACtD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,oDAAoD;EACtD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,oDAAoD;EACtD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,8BAA8B;EAChC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,kDAAkD;EACpD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,oDAAoD;EACtD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,oDAAoD;EACtD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,oDAAoD;EACtD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,oDAAoD;EACtD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,sDAAsD;EACxD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sEAAsE;EACxE;EACA;IACE,4EAA4E;EAC9E;EACA;IACE,wEAAwE;EAC1E;EACA;IACE,+EAA+E;EACjF;EACA;IACE,yEAAyE;EAC3E;EACA;IACE,8EAA8E;EAChF;EACA;IACE,uEAAuE;EACzE;EACA;IACE,2EAA2E;EAC7E;EACA;IACE,mCAAmC;IACnC,oGAAoG;EACtG;EACA;IACE,kCAAkC;IAClC,8FAA8F;EAChG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,8FAA8F;EAChG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,iGAAiG;EACnG;EACA;IACE,8BAA8B;IAC9B,iGAAiG;EACnG;EACA;IACE,8BAA8B;IAC9B,iGAAiG;EACnG;EACA;IACE,8BAA8B;IAC9B,iGAAiG;EACnG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,mGAAmG;EACrG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,iGAAiG;EACnG;EACA;IACE,8BAA8B;IAC9B,iGAAiG;EACnG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,mGAAmG;EACrG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,iGAAiG;EACnG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,mGAAmG;EACrG;EACA;IACE,8BAA8B;IAC9B,mGAAmG;EACrG;EACA;IACE,8BAA8B;IAC9B,iGAAiG;EACnG;EACA;IACE,8BAA8B;IAC9B,iGAAiG;EACnG;EACA;IACE,8BAA8B;IAC9B,gGAAgG;EAClG;EACA;IACE,8BAA8B;IAC9B,gGAAgG;EAClG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,mGAAmG;EACrG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,gGAAgG;EAClG;EACA;IACE,8BAA8B;IAC9B,gGAAgG;EAClG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,mGAAmG;EACrG;EACA;IACE,8BAA8B;IAC9B,mGAAmG;EACrG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,mGAAmG;EACrG;EACA;IACE,8BAA8B;IAC9B,mGAAmG;EACrG;EACA;IACE,8BAA8B;IAC9B,mGAAmG;EACrG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,mGAAmG;EACrG;EACA;IACE,8BAA8B;IAC9B,mGAAmG;EACrG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,iGAAiG;EACnG;EACA;IACE,8BAA8B;IAC9B,iGAAiG;EACnG;EACA;IACE,8BAA8B;IAC9B,iGAAiG;EACnG;EACA;IACE,kCAAkC;IAClC,+HAA+H;EACjI;EACA;IACE,iCAAiC;IACjC,yHAAyH;EAC3H;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,yHAAyH;EAC3H;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,4HAA4H;EAC9H;EACA;IACE,6BAA6B;IAC7B,4HAA4H;EAC9H;EACA;IACE,6BAA6B;IAC7B,4HAA4H;EAC9H;EACA;IACE,6BAA6B;IAC7B,4HAA4H;EAC9H;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,8HAA8H;EAChI;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,4HAA4H;EAC9H;EACA;IACE,6BAA6B;IAC7B,4HAA4H;EAC9H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,8HAA8H;EAChI;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,4HAA4H;EAC9H;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,8HAA8H;EAChI;EACA;IACE,6BAA6B;IAC7B,8HAA8H;EAChI;EACA;IACE,6BAA6B;IAC7B,4HAA4H;EAC9H;EACA;IACE,6BAA6B;IAC7B,4HAA4H;EAC9H;EACA;IACE,6BAA6B;IAC7B,2HAA2H;EAC7H;EACA;IACE,6BAA6B;IAC7B,2HAA2H;EAC7H;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,8HAA8H;EAChI;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,2HAA2H;EAC7H;EACA;IACE,6BAA6B;IAC7B,2HAA2H;EAC7H;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,8HAA8H;EAChI;EACA;IACE,6BAA6B;IAC7B,8HAA8H;EAChI;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,8HAA8H;EAChI;EACA;IACE,6BAA6B;IAC7B,8HAA8H;EAChI;EACA;IACE,6BAA6B;IAC7B,8HAA8H;EAChI;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,8HAA8H;EAChI;EACA;IACE,6BAA6B;IAC7B,8HAA8H;EAChI;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,4HAA4H;EAC9H;EACA;IACE,6BAA6B;IAC7B,4HAA4H;EAC9H;EACA;IACE,6BAA6B;IAC7B,4HAA4H;EAC9H;EACA;IACE,iCAAiC;EACnC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,mCAAmC;IACnC,oGAAoG;EACtG;EACA;IACE,kCAAkC;IAClC,8FAA8F;EAChG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,8FAA8F;EAChG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,iGAAiG;EACnG;EACA;IACE,8BAA8B;IAC9B,iGAAiG;EACnG;EACA;IACE,8BAA8B;IAC9B,iGAAiG;EACnG;EACA;IACE,8BAA8B;IAC9B,iGAAiG;EACnG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,mGAAmG;EACrG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,iGAAiG;EACnG;EACA;IACE,8BAA8B;IAC9B,iGAAiG;EACnG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,mGAAmG;EACrG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,iGAAiG;EACnG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,mGAAmG;EACrG;EACA;IACE,8BAA8B;IAC9B,mGAAmG;EACrG;EACA;IACE,8BAA8B;IAC9B,iGAAiG;EACnG;EACA;IACE,8BAA8B;IAC9B,iGAAiG;EACnG;EACA;IACE,8BAA8B;IAC9B,gGAAgG;EAClG;EACA;IACE,8BAA8B;IAC9B,gGAAgG;EAClG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,mGAAmG;EACrG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,gGAAgG;EAClG;EACA;IACE,8BAA8B;IAC9B,gGAAgG;EAClG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,mGAAmG;EACrG;EACA;IACE,8BAA8B;IAC9B,mGAAmG;EACrG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,mGAAmG;EACrG;EACA;IACE,8BAA8B;IAC9B,mGAAmG;EACrG;EACA;IACE,8BAA8B;IAC9B,mGAAmG;EACrG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,mGAAmG;EACrG;EACA;IACE,8BAA8B;IAC9B,mGAAmG;EACrG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,iGAAiG;EACnG;EACA;IACE,8BAA8B;IAC9B,iGAAiG;EACnG;EACA;IACE,8BAA8B;IAC9B,iGAAiG;EACnG;EACA;IACE,kCAAkC;IAClC,+HAA+H;EACjI;EACA;IACE,iCAAiC;IACjC,yHAAyH;EAC3H;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,yHAAyH;EAC3H;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,4HAA4H;EAC9H;EACA;IACE,6BAA6B;IAC7B,4HAA4H;EAC9H;EACA;IACE,6BAA6B;IAC7B,4HAA4H;EAC9H;EACA;IACE,6BAA6B;IAC7B,4HAA4H;EAC9H;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,8HAA8H;EAChI;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,4HAA4H;EAC9H;EACA;IACE,6BAA6B;IAC7B,4HAA4H;EAC9H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,8HAA8H;EAChI;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,4HAA4H;EAC9H;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,8HAA8H;EAChI;EACA;IACE,6BAA6B;IAC7B,8HAA8H;EAChI;EACA;IACE,6BAA6B;IAC7B,4HAA4H;EAC9H;EACA;IACE,6BAA6B;IAC7B,4HAA4H;EAC9H;EACA;IACE,6BAA6B;IAC7B,2HAA2H;EAC7H;EACA;IACE,6BAA6B;IAC7B,2HAA2H;EAC7H;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,8HAA8H;EAChI;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,2HAA2H;EAC7H;EACA;IACE,6BAA6B;IAC7B,2HAA2H;EAC7H;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,8HAA8H;EAChI;EACA;IACE,6BAA6B;IAC7B,8HAA8H;EAChI;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,8HAA8H;EAChI;EACA;IACE,6BAA6B;IAC7B,8HAA8H;EAChI;EACA;IACE,6BAA6B;IAC7B,8HAA8H;EAChI;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,8HAA8H;EAChI;EACA;IACE,6BAA6B;IAC7B,8HAA8H;EAChI;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,4HAA4H;EAC9H;EACA;IACE,6BAA6B;IAC7B,4HAA4H;EAC9H;EACA;IACE,6BAA6B;IAC7B,4HAA4H;EAC9H;EACA;IACE,iCAAiC;EACnC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,mCAAmC;IACnC,oGAAoG;EACtG;EACA;IACE,kCAAkC;IAClC,8FAA8F;EAChG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,8FAA8F;EAChG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,iGAAiG;EACnG;EACA;IACE,8BAA8B;IAC9B,iGAAiG;EACnG;EACA;IACE,8BAA8B;IAC9B,iGAAiG;EACnG;EACA;IACE,8BAA8B;IAC9B,iGAAiG;EACnG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,mGAAmG;EACrG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,iGAAiG;EACnG;EACA;IACE,8BAA8B;IAC9B,iGAAiG;EACnG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,mGAAmG;EACrG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,iGAAiG;EACnG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,mGAAmG;EACrG;EACA;IACE,8BAA8B;IAC9B,mGAAmG;EACrG;EACA;IACE,8BAA8B;IAC9B,iGAAiG;EACnG;EACA;IACE,8BAA8B;IAC9B,iGAAiG;EACnG;EACA;IACE,8BAA8B;IAC9B,gGAAgG;EAClG;EACA;IACE,8BAA8B;IAC9B,gGAAgG;EAClG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,mGAAmG;EACrG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,gGAAgG;EAClG;EACA;IACE,8BAA8B;IAC9B,gGAAgG;EAClG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,mGAAmG;EACrG;EACA;IACE,8BAA8B;IAC9B,mGAAmG;EACrG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,mGAAmG;EACrG;EACA;IACE,8BAA8B;IAC9B,mGAAmG;EACrG;EACA;IACE,8BAA8B;IAC9B,mGAAmG;EACrG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,mGAAmG;EACrG;EACA;IACE,8BAA8B;IAC9B,mGAAmG;EACrG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,oGAAoG;EACtG;EACA;IACE,8BAA8B;IAC9B,kGAAkG;EACpG;EACA;IACE,8BAA8B;IAC9B,iGAAiG;EACnG;EACA;IACE,8BAA8B;IAC9B,iGAAiG;EACnG;EACA;IACE,8BAA8B;IAC9B,iGAAiG;EACnG;EACA;IACE,kCAAkC;IAClC,+HAA+H;EACjI;EACA;IACE,iCAAiC;IACjC,yHAAyH;EAC3H;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,yHAAyH;EAC3H;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,4HAA4H;EAC9H;EACA;IACE,6BAA6B;IAC7B,4HAA4H;EAC9H;EACA;IACE,6BAA6B;IAC7B,4HAA4H;EAC9H;EACA;IACE,6BAA6B;IAC7B,4HAA4H;EAC9H;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,8HAA8H;EAChI;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,4HAA4H;EAC9H;EACA;IACE,6BAA6B;IAC7B,4HAA4H;EAC9H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,8HAA8H;EAChI;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,4HAA4H;EAC9H;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,8HAA8H;EAChI;EACA;IACE,6BAA6B;IAC7B,8HAA8H;EAChI;EACA;IACE,6BAA6B;IAC7B,4HAA4H;EAC9H;EACA;IACE,6BAA6B;IAC7B,4HAA4H;EAC9H;EACA;IACE,6BAA6B;IAC7B,2HAA2H;EAC7H;EACA;IACE,6BAA6B;IAC7B,2HAA2H;EAC7H;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,8HAA8H;EAChI;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,2HAA2H;EAC7H;EACA;IACE,6BAA6B;IAC7B,2HAA2H;EAC7H;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,8HAA8H;EAChI;EACA;IACE,6BAA6B;IAC7B,8HAA8H;EAChI;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,8HAA8H;EAChI;EACA;IACE,6BAA6B;IAC7B,8HAA8H;EAChI;EACA;IACE,6BAA6B;IAC7B,8HAA8H;EAChI;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,8HAA8H;EAChI;EACA;IACE,6BAA6B;IAC7B,8HAA8H;EAChI;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,+HAA+H;EACjI;EACA;IACE,6BAA6B;IAC7B,6HAA6H;EAC/H;EACA;IACE,6BAA6B;IAC7B,4HAA4H;EAC9H;EACA;IACE,6BAA6B;IAC7B,4HAA4H;EAC9H;EACA;IACE,6BAA6B;IAC7B,4HAA4H;EAC9H;EACA;IACE,iCAAiC;EACnC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,eAAe;EACjB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,eAAe;EACjB;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,gCAAgC;EAClC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,iCAAiC;EACnC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,qBAAqB;EACvB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,kDAAkD;EACpD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,oDAAoD;EACtD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,oDAAoD;EACtD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,oDAAoD;EACtD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,oDAAoD;EACtD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,kDAAkD;EACpD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,oDAAoD;EACtD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,oDAAoD;EACtD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,oDAAoD;EACtD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,oDAAoD;EACtD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,kDAAkD;EACpD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,oDAAoD;EACtD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,oDAAoD;EACtD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,oDAAoD;EACtD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,oDAAoD;EACtD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,kDAAkD;EACpD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,oDAAoD;EACtD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,oDAAoD;EACtD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,oDAAoD;EACtD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,oDAAoD;EACtD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,kDAAkD;EACpD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,oDAAoD;EACtD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,oDAAoD;EACtD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,oDAAoD;EACtD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,oDAAoD;EACtD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,kDAAkD;EACpD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,oDAAoD;EACtD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,oDAAoD;EACtD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,oDAAoD;EACtD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,oDAAoD;EACtD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wDAAwD;EAC1D;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,mBAAmB;EACrB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,yBAAyB;IACzB,0BAA0B;EAC5B;EACA;IACE,0BAA0B;IAC1B,6BAA6B;EAC/B;EACA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;EACA;IACE,yBAAyB;IACzB,4BAA4B;EAC9B;EACA;IACE,gCAAgC;IAChC,iCAAiC;EACnC;EACA;IACE,iCAAiC;IACjC,oCAAoC;EACtC;EACA;IACE,oCAAoC;IACpC,mCAAmC;EACrC;EACA;IACE,gCAAgC;IAChC,mCAAmC;EACrC;EACA;IACE,+BAA+B;IAC/B,gCAAgC;EAClC;EACA;IACE,gCAAgC;IAChC,mCAAmC;EACrC;EACA;IACE,mCAAmC;IACnC,kCAAkC;EACpC;EACA;IACE,+BAA+B;IAC/B,kCAAkC;EACpC;EACA;IACE,gCAAgC;IAChC,iCAAiC;EACnC;EACA;IACE,iCAAiC;IACjC,oCAAoC;EACtC;EACA;IACE,oCAAoC;IACpC,mCAAmC;EACrC;EACA;IACE,gCAAgC;IAChC,mCAAmC;EACrC;EACA;IACE,8BAA8B;IAC9B,+BAA+B;EACjC;EACA;IACE,+BAA+B;IAC/B,kCAAkC;EACpC;EACA;IACE,kCAAkC;IAClC,iCAAiC;EACnC;EACA;IACE,8BAA8B;IAC9B,iCAAiC;EACnC;EACA;IACE,+BAA+B;IAC/B,gCAAgC;EAClC;EACA;IACE,gCAAgC;IAChC,mCAAmC;EACrC;EACA;IACE,mCAAmC;IACnC,kCAAkC;EACpC;EACA;IACE,+BAA+B;IAC/B,kCAAkC;EACpC;EACA;IACE,4BAA4B;IAC5B,6BAA6B;EAC/B;EACA;IACE,6BAA6B;IAC7B,gCAAgC;EAClC;EACA;IACE,gCAAgC;IAChC,+BAA+B;EACjC;EACA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;EACA;IACE,8BAA8B;IAC9B,+BAA+B;EACjC;EACA;IACE,+BAA+B;IAC/B,kCAAkC;EACpC;EACA;IACE,kCAAkC;IAClC,iCAAiC;EACnC;EACA;IACE,8BAA8B;IAC9B,iCAAiC;EACnC;EACA;IACE,8BAA8B;IAC9B,+BAA+B;EACjC;EACA;IACE,+BAA+B;IAC/B,kCAAkC;EACpC;EACA;IACE,kCAAkC;IAClC,iCAAiC;EACnC;EACA;IACE,8BAA8B;IAC9B,iCAAiC;EACnC;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,gCAAgC;EAClC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,gCAAgC;EAClC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,YAAY;EACd;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,mBAAmB;EACrB;EACA;IACE,cAAc;EAChB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;EACf;EACA;IACE,oBAAoB;EACtB;EACA;IACE,cAAc;EAChB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,aAAa;EACf;EACA;IACE,oBAAoB;EACtB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,aAAa;EACf;EACA;IACE,mBAAmB;EACrB;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,8BAA8B;EAChC;EACA;IACE,eAAe;EACjB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,gBAAgB;EAClB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,8BAA8B;EAChC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,SAAY;EACd;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA;IACE,UAAU;EACZ;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA;IACE,QAAQ;EACV;EACA;IACE,QAAQ;EACV;EACA;IACE,QAAQ;EACV;EACA;IACE,QAAQ;EACV;EACA;IACE,QAAQ;EACV;EACA;IACE,QAAQ;EACV;EACA;IACE,QAAQ;EACV;EACA;IACE,QAAQ;EACV;EACA;IACE,QAAQ;EACV;EACA;IACE,SAAS;EACX;EACA;IACE,SAAS;EACX;EACA;IACE,SAAS;EACX;EACA;IACE,YAAY;EACd;EACA;IACE,WAAW;EACb;EACA;IACE,QAAQ;EACV;EACA;IACE,YAAY;EACd;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;IACX,cAAc;IACd,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,YAAY;EACd;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,6MAA6M;EAC/M;EACA;IACE,8DAA8D;EAChE;EACA;IACE,iFAAiF;EACnF;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,SAAS;EACX;EACA;IACE,eAAe;EACjB;EACA;IACE,cAAc;EAChB;EACA;IACE,eAAe;EACjB;EACA;IACE,YAAY;EACd;EACA;IACE,eAAe;EACjB;EACA;IACE,cAAc;EAChB;EACA;IACE,eAAe;EACjB;EACA;IACE,YAAY;EACd;EACA;IACE,eAAe;EACjB;EACA;IACE,cAAc;EAChB;EACA;IACE,eAAe;EACjB;EACA;IACE,YAAY;EACd;EACA;IACE,eAAe;EACjB;EACA;IACE,cAAc;EAChB;EACA;IACE,eAAe;EACjB;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,YAAY;EACd;EACA;IACE,WAAW;EACb;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,WAAW;EACb;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,WAAW;EACb;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,WAAW;EACb;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,WAAW;EACb;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,WAAW;EACb;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,YAAY;EACd;EACA;IACE,aAAa;EACf;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,eAAe;EACjB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,cAAc;EAChB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,cAAc;EAChB;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,SAAS;EACX;EACA;IACE,eAAe;EACjB;EACA;IACE,cAAc;EAChB;EACA;IACE,eAAe;EACjB;EACA;IACE,YAAY;EACd;EACA;IACE,eAAe;EACjB;EACA;IACE,cAAc;EAChB;EACA;IACE,eAAe;EACjB;EACA;IACE,YAAY;EACd;EACA;IACE,eAAe;EACjB;EACA;IACE,cAAc;EAChB;EACA;IACE,eAAe;EACjB;EACA;IACE,YAAY;EACd;EACA;IACE,eAAe;EACjB;EACA;IACE,cAAc;EAChB;EACA;IACE,eAAe;EACjB;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,YAAY;EACd;EACA;IACE,WAAW;EACb;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,WAAW;EACb;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,WAAW;EACb;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,WAAW;EACb;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,WAAW;EACb;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,WAAW;EACb;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,YAAY;EACd;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,aAAa;EACf;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,aAAa;EACf;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,aAAa;EACf;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA;IACE,YAAY;EACd;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,YAAY;EACd;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,YAAY;EACd;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,YAAY;EACd;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,YAAY;EACd;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,YAAY;EACd;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;IACb,gBAAgB;EAClB;EACA;IACE,cAAc;IACd,eAAe;EACjB;EACA;IACE,mBAAmB;IACnB,sBAAsB;EACxB;EACA;IACE,oBAAoB;IACpB,qBAAqB;EACvB;EACA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;EACA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;EACA;IACE,mBAAmB;IACnB,sBAAsB;EACxB;EACA;IACE,oBAAoB;IACpB,qBAAqB;EACvB;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,mBAAmB;IACnB,sBAAsB;EACxB;EACA;IACE,oBAAoB;IACpB,qBAAqB;EACvB;EACA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;EACA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;EACA;IACE,mBAAmB;IACnB,sBAAsB;EACxB;EACA;IACE,oBAAoB;IACpB,qBAAqB;EACvB;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,mBAAmB;IACnB,sBAAsB;EACxB;EACA;IACE,oBAAoB;IACpB,qBAAqB;EACvB;EACA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;EACA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;EACA;IACE,mBAAmB;IACnB,sBAAsB;EACxB;EACA;IACE,oBAAoB;IACpB,qBAAqB;EACvB;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,mBAAmB;IACnB,sBAAsB;EACxB;EACA;IACE,oBAAoB;IACpB,qBAAqB;EACvB;EACA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;EACA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;EACA;IACE,mBAAmB;IACnB,sBAAsB;EACxB;EACA;IACE,oBAAoB;IACpB,qBAAqB;EACvB;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE,oBAAoB;IACpB,uBAAuB;EACzB;EACA;IACE,qBAAqB;IACrB,sBAAsB;EACxB;EACA;IACE,oBAAoB;IACpB,uBAAuB;EACzB;EACA;IACE,qBAAqB;IACrB,sBAAsB;EACxB;EACA;IACE,oBAAoB;IACpB,uBAAuB;EACzB;EACA;IACE,qBAAqB;IACrB,sBAAsB;EACxB;EACA;IACE,oBAAoB;IACpB,uBAAuB;EACzB;EACA;IACE,qBAAqB;IACrB,sBAAsB;EACxB;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE,sBAAsB;IACtB,yBAAyB;EAC3B;EACA;IACE,uBAAuB;IACvB,wBAAwB;EAC1B;EACA;IACE,sBAAsB;IACtB,yBAAyB;EAC3B;EACA;IACE,uBAAuB;IACvB,wBAAwB;EAC1B;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE,sBAAsB;IACtB,yBAAyB;EAC3B;EACA;IACE,uBAAuB;IACvB,wBAAwB;EAC1B;EACA;IACE,sBAAsB;IACtB,yBAAyB;EAC3B;EACA;IACE,uBAAuB;IACvB,wBAAwB;EAC1B;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE,sBAAsB;IACtB,yBAAyB;EAC3B;EACA;IACE,uBAAuB;IACvB,wBAAwB;EAC1B;EACA;IACE,sBAAsB;IACtB,yBAAyB;EAC3B;EACA;IACE,uBAAuB;IACvB,wBAAwB;EAC1B;EACA;IACE,qBAAqB;IACrB,wBAAwB;EAC1B;EACA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,sBAAsB;IACtB,yBAAyB;EAC3B;EACA;IACE,uBAAuB;IACvB,wBAAwB;EAC1B;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE,sBAAsB;IACtB,yBAAyB;EAC3B;EACA;IACE,uBAAuB;IACvB,wBAAwB;EAC1B;EACA;IACE,sBAAsB;IACtB,yBAAyB;EAC3B;EACA;IACE,uBAAuB;IACvB,wBAAwB;EAC1B;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE,sBAAsB;IACtB,yBAAyB;EAC3B;EACA;IACE,uBAAuB;IACvB,wBAAwB;EAC1B;EACA;IACE,sBAAsB;IACtB,yBAAyB;EAC3B;EACA;IACE,uBAAuB;IACvB,wBAAwB;EAC1B;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE,sBAAsB;IACtB,yBAAyB;EAC3B;EACA;IACE,uBAAuB;IACvB,wBAAwB;EAC1B;EACA;IACE,sBAAsB;IACtB,yBAAyB;EAC3B;EACA;IACE,uBAAuB;IACvB,wBAAwB;EAC1B;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,oBAAoB;IACpB,uBAAuB;EACzB;EACA;IACE,qBAAqB;IACrB,sBAAsB;EACxB;EACA;IACE,mBAAmB;IACnB,sBAAsB;EACxB;EACA;IACE,oBAAoB;IACpB,qBAAqB;EACvB;EACA;IACE,oBAAoB;IACpB,uBAAuB;EACzB;EACA;IACE,qBAAqB;IACrB,sBAAsB;EACxB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,oBAAoB;IACpB,uBAAuB;EACzB;EACA;IACE,qBAAqB;IACrB,sBAAsB;EACxB;EACA;IACE,mBAAmB;IACnB,sBAAsB;EACxB;EACA;IACE,oBAAoB;IACpB,qBAAqB;EACvB;EACA;IACE,oBAAoB;IACpB,uBAAuB;EACzB;EACA;IACE,qBAAqB;IACrB,sBAAsB;EACxB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,oBAAoB;IACpB,uBAAuB;EACzB;EACA;IACE,qBAAqB;IACrB,sBAAsB;EACxB;EACA;IACE,mBAAmB;IACnB,sBAAsB;EACxB;EACA;IACE,oBAAoB;IACpB,qBAAqB;EACvB;EACA;IACE,oBAAoB;IACpB,uBAAuB;EACzB;EACA;IACE,qBAAqB;IACrB,sBAAsB;EACxB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,oBAAoB;IACpB,uBAAuB;EACzB;EACA;IACE,qBAAqB;IACrB,sBAAsB;EACxB;EACA;IACE,mBAAmB;IACnB,sBAAsB;EACxB;EACA;IACE,oBAAoB;IACpB,qBAAqB;EACvB;EACA;IACE,oBAAoB;IACpB,uBAAuB;EACzB;EACA;IACE,qBAAqB;IACrB,sBAAsB;EACxB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;EACA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;EACA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;EACA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;EACA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;EACA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;EACA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;EACA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;EACA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;EACA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;EACA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,qBAAqB;IACrB,wBAAwB;EAC1B;EACA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,qBAAqB;IACrB,wBAAwB;EAC1B;EACA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,qBAAqB;IACrB,wBAAwB;EAC1B;EACA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,qBAAqB;IACrB,wBAAwB;EAC1B;EACA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,sBAAsB;IACtB,yBAAyB;EAC3B;EACA;IACE,uBAAuB;IACvB,wBAAwB;EAC1B;EACA;IACE,sBAAsB;IACtB,yBAAyB;EAC3B;EACA;IACE,uBAAuB;IACvB,wBAAwB;EAC1B;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,sBAAsB;IACtB,yBAAyB;EAC3B;EACA;IACE,uBAAuB;IACvB,wBAAwB;EAC1B;EACA;IACE,sBAAsB;IACtB,yBAAyB;EAC3B;EACA;IACE,uBAAuB;IACvB,wBAAwB;EAC1B;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,sBAAsB;IACtB,yBAAyB;EAC3B;EACA;IACE,uBAAuB;IACvB,wBAAwB;EAC1B;EACA;IACE,sBAAsB;IACtB,yBAAyB;EAC3B;EACA;IACE,uBAAuB;IACvB,wBAAwB;EAC1B;EACA;IACE,qBAAqB;IACrB,wBAAwB;EAC1B;EACA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,sBAAsB;IACtB,yBAAyB;EAC3B;EACA;IACE,uBAAuB;IACvB,wBAAwB;EAC1B;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,sBAAsB;IACtB,yBAAyB;EAC3B;EACA;IACE,uBAAuB;IACvB,wBAAwB;EAC1B;EACA;IACE,sBAAsB;IACtB,yBAAyB;EAC3B;EACA;IACE,uBAAuB;IACvB,wBAAwB;EAC1B;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,sBAAsB;IACtB,yBAAyB;EAC3B;EACA;IACE,uBAAuB;IACvB,wBAAwB;EAC1B;EACA;IACE,sBAAsB;IACtB,yBAAyB;EAC3B;EACA;IACE,uBAAuB;IACvB,wBAAwB;EAC1B;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,sBAAsB;IACtB,yBAAyB;EAC3B;EACA;IACE,uBAAuB;IACvB,wBAAwB;EAC1B;EACA;IACE,sBAAsB;IACtB,yBAAyB;EAC3B;EACA;IACE,uBAAuB;IACvB,wBAAwB;EAC1B;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,aAAa;EACf;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,cAAc;EAChB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,aAAa;EACf;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,eAAe;EACjB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,eAAe;EACjB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,eAAe;EACjB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,eAAe;EACjB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,eAAe;EACjB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IAEE,sBAAsB;EACxB;EACA;IAEE,sBAAsB;EACxB;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,aAAa;EACf;EACA;IACE,gBAAgB;EAClB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,YAAY;EACd;EACA;IACE,eAAe;EACjB;EACA;IAEE,sBAAsB;EACxB;EACA;IAEE,sBAAsB;EACxB;EACA;IAEE,mBAAmB;EACrB;EACA;IAEE,iBAAiB;EACnB;EACA;IAEE,gBAAgB;EAClB;EACA;IAEE,gBAAgB;EAClB;EACA;IAEE,sBAAsB;EACxB;EACA;IAEE,uBAAuB;EACzB;EACA;IAEE,uBAAuB;EACzB;EACA;IAEE,qBAAqB;EACvB;EACA;IAEE,4BAA4B;EAC9B;EACA;IAEE,yBAAyB;EAC3B;EACA;IAEE,sBAAsB;EACxB;EACA;IAEE,6BAA6B;EAC/B;EACA;IAEE,0BAA0B;EAC5B;EACA;IAEE,oBAAoB;EACtB;EACA;IACE,UAAU;EACZ;EACA;IACE,aAAa;EACf;EACA;IACE,YAAY;EACd;EACA;IACE,aAAa;EACf;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,aAAa;EACf;EACA;IACE,YAAY;EACd;EACA;IACE,aAAa;EACf;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,aAAa;EACf;EACA;IACE,YAAY;EACd;EACA;IACE,aAAa;EACf;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,aAAa;EACf;EACA;IACE,YAAY;EACd;EACA;IACE,aAAa;EACf;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,aAAa;EACf;EACA;IACE,YAAY;EACd;EACA;IACE,aAAa;EACf;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,aAAa;EACf;EACA;IACE,YAAY;EACd;EACA;IACE,aAAa;EACf;EACA;IACE,UAAU;EACZ;EACA;IACE,8BAA8B;IAC9B,mBAAmB;EACrB;EACA;IACE,yBAAyB;IACzB,mBAAmB;EACrB;EACA;IACE,yBAAyB;IACzB,mBAAmB;EACrB;EACA;IACE,8BAA8B;IAC9B,mBAAmB;EACrB;EACA;IACE,yBAAyB;IACzB,mBAAmB;EACrB;EACA;IACE,yBAAyB;IACzB,mBAAmB;EACrB;EACA;IACE,cAAc;EAChB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iCAAiC;EACnC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,8BAA8B;EAChC;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,8BAA8B;EAChC;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,UAAU;EACZ;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,aAAa;EACf;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,aAAa;EACf;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,aAAa;EACf;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA;IACE,YAAY;EACd;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,YAAY;EACd;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,YAAY;EACd;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,YAAY;EACd;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,YAAY;EACd;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,YAAY;EACd;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,aAAa;EACf;EACA;IACE,cAAc;IACd,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,oBAAoB;IACpB,uBAAuB;EACzB;EACA;IACE,qBAAqB;IACrB,sBAAsB;EACxB;EACA;IACE,mBAAmB;IACnB,sBAAsB;EACxB;EACA;IACE,oBAAoB;IACpB,qBAAqB;EACvB;EACA;IACE,oBAAoB;IACpB,uBAAuB;EACzB;EACA;IACE,qBAAqB;IACrB,sBAAsB;EACxB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,oBAAoB;IACpB,uBAAuB;EACzB;EACA;IACE,qBAAqB;IACrB,sBAAsB;EACxB;EACA;IACE,mBAAmB;IACnB,sBAAsB;EACxB;EACA;IACE,oBAAoB;IACpB,qBAAqB;EACvB;EACA;IACE,oBAAoB;IACpB,uBAAuB;EACzB;EACA;IACE,qBAAqB;IACrB,sBAAsB;EACxB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,oBAAoB;IACpB,uBAAuB;EACzB;EACA;IACE,qBAAqB;IACrB,sBAAsB;EACxB;EACA;IACE,mBAAmB;IACnB,sBAAsB;EACxB;EACA;IACE,oBAAoB;IACpB,qBAAqB;EACvB;EACA;IACE,oBAAoB;IACpB,uBAAuB;EACzB;EACA;IACE,qBAAqB;IACrB,sBAAsB;EACxB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,oBAAoB;IACpB,uBAAuB;EACzB;EACA;IACE,qBAAqB;IACrB,sBAAsB;EACxB;EACA;IACE,mBAAmB;IACnB,sBAAsB;EACxB;EACA;IACE,oBAAoB;IACpB,qBAAqB;EACvB;EACA;IACE,oBAAoB;IACpB,uBAAuB;EACzB;EACA;IACE,qBAAqB;IACrB,sBAAsB;EACxB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;EACA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;EACA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;EACA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;EACA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;EACA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;EACA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;EACA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;EACA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;EACA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;EACA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,qBAAqB;IACrB,wBAAwB;EAC1B;EACA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,qBAAqB;IACrB,wBAAwB;EAC1B;EACA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,qBAAqB;IACrB,wBAAwB;EAC1B;EACA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,qBAAqB;IACrB,wBAAwB;EAC1B;EACA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,wBAAwB;IACxB,yBAAyB;EAC3B;EACA;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,wBAAwB;IACxB,yBAAyB;EAC3B;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,wBAAwB;IACxB,yBAAyB;EAC3B;EACA;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,wBAAwB;IACxB,yBAAyB;EAC3B;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,wBAAwB;IACxB,yBAAyB;EAC3B;EACA;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,wBAAwB;IACxB,yBAAyB;EAC3B;EACA;IACE,sBAAsB;IACtB,yBAAyB;EAC3B;EACA;IACE,uBAAuB;IACvB,wBAAwB;EAC1B;EACA;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,wBAAwB;IACxB,yBAAyB;EAC3B;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,wBAAwB;IACxB,yBAAyB;EAC3B;EACA;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,wBAAwB;IACxB,yBAAyB;EAC3B;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,wBAAwB;IACxB,yBAAyB;EAC3B;EACA;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,wBAAwB;IACxB,yBAAyB;EAC3B;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,wBAAwB;IACxB,yBAAyB;EAC3B;EACA;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,wBAAwB;IACxB,yBAAyB;EAC3B;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,cAAc;EAChB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EAIA;IACE,mBAAmB;EACrB;EAIA;IACE,kBAAkB;EACpB;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,gDAAgD;EAClD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,mDAAmD;EACrD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,mDAAmD;EACrD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,mDAAmD;EACrD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,mDAAmD;EACrD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,qDAAqD;EACvD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,mDAAmD;EACrD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,mDAAmD;EACrD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,qDAAqD;EACvD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,mDAAmD;EACrD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,qDAAqD;EACvD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,qDAAqD;EACvD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,mDAAmD;EACrD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,mDAAmD;EACrD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,kDAAkD;EACpD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,kDAAkD;EACpD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,qDAAqD;EACvD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,kDAAkD;EACpD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,kDAAkD;EACpD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,qDAAqD;EACvD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,qDAAqD;EACvD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,qDAAqD;EACvD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,qDAAqD;EACvD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,qDAAqD;EACvD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,qDAAqD;EACvD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,qDAAqD;EACvD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,mDAAmD;EACrD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,mDAAmD;EACrD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,mDAAmD;EACrD;EAIA;IACE,mBAAmB;EACrB;EAIA;IACE,kBAAkB;EACpB;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,gDAAgD;EAClD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,mDAAmD;EACrD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,mDAAmD;EACrD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,mDAAmD;EACrD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,mDAAmD;EACrD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,qDAAqD;EACvD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,mDAAmD;EACrD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,mDAAmD;EACrD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,qDAAqD;EACvD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,mDAAmD;EACrD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,qDAAqD;EACvD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,qDAAqD;EACvD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,mDAAmD;EACrD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,mDAAmD;EACrD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,kDAAkD;EACpD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,kDAAkD;EACpD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,qDAAqD;EACvD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,kDAAkD;EACpD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,kDAAkD;EACpD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,qDAAqD;EACvD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,qDAAqD;EACvD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,qDAAqD;EACvD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,qDAAqD;EACvD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,qDAAqD;EACvD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,qDAAqD;EACvD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,qDAAqD;EACvD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,sDAAsD;EACxD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,oDAAoD;EACtD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,mDAAmD;EACrD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,mDAAmD;EACrD;EAMA;IACE,wBAAwB;IACxB,cAAc;IACd,mDAAmD;EACrD;EAIA;IACE,wBAAwB;EAC1B;EAIA;IACE,2BAA2B;EAC7B;EAIA;IACE,0BAA0B;EAC5B;EAIA;IACE,2BAA2B;EAC7B;EAIA;IACE,wBAAwB;EAC1B;EAIA;IACE,wBAAwB;EAC1B;EAIA;IACE,2BAA2B;EAC7B;EAIA;IACE,0BAA0B;EAC5B;EAIA;IACE,2BAA2B;EAC7B;EAIA;IACE,wBAAwB;EAC1B;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,MAAM;IACN,QAAQ;IACR,SAAS;IACT,OAAO;EACT;EACA;IACE,YAAY;IACZ,cAAc;IACd,eAAe;IACf,aAAa;EACf;EACA;IACE,WAAW;IACX,aAAa;IACb,cAAc;IACd,YAAY;EACd;EACA;IACE,YAAY;IACZ,cAAc;IACd,eAAe;IACf,aAAa;EACf;EACA;IACE,SAAS;IACT,WAAW;IACX,YAAY;IACZ,UAAU;EACZ;EACA;IACE,YAAY;IACZ,cAAc;IACd,eAAe;IACf,aAAa;EACf;EACA;IACE,WAAW;IACX,aAAa;IACb,cAAc;IACd,YAAY;EACd;EACA;IACE,YAAY;IACZ,cAAc;IACd,eAAe;IACf,aAAa;EACf;EACA;IACE,SAAS;IACT,WAAW;IACX,YAAY;IACZ,UAAU;EACZ;EACA;IACE,YAAY;IACZ,cAAc;IACd,eAAe;IACf,aAAa;EACf;EACA;IACE,WAAW;IACX,aAAa;IACb,cAAc;IACd,YAAY;EACd;EACA;IACE,YAAY;IACZ,cAAc;IACd,eAAe;IACf,aAAa;EACf;EACA;IACE,SAAS;IACT,WAAW;IACX,YAAY;IACZ,UAAU;EACZ;EACA;IACE,YAAY;IACZ,cAAc;IACd,eAAe;IACf,aAAa;EACf;EACA;IACE,WAAW;IACX,aAAa;IACb,cAAc;IACd,YAAY;EACd;EACA;IACE,YAAY;IACZ,cAAc;IACd,eAAe;IACf,aAAa;EACf;EACA;IACE,SAAS;IACT,WAAW;IACX,YAAY;IACZ,UAAU;EACZ;EACA;IACE,SAAS;IACT,WAAW;IACX,YAAY;IACZ,UAAU;EACZ;EACA;IACE,SAAS;IACT,WAAW;IACX,YAAY;IACZ,UAAU;EACZ;EACA;IACE,SAAS;IACT,WAAW;IACX,YAAY;IACZ,UAAU;EACZ;EACA;IACE,SAAS;IACT,WAAW;IACX,YAAY;IACZ,UAAU;EACZ;EACA;IACE,SAAS;IACT,WAAW;IACX,YAAY;IACZ,UAAU;EACZ;EACA;IACE,UAAU;IACV,YAAY;IACZ,aAAa;IACb,WAAW;EACb;EACA;IACE,UAAU;IACV,YAAY;IACZ,aAAa;IACb,WAAW;EACb;EACA;IACE,UAAU;IACV,YAAY;IACZ,aAAa;IACb,WAAW;EACb;EACA;IACE,UAAU;IACV,YAAY;IACZ,aAAa;IACb,WAAW;EACb;EACA;IACE,UAAU;IACV,YAAY;IACZ,aAAa;IACb,WAAW;EACb;EACA;IACE,UAAU;IACV,YAAY;IACZ,aAAa;IACb,WAAW;EACb;EACA;IACE,UAAU;IACV,YAAY;IACZ,aAAa;IACb,WAAW;EACb;EACA;IACE,UAAU;IACV,YAAY;IACZ,aAAa;IACb,WAAW;EACb;EACA;IACE,UAAU;IACV,YAAY;IACZ,aAAa;IACb,WAAW;EACb;EACA;IACE,UAAU;IACV,YAAY;IACZ,aAAa;IACb,WAAW;EACb;EACA;IACE,SAAS;IACT,WAAW;IACX,YAAY;IACZ,UAAU;EACZ;EACA;IACE,QAAQ;IACR,UAAU;IACV,WAAW;IACX,SAAS;EACX;EACA;IACE,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,cAAc;EAChB;EACA;IACE,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,cAAc;EAChB;EACA;IACE,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,cAAc;EAChB;EACA;IACE,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,cAAc;EAChB;EACA;IACE,QAAQ;IACR,UAAU;IACV,WAAW;IACX,SAAS;EACX;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;EAClB;EACA;IACE,QAAQ;IACR,UAAU;IACV,WAAW;IACX,SAAS;EACX;EACA;IACE,QAAQ;IACR,UAAU;IACV,WAAW;IACX,SAAS;EACX;EACA;IACE,QAAQ;IACR,UAAU;IACV,WAAW;IACX,SAAS;EACX;EACA;IACE,QAAQ;IACR,UAAU;IACV,WAAW;IACX,SAAS;EACX;EACA;IACE,QAAQ;IACR,UAAU;IACV,WAAW;IACX,SAAS;EACX;EACA;IACE,QAAQ;IACR,UAAU;IACV,WAAW;IACX,SAAS;EACX;EACA;IACE,QAAQ;IACR,UAAU;IACV,WAAW;IACX,SAAS;EACX;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;EAClB;EACA;IACE,QAAQ;IACR,UAAU;IACV,WAAW;IACX,SAAS;EACX;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;EAClB;EACA;IACE,cAAc;IACd,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;EACjB;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;EAClB;EACA;IACE,QAAQ;IACR,UAAU;IACV,WAAW;IACX,SAAS;EACX;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;EAClB;EACA;IACE,QAAQ;IACR,UAAU;IACV,WAAW;IACX,SAAS;EACX;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;EAClB;EACA;IACE,QAAQ;IACR,UAAU;IACV,WAAW;IACX,SAAS;EACX;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;EAClB;EACA;IACE,SAAS;IACT,WAAW;IACX,YAAY;IACZ,UAAU;EACZ;EACA;IACE,MAAM;IACN,SAAS;EACX;EACA;IACE,QAAQ;IACR,OAAO;EACT;EACA;IACE,YAAY;IACZ,eAAe;EACjB;EACA;IACE,cAAc;IACd,aAAa;EACf;EACA;IACE,WAAW;IACX,cAAc;EAChB;EACA;IACE,aAAa;IACb,YAAY;EACd;EACA;IACE,YAAY;IACZ,eAAe;EACjB;EACA;IACE,cAAc;IACd,aAAa;EACf;EACA;IACE,SAAS;IACT,YAAY;EACd;EACA;IACE,WAAW;IACX,UAAU;EACZ;EACA;IACE,YAAY;IACZ,eAAe;EACjB;EACA;IACE,cAAc;IACd,aAAa;EACf;EACA;IACE,WAAW;IACX,cAAc;EAChB;EACA;IACE,aAAa;IACb,YAAY;EACd;EACA;IACE,YAAY;IACZ,eAAe;EACjB;EACA;IACE,cAAc;IACd,aAAa;EACf;EACA;IACE,SAAS;IACT,YAAY;EACd;EACA;IACE,WAAW;IACX,UAAU;EACZ;EACA;IACE,YAAY;IACZ,eAAe;EACjB;EACA;IACE,cAAc;IACd,aAAa;EACf;EACA;IACE,WAAW;IACX,cAAc;EAChB;EACA;IACE,aAAa;IACb,YAAY;EACd;EACA;IACE,YAAY;IACZ,eAAe;EACjB;EACA;IACE,cAAc;IACd,aAAa;EACf;EACA;IACE,SAAS;IACT,YAAY;EACd;EACA;IACE,WAAW;IACX,UAAU;EACZ;EACA;IACE,YAAY;IACZ,eAAe;EACjB;EACA;IACE,cAAc;IACd,aAAa;EACf;EACA;IACE,WAAW;IACX,cAAc;EAChB;EACA;IACE,aAAa;IACb,YAAY;EACd;EACA;IACE,YAAY;IACZ,eAAe;EACjB;EACA;IACE,cAAc;IACd,aAAa;EACf;EACA;IACE,SAAS;IACT,YAAY;EACd;EACA;IACE,WAAW;IACX,UAAU;EACZ;EACA;IACE,SAAS;IACT,YAAY;EACd;EACA;IACE,WAAW;IACX,UAAU;EACZ;EACA;IACE,SAAS;IACT,YAAY;EACd;EACA;IACE,WAAW;IACX,UAAU;EACZ;EACA;IACE,SAAS;IACT,YAAY;EACd;EACA;IACE,WAAW;IACX,UAAU;EACZ;EACA;IACE,SAAS;IACT,YAAY;EACd;EACA;IACE,WAAW;IACX,UAAU;EACZ;EACA;IACE,SAAS;IACT,YAAY;EACd;EACA;IACE,WAAW;IACX,UAAU;EACZ;EACA;IACE,UAAU;IACV,aAAa;EACf;EACA;IACE,YAAY;IACZ,WAAW;EACb;EACA;IACE,UAAU;IACV,aAAa;EACf;EACA;IACE,YAAY;IACZ,WAAW;EACb;EACA;IACE,UAAU;IACV,aAAa;EACf;EACA;IACE,YAAY;IACZ,WAAW;EACb;EACA;IACE,UAAU;IACV,aAAa;EACf;EACA;IACE,YAAY;IACZ,WAAW;EACb;EACA;IACE,UAAU;IACV,aAAa;EACf;EACA;IACE,YAAY;IACZ,WAAW;EACb;EACA;IACE,UAAU;IACV,aAAa;EACf;EACA;IACE,YAAY;IACZ,WAAW;EACb;EACA;IACE,UAAU;IACV,aAAa;EACf;EACA;IACE,YAAY;IACZ,WAAW;EACb;EACA;IACE,UAAU;IACV,aAAa;EACf;EACA;IACE,YAAY;IACZ,WAAW;EACb;EACA;IACE,UAAU;IACV,aAAa;EACf;EACA;IACE,YAAY;IACZ,WAAW;EACb;EACA;IACE,UAAU;IACV,aAAa;EACf;EACA;IACE,YAAY;IACZ,WAAW;EACb;EACA;IACE,SAAS;IACT,YAAY;EACd;EACA;IACE,WAAW;IACX,UAAU;EACZ;EACA;IACE,QAAQ;IACR,WAAW;EACb;EACA;IACE,UAAU;IACV,SAAS;EACX;EACA;IACE,aAAa;IACb,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,cAAc;EAChB;EACA;IACE,aAAa;IACb,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,cAAc;EAChB;EACA;IACE,aAAa;IACb,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,cAAc;EAChB;EACA;IACE,aAAa;IACb,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,cAAc;EAChB;EACA;IACE,QAAQ;IACR,WAAW;EACb;EACA;IACE,UAAU;IACV,SAAS;EACX;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;EACA;IACE,QAAQ;IACR,WAAW;EACb;EACA;IACE,UAAU;IACV,SAAS;EACX;EACA;IACE,QAAQ;IACR,WAAW;EACb;EACA;IACE,UAAU;IACV,SAAS;EACX;EACA;IACE,QAAQ;IACR,WAAW;EACb;EACA;IACE,UAAU;IACV,SAAS;EACX;EACA;IACE,QAAQ;IACR,WAAW;EACb;EACA;IACE,UAAU;IACV,SAAS;EACX;EACA;IACE,QAAQ;IACR,WAAW;EACb;EACA;IACE,UAAU;IACV,SAAS;EACX;EACA;IACE,QAAQ;IACR,WAAW;EACb;EACA;IACE,UAAU;IACV,SAAS;EACX;EACA;IACE,QAAQ;IACR,WAAW;EACb;EACA;IACE,UAAU;IACV,SAAS;EACX;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;EACA;IACE,QAAQ;IACR,WAAW;EACb;EACA;IACE,UAAU;IACV,SAAS;EACX;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;EACA;IACE,cAAc;IACd,iBAAiB;EACnB;EACA;IACE,gBAAgB;IAChB,eAAe;EACjB;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;EACA;IACE,QAAQ;IACR,WAAW;EACb;EACA;IACE,UAAU;IACV,SAAS;EACX;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;EACA;IACE,QAAQ;IACR,WAAW;EACb;EACA;IACE,UAAU;IACV,SAAS;EACX;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;EACA;IACE,QAAQ;IACR,WAAW;EACb;EACA;IACE,UAAU;IACV,SAAS;EACX;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;EACA;IACE,SAAS;IACT,YAAY;EACd;EACA;IACE,WAAW;IACX,UAAU;EACZ;EACA;IACE,MAAM;EACR;EACA;IACE,QAAQ;EACV;EACA;IACE,SAAS;EACX;EACA;IACE,OAAO;EACT;EACA;IACE,YAAY;EACd;EACA;IACE,cAAc;EAChB;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;EACf;EACA;IACE,WAAW;EACb;EACA;IACE,aAAa;EACf;EACA;IACE,cAAc;EAChB;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,cAAc;EAChB;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;EACf;EACA;IACE,SAAS;EACX;EACA;IACE,WAAW;EACb;EACA;IACE,YAAY;EACd;EACA;IACE,UAAU;EACZ;EACA;IACE,YAAY;EACd;EACA;IACE,cAAc;EAChB;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;EACf;EACA;IACE,WAAW;EACb;EACA;IACE,aAAa;EACf;EACA;IACE,cAAc;EAChB;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,cAAc;EAChB;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;EACf;EACA;IACE,SAAS;EACX;EACA;IACE,WAAW;EACb;EACA;IACE,YAAY;EACd;EACA;IACE,UAAU;EACZ;EACA;IACE,YAAY;EACd;EACA;IACE,cAAc;EAChB;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;EACf;EACA;IACE,WAAW;EACb;EACA;IACE,aAAa;EACf;EACA;IACE,cAAc;EAChB;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,cAAc;EAChB;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;EACf;EACA;IACE,SAAS;EACX;EACA;IACE,WAAW;EACb;EACA;IACE,YAAY;EACd;EACA;IACE,UAAU;EACZ;EACA;IACE,YAAY;EACd;EACA;IACE,cAAc;EAChB;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;EACf;EACA;IACE,WAAW;EACb;EACA;IACE,aAAa;EACf;EACA;IACE,cAAc;EAChB;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,cAAc;EAChB;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;EACf;EACA;IACE,SAAS;EACX;EACA;IACE,WAAW;EACb;EACA;IACE,YAAY;EACd;EACA;IACE,UAAU;EACZ;EACA;IACE,SAAS;EACX;EACA;IACE,WAAW;EACb;EACA;IACE,YAAY;EACd;EACA;IACE,UAAU;EACZ;EACA;IACE,SAAS;EACX;EACA;IACE,WAAW;EACb;EACA;IACE,YAAY;EACd;EACA;IACE,UAAU;EACZ;EACA;IACE,SAAS;EACX;EACA;IACE,WAAW;EACb;EACA;IACE,YAAY;EACd;EACA;IACE,UAAU;EACZ;EACA;IACE,SAAS;EACX;EACA;IACE,WAAW;EACb;EACA;IACE,YAAY;EACd;EACA;IACE,UAAU;EACZ;EACA;IACE,SAAS;EACX;EACA;IACE,WAAW;EACb;EACA;IACE,YAAY;EACd;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,YAAY;EACd;EACA;IACE,aAAa;EACf;EACA;IACE,WAAW;EACb;EACA;IACE,UAAU;EACZ;EACA;IACE,YAAY;EACd;EACA;IACE,aAAa;EACf;EACA;IACE,WAAW;EACb;EACA;IACE,UAAU;EACZ;EACA;IACE,YAAY;EACd;EACA;IACE,aAAa;EACf;EACA;IACE,WAAW;EACb;EACA;IACE,UAAU;EACZ;EACA;IACE,YAAY;EACd;EACA;IACE,aAAa;EACf;EACA;IACE,WAAW;EACb;EACA;IACE,UAAU;EACZ;EACA;IACE,YAAY;EACd;EACA;IACE,aAAa;EACf;EACA;IACE,WAAW;EACb;EACA;IACE,UAAU;EACZ;EACA;IACE,YAAY;EACd;EACA;IACE,aAAa;EACf;EACA;IACE,WAAW;EACb;EACA;IACE,UAAU;EACZ;EACA;IACE,YAAY;EACd;EACA;IACE,aAAa;EACf;EACA;IACE,WAAW;EACb;EACA;IACE,UAAU;EACZ;EACA;IACE,YAAY;EACd;EACA;IACE,aAAa;EACf;EACA;IACE,WAAW;EACb;EACA;IACE,UAAU;EACZ;EACA;IACE,YAAY;EACd;EACA;IACE,aAAa;EACf;EACA;IACE,WAAW;EACb;EACA;IACE,UAAU;EACZ;EACA;IACE,YAAY;EACd;EACA;IACE,aAAa;EACf;EACA;IACE,WAAW;EACb;EACA;IACE,SAAS;EACX;EACA;IACE,WAAW;EACb;EACA;IACE,YAAY;EACd;EACA;IACE,UAAU;EACZ;EACA;IACE,QAAQ;EACV;EACA;IACE,UAAU;EACZ;EACA;IACE,WAAW;EACb;EACA;IACE,SAAS;EACX;EACA;IACE,aAAa;EACf;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,cAAc;EAChB;EACA;IACE,aAAa;EACf;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,cAAc;EAChB;EACA;IACE,aAAa;EACf;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,cAAc;EAChB;EACA;IACE,aAAa;EACf;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,cAAc;EAChB;EACA;IACE,QAAQ;EACV;EACA;IACE,UAAU;EACZ;EACA;IACE,WAAW;EACb;EACA;IACE,SAAS;EACX;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,QAAQ;EACV;EACA;IACE,UAAU;EACZ;EACA;IACE,WAAW;EACb;EACA;IACE,SAAS;EACX;EACA;IACE,QAAQ;EACV;EACA;IACE,UAAU;EACZ;EACA;IACE,WAAW;EACb;EACA;IACE,SAAS;EACX;EACA;IACE,QAAQ;EACV;EACA;IACE,UAAU;EACZ;EACA;IACE,WAAW;EACb;EACA;IACE,SAAS;EACX;EACA;IACE,QAAQ;EACV;EACA;IACE,UAAU;EACZ;EACA;IACE,WAAW;EACb;EACA;IACE,SAAS;EACX;EACA;IACE,QAAQ;EACV;EACA;IACE,UAAU;EACZ;EACA;IACE,WAAW;EACb;EACA;IACE,SAAS;EACX;EACA;IACE,QAAQ;EACV;EACA;IACE,UAAU;EACZ;EACA;IACE,WAAW;EACb;EACA;IACE,SAAS;EACX;EACA;IACE,QAAQ;EACV;EACA;IACE,UAAU;EACZ;EACA;IACE,WAAW;EACb;EACA;IACE,SAAS;EACX;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,QAAQ;EACV;EACA;IACE,UAAU;EACZ;EACA;IACE,WAAW;EACb;EACA;IACE,SAAS;EACX;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,cAAc;EAChB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,QAAQ;EACV;EACA;IACE,UAAU;EACZ;EACA;IACE,WAAW;EACb;EACA;IACE,SAAS;EACX;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,QAAQ;EACV;EACA;IACE,UAAU;EACZ;EACA;IACE,WAAW;EACb;EACA;IACE,SAAS;EACX;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,QAAQ;EACV;EACA;IACE,UAAU;EACZ;EACA;IACE,WAAW;EACb;EACA;IACE,SAAS;EACX;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,SAAS;EACX;EACA;IACE,WAAW;EACb;EACA;IACE,YAAY;EACd;EACA;IACE,UAAU;EACZ;EACA;IACE,YAAY;EACd;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,YAAY;EACd;EACA;IACE,yCAAyC;EAC3C;EACA;IACE,2CAA2C;EAC7C;EACA;IACE,2EAA2E;EAC7E;EACA;IACE,iFAAiF;EACnF;EACA;IACE,mFAAmF;EACrF;EACA;IACE,qFAAqF;EACvF;EACA;IACE,iDAAiD;EACnD;EACA;IACE,iDAAiD;EACnD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kCAAkC;EACpC;EACA;IACE,+CAA+C;EACjD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,8CAA8C;EAChD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,yCAAyC;EAC3C;EACA;IACE,2CAA2C;EAC7C;EACA;IACE,2EAA2E;EAC7E;EACA;IACE,iFAAiF;EACnF;EACA;IACE,mFAAmF;EACrF;EACA;IACE,qFAAqF;EACvF;EACA;IACE,iDAAiD;EACnD;EACA;IACE,iDAAiD;EACnD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kCAAkC;EACpC;EACA;IACE,+CAA+C;EACjD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,8CAA8C;EAChD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,yCAAyC;EAC3C;EACA;IACE,2CAA2C;EAC7C;EACA;IACE,2EAA2E;EAC7E;EACA;IACE,iFAAiF;EACnF;EACA;IACE,mFAAmF;EACrF;EACA;IACE,qFAAqF;EACvF;EACA;IACE,iDAAiD;EACnD;EACA;IACE,iDAAiD;EACnD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kCAAkC;EACpC;EACA;IACE,+CAA+C;EACjD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,8CAA8C;EAChD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,yCAAyC;EAC3C;EACA;IACE,2CAA2C;EAC7C;EACA;IACE,2EAA2E;EAC7E;EACA;IACE,iFAAiF;EACnF;EACA;IACE,mFAAmF;EACrF;EACA;IACE,qFAAqF;EACvF;EACA;IACE,iDAAiD;EACnD;EACA;IACE,iDAAiD;EACnD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kCAAkC;EACpC;EACA;IACE,+CAA+C;EACjD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,8CAA8C;EAChD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,yCAAyC;EAC3C;EACA;IACE,2CAA2C;EAC7C;EACA;IACE,2EAA2E;EAC7E;EACA;IACE,iFAAiF;EACnF;EACA;IACE,mFAAmF;EACrF;EACA;IACE,qFAAqF;EACvF;EACA;IACE,iDAAiD;EACnD;EACA;IACE,iDAAiD;EACnD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kCAAkC;EACpC;EACA;IACE,+CAA+C;EACjD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,8CAA8C;EAChD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,kBAAkB;EACpB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,yCAAyC;EAC3C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,2CAA2C;EAC7C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,2CAA2C;EAC7C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,2CAA2C;EAC7C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,2CAA2C;EAC7C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,yCAAyC;EAC3C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,2CAA2C;EAC7C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,2CAA2C;EAC7C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,2CAA2C;EAC7C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,2CAA2C;EAC7C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,yCAAyC;EAC3C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,2CAA2C;EAC7C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,2CAA2C;EAC7C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,2CAA2C;EAC7C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,2CAA2C;EAC7C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,yCAAyC;EAC3C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,2CAA2C;EAC7C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,2CAA2C;EAC7C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,2CAA2C;EAC7C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,2CAA2C;EAC7C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,yCAAyC;EAC3C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,2CAA2C;EAC7C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,2CAA2C;EAC7C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,2CAA2C;EAC7C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,2CAA2C;EAC7C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,yCAAyC;EAC3C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,2CAA2C;EAC7C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,2CAA2C;EAC7C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,2CAA2C;EAC7C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,2CAA2C;EAC7C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,yCAAyC;EAC3C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,2CAA2C;EAC7C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,2CAA2C;EAC7C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,2CAA2C;EAC7C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,2CAA2C;EAC7C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,8CAA8C;EAChD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,+CAA+C;EACjD;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,6CAA6C;EAC/C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,iBAAiB;EACnB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,oBAAoB;EACtB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mCAAmC;IACnC,kCAAkC;EACpC;EACA;IACE,4BAA4B;IAC5B,6BAA6B;EAC/B;EACA;IACE;;;OAGG;IACH;;;OAGG;IACH;;;OAGG;IACH;;;OAGG;IACH;;;OAGG;IACH,8MAA8M;EAChN;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,uCAAuC;EACzC;EACA;IACE,iDAAiD;EACnD;EACA;IACE,0CAA0C;EAC5C;EACA;IACE,4CAA4C;EAC9C;EACA;IACE,iDAAiD;EACnD;EACA;IACE,4CAA4C;EAC9C;EACA;IACE,mDAAmD;EACrD;EACA;IACE,kDAAkD;EACpD;EACA;IACE,uBAAuB;EACzB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,iBAAiB;EACnB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,yBAAyB;IAEzB,iBAAiB;EACnB;EACA;IACE,yBAAyB;IAEzB,iBAAiB;EACnB;EACA;IACE,wBAAwB;IAExB,gBAAgB;EAClB;EACA;IACE,yBAAyB;IAEzB,iBAAiB;EACnB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,mBAAmB;EACrB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,iBAAiB;IACjB,qBAAqB;IACrB,kBAAkB;EACpB;EACA;IACE,qBAAqB;IACrB,yBAAyB;EAC3B;EACA;IACE,qBAAqB;EACvB;EACA;IACE,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;EACrB;EACA;IACE,QAAQ;EACV;EACA;IACE,cAAc;EAChB;EACA;IACE,aAAa;EACf;EACA;IACE,cAAc;EAChB;EACA;IACE,WAAW;EACb;EACA;IACE,cAAc;EAChB;EACA;IACE,aAAa;EACf;EACA;IACE,cAAc;EAChB;EACA;IACE,WAAW;EACb;EACA;IACE,cAAc;EAChB;EACA;IACE,aAAa;EACf;EACA;IACE,cAAc;EAChB;EACA;IACE,WAAW;EACb;EACA;IACE,cAAc;EAChB;EACA;IACE,aAAa;EACf;EACA;IACE,cAAc;EAChB;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,WAAW;EACb;EACA;IACE,UAAU;EACZ;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,UAAU;EACZ;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,UAAU;EACZ;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,UAAU;EACZ;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,UAAU;EACZ;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,UAAU;EACZ;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,WAAW;EACb;EACA;IACE,YAAY;EACd;EACA;IAEE,kBAAkB;EACpB;EACA;IAEE,kBAAkB;EACpB;EACA;IACE,UAAU;EACZ;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,aAAa;EACf;EACA;IACE,UAAU;EACZ;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,aAAa;EACf;EACA;IACE,UAAU;EACZ;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,aAAa;EACf;EACA;IACE,WAAW;IACX,MAAM;EACR;EACA;IACE,iBAAiB;IACjB,YAAY;EACd;EACA;IACE,gBAAgB;IAChB,WAAW;EACb;EACA;IACE,iBAAiB;IACjB,YAAY;EACd;EACA;IACE,cAAc;IACd,SAAS;EACX;EACA;IACE,iBAAiB;IACjB,YAAY;EACd;EACA;IACE,gBAAgB;IAChB,WAAW;EACb;EACA;IACE,iBAAiB;IACjB,YAAY;EACd;EACA;IACE,cAAc;IACd,SAAS;EACX;EACA;IACE,iBAAiB;IACjB,YAAY;EACd;EACA;IACE,gBAAgB;IAChB,WAAW;EACb;EACA;IACE,iBAAiB;IACjB,YAAY;EACd;EACA;IACE,cAAc;IACd,SAAS;EACX;EACA;IACE,iBAAiB;IACjB,YAAY;EACd;EACA;IACE,gBAAgB;IAChB,WAAW;EACb;EACA;IACE,iBAAiB;IACjB,YAAY;EACd;EACA;IACE,cAAc;IACd,SAAS;EACX;EACA;IACE,cAAc;IACd,SAAS;EACX;EACA;IACE,cAAc;IACd,SAAS;EACX;EACA;IACE,cAAc;IACd,SAAS;EACX;EACA;IACE,cAAc;IACd,SAAS;EACX;EACA;IACE,cAAc;IACd,SAAS;EACX;EACA;IACE,eAAe;IACf,UAAU;EACZ;EACA;IACE,eAAe;IACf,UAAU;EACZ;EACA;IACE,eAAe;IACf,UAAU;EACZ;EACA;IACE,eAAe;IACf,UAAU;EACZ;EACA;IACE,eAAe;IACf,UAAU;EACZ;EACA;IACE,eAAe;IACf,UAAU;EACZ;EACA;IACE,eAAe;IACf,UAAU;EACZ;EACA;IACE,eAAe;IACf,UAAU;EACZ;EACA;IACE,eAAe;IACf,UAAU;EACZ;EACA;IACE,eAAe;IACf,UAAU;EACZ;EACA;IACE,aAAa;IACb,QAAQ;EACV;EACA;IACE,kBAAkB;IAClB,aAAa;EACf;EACA;IACE,kBAAkB;IAClB,aAAa;EACf;EACA;IACE,kBAAkB;IAClB,aAAa;EACf;EACA;IACE,kBAAkB;IAClB,aAAa;EACf;EACA;IACE,aAAa;IACb,QAAQ;EACV;EACA;IACE,oBAAoB;IACpB,eAAe;EACjB;EACA;IACE,oBAAoB;IACpB,eAAe;EACjB;EACA;IACE,aAAa;IACb,QAAQ;EACV;EACA;IACE,aAAa;IACb,QAAQ;EACV;EACA;IACE,aAAa;IACb,QAAQ;EACV;EACA;IACE,aAAa;IACb,QAAQ;EACV;EACA;IACE,aAAa;IACb,QAAQ;EACV;EACA;IACE,aAAa;IACb,QAAQ;EACV;EACA;IACE,aAAa;IACb,QAAQ;EACV;EACA;IACE,oBAAoB;IACpB,eAAe;EACjB;EACA;IACE,oBAAoB;IACpB,eAAe;EACjB;EACA;IACE,aAAa;IACb,QAAQ;EACV;EACA;IACE,oBAAoB;IACpB,eAAe;EACjB;EACA;IACE,oBAAoB;IACpB,eAAe;EACjB;EACA;IACE,mBAAmB;IACnB,cAAc;EAChB;EACA;IACE,oBAAoB;IACpB,eAAe;EACjB;EACA;IACE,aAAa;IACb,QAAQ;EACV;EACA;IACE,oBAAoB;IACpB,eAAe;EACjB;EACA;IACE,oBAAoB;IACpB,eAAe;EACjB;EACA;IACE,aAAa;IACb,QAAQ;EACV;EACA;IACE,oBAAoB;IACpB,eAAe;EACjB;EACA;IACE,oBAAoB;IACpB,eAAe;EACjB;EACA;IACE,aAAa;IACb,QAAQ;EACV;EACA;IACE,oBAAoB;IACpB,eAAe;EACjB;EACA;IACE,oBAAoB;IACpB,eAAe;EACjB;EACA;IACE,cAAc;IACd,SAAS;EACX;EACA;IACE,kBAAkB;IAElB,aAAa;EACf;EACA;IACE,wBAAwB;IAExB,mBAAmB;EACrB;EACA;IACE,uBAAuB;IAEvB,kBAAkB;EACpB;EACA;IACE,wBAAwB;IAExB,mBAAmB;EACrB;EACA;IACE,qBAAqB;IAErB,gBAAgB;EAClB;EACA;IACE,wBAAwB;IAExB,mBAAmB;EACrB;EACA;IACE,uBAAuB;IAEvB,kBAAkB;EACpB;EACA;IACE,wBAAwB;IAExB,mBAAmB;EACrB;EACA;IACE,qBAAqB;IAErB,gBAAgB;EAClB;EACA;IACE,wBAAwB;IAExB,mBAAmB;EACrB;EACA;IACE,uBAAuB;IAEvB,kBAAkB;EACpB;EACA;IACE,wBAAwB;IAExB,mBAAmB;EACrB;EACA;IACE,qBAAqB;IAErB,gBAAgB;EAClB;EACA;IACE,wBAAwB;IAExB,mBAAmB;EACrB;EACA;IACE,uBAAuB;IAEvB,kBAAkB;EACpB;EACA;IACE,wBAAwB;IAExB,mBAAmB;EACrB;EACA;IACE,qBAAqB;IAErB,gBAAgB;EAClB;EACA;IACE,qBAAqB;IAErB,gBAAgB;EAClB;EACA;IACE,qBAAqB;IAErB,gBAAgB;EAClB;EACA;IACE,qBAAqB;IAErB,gBAAgB;EAClB;EACA;IACE,qBAAqB;IAErB,gBAAgB;EAClB;EACA;IACE,qBAAqB;IAErB,gBAAgB;EAClB;EACA;IACE,sBAAsB;IAEtB,iBAAiB;EACnB;EACA;IACE,sBAAsB;IAEtB,iBAAiB;EACnB;EACA;IACE,sBAAsB;IAEtB,iBAAiB;EACnB;EACA;IACE,sBAAsB;IAEtB,iBAAiB;EACnB;EACA;IACE,sBAAsB;IAEtB,iBAAiB;EACnB;EACA;IACE,sBAAsB;IAEtB,iBAAiB;EACnB;EACA;IACE,sBAAsB;IAEtB,iBAAiB;EACnB;EACA;IACE,sBAAsB;IAEtB,iBAAiB;EACnB;EACA;IACE,sBAAsB;IAEtB,iBAAiB;EACnB;EACA;IACE,sBAAsB;IAEtB,iBAAiB;EACnB;EACA;IACE,oBAAoB;IAEpB,eAAe;EACjB;EACA;IACE,yBAAyB;IAEzB,oBAAoB;EACtB;EACA;IACE,yBAAyB;IAEzB,oBAAoB;EACtB;EACA;IACE,yBAAyB;IAEzB,oBAAoB;EACtB;EACA;IACE,yBAAyB;IAEzB,oBAAoB;EACtB;EACA;IACE,oBAAoB;IAEpB,eAAe;EACjB;EACA;IACE,2BAA2B;IAE3B,sBAAsB;EACxB;EACA;IACE,2BAA2B;IAE3B,sBAAsB;EACxB;EACA;IACE,oBAAoB;IAEpB,eAAe;EACjB;EACA;IACE,oBAAoB;IAEpB,eAAe;EACjB;EACA;IACE,oBAAoB;IAEpB,eAAe;EACjB;EACA;IACE,oBAAoB;IAEpB,eAAe;EACjB;EACA;IACE,oBAAoB;IAEpB,eAAe;EACjB;EACA;IACE,oBAAoB;IAEpB,eAAe;EACjB;EACA;IACE,oBAAoB;IAEpB,eAAe;EACjB;EACA;IACE,2BAA2B;IAE3B,sBAAsB;EACxB;EACA;IACE,2BAA2B;IAE3B,sBAAsB;EACxB;EACA;IACE,oBAAoB;IAEpB,eAAe;EACjB;EACA;IACE,2BAA2B;IAE3B,sBAAsB;EACxB;EACA;IACE,2BAA2B;IAE3B,sBAAsB;EACxB;EACA;IACE,0BAA0B;IAE1B,qBAAqB;EACvB;EACA;IACE,2BAA2B;IAE3B,sBAAsB;EACxB;EACA;IACE,oBAAoB;IAEpB,eAAe;EACjB;EACA;IACE,2BAA2B;IAE3B,sBAAsB;EACxB;EACA;IACE,2BAA2B;IAE3B,sBAAsB;EACxB;EACA;IACE,oBAAoB;IAEpB,eAAe;EACjB;EACA;IACE,2BAA2B;IAE3B,sBAAsB;EACxB;EACA;IACE,2BAA2B;IAE3B,sBAAsB;EACxB;EACA;IACE,oBAAoB;IAEpB,eAAe;EACjB;EACA;IACE,2BAA2B;IAE3B,sBAAsB;EACxB;EACA;IACE,2BAA2B;IAE3B,sBAAsB;EACxB;EACA;IACE,qBAAqB;IAErB,gBAAgB;EAClB;EACA;IACE,kBAAkB;IAElB,aAAa;EACf;EACA;IACE,wBAAwB;IAExB,mBAAmB;EACrB;EACA;IACE,uBAAuB;IAEvB,kBAAkB;EACpB;EACA;IACE,wBAAwB;IAExB,mBAAmB;EACrB;EACA;IACE,qBAAqB;IAErB,gBAAgB;EAClB;EACA;IACE,wBAAwB;IAExB,mBAAmB;EACrB;EACA;IACE,uBAAuB;IAEvB,kBAAkB;EACpB;EACA;IACE,wBAAwB;IAExB,mBAAmB;EACrB;EACA;IACE,qBAAqB;IAErB,gBAAgB;EAClB;EACA;IACE,wBAAwB;IAExB,mBAAmB;EACrB;EACA;IACE,uBAAuB;IAEvB,kBAAkB;EACpB;EACA;IACE,wBAAwB;IAExB,mBAAmB;EACrB;EACA;IACE,qBAAqB;IAErB,gBAAgB;EAClB;EACA;IACE,wBAAwB;IAExB,mBAAmB;EACrB;EACA;IACE,uBAAuB;IAEvB,kBAAkB;EACpB;EACA;IACE,wBAAwB;IAExB,mBAAmB;EACrB;EACA;IACE,qBAAqB;IAErB,gBAAgB;EAClB;EACA;IACE,qBAAqB;IAErB,gBAAgB;EAClB;EACA;IACE,qBAAqB;IAErB,gBAAgB;EAClB;EACA;IACE,qBAAqB;IAErB,gBAAgB;EAClB;EACA;IACE,qBAAqB;IAErB,gBAAgB;EAClB;EACA;IACE,qBAAqB;IAErB,gBAAgB;EAClB;EACA;IACE,sBAAsB;IAEtB,iBAAiB;EACnB;EACA;IACE,sBAAsB;IAEtB,iBAAiB;EACnB;EACA;IACE,sBAAsB;IAEtB,iBAAiB;EACnB;EACA;IACE,sBAAsB;IAEtB,iBAAiB;EACnB;EACA;IACE,sBAAsB;IAEtB,iBAAiB;EACnB;EACA;IACE,sBAAsB;IAEtB,iBAAiB;EACnB;EACA;IACE,sBAAsB;IAEtB,iBAAiB;EACnB;EACA;IACE,sBAAsB;IAEtB,iBAAiB;EACnB;EACA;IACE,sBAAsB;IAEtB,iBAAiB;EACnB;EACA;IACE,sBAAsB;IAEtB,iBAAiB;EACnB;EACA;IACE,oBAAoB;IAEpB,eAAe;EACjB;EACA;IACE,yBAAyB;IAEzB,oBAAoB;EACtB;EACA;IACE,yBAAyB;IAEzB,oBAAoB;EACtB;EACA;IACE,yBAAyB;IAEzB,oBAAoB;EACtB;EACA;IACE,yBAAyB;IAEzB,oBAAoB;EACtB;EACA;IACE,oBAAoB;IAEpB,eAAe;EACjB;EACA;IACE,2BAA2B;IAE3B,sBAAsB;EACxB;EACA;IACE,2BAA2B;IAE3B,sBAAsB;EACxB;EACA;IACE,oBAAoB;IAEpB,eAAe;EACjB;EACA;IACE,oBAAoB;IAEpB,eAAe;EACjB;EACA;IACE,oBAAoB;IAEpB,eAAe;EACjB;EACA;IACE,oBAAoB;IAEpB,eAAe;EACjB;EACA;IACE,oBAAoB;IAEpB,eAAe;EACjB;EACA;IACE,oBAAoB;IAEpB,eAAe;EACjB;EACA;IACE,oBAAoB;IAEpB,eAAe;EACjB;EACA;IACE,2BAA2B;IAE3B,sBAAsB;EACxB;EACA;IACE,2BAA2B;IAE3B,sBAAsB;EACxB;EACA;IACE,oBAAoB;IAEpB,eAAe;EACjB;EACA;IACE,2BAA2B;IAE3B,sBAAsB;EACxB;EACA;IACE,2BAA2B;IAE3B,sBAAsB;EACxB;EACA;IACE,0BAA0B;IAE1B,qBAAqB;EACvB;EACA;IACE,2BAA2B;IAE3B,sBAAsB;EACxB;EACA;IACE,oBAAoB;IAEpB,eAAe;EACjB;EACA;IACE,2BAA2B;IAE3B,sBAAsB;EACxB;EACA;IACE,2BAA2B;IAE3B,sBAAsB;EACxB;EACA;IACE,oBAAoB;IAEpB,eAAe;EACjB;EACA;IACE,2BAA2B;IAE3B,sBAAsB;EACxB;EACA;IACE,2BAA2B;IAE3B,sBAAsB;EACxB;EACA;IACE,oBAAoB;IAEpB,eAAe;EACjB;EACA;IACE,2BAA2B;IAE3B,sBAAsB;EACxB;EACA;IACE,2BAA2B;IAE3B,sBAAsB;EACxB;EACA;IACE,qBAAqB;IAErB,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,UAAU;EACZ;EACA;IACE,qBAAqB;IACrB,gBAAgB;EAClB;EACA;IACE,oBAAoB;IACpB,eAAe;EACjB;EACA;IACE,qBAAqB;IACrB,gBAAgB;EAClB;EACA;IACE,kBAAkB;IAClB,aAAa;EACf;EACA;IACE,qBAAqB;IACrB,gBAAgB;EAClB;EACA;IACE,oBAAoB;IACpB,eAAe;EACjB;EACA;IACE,qBAAqB;IACrB,gBAAgB;EAClB;EACA;IACE,kBAAkB;IAClB,aAAa;EACf;EACA;IACE,qBAAqB;IACrB,gBAAgB;EAClB;EACA;IACE,oBAAoB;IACpB,eAAe;EACjB;EACA;IACE,qBAAqB;IACrB,gBAAgB;EAClB;EACA;IACE,kBAAkB;IAClB,aAAa;EACf;EACA;IACE,qBAAqB;IACrB,gBAAgB;EAClB;EACA;IACE,oBAAoB;IACpB,eAAe;EACjB;EACA;IACE,qBAAqB;IACrB,gBAAgB;EAClB;EACA;IACE,kBAAkB;IAClB,aAAa;EACf;EACA;IACE,kBAAkB;IAClB,aAAa;EACf;EACA;IACE,kBAAkB;IAClB,aAAa;EACf;EACA;IACE,kBAAkB;IAClB,aAAa;EACf;EACA;IACE,kBAAkB;IAClB,aAAa;EACf;EACA;IACE,kBAAkB;IAClB,aAAa;EACf;EACA;IACE,mBAAmB;IACnB,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,cAAc;EAChB;EACA;IACE,iBAAiB;IACjB,YAAY;EACd;EACA;IACE,sBAAsB;IACtB,iBAAiB;EACnB;EACA;IACE,sBAAsB;IACtB,iBAAiB;EACnB;EACA;IACE,sBAAsB;IACtB,iBAAiB;EACnB;EACA;IACE,sBAAsB;IACtB,iBAAiB;EACnB;EACA;IACE,iBAAiB;IACjB,YAAY;EACd;EACA;IACE,wBAAwB;IACxB,mBAAmB;EACrB;EACA;IACE,wBAAwB;IACxB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,YAAY;EACd;EACA;IACE,iBAAiB;IACjB,YAAY;EACd;EACA;IACE,iBAAiB;IACjB,YAAY;EACd;EACA;IACE,iBAAiB;IACjB,YAAY;EACd;EACA;IACE,iBAAiB;IACjB,YAAY;EACd;EACA;IACE,iBAAiB;IACjB,YAAY;EACd;EACA;IACE,iBAAiB;IACjB,YAAY;EACd;EACA;IACE,wBAAwB;IACxB,mBAAmB;EACrB;EACA;IACE,wBAAwB;IACxB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,YAAY;EACd;EACA;IACE,wBAAwB;IACxB,mBAAmB;EACrB;EACA;IACE,wBAAwB;IACxB,mBAAmB;EACrB;EACA;IACE,uBAAuB;IACvB,kBAAkB;EACpB;EACA;IACE,wBAAwB;IACxB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,YAAY;EACd;EACA;IACE,wBAAwB;IACxB,mBAAmB;EACrB;EACA;IACE,wBAAwB;IACxB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,YAAY;EACd;EACA;IACE,wBAAwB;IACxB,mBAAmB;EACrB;EACA;IACE,wBAAwB;IACxB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,YAAY;EACd;EACA;IACE,wBAAwB;IACxB,mBAAmB;EACrB;EACA;IACE,wBAAwB;IACxB,mBAAmB;EACrB;EACA;IACE,kBAAkB;IAClB,aAAa;EACf;EACA;IACE,eAAe;IACf,UAAU;EACZ;EACA;IACE,qBAAqB;IACrB,gBAAgB;EAClB;EACA;IACE,oBAAoB;IACpB,eAAe;EACjB;EACA;IACE,qBAAqB;IACrB,gBAAgB;EAClB;EACA;IACE,kBAAkB;IAClB,aAAa;EACf;EACA;IACE,qBAAqB;IACrB,gBAAgB;EAClB;EACA;IACE,oBAAoB;IACpB,eAAe;EACjB;EACA;IACE,qBAAqB;IACrB,gBAAgB;EAClB;EACA;IACE,kBAAkB;IAClB,aAAa;EACf;EACA;IACE,qBAAqB;IACrB,gBAAgB;EAClB;EACA;IACE,oBAAoB;IACpB,eAAe;EACjB;EACA;IACE,qBAAqB;IACrB,gBAAgB;EAClB;EACA;IACE,kBAAkB;IAClB,aAAa;EACf;EACA;IACE,qBAAqB;IACrB,gBAAgB;EAClB;EACA;IACE,oBAAoB;IACpB,eAAe;EACjB;EACA;IACE,qBAAqB;IACrB,gBAAgB;EAClB;EACA;IACE,kBAAkB;IAClB,aAAa;EACf;EACA;IACE,kBAAkB;IAClB,aAAa;EACf;EACA;IACE,kBAAkB;IAClB,aAAa;EACf;EACA;IACE,kBAAkB;IAClB,aAAa;EACf;EACA;IACE,kBAAkB;IAClB,aAAa;EACf;EACA;IACE,kBAAkB;IAClB,aAAa;EACf;EACA;IACE,mBAAmB;IACnB,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,cAAc;EAChB;EACA;IACE,iBAAiB;IACjB,YAAY;EACd;EACA;IACE,sBAAsB;IACtB,iBAAiB;EACnB;EACA;IACE,sBAAsB;IACtB,iBAAiB;EACnB;EACA;IACE,sBAAsB;IACtB,iBAAiB;EACnB;EACA;IACE,sBAAsB;IACtB,iBAAiB;EACnB;EACA;IACE,iBAAiB;IACjB,YAAY;EACd;EACA;IACE,wBAAwB;IACxB,mBAAmB;EACrB;EACA;IACE,wBAAwB;IACxB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,YAAY;EACd;EACA;IACE,iBAAiB;IACjB,YAAY;EACd;EACA;IACE,iBAAiB;IACjB,YAAY;EACd;EACA;IACE,iBAAiB;IACjB,YAAY;EACd;EACA;IACE,iBAAiB;IACjB,YAAY;EACd;EACA;IACE,iBAAiB;IACjB,YAAY;EACd;EACA;IACE,iBAAiB;IACjB,YAAY;EACd;EACA;IACE,wBAAwB;IACxB,mBAAmB;EACrB;EACA;IACE,wBAAwB;IACxB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,YAAY;EACd;EACA;IACE,wBAAwB;IACxB,mBAAmB;EACrB;EACA;IACE,wBAAwB;IACxB,mBAAmB;EACrB;EACA;IACE,uBAAuB;IACvB,kBAAkB;EACpB;EACA;IACE,wBAAwB;IACxB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,YAAY;EACd;EACA;IACE,wBAAwB;IACxB,mBAAmB;EACrB;EACA;IACE,wBAAwB;IACxB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,YAAY;EACd;EACA;IACE,wBAAwB;IACxB,mBAAmB;EACrB;EACA;IACE,wBAAwB;IACxB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,YAAY;EACd;EACA;IACE,wBAAwB;IACxB,mBAAmB;EACrB;EACA;IACE,wBAAwB;IACxB,mBAAmB;EACrB;EACA;IACE,kBAAkB;IAClB,aAAa;EACf;EACA;IACE,mBAAmB;EACrB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,gDAAgD;EAClD;EACA;IACE,gDAAgD;EAClD;EACA;IACE,gDAAgD;EAClD;EACA;IACE,gDAAgD;EAClD;EACA;IACE,gDAAgD;EAClD;EACA;IACE,gDAAgD;EAClD;EACA;IACE,gDAAgD;EAClD;EACA;IACE,gDAAgD;EAClD;EACA;IACE,gDAAgD;EAClD;EACA;IACE,iDAAiD;EACnD;EACA;IACE,iDAAiD;EACnD;EACA;IACE,iDAAiD;EACnD;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,iBAAiB;EACnB;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,6CAA6C;EAC/C;EACA;IACE,6CAA6C;EAC/C;EACA;IACE,6CAA6C;EAC/C;EACA;IACE,6CAA6C;EAC/C;EACA;IACE,6CAA6C;EAC/C;EACA;IACE,6CAA6C;EAC/C;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,oBAAoB;EACtB;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,8BAA8B;EAChC;EACA;IACE,cAAc;EAChB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,gBAAgB;EAClB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,0BAA0B;IAC1B,0BAA0B;IAC1B,qBAAqB;IACrB,qBAAqB;IACrB,qBAAqB;IACrB,sBAAsB;IACtB,sBAAsB;IACtB,4PAA4P;EAC9P;EACA;IACE,eAAe;EACjB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,qBAAqB;EACvB;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,8BAA8B;EAChC;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,sBAAsB;IACtB,sBAAsB;EACxB;EACA;IACE,uBAAuB;IACvB,uBAAuB;EACzB;EACA;IACE,wBAAwB;IACxB,wBAAwB;EAC1B;EACA;IACE,uBAAuB;IACvB,uBAAuB;EACzB;EACA;IACE,wBAAwB;IACxB,wBAAwB;EAC1B;EACA;IACE,sBAAsB;IACtB,sBAAsB;EACxB;EACA;IACE,yBAAyB;IACzB,yBAAyB;EAC3B;EACA;IACE,wBAAwB;IACxB,wBAAwB;EAC1B;EACA;IACE,yBAAyB;IACzB,yBAAyB;EAC3B;EACA;IACE,wBAAwB;IACxB,wBAAwB;EAC1B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,sBAAsB;IACtB,sBAAsB;EACxB;EACA;IACE,uBAAuB;IACvB,uBAAuB;EACzB;EACA;IACE,wBAAwB;IACxB,wBAAwB;EAC1B;EACA;IACE,uBAAuB;IACvB,uBAAuB;EACzB;EACA;IACE,wBAAwB;IACxB,wBAAwB;EAC1B;EACA;IACE,sBAAsB;IACtB,sBAAsB;EACxB;EACA;IACE,yBAAyB;IACzB,yBAAyB;EAC3B;EACA;IACE,wBAAwB;IACxB,wBAAwB;EAC1B;EACA;IACE,yBAAyB;IACzB,yBAAyB;EAC3B;EACA;IACE,wBAAwB;IACxB,wBAAwB;EAC1B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,sBAAsB;IACtB,sBAAsB;EACxB;EACA;IACE,uBAAuB;IACvB,uBAAuB;EACzB;EACA;IACE,wBAAwB;IACxB,wBAAwB;EAC1B;EACA;IACE,uBAAuB;IACvB,uBAAuB;EACzB;EACA;IACE,wBAAwB;IACxB,wBAAwB;EAC1B;EACA;IACE,sBAAsB;IACtB,sBAAsB;EACxB;EACA;IACE,yBAAyB;IACzB,yBAAyB;EAC3B;EACA;IACE,wBAAwB;IACxB,wBAAwB;EAC1B;EACA;IACE,yBAAyB;IACzB,yBAAyB;EAC3B;EACA;IACE,wBAAwB;IACxB,wBAAwB;EAC1B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,qBAAqB;EACvB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,qBAAqB;EACvB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,qBAAqB;EACvB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,gCAAgC;EAClC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,gCAAgC;EAClC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,gCAAgC;EAClC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,gCAAgC;EAClC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,iCAAiC;EACnC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,iCAAiC;EACnC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,gCAAgC;EAClC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,gCAAgC;EAClC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,gCAAgC;EAClC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,gCAAgC;EAClC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,iCAAiC;EACnC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,iCAAiC;EACnC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,gCAAgC;EAClC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,gCAAgC;EAClC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,gCAAgC;EAClC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,gCAAgC;EAClC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,iCAAiC;EACnC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,iCAAiC;EACnC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,gCAAgC;EAClC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,gCAAgC;EAClC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,gCAAgC;EAClC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,gCAAgC;EAClC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,iCAAiC;EACnC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,iCAAiC;EACnC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,gCAAgC;EAClC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,gCAAgC;EAClC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,gCAAgC;EAClC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,gCAAgC;EAClC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,iCAAiC;EACnC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,iCAAiC;EACnC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,gCAAgC;EAClC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,gCAAgC;EAClC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,gCAAgC;EAClC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,gCAAgC;EAClC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,iCAAiC;EACnC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,iCAAiC;EACnC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,qBAAqB;EACvB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,qBAAqB;EACvB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,qBAAqB;EACvB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,qBAAqB;EACvB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,qBAAqB;EACvB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,qBAAqB;EACvB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wGAAwG;EAC1G;EACA;IACE,wEAAwE;EAC1E;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,+BAA+B;EACjC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,sDAAsD;EACxD;EACA;IACE,sDAAsD;EACxD;EACA;IACE,wDAAwD;EAC1D;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,eAAe;EACjB;EACA;IACE,kCAAkC;EACpC;EACA;IACE,sDAAsD;EACxD;EACA;IACE,yDAAyD;EAC3D;EACA;IACE,6BAA6B;EAC/B;AACF;AACA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,eAAe;EACf,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,eAAe;EACf,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,eAAe;EACf,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,eAAe;EACf,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,eAAe;EACf,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,eAAe;EACf,oBAAoB;AACtB;AACA;EACE,WAAW;EACX,eAAe;AACjB;AACA;EACE,WAAW;EACX,eAAe;AACjB;AACA;EACE,WAAW;EACX,eAAe;AACjB;AACA;EACE,WAAW;EACX,eAAe;EACf,wBAAwB;AAC1B;AACA;EACE,WAAW;EACX,eAAe;AACjB;AACA;EACE,WAAW;EACX,eAAe;EACf,wBAAwB;AAC1B;AACA;EACE,WAAW;EACX,eAAe;AACjB;AACA;EACE,WAAW;EACX,eAAe;AACjB;AACA;EACE,WAAW;EACX,eAAe;EACf,wBAAwB;AAC1B;AACA;EACE,WAAW;EACX,eAAe;AACjB;AACA;EACE,WAAW;EACX,eAAe;EACf,wBAAwB;AAC1B;AACA;EACE,WAAW;EACX,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,eAAe;EACf,wBAAwB;AAC1B;AACA;EACE,WAAW;EACX,eAAe;EACf,oBAAoB;AACtB;AACA;EACE,WAAW;EACX,eAAe;AACjB;AACA;EACE,WAAW;EACX,eAAe;AACjB;AACA;EACE,WAAW;EACX,eAAe;AACjB;AACA;EACE,WAAW;EACX,eAAe;AACjB;AACA;EACE,WAAW;EACX,eAAe;AACjB;AACA;EACE,WAAW;EACX,eAAe;AACjB;AACA;EACE,WAAW;EACX,eAAe;AACjB;AACA;EACE,WAAW;EACX,eAAe;AACjB;AACA;EACE,WAAW;EACX,eAAe;AACjB;AACA;EACE,WAAW;EACX,eAAe;AACjB;AACA;EACE,WAAW;EACX,eAAe;AACjB;AACA;EACE,WAAW;EACX,eAAe;AACjB;AACA;EACE;IACE,yBAAyB;EAC3B;AACF;AACA;EACE;IACE,mBAAmB;IACnB,UAAU;EACZ;AACF;AACA;EACE;IACE,YAAY;EACd;AACF;AACA;EACE;IACE,2BAA2B;IAC3B,qDAAqD;EACvD;EACA;IACE,eAAe;IACf,qDAAqD;EACvD;AACF","sourcesContent":["/*! tailwindcss v4.0.15 | MIT License | https://tailwindcss.com */\n/*! normalize.css v8.0.1 | MIT License | github.com/necolas/normalize.css */\n@layer theme, base, components, utilities;\n@layer theme {\n  :root, :host {\n    --font-sans: ui-sans-serif, system-ui, sans-serif, \"Apple Color Emoji\",\n      \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n    --font-mono: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\",\n      \"Courier New\", monospace;\n    --color-orange-100: oklch(0.954 0.038 75.164);\n    --color-orange-300: oklch(0.837 0.128 66.29);\n    --color-orange-400: oklch(0.75 0.183 55.934);\n    --color-green-400: oklch(0.792 0.209 151.711);\n    --color-green-500: oklch(0.723 0.219 149.579);\n    --color-green-600: oklch(0.627 0.194 149.214);\n    --color-green-700: oklch(0.527 0.154 150.069);\n    --color-green-900: oklch(0.393 0.095 152.535);\n    --color-indigo-500: oklch(0.585 0.233 277.117);\n    --color-indigo-600: oklch(0.511 0.262 276.966);\n    --color-indigo-700: oklch(0.457 0.24 277.023);\n    --color-gray-50: oklch(0.985 0.002 247.839);\n    --color-gray-100: oklch(0.967 0.003 264.542);\n    --color-gray-200: oklch(0.928 0.006 264.531);\n    --color-gray-300: oklch(0.872 0.01 258.338);\n    --color-gray-400: oklch(0.707 0.022 261.325);\n    --color-gray-500: oklch(0.551 0.027 264.364);\n    --color-gray-600: oklch(0.446 0.03 256.802);\n    --color-gray-700: oklch(0.373 0.034 259.733);\n    --color-gray-800: oklch(0.278 0.033 256.848);\n    --color-gray-900: oklch(0.21 0.034 264.665);\n    --color-black: #000;\n    --color-white: #fff;\n    --spacing: 0.25rem;\n    --container-md: 28rem;\n    --container-2xl: 42rem;\n    --container-4xl: 56rem;\n    --container-7xl: 80rem;\n    --text-xs: 0.75rem;\n    --text-xs--line-height: calc(1 / 0.75);\n    --text-sm: 0.875rem;\n    --text-sm--line-height: calc(1.25 / 0.875);\n    --text-base: 1rem;\n    --text-base--line-height: calc(1.5 / 1);\n    --text-lg: 1.125rem;\n    --text-lg--line-height: calc(1.75 / 1.125);\n    --text-2xl: 1.5rem;\n    --text-2xl--line-height: calc(2 / 1.5);\n    --text-3xl: 1.875rem;\n    --text-3xl--line-height: calc(2.25 / 1.875);\n    --text-4xl: 2.25rem;\n    --text-4xl--line-height: calc(2.5 / 2.25);\n    --font-weight-medium: 500;\n    --font-weight-semibold: 600;\n    --font-weight-bold: 700;\n    --font-weight-extrabold: 800;\n    --tracking-tight: -0.025em;\n    --radius-md: 0.375rem;\n    --radius-lg: 0.5rem;\n    --radius-xl: 0.75rem;\n    --radius-2xl: 1rem;\n    --radius-3xl: 1.5rem;\n    --ease-in: cubic-bezier(0.4, 0, 1, 1);\n    --ease-out: cubic-bezier(0, 0, 0.2, 1);\n    --ease-in-out: cubic-bezier(0.4, 0, 0.2, 1);\n    --default-transition-duration: 150ms;\n    --default-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n    --default-font-family: var(--font-sans);\n    --default-mono-font-family: var(--font-mono);\n  }\n}\n@layer base {\n  *, ::after, ::before, ::backdrop, ::file-selector-button {\n    box-sizing: border-box;\n    margin: 0;\n    padding: 0;\n    border: 0 solid;\n  }\n  html, :host {\n    line-height: 1.5;\n    -webkit-text-size-adjust: 100%;\n    tab-size: 4;\n    font-family: var(--default-font-family, ui-sans-serif, system-ui, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\");\n    font-feature-settings: var(--default-font-feature-settings, normal);\n    font-variation-settings: var(--default-font-variation-settings, normal);\n    -webkit-tap-highlight-color: transparent;\n  }\n  hr {\n    height: 0;\n    color: inherit;\n    border-top-width: 1px;\n  }\n  abbr:where([title]) {\n    -webkit-text-decoration: underline dotted;\n    text-decoration: underline dotted;\n  }\n  h1, h2, h3, h4, h5, h6 {\n    font-size: inherit;\n    font-weight: inherit;\n  }\n  a {\n    color: inherit;\n    -webkit-text-decoration: inherit;\n    text-decoration: inherit;\n  }\n  b, strong {\n    font-weight: bolder;\n  }\n  code, kbd, samp, pre {\n    font-family: var(--default-mono-font-family, ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace);\n    font-feature-settings: var(--default-mono-font-feature-settings, normal);\n    font-variation-settings: var(--default-mono-font-variation-settings, normal);\n    font-size: 1em;\n  }\n  small {\n    font-size: 80%;\n  }\n  sub, sup {\n    font-size: 75%;\n    line-height: 0;\n    position: relative;\n    vertical-align: baseline;\n  }\n  sub {\n    bottom: -0.25em;\n  }\n  sup {\n    top: -0.5em;\n  }\n  table {\n    text-indent: 0;\n    border-color: inherit;\n    border-collapse: collapse;\n  }\n  :-moz-focusring {\n    outline: auto;\n  }\n  progress {\n    vertical-align: baseline;\n  }\n  summary {\n    display: list-item;\n  }\n  ol, ul, menu {\n    list-style: none;\n  }\n  img, svg, video, canvas, audio, iframe, embed, object {\n    display: block;\n    vertical-align: middle;\n  }\n  img, video {\n    max-width: 100%;\n    height: auto;\n  }\n  button, input, select, optgroup, textarea, ::file-selector-button {\n    font: inherit;\n    font-feature-settings: inherit;\n    font-variation-settings: inherit;\n    letter-spacing: inherit;\n    color: inherit;\n    border-radius: 0;\n    background-color: transparent;\n    opacity: 1;\n  }\n  :where(select:is([multiple], [size])) optgroup {\n    font-weight: bolder;\n  }\n  :where(select:is([multiple], [size])) optgroup option {\n    padding-inline-start: 20px;\n  }\n  ::file-selector-button {\n    margin-inline-end: 4px;\n  }\n  ::placeholder {\n    opacity: 1;\n  }\n  @supports (not (-webkit-appearance: -apple-pay-button))  or (contain-intrinsic-size: 1px) {\n    ::placeholder {\n      color: color-mix(in oklab, currentColor 50%, transparent);\n    }\n  }\n  textarea {\n    resize: vertical;\n  }\n  ::-webkit-search-decoration {\n    -webkit-appearance: none;\n  }\n  ::-webkit-date-and-time-value {\n    min-height: 1lh;\n    text-align: inherit;\n  }\n  ::-webkit-datetime-edit {\n    display: inline-flex;\n  }\n  ::-webkit-datetime-edit-fields-wrapper {\n    padding: 0;\n  }\n  ::-webkit-datetime-edit, ::-webkit-datetime-edit-year-field, ::-webkit-datetime-edit-month-field, ::-webkit-datetime-edit-day-field, ::-webkit-datetime-edit-hour-field, ::-webkit-datetime-edit-minute-field, ::-webkit-datetime-edit-second-field, ::-webkit-datetime-edit-millisecond-field, ::-webkit-datetime-edit-meridiem-field {\n    padding-block: 0;\n  }\n  :-moz-ui-invalid {\n    box-shadow: none;\n  }\n  button, input:where([type=\"button\"], [type=\"reset\"], [type=\"submit\"]), ::file-selector-button {\n    appearance: button;\n  }\n  ::-webkit-inner-spin-button, ::-webkit-outer-spin-button {\n    height: auto;\n  }\n  [hidden]:where(:not([hidden=\"until-found\"])) {\n    display: none !important;\n  }\n}\n@layer utilities {\n  .pointer-events-none {\n    pointer-events: none;\n  }\n  .sr-only {\n    position: absolute;\n    width: 1px;\n    height: 1px;\n    padding: 0;\n    margin: -1px;\n    overflow: hidden;\n    clip: rect(0, 0, 0, 0);\n    white-space: nowrap;\n    border-width: 0;\n  }\n  .absolute {\n    position: absolute;\n  }\n  .relative {\n    position: relative;\n  }\n  .static {\n    position: static;\n  }\n  .inset-0 {\n    inset: calc(var(--spacing) * 0);\n  }\n  .top-0 {\n    top: calc(var(--spacing) * 0);\n  }\n  .top-\\[60px\\] {\n    top: 60px;\n  }\n  .right-0 {\n    right: calc(var(--spacing) * 0);\n  }\n  .left-0 {\n    left: calc(var(--spacing) * 0);\n  }\n  .left-\\[-254px\\] {\n    left: -254px;\n  }\n  .z-10 {\n    z-index: 10;\n  }\n  .col-span-1 {\n    grid-column: span 1 / span 1;\n  }\n  .col-span-2 {\n    grid-column: span 2 / span 2;\n  }\n  .col-span-3 {\n    grid-column: span 3 / span 3;\n  }\n  .col-start-1 {\n    grid-column-start: 1;\n  }\n  .row-start-1 {\n    grid-row-start: 1;\n  }\n  .container {\n    width: 100%;\n    @media (width >= 40rem) {\n      max-width: 40rem;\n    }\n    @media (width >= 48rem) {\n      max-width: 48rem;\n    }\n    @media (width >= 64rem) {\n      max-width: 64rem;\n    }\n    @media (width >= 80rem) {\n      max-width: 80rem;\n    }\n    @media (width >= 96rem) {\n      max-width: 96rem;\n    }\n  }\n  .-m-2 {\n    margin: calc(var(--spacing) * -2);\n  }\n  .m-0 {\n    margin: calc(var(--spacing) * 0);\n  }\n  .mx-20 {\n    margin-inline: calc(var(--spacing) * 20);\n  }\n  .mx-auto {\n    margin-inline: auto;\n  }\n  .my-8 {\n    margin-block: calc(var(--spacing) * 8);\n  }\n  .my-20 {\n    margin-block: calc(var(--spacing) * 20);\n  }\n  .mt-1 {\n    margin-top: calc(var(--spacing) * 1);\n  }\n  .mt-2 {\n    margin-top: calc(var(--spacing) * 2);\n  }\n  .mt-3 {\n    margin-top: calc(var(--spacing) * 3);\n  }\n  .mt-4 {\n    margin-top: calc(var(--spacing) * 4);\n  }\n  .mt-6 {\n    margin-top: calc(var(--spacing) * 6);\n  }\n  .mt-10 {\n    margin-top: calc(var(--spacing) * 10);\n  }\n  .mt-12 {\n    margin-top: calc(var(--spacing) * 12);\n  }\n  .mt-16 {\n    margin-top: calc(var(--spacing) * 16);\n  }\n  .mt-32 {\n    margin-top: calc(var(--spacing) * 32);\n  }\n  .mr-2 {\n    margin-right: calc(var(--spacing) * 2);\n  }\n  .mr-4 {\n    margin-right: calc(var(--spacing) * 4);\n  }\n  .mr-8 {\n    margin-right: calc(var(--spacing) * 8);\n  }\n  .mb-4 {\n    margin-bottom: calc(var(--spacing) * 4);\n  }\n  .mb-10 {\n    margin-bottom: calc(var(--spacing) * 10);\n  }\n  .mb-20 {\n    margin-bottom: calc(var(--spacing) * 20);\n  }\n  .mb-40 {\n    margin-bottom: calc(var(--spacing) * 40);\n  }\n  .ml-2 {\n    margin-left: calc(var(--spacing) * 2);\n  }\n  .ml-4 {\n    margin-left: calc(var(--spacing) * 4);\n  }\n  .block {\n    display: block;\n  }\n  .contents {\n    display: contents;\n  }\n  .flex {\n    display: flex;\n  }\n  .grid {\n    display: grid;\n  }\n  .hidden {\n    display: none;\n  }\n  .inline {\n    display: inline;\n  }\n  .inline-block {\n    display: inline-block;\n  }\n  .inline-flex {\n    display: inline-flex;\n  }\n  .aspect-square {\n    aspect-ratio: 1 / 1;\n  }\n  .size-5 {\n    width: calc(var(--spacing) * 5);\n    height: calc(var(--spacing) * 5);\n  }\n  .size-24 {\n    width: calc(var(--spacing) * 24);\n    height: calc(var(--spacing) * 24);\n  }\n  .size-full {\n    width: 100%;\n    height: 100%;\n  }\n  .h-1\\/3 {\n    height: calc(1/3 * 100%);\n  }\n  .h-4 {\n    height: calc(var(--spacing) * 4);\n  }\n  .h-5 {\n    height: calc(var(--spacing) * 5);\n  }\n  .h-8 {\n    height: calc(var(--spacing) * 8);\n  }\n  .h-10 {\n    height: calc(var(--spacing) * 10);\n  }\n  .h-12 {\n    height: calc(var(--spacing) * 12);\n  }\n  .h-16 {\n    height: calc(var(--spacing) * 16);\n  }\n  .h-full {\n    height: 100%;\n  }\n  .h-screen {\n    height: 100vh;\n  }\n  .min-h-full {\n    min-height: 100%;\n  }\n  .w-1\\/2 {\n    width: calc(1/2 * 100%);\n  }\n  .w-3\\/4 {\n    width: calc(3/4 * 100%);\n  }\n  .w-4 {\n    width: calc(var(--spacing) * 4);\n  }\n  .w-5 {\n    width: calc(var(--spacing) * 5);\n  }\n  .w-10 {\n    width: calc(var(--spacing) * 10);\n  }\n  .w-16 {\n    width: calc(var(--spacing) * 16);\n  }\n  .w-52 {\n    width: calc(var(--spacing) * 52);\n  }\n  .w-56 {\n    width: calc(var(--spacing) * 56);\n  }\n  .w-92 {\n    width: calc(var(--spacing) * 92);\n  }\n  .w-fit {\n    width: fit-content;\n  }\n  .w-full {\n    width: 100%;\n  }\n  .max-w-2xl {\n    max-width: var(--container-2xl);\n  }\n  .max-w-4xl {\n    max-width: var(--container-4xl);\n  }\n  .max-w-16 {\n    max-width: calc(var(--spacing) * 16);\n  }\n  .flex-1 {\n    flex: 1;\n  }\n  .shrink-0 {\n    flex-shrink: 0;\n  }\n  .grow {\n    flex-grow: 1;\n  }\n  .origin-top-right {\n    transform-origin: top right;\n  }\n  .-translate-x-full {\n    --tw-translate-x: -100%;\n    translate: var(--tw-translate-x) var(--tw-translate-y);\n  }\n  .translate-x-0 {\n    --tw-translate-x: calc(var(--spacing) * 0);\n    translate: var(--tw-translate-x) var(--tw-translate-y);\n  }\n  .translate-x-full {\n    --tw-translate-x: 100%;\n    translate: var(--tw-translate-x) var(--tw-translate-y);\n  }\n  .scale-95 {\n    --tw-scale-x: 95%;\n    --tw-scale-y: 95%;\n    --tw-scale-z: 95%;\n    scale: var(--tw-scale-x) var(--tw-scale-y);\n  }\n  .scale-100 {\n    --tw-scale-x: 100%;\n    --tw-scale-y: 100%;\n    --tw-scale-z: 100%;\n    scale: var(--tw-scale-x) var(--tw-scale-y);\n  }\n  .transform {\n    transform: var(--tw-rotate-x) var(--tw-rotate-y) var(--tw-rotate-z) var(--tw-skew-x) var(--tw-skew-y);\n  }\n  .cursor-crosshair {\n    cursor: crosshair;\n  }\n  .cursor-not-allowed {\n    cursor: not-allowed;\n  }\n  .cursor-pointer {\n    cursor: pointer;\n  }\n  .resize {\n    resize: both;\n  }\n  .appearance-none {\n    appearance: none;\n  }\n  .grid-cols-1 {\n    grid-template-columns: repeat(1, minmax(0, 1fr));\n  }\n  .grid-cols-2 {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n  .grid-cols-3 {\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n  }\n  .grid-cols-8 {\n    grid-template-columns: repeat(8, minmax(0, 1fr));\n  }\n  .flex-col {\n    flex-direction: column;\n  }\n  .items-center {\n    align-items: center;\n  }\n  .justify-between {\n    justify-content: space-between;\n  }\n  .justify-center {\n    justify-content: center;\n  }\n  .justify-end {\n    justify-content: flex-end;\n  }\n  .gap-0 {\n    gap: calc(var(--spacing) * 0);\n  }\n  .gap-3 {\n    gap: calc(var(--spacing) * 3);\n  }\n  .gap-4 {\n    gap: calc(var(--spacing) * 4);\n  }\n  .gap-8 {\n    gap: calc(var(--spacing) * 8);\n  }\n  .space-y-0 {\n    :where(& > :not(:last-child)) {\n      --tw-space-y-reverse: 0;\n      margin-block-start: calc(calc(var(--spacing) * 0) * var(--tw-space-y-reverse));\n      margin-block-end: calc(calc(var(--spacing) * 0) * calc(1 - var(--tw-space-y-reverse)));\n    }\n  }\n  .space-y-2 {\n    :where(& > :not(:last-child)) {\n      --tw-space-y-reverse: 0;\n      margin-block-start: calc(calc(var(--spacing) * 2) * var(--tw-space-y-reverse));\n      margin-block-end: calc(calc(var(--spacing) * 2) * calc(1 - var(--tw-space-y-reverse)));\n    }\n  }\n  .space-y-4 {\n    :where(& > :not(:last-child)) {\n      --tw-space-y-reverse: 0;\n      margin-block-start: calc(calc(var(--spacing) * 4) * var(--tw-space-y-reverse));\n      margin-block-end: calc(calc(var(--spacing) * 4) * calc(1 - var(--tw-space-y-reverse)));\n    }\n  }\n  .space-y-6 {\n    :where(& > :not(:last-child)) {\n      --tw-space-y-reverse: 0;\n      margin-block-start: calc(calc(var(--spacing) * 6) * var(--tw-space-y-reverse));\n      margin-block-end: calc(calc(var(--spacing) * 6) * calc(1 - var(--tw-space-y-reverse)));\n    }\n  }\n  .space-y-8 {\n    :where(& > :not(:last-child)) {\n      --tw-space-y-reverse: 0;\n      margin-block-start: calc(calc(var(--spacing) * 8) * var(--tw-space-y-reverse));\n      margin-block-end: calc(calc(var(--spacing) * 8) * calc(1 - var(--tw-space-y-reverse)));\n    }\n  }\n  .gap-x-1\\.5 {\n    column-gap: calc(var(--spacing) * 1.5);\n  }\n  .gap-x-8 {\n    column-gap: calc(var(--spacing) * 8);\n  }\n  .space-x-2 {\n    :where(& > :not(:last-child)) {\n      --tw-space-x-reverse: 0;\n      margin-inline-start: calc(calc(var(--spacing) * 2) * var(--tw-space-x-reverse));\n      margin-inline-end: calc(calc(var(--spacing) * 2) * calc(1 - var(--tw-space-x-reverse)));\n    }\n  }\n  .space-x-4 {\n    :where(& > :not(:last-child)) {\n      --tw-space-x-reverse: 0;\n      margin-inline-start: calc(calc(var(--spacing) * 4) * var(--tw-space-x-reverse));\n      margin-inline-end: calc(calc(var(--spacing) * 4) * calc(1 - var(--tw-space-x-reverse)));\n    }\n  }\n  .divide-y {\n    :where(& > :not(:last-child)) {\n      --tw-divide-y-reverse: 0;\n      border-bottom-style: var(--tw-border-style);\n      border-top-style: var(--tw-border-style);\n      border-top-width: calc(1px * var(--tw-divide-y-reverse));\n      border-bottom-width: calc(1px * calc(1 - var(--tw-divide-y-reverse)));\n    }\n  }\n  .divide-gray-200 {\n    :where(& > :not(:last-child)) {\n      border-color: var(--color-gray-200);\n    }\n  }\n  .self-center {\n    align-self: center;\n  }\n  .justify-self-end {\n    justify-self: flex-end;\n  }\n  .rounded {\n    border-radius: 0.25rem;\n  }\n  .rounded-2xl {\n    border-radius: var(--radius-2xl);\n  }\n  .rounded-3xl {\n    border-radius: var(--radius-3xl);\n  }\n  .rounded-full {\n    border-radius: calc(infinity * 1px);\n  }\n  .rounded-lg {\n    border-radius: var(--radius-lg);\n  }\n  .rounded-md {\n    border-radius: var(--radius-md);\n  }\n  .rounded-xl {\n    border-radius: var(--radius-xl);\n  }\n  .border {\n    border-style: var(--tw-border-style);\n    border-width: 1px;\n  }\n  .border-0 {\n    border-style: var(--tw-border-style);\n    border-width: 0px;\n  }\n  .border-12 {\n    border-style: var(--tw-border-style);\n    border-width: 12px;\n  }\n  .border-t {\n    border-top-style: var(--tw-border-style);\n    border-top-width: 1px;\n  }\n  .border-b {\n    border-bottom-style: var(--tw-border-style);\n    border-bottom-width: 1px;\n  }\n  .border-l {\n    border-left-style: var(--tw-border-style);\n    border-left-width: 1px;\n  }\n  .border-none {\n    --tw-border-style: none;\n    border-style: none;\n  }\n  .border-gray-200 {\n    border-color: var(--color-gray-200);\n  }\n  .border-gray-300 {\n    border-color: var(--color-gray-300);\n  }\n  .border-transparent {\n    border-color: transparent;\n  }\n  .bg-gray-50 {\n    background-color: var(--color-gray-50);\n  }\n  .bg-gray-100 {\n    background-color: var(--color-gray-100);\n  }\n  .bg-gray-200 {\n    background-color: var(--color-gray-200);\n  }\n  .bg-gray-400 {\n    background-color: var(--color-gray-400);\n  }\n  .bg-green-400 {\n    background-color: var(--color-green-400);\n  }\n  .bg-green-600 {\n    background-color: var(--color-green-600);\n  }\n  .bg-green-700 {\n    background-color: var(--color-green-700);\n  }\n  .bg-green-900 {\n    background-color: var(--color-green-900);\n  }\n  .bg-indigo-600 {\n    background-color: var(--color-indigo-600);\n  }\n  .bg-orange-300 {\n    background-color: var(--color-orange-300);\n  }\n  .bg-orange-400 {\n    background-color: var(--color-orange-400);\n  }\n  .bg-white {\n    background-color: var(--color-white);\n  }\n  .fill-\\[\\#24292F\\] {\n    fill: #24292F;\n  }\n  .object-cover {\n    object-fit: cover;\n  }\n  .p-0 {\n    padding: calc(var(--spacing) * 0);\n  }\n  .p-1 {\n    padding: calc(var(--spacing) * 1);\n  }\n  .p-1\\.5 {\n    padding: calc(var(--spacing) * 1.5);\n  }\n  .p-2 {\n    padding: calc(var(--spacing) * 2);\n  }\n  .p-4 {\n    padding: calc(var(--spacing) * 4);\n  }\n  .p-10 {\n    padding: calc(var(--spacing) * 10);\n  }\n  .px-0 {\n    padding-inline: calc(var(--spacing) * 0);\n  }\n  .px-1\\.5 {\n    padding-inline: calc(var(--spacing) * 1.5);\n  }\n  .px-2 {\n    padding-inline: calc(var(--spacing) * 2);\n  }\n  .px-2\\.5 {\n    padding-inline: calc(var(--spacing) * 2.5);\n  }\n  .px-3 {\n    padding-inline: calc(var(--spacing) * 3);\n  }\n  .px-4 {\n    padding-inline: calc(var(--spacing) * 4);\n  }\n  .px-6 {\n    padding-inline: calc(var(--spacing) * 6);\n  }\n  .px-8 {\n    padding-inline: calc(var(--spacing) * 8);\n  }\n  .py-1 {\n    padding-block: calc(var(--spacing) * 1);\n  }\n  .py-1\\.5 {\n    padding-block: calc(var(--spacing) * 1.5);\n  }\n  .py-2 {\n    padding-block: calc(var(--spacing) * 2);\n  }\n  .py-3 {\n    padding-block: calc(var(--spacing) * 3);\n  }\n  .py-4 {\n    padding-block: calc(var(--spacing) * 4);\n  }\n  .py-6 {\n    padding-block: calc(var(--spacing) * 6);\n  }\n  .py-12 {\n    padding-block: calc(var(--spacing) * 12);\n  }\n  .pt-2 {\n    padding-top: calc(var(--spacing) * 2);\n  }\n  .pt-4 {\n    padding-top: calc(var(--spacing) * 4);\n  }\n  .pt-8 {\n    padding-top: calc(var(--spacing) * 8);\n  }\n  .pt-16 {\n    padding-top: calc(var(--spacing) * 16);\n  }\n  .pr-2 {\n    padding-right: calc(var(--spacing) * 2);\n  }\n  .pr-8 {\n    padding-right: calc(var(--spacing) * 8);\n  }\n  .pr-9 {\n    padding-right: calc(var(--spacing) * 9);\n  }\n  .pb-4 {\n    padding-bottom: calc(var(--spacing) * 4);\n  }\n  .pb-8 {\n    padding-bottom: calc(var(--spacing) * 8);\n  }\n  .pb-24 {\n    padding-bottom: calc(var(--spacing) * 24);\n  }\n  .pl-3 {\n    padding-left: calc(var(--spacing) * 3);\n  }\n  .pl-4 {\n    padding-left: calc(var(--spacing) * 4);\n  }\n  .text-center {\n    text-align: center;\n  }\n  .text-left {\n    text-align: left;\n  }\n  .text-2xl {\n    font-size: var(--text-2xl);\n    line-height: var(--tw-leading, var(--text-2xl--line-height));\n  }\n  .text-3xl {\n    font-size: var(--text-3xl);\n    line-height: var(--tw-leading, var(--text-3xl--line-height));\n  }\n  .text-base {\n    font-size: var(--text-base);\n    line-height: var(--tw-leading, var(--text-base--line-height));\n  }\n  .text-lg {\n    font-size: var(--text-lg);\n    line-height: var(--tw-leading, var(--text-lg--line-height));\n  }\n  .text-sm {\n    font-size: var(--text-sm);\n    line-height: var(--tw-leading, var(--text-sm--line-height));\n  }\n  .text-xs {\n    font-size: var(--text-xs);\n    line-height: var(--tw-leading, var(--text-xs--line-height));\n  }\n  .leading-5 {\n    --tw-leading: calc(var(--spacing) * 5);\n    line-height: calc(var(--spacing) * 5);\n  }\n  .leading-6 {\n    --tw-leading: calc(var(--spacing) * 6);\n    line-height: calc(var(--spacing) * 6);\n  }\n  .leading-9 {\n    --tw-leading: calc(var(--spacing) * 9);\n    line-height: calc(var(--spacing) * 9);\n  }\n  .font-bold {\n    --tw-font-weight: var(--font-weight-bold);\n    font-weight: var(--font-weight-bold);\n  }\n  .font-extrabold {\n    --tw-font-weight: var(--font-weight-extrabold);\n    font-weight: var(--font-weight-extrabold);\n  }\n  .font-medium {\n    --tw-font-weight: var(--font-weight-medium);\n    font-weight: var(--font-weight-medium);\n  }\n  .font-semibold {\n    --tw-font-weight: var(--font-weight-semibold);\n    font-weight: var(--font-weight-semibold);\n  }\n  .tracking-tight {\n    --tw-tracking: var(--tracking-tight);\n    letter-spacing: var(--tracking-tight);\n  }\n  .text-wrap {\n    text-wrap: wrap;\n  }\n  .text-black {\n    color: var(--color-black);\n  }\n  .text-gray-100 {\n    color: var(--color-gray-100);\n  }\n  .text-gray-300 {\n    color: var(--color-gray-300);\n  }\n  .text-gray-400 {\n    color: var(--color-gray-400);\n  }\n  .text-gray-500 {\n    color: var(--color-gray-500);\n  }\n  .text-gray-600 {\n    color: var(--color-gray-600);\n  }\n  .text-gray-700 {\n    color: var(--color-gray-700);\n  }\n  .text-gray-900 {\n    color: var(--color-gray-900);\n  }\n  .text-green-500 {\n    color: var(--color-green-500);\n  }\n  .text-green-600 {\n    color: var(--color-green-600);\n  }\n  .text-green-700 {\n    color: var(--color-green-700);\n  }\n  .text-indigo-600 {\n    color: var(--color-indigo-600);\n  }\n  .text-white {\n    color: var(--color-white);\n  }\n  .underline {\n    text-decoration-line: underline;\n  }\n  .opacity-0 {\n    opacity: 0%;\n  }\n  .opacity-50 {\n    opacity: 50%;\n  }\n  .opacity-100 {\n    opacity: 100%;\n  }\n  .shadow {\n    --tw-shadow: 0 1px 3px 0 var(--tw-shadow-color, rgb(0 0 0 / 0.1)), 0 1px 2px -1px var(--tw-shadow-color, rgb(0 0 0 / 0.1));\n    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);\n  }\n  .shadow-2xl {\n    --tw-shadow: 0 25px 50px -12px var(--tw-shadow-color, rgb(0 0 0 / 0.25));\n    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);\n  }\n  .shadow-lg {\n    --tw-shadow: 0 10px 15px -3px var(--tw-shadow-color, rgb(0 0 0 / 0.1)), 0 4px 6px -4px var(--tw-shadow-color, rgb(0 0 0 / 0.1));\n    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);\n  }\n  .shadow-md {\n    --tw-shadow: 0 4px 6px -1px var(--tw-shadow-color, rgb(0 0 0 / 0.1)), 0 2px 4px -2px var(--tw-shadow-color, rgb(0 0 0 / 0.1));\n    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);\n  }\n  .shadow-sm {\n    --tw-shadow: 0 1px 3px 0 var(--tw-shadow-color, rgb(0 0 0 / 0.1)), 0 1px 2px -1px var(--tw-shadow-color, rgb(0 0 0 / 0.1));\n    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);\n  }\n  .ring-1 {\n    --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentColor);\n    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);\n  }\n  .ring-black {\n    --tw-ring-color: var(--color-black);\n  }\n  .ring-gray-200 {\n    --tw-ring-color: var(--color-gray-200);\n  }\n  .ring-gray-300 {\n    --tw-ring-color: var(--color-gray-300);\n  }\n  .outline {\n    outline-style: var(--tw-outline-style);\n    outline-width: 1px;\n  }\n  .outline-1 {\n    outline-style: var(--tw-outline-style);\n    outline-width: 1px;\n  }\n  .-outline-offset-1 {\n    outline-offset: calc(1px * -1);\n  }\n  .outline-gray-300 {\n    outline-color: var(--color-gray-300);\n  }\n  .filter {\n    filter: var(--tw-blur,) var(--tw-brightness,) var(--tw-contrast,) var(--tw-grayscale,) var(--tw-hue-rotate,) var(--tw-invert,) var(--tw-saturate,) var(--tw-sepia,) var(--tw-drop-shadow,);\n  }\n  .transition {\n    transition-property: color, background-color, border-color, outline-color, text-decoration-color, fill, stroke, --tw-gradient-from, --tw-gradient-via, --tw-gradient-to, opacity, box-shadow, transform, translate, scale, rotate, filter, -webkit-backdrop-filter, backdrop-filter;\n    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));\n    transition-duration: var(--tw-duration, var(--default-transition-duration));\n  }\n  .transition-opacity {\n    transition-property: opacity;\n    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));\n    transition-duration: var(--tw-duration, var(--default-transition-duration));\n  }\n  .duration-75 {\n    --tw-duration: 75ms;\n    transition-duration: 75ms;\n  }\n  .duration-100 {\n    --tw-duration: 100ms;\n    transition-duration: 100ms;\n  }\n  .duration-300 {\n    --tw-duration: 300ms;\n    transition-duration: 300ms;\n  }\n  .duration-700 {\n    --tw-duration: 700ms;\n    transition-duration: 700ms;\n  }\n  .duration-1000 {\n    --tw-duration: 1000ms;\n    transition-duration: 1000ms;\n  }\n  .ease-in {\n    --tw-ease: var(--ease-in);\n    transition-timing-function: var(--ease-in);\n  }\n  .ease-in-out {\n    --tw-ease: var(--ease-in-out);\n    transition-timing-function: var(--ease-in-out);\n  }\n  .ease-out {\n    --tw-ease: var(--ease-out);\n    transition-timing-function: var(--ease-out);\n  }\n  .ring-inset {\n    --tw-ring-inset: inset;\n  }\n  .placeholder\\:text-gray-400 {\n    &::placeholder {\n      color: var(--color-gray-400);\n    }\n  }\n  .hover\\:bg-gray-50 {\n    &:hover {\n      @media (hover: hover) {\n        background-color: var(--color-gray-50);\n      }\n    }\n  }\n  .hover\\:bg-gray-500 {\n    &:hover {\n      @media (hover: hover) {\n        background-color: var(--color-gray-500);\n      }\n    }\n  }\n  .hover\\:bg-green-500 {\n    &:hover {\n      @media (hover: hover) {\n        background-color: var(--color-green-500);\n      }\n    }\n  }\n  .hover\\:bg-indigo-700 {\n    &:hover {\n      @media (hover: hover) {\n        background-color: var(--color-indigo-700);\n      }\n    }\n  }\n  .hover\\:bg-orange-100 {\n    &:hover {\n      @media (hover: hover) {\n        background-color: var(--color-orange-100);\n      }\n    }\n  }\n  .hover\\:text-gray-500 {\n    &:hover {\n      @media (hover: hover) {\n        color: var(--color-gray-500);\n      }\n    }\n  }\n  .hover\\:text-gray-800 {\n    &:hover {\n      @media (hover: hover) {\n        color: var(--color-gray-800);\n      }\n    }\n  }\n  .hover\\:text-green-500 {\n    &:hover {\n      @media (hover: hover) {\n        color: var(--color-green-500);\n      }\n    }\n  }\n  .hover\\:text-indigo-500 {\n    &:hover {\n      @media (hover: hover) {\n        color: var(--color-indigo-500);\n      }\n    }\n  }\n  .focus\\:ring-2 {\n    &:focus {\n      --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentColor);\n      box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);\n    }\n  }\n  .focus\\:ring-green-600 {\n    &:focus {\n      --tw-ring-color: var(--color-green-600);\n    }\n  }\n  .focus\\:ring-indigo-500 {\n    &:focus {\n      --tw-ring-color: var(--color-indigo-500);\n    }\n  }\n  .focus\\:ring-indigo-600 {\n    &:focus {\n      --tw-ring-color: var(--color-indigo-600);\n    }\n  }\n  .focus\\:ring-offset-2 {\n    &:focus {\n      --tw-ring-offset-width: 2px;\n      --tw-ring-offset-shadow: var(--tw-ring-inset,) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);\n    }\n  }\n  .focus\\:ring-offset-gray-50 {\n    &:focus {\n      --tw-ring-offset-color: var(--color-gray-50);\n    }\n  }\n  .focus\\:outline {\n    &:focus {\n      outline-style: var(--tw-outline-style);\n      outline-width: 1px;\n    }\n  }\n  .focus\\:outline-2 {\n    &:focus {\n      outline-style: var(--tw-outline-style);\n      outline-width: 2px;\n    }\n  }\n  .focus\\:-outline-offset-2 {\n    &:focus {\n      outline-offset: calc(2px * -1);\n    }\n  }\n  .focus\\:outline-indigo-600 {\n    &:focus {\n      outline-color: var(--color-indigo-600);\n    }\n  }\n  .focus\\:outline-none {\n    &:focus {\n      --tw-outline-style: none;\n      outline-style: none;\n    }\n  }\n  .focus\\:ring-inset {\n    &:focus {\n      --tw-ring-inset: inset;\n    }\n  }\n  .focus-visible\\:ring-transparent {\n    &:focus-visible {\n      --tw-ring-color: transparent;\n    }\n  }\n  .focus-visible\\:outline {\n    &:focus-visible {\n      outline-style: var(--tw-outline-style);\n      outline-width: 1px;\n    }\n  }\n  .focus-visible\\:outline-2 {\n    &:focus-visible {\n      outline-style: var(--tw-outline-style);\n      outline-width: 2px;\n    }\n  }\n  .focus-visible\\:outline-offset-2 {\n    &:focus-visible {\n      outline-offset: 2px;\n    }\n  }\n  .focus-visible\\:outline-indigo-600 {\n    &:focus-visible {\n      outline-color: var(--color-indigo-600);\n    }\n  }\n  .sm\\:mx-auto {\n    @media (width >= 40rem) {\n      margin-inline: auto;\n    }\n  }\n  .sm\\:mt-0 {\n    @media (width >= 40rem) {\n      margin-top: calc(var(--spacing) * 0);\n    }\n  }\n  .sm\\:mt-10 {\n    @media (width >= 40rem) {\n      margin-top: calc(var(--spacing) * 10);\n    }\n  }\n  .sm\\:ml-6 {\n    @media (width >= 40rem) {\n      margin-left: calc(var(--spacing) * 6);\n    }\n  }\n  .sm\\:flex {\n    @media (width >= 40rem) {\n      display: flex;\n    }\n  }\n  .sm\\:grid {\n    @media (width >= 40rem) {\n      display: grid;\n    }\n  }\n  .sm\\:size-4 {\n    @media (width >= 40rem) {\n      width: calc(var(--spacing) * 4);\n      height: calc(var(--spacing) * 4);\n    }\n  }\n  .sm\\:size-48 {\n    @media (width >= 40rem) {\n      width: calc(var(--spacing) * 48);\n      height: calc(var(--spacing) * 48);\n    }\n  }\n  .sm\\:w-full {\n    @media (width >= 40rem) {\n      width: 100%;\n    }\n  }\n  .sm\\:max-w-\\[480px\\] {\n    @media (width >= 40rem) {\n      max-width: 480px;\n    }\n  }\n  .sm\\:max-w-md {\n    @media (width >= 40rem) {\n      max-width: var(--container-md);\n    }\n  }\n  .sm\\:grid-cols-2 {\n    @media (width >= 40rem) {\n      grid-template-columns: repeat(2, minmax(0, 1fr));\n    }\n  }\n  .sm\\:gap-x-6 {\n    @media (width >= 40rem) {\n      column-gap: calc(var(--spacing) * 6);\n    }\n  }\n  .sm\\:rounded-xl {\n    @media (width >= 40rem) {\n      border-radius: var(--radius-xl);\n    }\n  }\n  .sm\\:p-6 {\n    @media (width >= 40rem) {\n      padding: calc(var(--spacing) * 6);\n    }\n  }\n  .sm\\:px-6 {\n    @media (width >= 40rem) {\n      padding-inline: calc(var(--spacing) * 6);\n    }\n  }\n  .sm\\:px-12 {\n    @media (width >= 40rem) {\n      padding-inline: calc(var(--spacing) * 12);\n    }\n  }\n  .sm\\:py-10 {\n    @media (width >= 40rem) {\n      padding-block: calc(var(--spacing) * 10);\n    }\n  }\n  .sm\\:pr-0 {\n    @media (width >= 40rem) {\n      padding-right: calc(var(--spacing) * 0);\n    }\n  }\n  .sm\\:pr-9 {\n    @media (width >= 40rem) {\n      padding-right: calc(var(--spacing) * 9);\n    }\n  }\n  .sm\\:text-4xl {\n    @media (width >= 40rem) {\n      font-size: var(--text-4xl);\n      line-height: var(--tw-leading, var(--text-4xl--line-height));\n    }\n  }\n  .sm\\:text-sm {\n    @media (width >= 40rem) {\n      font-size: var(--text-sm);\n      line-height: var(--tw-leading, var(--text-sm--line-height));\n    }\n  }\n  .sm\\:text-sm\\/6 {\n    @media (width >= 40rem) {\n      font-size: var(--text-sm);\n      line-height: calc(var(--spacing) * 6);\n    }\n  }\n  .sm\\:leading-6 {\n    @media (width >= 40rem) {\n      --tw-leading: calc(var(--spacing) * 6);\n      line-height: calc(var(--spacing) * 6);\n    }\n  }\n  .md\\:grid-cols-2 {\n    @media (width >= 48rem) {\n      grid-template-columns: repeat(2, minmax(0, 1fr));\n    }\n  }\n  .md\\:p-4 {\n    @media (width >= 48rem) {\n      padding: calc(var(--spacing) * 4);\n    }\n  }\n  .md\\:px-0 {\n    @media (width >= 48rem) {\n      padding-inline: calc(var(--spacing) * 0);\n    }\n  }\n  .md\\:px-4 {\n    @media (width >= 48rem) {\n      padding-inline: calc(var(--spacing) * 4);\n    }\n  }\n  .md\\:pt-8 {\n    @media (width >= 48rem) {\n      padding-top: calc(var(--spacing) * 8);\n    }\n  }\n  .md\\:text-left {\n    @media (width >= 48rem) {\n      text-align: left;\n    }\n  }\n  .lg\\:col-span-5 {\n    @media (width >= 64rem) {\n      grid-column: span 5 / span 5;\n    }\n  }\n  .lg\\:col-span-7 {\n    @media (width >= 64rem) {\n      grid-column: span 7 / span 7;\n    }\n  }\n  .lg\\:mt-0 {\n    @media (width >= 64rem) {\n      margin-top: calc(var(--spacing) * 0);\n    }\n  }\n  .lg\\:grid {\n    @media (width >= 64rem) {\n      display: grid;\n    }\n  }\n  .lg\\:w-1\\/2 {\n    @media (width >= 64rem) {\n      width: calc(1/2 * 100%);\n    }\n  }\n  .lg\\:max-w-7xl {\n    @media (width >= 64rem) {\n      max-width: var(--container-7xl);\n    }\n  }\n  .lg\\:grid-cols-12 {\n    @media (width >= 64rem) {\n      grid-template-columns: repeat(12, minmax(0, 1fr));\n    }\n  }\n  .lg\\:items-start {\n    @media (width >= 64rem) {\n      align-items: flex-start;\n    }\n  }\n  .lg\\:gap-x-12 {\n    @media (width >= 64rem) {\n      column-gap: calc(var(--spacing) * 12);\n    }\n  }\n  .lg\\:p-8 {\n    @media (width >= 64rem) {\n      padding: calc(var(--spacing) * 8);\n    }\n  }\n  .lg\\:px-8 {\n    @media (width >= 64rem) {\n      padding-inline: calc(var(--spacing) * 8);\n    }\n  }\n  .xl\\:gap-x-16 {\n    @media (width >= 80rem) {\n      column-gap: calc(var(--spacing) * 16);\n    }\n  }\n}\n@layer base {\n  *, ::after, ::before, ::backdrop, ::file-selector-button {\n    border-color: var(--color-gray-200, currentColor);\n  }\n}\nhtml {\n  line-height: 1.15;\n  -webkit-text-size-adjust: 100%;\n}\nbody {\n  margin: 0;\n}\nmain {\n  display: block;\n}\nh1 {\n  font-size: 2em;\n  margin: 0.67em 0;\n}\nhr {\n  box-sizing: content-box;\n  height: 0;\n  overflow: visible;\n}\npre {\n  font-family: monospace, monospace;\n  font-size: 1em;\n}\na {\n  background-color: transparent;\n}\nabbr[title] {\n  border-bottom: none;\n  text-decoration: none;\n  -webkit-text-decoration: none dotted;\n  text-decoration: none dotted;\n}\nb, strong {\n  font-weight: bolder;\n}\ncode, kbd, samp {\n  font-family: monospace, monospace;\n  font-size: 1em;\n}\nsmall {\n  font-size: 80%;\n}\nsub, sup {\n  font-size: 75%;\n  line-height: 0;\n  position: relative;\n  vertical-align: baseline;\n}\nsub {\n  bottom: -0.25em;\n}\nsup {\n  top: -0.5em;\n}\nimg {\n  border-style: none;\n}\nbutton, input, optgroup, select, textarea {\n  font-family: inherit;\n  font-size: 100%;\n  line-height: 1.15;\n  margin: 0;\n}\nbutton, input {\n  overflow: visible;\n}\nbutton, select {\n  text-transform: none;\n}\nbutton, [type=\"button\"], [type=\"reset\"], [type=\"submit\"] {\n  -webkit-appearance: button;\n}\nbutton::-moz-focus-inner, [type=\"button\"]::-moz-focus-inner, [type=\"reset\"]::-moz-focus-inner, [type=\"submit\"]::-moz-focus-inner {\n  border-style: none;\n  padding: 0;\n}\nbutton:-moz-focusring, [type=\"button\"]:-moz-focusring, [type=\"reset\"]:-moz-focusring, [type=\"submit\"]:-moz-focusring {\n  outline: 1px dotted ButtonText;\n}\nfieldset {\n  padding: 0.35em 0.75em 0.625em;\n}\nlegend {\n  box-sizing: border-box;\n  color: inherit;\n  display: table;\n  max-width: 100%;\n  padding: 0;\n  white-space: normal;\n}\nprogress {\n  vertical-align: baseline;\n}\ntextarea {\n  overflow: auto;\n}\n[type=\"checkbox\"], [type=\"radio\"] {\n  box-sizing: border-box;\n  padding: 0;\n}\n[type=\"number\"]::-webkit-inner-spin-button, [type=\"number\"]::-webkit-outer-spin-button {\n  height: auto;\n}\n[type=\"search\"] {\n  -webkit-appearance: textfield;\n  outline-offset: -2px;\n}\n[type=\"search\"]::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n::-webkit-file-upload-button {\n  -webkit-appearance: button;\n  font: inherit;\n}\ndetails {\n  display: block;\n}\nsummary {\n  display: list-item;\n}\ntemplate {\n  display: none;\n}\n[hidden] {\n  display: none;\n}\nblockquote, dl, dd, h1, h2, h3, h4, h5, h6, hr, figure, p, pre {\n  margin: 0;\n}\nbutton {\n  background-color: transparent;\n  background-image: none;\n}\nbutton:focus {\n  outline: 1px dotted;\n  outline: 5px auto -webkit-focus-ring-color;\n}\nfieldset {\n  margin: 0;\n  padding: 0;\n}\nol, ul {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\nhtml {\n  font-family: system-ui, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, \"Noto Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n  line-height: 1.5;\n}\n*, ::before, ::after {\n  box-sizing: border-box;\n  border-width: 0;\n  border-style: solid;\n  border-color: #d2d6dc;\n}\nhr {\n  border-top-width: 1px;\n}\nimg {\n  border-style: solid;\n}\ntextarea {\n  resize: vertical;\n}\ninput::-moz-placeholder, textarea::-moz-placeholder {\n  color: #a0aec0;\n}\ninput::placeholder, textarea::placeholder {\n  color: #a0aec0;\n}\nbutton, [role=\"button\"] {\n  cursor: pointer;\n}\ntable {\n  border-collapse: collapse;\n}\nh1, h2, h3, h4, h5, h6 {\n  font-size: inherit;\n  font-weight: inherit;\n}\nbutton, input, optgroup, select, textarea {\n  padding: 0;\n  line-height: inherit;\n  color: inherit;\n}\npre, code, kbd, samp {\n  font-family: Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace;\n}\nimg, svg, video, canvas, audio, iframe, embed, object {\n  display: block;\n  vertical-align: middle;\n}\nimg, video {\n  max-width: 100%;\n  height: auto;\n}\n.container {\n  width: 100%;\n}\n@media (min-width: 640px) {\n  .container {\n    max-width: 640px;\n  }\n}\n@media (min-width: 768px) {\n  .container {\n    max-width: 768px;\n  }\n}\n@media (min-width: 1024px) {\n  .container {\n    max-width: 1024px;\n  }\n}\n@media (min-width: 1280px) {\n  .container {\n    max-width: 1280px;\n  }\n}\n.form-input {\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  background-color: #ffffff;\n  border-color: #d2d6dc;\n  border-width: 1px;\n  border-radius: 0.375rem;\n  padding-top: 0.5rem;\n  padding-right: 0.75rem;\n  padding-bottom: 0.5rem;\n  padding-left: 0.75rem;\n  font-size: 1rem;\n  line-height: 1.5;\n}\n.form-input::-moz-placeholder {\n  color: #9fa6b2;\n  opacity: 1;\n}\n.form-input::placeholder {\n  color: #9fa6b2;\n  opacity: 1;\n}\n.form-input:focus {\n  outline: none;\n  box-shadow: 0 0 0 3px rgba(164, 202, 254, 0.45);\n  border-color: #a4cafe;\n}\n.form-textarea {\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  background-color: #ffffff;\n  border-color: #d2d6dc;\n  border-width: 1px;\n  border-radius: 0.375rem;\n  padding-top: 0.5rem;\n  padding-right: 0.75rem;\n  padding-bottom: 0.5rem;\n  padding-left: 0.75rem;\n  font-size: 1rem;\n  line-height: 1.5;\n}\n.form-textarea::-moz-placeholder {\n  color: #9fa6b2;\n  opacity: 1;\n}\n.form-textarea::placeholder {\n  color: #9fa6b2;\n  opacity: 1;\n}\n.form-textarea:focus {\n  outline: none;\n  box-shadow: 0 0 0 3px rgba(164, 202, 254, 0.45);\n  border-color: #a4cafe;\n}\n.form-multiselect {\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  background-color: #ffffff;\n  border-color: #d2d6dc;\n  border-width: 1px;\n  border-radius: 0.375rem;\n  padding-top: 0.5rem;\n  padding-right: 0.75rem;\n  padding-bottom: 0.5rem;\n  padding-left: 0.75rem;\n  font-size: 1rem;\n  line-height: 1.5;\n}\n.form-multiselect:focus {\n  outline: none;\n  box-shadow: 0 0 0 3px rgba(164, 202, 254, 0.45);\n  border-color: #a4cafe;\n}\n.form-select {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20' fill='none'%3e%3cpath d='M7 7l3-3 3 3m0 6l-3 3-3-3' stroke='%239fa6b2' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3e%3c/svg%3e\");\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  -webkit-print-color-adjust: exact;\n  print-color-adjust: exact;\n  background-repeat: no-repeat;\n  background-color: #ffffff;\n  border-color: #d2d6dc;\n  border-width: 1px;\n  border-radius: 0.375rem;\n  padding-top: 0.5rem;\n  padding-right: 2.5rem;\n  padding-bottom: 0.5rem;\n  padding-left: 0.75rem;\n  font-size: 1rem;\n  line-height: 1.5;\n  background-position: right 0.5rem center;\n  background-size: 1.5em 1.5em;\n}\n.form-select::-ms-expand {\n  color: #9fa6b2;\n  border: none;\n}\n@media not print {\n  .form-select::-ms-expand {\n    display: none;\n  }\n}\n@media print and (-ms-high-contrast: active), print and (-ms-high-contrast: none) {\n  .form-select {\n    padding-right: 0.75rem;\n  }\n}\n.form-select:focus {\n  outline: none;\n  box-shadow: 0 0 0 3px rgba(164, 202, 254, 0.45);\n  border-color: #a4cafe;\n}\n.form-checkbox:checked {\n  background-image: url(\"data:image/svg+xml,%3csvg viewBox='0 0 16 16' fill='white' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M5.707 7.293a1 1 0 0 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 0 0-1.414-1.414L7 8.586 5.707 7.293z'/%3e%3c/svg%3e\");\n  border-color: transparent;\n  background-color: currentColor;\n  background-size: 100% 100%;\n  background-position: center;\n  background-repeat: no-repeat;\n}\n@media not print {\n  .form-checkbox::-ms-check {\n    border-width: 1px;\n    color: transparent;\n    background: inherit;\n    border-color: inherit;\n    border-radius: inherit;\n  }\n}\n.form-checkbox {\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  -webkit-print-color-adjust: exact;\n  print-color-adjust: exact;\n  display: inline-block;\n  vertical-align: middle;\n  background-origin: border-box;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  user-select: none;\n  flex-shrink: 0;\n  height: 1rem;\n  width: 1rem;\n  color: #3f83f8;\n  background-color: #ffffff;\n  border-color: #d2d6dc;\n  border-width: 1px;\n  border-radius: 0.25rem;\n}\n.form-checkbox:focus {\n  outline: none;\n  box-shadow: 0 0 0 3px rgba(164, 202, 254, 0.45);\n  border-color: #a4cafe;\n}\n.form-checkbox:checked:focus {\n  border-color: transparent;\n}\n.form-radio:checked {\n  background-image: url(\"data:image/svg+xml,%3csvg viewBox='0 0 16 16' fill='white' xmlns='http://www.w3.org/2000/svg'%3e%3ccircle cx='8' cy='8' r='3'/%3e%3c/svg%3e\");\n  border-color: transparent;\n  background-color: currentColor;\n  background-size: 100% 100%;\n  background-position: center;\n  background-repeat: no-repeat;\n}\n@media not print {\n  .form-radio::-ms-check {\n    border-width: 1px;\n    color: transparent;\n    background: inherit;\n    border-color: inherit;\n    border-radius: inherit;\n  }\n}\n.form-radio {\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  -webkit-print-color-adjust: exact;\n  print-color-adjust: exact;\n  display: inline-block;\n  vertical-align: middle;\n  background-origin: border-box;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  user-select: none;\n  flex-shrink: 0;\n  border-radius: 100%;\n  height: 1rem;\n  width: 1rem;\n  color: #3f83f8;\n  background-color: #ffffff;\n  border-color: #d2d6dc;\n  border-width: 1px;\n}\n.form-radio:focus {\n  outline: none;\n  box-shadow: 0 0 0 3px rgba(164, 202, 254, 0.45);\n  border-color: #a4cafe;\n}\n.form-radio:checked:focus {\n  border-color: transparent;\n}\n.prose {\n  color: #374151;\n  max-width: 65ch;\n}\n.prose [class~=\"lead\"] {\n  color: #4b5563;\n  font-size: 1.25em;\n  line-height: 1.6;\n  margin-top: 1.2em;\n  margin-bottom: 1.2em;\n}\n.prose a {\n  color: #5850ec;\n  text-decoration: none;\n  font-weight: 600;\n}\n.prose strong {\n  color: #161e2e;\n  font-weight: 600;\n}\n.prose ol {\n  counter-reset: list-counter;\n  margin-top: 1.25em;\n  margin-bottom: 1.25em;\n}\n.prose ol>li {\n  position: relative;\n  counter-increment: list-counter;\n  padding-left: 1.75em;\n}\n.prose ol>li::before {\n  content: counter(list-counter) \".\";\n  position: absolute;\n  font-weight: 400;\n  color: #6b7280;\n}\n.prose ul>li {\n  position: relative;\n  padding-left: 1.75em;\n}\n.prose ul>li::before {\n  content: \"\";\n  position: absolute;\n  background-color: #d2d6dc;\n  border-radius: 50%;\n  width: 0.375em;\n  height: 0.375em;\n  top: calc(0.875em - 0.1875em);\n  left: 0.25em;\n}\n.prose hr {\n  border-color: #e5e7eb;\n  border-top-width: 1px;\n  margin-top: 3em;\n  margin-bottom: 3em;\n}\n.prose blockquote {\n  font-weight: 500;\n  font-style: italic;\n  color: #161e2e;\n  border-left-width: 0.25rem;\n  border-left-color: #e5e7eb;\n  quotes: \"\\201C\" \"\\201D\" \"\\2018\" \"\\2019\";\n  margin-top: 1.6em;\n  margin-bottom: 1.6em;\n  padding-left: 1em;\n}\n.prose blockquote p:first-of-type::before {\n  content: open-quote;\n}\n.prose blockquote p:last-of-type::after {\n  content: close-quote;\n}\n.prose h1 {\n  color: #1a202c;\n  font-weight: 800;\n  font-size: 2.25em;\n  margin-top: 0;\n  margin-bottom: 0.8888889em;\n  line-height: 1.1111111;\n}\n.prose h2 {\n  color: #1a202c;\n  font-weight: 700;\n  font-size: 1.5em;\n  margin-top: 2em;\n  margin-bottom: 1em;\n  line-height: 1.3333333;\n}\n.prose h3 {\n  color: #1a202c;\n  font-weight: 600;\n  font-size: 1.25em;\n  margin-top: 1.6em;\n  margin-bottom: 0.6em;\n  line-height: 1.6;\n}\n.prose h4 {\n  color: #1a202c;\n  font-weight: 600;\n  margin-top: 1.5em;\n  margin-bottom: 0.5em;\n  line-height: 1.5;\n}\n.prose figure figcaption {\n  color: #6b7280;\n  font-size: 0.875em;\n  line-height: 1.4285714;\n  margin-top: 0.8571429em;\n}\n.prose code {\n  color: #161e2e;\n  font-weight: 600;\n  font-size: 0.875em;\n}\n.prose code::before {\n  content: \"`\";\n}\n.prose code::after {\n  content: \"`\";\n}\n.prose pre {\n  color: #e5e7eb;\n  background-color: #252f3f;\n  overflow-x: auto;\n  font-size: 0.875em;\n  line-height: 1.7142857;\n  margin-top: 1.7142857em;\n  margin-bottom: 1.7142857em;\n  border-radius: 0.375rem;\n  padding-top: 0.8571429em;\n  padding-right: 1.1428571em;\n  padding-bottom: 0.8571429em;\n  padding-left: 1.1428571em;\n}\n.prose pre code {\n  background-color: transparent;\n  border-width: 0;\n  border-radius: 0;\n  padding: 0;\n  font-weight: 400;\n  color: inherit;\n  font-size: inherit;\n  font-family: inherit;\n  line-height: inherit;\n}\n.prose pre code::before {\n  content: \"\";\n}\n.prose pre code::after {\n  content: \"\";\n}\n.prose table {\n  width: 100%;\n  table-layout: auto;\n  text-align: left;\n  margin-top: 2em;\n  margin-bottom: 2em;\n  font-size: 0.875em;\n  line-height: 1.7142857;\n}\n.prose thead {\n  color: #161e2e;\n  font-weight: 600;\n  border-bottom-width: 1px;\n  border-bottom-color: #d2d6dc;\n}\n.prose thead th {\n  vertical-align: bottom;\n  padding-right: 0.5714286em;\n  padding-bottom: 0.5714286em;\n  padding-left: 0.5714286em;\n}\n.prose tbody tr {\n  border-bottom-width: 1px;\n  border-bottom-color: #e5e7eb;\n}\n.prose tbody tr:last-child {\n  border-bottom-width: 0;\n}\n.prose tbody td {\n  vertical-align: top;\n  padding-top: 0.5714286em;\n  padding-right: 0.5714286em;\n  padding-bottom: 0.5714286em;\n  padding-left: 0.5714286em;\n}\n.prose {\n  font-size: 1rem;\n  line-height: 1.75;\n}\n.prose p {\n  margin-top: 1.25em;\n  margin-bottom: 1.25em;\n}\n.prose img {\n  margin-top: 2em;\n  margin-bottom: 2em;\n}\n.prose video {\n  margin-top: 2em;\n  margin-bottom: 2em;\n}\n.prose figure {\n  margin-top: 2em;\n  margin-bottom: 2em;\n}\n.prose figure>* {\n  margin-top: 0;\n  margin-bottom: 0;\n}\n.prose h2 code {\n  font-size: 0.875em;\n}\n.prose h3 code {\n  font-size: 0.9em;\n}\n.prose ul {\n  margin-top: 1.25em;\n  margin-bottom: 1.25em;\n}\n.prose li {\n  margin-top: 0.5em;\n  margin-bottom: 0.5em;\n}\n.prose ol>li:before {\n  left: 0;\n}\n.prose>ul>li p {\n  margin-top: 0.75em;\n  margin-bottom: 0.75em;\n}\n.prose>ul>li>*:first-child {\n  margin-top: 1.25em;\n}\n.prose>ul>li>*:last-child {\n  margin-bottom: 1.25em;\n}\n.prose>ol>li>*:first-child {\n  margin-top: 1.25em;\n}\n.prose>ol>li>*:last-child {\n  margin-bottom: 1.25em;\n}\n.prose ul ul, .prose ul ol, .prose ol ul, .prose ol ol {\n  margin-top: 0.75em;\n  margin-bottom: 0.75em;\n}\n.prose hr+* {\n  margin-top: 0;\n}\n.prose h2+* {\n  margin-top: 0;\n}\n.prose h3+* {\n  margin-top: 0;\n}\n.prose h4+* {\n  margin-top: 0;\n}\n.prose thead th:first-child {\n  padding-left: 0;\n}\n.prose thead th:last-child {\n  padding-right: 0;\n}\n.prose tbody td:first-child {\n  padding-left: 0;\n}\n.prose tbody td:last-child {\n  padding-right: 0;\n}\n.prose> :first-child {\n  margin-top: 0;\n}\n.prose> :last-child {\n  margin-bottom: 0;\n}\n.prose h1, .prose h2, .prose h3, .prose h4 {\n  color: #161e2e;\n}\n.prose-sm {\n  font-size: 0.875rem;\n  line-height: 1.7142857;\n}\n.prose-sm p {\n  margin-top: 1.1428571em;\n  margin-bottom: 1.1428571em;\n}\n.prose-sm [class~=\"lead\"] {\n  font-size: 1.2857143em;\n  line-height: 1.5555556;\n  margin-top: 0.8888889em;\n  margin-bottom: 0.8888889em;\n}\n.prose-sm blockquote {\n  margin-top: 1.3333333em;\n  margin-bottom: 1.3333333em;\n  padding-left: 1.1111111em;\n}\n.prose-sm h1 {\n  font-size: 2.1428571em;\n  margin-top: 0;\n  margin-bottom: 0.8em;\n  line-height: 1.2;\n}\n.prose-sm h2 {\n  font-size: 1.4285714em;\n  margin-top: 1.6em;\n  margin-bottom: 0.8em;\n  line-height: 1.4;\n}\n.prose-sm h3 {\n  font-size: 1.2857143em;\n  margin-top: 1.5555556em;\n  margin-bottom: 0.4444444em;\n  line-height: 1.5555556;\n}\n.prose-sm h4 {\n  margin-top: 1.4285714em;\n  margin-bottom: 0.5714286em;\n  line-height: 1.4285714;\n}\n.prose-sm img {\n  margin-top: 1.7142857em;\n  margin-bottom: 1.7142857em;\n}\n.prose-sm video {\n  margin-top: 1.7142857em;\n  margin-bottom: 1.7142857em;\n}\n.prose-sm figure {\n  margin-top: 1.7142857em;\n  margin-bottom: 1.7142857em;\n}\n.prose-sm figure>* {\n  margin-top: 0;\n  margin-bottom: 0;\n}\n.prose-sm figure figcaption {\n  font-size: 0.8571429em;\n  line-height: 1.3333333;\n  margin-top: 0.6666667em;\n}\n.prose-sm code {\n  font-size: 0.8571429em;\n}\n.prose-sm h2 code {\n  font-size: 0.9em;\n}\n.prose-sm h3 code {\n  font-size: 0.8888889em;\n}\n.prose-sm pre {\n  font-size: 0.8571429em;\n  line-height: 1.6666667;\n  margin-top: 1.6666667em;\n  margin-bottom: 1.6666667em;\n  border-radius: 0.25rem;\n  padding-top: 0.6666667em;\n  padding-right: 1em;\n  padding-bottom: 0.6666667em;\n  padding-left: 1em;\n}\n.prose-sm ol {\n  margin-top: 1.1428571em;\n  margin-bottom: 1.1428571em;\n}\n.prose-sm ul {\n  margin-top: 1.1428571em;\n  margin-bottom: 1.1428571em;\n}\n.prose-sm li {\n  margin-top: 0.2857143em;\n  margin-bottom: 0.2857143em;\n}\n.prose-sm ol>li {\n  padding-left: 1.5714286em;\n}\n.prose-sm ol>li:before {\n  left: 0;\n}\n.prose-sm ul>li {\n  padding-left: 1.5714286em;\n}\n.prose-sm ul>li::before {\n  height: 0.3571429em;\n  width: 0.3571429em;\n  top: calc(0.8571429em - 0.1785714em);\n  left: 0.2142857em;\n}\n.prose-sm>ul>li p {\n  margin-top: 0.5714286em;\n  margin-bottom: 0.5714286em;\n}\n.prose-sm>ul>li>*:first-child {\n  margin-top: 1.1428571em;\n}\n.prose-sm>ul>li>*:last-child {\n  margin-bottom: 1.1428571em;\n}\n.prose-sm>ol>li>*:first-child {\n  margin-top: 1.1428571em;\n}\n.prose-sm>ol>li>*:last-child {\n  margin-bottom: 1.1428571em;\n}\n.prose-sm ul ul, .prose-sm ul ol, .prose-sm ol ul, .prose-sm ol ol {\n  margin-top: 0.5714286em;\n  margin-bottom: 0.5714286em;\n}\n.prose-sm hr {\n  margin-top: 2.8571429em;\n  margin-bottom: 2.8571429em;\n}\n.prose-sm hr+* {\n  margin-top: 0;\n}\n.prose-sm h2+* {\n  margin-top: 0;\n}\n.prose-sm h3+* {\n  margin-top: 0;\n}\n.prose-sm h4+* {\n  margin-top: 0;\n}\n.prose-sm table {\n  font-size: 0.8571429em;\n  line-height: 1.5;\n}\n.prose-sm thead th {\n  padding-right: 1em;\n  padding-bottom: 0.6666667em;\n  padding-left: 1em;\n}\n.prose-sm thead th:first-child {\n  padding-left: 0;\n}\n.prose-sm thead th:last-child {\n  padding-right: 0;\n}\n.prose-sm tbody td {\n  padding-top: 0.6666667em;\n  padding-right: 1em;\n  padding-bottom: 0.6666667em;\n  padding-left: 1em;\n}\n.prose-sm tbody td:first-child {\n  padding-left: 0;\n}\n.prose-sm tbody td:last-child {\n  padding-right: 0;\n}\n.prose-sm> :first-child {\n  margin-top: 0;\n}\n.prose-sm> :last-child {\n  margin-bottom: 0;\n}\n.prose-lg {\n  font-size: 1.125rem;\n  line-height: 1.7777778;\n}\n.prose-lg p {\n  margin-top: 1.3333333em;\n  margin-bottom: 1.3333333em;\n}\n.prose-lg [class~=\"lead\"] {\n  font-size: 1.2222222em;\n  line-height: 1.4545455;\n  margin-top: 1.0909091em;\n  margin-bottom: 1.0909091em;\n}\n.prose-lg blockquote {\n  margin-top: 1.6666667em;\n  margin-bottom: 1.6666667em;\n  padding-left: 1em;\n}\n.prose-lg h1 {\n  font-size: 2.6666667em;\n  margin-top: 0;\n  margin-bottom: 0.8333333em;\n  line-height: 1;\n}\n.prose-lg h2 {\n  font-size: 1.6666667em;\n  margin-top: 1.8666667em;\n  margin-bottom: 1.0666667em;\n  line-height: 1.3333333;\n}\n.prose-lg h3 {\n  font-size: 1.3333333em;\n  margin-top: 1.6666667em;\n  margin-bottom: 0.6666667em;\n  line-height: 1.5;\n}\n.prose-lg h4 {\n  margin-top: 1.7777778em;\n  margin-bottom: 0.4444444em;\n  line-height: 1.5555556;\n}\n.prose-lg img {\n  margin-top: 1.7777778em;\n  margin-bottom: 1.7777778em;\n}\n.prose-lg video {\n  margin-top: 1.7777778em;\n  margin-bottom: 1.7777778em;\n}\n.prose-lg figure {\n  margin-top: 1.7777778em;\n  margin-bottom: 1.7777778em;\n}\n.prose-lg figure>* {\n  margin-top: 0;\n  margin-bottom: 0;\n}\n.prose-lg figure figcaption {\n  font-size: 0.8888889em;\n  line-height: 1.5;\n  margin-top: 1em;\n}\n.prose-lg code {\n  font-size: 0.8888889em;\n}\n.prose-lg h2 code {\n  font-size: 0.8666667em;\n}\n.prose-lg h3 code {\n  font-size: 0.875em;\n}\n.prose-lg pre {\n  font-size: 0.8888889em;\n  line-height: 1.75;\n  margin-top: 2em;\n  margin-bottom: 2em;\n  border-radius: 0.375rem;\n  padding-top: 1em;\n  padding-right: 1.5em;\n  padding-bottom: 1em;\n  padding-left: 1.5em;\n}\n.prose-lg ol {\n  margin-top: 1.3333333em;\n  margin-bottom: 1.3333333em;\n}\n.prose-lg ul {\n  margin-top: 1.3333333em;\n  margin-bottom: 1.3333333em;\n}\n.prose-lg li {\n  margin-top: 0.6666667em;\n  margin-bottom: 0.6666667em;\n}\n.prose-lg ol>li {\n  padding-left: 1.6666667em;\n}\n.prose-lg ol>li:before {\n  left: 0;\n}\n.prose-lg ul>li {\n  padding-left: 1.6666667em;\n}\n.prose-lg ul>li::before {\n  width: 0.3333333em;\n  height: 0.3333333em;\n  top: calc(0.8888889em - 0.1666667em);\n  left: 0.2222222em;\n}\n.prose-lg>ul>li p {\n  margin-top: 0.8888889em;\n  margin-bottom: 0.8888889em;\n}\n.prose-lg>ul>li>*:first-child {\n  margin-top: 1.3333333em;\n}\n.prose-lg>ul>li>*:last-child {\n  margin-bottom: 1.3333333em;\n}\n.prose-lg>ol>li>*:first-child {\n  margin-top: 1.3333333em;\n}\n.prose-lg>ol>li>*:last-child {\n  margin-bottom: 1.3333333em;\n}\n.prose-lg ul ul, .prose-lg ul ol, .prose-lg ol ul, .prose-lg ol ol {\n  margin-top: 0.8888889em;\n  margin-bottom: 0.8888889em;\n}\n.prose-lg hr {\n  margin-top: 3.1111111em;\n  margin-bottom: 3.1111111em;\n}\n.prose-lg hr+* {\n  margin-top: 0;\n}\n.prose-lg h2+* {\n  margin-top: 0;\n}\n.prose-lg h3+* {\n  margin-top: 0;\n}\n.prose-lg h4+* {\n  margin-top: 0;\n}\n.prose-lg table {\n  font-size: 0.8888889em;\n  line-height: 1.5;\n}\n.prose-lg thead th {\n  padding-right: 0.75em;\n  padding-bottom: 0.75em;\n  padding-left: 0.75em;\n}\n.prose-lg thead th:first-child {\n  padding-left: 0;\n}\n.prose-lg thead th:last-child {\n  padding-right: 0;\n}\n.prose-lg tbody td {\n  padding-top: 0.75em;\n  padding-right: 0.75em;\n  padding-bottom: 0.75em;\n  padding-left: 0.75em;\n}\n.prose-lg tbody td:first-child {\n  padding-left: 0;\n}\n.prose-lg tbody td:last-child {\n  padding-right: 0;\n}\n.prose-lg> :first-child {\n  margin-top: 0;\n}\n.prose-lg> :last-child {\n  margin-bottom: 0;\n}\n.prose-xl {\n  font-size: 1.25rem;\n  line-height: 1.8;\n}\n.prose-xl p {\n  margin-top: 1.2em;\n  margin-bottom: 1.2em;\n}\n.prose-xl [class~=\"lead\"] {\n  font-size: 1.2em;\n  line-height: 1.5;\n  margin-top: 1em;\n  margin-bottom: 1em;\n}\n.prose-xl blockquote {\n  margin-top: 1.6em;\n  margin-bottom: 1.6em;\n  padding-left: 1.0666667em;\n}\n.prose-xl h1 {\n  font-size: 2.8em;\n  margin-top: 0;\n  margin-bottom: 0.8571429em;\n  line-height: 1;\n}\n.prose-xl h2 {\n  font-size: 1.8em;\n  margin-top: 1.5555556em;\n  margin-bottom: 0.8888889em;\n  line-height: 1.1111111;\n}\n.prose-xl h3 {\n  font-size: 1.5em;\n  margin-top: 1.6em;\n  margin-bottom: 0.6666667em;\n  line-height: 1.3333333;\n}\n.prose-xl h4 {\n  margin-top: 1.8em;\n  margin-bottom: 0.6em;\n  line-height: 1.6;\n}\n.prose-xl img {\n  margin-top: 2em;\n  margin-bottom: 2em;\n}\n.prose-xl video {\n  margin-top: 2em;\n  margin-bottom: 2em;\n}\n.prose-xl figure {\n  margin-top: 2em;\n  margin-bottom: 2em;\n}\n.prose-xl figure>* {\n  margin-top: 0;\n  margin-bottom: 0;\n}\n.prose-xl figure figcaption {\n  font-size: 0.9em;\n  line-height: 1.5555556;\n  margin-top: 1em;\n}\n.prose-xl code {\n  font-size: 0.9em;\n}\n.prose-xl h2 code {\n  font-size: 0.8611111em;\n}\n.prose-xl h3 code {\n  font-size: 0.9em;\n}\n.prose-xl pre {\n  font-size: 0.9em;\n  line-height: 1.7777778;\n  margin-top: 2em;\n  margin-bottom: 2em;\n  border-radius: 0.5rem;\n  padding-top: 1.1111111em;\n  padding-right: 1.3333333em;\n  padding-bottom: 1.1111111em;\n  padding-left: 1.3333333em;\n}\n.prose-xl ol {\n  margin-top: 1.2em;\n  margin-bottom: 1.2em;\n}\n.prose-xl ul {\n  margin-top: 1.2em;\n  margin-bottom: 1.2em;\n}\n.prose-xl li {\n  margin-top: 0.6em;\n  margin-bottom: 0.6em;\n}\n.prose-xl ol>li {\n  padding-left: 1.8em;\n}\n.prose-xl ol>li:before {\n  left: 0;\n}\n.prose-xl ul>li {\n  padding-left: 1.8em;\n}\n.prose-xl ul>li::before {\n  width: 0.35em;\n  height: 0.35em;\n  top: calc(0.9em - 0.175em);\n  left: 0.25em;\n}\n.prose-xl>ul>li p {\n  margin-top: 0.8em;\n  margin-bottom: 0.8em;\n}\n.prose-xl>ul>li>*:first-child {\n  margin-top: 1.2em;\n}\n.prose-xl>ul>li>*:last-child {\n  margin-bottom: 1.2em;\n}\n.prose-xl>ol>li>*:first-child {\n  margin-top: 1.2em;\n}\n.prose-xl>ol>li>*:last-child {\n  margin-bottom: 1.2em;\n}\n.prose-xl ul ul, .prose-xl ul ol, .prose-xl ol ul, .prose-xl ol ol {\n  margin-top: 0.8em;\n  margin-bottom: 0.8em;\n}\n.prose-xl hr {\n  margin-top: 2.8em;\n  margin-bottom: 2.8em;\n}\n.prose-xl hr+* {\n  margin-top: 0;\n}\n.prose-xl h2+* {\n  margin-top: 0;\n}\n.prose-xl h3+* {\n  margin-top: 0;\n}\n.prose-xl h4+* {\n  margin-top: 0;\n}\n.prose-xl table {\n  font-size: 0.9em;\n  line-height: 1.5555556;\n}\n.prose-xl thead th {\n  padding-right: 0.6666667em;\n  padding-bottom: 0.8888889em;\n  padding-left: 0.6666667em;\n}\n.prose-xl thead th:first-child {\n  padding-left: 0;\n}\n.prose-xl thead th:last-child {\n  padding-right: 0;\n}\n.prose-xl tbody td {\n  padding-top: 0.8888889em;\n  padding-right: 0.6666667em;\n  padding-bottom: 0.8888889em;\n  padding-left: 0.6666667em;\n}\n.prose-xl tbody td:first-child {\n  padding-left: 0;\n}\n.prose-xl tbody td:last-child {\n  padding-right: 0;\n}\n.prose-xl> :first-child {\n  margin-top: 0;\n}\n.prose-xl> :last-child {\n  margin-bottom: 0;\n}\n.prose-2xl {\n  font-size: 1.5rem;\n  line-height: 1.6666667;\n}\n.prose-2xl p {\n  margin-top: 1.3333333em;\n  margin-bottom: 1.3333333em;\n}\n.prose-2xl [class~=\"lead\"] {\n  font-size: 1.25em;\n  line-height: 1.4666667;\n  margin-top: 1.0666667em;\n  margin-bottom: 1.0666667em;\n}\n.prose-2xl blockquote {\n  margin-top: 1.7777778em;\n  margin-bottom: 1.7777778em;\n  padding-left: 1.1111111em;\n}\n.prose-2xl h1 {\n  font-size: 2.6666667em;\n  margin-top: 0;\n  margin-bottom: 0.875em;\n  line-height: 1;\n}\n.prose-2xl h2 {\n  font-size: 2em;\n  margin-top: 1.5em;\n  margin-bottom: 0.8333333em;\n  line-height: 1.0833333;\n}\n.prose-2xl h3 {\n  font-size: 1.5em;\n  margin-top: 1.5555556em;\n  margin-bottom: 0.6666667em;\n  line-height: 1.2222222;\n}\n.prose-2xl h4 {\n  margin-top: 1.6666667em;\n  margin-bottom: 0.6666667em;\n  line-height: 1.5;\n}\n.prose-2xl img {\n  margin-top: 2em;\n  margin-bottom: 2em;\n}\n.prose-2xl video {\n  margin-top: 2em;\n  margin-bottom: 2em;\n}\n.prose-2xl figure {\n  margin-top: 2em;\n  margin-bottom: 2em;\n}\n.prose-2xl figure>* {\n  margin-top: 0;\n  margin-bottom: 0;\n}\n.prose-2xl figure figcaption {\n  font-size: 0.8333333em;\n  line-height: 1.6;\n  margin-top: 1em;\n}\n.prose-2xl code {\n  font-size: 0.8333333em;\n}\n.prose-2xl h2 code {\n  font-size: 0.875em;\n}\n.prose-2xl h3 code {\n  font-size: 0.8888889em;\n}\n.prose-2xl pre {\n  font-size: 0.8333333em;\n  line-height: 1.8;\n  margin-top: 2em;\n  margin-bottom: 2em;\n  border-radius: 0.5rem;\n  padding-top: 1.2em;\n  padding-right: 1.6em;\n  padding-bottom: 1.2em;\n  padding-left: 1.6em;\n}\n.prose-2xl ol {\n  margin-top: 1.3333333em;\n  margin-bottom: 1.3333333em;\n}\n.prose-2xl ul {\n  margin-top: 1.3333333em;\n  margin-bottom: 1.3333333em;\n}\n.prose-2xl li {\n  margin-top: 0.5em;\n  margin-bottom: 0.5em;\n}\n.prose-2xl ol>li {\n  padding-left: 1.6666667em;\n}\n.prose-2xl ol>li:before {\n  left: 0;\n}\n.prose-2xl ul>li {\n  padding-left: 1.6666667em;\n}\n.prose-2xl ul>li::before {\n  width: 0.3333333em;\n  height: 0.3333333em;\n  top: calc(0.8333333em - 0.1666667em);\n  left: 0.25em;\n}\n.prose-2xl>ul>li p {\n  margin-top: 0.8333333em;\n  margin-bottom: 0.8333333em;\n}\n.prose-2xl>ul>li>*:first-child {\n  margin-top: 1.3333333em;\n}\n.prose-2xl>ul>li>*:last-child {\n  margin-bottom: 1.3333333em;\n}\n.prose-2xl>ol>li>*:first-child {\n  margin-top: 1.3333333em;\n}\n.prose-2xl>ol>li>*:last-child {\n  margin-bottom: 1.3333333em;\n}\n.prose-2xl ul ul, .prose-2xl ul ol, .prose-2xl ol ul, .prose-2xl ol ol {\n  margin-top: 0.6666667em;\n  margin-bottom: 0.6666667em;\n}\n.prose-2xl hr {\n  margin-top: 3em;\n  margin-bottom: 3em;\n}\n.prose-2xl hr+* {\n  margin-top: 0;\n}\n.prose-2xl h2+* {\n  margin-top: 0;\n}\n.prose-2xl h3+* {\n  margin-top: 0;\n}\n.prose-2xl h4+* {\n  margin-top: 0;\n}\n.prose-2xl table {\n  font-size: 0.8333333em;\n  line-height: 1.4;\n}\n.prose-2xl thead th {\n  padding-right: 0.6em;\n  padding-bottom: 0.8em;\n  padding-left: 0.6em;\n}\n.prose-2xl thead th:first-child {\n  padding-left: 0;\n}\n.prose-2xl thead th:last-child {\n  padding-right: 0;\n}\n.prose-2xl tbody td {\n  padding-top: 0.8em;\n  padding-right: 0.6em;\n  padding-bottom: 0.8em;\n  padding-left: 0.6em;\n}\n.prose-2xl tbody td:first-child {\n  padding-left: 0;\n}\n.prose-2xl tbody td:last-child {\n  padding-right: 0;\n}\n.prose-2xl> :first-child {\n  margin-top: 0;\n}\n.prose-2xl> :last-child {\n  margin-bottom: 0;\n}\n.space-y-0> :not(template)~ :not(template) {\n  --space-y-reverse: 0;\n  margin-top: calc(0px * calc(1 - var(--space-y-reverse)));\n  margin-bottom: calc(0px * var(--space-y-reverse));\n}\n.space-x-0> :not(template)~ :not(template) {\n  --space-x-reverse: 0;\n  margin-right: calc(0px * var(--space-x-reverse));\n  margin-left: calc(0px * calc(1 - var(--space-x-reverse)));\n}\n.space-y-1> :not(template)~ :not(template) {\n  --space-y-reverse: 0;\n  margin-top: calc(0.25rem * calc(1 - var(--space-y-reverse)));\n  margin-bottom: calc(0.25rem * var(--space-y-reverse));\n}\n.space-x-1> :not(template)~ :not(template) {\n  --space-x-reverse: 0;\n  margin-right: calc(0.25rem * var(--space-x-reverse));\n  margin-left: calc(0.25rem * calc(1 - var(--space-x-reverse)));\n}\n.space-y-2> :not(template)~ :not(template) {\n  --space-y-reverse: 0;\n  margin-top: calc(0.5rem * calc(1 - var(--space-y-reverse)));\n  margin-bottom: calc(0.5rem * var(--space-y-reverse));\n}\n.space-x-2> :not(template)~ :not(template) {\n  --space-x-reverse: 0;\n  margin-right: calc(0.5rem * var(--space-x-reverse));\n  margin-left: calc(0.5rem * calc(1 - var(--space-x-reverse)));\n}\n.space-y-3> :not(template)~ :not(template) {\n  --space-y-reverse: 0;\n  margin-top: calc(0.75rem * calc(1 - var(--space-y-reverse)));\n  margin-bottom: calc(0.75rem * var(--space-y-reverse));\n}\n.space-x-3> :not(template)~ :not(template) {\n  --space-x-reverse: 0;\n  margin-right: calc(0.75rem * var(--space-x-reverse));\n  margin-left: calc(0.75rem * calc(1 - var(--space-x-reverse)));\n}\n.space-y-4> :not(template)~ :not(template) {\n  --space-y-reverse: 0;\n  margin-top: calc(1rem * calc(1 - var(--space-y-reverse)));\n  margin-bottom: calc(1rem * var(--space-y-reverse));\n}\n.space-x-4> :not(template)~ :not(template) {\n  --space-x-reverse: 0;\n  margin-right: calc(1rem * var(--space-x-reverse));\n  margin-left: calc(1rem * calc(1 - var(--space-x-reverse)));\n}\n.space-y-5> :not(template)~ :not(template) {\n  --space-y-reverse: 0;\n  margin-top: calc(1.25rem * calc(1 - var(--space-y-reverse)));\n  margin-bottom: calc(1.25rem * var(--space-y-reverse));\n}\n.space-x-5> :not(template)~ :not(template) {\n  --space-x-reverse: 0;\n  margin-right: calc(1.25rem * var(--space-x-reverse));\n  margin-left: calc(1.25rem * calc(1 - var(--space-x-reverse)));\n}\n.space-y-6> :not(template)~ :not(template) {\n  --space-y-reverse: 0;\n  margin-top: calc(1.5rem * calc(1 - var(--space-y-reverse)));\n  margin-bottom: calc(1.5rem * var(--space-y-reverse));\n}\n.space-x-6> :not(template)~ :not(template) {\n  --space-x-reverse: 0;\n  margin-right: calc(1.5rem * var(--space-x-reverse));\n  margin-left: calc(1.5rem * calc(1 - var(--space-x-reverse)));\n}\n.space-y-7> :not(template)~ :not(template) {\n  --space-y-reverse: 0;\n  margin-top: calc(1.75rem * calc(1 - var(--space-y-reverse)));\n  margin-bottom: calc(1.75rem * var(--space-y-reverse));\n}\n.space-x-7> :not(template)~ :not(template) {\n  --space-x-reverse: 0;\n  margin-right: calc(1.75rem * var(--space-x-reverse));\n  margin-left: calc(1.75rem * calc(1 - var(--space-x-reverse)));\n}\n.space-y-8> :not(template)~ :not(template) {\n  --space-y-reverse: 0;\n  margin-top: calc(2rem * calc(1 - var(--space-y-reverse)));\n  margin-bottom: calc(2rem * var(--space-y-reverse));\n}\n.space-x-8> :not(template)~ :not(template) {\n  --space-x-reverse: 0;\n  margin-right: calc(2rem * var(--space-x-reverse));\n  margin-left: calc(2rem * calc(1 - var(--space-x-reverse)));\n}\n.space-y-9> :not(template)~ :not(template) {\n  --space-y-reverse: 0;\n  margin-top: calc(2.25rem * calc(1 - var(--space-y-reverse)));\n  margin-bottom: calc(2.25rem * var(--space-y-reverse));\n}\n.space-x-9> :not(template)~ :not(template) {\n  --space-x-reverse: 0;\n  margin-right: calc(2.25rem * var(--space-x-reverse));\n  margin-left: calc(2.25rem * calc(1 - var(--space-x-reverse)));\n}\n.space-y-10> :not(template)~ :not(template) {\n  --space-y-reverse: 0;\n  margin-top: calc(2.5rem * calc(1 - var(--space-y-reverse)));\n  margin-bottom: calc(2.5rem * var(--space-y-reverse));\n}\n.space-x-10> :not(template)~ :not(template) {\n  --space-x-reverse: 0;\n  margin-right: calc(2.5rem * var(--space-x-reverse));\n  margin-left: calc(2.5rem * calc(1 - var(--space-x-reverse)));\n}\n.space-y-11> :not(template)~ :not(template) {\n  --space-y-reverse: 0;\n  margin-top: calc(2.75rem * calc(1 - var(--space-y-reverse)));\n  margin-bottom: calc(2.75rem * var(--space-y-reverse));\n}\n.space-x-11> :not(template)~ :not(template) {\n  --space-x-reverse: 0;\n  margin-right: calc(2.75rem * var(--space-x-reverse));\n  margin-left: calc(2.75rem * calc(1 - var(--space-x-reverse)));\n}\n.space-y-12> :not(template)~ :not(template) {\n  --space-y-reverse: 0;\n  margin-top: calc(3rem * calc(1 - var(--space-y-reverse)));\n  margin-bottom: calc(3rem * var(--space-y-reverse));\n}\n.space-x-12> :not(template)~ :not(template) {\n  --space-x-reverse: 0;\n  margin-right: calc(3rem * var(--space-x-reverse));\n  margin-left: calc(3rem * calc(1 - var(--space-x-reverse)));\n}\n.space-y-13> :not(template)~ :not(template) {\n  --space-y-reverse: 0;\n  margin-top: calc(3.25rem * calc(1 - var(--space-y-reverse)));\n  margin-bottom: calc(3.25rem * var(--space-y-reverse));\n}\n.space-x-13> :not(template)~ :not(template) {\n  --space-x-reverse: 0;\n  margin-right: calc(3.25rem * var(--space-x-reverse));\n  margin-left: calc(3.25rem * calc(1 - var(--space-x-reverse)));\n}\n.space-y-14> :not(template)~ :not(template) {\n  --space-y-reverse: 0;\n  margin-top: calc(3.5rem * calc(1 - var(--space-y-reverse)));\n  margin-bottom: calc(3.5rem * var(--space-y-reverse));\n}\n.space-x-14> :not(template)~ :not(template) {\n  --space-x-reverse: 0;\n  margin-right: calc(3.5rem * var(--space-x-reverse));\n  margin-left: calc(3.5rem * calc(1 - var(--space-x-reverse)));\n}\n.space-y-15> :not(template)~ :not(template) {\n  --space-y-reverse: 0;\n  margin-top: calc(3.75rem * calc(1 - var(--space-y-reverse)));\n  margin-bottom: calc(3.75rem * var(--space-y-reverse));\n}\n.space-x-15> :not(template)~ :not(template) {\n  --space-x-reverse: 0;\n  margin-right: calc(3.75rem * var(--space-x-reverse));\n  margin-left: calc(3.75rem * calc(1 - var(--space-x-reverse)));\n}\n.space-y-16> :not(template)~ :not(template) {\n  --space-y-reverse: 0;\n  margin-top: calc(4rem * calc(1 - var(--space-y-reverse)));\n  margin-bottom: calc(4rem * var(--space-y-reverse));\n}\n.space-x-16> :not(template)~ :not(template) {\n  --space-x-reverse: 0;\n  margin-right: calc(4rem * var(--space-x-reverse));\n  margin-left: calc(4rem * calc(1 - var(--space-x-reverse)));\n}\n.space-y-20> :not(template)~ :not(template) {\n  --space-y-reverse: 0;\n  margin-top: calc(5rem * calc(1 - var(--space-y-reverse)));\n  margin-bottom: calc(5rem * var(--space-y-reverse));\n}\n.space-x-20> :not(template)~ :not(template) {\n  --space-x-reverse: 0;\n  margin-right: calc(5rem * var(--space-x-reverse));\n  margin-left: calc(5rem * calc(1 - var(--space-x-reverse)));\n}\n.space-y-24> :not(template)~ :not(template) {\n  --space-y-reverse: 0;\n  margin-top: calc(6rem * calc(1 - var(--space-y-reverse)));\n  margin-bottom: calc(6rem * var(--space-y-reverse));\n}\n.space-x-24> :not(template)~ :not(template) {\n  --space-x-reverse: 0;\n  margin-right: calc(6rem * var(--space-x-reverse));\n  margin-left: calc(6rem * calc(1 - var(--space-x-reverse)));\n}\n.space-y-28> :not(template)~ :not(template) {\n  --space-y-reverse: 0;\n  margin-top: calc(7rem * calc(1 - var(--space-y-reverse)));\n  margin-bottom: calc(7rem * var(--space-y-reverse));\n}\n.space-x-28> :not(template)~ :not(template) {\n  --space-x-reverse: 0;\n  margin-right: calc(7rem * var(--space-x-reverse));\n  margin-left: calc(7rem * calc(1 - var(--space-x-reverse)));\n}\n.space-y-32> :not(template)~ :not(template) {\n  --space-y-reverse: 0;\n  margin-top: calc(8rem * calc(1 - var(--space-y-reverse)));\n  margin-bottom: calc(8rem * var(--space-y-reverse));\n}\n.space-x-32> :not(template)~ :not(template) {\n  --space-x-reverse: 0;\n  margin-right: calc(8rem * var(--space-x-reverse));\n  margin-left: calc(8rem * calc(1 - var(--space-x-reverse)));\n}\n.space-y-36> :not(template)~ :not(template) {\n  --space-y-reverse: 0;\n  margin-top: calc(9rem * calc(1 - var(--space-y-reverse)));\n  margin-bottom: calc(9rem * var(--space-y-reverse));\n}\n.space-x-36> :not(template)~ :not(template) {\n  --space-x-reverse: 0;\n  margin-right: calc(9rem * var(--space-x-reverse));\n  margin-left: calc(9rem * calc(1 - var(--space-x-reverse)));\n}\n.space-y-40> :not(template)~ :not(template) {\n  --space-y-reverse: 0;\n  margin-top: calc(10rem * calc(1 - var(--space-y-reverse)));\n  margin-bottom: calc(10rem * var(--space-y-reverse));\n}\n.space-x-40> :not(template)~ :not(template) {\n  --space-x-reverse: 0;\n  margin-right: calc(10rem * var(--space-x-reverse));\n  margin-left: calc(10rem * calc(1 - var(--space-x-reverse)));\n}\n.space-y-44> :not(template)~ :not(template) {\n  --space-y-reverse: 0;\n  margin-top: calc(11rem * calc(1 - var(--space-y-reverse)));\n  margin-bottom: calc(11rem * var(--space-y-reverse));\n}\n.space-x-44> :not(template)~ :not(template) {\n  --space-x-reverse: 0;\n  margin-right: calc(11rem * var(--space-x-reverse));\n  margin-left: calc(11rem * calc(1 - var(--space-x-reverse)));\n}\n.space-y-48> :not(template)~ :not(template) {\n  --space-y-reverse: 0;\n  margin-top: calc(12rem * calc(1 - var(--space-y-reverse)));\n  margin-bottom: calc(12rem * var(--space-y-reverse));\n}\n.space-x-48> :not(template)~ :not(template) {\n  --space-x-reverse: 0;\n  margin-right: calc(12rem * var(--space-x-reverse));\n  margin-left: calc(12rem * calc(1 - var(--space-x-reverse)));\n}\n.space-y-52> :not(template)~ :not(template) {\n  --space-y-reverse: 0;\n  margin-top: calc(13rem * calc(1 - var(--space-y-reverse)));\n  margin-bottom: calc(13rem * var(--space-y-reverse));\n}\n.space-x-52> :not(template)~ :not(template) {\n  --space-x-reverse: 0;\n  margin-right: calc(13rem * var(--space-x-reverse));\n  margin-left: calc(13rem * calc(1 - var(--space-x-reverse)));\n}\n.space-y-56> :not(template)~ :not(template) {\n  --space-y-reverse: 0;\n  margin-top: calc(14rem * calc(1 - var(--space-y-reverse)));\n  margin-bottom: calc(14rem * var(--space-y-reverse));\n}\n.space-x-56> :not(template)~ :not(template) {\n  --space-x-reverse: 0;\n  margin-right: calc(14rem * var(--space-x-reverse));\n  margin-left: calc(14rem * calc(1 - var(--space-x-reverse)));\n}\n.space-y-60> :not(template)~ :not(template) {\n  --space-y-reverse: 0;\n  margin-top: calc(15rem * calc(1 - var(--space-y-reverse)));\n  margin-bottom: calc(15rem * var(--space-y-reverse));\n}\n.space-x-60> :not(template)~ :not(template) {\n  --space-x-reverse: 0;\n  margin-right: calc(15rem * var(--space-x-reverse));\n  margin-left: calc(15rem * calc(1 - var(--space-x-reverse)));\n}\n.space-y-64> :not(template)~ :not(template) {\n  --space-y-reverse: 0;\n  margin-top: calc(16rem * calc(1 - var(--space-y-reverse)));\n  margin-bottom: calc(16rem * var(--space-y-reverse));\n}\n.space-x-64> :not(template)~ :not(template) {\n  --space-x-reverse: 0;\n  margin-right: calc(16rem * var(--space-x-reverse));\n  margin-left: calc(16rem * calc(1 - var(--space-x-reverse)));\n}\n.space-y-72> :not(template)~ :not(template) {\n  --space-y-reverse: 0;\n  margin-top: calc(18rem * calc(1 - var(--space-y-reverse)));\n  margin-bottom: calc(18rem * var(--space-y-reverse));\n}\n.space-x-72> :not(template)~ :not(template) {\n  --space-x-reverse: 0;\n  margin-right: calc(18rem * var(--space-x-reverse));\n  margin-left: calc(18rem * calc(1 - var(--space-x-reverse)));\n}\n.space-y-80> :not(template)~ :not(template) {\n  --space-y-reverse: 0;\n  margin-top: calc(20rem * calc(1 - var(--space-y-reverse)));\n  margin-bottom: calc(20rem * var(--space-y-reverse));\n}\n.space-x-80> :not(template)~ :not(template) {\n  --space-x-reverse: 0;\n  margin-right: calc(20rem * var(--space-x-reverse));\n  margin-left: calc(20rem * calc(1 - var(--space-x-reverse)));\n}\n.space-y-96> :not(template)~ :not(template) {\n  --space-y-reverse: 0;\n  margin-top: calc(24rem * calc(1 - var(--space-y-reverse)));\n  margin-bottom: calc(24rem * var(--space-y-reverse));\n}\n.space-x-96> :not(template)~ :not(template) {\n  --space-x-reverse: 0;\n  margin-right: calc(24rem * var(--space-x-reverse));\n  margin-left: calc(24rem * calc(1 - var(--space-x-reverse)));\n}\n.space-y-px> :not(template)~ :not(template) {\n  --space-y-reverse: 0;\n  margin-top: calc(1px * calc(1 - var(--space-y-reverse)));\n  margin-bottom: calc(1px * var(--space-y-reverse));\n}\n.space-x-px> :not(template)~ :not(template) {\n  --space-x-reverse: 0;\n  margin-right: calc(1px * var(--space-x-reverse));\n  margin-left: calc(1px * calc(1 - var(--space-x-reverse)));\n}\n.space-y-0\\.5> :not(template)~ :not(template) {\n  --space-y-reverse: 0;\n  margin-top: calc(0.125rem * calc(1 - var(--space-y-reverse)));\n  margin-bottom: calc(0.125rem * var(--space-y-reverse));\n}\n.space-x-0\\.5> :not(template)~ :not(template) {\n  --space-x-reverse: 0;\n  margin-right: calc(0.125rem * var(--space-x-reverse));\n  margin-left: calc(0.125rem * calc(1 - var(--space-x-reverse)));\n}\n.space-y-1\\.5> :not(template)~ :not(template) {\n  --space-y-reverse: 0;\n  margin-top: calc(0.375rem * calc(1 - var(--space-y-reverse)));\n  margin-bottom: calc(0.375rem * var(--space-y-reverse));\n}\n.space-x-1\\.5> :not(template)~ :not(template) {\n  --space-x-reverse: 0;\n  margin-right: calc(0.375rem * var(--space-x-reverse));\n  margin-left: calc(0.375rem * calc(1 - var(--space-x-reverse)));\n}\n.space-y-2\\.5> :not(template)~ :not(template) {\n  --space-y-reverse: 0;\n  margin-top: calc(0.625rem * calc(1 - var(--space-y-reverse)));\n  margin-bottom: calc(0.625rem * var(--space-y-reverse));\n}\n.space-x-2\\.5> :not(template)~ :not(template) {\n  --space-x-reverse: 0;\n  margin-right: calc(0.625rem * var(--space-x-reverse));\n  margin-left: calc(0.625rem * calc(1 - var(--space-x-reverse)));\n}\n.space-y-3\\.5> :not(template)~ :not(template) {\n  --space-y-reverse: 0;\n  margin-top: calc(0.875rem * calc(1 - var(--space-y-reverse)));\n  margin-bottom: calc(0.875rem * var(--space-y-reverse));\n}\n.space-x-3\\.5> :not(template)~ :not(template) {\n  --space-x-reverse: 0;\n  margin-right: calc(0.875rem * var(--space-x-reverse));\n  margin-left: calc(0.875rem * calc(1 - var(--space-x-reverse)));\n}\n.space-y-1\\/2> :not(template)~ :not(template) {\n  --space-y-reverse: 0;\n  margin-top: calc(50% * calc(1 - var(--space-y-reverse)));\n  margin-bottom: calc(50% * var(--space-y-reverse));\n}\n.space-x-1\\/2> :not(template)~ :not(template) {\n  --space-x-reverse: 0;\n  margin-right: calc(50% * var(--space-x-reverse));\n  margin-left: calc(50% * calc(1 - var(--space-x-reverse)));\n}\n.space-y-1\\/3> :not(template)~ :not(template) {\n  --space-y-reverse: 0;\n  margin-top: calc(33.333333% * calc(1 - var(--space-y-reverse)));\n  margin-bottom: calc(33.333333% * var(--space-y-reverse));\n}\n.space-x-1\\/3> :not(template)~ :not(template) {\n  --space-x-reverse: 0;\n  margin-right: calc(33.333333% * var(--space-x-reverse));\n  margin-left: calc(33.333333% * calc(1 - var(--space-x-reverse)));\n}\n.space-y-2\\/3> :not(template)~ :not(template) {\n  --space-y-reverse: 0;\n  margin-top: calc(66.666667% * calc(1 - var(--space-y-reverse)));\n  margin-bottom: calc(66.666667% * var(--space-y-reverse));\n}\n.space-x-2\\/3> :not(template)~ :not(template) {\n  --space-x-reverse: 0;\n  margin-right: calc(66.666667% * var(--space-x-reverse));\n  margin-left: calc(66.666667% * calc(1 - var(--space-x-reverse)));\n}\n.space-y-1\\/4> :not(template)~ :not(template) {\n  --space-y-reverse: 0;\n  margin-top: calc(25% * calc(1 - var(--space-y-reverse)));\n  margin-bottom: calc(25% * var(--space-y-reverse));\n}\n.space-x-1\\/4> :not(template)~ :not(template) {\n  --space-x-reverse: 0;\n  margin-right: calc(25% * var(--space-x-reverse));\n  margin-left: calc(25% * calc(1 - var(--space-x-reverse)));\n}\n.space-y-2\\/4> :not(template)~ :not(template) {\n  --space-y-reverse: 0;\n  margin-top: calc(50% * calc(1 - var(--space-y-reverse)));\n  margin-bottom: calc(50% * var(--space-y-reverse));\n}\n.space-x-2\\/4> :not(template)~ :not(template) {\n  --space-x-reverse: 0;\n  margin-right: calc(50% * var(--space-x-reverse));\n  margin-left: calc(50% * calc(1 - var(--space-x-reverse)));\n}\n.space-y-3\\/4> :not(template)~ :not(template) {\n  --space-y-reverse: 0;\n  margin-top: calc(75% * calc(1 - var(--space-y-reverse)));\n  margin-bottom: calc(75% * var(--space-y-reverse));\n}\n.space-x-3\\/4> :not(template)~ :not(template) {\n  --space-x-reverse: 0;\n  margin-right: calc(75% * var(--space-x-reverse));\n  margin-left: calc(75% * calc(1 - var(--space-x-reverse)));\n}\n.space-y-1\\/5> :not(template)~ :not(template) {\n  --space-y-reverse: 0;\n  margin-top: calc(20% * calc(1 - var(--space-y-reverse)));\n  margin-bottom: calc(20% * var(--space-y-reverse));\n}\n.space-x-1\\/5> :not(template)~ :not(template) {\n  --space-x-reverse: 0;\n  margin-right: calc(20% * var(--space-x-reverse));\n  margin-left: calc(20% * calc(1 - var(--space-x-reverse)));\n}\n.space-y-2\\/5> :not(template)~ :not(template) {\n  --space-y-reverse: 0;\n  margin-top: calc(40% * calc(1 - var(--space-y-reverse)));\n  margin-bottom: calc(40% * var(--space-y-reverse));\n}\n.space-x-2\\/5> :not(template)~ :not(template) {\n  --space-x-reverse: 0;\n  margin-right: calc(40% * var(--space-x-reverse));\n  margin-left: calc(40% * calc(1 - var(--space-x-reverse)));\n}\n.space-y-3\\/5> :not(template)~ :not(template) {\n  --space-y-reverse: 0;\n  margin-top: calc(60% * calc(1 - var(--space-y-reverse)));\n  margin-bottom: calc(60% * var(--space-y-reverse));\n}\n.space-x-3\\/5> :not(template)~ :not(template) {\n  --space-x-reverse: 0;\n  margin-right: calc(60% * var(--space-x-reverse));\n  margin-left: calc(60% * calc(1 - var(--space-x-reverse)));\n}\n.space-y-4\\/5> :not(template)~ :not(template) {\n  --space-y-reverse: 0;\n  margin-top: calc(80% * calc(1 - var(--space-y-reverse)));\n  margin-bottom: calc(80% * var(--space-y-reverse));\n}\n.space-x-4\\/5> :not(template)~ :not(template) {\n  --space-x-reverse: 0;\n  margin-right: calc(80% * var(--space-x-reverse));\n  margin-left: calc(80% * calc(1 - var(--space-x-reverse)));\n}\n.space-y-1\\/6> :not(template)~ :not(template) {\n  --space-y-reverse: 0;\n  margin-top: calc(16.666667% * calc(1 - var(--space-y-reverse)));\n  margin-bottom: calc(16.666667% * var(--space-y-reverse));\n}\n.space-x-1\\/6> :not(template)~ :not(template) {\n  --space-x-reverse: 0;\n  margin-right: calc(16.666667% * var(--space-x-reverse));\n  margin-left: calc(16.666667% * calc(1 - var(--space-x-reverse)));\n}\n.space-y-2\\/6> :not(template)~ :not(template) {\n  --space-y-reverse: 0;\n  margin-top: calc(33.333333% * calc(1 - var(--space-y-reverse)));\n  margin-bottom: calc(33.333333% * var(--space-y-reverse));\n}\n.space-x-2\\/6> :not(template)~ :not(template) {\n  --space-x-reverse: 0;\n  margin-right: calc(33.333333% * var(--space-x-reverse));\n  margin-left: calc(33.333333% * calc(1 - var(--space-x-reverse)));\n}\n.space-y-3\\/6> :not(template)~ :not(template) {\n  --space-y-reverse: 0;\n  margin-top: calc(50% * calc(1 - var(--space-y-reverse)));\n  margin-bottom: calc(50% * var(--space-y-reverse));\n}\n.space-x-3\\/6> :not(template)~ :not(template) {\n  --space-x-reverse: 0;\n  margin-right: calc(50% * var(--space-x-reverse));\n  margin-left: calc(50% * calc(1 - var(--space-x-reverse)));\n}\n.space-y-4\\/6> :not(template)~ :not(template) {\n  --space-y-reverse: 0;\n  margin-top: calc(66.666667% * calc(1 - var(--space-y-reverse)));\n  margin-bottom: calc(66.666667% * var(--space-y-reverse));\n}\n.space-x-4\\/6> :not(template)~ :not(template) {\n  --space-x-reverse: 0;\n  margin-right: calc(66.666667% * var(--space-x-reverse));\n  margin-left: calc(66.666667% * calc(1 - var(--space-x-reverse)));\n}\n.space-y-5\\/6> :not(template)~ :not(template) {\n  --space-y-reverse: 0;\n  margin-top: calc(83.333333% * calc(1 - var(--space-y-reverse)));\n  margin-bottom: calc(83.333333% * var(--space-y-reverse));\n}\n.space-x-5\\/6> :not(template)~ :not(template) {\n  --space-x-reverse: 0;\n  margin-right: calc(83.333333% * var(--space-x-reverse));\n  margin-left: calc(83.333333% * calc(1 - var(--space-x-reverse)));\n}\n.space-y-1\\/12> :not(template)~ :not(template) {\n  --space-y-reverse: 0;\n  margin-top: calc(8.333333% * calc(1 - var(--space-y-reverse)));\n  margin-bottom: calc(8.333333% * var(--space-y-reverse));\n}\n.space-x-1\\/12> :not(template)~ :not(template) {\n  --space-x-reverse: 0;\n  margin-right: calc(8.333333% * var(--space-x-reverse));\n  margin-left: calc(8.333333% * calc(1 - var(--space-x-reverse)));\n}\n.space-y-2\\/12> :not(template)~ :not(template) {\n  --space-y-reverse: 0;\n  margin-top: calc(16.666667% * calc(1 - var(--space-y-reverse)));\n  margin-bottom: calc(16.666667% * var(--space-y-reverse));\n}\n.space-x-2\\/12> :not(template)~ :not(template) {\n  --space-x-reverse: 0;\n  margin-right: calc(16.666667% * var(--space-x-reverse));\n  margin-left: calc(16.666667% * calc(1 - var(--space-x-reverse)));\n}\n.space-y-3\\/12> :not(template)~ :not(template) {\n  --space-y-reverse: 0;\n  margin-top: calc(25% * calc(1 - var(--space-y-reverse)));\n  margin-bottom: calc(25% * var(--space-y-reverse));\n}\n.space-x-3\\/12> :not(template)~ :not(template) {\n  --space-x-reverse: 0;\n  margin-right: calc(25% * var(--space-x-reverse));\n  margin-left: calc(25% * calc(1 - var(--space-x-reverse)));\n}\n.space-y-4\\/12> :not(template)~ :not(template) {\n  --space-y-reverse: 0;\n  margin-top: calc(33.333333% * calc(1 - var(--space-y-reverse)));\n  margin-bottom: calc(33.333333% * var(--space-y-reverse));\n}\n.space-x-4\\/12> :not(template)~ :not(template) {\n  --space-x-reverse: 0;\n  margin-right: calc(33.333333% * var(--space-x-reverse));\n  margin-left: calc(33.333333% * calc(1 - var(--space-x-reverse)));\n}\n.space-y-5\\/12> :not(template)~ :not(template) {\n  --space-y-reverse: 0;\n  margin-top: calc(41.666667% * calc(1 - var(--space-y-reverse)));\n  margin-bottom: calc(41.666667% * var(--space-y-reverse));\n}\n.space-x-5\\/12> :not(template)~ :not(template) {\n  --space-x-reverse: 0;\n  margin-right: calc(41.666667% * var(--space-x-reverse));\n  margin-left: calc(41.666667% * calc(1 - var(--space-x-reverse)));\n}\n.space-y-6\\/12> :not(template)~ :not(template) {\n  --space-y-reverse: 0;\n  margin-top: calc(50% * calc(1 - var(--space-y-reverse)));\n  margin-bottom: calc(50% * var(--space-y-reverse));\n}\n.space-x-6\\/12> :not(template)~ :not(template) {\n  --space-x-reverse: 0;\n  margin-right: calc(50% * var(--space-x-reverse));\n  margin-left: calc(50% * calc(1 - var(--space-x-reverse)));\n}\n.space-y-7\\/12> :not(template)~ :not(template) {\n  --space-y-reverse: 0;\n  margin-top: calc(58.333333% * calc(1 - var(--space-y-reverse)));\n  margin-bottom: calc(58.333333% * var(--space-y-reverse));\n}\n.space-x-7\\/12> :not(template)~ :not(template) {\n  --space-x-reverse: 0;\n  margin-right: calc(58.333333% * var(--space-x-reverse));\n  margin-left: calc(58.333333% * calc(1 - var(--space-x-reverse)));\n}\n.space-y-8\\/12> :not(template)~ :not(template) {\n  --space-y-reverse: 0;\n  margin-top: calc(66.666667% * calc(1 - var(--space-y-reverse)));\n  margin-bottom: calc(66.666667% * var(--space-y-reverse));\n}\n.space-x-8\\/12> :not(template)~ :not(template) {\n  --space-x-reverse: 0;\n  margin-right: calc(66.666667% * var(--space-x-reverse));\n  margin-left: calc(66.666667% * calc(1 - var(--space-x-reverse)));\n}\n.space-y-9\\/12> :not(template)~ :not(template) {\n  --space-y-reverse: 0;\n  margin-top: calc(75% * calc(1 - var(--space-y-reverse)));\n  margin-bottom: calc(75% * var(--space-y-reverse));\n}\n.space-x-9\\/12> :not(template)~ :not(template) {\n  --space-x-reverse: 0;\n  margin-right: calc(75% * var(--space-x-reverse));\n  margin-left: calc(75% * calc(1 - var(--space-x-reverse)));\n}\n.space-y-10\\/12> :not(template)~ :not(template) {\n  --space-y-reverse: 0;\n  margin-top: calc(83.333333% * calc(1 - var(--space-y-reverse)));\n  margin-bottom: calc(83.333333% * var(--space-y-reverse));\n}\n.space-x-10\\/12> :not(template)~ :not(template) {\n  --space-x-reverse: 0;\n  margin-right: calc(83.333333% * var(--space-x-reverse));\n  margin-left: calc(83.333333% * calc(1 - var(--space-x-reverse)));\n}\n.space-y-11\\/12> :not(template)~ :not(template) {\n  --space-y-reverse: 0;\n  margin-top: calc(91.666667% * calc(1 - var(--space-y-reverse)));\n  margin-bottom: calc(91.666667% * var(--space-y-reverse));\n}\n.space-x-11\\/12> :not(template)~ :not(template) {\n  --space-x-reverse: 0;\n  margin-right: calc(91.666667% * var(--space-x-reverse));\n  margin-left: calc(91.666667% * calc(1 - var(--space-x-reverse)));\n}\n.space-y-full> :not(template)~ :not(template) {\n  --space-y-reverse: 0;\n  margin-top: calc(100% * calc(1 - var(--space-y-reverse)));\n  margin-bottom: calc(100% * var(--space-y-reverse));\n}\n.space-x-full> :not(template)~ :not(template) {\n  --space-x-reverse: 0;\n  margin-right: calc(100% * var(--space-x-reverse));\n  margin-left: calc(100% * calc(1 - var(--space-x-reverse)));\n}\n.-space-y-1> :not(template)~ :not(template) {\n  --space-y-reverse: 0;\n  margin-top: calc(-0.25rem * calc(1 - var(--space-y-reverse)));\n  margin-bottom: calc(-0.25rem * var(--space-y-reverse));\n}\n.-space-x-1> :not(template)~ :not(template) {\n  --space-x-reverse: 0;\n  margin-right: calc(-0.25rem * var(--space-x-reverse));\n  margin-left: calc(-0.25rem * calc(1 - var(--space-x-reverse)));\n}\n.-space-y-2> :not(template)~ :not(template) {\n  --space-y-reverse: 0;\n  margin-top: calc(-0.5rem * calc(1 - var(--space-y-reverse)));\n  margin-bottom: calc(-0.5rem * var(--space-y-reverse));\n}\n.-space-x-2> :not(template)~ :not(template) {\n  --space-x-reverse: 0;\n  margin-right: calc(-0.5rem * var(--space-x-reverse));\n  margin-left: calc(-0.5rem * calc(1 - var(--space-x-reverse)));\n}\n.-space-y-3> :not(template)~ :not(template) {\n  --space-y-reverse: 0;\n  margin-top: calc(-0.75rem * calc(1 - var(--space-y-reverse)));\n  margin-bottom: calc(-0.75rem * var(--space-y-reverse));\n}\n.-space-x-3> :not(template)~ :not(template) {\n  --space-x-reverse: 0;\n  margin-right: calc(-0.75rem * var(--space-x-reverse));\n  margin-left: calc(-0.75rem * calc(1 - var(--space-x-reverse)));\n}\n.-space-y-4> :not(template)~ :not(template) {\n  --space-y-reverse: 0;\n  margin-top: calc(-1rem * calc(1 - var(--space-y-reverse)));\n  margin-bottom: calc(-1rem * var(--space-y-reverse));\n}\n.-space-x-4> :not(template)~ :not(template) {\n  --space-x-reverse: 0;\n  margin-right: calc(-1rem * var(--space-x-reverse));\n  margin-left: calc(-1rem * calc(1 - var(--space-x-reverse)));\n}\n.-space-y-5> :not(template)~ :not(template) {\n  --space-y-reverse: 0;\n  margin-top: calc(-1.25rem * calc(1 - var(--space-y-reverse)));\n  margin-bottom: calc(-1.25rem * var(--space-y-reverse));\n}\n.-space-x-5> :not(template)~ :not(template) {\n  --space-x-reverse: 0;\n  margin-right: calc(-1.25rem * var(--space-x-reverse));\n  margin-left: calc(-1.25rem * calc(1 - var(--space-x-reverse)));\n}\n.-space-y-6> :not(template)~ :not(template) {\n  --space-y-reverse: 0;\n  margin-top: calc(-1.5rem * calc(1 - var(--space-y-reverse)));\n  margin-bottom: calc(-1.5rem * var(--space-y-reverse));\n}\n.-space-x-6> :not(template)~ :not(template) {\n  --space-x-reverse: 0;\n  margin-right: calc(-1.5rem * var(--space-x-reverse));\n  margin-left: calc(-1.5rem * calc(1 - var(--space-x-reverse)));\n}\n.-space-y-7> :not(template)~ :not(template) {\n  --space-y-reverse: 0;\n  margin-top: calc(-1.75rem * calc(1 - var(--space-y-reverse)));\n  margin-bottom: calc(-1.75rem * var(--space-y-reverse));\n}\n.-space-x-7> :not(template)~ :not(template) {\n  --space-x-reverse: 0;\n  margin-right: calc(-1.75rem * var(--space-x-reverse));\n  margin-left: calc(-1.75rem * calc(1 - var(--space-x-reverse)));\n}\n.-space-y-8> :not(template)~ :not(template) {\n  --space-y-reverse: 0;\n  margin-top: calc(-2rem * calc(1 - var(--space-y-reverse)));\n  margin-bottom: calc(-2rem * var(--space-y-reverse));\n}\n.-space-x-8> :not(template)~ :not(template) {\n  --space-x-reverse: 0;\n  margin-right: calc(-2rem * var(--space-x-reverse));\n  margin-left: calc(-2rem * calc(1 - var(--space-x-reverse)));\n}\n.-space-y-9> :not(template)~ :not(template) {\n  --space-y-reverse: 0;\n  margin-top: calc(-2.25rem * calc(1 - var(--space-y-reverse)));\n  margin-bottom: calc(-2.25rem * var(--space-y-reverse));\n}\n.-space-x-9> :not(template)~ :not(template) {\n  --space-x-reverse: 0;\n  margin-right: calc(-2.25rem * var(--space-x-reverse));\n  margin-left: calc(-2.25rem * calc(1 - var(--space-x-reverse)));\n}\n.-space-y-10> :not(template)~ :not(template) {\n  --space-y-reverse: 0;\n  margin-top: calc(-2.5rem * calc(1 - var(--space-y-reverse)));\n  margin-bottom: calc(-2.5rem * var(--space-y-reverse));\n}\n.-space-x-10> :not(template)~ :not(template) {\n  --space-x-reverse: 0;\n  margin-right: calc(-2.5rem * var(--space-x-reverse));\n  margin-left: calc(-2.5rem * calc(1 - var(--space-x-reverse)));\n}\n.-space-y-11> :not(template)~ :not(template) {\n  --space-y-reverse: 0;\n  margin-top: calc(-2.75rem * calc(1 - var(--space-y-reverse)));\n  margin-bottom: calc(-2.75rem * var(--space-y-reverse));\n}\n.-space-x-11> :not(template)~ :not(template) {\n  --space-x-reverse: 0;\n  margin-right: calc(-2.75rem * var(--space-x-reverse));\n  margin-left: calc(-2.75rem * calc(1 - var(--space-x-reverse)));\n}\n.-space-y-12> :not(template)~ :not(template) {\n  --space-y-reverse: 0;\n  margin-top: calc(-3rem * calc(1 - var(--space-y-reverse)));\n  margin-bottom: calc(-3rem * var(--space-y-reverse));\n}\n.-space-x-12> :not(template)~ :not(template) {\n  --space-x-reverse: 0;\n  margin-right: calc(-3rem * var(--space-x-reverse));\n  margin-left: calc(-3rem * calc(1 - var(--space-x-reverse)));\n}\n.-space-y-13> :not(template)~ :not(template) {\n  --space-y-reverse: 0;\n  margin-top: calc(-3.25rem * calc(1 - var(--space-y-reverse)));\n  margin-bottom: calc(-3.25rem * var(--space-y-reverse));\n}\n.-space-x-13> :not(template)~ :not(template) {\n  --space-x-reverse: 0;\n  margin-right: calc(-3.25rem * var(--space-x-reverse));\n  margin-left: calc(-3.25rem * calc(1 - var(--space-x-reverse)));\n}\n.-space-y-14> :not(template)~ :not(template) {\n  --space-y-reverse: 0;\n  margin-top: calc(-3.5rem * calc(1 - var(--space-y-reverse)));\n  margin-bottom: calc(-3.5rem * var(--space-y-reverse));\n}\n.-space-x-14> :not(template)~ :not(template) {\n  --space-x-reverse: 0;\n  margin-right: calc(-3.5rem * var(--space-x-reverse));\n  margin-left: calc(-3.5rem * calc(1 - var(--space-x-reverse)));\n}\n.-space-y-15> :not(template)~ :not(template) {\n  --space-y-reverse: 0;\n  margin-top: calc(-3.75rem * calc(1 - var(--space-y-reverse)));\n  margin-bottom: calc(-3.75rem * var(--space-y-reverse));\n}\n.-space-x-15> :not(template)~ :not(template) {\n  --space-x-reverse: 0;\n  margin-right: calc(-3.75rem * var(--space-x-reverse));\n  margin-left: calc(-3.75rem * calc(1 - var(--space-x-reverse)));\n}\n.-space-y-16> :not(template)~ :not(template) {\n  --space-y-reverse: 0;\n  margin-top: calc(-4rem * calc(1 - var(--space-y-reverse)));\n  margin-bottom: calc(-4rem * var(--space-y-reverse));\n}\n.-space-x-16> :not(template)~ :not(template) {\n  --space-x-reverse: 0;\n  margin-right: calc(-4rem * var(--space-x-reverse));\n  margin-left: calc(-4rem * calc(1 - var(--space-x-reverse)));\n}\n.-space-y-20> :not(template)~ :not(template) {\n  --space-y-reverse: 0;\n  margin-top: calc(-5rem * calc(1 - var(--space-y-reverse)));\n  margin-bottom: calc(-5rem * var(--space-y-reverse));\n}\n.-space-x-20> :not(template)~ :not(template) {\n  --space-x-reverse: 0;\n  margin-right: calc(-5rem * var(--space-x-reverse));\n  margin-left: calc(-5rem * calc(1 - var(--space-x-reverse)));\n}\n.-space-y-24> :not(template)~ :not(template) {\n  --space-y-reverse: 0;\n  margin-top: calc(-6rem * calc(1 - var(--space-y-reverse)));\n  margin-bottom: calc(-6rem * var(--space-y-reverse));\n}\n.-space-x-24> :not(template)~ :not(template) {\n  --space-x-reverse: 0;\n  margin-right: calc(-6rem * var(--space-x-reverse));\n  margin-left: calc(-6rem * calc(1 - var(--space-x-reverse)));\n}\n.-space-y-28> :not(template)~ :not(template) {\n  --space-y-reverse: 0;\n  margin-top: calc(-7rem * calc(1 - var(--space-y-reverse)));\n  margin-bottom: calc(-7rem * var(--space-y-reverse));\n}\n.-space-x-28> :not(template)~ :not(template) {\n  --space-x-reverse: 0;\n  margin-right: calc(-7rem * var(--space-x-reverse));\n  margin-left: calc(-7rem * calc(1 - var(--space-x-reverse)));\n}\n.-space-y-32> :not(template)~ :not(template) {\n  --space-y-reverse: 0;\n  margin-top: calc(-8rem * calc(1 - var(--space-y-reverse)));\n  margin-bottom: calc(-8rem * var(--space-y-reverse));\n}\n.-space-x-32> :not(template)~ :not(template) {\n  --space-x-reverse: 0;\n  margin-right: calc(-8rem * var(--space-x-reverse));\n  margin-left: calc(-8rem * calc(1 - var(--space-x-reverse)));\n}\n.-space-y-36> :not(template)~ :not(template) {\n  --space-y-reverse: 0;\n  margin-top: calc(-9rem * calc(1 - var(--space-y-reverse)));\n  margin-bottom: calc(-9rem * var(--space-y-reverse));\n}\n.-space-x-36> :not(template)~ :not(template) {\n  --space-x-reverse: 0;\n  margin-right: calc(-9rem * var(--space-x-reverse));\n  margin-left: calc(-9rem * calc(1 - var(--space-x-reverse)));\n}\n.-space-y-40> :not(template)~ :not(template) {\n  --space-y-reverse: 0;\n  margin-top: calc(-10rem * calc(1 - var(--space-y-reverse)));\n  margin-bottom: calc(-10rem * var(--space-y-reverse));\n}\n.-space-x-40> :not(template)~ :not(template) {\n  --space-x-reverse: 0;\n  margin-right: calc(-10rem * var(--space-x-reverse));\n  margin-left: calc(-10rem * calc(1 - var(--space-x-reverse)));\n}\n.-space-y-44> :not(template)~ :not(template) {\n  --space-y-reverse: 0;\n  margin-top: calc(-11rem * calc(1 - var(--space-y-reverse)));\n  margin-bottom: calc(-11rem * var(--space-y-reverse));\n}\n.-space-x-44> :not(template)~ :not(template) {\n  --space-x-reverse: 0;\n  margin-right: calc(-11rem * var(--space-x-reverse));\n  margin-left: calc(-11rem * calc(1 - var(--space-x-reverse)));\n}\n.-space-y-48> :not(template)~ :not(template) {\n  --space-y-reverse: 0;\n  margin-top: calc(-12rem * calc(1 - var(--space-y-reverse)));\n  margin-bottom: calc(-12rem * var(--space-y-reverse));\n}\n.-space-x-48> :not(template)~ :not(template) {\n  --space-x-reverse: 0;\n  margin-right: calc(-12rem * var(--space-x-reverse));\n  margin-left: calc(-12rem * calc(1 - var(--space-x-reverse)));\n}\n.-space-y-52> :not(template)~ :not(template) {\n  --space-y-reverse: 0;\n  margin-top: calc(-13rem * calc(1 - var(--space-y-reverse)));\n  margin-bottom: calc(-13rem * var(--space-y-reverse));\n}\n.-space-x-52> :not(template)~ :not(template) {\n  --space-x-reverse: 0;\n  margin-right: calc(-13rem * var(--space-x-reverse));\n  margin-left: calc(-13rem * calc(1 - var(--space-x-reverse)));\n}\n.-space-y-56> :not(template)~ :not(template) {\n  --space-y-reverse: 0;\n  margin-top: calc(-14rem * calc(1 - var(--space-y-reverse)));\n  margin-bottom: calc(-14rem * var(--space-y-reverse));\n}\n.-space-x-56> :not(template)~ :not(template) {\n  --space-x-reverse: 0;\n  margin-right: calc(-14rem * var(--space-x-reverse));\n  margin-left: calc(-14rem * calc(1 - var(--space-x-reverse)));\n}\n.-space-y-60> :not(template)~ :not(template) {\n  --space-y-reverse: 0;\n  margin-top: calc(-15rem * calc(1 - var(--space-y-reverse)));\n  margin-bottom: calc(-15rem * var(--space-y-reverse));\n}\n.-space-x-60> :not(template)~ :not(template) {\n  --space-x-reverse: 0;\n  margin-right: calc(-15rem * var(--space-x-reverse));\n  margin-left: calc(-15rem * calc(1 - var(--space-x-reverse)));\n}\n.-space-y-64> :not(template)~ :not(template) {\n  --space-y-reverse: 0;\n  margin-top: calc(-16rem * calc(1 - var(--space-y-reverse)));\n  margin-bottom: calc(-16rem * var(--space-y-reverse));\n}\n.-space-x-64> :not(template)~ :not(template) {\n  --space-x-reverse: 0;\n  margin-right: calc(-16rem * var(--space-x-reverse));\n  margin-left: calc(-16rem * calc(1 - var(--space-x-reverse)));\n}\n.-space-y-72> :not(template)~ :not(template) {\n  --space-y-reverse: 0;\n  margin-top: calc(-18rem * calc(1 - var(--space-y-reverse)));\n  margin-bottom: calc(-18rem * var(--space-y-reverse));\n}\n.-space-x-72> :not(template)~ :not(template) {\n  --space-x-reverse: 0;\n  margin-right: calc(-18rem * var(--space-x-reverse));\n  margin-left: calc(-18rem * calc(1 - var(--space-x-reverse)));\n}\n.-space-y-80> :not(template)~ :not(template) {\n  --space-y-reverse: 0;\n  margin-top: calc(-20rem * calc(1 - var(--space-y-reverse)));\n  margin-bottom: calc(-20rem * var(--space-y-reverse));\n}\n.-space-x-80> :not(template)~ :not(template) {\n  --space-x-reverse: 0;\n  margin-right: calc(-20rem * var(--space-x-reverse));\n  margin-left: calc(-20rem * calc(1 - var(--space-x-reverse)));\n}\n.-space-y-96> :not(template)~ :not(template) {\n  --space-y-reverse: 0;\n  margin-top: calc(-24rem * calc(1 - var(--space-y-reverse)));\n  margin-bottom: calc(-24rem * var(--space-y-reverse));\n}\n.-space-x-96> :not(template)~ :not(template) {\n  --space-x-reverse: 0;\n  margin-right: calc(-24rem * var(--space-x-reverse));\n  margin-left: calc(-24rem * calc(1 - var(--space-x-reverse)));\n}\n.-space-y-px> :not(template)~ :not(template) {\n  --space-y-reverse: 0;\n  margin-top: calc(-1px * calc(1 - var(--space-y-reverse)));\n  margin-bottom: calc(-1px * var(--space-y-reverse));\n}\n.-space-x-px> :not(template)~ :not(template) {\n  --space-x-reverse: 0;\n  margin-right: calc(-1px * var(--space-x-reverse));\n  margin-left: calc(-1px * calc(1 - var(--space-x-reverse)));\n}\n.-space-y-0\\.5> :not(template)~ :not(template) {\n  --space-y-reverse: 0;\n  margin-top: calc(-0.125rem * calc(1 - var(--space-y-reverse)));\n  margin-bottom: calc(-0.125rem * var(--space-y-reverse));\n}\n.-space-x-0\\.5> :not(template)~ :not(template) {\n  --space-x-reverse: 0;\n  margin-right: calc(-0.125rem * var(--space-x-reverse));\n  margin-left: calc(-0.125rem * calc(1 - var(--space-x-reverse)));\n}\n.-space-y-1\\.5> :not(template)~ :not(template) {\n  --space-y-reverse: 0;\n  margin-top: calc(-0.375rem * calc(1 - var(--space-y-reverse)));\n  margin-bottom: calc(-0.375rem * var(--space-y-reverse));\n}\n.-space-x-1\\.5> :not(template)~ :not(template) {\n  --space-x-reverse: 0;\n  margin-right: calc(-0.375rem * var(--space-x-reverse));\n  margin-left: calc(-0.375rem * calc(1 - var(--space-x-reverse)));\n}\n.-space-y-2\\.5> :not(template)~ :not(template) {\n  --space-y-reverse: 0;\n  margin-top: calc(-0.625rem * calc(1 - var(--space-y-reverse)));\n  margin-bottom: calc(-0.625rem * var(--space-y-reverse));\n}\n.-space-x-2\\.5> :not(template)~ :not(template) {\n  --space-x-reverse: 0;\n  margin-right: calc(-0.625rem * var(--space-x-reverse));\n  margin-left: calc(-0.625rem * calc(1 - var(--space-x-reverse)));\n}\n.-space-y-3\\.5> :not(template)~ :not(template) {\n  --space-y-reverse: 0;\n  margin-top: calc(-0.875rem * calc(1 - var(--space-y-reverse)));\n  margin-bottom: calc(-0.875rem * var(--space-y-reverse));\n}\n.-space-x-3\\.5> :not(template)~ :not(template) {\n  --space-x-reverse: 0;\n  margin-right: calc(-0.875rem * var(--space-x-reverse));\n  margin-left: calc(-0.875rem * calc(1 - var(--space-x-reverse)));\n}\n.-space-y-1\\/2> :not(template)~ :not(template) {\n  --space-y-reverse: 0;\n  margin-top: calc(-50% * calc(1 - var(--space-y-reverse)));\n  margin-bottom: calc(-50% * var(--space-y-reverse));\n}\n.-space-x-1\\/2> :not(template)~ :not(template) {\n  --space-x-reverse: 0;\n  margin-right: calc(-50% * var(--space-x-reverse));\n  margin-left: calc(-50% * calc(1 - var(--space-x-reverse)));\n}\n.-space-y-1\\/3> :not(template)~ :not(template) {\n  --space-y-reverse: 0;\n  margin-top: calc(-33.33333% * calc(1 - var(--space-y-reverse)));\n  margin-bottom: calc(-33.33333% * var(--space-y-reverse));\n}\n.-space-x-1\\/3> :not(template)~ :not(template) {\n  --space-x-reverse: 0;\n  margin-right: calc(-33.33333% * var(--space-x-reverse));\n  margin-left: calc(-33.33333% * calc(1 - var(--space-x-reverse)));\n}\n.-space-y-2\\/3> :not(template)~ :not(template) {\n  --space-y-reverse: 0;\n  margin-top: calc(-66.66667% * calc(1 - var(--space-y-reverse)));\n  margin-bottom: calc(-66.66667% * var(--space-y-reverse));\n}\n.-space-x-2\\/3> :not(template)~ :not(template) {\n  --space-x-reverse: 0;\n  margin-right: calc(-66.66667% * var(--space-x-reverse));\n  margin-left: calc(-66.66667% * calc(1 - var(--space-x-reverse)));\n}\n.-space-y-1\\/4> :not(template)~ :not(template) {\n  --space-y-reverse: 0;\n  margin-top: calc(-25% * calc(1 - var(--space-y-reverse)));\n  margin-bottom: calc(-25% * var(--space-y-reverse));\n}\n.-space-x-1\\/4> :not(template)~ :not(template) {\n  --space-x-reverse: 0;\n  margin-right: calc(-25% * var(--space-x-reverse));\n  margin-left: calc(-25% * calc(1 - var(--space-x-reverse)));\n}\n.-space-y-2\\/4> :not(template)~ :not(template) {\n  --space-y-reverse: 0;\n  margin-top: calc(-50% * calc(1 - var(--space-y-reverse)));\n  margin-bottom: calc(-50% * var(--space-y-reverse));\n}\n.-space-x-2\\/4> :not(template)~ :not(template) {\n  --space-x-reverse: 0;\n  margin-right: calc(-50% * var(--space-x-reverse));\n  margin-left: calc(-50% * calc(1 - var(--space-x-reverse)));\n}\n.-space-y-3\\/4> :not(template)~ :not(template) {\n  --space-y-reverse: 0;\n  margin-top: calc(-75% * calc(1 - var(--space-y-reverse)));\n  margin-bottom: calc(-75% * var(--space-y-reverse));\n}\n.-space-x-3\\/4> :not(template)~ :not(template) {\n  --space-x-reverse: 0;\n  margin-right: calc(-75% * var(--space-x-reverse));\n  margin-left: calc(-75% * calc(1 - var(--space-x-reverse)));\n}\n.-space-y-1\\/5> :not(template)~ :not(template) {\n  --space-y-reverse: 0;\n  margin-top: calc(-20% * calc(1 - var(--space-y-reverse)));\n  margin-bottom: calc(-20% * var(--space-y-reverse));\n}\n.-space-x-1\\/5> :not(template)~ :not(template) {\n  --space-x-reverse: 0;\n  margin-right: calc(-20% * var(--space-x-reverse));\n  margin-left: calc(-20% * calc(1 - var(--space-x-reverse)));\n}\n.-space-y-2\\/5> :not(template)~ :not(template) {\n  --space-y-reverse: 0;\n  margin-top: calc(-40% * calc(1 - var(--space-y-reverse)));\n  margin-bottom: calc(-40% * var(--space-y-reverse));\n}\n.-space-x-2\\/5> :not(template)~ :not(template) {\n  --space-x-reverse: 0;\n  margin-right: calc(-40% * var(--space-x-reverse));\n  margin-left: calc(-40% * calc(1 - var(--space-x-reverse)));\n}\n.-space-y-3\\/5> :not(template)~ :not(template) {\n  --space-y-reverse: 0;\n  margin-top: calc(-60% * calc(1 - var(--space-y-reverse)));\n  margin-bottom: calc(-60% * var(--space-y-reverse));\n}\n.-space-x-3\\/5> :not(template)~ :not(template) {\n  --space-x-reverse: 0;\n  margin-right: calc(-60% * var(--space-x-reverse));\n  margin-left: calc(-60% * calc(1 - var(--space-x-reverse)));\n}\n.-space-y-4\\/5> :not(template)~ :not(template) {\n  --space-y-reverse: 0;\n  margin-top: calc(-80% * calc(1 - var(--space-y-reverse)));\n  margin-bottom: calc(-80% * var(--space-y-reverse));\n}\n.-space-x-4\\/5> :not(template)~ :not(template) {\n  --space-x-reverse: 0;\n  margin-right: calc(-80% * var(--space-x-reverse));\n  margin-left: calc(-80% * calc(1 - var(--space-x-reverse)));\n}\n.-space-y-1\\/6> :not(template)~ :not(template) {\n  --space-y-reverse: 0;\n  margin-top: calc(-16.66667% * calc(1 - var(--space-y-reverse)));\n  margin-bottom: calc(-16.66667% * var(--space-y-reverse));\n}\n.-space-x-1\\/6> :not(template)~ :not(template) {\n  --space-x-reverse: 0;\n  margin-right: calc(-16.66667% * var(--space-x-reverse));\n  margin-left: calc(-16.66667% * calc(1 - var(--space-x-reverse)));\n}\n.-space-y-2\\/6> :not(template)~ :not(template) {\n  --space-y-reverse: 0;\n  margin-top: calc(-33.33333% * calc(1 - var(--space-y-reverse)));\n  margin-bottom: calc(-33.33333% * var(--space-y-reverse));\n}\n.-space-x-2\\/6> :not(template)~ :not(template) {\n  --space-x-reverse: 0;\n  margin-right: calc(-33.33333% * var(--space-x-reverse));\n  margin-left: calc(-33.33333% * calc(1 - var(--space-x-reverse)));\n}\n.-space-y-3\\/6> :not(template)~ :not(template) {\n  --space-y-reverse: 0;\n  margin-top: calc(-50% * calc(1 - var(--space-y-reverse)));\n  margin-bottom: calc(-50% * var(--space-y-reverse));\n}\n.-space-x-3\\/6> :not(template)~ :not(template) {\n  --space-x-reverse: 0;\n  margin-right: calc(-50% * var(--space-x-reverse));\n  margin-left: calc(-50% * calc(1 - var(--space-x-reverse)));\n}\n.-space-y-4\\/6> :not(template)~ :not(template) {\n  --space-y-reverse: 0;\n  margin-top: calc(-66.66667% * calc(1 - var(--space-y-reverse)));\n  margin-bottom: calc(-66.66667% * var(--space-y-reverse));\n}\n.-space-x-4\\/6> :not(template)~ :not(template) {\n  --space-x-reverse: 0;\n  margin-right: calc(-66.66667% * var(--space-x-reverse));\n  margin-left: calc(-66.66667% * calc(1 - var(--space-x-reverse)));\n}\n.-space-y-5\\/6> :not(template)~ :not(template) {\n  --space-y-reverse: 0;\n  margin-top: calc(-83.33333% * calc(1 - var(--space-y-reverse)));\n  margin-bottom: calc(-83.33333% * var(--space-y-reverse));\n}\n.-space-x-5\\/6> :not(template)~ :not(template) {\n  --space-x-reverse: 0;\n  margin-right: calc(-83.33333% * var(--space-x-reverse));\n  margin-left: calc(-83.33333% * calc(1 - var(--space-x-reverse)));\n}\n.-space-y-1\\/12> :not(template)~ :not(template) {\n  --space-y-reverse: 0;\n  margin-top: calc(-8.33333% * calc(1 - var(--space-y-reverse)));\n  margin-bottom: calc(-8.33333% * var(--space-y-reverse));\n}\n.-space-x-1\\/12> :not(template)~ :not(template) {\n  --space-x-reverse: 0;\n  margin-right: calc(-8.33333% * var(--space-x-reverse));\n  margin-left: calc(-8.33333% * calc(1 - var(--space-x-reverse)));\n}\n.-space-y-2\\/12> :not(template)~ :not(template) {\n  --space-y-reverse: 0;\n  margin-top: calc(-16.66667% * calc(1 - var(--space-y-reverse)));\n  margin-bottom: calc(-16.66667% * var(--space-y-reverse));\n}\n.-space-x-2\\/12> :not(template)~ :not(template) {\n  --space-x-reverse: 0;\n  margin-right: calc(-16.66667% * var(--space-x-reverse));\n  margin-left: calc(-16.66667% * calc(1 - var(--space-x-reverse)));\n}\n.-space-y-3\\/12> :not(template)~ :not(template) {\n  --space-y-reverse: 0;\n  margin-top: calc(-25% * calc(1 - var(--space-y-reverse)));\n  margin-bottom: calc(-25% * var(--space-y-reverse));\n}\n.-space-x-3\\/12> :not(template)~ :not(template) {\n  --space-x-reverse: 0;\n  margin-right: calc(-25% * var(--space-x-reverse));\n  margin-left: calc(-25% * calc(1 - var(--space-x-reverse)));\n}\n.-space-y-4\\/12> :not(template)~ :not(template) {\n  --space-y-reverse: 0;\n  margin-top: calc(-33.33333% * calc(1 - var(--space-y-reverse)));\n  margin-bottom: calc(-33.33333% * var(--space-y-reverse));\n}\n.-space-x-4\\/12> :not(template)~ :not(template) {\n  --space-x-reverse: 0;\n  margin-right: calc(-33.33333% * var(--space-x-reverse));\n  margin-left: calc(-33.33333% * calc(1 - var(--space-x-reverse)));\n}\n.-space-y-5\\/12> :not(template)~ :not(template) {\n  --space-y-reverse: 0;\n  margin-top: calc(-41.66667% * calc(1 - var(--space-y-reverse)));\n  margin-bottom: calc(-41.66667% * var(--space-y-reverse));\n}\n.-space-x-5\\/12> :not(template)~ :not(template) {\n  --space-x-reverse: 0;\n  margin-right: calc(-41.66667% * var(--space-x-reverse));\n  margin-left: calc(-41.66667% * calc(1 - var(--space-x-reverse)));\n}\n.-space-y-6\\/12> :not(template)~ :not(template) {\n  --space-y-reverse: 0;\n  margin-top: calc(-50% * calc(1 - var(--space-y-reverse)));\n  margin-bottom: calc(-50% * var(--space-y-reverse));\n}\n.-space-x-6\\/12> :not(template)~ :not(template) {\n  --space-x-reverse: 0;\n  margin-right: calc(-50% * var(--space-x-reverse));\n  margin-left: calc(-50% * calc(1 - var(--space-x-reverse)));\n}\n.-space-y-7\\/12> :not(template)~ :not(template) {\n  --space-y-reverse: 0;\n  margin-top: calc(-58.33333% * calc(1 - var(--space-y-reverse)));\n  margin-bottom: calc(-58.33333% * var(--space-y-reverse));\n}\n.-space-x-7\\/12> :not(template)~ :not(template) {\n  --space-x-reverse: 0;\n  margin-right: calc(-58.33333% * var(--space-x-reverse));\n  margin-left: calc(-58.33333% * calc(1 - var(--space-x-reverse)));\n}\n.-space-y-8\\/12> :not(template)~ :not(template) {\n  --space-y-reverse: 0;\n  margin-top: calc(-66.66667% * calc(1 - var(--space-y-reverse)));\n  margin-bottom: calc(-66.66667% * var(--space-y-reverse));\n}\n.-space-x-8\\/12> :not(template)~ :not(template) {\n  --space-x-reverse: 0;\n  margin-right: calc(-66.66667% * var(--space-x-reverse));\n  margin-left: calc(-66.66667% * calc(1 - var(--space-x-reverse)));\n}\n.-space-y-9\\/12> :not(template)~ :not(template) {\n  --space-y-reverse: 0;\n  margin-top: calc(-75% * calc(1 - var(--space-y-reverse)));\n  margin-bottom: calc(-75% * var(--space-y-reverse));\n}\n.-space-x-9\\/12> :not(template)~ :not(template) {\n  --space-x-reverse: 0;\n  margin-right: calc(-75% * var(--space-x-reverse));\n  margin-left: calc(-75% * calc(1 - var(--space-x-reverse)));\n}\n.-space-y-10\\/12> :not(template)~ :not(template) {\n  --space-y-reverse: 0;\n  margin-top: calc(-83.33333% * calc(1 - var(--space-y-reverse)));\n  margin-bottom: calc(-83.33333% * var(--space-y-reverse));\n}\n.-space-x-10\\/12> :not(template)~ :not(template) {\n  --space-x-reverse: 0;\n  margin-right: calc(-83.33333% * var(--space-x-reverse));\n  margin-left: calc(-83.33333% * calc(1 - var(--space-x-reverse)));\n}\n.-space-y-11\\/12> :not(template)~ :not(template) {\n  --space-y-reverse: 0;\n  margin-top: calc(-91.66667% * calc(1 - var(--space-y-reverse)));\n  margin-bottom: calc(-91.66667% * var(--space-y-reverse));\n}\n.-space-x-11\\/12> :not(template)~ :not(template) {\n  --space-x-reverse: 0;\n  margin-right: calc(-91.66667% * var(--space-x-reverse));\n  margin-left: calc(-91.66667% * calc(1 - var(--space-x-reverse)));\n}\n.-space-y-full> :not(template)~ :not(template) {\n  --space-y-reverse: 0;\n  margin-top: calc(-100% * calc(1 - var(--space-y-reverse)));\n  margin-bottom: calc(-100% * var(--space-y-reverse));\n}\n.-space-x-full> :not(template)~ :not(template) {\n  --space-x-reverse: 0;\n  margin-right: calc(-100% * var(--space-x-reverse));\n  margin-left: calc(-100% * calc(1 - var(--space-x-reverse)));\n}\n.space-y-reverse> :not(template)~ :not(template) {\n  --space-y-reverse: 1;\n}\n.space-x-reverse> :not(template)~ :not(template) {\n  --space-x-reverse: 1;\n}\n.divide-y-0> :not(template)~ :not(template) {\n  --divide-y-reverse: 0;\n  border-top-width: calc(0px * calc(1 - var(--divide-y-reverse)));\n  border-bottom-width: calc(0px * var(--divide-y-reverse));\n}\n.divide-x-0> :not(template)~ :not(template) {\n  --divide-x-reverse: 0;\n  border-right-width: calc(0px * var(--divide-x-reverse));\n  border-left-width: calc(0px * calc(1 - var(--divide-x-reverse)));\n}\n.divide-y-2> :not(template)~ :not(template) {\n  --divide-y-reverse: 0;\n  border-top-width: calc(2px * calc(1 - var(--divide-y-reverse)));\n  border-bottom-width: calc(2px * var(--divide-y-reverse));\n}\n.divide-x-2> :not(template)~ :not(template) {\n  --divide-x-reverse: 0;\n  border-right-width: calc(2px * var(--divide-x-reverse));\n  border-left-width: calc(2px * calc(1 - var(--divide-x-reverse)));\n}\n.divide-y-4> :not(template)~ :not(template) {\n  --divide-y-reverse: 0;\n  border-top-width: calc(4px * calc(1 - var(--divide-y-reverse)));\n  border-bottom-width: calc(4px * var(--divide-y-reverse));\n}\n.divide-x-4> :not(template)~ :not(template) {\n  --divide-x-reverse: 0;\n  border-right-width: calc(4px * var(--divide-x-reverse));\n  border-left-width: calc(4px * calc(1 - var(--divide-x-reverse)));\n}\n.divide-y-8> :not(template)~ :not(template) {\n  --divide-y-reverse: 0;\n  border-top-width: calc(8px * calc(1 - var(--divide-y-reverse)));\n  border-bottom-width: calc(8px * var(--divide-y-reverse));\n}\n.divide-x-8> :not(template)~ :not(template) {\n  --divide-x-reverse: 0;\n  border-right-width: calc(8px * var(--divide-x-reverse));\n  border-left-width: calc(8px * calc(1 - var(--divide-x-reverse)));\n}\n.divide-y> :not(template)~ :not(template) {\n  --divide-y-reverse: 0;\n  border-top-width: calc(1px * calc(1 - var(--divide-y-reverse)));\n  border-bottom-width: calc(1px * var(--divide-y-reverse));\n}\n.divide-x> :not(template)~ :not(template) {\n  --divide-x-reverse: 0;\n  border-right-width: calc(1px * var(--divide-x-reverse));\n  border-left-width: calc(1px * calc(1 - var(--divide-x-reverse)));\n}\n.divide-y-reverse> :not(template)~ :not(template) {\n  --divide-y-reverse: 1;\n}\n.divide-x-reverse> :not(template)~ :not(template) {\n  --divide-x-reverse: 1;\n}\n.divide-current> :not(template)~ :not(template) {\n  border-color: currentColor;\n}\n.divide-transparent> :not(template)~ :not(template) {\n  border-color: transparent;\n}\n.divide-white> :not(template)~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #ffffff;\n  border-color: rgba(255, 255, 255, var(--divide-opacity));\n}\n.divide-black> :not(template)~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #000000;\n  border-color: rgba(0, 0, 0, var(--divide-opacity));\n}\n.divide-gray-50> :not(template)~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #f9fafb;\n  border-color: rgba(249, 250, 251, var(--divide-opacity));\n}\n.divide-gray-100> :not(template)~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #f4f5f7;\n  border-color: rgba(244, 245, 247, var(--divide-opacity));\n}\n.divide-gray-200> :not(template)~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #e5e7eb;\n  border-color: rgba(229, 231, 235, var(--divide-opacity));\n}\n.divide-gray-300> :not(template)~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #d2d6dc;\n  border-color: rgba(210, 214, 220, var(--divide-opacity));\n}\n.divide-gray-400> :not(template)~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #9fa6b2;\n  border-color: rgba(159, 166, 178, var(--divide-opacity));\n}\n.divide-gray-500> :not(template)~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #6b7280;\n  border-color: rgba(107, 114, 128, var(--divide-opacity));\n}\n.divide-gray-600> :not(template)~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #4b5563;\n  border-color: rgba(75, 85, 99, var(--divide-opacity));\n}\n.divide-gray-700> :not(template)~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #374151;\n  border-color: rgba(55, 65, 81, var(--divide-opacity));\n}\n.divide-gray-800> :not(template)~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #252f3f;\n  border-color: rgba(37, 47, 63, var(--divide-opacity));\n}\n.divide-gray-900> :not(template)~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #161e2e;\n  border-color: rgba(22, 30, 46, var(--divide-opacity));\n}\n.divide-red-50> :not(template)~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #fdf2f2;\n  border-color: rgba(253, 242, 242, var(--divide-opacity));\n}\n.divide-red-100> :not(template)~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #fde8e8;\n  border-color: rgba(253, 232, 232, var(--divide-opacity));\n}\n.divide-red-200> :not(template)~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #fbd5d5;\n  border-color: rgba(251, 213, 213, var(--divide-opacity));\n}\n.divide-red-300> :not(template)~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #f8b4b4;\n  border-color: rgba(248, 180, 180, var(--divide-opacity));\n}\n.divide-red-400> :not(template)~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #f98080;\n  border-color: rgba(249, 128, 128, var(--divide-opacity));\n}\n.divide-red-500> :not(template)~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #f05252;\n  border-color: rgba(240, 82, 82, var(--divide-opacity));\n}\n.divide-red-600> :not(template)~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #e02424;\n  border-color: rgba(224, 36, 36, var(--divide-opacity));\n}\n.divide-red-700> :not(template)~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #c81e1e;\n  border-color: rgba(200, 30, 30, var(--divide-opacity));\n}\n.divide-red-800> :not(template)~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #9b1c1c;\n  border-color: rgba(155, 28, 28, var(--divide-opacity));\n}\n.divide-red-900> :not(template)~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #771d1d;\n  border-color: rgba(119, 29, 29, var(--divide-opacity));\n}\n.divide-orange-50> :not(template)~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #fff8f1;\n  border-color: rgba(255, 248, 241, var(--divide-opacity));\n}\n.divide-orange-100> :not(template)~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #feecdc;\n  border-color: rgba(254, 236, 220, var(--divide-opacity));\n}\n.divide-orange-200> :not(template)~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #fcd9bd;\n  border-color: rgba(252, 217, 189, var(--divide-opacity));\n}\n.divide-orange-300> :not(template)~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #fdba8c;\n  border-color: rgba(253, 186, 140, var(--divide-opacity));\n}\n.divide-orange-400> :not(template)~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #ff8a4c;\n  border-color: rgba(255, 138, 76, var(--divide-opacity));\n}\n.divide-orange-500> :not(template)~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #ff5a1f;\n  border-color: rgba(255, 90, 31, var(--divide-opacity));\n}\n.divide-orange-600> :not(template)~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #d03801;\n  border-color: rgba(208, 56, 1, var(--divide-opacity));\n}\n.divide-orange-700> :not(template)~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #b43403;\n  border-color: rgba(180, 52, 3, var(--divide-opacity));\n}\n.divide-orange-800> :not(template)~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #8a2c0d;\n  border-color: rgba(138, 44, 13, var(--divide-opacity));\n}\n.divide-orange-900> :not(template)~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #73230d;\n  border-color: rgba(115, 35, 13, var(--divide-opacity));\n}\n.divide-yellow-50> :not(template)~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #fdfdea;\n  border-color: rgba(253, 253, 234, var(--divide-opacity));\n}\n.divide-yellow-100> :not(template)~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #fdf6b2;\n  border-color: rgba(253, 246, 178, var(--divide-opacity));\n}\n.divide-yellow-200> :not(template)~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #fce96a;\n  border-color: rgba(252, 233, 106, var(--divide-opacity));\n}\n.divide-yellow-300> :not(template)~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #faca15;\n  border-color: rgba(250, 202, 21, var(--divide-opacity));\n}\n.divide-yellow-400> :not(template)~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #e3a008;\n  border-color: rgba(227, 160, 8, var(--divide-opacity));\n}\n.divide-yellow-500> :not(template)~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #c27803;\n  border-color: rgba(194, 120, 3, var(--divide-opacity));\n}\n.divide-yellow-600> :not(template)~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #9f580a;\n  border-color: rgba(159, 88, 10, var(--divide-opacity));\n}\n.divide-yellow-700> :not(template)~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #8e4b10;\n  border-color: rgba(142, 75, 16, var(--divide-opacity));\n}\n.divide-yellow-800> :not(template)~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #723b13;\n  border-color: rgba(114, 59, 19, var(--divide-opacity));\n}\n.divide-yellow-900> :not(template)~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #633112;\n  border-color: rgba(99, 49, 18, var(--divide-opacity));\n}\n.divide-green-50> :not(template)~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #f3faf7;\n  border-color: rgba(243, 250, 247, var(--divide-opacity));\n}\n.divide-green-100> :not(template)~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #def7ec;\n  border-color: rgba(222, 247, 236, var(--divide-opacity));\n}\n.divide-green-200> :not(template)~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #bcf0da;\n  border-color: rgba(188, 240, 218, var(--divide-opacity));\n}\n.divide-green-300> :not(template)~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #84e1bc;\n  border-color: rgba(132, 225, 188, var(--divide-opacity));\n}\n.divide-green-400> :not(template)~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #31c48d;\n  border-color: rgba(49, 196, 141, var(--divide-opacity));\n}\n.divide-green-500> :not(template)~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #0e9f6e;\n  border-color: rgba(14, 159, 110, var(--divide-opacity));\n}\n.divide-green-600> :not(template)~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #057a55;\n  border-color: rgba(5, 122, 85, var(--divide-opacity));\n}\n.divide-green-700> :not(template)~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #046c4e;\n  border-color: rgba(4, 108, 78, var(--divide-opacity));\n}\n.divide-green-800> :not(template)~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #03543f;\n  border-color: rgba(3, 84, 63, var(--divide-opacity));\n}\n.divide-green-900> :not(template)~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #014737;\n  border-color: rgba(1, 71, 55, var(--divide-opacity));\n}\n.divide-teal-50> :not(template)~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #edfafa;\n  border-color: rgba(237, 250, 250, var(--divide-opacity));\n}\n.divide-teal-100> :not(template)~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #d5f5f6;\n  border-color: rgba(213, 245, 246, var(--divide-opacity));\n}\n.divide-teal-200> :not(template)~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #afecef;\n  border-color: rgba(175, 236, 239, var(--divide-opacity));\n}\n.divide-teal-300> :not(template)~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #7edce2;\n  border-color: rgba(126, 220, 226, var(--divide-opacity));\n}\n.divide-teal-400> :not(template)~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #16bdca;\n  border-color: rgba(22, 189, 202, var(--divide-opacity));\n}\n.divide-teal-500> :not(template)~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #0694a2;\n  border-color: rgba(6, 148, 162, var(--divide-opacity));\n}\n.divide-teal-600> :not(template)~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #047481;\n  border-color: rgba(4, 116, 129, var(--divide-opacity));\n}\n.divide-teal-700> :not(template)~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #036672;\n  border-color: rgba(3, 102, 114, var(--divide-opacity));\n}\n.divide-teal-800> :not(template)~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #05505c;\n  border-color: rgba(5, 80, 92, var(--divide-opacity));\n}\n.divide-teal-900> :not(template)~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #014451;\n  border-color: rgba(1, 68, 81, var(--divide-opacity));\n}\n.divide-blue-50> :not(template)~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #ebf5ff;\n  border-color: rgba(235, 245, 255, var(--divide-opacity));\n}\n.divide-blue-100> :not(template)~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #e1effe;\n  border-color: rgba(225, 239, 254, var(--divide-opacity));\n}\n.divide-blue-200> :not(template)~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #c3ddfd;\n  border-color: rgba(195, 221, 253, var(--divide-opacity));\n}\n.divide-blue-300> :not(template)~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #a4cafe;\n  border-color: rgba(164, 202, 254, var(--divide-opacity));\n}\n.divide-blue-400> :not(template)~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #76a9fa;\n  border-color: rgba(118, 169, 250, var(--divide-opacity));\n}\n.divide-blue-500> :not(template)~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #3f83f8;\n  border-color: rgba(63, 131, 248, var(--divide-opacity));\n}\n.divide-blue-600> :not(template)~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #1c64f2;\n  border-color: rgba(28, 100, 242, var(--divide-opacity));\n}\n.divide-blue-700> :not(template)~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #1a56db;\n  border-color: rgba(26, 86, 219, var(--divide-opacity));\n}\n.divide-blue-800> :not(template)~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #1e429f;\n  border-color: rgba(30, 66, 159, var(--divide-opacity));\n}\n.divide-blue-900> :not(template)~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #233876;\n  border-color: rgba(35, 56, 118, var(--divide-opacity));\n}\n.divide-indigo-50> :not(template)~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #f0f5ff;\n  border-color: rgba(240, 245, 255, var(--divide-opacity));\n}\n.divide-indigo-100> :not(template)~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #e5edff;\n  border-color: rgba(229, 237, 255, var(--divide-opacity));\n}\n.divide-indigo-200> :not(template)~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #cddbfe;\n  border-color: rgba(205, 219, 254, var(--divide-opacity));\n}\n.divide-indigo-300> :not(template)~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #b4c6fc;\n  border-color: rgba(180, 198, 252, var(--divide-opacity));\n}\n.divide-indigo-400> :not(template)~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #8da2fb;\n  border-color: rgba(141, 162, 251, var(--divide-opacity));\n}\n.divide-indigo-500> :not(template)~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #6875f5;\n  border-color: rgba(104, 117, 245, var(--divide-opacity));\n}\n.divide-indigo-600> :not(template)~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #5850ec;\n  border-color: rgba(88, 80, 236, var(--divide-opacity));\n}\n.divide-indigo-700> :not(template)~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #5145cd;\n  border-color: rgba(81, 69, 205, var(--divide-opacity));\n}\n.divide-indigo-800> :not(template)~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #42389d;\n  border-color: rgba(66, 56, 157, var(--divide-opacity));\n}\n.divide-indigo-900> :not(template)~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #362f78;\n  border-color: rgba(54, 47, 120, var(--divide-opacity));\n}\n.divide-purple-50> :not(template)~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #f6f5ff;\n  border-color: rgba(246, 245, 255, var(--divide-opacity));\n}\n.divide-purple-100> :not(template)~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #edebfe;\n  border-color: rgba(237, 235, 254, var(--divide-opacity));\n}\n.divide-purple-200> :not(template)~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #dcd7fe;\n  border-color: rgba(220, 215, 254, var(--divide-opacity));\n}\n.divide-purple-300> :not(template)~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #cabffd;\n  border-color: rgba(202, 191, 253, var(--divide-opacity));\n}\n.divide-purple-400> :not(template)~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #ac94fa;\n  border-color: rgba(172, 148, 250, var(--divide-opacity));\n}\n.divide-purple-500> :not(template)~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #9061f9;\n  border-color: rgba(144, 97, 249, var(--divide-opacity));\n}\n.divide-purple-600> :not(template)~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #7e3af2;\n  border-color: rgba(126, 58, 242, var(--divide-opacity));\n}\n.divide-purple-700> :not(template)~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #6c2bd9;\n  border-color: rgba(108, 43, 217, var(--divide-opacity));\n}\n.divide-purple-800> :not(template)~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #5521b5;\n  border-color: rgba(85, 33, 181, var(--divide-opacity));\n}\n.divide-purple-900> :not(template)~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #4a1d96;\n  border-color: rgba(74, 29, 150, var(--divide-opacity));\n}\n.divide-pink-50> :not(template)~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #fdf2f8;\n  border-color: rgba(253, 242, 248, var(--divide-opacity));\n}\n.divide-pink-100> :not(template)~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #fce8f3;\n  border-color: rgba(252, 232, 243, var(--divide-opacity));\n}\n.divide-pink-200> :not(template)~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #fad1e8;\n  border-color: rgba(250, 209, 232, var(--divide-opacity));\n}\n.divide-pink-300> :not(template)~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #f8b4d9;\n  border-color: rgba(248, 180, 217, var(--divide-opacity));\n}\n.divide-pink-400> :not(template)~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #f17eb8;\n  border-color: rgba(241, 126, 184, var(--divide-opacity));\n}\n.divide-pink-500> :not(template)~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #e74694;\n  border-color: rgba(231, 70, 148, var(--divide-opacity));\n}\n.divide-pink-600> :not(template)~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #d61f69;\n  border-color: rgba(214, 31, 105, var(--divide-opacity));\n}\n.divide-pink-700> :not(template)~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #bf125d;\n  border-color: rgba(191, 18, 93, var(--divide-opacity));\n}\n.divide-pink-800> :not(template)~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #99154b;\n  border-color: rgba(153, 21, 75, var(--divide-opacity));\n}\n.divide-pink-900> :not(template)~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #751a3d;\n  border-color: rgba(117, 26, 61, var(--divide-opacity));\n}\n.divide-cool-gray-50> :not(template)~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #f8fafc;\n  border-color: rgba(248, 250, 252, var(--divide-opacity));\n}\n.divide-cool-gray-100> :not(template)~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #f1f5f9;\n  border-color: rgba(241, 245, 249, var(--divide-opacity));\n}\n.divide-cool-gray-200> :not(template)~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #e2e8f0;\n  border-color: rgba(226, 232, 240, var(--divide-opacity));\n}\n.divide-cool-gray-300> :not(template)~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #cfd8e3;\n  border-color: rgba(207, 216, 227, var(--divide-opacity));\n}\n.divide-cool-gray-400> :not(template)~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #97a6ba;\n  border-color: rgba(151, 166, 186, var(--divide-opacity));\n}\n.divide-cool-gray-500> :not(template)~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #64748b;\n  border-color: rgba(100, 116, 139, var(--divide-opacity));\n}\n.divide-cool-gray-600> :not(template)~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #475569;\n  border-color: rgba(71, 85, 105, var(--divide-opacity));\n}\n.divide-cool-gray-700> :not(template)~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #364152;\n  border-color: rgba(54, 65, 82, var(--divide-opacity));\n}\n.divide-cool-gray-800> :not(template)~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #27303f;\n  border-color: rgba(39, 48, 63, var(--divide-opacity));\n}\n.divide-cool-gray-900> :not(template)~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #1a202e;\n  border-color: rgba(26, 32, 46, var(--divide-opacity));\n}\n.divide-solid> :not(template)~ :not(template) {\n  border-style: solid;\n}\n.divide-dashed> :not(template)~ :not(template) {\n  border-style: dashed;\n}\n.divide-dotted> :not(template)~ :not(template) {\n  border-style: dotted;\n}\n.divide-double> :not(template)~ :not(template) {\n  border-style: double;\n}\n.divide-none> :not(template)~ :not(template) {\n  border-style: none;\n}\n.divide-opacity-0> :not(template)~ :not(template) {\n  --divide-opacity: 0;\n}\n.divide-opacity-25> :not(template)~ :not(template) {\n  --divide-opacity: 0.25;\n}\n.divide-opacity-50> :not(template)~ :not(template) {\n  --divide-opacity: 0.5;\n}\n.divide-opacity-75> :not(template)~ :not(template) {\n  --divide-opacity: 0.75;\n}\n.divide-opacity-100> :not(template)~ :not(template) {\n  --divide-opacity: 1;\n}\n.sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border-width: 0;\n}\n.not-sr-only {\n  position: static;\n  width: auto;\n  height: auto;\n  padding: 0;\n  margin: 0;\n  overflow: visible;\n  clip: auto;\n  white-space: normal;\n}\n.focus\\:sr-only:focus {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border-width: 0;\n}\n.focus\\:not-sr-only:focus {\n  position: static;\n  width: auto;\n  height: auto;\n  padding: 0;\n  margin: 0;\n  overflow: visible;\n  clip: auto;\n  white-space: normal;\n}\n.appearance-none {\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n}\n.bg-fixed {\n  background-attachment: fixed;\n}\n.bg-local {\n  background-attachment: local;\n}\n.bg-scroll {\n  background-attachment: scroll;\n}\n.bg-clip-border {\n  background-clip: border-box;\n}\n.bg-clip-padding {\n  background-clip: padding-box;\n}\n.bg-clip-content {\n  background-clip: content-box;\n}\n.bg-clip-text {\n  -webkit-background-clip: text;\n  background-clip: text;\n}\n.bg-current {\n  background-color: currentColor;\n}\n.bg-transparent {\n  background-color: transparent;\n}\n.bg-white {\n  --bg-opacity: 1;\n  background-color: #ffffff;\n  background-color: rgba(255, 255, 255, var(--bg-opacity));\n}\n.bg-black {\n  --bg-opacity: 1;\n  background-color: #000000;\n  background-color: rgba(0, 0, 0, var(--bg-opacity));\n}\n.bg-gray-50 {\n  --bg-opacity: 1;\n  background-color: #f9fafb;\n  background-color: rgba(249, 250, 251, var(--bg-opacity));\n}\n.bg-gray-100 {\n  --bg-opacity: 1;\n  background-color: #f4f5f7;\n  background-color: rgba(244, 245, 247, var(--bg-opacity));\n}\n.bg-gray-200 {\n  --bg-opacity: 1;\n  background-color: #e5e7eb;\n  background-color: rgba(229, 231, 235, var(--bg-opacity));\n}\n.bg-gray-300 {\n  --bg-opacity: 1;\n  background-color: #d2d6dc;\n  background-color: rgba(210, 214, 220, var(--bg-opacity));\n}\n.bg-gray-400 {\n  --bg-opacity: 1;\n  background-color: #9fa6b2;\n  background-color: rgba(159, 166, 178, var(--bg-opacity));\n}\n.bg-gray-500 {\n  --bg-opacity: 1;\n  background-color: #6b7280;\n  background-color: rgba(107, 114, 128, var(--bg-opacity));\n}\n.bg-gray-600 {\n  --bg-opacity: 1;\n  background-color: #4b5563;\n  background-color: rgba(75, 85, 99, var(--bg-opacity));\n}\n.bg-gray-700 {\n  --bg-opacity: 1;\n  background-color: #374151;\n  background-color: rgba(55, 65, 81, var(--bg-opacity));\n}\n.bg-gray-800 {\n  --bg-opacity: 1;\n  background-color: #252f3f;\n  background-color: rgba(37, 47, 63, var(--bg-opacity));\n}\n.bg-gray-900 {\n  --bg-opacity: 1;\n  background-color: #161e2e;\n  background-color: rgba(22, 30, 46, var(--bg-opacity));\n}\n.bg-red-50 {\n  --bg-opacity: 1;\n  background-color: #fdf2f2;\n  background-color: rgba(253, 242, 242, var(--bg-opacity));\n}\n.bg-red-100 {\n  --bg-opacity: 1;\n  background-color: #fde8e8;\n  background-color: rgba(253, 232, 232, var(--bg-opacity));\n}\n.bg-red-200 {\n  --bg-opacity: 1;\n  background-color: #fbd5d5;\n  background-color: rgba(251, 213, 213, var(--bg-opacity));\n}\n.bg-red-300 {\n  --bg-opacity: 1;\n  background-color: #f8b4b4;\n  background-color: rgba(248, 180, 180, var(--bg-opacity));\n}\n.bg-red-400 {\n  --bg-opacity: 1;\n  background-color: #f98080;\n  background-color: rgba(249, 128, 128, var(--bg-opacity));\n}\n.bg-red-500 {\n  --bg-opacity: 1;\n  background-color: #f05252;\n  background-color: rgba(240, 82, 82, var(--bg-opacity));\n}\n.bg-red-600 {\n  --bg-opacity: 1;\n  background-color: #e02424;\n  background-color: rgba(224, 36, 36, var(--bg-opacity));\n}\n.bg-red-700 {\n  --bg-opacity: 1;\n  background-color: #c81e1e;\n  background-color: rgba(200, 30, 30, var(--bg-opacity));\n}\n.bg-red-800 {\n  --bg-opacity: 1;\n  background-color: #9b1c1c;\n  background-color: rgba(155, 28, 28, var(--bg-opacity));\n}\n.bg-red-900 {\n  --bg-opacity: 1;\n  background-color: #771d1d;\n  background-color: rgba(119, 29, 29, var(--bg-opacity));\n}\n.bg-orange-50 {\n  --bg-opacity: 1;\n  background-color: #fff8f1;\n  background-color: rgba(255, 248, 241, var(--bg-opacity));\n}\n.bg-orange-100 {\n  --bg-opacity: 1;\n  background-color: #feecdc;\n  background-color: rgba(254, 236, 220, var(--bg-opacity));\n}\n.bg-orange-200 {\n  --bg-opacity: 1;\n  background-color: #fcd9bd;\n  background-color: rgba(252, 217, 189, var(--bg-opacity));\n}\n.bg-orange-300 {\n  --bg-opacity: 1;\n  background-color: #fdba8c;\n  background-color: rgba(253, 186, 140, var(--bg-opacity));\n}\n.bg-orange-400 {\n  --bg-opacity: 1;\n  background-color: #ff8a4c;\n  background-color: rgba(255, 138, 76, var(--bg-opacity));\n}\n.bg-orange-500 {\n  --bg-opacity: 1;\n  background-color: #ff5a1f;\n  background-color: rgba(255, 90, 31, var(--bg-opacity));\n}\n.bg-orange-600 {\n  --bg-opacity: 1;\n  background-color: #d03801;\n  background-color: rgba(208, 56, 1, var(--bg-opacity));\n}\n.bg-orange-700 {\n  --bg-opacity: 1;\n  background-color: #b43403;\n  background-color: rgba(180, 52, 3, var(--bg-opacity));\n}\n.bg-orange-800 {\n  --bg-opacity: 1;\n  background-color: #8a2c0d;\n  background-color: rgba(138, 44, 13, var(--bg-opacity));\n}\n.bg-orange-900 {\n  --bg-opacity: 1;\n  background-color: #73230d;\n  background-color: rgba(115, 35, 13, var(--bg-opacity));\n}\n.bg-yellow-50 {\n  --bg-opacity: 1;\n  background-color: #fdfdea;\n  background-color: rgba(253, 253, 234, var(--bg-opacity));\n}\n.bg-yellow-100 {\n  --bg-opacity: 1;\n  background-color: #fdf6b2;\n  background-color: rgba(253, 246, 178, var(--bg-opacity));\n}\n.bg-yellow-200 {\n  --bg-opacity: 1;\n  background-color: #fce96a;\n  background-color: rgba(252, 233, 106, var(--bg-opacity));\n}\n.bg-yellow-300 {\n  --bg-opacity: 1;\n  background-color: #faca15;\n  background-color: rgba(250, 202, 21, var(--bg-opacity));\n}\n.bg-yellow-400 {\n  --bg-opacity: 1;\n  background-color: #e3a008;\n  background-color: rgba(227, 160, 8, var(--bg-opacity));\n}\n.bg-yellow-500 {\n  --bg-opacity: 1;\n  background-color: #c27803;\n  background-color: rgba(194, 120, 3, var(--bg-opacity));\n}\n.bg-yellow-600 {\n  --bg-opacity: 1;\n  background-color: #9f580a;\n  background-color: rgba(159, 88, 10, var(--bg-opacity));\n}\n.bg-yellow-700 {\n  --bg-opacity: 1;\n  background-color: #8e4b10;\n  background-color: rgba(142, 75, 16, var(--bg-opacity));\n}\n.bg-yellow-800 {\n  --bg-opacity: 1;\n  background-color: #723b13;\n  background-color: rgba(114, 59, 19, var(--bg-opacity));\n}\n.bg-yellow-900 {\n  --bg-opacity: 1;\n  background-color: #633112;\n  background-color: rgba(99, 49, 18, var(--bg-opacity));\n}\n.bg-green-50 {\n  --bg-opacity: 1;\n  background-color: #f3faf7;\n  background-color: rgba(243, 250, 247, var(--bg-opacity));\n}\n.bg-green-100 {\n  --bg-opacity: 1;\n  background-color: #def7ec;\n  background-color: rgba(222, 247, 236, var(--bg-opacity));\n}\n.bg-green-200 {\n  --bg-opacity: 1;\n  background-color: #bcf0da;\n  background-color: rgba(188, 240, 218, var(--bg-opacity));\n}\n.bg-green-300 {\n  --bg-opacity: 1;\n  background-color: #84e1bc;\n  background-color: rgba(132, 225, 188, var(--bg-opacity));\n}\n.bg-green-400 {\n  --bg-opacity: 1;\n  background-color: #31c48d;\n  background-color: rgba(49, 196, 141, var(--bg-opacity));\n}\n.bg-green-500 {\n  --bg-opacity: 1;\n  background-color: #0e9f6e;\n  background-color: rgba(14, 159, 110, var(--bg-opacity));\n}\n.bg-green-600 {\n  --bg-opacity: 1;\n  background-color: #057a55;\n  background-color: rgba(5, 122, 85, var(--bg-opacity));\n}\n.bg-green-700 {\n  --bg-opacity: 1;\n  background-color: #046c4e;\n  background-color: rgba(4, 108, 78, var(--bg-opacity));\n}\n.bg-green-800 {\n  --bg-opacity: 1;\n  background-color: #03543f;\n  background-color: rgba(3, 84, 63, var(--bg-opacity));\n}\n.bg-green-900 {\n  --bg-opacity: 1;\n  background-color: #014737;\n  background-color: rgba(1, 71, 55, var(--bg-opacity));\n}\n.bg-teal-50 {\n  --bg-opacity: 1;\n  background-color: #edfafa;\n  background-color: rgba(237, 250, 250, var(--bg-opacity));\n}\n.bg-teal-100 {\n  --bg-opacity: 1;\n  background-color: #d5f5f6;\n  background-color: rgba(213, 245, 246, var(--bg-opacity));\n}\n.bg-teal-200 {\n  --bg-opacity: 1;\n  background-color: #afecef;\n  background-color: rgba(175, 236, 239, var(--bg-opacity));\n}\n.bg-teal-300 {\n  --bg-opacity: 1;\n  background-color: #7edce2;\n  background-color: rgba(126, 220, 226, var(--bg-opacity));\n}\n.bg-teal-400 {\n  --bg-opacity: 1;\n  background-color: #16bdca;\n  background-color: rgba(22, 189, 202, var(--bg-opacity));\n}\n.bg-teal-500 {\n  --bg-opacity: 1;\n  background-color: #0694a2;\n  background-color: rgba(6, 148, 162, var(--bg-opacity));\n}\n.bg-teal-600 {\n  --bg-opacity: 1;\n  background-color: #047481;\n  background-color: rgba(4, 116, 129, var(--bg-opacity));\n}\n.bg-teal-700 {\n  --bg-opacity: 1;\n  background-color: #036672;\n  background-color: rgba(3, 102, 114, var(--bg-opacity));\n}\n.bg-teal-800 {\n  --bg-opacity: 1;\n  background-color: #05505c;\n  background-color: rgba(5, 80, 92, var(--bg-opacity));\n}\n.bg-teal-900 {\n  --bg-opacity: 1;\n  background-color: #014451;\n  background-color: rgba(1, 68, 81, var(--bg-opacity));\n}\n.bg-blue-50 {\n  --bg-opacity: 1;\n  background-color: #ebf5ff;\n  background-color: rgba(235, 245, 255, var(--bg-opacity));\n}\n.bg-blue-100 {\n  --bg-opacity: 1;\n  background-color: #e1effe;\n  background-color: rgba(225, 239, 254, var(--bg-opacity));\n}\n.bg-blue-200 {\n  --bg-opacity: 1;\n  background-color: #c3ddfd;\n  background-color: rgba(195, 221, 253, var(--bg-opacity));\n}\n.bg-blue-300 {\n  --bg-opacity: 1;\n  background-color: #a4cafe;\n  background-color: rgba(164, 202, 254, var(--bg-opacity));\n}\n.bg-blue-400 {\n  --bg-opacity: 1;\n  background-color: #76a9fa;\n  background-color: rgba(118, 169, 250, var(--bg-opacity));\n}\n.bg-blue-500 {\n  --bg-opacity: 1;\n  background-color: #3f83f8;\n  background-color: rgba(63, 131, 248, var(--bg-opacity));\n}\n.bg-blue-600 {\n  --bg-opacity: 1;\n  background-color: #1c64f2;\n  background-color: rgba(28, 100, 242, var(--bg-opacity));\n}\n.bg-blue-700 {\n  --bg-opacity: 1;\n  background-color: #1a56db;\n  background-color: rgba(26, 86, 219, var(--bg-opacity));\n}\n.bg-blue-800 {\n  --bg-opacity: 1;\n  background-color: #1e429f;\n  background-color: rgba(30, 66, 159, var(--bg-opacity));\n}\n.bg-blue-900 {\n  --bg-opacity: 1;\n  background-color: #233876;\n  background-color: rgba(35, 56, 118, var(--bg-opacity));\n}\n.bg-indigo-50 {\n  --bg-opacity: 1;\n  background-color: #f0f5ff;\n  background-color: rgba(240, 245, 255, var(--bg-opacity));\n}\n.bg-indigo-100 {\n  --bg-opacity: 1;\n  background-color: #e5edff;\n  background-color: rgba(229, 237, 255, var(--bg-opacity));\n}\n.bg-indigo-200 {\n  --bg-opacity: 1;\n  background-color: #cddbfe;\n  background-color: rgba(205, 219, 254, var(--bg-opacity));\n}\n.bg-indigo-300 {\n  --bg-opacity: 1;\n  background-color: #b4c6fc;\n  background-color: rgba(180, 198, 252, var(--bg-opacity));\n}\n.bg-indigo-400 {\n  --bg-opacity: 1;\n  background-color: #8da2fb;\n  background-color: rgba(141, 162, 251, var(--bg-opacity));\n}\n.bg-indigo-500 {\n  --bg-opacity: 1;\n  background-color: #6875f5;\n  background-color: rgba(104, 117, 245, var(--bg-opacity));\n}\n.bg-indigo-600 {\n  --bg-opacity: 1;\n  background-color: #5850ec;\n  background-color: rgba(88, 80, 236, var(--bg-opacity));\n}\n.bg-indigo-700 {\n  --bg-opacity: 1;\n  background-color: #5145cd;\n  background-color: rgba(81, 69, 205, var(--bg-opacity));\n}\n.bg-indigo-800 {\n  --bg-opacity: 1;\n  background-color: #42389d;\n  background-color: rgba(66, 56, 157, var(--bg-opacity));\n}\n.bg-indigo-900 {\n  --bg-opacity: 1;\n  background-color: #362f78;\n  background-color: rgba(54, 47, 120, var(--bg-opacity));\n}\n.bg-purple-50 {\n  --bg-opacity: 1;\n  background-color: #f6f5ff;\n  background-color: rgba(246, 245, 255, var(--bg-opacity));\n}\n.bg-purple-100 {\n  --bg-opacity: 1;\n  background-color: #edebfe;\n  background-color: rgba(237, 235, 254, var(--bg-opacity));\n}\n.bg-purple-200 {\n  --bg-opacity: 1;\n  background-color: #dcd7fe;\n  background-color: rgba(220, 215, 254, var(--bg-opacity));\n}\n.bg-purple-300 {\n  --bg-opacity: 1;\n  background-color: #cabffd;\n  background-color: rgba(202, 191, 253, var(--bg-opacity));\n}\n.bg-purple-400 {\n  --bg-opacity: 1;\n  background-color: #ac94fa;\n  background-color: rgba(172, 148, 250, var(--bg-opacity));\n}\n.bg-purple-500 {\n  --bg-opacity: 1;\n  background-color: #9061f9;\n  background-color: rgba(144, 97, 249, var(--bg-opacity));\n}\n.bg-purple-600 {\n  --bg-opacity: 1;\n  background-color: #7e3af2;\n  background-color: rgba(126, 58, 242, var(--bg-opacity));\n}\n.bg-purple-700 {\n  --bg-opacity: 1;\n  background-color: #6c2bd9;\n  background-color: rgba(108, 43, 217, var(--bg-opacity));\n}\n.bg-purple-800 {\n  --bg-opacity: 1;\n  background-color: #5521b5;\n  background-color: rgba(85, 33, 181, var(--bg-opacity));\n}\n.bg-purple-900 {\n  --bg-opacity: 1;\n  background-color: #4a1d96;\n  background-color: rgba(74, 29, 150, var(--bg-opacity));\n}\n.bg-pink-50 {\n  --bg-opacity: 1;\n  background-color: #fdf2f8;\n  background-color: rgba(253, 242, 248, var(--bg-opacity));\n}\n.bg-pink-100 {\n  --bg-opacity: 1;\n  background-color: #fce8f3;\n  background-color: rgba(252, 232, 243, var(--bg-opacity));\n}\n.bg-pink-200 {\n  --bg-opacity: 1;\n  background-color: #fad1e8;\n  background-color: rgba(250, 209, 232, var(--bg-opacity));\n}\n.bg-pink-300 {\n  --bg-opacity: 1;\n  background-color: #f8b4d9;\n  background-color: rgba(248, 180, 217, var(--bg-opacity));\n}\n.bg-pink-400 {\n  --bg-opacity: 1;\n  background-color: #f17eb8;\n  background-color: rgba(241, 126, 184, var(--bg-opacity));\n}\n.bg-pink-500 {\n  --bg-opacity: 1;\n  background-color: #e74694;\n  background-color: rgba(231, 70, 148, var(--bg-opacity));\n}\n.bg-pink-600 {\n  --bg-opacity: 1;\n  background-color: #d61f69;\n  background-color: rgba(214, 31, 105, var(--bg-opacity));\n}\n.bg-pink-700 {\n  --bg-opacity: 1;\n  background-color: #bf125d;\n  background-color: rgba(191, 18, 93, var(--bg-opacity));\n}\n.bg-pink-800 {\n  --bg-opacity: 1;\n  background-color: #99154b;\n  background-color: rgba(153, 21, 75, var(--bg-opacity));\n}\n.bg-pink-900 {\n  --bg-opacity: 1;\n  background-color: #751a3d;\n  background-color: rgba(117, 26, 61, var(--bg-opacity));\n}\n.bg-cool-gray-50 {\n  --bg-opacity: 1;\n  background-color: #f8fafc;\n  background-color: rgba(248, 250, 252, var(--bg-opacity));\n}\n.bg-cool-gray-100 {\n  --bg-opacity: 1;\n  background-color: #f1f5f9;\n  background-color: rgba(241, 245, 249, var(--bg-opacity));\n}\n.bg-cool-gray-200 {\n  --bg-opacity: 1;\n  background-color: #e2e8f0;\n  background-color: rgba(226, 232, 240, var(--bg-opacity));\n}\n.bg-cool-gray-300 {\n  --bg-opacity: 1;\n  background-color: #cfd8e3;\n  background-color: rgba(207, 216, 227, var(--bg-opacity));\n}\n.bg-cool-gray-400 {\n  --bg-opacity: 1;\n  background-color: #97a6ba;\n  background-color: rgba(151, 166, 186, var(--bg-opacity));\n}\n.bg-cool-gray-500 {\n  --bg-opacity: 1;\n  background-color: #64748b;\n  background-color: rgba(100, 116, 139, var(--bg-opacity));\n}\n.bg-cool-gray-600 {\n  --bg-opacity: 1;\n  background-color: #475569;\n  background-color: rgba(71, 85, 105, var(--bg-opacity));\n}\n.bg-cool-gray-700 {\n  --bg-opacity: 1;\n  background-color: #364152;\n  background-color: rgba(54, 65, 82, var(--bg-opacity));\n}\n.bg-cool-gray-800 {\n  --bg-opacity: 1;\n  background-color: #27303f;\n  background-color: rgba(39, 48, 63, var(--bg-opacity));\n}\n.bg-cool-gray-900 {\n  --bg-opacity: 1;\n  background-color: #1a202e;\n  background-color: rgba(26, 32, 46, var(--bg-opacity));\n}\n.group:hover .group-hover\\:bg-current {\n  background-color: currentColor;\n}\n.group:hover .group-hover\\:bg-transparent {\n  background-color: transparent;\n}\n.group:hover .group-hover\\:bg-white {\n  --bg-opacity: 1;\n  background-color: #ffffff;\n  background-color: rgba(255, 255, 255, var(--bg-opacity));\n}\n.group:hover .group-hover\\:bg-black {\n  --bg-opacity: 1;\n  background-color: #000000;\n  background-color: rgba(0, 0, 0, var(--bg-opacity));\n}\n.group:hover .group-hover\\:bg-gray-50 {\n  --bg-opacity: 1;\n  background-color: #f9fafb;\n  background-color: rgba(249, 250, 251, var(--bg-opacity));\n}\n.group:hover .group-hover\\:bg-gray-100 {\n  --bg-opacity: 1;\n  background-color: #f4f5f7;\n  background-color: rgba(244, 245, 247, var(--bg-opacity));\n}\n.group:hover .group-hover\\:bg-gray-200 {\n  --bg-opacity: 1;\n  background-color: #e5e7eb;\n  background-color: rgba(229, 231, 235, var(--bg-opacity));\n}\n.group:hover .group-hover\\:bg-gray-300 {\n  --bg-opacity: 1;\n  background-color: #d2d6dc;\n  background-color: rgba(210, 214, 220, var(--bg-opacity));\n}\n.group:hover .group-hover\\:bg-gray-400 {\n  --bg-opacity: 1;\n  background-color: #9fa6b2;\n  background-color: rgba(159, 166, 178, var(--bg-opacity));\n}\n.group:hover .group-hover\\:bg-gray-500 {\n  --bg-opacity: 1;\n  background-color: #6b7280;\n  background-color: rgba(107, 114, 128, var(--bg-opacity));\n}\n.group:hover .group-hover\\:bg-gray-600 {\n  --bg-opacity: 1;\n  background-color: #4b5563;\n  background-color: rgba(75, 85, 99, var(--bg-opacity));\n}\n.group:hover .group-hover\\:bg-gray-700 {\n  --bg-opacity: 1;\n  background-color: #374151;\n  background-color: rgba(55, 65, 81, var(--bg-opacity));\n}\n.group:hover .group-hover\\:bg-gray-800 {\n  --bg-opacity: 1;\n  background-color: #252f3f;\n  background-color: rgba(37, 47, 63, var(--bg-opacity));\n}\n.group:hover .group-hover\\:bg-gray-900 {\n  --bg-opacity: 1;\n  background-color: #161e2e;\n  background-color: rgba(22, 30, 46, var(--bg-opacity));\n}\n.group:hover .group-hover\\:bg-red-50 {\n  --bg-opacity: 1;\n  background-color: #fdf2f2;\n  background-color: rgba(253, 242, 242, var(--bg-opacity));\n}\n.group:hover .group-hover\\:bg-red-100 {\n  --bg-opacity: 1;\n  background-color: #fde8e8;\n  background-color: rgba(253, 232, 232, var(--bg-opacity));\n}\n.group:hover .group-hover\\:bg-red-200 {\n  --bg-opacity: 1;\n  background-color: #fbd5d5;\n  background-color: rgba(251, 213, 213, var(--bg-opacity));\n}\n.group:hover .group-hover\\:bg-red-300 {\n  --bg-opacity: 1;\n  background-color: #f8b4b4;\n  background-color: rgba(248, 180, 180, var(--bg-opacity));\n}\n.group:hover .group-hover\\:bg-red-400 {\n  --bg-opacity: 1;\n  background-color: #f98080;\n  background-color: rgba(249, 128, 128, var(--bg-opacity));\n}\n.group:hover .group-hover\\:bg-red-500 {\n  --bg-opacity: 1;\n  background-color: #f05252;\n  background-color: rgba(240, 82, 82, var(--bg-opacity));\n}\n.group:hover .group-hover\\:bg-red-600 {\n  --bg-opacity: 1;\n  background-color: #e02424;\n  background-color: rgba(224, 36, 36, var(--bg-opacity));\n}\n.group:hover .group-hover\\:bg-red-700 {\n  --bg-opacity: 1;\n  background-color: #c81e1e;\n  background-color: rgba(200, 30, 30, var(--bg-opacity));\n}\n.group:hover .group-hover\\:bg-red-800 {\n  --bg-opacity: 1;\n  background-color: #9b1c1c;\n  background-color: rgba(155, 28, 28, var(--bg-opacity));\n}\n.group:hover .group-hover\\:bg-red-900 {\n  --bg-opacity: 1;\n  background-color: #771d1d;\n  background-color: rgba(119, 29, 29, var(--bg-opacity));\n}\n.group:hover .group-hover\\:bg-orange-50 {\n  --bg-opacity: 1;\n  background-color: #fff8f1;\n  background-color: rgba(255, 248, 241, var(--bg-opacity));\n}\n.group:hover .group-hover\\:bg-orange-100 {\n  --bg-opacity: 1;\n  background-color: #feecdc;\n  background-color: rgba(254, 236, 220, var(--bg-opacity));\n}\n.group:hover .group-hover\\:bg-orange-200 {\n  --bg-opacity: 1;\n  background-color: #fcd9bd;\n  background-color: rgba(252, 217, 189, var(--bg-opacity));\n}\n.group:hover .group-hover\\:bg-orange-300 {\n  --bg-opacity: 1;\n  background-color: #fdba8c;\n  background-color: rgba(253, 186, 140, var(--bg-opacity));\n}\n.group:hover .group-hover\\:bg-orange-400 {\n  --bg-opacity: 1;\n  background-color: #ff8a4c;\n  background-color: rgba(255, 138, 76, var(--bg-opacity));\n}\n.group:hover .group-hover\\:bg-orange-500 {\n  --bg-opacity: 1;\n  background-color: #ff5a1f;\n  background-color: rgba(255, 90, 31, var(--bg-opacity));\n}\n.group:hover .group-hover\\:bg-orange-600 {\n  --bg-opacity: 1;\n  background-color: #d03801;\n  background-color: rgba(208, 56, 1, var(--bg-opacity));\n}\n.group:hover .group-hover\\:bg-orange-700 {\n  --bg-opacity: 1;\n  background-color: #b43403;\n  background-color: rgba(180, 52, 3, var(--bg-opacity));\n}\n.group:hover .group-hover\\:bg-orange-800 {\n  --bg-opacity: 1;\n  background-color: #8a2c0d;\n  background-color: rgba(138, 44, 13, var(--bg-opacity));\n}\n.group:hover .group-hover\\:bg-orange-900 {\n  --bg-opacity: 1;\n  background-color: #73230d;\n  background-color: rgba(115, 35, 13, var(--bg-opacity));\n}\n.group:hover .group-hover\\:bg-yellow-50 {\n  --bg-opacity: 1;\n  background-color: #fdfdea;\n  background-color: rgba(253, 253, 234, var(--bg-opacity));\n}\n.group:hover .group-hover\\:bg-yellow-100 {\n  --bg-opacity: 1;\n  background-color: #fdf6b2;\n  background-color: rgba(253, 246, 178, var(--bg-opacity));\n}\n.group:hover .group-hover\\:bg-yellow-200 {\n  --bg-opacity: 1;\n  background-color: #fce96a;\n  background-color: rgba(252, 233, 106, var(--bg-opacity));\n}\n.group:hover .group-hover\\:bg-yellow-300 {\n  --bg-opacity: 1;\n  background-color: #faca15;\n  background-color: rgba(250, 202, 21, var(--bg-opacity));\n}\n.group:hover .group-hover\\:bg-yellow-400 {\n  --bg-opacity: 1;\n  background-color: #e3a008;\n  background-color: rgba(227, 160, 8, var(--bg-opacity));\n}\n.group:hover .group-hover\\:bg-yellow-500 {\n  --bg-opacity: 1;\n  background-color: #c27803;\n  background-color: rgba(194, 120, 3, var(--bg-opacity));\n}\n.group:hover .group-hover\\:bg-yellow-600 {\n  --bg-opacity: 1;\n  background-color: #9f580a;\n  background-color: rgba(159, 88, 10, var(--bg-opacity));\n}\n.group:hover .group-hover\\:bg-yellow-700 {\n  --bg-opacity: 1;\n  background-color: #8e4b10;\n  background-color: rgba(142, 75, 16, var(--bg-opacity));\n}\n.group:hover .group-hover\\:bg-yellow-800 {\n  --bg-opacity: 1;\n  background-color: #723b13;\n  background-color: rgba(114, 59, 19, var(--bg-opacity));\n}\n.group:hover .group-hover\\:bg-yellow-900 {\n  --bg-opacity: 1;\n  background-color: #633112;\n  background-color: rgba(99, 49, 18, var(--bg-opacity));\n}\n.group:hover .group-hover\\:bg-green-50 {\n  --bg-opacity: 1;\n  background-color: #f3faf7;\n  background-color: rgba(243, 250, 247, var(--bg-opacity));\n}\n.group:hover .group-hover\\:bg-green-100 {\n  --bg-opacity: 1;\n  background-color: #def7ec;\n  background-color: rgba(222, 247, 236, var(--bg-opacity));\n}\n.group:hover .group-hover\\:bg-green-200 {\n  --bg-opacity: 1;\n  background-color: #bcf0da;\n  background-color: rgba(188, 240, 218, var(--bg-opacity));\n}\n.group:hover .group-hover\\:bg-green-300 {\n  --bg-opacity: 1;\n  background-color: #84e1bc;\n  background-color: rgba(132, 225, 188, var(--bg-opacity));\n}\n.group:hover .group-hover\\:bg-green-400 {\n  --bg-opacity: 1;\n  background-color: #31c48d;\n  background-color: rgba(49, 196, 141, var(--bg-opacity));\n}\n.group:hover .group-hover\\:bg-green-500 {\n  --bg-opacity: 1;\n  background-color: #0e9f6e;\n  background-color: rgba(14, 159, 110, var(--bg-opacity));\n}\n.group:hover .group-hover\\:bg-green-600 {\n  --bg-opacity: 1;\n  background-color: #057a55;\n  background-color: rgba(5, 122, 85, var(--bg-opacity));\n}\n.group:hover .group-hover\\:bg-green-700 {\n  --bg-opacity: 1;\n  background-color: #046c4e;\n  background-color: rgba(4, 108, 78, var(--bg-opacity));\n}\n.group:hover .group-hover\\:bg-green-800 {\n  --bg-opacity: 1;\n  background-color: #03543f;\n  background-color: rgba(3, 84, 63, var(--bg-opacity));\n}\n.group:hover .group-hover\\:bg-green-900 {\n  --bg-opacity: 1;\n  background-color: #014737;\n  background-color: rgba(1, 71, 55, var(--bg-opacity));\n}\n.group:hover .group-hover\\:bg-teal-50 {\n  --bg-opacity: 1;\n  background-color: #edfafa;\n  background-color: rgba(237, 250, 250, var(--bg-opacity));\n}\n.group:hover .group-hover\\:bg-teal-100 {\n  --bg-opacity: 1;\n  background-color: #d5f5f6;\n  background-color: rgba(213, 245, 246, var(--bg-opacity));\n}\n.group:hover .group-hover\\:bg-teal-200 {\n  --bg-opacity: 1;\n  background-color: #afecef;\n  background-color: rgba(175, 236, 239, var(--bg-opacity));\n}\n.group:hover .group-hover\\:bg-teal-300 {\n  --bg-opacity: 1;\n  background-color: #7edce2;\n  background-color: rgba(126, 220, 226, var(--bg-opacity));\n}\n.group:hover .group-hover\\:bg-teal-400 {\n  --bg-opacity: 1;\n  background-color: #16bdca;\n  background-color: rgba(22, 189, 202, var(--bg-opacity));\n}\n.group:hover .group-hover\\:bg-teal-500 {\n  --bg-opacity: 1;\n  background-color: #0694a2;\n  background-color: rgba(6, 148, 162, var(--bg-opacity));\n}\n.group:hover .group-hover\\:bg-teal-600 {\n  --bg-opacity: 1;\n  background-color: #047481;\n  background-color: rgba(4, 116, 129, var(--bg-opacity));\n}\n.group:hover .group-hover\\:bg-teal-700 {\n  --bg-opacity: 1;\n  background-color: #036672;\n  background-color: rgba(3, 102, 114, var(--bg-opacity));\n}\n.group:hover .group-hover\\:bg-teal-800 {\n  --bg-opacity: 1;\n  background-color: #05505c;\n  background-color: rgba(5, 80, 92, var(--bg-opacity));\n}\n.group:hover .group-hover\\:bg-teal-900 {\n  --bg-opacity: 1;\n  background-color: #014451;\n  background-color: rgba(1, 68, 81, var(--bg-opacity));\n}\n.group:hover .group-hover\\:bg-blue-50 {\n  --bg-opacity: 1;\n  background-color: #ebf5ff;\n  background-color: rgba(235, 245, 255, var(--bg-opacity));\n}\n.group:hover .group-hover\\:bg-blue-100 {\n  --bg-opacity: 1;\n  background-color: #e1effe;\n  background-color: rgba(225, 239, 254, var(--bg-opacity));\n}\n.group:hover .group-hover\\:bg-blue-200 {\n  --bg-opacity: 1;\n  background-color: #c3ddfd;\n  background-color: rgba(195, 221, 253, var(--bg-opacity));\n}\n.group:hover .group-hover\\:bg-blue-300 {\n  --bg-opacity: 1;\n  background-color: #a4cafe;\n  background-color: rgba(164, 202, 254, var(--bg-opacity));\n}\n.group:hover .group-hover\\:bg-blue-400 {\n  --bg-opacity: 1;\n  background-color: #76a9fa;\n  background-color: rgba(118, 169, 250, var(--bg-opacity));\n}\n.group:hover .group-hover\\:bg-blue-500 {\n  --bg-opacity: 1;\n  background-color: #3f83f8;\n  background-color: rgba(63, 131, 248, var(--bg-opacity));\n}\n.group:hover .group-hover\\:bg-blue-600 {\n  --bg-opacity: 1;\n  background-color: #1c64f2;\n  background-color: rgba(28, 100, 242, var(--bg-opacity));\n}\n.group:hover .group-hover\\:bg-blue-700 {\n  --bg-opacity: 1;\n  background-color: #1a56db;\n  background-color: rgba(26, 86, 219, var(--bg-opacity));\n}\n.group:hover .group-hover\\:bg-blue-800 {\n  --bg-opacity: 1;\n  background-color: #1e429f;\n  background-color: rgba(30, 66, 159, var(--bg-opacity));\n}\n.group:hover .group-hover\\:bg-blue-900 {\n  --bg-opacity: 1;\n  background-color: #233876;\n  background-color: rgba(35, 56, 118, var(--bg-opacity));\n}\n.group:hover .group-hover\\:bg-indigo-50 {\n  --bg-opacity: 1;\n  background-color: #f0f5ff;\n  background-color: rgba(240, 245, 255, var(--bg-opacity));\n}\n.group:hover .group-hover\\:bg-indigo-100 {\n  --bg-opacity: 1;\n  background-color: #e5edff;\n  background-color: rgba(229, 237, 255, var(--bg-opacity));\n}\n.group:hover .group-hover\\:bg-indigo-200 {\n  --bg-opacity: 1;\n  background-color: #cddbfe;\n  background-color: rgba(205, 219, 254, var(--bg-opacity));\n}\n.group:hover .group-hover\\:bg-indigo-300 {\n  --bg-opacity: 1;\n  background-color: #b4c6fc;\n  background-color: rgba(180, 198, 252, var(--bg-opacity));\n}\n.group:hover .group-hover\\:bg-indigo-400 {\n  --bg-opacity: 1;\n  background-color: #8da2fb;\n  background-color: rgba(141, 162, 251, var(--bg-opacity));\n}\n.group:hover .group-hover\\:bg-indigo-500 {\n  --bg-opacity: 1;\n  background-color: #6875f5;\n  background-color: rgba(104, 117, 245, var(--bg-opacity));\n}\n.group:hover .group-hover\\:bg-indigo-600 {\n  --bg-opacity: 1;\n  background-color: #5850ec;\n  background-color: rgba(88, 80, 236, var(--bg-opacity));\n}\n.group:hover .group-hover\\:bg-indigo-700 {\n  --bg-opacity: 1;\n  background-color: #5145cd;\n  background-color: rgba(81, 69, 205, var(--bg-opacity));\n}\n.group:hover .group-hover\\:bg-indigo-800 {\n  --bg-opacity: 1;\n  background-color: #42389d;\n  background-color: rgba(66, 56, 157, var(--bg-opacity));\n}\n.group:hover .group-hover\\:bg-indigo-900 {\n  --bg-opacity: 1;\n  background-color: #362f78;\n  background-color: rgba(54, 47, 120, var(--bg-opacity));\n}\n.group:hover .group-hover\\:bg-purple-50 {\n  --bg-opacity: 1;\n  background-color: #f6f5ff;\n  background-color: rgba(246, 245, 255, var(--bg-opacity));\n}\n.group:hover .group-hover\\:bg-purple-100 {\n  --bg-opacity: 1;\n  background-color: #edebfe;\n  background-color: rgba(237, 235, 254, var(--bg-opacity));\n}\n.group:hover .group-hover\\:bg-purple-200 {\n  --bg-opacity: 1;\n  background-color: #dcd7fe;\n  background-color: rgba(220, 215, 254, var(--bg-opacity));\n}\n.group:hover .group-hover\\:bg-purple-300 {\n  --bg-opacity: 1;\n  background-color: #cabffd;\n  background-color: rgba(202, 191, 253, var(--bg-opacity));\n}\n.group:hover .group-hover\\:bg-purple-400 {\n  --bg-opacity: 1;\n  background-color: #ac94fa;\n  background-color: rgba(172, 148, 250, var(--bg-opacity));\n}\n.group:hover .group-hover\\:bg-purple-500 {\n  --bg-opacity: 1;\n  background-color: #9061f9;\n  background-color: rgba(144, 97, 249, var(--bg-opacity));\n}\n.group:hover .group-hover\\:bg-purple-600 {\n  --bg-opacity: 1;\n  background-color: #7e3af2;\n  background-color: rgba(126, 58, 242, var(--bg-opacity));\n}\n.group:hover .group-hover\\:bg-purple-700 {\n  --bg-opacity: 1;\n  background-color: #6c2bd9;\n  background-color: rgba(108, 43, 217, var(--bg-opacity));\n}\n.group:hover .group-hover\\:bg-purple-800 {\n  --bg-opacity: 1;\n  background-color: #5521b5;\n  background-color: rgba(85, 33, 181, var(--bg-opacity));\n}\n.group:hover .group-hover\\:bg-purple-900 {\n  --bg-opacity: 1;\n  background-color: #4a1d96;\n  background-color: rgba(74, 29, 150, var(--bg-opacity));\n}\n.group:hover .group-hover\\:bg-pink-50 {\n  --bg-opacity: 1;\n  background-color: #fdf2f8;\n  background-color: rgba(253, 242, 248, var(--bg-opacity));\n}\n.group:hover .group-hover\\:bg-pink-100 {\n  --bg-opacity: 1;\n  background-color: #fce8f3;\n  background-color: rgba(252, 232, 243, var(--bg-opacity));\n}\n.group:hover .group-hover\\:bg-pink-200 {\n  --bg-opacity: 1;\n  background-color: #fad1e8;\n  background-color: rgba(250, 209, 232, var(--bg-opacity));\n}\n.group:hover .group-hover\\:bg-pink-300 {\n  --bg-opacity: 1;\n  background-color: #f8b4d9;\n  background-color: rgba(248, 180, 217, var(--bg-opacity));\n}\n.group:hover .group-hover\\:bg-pink-400 {\n  --bg-opacity: 1;\n  background-color: #f17eb8;\n  background-color: rgba(241, 126, 184, var(--bg-opacity));\n}\n.group:hover .group-hover\\:bg-pink-500 {\n  --bg-opacity: 1;\n  background-color: #e74694;\n  background-color: rgba(231, 70, 148, var(--bg-opacity));\n}\n.group:hover .group-hover\\:bg-pink-600 {\n  --bg-opacity: 1;\n  background-color: #d61f69;\n  background-color: rgba(214, 31, 105, var(--bg-opacity));\n}\n.group:hover .group-hover\\:bg-pink-700 {\n  --bg-opacity: 1;\n  background-color: #bf125d;\n  background-color: rgba(191, 18, 93, var(--bg-opacity));\n}\n.group:hover .group-hover\\:bg-pink-800 {\n  --bg-opacity: 1;\n  background-color: #99154b;\n  background-color: rgba(153, 21, 75, var(--bg-opacity));\n}\n.group:hover .group-hover\\:bg-pink-900 {\n  --bg-opacity: 1;\n  background-color: #751a3d;\n  background-color: rgba(117, 26, 61, var(--bg-opacity));\n}\n.group:hover .group-hover\\:bg-cool-gray-50 {\n  --bg-opacity: 1;\n  background-color: #f8fafc;\n  background-color: rgba(248, 250, 252, var(--bg-opacity));\n}\n.group:hover .group-hover\\:bg-cool-gray-100 {\n  --bg-opacity: 1;\n  background-color: #f1f5f9;\n  background-color: rgba(241, 245, 249, var(--bg-opacity));\n}\n.group:hover .group-hover\\:bg-cool-gray-200 {\n  --bg-opacity: 1;\n  background-color: #e2e8f0;\n  background-color: rgba(226, 232, 240, var(--bg-opacity));\n}\n.group:hover .group-hover\\:bg-cool-gray-300 {\n  --bg-opacity: 1;\n  background-color: #cfd8e3;\n  background-color: rgba(207, 216, 227, var(--bg-opacity));\n}\n.group:hover .group-hover\\:bg-cool-gray-400 {\n  --bg-opacity: 1;\n  background-color: #97a6ba;\n  background-color: rgba(151, 166, 186, var(--bg-opacity));\n}\n.group:hover .group-hover\\:bg-cool-gray-500 {\n  --bg-opacity: 1;\n  background-color: #64748b;\n  background-color: rgba(100, 116, 139, var(--bg-opacity));\n}\n.group:hover .group-hover\\:bg-cool-gray-600 {\n  --bg-opacity: 1;\n  background-color: #475569;\n  background-color: rgba(71, 85, 105, var(--bg-opacity));\n}\n.group:hover .group-hover\\:bg-cool-gray-700 {\n  --bg-opacity: 1;\n  background-color: #364152;\n  background-color: rgba(54, 65, 82, var(--bg-opacity));\n}\n.group:hover .group-hover\\:bg-cool-gray-800 {\n  --bg-opacity: 1;\n  background-color: #27303f;\n  background-color: rgba(39, 48, 63, var(--bg-opacity));\n}\n.group:hover .group-hover\\:bg-cool-gray-900 {\n  --bg-opacity: 1;\n  background-color: #1a202e;\n  background-color: rgba(26, 32, 46, var(--bg-opacity));\n}\n.group:focus .group-focus\\:bg-current {\n  background-color: currentColor;\n}\n.group:focus .group-focus\\:bg-transparent {\n  background-color: transparent;\n}\n.group:focus .group-focus\\:bg-white {\n  --bg-opacity: 1;\n  background-color: #ffffff;\n  background-color: rgba(255, 255, 255, var(--bg-opacity));\n}\n.group:focus .group-focus\\:bg-black {\n  --bg-opacity: 1;\n  background-color: #000000;\n  background-color: rgba(0, 0, 0, var(--bg-opacity));\n}\n.group:focus .group-focus\\:bg-gray-50 {\n  --bg-opacity: 1;\n  background-color: #f9fafb;\n  background-color: rgba(249, 250, 251, var(--bg-opacity));\n}\n.group:focus .group-focus\\:bg-gray-100 {\n  --bg-opacity: 1;\n  background-color: #f4f5f7;\n  background-color: rgba(244, 245, 247, var(--bg-opacity));\n}\n.group:focus .group-focus\\:bg-gray-200 {\n  --bg-opacity: 1;\n  background-color: #e5e7eb;\n  background-color: rgba(229, 231, 235, var(--bg-opacity));\n}\n.group:focus .group-focus\\:bg-gray-300 {\n  --bg-opacity: 1;\n  background-color: #d2d6dc;\n  background-color: rgba(210, 214, 220, var(--bg-opacity));\n}\n.group:focus .group-focus\\:bg-gray-400 {\n  --bg-opacity: 1;\n  background-color: #9fa6b2;\n  background-color: rgba(159, 166, 178, var(--bg-opacity));\n}\n.group:focus .group-focus\\:bg-gray-500 {\n  --bg-opacity: 1;\n  background-color: #6b7280;\n  background-color: rgba(107, 114, 128, var(--bg-opacity));\n}\n.group:focus .group-focus\\:bg-gray-600 {\n  --bg-opacity: 1;\n  background-color: #4b5563;\n  background-color: rgba(75, 85, 99, var(--bg-opacity));\n}\n.group:focus .group-focus\\:bg-gray-700 {\n  --bg-opacity: 1;\n  background-color: #374151;\n  background-color: rgba(55, 65, 81, var(--bg-opacity));\n}\n.group:focus .group-focus\\:bg-gray-800 {\n  --bg-opacity: 1;\n  background-color: #252f3f;\n  background-color: rgba(37, 47, 63, var(--bg-opacity));\n}\n.group:focus .group-focus\\:bg-gray-900 {\n  --bg-opacity: 1;\n  background-color: #161e2e;\n  background-color: rgba(22, 30, 46, var(--bg-opacity));\n}\n.group:focus .group-focus\\:bg-red-50 {\n  --bg-opacity: 1;\n  background-color: #fdf2f2;\n  background-color: rgba(253, 242, 242, var(--bg-opacity));\n}\n.group:focus .group-focus\\:bg-red-100 {\n  --bg-opacity: 1;\n  background-color: #fde8e8;\n  background-color: rgba(253, 232, 232, var(--bg-opacity));\n}\n.group:focus .group-focus\\:bg-red-200 {\n  --bg-opacity: 1;\n  background-color: #fbd5d5;\n  background-color: rgba(251, 213, 213, var(--bg-opacity));\n}\n.group:focus .group-focus\\:bg-red-300 {\n  --bg-opacity: 1;\n  background-color: #f8b4b4;\n  background-color: rgba(248, 180, 180, var(--bg-opacity));\n}\n.group:focus .group-focus\\:bg-red-400 {\n  --bg-opacity: 1;\n  background-color: #f98080;\n  background-color: rgba(249, 128, 128, var(--bg-opacity));\n}\n.group:focus .group-focus\\:bg-red-500 {\n  --bg-opacity: 1;\n  background-color: #f05252;\n  background-color: rgba(240, 82, 82, var(--bg-opacity));\n}\n.group:focus .group-focus\\:bg-red-600 {\n  --bg-opacity: 1;\n  background-color: #e02424;\n  background-color: rgba(224, 36, 36, var(--bg-opacity));\n}\n.group:focus .group-focus\\:bg-red-700 {\n  --bg-opacity: 1;\n  background-color: #c81e1e;\n  background-color: rgba(200, 30, 30, var(--bg-opacity));\n}\n.group:focus .group-focus\\:bg-red-800 {\n  --bg-opacity: 1;\n  background-color: #9b1c1c;\n  background-color: rgba(155, 28, 28, var(--bg-opacity));\n}\n.group:focus .group-focus\\:bg-red-900 {\n  --bg-opacity: 1;\n  background-color: #771d1d;\n  background-color: rgba(119, 29, 29, var(--bg-opacity));\n}\n.group:focus .group-focus\\:bg-orange-50 {\n  --bg-opacity: 1;\n  background-color: #fff8f1;\n  background-color: rgba(255, 248, 241, var(--bg-opacity));\n}\n.group:focus .group-focus\\:bg-orange-100 {\n  --bg-opacity: 1;\n  background-color: #feecdc;\n  background-color: rgba(254, 236, 220, var(--bg-opacity));\n}\n.group:focus .group-focus\\:bg-orange-200 {\n  --bg-opacity: 1;\n  background-color: #fcd9bd;\n  background-color: rgba(252, 217, 189, var(--bg-opacity));\n}\n.group:focus .group-focus\\:bg-orange-300 {\n  --bg-opacity: 1;\n  background-color: #fdba8c;\n  background-color: rgba(253, 186, 140, var(--bg-opacity));\n}\n.group:focus .group-focus\\:bg-orange-400 {\n  --bg-opacity: 1;\n  background-color: #ff8a4c;\n  background-color: rgba(255, 138, 76, var(--bg-opacity));\n}\n.group:focus .group-focus\\:bg-orange-500 {\n  --bg-opacity: 1;\n  background-color: #ff5a1f;\n  background-color: rgba(255, 90, 31, var(--bg-opacity));\n}\n.group:focus .group-focus\\:bg-orange-600 {\n  --bg-opacity: 1;\n  background-color: #d03801;\n  background-color: rgba(208, 56, 1, var(--bg-opacity));\n}\n.group:focus .group-focus\\:bg-orange-700 {\n  --bg-opacity: 1;\n  background-color: #b43403;\n  background-color: rgba(180, 52, 3, var(--bg-opacity));\n}\n.group:focus .group-focus\\:bg-orange-800 {\n  --bg-opacity: 1;\n  background-color: #8a2c0d;\n  background-color: rgba(138, 44, 13, var(--bg-opacity));\n}\n.group:focus .group-focus\\:bg-orange-900 {\n  --bg-opacity: 1;\n  background-color: #73230d;\n  background-color: rgba(115, 35, 13, var(--bg-opacity));\n}\n.group:focus .group-focus\\:bg-yellow-50 {\n  --bg-opacity: 1;\n  background-color: #fdfdea;\n  background-color: rgba(253, 253, 234, var(--bg-opacity));\n}\n.group:focus .group-focus\\:bg-yellow-100 {\n  --bg-opacity: 1;\n  background-color: #fdf6b2;\n  background-color: rgba(253, 246, 178, var(--bg-opacity));\n}\n.group:focus .group-focus\\:bg-yellow-200 {\n  --bg-opacity: 1;\n  background-color: #fce96a;\n  background-color: rgba(252, 233, 106, var(--bg-opacity));\n}\n.group:focus .group-focus\\:bg-yellow-300 {\n  --bg-opacity: 1;\n  background-color: #faca15;\n  background-color: rgba(250, 202, 21, var(--bg-opacity));\n}\n.group:focus .group-focus\\:bg-yellow-400 {\n  --bg-opacity: 1;\n  background-color: #e3a008;\n  background-color: rgba(227, 160, 8, var(--bg-opacity));\n}\n.group:focus .group-focus\\:bg-yellow-500 {\n  --bg-opacity: 1;\n  background-color: #c27803;\n  background-color: rgba(194, 120, 3, var(--bg-opacity));\n}\n.group:focus .group-focus\\:bg-yellow-600 {\n  --bg-opacity: 1;\n  background-color: #9f580a;\n  background-color: rgba(159, 88, 10, var(--bg-opacity));\n}\n.group:focus .group-focus\\:bg-yellow-700 {\n  --bg-opacity: 1;\n  background-color: #8e4b10;\n  background-color: rgba(142, 75, 16, var(--bg-opacity));\n}\n.group:focus .group-focus\\:bg-yellow-800 {\n  --bg-opacity: 1;\n  background-color: #723b13;\n  background-color: rgba(114, 59, 19, var(--bg-opacity));\n}\n.group:focus .group-focus\\:bg-yellow-900 {\n  --bg-opacity: 1;\n  background-color: #633112;\n  background-color: rgba(99, 49, 18, var(--bg-opacity));\n}\n.group:focus .group-focus\\:bg-green-50 {\n  --bg-opacity: 1;\n  background-color: #f3faf7;\n  background-color: rgba(243, 250, 247, var(--bg-opacity));\n}\n.group:focus .group-focus\\:bg-green-100 {\n  --bg-opacity: 1;\n  background-color: #def7ec;\n  background-color: rgba(222, 247, 236, var(--bg-opacity));\n}\n.group:focus .group-focus\\:bg-green-200 {\n  --bg-opacity: 1;\n  background-color: #bcf0da;\n  background-color: rgba(188, 240, 218, var(--bg-opacity));\n}\n.group:focus .group-focus\\:bg-green-300 {\n  --bg-opacity: 1;\n  background-color: #84e1bc;\n  background-color: rgba(132, 225, 188, var(--bg-opacity));\n}\n.group:focus .group-focus\\:bg-green-400 {\n  --bg-opacity: 1;\n  background-color: #31c48d;\n  background-color: rgba(49, 196, 141, var(--bg-opacity));\n}\n.group:focus .group-focus\\:bg-green-500 {\n  --bg-opacity: 1;\n  background-color: #0e9f6e;\n  background-color: rgba(14, 159, 110, var(--bg-opacity));\n}\n.group:focus .group-focus\\:bg-green-600 {\n  --bg-opacity: 1;\n  background-color: #057a55;\n  background-color: rgba(5, 122, 85, var(--bg-opacity));\n}\n.group:focus .group-focus\\:bg-green-700 {\n  --bg-opacity: 1;\n  background-color: #046c4e;\n  background-color: rgba(4, 108, 78, var(--bg-opacity));\n}\n.group:focus .group-focus\\:bg-green-800 {\n  --bg-opacity: 1;\n  background-color: #03543f;\n  background-color: rgba(3, 84, 63, var(--bg-opacity));\n}\n.group:focus .group-focus\\:bg-green-900 {\n  --bg-opacity: 1;\n  background-color: #014737;\n  background-color: rgba(1, 71, 55, var(--bg-opacity));\n}\n.group:focus .group-focus\\:bg-teal-50 {\n  --bg-opacity: 1;\n  background-color: #edfafa;\n  background-color: rgba(237, 250, 250, var(--bg-opacity));\n}\n.group:focus .group-focus\\:bg-teal-100 {\n  --bg-opacity: 1;\n  background-color: #d5f5f6;\n  background-color: rgba(213, 245, 246, var(--bg-opacity));\n}\n.group:focus .group-focus\\:bg-teal-200 {\n  --bg-opacity: 1;\n  background-color: #afecef;\n  background-color: rgba(175, 236, 239, var(--bg-opacity));\n}\n.group:focus .group-focus\\:bg-teal-300 {\n  --bg-opacity: 1;\n  background-color: #7edce2;\n  background-color: rgba(126, 220, 226, var(--bg-opacity));\n}\n.group:focus .group-focus\\:bg-teal-400 {\n  --bg-opacity: 1;\n  background-color: #16bdca;\n  background-color: rgba(22, 189, 202, var(--bg-opacity));\n}\n.group:focus .group-focus\\:bg-teal-500 {\n  --bg-opacity: 1;\n  background-color: #0694a2;\n  background-color: rgba(6, 148, 162, var(--bg-opacity));\n}\n.group:focus .group-focus\\:bg-teal-600 {\n  --bg-opacity: 1;\n  background-color: #047481;\n  background-color: rgba(4, 116, 129, var(--bg-opacity));\n}\n.group:focus .group-focus\\:bg-teal-700 {\n  --bg-opacity: 1;\n  background-color: #036672;\n  background-color: rgba(3, 102, 114, var(--bg-opacity));\n}\n.group:focus .group-focus\\:bg-teal-800 {\n  --bg-opacity: 1;\n  background-color: #05505c;\n  background-color: rgba(5, 80, 92, var(--bg-opacity));\n}\n.group:focus .group-focus\\:bg-teal-900 {\n  --bg-opacity: 1;\n  background-color: #014451;\n  background-color: rgba(1, 68, 81, var(--bg-opacity));\n}\n.group:focus .group-focus\\:bg-blue-50 {\n  --bg-opacity: 1;\n  background-color: #ebf5ff;\n  background-color: rgba(235, 245, 255, var(--bg-opacity));\n}\n.group:focus .group-focus\\:bg-blue-100 {\n  --bg-opacity: 1;\n  background-color: #e1effe;\n  background-color: rgba(225, 239, 254, var(--bg-opacity));\n}\n.group:focus .group-focus\\:bg-blue-200 {\n  --bg-opacity: 1;\n  background-color: #c3ddfd;\n  background-color: rgba(195, 221, 253, var(--bg-opacity));\n}\n.group:focus .group-focus\\:bg-blue-300 {\n  --bg-opacity: 1;\n  background-color: #a4cafe;\n  background-color: rgba(164, 202, 254, var(--bg-opacity));\n}\n.group:focus .group-focus\\:bg-blue-400 {\n  --bg-opacity: 1;\n  background-color: #76a9fa;\n  background-color: rgba(118, 169, 250, var(--bg-opacity));\n}\n.group:focus .group-focus\\:bg-blue-500 {\n  --bg-opacity: 1;\n  background-color: #3f83f8;\n  background-color: rgba(63, 131, 248, var(--bg-opacity));\n}\n.group:focus .group-focus\\:bg-blue-600 {\n  --bg-opacity: 1;\n  background-color: #1c64f2;\n  background-color: rgba(28, 100, 242, var(--bg-opacity));\n}\n.group:focus .group-focus\\:bg-blue-700 {\n  --bg-opacity: 1;\n  background-color: #1a56db;\n  background-color: rgba(26, 86, 219, var(--bg-opacity));\n}\n.group:focus .group-focus\\:bg-blue-800 {\n  --bg-opacity: 1;\n  background-color: #1e429f;\n  background-color: rgba(30, 66, 159, var(--bg-opacity));\n}\n.group:focus .group-focus\\:bg-blue-900 {\n  --bg-opacity: 1;\n  background-color: #233876;\n  background-color: rgba(35, 56, 118, var(--bg-opacity));\n}\n.group:focus .group-focus\\:bg-indigo-50 {\n  --bg-opacity: 1;\n  background-color: #f0f5ff;\n  background-color: rgba(240, 245, 255, var(--bg-opacity));\n}\n.group:focus .group-focus\\:bg-indigo-100 {\n  --bg-opacity: 1;\n  background-color: #e5edff;\n  background-color: rgba(229, 237, 255, var(--bg-opacity));\n}\n.group:focus .group-focus\\:bg-indigo-200 {\n  --bg-opacity: 1;\n  background-color: #cddbfe;\n  background-color: rgba(205, 219, 254, var(--bg-opacity));\n}\n.group:focus .group-focus\\:bg-indigo-300 {\n  --bg-opacity: 1;\n  background-color: #b4c6fc;\n  background-color: rgba(180, 198, 252, var(--bg-opacity));\n}\n.group:focus .group-focus\\:bg-indigo-400 {\n  --bg-opacity: 1;\n  background-color: #8da2fb;\n  background-color: rgba(141, 162, 251, var(--bg-opacity));\n}\n.group:focus .group-focus\\:bg-indigo-500 {\n  --bg-opacity: 1;\n  background-color: #6875f5;\n  background-color: rgba(104, 117, 245, var(--bg-opacity));\n}\n.group:focus .group-focus\\:bg-indigo-600 {\n  --bg-opacity: 1;\n  background-color: #5850ec;\n  background-color: rgba(88, 80, 236, var(--bg-opacity));\n}\n.group:focus .group-focus\\:bg-indigo-700 {\n  --bg-opacity: 1;\n  background-color: #5145cd;\n  background-color: rgba(81, 69, 205, var(--bg-opacity));\n}\n.group:focus .group-focus\\:bg-indigo-800 {\n  --bg-opacity: 1;\n  background-color: #42389d;\n  background-color: rgba(66, 56, 157, var(--bg-opacity));\n}\n.group:focus .group-focus\\:bg-indigo-900 {\n  --bg-opacity: 1;\n  background-color: #362f78;\n  background-color: rgba(54, 47, 120, var(--bg-opacity));\n}\n.group:focus .group-focus\\:bg-purple-50 {\n  --bg-opacity: 1;\n  background-color: #f6f5ff;\n  background-color: rgba(246, 245, 255, var(--bg-opacity));\n}\n.group:focus .group-focus\\:bg-purple-100 {\n  --bg-opacity: 1;\n  background-color: #edebfe;\n  background-color: rgba(237, 235, 254, var(--bg-opacity));\n}\n.group:focus .group-focus\\:bg-purple-200 {\n  --bg-opacity: 1;\n  background-color: #dcd7fe;\n  background-color: rgba(220, 215, 254, var(--bg-opacity));\n}\n.group:focus .group-focus\\:bg-purple-300 {\n  --bg-opacity: 1;\n  background-color: #cabffd;\n  background-color: rgba(202, 191, 253, var(--bg-opacity));\n}\n.group:focus .group-focus\\:bg-purple-400 {\n  --bg-opacity: 1;\n  background-color: #ac94fa;\n  background-color: rgba(172, 148, 250, var(--bg-opacity));\n}\n.group:focus .group-focus\\:bg-purple-500 {\n  --bg-opacity: 1;\n  background-color: #9061f9;\n  background-color: rgba(144, 97, 249, var(--bg-opacity));\n}\n.group:focus .group-focus\\:bg-purple-600 {\n  --bg-opacity: 1;\n  background-color: #7e3af2;\n  background-color: rgba(126, 58, 242, var(--bg-opacity));\n}\n.group:focus .group-focus\\:bg-purple-700 {\n  --bg-opacity: 1;\n  background-color: #6c2bd9;\n  background-color: rgba(108, 43, 217, var(--bg-opacity));\n}\n.group:focus .group-focus\\:bg-purple-800 {\n  --bg-opacity: 1;\n  background-color: #5521b5;\n  background-color: rgba(85, 33, 181, var(--bg-opacity));\n}\n.group:focus .group-focus\\:bg-purple-900 {\n  --bg-opacity: 1;\n  background-color: #4a1d96;\n  background-color: rgba(74, 29, 150, var(--bg-opacity));\n}\n.group:focus .group-focus\\:bg-pink-50 {\n  --bg-opacity: 1;\n  background-color: #fdf2f8;\n  background-color: rgba(253, 242, 248, var(--bg-opacity));\n}\n.group:focus .group-focus\\:bg-pink-100 {\n  --bg-opacity: 1;\n  background-color: #fce8f3;\n  background-color: rgba(252, 232, 243, var(--bg-opacity));\n}\n.group:focus .group-focus\\:bg-pink-200 {\n  --bg-opacity: 1;\n  background-color: #fad1e8;\n  background-color: rgba(250, 209, 232, var(--bg-opacity));\n}\n.group:focus .group-focus\\:bg-pink-300 {\n  --bg-opacity: 1;\n  background-color: #f8b4d9;\n  background-color: rgba(248, 180, 217, var(--bg-opacity));\n}\n.group:focus .group-focus\\:bg-pink-400 {\n  --bg-opacity: 1;\n  background-color: #f17eb8;\n  background-color: rgba(241, 126, 184, var(--bg-opacity));\n}\n.group:focus .group-focus\\:bg-pink-500 {\n  --bg-opacity: 1;\n  background-color: #e74694;\n  background-color: rgba(231, 70, 148, var(--bg-opacity));\n}\n.group:focus .group-focus\\:bg-pink-600 {\n  --bg-opacity: 1;\n  background-color: #d61f69;\n  background-color: rgba(214, 31, 105, var(--bg-opacity));\n}\n.group:focus .group-focus\\:bg-pink-700 {\n  --bg-opacity: 1;\n  background-color: #bf125d;\n  background-color: rgba(191, 18, 93, var(--bg-opacity));\n}\n.group:focus .group-focus\\:bg-pink-800 {\n  --bg-opacity: 1;\n  background-color: #99154b;\n  background-color: rgba(153, 21, 75, var(--bg-opacity));\n}\n.group:focus .group-focus\\:bg-pink-900 {\n  --bg-opacity: 1;\n  background-color: #751a3d;\n  background-color: rgba(117, 26, 61, var(--bg-opacity));\n}\n.group:focus .group-focus\\:bg-cool-gray-50 {\n  --bg-opacity: 1;\n  background-color: #f8fafc;\n  background-color: rgba(248, 250, 252, var(--bg-opacity));\n}\n.group:focus .group-focus\\:bg-cool-gray-100 {\n  --bg-opacity: 1;\n  background-color: #f1f5f9;\n  background-color: rgba(241, 245, 249, var(--bg-opacity));\n}\n.group:focus .group-focus\\:bg-cool-gray-200 {\n  --bg-opacity: 1;\n  background-color: #e2e8f0;\n  background-color: rgba(226, 232, 240, var(--bg-opacity));\n}\n.group:focus .group-focus\\:bg-cool-gray-300 {\n  --bg-opacity: 1;\n  background-color: #cfd8e3;\n  background-color: rgba(207, 216, 227, var(--bg-opacity));\n}\n.group:focus .group-focus\\:bg-cool-gray-400 {\n  --bg-opacity: 1;\n  background-color: #97a6ba;\n  background-color: rgba(151, 166, 186, var(--bg-opacity));\n}\n.group:focus .group-focus\\:bg-cool-gray-500 {\n  --bg-opacity: 1;\n  background-color: #64748b;\n  background-color: rgba(100, 116, 139, var(--bg-opacity));\n}\n.group:focus .group-focus\\:bg-cool-gray-600 {\n  --bg-opacity: 1;\n  background-color: #475569;\n  background-color: rgba(71, 85, 105, var(--bg-opacity));\n}\n.group:focus .group-focus\\:bg-cool-gray-700 {\n  --bg-opacity: 1;\n  background-color: #364152;\n  background-color: rgba(54, 65, 82, var(--bg-opacity));\n}\n.group:focus .group-focus\\:bg-cool-gray-800 {\n  --bg-opacity: 1;\n  background-color: #27303f;\n  background-color: rgba(39, 48, 63, var(--bg-opacity));\n}\n.group:focus .group-focus\\:bg-cool-gray-900 {\n  --bg-opacity: 1;\n  background-color: #1a202e;\n  background-color: rgba(26, 32, 46, var(--bg-opacity));\n}\n.hover\\:bg-current:hover {\n  background-color: currentColor;\n}\n.hover\\:bg-transparent:hover {\n  background-color: transparent;\n}\n.hover\\:bg-white:hover {\n  --bg-opacity: 1;\n  background-color: #ffffff;\n  background-color: rgba(255, 255, 255, var(--bg-opacity));\n}\n.hover\\:bg-black:hover {\n  --bg-opacity: 1;\n  background-color: #000000;\n  background-color: rgba(0, 0, 0, var(--bg-opacity));\n}\n.hover\\:bg-gray-50:hover {\n  --bg-opacity: 1;\n  background-color: #f9fafb;\n  background-color: rgba(249, 250, 251, var(--bg-opacity));\n}\n.hover\\:bg-gray-100:hover {\n  --bg-opacity: 1;\n  background-color: #f4f5f7;\n  background-color: rgba(244, 245, 247, var(--bg-opacity));\n}\n.hover\\:bg-gray-200:hover {\n  --bg-opacity: 1;\n  background-color: #e5e7eb;\n  background-color: rgba(229, 231, 235, var(--bg-opacity));\n}\n.hover\\:bg-gray-300:hover {\n  --bg-opacity: 1;\n  background-color: #d2d6dc;\n  background-color: rgba(210, 214, 220, var(--bg-opacity));\n}\n.hover\\:bg-gray-400:hover {\n  --bg-opacity: 1;\n  background-color: #9fa6b2;\n  background-color: rgba(159, 166, 178, var(--bg-opacity));\n}\n.hover\\:bg-gray-500:hover {\n  --bg-opacity: 1;\n  background-color: #6b7280;\n  background-color: rgba(107, 114, 128, var(--bg-opacity));\n}\n.hover\\:bg-gray-600:hover {\n  --bg-opacity: 1;\n  background-color: #4b5563;\n  background-color: rgba(75, 85, 99, var(--bg-opacity));\n}\n.hover\\:bg-gray-700:hover {\n  --bg-opacity: 1;\n  background-color: #374151;\n  background-color: rgba(55, 65, 81, var(--bg-opacity));\n}\n.hover\\:bg-gray-800:hover {\n  --bg-opacity: 1;\n  background-color: #252f3f;\n  background-color: rgba(37, 47, 63, var(--bg-opacity));\n}\n.hover\\:bg-gray-900:hover {\n  --bg-opacity: 1;\n  background-color: #161e2e;\n  background-color: rgba(22, 30, 46, var(--bg-opacity));\n}\n.hover\\:bg-red-50:hover {\n  --bg-opacity: 1;\n  background-color: #fdf2f2;\n  background-color: rgba(253, 242, 242, var(--bg-opacity));\n}\n.hover\\:bg-red-100:hover {\n  --bg-opacity: 1;\n  background-color: #fde8e8;\n  background-color: rgba(253, 232, 232, var(--bg-opacity));\n}\n.hover\\:bg-red-200:hover {\n  --bg-opacity: 1;\n  background-color: #fbd5d5;\n  background-color: rgba(251, 213, 213, var(--bg-opacity));\n}\n.hover\\:bg-red-300:hover {\n  --bg-opacity: 1;\n  background-color: #f8b4b4;\n  background-color: rgba(248, 180, 180, var(--bg-opacity));\n}\n.hover\\:bg-red-400:hover {\n  --bg-opacity: 1;\n  background-color: #f98080;\n  background-color: rgba(249, 128, 128, var(--bg-opacity));\n}\n.hover\\:bg-red-500:hover {\n  --bg-opacity: 1;\n  background-color: #f05252;\n  background-color: rgba(240, 82, 82, var(--bg-opacity));\n}\n.hover\\:bg-red-600:hover {\n  --bg-opacity: 1;\n  background-color: #e02424;\n  background-color: rgba(224, 36, 36, var(--bg-opacity));\n}\n.hover\\:bg-red-700:hover {\n  --bg-opacity: 1;\n  background-color: #c81e1e;\n  background-color: rgba(200, 30, 30, var(--bg-opacity));\n}\n.hover\\:bg-red-800:hover {\n  --bg-opacity: 1;\n  background-color: #9b1c1c;\n  background-color: rgba(155, 28, 28, var(--bg-opacity));\n}\n.hover\\:bg-red-900:hover {\n  --bg-opacity: 1;\n  background-color: #771d1d;\n  background-color: rgba(119, 29, 29, var(--bg-opacity));\n}\n.hover\\:bg-orange-50:hover {\n  --bg-opacity: 1;\n  background-color: #fff8f1;\n  background-color: rgba(255, 248, 241, var(--bg-opacity));\n}\n.hover\\:bg-orange-100:hover {\n  --bg-opacity: 1;\n  background-color: #feecdc;\n  background-color: rgba(254, 236, 220, var(--bg-opacity));\n}\n.hover\\:bg-orange-200:hover {\n  --bg-opacity: 1;\n  background-color: #fcd9bd;\n  background-color: rgba(252, 217, 189, var(--bg-opacity));\n}\n.hover\\:bg-orange-300:hover {\n  --bg-opacity: 1;\n  background-color: #fdba8c;\n  background-color: rgba(253, 186, 140, var(--bg-opacity));\n}\n.hover\\:bg-orange-400:hover {\n  --bg-opacity: 1;\n  background-color: #ff8a4c;\n  background-color: rgba(255, 138, 76, var(--bg-opacity));\n}\n.hover\\:bg-orange-500:hover {\n  --bg-opacity: 1;\n  background-color: #ff5a1f;\n  background-color: rgba(255, 90, 31, var(--bg-opacity));\n}\n.hover\\:bg-orange-600:hover {\n  --bg-opacity: 1;\n  background-color: #d03801;\n  background-color: rgba(208, 56, 1, var(--bg-opacity));\n}\n.hover\\:bg-orange-700:hover {\n  --bg-opacity: 1;\n  background-color: #b43403;\n  background-color: rgba(180, 52, 3, var(--bg-opacity));\n}\n.hover\\:bg-orange-800:hover {\n  --bg-opacity: 1;\n  background-color: #8a2c0d;\n  background-color: rgba(138, 44, 13, var(--bg-opacity));\n}\n.hover\\:bg-orange-900:hover {\n  --bg-opacity: 1;\n  background-color: #73230d;\n  background-color: rgba(115, 35, 13, var(--bg-opacity));\n}\n.hover\\:bg-yellow-50:hover {\n  --bg-opacity: 1;\n  background-color: #fdfdea;\n  background-color: rgba(253, 253, 234, var(--bg-opacity));\n}\n.hover\\:bg-yellow-100:hover {\n  --bg-opacity: 1;\n  background-color: #fdf6b2;\n  background-color: rgba(253, 246, 178, var(--bg-opacity));\n}\n.hover\\:bg-yellow-200:hover {\n  --bg-opacity: 1;\n  background-color: #fce96a;\n  background-color: rgba(252, 233, 106, var(--bg-opacity));\n}\n.hover\\:bg-yellow-300:hover {\n  --bg-opacity: 1;\n  background-color: #faca15;\n  background-color: rgba(250, 202, 21, var(--bg-opacity));\n}\n.hover\\:bg-yellow-400:hover {\n  --bg-opacity: 1;\n  background-color: #e3a008;\n  background-color: rgba(227, 160, 8, var(--bg-opacity));\n}\n.hover\\:bg-yellow-500:hover {\n  --bg-opacity: 1;\n  background-color: #c27803;\n  background-color: rgba(194, 120, 3, var(--bg-opacity));\n}\n.hover\\:bg-yellow-600:hover {\n  --bg-opacity: 1;\n  background-color: #9f580a;\n  background-color: rgba(159, 88, 10, var(--bg-opacity));\n}\n.hover\\:bg-yellow-700:hover {\n  --bg-opacity: 1;\n  background-color: #8e4b10;\n  background-color: rgba(142, 75, 16, var(--bg-opacity));\n}\n.hover\\:bg-yellow-800:hover {\n  --bg-opacity: 1;\n  background-color: #723b13;\n  background-color: rgba(114, 59, 19, var(--bg-opacity));\n}\n.hover\\:bg-yellow-900:hover {\n  --bg-opacity: 1;\n  background-color: #633112;\n  background-color: rgba(99, 49, 18, var(--bg-opacity));\n}\n.hover\\:bg-green-50:hover {\n  --bg-opacity: 1;\n  background-color: #f3faf7;\n  background-color: rgba(243, 250, 247, var(--bg-opacity));\n}\n.hover\\:bg-green-100:hover {\n  --bg-opacity: 1;\n  background-color: #def7ec;\n  background-color: rgba(222, 247, 236, var(--bg-opacity));\n}\n.hover\\:bg-green-200:hover {\n  --bg-opacity: 1;\n  background-color: #bcf0da;\n  background-color: rgba(188, 240, 218, var(--bg-opacity));\n}\n.hover\\:bg-green-300:hover {\n  --bg-opacity: 1;\n  background-color: #84e1bc;\n  background-color: rgba(132, 225, 188, var(--bg-opacity));\n}\n.hover\\:bg-green-400:hover {\n  --bg-opacity: 1;\n  background-color: #31c48d;\n  background-color: rgba(49, 196, 141, var(--bg-opacity));\n}\n.hover\\:bg-green-500:hover {\n  --bg-opacity: 1;\n  background-color: #0e9f6e;\n  background-color: rgba(14, 159, 110, var(--bg-opacity));\n}\n.hover\\:bg-green-600:hover {\n  --bg-opacity: 1;\n  background-color: #057a55;\n  background-color: rgba(5, 122, 85, var(--bg-opacity));\n}\n.hover\\:bg-green-700:hover {\n  --bg-opacity: 1;\n  background-color: #046c4e;\n  background-color: rgba(4, 108, 78, var(--bg-opacity));\n}\n.hover\\:bg-green-800:hover {\n  --bg-opacity: 1;\n  background-color: #03543f;\n  background-color: rgba(3, 84, 63, var(--bg-opacity));\n}\n.hover\\:bg-green-900:hover {\n  --bg-opacity: 1;\n  background-color: #014737;\n  background-color: rgba(1, 71, 55, var(--bg-opacity));\n}\n.hover\\:bg-teal-50:hover {\n  --bg-opacity: 1;\n  background-color: #edfafa;\n  background-color: rgba(237, 250, 250, var(--bg-opacity));\n}\n.hover\\:bg-teal-100:hover {\n  --bg-opacity: 1;\n  background-color: #d5f5f6;\n  background-color: rgba(213, 245, 246, var(--bg-opacity));\n}\n.hover\\:bg-teal-200:hover {\n  --bg-opacity: 1;\n  background-color: #afecef;\n  background-color: rgba(175, 236, 239, var(--bg-opacity));\n}\n.hover\\:bg-teal-300:hover {\n  --bg-opacity: 1;\n  background-color: #7edce2;\n  background-color: rgba(126, 220, 226, var(--bg-opacity));\n}\n.hover\\:bg-teal-400:hover {\n  --bg-opacity: 1;\n  background-color: #16bdca;\n  background-color: rgba(22, 189, 202, var(--bg-opacity));\n}\n.hover\\:bg-teal-500:hover {\n  --bg-opacity: 1;\n  background-color: #0694a2;\n  background-color: rgba(6, 148, 162, var(--bg-opacity));\n}\n.hover\\:bg-teal-600:hover {\n  --bg-opacity: 1;\n  background-color: #047481;\n  background-color: rgba(4, 116, 129, var(--bg-opacity));\n}\n.hover\\:bg-teal-700:hover {\n  --bg-opacity: 1;\n  background-color: #036672;\n  background-color: rgba(3, 102, 114, var(--bg-opacity));\n}\n.hover\\:bg-teal-800:hover {\n  --bg-opacity: 1;\n  background-color: #05505c;\n  background-color: rgba(5, 80, 92, var(--bg-opacity));\n}\n.hover\\:bg-teal-900:hover {\n  --bg-opacity: 1;\n  background-color: #014451;\n  background-color: rgba(1, 68, 81, var(--bg-opacity));\n}\n.hover\\:bg-blue-50:hover {\n  --bg-opacity: 1;\n  background-color: #ebf5ff;\n  background-color: rgba(235, 245, 255, var(--bg-opacity));\n}\n.hover\\:bg-blue-100:hover {\n  --bg-opacity: 1;\n  background-color: #e1effe;\n  background-color: rgba(225, 239, 254, var(--bg-opacity));\n}\n.hover\\:bg-blue-200:hover {\n  --bg-opacity: 1;\n  background-color: #c3ddfd;\n  background-color: rgba(195, 221, 253, var(--bg-opacity));\n}\n.hover\\:bg-blue-300:hover {\n  --bg-opacity: 1;\n  background-color: #a4cafe;\n  background-color: rgba(164, 202, 254, var(--bg-opacity));\n}\n.hover\\:bg-blue-400:hover {\n  --bg-opacity: 1;\n  background-color: #76a9fa;\n  background-color: rgba(118, 169, 250, var(--bg-opacity));\n}\n.hover\\:bg-blue-500:hover {\n  --bg-opacity: 1;\n  background-color: #3f83f8;\n  background-color: rgba(63, 131, 248, var(--bg-opacity));\n}\n.hover\\:bg-blue-600:hover {\n  --bg-opacity: 1;\n  background-color: #1c64f2;\n  background-color: rgba(28, 100, 242, var(--bg-opacity));\n}\n.hover\\:bg-blue-700:hover {\n  --bg-opacity: 1;\n  background-color: #1a56db;\n  background-color: rgba(26, 86, 219, var(--bg-opacity));\n}\n.hover\\:bg-blue-800:hover {\n  --bg-opacity: 1;\n  background-color: #1e429f;\n  background-color: rgba(30, 66, 159, var(--bg-opacity));\n}\n.hover\\:bg-blue-900:hover {\n  --bg-opacity: 1;\n  background-color: #233876;\n  background-color: rgba(35, 56, 118, var(--bg-opacity));\n}\n.hover\\:bg-indigo-50:hover {\n  --bg-opacity: 1;\n  background-color: #f0f5ff;\n  background-color: rgba(240, 245, 255, var(--bg-opacity));\n}\n.hover\\:bg-indigo-100:hover {\n  --bg-opacity: 1;\n  background-color: #e5edff;\n  background-color: rgba(229, 237, 255, var(--bg-opacity));\n}\n.hover\\:bg-indigo-200:hover {\n  --bg-opacity: 1;\n  background-color: #cddbfe;\n  background-color: rgba(205, 219, 254, var(--bg-opacity));\n}\n.hover\\:bg-indigo-300:hover {\n  --bg-opacity: 1;\n  background-color: #b4c6fc;\n  background-color: rgba(180, 198, 252, var(--bg-opacity));\n}\n.hover\\:bg-indigo-400:hover {\n  --bg-opacity: 1;\n  background-color: #8da2fb;\n  background-color: rgba(141, 162, 251, var(--bg-opacity));\n}\n.hover\\:bg-indigo-500:hover {\n  --bg-opacity: 1;\n  background-color: #6875f5;\n  background-color: rgba(104, 117, 245, var(--bg-opacity));\n}\n.hover\\:bg-indigo-600:hover {\n  --bg-opacity: 1;\n  background-color: #5850ec;\n  background-color: rgba(88, 80, 236, var(--bg-opacity));\n}\n.hover\\:bg-indigo-700:hover {\n  --bg-opacity: 1;\n  background-color: #5145cd;\n  background-color: rgba(81, 69, 205, var(--bg-opacity));\n}\n.hover\\:bg-indigo-800:hover {\n  --bg-opacity: 1;\n  background-color: #42389d;\n  background-color: rgba(66, 56, 157, var(--bg-opacity));\n}\n.hover\\:bg-indigo-900:hover {\n  --bg-opacity: 1;\n  background-color: #362f78;\n  background-color: rgba(54, 47, 120, var(--bg-opacity));\n}\n.hover\\:bg-purple-50:hover {\n  --bg-opacity: 1;\n  background-color: #f6f5ff;\n  background-color: rgba(246, 245, 255, var(--bg-opacity));\n}\n.hover\\:bg-purple-100:hover {\n  --bg-opacity: 1;\n  background-color: #edebfe;\n  background-color: rgba(237, 235, 254, var(--bg-opacity));\n}\n.hover\\:bg-purple-200:hover {\n  --bg-opacity: 1;\n  background-color: #dcd7fe;\n  background-color: rgba(220, 215, 254, var(--bg-opacity));\n}\n.hover\\:bg-purple-300:hover {\n  --bg-opacity: 1;\n  background-color: #cabffd;\n  background-color: rgba(202, 191, 253, var(--bg-opacity));\n}\n.hover\\:bg-purple-400:hover {\n  --bg-opacity: 1;\n  background-color: #ac94fa;\n  background-color: rgba(172, 148, 250, var(--bg-opacity));\n}\n.hover\\:bg-purple-500:hover {\n  --bg-opacity: 1;\n  background-color: #9061f9;\n  background-color: rgba(144, 97, 249, var(--bg-opacity));\n}\n.hover\\:bg-purple-600:hover {\n  --bg-opacity: 1;\n  background-color: #7e3af2;\n  background-color: rgba(126, 58, 242, var(--bg-opacity));\n}\n.hover\\:bg-purple-700:hover {\n  --bg-opacity: 1;\n  background-color: #6c2bd9;\n  background-color: rgba(108, 43, 217, var(--bg-opacity));\n}\n.hover\\:bg-purple-800:hover {\n  --bg-opacity: 1;\n  background-color: #5521b5;\n  background-color: rgba(85, 33, 181, var(--bg-opacity));\n}\n.hover\\:bg-purple-900:hover {\n  --bg-opacity: 1;\n  background-color: #4a1d96;\n  background-color: rgba(74, 29, 150, var(--bg-opacity));\n}\n.hover\\:bg-pink-50:hover {\n  --bg-opacity: 1;\n  background-color: #fdf2f8;\n  background-color: rgba(253, 242, 248, var(--bg-opacity));\n}\n.hover\\:bg-pink-100:hover {\n  --bg-opacity: 1;\n  background-color: #fce8f3;\n  background-color: rgba(252, 232, 243, var(--bg-opacity));\n}\n.hover\\:bg-pink-200:hover {\n  --bg-opacity: 1;\n  background-color: #fad1e8;\n  background-color: rgba(250, 209, 232, var(--bg-opacity));\n}\n.hover\\:bg-pink-300:hover {\n  --bg-opacity: 1;\n  background-color: #f8b4d9;\n  background-color: rgba(248, 180, 217, var(--bg-opacity));\n}\n.hover\\:bg-pink-400:hover {\n  --bg-opacity: 1;\n  background-color: #f17eb8;\n  background-color: rgba(241, 126, 184, var(--bg-opacity));\n}\n.hover\\:bg-pink-500:hover {\n  --bg-opacity: 1;\n  background-color: #e74694;\n  background-color: rgba(231, 70, 148, var(--bg-opacity));\n}\n.hover\\:bg-pink-600:hover {\n  --bg-opacity: 1;\n  background-color: #d61f69;\n  background-color: rgba(214, 31, 105, var(--bg-opacity));\n}\n.hover\\:bg-pink-700:hover {\n  --bg-opacity: 1;\n  background-color: #bf125d;\n  background-color: rgba(191, 18, 93, var(--bg-opacity));\n}\n.hover\\:bg-pink-800:hover {\n  --bg-opacity: 1;\n  background-color: #99154b;\n  background-color: rgba(153, 21, 75, var(--bg-opacity));\n}\n.hover\\:bg-pink-900:hover {\n  --bg-opacity: 1;\n  background-color: #751a3d;\n  background-color: rgba(117, 26, 61, var(--bg-opacity));\n}\n.hover\\:bg-cool-gray-50:hover {\n  --bg-opacity: 1;\n  background-color: #f8fafc;\n  background-color: rgba(248, 250, 252, var(--bg-opacity));\n}\n.hover\\:bg-cool-gray-100:hover {\n  --bg-opacity: 1;\n  background-color: #f1f5f9;\n  background-color: rgba(241, 245, 249, var(--bg-opacity));\n}\n.hover\\:bg-cool-gray-200:hover {\n  --bg-opacity: 1;\n  background-color: #e2e8f0;\n  background-color: rgba(226, 232, 240, var(--bg-opacity));\n}\n.hover\\:bg-cool-gray-300:hover {\n  --bg-opacity: 1;\n  background-color: #cfd8e3;\n  background-color: rgba(207, 216, 227, var(--bg-opacity));\n}\n.hover\\:bg-cool-gray-400:hover {\n  --bg-opacity: 1;\n  background-color: #97a6ba;\n  background-color: rgba(151, 166, 186, var(--bg-opacity));\n}\n.hover\\:bg-cool-gray-500:hover {\n  --bg-opacity: 1;\n  background-color: #64748b;\n  background-color: rgba(100, 116, 139, var(--bg-opacity));\n}\n.hover\\:bg-cool-gray-600:hover {\n  --bg-opacity: 1;\n  background-color: #475569;\n  background-color: rgba(71, 85, 105, var(--bg-opacity));\n}\n.hover\\:bg-cool-gray-700:hover {\n  --bg-opacity: 1;\n  background-color: #364152;\n  background-color: rgba(54, 65, 82, var(--bg-opacity));\n}\n.hover\\:bg-cool-gray-800:hover {\n  --bg-opacity: 1;\n  background-color: #27303f;\n  background-color: rgba(39, 48, 63, var(--bg-opacity));\n}\n.hover\\:bg-cool-gray-900:hover {\n  --bg-opacity: 1;\n  background-color: #1a202e;\n  background-color: rgba(26, 32, 46, var(--bg-opacity));\n}\n.focus\\:bg-current:focus {\n  background-color: currentColor;\n}\n.focus\\:bg-transparent:focus {\n  background-color: transparent;\n}\n.focus\\:bg-white:focus {\n  --bg-opacity: 1;\n  background-color: #ffffff;\n  background-color: rgba(255, 255, 255, var(--bg-opacity));\n}\n.focus\\:bg-black:focus {\n  --bg-opacity: 1;\n  background-color: #000000;\n  background-color: rgba(0, 0, 0, var(--bg-opacity));\n}\n.focus\\:bg-gray-50:focus {\n  --bg-opacity: 1;\n  background-color: #f9fafb;\n  background-color: rgba(249, 250, 251, var(--bg-opacity));\n}\n.focus\\:bg-gray-100:focus {\n  --bg-opacity: 1;\n  background-color: #f4f5f7;\n  background-color: rgba(244, 245, 247, var(--bg-opacity));\n}\n.focus\\:bg-gray-200:focus {\n  --bg-opacity: 1;\n  background-color: #e5e7eb;\n  background-color: rgba(229, 231, 235, var(--bg-opacity));\n}\n.focus\\:bg-gray-300:focus {\n  --bg-opacity: 1;\n  background-color: #d2d6dc;\n  background-color: rgba(210, 214, 220, var(--bg-opacity));\n}\n.focus\\:bg-gray-400:focus {\n  --bg-opacity: 1;\n  background-color: #9fa6b2;\n  background-color: rgba(159, 166, 178, var(--bg-opacity));\n}\n.focus\\:bg-gray-500:focus {\n  --bg-opacity: 1;\n  background-color: #6b7280;\n  background-color: rgba(107, 114, 128, var(--bg-opacity));\n}\n.focus\\:bg-gray-600:focus {\n  --bg-opacity: 1;\n  background-color: #4b5563;\n  background-color: rgba(75, 85, 99, var(--bg-opacity));\n}\n.focus\\:bg-gray-700:focus {\n  --bg-opacity: 1;\n  background-color: #374151;\n  background-color: rgba(55, 65, 81, var(--bg-opacity));\n}\n.focus\\:bg-gray-800:focus {\n  --bg-opacity: 1;\n  background-color: #252f3f;\n  background-color: rgba(37, 47, 63, var(--bg-opacity));\n}\n.focus\\:bg-gray-900:focus {\n  --bg-opacity: 1;\n  background-color: #161e2e;\n  background-color: rgba(22, 30, 46, var(--bg-opacity));\n}\n.focus\\:bg-red-50:focus {\n  --bg-opacity: 1;\n  background-color: #fdf2f2;\n  background-color: rgba(253, 242, 242, var(--bg-opacity));\n}\n.focus\\:bg-red-100:focus {\n  --bg-opacity: 1;\n  background-color: #fde8e8;\n  background-color: rgba(253, 232, 232, var(--bg-opacity));\n}\n.focus\\:bg-red-200:focus {\n  --bg-opacity: 1;\n  background-color: #fbd5d5;\n  background-color: rgba(251, 213, 213, var(--bg-opacity));\n}\n.focus\\:bg-red-300:focus {\n  --bg-opacity: 1;\n  background-color: #f8b4b4;\n  background-color: rgba(248, 180, 180, var(--bg-opacity));\n}\n.focus\\:bg-red-400:focus {\n  --bg-opacity: 1;\n  background-color: #f98080;\n  background-color: rgba(249, 128, 128, var(--bg-opacity));\n}\n.focus\\:bg-red-500:focus {\n  --bg-opacity: 1;\n  background-color: #f05252;\n  background-color: rgba(240, 82, 82, var(--bg-opacity));\n}\n.focus\\:bg-red-600:focus {\n  --bg-opacity: 1;\n  background-color: #e02424;\n  background-color: rgba(224, 36, 36, var(--bg-opacity));\n}\n.focus\\:bg-red-700:focus {\n  --bg-opacity: 1;\n  background-color: #c81e1e;\n  background-color: rgba(200, 30, 30, var(--bg-opacity));\n}\n.focus\\:bg-red-800:focus {\n  --bg-opacity: 1;\n  background-color: #9b1c1c;\n  background-color: rgba(155, 28, 28, var(--bg-opacity));\n}\n.focus\\:bg-red-900:focus {\n  --bg-opacity: 1;\n  background-color: #771d1d;\n  background-color: rgba(119, 29, 29, var(--bg-opacity));\n}\n.focus\\:bg-orange-50:focus {\n  --bg-opacity: 1;\n  background-color: #fff8f1;\n  background-color: rgba(255, 248, 241, var(--bg-opacity));\n}\n.focus\\:bg-orange-100:focus {\n  --bg-opacity: 1;\n  background-color: #feecdc;\n  background-color: rgba(254, 236, 220, var(--bg-opacity));\n}\n.focus\\:bg-orange-200:focus {\n  --bg-opacity: 1;\n  background-color: #fcd9bd;\n  background-color: rgba(252, 217, 189, var(--bg-opacity));\n}\n.focus\\:bg-orange-300:focus {\n  --bg-opacity: 1;\n  background-color: #fdba8c;\n  background-color: rgba(253, 186, 140, var(--bg-opacity));\n}\n.focus\\:bg-orange-400:focus {\n  --bg-opacity: 1;\n  background-color: #ff8a4c;\n  background-color: rgba(255, 138, 76, var(--bg-opacity));\n}\n.focus\\:bg-orange-500:focus {\n  --bg-opacity: 1;\n  background-color: #ff5a1f;\n  background-color: rgba(255, 90, 31, var(--bg-opacity));\n}\n.focus\\:bg-orange-600:focus {\n  --bg-opacity: 1;\n  background-color: #d03801;\n  background-color: rgba(208, 56, 1, var(--bg-opacity));\n}\n.focus\\:bg-orange-700:focus {\n  --bg-opacity: 1;\n  background-color: #b43403;\n  background-color: rgba(180, 52, 3, var(--bg-opacity));\n}\n.focus\\:bg-orange-800:focus {\n  --bg-opacity: 1;\n  background-color: #8a2c0d;\n  background-color: rgba(138, 44, 13, var(--bg-opacity));\n}\n.focus\\:bg-orange-900:focus {\n  --bg-opacity: 1;\n  background-color: #73230d;\n  background-color: rgba(115, 35, 13, var(--bg-opacity));\n}\n.focus\\:bg-yellow-50:focus {\n  --bg-opacity: 1;\n  background-color: #fdfdea;\n  background-color: rgba(253, 253, 234, var(--bg-opacity));\n}\n.focus\\:bg-yellow-100:focus {\n  --bg-opacity: 1;\n  background-color: #fdf6b2;\n  background-color: rgba(253, 246, 178, var(--bg-opacity));\n}\n.focus\\:bg-yellow-200:focus {\n  --bg-opacity: 1;\n  background-color: #fce96a;\n  background-color: rgba(252, 233, 106, var(--bg-opacity));\n}\n.focus\\:bg-yellow-300:focus {\n  --bg-opacity: 1;\n  background-color: #faca15;\n  background-color: rgba(250, 202, 21, var(--bg-opacity));\n}\n.focus\\:bg-yellow-400:focus {\n  --bg-opacity: 1;\n  background-color: #e3a008;\n  background-color: rgba(227, 160, 8, var(--bg-opacity));\n}\n.focus\\:bg-yellow-500:focus {\n  --bg-opacity: 1;\n  background-color: #c27803;\n  background-color: rgba(194, 120, 3, var(--bg-opacity));\n}\n.focus\\:bg-yellow-600:focus {\n  --bg-opacity: 1;\n  background-color: #9f580a;\n  background-color: rgba(159, 88, 10, var(--bg-opacity));\n}\n.focus\\:bg-yellow-700:focus {\n  --bg-opacity: 1;\n  background-color: #8e4b10;\n  background-color: rgba(142, 75, 16, var(--bg-opacity));\n}\n.focus\\:bg-yellow-800:focus {\n  --bg-opacity: 1;\n  background-color: #723b13;\n  background-color: rgba(114, 59, 19, var(--bg-opacity));\n}\n.focus\\:bg-yellow-900:focus {\n  --bg-opacity: 1;\n  background-color: #633112;\n  background-color: rgba(99, 49, 18, var(--bg-opacity));\n}\n.focus\\:bg-green-50:focus {\n  --bg-opacity: 1;\n  background-color: #f3faf7;\n  background-color: rgba(243, 250, 247, var(--bg-opacity));\n}\n.focus\\:bg-green-100:focus {\n  --bg-opacity: 1;\n  background-color: #def7ec;\n  background-color: rgba(222, 247, 236, var(--bg-opacity));\n}\n.focus\\:bg-green-200:focus {\n  --bg-opacity: 1;\n  background-color: #bcf0da;\n  background-color: rgba(188, 240, 218, var(--bg-opacity));\n}\n.focus\\:bg-green-300:focus {\n  --bg-opacity: 1;\n  background-color: #84e1bc;\n  background-color: rgba(132, 225, 188, var(--bg-opacity));\n}\n.focus\\:bg-green-400:focus {\n  --bg-opacity: 1;\n  background-color: #31c48d;\n  background-color: rgba(49, 196, 141, var(--bg-opacity));\n}\n.focus\\:bg-green-500:focus {\n  --bg-opacity: 1;\n  background-color: #0e9f6e;\n  background-color: rgba(14, 159, 110, var(--bg-opacity));\n}\n.focus\\:bg-green-600:focus {\n  --bg-opacity: 1;\n  background-color: #057a55;\n  background-color: rgba(5, 122, 85, var(--bg-opacity));\n}\n.focus\\:bg-green-700:focus {\n  --bg-opacity: 1;\n  background-color: #046c4e;\n  background-color: rgba(4, 108, 78, var(--bg-opacity));\n}\n.focus\\:bg-green-800:focus {\n  --bg-opacity: 1;\n  background-color: #03543f;\n  background-color: rgba(3, 84, 63, var(--bg-opacity));\n}\n.focus\\:bg-green-900:focus {\n  --bg-opacity: 1;\n  background-color: #014737;\n  background-color: rgba(1, 71, 55, var(--bg-opacity));\n}\n.focus\\:bg-teal-50:focus {\n  --bg-opacity: 1;\n  background-color: #edfafa;\n  background-color: rgba(237, 250, 250, var(--bg-opacity));\n}\n.focus\\:bg-teal-100:focus {\n  --bg-opacity: 1;\n  background-color: #d5f5f6;\n  background-color: rgba(213, 245, 246, var(--bg-opacity));\n}\n.focus\\:bg-teal-200:focus {\n  --bg-opacity: 1;\n  background-color: #afecef;\n  background-color: rgba(175, 236, 239, var(--bg-opacity));\n}\n.focus\\:bg-teal-300:focus {\n  --bg-opacity: 1;\n  background-color: #7edce2;\n  background-color: rgba(126, 220, 226, var(--bg-opacity));\n}\n.focus\\:bg-teal-400:focus {\n  --bg-opacity: 1;\n  background-color: #16bdca;\n  background-color: rgba(22, 189, 202, var(--bg-opacity));\n}\n.focus\\:bg-teal-500:focus {\n  --bg-opacity: 1;\n  background-color: #0694a2;\n  background-color: rgba(6, 148, 162, var(--bg-opacity));\n}\n.focus\\:bg-teal-600:focus {\n  --bg-opacity: 1;\n  background-color: #047481;\n  background-color: rgba(4, 116, 129, var(--bg-opacity));\n}\n.focus\\:bg-teal-700:focus {\n  --bg-opacity: 1;\n  background-color: #036672;\n  background-color: rgba(3, 102, 114, var(--bg-opacity));\n}\n.focus\\:bg-teal-800:focus {\n  --bg-opacity: 1;\n  background-color: #05505c;\n  background-color: rgba(5, 80, 92, var(--bg-opacity));\n}\n.focus\\:bg-teal-900:focus {\n  --bg-opacity: 1;\n  background-color: #014451;\n  background-color: rgba(1, 68, 81, var(--bg-opacity));\n}\n.focus\\:bg-blue-50:focus {\n  --bg-opacity: 1;\n  background-color: #ebf5ff;\n  background-color: rgba(235, 245, 255, var(--bg-opacity));\n}\n.focus\\:bg-blue-100:focus {\n  --bg-opacity: 1;\n  background-color: #e1effe;\n  background-color: rgba(225, 239, 254, var(--bg-opacity));\n}\n.focus\\:bg-blue-200:focus {\n  --bg-opacity: 1;\n  background-color: #c3ddfd;\n  background-color: rgba(195, 221, 253, var(--bg-opacity));\n}\n.focus\\:bg-blue-300:focus {\n  --bg-opacity: 1;\n  background-color: #a4cafe;\n  background-color: rgba(164, 202, 254, var(--bg-opacity));\n}\n.focus\\:bg-blue-400:focus {\n  --bg-opacity: 1;\n  background-color: #76a9fa;\n  background-color: rgba(118, 169, 250, var(--bg-opacity));\n}\n.focus\\:bg-blue-500:focus {\n  --bg-opacity: 1;\n  background-color: #3f83f8;\n  background-color: rgba(63, 131, 248, var(--bg-opacity));\n}\n.focus\\:bg-blue-600:focus {\n  --bg-opacity: 1;\n  background-color: #1c64f2;\n  background-color: rgba(28, 100, 242, var(--bg-opacity));\n}\n.focus\\:bg-blue-700:focus {\n  --bg-opacity: 1;\n  background-color: #1a56db;\n  background-color: rgba(26, 86, 219, var(--bg-opacity));\n}\n.focus\\:bg-blue-800:focus {\n  --bg-opacity: 1;\n  background-color: #1e429f;\n  background-color: rgba(30, 66, 159, var(--bg-opacity));\n}\n.focus\\:bg-blue-900:focus {\n  --bg-opacity: 1;\n  background-color: #233876;\n  background-color: rgba(35, 56, 118, var(--bg-opacity));\n}\n.focus\\:bg-indigo-50:focus {\n  --bg-opacity: 1;\n  background-color: #f0f5ff;\n  background-color: rgba(240, 245, 255, var(--bg-opacity));\n}\n.focus\\:bg-indigo-100:focus {\n  --bg-opacity: 1;\n  background-color: #e5edff;\n  background-color: rgba(229, 237, 255, var(--bg-opacity));\n}\n.focus\\:bg-indigo-200:focus {\n  --bg-opacity: 1;\n  background-color: #cddbfe;\n  background-color: rgba(205, 219, 254, var(--bg-opacity));\n}\n.focus\\:bg-indigo-300:focus {\n  --bg-opacity: 1;\n  background-color: #b4c6fc;\n  background-color: rgba(180, 198, 252, var(--bg-opacity));\n}\n.focus\\:bg-indigo-400:focus {\n  --bg-opacity: 1;\n  background-color: #8da2fb;\n  background-color: rgba(141, 162, 251, var(--bg-opacity));\n}\n.focus\\:bg-indigo-500:focus {\n  --bg-opacity: 1;\n  background-color: #6875f5;\n  background-color: rgba(104, 117, 245, var(--bg-opacity));\n}\n.focus\\:bg-indigo-600:focus {\n  --bg-opacity: 1;\n  background-color: #5850ec;\n  background-color: rgba(88, 80, 236, var(--bg-opacity));\n}\n.focus\\:bg-indigo-700:focus {\n  --bg-opacity: 1;\n  background-color: #5145cd;\n  background-color: rgba(81, 69, 205, var(--bg-opacity));\n}\n.focus\\:bg-indigo-800:focus {\n  --bg-opacity: 1;\n  background-color: #42389d;\n  background-color: rgba(66, 56, 157, var(--bg-opacity));\n}\n.focus\\:bg-indigo-900:focus {\n  --bg-opacity: 1;\n  background-color: #362f78;\n  background-color: rgba(54, 47, 120, var(--bg-opacity));\n}\n.focus\\:bg-purple-50:focus {\n  --bg-opacity: 1;\n  background-color: #f6f5ff;\n  background-color: rgba(246, 245, 255, var(--bg-opacity));\n}\n.focus\\:bg-purple-100:focus {\n  --bg-opacity: 1;\n  background-color: #edebfe;\n  background-color: rgba(237, 235, 254, var(--bg-opacity));\n}\n.focus\\:bg-purple-200:focus {\n  --bg-opacity: 1;\n  background-color: #dcd7fe;\n  background-color: rgba(220, 215, 254, var(--bg-opacity));\n}\n.focus\\:bg-purple-300:focus {\n  --bg-opacity: 1;\n  background-color: #cabffd;\n  background-color: rgba(202, 191, 253, var(--bg-opacity));\n}\n.focus\\:bg-purple-400:focus {\n  --bg-opacity: 1;\n  background-color: #ac94fa;\n  background-color: rgba(172, 148, 250, var(--bg-opacity));\n}\n.focus\\:bg-purple-500:focus {\n  --bg-opacity: 1;\n  background-color: #9061f9;\n  background-color: rgba(144, 97, 249, var(--bg-opacity));\n}\n.focus\\:bg-purple-600:focus {\n  --bg-opacity: 1;\n  background-color: #7e3af2;\n  background-color: rgba(126, 58, 242, var(--bg-opacity));\n}\n.focus\\:bg-purple-700:focus {\n  --bg-opacity: 1;\n  background-color: #6c2bd9;\n  background-color: rgba(108, 43, 217, var(--bg-opacity));\n}\n.focus\\:bg-purple-800:focus {\n  --bg-opacity: 1;\n  background-color: #5521b5;\n  background-color: rgba(85, 33, 181, var(--bg-opacity));\n}\n.focus\\:bg-purple-900:focus {\n  --bg-opacity: 1;\n  background-color: #4a1d96;\n  background-color: rgba(74, 29, 150, var(--bg-opacity));\n}\n.focus\\:bg-pink-50:focus {\n  --bg-opacity: 1;\n  background-color: #fdf2f8;\n  background-color: rgba(253, 242, 248, var(--bg-opacity));\n}\n.focus\\:bg-pink-100:focus {\n  --bg-opacity: 1;\n  background-color: #fce8f3;\n  background-color: rgba(252, 232, 243, var(--bg-opacity));\n}\n.focus\\:bg-pink-200:focus {\n  --bg-opacity: 1;\n  background-color: #fad1e8;\n  background-color: rgba(250, 209, 232, var(--bg-opacity));\n}\n.focus\\:bg-pink-300:focus {\n  --bg-opacity: 1;\n  background-color: #f8b4d9;\n  background-color: rgba(248, 180, 217, var(--bg-opacity));\n}\n.focus\\:bg-pink-400:focus {\n  --bg-opacity: 1;\n  background-color: #f17eb8;\n  background-color: rgba(241, 126, 184, var(--bg-opacity));\n}\n.focus\\:bg-pink-500:focus {\n  --bg-opacity: 1;\n  background-color: #e74694;\n  background-color: rgba(231, 70, 148, var(--bg-opacity));\n}\n.focus\\:bg-pink-600:focus {\n  --bg-opacity: 1;\n  background-color: #d61f69;\n  background-color: rgba(214, 31, 105, var(--bg-opacity));\n}\n.focus\\:bg-pink-700:focus {\n  --bg-opacity: 1;\n  background-color: #bf125d;\n  background-color: rgba(191, 18, 93, var(--bg-opacity));\n}\n.focus\\:bg-pink-800:focus {\n  --bg-opacity: 1;\n  background-color: #99154b;\n  background-color: rgba(153, 21, 75, var(--bg-opacity));\n}\n.focus\\:bg-pink-900:focus {\n  --bg-opacity: 1;\n  background-color: #751a3d;\n  background-color: rgba(117, 26, 61, var(--bg-opacity));\n}\n.focus\\:bg-cool-gray-50:focus {\n  --bg-opacity: 1;\n  background-color: #f8fafc;\n  background-color: rgba(248, 250, 252, var(--bg-opacity));\n}\n.focus\\:bg-cool-gray-100:focus {\n  --bg-opacity: 1;\n  background-color: #f1f5f9;\n  background-color: rgba(241, 245, 249, var(--bg-opacity));\n}\n.focus\\:bg-cool-gray-200:focus {\n  --bg-opacity: 1;\n  background-color: #e2e8f0;\n  background-color: rgba(226, 232, 240, var(--bg-opacity));\n}\n.focus\\:bg-cool-gray-300:focus {\n  --bg-opacity: 1;\n  background-color: #cfd8e3;\n  background-color: rgba(207, 216, 227, var(--bg-opacity));\n}\n.focus\\:bg-cool-gray-400:focus {\n  --bg-opacity: 1;\n  background-color: #97a6ba;\n  background-color: rgba(151, 166, 186, var(--bg-opacity));\n}\n.focus\\:bg-cool-gray-500:focus {\n  --bg-opacity: 1;\n  background-color: #64748b;\n  background-color: rgba(100, 116, 139, var(--bg-opacity));\n}\n.focus\\:bg-cool-gray-600:focus {\n  --bg-opacity: 1;\n  background-color: #475569;\n  background-color: rgba(71, 85, 105, var(--bg-opacity));\n}\n.focus\\:bg-cool-gray-700:focus {\n  --bg-opacity: 1;\n  background-color: #364152;\n  background-color: rgba(54, 65, 82, var(--bg-opacity));\n}\n.focus\\:bg-cool-gray-800:focus {\n  --bg-opacity: 1;\n  background-color: #27303f;\n  background-color: rgba(39, 48, 63, var(--bg-opacity));\n}\n.focus\\:bg-cool-gray-900:focus {\n  --bg-opacity: 1;\n  background-color: #1a202e;\n  background-color: rgba(26, 32, 46, var(--bg-opacity));\n}\n.active\\:bg-current:active {\n  background-color: currentColor;\n}\n.active\\:bg-transparent:active {\n  background-color: transparent;\n}\n.active\\:bg-white:active {\n  --bg-opacity: 1;\n  background-color: #ffffff;\n  background-color: rgba(255, 255, 255, var(--bg-opacity));\n}\n.active\\:bg-black:active {\n  --bg-opacity: 1;\n  background-color: #000000;\n  background-color: rgba(0, 0, 0, var(--bg-opacity));\n}\n.active\\:bg-gray-50:active {\n  --bg-opacity: 1;\n  background-color: #f9fafb;\n  background-color: rgba(249, 250, 251, var(--bg-opacity));\n}\n.active\\:bg-gray-100:active {\n  --bg-opacity: 1;\n  background-color: #f4f5f7;\n  background-color: rgba(244, 245, 247, var(--bg-opacity));\n}\n.active\\:bg-gray-200:active {\n  --bg-opacity: 1;\n  background-color: #e5e7eb;\n  background-color: rgba(229, 231, 235, var(--bg-opacity));\n}\n.active\\:bg-gray-300:active {\n  --bg-opacity: 1;\n  background-color: #d2d6dc;\n  background-color: rgba(210, 214, 220, var(--bg-opacity));\n}\n.active\\:bg-gray-400:active {\n  --bg-opacity: 1;\n  background-color: #9fa6b2;\n  background-color: rgba(159, 166, 178, var(--bg-opacity));\n}\n.active\\:bg-gray-500:active {\n  --bg-opacity: 1;\n  background-color: #6b7280;\n  background-color: rgba(107, 114, 128, var(--bg-opacity));\n}\n.active\\:bg-gray-600:active {\n  --bg-opacity: 1;\n  background-color: #4b5563;\n  background-color: rgba(75, 85, 99, var(--bg-opacity));\n}\n.active\\:bg-gray-700:active {\n  --bg-opacity: 1;\n  background-color: #374151;\n  background-color: rgba(55, 65, 81, var(--bg-opacity));\n}\n.active\\:bg-gray-800:active {\n  --bg-opacity: 1;\n  background-color: #252f3f;\n  background-color: rgba(37, 47, 63, var(--bg-opacity));\n}\n.active\\:bg-gray-900:active {\n  --bg-opacity: 1;\n  background-color: #161e2e;\n  background-color: rgba(22, 30, 46, var(--bg-opacity));\n}\n.active\\:bg-red-50:active {\n  --bg-opacity: 1;\n  background-color: #fdf2f2;\n  background-color: rgba(253, 242, 242, var(--bg-opacity));\n}\n.active\\:bg-red-100:active {\n  --bg-opacity: 1;\n  background-color: #fde8e8;\n  background-color: rgba(253, 232, 232, var(--bg-opacity));\n}\n.active\\:bg-red-200:active {\n  --bg-opacity: 1;\n  background-color: #fbd5d5;\n  background-color: rgba(251, 213, 213, var(--bg-opacity));\n}\n.active\\:bg-red-300:active {\n  --bg-opacity: 1;\n  background-color: #f8b4b4;\n  background-color: rgba(248, 180, 180, var(--bg-opacity));\n}\n.active\\:bg-red-400:active {\n  --bg-opacity: 1;\n  background-color: #f98080;\n  background-color: rgba(249, 128, 128, var(--bg-opacity));\n}\n.active\\:bg-red-500:active {\n  --bg-opacity: 1;\n  background-color: #f05252;\n  background-color: rgba(240, 82, 82, var(--bg-opacity));\n}\n.active\\:bg-red-600:active {\n  --bg-opacity: 1;\n  background-color: #e02424;\n  background-color: rgba(224, 36, 36, var(--bg-opacity));\n}\n.active\\:bg-red-700:active {\n  --bg-opacity: 1;\n  background-color: #c81e1e;\n  background-color: rgba(200, 30, 30, var(--bg-opacity));\n}\n.active\\:bg-red-800:active {\n  --bg-opacity: 1;\n  background-color: #9b1c1c;\n  background-color: rgba(155, 28, 28, var(--bg-opacity));\n}\n.active\\:bg-red-900:active {\n  --bg-opacity: 1;\n  background-color: #771d1d;\n  background-color: rgba(119, 29, 29, var(--bg-opacity));\n}\n.active\\:bg-orange-50:active {\n  --bg-opacity: 1;\n  background-color: #fff8f1;\n  background-color: rgba(255, 248, 241, var(--bg-opacity));\n}\n.active\\:bg-orange-100:active {\n  --bg-opacity: 1;\n  background-color: #feecdc;\n  background-color: rgba(254, 236, 220, var(--bg-opacity));\n}\n.active\\:bg-orange-200:active {\n  --bg-opacity: 1;\n  background-color: #fcd9bd;\n  background-color: rgba(252, 217, 189, var(--bg-opacity));\n}\n.active\\:bg-orange-300:active {\n  --bg-opacity: 1;\n  background-color: #fdba8c;\n  background-color: rgba(253, 186, 140, var(--bg-opacity));\n}\n.active\\:bg-orange-400:active {\n  --bg-opacity: 1;\n  background-color: #ff8a4c;\n  background-color: rgba(255, 138, 76, var(--bg-opacity));\n}\n.active\\:bg-orange-500:active {\n  --bg-opacity: 1;\n  background-color: #ff5a1f;\n  background-color: rgba(255, 90, 31, var(--bg-opacity));\n}\n.active\\:bg-orange-600:active {\n  --bg-opacity: 1;\n  background-color: #d03801;\n  background-color: rgba(208, 56, 1, var(--bg-opacity));\n}\n.active\\:bg-orange-700:active {\n  --bg-opacity: 1;\n  background-color: #b43403;\n  background-color: rgba(180, 52, 3, var(--bg-opacity));\n}\n.active\\:bg-orange-800:active {\n  --bg-opacity: 1;\n  background-color: #8a2c0d;\n  background-color: rgba(138, 44, 13, var(--bg-opacity));\n}\n.active\\:bg-orange-900:active {\n  --bg-opacity: 1;\n  background-color: #73230d;\n  background-color: rgba(115, 35, 13, var(--bg-opacity));\n}\n.active\\:bg-yellow-50:active {\n  --bg-opacity: 1;\n  background-color: #fdfdea;\n  background-color: rgba(253, 253, 234, var(--bg-opacity));\n}\n.active\\:bg-yellow-100:active {\n  --bg-opacity: 1;\n  background-color: #fdf6b2;\n  background-color: rgba(253, 246, 178, var(--bg-opacity));\n}\n.active\\:bg-yellow-200:active {\n  --bg-opacity: 1;\n  background-color: #fce96a;\n  background-color: rgba(252, 233, 106, var(--bg-opacity));\n}\n.active\\:bg-yellow-300:active {\n  --bg-opacity: 1;\n  background-color: #faca15;\n  background-color: rgba(250, 202, 21, var(--bg-opacity));\n}\n.active\\:bg-yellow-400:active {\n  --bg-opacity: 1;\n  background-color: #e3a008;\n  background-color: rgba(227, 160, 8, var(--bg-opacity));\n}\n.active\\:bg-yellow-500:active {\n  --bg-opacity: 1;\n  background-color: #c27803;\n  background-color: rgba(194, 120, 3, var(--bg-opacity));\n}\n.active\\:bg-yellow-600:active {\n  --bg-opacity: 1;\n  background-color: #9f580a;\n  background-color: rgba(159, 88, 10, var(--bg-opacity));\n}\n.active\\:bg-yellow-700:active {\n  --bg-opacity: 1;\n  background-color: #8e4b10;\n  background-color: rgba(142, 75, 16, var(--bg-opacity));\n}\n.active\\:bg-yellow-800:active {\n  --bg-opacity: 1;\n  background-color: #723b13;\n  background-color: rgba(114, 59, 19, var(--bg-opacity));\n}\n.active\\:bg-yellow-900:active {\n  --bg-opacity: 1;\n  background-color: #633112;\n  background-color: rgba(99, 49, 18, var(--bg-opacity));\n}\n.active\\:bg-green-50:active {\n  --bg-opacity: 1;\n  background-color: #f3faf7;\n  background-color: rgba(243, 250, 247, var(--bg-opacity));\n}\n.active\\:bg-green-100:active {\n  --bg-opacity: 1;\n  background-color: #def7ec;\n  background-color: rgba(222, 247, 236, var(--bg-opacity));\n}\n.active\\:bg-green-200:active {\n  --bg-opacity: 1;\n  background-color: #bcf0da;\n  background-color: rgba(188, 240, 218, var(--bg-opacity));\n}\n.active\\:bg-green-300:active {\n  --bg-opacity: 1;\n  background-color: #84e1bc;\n  background-color: rgba(132, 225, 188, var(--bg-opacity));\n}\n.active\\:bg-green-400:active {\n  --bg-opacity: 1;\n  background-color: #31c48d;\n  background-color: rgba(49, 196, 141, var(--bg-opacity));\n}\n.active\\:bg-green-500:active {\n  --bg-opacity: 1;\n  background-color: #0e9f6e;\n  background-color: rgba(14, 159, 110, var(--bg-opacity));\n}\n.active\\:bg-green-600:active {\n  --bg-opacity: 1;\n  background-color: #057a55;\n  background-color: rgba(5, 122, 85, var(--bg-opacity));\n}\n.active\\:bg-green-700:active {\n  --bg-opacity: 1;\n  background-color: #046c4e;\n  background-color: rgba(4, 108, 78, var(--bg-opacity));\n}\n.active\\:bg-green-800:active {\n  --bg-opacity: 1;\n  background-color: #03543f;\n  background-color: rgba(3, 84, 63, var(--bg-opacity));\n}\n.active\\:bg-green-900:active {\n  --bg-opacity: 1;\n  background-color: #014737;\n  background-color: rgba(1, 71, 55, var(--bg-opacity));\n}\n.active\\:bg-teal-50:active {\n  --bg-opacity: 1;\n  background-color: #edfafa;\n  background-color: rgba(237, 250, 250, var(--bg-opacity));\n}\n.active\\:bg-teal-100:active {\n  --bg-opacity: 1;\n  background-color: #d5f5f6;\n  background-color: rgba(213, 245, 246, var(--bg-opacity));\n}\n.active\\:bg-teal-200:active {\n  --bg-opacity: 1;\n  background-color: #afecef;\n  background-color: rgba(175, 236, 239, var(--bg-opacity));\n}\n.active\\:bg-teal-300:active {\n  --bg-opacity: 1;\n  background-color: #7edce2;\n  background-color: rgba(126, 220, 226, var(--bg-opacity));\n}\n.active\\:bg-teal-400:active {\n  --bg-opacity: 1;\n  background-color: #16bdca;\n  background-color: rgba(22, 189, 202, var(--bg-opacity));\n}\n.active\\:bg-teal-500:active {\n  --bg-opacity: 1;\n  background-color: #0694a2;\n  background-color: rgba(6, 148, 162, var(--bg-opacity));\n}\n.active\\:bg-teal-600:active {\n  --bg-opacity: 1;\n  background-color: #047481;\n  background-color: rgba(4, 116, 129, var(--bg-opacity));\n}\n.active\\:bg-teal-700:active {\n  --bg-opacity: 1;\n  background-color: #036672;\n  background-color: rgba(3, 102, 114, var(--bg-opacity));\n}\n.active\\:bg-teal-800:active {\n  --bg-opacity: 1;\n  background-color: #05505c;\n  background-color: rgba(5, 80, 92, var(--bg-opacity));\n}\n.active\\:bg-teal-900:active {\n  --bg-opacity: 1;\n  background-color: #014451;\n  background-color: rgba(1, 68, 81, var(--bg-opacity));\n}\n.active\\:bg-blue-50:active {\n  --bg-opacity: 1;\n  background-color: #ebf5ff;\n  background-color: rgba(235, 245, 255, var(--bg-opacity));\n}\n.active\\:bg-blue-100:active {\n  --bg-opacity: 1;\n  background-color: #e1effe;\n  background-color: rgba(225, 239, 254, var(--bg-opacity));\n}\n.active\\:bg-blue-200:active {\n  --bg-opacity: 1;\n  background-color: #c3ddfd;\n  background-color: rgba(195, 221, 253, var(--bg-opacity));\n}\n.active\\:bg-blue-300:active {\n  --bg-opacity: 1;\n  background-color: #a4cafe;\n  background-color: rgba(164, 202, 254, var(--bg-opacity));\n}\n.active\\:bg-blue-400:active {\n  --bg-opacity: 1;\n  background-color: #76a9fa;\n  background-color: rgba(118, 169, 250, var(--bg-opacity));\n}\n.active\\:bg-blue-500:active {\n  --bg-opacity: 1;\n  background-color: #3f83f8;\n  background-color: rgba(63, 131, 248, var(--bg-opacity));\n}\n.active\\:bg-blue-600:active {\n  --bg-opacity: 1;\n  background-color: #1c64f2;\n  background-color: rgba(28, 100, 242, var(--bg-opacity));\n}\n.active\\:bg-blue-700:active {\n  --bg-opacity: 1;\n  background-color: #1a56db;\n  background-color: rgba(26, 86, 219, var(--bg-opacity));\n}\n.active\\:bg-blue-800:active {\n  --bg-opacity: 1;\n  background-color: #1e429f;\n  background-color: rgba(30, 66, 159, var(--bg-opacity));\n}\n.active\\:bg-blue-900:active {\n  --bg-opacity: 1;\n  background-color: #233876;\n  background-color: rgba(35, 56, 118, var(--bg-opacity));\n}\n.active\\:bg-indigo-50:active {\n  --bg-opacity: 1;\n  background-color: #f0f5ff;\n  background-color: rgba(240, 245, 255, var(--bg-opacity));\n}\n.active\\:bg-indigo-100:active {\n  --bg-opacity: 1;\n  background-color: #e5edff;\n  background-color: rgba(229, 237, 255, var(--bg-opacity));\n}\n.active\\:bg-indigo-200:active {\n  --bg-opacity: 1;\n  background-color: #cddbfe;\n  background-color: rgba(205, 219, 254, var(--bg-opacity));\n}\n.active\\:bg-indigo-300:active {\n  --bg-opacity: 1;\n  background-color: #b4c6fc;\n  background-color: rgba(180, 198, 252, var(--bg-opacity));\n}\n.active\\:bg-indigo-400:active {\n  --bg-opacity: 1;\n  background-color: #8da2fb;\n  background-color: rgba(141, 162, 251, var(--bg-opacity));\n}\n.active\\:bg-indigo-500:active {\n  --bg-opacity: 1;\n  background-color: #6875f5;\n  background-color: rgba(104, 117, 245, var(--bg-opacity));\n}\n.active\\:bg-indigo-600:active {\n  --bg-opacity: 1;\n  background-color: #5850ec;\n  background-color: rgba(88, 80, 236, var(--bg-opacity));\n}\n.active\\:bg-indigo-700:active {\n  --bg-opacity: 1;\n  background-color: #5145cd;\n  background-color: rgba(81, 69, 205, var(--bg-opacity));\n}\n.active\\:bg-indigo-800:active {\n  --bg-opacity: 1;\n  background-color: #42389d;\n  background-color: rgba(66, 56, 157, var(--bg-opacity));\n}\n.active\\:bg-indigo-900:active {\n  --bg-opacity: 1;\n  background-color: #362f78;\n  background-color: rgba(54, 47, 120, var(--bg-opacity));\n}\n.active\\:bg-purple-50:active {\n  --bg-opacity: 1;\n  background-color: #f6f5ff;\n  background-color: rgba(246, 245, 255, var(--bg-opacity));\n}\n.active\\:bg-purple-100:active {\n  --bg-opacity: 1;\n  background-color: #edebfe;\n  background-color: rgba(237, 235, 254, var(--bg-opacity));\n}\n.active\\:bg-purple-200:active {\n  --bg-opacity: 1;\n  background-color: #dcd7fe;\n  background-color: rgba(220, 215, 254, var(--bg-opacity));\n}\n.active\\:bg-purple-300:active {\n  --bg-opacity: 1;\n  background-color: #cabffd;\n  background-color: rgba(202, 191, 253, var(--bg-opacity));\n}\n.active\\:bg-purple-400:active {\n  --bg-opacity: 1;\n  background-color: #ac94fa;\n  background-color: rgba(172, 148, 250, var(--bg-opacity));\n}\n.active\\:bg-purple-500:active {\n  --bg-opacity: 1;\n  background-color: #9061f9;\n  background-color: rgba(144, 97, 249, var(--bg-opacity));\n}\n.active\\:bg-purple-600:active {\n  --bg-opacity: 1;\n  background-color: #7e3af2;\n  background-color: rgba(126, 58, 242, var(--bg-opacity));\n}\n.active\\:bg-purple-700:active {\n  --bg-opacity: 1;\n  background-color: #6c2bd9;\n  background-color: rgba(108, 43, 217, var(--bg-opacity));\n}\n.active\\:bg-purple-800:active {\n  --bg-opacity: 1;\n  background-color: #5521b5;\n  background-color: rgba(85, 33, 181, var(--bg-opacity));\n}\n.active\\:bg-purple-900:active {\n  --bg-opacity: 1;\n  background-color: #4a1d96;\n  background-color: rgba(74, 29, 150, var(--bg-opacity));\n}\n.active\\:bg-pink-50:active {\n  --bg-opacity: 1;\n  background-color: #fdf2f8;\n  background-color: rgba(253, 242, 248, var(--bg-opacity));\n}\n.active\\:bg-pink-100:active {\n  --bg-opacity: 1;\n  background-color: #fce8f3;\n  background-color: rgba(252, 232, 243, var(--bg-opacity));\n}\n.active\\:bg-pink-200:active {\n  --bg-opacity: 1;\n  background-color: #fad1e8;\n  background-color: rgba(250, 209, 232, var(--bg-opacity));\n}\n.active\\:bg-pink-300:active {\n  --bg-opacity: 1;\n  background-color: #f8b4d9;\n  background-color: rgba(248, 180, 217, var(--bg-opacity));\n}\n.active\\:bg-pink-400:active {\n  --bg-opacity: 1;\n  background-color: #f17eb8;\n  background-color: rgba(241, 126, 184, var(--bg-opacity));\n}\n.active\\:bg-pink-500:active {\n  --bg-opacity: 1;\n  background-color: #e74694;\n  background-color: rgba(231, 70, 148, var(--bg-opacity));\n}\n.active\\:bg-pink-600:active {\n  --bg-opacity: 1;\n  background-color: #d61f69;\n  background-color: rgba(214, 31, 105, var(--bg-opacity));\n}\n.active\\:bg-pink-700:active {\n  --bg-opacity: 1;\n  background-color: #bf125d;\n  background-color: rgba(191, 18, 93, var(--bg-opacity));\n}\n.active\\:bg-pink-800:active {\n  --bg-opacity: 1;\n  background-color: #99154b;\n  background-color: rgba(153, 21, 75, var(--bg-opacity));\n}\n.active\\:bg-pink-900:active {\n  --bg-opacity: 1;\n  background-color: #751a3d;\n  background-color: rgba(117, 26, 61, var(--bg-opacity));\n}\n.active\\:bg-cool-gray-50:active {\n  --bg-opacity: 1;\n  background-color: #f8fafc;\n  background-color: rgba(248, 250, 252, var(--bg-opacity));\n}\n.active\\:bg-cool-gray-100:active {\n  --bg-opacity: 1;\n  background-color: #f1f5f9;\n  background-color: rgba(241, 245, 249, var(--bg-opacity));\n}\n.active\\:bg-cool-gray-200:active {\n  --bg-opacity: 1;\n  background-color: #e2e8f0;\n  background-color: rgba(226, 232, 240, var(--bg-opacity));\n}\n.active\\:bg-cool-gray-300:active {\n  --bg-opacity: 1;\n  background-color: #cfd8e3;\n  background-color: rgba(207, 216, 227, var(--bg-opacity));\n}\n.active\\:bg-cool-gray-400:active {\n  --bg-opacity: 1;\n  background-color: #97a6ba;\n  background-color: rgba(151, 166, 186, var(--bg-opacity));\n}\n.active\\:bg-cool-gray-500:active {\n  --bg-opacity: 1;\n  background-color: #64748b;\n  background-color: rgba(100, 116, 139, var(--bg-opacity));\n}\n.active\\:bg-cool-gray-600:active {\n  --bg-opacity: 1;\n  background-color: #475569;\n  background-color: rgba(71, 85, 105, var(--bg-opacity));\n}\n.active\\:bg-cool-gray-700:active {\n  --bg-opacity: 1;\n  background-color: #364152;\n  background-color: rgba(54, 65, 82, var(--bg-opacity));\n}\n.active\\:bg-cool-gray-800:active {\n  --bg-opacity: 1;\n  background-color: #27303f;\n  background-color: rgba(39, 48, 63, var(--bg-opacity));\n}\n.active\\:bg-cool-gray-900:active {\n  --bg-opacity: 1;\n  background-color: #1a202e;\n  background-color: rgba(26, 32, 46, var(--bg-opacity));\n}\n.bg-none {\n  background-image: none;\n}\n.bg-gradient-to-t {\n  background-image: linear-gradient(to top, var(--gradient-color-stops));\n}\n.bg-gradient-to-tr {\n  background-image: linear-gradient(to top right, var(--gradient-color-stops));\n}\n.bg-gradient-to-r {\n  background-image: linear-gradient(to right, var(--gradient-color-stops));\n}\n.bg-gradient-to-br {\n  background-image: linear-gradient(to bottom right, var(--gradient-color-stops));\n}\n.bg-gradient-to-b {\n  background-image: linear-gradient(to bottom, var(--gradient-color-stops));\n}\n.bg-gradient-to-bl {\n  background-image: linear-gradient(to bottom left, var(--gradient-color-stops));\n}\n.bg-gradient-to-l {\n  background-image: linear-gradient(to left, var(--gradient-color-stops));\n}\n.bg-gradient-to-tl {\n  background-image: linear-gradient(to top left, var(--gradient-color-stops));\n}\n.from-current {\n  --gradient-from-color: currentColor;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));\n}\n.from-transparent {\n  --gradient-from-color: transparent;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0));\n}\n.from-white {\n  --gradient-from-color: #ffffff;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));\n}\n.from-black {\n  --gradient-from-color: #000000;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0));\n}\n.from-gray-50 {\n  --gradient-from-color: #f9fafb;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(249, 250, 251, 0));\n}\n.from-gray-100 {\n  --gradient-from-color: #f4f5f7;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(244, 245, 247, 0));\n}\n.from-gray-200 {\n  --gradient-from-color: #e5e7eb;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(229, 231, 235, 0));\n}\n.from-gray-300 {\n  --gradient-from-color: #d2d6dc;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(210, 214, 220, 0));\n}\n.from-gray-400 {\n  --gradient-from-color: #9fa6b2;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(159, 166, 178, 0));\n}\n.from-gray-500 {\n  --gradient-from-color: #6b7280;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(107, 114, 128, 0));\n}\n.from-gray-600 {\n  --gradient-from-color: #4b5563;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(75, 85, 99, 0));\n}\n.from-gray-700 {\n  --gradient-from-color: #374151;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(55, 65, 81, 0));\n}\n.from-gray-800 {\n  --gradient-from-color: #252f3f;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(37, 47, 63, 0));\n}\n.from-gray-900 {\n  --gradient-from-color: #161e2e;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(22, 30, 46, 0));\n}\n.from-red-50 {\n  --gradient-from-color: #fdf2f2;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 242, 242, 0));\n}\n.from-red-100 {\n  --gradient-from-color: #fde8e8;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 232, 232, 0));\n}\n.from-red-200 {\n  --gradient-from-color: #fbd5d5;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(251, 213, 213, 0));\n}\n.from-red-300 {\n  --gradient-from-color: #f8b4b4;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(248, 180, 180, 0));\n}\n.from-red-400 {\n  --gradient-from-color: #f98080;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(249, 128, 128, 0));\n}\n.from-red-500 {\n  --gradient-from-color: #f05252;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(240, 82, 82, 0));\n}\n.from-red-600 {\n  --gradient-from-color: #e02424;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(224, 36, 36, 0));\n}\n.from-red-700 {\n  --gradient-from-color: #c81e1e;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(200, 30, 30, 0));\n}\n.from-red-800 {\n  --gradient-from-color: #9b1c1c;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(155, 28, 28, 0));\n}\n.from-red-900 {\n  --gradient-from-color: #771d1d;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(119, 29, 29, 0));\n}\n.from-orange-50 {\n  --gradient-from-color: #fff8f1;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 248, 241, 0));\n}\n.from-orange-100 {\n  --gradient-from-color: #feecdc;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 236, 220, 0));\n}\n.from-orange-200 {\n  --gradient-from-color: #fcd9bd;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(252, 217, 189, 0));\n}\n.from-orange-300 {\n  --gradient-from-color: #fdba8c;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 186, 140, 0));\n}\n.from-orange-400 {\n  --gradient-from-color: #ff8a4c;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 138, 76, 0));\n}\n.from-orange-500 {\n  --gradient-from-color: #ff5a1f;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 90, 31, 0));\n}\n.from-orange-600 {\n  --gradient-from-color: #d03801;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(208, 56, 1, 0));\n}\n.from-orange-700 {\n  --gradient-from-color: #b43403;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(180, 52, 3, 0));\n}\n.from-orange-800 {\n  --gradient-from-color: #8a2c0d;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(138, 44, 13, 0));\n}\n.from-orange-900 {\n  --gradient-from-color: #73230d;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(115, 35, 13, 0));\n}\n.from-yellow-50 {\n  --gradient-from-color: #fdfdea;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 253, 234, 0));\n}\n.from-yellow-100 {\n  --gradient-from-color: #fdf6b2;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 246, 178, 0));\n}\n.from-yellow-200 {\n  --gradient-from-color: #fce96a;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(252, 233, 106, 0));\n}\n.from-yellow-300 {\n  --gradient-from-color: #faca15;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(250, 202, 21, 0));\n}\n.from-yellow-400 {\n  --gradient-from-color: #e3a008;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(227, 160, 8, 0));\n}\n.from-yellow-500 {\n  --gradient-from-color: #c27803;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(194, 120, 3, 0));\n}\n.from-yellow-600 {\n  --gradient-from-color: #9f580a;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(159, 88, 10, 0));\n}\n.from-yellow-700 {\n  --gradient-from-color: #8e4b10;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(142, 75, 16, 0));\n}\n.from-yellow-800 {\n  --gradient-from-color: #723b13;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(114, 59, 19, 0));\n}\n.from-yellow-900 {\n  --gradient-from-color: #633112;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(99, 49, 18, 0));\n}\n.from-green-50 {\n  --gradient-from-color: #f3faf7;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(243, 250, 247, 0));\n}\n.from-green-100 {\n  --gradient-from-color: #def7ec;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(222, 247, 236, 0));\n}\n.from-green-200 {\n  --gradient-from-color: #bcf0da;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(188, 240, 218, 0));\n}\n.from-green-300 {\n  --gradient-from-color: #84e1bc;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(132, 225, 188, 0));\n}\n.from-green-400 {\n  --gradient-from-color: #31c48d;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(49, 196, 141, 0));\n}\n.from-green-500 {\n  --gradient-from-color: #0e9f6e;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(14, 159, 110, 0));\n}\n.from-green-600 {\n  --gradient-from-color: #057a55;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(5, 122, 85, 0));\n}\n.from-green-700 {\n  --gradient-from-color: #046c4e;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(4, 108, 78, 0));\n}\n.from-green-800 {\n  --gradient-from-color: #03543f;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(3, 84, 63, 0));\n}\n.from-green-900 {\n  --gradient-from-color: #014737;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(1, 71, 55, 0));\n}\n.from-teal-50 {\n  --gradient-from-color: #edfafa;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(237, 250, 250, 0));\n}\n.from-teal-100 {\n  --gradient-from-color: #d5f5f6;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(213, 245, 246, 0));\n}\n.from-teal-200 {\n  --gradient-from-color: #afecef;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(175, 236, 239, 0));\n}\n.from-teal-300 {\n  --gradient-from-color: #7edce2;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(126, 220, 226, 0));\n}\n.from-teal-400 {\n  --gradient-from-color: #16bdca;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(22, 189, 202, 0));\n}\n.from-teal-500 {\n  --gradient-from-color: #0694a2;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(6, 148, 162, 0));\n}\n.from-teal-600 {\n  --gradient-from-color: #047481;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(4, 116, 129, 0));\n}\n.from-teal-700 {\n  --gradient-from-color: #036672;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(3, 102, 114, 0));\n}\n.from-teal-800 {\n  --gradient-from-color: #05505c;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(5, 80, 92, 0));\n}\n.from-teal-900 {\n  --gradient-from-color: #014451;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(1, 68, 81, 0));\n}\n.from-blue-50 {\n  --gradient-from-color: #ebf5ff;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(235, 245, 255, 0));\n}\n.from-blue-100 {\n  --gradient-from-color: #e1effe;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(225, 239, 254, 0));\n}\n.from-blue-200 {\n  --gradient-from-color: #c3ddfd;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(195, 221, 253, 0));\n}\n.from-blue-300 {\n  --gradient-from-color: #a4cafe;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(164, 202, 254, 0));\n}\n.from-blue-400 {\n  --gradient-from-color: #76a9fa;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(118, 169, 250, 0));\n}\n.from-blue-500 {\n  --gradient-from-color: #3f83f8;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(63, 131, 248, 0));\n}\n.from-blue-600 {\n  --gradient-from-color: #1c64f2;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(28, 100, 242, 0));\n}\n.from-blue-700 {\n  --gradient-from-color: #1a56db;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(26, 86, 219, 0));\n}\n.from-blue-800 {\n  --gradient-from-color: #1e429f;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(30, 66, 159, 0));\n}\n.from-blue-900 {\n  --gradient-from-color: #233876;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(35, 56, 118, 0));\n}\n.from-indigo-50 {\n  --gradient-from-color: #f0f5ff;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(240, 245, 255, 0));\n}\n.from-indigo-100 {\n  --gradient-from-color: #e5edff;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(229, 237, 255, 0));\n}\n.from-indigo-200 {\n  --gradient-from-color: #cddbfe;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(205, 219, 254, 0));\n}\n.from-indigo-300 {\n  --gradient-from-color: #b4c6fc;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(180, 198, 252, 0));\n}\n.from-indigo-400 {\n  --gradient-from-color: #8da2fb;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(141, 162, 251, 0));\n}\n.from-indigo-500 {\n  --gradient-from-color: #6875f5;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(104, 117, 245, 0));\n}\n.from-indigo-600 {\n  --gradient-from-color: #5850ec;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(88, 80, 236, 0));\n}\n.from-indigo-700 {\n  --gradient-from-color: #5145cd;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(81, 69, 205, 0));\n}\n.from-indigo-800 {\n  --gradient-from-color: #42389d;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(66, 56, 157, 0));\n}\n.from-indigo-900 {\n  --gradient-from-color: #362f78;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(54, 47, 120, 0));\n}\n.from-purple-50 {\n  --gradient-from-color: #f6f5ff;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(246, 245, 255, 0));\n}\n.from-purple-100 {\n  --gradient-from-color: #edebfe;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(237, 235, 254, 0));\n}\n.from-purple-200 {\n  --gradient-from-color: #dcd7fe;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(220, 215, 254, 0));\n}\n.from-purple-300 {\n  --gradient-from-color: #cabffd;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(202, 191, 253, 0));\n}\n.from-purple-400 {\n  --gradient-from-color: #ac94fa;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(172, 148, 250, 0));\n}\n.from-purple-500 {\n  --gradient-from-color: #9061f9;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(144, 97, 249, 0));\n}\n.from-purple-600 {\n  --gradient-from-color: #7e3af2;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(126, 58, 242, 0));\n}\n.from-purple-700 {\n  --gradient-from-color: #6c2bd9;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(108, 43, 217, 0));\n}\n.from-purple-800 {\n  --gradient-from-color: #5521b5;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(85, 33, 181, 0));\n}\n.from-purple-900 {\n  --gradient-from-color: #4a1d96;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(74, 29, 150, 0));\n}\n.from-pink-50 {\n  --gradient-from-color: #fdf2f8;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 242, 248, 0));\n}\n.from-pink-100 {\n  --gradient-from-color: #fce8f3;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(252, 232, 243, 0));\n}\n.from-pink-200 {\n  --gradient-from-color: #fad1e8;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(250, 209, 232, 0));\n}\n.from-pink-300 {\n  --gradient-from-color: #f8b4d9;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(248, 180, 217, 0));\n}\n.from-pink-400 {\n  --gradient-from-color: #f17eb8;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(241, 126, 184, 0));\n}\n.from-pink-500 {\n  --gradient-from-color: #e74694;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(231, 70, 148, 0));\n}\n.from-pink-600 {\n  --gradient-from-color: #d61f69;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(214, 31, 105, 0));\n}\n.from-pink-700 {\n  --gradient-from-color: #bf125d;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(191, 18, 93, 0));\n}\n.from-pink-800 {\n  --gradient-from-color: #99154b;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(153, 21, 75, 0));\n}\n.from-pink-900 {\n  --gradient-from-color: #751a3d;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(117, 26, 61, 0));\n}\n.from-cool-gray-50 {\n  --gradient-from-color: #f8fafc;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(248, 250, 252, 0));\n}\n.from-cool-gray-100 {\n  --gradient-from-color: #f1f5f9;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(241, 245, 249, 0));\n}\n.from-cool-gray-200 {\n  --gradient-from-color: #e2e8f0;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(226, 232, 240, 0));\n}\n.from-cool-gray-300 {\n  --gradient-from-color: #cfd8e3;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(207, 216, 227, 0));\n}\n.from-cool-gray-400 {\n  --gradient-from-color: #97a6ba;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(151, 166, 186, 0));\n}\n.from-cool-gray-500 {\n  --gradient-from-color: #64748b;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(100, 116, 139, 0));\n}\n.from-cool-gray-600 {\n  --gradient-from-color: #475569;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(71, 85, 105, 0));\n}\n.from-cool-gray-700 {\n  --gradient-from-color: #364152;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(54, 65, 82, 0));\n}\n.from-cool-gray-800 {\n  --gradient-from-color: #27303f;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(39, 48, 63, 0));\n}\n.from-cool-gray-900 {\n  --gradient-from-color: #1a202e;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(26, 32, 46, 0));\n}\n.via-current {\n  --gradient-via-color: currentColor;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));\n}\n.via-transparent {\n  --gradient-via-color: transparent;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0));\n}\n.via-white {\n  --gradient-via-color: #ffffff;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));\n}\n.via-black {\n  --gradient-via-color: #000000;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0));\n}\n.via-gray-50 {\n  --gradient-via-color: #f9fafb;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(249, 250, 251, 0));\n}\n.via-gray-100 {\n  --gradient-via-color: #f4f5f7;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(244, 245, 247, 0));\n}\n.via-gray-200 {\n  --gradient-via-color: #e5e7eb;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(229, 231, 235, 0));\n}\n.via-gray-300 {\n  --gradient-via-color: #d2d6dc;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(210, 214, 220, 0));\n}\n.via-gray-400 {\n  --gradient-via-color: #9fa6b2;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(159, 166, 178, 0));\n}\n.via-gray-500 {\n  --gradient-via-color: #6b7280;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(107, 114, 128, 0));\n}\n.via-gray-600 {\n  --gradient-via-color: #4b5563;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(75, 85, 99, 0));\n}\n.via-gray-700 {\n  --gradient-via-color: #374151;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(55, 65, 81, 0));\n}\n.via-gray-800 {\n  --gradient-via-color: #252f3f;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(37, 47, 63, 0));\n}\n.via-gray-900 {\n  --gradient-via-color: #161e2e;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(22, 30, 46, 0));\n}\n.via-red-50 {\n  --gradient-via-color: #fdf2f2;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 242, 242, 0));\n}\n.via-red-100 {\n  --gradient-via-color: #fde8e8;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 232, 232, 0));\n}\n.via-red-200 {\n  --gradient-via-color: #fbd5d5;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(251, 213, 213, 0));\n}\n.via-red-300 {\n  --gradient-via-color: #f8b4b4;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(248, 180, 180, 0));\n}\n.via-red-400 {\n  --gradient-via-color: #f98080;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(249, 128, 128, 0));\n}\n.via-red-500 {\n  --gradient-via-color: #f05252;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(240, 82, 82, 0));\n}\n.via-red-600 {\n  --gradient-via-color: #e02424;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(224, 36, 36, 0));\n}\n.via-red-700 {\n  --gradient-via-color: #c81e1e;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(200, 30, 30, 0));\n}\n.via-red-800 {\n  --gradient-via-color: #9b1c1c;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(155, 28, 28, 0));\n}\n.via-red-900 {\n  --gradient-via-color: #771d1d;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(119, 29, 29, 0));\n}\n.via-orange-50 {\n  --gradient-via-color: #fff8f1;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 248, 241, 0));\n}\n.via-orange-100 {\n  --gradient-via-color: #feecdc;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 236, 220, 0));\n}\n.via-orange-200 {\n  --gradient-via-color: #fcd9bd;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(252, 217, 189, 0));\n}\n.via-orange-300 {\n  --gradient-via-color: #fdba8c;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 186, 140, 0));\n}\n.via-orange-400 {\n  --gradient-via-color: #ff8a4c;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 138, 76, 0));\n}\n.via-orange-500 {\n  --gradient-via-color: #ff5a1f;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 90, 31, 0));\n}\n.via-orange-600 {\n  --gradient-via-color: #d03801;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(208, 56, 1, 0));\n}\n.via-orange-700 {\n  --gradient-via-color: #b43403;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(180, 52, 3, 0));\n}\n.via-orange-800 {\n  --gradient-via-color: #8a2c0d;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(138, 44, 13, 0));\n}\n.via-orange-900 {\n  --gradient-via-color: #73230d;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(115, 35, 13, 0));\n}\n.via-yellow-50 {\n  --gradient-via-color: #fdfdea;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 253, 234, 0));\n}\n.via-yellow-100 {\n  --gradient-via-color: #fdf6b2;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 246, 178, 0));\n}\n.via-yellow-200 {\n  --gradient-via-color: #fce96a;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(252, 233, 106, 0));\n}\n.via-yellow-300 {\n  --gradient-via-color: #faca15;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(250, 202, 21, 0));\n}\n.via-yellow-400 {\n  --gradient-via-color: #e3a008;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(227, 160, 8, 0));\n}\n.via-yellow-500 {\n  --gradient-via-color: #c27803;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(194, 120, 3, 0));\n}\n.via-yellow-600 {\n  --gradient-via-color: #9f580a;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(159, 88, 10, 0));\n}\n.via-yellow-700 {\n  --gradient-via-color: #8e4b10;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(142, 75, 16, 0));\n}\n.via-yellow-800 {\n  --gradient-via-color: #723b13;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(114, 59, 19, 0));\n}\n.via-yellow-900 {\n  --gradient-via-color: #633112;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(99, 49, 18, 0));\n}\n.via-green-50 {\n  --gradient-via-color: #f3faf7;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(243, 250, 247, 0));\n}\n.via-green-100 {\n  --gradient-via-color: #def7ec;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(222, 247, 236, 0));\n}\n.via-green-200 {\n  --gradient-via-color: #bcf0da;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(188, 240, 218, 0));\n}\n.via-green-300 {\n  --gradient-via-color: #84e1bc;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(132, 225, 188, 0));\n}\n.via-green-400 {\n  --gradient-via-color: #31c48d;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(49, 196, 141, 0));\n}\n.via-green-500 {\n  --gradient-via-color: #0e9f6e;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(14, 159, 110, 0));\n}\n.via-green-600 {\n  --gradient-via-color: #057a55;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(5, 122, 85, 0));\n}\n.via-green-700 {\n  --gradient-via-color: #046c4e;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(4, 108, 78, 0));\n}\n.via-green-800 {\n  --gradient-via-color: #03543f;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(3, 84, 63, 0));\n}\n.via-green-900 {\n  --gradient-via-color: #014737;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(1, 71, 55, 0));\n}\n.via-teal-50 {\n  --gradient-via-color: #edfafa;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(237, 250, 250, 0));\n}\n.via-teal-100 {\n  --gradient-via-color: #d5f5f6;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(213, 245, 246, 0));\n}\n.via-teal-200 {\n  --gradient-via-color: #afecef;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(175, 236, 239, 0));\n}\n.via-teal-300 {\n  --gradient-via-color: #7edce2;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(126, 220, 226, 0));\n}\n.via-teal-400 {\n  --gradient-via-color: #16bdca;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(22, 189, 202, 0));\n}\n.via-teal-500 {\n  --gradient-via-color: #0694a2;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(6, 148, 162, 0));\n}\n.via-teal-600 {\n  --gradient-via-color: #047481;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(4, 116, 129, 0));\n}\n.via-teal-700 {\n  --gradient-via-color: #036672;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(3, 102, 114, 0));\n}\n.via-teal-800 {\n  --gradient-via-color: #05505c;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(5, 80, 92, 0));\n}\n.via-teal-900 {\n  --gradient-via-color: #014451;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(1, 68, 81, 0));\n}\n.via-blue-50 {\n  --gradient-via-color: #ebf5ff;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(235, 245, 255, 0));\n}\n.via-blue-100 {\n  --gradient-via-color: #e1effe;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(225, 239, 254, 0));\n}\n.via-blue-200 {\n  --gradient-via-color: #c3ddfd;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(195, 221, 253, 0));\n}\n.via-blue-300 {\n  --gradient-via-color: #a4cafe;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(164, 202, 254, 0));\n}\n.via-blue-400 {\n  --gradient-via-color: #76a9fa;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(118, 169, 250, 0));\n}\n.via-blue-500 {\n  --gradient-via-color: #3f83f8;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(63, 131, 248, 0));\n}\n.via-blue-600 {\n  --gradient-via-color: #1c64f2;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(28, 100, 242, 0));\n}\n.via-blue-700 {\n  --gradient-via-color: #1a56db;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(26, 86, 219, 0));\n}\n.via-blue-800 {\n  --gradient-via-color: #1e429f;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(30, 66, 159, 0));\n}\n.via-blue-900 {\n  --gradient-via-color: #233876;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(35, 56, 118, 0));\n}\n.via-indigo-50 {\n  --gradient-via-color: #f0f5ff;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(240, 245, 255, 0));\n}\n.via-indigo-100 {\n  --gradient-via-color: #e5edff;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(229, 237, 255, 0));\n}\n.via-indigo-200 {\n  --gradient-via-color: #cddbfe;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(205, 219, 254, 0));\n}\n.via-indigo-300 {\n  --gradient-via-color: #b4c6fc;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(180, 198, 252, 0));\n}\n.via-indigo-400 {\n  --gradient-via-color: #8da2fb;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(141, 162, 251, 0));\n}\n.via-indigo-500 {\n  --gradient-via-color: #6875f5;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(104, 117, 245, 0));\n}\n.via-indigo-600 {\n  --gradient-via-color: #5850ec;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(88, 80, 236, 0));\n}\n.via-indigo-700 {\n  --gradient-via-color: #5145cd;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(81, 69, 205, 0));\n}\n.via-indigo-800 {\n  --gradient-via-color: #42389d;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(66, 56, 157, 0));\n}\n.via-indigo-900 {\n  --gradient-via-color: #362f78;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(54, 47, 120, 0));\n}\n.via-purple-50 {\n  --gradient-via-color: #f6f5ff;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(246, 245, 255, 0));\n}\n.via-purple-100 {\n  --gradient-via-color: #edebfe;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(237, 235, 254, 0));\n}\n.via-purple-200 {\n  --gradient-via-color: #dcd7fe;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(220, 215, 254, 0));\n}\n.via-purple-300 {\n  --gradient-via-color: #cabffd;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(202, 191, 253, 0));\n}\n.via-purple-400 {\n  --gradient-via-color: #ac94fa;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(172, 148, 250, 0));\n}\n.via-purple-500 {\n  --gradient-via-color: #9061f9;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(144, 97, 249, 0));\n}\n.via-purple-600 {\n  --gradient-via-color: #7e3af2;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(126, 58, 242, 0));\n}\n.via-purple-700 {\n  --gradient-via-color: #6c2bd9;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(108, 43, 217, 0));\n}\n.via-purple-800 {\n  --gradient-via-color: #5521b5;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(85, 33, 181, 0));\n}\n.via-purple-900 {\n  --gradient-via-color: #4a1d96;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(74, 29, 150, 0));\n}\n.via-pink-50 {\n  --gradient-via-color: #fdf2f8;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 242, 248, 0));\n}\n.via-pink-100 {\n  --gradient-via-color: #fce8f3;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(252, 232, 243, 0));\n}\n.via-pink-200 {\n  --gradient-via-color: #fad1e8;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(250, 209, 232, 0));\n}\n.via-pink-300 {\n  --gradient-via-color: #f8b4d9;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(248, 180, 217, 0));\n}\n.via-pink-400 {\n  --gradient-via-color: #f17eb8;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(241, 126, 184, 0));\n}\n.via-pink-500 {\n  --gradient-via-color: #e74694;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(231, 70, 148, 0));\n}\n.via-pink-600 {\n  --gradient-via-color: #d61f69;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(214, 31, 105, 0));\n}\n.via-pink-700 {\n  --gradient-via-color: #bf125d;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(191, 18, 93, 0));\n}\n.via-pink-800 {\n  --gradient-via-color: #99154b;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(153, 21, 75, 0));\n}\n.via-pink-900 {\n  --gradient-via-color: #751a3d;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(117, 26, 61, 0));\n}\n.via-cool-gray-50 {\n  --gradient-via-color: #f8fafc;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(248, 250, 252, 0));\n}\n.via-cool-gray-100 {\n  --gradient-via-color: #f1f5f9;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(241, 245, 249, 0));\n}\n.via-cool-gray-200 {\n  --gradient-via-color: #e2e8f0;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(226, 232, 240, 0));\n}\n.via-cool-gray-300 {\n  --gradient-via-color: #cfd8e3;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(207, 216, 227, 0));\n}\n.via-cool-gray-400 {\n  --gradient-via-color: #97a6ba;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(151, 166, 186, 0));\n}\n.via-cool-gray-500 {\n  --gradient-via-color: #64748b;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(100, 116, 139, 0));\n}\n.via-cool-gray-600 {\n  --gradient-via-color: #475569;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(71, 85, 105, 0));\n}\n.via-cool-gray-700 {\n  --gradient-via-color: #364152;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(54, 65, 82, 0));\n}\n.via-cool-gray-800 {\n  --gradient-via-color: #27303f;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(39, 48, 63, 0));\n}\n.via-cool-gray-900 {\n  --gradient-via-color: #1a202e;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(26, 32, 46, 0));\n}\n.to-current {\n  --gradient-to-color: currentColor;\n}\n.to-transparent {\n  --gradient-to-color: transparent;\n}\n.to-white {\n  --gradient-to-color: #ffffff;\n}\n.to-black {\n  --gradient-to-color: #000000;\n}\n.to-gray-50 {\n  --gradient-to-color: #f9fafb;\n}\n.to-gray-100 {\n  --gradient-to-color: #f4f5f7;\n}\n.to-gray-200 {\n  --gradient-to-color: #e5e7eb;\n}\n.to-gray-300 {\n  --gradient-to-color: #d2d6dc;\n}\n.to-gray-400 {\n  --gradient-to-color: #9fa6b2;\n}\n.to-gray-500 {\n  --gradient-to-color: #6b7280;\n}\n.to-gray-600 {\n  --gradient-to-color: #4b5563;\n}\n.to-gray-700 {\n  --gradient-to-color: #374151;\n}\n.to-gray-800 {\n  --gradient-to-color: #252f3f;\n}\n.to-gray-900 {\n  --gradient-to-color: #161e2e;\n}\n.to-red-50 {\n  --gradient-to-color: #fdf2f2;\n}\n.to-red-100 {\n  --gradient-to-color: #fde8e8;\n}\n.to-red-200 {\n  --gradient-to-color: #fbd5d5;\n}\n.to-red-300 {\n  --gradient-to-color: #f8b4b4;\n}\n.to-red-400 {\n  --gradient-to-color: #f98080;\n}\n.to-red-500 {\n  --gradient-to-color: #f05252;\n}\n.to-red-600 {\n  --gradient-to-color: #e02424;\n}\n.to-red-700 {\n  --gradient-to-color: #c81e1e;\n}\n.to-red-800 {\n  --gradient-to-color: #9b1c1c;\n}\n.to-red-900 {\n  --gradient-to-color: #771d1d;\n}\n.to-orange-50 {\n  --gradient-to-color: #fff8f1;\n}\n.to-orange-100 {\n  --gradient-to-color: #feecdc;\n}\n.to-orange-200 {\n  --gradient-to-color: #fcd9bd;\n}\n.to-orange-300 {\n  --gradient-to-color: #fdba8c;\n}\n.to-orange-400 {\n  --gradient-to-color: #ff8a4c;\n}\n.to-orange-500 {\n  --gradient-to-color: #ff5a1f;\n}\n.to-orange-600 {\n  --gradient-to-color: #d03801;\n}\n.to-orange-700 {\n  --gradient-to-color: #b43403;\n}\n.to-orange-800 {\n  --gradient-to-color: #8a2c0d;\n}\n.to-orange-900 {\n  --gradient-to-color: #73230d;\n}\n.to-yellow-50 {\n  --gradient-to-color: #fdfdea;\n}\n.to-yellow-100 {\n  --gradient-to-color: #fdf6b2;\n}\n.to-yellow-200 {\n  --gradient-to-color: #fce96a;\n}\n.to-yellow-300 {\n  --gradient-to-color: #faca15;\n}\n.to-yellow-400 {\n  --gradient-to-color: #e3a008;\n}\n.to-yellow-500 {\n  --gradient-to-color: #c27803;\n}\n.to-yellow-600 {\n  --gradient-to-color: #9f580a;\n}\n.to-yellow-700 {\n  --gradient-to-color: #8e4b10;\n}\n.to-yellow-800 {\n  --gradient-to-color: #723b13;\n}\n.to-yellow-900 {\n  --gradient-to-color: #633112;\n}\n.to-green-50 {\n  --gradient-to-color: #f3faf7;\n}\n.to-green-100 {\n  --gradient-to-color: #def7ec;\n}\n.to-green-200 {\n  --gradient-to-color: #bcf0da;\n}\n.to-green-300 {\n  --gradient-to-color: #84e1bc;\n}\n.to-green-400 {\n  --gradient-to-color: #31c48d;\n}\n.to-green-500 {\n  --gradient-to-color: #0e9f6e;\n}\n.to-green-600 {\n  --gradient-to-color: #057a55;\n}\n.to-green-700 {\n  --gradient-to-color: #046c4e;\n}\n.to-green-800 {\n  --gradient-to-color: #03543f;\n}\n.to-green-900 {\n  --gradient-to-color: #014737;\n}\n.to-teal-50 {\n  --gradient-to-color: #edfafa;\n}\n.to-teal-100 {\n  --gradient-to-color: #d5f5f6;\n}\n.to-teal-200 {\n  --gradient-to-color: #afecef;\n}\n.to-teal-300 {\n  --gradient-to-color: #7edce2;\n}\n.to-teal-400 {\n  --gradient-to-color: #16bdca;\n}\n.to-teal-500 {\n  --gradient-to-color: #0694a2;\n}\n.to-teal-600 {\n  --gradient-to-color: #047481;\n}\n.to-teal-700 {\n  --gradient-to-color: #036672;\n}\n.to-teal-800 {\n  --gradient-to-color: #05505c;\n}\n.to-teal-900 {\n  --gradient-to-color: #014451;\n}\n.to-blue-50 {\n  --gradient-to-color: #ebf5ff;\n}\n.to-blue-100 {\n  --gradient-to-color: #e1effe;\n}\n.to-blue-200 {\n  --gradient-to-color: #c3ddfd;\n}\n.to-blue-300 {\n  --gradient-to-color: #a4cafe;\n}\n.to-blue-400 {\n  --gradient-to-color: #76a9fa;\n}\n.to-blue-500 {\n  --gradient-to-color: #3f83f8;\n}\n.to-blue-600 {\n  --gradient-to-color: #1c64f2;\n}\n.to-blue-700 {\n  --gradient-to-color: #1a56db;\n}\n.to-blue-800 {\n  --gradient-to-color: #1e429f;\n}\n.to-blue-900 {\n  --gradient-to-color: #233876;\n}\n.to-indigo-50 {\n  --gradient-to-color: #f0f5ff;\n}\n.to-indigo-100 {\n  --gradient-to-color: #e5edff;\n}\n.to-indigo-200 {\n  --gradient-to-color: #cddbfe;\n}\n.to-indigo-300 {\n  --gradient-to-color: #b4c6fc;\n}\n.to-indigo-400 {\n  --gradient-to-color: #8da2fb;\n}\n.to-indigo-500 {\n  --gradient-to-color: #6875f5;\n}\n.to-indigo-600 {\n  --gradient-to-color: #5850ec;\n}\n.to-indigo-700 {\n  --gradient-to-color: #5145cd;\n}\n.to-indigo-800 {\n  --gradient-to-color: #42389d;\n}\n.to-indigo-900 {\n  --gradient-to-color: #362f78;\n}\n.to-purple-50 {\n  --gradient-to-color: #f6f5ff;\n}\n.to-purple-100 {\n  --gradient-to-color: #edebfe;\n}\n.to-purple-200 {\n  --gradient-to-color: #dcd7fe;\n}\n.to-purple-300 {\n  --gradient-to-color: #cabffd;\n}\n.to-purple-400 {\n  --gradient-to-color: #ac94fa;\n}\n.to-purple-500 {\n  --gradient-to-color: #9061f9;\n}\n.to-purple-600 {\n  --gradient-to-color: #7e3af2;\n}\n.to-purple-700 {\n  --gradient-to-color: #6c2bd9;\n}\n.to-purple-800 {\n  --gradient-to-color: #5521b5;\n}\n.to-purple-900 {\n  --gradient-to-color: #4a1d96;\n}\n.to-pink-50 {\n  --gradient-to-color: #fdf2f8;\n}\n.to-pink-100 {\n  --gradient-to-color: #fce8f3;\n}\n.to-pink-200 {\n  --gradient-to-color: #fad1e8;\n}\n.to-pink-300 {\n  --gradient-to-color: #f8b4d9;\n}\n.to-pink-400 {\n  --gradient-to-color: #f17eb8;\n}\n.to-pink-500 {\n  --gradient-to-color: #e74694;\n}\n.to-pink-600 {\n  --gradient-to-color: #d61f69;\n}\n.to-pink-700 {\n  --gradient-to-color: #bf125d;\n}\n.to-pink-800 {\n  --gradient-to-color: #99154b;\n}\n.to-pink-900 {\n  --gradient-to-color: #751a3d;\n}\n.to-cool-gray-50 {\n  --gradient-to-color: #f8fafc;\n}\n.to-cool-gray-100 {\n  --gradient-to-color: #f1f5f9;\n}\n.to-cool-gray-200 {\n  --gradient-to-color: #e2e8f0;\n}\n.to-cool-gray-300 {\n  --gradient-to-color: #cfd8e3;\n}\n.to-cool-gray-400 {\n  --gradient-to-color: #97a6ba;\n}\n.to-cool-gray-500 {\n  --gradient-to-color: #64748b;\n}\n.to-cool-gray-600 {\n  --gradient-to-color: #475569;\n}\n.to-cool-gray-700 {\n  --gradient-to-color: #364152;\n}\n.to-cool-gray-800 {\n  --gradient-to-color: #27303f;\n}\n.to-cool-gray-900 {\n  --gradient-to-color: #1a202e;\n}\n.hover\\:from-current:hover {\n  --gradient-from-color: currentColor;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));\n}\n.hover\\:from-transparent:hover {\n  --gradient-from-color: transparent;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0));\n}\n.hover\\:from-white:hover {\n  --gradient-from-color: #ffffff;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));\n}\n.hover\\:from-black:hover {\n  --gradient-from-color: #000000;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0));\n}\n.hover\\:from-gray-50:hover {\n  --gradient-from-color: #f9fafb;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(249, 250, 251, 0));\n}\n.hover\\:from-gray-100:hover {\n  --gradient-from-color: #f4f5f7;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(244, 245, 247, 0));\n}\n.hover\\:from-gray-200:hover {\n  --gradient-from-color: #e5e7eb;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(229, 231, 235, 0));\n}\n.hover\\:from-gray-300:hover {\n  --gradient-from-color: #d2d6dc;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(210, 214, 220, 0));\n}\n.hover\\:from-gray-400:hover {\n  --gradient-from-color: #9fa6b2;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(159, 166, 178, 0));\n}\n.hover\\:from-gray-500:hover {\n  --gradient-from-color: #6b7280;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(107, 114, 128, 0));\n}\n.hover\\:from-gray-600:hover {\n  --gradient-from-color: #4b5563;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(75, 85, 99, 0));\n}\n.hover\\:from-gray-700:hover {\n  --gradient-from-color: #374151;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(55, 65, 81, 0));\n}\n.hover\\:from-gray-800:hover {\n  --gradient-from-color: #252f3f;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(37, 47, 63, 0));\n}\n.hover\\:from-gray-900:hover {\n  --gradient-from-color: #161e2e;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(22, 30, 46, 0));\n}\n.hover\\:from-red-50:hover {\n  --gradient-from-color: #fdf2f2;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 242, 242, 0));\n}\n.hover\\:from-red-100:hover {\n  --gradient-from-color: #fde8e8;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 232, 232, 0));\n}\n.hover\\:from-red-200:hover {\n  --gradient-from-color: #fbd5d5;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(251, 213, 213, 0));\n}\n.hover\\:from-red-300:hover {\n  --gradient-from-color: #f8b4b4;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(248, 180, 180, 0));\n}\n.hover\\:from-red-400:hover {\n  --gradient-from-color: #f98080;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(249, 128, 128, 0));\n}\n.hover\\:from-red-500:hover {\n  --gradient-from-color: #f05252;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(240, 82, 82, 0));\n}\n.hover\\:from-red-600:hover {\n  --gradient-from-color: #e02424;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(224, 36, 36, 0));\n}\n.hover\\:from-red-700:hover {\n  --gradient-from-color: #c81e1e;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(200, 30, 30, 0));\n}\n.hover\\:from-red-800:hover {\n  --gradient-from-color: #9b1c1c;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(155, 28, 28, 0));\n}\n.hover\\:from-red-900:hover {\n  --gradient-from-color: #771d1d;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(119, 29, 29, 0));\n}\n.hover\\:from-orange-50:hover {\n  --gradient-from-color: #fff8f1;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 248, 241, 0));\n}\n.hover\\:from-orange-100:hover {\n  --gradient-from-color: #feecdc;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 236, 220, 0));\n}\n.hover\\:from-orange-200:hover {\n  --gradient-from-color: #fcd9bd;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(252, 217, 189, 0));\n}\n.hover\\:from-orange-300:hover {\n  --gradient-from-color: #fdba8c;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 186, 140, 0));\n}\n.hover\\:from-orange-400:hover {\n  --gradient-from-color: #ff8a4c;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 138, 76, 0));\n}\n.hover\\:from-orange-500:hover {\n  --gradient-from-color: #ff5a1f;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 90, 31, 0));\n}\n.hover\\:from-orange-600:hover {\n  --gradient-from-color: #d03801;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(208, 56, 1, 0));\n}\n.hover\\:from-orange-700:hover {\n  --gradient-from-color: #b43403;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(180, 52, 3, 0));\n}\n.hover\\:from-orange-800:hover {\n  --gradient-from-color: #8a2c0d;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(138, 44, 13, 0));\n}\n.hover\\:from-orange-900:hover {\n  --gradient-from-color: #73230d;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(115, 35, 13, 0));\n}\n.hover\\:from-yellow-50:hover {\n  --gradient-from-color: #fdfdea;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 253, 234, 0));\n}\n.hover\\:from-yellow-100:hover {\n  --gradient-from-color: #fdf6b2;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 246, 178, 0));\n}\n.hover\\:from-yellow-200:hover {\n  --gradient-from-color: #fce96a;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(252, 233, 106, 0));\n}\n.hover\\:from-yellow-300:hover {\n  --gradient-from-color: #faca15;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(250, 202, 21, 0));\n}\n.hover\\:from-yellow-400:hover {\n  --gradient-from-color: #e3a008;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(227, 160, 8, 0));\n}\n.hover\\:from-yellow-500:hover {\n  --gradient-from-color: #c27803;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(194, 120, 3, 0));\n}\n.hover\\:from-yellow-600:hover {\n  --gradient-from-color: #9f580a;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(159, 88, 10, 0));\n}\n.hover\\:from-yellow-700:hover {\n  --gradient-from-color: #8e4b10;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(142, 75, 16, 0));\n}\n.hover\\:from-yellow-800:hover {\n  --gradient-from-color: #723b13;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(114, 59, 19, 0));\n}\n.hover\\:from-yellow-900:hover {\n  --gradient-from-color: #633112;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(99, 49, 18, 0));\n}\n.hover\\:from-green-50:hover {\n  --gradient-from-color: #f3faf7;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(243, 250, 247, 0));\n}\n.hover\\:from-green-100:hover {\n  --gradient-from-color: #def7ec;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(222, 247, 236, 0));\n}\n.hover\\:from-green-200:hover {\n  --gradient-from-color: #bcf0da;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(188, 240, 218, 0));\n}\n.hover\\:from-green-300:hover {\n  --gradient-from-color: #84e1bc;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(132, 225, 188, 0));\n}\n.hover\\:from-green-400:hover {\n  --gradient-from-color: #31c48d;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(49, 196, 141, 0));\n}\n.hover\\:from-green-500:hover {\n  --gradient-from-color: #0e9f6e;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(14, 159, 110, 0));\n}\n.hover\\:from-green-600:hover {\n  --gradient-from-color: #057a55;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(5, 122, 85, 0));\n}\n.hover\\:from-green-700:hover {\n  --gradient-from-color: #046c4e;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(4, 108, 78, 0));\n}\n.hover\\:from-green-800:hover {\n  --gradient-from-color: #03543f;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(3, 84, 63, 0));\n}\n.hover\\:from-green-900:hover {\n  --gradient-from-color: #014737;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(1, 71, 55, 0));\n}\n.hover\\:from-teal-50:hover {\n  --gradient-from-color: #edfafa;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(237, 250, 250, 0));\n}\n.hover\\:from-teal-100:hover {\n  --gradient-from-color: #d5f5f6;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(213, 245, 246, 0));\n}\n.hover\\:from-teal-200:hover {\n  --gradient-from-color: #afecef;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(175, 236, 239, 0));\n}\n.hover\\:from-teal-300:hover {\n  --gradient-from-color: #7edce2;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(126, 220, 226, 0));\n}\n.hover\\:from-teal-400:hover {\n  --gradient-from-color: #16bdca;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(22, 189, 202, 0));\n}\n.hover\\:from-teal-500:hover {\n  --gradient-from-color: #0694a2;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(6, 148, 162, 0));\n}\n.hover\\:from-teal-600:hover {\n  --gradient-from-color: #047481;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(4, 116, 129, 0));\n}\n.hover\\:from-teal-700:hover {\n  --gradient-from-color: #036672;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(3, 102, 114, 0));\n}\n.hover\\:from-teal-800:hover {\n  --gradient-from-color: #05505c;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(5, 80, 92, 0));\n}\n.hover\\:from-teal-900:hover {\n  --gradient-from-color: #014451;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(1, 68, 81, 0));\n}\n.hover\\:from-blue-50:hover {\n  --gradient-from-color: #ebf5ff;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(235, 245, 255, 0));\n}\n.hover\\:from-blue-100:hover {\n  --gradient-from-color: #e1effe;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(225, 239, 254, 0));\n}\n.hover\\:from-blue-200:hover {\n  --gradient-from-color: #c3ddfd;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(195, 221, 253, 0));\n}\n.hover\\:from-blue-300:hover {\n  --gradient-from-color: #a4cafe;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(164, 202, 254, 0));\n}\n.hover\\:from-blue-400:hover {\n  --gradient-from-color: #76a9fa;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(118, 169, 250, 0));\n}\n.hover\\:from-blue-500:hover {\n  --gradient-from-color: #3f83f8;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(63, 131, 248, 0));\n}\n.hover\\:from-blue-600:hover {\n  --gradient-from-color: #1c64f2;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(28, 100, 242, 0));\n}\n.hover\\:from-blue-700:hover {\n  --gradient-from-color: #1a56db;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(26, 86, 219, 0));\n}\n.hover\\:from-blue-800:hover {\n  --gradient-from-color: #1e429f;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(30, 66, 159, 0));\n}\n.hover\\:from-blue-900:hover {\n  --gradient-from-color: #233876;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(35, 56, 118, 0));\n}\n.hover\\:from-indigo-50:hover {\n  --gradient-from-color: #f0f5ff;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(240, 245, 255, 0));\n}\n.hover\\:from-indigo-100:hover {\n  --gradient-from-color: #e5edff;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(229, 237, 255, 0));\n}\n.hover\\:from-indigo-200:hover {\n  --gradient-from-color: #cddbfe;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(205, 219, 254, 0));\n}\n.hover\\:from-indigo-300:hover {\n  --gradient-from-color: #b4c6fc;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(180, 198, 252, 0));\n}\n.hover\\:from-indigo-400:hover {\n  --gradient-from-color: #8da2fb;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(141, 162, 251, 0));\n}\n.hover\\:from-indigo-500:hover {\n  --gradient-from-color: #6875f5;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(104, 117, 245, 0));\n}\n.hover\\:from-indigo-600:hover {\n  --gradient-from-color: #5850ec;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(88, 80, 236, 0));\n}\n.hover\\:from-indigo-700:hover {\n  --gradient-from-color: #5145cd;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(81, 69, 205, 0));\n}\n.hover\\:from-indigo-800:hover {\n  --gradient-from-color: #42389d;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(66, 56, 157, 0));\n}\n.hover\\:from-indigo-900:hover {\n  --gradient-from-color: #362f78;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(54, 47, 120, 0));\n}\n.hover\\:from-purple-50:hover {\n  --gradient-from-color: #f6f5ff;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(246, 245, 255, 0));\n}\n.hover\\:from-purple-100:hover {\n  --gradient-from-color: #edebfe;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(237, 235, 254, 0));\n}\n.hover\\:from-purple-200:hover {\n  --gradient-from-color: #dcd7fe;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(220, 215, 254, 0));\n}\n.hover\\:from-purple-300:hover {\n  --gradient-from-color: #cabffd;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(202, 191, 253, 0));\n}\n.hover\\:from-purple-400:hover {\n  --gradient-from-color: #ac94fa;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(172, 148, 250, 0));\n}\n.hover\\:from-purple-500:hover {\n  --gradient-from-color: #9061f9;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(144, 97, 249, 0));\n}\n.hover\\:from-purple-600:hover {\n  --gradient-from-color: #7e3af2;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(126, 58, 242, 0));\n}\n.hover\\:from-purple-700:hover {\n  --gradient-from-color: #6c2bd9;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(108, 43, 217, 0));\n}\n.hover\\:from-purple-800:hover {\n  --gradient-from-color: #5521b5;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(85, 33, 181, 0));\n}\n.hover\\:from-purple-900:hover {\n  --gradient-from-color: #4a1d96;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(74, 29, 150, 0));\n}\n.hover\\:from-pink-50:hover {\n  --gradient-from-color: #fdf2f8;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 242, 248, 0));\n}\n.hover\\:from-pink-100:hover {\n  --gradient-from-color: #fce8f3;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(252, 232, 243, 0));\n}\n.hover\\:from-pink-200:hover {\n  --gradient-from-color: #fad1e8;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(250, 209, 232, 0));\n}\n.hover\\:from-pink-300:hover {\n  --gradient-from-color: #f8b4d9;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(248, 180, 217, 0));\n}\n.hover\\:from-pink-400:hover {\n  --gradient-from-color: #f17eb8;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(241, 126, 184, 0));\n}\n.hover\\:from-pink-500:hover {\n  --gradient-from-color: #e74694;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(231, 70, 148, 0));\n}\n.hover\\:from-pink-600:hover {\n  --gradient-from-color: #d61f69;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(214, 31, 105, 0));\n}\n.hover\\:from-pink-700:hover {\n  --gradient-from-color: #bf125d;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(191, 18, 93, 0));\n}\n.hover\\:from-pink-800:hover {\n  --gradient-from-color: #99154b;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(153, 21, 75, 0));\n}\n.hover\\:from-pink-900:hover {\n  --gradient-from-color: #751a3d;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(117, 26, 61, 0));\n}\n.hover\\:from-cool-gray-50:hover {\n  --gradient-from-color: #f8fafc;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(248, 250, 252, 0));\n}\n.hover\\:from-cool-gray-100:hover {\n  --gradient-from-color: #f1f5f9;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(241, 245, 249, 0));\n}\n.hover\\:from-cool-gray-200:hover {\n  --gradient-from-color: #e2e8f0;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(226, 232, 240, 0));\n}\n.hover\\:from-cool-gray-300:hover {\n  --gradient-from-color: #cfd8e3;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(207, 216, 227, 0));\n}\n.hover\\:from-cool-gray-400:hover {\n  --gradient-from-color: #97a6ba;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(151, 166, 186, 0));\n}\n.hover\\:from-cool-gray-500:hover {\n  --gradient-from-color: #64748b;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(100, 116, 139, 0));\n}\n.hover\\:from-cool-gray-600:hover {\n  --gradient-from-color: #475569;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(71, 85, 105, 0));\n}\n.hover\\:from-cool-gray-700:hover {\n  --gradient-from-color: #364152;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(54, 65, 82, 0));\n}\n.hover\\:from-cool-gray-800:hover {\n  --gradient-from-color: #27303f;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(39, 48, 63, 0));\n}\n.hover\\:from-cool-gray-900:hover {\n  --gradient-from-color: #1a202e;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(26, 32, 46, 0));\n}\n.hover\\:via-current:hover {\n  --gradient-via-color: currentColor;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));\n}\n.hover\\:via-transparent:hover {\n  --gradient-via-color: transparent;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0));\n}\n.hover\\:via-white:hover {\n  --gradient-via-color: #ffffff;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));\n}\n.hover\\:via-black:hover {\n  --gradient-via-color: #000000;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0));\n}\n.hover\\:via-gray-50:hover {\n  --gradient-via-color: #f9fafb;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(249, 250, 251, 0));\n}\n.hover\\:via-gray-100:hover {\n  --gradient-via-color: #f4f5f7;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(244, 245, 247, 0));\n}\n.hover\\:via-gray-200:hover {\n  --gradient-via-color: #e5e7eb;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(229, 231, 235, 0));\n}\n.hover\\:via-gray-300:hover {\n  --gradient-via-color: #d2d6dc;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(210, 214, 220, 0));\n}\n.hover\\:via-gray-400:hover {\n  --gradient-via-color: #9fa6b2;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(159, 166, 178, 0));\n}\n.hover\\:via-gray-500:hover {\n  --gradient-via-color: #6b7280;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(107, 114, 128, 0));\n}\n.hover\\:via-gray-600:hover {\n  --gradient-via-color: #4b5563;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(75, 85, 99, 0));\n}\n.hover\\:via-gray-700:hover {\n  --gradient-via-color: #374151;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(55, 65, 81, 0));\n}\n.hover\\:via-gray-800:hover {\n  --gradient-via-color: #252f3f;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(37, 47, 63, 0));\n}\n.hover\\:via-gray-900:hover {\n  --gradient-via-color: #161e2e;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(22, 30, 46, 0));\n}\n.hover\\:via-red-50:hover {\n  --gradient-via-color: #fdf2f2;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 242, 242, 0));\n}\n.hover\\:via-red-100:hover {\n  --gradient-via-color: #fde8e8;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 232, 232, 0));\n}\n.hover\\:via-red-200:hover {\n  --gradient-via-color: #fbd5d5;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(251, 213, 213, 0));\n}\n.hover\\:via-red-300:hover {\n  --gradient-via-color: #f8b4b4;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(248, 180, 180, 0));\n}\n.hover\\:via-red-400:hover {\n  --gradient-via-color: #f98080;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(249, 128, 128, 0));\n}\n.hover\\:via-red-500:hover {\n  --gradient-via-color: #f05252;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(240, 82, 82, 0));\n}\n.hover\\:via-red-600:hover {\n  --gradient-via-color: #e02424;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(224, 36, 36, 0));\n}\n.hover\\:via-red-700:hover {\n  --gradient-via-color: #c81e1e;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(200, 30, 30, 0));\n}\n.hover\\:via-red-800:hover {\n  --gradient-via-color: #9b1c1c;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(155, 28, 28, 0));\n}\n.hover\\:via-red-900:hover {\n  --gradient-via-color: #771d1d;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(119, 29, 29, 0));\n}\n.hover\\:via-orange-50:hover {\n  --gradient-via-color: #fff8f1;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 248, 241, 0));\n}\n.hover\\:via-orange-100:hover {\n  --gradient-via-color: #feecdc;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 236, 220, 0));\n}\n.hover\\:via-orange-200:hover {\n  --gradient-via-color: #fcd9bd;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(252, 217, 189, 0));\n}\n.hover\\:via-orange-300:hover {\n  --gradient-via-color: #fdba8c;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 186, 140, 0));\n}\n.hover\\:via-orange-400:hover {\n  --gradient-via-color: #ff8a4c;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 138, 76, 0));\n}\n.hover\\:via-orange-500:hover {\n  --gradient-via-color: #ff5a1f;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 90, 31, 0));\n}\n.hover\\:via-orange-600:hover {\n  --gradient-via-color: #d03801;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(208, 56, 1, 0));\n}\n.hover\\:via-orange-700:hover {\n  --gradient-via-color: #b43403;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(180, 52, 3, 0));\n}\n.hover\\:via-orange-800:hover {\n  --gradient-via-color: #8a2c0d;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(138, 44, 13, 0));\n}\n.hover\\:via-orange-900:hover {\n  --gradient-via-color: #73230d;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(115, 35, 13, 0));\n}\n.hover\\:via-yellow-50:hover {\n  --gradient-via-color: #fdfdea;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 253, 234, 0));\n}\n.hover\\:via-yellow-100:hover {\n  --gradient-via-color: #fdf6b2;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 246, 178, 0));\n}\n.hover\\:via-yellow-200:hover {\n  --gradient-via-color: #fce96a;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(252, 233, 106, 0));\n}\n.hover\\:via-yellow-300:hover {\n  --gradient-via-color: #faca15;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(250, 202, 21, 0));\n}\n.hover\\:via-yellow-400:hover {\n  --gradient-via-color: #e3a008;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(227, 160, 8, 0));\n}\n.hover\\:via-yellow-500:hover {\n  --gradient-via-color: #c27803;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(194, 120, 3, 0));\n}\n.hover\\:via-yellow-600:hover {\n  --gradient-via-color: #9f580a;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(159, 88, 10, 0));\n}\n.hover\\:via-yellow-700:hover {\n  --gradient-via-color: #8e4b10;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(142, 75, 16, 0));\n}\n.hover\\:via-yellow-800:hover {\n  --gradient-via-color: #723b13;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(114, 59, 19, 0));\n}\n.hover\\:via-yellow-900:hover {\n  --gradient-via-color: #633112;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(99, 49, 18, 0));\n}\n.hover\\:via-green-50:hover {\n  --gradient-via-color: #f3faf7;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(243, 250, 247, 0));\n}\n.hover\\:via-green-100:hover {\n  --gradient-via-color: #def7ec;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(222, 247, 236, 0));\n}\n.hover\\:via-green-200:hover {\n  --gradient-via-color: #bcf0da;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(188, 240, 218, 0));\n}\n.hover\\:via-green-300:hover {\n  --gradient-via-color: #84e1bc;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(132, 225, 188, 0));\n}\n.hover\\:via-green-400:hover {\n  --gradient-via-color: #31c48d;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(49, 196, 141, 0));\n}\n.hover\\:via-green-500:hover {\n  --gradient-via-color: #0e9f6e;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(14, 159, 110, 0));\n}\n.hover\\:via-green-600:hover {\n  --gradient-via-color: #057a55;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(5, 122, 85, 0));\n}\n.hover\\:via-green-700:hover {\n  --gradient-via-color: #046c4e;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(4, 108, 78, 0));\n}\n.hover\\:via-green-800:hover {\n  --gradient-via-color: #03543f;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(3, 84, 63, 0));\n}\n.hover\\:via-green-900:hover {\n  --gradient-via-color: #014737;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(1, 71, 55, 0));\n}\n.hover\\:via-teal-50:hover {\n  --gradient-via-color: #edfafa;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(237, 250, 250, 0));\n}\n.hover\\:via-teal-100:hover {\n  --gradient-via-color: #d5f5f6;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(213, 245, 246, 0));\n}\n.hover\\:via-teal-200:hover {\n  --gradient-via-color: #afecef;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(175, 236, 239, 0));\n}\n.hover\\:via-teal-300:hover {\n  --gradient-via-color: #7edce2;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(126, 220, 226, 0));\n}\n.hover\\:via-teal-400:hover {\n  --gradient-via-color: #16bdca;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(22, 189, 202, 0));\n}\n.hover\\:via-teal-500:hover {\n  --gradient-via-color: #0694a2;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(6, 148, 162, 0));\n}\n.hover\\:via-teal-600:hover {\n  --gradient-via-color: #047481;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(4, 116, 129, 0));\n}\n.hover\\:via-teal-700:hover {\n  --gradient-via-color: #036672;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(3, 102, 114, 0));\n}\n.hover\\:via-teal-800:hover {\n  --gradient-via-color: #05505c;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(5, 80, 92, 0));\n}\n.hover\\:via-teal-900:hover {\n  --gradient-via-color: #014451;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(1, 68, 81, 0));\n}\n.hover\\:via-blue-50:hover {\n  --gradient-via-color: #ebf5ff;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(235, 245, 255, 0));\n}\n.hover\\:via-blue-100:hover {\n  --gradient-via-color: #e1effe;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(225, 239, 254, 0));\n}\n.hover\\:via-blue-200:hover {\n  --gradient-via-color: #c3ddfd;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(195, 221, 253, 0));\n}\n.hover\\:via-blue-300:hover {\n  --gradient-via-color: #a4cafe;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(164, 202, 254, 0));\n}\n.hover\\:via-blue-400:hover {\n  --gradient-via-color: #76a9fa;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(118, 169, 250, 0));\n}\n.hover\\:via-blue-500:hover {\n  --gradient-via-color: #3f83f8;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(63, 131, 248, 0));\n}\n.hover\\:via-blue-600:hover {\n  --gradient-via-color: #1c64f2;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(28, 100, 242, 0));\n}\n.hover\\:via-blue-700:hover {\n  --gradient-via-color: #1a56db;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(26, 86, 219, 0));\n}\n.hover\\:via-blue-800:hover {\n  --gradient-via-color: #1e429f;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(30, 66, 159, 0));\n}\n.hover\\:via-blue-900:hover {\n  --gradient-via-color: #233876;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(35, 56, 118, 0));\n}\n.hover\\:via-indigo-50:hover {\n  --gradient-via-color: #f0f5ff;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(240, 245, 255, 0));\n}\n.hover\\:via-indigo-100:hover {\n  --gradient-via-color: #e5edff;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(229, 237, 255, 0));\n}\n.hover\\:via-indigo-200:hover {\n  --gradient-via-color: #cddbfe;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(205, 219, 254, 0));\n}\n.hover\\:via-indigo-300:hover {\n  --gradient-via-color: #b4c6fc;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(180, 198, 252, 0));\n}\n.hover\\:via-indigo-400:hover {\n  --gradient-via-color: #8da2fb;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(141, 162, 251, 0));\n}\n.hover\\:via-indigo-500:hover {\n  --gradient-via-color: #6875f5;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(104, 117, 245, 0));\n}\n.hover\\:via-indigo-600:hover {\n  --gradient-via-color: #5850ec;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(88, 80, 236, 0));\n}\n.hover\\:via-indigo-700:hover {\n  --gradient-via-color: #5145cd;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(81, 69, 205, 0));\n}\n.hover\\:via-indigo-800:hover {\n  --gradient-via-color: #42389d;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(66, 56, 157, 0));\n}\n.hover\\:via-indigo-900:hover {\n  --gradient-via-color: #362f78;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(54, 47, 120, 0));\n}\n.hover\\:via-purple-50:hover {\n  --gradient-via-color: #f6f5ff;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(246, 245, 255, 0));\n}\n.hover\\:via-purple-100:hover {\n  --gradient-via-color: #edebfe;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(237, 235, 254, 0));\n}\n.hover\\:via-purple-200:hover {\n  --gradient-via-color: #dcd7fe;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(220, 215, 254, 0));\n}\n.hover\\:via-purple-300:hover {\n  --gradient-via-color: #cabffd;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(202, 191, 253, 0));\n}\n.hover\\:via-purple-400:hover {\n  --gradient-via-color: #ac94fa;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(172, 148, 250, 0));\n}\n.hover\\:via-purple-500:hover {\n  --gradient-via-color: #9061f9;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(144, 97, 249, 0));\n}\n.hover\\:via-purple-600:hover {\n  --gradient-via-color: #7e3af2;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(126, 58, 242, 0));\n}\n.hover\\:via-purple-700:hover {\n  --gradient-via-color: #6c2bd9;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(108, 43, 217, 0));\n}\n.hover\\:via-purple-800:hover {\n  --gradient-via-color: #5521b5;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(85, 33, 181, 0));\n}\n.hover\\:via-purple-900:hover {\n  --gradient-via-color: #4a1d96;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(74, 29, 150, 0));\n}\n.hover\\:via-pink-50:hover {\n  --gradient-via-color: #fdf2f8;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 242, 248, 0));\n}\n.hover\\:via-pink-100:hover {\n  --gradient-via-color: #fce8f3;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(252, 232, 243, 0));\n}\n.hover\\:via-pink-200:hover {\n  --gradient-via-color: #fad1e8;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(250, 209, 232, 0));\n}\n.hover\\:via-pink-300:hover {\n  --gradient-via-color: #f8b4d9;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(248, 180, 217, 0));\n}\n.hover\\:via-pink-400:hover {\n  --gradient-via-color: #f17eb8;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(241, 126, 184, 0));\n}\n.hover\\:via-pink-500:hover {\n  --gradient-via-color: #e74694;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(231, 70, 148, 0));\n}\n.hover\\:via-pink-600:hover {\n  --gradient-via-color: #d61f69;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(214, 31, 105, 0));\n}\n.hover\\:via-pink-700:hover {\n  --gradient-via-color: #bf125d;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(191, 18, 93, 0));\n}\n.hover\\:via-pink-800:hover {\n  --gradient-via-color: #99154b;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(153, 21, 75, 0));\n}\n.hover\\:via-pink-900:hover {\n  --gradient-via-color: #751a3d;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(117, 26, 61, 0));\n}\n.hover\\:via-cool-gray-50:hover {\n  --gradient-via-color: #f8fafc;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(248, 250, 252, 0));\n}\n.hover\\:via-cool-gray-100:hover {\n  --gradient-via-color: #f1f5f9;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(241, 245, 249, 0));\n}\n.hover\\:via-cool-gray-200:hover {\n  --gradient-via-color: #e2e8f0;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(226, 232, 240, 0));\n}\n.hover\\:via-cool-gray-300:hover {\n  --gradient-via-color: #cfd8e3;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(207, 216, 227, 0));\n}\n.hover\\:via-cool-gray-400:hover {\n  --gradient-via-color: #97a6ba;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(151, 166, 186, 0));\n}\n.hover\\:via-cool-gray-500:hover {\n  --gradient-via-color: #64748b;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(100, 116, 139, 0));\n}\n.hover\\:via-cool-gray-600:hover {\n  --gradient-via-color: #475569;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(71, 85, 105, 0));\n}\n.hover\\:via-cool-gray-700:hover {\n  --gradient-via-color: #364152;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(54, 65, 82, 0));\n}\n.hover\\:via-cool-gray-800:hover {\n  --gradient-via-color: #27303f;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(39, 48, 63, 0));\n}\n.hover\\:via-cool-gray-900:hover {\n  --gradient-via-color: #1a202e;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(26, 32, 46, 0));\n}\n.hover\\:to-current:hover {\n  --gradient-to-color: currentColor;\n}\n.hover\\:to-transparent:hover {\n  --gradient-to-color: transparent;\n}\n.hover\\:to-white:hover {\n  --gradient-to-color: #ffffff;\n}\n.hover\\:to-black:hover {\n  --gradient-to-color: #000000;\n}\n.hover\\:to-gray-50:hover {\n  --gradient-to-color: #f9fafb;\n}\n.hover\\:to-gray-100:hover {\n  --gradient-to-color: #f4f5f7;\n}\n.hover\\:to-gray-200:hover {\n  --gradient-to-color: #e5e7eb;\n}\n.hover\\:to-gray-300:hover {\n  --gradient-to-color: #d2d6dc;\n}\n.hover\\:to-gray-400:hover {\n  --gradient-to-color: #9fa6b2;\n}\n.hover\\:to-gray-500:hover {\n  --gradient-to-color: #6b7280;\n}\n.hover\\:to-gray-600:hover {\n  --gradient-to-color: #4b5563;\n}\n.hover\\:to-gray-700:hover {\n  --gradient-to-color: #374151;\n}\n.hover\\:to-gray-800:hover {\n  --gradient-to-color: #252f3f;\n}\n.hover\\:to-gray-900:hover {\n  --gradient-to-color: #161e2e;\n}\n.hover\\:to-red-50:hover {\n  --gradient-to-color: #fdf2f2;\n}\n.hover\\:to-red-100:hover {\n  --gradient-to-color: #fde8e8;\n}\n.hover\\:to-red-200:hover {\n  --gradient-to-color: #fbd5d5;\n}\n.hover\\:to-red-300:hover {\n  --gradient-to-color: #f8b4b4;\n}\n.hover\\:to-red-400:hover {\n  --gradient-to-color: #f98080;\n}\n.hover\\:to-red-500:hover {\n  --gradient-to-color: #f05252;\n}\n.hover\\:to-red-600:hover {\n  --gradient-to-color: #e02424;\n}\n.hover\\:to-red-700:hover {\n  --gradient-to-color: #c81e1e;\n}\n.hover\\:to-red-800:hover {\n  --gradient-to-color: #9b1c1c;\n}\n.hover\\:to-red-900:hover {\n  --gradient-to-color: #771d1d;\n}\n.hover\\:to-orange-50:hover {\n  --gradient-to-color: #fff8f1;\n}\n.hover\\:to-orange-100:hover {\n  --gradient-to-color: #feecdc;\n}\n.hover\\:to-orange-200:hover {\n  --gradient-to-color: #fcd9bd;\n}\n.hover\\:to-orange-300:hover {\n  --gradient-to-color: #fdba8c;\n}\n.hover\\:to-orange-400:hover {\n  --gradient-to-color: #ff8a4c;\n}\n.hover\\:to-orange-500:hover {\n  --gradient-to-color: #ff5a1f;\n}\n.hover\\:to-orange-600:hover {\n  --gradient-to-color: #d03801;\n}\n.hover\\:to-orange-700:hover {\n  --gradient-to-color: #b43403;\n}\n.hover\\:to-orange-800:hover {\n  --gradient-to-color: #8a2c0d;\n}\n.hover\\:to-orange-900:hover {\n  --gradient-to-color: #73230d;\n}\n.hover\\:to-yellow-50:hover {\n  --gradient-to-color: #fdfdea;\n}\n.hover\\:to-yellow-100:hover {\n  --gradient-to-color: #fdf6b2;\n}\n.hover\\:to-yellow-200:hover {\n  --gradient-to-color: #fce96a;\n}\n.hover\\:to-yellow-300:hover {\n  --gradient-to-color: #faca15;\n}\n.hover\\:to-yellow-400:hover {\n  --gradient-to-color: #e3a008;\n}\n.hover\\:to-yellow-500:hover {\n  --gradient-to-color: #c27803;\n}\n.hover\\:to-yellow-600:hover {\n  --gradient-to-color: #9f580a;\n}\n.hover\\:to-yellow-700:hover {\n  --gradient-to-color: #8e4b10;\n}\n.hover\\:to-yellow-800:hover {\n  --gradient-to-color: #723b13;\n}\n.hover\\:to-yellow-900:hover {\n  --gradient-to-color: #633112;\n}\n.hover\\:to-green-50:hover {\n  --gradient-to-color: #f3faf7;\n}\n.hover\\:to-green-100:hover {\n  --gradient-to-color: #def7ec;\n}\n.hover\\:to-green-200:hover {\n  --gradient-to-color: #bcf0da;\n}\n.hover\\:to-green-300:hover {\n  --gradient-to-color: #84e1bc;\n}\n.hover\\:to-green-400:hover {\n  --gradient-to-color: #31c48d;\n}\n.hover\\:to-green-500:hover {\n  --gradient-to-color: #0e9f6e;\n}\n.hover\\:to-green-600:hover {\n  --gradient-to-color: #057a55;\n}\n.hover\\:to-green-700:hover {\n  --gradient-to-color: #046c4e;\n}\n.hover\\:to-green-800:hover {\n  --gradient-to-color: #03543f;\n}\n.hover\\:to-green-900:hover {\n  --gradient-to-color: #014737;\n}\n.hover\\:to-teal-50:hover {\n  --gradient-to-color: #edfafa;\n}\n.hover\\:to-teal-100:hover {\n  --gradient-to-color: #d5f5f6;\n}\n.hover\\:to-teal-200:hover {\n  --gradient-to-color: #afecef;\n}\n.hover\\:to-teal-300:hover {\n  --gradient-to-color: #7edce2;\n}\n.hover\\:to-teal-400:hover {\n  --gradient-to-color: #16bdca;\n}\n.hover\\:to-teal-500:hover {\n  --gradient-to-color: #0694a2;\n}\n.hover\\:to-teal-600:hover {\n  --gradient-to-color: #047481;\n}\n.hover\\:to-teal-700:hover {\n  --gradient-to-color: #036672;\n}\n.hover\\:to-teal-800:hover {\n  --gradient-to-color: #05505c;\n}\n.hover\\:to-teal-900:hover {\n  --gradient-to-color: #014451;\n}\n.hover\\:to-blue-50:hover {\n  --gradient-to-color: #ebf5ff;\n}\n.hover\\:to-blue-100:hover {\n  --gradient-to-color: #e1effe;\n}\n.hover\\:to-blue-200:hover {\n  --gradient-to-color: #c3ddfd;\n}\n.hover\\:to-blue-300:hover {\n  --gradient-to-color: #a4cafe;\n}\n.hover\\:to-blue-400:hover {\n  --gradient-to-color: #76a9fa;\n}\n.hover\\:to-blue-500:hover {\n  --gradient-to-color: #3f83f8;\n}\n.hover\\:to-blue-600:hover {\n  --gradient-to-color: #1c64f2;\n}\n.hover\\:to-blue-700:hover {\n  --gradient-to-color: #1a56db;\n}\n.hover\\:to-blue-800:hover {\n  --gradient-to-color: #1e429f;\n}\n.hover\\:to-blue-900:hover {\n  --gradient-to-color: #233876;\n}\n.hover\\:to-indigo-50:hover {\n  --gradient-to-color: #f0f5ff;\n}\n.hover\\:to-indigo-100:hover {\n  --gradient-to-color: #e5edff;\n}\n.hover\\:to-indigo-200:hover {\n  --gradient-to-color: #cddbfe;\n}\n.hover\\:to-indigo-300:hover {\n  --gradient-to-color: #b4c6fc;\n}\n.hover\\:to-indigo-400:hover {\n  --gradient-to-color: #8da2fb;\n}\n.hover\\:to-indigo-500:hover {\n  --gradient-to-color: #6875f5;\n}\n.hover\\:to-indigo-600:hover {\n  --gradient-to-color: #5850ec;\n}\n.hover\\:to-indigo-700:hover {\n  --gradient-to-color: #5145cd;\n}\n.hover\\:to-indigo-800:hover {\n  --gradient-to-color: #42389d;\n}\n.hover\\:to-indigo-900:hover {\n  --gradient-to-color: #362f78;\n}\n.hover\\:to-purple-50:hover {\n  --gradient-to-color: #f6f5ff;\n}\n.hover\\:to-purple-100:hover {\n  --gradient-to-color: #edebfe;\n}\n.hover\\:to-purple-200:hover {\n  --gradient-to-color: #dcd7fe;\n}\n.hover\\:to-purple-300:hover {\n  --gradient-to-color: #cabffd;\n}\n.hover\\:to-purple-400:hover {\n  --gradient-to-color: #ac94fa;\n}\n.hover\\:to-purple-500:hover {\n  --gradient-to-color: #9061f9;\n}\n.hover\\:to-purple-600:hover {\n  --gradient-to-color: #7e3af2;\n}\n.hover\\:to-purple-700:hover {\n  --gradient-to-color: #6c2bd9;\n}\n.hover\\:to-purple-800:hover {\n  --gradient-to-color: #5521b5;\n}\n.hover\\:to-purple-900:hover {\n  --gradient-to-color: #4a1d96;\n}\n.hover\\:to-pink-50:hover {\n  --gradient-to-color: #fdf2f8;\n}\n.hover\\:to-pink-100:hover {\n  --gradient-to-color: #fce8f3;\n}\n.hover\\:to-pink-200:hover {\n  --gradient-to-color: #fad1e8;\n}\n.hover\\:to-pink-300:hover {\n  --gradient-to-color: #f8b4d9;\n}\n.hover\\:to-pink-400:hover {\n  --gradient-to-color: #f17eb8;\n}\n.hover\\:to-pink-500:hover {\n  --gradient-to-color: #e74694;\n}\n.hover\\:to-pink-600:hover {\n  --gradient-to-color: #d61f69;\n}\n.hover\\:to-pink-700:hover {\n  --gradient-to-color: #bf125d;\n}\n.hover\\:to-pink-800:hover {\n  --gradient-to-color: #99154b;\n}\n.hover\\:to-pink-900:hover {\n  --gradient-to-color: #751a3d;\n}\n.hover\\:to-cool-gray-50:hover {\n  --gradient-to-color: #f8fafc;\n}\n.hover\\:to-cool-gray-100:hover {\n  --gradient-to-color: #f1f5f9;\n}\n.hover\\:to-cool-gray-200:hover {\n  --gradient-to-color: #e2e8f0;\n}\n.hover\\:to-cool-gray-300:hover {\n  --gradient-to-color: #cfd8e3;\n}\n.hover\\:to-cool-gray-400:hover {\n  --gradient-to-color: #97a6ba;\n}\n.hover\\:to-cool-gray-500:hover {\n  --gradient-to-color: #64748b;\n}\n.hover\\:to-cool-gray-600:hover {\n  --gradient-to-color: #475569;\n}\n.hover\\:to-cool-gray-700:hover {\n  --gradient-to-color: #364152;\n}\n.hover\\:to-cool-gray-800:hover {\n  --gradient-to-color: #27303f;\n}\n.hover\\:to-cool-gray-900:hover {\n  --gradient-to-color: #1a202e;\n}\n.focus\\:from-current:focus {\n  --gradient-from-color: currentColor;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));\n}\n.focus\\:from-transparent:focus {\n  --gradient-from-color: transparent;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0));\n}\n.focus\\:from-white:focus {\n  --gradient-from-color: #ffffff;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));\n}\n.focus\\:from-black:focus {\n  --gradient-from-color: #000000;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0));\n}\n.focus\\:from-gray-50:focus {\n  --gradient-from-color: #f9fafb;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(249, 250, 251, 0));\n}\n.focus\\:from-gray-100:focus {\n  --gradient-from-color: #f4f5f7;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(244, 245, 247, 0));\n}\n.focus\\:from-gray-200:focus {\n  --gradient-from-color: #e5e7eb;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(229, 231, 235, 0));\n}\n.focus\\:from-gray-300:focus {\n  --gradient-from-color: #d2d6dc;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(210, 214, 220, 0));\n}\n.focus\\:from-gray-400:focus {\n  --gradient-from-color: #9fa6b2;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(159, 166, 178, 0));\n}\n.focus\\:from-gray-500:focus {\n  --gradient-from-color: #6b7280;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(107, 114, 128, 0));\n}\n.focus\\:from-gray-600:focus {\n  --gradient-from-color: #4b5563;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(75, 85, 99, 0));\n}\n.focus\\:from-gray-700:focus {\n  --gradient-from-color: #374151;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(55, 65, 81, 0));\n}\n.focus\\:from-gray-800:focus {\n  --gradient-from-color: #252f3f;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(37, 47, 63, 0));\n}\n.focus\\:from-gray-900:focus {\n  --gradient-from-color: #161e2e;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(22, 30, 46, 0));\n}\n.focus\\:from-red-50:focus {\n  --gradient-from-color: #fdf2f2;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 242, 242, 0));\n}\n.focus\\:from-red-100:focus {\n  --gradient-from-color: #fde8e8;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 232, 232, 0));\n}\n.focus\\:from-red-200:focus {\n  --gradient-from-color: #fbd5d5;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(251, 213, 213, 0));\n}\n.focus\\:from-red-300:focus {\n  --gradient-from-color: #f8b4b4;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(248, 180, 180, 0));\n}\n.focus\\:from-red-400:focus {\n  --gradient-from-color: #f98080;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(249, 128, 128, 0));\n}\n.focus\\:from-red-500:focus {\n  --gradient-from-color: #f05252;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(240, 82, 82, 0));\n}\n.focus\\:from-red-600:focus {\n  --gradient-from-color: #e02424;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(224, 36, 36, 0));\n}\n.focus\\:from-red-700:focus {\n  --gradient-from-color: #c81e1e;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(200, 30, 30, 0));\n}\n.focus\\:from-red-800:focus {\n  --gradient-from-color: #9b1c1c;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(155, 28, 28, 0));\n}\n.focus\\:from-red-900:focus {\n  --gradient-from-color: #771d1d;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(119, 29, 29, 0));\n}\n.focus\\:from-orange-50:focus {\n  --gradient-from-color: #fff8f1;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 248, 241, 0));\n}\n.focus\\:from-orange-100:focus {\n  --gradient-from-color: #feecdc;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 236, 220, 0));\n}\n.focus\\:from-orange-200:focus {\n  --gradient-from-color: #fcd9bd;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(252, 217, 189, 0));\n}\n.focus\\:from-orange-300:focus {\n  --gradient-from-color: #fdba8c;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 186, 140, 0));\n}\n.focus\\:from-orange-400:focus {\n  --gradient-from-color: #ff8a4c;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 138, 76, 0));\n}\n.focus\\:from-orange-500:focus {\n  --gradient-from-color: #ff5a1f;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 90, 31, 0));\n}\n.focus\\:from-orange-600:focus {\n  --gradient-from-color: #d03801;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(208, 56, 1, 0));\n}\n.focus\\:from-orange-700:focus {\n  --gradient-from-color: #b43403;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(180, 52, 3, 0));\n}\n.focus\\:from-orange-800:focus {\n  --gradient-from-color: #8a2c0d;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(138, 44, 13, 0));\n}\n.focus\\:from-orange-900:focus {\n  --gradient-from-color: #73230d;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(115, 35, 13, 0));\n}\n.focus\\:from-yellow-50:focus {\n  --gradient-from-color: #fdfdea;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 253, 234, 0));\n}\n.focus\\:from-yellow-100:focus {\n  --gradient-from-color: #fdf6b2;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 246, 178, 0));\n}\n.focus\\:from-yellow-200:focus {\n  --gradient-from-color: #fce96a;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(252, 233, 106, 0));\n}\n.focus\\:from-yellow-300:focus {\n  --gradient-from-color: #faca15;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(250, 202, 21, 0));\n}\n.focus\\:from-yellow-400:focus {\n  --gradient-from-color: #e3a008;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(227, 160, 8, 0));\n}\n.focus\\:from-yellow-500:focus {\n  --gradient-from-color: #c27803;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(194, 120, 3, 0));\n}\n.focus\\:from-yellow-600:focus {\n  --gradient-from-color: #9f580a;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(159, 88, 10, 0));\n}\n.focus\\:from-yellow-700:focus {\n  --gradient-from-color: #8e4b10;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(142, 75, 16, 0));\n}\n.focus\\:from-yellow-800:focus {\n  --gradient-from-color: #723b13;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(114, 59, 19, 0));\n}\n.focus\\:from-yellow-900:focus {\n  --gradient-from-color: #633112;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(99, 49, 18, 0));\n}\n.focus\\:from-green-50:focus {\n  --gradient-from-color: #f3faf7;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(243, 250, 247, 0));\n}\n.focus\\:from-green-100:focus {\n  --gradient-from-color: #def7ec;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(222, 247, 236, 0));\n}\n.focus\\:from-green-200:focus {\n  --gradient-from-color: #bcf0da;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(188, 240, 218, 0));\n}\n.focus\\:from-green-300:focus {\n  --gradient-from-color: #84e1bc;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(132, 225, 188, 0));\n}\n.focus\\:from-green-400:focus {\n  --gradient-from-color: #31c48d;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(49, 196, 141, 0));\n}\n.focus\\:from-green-500:focus {\n  --gradient-from-color: #0e9f6e;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(14, 159, 110, 0));\n}\n.focus\\:from-green-600:focus {\n  --gradient-from-color: #057a55;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(5, 122, 85, 0));\n}\n.focus\\:from-green-700:focus {\n  --gradient-from-color: #046c4e;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(4, 108, 78, 0));\n}\n.focus\\:from-green-800:focus {\n  --gradient-from-color: #03543f;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(3, 84, 63, 0));\n}\n.focus\\:from-green-900:focus {\n  --gradient-from-color: #014737;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(1, 71, 55, 0));\n}\n.focus\\:from-teal-50:focus {\n  --gradient-from-color: #edfafa;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(237, 250, 250, 0));\n}\n.focus\\:from-teal-100:focus {\n  --gradient-from-color: #d5f5f6;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(213, 245, 246, 0));\n}\n.focus\\:from-teal-200:focus {\n  --gradient-from-color: #afecef;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(175, 236, 239, 0));\n}\n.focus\\:from-teal-300:focus {\n  --gradient-from-color: #7edce2;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(126, 220, 226, 0));\n}\n.focus\\:from-teal-400:focus {\n  --gradient-from-color: #16bdca;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(22, 189, 202, 0));\n}\n.focus\\:from-teal-500:focus {\n  --gradient-from-color: #0694a2;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(6, 148, 162, 0));\n}\n.focus\\:from-teal-600:focus {\n  --gradient-from-color: #047481;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(4, 116, 129, 0));\n}\n.focus\\:from-teal-700:focus {\n  --gradient-from-color: #036672;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(3, 102, 114, 0));\n}\n.focus\\:from-teal-800:focus {\n  --gradient-from-color: #05505c;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(5, 80, 92, 0));\n}\n.focus\\:from-teal-900:focus {\n  --gradient-from-color: #014451;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(1, 68, 81, 0));\n}\n.focus\\:from-blue-50:focus {\n  --gradient-from-color: #ebf5ff;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(235, 245, 255, 0));\n}\n.focus\\:from-blue-100:focus {\n  --gradient-from-color: #e1effe;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(225, 239, 254, 0));\n}\n.focus\\:from-blue-200:focus {\n  --gradient-from-color: #c3ddfd;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(195, 221, 253, 0));\n}\n.focus\\:from-blue-300:focus {\n  --gradient-from-color: #a4cafe;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(164, 202, 254, 0));\n}\n.focus\\:from-blue-400:focus {\n  --gradient-from-color: #76a9fa;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(118, 169, 250, 0));\n}\n.focus\\:from-blue-500:focus {\n  --gradient-from-color: #3f83f8;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(63, 131, 248, 0));\n}\n.focus\\:from-blue-600:focus {\n  --gradient-from-color: #1c64f2;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(28, 100, 242, 0));\n}\n.focus\\:from-blue-700:focus {\n  --gradient-from-color: #1a56db;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(26, 86, 219, 0));\n}\n.focus\\:from-blue-800:focus {\n  --gradient-from-color: #1e429f;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(30, 66, 159, 0));\n}\n.focus\\:from-blue-900:focus {\n  --gradient-from-color: #233876;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(35, 56, 118, 0));\n}\n.focus\\:from-indigo-50:focus {\n  --gradient-from-color: #f0f5ff;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(240, 245, 255, 0));\n}\n.focus\\:from-indigo-100:focus {\n  --gradient-from-color: #e5edff;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(229, 237, 255, 0));\n}\n.focus\\:from-indigo-200:focus {\n  --gradient-from-color: #cddbfe;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(205, 219, 254, 0));\n}\n.focus\\:from-indigo-300:focus {\n  --gradient-from-color: #b4c6fc;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(180, 198, 252, 0));\n}\n.focus\\:from-indigo-400:focus {\n  --gradient-from-color: #8da2fb;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(141, 162, 251, 0));\n}\n.focus\\:from-indigo-500:focus {\n  --gradient-from-color: #6875f5;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(104, 117, 245, 0));\n}\n.focus\\:from-indigo-600:focus {\n  --gradient-from-color: #5850ec;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(88, 80, 236, 0));\n}\n.focus\\:from-indigo-700:focus {\n  --gradient-from-color: #5145cd;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(81, 69, 205, 0));\n}\n.focus\\:from-indigo-800:focus {\n  --gradient-from-color: #42389d;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(66, 56, 157, 0));\n}\n.focus\\:from-indigo-900:focus {\n  --gradient-from-color: #362f78;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(54, 47, 120, 0));\n}\n.focus\\:from-purple-50:focus {\n  --gradient-from-color: #f6f5ff;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(246, 245, 255, 0));\n}\n.focus\\:from-purple-100:focus {\n  --gradient-from-color: #edebfe;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(237, 235, 254, 0));\n}\n.focus\\:from-purple-200:focus {\n  --gradient-from-color: #dcd7fe;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(220, 215, 254, 0));\n}\n.focus\\:from-purple-300:focus {\n  --gradient-from-color: #cabffd;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(202, 191, 253, 0));\n}\n.focus\\:from-purple-400:focus {\n  --gradient-from-color: #ac94fa;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(172, 148, 250, 0));\n}\n.focus\\:from-purple-500:focus {\n  --gradient-from-color: #9061f9;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(144, 97, 249, 0));\n}\n.focus\\:from-purple-600:focus {\n  --gradient-from-color: #7e3af2;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(126, 58, 242, 0));\n}\n.focus\\:from-purple-700:focus {\n  --gradient-from-color: #6c2bd9;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(108, 43, 217, 0));\n}\n.focus\\:from-purple-800:focus {\n  --gradient-from-color: #5521b5;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(85, 33, 181, 0));\n}\n.focus\\:from-purple-900:focus {\n  --gradient-from-color: #4a1d96;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(74, 29, 150, 0));\n}\n.focus\\:from-pink-50:focus {\n  --gradient-from-color: #fdf2f8;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 242, 248, 0));\n}\n.focus\\:from-pink-100:focus {\n  --gradient-from-color: #fce8f3;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(252, 232, 243, 0));\n}\n.focus\\:from-pink-200:focus {\n  --gradient-from-color: #fad1e8;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(250, 209, 232, 0));\n}\n.focus\\:from-pink-300:focus {\n  --gradient-from-color: #f8b4d9;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(248, 180, 217, 0));\n}\n.focus\\:from-pink-400:focus {\n  --gradient-from-color: #f17eb8;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(241, 126, 184, 0));\n}\n.focus\\:from-pink-500:focus {\n  --gradient-from-color: #e74694;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(231, 70, 148, 0));\n}\n.focus\\:from-pink-600:focus {\n  --gradient-from-color: #d61f69;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(214, 31, 105, 0));\n}\n.focus\\:from-pink-700:focus {\n  --gradient-from-color: #bf125d;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(191, 18, 93, 0));\n}\n.focus\\:from-pink-800:focus {\n  --gradient-from-color: #99154b;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(153, 21, 75, 0));\n}\n.focus\\:from-pink-900:focus {\n  --gradient-from-color: #751a3d;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(117, 26, 61, 0));\n}\n.focus\\:from-cool-gray-50:focus {\n  --gradient-from-color: #f8fafc;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(248, 250, 252, 0));\n}\n.focus\\:from-cool-gray-100:focus {\n  --gradient-from-color: #f1f5f9;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(241, 245, 249, 0));\n}\n.focus\\:from-cool-gray-200:focus {\n  --gradient-from-color: #e2e8f0;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(226, 232, 240, 0));\n}\n.focus\\:from-cool-gray-300:focus {\n  --gradient-from-color: #cfd8e3;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(207, 216, 227, 0));\n}\n.focus\\:from-cool-gray-400:focus {\n  --gradient-from-color: #97a6ba;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(151, 166, 186, 0));\n}\n.focus\\:from-cool-gray-500:focus {\n  --gradient-from-color: #64748b;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(100, 116, 139, 0));\n}\n.focus\\:from-cool-gray-600:focus {\n  --gradient-from-color: #475569;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(71, 85, 105, 0));\n}\n.focus\\:from-cool-gray-700:focus {\n  --gradient-from-color: #364152;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(54, 65, 82, 0));\n}\n.focus\\:from-cool-gray-800:focus {\n  --gradient-from-color: #27303f;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(39, 48, 63, 0));\n}\n.focus\\:from-cool-gray-900:focus {\n  --gradient-from-color: #1a202e;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(26, 32, 46, 0));\n}\n.focus\\:via-current:focus {\n  --gradient-via-color: currentColor;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));\n}\n.focus\\:via-transparent:focus {\n  --gradient-via-color: transparent;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0));\n}\n.focus\\:via-white:focus {\n  --gradient-via-color: #ffffff;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));\n}\n.focus\\:via-black:focus {\n  --gradient-via-color: #000000;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0));\n}\n.focus\\:via-gray-50:focus {\n  --gradient-via-color: #f9fafb;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(249, 250, 251, 0));\n}\n.focus\\:via-gray-100:focus {\n  --gradient-via-color: #f4f5f7;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(244, 245, 247, 0));\n}\n.focus\\:via-gray-200:focus {\n  --gradient-via-color: #e5e7eb;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(229, 231, 235, 0));\n}\n.focus\\:via-gray-300:focus {\n  --gradient-via-color: #d2d6dc;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(210, 214, 220, 0));\n}\n.focus\\:via-gray-400:focus {\n  --gradient-via-color: #9fa6b2;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(159, 166, 178, 0));\n}\n.focus\\:via-gray-500:focus {\n  --gradient-via-color: #6b7280;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(107, 114, 128, 0));\n}\n.focus\\:via-gray-600:focus {\n  --gradient-via-color: #4b5563;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(75, 85, 99, 0));\n}\n.focus\\:via-gray-700:focus {\n  --gradient-via-color: #374151;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(55, 65, 81, 0));\n}\n.focus\\:via-gray-800:focus {\n  --gradient-via-color: #252f3f;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(37, 47, 63, 0));\n}\n.focus\\:via-gray-900:focus {\n  --gradient-via-color: #161e2e;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(22, 30, 46, 0));\n}\n.focus\\:via-red-50:focus {\n  --gradient-via-color: #fdf2f2;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 242, 242, 0));\n}\n.focus\\:via-red-100:focus {\n  --gradient-via-color: #fde8e8;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 232, 232, 0));\n}\n.focus\\:via-red-200:focus {\n  --gradient-via-color: #fbd5d5;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(251, 213, 213, 0));\n}\n.focus\\:via-red-300:focus {\n  --gradient-via-color: #f8b4b4;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(248, 180, 180, 0));\n}\n.focus\\:via-red-400:focus {\n  --gradient-via-color: #f98080;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(249, 128, 128, 0));\n}\n.focus\\:via-red-500:focus {\n  --gradient-via-color: #f05252;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(240, 82, 82, 0));\n}\n.focus\\:via-red-600:focus {\n  --gradient-via-color: #e02424;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(224, 36, 36, 0));\n}\n.focus\\:via-red-700:focus {\n  --gradient-via-color: #c81e1e;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(200, 30, 30, 0));\n}\n.focus\\:via-red-800:focus {\n  --gradient-via-color: #9b1c1c;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(155, 28, 28, 0));\n}\n.focus\\:via-red-900:focus {\n  --gradient-via-color: #771d1d;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(119, 29, 29, 0));\n}\n.focus\\:via-orange-50:focus {\n  --gradient-via-color: #fff8f1;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 248, 241, 0));\n}\n.focus\\:via-orange-100:focus {\n  --gradient-via-color: #feecdc;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 236, 220, 0));\n}\n.focus\\:via-orange-200:focus {\n  --gradient-via-color: #fcd9bd;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(252, 217, 189, 0));\n}\n.focus\\:via-orange-300:focus {\n  --gradient-via-color: #fdba8c;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 186, 140, 0));\n}\n.focus\\:via-orange-400:focus {\n  --gradient-via-color: #ff8a4c;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 138, 76, 0));\n}\n.focus\\:via-orange-500:focus {\n  --gradient-via-color: #ff5a1f;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 90, 31, 0));\n}\n.focus\\:via-orange-600:focus {\n  --gradient-via-color: #d03801;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(208, 56, 1, 0));\n}\n.focus\\:via-orange-700:focus {\n  --gradient-via-color: #b43403;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(180, 52, 3, 0));\n}\n.focus\\:via-orange-800:focus {\n  --gradient-via-color: #8a2c0d;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(138, 44, 13, 0));\n}\n.focus\\:via-orange-900:focus {\n  --gradient-via-color: #73230d;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(115, 35, 13, 0));\n}\n.focus\\:via-yellow-50:focus {\n  --gradient-via-color: #fdfdea;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 253, 234, 0));\n}\n.focus\\:via-yellow-100:focus {\n  --gradient-via-color: #fdf6b2;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 246, 178, 0));\n}\n.focus\\:via-yellow-200:focus {\n  --gradient-via-color: #fce96a;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(252, 233, 106, 0));\n}\n.focus\\:via-yellow-300:focus {\n  --gradient-via-color: #faca15;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(250, 202, 21, 0));\n}\n.focus\\:via-yellow-400:focus {\n  --gradient-via-color: #e3a008;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(227, 160, 8, 0));\n}\n.focus\\:via-yellow-500:focus {\n  --gradient-via-color: #c27803;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(194, 120, 3, 0));\n}\n.focus\\:via-yellow-600:focus {\n  --gradient-via-color: #9f580a;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(159, 88, 10, 0));\n}\n.focus\\:via-yellow-700:focus {\n  --gradient-via-color: #8e4b10;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(142, 75, 16, 0));\n}\n.focus\\:via-yellow-800:focus {\n  --gradient-via-color: #723b13;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(114, 59, 19, 0));\n}\n.focus\\:via-yellow-900:focus {\n  --gradient-via-color: #633112;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(99, 49, 18, 0));\n}\n.focus\\:via-green-50:focus {\n  --gradient-via-color: #f3faf7;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(243, 250, 247, 0));\n}\n.focus\\:via-green-100:focus {\n  --gradient-via-color: #def7ec;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(222, 247, 236, 0));\n}\n.focus\\:via-green-200:focus {\n  --gradient-via-color: #bcf0da;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(188, 240, 218, 0));\n}\n.focus\\:via-green-300:focus {\n  --gradient-via-color: #84e1bc;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(132, 225, 188, 0));\n}\n.focus\\:via-green-400:focus {\n  --gradient-via-color: #31c48d;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(49, 196, 141, 0));\n}\n.focus\\:via-green-500:focus {\n  --gradient-via-color: #0e9f6e;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(14, 159, 110, 0));\n}\n.focus\\:via-green-600:focus {\n  --gradient-via-color: #057a55;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(5, 122, 85, 0));\n}\n.focus\\:via-green-700:focus {\n  --gradient-via-color: #046c4e;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(4, 108, 78, 0));\n}\n.focus\\:via-green-800:focus {\n  --gradient-via-color: #03543f;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(3, 84, 63, 0));\n}\n.focus\\:via-green-900:focus {\n  --gradient-via-color: #014737;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(1, 71, 55, 0));\n}\n.focus\\:via-teal-50:focus {\n  --gradient-via-color: #edfafa;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(237, 250, 250, 0));\n}\n.focus\\:via-teal-100:focus {\n  --gradient-via-color: #d5f5f6;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(213, 245, 246, 0));\n}\n.focus\\:via-teal-200:focus {\n  --gradient-via-color: #afecef;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(175, 236, 239, 0));\n}\n.focus\\:via-teal-300:focus {\n  --gradient-via-color: #7edce2;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(126, 220, 226, 0));\n}\n.focus\\:via-teal-400:focus {\n  --gradient-via-color: #16bdca;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(22, 189, 202, 0));\n}\n.focus\\:via-teal-500:focus {\n  --gradient-via-color: #0694a2;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(6, 148, 162, 0));\n}\n.focus\\:via-teal-600:focus {\n  --gradient-via-color: #047481;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(4, 116, 129, 0));\n}\n.focus\\:via-teal-700:focus {\n  --gradient-via-color: #036672;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(3, 102, 114, 0));\n}\n.focus\\:via-teal-800:focus {\n  --gradient-via-color: #05505c;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(5, 80, 92, 0));\n}\n.focus\\:via-teal-900:focus {\n  --gradient-via-color: #014451;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(1, 68, 81, 0));\n}\n.focus\\:via-blue-50:focus {\n  --gradient-via-color: #ebf5ff;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(235, 245, 255, 0));\n}\n.focus\\:via-blue-100:focus {\n  --gradient-via-color: #e1effe;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(225, 239, 254, 0));\n}\n.focus\\:via-blue-200:focus {\n  --gradient-via-color: #c3ddfd;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(195, 221, 253, 0));\n}\n.focus\\:via-blue-300:focus {\n  --gradient-via-color: #a4cafe;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(164, 202, 254, 0));\n}\n.focus\\:via-blue-400:focus {\n  --gradient-via-color: #76a9fa;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(118, 169, 250, 0));\n}\n.focus\\:via-blue-500:focus {\n  --gradient-via-color: #3f83f8;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(63, 131, 248, 0));\n}\n.focus\\:via-blue-600:focus {\n  --gradient-via-color: #1c64f2;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(28, 100, 242, 0));\n}\n.focus\\:via-blue-700:focus {\n  --gradient-via-color: #1a56db;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(26, 86, 219, 0));\n}\n.focus\\:via-blue-800:focus {\n  --gradient-via-color: #1e429f;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(30, 66, 159, 0));\n}\n.focus\\:via-blue-900:focus {\n  --gradient-via-color: #233876;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(35, 56, 118, 0));\n}\n.focus\\:via-indigo-50:focus {\n  --gradient-via-color: #f0f5ff;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(240, 245, 255, 0));\n}\n.focus\\:via-indigo-100:focus {\n  --gradient-via-color: #e5edff;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(229, 237, 255, 0));\n}\n.focus\\:via-indigo-200:focus {\n  --gradient-via-color: #cddbfe;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(205, 219, 254, 0));\n}\n.focus\\:via-indigo-300:focus {\n  --gradient-via-color: #b4c6fc;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(180, 198, 252, 0));\n}\n.focus\\:via-indigo-400:focus {\n  --gradient-via-color: #8da2fb;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(141, 162, 251, 0));\n}\n.focus\\:via-indigo-500:focus {\n  --gradient-via-color: #6875f5;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(104, 117, 245, 0));\n}\n.focus\\:via-indigo-600:focus {\n  --gradient-via-color: #5850ec;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(88, 80, 236, 0));\n}\n.focus\\:via-indigo-700:focus {\n  --gradient-via-color: #5145cd;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(81, 69, 205, 0));\n}\n.focus\\:via-indigo-800:focus {\n  --gradient-via-color: #42389d;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(66, 56, 157, 0));\n}\n.focus\\:via-indigo-900:focus {\n  --gradient-via-color: #362f78;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(54, 47, 120, 0));\n}\n.focus\\:via-purple-50:focus {\n  --gradient-via-color: #f6f5ff;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(246, 245, 255, 0));\n}\n.focus\\:via-purple-100:focus {\n  --gradient-via-color: #edebfe;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(237, 235, 254, 0));\n}\n.focus\\:via-purple-200:focus {\n  --gradient-via-color: #dcd7fe;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(220, 215, 254, 0));\n}\n.focus\\:via-purple-300:focus {\n  --gradient-via-color: #cabffd;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(202, 191, 253, 0));\n}\n.focus\\:via-purple-400:focus {\n  --gradient-via-color: #ac94fa;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(172, 148, 250, 0));\n}\n.focus\\:via-purple-500:focus {\n  --gradient-via-color: #9061f9;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(144, 97, 249, 0));\n}\n.focus\\:via-purple-600:focus {\n  --gradient-via-color: #7e3af2;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(126, 58, 242, 0));\n}\n.focus\\:via-purple-700:focus {\n  --gradient-via-color: #6c2bd9;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(108, 43, 217, 0));\n}\n.focus\\:via-purple-800:focus {\n  --gradient-via-color: #5521b5;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(85, 33, 181, 0));\n}\n.focus\\:via-purple-900:focus {\n  --gradient-via-color: #4a1d96;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(74, 29, 150, 0));\n}\n.focus\\:via-pink-50:focus {\n  --gradient-via-color: #fdf2f8;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 242, 248, 0));\n}\n.focus\\:via-pink-100:focus {\n  --gradient-via-color: #fce8f3;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(252, 232, 243, 0));\n}\n.focus\\:via-pink-200:focus {\n  --gradient-via-color: #fad1e8;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(250, 209, 232, 0));\n}\n.focus\\:via-pink-300:focus {\n  --gradient-via-color: #f8b4d9;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(248, 180, 217, 0));\n}\n.focus\\:via-pink-400:focus {\n  --gradient-via-color: #f17eb8;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(241, 126, 184, 0));\n}\n.focus\\:via-pink-500:focus {\n  --gradient-via-color: #e74694;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(231, 70, 148, 0));\n}\n.focus\\:via-pink-600:focus {\n  --gradient-via-color: #d61f69;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(214, 31, 105, 0));\n}\n.focus\\:via-pink-700:focus {\n  --gradient-via-color: #bf125d;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(191, 18, 93, 0));\n}\n.focus\\:via-pink-800:focus {\n  --gradient-via-color: #99154b;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(153, 21, 75, 0));\n}\n.focus\\:via-pink-900:focus {\n  --gradient-via-color: #751a3d;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(117, 26, 61, 0));\n}\n.focus\\:via-cool-gray-50:focus {\n  --gradient-via-color: #f8fafc;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(248, 250, 252, 0));\n}\n.focus\\:via-cool-gray-100:focus {\n  --gradient-via-color: #f1f5f9;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(241, 245, 249, 0));\n}\n.focus\\:via-cool-gray-200:focus {\n  --gradient-via-color: #e2e8f0;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(226, 232, 240, 0));\n}\n.focus\\:via-cool-gray-300:focus {\n  --gradient-via-color: #cfd8e3;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(207, 216, 227, 0));\n}\n.focus\\:via-cool-gray-400:focus {\n  --gradient-via-color: #97a6ba;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(151, 166, 186, 0));\n}\n.focus\\:via-cool-gray-500:focus {\n  --gradient-via-color: #64748b;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(100, 116, 139, 0));\n}\n.focus\\:via-cool-gray-600:focus {\n  --gradient-via-color: #475569;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(71, 85, 105, 0));\n}\n.focus\\:via-cool-gray-700:focus {\n  --gradient-via-color: #364152;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(54, 65, 82, 0));\n}\n.focus\\:via-cool-gray-800:focus {\n  --gradient-via-color: #27303f;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(39, 48, 63, 0));\n}\n.focus\\:via-cool-gray-900:focus {\n  --gradient-via-color: #1a202e;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(26, 32, 46, 0));\n}\n.focus\\:to-current:focus {\n  --gradient-to-color: currentColor;\n}\n.focus\\:to-transparent:focus {\n  --gradient-to-color: transparent;\n}\n.focus\\:to-white:focus {\n  --gradient-to-color: #ffffff;\n}\n.focus\\:to-black:focus {\n  --gradient-to-color: #000000;\n}\n.focus\\:to-gray-50:focus {\n  --gradient-to-color: #f9fafb;\n}\n.focus\\:to-gray-100:focus {\n  --gradient-to-color: #f4f5f7;\n}\n.focus\\:to-gray-200:focus {\n  --gradient-to-color: #e5e7eb;\n}\n.focus\\:to-gray-300:focus {\n  --gradient-to-color: #d2d6dc;\n}\n.focus\\:to-gray-400:focus {\n  --gradient-to-color: #9fa6b2;\n}\n.focus\\:to-gray-500:focus {\n  --gradient-to-color: #6b7280;\n}\n.focus\\:to-gray-600:focus {\n  --gradient-to-color: #4b5563;\n}\n.focus\\:to-gray-700:focus {\n  --gradient-to-color: #374151;\n}\n.focus\\:to-gray-800:focus {\n  --gradient-to-color: #252f3f;\n}\n.focus\\:to-gray-900:focus {\n  --gradient-to-color: #161e2e;\n}\n.focus\\:to-red-50:focus {\n  --gradient-to-color: #fdf2f2;\n}\n.focus\\:to-red-100:focus {\n  --gradient-to-color: #fde8e8;\n}\n.focus\\:to-red-200:focus {\n  --gradient-to-color: #fbd5d5;\n}\n.focus\\:to-red-300:focus {\n  --gradient-to-color: #f8b4b4;\n}\n.focus\\:to-red-400:focus {\n  --gradient-to-color: #f98080;\n}\n.focus\\:to-red-500:focus {\n  --gradient-to-color: #f05252;\n}\n.focus\\:to-red-600:focus {\n  --gradient-to-color: #e02424;\n}\n.focus\\:to-red-700:focus {\n  --gradient-to-color: #c81e1e;\n}\n.focus\\:to-red-800:focus {\n  --gradient-to-color: #9b1c1c;\n}\n.focus\\:to-red-900:focus {\n  --gradient-to-color: #771d1d;\n}\n.focus\\:to-orange-50:focus {\n  --gradient-to-color: #fff8f1;\n}\n.focus\\:to-orange-100:focus {\n  --gradient-to-color: #feecdc;\n}\n.focus\\:to-orange-200:focus {\n  --gradient-to-color: #fcd9bd;\n}\n.focus\\:to-orange-300:focus {\n  --gradient-to-color: #fdba8c;\n}\n.focus\\:to-orange-400:focus {\n  --gradient-to-color: #ff8a4c;\n}\n.focus\\:to-orange-500:focus {\n  --gradient-to-color: #ff5a1f;\n}\n.focus\\:to-orange-600:focus {\n  --gradient-to-color: #d03801;\n}\n.focus\\:to-orange-700:focus {\n  --gradient-to-color: #b43403;\n}\n.focus\\:to-orange-800:focus {\n  --gradient-to-color: #8a2c0d;\n}\n.focus\\:to-orange-900:focus {\n  --gradient-to-color: #73230d;\n}\n.focus\\:to-yellow-50:focus {\n  --gradient-to-color: #fdfdea;\n}\n.focus\\:to-yellow-100:focus {\n  --gradient-to-color: #fdf6b2;\n}\n.focus\\:to-yellow-200:focus {\n  --gradient-to-color: #fce96a;\n}\n.focus\\:to-yellow-300:focus {\n  --gradient-to-color: #faca15;\n}\n.focus\\:to-yellow-400:focus {\n  --gradient-to-color: #e3a008;\n}\n.focus\\:to-yellow-500:focus {\n  --gradient-to-color: #c27803;\n}\n.focus\\:to-yellow-600:focus {\n  --gradient-to-color: #9f580a;\n}\n.focus\\:to-yellow-700:focus {\n  --gradient-to-color: #8e4b10;\n}\n.focus\\:to-yellow-800:focus {\n  --gradient-to-color: #723b13;\n}\n.focus\\:to-yellow-900:focus {\n  --gradient-to-color: #633112;\n}\n.focus\\:to-green-50:focus {\n  --gradient-to-color: #f3faf7;\n}\n.focus\\:to-green-100:focus {\n  --gradient-to-color: #def7ec;\n}\n.focus\\:to-green-200:focus {\n  --gradient-to-color: #bcf0da;\n}\n.focus\\:to-green-300:focus {\n  --gradient-to-color: #84e1bc;\n}\n.focus\\:to-green-400:focus {\n  --gradient-to-color: #31c48d;\n}\n.focus\\:to-green-500:focus {\n  --gradient-to-color: #0e9f6e;\n}\n.focus\\:to-green-600:focus {\n  --gradient-to-color: #057a55;\n}\n.focus\\:to-green-700:focus {\n  --gradient-to-color: #046c4e;\n}\n.focus\\:to-green-800:focus {\n  --gradient-to-color: #03543f;\n}\n.focus\\:to-green-900:focus {\n  --gradient-to-color: #014737;\n}\n.focus\\:to-teal-50:focus {\n  --gradient-to-color: #edfafa;\n}\n.focus\\:to-teal-100:focus {\n  --gradient-to-color: #d5f5f6;\n}\n.focus\\:to-teal-200:focus {\n  --gradient-to-color: #afecef;\n}\n.focus\\:to-teal-300:focus {\n  --gradient-to-color: #7edce2;\n}\n.focus\\:to-teal-400:focus {\n  --gradient-to-color: #16bdca;\n}\n.focus\\:to-teal-500:focus {\n  --gradient-to-color: #0694a2;\n}\n.focus\\:to-teal-600:focus {\n  --gradient-to-color: #047481;\n}\n.focus\\:to-teal-700:focus {\n  --gradient-to-color: #036672;\n}\n.focus\\:to-teal-800:focus {\n  --gradient-to-color: #05505c;\n}\n.focus\\:to-teal-900:focus {\n  --gradient-to-color: #014451;\n}\n.focus\\:to-blue-50:focus {\n  --gradient-to-color: #ebf5ff;\n}\n.focus\\:to-blue-100:focus {\n  --gradient-to-color: #e1effe;\n}\n.focus\\:to-blue-200:focus {\n  --gradient-to-color: #c3ddfd;\n}\n.focus\\:to-blue-300:focus {\n  --gradient-to-color: #a4cafe;\n}\n.focus\\:to-blue-400:focus {\n  --gradient-to-color: #76a9fa;\n}\n.focus\\:to-blue-500:focus {\n  --gradient-to-color: #3f83f8;\n}\n.focus\\:to-blue-600:focus {\n  --gradient-to-color: #1c64f2;\n}\n.focus\\:to-blue-700:focus {\n  --gradient-to-color: #1a56db;\n}\n.focus\\:to-blue-800:focus {\n  --gradient-to-color: #1e429f;\n}\n.focus\\:to-blue-900:focus {\n  --gradient-to-color: #233876;\n}\n.focus\\:to-indigo-50:focus {\n  --gradient-to-color: #f0f5ff;\n}\n.focus\\:to-indigo-100:focus {\n  --gradient-to-color: #e5edff;\n}\n.focus\\:to-indigo-200:focus {\n  --gradient-to-color: #cddbfe;\n}\n.focus\\:to-indigo-300:focus {\n  --gradient-to-color: #b4c6fc;\n}\n.focus\\:to-indigo-400:focus {\n  --gradient-to-color: #8da2fb;\n}\n.focus\\:to-indigo-500:focus {\n  --gradient-to-color: #6875f5;\n}\n.focus\\:to-indigo-600:focus {\n  --gradient-to-color: #5850ec;\n}\n.focus\\:to-indigo-700:focus {\n  --gradient-to-color: #5145cd;\n}\n.focus\\:to-indigo-800:focus {\n  --gradient-to-color: #42389d;\n}\n.focus\\:to-indigo-900:focus {\n  --gradient-to-color: #362f78;\n}\n.focus\\:to-purple-50:focus {\n  --gradient-to-color: #f6f5ff;\n}\n.focus\\:to-purple-100:focus {\n  --gradient-to-color: #edebfe;\n}\n.focus\\:to-purple-200:focus {\n  --gradient-to-color: #dcd7fe;\n}\n.focus\\:to-purple-300:focus {\n  --gradient-to-color: #cabffd;\n}\n.focus\\:to-purple-400:focus {\n  --gradient-to-color: #ac94fa;\n}\n.focus\\:to-purple-500:focus {\n  --gradient-to-color: #9061f9;\n}\n.focus\\:to-purple-600:focus {\n  --gradient-to-color: #7e3af2;\n}\n.focus\\:to-purple-700:focus {\n  --gradient-to-color: #6c2bd9;\n}\n.focus\\:to-purple-800:focus {\n  --gradient-to-color: #5521b5;\n}\n.focus\\:to-purple-900:focus {\n  --gradient-to-color: #4a1d96;\n}\n.focus\\:to-pink-50:focus {\n  --gradient-to-color: #fdf2f8;\n}\n.focus\\:to-pink-100:focus {\n  --gradient-to-color: #fce8f3;\n}\n.focus\\:to-pink-200:focus {\n  --gradient-to-color: #fad1e8;\n}\n.focus\\:to-pink-300:focus {\n  --gradient-to-color: #f8b4d9;\n}\n.focus\\:to-pink-400:focus {\n  --gradient-to-color: #f17eb8;\n}\n.focus\\:to-pink-500:focus {\n  --gradient-to-color: #e74694;\n}\n.focus\\:to-pink-600:focus {\n  --gradient-to-color: #d61f69;\n}\n.focus\\:to-pink-700:focus {\n  --gradient-to-color: #bf125d;\n}\n.focus\\:to-pink-800:focus {\n  --gradient-to-color: #99154b;\n}\n.focus\\:to-pink-900:focus {\n  --gradient-to-color: #751a3d;\n}\n.focus\\:to-cool-gray-50:focus {\n  --gradient-to-color: #f8fafc;\n}\n.focus\\:to-cool-gray-100:focus {\n  --gradient-to-color: #f1f5f9;\n}\n.focus\\:to-cool-gray-200:focus {\n  --gradient-to-color: #e2e8f0;\n}\n.focus\\:to-cool-gray-300:focus {\n  --gradient-to-color: #cfd8e3;\n}\n.focus\\:to-cool-gray-400:focus {\n  --gradient-to-color: #97a6ba;\n}\n.focus\\:to-cool-gray-500:focus {\n  --gradient-to-color: #64748b;\n}\n.focus\\:to-cool-gray-600:focus {\n  --gradient-to-color: #475569;\n}\n.focus\\:to-cool-gray-700:focus {\n  --gradient-to-color: #364152;\n}\n.focus\\:to-cool-gray-800:focus {\n  --gradient-to-color: #27303f;\n}\n.focus\\:to-cool-gray-900:focus {\n  --gradient-to-color: #1a202e;\n}\n.bg-opacity-0 {\n  --bg-opacity: 0;\n}\n.bg-opacity-25 {\n  --bg-opacity: 0.25;\n}\n.bg-opacity-50 {\n  --bg-opacity: 0.5;\n}\n.bg-opacity-75 {\n  --bg-opacity: 0.75;\n}\n.bg-opacity-100 {\n  --bg-opacity: 1;\n}\n.hover\\:bg-opacity-0:hover {\n  --bg-opacity: 0;\n}\n.hover\\:bg-opacity-25:hover {\n  --bg-opacity: 0.25;\n}\n.hover\\:bg-opacity-50:hover {\n  --bg-opacity: 0.5;\n}\n.hover\\:bg-opacity-75:hover {\n  --bg-opacity: 0.75;\n}\n.hover\\:bg-opacity-100:hover {\n  --bg-opacity: 1;\n}\n.focus\\:bg-opacity-0:focus {\n  --bg-opacity: 0;\n}\n.focus\\:bg-opacity-25:focus {\n  --bg-opacity: 0.25;\n}\n.focus\\:bg-opacity-50:focus {\n  --bg-opacity: 0.5;\n}\n.focus\\:bg-opacity-75:focus {\n  --bg-opacity: 0.75;\n}\n.focus\\:bg-opacity-100:focus {\n  --bg-opacity: 1;\n}\n.bg-bottom {\n  background-position: bottom;\n}\n.bg-center {\n  background-position: center;\n}\n.bg-left {\n  background-position: left;\n}\n.bg-left-bottom {\n  background-position: left bottom;\n}\n.bg-left-top {\n  background-position: left top;\n}\n.bg-right {\n  background-position: right;\n}\n.bg-right-bottom {\n  background-position: right bottom;\n}\n.bg-right-top {\n  background-position: right top;\n}\n.bg-top {\n  background-position: top;\n}\n.bg-repeat {\n  background-repeat: repeat;\n}\n.bg-no-repeat {\n  background-repeat: no-repeat;\n}\n.bg-repeat-x {\n  background-repeat: repeat-x;\n}\n.bg-repeat-y {\n  background-repeat: repeat-y;\n}\n.bg-repeat-round {\n  background-repeat: round;\n}\n.bg-repeat-space {\n  background-repeat: space;\n}\n.bg-auto {\n  background-size: auto;\n}\n.bg-cover {\n  background-size: cover;\n}\n.bg-contain {\n  background-size: contain;\n}\n.border-collapse {\n  border-collapse: collapse;\n}\n.border-separate {\n  border-collapse: separate;\n}\n.border-current {\n  border-color: currentColor;\n}\n.border-transparent {\n  border-color: transparent;\n}\n.border-white {\n  --border-opacity: 1;\n  border-color: #ffffff;\n  border-color: rgba(255, 255, 255, var(--border-opacity));\n}\n.border-black {\n  --border-opacity: 1;\n  border-color: #000000;\n  border-color: rgba(0, 0, 0, var(--border-opacity));\n}\n.border-gray-50 {\n  --border-opacity: 1;\n  border-color: #f9fafb;\n  border-color: rgba(249, 250, 251, var(--border-opacity));\n}\n.border-gray-100 {\n  --border-opacity: 1;\n  border-color: #f4f5f7;\n  border-color: rgba(244, 245, 247, var(--border-opacity));\n}\n.border-gray-200 {\n  --border-opacity: 1;\n  border-color: #e5e7eb;\n  border-color: rgba(229, 231, 235, var(--border-opacity));\n}\n.border-gray-300 {\n  --border-opacity: 1;\n  border-color: #d2d6dc;\n  border-color: rgba(210, 214, 220, var(--border-opacity));\n}\n.border-gray-400 {\n  --border-opacity: 1;\n  border-color: #9fa6b2;\n  border-color: rgba(159, 166, 178, var(--border-opacity));\n}\n.border-gray-500 {\n  --border-opacity: 1;\n  border-color: #6b7280;\n  border-color: rgba(107, 114, 128, var(--border-opacity));\n}\n.border-gray-600 {\n  --border-opacity: 1;\n  border-color: #4b5563;\n  border-color: rgba(75, 85, 99, var(--border-opacity));\n}\n.border-gray-700 {\n  --border-opacity: 1;\n  border-color: #374151;\n  border-color: rgba(55, 65, 81, var(--border-opacity));\n}\n.border-gray-800 {\n  --border-opacity: 1;\n  border-color: #252f3f;\n  border-color: rgba(37, 47, 63, var(--border-opacity));\n}\n.border-gray-900 {\n  --border-opacity: 1;\n  border-color: #161e2e;\n  border-color: rgba(22, 30, 46, var(--border-opacity));\n}\n.border-red-50 {\n  --border-opacity: 1;\n  border-color: #fdf2f2;\n  border-color: rgba(253, 242, 242, var(--border-opacity));\n}\n.border-red-100 {\n  --border-opacity: 1;\n  border-color: #fde8e8;\n  border-color: rgba(253, 232, 232, var(--border-opacity));\n}\n.border-red-200 {\n  --border-opacity: 1;\n  border-color: #fbd5d5;\n  border-color: rgba(251, 213, 213, var(--border-opacity));\n}\n.border-red-300 {\n  --border-opacity: 1;\n  border-color: #f8b4b4;\n  border-color: rgba(248, 180, 180, var(--border-opacity));\n}\n.border-red-400 {\n  --border-opacity: 1;\n  border-color: #f98080;\n  border-color: rgba(249, 128, 128, var(--border-opacity));\n}\n.border-red-500 {\n  --border-opacity: 1;\n  border-color: #f05252;\n  border-color: rgba(240, 82, 82, var(--border-opacity));\n}\n.border-red-600 {\n  --border-opacity: 1;\n  border-color: #e02424;\n  border-color: rgba(224, 36, 36, var(--border-opacity));\n}\n.border-red-700 {\n  --border-opacity: 1;\n  border-color: #c81e1e;\n  border-color: rgba(200, 30, 30, var(--border-opacity));\n}\n.border-red-800 {\n  --border-opacity: 1;\n  border-color: #9b1c1c;\n  border-color: rgba(155, 28, 28, var(--border-opacity));\n}\n.border-red-900 {\n  --border-opacity: 1;\n  border-color: #771d1d;\n  border-color: rgba(119, 29, 29, var(--border-opacity));\n}\n.border-orange-50 {\n  --border-opacity: 1;\n  border-color: #fff8f1;\n  border-color: rgba(255, 248, 241, var(--border-opacity));\n}\n.border-orange-100 {\n  --border-opacity: 1;\n  border-color: #feecdc;\n  border-color: rgba(254, 236, 220, var(--border-opacity));\n}\n.border-orange-200 {\n  --border-opacity: 1;\n  border-color: #fcd9bd;\n  border-color: rgba(252, 217, 189, var(--border-opacity));\n}\n.border-orange-300 {\n  --border-opacity: 1;\n  border-color: #fdba8c;\n  border-color: rgba(253, 186, 140, var(--border-opacity));\n}\n.border-orange-400 {\n  --border-opacity: 1;\n  border-color: #ff8a4c;\n  border-color: rgba(255, 138, 76, var(--border-opacity));\n}\n.border-orange-500 {\n  --border-opacity: 1;\n  border-color: #ff5a1f;\n  border-color: rgba(255, 90, 31, var(--border-opacity));\n}\n.border-orange-600 {\n  --border-opacity: 1;\n  border-color: #d03801;\n  border-color: rgba(208, 56, 1, var(--border-opacity));\n}\n.border-orange-700 {\n  --border-opacity: 1;\n  border-color: #b43403;\n  border-color: rgba(180, 52, 3, var(--border-opacity));\n}\n.border-orange-800 {\n  --border-opacity: 1;\n  border-color: #8a2c0d;\n  border-color: rgba(138, 44, 13, var(--border-opacity));\n}\n.border-orange-900 {\n  --border-opacity: 1;\n  border-color: #73230d;\n  border-color: rgba(115, 35, 13, var(--border-opacity));\n}\n.border-yellow-50 {\n  --border-opacity: 1;\n  border-color: #fdfdea;\n  border-color: rgba(253, 253, 234, var(--border-opacity));\n}\n.border-yellow-100 {\n  --border-opacity: 1;\n  border-color: #fdf6b2;\n  border-color: rgba(253, 246, 178, var(--border-opacity));\n}\n.border-yellow-200 {\n  --border-opacity: 1;\n  border-color: #fce96a;\n  border-color: rgba(252, 233, 106, var(--border-opacity));\n}\n.border-yellow-300 {\n  --border-opacity: 1;\n  border-color: #faca15;\n  border-color: rgba(250, 202, 21, var(--border-opacity));\n}\n.border-yellow-400 {\n  --border-opacity: 1;\n  border-color: #e3a008;\n  border-color: rgba(227, 160, 8, var(--border-opacity));\n}\n.border-yellow-500 {\n  --border-opacity: 1;\n  border-color: #c27803;\n  border-color: rgba(194, 120, 3, var(--border-opacity));\n}\n.border-yellow-600 {\n  --border-opacity: 1;\n  border-color: #9f580a;\n  border-color: rgba(159, 88, 10, var(--border-opacity));\n}\n.border-yellow-700 {\n  --border-opacity: 1;\n  border-color: #8e4b10;\n  border-color: rgba(142, 75, 16, var(--border-opacity));\n}\n.border-yellow-800 {\n  --border-opacity: 1;\n  border-color: #723b13;\n  border-color: rgba(114, 59, 19, var(--border-opacity));\n}\n.border-yellow-900 {\n  --border-opacity: 1;\n  border-color: #633112;\n  border-color: rgba(99, 49, 18, var(--border-opacity));\n}\n.border-green-50 {\n  --border-opacity: 1;\n  border-color: #f3faf7;\n  border-color: rgba(243, 250, 247, var(--border-opacity));\n}\n.border-green-100 {\n  --border-opacity: 1;\n  border-color: #def7ec;\n  border-color: rgba(222, 247, 236, var(--border-opacity));\n}\n.border-green-200 {\n  --border-opacity: 1;\n  border-color: #bcf0da;\n  border-color: rgba(188, 240, 218, var(--border-opacity));\n}\n.border-green-300 {\n  --border-opacity: 1;\n  border-color: #84e1bc;\n  border-color: rgba(132, 225, 188, var(--border-opacity));\n}\n.border-green-400 {\n  --border-opacity: 1;\n  border-color: #31c48d;\n  border-color: rgba(49, 196, 141, var(--border-opacity));\n}\n.border-green-500 {\n  --border-opacity: 1;\n  border-color: #0e9f6e;\n  border-color: rgba(14, 159, 110, var(--border-opacity));\n}\n.border-green-600 {\n  --border-opacity: 1;\n  border-color: #057a55;\n  border-color: rgba(5, 122, 85, var(--border-opacity));\n}\n.border-green-700 {\n  --border-opacity: 1;\n  border-color: #046c4e;\n  border-color: rgba(4, 108, 78, var(--border-opacity));\n}\n.border-green-800 {\n  --border-opacity: 1;\n  border-color: #03543f;\n  border-color: rgba(3, 84, 63, var(--border-opacity));\n}\n.border-green-900 {\n  --border-opacity: 1;\n  border-color: #014737;\n  border-color: rgba(1, 71, 55, var(--border-opacity));\n}\n.border-teal-50 {\n  --border-opacity: 1;\n  border-color: #edfafa;\n  border-color: rgba(237, 250, 250, var(--border-opacity));\n}\n.border-teal-100 {\n  --border-opacity: 1;\n  border-color: #d5f5f6;\n  border-color: rgba(213, 245, 246, var(--border-opacity));\n}\n.border-teal-200 {\n  --border-opacity: 1;\n  border-color: #afecef;\n  border-color: rgba(175, 236, 239, var(--border-opacity));\n}\n.border-teal-300 {\n  --border-opacity: 1;\n  border-color: #7edce2;\n  border-color: rgba(126, 220, 226, var(--border-opacity));\n}\n.border-teal-400 {\n  --border-opacity: 1;\n  border-color: #16bdca;\n  border-color: rgba(22, 189, 202, var(--border-opacity));\n}\n.border-teal-500 {\n  --border-opacity: 1;\n  border-color: #0694a2;\n  border-color: rgba(6, 148, 162, var(--border-opacity));\n}\n.border-teal-600 {\n  --border-opacity: 1;\n  border-color: #047481;\n  border-color: rgba(4, 116, 129, var(--border-opacity));\n}\n.border-teal-700 {\n  --border-opacity: 1;\n  border-color: #036672;\n  border-color: rgba(3, 102, 114, var(--border-opacity));\n}\n.border-teal-800 {\n  --border-opacity: 1;\n  border-color: #05505c;\n  border-color: rgba(5, 80, 92, var(--border-opacity));\n}\n.border-teal-900 {\n  --border-opacity: 1;\n  border-color: #014451;\n  border-color: rgba(1, 68, 81, var(--border-opacity));\n}\n.border-blue-50 {\n  --border-opacity: 1;\n  border-color: #ebf5ff;\n  border-color: rgba(235, 245, 255, var(--border-opacity));\n}\n.border-blue-100 {\n  --border-opacity: 1;\n  border-color: #e1effe;\n  border-color: rgba(225, 239, 254, var(--border-opacity));\n}\n.border-blue-200 {\n  --border-opacity: 1;\n  border-color: #c3ddfd;\n  border-color: rgba(195, 221, 253, var(--border-opacity));\n}\n.border-blue-300 {\n  --border-opacity: 1;\n  border-color: #a4cafe;\n  border-color: rgba(164, 202, 254, var(--border-opacity));\n}\n.border-blue-400 {\n  --border-opacity: 1;\n  border-color: #76a9fa;\n  border-color: rgba(118, 169, 250, var(--border-opacity));\n}\n.border-blue-500 {\n  --border-opacity: 1;\n  border-color: #3f83f8;\n  border-color: rgba(63, 131, 248, var(--border-opacity));\n}\n.border-blue-600 {\n  --border-opacity: 1;\n  border-color: #1c64f2;\n  border-color: rgba(28, 100, 242, var(--border-opacity));\n}\n.border-blue-700 {\n  --border-opacity: 1;\n  border-color: #1a56db;\n  border-color: rgba(26, 86, 219, var(--border-opacity));\n}\n.border-blue-800 {\n  --border-opacity: 1;\n  border-color: #1e429f;\n  border-color: rgba(30, 66, 159, var(--border-opacity));\n}\n.border-blue-900 {\n  --border-opacity: 1;\n  border-color: #233876;\n  border-color: rgba(35, 56, 118, var(--border-opacity));\n}\n.border-indigo-50 {\n  --border-opacity: 1;\n  border-color: #f0f5ff;\n  border-color: rgba(240, 245, 255, var(--border-opacity));\n}\n.border-indigo-100 {\n  --border-opacity: 1;\n  border-color: #e5edff;\n  border-color: rgba(229, 237, 255, var(--border-opacity));\n}\n.border-indigo-200 {\n  --border-opacity: 1;\n  border-color: #cddbfe;\n  border-color: rgba(205, 219, 254, var(--border-opacity));\n}\n.border-indigo-300 {\n  --border-opacity: 1;\n  border-color: #b4c6fc;\n  border-color: rgba(180, 198, 252, var(--border-opacity));\n}\n.border-indigo-400 {\n  --border-opacity: 1;\n  border-color: #8da2fb;\n  border-color: rgba(141, 162, 251, var(--border-opacity));\n}\n.border-indigo-500 {\n  --border-opacity: 1;\n  border-color: #6875f5;\n  border-color: rgba(104, 117, 245, var(--border-opacity));\n}\n.border-indigo-600 {\n  --border-opacity: 1;\n  border-color: #5850ec;\n  border-color: rgba(88, 80, 236, var(--border-opacity));\n}\n.border-indigo-700 {\n  --border-opacity: 1;\n  border-color: #5145cd;\n  border-color: rgba(81, 69, 205, var(--border-opacity));\n}\n.border-indigo-800 {\n  --border-opacity: 1;\n  border-color: #42389d;\n  border-color: rgba(66, 56, 157, var(--border-opacity));\n}\n.border-indigo-900 {\n  --border-opacity: 1;\n  border-color: #362f78;\n  border-color: rgba(54, 47, 120, var(--border-opacity));\n}\n.border-purple-50 {\n  --border-opacity: 1;\n  border-color: #f6f5ff;\n  border-color: rgba(246, 245, 255, var(--border-opacity));\n}\n.border-purple-100 {\n  --border-opacity: 1;\n  border-color: #edebfe;\n  border-color: rgba(237, 235, 254, var(--border-opacity));\n}\n.border-purple-200 {\n  --border-opacity: 1;\n  border-color: #dcd7fe;\n  border-color: rgba(220, 215, 254, var(--border-opacity));\n}\n.border-purple-300 {\n  --border-opacity: 1;\n  border-color: #cabffd;\n  border-color: rgba(202, 191, 253, var(--border-opacity));\n}\n.border-purple-400 {\n  --border-opacity: 1;\n  border-color: #ac94fa;\n  border-color: rgba(172, 148, 250, var(--border-opacity));\n}\n.border-purple-500 {\n  --border-opacity: 1;\n  border-color: #9061f9;\n  border-color: rgba(144, 97, 249, var(--border-opacity));\n}\n.border-purple-600 {\n  --border-opacity: 1;\n  border-color: #7e3af2;\n  border-color: rgba(126, 58, 242, var(--border-opacity));\n}\n.border-purple-700 {\n  --border-opacity: 1;\n  border-color: #6c2bd9;\n  border-color: rgba(108, 43, 217, var(--border-opacity));\n}\n.border-purple-800 {\n  --border-opacity: 1;\n  border-color: #5521b5;\n  border-color: rgba(85, 33, 181, var(--border-opacity));\n}\n.border-purple-900 {\n  --border-opacity: 1;\n  border-color: #4a1d96;\n  border-color: rgba(74, 29, 150, var(--border-opacity));\n}\n.border-pink-50 {\n  --border-opacity: 1;\n  border-color: #fdf2f8;\n  border-color: rgba(253, 242, 248, var(--border-opacity));\n}\n.border-pink-100 {\n  --border-opacity: 1;\n  border-color: #fce8f3;\n  border-color: rgba(252, 232, 243, var(--border-opacity));\n}\n.border-pink-200 {\n  --border-opacity: 1;\n  border-color: #fad1e8;\n  border-color: rgba(250, 209, 232, var(--border-opacity));\n}\n.border-pink-300 {\n  --border-opacity: 1;\n  border-color: #f8b4d9;\n  border-color: rgba(248, 180, 217, var(--border-opacity));\n}\n.border-pink-400 {\n  --border-opacity: 1;\n  border-color: #f17eb8;\n  border-color: rgba(241, 126, 184, var(--border-opacity));\n}\n.border-pink-500 {\n  --border-opacity: 1;\n  border-color: #e74694;\n  border-color: rgba(231, 70, 148, var(--border-opacity));\n}\n.border-pink-600 {\n  --border-opacity: 1;\n  border-color: #d61f69;\n  border-color: rgba(214, 31, 105, var(--border-opacity));\n}\n.border-pink-700 {\n  --border-opacity: 1;\n  border-color: #bf125d;\n  border-color: rgba(191, 18, 93, var(--border-opacity));\n}\n.border-pink-800 {\n  --border-opacity: 1;\n  border-color: #99154b;\n  border-color: rgba(153, 21, 75, var(--border-opacity));\n}\n.border-pink-900 {\n  --border-opacity: 1;\n  border-color: #751a3d;\n  border-color: rgba(117, 26, 61, var(--border-opacity));\n}\n.border-cool-gray-50 {\n  --border-opacity: 1;\n  border-color: #f8fafc;\n  border-color: rgba(248, 250, 252, var(--border-opacity));\n}\n.border-cool-gray-100 {\n  --border-opacity: 1;\n  border-color: #f1f5f9;\n  border-color: rgba(241, 245, 249, var(--border-opacity));\n}\n.border-cool-gray-200 {\n  --border-opacity: 1;\n  border-color: #e2e8f0;\n  border-color: rgba(226, 232, 240, var(--border-opacity));\n}\n.border-cool-gray-300 {\n  --border-opacity: 1;\n  border-color: #cfd8e3;\n  border-color: rgba(207, 216, 227, var(--border-opacity));\n}\n.border-cool-gray-400 {\n  --border-opacity: 1;\n  border-color: #97a6ba;\n  border-color: rgba(151, 166, 186, var(--border-opacity));\n}\n.border-cool-gray-500 {\n  --border-opacity: 1;\n  border-color: #64748b;\n  border-color: rgba(100, 116, 139, var(--border-opacity));\n}\n.border-cool-gray-600 {\n  --border-opacity: 1;\n  border-color: #475569;\n  border-color: rgba(71, 85, 105, var(--border-opacity));\n}\n.border-cool-gray-700 {\n  --border-opacity: 1;\n  border-color: #364152;\n  border-color: rgba(54, 65, 82, var(--border-opacity));\n}\n.border-cool-gray-800 {\n  --border-opacity: 1;\n  border-color: #27303f;\n  border-color: rgba(39, 48, 63, var(--border-opacity));\n}\n.border-cool-gray-900 {\n  --border-opacity: 1;\n  border-color: #1a202e;\n  border-color: rgba(26, 32, 46, var(--border-opacity));\n}\n.group:hover .group-hover\\:border-current {\n  border-color: currentColor;\n}\n.group:hover .group-hover\\:border-transparent {\n  border-color: transparent;\n}\n.group:hover .group-hover\\:border-white {\n  --border-opacity: 1;\n  border-color: #ffffff;\n  border-color: rgba(255, 255, 255, var(--border-opacity));\n}\n.group:hover .group-hover\\:border-black {\n  --border-opacity: 1;\n  border-color: #000000;\n  border-color: rgba(0, 0, 0, var(--border-opacity));\n}\n.group:hover .group-hover\\:border-gray-50 {\n  --border-opacity: 1;\n  border-color: #f9fafb;\n  border-color: rgba(249, 250, 251, var(--border-opacity));\n}\n.group:hover .group-hover\\:border-gray-100 {\n  --border-opacity: 1;\n  border-color: #f4f5f7;\n  border-color: rgba(244, 245, 247, var(--border-opacity));\n}\n.group:hover .group-hover\\:border-gray-200 {\n  --border-opacity: 1;\n  border-color: #e5e7eb;\n  border-color: rgba(229, 231, 235, var(--border-opacity));\n}\n.group:hover .group-hover\\:border-gray-300 {\n  --border-opacity: 1;\n  border-color: #d2d6dc;\n  border-color: rgba(210, 214, 220, var(--border-opacity));\n}\n.group:hover .group-hover\\:border-gray-400 {\n  --border-opacity: 1;\n  border-color: #9fa6b2;\n  border-color: rgba(159, 166, 178, var(--border-opacity));\n}\n.group:hover .group-hover\\:border-gray-500 {\n  --border-opacity: 1;\n  border-color: #6b7280;\n  border-color: rgba(107, 114, 128, var(--border-opacity));\n}\n.group:hover .group-hover\\:border-gray-600 {\n  --border-opacity: 1;\n  border-color: #4b5563;\n  border-color: rgba(75, 85, 99, var(--border-opacity));\n}\n.group:hover .group-hover\\:border-gray-700 {\n  --border-opacity: 1;\n  border-color: #374151;\n  border-color: rgba(55, 65, 81, var(--border-opacity));\n}\n.group:hover .group-hover\\:border-gray-800 {\n  --border-opacity: 1;\n  border-color: #252f3f;\n  border-color: rgba(37, 47, 63, var(--border-opacity));\n}\n.group:hover .group-hover\\:border-gray-900 {\n  --border-opacity: 1;\n  border-color: #161e2e;\n  border-color: rgba(22, 30, 46, var(--border-opacity));\n}\n.group:hover .group-hover\\:border-red-50 {\n  --border-opacity: 1;\n  border-color: #fdf2f2;\n  border-color: rgba(253, 242, 242, var(--border-opacity));\n}\n.group:hover .group-hover\\:border-red-100 {\n  --border-opacity: 1;\n  border-color: #fde8e8;\n  border-color: rgba(253, 232, 232, var(--border-opacity));\n}\n.group:hover .group-hover\\:border-red-200 {\n  --border-opacity: 1;\n  border-color: #fbd5d5;\n  border-color: rgba(251, 213, 213, var(--border-opacity));\n}\n.group:hover .group-hover\\:border-red-300 {\n  --border-opacity: 1;\n  border-color: #f8b4b4;\n  border-color: rgba(248, 180, 180, var(--border-opacity));\n}\n.group:hover .group-hover\\:border-red-400 {\n  --border-opacity: 1;\n  border-color: #f98080;\n  border-color: rgba(249, 128, 128, var(--border-opacity));\n}\n.group:hover .group-hover\\:border-red-500 {\n  --border-opacity: 1;\n  border-color: #f05252;\n  border-color: rgba(240, 82, 82, var(--border-opacity));\n}\n.group:hover .group-hover\\:border-red-600 {\n  --border-opacity: 1;\n  border-color: #e02424;\n  border-color: rgba(224, 36, 36, var(--border-opacity));\n}\n.group:hover .group-hover\\:border-red-700 {\n  --border-opacity: 1;\n  border-color: #c81e1e;\n  border-color: rgba(200, 30, 30, var(--border-opacity));\n}\n.group:hover .group-hover\\:border-red-800 {\n  --border-opacity: 1;\n  border-color: #9b1c1c;\n  border-color: rgba(155, 28, 28, var(--border-opacity));\n}\n.group:hover .group-hover\\:border-red-900 {\n  --border-opacity: 1;\n  border-color: #771d1d;\n  border-color: rgba(119, 29, 29, var(--border-opacity));\n}\n.group:hover .group-hover\\:border-orange-50 {\n  --border-opacity: 1;\n  border-color: #fff8f1;\n  border-color: rgba(255, 248, 241, var(--border-opacity));\n}\n.group:hover .group-hover\\:border-orange-100 {\n  --border-opacity: 1;\n  border-color: #feecdc;\n  border-color: rgba(254, 236, 220, var(--border-opacity));\n}\n.group:hover .group-hover\\:border-orange-200 {\n  --border-opacity: 1;\n  border-color: #fcd9bd;\n  border-color: rgba(252, 217, 189, var(--border-opacity));\n}\n.group:hover .group-hover\\:border-orange-300 {\n  --border-opacity: 1;\n  border-color: #fdba8c;\n  border-color: rgba(253, 186, 140, var(--border-opacity));\n}\n.group:hover .group-hover\\:border-orange-400 {\n  --border-opacity: 1;\n  border-color: #ff8a4c;\n  border-color: rgba(255, 138, 76, var(--border-opacity));\n}\n.group:hover .group-hover\\:border-orange-500 {\n  --border-opacity: 1;\n  border-color: #ff5a1f;\n  border-color: rgba(255, 90, 31, var(--border-opacity));\n}\n.group:hover .group-hover\\:border-orange-600 {\n  --border-opacity: 1;\n  border-color: #d03801;\n  border-color: rgba(208, 56, 1, var(--border-opacity));\n}\n.group:hover .group-hover\\:border-orange-700 {\n  --border-opacity: 1;\n  border-color: #b43403;\n  border-color: rgba(180, 52, 3, var(--border-opacity));\n}\n.group:hover .group-hover\\:border-orange-800 {\n  --border-opacity: 1;\n  border-color: #8a2c0d;\n  border-color: rgba(138, 44, 13, var(--border-opacity));\n}\n.group:hover .group-hover\\:border-orange-900 {\n  --border-opacity: 1;\n  border-color: #73230d;\n  border-color: rgba(115, 35, 13, var(--border-opacity));\n}\n.group:hover .group-hover\\:border-yellow-50 {\n  --border-opacity: 1;\n  border-color: #fdfdea;\n  border-color: rgba(253, 253, 234, var(--border-opacity));\n}\n.group:hover .group-hover\\:border-yellow-100 {\n  --border-opacity: 1;\n  border-color: #fdf6b2;\n  border-color: rgba(253, 246, 178, var(--border-opacity));\n}\n.group:hover .group-hover\\:border-yellow-200 {\n  --border-opacity: 1;\n  border-color: #fce96a;\n  border-color: rgba(252, 233, 106, var(--border-opacity));\n}\n.group:hover .group-hover\\:border-yellow-300 {\n  --border-opacity: 1;\n  border-color: #faca15;\n  border-color: rgba(250, 202, 21, var(--border-opacity));\n}\n.group:hover .group-hover\\:border-yellow-400 {\n  --border-opacity: 1;\n  border-color: #e3a008;\n  border-color: rgba(227, 160, 8, var(--border-opacity));\n}\n.group:hover .group-hover\\:border-yellow-500 {\n  --border-opacity: 1;\n  border-color: #c27803;\n  border-color: rgba(194, 120, 3, var(--border-opacity));\n}\n.group:hover .group-hover\\:border-yellow-600 {\n  --border-opacity: 1;\n  border-color: #9f580a;\n  border-color: rgba(159, 88, 10, var(--border-opacity));\n}\n.group:hover .group-hover\\:border-yellow-700 {\n  --border-opacity: 1;\n  border-color: #8e4b10;\n  border-color: rgba(142, 75, 16, var(--border-opacity));\n}\n.group:hover .group-hover\\:border-yellow-800 {\n  --border-opacity: 1;\n  border-color: #723b13;\n  border-color: rgba(114, 59, 19, var(--border-opacity));\n}\n.group:hover .group-hover\\:border-yellow-900 {\n  --border-opacity: 1;\n  border-color: #633112;\n  border-color: rgba(99, 49, 18, var(--border-opacity));\n}\n.group:hover .group-hover\\:border-green-50 {\n  --border-opacity: 1;\n  border-color: #f3faf7;\n  border-color: rgba(243, 250, 247, var(--border-opacity));\n}\n.group:hover .group-hover\\:border-green-100 {\n  --border-opacity: 1;\n  border-color: #def7ec;\n  border-color: rgba(222, 247, 236, var(--border-opacity));\n}\n.group:hover .group-hover\\:border-green-200 {\n  --border-opacity: 1;\n  border-color: #bcf0da;\n  border-color: rgba(188, 240, 218, var(--border-opacity));\n}\n.group:hover .group-hover\\:border-green-300 {\n  --border-opacity: 1;\n  border-color: #84e1bc;\n  border-color: rgba(132, 225, 188, var(--border-opacity));\n}\n.group:hover .group-hover\\:border-green-400 {\n  --border-opacity: 1;\n  border-color: #31c48d;\n  border-color: rgba(49, 196, 141, var(--border-opacity));\n}\n.group:hover .group-hover\\:border-green-500 {\n  --border-opacity: 1;\n  border-color: #0e9f6e;\n  border-color: rgba(14, 159, 110, var(--border-opacity));\n}\n.group:hover .group-hover\\:border-green-600 {\n  --border-opacity: 1;\n  border-color: #057a55;\n  border-color: rgba(5, 122, 85, var(--border-opacity));\n}\n.group:hover .group-hover\\:border-green-700 {\n  --border-opacity: 1;\n  border-color: #046c4e;\n  border-color: rgba(4, 108, 78, var(--border-opacity));\n}\n.group:hover .group-hover\\:border-green-800 {\n  --border-opacity: 1;\n  border-color: #03543f;\n  border-color: rgba(3, 84, 63, var(--border-opacity));\n}\n.group:hover .group-hover\\:border-green-900 {\n  --border-opacity: 1;\n  border-color: #014737;\n  border-color: rgba(1, 71, 55, var(--border-opacity));\n}\n.group:hover .group-hover\\:border-teal-50 {\n  --border-opacity: 1;\n  border-color: #edfafa;\n  border-color: rgba(237, 250, 250, var(--border-opacity));\n}\n.group:hover .group-hover\\:border-teal-100 {\n  --border-opacity: 1;\n  border-color: #d5f5f6;\n  border-color: rgba(213, 245, 246, var(--border-opacity));\n}\n.group:hover .group-hover\\:border-teal-200 {\n  --border-opacity: 1;\n  border-color: #afecef;\n  border-color: rgba(175, 236, 239, var(--border-opacity));\n}\n.group:hover .group-hover\\:border-teal-300 {\n  --border-opacity: 1;\n  border-color: #7edce2;\n  border-color: rgba(126, 220, 226, var(--border-opacity));\n}\n.group:hover .group-hover\\:border-teal-400 {\n  --border-opacity: 1;\n  border-color: #16bdca;\n  border-color: rgba(22, 189, 202, var(--border-opacity));\n}\n.group:hover .group-hover\\:border-teal-500 {\n  --border-opacity: 1;\n  border-color: #0694a2;\n  border-color: rgba(6, 148, 162, var(--border-opacity));\n}\n.group:hover .group-hover\\:border-teal-600 {\n  --border-opacity: 1;\n  border-color: #047481;\n  border-color: rgba(4, 116, 129, var(--border-opacity));\n}\n.group:hover .group-hover\\:border-teal-700 {\n  --border-opacity: 1;\n  border-color: #036672;\n  border-color: rgba(3, 102, 114, var(--border-opacity));\n}\n.group:hover .group-hover\\:border-teal-800 {\n  --border-opacity: 1;\n  border-color: #05505c;\n  border-color: rgba(5, 80, 92, var(--border-opacity));\n}\n.group:hover .group-hover\\:border-teal-900 {\n  --border-opacity: 1;\n  border-color: #014451;\n  border-color: rgba(1, 68, 81, var(--border-opacity));\n}\n.group:hover .group-hover\\:border-blue-50 {\n  --border-opacity: 1;\n  border-color: #ebf5ff;\n  border-color: rgba(235, 245, 255, var(--border-opacity));\n}\n.group:hover .group-hover\\:border-blue-100 {\n  --border-opacity: 1;\n  border-color: #e1effe;\n  border-color: rgba(225, 239, 254, var(--border-opacity));\n}\n.group:hover .group-hover\\:border-blue-200 {\n  --border-opacity: 1;\n  border-color: #c3ddfd;\n  border-color: rgba(195, 221, 253, var(--border-opacity));\n}\n.group:hover .group-hover\\:border-blue-300 {\n  --border-opacity: 1;\n  border-color: #a4cafe;\n  border-color: rgba(164, 202, 254, var(--border-opacity));\n}\n.group:hover .group-hover\\:border-blue-400 {\n  --border-opacity: 1;\n  border-color: #76a9fa;\n  border-color: rgba(118, 169, 250, var(--border-opacity));\n}\n.group:hover .group-hover\\:border-blue-500 {\n  --border-opacity: 1;\n  border-color: #3f83f8;\n  border-color: rgba(63, 131, 248, var(--border-opacity));\n}\n.group:hover .group-hover\\:border-blue-600 {\n  --border-opacity: 1;\n  border-color: #1c64f2;\n  border-color: rgba(28, 100, 242, var(--border-opacity));\n}\n.group:hover .group-hover\\:border-blue-700 {\n  --border-opacity: 1;\n  border-color: #1a56db;\n  border-color: rgba(26, 86, 219, var(--border-opacity));\n}\n.group:hover .group-hover\\:border-blue-800 {\n  --border-opacity: 1;\n  border-color: #1e429f;\n  border-color: rgba(30, 66, 159, var(--border-opacity));\n}\n.group:hover .group-hover\\:border-blue-900 {\n  --border-opacity: 1;\n  border-color: #233876;\n  border-color: rgba(35, 56, 118, var(--border-opacity));\n}\n.group:hover .group-hover\\:border-indigo-50 {\n  --border-opacity: 1;\n  border-color: #f0f5ff;\n  border-color: rgba(240, 245, 255, var(--border-opacity));\n}\n.group:hover .group-hover\\:border-indigo-100 {\n  --border-opacity: 1;\n  border-color: #e5edff;\n  border-color: rgba(229, 237, 255, var(--border-opacity));\n}\n.group:hover .group-hover\\:border-indigo-200 {\n  --border-opacity: 1;\n  border-color: #cddbfe;\n  border-color: rgba(205, 219, 254, var(--border-opacity));\n}\n.group:hover .group-hover\\:border-indigo-300 {\n  --border-opacity: 1;\n  border-color: #b4c6fc;\n  border-color: rgba(180, 198, 252, var(--border-opacity));\n}\n.group:hover .group-hover\\:border-indigo-400 {\n  --border-opacity: 1;\n  border-color: #8da2fb;\n  border-color: rgba(141, 162, 251, var(--border-opacity));\n}\n.group:hover .group-hover\\:border-indigo-500 {\n  --border-opacity: 1;\n  border-color: #6875f5;\n  border-color: rgba(104, 117, 245, var(--border-opacity));\n}\n.group:hover .group-hover\\:border-indigo-600 {\n  --border-opacity: 1;\n  border-color: #5850ec;\n  border-color: rgba(88, 80, 236, var(--border-opacity));\n}\n.group:hover .group-hover\\:border-indigo-700 {\n  --border-opacity: 1;\n  border-color: #5145cd;\n  border-color: rgba(81, 69, 205, var(--border-opacity));\n}\n.group:hover .group-hover\\:border-indigo-800 {\n  --border-opacity: 1;\n  border-color: #42389d;\n  border-color: rgba(66, 56, 157, var(--border-opacity));\n}\n.group:hover .group-hover\\:border-indigo-900 {\n  --border-opacity: 1;\n  border-color: #362f78;\n  border-color: rgba(54, 47, 120, var(--border-opacity));\n}\n.group:hover .group-hover\\:border-purple-50 {\n  --border-opacity: 1;\n  border-color: #f6f5ff;\n  border-color: rgba(246, 245, 255, var(--border-opacity));\n}\n.group:hover .group-hover\\:border-purple-100 {\n  --border-opacity: 1;\n  border-color: #edebfe;\n  border-color: rgba(237, 235, 254, var(--border-opacity));\n}\n.group:hover .group-hover\\:border-purple-200 {\n  --border-opacity: 1;\n  border-color: #dcd7fe;\n  border-color: rgba(220, 215, 254, var(--border-opacity));\n}\n.group:hover .group-hover\\:border-purple-300 {\n  --border-opacity: 1;\n  border-color: #cabffd;\n  border-color: rgba(202, 191, 253, var(--border-opacity));\n}\n.group:hover .group-hover\\:border-purple-400 {\n  --border-opacity: 1;\n  border-color: #ac94fa;\n  border-color: rgba(172, 148, 250, var(--border-opacity));\n}\n.group:hover .group-hover\\:border-purple-500 {\n  --border-opacity: 1;\n  border-color: #9061f9;\n  border-color: rgba(144, 97, 249, var(--border-opacity));\n}\n.group:hover .group-hover\\:border-purple-600 {\n  --border-opacity: 1;\n  border-color: #7e3af2;\n  border-color: rgba(126, 58, 242, var(--border-opacity));\n}\n.group:hover .group-hover\\:border-purple-700 {\n  --border-opacity: 1;\n  border-color: #6c2bd9;\n  border-color: rgba(108, 43, 217, var(--border-opacity));\n}\n.group:hover .group-hover\\:border-purple-800 {\n  --border-opacity: 1;\n  border-color: #5521b5;\n  border-color: rgba(85, 33, 181, var(--border-opacity));\n}\n.group:hover .group-hover\\:border-purple-900 {\n  --border-opacity: 1;\n  border-color: #4a1d96;\n  border-color: rgba(74, 29, 150, var(--border-opacity));\n}\n.group:hover .group-hover\\:border-pink-50 {\n  --border-opacity: 1;\n  border-color: #fdf2f8;\n  border-color: rgba(253, 242, 248, var(--border-opacity));\n}\n.group:hover .group-hover\\:border-pink-100 {\n  --border-opacity: 1;\n  border-color: #fce8f3;\n  border-color: rgba(252, 232, 243, var(--border-opacity));\n}\n.group:hover .group-hover\\:border-pink-200 {\n  --border-opacity: 1;\n  border-color: #fad1e8;\n  border-color: rgba(250, 209, 232, var(--border-opacity));\n}\n.group:hover .group-hover\\:border-pink-300 {\n  --border-opacity: 1;\n  border-color: #f8b4d9;\n  border-color: rgba(248, 180, 217, var(--border-opacity));\n}\n.group:hover .group-hover\\:border-pink-400 {\n  --border-opacity: 1;\n  border-color: #f17eb8;\n  border-color: rgba(241, 126, 184, var(--border-opacity));\n}\n.group:hover .group-hover\\:border-pink-500 {\n  --border-opacity: 1;\n  border-color: #e74694;\n  border-color: rgba(231, 70, 148, var(--border-opacity));\n}\n.group:hover .group-hover\\:border-pink-600 {\n  --border-opacity: 1;\n  border-color: #d61f69;\n  border-color: rgba(214, 31, 105, var(--border-opacity));\n}\n.group:hover .group-hover\\:border-pink-700 {\n  --border-opacity: 1;\n  border-color: #bf125d;\n  border-color: rgba(191, 18, 93, var(--border-opacity));\n}\n.group:hover .group-hover\\:border-pink-800 {\n  --border-opacity: 1;\n  border-color: #99154b;\n  border-color: rgba(153, 21, 75, var(--border-opacity));\n}\n.group:hover .group-hover\\:border-pink-900 {\n  --border-opacity: 1;\n  border-color: #751a3d;\n  border-color: rgba(117, 26, 61, var(--border-opacity));\n}\n.group:hover .group-hover\\:border-cool-gray-50 {\n  --border-opacity: 1;\n  border-color: #f8fafc;\n  border-color: rgba(248, 250, 252, var(--border-opacity));\n}\n.group:hover .group-hover\\:border-cool-gray-100 {\n  --border-opacity: 1;\n  border-color: #f1f5f9;\n  border-color: rgba(241, 245, 249, var(--border-opacity));\n}\n.group:hover .group-hover\\:border-cool-gray-200 {\n  --border-opacity: 1;\n  border-color: #e2e8f0;\n  border-color: rgba(226, 232, 240, var(--border-opacity));\n}\n.group:hover .group-hover\\:border-cool-gray-300 {\n  --border-opacity: 1;\n  border-color: #cfd8e3;\n  border-color: rgba(207, 216, 227, var(--border-opacity));\n}\n.group:hover .group-hover\\:border-cool-gray-400 {\n  --border-opacity: 1;\n  border-color: #97a6ba;\n  border-color: rgba(151, 166, 186, var(--border-opacity));\n}\n.group:hover .group-hover\\:border-cool-gray-500 {\n  --border-opacity: 1;\n  border-color: #64748b;\n  border-color: rgba(100, 116, 139, var(--border-opacity));\n}\n.group:hover .group-hover\\:border-cool-gray-600 {\n  --border-opacity: 1;\n  border-color: #475569;\n  border-color: rgba(71, 85, 105, var(--border-opacity));\n}\n.group:hover .group-hover\\:border-cool-gray-700 {\n  --border-opacity: 1;\n  border-color: #364152;\n  border-color: rgba(54, 65, 82, var(--border-opacity));\n}\n.group:hover .group-hover\\:border-cool-gray-800 {\n  --border-opacity: 1;\n  border-color: #27303f;\n  border-color: rgba(39, 48, 63, var(--border-opacity));\n}\n.group:hover .group-hover\\:border-cool-gray-900 {\n  --border-opacity: 1;\n  border-color: #1a202e;\n  border-color: rgba(26, 32, 46, var(--border-opacity));\n}\n.group:focus .group-focus\\:border-current {\n  border-color: currentColor;\n}\n.group:focus .group-focus\\:border-transparent {\n  border-color: transparent;\n}\n.group:focus .group-focus\\:border-white {\n  --border-opacity: 1;\n  border-color: #ffffff;\n  border-color: rgba(255, 255, 255, var(--border-opacity));\n}\n.group:focus .group-focus\\:border-black {\n  --border-opacity: 1;\n  border-color: #000000;\n  border-color: rgba(0, 0, 0, var(--border-opacity));\n}\n.group:focus .group-focus\\:border-gray-50 {\n  --border-opacity: 1;\n  border-color: #f9fafb;\n  border-color: rgba(249, 250, 251, var(--border-opacity));\n}\n.group:focus .group-focus\\:border-gray-100 {\n  --border-opacity: 1;\n  border-color: #f4f5f7;\n  border-color: rgba(244, 245, 247, var(--border-opacity));\n}\n.group:focus .group-focus\\:border-gray-200 {\n  --border-opacity: 1;\n  border-color: #e5e7eb;\n  border-color: rgba(229, 231, 235, var(--border-opacity));\n}\n.group:focus .group-focus\\:border-gray-300 {\n  --border-opacity: 1;\n  border-color: #d2d6dc;\n  border-color: rgba(210, 214, 220, var(--border-opacity));\n}\n.group:focus .group-focus\\:border-gray-400 {\n  --border-opacity: 1;\n  border-color: #9fa6b2;\n  border-color: rgba(159, 166, 178, var(--border-opacity));\n}\n.group:focus .group-focus\\:border-gray-500 {\n  --border-opacity: 1;\n  border-color: #6b7280;\n  border-color: rgba(107, 114, 128, var(--border-opacity));\n}\n.group:focus .group-focus\\:border-gray-600 {\n  --border-opacity: 1;\n  border-color: #4b5563;\n  border-color: rgba(75, 85, 99, var(--border-opacity));\n}\n.group:focus .group-focus\\:border-gray-700 {\n  --border-opacity: 1;\n  border-color: #374151;\n  border-color: rgba(55, 65, 81, var(--border-opacity));\n}\n.group:focus .group-focus\\:border-gray-800 {\n  --border-opacity: 1;\n  border-color: #252f3f;\n  border-color: rgba(37, 47, 63, var(--border-opacity));\n}\n.group:focus .group-focus\\:border-gray-900 {\n  --border-opacity: 1;\n  border-color: #161e2e;\n  border-color: rgba(22, 30, 46, var(--border-opacity));\n}\n.group:focus .group-focus\\:border-red-50 {\n  --border-opacity: 1;\n  border-color: #fdf2f2;\n  border-color: rgba(253, 242, 242, var(--border-opacity));\n}\n.group:focus .group-focus\\:border-red-100 {\n  --border-opacity: 1;\n  border-color: #fde8e8;\n  border-color: rgba(253, 232, 232, var(--border-opacity));\n}\n.group:focus .group-focus\\:border-red-200 {\n  --border-opacity: 1;\n  border-color: #fbd5d5;\n  border-color: rgba(251, 213, 213, var(--border-opacity));\n}\n.group:focus .group-focus\\:border-red-300 {\n  --border-opacity: 1;\n  border-color: #f8b4b4;\n  border-color: rgba(248, 180, 180, var(--border-opacity));\n}\n.group:focus .group-focus\\:border-red-400 {\n  --border-opacity: 1;\n  border-color: #f98080;\n  border-color: rgba(249, 128, 128, var(--border-opacity));\n}\n.group:focus .group-focus\\:border-red-500 {\n  --border-opacity: 1;\n  border-color: #f05252;\n  border-color: rgba(240, 82, 82, var(--border-opacity));\n}\n.group:focus .group-focus\\:border-red-600 {\n  --border-opacity: 1;\n  border-color: #e02424;\n  border-color: rgba(224, 36, 36, var(--border-opacity));\n}\n.group:focus .group-focus\\:border-red-700 {\n  --border-opacity: 1;\n  border-color: #c81e1e;\n  border-color: rgba(200, 30, 30, var(--border-opacity));\n}\n.group:focus .group-focus\\:border-red-800 {\n  --border-opacity: 1;\n  border-color: #9b1c1c;\n  border-color: rgba(155, 28, 28, var(--border-opacity));\n}\n.group:focus .group-focus\\:border-red-900 {\n  --border-opacity: 1;\n  border-color: #771d1d;\n  border-color: rgba(119, 29, 29, var(--border-opacity));\n}\n.group:focus .group-focus\\:border-orange-50 {\n  --border-opacity: 1;\n  border-color: #fff8f1;\n  border-color: rgba(255, 248, 241, var(--border-opacity));\n}\n.group:focus .group-focus\\:border-orange-100 {\n  --border-opacity: 1;\n  border-color: #feecdc;\n  border-color: rgba(254, 236, 220, var(--border-opacity));\n}\n.group:focus .group-focus\\:border-orange-200 {\n  --border-opacity: 1;\n  border-color: #fcd9bd;\n  border-color: rgba(252, 217, 189, var(--border-opacity));\n}\n.group:focus .group-focus\\:border-orange-300 {\n  --border-opacity: 1;\n  border-color: #fdba8c;\n  border-color: rgba(253, 186, 140, var(--border-opacity));\n}\n.group:focus .group-focus\\:border-orange-400 {\n  --border-opacity: 1;\n  border-color: #ff8a4c;\n  border-color: rgba(255, 138, 76, var(--border-opacity));\n}\n.group:focus .group-focus\\:border-orange-500 {\n  --border-opacity: 1;\n  border-color: #ff5a1f;\n  border-color: rgba(255, 90, 31, var(--border-opacity));\n}\n.group:focus .group-focus\\:border-orange-600 {\n  --border-opacity: 1;\n  border-color: #d03801;\n  border-color: rgba(208, 56, 1, var(--border-opacity));\n}\n.group:focus .group-focus\\:border-orange-700 {\n  --border-opacity: 1;\n  border-color: #b43403;\n  border-color: rgba(180, 52, 3, var(--border-opacity));\n}\n.group:focus .group-focus\\:border-orange-800 {\n  --border-opacity: 1;\n  border-color: #8a2c0d;\n  border-color: rgba(138, 44, 13, var(--border-opacity));\n}\n.group:focus .group-focus\\:border-orange-900 {\n  --border-opacity: 1;\n  border-color: #73230d;\n  border-color: rgba(115, 35, 13, var(--border-opacity));\n}\n.group:focus .group-focus\\:border-yellow-50 {\n  --border-opacity: 1;\n  border-color: #fdfdea;\n  border-color: rgba(253, 253, 234, var(--border-opacity));\n}\n.group:focus .group-focus\\:border-yellow-100 {\n  --border-opacity: 1;\n  border-color: #fdf6b2;\n  border-color: rgba(253, 246, 178, var(--border-opacity));\n}\n.group:focus .group-focus\\:border-yellow-200 {\n  --border-opacity: 1;\n  border-color: #fce96a;\n  border-color: rgba(252, 233, 106, var(--border-opacity));\n}\n.group:focus .group-focus\\:border-yellow-300 {\n  --border-opacity: 1;\n  border-color: #faca15;\n  border-color: rgba(250, 202, 21, var(--border-opacity));\n}\n.group:focus .group-focus\\:border-yellow-400 {\n  --border-opacity: 1;\n  border-color: #e3a008;\n  border-color: rgba(227, 160, 8, var(--border-opacity));\n}\n.group:focus .group-focus\\:border-yellow-500 {\n  --border-opacity: 1;\n  border-color: #c27803;\n  border-color: rgba(194, 120, 3, var(--border-opacity));\n}\n.group:focus .group-focus\\:border-yellow-600 {\n  --border-opacity: 1;\n  border-color: #9f580a;\n  border-color: rgba(159, 88, 10, var(--border-opacity));\n}\n.group:focus .group-focus\\:border-yellow-700 {\n  --border-opacity: 1;\n  border-color: #8e4b10;\n  border-color: rgba(142, 75, 16, var(--border-opacity));\n}\n.group:focus .group-focus\\:border-yellow-800 {\n  --border-opacity: 1;\n  border-color: #723b13;\n  border-color: rgba(114, 59, 19, var(--border-opacity));\n}\n.group:focus .group-focus\\:border-yellow-900 {\n  --border-opacity: 1;\n  border-color: #633112;\n  border-color: rgba(99, 49, 18, var(--border-opacity));\n}\n.group:focus .group-focus\\:border-green-50 {\n  --border-opacity: 1;\n  border-color: #f3faf7;\n  border-color: rgba(243, 250, 247, var(--border-opacity));\n}\n.group:focus .group-focus\\:border-green-100 {\n  --border-opacity: 1;\n  border-color: #def7ec;\n  border-color: rgba(222, 247, 236, var(--border-opacity));\n}\n.group:focus .group-focus\\:border-green-200 {\n  --border-opacity: 1;\n  border-color: #bcf0da;\n  border-color: rgba(188, 240, 218, var(--border-opacity));\n}\n.group:focus .group-focus\\:border-green-300 {\n  --border-opacity: 1;\n  border-color: #84e1bc;\n  border-color: rgba(132, 225, 188, var(--border-opacity));\n}\n.group:focus .group-focus\\:border-green-400 {\n  --border-opacity: 1;\n  border-color: #31c48d;\n  border-color: rgba(49, 196, 141, var(--border-opacity));\n}\n.group:focus .group-focus\\:border-green-500 {\n  --border-opacity: 1;\n  border-color: #0e9f6e;\n  border-color: rgba(14, 159, 110, var(--border-opacity));\n}\n.group:focus .group-focus\\:border-green-600 {\n  --border-opacity: 1;\n  border-color: #057a55;\n  border-color: rgba(5, 122, 85, var(--border-opacity));\n}\n.group:focus .group-focus\\:border-green-700 {\n  --border-opacity: 1;\n  border-color: #046c4e;\n  border-color: rgba(4, 108, 78, var(--border-opacity));\n}\n.group:focus .group-focus\\:border-green-800 {\n  --border-opacity: 1;\n  border-color: #03543f;\n  border-color: rgba(3, 84, 63, var(--border-opacity));\n}\n.group:focus .group-focus\\:border-green-900 {\n  --border-opacity: 1;\n  border-color: #014737;\n  border-color: rgba(1, 71, 55, var(--border-opacity));\n}\n.group:focus .group-focus\\:border-teal-50 {\n  --border-opacity: 1;\n  border-color: #edfafa;\n  border-color: rgba(237, 250, 250, var(--border-opacity));\n}\n.group:focus .group-focus\\:border-teal-100 {\n  --border-opacity: 1;\n  border-color: #d5f5f6;\n  border-color: rgba(213, 245, 246, var(--border-opacity));\n}\n.group:focus .group-focus\\:border-teal-200 {\n  --border-opacity: 1;\n  border-color: #afecef;\n  border-color: rgba(175, 236, 239, var(--border-opacity));\n}\n.group:focus .group-focus\\:border-teal-300 {\n  --border-opacity: 1;\n  border-color: #7edce2;\n  border-color: rgba(126, 220, 226, var(--border-opacity));\n}\n.group:focus .group-focus\\:border-teal-400 {\n  --border-opacity: 1;\n  border-color: #16bdca;\n  border-color: rgba(22, 189, 202, var(--border-opacity));\n}\n.group:focus .group-focus\\:border-teal-500 {\n  --border-opacity: 1;\n  border-color: #0694a2;\n  border-color: rgba(6, 148, 162, var(--border-opacity));\n}\n.group:focus .group-focus\\:border-teal-600 {\n  --border-opacity: 1;\n  border-color: #047481;\n  border-color: rgba(4, 116, 129, var(--border-opacity));\n}\n.group:focus .group-focus\\:border-teal-700 {\n  --border-opacity: 1;\n  border-color: #036672;\n  border-color: rgba(3, 102, 114, var(--border-opacity));\n}\n.group:focus .group-focus\\:border-teal-800 {\n  --border-opacity: 1;\n  border-color: #05505c;\n  border-color: rgba(5, 80, 92, var(--border-opacity));\n}\n.group:focus .group-focus\\:border-teal-900 {\n  --border-opacity: 1;\n  border-color: #014451;\n  border-color: rgba(1, 68, 81, var(--border-opacity));\n}\n.group:focus .group-focus\\:border-blue-50 {\n  --border-opacity: 1;\n  border-color: #ebf5ff;\n  border-color: rgba(235, 245, 255, var(--border-opacity));\n}\n.group:focus .group-focus\\:border-blue-100 {\n  --border-opacity: 1;\n  border-color: #e1effe;\n  border-color: rgba(225, 239, 254, var(--border-opacity));\n}\n.group:focus .group-focus\\:border-blue-200 {\n  --border-opacity: 1;\n  border-color: #c3ddfd;\n  border-color: rgba(195, 221, 253, var(--border-opacity));\n}\n.group:focus .group-focus\\:border-blue-300 {\n  --border-opacity: 1;\n  border-color: #a4cafe;\n  border-color: rgba(164, 202, 254, var(--border-opacity));\n}\n.group:focus .group-focus\\:border-blue-400 {\n  --border-opacity: 1;\n  border-color: #76a9fa;\n  border-color: rgba(118, 169, 250, var(--border-opacity));\n}\n.group:focus .group-focus\\:border-blue-500 {\n  --border-opacity: 1;\n  border-color: #3f83f8;\n  border-color: rgba(63, 131, 248, var(--border-opacity));\n}\n.group:focus .group-focus\\:border-blue-600 {\n  --border-opacity: 1;\n  border-color: #1c64f2;\n  border-color: rgba(28, 100, 242, var(--border-opacity));\n}\n.group:focus .group-focus\\:border-blue-700 {\n  --border-opacity: 1;\n  border-color: #1a56db;\n  border-color: rgba(26, 86, 219, var(--border-opacity));\n}\n.group:focus .group-focus\\:border-blue-800 {\n  --border-opacity: 1;\n  border-color: #1e429f;\n  border-color: rgba(30, 66, 159, var(--border-opacity));\n}\n.group:focus .group-focus\\:border-blue-900 {\n  --border-opacity: 1;\n  border-color: #233876;\n  border-color: rgba(35, 56, 118, var(--border-opacity));\n}\n.group:focus .group-focus\\:border-indigo-50 {\n  --border-opacity: 1;\n  border-color: #f0f5ff;\n  border-color: rgba(240, 245, 255, var(--border-opacity));\n}\n.group:focus .group-focus\\:border-indigo-100 {\n  --border-opacity: 1;\n  border-color: #e5edff;\n  border-color: rgba(229, 237, 255, var(--border-opacity));\n}\n.group:focus .group-focus\\:border-indigo-200 {\n  --border-opacity: 1;\n  border-color: #cddbfe;\n  border-color: rgba(205, 219, 254, var(--border-opacity));\n}\n.group:focus .group-focus\\:border-indigo-300 {\n  --border-opacity: 1;\n  border-color: #b4c6fc;\n  border-color: rgba(180, 198, 252, var(--border-opacity));\n}\n.group:focus .group-focus\\:border-indigo-400 {\n  --border-opacity: 1;\n  border-color: #8da2fb;\n  border-color: rgba(141, 162, 251, var(--border-opacity));\n}\n.group:focus .group-focus\\:border-indigo-500 {\n  --border-opacity: 1;\n  border-color: #6875f5;\n  border-color: rgba(104, 117, 245, var(--border-opacity));\n}\n.group:focus .group-focus\\:border-indigo-600 {\n  --border-opacity: 1;\n  border-color: #5850ec;\n  border-color: rgba(88, 80, 236, var(--border-opacity));\n}\n.group:focus .group-focus\\:border-indigo-700 {\n  --border-opacity: 1;\n  border-color: #5145cd;\n  border-color: rgba(81, 69, 205, var(--border-opacity));\n}\n.group:focus .group-focus\\:border-indigo-800 {\n  --border-opacity: 1;\n  border-color: #42389d;\n  border-color: rgba(66, 56, 157, var(--border-opacity));\n}\n.group:focus .group-focus\\:border-indigo-900 {\n  --border-opacity: 1;\n  border-color: #362f78;\n  border-color: rgba(54, 47, 120, var(--border-opacity));\n}\n.group:focus .group-focus\\:border-purple-50 {\n  --border-opacity: 1;\n  border-color: #f6f5ff;\n  border-color: rgba(246, 245, 255, var(--border-opacity));\n}\n.group:focus .group-focus\\:border-purple-100 {\n  --border-opacity: 1;\n  border-color: #edebfe;\n  border-color: rgba(237, 235, 254, var(--border-opacity));\n}\n.group:focus .group-focus\\:border-purple-200 {\n  --border-opacity: 1;\n  border-color: #dcd7fe;\n  border-color: rgba(220, 215, 254, var(--border-opacity));\n}\n.group:focus .group-focus\\:border-purple-300 {\n  --border-opacity: 1;\n  border-color: #cabffd;\n  border-color: rgba(202, 191, 253, var(--border-opacity));\n}\n.group:focus .group-focus\\:border-purple-400 {\n  --border-opacity: 1;\n  border-color: #ac94fa;\n  border-color: rgba(172, 148, 250, var(--border-opacity));\n}\n.group:focus .group-focus\\:border-purple-500 {\n  --border-opacity: 1;\n  border-color: #9061f9;\n  border-color: rgba(144, 97, 249, var(--border-opacity));\n}\n.group:focus .group-focus\\:border-purple-600 {\n  --border-opacity: 1;\n  border-color: #7e3af2;\n  border-color: rgba(126, 58, 242, var(--border-opacity));\n}\n.group:focus .group-focus\\:border-purple-700 {\n  --border-opacity: 1;\n  border-color: #6c2bd9;\n  border-color: rgba(108, 43, 217, var(--border-opacity));\n}\n.group:focus .group-focus\\:border-purple-800 {\n  --border-opacity: 1;\n  border-color: #5521b5;\n  border-color: rgba(85, 33, 181, var(--border-opacity));\n}\n.group:focus .group-focus\\:border-purple-900 {\n  --border-opacity: 1;\n  border-color: #4a1d96;\n  border-color: rgba(74, 29, 150, var(--border-opacity));\n}\n.group:focus .group-focus\\:border-pink-50 {\n  --border-opacity: 1;\n  border-color: #fdf2f8;\n  border-color: rgba(253, 242, 248, var(--border-opacity));\n}\n.group:focus .group-focus\\:border-pink-100 {\n  --border-opacity: 1;\n  border-color: #fce8f3;\n  border-color: rgba(252, 232, 243, var(--border-opacity));\n}\n.group:focus .group-focus\\:border-pink-200 {\n  --border-opacity: 1;\n  border-color: #fad1e8;\n  border-color: rgba(250, 209, 232, var(--border-opacity));\n}\n.group:focus .group-focus\\:border-pink-300 {\n  --border-opacity: 1;\n  border-color: #f8b4d9;\n  border-color: rgba(248, 180, 217, var(--border-opacity));\n}\n.group:focus .group-focus\\:border-pink-400 {\n  --border-opacity: 1;\n  border-color: #f17eb8;\n  border-color: rgba(241, 126, 184, var(--border-opacity));\n}\n.group:focus .group-focus\\:border-pink-500 {\n  --border-opacity: 1;\n  border-color: #e74694;\n  border-color: rgba(231, 70, 148, var(--border-opacity));\n}\n.group:focus .group-focus\\:border-pink-600 {\n  --border-opacity: 1;\n  border-color: #d61f69;\n  border-color: rgba(214, 31, 105, var(--border-opacity));\n}\n.group:focus .group-focus\\:border-pink-700 {\n  --border-opacity: 1;\n  border-color: #bf125d;\n  border-color: rgba(191, 18, 93, var(--border-opacity));\n}\n.group:focus .group-focus\\:border-pink-800 {\n  --border-opacity: 1;\n  border-color: #99154b;\n  border-color: rgba(153, 21, 75, var(--border-opacity));\n}\n.group:focus .group-focus\\:border-pink-900 {\n  --border-opacity: 1;\n  border-color: #751a3d;\n  border-color: rgba(117, 26, 61, var(--border-opacity));\n}\n.group:focus .group-focus\\:border-cool-gray-50 {\n  --border-opacity: 1;\n  border-color: #f8fafc;\n  border-color: rgba(248, 250, 252, var(--border-opacity));\n}\n.group:focus .group-focus\\:border-cool-gray-100 {\n  --border-opacity: 1;\n  border-color: #f1f5f9;\n  border-color: rgba(241, 245, 249, var(--border-opacity));\n}\n.group:focus .group-focus\\:border-cool-gray-200 {\n  --border-opacity: 1;\n  border-color: #e2e8f0;\n  border-color: rgba(226, 232, 240, var(--border-opacity));\n}\n.group:focus .group-focus\\:border-cool-gray-300 {\n  --border-opacity: 1;\n  border-color: #cfd8e3;\n  border-color: rgba(207, 216, 227, var(--border-opacity));\n}\n.group:focus .group-focus\\:border-cool-gray-400 {\n  --border-opacity: 1;\n  border-color: #97a6ba;\n  border-color: rgba(151, 166, 186, var(--border-opacity));\n}\n.group:focus .group-focus\\:border-cool-gray-500 {\n  --border-opacity: 1;\n  border-color: #64748b;\n  border-color: rgba(100, 116, 139, var(--border-opacity));\n}\n.group:focus .group-focus\\:border-cool-gray-600 {\n  --border-opacity: 1;\n  border-color: #475569;\n  border-color: rgba(71, 85, 105, var(--border-opacity));\n}\n.group:focus .group-focus\\:border-cool-gray-700 {\n  --border-opacity: 1;\n  border-color: #364152;\n  border-color: rgba(54, 65, 82, var(--border-opacity));\n}\n.group:focus .group-focus\\:border-cool-gray-800 {\n  --border-opacity: 1;\n  border-color: #27303f;\n  border-color: rgba(39, 48, 63, var(--border-opacity));\n}\n.group:focus .group-focus\\:border-cool-gray-900 {\n  --border-opacity: 1;\n  border-color: #1a202e;\n  border-color: rgba(26, 32, 46, var(--border-opacity));\n}\n.hover\\:border-current:hover {\n  border-color: currentColor;\n}\n.hover\\:border-transparent:hover {\n  border-color: transparent;\n}\n.hover\\:border-white:hover {\n  --border-opacity: 1;\n  border-color: #ffffff;\n  border-color: rgba(255, 255, 255, var(--border-opacity));\n}\n.hover\\:border-black:hover {\n  --border-opacity: 1;\n  border-color: #000000;\n  border-color: rgba(0, 0, 0, var(--border-opacity));\n}\n.hover\\:border-gray-50:hover {\n  --border-opacity: 1;\n  border-color: #f9fafb;\n  border-color: rgba(249, 250, 251, var(--border-opacity));\n}\n.hover\\:border-gray-100:hover {\n  --border-opacity: 1;\n  border-color: #f4f5f7;\n  border-color: rgba(244, 245, 247, var(--border-opacity));\n}\n.hover\\:border-gray-200:hover {\n  --border-opacity: 1;\n  border-color: #e5e7eb;\n  border-color: rgba(229, 231, 235, var(--border-opacity));\n}\n.hover\\:border-gray-300:hover {\n  --border-opacity: 1;\n  border-color: #d2d6dc;\n  border-color: rgba(210, 214, 220, var(--border-opacity));\n}\n.hover\\:border-gray-400:hover {\n  --border-opacity: 1;\n  border-color: #9fa6b2;\n  border-color: rgba(159, 166, 178, var(--border-opacity));\n}\n.hover\\:border-gray-500:hover {\n  --border-opacity: 1;\n  border-color: #6b7280;\n  border-color: rgba(107, 114, 128, var(--border-opacity));\n}\n.hover\\:border-gray-600:hover {\n  --border-opacity: 1;\n  border-color: #4b5563;\n  border-color: rgba(75, 85, 99, var(--border-opacity));\n}\n.hover\\:border-gray-700:hover {\n  --border-opacity: 1;\n  border-color: #374151;\n  border-color: rgba(55, 65, 81, var(--border-opacity));\n}\n.hover\\:border-gray-800:hover {\n  --border-opacity: 1;\n  border-color: #252f3f;\n  border-color: rgba(37, 47, 63, var(--border-opacity));\n}\n.hover\\:border-gray-900:hover {\n  --border-opacity: 1;\n  border-color: #161e2e;\n  border-color: rgba(22, 30, 46, var(--border-opacity));\n}\n.hover\\:border-red-50:hover {\n  --border-opacity: 1;\n  border-color: #fdf2f2;\n  border-color: rgba(253, 242, 242, var(--border-opacity));\n}\n.hover\\:border-red-100:hover {\n  --border-opacity: 1;\n  border-color: #fde8e8;\n  border-color: rgba(253, 232, 232, var(--border-opacity));\n}\n.hover\\:border-red-200:hover {\n  --border-opacity: 1;\n  border-color: #fbd5d5;\n  border-color: rgba(251, 213, 213, var(--border-opacity));\n}\n.hover\\:border-red-300:hover {\n  --border-opacity: 1;\n  border-color: #f8b4b4;\n  border-color: rgba(248, 180, 180, var(--border-opacity));\n}\n.hover\\:border-red-400:hover {\n  --border-opacity: 1;\n  border-color: #f98080;\n  border-color: rgba(249, 128, 128, var(--border-opacity));\n}\n.hover\\:border-red-500:hover {\n  --border-opacity: 1;\n  border-color: #f05252;\n  border-color: rgba(240, 82, 82, var(--border-opacity));\n}\n.hover\\:border-red-600:hover {\n  --border-opacity: 1;\n  border-color: #e02424;\n  border-color: rgba(224, 36, 36, var(--border-opacity));\n}\n.hover\\:border-red-700:hover {\n  --border-opacity: 1;\n  border-color: #c81e1e;\n  border-color: rgba(200, 30, 30, var(--border-opacity));\n}\n.hover\\:border-red-800:hover {\n  --border-opacity: 1;\n  border-color: #9b1c1c;\n  border-color: rgba(155, 28, 28, var(--border-opacity));\n}\n.hover\\:border-red-900:hover {\n  --border-opacity: 1;\n  border-color: #771d1d;\n  border-color: rgba(119, 29, 29, var(--border-opacity));\n}\n.hover\\:border-orange-50:hover {\n  --border-opacity: 1;\n  border-color: #fff8f1;\n  border-color: rgba(255, 248, 241, var(--border-opacity));\n}\n.hover\\:border-orange-100:hover {\n  --border-opacity: 1;\n  border-color: #feecdc;\n  border-color: rgba(254, 236, 220, var(--border-opacity));\n}\n.hover\\:border-orange-200:hover {\n  --border-opacity: 1;\n  border-color: #fcd9bd;\n  border-color: rgba(252, 217, 189, var(--border-opacity));\n}\n.hover\\:border-orange-300:hover {\n  --border-opacity: 1;\n  border-color: #fdba8c;\n  border-color: rgba(253, 186, 140, var(--border-opacity));\n}\n.hover\\:border-orange-400:hover {\n  --border-opacity: 1;\n  border-color: #ff8a4c;\n  border-color: rgba(255, 138, 76, var(--border-opacity));\n}\n.hover\\:border-orange-500:hover {\n  --border-opacity: 1;\n  border-color: #ff5a1f;\n  border-color: rgba(255, 90, 31, var(--border-opacity));\n}\n.hover\\:border-orange-600:hover {\n  --border-opacity: 1;\n  border-color: #d03801;\n  border-color: rgba(208, 56, 1, var(--border-opacity));\n}\n.hover\\:border-orange-700:hover {\n  --border-opacity: 1;\n  border-color: #b43403;\n  border-color: rgba(180, 52, 3, var(--border-opacity));\n}\n.hover\\:border-orange-800:hover {\n  --border-opacity: 1;\n  border-color: #8a2c0d;\n  border-color: rgba(138, 44, 13, var(--border-opacity));\n}\n.hover\\:border-orange-900:hover {\n  --border-opacity: 1;\n  border-color: #73230d;\n  border-color: rgba(115, 35, 13, var(--border-opacity));\n}\n.hover\\:border-yellow-50:hover {\n  --border-opacity: 1;\n  border-color: #fdfdea;\n  border-color: rgba(253, 253, 234, var(--border-opacity));\n}\n.hover\\:border-yellow-100:hover {\n  --border-opacity: 1;\n  border-color: #fdf6b2;\n  border-color: rgba(253, 246, 178, var(--border-opacity));\n}\n.hover\\:border-yellow-200:hover {\n  --border-opacity: 1;\n  border-color: #fce96a;\n  border-color: rgba(252, 233, 106, var(--border-opacity));\n}\n.hover\\:border-yellow-300:hover {\n  --border-opacity: 1;\n  border-color: #faca15;\n  border-color: rgba(250, 202, 21, var(--border-opacity));\n}\n.hover\\:border-yellow-400:hover {\n  --border-opacity: 1;\n  border-color: #e3a008;\n  border-color: rgba(227, 160, 8, var(--border-opacity));\n}\n.hover\\:border-yellow-500:hover {\n  --border-opacity: 1;\n  border-color: #c27803;\n  border-color: rgba(194, 120, 3, var(--border-opacity));\n}\n.hover\\:border-yellow-600:hover {\n  --border-opacity: 1;\n  border-color: #9f580a;\n  border-color: rgba(159, 88, 10, var(--border-opacity));\n}\n.hover\\:border-yellow-700:hover {\n  --border-opacity: 1;\n  border-color: #8e4b10;\n  border-color: rgba(142, 75, 16, var(--border-opacity));\n}\n.hover\\:border-yellow-800:hover {\n  --border-opacity: 1;\n  border-color: #723b13;\n  border-color: rgba(114, 59, 19, var(--border-opacity));\n}\n.hover\\:border-yellow-900:hover {\n  --border-opacity: 1;\n  border-color: #633112;\n  border-color: rgba(99, 49, 18, var(--border-opacity));\n}\n.hover\\:border-green-50:hover {\n  --border-opacity: 1;\n  border-color: #f3faf7;\n  border-color: rgba(243, 250, 247, var(--border-opacity));\n}\n.hover\\:border-green-100:hover {\n  --border-opacity: 1;\n  border-color: #def7ec;\n  border-color: rgba(222, 247, 236, var(--border-opacity));\n}\n.hover\\:border-green-200:hover {\n  --border-opacity: 1;\n  border-color: #bcf0da;\n  border-color: rgba(188, 240, 218, var(--border-opacity));\n}\n.hover\\:border-green-300:hover {\n  --border-opacity: 1;\n  border-color: #84e1bc;\n  border-color: rgba(132, 225, 188, var(--border-opacity));\n}\n.hover\\:border-green-400:hover {\n  --border-opacity: 1;\n  border-color: #31c48d;\n  border-color: rgba(49, 196, 141, var(--border-opacity));\n}\n.hover\\:border-green-500:hover {\n  --border-opacity: 1;\n  border-color: #0e9f6e;\n  border-color: rgba(14, 159, 110, var(--border-opacity));\n}\n.hover\\:border-green-600:hover {\n  --border-opacity: 1;\n  border-color: #057a55;\n  border-color: rgba(5, 122, 85, var(--border-opacity));\n}\n.hover\\:border-green-700:hover {\n  --border-opacity: 1;\n  border-color: #046c4e;\n  border-color: rgba(4, 108, 78, var(--border-opacity));\n}\n.hover\\:border-green-800:hover {\n  --border-opacity: 1;\n  border-color: #03543f;\n  border-color: rgba(3, 84, 63, var(--border-opacity));\n}\n.hover\\:border-green-900:hover {\n  --border-opacity: 1;\n  border-color: #014737;\n  border-color: rgba(1, 71, 55, var(--border-opacity));\n}\n.hover\\:border-teal-50:hover {\n  --border-opacity: 1;\n  border-color: #edfafa;\n  border-color: rgba(237, 250, 250, var(--border-opacity));\n}\n.hover\\:border-teal-100:hover {\n  --border-opacity: 1;\n  border-color: #d5f5f6;\n  border-color: rgba(213, 245, 246, var(--border-opacity));\n}\n.hover\\:border-teal-200:hover {\n  --border-opacity: 1;\n  border-color: #afecef;\n  border-color: rgba(175, 236, 239, var(--border-opacity));\n}\n.hover\\:border-teal-300:hover {\n  --border-opacity: 1;\n  border-color: #7edce2;\n  border-color: rgba(126, 220, 226, var(--border-opacity));\n}\n.hover\\:border-teal-400:hover {\n  --border-opacity: 1;\n  border-color: #16bdca;\n  border-color: rgba(22, 189, 202, var(--border-opacity));\n}\n.hover\\:border-teal-500:hover {\n  --border-opacity: 1;\n  border-color: #0694a2;\n  border-color: rgba(6, 148, 162, var(--border-opacity));\n}\n.hover\\:border-teal-600:hover {\n  --border-opacity: 1;\n  border-color: #047481;\n  border-color: rgba(4, 116, 129, var(--border-opacity));\n}\n.hover\\:border-teal-700:hover {\n  --border-opacity: 1;\n  border-color: #036672;\n  border-color: rgba(3, 102, 114, var(--border-opacity));\n}\n.hover\\:border-teal-800:hover {\n  --border-opacity: 1;\n  border-color: #05505c;\n  border-color: rgba(5, 80, 92, var(--border-opacity));\n}\n.hover\\:border-teal-900:hover {\n  --border-opacity: 1;\n  border-color: #014451;\n  border-color: rgba(1, 68, 81, var(--border-opacity));\n}\n.hover\\:border-blue-50:hover {\n  --border-opacity: 1;\n  border-color: #ebf5ff;\n  border-color: rgba(235, 245, 255, var(--border-opacity));\n}\n.hover\\:border-blue-100:hover {\n  --border-opacity: 1;\n  border-color: #e1effe;\n  border-color: rgba(225, 239, 254, var(--border-opacity));\n}\n.hover\\:border-blue-200:hover {\n  --border-opacity: 1;\n  border-color: #c3ddfd;\n  border-color: rgba(195, 221, 253, var(--border-opacity));\n}\n.hover\\:border-blue-300:hover {\n  --border-opacity: 1;\n  border-color: #a4cafe;\n  border-color: rgba(164, 202, 254, var(--border-opacity));\n}\n.hover\\:border-blue-400:hover {\n  --border-opacity: 1;\n  border-color: #76a9fa;\n  border-color: rgba(118, 169, 250, var(--border-opacity));\n}\n.hover\\:border-blue-500:hover {\n  --border-opacity: 1;\n  border-color: #3f83f8;\n  border-color: rgba(63, 131, 248, var(--border-opacity));\n}\n.hover\\:border-blue-600:hover {\n  --border-opacity: 1;\n  border-color: #1c64f2;\n  border-color: rgba(28, 100, 242, var(--border-opacity));\n}\n.hover\\:border-blue-700:hover {\n  --border-opacity: 1;\n  border-color: #1a56db;\n  border-color: rgba(26, 86, 219, var(--border-opacity));\n}\n.hover\\:border-blue-800:hover {\n  --border-opacity: 1;\n  border-color: #1e429f;\n  border-color: rgba(30, 66, 159, var(--border-opacity));\n}\n.hover\\:border-blue-900:hover {\n  --border-opacity: 1;\n  border-color: #233876;\n  border-color: rgba(35, 56, 118, var(--border-opacity));\n}\n.hover\\:border-indigo-50:hover {\n  --border-opacity: 1;\n  border-color: #f0f5ff;\n  border-color: rgba(240, 245, 255, var(--border-opacity));\n}\n.hover\\:border-indigo-100:hover {\n  --border-opacity: 1;\n  border-color: #e5edff;\n  border-color: rgba(229, 237, 255, var(--border-opacity));\n}\n.hover\\:border-indigo-200:hover {\n  --border-opacity: 1;\n  border-color: #cddbfe;\n  border-color: rgba(205, 219, 254, var(--border-opacity));\n}\n.hover\\:border-indigo-300:hover {\n  --border-opacity: 1;\n  border-color: #b4c6fc;\n  border-color: rgba(180, 198, 252, var(--border-opacity));\n}\n.hover\\:border-indigo-400:hover {\n  --border-opacity: 1;\n  border-color: #8da2fb;\n  border-color: rgba(141, 162, 251, var(--border-opacity));\n}\n.hover\\:border-indigo-500:hover {\n  --border-opacity: 1;\n  border-color: #6875f5;\n  border-color: rgba(104, 117, 245, var(--border-opacity));\n}\n.hover\\:border-indigo-600:hover {\n  --border-opacity: 1;\n  border-color: #5850ec;\n  border-color: rgba(88, 80, 236, var(--border-opacity));\n}\n.hover\\:border-indigo-700:hover {\n  --border-opacity: 1;\n  border-color: #5145cd;\n  border-color: rgba(81, 69, 205, var(--border-opacity));\n}\n.hover\\:border-indigo-800:hover {\n  --border-opacity: 1;\n  border-color: #42389d;\n  border-color: rgba(66, 56, 157, var(--border-opacity));\n}\n.hover\\:border-indigo-900:hover {\n  --border-opacity: 1;\n  border-color: #362f78;\n  border-color: rgba(54, 47, 120, var(--border-opacity));\n}\n.hover\\:border-purple-50:hover {\n  --border-opacity: 1;\n  border-color: #f6f5ff;\n  border-color: rgba(246, 245, 255, var(--border-opacity));\n}\n.hover\\:border-purple-100:hover {\n  --border-opacity: 1;\n  border-color: #edebfe;\n  border-color: rgba(237, 235, 254, var(--border-opacity));\n}\n.hover\\:border-purple-200:hover {\n  --border-opacity: 1;\n  border-color: #dcd7fe;\n  border-color: rgba(220, 215, 254, var(--border-opacity));\n}\n.hover\\:border-purple-300:hover {\n  --border-opacity: 1;\n  border-color: #cabffd;\n  border-color: rgba(202, 191, 253, var(--border-opacity));\n}\n.hover\\:border-purple-400:hover {\n  --border-opacity: 1;\n  border-color: #ac94fa;\n  border-color: rgba(172, 148, 250, var(--border-opacity));\n}\n.hover\\:border-purple-500:hover {\n  --border-opacity: 1;\n  border-color: #9061f9;\n  border-color: rgba(144, 97, 249, var(--border-opacity));\n}\n.hover\\:border-purple-600:hover {\n  --border-opacity: 1;\n  border-color: #7e3af2;\n  border-color: rgba(126, 58, 242, var(--border-opacity));\n}\n.hover\\:border-purple-700:hover {\n  --border-opacity: 1;\n  border-color: #6c2bd9;\n  border-color: rgba(108, 43, 217, var(--border-opacity));\n}\n.hover\\:border-purple-800:hover {\n  --border-opacity: 1;\n  border-color: #5521b5;\n  border-color: rgba(85, 33, 181, var(--border-opacity));\n}\n.hover\\:border-purple-900:hover {\n  --border-opacity: 1;\n  border-color: #4a1d96;\n  border-color: rgba(74, 29, 150, var(--border-opacity));\n}\n.hover\\:border-pink-50:hover {\n  --border-opacity: 1;\n  border-color: #fdf2f8;\n  border-color: rgba(253, 242, 248, var(--border-opacity));\n}\n.hover\\:border-pink-100:hover {\n  --border-opacity: 1;\n  border-color: #fce8f3;\n  border-color: rgba(252, 232, 243, var(--border-opacity));\n}\n.hover\\:border-pink-200:hover {\n  --border-opacity: 1;\n  border-color: #fad1e8;\n  border-color: rgba(250, 209, 232, var(--border-opacity));\n}\n.hover\\:border-pink-300:hover {\n  --border-opacity: 1;\n  border-color: #f8b4d9;\n  border-color: rgba(248, 180, 217, var(--border-opacity));\n}\n.hover\\:border-pink-400:hover {\n  --border-opacity: 1;\n  border-color: #f17eb8;\n  border-color: rgba(241, 126, 184, var(--border-opacity));\n}\n.hover\\:border-pink-500:hover {\n  --border-opacity: 1;\n  border-color: #e74694;\n  border-color: rgba(231, 70, 148, var(--border-opacity));\n}\n.hover\\:border-pink-600:hover {\n  --border-opacity: 1;\n  border-color: #d61f69;\n  border-color: rgba(214, 31, 105, var(--border-opacity));\n}\n.hover\\:border-pink-700:hover {\n  --border-opacity: 1;\n  border-color: #bf125d;\n  border-color: rgba(191, 18, 93, var(--border-opacity));\n}\n.hover\\:border-pink-800:hover {\n  --border-opacity: 1;\n  border-color: #99154b;\n  border-color: rgba(153, 21, 75, var(--border-opacity));\n}\n.hover\\:border-pink-900:hover {\n  --border-opacity: 1;\n  border-color: #751a3d;\n  border-color: rgba(117, 26, 61, var(--border-opacity));\n}\n.hover\\:border-cool-gray-50:hover {\n  --border-opacity: 1;\n  border-color: #f8fafc;\n  border-color: rgba(248, 250, 252, var(--border-opacity));\n}\n.hover\\:border-cool-gray-100:hover {\n  --border-opacity: 1;\n  border-color: #f1f5f9;\n  border-color: rgba(241, 245, 249, var(--border-opacity));\n}\n.hover\\:border-cool-gray-200:hover {\n  --border-opacity: 1;\n  border-color: #e2e8f0;\n  border-color: rgba(226, 232, 240, var(--border-opacity));\n}\n.hover\\:border-cool-gray-300:hover {\n  --border-opacity: 1;\n  border-color: #cfd8e3;\n  border-color: rgba(207, 216, 227, var(--border-opacity));\n}\n.hover\\:border-cool-gray-400:hover {\n  --border-opacity: 1;\n  border-color: #97a6ba;\n  border-color: rgba(151, 166, 186, var(--border-opacity));\n}\n.hover\\:border-cool-gray-500:hover {\n  --border-opacity: 1;\n  border-color: #64748b;\n  border-color: rgba(100, 116, 139, var(--border-opacity));\n}\n.hover\\:border-cool-gray-600:hover {\n  --border-opacity: 1;\n  border-color: #475569;\n  border-color: rgba(71, 85, 105, var(--border-opacity));\n}\n.hover\\:border-cool-gray-700:hover {\n  --border-opacity: 1;\n  border-color: #364152;\n  border-color: rgba(54, 65, 82, var(--border-opacity));\n}\n.hover\\:border-cool-gray-800:hover {\n  --border-opacity: 1;\n  border-color: #27303f;\n  border-color: rgba(39, 48, 63, var(--border-opacity));\n}\n.hover\\:border-cool-gray-900:hover {\n  --border-opacity: 1;\n  border-color: #1a202e;\n  border-color: rgba(26, 32, 46, var(--border-opacity));\n}\n.focus-within\\:border-current:focus-within {\n  border-color: currentColor;\n}\n.focus-within\\:border-transparent:focus-within {\n  border-color: transparent;\n}\n.focus-within\\:border-white:focus-within {\n  --border-opacity: 1;\n  border-color: #ffffff;\n  border-color: rgba(255, 255, 255, var(--border-opacity));\n}\n.focus-within\\:border-black:focus-within {\n  --border-opacity: 1;\n  border-color: #000000;\n  border-color: rgba(0, 0, 0, var(--border-opacity));\n}\n.focus-within\\:border-gray-50:focus-within {\n  --border-opacity: 1;\n  border-color: #f9fafb;\n  border-color: rgba(249, 250, 251, var(--border-opacity));\n}\n.focus-within\\:border-gray-100:focus-within {\n  --border-opacity: 1;\n  border-color: #f4f5f7;\n  border-color: rgba(244, 245, 247, var(--border-opacity));\n}\n.focus-within\\:border-gray-200:focus-within {\n  --border-opacity: 1;\n  border-color: #e5e7eb;\n  border-color: rgba(229, 231, 235, var(--border-opacity));\n}\n.focus-within\\:border-gray-300:focus-within {\n  --border-opacity: 1;\n  border-color: #d2d6dc;\n  border-color: rgba(210, 214, 220, var(--border-opacity));\n}\n.focus-within\\:border-gray-400:focus-within {\n  --border-opacity: 1;\n  border-color: #9fa6b2;\n  border-color: rgba(159, 166, 178, var(--border-opacity));\n}\n.focus-within\\:border-gray-500:focus-within {\n  --border-opacity: 1;\n  border-color: #6b7280;\n  border-color: rgba(107, 114, 128, var(--border-opacity));\n}\n.focus-within\\:border-gray-600:focus-within {\n  --border-opacity: 1;\n  border-color: #4b5563;\n  border-color: rgba(75, 85, 99, var(--border-opacity));\n}\n.focus-within\\:border-gray-700:focus-within {\n  --border-opacity: 1;\n  border-color: #374151;\n  border-color: rgba(55, 65, 81, var(--border-opacity));\n}\n.focus-within\\:border-gray-800:focus-within {\n  --border-opacity: 1;\n  border-color: #252f3f;\n  border-color: rgba(37, 47, 63, var(--border-opacity));\n}\n.focus-within\\:border-gray-900:focus-within {\n  --border-opacity: 1;\n  border-color: #161e2e;\n  border-color: rgba(22, 30, 46, var(--border-opacity));\n}\n.focus-within\\:border-red-50:focus-within {\n  --border-opacity: 1;\n  border-color: #fdf2f2;\n  border-color: rgba(253, 242, 242, var(--border-opacity));\n}\n.focus-within\\:border-red-100:focus-within {\n  --border-opacity: 1;\n  border-color: #fde8e8;\n  border-color: rgba(253, 232, 232, var(--border-opacity));\n}\n.focus-within\\:border-red-200:focus-within {\n  --border-opacity: 1;\n  border-color: #fbd5d5;\n  border-color: rgba(251, 213, 213, var(--border-opacity));\n}\n.focus-within\\:border-red-300:focus-within {\n  --border-opacity: 1;\n  border-color: #f8b4b4;\n  border-color: rgba(248, 180, 180, var(--border-opacity));\n}\n.focus-within\\:border-red-400:focus-within {\n  --border-opacity: 1;\n  border-color: #f98080;\n  border-color: rgba(249, 128, 128, var(--border-opacity));\n}\n.focus-within\\:border-red-500:focus-within {\n  --border-opacity: 1;\n  border-color: #f05252;\n  border-color: rgba(240, 82, 82, var(--border-opacity));\n}\n.focus-within\\:border-red-600:focus-within {\n  --border-opacity: 1;\n  border-color: #e02424;\n  border-color: rgba(224, 36, 36, var(--border-opacity));\n}\n.focus-within\\:border-red-700:focus-within {\n  --border-opacity: 1;\n  border-color: #c81e1e;\n  border-color: rgba(200, 30, 30, var(--border-opacity));\n}\n.focus-within\\:border-red-800:focus-within {\n  --border-opacity: 1;\n  border-color: #9b1c1c;\n  border-color: rgba(155, 28, 28, var(--border-opacity));\n}\n.focus-within\\:border-red-900:focus-within {\n  --border-opacity: 1;\n  border-color: #771d1d;\n  border-color: rgba(119, 29, 29, var(--border-opacity));\n}\n.focus-within\\:border-orange-50:focus-within {\n  --border-opacity: 1;\n  border-color: #fff8f1;\n  border-color: rgba(255, 248, 241, var(--border-opacity));\n}\n.focus-within\\:border-orange-100:focus-within {\n  --border-opacity: 1;\n  border-color: #feecdc;\n  border-color: rgba(254, 236, 220, var(--border-opacity));\n}\n.focus-within\\:border-orange-200:focus-within {\n  --border-opacity: 1;\n  border-color: #fcd9bd;\n  border-color: rgba(252, 217, 189, var(--border-opacity));\n}\n.focus-within\\:border-orange-300:focus-within {\n  --border-opacity: 1;\n  border-color: #fdba8c;\n  border-color: rgba(253, 186, 140, var(--border-opacity));\n}\n.focus-within\\:border-orange-400:focus-within {\n  --border-opacity: 1;\n  border-color: #ff8a4c;\n  border-color: rgba(255, 138, 76, var(--border-opacity));\n}\n.focus-within\\:border-orange-500:focus-within {\n  --border-opacity: 1;\n  border-color: #ff5a1f;\n  border-color: rgba(255, 90, 31, var(--border-opacity));\n}\n.focus-within\\:border-orange-600:focus-within {\n  --border-opacity: 1;\n  border-color: #d03801;\n  border-color: rgba(208, 56, 1, var(--border-opacity));\n}\n.focus-within\\:border-orange-700:focus-within {\n  --border-opacity: 1;\n  border-color: #b43403;\n  border-color: rgba(180, 52, 3, var(--border-opacity));\n}\n.focus-within\\:border-orange-800:focus-within {\n  --border-opacity: 1;\n  border-color: #8a2c0d;\n  border-color: rgba(138, 44, 13, var(--border-opacity));\n}\n.focus-within\\:border-orange-900:focus-within {\n  --border-opacity: 1;\n  border-color: #73230d;\n  border-color: rgba(115, 35, 13, var(--border-opacity));\n}\n.focus-within\\:border-yellow-50:focus-within {\n  --border-opacity: 1;\n  border-color: #fdfdea;\n  border-color: rgba(253, 253, 234, var(--border-opacity));\n}\n.focus-within\\:border-yellow-100:focus-within {\n  --border-opacity: 1;\n  border-color: #fdf6b2;\n  border-color: rgba(253, 246, 178, var(--border-opacity));\n}\n.focus-within\\:border-yellow-200:focus-within {\n  --border-opacity: 1;\n  border-color: #fce96a;\n  border-color: rgba(252, 233, 106, var(--border-opacity));\n}\n.focus-within\\:border-yellow-300:focus-within {\n  --border-opacity: 1;\n  border-color: #faca15;\n  border-color: rgba(250, 202, 21, var(--border-opacity));\n}\n.focus-within\\:border-yellow-400:focus-within {\n  --border-opacity: 1;\n  border-color: #e3a008;\n  border-color: rgba(227, 160, 8, var(--border-opacity));\n}\n.focus-within\\:border-yellow-500:focus-within {\n  --border-opacity: 1;\n  border-color: #c27803;\n  border-color: rgba(194, 120, 3, var(--border-opacity));\n}\n.focus-within\\:border-yellow-600:focus-within {\n  --border-opacity: 1;\n  border-color: #9f580a;\n  border-color: rgba(159, 88, 10, var(--border-opacity));\n}\n.focus-within\\:border-yellow-700:focus-within {\n  --border-opacity: 1;\n  border-color: #8e4b10;\n  border-color: rgba(142, 75, 16, var(--border-opacity));\n}\n.focus-within\\:border-yellow-800:focus-within {\n  --border-opacity: 1;\n  border-color: #723b13;\n  border-color: rgba(114, 59, 19, var(--border-opacity));\n}\n.focus-within\\:border-yellow-900:focus-within {\n  --border-opacity: 1;\n  border-color: #633112;\n  border-color: rgba(99, 49, 18, var(--border-opacity));\n}\n.focus-within\\:border-green-50:focus-within {\n  --border-opacity: 1;\n  border-color: #f3faf7;\n  border-color: rgba(243, 250, 247, var(--border-opacity));\n}\n.focus-within\\:border-green-100:focus-within {\n  --border-opacity: 1;\n  border-color: #def7ec;\n  border-color: rgba(222, 247, 236, var(--border-opacity));\n}\n.focus-within\\:border-green-200:focus-within {\n  --border-opacity: 1;\n  border-color: #bcf0da;\n  border-color: rgba(188, 240, 218, var(--border-opacity));\n}\n.focus-within\\:border-green-300:focus-within {\n  --border-opacity: 1;\n  border-color: #84e1bc;\n  border-color: rgba(132, 225, 188, var(--border-opacity));\n}\n.focus-within\\:border-green-400:focus-within {\n  --border-opacity: 1;\n  border-color: #31c48d;\n  border-color: rgba(49, 196, 141, var(--border-opacity));\n}\n.focus-within\\:border-green-500:focus-within {\n  --border-opacity: 1;\n  border-color: #0e9f6e;\n  border-color: rgba(14, 159, 110, var(--border-opacity));\n}\n.focus-within\\:border-green-600:focus-within {\n  --border-opacity: 1;\n  border-color: #057a55;\n  border-color: rgba(5, 122, 85, var(--border-opacity));\n}\n.focus-within\\:border-green-700:focus-within {\n  --border-opacity: 1;\n  border-color: #046c4e;\n  border-color: rgba(4, 108, 78, var(--border-opacity));\n}\n.focus-within\\:border-green-800:focus-within {\n  --border-opacity: 1;\n  border-color: #03543f;\n  border-color: rgba(3, 84, 63, var(--border-opacity));\n}\n.focus-within\\:border-green-900:focus-within {\n  --border-opacity: 1;\n  border-color: #014737;\n  border-color: rgba(1, 71, 55, var(--border-opacity));\n}\n.focus-within\\:border-teal-50:focus-within {\n  --border-opacity: 1;\n  border-color: #edfafa;\n  border-color: rgba(237, 250, 250, var(--border-opacity));\n}\n.focus-within\\:border-teal-100:focus-within {\n  --border-opacity: 1;\n  border-color: #d5f5f6;\n  border-color: rgba(213, 245, 246, var(--border-opacity));\n}\n.focus-within\\:border-teal-200:focus-within {\n  --border-opacity: 1;\n  border-color: #afecef;\n  border-color: rgba(175, 236, 239, var(--border-opacity));\n}\n.focus-within\\:border-teal-300:focus-within {\n  --border-opacity: 1;\n  border-color: #7edce2;\n  border-color: rgba(126, 220, 226, var(--border-opacity));\n}\n.focus-within\\:border-teal-400:focus-within {\n  --border-opacity: 1;\n  border-color: #16bdca;\n  border-color: rgba(22, 189, 202, var(--border-opacity));\n}\n.focus-within\\:border-teal-500:focus-within {\n  --border-opacity: 1;\n  border-color: #0694a2;\n  border-color: rgba(6, 148, 162, var(--border-opacity));\n}\n.focus-within\\:border-teal-600:focus-within {\n  --border-opacity: 1;\n  border-color: #047481;\n  border-color: rgba(4, 116, 129, var(--border-opacity));\n}\n.focus-within\\:border-teal-700:focus-within {\n  --border-opacity: 1;\n  border-color: #036672;\n  border-color: rgba(3, 102, 114, var(--border-opacity));\n}\n.focus-within\\:border-teal-800:focus-within {\n  --border-opacity: 1;\n  border-color: #05505c;\n  border-color: rgba(5, 80, 92, var(--border-opacity));\n}\n.focus-within\\:border-teal-900:focus-within {\n  --border-opacity: 1;\n  border-color: #014451;\n  border-color: rgba(1, 68, 81, var(--border-opacity));\n}\n.focus-within\\:border-blue-50:focus-within {\n  --border-opacity: 1;\n  border-color: #ebf5ff;\n  border-color: rgba(235, 245, 255, var(--border-opacity));\n}\n.focus-within\\:border-blue-100:focus-within {\n  --border-opacity: 1;\n  border-color: #e1effe;\n  border-color: rgba(225, 239, 254, var(--border-opacity));\n}\n.focus-within\\:border-blue-200:focus-within {\n  --border-opacity: 1;\n  border-color: #c3ddfd;\n  border-color: rgba(195, 221, 253, var(--border-opacity));\n}\n.focus-within\\:border-blue-300:focus-within {\n  --border-opacity: 1;\n  border-color: #a4cafe;\n  border-color: rgba(164, 202, 254, var(--border-opacity));\n}\n.focus-within\\:border-blue-400:focus-within {\n  --border-opacity: 1;\n  border-color: #76a9fa;\n  border-color: rgba(118, 169, 250, var(--border-opacity));\n}\n.focus-within\\:border-blue-500:focus-within {\n  --border-opacity: 1;\n  border-color: #3f83f8;\n  border-color: rgba(63, 131, 248, var(--border-opacity));\n}\n.focus-within\\:border-blue-600:focus-within {\n  --border-opacity: 1;\n  border-color: #1c64f2;\n  border-color: rgba(28, 100, 242, var(--border-opacity));\n}\n.focus-within\\:border-blue-700:focus-within {\n  --border-opacity: 1;\n  border-color: #1a56db;\n  border-color: rgba(26, 86, 219, var(--border-opacity));\n}\n.focus-within\\:border-blue-800:focus-within {\n  --border-opacity: 1;\n  border-color: #1e429f;\n  border-color: rgba(30, 66, 159, var(--border-opacity));\n}\n.focus-within\\:border-blue-900:focus-within {\n  --border-opacity: 1;\n  border-color: #233876;\n  border-color: rgba(35, 56, 118, var(--border-opacity));\n}\n.focus-within\\:border-indigo-50:focus-within {\n  --border-opacity: 1;\n  border-color: #f0f5ff;\n  border-color: rgba(240, 245, 255, var(--border-opacity));\n}\n.focus-within\\:border-indigo-100:focus-within {\n  --border-opacity: 1;\n  border-color: #e5edff;\n  border-color: rgba(229, 237, 255, var(--border-opacity));\n}\n.focus-within\\:border-indigo-200:focus-within {\n  --border-opacity: 1;\n  border-color: #cddbfe;\n  border-color: rgba(205, 219, 254, var(--border-opacity));\n}\n.focus-within\\:border-indigo-300:focus-within {\n  --border-opacity: 1;\n  border-color: #b4c6fc;\n  border-color: rgba(180, 198, 252, var(--border-opacity));\n}\n.focus-within\\:border-indigo-400:focus-within {\n  --border-opacity: 1;\n  border-color: #8da2fb;\n  border-color: rgba(141, 162, 251, var(--border-opacity));\n}\n.focus-within\\:border-indigo-500:focus-within {\n  --border-opacity: 1;\n  border-color: #6875f5;\n  border-color: rgba(104, 117, 245, var(--border-opacity));\n}\n.focus-within\\:border-indigo-600:focus-within {\n  --border-opacity: 1;\n  border-color: #5850ec;\n  border-color: rgba(88, 80, 236, var(--border-opacity));\n}\n.focus-within\\:border-indigo-700:focus-within {\n  --border-opacity: 1;\n  border-color: #5145cd;\n  border-color: rgba(81, 69, 205, var(--border-opacity));\n}\n.focus-within\\:border-indigo-800:focus-within {\n  --border-opacity: 1;\n  border-color: #42389d;\n  border-color: rgba(66, 56, 157, var(--border-opacity));\n}\n.focus-within\\:border-indigo-900:focus-within {\n  --border-opacity: 1;\n  border-color: #362f78;\n  border-color: rgba(54, 47, 120, var(--border-opacity));\n}\n.focus-within\\:border-purple-50:focus-within {\n  --border-opacity: 1;\n  border-color: #f6f5ff;\n  border-color: rgba(246, 245, 255, var(--border-opacity));\n}\n.focus-within\\:border-purple-100:focus-within {\n  --border-opacity: 1;\n  border-color: #edebfe;\n  border-color: rgba(237, 235, 254, var(--border-opacity));\n}\n.focus-within\\:border-purple-200:focus-within {\n  --border-opacity: 1;\n  border-color: #dcd7fe;\n  border-color: rgba(220, 215, 254, var(--border-opacity));\n}\n.focus-within\\:border-purple-300:focus-within {\n  --border-opacity: 1;\n  border-color: #cabffd;\n  border-color: rgba(202, 191, 253, var(--border-opacity));\n}\n.focus-within\\:border-purple-400:focus-within {\n  --border-opacity: 1;\n  border-color: #ac94fa;\n  border-color: rgba(172, 148, 250, var(--border-opacity));\n}\n.focus-within\\:border-purple-500:focus-within {\n  --border-opacity: 1;\n  border-color: #9061f9;\n  border-color: rgba(144, 97, 249, var(--border-opacity));\n}\n.focus-within\\:border-purple-600:focus-within {\n  --border-opacity: 1;\n  border-color: #7e3af2;\n  border-color: rgba(126, 58, 242, var(--border-opacity));\n}\n.focus-within\\:border-purple-700:focus-within {\n  --border-opacity: 1;\n  border-color: #6c2bd9;\n  border-color: rgba(108, 43, 217, var(--border-opacity));\n}\n.focus-within\\:border-purple-800:focus-within {\n  --border-opacity: 1;\n  border-color: #5521b5;\n  border-color: rgba(85, 33, 181, var(--border-opacity));\n}\n.focus-within\\:border-purple-900:focus-within {\n  --border-opacity: 1;\n  border-color: #4a1d96;\n  border-color: rgba(74, 29, 150, var(--border-opacity));\n}\n.focus-within\\:border-pink-50:focus-within {\n  --border-opacity: 1;\n  border-color: #fdf2f8;\n  border-color: rgba(253, 242, 248, var(--border-opacity));\n}\n.focus-within\\:border-pink-100:focus-within {\n  --border-opacity: 1;\n  border-color: #fce8f3;\n  border-color: rgba(252, 232, 243, var(--border-opacity));\n}\n.focus-within\\:border-pink-200:focus-within {\n  --border-opacity: 1;\n  border-color: #fad1e8;\n  border-color: rgba(250, 209, 232, var(--border-opacity));\n}\n.focus-within\\:border-pink-300:focus-within {\n  --border-opacity: 1;\n  border-color: #f8b4d9;\n  border-color: rgba(248, 180, 217, var(--border-opacity));\n}\n.focus-within\\:border-pink-400:focus-within {\n  --border-opacity: 1;\n  border-color: #f17eb8;\n  border-color: rgba(241, 126, 184, var(--border-opacity));\n}\n.focus-within\\:border-pink-500:focus-within {\n  --border-opacity: 1;\n  border-color: #e74694;\n  border-color: rgba(231, 70, 148, var(--border-opacity));\n}\n.focus-within\\:border-pink-600:focus-within {\n  --border-opacity: 1;\n  border-color: #d61f69;\n  border-color: rgba(214, 31, 105, var(--border-opacity));\n}\n.focus-within\\:border-pink-700:focus-within {\n  --border-opacity: 1;\n  border-color: #bf125d;\n  border-color: rgba(191, 18, 93, var(--border-opacity));\n}\n.focus-within\\:border-pink-800:focus-within {\n  --border-opacity: 1;\n  border-color: #99154b;\n  border-color: rgba(153, 21, 75, var(--border-opacity));\n}\n.focus-within\\:border-pink-900:focus-within {\n  --border-opacity: 1;\n  border-color: #751a3d;\n  border-color: rgba(117, 26, 61, var(--border-opacity));\n}\n.focus-within\\:border-cool-gray-50:focus-within {\n  --border-opacity: 1;\n  border-color: #f8fafc;\n  border-color: rgba(248, 250, 252, var(--border-opacity));\n}\n.focus-within\\:border-cool-gray-100:focus-within {\n  --border-opacity: 1;\n  border-color: #f1f5f9;\n  border-color: rgba(241, 245, 249, var(--border-opacity));\n}\n.focus-within\\:border-cool-gray-200:focus-within {\n  --border-opacity: 1;\n  border-color: #e2e8f0;\n  border-color: rgba(226, 232, 240, var(--border-opacity));\n}\n.focus-within\\:border-cool-gray-300:focus-within {\n  --border-opacity: 1;\n  border-color: #cfd8e3;\n  border-color: rgba(207, 216, 227, var(--border-opacity));\n}\n.focus-within\\:border-cool-gray-400:focus-within {\n  --border-opacity: 1;\n  border-color: #97a6ba;\n  border-color: rgba(151, 166, 186, var(--border-opacity));\n}\n.focus-within\\:border-cool-gray-500:focus-within {\n  --border-opacity: 1;\n  border-color: #64748b;\n  border-color: rgba(100, 116, 139, var(--border-opacity));\n}\n.focus-within\\:border-cool-gray-600:focus-within {\n  --border-opacity: 1;\n  border-color: #475569;\n  border-color: rgba(71, 85, 105, var(--border-opacity));\n}\n.focus-within\\:border-cool-gray-700:focus-within {\n  --border-opacity: 1;\n  border-color: #364152;\n  border-color: rgba(54, 65, 82, var(--border-opacity));\n}\n.focus-within\\:border-cool-gray-800:focus-within {\n  --border-opacity: 1;\n  border-color: #27303f;\n  border-color: rgba(39, 48, 63, var(--border-opacity));\n}\n.focus-within\\:border-cool-gray-900:focus-within {\n  --border-opacity: 1;\n  border-color: #1a202e;\n  border-color: rgba(26, 32, 46, var(--border-opacity));\n}\n.focus\\:border-current:focus {\n  border-color: currentColor;\n}\n.focus\\:border-transparent:focus {\n  border-color: transparent;\n}\n.focus\\:border-white:focus {\n  --border-opacity: 1;\n  border-color: #ffffff;\n  border-color: rgba(255, 255, 255, var(--border-opacity));\n}\n.focus\\:border-black:focus {\n  --border-opacity: 1;\n  border-color: #000000;\n  border-color: rgba(0, 0, 0, var(--border-opacity));\n}\n.focus\\:border-gray-50:focus {\n  --border-opacity: 1;\n  border-color: #f9fafb;\n  border-color: rgba(249, 250, 251, var(--border-opacity));\n}\n.focus\\:border-gray-100:focus {\n  --border-opacity: 1;\n  border-color: #f4f5f7;\n  border-color: rgba(244, 245, 247, var(--border-opacity));\n}\n.focus\\:border-gray-200:focus {\n  --border-opacity: 1;\n  border-color: #e5e7eb;\n  border-color: rgba(229, 231, 235, var(--border-opacity));\n}\n.focus\\:border-gray-300:focus {\n  --border-opacity: 1;\n  border-color: #d2d6dc;\n  border-color: rgba(210, 214, 220, var(--border-opacity));\n}\n.focus\\:border-gray-400:focus {\n  --border-opacity: 1;\n  border-color: #9fa6b2;\n  border-color: rgba(159, 166, 178, var(--border-opacity));\n}\n.focus\\:border-gray-500:focus {\n  --border-opacity: 1;\n  border-color: #6b7280;\n  border-color: rgba(107, 114, 128, var(--border-opacity));\n}\n.focus\\:border-gray-600:focus {\n  --border-opacity: 1;\n  border-color: #4b5563;\n  border-color: rgba(75, 85, 99, var(--border-opacity));\n}\n.focus\\:border-gray-700:focus {\n  --border-opacity: 1;\n  border-color: #374151;\n  border-color: rgba(55, 65, 81, var(--border-opacity));\n}\n.focus\\:border-gray-800:focus {\n  --border-opacity: 1;\n  border-color: #252f3f;\n  border-color: rgba(37, 47, 63, var(--border-opacity));\n}\n.focus\\:border-gray-900:focus {\n  --border-opacity: 1;\n  border-color: #161e2e;\n  border-color: rgba(22, 30, 46, var(--border-opacity));\n}\n.focus\\:border-red-50:focus {\n  --border-opacity: 1;\n  border-color: #fdf2f2;\n  border-color: rgba(253, 242, 242, var(--border-opacity));\n}\n.focus\\:border-red-100:focus {\n  --border-opacity: 1;\n  border-color: #fde8e8;\n  border-color: rgba(253, 232, 232, var(--border-opacity));\n}\n.focus\\:border-red-200:focus {\n  --border-opacity: 1;\n  border-color: #fbd5d5;\n  border-color: rgba(251, 213, 213, var(--border-opacity));\n}\n.focus\\:border-red-300:focus {\n  --border-opacity: 1;\n  border-color: #f8b4b4;\n  border-color: rgba(248, 180, 180, var(--border-opacity));\n}\n.focus\\:border-red-400:focus {\n  --border-opacity: 1;\n  border-color: #f98080;\n  border-color: rgba(249, 128, 128, var(--border-opacity));\n}\n.focus\\:border-red-500:focus {\n  --border-opacity: 1;\n  border-color: #f05252;\n  border-color: rgba(240, 82, 82, var(--border-opacity));\n}\n.focus\\:border-red-600:focus {\n  --border-opacity: 1;\n  border-color: #e02424;\n  border-color: rgba(224, 36, 36, var(--border-opacity));\n}\n.focus\\:border-red-700:focus {\n  --border-opacity: 1;\n  border-color: #c81e1e;\n  border-color: rgba(200, 30, 30, var(--border-opacity));\n}\n.focus\\:border-red-800:focus {\n  --border-opacity: 1;\n  border-color: #9b1c1c;\n  border-color: rgba(155, 28, 28, var(--border-opacity));\n}\n.focus\\:border-red-900:focus {\n  --border-opacity: 1;\n  border-color: #771d1d;\n  border-color: rgba(119, 29, 29, var(--border-opacity));\n}\n.focus\\:border-orange-50:focus {\n  --border-opacity: 1;\n  border-color: #fff8f1;\n  border-color: rgba(255, 248, 241, var(--border-opacity));\n}\n.focus\\:border-orange-100:focus {\n  --border-opacity: 1;\n  border-color: #feecdc;\n  border-color: rgba(254, 236, 220, var(--border-opacity));\n}\n.focus\\:border-orange-200:focus {\n  --border-opacity: 1;\n  border-color: #fcd9bd;\n  border-color: rgba(252, 217, 189, var(--border-opacity));\n}\n.focus\\:border-orange-300:focus {\n  --border-opacity: 1;\n  border-color: #fdba8c;\n  border-color: rgba(253, 186, 140, var(--border-opacity));\n}\n.focus\\:border-orange-400:focus {\n  --border-opacity: 1;\n  border-color: #ff8a4c;\n  border-color: rgba(255, 138, 76, var(--border-opacity));\n}\n.focus\\:border-orange-500:focus {\n  --border-opacity: 1;\n  border-color: #ff5a1f;\n  border-color: rgba(255, 90, 31, var(--border-opacity));\n}\n.focus\\:border-orange-600:focus {\n  --border-opacity: 1;\n  border-color: #d03801;\n  border-color: rgba(208, 56, 1, var(--border-opacity));\n}\n.focus\\:border-orange-700:focus {\n  --border-opacity: 1;\n  border-color: #b43403;\n  border-color: rgba(180, 52, 3, var(--border-opacity));\n}\n.focus\\:border-orange-800:focus {\n  --border-opacity: 1;\n  border-color: #8a2c0d;\n  border-color: rgba(138, 44, 13, var(--border-opacity));\n}\n.focus\\:border-orange-900:focus {\n  --border-opacity: 1;\n  border-color: #73230d;\n  border-color: rgba(115, 35, 13, var(--border-opacity));\n}\n.focus\\:border-yellow-50:focus {\n  --border-opacity: 1;\n  border-color: #fdfdea;\n  border-color: rgba(253, 253, 234, var(--border-opacity));\n}\n.focus\\:border-yellow-100:focus {\n  --border-opacity: 1;\n  border-color: #fdf6b2;\n  border-color: rgba(253, 246, 178, var(--border-opacity));\n}\n.focus\\:border-yellow-200:focus {\n  --border-opacity: 1;\n  border-color: #fce96a;\n  border-color: rgba(252, 233, 106, var(--border-opacity));\n}\n.focus\\:border-yellow-300:focus {\n  --border-opacity: 1;\n  border-color: #faca15;\n  border-color: rgba(250, 202, 21, var(--border-opacity));\n}\n.focus\\:border-yellow-400:focus {\n  --border-opacity: 1;\n  border-color: #e3a008;\n  border-color: rgba(227, 160, 8, var(--border-opacity));\n}\n.focus\\:border-yellow-500:focus {\n  --border-opacity: 1;\n  border-color: #c27803;\n  border-color: rgba(194, 120, 3, var(--border-opacity));\n}\n.focus\\:border-yellow-600:focus {\n  --border-opacity: 1;\n  border-color: #9f580a;\n  border-color: rgba(159, 88, 10, var(--border-opacity));\n}\n.focus\\:border-yellow-700:focus {\n  --border-opacity: 1;\n  border-color: #8e4b10;\n  border-color: rgba(142, 75, 16, var(--border-opacity));\n}\n.focus\\:border-yellow-800:focus {\n  --border-opacity: 1;\n  border-color: #723b13;\n  border-color: rgba(114, 59, 19, var(--border-opacity));\n}\n.focus\\:border-yellow-900:focus {\n  --border-opacity: 1;\n  border-color: #633112;\n  border-color: rgba(99, 49, 18, var(--border-opacity));\n}\n.focus\\:border-green-50:focus {\n  --border-opacity: 1;\n  border-color: #f3faf7;\n  border-color: rgba(243, 250, 247, var(--border-opacity));\n}\n.focus\\:border-green-100:focus {\n  --border-opacity: 1;\n  border-color: #def7ec;\n  border-color: rgba(222, 247, 236, var(--border-opacity));\n}\n.focus\\:border-green-200:focus {\n  --border-opacity: 1;\n  border-color: #bcf0da;\n  border-color: rgba(188, 240, 218, var(--border-opacity));\n}\n.focus\\:border-green-300:focus {\n  --border-opacity: 1;\n  border-color: #84e1bc;\n  border-color: rgba(132, 225, 188, var(--border-opacity));\n}\n.focus\\:border-green-400:focus {\n  --border-opacity: 1;\n  border-color: #31c48d;\n  border-color: rgba(49, 196, 141, var(--border-opacity));\n}\n.focus\\:border-green-500:focus {\n  --border-opacity: 1;\n  border-color: #0e9f6e;\n  border-color: rgba(14, 159, 110, var(--border-opacity));\n}\n.focus\\:border-green-600:focus {\n  --border-opacity: 1;\n  border-color: #057a55;\n  border-color: rgba(5, 122, 85, var(--border-opacity));\n}\n.focus\\:border-green-700:focus {\n  --border-opacity: 1;\n  border-color: #046c4e;\n  border-color: rgba(4, 108, 78, var(--border-opacity));\n}\n.focus\\:border-green-800:focus {\n  --border-opacity: 1;\n  border-color: #03543f;\n  border-color: rgba(3, 84, 63, var(--border-opacity));\n}\n.focus\\:border-green-900:focus {\n  --border-opacity: 1;\n  border-color: #014737;\n  border-color: rgba(1, 71, 55, var(--border-opacity));\n}\n.focus\\:border-teal-50:focus {\n  --border-opacity: 1;\n  border-color: #edfafa;\n  border-color: rgba(237, 250, 250, var(--border-opacity));\n}\n.focus\\:border-teal-100:focus {\n  --border-opacity: 1;\n  border-color: #d5f5f6;\n  border-color: rgba(213, 245, 246, var(--border-opacity));\n}\n.focus\\:border-teal-200:focus {\n  --border-opacity: 1;\n  border-color: #afecef;\n  border-color: rgba(175, 236, 239, var(--border-opacity));\n}\n.focus\\:border-teal-300:focus {\n  --border-opacity: 1;\n  border-color: #7edce2;\n  border-color: rgba(126, 220, 226, var(--border-opacity));\n}\n.focus\\:border-teal-400:focus {\n  --border-opacity: 1;\n  border-color: #16bdca;\n  border-color: rgba(22, 189, 202, var(--border-opacity));\n}\n.focus\\:border-teal-500:focus {\n  --border-opacity: 1;\n  border-color: #0694a2;\n  border-color: rgba(6, 148, 162, var(--border-opacity));\n}\n.focus\\:border-teal-600:focus {\n  --border-opacity: 1;\n  border-color: #047481;\n  border-color: rgba(4, 116, 129, var(--border-opacity));\n}\n.focus\\:border-teal-700:focus {\n  --border-opacity: 1;\n  border-color: #036672;\n  border-color: rgba(3, 102, 114, var(--border-opacity));\n}\n.focus\\:border-teal-800:focus {\n  --border-opacity: 1;\n  border-color: #05505c;\n  border-color: rgba(5, 80, 92, var(--border-opacity));\n}\n.focus\\:border-teal-900:focus {\n  --border-opacity: 1;\n  border-color: #014451;\n  border-color: rgba(1, 68, 81, var(--border-opacity));\n}\n.focus\\:border-blue-50:focus {\n  --border-opacity: 1;\n  border-color: #ebf5ff;\n  border-color: rgba(235, 245, 255, var(--border-opacity));\n}\n.focus\\:border-blue-100:focus {\n  --border-opacity: 1;\n  border-color: #e1effe;\n  border-color: rgba(225, 239, 254, var(--border-opacity));\n}\n.focus\\:border-blue-200:focus {\n  --border-opacity: 1;\n  border-color: #c3ddfd;\n  border-color: rgba(195, 221, 253, var(--border-opacity));\n}\n.focus\\:border-blue-300:focus {\n  --border-opacity: 1;\n  border-color: #a4cafe;\n  border-color: rgba(164, 202, 254, var(--border-opacity));\n}\n.focus\\:border-blue-400:focus {\n  --border-opacity: 1;\n  border-color: #76a9fa;\n  border-color: rgba(118, 169, 250, var(--border-opacity));\n}\n.focus\\:border-blue-500:focus {\n  --border-opacity: 1;\n  border-color: #3f83f8;\n  border-color: rgba(63, 131, 248, var(--border-opacity));\n}\n.focus\\:border-blue-600:focus {\n  --border-opacity: 1;\n  border-color: #1c64f2;\n  border-color: rgba(28, 100, 242, var(--border-opacity));\n}\n.focus\\:border-blue-700:focus {\n  --border-opacity: 1;\n  border-color: #1a56db;\n  border-color: rgba(26, 86, 219, var(--border-opacity));\n}\n.focus\\:border-blue-800:focus {\n  --border-opacity: 1;\n  border-color: #1e429f;\n  border-color: rgba(30, 66, 159, var(--border-opacity));\n}\n.focus\\:border-blue-900:focus {\n  --border-opacity: 1;\n  border-color: #233876;\n  border-color: rgba(35, 56, 118, var(--border-opacity));\n}\n.focus\\:border-indigo-50:focus {\n  --border-opacity: 1;\n  border-color: #f0f5ff;\n  border-color: rgba(240, 245, 255, var(--border-opacity));\n}\n.focus\\:border-indigo-100:focus {\n  --border-opacity: 1;\n  border-color: #e5edff;\n  border-color: rgba(229, 237, 255, var(--border-opacity));\n}\n.focus\\:border-indigo-200:focus {\n  --border-opacity: 1;\n  border-color: #cddbfe;\n  border-color: rgba(205, 219, 254, var(--border-opacity));\n}\n.focus\\:border-indigo-300:focus {\n  --border-opacity: 1;\n  border-color: #b4c6fc;\n  border-color: rgba(180, 198, 252, var(--border-opacity));\n}\n.focus\\:border-indigo-400:focus {\n  --border-opacity: 1;\n  border-color: #8da2fb;\n  border-color: rgba(141, 162, 251, var(--border-opacity));\n}\n.focus\\:border-indigo-500:focus {\n  --border-opacity: 1;\n  border-color: #6875f5;\n  border-color: rgba(104, 117, 245, var(--border-opacity));\n}\n.focus\\:border-indigo-600:focus {\n  --border-opacity: 1;\n  border-color: #5850ec;\n  border-color: rgba(88, 80, 236, var(--border-opacity));\n}\n.focus\\:border-indigo-700:focus {\n  --border-opacity: 1;\n  border-color: #5145cd;\n  border-color: rgba(81, 69, 205, var(--border-opacity));\n}\n.focus\\:border-indigo-800:focus {\n  --border-opacity: 1;\n  border-color: #42389d;\n  border-color: rgba(66, 56, 157, var(--border-opacity));\n}\n.focus\\:border-indigo-900:focus {\n  --border-opacity: 1;\n  border-color: #362f78;\n  border-color: rgba(54, 47, 120, var(--border-opacity));\n}\n.focus\\:border-purple-50:focus {\n  --border-opacity: 1;\n  border-color: #f6f5ff;\n  border-color: rgba(246, 245, 255, var(--border-opacity));\n}\n.focus\\:border-purple-100:focus {\n  --border-opacity: 1;\n  border-color: #edebfe;\n  border-color: rgba(237, 235, 254, var(--border-opacity));\n}\n.focus\\:border-purple-200:focus {\n  --border-opacity: 1;\n  border-color: #dcd7fe;\n  border-color: rgba(220, 215, 254, var(--border-opacity));\n}\n.focus\\:border-purple-300:focus {\n  --border-opacity: 1;\n  border-color: #cabffd;\n  border-color: rgba(202, 191, 253, var(--border-opacity));\n}\n.focus\\:border-purple-400:focus {\n  --border-opacity: 1;\n  border-color: #ac94fa;\n  border-color: rgba(172, 148, 250, var(--border-opacity));\n}\n.focus\\:border-purple-500:focus {\n  --border-opacity: 1;\n  border-color: #9061f9;\n  border-color: rgba(144, 97, 249, var(--border-opacity));\n}\n.focus\\:border-purple-600:focus {\n  --border-opacity: 1;\n  border-color: #7e3af2;\n  border-color: rgba(126, 58, 242, var(--border-opacity));\n}\n.focus\\:border-purple-700:focus {\n  --border-opacity: 1;\n  border-color: #6c2bd9;\n  border-color: rgba(108, 43, 217, var(--border-opacity));\n}\n.focus\\:border-purple-800:focus {\n  --border-opacity: 1;\n  border-color: #5521b5;\n  border-color: rgba(85, 33, 181, var(--border-opacity));\n}\n.focus\\:border-purple-900:focus {\n  --border-opacity: 1;\n  border-color: #4a1d96;\n  border-color: rgba(74, 29, 150, var(--border-opacity));\n}\n.focus\\:border-pink-50:focus {\n  --border-opacity: 1;\n  border-color: #fdf2f8;\n  border-color: rgba(253, 242, 248, var(--border-opacity));\n}\n.focus\\:border-pink-100:focus {\n  --border-opacity: 1;\n  border-color: #fce8f3;\n  border-color: rgba(252, 232, 243, var(--border-opacity));\n}\n.focus\\:border-pink-200:focus {\n  --border-opacity: 1;\n  border-color: #fad1e8;\n  border-color: rgba(250, 209, 232, var(--border-opacity));\n}\n.focus\\:border-pink-300:focus {\n  --border-opacity: 1;\n  border-color: #f8b4d9;\n  border-color: rgba(248, 180, 217, var(--border-opacity));\n}\n.focus\\:border-pink-400:focus {\n  --border-opacity: 1;\n  border-color: #f17eb8;\n  border-color: rgba(241, 126, 184, var(--border-opacity));\n}\n.focus\\:border-pink-500:focus {\n  --border-opacity: 1;\n  border-color: #e74694;\n  border-color: rgba(231, 70, 148, var(--border-opacity));\n}\n.focus\\:border-pink-600:focus {\n  --border-opacity: 1;\n  border-color: #d61f69;\n  border-color: rgba(214, 31, 105, var(--border-opacity));\n}\n.focus\\:border-pink-700:focus {\n  --border-opacity: 1;\n  border-color: #bf125d;\n  border-color: rgba(191, 18, 93, var(--border-opacity));\n}\n.focus\\:border-pink-800:focus {\n  --border-opacity: 1;\n  border-color: #99154b;\n  border-color: rgba(153, 21, 75, var(--border-opacity));\n}\n.focus\\:border-pink-900:focus {\n  --border-opacity: 1;\n  border-color: #751a3d;\n  border-color: rgba(117, 26, 61, var(--border-opacity));\n}\n.focus\\:border-cool-gray-50:focus {\n  --border-opacity: 1;\n  border-color: #f8fafc;\n  border-color: rgba(248, 250, 252, var(--border-opacity));\n}\n.focus\\:border-cool-gray-100:focus {\n  --border-opacity: 1;\n  border-color: #f1f5f9;\n  border-color: rgba(241, 245, 249, var(--border-opacity));\n}\n.focus\\:border-cool-gray-200:focus {\n  --border-opacity: 1;\n  border-color: #e2e8f0;\n  border-color: rgba(226, 232, 240, var(--border-opacity));\n}\n.focus\\:border-cool-gray-300:focus {\n  --border-opacity: 1;\n  border-color: #cfd8e3;\n  border-color: rgba(207, 216, 227, var(--border-opacity));\n}\n.focus\\:border-cool-gray-400:focus {\n  --border-opacity: 1;\n  border-color: #97a6ba;\n  border-color: rgba(151, 166, 186, var(--border-opacity));\n}\n.focus\\:border-cool-gray-500:focus {\n  --border-opacity: 1;\n  border-color: #64748b;\n  border-color: rgba(100, 116, 139, var(--border-opacity));\n}\n.focus\\:border-cool-gray-600:focus {\n  --border-opacity: 1;\n  border-color: #475569;\n  border-color: rgba(71, 85, 105, var(--border-opacity));\n}\n.focus\\:border-cool-gray-700:focus {\n  --border-opacity: 1;\n  border-color: #364152;\n  border-color: rgba(54, 65, 82, var(--border-opacity));\n}\n.focus\\:border-cool-gray-800:focus {\n  --border-opacity: 1;\n  border-color: #27303f;\n  border-color: rgba(39, 48, 63, var(--border-opacity));\n}\n.focus\\:border-cool-gray-900:focus {\n  --border-opacity: 1;\n  border-color: #1a202e;\n  border-color: rgba(26, 32, 46, var(--border-opacity));\n}\n.border-opacity-0 {\n  --border-opacity: 0;\n}\n.border-opacity-25 {\n  --border-opacity: 0.25;\n}\n.border-opacity-50 {\n  --border-opacity: 0.5;\n}\n.border-opacity-75 {\n  --border-opacity: 0.75;\n}\n.border-opacity-100 {\n  --border-opacity: 1;\n}\n.hover\\:border-opacity-0:hover {\n  --border-opacity: 0;\n}\n.hover\\:border-opacity-25:hover {\n  --border-opacity: 0.25;\n}\n.hover\\:border-opacity-50:hover {\n  --border-opacity: 0.5;\n}\n.hover\\:border-opacity-75:hover {\n  --border-opacity: 0.75;\n}\n.hover\\:border-opacity-100:hover {\n  --border-opacity: 1;\n}\n.focus\\:border-opacity-0:focus {\n  --border-opacity: 0;\n}\n.focus\\:border-opacity-25:focus {\n  --border-opacity: 0.25;\n}\n.focus\\:border-opacity-50:focus {\n  --border-opacity: 0.5;\n}\n.focus\\:border-opacity-75:focus {\n  --border-opacity: 0.75;\n}\n.focus\\:border-opacity-100:focus {\n  --border-opacity: 1;\n}\n.rounded-none {\n  border-radius: 0;\n}\n.rounded-sm {\n  border-radius: 0.125rem;\n}\n.rounded {\n  border-radius: 0.25rem;\n}\n.rounded-md {\n  border-radius: 0.375rem;\n}\n.rounded-lg {\n  border-radius: 0.5rem;\n}\n.rounded-xl {\n  border-radius: 0.75rem;\n}\n.rounded-2xl {\n  border-radius: 1rem;\n}\n.rounded-3xl {\n  border-radius: 1.5rem;\n}\n.rounded-full {\n  border-radius: 9999px;\n}\n.rounded-t-none {\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n.rounded-r-none {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.rounded-b-none {\n  border-bottom-right-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.rounded-l-none {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.rounded-t-sm {\n  border-top-left-radius: 0.125rem;\n  border-top-right-radius: 0.125rem;\n}\n.rounded-r-sm {\n  border-top-right-radius: 0.125rem;\n  border-bottom-right-radius: 0.125rem;\n}\n.rounded-b-sm {\n  border-bottom-right-radius: 0.125rem;\n  border-bottom-left-radius: 0.125rem;\n}\n.rounded-l-sm {\n  border-top-left-radius: 0.125rem;\n  border-bottom-left-radius: 0.125rem;\n}\n.rounded-t {\n  border-top-left-radius: 0.25rem;\n  border-top-right-radius: 0.25rem;\n}\n.rounded-r {\n  border-top-right-radius: 0.25rem;\n  border-bottom-right-radius: 0.25rem;\n}\n.rounded-b {\n  border-bottom-right-radius: 0.25rem;\n  border-bottom-left-radius: 0.25rem;\n}\n.rounded-l {\n  border-top-left-radius: 0.25rem;\n  border-bottom-left-radius: 0.25rem;\n}\n.rounded-t-md {\n  border-top-left-radius: 0.375rem;\n  border-top-right-radius: 0.375rem;\n}\n.rounded-r-md {\n  border-top-right-radius: 0.375rem;\n  border-bottom-right-radius: 0.375rem;\n}\n.rounded-b-md {\n  border-bottom-right-radius: 0.375rem;\n  border-bottom-left-radius: 0.375rem;\n}\n.rounded-l-md {\n  border-top-left-radius: 0.375rem;\n  border-bottom-left-radius: 0.375rem;\n}\n.rounded-t-lg {\n  border-top-left-radius: 0.5rem;\n  border-top-right-radius: 0.5rem;\n}\n.rounded-r-lg {\n  border-top-right-radius: 0.5rem;\n  border-bottom-right-radius: 0.5rem;\n}\n.rounded-b-lg {\n  border-bottom-right-radius: 0.5rem;\n  border-bottom-left-radius: 0.5rem;\n}\n.rounded-l-lg {\n  border-top-left-radius: 0.5rem;\n  border-bottom-left-radius: 0.5rem;\n}\n.rounded-t-xl {\n  border-top-left-radius: 0.75rem;\n  border-top-right-radius: 0.75rem;\n}\n.rounded-r-xl {\n  border-top-right-radius: 0.75rem;\n  border-bottom-right-radius: 0.75rem;\n}\n.rounded-b-xl {\n  border-bottom-right-radius: 0.75rem;\n  border-bottom-left-radius: 0.75rem;\n}\n.rounded-l-xl {\n  border-top-left-radius: 0.75rem;\n  border-bottom-left-radius: 0.75rem;\n}\n.rounded-t-2xl {\n  border-top-left-radius: 1rem;\n  border-top-right-radius: 1rem;\n}\n.rounded-r-2xl {\n  border-top-right-radius: 1rem;\n  border-bottom-right-radius: 1rem;\n}\n.rounded-b-2xl {\n  border-bottom-right-radius: 1rem;\n  border-bottom-left-radius: 1rem;\n}\n.rounded-l-2xl {\n  border-top-left-radius: 1rem;\n  border-bottom-left-radius: 1rem;\n}\n.rounded-t-3xl {\n  border-top-left-radius: 1.5rem;\n  border-top-right-radius: 1.5rem;\n}\n.rounded-r-3xl {\n  border-top-right-radius: 1.5rem;\n  border-bottom-right-radius: 1.5rem;\n}\n.rounded-b-3xl {\n  border-bottom-right-radius: 1.5rem;\n  border-bottom-left-radius: 1.5rem;\n}\n.rounded-l-3xl {\n  border-top-left-radius: 1.5rem;\n  border-bottom-left-radius: 1.5rem;\n}\n.rounded-t-full {\n  border-top-left-radius: 9999px;\n  border-top-right-radius: 9999px;\n}\n.rounded-r-full {\n  border-top-right-radius: 9999px;\n  border-bottom-right-radius: 9999px;\n}\n.rounded-b-full {\n  border-bottom-right-radius: 9999px;\n  border-bottom-left-radius: 9999px;\n}\n.rounded-l-full {\n  border-top-left-radius: 9999px;\n  border-bottom-left-radius: 9999px;\n}\n.rounded-tl-none {\n  border-top-left-radius: 0;\n}\n.rounded-tr-none {\n  border-top-right-radius: 0;\n}\n.rounded-br-none {\n  border-bottom-right-radius: 0;\n}\n.rounded-bl-none {\n  border-bottom-left-radius: 0;\n}\n.rounded-tl-sm {\n  border-top-left-radius: 0.125rem;\n}\n.rounded-tr-sm {\n  border-top-right-radius: 0.125rem;\n}\n.rounded-br-sm {\n  border-bottom-right-radius: 0.125rem;\n}\n.rounded-bl-sm {\n  border-bottom-left-radius: 0.125rem;\n}\n.rounded-tl {\n  border-top-left-radius: 0.25rem;\n}\n.rounded-tr {\n  border-top-right-radius: 0.25rem;\n}\n.rounded-br {\n  border-bottom-right-radius: 0.25rem;\n}\n.rounded-bl {\n  border-bottom-left-radius: 0.25rem;\n}\n.rounded-tl-md {\n  border-top-left-radius: 0.375rem;\n}\n.rounded-tr-md {\n  border-top-right-radius: 0.375rem;\n}\n.rounded-br-md {\n  border-bottom-right-radius: 0.375rem;\n}\n.rounded-bl-md {\n  border-bottom-left-radius: 0.375rem;\n}\n.rounded-tl-lg {\n  border-top-left-radius: 0.5rem;\n}\n.rounded-tr-lg {\n  border-top-right-radius: 0.5rem;\n}\n.rounded-br-lg {\n  border-bottom-right-radius: 0.5rem;\n}\n.rounded-bl-lg {\n  border-bottom-left-radius: 0.5rem;\n}\n.rounded-tl-xl {\n  border-top-left-radius: 0.75rem;\n}\n.rounded-tr-xl {\n  border-top-right-radius: 0.75rem;\n}\n.rounded-br-xl {\n  border-bottom-right-radius: 0.75rem;\n}\n.rounded-bl-xl {\n  border-bottom-left-radius: 0.75rem;\n}\n.rounded-tl-2xl {\n  border-top-left-radius: 1rem;\n}\n.rounded-tr-2xl {\n  border-top-right-radius: 1rem;\n}\n.rounded-br-2xl {\n  border-bottom-right-radius: 1rem;\n}\n.rounded-bl-2xl {\n  border-bottom-left-radius: 1rem;\n}\n.rounded-tl-3xl {\n  border-top-left-radius: 1.5rem;\n}\n.rounded-tr-3xl {\n  border-top-right-radius: 1.5rem;\n}\n.rounded-br-3xl {\n  border-bottom-right-radius: 1.5rem;\n}\n.rounded-bl-3xl {\n  border-bottom-left-radius: 1.5rem;\n}\n.rounded-tl-full {\n  border-top-left-radius: 9999px;\n}\n.rounded-tr-full {\n  border-top-right-radius: 9999px;\n}\n.rounded-br-full {\n  border-bottom-right-radius: 9999px;\n}\n.rounded-bl-full {\n  border-bottom-left-radius: 9999px;\n}\n.border-solid {\n  border-style: solid;\n}\n.border-dashed {\n  border-style: dashed;\n}\n.border-dotted {\n  border-style: dotted;\n}\n.border-double {\n  border-style: double;\n}\n.border-none {\n  border-style: none;\n}\n.border-0 {\n  border-width: 0;\n}\n.border-2 {\n  border-width: 2px;\n}\n.border-4 {\n  border-width: 4px;\n}\n.border-8 {\n  border-width: 8px;\n}\n.border {\n  border-width: 1px;\n}\n.border-t-0 {\n  border-top-width: 0;\n}\n.border-r-0 {\n  border-right-width: 0;\n}\n.border-b-0 {\n  border-bottom-width: 0;\n}\n.border-l-0 {\n  border-left-width: 0;\n}\n.border-t-2 {\n  border-top-width: 2px;\n}\n.border-r-2 {\n  border-right-width: 2px;\n}\n.border-b-2 {\n  border-bottom-width: 2px;\n}\n.border-l-2 {\n  border-left-width: 2px;\n}\n.border-t-4 {\n  border-top-width: 4px;\n}\n.border-r-4 {\n  border-right-width: 4px;\n}\n.border-b-4 {\n  border-bottom-width: 4px;\n}\n.border-l-4 {\n  border-left-width: 4px;\n}\n.border-t-8 {\n  border-top-width: 8px;\n}\n.border-r-8 {\n  border-right-width: 8px;\n}\n.border-b-8 {\n  border-bottom-width: 8px;\n}\n.border-l-8 {\n  border-left-width: 8px;\n}\n.border-t {\n  border-top-width: 1px;\n}\n.border-r {\n  border-right-width: 1px;\n}\n.border-b {\n  border-bottom-width: 1px;\n}\n.border-l {\n  border-left-width: 1px;\n}\n.box-border {\n  box-sizing: border-box;\n}\n.box-content {\n  box-sizing: content-box;\n}\n.cursor-auto {\n  cursor: auto;\n}\n.cursor-default {\n  cursor: default;\n}\n.cursor-pointer {\n  cursor: pointer;\n}\n.cursor-wait {\n  cursor: wait;\n}\n.cursor-text {\n  cursor: text;\n}\n.cursor-move {\n  cursor: move;\n}\n.cursor-not-allowed {\n  cursor: not-allowed;\n}\n.block {\n  display: block;\n}\n.inline-block {\n  display: inline-block;\n}\n.inline {\n  display: inline;\n}\n.flex {\n  display: flex;\n}\n.inline-flex {\n  display: inline-flex;\n}\n.table {\n  display: table;\n}\n.table-caption {\n  display: table-caption;\n}\n.table-cell {\n  display: table-cell;\n}\n.table-column {\n  display: table-column;\n}\n.table-column-group {\n  display: table-column-group;\n}\n.table-footer-group {\n  display: table-footer-group;\n}\n.table-header-group {\n  display: table-header-group;\n}\n.table-row-group {\n  display: table-row-group;\n}\n.table-row {\n  display: table-row;\n}\n.flow-root {\n  display: flow-root;\n}\n.grid {\n  display: grid;\n}\n.inline-grid {\n  display: inline-grid;\n}\n.contents {\n  display: contents;\n}\n.hidden {\n  display: none;\n}\n.flex-row {\n  flex-direction: row;\n}\n.flex-row-reverse {\n  flex-direction: row-reverse;\n}\n.flex-col {\n  flex-direction: column;\n}\n.flex-col-reverse {\n  flex-direction: column-reverse;\n}\n.flex-wrap {\n  flex-wrap: wrap;\n}\n.flex-wrap-reverse {\n  flex-wrap: wrap-reverse;\n}\n.flex-no-wrap {\n  flex-wrap: nowrap;\n}\n.place-items-auto {\n  place-items: auto;\n}\n.place-items-start {\n  place-items: start;\n}\n.place-items-end {\n  place-items: end;\n}\n.place-items-center {\n  place-items: center;\n}\n.place-items-stretch {\n  place-items: stretch;\n}\n.place-content-center {\n  place-content: center;\n}\n.place-content-start {\n  place-content: start;\n}\n.place-content-end {\n  place-content: end;\n}\n.place-content-between {\n  place-content: space-between;\n}\n.place-content-around {\n  place-content: space-around;\n}\n.place-content-evenly {\n  place-content: space-evenly;\n}\n.place-content-stretch {\n  place-content: stretch;\n}\n.place-self-auto {\n  place-self: auto;\n}\n.place-self-start {\n  place-self: start;\n}\n.place-self-end {\n  place-self: end;\n}\n.place-self-center {\n  place-self: center;\n}\n.place-self-stretch {\n  place-self: stretch;\n}\n.items-start {\n  align-items: flex-start;\n}\n.items-end {\n  align-items: flex-end;\n}\n.items-center {\n  align-items: center;\n}\n.items-baseline {\n  align-items: baseline;\n}\n.items-stretch {\n  align-items: stretch;\n}\n.content-center {\n  align-content: center;\n}\n.content-start {\n  align-content: flex-start;\n}\n.content-end {\n  align-content: flex-end;\n}\n.content-between {\n  align-content: space-between;\n}\n.content-around {\n  align-content: space-around;\n}\n.content-evenly {\n  align-content: space-evenly;\n}\n.self-auto {\n  align-self: auto;\n}\n.self-start {\n  align-self: flex-start;\n}\n.self-end {\n  align-self: flex-end;\n}\n.self-center {\n  align-self: center;\n}\n.self-stretch {\n  align-self: stretch;\n}\n.justify-items-auto {\n  justify-items: auto;\n}\n.justify-items-start {\n  justify-items: start;\n}\n.justify-items-end {\n  justify-items: end;\n}\n.justify-items-center {\n  justify-items: center;\n}\n.justify-items-stretch {\n  justify-items: stretch;\n}\n.justify-start {\n  justify-content: flex-start;\n}\n.justify-end {\n  justify-content: flex-end;\n}\n.justify-center {\n  justify-content: center;\n}\n.justify-between {\n  justify-content: space-between;\n}\n.justify-around {\n  justify-content: space-around;\n}\n.justify-evenly {\n  justify-content: space-evenly;\n}\n.justify-self-auto {\n  justify-self: auto;\n}\n.justify-self-start {\n  justify-self: start;\n}\n.justify-self-end {\n  justify-self: end;\n}\n.justify-self-center {\n  justify-self: center;\n}\n.justify-self-stretch {\n  justify-self: stretch;\n}\n.flex-1 {\n  flex: 1 1 0%;\n}\n.flex-auto {\n  flex: 1 1 auto;\n}\n.flex-initial {\n  flex: 0 1 auto;\n}\n.flex-none {\n  flex: none;\n}\n.flex-grow-0 {\n  flex-grow: 0;\n}\n.flex-grow {\n  flex-grow: 1;\n}\n.flex-shrink-0 {\n  flex-shrink: 0;\n}\n.flex-shrink {\n  flex-shrink: 1;\n}\n.order-1 {\n  order: 1;\n}\n.order-2 {\n  order: 2;\n}\n.order-3 {\n  order: 3;\n}\n.order-4 {\n  order: 4;\n}\n.order-5 {\n  order: 5;\n}\n.order-6 {\n  order: 6;\n}\n.order-7 {\n  order: 7;\n}\n.order-8 {\n  order: 8;\n}\n.order-9 {\n  order: 9;\n}\n.order-10 {\n  order: 10;\n}\n.order-11 {\n  order: 11;\n}\n.order-12 {\n  order: 12;\n}\n.order-first {\n  order: -9999;\n}\n.order-last {\n  order: 9999;\n}\n.order-none {\n  order: 0;\n}\n.float-right {\n  float: right;\n}\n.float-left {\n  float: left;\n}\n.float-none {\n  float: none;\n}\n.clearfix:after {\n  content: \"\";\n  display: table;\n  clear: both;\n}\n.clear-left {\n  clear: left;\n}\n.clear-right {\n  clear: right;\n}\n.clear-both {\n  clear: both;\n}\n.clear-none {\n  clear: none;\n}\n.font-sans {\n  font-family: system-ui, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, \"Noto Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n}\n.font-serif {\n  font-family: Georgia, Cambria, \"Times New Roman\", Times, serif;\n}\n.font-mono {\n  font-family: Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace;\n}\n.font-hairline {\n  font-weight: 100;\n}\n.font-thin {\n  font-weight: 200;\n}\n.font-light {\n  font-weight: 300;\n}\n.font-normal {\n  font-weight: 400;\n}\n.font-medium {\n  font-weight: 500;\n}\n.font-semibold {\n  font-weight: 600;\n}\n.font-bold {\n  font-weight: 700;\n}\n.font-extrabold {\n  font-weight: 800;\n}\n.font-black {\n  font-weight: 900;\n}\n.hover\\:font-hairline:hover {\n  font-weight: 100;\n}\n.hover\\:font-thin:hover {\n  font-weight: 200;\n}\n.hover\\:font-light:hover {\n  font-weight: 300;\n}\n.hover\\:font-normal:hover {\n  font-weight: 400;\n}\n.hover\\:font-medium:hover {\n  font-weight: 500;\n}\n.hover\\:font-semibold:hover {\n  font-weight: 600;\n}\n.hover\\:font-bold:hover {\n  font-weight: 700;\n}\n.hover\\:font-extrabold:hover {\n  font-weight: 800;\n}\n.hover\\:font-black:hover {\n  font-weight: 900;\n}\n.focus\\:font-hairline:focus {\n  font-weight: 100;\n}\n.focus\\:font-thin:focus {\n  font-weight: 200;\n}\n.focus\\:font-light:focus {\n  font-weight: 300;\n}\n.focus\\:font-normal:focus {\n  font-weight: 400;\n}\n.focus\\:font-medium:focus {\n  font-weight: 500;\n}\n.focus\\:font-semibold:focus {\n  font-weight: 600;\n}\n.focus\\:font-bold:focus {\n  font-weight: 700;\n}\n.focus\\:font-extrabold:focus {\n  font-weight: 800;\n}\n.focus\\:font-black:focus {\n  font-weight: 900;\n}\n.h-0 {\n  height: 0;\n}\n.h-1 {\n  height: 0.25rem;\n}\n.h-2 {\n  height: 0.5rem;\n}\n.h-3 {\n  height: 0.75rem;\n}\n.h-4 {\n  height: 1rem;\n}\n.h-5 {\n  height: 1.25rem;\n}\n.h-6 {\n  height: 1.5rem;\n}\n.h-7 {\n  height: 1.75rem;\n}\n.h-8 {\n  height: 3rem;\n}\n.h-9 {\n  height: 2.25rem;\n}\n.h-10 {\n  height: 2.5rem;\n}\n.h-11 {\n  height: 2.75rem;\n}\n.h-12 {\n  height: 3rem;\n}\n.h-13 {\n  height: 3.25rem;\n}\n.h-14 {\n  height: 3.5rem;\n}\n.h-15 {\n  height: 3.75rem;\n}\n.h-16 {\n  height: 4rem;\n}\n.h-20 {\n  height: 5rem;\n}\n.h-24 {\n  height: 6rem;\n}\n.h-28 {\n  height: 7rem;\n}\n.h-32 {\n  height: 8rem;\n}\n.h-36 {\n  height: 9rem;\n}\n.h-40 {\n  height: 10rem;\n}\n.h-44 {\n  height: 11rem;\n}\n.h-48 {\n  height: 12rem;\n}\n.h-52 {\n  height: 13rem;\n}\n.h-56 {\n  height: 14rem;\n}\n.h-60 {\n  height: 15rem;\n}\n.h-64 {\n  height: 16rem;\n}\n.h-72 {\n  height: 18rem;\n}\n.h-80 {\n  height: 20rem;\n}\n.h-96 {\n  height: 24rem;\n}\n.h-auto {\n  height: auto;\n}\n.h-px {\n  height: 1px;\n}\n.h-0\\.5 {\n  height: 0.125rem;\n}\n.h-1\\.5 {\n  height: 0.375rem;\n}\n.h-2\\.5 {\n  height: 0.625rem;\n}\n.h-3\\.5 {\n  height: 0.875rem;\n}\n.h-1\\/2 {\n  height: 50%;\n}\n.h-1\\/3 {\n  height: 33.333333%;\n}\n.h-2\\/3 {\n  height: 66.666667%;\n}\n.h-1\\/4 {\n  height: 25%;\n}\n.h-2\\/4 {\n  height: 50%;\n}\n.h-3\\/4 {\n  height: 75%;\n}\n.h-1\\/5 {\n  height: 20%;\n}\n.h-2\\/5 {\n  height: 40%;\n}\n.h-3\\/5 {\n  height: 60%;\n}\n.h-4\\/5 {\n  height: 80%;\n}\n.h-1\\/6 {\n  height: 16.666667%;\n}\n.h-2\\/6 {\n  height: 33.333333%;\n}\n.h-3\\/6 {\n  height: 50%;\n}\n.h-4\\/6 {\n  height: 66.666667%;\n}\n.h-5\\/6 {\n  height: 83.333333%;\n}\n.h-1\\/12 {\n  height: 8.333333%;\n}\n.h-2\\/12 {\n  height: 16.666667%;\n}\n.h-3\\/12 {\n  height: 25%;\n}\n.h-4\\/12 {\n  height: 33.333333%;\n}\n.h-5\\/12 {\n  height: 41.666667%;\n}\n.h-6\\/12 {\n  height: 50%;\n}\n.h-7\\/12 {\n  height: 58.333333%;\n}\n.h-8\\/12 {\n  height: 66.666667%;\n}\n.h-9\\/12 {\n  height: 75%;\n}\n.h-10\\/12 {\n  height: 83.333333%;\n}\n.h-11\\/12 {\n  height: 91.666667%;\n}\n.h-full {\n  height: 100%;\n}\n.h-screen {\n  height: 100vh;\n}\n.text-xs {\n  font-size: 0.75rem;\n}\n.text-sm {\n  font-size: 0.875rem;\n}\n.text-base {\n  font-size: 1rem;\n}\n.text-lg {\n  font-size: 1.125rem;\n}\n.text-xl {\n  font-size: 1.25rem;\n}\n.text-2xl {\n  font-size: 1.5rem;\n}\n.text-3xl {\n  font-size: 1.875rem;\n}\n.text-4xl {\n  font-size: 2.25rem;\n}\n.text-5xl {\n  font-size: 3rem;\n}\n.text-6xl {\n  font-size: 4rem;\n}\n.leading-3 {\n  line-height: .75rem;\n}\n.leading-4 {\n  line-height: 1rem;\n}\n.leading-5 {\n  line-height: 1.25rem;\n}\n.leading-6 {\n  line-height: 1.5rem;\n}\n.leading-7 {\n  line-height: 1.75rem;\n}\n.leading-8 {\n  line-height: 2rem;\n}\n.leading-9 {\n  line-height: 2.25rem;\n}\n.leading-10 {\n  line-height: 2.5rem;\n}\n.leading-none {\n  line-height: 1;\n}\n.leading-tight {\n  line-height: 1.25;\n}\n.leading-snug {\n  line-height: 1.375;\n}\n.leading-normal {\n  line-height: 1.5;\n}\n.leading-relaxed {\n  line-height: 1.625;\n}\n.leading-loose {\n  line-height: 2;\n}\n.list-inside {\n  list-style-position: inside;\n}\n.list-outside {\n  list-style-position: outside;\n}\n.list-none {\n  list-style-type: none;\n}\n.list-disc {\n  list-style-type: disc;\n}\n.list-decimal {\n  list-style-type: decimal;\n}\n.m-0 {\n  margin: 0;\n}\n.m-1 {\n  margin: 0.25rem;\n}\n.m-2 {\n  margin: 0.5rem;\n}\n.m-3 {\n  margin: 0.75rem;\n}\n.m-4 {\n  margin: 1rem;\n}\n.m-5 {\n  margin: 1.25rem;\n}\n.m-6 {\n  margin: 1.5rem;\n}\n.m-7 {\n  margin: 1.75rem;\n}\n.m-8 {\n  margin: 2rem;\n}\n.m-9 {\n  margin: 2.25rem;\n}\n.m-10 {\n  margin: 2.5rem;\n}\n.m-11 {\n  margin: 2.75rem;\n}\n.m-12 {\n  margin: 3rem;\n}\n.m-13 {\n  margin: 3.25rem;\n}\n.m-14 {\n  margin: 3.5rem;\n}\n.m-15 {\n  margin: 3.75rem;\n}\n.m-16 {\n  margin: 4rem;\n}\n.m-20 {\n  margin: 5rem;\n}\n.m-24 {\n  margin: 6rem;\n}\n.m-28 {\n  margin: 7rem;\n}\n.m-32 {\n  margin: 8rem;\n}\n.m-36 {\n  margin: 9rem;\n}\n.m-40 {\n  margin: 10rem;\n}\n.m-44 {\n  margin: 11rem;\n}\n.m-48 {\n  margin: 12rem;\n}\n.m-52 {\n  margin: 13rem;\n}\n.m-56 {\n  margin: 14rem;\n}\n.m-60 {\n  margin: 15rem;\n}\n.m-64 {\n  margin: 16rem;\n}\n.m-72 {\n  margin: 18rem;\n}\n.m-80 {\n  margin: 20rem;\n}\n.m-96 {\n  margin: 24rem;\n}\n.m-auto {\n  margin: auto;\n}\n.m-px {\n  margin: 1px;\n}\n.m-0\\.5 {\n  margin: 0.125rem;\n}\n.m-1\\.5 {\n  margin: 0.375rem;\n}\n.m-2\\.5 {\n  margin: 0.625rem;\n}\n.m-3\\.5 {\n  margin: 0.875rem;\n}\n.m-1\\/2 {\n  margin: 50%;\n}\n.m-1\\/3 {\n  margin: 33.333333%;\n}\n.m-2\\/3 {\n  margin: 66.666667%;\n}\n.m-1\\/4 {\n  margin: 25%;\n}\n.m-2\\/4 {\n  margin: 50%;\n}\n.m-3\\/4 {\n  margin: 75%;\n}\n.m-1\\/5 {\n  margin: 20%;\n}\n.m-2\\/5 {\n  margin: 40%;\n}\n.m-3\\/5 {\n  margin: 60%;\n}\n.m-4\\/5 {\n  margin: 80%;\n}\n.m-1\\/6 {\n  margin: 16.666667%;\n}\n.m-2\\/6 {\n  margin: 33.333333%;\n}\n.m-3\\/6 {\n  margin: 50%;\n}\n.m-4\\/6 {\n  margin: 66.666667%;\n}\n.m-5\\/6 {\n  margin: 83.333333%;\n}\n.m-1\\/12 {\n  margin: 8.333333%;\n}\n.m-2\\/12 {\n  margin: 16.666667%;\n}\n.m-3\\/12 {\n  margin: 25%;\n}\n.m-4\\/12 {\n  margin: 33.333333%;\n}\n.m-5\\/12 {\n  margin: 41.666667%;\n}\n.m-6\\/12 {\n  margin: 50%;\n}\n.m-7\\/12 {\n  margin: 58.333333%;\n}\n.m-8\\/12 {\n  margin: 66.666667%;\n}\n.m-9\\/12 {\n  margin: 75%;\n}\n.m-10\\/12 {\n  margin: 83.333333%;\n}\n.m-11\\/12 {\n  margin: 91.666667%;\n}\n.m-full {\n  margin: 100%;\n}\n.-m-1 {\n  margin: -0.25rem;\n}\n.-m-2 {\n  margin: -0.5rem;\n}\n.-m-3 {\n  margin: -0.75rem;\n}\n.-m-4 {\n  margin: -1rem;\n}\n.-m-5 {\n  margin: -1.25rem;\n}\n.-m-6 {\n  margin: -1.5rem;\n}\n.-m-7 {\n  margin: -1.75rem;\n}\n.-m-8 {\n  margin: -2rem;\n}\n.-m-9 {\n  margin: -2.25rem;\n}\n.-m-10 {\n  margin: -2.5rem;\n}\n.-m-11 {\n  margin: -2.75rem;\n}\n.-m-12 {\n  margin: -3rem;\n}\n.-m-13 {\n  margin: -3.25rem;\n}\n.-m-14 {\n  margin: -3.5rem;\n}\n.-m-15 {\n  margin: -3.75rem;\n}\n.-m-16 {\n  margin: -4rem;\n}\n.-m-20 {\n  margin: -5rem;\n}\n.-m-24 {\n  margin: -6rem;\n}\n.-m-28 {\n  margin: -7rem;\n}\n.-m-32 {\n  margin: -8rem;\n}\n.-m-36 {\n  margin: -9rem;\n}\n.-m-40 {\n  margin: -10rem;\n}\n.-m-44 {\n  margin: -11rem;\n}\n.-m-48 {\n  margin: -12rem;\n}\n.-m-52 {\n  margin: -13rem;\n}\n.-m-56 {\n  margin: -14rem;\n}\n.-m-60 {\n  margin: -15rem;\n}\n.-m-64 {\n  margin: -16rem;\n}\n.-m-72 {\n  margin: -18rem;\n}\n.-m-80 {\n  margin: -20rem;\n}\n.-m-96 {\n  margin: -24rem;\n}\n.-m-px {\n  margin: -1px;\n}\n.-m-0\\.5 {\n  margin: -0.125rem;\n}\n.-m-1\\.5 {\n  margin: -0.375rem;\n}\n.-m-2\\.5 {\n  margin: -0.625rem;\n}\n.-m-3\\.5 {\n  margin: -0.875rem;\n}\n.-m-1\\/2 {\n  margin: -50%;\n}\n.-m-1\\/3 {\n  margin: -33.33333%;\n}\n.-m-2\\/3 {\n  margin: -66.66667%;\n}\n.-m-1\\/4 {\n  margin: -25%;\n}\n.-m-2\\/4 {\n  margin: -50%;\n}\n.-m-3\\/4 {\n  margin: -75%;\n}\n.-m-1\\/5 {\n  margin: -20%;\n}\n.-m-2\\/5 {\n  margin: -40%;\n}\n.-m-3\\/5 {\n  margin: -60%;\n}\n.-m-4\\/5 {\n  margin: -80%;\n}\n.-m-1\\/6 {\n  margin: -16.66667%;\n}\n.-m-2\\/6 {\n  margin: -33.33333%;\n}\n.-m-3\\/6 {\n  margin: -50%;\n}\n.-m-4\\/6 {\n  margin: -66.66667%;\n}\n.-m-5\\/6 {\n  margin: -83.33333%;\n}\n.-m-1\\/12 {\n  margin: -8.33333%;\n}\n.-m-2\\/12 {\n  margin: -16.66667%;\n}\n.-m-3\\/12 {\n  margin: -25%;\n}\n.-m-4\\/12 {\n  margin: -33.33333%;\n}\n.-m-5\\/12 {\n  margin: -41.66667%;\n}\n.-m-6\\/12 {\n  margin: -50%;\n}\n.-m-7\\/12 {\n  margin: -58.33333%;\n}\n.-m-8\\/12 {\n  margin: -66.66667%;\n}\n.-m-9\\/12 {\n  margin: -75%;\n}\n.-m-10\\/12 {\n  margin: -83.33333%;\n}\n.-m-11\\/12 {\n  margin: -91.66667%;\n}\n.-m-full {\n  margin: -100%;\n}\n.my-0 {\n  margin-top: 0;\n  margin-bottom: 0;\n}\n.mx-0 {\n  margin-left: 0;\n  margin-right: 0;\n}\n.my-1 {\n  margin-top: 0.25rem;\n  margin-bottom: 0.25rem;\n}\n.mx-1 {\n  margin-left: 0.25rem;\n  margin-right: 0.25rem;\n}\n.my-2 {\n  margin-top: 0.5rem;\n  margin-bottom: 0.5rem;\n}\n.mx-2 {\n  margin-left: 0.5rem;\n  margin-right: 0.5rem;\n}\n.my-3 {\n  margin-top: 0.75rem;\n  margin-bottom: 0.75rem;\n}\n.mx-3 {\n  margin-left: 0.75rem;\n  margin-right: 0.75rem;\n}\n.my-4 {\n  margin-top: 1rem;\n  margin-bottom: 1rem;\n}\n.mx-4 {\n  margin-left: 1rem;\n  margin-right: 1rem;\n}\n.my-5 {\n  margin-top: 1.25rem;\n  margin-bottom: 1.25rem;\n}\n.mx-5 {\n  margin-left: 1.25rem;\n  margin-right: 1.25rem;\n}\n.my-6 {\n  margin-top: 1.5rem;\n  margin-bottom: 1.5rem;\n}\n.mx-6 {\n  margin-left: 1.5rem;\n  margin-right: 1.5rem;\n}\n.my-7 {\n  margin-top: 1.75rem;\n  margin-bottom: 1.75rem;\n}\n.mx-7 {\n  margin-left: 1.75rem;\n  margin-right: 1.75rem;\n}\n.my-8 {\n  margin-top: 2rem;\n  margin-bottom: 2rem;\n}\n.mx-8 {\n  margin-left: 2rem;\n  margin-right: 2rem;\n}\n.my-9 {\n  margin-top: 2.25rem;\n  margin-bottom: 2.25rem;\n}\n.mx-9 {\n  margin-left: 2.25rem;\n  margin-right: 2.25rem;\n}\n.my-10 {\n  margin-top: 2.5rem;\n  margin-bottom: 2.5rem;\n}\n.mx-10 {\n  margin-left: 2.5rem;\n  margin-right: 2.5rem;\n}\n.my-11 {\n  margin-top: 2.75rem;\n  margin-bottom: 2.75rem;\n}\n.mx-11 {\n  margin-left: 2.75rem;\n  margin-right: 2.75rem;\n}\n.my-12 {\n  margin-top: 3rem;\n  margin-bottom: 3rem;\n}\n.mx-12 {\n  margin-left: 3rem;\n  margin-right: 3rem;\n}\n.my-13 {\n  margin-top: 3.25rem;\n  margin-bottom: 3.25rem;\n}\n.mx-13 {\n  margin-left: 3.25rem;\n  margin-right: 3.25rem;\n}\n.my-14 {\n  margin-top: 3.5rem;\n  margin-bottom: 3.5rem;\n}\n.mx-14 {\n  margin-left: 3.5rem;\n  margin-right: 3.5rem;\n}\n.my-15 {\n  margin-top: 3.75rem;\n  margin-bottom: 3.75rem;\n}\n.mx-15 {\n  margin-left: 3.75rem;\n  margin-right: 3.75rem;\n}\n.my-16 {\n  margin-top: 4rem;\n  margin-bottom: 4rem;\n}\n.mx-16 {\n  margin-left: 4rem;\n  margin-right: 4rem;\n}\n.my-20 {\n  margin-top: 5rem;\n  margin-bottom: 5rem;\n}\n.mx-20 {\n  margin-left: 5rem;\n  margin-right: 5rem;\n}\n.my-24 {\n  margin-top: 6rem;\n  margin-bottom: 6rem;\n}\n.mx-24 {\n  margin-left: 6rem;\n  margin-right: 6rem;\n}\n.my-28 {\n  margin-top: 7rem;\n  margin-bottom: 7rem;\n}\n.mx-28 {\n  margin-left: 7rem;\n  margin-right: 7rem;\n}\n.my-32 {\n  margin-top: 8rem;\n  margin-bottom: 8rem;\n}\n.mx-32 {\n  margin-left: 8rem;\n  margin-right: 8rem;\n}\n.my-36 {\n  margin-top: 9rem;\n  margin-bottom: 9rem;\n}\n.mx-36 {\n  margin-left: 9rem;\n  margin-right: 9rem;\n}\n.my-40 {\n  margin-top: 10rem;\n  margin-bottom: 10rem;\n}\n.mx-40 {\n  margin-left: 10rem;\n  margin-right: 10rem;\n}\n.my-44 {\n  margin-top: 11rem;\n  margin-bottom: 11rem;\n}\n.mx-44 {\n  margin-left: 11rem;\n  margin-right: 11rem;\n}\n.my-48 {\n  margin-top: 12rem;\n  margin-bottom: 12rem;\n}\n.mx-48 {\n  margin-left: 12rem;\n  margin-right: 12rem;\n}\n.my-52 {\n  margin-top: 13rem;\n  margin-bottom: 13rem;\n}\n.mx-52 {\n  margin-left: 13rem;\n  margin-right: 13rem;\n}\n.my-56 {\n  margin-top: 14rem;\n  margin-bottom: 14rem;\n}\n.mx-56 {\n  margin-left: 14rem;\n  margin-right: 14rem;\n}\n.my-60 {\n  margin-top: 15rem;\n  margin-bottom: 15rem;\n}\n.mx-60 {\n  margin-left: 15rem;\n  margin-right: 15rem;\n}\n.my-64 {\n  margin-top: 16rem;\n  margin-bottom: 16rem;\n}\n.mx-64 {\n  margin-left: 16rem;\n  margin-right: 16rem;\n}\n.my-72 {\n  margin-top: 18rem;\n  margin-bottom: 18rem;\n}\n.mx-72 {\n  margin-left: 18rem;\n  margin-right: 18rem;\n}\n.my-80 {\n  margin-top: 20rem;\n  margin-bottom: 20rem;\n}\n.mx-80 {\n  margin-left: 20rem;\n  margin-right: 20rem;\n}\n.my-96 {\n  margin-top: 24rem;\n  margin-bottom: 24rem;\n}\n.mx-96 {\n  margin-left: 24rem;\n  margin-right: 24rem;\n}\n.my-auto {\n  margin-top: auto;\n  margin-bottom: auto;\n}\n.mx-auto {\n  margin-left: auto;\n  margin-right: auto;\n}\n.my-px {\n  margin-top: 1px;\n  margin-bottom: 1px;\n}\n.mx-px {\n  margin-left: 1px;\n  margin-right: 1px;\n}\n.my-0\\.5 {\n  margin-top: 0.125rem;\n  margin-bottom: 0.125rem;\n}\n.mx-0\\.5 {\n  margin-left: 0.125rem;\n  margin-right: 0.125rem;\n}\n.my-1\\.5 {\n  margin-top: 0.375rem;\n  margin-bottom: 0.375rem;\n}\n.mx-1\\.5 {\n  margin-left: 0.375rem;\n  margin-right: 0.375rem;\n}\n.my-2\\.5 {\n  margin-top: 0.625rem;\n  margin-bottom: 0.625rem;\n}\n.mx-2\\.5 {\n  margin-left: 0.625rem;\n  margin-right: 0.625rem;\n}\n.my-3\\.5 {\n  margin-top: 0.875rem;\n  margin-bottom: 0.875rem;\n}\n.mx-3\\.5 {\n  margin-left: 0.875rem;\n  margin-right: 0.875rem;\n}\n.my-1\\/2 {\n  margin-top: 50%;\n  margin-bottom: 50%;\n}\n.mx-1\\/2 {\n  margin-left: 50%;\n  margin-right: 50%;\n}\n.my-1\\/3 {\n  margin-top: 33.333333%;\n  margin-bottom: 33.333333%;\n}\n.mx-1\\/3 {\n  margin-left: 33.333333%;\n  margin-right: 33.333333%;\n}\n.my-2\\/3 {\n  margin-top: 66.666667%;\n  margin-bottom: 66.666667%;\n}\n.mx-2\\/3 {\n  margin-left: 66.666667%;\n  margin-right: 66.666667%;\n}\n.my-1\\/4 {\n  margin-top: 25%;\n  margin-bottom: 25%;\n}\n.mx-1\\/4 {\n  margin-left: 25%;\n  margin-right: 25%;\n}\n.my-2\\/4 {\n  margin-top: 50%;\n  margin-bottom: 50%;\n}\n.mx-2\\/4 {\n  margin-left: 50%;\n  margin-right: 50%;\n}\n.my-3\\/4 {\n  margin-top: 75%;\n  margin-bottom: 75%;\n}\n.mx-3\\/4 {\n  margin-left: 75%;\n  margin-right: 75%;\n}\n.my-1\\/5 {\n  margin-top: 20%;\n  margin-bottom: 20%;\n}\n.mx-1\\/5 {\n  margin-left: 20%;\n  margin-right: 20%;\n}\n.my-2\\/5 {\n  margin-top: 40%;\n  margin-bottom: 40%;\n}\n.mx-2\\/5 {\n  margin-left: 40%;\n  margin-right: 40%;\n}\n.my-3\\/5 {\n  margin-top: 60%;\n  margin-bottom: 60%;\n}\n.mx-3\\/5 {\n  margin-left: 60%;\n  margin-right: 60%;\n}\n.my-4\\/5 {\n  margin-top: 80%;\n  margin-bottom: 80%;\n}\n.mx-4\\/5 {\n  margin-left: 80%;\n  margin-right: 80%;\n}\n.my-1\\/6 {\n  margin-top: 16.666667%;\n  margin-bottom: 16.666667%;\n}\n.mx-1\\/6 {\n  margin-left: 16.666667%;\n  margin-right: 16.666667%;\n}\n.my-2\\/6 {\n  margin-top: 33.333333%;\n  margin-bottom: 33.333333%;\n}\n.mx-2\\/6 {\n  margin-left: 33.333333%;\n  margin-right: 33.333333%;\n}\n.my-3\\/6 {\n  margin-top: 50%;\n  margin-bottom: 50%;\n}\n.mx-3\\/6 {\n  margin-left: 50%;\n  margin-right: 50%;\n}\n.my-4\\/6 {\n  margin-top: 66.666667%;\n  margin-bottom: 66.666667%;\n}\n.mx-4\\/6 {\n  margin-left: 66.666667%;\n  margin-right: 66.666667%;\n}\n.my-5\\/6 {\n  margin-top: 83.333333%;\n  margin-bottom: 83.333333%;\n}\n.mx-5\\/6 {\n  margin-left: 83.333333%;\n  margin-right: 83.333333%;\n}\n.my-1\\/12 {\n  margin-top: 8.333333%;\n  margin-bottom: 8.333333%;\n}\n.mx-1\\/12 {\n  margin-left: 8.333333%;\n  margin-right: 8.333333%;\n}\n.my-2\\/12 {\n  margin-top: 16.666667%;\n  margin-bottom: 16.666667%;\n}\n.mx-2\\/12 {\n  margin-left: 16.666667%;\n  margin-right: 16.666667%;\n}\n.my-3\\/12 {\n  margin-top: 25%;\n  margin-bottom: 25%;\n}\n.mx-3\\/12 {\n  margin-left: 25%;\n  margin-right: 25%;\n}\n.my-4\\/12 {\n  margin-top: 33.333333%;\n  margin-bottom: 33.333333%;\n}\n.mx-4\\/12 {\n  margin-left: 33.333333%;\n  margin-right: 33.333333%;\n}\n.my-5\\/12 {\n  margin-top: 41.666667%;\n  margin-bottom: 41.666667%;\n}\n.mx-5\\/12 {\n  margin-left: 41.666667%;\n  margin-right: 41.666667%;\n}\n.my-6\\/12 {\n  margin-top: 50%;\n  margin-bottom: 50%;\n}\n.mx-6\\/12 {\n  margin-left: 50%;\n  margin-right: 50%;\n}\n.my-7\\/12 {\n  margin-top: 58.333333%;\n  margin-bottom: 58.333333%;\n}\n.mx-7\\/12 {\n  margin-left: 58.333333%;\n  margin-right: 58.333333%;\n}\n.my-8\\/12 {\n  margin-top: 66.666667%;\n  margin-bottom: 66.666667%;\n}\n.mx-8\\/12 {\n  margin-left: 66.666667%;\n  margin-right: 66.666667%;\n}\n.my-9\\/12 {\n  margin-top: 75%;\n  margin-bottom: 75%;\n}\n.mx-9\\/12 {\n  margin-left: 75%;\n  margin-right: 75%;\n}\n.my-10\\/12 {\n  margin-top: 83.333333%;\n  margin-bottom: 83.333333%;\n}\n.mx-10\\/12 {\n  margin-left: 83.333333%;\n  margin-right: 83.333333%;\n}\n.my-11\\/12 {\n  margin-top: 91.666667%;\n  margin-bottom: 91.666667%;\n}\n.mx-11\\/12 {\n  margin-left: 91.666667%;\n  margin-right: 91.666667%;\n}\n.my-full {\n  margin-top: 100%;\n  margin-bottom: 100%;\n}\n.mx-full {\n  margin-left: 100%;\n  margin-right: 100%;\n}\n.-my-1 {\n  margin-top: -0.25rem;\n  margin-bottom: -0.25rem;\n}\n.-mx-1 {\n  margin-left: -0.25rem;\n  margin-right: -0.25rem;\n}\n.-my-2 {\n  margin-top: -0.5rem;\n  margin-bottom: -0.5rem;\n}\n.-mx-2 {\n  margin-left: -0.5rem;\n  margin-right: -0.5rem;\n}\n.-my-3 {\n  margin-top: -0.75rem;\n  margin-bottom: -0.75rem;\n}\n.-mx-3 {\n  margin-left: -0.75rem;\n  margin-right: -0.75rem;\n}\n.-my-4 {\n  margin-top: -1rem;\n  margin-bottom: -1rem;\n}\n.-mx-4 {\n  margin-left: -1rem;\n  margin-right: -1rem;\n}\n.-my-5 {\n  margin-top: -1.25rem;\n  margin-bottom: -1.25rem;\n}\n.-mx-5 {\n  margin-left: -1.25rem;\n  margin-right: -1.25rem;\n}\n.-my-6 {\n  margin-top: -1.5rem;\n  margin-bottom: -1.5rem;\n}\n.-mx-6 {\n  margin-left: -1.5rem;\n  margin-right: -1.5rem;\n}\n.-my-7 {\n  margin-top: -1.75rem;\n  margin-bottom: -1.75rem;\n}\n.-mx-7 {\n  margin-left: -1.75rem;\n  margin-right: -1.75rem;\n}\n.-my-8 {\n  margin-top: -2rem;\n  margin-bottom: -2rem;\n}\n.-mx-8 {\n  margin-left: -2rem;\n  margin-right: -2rem;\n}\n.-my-9 {\n  margin-top: -2.25rem;\n  margin-bottom: -2.25rem;\n}\n.-mx-9 {\n  margin-left: -2.25rem;\n  margin-right: -2.25rem;\n}\n.-my-10 {\n  margin-top: -2.5rem;\n  margin-bottom: -2.5rem;\n}\n.-mx-10 {\n  margin-left: -2.5rem;\n  margin-right: -2.5rem;\n}\n.-my-11 {\n  margin-top: -2.75rem;\n  margin-bottom: -2.75rem;\n}\n.-mx-11 {\n  margin-left: -2.75rem;\n  margin-right: -2.75rem;\n}\n.-my-12 {\n  margin-top: -3rem;\n  margin-bottom: -3rem;\n}\n.-mx-12 {\n  margin-left: -3rem;\n  margin-right: -3rem;\n}\n.-my-13 {\n  margin-top: -3.25rem;\n  margin-bottom: -3.25rem;\n}\n.-mx-13 {\n  margin-left: -3.25rem;\n  margin-right: -3.25rem;\n}\n.-my-14 {\n  margin-top: -3.5rem;\n  margin-bottom: -3.5rem;\n}\n.-mx-14 {\n  margin-left: -3.5rem;\n  margin-right: -3.5rem;\n}\n.-my-15 {\n  margin-top: -3.75rem;\n  margin-bottom: -3.75rem;\n}\n.-mx-15 {\n  margin-left: -3.75rem;\n  margin-right: -3.75rem;\n}\n.-my-16 {\n  margin-top: -4rem;\n  margin-bottom: -4rem;\n}\n.-mx-16 {\n  margin-left: -4rem;\n  margin-right: -4rem;\n}\n.-my-20 {\n  margin-top: -5rem;\n  margin-bottom: -5rem;\n}\n.-mx-20 {\n  margin-left: -5rem;\n  margin-right: -5rem;\n}\n.-my-24 {\n  margin-top: -6rem;\n  margin-bottom: -6rem;\n}\n.-mx-24 {\n  margin-left: -6rem;\n  margin-right: -6rem;\n}\n.-my-28 {\n  margin-top: -7rem;\n  margin-bottom: -7rem;\n}\n.-mx-28 {\n  margin-left: -7rem;\n  margin-right: -7rem;\n}\n.-my-32 {\n  margin-top: -8rem;\n  margin-bottom: -8rem;\n}\n.-mx-32 {\n  margin-left: -8rem;\n  margin-right: -8rem;\n}\n.-my-36 {\n  margin-top: -9rem;\n  margin-bottom: -9rem;\n}\n.-mx-36 {\n  margin-left: -9rem;\n  margin-right: -9rem;\n}\n.-my-40 {\n  margin-top: -10rem;\n  margin-bottom: -10rem;\n}\n.-mx-40 {\n  margin-left: -10rem;\n  margin-right: -10rem;\n}\n.-my-44 {\n  margin-top: -11rem;\n  margin-bottom: -11rem;\n}\n.-mx-44 {\n  margin-left: -11rem;\n  margin-right: -11rem;\n}\n.-my-48 {\n  margin-top: -12rem;\n  margin-bottom: -12rem;\n}\n.-mx-48 {\n  margin-left: -12rem;\n  margin-right: -12rem;\n}\n.-my-52 {\n  margin-top: -13rem;\n  margin-bottom: -13rem;\n}\n.-mx-52 {\n  margin-left: -13rem;\n  margin-right: -13rem;\n}\n.-my-56 {\n  margin-top: -14rem;\n  margin-bottom: -14rem;\n}\n.-mx-56 {\n  margin-left: -14rem;\n  margin-right: -14rem;\n}\n.-my-60 {\n  margin-top: -15rem;\n  margin-bottom: -15rem;\n}\n.-mx-60 {\n  margin-left: -15rem;\n  margin-right: -15rem;\n}\n.-my-64 {\n  margin-top: -16rem;\n  margin-bottom: -16rem;\n}\n.-mx-64 {\n  margin-left: -16rem;\n  margin-right: -16rem;\n}\n.-my-72 {\n  margin-top: -18rem;\n  margin-bottom: -18rem;\n}\n.-mx-72 {\n  margin-left: -18rem;\n  margin-right: -18rem;\n}\n.-my-80 {\n  margin-top: -20rem;\n  margin-bottom: -20rem;\n}\n.-mx-80 {\n  margin-left: -20rem;\n  margin-right: -20rem;\n}\n.-my-96 {\n  margin-top: -24rem;\n  margin-bottom: -24rem;\n}\n.-mx-96 {\n  margin-left: -24rem;\n  margin-right: -24rem;\n}\n.-my-px {\n  margin-top: -1px;\n  margin-bottom: -1px;\n}\n.-mx-px {\n  margin-left: -1px;\n  margin-right: -1px;\n}\n.-my-0\\.5 {\n  margin-top: -0.125rem;\n  margin-bottom: -0.125rem;\n}\n.-mx-0\\.5 {\n  margin-left: -0.125rem;\n  margin-right: -0.125rem;\n}\n.-my-1\\.5 {\n  margin-top: -0.375rem;\n  margin-bottom: -0.375rem;\n}\n.-mx-1\\.5 {\n  margin-left: -0.375rem;\n  margin-right: -0.375rem;\n}\n.-my-2\\.5 {\n  margin-top: -0.625rem;\n  margin-bottom: -0.625rem;\n}\n.-mx-2\\.5 {\n  margin-left: -0.625rem;\n  margin-right: -0.625rem;\n}\n.-my-3\\.5 {\n  margin-top: -0.875rem;\n  margin-bottom: -0.875rem;\n}\n.-mx-3\\.5 {\n  margin-left: -0.875rem;\n  margin-right: -0.875rem;\n}\n.-my-1\\/2 {\n  margin-top: -50%;\n  margin-bottom: -50%;\n}\n.-mx-1\\/2 {\n  margin-left: -50%;\n  margin-right: -50%;\n}\n.-my-1\\/3 {\n  margin-top: -33.33333%;\n  margin-bottom: -33.33333%;\n}\n.-mx-1\\/3 {\n  margin-left: -33.33333%;\n  margin-right: -33.33333%;\n}\n.-my-2\\/3 {\n  margin-top: -66.66667%;\n  margin-bottom: -66.66667%;\n}\n.-mx-2\\/3 {\n  margin-left: -66.66667%;\n  margin-right: -66.66667%;\n}\n.-my-1\\/4 {\n  margin-top: -25%;\n  margin-bottom: -25%;\n}\n.-mx-1\\/4 {\n  margin-left: -25%;\n  margin-right: -25%;\n}\n.-my-2\\/4 {\n  margin-top: -50%;\n  margin-bottom: -50%;\n}\n.-mx-2\\/4 {\n  margin-left: -50%;\n  margin-right: -50%;\n}\n.-my-3\\/4 {\n  margin-top: -75%;\n  margin-bottom: -75%;\n}\n.-mx-3\\/4 {\n  margin-left: -75%;\n  margin-right: -75%;\n}\n.-my-1\\/5 {\n  margin-top: -20%;\n  margin-bottom: -20%;\n}\n.-mx-1\\/5 {\n  margin-left: -20%;\n  margin-right: -20%;\n}\n.-my-2\\/5 {\n  margin-top: -40%;\n  margin-bottom: -40%;\n}\n.-mx-2\\/5 {\n  margin-left: -40%;\n  margin-right: -40%;\n}\n.-my-3\\/5 {\n  margin-top: -60%;\n  margin-bottom: -60%;\n}\n.-mx-3\\/5 {\n  margin-left: -60%;\n  margin-right: -60%;\n}\n.-my-4\\/5 {\n  margin-top: -80%;\n  margin-bottom: -80%;\n}\n.-mx-4\\/5 {\n  margin-left: -80%;\n  margin-right: -80%;\n}\n.-my-1\\/6 {\n  margin-top: -16.66667%;\n  margin-bottom: -16.66667%;\n}\n.-mx-1\\/6 {\n  margin-left: -16.66667%;\n  margin-right: -16.66667%;\n}\n.-my-2\\/6 {\n  margin-top: -33.33333%;\n  margin-bottom: -33.33333%;\n}\n.-mx-2\\/6 {\n  margin-left: -33.33333%;\n  margin-right: -33.33333%;\n}\n.-my-3\\/6 {\n  margin-top: -50%;\n  margin-bottom: -50%;\n}\n.-mx-3\\/6 {\n  margin-left: -50%;\n  margin-right: -50%;\n}\n.-my-4\\/6 {\n  margin-top: -66.66667%;\n  margin-bottom: -66.66667%;\n}\n.-mx-4\\/6 {\n  margin-left: -66.66667%;\n  margin-right: -66.66667%;\n}\n.-my-5\\/6 {\n  margin-top: -83.33333%;\n  margin-bottom: -83.33333%;\n}\n.-mx-5\\/6 {\n  margin-left: -83.33333%;\n  margin-right: -83.33333%;\n}\n.-my-1\\/12 {\n  margin-top: -8.33333%;\n  margin-bottom: -8.33333%;\n}\n.-mx-1\\/12 {\n  margin-left: -8.33333%;\n  margin-right: -8.33333%;\n}\n.-my-2\\/12 {\n  margin-top: -16.66667%;\n  margin-bottom: -16.66667%;\n}\n.-mx-2\\/12 {\n  margin-left: -16.66667%;\n  margin-right: -16.66667%;\n}\n.-my-3\\/12 {\n  margin-top: -25%;\n  margin-bottom: -25%;\n}\n.-mx-3\\/12 {\n  margin-left: -25%;\n  margin-right: -25%;\n}\n.-my-4\\/12 {\n  margin-top: -33.33333%;\n  margin-bottom: -33.33333%;\n}\n.-mx-4\\/12 {\n  margin-left: -33.33333%;\n  margin-right: -33.33333%;\n}\n.-my-5\\/12 {\n  margin-top: -41.66667%;\n  margin-bottom: -41.66667%;\n}\n.-mx-5\\/12 {\n  margin-left: -41.66667%;\n  margin-right: -41.66667%;\n}\n.-my-6\\/12 {\n  margin-top: -50%;\n  margin-bottom: -50%;\n}\n.-mx-6\\/12 {\n  margin-left: -50%;\n  margin-right: -50%;\n}\n.-my-7\\/12 {\n  margin-top: -58.33333%;\n  margin-bottom: -58.33333%;\n}\n.-mx-7\\/12 {\n  margin-left: -58.33333%;\n  margin-right: -58.33333%;\n}\n.-my-8\\/12 {\n  margin-top: -66.66667%;\n  margin-bottom: -66.66667%;\n}\n.-mx-8\\/12 {\n  margin-left: -66.66667%;\n  margin-right: -66.66667%;\n}\n.-my-9\\/12 {\n  margin-top: -75%;\n  margin-bottom: -75%;\n}\n.-mx-9\\/12 {\n  margin-left: -75%;\n  margin-right: -75%;\n}\n.-my-10\\/12 {\n  margin-top: -83.33333%;\n  margin-bottom: -83.33333%;\n}\n.-mx-10\\/12 {\n  margin-left: -83.33333%;\n  margin-right: -83.33333%;\n}\n.-my-11\\/12 {\n  margin-top: -91.66667%;\n  margin-bottom: -91.66667%;\n}\n.-mx-11\\/12 {\n  margin-left: -91.66667%;\n  margin-right: -91.66667%;\n}\n.-my-full {\n  margin-top: -100%;\n  margin-bottom: -100%;\n}\n.-mx-full {\n  margin-left: -100%;\n  margin-right: -100%;\n}\n.mt-0 {\n  margin-top: 0;\n}\n.mr-0 {\n  margin-right: 0;\n}\n.mb-0 {\n  margin-bottom: 0;\n}\n.ml-0 {\n  margin-left: 0;\n}\n.mt-1 {\n  margin-top: 0.25rem;\n}\n.mr-1 {\n  margin-right: 0.25rem;\n}\n.mb-1 {\n  margin-bottom: 0.25rem;\n}\n.ml-1 {\n  margin-left: 0.25rem;\n}\n.mt-2 {\n  margin-top: 0.5rem;\n}\n.mr-2 {\n  margin-right: 0.5rem;\n}\n.mb-2 {\n  margin-bottom: 0.5rem;\n}\n.ml-2 {\n  margin-left: 0.5rem;\n}\n.mt-3 {\n  margin-top: 0.75rem;\n}\n.mr-3 {\n  margin-right: 0.75rem;\n}\n.mb-3 {\n  margin-bottom: 0.75rem;\n}\n.ml-3 {\n  margin-left: 0.75rem;\n}\n.mt-4 {\n  margin-top: 1rem;\n}\n.mr-4 {\n  margin-right: 1rem;\n}\n.mb-4 {\n  margin-bottom: 1rem;\n}\n.ml-4 {\n  margin-left: 1rem;\n}\n.mt-5 {\n  margin-top: 1.25rem;\n}\n.mr-5 {\n  margin-right: 1.25rem;\n}\n.mb-5 {\n  margin-bottom: 1.25rem;\n}\n.ml-5 {\n  margin-left: 1.25rem;\n}\n.mt-6 {\n  margin-top: 1.5rem;\n}\n.mr-6 {\n  margin-right: 1.5rem;\n}\n.mb-6 {\n  margin-bottom: 1.5rem;\n}\n.ml-6 {\n  margin-left: 1.5rem;\n}\n.mt-7 {\n  margin-top: 1.75rem;\n}\n.mr-7 {\n  margin-right: 1.75rem;\n}\n.mb-7 {\n  margin-bottom: 1.75rem;\n}\n.ml-7 {\n  margin-left: 1.75rem;\n}\n.mt-8 {\n  margin-top: 2rem;\n}\n.mr-8 {\n  margin-right: 2rem;\n}\n.mb-8 {\n  margin-bottom: 2rem;\n}\n.ml-8 {\n  margin-left: 2rem;\n}\n.mt-9 {\n  margin-top: 2.25rem;\n}\n.mr-9 {\n  margin-right: 2.25rem;\n}\n.mb-9 {\n  margin-bottom: 2.25rem;\n}\n.ml-9 {\n  margin-left: 2.25rem;\n}\n.mt-10 {\n  margin-top: 2.5rem;\n}\n.mr-10 {\n  margin-right: 2.5rem;\n}\n.mb-10 {\n  margin-bottom: 2.5rem;\n}\n.ml-10 {\n  margin-left: 2.5rem;\n}\n.mt-11 {\n  margin-top: 2.75rem;\n}\n.mr-11 {\n  margin-right: 2.75rem;\n}\n.mb-11 {\n  margin-bottom: 2.75rem;\n}\n.ml-11 {\n  margin-left: 2.75rem;\n}\n.mt-12 {\n  margin-top: 3rem;\n}\n.mr-12 {\n  margin-right: 3rem;\n}\n.mb-12 {\n  margin-bottom: 3rem;\n}\n.ml-12 {\n  margin-left: 3rem;\n}\n.mt-13 {\n  margin-top: 3.25rem;\n}\n.mr-13 {\n  margin-right: 3.25rem;\n}\n.mb-13 {\n  margin-bottom: 3.25rem;\n}\n.ml-13 {\n  margin-left: 3.25rem;\n}\n.mt-14 {\n  margin-top: 3.5rem;\n}\n.mr-14 {\n  margin-right: 3.5rem;\n}\n.mb-14 {\n  margin-bottom: 3.5rem;\n}\n.ml-14 {\n  margin-left: 3.5rem;\n}\n.mt-15 {\n  margin-top: 3.75rem;\n}\n.mr-15 {\n  margin-right: 3.75rem;\n}\n.mb-15 {\n  margin-bottom: 3.75rem;\n}\n.ml-15 {\n  margin-left: 3.75rem;\n}\n.mt-16 {\n  margin-top: 4rem;\n}\n.mr-16 {\n  margin-right: 4rem;\n}\n.mb-16 {\n  margin-bottom: 4rem;\n}\n.ml-16 {\n  margin-left: 4rem;\n}\n.mt-20 {\n  margin-top: 5rem;\n}\n.mr-20 {\n  margin-right: 5rem;\n}\n.mb-20 {\n  margin-bottom: 5rem;\n}\n.ml-20 {\n  margin-left: 5rem;\n}\n.mt-24 {\n  margin-top: 6rem;\n}\n.mr-24 {\n  margin-right: 6rem;\n}\n.mb-24 {\n  margin-bottom: 6rem;\n}\n.ml-24 {\n  margin-left: 6rem;\n}\n.mt-28 {\n  margin-top: 7rem;\n}\n.mr-28 {\n  margin-right: 7rem;\n}\n.mb-28 {\n  margin-bottom: 7rem;\n}\n.ml-28 {\n  margin-left: 7rem;\n}\n.mt-32 {\n  margin-top: 5rem;\n}\n.mr-32 {\n  margin-right: 8rem;\n}\n.mb-32 {\n  margin-bottom: 8rem;\n}\n.ml-32 {\n  margin-left: 8rem;\n}\n.mt-36 {\n  margin-top: 9rem;\n}\n.mr-36 {\n  margin-right: 9rem;\n}\n.mb-36 {\n  margin-bottom: 9rem;\n}\n.ml-36 {\n  margin-left: 9rem;\n}\n.mt-40 {\n  margin-top: 10rem;\n}\n.mr-40 {\n  margin-right: 10rem;\n}\n.mb-40 {\n  margin-bottom: 10rem;\n}\n.ml-40 {\n  margin-left: 10rem;\n}\n.mt-44 {\n  margin-top: 11rem;\n}\n.mr-44 {\n  margin-right: 11rem;\n}\n.mb-44 {\n  margin-bottom: 11rem;\n}\n.ml-44 {\n  margin-left: 11rem;\n}\n.mt-48 {\n  margin-top: 12rem;\n}\n.mr-48 {\n  margin-right: 12rem;\n}\n.mb-48 {\n  margin-bottom: 12rem;\n}\n.ml-48 {\n  margin-left: 12rem;\n}\n.mt-52 {\n  margin-top: 13rem;\n}\n.mr-52 {\n  margin-right: 13rem;\n}\n.mb-52 {\n  margin-bottom: 13rem;\n}\n.ml-52 {\n  margin-left: 13rem;\n}\n.mt-56 {\n  margin-top: 14rem;\n}\n.mr-56 {\n  margin-right: 14rem;\n}\n.mb-56 {\n  margin-bottom: 14rem;\n}\n.ml-56 {\n  margin-left: 14rem;\n}\n.mt-60 {\n  margin-top: 15rem;\n}\n.mr-60 {\n  margin-right: 15rem;\n}\n.mb-60 {\n  margin-bottom: 15rem;\n}\n.ml-60 {\n  margin-left: 15rem;\n}\n.mt-64 {\n  margin-top: 16rem;\n}\n.mr-64 {\n  margin-right: 16rem;\n}\n.mb-64 {\n  margin-bottom: 16rem;\n}\n.ml-64 {\n  margin-left: 16rem;\n}\n.mt-72 {\n  margin-top: 18rem;\n}\n.mr-72 {\n  margin-right: 18rem;\n}\n.mb-72 {\n  margin-bottom: 18rem;\n}\n.ml-72 {\n  margin-left: 18rem;\n}\n.mt-80 {\n  margin-top: 20rem;\n}\n.mr-80 {\n  margin-right: 20rem;\n}\n.mb-80 {\n  margin-bottom: 20rem;\n}\n.ml-80 {\n  margin-left: 20rem;\n}\n.mt-96 {\n  margin-top: 24rem;\n}\n.mr-96 {\n  margin-right: 24rem;\n}\n.mb-96 {\n  margin-bottom: 24rem;\n}\n.ml-96 {\n  margin-left: 24rem;\n}\n.mt-auto {\n  margin-top: auto;\n}\n.mr-auto {\n  margin-right: auto;\n}\n.mb-auto {\n  margin-bottom: auto;\n}\n.ml-auto {\n  margin-left: auto;\n}\n.mt-px {\n  margin-top: 1px;\n}\n.mr-px {\n  margin-right: 1px;\n}\n.mb-px {\n  margin-bottom: 1px;\n}\n.ml-px {\n  margin-left: 1px;\n}\n.mt-0\\.5 {\n  margin-top: 0.125rem;\n}\n.mr-0\\.5 {\n  margin-right: 0.125rem;\n}\n.mb-0\\.5 {\n  margin-bottom: 0.125rem;\n}\n.ml-0\\.5 {\n  margin-left: 0.125rem;\n}\n.mt-1\\.5 {\n  margin-top: 0.375rem;\n}\n.mr-1\\.5 {\n  margin-right: 0.375rem;\n}\n.mb-1\\.5 {\n  margin-bottom: 0.375rem;\n}\n.ml-1\\.5 {\n  margin-left: 0.375rem;\n}\n.mt-2\\.5 {\n  margin-top: 0.625rem;\n}\n.mr-2\\.5 {\n  margin-right: 0.625rem;\n}\n.mb-2\\.5 {\n  margin-bottom: 0.625rem;\n}\n.ml-2\\.5 {\n  margin-left: 0.625rem;\n}\n.mt-3\\.5 {\n  margin-top: 0.875rem;\n}\n.mr-3\\.5 {\n  margin-right: 0.875rem;\n}\n.mb-3\\.5 {\n  margin-bottom: 0.875rem;\n}\n.ml-3\\.5 {\n  margin-left: 0.875rem;\n}\n.mt-1\\/2 {\n  margin-top: 50%;\n}\n.mr-1\\/2 {\n  margin-right: 50%;\n}\n.mb-1\\/2 {\n  margin-bottom: 50%;\n}\n.ml-1\\/2 {\n  margin-left: 50%;\n}\n.mt-1\\/3 {\n  margin-top: 33.333333%;\n}\n.mr-1\\/3 {\n  margin-right: 33.333333%;\n}\n.mb-1\\/3 {\n  margin-bottom: 33.333333%;\n}\n.ml-1\\/3 {\n  margin-left: 33.333333%;\n}\n.mt-2\\/3 {\n  margin-top: 66.666667%;\n}\n.mr-2\\/3 {\n  margin-right: 66.666667%;\n}\n.mb-2\\/3 {\n  margin-bottom: 66.666667%;\n}\n.ml-2\\/3 {\n  margin-left: 66.666667%;\n}\n.mt-1\\/4 {\n  margin-top: 25%;\n}\n.mr-1\\/4 {\n  margin-right: 25%;\n}\n.mb-1\\/4 {\n  margin-bottom: 25%;\n}\n.ml-1\\/4 {\n  margin-left: 25%;\n}\n.mt-2\\/4 {\n  margin-top: 50%;\n}\n.mr-2\\/4 {\n  margin-right: 50%;\n}\n.mb-2\\/4 {\n  margin-bottom: 50%;\n}\n.ml-2\\/4 {\n  margin-left: 50%;\n}\n.mt-3\\/4 {\n  margin-top: 75%;\n}\n.mr-3\\/4 {\n  margin-right: 75%;\n}\n.mb-3\\/4 {\n  margin-bottom: 75%;\n}\n.ml-3\\/4 {\n  margin-left: 75%;\n}\n.mt-1\\/5 {\n  margin-top: 20%;\n}\n.mr-1\\/5 {\n  margin-right: 20%;\n}\n.mb-1\\/5 {\n  margin-bottom: 20%;\n}\n.ml-1\\/5 {\n  margin-left: 20%;\n}\n.mt-2\\/5 {\n  margin-top: 40%;\n}\n.mr-2\\/5 {\n  margin-right: 40%;\n}\n.mb-2\\/5 {\n  margin-bottom: 40%;\n}\n.ml-2\\/5 {\n  margin-left: 40%;\n}\n.mt-3\\/5 {\n  margin-top: 60%;\n}\n.mr-3\\/5 {\n  margin-right: 60%;\n}\n.mb-3\\/5 {\n  margin-bottom: 60%;\n}\n.ml-3\\/5 {\n  margin-left: 60%;\n}\n.mt-4\\/5 {\n  margin-top: 80%;\n}\n.mr-4\\/5 {\n  margin-right: 80%;\n}\n.mb-4\\/5 {\n  margin-bottom: 80%;\n}\n.ml-4\\/5 {\n  margin-left: 80%;\n}\n.mt-1\\/6 {\n  margin-top: 16.666667%;\n}\n.mr-1\\/6 {\n  margin-right: 16.666667%;\n}\n.mb-1\\/6 {\n  margin-bottom: 16.666667%;\n}\n.ml-1\\/6 {\n  margin-left: 16.666667%;\n}\n.mt-2\\/6 {\n  margin-top: 33.333333%;\n}\n.mr-2\\/6 {\n  margin-right: 33.333333%;\n}\n.mb-2\\/6 {\n  margin-bottom: 33.333333%;\n}\n.ml-2\\/6 {\n  margin-left: 33.333333%;\n}\n.mt-3\\/6 {\n  margin-top: 50%;\n}\n.mr-3\\/6 {\n  margin-right: 50%;\n}\n.mb-3\\/6 {\n  margin-bottom: 50%;\n}\n.ml-3\\/6 {\n  margin-left: 50%;\n}\n.mt-4\\/6 {\n  margin-top: 66.666667%;\n}\n.mr-4\\/6 {\n  margin-right: 66.666667%;\n}\n.mb-4\\/6 {\n  margin-bottom: 66.666667%;\n}\n.ml-4\\/6 {\n  margin-left: 66.666667%;\n}\n.mt-5\\/6 {\n  margin-top: 83.333333%;\n}\n.mr-5\\/6 {\n  margin-right: 83.333333%;\n}\n.mb-5\\/6 {\n  margin-bottom: 83.333333%;\n}\n.ml-5\\/6 {\n  margin-left: 83.333333%;\n}\n.mt-1\\/12 {\n  margin-top: 8.333333%;\n}\n.mr-1\\/12 {\n  margin-right: 8.333333%;\n}\n.mb-1\\/12 {\n  margin-bottom: 8.333333%;\n}\n.ml-1\\/12 {\n  margin-left: 8.333333%;\n}\n.mt-2\\/12 {\n  margin-top: 16.666667%;\n}\n.mr-2\\/12 {\n  margin-right: 16.666667%;\n}\n.mb-2\\/12 {\n  margin-bottom: 16.666667%;\n}\n.ml-2\\/12 {\n  margin-left: 16.666667%;\n}\n.mt-3\\/12 {\n  margin-top: 25%;\n}\n.mr-3\\/12 {\n  margin-right: 25%;\n}\n.mb-3\\/12 {\n  margin-bottom: 25%;\n}\n.ml-3\\/12 {\n  margin-left: 25%;\n}\n.mt-4\\/12 {\n  margin-top: 33.333333%;\n}\n.mr-4\\/12 {\n  margin-right: 33.333333%;\n}\n.mb-4\\/12 {\n  margin-bottom: 33.333333%;\n}\n.ml-4\\/12 {\n  margin-left: 33.333333%;\n}\n.mt-5\\/12 {\n  margin-top: 41.666667%;\n}\n.mr-5\\/12 {\n  margin-right: 41.666667%;\n}\n.mb-5\\/12 {\n  margin-bottom: 41.666667%;\n}\n.ml-5\\/12 {\n  margin-left: 41.666667%;\n}\n.mt-6\\/12 {\n  margin-top: 50%;\n}\n.mr-6\\/12 {\n  margin-right: 50%;\n}\n.mb-6\\/12 {\n  margin-bottom: 50%;\n}\n.ml-6\\/12 {\n  margin-left: 50%;\n}\n.mt-7\\/12 {\n  margin-top: 58.333333%;\n}\n.mr-7\\/12 {\n  margin-right: 58.333333%;\n}\n.mb-7\\/12 {\n  margin-bottom: 58.333333%;\n}\n.ml-7\\/12 {\n  margin-left: 58.333333%;\n}\n.mt-8\\/12 {\n  margin-top: 66.666667%;\n}\n.mr-8\\/12 {\n  margin-right: 66.666667%;\n}\n.mb-8\\/12 {\n  margin-bottom: 66.666667%;\n}\n.ml-8\\/12 {\n  margin-left: 66.666667%;\n}\n.mt-9\\/12 {\n  margin-top: 75%;\n}\n.mr-9\\/12 {\n  margin-right: 75%;\n}\n.mb-9\\/12 {\n  margin-bottom: 75%;\n}\n.ml-9\\/12 {\n  margin-left: 75%;\n}\n.mt-10\\/12 {\n  margin-top: 83.333333%;\n}\n.mr-10\\/12 {\n  margin-right: 83.333333%;\n}\n.mb-10\\/12 {\n  margin-bottom: 83.333333%;\n}\n.ml-10\\/12 {\n  margin-left: 83.333333%;\n}\n.mt-11\\/12 {\n  margin-top: 91.666667%;\n}\n.mr-11\\/12 {\n  margin-right: 91.666667%;\n}\n.mb-11\\/12 {\n  margin-bottom: 91.666667%;\n}\n.ml-11\\/12 {\n  margin-left: 91.666667%;\n}\n.mt-full {\n  margin-top: 100%;\n}\n.mr-full {\n  margin-right: 100%;\n}\n.mb-full {\n  margin-bottom: 100%;\n}\n.ml-full {\n  margin-left: 100%;\n}\n.-mt-1 {\n  margin-top: -0.25rem;\n}\n.-mr-1 {\n  margin-right: -0.25rem;\n}\n.-mb-1 {\n  margin-bottom: -0.25rem;\n}\n.-ml-1 {\n  margin-left: -0.25rem;\n}\n.-mt-2 {\n  margin-top: -0.5rem;\n}\n.-mr-2 {\n  margin-right: -0.5rem;\n}\n.-mb-2 {\n  margin-bottom: -0.5rem;\n}\n.-ml-2 {\n  margin-left: -0.5rem;\n}\n.-mt-3 {\n  margin-top: -0.75rem;\n}\n.-mr-3 {\n  margin-right: -0.75rem;\n}\n.-mb-3 {\n  margin-bottom: -0.75rem;\n}\n.-ml-3 {\n  margin-left: -0.75rem;\n}\n.-mt-4 {\n  margin-top: -1rem;\n}\n.-mr-4 {\n  margin-right: -1rem;\n}\n.-mb-4 {\n  margin-bottom: -1rem;\n}\n.-ml-4 {\n  margin-left: -1rem;\n}\n.-mt-5 {\n  margin-top: -1.25rem;\n}\n.-mr-5 {\n  margin-right: -1.25rem;\n}\n.-mb-5 {\n  margin-bottom: -1.25rem;\n}\n.-ml-5 {\n  margin-left: -1.25rem;\n}\n.-mt-6 {\n  margin-top: -1.5rem;\n}\n.-mr-6 {\n  margin-right: -1.5rem;\n}\n.-mb-6 {\n  margin-bottom: -1.5rem;\n}\n.-ml-6 {\n  margin-left: -1.5rem;\n}\n.-mt-7 {\n  margin-top: -1.75rem;\n}\n.-mr-7 {\n  margin-right: -1.75rem;\n}\n.-mb-7 {\n  margin-bottom: -1.75rem;\n}\n.-ml-7 {\n  margin-left: -1.75rem;\n}\n.-mt-8 {\n  margin-top: -2rem;\n}\n.-mr-8 {\n  margin-right: -2rem;\n}\n.-mb-8 {\n  margin-bottom: -2rem;\n}\n.-ml-8 {\n  margin-left: -2rem;\n}\n.-mt-9 {\n  margin-top: -2.25rem;\n}\n.-mr-9 {\n  margin-right: -2.25rem;\n}\n.-mb-9 {\n  margin-bottom: -2.25rem;\n}\n.-ml-9 {\n  margin-left: -2.25rem;\n}\n.-mt-10 {\n  margin-top: -2.5rem;\n}\n.-mr-10 {\n  margin-right: -2.5rem;\n}\n.-mb-10 {\n  margin-bottom: -2.5rem;\n}\n.-ml-10 {\n  margin-left: -2.5rem;\n}\n.-mt-11 {\n  margin-top: -2.75rem;\n}\n.-mr-11 {\n  margin-right: -2.75rem;\n}\n.-mb-11 {\n  margin-bottom: -2.75rem;\n}\n.-ml-11 {\n  margin-left: -2.75rem;\n}\n.-mt-12 {\n  margin-top: -3rem;\n}\n.-mr-12 {\n  margin-right: -3rem;\n}\n.-mb-12 {\n  margin-bottom: -3rem;\n}\n.-ml-12 {\n  margin-left: -3rem;\n}\n.-mt-13 {\n  margin-top: -3.25rem;\n}\n.-mr-13 {\n  margin-right: -3.25rem;\n}\n.-mb-13 {\n  margin-bottom: -3.25rem;\n}\n.-ml-13 {\n  margin-left: -3.25rem;\n}\n.-mt-14 {\n  margin-top: -3.5rem;\n}\n.-mr-14 {\n  margin-right: -3.5rem;\n}\n.-mb-14 {\n  margin-bottom: -3.5rem;\n}\n.-ml-14 {\n  margin-left: -3.5rem;\n}\n.-mt-15 {\n  margin-top: -3.75rem;\n}\n.-mr-15 {\n  margin-right: -3.75rem;\n}\n.-mb-15 {\n  margin-bottom: -3.75rem;\n}\n.-ml-15 {\n  margin-left: -3.75rem;\n}\n.-mt-16 {\n  margin-top: -4rem;\n}\n.-mr-16 {\n  margin-right: -4rem;\n}\n.-mb-16 {\n  margin-bottom: -4rem;\n}\n.-ml-16 {\n  margin-left: -4rem;\n}\n.-mt-20 {\n  margin-top: -5rem;\n}\n.-mr-20 {\n  margin-right: -5rem;\n}\n.-mb-20 {\n  margin-bottom: -5rem;\n}\n.-ml-20 {\n  margin-left: -5rem;\n}\n.-mt-24 {\n  margin-top: -6rem;\n}\n.-mr-24 {\n  margin-right: -6rem;\n}\n.-mb-24 {\n  margin-bottom: -6rem;\n}\n.-ml-24 {\n  margin-left: -6rem;\n}\n.-mt-28 {\n  margin-top: -7rem;\n}\n.-mr-28 {\n  margin-right: -7rem;\n}\n.-mb-28 {\n  margin-bottom: -7rem;\n}\n.-ml-28 {\n  margin-left: -7rem;\n}\n.-mt-32 {\n  margin-top: -8rem;\n}\n.-mr-32 {\n  margin-right: -8rem;\n}\n.-mb-32 {\n  margin-bottom: -8rem;\n}\n.-ml-32 {\n  margin-left: -8rem;\n}\n.-mt-36 {\n  margin-top: -9rem;\n}\n.-mr-36 {\n  margin-right: -9rem;\n}\n.-mb-36 {\n  margin-bottom: -9rem;\n}\n.-ml-36 {\n  margin-left: -9rem;\n}\n.-mt-40 {\n  margin-top: -10rem;\n}\n.-mr-40 {\n  margin-right: -10rem;\n}\n.-mb-40 {\n  margin-bottom: -10rem;\n}\n.-ml-40 {\n  margin-left: -10rem;\n}\n.-mt-44 {\n  margin-top: -11rem;\n}\n.-mr-44 {\n  margin-right: -11rem;\n}\n.-mb-44 {\n  margin-bottom: -11rem;\n}\n.-ml-44 {\n  margin-left: -11rem;\n}\n.-mt-48 {\n  margin-top: -12rem;\n}\n.-mr-48 {\n  margin-right: -12rem;\n}\n.-mb-48 {\n  margin-bottom: -12rem;\n}\n.-ml-48 {\n  margin-left: -12rem;\n}\n.-mt-52 {\n  margin-top: -13rem;\n}\n.-mr-52 {\n  margin-right: -13rem;\n}\n.-mb-52 {\n  margin-bottom: -13rem;\n}\n.-ml-52 {\n  margin-left: -13rem;\n}\n.-mt-56 {\n  margin-top: -14rem;\n}\n.-mr-56 {\n  margin-right: -14rem;\n}\n.-mb-56 {\n  margin-bottom: -14rem;\n}\n.-ml-56 {\n  margin-left: -14rem;\n}\n.-mt-60 {\n  margin-top: -15rem;\n}\n.-mr-60 {\n  margin-right: -15rem;\n}\n.-mb-60 {\n  margin-bottom: -15rem;\n}\n.-ml-60 {\n  margin-left: -15rem;\n}\n.-mt-64 {\n  margin-top: -16rem;\n}\n.-mr-64 {\n  margin-right: -16rem;\n}\n.-mb-64 {\n  margin-bottom: -16rem;\n}\n.-ml-64 {\n  margin-left: -16rem;\n}\n.-mt-72 {\n  margin-top: -18rem;\n}\n.-mr-72 {\n  margin-right: -18rem;\n}\n.-mb-72 {\n  margin-bottom: -18rem;\n}\n.-ml-72 {\n  margin-left: -18rem;\n}\n.-mt-80 {\n  margin-top: -20rem;\n}\n.-mr-80 {\n  margin-right: -20rem;\n}\n.-mb-80 {\n  margin-bottom: -20rem;\n}\n.-ml-80 {\n  margin-left: -20rem;\n}\n.-mt-96 {\n  margin-top: -24rem;\n}\n.-mr-96 {\n  margin-right: -24rem;\n}\n.-mb-96 {\n  margin-bottom: -24rem;\n}\n.-ml-96 {\n  margin-left: -24rem;\n}\n.-mt-px {\n  margin-top: -1px;\n}\n.-mr-px {\n  margin-right: -1px;\n}\n.-mb-px {\n  margin-bottom: -1px;\n}\n.-ml-px {\n  margin-left: -1px;\n}\n.-mt-0\\.5 {\n  margin-top: -0.125rem;\n}\n.-mr-0\\.5 {\n  margin-right: -0.125rem;\n}\n.-mb-0\\.5 {\n  margin-bottom: -0.125rem;\n}\n.-ml-0\\.5 {\n  margin-left: -0.125rem;\n}\n.-mt-1\\.5 {\n  margin-top: -0.375rem;\n}\n.-mr-1\\.5 {\n  margin-right: -0.375rem;\n}\n.-mb-1\\.5 {\n  margin-bottom: -0.375rem;\n}\n.-ml-1\\.5 {\n  margin-left: -0.375rem;\n}\n.-mt-2\\.5 {\n  margin-top: -0.625rem;\n}\n.-mr-2\\.5 {\n  margin-right: -0.625rem;\n}\n.-mb-2\\.5 {\n  margin-bottom: -0.625rem;\n}\n.-ml-2\\.5 {\n  margin-left: -0.625rem;\n}\n.-mt-3\\.5 {\n  margin-top: -0.875rem;\n}\n.-mr-3\\.5 {\n  margin-right: -0.875rem;\n}\n.-mb-3\\.5 {\n  margin-bottom: -0.875rem;\n}\n.-ml-3\\.5 {\n  margin-left: -0.875rem;\n}\n.-mt-1\\/2 {\n  margin-top: -50%;\n}\n.-mr-1\\/2 {\n  margin-right: -50%;\n}\n.-mb-1\\/2 {\n  margin-bottom: -50%;\n}\n.-ml-1\\/2 {\n  margin-left: -50%;\n}\n.-mt-1\\/3 {\n  margin-top: -33.33333%;\n}\n.-mr-1\\/3 {\n  margin-right: -33.33333%;\n}\n.-mb-1\\/3 {\n  margin-bottom: -33.33333%;\n}\n.-ml-1\\/3 {\n  margin-left: -33.33333%;\n}\n.-mt-2\\/3 {\n  margin-top: -66.66667%;\n}\n.-mr-2\\/3 {\n  margin-right: -66.66667%;\n}\n.-mb-2\\/3 {\n  margin-bottom: -66.66667%;\n}\n.-ml-2\\/3 {\n  margin-left: -66.66667%;\n}\n.-mt-1\\/4 {\n  margin-top: -25%;\n}\n.-mr-1\\/4 {\n  margin-right: -25%;\n}\n.-mb-1\\/4 {\n  margin-bottom: -25%;\n}\n.-ml-1\\/4 {\n  margin-left: -25%;\n}\n.-mt-2\\/4 {\n  margin-top: -50%;\n}\n.-mr-2\\/4 {\n  margin-right: -50%;\n}\n.-mb-2\\/4 {\n  margin-bottom: -50%;\n}\n.-ml-2\\/4 {\n  margin-left: -50%;\n}\n.-mt-3\\/4 {\n  margin-top: -75%;\n}\n.-mr-3\\/4 {\n  margin-right: -75%;\n}\n.-mb-3\\/4 {\n  margin-bottom: -75%;\n}\n.-ml-3\\/4 {\n  margin-left: -75%;\n}\n.-mt-1\\/5 {\n  margin-top: -20%;\n}\n.-mr-1\\/5 {\n  margin-right: -20%;\n}\n.-mb-1\\/5 {\n  margin-bottom: -20%;\n}\n.-ml-1\\/5 {\n  margin-left: -20%;\n}\n.-mt-2\\/5 {\n  margin-top: -40%;\n}\n.-mr-2\\/5 {\n  margin-right: -40%;\n}\n.-mb-2\\/5 {\n  margin-bottom: -40%;\n}\n.-ml-2\\/5 {\n  margin-left: -40%;\n}\n.-mt-3\\/5 {\n  margin-top: -60%;\n}\n.-mr-3\\/5 {\n  margin-right: -60%;\n}\n.-mb-3\\/5 {\n  margin-bottom: -60%;\n}\n.-ml-3\\/5 {\n  margin-left: -60%;\n}\n.-mt-4\\/5 {\n  margin-top: -80%;\n}\n.-mr-4\\/5 {\n  margin-right: -80%;\n}\n.-mb-4\\/5 {\n  margin-bottom: -80%;\n}\n.-ml-4\\/5 {\n  margin-left: -80%;\n}\n.-mt-1\\/6 {\n  margin-top: -16.66667%;\n}\n.-mr-1\\/6 {\n  margin-right: -16.66667%;\n}\n.-mb-1\\/6 {\n  margin-bottom: -16.66667%;\n}\n.-ml-1\\/6 {\n  margin-left: -16.66667%;\n}\n.-mt-2\\/6 {\n  margin-top: -33.33333%;\n}\n.-mr-2\\/6 {\n  margin-right: -33.33333%;\n}\n.-mb-2\\/6 {\n  margin-bottom: -33.33333%;\n}\n.-ml-2\\/6 {\n  margin-left: -33.33333%;\n}\n.-mt-3\\/6 {\n  margin-top: -50%;\n}\n.-mr-3\\/6 {\n  margin-right: -50%;\n}\n.-mb-3\\/6 {\n  margin-bottom: -50%;\n}\n.-ml-3\\/6 {\n  margin-left: -50%;\n}\n.-mt-4\\/6 {\n  margin-top: -66.66667%;\n}\n.-mr-4\\/6 {\n  margin-right: -66.66667%;\n}\n.-mb-4\\/6 {\n  margin-bottom: -66.66667%;\n}\n.-ml-4\\/6 {\n  margin-left: -66.66667%;\n}\n.-mt-5\\/6 {\n  margin-top: -83.33333%;\n}\n.-mr-5\\/6 {\n  margin-right: -83.33333%;\n}\n.-mb-5\\/6 {\n  margin-bottom: -83.33333%;\n}\n.-ml-5\\/6 {\n  margin-left: -83.33333%;\n}\n.-mt-1\\/12 {\n  margin-top: -8.33333%;\n}\n.-mr-1\\/12 {\n  margin-right: -8.33333%;\n}\n.-mb-1\\/12 {\n  margin-bottom: -8.33333%;\n}\n.-ml-1\\/12 {\n  margin-left: -8.33333%;\n}\n.-mt-2\\/12 {\n  margin-top: -16.66667%;\n}\n.-mr-2\\/12 {\n  margin-right: -16.66667%;\n}\n.-mb-2\\/12 {\n  margin-bottom: -16.66667%;\n}\n.-ml-2\\/12 {\n  margin-left: -16.66667%;\n}\n.-mt-3\\/12 {\n  margin-top: -25%;\n}\n.-mr-3\\/12 {\n  margin-right: -25%;\n}\n.-mb-3\\/12 {\n  margin-bottom: -25%;\n}\n.-ml-3\\/12 {\n  margin-left: -25%;\n}\n.-mt-4\\/12 {\n  margin-top: -33.33333%;\n}\n.-mr-4\\/12 {\n  margin-right: -33.33333%;\n}\n.-mb-4\\/12 {\n  margin-bottom: -33.33333%;\n}\n.-ml-4\\/12 {\n  margin-left: -33.33333%;\n}\n.-mt-5\\/12 {\n  margin-top: -41.66667%;\n}\n.-mr-5\\/12 {\n  margin-right: -41.66667%;\n}\n.-mb-5\\/12 {\n  margin-bottom: -41.66667%;\n}\n.-ml-5\\/12 {\n  margin-left: -41.66667%;\n}\n.-mt-6\\/12 {\n  margin-top: -50%;\n}\n.-mr-6\\/12 {\n  margin-right: -50%;\n}\n.-mb-6\\/12 {\n  margin-bottom: -50%;\n}\n.-ml-6\\/12 {\n  margin-left: -50%;\n}\n.-mt-7\\/12 {\n  margin-top: -58.33333%;\n}\n.-mr-7\\/12 {\n  margin-right: -58.33333%;\n}\n.-mb-7\\/12 {\n  margin-bottom: -58.33333%;\n}\n.-ml-7\\/12 {\n  margin-left: -58.33333%;\n}\n.-mt-8\\/12 {\n  margin-top: -66.66667%;\n}\n.-mr-8\\/12 {\n  margin-right: -66.66667%;\n}\n.-mb-8\\/12 {\n  margin-bottom: -66.66667%;\n}\n.-ml-8\\/12 {\n  margin-left: -66.66667%;\n}\n.-mt-9\\/12 {\n  margin-top: -75%;\n}\n.-mr-9\\/12 {\n  margin-right: -75%;\n}\n.-mb-9\\/12 {\n  margin-bottom: -75%;\n}\n.-ml-9\\/12 {\n  margin-left: -75%;\n}\n.-mt-10\\/12 {\n  margin-top: -83.33333%;\n}\n.-mr-10\\/12 {\n  margin-right: -83.33333%;\n}\n.-mb-10\\/12 {\n  margin-bottom: -83.33333%;\n}\n.-ml-10\\/12 {\n  margin-left: -83.33333%;\n}\n.-mt-11\\/12 {\n  margin-top: -91.66667%;\n}\n.-mr-11\\/12 {\n  margin-right: -91.66667%;\n}\n.-mb-11\\/12 {\n  margin-bottom: -91.66667%;\n}\n.-ml-11\\/12 {\n  margin-left: -91.66667%;\n}\n.-mt-full {\n  margin-top: -100%;\n}\n.-mr-full {\n  margin-right: -100%;\n}\n.-mb-full {\n  margin-bottom: -100%;\n}\n.-ml-full {\n  margin-left: -100%;\n}\n.max-h-0 {\n  max-height: 0;\n}\n.max-h-1 {\n  max-height: 0.25rem;\n}\n.max-h-2 {\n  max-height: 0.5rem;\n}\n.max-h-3 {\n  max-height: 0.75rem;\n}\n.max-h-4 {\n  max-height: 1rem;\n}\n.max-h-5 {\n  max-height: 1.25rem;\n}\n.max-h-6 {\n  max-height: 1.5rem;\n}\n.max-h-7 {\n  max-height: 1.75rem;\n}\n.max-h-8 {\n  max-height: 4rem;\n}\n.max-h-9 {\n  max-height: 2.25rem;\n}\n.max-h-10 {\n  max-height: 2.5rem;\n}\n.max-h-11 {\n  max-height: 2.75rem;\n}\n.max-h-12 {\n  max-height: 3rem;\n}\n.max-h-13 {\n  max-height: 3.25rem;\n}\n.max-h-14 {\n  max-height: 3.5rem;\n}\n.max-h-15 {\n  max-height: 3.75rem;\n}\n.max-h-16 {\n  max-height: 4rem;\n}\n.max-h-20 {\n  max-height: 5rem;\n}\n.max-h-24 {\n  max-height: 6rem;\n}\n.max-h-28 {\n  max-height: 7rem;\n}\n.max-h-32 {\n  max-height: 8rem;\n}\n.max-h-36 {\n  max-height: 9rem;\n}\n.max-h-40 {\n  max-height: 10rem;\n}\n.max-h-44 {\n  max-height: 11rem;\n}\n.max-h-48 {\n  max-height: 12rem;\n}\n.max-h-52 {\n  max-height: 13rem;\n}\n.max-h-56 {\n  max-height: 14rem;\n}\n.max-h-60 {\n  max-height: 15rem;\n}\n.max-h-64 {\n  max-height: 16rem;\n}\n.max-h-72 {\n  max-height: 18rem;\n}\n.max-h-80 {\n  max-height: 20rem;\n}\n.max-h-96 {\n  max-height: 24rem;\n}\n.max-h-screen {\n  max-height: 100vh;\n}\n.max-h-px {\n  max-height: 1px;\n}\n.max-h-0\\.5 {\n  max-height: 0.125rem;\n}\n.max-h-1\\.5 {\n  max-height: 0.375rem;\n}\n.max-h-2\\.5 {\n  max-height: 0.625rem;\n}\n.max-h-3\\.5 {\n  max-height: 0.875rem;\n}\n.max-h-1\\/2 {\n  max-height: 50%;\n}\n.max-h-1\\/3 {\n  max-height: 33.333333%;\n}\n.max-h-2\\/3 {\n  max-height: 66.666667%;\n}\n.max-h-1\\/4 {\n  max-height: 25%;\n}\n.max-h-2\\/4 {\n  max-height: 50%;\n}\n.max-h-3\\/4 {\n  max-height: 75%;\n}\n.max-h-1\\/5 {\n  max-height: 20%;\n}\n.max-h-2\\/5 {\n  max-height: 40%;\n}\n.max-h-3\\/5 {\n  max-height: 60%;\n}\n.max-h-4\\/5 {\n  max-height: 80%;\n}\n.max-h-1\\/6 {\n  max-height: 16.666667%;\n}\n.max-h-2\\/6 {\n  max-height: 33.333333%;\n}\n.max-h-3\\/6 {\n  max-height: 50%;\n}\n.max-h-4\\/6 {\n  max-height: 66.666667%;\n}\n.max-h-5\\/6 {\n  max-height: 83.333333%;\n}\n.max-h-1\\/12 {\n  max-height: 8.333333%;\n}\n.max-h-2\\/12 {\n  max-height: 16.666667%;\n}\n.max-h-3\\/12 {\n  max-height: 25%;\n}\n.max-h-4\\/12 {\n  max-height: 33.333333%;\n}\n.max-h-5\\/12 {\n  max-height: 41.666667%;\n}\n.max-h-6\\/12 {\n  max-height: 50%;\n}\n.max-h-7\\/12 {\n  max-height: 58.333333%;\n}\n.max-h-8\\/12 {\n  max-height: 66.666667%;\n}\n.max-h-9\\/12 {\n  max-height: 75%;\n}\n.max-h-10\\/12 {\n  max-height: 83.333333%;\n}\n.max-h-11\\/12 {\n  max-height: 91.666667%;\n}\n.max-h-full {\n  max-height: 100%;\n}\n.max-w-0 {\n  max-width: 0rem;\n}\n.max-w-none {\n  max-width: none;\n}\n.max-w-xs {\n  max-width: 20rem;\n}\n.max-w-sm {\n  max-width: 24rem;\n}\n.max-w-md {\n  max-width: 28rem;\n}\n.max-w-lg {\n  max-width: 32rem;\n}\n.max-w-xl {\n  max-width: 36rem;\n}\n.max-w-2xl {\n  max-width: 42rem;\n}\n.max-w-3xl {\n  max-width: 48rem;\n}\n.max-w-4xl {\n  max-width: 56rem;\n}\n.max-w-5xl {\n  max-width: 64rem;\n}\n.max-w-6xl {\n  max-width: 72rem;\n}\n.max-w-7xl {\n  max-width: 80rem;\n}\n.max-w-full {\n  max-width: 100%;\n}\n.max-w-min-content {\n  max-width: -moz-min-content;\n  max-width: min-content;\n}\n.max-w-max-content {\n  max-width: -moz-max-content;\n  max-width: max-content;\n}\n.max-w-prose {\n  max-width: 65ch;\n}\n.max-w-screen-sm {\n  max-width: 640px;\n}\n.max-w-screen-md {\n  max-width: 768px;\n}\n.max-w-screen-lg {\n  max-width: 1024px;\n}\n.max-w-screen-xl {\n  max-width: 1280px;\n}\n.min-h-0 {\n  min-height: 0;\n}\n.min-h-full {\n  min-height: 100%;\n}\n.min-h-screen {\n  min-height: 100vh;\n}\n.min-w-0 {\n  min-width: 0;\n}\n.min-w-full {\n  min-width: 100%;\n}\n.min-w-min-content {\n  min-width: -moz-min-content;\n  min-width: min-content;\n}\n.min-w-max-content {\n  min-width: -moz-max-content;\n  min-width: max-content;\n}\n.object-contain {\n  -o-object-fit: contain;\n  object-fit: contain;\n}\n.object-cover {\n  -o-object-fit: cover;\n  object-fit: cover;\n}\n.object-fill {\n  -o-object-fit: fill;\n  object-fit: fill;\n}\n.object-none {\n  -o-object-fit: none;\n  object-fit: none;\n}\n.object-scale-down {\n  -o-object-fit: scale-down;\n  object-fit: scale-down;\n}\n.object-bottom {\n  -o-object-position: bottom;\n  object-position: bottom;\n}\n.object-center {\n  -o-object-position: center;\n  object-position: center;\n}\n.object-left {\n  -o-object-position: left;\n  object-position: left;\n}\n.object-left-bottom {\n  -o-object-position: left bottom;\n  object-position: left bottom;\n}\n.object-left-top {\n  -o-object-position: left top;\n  object-position: left top;\n}\n.object-right {\n  -o-object-position: right;\n  object-position: right;\n}\n.object-right-bottom {\n  -o-object-position: right bottom;\n  object-position: right bottom;\n}\n.object-right-top {\n  -o-object-position: right top;\n  object-position: right top;\n}\n.object-top {\n  -o-object-position: top;\n  object-position: top;\n}\n.opacity-0 {\n  opacity: 0;\n}\n.opacity-25 {\n  opacity: 0.25;\n}\n.opacity-50 {\n  opacity: 0.5;\n}\n.opacity-75 {\n  opacity: 0.75;\n}\n.opacity-100 {\n  opacity: 1;\n}\n.focus-within\\:opacity-0:focus-within {\n  opacity: 0;\n}\n.focus-within\\:opacity-25:focus-within {\n  opacity: 0.25;\n}\n.focus-within\\:opacity-50:focus-within {\n  opacity: 0.5;\n}\n.focus-within\\:opacity-75:focus-within {\n  opacity: 0.75;\n}\n.focus-within\\:opacity-100:focus-within {\n  opacity: 1;\n}\n.group:hover .group-hover\\:opacity-0 {\n  opacity: 0;\n}\n.group:hover .group-hover\\:opacity-25 {\n  opacity: 0.25;\n}\n.group:hover .group-hover\\:opacity-50 {\n  opacity: 0.5;\n}\n.group:hover .group-hover\\:opacity-75 {\n  opacity: 0.75;\n}\n.group:hover .group-hover\\:opacity-100 {\n  opacity: 1;\n}\n.group:focus .group-focus\\:opacity-0 {\n  opacity: 0;\n}\n.group:focus .group-focus\\:opacity-25 {\n  opacity: 0.25;\n}\n.group:focus .group-focus\\:opacity-50 {\n  opacity: 0.5;\n}\n.group:focus .group-focus\\:opacity-75 {\n  opacity: 0.75;\n}\n.group:focus .group-focus\\:opacity-100 {\n  opacity: 1;\n}\n.hover\\:opacity-0:hover {\n  opacity: 0;\n}\n.hover\\:opacity-25:hover {\n  opacity: 0.25;\n}\n.hover\\:opacity-50:hover {\n  opacity: 0.5;\n}\n.hover\\:opacity-75:hover {\n  opacity: 0.75;\n}\n.hover\\:opacity-100:hover {\n  opacity: 1;\n}\n.focus\\:opacity-0:focus {\n  opacity: 0;\n}\n.focus\\:opacity-25:focus {\n  opacity: 0.25;\n}\n.focus\\:opacity-50:focus {\n  opacity: 0.5;\n}\n.focus\\:opacity-75:focus {\n  opacity: 0.75;\n}\n.focus\\:opacity-100:focus {\n  opacity: 1;\n}\n.outline-none {\n  outline: 2px solid transparent;\n  outline-offset: 2px;\n}\n.outline-white {\n  outline: 2px dotted white;\n  outline-offset: 2px;\n}\n.outline-black {\n  outline: 2px dotted black;\n  outline-offset: 2px;\n}\n.focus\\:outline-none:focus {\n  outline: 2px solid transparent;\n  outline-offset: 2px;\n}\n.focus\\:outline-white:focus {\n  outline: 2px dotted white;\n  outline-offset: 2px;\n}\n.focus\\:outline-black:focus {\n  outline: 2px dotted black;\n  outline-offset: 2px;\n}\n.overflow-auto {\n  overflow: auto;\n}\n.overflow-hidden {\n  overflow: hidden;\n}\n.overflow-visible {\n  overflow: visible;\n}\n.overflow-scroll {\n  overflow: scroll;\n}\n.overflow-x-auto {\n  overflow-x: auto;\n}\n.overflow-y-auto {\n  overflow-y: auto;\n}\n.overflow-x-hidden {\n  overflow-x: hidden;\n}\n.overflow-y-hidden {\n  overflow-y: hidden;\n}\n.overflow-x-visible {\n  overflow-x: visible;\n}\n.overflow-y-visible {\n  overflow-y: visible;\n}\n.overflow-x-scroll {\n  overflow-x: scroll;\n}\n.overflow-y-scroll {\n  overflow-y: scroll;\n}\n.scrolling-touch {\n  -webkit-overflow-scrolling: touch;\n}\n.scrolling-auto {\n  -webkit-overflow-scrolling: auto;\n}\n.overscroll-auto {\n  overscroll-behavior: auto;\n}\n.overscroll-contain {\n  overscroll-behavior: contain;\n}\n.overscroll-none {\n  overscroll-behavior: none;\n}\n.overscroll-y-auto {\n  overscroll-behavior-y: auto;\n}\n.overscroll-y-contain {\n  overscroll-behavior-y: contain;\n}\n.overscroll-y-none {\n  overscroll-behavior-y: none;\n}\n.overscroll-x-auto {\n  overscroll-behavior-x: auto;\n}\n.overscroll-x-contain {\n  overscroll-behavior-x: contain;\n}\n.overscroll-x-none {\n  overscroll-behavior-x: none;\n}\n.p-0 {\n  padding: 0;\n}\n.p-1 {\n  padding: 0.25rem;\n}\n.p-2 {\n  padding: 0.5rem;\n}\n.p-3 {\n  padding: 0.75rem;\n}\n.p-4 {\n  padding: 1rem;\n}\n.p-5 {\n  padding: 1.25rem;\n}\n.p-6 {\n  padding: 1.5rem;\n}\n.p-7 {\n  padding: 1.75rem;\n}\n.p-8 {\n  padding: 2rem;\n}\n.p-9 {\n  padding: 2.25rem;\n}\n.p-10 {\n  padding: 2.5rem;\n}\n.p-11 {\n  padding: 2.75rem;\n}\n.p-12 {\n  padding: 3rem;\n}\n.p-13 {\n  padding: 3.25rem;\n}\n.p-14 {\n  padding: 3.5rem;\n}\n.p-15 {\n  padding: 3.75rem;\n}\n.p-16 {\n  padding: 4rem;\n}\n.p-20 {\n  padding: 5rem;\n}\n.p-24 {\n  padding: 6rem;\n}\n.p-28 {\n  padding: 7rem;\n}\n.p-32 {\n  padding: 8rem;\n}\n.p-36 {\n  padding: 9rem;\n}\n.p-40 {\n  padding: 10rem;\n}\n.p-44 {\n  padding: 11rem;\n}\n.p-48 {\n  padding: 12rem;\n}\n.p-52 {\n  padding: 13rem;\n}\n.p-56 {\n  padding: 14rem;\n}\n.p-60 {\n  padding: 15rem;\n}\n.p-64 {\n  padding: 16rem;\n}\n.p-72 {\n  padding: 18rem;\n}\n.p-80 {\n  padding: 20rem;\n}\n.p-96 {\n  padding: 24rem;\n}\n.p-px {\n  padding: 1px;\n}\n.p-0\\.5 {\n  padding: 0.125rem;\n}\n.p-1\\.5 {\n  padding: 0.375rem;\n}\n.p-2\\.5 {\n  padding: 0.625rem;\n}\n.p-3\\.5 {\n  padding: 0.875rem;\n}\n.p-1\\/2 {\n  padding: 50%;\n}\n.p-1\\/3 {\n  padding: 33.333333%;\n}\n.p-2\\/3 {\n  padding: 66.666667%;\n}\n.p-1\\/4 {\n  padding: 25%;\n}\n.p-2\\/4 {\n  padding: 50%;\n}\n.p-3\\/4 {\n  padding: 75%;\n}\n.p-1\\/5 {\n  padding: 20%;\n}\n.p-2\\/5 {\n  padding: 40%;\n}\n.p-3\\/5 {\n  padding: 60%;\n}\n.p-4\\/5 {\n  padding: 80%;\n}\n.p-1\\/6 {\n  padding: 16.666667%;\n}\n.p-2\\/6 {\n  padding: 33.333333%;\n}\n.p-3\\/6 {\n  padding: 50%;\n}\n.p-4\\/6 {\n  padding: 66.666667%;\n}\n.p-5\\/6 {\n  padding: 83.333333%;\n}\n.p-1\\/12 {\n  padding: 8.333333%;\n}\n.p-2\\/12 {\n  padding: 16.666667%;\n}\n.p-3\\/12 {\n  padding: 25%;\n}\n.p-4\\/12 {\n  padding: 33.333333%;\n}\n.p-5\\/12 {\n  padding: 41.666667%;\n}\n.p-6\\/12 {\n  padding: 50%;\n}\n.p-7\\/12 {\n  padding: 58.333333%;\n}\n.p-8\\/12 {\n  padding: 66.666667%;\n}\n.p-9\\/12 {\n  padding: 75%;\n}\n.p-10\\/12 {\n  padding: 83.333333%;\n}\n.p-11\\/12 {\n  padding: 91.666667%;\n}\n.p-full {\n  padding: 100%;\n}\n.py-0 {\n  padding-top: 0;\n  padding-bottom: 0;\n}\n.px-0 {\n  padding-left: 0;\n  padding-right: 0;\n}\n.py-1 {\n  padding-top: 0.25rem;\n  padding-bottom: 0.25rem;\n}\n.px-1 {\n  padding-left: 0.25rem;\n  padding-right: 0.25rem;\n}\n.py-2 {\n  padding-top: 0.5rem;\n  padding-bottom: 0.5rem;\n}\n.px-2 {\n  padding-left: 0.5rem;\n  padding-right: 0.5rem;\n}\n.py-3 {\n  padding-top: 0.75rem;\n  padding-bottom: 0.75rem;\n}\n.px-3 {\n  padding-left: 0.75rem;\n  padding-right: 0.75rem;\n}\n.py-4 {\n  padding-top: 1rem;\n  padding-bottom: 1rem;\n}\n.px-4 {\n  padding-left: 1rem;\n  padding-right: 1rem;\n}\n.py-5 {\n  padding-top: 1.25rem;\n  padding-bottom: 1.25rem;\n}\n.px-5 {\n  padding-left: 1.25rem;\n  padding-right: 1.25rem;\n}\n.py-6 {\n  padding-top: 1.5rem;\n  padding-bottom: 1.5rem;\n}\n.px-6 {\n  padding-left: 1.5rem;\n  padding-right: 1.5rem;\n}\n.py-7 {\n  padding-top: 1.75rem;\n  padding-bottom: 1.75rem;\n}\n.px-7 {\n  padding-left: 1.75rem;\n  padding-right: 1.75rem;\n}\n.py-8 {\n  padding-top: 2rem;\n  padding-bottom: 2rem;\n}\n.px-8 {\n  padding-left: 2rem;\n  padding-right: 2rem;\n}\n.py-9 {\n  padding-top: 2.25rem;\n  padding-bottom: 2.25rem;\n}\n.px-9 {\n  padding-left: 2.25rem;\n  padding-right: 2.25rem;\n}\n.py-10 {\n  padding-top: 2.5rem;\n  padding-bottom: 2.5rem;\n}\n.px-10 {\n  padding-left: 2.5rem;\n  padding-right: 2.5rem;\n}\n.py-11 {\n  padding-top: 2.75rem;\n  padding-bottom: 2.75rem;\n}\n.px-11 {\n  padding-left: 2.75rem;\n  padding-right: 2.75rem;\n}\n.py-12 {\n  padding-top: 3rem;\n  padding-bottom: 3rem;\n}\n.px-12 {\n  padding-left: 3rem;\n  padding-right: 3rem;\n}\n.py-13 {\n  padding-top: 3.25rem;\n  padding-bottom: 3.25rem;\n}\n.px-13 {\n  padding-left: 3.25rem;\n  padding-right: 3.25rem;\n}\n.py-14 {\n  padding-top: 3.5rem;\n  padding-bottom: 3.5rem;\n}\n.px-14 {\n  padding-left: 3.5rem;\n  padding-right: 3.5rem;\n}\n.py-15 {\n  padding-top: 3.75rem;\n  padding-bottom: 3.75rem;\n}\n.px-15 {\n  padding-left: 3.75rem;\n  padding-right: 3.75rem;\n}\n.py-16 {\n  padding-top: 4rem;\n  padding-bottom: 4rem;\n}\n.px-16 {\n  padding-left: 4rem;\n  padding-right: 4rem;\n}\n.py-20 {\n  padding-top: 5rem;\n  padding-bottom: 5rem;\n}\n.px-20 {\n  padding-left: 5rem;\n  padding-right: 5rem;\n}\n.py-24 {\n  padding-top: 6rem;\n  padding-bottom: 6rem;\n}\n.px-24 {\n  padding-left: 6rem;\n  padding-right: 6rem;\n}\n.py-28 {\n  padding-top: 7rem;\n  padding-bottom: 7rem;\n}\n.px-28 {\n  padding-left: 7rem;\n  padding-right: 7rem;\n}\n.py-32 {\n  padding-top: 8rem;\n  padding-bottom: 8rem;\n}\n.px-32 {\n  padding-left: 8rem;\n  padding-right: 8rem;\n}\n.py-36 {\n  padding-top: 9rem;\n  padding-bottom: 9rem;\n}\n.px-36 {\n  padding-left: 9rem;\n  padding-right: 9rem;\n}\n.py-40 {\n  padding-top: 10rem;\n  padding-bottom: 10rem;\n}\n.px-40 {\n  padding-left: 10rem;\n  padding-right: 10rem;\n}\n.py-44 {\n  padding-top: 11rem;\n  padding-bottom: 11rem;\n}\n.px-44 {\n  padding-left: 11rem;\n  padding-right: 11rem;\n}\n.py-48 {\n  padding-top: 12rem;\n  padding-bottom: 12rem;\n}\n.px-48 {\n  padding-left: 12rem;\n  padding-right: 12rem;\n}\n.py-52 {\n  padding-top: 13rem;\n  padding-bottom: 13rem;\n}\n.px-52 {\n  padding-left: 13rem;\n  padding-right: 13rem;\n}\n.py-56 {\n  padding-top: 14rem;\n  padding-bottom: 14rem;\n}\n.px-56 {\n  padding-left: 14rem;\n  padding-right: 14rem;\n}\n.py-60 {\n  padding-top: 15rem;\n  padding-bottom: 15rem;\n}\n.px-60 {\n  padding-left: 15rem;\n  padding-right: 15rem;\n}\n.py-64 {\n  padding-top: 16rem;\n  padding-bottom: 16rem;\n}\n.px-64 {\n  padding-left: 16rem;\n  padding-right: 16rem;\n}\n.py-72 {\n  padding-top: 18rem;\n  padding-bottom: 18rem;\n}\n.px-72 {\n  padding-left: 18rem;\n  padding-right: 18rem;\n}\n.py-80 {\n  padding-top: 20rem;\n  padding-bottom: 20rem;\n}\n.px-80 {\n  padding-left: 20rem;\n  padding-right: 20rem;\n}\n.py-96 {\n  padding-top: 24rem;\n  padding-bottom: 24rem;\n}\n.px-96 {\n  padding-left: 24rem;\n  padding-right: 24rem;\n}\n.py-px {\n  padding-top: 1px;\n  padding-bottom: 1px;\n}\n.px-px {\n  padding-left: 1px;\n  padding-right: 1px;\n}\n.py-0\\.5 {\n  padding-top: 0.125rem;\n  padding-bottom: 0.125rem;\n}\n.px-0\\.5 {\n  padding-left: 0.125rem;\n  padding-right: 0.125rem;\n}\n.py-1\\.5 {\n  padding-top: 0.375rem;\n  padding-bottom: 0.375rem;\n}\n.px-1\\.5 {\n  padding-left: 0.375rem;\n  padding-right: 0.375rem;\n}\n.py-2\\.5 {\n  padding-top: 0.625rem;\n  padding-bottom: 0.625rem;\n}\n.px-2\\.5 {\n  padding-left: 0.625rem;\n  padding-right: 0.625rem;\n}\n.py-3\\.5 {\n  padding-top: 0.875rem;\n  padding-bottom: 0.875rem;\n}\n.px-3\\.5 {\n  padding-left: 0.875rem;\n  padding-right: 0.875rem;\n}\n.py-1\\/2 {\n  padding-top: 50%;\n  padding-bottom: 50%;\n}\n.px-1\\/2 {\n  padding-left: 50%;\n  padding-right: 50%;\n}\n.py-1\\/3 {\n  padding-top: 33.333333%;\n  padding-bottom: 33.333333%;\n}\n.px-1\\/3 {\n  padding-left: 33.333333%;\n  padding-right: 33.333333%;\n}\n.py-2\\/3 {\n  padding-top: 66.666667%;\n  padding-bottom: 66.666667%;\n}\n.px-2\\/3 {\n  padding-left: 66.666667%;\n  padding-right: 66.666667%;\n}\n.py-1\\/4 {\n  padding-top: 25%;\n  padding-bottom: 25%;\n}\n.px-1\\/4 {\n  padding-left: 25%;\n  padding-right: 25%;\n}\n.py-2\\/4 {\n  padding-top: 50%;\n  padding-bottom: 50%;\n}\n.px-2\\/4 {\n  padding-left: 50%;\n  padding-right: 50%;\n}\n.py-3\\/4 {\n  padding-top: 75%;\n  padding-bottom: 75%;\n}\n.px-3\\/4 {\n  padding-left: 75%;\n  padding-right: 75%;\n}\n.py-1\\/5 {\n  padding-top: 20%;\n  padding-bottom: 20%;\n}\n.px-1\\/5 {\n  padding-left: 20%;\n  padding-right: 20%;\n}\n.py-2\\/5 {\n  padding-top: 40%;\n  padding-bottom: 40%;\n}\n.px-2\\/5 {\n  padding-left: 40%;\n  padding-right: 40%;\n}\n.py-3\\/5 {\n  padding-top: 60%;\n  padding-bottom: 60%;\n}\n.px-3\\/5 {\n  padding-left: 60%;\n  padding-right: 60%;\n}\n.py-4\\/5 {\n  padding-top: 80%;\n  padding-bottom: 80%;\n}\n.px-4\\/5 {\n  padding-left: 80%;\n  padding-right: 80%;\n}\n.py-1\\/6 {\n  padding-top: 16.666667%;\n  padding-bottom: 16.666667%;\n}\n.px-1\\/6 {\n  padding-left: 16.666667%;\n  padding-right: 16.666667%;\n}\n.py-2\\/6 {\n  padding-top: 33.333333%;\n  padding-bottom: 33.333333%;\n}\n.px-2\\/6 {\n  padding-left: 33.333333%;\n  padding-right: 33.333333%;\n}\n.py-3\\/6 {\n  padding-top: 50%;\n  padding-bottom: 50%;\n}\n.px-3\\/6 {\n  padding-left: 50%;\n  padding-right: 50%;\n}\n.py-4\\/6 {\n  padding-top: 66.666667%;\n  padding-bottom: 66.666667%;\n}\n.px-4\\/6 {\n  padding-left: 66.666667%;\n  padding-right: 66.666667%;\n}\n.py-5\\/6 {\n  padding-top: 83.333333%;\n  padding-bottom: 83.333333%;\n}\n.px-5\\/6 {\n  padding-left: 83.333333%;\n  padding-right: 83.333333%;\n}\n.py-1\\/12 {\n  padding-top: 8.333333%;\n  padding-bottom: 8.333333%;\n}\n.px-1\\/12 {\n  padding-left: 8.333333%;\n  padding-right: 8.333333%;\n}\n.py-2\\/12 {\n  padding-top: 16.666667%;\n  padding-bottom: 16.666667%;\n}\n.px-2\\/12 {\n  padding-left: 16.666667%;\n  padding-right: 16.666667%;\n}\n.py-3\\/12 {\n  padding-top: 25%;\n  padding-bottom: 25%;\n}\n.px-3\\/12 {\n  padding-left: 25%;\n  padding-right: 25%;\n}\n.py-4\\/12 {\n  padding-top: 33.333333%;\n  padding-bottom: 33.333333%;\n}\n.px-4\\/12 {\n  padding-left: 33.333333%;\n  padding-right: 33.333333%;\n}\n.py-5\\/12 {\n  padding-top: 41.666667%;\n  padding-bottom: 41.666667%;\n}\n.px-5\\/12 {\n  padding-left: 41.666667%;\n  padding-right: 41.666667%;\n}\n.py-6\\/12 {\n  padding-top: 50%;\n  padding-bottom: 50%;\n}\n.px-6\\/12 {\n  padding-left: 50%;\n  padding-right: 50%;\n}\n.py-7\\/12 {\n  padding-top: 58.333333%;\n  padding-bottom: 58.333333%;\n}\n.px-7\\/12 {\n  padding-left: 58.333333%;\n  padding-right: 58.333333%;\n}\n.py-8\\/12 {\n  padding-top: 66.666667%;\n  padding-bottom: 66.666667%;\n}\n.px-8\\/12 {\n  padding-left: 66.666667%;\n  padding-right: 66.666667%;\n}\n.py-9\\/12 {\n  padding-top: 75%;\n  padding-bottom: 75%;\n}\n.px-9\\/12 {\n  padding-left: 75%;\n  padding-right: 75%;\n}\n.py-10\\/12 {\n  padding-top: 83.333333%;\n  padding-bottom: 83.333333%;\n}\n.px-10\\/12 {\n  padding-left: 83.333333%;\n  padding-right: 83.333333%;\n}\n.py-11\\/12 {\n  padding-top: 91.666667%;\n  padding-bottom: 91.666667%;\n}\n.px-11\\/12 {\n  padding-left: 91.666667%;\n  padding-right: 91.666667%;\n}\n.py-full {\n  padding-top: 100%;\n  padding-bottom: 100%;\n}\n.px-full {\n  padding-left: 100%;\n  padding-right: 100%;\n}\n.pt-0 {\n  padding-top: 0;\n}\n.pr-0 {\n  padding-right: 0;\n}\n.pb-0 {\n  padding-bottom: 0;\n}\n.pl-0 {\n  padding-left: 0;\n}\n.pt-1 {\n  padding-top: 0.25rem;\n}\n.pr-1 {\n  padding-right: 0.25rem;\n}\n.pb-1 {\n  padding-bottom: 0.25rem;\n}\n.pl-1 {\n  padding-left: 0.25rem;\n}\n.pt-2 {\n  padding-top: 0.5rem;\n}\n.pr-2 {\n  padding-right: 0.5rem;\n}\n.pb-2 {\n  padding-bottom: 0.5rem;\n}\n.pl-2 {\n  padding-left: 0.5rem;\n}\n.pt-3 {\n  padding-top: 0.75rem;\n}\n.pr-3 {\n  padding-right: 0.75rem;\n}\n.pb-3 {\n  padding-bottom: 0.75rem;\n}\n.pl-3 {\n  padding-left: 0.75rem;\n}\n.pt-4 {\n  padding-top: 1rem;\n}\n.pr-4 {\n  padding-right: 1rem;\n}\n.pb-4 {\n  padding-bottom: 1rem;\n}\n.pl-4 {\n  padding-left: 1rem;\n}\n.pt-5 {\n  padding-top: 1.25rem;\n}\n.pr-5 {\n  padding-right: 1.25rem;\n}\n.pb-5 {\n  padding-bottom: 1.25rem;\n}\n.pl-5 {\n  padding-left: 1.25rem;\n}\n.pt-6 {\n  padding-top: 1.5rem;\n}\n.pr-6 {\n  padding-right: 1.5rem;\n}\n.pb-6 {\n  padding-bottom: 1.5rem;\n}\n.pl-6 {\n  padding-left: 1.5rem;\n}\n.pt-7 {\n  padding-top: 1.75rem;\n}\n.pr-7 {\n  padding-right: 1.75rem;\n}\n.pb-7 {\n  padding-bottom: 1.75rem;\n}\n.pl-7 {\n  padding-left: 1.75rem;\n}\n.pt-8 {\n  padding-top: 2rem;\n}\n.pr-8 {\n  padding-right: 2rem;\n}\n.pb-8 {\n  padding-bottom: 2rem;\n}\n.pl-8 {\n  padding-left: 2rem;\n}\n.pt-9 {\n  padding-top: 2.25rem;\n}\n.pr-9 {\n  padding-right: 2.25rem;\n}\n.pb-9 {\n  padding-bottom: 2.25rem;\n}\n.pl-9 {\n  padding-left: 2.25rem;\n}\n.pt-10 {\n  padding-top: 2.5rem;\n}\n.pr-10 {\n  padding-right: 2.5rem;\n}\n.pb-10 {\n  padding-bottom: 2.5rem;\n}\n.pl-10 {\n  padding-left: 2.5rem;\n}\n.pt-11 {\n  padding-top: 2.75rem;\n}\n.pr-11 {\n  padding-right: 2.75rem;\n}\n.pb-11 {\n  padding-bottom: 2.75rem;\n}\n.pl-11 {\n  padding-left: 2.75rem;\n}\n.pt-12 {\n  padding-top: 3rem;\n}\n.pr-12 {\n  padding-right: 3rem;\n}\n.pb-12 {\n  padding-bottom: 3rem;\n}\n.pl-12 {\n  padding-left: 3rem;\n}\n.pt-13 {\n  padding-top: 3.25rem;\n}\n.pr-13 {\n  padding-right: 3.25rem;\n}\n.pb-13 {\n  padding-bottom: 3.25rem;\n}\n.pl-13 {\n  padding-left: 3.25rem;\n}\n.pt-14 {\n  padding-top: 3.5rem;\n}\n.pr-14 {\n  padding-right: 3.5rem;\n}\n.pb-14 {\n  padding-bottom: 3.5rem;\n}\n.pl-14 {\n  padding-left: 3.5rem;\n}\n.pt-15 {\n  padding-top: 3.75rem;\n}\n.pr-15 {\n  padding-right: 3.75rem;\n}\n.pb-15 {\n  padding-bottom: 3.75rem;\n}\n.pl-15 {\n  padding-left: 3.75rem;\n}\n.pt-16 {\n  padding-top: 4rem;\n}\n.pr-16 {\n  padding-right: 4rem;\n}\n.pb-16 {\n  padding-bottom: 4rem;\n}\n.pl-16 {\n  padding-left: 4rem;\n}\n.pt-20 {\n  padding-top: 5rem;\n}\n.pr-20 {\n  padding-right: 5rem;\n}\n.pb-20 {\n  padding-bottom: 5rem;\n}\n.pl-20 {\n  padding-left: 5rem;\n}\n.pt-24 {\n  padding-top: 6rem;\n}\n.pr-24 {\n  padding-right: 6rem;\n}\n.pb-24 {\n  padding-bottom: 6rem;\n}\n.pl-24 {\n  padding-left: 6rem;\n}\n.pt-28 {\n  padding-top: 7rem;\n}\n.pr-28 {\n  padding-right: 7rem;\n}\n.pb-28 {\n  padding-bottom: 7rem;\n}\n.pl-28 {\n  padding-left: 7rem;\n}\n.pt-32 {\n  padding-top: 8rem;\n}\n.pr-32 {\n  padding-right: 8rem;\n}\n.pb-32 {\n  padding-bottom: 8rem;\n}\n.pl-32 {\n  padding-left: 8rem;\n}\n.pt-36 {\n  padding-top: 9rem;\n}\n.pr-36 {\n  padding-right: 9rem;\n}\n.pb-36 {\n  padding-bottom: 9rem;\n}\n.pl-36 {\n  padding-left: 9rem;\n}\n.pt-40 {\n  padding-top: 10rem;\n}\n.pr-40 {\n  padding-right: 10rem;\n}\n.pb-40 {\n  padding-bottom: 10rem;\n}\n.pl-40 {\n  padding-left: 10rem;\n}\n.pt-44 {\n  padding-top: 11rem;\n}\n.pr-44 {\n  padding-right: 11rem;\n}\n.pb-44 {\n  padding-bottom: 11rem;\n}\n.pl-44 {\n  padding-left: 11rem;\n}\n.pt-48 {\n  padding-top: 12rem;\n}\n.pr-48 {\n  padding-right: 12rem;\n}\n.pb-48 {\n  padding-bottom: 12rem;\n}\n.pl-48 {\n  padding-left: 12rem;\n}\n.pt-52 {\n  padding-top: 13rem;\n}\n.pr-52 {\n  padding-right: 13rem;\n}\n.pb-52 {\n  padding-bottom: 13rem;\n}\n.pl-52 {\n  padding-left: 13rem;\n}\n.pt-56 {\n  padding-top: 14rem;\n}\n.pr-56 {\n  padding-right: 14rem;\n}\n.pb-56 {\n  padding-bottom: 14rem;\n}\n.pl-56 {\n  padding-left: 14rem;\n}\n.pt-60 {\n  padding-top: 15rem;\n}\n.pr-60 {\n  padding-right: 15rem;\n}\n.pb-60 {\n  padding-bottom: 15rem;\n}\n.pl-60 {\n  padding-left: 15rem;\n}\n.pt-64 {\n  padding-top: 16rem;\n}\n.pr-64 {\n  padding-right: 16rem;\n}\n.pb-64 {\n  padding-bottom: 16rem;\n}\n.pl-64 {\n  padding-left: 16rem;\n}\n.pt-72 {\n  padding-top: 18rem;\n}\n.pr-72 {\n  padding-right: 18rem;\n}\n.pb-72 {\n  padding-bottom: 18rem;\n}\n.pl-72 {\n  padding-left: 18rem;\n}\n.pt-80 {\n  padding-top: 20rem;\n}\n.pr-80 {\n  padding-right: 20rem;\n}\n.pb-80 {\n  padding-bottom: 20rem;\n}\n.pl-80 {\n  padding-left: 20rem;\n}\n.pt-96 {\n  padding-top: 24rem;\n}\n.pr-96 {\n  padding-right: 24rem;\n}\n.pb-96 {\n  padding-bottom: 24rem;\n}\n.pl-96 {\n  padding-left: 24rem;\n}\n.pt-px {\n  padding-top: 1px;\n}\n.pr-px {\n  padding-right: 1px;\n}\n.pb-px {\n  padding-bottom: 1px;\n}\n.pl-px {\n  padding-left: 1px;\n}\n.pt-0\\.5 {\n  padding-top: 0.125rem;\n}\n.pr-0\\.5 {\n  padding-right: 0.125rem;\n}\n.pb-0\\.5 {\n  padding-bottom: 0.125rem;\n}\n.pl-0\\.5 {\n  padding-left: 0.125rem;\n}\n.pt-1\\.5 {\n  padding-top: 0.375rem;\n}\n.pr-1\\.5 {\n  padding-right: 0.375rem;\n}\n.pb-1\\.5 {\n  padding-bottom: 0.375rem;\n}\n.pl-1\\.5 {\n  padding-left: 0.375rem;\n}\n.pt-2\\.5 {\n  padding-top: 0.625rem;\n}\n.pr-2\\.5 {\n  padding-right: 0.625rem;\n}\n.pb-2\\.5 {\n  padding-bottom: 0.625rem;\n}\n.pl-2\\.5 {\n  padding-left: 0.625rem;\n}\n.pt-3\\.5 {\n  padding-top: 0.875rem;\n}\n.pr-3\\.5 {\n  padding-right: 0.875rem;\n}\n.pb-3\\.5 {\n  padding-bottom: 0.875rem;\n}\n.pl-3\\.5 {\n  padding-left: 0.875rem;\n}\n.pt-1\\/2 {\n  padding-top: 50%;\n}\n.pr-1\\/2 {\n  padding-right: 50%;\n}\n.pb-1\\/2 {\n  padding-bottom: 50%;\n}\n.pl-1\\/2 {\n  padding-left: 50%;\n}\n.pt-1\\/3 {\n  padding-top: 33.333333%;\n}\n.pr-1\\/3 {\n  padding-right: 33.333333%;\n}\n.pb-1\\/3 {\n  padding-bottom: 33.333333%;\n}\n.pl-1\\/3 {\n  padding-left: 33.333333%;\n}\n.pt-2\\/3 {\n  padding-top: 66.666667%;\n}\n.pr-2\\/3 {\n  padding-right: 66.666667%;\n}\n.pb-2\\/3 {\n  padding-bottom: 66.666667%;\n}\n.pl-2\\/3 {\n  padding-left: 66.666667%;\n}\n.pt-1\\/4 {\n  padding-top: 25%;\n}\n.pr-1\\/4 {\n  padding-right: 25%;\n}\n.pb-1\\/4 {\n  padding-bottom: 25%;\n}\n.pl-1\\/4 {\n  padding-left: 25%;\n}\n.pt-2\\/4 {\n  padding-top: 50%;\n}\n.pr-2\\/4 {\n  padding-right: 50%;\n}\n.pb-2\\/4 {\n  padding-bottom: 50%;\n}\n.pl-2\\/4 {\n  padding-left: 50%;\n}\n.pt-3\\/4 {\n  padding-top: 75%;\n}\n.pr-3\\/4 {\n  padding-right: 75%;\n}\n.pb-3\\/4 {\n  padding-bottom: 75%;\n}\n.pl-3\\/4 {\n  padding-left: 75%;\n}\n.pt-1\\/5 {\n  padding-top: 20%;\n}\n.pr-1\\/5 {\n  padding-right: 20%;\n}\n.pb-1\\/5 {\n  padding-bottom: 20%;\n}\n.pl-1\\/5 {\n  padding-left: 20%;\n}\n.pt-2\\/5 {\n  padding-top: 40%;\n}\n.pr-2\\/5 {\n  padding-right: 40%;\n}\n.pb-2\\/5 {\n  padding-bottom: 40%;\n}\n.pl-2\\/5 {\n  padding-left: 40%;\n}\n.pt-3\\/5 {\n  padding-top: 60%;\n}\n.pr-3\\/5 {\n  padding-right: 60%;\n}\n.pb-3\\/5 {\n  padding-bottom: 60%;\n}\n.pl-3\\/5 {\n  padding-left: 60%;\n}\n.pt-4\\/5 {\n  padding-top: 80%;\n}\n.pr-4\\/5 {\n  padding-right: 80%;\n}\n.pb-4\\/5 {\n  padding-bottom: 80%;\n}\n.pl-4\\/5 {\n  padding-left: 80%;\n}\n.pt-1\\/6 {\n  padding-top: 16.666667%;\n}\n.pr-1\\/6 {\n  padding-right: 16.666667%;\n}\n.pb-1\\/6 {\n  padding-bottom: 16.666667%;\n}\n.pl-1\\/6 {\n  padding-left: 16.666667%;\n}\n.pt-2\\/6 {\n  padding-top: 33.333333%;\n}\n.pr-2\\/6 {\n  padding-right: 33.333333%;\n}\n.pb-2\\/6 {\n  padding-bottom: 33.333333%;\n}\n.pl-2\\/6 {\n  padding-left: 33.333333%;\n}\n.pt-3\\/6 {\n  padding-top: 50%;\n}\n.pr-3\\/6 {\n  padding-right: 50%;\n}\n.pb-3\\/6 {\n  padding-bottom: 50%;\n}\n.pl-3\\/6 {\n  padding-left: 50%;\n}\n.pt-4\\/6 {\n  padding-top: 66.666667%;\n}\n.pr-4\\/6 {\n  padding-right: 66.666667%;\n}\n.pb-4\\/6 {\n  padding-bottom: 66.666667%;\n}\n.pl-4\\/6 {\n  padding-left: 66.666667%;\n}\n.pt-5\\/6 {\n  padding-top: 83.333333%;\n}\n.pr-5\\/6 {\n  padding-right: 83.333333%;\n}\n.pb-5\\/6 {\n  padding-bottom: 83.333333%;\n}\n.pl-5\\/6 {\n  padding-left: 83.333333%;\n}\n.pt-1\\/12 {\n  padding-top: 8.333333%;\n}\n.pr-1\\/12 {\n  padding-right: 8.333333%;\n}\n.pb-1\\/12 {\n  padding-bottom: 8.333333%;\n}\n.pl-1\\/12 {\n  padding-left: 8.333333%;\n}\n.pt-2\\/12 {\n  padding-top: 16.666667%;\n}\n.pr-2\\/12 {\n  padding-right: 16.666667%;\n}\n.pb-2\\/12 {\n  padding-bottom: 16.666667%;\n}\n.pl-2\\/12 {\n  padding-left: 16.666667%;\n}\n.pt-3\\/12 {\n  padding-top: 25%;\n}\n.pr-3\\/12 {\n  padding-right: 25%;\n}\n.pb-3\\/12 {\n  padding-bottom: 25%;\n}\n.pl-3\\/12 {\n  padding-left: 25%;\n}\n.pt-4\\/12 {\n  padding-top: 33.333333%;\n}\n.pr-4\\/12 {\n  padding-right: 33.333333%;\n}\n.pb-4\\/12 {\n  padding-bottom: 33.333333%;\n}\n.pl-4\\/12 {\n  padding-left: 33.333333%;\n}\n.pt-5\\/12 {\n  padding-top: 41.666667%;\n}\n.pr-5\\/12 {\n  padding-right: 41.666667%;\n}\n.pb-5\\/12 {\n  padding-bottom: 41.666667%;\n}\n.pl-5\\/12 {\n  padding-left: 41.666667%;\n}\n.pt-6\\/12 {\n  padding-top: 50%;\n}\n.pr-6\\/12 {\n  padding-right: 50%;\n}\n.pb-6\\/12 {\n  padding-bottom: 50%;\n}\n.pl-6\\/12 {\n  padding-left: 50%;\n}\n.pt-7\\/12 {\n  padding-top: 58.333333%;\n}\n.pr-7\\/12 {\n  padding-right: 58.333333%;\n}\n.pb-7\\/12 {\n  padding-bottom: 58.333333%;\n}\n.pl-7\\/12 {\n  padding-left: 58.333333%;\n}\n.pt-8\\/12 {\n  padding-top: 66.666667%;\n}\n.pr-8\\/12 {\n  padding-right: 66.666667%;\n}\n.pb-8\\/12 {\n  padding-bottom: 66.666667%;\n}\n.pl-8\\/12 {\n  padding-left: 66.666667%;\n}\n.pt-9\\/12 {\n  padding-top: 75%;\n}\n.pr-9\\/12 {\n  padding-right: 75%;\n}\n.pb-9\\/12 {\n  padding-bottom: 75%;\n}\n.pl-9\\/12 {\n  padding-left: 75%;\n}\n.pt-10\\/12 {\n  padding-top: 83.333333%;\n}\n.pr-10\\/12 {\n  padding-right: 83.333333%;\n}\n.pb-10\\/12 {\n  padding-bottom: 83.333333%;\n}\n.pl-10\\/12 {\n  padding-left: 83.333333%;\n}\n.pt-11\\/12 {\n  padding-top: 91.666667%;\n}\n.pr-11\\/12 {\n  padding-right: 91.666667%;\n}\n.pb-11\\/12 {\n  padding-bottom: 91.666667%;\n}\n.pl-11\\/12 {\n  padding-left: 91.666667%;\n}\n.pt-full {\n  padding-top: 100%;\n}\n.pr-full {\n  padding-right: 100%;\n}\n.pb-full {\n  padding-bottom: 100%;\n}\n.pl-full {\n  padding-left: 100%;\n}\n.placeholder-current::-moz-placeholder {\n  color: currentColor;\n}\n.placeholder-current::placeholder {\n  color: currentColor;\n}\n.placeholder-transparent::-moz-placeholder {\n  color: transparent;\n}\n.placeholder-transparent::placeholder {\n  color: transparent;\n}\n.placeholder-white::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #ffffff;\n  color: rgba(255, 255, 255, var(--placeholder-opacity));\n}\n.placeholder-white::placeholder {\n  --placeholder-opacity: 1;\n  color: #ffffff;\n  color: rgba(255, 255, 255, var(--placeholder-opacity));\n}\n.placeholder-black::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #000000;\n  color: rgba(0, 0, 0, var(--placeholder-opacity));\n}\n.placeholder-black::placeholder {\n  --placeholder-opacity: 1;\n  color: #000000;\n  color: rgba(0, 0, 0, var(--placeholder-opacity));\n}\n.placeholder-gray-50::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #f9fafb;\n  color: rgba(249, 250, 251, var(--placeholder-opacity));\n}\n.placeholder-gray-50::placeholder {\n  --placeholder-opacity: 1;\n  color: #f9fafb;\n  color: rgba(249, 250, 251, var(--placeholder-opacity));\n}\n.placeholder-gray-100::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #f4f5f7;\n  color: rgba(244, 245, 247, var(--placeholder-opacity));\n}\n.placeholder-gray-100::placeholder {\n  --placeholder-opacity: 1;\n  color: #f4f5f7;\n  color: rgba(244, 245, 247, var(--placeholder-opacity));\n}\n.placeholder-gray-200::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #e5e7eb;\n  color: rgba(229, 231, 235, var(--placeholder-opacity));\n}\n.placeholder-gray-200::placeholder {\n  --placeholder-opacity: 1;\n  color: #e5e7eb;\n  color: rgba(229, 231, 235, var(--placeholder-opacity));\n}\n.placeholder-gray-300::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #d2d6dc;\n  color: rgba(210, 214, 220, var(--placeholder-opacity));\n}\n.placeholder-gray-300::placeholder {\n  --placeholder-opacity: 1;\n  color: #d2d6dc;\n  color: rgba(210, 214, 220, var(--placeholder-opacity));\n}\n.placeholder-gray-400::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #9fa6b2;\n  color: rgba(159, 166, 178, var(--placeholder-opacity));\n}\n.placeholder-gray-400::placeholder {\n  --placeholder-opacity: 1;\n  color: #9fa6b2;\n  color: rgba(159, 166, 178, var(--placeholder-opacity));\n}\n.placeholder-gray-500::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #6b7280;\n  color: rgba(107, 114, 128, var(--placeholder-opacity));\n}\n.placeholder-gray-500::placeholder {\n  --placeholder-opacity: 1;\n  color: #6b7280;\n  color: rgba(107, 114, 128, var(--placeholder-opacity));\n}\n.placeholder-gray-600::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #4b5563;\n  color: rgba(75, 85, 99, var(--placeholder-opacity));\n}\n.placeholder-gray-600::placeholder {\n  --placeholder-opacity: 1;\n  color: #4b5563;\n  color: rgba(75, 85, 99, var(--placeholder-opacity));\n}\n.placeholder-gray-700::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #374151;\n  color: rgba(55, 65, 81, var(--placeholder-opacity));\n}\n.placeholder-gray-700::placeholder {\n  --placeholder-opacity: 1;\n  color: #374151;\n  color: rgba(55, 65, 81, var(--placeholder-opacity));\n}\n.placeholder-gray-800::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #252f3f;\n  color: rgba(37, 47, 63, var(--placeholder-opacity));\n}\n.placeholder-gray-800::placeholder {\n  --placeholder-opacity: 1;\n  color: #252f3f;\n  color: rgba(37, 47, 63, var(--placeholder-opacity));\n}\n.placeholder-gray-900::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #161e2e;\n  color: rgba(22, 30, 46, var(--placeholder-opacity));\n}\n.placeholder-gray-900::placeholder {\n  --placeholder-opacity: 1;\n  color: #161e2e;\n  color: rgba(22, 30, 46, var(--placeholder-opacity));\n}\n.placeholder-red-50::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #fdf2f2;\n  color: rgba(253, 242, 242, var(--placeholder-opacity));\n}\n.placeholder-red-50::placeholder {\n  --placeholder-opacity: 1;\n  color: #fdf2f2;\n  color: rgba(253, 242, 242, var(--placeholder-opacity));\n}\n.placeholder-red-100::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #fde8e8;\n  color: rgba(253, 232, 232, var(--placeholder-opacity));\n}\n.placeholder-red-100::placeholder {\n  --placeholder-opacity: 1;\n  color: #fde8e8;\n  color: rgba(253, 232, 232, var(--placeholder-opacity));\n}\n.placeholder-red-200::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #fbd5d5;\n  color: rgba(251, 213, 213, var(--placeholder-opacity));\n}\n.placeholder-red-200::placeholder {\n  --placeholder-opacity: 1;\n  color: #fbd5d5;\n  color: rgba(251, 213, 213, var(--placeholder-opacity));\n}\n.placeholder-red-300::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #f8b4b4;\n  color: rgba(248, 180, 180, var(--placeholder-opacity));\n}\n.placeholder-red-300::placeholder {\n  --placeholder-opacity: 1;\n  color: #f8b4b4;\n  color: rgba(248, 180, 180, var(--placeholder-opacity));\n}\n.placeholder-red-400::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #f98080;\n  color: rgba(249, 128, 128, var(--placeholder-opacity));\n}\n.placeholder-red-400::placeholder {\n  --placeholder-opacity: 1;\n  color: #f98080;\n  color: rgba(249, 128, 128, var(--placeholder-opacity));\n}\n.placeholder-red-500::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #f05252;\n  color: rgba(240, 82, 82, var(--placeholder-opacity));\n}\n.placeholder-red-500::placeholder {\n  --placeholder-opacity: 1;\n  color: #f05252;\n  color: rgba(240, 82, 82, var(--placeholder-opacity));\n}\n.placeholder-red-600::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #e02424;\n  color: rgba(224, 36, 36, var(--placeholder-opacity));\n}\n.placeholder-red-600::placeholder {\n  --placeholder-opacity: 1;\n  color: #e02424;\n  color: rgba(224, 36, 36, var(--placeholder-opacity));\n}\n.placeholder-red-700::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #c81e1e;\n  color: rgba(200, 30, 30, var(--placeholder-opacity));\n}\n.placeholder-red-700::placeholder {\n  --placeholder-opacity: 1;\n  color: #c81e1e;\n  color: rgba(200, 30, 30, var(--placeholder-opacity));\n}\n.placeholder-red-800::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #9b1c1c;\n  color: rgba(155, 28, 28, var(--placeholder-opacity));\n}\n.placeholder-red-800::placeholder {\n  --placeholder-opacity: 1;\n  color: #9b1c1c;\n  color: rgba(155, 28, 28, var(--placeholder-opacity));\n}\n.placeholder-red-900::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #771d1d;\n  color: rgba(119, 29, 29, var(--placeholder-opacity));\n}\n.placeholder-red-900::placeholder {\n  --placeholder-opacity: 1;\n  color: #771d1d;\n  color: rgba(119, 29, 29, var(--placeholder-opacity));\n}\n.placeholder-orange-50::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #fff8f1;\n  color: rgba(255, 248, 241, var(--placeholder-opacity));\n}\n.placeholder-orange-50::placeholder {\n  --placeholder-opacity: 1;\n  color: #fff8f1;\n  color: rgba(255, 248, 241, var(--placeholder-opacity));\n}\n.placeholder-orange-100::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #feecdc;\n  color: rgba(254, 236, 220, var(--placeholder-opacity));\n}\n.placeholder-orange-100::placeholder {\n  --placeholder-opacity: 1;\n  color: #feecdc;\n  color: rgba(254, 236, 220, var(--placeholder-opacity));\n}\n.placeholder-orange-200::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #fcd9bd;\n  color: rgba(252, 217, 189, var(--placeholder-opacity));\n}\n.placeholder-orange-200::placeholder {\n  --placeholder-opacity: 1;\n  color: #fcd9bd;\n  color: rgba(252, 217, 189, var(--placeholder-opacity));\n}\n.placeholder-orange-300::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #fdba8c;\n  color: rgba(253, 186, 140, var(--placeholder-opacity));\n}\n.placeholder-orange-300::placeholder {\n  --placeholder-opacity: 1;\n  color: #fdba8c;\n  color: rgba(253, 186, 140, var(--placeholder-opacity));\n}\n.placeholder-orange-400::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #ff8a4c;\n  color: rgba(255, 138, 76, var(--placeholder-opacity));\n}\n.placeholder-orange-400::placeholder {\n  --placeholder-opacity: 1;\n  color: #ff8a4c;\n  color: rgba(255, 138, 76, var(--placeholder-opacity));\n}\n.placeholder-orange-500::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #ff5a1f;\n  color: rgba(255, 90, 31, var(--placeholder-opacity));\n}\n.placeholder-orange-500::placeholder {\n  --placeholder-opacity: 1;\n  color: #ff5a1f;\n  color: rgba(255, 90, 31, var(--placeholder-opacity));\n}\n.placeholder-orange-600::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #d03801;\n  color: rgba(208, 56, 1, var(--placeholder-opacity));\n}\n.placeholder-orange-600::placeholder {\n  --placeholder-opacity: 1;\n  color: #d03801;\n  color: rgba(208, 56, 1, var(--placeholder-opacity));\n}\n.placeholder-orange-700::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #b43403;\n  color: rgba(180, 52, 3, var(--placeholder-opacity));\n}\n.placeholder-orange-700::placeholder {\n  --placeholder-opacity: 1;\n  color: #b43403;\n  color: rgba(180, 52, 3, var(--placeholder-opacity));\n}\n.placeholder-orange-800::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #8a2c0d;\n  color: rgba(138, 44, 13, var(--placeholder-opacity));\n}\n.placeholder-orange-800::placeholder {\n  --placeholder-opacity: 1;\n  color: #8a2c0d;\n  color: rgba(138, 44, 13, var(--placeholder-opacity));\n}\n.placeholder-orange-900::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #73230d;\n  color: rgba(115, 35, 13, var(--placeholder-opacity));\n}\n.placeholder-orange-900::placeholder {\n  --placeholder-opacity: 1;\n  color: #73230d;\n  color: rgba(115, 35, 13, var(--placeholder-opacity));\n}\n.placeholder-yellow-50::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #fdfdea;\n  color: rgba(253, 253, 234, var(--placeholder-opacity));\n}\n.placeholder-yellow-50::placeholder {\n  --placeholder-opacity: 1;\n  color: #fdfdea;\n  color: rgba(253, 253, 234, var(--placeholder-opacity));\n}\n.placeholder-yellow-100::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #fdf6b2;\n  color: rgba(253, 246, 178, var(--placeholder-opacity));\n}\n.placeholder-yellow-100::placeholder {\n  --placeholder-opacity: 1;\n  color: #fdf6b2;\n  color: rgba(253, 246, 178, var(--placeholder-opacity));\n}\n.placeholder-yellow-200::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #fce96a;\n  color: rgba(252, 233, 106, var(--placeholder-opacity));\n}\n.placeholder-yellow-200::placeholder {\n  --placeholder-opacity: 1;\n  color: #fce96a;\n  color: rgba(252, 233, 106, var(--placeholder-opacity));\n}\n.placeholder-yellow-300::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #faca15;\n  color: rgba(250, 202, 21, var(--placeholder-opacity));\n}\n.placeholder-yellow-300::placeholder {\n  --placeholder-opacity: 1;\n  color: #faca15;\n  color: rgba(250, 202, 21, var(--placeholder-opacity));\n}\n.placeholder-yellow-400::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #e3a008;\n  color: rgba(227, 160, 8, var(--placeholder-opacity));\n}\n.placeholder-yellow-400::placeholder {\n  --placeholder-opacity: 1;\n  color: #e3a008;\n  color: rgba(227, 160, 8, var(--placeholder-opacity));\n}\n.placeholder-yellow-500::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #c27803;\n  color: rgba(194, 120, 3, var(--placeholder-opacity));\n}\n.placeholder-yellow-500::placeholder {\n  --placeholder-opacity: 1;\n  color: #c27803;\n  color: rgba(194, 120, 3, var(--placeholder-opacity));\n}\n.placeholder-yellow-600::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #9f580a;\n  color: rgba(159, 88, 10, var(--placeholder-opacity));\n}\n.placeholder-yellow-600::placeholder {\n  --placeholder-opacity: 1;\n  color: #9f580a;\n  color: rgba(159, 88, 10, var(--placeholder-opacity));\n}\n.placeholder-yellow-700::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #8e4b10;\n  color: rgba(142, 75, 16, var(--placeholder-opacity));\n}\n.placeholder-yellow-700::placeholder {\n  --placeholder-opacity: 1;\n  color: #8e4b10;\n  color: rgba(142, 75, 16, var(--placeholder-opacity));\n}\n.placeholder-yellow-800::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #723b13;\n  color: rgba(114, 59, 19, var(--placeholder-opacity));\n}\n.placeholder-yellow-800::placeholder {\n  --placeholder-opacity: 1;\n  color: #723b13;\n  color: rgba(114, 59, 19, var(--placeholder-opacity));\n}\n.placeholder-yellow-900::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #633112;\n  color: rgba(99, 49, 18, var(--placeholder-opacity));\n}\n.placeholder-yellow-900::placeholder {\n  --placeholder-opacity: 1;\n  color: #633112;\n  color: rgba(99, 49, 18, var(--placeholder-opacity));\n}\n.placeholder-green-50::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #f3faf7;\n  color: rgba(243, 250, 247, var(--placeholder-opacity));\n}\n.placeholder-green-50::placeholder {\n  --placeholder-opacity: 1;\n  color: #f3faf7;\n  color: rgba(243, 250, 247, var(--placeholder-opacity));\n}\n.placeholder-green-100::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #def7ec;\n  color: rgba(222, 247, 236, var(--placeholder-opacity));\n}\n.placeholder-green-100::placeholder {\n  --placeholder-opacity: 1;\n  color: #def7ec;\n  color: rgba(222, 247, 236, var(--placeholder-opacity));\n}\n.placeholder-green-200::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #bcf0da;\n  color: rgba(188, 240, 218, var(--placeholder-opacity));\n}\n.placeholder-green-200::placeholder {\n  --placeholder-opacity: 1;\n  color: #bcf0da;\n  color: rgba(188, 240, 218, var(--placeholder-opacity));\n}\n.placeholder-green-300::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #84e1bc;\n  color: rgba(132, 225, 188, var(--placeholder-opacity));\n}\n.placeholder-green-300::placeholder {\n  --placeholder-opacity: 1;\n  color: #84e1bc;\n  color: rgba(132, 225, 188, var(--placeholder-opacity));\n}\n.placeholder-green-400::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #31c48d;\n  color: rgba(49, 196, 141, var(--placeholder-opacity));\n}\n.placeholder-green-400::placeholder {\n  --placeholder-opacity: 1;\n  color: #31c48d;\n  color: rgba(49, 196, 141, var(--placeholder-opacity));\n}\n.placeholder-green-500::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #0e9f6e;\n  color: rgba(14, 159, 110, var(--placeholder-opacity));\n}\n.placeholder-green-500::placeholder {\n  --placeholder-opacity: 1;\n  color: #0e9f6e;\n  color: rgba(14, 159, 110, var(--placeholder-opacity));\n}\n.placeholder-green-600::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #057a55;\n  color: rgba(5, 122, 85, var(--placeholder-opacity));\n}\n.placeholder-green-600::placeholder {\n  --placeholder-opacity: 1;\n  color: #057a55;\n  color: rgba(5, 122, 85, var(--placeholder-opacity));\n}\n.placeholder-green-700::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #046c4e;\n  color: rgba(4, 108, 78, var(--placeholder-opacity));\n}\n.placeholder-green-700::placeholder {\n  --placeholder-opacity: 1;\n  color: #046c4e;\n  color: rgba(4, 108, 78, var(--placeholder-opacity));\n}\n.placeholder-green-800::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #03543f;\n  color: rgba(3, 84, 63, var(--placeholder-opacity));\n}\n.placeholder-green-800::placeholder {\n  --placeholder-opacity: 1;\n  color: #03543f;\n  color: rgba(3, 84, 63, var(--placeholder-opacity));\n}\n.placeholder-green-900::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #014737;\n  color: rgba(1, 71, 55, var(--placeholder-opacity));\n}\n.placeholder-green-900::placeholder {\n  --placeholder-opacity: 1;\n  color: #014737;\n  color: rgba(1, 71, 55, var(--placeholder-opacity));\n}\n.placeholder-teal-50::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #edfafa;\n  color: rgba(237, 250, 250, var(--placeholder-opacity));\n}\n.placeholder-teal-50::placeholder {\n  --placeholder-opacity: 1;\n  color: #edfafa;\n  color: rgba(237, 250, 250, var(--placeholder-opacity));\n}\n.placeholder-teal-100::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #d5f5f6;\n  color: rgba(213, 245, 246, var(--placeholder-opacity));\n}\n.placeholder-teal-100::placeholder {\n  --placeholder-opacity: 1;\n  color: #d5f5f6;\n  color: rgba(213, 245, 246, var(--placeholder-opacity));\n}\n.placeholder-teal-200::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #afecef;\n  color: rgba(175, 236, 239, var(--placeholder-opacity));\n}\n.placeholder-teal-200::placeholder {\n  --placeholder-opacity: 1;\n  color: #afecef;\n  color: rgba(175, 236, 239, var(--placeholder-opacity));\n}\n.placeholder-teal-300::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #7edce2;\n  color: rgba(126, 220, 226, var(--placeholder-opacity));\n}\n.placeholder-teal-300::placeholder {\n  --placeholder-opacity: 1;\n  color: #7edce2;\n  color: rgba(126, 220, 226, var(--placeholder-opacity));\n}\n.placeholder-teal-400::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #16bdca;\n  color: rgba(22, 189, 202, var(--placeholder-opacity));\n}\n.placeholder-teal-400::placeholder {\n  --placeholder-opacity: 1;\n  color: #16bdca;\n  color: rgba(22, 189, 202, var(--placeholder-opacity));\n}\n.placeholder-teal-500::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #0694a2;\n  color: rgba(6, 148, 162, var(--placeholder-opacity));\n}\n.placeholder-teal-500::placeholder {\n  --placeholder-opacity: 1;\n  color: #0694a2;\n  color: rgba(6, 148, 162, var(--placeholder-opacity));\n}\n.placeholder-teal-600::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #047481;\n  color: rgba(4, 116, 129, var(--placeholder-opacity));\n}\n.placeholder-teal-600::placeholder {\n  --placeholder-opacity: 1;\n  color: #047481;\n  color: rgba(4, 116, 129, var(--placeholder-opacity));\n}\n.placeholder-teal-700::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #036672;\n  color: rgba(3, 102, 114, var(--placeholder-opacity));\n}\n.placeholder-teal-700::placeholder {\n  --placeholder-opacity: 1;\n  color: #036672;\n  color: rgba(3, 102, 114, var(--placeholder-opacity));\n}\n.placeholder-teal-800::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #05505c;\n  color: rgba(5, 80, 92, var(--placeholder-opacity));\n}\n.placeholder-teal-800::placeholder {\n  --placeholder-opacity: 1;\n  color: #05505c;\n  color: rgba(5, 80, 92, var(--placeholder-opacity));\n}\n.placeholder-teal-900::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #014451;\n  color: rgba(1, 68, 81, var(--placeholder-opacity));\n}\n.placeholder-teal-900::placeholder {\n  --placeholder-opacity: 1;\n  color: #014451;\n  color: rgba(1, 68, 81, var(--placeholder-opacity));\n}\n.placeholder-blue-50::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #ebf5ff;\n  color: rgba(235, 245, 255, var(--placeholder-opacity));\n}\n.placeholder-blue-50::placeholder {\n  --placeholder-opacity: 1;\n  color: #ebf5ff;\n  color: rgba(235, 245, 255, var(--placeholder-opacity));\n}\n.placeholder-blue-100::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #e1effe;\n  color: rgba(225, 239, 254, var(--placeholder-opacity));\n}\n.placeholder-blue-100::placeholder {\n  --placeholder-opacity: 1;\n  color: #e1effe;\n  color: rgba(225, 239, 254, var(--placeholder-opacity));\n}\n.placeholder-blue-200::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #c3ddfd;\n  color: rgba(195, 221, 253, var(--placeholder-opacity));\n}\n.placeholder-blue-200::placeholder {\n  --placeholder-opacity: 1;\n  color: #c3ddfd;\n  color: rgba(195, 221, 253, var(--placeholder-opacity));\n}\n.placeholder-blue-300::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #a4cafe;\n  color: rgba(164, 202, 254, var(--placeholder-opacity));\n}\n.placeholder-blue-300::placeholder {\n  --placeholder-opacity: 1;\n  color: #a4cafe;\n  color: rgba(164, 202, 254, var(--placeholder-opacity));\n}\n.placeholder-blue-400::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #76a9fa;\n  color: rgba(118, 169, 250, var(--placeholder-opacity));\n}\n.placeholder-blue-400::placeholder {\n  --placeholder-opacity: 1;\n  color: #76a9fa;\n  color: rgba(118, 169, 250, var(--placeholder-opacity));\n}\n.placeholder-blue-500::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #3f83f8;\n  color: rgba(63, 131, 248, var(--placeholder-opacity));\n}\n.placeholder-blue-500::placeholder {\n  --placeholder-opacity: 1;\n  color: #3f83f8;\n  color: rgba(63, 131, 248, var(--placeholder-opacity));\n}\n.placeholder-blue-600::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #1c64f2;\n  color: rgba(28, 100, 242, var(--placeholder-opacity));\n}\n.placeholder-blue-600::placeholder {\n  --placeholder-opacity: 1;\n  color: #1c64f2;\n  color: rgba(28, 100, 242, var(--placeholder-opacity));\n}\n.placeholder-blue-700::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #1a56db;\n  color: rgba(26, 86, 219, var(--placeholder-opacity));\n}\n.placeholder-blue-700::placeholder {\n  --placeholder-opacity: 1;\n  color: #1a56db;\n  color: rgba(26, 86, 219, var(--placeholder-opacity));\n}\n.placeholder-blue-800::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #1e429f;\n  color: rgba(30, 66, 159, var(--placeholder-opacity));\n}\n.placeholder-blue-800::placeholder {\n  --placeholder-opacity: 1;\n  color: #1e429f;\n  color: rgba(30, 66, 159, var(--placeholder-opacity));\n}\n.placeholder-blue-900::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #233876;\n  color: rgba(35, 56, 118, var(--placeholder-opacity));\n}\n.placeholder-blue-900::placeholder {\n  --placeholder-opacity: 1;\n  color: #233876;\n  color: rgba(35, 56, 118, var(--placeholder-opacity));\n}\n.placeholder-indigo-50::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #f0f5ff;\n  color: rgba(240, 245, 255, var(--placeholder-opacity));\n}\n.placeholder-indigo-50::placeholder {\n  --placeholder-opacity: 1;\n  color: #f0f5ff;\n  color: rgba(240, 245, 255, var(--placeholder-opacity));\n}\n.placeholder-indigo-100::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #e5edff;\n  color: rgba(229, 237, 255, var(--placeholder-opacity));\n}\n.placeholder-indigo-100::placeholder {\n  --placeholder-opacity: 1;\n  color: #e5edff;\n  color: rgba(229, 237, 255, var(--placeholder-opacity));\n}\n.placeholder-indigo-200::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #cddbfe;\n  color: rgba(205, 219, 254, var(--placeholder-opacity));\n}\n.placeholder-indigo-200::placeholder {\n  --placeholder-opacity: 1;\n  color: #cddbfe;\n  color: rgba(205, 219, 254, var(--placeholder-opacity));\n}\n.placeholder-indigo-300::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #b4c6fc;\n  color: rgba(180, 198, 252, var(--placeholder-opacity));\n}\n.placeholder-indigo-300::placeholder {\n  --placeholder-opacity: 1;\n  color: #b4c6fc;\n  color: rgba(180, 198, 252, var(--placeholder-opacity));\n}\n.placeholder-indigo-400::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #8da2fb;\n  color: rgba(141, 162, 251, var(--placeholder-opacity));\n}\n.placeholder-indigo-400::placeholder {\n  --placeholder-opacity: 1;\n  color: #8da2fb;\n  color: rgba(141, 162, 251, var(--placeholder-opacity));\n}\n.placeholder-indigo-500::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #6875f5;\n  color: rgba(104, 117, 245, var(--placeholder-opacity));\n}\n.placeholder-indigo-500::placeholder {\n  --placeholder-opacity: 1;\n  color: #6875f5;\n  color: rgba(104, 117, 245, var(--placeholder-opacity));\n}\n.placeholder-indigo-600::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #5850ec;\n  color: rgba(88, 80, 236, var(--placeholder-opacity));\n}\n.placeholder-indigo-600::placeholder {\n  --placeholder-opacity: 1;\n  color: #5850ec;\n  color: rgba(88, 80, 236, var(--placeholder-opacity));\n}\n.placeholder-indigo-700::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #5145cd;\n  color: rgba(81, 69, 205, var(--placeholder-opacity));\n}\n.placeholder-indigo-700::placeholder {\n  --placeholder-opacity: 1;\n  color: #5145cd;\n  color: rgba(81, 69, 205, var(--placeholder-opacity));\n}\n.placeholder-indigo-800::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #42389d;\n  color: rgba(66, 56, 157, var(--placeholder-opacity));\n}\n.placeholder-indigo-800::placeholder {\n  --placeholder-opacity: 1;\n  color: #42389d;\n  color: rgba(66, 56, 157, var(--placeholder-opacity));\n}\n.placeholder-indigo-900::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #362f78;\n  color: rgba(54, 47, 120, var(--placeholder-opacity));\n}\n.placeholder-indigo-900::placeholder {\n  --placeholder-opacity: 1;\n  color: #362f78;\n  color: rgba(54, 47, 120, var(--placeholder-opacity));\n}\n.placeholder-purple-50::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #f6f5ff;\n  color: rgba(246, 245, 255, var(--placeholder-opacity));\n}\n.placeholder-purple-50::placeholder {\n  --placeholder-opacity: 1;\n  color: #f6f5ff;\n  color: rgba(246, 245, 255, var(--placeholder-opacity));\n}\n.placeholder-purple-100::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #edebfe;\n  color: rgba(237, 235, 254, var(--placeholder-opacity));\n}\n.placeholder-purple-100::placeholder {\n  --placeholder-opacity: 1;\n  color: #edebfe;\n  color: rgba(237, 235, 254, var(--placeholder-opacity));\n}\n.placeholder-purple-200::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #dcd7fe;\n  color: rgba(220, 215, 254, var(--placeholder-opacity));\n}\n.placeholder-purple-200::placeholder {\n  --placeholder-opacity: 1;\n  color: #dcd7fe;\n  color: rgba(220, 215, 254, var(--placeholder-opacity));\n}\n.placeholder-purple-300::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #cabffd;\n  color: rgba(202, 191, 253, var(--placeholder-opacity));\n}\n.placeholder-purple-300::placeholder {\n  --placeholder-opacity: 1;\n  color: #cabffd;\n  color: rgba(202, 191, 253, var(--placeholder-opacity));\n}\n.placeholder-purple-400::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #ac94fa;\n  color: rgba(172, 148, 250, var(--placeholder-opacity));\n}\n.placeholder-purple-400::placeholder {\n  --placeholder-opacity: 1;\n  color: #ac94fa;\n  color: rgba(172, 148, 250, var(--placeholder-opacity));\n}\n.placeholder-purple-500::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #9061f9;\n  color: rgba(144, 97, 249, var(--placeholder-opacity));\n}\n.placeholder-purple-500::placeholder {\n  --placeholder-opacity: 1;\n  color: #9061f9;\n  color: rgba(144, 97, 249, var(--placeholder-opacity));\n}\n.placeholder-purple-600::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #7e3af2;\n  color: rgba(126, 58, 242, var(--placeholder-opacity));\n}\n.placeholder-purple-600::placeholder {\n  --placeholder-opacity: 1;\n  color: #7e3af2;\n  color: rgba(126, 58, 242, var(--placeholder-opacity));\n}\n.placeholder-purple-700::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #6c2bd9;\n  color: rgba(108, 43, 217, var(--placeholder-opacity));\n}\n.placeholder-purple-700::placeholder {\n  --placeholder-opacity: 1;\n  color: #6c2bd9;\n  color: rgba(108, 43, 217, var(--placeholder-opacity));\n}\n.placeholder-purple-800::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #5521b5;\n  color: rgba(85, 33, 181, var(--placeholder-opacity));\n}\n.placeholder-purple-800::placeholder {\n  --placeholder-opacity: 1;\n  color: #5521b5;\n  color: rgba(85, 33, 181, var(--placeholder-opacity));\n}\n.placeholder-purple-900::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #4a1d96;\n  color: rgba(74, 29, 150, var(--placeholder-opacity));\n}\n.placeholder-purple-900::placeholder {\n  --placeholder-opacity: 1;\n  color: #4a1d96;\n  color: rgba(74, 29, 150, var(--placeholder-opacity));\n}\n.placeholder-pink-50::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #fdf2f8;\n  color: rgba(253, 242, 248, var(--placeholder-opacity));\n}\n.placeholder-pink-50::placeholder {\n  --placeholder-opacity: 1;\n  color: #fdf2f8;\n  color: rgba(253, 242, 248, var(--placeholder-opacity));\n}\n.placeholder-pink-100::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #fce8f3;\n  color: rgba(252, 232, 243, var(--placeholder-opacity));\n}\n.placeholder-pink-100::placeholder {\n  --placeholder-opacity: 1;\n  color: #fce8f3;\n  color: rgba(252, 232, 243, var(--placeholder-opacity));\n}\n.placeholder-pink-200::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #fad1e8;\n  color: rgba(250, 209, 232, var(--placeholder-opacity));\n}\n.placeholder-pink-200::placeholder {\n  --placeholder-opacity: 1;\n  color: #fad1e8;\n  color: rgba(250, 209, 232, var(--placeholder-opacity));\n}\n.placeholder-pink-300::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #f8b4d9;\n  color: rgba(248, 180, 217, var(--placeholder-opacity));\n}\n.placeholder-pink-300::placeholder {\n  --placeholder-opacity: 1;\n  color: #f8b4d9;\n  color: rgba(248, 180, 217, var(--placeholder-opacity));\n}\n.placeholder-pink-400::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #f17eb8;\n  color: rgba(241, 126, 184, var(--placeholder-opacity));\n}\n.placeholder-pink-400::placeholder {\n  --placeholder-opacity: 1;\n  color: #f17eb8;\n  color: rgba(241, 126, 184, var(--placeholder-opacity));\n}\n.placeholder-pink-500::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #e74694;\n  color: rgba(231, 70, 148, var(--placeholder-opacity));\n}\n.placeholder-pink-500::placeholder {\n  --placeholder-opacity: 1;\n  color: #e74694;\n  color: rgba(231, 70, 148, var(--placeholder-opacity));\n}\n.placeholder-pink-600::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #d61f69;\n  color: rgba(214, 31, 105, var(--placeholder-opacity));\n}\n.placeholder-pink-600::placeholder {\n  --placeholder-opacity: 1;\n  color: #d61f69;\n  color: rgba(214, 31, 105, var(--placeholder-opacity));\n}\n.placeholder-pink-700::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #bf125d;\n  color: rgba(191, 18, 93, var(--placeholder-opacity));\n}\n.placeholder-pink-700::placeholder {\n  --placeholder-opacity: 1;\n  color: #bf125d;\n  color: rgba(191, 18, 93, var(--placeholder-opacity));\n}\n.placeholder-pink-800::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #99154b;\n  color: rgba(153, 21, 75, var(--placeholder-opacity));\n}\n.placeholder-pink-800::placeholder {\n  --placeholder-opacity: 1;\n  color: #99154b;\n  color: rgba(153, 21, 75, var(--placeholder-opacity));\n}\n.placeholder-pink-900::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #751a3d;\n  color: rgba(117, 26, 61, var(--placeholder-opacity));\n}\n.placeholder-pink-900::placeholder {\n  --placeholder-opacity: 1;\n  color: #751a3d;\n  color: rgba(117, 26, 61, var(--placeholder-opacity));\n}\n.placeholder-cool-gray-50::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #f8fafc;\n  color: rgba(248, 250, 252, var(--placeholder-opacity));\n}\n.placeholder-cool-gray-50::placeholder {\n  --placeholder-opacity: 1;\n  color: #f8fafc;\n  color: rgba(248, 250, 252, var(--placeholder-opacity));\n}\n.placeholder-cool-gray-100::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #f1f5f9;\n  color: rgba(241, 245, 249, var(--placeholder-opacity));\n}\n.placeholder-cool-gray-100::placeholder {\n  --placeholder-opacity: 1;\n  color: #f1f5f9;\n  color: rgba(241, 245, 249, var(--placeholder-opacity));\n}\n.placeholder-cool-gray-200::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #e2e8f0;\n  color: rgba(226, 232, 240, var(--placeholder-opacity));\n}\n.placeholder-cool-gray-200::placeholder {\n  --placeholder-opacity: 1;\n  color: #e2e8f0;\n  color: rgba(226, 232, 240, var(--placeholder-opacity));\n}\n.placeholder-cool-gray-300::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #cfd8e3;\n  color: rgba(207, 216, 227, var(--placeholder-opacity));\n}\n.placeholder-cool-gray-300::placeholder {\n  --placeholder-opacity: 1;\n  color: #cfd8e3;\n  color: rgba(207, 216, 227, var(--placeholder-opacity));\n}\n.placeholder-cool-gray-400::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #97a6ba;\n  color: rgba(151, 166, 186, var(--placeholder-opacity));\n}\n.placeholder-cool-gray-400::placeholder {\n  --placeholder-opacity: 1;\n  color: #97a6ba;\n  color: rgba(151, 166, 186, var(--placeholder-opacity));\n}\n.placeholder-cool-gray-500::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #64748b;\n  color: rgba(100, 116, 139, var(--placeholder-opacity));\n}\n.placeholder-cool-gray-500::placeholder {\n  --placeholder-opacity: 1;\n  color: #64748b;\n  color: rgba(100, 116, 139, var(--placeholder-opacity));\n}\n.placeholder-cool-gray-600::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #475569;\n  color: rgba(71, 85, 105, var(--placeholder-opacity));\n}\n.placeholder-cool-gray-600::placeholder {\n  --placeholder-opacity: 1;\n  color: #475569;\n  color: rgba(71, 85, 105, var(--placeholder-opacity));\n}\n.placeholder-cool-gray-700::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #364152;\n  color: rgba(54, 65, 82, var(--placeholder-opacity));\n}\n.placeholder-cool-gray-700::placeholder {\n  --placeholder-opacity: 1;\n  color: #364152;\n  color: rgba(54, 65, 82, var(--placeholder-opacity));\n}\n.placeholder-cool-gray-800::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #27303f;\n  color: rgba(39, 48, 63, var(--placeholder-opacity));\n}\n.placeholder-cool-gray-800::placeholder {\n  --placeholder-opacity: 1;\n  color: #27303f;\n  color: rgba(39, 48, 63, var(--placeholder-opacity));\n}\n.placeholder-cool-gray-900::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #1a202e;\n  color: rgba(26, 32, 46, var(--placeholder-opacity));\n}\n.placeholder-cool-gray-900::placeholder {\n  --placeholder-opacity: 1;\n  color: #1a202e;\n  color: rgba(26, 32, 46, var(--placeholder-opacity));\n}\n.focus\\:placeholder-current:focus::-moz-placeholder {\n  color: currentColor;\n}\n.focus\\:placeholder-current:focus::placeholder {\n  color: currentColor;\n}\n.focus\\:placeholder-transparent:focus::-moz-placeholder {\n  color: transparent;\n}\n.focus\\:placeholder-transparent:focus::placeholder {\n  color: transparent;\n}\n.focus\\:placeholder-white:focus::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #ffffff;\n  color: rgba(255, 255, 255, var(--placeholder-opacity));\n}\n.focus\\:placeholder-white:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #ffffff;\n  color: rgba(255, 255, 255, var(--placeholder-opacity));\n}\n.focus\\:placeholder-black:focus::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #000000;\n  color: rgba(0, 0, 0, var(--placeholder-opacity));\n}\n.focus\\:placeholder-black:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #000000;\n  color: rgba(0, 0, 0, var(--placeholder-opacity));\n}\n.focus\\:placeholder-gray-50:focus::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #f9fafb;\n  color: rgba(249, 250, 251, var(--placeholder-opacity));\n}\n.focus\\:placeholder-gray-50:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #f9fafb;\n  color: rgba(249, 250, 251, var(--placeholder-opacity));\n}\n.focus\\:placeholder-gray-100:focus::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #f4f5f7;\n  color: rgba(244, 245, 247, var(--placeholder-opacity));\n}\n.focus\\:placeholder-gray-100:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #f4f5f7;\n  color: rgba(244, 245, 247, var(--placeholder-opacity));\n}\n.focus\\:placeholder-gray-200:focus::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #e5e7eb;\n  color: rgba(229, 231, 235, var(--placeholder-opacity));\n}\n.focus\\:placeholder-gray-200:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #e5e7eb;\n  color: rgba(229, 231, 235, var(--placeholder-opacity));\n}\n.focus\\:placeholder-gray-300:focus::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #d2d6dc;\n  color: rgba(210, 214, 220, var(--placeholder-opacity));\n}\n.focus\\:placeholder-gray-300:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #d2d6dc;\n  color: rgba(210, 214, 220, var(--placeholder-opacity));\n}\n.focus\\:placeholder-gray-400:focus::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #9fa6b2;\n  color: rgba(159, 166, 178, var(--placeholder-opacity));\n}\n.focus\\:placeholder-gray-400:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #9fa6b2;\n  color: rgba(159, 166, 178, var(--placeholder-opacity));\n}\n.focus\\:placeholder-gray-500:focus::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #6b7280;\n  color: rgba(107, 114, 128, var(--placeholder-opacity));\n}\n.focus\\:placeholder-gray-500:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #6b7280;\n  color: rgba(107, 114, 128, var(--placeholder-opacity));\n}\n.focus\\:placeholder-gray-600:focus::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #4b5563;\n  color: rgba(75, 85, 99, var(--placeholder-opacity));\n}\n.focus\\:placeholder-gray-600:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #4b5563;\n  color: rgba(75, 85, 99, var(--placeholder-opacity));\n}\n.focus\\:placeholder-gray-700:focus::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #374151;\n  color: rgba(55, 65, 81, var(--placeholder-opacity));\n}\n.focus\\:placeholder-gray-700:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #374151;\n  color: rgba(55, 65, 81, var(--placeholder-opacity));\n}\n.focus\\:placeholder-gray-800:focus::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #252f3f;\n  color: rgba(37, 47, 63, var(--placeholder-opacity));\n}\n.focus\\:placeholder-gray-800:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #252f3f;\n  color: rgba(37, 47, 63, var(--placeholder-opacity));\n}\n.focus\\:placeholder-gray-900:focus::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #161e2e;\n  color: rgba(22, 30, 46, var(--placeholder-opacity));\n}\n.focus\\:placeholder-gray-900:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #161e2e;\n  color: rgba(22, 30, 46, var(--placeholder-opacity));\n}\n.focus\\:placeholder-red-50:focus::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #fdf2f2;\n  color: rgba(253, 242, 242, var(--placeholder-opacity));\n}\n.focus\\:placeholder-red-50:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #fdf2f2;\n  color: rgba(253, 242, 242, var(--placeholder-opacity));\n}\n.focus\\:placeholder-red-100:focus::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #fde8e8;\n  color: rgba(253, 232, 232, var(--placeholder-opacity));\n}\n.focus\\:placeholder-red-100:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #fde8e8;\n  color: rgba(253, 232, 232, var(--placeholder-opacity));\n}\n.focus\\:placeholder-red-200:focus::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #fbd5d5;\n  color: rgba(251, 213, 213, var(--placeholder-opacity));\n}\n.focus\\:placeholder-red-200:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #fbd5d5;\n  color: rgba(251, 213, 213, var(--placeholder-opacity));\n}\n.focus\\:placeholder-red-300:focus::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #f8b4b4;\n  color: rgba(248, 180, 180, var(--placeholder-opacity));\n}\n.focus\\:placeholder-red-300:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #f8b4b4;\n  color: rgba(248, 180, 180, var(--placeholder-opacity));\n}\n.focus\\:placeholder-red-400:focus::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #f98080;\n  color: rgba(249, 128, 128, var(--placeholder-opacity));\n}\n.focus\\:placeholder-red-400:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #f98080;\n  color: rgba(249, 128, 128, var(--placeholder-opacity));\n}\n.focus\\:placeholder-red-500:focus::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #f05252;\n  color: rgba(240, 82, 82, var(--placeholder-opacity));\n}\n.focus\\:placeholder-red-500:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #f05252;\n  color: rgba(240, 82, 82, var(--placeholder-opacity));\n}\n.focus\\:placeholder-red-600:focus::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #e02424;\n  color: rgba(224, 36, 36, var(--placeholder-opacity));\n}\n.focus\\:placeholder-red-600:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #e02424;\n  color: rgba(224, 36, 36, var(--placeholder-opacity));\n}\n.focus\\:placeholder-red-700:focus::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #c81e1e;\n  color: rgba(200, 30, 30, var(--placeholder-opacity));\n}\n.focus\\:placeholder-red-700:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #c81e1e;\n  color: rgba(200, 30, 30, var(--placeholder-opacity));\n}\n.focus\\:placeholder-red-800:focus::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #9b1c1c;\n  color: rgba(155, 28, 28, var(--placeholder-opacity));\n}\n.focus\\:placeholder-red-800:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #9b1c1c;\n  color: rgba(155, 28, 28, var(--placeholder-opacity));\n}\n.focus\\:placeholder-red-900:focus::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #771d1d;\n  color: rgba(119, 29, 29, var(--placeholder-opacity));\n}\n.focus\\:placeholder-red-900:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #771d1d;\n  color: rgba(119, 29, 29, var(--placeholder-opacity));\n}\n.focus\\:placeholder-orange-50:focus::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #fff8f1;\n  color: rgba(255, 248, 241, var(--placeholder-opacity));\n}\n.focus\\:placeholder-orange-50:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #fff8f1;\n  color: rgba(255, 248, 241, var(--placeholder-opacity));\n}\n.focus\\:placeholder-orange-100:focus::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #feecdc;\n  color: rgba(254, 236, 220, var(--placeholder-opacity));\n}\n.focus\\:placeholder-orange-100:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #feecdc;\n  color: rgba(254, 236, 220, var(--placeholder-opacity));\n}\n.focus\\:placeholder-orange-200:focus::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #fcd9bd;\n  color: rgba(252, 217, 189, var(--placeholder-opacity));\n}\n.focus\\:placeholder-orange-200:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #fcd9bd;\n  color: rgba(252, 217, 189, var(--placeholder-opacity));\n}\n.focus\\:placeholder-orange-300:focus::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #fdba8c;\n  color: rgba(253, 186, 140, var(--placeholder-opacity));\n}\n.focus\\:placeholder-orange-300:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #fdba8c;\n  color: rgba(253, 186, 140, var(--placeholder-opacity));\n}\n.focus\\:placeholder-orange-400:focus::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #ff8a4c;\n  color: rgba(255, 138, 76, var(--placeholder-opacity));\n}\n.focus\\:placeholder-orange-400:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #ff8a4c;\n  color: rgba(255, 138, 76, var(--placeholder-opacity));\n}\n.focus\\:placeholder-orange-500:focus::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #ff5a1f;\n  color: rgba(255, 90, 31, var(--placeholder-opacity));\n}\n.focus\\:placeholder-orange-500:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #ff5a1f;\n  color: rgba(255, 90, 31, var(--placeholder-opacity));\n}\n.focus\\:placeholder-orange-600:focus::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #d03801;\n  color: rgba(208, 56, 1, var(--placeholder-opacity));\n}\n.focus\\:placeholder-orange-600:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #d03801;\n  color: rgba(208, 56, 1, var(--placeholder-opacity));\n}\n.focus\\:placeholder-orange-700:focus::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #b43403;\n  color: rgba(180, 52, 3, var(--placeholder-opacity));\n}\n.focus\\:placeholder-orange-700:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #b43403;\n  color: rgba(180, 52, 3, var(--placeholder-opacity));\n}\n.focus\\:placeholder-orange-800:focus::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #8a2c0d;\n  color: rgba(138, 44, 13, var(--placeholder-opacity));\n}\n.focus\\:placeholder-orange-800:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #8a2c0d;\n  color: rgba(138, 44, 13, var(--placeholder-opacity));\n}\n.focus\\:placeholder-orange-900:focus::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #73230d;\n  color: rgba(115, 35, 13, var(--placeholder-opacity));\n}\n.focus\\:placeholder-orange-900:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #73230d;\n  color: rgba(115, 35, 13, var(--placeholder-opacity));\n}\n.focus\\:placeholder-yellow-50:focus::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #fdfdea;\n  color: rgba(253, 253, 234, var(--placeholder-opacity));\n}\n.focus\\:placeholder-yellow-50:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #fdfdea;\n  color: rgba(253, 253, 234, var(--placeholder-opacity));\n}\n.focus\\:placeholder-yellow-100:focus::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #fdf6b2;\n  color: rgba(253, 246, 178, var(--placeholder-opacity));\n}\n.focus\\:placeholder-yellow-100:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #fdf6b2;\n  color: rgba(253, 246, 178, var(--placeholder-opacity));\n}\n.focus\\:placeholder-yellow-200:focus::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #fce96a;\n  color: rgba(252, 233, 106, var(--placeholder-opacity));\n}\n.focus\\:placeholder-yellow-200:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #fce96a;\n  color: rgba(252, 233, 106, var(--placeholder-opacity));\n}\n.focus\\:placeholder-yellow-300:focus::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #faca15;\n  color: rgba(250, 202, 21, var(--placeholder-opacity));\n}\n.focus\\:placeholder-yellow-300:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #faca15;\n  color: rgba(250, 202, 21, var(--placeholder-opacity));\n}\n.focus\\:placeholder-yellow-400:focus::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #e3a008;\n  color: rgba(227, 160, 8, var(--placeholder-opacity));\n}\n.focus\\:placeholder-yellow-400:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #e3a008;\n  color: rgba(227, 160, 8, var(--placeholder-opacity));\n}\n.focus\\:placeholder-yellow-500:focus::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #c27803;\n  color: rgba(194, 120, 3, var(--placeholder-opacity));\n}\n.focus\\:placeholder-yellow-500:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #c27803;\n  color: rgba(194, 120, 3, var(--placeholder-opacity));\n}\n.focus\\:placeholder-yellow-600:focus::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #9f580a;\n  color: rgba(159, 88, 10, var(--placeholder-opacity));\n}\n.focus\\:placeholder-yellow-600:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #9f580a;\n  color: rgba(159, 88, 10, var(--placeholder-opacity));\n}\n.focus\\:placeholder-yellow-700:focus::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #8e4b10;\n  color: rgba(142, 75, 16, var(--placeholder-opacity));\n}\n.focus\\:placeholder-yellow-700:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #8e4b10;\n  color: rgba(142, 75, 16, var(--placeholder-opacity));\n}\n.focus\\:placeholder-yellow-800:focus::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #723b13;\n  color: rgba(114, 59, 19, var(--placeholder-opacity));\n}\n.focus\\:placeholder-yellow-800:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #723b13;\n  color: rgba(114, 59, 19, var(--placeholder-opacity));\n}\n.focus\\:placeholder-yellow-900:focus::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #633112;\n  color: rgba(99, 49, 18, var(--placeholder-opacity));\n}\n.focus\\:placeholder-yellow-900:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #633112;\n  color: rgba(99, 49, 18, var(--placeholder-opacity));\n}\n.focus\\:placeholder-green-50:focus::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #f3faf7;\n  color: rgba(243, 250, 247, var(--placeholder-opacity));\n}\n.focus\\:placeholder-green-50:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #f3faf7;\n  color: rgba(243, 250, 247, var(--placeholder-opacity));\n}\n.focus\\:placeholder-green-100:focus::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #def7ec;\n  color: rgba(222, 247, 236, var(--placeholder-opacity));\n}\n.focus\\:placeholder-green-100:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #def7ec;\n  color: rgba(222, 247, 236, var(--placeholder-opacity));\n}\n.focus\\:placeholder-green-200:focus::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #bcf0da;\n  color: rgba(188, 240, 218, var(--placeholder-opacity));\n}\n.focus\\:placeholder-green-200:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #bcf0da;\n  color: rgba(188, 240, 218, var(--placeholder-opacity));\n}\n.focus\\:placeholder-green-300:focus::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #84e1bc;\n  color: rgba(132, 225, 188, var(--placeholder-opacity));\n}\n.focus\\:placeholder-green-300:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #84e1bc;\n  color: rgba(132, 225, 188, var(--placeholder-opacity));\n}\n.focus\\:placeholder-green-400:focus::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #31c48d;\n  color: rgba(49, 196, 141, var(--placeholder-opacity));\n}\n.focus\\:placeholder-green-400:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #31c48d;\n  color: rgba(49, 196, 141, var(--placeholder-opacity));\n}\n.focus\\:placeholder-green-500:focus::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #0e9f6e;\n  color: rgba(14, 159, 110, var(--placeholder-opacity));\n}\n.focus\\:placeholder-green-500:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #0e9f6e;\n  color: rgba(14, 159, 110, var(--placeholder-opacity));\n}\n.focus\\:placeholder-green-600:focus::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #057a55;\n  color: rgba(5, 122, 85, var(--placeholder-opacity));\n}\n.focus\\:placeholder-green-600:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #057a55;\n  color: rgba(5, 122, 85, var(--placeholder-opacity));\n}\n.focus\\:placeholder-green-700:focus::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #046c4e;\n  color: rgba(4, 108, 78, var(--placeholder-opacity));\n}\n.focus\\:placeholder-green-700:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #046c4e;\n  color: rgba(4, 108, 78, var(--placeholder-opacity));\n}\n.focus\\:placeholder-green-800:focus::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #03543f;\n  color: rgba(3, 84, 63, var(--placeholder-opacity));\n}\n.focus\\:placeholder-green-800:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #03543f;\n  color: rgba(3, 84, 63, var(--placeholder-opacity));\n}\n.focus\\:placeholder-green-900:focus::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #014737;\n  color: rgba(1, 71, 55, var(--placeholder-opacity));\n}\n.focus\\:placeholder-green-900:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #014737;\n  color: rgba(1, 71, 55, var(--placeholder-opacity));\n}\n.focus\\:placeholder-teal-50:focus::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #edfafa;\n  color: rgba(237, 250, 250, var(--placeholder-opacity));\n}\n.focus\\:placeholder-teal-50:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #edfafa;\n  color: rgba(237, 250, 250, var(--placeholder-opacity));\n}\n.focus\\:placeholder-teal-100:focus::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #d5f5f6;\n  color: rgba(213, 245, 246, var(--placeholder-opacity));\n}\n.focus\\:placeholder-teal-100:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #d5f5f6;\n  color: rgba(213, 245, 246, var(--placeholder-opacity));\n}\n.focus\\:placeholder-teal-200:focus::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #afecef;\n  color: rgba(175, 236, 239, var(--placeholder-opacity));\n}\n.focus\\:placeholder-teal-200:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #afecef;\n  color: rgba(175, 236, 239, var(--placeholder-opacity));\n}\n.focus\\:placeholder-teal-300:focus::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #7edce2;\n  color: rgba(126, 220, 226, var(--placeholder-opacity));\n}\n.focus\\:placeholder-teal-300:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #7edce2;\n  color: rgba(126, 220, 226, var(--placeholder-opacity));\n}\n.focus\\:placeholder-teal-400:focus::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #16bdca;\n  color: rgba(22, 189, 202, var(--placeholder-opacity));\n}\n.focus\\:placeholder-teal-400:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #16bdca;\n  color: rgba(22, 189, 202, var(--placeholder-opacity));\n}\n.focus\\:placeholder-teal-500:focus::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #0694a2;\n  color: rgba(6, 148, 162, var(--placeholder-opacity));\n}\n.focus\\:placeholder-teal-500:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #0694a2;\n  color: rgba(6, 148, 162, var(--placeholder-opacity));\n}\n.focus\\:placeholder-teal-600:focus::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #047481;\n  color: rgba(4, 116, 129, var(--placeholder-opacity));\n}\n.focus\\:placeholder-teal-600:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #047481;\n  color: rgba(4, 116, 129, var(--placeholder-opacity));\n}\n.focus\\:placeholder-teal-700:focus::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #036672;\n  color: rgba(3, 102, 114, var(--placeholder-opacity));\n}\n.focus\\:placeholder-teal-700:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #036672;\n  color: rgba(3, 102, 114, var(--placeholder-opacity));\n}\n.focus\\:placeholder-teal-800:focus::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #05505c;\n  color: rgba(5, 80, 92, var(--placeholder-opacity));\n}\n.focus\\:placeholder-teal-800:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #05505c;\n  color: rgba(5, 80, 92, var(--placeholder-opacity));\n}\n.focus\\:placeholder-teal-900:focus::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #014451;\n  color: rgba(1, 68, 81, var(--placeholder-opacity));\n}\n.focus\\:placeholder-teal-900:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #014451;\n  color: rgba(1, 68, 81, var(--placeholder-opacity));\n}\n.focus\\:placeholder-blue-50:focus::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #ebf5ff;\n  color: rgba(235, 245, 255, var(--placeholder-opacity));\n}\n.focus\\:placeholder-blue-50:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #ebf5ff;\n  color: rgba(235, 245, 255, var(--placeholder-opacity));\n}\n.focus\\:placeholder-blue-100:focus::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #e1effe;\n  color: rgba(225, 239, 254, var(--placeholder-opacity));\n}\n.focus\\:placeholder-blue-100:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #e1effe;\n  color: rgba(225, 239, 254, var(--placeholder-opacity));\n}\n.focus\\:placeholder-blue-200:focus::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #c3ddfd;\n  color: rgba(195, 221, 253, var(--placeholder-opacity));\n}\n.focus\\:placeholder-blue-200:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #c3ddfd;\n  color: rgba(195, 221, 253, var(--placeholder-opacity));\n}\n.focus\\:placeholder-blue-300:focus::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #a4cafe;\n  color: rgba(164, 202, 254, var(--placeholder-opacity));\n}\n.focus\\:placeholder-blue-300:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #a4cafe;\n  color: rgba(164, 202, 254, var(--placeholder-opacity));\n}\n.focus\\:placeholder-blue-400:focus::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #76a9fa;\n  color: rgba(118, 169, 250, var(--placeholder-opacity));\n}\n.focus\\:placeholder-blue-400:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #76a9fa;\n  color: rgba(118, 169, 250, var(--placeholder-opacity));\n}\n.focus\\:placeholder-blue-500:focus::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #3f83f8;\n  color: rgba(63, 131, 248, var(--placeholder-opacity));\n}\n.focus\\:placeholder-blue-500:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #3f83f8;\n  color: rgba(63, 131, 248, var(--placeholder-opacity));\n}\n.focus\\:placeholder-blue-600:focus::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #1c64f2;\n  color: rgba(28, 100, 242, var(--placeholder-opacity));\n}\n.focus\\:placeholder-blue-600:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #1c64f2;\n  color: rgba(28, 100, 242, var(--placeholder-opacity));\n}\n.focus\\:placeholder-blue-700:focus::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #1a56db;\n  color: rgba(26, 86, 219, var(--placeholder-opacity));\n}\n.focus\\:placeholder-blue-700:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #1a56db;\n  color: rgba(26, 86, 219, var(--placeholder-opacity));\n}\n.focus\\:placeholder-blue-800:focus::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #1e429f;\n  color: rgba(30, 66, 159, var(--placeholder-opacity));\n}\n.focus\\:placeholder-blue-800:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #1e429f;\n  color: rgba(30, 66, 159, var(--placeholder-opacity));\n}\n.focus\\:placeholder-blue-900:focus::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #233876;\n  color: rgba(35, 56, 118, var(--placeholder-opacity));\n}\n.focus\\:placeholder-blue-900:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #233876;\n  color: rgba(35, 56, 118, var(--placeholder-opacity));\n}\n.focus\\:placeholder-indigo-50:focus::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #f0f5ff;\n  color: rgba(240, 245, 255, var(--placeholder-opacity));\n}\n.focus\\:placeholder-indigo-50:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #f0f5ff;\n  color: rgba(240, 245, 255, var(--placeholder-opacity));\n}\n.focus\\:placeholder-indigo-100:focus::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #e5edff;\n  color: rgba(229, 237, 255, var(--placeholder-opacity));\n}\n.focus\\:placeholder-indigo-100:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #e5edff;\n  color: rgba(229, 237, 255, var(--placeholder-opacity));\n}\n.focus\\:placeholder-indigo-200:focus::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #cddbfe;\n  color: rgba(205, 219, 254, var(--placeholder-opacity));\n}\n.focus\\:placeholder-indigo-200:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #cddbfe;\n  color: rgba(205, 219, 254, var(--placeholder-opacity));\n}\n.focus\\:placeholder-indigo-300:focus::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #b4c6fc;\n  color: rgba(180, 198, 252, var(--placeholder-opacity));\n}\n.focus\\:placeholder-indigo-300:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #b4c6fc;\n  color: rgba(180, 198, 252, var(--placeholder-opacity));\n}\n.focus\\:placeholder-indigo-400:focus::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #8da2fb;\n  color: rgba(141, 162, 251, var(--placeholder-opacity));\n}\n.focus\\:placeholder-indigo-400:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #8da2fb;\n  color: rgba(141, 162, 251, var(--placeholder-opacity));\n}\n.focus\\:placeholder-indigo-500:focus::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #6875f5;\n  color: rgba(104, 117, 245, var(--placeholder-opacity));\n}\n.focus\\:placeholder-indigo-500:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #6875f5;\n  color: rgba(104, 117, 245, var(--placeholder-opacity));\n}\n.focus\\:placeholder-indigo-600:focus::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #5850ec;\n  color: rgba(88, 80, 236, var(--placeholder-opacity));\n}\n.focus\\:placeholder-indigo-600:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #5850ec;\n  color: rgba(88, 80, 236, var(--placeholder-opacity));\n}\n.focus\\:placeholder-indigo-700:focus::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #5145cd;\n  color: rgba(81, 69, 205, var(--placeholder-opacity));\n}\n.focus\\:placeholder-indigo-700:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #5145cd;\n  color: rgba(81, 69, 205, var(--placeholder-opacity));\n}\n.focus\\:placeholder-indigo-800:focus::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #42389d;\n  color: rgba(66, 56, 157, var(--placeholder-opacity));\n}\n.focus\\:placeholder-indigo-800:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #42389d;\n  color: rgba(66, 56, 157, var(--placeholder-opacity));\n}\n.focus\\:placeholder-indigo-900:focus::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #362f78;\n  color: rgba(54, 47, 120, var(--placeholder-opacity));\n}\n.focus\\:placeholder-indigo-900:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #362f78;\n  color: rgba(54, 47, 120, var(--placeholder-opacity));\n}\n.focus\\:placeholder-purple-50:focus::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #f6f5ff;\n  color: rgba(246, 245, 255, var(--placeholder-opacity));\n}\n.focus\\:placeholder-purple-50:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #f6f5ff;\n  color: rgba(246, 245, 255, var(--placeholder-opacity));\n}\n.focus\\:placeholder-purple-100:focus::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #edebfe;\n  color: rgba(237, 235, 254, var(--placeholder-opacity));\n}\n.focus\\:placeholder-purple-100:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #edebfe;\n  color: rgba(237, 235, 254, var(--placeholder-opacity));\n}\n.focus\\:placeholder-purple-200:focus::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #dcd7fe;\n  color: rgba(220, 215, 254, var(--placeholder-opacity));\n}\n.focus\\:placeholder-purple-200:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #dcd7fe;\n  color: rgba(220, 215, 254, var(--placeholder-opacity));\n}\n.focus\\:placeholder-purple-300:focus::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #cabffd;\n  color: rgba(202, 191, 253, var(--placeholder-opacity));\n}\n.focus\\:placeholder-purple-300:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #cabffd;\n  color: rgba(202, 191, 253, var(--placeholder-opacity));\n}\n.focus\\:placeholder-purple-400:focus::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #ac94fa;\n  color: rgba(172, 148, 250, var(--placeholder-opacity));\n}\n.focus\\:placeholder-purple-400:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #ac94fa;\n  color: rgba(172, 148, 250, var(--placeholder-opacity));\n}\n.focus\\:placeholder-purple-500:focus::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #9061f9;\n  color: rgba(144, 97, 249, var(--placeholder-opacity));\n}\n.focus\\:placeholder-purple-500:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #9061f9;\n  color: rgba(144, 97, 249, var(--placeholder-opacity));\n}\n.focus\\:placeholder-purple-600:focus::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #7e3af2;\n  color: rgba(126, 58, 242, var(--placeholder-opacity));\n}\n.focus\\:placeholder-purple-600:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #7e3af2;\n  color: rgba(126, 58, 242, var(--placeholder-opacity));\n}\n.focus\\:placeholder-purple-700:focus::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #6c2bd9;\n  color: rgba(108, 43, 217, var(--placeholder-opacity));\n}\n.focus\\:placeholder-purple-700:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #6c2bd9;\n  color: rgba(108, 43, 217, var(--placeholder-opacity));\n}\n.focus\\:placeholder-purple-800:focus::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #5521b5;\n  color: rgba(85, 33, 181, var(--placeholder-opacity));\n}\n.focus\\:placeholder-purple-800:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #5521b5;\n  color: rgba(85, 33, 181, var(--placeholder-opacity));\n}\n.focus\\:placeholder-purple-900:focus::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #4a1d96;\n  color: rgba(74, 29, 150, var(--placeholder-opacity));\n}\n.focus\\:placeholder-purple-900:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #4a1d96;\n  color: rgba(74, 29, 150, var(--placeholder-opacity));\n}\n.focus\\:placeholder-pink-50:focus::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #fdf2f8;\n  color: rgba(253, 242, 248, var(--placeholder-opacity));\n}\n.focus\\:placeholder-pink-50:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #fdf2f8;\n  color: rgba(253, 242, 248, var(--placeholder-opacity));\n}\n.focus\\:placeholder-pink-100:focus::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #fce8f3;\n  color: rgba(252, 232, 243, var(--placeholder-opacity));\n}\n.focus\\:placeholder-pink-100:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #fce8f3;\n  color: rgba(252, 232, 243, var(--placeholder-opacity));\n}\n.focus\\:placeholder-pink-200:focus::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #fad1e8;\n  color: rgba(250, 209, 232, var(--placeholder-opacity));\n}\n.focus\\:placeholder-pink-200:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #fad1e8;\n  color: rgba(250, 209, 232, var(--placeholder-opacity));\n}\n.focus\\:placeholder-pink-300:focus::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #f8b4d9;\n  color: rgba(248, 180, 217, var(--placeholder-opacity));\n}\n.focus\\:placeholder-pink-300:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #f8b4d9;\n  color: rgba(248, 180, 217, var(--placeholder-opacity));\n}\n.focus\\:placeholder-pink-400:focus::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #f17eb8;\n  color: rgba(241, 126, 184, var(--placeholder-opacity));\n}\n.focus\\:placeholder-pink-400:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #f17eb8;\n  color: rgba(241, 126, 184, var(--placeholder-opacity));\n}\n.focus\\:placeholder-pink-500:focus::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #e74694;\n  color: rgba(231, 70, 148, var(--placeholder-opacity));\n}\n.focus\\:placeholder-pink-500:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #e74694;\n  color: rgba(231, 70, 148, var(--placeholder-opacity));\n}\n.focus\\:placeholder-pink-600:focus::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #d61f69;\n  color: rgba(214, 31, 105, var(--placeholder-opacity));\n}\n.focus\\:placeholder-pink-600:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #d61f69;\n  color: rgba(214, 31, 105, var(--placeholder-opacity));\n}\n.focus\\:placeholder-pink-700:focus::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #bf125d;\n  color: rgba(191, 18, 93, var(--placeholder-opacity));\n}\n.focus\\:placeholder-pink-700:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #bf125d;\n  color: rgba(191, 18, 93, var(--placeholder-opacity));\n}\n.focus\\:placeholder-pink-800:focus::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #99154b;\n  color: rgba(153, 21, 75, var(--placeholder-opacity));\n}\n.focus\\:placeholder-pink-800:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #99154b;\n  color: rgba(153, 21, 75, var(--placeholder-opacity));\n}\n.focus\\:placeholder-pink-900:focus::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #751a3d;\n  color: rgba(117, 26, 61, var(--placeholder-opacity));\n}\n.focus\\:placeholder-pink-900:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #751a3d;\n  color: rgba(117, 26, 61, var(--placeholder-opacity));\n}\n.focus\\:placeholder-cool-gray-50:focus::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #f8fafc;\n  color: rgba(248, 250, 252, var(--placeholder-opacity));\n}\n.focus\\:placeholder-cool-gray-50:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #f8fafc;\n  color: rgba(248, 250, 252, var(--placeholder-opacity));\n}\n.focus\\:placeholder-cool-gray-100:focus::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #f1f5f9;\n  color: rgba(241, 245, 249, var(--placeholder-opacity));\n}\n.focus\\:placeholder-cool-gray-100:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #f1f5f9;\n  color: rgba(241, 245, 249, var(--placeholder-opacity));\n}\n.focus\\:placeholder-cool-gray-200:focus::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #e2e8f0;\n  color: rgba(226, 232, 240, var(--placeholder-opacity));\n}\n.focus\\:placeholder-cool-gray-200:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #e2e8f0;\n  color: rgba(226, 232, 240, var(--placeholder-opacity));\n}\n.focus\\:placeholder-cool-gray-300:focus::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #cfd8e3;\n  color: rgba(207, 216, 227, var(--placeholder-opacity));\n}\n.focus\\:placeholder-cool-gray-300:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #cfd8e3;\n  color: rgba(207, 216, 227, var(--placeholder-opacity));\n}\n.focus\\:placeholder-cool-gray-400:focus::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #97a6ba;\n  color: rgba(151, 166, 186, var(--placeholder-opacity));\n}\n.focus\\:placeholder-cool-gray-400:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #97a6ba;\n  color: rgba(151, 166, 186, var(--placeholder-opacity));\n}\n.focus\\:placeholder-cool-gray-500:focus::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #64748b;\n  color: rgba(100, 116, 139, var(--placeholder-opacity));\n}\n.focus\\:placeholder-cool-gray-500:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #64748b;\n  color: rgba(100, 116, 139, var(--placeholder-opacity));\n}\n.focus\\:placeholder-cool-gray-600:focus::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #475569;\n  color: rgba(71, 85, 105, var(--placeholder-opacity));\n}\n.focus\\:placeholder-cool-gray-600:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #475569;\n  color: rgba(71, 85, 105, var(--placeholder-opacity));\n}\n.focus\\:placeholder-cool-gray-700:focus::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #364152;\n  color: rgba(54, 65, 82, var(--placeholder-opacity));\n}\n.focus\\:placeholder-cool-gray-700:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #364152;\n  color: rgba(54, 65, 82, var(--placeholder-opacity));\n}\n.focus\\:placeholder-cool-gray-800:focus::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #27303f;\n  color: rgba(39, 48, 63, var(--placeholder-opacity));\n}\n.focus\\:placeholder-cool-gray-800:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #27303f;\n  color: rgba(39, 48, 63, var(--placeholder-opacity));\n}\n.focus\\:placeholder-cool-gray-900:focus::-moz-placeholder {\n  --placeholder-opacity: 1;\n  color: #1a202e;\n  color: rgba(26, 32, 46, var(--placeholder-opacity));\n}\n.focus\\:placeholder-cool-gray-900:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #1a202e;\n  color: rgba(26, 32, 46, var(--placeholder-opacity));\n}\n.placeholder-opacity-0::-moz-placeholder {\n  --placeholder-opacity: 0;\n}\n.placeholder-opacity-0::placeholder {\n  --placeholder-opacity: 0;\n}\n.placeholder-opacity-25::-moz-placeholder {\n  --placeholder-opacity: 0.25;\n}\n.placeholder-opacity-25::placeholder {\n  --placeholder-opacity: 0.25;\n}\n.placeholder-opacity-50::-moz-placeholder {\n  --placeholder-opacity: 0.5;\n}\n.placeholder-opacity-50::placeholder {\n  --placeholder-opacity: 0.5;\n}\n.placeholder-opacity-75::-moz-placeholder {\n  --placeholder-opacity: 0.75;\n}\n.placeholder-opacity-75::placeholder {\n  --placeholder-opacity: 0.75;\n}\n.placeholder-opacity-100::-moz-placeholder {\n  --placeholder-opacity: 1;\n}\n.placeholder-opacity-100::placeholder {\n  --placeholder-opacity: 1;\n}\n.focus\\:placeholder-opacity-0:focus::-moz-placeholder {\n  --placeholder-opacity: 0;\n}\n.focus\\:placeholder-opacity-0:focus::placeholder {\n  --placeholder-opacity: 0;\n}\n.focus\\:placeholder-opacity-25:focus::-moz-placeholder {\n  --placeholder-opacity: 0.25;\n}\n.focus\\:placeholder-opacity-25:focus::placeholder {\n  --placeholder-opacity: 0.25;\n}\n.focus\\:placeholder-opacity-50:focus::-moz-placeholder {\n  --placeholder-opacity: 0.5;\n}\n.focus\\:placeholder-opacity-50:focus::placeholder {\n  --placeholder-opacity: 0.5;\n}\n.focus\\:placeholder-opacity-75:focus::-moz-placeholder {\n  --placeholder-opacity: 0.75;\n}\n.focus\\:placeholder-opacity-75:focus::placeholder {\n  --placeholder-opacity: 0.75;\n}\n.focus\\:placeholder-opacity-100:focus::-moz-placeholder {\n  --placeholder-opacity: 1;\n}\n.focus\\:placeholder-opacity-100:focus::placeholder {\n  --placeholder-opacity: 1;\n}\n.pointer-events-none {\n  pointer-events: none;\n}\n.pointer-events-auto {\n  pointer-events: auto;\n}\n.static {\n  position: static;\n}\n.fixed {\n  position: fixed;\n}\n.absolute {\n  position: absolute;\n}\n.relative {\n  position: relative;\n}\n.sticky {\n  position: sticky;\n}\n.inset-0 {\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n}\n.inset-1 {\n  top: 0.25rem;\n  right: 0.25rem;\n  bottom: 0.25rem;\n  left: 0.25rem;\n}\n.inset-2 {\n  top: 0.5rem;\n  right: 0.5rem;\n  bottom: 0.5rem;\n  left: 0.5rem;\n}\n.inset-3 {\n  top: 0.75rem;\n  right: 0.75rem;\n  bottom: 0.75rem;\n  left: 0.75rem;\n}\n.inset-4 {\n  top: 1rem;\n  right: 1rem;\n  bottom: 1rem;\n  left: 1rem;\n}\n.inset-5 {\n  top: 1.25rem;\n  right: 1.25rem;\n  bottom: 1.25rem;\n  left: 1.25rem;\n}\n.inset-6 {\n  top: 1.5rem;\n  right: 1.5rem;\n  bottom: 1.5rem;\n  left: 1.5rem;\n}\n.inset-7 {\n  top: 1.75rem;\n  right: 1.75rem;\n  bottom: 1.75rem;\n  left: 1.75rem;\n}\n.inset-8 {\n  top: 2rem;\n  right: 2rem;\n  bottom: 2rem;\n  left: 2rem;\n}\n.inset-9 {\n  top: 2.25rem;\n  right: 2.25rem;\n  bottom: 2.25rem;\n  left: 2.25rem;\n}\n.inset-10 {\n  top: 2.5rem;\n  right: 2.5rem;\n  bottom: 2.5rem;\n  left: 2.5rem;\n}\n.inset-11 {\n  top: 2.75rem;\n  right: 2.75rem;\n  bottom: 2.75rem;\n  left: 2.75rem;\n}\n.inset-12 {\n  top: 3rem;\n  right: 3rem;\n  bottom: 3rem;\n  left: 3rem;\n}\n.inset-13 {\n  top: 3.25rem;\n  right: 3.25rem;\n  bottom: 3.25rem;\n  left: 3.25rem;\n}\n.inset-14 {\n  top: 3.5rem;\n  right: 3.5rem;\n  bottom: 3.5rem;\n  left: 3.5rem;\n}\n.inset-15 {\n  top: 3.75rem;\n  right: 3.75rem;\n  bottom: 3.75rem;\n  left: 3.75rem;\n}\n.inset-16 {\n  top: 4rem;\n  right: 4rem;\n  bottom: 4rem;\n  left: 4rem;\n}\n.inset-20 {\n  top: 5rem;\n  right: 5rem;\n  bottom: 5rem;\n  left: 5rem;\n}\n.inset-24 {\n  top: 6rem;\n  right: 6rem;\n  bottom: 6rem;\n  left: 6rem;\n}\n.inset-28 {\n  top: 7rem;\n  right: 7rem;\n  bottom: 7rem;\n  left: 7rem;\n}\n.inset-32 {\n  top: 8rem;\n  right: 8rem;\n  bottom: 8rem;\n  left: 8rem;\n}\n.inset-36 {\n  top: 9rem;\n  right: 9rem;\n  bottom: 9rem;\n  left: 9rem;\n}\n.inset-40 {\n  top: 10rem;\n  right: 10rem;\n  bottom: 10rem;\n  left: 10rem;\n}\n.inset-44 {\n  top: 11rem;\n  right: 11rem;\n  bottom: 11rem;\n  left: 11rem;\n}\n.inset-48 {\n  top: 12rem;\n  right: 12rem;\n  bottom: 12rem;\n  left: 12rem;\n}\n.inset-52 {\n  top: 13rem;\n  right: 13rem;\n  bottom: 13rem;\n  left: 13rem;\n}\n.inset-56 {\n  top: 14rem;\n  right: 14rem;\n  bottom: 14rem;\n  left: 14rem;\n}\n.inset-60 {\n  top: 15rem;\n  right: 15rem;\n  bottom: 15rem;\n  left: 15rem;\n}\n.inset-64 {\n  top: 16rem;\n  right: 16rem;\n  bottom: 16rem;\n  left: 16rem;\n}\n.inset-72 {\n  top: 18rem;\n  right: 18rem;\n  bottom: 18rem;\n  left: 18rem;\n}\n.inset-80 {\n  top: 20rem;\n  right: 20rem;\n  bottom: 20rem;\n  left: 20rem;\n}\n.inset-96 {\n  top: 24rem;\n  right: 24rem;\n  bottom: 24rem;\n  left: 24rem;\n}\n.inset-auto {\n  top: auto;\n  right: auto;\n  bottom: auto;\n  left: auto;\n}\n.inset-px {\n  top: 1px;\n  right: 1px;\n  bottom: 1px;\n  left: 1px;\n}\n.inset-0\\.5 {\n  top: 0.125rem;\n  right: 0.125rem;\n  bottom: 0.125rem;\n  left: 0.125rem;\n}\n.inset-1\\.5 {\n  top: 0.375rem;\n  right: 0.375rem;\n  bottom: 0.375rem;\n  left: 0.375rem;\n}\n.inset-2\\.5 {\n  top: 0.625rem;\n  right: 0.625rem;\n  bottom: 0.625rem;\n  left: 0.625rem;\n}\n.inset-3\\.5 {\n  top: 0.875rem;\n  right: 0.875rem;\n  bottom: 0.875rem;\n  left: 0.875rem;\n}\n.inset-1\\/2 {\n  top: 50%;\n  right: 50%;\n  bottom: 50%;\n  left: 50%;\n}\n.inset-1\\/3 {\n  top: 33.333333%;\n  right: 33.333333%;\n  bottom: 33.333333%;\n  left: 33.333333%;\n}\n.inset-2\\/3 {\n  top: 66.666667%;\n  right: 66.666667%;\n  bottom: 66.666667%;\n  left: 66.666667%;\n}\n.inset-1\\/4 {\n  top: 25%;\n  right: 25%;\n  bottom: 25%;\n  left: 25%;\n}\n.inset-2\\/4 {\n  top: 50%;\n  right: 50%;\n  bottom: 50%;\n  left: 50%;\n}\n.inset-3\\/4 {\n  top: 75%;\n  right: 75%;\n  bottom: 75%;\n  left: 75%;\n}\n.inset-1\\/5 {\n  top: 20%;\n  right: 20%;\n  bottom: 20%;\n  left: 20%;\n}\n.inset-2\\/5 {\n  top: 40%;\n  right: 40%;\n  bottom: 40%;\n  left: 40%;\n}\n.inset-3\\/5 {\n  top: 60%;\n  right: 60%;\n  bottom: 60%;\n  left: 60%;\n}\n.inset-4\\/5 {\n  top: 80%;\n  right: 80%;\n  bottom: 80%;\n  left: 80%;\n}\n.inset-1\\/6 {\n  top: 16.666667%;\n  right: 16.666667%;\n  bottom: 16.666667%;\n  left: 16.666667%;\n}\n.inset-2\\/6 {\n  top: 33.333333%;\n  right: 33.333333%;\n  bottom: 33.333333%;\n  left: 33.333333%;\n}\n.inset-3\\/6 {\n  top: 50%;\n  right: 50%;\n  bottom: 50%;\n  left: 50%;\n}\n.inset-4\\/6 {\n  top: 66.666667%;\n  right: 66.666667%;\n  bottom: 66.666667%;\n  left: 66.666667%;\n}\n.inset-5\\/6 {\n  top: 83.333333%;\n  right: 83.333333%;\n  bottom: 83.333333%;\n  left: 83.333333%;\n}\n.inset-1\\/12 {\n  top: 8.333333%;\n  right: 8.333333%;\n  bottom: 8.333333%;\n  left: 8.333333%;\n}\n.inset-2\\/12 {\n  top: 16.666667%;\n  right: 16.666667%;\n  bottom: 16.666667%;\n  left: 16.666667%;\n}\n.inset-3\\/12 {\n  top: 25%;\n  right: 25%;\n  bottom: 25%;\n  left: 25%;\n}\n.inset-4\\/12 {\n  top: 33.333333%;\n  right: 33.333333%;\n  bottom: 33.333333%;\n  left: 33.333333%;\n}\n.inset-5\\/12 {\n  top: 41.666667%;\n  right: 41.666667%;\n  bottom: 41.666667%;\n  left: 41.666667%;\n}\n.inset-6\\/12 {\n  top: 50%;\n  right: 50%;\n  bottom: 50%;\n  left: 50%;\n}\n.inset-7\\/12 {\n  top: 58.333333%;\n  right: 58.333333%;\n  bottom: 58.333333%;\n  left: 58.333333%;\n}\n.inset-8\\/12 {\n  top: 66.666667%;\n  right: 66.666667%;\n  bottom: 66.666667%;\n  left: 66.666667%;\n}\n.inset-9\\/12 {\n  top: 75%;\n  right: 75%;\n  bottom: 75%;\n  left: 75%;\n}\n.inset-10\\/12 {\n  top: 83.333333%;\n  right: 83.333333%;\n  bottom: 83.333333%;\n  left: 83.333333%;\n}\n.inset-11\\/12 {\n  top: 91.666667%;\n  right: 91.666667%;\n  bottom: 91.666667%;\n  left: 91.666667%;\n}\n.inset-full {\n  top: 100%;\n  right: 100%;\n  bottom: 100%;\n  left: 100%;\n}\n.inset-y-0 {\n  top: 0;\n  bottom: 0;\n}\n.inset-x-0 {\n  right: 0;\n  left: 0;\n}\n.inset-y-1 {\n  top: 0.25rem;\n  bottom: 0.25rem;\n}\n.inset-x-1 {\n  right: 0.25rem;\n  left: 0.25rem;\n}\n.inset-y-2 {\n  top: 0.5rem;\n  bottom: 0.5rem;\n}\n.inset-x-2 {\n  right: 0.5rem;\n  left: 0.5rem;\n}\n.inset-y-3 {\n  top: 0.75rem;\n  bottom: 0.75rem;\n}\n.inset-x-3 {\n  right: 0.75rem;\n  left: 0.75rem;\n}\n.inset-y-4 {\n  top: 1rem;\n  bottom: 1rem;\n}\n.inset-x-4 {\n  right: 1rem;\n  left: 1rem;\n}\n.inset-y-5 {\n  top: 1.25rem;\n  bottom: 1.25rem;\n}\n.inset-x-5 {\n  right: 1.25rem;\n  left: 1.25rem;\n}\n.inset-y-6 {\n  top: 1.5rem;\n  bottom: 1.5rem;\n}\n.inset-x-6 {\n  right: 1.5rem;\n  left: 1.5rem;\n}\n.inset-y-7 {\n  top: 1.75rem;\n  bottom: 1.75rem;\n}\n.inset-x-7 {\n  right: 1.75rem;\n  left: 1.75rem;\n}\n.inset-y-8 {\n  top: 2rem;\n  bottom: 2rem;\n}\n.inset-x-8 {\n  right: 2rem;\n  left: 2rem;\n}\n.inset-y-9 {\n  top: 2.25rem;\n  bottom: 2.25rem;\n}\n.inset-x-9 {\n  right: 2.25rem;\n  left: 2.25rem;\n}\n.inset-y-10 {\n  top: 2.5rem;\n  bottom: 2.5rem;\n}\n.inset-x-10 {\n  right: 2.5rem;\n  left: 2.5rem;\n}\n.inset-y-11 {\n  top: 2.75rem;\n  bottom: 2.75rem;\n}\n.inset-x-11 {\n  right: 2.75rem;\n  left: 2.75rem;\n}\n.inset-y-12 {\n  top: 3rem;\n  bottom: 3rem;\n}\n.inset-x-12 {\n  right: 3rem;\n  left: 3rem;\n}\n.inset-y-13 {\n  top: 3.25rem;\n  bottom: 3.25rem;\n}\n.inset-x-13 {\n  right: 3.25rem;\n  left: 3.25rem;\n}\n.inset-y-14 {\n  top: 3.5rem;\n  bottom: 3.5rem;\n}\n.inset-x-14 {\n  right: 3.5rem;\n  left: 3.5rem;\n}\n.inset-y-15 {\n  top: 3.75rem;\n  bottom: 3.75rem;\n}\n.inset-x-15 {\n  right: 3.75rem;\n  left: 3.75rem;\n}\n.inset-y-16 {\n  top: 4rem;\n  bottom: 4rem;\n}\n.inset-x-16 {\n  right: 4rem;\n  left: 4rem;\n}\n.inset-y-20 {\n  top: 5rem;\n  bottom: 5rem;\n}\n.inset-x-20 {\n  right: 5rem;\n  left: 5rem;\n}\n.inset-y-24 {\n  top: 6rem;\n  bottom: 6rem;\n}\n.inset-x-24 {\n  right: 6rem;\n  left: 6rem;\n}\n.inset-y-28 {\n  top: 7rem;\n  bottom: 7rem;\n}\n.inset-x-28 {\n  right: 7rem;\n  left: 7rem;\n}\n.inset-y-32 {\n  top: 8rem;\n  bottom: 8rem;\n}\n.inset-x-32 {\n  right: 8rem;\n  left: 8rem;\n}\n.inset-y-36 {\n  top: 9rem;\n  bottom: 9rem;\n}\n.inset-x-36 {\n  right: 9rem;\n  left: 9rem;\n}\n.inset-y-40 {\n  top: 10rem;\n  bottom: 10rem;\n}\n.inset-x-40 {\n  right: 10rem;\n  left: 10rem;\n}\n.inset-y-44 {\n  top: 11rem;\n  bottom: 11rem;\n}\n.inset-x-44 {\n  right: 11rem;\n  left: 11rem;\n}\n.inset-y-48 {\n  top: 12rem;\n  bottom: 12rem;\n}\n.inset-x-48 {\n  right: 12rem;\n  left: 12rem;\n}\n.inset-y-52 {\n  top: 13rem;\n  bottom: 13rem;\n}\n.inset-x-52 {\n  right: 13rem;\n  left: 13rem;\n}\n.inset-y-56 {\n  top: 14rem;\n  bottom: 14rem;\n}\n.inset-x-56 {\n  right: 14rem;\n  left: 14rem;\n}\n.inset-y-60 {\n  top: 15rem;\n  bottom: 15rem;\n}\n.inset-x-60 {\n  right: 15rem;\n  left: 15rem;\n}\n.inset-y-64 {\n  top: 16rem;\n  bottom: 16rem;\n}\n.inset-x-64 {\n  right: 16rem;\n  left: 16rem;\n}\n.inset-y-72 {\n  top: 18rem;\n  bottom: 18rem;\n}\n.inset-x-72 {\n  right: 18rem;\n  left: 18rem;\n}\n.inset-y-80 {\n  top: 20rem;\n  bottom: 20rem;\n}\n.inset-x-80 {\n  right: 20rem;\n  left: 20rem;\n}\n.inset-y-96 {\n  top: 24rem;\n  bottom: 24rem;\n}\n.inset-x-96 {\n  right: 24rem;\n  left: 24rem;\n}\n.inset-y-auto {\n  top: auto;\n  bottom: auto;\n}\n.inset-x-auto {\n  right: auto;\n  left: auto;\n}\n.inset-y-px {\n  top: 1px;\n  bottom: 1px;\n}\n.inset-x-px {\n  right: 1px;\n  left: 1px;\n}\n.inset-y-0\\.5 {\n  top: 0.125rem;\n  bottom: 0.125rem;\n}\n.inset-x-0\\.5 {\n  right: 0.125rem;\n  left: 0.125rem;\n}\n.inset-y-1\\.5 {\n  top: 0.375rem;\n  bottom: 0.375rem;\n}\n.inset-x-1\\.5 {\n  right: 0.375rem;\n  left: 0.375rem;\n}\n.inset-y-2\\.5 {\n  top: 0.625rem;\n  bottom: 0.625rem;\n}\n.inset-x-2\\.5 {\n  right: 0.625rem;\n  left: 0.625rem;\n}\n.inset-y-3\\.5 {\n  top: 0.875rem;\n  bottom: 0.875rem;\n}\n.inset-x-3\\.5 {\n  right: 0.875rem;\n  left: 0.875rem;\n}\n.inset-y-1\\/2 {\n  top: 50%;\n  bottom: 50%;\n}\n.inset-x-1\\/2 {\n  right: 50%;\n  left: 50%;\n}\n.inset-y-1\\/3 {\n  top: 33.333333%;\n  bottom: 33.333333%;\n}\n.inset-x-1\\/3 {\n  right: 33.333333%;\n  left: 33.333333%;\n}\n.inset-y-2\\/3 {\n  top: 66.666667%;\n  bottom: 66.666667%;\n}\n.inset-x-2\\/3 {\n  right: 66.666667%;\n  left: 66.666667%;\n}\n.inset-y-1\\/4 {\n  top: 25%;\n  bottom: 25%;\n}\n.inset-x-1\\/4 {\n  right: 25%;\n  left: 25%;\n}\n.inset-y-2\\/4 {\n  top: 50%;\n  bottom: 50%;\n}\n.inset-x-2\\/4 {\n  right: 50%;\n  left: 50%;\n}\n.inset-y-3\\/4 {\n  top: 75%;\n  bottom: 75%;\n}\n.inset-x-3\\/4 {\n  right: 75%;\n  left: 75%;\n}\n.inset-y-1\\/5 {\n  top: 20%;\n  bottom: 20%;\n}\n.inset-x-1\\/5 {\n  right: 20%;\n  left: 20%;\n}\n.inset-y-2\\/5 {\n  top: 40%;\n  bottom: 40%;\n}\n.inset-x-2\\/5 {\n  right: 40%;\n  left: 40%;\n}\n.inset-y-3\\/5 {\n  top: 60%;\n  bottom: 60%;\n}\n.inset-x-3\\/5 {\n  right: 60%;\n  left: 60%;\n}\n.inset-y-4\\/5 {\n  top: 80%;\n  bottom: 80%;\n}\n.inset-x-4\\/5 {\n  right: 80%;\n  left: 80%;\n}\n.inset-y-1\\/6 {\n  top: 16.666667%;\n  bottom: 16.666667%;\n}\n.inset-x-1\\/6 {\n  right: 16.666667%;\n  left: 16.666667%;\n}\n.inset-y-2\\/6 {\n  top: 33.333333%;\n  bottom: 33.333333%;\n}\n.inset-x-2\\/6 {\n  right: 33.333333%;\n  left: 33.333333%;\n}\n.inset-y-3\\/6 {\n  top: 50%;\n  bottom: 50%;\n}\n.inset-x-3\\/6 {\n  right: 50%;\n  left: 50%;\n}\n.inset-y-4\\/6 {\n  top: 66.666667%;\n  bottom: 66.666667%;\n}\n.inset-x-4\\/6 {\n  right: 66.666667%;\n  left: 66.666667%;\n}\n.inset-y-5\\/6 {\n  top: 83.333333%;\n  bottom: 83.333333%;\n}\n.inset-x-5\\/6 {\n  right: 83.333333%;\n  left: 83.333333%;\n}\n.inset-y-1\\/12 {\n  top: 8.333333%;\n  bottom: 8.333333%;\n}\n.inset-x-1\\/12 {\n  right: 8.333333%;\n  left: 8.333333%;\n}\n.inset-y-2\\/12 {\n  top: 16.666667%;\n  bottom: 16.666667%;\n}\n.inset-x-2\\/12 {\n  right: 16.666667%;\n  left: 16.666667%;\n}\n.inset-y-3\\/12 {\n  top: 25%;\n  bottom: 25%;\n}\n.inset-x-3\\/12 {\n  right: 25%;\n  left: 25%;\n}\n.inset-y-4\\/12 {\n  top: 33.333333%;\n  bottom: 33.333333%;\n}\n.inset-x-4\\/12 {\n  right: 33.333333%;\n  left: 33.333333%;\n}\n.inset-y-5\\/12 {\n  top: 41.666667%;\n  bottom: 41.666667%;\n}\n.inset-x-5\\/12 {\n  right: 41.666667%;\n  left: 41.666667%;\n}\n.inset-y-6\\/12 {\n  top: 50%;\n  bottom: 50%;\n}\n.inset-x-6\\/12 {\n  right: 50%;\n  left: 50%;\n}\n.inset-y-7\\/12 {\n  top: 58.333333%;\n  bottom: 58.333333%;\n}\n.inset-x-7\\/12 {\n  right: 58.333333%;\n  left: 58.333333%;\n}\n.inset-y-8\\/12 {\n  top: 66.666667%;\n  bottom: 66.666667%;\n}\n.inset-x-8\\/12 {\n  right: 66.666667%;\n  left: 66.666667%;\n}\n.inset-y-9\\/12 {\n  top: 75%;\n  bottom: 75%;\n}\n.inset-x-9\\/12 {\n  right: 75%;\n  left: 75%;\n}\n.inset-y-10\\/12 {\n  top: 83.333333%;\n  bottom: 83.333333%;\n}\n.inset-x-10\\/12 {\n  right: 83.333333%;\n  left: 83.333333%;\n}\n.inset-y-11\\/12 {\n  top: 91.666667%;\n  bottom: 91.666667%;\n}\n.inset-x-11\\/12 {\n  right: 91.666667%;\n  left: 91.666667%;\n}\n.inset-y-full {\n  top: 100%;\n  bottom: 100%;\n}\n.inset-x-full {\n  right: 100%;\n  left: 100%;\n}\n.top-0 {\n  top: 0;\n}\n.right-0 {\n  right: 0;\n}\n.bottom-0 {\n  bottom: 0;\n}\n.left-0 {\n  left: 0;\n}\n.top-1 {\n  top: 0.25rem;\n}\n.right-1 {\n  right: 0.25rem;\n}\n.bottom-1 {\n  bottom: 0.25rem;\n}\n.left-1 {\n  left: 0.25rem;\n}\n.top-2 {\n  top: 0.5rem;\n}\n.right-2 {\n  right: 0.5rem;\n}\n.bottom-2 {\n  bottom: 0.5rem;\n}\n.left-2 {\n  left: 0.5rem;\n}\n.top-3 {\n  top: 0.75rem;\n}\n.right-3 {\n  right: 0.75rem;\n}\n.bottom-3 {\n  bottom: 0.75rem;\n}\n.left-3 {\n  left: 0.75rem;\n}\n.top-4 {\n  top: 1rem;\n}\n.right-4 {\n  right: 1rem;\n}\n.bottom-4 {\n  bottom: 1rem;\n}\n.left-4 {\n  left: 1rem;\n}\n.top-5 {\n  top: 1.25rem;\n}\n.right-5 {\n  right: 1.25rem;\n}\n.bottom-5 {\n  bottom: 1.25rem;\n}\n.left-5 {\n  left: 1.25rem;\n}\n.top-6 {\n  top: 1.5rem;\n}\n.right-6 {\n  right: 1.5rem;\n}\n.bottom-6 {\n  bottom: 1.5rem;\n}\n.left-6 {\n  left: 1.5rem;\n}\n.top-7 {\n  top: 1.75rem;\n}\n.right-7 {\n  right: 1.75rem;\n}\n.bottom-7 {\n  bottom: 1.75rem;\n}\n.left-7 {\n  left: 1.75rem;\n}\n.top-8 {\n  top: 2rem;\n}\n.right-8 {\n  right: 2rem;\n}\n.bottom-8 {\n  bottom: 2rem;\n}\n.left-8 {\n  left: 2rem;\n}\n.top-9 {\n  top: 2.25rem;\n}\n.right-9 {\n  right: 2.25rem;\n}\n.bottom-9 {\n  bottom: 2.25rem;\n}\n.left-9 {\n  left: 2.25rem;\n}\n.top-10 {\n  top: 2.5rem;\n}\n.right-10 {\n  right: 2.5rem;\n}\n.bottom-10 {\n  bottom: 2.5rem;\n}\n.left-10 {\n  left: 2.5rem;\n}\n.top-11 {\n  top: 2.75rem;\n}\n.right-11 {\n  right: 2.75rem;\n}\n.bottom-11 {\n  bottom: 2.75rem;\n}\n.left-11 {\n  left: 2.75rem;\n}\n.top-12 {\n  top: 3rem;\n}\n.right-12 {\n  right: 3rem;\n}\n.bottom-12 {\n  bottom: 3rem;\n}\n.left-12 {\n  left: 3rem;\n}\n.top-13 {\n  top: 3.25rem;\n}\n.right-13 {\n  right: 3.25rem;\n}\n.bottom-13 {\n  bottom: 3.25rem;\n}\n.left-13 {\n  left: 3.25rem;\n}\n.top-14 {\n  top: 3.5rem;\n}\n.right-14 {\n  right: 3.5rem;\n}\n.bottom-14 {\n  bottom: 3.5rem;\n}\n.left-14 {\n  left: 3.5rem;\n}\n.top-15 {\n  top: 3.75rem;\n}\n.right-15 {\n  right: 3.75rem;\n}\n.bottom-15 {\n  bottom: 3.75rem;\n}\n.left-15 {\n  left: 3.75rem;\n}\n.top-16 {\n  top: 4rem;\n}\n.right-16 {\n  right: 4rem;\n}\n.bottom-16 {\n  bottom: 4rem;\n}\n.left-16 {\n  left: 4rem;\n}\n.top-20 {\n  top: 5rem;\n}\n.right-20 {\n  right: 5rem;\n}\n.bottom-20 {\n  bottom: 5rem;\n}\n.left-20 {\n  left: 5rem;\n}\n.top-24 {\n  top: 6rem;\n}\n.right-24 {\n  right: 6rem;\n}\n.bottom-24 {\n  bottom: 6rem;\n}\n.left-24 {\n  left: 6rem;\n}\n.top-28 {\n  top: 7rem;\n}\n.right-28 {\n  right: 7rem;\n}\n.bottom-28 {\n  bottom: 7rem;\n}\n.left-28 {\n  left: 7rem;\n}\n.top-32 {\n  top: 8rem;\n}\n.right-32 {\n  right: 8rem;\n}\n.bottom-32 {\n  bottom: 8rem;\n}\n.left-32 {\n  left: 8rem;\n}\n.top-36 {\n  top: 9rem;\n}\n.right-36 {\n  right: 9rem;\n}\n.bottom-36 {\n  bottom: 9rem;\n}\n.left-36 {\n  left: 9rem;\n}\n.top-40 {\n  top: 10rem;\n}\n.right-40 {\n  right: 10rem;\n}\n.bottom-40 {\n  bottom: 10rem;\n}\n.left-40 {\n  left: 10rem;\n}\n.top-44 {\n  top: 11rem;\n}\n.right-44 {\n  right: 11rem;\n}\n.bottom-44 {\n  bottom: 11rem;\n}\n.left-44 {\n  left: 11rem;\n}\n.top-48 {\n  top: 12rem;\n}\n.right-48 {\n  right: 12rem;\n}\n.bottom-48 {\n  bottom: 12rem;\n}\n.left-48 {\n  left: 12rem;\n}\n.top-52 {\n  top: 13rem;\n}\n.right-52 {\n  right: 13rem;\n}\n.bottom-52 {\n  bottom: 13rem;\n}\n.left-52 {\n  left: 13rem;\n}\n.top-56 {\n  top: 14rem;\n}\n.right-56 {\n  right: 14rem;\n}\n.bottom-56 {\n  bottom: 14rem;\n}\n.left-56 {\n  left: 14rem;\n}\n.top-60 {\n  top: 15rem;\n}\n.right-60 {\n  right: 15rem;\n}\n.bottom-60 {\n  bottom: 15rem;\n}\n.left-60 {\n  left: 15rem;\n}\n.top-64 {\n  top: 16rem;\n}\n.right-64 {\n  right: 16rem;\n}\n.bottom-64 {\n  bottom: 16rem;\n}\n.left-64 {\n  left: 16rem;\n}\n.top-72 {\n  top: 18rem;\n}\n.right-72 {\n  right: 18rem;\n}\n.bottom-72 {\n  bottom: 18rem;\n}\n.left-72 {\n  left: 18rem;\n}\n.top-80 {\n  top: 20rem;\n}\n.right-80 {\n  right: 20rem;\n}\n.bottom-80 {\n  bottom: 20rem;\n}\n.left-80 {\n  left: 20rem;\n}\n.top-96 {\n  top: 24rem;\n}\n.right-96 {\n  right: 24rem;\n}\n.bottom-96 {\n  bottom: 24rem;\n}\n.left-96 {\n  left: 24rem;\n}\n.top-auto {\n  top: auto;\n}\n.right-auto {\n  right: auto;\n}\n.bottom-auto {\n  bottom: auto;\n}\n.left-auto {\n  left: auto;\n}\n.top-px {\n  top: 1px;\n}\n.right-px {\n  right: 1px;\n}\n.bottom-px {\n  bottom: 1px;\n}\n.left-px {\n  left: 1px;\n}\n.top-0\\.5 {\n  top: 0.125rem;\n}\n.right-0\\.5 {\n  right: 0.125rem;\n}\n.bottom-0\\.5 {\n  bottom: 0.125rem;\n}\n.left-0\\.5 {\n  left: 0.125rem;\n}\n.top-1\\.5 {\n  top: 0.375rem;\n}\n.right-1\\.5 {\n  right: 0.375rem;\n}\n.bottom-1\\.5 {\n  bottom: 0.375rem;\n}\n.left-1\\.5 {\n  left: 0.375rem;\n}\n.top-2\\.5 {\n  top: 0.625rem;\n}\n.right-2\\.5 {\n  right: 0.625rem;\n}\n.bottom-2\\.5 {\n  bottom: 0.625rem;\n}\n.left-2\\.5 {\n  left: 0.625rem;\n}\n.top-3\\.5 {\n  top: 0.875rem;\n}\n.right-3\\.5 {\n  right: 0.875rem;\n}\n.bottom-3\\.5 {\n  bottom: 0.875rem;\n}\n.left-3\\.5 {\n  left: 0.875rem;\n}\n.top-1\\/2 {\n  top: 50%;\n}\n.right-1\\/2 {\n  right: 50%;\n}\n.bottom-1\\/2 {\n  bottom: 50%;\n}\n.left-1\\/2 {\n  left: 50%;\n}\n.top-1\\/3 {\n  top: 33.333333%;\n}\n.right-1\\/3 {\n  right: 33.333333%;\n}\n.bottom-1\\/3 {\n  bottom: 33.333333%;\n}\n.left-1\\/3 {\n  left: 33.333333%;\n}\n.top-2\\/3 {\n  top: 66.666667%;\n}\n.right-2\\/3 {\n  right: 66.666667%;\n}\n.bottom-2\\/3 {\n  bottom: 66.666667%;\n}\n.left-2\\/3 {\n  left: 66.666667%;\n}\n.top-1\\/4 {\n  top: 25%;\n}\n.right-1\\/4 {\n  right: 25%;\n}\n.bottom-1\\/4 {\n  bottom: 25%;\n}\n.left-1\\/4 {\n  left: 25%;\n}\n.top-2\\/4 {\n  top: 50%;\n}\n.right-2\\/4 {\n  right: 50%;\n}\n.bottom-2\\/4 {\n  bottom: 50%;\n}\n.left-2\\/4 {\n  left: 50%;\n}\n.top-3\\/4 {\n  top: 75%;\n}\n.right-3\\/4 {\n  right: 75%;\n}\n.bottom-3\\/4 {\n  bottom: 75%;\n}\n.left-3\\/4 {\n  left: 75%;\n}\n.top-1\\/5 {\n  top: 20%;\n}\n.right-1\\/5 {\n  right: 20%;\n}\n.bottom-1\\/5 {\n  bottom: 20%;\n}\n.left-1\\/5 {\n  left: 20%;\n}\n.top-2\\/5 {\n  top: 40%;\n}\n.right-2\\/5 {\n  right: 40%;\n}\n.bottom-2\\/5 {\n  bottom: 40%;\n}\n.left-2\\/5 {\n  left: 40%;\n}\n.top-3\\/5 {\n  top: 60%;\n}\n.right-3\\/5 {\n  right: 60%;\n}\n.bottom-3\\/5 {\n  bottom: 60%;\n}\n.left-3\\/5 {\n  left: 60%;\n}\n.top-4\\/5 {\n  top: 80%;\n}\n.right-4\\/5 {\n  right: 80%;\n}\n.bottom-4\\/5 {\n  bottom: 80%;\n}\n.left-4\\/5 {\n  left: 80%;\n}\n.top-1\\/6 {\n  top: 16.666667%;\n}\n.right-1\\/6 {\n  right: 16.666667%;\n}\n.bottom-1\\/6 {\n  bottom: 16.666667%;\n}\n.left-1\\/6 {\n  left: 16.666667%;\n}\n.top-2\\/6 {\n  top: 33.333333%;\n}\n.right-2\\/6 {\n  right: 33.333333%;\n}\n.bottom-2\\/6 {\n  bottom: 33.333333%;\n}\n.left-2\\/6 {\n  left: 33.333333%;\n}\n.top-3\\/6 {\n  top: 50%;\n}\n.right-3\\/6 {\n  right: 50%;\n}\n.bottom-3\\/6 {\n  bottom: 50%;\n}\n.left-3\\/6 {\n  left: 50%;\n}\n.top-4\\/6 {\n  top: 66.666667%;\n}\n.right-4\\/6 {\n  right: 66.666667%;\n}\n.bottom-4\\/6 {\n  bottom: 66.666667%;\n}\n.left-4\\/6 {\n  left: 66.666667%;\n}\n.top-5\\/6 {\n  top: 83.333333%;\n}\n.right-5\\/6 {\n  right: 83.333333%;\n}\n.bottom-5\\/6 {\n  bottom: 83.333333%;\n}\n.left-5\\/6 {\n  left: 83.333333%;\n}\n.top-1\\/12 {\n  top: 8.333333%;\n}\n.right-1\\/12 {\n  right: 8.333333%;\n}\n.bottom-1\\/12 {\n  bottom: 8.333333%;\n}\n.left-1\\/12 {\n  left: 8.333333%;\n}\n.top-2\\/12 {\n  top: 16.666667%;\n}\n.right-2\\/12 {\n  right: 16.666667%;\n}\n.bottom-2\\/12 {\n  bottom: 16.666667%;\n}\n.left-2\\/12 {\n  left: 16.666667%;\n}\n.top-3\\/12 {\n  top: 25%;\n}\n.right-3\\/12 {\n  right: 25%;\n}\n.bottom-3\\/12 {\n  bottom: 25%;\n}\n.left-3\\/12 {\n  left: 25%;\n}\n.top-4\\/12 {\n  top: 33.333333%;\n}\n.right-4\\/12 {\n  right: 33.333333%;\n}\n.bottom-4\\/12 {\n  bottom: 33.333333%;\n}\n.left-4\\/12 {\n  left: 33.333333%;\n}\n.top-5\\/12 {\n  top: 41.666667%;\n}\n.right-5\\/12 {\n  right: 41.666667%;\n}\n.bottom-5\\/12 {\n  bottom: 41.666667%;\n}\n.left-5\\/12 {\n  left: 41.666667%;\n}\n.top-6\\/12 {\n  top: 50%;\n}\n.right-6\\/12 {\n  right: 50%;\n}\n.bottom-6\\/12 {\n  bottom: 50%;\n}\n.left-6\\/12 {\n  left: 50%;\n}\n.top-7\\/12 {\n  top: 58.333333%;\n}\n.right-7\\/12 {\n  right: 58.333333%;\n}\n.bottom-7\\/12 {\n  bottom: 58.333333%;\n}\n.left-7\\/12 {\n  left: 58.333333%;\n}\n.top-8\\/12 {\n  top: 66.666667%;\n}\n.right-8\\/12 {\n  right: 66.666667%;\n}\n.bottom-8\\/12 {\n  bottom: 66.666667%;\n}\n.left-8\\/12 {\n  left: 66.666667%;\n}\n.top-9\\/12 {\n  top: 75%;\n}\n.right-9\\/12 {\n  right: 75%;\n}\n.bottom-9\\/12 {\n  bottom: 75%;\n}\n.left-9\\/12 {\n  left: 75%;\n}\n.top-10\\/12 {\n  top: 83.333333%;\n}\n.right-10\\/12 {\n  right: 83.333333%;\n}\n.bottom-10\\/12 {\n  bottom: 83.333333%;\n}\n.left-10\\/12 {\n  left: 83.333333%;\n}\n.top-11\\/12 {\n  top: 91.666667%;\n}\n.right-11\\/12 {\n  right: 91.666667%;\n}\n.bottom-11\\/12 {\n  bottom: 91.666667%;\n}\n.left-11\\/12 {\n  left: 91.666667%;\n}\n.top-full {\n  top: 100%;\n}\n.right-full {\n  right: 100%;\n}\n.bottom-full {\n  bottom: 100%;\n}\n.left-full {\n  left: 100%;\n}\n.resize-none {\n  resize: none;\n}\n.resize-y {\n  resize: vertical;\n}\n.resize-x {\n  resize: horizontal;\n}\n.resize {\n  resize: both;\n}\n.shadow-xs {\n  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.05);\n}\n.shadow-sm {\n  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);\n}\n.shadow {\n  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);\n}\n.shadow-md {\n  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);\n}\n.shadow-lg {\n  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);\n}\n.shadow-xl {\n  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);\n}\n.shadow-2xl {\n  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);\n}\n.shadow-inner {\n  box-shadow: inset 0 2px 4px 0 rgba(0, 0, 0, 0.06);\n}\n.shadow-outline {\n  box-shadow: 0 0 0 3px rgba(118, 169, 250, 0.45);\n}\n.shadow-none {\n  box-shadow: none;\n}\n.shadow-solid {\n  box-shadow: 0 0 0 2px currentColor;\n}\n.shadow-outline-gray {\n  box-shadow: 0 0 0 3px rgba(159, 166, 178, 0.45);\n}\n.shadow-outline-blue {\n  box-shadow: 0 0 0 3px rgba(164, 202, 254, 0.45);\n}\n.shadow-outline-teal {\n  box-shadow: 0 0 0 3px rgba(126, 220, 226, 0.45);\n}\n.shadow-outline-green {\n  box-shadow: 0 0 0 3px rgba(132, 225, 188, 0.45);\n}\n.shadow-outline-yellow {\n  box-shadow: 0 0 0 3px rgba(250, 202, 21, 0.45);\n}\n.shadow-outline-orange {\n  box-shadow: 0 0 0 3px rgba(253, 186, 140, 0.45);\n}\n.shadow-outline-red {\n  box-shadow: 0 0 0 3px rgba(248, 180, 180, 0.45);\n}\n.shadow-outline-pink {\n  box-shadow: 0 0 0 3px rgba(248, 180, 217, 0.45);\n}\n.shadow-outline-purple {\n  box-shadow: 0 0 0 3px rgba(202, 191, 253, 0.45);\n}\n.shadow-outline-indigo {\n  box-shadow: 0 0 0 3px rgba(180, 198, 252, 0.45);\n}\n.group:focus .group-focus\\:shadow-xs {\n  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.05);\n}\n.group:focus .group-focus\\:shadow-sm {\n  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);\n}\n.group:focus .group-focus\\:shadow {\n  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);\n}\n.group:focus .group-focus\\:shadow-md {\n  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);\n}\n.group:focus .group-focus\\:shadow-lg {\n  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);\n}\n.group:focus .group-focus\\:shadow-xl {\n  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);\n}\n.group:focus .group-focus\\:shadow-2xl {\n  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);\n}\n.group:focus .group-focus\\:shadow-inner {\n  box-shadow: inset 0 2px 4px 0 rgba(0, 0, 0, 0.06);\n}\n.group:focus .group-focus\\:shadow-outline {\n  box-shadow: 0 0 0 3px rgba(118, 169, 250, 0.45);\n}\n.group:focus .group-focus\\:shadow-none {\n  box-shadow: none;\n}\n.group:focus .group-focus\\:shadow-solid {\n  box-shadow: 0 0 0 2px currentColor;\n}\n.group:focus .group-focus\\:shadow-outline-gray {\n  box-shadow: 0 0 0 3px rgba(159, 166, 178, 0.45);\n}\n.group:focus .group-focus\\:shadow-outline-blue {\n  box-shadow: 0 0 0 3px rgba(164, 202, 254, 0.45);\n}\n.group:focus .group-focus\\:shadow-outline-teal {\n  box-shadow: 0 0 0 3px rgba(126, 220, 226, 0.45);\n}\n.group:focus .group-focus\\:shadow-outline-green {\n  box-shadow: 0 0 0 3px rgba(132, 225, 188, 0.45);\n}\n.group:focus .group-focus\\:shadow-outline-yellow {\n  box-shadow: 0 0 0 3px rgba(250, 202, 21, 0.45);\n}\n.group:focus .group-focus\\:shadow-outline-orange {\n  box-shadow: 0 0 0 3px rgba(253, 186, 140, 0.45);\n}\n.group:focus .group-focus\\:shadow-outline-red {\n  box-shadow: 0 0 0 3px rgba(248, 180, 180, 0.45);\n}\n.group:focus .group-focus\\:shadow-outline-pink {\n  box-shadow: 0 0 0 3px rgba(248, 180, 217, 0.45);\n}\n.group:focus .group-focus\\:shadow-outline-purple {\n  box-shadow: 0 0 0 3px rgba(202, 191, 253, 0.45);\n}\n.group:focus .group-focus\\:shadow-outline-indigo {\n  box-shadow: 0 0 0 3px rgba(180, 198, 252, 0.45);\n}\n.hover\\:shadow-xs:hover {\n  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.05);\n}\n.hover\\:shadow-sm:hover {\n  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);\n}\n.hover\\:shadow:hover {\n  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);\n}\n.hover\\:shadow-md:hover {\n  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);\n}\n.hover\\:shadow-lg:hover {\n  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);\n}\n.hover\\:shadow-xl:hover {\n  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);\n}\n.hover\\:shadow-2xl:hover {\n  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);\n}\n.hover\\:shadow-inner:hover {\n  box-shadow: inset 0 2px 4px 0 rgba(0, 0, 0, 0.06);\n}\n.hover\\:shadow-outline:hover {\n  box-shadow: 0 0 0 3px rgba(118, 169, 250, 0.45);\n}\n.hover\\:shadow-none:hover {\n  box-shadow: none;\n}\n.hover\\:shadow-solid:hover {\n  box-shadow: 0 0 0 2px currentColor;\n}\n.hover\\:shadow-outline-gray:hover {\n  box-shadow: 0 0 0 3px rgba(159, 166, 178, 0.45);\n}\n.hover\\:shadow-outline-blue:hover {\n  box-shadow: 0 0 0 3px rgba(164, 202, 254, 0.45);\n}\n.hover\\:shadow-outline-teal:hover {\n  box-shadow: 0 0 0 3px rgba(126, 220, 226, 0.45);\n}\n.hover\\:shadow-outline-green:hover {\n  box-shadow: 0 0 0 3px rgba(132, 225, 188, 0.45);\n}\n.hover\\:shadow-outline-yellow:hover {\n  box-shadow: 0 0 0 3px rgba(250, 202, 21, 0.45);\n}\n.hover\\:shadow-outline-orange:hover {\n  box-shadow: 0 0 0 3px rgba(253, 186, 140, 0.45);\n}\n.hover\\:shadow-outline-red:hover {\n  box-shadow: 0 0 0 3px rgba(248, 180, 180, 0.45);\n}\n.hover\\:shadow-outline-pink:hover {\n  box-shadow: 0 0 0 3px rgba(248, 180, 217, 0.45);\n}\n.hover\\:shadow-outline-purple:hover {\n  box-shadow: 0 0 0 3px rgba(202, 191, 253, 0.45);\n}\n.hover\\:shadow-outline-indigo:hover {\n  box-shadow: 0 0 0 3px rgba(180, 198, 252, 0.45);\n}\n.focus-within\\:shadow-xs:focus-within {\n  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.05);\n}\n.focus-within\\:shadow-sm:focus-within {\n  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);\n}\n.focus-within\\:shadow:focus-within {\n  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);\n}\n.focus-within\\:shadow-md:focus-within {\n  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);\n}\n.focus-within\\:shadow-lg:focus-within {\n  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);\n}\n.focus-within\\:shadow-xl:focus-within {\n  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);\n}\n.focus-within\\:shadow-2xl:focus-within {\n  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);\n}\n.focus-within\\:shadow-inner:focus-within {\n  box-shadow: inset 0 2px 4px 0 rgba(0, 0, 0, 0.06);\n}\n.focus-within\\:shadow-outline:focus-within {\n  box-shadow: 0 0 0 3px rgba(118, 169, 250, 0.45);\n}\n.focus-within\\:shadow-none:focus-within {\n  box-shadow: none;\n}\n.focus-within\\:shadow-solid:focus-within {\n  box-shadow: 0 0 0 2px currentColor;\n}\n.focus-within\\:shadow-outline-gray:focus-within {\n  box-shadow: 0 0 0 3px rgba(159, 166, 178, 0.45);\n}\n.focus-within\\:shadow-outline-blue:focus-within {\n  box-shadow: 0 0 0 3px rgba(164, 202, 254, 0.45);\n}\n.focus-within\\:shadow-outline-teal:focus-within {\n  box-shadow: 0 0 0 3px rgba(126, 220, 226, 0.45);\n}\n.focus-within\\:shadow-outline-green:focus-within {\n  box-shadow: 0 0 0 3px rgba(132, 225, 188, 0.45);\n}\n.focus-within\\:shadow-outline-yellow:focus-within {\n  box-shadow: 0 0 0 3px rgba(250, 202, 21, 0.45);\n}\n.focus-within\\:shadow-outline-orange:focus-within {\n  box-shadow: 0 0 0 3px rgba(253, 186, 140, 0.45);\n}\n.focus-within\\:shadow-outline-red:focus-within {\n  box-shadow: 0 0 0 3px rgba(248, 180, 180, 0.45);\n}\n.focus-within\\:shadow-outline-pink:focus-within {\n  box-shadow: 0 0 0 3px rgba(248, 180, 217, 0.45);\n}\n.focus-within\\:shadow-outline-purple:focus-within {\n  box-shadow: 0 0 0 3px rgba(202, 191, 253, 0.45);\n}\n.focus-within\\:shadow-outline-indigo:focus-within {\n  box-shadow: 0 0 0 3px rgba(180, 198, 252, 0.45);\n}\n.focus\\:shadow-xs:focus {\n  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.05);\n}\n.focus\\:shadow-sm:focus {\n  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);\n}\n.focus\\:shadow:focus {\n  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);\n}\n.focus\\:shadow-md:focus {\n  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);\n}\n.focus\\:shadow-lg:focus {\n  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);\n}\n.focus\\:shadow-xl:focus {\n  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);\n}\n.focus\\:shadow-2xl:focus {\n  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);\n}\n.focus\\:shadow-inner:focus {\n  box-shadow: inset 0 2px 4px 0 rgba(0, 0, 0, 0.06);\n}\n.focus\\:shadow-outline:focus {\n  box-shadow: 0 0 0 3px rgba(118, 169, 250, 0.45);\n}\n.focus\\:shadow-none:focus {\n  box-shadow: none;\n}\n.focus\\:shadow-solid:focus {\n  box-shadow: 0 0 0 2px currentColor;\n}\n.focus\\:shadow-outline-gray:focus {\n  box-shadow: 0 0 0 3px rgba(159, 166, 178, 0.45);\n}\n.focus\\:shadow-outline-blue:focus {\n  box-shadow: 0 0 0 3px rgba(164, 202, 254, 0.45);\n}\n.focus\\:shadow-outline-teal:focus {\n  box-shadow: 0 0 0 3px rgba(126, 220, 226, 0.45);\n}\n.focus\\:shadow-outline-green:focus {\n  box-shadow: 0 0 0 3px rgba(132, 225, 188, 0.45);\n}\n.focus\\:shadow-outline-yellow:focus {\n  box-shadow: 0 0 0 3px rgba(250, 202, 21, 0.45);\n}\n.focus\\:shadow-outline-orange:focus {\n  box-shadow: 0 0 0 3px rgba(253, 186, 140, 0.45);\n}\n.focus\\:shadow-outline-red:focus {\n  box-shadow: 0 0 0 3px rgba(248, 180, 180, 0.45);\n}\n.focus\\:shadow-outline-pink:focus {\n  box-shadow: 0 0 0 3px rgba(248, 180, 217, 0.45);\n}\n.focus\\:shadow-outline-purple:focus {\n  box-shadow: 0 0 0 3px rgba(202, 191, 253, 0.45);\n}\n.focus\\:shadow-outline-indigo:focus {\n  box-shadow: 0 0 0 3px rgba(180, 198, 252, 0.45);\n}\n.fill-current {\n  fill: currentColor;\n}\n.stroke-current {\n  stroke: currentColor;\n}\n.stroke-0 {\n  stroke-width: 0;\n}\n.stroke-1 {\n  stroke-width: 1;\n}\n.stroke-2 {\n  stroke-width: 2;\n}\n.table-auto {\n  table-layout: auto;\n}\n.table-fixed {\n  table-layout: fixed;\n}\n.text-left {\n  text-align: left;\n}\n.text-center {\n  text-align: center;\n}\n.text-right {\n  text-align: right;\n}\n.text-justify {\n  text-align: justify;\n}\n.text-current {\n  color: currentColor;\n}\n.text-transparent {\n  color: transparent;\n}\n.text-white {\n  --text-opacity: 1;\n  color: #ffffff;\n  color: rgba(255, 255, 255, var(--text-opacity));\n}\n.text-black {\n  --text-opacity: 1;\n  color: #000000;\n  color: rgba(0, 0, 0, var(--text-opacity));\n}\n.text-gray-50 {\n  --text-opacity: 1;\n  color: #f9fafb;\n  color: rgba(249, 250, 251, var(--text-opacity));\n}\n.text-gray-100 {\n  --text-opacity: 1;\n  color: #f4f5f7;\n  color: rgba(244, 245, 247, var(--text-opacity));\n}\n.text-gray-200 {\n  --text-opacity: 1;\n  color: #e5e7eb;\n  color: rgba(229, 231, 235, var(--text-opacity));\n}\n.text-gray-300 {\n  --text-opacity: 1;\n  color: #d2d6dc;\n  color: rgba(210, 214, 220, var(--text-opacity));\n}\n.text-gray-400 {\n  --text-opacity: 1;\n  color: #9fa6b2;\n  color: rgba(159, 166, 178, var(--text-opacity));\n}\n.text-gray-500 {\n  --text-opacity: 1;\n  color: #6b7280;\n  color: rgba(107, 114, 128, var(--text-opacity));\n}\n.text-gray-600 {\n  --text-opacity: 1;\n  color: #4b5563;\n  color: rgba(75, 85, 99, var(--text-opacity));\n}\n.text-gray-700 {\n  --text-opacity: 1;\n  color: #374151;\n  color: rgba(55, 65, 81, var(--text-opacity));\n}\n.text-gray-800 {\n  --text-opacity: 1;\n  color: #252f3f;\n  color: rgba(37, 47, 63, var(--text-opacity));\n}\n.text-gray-900 {\n  --text-opacity: 1;\n  color: #161e2e;\n  color: rgba(22, 30, 46, var(--text-opacity));\n}\n.text-red-50 {\n  --text-opacity: 1;\n  color: #fdf2f2;\n  color: rgba(253, 242, 242, var(--text-opacity));\n}\n.text-red-100 {\n  --text-opacity: 1;\n  color: #fde8e8;\n  color: rgba(253, 232, 232, var(--text-opacity));\n}\n.text-red-200 {\n  --text-opacity: 1;\n  color: #fbd5d5;\n  color: rgba(251, 213, 213, var(--text-opacity));\n}\n.text-red-300 {\n  --text-opacity: 1;\n  color: #f8b4b4;\n  color: rgba(248, 180, 180, var(--text-opacity));\n}\n.text-red-400 {\n  --text-opacity: 1;\n  color: #f98080;\n  color: rgba(249, 128, 128, var(--text-opacity));\n}\n.text-red-500 {\n  --text-opacity: 1;\n  color: #f05252;\n  color: rgba(240, 82, 82, var(--text-opacity));\n}\n.text-red-600 {\n  --text-opacity: 1;\n  color: #e02424;\n  color: rgba(224, 36, 36, var(--text-opacity));\n}\n.text-red-700 {\n  --text-opacity: 1;\n  color: #c81e1e;\n  color: rgba(200, 30, 30, var(--text-opacity));\n}\n.text-red-800 {\n  --text-opacity: 1;\n  color: #9b1c1c;\n  color: rgba(155, 28, 28, var(--text-opacity));\n}\n.text-red-900 {\n  --text-opacity: 1;\n  color: #771d1d;\n  color: rgba(119, 29, 29, var(--text-opacity));\n}\n.text-orange-50 {\n  --text-opacity: 1;\n  color: #fff8f1;\n  color: rgba(255, 248, 241, var(--text-opacity));\n}\n.text-orange-100 {\n  --text-opacity: 1;\n  color: #feecdc;\n  color: rgba(254, 236, 220, var(--text-opacity));\n}\n.text-orange-200 {\n  --text-opacity: 1;\n  color: #fcd9bd;\n  color: rgba(252, 217, 189, var(--text-opacity));\n}\n.text-orange-300 {\n  --text-opacity: 1;\n  color: #fdba8c;\n  color: rgba(253, 186, 140, var(--text-opacity));\n}\n.text-orange-400 {\n  --text-opacity: 1;\n  color: #ff8a4c;\n  color: rgba(255, 138, 76, var(--text-opacity));\n}\n.text-orange-500 {\n  --text-opacity: 1;\n  color: #ff5a1f;\n  color: rgba(255, 90, 31, var(--text-opacity));\n}\n.text-orange-600 {\n  --text-opacity: 1;\n  color: #d03801;\n  color: rgba(208, 56, 1, var(--text-opacity));\n}\n.text-orange-700 {\n  --text-opacity: 1;\n  color: #b43403;\n  color: rgba(180, 52, 3, var(--text-opacity));\n}\n.text-orange-800 {\n  --text-opacity: 1;\n  color: #8a2c0d;\n  color: rgba(138, 44, 13, var(--text-opacity));\n}\n.text-orange-900 {\n  --text-opacity: 1;\n  color: #73230d;\n  color: rgba(115, 35, 13, var(--text-opacity));\n}\n.text-yellow-50 {\n  --text-opacity: 1;\n  color: #fdfdea;\n  color: rgba(253, 253, 234, var(--text-opacity));\n}\n.text-yellow-100 {\n  --text-opacity: 1;\n  color: #fdf6b2;\n  color: rgba(253, 246, 178, var(--text-opacity));\n}\n.text-yellow-200 {\n  --text-opacity: 1;\n  color: #fce96a;\n  color: rgba(252, 233, 106, var(--text-opacity));\n}\n.text-yellow-300 {\n  --text-opacity: 1;\n  color: #faca15;\n  color: rgba(250, 202, 21, var(--text-opacity));\n}\n.text-yellow-400 {\n  --text-opacity: 1;\n  color: #e3a008;\n  color: rgba(227, 160, 8, var(--text-opacity));\n}\n.text-yellow-500 {\n  --text-opacity: 1;\n  color: #c27803;\n  color: rgba(194, 120, 3, var(--text-opacity));\n}\n.text-yellow-600 {\n  --text-opacity: 1;\n  color: #9f580a;\n  color: rgba(159, 88, 10, var(--text-opacity));\n}\n.text-yellow-700 {\n  --text-opacity: 1;\n  color: #8e4b10;\n  color: rgba(142, 75, 16, var(--text-opacity));\n}\n.text-yellow-800 {\n  --text-opacity: 1;\n  color: #723b13;\n  color: rgba(114, 59, 19, var(--text-opacity));\n}\n.text-yellow-900 {\n  --text-opacity: 1;\n  color: #633112;\n  color: rgba(99, 49, 18, var(--text-opacity));\n}\n.text-green-50 {\n  --text-opacity: 1;\n  color: #f3faf7;\n  color: rgba(243, 250, 247, var(--text-opacity));\n}\n.text-green-100 {\n  --text-opacity: 1;\n  color: #def7ec;\n  color: rgba(222, 247, 236, var(--text-opacity));\n}\n.text-green-200 {\n  --text-opacity: 1;\n  color: #bcf0da;\n  color: rgba(188, 240, 218, var(--text-opacity));\n}\n.text-green-300 {\n  --text-opacity: 1;\n  color: #84e1bc;\n  color: rgba(132, 225, 188, var(--text-opacity));\n}\n.text-green-400 {\n  --text-opacity: 1;\n  color: #31c48d;\n  color: rgba(49, 196, 141, var(--text-opacity));\n}\n.text-green-500 {\n  --text-opacity: 1;\n  color: #0e9f6e;\n  color: rgba(14, 159, 110, var(--text-opacity));\n}\n.text-green-600 {\n  --text-opacity: 1;\n  color: #057a55;\n  color: rgba(5, 122, 85, var(--text-opacity));\n}\n.text-green-700 {\n  --text-opacity: 1;\n  color: #046c4e;\n  color: rgba(4, 108, 78, var(--text-opacity));\n}\n.text-green-800 {\n  --text-opacity: 1;\n  color: #03543f;\n  color: rgba(3, 84, 63, var(--text-opacity));\n}\n.text-green-900 {\n  --text-opacity: 1;\n  color: #014737;\n  color: rgba(1, 71, 55, var(--text-opacity));\n}\n.text-teal-50 {\n  --text-opacity: 1;\n  color: #edfafa;\n  color: rgba(237, 250, 250, var(--text-opacity));\n}\n.text-teal-100 {\n  --text-opacity: 1;\n  color: #d5f5f6;\n  color: rgba(213, 245, 246, var(--text-opacity));\n}\n.text-teal-200 {\n  --text-opacity: 1;\n  color: #afecef;\n  color: rgba(175, 236, 239, var(--text-opacity));\n}\n.text-teal-300 {\n  --text-opacity: 1;\n  color: #7edce2;\n  color: rgba(126, 220, 226, var(--text-opacity));\n}\n.text-teal-400 {\n  --text-opacity: 1;\n  color: #16bdca;\n  color: rgba(22, 189, 202, var(--text-opacity));\n}\n.text-teal-500 {\n  --text-opacity: 1;\n  color: #0694a2;\n  color: rgba(6, 148, 162, var(--text-opacity));\n}\n.text-teal-600 {\n  --text-opacity: 1;\n  color: #047481;\n  color: rgba(4, 116, 129, var(--text-opacity));\n}\n.text-teal-700 {\n  --text-opacity: 1;\n  color: #036672;\n  color: rgba(3, 102, 114, var(--text-opacity));\n}\n.text-teal-800 {\n  --text-opacity: 1;\n  color: #05505c;\n  color: rgba(5, 80, 92, var(--text-opacity));\n}\n.text-teal-900 {\n  --text-opacity: 1;\n  color: #014451;\n  color: rgba(1, 68, 81, var(--text-opacity));\n}\n.text-blue-50 {\n  --text-opacity: 1;\n  color: #ebf5ff;\n  color: rgba(235, 245, 255, var(--text-opacity));\n}\n.text-blue-100 {\n  --text-opacity: 1;\n  color: #e1effe;\n  color: rgba(225, 239, 254, var(--text-opacity));\n}\n.text-blue-200 {\n  --text-opacity: 1;\n  color: #c3ddfd;\n  color: rgba(195, 221, 253, var(--text-opacity));\n}\n.text-blue-300 {\n  --text-opacity: 1;\n  color: #a4cafe;\n  color: rgba(164, 202, 254, var(--text-opacity));\n}\n.text-blue-400 {\n  --text-opacity: 1;\n  color: #76a9fa;\n  color: rgba(118, 169, 250, var(--text-opacity));\n}\n.text-blue-500 {\n  --text-opacity: 1;\n  color: #3f83f8;\n  color: rgba(63, 131, 248, var(--text-opacity));\n}\n.text-blue-600 {\n  --text-opacity: 1;\n  color: #1c64f2;\n  color: rgba(28, 100, 242, var(--text-opacity));\n}\n.text-blue-700 {\n  --text-opacity: 1;\n  color: #1a56db;\n  color: rgba(26, 86, 219, var(--text-opacity));\n}\n.text-blue-800 {\n  --text-opacity: 1;\n  color: #1e429f;\n  color: rgba(30, 66, 159, var(--text-opacity));\n}\n.text-blue-900 {\n  --text-opacity: 1;\n  color: #233876;\n  color: rgba(35, 56, 118, var(--text-opacity));\n}\n.text-indigo-50 {\n  --text-opacity: 1;\n  color: #f0f5ff;\n  color: rgba(240, 245, 255, var(--text-opacity));\n}\n.text-indigo-100 {\n  --text-opacity: 1;\n  color: #e5edff;\n  color: rgba(229, 237, 255, var(--text-opacity));\n}\n.text-indigo-200 {\n  --text-opacity: 1;\n  color: #cddbfe;\n  color: rgba(205, 219, 254, var(--text-opacity));\n}\n.text-indigo-300 {\n  --text-opacity: 1;\n  color: #b4c6fc;\n  color: rgba(180, 198, 252, var(--text-opacity));\n}\n.text-indigo-400 {\n  --text-opacity: 1;\n  color: #8da2fb;\n  color: rgba(141, 162, 251, var(--text-opacity));\n}\n.text-indigo-500 {\n  --text-opacity: 1;\n  color: #6875f5;\n  color: rgba(104, 117, 245, var(--text-opacity));\n}\n.text-indigo-600 {\n  --text-opacity: 1;\n  color: #5850ec;\n  color: rgba(88, 80, 236, var(--text-opacity));\n}\n.text-indigo-700 {\n  --text-opacity: 1;\n  color: #5145cd;\n  color: rgba(81, 69, 205, var(--text-opacity));\n}\n.text-indigo-800 {\n  --text-opacity: 1;\n  color: #42389d;\n  color: rgba(66, 56, 157, var(--text-opacity));\n}\n.text-indigo-900 {\n  --text-opacity: 1;\n  color: #362f78;\n  color: rgba(54, 47, 120, var(--text-opacity));\n}\n.text-purple-50 {\n  --text-opacity: 1;\n  color: #f6f5ff;\n  color: rgba(246, 245, 255, var(--text-opacity));\n}\n.text-purple-100 {\n  --text-opacity: 1;\n  color: #edebfe;\n  color: rgba(237, 235, 254, var(--text-opacity));\n}\n.text-purple-200 {\n  --text-opacity: 1;\n  color: #dcd7fe;\n  color: rgba(220, 215, 254, var(--text-opacity));\n}\n.text-purple-300 {\n  --text-opacity: 1;\n  color: #cabffd;\n  color: rgba(202, 191, 253, var(--text-opacity));\n}\n.text-purple-400 {\n  --text-opacity: 1;\n  color: #ac94fa;\n  color: rgba(172, 148, 250, var(--text-opacity));\n}\n.text-purple-500 {\n  --text-opacity: 1;\n  color: #9061f9;\n  color: rgba(144, 97, 249, var(--text-opacity));\n}\n.text-purple-600 {\n  --text-opacity: 1;\n  color: #7e3af2;\n  color: rgba(126, 58, 242, var(--text-opacity));\n}\n.text-purple-700 {\n  --text-opacity: 1;\n  color: #6c2bd9;\n  color: rgba(108, 43, 217, var(--text-opacity));\n}\n.text-purple-800 {\n  --text-opacity: 1;\n  color: #5521b5;\n  color: rgba(85, 33, 181, var(--text-opacity));\n}\n.text-purple-900 {\n  --text-opacity: 1;\n  color: #4a1d96;\n  color: rgba(74, 29, 150, var(--text-opacity));\n}\n.text-pink-50 {\n  --text-opacity: 1;\n  color: #fdf2f8;\n  color: rgba(253, 242, 248, var(--text-opacity));\n}\n.text-pink-100 {\n  --text-opacity: 1;\n  color: #fce8f3;\n  color: rgba(252, 232, 243, var(--text-opacity));\n}\n.text-pink-200 {\n  --text-opacity: 1;\n  color: #fad1e8;\n  color: rgba(250, 209, 232, var(--text-opacity));\n}\n.text-pink-300 {\n  --text-opacity: 1;\n  color: #f8b4d9;\n  color: rgba(248, 180, 217, var(--text-opacity));\n}\n.text-pink-400 {\n  --text-opacity: 1;\n  color: #f17eb8;\n  color: rgba(241, 126, 184, var(--text-opacity));\n}\n.text-pink-500 {\n  --text-opacity: 1;\n  color: #e74694;\n  color: rgba(231, 70, 148, var(--text-opacity));\n}\n.text-pink-600 {\n  --text-opacity: 1;\n  color: #d61f69;\n  color: rgba(214, 31, 105, var(--text-opacity));\n}\n.text-pink-700 {\n  --text-opacity: 1;\n  color: #bf125d;\n  color: rgba(191, 18, 93, var(--text-opacity));\n}\n.text-pink-800 {\n  --text-opacity: 1;\n  color: #99154b;\n  color: rgba(153, 21, 75, var(--text-opacity));\n}\n.text-pink-900 {\n  --text-opacity: 1;\n  color: #751a3d;\n  color: rgba(117, 26, 61, var(--text-opacity));\n}\n.text-cool-gray-50 {\n  --text-opacity: 1;\n  color: #f8fafc;\n  color: rgba(248, 250, 252, var(--text-opacity));\n}\n.text-cool-gray-100 {\n  --text-opacity: 1;\n  color: #f1f5f9;\n  color: rgba(241, 245, 249, var(--text-opacity));\n}\n.text-cool-gray-200 {\n  --text-opacity: 1;\n  color: #e2e8f0;\n  color: rgba(226, 232, 240, var(--text-opacity));\n}\n.text-cool-gray-300 {\n  --text-opacity: 1;\n  color: #cfd8e3;\n  color: rgba(207, 216, 227, var(--text-opacity));\n}\n.text-cool-gray-400 {\n  --text-opacity: 1;\n  color: #97a6ba;\n  color: rgba(151, 166, 186, var(--text-opacity));\n}\n.text-cool-gray-500 {\n  --text-opacity: 1;\n  color: #64748b;\n  color: rgba(100, 116, 139, var(--text-opacity));\n}\n.text-cool-gray-600 {\n  --text-opacity: 1;\n  color: #475569;\n  color: rgba(71, 85, 105, var(--text-opacity));\n}\n.text-cool-gray-700 {\n  --text-opacity: 1;\n  color: #364152;\n  color: rgba(54, 65, 82, var(--text-opacity));\n}\n.text-cool-gray-800 {\n  --text-opacity: 1;\n  color: #27303f;\n  color: rgba(39, 48, 63, var(--text-opacity));\n}\n.text-cool-gray-900 {\n  --text-opacity: 1;\n  color: #1a202e;\n  color: rgba(26, 32, 46, var(--text-opacity));\n}\n.group:hover .group-hover\\:text-current {\n  color: currentColor;\n}\n.group:hover .group-hover\\:text-transparent {\n  color: transparent;\n}\n.group:hover .group-hover\\:text-white {\n  --text-opacity: 1;\n  color: #ffffff;\n  color: rgba(255, 255, 255, var(--text-opacity));\n}\n.group:hover .group-hover\\:text-black {\n  --text-opacity: 1;\n  color: #000000;\n  color: rgba(0, 0, 0, var(--text-opacity));\n}\n.group:hover .group-hover\\:text-gray-50 {\n  --text-opacity: 1;\n  color: #f9fafb;\n  color: rgba(249, 250, 251, var(--text-opacity));\n}\n.group:hover .group-hover\\:text-gray-100 {\n  --text-opacity: 1;\n  color: #f4f5f7;\n  color: rgba(244, 245, 247, var(--text-opacity));\n}\n.group:hover .group-hover\\:text-gray-200 {\n  --text-opacity: 1;\n  color: #e5e7eb;\n  color: rgba(229, 231, 235, var(--text-opacity));\n}\n.group:hover .group-hover\\:text-gray-300 {\n  --text-opacity: 1;\n  color: #d2d6dc;\n  color: rgba(210, 214, 220, var(--text-opacity));\n}\n.group:hover .group-hover\\:text-gray-400 {\n  --text-opacity: 1;\n  color: #9fa6b2;\n  color: rgba(159, 166, 178, var(--text-opacity));\n}\n.group:hover .group-hover\\:text-gray-500 {\n  --text-opacity: 1;\n  color: #6b7280;\n  color: rgba(107, 114, 128, var(--text-opacity));\n}\n.group:hover .group-hover\\:text-gray-600 {\n  --text-opacity: 1;\n  color: #4b5563;\n  color: rgba(75, 85, 99, var(--text-opacity));\n}\n.group:hover .group-hover\\:text-gray-700 {\n  --text-opacity: 1;\n  color: #374151;\n  color: rgba(55, 65, 81, var(--text-opacity));\n}\n.group:hover .group-hover\\:text-gray-800 {\n  --text-opacity: 1;\n  color: #252f3f;\n  color: rgba(37, 47, 63, var(--text-opacity));\n}\n.group:hover .group-hover\\:text-gray-900 {\n  --text-opacity: 1;\n  color: #161e2e;\n  color: rgba(22, 30, 46, var(--text-opacity));\n}\n.group:hover .group-hover\\:text-red-50 {\n  --text-opacity: 1;\n  color: #fdf2f2;\n  color: rgba(253, 242, 242, var(--text-opacity));\n}\n.group:hover .group-hover\\:text-red-100 {\n  --text-opacity: 1;\n  color: #fde8e8;\n  color: rgba(253, 232, 232, var(--text-opacity));\n}\n.group:hover .group-hover\\:text-red-200 {\n  --text-opacity: 1;\n  color: #fbd5d5;\n  color: rgba(251, 213, 213, var(--text-opacity));\n}\n.group:hover .group-hover\\:text-red-300 {\n  --text-opacity: 1;\n  color: #f8b4b4;\n  color: rgba(248, 180, 180, var(--text-opacity));\n}\n.group:hover .group-hover\\:text-red-400 {\n  --text-opacity: 1;\n  color: #f98080;\n  color: rgba(249, 128, 128, var(--text-opacity));\n}\n.group:hover .group-hover\\:text-red-500 {\n  --text-opacity: 1;\n  color: #f05252;\n  color: rgba(240, 82, 82, var(--text-opacity));\n}\n.group:hover .group-hover\\:text-red-600 {\n  --text-opacity: 1;\n  color: #e02424;\n  color: rgba(224, 36, 36, var(--text-opacity));\n}\n.group:hover .group-hover\\:text-red-700 {\n  --text-opacity: 1;\n  color: #c81e1e;\n  color: rgba(200, 30, 30, var(--text-opacity));\n}\n.group:hover .group-hover\\:text-red-800 {\n  --text-opacity: 1;\n  color: #9b1c1c;\n  color: rgba(155, 28, 28, var(--text-opacity));\n}\n.group:hover .group-hover\\:text-red-900 {\n  --text-opacity: 1;\n  color: #771d1d;\n  color: rgba(119, 29, 29, var(--text-opacity));\n}\n.group:hover .group-hover\\:text-orange-50 {\n  --text-opacity: 1;\n  color: #fff8f1;\n  color: rgba(255, 248, 241, var(--text-opacity));\n}\n.group:hover .group-hover\\:text-orange-100 {\n  --text-opacity: 1;\n  color: #feecdc;\n  color: rgba(254, 236, 220, var(--text-opacity));\n}\n.group:hover .group-hover\\:text-orange-200 {\n  --text-opacity: 1;\n  color: #fcd9bd;\n  color: rgba(252, 217, 189, var(--text-opacity));\n}\n.group:hover .group-hover\\:text-orange-300 {\n  --text-opacity: 1;\n  color: #fdba8c;\n  color: rgba(253, 186, 140, var(--text-opacity));\n}\n.group:hover .group-hover\\:text-orange-400 {\n  --text-opacity: 1;\n  color: #ff8a4c;\n  color: rgba(255, 138, 76, var(--text-opacity));\n}\n.group:hover .group-hover\\:text-orange-500 {\n  --text-opacity: 1;\n  color: #ff5a1f;\n  color: rgba(255, 90, 31, var(--text-opacity));\n}\n.group:hover .group-hover\\:text-orange-600 {\n  --text-opacity: 1;\n  color: #d03801;\n  color: rgba(208, 56, 1, var(--text-opacity));\n}\n.group:hover .group-hover\\:text-orange-700 {\n  --text-opacity: 1;\n  color: #b43403;\n  color: rgba(180, 52, 3, var(--text-opacity));\n}\n.group:hover .group-hover\\:text-orange-800 {\n  --text-opacity: 1;\n  color: #8a2c0d;\n  color: rgba(138, 44, 13, var(--text-opacity));\n}\n.group:hover .group-hover\\:text-orange-900 {\n  --text-opacity: 1;\n  color: #73230d;\n  color: rgba(115, 35, 13, var(--text-opacity));\n}\n.group:hover .group-hover\\:text-yellow-50 {\n  --text-opacity: 1;\n  color: #fdfdea;\n  color: rgba(253, 253, 234, var(--text-opacity));\n}\n.group:hover .group-hover\\:text-yellow-100 {\n  --text-opacity: 1;\n  color: #fdf6b2;\n  color: rgba(253, 246, 178, var(--text-opacity));\n}\n.group:hover .group-hover\\:text-yellow-200 {\n  --text-opacity: 1;\n  color: #fce96a;\n  color: rgba(252, 233, 106, var(--text-opacity));\n}\n.group:hover .group-hover\\:text-yellow-300 {\n  --text-opacity: 1;\n  color: #faca15;\n  color: rgba(250, 202, 21, var(--text-opacity));\n}\n.group:hover .group-hover\\:text-yellow-400 {\n  --text-opacity: 1;\n  color: #e3a008;\n  color: rgba(227, 160, 8, var(--text-opacity));\n}\n.group:hover .group-hover\\:text-yellow-500 {\n  --text-opacity: 1;\n  color: #c27803;\n  color: rgba(194, 120, 3, var(--text-opacity));\n}\n.group:hover .group-hover\\:text-yellow-600 {\n  --text-opacity: 1;\n  color: #9f580a;\n  color: rgba(159, 88, 10, var(--text-opacity));\n}\n.group:hover .group-hover\\:text-yellow-700 {\n  --text-opacity: 1;\n  color: #8e4b10;\n  color: rgba(142, 75, 16, var(--text-opacity));\n}\n.group:hover .group-hover\\:text-yellow-800 {\n  --text-opacity: 1;\n  color: #723b13;\n  color: rgba(114, 59, 19, var(--text-opacity));\n}\n.group:hover .group-hover\\:text-yellow-900 {\n  --text-opacity: 1;\n  color: #633112;\n  color: rgba(99, 49, 18, var(--text-opacity));\n}\n.group:hover .group-hover\\:text-green-50 {\n  --text-opacity: 1;\n  color: #f3faf7;\n  color: rgba(243, 250, 247, var(--text-opacity));\n}\n.group:hover .group-hover\\:text-green-100 {\n  --text-opacity: 1;\n  color: #def7ec;\n  color: rgba(222, 247, 236, var(--text-opacity));\n}\n.group:hover .group-hover\\:text-green-200 {\n  --text-opacity: 1;\n  color: #bcf0da;\n  color: rgba(188, 240, 218, var(--text-opacity));\n}\n.group:hover .group-hover\\:text-green-300 {\n  --text-opacity: 1;\n  color: #84e1bc;\n  color: rgba(132, 225, 188, var(--text-opacity));\n}\n.group:hover .group-hover\\:text-green-400 {\n  --text-opacity: 1;\n  color: #31c48d;\n  color: rgba(49, 196, 141, var(--text-opacity));\n}\n.group:hover .group-hover\\:text-green-500 {\n  --text-opacity: 1;\n  color: #0e9f6e;\n  color: rgba(14, 159, 110, var(--text-opacity));\n}\n.group:hover .group-hover\\:text-green-600 {\n  --text-opacity: 1;\n  color: #057a55;\n  color: rgba(5, 122, 85, var(--text-opacity));\n}\n.group:hover .group-hover\\:text-green-700 {\n  --text-opacity: 1;\n  color: #046c4e;\n  color: rgba(4, 108, 78, var(--text-opacity));\n}\n.group:hover .group-hover\\:text-green-800 {\n  --text-opacity: 1;\n  color: #03543f;\n  color: rgba(3, 84, 63, var(--text-opacity));\n}\n.group:hover .group-hover\\:text-green-900 {\n  --text-opacity: 1;\n  color: #014737;\n  color: rgba(1, 71, 55, var(--text-opacity));\n}\n.group:hover .group-hover\\:text-teal-50 {\n  --text-opacity: 1;\n  color: #edfafa;\n  color: rgba(237, 250, 250, var(--text-opacity));\n}\n.group:hover .group-hover\\:text-teal-100 {\n  --text-opacity: 1;\n  color: #d5f5f6;\n  color: rgba(213, 245, 246, var(--text-opacity));\n}\n.group:hover .group-hover\\:text-teal-200 {\n  --text-opacity: 1;\n  color: #afecef;\n  color: rgba(175, 236, 239, var(--text-opacity));\n}\n.group:hover .group-hover\\:text-teal-300 {\n  --text-opacity: 1;\n  color: #7edce2;\n  color: rgba(126, 220, 226, var(--text-opacity));\n}\n.group:hover .group-hover\\:text-teal-400 {\n  --text-opacity: 1;\n  color: #16bdca;\n  color: rgba(22, 189, 202, var(--text-opacity));\n}\n.group:hover .group-hover\\:text-teal-500 {\n  --text-opacity: 1;\n  color: #0694a2;\n  color: rgba(6, 148, 162, var(--text-opacity));\n}\n.group:hover .group-hover\\:text-teal-600 {\n  --text-opacity: 1;\n  color: #047481;\n  color: rgba(4, 116, 129, var(--text-opacity));\n}\n.group:hover .group-hover\\:text-teal-700 {\n  --text-opacity: 1;\n  color: #036672;\n  color: rgba(3, 102, 114, var(--text-opacity));\n}\n.group:hover .group-hover\\:text-teal-800 {\n  --text-opacity: 1;\n  color: #05505c;\n  color: rgba(5, 80, 92, var(--text-opacity));\n}\n.group:hover .group-hover\\:text-teal-900 {\n  --text-opacity: 1;\n  color: #014451;\n  color: rgba(1, 68, 81, var(--text-opacity));\n}\n.group:hover .group-hover\\:text-blue-50 {\n  --text-opacity: 1;\n  color: #ebf5ff;\n  color: rgba(235, 245, 255, var(--text-opacity));\n}\n.group:hover .group-hover\\:text-blue-100 {\n  --text-opacity: 1;\n  color: #e1effe;\n  color: rgba(225, 239, 254, var(--text-opacity));\n}\n.group:hover .group-hover\\:text-blue-200 {\n  --text-opacity: 1;\n  color: #c3ddfd;\n  color: rgba(195, 221, 253, var(--text-opacity));\n}\n.group:hover .group-hover\\:text-blue-300 {\n  --text-opacity: 1;\n  color: #a4cafe;\n  color: rgba(164, 202, 254, var(--text-opacity));\n}\n.group:hover .group-hover\\:text-blue-400 {\n  --text-opacity: 1;\n  color: #76a9fa;\n  color: rgba(118, 169, 250, var(--text-opacity));\n}\n.group:hover .group-hover\\:text-blue-500 {\n  --text-opacity: 1;\n  color: #3f83f8;\n  color: rgba(63, 131, 248, var(--text-opacity));\n}\n.group:hover .group-hover\\:text-blue-600 {\n  --text-opacity: 1;\n  color: #1c64f2;\n  color: rgba(28, 100, 242, var(--text-opacity));\n}\n.group:hover .group-hover\\:text-blue-700 {\n  --text-opacity: 1;\n  color: #1a56db;\n  color: rgba(26, 86, 219, var(--text-opacity));\n}\n.group:hover .group-hover\\:text-blue-800 {\n  --text-opacity: 1;\n  color: #1e429f;\n  color: rgba(30, 66, 159, var(--text-opacity));\n}\n.group:hover .group-hover\\:text-blue-900 {\n  --text-opacity: 1;\n  color: #233876;\n  color: rgba(35, 56, 118, var(--text-opacity));\n}\n.group:hover .group-hover\\:text-indigo-50 {\n  --text-opacity: 1;\n  color: #f0f5ff;\n  color: rgba(240, 245, 255, var(--text-opacity));\n}\n.group:hover .group-hover\\:text-indigo-100 {\n  --text-opacity: 1;\n  color: #e5edff;\n  color: rgba(229, 237, 255, var(--text-opacity));\n}\n.group:hover .group-hover\\:text-indigo-200 {\n  --text-opacity: 1;\n  color: #cddbfe;\n  color: rgba(205, 219, 254, var(--text-opacity));\n}\n.group:hover .group-hover\\:text-indigo-300 {\n  --text-opacity: 1;\n  color: #b4c6fc;\n  color: rgba(180, 198, 252, var(--text-opacity));\n}\n.group:hover .group-hover\\:text-indigo-400 {\n  --text-opacity: 1;\n  color: #8da2fb;\n  color: rgba(141, 162, 251, var(--text-opacity));\n}\n.group:hover .group-hover\\:text-indigo-500 {\n  --text-opacity: 1;\n  color: #6875f5;\n  color: rgba(104, 117, 245, var(--text-opacity));\n}\n.group:hover .group-hover\\:text-indigo-600 {\n  --text-opacity: 1;\n  color: #5850ec;\n  color: rgba(88, 80, 236, var(--text-opacity));\n}\n.group:hover .group-hover\\:text-indigo-700 {\n  --text-opacity: 1;\n  color: #5145cd;\n  color: rgba(81, 69, 205, var(--text-opacity));\n}\n.group:hover .group-hover\\:text-indigo-800 {\n  --text-opacity: 1;\n  color: #42389d;\n  color: rgba(66, 56, 157, var(--text-opacity));\n}\n.group:hover .group-hover\\:text-indigo-900 {\n  --text-opacity: 1;\n  color: #362f78;\n  color: rgba(54, 47, 120, var(--text-opacity));\n}\n.group:hover .group-hover\\:text-purple-50 {\n  --text-opacity: 1;\n  color: #f6f5ff;\n  color: rgba(246, 245, 255, var(--text-opacity));\n}\n.group:hover .group-hover\\:text-purple-100 {\n  --text-opacity: 1;\n  color: #edebfe;\n  color: rgba(237, 235, 254, var(--text-opacity));\n}\n.group:hover .group-hover\\:text-purple-200 {\n  --text-opacity: 1;\n  color: #dcd7fe;\n  color: rgba(220, 215, 254, var(--text-opacity));\n}\n.group:hover .group-hover\\:text-purple-300 {\n  --text-opacity: 1;\n  color: #cabffd;\n  color: rgba(202, 191, 253, var(--text-opacity));\n}\n.group:hover .group-hover\\:text-purple-400 {\n  --text-opacity: 1;\n  color: #ac94fa;\n  color: rgba(172, 148, 250, var(--text-opacity));\n}\n.group:hover .group-hover\\:text-purple-500 {\n  --text-opacity: 1;\n  color: #9061f9;\n  color: rgba(144, 97, 249, var(--text-opacity));\n}\n.group:hover .group-hover\\:text-purple-600 {\n  --text-opacity: 1;\n  color: #7e3af2;\n  color: rgba(126, 58, 242, var(--text-opacity));\n}\n.group:hover .group-hover\\:text-purple-700 {\n  --text-opacity: 1;\n  color: #6c2bd9;\n  color: rgba(108, 43, 217, var(--text-opacity));\n}\n.group:hover .group-hover\\:text-purple-800 {\n  --text-opacity: 1;\n  color: #5521b5;\n  color: rgba(85, 33, 181, var(--text-opacity));\n}\n.group:hover .group-hover\\:text-purple-900 {\n  --text-opacity: 1;\n  color: #4a1d96;\n  color: rgba(74, 29, 150, var(--text-opacity));\n}\n.group:hover .group-hover\\:text-pink-50 {\n  --text-opacity: 1;\n  color: #fdf2f8;\n  color: rgba(253, 242, 248, var(--text-opacity));\n}\n.group:hover .group-hover\\:text-pink-100 {\n  --text-opacity: 1;\n  color: #fce8f3;\n  color: rgba(252, 232, 243, var(--text-opacity));\n}\n.group:hover .group-hover\\:text-pink-200 {\n  --text-opacity: 1;\n  color: #fad1e8;\n  color: rgba(250, 209, 232, var(--text-opacity));\n}\n.group:hover .group-hover\\:text-pink-300 {\n  --text-opacity: 1;\n  color: #f8b4d9;\n  color: rgba(248, 180, 217, var(--text-opacity));\n}\n.group:hover .group-hover\\:text-pink-400 {\n  --text-opacity: 1;\n  color: #f17eb8;\n  color: rgba(241, 126, 184, var(--text-opacity));\n}\n.group:hover .group-hover\\:text-pink-500 {\n  --text-opacity: 1;\n  color: #e74694;\n  color: rgba(231, 70, 148, var(--text-opacity));\n}\n.group:hover .group-hover\\:text-pink-600 {\n  --text-opacity: 1;\n  color: #d61f69;\n  color: rgba(214, 31, 105, var(--text-opacity));\n}\n.group:hover .group-hover\\:text-pink-700 {\n  --text-opacity: 1;\n  color: #bf125d;\n  color: rgba(191, 18, 93, var(--text-opacity));\n}\n.group:hover .group-hover\\:text-pink-800 {\n  --text-opacity: 1;\n  color: #99154b;\n  color: rgba(153, 21, 75, var(--text-opacity));\n}\n.group:hover .group-hover\\:text-pink-900 {\n  --text-opacity: 1;\n  color: #751a3d;\n  color: rgba(117, 26, 61, var(--text-opacity));\n}\n.group:hover .group-hover\\:text-cool-gray-50 {\n  --text-opacity: 1;\n  color: #f8fafc;\n  color: rgba(248, 250, 252, var(--text-opacity));\n}\n.group:hover .group-hover\\:text-cool-gray-100 {\n  --text-opacity: 1;\n  color: #f1f5f9;\n  color: rgba(241, 245, 249, var(--text-opacity));\n}\n.group:hover .group-hover\\:text-cool-gray-200 {\n  --text-opacity: 1;\n  color: #e2e8f0;\n  color: rgba(226, 232, 240, var(--text-opacity));\n}\n.group:hover .group-hover\\:text-cool-gray-300 {\n  --text-opacity: 1;\n  color: #cfd8e3;\n  color: rgba(207, 216, 227, var(--text-opacity));\n}\n.group:hover .group-hover\\:text-cool-gray-400 {\n  --text-opacity: 1;\n  color: #97a6ba;\n  color: rgba(151, 166, 186, var(--text-opacity));\n}\n.group:hover .group-hover\\:text-cool-gray-500 {\n  --text-opacity: 1;\n  color: #64748b;\n  color: rgba(100, 116, 139, var(--text-opacity));\n}\n.group:hover .group-hover\\:text-cool-gray-600 {\n  --text-opacity: 1;\n  color: #475569;\n  color: rgba(71, 85, 105, var(--text-opacity));\n}\n.group:hover .group-hover\\:text-cool-gray-700 {\n  --text-opacity: 1;\n  color: #364152;\n  color: rgba(54, 65, 82, var(--text-opacity));\n}\n.group:hover .group-hover\\:text-cool-gray-800 {\n  --text-opacity: 1;\n  color: #27303f;\n  color: rgba(39, 48, 63, var(--text-opacity));\n}\n.group:hover .group-hover\\:text-cool-gray-900 {\n  --text-opacity: 1;\n  color: #1a202e;\n  color: rgba(26, 32, 46, var(--text-opacity));\n}\n.group:focus .group-focus\\:text-current {\n  color: currentColor;\n}\n.group:focus .group-focus\\:text-transparent {\n  color: transparent;\n}\n.group:focus .group-focus\\:text-white {\n  --text-opacity: 1;\n  color: #ffffff;\n  color: rgba(255, 255, 255, var(--text-opacity));\n}\n.group:focus .group-focus\\:text-black {\n  --text-opacity: 1;\n  color: #000000;\n  color: rgba(0, 0, 0, var(--text-opacity));\n}\n.group:focus .group-focus\\:text-gray-50 {\n  --text-opacity: 1;\n  color: #f9fafb;\n  color: rgba(249, 250, 251, var(--text-opacity));\n}\n.group:focus .group-focus\\:text-gray-100 {\n  --text-opacity: 1;\n  color: #f4f5f7;\n  color: rgba(244, 245, 247, var(--text-opacity));\n}\n.group:focus .group-focus\\:text-gray-200 {\n  --text-opacity: 1;\n  color: #e5e7eb;\n  color: rgba(229, 231, 235, var(--text-opacity));\n}\n.group:focus .group-focus\\:text-gray-300 {\n  --text-opacity: 1;\n  color: #d2d6dc;\n  color: rgba(210, 214, 220, var(--text-opacity));\n}\n.group:focus .group-focus\\:text-gray-400 {\n  --text-opacity: 1;\n  color: #9fa6b2;\n  color: rgba(159, 166, 178, var(--text-opacity));\n}\n.group:focus .group-focus\\:text-gray-500 {\n  --text-opacity: 1;\n  color: #6b7280;\n  color: rgba(107, 114, 128, var(--text-opacity));\n}\n.group:focus .group-focus\\:text-gray-600 {\n  --text-opacity: 1;\n  color: #4b5563;\n  color: rgba(75, 85, 99, var(--text-opacity));\n}\n.group:focus .group-focus\\:text-gray-700 {\n  --text-opacity: 1;\n  color: #374151;\n  color: rgba(55, 65, 81, var(--text-opacity));\n}\n.group:focus .group-focus\\:text-gray-800 {\n  --text-opacity: 1;\n  color: #252f3f;\n  color: rgba(37, 47, 63, var(--text-opacity));\n}\n.group:focus .group-focus\\:text-gray-900 {\n  --text-opacity: 1;\n  color: #161e2e;\n  color: rgba(22, 30, 46, var(--text-opacity));\n}\n.group:focus .group-focus\\:text-red-50 {\n  --text-opacity: 1;\n  color: #fdf2f2;\n  color: rgba(253, 242, 242, var(--text-opacity));\n}\n.group:focus .group-focus\\:text-red-100 {\n  --text-opacity: 1;\n  color: #fde8e8;\n  color: rgba(253, 232, 232, var(--text-opacity));\n}\n.group:focus .group-focus\\:text-red-200 {\n  --text-opacity: 1;\n  color: #fbd5d5;\n  color: rgba(251, 213, 213, var(--text-opacity));\n}\n.group:focus .group-focus\\:text-red-300 {\n  --text-opacity: 1;\n  color: #f8b4b4;\n  color: rgba(248, 180, 180, var(--text-opacity));\n}\n.group:focus .group-focus\\:text-red-400 {\n  --text-opacity: 1;\n  color: #f98080;\n  color: rgba(249, 128, 128, var(--text-opacity));\n}\n.group:focus .group-focus\\:text-red-500 {\n  --text-opacity: 1;\n  color: #f05252;\n  color: rgba(240, 82, 82, var(--text-opacity));\n}\n.group:focus .group-focus\\:text-red-600 {\n  --text-opacity: 1;\n  color: #e02424;\n  color: rgba(224, 36, 36, var(--text-opacity));\n}\n.group:focus .group-focus\\:text-red-700 {\n  --text-opacity: 1;\n  color: #c81e1e;\n  color: rgba(200, 30, 30, var(--text-opacity));\n}\n.group:focus .group-focus\\:text-red-800 {\n  --text-opacity: 1;\n  color: #9b1c1c;\n  color: rgba(155, 28, 28, var(--text-opacity));\n}\n.group:focus .group-focus\\:text-red-900 {\n  --text-opacity: 1;\n  color: #771d1d;\n  color: rgba(119, 29, 29, var(--text-opacity));\n}\n.group:focus .group-focus\\:text-orange-50 {\n  --text-opacity: 1;\n  color: #fff8f1;\n  color: rgba(255, 248, 241, var(--text-opacity));\n}\n.group:focus .group-focus\\:text-orange-100 {\n  --text-opacity: 1;\n  color: #feecdc;\n  color: rgba(254, 236, 220, var(--text-opacity));\n}\n.group:focus .group-focus\\:text-orange-200 {\n  --text-opacity: 1;\n  color: #fcd9bd;\n  color: rgba(252, 217, 189, var(--text-opacity));\n}\n.group:focus .group-focus\\:text-orange-300 {\n  --text-opacity: 1;\n  color: #fdba8c;\n  color: rgba(253, 186, 140, var(--text-opacity));\n}\n.group:focus .group-focus\\:text-orange-400 {\n  --text-opacity: 1;\n  color: #ff8a4c;\n  color: rgba(255, 138, 76, var(--text-opacity));\n}\n.group:focus .group-focus\\:text-orange-500 {\n  --text-opacity: 1;\n  color: #ff5a1f;\n  color: rgba(255, 90, 31, var(--text-opacity));\n}\n.group:focus .group-focus\\:text-orange-600 {\n  --text-opacity: 1;\n  color: #d03801;\n  color: rgba(208, 56, 1, var(--text-opacity));\n}\n.group:focus .group-focus\\:text-orange-700 {\n  --text-opacity: 1;\n  color: #b43403;\n  color: rgba(180, 52, 3, var(--text-opacity));\n}\n.group:focus .group-focus\\:text-orange-800 {\n  --text-opacity: 1;\n  color: #8a2c0d;\n  color: rgba(138, 44, 13, var(--text-opacity));\n}\n.group:focus .group-focus\\:text-orange-900 {\n  --text-opacity: 1;\n  color: #73230d;\n  color: rgba(115, 35, 13, var(--text-opacity));\n}\n.group:focus .group-focus\\:text-yellow-50 {\n  --text-opacity: 1;\n  color: #fdfdea;\n  color: rgba(253, 253, 234, var(--text-opacity));\n}\n.group:focus .group-focus\\:text-yellow-100 {\n  --text-opacity: 1;\n  color: #fdf6b2;\n  color: rgba(253, 246, 178, var(--text-opacity));\n}\n.group:focus .group-focus\\:text-yellow-200 {\n  --text-opacity: 1;\n  color: #fce96a;\n  color: rgba(252, 233, 106, var(--text-opacity));\n}\n.group:focus .group-focus\\:text-yellow-300 {\n  --text-opacity: 1;\n  color: #faca15;\n  color: rgba(250, 202, 21, var(--text-opacity));\n}\n.group:focus .group-focus\\:text-yellow-400 {\n  --text-opacity: 1;\n  color: #e3a008;\n  color: rgba(227, 160, 8, var(--text-opacity));\n}\n.group:focus .group-focus\\:text-yellow-500 {\n  --text-opacity: 1;\n  color: #c27803;\n  color: rgba(194, 120, 3, var(--text-opacity));\n}\n.group:focus .group-focus\\:text-yellow-600 {\n  --text-opacity: 1;\n  color: #9f580a;\n  color: rgba(159, 88, 10, var(--text-opacity));\n}\n.group:focus .group-focus\\:text-yellow-700 {\n  --text-opacity: 1;\n  color: #8e4b10;\n  color: rgba(142, 75, 16, var(--text-opacity));\n}\n.group:focus .group-focus\\:text-yellow-800 {\n  --text-opacity: 1;\n  color: #723b13;\n  color: rgba(114, 59, 19, var(--text-opacity));\n}\n.group:focus .group-focus\\:text-yellow-900 {\n  --text-opacity: 1;\n  color: #633112;\n  color: rgba(99, 49, 18, var(--text-opacity));\n}\n.group:focus .group-focus\\:text-green-50 {\n  --text-opacity: 1;\n  color: #f3faf7;\n  color: rgba(243, 250, 247, var(--text-opacity));\n}\n.group:focus .group-focus\\:text-green-100 {\n  --text-opacity: 1;\n  color: #def7ec;\n  color: rgba(222, 247, 236, var(--text-opacity));\n}\n.group:focus .group-focus\\:text-green-200 {\n  --text-opacity: 1;\n  color: #bcf0da;\n  color: rgba(188, 240, 218, var(--text-opacity));\n}\n.group:focus .group-focus\\:text-green-300 {\n  --text-opacity: 1;\n  color: #84e1bc;\n  color: rgba(132, 225, 188, var(--text-opacity));\n}\n.group:focus .group-focus\\:text-green-400 {\n  --text-opacity: 1;\n  color: #31c48d;\n  color: rgba(49, 196, 141, var(--text-opacity));\n}\n.group:focus .group-focus\\:text-green-500 {\n  --text-opacity: 1;\n  color: #0e9f6e;\n  color: rgba(14, 159, 110, var(--text-opacity));\n}\n.group:focus .group-focus\\:text-green-600 {\n  --text-opacity: 1;\n  color: #057a55;\n  color: rgba(5, 122, 85, var(--text-opacity));\n}\n.group:focus .group-focus\\:text-green-700 {\n  --text-opacity: 1;\n  color: #046c4e;\n  color: rgba(4, 108, 78, var(--text-opacity));\n}\n.group:focus .group-focus\\:text-green-800 {\n  --text-opacity: 1;\n  color: #03543f;\n  color: rgba(3, 84, 63, var(--text-opacity));\n}\n.group:focus .group-focus\\:text-green-900 {\n  --text-opacity: 1;\n  color: #014737;\n  color: rgba(1, 71, 55, var(--text-opacity));\n}\n.group:focus .group-focus\\:text-teal-50 {\n  --text-opacity: 1;\n  color: #edfafa;\n  color: rgba(237, 250, 250, var(--text-opacity));\n}\n.group:focus .group-focus\\:text-teal-100 {\n  --text-opacity: 1;\n  color: #d5f5f6;\n  color: rgba(213, 245, 246, var(--text-opacity));\n}\n.group:focus .group-focus\\:text-teal-200 {\n  --text-opacity: 1;\n  color: #afecef;\n  color: rgba(175, 236, 239, var(--text-opacity));\n}\n.group:focus .group-focus\\:text-teal-300 {\n  --text-opacity: 1;\n  color: #7edce2;\n  color: rgba(126, 220, 226, var(--text-opacity));\n}\n.group:focus .group-focus\\:text-teal-400 {\n  --text-opacity: 1;\n  color: #16bdca;\n  color: rgba(22, 189, 202, var(--text-opacity));\n}\n.group:focus .group-focus\\:text-teal-500 {\n  --text-opacity: 1;\n  color: #0694a2;\n  color: rgba(6, 148, 162, var(--text-opacity));\n}\n.group:focus .group-focus\\:text-teal-600 {\n  --text-opacity: 1;\n  color: #047481;\n  color: rgba(4, 116, 129, var(--text-opacity));\n}\n.group:focus .group-focus\\:text-teal-700 {\n  --text-opacity: 1;\n  color: #036672;\n  color: rgba(3, 102, 114, var(--text-opacity));\n}\n.group:focus .group-focus\\:text-teal-800 {\n  --text-opacity: 1;\n  color: #05505c;\n  color: rgba(5, 80, 92, var(--text-opacity));\n}\n.group:focus .group-focus\\:text-teal-900 {\n  --text-opacity: 1;\n  color: #014451;\n  color: rgba(1, 68, 81, var(--text-opacity));\n}\n.group:focus .group-focus\\:text-blue-50 {\n  --text-opacity: 1;\n  color: #ebf5ff;\n  color: rgba(235, 245, 255, var(--text-opacity));\n}\n.group:focus .group-focus\\:text-blue-100 {\n  --text-opacity: 1;\n  color: #e1effe;\n  color: rgba(225, 239, 254, var(--text-opacity));\n}\n.group:focus .group-focus\\:text-blue-200 {\n  --text-opacity: 1;\n  color: #c3ddfd;\n  color: rgba(195, 221, 253, var(--text-opacity));\n}\n.group:focus .group-focus\\:text-blue-300 {\n  --text-opacity: 1;\n  color: #a4cafe;\n  color: rgba(164, 202, 254, var(--text-opacity));\n}\n.group:focus .group-focus\\:text-blue-400 {\n  --text-opacity: 1;\n  color: #76a9fa;\n  color: rgba(118, 169, 250, var(--text-opacity));\n}\n.group:focus .group-focus\\:text-blue-500 {\n  --text-opacity: 1;\n  color: #3f83f8;\n  color: rgba(63, 131, 248, var(--text-opacity));\n}\n.group:focus .group-focus\\:text-blue-600 {\n  --text-opacity: 1;\n  color: #1c64f2;\n  color: rgba(28, 100, 242, var(--text-opacity));\n}\n.group:focus .group-focus\\:text-blue-700 {\n  --text-opacity: 1;\n  color: #1a56db;\n  color: rgba(26, 86, 219, var(--text-opacity));\n}\n.group:focus .group-focus\\:text-blue-800 {\n  --text-opacity: 1;\n  color: #1e429f;\n  color: rgba(30, 66, 159, var(--text-opacity));\n}\n.group:focus .group-focus\\:text-blue-900 {\n  --text-opacity: 1;\n  color: #233876;\n  color: rgba(35, 56, 118, var(--text-opacity));\n}\n.group:focus .group-focus\\:text-indigo-50 {\n  --text-opacity: 1;\n  color: #f0f5ff;\n  color: rgba(240, 245, 255, var(--text-opacity));\n}\n.group:focus .group-focus\\:text-indigo-100 {\n  --text-opacity: 1;\n  color: #e5edff;\n  color: rgba(229, 237, 255, var(--text-opacity));\n}\n.group:focus .group-focus\\:text-indigo-200 {\n  --text-opacity: 1;\n  color: #cddbfe;\n  color: rgba(205, 219, 254, var(--text-opacity));\n}\n.group:focus .group-focus\\:text-indigo-300 {\n  --text-opacity: 1;\n  color: #b4c6fc;\n  color: rgba(180, 198, 252, var(--text-opacity));\n}\n.group:focus .group-focus\\:text-indigo-400 {\n  --text-opacity: 1;\n  color: #8da2fb;\n  color: rgba(141, 162, 251, var(--text-opacity));\n}\n.group:focus .group-focus\\:text-indigo-500 {\n  --text-opacity: 1;\n  color: #6875f5;\n  color: rgba(104, 117, 245, var(--text-opacity));\n}\n.group:focus .group-focus\\:text-indigo-600 {\n  --text-opacity: 1;\n  color: #5850ec;\n  color: rgba(88, 80, 236, var(--text-opacity));\n}\n.group:focus .group-focus\\:text-indigo-700 {\n  --text-opacity: 1;\n  color: #5145cd;\n  color: rgba(81, 69, 205, var(--text-opacity));\n}\n.group:focus .group-focus\\:text-indigo-800 {\n  --text-opacity: 1;\n  color: #42389d;\n  color: rgba(66, 56, 157, var(--text-opacity));\n}\n.group:focus .group-focus\\:text-indigo-900 {\n  --text-opacity: 1;\n  color: #362f78;\n  color: rgba(54, 47, 120, var(--text-opacity));\n}\n.group:focus .group-focus\\:text-purple-50 {\n  --text-opacity: 1;\n  color: #f6f5ff;\n  color: rgba(246, 245, 255, var(--text-opacity));\n}\n.group:focus .group-focus\\:text-purple-100 {\n  --text-opacity: 1;\n  color: #edebfe;\n  color: rgba(237, 235, 254, var(--text-opacity));\n}\n.group:focus .group-focus\\:text-purple-200 {\n  --text-opacity: 1;\n  color: #dcd7fe;\n  color: rgba(220, 215, 254, var(--text-opacity));\n}\n.group:focus .group-focus\\:text-purple-300 {\n  --text-opacity: 1;\n  color: #cabffd;\n  color: rgba(202, 191, 253, var(--text-opacity));\n}\n.group:focus .group-focus\\:text-purple-400 {\n  --text-opacity: 1;\n  color: #ac94fa;\n  color: rgba(172, 148, 250, var(--text-opacity));\n}\n.group:focus .group-focus\\:text-purple-500 {\n  --text-opacity: 1;\n  color: #9061f9;\n  color: rgba(144, 97, 249, var(--text-opacity));\n}\n.group:focus .group-focus\\:text-purple-600 {\n  --text-opacity: 1;\n  color: #7e3af2;\n  color: rgba(126, 58, 242, var(--text-opacity));\n}\n.group:focus .group-focus\\:text-purple-700 {\n  --text-opacity: 1;\n  color: #6c2bd9;\n  color: rgba(108, 43, 217, var(--text-opacity));\n}\n.group:focus .group-focus\\:text-purple-800 {\n  --text-opacity: 1;\n  color: #5521b5;\n  color: rgba(85, 33, 181, var(--text-opacity));\n}\n.group:focus .group-focus\\:text-purple-900 {\n  --text-opacity: 1;\n  color: #4a1d96;\n  color: rgba(74, 29, 150, var(--text-opacity));\n}\n.group:focus .group-focus\\:text-pink-50 {\n  --text-opacity: 1;\n  color: #fdf2f8;\n  color: rgba(253, 242, 248, var(--text-opacity));\n}\n.group:focus .group-focus\\:text-pink-100 {\n  --text-opacity: 1;\n  color: #fce8f3;\n  color: rgba(252, 232, 243, var(--text-opacity));\n}\n.group:focus .group-focus\\:text-pink-200 {\n  --text-opacity: 1;\n  color: #fad1e8;\n  color: rgba(250, 209, 232, var(--text-opacity));\n}\n.group:focus .group-focus\\:text-pink-300 {\n  --text-opacity: 1;\n  color: #f8b4d9;\n  color: rgba(248, 180, 217, var(--text-opacity));\n}\n.group:focus .group-focus\\:text-pink-400 {\n  --text-opacity: 1;\n  color: #f17eb8;\n  color: rgba(241, 126, 184, var(--text-opacity));\n}\n.group:focus .group-focus\\:text-pink-500 {\n  --text-opacity: 1;\n  color: #e74694;\n  color: rgba(231, 70, 148, var(--text-opacity));\n}\n.group:focus .group-focus\\:text-pink-600 {\n  --text-opacity: 1;\n  color: #d61f69;\n  color: rgba(214, 31, 105, var(--text-opacity));\n}\n.group:focus .group-focus\\:text-pink-700 {\n  --text-opacity: 1;\n  color: #bf125d;\n  color: rgba(191, 18, 93, var(--text-opacity));\n}\n.group:focus .group-focus\\:text-pink-800 {\n  --text-opacity: 1;\n  color: #99154b;\n  color: rgba(153, 21, 75, var(--text-opacity));\n}\n.group:focus .group-focus\\:text-pink-900 {\n  --text-opacity: 1;\n  color: #751a3d;\n  color: rgba(117, 26, 61, var(--text-opacity));\n}\n.group:focus .group-focus\\:text-cool-gray-50 {\n  --text-opacity: 1;\n  color: #f8fafc;\n  color: rgba(248, 250, 252, var(--text-opacity));\n}\n.group:focus .group-focus\\:text-cool-gray-100 {\n  --text-opacity: 1;\n  color: #f1f5f9;\n  color: rgba(241, 245, 249, var(--text-opacity));\n}\n.group:focus .group-focus\\:text-cool-gray-200 {\n  --text-opacity: 1;\n  color: #e2e8f0;\n  color: rgba(226, 232, 240, var(--text-opacity));\n}\n.group:focus .group-focus\\:text-cool-gray-300 {\n  --text-opacity: 1;\n  color: #cfd8e3;\n  color: rgba(207, 216, 227, var(--text-opacity));\n}\n.group:focus .group-focus\\:text-cool-gray-400 {\n  --text-opacity: 1;\n  color: #97a6ba;\n  color: rgba(151, 166, 186, var(--text-opacity));\n}\n.group:focus .group-focus\\:text-cool-gray-500 {\n  --text-opacity: 1;\n  color: #64748b;\n  color: rgba(100, 116, 139, var(--text-opacity));\n}\n.group:focus .group-focus\\:text-cool-gray-600 {\n  --text-opacity: 1;\n  color: #475569;\n  color: rgba(71, 85, 105, var(--text-opacity));\n}\n.group:focus .group-focus\\:text-cool-gray-700 {\n  --text-opacity: 1;\n  color: #364152;\n  color: rgba(54, 65, 82, var(--text-opacity));\n}\n.group:focus .group-focus\\:text-cool-gray-800 {\n  --text-opacity: 1;\n  color: #27303f;\n  color: rgba(39, 48, 63, var(--text-opacity));\n}\n.group:focus .group-focus\\:text-cool-gray-900 {\n  --text-opacity: 1;\n  color: #1a202e;\n  color: rgba(26, 32, 46, var(--text-opacity));\n}\n.hover\\:text-current:hover {\n  color: currentColor;\n}\n.hover\\:text-transparent:hover {\n  color: transparent;\n}\n.hover\\:text-white:hover {\n  --text-opacity: 1;\n  color: #ffffff;\n  color: rgba(255, 255, 255, var(--text-opacity));\n}\n.hover\\:text-black:hover {\n  --text-opacity: 1;\n  color: #000000;\n  color: rgba(0, 0, 0, var(--text-opacity));\n}\n.hover\\:text-gray-50:hover {\n  --text-opacity: 1;\n  color: #f9fafb;\n  color: rgba(249, 250, 251, var(--text-opacity));\n}\n.hover\\:text-gray-100:hover {\n  --text-opacity: 1;\n  color: #f4f5f7;\n  color: rgba(244, 245, 247, var(--text-opacity));\n}\n.hover\\:text-gray-200:hover {\n  --text-opacity: 1;\n  color: #e5e7eb;\n  color: rgba(229, 231, 235, var(--text-opacity));\n}\n.hover\\:text-gray-300:hover {\n  --text-opacity: 1;\n  color: #d2d6dc;\n  color: rgba(210, 214, 220, var(--text-opacity));\n}\n.hover\\:text-gray-400:hover {\n  --text-opacity: 1;\n  color: #9fa6b2;\n  color: rgba(159, 166, 178, var(--text-opacity));\n}\n.hover\\:text-gray-500:hover {\n  --text-opacity: 1;\n  color: #6b7280;\n  color: rgba(107, 114, 128, var(--text-opacity));\n}\n.hover\\:text-gray-600:hover {\n  --text-opacity: 1;\n  color: #4b5563;\n  color: rgba(75, 85, 99, var(--text-opacity));\n}\n.hover\\:text-gray-700:hover {\n  --text-opacity: 1;\n  color: #374151;\n  color: rgba(55, 65, 81, var(--text-opacity));\n}\n.hover\\:text-gray-800:hover {\n  --text-opacity: 1;\n  color: #252f3f;\n  color: rgba(37, 47, 63, var(--text-opacity));\n}\n.hover\\:text-gray-900:hover {\n  --text-opacity: 1;\n  color: #161e2e;\n  color: rgba(22, 30, 46, var(--text-opacity));\n}\n.hover\\:text-red-50:hover {\n  --text-opacity: 1;\n  color: #fdf2f2;\n  color: rgba(253, 242, 242, var(--text-opacity));\n}\n.hover\\:text-red-100:hover {\n  --text-opacity: 1;\n  color: #fde8e8;\n  color: rgba(253, 232, 232, var(--text-opacity));\n}\n.hover\\:text-red-200:hover {\n  --text-opacity: 1;\n  color: #fbd5d5;\n  color: rgba(251, 213, 213, var(--text-opacity));\n}\n.hover\\:text-red-300:hover {\n  --text-opacity: 1;\n  color: #f8b4b4;\n  color: rgba(248, 180, 180, var(--text-opacity));\n}\n.hover\\:text-red-400:hover {\n  --text-opacity: 1;\n  color: #f98080;\n  color: rgba(249, 128, 128, var(--text-opacity));\n}\n.hover\\:text-red-500:hover {\n  --text-opacity: 1;\n  color: #f05252;\n  color: rgba(240, 82, 82, var(--text-opacity));\n}\n.hover\\:text-red-600:hover {\n  --text-opacity: 1;\n  color: #e02424;\n  color: rgba(224, 36, 36, var(--text-opacity));\n}\n.hover\\:text-red-700:hover {\n  --text-opacity: 1;\n  color: #c81e1e;\n  color: rgba(200, 30, 30, var(--text-opacity));\n}\n.hover\\:text-red-800:hover {\n  --text-opacity: 1;\n  color: #9b1c1c;\n  color: rgba(155, 28, 28, var(--text-opacity));\n}\n.hover\\:text-red-900:hover {\n  --text-opacity: 1;\n  color: #771d1d;\n  color: rgba(119, 29, 29, var(--text-opacity));\n}\n.hover\\:text-orange-50:hover {\n  --text-opacity: 1;\n  color: #fff8f1;\n  color: rgba(255, 248, 241, var(--text-opacity));\n}\n.hover\\:text-orange-100:hover {\n  --text-opacity: 1;\n  color: #feecdc;\n  color: rgba(254, 236, 220, var(--text-opacity));\n}\n.hover\\:text-orange-200:hover {\n  --text-opacity: 1;\n  color: #fcd9bd;\n  color: rgba(252, 217, 189, var(--text-opacity));\n}\n.hover\\:text-orange-300:hover {\n  --text-opacity: 1;\n  color: #fdba8c;\n  color: rgba(253, 186, 140, var(--text-opacity));\n}\n.hover\\:text-orange-400:hover {\n  --text-opacity: 1;\n  color: #ff8a4c;\n  color: rgba(255, 138, 76, var(--text-opacity));\n}\n.hover\\:text-orange-500:hover {\n  --text-opacity: 1;\n  color: #ff5a1f;\n  color: rgba(255, 90, 31, var(--text-opacity));\n}\n.hover\\:text-orange-600:hover {\n  --text-opacity: 1;\n  color: #d03801;\n  color: rgba(208, 56, 1, var(--text-opacity));\n}\n.hover\\:text-orange-700:hover {\n  --text-opacity: 1;\n  color: #b43403;\n  color: rgba(180, 52, 3, var(--text-opacity));\n}\n.hover\\:text-orange-800:hover {\n  --text-opacity: 1;\n  color: #8a2c0d;\n  color: rgba(138, 44, 13, var(--text-opacity));\n}\n.hover\\:text-orange-900:hover {\n  --text-opacity: 1;\n  color: #73230d;\n  color: rgba(115, 35, 13, var(--text-opacity));\n}\n.hover\\:text-yellow-50:hover {\n  --text-opacity: 1;\n  color: #fdfdea;\n  color: rgba(253, 253, 234, var(--text-opacity));\n}\n.hover\\:text-yellow-100:hover {\n  --text-opacity: 1;\n  color: #fdf6b2;\n  color: rgba(253, 246, 178, var(--text-opacity));\n}\n.hover\\:text-yellow-200:hover {\n  --text-opacity: 1;\n  color: #fce96a;\n  color: rgba(252, 233, 106, var(--text-opacity));\n}\n.hover\\:text-yellow-300:hover {\n  --text-opacity: 1;\n  color: #faca15;\n  color: rgba(250, 202, 21, var(--text-opacity));\n}\n.hover\\:text-yellow-400:hover {\n  --text-opacity: 1;\n  color: #e3a008;\n  color: rgba(227, 160, 8, var(--text-opacity));\n}\n.hover\\:text-yellow-500:hover {\n  --text-opacity: 1;\n  color: #c27803;\n  color: rgba(194, 120, 3, var(--text-opacity));\n}\n.hover\\:text-yellow-600:hover {\n  --text-opacity: 1;\n  color: #9f580a;\n  color: rgba(159, 88, 10, var(--text-opacity));\n}\n.hover\\:text-yellow-700:hover {\n  --text-opacity: 1;\n  color: #8e4b10;\n  color: rgba(142, 75, 16, var(--text-opacity));\n}\n.hover\\:text-yellow-800:hover {\n  --text-opacity: 1;\n  color: #723b13;\n  color: rgba(114, 59, 19, var(--text-opacity));\n}\n.hover\\:text-yellow-900:hover {\n  --text-opacity: 1;\n  color: #633112;\n  color: rgba(99, 49, 18, var(--text-opacity));\n}\n.hover\\:text-green-50:hover {\n  --text-opacity: 1;\n  color: #f3faf7;\n  color: rgba(243, 250, 247, var(--text-opacity));\n}\n.hover\\:text-green-100:hover {\n  --text-opacity: 1;\n  color: #def7ec;\n  color: rgba(222, 247, 236, var(--text-opacity));\n}\n.hover\\:text-green-200:hover {\n  --text-opacity: 1;\n  color: #bcf0da;\n  color: rgba(188, 240, 218, var(--text-opacity));\n}\n.hover\\:text-green-300:hover {\n  --text-opacity: 1;\n  color: #84e1bc;\n  color: rgba(132, 225, 188, var(--text-opacity));\n}\n.hover\\:text-green-400:hover {\n  --text-opacity: 1;\n  color: #31c48d;\n  color: rgba(49, 196, 141, var(--text-opacity));\n}\n.hover\\:text-green-500:hover {\n  --text-opacity: 1;\n  color: #0e9f6e;\n  color: rgba(14, 159, 110, var(--text-opacity));\n}\n.hover\\:text-green-600:hover {\n  --text-opacity: 1;\n  color: #057a55;\n  color: rgba(5, 122, 85, var(--text-opacity));\n}\n.hover\\:text-green-700:hover {\n  --text-opacity: 1;\n  color: #046c4e;\n  color: rgba(4, 108, 78, var(--text-opacity));\n}\n.hover\\:text-green-800:hover {\n  --text-opacity: 1;\n  color: #03543f;\n  color: rgba(3, 84, 63, var(--text-opacity));\n}\n.hover\\:text-green-900:hover {\n  --text-opacity: 1;\n  color: #014737;\n  color: rgba(1, 71, 55, var(--text-opacity));\n}\n.hover\\:text-teal-50:hover {\n  --text-opacity: 1;\n  color: #edfafa;\n  color: rgba(237, 250, 250, var(--text-opacity));\n}\n.hover\\:text-teal-100:hover {\n  --text-opacity: 1;\n  color: #d5f5f6;\n  color: rgba(213, 245, 246, var(--text-opacity));\n}\n.hover\\:text-teal-200:hover {\n  --text-opacity: 1;\n  color: #afecef;\n  color: rgba(175, 236, 239, var(--text-opacity));\n}\n.hover\\:text-teal-300:hover {\n  --text-opacity: 1;\n  color: #7edce2;\n  color: rgba(126, 220, 226, var(--text-opacity));\n}\n.hover\\:text-teal-400:hover {\n  --text-opacity: 1;\n  color: #16bdca;\n  color: rgba(22, 189, 202, var(--text-opacity));\n}\n.hover\\:text-teal-500:hover {\n  --text-opacity: 1;\n  color: #0694a2;\n  color: rgba(6, 148, 162, var(--text-opacity));\n}\n.hover\\:text-teal-600:hover {\n  --text-opacity: 1;\n  color: #047481;\n  color: rgba(4, 116, 129, var(--text-opacity));\n}\n.hover\\:text-teal-700:hover {\n  --text-opacity: 1;\n  color: #036672;\n  color: rgba(3, 102, 114, var(--text-opacity));\n}\n.hover\\:text-teal-800:hover {\n  --text-opacity: 1;\n  color: #05505c;\n  color: rgba(5, 80, 92, var(--text-opacity));\n}\n.hover\\:text-teal-900:hover {\n  --text-opacity: 1;\n  color: #014451;\n  color: rgba(1, 68, 81, var(--text-opacity));\n}\n.hover\\:text-blue-50:hover {\n  --text-opacity: 1;\n  color: #ebf5ff;\n  color: rgba(235, 245, 255, var(--text-opacity));\n}\n.hover\\:text-blue-100:hover {\n  --text-opacity: 1;\n  color: #e1effe;\n  color: rgba(225, 239, 254, var(--text-opacity));\n}\n.hover\\:text-blue-200:hover {\n  --text-opacity: 1;\n  color: #c3ddfd;\n  color: rgba(195, 221, 253, var(--text-opacity));\n}\n.hover\\:text-blue-300:hover {\n  --text-opacity: 1;\n  color: #a4cafe;\n  color: rgba(164, 202, 254, var(--text-opacity));\n}\n.hover\\:text-blue-400:hover {\n  --text-opacity: 1;\n  color: #76a9fa;\n  color: rgba(118, 169, 250, var(--text-opacity));\n}\n.hover\\:text-blue-500:hover {\n  --text-opacity: 1;\n  color: #3f83f8;\n  color: rgba(63, 131, 248, var(--text-opacity));\n}\n.hover\\:text-blue-600:hover {\n  --text-opacity: 1;\n  color: #1c64f2;\n  color: rgba(28, 100, 242, var(--text-opacity));\n}\n.hover\\:text-blue-700:hover {\n  --text-opacity: 1;\n  color: #1a56db;\n  color: rgba(26, 86, 219, var(--text-opacity));\n}\n.hover\\:text-blue-800:hover {\n  --text-opacity: 1;\n  color: #1e429f;\n  color: rgba(30, 66, 159, var(--text-opacity));\n}\n.hover\\:text-blue-900:hover {\n  --text-opacity: 1;\n  color: #233876;\n  color: rgba(35, 56, 118, var(--text-opacity));\n}\n.hover\\:text-indigo-50:hover {\n  --text-opacity: 1;\n  color: #f0f5ff;\n  color: rgba(240, 245, 255, var(--text-opacity));\n}\n.hover\\:text-indigo-100:hover {\n  --text-opacity: 1;\n  color: #e5edff;\n  color: rgba(229, 237, 255, var(--text-opacity));\n}\n.hover\\:text-indigo-200:hover {\n  --text-opacity: 1;\n  color: #cddbfe;\n  color: rgba(205, 219, 254, var(--text-opacity));\n}\n.hover\\:text-indigo-300:hover {\n  --text-opacity: 1;\n  color: #b4c6fc;\n  color: rgba(180, 198, 252, var(--text-opacity));\n}\n.hover\\:text-indigo-400:hover {\n  --text-opacity: 1;\n  color: #8da2fb;\n  color: rgba(141, 162, 251, var(--text-opacity));\n}\n.hover\\:text-indigo-500:hover {\n  --text-opacity: 1;\n  color: #6875f5;\n  color: rgba(104, 117, 245, var(--text-opacity));\n}\n.hover\\:text-indigo-600:hover {\n  --text-opacity: 1;\n  color: #5850ec;\n  color: rgba(88, 80, 236, var(--text-opacity));\n}\n.hover\\:text-indigo-700:hover {\n  --text-opacity: 1;\n  color: #5145cd;\n  color: rgba(81, 69, 205, var(--text-opacity));\n}\n.hover\\:text-indigo-800:hover {\n  --text-opacity: 1;\n  color: #42389d;\n  color: rgba(66, 56, 157, var(--text-opacity));\n}\n.hover\\:text-indigo-900:hover {\n  --text-opacity: 1;\n  color: #362f78;\n  color: rgba(54, 47, 120, var(--text-opacity));\n}\n.hover\\:text-purple-50:hover {\n  --text-opacity: 1;\n  color: #f6f5ff;\n  color: rgba(246, 245, 255, var(--text-opacity));\n}\n.hover\\:text-purple-100:hover {\n  --text-opacity: 1;\n  color: #edebfe;\n  color: rgba(237, 235, 254, var(--text-opacity));\n}\n.hover\\:text-purple-200:hover {\n  --text-opacity: 1;\n  color: #dcd7fe;\n  color: rgba(220, 215, 254, var(--text-opacity));\n}\n.hover\\:text-purple-300:hover {\n  --text-opacity: 1;\n  color: #cabffd;\n  color: rgba(202, 191, 253, var(--text-opacity));\n}\n.hover\\:text-purple-400:hover {\n  --text-opacity: 1;\n  color: #ac94fa;\n  color: rgba(172, 148, 250, var(--text-opacity));\n}\n.hover\\:text-purple-500:hover {\n  --text-opacity: 1;\n  color: #9061f9;\n  color: rgba(144, 97, 249, var(--text-opacity));\n}\n.hover\\:text-purple-600:hover {\n  --text-opacity: 1;\n  color: #7e3af2;\n  color: rgba(126, 58, 242, var(--text-opacity));\n}\n.hover\\:text-purple-700:hover {\n  --text-opacity: 1;\n  color: #6c2bd9;\n  color: rgba(108, 43, 217, var(--text-opacity));\n}\n.hover\\:text-purple-800:hover {\n  --text-opacity: 1;\n  color: #5521b5;\n  color: rgba(85, 33, 181, var(--text-opacity));\n}\n.hover\\:text-purple-900:hover {\n  --text-opacity: 1;\n  color: #4a1d96;\n  color: rgba(74, 29, 150, var(--text-opacity));\n}\n.hover\\:text-pink-50:hover {\n  --text-opacity: 1;\n  color: #fdf2f8;\n  color: rgba(253, 242, 248, var(--text-opacity));\n}\n.hover\\:text-pink-100:hover {\n  --text-opacity: 1;\n  color: #fce8f3;\n  color: rgba(252, 232, 243, var(--text-opacity));\n}\n.hover\\:text-pink-200:hover {\n  --text-opacity: 1;\n  color: #fad1e8;\n  color: rgba(250, 209, 232, var(--text-opacity));\n}\n.hover\\:text-pink-300:hover {\n  --text-opacity: 1;\n  color: #f8b4d9;\n  color: rgba(248, 180, 217, var(--text-opacity));\n}\n.hover\\:text-pink-400:hover {\n  --text-opacity: 1;\n  color: #f17eb8;\n  color: rgba(241, 126, 184, var(--text-opacity));\n}\n.hover\\:text-pink-500:hover {\n  --text-opacity: 1;\n  color: #e74694;\n  color: rgba(231, 70, 148, var(--text-opacity));\n}\n.hover\\:text-pink-600:hover {\n  --text-opacity: 1;\n  color: #d61f69;\n  color: rgba(214, 31, 105, var(--text-opacity));\n}\n.hover\\:text-pink-700:hover {\n  --text-opacity: 1;\n  color: #bf125d;\n  color: rgba(191, 18, 93, var(--text-opacity));\n}\n.hover\\:text-pink-800:hover {\n  --text-opacity: 1;\n  color: #99154b;\n  color: rgba(153, 21, 75, var(--text-opacity));\n}\n.hover\\:text-pink-900:hover {\n  --text-opacity: 1;\n  color: #751a3d;\n  color: rgba(117, 26, 61, var(--text-opacity));\n}\n.hover\\:text-cool-gray-50:hover {\n  --text-opacity: 1;\n  color: #f8fafc;\n  color: rgba(248, 250, 252, var(--text-opacity));\n}\n.hover\\:text-cool-gray-100:hover {\n  --text-opacity: 1;\n  color: #f1f5f9;\n  color: rgba(241, 245, 249, var(--text-opacity));\n}\n.hover\\:text-cool-gray-200:hover {\n  --text-opacity: 1;\n  color: #e2e8f0;\n  color: rgba(226, 232, 240, var(--text-opacity));\n}\n.hover\\:text-cool-gray-300:hover {\n  --text-opacity: 1;\n  color: #cfd8e3;\n  color: rgba(207, 216, 227, var(--text-opacity));\n}\n.hover\\:text-cool-gray-400:hover {\n  --text-opacity: 1;\n  color: #97a6ba;\n  color: rgba(151, 166, 186, var(--text-opacity));\n}\n.hover\\:text-cool-gray-500:hover {\n  --text-opacity: 1;\n  color: #64748b;\n  color: rgba(100, 116, 139, var(--text-opacity));\n}\n.hover\\:text-cool-gray-600:hover {\n  --text-opacity: 1;\n  color: #475569;\n  color: rgba(71, 85, 105, var(--text-opacity));\n}\n.hover\\:text-cool-gray-700:hover {\n  --text-opacity: 1;\n  color: #364152;\n  color: rgba(54, 65, 82, var(--text-opacity));\n}\n.hover\\:text-cool-gray-800:hover {\n  --text-opacity: 1;\n  color: #27303f;\n  color: rgba(39, 48, 63, var(--text-opacity));\n}\n.hover\\:text-cool-gray-900:hover {\n  --text-opacity: 1;\n  color: #1a202e;\n  color: rgba(26, 32, 46, var(--text-opacity));\n}\n.focus-within\\:text-current:focus-within {\n  color: currentColor;\n}\n.focus-within\\:text-transparent:focus-within {\n  color: transparent;\n}\n.focus-within\\:text-white:focus-within {\n  --text-opacity: 1;\n  color: #ffffff;\n  color: rgba(255, 255, 255, var(--text-opacity));\n}\n.focus-within\\:text-black:focus-within {\n  --text-opacity: 1;\n  color: #000000;\n  color: rgba(0, 0, 0, var(--text-opacity));\n}\n.focus-within\\:text-gray-50:focus-within {\n  --text-opacity: 1;\n  color: #f9fafb;\n  color: rgba(249, 250, 251, var(--text-opacity));\n}\n.focus-within\\:text-gray-100:focus-within {\n  --text-opacity: 1;\n  color: #f4f5f7;\n  color: rgba(244, 245, 247, var(--text-opacity));\n}\n.focus-within\\:text-gray-200:focus-within {\n  --text-opacity: 1;\n  color: #e5e7eb;\n  color: rgba(229, 231, 235, var(--text-opacity));\n}\n.focus-within\\:text-gray-300:focus-within {\n  --text-opacity: 1;\n  color: #d2d6dc;\n  color: rgba(210, 214, 220, var(--text-opacity));\n}\n.focus-within\\:text-gray-400:focus-within {\n  --text-opacity: 1;\n  color: #9fa6b2;\n  color: rgba(159, 166, 178, var(--text-opacity));\n}\n.focus-within\\:text-gray-500:focus-within {\n  --text-opacity: 1;\n  color: #6b7280;\n  color: rgba(107, 114, 128, var(--text-opacity));\n}\n.focus-within\\:text-gray-600:focus-within {\n  --text-opacity: 1;\n  color: #4b5563;\n  color: rgba(75, 85, 99, var(--text-opacity));\n}\n.focus-within\\:text-gray-700:focus-within {\n  --text-opacity: 1;\n  color: #374151;\n  color: rgba(55, 65, 81, var(--text-opacity));\n}\n.focus-within\\:text-gray-800:focus-within {\n  --text-opacity: 1;\n  color: #252f3f;\n  color: rgba(37, 47, 63, var(--text-opacity));\n}\n.focus-within\\:text-gray-900:focus-within {\n  --text-opacity: 1;\n  color: #161e2e;\n  color: rgba(22, 30, 46, var(--text-opacity));\n}\n.focus-within\\:text-red-50:focus-within {\n  --text-opacity: 1;\n  color: #fdf2f2;\n  color: rgba(253, 242, 242, var(--text-opacity));\n}\n.focus-within\\:text-red-100:focus-within {\n  --text-opacity: 1;\n  color: #fde8e8;\n  color: rgba(253, 232, 232, var(--text-opacity));\n}\n.focus-within\\:text-red-200:focus-within {\n  --text-opacity: 1;\n  color: #fbd5d5;\n  color: rgba(251, 213, 213, var(--text-opacity));\n}\n.focus-within\\:text-red-300:focus-within {\n  --text-opacity: 1;\n  color: #f8b4b4;\n  color: rgba(248, 180, 180, var(--text-opacity));\n}\n.focus-within\\:text-red-400:focus-within {\n  --text-opacity: 1;\n  color: #f98080;\n  color: rgba(249, 128, 128, var(--text-opacity));\n}\n.focus-within\\:text-red-500:focus-within {\n  --text-opacity: 1;\n  color: #f05252;\n  color: rgba(240, 82, 82, var(--text-opacity));\n}\n.focus-within\\:text-red-600:focus-within {\n  --text-opacity: 1;\n  color: #e02424;\n  color: rgba(224, 36, 36, var(--text-opacity));\n}\n.focus-within\\:text-red-700:focus-within {\n  --text-opacity: 1;\n  color: #c81e1e;\n  color: rgba(200, 30, 30, var(--text-opacity));\n}\n.focus-within\\:text-red-800:focus-within {\n  --text-opacity: 1;\n  color: #9b1c1c;\n  color: rgba(155, 28, 28, var(--text-opacity));\n}\n.focus-within\\:text-red-900:focus-within {\n  --text-opacity: 1;\n  color: #771d1d;\n  color: rgba(119, 29, 29, var(--text-opacity));\n}\n.focus-within\\:text-orange-50:focus-within {\n  --text-opacity: 1;\n  color: #fff8f1;\n  color: rgba(255, 248, 241, var(--text-opacity));\n}\n.focus-within\\:text-orange-100:focus-within {\n  --text-opacity: 1;\n  color: #feecdc;\n  color: rgba(254, 236, 220, var(--text-opacity));\n}\n.focus-within\\:text-orange-200:focus-within {\n  --text-opacity: 1;\n  color: #fcd9bd;\n  color: rgba(252, 217, 189, var(--text-opacity));\n}\n.focus-within\\:text-orange-300:focus-within {\n  --text-opacity: 1;\n  color: #fdba8c;\n  color: rgba(253, 186, 140, var(--text-opacity));\n}\n.focus-within\\:text-orange-400:focus-within {\n  --text-opacity: 1;\n  color: #ff8a4c;\n  color: rgba(255, 138, 76, var(--text-opacity));\n}\n.focus-within\\:text-orange-500:focus-within {\n  --text-opacity: 1;\n  color: #ff5a1f;\n  color: rgba(255, 90, 31, var(--text-opacity));\n}\n.focus-within\\:text-orange-600:focus-within {\n  --text-opacity: 1;\n  color: #d03801;\n  color: rgba(208, 56, 1, var(--text-opacity));\n}\n.focus-within\\:text-orange-700:focus-within {\n  --text-opacity: 1;\n  color: #b43403;\n  color: rgba(180, 52, 3, var(--text-opacity));\n}\n.focus-within\\:text-orange-800:focus-within {\n  --text-opacity: 1;\n  color: #8a2c0d;\n  color: rgba(138, 44, 13, var(--text-opacity));\n}\n.focus-within\\:text-orange-900:focus-within {\n  --text-opacity: 1;\n  color: #73230d;\n  color: rgba(115, 35, 13, var(--text-opacity));\n}\n.focus-within\\:text-yellow-50:focus-within {\n  --text-opacity: 1;\n  color: #fdfdea;\n  color: rgba(253, 253, 234, var(--text-opacity));\n}\n.focus-within\\:text-yellow-100:focus-within {\n  --text-opacity: 1;\n  color: #fdf6b2;\n  color: rgba(253, 246, 178, var(--text-opacity));\n}\n.focus-within\\:text-yellow-200:focus-within {\n  --text-opacity: 1;\n  color: #fce96a;\n  color: rgba(252, 233, 106, var(--text-opacity));\n}\n.focus-within\\:text-yellow-300:focus-within {\n  --text-opacity: 1;\n  color: #faca15;\n  color: rgba(250, 202, 21, var(--text-opacity));\n}\n.focus-within\\:text-yellow-400:focus-within {\n  --text-opacity: 1;\n  color: #e3a008;\n  color: rgba(227, 160, 8, var(--text-opacity));\n}\n.focus-within\\:text-yellow-500:focus-within {\n  --text-opacity: 1;\n  color: #c27803;\n  color: rgba(194, 120, 3, var(--text-opacity));\n}\n.focus-within\\:text-yellow-600:focus-within {\n  --text-opacity: 1;\n  color: #9f580a;\n  color: rgba(159, 88, 10, var(--text-opacity));\n}\n.focus-within\\:text-yellow-700:focus-within {\n  --text-opacity: 1;\n  color: #8e4b10;\n  color: rgba(142, 75, 16, var(--text-opacity));\n}\n.focus-within\\:text-yellow-800:focus-within {\n  --text-opacity: 1;\n  color: #723b13;\n  color: rgba(114, 59, 19, var(--text-opacity));\n}\n.focus-within\\:text-yellow-900:focus-within {\n  --text-opacity: 1;\n  color: #633112;\n  color: rgba(99, 49, 18, var(--text-opacity));\n}\n.focus-within\\:text-green-50:focus-within {\n  --text-opacity: 1;\n  color: #f3faf7;\n  color: rgba(243, 250, 247, var(--text-opacity));\n}\n.focus-within\\:text-green-100:focus-within {\n  --text-opacity: 1;\n  color: #def7ec;\n  color: rgba(222, 247, 236, var(--text-opacity));\n}\n.focus-within\\:text-green-200:focus-within {\n  --text-opacity: 1;\n  color: #bcf0da;\n  color: rgba(188, 240, 218, var(--text-opacity));\n}\n.focus-within\\:text-green-300:focus-within {\n  --text-opacity: 1;\n  color: #84e1bc;\n  color: rgba(132, 225, 188, var(--text-opacity));\n}\n.focus-within\\:text-green-400:focus-within {\n  --text-opacity: 1;\n  color: #31c48d;\n  color: rgba(49, 196, 141, var(--text-opacity));\n}\n.focus-within\\:text-green-500:focus-within {\n  --text-opacity: 1;\n  color: #0e9f6e;\n  color: rgba(14, 159, 110, var(--text-opacity));\n}\n.focus-within\\:text-green-600:focus-within {\n  --text-opacity: 1;\n  color: #057a55;\n  color: rgba(5, 122, 85, var(--text-opacity));\n}\n.focus-within\\:text-green-700:focus-within {\n  --text-opacity: 1;\n  color: #046c4e;\n  color: rgba(4, 108, 78, var(--text-opacity));\n}\n.focus-within\\:text-green-800:focus-within {\n  --text-opacity: 1;\n  color: #03543f;\n  color: rgba(3, 84, 63, var(--text-opacity));\n}\n.focus-within\\:text-green-900:focus-within {\n  --text-opacity: 1;\n  color: #014737;\n  color: rgba(1, 71, 55, var(--text-opacity));\n}\n.focus-within\\:text-teal-50:focus-within {\n  --text-opacity: 1;\n  color: #edfafa;\n  color: rgba(237, 250, 250, var(--text-opacity));\n}\n.focus-within\\:text-teal-100:focus-within {\n  --text-opacity: 1;\n  color: #d5f5f6;\n  color: rgba(213, 245, 246, var(--text-opacity));\n}\n.focus-within\\:text-teal-200:focus-within {\n  --text-opacity: 1;\n  color: #afecef;\n  color: rgba(175, 236, 239, var(--text-opacity));\n}\n.focus-within\\:text-teal-300:focus-within {\n  --text-opacity: 1;\n  color: #7edce2;\n  color: rgba(126, 220, 226, var(--text-opacity));\n}\n.focus-within\\:text-teal-400:focus-within {\n  --text-opacity: 1;\n  color: #16bdca;\n  color: rgba(22, 189, 202, var(--text-opacity));\n}\n.focus-within\\:text-teal-500:focus-within {\n  --text-opacity: 1;\n  color: #0694a2;\n  color: rgba(6, 148, 162, var(--text-opacity));\n}\n.focus-within\\:text-teal-600:focus-within {\n  --text-opacity: 1;\n  color: #047481;\n  color: rgba(4, 116, 129, var(--text-opacity));\n}\n.focus-within\\:text-teal-700:focus-within {\n  --text-opacity: 1;\n  color: #036672;\n  color: rgba(3, 102, 114, var(--text-opacity));\n}\n.focus-within\\:text-teal-800:focus-within {\n  --text-opacity: 1;\n  color: #05505c;\n  color: rgba(5, 80, 92, var(--text-opacity));\n}\n.focus-within\\:text-teal-900:focus-within {\n  --text-opacity: 1;\n  color: #014451;\n  color: rgba(1, 68, 81, var(--text-opacity));\n}\n.focus-within\\:text-blue-50:focus-within {\n  --text-opacity: 1;\n  color: #ebf5ff;\n  color: rgba(235, 245, 255, var(--text-opacity));\n}\n.focus-within\\:text-blue-100:focus-within {\n  --text-opacity: 1;\n  color: #e1effe;\n  color: rgba(225, 239, 254, var(--text-opacity));\n}\n.focus-within\\:text-blue-200:focus-within {\n  --text-opacity: 1;\n  color: #c3ddfd;\n  color: rgba(195, 221, 253, var(--text-opacity));\n}\n.focus-within\\:text-blue-300:focus-within {\n  --text-opacity: 1;\n  color: #a4cafe;\n  color: rgba(164, 202, 254, var(--text-opacity));\n}\n.focus-within\\:text-blue-400:focus-within {\n  --text-opacity: 1;\n  color: #76a9fa;\n  color: rgba(118, 169, 250, var(--text-opacity));\n}\n.focus-within\\:text-blue-500:focus-within {\n  --text-opacity: 1;\n  color: #3f83f8;\n  color: rgba(63, 131, 248, var(--text-opacity));\n}\n.focus-within\\:text-blue-600:focus-within {\n  --text-opacity: 1;\n  color: #1c64f2;\n  color: rgba(28, 100, 242, var(--text-opacity));\n}\n.focus-within\\:text-blue-700:focus-within {\n  --text-opacity: 1;\n  color: #1a56db;\n  color: rgba(26, 86, 219, var(--text-opacity));\n}\n.focus-within\\:text-blue-800:focus-within {\n  --text-opacity: 1;\n  color: #1e429f;\n  color: rgba(30, 66, 159, var(--text-opacity));\n}\n.focus-within\\:text-blue-900:focus-within {\n  --text-opacity: 1;\n  color: #233876;\n  color: rgba(35, 56, 118, var(--text-opacity));\n}\n.focus-within\\:text-indigo-50:focus-within {\n  --text-opacity: 1;\n  color: #f0f5ff;\n  color: rgba(240, 245, 255, var(--text-opacity));\n}\n.focus-within\\:text-indigo-100:focus-within {\n  --text-opacity: 1;\n  color: #e5edff;\n  color: rgba(229, 237, 255, var(--text-opacity));\n}\n.focus-within\\:text-indigo-200:focus-within {\n  --text-opacity: 1;\n  color: #cddbfe;\n  color: rgba(205, 219, 254, var(--text-opacity));\n}\n.focus-within\\:text-indigo-300:focus-within {\n  --text-opacity: 1;\n  color: #b4c6fc;\n  color: rgba(180, 198, 252, var(--text-opacity));\n}\n.focus-within\\:text-indigo-400:focus-within {\n  --text-opacity: 1;\n  color: #8da2fb;\n  color: rgba(141, 162, 251, var(--text-opacity));\n}\n.focus-within\\:text-indigo-500:focus-within {\n  --text-opacity: 1;\n  color: #6875f5;\n  color: rgba(104, 117, 245, var(--text-opacity));\n}\n.focus-within\\:text-indigo-600:focus-within {\n  --text-opacity: 1;\n  color: #5850ec;\n  color: rgba(88, 80, 236, var(--text-opacity));\n}\n.focus-within\\:text-indigo-700:focus-within {\n  --text-opacity: 1;\n  color: #5145cd;\n  color: rgba(81, 69, 205, var(--text-opacity));\n}\n.focus-within\\:text-indigo-800:focus-within {\n  --text-opacity: 1;\n  color: #42389d;\n  color: rgba(66, 56, 157, var(--text-opacity));\n}\n.focus-within\\:text-indigo-900:focus-within {\n  --text-opacity: 1;\n  color: #362f78;\n  color: rgba(54, 47, 120, var(--text-opacity));\n}\n.focus-within\\:text-purple-50:focus-within {\n  --text-opacity: 1;\n  color: #f6f5ff;\n  color: rgba(246, 245, 255, var(--text-opacity));\n}\n.focus-within\\:text-purple-100:focus-within {\n  --text-opacity: 1;\n  color: #edebfe;\n  color: rgba(237, 235, 254, var(--text-opacity));\n}\n.focus-within\\:text-purple-200:focus-within {\n  --text-opacity: 1;\n  color: #dcd7fe;\n  color: rgba(220, 215, 254, var(--text-opacity));\n}\n.focus-within\\:text-purple-300:focus-within {\n  --text-opacity: 1;\n  color: #cabffd;\n  color: rgba(202, 191, 253, var(--text-opacity));\n}\n.focus-within\\:text-purple-400:focus-within {\n  --text-opacity: 1;\n  color: #ac94fa;\n  color: rgba(172, 148, 250, var(--text-opacity));\n}\n.focus-within\\:text-purple-500:focus-within {\n  --text-opacity: 1;\n  color: #9061f9;\n  color: rgba(144, 97, 249, var(--text-opacity));\n}\n.focus-within\\:text-purple-600:focus-within {\n  --text-opacity: 1;\n  color: #7e3af2;\n  color: rgba(126, 58, 242, var(--text-opacity));\n}\n.focus-within\\:text-purple-700:focus-within {\n  --text-opacity: 1;\n  color: #6c2bd9;\n  color: rgba(108, 43, 217, var(--text-opacity));\n}\n.focus-within\\:text-purple-800:focus-within {\n  --text-opacity: 1;\n  color: #5521b5;\n  color: rgba(85, 33, 181, var(--text-opacity));\n}\n.focus-within\\:text-purple-900:focus-within {\n  --text-opacity: 1;\n  color: #4a1d96;\n  color: rgba(74, 29, 150, var(--text-opacity));\n}\n.focus-within\\:text-pink-50:focus-within {\n  --text-opacity: 1;\n  color: #fdf2f8;\n  color: rgba(253, 242, 248, var(--text-opacity));\n}\n.focus-within\\:text-pink-100:focus-within {\n  --text-opacity: 1;\n  color: #fce8f3;\n  color: rgba(252, 232, 243, var(--text-opacity));\n}\n.focus-within\\:text-pink-200:focus-within {\n  --text-opacity: 1;\n  color: #fad1e8;\n  color: rgba(250, 209, 232, var(--text-opacity));\n}\n.focus-within\\:text-pink-300:focus-within {\n  --text-opacity: 1;\n  color: #f8b4d9;\n  color: rgba(248, 180, 217, var(--text-opacity));\n}\n.focus-within\\:text-pink-400:focus-within {\n  --text-opacity: 1;\n  color: #f17eb8;\n  color: rgba(241, 126, 184, var(--text-opacity));\n}\n.focus-within\\:text-pink-500:focus-within {\n  --text-opacity: 1;\n  color: #e74694;\n  color: rgba(231, 70, 148, var(--text-opacity));\n}\n.focus-within\\:text-pink-600:focus-within {\n  --text-opacity: 1;\n  color: #d61f69;\n  color: rgba(214, 31, 105, var(--text-opacity));\n}\n.focus-within\\:text-pink-700:focus-within {\n  --text-opacity: 1;\n  color: #bf125d;\n  color: rgba(191, 18, 93, var(--text-opacity));\n}\n.focus-within\\:text-pink-800:focus-within {\n  --text-opacity: 1;\n  color: #99154b;\n  color: rgba(153, 21, 75, var(--text-opacity));\n}\n.focus-within\\:text-pink-900:focus-within {\n  --text-opacity: 1;\n  color: #751a3d;\n  color: rgba(117, 26, 61, var(--text-opacity));\n}\n.focus-within\\:text-cool-gray-50:focus-within {\n  --text-opacity: 1;\n  color: #f8fafc;\n  color: rgba(248, 250, 252, var(--text-opacity));\n}\n.focus-within\\:text-cool-gray-100:focus-within {\n  --text-opacity: 1;\n  color: #f1f5f9;\n  color: rgba(241, 245, 249, var(--text-opacity));\n}\n.focus-within\\:text-cool-gray-200:focus-within {\n  --text-opacity: 1;\n  color: #e2e8f0;\n  color: rgba(226, 232, 240, var(--text-opacity));\n}\n.focus-within\\:text-cool-gray-300:focus-within {\n  --text-opacity: 1;\n  color: #cfd8e3;\n  color: rgba(207, 216, 227, var(--text-opacity));\n}\n.focus-within\\:text-cool-gray-400:focus-within {\n  --text-opacity: 1;\n  color: #97a6ba;\n  color: rgba(151, 166, 186, var(--text-opacity));\n}\n.focus-within\\:text-cool-gray-500:focus-within {\n  --text-opacity: 1;\n  color: #64748b;\n  color: rgba(100, 116, 139, var(--text-opacity));\n}\n.focus-within\\:text-cool-gray-600:focus-within {\n  --text-opacity: 1;\n  color: #475569;\n  color: rgba(71, 85, 105, var(--text-opacity));\n}\n.focus-within\\:text-cool-gray-700:focus-within {\n  --text-opacity: 1;\n  color: #364152;\n  color: rgba(54, 65, 82, var(--text-opacity));\n}\n.focus-within\\:text-cool-gray-800:focus-within {\n  --text-opacity: 1;\n  color: #27303f;\n  color: rgba(39, 48, 63, var(--text-opacity));\n}\n.focus-within\\:text-cool-gray-900:focus-within {\n  --text-opacity: 1;\n  color: #1a202e;\n  color: rgba(26, 32, 46, var(--text-opacity));\n}\n.focus\\:text-current:focus {\n  color: currentColor;\n}\n.focus\\:text-transparent:focus {\n  color: transparent;\n}\n.focus\\:text-white:focus {\n  --text-opacity: 1;\n  color: #ffffff;\n  color: rgba(255, 255, 255, var(--text-opacity));\n}\n.focus\\:text-black:focus {\n  --text-opacity: 1;\n  color: #000000;\n  color: rgba(0, 0, 0, var(--text-opacity));\n}\n.focus\\:text-gray-50:focus {\n  --text-opacity: 1;\n  color: #f9fafb;\n  color: rgba(249, 250, 251, var(--text-opacity));\n}\n.focus\\:text-gray-100:focus {\n  --text-opacity: 1;\n  color: #f4f5f7;\n  color: rgba(244, 245, 247, var(--text-opacity));\n}\n.focus\\:text-gray-200:focus {\n  --text-opacity: 1;\n  color: #e5e7eb;\n  color: rgba(229, 231, 235, var(--text-opacity));\n}\n.focus\\:text-gray-300:focus {\n  --text-opacity: 1;\n  color: #d2d6dc;\n  color: rgba(210, 214, 220, var(--text-opacity));\n}\n.focus\\:text-gray-400:focus {\n  --text-opacity: 1;\n  color: #9fa6b2;\n  color: rgba(159, 166, 178, var(--text-opacity));\n}\n.focus\\:text-gray-500:focus {\n  --text-opacity: 1;\n  color: #6b7280;\n  color: rgba(107, 114, 128, var(--text-opacity));\n}\n.focus\\:text-gray-600:focus {\n  --text-opacity: 1;\n  color: #4b5563;\n  color: rgba(75, 85, 99, var(--text-opacity));\n}\n.focus\\:text-gray-700:focus {\n  --text-opacity: 1;\n  color: #374151;\n  color: rgba(55, 65, 81, var(--text-opacity));\n}\n.focus\\:text-gray-800:focus {\n  --text-opacity: 1;\n  color: #252f3f;\n  color: rgba(37, 47, 63, var(--text-opacity));\n}\n.focus\\:text-gray-900:focus {\n  --text-opacity: 1;\n  color: #161e2e;\n  color: rgba(22, 30, 46, var(--text-opacity));\n}\n.focus\\:text-red-50:focus {\n  --text-opacity: 1;\n  color: #fdf2f2;\n  color: rgba(253, 242, 242, var(--text-opacity));\n}\n.focus\\:text-red-100:focus {\n  --text-opacity: 1;\n  color: #fde8e8;\n  color: rgba(253, 232, 232, var(--text-opacity));\n}\n.focus\\:text-red-200:focus {\n  --text-opacity: 1;\n  color: #fbd5d5;\n  color: rgba(251, 213, 213, var(--text-opacity));\n}\n.focus\\:text-red-300:focus {\n  --text-opacity: 1;\n  color: #f8b4b4;\n  color: rgba(248, 180, 180, var(--text-opacity));\n}\n.focus\\:text-red-400:focus {\n  --text-opacity: 1;\n  color: #f98080;\n  color: rgba(249, 128, 128, var(--text-opacity));\n}\n.focus\\:text-red-500:focus {\n  --text-opacity: 1;\n  color: #f05252;\n  color: rgba(240, 82, 82, var(--text-opacity));\n}\n.focus\\:text-red-600:focus {\n  --text-opacity: 1;\n  color: #e02424;\n  color: rgba(224, 36, 36, var(--text-opacity));\n}\n.focus\\:text-red-700:focus {\n  --text-opacity: 1;\n  color: #c81e1e;\n  color: rgba(200, 30, 30, var(--text-opacity));\n}\n.focus\\:text-red-800:focus {\n  --text-opacity: 1;\n  color: #9b1c1c;\n  color: rgba(155, 28, 28, var(--text-opacity));\n}\n.focus\\:text-red-900:focus {\n  --text-opacity: 1;\n  color: #771d1d;\n  color: rgba(119, 29, 29, var(--text-opacity));\n}\n.focus\\:text-orange-50:focus {\n  --text-opacity: 1;\n  color: #fff8f1;\n  color: rgba(255, 248, 241, var(--text-opacity));\n}\n.focus\\:text-orange-100:focus {\n  --text-opacity: 1;\n  color: #feecdc;\n  color: rgba(254, 236, 220, var(--text-opacity));\n}\n.focus\\:text-orange-200:focus {\n  --text-opacity: 1;\n  color: #fcd9bd;\n  color: rgba(252, 217, 189, var(--text-opacity));\n}\n.focus\\:text-orange-300:focus {\n  --text-opacity: 1;\n  color: #fdba8c;\n  color: rgba(253, 186, 140, var(--text-opacity));\n}\n.focus\\:text-orange-400:focus {\n  --text-opacity: 1;\n  color: #ff8a4c;\n  color: rgba(255, 138, 76, var(--text-opacity));\n}\n.focus\\:text-orange-500:focus {\n  --text-opacity: 1;\n  color: #ff5a1f;\n  color: rgba(255, 90, 31, var(--text-opacity));\n}\n.focus\\:text-orange-600:focus {\n  --text-opacity: 1;\n  color: #d03801;\n  color: rgba(208, 56, 1, var(--text-opacity));\n}\n.focus\\:text-orange-700:focus {\n  --text-opacity: 1;\n  color: #b43403;\n  color: rgba(180, 52, 3, var(--text-opacity));\n}\n.focus\\:text-orange-800:focus {\n  --text-opacity: 1;\n  color: #8a2c0d;\n  color: rgba(138, 44, 13, var(--text-opacity));\n}\n.focus\\:text-orange-900:focus {\n  --text-opacity: 1;\n  color: #73230d;\n  color: rgba(115, 35, 13, var(--text-opacity));\n}\n.focus\\:text-yellow-50:focus {\n  --text-opacity: 1;\n  color: #fdfdea;\n  color: rgba(253, 253, 234, var(--text-opacity));\n}\n.focus\\:text-yellow-100:focus {\n  --text-opacity: 1;\n  color: #fdf6b2;\n  color: rgba(253, 246, 178, var(--text-opacity));\n}\n.focus\\:text-yellow-200:focus {\n  --text-opacity: 1;\n  color: #fce96a;\n  color: rgba(252, 233, 106, var(--text-opacity));\n}\n.focus\\:text-yellow-300:focus {\n  --text-opacity: 1;\n  color: #faca15;\n  color: rgba(250, 202, 21, var(--text-opacity));\n}\n.focus\\:text-yellow-400:focus {\n  --text-opacity: 1;\n  color: #e3a008;\n  color: rgba(227, 160, 8, var(--text-opacity));\n}\n.focus\\:text-yellow-500:focus {\n  --text-opacity: 1;\n  color: #c27803;\n  color: rgba(194, 120, 3, var(--text-opacity));\n}\n.focus\\:text-yellow-600:focus {\n  --text-opacity: 1;\n  color: #9f580a;\n  color: rgba(159, 88, 10, var(--text-opacity));\n}\n.focus\\:text-yellow-700:focus {\n  --text-opacity: 1;\n  color: #8e4b10;\n  color: rgba(142, 75, 16, var(--text-opacity));\n}\n.focus\\:text-yellow-800:focus {\n  --text-opacity: 1;\n  color: #723b13;\n  color: rgba(114, 59, 19, var(--text-opacity));\n}\n.focus\\:text-yellow-900:focus {\n  --text-opacity: 1;\n  color: #633112;\n  color: rgba(99, 49, 18, var(--text-opacity));\n}\n.focus\\:text-green-50:focus {\n  --text-opacity: 1;\n  color: #f3faf7;\n  color: rgba(243, 250, 247, var(--text-opacity));\n}\n.focus\\:text-green-100:focus {\n  --text-opacity: 1;\n  color: #def7ec;\n  color: rgba(222, 247, 236, var(--text-opacity));\n}\n.focus\\:text-green-200:focus {\n  --text-opacity: 1;\n  color: #bcf0da;\n  color: rgba(188, 240, 218, var(--text-opacity));\n}\n.focus\\:text-green-300:focus {\n  --text-opacity: 1;\n  color: #84e1bc;\n  color: rgba(132, 225, 188, var(--text-opacity));\n}\n.focus\\:text-green-400:focus {\n  --text-opacity: 1;\n  color: #31c48d;\n  color: rgba(49, 196, 141, var(--text-opacity));\n}\n.focus\\:text-green-500:focus {\n  --text-opacity: 1;\n  color: #0e9f6e;\n  color: rgba(14, 159, 110, var(--text-opacity));\n}\n.focus\\:text-green-600:focus {\n  --text-opacity: 1;\n  color: #057a55;\n  color: rgba(5, 122, 85, var(--text-opacity));\n}\n.focus\\:text-green-700:focus {\n  --text-opacity: 1;\n  color: #046c4e;\n  color: rgba(4, 108, 78, var(--text-opacity));\n}\n.focus\\:text-green-800:focus {\n  --text-opacity: 1;\n  color: #03543f;\n  color: rgba(3, 84, 63, var(--text-opacity));\n}\n.focus\\:text-green-900:focus {\n  --text-opacity: 1;\n  color: #014737;\n  color: rgba(1, 71, 55, var(--text-opacity));\n}\n.focus\\:text-teal-50:focus {\n  --text-opacity: 1;\n  color: #edfafa;\n  color: rgba(237, 250, 250, var(--text-opacity));\n}\n.focus\\:text-teal-100:focus {\n  --text-opacity: 1;\n  color: #d5f5f6;\n  color: rgba(213, 245, 246, var(--text-opacity));\n}\n.focus\\:text-teal-200:focus {\n  --text-opacity: 1;\n  color: #afecef;\n  color: rgba(175, 236, 239, var(--text-opacity));\n}\n.focus\\:text-teal-300:focus {\n  --text-opacity: 1;\n  color: #7edce2;\n  color: rgba(126, 220, 226, var(--text-opacity));\n}\n.focus\\:text-teal-400:focus {\n  --text-opacity: 1;\n  color: #16bdca;\n  color: rgba(22, 189, 202, var(--text-opacity));\n}\n.focus\\:text-teal-500:focus {\n  --text-opacity: 1;\n  color: #0694a2;\n  color: rgba(6, 148, 162, var(--text-opacity));\n}\n.focus\\:text-teal-600:focus {\n  --text-opacity: 1;\n  color: #047481;\n  color: rgba(4, 116, 129, var(--text-opacity));\n}\n.focus\\:text-teal-700:focus {\n  --text-opacity: 1;\n  color: #036672;\n  color: rgba(3, 102, 114, var(--text-opacity));\n}\n.focus\\:text-teal-800:focus {\n  --text-opacity: 1;\n  color: #05505c;\n  color: rgba(5, 80, 92, var(--text-opacity));\n}\n.focus\\:text-teal-900:focus {\n  --text-opacity: 1;\n  color: #014451;\n  color: rgba(1, 68, 81, var(--text-opacity));\n}\n.focus\\:text-blue-50:focus {\n  --text-opacity: 1;\n  color: #ebf5ff;\n  color: rgba(235, 245, 255, var(--text-opacity));\n}\n.focus\\:text-blue-100:focus {\n  --text-opacity: 1;\n  color: #e1effe;\n  color: rgba(225, 239, 254, var(--text-opacity));\n}\n.focus\\:text-blue-200:focus {\n  --text-opacity: 1;\n  color: #c3ddfd;\n  color: rgba(195, 221, 253, var(--text-opacity));\n}\n.focus\\:text-blue-300:focus {\n  --text-opacity: 1;\n  color: #a4cafe;\n  color: rgba(164, 202, 254, var(--text-opacity));\n}\n.focus\\:text-blue-400:focus {\n  --text-opacity: 1;\n  color: #76a9fa;\n  color: rgba(118, 169, 250, var(--text-opacity));\n}\n.focus\\:text-blue-500:focus {\n  --text-opacity: 1;\n  color: #3f83f8;\n  color: rgba(63, 131, 248, var(--text-opacity));\n}\n.focus\\:text-blue-600:focus {\n  --text-opacity: 1;\n  color: #1c64f2;\n  color: rgba(28, 100, 242, var(--text-opacity));\n}\n.focus\\:text-blue-700:focus {\n  --text-opacity: 1;\n  color: #1a56db;\n  color: rgba(26, 86, 219, var(--text-opacity));\n}\n.focus\\:text-blue-800:focus {\n  --text-opacity: 1;\n  color: #1e429f;\n  color: rgba(30, 66, 159, var(--text-opacity));\n}\n.focus\\:text-blue-900:focus {\n  --text-opacity: 1;\n  color: #233876;\n  color: rgba(35, 56, 118, var(--text-opacity));\n}\n.focus\\:text-indigo-50:focus {\n  --text-opacity: 1;\n  color: #f0f5ff;\n  color: rgba(240, 245, 255, var(--text-opacity));\n}\n.focus\\:text-indigo-100:focus {\n  --text-opacity: 1;\n  color: #e5edff;\n  color: rgba(229, 237, 255, var(--text-opacity));\n}\n.focus\\:text-indigo-200:focus {\n  --text-opacity: 1;\n  color: #cddbfe;\n  color: rgba(205, 219, 254, var(--text-opacity));\n}\n.focus\\:text-indigo-300:focus {\n  --text-opacity: 1;\n  color: #b4c6fc;\n  color: rgba(180, 198, 252, var(--text-opacity));\n}\n.focus\\:text-indigo-400:focus {\n  --text-opacity: 1;\n  color: #8da2fb;\n  color: rgba(141, 162, 251, var(--text-opacity));\n}\n.focus\\:text-indigo-500:focus {\n  --text-opacity: 1;\n  color: #6875f5;\n  color: rgba(104, 117, 245, var(--text-opacity));\n}\n.focus\\:text-indigo-600:focus {\n  --text-opacity: 1;\n  color: #5850ec;\n  color: rgba(88, 80, 236, var(--text-opacity));\n}\n.focus\\:text-indigo-700:focus {\n  --text-opacity: 1;\n  color: #5145cd;\n  color: rgba(81, 69, 205, var(--text-opacity));\n}\n.focus\\:text-indigo-800:focus {\n  --text-opacity: 1;\n  color: #42389d;\n  color: rgba(66, 56, 157, var(--text-opacity));\n}\n.focus\\:text-indigo-900:focus {\n  --text-opacity: 1;\n  color: #362f78;\n  color: rgba(54, 47, 120, var(--text-opacity));\n}\n.focus\\:text-purple-50:focus {\n  --text-opacity: 1;\n  color: #f6f5ff;\n  color: rgba(246, 245, 255, var(--text-opacity));\n}\n.focus\\:text-purple-100:focus {\n  --text-opacity: 1;\n  color: #edebfe;\n  color: rgba(237, 235, 254, var(--text-opacity));\n}\n.focus\\:text-purple-200:focus {\n  --text-opacity: 1;\n  color: #dcd7fe;\n  color: rgba(220, 215, 254, var(--text-opacity));\n}\n.focus\\:text-purple-300:focus {\n  --text-opacity: 1;\n  color: #cabffd;\n  color: rgba(202, 191, 253, var(--text-opacity));\n}\n.focus\\:text-purple-400:focus {\n  --text-opacity: 1;\n  color: #ac94fa;\n  color: rgba(172, 148, 250, var(--text-opacity));\n}\n.focus\\:text-purple-500:focus {\n  --text-opacity: 1;\n  color: #9061f9;\n  color: rgba(144, 97, 249, var(--text-opacity));\n}\n.focus\\:text-purple-600:focus {\n  --text-opacity: 1;\n  color: #7e3af2;\n  color: rgba(126, 58, 242, var(--text-opacity));\n}\n.focus\\:text-purple-700:focus {\n  --text-opacity: 1;\n  color: #6c2bd9;\n  color: rgba(108, 43, 217, var(--text-opacity));\n}\n.focus\\:text-purple-800:focus {\n  --text-opacity: 1;\n  color: #5521b5;\n  color: rgba(85, 33, 181, var(--text-opacity));\n}\n.focus\\:text-purple-900:focus {\n  --text-opacity: 1;\n  color: #4a1d96;\n  color: rgba(74, 29, 150, var(--text-opacity));\n}\n.focus\\:text-pink-50:focus {\n  --text-opacity: 1;\n  color: #fdf2f8;\n  color: rgba(253, 242, 248, var(--text-opacity));\n}\n.focus\\:text-pink-100:focus {\n  --text-opacity: 1;\n  color: #fce8f3;\n  color: rgba(252, 232, 243, var(--text-opacity));\n}\n.focus\\:text-pink-200:focus {\n  --text-opacity: 1;\n  color: #fad1e8;\n  color: rgba(250, 209, 232, var(--text-opacity));\n}\n.focus\\:text-pink-300:focus {\n  --text-opacity: 1;\n  color: #f8b4d9;\n  color: rgba(248, 180, 217, var(--text-opacity));\n}\n.focus\\:text-pink-400:focus {\n  --text-opacity: 1;\n  color: #f17eb8;\n  color: rgba(241, 126, 184, var(--text-opacity));\n}\n.focus\\:text-pink-500:focus {\n  --text-opacity: 1;\n  color: #e74694;\n  color: rgba(231, 70, 148, var(--text-opacity));\n}\n.focus\\:text-pink-600:focus {\n  --text-opacity: 1;\n  color: #d61f69;\n  color: rgba(214, 31, 105, var(--text-opacity));\n}\n.focus\\:text-pink-700:focus {\n  --text-opacity: 1;\n  color: #bf125d;\n  color: rgba(191, 18, 93, var(--text-opacity));\n}\n.focus\\:text-pink-800:focus {\n  --text-opacity: 1;\n  color: #99154b;\n  color: rgba(153, 21, 75, var(--text-opacity));\n}\n.focus\\:text-pink-900:focus {\n  --text-opacity: 1;\n  color: #751a3d;\n  color: rgba(117, 26, 61, var(--text-opacity));\n}\n.focus\\:text-cool-gray-50:focus {\n  --text-opacity: 1;\n  color: #f8fafc;\n  color: rgba(248, 250, 252, var(--text-opacity));\n}\n.focus\\:text-cool-gray-100:focus {\n  --text-opacity: 1;\n  color: #f1f5f9;\n  color: rgba(241, 245, 249, var(--text-opacity));\n}\n.focus\\:text-cool-gray-200:focus {\n  --text-opacity: 1;\n  color: #e2e8f0;\n  color: rgba(226, 232, 240, var(--text-opacity));\n}\n.focus\\:text-cool-gray-300:focus {\n  --text-opacity: 1;\n  color: #cfd8e3;\n  color: rgba(207, 216, 227, var(--text-opacity));\n}\n.focus\\:text-cool-gray-400:focus {\n  --text-opacity: 1;\n  color: #97a6ba;\n  color: rgba(151, 166, 186, var(--text-opacity));\n}\n.focus\\:text-cool-gray-500:focus {\n  --text-opacity: 1;\n  color: #64748b;\n  color: rgba(100, 116, 139, var(--text-opacity));\n}\n.focus\\:text-cool-gray-600:focus {\n  --text-opacity: 1;\n  color: #475569;\n  color: rgba(71, 85, 105, var(--text-opacity));\n}\n.focus\\:text-cool-gray-700:focus {\n  --text-opacity: 1;\n  color: #364152;\n  color: rgba(54, 65, 82, var(--text-opacity));\n}\n.focus\\:text-cool-gray-800:focus {\n  --text-opacity: 1;\n  color: #27303f;\n  color: rgba(39, 48, 63, var(--text-opacity));\n}\n.focus\\:text-cool-gray-900:focus {\n  --text-opacity: 1;\n  color: #1a202e;\n  color: rgba(26, 32, 46, var(--text-opacity));\n}\n.active\\:text-current:active {\n  color: currentColor;\n}\n.active\\:text-transparent:active {\n  color: transparent;\n}\n.active\\:text-white:active {\n  --text-opacity: 1;\n  color: #ffffff;\n  color: rgba(255, 255, 255, var(--text-opacity));\n}\n.active\\:text-black:active {\n  --text-opacity: 1;\n  color: #000000;\n  color: rgba(0, 0, 0, var(--text-opacity));\n}\n.active\\:text-gray-50:active {\n  --text-opacity: 1;\n  color: #f9fafb;\n  color: rgba(249, 250, 251, var(--text-opacity));\n}\n.active\\:text-gray-100:active {\n  --text-opacity: 1;\n  color: #f4f5f7;\n  color: rgba(244, 245, 247, var(--text-opacity));\n}\n.active\\:text-gray-200:active {\n  --text-opacity: 1;\n  color: #e5e7eb;\n  color: rgba(229, 231, 235, var(--text-opacity));\n}\n.active\\:text-gray-300:active {\n  --text-opacity: 1;\n  color: #d2d6dc;\n  color: rgba(210, 214, 220, var(--text-opacity));\n}\n.active\\:text-gray-400:active {\n  --text-opacity: 1;\n  color: #9fa6b2;\n  color: rgba(159, 166, 178, var(--text-opacity));\n}\n.active\\:text-gray-500:active {\n  --text-opacity: 1;\n  color: #6b7280;\n  color: rgba(107, 114, 128, var(--text-opacity));\n}\n.active\\:text-gray-600:active {\n  --text-opacity: 1;\n  color: #4b5563;\n  color: rgba(75, 85, 99, var(--text-opacity));\n}\n.active\\:text-gray-700:active {\n  --text-opacity: 1;\n  color: #374151;\n  color: rgba(55, 65, 81, var(--text-opacity));\n}\n.active\\:text-gray-800:active {\n  --text-opacity: 1;\n  color: #252f3f;\n  color: rgba(37, 47, 63, var(--text-opacity));\n}\n.active\\:text-gray-900:active {\n  --text-opacity: 1;\n  color: #161e2e;\n  color: rgba(22, 30, 46, var(--text-opacity));\n}\n.active\\:text-red-50:active {\n  --text-opacity: 1;\n  color: #fdf2f2;\n  color: rgba(253, 242, 242, var(--text-opacity));\n}\n.active\\:text-red-100:active {\n  --text-opacity: 1;\n  color: #fde8e8;\n  color: rgba(253, 232, 232, var(--text-opacity));\n}\n.active\\:text-red-200:active {\n  --text-opacity: 1;\n  color: #fbd5d5;\n  color: rgba(251, 213, 213, var(--text-opacity));\n}\n.active\\:text-red-300:active {\n  --text-opacity: 1;\n  color: #f8b4b4;\n  color: rgba(248, 180, 180, var(--text-opacity));\n}\n.active\\:text-red-400:active {\n  --text-opacity: 1;\n  color: #f98080;\n  color: rgba(249, 128, 128, var(--text-opacity));\n}\n.active\\:text-red-500:active {\n  --text-opacity: 1;\n  color: #f05252;\n  color: rgba(240, 82, 82, var(--text-opacity));\n}\n.active\\:text-red-600:active {\n  --text-opacity: 1;\n  color: #e02424;\n  color: rgba(224, 36, 36, var(--text-opacity));\n}\n.active\\:text-red-700:active {\n  --text-opacity: 1;\n  color: #c81e1e;\n  color: rgba(200, 30, 30, var(--text-opacity));\n}\n.active\\:text-red-800:active {\n  --text-opacity: 1;\n  color: #9b1c1c;\n  color: rgba(155, 28, 28, var(--text-opacity));\n}\n.active\\:text-red-900:active {\n  --text-opacity: 1;\n  color: #771d1d;\n  color: rgba(119, 29, 29, var(--text-opacity));\n}\n.active\\:text-orange-50:active {\n  --text-opacity: 1;\n  color: #fff8f1;\n  color: rgba(255, 248, 241, var(--text-opacity));\n}\n.active\\:text-orange-100:active {\n  --text-opacity: 1;\n  color: #feecdc;\n  color: rgba(254, 236, 220, var(--text-opacity));\n}\n.active\\:text-orange-200:active {\n  --text-opacity: 1;\n  color: #fcd9bd;\n  color: rgba(252, 217, 189, var(--text-opacity));\n}\n.active\\:text-orange-300:active {\n  --text-opacity: 1;\n  color: #fdba8c;\n  color: rgba(253, 186, 140, var(--text-opacity));\n}\n.active\\:text-orange-400:active {\n  --text-opacity: 1;\n  color: #ff8a4c;\n  color: rgba(255, 138, 76, var(--text-opacity));\n}\n.active\\:text-orange-500:active {\n  --text-opacity: 1;\n  color: #ff5a1f;\n  color: rgba(255, 90, 31, var(--text-opacity));\n}\n.active\\:text-orange-600:active {\n  --text-opacity: 1;\n  color: #d03801;\n  color: rgba(208, 56, 1, var(--text-opacity));\n}\n.active\\:text-orange-700:active {\n  --text-opacity: 1;\n  color: #b43403;\n  color: rgba(180, 52, 3, var(--text-opacity));\n}\n.active\\:text-orange-800:active {\n  --text-opacity: 1;\n  color: #8a2c0d;\n  color: rgba(138, 44, 13, var(--text-opacity));\n}\n.active\\:text-orange-900:active {\n  --text-opacity: 1;\n  color: #73230d;\n  color: rgba(115, 35, 13, var(--text-opacity));\n}\n.active\\:text-yellow-50:active {\n  --text-opacity: 1;\n  color: #fdfdea;\n  color: rgba(253, 253, 234, var(--text-opacity));\n}\n.active\\:text-yellow-100:active {\n  --text-opacity: 1;\n  color: #fdf6b2;\n  color: rgba(253, 246, 178, var(--text-opacity));\n}\n.active\\:text-yellow-200:active {\n  --text-opacity: 1;\n  color: #fce96a;\n  color: rgba(252, 233, 106, var(--text-opacity));\n}\n.active\\:text-yellow-300:active {\n  --text-opacity: 1;\n  color: #faca15;\n  color: rgba(250, 202, 21, var(--text-opacity));\n}\n.active\\:text-yellow-400:active {\n  --text-opacity: 1;\n  color: #e3a008;\n  color: rgba(227, 160, 8, var(--text-opacity));\n}\n.active\\:text-yellow-500:active {\n  --text-opacity: 1;\n  color: #c27803;\n  color: rgba(194, 120, 3, var(--text-opacity));\n}\n.active\\:text-yellow-600:active {\n  --text-opacity: 1;\n  color: #9f580a;\n  color: rgba(159, 88, 10, var(--text-opacity));\n}\n.active\\:text-yellow-700:active {\n  --text-opacity: 1;\n  color: #8e4b10;\n  color: rgba(142, 75, 16, var(--text-opacity));\n}\n.active\\:text-yellow-800:active {\n  --text-opacity: 1;\n  color: #723b13;\n  color: rgba(114, 59, 19, var(--text-opacity));\n}\n.active\\:text-yellow-900:active {\n  --text-opacity: 1;\n  color: #633112;\n  color: rgba(99, 49, 18, var(--text-opacity));\n}\n.active\\:text-green-50:active {\n  --text-opacity: 1;\n  color: #f3faf7;\n  color: rgba(243, 250, 247, var(--text-opacity));\n}\n.active\\:text-green-100:active {\n  --text-opacity: 1;\n  color: #def7ec;\n  color: rgba(222, 247, 236, var(--text-opacity));\n}\n.active\\:text-green-200:active {\n  --text-opacity: 1;\n  color: #bcf0da;\n  color: rgba(188, 240, 218, var(--text-opacity));\n}\n.active\\:text-green-300:active {\n  --text-opacity: 1;\n  color: #84e1bc;\n  color: rgba(132, 225, 188, var(--text-opacity));\n}\n.active\\:text-green-400:active {\n  --text-opacity: 1;\n  color: #31c48d;\n  color: rgba(49, 196, 141, var(--text-opacity));\n}\n.active\\:text-green-500:active {\n  --text-opacity: 1;\n  color: #0e9f6e;\n  color: rgba(14, 159, 110, var(--text-opacity));\n}\n.active\\:text-green-600:active {\n  --text-opacity: 1;\n  color: #057a55;\n  color: rgba(5, 122, 85, var(--text-opacity));\n}\n.active\\:text-green-700:active {\n  --text-opacity: 1;\n  color: #046c4e;\n  color: rgba(4, 108, 78, var(--text-opacity));\n}\n.active\\:text-green-800:active {\n  --text-opacity: 1;\n  color: #03543f;\n  color: rgba(3, 84, 63, var(--text-opacity));\n}\n.active\\:text-green-900:active {\n  --text-opacity: 1;\n  color: #014737;\n  color: rgba(1, 71, 55, var(--text-opacity));\n}\n.active\\:text-teal-50:active {\n  --text-opacity: 1;\n  color: #edfafa;\n  color: rgba(237, 250, 250, var(--text-opacity));\n}\n.active\\:text-teal-100:active {\n  --text-opacity: 1;\n  color: #d5f5f6;\n  color: rgba(213, 245, 246, var(--text-opacity));\n}\n.active\\:text-teal-200:active {\n  --text-opacity: 1;\n  color: #afecef;\n  color: rgba(175, 236, 239, var(--text-opacity));\n}\n.active\\:text-teal-300:active {\n  --text-opacity: 1;\n  color: #7edce2;\n  color: rgba(126, 220, 226, var(--text-opacity));\n}\n.active\\:text-teal-400:active {\n  --text-opacity: 1;\n  color: #16bdca;\n  color: rgba(22, 189, 202, var(--text-opacity));\n}\n.active\\:text-teal-500:active {\n  --text-opacity: 1;\n  color: #0694a2;\n  color: rgba(6, 148, 162, var(--text-opacity));\n}\n.active\\:text-teal-600:active {\n  --text-opacity: 1;\n  color: #047481;\n  color: rgba(4, 116, 129, var(--text-opacity));\n}\n.active\\:text-teal-700:active {\n  --text-opacity: 1;\n  color: #036672;\n  color: rgba(3, 102, 114, var(--text-opacity));\n}\n.active\\:text-teal-800:active {\n  --text-opacity: 1;\n  color: #05505c;\n  color: rgba(5, 80, 92, var(--text-opacity));\n}\n.active\\:text-teal-900:active {\n  --text-opacity: 1;\n  color: #014451;\n  color: rgba(1, 68, 81, var(--text-opacity));\n}\n.active\\:text-blue-50:active {\n  --text-opacity: 1;\n  color: #ebf5ff;\n  color: rgba(235, 245, 255, var(--text-opacity));\n}\n.active\\:text-blue-100:active {\n  --text-opacity: 1;\n  color: #e1effe;\n  color: rgba(225, 239, 254, var(--text-opacity));\n}\n.active\\:text-blue-200:active {\n  --text-opacity: 1;\n  color: #c3ddfd;\n  color: rgba(195, 221, 253, var(--text-opacity));\n}\n.active\\:text-blue-300:active {\n  --text-opacity: 1;\n  color: #a4cafe;\n  color: rgba(164, 202, 254, var(--text-opacity));\n}\n.active\\:text-blue-400:active {\n  --text-opacity: 1;\n  color: #76a9fa;\n  color: rgba(118, 169, 250, var(--text-opacity));\n}\n.active\\:text-blue-500:active {\n  --text-opacity: 1;\n  color: #3f83f8;\n  color: rgba(63, 131, 248, var(--text-opacity));\n}\n.active\\:text-blue-600:active {\n  --text-opacity: 1;\n  color: #1c64f2;\n  color: rgba(28, 100, 242, var(--text-opacity));\n}\n.active\\:text-blue-700:active {\n  --text-opacity: 1;\n  color: #1a56db;\n  color: rgba(26, 86, 219, var(--text-opacity));\n}\n.active\\:text-blue-800:active {\n  --text-opacity: 1;\n  color: #1e429f;\n  color: rgba(30, 66, 159, var(--text-opacity));\n}\n.active\\:text-blue-900:active {\n  --text-opacity: 1;\n  color: #233876;\n  color: rgba(35, 56, 118, var(--text-opacity));\n}\n.active\\:text-indigo-50:active {\n  --text-opacity: 1;\n  color: #f0f5ff;\n  color: rgba(240, 245, 255, var(--text-opacity));\n}\n.active\\:text-indigo-100:active {\n  --text-opacity: 1;\n  color: #e5edff;\n  color: rgba(229, 237, 255, var(--text-opacity));\n}\n.active\\:text-indigo-200:active {\n  --text-opacity: 1;\n  color: #cddbfe;\n  color: rgba(205, 219, 254, var(--text-opacity));\n}\n.active\\:text-indigo-300:active {\n  --text-opacity: 1;\n  color: #b4c6fc;\n  color: rgba(180, 198, 252, var(--text-opacity));\n}\n.active\\:text-indigo-400:active {\n  --text-opacity: 1;\n  color: #8da2fb;\n  color: rgba(141, 162, 251, var(--text-opacity));\n}\n.active\\:text-indigo-500:active {\n  --text-opacity: 1;\n  color: #6875f5;\n  color: rgba(104, 117, 245, var(--text-opacity));\n}\n.active\\:text-indigo-600:active {\n  --text-opacity: 1;\n  color: #5850ec;\n  color: rgba(88, 80, 236, var(--text-opacity));\n}\n.active\\:text-indigo-700:active {\n  --text-opacity: 1;\n  color: #5145cd;\n  color: rgba(81, 69, 205, var(--text-opacity));\n}\n.active\\:text-indigo-800:active {\n  --text-opacity: 1;\n  color: #42389d;\n  color: rgba(66, 56, 157, var(--text-opacity));\n}\n.active\\:text-indigo-900:active {\n  --text-opacity: 1;\n  color: #362f78;\n  color: rgba(54, 47, 120, var(--text-opacity));\n}\n.active\\:text-purple-50:active {\n  --text-opacity: 1;\n  color: #f6f5ff;\n  color: rgba(246, 245, 255, var(--text-opacity));\n}\n.active\\:text-purple-100:active {\n  --text-opacity: 1;\n  color: #edebfe;\n  color: rgba(237, 235, 254, var(--text-opacity));\n}\n.active\\:text-purple-200:active {\n  --text-opacity: 1;\n  color: #dcd7fe;\n  color: rgba(220, 215, 254, var(--text-opacity));\n}\n.active\\:text-purple-300:active {\n  --text-opacity: 1;\n  color: #cabffd;\n  color: rgba(202, 191, 253, var(--text-opacity));\n}\n.active\\:text-purple-400:active {\n  --text-opacity: 1;\n  color: #ac94fa;\n  color: rgba(172, 148, 250, var(--text-opacity));\n}\n.active\\:text-purple-500:active {\n  --text-opacity: 1;\n  color: #9061f9;\n  color: rgba(144, 97, 249, var(--text-opacity));\n}\n.active\\:text-purple-600:active {\n  --text-opacity: 1;\n  color: #7e3af2;\n  color: rgba(126, 58, 242, var(--text-opacity));\n}\n.active\\:text-purple-700:active {\n  --text-opacity: 1;\n  color: #6c2bd9;\n  color: rgba(108, 43, 217, var(--text-opacity));\n}\n.active\\:text-purple-800:active {\n  --text-opacity: 1;\n  color: #5521b5;\n  color: rgba(85, 33, 181, var(--text-opacity));\n}\n.active\\:text-purple-900:active {\n  --text-opacity: 1;\n  color: #4a1d96;\n  color: rgba(74, 29, 150, var(--text-opacity));\n}\n.active\\:text-pink-50:active {\n  --text-opacity: 1;\n  color: #fdf2f8;\n  color: rgba(253, 242, 248, var(--text-opacity));\n}\n.active\\:text-pink-100:active {\n  --text-opacity: 1;\n  color: #fce8f3;\n  color: rgba(252, 232, 243, var(--text-opacity));\n}\n.active\\:text-pink-200:active {\n  --text-opacity: 1;\n  color: #fad1e8;\n  color: rgba(250, 209, 232, var(--text-opacity));\n}\n.active\\:text-pink-300:active {\n  --text-opacity: 1;\n  color: #f8b4d9;\n  color: rgba(248, 180, 217, var(--text-opacity));\n}\n.active\\:text-pink-400:active {\n  --text-opacity: 1;\n  color: #f17eb8;\n  color: rgba(241, 126, 184, var(--text-opacity));\n}\n.active\\:text-pink-500:active {\n  --text-opacity: 1;\n  color: #e74694;\n  color: rgba(231, 70, 148, var(--text-opacity));\n}\n.active\\:text-pink-600:active {\n  --text-opacity: 1;\n  color: #d61f69;\n  color: rgba(214, 31, 105, var(--text-opacity));\n}\n.active\\:text-pink-700:active {\n  --text-opacity: 1;\n  color: #bf125d;\n  color: rgba(191, 18, 93, var(--text-opacity));\n}\n.active\\:text-pink-800:active {\n  --text-opacity: 1;\n  color: #99154b;\n  color: rgba(153, 21, 75, var(--text-opacity));\n}\n.active\\:text-pink-900:active {\n  --text-opacity: 1;\n  color: #751a3d;\n  color: rgba(117, 26, 61, var(--text-opacity));\n}\n.active\\:text-cool-gray-50:active {\n  --text-opacity: 1;\n  color: #f8fafc;\n  color: rgba(248, 250, 252, var(--text-opacity));\n}\n.active\\:text-cool-gray-100:active {\n  --text-opacity: 1;\n  color: #f1f5f9;\n  color: rgba(241, 245, 249, var(--text-opacity));\n}\n.active\\:text-cool-gray-200:active {\n  --text-opacity: 1;\n  color: #e2e8f0;\n  color: rgba(226, 232, 240, var(--text-opacity));\n}\n.active\\:text-cool-gray-300:active {\n  --text-opacity: 1;\n  color: #cfd8e3;\n  color: rgba(207, 216, 227, var(--text-opacity));\n}\n.active\\:text-cool-gray-400:active {\n  --text-opacity: 1;\n  color: #97a6ba;\n  color: rgba(151, 166, 186, var(--text-opacity));\n}\n.active\\:text-cool-gray-500:active {\n  --text-opacity: 1;\n  color: #64748b;\n  color: rgba(100, 116, 139, var(--text-opacity));\n}\n.active\\:text-cool-gray-600:active {\n  --text-opacity: 1;\n  color: #475569;\n  color: rgba(71, 85, 105, var(--text-opacity));\n}\n.active\\:text-cool-gray-700:active {\n  --text-opacity: 1;\n  color: #364152;\n  color: rgba(54, 65, 82, var(--text-opacity));\n}\n.active\\:text-cool-gray-800:active {\n  --text-opacity: 1;\n  color: #27303f;\n  color: rgba(39, 48, 63, var(--text-opacity));\n}\n.active\\:text-cool-gray-900:active {\n  --text-opacity: 1;\n  color: #1a202e;\n  color: rgba(26, 32, 46, var(--text-opacity));\n}\n.text-opacity-0 {\n  --text-opacity: 0;\n}\n.text-opacity-25 {\n  --text-opacity: 0.25;\n}\n.text-opacity-50 {\n  --text-opacity: 0.5;\n}\n.text-opacity-75 {\n  --text-opacity: 0.75;\n}\n.text-opacity-100 {\n  --text-opacity: 1;\n}\n.hover\\:text-opacity-0:hover {\n  --text-opacity: 0;\n}\n.hover\\:text-opacity-25:hover {\n  --text-opacity: 0.25;\n}\n.hover\\:text-opacity-50:hover {\n  --text-opacity: 0.5;\n}\n.hover\\:text-opacity-75:hover {\n  --text-opacity: 0.75;\n}\n.hover\\:text-opacity-100:hover {\n  --text-opacity: 1;\n}\n.focus\\:text-opacity-0:focus {\n  --text-opacity: 0;\n}\n.focus\\:text-opacity-25:focus {\n  --text-opacity: 0.25;\n}\n.focus\\:text-opacity-50:focus {\n  --text-opacity: 0.5;\n}\n.focus\\:text-opacity-75:focus {\n  --text-opacity: 0.75;\n}\n.focus\\:text-opacity-100:focus {\n  --text-opacity: 1;\n}\n.italic {\n  font-style: italic;\n}\n.not-italic {\n  font-style: normal;\n}\n.uppercase {\n  text-transform: uppercase;\n}\n.lowercase {\n  text-transform: lowercase;\n}\n.capitalize {\n  text-transform: capitalize;\n}\n.normal-case {\n  text-transform: none;\n}\n.underline {\n  text-decoration: none;\n}\n.line-through {\n  text-decoration: line-through;\n}\n.no-underline {\n  text-decoration: none;\n}\n.group:hover .group-hover\\:underline {\n  text-decoration: none;\n}\n.group:hover .group-hover\\:line-through {\n  text-decoration: line-through;\n}\n.group:hover .group-hover\\:no-underline {\n  text-decoration: none;\n}\n.group:focus .group-focus\\:underline {\n  text-decoration: none;\n}\n.group:focus .group-focus\\:line-through {\n  text-decoration: line-through;\n}\n.group:focus .group-focus\\:no-underline {\n  text-decoration: none;\n}\n.hover\\:underline:hover {\n  text-decoration: none;\n}\n.hover\\:line-through:hover {\n  text-decoration: line-through;\n}\n.hover\\:no-underline:hover {\n  text-decoration: none;\n}\n.focus\\:underline:focus {\n  text-decoration: none;\n}\n.focus\\:line-through:focus {\n  text-decoration: line-through;\n}\n.focus\\:no-underline:focus {\n  text-decoration: none;\n}\n.antialiased {\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n.subpixel-antialiased {\n  -webkit-font-smoothing: auto;\n  -moz-osx-font-smoothing: auto;\n}\n.ordinal, .slashed-zero, .lining-nums, .oldstyle-nums, .proportional-nums, .tabular-nums, .diagonal-fractions, .stacked-fractions {\n  --font-variant-numeric-ordinal: var(--tailwind-empty,\n      /*!*/\n      /*!*/\n    );\n  --font-variant-numeric-slashed-zero: var(--tailwind-empty,\n      /*!*/\n      /*!*/\n    );\n  --font-variant-numeric-figure: var(--tailwind-empty,\n      /*!*/\n      /*!*/\n    );\n  --font-variant-numeric-spacing: var(--tailwind-empty,\n      /*!*/\n      /*!*/\n    );\n  --font-variant-numeric-fraction: var(--tailwind-empty,\n      /*!*/\n      /*!*/\n    );\n  font-variant-numeric: var(--font-variant-numeric-ordinal) var(--font-variant-numeric-slashed-zero) var(--font-variant-numeric-figure) var(--font-variant-numeric-spacing) var(--font-variant-numeric-fraction);\n}\n.normal-nums {\n  font-variant-numeric: normal;\n}\n.ordinal {\n  --font-variant-numeric-ordinal: ordinal;\n}\n.slashed-zero {\n  --font-variant-numeric-slashed-zero: slashed-zero;\n}\n.lining-nums {\n  --font-variant-numeric-figure: lining-nums;\n}\n.oldstyle-nums {\n  --font-variant-numeric-figure: oldstyle-nums;\n}\n.proportional-nums {\n  --font-variant-numeric-spacing: proportional-nums;\n}\n.tabular-nums {\n  --font-variant-numeric-spacing: tabular-nums;\n}\n.diagonal-fractions {\n  --font-variant-numeric-fraction: diagonal-fractions;\n}\n.stacked-fractions {\n  --font-variant-numeric-fraction: stacked-fractions;\n}\n.tracking-tighter {\n  letter-spacing: -0.05em;\n}\n.tracking-tight {\n  letter-spacing: -0.025em;\n}\n.tracking-normal {\n  letter-spacing: 0;\n}\n.tracking-wide {\n  letter-spacing: 0.025em;\n}\n.tracking-wider {\n  letter-spacing: 0.05em;\n}\n.tracking-widest {\n  letter-spacing: 0.1em;\n}\n.select-none {\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  user-select: none;\n}\n.select-text {\n  -webkit-user-select: text;\n  -moz-user-select: text;\n  user-select: text;\n}\n.select-all {\n  -webkit-user-select: all;\n  -moz-user-select: all;\n  user-select: all;\n}\n.select-auto {\n  -webkit-user-select: auto;\n  -moz-user-select: auto;\n  user-select: auto;\n}\n.align-baseline {\n  vertical-align: baseline;\n}\n.align-top {\n  vertical-align: top;\n}\n.align-middle {\n  vertical-align: middle;\n}\n.align-bottom {\n  vertical-align: bottom;\n}\n.align-text-top {\n  vertical-align: text-top;\n}\n.align-text-bottom {\n  vertical-align: text-bottom;\n}\n.visible {\n  visibility: visible;\n}\n.invisible {\n  visibility: hidden;\n}\n.whitespace-normal {\n  white-space: normal;\n}\n.whitespace-no-wrap {\n  white-space: nowrap;\n}\n.whitespace-pre {\n  white-space: pre;\n}\n.whitespace-pre-line {\n  white-space: pre-line;\n}\n.whitespace-pre-wrap {\n  white-space: pre-wrap;\n}\n.break-normal {\n  word-wrap: normal;\n  overflow-wrap: normal;\n  word-break: normal;\n}\n.break-words {\n  word-wrap: break-word;\n  overflow-wrap: break-word;\n}\n.break-all {\n  word-break: break-all;\n}\n.truncate {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.w-0 {\n  width: 0;\n}\n.w-1 {\n  width: 0.25rem;\n}\n.w-2 {\n  width: 0.5rem;\n}\n.w-3 {\n  width: 0.75rem;\n}\n.w-4 {\n  width: 1rem;\n}\n.w-5 {\n  width: 1.25rem;\n}\n.w-6 {\n  width: 1.5rem;\n}\n.w-7 {\n  width: 1.75rem;\n}\n.w-8 {\n  width: 2rem;\n}\n.w-9 {\n  width: 2.25rem;\n}\n.w-10 {\n  width: 2.5rem;\n}\n.w-11 {\n  width: 2.75rem;\n}\n.w-12 {\n  width: 3rem;\n}\n.w-13 {\n  width: 3.25rem;\n}\n.w-14 {\n  width: 3.5rem;\n}\n.w-15 {\n  width: 3.75rem;\n}\n.w-16 {\n  width: 4rem;\n}\n.w-20 {\n  width: 5rem;\n}\n.w-24 {\n  width: 6rem;\n}\n.w-28 {\n  width: 7rem;\n}\n.w-32 {\n  width: 8rem;\n}\n.w-36 {\n  width: 9rem;\n}\n.w-40 {\n  width: 10rem;\n}\n.w-44 {\n  width: 11rem;\n}\n.w-48 {\n  width: 12rem;\n}\n.w-52 {\n  width: 13rem;\n}\n.w-56 {\n  width: 14rem;\n}\n.w-60 {\n  width: 15rem;\n}\n.w-64 {\n  width: 16rem;\n}\n.w-72 {\n  width: 18rem;\n}\n.w-80 {\n  width: 20rem;\n}\n.w-96 {\n  width: 24rem;\n}\n.w-auto {\n  width: auto;\n}\n.w-px {\n  width: 1px;\n}\n.w-0\\.5 {\n  width: 0.125rem;\n}\n.w-1\\.5 {\n  width: 0.375rem;\n}\n.w-2\\.5 {\n  width: 0.625rem;\n}\n.w-3\\.5 {\n  width: 0.875rem;\n}\n.w-1\\/2 {\n  width: 50%;\n}\n.w-1\\/3 {\n  width: 33.333333%;\n}\n.w-2\\/3 {\n  width: 66.666667%;\n}\n.w-1\\/4 {\n  width: 25%;\n}\n.w-2\\/4 {\n  width: 50%;\n}\n.w-3\\/4 {\n  width: 75%;\n}\n.w-1\\/5 {\n  width: 20%;\n}\n.w-2\\/5 {\n  width: 40%;\n}\n.w-3\\/5 {\n  width: 60%;\n}\n.w-4\\/5 {\n  width: 80%;\n}\n.w-1\\/6 {\n  width: 16.666667%;\n}\n.w-2\\/6 {\n  width: 33.333333%;\n}\n.w-3\\/6 {\n  width: 50%;\n}\n.w-4\\/6 {\n  width: 66.666667%;\n}\n.w-5\\/6 {\n  width: 83.333333%;\n}\n.w-1\\/12 {\n  width: 8.333333%;\n}\n.w-2\\/12 {\n  width: 16.666667%;\n}\n.w-3\\/12 {\n  width: 25%;\n}\n.w-4\\/12 {\n  width: 33.333333%;\n}\n.w-5\\/12 {\n  width: 41.666667%;\n}\n.w-6\\/12 {\n  width: 50%;\n}\n.w-7\\/12 {\n  width: 58.333333%;\n}\n.w-8\\/12 {\n  width: 66.666667%;\n}\n.w-9\\/12 {\n  width: 75%;\n}\n.w-10\\/12 {\n  width: 83.333333%;\n}\n.w-11\\/12 {\n  width: 91.666667%;\n}\n.w-full {\n  width: 100%;\n}\n.w-screen {\n  width: 100vw;\n}\n.w-min-content {\n  width: -moz-min-content;\n  width: min-content;\n}\n.w-max-content {\n  width: -moz-max-content;\n  width: max-content;\n}\n.z-0 {\n  z-index: 0;\n}\n.z-10 {\n  z-index: 10;\n}\n.z-20 {\n  z-index: 20;\n}\n.z-30 {\n  z-index: 30;\n}\n.z-40 {\n  z-index: 40;\n}\n.z-50 {\n  z-index: 50;\n}\n.z-auto {\n  z-index: auto;\n}\n.focus-within\\:z-0:focus-within {\n  z-index: 0;\n}\n.focus-within\\:z-10:focus-within {\n  z-index: 10;\n}\n.focus-within\\:z-20:focus-within {\n  z-index: 20;\n}\n.focus-within\\:z-30:focus-within {\n  z-index: 30;\n}\n.focus-within\\:z-40:focus-within {\n  z-index: 40;\n}\n.focus-within\\:z-50:focus-within {\n  z-index: 50;\n}\n.focus-within\\:z-auto:focus-within {\n  z-index: auto;\n}\n.focus\\:z-0:focus {\n  z-index: 0;\n}\n.focus\\:z-10:focus {\n  z-index: 10;\n}\n.focus\\:z-20:focus {\n  z-index: 20;\n}\n.focus\\:z-30:focus {\n  z-index: 30;\n}\n.focus\\:z-40:focus {\n  z-index: 40;\n}\n.focus\\:z-50:focus {\n  z-index: 50;\n}\n.focus\\:z-auto:focus {\n  z-index: auto;\n}\n.gap-0 {\n  grid-gap: 0;\n  gap: 0;\n}\n.gap-1 {\n  grid-gap: 0.25rem;\n  gap: 0.25rem;\n}\n.gap-2 {\n  grid-gap: 0.5rem;\n  gap: 0.5rem;\n}\n.gap-3 {\n  grid-gap: 0.75rem;\n  gap: 0.75rem;\n}\n.gap-4 {\n  grid-gap: 1rem;\n  gap: 1rem;\n}\n.gap-5 {\n  grid-gap: 1.25rem;\n  gap: 1.25rem;\n}\n.gap-6 {\n  grid-gap: 1.5rem;\n  gap: 1.5rem;\n}\n.gap-7 {\n  grid-gap: 1.75rem;\n  gap: 1.75rem;\n}\n.gap-8 {\n  grid-gap: 2rem;\n  gap: 2rem;\n}\n.gap-9 {\n  grid-gap: 2.25rem;\n  gap: 2.25rem;\n}\n.gap-10 {\n  grid-gap: 2.5rem;\n  gap: 2.5rem;\n}\n.gap-11 {\n  grid-gap: 2.75rem;\n  gap: 2.75rem;\n}\n.gap-12 {\n  grid-gap: 3rem;\n  gap: 3rem;\n}\n.gap-13 {\n  grid-gap: 3.25rem;\n  gap: 3.25rem;\n}\n.gap-14 {\n  grid-gap: 3.5rem;\n  gap: 3.5rem;\n}\n.gap-15 {\n  grid-gap: 3.75rem;\n  gap: 3.75rem;\n}\n.gap-16 {\n  grid-gap: 4rem;\n  gap: 4rem;\n}\n.gap-20 {\n  grid-gap: 5rem;\n  gap: 5rem;\n}\n.gap-24 {\n  grid-gap: 6rem;\n  gap: 6rem;\n}\n.gap-28 {\n  grid-gap: 7rem;\n  gap: 7rem;\n}\n.gap-32 {\n  grid-gap: 8rem;\n  gap: 8rem;\n}\n.gap-36 {\n  grid-gap: 9rem;\n  gap: 9rem;\n}\n.gap-40 {\n  grid-gap: 10rem;\n  gap: 10rem;\n}\n.gap-44 {\n  grid-gap: 11rem;\n  gap: 11rem;\n}\n.gap-48 {\n  grid-gap: 12rem;\n  gap: 12rem;\n}\n.gap-52 {\n  grid-gap: 13rem;\n  gap: 13rem;\n}\n.gap-56 {\n  grid-gap: 14rem;\n  gap: 14rem;\n}\n.gap-60 {\n  grid-gap: 15rem;\n  gap: 15rem;\n}\n.gap-64 {\n  grid-gap: 16rem;\n  gap: 16rem;\n}\n.gap-72 {\n  grid-gap: 18rem;\n  gap: 18rem;\n}\n.gap-80 {\n  grid-gap: 20rem;\n  gap: 20rem;\n}\n.gap-96 {\n  grid-gap: 24rem;\n  gap: 24rem;\n}\n.gap-px {\n  grid-gap: 1px;\n  gap: 1px;\n}\n.gap-0\\.5 {\n  grid-gap: 0.125rem;\n  gap: 0.125rem;\n}\n.gap-1\\.5 {\n  grid-gap: 0.375rem;\n  gap: 0.375rem;\n}\n.gap-2\\.5 {\n  grid-gap: 0.625rem;\n  gap: 0.625rem;\n}\n.gap-3\\.5 {\n  grid-gap: 0.875rem;\n  gap: 0.875rem;\n}\n.gap-1\\/2 {\n  grid-gap: 50%;\n  gap: 50%;\n}\n.gap-1\\/3 {\n  grid-gap: 33.333333%;\n  gap: 33.333333%;\n}\n.gap-2\\/3 {\n  grid-gap: 66.666667%;\n  gap: 66.666667%;\n}\n.gap-1\\/4 {\n  grid-gap: 25%;\n  gap: 25%;\n}\n.gap-2\\/4 {\n  grid-gap: 50%;\n  gap: 50%;\n}\n.gap-3\\/4 {\n  grid-gap: 75%;\n  gap: 75%;\n}\n.gap-1\\/5 {\n  grid-gap: 20%;\n  gap: 20%;\n}\n.gap-2\\/5 {\n  grid-gap: 40%;\n  gap: 40%;\n}\n.gap-3\\/5 {\n  grid-gap: 60%;\n  gap: 60%;\n}\n.gap-4\\/5 {\n  grid-gap: 80%;\n  gap: 80%;\n}\n.gap-1\\/6 {\n  grid-gap: 16.666667%;\n  gap: 16.666667%;\n}\n.gap-2\\/6 {\n  grid-gap: 33.333333%;\n  gap: 33.333333%;\n}\n.gap-3\\/6 {\n  grid-gap: 50%;\n  gap: 50%;\n}\n.gap-4\\/6 {\n  grid-gap: 66.666667%;\n  gap: 66.666667%;\n}\n.gap-5\\/6 {\n  grid-gap: 83.333333%;\n  gap: 83.333333%;\n}\n.gap-1\\/12 {\n  grid-gap: 8.333333%;\n  gap: 8.333333%;\n}\n.gap-2\\/12 {\n  grid-gap: 16.666667%;\n  gap: 16.666667%;\n}\n.gap-3\\/12 {\n  grid-gap: 25%;\n  gap: 25%;\n}\n.gap-4\\/12 {\n  grid-gap: 33.333333%;\n  gap: 33.333333%;\n}\n.gap-5\\/12 {\n  grid-gap: 41.666667%;\n  gap: 41.666667%;\n}\n.gap-6\\/12 {\n  grid-gap: 50%;\n  gap: 50%;\n}\n.gap-7\\/12 {\n  grid-gap: 58.333333%;\n  gap: 58.333333%;\n}\n.gap-8\\/12 {\n  grid-gap: 66.666667%;\n  gap: 66.666667%;\n}\n.gap-9\\/12 {\n  grid-gap: 75%;\n  gap: 75%;\n}\n.gap-10\\/12 {\n  grid-gap: 83.333333%;\n  gap: 83.333333%;\n}\n.gap-11\\/12 {\n  grid-gap: 91.666667%;\n  gap: 91.666667%;\n}\n.gap-full {\n  grid-gap: 100%;\n  gap: 100%;\n}\n.col-gap-0 {\n  grid-column-gap: 0;\n  -moz-column-gap: 0;\n  column-gap: 0;\n}\n.col-gap-1 {\n  grid-column-gap: 0.25rem;\n  -moz-column-gap: 0.25rem;\n  column-gap: 0.25rem;\n}\n.col-gap-2 {\n  grid-column-gap: 0.5rem;\n  -moz-column-gap: 0.5rem;\n  column-gap: 0.5rem;\n}\n.col-gap-3 {\n  grid-column-gap: 0.75rem;\n  -moz-column-gap: 0.75rem;\n  column-gap: 0.75rem;\n}\n.col-gap-4 {\n  grid-column-gap: 1rem;\n  -moz-column-gap: 1rem;\n  column-gap: 1rem;\n}\n.col-gap-5 {\n  grid-column-gap: 1.25rem;\n  -moz-column-gap: 1.25rem;\n  column-gap: 1.25rem;\n}\n.col-gap-6 {\n  grid-column-gap: 1.5rem;\n  -moz-column-gap: 1.5rem;\n  column-gap: 1.5rem;\n}\n.col-gap-7 {\n  grid-column-gap: 1.75rem;\n  -moz-column-gap: 1.75rem;\n  column-gap: 1.75rem;\n}\n.col-gap-8 {\n  grid-column-gap: 2rem;\n  -moz-column-gap: 2rem;\n  column-gap: 2rem;\n}\n.col-gap-9 {\n  grid-column-gap: 2.25rem;\n  -moz-column-gap: 2.25rem;\n  column-gap: 2.25rem;\n}\n.col-gap-10 {\n  grid-column-gap: 2.5rem;\n  -moz-column-gap: 2.5rem;\n  column-gap: 2.5rem;\n}\n.col-gap-11 {\n  grid-column-gap: 2.75rem;\n  -moz-column-gap: 2.75rem;\n  column-gap: 2.75rem;\n}\n.col-gap-12 {\n  grid-column-gap: 3rem;\n  -moz-column-gap: 3rem;\n  column-gap: 3rem;\n}\n.col-gap-13 {\n  grid-column-gap: 3.25rem;\n  -moz-column-gap: 3.25rem;\n  column-gap: 3.25rem;\n}\n.col-gap-14 {\n  grid-column-gap: 3.5rem;\n  -moz-column-gap: 3.5rem;\n  column-gap: 3.5rem;\n}\n.col-gap-15 {\n  grid-column-gap: 3.75rem;\n  -moz-column-gap: 3.75rem;\n  column-gap: 3.75rem;\n}\n.col-gap-16 {\n  grid-column-gap: 4rem;\n  -moz-column-gap: 4rem;\n  column-gap: 4rem;\n}\n.col-gap-20 {\n  grid-column-gap: 5rem;\n  -moz-column-gap: 5rem;\n  column-gap: 5rem;\n}\n.col-gap-24 {\n  grid-column-gap: 6rem;\n  -moz-column-gap: 6rem;\n  column-gap: 6rem;\n}\n.col-gap-28 {\n  grid-column-gap: 7rem;\n  -moz-column-gap: 7rem;\n  column-gap: 7rem;\n}\n.col-gap-32 {\n  grid-column-gap: 8rem;\n  -moz-column-gap: 8rem;\n  column-gap: 8rem;\n}\n.col-gap-36 {\n  grid-column-gap: 9rem;\n  -moz-column-gap: 9rem;\n  column-gap: 9rem;\n}\n.col-gap-40 {\n  grid-column-gap: 10rem;\n  -moz-column-gap: 10rem;\n  column-gap: 10rem;\n}\n.col-gap-44 {\n  grid-column-gap: 11rem;\n  -moz-column-gap: 11rem;\n  column-gap: 11rem;\n}\n.col-gap-48 {\n  grid-column-gap: 12rem;\n  -moz-column-gap: 12rem;\n  column-gap: 12rem;\n}\n.col-gap-52 {\n  grid-column-gap: 13rem;\n  -moz-column-gap: 13rem;\n  column-gap: 13rem;\n}\n.col-gap-56 {\n  grid-column-gap: 14rem;\n  -moz-column-gap: 14rem;\n  column-gap: 14rem;\n}\n.col-gap-60 {\n  grid-column-gap: 15rem;\n  -moz-column-gap: 15rem;\n  column-gap: 15rem;\n}\n.col-gap-64 {\n  grid-column-gap: 16rem;\n  -moz-column-gap: 16rem;\n  column-gap: 16rem;\n}\n.col-gap-72 {\n  grid-column-gap: 18rem;\n  -moz-column-gap: 18rem;\n  column-gap: 18rem;\n}\n.col-gap-80 {\n  grid-column-gap: 20rem;\n  -moz-column-gap: 20rem;\n  column-gap: 20rem;\n}\n.col-gap-96 {\n  grid-column-gap: 24rem;\n  -moz-column-gap: 24rem;\n  column-gap: 24rem;\n}\n.col-gap-px {\n  grid-column-gap: 1px;\n  -moz-column-gap: 1px;\n  column-gap: 1px;\n}\n.col-gap-0\\.5 {\n  grid-column-gap: 0.125rem;\n  -moz-column-gap: 0.125rem;\n  column-gap: 0.125rem;\n}\n.col-gap-1\\.5 {\n  grid-column-gap: 0.375rem;\n  -moz-column-gap: 0.375rem;\n  column-gap: 0.375rem;\n}\n.col-gap-2\\.5 {\n  grid-column-gap: 0.625rem;\n  -moz-column-gap: 0.625rem;\n  column-gap: 0.625rem;\n}\n.col-gap-3\\.5 {\n  grid-column-gap: 0.875rem;\n  -moz-column-gap: 0.875rem;\n  column-gap: 0.875rem;\n}\n.col-gap-1\\/2 {\n  grid-column-gap: 50%;\n  -moz-column-gap: 50%;\n  column-gap: 50%;\n}\n.col-gap-1\\/3 {\n  grid-column-gap: 33.333333%;\n  -moz-column-gap: 33.333333%;\n  column-gap: 33.333333%;\n}\n.col-gap-2\\/3 {\n  grid-column-gap: 66.666667%;\n  -moz-column-gap: 66.666667%;\n  column-gap: 66.666667%;\n}\n.col-gap-1\\/4 {\n  grid-column-gap: 25%;\n  -moz-column-gap: 25%;\n  column-gap: 25%;\n}\n.col-gap-2\\/4 {\n  grid-column-gap: 50%;\n  -moz-column-gap: 50%;\n  column-gap: 50%;\n}\n.col-gap-3\\/4 {\n  grid-column-gap: 75%;\n  -moz-column-gap: 75%;\n  column-gap: 75%;\n}\n.col-gap-1\\/5 {\n  grid-column-gap: 20%;\n  -moz-column-gap: 20%;\n  column-gap: 20%;\n}\n.col-gap-2\\/5 {\n  grid-column-gap: 40%;\n  -moz-column-gap: 40%;\n  column-gap: 40%;\n}\n.col-gap-3\\/5 {\n  grid-column-gap: 60%;\n  -moz-column-gap: 60%;\n  column-gap: 60%;\n}\n.col-gap-4\\/5 {\n  grid-column-gap: 80%;\n  -moz-column-gap: 80%;\n  column-gap: 80%;\n}\n.col-gap-1\\/6 {\n  grid-column-gap: 16.666667%;\n  -moz-column-gap: 16.666667%;\n  column-gap: 16.666667%;\n}\n.col-gap-2\\/6 {\n  grid-column-gap: 33.333333%;\n  -moz-column-gap: 33.333333%;\n  column-gap: 33.333333%;\n}\n.col-gap-3\\/6 {\n  grid-column-gap: 50%;\n  -moz-column-gap: 50%;\n  column-gap: 50%;\n}\n.col-gap-4\\/6 {\n  grid-column-gap: 66.666667%;\n  -moz-column-gap: 66.666667%;\n  column-gap: 66.666667%;\n}\n.col-gap-5\\/6 {\n  grid-column-gap: 83.333333%;\n  -moz-column-gap: 83.333333%;\n  column-gap: 83.333333%;\n}\n.col-gap-1\\/12 {\n  grid-column-gap: 8.333333%;\n  -moz-column-gap: 8.333333%;\n  column-gap: 8.333333%;\n}\n.col-gap-2\\/12 {\n  grid-column-gap: 16.666667%;\n  -moz-column-gap: 16.666667%;\n  column-gap: 16.666667%;\n}\n.col-gap-3\\/12 {\n  grid-column-gap: 25%;\n  -moz-column-gap: 25%;\n  column-gap: 25%;\n}\n.col-gap-4\\/12 {\n  grid-column-gap: 33.333333%;\n  -moz-column-gap: 33.333333%;\n  column-gap: 33.333333%;\n}\n.col-gap-5\\/12 {\n  grid-column-gap: 41.666667%;\n  -moz-column-gap: 41.666667%;\n  column-gap: 41.666667%;\n}\n.col-gap-6\\/12 {\n  grid-column-gap: 50%;\n  -moz-column-gap: 50%;\n  column-gap: 50%;\n}\n.col-gap-7\\/12 {\n  grid-column-gap: 58.333333%;\n  -moz-column-gap: 58.333333%;\n  column-gap: 58.333333%;\n}\n.col-gap-8\\/12 {\n  grid-column-gap: 66.666667%;\n  -moz-column-gap: 66.666667%;\n  column-gap: 66.666667%;\n}\n.col-gap-9\\/12 {\n  grid-column-gap: 75%;\n  -moz-column-gap: 75%;\n  column-gap: 75%;\n}\n.col-gap-10\\/12 {\n  grid-column-gap: 83.333333%;\n  -moz-column-gap: 83.333333%;\n  column-gap: 83.333333%;\n}\n.col-gap-11\\/12 {\n  grid-column-gap: 91.666667%;\n  -moz-column-gap: 91.666667%;\n  column-gap: 91.666667%;\n}\n.col-gap-full {\n  grid-column-gap: 100%;\n  -moz-column-gap: 100%;\n  column-gap: 100%;\n}\n.gap-x-0 {\n  grid-column-gap: 0;\n  -moz-column-gap: 0;\n  column-gap: 0;\n}\n.gap-x-1 {\n  grid-column-gap: 0.25rem;\n  -moz-column-gap: 0.25rem;\n  column-gap: 0.25rem;\n}\n.gap-x-2 {\n  grid-column-gap: 0.5rem;\n  -moz-column-gap: 0.5rem;\n  column-gap: 0.5rem;\n}\n.gap-x-3 {\n  grid-column-gap: 0.75rem;\n  -moz-column-gap: 0.75rem;\n  column-gap: 0.75rem;\n}\n.gap-x-4 {\n  grid-column-gap: 1rem;\n  -moz-column-gap: 1rem;\n  column-gap: 1rem;\n}\n.gap-x-5 {\n  grid-column-gap: 1.25rem;\n  -moz-column-gap: 1.25rem;\n  column-gap: 1.25rem;\n}\n.gap-x-6 {\n  grid-column-gap: 1.5rem;\n  -moz-column-gap: 1.5rem;\n  column-gap: 1.5rem;\n}\n.gap-x-7 {\n  grid-column-gap: 1.75rem;\n  -moz-column-gap: 1.75rem;\n  column-gap: 1.75rem;\n}\n.gap-x-8 {\n  grid-column-gap: 2rem;\n  -moz-column-gap: 2rem;\n  column-gap: 2rem;\n}\n.gap-x-9 {\n  grid-column-gap: 2.25rem;\n  -moz-column-gap: 2.25rem;\n  column-gap: 2.25rem;\n}\n.gap-x-10 {\n  grid-column-gap: 2.5rem;\n  -moz-column-gap: 2.5rem;\n  column-gap: 2.5rem;\n}\n.gap-x-11 {\n  grid-column-gap: 2.75rem;\n  -moz-column-gap: 2.75rem;\n  column-gap: 2.75rem;\n}\n.gap-x-12 {\n  grid-column-gap: 3rem;\n  -moz-column-gap: 3rem;\n  column-gap: 3rem;\n}\n.gap-x-13 {\n  grid-column-gap: 3.25rem;\n  -moz-column-gap: 3.25rem;\n  column-gap: 3.25rem;\n}\n.gap-x-14 {\n  grid-column-gap: 3.5rem;\n  -moz-column-gap: 3.5rem;\n  column-gap: 3.5rem;\n}\n.gap-x-15 {\n  grid-column-gap: 3.75rem;\n  -moz-column-gap: 3.75rem;\n  column-gap: 3.75rem;\n}\n.gap-x-16 {\n  grid-column-gap: 4rem;\n  -moz-column-gap: 4rem;\n  column-gap: 4rem;\n}\n.gap-x-20 {\n  grid-column-gap: 5rem;\n  -moz-column-gap: 5rem;\n  column-gap: 5rem;\n}\n.gap-x-24 {\n  grid-column-gap: 6rem;\n  -moz-column-gap: 6rem;\n  column-gap: 6rem;\n}\n.gap-x-28 {\n  grid-column-gap: 7rem;\n  -moz-column-gap: 7rem;\n  column-gap: 7rem;\n}\n.gap-x-32 {\n  grid-column-gap: 8rem;\n  -moz-column-gap: 8rem;\n  column-gap: 8rem;\n}\n.gap-x-36 {\n  grid-column-gap: 9rem;\n  -moz-column-gap: 9rem;\n  column-gap: 9rem;\n}\n.gap-x-40 {\n  grid-column-gap: 10rem;\n  -moz-column-gap: 10rem;\n  column-gap: 10rem;\n}\n.gap-x-44 {\n  grid-column-gap: 11rem;\n  -moz-column-gap: 11rem;\n  column-gap: 11rem;\n}\n.gap-x-48 {\n  grid-column-gap: 12rem;\n  -moz-column-gap: 12rem;\n  column-gap: 12rem;\n}\n.gap-x-52 {\n  grid-column-gap: 13rem;\n  -moz-column-gap: 13rem;\n  column-gap: 13rem;\n}\n.gap-x-56 {\n  grid-column-gap: 14rem;\n  -moz-column-gap: 14rem;\n  column-gap: 14rem;\n}\n.gap-x-60 {\n  grid-column-gap: 15rem;\n  -moz-column-gap: 15rem;\n  column-gap: 15rem;\n}\n.gap-x-64 {\n  grid-column-gap: 16rem;\n  -moz-column-gap: 16rem;\n  column-gap: 16rem;\n}\n.gap-x-72 {\n  grid-column-gap: 18rem;\n  -moz-column-gap: 18rem;\n  column-gap: 18rem;\n}\n.gap-x-80 {\n  grid-column-gap: 20rem;\n  -moz-column-gap: 20rem;\n  column-gap: 20rem;\n}\n.gap-x-96 {\n  grid-column-gap: 24rem;\n  -moz-column-gap: 24rem;\n  column-gap: 24rem;\n}\n.gap-x-px {\n  grid-column-gap: 1px;\n  -moz-column-gap: 1px;\n  column-gap: 1px;\n}\n.gap-x-0\\.5 {\n  grid-column-gap: 0.125rem;\n  -moz-column-gap: 0.125rem;\n  column-gap: 0.125rem;\n}\n.gap-x-1\\.5 {\n  grid-column-gap: 0.375rem;\n  -moz-column-gap: 0.375rem;\n  column-gap: 0.375rem;\n}\n.gap-x-2\\.5 {\n  grid-column-gap: 0.625rem;\n  -moz-column-gap: 0.625rem;\n  column-gap: 0.625rem;\n}\n.gap-x-3\\.5 {\n  grid-column-gap: 0.875rem;\n  -moz-column-gap: 0.875rem;\n  column-gap: 0.875rem;\n}\n.gap-x-1\\/2 {\n  grid-column-gap: 50%;\n  -moz-column-gap: 50%;\n  column-gap: 50%;\n}\n.gap-x-1\\/3 {\n  grid-column-gap: 33.333333%;\n  -moz-column-gap: 33.333333%;\n  column-gap: 33.333333%;\n}\n.gap-x-2\\/3 {\n  grid-column-gap: 66.666667%;\n  -moz-column-gap: 66.666667%;\n  column-gap: 66.666667%;\n}\n.gap-x-1\\/4 {\n  grid-column-gap: 25%;\n  -moz-column-gap: 25%;\n  column-gap: 25%;\n}\n.gap-x-2\\/4 {\n  grid-column-gap: 50%;\n  -moz-column-gap: 50%;\n  column-gap: 50%;\n}\n.gap-x-3\\/4 {\n  grid-column-gap: 75%;\n  -moz-column-gap: 75%;\n  column-gap: 75%;\n}\n.gap-x-1\\/5 {\n  grid-column-gap: 20%;\n  -moz-column-gap: 20%;\n  column-gap: 20%;\n}\n.gap-x-2\\/5 {\n  grid-column-gap: 40%;\n  -moz-column-gap: 40%;\n  column-gap: 40%;\n}\n.gap-x-3\\/5 {\n  grid-column-gap: 60%;\n  -moz-column-gap: 60%;\n  column-gap: 60%;\n}\n.gap-x-4\\/5 {\n  grid-column-gap: 80%;\n  -moz-column-gap: 80%;\n  column-gap: 80%;\n}\n.gap-x-1\\/6 {\n  grid-column-gap: 16.666667%;\n  -moz-column-gap: 16.666667%;\n  column-gap: 16.666667%;\n}\n.gap-x-2\\/6 {\n  grid-column-gap: 33.333333%;\n  -moz-column-gap: 33.333333%;\n  column-gap: 33.333333%;\n}\n.gap-x-3\\/6 {\n  grid-column-gap: 50%;\n  -moz-column-gap: 50%;\n  column-gap: 50%;\n}\n.gap-x-4\\/6 {\n  grid-column-gap: 66.666667%;\n  -moz-column-gap: 66.666667%;\n  column-gap: 66.666667%;\n}\n.gap-x-5\\/6 {\n  grid-column-gap: 83.333333%;\n  -moz-column-gap: 83.333333%;\n  column-gap: 83.333333%;\n}\n.gap-x-1\\/12 {\n  grid-column-gap: 8.333333%;\n  -moz-column-gap: 8.333333%;\n  column-gap: 8.333333%;\n}\n.gap-x-2\\/12 {\n  grid-column-gap: 16.666667%;\n  -moz-column-gap: 16.666667%;\n  column-gap: 16.666667%;\n}\n.gap-x-3\\/12 {\n  grid-column-gap: 25%;\n  -moz-column-gap: 25%;\n  column-gap: 25%;\n}\n.gap-x-4\\/12 {\n  grid-column-gap: 33.333333%;\n  -moz-column-gap: 33.333333%;\n  column-gap: 33.333333%;\n}\n.gap-x-5\\/12 {\n  grid-column-gap: 41.666667%;\n  -moz-column-gap: 41.666667%;\n  column-gap: 41.666667%;\n}\n.gap-x-6\\/12 {\n  grid-column-gap: 50%;\n  -moz-column-gap: 50%;\n  column-gap: 50%;\n}\n.gap-x-7\\/12 {\n  grid-column-gap: 58.333333%;\n  -moz-column-gap: 58.333333%;\n  column-gap: 58.333333%;\n}\n.gap-x-8\\/12 {\n  grid-column-gap: 66.666667%;\n  -moz-column-gap: 66.666667%;\n  column-gap: 66.666667%;\n}\n.gap-x-9\\/12 {\n  grid-column-gap: 75%;\n  -moz-column-gap: 75%;\n  column-gap: 75%;\n}\n.gap-x-10\\/12 {\n  grid-column-gap: 83.333333%;\n  -moz-column-gap: 83.333333%;\n  column-gap: 83.333333%;\n}\n.gap-x-11\\/12 {\n  grid-column-gap: 91.666667%;\n  -moz-column-gap: 91.666667%;\n  column-gap: 91.666667%;\n}\n.gap-x-full {\n  grid-column-gap: 100%;\n  -moz-column-gap: 100%;\n  column-gap: 100%;\n}\n.row-gap-0 {\n  grid-row-gap: 0;\n  row-gap: 0;\n}\n.row-gap-1 {\n  grid-row-gap: 0.25rem;\n  row-gap: 0.25rem;\n}\n.row-gap-2 {\n  grid-row-gap: 0.5rem;\n  row-gap: 0.5rem;\n}\n.row-gap-3 {\n  grid-row-gap: 0.75rem;\n  row-gap: 0.75rem;\n}\n.row-gap-4 {\n  grid-row-gap: 1rem;\n  row-gap: 1rem;\n}\n.row-gap-5 {\n  grid-row-gap: 1.25rem;\n  row-gap: 1.25rem;\n}\n.row-gap-6 {\n  grid-row-gap: 1.5rem;\n  row-gap: 1.5rem;\n}\n.row-gap-7 {\n  grid-row-gap: 1.75rem;\n  row-gap: 1.75rem;\n}\n.row-gap-8 {\n  grid-row-gap: 2rem;\n  row-gap: 2rem;\n}\n.row-gap-9 {\n  grid-row-gap: 2.25rem;\n  row-gap: 2.25rem;\n}\n.row-gap-10 {\n  grid-row-gap: 2.5rem;\n  row-gap: 2.5rem;\n}\n.row-gap-11 {\n  grid-row-gap: 2.75rem;\n  row-gap: 2.75rem;\n}\n.row-gap-12 {\n  grid-row-gap: 3rem;\n  row-gap: 3rem;\n}\n.row-gap-13 {\n  grid-row-gap: 3.25rem;\n  row-gap: 3.25rem;\n}\n.row-gap-14 {\n  grid-row-gap: 3.5rem;\n  row-gap: 3.5rem;\n}\n.row-gap-15 {\n  grid-row-gap: 3.75rem;\n  row-gap: 3.75rem;\n}\n.row-gap-16 {\n  grid-row-gap: 4rem;\n  row-gap: 4rem;\n}\n.row-gap-20 {\n  grid-row-gap: 5rem;\n  row-gap: 5rem;\n}\n.row-gap-24 {\n  grid-row-gap: 6rem;\n  row-gap: 6rem;\n}\n.row-gap-28 {\n  grid-row-gap: 7rem;\n  row-gap: 7rem;\n}\n.row-gap-32 {\n  grid-row-gap: 8rem;\n  row-gap: 8rem;\n}\n.row-gap-36 {\n  grid-row-gap: 9rem;\n  row-gap: 9rem;\n}\n.row-gap-40 {\n  grid-row-gap: 10rem;\n  row-gap: 10rem;\n}\n.row-gap-44 {\n  grid-row-gap: 11rem;\n  row-gap: 11rem;\n}\n.row-gap-48 {\n  grid-row-gap: 12rem;\n  row-gap: 12rem;\n}\n.row-gap-52 {\n  grid-row-gap: 13rem;\n  row-gap: 13rem;\n}\n.row-gap-56 {\n  grid-row-gap: 14rem;\n  row-gap: 14rem;\n}\n.row-gap-60 {\n  grid-row-gap: 15rem;\n  row-gap: 15rem;\n}\n.row-gap-64 {\n  grid-row-gap: 16rem;\n  row-gap: 16rem;\n}\n.row-gap-72 {\n  grid-row-gap: 18rem;\n  row-gap: 18rem;\n}\n.row-gap-80 {\n  grid-row-gap: 20rem;\n  row-gap: 20rem;\n}\n.row-gap-96 {\n  grid-row-gap: 24rem;\n  row-gap: 24rem;\n}\n.row-gap-px {\n  grid-row-gap: 1px;\n  row-gap: 1px;\n}\n.row-gap-0\\.5 {\n  grid-row-gap: 0.125rem;\n  row-gap: 0.125rem;\n}\n.row-gap-1\\.5 {\n  grid-row-gap: 0.375rem;\n  row-gap: 0.375rem;\n}\n.row-gap-2\\.5 {\n  grid-row-gap: 0.625rem;\n  row-gap: 0.625rem;\n}\n.row-gap-3\\.5 {\n  grid-row-gap: 0.875rem;\n  row-gap: 0.875rem;\n}\n.row-gap-1\\/2 {\n  grid-row-gap: 50%;\n  row-gap: 50%;\n}\n.row-gap-1\\/3 {\n  grid-row-gap: 33.333333%;\n  row-gap: 33.333333%;\n}\n.row-gap-2\\/3 {\n  grid-row-gap: 66.666667%;\n  row-gap: 66.666667%;\n}\n.row-gap-1\\/4 {\n  grid-row-gap: 25%;\n  row-gap: 25%;\n}\n.row-gap-2\\/4 {\n  grid-row-gap: 50%;\n  row-gap: 50%;\n}\n.row-gap-3\\/4 {\n  grid-row-gap: 75%;\n  row-gap: 75%;\n}\n.row-gap-1\\/5 {\n  grid-row-gap: 20%;\n  row-gap: 20%;\n}\n.row-gap-2\\/5 {\n  grid-row-gap: 40%;\n  row-gap: 40%;\n}\n.row-gap-3\\/5 {\n  grid-row-gap: 60%;\n  row-gap: 60%;\n}\n.row-gap-4\\/5 {\n  grid-row-gap: 80%;\n  row-gap: 80%;\n}\n.row-gap-1\\/6 {\n  grid-row-gap: 16.666667%;\n  row-gap: 16.666667%;\n}\n.row-gap-2\\/6 {\n  grid-row-gap: 33.333333%;\n  row-gap: 33.333333%;\n}\n.row-gap-3\\/6 {\n  grid-row-gap: 50%;\n  row-gap: 50%;\n}\n.row-gap-4\\/6 {\n  grid-row-gap: 66.666667%;\n  row-gap: 66.666667%;\n}\n.row-gap-5\\/6 {\n  grid-row-gap: 83.333333%;\n  row-gap: 83.333333%;\n}\n.row-gap-1\\/12 {\n  grid-row-gap: 8.333333%;\n  row-gap: 8.333333%;\n}\n.row-gap-2\\/12 {\n  grid-row-gap: 16.666667%;\n  row-gap: 16.666667%;\n}\n.row-gap-3\\/12 {\n  grid-row-gap: 25%;\n  row-gap: 25%;\n}\n.row-gap-4\\/12 {\n  grid-row-gap: 33.333333%;\n  row-gap: 33.333333%;\n}\n.row-gap-5\\/12 {\n  grid-row-gap: 41.666667%;\n  row-gap: 41.666667%;\n}\n.row-gap-6\\/12 {\n  grid-row-gap: 50%;\n  row-gap: 50%;\n}\n.row-gap-7\\/12 {\n  grid-row-gap: 58.333333%;\n  row-gap: 58.333333%;\n}\n.row-gap-8\\/12 {\n  grid-row-gap: 66.666667%;\n  row-gap: 66.666667%;\n}\n.row-gap-9\\/12 {\n  grid-row-gap: 75%;\n  row-gap: 75%;\n}\n.row-gap-10\\/12 {\n  grid-row-gap: 83.333333%;\n  row-gap: 83.333333%;\n}\n.row-gap-11\\/12 {\n  grid-row-gap: 91.666667%;\n  row-gap: 91.666667%;\n}\n.row-gap-full {\n  grid-row-gap: 100%;\n  row-gap: 100%;\n}\n.gap-y-0 {\n  grid-row-gap: 0;\n  row-gap: 0;\n}\n.gap-y-1 {\n  grid-row-gap: 0.25rem;\n  row-gap: 0.25rem;\n}\n.gap-y-2 {\n  grid-row-gap: 0.5rem;\n  row-gap: 0.5rem;\n}\n.gap-y-3 {\n  grid-row-gap: 0.75rem;\n  row-gap: 0.75rem;\n}\n.gap-y-4 {\n  grid-row-gap: 1rem;\n  row-gap: 1rem;\n}\n.gap-y-5 {\n  grid-row-gap: 1.25rem;\n  row-gap: 1.25rem;\n}\n.gap-y-6 {\n  grid-row-gap: 1.5rem;\n  row-gap: 1.5rem;\n}\n.gap-y-7 {\n  grid-row-gap: 1.75rem;\n  row-gap: 1.75rem;\n}\n.gap-y-8 {\n  grid-row-gap: 2rem;\n  row-gap: 2rem;\n}\n.gap-y-9 {\n  grid-row-gap: 2.25rem;\n  row-gap: 2.25rem;\n}\n.gap-y-10 {\n  grid-row-gap: 2.5rem;\n  row-gap: 2.5rem;\n}\n.gap-y-11 {\n  grid-row-gap: 2.75rem;\n  row-gap: 2.75rem;\n}\n.gap-y-12 {\n  grid-row-gap: 3rem;\n  row-gap: 3rem;\n}\n.gap-y-13 {\n  grid-row-gap: 3.25rem;\n  row-gap: 3.25rem;\n}\n.gap-y-14 {\n  grid-row-gap: 3.5rem;\n  row-gap: 3.5rem;\n}\n.gap-y-15 {\n  grid-row-gap: 3.75rem;\n  row-gap: 3.75rem;\n}\n.gap-y-16 {\n  grid-row-gap: 4rem;\n  row-gap: 4rem;\n}\n.gap-y-20 {\n  grid-row-gap: 5rem;\n  row-gap: 5rem;\n}\n.gap-y-24 {\n  grid-row-gap: 6rem;\n  row-gap: 6rem;\n}\n.gap-y-28 {\n  grid-row-gap: 7rem;\n  row-gap: 7rem;\n}\n.gap-y-32 {\n  grid-row-gap: 8rem;\n  row-gap: 8rem;\n}\n.gap-y-36 {\n  grid-row-gap: 9rem;\n  row-gap: 9rem;\n}\n.gap-y-40 {\n  grid-row-gap: 10rem;\n  row-gap: 10rem;\n}\n.gap-y-44 {\n  grid-row-gap: 11rem;\n  row-gap: 11rem;\n}\n.gap-y-48 {\n  grid-row-gap: 12rem;\n  row-gap: 12rem;\n}\n.gap-y-52 {\n  grid-row-gap: 13rem;\n  row-gap: 13rem;\n}\n.gap-y-56 {\n  grid-row-gap: 14rem;\n  row-gap: 14rem;\n}\n.gap-y-60 {\n  grid-row-gap: 15rem;\n  row-gap: 15rem;\n}\n.gap-y-64 {\n  grid-row-gap: 16rem;\n  row-gap: 16rem;\n}\n.gap-y-72 {\n  grid-row-gap: 18rem;\n  row-gap: 18rem;\n}\n.gap-y-80 {\n  grid-row-gap: 20rem;\n  row-gap: 20rem;\n}\n.gap-y-96 {\n  grid-row-gap: 24rem;\n  row-gap: 24rem;\n}\n.gap-y-px {\n  grid-row-gap: 1px;\n  row-gap: 1px;\n}\n.gap-y-0\\.5 {\n  grid-row-gap: 0.125rem;\n  row-gap: 0.125rem;\n}\n.gap-y-1\\.5 {\n  grid-row-gap: 0.375rem;\n  row-gap: 0.375rem;\n}\n.gap-y-2\\.5 {\n  grid-row-gap: 0.625rem;\n  row-gap: 0.625rem;\n}\n.gap-y-3\\.5 {\n  grid-row-gap: 0.875rem;\n  row-gap: 0.875rem;\n}\n.gap-y-1\\/2 {\n  grid-row-gap: 50%;\n  row-gap: 50%;\n}\n.gap-y-1\\/3 {\n  grid-row-gap: 33.333333%;\n  row-gap: 33.333333%;\n}\n.gap-y-2\\/3 {\n  grid-row-gap: 66.666667%;\n  row-gap: 66.666667%;\n}\n.gap-y-1\\/4 {\n  grid-row-gap: 25%;\n  row-gap: 25%;\n}\n.gap-y-2\\/4 {\n  grid-row-gap: 50%;\n  row-gap: 50%;\n}\n.gap-y-3\\/4 {\n  grid-row-gap: 75%;\n  row-gap: 75%;\n}\n.gap-y-1\\/5 {\n  grid-row-gap: 20%;\n  row-gap: 20%;\n}\n.gap-y-2\\/5 {\n  grid-row-gap: 40%;\n  row-gap: 40%;\n}\n.gap-y-3\\/5 {\n  grid-row-gap: 60%;\n  row-gap: 60%;\n}\n.gap-y-4\\/5 {\n  grid-row-gap: 80%;\n  row-gap: 80%;\n}\n.gap-y-1\\/6 {\n  grid-row-gap: 16.666667%;\n  row-gap: 16.666667%;\n}\n.gap-y-2\\/6 {\n  grid-row-gap: 33.333333%;\n  row-gap: 33.333333%;\n}\n.gap-y-3\\/6 {\n  grid-row-gap: 50%;\n  row-gap: 50%;\n}\n.gap-y-4\\/6 {\n  grid-row-gap: 66.666667%;\n  row-gap: 66.666667%;\n}\n.gap-y-5\\/6 {\n  grid-row-gap: 83.333333%;\n  row-gap: 83.333333%;\n}\n.gap-y-1\\/12 {\n  grid-row-gap: 8.333333%;\n  row-gap: 8.333333%;\n}\n.gap-y-2\\/12 {\n  grid-row-gap: 16.666667%;\n  row-gap: 16.666667%;\n}\n.gap-y-3\\/12 {\n  grid-row-gap: 25%;\n  row-gap: 25%;\n}\n.gap-y-4\\/12 {\n  grid-row-gap: 33.333333%;\n  row-gap: 33.333333%;\n}\n.gap-y-5\\/12 {\n  grid-row-gap: 41.666667%;\n  row-gap: 41.666667%;\n}\n.gap-y-6\\/12 {\n  grid-row-gap: 50%;\n  row-gap: 50%;\n}\n.gap-y-7\\/12 {\n  grid-row-gap: 58.333333%;\n  row-gap: 58.333333%;\n}\n.gap-y-8\\/12 {\n  grid-row-gap: 66.666667%;\n  row-gap: 66.666667%;\n}\n.gap-y-9\\/12 {\n  grid-row-gap: 75%;\n  row-gap: 75%;\n}\n.gap-y-10\\/12 {\n  grid-row-gap: 83.333333%;\n  row-gap: 83.333333%;\n}\n.gap-y-11\\/12 {\n  grid-row-gap: 91.666667%;\n  row-gap: 91.666667%;\n}\n.gap-y-full {\n  grid-row-gap: 100%;\n  row-gap: 100%;\n}\n.grid-flow-row {\n  grid-auto-flow: row;\n}\n.grid-flow-col {\n  grid-auto-flow: column;\n}\n.grid-flow-row-dense {\n  grid-auto-flow: row dense;\n}\n.grid-flow-col-dense {\n  grid-auto-flow: column dense;\n}\n.grid-cols-1 {\n  grid-template-columns: repeat(1, minmax(0, 1fr));\n}\n.grid-cols-2 {\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n}\n.grid-cols-3 {\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n}\n.grid-cols-4 {\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n}\n.grid-cols-5 {\n  grid-template-columns: repeat(5, minmax(0, 1fr));\n}\n.grid-cols-6 {\n  grid-template-columns: repeat(6, minmax(0, 1fr));\n}\n.grid-cols-7 {\n  grid-template-columns: repeat(7, minmax(0, 1fr));\n}\n.grid-cols-8 {\n  grid-template-columns: repeat(8, minmax(0, 1fr));\n}\n.grid-cols-9 {\n  grid-template-columns: repeat(9, minmax(0, 1fr));\n}\n.grid-cols-10 {\n  grid-template-columns: repeat(10, minmax(0, 1fr));\n}\n.grid-cols-11 {\n  grid-template-columns: repeat(11, minmax(0, 1fr));\n}\n.grid-cols-12 {\n  grid-template-columns: repeat(12, minmax(0, 1fr));\n}\n.grid-cols-none {\n  grid-template-columns: none;\n}\n.auto-cols-auto {\n  grid-auto-columns: auto;\n}\n.auto-cols-min {\n  grid-auto-columns: min-content;\n}\n.auto-cols-max {\n  grid-auto-columns: max-content;\n}\n.auto-cols-fr {\n  grid-auto-columns: minmax(0, 1fr);\n}\n.col-auto {\n  grid-column: auto;\n}\n.col-span-1 {\n  grid-column: span 1 / span 1;\n}\n.col-span-2 {\n  grid-column: span 2 / span 2;\n}\n.col-span-3 {\n  grid-column: span 3 / span 3;\n}\n.col-span-4 {\n  grid-column: span 4 / span 4;\n}\n.col-span-5 {\n  grid-column: span 5 / span 5;\n}\n.col-span-6 {\n  grid-column: span 6 / span 6;\n}\n.col-span-7 {\n  grid-column: span 7 / span 7;\n}\n.col-span-8 {\n  grid-column: span 8 / span 8;\n}\n.col-span-9 {\n  grid-column: span 9 / span 9;\n}\n.col-span-10 {\n  grid-column: span 10 / span 10;\n}\n.col-span-11 {\n  grid-column: span 11 / span 11;\n}\n.col-span-12 {\n  grid-column: span 12 / span 12;\n}\n.col-span-full {\n  grid-column: 1 / -1;\n}\n.col-start-1 {\n  grid-column-start: 1;\n}\n.col-start-2 {\n  grid-column-start: 2;\n}\n.col-start-3 {\n  grid-column-start: 3;\n}\n.col-start-4 {\n  grid-column-start: 4;\n}\n.col-start-5 {\n  grid-column-start: 5;\n}\n.col-start-6 {\n  grid-column-start: 6;\n}\n.col-start-7 {\n  grid-column-start: 7;\n}\n.col-start-8 {\n  grid-column-start: 8;\n}\n.col-start-9 {\n  grid-column-start: 9;\n}\n.col-start-10 {\n  grid-column-start: 10;\n}\n.col-start-11 {\n  grid-column-start: 11;\n}\n.col-start-12 {\n  grid-column-start: 12;\n}\n.col-start-13 {\n  grid-column-start: 13;\n}\n.col-start-auto {\n  grid-column-start: auto;\n}\n.col-end-1 {\n  grid-column-end: 1;\n}\n.col-end-2 {\n  grid-column-end: 2;\n}\n.col-end-3 {\n  grid-column-end: 3;\n}\n.col-end-4 {\n  grid-column-end: 4;\n}\n.col-end-5 {\n  grid-column-end: 5;\n}\n.col-end-6 {\n  grid-column-end: 6;\n}\n.col-end-7 {\n  grid-column-end: 7;\n}\n.col-end-8 {\n  grid-column-end: 8;\n}\n.col-end-9 {\n  grid-column-end: 9;\n}\n.col-end-10 {\n  grid-column-end: 10;\n}\n.col-end-11 {\n  grid-column-end: 11;\n}\n.col-end-12 {\n  grid-column-end: 12;\n}\n.col-end-13 {\n  grid-column-end: 13;\n}\n.col-end-auto {\n  grid-column-end: auto;\n}\n.grid-rows-1 {\n  grid-template-rows: repeat(1, minmax(0, 1fr));\n}\n.grid-rows-2 {\n  grid-template-rows: repeat(2, minmax(0, 1fr));\n}\n.grid-rows-3 {\n  grid-template-rows: repeat(3, minmax(0, 1fr));\n}\n.grid-rows-4 {\n  grid-template-rows: repeat(4, minmax(0, 1fr));\n}\n.grid-rows-5 {\n  grid-template-rows: repeat(5, minmax(0, 1fr));\n}\n.grid-rows-6 {\n  grid-template-rows: repeat(6, minmax(0, 1fr));\n}\n.grid-rows-none {\n  grid-template-rows: none;\n}\n.auto-rows-auto {\n  grid-auto-rows: auto;\n}\n.auto-rows-min {\n  grid-auto-rows: min-content;\n}\n.auto-rows-max {\n  grid-auto-rows: max-content;\n}\n.auto-rows-fr {\n  grid-auto-rows: minmax(0, 1fr);\n}\n.row-auto {\n  grid-row: auto;\n}\n.row-span-1 {\n  grid-row: span 1 / span 1;\n}\n.row-span-2 {\n  grid-row: span 2 / span 2;\n}\n.row-span-3 {\n  grid-row: span 3 / span 3;\n}\n.row-span-4 {\n  grid-row: span 4 / span 4;\n}\n.row-span-5 {\n  grid-row: span 5 / span 5;\n}\n.row-span-6 {\n  grid-row: span 6 / span 6;\n}\n.row-span-full {\n  grid-row: 1 / -1;\n}\n.row-start-1 {\n  grid-row-start: 1;\n}\n.row-start-2 {\n  grid-row-start: 2;\n}\n.row-start-3 {\n  grid-row-start: 3;\n}\n.row-start-4 {\n  grid-row-start: 4;\n}\n.row-start-5 {\n  grid-row-start: 5;\n}\n.row-start-6 {\n  grid-row-start: 6;\n}\n.row-start-7 {\n  grid-row-start: 7;\n}\n.row-start-auto {\n  grid-row-start: auto;\n}\n.row-end-1 {\n  grid-row-end: 1;\n}\n.row-end-2 {\n  grid-row-end: 2;\n}\n.row-end-3 {\n  grid-row-end: 3;\n}\n.row-end-4 {\n  grid-row-end: 4;\n}\n.row-end-5 {\n  grid-row-end: 5;\n}\n.row-end-6 {\n  grid-row-end: 6;\n}\n.row-end-7 {\n  grid-row-end: 7;\n}\n.row-end-auto {\n  grid-row-end: auto;\n}\n.transform {\n  --transform-translate-x: 0;\n  --transform-translate-y: 0;\n  --transform-rotate: 0;\n  --transform-skew-x: 0;\n  --transform-skew-y: 0;\n  --transform-scale-x: 1;\n  --transform-scale-y: 1;\n  transform: translateX(var(--transform-translate-x)) translateY(var(--transform-translate-y)) rotate(var(--transform-rotate)) skewX(var(--transform-skew-x)) skewY(var(--transform-skew-y)) scaleX(var(--transform-scale-x)) scaleY(var(--transform-scale-y));\n}\n.transform-none {\n  transform: none;\n}\n.origin-center {\n  transform-origin: center;\n}\n.origin-top {\n  transform-origin: top;\n}\n.origin-top-right {\n  transform-origin: top right;\n}\n.origin-right {\n  transform-origin: right;\n}\n.origin-bottom-right {\n  transform-origin: bottom right;\n}\n.origin-bottom {\n  transform-origin: bottom;\n}\n.origin-bottom-left {\n  transform-origin: bottom left;\n}\n.origin-left {\n  transform-origin: left;\n}\n.origin-top-left {\n  transform-origin: top left;\n}\n.scale-0 {\n  --transform-scale-x: 0;\n  --transform-scale-y: 0;\n}\n.scale-50 {\n  --transform-scale-x: .5;\n  --transform-scale-y: .5;\n}\n.scale-75 {\n  --transform-scale-x: .75;\n  --transform-scale-y: .75;\n}\n.scale-90 {\n  --transform-scale-x: .9;\n  --transform-scale-y: .9;\n}\n.scale-95 {\n  --transform-scale-x: .95;\n  --transform-scale-y: .95;\n}\n.scale-100 {\n  --transform-scale-x: 1;\n  --transform-scale-y: 1;\n}\n.scale-105 {\n  --transform-scale-x: 1.05;\n  --transform-scale-y: 1.05;\n}\n.scale-110 {\n  --transform-scale-x: 1.1;\n  --transform-scale-y: 1.1;\n}\n.scale-125 {\n  --transform-scale-x: 1.25;\n  --transform-scale-y: 1.25;\n}\n.scale-150 {\n  --transform-scale-x: 1.5;\n  --transform-scale-y: 1.5;\n}\n.scale-x-0 {\n  --transform-scale-x: 0;\n}\n.scale-x-50 {\n  --transform-scale-x: .5;\n}\n.scale-x-75 {\n  --transform-scale-x: .75;\n}\n.scale-x-90 {\n  --transform-scale-x: .9;\n}\n.scale-x-95 {\n  --transform-scale-x: .95;\n}\n.scale-x-100 {\n  --transform-scale-x: 1;\n}\n.scale-x-105 {\n  --transform-scale-x: 1.05;\n}\n.scale-x-110 {\n  --transform-scale-x: 1.1;\n}\n.scale-x-125 {\n  --transform-scale-x: 1.25;\n}\n.scale-x-150 {\n  --transform-scale-x: 1.5;\n}\n.scale-y-0 {\n  --transform-scale-y: 0;\n}\n.scale-y-50 {\n  --transform-scale-y: .5;\n}\n.scale-y-75 {\n  --transform-scale-y: .75;\n}\n.scale-y-90 {\n  --transform-scale-y: .9;\n}\n.scale-y-95 {\n  --transform-scale-y: .95;\n}\n.scale-y-100 {\n  --transform-scale-y: 1;\n}\n.scale-y-105 {\n  --transform-scale-y: 1.05;\n}\n.scale-y-110 {\n  --transform-scale-y: 1.1;\n}\n.scale-y-125 {\n  --transform-scale-y: 1.25;\n}\n.scale-y-150 {\n  --transform-scale-y: 1.5;\n}\n.hover\\:scale-0:hover {\n  --transform-scale-x: 0;\n  --transform-scale-y: 0;\n}\n.hover\\:scale-50:hover {\n  --transform-scale-x: .5;\n  --transform-scale-y: .5;\n}\n.hover\\:scale-75:hover {\n  --transform-scale-x: .75;\n  --transform-scale-y: .75;\n}\n.hover\\:scale-90:hover {\n  --transform-scale-x: .9;\n  --transform-scale-y: .9;\n}\n.hover\\:scale-95:hover {\n  --transform-scale-x: .95;\n  --transform-scale-y: .95;\n}\n.hover\\:scale-100:hover {\n  --transform-scale-x: 1;\n  --transform-scale-y: 1;\n}\n.hover\\:scale-105:hover {\n  --transform-scale-x: 1.05;\n  --transform-scale-y: 1.05;\n}\n.hover\\:scale-110:hover {\n  --transform-scale-x: 1.1;\n  --transform-scale-y: 1.1;\n}\n.hover\\:scale-125:hover {\n  --transform-scale-x: 1.25;\n  --transform-scale-y: 1.25;\n}\n.hover\\:scale-150:hover {\n  --transform-scale-x: 1.5;\n  --transform-scale-y: 1.5;\n}\n.hover\\:scale-x-0:hover {\n  --transform-scale-x: 0;\n}\n.hover\\:scale-x-50:hover {\n  --transform-scale-x: .5;\n}\n.hover\\:scale-x-75:hover {\n  --transform-scale-x: .75;\n}\n.hover\\:scale-x-90:hover {\n  --transform-scale-x: .9;\n}\n.hover\\:scale-x-95:hover {\n  --transform-scale-x: .95;\n}\n.hover\\:scale-x-100:hover {\n  --transform-scale-x: 1;\n}\n.hover\\:scale-x-105:hover {\n  --transform-scale-x: 1.05;\n}\n.hover\\:scale-x-110:hover {\n  --transform-scale-x: 1.1;\n}\n.hover\\:scale-x-125:hover {\n  --transform-scale-x: 1.25;\n}\n.hover\\:scale-x-150:hover {\n  --transform-scale-x: 1.5;\n}\n.hover\\:scale-y-0:hover {\n  --transform-scale-y: 0;\n}\n.hover\\:scale-y-50:hover {\n  --transform-scale-y: .5;\n}\n.hover\\:scale-y-75:hover {\n  --transform-scale-y: .75;\n}\n.hover\\:scale-y-90:hover {\n  --transform-scale-y: .9;\n}\n.hover\\:scale-y-95:hover {\n  --transform-scale-y: .95;\n}\n.hover\\:scale-y-100:hover {\n  --transform-scale-y: 1;\n}\n.hover\\:scale-y-105:hover {\n  --transform-scale-y: 1.05;\n}\n.hover\\:scale-y-110:hover {\n  --transform-scale-y: 1.1;\n}\n.hover\\:scale-y-125:hover {\n  --transform-scale-y: 1.25;\n}\n.hover\\:scale-y-150:hover {\n  --transform-scale-y: 1.5;\n}\n.focus\\:scale-0:focus {\n  --transform-scale-x: 0;\n  --transform-scale-y: 0;\n}\n.focus\\:scale-50:focus {\n  --transform-scale-x: .5;\n  --transform-scale-y: .5;\n}\n.focus\\:scale-75:focus {\n  --transform-scale-x: .75;\n  --transform-scale-y: .75;\n}\n.focus\\:scale-90:focus {\n  --transform-scale-x: .9;\n  --transform-scale-y: .9;\n}\n.focus\\:scale-95:focus {\n  --transform-scale-x: .95;\n  --transform-scale-y: .95;\n}\n.focus\\:scale-100:focus {\n  --transform-scale-x: 1;\n  --transform-scale-y: 1;\n}\n.focus\\:scale-105:focus {\n  --transform-scale-x: 1.05;\n  --transform-scale-y: 1.05;\n}\n.focus\\:scale-110:focus {\n  --transform-scale-x: 1.1;\n  --transform-scale-y: 1.1;\n}\n.focus\\:scale-125:focus {\n  --transform-scale-x: 1.25;\n  --transform-scale-y: 1.25;\n}\n.focus\\:scale-150:focus {\n  --transform-scale-x: 1.5;\n  --transform-scale-y: 1.5;\n}\n.focus\\:scale-x-0:focus {\n  --transform-scale-x: 0;\n}\n.focus\\:scale-x-50:focus {\n  --transform-scale-x: .5;\n}\n.focus\\:scale-x-75:focus {\n  --transform-scale-x: .75;\n}\n.focus\\:scale-x-90:focus {\n  --transform-scale-x: .9;\n}\n.focus\\:scale-x-95:focus {\n  --transform-scale-x: .95;\n}\n.focus\\:scale-x-100:focus {\n  --transform-scale-x: 1;\n}\n.focus\\:scale-x-105:focus {\n  --transform-scale-x: 1.05;\n}\n.focus\\:scale-x-110:focus {\n  --transform-scale-x: 1.1;\n}\n.focus\\:scale-x-125:focus {\n  --transform-scale-x: 1.25;\n}\n.focus\\:scale-x-150:focus {\n  --transform-scale-x: 1.5;\n}\n.focus\\:scale-y-0:focus {\n  --transform-scale-y: 0;\n}\n.focus\\:scale-y-50:focus {\n  --transform-scale-y: .5;\n}\n.focus\\:scale-y-75:focus {\n  --transform-scale-y: .75;\n}\n.focus\\:scale-y-90:focus {\n  --transform-scale-y: .9;\n}\n.focus\\:scale-y-95:focus {\n  --transform-scale-y: .95;\n}\n.focus\\:scale-y-100:focus {\n  --transform-scale-y: 1;\n}\n.focus\\:scale-y-105:focus {\n  --transform-scale-y: 1.05;\n}\n.focus\\:scale-y-110:focus {\n  --transform-scale-y: 1.1;\n}\n.focus\\:scale-y-125:focus {\n  --transform-scale-y: 1.25;\n}\n.focus\\:scale-y-150:focus {\n  --transform-scale-y: 1.5;\n}\n.rotate-0 {\n  --transform-rotate: 0;\n}\n.rotate-1 {\n  --transform-rotate: 1deg;\n}\n.rotate-2 {\n  --transform-rotate: 2deg;\n}\n.rotate-3 {\n  --transform-rotate: 3deg;\n}\n.rotate-6 {\n  --transform-rotate: 6deg;\n}\n.rotate-12 {\n  --transform-rotate: 12deg;\n}\n.rotate-45 {\n  --transform-rotate: 45deg;\n}\n.rotate-90 {\n  --transform-rotate: 90deg;\n}\n.rotate-180 {\n  --transform-rotate: 180deg;\n}\n.-rotate-180 {\n  --transform-rotate: -180deg;\n}\n.-rotate-90 {\n  --transform-rotate: -90deg;\n}\n.-rotate-45 {\n  --transform-rotate: -45deg;\n}\n.-rotate-12 {\n  --transform-rotate: -12deg;\n}\n.-rotate-6 {\n  --transform-rotate: -6deg;\n}\n.-rotate-3 {\n  --transform-rotate: -3deg;\n}\n.-rotate-2 {\n  --transform-rotate: -2deg;\n}\n.-rotate-1 {\n  --transform-rotate: -1deg;\n}\n.hover\\:rotate-0:hover {\n  --transform-rotate: 0;\n}\n.hover\\:rotate-1:hover {\n  --transform-rotate: 1deg;\n}\n.hover\\:rotate-2:hover {\n  --transform-rotate: 2deg;\n}\n.hover\\:rotate-3:hover {\n  --transform-rotate: 3deg;\n}\n.hover\\:rotate-6:hover {\n  --transform-rotate: 6deg;\n}\n.hover\\:rotate-12:hover {\n  --transform-rotate: 12deg;\n}\n.hover\\:rotate-45:hover {\n  --transform-rotate: 45deg;\n}\n.hover\\:rotate-90:hover {\n  --transform-rotate: 90deg;\n}\n.hover\\:rotate-180:hover {\n  --transform-rotate: 180deg;\n}\n.hover\\:-rotate-180:hover {\n  --transform-rotate: -180deg;\n}\n.hover\\:-rotate-90:hover {\n  --transform-rotate: -90deg;\n}\n.hover\\:-rotate-45:hover {\n  --transform-rotate: -45deg;\n}\n.hover\\:-rotate-12:hover {\n  --transform-rotate: -12deg;\n}\n.hover\\:-rotate-6:hover {\n  --transform-rotate: -6deg;\n}\n.hover\\:-rotate-3:hover {\n  --transform-rotate: -3deg;\n}\n.hover\\:-rotate-2:hover {\n  --transform-rotate: -2deg;\n}\n.hover\\:-rotate-1:hover {\n  --transform-rotate: -1deg;\n}\n.focus\\:rotate-0:focus {\n  --transform-rotate: 0;\n}\n.focus\\:rotate-1:focus {\n  --transform-rotate: 1deg;\n}\n.focus\\:rotate-2:focus {\n  --transform-rotate: 2deg;\n}\n.focus\\:rotate-3:focus {\n  --transform-rotate: 3deg;\n}\n.focus\\:rotate-6:focus {\n  --transform-rotate: 6deg;\n}\n.focus\\:rotate-12:focus {\n  --transform-rotate: 12deg;\n}\n.focus\\:rotate-45:focus {\n  --transform-rotate: 45deg;\n}\n.focus\\:rotate-90:focus {\n  --transform-rotate: 90deg;\n}\n.focus\\:rotate-180:focus {\n  --transform-rotate: 180deg;\n}\n.focus\\:-rotate-180:focus {\n  --transform-rotate: -180deg;\n}\n.focus\\:-rotate-90:focus {\n  --transform-rotate: -90deg;\n}\n.focus\\:-rotate-45:focus {\n  --transform-rotate: -45deg;\n}\n.focus\\:-rotate-12:focus {\n  --transform-rotate: -12deg;\n}\n.focus\\:-rotate-6:focus {\n  --transform-rotate: -6deg;\n}\n.focus\\:-rotate-3:focus {\n  --transform-rotate: -3deg;\n}\n.focus\\:-rotate-2:focus {\n  --transform-rotate: -2deg;\n}\n.focus\\:-rotate-1:focus {\n  --transform-rotate: -1deg;\n}\n.translate-x-0 {\n  --transform-translate-x: 0;\n}\n.translate-x-1 {\n  --transform-translate-x: 0.25rem;\n}\n.translate-x-2 {\n  --transform-translate-x: 0.5rem;\n}\n.translate-x-3 {\n  --transform-translate-x: 0.75rem;\n}\n.translate-x-4 {\n  --transform-translate-x: 1rem;\n}\n.translate-x-5 {\n  --transform-translate-x: 1.25rem;\n}\n.translate-x-6 {\n  --transform-translate-x: 1.5rem;\n}\n.translate-x-7 {\n  --transform-translate-x: 1.75rem;\n}\n.translate-x-8 {\n  --transform-translate-x: 2rem;\n}\n.translate-x-9 {\n  --transform-translate-x: 2.25rem;\n}\n.translate-x-10 {\n  --transform-translate-x: 2.5rem;\n}\n.translate-x-11 {\n  --transform-translate-x: 2.75rem;\n}\n.translate-x-12 {\n  --transform-translate-x: 3rem;\n}\n.translate-x-13 {\n  --transform-translate-x: 3.25rem;\n}\n.translate-x-14 {\n  --transform-translate-x: 3.5rem;\n}\n.translate-x-15 {\n  --transform-translate-x: 3.75rem;\n}\n.translate-x-16 {\n  --transform-translate-x: 4rem;\n}\n.translate-x-20 {\n  --transform-translate-x: 5rem;\n}\n.translate-x-24 {\n  --transform-translate-x: 6rem;\n}\n.translate-x-28 {\n  --transform-translate-x: 7rem;\n}\n.translate-x-32 {\n  --transform-translate-x: 8rem;\n}\n.translate-x-36 {\n  --transform-translate-x: 9rem;\n}\n.translate-x-40 {\n  --transform-translate-x: 10rem;\n}\n.translate-x-44 {\n  --transform-translate-x: 11rem;\n}\n.translate-x-48 {\n  --transform-translate-x: 12rem;\n}\n.translate-x-52 {\n  --transform-translate-x: 13rem;\n}\n.translate-x-56 {\n  --transform-translate-x: 14rem;\n}\n.translate-x-60 {\n  --transform-translate-x: 15rem;\n}\n.translate-x-64 {\n  --transform-translate-x: 16rem;\n}\n.translate-x-72 {\n  --transform-translate-x: 18rem;\n}\n.translate-x-80 {\n  --transform-translate-x: 20rem;\n}\n.translate-x-96 {\n  --transform-translate-x: 24rem;\n}\n.translate-x-px {\n  --transform-translate-x: 1px;\n}\n.translate-x-0\\.5 {\n  --transform-translate-x: 0.125rem;\n}\n.translate-x-1\\.5 {\n  --transform-translate-x: 0.375rem;\n}\n.translate-x-2\\.5 {\n  --transform-translate-x: 0.625rem;\n}\n.translate-x-3\\.5 {\n  --transform-translate-x: 0.875rem;\n}\n.translate-x-1\\/2 {\n  --transform-translate-x: 50%;\n}\n.translate-x-1\\/3 {\n  --transform-translate-x: 33.333333%;\n}\n.translate-x-2\\/3 {\n  --transform-translate-x: 66.666667%;\n}\n.translate-x-1\\/4 {\n  --transform-translate-x: 25%;\n}\n.translate-x-2\\/4 {\n  --transform-translate-x: 50%;\n}\n.translate-x-3\\/4 {\n  --transform-translate-x: 75%;\n}\n.translate-x-1\\/5 {\n  --transform-translate-x: 20%;\n}\n.translate-x-2\\/5 {\n  --transform-translate-x: 40%;\n}\n.translate-x-3\\/5 {\n  --transform-translate-x: 60%;\n}\n.translate-x-4\\/5 {\n  --transform-translate-x: 80%;\n}\n.translate-x-1\\/6 {\n  --transform-translate-x: 16.666667%;\n}\n.translate-x-2\\/6 {\n  --transform-translate-x: 33.333333%;\n}\n.translate-x-3\\/6 {\n  --transform-translate-x: 50%;\n}\n.translate-x-4\\/6 {\n  --transform-translate-x: 66.666667%;\n}\n.translate-x-5\\/6 {\n  --transform-translate-x: 83.333333%;\n}\n.translate-x-1\\/12 {\n  --transform-translate-x: 8.333333%;\n}\n.translate-x-2\\/12 {\n  --transform-translate-x: 16.666667%;\n}\n.translate-x-3\\/12 {\n  --transform-translate-x: 25%;\n}\n.translate-x-4\\/12 {\n  --transform-translate-x: 33.333333%;\n}\n.translate-x-5\\/12 {\n  --transform-translate-x: 41.666667%;\n}\n.translate-x-6\\/12 {\n  --transform-translate-x: 50%;\n}\n.translate-x-7\\/12 {\n  --transform-translate-x: 58.333333%;\n}\n.translate-x-8\\/12 {\n  --transform-translate-x: 66.666667%;\n}\n.translate-x-9\\/12 {\n  --transform-translate-x: 75%;\n}\n.translate-x-10\\/12 {\n  --transform-translate-x: 83.333333%;\n}\n.translate-x-11\\/12 {\n  --transform-translate-x: 91.666667%;\n}\n.translate-x-full {\n  --transform-translate-x: 100%;\n}\n.-translate-x-1 {\n  --transform-translate-x: -0.25rem;\n}\n.-translate-x-2 {\n  --transform-translate-x: -0.5rem;\n}\n.-translate-x-3 {\n  --transform-translate-x: -0.75rem;\n}\n.-translate-x-4 {\n  --transform-translate-x: -1rem;\n}\n.-translate-x-5 {\n  --transform-translate-x: -1.25rem;\n}\n.-translate-x-6 {\n  --transform-translate-x: -1.5rem;\n}\n.-translate-x-7 {\n  --transform-translate-x: -1.75rem;\n}\n.-translate-x-8 {\n  --transform-translate-x: -2rem;\n}\n.-translate-x-9 {\n  --transform-translate-x: -2.25rem;\n}\n.-translate-x-10 {\n  --transform-translate-x: -2.5rem;\n}\n.-translate-x-11 {\n  --transform-translate-x: -2.75rem;\n}\n.-translate-x-12 {\n  --transform-translate-x: -3rem;\n}\n.-translate-x-13 {\n  --transform-translate-x: -3.25rem;\n}\n.-translate-x-14 {\n  --transform-translate-x: -3.5rem;\n}\n.-translate-x-15 {\n  --transform-translate-x: -3.75rem;\n}\n.-translate-x-16 {\n  --transform-translate-x: -4rem;\n}\n.-translate-x-20 {\n  --transform-translate-x: -5rem;\n}\n.-translate-x-24 {\n  --transform-translate-x: -6rem;\n}\n.-translate-x-28 {\n  --transform-translate-x: -7rem;\n}\n.-translate-x-32 {\n  --transform-translate-x: -8rem;\n}\n.-translate-x-36 {\n  --transform-translate-x: -9rem;\n}\n.-translate-x-40 {\n  --transform-translate-x: -10rem;\n}\n.-translate-x-44 {\n  --transform-translate-x: -11rem;\n}\n.-translate-x-48 {\n  --transform-translate-x: -12rem;\n}\n.-translate-x-52 {\n  --transform-translate-x: -13rem;\n}\n.-translate-x-56 {\n  --transform-translate-x: -14rem;\n}\n.-translate-x-60 {\n  --transform-translate-x: -15rem;\n}\n.-translate-x-64 {\n  --transform-translate-x: -16rem;\n}\n.-translate-x-72 {\n  --transform-translate-x: -18rem;\n}\n.-translate-x-80 {\n  --transform-translate-x: -20rem;\n}\n.-translate-x-96 {\n  --transform-translate-x: -24rem;\n}\n.-translate-x-px {\n  --transform-translate-x: -1px;\n}\n.-translate-x-0\\.5 {\n  --transform-translate-x: -0.125rem;\n}\n.-translate-x-1\\.5 {\n  --transform-translate-x: -0.375rem;\n}\n.-translate-x-2\\.5 {\n  --transform-translate-x: -0.625rem;\n}\n.-translate-x-3\\.5 {\n  --transform-translate-x: -0.875rem;\n}\n.-translate-x-1\\/2 {\n  --transform-translate-x: -50%;\n}\n.-translate-x-1\\/3 {\n  --transform-translate-x: -33.33333%;\n}\n.-translate-x-2\\/3 {\n  --transform-translate-x: -66.66667%;\n}\n.-translate-x-1\\/4 {\n  --transform-translate-x: -25%;\n}\n.-translate-x-2\\/4 {\n  --transform-translate-x: -50%;\n}\n.-translate-x-3\\/4 {\n  --transform-translate-x: -75%;\n}\n.-translate-x-1\\/5 {\n  --transform-translate-x: -20%;\n}\n.-translate-x-2\\/5 {\n  --transform-translate-x: -40%;\n}\n.-translate-x-3\\/5 {\n  --transform-translate-x: -60%;\n}\n.-translate-x-4\\/5 {\n  --transform-translate-x: -80%;\n}\n.-translate-x-1\\/6 {\n  --transform-translate-x: -16.66667%;\n}\n.-translate-x-2\\/6 {\n  --transform-translate-x: -33.33333%;\n}\n.-translate-x-3\\/6 {\n  --transform-translate-x: -50%;\n}\n.-translate-x-4\\/6 {\n  --transform-translate-x: -66.66667%;\n}\n.-translate-x-5\\/6 {\n  --transform-translate-x: -83.33333%;\n}\n.-translate-x-1\\/12 {\n  --transform-translate-x: -8.33333%;\n}\n.-translate-x-2\\/12 {\n  --transform-translate-x: -16.66667%;\n}\n.-translate-x-3\\/12 {\n  --transform-translate-x: -25%;\n}\n.-translate-x-4\\/12 {\n  --transform-translate-x: -33.33333%;\n}\n.-translate-x-5\\/12 {\n  --transform-translate-x: -41.66667%;\n}\n.-translate-x-6\\/12 {\n  --transform-translate-x: -50%;\n}\n.-translate-x-7\\/12 {\n  --transform-translate-x: -58.33333%;\n}\n.-translate-x-8\\/12 {\n  --transform-translate-x: -66.66667%;\n}\n.-translate-x-9\\/12 {\n  --transform-translate-x: -75%;\n}\n.-translate-x-10\\/12 {\n  --transform-translate-x: -83.33333%;\n}\n.-translate-x-11\\/12 {\n  --transform-translate-x: -91.66667%;\n}\n.-translate-x-full {\n  --transform-translate-x: -100%;\n}\n.translate-y-0 {\n  --transform-translate-y: 0;\n}\n.translate-y-1 {\n  --transform-translate-y: 0.25rem;\n}\n.translate-y-2 {\n  --transform-translate-y: 0.5rem;\n}\n.translate-y-3 {\n  --transform-translate-y: 0.75rem;\n}\n.translate-y-4 {\n  --transform-translate-y: 1rem;\n}\n.translate-y-5 {\n  --transform-translate-y: 1.25rem;\n}\n.translate-y-6 {\n  --transform-translate-y: 1.5rem;\n}\n.translate-y-7 {\n  --transform-translate-y: 1.75rem;\n}\n.translate-y-8 {\n  --transform-translate-y: 2rem;\n}\n.translate-y-9 {\n  --transform-translate-y: 2.25rem;\n}\n.translate-y-10 {\n  --transform-translate-y: 2.5rem;\n}\n.translate-y-11 {\n  --transform-translate-y: 2.75rem;\n}\n.translate-y-12 {\n  --transform-translate-y: 3rem;\n}\n.translate-y-13 {\n  --transform-translate-y: 3.25rem;\n}\n.translate-y-14 {\n  --transform-translate-y: 3.5rem;\n}\n.translate-y-15 {\n  --transform-translate-y: 3.75rem;\n}\n.translate-y-16 {\n  --transform-translate-y: 4rem;\n}\n.translate-y-20 {\n  --transform-translate-y: 5rem;\n}\n.translate-y-24 {\n  --transform-translate-y: 6rem;\n}\n.translate-y-28 {\n  --transform-translate-y: 7rem;\n}\n.translate-y-32 {\n  --transform-translate-y: 8rem;\n}\n.translate-y-36 {\n  --transform-translate-y: 9rem;\n}\n.translate-y-40 {\n  --transform-translate-y: 10rem;\n}\n.translate-y-44 {\n  --transform-translate-y: 11rem;\n}\n.translate-y-48 {\n  --transform-translate-y: 12rem;\n}\n.translate-y-52 {\n  --transform-translate-y: 13rem;\n}\n.translate-y-56 {\n  --transform-translate-y: 14rem;\n}\n.translate-y-60 {\n  --transform-translate-y: 15rem;\n}\n.translate-y-64 {\n  --transform-translate-y: 16rem;\n}\n.translate-y-72 {\n  --transform-translate-y: 18rem;\n}\n.translate-y-80 {\n  --transform-translate-y: 20rem;\n}\n.translate-y-96 {\n  --transform-translate-y: 24rem;\n}\n.translate-y-px {\n  --transform-translate-y: 1px;\n}\n.translate-y-0\\.5 {\n  --transform-translate-y: 0.125rem;\n}\n.translate-y-1\\.5 {\n  --transform-translate-y: 0.375rem;\n}\n.translate-y-2\\.5 {\n  --transform-translate-y: 0.625rem;\n}\n.translate-y-3\\.5 {\n  --transform-translate-y: 0.875rem;\n}\n.translate-y-1\\/2 {\n  --transform-translate-y: 50%;\n}\n.translate-y-1\\/3 {\n  --transform-translate-y: 33.333333%;\n}\n.translate-y-2\\/3 {\n  --transform-translate-y: 66.666667%;\n}\n.translate-y-1\\/4 {\n  --transform-translate-y: 25%;\n}\n.translate-y-2\\/4 {\n  --transform-translate-y: 50%;\n}\n.translate-y-3\\/4 {\n  --transform-translate-y: 75%;\n}\n.translate-y-1\\/5 {\n  --transform-translate-y: 20%;\n}\n.translate-y-2\\/5 {\n  --transform-translate-y: 40%;\n}\n.translate-y-3\\/5 {\n  --transform-translate-y: 60%;\n}\n.translate-y-4\\/5 {\n  --transform-translate-y: 80%;\n}\n.translate-y-1\\/6 {\n  --transform-translate-y: 16.666667%;\n}\n.translate-y-2\\/6 {\n  --transform-translate-y: 33.333333%;\n}\n.translate-y-3\\/6 {\n  --transform-translate-y: 50%;\n}\n.translate-y-4\\/6 {\n  --transform-translate-y: 66.666667%;\n}\n.translate-y-5\\/6 {\n  --transform-translate-y: 83.333333%;\n}\n.translate-y-1\\/12 {\n  --transform-translate-y: 8.333333%;\n}\n.translate-y-2\\/12 {\n  --transform-translate-y: 16.666667%;\n}\n.translate-y-3\\/12 {\n  --transform-translate-y: 25%;\n}\n.translate-y-4\\/12 {\n  --transform-translate-y: 33.333333%;\n}\n.translate-y-5\\/12 {\n  --transform-translate-y: 41.666667%;\n}\n.translate-y-6\\/12 {\n  --transform-translate-y: 50%;\n}\n.translate-y-7\\/12 {\n  --transform-translate-y: 58.333333%;\n}\n.translate-y-8\\/12 {\n  --transform-translate-y: 66.666667%;\n}\n.translate-y-9\\/12 {\n  --transform-translate-y: 75%;\n}\n.translate-y-10\\/12 {\n  --transform-translate-y: 83.333333%;\n}\n.translate-y-11\\/12 {\n  --transform-translate-y: 91.666667%;\n}\n.translate-y-full {\n  --transform-translate-y: 100%;\n}\n.-translate-y-1 {\n  --transform-translate-y: -0.25rem;\n}\n.-translate-y-2 {\n  --transform-translate-y: -0.5rem;\n}\n.-translate-y-3 {\n  --transform-translate-y: -0.75rem;\n}\n.-translate-y-4 {\n  --transform-translate-y: -1rem;\n}\n.-translate-y-5 {\n  --transform-translate-y: -1.25rem;\n}\n.-translate-y-6 {\n  --transform-translate-y: -1.5rem;\n}\n.-translate-y-7 {\n  --transform-translate-y: -1.75rem;\n}\n.-translate-y-8 {\n  --transform-translate-y: -2rem;\n}\n.-translate-y-9 {\n  --transform-translate-y: -2.25rem;\n}\n.-translate-y-10 {\n  --transform-translate-y: -2.5rem;\n}\n.-translate-y-11 {\n  --transform-translate-y: -2.75rem;\n}\n.-translate-y-12 {\n  --transform-translate-y: -3rem;\n}\n.-translate-y-13 {\n  --transform-translate-y: -3.25rem;\n}\n.-translate-y-14 {\n  --transform-translate-y: -3.5rem;\n}\n.-translate-y-15 {\n  --transform-translate-y: -3.75rem;\n}\n.-translate-y-16 {\n  --transform-translate-y: -4rem;\n}\n.-translate-y-20 {\n  --transform-translate-y: -5rem;\n}\n.-translate-y-24 {\n  --transform-translate-y: -6rem;\n}\n.-translate-y-28 {\n  --transform-translate-y: -7rem;\n}\n.-translate-y-32 {\n  --transform-translate-y: -8rem;\n}\n.-translate-y-36 {\n  --transform-translate-y: -9rem;\n}\n.-translate-y-40 {\n  --transform-translate-y: -10rem;\n}\n.-translate-y-44 {\n  --transform-translate-y: -11rem;\n}\n.-translate-y-48 {\n  --transform-translate-y: -12rem;\n}\n.-translate-y-52 {\n  --transform-translate-y: -13rem;\n}\n.-translate-y-56 {\n  --transform-translate-y: -14rem;\n}\n.-translate-y-60 {\n  --transform-translate-y: -15rem;\n}\n.-translate-y-64 {\n  --transform-translate-y: -16rem;\n}\n.-translate-y-72 {\n  --transform-translate-y: -18rem;\n}\n.-translate-y-80 {\n  --transform-translate-y: -20rem;\n}\n.-translate-y-96 {\n  --transform-translate-y: -24rem;\n}\n.-translate-y-px {\n  --transform-translate-y: -1px;\n}\n.-translate-y-0\\.5 {\n  --transform-translate-y: -0.125rem;\n}\n.-translate-y-1\\.5 {\n  --transform-translate-y: -0.375rem;\n}\n.-translate-y-2\\.5 {\n  --transform-translate-y: -0.625rem;\n}\n.-translate-y-3\\.5 {\n  --transform-translate-y: -0.875rem;\n}\n.-translate-y-1\\/2 {\n  --transform-translate-y: -50%;\n}\n.-translate-y-1\\/3 {\n  --transform-translate-y: -33.33333%;\n}\n.-translate-y-2\\/3 {\n  --transform-translate-y: -66.66667%;\n}\n.-translate-y-1\\/4 {\n  --transform-translate-y: -25%;\n}\n.-translate-y-2\\/4 {\n  --transform-translate-y: -50%;\n}\n.-translate-y-3\\/4 {\n  --transform-translate-y: -75%;\n}\n.-translate-y-1\\/5 {\n  --transform-translate-y: -20%;\n}\n.-translate-y-2\\/5 {\n  --transform-translate-y: -40%;\n}\n.-translate-y-3\\/5 {\n  --transform-translate-y: -60%;\n}\n.-translate-y-4\\/5 {\n  --transform-translate-y: -80%;\n}\n.-translate-y-1\\/6 {\n  --transform-translate-y: -16.66667%;\n}\n.-translate-y-2\\/6 {\n  --transform-translate-y: -33.33333%;\n}\n.-translate-y-3\\/6 {\n  --transform-translate-y: -50%;\n}\n.-translate-y-4\\/6 {\n  --transform-translate-y: -66.66667%;\n}\n.-translate-y-5\\/6 {\n  --transform-translate-y: -83.33333%;\n}\n.-translate-y-1\\/12 {\n  --transform-translate-y: -8.33333%;\n}\n.-translate-y-2\\/12 {\n  --transform-translate-y: -16.66667%;\n}\n.-translate-y-3\\/12 {\n  --transform-translate-y: -25%;\n}\n.-translate-y-4\\/12 {\n  --transform-translate-y: -33.33333%;\n}\n.-translate-y-5\\/12 {\n  --transform-translate-y: -41.66667%;\n}\n.-translate-y-6\\/12 {\n  --transform-translate-y: -50%;\n}\n.-translate-y-7\\/12 {\n  --transform-translate-y: -58.33333%;\n}\n.-translate-y-8\\/12 {\n  --transform-translate-y: -66.66667%;\n}\n.-translate-y-9\\/12 {\n  --transform-translate-y: -75%;\n}\n.-translate-y-10\\/12 {\n  --transform-translate-y: -83.33333%;\n}\n.-translate-y-11\\/12 {\n  --transform-translate-y: -91.66667%;\n}\n.-translate-y-full {\n  --transform-translate-y: -100%;\n}\n.hover\\:translate-x-0:hover {\n  --transform-translate-x: 0;\n}\n.hover\\:translate-x-1:hover {\n  --transform-translate-x: 0.25rem;\n}\n.hover\\:translate-x-2:hover {\n  --transform-translate-x: 0.5rem;\n}\n.hover\\:translate-x-3:hover {\n  --transform-translate-x: 0.75rem;\n}\n.hover\\:translate-x-4:hover {\n  --transform-translate-x: 1rem;\n}\n.hover\\:translate-x-5:hover {\n  --transform-translate-x: 1.25rem;\n}\n.hover\\:translate-x-6:hover {\n  --transform-translate-x: 1.5rem;\n}\n.hover\\:translate-x-7:hover {\n  --transform-translate-x: 1.75rem;\n}\n.hover\\:translate-x-8:hover {\n  --transform-translate-x: 2rem;\n}\n.hover\\:translate-x-9:hover {\n  --transform-translate-x: 2.25rem;\n}\n.hover\\:translate-x-10:hover {\n  --transform-translate-x: 2.5rem;\n}\n.hover\\:translate-x-11:hover {\n  --transform-translate-x: 2.75rem;\n}\n.hover\\:translate-x-12:hover {\n  --transform-translate-x: 3rem;\n}\n.hover\\:translate-x-13:hover {\n  --transform-translate-x: 3.25rem;\n}\n.hover\\:translate-x-14:hover {\n  --transform-translate-x: 3.5rem;\n}\n.hover\\:translate-x-15:hover {\n  --transform-translate-x: 3.75rem;\n}\n.hover\\:translate-x-16:hover {\n  --transform-translate-x: 4rem;\n}\n.hover\\:translate-x-20:hover {\n  --transform-translate-x: 5rem;\n}\n.hover\\:translate-x-24:hover {\n  --transform-translate-x: 6rem;\n}\n.hover\\:translate-x-28:hover {\n  --transform-translate-x: 7rem;\n}\n.hover\\:translate-x-32:hover {\n  --transform-translate-x: 8rem;\n}\n.hover\\:translate-x-36:hover {\n  --transform-translate-x: 9rem;\n}\n.hover\\:translate-x-40:hover {\n  --transform-translate-x: 10rem;\n}\n.hover\\:translate-x-44:hover {\n  --transform-translate-x: 11rem;\n}\n.hover\\:translate-x-48:hover {\n  --transform-translate-x: 12rem;\n}\n.hover\\:translate-x-52:hover {\n  --transform-translate-x: 13rem;\n}\n.hover\\:translate-x-56:hover {\n  --transform-translate-x: 14rem;\n}\n.hover\\:translate-x-60:hover {\n  --transform-translate-x: 15rem;\n}\n.hover\\:translate-x-64:hover {\n  --transform-translate-x: 16rem;\n}\n.hover\\:translate-x-72:hover {\n  --transform-translate-x: 18rem;\n}\n.hover\\:translate-x-80:hover {\n  --transform-translate-x: 20rem;\n}\n.hover\\:translate-x-96:hover {\n  --transform-translate-x: 24rem;\n}\n.hover\\:translate-x-px:hover {\n  --transform-translate-x: 1px;\n}\n.hover\\:translate-x-0\\.5:hover {\n  --transform-translate-x: 0.125rem;\n}\n.hover\\:translate-x-1\\.5:hover {\n  --transform-translate-x: 0.375rem;\n}\n.hover\\:translate-x-2\\.5:hover {\n  --transform-translate-x: 0.625rem;\n}\n.hover\\:translate-x-3\\.5:hover {\n  --transform-translate-x: 0.875rem;\n}\n.hover\\:translate-x-1\\/2:hover {\n  --transform-translate-x: 50%;\n}\n.hover\\:translate-x-1\\/3:hover {\n  --transform-translate-x: 33.333333%;\n}\n.hover\\:translate-x-2\\/3:hover {\n  --transform-translate-x: 66.666667%;\n}\n.hover\\:translate-x-1\\/4:hover {\n  --transform-translate-x: 25%;\n}\n.hover\\:translate-x-2\\/4:hover {\n  --transform-translate-x: 50%;\n}\n.hover\\:translate-x-3\\/4:hover {\n  --transform-translate-x: 75%;\n}\n.hover\\:translate-x-1\\/5:hover {\n  --transform-translate-x: 20%;\n}\n.hover\\:translate-x-2\\/5:hover {\n  --transform-translate-x: 40%;\n}\n.hover\\:translate-x-3\\/5:hover {\n  --transform-translate-x: 60%;\n}\n.hover\\:translate-x-4\\/5:hover {\n  --transform-translate-x: 80%;\n}\n.hover\\:translate-x-1\\/6:hover {\n  --transform-translate-x: 16.666667%;\n}\n.hover\\:translate-x-2\\/6:hover {\n  --transform-translate-x: 33.333333%;\n}\n.hover\\:translate-x-3\\/6:hover {\n  --transform-translate-x: 50%;\n}\n.hover\\:translate-x-4\\/6:hover {\n  --transform-translate-x: 66.666667%;\n}\n.hover\\:translate-x-5\\/6:hover {\n  --transform-translate-x: 83.333333%;\n}\n.hover\\:translate-x-1\\/12:hover {\n  --transform-translate-x: 8.333333%;\n}\n.hover\\:translate-x-2\\/12:hover {\n  --transform-translate-x: 16.666667%;\n}\n.hover\\:translate-x-3\\/12:hover {\n  --transform-translate-x: 25%;\n}\n.hover\\:translate-x-4\\/12:hover {\n  --transform-translate-x: 33.333333%;\n}\n.hover\\:translate-x-5\\/12:hover {\n  --transform-translate-x: 41.666667%;\n}\n.hover\\:translate-x-6\\/12:hover {\n  --transform-translate-x: 50%;\n}\n.hover\\:translate-x-7\\/12:hover {\n  --transform-translate-x: 58.333333%;\n}\n.hover\\:translate-x-8\\/12:hover {\n  --transform-translate-x: 66.666667%;\n}\n.hover\\:translate-x-9\\/12:hover {\n  --transform-translate-x: 75%;\n}\n.hover\\:translate-x-10\\/12:hover {\n  --transform-translate-x: 83.333333%;\n}\n.hover\\:translate-x-11\\/12:hover {\n  --transform-translate-x: 91.666667%;\n}\n.hover\\:translate-x-full:hover {\n  --transform-translate-x: 100%;\n}\n.hover\\:-translate-x-1:hover {\n  --transform-translate-x: -0.25rem;\n}\n.hover\\:-translate-x-2:hover {\n  --transform-translate-x: -0.5rem;\n}\n.hover\\:-translate-x-3:hover {\n  --transform-translate-x: -0.75rem;\n}\n.hover\\:-translate-x-4:hover {\n  --transform-translate-x: -1rem;\n}\n.hover\\:-translate-x-5:hover {\n  --transform-translate-x: -1.25rem;\n}\n.hover\\:-translate-x-6:hover {\n  --transform-translate-x: -1.5rem;\n}\n.hover\\:-translate-x-7:hover {\n  --transform-translate-x: -1.75rem;\n}\n.hover\\:-translate-x-8:hover {\n  --transform-translate-x: -2rem;\n}\n.hover\\:-translate-x-9:hover {\n  --transform-translate-x: -2.25rem;\n}\n.hover\\:-translate-x-10:hover {\n  --transform-translate-x: -2.5rem;\n}\n.hover\\:-translate-x-11:hover {\n  --transform-translate-x: -2.75rem;\n}\n.hover\\:-translate-x-12:hover {\n  --transform-translate-x: -3rem;\n}\n.hover\\:-translate-x-13:hover {\n  --transform-translate-x: -3.25rem;\n}\n.hover\\:-translate-x-14:hover {\n  --transform-translate-x: -3.5rem;\n}\n.hover\\:-translate-x-15:hover {\n  --transform-translate-x: -3.75rem;\n}\n.hover\\:-translate-x-16:hover {\n  --transform-translate-x: -4rem;\n}\n.hover\\:-translate-x-20:hover {\n  --transform-translate-x: -5rem;\n}\n.hover\\:-translate-x-24:hover {\n  --transform-translate-x: -6rem;\n}\n.hover\\:-translate-x-28:hover {\n  --transform-translate-x: -7rem;\n}\n.hover\\:-translate-x-32:hover {\n  --transform-translate-x: -8rem;\n}\n.hover\\:-translate-x-36:hover {\n  --transform-translate-x: -9rem;\n}\n.hover\\:-translate-x-40:hover {\n  --transform-translate-x: -10rem;\n}\n.hover\\:-translate-x-44:hover {\n  --transform-translate-x: -11rem;\n}\n.hover\\:-translate-x-48:hover {\n  --transform-translate-x: -12rem;\n}\n.hover\\:-translate-x-52:hover {\n  --transform-translate-x: -13rem;\n}\n.hover\\:-translate-x-56:hover {\n  --transform-translate-x: -14rem;\n}\n.hover\\:-translate-x-60:hover {\n  --transform-translate-x: -15rem;\n}\n.hover\\:-translate-x-64:hover {\n  --transform-translate-x: -16rem;\n}\n.hover\\:-translate-x-72:hover {\n  --transform-translate-x: -18rem;\n}\n.hover\\:-translate-x-80:hover {\n  --transform-translate-x: -20rem;\n}\n.hover\\:-translate-x-96:hover {\n  --transform-translate-x: -24rem;\n}\n.hover\\:-translate-x-px:hover {\n  --transform-translate-x: -1px;\n}\n.hover\\:-translate-x-0\\.5:hover {\n  --transform-translate-x: -0.125rem;\n}\n.hover\\:-translate-x-1\\.5:hover {\n  --transform-translate-x: -0.375rem;\n}\n.hover\\:-translate-x-2\\.5:hover {\n  --transform-translate-x: -0.625rem;\n}\n.hover\\:-translate-x-3\\.5:hover {\n  --transform-translate-x: -0.875rem;\n}\n.hover\\:-translate-x-1\\/2:hover {\n  --transform-translate-x: -50%;\n}\n.hover\\:-translate-x-1\\/3:hover {\n  --transform-translate-x: -33.33333%;\n}\n.hover\\:-translate-x-2\\/3:hover {\n  --transform-translate-x: -66.66667%;\n}\n.hover\\:-translate-x-1\\/4:hover {\n  --transform-translate-x: -25%;\n}\n.hover\\:-translate-x-2\\/4:hover {\n  --transform-translate-x: -50%;\n}\n.hover\\:-translate-x-3\\/4:hover {\n  --transform-translate-x: -75%;\n}\n.hover\\:-translate-x-1\\/5:hover {\n  --transform-translate-x: -20%;\n}\n.hover\\:-translate-x-2\\/5:hover {\n  --transform-translate-x: -40%;\n}\n.hover\\:-translate-x-3\\/5:hover {\n  --transform-translate-x: -60%;\n}\n.hover\\:-translate-x-4\\/5:hover {\n  --transform-translate-x: -80%;\n}\n.hover\\:-translate-x-1\\/6:hover {\n  --transform-translate-x: -16.66667%;\n}\n.hover\\:-translate-x-2\\/6:hover {\n  --transform-translate-x: -33.33333%;\n}\n.hover\\:-translate-x-3\\/6:hover {\n  --transform-translate-x: -50%;\n}\n.hover\\:-translate-x-4\\/6:hover {\n  --transform-translate-x: -66.66667%;\n}\n.hover\\:-translate-x-5\\/6:hover {\n  --transform-translate-x: -83.33333%;\n}\n.hover\\:-translate-x-1\\/12:hover {\n  --transform-translate-x: -8.33333%;\n}\n.hover\\:-translate-x-2\\/12:hover {\n  --transform-translate-x: -16.66667%;\n}\n.hover\\:-translate-x-3\\/12:hover {\n  --transform-translate-x: -25%;\n}\n.hover\\:-translate-x-4\\/12:hover {\n  --transform-translate-x: -33.33333%;\n}\n.hover\\:-translate-x-5\\/12:hover {\n  --transform-translate-x: -41.66667%;\n}\n.hover\\:-translate-x-6\\/12:hover {\n  --transform-translate-x: -50%;\n}\n.hover\\:-translate-x-7\\/12:hover {\n  --transform-translate-x: -58.33333%;\n}\n.hover\\:-translate-x-8\\/12:hover {\n  --transform-translate-x: -66.66667%;\n}\n.hover\\:-translate-x-9\\/12:hover {\n  --transform-translate-x: -75%;\n}\n.hover\\:-translate-x-10\\/12:hover {\n  --transform-translate-x: -83.33333%;\n}\n.hover\\:-translate-x-11\\/12:hover {\n  --transform-translate-x: -91.66667%;\n}\n.hover\\:-translate-x-full:hover {\n  --transform-translate-x: -100%;\n}\n.hover\\:translate-y-0:hover {\n  --transform-translate-y: 0;\n}\n.hover\\:translate-y-1:hover {\n  --transform-translate-y: 0.25rem;\n}\n.hover\\:translate-y-2:hover {\n  --transform-translate-y: 0.5rem;\n}\n.hover\\:translate-y-3:hover {\n  --transform-translate-y: 0.75rem;\n}\n.hover\\:translate-y-4:hover {\n  --transform-translate-y: 1rem;\n}\n.hover\\:translate-y-5:hover {\n  --transform-translate-y: 1.25rem;\n}\n.hover\\:translate-y-6:hover {\n  --transform-translate-y: 1.5rem;\n}\n.hover\\:translate-y-7:hover {\n  --transform-translate-y: 1.75rem;\n}\n.hover\\:translate-y-8:hover {\n  --transform-translate-y: 2rem;\n}\n.hover\\:translate-y-9:hover {\n  --transform-translate-y: 2.25rem;\n}\n.hover\\:translate-y-10:hover {\n  --transform-translate-y: 2.5rem;\n}\n.hover\\:translate-y-11:hover {\n  --transform-translate-y: 2.75rem;\n}\n.hover\\:translate-y-12:hover {\n  --transform-translate-y: 3rem;\n}\n.hover\\:translate-y-13:hover {\n  --transform-translate-y: 3.25rem;\n}\n.hover\\:translate-y-14:hover {\n  --transform-translate-y: 3.5rem;\n}\n.hover\\:translate-y-15:hover {\n  --transform-translate-y: 3.75rem;\n}\n.hover\\:translate-y-16:hover {\n  --transform-translate-y: 4rem;\n}\n.hover\\:translate-y-20:hover {\n  --transform-translate-y: 5rem;\n}\n.hover\\:translate-y-24:hover {\n  --transform-translate-y: 6rem;\n}\n.hover\\:translate-y-28:hover {\n  --transform-translate-y: 7rem;\n}\n.hover\\:translate-y-32:hover {\n  --transform-translate-y: 8rem;\n}\n.hover\\:translate-y-36:hover {\n  --transform-translate-y: 9rem;\n}\n.hover\\:translate-y-40:hover {\n  --transform-translate-y: 10rem;\n}\n.hover\\:translate-y-44:hover {\n  --transform-translate-y: 11rem;\n}\n.hover\\:translate-y-48:hover {\n  --transform-translate-y: 12rem;\n}\n.hover\\:translate-y-52:hover {\n  --transform-translate-y: 13rem;\n}\n.hover\\:translate-y-56:hover {\n  --transform-translate-y: 14rem;\n}\n.hover\\:translate-y-60:hover {\n  --transform-translate-y: 15rem;\n}\n.hover\\:translate-y-64:hover {\n  --transform-translate-y: 16rem;\n}\n.hover\\:translate-y-72:hover {\n  --transform-translate-y: 18rem;\n}\n.hover\\:translate-y-80:hover {\n  --transform-translate-y: 20rem;\n}\n.hover\\:translate-y-96:hover {\n  --transform-translate-y: 24rem;\n}\n.hover\\:translate-y-px:hover {\n  --transform-translate-y: 1px;\n}\n.hover\\:translate-y-0\\.5:hover {\n  --transform-translate-y: 0.125rem;\n}\n.hover\\:translate-y-1\\.5:hover {\n  --transform-translate-y: 0.375rem;\n}\n.hover\\:translate-y-2\\.5:hover {\n  --transform-translate-y: 0.625rem;\n}\n.hover\\:translate-y-3\\.5:hover {\n  --transform-translate-y: 0.875rem;\n}\n.hover\\:translate-y-1\\/2:hover {\n  --transform-translate-y: 50%;\n}\n.hover\\:translate-y-1\\/3:hover {\n  --transform-translate-y: 33.333333%;\n}\n.hover\\:translate-y-2\\/3:hover {\n  --transform-translate-y: 66.666667%;\n}\n.hover\\:translate-y-1\\/4:hover {\n  --transform-translate-y: 25%;\n}\n.hover\\:translate-y-2\\/4:hover {\n  --transform-translate-y: 50%;\n}\n.hover\\:translate-y-3\\/4:hover {\n  --transform-translate-y: 75%;\n}\n.hover\\:translate-y-1\\/5:hover {\n  --transform-translate-y: 20%;\n}\n.hover\\:translate-y-2\\/5:hover {\n  --transform-translate-y: 40%;\n}\n.hover\\:translate-y-3\\/5:hover {\n  --transform-translate-y: 60%;\n}\n.hover\\:translate-y-4\\/5:hover {\n  --transform-translate-y: 80%;\n}\n.hover\\:translate-y-1\\/6:hover {\n  --transform-translate-y: 16.666667%;\n}\n.hover\\:translate-y-2\\/6:hover {\n  --transform-translate-y: 33.333333%;\n}\n.hover\\:translate-y-3\\/6:hover {\n  --transform-translate-y: 50%;\n}\n.hover\\:translate-y-4\\/6:hover {\n  --transform-translate-y: 66.666667%;\n}\n.hover\\:translate-y-5\\/6:hover {\n  --transform-translate-y: 83.333333%;\n}\n.hover\\:translate-y-1\\/12:hover {\n  --transform-translate-y: 8.333333%;\n}\n.hover\\:translate-y-2\\/12:hover {\n  --transform-translate-y: 16.666667%;\n}\n.hover\\:translate-y-3\\/12:hover {\n  --transform-translate-y: 25%;\n}\n.hover\\:translate-y-4\\/12:hover {\n  --transform-translate-y: 33.333333%;\n}\n.hover\\:translate-y-5\\/12:hover {\n  --transform-translate-y: 41.666667%;\n}\n.hover\\:translate-y-6\\/12:hover {\n  --transform-translate-y: 50%;\n}\n.hover\\:translate-y-7\\/12:hover {\n  --transform-translate-y: 58.333333%;\n}\n.hover\\:translate-y-8\\/12:hover {\n  --transform-translate-y: 66.666667%;\n}\n.hover\\:translate-y-9\\/12:hover {\n  --transform-translate-y: 75%;\n}\n.hover\\:translate-y-10\\/12:hover {\n  --transform-translate-y: 83.333333%;\n}\n.hover\\:translate-y-11\\/12:hover {\n  --transform-translate-y: 91.666667%;\n}\n.hover\\:translate-y-full:hover {\n  --transform-translate-y: 100%;\n}\n.hover\\:-translate-y-1:hover {\n  --transform-translate-y: -0.25rem;\n}\n.hover\\:-translate-y-2:hover {\n  --transform-translate-y: -0.5rem;\n}\n.hover\\:-translate-y-3:hover {\n  --transform-translate-y: -0.75rem;\n}\n.hover\\:-translate-y-4:hover {\n  --transform-translate-y: -1rem;\n}\n.hover\\:-translate-y-5:hover {\n  --transform-translate-y: -1.25rem;\n}\n.hover\\:-translate-y-6:hover {\n  --transform-translate-y: -1.5rem;\n}\n.hover\\:-translate-y-7:hover {\n  --transform-translate-y: -1.75rem;\n}\n.hover\\:-translate-y-8:hover {\n  --transform-translate-y: -2rem;\n}\n.hover\\:-translate-y-9:hover {\n  --transform-translate-y: -2.25rem;\n}\n.hover\\:-translate-y-10:hover {\n  --transform-translate-y: -2.5rem;\n}\n.hover\\:-translate-y-11:hover {\n  --transform-translate-y: -2.75rem;\n}\n.hover\\:-translate-y-12:hover {\n  --transform-translate-y: -3rem;\n}\n.hover\\:-translate-y-13:hover {\n  --transform-translate-y: -3.25rem;\n}\n.hover\\:-translate-y-14:hover {\n  --transform-translate-y: -3.5rem;\n}\n.hover\\:-translate-y-15:hover {\n  --transform-translate-y: -3.75rem;\n}\n.hover\\:-translate-y-16:hover {\n  --transform-translate-y: -4rem;\n}\n.hover\\:-translate-y-20:hover {\n  --transform-translate-y: -5rem;\n}\n.hover\\:-translate-y-24:hover {\n  --transform-translate-y: -6rem;\n}\n.hover\\:-translate-y-28:hover {\n  --transform-translate-y: -7rem;\n}\n.hover\\:-translate-y-32:hover {\n  --transform-translate-y: -8rem;\n}\n.hover\\:-translate-y-36:hover {\n  --transform-translate-y: -9rem;\n}\n.hover\\:-translate-y-40:hover {\n  --transform-translate-y: -10rem;\n}\n.hover\\:-translate-y-44:hover {\n  --transform-translate-y: -11rem;\n}\n.hover\\:-translate-y-48:hover {\n  --transform-translate-y: -12rem;\n}\n.hover\\:-translate-y-52:hover {\n  --transform-translate-y: -13rem;\n}\n.hover\\:-translate-y-56:hover {\n  --transform-translate-y: -14rem;\n}\n.hover\\:-translate-y-60:hover {\n  --transform-translate-y: -15rem;\n}\n.hover\\:-translate-y-64:hover {\n  --transform-translate-y: -16rem;\n}\n.hover\\:-translate-y-72:hover {\n  --transform-translate-y: -18rem;\n}\n.hover\\:-translate-y-80:hover {\n  --transform-translate-y: -20rem;\n}\n.hover\\:-translate-y-96:hover {\n  --transform-translate-y: -24rem;\n}\n.hover\\:-translate-y-px:hover {\n  --transform-translate-y: -1px;\n}\n.hover\\:-translate-y-0\\.5:hover {\n  --transform-translate-y: -0.125rem;\n}\n.hover\\:-translate-y-1\\.5:hover {\n  --transform-translate-y: -0.375rem;\n}\n.hover\\:-translate-y-2\\.5:hover {\n  --transform-translate-y: -0.625rem;\n}\n.hover\\:-translate-y-3\\.5:hover {\n  --transform-translate-y: -0.875rem;\n}\n.hover\\:-translate-y-1\\/2:hover {\n  --transform-translate-y: -50%;\n}\n.hover\\:-translate-y-1\\/3:hover {\n  --transform-translate-y: -33.33333%;\n}\n.hover\\:-translate-y-2\\/3:hover {\n  --transform-translate-y: -66.66667%;\n}\n.hover\\:-translate-y-1\\/4:hover {\n  --transform-translate-y: -25%;\n}\n.hover\\:-translate-y-2\\/4:hover {\n  --transform-translate-y: -50%;\n}\n.hover\\:-translate-y-3\\/4:hover {\n  --transform-translate-y: -75%;\n}\n.hover\\:-translate-y-1\\/5:hover {\n  --transform-translate-y: -20%;\n}\n.hover\\:-translate-y-2\\/5:hover {\n  --transform-translate-y: -40%;\n}\n.hover\\:-translate-y-3\\/5:hover {\n  --transform-translate-y: -60%;\n}\n.hover\\:-translate-y-4\\/5:hover {\n  --transform-translate-y: -80%;\n}\n.hover\\:-translate-y-1\\/6:hover {\n  --transform-translate-y: -16.66667%;\n}\n.hover\\:-translate-y-2\\/6:hover {\n  --transform-translate-y: -33.33333%;\n}\n.hover\\:-translate-y-3\\/6:hover {\n  --transform-translate-y: -50%;\n}\n.hover\\:-translate-y-4\\/6:hover {\n  --transform-translate-y: -66.66667%;\n}\n.hover\\:-translate-y-5\\/6:hover {\n  --transform-translate-y: -83.33333%;\n}\n.hover\\:-translate-y-1\\/12:hover {\n  --transform-translate-y: -8.33333%;\n}\n.hover\\:-translate-y-2\\/12:hover {\n  --transform-translate-y: -16.66667%;\n}\n.hover\\:-translate-y-3\\/12:hover {\n  --transform-translate-y: -25%;\n}\n.hover\\:-translate-y-4\\/12:hover {\n  --transform-translate-y: -33.33333%;\n}\n.hover\\:-translate-y-5\\/12:hover {\n  --transform-translate-y: -41.66667%;\n}\n.hover\\:-translate-y-6\\/12:hover {\n  --transform-translate-y: -50%;\n}\n.hover\\:-translate-y-7\\/12:hover {\n  --transform-translate-y: -58.33333%;\n}\n.hover\\:-translate-y-8\\/12:hover {\n  --transform-translate-y: -66.66667%;\n}\n.hover\\:-translate-y-9\\/12:hover {\n  --transform-translate-y: -75%;\n}\n.hover\\:-translate-y-10\\/12:hover {\n  --transform-translate-y: -83.33333%;\n}\n.hover\\:-translate-y-11\\/12:hover {\n  --transform-translate-y: -91.66667%;\n}\n.hover\\:-translate-y-full:hover {\n  --transform-translate-y: -100%;\n}\n.focus\\:translate-x-0:focus {\n  --transform-translate-x: 0;\n}\n.focus\\:translate-x-1:focus {\n  --transform-translate-x: 0.25rem;\n}\n.focus\\:translate-x-2:focus {\n  --transform-translate-x: 0.5rem;\n}\n.focus\\:translate-x-3:focus {\n  --transform-translate-x: 0.75rem;\n}\n.focus\\:translate-x-4:focus {\n  --transform-translate-x: 1rem;\n}\n.focus\\:translate-x-5:focus {\n  --transform-translate-x: 1.25rem;\n}\n.focus\\:translate-x-6:focus {\n  --transform-translate-x: 1.5rem;\n}\n.focus\\:translate-x-7:focus {\n  --transform-translate-x: 1.75rem;\n}\n.focus\\:translate-x-8:focus {\n  --transform-translate-x: 2rem;\n}\n.focus\\:translate-x-9:focus {\n  --transform-translate-x: 2.25rem;\n}\n.focus\\:translate-x-10:focus {\n  --transform-translate-x: 2.5rem;\n}\n.focus\\:translate-x-11:focus {\n  --transform-translate-x: 2.75rem;\n}\n.focus\\:translate-x-12:focus {\n  --transform-translate-x: 3rem;\n}\n.focus\\:translate-x-13:focus {\n  --transform-translate-x: 3.25rem;\n}\n.focus\\:translate-x-14:focus {\n  --transform-translate-x: 3.5rem;\n}\n.focus\\:translate-x-15:focus {\n  --transform-translate-x: 3.75rem;\n}\n.focus\\:translate-x-16:focus {\n  --transform-translate-x: 4rem;\n}\n.focus\\:translate-x-20:focus {\n  --transform-translate-x: 5rem;\n}\n.focus\\:translate-x-24:focus {\n  --transform-translate-x: 6rem;\n}\n.focus\\:translate-x-28:focus {\n  --transform-translate-x: 7rem;\n}\n.focus\\:translate-x-32:focus {\n  --transform-translate-x: 8rem;\n}\n.focus\\:translate-x-36:focus {\n  --transform-translate-x: 9rem;\n}\n.focus\\:translate-x-40:focus {\n  --transform-translate-x: 10rem;\n}\n.focus\\:translate-x-44:focus {\n  --transform-translate-x: 11rem;\n}\n.focus\\:translate-x-48:focus {\n  --transform-translate-x: 12rem;\n}\n.focus\\:translate-x-52:focus {\n  --transform-translate-x: 13rem;\n}\n.focus\\:translate-x-56:focus {\n  --transform-translate-x: 14rem;\n}\n.focus\\:translate-x-60:focus {\n  --transform-translate-x: 15rem;\n}\n.focus\\:translate-x-64:focus {\n  --transform-translate-x: 16rem;\n}\n.focus\\:translate-x-72:focus {\n  --transform-translate-x: 18rem;\n}\n.focus\\:translate-x-80:focus {\n  --transform-translate-x: 20rem;\n}\n.focus\\:translate-x-96:focus {\n  --transform-translate-x: 24rem;\n}\n.focus\\:translate-x-px:focus {\n  --transform-translate-x: 1px;\n}\n.focus\\:translate-x-0\\.5:focus {\n  --transform-translate-x: 0.125rem;\n}\n.focus\\:translate-x-1\\.5:focus {\n  --transform-translate-x: 0.375rem;\n}\n.focus\\:translate-x-2\\.5:focus {\n  --transform-translate-x: 0.625rem;\n}\n.focus\\:translate-x-3\\.5:focus {\n  --transform-translate-x: 0.875rem;\n}\n.focus\\:translate-x-1\\/2:focus {\n  --transform-translate-x: 50%;\n}\n.focus\\:translate-x-1\\/3:focus {\n  --transform-translate-x: 33.333333%;\n}\n.focus\\:translate-x-2\\/3:focus {\n  --transform-translate-x: 66.666667%;\n}\n.focus\\:translate-x-1\\/4:focus {\n  --transform-translate-x: 25%;\n}\n.focus\\:translate-x-2\\/4:focus {\n  --transform-translate-x: 50%;\n}\n.focus\\:translate-x-3\\/4:focus {\n  --transform-translate-x: 75%;\n}\n.focus\\:translate-x-1\\/5:focus {\n  --transform-translate-x: 20%;\n}\n.focus\\:translate-x-2\\/5:focus {\n  --transform-translate-x: 40%;\n}\n.focus\\:translate-x-3\\/5:focus {\n  --transform-translate-x: 60%;\n}\n.focus\\:translate-x-4\\/5:focus {\n  --transform-translate-x: 80%;\n}\n.focus\\:translate-x-1\\/6:focus {\n  --transform-translate-x: 16.666667%;\n}\n.focus\\:translate-x-2\\/6:focus {\n  --transform-translate-x: 33.333333%;\n}\n.focus\\:translate-x-3\\/6:focus {\n  --transform-translate-x: 50%;\n}\n.focus\\:translate-x-4\\/6:focus {\n  --transform-translate-x: 66.666667%;\n}\n.focus\\:translate-x-5\\/6:focus {\n  --transform-translate-x: 83.333333%;\n}\n.focus\\:translate-x-1\\/12:focus {\n  --transform-translate-x: 8.333333%;\n}\n.focus\\:translate-x-2\\/12:focus {\n  --transform-translate-x: 16.666667%;\n}\n.focus\\:translate-x-3\\/12:focus {\n  --transform-translate-x: 25%;\n}\n.focus\\:translate-x-4\\/12:focus {\n  --transform-translate-x: 33.333333%;\n}\n.focus\\:translate-x-5\\/12:focus {\n  --transform-translate-x: 41.666667%;\n}\n.focus\\:translate-x-6\\/12:focus {\n  --transform-translate-x: 50%;\n}\n.focus\\:translate-x-7\\/12:focus {\n  --transform-translate-x: 58.333333%;\n}\n.focus\\:translate-x-8\\/12:focus {\n  --transform-translate-x: 66.666667%;\n}\n.focus\\:translate-x-9\\/12:focus {\n  --transform-translate-x: 75%;\n}\n.focus\\:translate-x-10\\/12:focus {\n  --transform-translate-x: 83.333333%;\n}\n.focus\\:translate-x-11\\/12:focus {\n  --transform-translate-x: 91.666667%;\n}\n.focus\\:translate-x-full:focus {\n  --transform-translate-x: 100%;\n}\n.focus\\:-translate-x-1:focus {\n  --transform-translate-x: -0.25rem;\n}\n.focus\\:-translate-x-2:focus {\n  --transform-translate-x: -0.5rem;\n}\n.focus\\:-translate-x-3:focus {\n  --transform-translate-x: -0.75rem;\n}\n.focus\\:-translate-x-4:focus {\n  --transform-translate-x: -1rem;\n}\n.focus\\:-translate-x-5:focus {\n  --transform-translate-x: -1.25rem;\n}\n.focus\\:-translate-x-6:focus {\n  --transform-translate-x: -1.5rem;\n}\n.focus\\:-translate-x-7:focus {\n  --transform-translate-x: -1.75rem;\n}\n.focus\\:-translate-x-8:focus {\n  --transform-translate-x: -2rem;\n}\n.focus\\:-translate-x-9:focus {\n  --transform-translate-x: -2.25rem;\n}\n.focus\\:-translate-x-10:focus {\n  --transform-translate-x: -2.5rem;\n}\n.focus\\:-translate-x-11:focus {\n  --transform-translate-x: -2.75rem;\n}\n.focus\\:-translate-x-12:focus {\n  --transform-translate-x: -3rem;\n}\n.focus\\:-translate-x-13:focus {\n  --transform-translate-x: -3.25rem;\n}\n.focus\\:-translate-x-14:focus {\n  --transform-translate-x: -3.5rem;\n}\n.focus\\:-translate-x-15:focus {\n  --transform-translate-x: -3.75rem;\n}\n.focus\\:-translate-x-16:focus {\n  --transform-translate-x: -4rem;\n}\n.focus\\:-translate-x-20:focus {\n  --transform-translate-x: -5rem;\n}\n.focus\\:-translate-x-24:focus {\n  --transform-translate-x: -6rem;\n}\n.focus\\:-translate-x-28:focus {\n  --transform-translate-x: -7rem;\n}\n.focus\\:-translate-x-32:focus {\n  --transform-translate-x: -8rem;\n}\n.focus\\:-translate-x-36:focus {\n  --transform-translate-x: -9rem;\n}\n.focus\\:-translate-x-40:focus {\n  --transform-translate-x: -10rem;\n}\n.focus\\:-translate-x-44:focus {\n  --transform-translate-x: -11rem;\n}\n.focus\\:-translate-x-48:focus {\n  --transform-translate-x: -12rem;\n}\n.focus\\:-translate-x-52:focus {\n  --transform-translate-x: -13rem;\n}\n.focus\\:-translate-x-56:focus {\n  --transform-translate-x: -14rem;\n}\n.focus\\:-translate-x-60:focus {\n  --transform-translate-x: -15rem;\n}\n.focus\\:-translate-x-64:focus {\n  --transform-translate-x: -16rem;\n}\n.focus\\:-translate-x-72:focus {\n  --transform-translate-x: -18rem;\n}\n.focus\\:-translate-x-80:focus {\n  --transform-translate-x: -20rem;\n}\n.focus\\:-translate-x-96:focus {\n  --transform-translate-x: -24rem;\n}\n.focus\\:-translate-x-px:focus {\n  --transform-translate-x: -1px;\n}\n.focus\\:-translate-x-0\\.5:focus {\n  --transform-translate-x: -0.125rem;\n}\n.focus\\:-translate-x-1\\.5:focus {\n  --transform-translate-x: -0.375rem;\n}\n.focus\\:-translate-x-2\\.5:focus {\n  --transform-translate-x: -0.625rem;\n}\n.focus\\:-translate-x-3\\.5:focus {\n  --transform-translate-x: -0.875rem;\n}\n.focus\\:-translate-x-1\\/2:focus {\n  --transform-translate-x: -50%;\n}\n.focus\\:-translate-x-1\\/3:focus {\n  --transform-translate-x: -33.33333%;\n}\n.focus\\:-translate-x-2\\/3:focus {\n  --transform-translate-x: -66.66667%;\n}\n.focus\\:-translate-x-1\\/4:focus {\n  --transform-translate-x: -25%;\n}\n.focus\\:-translate-x-2\\/4:focus {\n  --transform-translate-x: -50%;\n}\n.focus\\:-translate-x-3\\/4:focus {\n  --transform-translate-x: -75%;\n}\n.focus\\:-translate-x-1\\/5:focus {\n  --transform-translate-x: -20%;\n}\n.focus\\:-translate-x-2\\/5:focus {\n  --transform-translate-x: -40%;\n}\n.focus\\:-translate-x-3\\/5:focus {\n  --transform-translate-x: -60%;\n}\n.focus\\:-translate-x-4\\/5:focus {\n  --transform-translate-x: -80%;\n}\n.focus\\:-translate-x-1\\/6:focus {\n  --transform-translate-x: -16.66667%;\n}\n.focus\\:-translate-x-2\\/6:focus {\n  --transform-translate-x: -33.33333%;\n}\n.focus\\:-translate-x-3\\/6:focus {\n  --transform-translate-x: -50%;\n}\n.focus\\:-translate-x-4\\/6:focus {\n  --transform-translate-x: -66.66667%;\n}\n.focus\\:-translate-x-5\\/6:focus {\n  --transform-translate-x: -83.33333%;\n}\n.focus\\:-translate-x-1\\/12:focus {\n  --transform-translate-x: -8.33333%;\n}\n.focus\\:-translate-x-2\\/12:focus {\n  --transform-translate-x: -16.66667%;\n}\n.focus\\:-translate-x-3\\/12:focus {\n  --transform-translate-x: -25%;\n}\n.focus\\:-translate-x-4\\/12:focus {\n  --transform-translate-x: -33.33333%;\n}\n.focus\\:-translate-x-5\\/12:focus {\n  --transform-translate-x: -41.66667%;\n}\n.focus\\:-translate-x-6\\/12:focus {\n  --transform-translate-x: -50%;\n}\n.focus\\:-translate-x-7\\/12:focus {\n  --transform-translate-x: -58.33333%;\n}\n.focus\\:-translate-x-8\\/12:focus {\n  --transform-translate-x: -66.66667%;\n}\n.focus\\:-translate-x-9\\/12:focus {\n  --transform-translate-x: -75%;\n}\n.focus\\:-translate-x-10\\/12:focus {\n  --transform-translate-x: -83.33333%;\n}\n.focus\\:-translate-x-11\\/12:focus {\n  --transform-translate-x: -91.66667%;\n}\n.focus\\:-translate-x-full:focus {\n  --transform-translate-x: -100%;\n}\n.focus\\:translate-y-0:focus {\n  --transform-translate-y: 0;\n}\n.focus\\:translate-y-1:focus {\n  --transform-translate-y: 0.25rem;\n}\n.focus\\:translate-y-2:focus {\n  --transform-translate-y: 0.5rem;\n}\n.focus\\:translate-y-3:focus {\n  --transform-translate-y: 0.75rem;\n}\n.focus\\:translate-y-4:focus {\n  --transform-translate-y: 1rem;\n}\n.focus\\:translate-y-5:focus {\n  --transform-translate-y: 1.25rem;\n}\n.focus\\:translate-y-6:focus {\n  --transform-translate-y: 1.5rem;\n}\n.focus\\:translate-y-7:focus {\n  --transform-translate-y: 1.75rem;\n}\n.focus\\:translate-y-8:focus {\n  --transform-translate-y: 2rem;\n}\n.focus\\:translate-y-9:focus {\n  --transform-translate-y: 2.25rem;\n}\n.focus\\:translate-y-10:focus {\n  --transform-translate-y: 2.5rem;\n}\n.focus\\:translate-y-11:focus {\n  --transform-translate-y: 2.75rem;\n}\n.focus\\:translate-y-12:focus {\n  --transform-translate-y: 3rem;\n}\n.focus\\:translate-y-13:focus {\n  --transform-translate-y: 3.25rem;\n}\n.focus\\:translate-y-14:focus {\n  --transform-translate-y: 3.5rem;\n}\n.focus\\:translate-y-15:focus {\n  --transform-translate-y: 3.75rem;\n}\n.focus\\:translate-y-16:focus {\n  --transform-translate-y: 4rem;\n}\n.focus\\:translate-y-20:focus {\n  --transform-translate-y: 5rem;\n}\n.focus\\:translate-y-24:focus {\n  --transform-translate-y: 6rem;\n}\n.focus\\:translate-y-28:focus {\n  --transform-translate-y: 7rem;\n}\n.focus\\:translate-y-32:focus {\n  --transform-translate-y: 8rem;\n}\n.focus\\:translate-y-36:focus {\n  --transform-translate-y: 9rem;\n}\n.focus\\:translate-y-40:focus {\n  --transform-translate-y: 10rem;\n}\n.focus\\:translate-y-44:focus {\n  --transform-translate-y: 11rem;\n}\n.focus\\:translate-y-48:focus {\n  --transform-translate-y: 12rem;\n}\n.focus\\:translate-y-52:focus {\n  --transform-translate-y: 13rem;\n}\n.focus\\:translate-y-56:focus {\n  --transform-translate-y: 14rem;\n}\n.focus\\:translate-y-60:focus {\n  --transform-translate-y: 15rem;\n}\n.focus\\:translate-y-64:focus {\n  --transform-translate-y: 16rem;\n}\n.focus\\:translate-y-72:focus {\n  --transform-translate-y: 18rem;\n}\n.focus\\:translate-y-80:focus {\n  --transform-translate-y: 20rem;\n}\n.focus\\:translate-y-96:focus {\n  --transform-translate-y: 24rem;\n}\n.focus\\:translate-y-px:focus {\n  --transform-translate-y: 1px;\n}\n.focus\\:translate-y-0\\.5:focus {\n  --transform-translate-y: 0.125rem;\n}\n.focus\\:translate-y-1\\.5:focus {\n  --transform-translate-y: 0.375rem;\n}\n.focus\\:translate-y-2\\.5:focus {\n  --transform-translate-y: 0.625rem;\n}\n.focus\\:translate-y-3\\.5:focus {\n  --transform-translate-y: 0.875rem;\n}\n.focus\\:translate-y-1\\/2:focus {\n  --transform-translate-y: 50%;\n}\n.focus\\:translate-y-1\\/3:focus {\n  --transform-translate-y: 33.333333%;\n}\n.focus\\:translate-y-2\\/3:focus {\n  --transform-translate-y: 66.666667%;\n}\n.focus\\:translate-y-1\\/4:focus {\n  --transform-translate-y: 25%;\n}\n.focus\\:translate-y-2\\/4:focus {\n  --transform-translate-y: 50%;\n}\n.focus\\:translate-y-3\\/4:focus {\n  --transform-translate-y: 75%;\n}\n.focus\\:translate-y-1\\/5:focus {\n  --transform-translate-y: 20%;\n}\n.focus\\:translate-y-2\\/5:focus {\n  --transform-translate-y: 40%;\n}\n.focus\\:translate-y-3\\/5:focus {\n  --transform-translate-y: 60%;\n}\n.focus\\:translate-y-4\\/5:focus {\n  --transform-translate-y: 80%;\n}\n.focus\\:translate-y-1\\/6:focus {\n  --transform-translate-y: 16.666667%;\n}\n.focus\\:translate-y-2\\/6:focus {\n  --transform-translate-y: 33.333333%;\n}\n.focus\\:translate-y-3\\/6:focus {\n  --transform-translate-y: 50%;\n}\n.focus\\:translate-y-4\\/6:focus {\n  --transform-translate-y: 66.666667%;\n}\n.focus\\:translate-y-5\\/6:focus {\n  --transform-translate-y: 83.333333%;\n}\n.focus\\:translate-y-1\\/12:focus {\n  --transform-translate-y: 8.333333%;\n}\n.focus\\:translate-y-2\\/12:focus {\n  --transform-translate-y: 16.666667%;\n}\n.focus\\:translate-y-3\\/12:focus {\n  --transform-translate-y: 25%;\n}\n.focus\\:translate-y-4\\/12:focus {\n  --transform-translate-y: 33.333333%;\n}\n.focus\\:translate-y-5\\/12:focus {\n  --transform-translate-y: 41.666667%;\n}\n.focus\\:translate-y-6\\/12:focus {\n  --transform-translate-y: 50%;\n}\n.focus\\:translate-y-7\\/12:focus {\n  --transform-translate-y: 58.333333%;\n}\n.focus\\:translate-y-8\\/12:focus {\n  --transform-translate-y: 66.666667%;\n}\n.focus\\:translate-y-9\\/12:focus {\n  --transform-translate-y: 75%;\n}\n.focus\\:translate-y-10\\/12:focus {\n  --transform-translate-y: 83.333333%;\n}\n.focus\\:translate-y-11\\/12:focus {\n  --transform-translate-y: 91.666667%;\n}\n.focus\\:translate-y-full:focus {\n  --transform-translate-y: 100%;\n}\n.focus\\:-translate-y-1:focus {\n  --transform-translate-y: -0.25rem;\n}\n.focus\\:-translate-y-2:focus {\n  --transform-translate-y: -0.5rem;\n}\n.focus\\:-translate-y-3:focus {\n  --transform-translate-y: -0.75rem;\n}\n.focus\\:-translate-y-4:focus {\n  --transform-translate-y: -1rem;\n}\n.focus\\:-translate-y-5:focus {\n  --transform-translate-y: -1.25rem;\n}\n.focus\\:-translate-y-6:focus {\n  --transform-translate-y: -1.5rem;\n}\n.focus\\:-translate-y-7:focus {\n  --transform-translate-y: -1.75rem;\n}\n.focus\\:-translate-y-8:focus {\n  --transform-translate-y: -2rem;\n}\n.focus\\:-translate-y-9:focus {\n  --transform-translate-y: -2.25rem;\n}\n.focus\\:-translate-y-10:focus {\n  --transform-translate-y: -2.5rem;\n}\n.focus\\:-translate-y-11:focus {\n  --transform-translate-y: -2.75rem;\n}\n.focus\\:-translate-y-12:focus {\n  --transform-translate-y: -3rem;\n}\n.focus\\:-translate-y-13:focus {\n  --transform-translate-y: -3.25rem;\n}\n.focus\\:-translate-y-14:focus {\n  --transform-translate-y: -3.5rem;\n}\n.focus\\:-translate-y-15:focus {\n  --transform-translate-y: -3.75rem;\n}\n.focus\\:-translate-y-16:focus {\n  --transform-translate-y: -4rem;\n}\n.focus\\:-translate-y-20:focus {\n  --transform-translate-y: -5rem;\n}\n.focus\\:-translate-y-24:focus {\n  --transform-translate-y: -6rem;\n}\n.focus\\:-translate-y-28:focus {\n  --transform-translate-y: -7rem;\n}\n.focus\\:-translate-y-32:focus {\n  --transform-translate-y: -8rem;\n}\n.focus\\:-translate-y-36:focus {\n  --transform-translate-y: -9rem;\n}\n.focus\\:-translate-y-40:focus {\n  --transform-translate-y: -10rem;\n}\n.focus\\:-translate-y-44:focus {\n  --transform-translate-y: -11rem;\n}\n.focus\\:-translate-y-48:focus {\n  --transform-translate-y: -12rem;\n}\n.focus\\:-translate-y-52:focus {\n  --transform-translate-y: -13rem;\n}\n.focus\\:-translate-y-56:focus {\n  --transform-translate-y: -14rem;\n}\n.focus\\:-translate-y-60:focus {\n  --transform-translate-y: -15rem;\n}\n.focus\\:-translate-y-64:focus {\n  --transform-translate-y: -16rem;\n}\n.focus\\:-translate-y-72:focus {\n  --transform-translate-y: -18rem;\n}\n.focus\\:-translate-y-80:focus {\n  --transform-translate-y: -20rem;\n}\n.focus\\:-translate-y-96:focus {\n  --transform-translate-y: -24rem;\n}\n.focus\\:-translate-y-px:focus {\n  --transform-translate-y: -1px;\n}\n.focus\\:-translate-y-0\\.5:focus {\n  --transform-translate-y: -0.125rem;\n}\n.focus\\:-translate-y-1\\.5:focus {\n  --transform-translate-y: -0.375rem;\n}\n.focus\\:-translate-y-2\\.5:focus {\n  --transform-translate-y: -0.625rem;\n}\n.focus\\:-translate-y-3\\.5:focus {\n  --transform-translate-y: -0.875rem;\n}\n.focus\\:-translate-y-1\\/2:focus {\n  --transform-translate-y: -50%;\n}\n.focus\\:-translate-y-1\\/3:focus {\n  --transform-translate-y: -33.33333%;\n}\n.focus\\:-translate-y-2\\/3:focus {\n  --transform-translate-y: -66.66667%;\n}\n.focus\\:-translate-y-1\\/4:focus {\n  --transform-translate-y: -25%;\n}\n.focus\\:-translate-y-2\\/4:focus {\n  --transform-translate-y: -50%;\n}\n.focus\\:-translate-y-3\\/4:focus {\n  --transform-translate-y: -75%;\n}\n.focus\\:-translate-y-1\\/5:focus {\n  --transform-translate-y: -20%;\n}\n.focus\\:-translate-y-2\\/5:focus {\n  --transform-translate-y: -40%;\n}\n.focus\\:-translate-y-3\\/5:focus {\n  --transform-translate-y: -60%;\n}\n.focus\\:-translate-y-4\\/5:focus {\n  --transform-translate-y: -80%;\n}\n.focus\\:-translate-y-1\\/6:focus {\n  --transform-translate-y: -16.66667%;\n}\n.focus\\:-translate-y-2\\/6:focus {\n  --transform-translate-y: -33.33333%;\n}\n.focus\\:-translate-y-3\\/6:focus {\n  --transform-translate-y: -50%;\n}\n.focus\\:-translate-y-4\\/6:focus {\n  --transform-translate-y: -66.66667%;\n}\n.focus\\:-translate-y-5\\/6:focus {\n  --transform-translate-y: -83.33333%;\n}\n.focus\\:-translate-y-1\\/12:focus {\n  --transform-translate-y: -8.33333%;\n}\n.focus\\:-translate-y-2\\/12:focus {\n  --transform-translate-y: -16.66667%;\n}\n.focus\\:-translate-y-3\\/12:focus {\n  --transform-translate-y: -25%;\n}\n.focus\\:-translate-y-4\\/12:focus {\n  --transform-translate-y: -33.33333%;\n}\n.focus\\:-translate-y-5\\/12:focus {\n  --transform-translate-y: -41.66667%;\n}\n.focus\\:-translate-y-6\\/12:focus {\n  --transform-translate-y: -50%;\n}\n.focus\\:-translate-y-7\\/12:focus {\n  --transform-translate-y: -58.33333%;\n}\n.focus\\:-translate-y-8\\/12:focus {\n  --transform-translate-y: -66.66667%;\n}\n.focus\\:-translate-y-9\\/12:focus {\n  --transform-translate-y: -75%;\n}\n.focus\\:-translate-y-10\\/12:focus {\n  --transform-translate-y: -83.33333%;\n}\n.focus\\:-translate-y-11\\/12:focus {\n  --transform-translate-y: -91.66667%;\n}\n.focus\\:-translate-y-full:focus {\n  --transform-translate-y: -100%;\n}\n.skew-x-0 {\n  --transform-skew-x: 0;\n}\n.skew-x-1 {\n  --transform-skew-x: 1deg;\n}\n.skew-x-2 {\n  --transform-skew-x: 2deg;\n}\n.skew-x-3 {\n  --transform-skew-x: 3deg;\n}\n.skew-x-6 {\n  --transform-skew-x: 6deg;\n}\n.skew-x-12 {\n  --transform-skew-x: 12deg;\n}\n.-skew-x-12 {\n  --transform-skew-x: -12deg;\n}\n.-skew-x-6 {\n  --transform-skew-x: -6deg;\n}\n.-skew-x-3 {\n  --transform-skew-x: -3deg;\n}\n.-skew-x-2 {\n  --transform-skew-x: -2deg;\n}\n.-skew-x-1 {\n  --transform-skew-x: -1deg;\n}\n.skew-y-0 {\n  --transform-skew-y: 0;\n}\n.skew-y-1 {\n  --transform-skew-y: 1deg;\n}\n.skew-y-2 {\n  --transform-skew-y: 2deg;\n}\n.skew-y-3 {\n  --transform-skew-y: 3deg;\n}\n.skew-y-6 {\n  --transform-skew-y: 6deg;\n}\n.skew-y-12 {\n  --transform-skew-y: 12deg;\n}\n.-skew-y-12 {\n  --transform-skew-y: -12deg;\n}\n.-skew-y-6 {\n  --transform-skew-y: -6deg;\n}\n.-skew-y-3 {\n  --transform-skew-y: -3deg;\n}\n.-skew-y-2 {\n  --transform-skew-y: -2deg;\n}\n.-skew-y-1 {\n  --transform-skew-y: -1deg;\n}\n.hover\\:skew-x-0:hover {\n  --transform-skew-x: 0;\n}\n.hover\\:skew-x-1:hover {\n  --transform-skew-x: 1deg;\n}\n.hover\\:skew-x-2:hover {\n  --transform-skew-x: 2deg;\n}\n.hover\\:skew-x-3:hover {\n  --transform-skew-x: 3deg;\n}\n.hover\\:skew-x-6:hover {\n  --transform-skew-x: 6deg;\n}\n.hover\\:skew-x-12:hover {\n  --transform-skew-x: 12deg;\n}\n.hover\\:-skew-x-12:hover {\n  --transform-skew-x: -12deg;\n}\n.hover\\:-skew-x-6:hover {\n  --transform-skew-x: -6deg;\n}\n.hover\\:-skew-x-3:hover {\n  --transform-skew-x: -3deg;\n}\n.hover\\:-skew-x-2:hover {\n  --transform-skew-x: -2deg;\n}\n.hover\\:-skew-x-1:hover {\n  --transform-skew-x: -1deg;\n}\n.hover\\:skew-y-0:hover {\n  --transform-skew-y: 0;\n}\n.hover\\:skew-y-1:hover {\n  --transform-skew-y: 1deg;\n}\n.hover\\:skew-y-2:hover {\n  --transform-skew-y: 2deg;\n}\n.hover\\:skew-y-3:hover {\n  --transform-skew-y: 3deg;\n}\n.hover\\:skew-y-6:hover {\n  --transform-skew-y: 6deg;\n}\n.hover\\:skew-y-12:hover {\n  --transform-skew-y: 12deg;\n}\n.hover\\:-skew-y-12:hover {\n  --transform-skew-y: -12deg;\n}\n.hover\\:-skew-y-6:hover {\n  --transform-skew-y: -6deg;\n}\n.hover\\:-skew-y-3:hover {\n  --transform-skew-y: -3deg;\n}\n.hover\\:-skew-y-2:hover {\n  --transform-skew-y: -2deg;\n}\n.hover\\:-skew-y-1:hover {\n  --transform-skew-y: -1deg;\n}\n.focus\\:skew-x-0:focus {\n  --transform-skew-x: 0;\n}\n.focus\\:skew-x-1:focus {\n  --transform-skew-x: 1deg;\n}\n.focus\\:skew-x-2:focus {\n  --transform-skew-x: 2deg;\n}\n.focus\\:skew-x-3:focus {\n  --transform-skew-x: 3deg;\n}\n.focus\\:skew-x-6:focus {\n  --transform-skew-x: 6deg;\n}\n.focus\\:skew-x-12:focus {\n  --transform-skew-x: 12deg;\n}\n.focus\\:-skew-x-12:focus {\n  --transform-skew-x: -12deg;\n}\n.focus\\:-skew-x-6:focus {\n  --transform-skew-x: -6deg;\n}\n.focus\\:-skew-x-3:focus {\n  --transform-skew-x: -3deg;\n}\n.focus\\:-skew-x-2:focus {\n  --transform-skew-x: -2deg;\n}\n.focus\\:-skew-x-1:focus {\n  --transform-skew-x: -1deg;\n}\n.focus\\:skew-y-0:focus {\n  --transform-skew-y: 0;\n}\n.focus\\:skew-y-1:focus {\n  --transform-skew-y: 1deg;\n}\n.focus\\:skew-y-2:focus {\n  --transform-skew-y: 2deg;\n}\n.focus\\:skew-y-3:focus {\n  --transform-skew-y: 3deg;\n}\n.focus\\:skew-y-6:focus {\n  --transform-skew-y: 6deg;\n}\n.focus\\:skew-y-12:focus {\n  --transform-skew-y: 12deg;\n}\n.focus\\:-skew-y-12:focus {\n  --transform-skew-y: -12deg;\n}\n.focus\\:-skew-y-6:focus {\n  --transform-skew-y: -6deg;\n}\n.focus\\:-skew-y-3:focus {\n  --transform-skew-y: -3deg;\n}\n.focus\\:-skew-y-2:focus {\n  --transform-skew-y: -2deg;\n}\n.focus\\:-skew-y-1:focus {\n  --transform-skew-y: -1deg;\n}\n.transition-none {\n  transition-property: none;\n}\n.transition-all {\n  transition-property: all;\n}\n.transition {\n  transition-property: background-color, border-color, color, fill, stroke, opacity, box-shadow, transform;\n}\n.transition-colors {\n  transition-property: background-color, border-color, color, fill, stroke;\n}\n.transition-opacity {\n  transition-property: opacity;\n}\n.transition-shadow {\n  transition-property: box-shadow;\n}\n.transition-transform {\n  transition-property: transform;\n}\n.ease-linear {\n  transition-timing-function: linear;\n}\n.ease-in {\n  transition-timing-function: cubic-bezier(0.4, 0, 1, 1);\n}\n.ease-out {\n  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);\n}\n.ease-in-out {\n  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n}\n.duration-75 {\n  transition-duration: 75ms;\n}\n.duration-100 {\n  transition-duration: 100ms;\n}\n.duration-150 {\n  transition-duration: 150ms;\n}\n.duration-200 {\n  transition-duration: 200ms;\n}\n.duration-300 {\n  transition-duration: 300ms;\n}\n.duration-500 {\n  transition-duration: 500ms;\n}\n.duration-700 {\n  transition-duration: 700ms;\n}\n.duration-1000 {\n  transition-duration: 1000ms;\n}\n.delay-75 {\n  transition-delay: 75ms;\n}\n.delay-100 {\n  transition-delay: 100ms;\n}\n.delay-150 {\n  transition-delay: 150ms;\n}\n.delay-200 {\n  transition-delay: 200ms;\n}\n.delay-300 {\n  transition-delay: 300ms;\n}\n.delay-500 {\n  transition-delay: 500ms;\n}\n.delay-700 {\n  transition-delay: 700ms;\n}\n.delay-1000 {\n  transition-delay: 1000ms;\n}\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n@keyframes ping {\n  75%, 100% {\n    transform: scale(2);\n    opacity: 0;\n  }\n}\n@keyframes pulse {\n  50% {\n    opacity: .5;\n  }\n}\n@keyframes bounce {\n  0%, 100% {\n    transform: translateY(-25%);\n    animation-timing-function: cubic-bezier(0.8, 0, 1, 1);\n  }\n  50% {\n    transform: none;\n    animation-timing-function: cubic-bezier(0, 0, 0.2, 1);\n  }\n}\n.animate-none {\n  animation: none;\n}\n.animate-spin {\n  animation: spin 1s linear infinite;\n}\n.animate-ping {\n  animation: ping 1s cubic-bezier(0, 0, 0.2, 1) infinite;\n}\n.animate-pulse {\n  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;\n}\n.animate-bounce {\n  animation: bounce 1s infinite;\n}\n@media (min-width: 640px) {\n  .sm\\:container {\n    width: 100%;\n  }\n  @media (min-width: 640px) {\n    .sm\\:container {\n      max-width: 640px;\n    }\n  }\n  @media (min-width: 768px) {\n    .sm\\:container {\n      max-width: 768px;\n    }\n  }\n  @media (min-width: 1024px) {\n    .sm\\:container {\n      max-width: 1024px;\n    }\n  }\n  @media (min-width: 1280px) {\n    .sm\\:container {\n      max-width: 1280px;\n    }\n  }\n  .sm\\:prose {\n    color: #374151;\n    max-width: 65ch;\n  }\n  .sm\\:prose [class~=\"lead\"] {\n    color: #4b5563;\n    font-size: 1.25em;\n    line-height: 1.6;\n    margin-top: 1.2em;\n    margin-bottom: 1.2em;\n  }\n  .sm\\:prose a {\n    color: #5850ec;\n    text-decoration: none;\n    font-weight: 600;\n  }\n  .sm\\:prose strong {\n    color: #161e2e;\n    font-weight: 600;\n  }\n  .sm\\:prose ol {\n    counter-reset: list-counter;\n    margin-top: 1.25em;\n    margin-bottom: 1.25em;\n  }\n  .sm\\:prose ol>li {\n    position: relative;\n    counter-increment: list-counter;\n    padding-left: 1.75em;\n  }\n  .sm\\:prose ol>li::before {\n    content: counter(list-counter) \".\";\n    position: absolute;\n    font-weight: 400;\n    color: #6b7280;\n  }\n  .sm\\:prose ul>li {\n    position: relative;\n    padding-left: 1.75em;\n  }\n  .sm\\:prose ul>li::before {\n    content: \"\";\n    position: absolute;\n    background-color: #d2d6dc;\n    border-radius: 50%;\n    width: 0.375em;\n    height: 0.375em;\n    top: calc(0.875em - 0.1875em);\n    left: 0.25em;\n  }\n  .sm\\:prose hr {\n    border-color: #e5e7eb;\n    border-top-width: 1px;\n    margin-top: 3em;\n    margin-bottom: 3em;\n  }\n  .sm\\:prose blockquote {\n    font-weight: 500;\n    font-style: italic;\n    color: #161e2e;\n    border-left-width: 0.25rem;\n    border-left-color: #e5e7eb;\n    quotes: \"\\201C\" \"\\201D\" \"\\2018\" \"\\2019\";\n    margin-top: 1.6em;\n    margin-bottom: 1.6em;\n    padding-left: 1em;\n  }\n  .sm\\:prose blockquote p:first-of-type::before {\n    content: open-quote;\n  }\n  .sm\\:prose blockquote p:last-of-type::after {\n    content: close-quote;\n  }\n  .sm\\:prose h1 {\n    color: #1a202c;\n    font-weight: 800;\n    font-size: 2.25em;\n    margin-top: 0;\n    margin-bottom: 0.8888889em;\n    line-height: 1.1111111;\n  }\n  .sm\\:prose h2 {\n    color: #1a202c;\n    font-weight: 700;\n    font-size: 1.5em;\n    margin-top: 2em;\n    margin-bottom: 1em;\n    line-height: 1.3333333;\n  }\n  .sm\\:prose h3 {\n    color: #1a202c;\n    font-weight: 600;\n    font-size: 1.25em;\n    margin-top: 1.6em;\n    margin-bottom: 0.6em;\n    line-height: 1.6;\n  }\n  .sm\\:prose h4 {\n    color: #1a202c;\n    font-weight: 600;\n    margin-top: 1.5em;\n    margin-bottom: 0.5em;\n    line-height: 1.5;\n  }\n  .sm\\:prose figure figcaption {\n    color: #6b7280;\n    font-size: 0.875em;\n    line-height: 1.4285714;\n    margin-top: 0.8571429em;\n  }\n  .sm\\:prose code {\n    color: #161e2e;\n    font-weight: 600;\n    font-size: 0.875em;\n  }\n  .sm\\:prose code::before {\n    content: \"`\";\n  }\n  .sm\\:prose code::after {\n    content: \"`\";\n  }\n  .sm\\:prose pre {\n    color: #e5e7eb;\n    background-color: #252f3f;\n    overflow-x: auto;\n    font-size: 0.875em;\n    line-height: 1.7142857;\n    margin-top: 1.7142857em;\n    margin-bottom: 1.7142857em;\n    border-radius: 0.375rem;\n    padding-top: 0.8571429em;\n    padding-right: 1.1428571em;\n    padding-bottom: 0.8571429em;\n    padding-left: 1.1428571em;\n  }\n  .sm\\:prose pre code {\n    background-color: transparent;\n    border-width: 0;\n    border-radius: 0;\n    padding: 0;\n    font-weight: 400;\n    color: inherit;\n    font-size: inherit;\n    font-family: inherit;\n    line-height: inherit;\n  }\n  .sm\\:prose pre code::before {\n    content: \"\";\n  }\n  .sm\\:prose pre code::after {\n    content: \"\";\n  }\n  .sm\\:prose table {\n    width: 100%;\n    table-layout: auto;\n    text-align: left;\n    margin-top: 2em;\n    margin-bottom: 2em;\n    font-size: 0.875em;\n    line-height: 1.7142857;\n  }\n  .sm\\:prose thead {\n    color: #161e2e;\n    font-weight: 600;\n    border-bottom-width: 1px;\n    border-bottom-color: #d2d6dc;\n  }\n  .sm\\:prose thead th {\n    vertical-align: bottom;\n    padding-right: 0.5714286em;\n    padding-bottom: 0.5714286em;\n    padding-left: 0.5714286em;\n  }\n  .sm\\:prose tbody tr {\n    border-bottom-width: 1px;\n    border-bottom-color: #e5e7eb;\n  }\n  .sm\\:prose tbody tr:last-child {\n    border-bottom-width: 0;\n  }\n  .sm\\:prose tbody td {\n    vertical-align: top;\n    padding-top: 0.5714286em;\n    padding-right: 0.5714286em;\n    padding-bottom: 0.5714286em;\n    padding-left: 0.5714286em;\n  }\n  .sm\\:prose {\n    font-size: 1rem;\n    line-height: 1.75;\n  }\n  .sm\\:prose p {\n    margin-top: 1.25em;\n    margin-bottom: 1.25em;\n  }\n  .sm\\:prose img {\n    margin-top: 2em;\n    margin-bottom: 2em;\n  }\n  .sm\\:prose video {\n    margin-top: 2em;\n    margin-bottom: 2em;\n  }\n  .sm\\:prose figure {\n    margin-top: 2em;\n    margin-bottom: 2em;\n  }\n  .sm\\:prose figure>* {\n    margin-top: 0;\n    margin-bottom: 0;\n  }\n  .sm\\:prose h2 code {\n    font-size: 0.875em;\n  }\n  .sm\\:prose h3 code {\n    font-size: 0.9em;\n  }\n  .sm\\:prose ul {\n    margin-top: 1.25em;\n    margin-bottom: 1.25em;\n  }\n  .sm\\:prose li {\n    margin-top: 0.5em;\n    margin-bottom: 0.5em;\n  }\n  .sm\\:prose ol>li:before {\n    left: 0;\n  }\n  .sm\\:prose>ul>li p {\n    margin-top: 0.75em;\n    margin-bottom: 0.75em;\n  }\n  .sm\\:prose>ul>li>*:first-child {\n    margin-top: 1.25em;\n  }\n  .sm\\:prose>ul>li>*:last-child {\n    margin-bottom: 1.25em;\n  }\n  .sm\\:prose>ol>li>*:first-child {\n    margin-top: 1.25em;\n  }\n  .sm\\:prose>ol>li>*:last-child {\n    margin-bottom: 1.25em;\n  }\n  .sm\\:prose ul ul, .sm\\:prose ul ol, .sm\\:prose ol ul, .sm\\:prose ol ol {\n    margin-top: 0.75em;\n    margin-bottom: 0.75em;\n  }\n  .sm\\:prose hr+* {\n    margin-top: 0;\n  }\n  .sm\\:prose h2+* {\n    margin-top: 0;\n  }\n  .sm\\:prose h3+* {\n    margin-top: 0;\n  }\n  .sm\\:prose h4+* {\n    margin-top: 0;\n  }\n  .sm\\:prose thead th:first-child {\n    padding-left: 0;\n  }\n  .sm\\:prose thead th:last-child {\n    padding-right: 0;\n  }\n  .sm\\:prose tbody td:first-child {\n    padding-left: 0;\n  }\n  .sm\\:prose tbody td:last-child {\n    padding-right: 0;\n  }\n  .sm\\:prose> :first-child {\n    margin-top: 0;\n  }\n  .sm\\:prose> :last-child {\n    margin-bottom: 0;\n  }\n  .sm\\:prose h1, .sm\\:prose h2, .sm\\:prose h3, .sm\\:prose h4 {\n    color: #161e2e;\n  }\n  .sm\\:prose-sm {\n    font-size: 0.875rem;\n    line-height: 1.7142857;\n  }\n  .sm\\:prose-sm p {\n    margin-top: 1.1428571em;\n    margin-bottom: 1.1428571em;\n  }\n  .sm\\:prose-sm [class~=\"lead\"] {\n    font-size: 1.2857143em;\n    line-height: 1.5555556;\n    margin-top: 0.8888889em;\n    margin-bottom: 0.8888889em;\n  }\n  .sm\\:prose-sm blockquote {\n    margin-top: 1.3333333em;\n    margin-bottom: 1.3333333em;\n    padding-left: 1.1111111em;\n  }\n  .sm\\:prose-sm h1 {\n    font-size: 2.1428571em;\n    margin-top: 0;\n    margin-bottom: 0.8em;\n    line-height: 1.2;\n  }\n  .sm\\:prose-sm h2 {\n    font-size: 1.4285714em;\n    margin-top: 1.6em;\n    margin-bottom: 0.8em;\n    line-height: 1.4;\n  }\n  .sm\\:prose-sm h3 {\n    font-size: 1.2857143em;\n    margin-top: 1.5555556em;\n    margin-bottom: 0.4444444em;\n    line-height: 1.5555556;\n  }\n  .sm\\:prose-sm h4 {\n    margin-top: 1.4285714em;\n    margin-bottom: 0.5714286em;\n    line-height: 1.4285714;\n  }\n  .sm\\:prose-sm img {\n    margin-top: 1.7142857em;\n    margin-bottom: 1.7142857em;\n  }\n  .sm\\:prose-sm video {\n    margin-top: 1.7142857em;\n    margin-bottom: 1.7142857em;\n  }\n  .sm\\:prose-sm figure {\n    margin-top: 1.7142857em;\n    margin-bottom: 1.7142857em;\n  }\n  .sm\\:prose-sm figure>* {\n    margin-top: 0;\n    margin-bottom: 0;\n  }\n  .sm\\:prose-sm figure figcaption {\n    font-size: 0.8571429em;\n    line-height: 1.3333333;\n    margin-top: 0.6666667em;\n  }\n  .sm\\:prose-sm code {\n    font-size: 0.8571429em;\n  }\n  .sm\\:prose-sm h2 code {\n    font-size: 0.9em;\n  }\n  .sm\\:prose-sm h3 code {\n    font-size: 0.8888889em;\n  }\n  .sm\\:prose-sm pre {\n    font-size: 0.8571429em;\n    line-height: 1.6666667;\n    margin-top: 1.6666667em;\n    margin-bottom: 1.6666667em;\n    border-radius: 0.25rem;\n    padding-top: 0.6666667em;\n    padding-right: 1em;\n    padding-bottom: 0.6666667em;\n    padding-left: 1em;\n  }\n  .sm\\:prose-sm ol {\n    margin-top: 1.1428571em;\n    margin-bottom: 1.1428571em;\n  }\n  .sm\\:prose-sm ul {\n    margin-top: 1.1428571em;\n    margin-bottom: 1.1428571em;\n  }\n  .sm\\:prose-sm li {\n    margin-top: 0.2857143em;\n    margin-bottom: 0.2857143em;\n  }\n  .sm\\:prose-sm ol>li {\n    padding-left: 1.5714286em;\n  }\n  .sm\\:prose-sm ol>li:before {\n    left: 0;\n  }\n  .sm\\:prose-sm ul>li {\n    padding-left: 1.5714286em;\n  }\n  .sm\\:prose-sm ul>li::before {\n    height: 0.3571429em;\n    width: 0.3571429em;\n    top: calc(0.8571429em - 0.1785714em);\n    left: 0.2142857em;\n  }\n  .sm\\:prose-sm>ul>li p {\n    margin-top: 0.5714286em;\n    margin-bottom: 0.5714286em;\n  }\n  .sm\\:prose-sm>ul>li>*:first-child {\n    margin-top: 1.1428571em;\n  }\n  .sm\\:prose-sm>ul>li>*:last-child {\n    margin-bottom: 1.1428571em;\n  }\n  .sm\\:prose-sm>ol>li>*:first-child {\n    margin-top: 1.1428571em;\n  }\n  .sm\\:prose-sm>ol>li>*:last-child {\n    margin-bottom: 1.1428571em;\n  }\n  .sm\\:prose-sm ul ul, .sm\\:prose-sm ul ol, .sm\\:prose-sm ol ul, .sm\\:prose-sm ol ol {\n    margin-top: 0.5714286em;\n    margin-bottom: 0.5714286em;\n  }\n  .sm\\:prose-sm hr {\n    margin-top: 2.8571429em;\n    margin-bottom: 2.8571429em;\n  }\n  .sm\\:prose-sm hr+* {\n    margin-top: 0;\n  }\n  .sm\\:prose-sm h2+* {\n    margin-top: 0;\n  }\n  .sm\\:prose-sm h3+* {\n    margin-top: 0;\n  }\n  .sm\\:prose-sm h4+* {\n    margin-top: 0;\n  }\n  .sm\\:prose-sm table {\n    font-size: 0.8571429em;\n    line-height: 1.5;\n  }\n  .sm\\:prose-sm thead th {\n    padding-right: 1em;\n    padding-bottom: 0.6666667em;\n    padding-left: 1em;\n  }\n  .sm\\:prose-sm thead th:first-child {\n    padding-left: 0;\n  }\n  .sm\\:prose-sm thead th:last-child {\n    padding-right: 0;\n  }\n  .sm\\:prose-sm tbody td {\n    padding-top: 0.6666667em;\n    padding-right: 1em;\n    padding-bottom: 0.6666667em;\n    padding-left: 1em;\n  }\n  .sm\\:prose-sm tbody td:first-child {\n    padding-left: 0;\n  }\n  .sm\\:prose-sm tbody td:last-child {\n    padding-right: 0;\n  }\n  .sm\\:prose-sm> :first-child {\n    margin-top: 0;\n  }\n  .sm\\:prose-sm> :last-child {\n    margin-bottom: 0;\n  }\n  .sm\\:prose-lg {\n    font-size: 1.125rem;\n    line-height: 1.7777778;\n  }\n  .sm\\:prose-lg p {\n    margin-top: 1.3333333em;\n    margin-bottom: 1.3333333em;\n  }\n  .sm\\:prose-lg [class~=\"lead\"] {\n    font-size: 1.2222222em;\n    line-height: 1.4545455;\n    margin-top: 1.0909091em;\n    margin-bottom: 1.0909091em;\n  }\n  .sm\\:prose-lg blockquote {\n    margin-top: 1.6666667em;\n    margin-bottom: 1.6666667em;\n    padding-left: 1em;\n  }\n  .sm\\:prose-lg h1 {\n    font-size: 2.6666667em;\n    margin-top: 0;\n    margin-bottom: 0.8333333em;\n    line-height: 1;\n  }\n  .sm\\:prose-lg h2 {\n    font-size: 1.6666667em;\n    margin-top: 1.8666667em;\n    margin-bottom: 1.0666667em;\n    line-height: 1.3333333;\n  }\n  .sm\\:prose-lg h3 {\n    font-size: 1.3333333em;\n    margin-top: 1.6666667em;\n    margin-bottom: 0.6666667em;\n    line-height: 1.5;\n  }\n  .sm\\:prose-lg h4 {\n    margin-top: 1.7777778em;\n    margin-bottom: 0.4444444em;\n    line-height: 1.5555556;\n  }\n  .sm\\:prose-lg img {\n    margin-top: 1.7777778em;\n    margin-bottom: 1.7777778em;\n  }\n  .sm\\:prose-lg video {\n    margin-top: 1.7777778em;\n    margin-bottom: 1.7777778em;\n  }\n  .sm\\:prose-lg figure {\n    margin-top: 1.7777778em;\n    margin-bottom: 1.7777778em;\n  }\n  .sm\\:prose-lg figure>* {\n    margin-top: 0;\n    margin-bottom: 0;\n  }\n  .sm\\:prose-lg figure figcaption {\n    font-size: 0.8888889em;\n    line-height: 1.5;\n    margin-top: 1em;\n  }\n  .sm\\:prose-lg code {\n    font-size: 0.8888889em;\n  }\n  .sm\\:prose-lg h2 code {\n    font-size: 0.8666667em;\n  }\n  .sm\\:prose-lg h3 code {\n    font-size: 0.875em;\n  }\n  .sm\\:prose-lg pre {\n    font-size: 0.8888889em;\n    line-height: 1.75;\n    margin-top: 2em;\n    margin-bottom: 2em;\n    border-radius: 0.375rem;\n    padding-top: 1em;\n    padding-right: 1.5em;\n    padding-bottom: 1em;\n    padding-left: 1.5em;\n  }\n  .sm\\:prose-lg ol {\n    margin-top: 1.3333333em;\n    margin-bottom: 1.3333333em;\n  }\n  .sm\\:prose-lg ul {\n    margin-top: 1.3333333em;\n    margin-bottom: 1.3333333em;\n  }\n  .sm\\:prose-lg li {\n    margin-top: 0.6666667em;\n    margin-bottom: 0.6666667em;\n  }\n  .sm\\:prose-lg ol>li {\n    padding-left: 1.6666667em;\n  }\n  .sm\\:prose-lg ol>li:before {\n    left: 0;\n  }\n  .sm\\:prose-lg ul>li {\n    padding-left: 1.6666667em;\n  }\n  .sm\\:prose-lg ul>li::before {\n    width: 0.3333333em;\n    height: 0.3333333em;\n    top: calc(0.8888889em - 0.1666667em);\n    left: 0.2222222em;\n  }\n  .sm\\:prose-lg>ul>li p {\n    margin-top: 0.8888889em;\n    margin-bottom: 0.8888889em;\n  }\n  .sm\\:prose-lg>ul>li>*:first-child {\n    margin-top: 1.3333333em;\n  }\n  .sm\\:prose-lg>ul>li>*:last-child {\n    margin-bottom: 1.3333333em;\n  }\n  .sm\\:prose-lg>ol>li>*:first-child {\n    margin-top: 1.3333333em;\n  }\n  .sm\\:prose-lg>ol>li>*:last-child {\n    margin-bottom: 1.3333333em;\n  }\n  .sm\\:prose-lg ul ul, .sm\\:prose-lg ul ol, .sm\\:prose-lg ol ul, .sm\\:prose-lg ol ol {\n    margin-top: 0.8888889em;\n    margin-bottom: 0.8888889em;\n  }\n  .sm\\:prose-lg hr {\n    margin-top: 3.1111111em;\n    margin-bottom: 3.1111111em;\n  }\n  .sm\\:prose-lg hr+* {\n    margin-top: 0;\n  }\n  .sm\\:prose-lg h2+* {\n    margin-top: 0;\n  }\n  .sm\\:prose-lg h3+* {\n    margin-top: 0;\n  }\n  .sm\\:prose-lg h4+* {\n    margin-top: 0;\n  }\n  .sm\\:prose-lg table {\n    font-size: 0.8888889em;\n    line-height: 1.5;\n  }\n  .sm\\:prose-lg thead th {\n    padding-right: 0.75em;\n    padding-bottom: 0.75em;\n    padding-left: 0.75em;\n  }\n  .sm\\:prose-lg thead th:first-child {\n    padding-left: 0;\n  }\n  .sm\\:prose-lg thead th:last-child {\n    padding-right: 0;\n  }\n  .sm\\:prose-lg tbody td {\n    padding-top: 0.75em;\n    padding-right: 0.75em;\n    padding-bottom: 0.75em;\n    padding-left: 0.75em;\n  }\n  .sm\\:prose-lg tbody td:first-child {\n    padding-left: 0;\n  }\n  .sm\\:prose-lg tbody td:last-child {\n    padding-right: 0;\n  }\n  .sm\\:prose-lg> :first-child {\n    margin-top: 0;\n  }\n  .sm\\:prose-lg> :last-child {\n    margin-bottom: 0;\n  }\n  .sm\\:prose-xl {\n    font-size: 1.25rem;\n    line-height: 1.8;\n  }\n  .sm\\:prose-xl p {\n    margin-top: 1.2em;\n    margin-bottom: 1.2em;\n  }\n  .sm\\:prose-xl [class~=\"lead\"] {\n    font-size: 1.2em;\n    line-height: 1.5;\n    margin-top: 1em;\n    margin-bottom: 1em;\n  }\n  .sm\\:prose-xl blockquote {\n    margin-top: 1.6em;\n    margin-bottom: 1.6em;\n    padding-left: 1.0666667em;\n  }\n  .sm\\:prose-xl h1 {\n    font-size: 2.8em;\n    margin-top: 0;\n    margin-bottom: 0.8571429em;\n    line-height: 1;\n  }\n  .sm\\:prose-xl h2 {\n    font-size: 1.8em;\n    margin-top: 1.5555556em;\n    margin-bottom: 0.8888889em;\n    line-height: 1.1111111;\n  }\n  .sm\\:prose-xl h3 {\n    font-size: 1.5em;\n    margin-top: 1.6em;\n    margin-bottom: 0.6666667em;\n    line-height: 1.3333333;\n  }\n  .sm\\:prose-xl h4 {\n    margin-top: 1.8em;\n    margin-bottom: 0.6em;\n    line-height: 1.6;\n  }\n  .sm\\:prose-xl img {\n    margin-top: 2em;\n    margin-bottom: 2em;\n  }\n  .sm\\:prose-xl video {\n    margin-top: 2em;\n    margin-bottom: 2em;\n  }\n  .sm\\:prose-xl figure {\n    margin-top: 2em;\n    margin-bottom: 2em;\n  }\n  .sm\\:prose-xl figure>* {\n    margin-top: 0;\n    margin-bottom: 0;\n  }\n  .sm\\:prose-xl figure figcaption {\n    font-size: 0.9em;\n    line-height: 1.5555556;\n    margin-top: 1em;\n  }\n  .sm\\:prose-xl code {\n    font-size: 0.9em;\n  }\n  .sm\\:prose-xl h2 code {\n    font-size: 0.8611111em;\n  }\n  .sm\\:prose-xl h3 code {\n    font-size: 0.9em;\n  }\n  .sm\\:prose-xl pre {\n    font-size: 0.9em;\n    line-height: 1.7777778;\n    margin-top: 2em;\n    margin-bottom: 2em;\n    border-radius: 0.5rem;\n    padding-top: 1.1111111em;\n    padding-right: 1.3333333em;\n    padding-bottom: 1.1111111em;\n    padding-left: 1.3333333em;\n  }\n  .sm\\:prose-xl ol {\n    margin-top: 1.2em;\n    margin-bottom: 1.2em;\n  }\n  .sm\\:prose-xl ul {\n    margin-top: 1.2em;\n    margin-bottom: 1.2em;\n  }\n  .sm\\:prose-xl li {\n    margin-top: 0.6em;\n    margin-bottom: 0.6em;\n  }\n  .sm\\:prose-xl ol>li {\n    padding-left: 1.8em;\n  }\n  .sm\\:prose-xl ol>li:before {\n    left: 0;\n  }\n  .sm\\:prose-xl ul>li {\n    padding-left: 1.8em;\n  }\n  .sm\\:prose-xl ul>li::before {\n    width: 0.35em;\n    height: 0.35em;\n    top: calc(0.9em - 0.175em);\n    left: 0.25em;\n  }\n  .sm\\:prose-xl>ul>li p {\n    margin-top: 0.8em;\n    margin-bottom: 0.8em;\n  }\n  .sm\\:prose-xl>ul>li>*:first-child {\n    margin-top: 1.2em;\n  }\n  .sm\\:prose-xl>ul>li>*:last-child {\n    margin-bottom: 1.2em;\n  }\n  .sm\\:prose-xl>ol>li>*:first-child {\n    margin-top: 1.2em;\n  }\n  .sm\\:prose-xl>ol>li>*:last-child {\n    margin-bottom: 1.2em;\n  }\n  .sm\\:prose-xl ul ul, .sm\\:prose-xl ul ol, .sm\\:prose-xl ol ul, .sm\\:prose-xl ol ol {\n    margin-top: 0.8em;\n    margin-bottom: 0.8em;\n  }\n  .sm\\:prose-xl hr {\n    margin-top: 2.8em;\n    margin-bottom: 2.8em;\n  }\n  .sm\\:prose-xl hr+* {\n    margin-top: 0;\n  }\n  .sm\\:prose-xl h2+* {\n    margin-top: 0;\n  }\n  .sm\\:prose-xl h3+* {\n    margin-top: 0;\n  }\n  .sm\\:prose-xl h4+* {\n    margin-top: 0;\n  }\n  .sm\\:prose-xl table {\n    font-size: 0.9em;\n    line-height: 1.5555556;\n  }\n  .sm\\:prose-xl thead th {\n    padding-right: 0.6666667em;\n    padding-bottom: 0.8888889em;\n    padding-left: 0.6666667em;\n  }\n  .sm\\:prose-xl thead th:first-child {\n    padding-left: 0;\n  }\n  .sm\\:prose-xl thead th:last-child {\n    padding-right: 0;\n  }\n  .sm\\:prose-xl tbody td {\n    padding-top: 0.8888889em;\n    padding-right: 0.6666667em;\n    padding-bottom: 0.8888889em;\n    padding-left: 0.6666667em;\n  }\n  .sm\\:prose-xl tbody td:first-child {\n    padding-left: 0;\n  }\n  .sm\\:prose-xl tbody td:last-child {\n    padding-right: 0;\n  }\n  .sm\\:prose-xl> :first-child {\n    margin-top: 0;\n  }\n  .sm\\:prose-xl> :last-child {\n    margin-bottom: 0;\n  }\n  .sm\\:prose-2xl {\n    font-size: 1.5rem;\n    line-height: 1.6666667;\n  }\n  .sm\\:prose-2xl p {\n    margin-top: 1.3333333em;\n    margin-bottom: 1.3333333em;\n  }\n  .sm\\:prose-2xl [class~=\"lead\"] {\n    font-size: 1.25em;\n    line-height: 1.4666667;\n    margin-top: 1.0666667em;\n    margin-bottom: 1.0666667em;\n  }\n  .sm\\:prose-2xl blockquote {\n    margin-top: 1.7777778em;\n    margin-bottom: 1.7777778em;\n    padding-left: 1.1111111em;\n  }\n  .sm\\:prose-2xl h1 {\n    font-size: 2.6666667em;\n    margin-top: 0;\n    margin-bottom: 0.875em;\n    line-height: 1;\n  }\n  .sm\\:prose-2xl h2 {\n    font-size: 2em;\n    margin-top: 1.5em;\n    margin-bottom: 0.8333333em;\n    line-height: 1.0833333;\n  }\n  .sm\\:prose-2xl h3 {\n    font-size: 1.5em;\n    margin-top: 1.5555556em;\n    margin-bottom: 0.6666667em;\n    line-height: 1.2222222;\n  }\n  .sm\\:prose-2xl h4 {\n    margin-top: 1.6666667em;\n    margin-bottom: 0.6666667em;\n    line-height: 1.5;\n  }\n  .sm\\:prose-2xl img {\n    margin-top: 2em;\n    margin-bottom: 2em;\n  }\n  .sm\\:prose-2xl video {\n    margin-top: 2em;\n    margin-bottom: 2em;\n  }\n  .sm\\:prose-2xl figure {\n    margin-top: 2em;\n    margin-bottom: 2em;\n  }\n  .sm\\:prose-2xl figure>* {\n    margin-top: 0;\n    margin-bottom: 0;\n  }\n  .sm\\:prose-2xl figure figcaption {\n    font-size: 0.8333333em;\n    line-height: 1.6;\n    margin-top: 1em;\n  }\n  .sm\\:prose-2xl code {\n    font-size: 0.8333333em;\n  }\n  .sm\\:prose-2xl h2 code {\n    font-size: 0.875em;\n  }\n  .sm\\:prose-2xl h3 code {\n    font-size: 0.8888889em;\n  }\n  .sm\\:prose-2xl pre {\n    font-size: 0.8333333em;\n    line-height: 1.8;\n    margin-top: 2em;\n    margin-bottom: 2em;\n    border-radius: 0.5rem;\n    padding-top: 1.2em;\n    padding-right: 1.6em;\n    padding-bottom: 1.2em;\n    padding-left: 1.6em;\n  }\n  .sm\\:prose-2xl ol {\n    margin-top: 1.3333333em;\n    margin-bottom: 1.3333333em;\n  }\n  .sm\\:prose-2xl ul {\n    margin-top: 1.3333333em;\n    margin-bottom: 1.3333333em;\n  }\n  .sm\\:prose-2xl li {\n    margin-top: 0.5em;\n    margin-bottom: 0.5em;\n  }\n  .sm\\:prose-2xl ol>li {\n    padding-left: 1.6666667em;\n  }\n  .sm\\:prose-2xl ol>li:before {\n    left: 0;\n  }\n  .sm\\:prose-2xl ul>li {\n    padding-left: 1.6666667em;\n  }\n  .sm\\:prose-2xl ul>li::before {\n    width: 0.3333333em;\n    height: 0.3333333em;\n    top: calc(0.8333333em - 0.1666667em);\n    left: 0.25em;\n  }\n  .sm\\:prose-2xl>ul>li p {\n    margin-top: 0.8333333em;\n    margin-bottom: 0.8333333em;\n  }\n  .sm\\:prose-2xl>ul>li>*:first-child {\n    margin-top: 1.3333333em;\n  }\n  .sm\\:prose-2xl>ul>li>*:last-child {\n    margin-bottom: 1.3333333em;\n  }\n  .sm\\:prose-2xl>ol>li>*:first-child {\n    margin-top: 1.3333333em;\n  }\n  .sm\\:prose-2xl>ol>li>*:last-child {\n    margin-bottom: 1.3333333em;\n  }\n  .sm\\:prose-2xl ul ul, .sm\\:prose-2xl ul ol, .sm\\:prose-2xl ol ul, .sm\\:prose-2xl ol ol {\n    margin-top: 0.6666667em;\n    margin-bottom: 0.6666667em;\n  }\n  .sm\\:prose-2xl hr {\n    margin-top: 3em;\n    margin-bottom: 3em;\n  }\n  .sm\\:prose-2xl hr+* {\n    margin-top: 0;\n  }\n  .sm\\:prose-2xl h2+* {\n    margin-top: 0;\n  }\n  .sm\\:prose-2xl h3+* {\n    margin-top: 0;\n  }\n  .sm\\:prose-2xl h4+* {\n    margin-top: 0;\n  }\n  .sm\\:prose-2xl table {\n    font-size: 0.8333333em;\n    line-height: 1.4;\n  }\n  .sm\\:prose-2xl thead th {\n    padding-right: 0.6em;\n    padding-bottom: 0.8em;\n    padding-left: 0.6em;\n  }\n  .sm\\:prose-2xl thead th:first-child {\n    padding-left: 0;\n  }\n  .sm\\:prose-2xl thead th:last-child {\n    padding-right: 0;\n  }\n  .sm\\:prose-2xl tbody td {\n    padding-top: 0.8em;\n    padding-right: 0.6em;\n    padding-bottom: 0.8em;\n    padding-left: 0.6em;\n  }\n  .sm\\:prose-2xl tbody td:first-child {\n    padding-left: 0;\n  }\n  .sm\\:prose-2xl tbody td:last-child {\n    padding-right: 0;\n  }\n  .sm\\:prose-2xl> :first-child {\n    margin-top: 0;\n  }\n  .sm\\:prose-2xl> :last-child {\n    margin-bottom: 0;\n  }\n  .sm\\:space-y-0> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(0px * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(0px * var(--space-y-reverse));\n  }\n  .sm\\:space-x-0> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(0px * var(--space-x-reverse));\n    margin-left: calc(0px * calc(1 - var(--space-x-reverse)));\n  }\n  .sm\\:space-y-1> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(0.25rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(0.25rem * var(--space-y-reverse));\n  }\n  .sm\\:space-x-1> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(0.25rem * var(--space-x-reverse));\n    margin-left: calc(0.25rem * calc(1 - var(--space-x-reverse)));\n  }\n  .sm\\:space-y-2> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(0.5rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(0.5rem * var(--space-y-reverse));\n  }\n  .sm\\:space-x-2> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(0.5rem * var(--space-x-reverse));\n    margin-left: calc(0.5rem * calc(1 - var(--space-x-reverse)));\n  }\n  .sm\\:space-y-3> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(0.75rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(0.75rem * var(--space-y-reverse));\n  }\n  .sm\\:space-x-3> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(0.75rem * var(--space-x-reverse));\n    margin-left: calc(0.75rem * calc(1 - var(--space-x-reverse)));\n  }\n  .sm\\:space-y-4> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(1rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(1rem * var(--space-y-reverse));\n  }\n  .sm\\:space-x-4> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(1rem * var(--space-x-reverse));\n    margin-left: calc(1rem * calc(1 - var(--space-x-reverse)));\n  }\n  .sm\\:space-y-5> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(1.25rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(1.25rem * var(--space-y-reverse));\n  }\n  .sm\\:space-x-5> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(1.25rem * var(--space-x-reverse));\n    margin-left: calc(1.25rem * calc(1 - var(--space-x-reverse)));\n  }\n  .sm\\:space-y-6> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(1.5rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(1.5rem * var(--space-y-reverse));\n  }\n  .sm\\:space-x-6> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(1.5rem * var(--space-x-reverse));\n    margin-left: calc(1.5rem * calc(1 - var(--space-x-reverse)));\n  }\n  .sm\\:space-y-7> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(1.75rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(1.75rem * var(--space-y-reverse));\n  }\n  .sm\\:space-x-7> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(1.75rem * var(--space-x-reverse));\n    margin-left: calc(1.75rem * calc(1 - var(--space-x-reverse)));\n  }\n  .sm\\:space-y-8> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(2rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(2rem * var(--space-y-reverse));\n  }\n  .sm\\:space-x-8> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(2rem * var(--space-x-reverse));\n    margin-left: calc(2rem * calc(1 - var(--space-x-reverse)));\n  }\n  .sm\\:space-y-9> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(2.25rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(2.25rem * var(--space-y-reverse));\n  }\n  .sm\\:space-x-9> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(2.25rem * var(--space-x-reverse));\n    margin-left: calc(2.25rem * calc(1 - var(--space-x-reverse)));\n  }\n  .sm\\:space-y-10> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(2.5rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(2.5rem * var(--space-y-reverse));\n  }\n  .sm\\:space-x-10> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(2.5rem * var(--space-x-reverse));\n    margin-left: calc(2.5rem * calc(1 - var(--space-x-reverse)));\n  }\n  .sm\\:space-y-11> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(2.75rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(2.75rem * var(--space-y-reverse));\n  }\n  .sm\\:space-x-11> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(2.75rem * var(--space-x-reverse));\n    margin-left: calc(2.75rem * calc(1 - var(--space-x-reverse)));\n  }\n  .sm\\:space-y-12> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(3rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(3rem * var(--space-y-reverse));\n  }\n  .sm\\:space-x-12> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(3rem * var(--space-x-reverse));\n    margin-left: calc(3rem * calc(1 - var(--space-x-reverse)));\n  }\n  .sm\\:space-y-13> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(3.25rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(3.25rem * var(--space-y-reverse));\n  }\n  .sm\\:space-x-13> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(3.25rem * var(--space-x-reverse));\n    margin-left: calc(3.25rem * calc(1 - var(--space-x-reverse)));\n  }\n  .sm\\:space-y-14> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(3.5rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(3.5rem * var(--space-y-reverse));\n  }\n  .sm\\:space-x-14> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(3.5rem * var(--space-x-reverse));\n    margin-left: calc(3.5rem * calc(1 - var(--space-x-reverse)));\n  }\n  .sm\\:space-y-15> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(3.75rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(3.75rem * var(--space-y-reverse));\n  }\n  .sm\\:space-x-15> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(3.75rem * var(--space-x-reverse));\n    margin-left: calc(3.75rem * calc(1 - var(--space-x-reverse)));\n  }\n  .sm\\:space-y-16> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(4rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(4rem * var(--space-y-reverse));\n  }\n  .sm\\:space-x-16> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(4rem * var(--space-x-reverse));\n    margin-left: calc(4rem * calc(1 - var(--space-x-reverse)));\n  }\n  .sm\\:space-y-20> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(5rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(5rem * var(--space-y-reverse));\n  }\n  .sm\\:space-x-20> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(5rem * var(--space-x-reverse));\n    margin-left: calc(5rem * calc(1 - var(--space-x-reverse)));\n  }\n  .sm\\:space-y-24> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(6rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(6rem * var(--space-y-reverse));\n  }\n  .sm\\:space-x-24> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(6rem * var(--space-x-reverse));\n    margin-left: calc(6rem * calc(1 - var(--space-x-reverse)));\n  }\n  .sm\\:space-y-28> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(7rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(7rem * var(--space-y-reverse));\n  }\n  .sm\\:space-x-28> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(7rem * var(--space-x-reverse));\n    margin-left: calc(7rem * calc(1 - var(--space-x-reverse)));\n  }\n  .sm\\:space-y-32> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(8rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(8rem * var(--space-y-reverse));\n  }\n  .sm\\:space-x-32> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(8rem * var(--space-x-reverse));\n    margin-left: calc(8rem * calc(1 - var(--space-x-reverse)));\n  }\n  .sm\\:space-y-36> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(9rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(9rem * var(--space-y-reverse));\n  }\n  .sm\\:space-x-36> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(9rem * var(--space-x-reverse));\n    margin-left: calc(9rem * calc(1 - var(--space-x-reverse)));\n  }\n  .sm\\:space-y-40> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(10rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(10rem * var(--space-y-reverse));\n  }\n  .sm\\:space-x-40> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(10rem * var(--space-x-reverse));\n    margin-left: calc(10rem * calc(1 - var(--space-x-reverse)));\n  }\n  .sm\\:space-y-44> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(11rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(11rem * var(--space-y-reverse));\n  }\n  .sm\\:space-x-44> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(11rem * var(--space-x-reverse));\n    margin-left: calc(11rem * calc(1 - var(--space-x-reverse)));\n  }\n  .sm\\:space-y-48> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(12rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(12rem * var(--space-y-reverse));\n  }\n  .sm\\:space-x-48> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(12rem * var(--space-x-reverse));\n    margin-left: calc(12rem * calc(1 - var(--space-x-reverse)));\n  }\n  .sm\\:space-y-52> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(13rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(13rem * var(--space-y-reverse));\n  }\n  .sm\\:space-x-52> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(13rem * var(--space-x-reverse));\n    margin-left: calc(13rem * calc(1 - var(--space-x-reverse)));\n  }\n  .sm\\:space-y-56> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(14rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(14rem * var(--space-y-reverse));\n  }\n  .sm\\:space-x-56> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(14rem * var(--space-x-reverse));\n    margin-left: calc(14rem * calc(1 - var(--space-x-reverse)));\n  }\n  .sm\\:space-y-60> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(15rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(15rem * var(--space-y-reverse));\n  }\n  .sm\\:space-x-60> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(15rem * var(--space-x-reverse));\n    margin-left: calc(15rem * calc(1 - var(--space-x-reverse)));\n  }\n  .sm\\:space-y-64> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(16rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(16rem * var(--space-y-reverse));\n  }\n  .sm\\:space-x-64> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(16rem * var(--space-x-reverse));\n    margin-left: calc(16rem * calc(1 - var(--space-x-reverse)));\n  }\n  .sm\\:space-y-72> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(18rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(18rem * var(--space-y-reverse));\n  }\n  .sm\\:space-x-72> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(18rem * var(--space-x-reverse));\n    margin-left: calc(18rem * calc(1 - var(--space-x-reverse)));\n  }\n  .sm\\:space-y-80> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(20rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(20rem * var(--space-y-reverse));\n  }\n  .sm\\:space-x-80> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(20rem * var(--space-x-reverse));\n    margin-left: calc(20rem * calc(1 - var(--space-x-reverse)));\n  }\n  .sm\\:space-y-96> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(24rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(24rem * var(--space-y-reverse));\n  }\n  .sm\\:space-x-96> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(24rem * var(--space-x-reverse));\n    margin-left: calc(24rem * calc(1 - var(--space-x-reverse)));\n  }\n  .sm\\:space-y-px> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(1px * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(1px * var(--space-y-reverse));\n  }\n  .sm\\:space-x-px> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(1px * var(--space-x-reverse));\n    margin-left: calc(1px * calc(1 - var(--space-x-reverse)));\n  }\n  .sm\\:space-y-0\\.5> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(0.125rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(0.125rem * var(--space-y-reverse));\n  }\n  .sm\\:space-x-0\\.5> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(0.125rem * var(--space-x-reverse));\n    margin-left: calc(0.125rem * calc(1 - var(--space-x-reverse)));\n  }\n  .sm\\:space-y-1\\.5> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(0.375rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(0.375rem * var(--space-y-reverse));\n  }\n  .sm\\:space-x-1\\.5> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(0.375rem * var(--space-x-reverse));\n    margin-left: calc(0.375rem * calc(1 - var(--space-x-reverse)));\n  }\n  .sm\\:space-y-2\\.5> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(0.625rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(0.625rem * var(--space-y-reverse));\n  }\n  .sm\\:space-x-2\\.5> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(0.625rem * var(--space-x-reverse));\n    margin-left: calc(0.625rem * calc(1 - var(--space-x-reverse)));\n  }\n  .sm\\:space-y-3\\.5> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(0.875rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(0.875rem * var(--space-y-reverse));\n  }\n  .sm\\:space-x-3\\.5> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(0.875rem * var(--space-x-reverse));\n    margin-left: calc(0.875rem * calc(1 - var(--space-x-reverse)));\n  }\n  .sm\\:space-y-1\\/2> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(50% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(50% * var(--space-y-reverse));\n  }\n  .sm\\:space-x-1\\/2> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(50% * var(--space-x-reverse));\n    margin-left: calc(50% * calc(1 - var(--space-x-reverse)));\n  }\n  .sm\\:space-y-1\\/3> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(33.333333% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(33.333333% * var(--space-y-reverse));\n  }\n  .sm\\:space-x-1\\/3> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(33.333333% * var(--space-x-reverse));\n    margin-left: calc(33.333333% * calc(1 - var(--space-x-reverse)));\n  }\n  .sm\\:space-y-2\\/3> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(66.666667% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(66.666667% * var(--space-y-reverse));\n  }\n  .sm\\:space-x-2\\/3> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(66.666667% * var(--space-x-reverse));\n    margin-left: calc(66.666667% * calc(1 - var(--space-x-reverse)));\n  }\n  .sm\\:space-y-1\\/4> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(25% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(25% * var(--space-y-reverse));\n  }\n  .sm\\:space-x-1\\/4> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(25% * var(--space-x-reverse));\n    margin-left: calc(25% * calc(1 - var(--space-x-reverse)));\n  }\n  .sm\\:space-y-2\\/4> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(50% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(50% * var(--space-y-reverse));\n  }\n  .sm\\:space-x-2\\/4> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(50% * var(--space-x-reverse));\n    margin-left: calc(50% * calc(1 - var(--space-x-reverse)));\n  }\n  .sm\\:space-y-3\\/4> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(75% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(75% * var(--space-y-reverse));\n  }\n  .sm\\:space-x-3\\/4> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(75% * var(--space-x-reverse));\n    margin-left: calc(75% * calc(1 - var(--space-x-reverse)));\n  }\n  .sm\\:space-y-1\\/5> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(20% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(20% * var(--space-y-reverse));\n  }\n  .sm\\:space-x-1\\/5> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(20% * var(--space-x-reverse));\n    margin-left: calc(20% * calc(1 - var(--space-x-reverse)));\n  }\n  .sm\\:space-y-2\\/5> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(40% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(40% * var(--space-y-reverse));\n  }\n  .sm\\:space-x-2\\/5> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(40% * var(--space-x-reverse));\n    margin-left: calc(40% * calc(1 - var(--space-x-reverse)));\n  }\n  .sm\\:space-y-3\\/5> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(60% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(60% * var(--space-y-reverse));\n  }\n  .sm\\:space-x-3\\/5> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(60% * var(--space-x-reverse));\n    margin-left: calc(60% * calc(1 - var(--space-x-reverse)));\n  }\n  .sm\\:space-y-4\\/5> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(80% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(80% * var(--space-y-reverse));\n  }\n  .sm\\:space-x-4\\/5> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(80% * var(--space-x-reverse));\n    margin-left: calc(80% * calc(1 - var(--space-x-reverse)));\n  }\n  .sm\\:space-y-1\\/6> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(16.666667% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(16.666667% * var(--space-y-reverse));\n  }\n  .sm\\:space-x-1\\/6> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(16.666667% * var(--space-x-reverse));\n    margin-left: calc(16.666667% * calc(1 - var(--space-x-reverse)));\n  }\n  .sm\\:space-y-2\\/6> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(33.333333% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(33.333333% * var(--space-y-reverse));\n  }\n  .sm\\:space-x-2\\/6> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(33.333333% * var(--space-x-reverse));\n    margin-left: calc(33.333333% * calc(1 - var(--space-x-reverse)));\n  }\n  .sm\\:space-y-3\\/6> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(50% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(50% * var(--space-y-reverse));\n  }\n  .sm\\:space-x-3\\/6> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(50% * var(--space-x-reverse));\n    margin-left: calc(50% * calc(1 - var(--space-x-reverse)));\n  }\n  .sm\\:space-y-4\\/6> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(66.666667% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(66.666667% * var(--space-y-reverse));\n  }\n  .sm\\:space-x-4\\/6> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(66.666667% * var(--space-x-reverse));\n    margin-left: calc(66.666667% * calc(1 - var(--space-x-reverse)));\n  }\n  .sm\\:space-y-5\\/6> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(83.333333% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(83.333333% * var(--space-y-reverse));\n  }\n  .sm\\:space-x-5\\/6> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(83.333333% * var(--space-x-reverse));\n    margin-left: calc(83.333333% * calc(1 - var(--space-x-reverse)));\n  }\n  .sm\\:space-y-1\\/12> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(8.333333% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(8.333333% * var(--space-y-reverse));\n  }\n  .sm\\:space-x-1\\/12> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(8.333333% * var(--space-x-reverse));\n    margin-left: calc(8.333333% * calc(1 - var(--space-x-reverse)));\n  }\n  .sm\\:space-y-2\\/12> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(16.666667% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(16.666667% * var(--space-y-reverse));\n  }\n  .sm\\:space-x-2\\/12> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(16.666667% * var(--space-x-reverse));\n    margin-left: calc(16.666667% * calc(1 - var(--space-x-reverse)));\n  }\n  .sm\\:space-y-3\\/12> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(25% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(25% * var(--space-y-reverse));\n  }\n  .sm\\:space-x-3\\/12> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(25% * var(--space-x-reverse));\n    margin-left: calc(25% * calc(1 - var(--space-x-reverse)));\n  }\n  .sm\\:space-y-4\\/12> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(33.333333% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(33.333333% * var(--space-y-reverse));\n  }\n  .sm\\:space-x-4\\/12> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(33.333333% * var(--space-x-reverse));\n    margin-left: calc(33.333333% * calc(1 - var(--space-x-reverse)));\n  }\n  .sm\\:space-y-5\\/12> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(41.666667% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(41.666667% * var(--space-y-reverse));\n  }\n  .sm\\:space-x-5\\/12> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(41.666667% * var(--space-x-reverse));\n    margin-left: calc(41.666667% * calc(1 - var(--space-x-reverse)));\n  }\n  .sm\\:space-y-6\\/12> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(50% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(50% * var(--space-y-reverse));\n  }\n  .sm\\:space-x-6\\/12> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(50% * var(--space-x-reverse));\n    margin-left: calc(50% * calc(1 - var(--space-x-reverse)));\n  }\n  .sm\\:space-y-7\\/12> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(58.333333% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(58.333333% * var(--space-y-reverse));\n  }\n  .sm\\:space-x-7\\/12> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(58.333333% * var(--space-x-reverse));\n    margin-left: calc(58.333333% * calc(1 - var(--space-x-reverse)));\n  }\n  .sm\\:space-y-8\\/12> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(66.666667% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(66.666667% * var(--space-y-reverse));\n  }\n  .sm\\:space-x-8\\/12> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(66.666667% * var(--space-x-reverse));\n    margin-left: calc(66.666667% * calc(1 - var(--space-x-reverse)));\n  }\n  .sm\\:space-y-9\\/12> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(75% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(75% * var(--space-y-reverse));\n  }\n  .sm\\:space-x-9\\/12> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(75% * var(--space-x-reverse));\n    margin-left: calc(75% * calc(1 - var(--space-x-reverse)));\n  }\n  .sm\\:space-y-10\\/12> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(83.333333% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(83.333333% * var(--space-y-reverse));\n  }\n  .sm\\:space-x-10\\/12> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(83.333333% * var(--space-x-reverse));\n    margin-left: calc(83.333333% * calc(1 - var(--space-x-reverse)));\n  }\n  .sm\\:space-y-11\\/12> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(91.666667% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(91.666667% * var(--space-y-reverse));\n  }\n  .sm\\:space-x-11\\/12> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(91.666667% * var(--space-x-reverse));\n    margin-left: calc(91.666667% * calc(1 - var(--space-x-reverse)));\n  }\n  .sm\\:space-y-full> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(100% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(100% * var(--space-y-reverse));\n  }\n  .sm\\:space-x-full> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(100% * var(--space-x-reverse));\n    margin-left: calc(100% * calc(1 - var(--space-x-reverse)));\n  }\n  .sm\\:-space-y-1> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-0.25rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-0.25rem * var(--space-y-reverse));\n  }\n  .sm\\:-space-x-1> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-0.25rem * var(--space-x-reverse));\n    margin-left: calc(-0.25rem * calc(1 - var(--space-x-reverse)));\n  }\n  .sm\\:-space-y-2> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-0.5rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-0.5rem * var(--space-y-reverse));\n  }\n  .sm\\:-space-x-2> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-0.5rem * var(--space-x-reverse));\n    margin-left: calc(-0.5rem * calc(1 - var(--space-x-reverse)));\n  }\n  .sm\\:-space-y-3> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-0.75rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-0.75rem * var(--space-y-reverse));\n  }\n  .sm\\:-space-x-3> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-0.75rem * var(--space-x-reverse));\n    margin-left: calc(-0.75rem * calc(1 - var(--space-x-reverse)));\n  }\n  .sm\\:-space-y-4> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-1rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-1rem * var(--space-y-reverse));\n  }\n  .sm\\:-space-x-4> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-1rem * var(--space-x-reverse));\n    margin-left: calc(-1rem * calc(1 - var(--space-x-reverse)));\n  }\n  .sm\\:-space-y-5> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-1.25rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-1.25rem * var(--space-y-reverse));\n  }\n  .sm\\:-space-x-5> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-1.25rem * var(--space-x-reverse));\n    margin-left: calc(-1.25rem * calc(1 - var(--space-x-reverse)));\n  }\n  .sm\\:-space-y-6> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-1.5rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-1.5rem * var(--space-y-reverse));\n  }\n  .sm\\:-space-x-6> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-1.5rem * var(--space-x-reverse));\n    margin-left: calc(-1.5rem * calc(1 - var(--space-x-reverse)));\n  }\n  .sm\\:-space-y-7> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-1.75rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-1.75rem * var(--space-y-reverse));\n  }\n  .sm\\:-space-x-7> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-1.75rem * var(--space-x-reverse));\n    margin-left: calc(-1.75rem * calc(1 - var(--space-x-reverse)));\n  }\n  .sm\\:-space-y-8> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-2rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-2rem * var(--space-y-reverse));\n  }\n  .sm\\:-space-x-8> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-2rem * var(--space-x-reverse));\n    margin-left: calc(-2rem * calc(1 - var(--space-x-reverse)));\n  }\n  .sm\\:-space-y-9> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-2.25rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-2.25rem * var(--space-y-reverse));\n  }\n  .sm\\:-space-x-9> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-2.25rem * var(--space-x-reverse));\n    margin-left: calc(-2.25rem * calc(1 - var(--space-x-reverse)));\n  }\n  .sm\\:-space-y-10> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-2.5rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-2.5rem * var(--space-y-reverse));\n  }\n  .sm\\:-space-x-10> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-2.5rem * var(--space-x-reverse));\n    margin-left: calc(-2.5rem * calc(1 - var(--space-x-reverse)));\n  }\n  .sm\\:-space-y-11> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-2.75rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-2.75rem * var(--space-y-reverse));\n  }\n  .sm\\:-space-x-11> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-2.75rem * var(--space-x-reverse));\n    margin-left: calc(-2.75rem * calc(1 - var(--space-x-reverse)));\n  }\n  .sm\\:-space-y-12> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-3rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-3rem * var(--space-y-reverse));\n  }\n  .sm\\:-space-x-12> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-3rem * var(--space-x-reverse));\n    margin-left: calc(-3rem * calc(1 - var(--space-x-reverse)));\n  }\n  .sm\\:-space-y-13> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-3.25rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-3.25rem * var(--space-y-reverse));\n  }\n  .sm\\:-space-x-13> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-3.25rem * var(--space-x-reverse));\n    margin-left: calc(-3.25rem * calc(1 - var(--space-x-reverse)));\n  }\n  .sm\\:-space-y-14> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-3.5rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-3.5rem * var(--space-y-reverse));\n  }\n  .sm\\:-space-x-14> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-3.5rem * var(--space-x-reverse));\n    margin-left: calc(-3.5rem * calc(1 - var(--space-x-reverse)));\n  }\n  .sm\\:-space-y-15> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-3.75rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-3.75rem * var(--space-y-reverse));\n  }\n  .sm\\:-space-x-15> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-3.75rem * var(--space-x-reverse));\n    margin-left: calc(-3.75rem * calc(1 - var(--space-x-reverse)));\n  }\n  .sm\\:-space-y-16> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-4rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-4rem * var(--space-y-reverse));\n  }\n  .sm\\:-space-x-16> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-4rem * var(--space-x-reverse));\n    margin-left: calc(-4rem * calc(1 - var(--space-x-reverse)));\n  }\n  .sm\\:-space-y-20> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-5rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-5rem * var(--space-y-reverse));\n  }\n  .sm\\:-space-x-20> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-5rem * var(--space-x-reverse));\n    margin-left: calc(-5rem * calc(1 - var(--space-x-reverse)));\n  }\n  .sm\\:-space-y-24> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-6rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-6rem * var(--space-y-reverse));\n  }\n  .sm\\:-space-x-24> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-6rem * var(--space-x-reverse));\n    margin-left: calc(-6rem * calc(1 - var(--space-x-reverse)));\n  }\n  .sm\\:-space-y-28> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-7rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-7rem * var(--space-y-reverse));\n  }\n  .sm\\:-space-x-28> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-7rem * var(--space-x-reverse));\n    margin-left: calc(-7rem * calc(1 - var(--space-x-reverse)));\n  }\n  .sm\\:-space-y-32> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-8rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-8rem * var(--space-y-reverse));\n  }\n  .sm\\:-space-x-32> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-8rem * var(--space-x-reverse));\n    margin-left: calc(-8rem * calc(1 - var(--space-x-reverse)));\n  }\n  .sm\\:-space-y-36> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-9rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-9rem * var(--space-y-reverse));\n  }\n  .sm\\:-space-x-36> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-9rem * var(--space-x-reverse));\n    margin-left: calc(-9rem * calc(1 - var(--space-x-reverse)));\n  }\n  .sm\\:-space-y-40> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-10rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-10rem * var(--space-y-reverse));\n  }\n  .sm\\:-space-x-40> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-10rem * var(--space-x-reverse));\n    margin-left: calc(-10rem * calc(1 - var(--space-x-reverse)));\n  }\n  .sm\\:-space-y-44> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-11rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-11rem * var(--space-y-reverse));\n  }\n  .sm\\:-space-x-44> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-11rem * var(--space-x-reverse));\n    margin-left: calc(-11rem * calc(1 - var(--space-x-reverse)));\n  }\n  .sm\\:-space-y-48> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-12rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-12rem * var(--space-y-reverse));\n  }\n  .sm\\:-space-x-48> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-12rem * var(--space-x-reverse));\n    margin-left: calc(-12rem * calc(1 - var(--space-x-reverse)));\n  }\n  .sm\\:-space-y-52> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-13rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-13rem * var(--space-y-reverse));\n  }\n  .sm\\:-space-x-52> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-13rem * var(--space-x-reverse));\n    margin-left: calc(-13rem * calc(1 - var(--space-x-reverse)));\n  }\n  .sm\\:-space-y-56> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-14rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-14rem * var(--space-y-reverse));\n  }\n  .sm\\:-space-x-56> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-14rem * var(--space-x-reverse));\n    margin-left: calc(-14rem * calc(1 - var(--space-x-reverse)));\n  }\n  .sm\\:-space-y-60> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-15rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-15rem * var(--space-y-reverse));\n  }\n  .sm\\:-space-x-60> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-15rem * var(--space-x-reverse));\n    margin-left: calc(-15rem * calc(1 - var(--space-x-reverse)));\n  }\n  .sm\\:-space-y-64> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-16rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-16rem * var(--space-y-reverse));\n  }\n  .sm\\:-space-x-64> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-16rem * var(--space-x-reverse));\n    margin-left: calc(-16rem * calc(1 - var(--space-x-reverse)));\n  }\n  .sm\\:-space-y-72> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-18rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-18rem * var(--space-y-reverse));\n  }\n  .sm\\:-space-x-72> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-18rem * var(--space-x-reverse));\n    margin-left: calc(-18rem * calc(1 - var(--space-x-reverse)));\n  }\n  .sm\\:-space-y-80> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-20rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-20rem * var(--space-y-reverse));\n  }\n  .sm\\:-space-x-80> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-20rem * var(--space-x-reverse));\n    margin-left: calc(-20rem * calc(1 - var(--space-x-reverse)));\n  }\n  .sm\\:-space-y-96> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-24rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-24rem * var(--space-y-reverse));\n  }\n  .sm\\:-space-x-96> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-24rem * var(--space-x-reverse));\n    margin-left: calc(-24rem * calc(1 - var(--space-x-reverse)));\n  }\n  .sm\\:-space-y-px> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-1px * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-1px * var(--space-y-reverse));\n  }\n  .sm\\:-space-x-px> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-1px * var(--space-x-reverse));\n    margin-left: calc(-1px * calc(1 - var(--space-x-reverse)));\n  }\n  .sm\\:-space-y-0\\.5> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-0.125rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-0.125rem * var(--space-y-reverse));\n  }\n  .sm\\:-space-x-0\\.5> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-0.125rem * var(--space-x-reverse));\n    margin-left: calc(-0.125rem * calc(1 - var(--space-x-reverse)));\n  }\n  .sm\\:-space-y-1\\.5> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-0.375rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-0.375rem * var(--space-y-reverse));\n  }\n  .sm\\:-space-x-1\\.5> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-0.375rem * var(--space-x-reverse));\n    margin-left: calc(-0.375rem * calc(1 - var(--space-x-reverse)));\n  }\n  .sm\\:-space-y-2\\.5> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-0.625rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-0.625rem * var(--space-y-reverse));\n  }\n  .sm\\:-space-x-2\\.5> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-0.625rem * var(--space-x-reverse));\n    margin-left: calc(-0.625rem * calc(1 - var(--space-x-reverse)));\n  }\n  .sm\\:-space-y-3\\.5> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-0.875rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-0.875rem * var(--space-y-reverse));\n  }\n  .sm\\:-space-x-3\\.5> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-0.875rem * var(--space-x-reverse));\n    margin-left: calc(-0.875rem * calc(1 - var(--space-x-reverse)));\n  }\n  .sm\\:-space-y-1\\/2> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-50% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-50% * var(--space-y-reverse));\n  }\n  .sm\\:-space-x-1\\/2> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-50% * var(--space-x-reverse));\n    margin-left: calc(-50% * calc(1 - var(--space-x-reverse)));\n  }\n  .sm\\:-space-y-1\\/3> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-33.33333% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-33.33333% * var(--space-y-reverse));\n  }\n  .sm\\:-space-x-1\\/3> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-33.33333% * var(--space-x-reverse));\n    margin-left: calc(-33.33333% * calc(1 - var(--space-x-reverse)));\n  }\n  .sm\\:-space-y-2\\/3> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-66.66667% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-66.66667% * var(--space-y-reverse));\n  }\n  .sm\\:-space-x-2\\/3> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-66.66667% * var(--space-x-reverse));\n    margin-left: calc(-66.66667% * calc(1 - var(--space-x-reverse)));\n  }\n  .sm\\:-space-y-1\\/4> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-25% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-25% * var(--space-y-reverse));\n  }\n  .sm\\:-space-x-1\\/4> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-25% * var(--space-x-reverse));\n    margin-left: calc(-25% * calc(1 - var(--space-x-reverse)));\n  }\n  .sm\\:-space-y-2\\/4> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-50% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-50% * var(--space-y-reverse));\n  }\n  .sm\\:-space-x-2\\/4> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-50% * var(--space-x-reverse));\n    margin-left: calc(-50% * calc(1 - var(--space-x-reverse)));\n  }\n  .sm\\:-space-y-3\\/4> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-75% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-75% * var(--space-y-reverse));\n  }\n  .sm\\:-space-x-3\\/4> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-75% * var(--space-x-reverse));\n    margin-left: calc(-75% * calc(1 - var(--space-x-reverse)));\n  }\n  .sm\\:-space-y-1\\/5> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-20% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-20% * var(--space-y-reverse));\n  }\n  .sm\\:-space-x-1\\/5> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-20% * var(--space-x-reverse));\n    margin-left: calc(-20% * calc(1 - var(--space-x-reverse)));\n  }\n  .sm\\:-space-y-2\\/5> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-40% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-40% * var(--space-y-reverse));\n  }\n  .sm\\:-space-x-2\\/5> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-40% * var(--space-x-reverse));\n    margin-left: calc(-40% * calc(1 - var(--space-x-reverse)));\n  }\n  .sm\\:-space-y-3\\/5> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-60% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-60% * var(--space-y-reverse));\n  }\n  .sm\\:-space-x-3\\/5> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-60% * var(--space-x-reverse));\n    margin-left: calc(-60% * calc(1 - var(--space-x-reverse)));\n  }\n  .sm\\:-space-y-4\\/5> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-80% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-80% * var(--space-y-reverse));\n  }\n  .sm\\:-space-x-4\\/5> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-80% * var(--space-x-reverse));\n    margin-left: calc(-80% * calc(1 - var(--space-x-reverse)));\n  }\n  .sm\\:-space-y-1\\/6> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-16.66667% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-16.66667% * var(--space-y-reverse));\n  }\n  .sm\\:-space-x-1\\/6> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-16.66667% * var(--space-x-reverse));\n    margin-left: calc(-16.66667% * calc(1 - var(--space-x-reverse)));\n  }\n  .sm\\:-space-y-2\\/6> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-33.33333% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-33.33333% * var(--space-y-reverse));\n  }\n  .sm\\:-space-x-2\\/6> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-33.33333% * var(--space-x-reverse));\n    margin-left: calc(-33.33333% * calc(1 - var(--space-x-reverse)));\n  }\n  .sm\\:-space-y-3\\/6> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-50% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-50% * var(--space-y-reverse));\n  }\n  .sm\\:-space-x-3\\/6> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-50% * var(--space-x-reverse));\n    margin-left: calc(-50% * calc(1 - var(--space-x-reverse)));\n  }\n  .sm\\:-space-y-4\\/6> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-66.66667% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-66.66667% * var(--space-y-reverse));\n  }\n  .sm\\:-space-x-4\\/6> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-66.66667% * var(--space-x-reverse));\n    margin-left: calc(-66.66667% * calc(1 - var(--space-x-reverse)));\n  }\n  .sm\\:-space-y-5\\/6> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-83.33333% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-83.33333% * var(--space-y-reverse));\n  }\n  .sm\\:-space-x-5\\/6> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-83.33333% * var(--space-x-reverse));\n    margin-left: calc(-83.33333% * calc(1 - var(--space-x-reverse)));\n  }\n  .sm\\:-space-y-1\\/12> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-8.33333% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-8.33333% * var(--space-y-reverse));\n  }\n  .sm\\:-space-x-1\\/12> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-8.33333% * var(--space-x-reverse));\n    margin-left: calc(-8.33333% * calc(1 - var(--space-x-reverse)));\n  }\n  .sm\\:-space-y-2\\/12> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-16.66667% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-16.66667% * var(--space-y-reverse));\n  }\n  .sm\\:-space-x-2\\/12> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-16.66667% * var(--space-x-reverse));\n    margin-left: calc(-16.66667% * calc(1 - var(--space-x-reverse)));\n  }\n  .sm\\:-space-y-3\\/12> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-25% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-25% * var(--space-y-reverse));\n  }\n  .sm\\:-space-x-3\\/12> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-25% * var(--space-x-reverse));\n    margin-left: calc(-25% * calc(1 - var(--space-x-reverse)));\n  }\n  .sm\\:-space-y-4\\/12> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-33.33333% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-33.33333% * var(--space-y-reverse));\n  }\n  .sm\\:-space-x-4\\/12> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-33.33333% * var(--space-x-reverse));\n    margin-left: calc(-33.33333% * calc(1 - var(--space-x-reverse)));\n  }\n  .sm\\:-space-y-5\\/12> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-41.66667% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-41.66667% * var(--space-y-reverse));\n  }\n  .sm\\:-space-x-5\\/12> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-41.66667% * var(--space-x-reverse));\n    margin-left: calc(-41.66667% * calc(1 - var(--space-x-reverse)));\n  }\n  .sm\\:-space-y-6\\/12> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-50% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-50% * var(--space-y-reverse));\n  }\n  .sm\\:-space-x-6\\/12> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-50% * var(--space-x-reverse));\n    margin-left: calc(-50% * calc(1 - var(--space-x-reverse)));\n  }\n  .sm\\:-space-y-7\\/12> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-58.33333% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-58.33333% * var(--space-y-reverse));\n  }\n  .sm\\:-space-x-7\\/12> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-58.33333% * var(--space-x-reverse));\n    margin-left: calc(-58.33333% * calc(1 - var(--space-x-reverse)));\n  }\n  .sm\\:-space-y-8\\/12> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-66.66667% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-66.66667% * var(--space-y-reverse));\n  }\n  .sm\\:-space-x-8\\/12> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-66.66667% * var(--space-x-reverse));\n    margin-left: calc(-66.66667% * calc(1 - var(--space-x-reverse)));\n  }\n  .sm\\:-space-y-9\\/12> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-75% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-75% * var(--space-y-reverse));\n  }\n  .sm\\:-space-x-9\\/12> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-75% * var(--space-x-reverse));\n    margin-left: calc(-75% * calc(1 - var(--space-x-reverse)));\n  }\n  .sm\\:-space-y-10\\/12> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-83.33333% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-83.33333% * var(--space-y-reverse));\n  }\n  .sm\\:-space-x-10\\/12> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-83.33333% * var(--space-x-reverse));\n    margin-left: calc(-83.33333% * calc(1 - var(--space-x-reverse)));\n  }\n  .sm\\:-space-y-11\\/12> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-91.66667% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-91.66667% * var(--space-y-reverse));\n  }\n  .sm\\:-space-x-11\\/12> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-91.66667% * var(--space-x-reverse));\n    margin-left: calc(-91.66667% * calc(1 - var(--space-x-reverse)));\n  }\n  .sm\\:-space-y-full> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-100% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-100% * var(--space-y-reverse));\n  }\n  .sm\\:-space-x-full> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-100% * var(--space-x-reverse));\n    margin-left: calc(-100% * calc(1 - var(--space-x-reverse)));\n  }\n  .sm\\:space-y-reverse> :not(template)~ :not(template) {\n    --space-y-reverse: 1;\n  }\n  .sm\\:space-x-reverse> :not(template)~ :not(template) {\n    --space-x-reverse: 1;\n  }\n  .sm\\:divide-y-0> :not(template)~ :not(template) {\n    --divide-y-reverse: 0;\n    border-top-width: calc(0px * calc(1 - var(--divide-y-reverse)));\n    border-bottom-width: calc(0px * var(--divide-y-reverse));\n  }\n  .sm\\:divide-x-0> :not(template)~ :not(template) {\n    --divide-x-reverse: 0;\n    border-right-width: calc(0px * var(--divide-x-reverse));\n    border-left-width: calc(0px * calc(1 - var(--divide-x-reverse)));\n  }\n  .sm\\:divide-y-2> :not(template)~ :not(template) {\n    --divide-y-reverse: 0;\n    border-top-width: calc(2px * calc(1 - var(--divide-y-reverse)));\n    border-bottom-width: calc(2px * var(--divide-y-reverse));\n  }\n  .sm\\:divide-x-2> :not(template)~ :not(template) {\n    --divide-x-reverse: 0;\n    border-right-width: calc(2px * var(--divide-x-reverse));\n    border-left-width: calc(2px * calc(1 - var(--divide-x-reverse)));\n  }\n  .sm\\:divide-y-4> :not(template)~ :not(template) {\n    --divide-y-reverse: 0;\n    border-top-width: calc(4px * calc(1 - var(--divide-y-reverse)));\n    border-bottom-width: calc(4px * var(--divide-y-reverse));\n  }\n  .sm\\:divide-x-4> :not(template)~ :not(template) {\n    --divide-x-reverse: 0;\n    border-right-width: calc(4px * var(--divide-x-reverse));\n    border-left-width: calc(4px * calc(1 - var(--divide-x-reverse)));\n  }\n  .sm\\:divide-y-8> :not(template)~ :not(template) {\n    --divide-y-reverse: 0;\n    border-top-width: calc(8px * calc(1 - var(--divide-y-reverse)));\n    border-bottom-width: calc(8px * var(--divide-y-reverse));\n  }\n  .sm\\:divide-x-8> :not(template)~ :not(template) {\n    --divide-x-reverse: 0;\n    border-right-width: calc(8px * var(--divide-x-reverse));\n    border-left-width: calc(8px * calc(1 - var(--divide-x-reverse)));\n  }\n  .sm\\:divide-y> :not(template)~ :not(template) {\n    --divide-y-reverse: 0;\n    border-top-width: calc(1px * calc(1 - var(--divide-y-reverse)));\n    border-bottom-width: calc(1px * var(--divide-y-reverse));\n  }\n  .sm\\:divide-x> :not(template)~ :not(template) {\n    --divide-x-reverse: 0;\n    border-right-width: calc(1px * var(--divide-x-reverse));\n    border-left-width: calc(1px * calc(1 - var(--divide-x-reverse)));\n  }\n  .sm\\:divide-y-reverse> :not(template)~ :not(template) {\n    --divide-y-reverse: 1;\n  }\n  .sm\\:divide-x-reverse> :not(template)~ :not(template) {\n    --divide-x-reverse: 1;\n  }\n  .sm\\:divide-current> :not(template)~ :not(template) {\n    border-color: currentColor;\n  }\n  .sm\\:divide-transparent> :not(template)~ :not(template) {\n    border-color: transparent;\n  }\n  .sm\\:divide-white> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #ffffff;\n    border-color: rgba(255, 255, 255, var(--divide-opacity));\n  }\n  .sm\\:divide-black> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #000000;\n    border-color: rgba(0, 0, 0, var(--divide-opacity));\n  }\n  .sm\\:divide-gray-50> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #f9fafb;\n    border-color: rgba(249, 250, 251, var(--divide-opacity));\n  }\n  .sm\\:divide-gray-100> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #f4f5f7;\n    border-color: rgba(244, 245, 247, var(--divide-opacity));\n  }\n  .sm\\:divide-gray-200> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #e5e7eb;\n    border-color: rgba(229, 231, 235, var(--divide-opacity));\n  }\n  .sm\\:divide-gray-300> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #d2d6dc;\n    border-color: rgba(210, 214, 220, var(--divide-opacity));\n  }\n  .sm\\:divide-gray-400> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #9fa6b2;\n    border-color: rgba(159, 166, 178, var(--divide-opacity));\n  }\n  .sm\\:divide-gray-500> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #6b7280;\n    border-color: rgba(107, 114, 128, var(--divide-opacity));\n  }\n  .sm\\:divide-gray-600> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #4b5563;\n    border-color: rgba(75, 85, 99, var(--divide-opacity));\n  }\n  .sm\\:divide-gray-700> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #374151;\n    border-color: rgba(55, 65, 81, var(--divide-opacity));\n  }\n  .sm\\:divide-gray-800> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #252f3f;\n    border-color: rgba(37, 47, 63, var(--divide-opacity));\n  }\n  .sm\\:divide-gray-900> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #161e2e;\n    border-color: rgba(22, 30, 46, var(--divide-opacity));\n  }\n  .sm\\:divide-red-50> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #fdf2f2;\n    border-color: rgba(253, 242, 242, var(--divide-opacity));\n  }\n  .sm\\:divide-red-100> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #fde8e8;\n    border-color: rgba(253, 232, 232, var(--divide-opacity));\n  }\n  .sm\\:divide-red-200> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #fbd5d5;\n    border-color: rgba(251, 213, 213, var(--divide-opacity));\n  }\n  .sm\\:divide-red-300> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #f8b4b4;\n    border-color: rgba(248, 180, 180, var(--divide-opacity));\n  }\n  .sm\\:divide-red-400> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #f98080;\n    border-color: rgba(249, 128, 128, var(--divide-opacity));\n  }\n  .sm\\:divide-red-500> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #f05252;\n    border-color: rgba(240, 82, 82, var(--divide-opacity));\n  }\n  .sm\\:divide-red-600> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #e02424;\n    border-color: rgba(224, 36, 36, var(--divide-opacity));\n  }\n  .sm\\:divide-red-700> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #c81e1e;\n    border-color: rgba(200, 30, 30, var(--divide-opacity));\n  }\n  .sm\\:divide-red-800> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #9b1c1c;\n    border-color: rgba(155, 28, 28, var(--divide-opacity));\n  }\n  .sm\\:divide-red-900> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #771d1d;\n    border-color: rgba(119, 29, 29, var(--divide-opacity));\n  }\n  .sm\\:divide-orange-50> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #fff8f1;\n    border-color: rgba(255, 248, 241, var(--divide-opacity));\n  }\n  .sm\\:divide-orange-100> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #feecdc;\n    border-color: rgba(254, 236, 220, var(--divide-opacity));\n  }\n  .sm\\:divide-orange-200> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #fcd9bd;\n    border-color: rgba(252, 217, 189, var(--divide-opacity));\n  }\n  .sm\\:divide-orange-300> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #fdba8c;\n    border-color: rgba(253, 186, 140, var(--divide-opacity));\n  }\n  .sm\\:divide-orange-400> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #ff8a4c;\n    border-color: rgba(255, 138, 76, var(--divide-opacity));\n  }\n  .sm\\:divide-orange-500> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #ff5a1f;\n    border-color: rgba(255, 90, 31, var(--divide-opacity));\n  }\n  .sm\\:divide-orange-600> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #d03801;\n    border-color: rgba(208, 56, 1, var(--divide-opacity));\n  }\n  .sm\\:divide-orange-700> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #b43403;\n    border-color: rgba(180, 52, 3, var(--divide-opacity));\n  }\n  .sm\\:divide-orange-800> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #8a2c0d;\n    border-color: rgba(138, 44, 13, var(--divide-opacity));\n  }\n  .sm\\:divide-orange-900> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #73230d;\n    border-color: rgba(115, 35, 13, var(--divide-opacity));\n  }\n  .sm\\:divide-yellow-50> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #fdfdea;\n    border-color: rgba(253, 253, 234, var(--divide-opacity));\n  }\n  .sm\\:divide-yellow-100> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #fdf6b2;\n    border-color: rgba(253, 246, 178, var(--divide-opacity));\n  }\n  .sm\\:divide-yellow-200> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #fce96a;\n    border-color: rgba(252, 233, 106, var(--divide-opacity));\n  }\n  .sm\\:divide-yellow-300> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #faca15;\n    border-color: rgba(250, 202, 21, var(--divide-opacity));\n  }\n  .sm\\:divide-yellow-400> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #e3a008;\n    border-color: rgba(227, 160, 8, var(--divide-opacity));\n  }\n  .sm\\:divide-yellow-500> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #c27803;\n    border-color: rgba(194, 120, 3, var(--divide-opacity));\n  }\n  .sm\\:divide-yellow-600> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #9f580a;\n    border-color: rgba(159, 88, 10, var(--divide-opacity));\n  }\n  .sm\\:divide-yellow-700> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #8e4b10;\n    border-color: rgba(142, 75, 16, var(--divide-opacity));\n  }\n  .sm\\:divide-yellow-800> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #723b13;\n    border-color: rgba(114, 59, 19, var(--divide-opacity));\n  }\n  .sm\\:divide-yellow-900> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #633112;\n    border-color: rgba(99, 49, 18, var(--divide-opacity));\n  }\n  .sm\\:divide-green-50> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #f3faf7;\n    border-color: rgba(243, 250, 247, var(--divide-opacity));\n  }\n  .sm\\:divide-green-100> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #def7ec;\n    border-color: rgba(222, 247, 236, var(--divide-opacity));\n  }\n  .sm\\:divide-green-200> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #bcf0da;\n    border-color: rgba(188, 240, 218, var(--divide-opacity));\n  }\n  .sm\\:divide-green-300> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #84e1bc;\n    border-color: rgba(132, 225, 188, var(--divide-opacity));\n  }\n  .sm\\:divide-green-400> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #31c48d;\n    border-color: rgba(49, 196, 141, var(--divide-opacity));\n  }\n  .sm\\:divide-green-500> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #0e9f6e;\n    border-color: rgba(14, 159, 110, var(--divide-opacity));\n  }\n  .sm\\:divide-green-600> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #057a55;\n    border-color: rgba(5, 122, 85, var(--divide-opacity));\n  }\n  .sm\\:divide-green-700> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #046c4e;\n    border-color: rgba(4, 108, 78, var(--divide-opacity));\n  }\n  .sm\\:divide-green-800> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #03543f;\n    border-color: rgba(3, 84, 63, var(--divide-opacity));\n  }\n  .sm\\:divide-green-900> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #014737;\n    border-color: rgba(1, 71, 55, var(--divide-opacity));\n  }\n  .sm\\:divide-teal-50> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #edfafa;\n    border-color: rgba(237, 250, 250, var(--divide-opacity));\n  }\n  .sm\\:divide-teal-100> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #d5f5f6;\n    border-color: rgba(213, 245, 246, var(--divide-opacity));\n  }\n  .sm\\:divide-teal-200> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #afecef;\n    border-color: rgba(175, 236, 239, var(--divide-opacity));\n  }\n  .sm\\:divide-teal-300> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #7edce2;\n    border-color: rgba(126, 220, 226, var(--divide-opacity));\n  }\n  .sm\\:divide-teal-400> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #16bdca;\n    border-color: rgba(22, 189, 202, var(--divide-opacity));\n  }\n  .sm\\:divide-teal-500> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #0694a2;\n    border-color: rgba(6, 148, 162, var(--divide-opacity));\n  }\n  .sm\\:divide-teal-600> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #047481;\n    border-color: rgba(4, 116, 129, var(--divide-opacity));\n  }\n  .sm\\:divide-teal-700> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #036672;\n    border-color: rgba(3, 102, 114, var(--divide-opacity));\n  }\n  .sm\\:divide-teal-800> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #05505c;\n    border-color: rgba(5, 80, 92, var(--divide-opacity));\n  }\n  .sm\\:divide-teal-900> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #014451;\n    border-color: rgba(1, 68, 81, var(--divide-opacity));\n  }\n  .sm\\:divide-blue-50> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #ebf5ff;\n    border-color: rgba(235, 245, 255, var(--divide-opacity));\n  }\n  .sm\\:divide-blue-100> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #e1effe;\n    border-color: rgba(225, 239, 254, var(--divide-opacity));\n  }\n  .sm\\:divide-blue-200> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #c3ddfd;\n    border-color: rgba(195, 221, 253, var(--divide-opacity));\n  }\n  .sm\\:divide-blue-300> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #a4cafe;\n    border-color: rgba(164, 202, 254, var(--divide-opacity));\n  }\n  .sm\\:divide-blue-400> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #76a9fa;\n    border-color: rgba(118, 169, 250, var(--divide-opacity));\n  }\n  .sm\\:divide-blue-500> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #3f83f8;\n    border-color: rgba(63, 131, 248, var(--divide-opacity));\n  }\n  .sm\\:divide-blue-600> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #1c64f2;\n    border-color: rgba(28, 100, 242, var(--divide-opacity));\n  }\n  .sm\\:divide-blue-700> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #1a56db;\n    border-color: rgba(26, 86, 219, var(--divide-opacity));\n  }\n  .sm\\:divide-blue-800> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #1e429f;\n    border-color: rgba(30, 66, 159, var(--divide-opacity));\n  }\n  .sm\\:divide-blue-900> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #233876;\n    border-color: rgba(35, 56, 118, var(--divide-opacity));\n  }\n  .sm\\:divide-indigo-50> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #f0f5ff;\n    border-color: rgba(240, 245, 255, var(--divide-opacity));\n  }\n  .sm\\:divide-indigo-100> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #e5edff;\n    border-color: rgba(229, 237, 255, var(--divide-opacity));\n  }\n  .sm\\:divide-indigo-200> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #cddbfe;\n    border-color: rgba(205, 219, 254, var(--divide-opacity));\n  }\n  .sm\\:divide-indigo-300> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #b4c6fc;\n    border-color: rgba(180, 198, 252, var(--divide-opacity));\n  }\n  .sm\\:divide-indigo-400> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #8da2fb;\n    border-color: rgba(141, 162, 251, var(--divide-opacity));\n  }\n  .sm\\:divide-indigo-500> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #6875f5;\n    border-color: rgba(104, 117, 245, var(--divide-opacity));\n  }\n  .sm\\:divide-indigo-600> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #5850ec;\n    border-color: rgba(88, 80, 236, var(--divide-opacity));\n  }\n  .sm\\:divide-indigo-700> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #5145cd;\n    border-color: rgba(81, 69, 205, var(--divide-opacity));\n  }\n  .sm\\:divide-indigo-800> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #42389d;\n    border-color: rgba(66, 56, 157, var(--divide-opacity));\n  }\n  .sm\\:divide-indigo-900> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #362f78;\n    border-color: rgba(54, 47, 120, var(--divide-opacity));\n  }\n  .sm\\:divide-purple-50> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #f6f5ff;\n    border-color: rgba(246, 245, 255, var(--divide-opacity));\n  }\n  .sm\\:divide-purple-100> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #edebfe;\n    border-color: rgba(237, 235, 254, var(--divide-opacity));\n  }\n  .sm\\:divide-purple-200> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #dcd7fe;\n    border-color: rgba(220, 215, 254, var(--divide-opacity));\n  }\n  .sm\\:divide-purple-300> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #cabffd;\n    border-color: rgba(202, 191, 253, var(--divide-opacity));\n  }\n  .sm\\:divide-purple-400> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #ac94fa;\n    border-color: rgba(172, 148, 250, var(--divide-opacity));\n  }\n  .sm\\:divide-purple-500> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #9061f9;\n    border-color: rgba(144, 97, 249, var(--divide-opacity));\n  }\n  .sm\\:divide-purple-600> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #7e3af2;\n    border-color: rgba(126, 58, 242, var(--divide-opacity));\n  }\n  .sm\\:divide-purple-700> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #6c2bd9;\n    border-color: rgba(108, 43, 217, var(--divide-opacity));\n  }\n  .sm\\:divide-purple-800> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #5521b5;\n    border-color: rgba(85, 33, 181, var(--divide-opacity));\n  }\n  .sm\\:divide-purple-900> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #4a1d96;\n    border-color: rgba(74, 29, 150, var(--divide-opacity));\n  }\n  .sm\\:divide-pink-50> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #fdf2f8;\n    border-color: rgba(253, 242, 248, var(--divide-opacity));\n  }\n  .sm\\:divide-pink-100> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #fce8f3;\n    border-color: rgba(252, 232, 243, var(--divide-opacity));\n  }\n  .sm\\:divide-pink-200> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #fad1e8;\n    border-color: rgba(250, 209, 232, var(--divide-opacity));\n  }\n  .sm\\:divide-pink-300> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #f8b4d9;\n    border-color: rgba(248, 180, 217, var(--divide-opacity));\n  }\n  .sm\\:divide-pink-400> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #f17eb8;\n    border-color: rgba(241, 126, 184, var(--divide-opacity));\n  }\n  .sm\\:divide-pink-500> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #e74694;\n    border-color: rgba(231, 70, 148, var(--divide-opacity));\n  }\n  .sm\\:divide-pink-600> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #d61f69;\n    border-color: rgba(214, 31, 105, var(--divide-opacity));\n  }\n  .sm\\:divide-pink-700> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #bf125d;\n    border-color: rgba(191, 18, 93, var(--divide-opacity));\n  }\n  .sm\\:divide-pink-800> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #99154b;\n    border-color: rgba(153, 21, 75, var(--divide-opacity));\n  }\n  .sm\\:divide-pink-900> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #751a3d;\n    border-color: rgba(117, 26, 61, var(--divide-opacity));\n  }\n  .sm\\:divide-cool-gray-50> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #f8fafc;\n    border-color: rgba(248, 250, 252, var(--divide-opacity));\n  }\n  .sm\\:divide-cool-gray-100> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #f1f5f9;\n    border-color: rgba(241, 245, 249, var(--divide-opacity));\n  }\n  .sm\\:divide-cool-gray-200> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #e2e8f0;\n    border-color: rgba(226, 232, 240, var(--divide-opacity));\n  }\n  .sm\\:divide-cool-gray-300> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #cfd8e3;\n    border-color: rgba(207, 216, 227, var(--divide-opacity));\n  }\n  .sm\\:divide-cool-gray-400> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #97a6ba;\n    border-color: rgba(151, 166, 186, var(--divide-opacity));\n  }\n  .sm\\:divide-cool-gray-500> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #64748b;\n    border-color: rgba(100, 116, 139, var(--divide-opacity));\n  }\n  .sm\\:divide-cool-gray-600> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #475569;\n    border-color: rgba(71, 85, 105, var(--divide-opacity));\n  }\n  .sm\\:divide-cool-gray-700> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #364152;\n    border-color: rgba(54, 65, 82, var(--divide-opacity));\n  }\n  .sm\\:divide-cool-gray-800> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #27303f;\n    border-color: rgba(39, 48, 63, var(--divide-opacity));\n  }\n  .sm\\:divide-cool-gray-900> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #1a202e;\n    border-color: rgba(26, 32, 46, var(--divide-opacity));\n  }\n  .sm\\:divide-solid> :not(template)~ :not(template) {\n    border-style: solid;\n  }\n  .sm\\:divide-dashed> :not(template)~ :not(template) {\n    border-style: dashed;\n  }\n  .sm\\:divide-dotted> :not(template)~ :not(template) {\n    border-style: dotted;\n  }\n  .sm\\:divide-double> :not(template)~ :not(template) {\n    border-style: double;\n  }\n  .sm\\:divide-none> :not(template)~ :not(template) {\n    border-style: none;\n  }\n  .sm\\:divide-opacity-0> :not(template)~ :not(template) {\n    --divide-opacity: 0;\n  }\n  .sm\\:divide-opacity-25> :not(template)~ :not(template) {\n    --divide-opacity: 0.25;\n  }\n  .sm\\:divide-opacity-50> :not(template)~ :not(template) {\n    --divide-opacity: 0.5;\n  }\n  .sm\\:divide-opacity-75> :not(template)~ :not(template) {\n    --divide-opacity: 0.75;\n  }\n  .sm\\:divide-opacity-100> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n  }\n  .sm\\:sr-only {\n    position: absolute;\n    width: 1px;\n    height: 1px;\n    padding: 0;\n    margin: -1px;\n    overflow: hidden;\n    clip: rect(0, 0, 0, 0);\n    white-space: nowrap;\n    border-width: 0;\n  }\n  .sm\\:not-sr-only {\n    position: static;\n    width: auto;\n    height: auto;\n    padding: 0;\n    margin: 0;\n    overflow: visible;\n    clip: auto;\n    white-space: normal;\n  }\n  .sm\\:focus\\:sr-only:focus {\n    position: absolute;\n    width: 1px;\n    height: 1px;\n    padding: 0;\n    margin: -1px;\n    overflow: hidden;\n    clip: rect(0, 0, 0, 0);\n    white-space: nowrap;\n    border-width: 0;\n  }\n  .sm\\:focus\\:not-sr-only:focus {\n    position: static;\n    width: auto;\n    height: auto;\n    padding: 0;\n    margin: 0;\n    overflow: visible;\n    clip: auto;\n    white-space: normal;\n  }\n  .sm\\:appearance-none {\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    appearance: none;\n  }\n  .sm\\:bg-fixed {\n    background-attachment: fixed;\n  }\n  .sm\\:bg-local {\n    background-attachment: local;\n  }\n  .sm\\:bg-scroll {\n    background-attachment: scroll;\n  }\n  .sm\\:bg-clip-border {\n    background-clip: border-box;\n  }\n  .sm\\:bg-clip-padding {\n    background-clip: padding-box;\n  }\n  .sm\\:bg-clip-content {\n    background-clip: content-box;\n  }\n  .sm\\:bg-clip-text {\n    -webkit-background-clip: text;\n    background-clip: text;\n  }\n  .sm\\:bg-current {\n    background-color: currentColor;\n  }\n  .sm\\:bg-transparent {\n    background-color: transparent;\n  }\n  .sm\\:bg-white {\n    --bg-opacity: 1;\n    background-color: #ffffff;\n    background-color: rgba(255, 255, 255, var(--bg-opacity));\n  }\n  .sm\\:bg-black {\n    --bg-opacity: 1;\n    background-color: #000000;\n    background-color: rgba(0, 0, 0, var(--bg-opacity));\n  }\n  .sm\\:bg-gray-50 {\n    --bg-opacity: 1;\n    background-color: #f9fafb;\n    background-color: rgba(249, 250, 251, var(--bg-opacity));\n  }\n  .sm\\:bg-gray-100 {\n    --bg-opacity: 1;\n    background-color: #f4f5f7;\n    background-color: rgba(244, 245, 247, var(--bg-opacity));\n  }\n  .sm\\:bg-gray-200 {\n    --bg-opacity: 1;\n    background-color: #e5e7eb;\n    background-color: rgba(229, 231, 235, var(--bg-opacity));\n  }\n  .sm\\:bg-gray-300 {\n    --bg-opacity: 1;\n    background-color: #d2d6dc;\n    background-color: rgba(210, 214, 220, var(--bg-opacity));\n  }\n  .sm\\:bg-gray-400 {\n    --bg-opacity: 1;\n    background-color: #9fa6b2;\n    background-color: rgba(159, 166, 178, var(--bg-opacity));\n  }\n  .sm\\:bg-gray-500 {\n    --bg-opacity: 1;\n    background-color: #6b7280;\n    background-color: rgba(107, 114, 128, var(--bg-opacity));\n  }\n  .sm\\:bg-gray-600 {\n    --bg-opacity: 1;\n    background-color: #4b5563;\n    background-color: rgba(75, 85, 99, var(--bg-opacity));\n  }\n  .sm\\:bg-gray-700 {\n    --bg-opacity: 1;\n    background-color: #374151;\n    background-color: rgba(55, 65, 81, var(--bg-opacity));\n  }\n  .sm\\:bg-gray-800 {\n    --bg-opacity: 1;\n    background-color: #252f3f;\n    background-color: rgba(37, 47, 63, var(--bg-opacity));\n  }\n  .sm\\:bg-gray-900 {\n    --bg-opacity: 1;\n    background-color: #161e2e;\n    background-color: rgba(22, 30, 46, var(--bg-opacity));\n  }\n  .sm\\:bg-red-50 {\n    --bg-opacity: 1;\n    background-color: #fdf2f2;\n    background-color: rgba(253, 242, 242, var(--bg-opacity));\n  }\n  .sm\\:bg-red-100 {\n    --bg-opacity: 1;\n    background-color: #fde8e8;\n    background-color: rgba(253, 232, 232, var(--bg-opacity));\n  }\n  .sm\\:bg-red-200 {\n    --bg-opacity: 1;\n    background-color: #fbd5d5;\n    background-color: rgba(251, 213, 213, var(--bg-opacity));\n  }\n  .sm\\:bg-red-300 {\n    --bg-opacity: 1;\n    background-color: #f8b4b4;\n    background-color: rgba(248, 180, 180, var(--bg-opacity));\n  }\n  .sm\\:bg-red-400 {\n    --bg-opacity: 1;\n    background-color: #f98080;\n    background-color: rgba(249, 128, 128, var(--bg-opacity));\n  }\n  .sm\\:bg-red-500 {\n    --bg-opacity: 1;\n    background-color: #f05252;\n    background-color: rgba(240, 82, 82, var(--bg-opacity));\n  }\n  .sm\\:bg-red-600 {\n    --bg-opacity: 1;\n    background-color: #e02424;\n    background-color: rgba(224, 36, 36, var(--bg-opacity));\n  }\n  .sm\\:bg-red-700 {\n    --bg-opacity: 1;\n    background-color: #c81e1e;\n    background-color: rgba(200, 30, 30, var(--bg-opacity));\n  }\n  .sm\\:bg-red-800 {\n    --bg-opacity: 1;\n    background-color: #9b1c1c;\n    background-color: rgba(155, 28, 28, var(--bg-opacity));\n  }\n  .sm\\:bg-red-900 {\n    --bg-opacity: 1;\n    background-color: #771d1d;\n    background-color: rgba(119, 29, 29, var(--bg-opacity));\n  }\n  .sm\\:bg-orange-50 {\n    --bg-opacity: 1;\n    background-color: #fff8f1;\n    background-color: rgba(255, 248, 241, var(--bg-opacity));\n  }\n  .sm\\:bg-orange-100 {\n    --bg-opacity: 1;\n    background-color: #feecdc;\n    background-color: rgba(254, 236, 220, var(--bg-opacity));\n  }\n  .sm\\:bg-orange-200 {\n    --bg-opacity: 1;\n    background-color: #fcd9bd;\n    background-color: rgba(252, 217, 189, var(--bg-opacity));\n  }\n  .sm\\:bg-orange-300 {\n    --bg-opacity: 1;\n    background-color: #fdba8c;\n    background-color: rgba(253, 186, 140, var(--bg-opacity));\n  }\n  .sm\\:bg-orange-400 {\n    --bg-opacity: 1;\n    background-color: #ff8a4c;\n    background-color: rgba(255, 138, 76, var(--bg-opacity));\n  }\n  .sm\\:bg-orange-500 {\n    --bg-opacity: 1;\n    background-color: #ff5a1f;\n    background-color: rgba(255, 90, 31, var(--bg-opacity));\n  }\n  .sm\\:bg-orange-600 {\n    --bg-opacity: 1;\n    background-color: #d03801;\n    background-color: rgba(208, 56, 1, var(--bg-opacity));\n  }\n  .sm\\:bg-orange-700 {\n    --bg-opacity: 1;\n    background-color: #b43403;\n    background-color: rgba(180, 52, 3, var(--bg-opacity));\n  }\n  .sm\\:bg-orange-800 {\n    --bg-opacity: 1;\n    background-color: #8a2c0d;\n    background-color: rgba(138, 44, 13, var(--bg-opacity));\n  }\n  .sm\\:bg-orange-900 {\n    --bg-opacity: 1;\n    background-color: #73230d;\n    background-color: rgba(115, 35, 13, var(--bg-opacity));\n  }\n  .sm\\:bg-yellow-50 {\n    --bg-opacity: 1;\n    background-color: #fdfdea;\n    background-color: rgba(253, 253, 234, var(--bg-opacity));\n  }\n  .sm\\:bg-yellow-100 {\n    --bg-opacity: 1;\n    background-color: #fdf6b2;\n    background-color: rgba(253, 246, 178, var(--bg-opacity));\n  }\n  .sm\\:bg-yellow-200 {\n    --bg-opacity: 1;\n    background-color: #fce96a;\n    background-color: rgba(252, 233, 106, var(--bg-opacity));\n  }\n  .sm\\:bg-yellow-300 {\n    --bg-opacity: 1;\n    background-color: #faca15;\n    background-color: rgba(250, 202, 21, var(--bg-opacity));\n  }\n  .sm\\:bg-yellow-400 {\n    --bg-opacity: 1;\n    background-color: #e3a008;\n    background-color: rgba(227, 160, 8, var(--bg-opacity));\n  }\n  .sm\\:bg-yellow-500 {\n    --bg-opacity: 1;\n    background-color: #c27803;\n    background-color: rgba(194, 120, 3, var(--bg-opacity));\n  }\n  .sm\\:bg-yellow-600 {\n    --bg-opacity: 1;\n    background-color: #9f580a;\n    background-color: rgba(159, 88, 10, var(--bg-opacity));\n  }\n  .sm\\:bg-yellow-700 {\n    --bg-opacity: 1;\n    background-color: #8e4b10;\n    background-color: rgba(142, 75, 16, var(--bg-opacity));\n  }\n  .sm\\:bg-yellow-800 {\n    --bg-opacity: 1;\n    background-color: #723b13;\n    background-color: rgba(114, 59, 19, var(--bg-opacity));\n  }\n  .sm\\:bg-yellow-900 {\n    --bg-opacity: 1;\n    background-color: #633112;\n    background-color: rgba(99, 49, 18, var(--bg-opacity));\n  }\n  .sm\\:bg-green-50 {\n    --bg-opacity: 1;\n    background-color: #f3faf7;\n    background-color: rgba(243, 250, 247, var(--bg-opacity));\n  }\n  .sm\\:bg-green-100 {\n    --bg-opacity: 1;\n    background-color: #def7ec;\n    background-color: rgba(222, 247, 236, var(--bg-opacity));\n  }\n  .sm\\:bg-green-200 {\n    --bg-opacity: 1;\n    background-color: #bcf0da;\n    background-color: rgba(188, 240, 218, var(--bg-opacity));\n  }\n  .sm\\:bg-green-300 {\n    --bg-opacity: 1;\n    background-color: #84e1bc;\n    background-color: rgba(132, 225, 188, var(--bg-opacity));\n  }\n  .sm\\:bg-green-400 {\n    --bg-opacity: 1;\n    background-color: #31c48d;\n    background-color: rgba(49, 196, 141, var(--bg-opacity));\n  }\n  .sm\\:bg-green-500 {\n    --bg-opacity: 1;\n    background-color: #0e9f6e;\n    background-color: rgba(14, 159, 110, var(--bg-opacity));\n  }\n  .sm\\:bg-green-600 {\n    --bg-opacity: 1;\n    background-color: #057a55;\n    background-color: rgba(5, 122, 85, var(--bg-opacity));\n  }\n  .sm\\:bg-green-700 {\n    --bg-opacity: 1;\n    background-color: #046c4e;\n    background-color: rgba(4, 108, 78, var(--bg-opacity));\n  }\n  .sm\\:bg-green-800 {\n    --bg-opacity: 1;\n    background-color: #03543f;\n    background-color: rgba(3, 84, 63, var(--bg-opacity));\n  }\n  .sm\\:bg-green-900 {\n    --bg-opacity: 1;\n    background-color: #014737;\n    background-color: rgba(1, 71, 55, var(--bg-opacity));\n  }\n  .sm\\:bg-teal-50 {\n    --bg-opacity: 1;\n    background-color: #edfafa;\n    background-color: rgba(237, 250, 250, var(--bg-opacity));\n  }\n  .sm\\:bg-teal-100 {\n    --bg-opacity: 1;\n    background-color: #d5f5f6;\n    background-color: rgba(213, 245, 246, var(--bg-opacity));\n  }\n  .sm\\:bg-teal-200 {\n    --bg-opacity: 1;\n    background-color: #afecef;\n    background-color: rgba(175, 236, 239, var(--bg-opacity));\n  }\n  .sm\\:bg-teal-300 {\n    --bg-opacity: 1;\n    background-color: #7edce2;\n    background-color: rgba(126, 220, 226, var(--bg-opacity));\n  }\n  .sm\\:bg-teal-400 {\n    --bg-opacity: 1;\n    background-color: #16bdca;\n    background-color: rgba(22, 189, 202, var(--bg-opacity));\n  }\n  .sm\\:bg-teal-500 {\n    --bg-opacity: 1;\n    background-color: #0694a2;\n    background-color: rgba(6, 148, 162, var(--bg-opacity));\n  }\n  .sm\\:bg-teal-600 {\n    --bg-opacity: 1;\n    background-color: #047481;\n    background-color: rgba(4, 116, 129, var(--bg-opacity));\n  }\n  .sm\\:bg-teal-700 {\n    --bg-opacity: 1;\n    background-color: #036672;\n    background-color: rgba(3, 102, 114, var(--bg-opacity));\n  }\n  .sm\\:bg-teal-800 {\n    --bg-opacity: 1;\n    background-color: #05505c;\n    background-color: rgba(5, 80, 92, var(--bg-opacity));\n  }\n  .sm\\:bg-teal-900 {\n    --bg-opacity: 1;\n    background-color: #014451;\n    background-color: rgba(1, 68, 81, var(--bg-opacity));\n  }\n  .sm\\:bg-blue-50 {\n    --bg-opacity: 1;\n    background-color: #ebf5ff;\n    background-color: rgba(235, 245, 255, var(--bg-opacity));\n  }\n  .sm\\:bg-blue-100 {\n    --bg-opacity: 1;\n    background-color: #e1effe;\n    background-color: rgba(225, 239, 254, var(--bg-opacity));\n  }\n  .sm\\:bg-blue-200 {\n    --bg-opacity: 1;\n    background-color: #c3ddfd;\n    background-color: rgba(195, 221, 253, var(--bg-opacity));\n  }\n  .sm\\:bg-blue-300 {\n    --bg-opacity: 1;\n    background-color: #a4cafe;\n    background-color: rgba(164, 202, 254, var(--bg-opacity));\n  }\n  .sm\\:bg-blue-400 {\n    --bg-opacity: 1;\n    background-color: #76a9fa;\n    background-color: rgba(118, 169, 250, var(--bg-opacity));\n  }\n  .sm\\:bg-blue-500 {\n    --bg-opacity: 1;\n    background-color: #3f83f8;\n    background-color: rgba(63, 131, 248, var(--bg-opacity));\n  }\n  .sm\\:bg-blue-600 {\n    --bg-opacity: 1;\n    background-color: #1c64f2;\n    background-color: rgba(28, 100, 242, var(--bg-opacity));\n  }\n  .sm\\:bg-blue-700 {\n    --bg-opacity: 1;\n    background-color: #1a56db;\n    background-color: rgba(26, 86, 219, var(--bg-opacity));\n  }\n  .sm\\:bg-blue-800 {\n    --bg-opacity: 1;\n    background-color: #1e429f;\n    background-color: rgba(30, 66, 159, var(--bg-opacity));\n  }\n  .sm\\:bg-blue-900 {\n    --bg-opacity: 1;\n    background-color: #233876;\n    background-color: rgba(35, 56, 118, var(--bg-opacity));\n  }\n  .sm\\:bg-indigo-50 {\n    --bg-opacity: 1;\n    background-color: #f0f5ff;\n    background-color: rgba(240, 245, 255, var(--bg-opacity));\n  }\n  .sm\\:bg-indigo-100 {\n    --bg-opacity: 1;\n    background-color: #e5edff;\n    background-color: rgba(229, 237, 255, var(--bg-opacity));\n  }\n  .sm\\:bg-indigo-200 {\n    --bg-opacity: 1;\n    background-color: #cddbfe;\n    background-color: rgba(205, 219, 254, var(--bg-opacity));\n  }\n  .sm\\:bg-indigo-300 {\n    --bg-opacity: 1;\n    background-color: #b4c6fc;\n    background-color: rgba(180, 198, 252, var(--bg-opacity));\n  }\n  .sm\\:bg-indigo-400 {\n    --bg-opacity: 1;\n    background-color: #8da2fb;\n    background-color: rgba(141, 162, 251, var(--bg-opacity));\n  }\n  .sm\\:bg-indigo-500 {\n    --bg-opacity: 1;\n    background-color: #6875f5;\n    background-color: rgba(104, 117, 245, var(--bg-opacity));\n  }\n  .sm\\:bg-indigo-600 {\n    --bg-opacity: 1;\n    background-color: #5850ec;\n    background-color: rgba(88, 80, 236, var(--bg-opacity));\n  }\n  .sm\\:bg-indigo-700 {\n    --bg-opacity: 1;\n    background-color: #5145cd;\n    background-color: rgba(81, 69, 205, var(--bg-opacity));\n  }\n  .sm\\:bg-indigo-800 {\n    --bg-opacity: 1;\n    background-color: #42389d;\n    background-color: rgba(66, 56, 157, var(--bg-opacity));\n  }\n  .sm\\:bg-indigo-900 {\n    --bg-opacity: 1;\n    background-color: #362f78;\n    background-color: rgba(54, 47, 120, var(--bg-opacity));\n  }\n  .sm\\:bg-purple-50 {\n    --bg-opacity: 1;\n    background-color: #f6f5ff;\n    background-color: rgba(246, 245, 255, var(--bg-opacity));\n  }\n  .sm\\:bg-purple-100 {\n    --bg-opacity: 1;\n    background-color: #edebfe;\n    background-color: rgba(237, 235, 254, var(--bg-opacity));\n  }\n  .sm\\:bg-purple-200 {\n    --bg-opacity: 1;\n    background-color: #dcd7fe;\n    background-color: rgba(220, 215, 254, var(--bg-opacity));\n  }\n  .sm\\:bg-purple-300 {\n    --bg-opacity: 1;\n    background-color: #cabffd;\n    background-color: rgba(202, 191, 253, var(--bg-opacity));\n  }\n  .sm\\:bg-purple-400 {\n    --bg-opacity: 1;\n    background-color: #ac94fa;\n    background-color: rgba(172, 148, 250, var(--bg-opacity));\n  }\n  .sm\\:bg-purple-500 {\n    --bg-opacity: 1;\n    background-color: #9061f9;\n    background-color: rgba(144, 97, 249, var(--bg-opacity));\n  }\n  .sm\\:bg-purple-600 {\n    --bg-opacity: 1;\n    background-color: #7e3af2;\n    background-color: rgba(126, 58, 242, var(--bg-opacity));\n  }\n  .sm\\:bg-purple-700 {\n    --bg-opacity: 1;\n    background-color: #6c2bd9;\n    background-color: rgba(108, 43, 217, var(--bg-opacity));\n  }\n  .sm\\:bg-purple-800 {\n    --bg-opacity: 1;\n    background-color: #5521b5;\n    background-color: rgba(85, 33, 181, var(--bg-opacity));\n  }\n  .sm\\:bg-purple-900 {\n    --bg-opacity: 1;\n    background-color: #4a1d96;\n    background-color: rgba(74, 29, 150, var(--bg-opacity));\n  }\n  .sm\\:bg-pink-50 {\n    --bg-opacity: 1;\n    background-color: #fdf2f8;\n    background-color: rgba(253, 242, 248, var(--bg-opacity));\n  }\n  .sm\\:bg-pink-100 {\n    --bg-opacity: 1;\n    background-color: #fce8f3;\n    background-color: rgba(252, 232, 243, var(--bg-opacity));\n  }\n  .sm\\:bg-pink-200 {\n    --bg-opacity: 1;\n    background-color: #fad1e8;\n    background-color: rgba(250, 209, 232, var(--bg-opacity));\n  }\n  .sm\\:bg-pink-300 {\n    --bg-opacity: 1;\n    background-color: #f8b4d9;\n    background-color: rgba(248, 180, 217, var(--bg-opacity));\n  }\n  .sm\\:bg-pink-400 {\n    --bg-opacity: 1;\n    background-color: #f17eb8;\n    background-color: rgba(241, 126, 184, var(--bg-opacity));\n  }\n  .sm\\:bg-pink-500 {\n    --bg-opacity: 1;\n    background-color: #e74694;\n    background-color: rgba(231, 70, 148, var(--bg-opacity));\n  }\n  .sm\\:bg-pink-600 {\n    --bg-opacity: 1;\n    background-color: #d61f69;\n    background-color: rgba(214, 31, 105, var(--bg-opacity));\n  }\n  .sm\\:bg-pink-700 {\n    --bg-opacity: 1;\n    background-color: #bf125d;\n    background-color: rgba(191, 18, 93, var(--bg-opacity));\n  }\n  .sm\\:bg-pink-800 {\n    --bg-opacity: 1;\n    background-color: #99154b;\n    background-color: rgba(153, 21, 75, var(--bg-opacity));\n  }\n  .sm\\:bg-pink-900 {\n    --bg-opacity: 1;\n    background-color: #751a3d;\n    background-color: rgba(117, 26, 61, var(--bg-opacity));\n  }\n  .sm\\:bg-cool-gray-50 {\n    --bg-opacity: 1;\n    background-color: #f8fafc;\n    background-color: rgba(248, 250, 252, var(--bg-opacity));\n  }\n  .sm\\:bg-cool-gray-100 {\n    --bg-opacity: 1;\n    background-color: #f1f5f9;\n    background-color: rgba(241, 245, 249, var(--bg-opacity));\n  }\n  .sm\\:bg-cool-gray-200 {\n    --bg-opacity: 1;\n    background-color: #e2e8f0;\n    background-color: rgba(226, 232, 240, var(--bg-opacity));\n  }\n  .sm\\:bg-cool-gray-300 {\n    --bg-opacity: 1;\n    background-color: #cfd8e3;\n    background-color: rgba(207, 216, 227, var(--bg-opacity));\n  }\n  .sm\\:bg-cool-gray-400 {\n    --bg-opacity: 1;\n    background-color: #97a6ba;\n    background-color: rgba(151, 166, 186, var(--bg-opacity));\n  }\n  .sm\\:bg-cool-gray-500 {\n    --bg-opacity: 1;\n    background-color: #64748b;\n    background-color: rgba(100, 116, 139, var(--bg-opacity));\n  }\n  .sm\\:bg-cool-gray-600 {\n    --bg-opacity: 1;\n    background-color: #475569;\n    background-color: rgba(71, 85, 105, var(--bg-opacity));\n  }\n  .sm\\:bg-cool-gray-700 {\n    --bg-opacity: 1;\n    background-color: #364152;\n    background-color: rgba(54, 65, 82, var(--bg-opacity));\n  }\n  .sm\\:bg-cool-gray-800 {\n    --bg-opacity: 1;\n    background-color: #27303f;\n    background-color: rgba(39, 48, 63, var(--bg-opacity));\n  }\n  .sm\\:bg-cool-gray-900 {\n    --bg-opacity: 1;\n    background-color: #1a202e;\n    background-color: rgba(26, 32, 46, var(--bg-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:bg-current {\n    background-color: currentColor;\n  }\n  .group:hover .sm\\:group-hover\\:bg-transparent {\n    background-color: transparent;\n  }\n  .group:hover .sm\\:group-hover\\:bg-white {\n    --bg-opacity: 1;\n    background-color: #ffffff;\n    background-color: rgba(255, 255, 255, var(--bg-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:bg-black {\n    --bg-opacity: 1;\n    background-color: #000000;\n    background-color: rgba(0, 0, 0, var(--bg-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:bg-gray-50 {\n    --bg-opacity: 1;\n    background-color: #f9fafb;\n    background-color: rgba(249, 250, 251, var(--bg-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:bg-gray-100 {\n    --bg-opacity: 1;\n    background-color: #f4f5f7;\n    background-color: rgba(244, 245, 247, var(--bg-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:bg-gray-200 {\n    --bg-opacity: 1;\n    background-color: #e5e7eb;\n    background-color: rgba(229, 231, 235, var(--bg-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:bg-gray-300 {\n    --bg-opacity: 1;\n    background-color: #d2d6dc;\n    background-color: rgba(210, 214, 220, var(--bg-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:bg-gray-400 {\n    --bg-opacity: 1;\n    background-color: #9fa6b2;\n    background-color: rgba(159, 166, 178, var(--bg-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:bg-gray-500 {\n    --bg-opacity: 1;\n    background-color: #6b7280;\n    background-color: rgba(107, 114, 128, var(--bg-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:bg-gray-600 {\n    --bg-opacity: 1;\n    background-color: #4b5563;\n    background-color: rgba(75, 85, 99, var(--bg-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:bg-gray-700 {\n    --bg-opacity: 1;\n    background-color: #374151;\n    background-color: rgba(55, 65, 81, var(--bg-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:bg-gray-800 {\n    --bg-opacity: 1;\n    background-color: #252f3f;\n    background-color: rgba(37, 47, 63, var(--bg-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:bg-gray-900 {\n    --bg-opacity: 1;\n    background-color: #161e2e;\n    background-color: rgba(22, 30, 46, var(--bg-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:bg-red-50 {\n    --bg-opacity: 1;\n    background-color: #fdf2f2;\n    background-color: rgba(253, 242, 242, var(--bg-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:bg-red-100 {\n    --bg-opacity: 1;\n    background-color: #fde8e8;\n    background-color: rgba(253, 232, 232, var(--bg-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:bg-red-200 {\n    --bg-opacity: 1;\n    background-color: #fbd5d5;\n    background-color: rgba(251, 213, 213, var(--bg-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:bg-red-300 {\n    --bg-opacity: 1;\n    background-color: #f8b4b4;\n    background-color: rgba(248, 180, 180, var(--bg-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:bg-red-400 {\n    --bg-opacity: 1;\n    background-color: #f98080;\n    background-color: rgba(249, 128, 128, var(--bg-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:bg-red-500 {\n    --bg-opacity: 1;\n    background-color: #f05252;\n    background-color: rgba(240, 82, 82, var(--bg-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:bg-red-600 {\n    --bg-opacity: 1;\n    background-color: #e02424;\n    background-color: rgba(224, 36, 36, var(--bg-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:bg-red-700 {\n    --bg-opacity: 1;\n    background-color: #c81e1e;\n    background-color: rgba(200, 30, 30, var(--bg-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:bg-red-800 {\n    --bg-opacity: 1;\n    background-color: #9b1c1c;\n    background-color: rgba(155, 28, 28, var(--bg-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:bg-red-900 {\n    --bg-opacity: 1;\n    background-color: #771d1d;\n    background-color: rgba(119, 29, 29, var(--bg-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:bg-orange-50 {\n    --bg-opacity: 1;\n    background-color: #fff8f1;\n    background-color: rgba(255, 248, 241, var(--bg-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:bg-orange-100 {\n    --bg-opacity: 1;\n    background-color: #feecdc;\n    background-color: rgba(254, 236, 220, var(--bg-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:bg-orange-200 {\n    --bg-opacity: 1;\n    background-color: #fcd9bd;\n    background-color: rgba(252, 217, 189, var(--bg-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:bg-orange-300 {\n    --bg-opacity: 1;\n    background-color: #fdba8c;\n    background-color: rgba(253, 186, 140, var(--bg-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:bg-orange-400 {\n    --bg-opacity: 1;\n    background-color: #ff8a4c;\n    background-color: rgba(255, 138, 76, var(--bg-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:bg-orange-500 {\n    --bg-opacity: 1;\n    background-color: #ff5a1f;\n    background-color: rgba(255, 90, 31, var(--bg-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:bg-orange-600 {\n    --bg-opacity: 1;\n    background-color: #d03801;\n    background-color: rgba(208, 56, 1, var(--bg-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:bg-orange-700 {\n    --bg-opacity: 1;\n    background-color: #b43403;\n    background-color: rgba(180, 52, 3, var(--bg-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:bg-orange-800 {\n    --bg-opacity: 1;\n    background-color: #8a2c0d;\n    background-color: rgba(138, 44, 13, var(--bg-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:bg-orange-900 {\n    --bg-opacity: 1;\n    background-color: #73230d;\n    background-color: rgba(115, 35, 13, var(--bg-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:bg-yellow-50 {\n    --bg-opacity: 1;\n    background-color: #fdfdea;\n    background-color: rgba(253, 253, 234, var(--bg-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:bg-yellow-100 {\n    --bg-opacity: 1;\n    background-color: #fdf6b2;\n    background-color: rgba(253, 246, 178, var(--bg-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:bg-yellow-200 {\n    --bg-opacity: 1;\n    background-color: #fce96a;\n    background-color: rgba(252, 233, 106, var(--bg-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:bg-yellow-300 {\n    --bg-opacity: 1;\n    background-color: #faca15;\n    background-color: rgba(250, 202, 21, var(--bg-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:bg-yellow-400 {\n    --bg-opacity: 1;\n    background-color: #e3a008;\n    background-color: rgba(227, 160, 8, var(--bg-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:bg-yellow-500 {\n    --bg-opacity: 1;\n    background-color: #c27803;\n    background-color: rgba(194, 120, 3, var(--bg-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:bg-yellow-600 {\n    --bg-opacity: 1;\n    background-color: #9f580a;\n    background-color: rgba(159, 88, 10, var(--bg-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:bg-yellow-700 {\n    --bg-opacity: 1;\n    background-color: #8e4b10;\n    background-color: rgba(142, 75, 16, var(--bg-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:bg-yellow-800 {\n    --bg-opacity: 1;\n    background-color: #723b13;\n    background-color: rgba(114, 59, 19, var(--bg-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:bg-yellow-900 {\n    --bg-opacity: 1;\n    background-color: #633112;\n    background-color: rgba(99, 49, 18, var(--bg-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:bg-green-50 {\n    --bg-opacity: 1;\n    background-color: #f3faf7;\n    background-color: rgba(243, 250, 247, var(--bg-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:bg-green-100 {\n    --bg-opacity: 1;\n    background-color: #def7ec;\n    background-color: rgba(222, 247, 236, var(--bg-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:bg-green-200 {\n    --bg-opacity: 1;\n    background-color: #bcf0da;\n    background-color: rgba(188, 240, 218, var(--bg-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:bg-green-300 {\n    --bg-opacity: 1;\n    background-color: #84e1bc;\n    background-color: rgba(132, 225, 188, var(--bg-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:bg-green-400 {\n    --bg-opacity: 1;\n    background-color: #31c48d;\n    background-color: rgba(49, 196, 141, var(--bg-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:bg-green-500 {\n    --bg-opacity: 1;\n    background-color: #0e9f6e;\n    background-color: rgba(14, 159, 110, var(--bg-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:bg-green-600 {\n    --bg-opacity: 1;\n    background-color: #057a55;\n    background-color: rgba(5, 122, 85, var(--bg-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:bg-green-700 {\n    --bg-opacity: 1;\n    background-color: #046c4e;\n    background-color: rgba(4, 108, 78, var(--bg-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:bg-green-800 {\n    --bg-opacity: 1;\n    background-color: #03543f;\n    background-color: rgba(3, 84, 63, var(--bg-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:bg-green-900 {\n    --bg-opacity: 1;\n    background-color: #014737;\n    background-color: rgba(1, 71, 55, var(--bg-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:bg-teal-50 {\n    --bg-opacity: 1;\n    background-color: #edfafa;\n    background-color: rgba(237, 250, 250, var(--bg-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:bg-teal-100 {\n    --bg-opacity: 1;\n    background-color: #d5f5f6;\n    background-color: rgba(213, 245, 246, var(--bg-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:bg-teal-200 {\n    --bg-opacity: 1;\n    background-color: #afecef;\n    background-color: rgba(175, 236, 239, var(--bg-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:bg-teal-300 {\n    --bg-opacity: 1;\n    background-color: #7edce2;\n    background-color: rgba(126, 220, 226, var(--bg-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:bg-teal-400 {\n    --bg-opacity: 1;\n    background-color: #16bdca;\n    background-color: rgba(22, 189, 202, var(--bg-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:bg-teal-500 {\n    --bg-opacity: 1;\n    background-color: #0694a2;\n    background-color: rgba(6, 148, 162, var(--bg-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:bg-teal-600 {\n    --bg-opacity: 1;\n    background-color: #047481;\n    background-color: rgba(4, 116, 129, var(--bg-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:bg-teal-700 {\n    --bg-opacity: 1;\n    background-color: #036672;\n    background-color: rgba(3, 102, 114, var(--bg-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:bg-teal-800 {\n    --bg-opacity: 1;\n    background-color: #05505c;\n    background-color: rgba(5, 80, 92, var(--bg-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:bg-teal-900 {\n    --bg-opacity: 1;\n    background-color: #014451;\n    background-color: rgba(1, 68, 81, var(--bg-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:bg-blue-50 {\n    --bg-opacity: 1;\n    background-color: #ebf5ff;\n    background-color: rgba(235, 245, 255, var(--bg-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:bg-blue-100 {\n    --bg-opacity: 1;\n    background-color: #e1effe;\n    background-color: rgba(225, 239, 254, var(--bg-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:bg-blue-200 {\n    --bg-opacity: 1;\n    background-color: #c3ddfd;\n    background-color: rgba(195, 221, 253, var(--bg-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:bg-blue-300 {\n    --bg-opacity: 1;\n    background-color: #a4cafe;\n    background-color: rgba(164, 202, 254, var(--bg-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:bg-blue-400 {\n    --bg-opacity: 1;\n    background-color: #76a9fa;\n    background-color: rgba(118, 169, 250, var(--bg-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:bg-blue-500 {\n    --bg-opacity: 1;\n    background-color: #3f83f8;\n    background-color: rgba(63, 131, 248, var(--bg-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:bg-blue-600 {\n    --bg-opacity: 1;\n    background-color: #1c64f2;\n    background-color: rgba(28, 100, 242, var(--bg-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:bg-blue-700 {\n    --bg-opacity: 1;\n    background-color: #1a56db;\n    background-color: rgba(26, 86, 219, var(--bg-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:bg-blue-800 {\n    --bg-opacity: 1;\n    background-color: #1e429f;\n    background-color: rgba(30, 66, 159, var(--bg-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:bg-blue-900 {\n    --bg-opacity: 1;\n    background-color: #233876;\n    background-color: rgba(35, 56, 118, var(--bg-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:bg-indigo-50 {\n    --bg-opacity: 1;\n    background-color: #f0f5ff;\n    background-color: rgba(240, 245, 255, var(--bg-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:bg-indigo-100 {\n    --bg-opacity: 1;\n    background-color: #e5edff;\n    background-color: rgba(229, 237, 255, var(--bg-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:bg-indigo-200 {\n    --bg-opacity: 1;\n    background-color: #cddbfe;\n    background-color: rgba(205, 219, 254, var(--bg-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:bg-indigo-300 {\n    --bg-opacity: 1;\n    background-color: #b4c6fc;\n    background-color: rgba(180, 198, 252, var(--bg-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:bg-indigo-400 {\n    --bg-opacity: 1;\n    background-color: #8da2fb;\n    background-color: rgba(141, 162, 251, var(--bg-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:bg-indigo-500 {\n    --bg-opacity: 1;\n    background-color: #6875f5;\n    background-color: rgba(104, 117, 245, var(--bg-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:bg-indigo-600 {\n    --bg-opacity: 1;\n    background-color: #5850ec;\n    background-color: rgba(88, 80, 236, var(--bg-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:bg-indigo-700 {\n    --bg-opacity: 1;\n    background-color: #5145cd;\n    background-color: rgba(81, 69, 205, var(--bg-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:bg-indigo-800 {\n    --bg-opacity: 1;\n    background-color: #42389d;\n    background-color: rgba(66, 56, 157, var(--bg-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:bg-indigo-900 {\n    --bg-opacity: 1;\n    background-color: #362f78;\n    background-color: rgba(54, 47, 120, var(--bg-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:bg-purple-50 {\n    --bg-opacity: 1;\n    background-color: #f6f5ff;\n    background-color: rgba(246, 245, 255, var(--bg-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:bg-purple-100 {\n    --bg-opacity: 1;\n    background-color: #edebfe;\n    background-color: rgba(237, 235, 254, var(--bg-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:bg-purple-200 {\n    --bg-opacity: 1;\n    background-color: #dcd7fe;\n    background-color: rgba(220, 215, 254, var(--bg-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:bg-purple-300 {\n    --bg-opacity: 1;\n    background-color: #cabffd;\n    background-color: rgba(202, 191, 253, var(--bg-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:bg-purple-400 {\n    --bg-opacity: 1;\n    background-color: #ac94fa;\n    background-color: rgba(172, 148, 250, var(--bg-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:bg-purple-500 {\n    --bg-opacity: 1;\n    background-color: #9061f9;\n    background-color: rgba(144, 97, 249, var(--bg-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:bg-purple-600 {\n    --bg-opacity: 1;\n    background-color: #7e3af2;\n    background-color: rgba(126, 58, 242, var(--bg-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:bg-purple-700 {\n    --bg-opacity: 1;\n    background-color: #6c2bd9;\n    background-color: rgba(108, 43, 217, var(--bg-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:bg-purple-800 {\n    --bg-opacity: 1;\n    background-color: #5521b5;\n    background-color: rgba(85, 33, 181, var(--bg-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:bg-purple-900 {\n    --bg-opacity: 1;\n    background-color: #4a1d96;\n    background-color: rgba(74, 29, 150, var(--bg-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:bg-pink-50 {\n    --bg-opacity: 1;\n    background-color: #fdf2f8;\n    background-color: rgba(253, 242, 248, var(--bg-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:bg-pink-100 {\n    --bg-opacity: 1;\n    background-color: #fce8f3;\n    background-color: rgba(252, 232, 243, var(--bg-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:bg-pink-200 {\n    --bg-opacity: 1;\n    background-color: #fad1e8;\n    background-color: rgba(250, 209, 232, var(--bg-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:bg-pink-300 {\n    --bg-opacity: 1;\n    background-color: #f8b4d9;\n    background-color: rgba(248, 180, 217, var(--bg-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:bg-pink-400 {\n    --bg-opacity: 1;\n    background-color: #f17eb8;\n    background-color: rgba(241, 126, 184, var(--bg-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:bg-pink-500 {\n    --bg-opacity: 1;\n    background-color: #e74694;\n    background-color: rgba(231, 70, 148, var(--bg-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:bg-pink-600 {\n    --bg-opacity: 1;\n    background-color: #d61f69;\n    background-color: rgba(214, 31, 105, var(--bg-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:bg-pink-700 {\n    --bg-opacity: 1;\n    background-color: #bf125d;\n    background-color: rgba(191, 18, 93, var(--bg-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:bg-pink-800 {\n    --bg-opacity: 1;\n    background-color: #99154b;\n    background-color: rgba(153, 21, 75, var(--bg-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:bg-pink-900 {\n    --bg-opacity: 1;\n    background-color: #751a3d;\n    background-color: rgba(117, 26, 61, var(--bg-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:bg-cool-gray-50 {\n    --bg-opacity: 1;\n    background-color: #f8fafc;\n    background-color: rgba(248, 250, 252, var(--bg-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:bg-cool-gray-100 {\n    --bg-opacity: 1;\n    background-color: #f1f5f9;\n    background-color: rgba(241, 245, 249, var(--bg-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:bg-cool-gray-200 {\n    --bg-opacity: 1;\n    background-color: #e2e8f0;\n    background-color: rgba(226, 232, 240, var(--bg-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:bg-cool-gray-300 {\n    --bg-opacity: 1;\n    background-color: #cfd8e3;\n    background-color: rgba(207, 216, 227, var(--bg-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:bg-cool-gray-400 {\n    --bg-opacity: 1;\n    background-color: #97a6ba;\n    background-color: rgba(151, 166, 186, var(--bg-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:bg-cool-gray-500 {\n    --bg-opacity: 1;\n    background-color: #64748b;\n    background-color: rgba(100, 116, 139, var(--bg-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:bg-cool-gray-600 {\n    --bg-opacity: 1;\n    background-color: #475569;\n    background-color: rgba(71, 85, 105, var(--bg-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:bg-cool-gray-700 {\n    --bg-opacity: 1;\n    background-color: #364152;\n    background-color: rgba(54, 65, 82, var(--bg-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:bg-cool-gray-800 {\n    --bg-opacity: 1;\n    background-color: #27303f;\n    background-color: rgba(39, 48, 63, var(--bg-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:bg-cool-gray-900 {\n    --bg-opacity: 1;\n    background-color: #1a202e;\n    background-color: rgba(26, 32, 46, var(--bg-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:bg-current {\n    background-color: currentColor;\n  }\n  .group:focus .sm\\:group-focus\\:bg-transparent {\n    background-color: transparent;\n  }\n  .group:focus .sm\\:group-focus\\:bg-white {\n    --bg-opacity: 1;\n    background-color: #ffffff;\n    background-color: rgba(255, 255, 255, var(--bg-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:bg-black {\n    --bg-opacity: 1;\n    background-color: #000000;\n    background-color: rgba(0, 0, 0, var(--bg-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:bg-gray-50 {\n    --bg-opacity: 1;\n    background-color: #f9fafb;\n    background-color: rgba(249, 250, 251, var(--bg-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:bg-gray-100 {\n    --bg-opacity: 1;\n    background-color: #f4f5f7;\n    background-color: rgba(244, 245, 247, var(--bg-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:bg-gray-200 {\n    --bg-opacity: 1;\n    background-color: #e5e7eb;\n    background-color: rgba(229, 231, 235, var(--bg-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:bg-gray-300 {\n    --bg-opacity: 1;\n    background-color: #d2d6dc;\n    background-color: rgba(210, 214, 220, var(--bg-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:bg-gray-400 {\n    --bg-opacity: 1;\n    background-color: #9fa6b2;\n    background-color: rgba(159, 166, 178, var(--bg-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:bg-gray-500 {\n    --bg-opacity: 1;\n    background-color: #6b7280;\n    background-color: rgba(107, 114, 128, var(--bg-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:bg-gray-600 {\n    --bg-opacity: 1;\n    background-color: #4b5563;\n    background-color: rgba(75, 85, 99, var(--bg-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:bg-gray-700 {\n    --bg-opacity: 1;\n    background-color: #374151;\n    background-color: rgba(55, 65, 81, var(--bg-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:bg-gray-800 {\n    --bg-opacity: 1;\n    background-color: #252f3f;\n    background-color: rgba(37, 47, 63, var(--bg-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:bg-gray-900 {\n    --bg-opacity: 1;\n    background-color: #161e2e;\n    background-color: rgba(22, 30, 46, var(--bg-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:bg-red-50 {\n    --bg-opacity: 1;\n    background-color: #fdf2f2;\n    background-color: rgba(253, 242, 242, var(--bg-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:bg-red-100 {\n    --bg-opacity: 1;\n    background-color: #fde8e8;\n    background-color: rgba(253, 232, 232, var(--bg-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:bg-red-200 {\n    --bg-opacity: 1;\n    background-color: #fbd5d5;\n    background-color: rgba(251, 213, 213, var(--bg-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:bg-red-300 {\n    --bg-opacity: 1;\n    background-color: #f8b4b4;\n    background-color: rgba(248, 180, 180, var(--bg-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:bg-red-400 {\n    --bg-opacity: 1;\n    background-color: #f98080;\n    background-color: rgba(249, 128, 128, var(--bg-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:bg-red-500 {\n    --bg-opacity: 1;\n    background-color: #f05252;\n    background-color: rgba(240, 82, 82, var(--bg-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:bg-red-600 {\n    --bg-opacity: 1;\n    background-color: #e02424;\n    background-color: rgba(224, 36, 36, var(--bg-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:bg-red-700 {\n    --bg-opacity: 1;\n    background-color: #c81e1e;\n    background-color: rgba(200, 30, 30, var(--bg-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:bg-red-800 {\n    --bg-opacity: 1;\n    background-color: #9b1c1c;\n    background-color: rgba(155, 28, 28, var(--bg-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:bg-red-900 {\n    --bg-opacity: 1;\n    background-color: #771d1d;\n    background-color: rgba(119, 29, 29, var(--bg-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:bg-orange-50 {\n    --bg-opacity: 1;\n    background-color: #fff8f1;\n    background-color: rgba(255, 248, 241, var(--bg-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:bg-orange-100 {\n    --bg-opacity: 1;\n    background-color: #feecdc;\n    background-color: rgba(254, 236, 220, var(--bg-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:bg-orange-200 {\n    --bg-opacity: 1;\n    background-color: #fcd9bd;\n    background-color: rgba(252, 217, 189, var(--bg-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:bg-orange-300 {\n    --bg-opacity: 1;\n    background-color: #fdba8c;\n    background-color: rgba(253, 186, 140, var(--bg-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:bg-orange-400 {\n    --bg-opacity: 1;\n    background-color: #ff8a4c;\n    background-color: rgba(255, 138, 76, var(--bg-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:bg-orange-500 {\n    --bg-opacity: 1;\n    background-color: #ff5a1f;\n    background-color: rgba(255, 90, 31, var(--bg-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:bg-orange-600 {\n    --bg-opacity: 1;\n    background-color: #d03801;\n    background-color: rgba(208, 56, 1, var(--bg-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:bg-orange-700 {\n    --bg-opacity: 1;\n    background-color: #b43403;\n    background-color: rgba(180, 52, 3, var(--bg-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:bg-orange-800 {\n    --bg-opacity: 1;\n    background-color: #8a2c0d;\n    background-color: rgba(138, 44, 13, var(--bg-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:bg-orange-900 {\n    --bg-opacity: 1;\n    background-color: #73230d;\n    background-color: rgba(115, 35, 13, var(--bg-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:bg-yellow-50 {\n    --bg-opacity: 1;\n    background-color: #fdfdea;\n    background-color: rgba(253, 253, 234, var(--bg-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:bg-yellow-100 {\n    --bg-opacity: 1;\n    background-color: #fdf6b2;\n    background-color: rgba(253, 246, 178, var(--bg-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:bg-yellow-200 {\n    --bg-opacity: 1;\n    background-color: #fce96a;\n    background-color: rgba(252, 233, 106, var(--bg-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:bg-yellow-300 {\n    --bg-opacity: 1;\n    background-color: #faca15;\n    background-color: rgba(250, 202, 21, var(--bg-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:bg-yellow-400 {\n    --bg-opacity: 1;\n    background-color: #e3a008;\n    background-color: rgba(227, 160, 8, var(--bg-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:bg-yellow-500 {\n    --bg-opacity: 1;\n    background-color: #c27803;\n    background-color: rgba(194, 120, 3, var(--bg-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:bg-yellow-600 {\n    --bg-opacity: 1;\n    background-color: #9f580a;\n    background-color: rgba(159, 88, 10, var(--bg-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:bg-yellow-700 {\n    --bg-opacity: 1;\n    background-color: #8e4b10;\n    background-color: rgba(142, 75, 16, var(--bg-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:bg-yellow-800 {\n    --bg-opacity: 1;\n    background-color: #723b13;\n    background-color: rgba(114, 59, 19, var(--bg-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:bg-yellow-900 {\n    --bg-opacity: 1;\n    background-color: #633112;\n    background-color: rgba(99, 49, 18, var(--bg-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:bg-green-50 {\n    --bg-opacity: 1;\n    background-color: #f3faf7;\n    background-color: rgba(243, 250, 247, var(--bg-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:bg-green-100 {\n    --bg-opacity: 1;\n    background-color: #def7ec;\n    background-color: rgba(222, 247, 236, var(--bg-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:bg-green-200 {\n    --bg-opacity: 1;\n    background-color: #bcf0da;\n    background-color: rgba(188, 240, 218, var(--bg-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:bg-green-300 {\n    --bg-opacity: 1;\n    background-color: #84e1bc;\n    background-color: rgba(132, 225, 188, var(--bg-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:bg-green-400 {\n    --bg-opacity: 1;\n    background-color: #31c48d;\n    background-color: rgba(49, 196, 141, var(--bg-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:bg-green-500 {\n    --bg-opacity: 1;\n    background-color: #0e9f6e;\n    background-color: rgba(14, 159, 110, var(--bg-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:bg-green-600 {\n    --bg-opacity: 1;\n    background-color: #057a55;\n    background-color: rgba(5, 122, 85, var(--bg-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:bg-green-700 {\n    --bg-opacity: 1;\n    background-color: #046c4e;\n    background-color: rgba(4, 108, 78, var(--bg-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:bg-green-800 {\n    --bg-opacity: 1;\n    background-color: #03543f;\n    background-color: rgba(3, 84, 63, var(--bg-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:bg-green-900 {\n    --bg-opacity: 1;\n    background-color: #014737;\n    background-color: rgba(1, 71, 55, var(--bg-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:bg-teal-50 {\n    --bg-opacity: 1;\n    background-color: #edfafa;\n    background-color: rgba(237, 250, 250, var(--bg-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:bg-teal-100 {\n    --bg-opacity: 1;\n    background-color: #d5f5f6;\n    background-color: rgba(213, 245, 246, var(--bg-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:bg-teal-200 {\n    --bg-opacity: 1;\n    background-color: #afecef;\n    background-color: rgba(175, 236, 239, var(--bg-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:bg-teal-300 {\n    --bg-opacity: 1;\n    background-color: #7edce2;\n    background-color: rgba(126, 220, 226, var(--bg-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:bg-teal-400 {\n    --bg-opacity: 1;\n    background-color: #16bdca;\n    background-color: rgba(22, 189, 202, var(--bg-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:bg-teal-500 {\n    --bg-opacity: 1;\n    background-color: #0694a2;\n    background-color: rgba(6, 148, 162, var(--bg-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:bg-teal-600 {\n    --bg-opacity: 1;\n    background-color: #047481;\n    background-color: rgba(4, 116, 129, var(--bg-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:bg-teal-700 {\n    --bg-opacity: 1;\n    background-color: #036672;\n    background-color: rgba(3, 102, 114, var(--bg-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:bg-teal-800 {\n    --bg-opacity: 1;\n    background-color: #05505c;\n    background-color: rgba(5, 80, 92, var(--bg-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:bg-teal-900 {\n    --bg-opacity: 1;\n    background-color: #014451;\n    background-color: rgba(1, 68, 81, var(--bg-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:bg-blue-50 {\n    --bg-opacity: 1;\n    background-color: #ebf5ff;\n    background-color: rgba(235, 245, 255, var(--bg-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:bg-blue-100 {\n    --bg-opacity: 1;\n    background-color: #e1effe;\n    background-color: rgba(225, 239, 254, var(--bg-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:bg-blue-200 {\n    --bg-opacity: 1;\n    background-color: #c3ddfd;\n    background-color: rgba(195, 221, 253, var(--bg-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:bg-blue-300 {\n    --bg-opacity: 1;\n    background-color: #a4cafe;\n    background-color: rgba(164, 202, 254, var(--bg-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:bg-blue-400 {\n    --bg-opacity: 1;\n    background-color: #76a9fa;\n    background-color: rgba(118, 169, 250, var(--bg-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:bg-blue-500 {\n    --bg-opacity: 1;\n    background-color: #3f83f8;\n    background-color: rgba(63, 131, 248, var(--bg-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:bg-blue-600 {\n    --bg-opacity: 1;\n    background-color: #1c64f2;\n    background-color: rgba(28, 100, 242, var(--bg-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:bg-blue-700 {\n    --bg-opacity: 1;\n    background-color: #1a56db;\n    background-color: rgba(26, 86, 219, var(--bg-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:bg-blue-800 {\n    --bg-opacity: 1;\n    background-color: #1e429f;\n    background-color: rgba(30, 66, 159, var(--bg-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:bg-blue-900 {\n    --bg-opacity: 1;\n    background-color: #233876;\n    background-color: rgba(35, 56, 118, var(--bg-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:bg-indigo-50 {\n    --bg-opacity: 1;\n    background-color: #f0f5ff;\n    background-color: rgba(240, 245, 255, var(--bg-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:bg-indigo-100 {\n    --bg-opacity: 1;\n    background-color: #e5edff;\n    background-color: rgba(229, 237, 255, var(--bg-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:bg-indigo-200 {\n    --bg-opacity: 1;\n    background-color: #cddbfe;\n    background-color: rgba(205, 219, 254, var(--bg-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:bg-indigo-300 {\n    --bg-opacity: 1;\n    background-color: #b4c6fc;\n    background-color: rgba(180, 198, 252, var(--bg-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:bg-indigo-400 {\n    --bg-opacity: 1;\n    background-color: #8da2fb;\n    background-color: rgba(141, 162, 251, var(--bg-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:bg-indigo-500 {\n    --bg-opacity: 1;\n    background-color: #6875f5;\n    background-color: rgba(104, 117, 245, var(--bg-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:bg-indigo-600 {\n    --bg-opacity: 1;\n    background-color: #5850ec;\n    background-color: rgba(88, 80, 236, var(--bg-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:bg-indigo-700 {\n    --bg-opacity: 1;\n    background-color: #5145cd;\n    background-color: rgba(81, 69, 205, var(--bg-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:bg-indigo-800 {\n    --bg-opacity: 1;\n    background-color: #42389d;\n    background-color: rgba(66, 56, 157, var(--bg-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:bg-indigo-900 {\n    --bg-opacity: 1;\n    background-color: #362f78;\n    background-color: rgba(54, 47, 120, var(--bg-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:bg-purple-50 {\n    --bg-opacity: 1;\n    background-color: #f6f5ff;\n    background-color: rgba(246, 245, 255, var(--bg-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:bg-purple-100 {\n    --bg-opacity: 1;\n    background-color: #edebfe;\n    background-color: rgba(237, 235, 254, var(--bg-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:bg-purple-200 {\n    --bg-opacity: 1;\n    background-color: #dcd7fe;\n    background-color: rgba(220, 215, 254, var(--bg-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:bg-purple-300 {\n    --bg-opacity: 1;\n    background-color: #cabffd;\n    background-color: rgba(202, 191, 253, var(--bg-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:bg-purple-400 {\n    --bg-opacity: 1;\n    background-color: #ac94fa;\n    background-color: rgba(172, 148, 250, var(--bg-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:bg-purple-500 {\n    --bg-opacity: 1;\n    background-color: #9061f9;\n    background-color: rgba(144, 97, 249, var(--bg-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:bg-purple-600 {\n    --bg-opacity: 1;\n    background-color: #7e3af2;\n    background-color: rgba(126, 58, 242, var(--bg-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:bg-purple-700 {\n    --bg-opacity: 1;\n    background-color: #6c2bd9;\n    background-color: rgba(108, 43, 217, var(--bg-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:bg-purple-800 {\n    --bg-opacity: 1;\n    background-color: #5521b5;\n    background-color: rgba(85, 33, 181, var(--bg-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:bg-purple-900 {\n    --bg-opacity: 1;\n    background-color: #4a1d96;\n    background-color: rgba(74, 29, 150, var(--bg-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:bg-pink-50 {\n    --bg-opacity: 1;\n    background-color: #fdf2f8;\n    background-color: rgba(253, 242, 248, var(--bg-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:bg-pink-100 {\n    --bg-opacity: 1;\n    background-color: #fce8f3;\n    background-color: rgba(252, 232, 243, var(--bg-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:bg-pink-200 {\n    --bg-opacity: 1;\n    background-color: #fad1e8;\n    background-color: rgba(250, 209, 232, var(--bg-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:bg-pink-300 {\n    --bg-opacity: 1;\n    background-color: #f8b4d9;\n    background-color: rgba(248, 180, 217, var(--bg-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:bg-pink-400 {\n    --bg-opacity: 1;\n    background-color: #f17eb8;\n    background-color: rgba(241, 126, 184, var(--bg-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:bg-pink-500 {\n    --bg-opacity: 1;\n    background-color: #e74694;\n    background-color: rgba(231, 70, 148, var(--bg-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:bg-pink-600 {\n    --bg-opacity: 1;\n    background-color: #d61f69;\n    background-color: rgba(214, 31, 105, var(--bg-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:bg-pink-700 {\n    --bg-opacity: 1;\n    background-color: #bf125d;\n    background-color: rgba(191, 18, 93, var(--bg-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:bg-pink-800 {\n    --bg-opacity: 1;\n    background-color: #99154b;\n    background-color: rgba(153, 21, 75, var(--bg-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:bg-pink-900 {\n    --bg-opacity: 1;\n    background-color: #751a3d;\n    background-color: rgba(117, 26, 61, var(--bg-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:bg-cool-gray-50 {\n    --bg-opacity: 1;\n    background-color: #f8fafc;\n    background-color: rgba(248, 250, 252, var(--bg-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:bg-cool-gray-100 {\n    --bg-opacity: 1;\n    background-color: #f1f5f9;\n    background-color: rgba(241, 245, 249, var(--bg-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:bg-cool-gray-200 {\n    --bg-opacity: 1;\n    background-color: #e2e8f0;\n    background-color: rgba(226, 232, 240, var(--bg-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:bg-cool-gray-300 {\n    --bg-opacity: 1;\n    background-color: #cfd8e3;\n    background-color: rgba(207, 216, 227, var(--bg-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:bg-cool-gray-400 {\n    --bg-opacity: 1;\n    background-color: #97a6ba;\n    background-color: rgba(151, 166, 186, var(--bg-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:bg-cool-gray-500 {\n    --bg-opacity: 1;\n    background-color: #64748b;\n    background-color: rgba(100, 116, 139, var(--bg-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:bg-cool-gray-600 {\n    --bg-opacity: 1;\n    background-color: #475569;\n    background-color: rgba(71, 85, 105, var(--bg-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:bg-cool-gray-700 {\n    --bg-opacity: 1;\n    background-color: #364152;\n    background-color: rgba(54, 65, 82, var(--bg-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:bg-cool-gray-800 {\n    --bg-opacity: 1;\n    background-color: #27303f;\n    background-color: rgba(39, 48, 63, var(--bg-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:bg-cool-gray-900 {\n    --bg-opacity: 1;\n    background-color: #1a202e;\n    background-color: rgba(26, 32, 46, var(--bg-opacity));\n  }\n  .sm\\:hover\\:bg-current:hover {\n    background-color: currentColor;\n  }\n  .sm\\:hover\\:bg-transparent:hover {\n    background-color: transparent;\n  }\n  .sm\\:hover\\:bg-white:hover {\n    --bg-opacity: 1;\n    background-color: #ffffff;\n    background-color: rgba(255, 255, 255, var(--bg-opacity));\n  }\n  .sm\\:hover\\:bg-black:hover {\n    --bg-opacity: 1;\n    background-color: #000000;\n    background-color: rgba(0, 0, 0, var(--bg-opacity));\n  }\n  .sm\\:hover\\:bg-gray-50:hover {\n    --bg-opacity: 1;\n    background-color: #f9fafb;\n    background-color: rgba(249, 250, 251, var(--bg-opacity));\n  }\n  .sm\\:hover\\:bg-gray-100:hover {\n    --bg-opacity: 1;\n    background-color: #f4f5f7;\n    background-color: rgba(244, 245, 247, var(--bg-opacity));\n  }\n  .sm\\:hover\\:bg-gray-200:hover {\n    --bg-opacity: 1;\n    background-color: #e5e7eb;\n    background-color: rgba(229, 231, 235, var(--bg-opacity));\n  }\n  .sm\\:hover\\:bg-gray-300:hover {\n    --bg-opacity: 1;\n    background-color: #d2d6dc;\n    background-color: rgba(210, 214, 220, var(--bg-opacity));\n  }\n  .sm\\:hover\\:bg-gray-400:hover {\n    --bg-opacity: 1;\n    background-color: #9fa6b2;\n    background-color: rgba(159, 166, 178, var(--bg-opacity));\n  }\n  .sm\\:hover\\:bg-gray-500:hover {\n    --bg-opacity: 1;\n    background-color: #6b7280;\n    background-color: rgba(107, 114, 128, var(--bg-opacity));\n  }\n  .sm\\:hover\\:bg-gray-600:hover {\n    --bg-opacity: 1;\n    background-color: #4b5563;\n    background-color: rgba(75, 85, 99, var(--bg-opacity));\n  }\n  .sm\\:hover\\:bg-gray-700:hover {\n    --bg-opacity: 1;\n    background-color: #374151;\n    background-color: rgba(55, 65, 81, var(--bg-opacity));\n  }\n  .sm\\:hover\\:bg-gray-800:hover {\n    --bg-opacity: 1;\n    background-color: #252f3f;\n    background-color: rgba(37, 47, 63, var(--bg-opacity));\n  }\n  .sm\\:hover\\:bg-gray-900:hover {\n    --bg-opacity: 1;\n    background-color: #161e2e;\n    background-color: rgba(22, 30, 46, var(--bg-opacity));\n  }\n  .sm\\:hover\\:bg-red-50:hover {\n    --bg-opacity: 1;\n    background-color: #fdf2f2;\n    background-color: rgba(253, 242, 242, var(--bg-opacity));\n  }\n  .sm\\:hover\\:bg-red-100:hover {\n    --bg-opacity: 1;\n    background-color: #fde8e8;\n    background-color: rgba(253, 232, 232, var(--bg-opacity));\n  }\n  .sm\\:hover\\:bg-red-200:hover {\n    --bg-opacity: 1;\n    background-color: #fbd5d5;\n    background-color: rgba(251, 213, 213, var(--bg-opacity));\n  }\n  .sm\\:hover\\:bg-red-300:hover {\n    --bg-opacity: 1;\n    background-color: #f8b4b4;\n    background-color: rgba(248, 180, 180, var(--bg-opacity));\n  }\n  .sm\\:hover\\:bg-red-400:hover {\n    --bg-opacity: 1;\n    background-color: #f98080;\n    background-color: rgba(249, 128, 128, var(--bg-opacity));\n  }\n  .sm\\:hover\\:bg-red-500:hover {\n    --bg-opacity: 1;\n    background-color: #f05252;\n    background-color: rgba(240, 82, 82, var(--bg-opacity));\n  }\n  .sm\\:hover\\:bg-red-600:hover {\n    --bg-opacity: 1;\n    background-color: #e02424;\n    background-color: rgba(224, 36, 36, var(--bg-opacity));\n  }\n  .sm\\:hover\\:bg-red-700:hover {\n    --bg-opacity: 1;\n    background-color: #c81e1e;\n    background-color: rgba(200, 30, 30, var(--bg-opacity));\n  }\n  .sm\\:hover\\:bg-red-800:hover {\n    --bg-opacity: 1;\n    background-color: #9b1c1c;\n    background-color: rgba(155, 28, 28, var(--bg-opacity));\n  }\n  .sm\\:hover\\:bg-red-900:hover {\n    --bg-opacity: 1;\n    background-color: #771d1d;\n    background-color: rgba(119, 29, 29, var(--bg-opacity));\n  }\n  .sm\\:hover\\:bg-orange-50:hover {\n    --bg-opacity: 1;\n    background-color: #fff8f1;\n    background-color: rgba(255, 248, 241, var(--bg-opacity));\n  }\n  .sm\\:hover\\:bg-orange-100:hover {\n    --bg-opacity: 1;\n    background-color: #feecdc;\n    background-color: rgba(254, 236, 220, var(--bg-opacity));\n  }\n  .sm\\:hover\\:bg-orange-200:hover {\n    --bg-opacity: 1;\n    background-color: #fcd9bd;\n    background-color: rgba(252, 217, 189, var(--bg-opacity));\n  }\n  .sm\\:hover\\:bg-orange-300:hover {\n    --bg-opacity: 1;\n    background-color: #fdba8c;\n    background-color: rgba(253, 186, 140, var(--bg-opacity));\n  }\n  .sm\\:hover\\:bg-orange-400:hover {\n    --bg-opacity: 1;\n    background-color: #ff8a4c;\n    background-color: rgba(255, 138, 76, var(--bg-opacity));\n  }\n  .sm\\:hover\\:bg-orange-500:hover {\n    --bg-opacity: 1;\n    background-color: #ff5a1f;\n    background-color: rgba(255, 90, 31, var(--bg-opacity));\n  }\n  .sm\\:hover\\:bg-orange-600:hover {\n    --bg-opacity: 1;\n    background-color: #d03801;\n    background-color: rgba(208, 56, 1, var(--bg-opacity));\n  }\n  .sm\\:hover\\:bg-orange-700:hover {\n    --bg-opacity: 1;\n    background-color: #b43403;\n    background-color: rgba(180, 52, 3, var(--bg-opacity));\n  }\n  .sm\\:hover\\:bg-orange-800:hover {\n    --bg-opacity: 1;\n    background-color: #8a2c0d;\n    background-color: rgba(138, 44, 13, var(--bg-opacity));\n  }\n  .sm\\:hover\\:bg-orange-900:hover {\n    --bg-opacity: 1;\n    background-color: #73230d;\n    background-color: rgba(115, 35, 13, var(--bg-opacity));\n  }\n  .sm\\:hover\\:bg-yellow-50:hover {\n    --bg-opacity: 1;\n    background-color: #fdfdea;\n    background-color: rgba(253, 253, 234, var(--bg-opacity));\n  }\n  .sm\\:hover\\:bg-yellow-100:hover {\n    --bg-opacity: 1;\n    background-color: #fdf6b2;\n    background-color: rgba(253, 246, 178, var(--bg-opacity));\n  }\n  .sm\\:hover\\:bg-yellow-200:hover {\n    --bg-opacity: 1;\n    background-color: #fce96a;\n    background-color: rgba(252, 233, 106, var(--bg-opacity));\n  }\n  .sm\\:hover\\:bg-yellow-300:hover {\n    --bg-opacity: 1;\n    background-color: #faca15;\n    background-color: rgba(250, 202, 21, var(--bg-opacity));\n  }\n  .sm\\:hover\\:bg-yellow-400:hover {\n    --bg-opacity: 1;\n    background-color: #e3a008;\n    background-color: rgba(227, 160, 8, var(--bg-opacity));\n  }\n  .sm\\:hover\\:bg-yellow-500:hover {\n    --bg-opacity: 1;\n    background-color: #c27803;\n    background-color: rgba(194, 120, 3, var(--bg-opacity));\n  }\n  .sm\\:hover\\:bg-yellow-600:hover {\n    --bg-opacity: 1;\n    background-color: #9f580a;\n    background-color: rgba(159, 88, 10, var(--bg-opacity));\n  }\n  .sm\\:hover\\:bg-yellow-700:hover {\n    --bg-opacity: 1;\n    background-color: #8e4b10;\n    background-color: rgba(142, 75, 16, var(--bg-opacity));\n  }\n  .sm\\:hover\\:bg-yellow-800:hover {\n    --bg-opacity: 1;\n    background-color: #723b13;\n    background-color: rgba(114, 59, 19, var(--bg-opacity));\n  }\n  .sm\\:hover\\:bg-yellow-900:hover {\n    --bg-opacity: 1;\n    background-color: #633112;\n    background-color: rgba(99, 49, 18, var(--bg-opacity));\n  }\n  .sm\\:hover\\:bg-green-50:hover {\n    --bg-opacity: 1;\n    background-color: #f3faf7;\n    background-color: rgba(243, 250, 247, var(--bg-opacity));\n  }\n  .sm\\:hover\\:bg-green-100:hover {\n    --bg-opacity: 1;\n    background-color: #def7ec;\n    background-color: rgba(222, 247, 236, var(--bg-opacity));\n  }\n  .sm\\:hover\\:bg-green-200:hover {\n    --bg-opacity: 1;\n    background-color: #bcf0da;\n    background-color: rgba(188, 240, 218, var(--bg-opacity));\n  }\n  .sm\\:hover\\:bg-green-300:hover {\n    --bg-opacity: 1;\n    background-color: #84e1bc;\n    background-color: rgba(132, 225, 188, var(--bg-opacity));\n  }\n  .sm\\:hover\\:bg-green-400:hover {\n    --bg-opacity: 1;\n    background-color: #31c48d;\n    background-color: rgba(49, 196, 141, var(--bg-opacity));\n  }\n  .sm\\:hover\\:bg-green-500:hover {\n    --bg-opacity: 1;\n    background-color: #0e9f6e;\n    background-color: rgba(14, 159, 110, var(--bg-opacity));\n  }\n  .sm\\:hover\\:bg-green-600:hover {\n    --bg-opacity: 1;\n    background-color: #057a55;\n    background-color: rgba(5, 122, 85, var(--bg-opacity));\n  }\n  .sm\\:hover\\:bg-green-700:hover {\n    --bg-opacity: 1;\n    background-color: #046c4e;\n    background-color: rgba(4, 108, 78, var(--bg-opacity));\n  }\n  .sm\\:hover\\:bg-green-800:hover {\n    --bg-opacity: 1;\n    background-color: #03543f;\n    background-color: rgba(3, 84, 63, var(--bg-opacity));\n  }\n  .sm\\:hover\\:bg-green-900:hover {\n    --bg-opacity: 1;\n    background-color: #014737;\n    background-color: rgba(1, 71, 55, var(--bg-opacity));\n  }\n  .sm\\:hover\\:bg-teal-50:hover {\n    --bg-opacity: 1;\n    background-color: #edfafa;\n    background-color: rgba(237, 250, 250, var(--bg-opacity));\n  }\n  .sm\\:hover\\:bg-teal-100:hover {\n    --bg-opacity: 1;\n    background-color: #d5f5f6;\n    background-color: rgba(213, 245, 246, var(--bg-opacity));\n  }\n  .sm\\:hover\\:bg-teal-200:hover {\n    --bg-opacity: 1;\n    background-color: #afecef;\n    background-color: rgba(175, 236, 239, var(--bg-opacity));\n  }\n  .sm\\:hover\\:bg-teal-300:hover {\n    --bg-opacity: 1;\n    background-color: #7edce2;\n    background-color: rgba(126, 220, 226, var(--bg-opacity));\n  }\n  .sm\\:hover\\:bg-teal-400:hover {\n    --bg-opacity: 1;\n    background-color: #16bdca;\n    background-color: rgba(22, 189, 202, var(--bg-opacity));\n  }\n  .sm\\:hover\\:bg-teal-500:hover {\n    --bg-opacity: 1;\n    background-color: #0694a2;\n    background-color: rgba(6, 148, 162, var(--bg-opacity));\n  }\n  .sm\\:hover\\:bg-teal-600:hover {\n    --bg-opacity: 1;\n    background-color: #047481;\n    background-color: rgba(4, 116, 129, var(--bg-opacity));\n  }\n  .sm\\:hover\\:bg-teal-700:hover {\n    --bg-opacity: 1;\n    background-color: #036672;\n    background-color: rgba(3, 102, 114, var(--bg-opacity));\n  }\n  .sm\\:hover\\:bg-teal-800:hover {\n    --bg-opacity: 1;\n    background-color: #05505c;\n    background-color: rgba(5, 80, 92, var(--bg-opacity));\n  }\n  .sm\\:hover\\:bg-teal-900:hover {\n    --bg-opacity: 1;\n    background-color: #014451;\n    background-color: rgba(1, 68, 81, var(--bg-opacity));\n  }\n  .sm\\:hover\\:bg-blue-50:hover {\n    --bg-opacity: 1;\n    background-color: #ebf5ff;\n    background-color: rgba(235, 245, 255, var(--bg-opacity));\n  }\n  .sm\\:hover\\:bg-blue-100:hover {\n    --bg-opacity: 1;\n    background-color: #e1effe;\n    background-color: rgba(225, 239, 254, var(--bg-opacity));\n  }\n  .sm\\:hover\\:bg-blue-200:hover {\n    --bg-opacity: 1;\n    background-color: #c3ddfd;\n    background-color: rgba(195, 221, 253, var(--bg-opacity));\n  }\n  .sm\\:hover\\:bg-blue-300:hover {\n    --bg-opacity: 1;\n    background-color: #a4cafe;\n    background-color: rgba(164, 202, 254, var(--bg-opacity));\n  }\n  .sm\\:hover\\:bg-blue-400:hover {\n    --bg-opacity: 1;\n    background-color: #76a9fa;\n    background-color: rgba(118, 169, 250, var(--bg-opacity));\n  }\n  .sm\\:hover\\:bg-blue-500:hover {\n    --bg-opacity: 1;\n    background-color: #3f83f8;\n    background-color: rgba(63, 131, 248, var(--bg-opacity));\n  }\n  .sm\\:hover\\:bg-blue-600:hover {\n    --bg-opacity: 1;\n    background-color: #1c64f2;\n    background-color: rgba(28, 100, 242, var(--bg-opacity));\n  }\n  .sm\\:hover\\:bg-blue-700:hover {\n    --bg-opacity: 1;\n    background-color: #1a56db;\n    background-color: rgba(26, 86, 219, var(--bg-opacity));\n  }\n  .sm\\:hover\\:bg-blue-800:hover {\n    --bg-opacity: 1;\n    background-color: #1e429f;\n    background-color: rgba(30, 66, 159, var(--bg-opacity));\n  }\n  .sm\\:hover\\:bg-blue-900:hover {\n    --bg-opacity: 1;\n    background-color: #233876;\n    background-color: rgba(35, 56, 118, var(--bg-opacity));\n  }\n  .sm\\:hover\\:bg-indigo-50:hover {\n    --bg-opacity: 1;\n    background-color: #f0f5ff;\n    background-color: rgba(240, 245, 255, var(--bg-opacity));\n  }\n  .sm\\:hover\\:bg-indigo-100:hover {\n    --bg-opacity: 1;\n    background-color: #e5edff;\n    background-color: rgba(229, 237, 255, var(--bg-opacity));\n  }\n  .sm\\:hover\\:bg-indigo-200:hover {\n    --bg-opacity: 1;\n    background-color: #cddbfe;\n    background-color: rgba(205, 219, 254, var(--bg-opacity));\n  }\n  .sm\\:hover\\:bg-indigo-300:hover {\n    --bg-opacity: 1;\n    background-color: #b4c6fc;\n    background-color: rgba(180, 198, 252, var(--bg-opacity));\n  }\n  .sm\\:hover\\:bg-indigo-400:hover {\n    --bg-opacity: 1;\n    background-color: #8da2fb;\n    background-color: rgba(141, 162, 251, var(--bg-opacity));\n  }\n  .sm\\:hover\\:bg-indigo-500:hover {\n    --bg-opacity: 1;\n    background-color: #6875f5;\n    background-color: rgba(104, 117, 245, var(--bg-opacity));\n  }\n  .sm\\:hover\\:bg-indigo-600:hover {\n    --bg-opacity: 1;\n    background-color: #5850ec;\n    background-color: rgba(88, 80, 236, var(--bg-opacity));\n  }\n  .sm\\:hover\\:bg-indigo-700:hover {\n    --bg-opacity: 1;\n    background-color: #5145cd;\n    background-color: rgba(81, 69, 205, var(--bg-opacity));\n  }\n  .sm\\:hover\\:bg-indigo-800:hover {\n    --bg-opacity: 1;\n    background-color: #42389d;\n    background-color: rgba(66, 56, 157, var(--bg-opacity));\n  }\n  .sm\\:hover\\:bg-indigo-900:hover {\n    --bg-opacity: 1;\n    background-color: #362f78;\n    background-color: rgba(54, 47, 120, var(--bg-opacity));\n  }\n  .sm\\:hover\\:bg-purple-50:hover {\n    --bg-opacity: 1;\n    background-color: #f6f5ff;\n    background-color: rgba(246, 245, 255, var(--bg-opacity));\n  }\n  .sm\\:hover\\:bg-purple-100:hover {\n    --bg-opacity: 1;\n    background-color: #edebfe;\n    background-color: rgba(237, 235, 254, var(--bg-opacity));\n  }\n  .sm\\:hover\\:bg-purple-200:hover {\n    --bg-opacity: 1;\n    background-color: #dcd7fe;\n    background-color: rgba(220, 215, 254, var(--bg-opacity));\n  }\n  .sm\\:hover\\:bg-purple-300:hover {\n    --bg-opacity: 1;\n    background-color: #cabffd;\n    background-color: rgba(202, 191, 253, var(--bg-opacity));\n  }\n  .sm\\:hover\\:bg-purple-400:hover {\n    --bg-opacity: 1;\n    background-color: #ac94fa;\n    background-color: rgba(172, 148, 250, var(--bg-opacity));\n  }\n  .sm\\:hover\\:bg-purple-500:hover {\n    --bg-opacity: 1;\n    background-color: #9061f9;\n    background-color: rgba(144, 97, 249, var(--bg-opacity));\n  }\n  .sm\\:hover\\:bg-purple-600:hover {\n    --bg-opacity: 1;\n    background-color: #7e3af2;\n    background-color: rgba(126, 58, 242, var(--bg-opacity));\n  }\n  .sm\\:hover\\:bg-purple-700:hover {\n    --bg-opacity: 1;\n    background-color: #6c2bd9;\n    background-color: rgba(108, 43, 217, var(--bg-opacity));\n  }\n  .sm\\:hover\\:bg-purple-800:hover {\n    --bg-opacity: 1;\n    background-color: #5521b5;\n    background-color: rgba(85, 33, 181, var(--bg-opacity));\n  }\n  .sm\\:hover\\:bg-purple-900:hover {\n    --bg-opacity: 1;\n    background-color: #4a1d96;\n    background-color: rgba(74, 29, 150, var(--bg-opacity));\n  }\n  .sm\\:hover\\:bg-pink-50:hover {\n    --bg-opacity: 1;\n    background-color: #fdf2f8;\n    background-color: rgba(253, 242, 248, var(--bg-opacity));\n  }\n  .sm\\:hover\\:bg-pink-100:hover {\n    --bg-opacity: 1;\n    background-color: #fce8f3;\n    background-color: rgba(252, 232, 243, var(--bg-opacity));\n  }\n  .sm\\:hover\\:bg-pink-200:hover {\n    --bg-opacity: 1;\n    background-color: #fad1e8;\n    background-color: rgba(250, 209, 232, var(--bg-opacity));\n  }\n  .sm\\:hover\\:bg-pink-300:hover {\n    --bg-opacity: 1;\n    background-color: #f8b4d9;\n    background-color: rgba(248, 180, 217, var(--bg-opacity));\n  }\n  .sm\\:hover\\:bg-pink-400:hover {\n    --bg-opacity: 1;\n    background-color: #f17eb8;\n    background-color: rgba(241, 126, 184, var(--bg-opacity));\n  }\n  .sm\\:hover\\:bg-pink-500:hover {\n    --bg-opacity: 1;\n    background-color: #e74694;\n    background-color: rgba(231, 70, 148, var(--bg-opacity));\n  }\n  .sm\\:hover\\:bg-pink-600:hover {\n    --bg-opacity: 1;\n    background-color: #d61f69;\n    background-color: rgba(214, 31, 105, var(--bg-opacity));\n  }\n  .sm\\:hover\\:bg-pink-700:hover {\n    --bg-opacity: 1;\n    background-color: #bf125d;\n    background-color: rgba(191, 18, 93, var(--bg-opacity));\n  }\n  .sm\\:hover\\:bg-pink-800:hover {\n    --bg-opacity: 1;\n    background-color: #99154b;\n    background-color: rgba(153, 21, 75, var(--bg-opacity));\n  }\n  .sm\\:hover\\:bg-pink-900:hover {\n    --bg-opacity: 1;\n    background-color: #751a3d;\n    background-color: rgba(117, 26, 61, var(--bg-opacity));\n  }\n  .sm\\:hover\\:bg-cool-gray-50:hover {\n    --bg-opacity: 1;\n    background-color: #f8fafc;\n    background-color: rgba(248, 250, 252, var(--bg-opacity));\n  }\n  .sm\\:hover\\:bg-cool-gray-100:hover {\n    --bg-opacity: 1;\n    background-color: #f1f5f9;\n    background-color: rgba(241, 245, 249, var(--bg-opacity));\n  }\n  .sm\\:hover\\:bg-cool-gray-200:hover {\n    --bg-opacity: 1;\n    background-color: #e2e8f0;\n    background-color: rgba(226, 232, 240, var(--bg-opacity));\n  }\n  .sm\\:hover\\:bg-cool-gray-300:hover {\n    --bg-opacity: 1;\n    background-color: #cfd8e3;\n    background-color: rgba(207, 216, 227, var(--bg-opacity));\n  }\n  .sm\\:hover\\:bg-cool-gray-400:hover {\n    --bg-opacity: 1;\n    background-color: #97a6ba;\n    background-color: rgba(151, 166, 186, var(--bg-opacity));\n  }\n  .sm\\:hover\\:bg-cool-gray-500:hover {\n    --bg-opacity: 1;\n    background-color: #64748b;\n    background-color: rgba(100, 116, 139, var(--bg-opacity));\n  }\n  .sm\\:hover\\:bg-cool-gray-600:hover {\n    --bg-opacity: 1;\n    background-color: #475569;\n    background-color: rgba(71, 85, 105, var(--bg-opacity));\n  }\n  .sm\\:hover\\:bg-cool-gray-700:hover {\n    --bg-opacity: 1;\n    background-color: #364152;\n    background-color: rgba(54, 65, 82, var(--bg-opacity));\n  }\n  .sm\\:hover\\:bg-cool-gray-800:hover {\n    --bg-opacity: 1;\n    background-color: #27303f;\n    background-color: rgba(39, 48, 63, var(--bg-opacity));\n  }\n  .sm\\:hover\\:bg-cool-gray-900:hover {\n    --bg-opacity: 1;\n    background-color: #1a202e;\n    background-color: rgba(26, 32, 46, var(--bg-opacity));\n  }\n  .sm\\:focus\\:bg-current:focus {\n    background-color: currentColor;\n  }\n  .sm\\:focus\\:bg-transparent:focus {\n    background-color: transparent;\n  }\n  .sm\\:focus\\:bg-white:focus {\n    --bg-opacity: 1;\n    background-color: #ffffff;\n    background-color: rgba(255, 255, 255, var(--bg-opacity));\n  }\n  .sm\\:focus\\:bg-black:focus {\n    --bg-opacity: 1;\n    background-color: #000000;\n    background-color: rgba(0, 0, 0, var(--bg-opacity));\n  }\n  .sm\\:focus\\:bg-gray-50:focus {\n    --bg-opacity: 1;\n    background-color: #f9fafb;\n    background-color: rgba(249, 250, 251, var(--bg-opacity));\n  }\n  .sm\\:focus\\:bg-gray-100:focus {\n    --bg-opacity: 1;\n    background-color: #f4f5f7;\n    background-color: rgba(244, 245, 247, var(--bg-opacity));\n  }\n  .sm\\:focus\\:bg-gray-200:focus {\n    --bg-opacity: 1;\n    background-color: #e5e7eb;\n    background-color: rgba(229, 231, 235, var(--bg-opacity));\n  }\n  .sm\\:focus\\:bg-gray-300:focus {\n    --bg-opacity: 1;\n    background-color: #d2d6dc;\n    background-color: rgba(210, 214, 220, var(--bg-opacity));\n  }\n  .sm\\:focus\\:bg-gray-400:focus {\n    --bg-opacity: 1;\n    background-color: #9fa6b2;\n    background-color: rgba(159, 166, 178, var(--bg-opacity));\n  }\n  .sm\\:focus\\:bg-gray-500:focus {\n    --bg-opacity: 1;\n    background-color: #6b7280;\n    background-color: rgba(107, 114, 128, var(--bg-opacity));\n  }\n  .sm\\:focus\\:bg-gray-600:focus {\n    --bg-opacity: 1;\n    background-color: #4b5563;\n    background-color: rgba(75, 85, 99, var(--bg-opacity));\n  }\n  .sm\\:focus\\:bg-gray-700:focus {\n    --bg-opacity: 1;\n    background-color: #374151;\n    background-color: rgba(55, 65, 81, var(--bg-opacity));\n  }\n  .sm\\:focus\\:bg-gray-800:focus {\n    --bg-opacity: 1;\n    background-color: #252f3f;\n    background-color: rgba(37, 47, 63, var(--bg-opacity));\n  }\n  .sm\\:focus\\:bg-gray-900:focus {\n    --bg-opacity: 1;\n    background-color: #161e2e;\n    background-color: rgba(22, 30, 46, var(--bg-opacity));\n  }\n  .sm\\:focus\\:bg-red-50:focus {\n    --bg-opacity: 1;\n    background-color: #fdf2f2;\n    background-color: rgba(253, 242, 242, var(--bg-opacity));\n  }\n  .sm\\:focus\\:bg-red-100:focus {\n    --bg-opacity: 1;\n    background-color: #fde8e8;\n    background-color: rgba(253, 232, 232, var(--bg-opacity));\n  }\n  .sm\\:focus\\:bg-red-200:focus {\n    --bg-opacity: 1;\n    background-color: #fbd5d5;\n    background-color: rgba(251, 213, 213, var(--bg-opacity));\n  }\n  .sm\\:focus\\:bg-red-300:focus {\n    --bg-opacity: 1;\n    background-color: #f8b4b4;\n    background-color: rgba(248, 180, 180, var(--bg-opacity));\n  }\n  .sm\\:focus\\:bg-red-400:focus {\n    --bg-opacity: 1;\n    background-color: #f98080;\n    background-color: rgba(249, 128, 128, var(--bg-opacity));\n  }\n  .sm\\:focus\\:bg-red-500:focus {\n    --bg-opacity: 1;\n    background-color: #f05252;\n    background-color: rgba(240, 82, 82, var(--bg-opacity));\n  }\n  .sm\\:focus\\:bg-red-600:focus {\n    --bg-opacity: 1;\n    background-color: #e02424;\n    background-color: rgba(224, 36, 36, var(--bg-opacity));\n  }\n  .sm\\:focus\\:bg-red-700:focus {\n    --bg-opacity: 1;\n    background-color: #c81e1e;\n    background-color: rgba(200, 30, 30, var(--bg-opacity));\n  }\n  .sm\\:focus\\:bg-red-800:focus {\n    --bg-opacity: 1;\n    background-color: #9b1c1c;\n    background-color: rgba(155, 28, 28, var(--bg-opacity));\n  }\n  .sm\\:focus\\:bg-red-900:focus {\n    --bg-opacity: 1;\n    background-color: #771d1d;\n    background-color: rgba(119, 29, 29, var(--bg-opacity));\n  }\n  .sm\\:focus\\:bg-orange-50:focus {\n    --bg-opacity: 1;\n    background-color: #fff8f1;\n    background-color: rgba(255, 248, 241, var(--bg-opacity));\n  }\n  .sm\\:focus\\:bg-orange-100:focus {\n    --bg-opacity: 1;\n    background-color: #feecdc;\n    background-color: rgba(254, 236, 220, var(--bg-opacity));\n  }\n  .sm\\:focus\\:bg-orange-200:focus {\n    --bg-opacity: 1;\n    background-color: #fcd9bd;\n    background-color: rgba(252, 217, 189, var(--bg-opacity));\n  }\n  .sm\\:focus\\:bg-orange-300:focus {\n    --bg-opacity: 1;\n    background-color: #fdba8c;\n    background-color: rgba(253, 186, 140, var(--bg-opacity));\n  }\n  .sm\\:focus\\:bg-orange-400:focus {\n    --bg-opacity: 1;\n    background-color: #ff8a4c;\n    background-color: rgba(255, 138, 76, var(--bg-opacity));\n  }\n  .sm\\:focus\\:bg-orange-500:focus {\n    --bg-opacity: 1;\n    background-color: #ff5a1f;\n    background-color: rgba(255, 90, 31, var(--bg-opacity));\n  }\n  .sm\\:focus\\:bg-orange-600:focus {\n    --bg-opacity: 1;\n    background-color: #d03801;\n    background-color: rgba(208, 56, 1, var(--bg-opacity));\n  }\n  .sm\\:focus\\:bg-orange-700:focus {\n    --bg-opacity: 1;\n    background-color: #b43403;\n    background-color: rgba(180, 52, 3, var(--bg-opacity));\n  }\n  .sm\\:focus\\:bg-orange-800:focus {\n    --bg-opacity: 1;\n    background-color: #8a2c0d;\n    background-color: rgba(138, 44, 13, var(--bg-opacity));\n  }\n  .sm\\:focus\\:bg-orange-900:focus {\n    --bg-opacity: 1;\n    background-color: #73230d;\n    background-color: rgba(115, 35, 13, var(--bg-opacity));\n  }\n  .sm\\:focus\\:bg-yellow-50:focus {\n    --bg-opacity: 1;\n    background-color: #fdfdea;\n    background-color: rgba(253, 253, 234, var(--bg-opacity));\n  }\n  .sm\\:focus\\:bg-yellow-100:focus {\n    --bg-opacity: 1;\n    background-color: #fdf6b2;\n    background-color: rgba(253, 246, 178, var(--bg-opacity));\n  }\n  .sm\\:focus\\:bg-yellow-200:focus {\n    --bg-opacity: 1;\n    background-color: #fce96a;\n    background-color: rgba(252, 233, 106, var(--bg-opacity));\n  }\n  .sm\\:focus\\:bg-yellow-300:focus {\n    --bg-opacity: 1;\n    background-color: #faca15;\n    background-color: rgba(250, 202, 21, var(--bg-opacity));\n  }\n  .sm\\:focus\\:bg-yellow-400:focus {\n    --bg-opacity: 1;\n    background-color: #e3a008;\n    background-color: rgba(227, 160, 8, var(--bg-opacity));\n  }\n  .sm\\:focus\\:bg-yellow-500:focus {\n    --bg-opacity: 1;\n    background-color: #c27803;\n    background-color: rgba(194, 120, 3, var(--bg-opacity));\n  }\n  .sm\\:focus\\:bg-yellow-600:focus {\n    --bg-opacity: 1;\n    background-color: #9f580a;\n    background-color: rgba(159, 88, 10, var(--bg-opacity));\n  }\n  .sm\\:focus\\:bg-yellow-700:focus {\n    --bg-opacity: 1;\n    background-color: #8e4b10;\n    background-color: rgba(142, 75, 16, var(--bg-opacity));\n  }\n  .sm\\:focus\\:bg-yellow-800:focus {\n    --bg-opacity: 1;\n    background-color: #723b13;\n    background-color: rgba(114, 59, 19, var(--bg-opacity));\n  }\n  .sm\\:focus\\:bg-yellow-900:focus {\n    --bg-opacity: 1;\n    background-color: #633112;\n    background-color: rgba(99, 49, 18, var(--bg-opacity));\n  }\n  .sm\\:focus\\:bg-green-50:focus {\n    --bg-opacity: 1;\n    background-color: #f3faf7;\n    background-color: rgba(243, 250, 247, var(--bg-opacity));\n  }\n  .sm\\:focus\\:bg-green-100:focus {\n    --bg-opacity: 1;\n    background-color: #def7ec;\n    background-color: rgba(222, 247, 236, var(--bg-opacity));\n  }\n  .sm\\:focus\\:bg-green-200:focus {\n    --bg-opacity: 1;\n    background-color: #bcf0da;\n    background-color: rgba(188, 240, 218, var(--bg-opacity));\n  }\n  .sm\\:focus\\:bg-green-300:focus {\n    --bg-opacity: 1;\n    background-color: #84e1bc;\n    background-color: rgba(132, 225, 188, var(--bg-opacity));\n  }\n  .sm\\:focus\\:bg-green-400:focus {\n    --bg-opacity: 1;\n    background-color: #31c48d;\n    background-color: rgba(49, 196, 141, var(--bg-opacity));\n  }\n  .sm\\:focus\\:bg-green-500:focus {\n    --bg-opacity: 1;\n    background-color: #0e9f6e;\n    background-color: rgba(14, 159, 110, var(--bg-opacity));\n  }\n  .sm\\:focus\\:bg-green-600:focus {\n    --bg-opacity: 1;\n    background-color: #057a55;\n    background-color: rgba(5, 122, 85, var(--bg-opacity));\n  }\n  .sm\\:focus\\:bg-green-700:focus {\n    --bg-opacity: 1;\n    background-color: #046c4e;\n    background-color: rgba(4, 108, 78, var(--bg-opacity));\n  }\n  .sm\\:focus\\:bg-green-800:focus {\n    --bg-opacity: 1;\n    background-color: #03543f;\n    background-color: rgba(3, 84, 63, var(--bg-opacity));\n  }\n  .sm\\:focus\\:bg-green-900:focus {\n    --bg-opacity: 1;\n    background-color: #014737;\n    background-color: rgba(1, 71, 55, var(--bg-opacity));\n  }\n  .sm\\:focus\\:bg-teal-50:focus {\n    --bg-opacity: 1;\n    background-color: #edfafa;\n    background-color: rgba(237, 250, 250, var(--bg-opacity));\n  }\n  .sm\\:focus\\:bg-teal-100:focus {\n    --bg-opacity: 1;\n    background-color: #d5f5f6;\n    background-color: rgba(213, 245, 246, var(--bg-opacity));\n  }\n  .sm\\:focus\\:bg-teal-200:focus {\n    --bg-opacity: 1;\n    background-color: #afecef;\n    background-color: rgba(175, 236, 239, var(--bg-opacity));\n  }\n  .sm\\:focus\\:bg-teal-300:focus {\n    --bg-opacity: 1;\n    background-color: #7edce2;\n    background-color: rgba(126, 220, 226, var(--bg-opacity));\n  }\n  .sm\\:focus\\:bg-teal-400:focus {\n    --bg-opacity: 1;\n    background-color: #16bdca;\n    background-color: rgba(22, 189, 202, var(--bg-opacity));\n  }\n  .sm\\:focus\\:bg-teal-500:focus {\n    --bg-opacity: 1;\n    background-color: #0694a2;\n    background-color: rgba(6, 148, 162, var(--bg-opacity));\n  }\n  .sm\\:focus\\:bg-teal-600:focus {\n    --bg-opacity: 1;\n    background-color: #047481;\n    background-color: rgba(4, 116, 129, var(--bg-opacity));\n  }\n  .sm\\:focus\\:bg-teal-700:focus {\n    --bg-opacity: 1;\n    background-color: #036672;\n    background-color: rgba(3, 102, 114, var(--bg-opacity));\n  }\n  .sm\\:focus\\:bg-teal-800:focus {\n    --bg-opacity: 1;\n    background-color: #05505c;\n    background-color: rgba(5, 80, 92, var(--bg-opacity));\n  }\n  .sm\\:focus\\:bg-teal-900:focus {\n    --bg-opacity: 1;\n    background-color: #014451;\n    background-color: rgba(1, 68, 81, var(--bg-opacity));\n  }\n  .sm\\:focus\\:bg-blue-50:focus {\n    --bg-opacity: 1;\n    background-color: #ebf5ff;\n    background-color: rgba(235, 245, 255, var(--bg-opacity));\n  }\n  .sm\\:focus\\:bg-blue-100:focus {\n    --bg-opacity: 1;\n    background-color: #e1effe;\n    background-color: rgba(225, 239, 254, var(--bg-opacity));\n  }\n  .sm\\:focus\\:bg-blue-200:focus {\n    --bg-opacity: 1;\n    background-color: #c3ddfd;\n    background-color: rgba(195, 221, 253, var(--bg-opacity));\n  }\n  .sm\\:focus\\:bg-blue-300:focus {\n    --bg-opacity: 1;\n    background-color: #a4cafe;\n    background-color: rgba(164, 202, 254, var(--bg-opacity));\n  }\n  .sm\\:focus\\:bg-blue-400:focus {\n    --bg-opacity: 1;\n    background-color: #76a9fa;\n    background-color: rgba(118, 169, 250, var(--bg-opacity));\n  }\n  .sm\\:focus\\:bg-blue-500:focus {\n    --bg-opacity: 1;\n    background-color: #3f83f8;\n    background-color: rgba(63, 131, 248, var(--bg-opacity));\n  }\n  .sm\\:focus\\:bg-blue-600:focus {\n    --bg-opacity: 1;\n    background-color: #1c64f2;\n    background-color: rgba(28, 100, 242, var(--bg-opacity));\n  }\n  .sm\\:focus\\:bg-blue-700:focus {\n    --bg-opacity: 1;\n    background-color: #1a56db;\n    background-color: rgba(26, 86, 219, var(--bg-opacity));\n  }\n  .sm\\:focus\\:bg-blue-800:focus {\n    --bg-opacity: 1;\n    background-color: #1e429f;\n    background-color: rgba(30, 66, 159, var(--bg-opacity));\n  }\n  .sm\\:focus\\:bg-blue-900:focus {\n    --bg-opacity: 1;\n    background-color: #233876;\n    background-color: rgba(35, 56, 118, var(--bg-opacity));\n  }\n  .sm\\:focus\\:bg-indigo-50:focus {\n    --bg-opacity: 1;\n    background-color: #f0f5ff;\n    background-color: rgba(240, 245, 255, var(--bg-opacity));\n  }\n  .sm\\:focus\\:bg-indigo-100:focus {\n    --bg-opacity: 1;\n    background-color: #e5edff;\n    background-color: rgba(229, 237, 255, var(--bg-opacity));\n  }\n  .sm\\:focus\\:bg-indigo-200:focus {\n    --bg-opacity: 1;\n    background-color: #cddbfe;\n    background-color: rgba(205, 219, 254, var(--bg-opacity));\n  }\n  .sm\\:focus\\:bg-indigo-300:focus {\n    --bg-opacity: 1;\n    background-color: #b4c6fc;\n    background-color: rgba(180, 198, 252, var(--bg-opacity));\n  }\n  .sm\\:focus\\:bg-indigo-400:focus {\n    --bg-opacity: 1;\n    background-color: #8da2fb;\n    background-color: rgba(141, 162, 251, var(--bg-opacity));\n  }\n  .sm\\:focus\\:bg-indigo-500:focus {\n    --bg-opacity: 1;\n    background-color: #6875f5;\n    background-color: rgba(104, 117, 245, var(--bg-opacity));\n  }\n  .sm\\:focus\\:bg-indigo-600:focus {\n    --bg-opacity: 1;\n    background-color: #5850ec;\n    background-color: rgba(88, 80, 236, var(--bg-opacity));\n  }\n  .sm\\:focus\\:bg-indigo-700:focus {\n    --bg-opacity: 1;\n    background-color: #5145cd;\n    background-color: rgba(81, 69, 205, var(--bg-opacity));\n  }\n  .sm\\:focus\\:bg-indigo-800:focus {\n    --bg-opacity: 1;\n    background-color: #42389d;\n    background-color: rgba(66, 56, 157, var(--bg-opacity));\n  }\n  .sm\\:focus\\:bg-indigo-900:focus {\n    --bg-opacity: 1;\n    background-color: #362f78;\n    background-color: rgba(54, 47, 120, var(--bg-opacity));\n  }\n  .sm\\:focus\\:bg-purple-50:focus {\n    --bg-opacity: 1;\n    background-color: #f6f5ff;\n    background-color: rgba(246, 245, 255, var(--bg-opacity));\n  }\n  .sm\\:focus\\:bg-purple-100:focus {\n    --bg-opacity: 1;\n    background-color: #edebfe;\n    background-color: rgba(237, 235, 254, var(--bg-opacity));\n  }\n  .sm\\:focus\\:bg-purple-200:focus {\n    --bg-opacity: 1;\n    background-color: #dcd7fe;\n    background-color: rgba(220, 215, 254, var(--bg-opacity));\n  }\n  .sm\\:focus\\:bg-purple-300:focus {\n    --bg-opacity: 1;\n    background-color: #cabffd;\n    background-color: rgba(202, 191, 253, var(--bg-opacity));\n  }\n  .sm\\:focus\\:bg-purple-400:focus {\n    --bg-opacity: 1;\n    background-color: #ac94fa;\n    background-color: rgba(172, 148, 250, var(--bg-opacity));\n  }\n  .sm\\:focus\\:bg-purple-500:focus {\n    --bg-opacity: 1;\n    background-color: #9061f9;\n    background-color: rgba(144, 97, 249, var(--bg-opacity));\n  }\n  .sm\\:focus\\:bg-purple-600:focus {\n    --bg-opacity: 1;\n    background-color: #7e3af2;\n    background-color: rgba(126, 58, 242, var(--bg-opacity));\n  }\n  .sm\\:focus\\:bg-purple-700:focus {\n    --bg-opacity: 1;\n    background-color: #6c2bd9;\n    background-color: rgba(108, 43, 217, var(--bg-opacity));\n  }\n  .sm\\:focus\\:bg-purple-800:focus {\n    --bg-opacity: 1;\n    background-color: #5521b5;\n    background-color: rgba(85, 33, 181, var(--bg-opacity));\n  }\n  .sm\\:focus\\:bg-purple-900:focus {\n    --bg-opacity: 1;\n    background-color: #4a1d96;\n    background-color: rgba(74, 29, 150, var(--bg-opacity));\n  }\n  .sm\\:focus\\:bg-pink-50:focus {\n    --bg-opacity: 1;\n    background-color: #fdf2f8;\n    background-color: rgba(253, 242, 248, var(--bg-opacity));\n  }\n  .sm\\:focus\\:bg-pink-100:focus {\n    --bg-opacity: 1;\n    background-color: #fce8f3;\n    background-color: rgba(252, 232, 243, var(--bg-opacity));\n  }\n  .sm\\:focus\\:bg-pink-200:focus {\n    --bg-opacity: 1;\n    background-color: #fad1e8;\n    background-color: rgba(250, 209, 232, var(--bg-opacity));\n  }\n  .sm\\:focus\\:bg-pink-300:focus {\n    --bg-opacity: 1;\n    background-color: #f8b4d9;\n    background-color: rgba(248, 180, 217, var(--bg-opacity));\n  }\n  .sm\\:focus\\:bg-pink-400:focus {\n    --bg-opacity: 1;\n    background-color: #f17eb8;\n    background-color: rgba(241, 126, 184, var(--bg-opacity));\n  }\n  .sm\\:focus\\:bg-pink-500:focus {\n    --bg-opacity: 1;\n    background-color: #e74694;\n    background-color: rgba(231, 70, 148, var(--bg-opacity));\n  }\n  .sm\\:focus\\:bg-pink-600:focus {\n    --bg-opacity: 1;\n    background-color: #d61f69;\n    background-color: rgba(214, 31, 105, var(--bg-opacity));\n  }\n  .sm\\:focus\\:bg-pink-700:focus {\n    --bg-opacity: 1;\n    background-color: #bf125d;\n    background-color: rgba(191, 18, 93, var(--bg-opacity));\n  }\n  .sm\\:focus\\:bg-pink-800:focus {\n    --bg-opacity: 1;\n    background-color: #99154b;\n    background-color: rgba(153, 21, 75, var(--bg-opacity));\n  }\n  .sm\\:focus\\:bg-pink-900:focus {\n    --bg-opacity: 1;\n    background-color: #751a3d;\n    background-color: rgba(117, 26, 61, var(--bg-opacity));\n  }\n  .sm\\:focus\\:bg-cool-gray-50:focus {\n    --bg-opacity: 1;\n    background-color: #f8fafc;\n    background-color: rgba(248, 250, 252, var(--bg-opacity));\n  }\n  .sm\\:focus\\:bg-cool-gray-100:focus {\n    --bg-opacity: 1;\n    background-color: #f1f5f9;\n    background-color: rgba(241, 245, 249, var(--bg-opacity));\n  }\n  .sm\\:focus\\:bg-cool-gray-200:focus {\n    --bg-opacity: 1;\n    background-color: #e2e8f0;\n    background-color: rgba(226, 232, 240, var(--bg-opacity));\n  }\n  .sm\\:focus\\:bg-cool-gray-300:focus {\n    --bg-opacity: 1;\n    background-color: #cfd8e3;\n    background-color: rgba(207, 216, 227, var(--bg-opacity));\n  }\n  .sm\\:focus\\:bg-cool-gray-400:focus {\n    --bg-opacity: 1;\n    background-color: #97a6ba;\n    background-color: rgba(151, 166, 186, var(--bg-opacity));\n  }\n  .sm\\:focus\\:bg-cool-gray-500:focus {\n    --bg-opacity: 1;\n    background-color: #64748b;\n    background-color: rgba(100, 116, 139, var(--bg-opacity));\n  }\n  .sm\\:focus\\:bg-cool-gray-600:focus {\n    --bg-opacity: 1;\n    background-color: #475569;\n    background-color: rgba(71, 85, 105, var(--bg-opacity));\n  }\n  .sm\\:focus\\:bg-cool-gray-700:focus {\n    --bg-opacity: 1;\n    background-color: #364152;\n    background-color: rgba(54, 65, 82, var(--bg-opacity));\n  }\n  .sm\\:focus\\:bg-cool-gray-800:focus {\n    --bg-opacity: 1;\n    background-color: #27303f;\n    background-color: rgba(39, 48, 63, var(--bg-opacity));\n  }\n  .sm\\:focus\\:bg-cool-gray-900:focus {\n    --bg-opacity: 1;\n    background-color: #1a202e;\n    background-color: rgba(26, 32, 46, var(--bg-opacity));\n  }\n  .sm\\:active\\:bg-current:active {\n    background-color: currentColor;\n  }\n  .sm\\:active\\:bg-transparent:active {\n    background-color: transparent;\n  }\n  .sm\\:active\\:bg-white:active {\n    --bg-opacity: 1;\n    background-color: #ffffff;\n    background-color: rgba(255, 255, 255, var(--bg-opacity));\n  }\n  .sm\\:active\\:bg-black:active {\n    --bg-opacity: 1;\n    background-color: #000000;\n    background-color: rgba(0, 0, 0, var(--bg-opacity));\n  }\n  .sm\\:active\\:bg-gray-50:active {\n    --bg-opacity: 1;\n    background-color: #f9fafb;\n    background-color: rgba(249, 250, 251, var(--bg-opacity));\n  }\n  .sm\\:active\\:bg-gray-100:active {\n    --bg-opacity: 1;\n    background-color: #f4f5f7;\n    background-color: rgba(244, 245, 247, var(--bg-opacity));\n  }\n  .sm\\:active\\:bg-gray-200:active {\n    --bg-opacity: 1;\n    background-color: #e5e7eb;\n    background-color: rgba(229, 231, 235, var(--bg-opacity));\n  }\n  .sm\\:active\\:bg-gray-300:active {\n    --bg-opacity: 1;\n    background-color: #d2d6dc;\n    background-color: rgba(210, 214, 220, var(--bg-opacity));\n  }\n  .sm\\:active\\:bg-gray-400:active {\n    --bg-opacity: 1;\n    background-color: #9fa6b2;\n    background-color: rgba(159, 166, 178, var(--bg-opacity));\n  }\n  .sm\\:active\\:bg-gray-500:active {\n    --bg-opacity: 1;\n    background-color: #6b7280;\n    background-color: rgba(107, 114, 128, var(--bg-opacity));\n  }\n  .sm\\:active\\:bg-gray-600:active {\n    --bg-opacity: 1;\n    background-color: #4b5563;\n    background-color: rgba(75, 85, 99, var(--bg-opacity));\n  }\n  .sm\\:active\\:bg-gray-700:active {\n    --bg-opacity: 1;\n    background-color: #374151;\n    background-color: rgba(55, 65, 81, var(--bg-opacity));\n  }\n  .sm\\:active\\:bg-gray-800:active {\n    --bg-opacity: 1;\n    background-color: #252f3f;\n    background-color: rgba(37, 47, 63, var(--bg-opacity));\n  }\n  .sm\\:active\\:bg-gray-900:active {\n    --bg-opacity: 1;\n    background-color: #161e2e;\n    background-color: rgba(22, 30, 46, var(--bg-opacity));\n  }\n  .sm\\:active\\:bg-red-50:active {\n    --bg-opacity: 1;\n    background-color: #fdf2f2;\n    background-color: rgba(253, 242, 242, var(--bg-opacity));\n  }\n  .sm\\:active\\:bg-red-100:active {\n    --bg-opacity: 1;\n    background-color: #fde8e8;\n    background-color: rgba(253, 232, 232, var(--bg-opacity));\n  }\n  .sm\\:active\\:bg-red-200:active {\n    --bg-opacity: 1;\n    background-color: #fbd5d5;\n    background-color: rgba(251, 213, 213, var(--bg-opacity));\n  }\n  .sm\\:active\\:bg-red-300:active {\n    --bg-opacity: 1;\n    background-color: #f8b4b4;\n    background-color: rgba(248, 180, 180, var(--bg-opacity));\n  }\n  .sm\\:active\\:bg-red-400:active {\n    --bg-opacity: 1;\n    background-color: #f98080;\n    background-color: rgba(249, 128, 128, var(--bg-opacity));\n  }\n  .sm\\:active\\:bg-red-500:active {\n    --bg-opacity: 1;\n    background-color: #f05252;\n    background-color: rgba(240, 82, 82, var(--bg-opacity));\n  }\n  .sm\\:active\\:bg-red-600:active {\n    --bg-opacity: 1;\n    background-color: #e02424;\n    background-color: rgba(224, 36, 36, var(--bg-opacity));\n  }\n  .sm\\:active\\:bg-red-700:active {\n    --bg-opacity: 1;\n    background-color: #c81e1e;\n    background-color: rgba(200, 30, 30, var(--bg-opacity));\n  }\n  .sm\\:active\\:bg-red-800:active {\n    --bg-opacity: 1;\n    background-color: #9b1c1c;\n    background-color: rgba(155, 28, 28, var(--bg-opacity));\n  }\n  .sm\\:active\\:bg-red-900:active {\n    --bg-opacity: 1;\n    background-color: #771d1d;\n    background-color: rgba(119, 29, 29, var(--bg-opacity));\n  }\n  .sm\\:active\\:bg-orange-50:active {\n    --bg-opacity: 1;\n    background-color: #fff8f1;\n    background-color: rgba(255, 248, 241, var(--bg-opacity));\n  }\n  .sm\\:active\\:bg-orange-100:active {\n    --bg-opacity: 1;\n    background-color: #feecdc;\n    background-color: rgba(254, 236, 220, var(--bg-opacity));\n  }\n  .sm\\:active\\:bg-orange-200:active {\n    --bg-opacity: 1;\n    background-color: #fcd9bd;\n    background-color: rgba(252, 217, 189, var(--bg-opacity));\n  }\n  .sm\\:active\\:bg-orange-300:active {\n    --bg-opacity: 1;\n    background-color: #fdba8c;\n    background-color: rgba(253, 186, 140, var(--bg-opacity));\n  }\n  .sm\\:active\\:bg-orange-400:active {\n    --bg-opacity: 1;\n    background-color: #ff8a4c;\n    background-color: rgba(255, 138, 76, var(--bg-opacity));\n  }\n  .sm\\:active\\:bg-orange-500:active {\n    --bg-opacity: 1;\n    background-color: #ff5a1f;\n    background-color: rgba(255, 90, 31, var(--bg-opacity));\n  }\n  .sm\\:active\\:bg-orange-600:active {\n    --bg-opacity: 1;\n    background-color: #d03801;\n    background-color: rgba(208, 56, 1, var(--bg-opacity));\n  }\n  .sm\\:active\\:bg-orange-700:active {\n    --bg-opacity: 1;\n    background-color: #b43403;\n    background-color: rgba(180, 52, 3, var(--bg-opacity));\n  }\n  .sm\\:active\\:bg-orange-800:active {\n    --bg-opacity: 1;\n    background-color: #8a2c0d;\n    background-color: rgba(138, 44, 13, var(--bg-opacity));\n  }\n  .sm\\:active\\:bg-orange-900:active {\n    --bg-opacity: 1;\n    background-color: #73230d;\n    background-color: rgba(115, 35, 13, var(--bg-opacity));\n  }\n  .sm\\:active\\:bg-yellow-50:active {\n    --bg-opacity: 1;\n    background-color: #fdfdea;\n    background-color: rgba(253, 253, 234, var(--bg-opacity));\n  }\n  .sm\\:active\\:bg-yellow-100:active {\n    --bg-opacity: 1;\n    background-color: #fdf6b2;\n    background-color: rgba(253, 246, 178, var(--bg-opacity));\n  }\n  .sm\\:active\\:bg-yellow-200:active {\n    --bg-opacity: 1;\n    background-color: #fce96a;\n    background-color: rgba(252, 233, 106, var(--bg-opacity));\n  }\n  .sm\\:active\\:bg-yellow-300:active {\n    --bg-opacity: 1;\n    background-color: #faca15;\n    background-color: rgba(250, 202, 21, var(--bg-opacity));\n  }\n  .sm\\:active\\:bg-yellow-400:active {\n    --bg-opacity: 1;\n    background-color: #e3a008;\n    background-color: rgba(227, 160, 8, var(--bg-opacity));\n  }\n  .sm\\:active\\:bg-yellow-500:active {\n    --bg-opacity: 1;\n    background-color: #c27803;\n    background-color: rgba(194, 120, 3, var(--bg-opacity));\n  }\n  .sm\\:active\\:bg-yellow-600:active {\n    --bg-opacity: 1;\n    background-color: #9f580a;\n    background-color: rgba(159, 88, 10, var(--bg-opacity));\n  }\n  .sm\\:active\\:bg-yellow-700:active {\n    --bg-opacity: 1;\n    background-color: #8e4b10;\n    background-color: rgba(142, 75, 16, var(--bg-opacity));\n  }\n  .sm\\:active\\:bg-yellow-800:active {\n    --bg-opacity: 1;\n    background-color: #723b13;\n    background-color: rgba(114, 59, 19, var(--bg-opacity));\n  }\n  .sm\\:active\\:bg-yellow-900:active {\n    --bg-opacity: 1;\n    background-color: #633112;\n    background-color: rgba(99, 49, 18, var(--bg-opacity));\n  }\n  .sm\\:active\\:bg-green-50:active {\n    --bg-opacity: 1;\n    background-color: #f3faf7;\n    background-color: rgba(243, 250, 247, var(--bg-opacity));\n  }\n  .sm\\:active\\:bg-green-100:active {\n    --bg-opacity: 1;\n    background-color: #def7ec;\n    background-color: rgba(222, 247, 236, var(--bg-opacity));\n  }\n  .sm\\:active\\:bg-green-200:active {\n    --bg-opacity: 1;\n    background-color: #bcf0da;\n    background-color: rgba(188, 240, 218, var(--bg-opacity));\n  }\n  .sm\\:active\\:bg-green-300:active {\n    --bg-opacity: 1;\n    background-color: #84e1bc;\n    background-color: rgba(132, 225, 188, var(--bg-opacity));\n  }\n  .sm\\:active\\:bg-green-400:active {\n    --bg-opacity: 1;\n    background-color: #31c48d;\n    background-color: rgba(49, 196, 141, var(--bg-opacity));\n  }\n  .sm\\:active\\:bg-green-500:active {\n    --bg-opacity: 1;\n    background-color: #0e9f6e;\n    background-color: rgba(14, 159, 110, var(--bg-opacity));\n  }\n  .sm\\:active\\:bg-green-600:active {\n    --bg-opacity: 1;\n    background-color: #057a55;\n    background-color: rgba(5, 122, 85, var(--bg-opacity));\n  }\n  .sm\\:active\\:bg-green-700:active {\n    --bg-opacity: 1;\n    background-color: #046c4e;\n    background-color: rgba(4, 108, 78, var(--bg-opacity));\n  }\n  .sm\\:active\\:bg-green-800:active {\n    --bg-opacity: 1;\n    background-color: #03543f;\n    background-color: rgba(3, 84, 63, var(--bg-opacity));\n  }\n  .sm\\:active\\:bg-green-900:active {\n    --bg-opacity: 1;\n    background-color: #014737;\n    background-color: rgba(1, 71, 55, var(--bg-opacity));\n  }\n  .sm\\:active\\:bg-teal-50:active {\n    --bg-opacity: 1;\n    background-color: #edfafa;\n    background-color: rgba(237, 250, 250, var(--bg-opacity));\n  }\n  .sm\\:active\\:bg-teal-100:active {\n    --bg-opacity: 1;\n    background-color: #d5f5f6;\n    background-color: rgba(213, 245, 246, var(--bg-opacity));\n  }\n  .sm\\:active\\:bg-teal-200:active {\n    --bg-opacity: 1;\n    background-color: #afecef;\n    background-color: rgba(175, 236, 239, var(--bg-opacity));\n  }\n  .sm\\:active\\:bg-teal-300:active {\n    --bg-opacity: 1;\n    background-color: #7edce2;\n    background-color: rgba(126, 220, 226, var(--bg-opacity));\n  }\n  .sm\\:active\\:bg-teal-400:active {\n    --bg-opacity: 1;\n    background-color: #16bdca;\n    background-color: rgba(22, 189, 202, var(--bg-opacity));\n  }\n  .sm\\:active\\:bg-teal-500:active {\n    --bg-opacity: 1;\n    background-color: #0694a2;\n    background-color: rgba(6, 148, 162, var(--bg-opacity));\n  }\n  .sm\\:active\\:bg-teal-600:active {\n    --bg-opacity: 1;\n    background-color: #047481;\n    background-color: rgba(4, 116, 129, var(--bg-opacity));\n  }\n  .sm\\:active\\:bg-teal-700:active {\n    --bg-opacity: 1;\n    background-color: #036672;\n    background-color: rgba(3, 102, 114, var(--bg-opacity));\n  }\n  .sm\\:active\\:bg-teal-800:active {\n    --bg-opacity: 1;\n    background-color: #05505c;\n    background-color: rgba(5, 80, 92, var(--bg-opacity));\n  }\n  .sm\\:active\\:bg-teal-900:active {\n    --bg-opacity: 1;\n    background-color: #014451;\n    background-color: rgba(1, 68, 81, var(--bg-opacity));\n  }\n  .sm\\:active\\:bg-blue-50:active {\n    --bg-opacity: 1;\n    background-color: #ebf5ff;\n    background-color: rgba(235, 245, 255, var(--bg-opacity));\n  }\n  .sm\\:active\\:bg-blue-100:active {\n    --bg-opacity: 1;\n    background-color: #e1effe;\n    background-color: rgba(225, 239, 254, var(--bg-opacity));\n  }\n  .sm\\:active\\:bg-blue-200:active {\n    --bg-opacity: 1;\n    background-color: #c3ddfd;\n    background-color: rgba(195, 221, 253, var(--bg-opacity));\n  }\n  .sm\\:active\\:bg-blue-300:active {\n    --bg-opacity: 1;\n    background-color: #a4cafe;\n    background-color: rgba(164, 202, 254, var(--bg-opacity));\n  }\n  .sm\\:active\\:bg-blue-400:active {\n    --bg-opacity: 1;\n    background-color: #76a9fa;\n    background-color: rgba(118, 169, 250, var(--bg-opacity));\n  }\n  .sm\\:active\\:bg-blue-500:active {\n    --bg-opacity: 1;\n    background-color: #3f83f8;\n    background-color: rgba(63, 131, 248, var(--bg-opacity));\n  }\n  .sm\\:active\\:bg-blue-600:active {\n    --bg-opacity: 1;\n    background-color: #1c64f2;\n    background-color: rgba(28, 100, 242, var(--bg-opacity));\n  }\n  .sm\\:active\\:bg-blue-700:active {\n    --bg-opacity: 1;\n    background-color: #1a56db;\n    background-color: rgba(26, 86, 219, var(--bg-opacity));\n  }\n  .sm\\:active\\:bg-blue-800:active {\n    --bg-opacity: 1;\n    background-color: #1e429f;\n    background-color: rgba(30, 66, 159, var(--bg-opacity));\n  }\n  .sm\\:active\\:bg-blue-900:active {\n    --bg-opacity: 1;\n    background-color: #233876;\n    background-color: rgba(35, 56, 118, var(--bg-opacity));\n  }\n  .sm\\:active\\:bg-indigo-50:active {\n    --bg-opacity: 1;\n    background-color: #f0f5ff;\n    background-color: rgba(240, 245, 255, var(--bg-opacity));\n  }\n  .sm\\:active\\:bg-indigo-100:active {\n    --bg-opacity: 1;\n    background-color: #e5edff;\n    background-color: rgba(229, 237, 255, var(--bg-opacity));\n  }\n  .sm\\:active\\:bg-indigo-200:active {\n    --bg-opacity: 1;\n    background-color: #cddbfe;\n    background-color: rgba(205, 219, 254, var(--bg-opacity));\n  }\n  .sm\\:active\\:bg-indigo-300:active {\n    --bg-opacity: 1;\n    background-color: #b4c6fc;\n    background-color: rgba(180, 198, 252, var(--bg-opacity));\n  }\n  .sm\\:active\\:bg-indigo-400:active {\n    --bg-opacity: 1;\n    background-color: #8da2fb;\n    background-color: rgba(141, 162, 251, var(--bg-opacity));\n  }\n  .sm\\:active\\:bg-indigo-500:active {\n    --bg-opacity: 1;\n    background-color: #6875f5;\n    background-color: rgba(104, 117, 245, var(--bg-opacity));\n  }\n  .sm\\:active\\:bg-indigo-600:active {\n    --bg-opacity: 1;\n    background-color: #5850ec;\n    background-color: rgba(88, 80, 236, var(--bg-opacity));\n  }\n  .sm\\:active\\:bg-indigo-700:active {\n    --bg-opacity: 1;\n    background-color: #5145cd;\n    background-color: rgba(81, 69, 205, var(--bg-opacity));\n  }\n  .sm\\:active\\:bg-indigo-800:active {\n    --bg-opacity: 1;\n    background-color: #42389d;\n    background-color: rgba(66, 56, 157, var(--bg-opacity));\n  }\n  .sm\\:active\\:bg-indigo-900:active {\n    --bg-opacity: 1;\n    background-color: #362f78;\n    background-color: rgba(54, 47, 120, var(--bg-opacity));\n  }\n  .sm\\:active\\:bg-purple-50:active {\n    --bg-opacity: 1;\n    background-color: #f6f5ff;\n    background-color: rgba(246, 245, 255, var(--bg-opacity));\n  }\n  .sm\\:active\\:bg-purple-100:active {\n    --bg-opacity: 1;\n    background-color: #edebfe;\n    background-color: rgba(237, 235, 254, var(--bg-opacity));\n  }\n  .sm\\:active\\:bg-purple-200:active {\n    --bg-opacity: 1;\n    background-color: #dcd7fe;\n    background-color: rgba(220, 215, 254, var(--bg-opacity));\n  }\n  .sm\\:active\\:bg-purple-300:active {\n    --bg-opacity: 1;\n    background-color: #cabffd;\n    background-color: rgba(202, 191, 253, var(--bg-opacity));\n  }\n  .sm\\:active\\:bg-purple-400:active {\n    --bg-opacity: 1;\n    background-color: #ac94fa;\n    background-color: rgba(172, 148, 250, var(--bg-opacity));\n  }\n  .sm\\:active\\:bg-purple-500:active {\n    --bg-opacity: 1;\n    background-color: #9061f9;\n    background-color: rgba(144, 97, 249, var(--bg-opacity));\n  }\n  .sm\\:active\\:bg-purple-600:active {\n    --bg-opacity: 1;\n    background-color: #7e3af2;\n    background-color: rgba(126, 58, 242, var(--bg-opacity));\n  }\n  .sm\\:active\\:bg-purple-700:active {\n    --bg-opacity: 1;\n    background-color: #6c2bd9;\n    background-color: rgba(108, 43, 217, var(--bg-opacity));\n  }\n  .sm\\:active\\:bg-purple-800:active {\n    --bg-opacity: 1;\n    background-color: #5521b5;\n    background-color: rgba(85, 33, 181, var(--bg-opacity));\n  }\n  .sm\\:active\\:bg-purple-900:active {\n    --bg-opacity: 1;\n    background-color: #4a1d96;\n    background-color: rgba(74, 29, 150, var(--bg-opacity));\n  }\n  .sm\\:active\\:bg-pink-50:active {\n    --bg-opacity: 1;\n    background-color: #fdf2f8;\n    background-color: rgba(253, 242, 248, var(--bg-opacity));\n  }\n  .sm\\:active\\:bg-pink-100:active {\n    --bg-opacity: 1;\n    background-color: #fce8f3;\n    background-color: rgba(252, 232, 243, var(--bg-opacity));\n  }\n  .sm\\:active\\:bg-pink-200:active {\n    --bg-opacity: 1;\n    background-color: #fad1e8;\n    background-color: rgba(250, 209, 232, var(--bg-opacity));\n  }\n  .sm\\:active\\:bg-pink-300:active {\n    --bg-opacity: 1;\n    background-color: #f8b4d9;\n    background-color: rgba(248, 180, 217, var(--bg-opacity));\n  }\n  .sm\\:active\\:bg-pink-400:active {\n    --bg-opacity: 1;\n    background-color: #f17eb8;\n    background-color: rgba(241, 126, 184, var(--bg-opacity));\n  }\n  .sm\\:active\\:bg-pink-500:active {\n    --bg-opacity: 1;\n    background-color: #e74694;\n    background-color: rgba(231, 70, 148, var(--bg-opacity));\n  }\n  .sm\\:active\\:bg-pink-600:active {\n    --bg-opacity: 1;\n    background-color: #d61f69;\n    background-color: rgba(214, 31, 105, var(--bg-opacity));\n  }\n  .sm\\:active\\:bg-pink-700:active {\n    --bg-opacity: 1;\n    background-color: #bf125d;\n    background-color: rgba(191, 18, 93, var(--bg-opacity));\n  }\n  .sm\\:active\\:bg-pink-800:active {\n    --bg-opacity: 1;\n    background-color: #99154b;\n    background-color: rgba(153, 21, 75, var(--bg-opacity));\n  }\n  .sm\\:active\\:bg-pink-900:active {\n    --bg-opacity: 1;\n    background-color: #751a3d;\n    background-color: rgba(117, 26, 61, var(--bg-opacity));\n  }\n  .sm\\:active\\:bg-cool-gray-50:active {\n    --bg-opacity: 1;\n    background-color: #f8fafc;\n    background-color: rgba(248, 250, 252, var(--bg-opacity));\n  }\n  .sm\\:active\\:bg-cool-gray-100:active {\n    --bg-opacity: 1;\n    background-color: #f1f5f9;\n    background-color: rgba(241, 245, 249, var(--bg-opacity));\n  }\n  .sm\\:active\\:bg-cool-gray-200:active {\n    --bg-opacity: 1;\n    background-color: #e2e8f0;\n    background-color: rgba(226, 232, 240, var(--bg-opacity));\n  }\n  .sm\\:active\\:bg-cool-gray-300:active {\n    --bg-opacity: 1;\n    background-color: #cfd8e3;\n    background-color: rgba(207, 216, 227, var(--bg-opacity));\n  }\n  .sm\\:active\\:bg-cool-gray-400:active {\n    --bg-opacity: 1;\n    background-color: #97a6ba;\n    background-color: rgba(151, 166, 186, var(--bg-opacity));\n  }\n  .sm\\:active\\:bg-cool-gray-500:active {\n    --bg-opacity: 1;\n    background-color: #64748b;\n    background-color: rgba(100, 116, 139, var(--bg-opacity));\n  }\n  .sm\\:active\\:bg-cool-gray-600:active {\n    --bg-opacity: 1;\n    background-color: #475569;\n    background-color: rgba(71, 85, 105, var(--bg-opacity));\n  }\n  .sm\\:active\\:bg-cool-gray-700:active {\n    --bg-opacity: 1;\n    background-color: #364152;\n    background-color: rgba(54, 65, 82, var(--bg-opacity));\n  }\n  .sm\\:active\\:bg-cool-gray-800:active {\n    --bg-opacity: 1;\n    background-color: #27303f;\n    background-color: rgba(39, 48, 63, var(--bg-opacity));\n  }\n  .sm\\:active\\:bg-cool-gray-900:active {\n    --bg-opacity: 1;\n    background-color: #1a202e;\n    background-color: rgba(26, 32, 46, var(--bg-opacity));\n  }\n  .sm\\:bg-none {\n    background-image: none;\n  }\n  .sm\\:bg-gradient-to-t {\n    background-image: linear-gradient(to top, var(--gradient-color-stops));\n  }\n  .sm\\:bg-gradient-to-tr {\n    background-image: linear-gradient(to top right, var(--gradient-color-stops));\n  }\n  .sm\\:bg-gradient-to-r {\n    background-image: linear-gradient(to right, var(--gradient-color-stops));\n  }\n  .sm\\:bg-gradient-to-br {\n    background-image: linear-gradient(to bottom right, var(--gradient-color-stops));\n  }\n  .sm\\:bg-gradient-to-b {\n    background-image: linear-gradient(to bottom, var(--gradient-color-stops));\n  }\n  .sm\\:bg-gradient-to-bl {\n    background-image: linear-gradient(to bottom left, var(--gradient-color-stops));\n  }\n  .sm\\:bg-gradient-to-l {\n    background-image: linear-gradient(to left, var(--gradient-color-stops));\n  }\n  .sm\\:bg-gradient-to-tl {\n    background-image: linear-gradient(to top left, var(--gradient-color-stops));\n  }\n  .sm\\:from-current {\n    --gradient-from-color: currentColor;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));\n  }\n  .sm\\:from-transparent {\n    --gradient-from-color: transparent;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0));\n  }\n  .sm\\:from-white {\n    --gradient-from-color: #ffffff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));\n  }\n  .sm\\:from-black {\n    --gradient-from-color: #000000;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0));\n  }\n  .sm\\:from-gray-50 {\n    --gradient-from-color: #f9fafb;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(249, 250, 251, 0));\n  }\n  .sm\\:from-gray-100 {\n    --gradient-from-color: #f4f5f7;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(244, 245, 247, 0));\n  }\n  .sm\\:from-gray-200 {\n    --gradient-from-color: #e5e7eb;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(229, 231, 235, 0));\n  }\n  .sm\\:from-gray-300 {\n    --gradient-from-color: #d2d6dc;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(210, 214, 220, 0));\n  }\n  .sm\\:from-gray-400 {\n    --gradient-from-color: #9fa6b2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(159, 166, 178, 0));\n  }\n  .sm\\:from-gray-500 {\n    --gradient-from-color: #6b7280;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(107, 114, 128, 0));\n  }\n  .sm\\:from-gray-600 {\n    --gradient-from-color: #4b5563;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(75, 85, 99, 0));\n  }\n  .sm\\:from-gray-700 {\n    --gradient-from-color: #374151;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(55, 65, 81, 0));\n  }\n  .sm\\:from-gray-800 {\n    --gradient-from-color: #252f3f;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(37, 47, 63, 0));\n  }\n  .sm\\:from-gray-900 {\n    --gradient-from-color: #161e2e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(22, 30, 46, 0));\n  }\n  .sm\\:from-red-50 {\n    --gradient-from-color: #fdf2f2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 242, 242, 0));\n  }\n  .sm\\:from-red-100 {\n    --gradient-from-color: #fde8e8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 232, 232, 0));\n  }\n  .sm\\:from-red-200 {\n    --gradient-from-color: #fbd5d5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(251, 213, 213, 0));\n  }\n  .sm\\:from-red-300 {\n    --gradient-from-color: #f8b4b4;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(248, 180, 180, 0));\n  }\n  .sm\\:from-red-400 {\n    --gradient-from-color: #f98080;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(249, 128, 128, 0));\n  }\n  .sm\\:from-red-500 {\n    --gradient-from-color: #f05252;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(240, 82, 82, 0));\n  }\n  .sm\\:from-red-600 {\n    --gradient-from-color: #e02424;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(224, 36, 36, 0));\n  }\n  .sm\\:from-red-700 {\n    --gradient-from-color: #c81e1e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(200, 30, 30, 0));\n  }\n  .sm\\:from-red-800 {\n    --gradient-from-color: #9b1c1c;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(155, 28, 28, 0));\n  }\n  .sm\\:from-red-900 {\n    --gradient-from-color: #771d1d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(119, 29, 29, 0));\n  }\n  .sm\\:from-orange-50 {\n    --gradient-from-color: #fff8f1;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 248, 241, 0));\n  }\n  .sm\\:from-orange-100 {\n    --gradient-from-color: #feecdc;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 236, 220, 0));\n  }\n  .sm\\:from-orange-200 {\n    --gradient-from-color: #fcd9bd;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(252, 217, 189, 0));\n  }\n  .sm\\:from-orange-300 {\n    --gradient-from-color: #fdba8c;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 186, 140, 0));\n  }\n  .sm\\:from-orange-400 {\n    --gradient-from-color: #ff8a4c;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 138, 76, 0));\n  }\n  .sm\\:from-orange-500 {\n    --gradient-from-color: #ff5a1f;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 90, 31, 0));\n  }\n  .sm\\:from-orange-600 {\n    --gradient-from-color: #d03801;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(208, 56, 1, 0));\n  }\n  .sm\\:from-orange-700 {\n    --gradient-from-color: #b43403;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(180, 52, 3, 0));\n  }\n  .sm\\:from-orange-800 {\n    --gradient-from-color: #8a2c0d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(138, 44, 13, 0));\n  }\n  .sm\\:from-orange-900 {\n    --gradient-from-color: #73230d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(115, 35, 13, 0));\n  }\n  .sm\\:from-yellow-50 {\n    --gradient-from-color: #fdfdea;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 253, 234, 0));\n  }\n  .sm\\:from-yellow-100 {\n    --gradient-from-color: #fdf6b2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 246, 178, 0));\n  }\n  .sm\\:from-yellow-200 {\n    --gradient-from-color: #fce96a;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(252, 233, 106, 0));\n  }\n  .sm\\:from-yellow-300 {\n    --gradient-from-color: #faca15;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(250, 202, 21, 0));\n  }\n  .sm\\:from-yellow-400 {\n    --gradient-from-color: #e3a008;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(227, 160, 8, 0));\n  }\n  .sm\\:from-yellow-500 {\n    --gradient-from-color: #c27803;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(194, 120, 3, 0));\n  }\n  .sm\\:from-yellow-600 {\n    --gradient-from-color: #9f580a;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(159, 88, 10, 0));\n  }\n  .sm\\:from-yellow-700 {\n    --gradient-from-color: #8e4b10;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(142, 75, 16, 0));\n  }\n  .sm\\:from-yellow-800 {\n    --gradient-from-color: #723b13;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(114, 59, 19, 0));\n  }\n  .sm\\:from-yellow-900 {\n    --gradient-from-color: #633112;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(99, 49, 18, 0));\n  }\n  .sm\\:from-green-50 {\n    --gradient-from-color: #f3faf7;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(243, 250, 247, 0));\n  }\n  .sm\\:from-green-100 {\n    --gradient-from-color: #def7ec;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(222, 247, 236, 0));\n  }\n  .sm\\:from-green-200 {\n    --gradient-from-color: #bcf0da;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(188, 240, 218, 0));\n  }\n  .sm\\:from-green-300 {\n    --gradient-from-color: #84e1bc;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(132, 225, 188, 0));\n  }\n  .sm\\:from-green-400 {\n    --gradient-from-color: #31c48d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(49, 196, 141, 0));\n  }\n  .sm\\:from-green-500 {\n    --gradient-from-color: #0e9f6e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(14, 159, 110, 0));\n  }\n  .sm\\:from-green-600 {\n    --gradient-from-color: #057a55;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(5, 122, 85, 0));\n  }\n  .sm\\:from-green-700 {\n    --gradient-from-color: #046c4e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(4, 108, 78, 0));\n  }\n  .sm\\:from-green-800 {\n    --gradient-from-color: #03543f;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(3, 84, 63, 0));\n  }\n  .sm\\:from-green-900 {\n    --gradient-from-color: #014737;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(1, 71, 55, 0));\n  }\n  .sm\\:from-teal-50 {\n    --gradient-from-color: #edfafa;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(237, 250, 250, 0));\n  }\n  .sm\\:from-teal-100 {\n    --gradient-from-color: #d5f5f6;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(213, 245, 246, 0));\n  }\n  .sm\\:from-teal-200 {\n    --gradient-from-color: #afecef;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(175, 236, 239, 0));\n  }\n  .sm\\:from-teal-300 {\n    --gradient-from-color: #7edce2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(126, 220, 226, 0));\n  }\n  .sm\\:from-teal-400 {\n    --gradient-from-color: #16bdca;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(22, 189, 202, 0));\n  }\n  .sm\\:from-teal-500 {\n    --gradient-from-color: #0694a2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(6, 148, 162, 0));\n  }\n  .sm\\:from-teal-600 {\n    --gradient-from-color: #047481;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(4, 116, 129, 0));\n  }\n  .sm\\:from-teal-700 {\n    --gradient-from-color: #036672;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(3, 102, 114, 0));\n  }\n  .sm\\:from-teal-800 {\n    --gradient-from-color: #05505c;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(5, 80, 92, 0));\n  }\n  .sm\\:from-teal-900 {\n    --gradient-from-color: #014451;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(1, 68, 81, 0));\n  }\n  .sm\\:from-blue-50 {\n    --gradient-from-color: #ebf5ff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(235, 245, 255, 0));\n  }\n  .sm\\:from-blue-100 {\n    --gradient-from-color: #e1effe;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(225, 239, 254, 0));\n  }\n  .sm\\:from-blue-200 {\n    --gradient-from-color: #c3ddfd;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(195, 221, 253, 0));\n  }\n  .sm\\:from-blue-300 {\n    --gradient-from-color: #a4cafe;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(164, 202, 254, 0));\n  }\n  .sm\\:from-blue-400 {\n    --gradient-from-color: #76a9fa;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(118, 169, 250, 0));\n  }\n  .sm\\:from-blue-500 {\n    --gradient-from-color: #3f83f8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(63, 131, 248, 0));\n  }\n  .sm\\:from-blue-600 {\n    --gradient-from-color: #1c64f2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(28, 100, 242, 0));\n  }\n  .sm\\:from-blue-700 {\n    --gradient-from-color: #1a56db;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(26, 86, 219, 0));\n  }\n  .sm\\:from-blue-800 {\n    --gradient-from-color: #1e429f;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(30, 66, 159, 0));\n  }\n  .sm\\:from-blue-900 {\n    --gradient-from-color: #233876;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(35, 56, 118, 0));\n  }\n  .sm\\:from-indigo-50 {\n    --gradient-from-color: #f0f5ff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(240, 245, 255, 0));\n  }\n  .sm\\:from-indigo-100 {\n    --gradient-from-color: #e5edff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(229, 237, 255, 0));\n  }\n  .sm\\:from-indigo-200 {\n    --gradient-from-color: #cddbfe;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(205, 219, 254, 0));\n  }\n  .sm\\:from-indigo-300 {\n    --gradient-from-color: #b4c6fc;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(180, 198, 252, 0));\n  }\n  .sm\\:from-indigo-400 {\n    --gradient-from-color: #8da2fb;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(141, 162, 251, 0));\n  }\n  .sm\\:from-indigo-500 {\n    --gradient-from-color: #6875f5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(104, 117, 245, 0));\n  }\n  .sm\\:from-indigo-600 {\n    --gradient-from-color: #5850ec;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(88, 80, 236, 0));\n  }\n  .sm\\:from-indigo-700 {\n    --gradient-from-color: #5145cd;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(81, 69, 205, 0));\n  }\n  .sm\\:from-indigo-800 {\n    --gradient-from-color: #42389d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(66, 56, 157, 0));\n  }\n  .sm\\:from-indigo-900 {\n    --gradient-from-color: #362f78;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(54, 47, 120, 0));\n  }\n  .sm\\:from-purple-50 {\n    --gradient-from-color: #f6f5ff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(246, 245, 255, 0));\n  }\n  .sm\\:from-purple-100 {\n    --gradient-from-color: #edebfe;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(237, 235, 254, 0));\n  }\n  .sm\\:from-purple-200 {\n    --gradient-from-color: #dcd7fe;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(220, 215, 254, 0));\n  }\n  .sm\\:from-purple-300 {\n    --gradient-from-color: #cabffd;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(202, 191, 253, 0));\n  }\n  .sm\\:from-purple-400 {\n    --gradient-from-color: #ac94fa;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(172, 148, 250, 0));\n  }\n  .sm\\:from-purple-500 {\n    --gradient-from-color: #9061f9;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(144, 97, 249, 0));\n  }\n  .sm\\:from-purple-600 {\n    --gradient-from-color: #7e3af2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(126, 58, 242, 0));\n  }\n  .sm\\:from-purple-700 {\n    --gradient-from-color: #6c2bd9;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(108, 43, 217, 0));\n  }\n  .sm\\:from-purple-800 {\n    --gradient-from-color: #5521b5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(85, 33, 181, 0));\n  }\n  .sm\\:from-purple-900 {\n    --gradient-from-color: #4a1d96;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(74, 29, 150, 0));\n  }\n  .sm\\:from-pink-50 {\n    --gradient-from-color: #fdf2f8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 242, 248, 0));\n  }\n  .sm\\:from-pink-100 {\n    --gradient-from-color: #fce8f3;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(252, 232, 243, 0));\n  }\n  .sm\\:from-pink-200 {\n    --gradient-from-color: #fad1e8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(250, 209, 232, 0));\n  }\n  .sm\\:from-pink-300 {\n    --gradient-from-color: #f8b4d9;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(248, 180, 217, 0));\n  }\n  .sm\\:from-pink-400 {\n    --gradient-from-color: #f17eb8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(241, 126, 184, 0));\n  }\n  .sm\\:from-pink-500 {\n    --gradient-from-color: #e74694;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(231, 70, 148, 0));\n  }\n  .sm\\:from-pink-600 {\n    --gradient-from-color: #d61f69;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(214, 31, 105, 0));\n  }\n  .sm\\:from-pink-700 {\n    --gradient-from-color: #bf125d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(191, 18, 93, 0));\n  }\n  .sm\\:from-pink-800 {\n    --gradient-from-color: #99154b;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(153, 21, 75, 0));\n  }\n  .sm\\:from-pink-900 {\n    --gradient-from-color: #751a3d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(117, 26, 61, 0));\n  }\n  .sm\\:from-cool-gray-50 {\n    --gradient-from-color: #f8fafc;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(248, 250, 252, 0));\n  }\n  .sm\\:from-cool-gray-100 {\n    --gradient-from-color: #f1f5f9;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(241, 245, 249, 0));\n  }\n  .sm\\:from-cool-gray-200 {\n    --gradient-from-color: #e2e8f0;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(226, 232, 240, 0));\n  }\n  .sm\\:from-cool-gray-300 {\n    --gradient-from-color: #cfd8e3;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(207, 216, 227, 0));\n  }\n  .sm\\:from-cool-gray-400 {\n    --gradient-from-color: #97a6ba;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(151, 166, 186, 0));\n  }\n  .sm\\:from-cool-gray-500 {\n    --gradient-from-color: #64748b;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(100, 116, 139, 0));\n  }\n  .sm\\:from-cool-gray-600 {\n    --gradient-from-color: #475569;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(71, 85, 105, 0));\n  }\n  .sm\\:from-cool-gray-700 {\n    --gradient-from-color: #364152;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(54, 65, 82, 0));\n  }\n  .sm\\:from-cool-gray-800 {\n    --gradient-from-color: #27303f;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(39, 48, 63, 0));\n  }\n  .sm\\:from-cool-gray-900 {\n    --gradient-from-color: #1a202e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(26, 32, 46, 0));\n  }\n  .sm\\:via-current {\n    --gradient-via-color: currentColor;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));\n  }\n  .sm\\:via-transparent {\n    --gradient-via-color: transparent;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0));\n  }\n  .sm\\:via-white {\n    --gradient-via-color: #ffffff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));\n  }\n  .sm\\:via-black {\n    --gradient-via-color: #000000;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0));\n  }\n  .sm\\:via-gray-50 {\n    --gradient-via-color: #f9fafb;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(249, 250, 251, 0));\n  }\n  .sm\\:via-gray-100 {\n    --gradient-via-color: #f4f5f7;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(244, 245, 247, 0));\n  }\n  .sm\\:via-gray-200 {\n    --gradient-via-color: #e5e7eb;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(229, 231, 235, 0));\n  }\n  .sm\\:via-gray-300 {\n    --gradient-via-color: #d2d6dc;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(210, 214, 220, 0));\n  }\n  .sm\\:via-gray-400 {\n    --gradient-via-color: #9fa6b2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(159, 166, 178, 0));\n  }\n  .sm\\:via-gray-500 {\n    --gradient-via-color: #6b7280;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(107, 114, 128, 0));\n  }\n  .sm\\:via-gray-600 {\n    --gradient-via-color: #4b5563;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(75, 85, 99, 0));\n  }\n  .sm\\:via-gray-700 {\n    --gradient-via-color: #374151;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(55, 65, 81, 0));\n  }\n  .sm\\:via-gray-800 {\n    --gradient-via-color: #252f3f;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(37, 47, 63, 0));\n  }\n  .sm\\:via-gray-900 {\n    --gradient-via-color: #161e2e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(22, 30, 46, 0));\n  }\n  .sm\\:via-red-50 {\n    --gradient-via-color: #fdf2f2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 242, 242, 0));\n  }\n  .sm\\:via-red-100 {\n    --gradient-via-color: #fde8e8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 232, 232, 0));\n  }\n  .sm\\:via-red-200 {\n    --gradient-via-color: #fbd5d5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(251, 213, 213, 0));\n  }\n  .sm\\:via-red-300 {\n    --gradient-via-color: #f8b4b4;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(248, 180, 180, 0));\n  }\n  .sm\\:via-red-400 {\n    --gradient-via-color: #f98080;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(249, 128, 128, 0));\n  }\n  .sm\\:via-red-500 {\n    --gradient-via-color: #f05252;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(240, 82, 82, 0));\n  }\n  .sm\\:via-red-600 {\n    --gradient-via-color: #e02424;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(224, 36, 36, 0));\n  }\n  .sm\\:via-red-700 {\n    --gradient-via-color: #c81e1e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(200, 30, 30, 0));\n  }\n  .sm\\:via-red-800 {\n    --gradient-via-color: #9b1c1c;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(155, 28, 28, 0));\n  }\n  .sm\\:via-red-900 {\n    --gradient-via-color: #771d1d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(119, 29, 29, 0));\n  }\n  .sm\\:via-orange-50 {\n    --gradient-via-color: #fff8f1;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 248, 241, 0));\n  }\n  .sm\\:via-orange-100 {\n    --gradient-via-color: #feecdc;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 236, 220, 0));\n  }\n  .sm\\:via-orange-200 {\n    --gradient-via-color: #fcd9bd;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(252, 217, 189, 0));\n  }\n  .sm\\:via-orange-300 {\n    --gradient-via-color: #fdba8c;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 186, 140, 0));\n  }\n  .sm\\:via-orange-400 {\n    --gradient-via-color: #ff8a4c;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 138, 76, 0));\n  }\n  .sm\\:via-orange-500 {\n    --gradient-via-color: #ff5a1f;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 90, 31, 0));\n  }\n  .sm\\:via-orange-600 {\n    --gradient-via-color: #d03801;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(208, 56, 1, 0));\n  }\n  .sm\\:via-orange-700 {\n    --gradient-via-color: #b43403;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(180, 52, 3, 0));\n  }\n  .sm\\:via-orange-800 {\n    --gradient-via-color: #8a2c0d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(138, 44, 13, 0));\n  }\n  .sm\\:via-orange-900 {\n    --gradient-via-color: #73230d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(115, 35, 13, 0));\n  }\n  .sm\\:via-yellow-50 {\n    --gradient-via-color: #fdfdea;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 253, 234, 0));\n  }\n  .sm\\:via-yellow-100 {\n    --gradient-via-color: #fdf6b2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 246, 178, 0));\n  }\n  .sm\\:via-yellow-200 {\n    --gradient-via-color: #fce96a;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(252, 233, 106, 0));\n  }\n  .sm\\:via-yellow-300 {\n    --gradient-via-color: #faca15;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(250, 202, 21, 0));\n  }\n  .sm\\:via-yellow-400 {\n    --gradient-via-color: #e3a008;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(227, 160, 8, 0));\n  }\n  .sm\\:via-yellow-500 {\n    --gradient-via-color: #c27803;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(194, 120, 3, 0));\n  }\n  .sm\\:via-yellow-600 {\n    --gradient-via-color: #9f580a;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(159, 88, 10, 0));\n  }\n  .sm\\:via-yellow-700 {\n    --gradient-via-color: #8e4b10;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(142, 75, 16, 0));\n  }\n  .sm\\:via-yellow-800 {\n    --gradient-via-color: #723b13;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(114, 59, 19, 0));\n  }\n  .sm\\:via-yellow-900 {\n    --gradient-via-color: #633112;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(99, 49, 18, 0));\n  }\n  .sm\\:via-green-50 {\n    --gradient-via-color: #f3faf7;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(243, 250, 247, 0));\n  }\n  .sm\\:via-green-100 {\n    --gradient-via-color: #def7ec;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(222, 247, 236, 0));\n  }\n  .sm\\:via-green-200 {\n    --gradient-via-color: #bcf0da;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(188, 240, 218, 0));\n  }\n  .sm\\:via-green-300 {\n    --gradient-via-color: #84e1bc;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(132, 225, 188, 0));\n  }\n  .sm\\:via-green-400 {\n    --gradient-via-color: #31c48d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(49, 196, 141, 0));\n  }\n  .sm\\:via-green-500 {\n    --gradient-via-color: #0e9f6e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(14, 159, 110, 0));\n  }\n  .sm\\:via-green-600 {\n    --gradient-via-color: #057a55;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(5, 122, 85, 0));\n  }\n  .sm\\:via-green-700 {\n    --gradient-via-color: #046c4e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(4, 108, 78, 0));\n  }\n  .sm\\:via-green-800 {\n    --gradient-via-color: #03543f;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(3, 84, 63, 0));\n  }\n  .sm\\:via-green-900 {\n    --gradient-via-color: #014737;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(1, 71, 55, 0));\n  }\n  .sm\\:via-teal-50 {\n    --gradient-via-color: #edfafa;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(237, 250, 250, 0));\n  }\n  .sm\\:via-teal-100 {\n    --gradient-via-color: #d5f5f6;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(213, 245, 246, 0));\n  }\n  .sm\\:via-teal-200 {\n    --gradient-via-color: #afecef;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(175, 236, 239, 0));\n  }\n  .sm\\:via-teal-300 {\n    --gradient-via-color: #7edce2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(126, 220, 226, 0));\n  }\n  .sm\\:via-teal-400 {\n    --gradient-via-color: #16bdca;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(22, 189, 202, 0));\n  }\n  .sm\\:via-teal-500 {\n    --gradient-via-color: #0694a2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(6, 148, 162, 0));\n  }\n  .sm\\:via-teal-600 {\n    --gradient-via-color: #047481;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(4, 116, 129, 0));\n  }\n  .sm\\:via-teal-700 {\n    --gradient-via-color: #036672;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(3, 102, 114, 0));\n  }\n  .sm\\:via-teal-800 {\n    --gradient-via-color: #05505c;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(5, 80, 92, 0));\n  }\n  .sm\\:via-teal-900 {\n    --gradient-via-color: #014451;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(1, 68, 81, 0));\n  }\n  .sm\\:via-blue-50 {\n    --gradient-via-color: #ebf5ff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(235, 245, 255, 0));\n  }\n  .sm\\:via-blue-100 {\n    --gradient-via-color: #e1effe;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(225, 239, 254, 0));\n  }\n  .sm\\:via-blue-200 {\n    --gradient-via-color: #c3ddfd;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(195, 221, 253, 0));\n  }\n  .sm\\:via-blue-300 {\n    --gradient-via-color: #a4cafe;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(164, 202, 254, 0));\n  }\n  .sm\\:via-blue-400 {\n    --gradient-via-color: #76a9fa;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(118, 169, 250, 0));\n  }\n  .sm\\:via-blue-500 {\n    --gradient-via-color: #3f83f8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(63, 131, 248, 0));\n  }\n  .sm\\:via-blue-600 {\n    --gradient-via-color: #1c64f2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(28, 100, 242, 0));\n  }\n  .sm\\:via-blue-700 {\n    --gradient-via-color: #1a56db;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(26, 86, 219, 0));\n  }\n  .sm\\:via-blue-800 {\n    --gradient-via-color: #1e429f;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(30, 66, 159, 0));\n  }\n  .sm\\:via-blue-900 {\n    --gradient-via-color: #233876;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(35, 56, 118, 0));\n  }\n  .sm\\:via-indigo-50 {\n    --gradient-via-color: #f0f5ff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(240, 245, 255, 0));\n  }\n  .sm\\:via-indigo-100 {\n    --gradient-via-color: #e5edff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(229, 237, 255, 0));\n  }\n  .sm\\:via-indigo-200 {\n    --gradient-via-color: #cddbfe;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(205, 219, 254, 0));\n  }\n  .sm\\:via-indigo-300 {\n    --gradient-via-color: #b4c6fc;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(180, 198, 252, 0));\n  }\n  .sm\\:via-indigo-400 {\n    --gradient-via-color: #8da2fb;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(141, 162, 251, 0));\n  }\n  .sm\\:via-indigo-500 {\n    --gradient-via-color: #6875f5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(104, 117, 245, 0));\n  }\n  .sm\\:via-indigo-600 {\n    --gradient-via-color: #5850ec;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(88, 80, 236, 0));\n  }\n  .sm\\:via-indigo-700 {\n    --gradient-via-color: #5145cd;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(81, 69, 205, 0));\n  }\n  .sm\\:via-indigo-800 {\n    --gradient-via-color: #42389d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(66, 56, 157, 0));\n  }\n  .sm\\:via-indigo-900 {\n    --gradient-via-color: #362f78;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(54, 47, 120, 0));\n  }\n  .sm\\:via-purple-50 {\n    --gradient-via-color: #f6f5ff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(246, 245, 255, 0));\n  }\n  .sm\\:via-purple-100 {\n    --gradient-via-color: #edebfe;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(237, 235, 254, 0));\n  }\n  .sm\\:via-purple-200 {\n    --gradient-via-color: #dcd7fe;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(220, 215, 254, 0));\n  }\n  .sm\\:via-purple-300 {\n    --gradient-via-color: #cabffd;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(202, 191, 253, 0));\n  }\n  .sm\\:via-purple-400 {\n    --gradient-via-color: #ac94fa;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(172, 148, 250, 0));\n  }\n  .sm\\:via-purple-500 {\n    --gradient-via-color: #9061f9;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(144, 97, 249, 0));\n  }\n  .sm\\:via-purple-600 {\n    --gradient-via-color: #7e3af2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(126, 58, 242, 0));\n  }\n  .sm\\:via-purple-700 {\n    --gradient-via-color: #6c2bd9;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(108, 43, 217, 0));\n  }\n  .sm\\:via-purple-800 {\n    --gradient-via-color: #5521b5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(85, 33, 181, 0));\n  }\n  .sm\\:via-purple-900 {\n    --gradient-via-color: #4a1d96;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(74, 29, 150, 0));\n  }\n  .sm\\:via-pink-50 {\n    --gradient-via-color: #fdf2f8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 242, 248, 0));\n  }\n  .sm\\:via-pink-100 {\n    --gradient-via-color: #fce8f3;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(252, 232, 243, 0));\n  }\n  .sm\\:via-pink-200 {\n    --gradient-via-color: #fad1e8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(250, 209, 232, 0));\n  }\n  .sm\\:via-pink-300 {\n    --gradient-via-color: #f8b4d9;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(248, 180, 217, 0));\n  }\n  .sm\\:via-pink-400 {\n    --gradient-via-color: #f17eb8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(241, 126, 184, 0));\n  }\n  .sm\\:via-pink-500 {\n    --gradient-via-color: #e74694;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(231, 70, 148, 0));\n  }\n  .sm\\:via-pink-600 {\n    --gradient-via-color: #d61f69;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(214, 31, 105, 0));\n  }\n  .sm\\:via-pink-700 {\n    --gradient-via-color: #bf125d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(191, 18, 93, 0));\n  }\n  .sm\\:via-pink-800 {\n    --gradient-via-color: #99154b;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(153, 21, 75, 0));\n  }\n  .sm\\:via-pink-900 {\n    --gradient-via-color: #751a3d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(117, 26, 61, 0));\n  }\n  .sm\\:via-cool-gray-50 {\n    --gradient-via-color: #f8fafc;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(248, 250, 252, 0));\n  }\n  .sm\\:via-cool-gray-100 {\n    --gradient-via-color: #f1f5f9;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(241, 245, 249, 0));\n  }\n  .sm\\:via-cool-gray-200 {\n    --gradient-via-color: #e2e8f0;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(226, 232, 240, 0));\n  }\n  .sm\\:via-cool-gray-300 {\n    --gradient-via-color: #cfd8e3;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(207, 216, 227, 0));\n  }\n  .sm\\:via-cool-gray-400 {\n    --gradient-via-color: #97a6ba;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(151, 166, 186, 0));\n  }\n  .sm\\:via-cool-gray-500 {\n    --gradient-via-color: #64748b;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(100, 116, 139, 0));\n  }\n  .sm\\:via-cool-gray-600 {\n    --gradient-via-color: #475569;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(71, 85, 105, 0));\n  }\n  .sm\\:via-cool-gray-700 {\n    --gradient-via-color: #364152;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(54, 65, 82, 0));\n  }\n  .sm\\:via-cool-gray-800 {\n    --gradient-via-color: #27303f;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(39, 48, 63, 0));\n  }\n  .sm\\:via-cool-gray-900 {\n    --gradient-via-color: #1a202e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(26, 32, 46, 0));\n  }\n  .sm\\:to-current {\n    --gradient-to-color: currentColor;\n  }\n  .sm\\:to-transparent {\n    --gradient-to-color: transparent;\n  }\n  .sm\\:to-white {\n    --gradient-to-color: #ffffff;\n  }\n  .sm\\:to-black {\n    --gradient-to-color: #000000;\n  }\n  .sm\\:to-gray-50 {\n    --gradient-to-color: #f9fafb;\n  }\n  .sm\\:to-gray-100 {\n    --gradient-to-color: #f4f5f7;\n  }\n  .sm\\:to-gray-200 {\n    --gradient-to-color: #e5e7eb;\n  }\n  .sm\\:to-gray-300 {\n    --gradient-to-color: #d2d6dc;\n  }\n  .sm\\:to-gray-400 {\n    --gradient-to-color: #9fa6b2;\n  }\n  .sm\\:to-gray-500 {\n    --gradient-to-color: #6b7280;\n  }\n  .sm\\:to-gray-600 {\n    --gradient-to-color: #4b5563;\n  }\n  .sm\\:to-gray-700 {\n    --gradient-to-color: #374151;\n  }\n  .sm\\:to-gray-800 {\n    --gradient-to-color: #252f3f;\n  }\n  .sm\\:to-gray-900 {\n    --gradient-to-color: #161e2e;\n  }\n  .sm\\:to-red-50 {\n    --gradient-to-color: #fdf2f2;\n  }\n  .sm\\:to-red-100 {\n    --gradient-to-color: #fde8e8;\n  }\n  .sm\\:to-red-200 {\n    --gradient-to-color: #fbd5d5;\n  }\n  .sm\\:to-red-300 {\n    --gradient-to-color: #f8b4b4;\n  }\n  .sm\\:to-red-400 {\n    --gradient-to-color: #f98080;\n  }\n  .sm\\:to-red-500 {\n    --gradient-to-color: #f05252;\n  }\n  .sm\\:to-red-600 {\n    --gradient-to-color: #e02424;\n  }\n  .sm\\:to-red-700 {\n    --gradient-to-color: #c81e1e;\n  }\n  .sm\\:to-red-800 {\n    --gradient-to-color: #9b1c1c;\n  }\n  .sm\\:to-red-900 {\n    --gradient-to-color: #771d1d;\n  }\n  .sm\\:to-orange-50 {\n    --gradient-to-color: #fff8f1;\n  }\n  .sm\\:to-orange-100 {\n    --gradient-to-color: #feecdc;\n  }\n  .sm\\:to-orange-200 {\n    --gradient-to-color: #fcd9bd;\n  }\n  .sm\\:to-orange-300 {\n    --gradient-to-color: #fdba8c;\n  }\n  .sm\\:to-orange-400 {\n    --gradient-to-color: #ff8a4c;\n  }\n  .sm\\:to-orange-500 {\n    --gradient-to-color: #ff5a1f;\n  }\n  .sm\\:to-orange-600 {\n    --gradient-to-color: #d03801;\n  }\n  .sm\\:to-orange-700 {\n    --gradient-to-color: #b43403;\n  }\n  .sm\\:to-orange-800 {\n    --gradient-to-color: #8a2c0d;\n  }\n  .sm\\:to-orange-900 {\n    --gradient-to-color: #73230d;\n  }\n  .sm\\:to-yellow-50 {\n    --gradient-to-color: #fdfdea;\n  }\n  .sm\\:to-yellow-100 {\n    --gradient-to-color: #fdf6b2;\n  }\n  .sm\\:to-yellow-200 {\n    --gradient-to-color: #fce96a;\n  }\n  .sm\\:to-yellow-300 {\n    --gradient-to-color: #faca15;\n  }\n  .sm\\:to-yellow-400 {\n    --gradient-to-color: #e3a008;\n  }\n  .sm\\:to-yellow-500 {\n    --gradient-to-color: #c27803;\n  }\n  .sm\\:to-yellow-600 {\n    --gradient-to-color: #9f580a;\n  }\n  .sm\\:to-yellow-700 {\n    --gradient-to-color: #8e4b10;\n  }\n  .sm\\:to-yellow-800 {\n    --gradient-to-color: #723b13;\n  }\n  .sm\\:to-yellow-900 {\n    --gradient-to-color: #633112;\n  }\n  .sm\\:to-green-50 {\n    --gradient-to-color: #f3faf7;\n  }\n  .sm\\:to-green-100 {\n    --gradient-to-color: #def7ec;\n  }\n  .sm\\:to-green-200 {\n    --gradient-to-color: #bcf0da;\n  }\n  .sm\\:to-green-300 {\n    --gradient-to-color: #84e1bc;\n  }\n  .sm\\:to-green-400 {\n    --gradient-to-color: #31c48d;\n  }\n  .sm\\:to-green-500 {\n    --gradient-to-color: #0e9f6e;\n  }\n  .sm\\:to-green-600 {\n    --gradient-to-color: #057a55;\n  }\n  .sm\\:to-green-700 {\n    --gradient-to-color: #046c4e;\n  }\n  .sm\\:to-green-800 {\n    --gradient-to-color: #03543f;\n  }\n  .sm\\:to-green-900 {\n    --gradient-to-color: #014737;\n  }\n  .sm\\:to-teal-50 {\n    --gradient-to-color: #edfafa;\n  }\n  .sm\\:to-teal-100 {\n    --gradient-to-color: #d5f5f6;\n  }\n  .sm\\:to-teal-200 {\n    --gradient-to-color: #afecef;\n  }\n  .sm\\:to-teal-300 {\n    --gradient-to-color: #7edce2;\n  }\n  .sm\\:to-teal-400 {\n    --gradient-to-color: #16bdca;\n  }\n  .sm\\:to-teal-500 {\n    --gradient-to-color: #0694a2;\n  }\n  .sm\\:to-teal-600 {\n    --gradient-to-color: #047481;\n  }\n  .sm\\:to-teal-700 {\n    --gradient-to-color: #036672;\n  }\n  .sm\\:to-teal-800 {\n    --gradient-to-color: #05505c;\n  }\n  .sm\\:to-teal-900 {\n    --gradient-to-color: #014451;\n  }\n  .sm\\:to-blue-50 {\n    --gradient-to-color: #ebf5ff;\n  }\n  .sm\\:to-blue-100 {\n    --gradient-to-color: #e1effe;\n  }\n  .sm\\:to-blue-200 {\n    --gradient-to-color: #c3ddfd;\n  }\n  .sm\\:to-blue-300 {\n    --gradient-to-color: #a4cafe;\n  }\n  .sm\\:to-blue-400 {\n    --gradient-to-color: #76a9fa;\n  }\n  .sm\\:to-blue-500 {\n    --gradient-to-color: #3f83f8;\n  }\n  .sm\\:to-blue-600 {\n    --gradient-to-color: #1c64f2;\n  }\n  .sm\\:to-blue-700 {\n    --gradient-to-color: #1a56db;\n  }\n  .sm\\:to-blue-800 {\n    --gradient-to-color: #1e429f;\n  }\n  .sm\\:to-blue-900 {\n    --gradient-to-color: #233876;\n  }\n  .sm\\:to-indigo-50 {\n    --gradient-to-color: #f0f5ff;\n  }\n  .sm\\:to-indigo-100 {\n    --gradient-to-color: #e5edff;\n  }\n  .sm\\:to-indigo-200 {\n    --gradient-to-color: #cddbfe;\n  }\n  .sm\\:to-indigo-300 {\n    --gradient-to-color: #b4c6fc;\n  }\n  .sm\\:to-indigo-400 {\n    --gradient-to-color: #8da2fb;\n  }\n  .sm\\:to-indigo-500 {\n    --gradient-to-color: #6875f5;\n  }\n  .sm\\:to-indigo-600 {\n    --gradient-to-color: #5850ec;\n  }\n  .sm\\:to-indigo-700 {\n    --gradient-to-color: #5145cd;\n  }\n  .sm\\:to-indigo-800 {\n    --gradient-to-color: #42389d;\n  }\n  .sm\\:to-indigo-900 {\n    --gradient-to-color: #362f78;\n  }\n  .sm\\:to-purple-50 {\n    --gradient-to-color: #f6f5ff;\n  }\n  .sm\\:to-purple-100 {\n    --gradient-to-color: #edebfe;\n  }\n  .sm\\:to-purple-200 {\n    --gradient-to-color: #dcd7fe;\n  }\n  .sm\\:to-purple-300 {\n    --gradient-to-color: #cabffd;\n  }\n  .sm\\:to-purple-400 {\n    --gradient-to-color: #ac94fa;\n  }\n  .sm\\:to-purple-500 {\n    --gradient-to-color: #9061f9;\n  }\n  .sm\\:to-purple-600 {\n    --gradient-to-color: #7e3af2;\n  }\n  .sm\\:to-purple-700 {\n    --gradient-to-color: #6c2bd9;\n  }\n  .sm\\:to-purple-800 {\n    --gradient-to-color: #5521b5;\n  }\n  .sm\\:to-purple-900 {\n    --gradient-to-color: #4a1d96;\n  }\n  .sm\\:to-pink-50 {\n    --gradient-to-color: #fdf2f8;\n  }\n  .sm\\:to-pink-100 {\n    --gradient-to-color: #fce8f3;\n  }\n  .sm\\:to-pink-200 {\n    --gradient-to-color: #fad1e8;\n  }\n  .sm\\:to-pink-300 {\n    --gradient-to-color: #f8b4d9;\n  }\n  .sm\\:to-pink-400 {\n    --gradient-to-color: #f17eb8;\n  }\n  .sm\\:to-pink-500 {\n    --gradient-to-color: #e74694;\n  }\n  .sm\\:to-pink-600 {\n    --gradient-to-color: #d61f69;\n  }\n  .sm\\:to-pink-700 {\n    --gradient-to-color: #bf125d;\n  }\n  .sm\\:to-pink-800 {\n    --gradient-to-color: #99154b;\n  }\n  .sm\\:to-pink-900 {\n    --gradient-to-color: #751a3d;\n  }\n  .sm\\:to-cool-gray-50 {\n    --gradient-to-color: #f8fafc;\n  }\n  .sm\\:to-cool-gray-100 {\n    --gradient-to-color: #f1f5f9;\n  }\n  .sm\\:to-cool-gray-200 {\n    --gradient-to-color: #e2e8f0;\n  }\n  .sm\\:to-cool-gray-300 {\n    --gradient-to-color: #cfd8e3;\n  }\n  .sm\\:to-cool-gray-400 {\n    --gradient-to-color: #97a6ba;\n  }\n  .sm\\:to-cool-gray-500 {\n    --gradient-to-color: #64748b;\n  }\n  .sm\\:to-cool-gray-600 {\n    --gradient-to-color: #475569;\n  }\n  .sm\\:to-cool-gray-700 {\n    --gradient-to-color: #364152;\n  }\n  .sm\\:to-cool-gray-800 {\n    --gradient-to-color: #27303f;\n  }\n  .sm\\:to-cool-gray-900 {\n    --gradient-to-color: #1a202e;\n  }\n  .sm\\:hover\\:from-current:hover {\n    --gradient-from-color: currentColor;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));\n  }\n  .sm\\:hover\\:from-transparent:hover {\n    --gradient-from-color: transparent;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0));\n  }\n  .sm\\:hover\\:from-white:hover {\n    --gradient-from-color: #ffffff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));\n  }\n  .sm\\:hover\\:from-black:hover {\n    --gradient-from-color: #000000;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0));\n  }\n  .sm\\:hover\\:from-gray-50:hover {\n    --gradient-from-color: #f9fafb;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(249, 250, 251, 0));\n  }\n  .sm\\:hover\\:from-gray-100:hover {\n    --gradient-from-color: #f4f5f7;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(244, 245, 247, 0));\n  }\n  .sm\\:hover\\:from-gray-200:hover {\n    --gradient-from-color: #e5e7eb;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(229, 231, 235, 0));\n  }\n  .sm\\:hover\\:from-gray-300:hover {\n    --gradient-from-color: #d2d6dc;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(210, 214, 220, 0));\n  }\n  .sm\\:hover\\:from-gray-400:hover {\n    --gradient-from-color: #9fa6b2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(159, 166, 178, 0));\n  }\n  .sm\\:hover\\:from-gray-500:hover {\n    --gradient-from-color: #6b7280;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(107, 114, 128, 0));\n  }\n  .sm\\:hover\\:from-gray-600:hover {\n    --gradient-from-color: #4b5563;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(75, 85, 99, 0));\n  }\n  .sm\\:hover\\:from-gray-700:hover {\n    --gradient-from-color: #374151;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(55, 65, 81, 0));\n  }\n  .sm\\:hover\\:from-gray-800:hover {\n    --gradient-from-color: #252f3f;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(37, 47, 63, 0));\n  }\n  .sm\\:hover\\:from-gray-900:hover {\n    --gradient-from-color: #161e2e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(22, 30, 46, 0));\n  }\n  .sm\\:hover\\:from-red-50:hover {\n    --gradient-from-color: #fdf2f2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 242, 242, 0));\n  }\n  .sm\\:hover\\:from-red-100:hover {\n    --gradient-from-color: #fde8e8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 232, 232, 0));\n  }\n  .sm\\:hover\\:from-red-200:hover {\n    --gradient-from-color: #fbd5d5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(251, 213, 213, 0));\n  }\n  .sm\\:hover\\:from-red-300:hover {\n    --gradient-from-color: #f8b4b4;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(248, 180, 180, 0));\n  }\n  .sm\\:hover\\:from-red-400:hover {\n    --gradient-from-color: #f98080;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(249, 128, 128, 0));\n  }\n  .sm\\:hover\\:from-red-500:hover {\n    --gradient-from-color: #f05252;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(240, 82, 82, 0));\n  }\n  .sm\\:hover\\:from-red-600:hover {\n    --gradient-from-color: #e02424;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(224, 36, 36, 0));\n  }\n  .sm\\:hover\\:from-red-700:hover {\n    --gradient-from-color: #c81e1e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(200, 30, 30, 0));\n  }\n  .sm\\:hover\\:from-red-800:hover {\n    --gradient-from-color: #9b1c1c;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(155, 28, 28, 0));\n  }\n  .sm\\:hover\\:from-red-900:hover {\n    --gradient-from-color: #771d1d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(119, 29, 29, 0));\n  }\n  .sm\\:hover\\:from-orange-50:hover {\n    --gradient-from-color: #fff8f1;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 248, 241, 0));\n  }\n  .sm\\:hover\\:from-orange-100:hover {\n    --gradient-from-color: #feecdc;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 236, 220, 0));\n  }\n  .sm\\:hover\\:from-orange-200:hover {\n    --gradient-from-color: #fcd9bd;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(252, 217, 189, 0));\n  }\n  .sm\\:hover\\:from-orange-300:hover {\n    --gradient-from-color: #fdba8c;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 186, 140, 0));\n  }\n  .sm\\:hover\\:from-orange-400:hover {\n    --gradient-from-color: #ff8a4c;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 138, 76, 0));\n  }\n  .sm\\:hover\\:from-orange-500:hover {\n    --gradient-from-color: #ff5a1f;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 90, 31, 0));\n  }\n  .sm\\:hover\\:from-orange-600:hover {\n    --gradient-from-color: #d03801;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(208, 56, 1, 0));\n  }\n  .sm\\:hover\\:from-orange-700:hover {\n    --gradient-from-color: #b43403;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(180, 52, 3, 0));\n  }\n  .sm\\:hover\\:from-orange-800:hover {\n    --gradient-from-color: #8a2c0d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(138, 44, 13, 0));\n  }\n  .sm\\:hover\\:from-orange-900:hover {\n    --gradient-from-color: #73230d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(115, 35, 13, 0));\n  }\n  .sm\\:hover\\:from-yellow-50:hover {\n    --gradient-from-color: #fdfdea;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 253, 234, 0));\n  }\n  .sm\\:hover\\:from-yellow-100:hover {\n    --gradient-from-color: #fdf6b2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 246, 178, 0));\n  }\n  .sm\\:hover\\:from-yellow-200:hover {\n    --gradient-from-color: #fce96a;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(252, 233, 106, 0));\n  }\n  .sm\\:hover\\:from-yellow-300:hover {\n    --gradient-from-color: #faca15;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(250, 202, 21, 0));\n  }\n  .sm\\:hover\\:from-yellow-400:hover {\n    --gradient-from-color: #e3a008;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(227, 160, 8, 0));\n  }\n  .sm\\:hover\\:from-yellow-500:hover {\n    --gradient-from-color: #c27803;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(194, 120, 3, 0));\n  }\n  .sm\\:hover\\:from-yellow-600:hover {\n    --gradient-from-color: #9f580a;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(159, 88, 10, 0));\n  }\n  .sm\\:hover\\:from-yellow-700:hover {\n    --gradient-from-color: #8e4b10;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(142, 75, 16, 0));\n  }\n  .sm\\:hover\\:from-yellow-800:hover {\n    --gradient-from-color: #723b13;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(114, 59, 19, 0));\n  }\n  .sm\\:hover\\:from-yellow-900:hover {\n    --gradient-from-color: #633112;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(99, 49, 18, 0));\n  }\n  .sm\\:hover\\:from-green-50:hover {\n    --gradient-from-color: #f3faf7;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(243, 250, 247, 0));\n  }\n  .sm\\:hover\\:from-green-100:hover {\n    --gradient-from-color: #def7ec;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(222, 247, 236, 0));\n  }\n  .sm\\:hover\\:from-green-200:hover {\n    --gradient-from-color: #bcf0da;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(188, 240, 218, 0));\n  }\n  .sm\\:hover\\:from-green-300:hover {\n    --gradient-from-color: #84e1bc;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(132, 225, 188, 0));\n  }\n  .sm\\:hover\\:from-green-400:hover {\n    --gradient-from-color: #31c48d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(49, 196, 141, 0));\n  }\n  .sm\\:hover\\:from-green-500:hover {\n    --gradient-from-color: #0e9f6e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(14, 159, 110, 0));\n  }\n  .sm\\:hover\\:from-green-600:hover {\n    --gradient-from-color: #057a55;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(5, 122, 85, 0));\n  }\n  .sm\\:hover\\:from-green-700:hover {\n    --gradient-from-color: #046c4e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(4, 108, 78, 0));\n  }\n  .sm\\:hover\\:from-green-800:hover {\n    --gradient-from-color: #03543f;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(3, 84, 63, 0));\n  }\n  .sm\\:hover\\:from-green-900:hover {\n    --gradient-from-color: #014737;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(1, 71, 55, 0));\n  }\n  .sm\\:hover\\:from-teal-50:hover {\n    --gradient-from-color: #edfafa;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(237, 250, 250, 0));\n  }\n  .sm\\:hover\\:from-teal-100:hover {\n    --gradient-from-color: #d5f5f6;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(213, 245, 246, 0));\n  }\n  .sm\\:hover\\:from-teal-200:hover {\n    --gradient-from-color: #afecef;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(175, 236, 239, 0));\n  }\n  .sm\\:hover\\:from-teal-300:hover {\n    --gradient-from-color: #7edce2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(126, 220, 226, 0));\n  }\n  .sm\\:hover\\:from-teal-400:hover {\n    --gradient-from-color: #16bdca;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(22, 189, 202, 0));\n  }\n  .sm\\:hover\\:from-teal-500:hover {\n    --gradient-from-color: #0694a2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(6, 148, 162, 0));\n  }\n  .sm\\:hover\\:from-teal-600:hover {\n    --gradient-from-color: #047481;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(4, 116, 129, 0));\n  }\n  .sm\\:hover\\:from-teal-700:hover {\n    --gradient-from-color: #036672;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(3, 102, 114, 0));\n  }\n  .sm\\:hover\\:from-teal-800:hover {\n    --gradient-from-color: #05505c;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(5, 80, 92, 0));\n  }\n  .sm\\:hover\\:from-teal-900:hover {\n    --gradient-from-color: #014451;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(1, 68, 81, 0));\n  }\n  .sm\\:hover\\:from-blue-50:hover {\n    --gradient-from-color: #ebf5ff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(235, 245, 255, 0));\n  }\n  .sm\\:hover\\:from-blue-100:hover {\n    --gradient-from-color: #e1effe;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(225, 239, 254, 0));\n  }\n  .sm\\:hover\\:from-blue-200:hover {\n    --gradient-from-color: #c3ddfd;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(195, 221, 253, 0));\n  }\n  .sm\\:hover\\:from-blue-300:hover {\n    --gradient-from-color: #a4cafe;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(164, 202, 254, 0));\n  }\n  .sm\\:hover\\:from-blue-400:hover {\n    --gradient-from-color: #76a9fa;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(118, 169, 250, 0));\n  }\n  .sm\\:hover\\:from-blue-500:hover {\n    --gradient-from-color: #3f83f8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(63, 131, 248, 0));\n  }\n  .sm\\:hover\\:from-blue-600:hover {\n    --gradient-from-color: #1c64f2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(28, 100, 242, 0));\n  }\n  .sm\\:hover\\:from-blue-700:hover {\n    --gradient-from-color: #1a56db;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(26, 86, 219, 0));\n  }\n  .sm\\:hover\\:from-blue-800:hover {\n    --gradient-from-color: #1e429f;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(30, 66, 159, 0));\n  }\n  .sm\\:hover\\:from-blue-900:hover {\n    --gradient-from-color: #233876;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(35, 56, 118, 0));\n  }\n  .sm\\:hover\\:from-indigo-50:hover {\n    --gradient-from-color: #f0f5ff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(240, 245, 255, 0));\n  }\n  .sm\\:hover\\:from-indigo-100:hover {\n    --gradient-from-color: #e5edff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(229, 237, 255, 0));\n  }\n  .sm\\:hover\\:from-indigo-200:hover {\n    --gradient-from-color: #cddbfe;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(205, 219, 254, 0));\n  }\n  .sm\\:hover\\:from-indigo-300:hover {\n    --gradient-from-color: #b4c6fc;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(180, 198, 252, 0));\n  }\n  .sm\\:hover\\:from-indigo-400:hover {\n    --gradient-from-color: #8da2fb;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(141, 162, 251, 0));\n  }\n  .sm\\:hover\\:from-indigo-500:hover {\n    --gradient-from-color: #6875f5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(104, 117, 245, 0));\n  }\n  .sm\\:hover\\:from-indigo-600:hover {\n    --gradient-from-color: #5850ec;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(88, 80, 236, 0));\n  }\n  .sm\\:hover\\:from-indigo-700:hover {\n    --gradient-from-color: #5145cd;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(81, 69, 205, 0));\n  }\n  .sm\\:hover\\:from-indigo-800:hover {\n    --gradient-from-color: #42389d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(66, 56, 157, 0));\n  }\n  .sm\\:hover\\:from-indigo-900:hover {\n    --gradient-from-color: #362f78;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(54, 47, 120, 0));\n  }\n  .sm\\:hover\\:from-purple-50:hover {\n    --gradient-from-color: #f6f5ff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(246, 245, 255, 0));\n  }\n  .sm\\:hover\\:from-purple-100:hover {\n    --gradient-from-color: #edebfe;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(237, 235, 254, 0));\n  }\n  .sm\\:hover\\:from-purple-200:hover {\n    --gradient-from-color: #dcd7fe;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(220, 215, 254, 0));\n  }\n  .sm\\:hover\\:from-purple-300:hover {\n    --gradient-from-color: #cabffd;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(202, 191, 253, 0));\n  }\n  .sm\\:hover\\:from-purple-400:hover {\n    --gradient-from-color: #ac94fa;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(172, 148, 250, 0));\n  }\n  .sm\\:hover\\:from-purple-500:hover {\n    --gradient-from-color: #9061f9;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(144, 97, 249, 0));\n  }\n  .sm\\:hover\\:from-purple-600:hover {\n    --gradient-from-color: #7e3af2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(126, 58, 242, 0));\n  }\n  .sm\\:hover\\:from-purple-700:hover {\n    --gradient-from-color: #6c2bd9;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(108, 43, 217, 0));\n  }\n  .sm\\:hover\\:from-purple-800:hover {\n    --gradient-from-color: #5521b5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(85, 33, 181, 0));\n  }\n  .sm\\:hover\\:from-purple-900:hover {\n    --gradient-from-color: #4a1d96;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(74, 29, 150, 0));\n  }\n  .sm\\:hover\\:from-pink-50:hover {\n    --gradient-from-color: #fdf2f8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 242, 248, 0));\n  }\n  .sm\\:hover\\:from-pink-100:hover {\n    --gradient-from-color: #fce8f3;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(252, 232, 243, 0));\n  }\n  .sm\\:hover\\:from-pink-200:hover {\n    --gradient-from-color: #fad1e8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(250, 209, 232, 0));\n  }\n  .sm\\:hover\\:from-pink-300:hover {\n    --gradient-from-color: #f8b4d9;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(248, 180, 217, 0));\n  }\n  .sm\\:hover\\:from-pink-400:hover {\n    --gradient-from-color: #f17eb8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(241, 126, 184, 0));\n  }\n  .sm\\:hover\\:from-pink-500:hover {\n    --gradient-from-color: #e74694;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(231, 70, 148, 0));\n  }\n  .sm\\:hover\\:from-pink-600:hover {\n    --gradient-from-color: #d61f69;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(214, 31, 105, 0));\n  }\n  .sm\\:hover\\:from-pink-700:hover {\n    --gradient-from-color: #bf125d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(191, 18, 93, 0));\n  }\n  .sm\\:hover\\:from-pink-800:hover {\n    --gradient-from-color: #99154b;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(153, 21, 75, 0));\n  }\n  .sm\\:hover\\:from-pink-900:hover {\n    --gradient-from-color: #751a3d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(117, 26, 61, 0));\n  }\n  .sm\\:hover\\:from-cool-gray-50:hover {\n    --gradient-from-color: #f8fafc;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(248, 250, 252, 0));\n  }\n  .sm\\:hover\\:from-cool-gray-100:hover {\n    --gradient-from-color: #f1f5f9;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(241, 245, 249, 0));\n  }\n  .sm\\:hover\\:from-cool-gray-200:hover {\n    --gradient-from-color: #e2e8f0;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(226, 232, 240, 0));\n  }\n  .sm\\:hover\\:from-cool-gray-300:hover {\n    --gradient-from-color: #cfd8e3;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(207, 216, 227, 0));\n  }\n  .sm\\:hover\\:from-cool-gray-400:hover {\n    --gradient-from-color: #97a6ba;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(151, 166, 186, 0));\n  }\n  .sm\\:hover\\:from-cool-gray-500:hover {\n    --gradient-from-color: #64748b;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(100, 116, 139, 0));\n  }\n  .sm\\:hover\\:from-cool-gray-600:hover {\n    --gradient-from-color: #475569;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(71, 85, 105, 0));\n  }\n  .sm\\:hover\\:from-cool-gray-700:hover {\n    --gradient-from-color: #364152;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(54, 65, 82, 0));\n  }\n  .sm\\:hover\\:from-cool-gray-800:hover {\n    --gradient-from-color: #27303f;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(39, 48, 63, 0));\n  }\n  .sm\\:hover\\:from-cool-gray-900:hover {\n    --gradient-from-color: #1a202e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(26, 32, 46, 0));\n  }\n  .sm\\:hover\\:via-current:hover {\n    --gradient-via-color: currentColor;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));\n  }\n  .sm\\:hover\\:via-transparent:hover {\n    --gradient-via-color: transparent;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0));\n  }\n  .sm\\:hover\\:via-white:hover {\n    --gradient-via-color: #ffffff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));\n  }\n  .sm\\:hover\\:via-black:hover {\n    --gradient-via-color: #000000;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0));\n  }\n  .sm\\:hover\\:via-gray-50:hover {\n    --gradient-via-color: #f9fafb;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(249, 250, 251, 0));\n  }\n  .sm\\:hover\\:via-gray-100:hover {\n    --gradient-via-color: #f4f5f7;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(244, 245, 247, 0));\n  }\n  .sm\\:hover\\:via-gray-200:hover {\n    --gradient-via-color: #e5e7eb;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(229, 231, 235, 0));\n  }\n  .sm\\:hover\\:via-gray-300:hover {\n    --gradient-via-color: #d2d6dc;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(210, 214, 220, 0));\n  }\n  .sm\\:hover\\:via-gray-400:hover {\n    --gradient-via-color: #9fa6b2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(159, 166, 178, 0));\n  }\n  .sm\\:hover\\:via-gray-500:hover {\n    --gradient-via-color: #6b7280;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(107, 114, 128, 0));\n  }\n  .sm\\:hover\\:via-gray-600:hover {\n    --gradient-via-color: #4b5563;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(75, 85, 99, 0));\n  }\n  .sm\\:hover\\:via-gray-700:hover {\n    --gradient-via-color: #374151;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(55, 65, 81, 0));\n  }\n  .sm\\:hover\\:via-gray-800:hover {\n    --gradient-via-color: #252f3f;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(37, 47, 63, 0));\n  }\n  .sm\\:hover\\:via-gray-900:hover {\n    --gradient-via-color: #161e2e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(22, 30, 46, 0));\n  }\n  .sm\\:hover\\:via-red-50:hover {\n    --gradient-via-color: #fdf2f2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 242, 242, 0));\n  }\n  .sm\\:hover\\:via-red-100:hover {\n    --gradient-via-color: #fde8e8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 232, 232, 0));\n  }\n  .sm\\:hover\\:via-red-200:hover {\n    --gradient-via-color: #fbd5d5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(251, 213, 213, 0));\n  }\n  .sm\\:hover\\:via-red-300:hover {\n    --gradient-via-color: #f8b4b4;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(248, 180, 180, 0));\n  }\n  .sm\\:hover\\:via-red-400:hover {\n    --gradient-via-color: #f98080;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(249, 128, 128, 0));\n  }\n  .sm\\:hover\\:via-red-500:hover {\n    --gradient-via-color: #f05252;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(240, 82, 82, 0));\n  }\n  .sm\\:hover\\:via-red-600:hover {\n    --gradient-via-color: #e02424;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(224, 36, 36, 0));\n  }\n  .sm\\:hover\\:via-red-700:hover {\n    --gradient-via-color: #c81e1e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(200, 30, 30, 0));\n  }\n  .sm\\:hover\\:via-red-800:hover {\n    --gradient-via-color: #9b1c1c;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(155, 28, 28, 0));\n  }\n  .sm\\:hover\\:via-red-900:hover {\n    --gradient-via-color: #771d1d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(119, 29, 29, 0));\n  }\n  .sm\\:hover\\:via-orange-50:hover {\n    --gradient-via-color: #fff8f1;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 248, 241, 0));\n  }\n  .sm\\:hover\\:via-orange-100:hover {\n    --gradient-via-color: #feecdc;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 236, 220, 0));\n  }\n  .sm\\:hover\\:via-orange-200:hover {\n    --gradient-via-color: #fcd9bd;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(252, 217, 189, 0));\n  }\n  .sm\\:hover\\:via-orange-300:hover {\n    --gradient-via-color: #fdba8c;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 186, 140, 0));\n  }\n  .sm\\:hover\\:via-orange-400:hover {\n    --gradient-via-color: #ff8a4c;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 138, 76, 0));\n  }\n  .sm\\:hover\\:via-orange-500:hover {\n    --gradient-via-color: #ff5a1f;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 90, 31, 0));\n  }\n  .sm\\:hover\\:via-orange-600:hover {\n    --gradient-via-color: #d03801;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(208, 56, 1, 0));\n  }\n  .sm\\:hover\\:via-orange-700:hover {\n    --gradient-via-color: #b43403;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(180, 52, 3, 0));\n  }\n  .sm\\:hover\\:via-orange-800:hover {\n    --gradient-via-color: #8a2c0d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(138, 44, 13, 0));\n  }\n  .sm\\:hover\\:via-orange-900:hover {\n    --gradient-via-color: #73230d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(115, 35, 13, 0));\n  }\n  .sm\\:hover\\:via-yellow-50:hover {\n    --gradient-via-color: #fdfdea;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 253, 234, 0));\n  }\n  .sm\\:hover\\:via-yellow-100:hover {\n    --gradient-via-color: #fdf6b2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 246, 178, 0));\n  }\n  .sm\\:hover\\:via-yellow-200:hover {\n    --gradient-via-color: #fce96a;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(252, 233, 106, 0));\n  }\n  .sm\\:hover\\:via-yellow-300:hover {\n    --gradient-via-color: #faca15;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(250, 202, 21, 0));\n  }\n  .sm\\:hover\\:via-yellow-400:hover {\n    --gradient-via-color: #e3a008;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(227, 160, 8, 0));\n  }\n  .sm\\:hover\\:via-yellow-500:hover {\n    --gradient-via-color: #c27803;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(194, 120, 3, 0));\n  }\n  .sm\\:hover\\:via-yellow-600:hover {\n    --gradient-via-color: #9f580a;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(159, 88, 10, 0));\n  }\n  .sm\\:hover\\:via-yellow-700:hover {\n    --gradient-via-color: #8e4b10;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(142, 75, 16, 0));\n  }\n  .sm\\:hover\\:via-yellow-800:hover {\n    --gradient-via-color: #723b13;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(114, 59, 19, 0));\n  }\n  .sm\\:hover\\:via-yellow-900:hover {\n    --gradient-via-color: #633112;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(99, 49, 18, 0));\n  }\n  .sm\\:hover\\:via-green-50:hover {\n    --gradient-via-color: #f3faf7;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(243, 250, 247, 0));\n  }\n  .sm\\:hover\\:via-green-100:hover {\n    --gradient-via-color: #def7ec;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(222, 247, 236, 0));\n  }\n  .sm\\:hover\\:via-green-200:hover {\n    --gradient-via-color: #bcf0da;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(188, 240, 218, 0));\n  }\n  .sm\\:hover\\:via-green-300:hover {\n    --gradient-via-color: #84e1bc;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(132, 225, 188, 0));\n  }\n  .sm\\:hover\\:via-green-400:hover {\n    --gradient-via-color: #31c48d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(49, 196, 141, 0));\n  }\n  .sm\\:hover\\:via-green-500:hover {\n    --gradient-via-color: #0e9f6e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(14, 159, 110, 0));\n  }\n  .sm\\:hover\\:via-green-600:hover {\n    --gradient-via-color: #057a55;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(5, 122, 85, 0));\n  }\n  .sm\\:hover\\:via-green-700:hover {\n    --gradient-via-color: #046c4e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(4, 108, 78, 0));\n  }\n  .sm\\:hover\\:via-green-800:hover {\n    --gradient-via-color: #03543f;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(3, 84, 63, 0));\n  }\n  .sm\\:hover\\:via-green-900:hover {\n    --gradient-via-color: #014737;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(1, 71, 55, 0));\n  }\n  .sm\\:hover\\:via-teal-50:hover {\n    --gradient-via-color: #edfafa;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(237, 250, 250, 0));\n  }\n  .sm\\:hover\\:via-teal-100:hover {\n    --gradient-via-color: #d5f5f6;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(213, 245, 246, 0));\n  }\n  .sm\\:hover\\:via-teal-200:hover {\n    --gradient-via-color: #afecef;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(175, 236, 239, 0));\n  }\n  .sm\\:hover\\:via-teal-300:hover {\n    --gradient-via-color: #7edce2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(126, 220, 226, 0));\n  }\n  .sm\\:hover\\:via-teal-400:hover {\n    --gradient-via-color: #16bdca;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(22, 189, 202, 0));\n  }\n  .sm\\:hover\\:via-teal-500:hover {\n    --gradient-via-color: #0694a2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(6, 148, 162, 0));\n  }\n  .sm\\:hover\\:via-teal-600:hover {\n    --gradient-via-color: #047481;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(4, 116, 129, 0));\n  }\n  .sm\\:hover\\:via-teal-700:hover {\n    --gradient-via-color: #036672;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(3, 102, 114, 0));\n  }\n  .sm\\:hover\\:via-teal-800:hover {\n    --gradient-via-color: #05505c;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(5, 80, 92, 0));\n  }\n  .sm\\:hover\\:via-teal-900:hover {\n    --gradient-via-color: #014451;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(1, 68, 81, 0));\n  }\n  .sm\\:hover\\:via-blue-50:hover {\n    --gradient-via-color: #ebf5ff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(235, 245, 255, 0));\n  }\n  .sm\\:hover\\:via-blue-100:hover {\n    --gradient-via-color: #e1effe;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(225, 239, 254, 0));\n  }\n  .sm\\:hover\\:via-blue-200:hover {\n    --gradient-via-color: #c3ddfd;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(195, 221, 253, 0));\n  }\n  .sm\\:hover\\:via-blue-300:hover {\n    --gradient-via-color: #a4cafe;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(164, 202, 254, 0));\n  }\n  .sm\\:hover\\:via-blue-400:hover {\n    --gradient-via-color: #76a9fa;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(118, 169, 250, 0));\n  }\n  .sm\\:hover\\:via-blue-500:hover {\n    --gradient-via-color: #3f83f8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(63, 131, 248, 0));\n  }\n  .sm\\:hover\\:via-blue-600:hover {\n    --gradient-via-color: #1c64f2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(28, 100, 242, 0));\n  }\n  .sm\\:hover\\:via-blue-700:hover {\n    --gradient-via-color: #1a56db;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(26, 86, 219, 0));\n  }\n  .sm\\:hover\\:via-blue-800:hover {\n    --gradient-via-color: #1e429f;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(30, 66, 159, 0));\n  }\n  .sm\\:hover\\:via-blue-900:hover {\n    --gradient-via-color: #233876;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(35, 56, 118, 0));\n  }\n  .sm\\:hover\\:via-indigo-50:hover {\n    --gradient-via-color: #f0f5ff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(240, 245, 255, 0));\n  }\n  .sm\\:hover\\:via-indigo-100:hover {\n    --gradient-via-color: #e5edff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(229, 237, 255, 0));\n  }\n  .sm\\:hover\\:via-indigo-200:hover {\n    --gradient-via-color: #cddbfe;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(205, 219, 254, 0));\n  }\n  .sm\\:hover\\:via-indigo-300:hover {\n    --gradient-via-color: #b4c6fc;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(180, 198, 252, 0));\n  }\n  .sm\\:hover\\:via-indigo-400:hover {\n    --gradient-via-color: #8da2fb;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(141, 162, 251, 0));\n  }\n  .sm\\:hover\\:via-indigo-500:hover {\n    --gradient-via-color: #6875f5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(104, 117, 245, 0));\n  }\n  .sm\\:hover\\:via-indigo-600:hover {\n    --gradient-via-color: #5850ec;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(88, 80, 236, 0));\n  }\n  .sm\\:hover\\:via-indigo-700:hover {\n    --gradient-via-color: #5145cd;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(81, 69, 205, 0));\n  }\n  .sm\\:hover\\:via-indigo-800:hover {\n    --gradient-via-color: #42389d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(66, 56, 157, 0));\n  }\n  .sm\\:hover\\:via-indigo-900:hover {\n    --gradient-via-color: #362f78;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(54, 47, 120, 0));\n  }\n  .sm\\:hover\\:via-purple-50:hover {\n    --gradient-via-color: #f6f5ff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(246, 245, 255, 0));\n  }\n  .sm\\:hover\\:via-purple-100:hover {\n    --gradient-via-color: #edebfe;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(237, 235, 254, 0));\n  }\n  .sm\\:hover\\:via-purple-200:hover {\n    --gradient-via-color: #dcd7fe;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(220, 215, 254, 0));\n  }\n  .sm\\:hover\\:via-purple-300:hover {\n    --gradient-via-color: #cabffd;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(202, 191, 253, 0));\n  }\n  .sm\\:hover\\:via-purple-400:hover {\n    --gradient-via-color: #ac94fa;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(172, 148, 250, 0));\n  }\n  .sm\\:hover\\:via-purple-500:hover {\n    --gradient-via-color: #9061f9;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(144, 97, 249, 0));\n  }\n  .sm\\:hover\\:via-purple-600:hover {\n    --gradient-via-color: #7e3af2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(126, 58, 242, 0));\n  }\n  .sm\\:hover\\:via-purple-700:hover {\n    --gradient-via-color: #6c2bd9;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(108, 43, 217, 0));\n  }\n  .sm\\:hover\\:via-purple-800:hover {\n    --gradient-via-color: #5521b5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(85, 33, 181, 0));\n  }\n  .sm\\:hover\\:via-purple-900:hover {\n    --gradient-via-color: #4a1d96;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(74, 29, 150, 0));\n  }\n  .sm\\:hover\\:via-pink-50:hover {\n    --gradient-via-color: #fdf2f8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 242, 248, 0));\n  }\n  .sm\\:hover\\:via-pink-100:hover {\n    --gradient-via-color: #fce8f3;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(252, 232, 243, 0));\n  }\n  .sm\\:hover\\:via-pink-200:hover {\n    --gradient-via-color: #fad1e8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(250, 209, 232, 0));\n  }\n  .sm\\:hover\\:via-pink-300:hover {\n    --gradient-via-color: #f8b4d9;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(248, 180, 217, 0));\n  }\n  .sm\\:hover\\:via-pink-400:hover {\n    --gradient-via-color: #f17eb8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(241, 126, 184, 0));\n  }\n  .sm\\:hover\\:via-pink-500:hover {\n    --gradient-via-color: #e74694;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(231, 70, 148, 0));\n  }\n  .sm\\:hover\\:via-pink-600:hover {\n    --gradient-via-color: #d61f69;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(214, 31, 105, 0));\n  }\n  .sm\\:hover\\:via-pink-700:hover {\n    --gradient-via-color: #bf125d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(191, 18, 93, 0));\n  }\n  .sm\\:hover\\:via-pink-800:hover {\n    --gradient-via-color: #99154b;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(153, 21, 75, 0));\n  }\n  .sm\\:hover\\:via-pink-900:hover {\n    --gradient-via-color: #751a3d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(117, 26, 61, 0));\n  }\n  .sm\\:hover\\:via-cool-gray-50:hover {\n    --gradient-via-color: #f8fafc;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(248, 250, 252, 0));\n  }\n  .sm\\:hover\\:via-cool-gray-100:hover {\n    --gradient-via-color: #f1f5f9;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(241, 245, 249, 0));\n  }\n  .sm\\:hover\\:via-cool-gray-200:hover {\n    --gradient-via-color: #e2e8f0;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(226, 232, 240, 0));\n  }\n  .sm\\:hover\\:via-cool-gray-300:hover {\n    --gradient-via-color: #cfd8e3;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(207, 216, 227, 0));\n  }\n  .sm\\:hover\\:via-cool-gray-400:hover {\n    --gradient-via-color: #97a6ba;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(151, 166, 186, 0));\n  }\n  .sm\\:hover\\:via-cool-gray-500:hover {\n    --gradient-via-color: #64748b;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(100, 116, 139, 0));\n  }\n  .sm\\:hover\\:via-cool-gray-600:hover {\n    --gradient-via-color: #475569;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(71, 85, 105, 0));\n  }\n  .sm\\:hover\\:via-cool-gray-700:hover {\n    --gradient-via-color: #364152;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(54, 65, 82, 0));\n  }\n  .sm\\:hover\\:via-cool-gray-800:hover {\n    --gradient-via-color: #27303f;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(39, 48, 63, 0));\n  }\n  .sm\\:hover\\:via-cool-gray-900:hover {\n    --gradient-via-color: #1a202e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(26, 32, 46, 0));\n  }\n  .sm\\:hover\\:to-current:hover {\n    --gradient-to-color: currentColor;\n  }\n  .sm\\:hover\\:to-transparent:hover {\n    --gradient-to-color: transparent;\n  }\n  .sm\\:hover\\:to-white:hover {\n    --gradient-to-color: #ffffff;\n  }\n  .sm\\:hover\\:to-black:hover {\n    --gradient-to-color: #000000;\n  }\n  .sm\\:hover\\:to-gray-50:hover {\n    --gradient-to-color: #f9fafb;\n  }\n  .sm\\:hover\\:to-gray-100:hover {\n    --gradient-to-color: #f4f5f7;\n  }\n  .sm\\:hover\\:to-gray-200:hover {\n    --gradient-to-color: #e5e7eb;\n  }\n  .sm\\:hover\\:to-gray-300:hover {\n    --gradient-to-color: #d2d6dc;\n  }\n  .sm\\:hover\\:to-gray-400:hover {\n    --gradient-to-color: #9fa6b2;\n  }\n  .sm\\:hover\\:to-gray-500:hover {\n    --gradient-to-color: #6b7280;\n  }\n  .sm\\:hover\\:to-gray-600:hover {\n    --gradient-to-color: #4b5563;\n  }\n  .sm\\:hover\\:to-gray-700:hover {\n    --gradient-to-color: #374151;\n  }\n  .sm\\:hover\\:to-gray-800:hover {\n    --gradient-to-color: #252f3f;\n  }\n  .sm\\:hover\\:to-gray-900:hover {\n    --gradient-to-color: #161e2e;\n  }\n  .sm\\:hover\\:to-red-50:hover {\n    --gradient-to-color: #fdf2f2;\n  }\n  .sm\\:hover\\:to-red-100:hover {\n    --gradient-to-color: #fde8e8;\n  }\n  .sm\\:hover\\:to-red-200:hover {\n    --gradient-to-color: #fbd5d5;\n  }\n  .sm\\:hover\\:to-red-300:hover {\n    --gradient-to-color: #f8b4b4;\n  }\n  .sm\\:hover\\:to-red-400:hover {\n    --gradient-to-color: #f98080;\n  }\n  .sm\\:hover\\:to-red-500:hover {\n    --gradient-to-color: #f05252;\n  }\n  .sm\\:hover\\:to-red-600:hover {\n    --gradient-to-color: #e02424;\n  }\n  .sm\\:hover\\:to-red-700:hover {\n    --gradient-to-color: #c81e1e;\n  }\n  .sm\\:hover\\:to-red-800:hover {\n    --gradient-to-color: #9b1c1c;\n  }\n  .sm\\:hover\\:to-red-900:hover {\n    --gradient-to-color: #771d1d;\n  }\n  .sm\\:hover\\:to-orange-50:hover {\n    --gradient-to-color: #fff8f1;\n  }\n  .sm\\:hover\\:to-orange-100:hover {\n    --gradient-to-color: #feecdc;\n  }\n  .sm\\:hover\\:to-orange-200:hover {\n    --gradient-to-color: #fcd9bd;\n  }\n  .sm\\:hover\\:to-orange-300:hover {\n    --gradient-to-color: #fdba8c;\n  }\n  .sm\\:hover\\:to-orange-400:hover {\n    --gradient-to-color: #ff8a4c;\n  }\n  .sm\\:hover\\:to-orange-500:hover {\n    --gradient-to-color: #ff5a1f;\n  }\n  .sm\\:hover\\:to-orange-600:hover {\n    --gradient-to-color: #d03801;\n  }\n  .sm\\:hover\\:to-orange-700:hover {\n    --gradient-to-color: #b43403;\n  }\n  .sm\\:hover\\:to-orange-800:hover {\n    --gradient-to-color: #8a2c0d;\n  }\n  .sm\\:hover\\:to-orange-900:hover {\n    --gradient-to-color: #73230d;\n  }\n  .sm\\:hover\\:to-yellow-50:hover {\n    --gradient-to-color: #fdfdea;\n  }\n  .sm\\:hover\\:to-yellow-100:hover {\n    --gradient-to-color: #fdf6b2;\n  }\n  .sm\\:hover\\:to-yellow-200:hover {\n    --gradient-to-color: #fce96a;\n  }\n  .sm\\:hover\\:to-yellow-300:hover {\n    --gradient-to-color: #faca15;\n  }\n  .sm\\:hover\\:to-yellow-400:hover {\n    --gradient-to-color: #e3a008;\n  }\n  .sm\\:hover\\:to-yellow-500:hover {\n    --gradient-to-color: #c27803;\n  }\n  .sm\\:hover\\:to-yellow-600:hover {\n    --gradient-to-color: #9f580a;\n  }\n  .sm\\:hover\\:to-yellow-700:hover {\n    --gradient-to-color: #8e4b10;\n  }\n  .sm\\:hover\\:to-yellow-800:hover {\n    --gradient-to-color: #723b13;\n  }\n  .sm\\:hover\\:to-yellow-900:hover {\n    --gradient-to-color: #633112;\n  }\n  .sm\\:hover\\:to-green-50:hover {\n    --gradient-to-color: #f3faf7;\n  }\n  .sm\\:hover\\:to-green-100:hover {\n    --gradient-to-color: #def7ec;\n  }\n  .sm\\:hover\\:to-green-200:hover {\n    --gradient-to-color: #bcf0da;\n  }\n  .sm\\:hover\\:to-green-300:hover {\n    --gradient-to-color: #84e1bc;\n  }\n  .sm\\:hover\\:to-green-400:hover {\n    --gradient-to-color: #31c48d;\n  }\n  .sm\\:hover\\:to-green-500:hover {\n    --gradient-to-color: #0e9f6e;\n  }\n  .sm\\:hover\\:to-green-600:hover {\n    --gradient-to-color: #057a55;\n  }\n  .sm\\:hover\\:to-green-700:hover {\n    --gradient-to-color: #046c4e;\n  }\n  .sm\\:hover\\:to-green-800:hover {\n    --gradient-to-color: #03543f;\n  }\n  .sm\\:hover\\:to-green-900:hover {\n    --gradient-to-color: #014737;\n  }\n  .sm\\:hover\\:to-teal-50:hover {\n    --gradient-to-color: #edfafa;\n  }\n  .sm\\:hover\\:to-teal-100:hover {\n    --gradient-to-color: #d5f5f6;\n  }\n  .sm\\:hover\\:to-teal-200:hover {\n    --gradient-to-color: #afecef;\n  }\n  .sm\\:hover\\:to-teal-300:hover {\n    --gradient-to-color: #7edce2;\n  }\n  .sm\\:hover\\:to-teal-400:hover {\n    --gradient-to-color: #16bdca;\n  }\n  .sm\\:hover\\:to-teal-500:hover {\n    --gradient-to-color: #0694a2;\n  }\n  .sm\\:hover\\:to-teal-600:hover {\n    --gradient-to-color: #047481;\n  }\n  .sm\\:hover\\:to-teal-700:hover {\n    --gradient-to-color: #036672;\n  }\n  .sm\\:hover\\:to-teal-800:hover {\n    --gradient-to-color: #05505c;\n  }\n  .sm\\:hover\\:to-teal-900:hover {\n    --gradient-to-color: #014451;\n  }\n  .sm\\:hover\\:to-blue-50:hover {\n    --gradient-to-color: #ebf5ff;\n  }\n  .sm\\:hover\\:to-blue-100:hover {\n    --gradient-to-color: #e1effe;\n  }\n  .sm\\:hover\\:to-blue-200:hover {\n    --gradient-to-color: #c3ddfd;\n  }\n  .sm\\:hover\\:to-blue-300:hover {\n    --gradient-to-color: #a4cafe;\n  }\n  .sm\\:hover\\:to-blue-400:hover {\n    --gradient-to-color: #76a9fa;\n  }\n  .sm\\:hover\\:to-blue-500:hover {\n    --gradient-to-color: #3f83f8;\n  }\n  .sm\\:hover\\:to-blue-600:hover {\n    --gradient-to-color: #1c64f2;\n  }\n  .sm\\:hover\\:to-blue-700:hover {\n    --gradient-to-color: #1a56db;\n  }\n  .sm\\:hover\\:to-blue-800:hover {\n    --gradient-to-color: #1e429f;\n  }\n  .sm\\:hover\\:to-blue-900:hover {\n    --gradient-to-color: #233876;\n  }\n  .sm\\:hover\\:to-indigo-50:hover {\n    --gradient-to-color: #f0f5ff;\n  }\n  .sm\\:hover\\:to-indigo-100:hover {\n    --gradient-to-color: #e5edff;\n  }\n  .sm\\:hover\\:to-indigo-200:hover {\n    --gradient-to-color: #cddbfe;\n  }\n  .sm\\:hover\\:to-indigo-300:hover {\n    --gradient-to-color: #b4c6fc;\n  }\n  .sm\\:hover\\:to-indigo-400:hover {\n    --gradient-to-color: #8da2fb;\n  }\n  .sm\\:hover\\:to-indigo-500:hover {\n    --gradient-to-color: #6875f5;\n  }\n  .sm\\:hover\\:to-indigo-600:hover {\n    --gradient-to-color: #5850ec;\n  }\n  .sm\\:hover\\:to-indigo-700:hover {\n    --gradient-to-color: #5145cd;\n  }\n  .sm\\:hover\\:to-indigo-800:hover {\n    --gradient-to-color: #42389d;\n  }\n  .sm\\:hover\\:to-indigo-900:hover {\n    --gradient-to-color: #362f78;\n  }\n  .sm\\:hover\\:to-purple-50:hover {\n    --gradient-to-color: #f6f5ff;\n  }\n  .sm\\:hover\\:to-purple-100:hover {\n    --gradient-to-color: #edebfe;\n  }\n  .sm\\:hover\\:to-purple-200:hover {\n    --gradient-to-color: #dcd7fe;\n  }\n  .sm\\:hover\\:to-purple-300:hover {\n    --gradient-to-color: #cabffd;\n  }\n  .sm\\:hover\\:to-purple-400:hover {\n    --gradient-to-color: #ac94fa;\n  }\n  .sm\\:hover\\:to-purple-500:hover {\n    --gradient-to-color: #9061f9;\n  }\n  .sm\\:hover\\:to-purple-600:hover {\n    --gradient-to-color: #7e3af2;\n  }\n  .sm\\:hover\\:to-purple-700:hover {\n    --gradient-to-color: #6c2bd9;\n  }\n  .sm\\:hover\\:to-purple-800:hover {\n    --gradient-to-color: #5521b5;\n  }\n  .sm\\:hover\\:to-purple-900:hover {\n    --gradient-to-color: #4a1d96;\n  }\n  .sm\\:hover\\:to-pink-50:hover {\n    --gradient-to-color: #fdf2f8;\n  }\n  .sm\\:hover\\:to-pink-100:hover {\n    --gradient-to-color: #fce8f3;\n  }\n  .sm\\:hover\\:to-pink-200:hover {\n    --gradient-to-color: #fad1e8;\n  }\n  .sm\\:hover\\:to-pink-300:hover {\n    --gradient-to-color: #f8b4d9;\n  }\n  .sm\\:hover\\:to-pink-400:hover {\n    --gradient-to-color: #f17eb8;\n  }\n  .sm\\:hover\\:to-pink-500:hover {\n    --gradient-to-color: #e74694;\n  }\n  .sm\\:hover\\:to-pink-600:hover {\n    --gradient-to-color: #d61f69;\n  }\n  .sm\\:hover\\:to-pink-700:hover {\n    --gradient-to-color: #bf125d;\n  }\n  .sm\\:hover\\:to-pink-800:hover {\n    --gradient-to-color: #99154b;\n  }\n  .sm\\:hover\\:to-pink-900:hover {\n    --gradient-to-color: #751a3d;\n  }\n  .sm\\:hover\\:to-cool-gray-50:hover {\n    --gradient-to-color: #f8fafc;\n  }\n  .sm\\:hover\\:to-cool-gray-100:hover {\n    --gradient-to-color: #f1f5f9;\n  }\n  .sm\\:hover\\:to-cool-gray-200:hover {\n    --gradient-to-color: #e2e8f0;\n  }\n  .sm\\:hover\\:to-cool-gray-300:hover {\n    --gradient-to-color: #cfd8e3;\n  }\n  .sm\\:hover\\:to-cool-gray-400:hover {\n    --gradient-to-color: #97a6ba;\n  }\n  .sm\\:hover\\:to-cool-gray-500:hover {\n    --gradient-to-color: #64748b;\n  }\n  .sm\\:hover\\:to-cool-gray-600:hover {\n    --gradient-to-color: #475569;\n  }\n  .sm\\:hover\\:to-cool-gray-700:hover {\n    --gradient-to-color: #364152;\n  }\n  .sm\\:hover\\:to-cool-gray-800:hover {\n    --gradient-to-color: #27303f;\n  }\n  .sm\\:hover\\:to-cool-gray-900:hover {\n    --gradient-to-color: #1a202e;\n  }\n  .sm\\:focus\\:from-current:focus {\n    --gradient-from-color: currentColor;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));\n  }\n  .sm\\:focus\\:from-transparent:focus {\n    --gradient-from-color: transparent;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0));\n  }\n  .sm\\:focus\\:from-white:focus {\n    --gradient-from-color: #ffffff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));\n  }\n  .sm\\:focus\\:from-black:focus {\n    --gradient-from-color: #000000;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0));\n  }\n  .sm\\:focus\\:from-gray-50:focus {\n    --gradient-from-color: #f9fafb;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(249, 250, 251, 0));\n  }\n  .sm\\:focus\\:from-gray-100:focus {\n    --gradient-from-color: #f4f5f7;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(244, 245, 247, 0));\n  }\n  .sm\\:focus\\:from-gray-200:focus {\n    --gradient-from-color: #e5e7eb;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(229, 231, 235, 0));\n  }\n  .sm\\:focus\\:from-gray-300:focus {\n    --gradient-from-color: #d2d6dc;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(210, 214, 220, 0));\n  }\n  .sm\\:focus\\:from-gray-400:focus {\n    --gradient-from-color: #9fa6b2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(159, 166, 178, 0));\n  }\n  .sm\\:focus\\:from-gray-500:focus {\n    --gradient-from-color: #6b7280;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(107, 114, 128, 0));\n  }\n  .sm\\:focus\\:from-gray-600:focus {\n    --gradient-from-color: #4b5563;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(75, 85, 99, 0));\n  }\n  .sm\\:focus\\:from-gray-700:focus {\n    --gradient-from-color: #374151;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(55, 65, 81, 0));\n  }\n  .sm\\:focus\\:from-gray-800:focus {\n    --gradient-from-color: #252f3f;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(37, 47, 63, 0));\n  }\n  .sm\\:focus\\:from-gray-900:focus {\n    --gradient-from-color: #161e2e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(22, 30, 46, 0));\n  }\n  .sm\\:focus\\:from-red-50:focus {\n    --gradient-from-color: #fdf2f2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 242, 242, 0));\n  }\n  .sm\\:focus\\:from-red-100:focus {\n    --gradient-from-color: #fde8e8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 232, 232, 0));\n  }\n  .sm\\:focus\\:from-red-200:focus {\n    --gradient-from-color: #fbd5d5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(251, 213, 213, 0));\n  }\n  .sm\\:focus\\:from-red-300:focus {\n    --gradient-from-color: #f8b4b4;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(248, 180, 180, 0));\n  }\n  .sm\\:focus\\:from-red-400:focus {\n    --gradient-from-color: #f98080;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(249, 128, 128, 0));\n  }\n  .sm\\:focus\\:from-red-500:focus {\n    --gradient-from-color: #f05252;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(240, 82, 82, 0));\n  }\n  .sm\\:focus\\:from-red-600:focus {\n    --gradient-from-color: #e02424;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(224, 36, 36, 0));\n  }\n  .sm\\:focus\\:from-red-700:focus {\n    --gradient-from-color: #c81e1e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(200, 30, 30, 0));\n  }\n  .sm\\:focus\\:from-red-800:focus {\n    --gradient-from-color: #9b1c1c;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(155, 28, 28, 0));\n  }\n  .sm\\:focus\\:from-red-900:focus {\n    --gradient-from-color: #771d1d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(119, 29, 29, 0));\n  }\n  .sm\\:focus\\:from-orange-50:focus {\n    --gradient-from-color: #fff8f1;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 248, 241, 0));\n  }\n  .sm\\:focus\\:from-orange-100:focus {\n    --gradient-from-color: #feecdc;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 236, 220, 0));\n  }\n  .sm\\:focus\\:from-orange-200:focus {\n    --gradient-from-color: #fcd9bd;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(252, 217, 189, 0));\n  }\n  .sm\\:focus\\:from-orange-300:focus {\n    --gradient-from-color: #fdba8c;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 186, 140, 0));\n  }\n  .sm\\:focus\\:from-orange-400:focus {\n    --gradient-from-color: #ff8a4c;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 138, 76, 0));\n  }\n  .sm\\:focus\\:from-orange-500:focus {\n    --gradient-from-color: #ff5a1f;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 90, 31, 0));\n  }\n  .sm\\:focus\\:from-orange-600:focus {\n    --gradient-from-color: #d03801;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(208, 56, 1, 0));\n  }\n  .sm\\:focus\\:from-orange-700:focus {\n    --gradient-from-color: #b43403;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(180, 52, 3, 0));\n  }\n  .sm\\:focus\\:from-orange-800:focus {\n    --gradient-from-color: #8a2c0d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(138, 44, 13, 0));\n  }\n  .sm\\:focus\\:from-orange-900:focus {\n    --gradient-from-color: #73230d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(115, 35, 13, 0));\n  }\n  .sm\\:focus\\:from-yellow-50:focus {\n    --gradient-from-color: #fdfdea;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 253, 234, 0));\n  }\n  .sm\\:focus\\:from-yellow-100:focus {\n    --gradient-from-color: #fdf6b2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 246, 178, 0));\n  }\n  .sm\\:focus\\:from-yellow-200:focus {\n    --gradient-from-color: #fce96a;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(252, 233, 106, 0));\n  }\n  .sm\\:focus\\:from-yellow-300:focus {\n    --gradient-from-color: #faca15;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(250, 202, 21, 0));\n  }\n  .sm\\:focus\\:from-yellow-400:focus {\n    --gradient-from-color: #e3a008;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(227, 160, 8, 0));\n  }\n  .sm\\:focus\\:from-yellow-500:focus {\n    --gradient-from-color: #c27803;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(194, 120, 3, 0));\n  }\n  .sm\\:focus\\:from-yellow-600:focus {\n    --gradient-from-color: #9f580a;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(159, 88, 10, 0));\n  }\n  .sm\\:focus\\:from-yellow-700:focus {\n    --gradient-from-color: #8e4b10;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(142, 75, 16, 0));\n  }\n  .sm\\:focus\\:from-yellow-800:focus {\n    --gradient-from-color: #723b13;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(114, 59, 19, 0));\n  }\n  .sm\\:focus\\:from-yellow-900:focus {\n    --gradient-from-color: #633112;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(99, 49, 18, 0));\n  }\n  .sm\\:focus\\:from-green-50:focus {\n    --gradient-from-color: #f3faf7;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(243, 250, 247, 0));\n  }\n  .sm\\:focus\\:from-green-100:focus {\n    --gradient-from-color: #def7ec;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(222, 247, 236, 0));\n  }\n  .sm\\:focus\\:from-green-200:focus {\n    --gradient-from-color: #bcf0da;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(188, 240, 218, 0));\n  }\n  .sm\\:focus\\:from-green-300:focus {\n    --gradient-from-color: #84e1bc;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(132, 225, 188, 0));\n  }\n  .sm\\:focus\\:from-green-400:focus {\n    --gradient-from-color: #31c48d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(49, 196, 141, 0));\n  }\n  .sm\\:focus\\:from-green-500:focus {\n    --gradient-from-color: #0e9f6e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(14, 159, 110, 0));\n  }\n  .sm\\:focus\\:from-green-600:focus {\n    --gradient-from-color: #057a55;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(5, 122, 85, 0));\n  }\n  .sm\\:focus\\:from-green-700:focus {\n    --gradient-from-color: #046c4e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(4, 108, 78, 0));\n  }\n  .sm\\:focus\\:from-green-800:focus {\n    --gradient-from-color: #03543f;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(3, 84, 63, 0));\n  }\n  .sm\\:focus\\:from-green-900:focus {\n    --gradient-from-color: #014737;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(1, 71, 55, 0));\n  }\n  .sm\\:focus\\:from-teal-50:focus {\n    --gradient-from-color: #edfafa;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(237, 250, 250, 0));\n  }\n  .sm\\:focus\\:from-teal-100:focus {\n    --gradient-from-color: #d5f5f6;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(213, 245, 246, 0));\n  }\n  .sm\\:focus\\:from-teal-200:focus {\n    --gradient-from-color: #afecef;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(175, 236, 239, 0));\n  }\n  .sm\\:focus\\:from-teal-300:focus {\n    --gradient-from-color: #7edce2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(126, 220, 226, 0));\n  }\n  .sm\\:focus\\:from-teal-400:focus {\n    --gradient-from-color: #16bdca;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(22, 189, 202, 0));\n  }\n  .sm\\:focus\\:from-teal-500:focus {\n    --gradient-from-color: #0694a2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(6, 148, 162, 0));\n  }\n  .sm\\:focus\\:from-teal-600:focus {\n    --gradient-from-color: #047481;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(4, 116, 129, 0));\n  }\n  .sm\\:focus\\:from-teal-700:focus {\n    --gradient-from-color: #036672;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(3, 102, 114, 0));\n  }\n  .sm\\:focus\\:from-teal-800:focus {\n    --gradient-from-color: #05505c;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(5, 80, 92, 0));\n  }\n  .sm\\:focus\\:from-teal-900:focus {\n    --gradient-from-color: #014451;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(1, 68, 81, 0));\n  }\n  .sm\\:focus\\:from-blue-50:focus {\n    --gradient-from-color: #ebf5ff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(235, 245, 255, 0));\n  }\n  .sm\\:focus\\:from-blue-100:focus {\n    --gradient-from-color: #e1effe;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(225, 239, 254, 0));\n  }\n  .sm\\:focus\\:from-blue-200:focus {\n    --gradient-from-color: #c3ddfd;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(195, 221, 253, 0));\n  }\n  .sm\\:focus\\:from-blue-300:focus {\n    --gradient-from-color: #a4cafe;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(164, 202, 254, 0));\n  }\n  .sm\\:focus\\:from-blue-400:focus {\n    --gradient-from-color: #76a9fa;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(118, 169, 250, 0));\n  }\n  .sm\\:focus\\:from-blue-500:focus {\n    --gradient-from-color: #3f83f8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(63, 131, 248, 0));\n  }\n  .sm\\:focus\\:from-blue-600:focus {\n    --gradient-from-color: #1c64f2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(28, 100, 242, 0));\n  }\n  .sm\\:focus\\:from-blue-700:focus {\n    --gradient-from-color: #1a56db;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(26, 86, 219, 0));\n  }\n  .sm\\:focus\\:from-blue-800:focus {\n    --gradient-from-color: #1e429f;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(30, 66, 159, 0));\n  }\n  .sm\\:focus\\:from-blue-900:focus {\n    --gradient-from-color: #233876;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(35, 56, 118, 0));\n  }\n  .sm\\:focus\\:from-indigo-50:focus {\n    --gradient-from-color: #f0f5ff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(240, 245, 255, 0));\n  }\n  .sm\\:focus\\:from-indigo-100:focus {\n    --gradient-from-color: #e5edff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(229, 237, 255, 0));\n  }\n  .sm\\:focus\\:from-indigo-200:focus {\n    --gradient-from-color: #cddbfe;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(205, 219, 254, 0));\n  }\n  .sm\\:focus\\:from-indigo-300:focus {\n    --gradient-from-color: #b4c6fc;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(180, 198, 252, 0));\n  }\n  .sm\\:focus\\:from-indigo-400:focus {\n    --gradient-from-color: #8da2fb;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(141, 162, 251, 0));\n  }\n  .sm\\:focus\\:from-indigo-500:focus {\n    --gradient-from-color: #6875f5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(104, 117, 245, 0));\n  }\n  .sm\\:focus\\:from-indigo-600:focus {\n    --gradient-from-color: #5850ec;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(88, 80, 236, 0));\n  }\n  .sm\\:focus\\:from-indigo-700:focus {\n    --gradient-from-color: #5145cd;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(81, 69, 205, 0));\n  }\n  .sm\\:focus\\:from-indigo-800:focus {\n    --gradient-from-color: #42389d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(66, 56, 157, 0));\n  }\n  .sm\\:focus\\:from-indigo-900:focus {\n    --gradient-from-color: #362f78;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(54, 47, 120, 0));\n  }\n  .sm\\:focus\\:from-purple-50:focus {\n    --gradient-from-color: #f6f5ff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(246, 245, 255, 0));\n  }\n  .sm\\:focus\\:from-purple-100:focus {\n    --gradient-from-color: #edebfe;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(237, 235, 254, 0));\n  }\n  .sm\\:focus\\:from-purple-200:focus {\n    --gradient-from-color: #dcd7fe;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(220, 215, 254, 0));\n  }\n  .sm\\:focus\\:from-purple-300:focus {\n    --gradient-from-color: #cabffd;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(202, 191, 253, 0));\n  }\n  .sm\\:focus\\:from-purple-400:focus {\n    --gradient-from-color: #ac94fa;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(172, 148, 250, 0));\n  }\n  .sm\\:focus\\:from-purple-500:focus {\n    --gradient-from-color: #9061f9;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(144, 97, 249, 0));\n  }\n  .sm\\:focus\\:from-purple-600:focus {\n    --gradient-from-color: #7e3af2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(126, 58, 242, 0));\n  }\n  .sm\\:focus\\:from-purple-700:focus {\n    --gradient-from-color: #6c2bd9;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(108, 43, 217, 0));\n  }\n  .sm\\:focus\\:from-purple-800:focus {\n    --gradient-from-color: #5521b5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(85, 33, 181, 0));\n  }\n  .sm\\:focus\\:from-purple-900:focus {\n    --gradient-from-color: #4a1d96;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(74, 29, 150, 0));\n  }\n  .sm\\:focus\\:from-pink-50:focus {\n    --gradient-from-color: #fdf2f8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 242, 248, 0));\n  }\n  .sm\\:focus\\:from-pink-100:focus {\n    --gradient-from-color: #fce8f3;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(252, 232, 243, 0));\n  }\n  .sm\\:focus\\:from-pink-200:focus {\n    --gradient-from-color: #fad1e8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(250, 209, 232, 0));\n  }\n  .sm\\:focus\\:from-pink-300:focus {\n    --gradient-from-color: #f8b4d9;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(248, 180, 217, 0));\n  }\n  .sm\\:focus\\:from-pink-400:focus {\n    --gradient-from-color: #f17eb8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(241, 126, 184, 0));\n  }\n  .sm\\:focus\\:from-pink-500:focus {\n    --gradient-from-color: #e74694;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(231, 70, 148, 0));\n  }\n  .sm\\:focus\\:from-pink-600:focus {\n    --gradient-from-color: #d61f69;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(214, 31, 105, 0));\n  }\n  .sm\\:focus\\:from-pink-700:focus {\n    --gradient-from-color: #bf125d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(191, 18, 93, 0));\n  }\n  .sm\\:focus\\:from-pink-800:focus {\n    --gradient-from-color: #99154b;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(153, 21, 75, 0));\n  }\n  .sm\\:focus\\:from-pink-900:focus {\n    --gradient-from-color: #751a3d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(117, 26, 61, 0));\n  }\n  .sm\\:focus\\:from-cool-gray-50:focus {\n    --gradient-from-color: #f8fafc;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(248, 250, 252, 0));\n  }\n  .sm\\:focus\\:from-cool-gray-100:focus {\n    --gradient-from-color: #f1f5f9;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(241, 245, 249, 0));\n  }\n  .sm\\:focus\\:from-cool-gray-200:focus {\n    --gradient-from-color: #e2e8f0;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(226, 232, 240, 0));\n  }\n  .sm\\:focus\\:from-cool-gray-300:focus {\n    --gradient-from-color: #cfd8e3;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(207, 216, 227, 0));\n  }\n  .sm\\:focus\\:from-cool-gray-400:focus {\n    --gradient-from-color: #97a6ba;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(151, 166, 186, 0));\n  }\n  .sm\\:focus\\:from-cool-gray-500:focus {\n    --gradient-from-color: #64748b;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(100, 116, 139, 0));\n  }\n  .sm\\:focus\\:from-cool-gray-600:focus {\n    --gradient-from-color: #475569;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(71, 85, 105, 0));\n  }\n  .sm\\:focus\\:from-cool-gray-700:focus {\n    --gradient-from-color: #364152;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(54, 65, 82, 0));\n  }\n  .sm\\:focus\\:from-cool-gray-800:focus {\n    --gradient-from-color: #27303f;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(39, 48, 63, 0));\n  }\n  .sm\\:focus\\:from-cool-gray-900:focus {\n    --gradient-from-color: #1a202e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(26, 32, 46, 0));\n  }\n  .sm\\:focus\\:via-current:focus {\n    --gradient-via-color: currentColor;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));\n  }\n  .sm\\:focus\\:via-transparent:focus {\n    --gradient-via-color: transparent;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0));\n  }\n  .sm\\:focus\\:via-white:focus {\n    --gradient-via-color: #ffffff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));\n  }\n  .sm\\:focus\\:via-black:focus {\n    --gradient-via-color: #000000;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0));\n  }\n  .sm\\:focus\\:via-gray-50:focus {\n    --gradient-via-color: #f9fafb;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(249, 250, 251, 0));\n  }\n  .sm\\:focus\\:via-gray-100:focus {\n    --gradient-via-color: #f4f5f7;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(244, 245, 247, 0));\n  }\n  .sm\\:focus\\:via-gray-200:focus {\n    --gradient-via-color: #e5e7eb;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(229, 231, 235, 0));\n  }\n  .sm\\:focus\\:via-gray-300:focus {\n    --gradient-via-color: #d2d6dc;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(210, 214, 220, 0));\n  }\n  .sm\\:focus\\:via-gray-400:focus {\n    --gradient-via-color: #9fa6b2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(159, 166, 178, 0));\n  }\n  .sm\\:focus\\:via-gray-500:focus {\n    --gradient-via-color: #6b7280;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(107, 114, 128, 0));\n  }\n  .sm\\:focus\\:via-gray-600:focus {\n    --gradient-via-color: #4b5563;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(75, 85, 99, 0));\n  }\n  .sm\\:focus\\:via-gray-700:focus {\n    --gradient-via-color: #374151;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(55, 65, 81, 0));\n  }\n  .sm\\:focus\\:via-gray-800:focus {\n    --gradient-via-color: #252f3f;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(37, 47, 63, 0));\n  }\n  .sm\\:focus\\:via-gray-900:focus {\n    --gradient-via-color: #161e2e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(22, 30, 46, 0));\n  }\n  .sm\\:focus\\:via-red-50:focus {\n    --gradient-via-color: #fdf2f2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 242, 242, 0));\n  }\n  .sm\\:focus\\:via-red-100:focus {\n    --gradient-via-color: #fde8e8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 232, 232, 0));\n  }\n  .sm\\:focus\\:via-red-200:focus {\n    --gradient-via-color: #fbd5d5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(251, 213, 213, 0));\n  }\n  .sm\\:focus\\:via-red-300:focus {\n    --gradient-via-color: #f8b4b4;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(248, 180, 180, 0));\n  }\n  .sm\\:focus\\:via-red-400:focus {\n    --gradient-via-color: #f98080;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(249, 128, 128, 0));\n  }\n  .sm\\:focus\\:via-red-500:focus {\n    --gradient-via-color: #f05252;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(240, 82, 82, 0));\n  }\n  .sm\\:focus\\:via-red-600:focus {\n    --gradient-via-color: #e02424;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(224, 36, 36, 0));\n  }\n  .sm\\:focus\\:via-red-700:focus {\n    --gradient-via-color: #c81e1e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(200, 30, 30, 0));\n  }\n  .sm\\:focus\\:via-red-800:focus {\n    --gradient-via-color: #9b1c1c;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(155, 28, 28, 0));\n  }\n  .sm\\:focus\\:via-red-900:focus {\n    --gradient-via-color: #771d1d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(119, 29, 29, 0));\n  }\n  .sm\\:focus\\:via-orange-50:focus {\n    --gradient-via-color: #fff8f1;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 248, 241, 0));\n  }\n  .sm\\:focus\\:via-orange-100:focus {\n    --gradient-via-color: #feecdc;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 236, 220, 0));\n  }\n  .sm\\:focus\\:via-orange-200:focus {\n    --gradient-via-color: #fcd9bd;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(252, 217, 189, 0));\n  }\n  .sm\\:focus\\:via-orange-300:focus {\n    --gradient-via-color: #fdba8c;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 186, 140, 0));\n  }\n  .sm\\:focus\\:via-orange-400:focus {\n    --gradient-via-color: #ff8a4c;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 138, 76, 0));\n  }\n  .sm\\:focus\\:via-orange-500:focus {\n    --gradient-via-color: #ff5a1f;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 90, 31, 0));\n  }\n  .sm\\:focus\\:via-orange-600:focus {\n    --gradient-via-color: #d03801;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(208, 56, 1, 0));\n  }\n  .sm\\:focus\\:via-orange-700:focus {\n    --gradient-via-color: #b43403;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(180, 52, 3, 0));\n  }\n  .sm\\:focus\\:via-orange-800:focus {\n    --gradient-via-color: #8a2c0d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(138, 44, 13, 0));\n  }\n  .sm\\:focus\\:via-orange-900:focus {\n    --gradient-via-color: #73230d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(115, 35, 13, 0));\n  }\n  .sm\\:focus\\:via-yellow-50:focus {\n    --gradient-via-color: #fdfdea;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 253, 234, 0));\n  }\n  .sm\\:focus\\:via-yellow-100:focus {\n    --gradient-via-color: #fdf6b2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 246, 178, 0));\n  }\n  .sm\\:focus\\:via-yellow-200:focus {\n    --gradient-via-color: #fce96a;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(252, 233, 106, 0));\n  }\n  .sm\\:focus\\:via-yellow-300:focus {\n    --gradient-via-color: #faca15;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(250, 202, 21, 0));\n  }\n  .sm\\:focus\\:via-yellow-400:focus {\n    --gradient-via-color: #e3a008;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(227, 160, 8, 0));\n  }\n  .sm\\:focus\\:via-yellow-500:focus {\n    --gradient-via-color: #c27803;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(194, 120, 3, 0));\n  }\n  .sm\\:focus\\:via-yellow-600:focus {\n    --gradient-via-color: #9f580a;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(159, 88, 10, 0));\n  }\n  .sm\\:focus\\:via-yellow-700:focus {\n    --gradient-via-color: #8e4b10;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(142, 75, 16, 0));\n  }\n  .sm\\:focus\\:via-yellow-800:focus {\n    --gradient-via-color: #723b13;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(114, 59, 19, 0));\n  }\n  .sm\\:focus\\:via-yellow-900:focus {\n    --gradient-via-color: #633112;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(99, 49, 18, 0));\n  }\n  .sm\\:focus\\:via-green-50:focus {\n    --gradient-via-color: #f3faf7;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(243, 250, 247, 0));\n  }\n  .sm\\:focus\\:via-green-100:focus {\n    --gradient-via-color: #def7ec;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(222, 247, 236, 0));\n  }\n  .sm\\:focus\\:via-green-200:focus {\n    --gradient-via-color: #bcf0da;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(188, 240, 218, 0));\n  }\n  .sm\\:focus\\:via-green-300:focus {\n    --gradient-via-color: #84e1bc;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(132, 225, 188, 0));\n  }\n  .sm\\:focus\\:via-green-400:focus {\n    --gradient-via-color: #31c48d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(49, 196, 141, 0));\n  }\n  .sm\\:focus\\:via-green-500:focus {\n    --gradient-via-color: #0e9f6e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(14, 159, 110, 0));\n  }\n  .sm\\:focus\\:via-green-600:focus {\n    --gradient-via-color: #057a55;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(5, 122, 85, 0));\n  }\n  .sm\\:focus\\:via-green-700:focus {\n    --gradient-via-color: #046c4e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(4, 108, 78, 0));\n  }\n  .sm\\:focus\\:via-green-800:focus {\n    --gradient-via-color: #03543f;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(3, 84, 63, 0));\n  }\n  .sm\\:focus\\:via-green-900:focus {\n    --gradient-via-color: #014737;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(1, 71, 55, 0));\n  }\n  .sm\\:focus\\:via-teal-50:focus {\n    --gradient-via-color: #edfafa;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(237, 250, 250, 0));\n  }\n  .sm\\:focus\\:via-teal-100:focus {\n    --gradient-via-color: #d5f5f6;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(213, 245, 246, 0));\n  }\n  .sm\\:focus\\:via-teal-200:focus {\n    --gradient-via-color: #afecef;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(175, 236, 239, 0));\n  }\n  .sm\\:focus\\:via-teal-300:focus {\n    --gradient-via-color: #7edce2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(126, 220, 226, 0));\n  }\n  .sm\\:focus\\:via-teal-400:focus {\n    --gradient-via-color: #16bdca;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(22, 189, 202, 0));\n  }\n  .sm\\:focus\\:via-teal-500:focus {\n    --gradient-via-color: #0694a2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(6, 148, 162, 0));\n  }\n  .sm\\:focus\\:via-teal-600:focus {\n    --gradient-via-color: #047481;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(4, 116, 129, 0));\n  }\n  .sm\\:focus\\:via-teal-700:focus {\n    --gradient-via-color: #036672;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(3, 102, 114, 0));\n  }\n  .sm\\:focus\\:via-teal-800:focus {\n    --gradient-via-color: #05505c;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(5, 80, 92, 0));\n  }\n  .sm\\:focus\\:via-teal-900:focus {\n    --gradient-via-color: #014451;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(1, 68, 81, 0));\n  }\n  .sm\\:focus\\:via-blue-50:focus {\n    --gradient-via-color: #ebf5ff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(235, 245, 255, 0));\n  }\n  .sm\\:focus\\:via-blue-100:focus {\n    --gradient-via-color: #e1effe;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(225, 239, 254, 0));\n  }\n  .sm\\:focus\\:via-blue-200:focus {\n    --gradient-via-color: #c3ddfd;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(195, 221, 253, 0));\n  }\n  .sm\\:focus\\:via-blue-300:focus {\n    --gradient-via-color: #a4cafe;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(164, 202, 254, 0));\n  }\n  .sm\\:focus\\:via-blue-400:focus {\n    --gradient-via-color: #76a9fa;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(118, 169, 250, 0));\n  }\n  .sm\\:focus\\:via-blue-500:focus {\n    --gradient-via-color: #3f83f8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(63, 131, 248, 0));\n  }\n  .sm\\:focus\\:via-blue-600:focus {\n    --gradient-via-color: #1c64f2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(28, 100, 242, 0));\n  }\n  .sm\\:focus\\:via-blue-700:focus {\n    --gradient-via-color: #1a56db;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(26, 86, 219, 0));\n  }\n  .sm\\:focus\\:via-blue-800:focus {\n    --gradient-via-color: #1e429f;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(30, 66, 159, 0));\n  }\n  .sm\\:focus\\:via-blue-900:focus {\n    --gradient-via-color: #233876;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(35, 56, 118, 0));\n  }\n  .sm\\:focus\\:via-indigo-50:focus {\n    --gradient-via-color: #f0f5ff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(240, 245, 255, 0));\n  }\n  .sm\\:focus\\:via-indigo-100:focus {\n    --gradient-via-color: #e5edff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(229, 237, 255, 0));\n  }\n  .sm\\:focus\\:via-indigo-200:focus {\n    --gradient-via-color: #cddbfe;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(205, 219, 254, 0));\n  }\n  .sm\\:focus\\:via-indigo-300:focus {\n    --gradient-via-color: #b4c6fc;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(180, 198, 252, 0));\n  }\n  .sm\\:focus\\:via-indigo-400:focus {\n    --gradient-via-color: #8da2fb;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(141, 162, 251, 0));\n  }\n  .sm\\:focus\\:via-indigo-500:focus {\n    --gradient-via-color: #6875f5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(104, 117, 245, 0));\n  }\n  .sm\\:focus\\:via-indigo-600:focus {\n    --gradient-via-color: #5850ec;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(88, 80, 236, 0));\n  }\n  .sm\\:focus\\:via-indigo-700:focus {\n    --gradient-via-color: #5145cd;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(81, 69, 205, 0));\n  }\n  .sm\\:focus\\:via-indigo-800:focus {\n    --gradient-via-color: #42389d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(66, 56, 157, 0));\n  }\n  .sm\\:focus\\:via-indigo-900:focus {\n    --gradient-via-color: #362f78;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(54, 47, 120, 0));\n  }\n  .sm\\:focus\\:via-purple-50:focus {\n    --gradient-via-color: #f6f5ff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(246, 245, 255, 0));\n  }\n  .sm\\:focus\\:via-purple-100:focus {\n    --gradient-via-color: #edebfe;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(237, 235, 254, 0));\n  }\n  .sm\\:focus\\:via-purple-200:focus {\n    --gradient-via-color: #dcd7fe;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(220, 215, 254, 0));\n  }\n  .sm\\:focus\\:via-purple-300:focus {\n    --gradient-via-color: #cabffd;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(202, 191, 253, 0));\n  }\n  .sm\\:focus\\:via-purple-400:focus {\n    --gradient-via-color: #ac94fa;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(172, 148, 250, 0));\n  }\n  .sm\\:focus\\:via-purple-500:focus {\n    --gradient-via-color: #9061f9;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(144, 97, 249, 0));\n  }\n  .sm\\:focus\\:via-purple-600:focus {\n    --gradient-via-color: #7e3af2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(126, 58, 242, 0));\n  }\n  .sm\\:focus\\:via-purple-700:focus {\n    --gradient-via-color: #6c2bd9;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(108, 43, 217, 0));\n  }\n  .sm\\:focus\\:via-purple-800:focus {\n    --gradient-via-color: #5521b5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(85, 33, 181, 0));\n  }\n  .sm\\:focus\\:via-purple-900:focus {\n    --gradient-via-color: #4a1d96;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(74, 29, 150, 0));\n  }\n  .sm\\:focus\\:via-pink-50:focus {\n    --gradient-via-color: #fdf2f8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 242, 248, 0));\n  }\n  .sm\\:focus\\:via-pink-100:focus {\n    --gradient-via-color: #fce8f3;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(252, 232, 243, 0));\n  }\n  .sm\\:focus\\:via-pink-200:focus {\n    --gradient-via-color: #fad1e8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(250, 209, 232, 0));\n  }\n  .sm\\:focus\\:via-pink-300:focus {\n    --gradient-via-color: #f8b4d9;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(248, 180, 217, 0));\n  }\n  .sm\\:focus\\:via-pink-400:focus {\n    --gradient-via-color: #f17eb8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(241, 126, 184, 0));\n  }\n  .sm\\:focus\\:via-pink-500:focus {\n    --gradient-via-color: #e74694;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(231, 70, 148, 0));\n  }\n  .sm\\:focus\\:via-pink-600:focus {\n    --gradient-via-color: #d61f69;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(214, 31, 105, 0));\n  }\n  .sm\\:focus\\:via-pink-700:focus {\n    --gradient-via-color: #bf125d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(191, 18, 93, 0));\n  }\n  .sm\\:focus\\:via-pink-800:focus {\n    --gradient-via-color: #99154b;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(153, 21, 75, 0));\n  }\n  .sm\\:focus\\:via-pink-900:focus {\n    --gradient-via-color: #751a3d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(117, 26, 61, 0));\n  }\n  .sm\\:focus\\:via-cool-gray-50:focus {\n    --gradient-via-color: #f8fafc;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(248, 250, 252, 0));\n  }\n  .sm\\:focus\\:via-cool-gray-100:focus {\n    --gradient-via-color: #f1f5f9;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(241, 245, 249, 0));\n  }\n  .sm\\:focus\\:via-cool-gray-200:focus {\n    --gradient-via-color: #e2e8f0;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(226, 232, 240, 0));\n  }\n  .sm\\:focus\\:via-cool-gray-300:focus {\n    --gradient-via-color: #cfd8e3;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(207, 216, 227, 0));\n  }\n  .sm\\:focus\\:via-cool-gray-400:focus {\n    --gradient-via-color: #97a6ba;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(151, 166, 186, 0));\n  }\n  .sm\\:focus\\:via-cool-gray-500:focus {\n    --gradient-via-color: #64748b;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(100, 116, 139, 0));\n  }\n  .sm\\:focus\\:via-cool-gray-600:focus {\n    --gradient-via-color: #475569;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(71, 85, 105, 0));\n  }\n  .sm\\:focus\\:via-cool-gray-700:focus {\n    --gradient-via-color: #364152;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(54, 65, 82, 0));\n  }\n  .sm\\:focus\\:via-cool-gray-800:focus {\n    --gradient-via-color: #27303f;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(39, 48, 63, 0));\n  }\n  .sm\\:focus\\:via-cool-gray-900:focus {\n    --gradient-via-color: #1a202e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(26, 32, 46, 0));\n  }\n  .sm\\:focus\\:to-current:focus {\n    --gradient-to-color: currentColor;\n  }\n  .sm\\:focus\\:to-transparent:focus {\n    --gradient-to-color: transparent;\n  }\n  .sm\\:focus\\:to-white:focus {\n    --gradient-to-color: #ffffff;\n  }\n  .sm\\:focus\\:to-black:focus {\n    --gradient-to-color: #000000;\n  }\n  .sm\\:focus\\:to-gray-50:focus {\n    --gradient-to-color: #f9fafb;\n  }\n  .sm\\:focus\\:to-gray-100:focus {\n    --gradient-to-color: #f4f5f7;\n  }\n  .sm\\:focus\\:to-gray-200:focus {\n    --gradient-to-color: #e5e7eb;\n  }\n  .sm\\:focus\\:to-gray-300:focus {\n    --gradient-to-color: #d2d6dc;\n  }\n  .sm\\:focus\\:to-gray-400:focus {\n    --gradient-to-color: #9fa6b2;\n  }\n  .sm\\:focus\\:to-gray-500:focus {\n    --gradient-to-color: #6b7280;\n  }\n  .sm\\:focus\\:to-gray-600:focus {\n    --gradient-to-color: #4b5563;\n  }\n  .sm\\:focus\\:to-gray-700:focus {\n    --gradient-to-color: #374151;\n  }\n  .sm\\:focus\\:to-gray-800:focus {\n    --gradient-to-color: #252f3f;\n  }\n  .sm\\:focus\\:to-gray-900:focus {\n    --gradient-to-color: #161e2e;\n  }\n  .sm\\:focus\\:to-red-50:focus {\n    --gradient-to-color: #fdf2f2;\n  }\n  .sm\\:focus\\:to-red-100:focus {\n    --gradient-to-color: #fde8e8;\n  }\n  .sm\\:focus\\:to-red-200:focus {\n    --gradient-to-color: #fbd5d5;\n  }\n  .sm\\:focus\\:to-red-300:focus {\n    --gradient-to-color: #f8b4b4;\n  }\n  .sm\\:focus\\:to-red-400:focus {\n    --gradient-to-color: #f98080;\n  }\n  .sm\\:focus\\:to-red-500:focus {\n    --gradient-to-color: #f05252;\n  }\n  .sm\\:focus\\:to-red-600:focus {\n    --gradient-to-color: #e02424;\n  }\n  .sm\\:focus\\:to-red-700:focus {\n    --gradient-to-color: #c81e1e;\n  }\n  .sm\\:focus\\:to-red-800:focus {\n    --gradient-to-color: #9b1c1c;\n  }\n  .sm\\:focus\\:to-red-900:focus {\n    --gradient-to-color: #771d1d;\n  }\n  .sm\\:focus\\:to-orange-50:focus {\n    --gradient-to-color: #fff8f1;\n  }\n  .sm\\:focus\\:to-orange-100:focus {\n    --gradient-to-color: #feecdc;\n  }\n  .sm\\:focus\\:to-orange-200:focus {\n    --gradient-to-color: #fcd9bd;\n  }\n  .sm\\:focus\\:to-orange-300:focus {\n    --gradient-to-color: #fdba8c;\n  }\n  .sm\\:focus\\:to-orange-400:focus {\n    --gradient-to-color: #ff8a4c;\n  }\n  .sm\\:focus\\:to-orange-500:focus {\n    --gradient-to-color: #ff5a1f;\n  }\n  .sm\\:focus\\:to-orange-600:focus {\n    --gradient-to-color: #d03801;\n  }\n  .sm\\:focus\\:to-orange-700:focus {\n    --gradient-to-color: #b43403;\n  }\n  .sm\\:focus\\:to-orange-800:focus {\n    --gradient-to-color: #8a2c0d;\n  }\n  .sm\\:focus\\:to-orange-900:focus {\n    --gradient-to-color: #73230d;\n  }\n  .sm\\:focus\\:to-yellow-50:focus {\n    --gradient-to-color: #fdfdea;\n  }\n  .sm\\:focus\\:to-yellow-100:focus {\n    --gradient-to-color: #fdf6b2;\n  }\n  .sm\\:focus\\:to-yellow-200:focus {\n    --gradient-to-color: #fce96a;\n  }\n  .sm\\:focus\\:to-yellow-300:focus {\n    --gradient-to-color: #faca15;\n  }\n  .sm\\:focus\\:to-yellow-400:focus {\n    --gradient-to-color: #e3a008;\n  }\n  .sm\\:focus\\:to-yellow-500:focus {\n    --gradient-to-color: #c27803;\n  }\n  .sm\\:focus\\:to-yellow-600:focus {\n    --gradient-to-color: #9f580a;\n  }\n  .sm\\:focus\\:to-yellow-700:focus {\n    --gradient-to-color: #8e4b10;\n  }\n  .sm\\:focus\\:to-yellow-800:focus {\n    --gradient-to-color: #723b13;\n  }\n  .sm\\:focus\\:to-yellow-900:focus {\n    --gradient-to-color: #633112;\n  }\n  .sm\\:focus\\:to-green-50:focus {\n    --gradient-to-color: #f3faf7;\n  }\n  .sm\\:focus\\:to-green-100:focus {\n    --gradient-to-color: #def7ec;\n  }\n  .sm\\:focus\\:to-green-200:focus {\n    --gradient-to-color: #bcf0da;\n  }\n  .sm\\:focus\\:to-green-300:focus {\n    --gradient-to-color: #84e1bc;\n  }\n  .sm\\:focus\\:to-green-400:focus {\n    --gradient-to-color: #31c48d;\n  }\n  .sm\\:focus\\:to-green-500:focus {\n    --gradient-to-color: #0e9f6e;\n  }\n  .sm\\:focus\\:to-green-600:focus {\n    --gradient-to-color: #057a55;\n  }\n  .sm\\:focus\\:to-green-700:focus {\n    --gradient-to-color: #046c4e;\n  }\n  .sm\\:focus\\:to-green-800:focus {\n    --gradient-to-color: #03543f;\n  }\n  .sm\\:focus\\:to-green-900:focus {\n    --gradient-to-color: #014737;\n  }\n  .sm\\:focus\\:to-teal-50:focus {\n    --gradient-to-color: #edfafa;\n  }\n  .sm\\:focus\\:to-teal-100:focus {\n    --gradient-to-color: #d5f5f6;\n  }\n  .sm\\:focus\\:to-teal-200:focus {\n    --gradient-to-color: #afecef;\n  }\n  .sm\\:focus\\:to-teal-300:focus {\n    --gradient-to-color: #7edce2;\n  }\n  .sm\\:focus\\:to-teal-400:focus {\n    --gradient-to-color: #16bdca;\n  }\n  .sm\\:focus\\:to-teal-500:focus {\n    --gradient-to-color: #0694a2;\n  }\n  .sm\\:focus\\:to-teal-600:focus {\n    --gradient-to-color: #047481;\n  }\n  .sm\\:focus\\:to-teal-700:focus {\n    --gradient-to-color: #036672;\n  }\n  .sm\\:focus\\:to-teal-800:focus {\n    --gradient-to-color: #05505c;\n  }\n  .sm\\:focus\\:to-teal-900:focus {\n    --gradient-to-color: #014451;\n  }\n  .sm\\:focus\\:to-blue-50:focus {\n    --gradient-to-color: #ebf5ff;\n  }\n  .sm\\:focus\\:to-blue-100:focus {\n    --gradient-to-color: #e1effe;\n  }\n  .sm\\:focus\\:to-blue-200:focus {\n    --gradient-to-color: #c3ddfd;\n  }\n  .sm\\:focus\\:to-blue-300:focus {\n    --gradient-to-color: #a4cafe;\n  }\n  .sm\\:focus\\:to-blue-400:focus {\n    --gradient-to-color: #76a9fa;\n  }\n  .sm\\:focus\\:to-blue-500:focus {\n    --gradient-to-color: #3f83f8;\n  }\n  .sm\\:focus\\:to-blue-600:focus {\n    --gradient-to-color: #1c64f2;\n  }\n  .sm\\:focus\\:to-blue-700:focus {\n    --gradient-to-color: #1a56db;\n  }\n  .sm\\:focus\\:to-blue-800:focus {\n    --gradient-to-color: #1e429f;\n  }\n  .sm\\:focus\\:to-blue-900:focus {\n    --gradient-to-color: #233876;\n  }\n  .sm\\:focus\\:to-indigo-50:focus {\n    --gradient-to-color: #f0f5ff;\n  }\n  .sm\\:focus\\:to-indigo-100:focus {\n    --gradient-to-color: #e5edff;\n  }\n  .sm\\:focus\\:to-indigo-200:focus {\n    --gradient-to-color: #cddbfe;\n  }\n  .sm\\:focus\\:to-indigo-300:focus {\n    --gradient-to-color: #b4c6fc;\n  }\n  .sm\\:focus\\:to-indigo-400:focus {\n    --gradient-to-color: #8da2fb;\n  }\n  .sm\\:focus\\:to-indigo-500:focus {\n    --gradient-to-color: #6875f5;\n  }\n  .sm\\:focus\\:to-indigo-600:focus {\n    --gradient-to-color: #5850ec;\n  }\n  .sm\\:focus\\:to-indigo-700:focus {\n    --gradient-to-color: #5145cd;\n  }\n  .sm\\:focus\\:to-indigo-800:focus {\n    --gradient-to-color: #42389d;\n  }\n  .sm\\:focus\\:to-indigo-900:focus {\n    --gradient-to-color: #362f78;\n  }\n  .sm\\:focus\\:to-purple-50:focus {\n    --gradient-to-color: #f6f5ff;\n  }\n  .sm\\:focus\\:to-purple-100:focus {\n    --gradient-to-color: #edebfe;\n  }\n  .sm\\:focus\\:to-purple-200:focus {\n    --gradient-to-color: #dcd7fe;\n  }\n  .sm\\:focus\\:to-purple-300:focus {\n    --gradient-to-color: #cabffd;\n  }\n  .sm\\:focus\\:to-purple-400:focus {\n    --gradient-to-color: #ac94fa;\n  }\n  .sm\\:focus\\:to-purple-500:focus {\n    --gradient-to-color: #9061f9;\n  }\n  .sm\\:focus\\:to-purple-600:focus {\n    --gradient-to-color: #7e3af2;\n  }\n  .sm\\:focus\\:to-purple-700:focus {\n    --gradient-to-color: #6c2bd9;\n  }\n  .sm\\:focus\\:to-purple-800:focus {\n    --gradient-to-color: #5521b5;\n  }\n  .sm\\:focus\\:to-purple-900:focus {\n    --gradient-to-color: #4a1d96;\n  }\n  .sm\\:focus\\:to-pink-50:focus {\n    --gradient-to-color: #fdf2f8;\n  }\n  .sm\\:focus\\:to-pink-100:focus {\n    --gradient-to-color: #fce8f3;\n  }\n  .sm\\:focus\\:to-pink-200:focus {\n    --gradient-to-color: #fad1e8;\n  }\n  .sm\\:focus\\:to-pink-300:focus {\n    --gradient-to-color: #f8b4d9;\n  }\n  .sm\\:focus\\:to-pink-400:focus {\n    --gradient-to-color: #f17eb8;\n  }\n  .sm\\:focus\\:to-pink-500:focus {\n    --gradient-to-color: #e74694;\n  }\n  .sm\\:focus\\:to-pink-600:focus {\n    --gradient-to-color: #d61f69;\n  }\n  .sm\\:focus\\:to-pink-700:focus {\n    --gradient-to-color: #bf125d;\n  }\n  .sm\\:focus\\:to-pink-800:focus {\n    --gradient-to-color: #99154b;\n  }\n  .sm\\:focus\\:to-pink-900:focus {\n    --gradient-to-color: #751a3d;\n  }\n  .sm\\:focus\\:to-cool-gray-50:focus {\n    --gradient-to-color: #f8fafc;\n  }\n  .sm\\:focus\\:to-cool-gray-100:focus {\n    --gradient-to-color: #f1f5f9;\n  }\n  .sm\\:focus\\:to-cool-gray-200:focus {\n    --gradient-to-color: #e2e8f0;\n  }\n  .sm\\:focus\\:to-cool-gray-300:focus {\n    --gradient-to-color: #cfd8e3;\n  }\n  .sm\\:focus\\:to-cool-gray-400:focus {\n    --gradient-to-color: #97a6ba;\n  }\n  .sm\\:focus\\:to-cool-gray-500:focus {\n    --gradient-to-color: #64748b;\n  }\n  .sm\\:focus\\:to-cool-gray-600:focus {\n    --gradient-to-color: #475569;\n  }\n  .sm\\:focus\\:to-cool-gray-700:focus {\n    --gradient-to-color: #364152;\n  }\n  .sm\\:focus\\:to-cool-gray-800:focus {\n    --gradient-to-color: #27303f;\n  }\n  .sm\\:focus\\:to-cool-gray-900:focus {\n    --gradient-to-color: #1a202e;\n  }\n  .sm\\:bg-opacity-0 {\n    --bg-opacity: 0;\n  }\n  .sm\\:bg-opacity-25 {\n    --bg-opacity: 0.25;\n  }\n  .sm\\:bg-opacity-50 {\n    --bg-opacity: 0.5;\n  }\n  .sm\\:bg-opacity-75 {\n    --bg-opacity: 0.75;\n  }\n  .sm\\:bg-opacity-100 {\n    --bg-opacity: 1;\n  }\n  .sm\\:hover\\:bg-opacity-0:hover {\n    --bg-opacity: 0;\n  }\n  .sm\\:hover\\:bg-opacity-25:hover {\n    --bg-opacity: 0.25;\n  }\n  .sm\\:hover\\:bg-opacity-50:hover {\n    --bg-opacity: 0.5;\n  }\n  .sm\\:hover\\:bg-opacity-75:hover {\n    --bg-opacity: 0.75;\n  }\n  .sm\\:hover\\:bg-opacity-100:hover {\n    --bg-opacity: 1;\n  }\n  .sm\\:focus\\:bg-opacity-0:focus {\n    --bg-opacity: 0;\n  }\n  .sm\\:focus\\:bg-opacity-25:focus {\n    --bg-opacity: 0.25;\n  }\n  .sm\\:focus\\:bg-opacity-50:focus {\n    --bg-opacity: 0.5;\n  }\n  .sm\\:focus\\:bg-opacity-75:focus {\n    --bg-opacity: 0.75;\n  }\n  .sm\\:focus\\:bg-opacity-100:focus {\n    --bg-opacity: 1;\n  }\n  .sm\\:bg-bottom {\n    background-position: bottom;\n  }\n  .sm\\:bg-center {\n    background-position: center;\n  }\n  .sm\\:bg-left {\n    background-position: left;\n  }\n  .sm\\:bg-left-bottom {\n    background-position: left bottom;\n  }\n  .sm\\:bg-left-top {\n    background-position: left top;\n  }\n  .sm\\:bg-right {\n    background-position: right;\n  }\n  .sm\\:bg-right-bottom {\n    background-position: right bottom;\n  }\n  .sm\\:bg-right-top {\n    background-position: right top;\n  }\n  .sm\\:bg-top {\n    background-position: top;\n  }\n  .sm\\:bg-repeat {\n    background-repeat: repeat;\n  }\n  .sm\\:bg-no-repeat {\n    background-repeat: no-repeat;\n  }\n  .sm\\:bg-repeat-x {\n    background-repeat: repeat-x;\n  }\n  .sm\\:bg-repeat-y {\n    background-repeat: repeat-y;\n  }\n  .sm\\:bg-repeat-round {\n    background-repeat: round;\n  }\n  .sm\\:bg-repeat-space {\n    background-repeat: space;\n  }\n  .sm\\:bg-auto {\n    background-size: auto;\n  }\n  .sm\\:bg-cover {\n    background-size: cover;\n  }\n  .sm\\:bg-contain {\n    background-size: contain;\n  }\n  .sm\\:border-collapse {\n    border-collapse: collapse;\n  }\n  .sm\\:border-separate {\n    border-collapse: separate;\n  }\n  .sm\\:border-current {\n    border-color: currentColor;\n  }\n  .sm\\:border-transparent {\n    border-color: transparent;\n  }\n  .sm\\:border-white {\n    --border-opacity: 1;\n    border-color: #ffffff;\n    border-color: rgba(255, 255, 255, var(--border-opacity));\n  }\n  .sm\\:border-black {\n    --border-opacity: 1;\n    border-color: #000000;\n    border-color: rgba(0, 0, 0, var(--border-opacity));\n  }\n  .sm\\:border-gray-50 {\n    --border-opacity: 1;\n    border-color: #f9fafb;\n    border-color: rgba(249, 250, 251, var(--border-opacity));\n  }\n  .sm\\:border-gray-100 {\n    --border-opacity: 1;\n    border-color: #f4f5f7;\n    border-color: rgba(244, 245, 247, var(--border-opacity));\n  }\n  .sm\\:border-gray-200 {\n    --border-opacity: 1;\n    border-color: #e5e7eb;\n    border-color: rgba(229, 231, 235, var(--border-opacity));\n  }\n  .sm\\:border-gray-300 {\n    --border-opacity: 1;\n    border-color: #d2d6dc;\n    border-color: rgba(210, 214, 220, var(--border-opacity));\n  }\n  .sm\\:border-gray-400 {\n    --border-opacity: 1;\n    border-color: #9fa6b2;\n    border-color: rgba(159, 166, 178, var(--border-opacity));\n  }\n  .sm\\:border-gray-500 {\n    --border-opacity: 1;\n    border-color: #6b7280;\n    border-color: rgba(107, 114, 128, var(--border-opacity));\n  }\n  .sm\\:border-gray-600 {\n    --border-opacity: 1;\n    border-color: #4b5563;\n    border-color: rgba(75, 85, 99, var(--border-opacity));\n  }\n  .sm\\:border-gray-700 {\n    --border-opacity: 1;\n    border-color: #374151;\n    border-color: rgba(55, 65, 81, var(--border-opacity));\n  }\n  .sm\\:border-gray-800 {\n    --border-opacity: 1;\n    border-color: #252f3f;\n    border-color: rgba(37, 47, 63, var(--border-opacity));\n  }\n  .sm\\:border-gray-900 {\n    --border-opacity: 1;\n    border-color: #161e2e;\n    border-color: rgba(22, 30, 46, var(--border-opacity));\n  }\n  .sm\\:border-red-50 {\n    --border-opacity: 1;\n    border-color: #fdf2f2;\n    border-color: rgba(253, 242, 242, var(--border-opacity));\n  }\n  .sm\\:border-red-100 {\n    --border-opacity: 1;\n    border-color: #fde8e8;\n    border-color: rgba(253, 232, 232, var(--border-opacity));\n  }\n  .sm\\:border-red-200 {\n    --border-opacity: 1;\n    border-color: #fbd5d5;\n    border-color: rgba(251, 213, 213, var(--border-opacity));\n  }\n  .sm\\:border-red-300 {\n    --border-opacity: 1;\n    border-color: #f8b4b4;\n    border-color: rgba(248, 180, 180, var(--border-opacity));\n  }\n  .sm\\:border-red-400 {\n    --border-opacity: 1;\n    border-color: #f98080;\n    border-color: rgba(249, 128, 128, var(--border-opacity));\n  }\n  .sm\\:border-red-500 {\n    --border-opacity: 1;\n    border-color: #f05252;\n    border-color: rgba(240, 82, 82, var(--border-opacity));\n  }\n  .sm\\:border-red-600 {\n    --border-opacity: 1;\n    border-color: #e02424;\n    border-color: rgba(224, 36, 36, var(--border-opacity));\n  }\n  .sm\\:border-red-700 {\n    --border-opacity: 1;\n    border-color: #c81e1e;\n    border-color: rgba(200, 30, 30, var(--border-opacity));\n  }\n  .sm\\:border-red-800 {\n    --border-opacity: 1;\n    border-color: #9b1c1c;\n    border-color: rgba(155, 28, 28, var(--border-opacity));\n  }\n  .sm\\:border-red-900 {\n    --border-opacity: 1;\n    border-color: #771d1d;\n    border-color: rgba(119, 29, 29, var(--border-opacity));\n  }\n  .sm\\:border-orange-50 {\n    --border-opacity: 1;\n    border-color: #fff8f1;\n    border-color: rgba(255, 248, 241, var(--border-opacity));\n  }\n  .sm\\:border-orange-100 {\n    --border-opacity: 1;\n    border-color: #feecdc;\n    border-color: rgba(254, 236, 220, var(--border-opacity));\n  }\n  .sm\\:border-orange-200 {\n    --border-opacity: 1;\n    border-color: #fcd9bd;\n    border-color: rgba(252, 217, 189, var(--border-opacity));\n  }\n  .sm\\:border-orange-300 {\n    --border-opacity: 1;\n    border-color: #fdba8c;\n    border-color: rgba(253, 186, 140, var(--border-opacity));\n  }\n  .sm\\:border-orange-400 {\n    --border-opacity: 1;\n    border-color: #ff8a4c;\n    border-color: rgba(255, 138, 76, var(--border-opacity));\n  }\n  .sm\\:border-orange-500 {\n    --border-opacity: 1;\n    border-color: #ff5a1f;\n    border-color: rgba(255, 90, 31, var(--border-opacity));\n  }\n  .sm\\:border-orange-600 {\n    --border-opacity: 1;\n    border-color: #d03801;\n    border-color: rgba(208, 56, 1, var(--border-opacity));\n  }\n  .sm\\:border-orange-700 {\n    --border-opacity: 1;\n    border-color: #b43403;\n    border-color: rgba(180, 52, 3, var(--border-opacity));\n  }\n  .sm\\:border-orange-800 {\n    --border-opacity: 1;\n    border-color: #8a2c0d;\n    border-color: rgba(138, 44, 13, var(--border-opacity));\n  }\n  .sm\\:border-orange-900 {\n    --border-opacity: 1;\n    border-color: #73230d;\n    border-color: rgba(115, 35, 13, var(--border-opacity));\n  }\n  .sm\\:border-yellow-50 {\n    --border-opacity: 1;\n    border-color: #fdfdea;\n    border-color: rgba(253, 253, 234, var(--border-opacity));\n  }\n  .sm\\:border-yellow-100 {\n    --border-opacity: 1;\n    border-color: #fdf6b2;\n    border-color: rgba(253, 246, 178, var(--border-opacity));\n  }\n  .sm\\:border-yellow-200 {\n    --border-opacity: 1;\n    border-color: #fce96a;\n    border-color: rgba(252, 233, 106, var(--border-opacity));\n  }\n  .sm\\:border-yellow-300 {\n    --border-opacity: 1;\n    border-color: #faca15;\n    border-color: rgba(250, 202, 21, var(--border-opacity));\n  }\n  .sm\\:border-yellow-400 {\n    --border-opacity: 1;\n    border-color: #e3a008;\n    border-color: rgba(227, 160, 8, var(--border-opacity));\n  }\n  .sm\\:border-yellow-500 {\n    --border-opacity: 1;\n    border-color: #c27803;\n    border-color: rgba(194, 120, 3, var(--border-opacity));\n  }\n  .sm\\:border-yellow-600 {\n    --border-opacity: 1;\n    border-color: #9f580a;\n    border-color: rgba(159, 88, 10, var(--border-opacity));\n  }\n  .sm\\:border-yellow-700 {\n    --border-opacity: 1;\n    border-color: #8e4b10;\n    border-color: rgba(142, 75, 16, var(--border-opacity));\n  }\n  .sm\\:border-yellow-800 {\n    --border-opacity: 1;\n    border-color: #723b13;\n    border-color: rgba(114, 59, 19, var(--border-opacity));\n  }\n  .sm\\:border-yellow-900 {\n    --border-opacity: 1;\n    border-color: #633112;\n    border-color: rgba(99, 49, 18, var(--border-opacity));\n  }\n  .sm\\:border-green-50 {\n    --border-opacity: 1;\n    border-color: #f3faf7;\n    border-color: rgba(243, 250, 247, var(--border-opacity));\n  }\n  .sm\\:border-green-100 {\n    --border-opacity: 1;\n    border-color: #def7ec;\n    border-color: rgba(222, 247, 236, var(--border-opacity));\n  }\n  .sm\\:border-green-200 {\n    --border-opacity: 1;\n    border-color: #bcf0da;\n    border-color: rgba(188, 240, 218, var(--border-opacity));\n  }\n  .sm\\:border-green-300 {\n    --border-opacity: 1;\n    border-color: #84e1bc;\n    border-color: rgba(132, 225, 188, var(--border-opacity));\n  }\n  .sm\\:border-green-400 {\n    --border-opacity: 1;\n    border-color: #31c48d;\n    border-color: rgba(49, 196, 141, var(--border-opacity));\n  }\n  .sm\\:border-green-500 {\n    --border-opacity: 1;\n    border-color: #0e9f6e;\n    border-color: rgba(14, 159, 110, var(--border-opacity));\n  }\n  .sm\\:border-green-600 {\n    --border-opacity: 1;\n    border-color: #057a55;\n    border-color: rgba(5, 122, 85, var(--border-opacity));\n  }\n  .sm\\:border-green-700 {\n    --border-opacity: 1;\n    border-color: #046c4e;\n    border-color: rgba(4, 108, 78, var(--border-opacity));\n  }\n  .sm\\:border-green-800 {\n    --border-opacity: 1;\n    border-color: #03543f;\n    border-color: rgba(3, 84, 63, var(--border-opacity));\n  }\n  .sm\\:border-green-900 {\n    --border-opacity: 1;\n    border-color: #014737;\n    border-color: rgba(1, 71, 55, var(--border-opacity));\n  }\n  .sm\\:border-teal-50 {\n    --border-opacity: 1;\n    border-color: #edfafa;\n    border-color: rgba(237, 250, 250, var(--border-opacity));\n  }\n  .sm\\:border-teal-100 {\n    --border-opacity: 1;\n    border-color: #d5f5f6;\n    border-color: rgba(213, 245, 246, var(--border-opacity));\n  }\n  .sm\\:border-teal-200 {\n    --border-opacity: 1;\n    border-color: #afecef;\n    border-color: rgba(175, 236, 239, var(--border-opacity));\n  }\n  .sm\\:border-teal-300 {\n    --border-opacity: 1;\n    border-color: #7edce2;\n    border-color: rgba(126, 220, 226, var(--border-opacity));\n  }\n  .sm\\:border-teal-400 {\n    --border-opacity: 1;\n    border-color: #16bdca;\n    border-color: rgba(22, 189, 202, var(--border-opacity));\n  }\n  .sm\\:border-teal-500 {\n    --border-opacity: 1;\n    border-color: #0694a2;\n    border-color: rgba(6, 148, 162, var(--border-opacity));\n  }\n  .sm\\:border-teal-600 {\n    --border-opacity: 1;\n    border-color: #047481;\n    border-color: rgba(4, 116, 129, var(--border-opacity));\n  }\n  .sm\\:border-teal-700 {\n    --border-opacity: 1;\n    border-color: #036672;\n    border-color: rgba(3, 102, 114, var(--border-opacity));\n  }\n  .sm\\:border-teal-800 {\n    --border-opacity: 1;\n    border-color: #05505c;\n    border-color: rgba(5, 80, 92, var(--border-opacity));\n  }\n  .sm\\:border-teal-900 {\n    --border-opacity: 1;\n    border-color: #014451;\n    border-color: rgba(1, 68, 81, var(--border-opacity));\n  }\n  .sm\\:border-blue-50 {\n    --border-opacity: 1;\n    border-color: #ebf5ff;\n    border-color: rgba(235, 245, 255, var(--border-opacity));\n  }\n  .sm\\:border-blue-100 {\n    --border-opacity: 1;\n    border-color: #e1effe;\n    border-color: rgba(225, 239, 254, var(--border-opacity));\n  }\n  .sm\\:border-blue-200 {\n    --border-opacity: 1;\n    border-color: #c3ddfd;\n    border-color: rgba(195, 221, 253, var(--border-opacity));\n  }\n  .sm\\:border-blue-300 {\n    --border-opacity: 1;\n    border-color: #a4cafe;\n    border-color: rgba(164, 202, 254, var(--border-opacity));\n  }\n  .sm\\:border-blue-400 {\n    --border-opacity: 1;\n    border-color: #76a9fa;\n    border-color: rgba(118, 169, 250, var(--border-opacity));\n  }\n  .sm\\:border-blue-500 {\n    --border-opacity: 1;\n    border-color: #3f83f8;\n    border-color: rgba(63, 131, 248, var(--border-opacity));\n  }\n  .sm\\:border-blue-600 {\n    --border-opacity: 1;\n    border-color: #1c64f2;\n    border-color: rgba(28, 100, 242, var(--border-opacity));\n  }\n  .sm\\:border-blue-700 {\n    --border-opacity: 1;\n    border-color: #1a56db;\n    border-color: rgba(26, 86, 219, var(--border-opacity));\n  }\n  .sm\\:border-blue-800 {\n    --border-opacity: 1;\n    border-color: #1e429f;\n    border-color: rgba(30, 66, 159, var(--border-opacity));\n  }\n  .sm\\:border-blue-900 {\n    --border-opacity: 1;\n    border-color: #233876;\n    border-color: rgba(35, 56, 118, var(--border-opacity));\n  }\n  .sm\\:border-indigo-50 {\n    --border-opacity: 1;\n    border-color: #f0f5ff;\n    border-color: rgba(240, 245, 255, var(--border-opacity));\n  }\n  .sm\\:border-indigo-100 {\n    --border-opacity: 1;\n    border-color: #e5edff;\n    border-color: rgba(229, 237, 255, var(--border-opacity));\n  }\n  .sm\\:border-indigo-200 {\n    --border-opacity: 1;\n    border-color: #cddbfe;\n    border-color: rgba(205, 219, 254, var(--border-opacity));\n  }\n  .sm\\:border-indigo-300 {\n    --border-opacity: 1;\n    border-color: #b4c6fc;\n    border-color: rgba(180, 198, 252, var(--border-opacity));\n  }\n  .sm\\:border-indigo-400 {\n    --border-opacity: 1;\n    border-color: #8da2fb;\n    border-color: rgba(141, 162, 251, var(--border-opacity));\n  }\n  .sm\\:border-indigo-500 {\n    --border-opacity: 1;\n    border-color: #6875f5;\n    border-color: rgba(104, 117, 245, var(--border-opacity));\n  }\n  .sm\\:border-indigo-600 {\n    --border-opacity: 1;\n    border-color: #5850ec;\n    border-color: rgba(88, 80, 236, var(--border-opacity));\n  }\n  .sm\\:border-indigo-700 {\n    --border-opacity: 1;\n    border-color: #5145cd;\n    border-color: rgba(81, 69, 205, var(--border-opacity));\n  }\n  .sm\\:border-indigo-800 {\n    --border-opacity: 1;\n    border-color: #42389d;\n    border-color: rgba(66, 56, 157, var(--border-opacity));\n  }\n  .sm\\:border-indigo-900 {\n    --border-opacity: 1;\n    border-color: #362f78;\n    border-color: rgba(54, 47, 120, var(--border-opacity));\n  }\n  .sm\\:border-purple-50 {\n    --border-opacity: 1;\n    border-color: #f6f5ff;\n    border-color: rgba(246, 245, 255, var(--border-opacity));\n  }\n  .sm\\:border-purple-100 {\n    --border-opacity: 1;\n    border-color: #edebfe;\n    border-color: rgba(237, 235, 254, var(--border-opacity));\n  }\n  .sm\\:border-purple-200 {\n    --border-opacity: 1;\n    border-color: #dcd7fe;\n    border-color: rgba(220, 215, 254, var(--border-opacity));\n  }\n  .sm\\:border-purple-300 {\n    --border-opacity: 1;\n    border-color: #cabffd;\n    border-color: rgba(202, 191, 253, var(--border-opacity));\n  }\n  .sm\\:border-purple-400 {\n    --border-opacity: 1;\n    border-color: #ac94fa;\n    border-color: rgba(172, 148, 250, var(--border-opacity));\n  }\n  .sm\\:border-purple-500 {\n    --border-opacity: 1;\n    border-color: #9061f9;\n    border-color: rgba(144, 97, 249, var(--border-opacity));\n  }\n  .sm\\:border-purple-600 {\n    --border-opacity: 1;\n    border-color: #7e3af2;\n    border-color: rgba(126, 58, 242, var(--border-opacity));\n  }\n  .sm\\:border-purple-700 {\n    --border-opacity: 1;\n    border-color: #6c2bd9;\n    border-color: rgba(108, 43, 217, var(--border-opacity));\n  }\n  .sm\\:border-purple-800 {\n    --border-opacity: 1;\n    border-color: #5521b5;\n    border-color: rgba(85, 33, 181, var(--border-opacity));\n  }\n  .sm\\:border-purple-900 {\n    --border-opacity: 1;\n    border-color: #4a1d96;\n    border-color: rgba(74, 29, 150, var(--border-opacity));\n  }\n  .sm\\:border-pink-50 {\n    --border-opacity: 1;\n    border-color: #fdf2f8;\n    border-color: rgba(253, 242, 248, var(--border-opacity));\n  }\n  .sm\\:border-pink-100 {\n    --border-opacity: 1;\n    border-color: #fce8f3;\n    border-color: rgba(252, 232, 243, var(--border-opacity));\n  }\n  .sm\\:border-pink-200 {\n    --border-opacity: 1;\n    border-color: #fad1e8;\n    border-color: rgba(250, 209, 232, var(--border-opacity));\n  }\n  .sm\\:border-pink-300 {\n    --border-opacity: 1;\n    border-color: #f8b4d9;\n    border-color: rgba(248, 180, 217, var(--border-opacity));\n  }\n  .sm\\:border-pink-400 {\n    --border-opacity: 1;\n    border-color: #f17eb8;\n    border-color: rgba(241, 126, 184, var(--border-opacity));\n  }\n  .sm\\:border-pink-500 {\n    --border-opacity: 1;\n    border-color: #e74694;\n    border-color: rgba(231, 70, 148, var(--border-opacity));\n  }\n  .sm\\:border-pink-600 {\n    --border-opacity: 1;\n    border-color: #d61f69;\n    border-color: rgba(214, 31, 105, var(--border-opacity));\n  }\n  .sm\\:border-pink-700 {\n    --border-opacity: 1;\n    border-color: #bf125d;\n    border-color: rgba(191, 18, 93, var(--border-opacity));\n  }\n  .sm\\:border-pink-800 {\n    --border-opacity: 1;\n    border-color: #99154b;\n    border-color: rgba(153, 21, 75, var(--border-opacity));\n  }\n  .sm\\:border-pink-900 {\n    --border-opacity: 1;\n    border-color: #751a3d;\n    border-color: rgba(117, 26, 61, var(--border-opacity));\n  }\n  .sm\\:border-cool-gray-50 {\n    --border-opacity: 1;\n    border-color: #f8fafc;\n    border-color: rgba(248, 250, 252, var(--border-opacity));\n  }\n  .sm\\:border-cool-gray-100 {\n    --border-opacity: 1;\n    border-color: #f1f5f9;\n    border-color: rgba(241, 245, 249, var(--border-opacity));\n  }\n  .sm\\:border-cool-gray-200 {\n    --border-opacity: 1;\n    border-color: #e2e8f0;\n    border-color: rgba(226, 232, 240, var(--border-opacity));\n  }\n  .sm\\:border-cool-gray-300 {\n    --border-opacity: 1;\n    border-color: #cfd8e3;\n    border-color: rgba(207, 216, 227, var(--border-opacity));\n  }\n  .sm\\:border-cool-gray-400 {\n    --border-opacity: 1;\n    border-color: #97a6ba;\n    border-color: rgba(151, 166, 186, var(--border-opacity));\n  }\n  .sm\\:border-cool-gray-500 {\n    --border-opacity: 1;\n    border-color: #64748b;\n    border-color: rgba(100, 116, 139, var(--border-opacity));\n  }\n  .sm\\:border-cool-gray-600 {\n    --border-opacity: 1;\n    border-color: #475569;\n    border-color: rgba(71, 85, 105, var(--border-opacity));\n  }\n  .sm\\:border-cool-gray-700 {\n    --border-opacity: 1;\n    border-color: #364152;\n    border-color: rgba(54, 65, 82, var(--border-opacity));\n  }\n  .sm\\:border-cool-gray-800 {\n    --border-opacity: 1;\n    border-color: #27303f;\n    border-color: rgba(39, 48, 63, var(--border-opacity));\n  }\n  .sm\\:border-cool-gray-900 {\n    --border-opacity: 1;\n    border-color: #1a202e;\n    border-color: rgba(26, 32, 46, var(--border-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:border-current {\n    border-color: currentColor;\n  }\n  .group:hover .sm\\:group-hover\\:border-transparent {\n    border-color: transparent;\n  }\n  .group:hover .sm\\:group-hover\\:border-white {\n    --border-opacity: 1;\n    border-color: #ffffff;\n    border-color: rgba(255, 255, 255, var(--border-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:border-black {\n    --border-opacity: 1;\n    border-color: #000000;\n    border-color: rgba(0, 0, 0, var(--border-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:border-gray-50 {\n    --border-opacity: 1;\n    border-color: #f9fafb;\n    border-color: rgba(249, 250, 251, var(--border-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:border-gray-100 {\n    --border-opacity: 1;\n    border-color: #f4f5f7;\n    border-color: rgba(244, 245, 247, var(--border-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:border-gray-200 {\n    --border-opacity: 1;\n    border-color: #e5e7eb;\n    border-color: rgba(229, 231, 235, var(--border-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:border-gray-300 {\n    --border-opacity: 1;\n    border-color: #d2d6dc;\n    border-color: rgba(210, 214, 220, var(--border-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:border-gray-400 {\n    --border-opacity: 1;\n    border-color: #9fa6b2;\n    border-color: rgba(159, 166, 178, var(--border-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:border-gray-500 {\n    --border-opacity: 1;\n    border-color: #6b7280;\n    border-color: rgba(107, 114, 128, var(--border-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:border-gray-600 {\n    --border-opacity: 1;\n    border-color: #4b5563;\n    border-color: rgba(75, 85, 99, var(--border-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:border-gray-700 {\n    --border-opacity: 1;\n    border-color: #374151;\n    border-color: rgba(55, 65, 81, var(--border-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:border-gray-800 {\n    --border-opacity: 1;\n    border-color: #252f3f;\n    border-color: rgba(37, 47, 63, var(--border-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:border-gray-900 {\n    --border-opacity: 1;\n    border-color: #161e2e;\n    border-color: rgba(22, 30, 46, var(--border-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:border-red-50 {\n    --border-opacity: 1;\n    border-color: #fdf2f2;\n    border-color: rgba(253, 242, 242, var(--border-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:border-red-100 {\n    --border-opacity: 1;\n    border-color: #fde8e8;\n    border-color: rgba(253, 232, 232, var(--border-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:border-red-200 {\n    --border-opacity: 1;\n    border-color: #fbd5d5;\n    border-color: rgba(251, 213, 213, var(--border-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:border-red-300 {\n    --border-opacity: 1;\n    border-color: #f8b4b4;\n    border-color: rgba(248, 180, 180, var(--border-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:border-red-400 {\n    --border-opacity: 1;\n    border-color: #f98080;\n    border-color: rgba(249, 128, 128, var(--border-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:border-red-500 {\n    --border-opacity: 1;\n    border-color: #f05252;\n    border-color: rgba(240, 82, 82, var(--border-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:border-red-600 {\n    --border-opacity: 1;\n    border-color: #e02424;\n    border-color: rgba(224, 36, 36, var(--border-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:border-red-700 {\n    --border-opacity: 1;\n    border-color: #c81e1e;\n    border-color: rgba(200, 30, 30, var(--border-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:border-red-800 {\n    --border-opacity: 1;\n    border-color: #9b1c1c;\n    border-color: rgba(155, 28, 28, var(--border-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:border-red-900 {\n    --border-opacity: 1;\n    border-color: #771d1d;\n    border-color: rgba(119, 29, 29, var(--border-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:border-orange-50 {\n    --border-opacity: 1;\n    border-color: #fff8f1;\n    border-color: rgba(255, 248, 241, var(--border-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:border-orange-100 {\n    --border-opacity: 1;\n    border-color: #feecdc;\n    border-color: rgba(254, 236, 220, var(--border-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:border-orange-200 {\n    --border-opacity: 1;\n    border-color: #fcd9bd;\n    border-color: rgba(252, 217, 189, var(--border-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:border-orange-300 {\n    --border-opacity: 1;\n    border-color: #fdba8c;\n    border-color: rgba(253, 186, 140, var(--border-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:border-orange-400 {\n    --border-opacity: 1;\n    border-color: #ff8a4c;\n    border-color: rgba(255, 138, 76, var(--border-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:border-orange-500 {\n    --border-opacity: 1;\n    border-color: #ff5a1f;\n    border-color: rgba(255, 90, 31, var(--border-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:border-orange-600 {\n    --border-opacity: 1;\n    border-color: #d03801;\n    border-color: rgba(208, 56, 1, var(--border-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:border-orange-700 {\n    --border-opacity: 1;\n    border-color: #b43403;\n    border-color: rgba(180, 52, 3, var(--border-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:border-orange-800 {\n    --border-opacity: 1;\n    border-color: #8a2c0d;\n    border-color: rgba(138, 44, 13, var(--border-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:border-orange-900 {\n    --border-opacity: 1;\n    border-color: #73230d;\n    border-color: rgba(115, 35, 13, var(--border-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:border-yellow-50 {\n    --border-opacity: 1;\n    border-color: #fdfdea;\n    border-color: rgba(253, 253, 234, var(--border-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:border-yellow-100 {\n    --border-opacity: 1;\n    border-color: #fdf6b2;\n    border-color: rgba(253, 246, 178, var(--border-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:border-yellow-200 {\n    --border-opacity: 1;\n    border-color: #fce96a;\n    border-color: rgba(252, 233, 106, var(--border-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:border-yellow-300 {\n    --border-opacity: 1;\n    border-color: #faca15;\n    border-color: rgba(250, 202, 21, var(--border-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:border-yellow-400 {\n    --border-opacity: 1;\n    border-color: #e3a008;\n    border-color: rgba(227, 160, 8, var(--border-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:border-yellow-500 {\n    --border-opacity: 1;\n    border-color: #c27803;\n    border-color: rgba(194, 120, 3, var(--border-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:border-yellow-600 {\n    --border-opacity: 1;\n    border-color: #9f580a;\n    border-color: rgba(159, 88, 10, var(--border-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:border-yellow-700 {\n    --border-opacity: 1;\n    border-color: #8e4b10;\n    border-color: rgba(142, 75, 16, var(--border-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:border-yellow-800 {\n    --border-opacity: 1;\n    border-color: #723b13;\n    border-color: rgba(114, 59, 19, var(--border-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:border-yellow-900 {\n    --border-opacity: 1;\n    border-color: #633112;\n    border-color: rgba(99, 49, 18, var(--border-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:border-green-50 {\n    --border-opacity: 1;\n    border-color: #f3faf7;\n    border-color: rgba(243, 250, 247, var(--border-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:border-green-100 {\n    --border-opacity: 1;\n    border-color: #def7ec;\n    border-color: rgba(222, 247, 236, var(--border-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:border-green-200 {\n    --border-opacity: 1;\n    border-color: #bcf0da;\n    border-color: rgba(188, 240, 218, var(--border-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:border-green-300 {\n    --border-opacity: 1;\n    border-color: #84e1bc;\n    border-color: rgba(132, 225, 188, var(--border-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:border-green-400 {\n    --border-opacity: 1;\n    border-color: #31c48d;\n    border-color: rgba(49, 196, 141, var(--border-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:border-green-500 {\n    --border-opacity: 1;\n    border-color: #0e9f6e;\n    border-color: rgba(14, 159, 110, var(--border-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:border-green-600 {\n    --border-opacity: 1;\n    border-color: #057a55;\n    border-color: rgba(5, 122, 85, var(--border-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:border-green-700 {\n    --border-opacity: 1;\n    border-color: #046c4e;\n    border-color: rgba(4, 108, 78, var(--border-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:border-green-800 {\n    --border-opacity: 1;\n    border-color: #03543f;\n    border-color: rgba(3, 84, 63, var(--border-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:border-green-900 {\n    --border-opacity: 1;\n    border-color: #014737;\n    border-color: rgba(1, 71, 55, var(--border-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:border-teal-50 {\n    --border-opacity: 1;\n    border-color: #edfafa;\n    border-color: rgba(237, 250, 250, var(--border-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:border-teal-100 {\n    --border-opacity: 1;\n    border-color: #d5f5f6;\n    border-color: rgba(213, 245, 246, var(--border-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:border-teal-200 {\n    --border-opacity: 1;\n    border-color: #afecef;\n    border-color: rgba(175, 236, 239, var(--border-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:border-teal-300 {\n    --border-opacity: 1;\n    border-color: #7edce2;\n    border-color: rgba(126, 220, 226, var(--border-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:border-teal-400 {\n    --border-opacity: 1;\n    border-color: #16bdca;\n    border-color: rgba(22, 189, 202, var(--border-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:border-teal-500 {\n    --border-opacity: 1;\n    border-color: #0694a2;\n    border-color: rgba(6, 148, 162, var(--border-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:border-teal-600 {\n    --border-opacity: 1;\n    border-color: #047481;\n    border-color: rgba(4, 116, 129, var(--border-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:border-teal-700 {\n    --border-opacity: 1;\n    border-color: #036672;\n    border-color: rgba(3, 102, 114, var(--border-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:border-teal-800 {\n    --border-opacity: 1;\n    border-color: #05505c;\n    border-color: rgba(5, 80, 92, var(--border-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:border-teal-900 {\n    --border-opacity: 1;\n    border-color: #014451;\n    border-color: rgba(1, 68, 81, var(--border-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:border-blue-50 {\n    --border-opacity: 1;\n    border-color: #ebf5ff;\n    border-color: rgba(235, 245, 255, var(--border-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:border-blue-100 {\n    --border-opacity: 1;\n    border-color: #e1effe;\n    border-color: rgba(225, 239, 254, var(--border-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:border-blue-200 {\n    --border-opacity: 1;\n    border-color: #c3ddfd;\n    border-color: rgba(195, 221, 253, var(--border-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:border-blue-300 {\n    --border-opacity: 1;\n    border-color: #a4cafe;\n    border-color: rgba(164, 202, 254, var(--border-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:border-blue-400 {\n    --border-opacity: 1;\n    border-color: #76a9fa;\n    border-color: rgba(118, 169, 250, var(--border-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:border-blue-500 {\n    --border-opacity: 1;\n    border-color: #3f83f8;\n    border-color: rgba(63, 131, 248, var(--border-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:border-blue-600 {\n    --border-opacity: 1;\n    border-color: #1c64f2;\n    border-color: rgba(28, 100, 242, var(--border-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:border-blue-700 {\n    --border-opacity: 1;\n    border-color: #1a56db;\n    border-color: rgba(26, 86, 219, var(--border-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:border-blue-800 {\n    --border-opacity: 1;\n    border-color: #1e429f;\n    border-color: rgba(30, 66, 159, var(--border-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:border-blue-900 {\n    --border-opacity: 1;\n    border-color: #233876;\n    border-color: rgba(35, 56, 118, var(--border-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:border-indigo-50 {\n    --border-opacity: 1;\n    border-color: #f0f5ff;\n    border-color: rgba(240, 245, 255, var(--border-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:border-indigo-100 {\n    --border-opacity: 1;\n    border-color: #e5edff;\n    border-color: rgba(229, 237, 255, var(--border-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:border-indigo-200 {\n    --border-opacity: 1;\n    border-color: #cddbfe;\n    border-color: rgba(205, 219, 254, var(--border-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:border-indigo-300 {\n    --border-opacity: 1;\n    border-color: #b4c6fc;\n    border-color: rgba(180, 198, 252, var(--border-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:border-indigo-400 {\n    --border-opacity: 1;\n    border-color: #8da2fb;\n    border-color: rgba(141, 162, 251, var(--border-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:border-indigo-500 {\n    --border-opacity: 1;\n    border-color: #6875f5;\n    border-color: rgba(104, 117, 245, var(--border-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:border-indigo-600 {\n    --border-opacity: 1;\n    border-color: #5850ec;\n    border-color: rgba(88, 80, 236, var(--border-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:border-indigo-700 {\n    --border-opacity: 1;\n    border-color: #5145cd;\n    border-color: rgba(81, 69, 205, var(--border-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:border-indigo-800 {\n    --border-opacity: 1;\n    border-color: #42389d;\n    border-color: rgba(66, 56, 157, var(--border-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:border-indigo-900 {\n    --border-opacity: 1;\n    border-color: #362f78;\n    border-color: rgba(54, 47, 120, var(--border-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:border-purple-50 {\n    --border-opacity: 1;\n    border-color: #f6f5ff;\n    border-color: rgba(246, 245, 255, var(--border-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:border-purple-100 {\n    --border-opacity: 1;\n    border-color: #edebfe;\n    border-color: rgba(237, 235, 254, var(--border-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:border-purple-200 {\n    --border-opacity: 1;\n    border-color: #dcd7fe;\n    border-color: rgba(220, 215, 254, var(--border-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:border-purple-300 {\n    --border-opacity: 1;\n    border-color: #cabffd;\n    border-color: rgba(202, 191, 253, var(--border-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:border-purple-400 {\n    --border-opacity: 1;\n    border-color: #ac94fa;\n    border-color: rgba(172, 148, 250, var(--border-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:border-purple-500 {\n    --border-opacity: 1;\n    border-color: #9061f9;\n    border-color: rgba(144, 97, 249, var(--border-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:border-purple-600 {\n    --border-opacity: 1;\n    border-color: #7e3af2;\n    border-color: rgba(126, 58, 242, var(--border-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:border-purple-700 {\n    --border-opacity: 1;\n    border-color: #6c2bd9;\n    border-color: rgba(108, 43, 217, var(--border-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:border-purple-800 {\n    --border-opacity: 1;\n    border-color: #5521b5;\n    border-color: rgba(85, 33, 181, var(--border-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:border-purple-900 {\n    --border-opacity: 1;\n    border-color: #4a1d96;\n    border-color: rgba(74, 29, 150, var(--border-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:border-pink-50 {\n    --border-opacity: 1;\n    border-color: #fdf2f8;\n    border-color: rgba(253, 242, 248, var(--border-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:border-pink-100 {\n    --border-opacity: 1;\n    border-color: #fce8f3;\n    border-color: rgba(252, 232, 243, var(--border-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:border-pink-200 {\n    --border-opacity: 1;\n    border-color: #fad1e8;\n    border-color: rgba(250, 209, 232, var(--border-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:border-pink-300 {\n    --border-opacity: 1;\n    border-color: #f8b4d9;\n    border-color: rgba(248, 180, 217, var(--border-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:border-pink-400 {\n    --border-opacity: 1;\n    border-color: #f17eb8;\n    border-color: rgba(241, 126, 184, var(--border-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:border-pink-500 {\n    --border-opacity: 1;\n    border-color: #e74694;\n    border-color: rgba(231, 70, 148, var(--border-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:border-pink-600 {\n    --border-opacity: 1;\n    border-color: #d61f69;\n    border-color: rgba(214, 31, 105, var(--border-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:border-pink-700 {\n    --border-opacity: 1;\n    border-color: #bf125d;\n    border-color: rgba(191, 18, 93, var(--border-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:border-pink-800 {\n    --border-opacity: 1;\n    border-color: #99154b;\n    border-color: rgba(153, 21, 75, var(--border-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:border-pink-900 {\n    --border-opacity: 1;\n    border-color: #751a3d;\n    border-color: rgba(117, 26, 61, var(--border-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:border-cool-gray-50 {\n    --border-opacity: 1;\n    border-color: #f8fafc;\n    border-color: rgba(248, 250, 252, var(--border-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:border-cool-gray-100 {\n    --border-opacity: 1;\n    border-color: #f1f5f9;\n    border-color: rgba(241, 245, 249, var(--border-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:border-cool-gray-200 {\n    --border-opacity: 1;\n    border-color: #e2e8f0;\n    border-color: rgba(226, 232, 240, var(--border-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:border-cool-gray-300 {\n    --border-opacity: 1;\n    border-color: #cfd8e3;\n    border-color: rgba(207, 216, 227, var(--border-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:border-cool-gray-400 {\n    --border-opacity: 1;\n    border-color: #97a6ba;\n    border-color: rgba(151, 166, 186, var(--border-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:border-cool-gray-500 {\n    --border-opacity: 1;\n    border-color: #64748b;\n    border-color: rgba(100, 116, 139, var(--border-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:border-cool-gray-600 {\n    --border-opacity: 1;\n    border-color: #475569;\n    border-color: rgba(71, 85, 105, var(--border-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:border-cool-gray-700 {\n    --border-opacity: 1;\n    border-color: #364152;\n    border-color: rgba(54, 65, 82, var(--border-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:border-cool-gray-800 {\n    --border-opacity: 1;\n    border-color: #27303f;\n    border-color: rgba(39, 48, 63, var(--border-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:border-cool-gray-900 {\n    --border-opacity: 1;\n    border-color: #1a202e;\n    border-color: rgba(26, 32, 46, var(--border-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:border-current {\n    border-color: currentColor;\n  }\n  .group:focus .sm\\:group-focus\\:border-transparent {\n    border-color: transparent;\n  }\n  .group:focus .sm\\:group-focus\\:border-white {\n    --border-opacity: 1;\n    border-color: #ffffff;\n    border-color: rgba(255, 255, 255, var(--border-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:border-black {\n    --border-opacity: 1;\n    border-color: #000000;\n    border-color: rgba(0, 0, 0, var(--border-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:border-gray-50 {\n    --border-opacity: 1;\n    border-color: #f9fafb;\n    border-color: rgba(249, 250, 251, var(--border-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:border-gray-100 {\n    --border-opacity: 1;\n    border-color: #f4f5f7;\n    border-color: rgba(244, 245, 247, var(--border-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:border-gray-200 {\n    --border-opacity: 1;\n    border-color: #e5e7eb;\n    border-color: rgba(229, 231, 235, var(--border-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:border-gray-300 {\n    --border-opacity: 1;\n    border-color: #d2d6dc;\n    border-color: rgba(210, 214, 220, var(--border-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:border-gray-400 {\n    --border-opacity: 1;\n    border-color: #9fa6b2;\n    border-color: rgba(159, 166, 178, var(--border-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:border-gray-500 {\n    --border-opacity: 1;\n    border-color: #6b7280;\n    border-color: rgba(107, 114, 128, var(--border-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:border-gray-600 {\n    --border-opacity: 1;\n    border-color: #4b5563;\n    border-color: rgba(75, 85, 99, var(--border-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:border-gray-700 {\n    --border-opacity: 1;\n    border-color: #374151;\n    border-color: rgba(55, 65, 81, var(--border-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:border-gray-800 {\n    --border-opacity: 1;\n    border-color: #252f3f;\n    border-color: rgba(37, 47, 63, var(--border-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:border-gray-900 {\n    --border-opacity: 1;\n    border-color: #161e2e;\n    border-color: rgba(22, 30, 46, var(--border-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:border-red-50 {\n    --border-opacity: 1;\n    border-color: #fdf2f2;\n    border-color: rgba(253, 242, 242, var(--border-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:border-red-100 {\n    --border-opacity: 1;\n    border-color: #fde8e8;\n    border-color: rgba(253, 232, 232, var(--border-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:border-red-200 {\n    --border-opacity: 1;\n    border-color: #fbd5d5;\n    border-color: rgba(251, 213, 213, var(--border-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:border-red-300 {\n    --border-opacity: 1;\n    border-color: #f8b4b4;\n    border-color: rgba(248, 180, 180, var(--border-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:border-red-400 {\n    --border-opacity: 1;\n    border-color: #f98080;\n    border-color: rgba(249, 128, 128, var(--border-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:border-red-500 {\n    --border-opacity: 1;\n    border-color: #f05252;\n    border-color: rgba(240, 82, 82, var(--border-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:border-red-600 {\n    --border-opacity: 1;\n    border-color: #e02424;\n    border-color: rgba(224, 36, 36, var(--border-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:border-red-700 {\n    --border-opacity: 1;\n    border-color: #c81e1e;\n    border-color: rgba(200, 30, 30, var(--border-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:border-red-800 {\n    --border-opacity: 1;\n    border-color: #9b1c1c;\n    border-color: rgba(155, 28, 28, var(--border-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:border-red-900 {\n    --border-opacity: 1;\n    border-color: #771d1d;\n    border-color: rgba(119, 29, 29, var(--border-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:border-orange-50 {\n    --border-opacity: 1;\n    border-color: #fff8f1;\n    border-color: rgba(255, 248, 241, var(--border-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:border-orange-100 {\n    --border-opacity: 1;\n    border-color: #feecdc;\n    border-color: rgba(254, 236, 220, var(--border-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:border-orange-200 {\n    --border-opacity: 1;\n    border-color: #fcd9bd;\n    border-color: rgba(252, 217, 189, var(--border-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:border-orange-300 {\n    --border-opacity: 1;\n    border-color: #fdba8c;\n    border-color: rgba(253, 186, 140, var(--border-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:border-orange-400 {\n    --border-opacity: 1;\n    border-color: #ff8a4c;\n    border-color: rgba(255, 138, 76, var(--border-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:border-orange-500 {\n    --border-opacity: 1;\n    border-color: #ff5a1f;\n    border-color: rgba(255, 90, 31, var(--border-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:border-orange-600 {\n    --border-opacity: 1;\n    border-color: #d03801;\n    border-color: rgba(208, 56, 1, var(--border-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:border-orange-700 {\n    --border-opacity: 1;\n    border-color: #b43403;\n    border-color: rgba(180, 52, 3, var(--border-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:border-orange-800 {\n    --border-opacity: 1;\n    border-color: #8a2c0d;\n    border-color: rgba(138, 44, 13, var(--border-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:border-orange-900 {\n    --border-opacity: 1;\n    border-color: #73230d;\n    border-color: rgba(115, 35, 13, var(--border-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:border-yellow-50 {\n    --border-opacity: 1;\n    border-color: #fdfdea;\n    border-color: rgba(253, 253, 234, var(--border-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:border-yellow-100 {\n    --border-opacity: 1;\n    border-color: #fdf6b2;\n    border-color: rgba(253, 246, 178, var(--border-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:border-yellow-200 {\n    --border-opacity: 1;\n    border-color: #fce96a;\n    border-color: rgba(252, 233, 106, var(--border-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:border-yellow-300 {\n    --border-opacity: 1;\n    border-color: #faca15;\n    border-color: rgba(250, 202, 21, var(--border-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:border-yellow-400 {\n    --border-opacity: 1;\n    border-color: #e3a008;\n    border-color: rgba(227, 160, 8, var(--border-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:border-yellow-500 {\n    --border-opacity: 1;\n    border-color: #c27803;\n    border-color: rgba(194, 120, 3, var(--border-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:border-yellow-600 {\n    --border-opacity: 1;\n    border-color: #9f580a;\n    border-color: rgba(159, 88, 10, var(--border-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:border-yellow-700 {\n    --border-opacity: 1;\n    border-color: #8e4b10;\n    border-color: rgba(142, 75, 16, var(--border-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:border-yellow-800 {\n    --border-opacity: 1;\n    border-color: #723b13;\n    border-color: rgba(114, 59, 19, var(--border-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:border-yellow-900 {\n    --border-opacity: 1;\n    border-color: #633112;\n    border-color: rgba(99, 49, 18, var(--border-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:border-green-50 {\n    --border-opacity: 1;\n    border-color: #f3faf7;\n    border-color: rgba(243, 250, 247, var(--border-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:border-green-100 {\n    --border-opacity: 1;\n    border-color: #def7ec;\n    border-color: rgba(222, 247, 236, var(--border-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:border-green-200 {\n    --border-opacity: 1;\n    border-color: #bcf0da;\n    border-color: rgba(188, 240, 218, var(--border-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:border-green-300 {\n    --border-opacity: 1;\n    border-color: #84e1bc;\n    border-color: rgba(132, 225, 188, var(--border-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:border-green-400 {\n    --border-opacity: 1;\n    border-color: #31c48d;\n    border-color: rgba(49, 196, 141, var(--border-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:border-green-500 {\n    --border-opacity: 1;\n    border-color: #0e9f6e;\n    border-color: rgba(14, 159, 110, var(--border-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:border-green-600 {\n    --border-opacity: 1;\n    border-color: #057a55;\n    border-color: rgba(5, 122, 85, var(--border-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:border-green-700 {\n    --border-opacity: 1;\n    border-color: #046c4e;\n    border-color: rgba(4, 108, 78, var(--border-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:border-green-800 {\n    --border-opacity: 1;\n    border-color: #03543f;\n    border-color: rgba(3, 84, 63, var(--border-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:border-green-900 {\n    --border-opacity: 1;\n    border-color: #014737;\n    border-color: rgba(1, 71, 55, var(--border-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:border-teal-50 {\n    --border-opacity: 1;\n    border-color: #edfafa;\n    border-color: rgba(237, 250, 250, var(--border-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:border-teal-100 {\n    --border-opacity: 1;\n    border-color: #d5f5f6;\n    border-color: rgba(213, 245, 246, var(--border-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:border-teal-200 {\n    --border-opacity: 1;\n    border-color: #afecef;\n    border-color: rgba(175, 236, 239, var(--border-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:border-teal-300 {\n    --border-opacity: 1;\n    border-color: #7edce2;\n    border-color: rgba(126, 220, 226, var(--border-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:border-teal-400 {\n    --border-opacity: 1;\n    border-color: #16bdca;\n    border-color: rgba(22, 189, 202, var(--border-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:border-teal-500 {\n    --border-opacity: 1;\n    border-color: #0694a2;\n    border-color: rgba(6, 148, 162, var(--border-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:border-teal-600 {\n    --border-opacity: 1;\n    border-color: #047481;\n    border-color: rgba(4, 116, 129, var(--border-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:border-teal-700 {\n    --border-opacity: 1;\n    border-color: #036672;\n    border-color: rgba(3, 102, 114, var(--border-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:border-teal-800 {\n    --border-opacity: 1;\n    border-color: #05505c;\n    border-color: rgba(5, 80, 92, var(--border-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:border-teal-900 {\n    --border-opacity: 1;\n    border-color: #014451;\n    border-color: rgba(1, 68, 81, var(--border-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:border-blue-50 {\n    --border-opacity: 1;\n    border-color: #ebf5ff;\n    border-color: rgba(235, 245, 255, var(--border-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:border-blue-100 {\n    --border-opacity: 1;\n    border-color: #e1effe;\n    border-color: rgba(225, 239, 254, var(--border-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:border-blue-200 {\n    --border-opacity: 1;\n    border-color: #c3ddfd;\n    border-color: rgba(195, 221, 253, var(--border-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:border-blue-300 {\n    --border-opacity: 1;\n    border-color: #a4cafe;\n    border-color: rgba(164, 202, 254, var(--border-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:border-blue-400 {\n    --border-opacity: 1;\n    border-color: #76a9fa;\n    border-color: rgba(118, 169, 250, var(--border-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:border-blue-500 {\n    --border-opacity: 1;\n    border-color: #3f83f8;\n    border-color: rgba(63, 131, 248, var(--border-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:border-blue-600 {\n    --border-opacity: 1;\n    border-color: #1c64f2;\n    border-color: rgba(28, 100, 242, var(--border-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:border-blue-700 {\n    --border-opacity: 1;\n    border-color: #1a56db;\n    border-color: rgba(26, 86, 219, var(--border-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:border-blue-800 {\n    --border-opacity: 1;\n    border-color: #1e429f;\n    border-color: rgba(30, 66, 159, var(--border-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:border-blue-900 {\n    --border-opacity: 1;\n    border-color: #233876;\n    border-color: rgba(35, 56, 118, var(--border-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:border-indigo-50 {\n    --border-opacity: 1;\n    border-color: #f0f5ff;\n    border-color: rgba(240, 245, 255, var(--border-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:border-indigo-100 {\n    --border-opacity: 1;\n    border-color: #e5edff;\n    border-color: rgba(229, 237, 255, var(--border-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:border-indigo-200 {\n    --border-opacity: 1;\n    border-color: #cddbfe;\n    border-color: rgba(205, 219, 254, var(--border-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:border-indigo-300 {\n    --border-opacity: 1;\n    border-color: #b4c6fc;\n    border-color: rgba(180, 198, 252, var(--border-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:border-indigo-400 {\n    --border-opacity: 1;\n    border-color: #8da2fb;\n    border-color: rgba(141, 162, 251, var(--border-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:border-indigo-500 {\n    --border-opacity: 1;\n    border-color: #6875f5;\n    border-color: rgba(104, 117, 245, var(--border-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:border-indigo-600 {\n    --border-opacity: 1;\n    border-color: #5850ec;\n    border-color: rgba(88, 80, 236, var(--border-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:border-indigo-700 {\n    --border-opacity: 1;\n    border-color: #5145cd;\n    border-color: rgba(81, 69, 205, var(--border-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:border-indigo-800 {\n    --border-opacity: 1;\n    border-color: #42389d;\n    border-color: rgba(66, 56, 157, var(--border-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:border-indigo-900 {\n    --border-opacity: 1;\n    border-color: #362f78;\n    border-color: rgba(54, 47, 120, var(--border-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:border-purple-50 {\n    --border-opacity: 1;\n    border-color: #f6f5ff;\n    border-color: rgba(246, 245, 255, var(--border-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:border-purple-100 {\n    --border-opacity: 1;\n    border-color: #edebfe;\n    border-color: rgba(237, 235, 254, var(--border-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:border-purple-200 {\n    --border-opacity: 1;\n    border-color: #dcd7fe;\n    border-color: rgba(220, 215, 254, var(--border-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:border-purple-300 {\n    --border-opacity: 1;\n    border-color: #cabffd;\n    border-color: rgba(202, 191, 253, var(--border-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:border-purple-400 {\n    --border-opacity: 1;\n    border-color: #ac94fa;\n    border-color: rgba(172, 148, 250, var(--border-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:border-purple-500 {\n    --border-opacity: 1;\n    border-color: #9061f9;\n    border-color: rgba(144, 97, 249, var(--border-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:border-purple-600 {\n    --border-opacity: 1;\n    border-color: #7e3af2;\n    border-color: rgba(126, 58, 242, var(--border-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:border-purple-700 {\n    --border-opacity: 1;\n    border-color: #6c2bd9;\n    border-color: rgba(108, 43, 217, var(--border-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:border-purple-800 {\n    --border-opacity: 1;\n    border-color: #5521b5;\n    border-color: rgba(85, 33, 181, var(--border-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:border-purple-900 {\n    --border-opacity: 1;\n    border-color: #4a1d96;\n    border-color: rgba(74, 29, 150, var(--border-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:border-pink-50 {\n    --border-opacity: 1;\n    border-color: #fdf2f8;\n    border-color: rgba(253, 242, 248, var(--border-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:border-pink-100 {\n    --border-opacity: 1;\n    border-color: #fce8f3;\n    border-color: rgba(252, 232, 243, var(--border-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:border-pink-200 {\n    --border-opacity: 1;\n    border-color: #fad1e8;\n    border-color: rgba(250, 209, 232, var(--border-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:border-pink-300 {\n    --border-opacity: 1;\n    border-color: #f8b4d9;\n    border-color: rgba(248, 180, 217, var(--border-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:border-pink-400 {\n    --border-opacity: 1;\n    border-color: #f17eb8;\n    border-color: rgba(241, 126, 184, var(--border-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:border-pink-500 {\n    --border-opacity: 1;\n    border-color: #e74694;\n    border-color: rgba(231, 70, 148, var(--border-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:border-pink-600 {\n    --border-opacity: 1;\n    border-color: #d61f69;\n    border-color: rgba(214, 31, 105, var(--border-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:border-pink-700 {\n    --border-opacity: 1;\n    border-color: #bf125d;\n    border-color: rgba(191, 18, 93, var(--border-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:border-pink-800 {\n    --border-opacity: 1;\n    border-color: #99154b;\n    border-color: rgba(153, 21, 75, var(--border-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:border-pink-900 {\n    --border-opacity: 1;\n    border-color: #751a3d;\n    border-color: rgba(117, 26, 61, var(--border-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:border-cool-gray-50 {\n    --border-opacity: 1;\n    border-color: #f8fafc;\n    border-color: rgba(248, 250, 252, var(--border-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:border-cool-gray-100 {\n    --border-opacity: 1;\n    border-color: #f1f5f9;\n    border-color: rgba(241, 245, 249, var(--border-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:border-cool-gray-200 {\n    --border-opacity: 1;\n    border-color: #e2e8f0;\n    border-color: rgba(226, 232, 240, var(--border-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:border-cool-gray-300 {\n    --border-opacity: 1;\n    border-color: #cfd8e3;\n    border-color: rgba(207, 216, 227, var(--border-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:border-cool-gray-400 {\n    --border-opacity: 1;\n    border-color: #97a6ba;\n    border-color: rgba(151, 166, 186, var(--border-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:border-cool-gray-500 {\n    --border-opacity: 1;\n    border-color: #64748b;\n    border-color: rgba(100, 116, 139, var(--border-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:border-cool-gray-600 {\n    --border-opacity: 1;\n    border-color: #475569;\n    border-color: rgba(71, 85, 105, var(--border-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:border-cool-gray-700 {\n    --border-opacity: 1;\n    border-color: #364152;\n    border-color: rgba(54, 65, 82, var(--border-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:border-cool-gray-800 {\n    --border-opacity: 1;\n    border-color: #27303f;\n    border-color: rgba(39, 48, 63, var(--border-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:border-cool-gray-900 {\n    --border-opacity: 1;\n    border-color: #1a202e;\n    border-color: rgba(26, 32, 46, var(--border-opacity));\n  }\n  .sm\\:hover\\:border-current:hover {\n    border-color: currentColor;\n  }\n  .sm\\:hover\\:border-transparent:hover {\n    border-color: transparent;\n  }\n  .sm\\:hover\\:border-white:hover {\n    --border-opacity: 1;\n    border-color: #ffffff;\n    border-color: rgba(255, 255, 255, var(--border-opacity));\n  }\n  .sm\\:hover\\:border-black:hover {\n    --border-opacity: 1;\n    border-color: #000000;\n    border-color: rgba(0, 0, 0, var(--border-opacity));\n  }\n  .sm\\:hover\\:border-gray-50:hover {\n    --border-opacity: 1;\n    border-color: #f9fafb;\n    border-color: rgba(249, 250, 251, var(--border-opacity));\n  }\n  .sm\\:hover\\:border-gray-100:hover {\n    --border-opacity: 1;\n    border-color: #f4f5f7;\n    border-color: rgba(244, 245, 247, var(--border-opacity));\n  }\n  .sm\\:hover\\:border-gray-200:hover {\n    --border-opacity: 1;\n    border-color: #e5e7eb;\n    border-color: rgba(229, 231, 235, var(--border-opacity));\n  }\n  .sm\\:hover\\:border-gray-300:hover {\n    --border-opacity: 1;\n    border-color: #d2d6dc;\n    border-color: rgba(210, 214, 220, var(--border-opacity));\n  }\n  .sm\\:hover\\:border-gray-400:hover {\n    --border-opacity: 1;\n    border-color: #9fa6b2;\n    border-color: rgba(159, 166, 178, var(--border-opacity));\n  }\n  .sm\\:hover\\:border-gray-500:hover {\n    --border-opacity: 1;\n    border-color: #6b7280;\n    border-color: rgba(107, 114, 128, var(--border-opacity));\n  }\n  .sm\\:hover\\:border-gray-600:hover {\n    --border-opacity: 1;\n    border-color: #4b5563;\n    border-color: rgba(75, 85, 99, var(--border-opacity));\n  }\n  .sm\\:hover\\:border-gray-700:hover {\n    --border-opacity: 1;\n    border-color: #374151;\n    border-color: rgba(55, 65, 81, var(--border-opacity));\n  }\n  .sm\\:hover\\:border-gray-800:hover {\n    --border-opacity: 1;\n    border-color: #252f3f;\n    border-color: rgba(37, 47, 63, var(--border-opacity));\n  }\n  .sm\\:hover\\:border-gray-900:hover {\n    --border-opacity: 1;\n    border-color: #161e2e;\n    border-color: rgba(22, 30, 46, var(--border-opacity));\n  }\n  .sm\\:hover\\:border-red-50:hover {\n    --border-opacity: 1;\n    border-color: #fdf2f2;\n    border-color: rgba(253, 242, 242, var(--border-opacity));\n  }\n  .sm\\:hover\\:border-red-100:hover {\n    --border-opacity: 1;\n    border-color: #fde8e8;\n    border-color: rgba(253, 232, 232, var(--border-opacity));\n  }\n  .sm\\:hover\\:border-red-200:hover {\n    --border-opacity: 1;\n    border-color: #fbd5d5;\n    border-color: rgba(251, 213, 213, var(--border-opacity));\n  }\n  .sm\\:hover\\:border-red-300:hover {\n    --border-opacity: 1;\n    border-color: #f8b4b4;\n    border-color: rgba(248, 180, 180, var(--border-opacity));\n  }\n  .sm\\:hover\\:border-red-400:hover {\n    --border-opacity: 1;\n    border-color: #f98080;\n    border-color: rgba(249, 128, 128, var(--border-opacity));\n  }\n  .sm\\:hover\\:border-red-500:hover {\n    --border-opacity: 1;\n    border-color: #f05252;\n    border-color: rgba(240, 82, 82, var(--border-opacity));\n  }\n  .sm\\:hover\\:border-red-600:hover {\n    --border-opacity: 1;\n    border-color: #e02424;\n    border-color: rgba(224, 36, 36, var(--border-opacity));\n  }\n  .sm\\:hover\\:border-red-700:hover {\n    --border-opacity: 1;\n    border-color: #c81e1e;\n    border-color: rgba(200, 30, 30, var(--border-opacity));\n  }\n  .sm\\:hover\\:border-red-800:hover {\n    --border-opacity: 1;\n    border-color: #9b1c1c;\n    border-color: rgba(155, 28, 28, var(--border-opacity));\n  }\n  .sm\\:hover\\:border-red-900:hover {\n    --border-opacity: 1;\n    border-color: #771d1d;\n    border-color: rgba(119, 29, 29, var(--border-opacity));\n  }\n  .sm\\:hover\\:border-orange-50:hover {\n    --border-opacity: 1;\n    border-color: #fff8f1;\n    border-color: rgba(255, 248, 241, var(--border-opacity));\n  }\n  .sm\\:hover\\:border-orange-100:hover {\n    --border-opacity: 1;\n    border-color: #feecdc;\n    border-color: rgba(254, 236, 220, var(--border-opacity));\n  }\n  .sm\\:hover\\:border-orange-200:hover {\n    --border-opacity: 1;\n    border-color: #fcd9bd;\n    border-color: rgba(252, 217, 189, var(--border-opacity));\n  }\n  .sm\\:hover\\:border-orange-300:hover {\n    --border-opacity: 1;\n    border-color: #fdba8c;\n    border-color: rgba(253, 186, 140, var(--border-opacity));\n  }\n  .sm\\:hover\\:border-orange-400:hover {\n    --border-opacity: 1;\n    border-color: #ff8a4c;\n    border-color: rgba(255, 138, 76, var(--border-opacity));\n  }\n  .sm\\:hover\\:border-orange-500:hover {\n    --border-opacity: 1;\n    border-color: #ff5a1f;\n    border-color: rgba(255, 90, 31, var(--border-opacity));\n  }\n  .sm\\:hover\\:border-orange-600:hover {\n    --border-opacity: 1;\n    border-color: #d03801;\n    border-color: rgba(208, 56, 1, var(--border-opacity));\n  }\n  .sm\\:hover\\:border-orange-700:hover {\n    --border-opacity: 1;\n    border-color: #b43403;\n    border-color: rgba(180, 52, 3, var(--border-opacity));\n  }\n  .sm\\:hover\\:border-orange-800:hover {\n    --border-opacity: 1;\n    border-color: #8a2c0d;\n    border-color: rgba(138, 44, 13, var(--border-opacity));\n  }\n  .sm\\:hover\\:border-orange-900:hover {\n    --border-opacity: 1;\n    border-color: #73230d;\n    border-color: rgba(115, 35, 13, var(--border-opacity));\n  }\n  .sm\\:hover\\:border-yellow-50:hover {\n    --border-opacity: 1;\n    border-color: #fdfdea;\n    border-color: rgba(253, 253, 234, var(--border-opacity));\n  }\n  .sm\\:hover\\:border-yellow-100:hover {\n    --border-opacity: 1;\n    border-color: #fdf6b2;\n    border-color: rgba(253, 246, 178, var(--border-opacity));\n  }\n  .sm\\:hover\\:border-yellow-200:hover {\n    --border-opacity: 1;\n    border-color: #fce96a;\n    border-color: rgba(252, 233, 106, var(--border-opacity));\n  }\n  .sm\\:hover\\:border-yellow-300:hover {\n    --border-opacity: 1;\n    border-color: #faca15;\n    border-color: rgba(250, 202, 21, var(--border-opacity));\n  }\n  .sm\\:hover\\:border-yellow-400:hover {\n    --border-opacity: 1;\n    border-color: #e3a008;\n    border-color: rgba(227, 160, 8, var(--border-opacity));\n  }\n  .sm\\:hover\\:border-yellow-500:hover {\n    --border-opacity: 1;\n    border-color: #c27803;\n    border-color: rgba(194, 120, 3, var(--border-opacity));\n  }\n  .sm\\:hover\\:border-yellow-600:hover {\n    --border-opacity: 1;\n    border-color: #9f580a;\n    border-color: rgba(159, 88, 10, var(--border-opacity));\n  }\n  .sm\\:hover\\:border-yellow-700:hover {\n    --border-opacity: 1;\n    border-color: #8e4b10;\n    border-color: rgba(142, 75, 16, var(--border-opacity));\n  }\n  .sm\\:hover\\:border-yellow-800:hover {\n    --border-opacity: 1;\n    border-color: #723b13;\n    border-color: rgba(114, 59, 19, var(--border-opacity));\n  }\n  .sm\\:hover\\:border-yellow-900:hover {\n    --border-opacity: 1;\n    border-color: #633112;\n    border-color: rgba(99, 49, 18, var(--border-opacity));\n  }\n  .sm\\:hover\\:border-green-50:hover {\n    --border-opacity: 1;\n    border-color: #f3faf7;\n    border-color: rgba(243, 250, 247, var(--border-opacity));\n  }\n  .sm\\:hover\\:border-green-100:hover {\n    --border-opacity: 1;\n    border-color: #def7ec;\n    border-color: rgba(222, 247, 236, var(--border-opacity));\n  }\n  .sm\\:hover\\:border-green-200:hover {\n    --border-opacity: 1;\n    border-color: #bcf0da;\n    border-color: rgba(188, 240, 218, var(--border-opacity));\n  }\n  .sm\\:hover\\:border-green-300:hover {\n    --border-opacity: 1;\n    border-color: #84e1bc;\n    border-color: rgba(132, 225, 188, var(--border-opacity));\n  }\n  .sm\\:hover\\:border-green-400:hover {\n    --border-opacity: 1;\n    border-color: #31c48d;\n    border-color: rgba(49, 196, 141, var(--border-opacity));\n  }\n  .sm\\:hover\\:border-green-500:hover {\n    --border-opacity: 1;\n    border-color: #0e9f6e;\n    border-color: rgba(14, 159, 110, var(--border-opacity));\n  }\n  .sm\\:hover\\:border-green-600:hover {\n    --border-opacity: 1;\n    border-color: #057a55;\n    border-color: rgba(5, 122, 85, var(--border-opacity));\n  }\n  .sm\\:hover\\:border-green-700:hover {\n    --border-opacity: 1;\n    border-color: #046c4e;\n    border-color: rgba(4, 108, 78, var(--border-opacity));\n  }\n  .sm\\:hover\\:border-green-800:hover {\n    --border-opacity: 1;\n    border-color: #03543f;\n    border-color: rgba(3, 84, 63, var(--border-opacity));\n  }\n  .sm\\:hover\\:border-green-900:hover {\n    --border-opacity: 1;\n    border-color: #014737;\n    border-color: rgba(1, 71, 55, var(--border-opacity));\n  }\n  .sm\\:hover\\:border-teal-50:hover {\n    --border-opacity: 1;\n    border-color: #edfafa;\n    border-color: rgba(237, 250, 250, var(--border-opacity));\n  }\n  .sm\\:hover\\:border-teal-100:hover {\n    --border-opacity: 1;\n    border-color: #d5f5f6;\n    border-color: rgba(213, 245, 246, var(--border-opacity));\n  }\n  .sm\\:hover\\:border-teal-200:hover {\n    --border-opacity: 1;\n    border-color: #afecef;\n    border-color: rgba(175, 236, 239, var(--border-opacity));\n  }\n  .sm\\:hover\\:border-teal-300:hover {\n    --border-opacity: 1;\n    border-color: #7edce2;\n    border-color: rgba(126, 220, 226, var(--border-opacity));\n  }\n  .sm\\:hover\\:border-teal-400:hover {\n    --border-opacity: 1;\n    border-color: #16bdca;\n    border-color: rgba(22, 189, 202, var(--border-opacity));\n  }\n  .sm\\:hover\\:border-teal-500:hover {\n    --border-opacity: 1;\n    border-color: #0694a2;\n    border-color: rgba(6, 148, 162, var(--border-opacity));\n  }\n  .sm\\:hover\\:border-teal-600:hover {\n    --border-opacity: 1;\n    border-color: #047481;\n    border-color: rgba(4, 116, 129, var(--border-opacity));\n  }\n  .sm\\:hover\\:border-teal-700:hover {\n    --border-opacity: 1;\n    border-color: #036672;\n    border-color: rgba(3, 102, 114, var(--border-opacity));\n  }\n  .sm\\:hover\\:border-teal-800:hover {\n    --border-opacity: 1;\n    border-color: #05505c;\n    border-color: rgba(5, 80, 92, var(--border-opacity));\n  }\n  .sm\\:hover\\:border-teal-900:hover {\n    --border-opacity: 1;\n    border-color: #014451;\n    border-color: rgba(1, 68, 81, var(--border-opacity));\n  }\n  .sm\\:hover\\:border-blue-50:hover {\n    --border-opacity: 1;\n    border-color: #ebf5ff;\n    border-color: rgba(235, 245, 255, var(--border-opacity));\n  }\n  .sm\\:hover\\:border-blue-100:hover {\n    --border-opacity: 1;\n    border-color: #e1effe;\n    border-color: rgba(225, 239, 254, var(--border-opacity));\n  }\n  .sm\\:hover\\:border-blue-200:hover {\n    --border-opacity: 1;\n    border-color: #c3ddfd;\n    border-color: rgba(195, 221, 253, var(--border-opacity));\n  }\n  .sm\\:hover\\:border-blue-300:hover {\n    --border-opacity: 1;\n    border-color: #a4cafe;\n    border-color: rgba(164, 202, 254, var(--border-opacity));\n  }\n  .sm\\:hover\\:border-blue-400:hover {\n    --border-opacity: 1;\n    border-color: #76a9fa;\n    border-color: rgba(118, 169, 250, var(--border-opacity));\n  }\n  .sm\\:hover\\:border-blue-500:hover {\n    --border-opacity: 1;\n    border-color: #3f83f8;\n    border-color: rgba(63, 131, 248, var(--border-opacity));\n  }\n  .sm\\:hover\\:border-blue-600:hover {\n    --border-opacity: 1;\n    border-color: #1c64f2;\n    border-color: rgba(28, 100, 242, var(--border-opacity));\n  }\n  .sm\\:hover\\:border-blue-700:hover {\n    --border-opacity: 1;\n    border-color: #1a56db;\n    border-color: rgba(26, 86, 219, var(--border-opacity));\n  }\n  .sm\\:hover\\:border-blue-800:hover {\n    --border-opacity: 1;\n    border-color: #1e429f;\n    border-color: rgba(30, 66, 159, var(--border-opacity));\n  }\n  .sm\\:hover\\:border-blue-900:hover {\n    --border-opacity: 1;\n    border-color: #233876;\n    border-color: rgba(35, 56, 118, var(--border-opacity));\n  }\n  .sm\\:hover\\:border-indigo-50:hover {\n    --border-opacity: 1;\n    border-color: #f0f5ff;\n    border-color: rgba(240, 245, 255, var(--border-opacity));\n  }\n  .sm\\:hover\\:border-indigo-100:hover {\n    --border-opacity: 1;\n    border-color: #e5edff;\n    border-color: rgba(229, 237, 255, var(--border-opacity));\n  }\n  .sm\\:hover\\:border-indigo-200:hover {\n    --border-opacity: 1;\n    border-color: #cddbfe;\n    border-color: rgba(205, 219, 254, var(--border-opacity));\n  }\n  .sm\\:hover\\:border-indigo-300:hover {\n    --border-opacity: 1;\n    border-color: #b4c6fc;\n    border-color: rgba(180, 198, 252, var(--border-opacity));\n  }\n  .sm\\:hover\\:border-indigo-400:hover {\n    --border-opacity: 1;\n    border-color: #8da2fb;\n    border-color: rgba(141, 162, 251, var(--border-opacity));\n  }\n  .sm\\:hover\\:border-indigo-500:hover {\n    --border-opacity: 1;\n    border-color: #6875f5;\n    border-color: rgba(104, 117, 245, var(--border-opacity));\n  }\n  .sm\\:hover\\:border-indigo-600:hover {\n    --border-opacity: 1;\n    border-color: #5850ec;\n    border-color: rgba(88, 80, 236, var(--border-opacity));\n  }\n  .sm\\:hover\\:border-indigo-700:hover {\n    --border-opacity: 1;\n    border-color: #5145cd;\n    border-color: rgba(81, 69, 205, var(--border-opacity));\n  }\n  .sm\\:hover\\:border-indigo-800:hover {\n    --border-opacity: 1;\n    border-color: #42389d;\n    border-color: rgba(66, 56, 157, var(--border-opacity));\n  }\n  .sm\\:hover\\:border-indigo-900:hover {\n    --border-opacity: 1;\n    border-color: #362f78;\n    border-color: rgba(54, 47, 120, var(--border-opacity));\n  }\n  .sm\\:hover\\:border-purple-50:hover {\n    --border-opacity: 1;\n    border-color: #f6f5ff;\n    border-color: rgba(246, 245, 255, var(--border-opacity));\n  }\n  .sm\\:hover\\:border-purple-100:hover {\n    --border-opacity: 1;\n    border-color: #edebfe;\n    border-color: rgba(237, 235, 254, var(--border-opacity));\n  }\n  .sm\\:hover\\:border-purple-200:hover {\n    --border-opacity: 1;\n    border-color: #dcd7fe;\n    border-color: rgba(220, 215, 254, var(--border-opacity));\n  }\n  .sm\\:hover\\:border-purple-300:hover {\n    --border-opacity: 1;\n    border-color: #cabffd;\n    border-color: rgba(202, 191, 253, var(--border-opacity));\n  }\n  .sm\\:hover\\:border-purple-400:hover {\n    --border-opacity: 1;\n    border-color: #ac94fa;\n    border-color: rgba(172, 148, 250, var(--border-opacity));\n  }\n  .sm\\:hover\\:border-purple-500:hover {\n    --border-opacity: 1;\n    border-color: #9061f9;\n    border-color: rgba(144, 97, 249, var(--border-opacity));\n  }\n  .sm\\:hover\\:border-purple-600:hover {\n    --border-opacity: 1;\n    border-color: #7e3af2;\n    border-color: rgba(126, 58, 242, var(--border-opacity));\n  }\n  .sm\\:hover\\:border-purple-700:hover {\n    --border-opacity: 1;\n    border-color: #6c2bd9;\n    border-color: rgba(108, 43, 217, var(--border-opacity));\n  }\n  .sm\\:hover\\:border-purple-800:hover {\n    --border-opacity: 1;\n    border-color: #5521b5;\n    border-color: rgba(85, 33, 181, var(--border-opacity));\n  }\n  .sm\\:hover\\:border-purple-900:hover {\n    --border-opacity: 1;\n    border-color: #4a1d96;\n    border-color: rgba(74, 29, 150, var(--border-opacity));\n  }\n  .sm\\:hover\\:border-pink-50:hover {\n    --border-opacity: 1;\n    border-color: #fdf2f8;\n    border-color: rgba(253, 242, 248, var(--border-opacity));\n  }\n  .sm\\:hover\\:border-pink-100:hover {\n    --border-opacity: 1;\n    border-color: #fce8f3;\n    border-color: rgba(252, 232, 243, var(--border-opacity));\n  }\n  .sm\\:hover\\:border-pink-200:hover {\n    --border-opacity: 1;\n    border-color: #fad1e8;\n    border-color: rgba(250, 209, 232, var(--border-opacity));\n  }\n  .sm\\:hover\\:border-pink-300:hover {\n    --border-opacity: 1;\n    border-color: #f8b4d9;\n    border-color: rgba(248, 180, 217, var(--border-opacity));\n  }\n  .sm\\:hover\\:border-pink-400:hover {\n    --border-opacity: 1;\n    border-color: #f17eb8;\n    border-color: rgba(241, 126, 184, var(--border-opacity));\n  }\n  .sm\\:hover\\:border-pink-500:hover {\n    --border-opacity: 1;\n    border-color: #e74694;\n    border-color: rgba(231, 70, 148, var(--border-opacity));\n  }\n  .sm\\:hover\\:border-pink-600:hover {\n    --border-opacity: 1;\n    border-color: #d61f69;\n    border-color: rgba(214, 31, 105, var(--border-opacity));\n  }\n  .sm\\:hover\\:border-pink-700:hover {\n    --border-opacity: 1;\n    border-color: #bf125d;\n    border-color: rgba(191, 18, 93, var(--border-opacity));\n  }\n  .sm\\:hover\\:border-pink-800:hover {\n    --border-opacity: 1;\n    border-color: #99154b;\n    border-color: rgba(153, 21, 75, var(--border-opacity));\n  }\n  .sm\\:hover\\:border-pink-900:hover {\n    --border-opacity: 1;\n    border-color: #751a3d;\n    border-color: rgba(117, 26, 61, var(--border-opacity));\n  }\n  .sm\\:hover\\:border-cool-gray-50:hover {\n    --border-opacity: 1;\n    border-color: #f8fafc;\n    border-color: rgba(248, 250, 252, var(--border-opacity));\n  }\n  .sm\\:hover\\:border-cool-gray-100:hover {\n    --border-opacity: 1;\n    border-color: #f1f5f9;\n    border-color: rgba(241, 245, 249, var(--border-opacity));\n  }\n  .sm\\:hover\\:border-cool-gray-200:hover {\n    --border-opacity: 1;\n    border-color: #e2e8f0;\n    border-color: rgba(226, 232, 240, var(--border-opacity));\n  }\n  .sm\\:hover\\:border-cool-gray-300:hover {\n    --border-opacity: 1;\n    border-color: #cfd8e3;\n    border-color: rgba(207, 216, 227, var(--border-opacity));\n  }\n  .sm\\:hover\\:border-cool-gray-400:hover {\n    --border-opacity: 1;\n    border-color: #97a6ba;\n    border-color: rgba(151, 166, 186, var(--border-opacity));\n  }\n  .sm\\:hover\\:border-cool-gray-500:hover {\n    --border-opacity: 1;\n    border-color: #64748b;\n    border-color: rgba(100, 116, 139, var(--border-opacity));\n  }\n  .sm\\:hover\\:border-cool-gray-600:hover {\n    --border-opacity: 1;\n    border-color: #475569;\n    border-color: rgba(71, 85, 105, var(--border-opacity));\n  }\n  .sm\\:hover\\:border-cool-gray-700:hover {\n    --border-opacity: 1;\n    border-color: #364152;\n    border-color: rgba(54, 65, 82, var(--border-opacity));\n  }\n  .sm\\:hover\\:border-cool-gray-800:hover {\n    --border-opacity: 1;\n    border-color: #27303f;\n    border-color: rgba(39, 48, 63, var(--border-opacity));\n  }\n  .sm\\:hover\\:border-cool-gray-900:hover {\n    --border-opacity: 1;\n    border-color: #1a202e;\n    border-color: rgba(26, 32, 46, var(--border-opacity));\n  }\n  .sm\\:focus-within\\:border-current:focus-within {\n    border-color: currentColor;\n  }\n  .sm\\:focus-within\\:border-transparent:focus-within {\n    border-color: transparent;\n  }\n  .sm\\:focus-within\\:border-white:focus-within {\n    --border-opacity: 1;\n    border-color: #ffffff;\n    border-color: rgba(255, 255, 255, var(--border-opacity));\n  }\n  .sm\\:focus-within\\:border-black:focus-within {\n    --border-opacity: 1;\n    border-color: #000000;\n    border-color: rgba(0, 0, 0, var(--border-opacity));\n  }\n  .sm\\:focus-within\\:border-gray-50:focus-within {\n    --border-opacity: 1;\n    border-color: #f9fafb;\n    border-color: rgba(249, 250, 251, var(--border-opacity));\n  }\n  .sm\\:focus-within\\:border-gray-100:focus-within {\n    --border-opacity: 1;\n    border-color: #f4f5f7;\n    border-color: rgba(244, 245, 247, var(--border-opacity));\n  }\n  .sm\\:focus-within\\:border-gray-200:focus-within {\n    --border-opacity: 1;\n    border-color: #e5e7eb;\n    border-color: rgba(229, 231, 235, var(--border-opacity));\n  }\n  .sm\\:focus-within\\:border-gray-300:focus-within {\n    --border-opacity: 1;\n    border-color: #d2d6dc;\n    border-color: rgba(210, 214, 220, var(--border-opacity));\n  }\n  .sm\\:focus-within\\:border-gray-400:focus-within {\n    --border-opacity: 1;\n    border-color: #9fa6b2;\n    border-color: rgba(159, 166, 178, var(--border-opacity));\n  }\n  .sm\\:focus-within\\:border-gray-500:focus-within {\n    --border-opacity: 1;\n    border-color: #6b7280;\n    border-color: rgba(107, 114, 128, var(--border-opacity));\n  }\n  .sm\\:focus-within\\:border-gray-600:focus-within {\n    --border-opacity: 1;\n    border-color: #4b5563;\n    border-color: rgba(75, 85, 99, var(--border-opacity));\n  }\n  .sm\\:focus-within\\:border-gray-700:focus-within {\n    --border-opacity: 1;\n    border-color: #374151;\n    border-color: rgba(55, 65, 81, var(--border-opacity));\n  }\n  .sm\\:focus-within\\:border-gray-800:focus-within {\n    --border-opacity: 1;\n    border-color: #252f3f;\n    border-color: rgba(37, 47, 63, var(--border-opacity));\n  }\n  .sm\\:focus-within\\:border-gray-900:focus-within {\n    --border-opacity: 1;\n    border-color: #161e2e;\n    border-color: rgba(22, 30, 46, var(--border-opacity));\n  }\n  .sm\\:focus-within\\:border-red-50:focus-within {\n    --border-opacity: 1;\n    border-color: #fdf2f2;\n    border-color: rgba(253, 242, 242, var(--border-opacity));\n  }\n  .sm\\:focus-within\\:border-red-100:focus-within {\n    --border-opacity: 1;\n    border-color: #fde8e8;\n    border-color: rgba(253, 232, 232, var(--border-opacity));\n  }\n  .sm\\:focus-within\\:border-red-200:focus-within {\n    --border-opacity: 1;\n    border-color: #fbd5d5;\n    border-color: rgba(251, 213, 213, var(--border-opacity));\n  }\n  .sm\\:focus-within\\:border-red-300:focus-within {\n    --border-opacity: 1;\n    border-color: #f8b4b4;\n    border-color: rgba(248, 180, 180, var(--border-opacity));\n  }\n  .sm\\:focus-within\\:border-red-400:focus-within {\n    --border-opacity: 1;\n    border-color: #f98080;\n    border-color: rgba(249, 128, 128, var(--border-opacity));\n  }\n  .sm\\:focus-within\\:border-red-500:focus-within {\n    --border-opacity: 1;\n    border-color: #f05252;\n    border-color: rgba(240, 82, 82, var(--border-opacity));\n  }\n  .sm\\:focus-within\\:border-red-600:focus-within {\n    --border-opacity: 1;\n    border-color: #e02424;\n    border-color: rgba(224, 36, 36, var(--border-opacity));\n  }\n  .sm\\:focus-within\\:border-red-700:focus-within {\n    --border-opacity: 1;\n    border-color: #c81e1e;\n    border-color: rgba(200, 30, 30, var(--border-opacity));\n  }\n  .sm\\:focus-within\\:border-red-800:focus-within {\n    --border-opacity: 1;\n    border-color: #9b1c1c;\n    border-color: rgba(155, 28, 28, var(--border-opacity));\n  }\n  .sm\\:focus-within\\:border-red-900:focus-within {\n    --border-opacity: 1;\n    border-color: #771d1d;\n    border-color: rgba(119, 29, 29, var(--border-opacity));\n  }\n  .sm\\:focus-within\\:border-orange-50:focus-within {\n    --border-opacity: 1;\n    border-color: #fff8f1;\n    border-color: rgba(255, 248, 241, var(--border-opacity));\n  }\n  .sm\\:focus-within\\:border-orange-100:focus-within {\n    --border-opacity: 1;\n    border-color: #feecdc;\n    border-color: rgba(254, 236, 220, var(--border-opacity));\n  }\n  .sm\\:focus-within\\:border-orange-200:focus-within {\n    --border-opacity: 1;\n    border-color: #fcd9bd;\n    border-color: rgba(252, 217, 189, var(--border-opacity));\n  }\n  .sm\\:focus-within\\:border-orange-300:focus-within {\n    --border-opacity: 1;\n    border-color: #fdba8c;\n    border-color: rgba(253, 186, 140, var(--border-opacity));\n  }\n  .sm\\:focus-within\\:border-orange-400:focus-within {\n    --border-opacity: 1;\n    border-color: #ff8a4c;\n    border-color: rgba(255, 138, 76, var(--border-opacity));\n  }\n  .sm\\:focus-within\\:border-orange-500:focus-within {\n    --border-opacity: 1;\n    border-color: #ff5a1f;\n    border-color: rgba(255, 90, 31, var(--border-opacity));\n  }\n  .sm\\:focus-within\\:border-orange-600:focus-within {\n    --border-opacity: 1;\n    border-color: #d03801;\n    border-color: rgba(208, 56, 1, var(--border-opacity));\n  }\n  .sm\\:focus-within\\:border-orange-700:focus-within {\n    --border-opacity: 1;\n    border-color: #b43403;\n    border-color: rgba(180, 52, 3, var(--border-opacity));\n  }\n  .sm\\:focus-within\\:border-orange-800:focus-within {\n    --border-opacity: 1;\n    border-color: #8a2c0d;\n    border-color: rgba(138, 44, 13, var(--border-opacity));\n  }\n  .sm\\:focus-within\\:border-orange-900:focus-within {\n    --border-opacity: 1;\n    border-color: #73230d;\n    border-color: rgba(115, 35, 13, var(--border-opacity));\n  }\n  .sm\\:focus-within\\:border-yellow-50:focus-within {\n    --border-opacity: 1;\n    border-color: #fdfdea;\n    border-color: rgba(253, 253, 234, var(--border-opacity));\n  }\n  .sm\\:focus-within\\:border-yellow-100:focus-within {\n    --border-opacity: 1;\n    border-color: #fdf6b2;\n    border-color: rgba(253, 246, 178, var(--border-opacity));\n  }\n  .sm\\:focus-within\\:border-yellow-200:focus-within {\n    --border-opacity: 1;\n    border-color: #fce96a;\n    border-color: rgba(252, 233, 106, var(--border-opacity));\n  }\n  .sm\\:focus-within\\:border-yellow-300:focus-within {\n    --border-opacity: 1;\n    border-color: #faca15;\n    border-color: rgba(250, 202, 21, var(--border-opacity));\n  }\n  .sm\\:focus-within\\:border-yellow-400:focus-within {\n    --border-opacity: 1;\n    border-color: #e3a008;\n    border-color: rgba(227, 160, 8, var(--border-opacity));\n  }\n  .sm\\:focus-within\\:border-yellow-500:focus-within {\n    --border-opacity: 1;\n    border-color: #c27803;\n    border-color: rgba(194, 120, 3, var(--border-opacity));\n  }\n  .sm\\:focus-within\\:border-yellow-600:focus-within {\n    --border-opacity: 1;\n    border-color: #9f580a;\n    border-color: rgba(159, 88, 10, var(--border-opacity));\n  }\n  .sm\\:focus-within\\:border-yellow-700:focus-within {\n    --border-opacity: 1;\n    border-color: #8e4b10;\n    border-color: rgba(142, 75, 16, var(--border-opacity));\n  }\n  .sm\\:focus-within\\:border-yellow-800:focus-within {\n    --border-opacity: 1;\n    border-color: #723b13;\n    border-color: rgba(114, 59, 19, var(--border-opacity));\n  }\n  .sm\\:focus-within\\:border-yellow-900:focus-within {\n    --border-opacity: 1;\n    border-color: #633112;\n    border-color: rgba(99, 49, 18, var(--border-opacity));\n  }\n  .sm\\:focus-within\\:border-green-50:focus-within {\n    --border-opacity: 1;\n    border-color: #f3faf7;\n    border-color: rgba(243, 250, 247, var(--border-opacity));\n  }\n  .sm\\:focus-within\\:border-green-100:focus-within {\n    --border-opacity: 1;\n    border-color: #def7ec;\n    border-color: rgba(222, 247, 236, var(--border-opacity));\n  }\n  .sm\\:focus-within\\:border-green-200:focus-within {\n    --border-opacity: 1;\n    border-color: #bcf0da;\n    border-color: rgba(188, 240, 218, var(--border-opacity));\n  }\n  .sm\\:focus-within\\:border-green-300:focus-within {\n    --border-opacity: 1;\n    border-color: #84e1bc;\n    border-color: rgba(132, 225, 188, var(--border-opacity));\n  }\n  .sm\\:focus-within\\:border-green-400:focus-within {\n    --border-opacity: 1;\n    border-color: #31c48d;\n    border-color: rgba(49, 196, 141, var(--border-opacity));\n  }\n  .sm\\:focus-within\\:border-green-500:focus-within {\n    --border-opacity: 1;\n    border-color: #0e9f6e;\n    border-color: rgba(14, 159, 110, var(--border-opacity));\n  }\n  .sm\\:focus-within\\:border-green-600:focus-within {\n    --border-opacity: 1;\n    border-color: #057a55;\n    border-color: rgba(5, 122, 85, var(--border-opacity));\n  }\n  .sm\\:focus-within\\:border-green-700:focus-within {\n    --border-opacity: 1;\n    border-color: #046c4e;\n    border-color: rgba(4, 108, 78, var(--border-opacity));\n  }\n  .sm\\:focus-within\\:border-green-800:focus-within {\n    --border-opacity: 1;\n    border-color: #03543f;\n    border-color: rgba(3, 84, 63, var(--border-opacity));\n  }\n  .sm\\:focus-within\\:border-green-900:focus-within {\n    --border-opacity: 1;\n    border-color: #014737;\n    border-color: rgba(1, 71, 55, var(--border-opacity));\n  }\n  .sm\\:focus-within\\:border-teal-50:focus-within {\n    --border-opacity: 1;\n    border-color: #edfafa;\n    border-color: rgba(237, 250, 250, var(--border-opacity));\n  }\n  .sm\\:focus-within\\:border-teal-100:focus-within {\n    --border-opacity: 1;\n    border-color: #d5f5f6;\n    border-color: rgba(213, 245, 246, var(--border-opacity));\n  }\n  .sm\\:focus-within\\:border-teal-200:focus-within {\n    --border-opacity: 1;\n    border-color: #afecef;\n    border-color: rgba(175, 236, 239, var(--border-opacity));\n  }\n  .sm\\:focus-within\\:border-teal-300:focus-within {\n    --border-opacity: 1;\n    border-color: #7edce2;\n    border-color: rgba(126, 220, 226, var(--border-opacity));\n  }\n  .sm\\:focus-within\\:border-teal-400:focus-within {\n    --border-opacity: 1;\n    border-color: #16bdca;\n    border-color: rgba(22, 189, 202, var(--border-opacity));\n  }\n  .sm\\:focus-within\\:border-teal-500:focus-within {\n    --border-opacity: 1;\n    border-color: #0694a2;\n    border-color: rgba(6, 148, 162, var(--border-opacity));\n  }\n  .sm\\:focus-within\\:border-teal-600:focus-within {\n    --border-opacity: 1;\n    border-color: #047481;\n    border-color: rgba(4, 116, 129, var(--border-opacity));\n  }\n  .sm\\:focus-within\\:border-teal-700:focus-within {\n    --border-opacity: 1;\n    border-color: #036672;\n    border-color: rgba(3, 102, 114, var(--border-opacity));\n  }\n  .sm\\:focus-within\\:border-teal-800:focus-within {\n    --border-opacity: 1;\n    border-color: #05505c;\n    border-color: rgba(5, 80, 92, var(--border-opacity));\n  }\n  .sm\\:focus-within\\:border-teal-900:focus-within {\n    --border-opacity: 1;\n    border-color: #014451;\n    border-color: rgba(1, 68, 81, var(--border-opacity));\n  }\n  .sm\\:focus-within\\:border-blue-50:focus-within {\n    --border-opacity: 1;\n    border-color: #ebf5ff;\n    border-color: rgba(235, 245, 255, var(--border-opacity));\n  }\n  .sm\\:focus-within\\:border-blue-100:focus-within {\n    --border-opacity: 1;\n    border-color: #e1effe;\n    border-color: rgba(225, 239, 254, var(--border-opacity));\n  }\n  .sm\\:focus-within\\:border-blue-200:focus-within {\n    --border-opacity: 1;\n    border-color: #c3ddfd;\n    border-color: rgba(195, 221, 253, var(--border-opacity));\n  }\n  .sm\\:focus-within\\:border-blue-300:focus-within {\n    --border-opacity: 1;\n    border-color: #a4cafe;\n    border-color: rgba(164, 202, 254, var(--border-opacity));\n  }\n  .sm\\:focus-within\\:border-blue-400:focus-within {\n    --border-opacity: 1;\n    border-color: #76a9fa;\n    border-color: rgba(118, 169, 250, var(--border-opacity));\n  }\n  .sm\\:focus-within\\:border-blue-500:focus-within {\n    --border-opacity: 1;\n    border-color: #3f83f8;\n    border-color: rgba(63, 131, 248, var(--border-opacity));\n  }\n  .sm\\:focus-within\\:border-blue-600:focus-within {\n    --border-opacity: 1;\n    border-color: #1c64f2;\n    border-color: rgba(28, 100, 242, var(--border-opacity));\n  }\n  .sm\\:focus-within\\:border-blue-700:focus-within {\n    --border-opacity: 1;\n    border-color: #1a56db;\n    border-color: rgba(26, 86, 219, var(--border-opacity));\n  }\n  .sm\\:focus-within\\:border-blue-800:focus-within {\n    --border-opacity: 1;\n    border-color: #1e429f;\n    border-color: rgba(30, 66, 159, var(--border-opacity));\n  }\n  .sm\\:focus-within\\:border-blue-900:focus-within {\n    --border-opacity: 1;\n    border-color: #233876;\n    border-color: rgba(35, 56, 118, var(--border-opacity));\n  }\n  .sm\\:focus-within\\:border-indigo-50:focus-within {\n    --border-opacity: 1;\n    border-color: #f0f5ff;\n    border-color: rgba(240, 245, 255, var(--border-opacity));\n  }\n  .sm\\:focus-within\\:border-indigo-100:focus-within {\n    --border-opacity: 1;\n    border-color: #e5edff;\n    border-color: rgba(229, 237, 255, var(--border-opacity));\n  }\n  .sm\\:focus-within\\:border-indigo-200:focus-within {\n    --border-opacity: 1;\n    border-color: #cddbfe;\n    border-color: rgba(205, 219, 254, var(--border-opacity));\n  }\n  .sm\\:focus-within\\:border-indigo-300:focus-within {\n    --border-opacity: 1;\n    border-color: #b4c6fc;\n    border-color: rgba(180, 198, 252, var(--border-opacity));\n  }\n  .sm\\:focus-within\\:border-indigo-400:focus-within {\n    --border-opacity: 1;\n    border-color: #8da2fb;\n    border-color: rgba(141, 162, 251, var(--border-opacity));\n  }\n  .sm\\:focus-within\\:border-indigo-500:focus-within {\n    --border-opacity: 1;\n    border-color: #6875f5;\n    border-color: rgba(104, 117, 245, var(--border-opacity));\n  }\n  .sm\\:focus-within\\:border-indigo-600:focus-within {\n    --border-opacity: 1;\n    border-color: #5850ec;\n    border-color: rgba(88, 80, 236, var(--border-opacity));\n  }\n  .sm\\:focus-within\\:border-indigo-700:focus-within {\n    --border-opacity: 1;\n    border-color: #5145cd;\n    border-color: rgba(81, 69, 205, var(--border-opacity));\n  }\n  .sm\\:focus-within\\:border-indigo-800:focus-within {\n    --border-opacity: 1;\n    border-color: #42389d;\n    border-color: rgba(66, 56, 157, var(--border-opacity));\n  }\n  .sm\\:focus-within\\:border-indigo-900:focus-within {\n    --border-opacity: 1;\n    border-color: #362f78;\n    border-color: rgba(54, 47, 120, var(--border-opacity));\n  }\n  .sm\\:focus-within\\:border-purple-50:focus-within {\n    --border-opacity: 1;\n    border-color: #f6f5ff;\n    border-color: rgba(246, 245, 255, var(--border-opacity));\n  }\n  .sm\\:focus-within\\:border-purple-100:focus-within {\n    --border-opacity: 1;\n    border-color: #edebfe;\n    border-color: rgba(237, 235, 254, var(--border-opacity));\n  }\n  .sm\\:focus-within\\:border-purple-200:focus-within {\n    --border-opacity: 1;\n    border-color: #dcd7fe;\n    border-color: rgba(220, 215, 254, var(--border-opacity));\n  }\n  .sm\\:focus-within\\:border-purple-300:focus-within {\n    --border-opacity: 1;\n    border-color: #cabffd;\n    border-color: rgba(202, 191, 253, var(--border-opacity));\n  }\n  .sm\\:focus-within\\:border-purple-400:focus-within {\n    --border-opacity: 1;\n    border-color: #ac94fa;\n    border-color: rgba(172, 148, 250, var(--border-opacity));\n  }\n  .sm\\:focus-within\\:border-purple-500:focus-within {\n    --border-opacity: 1;\n    border-color: #9061f9;\n    border-color: rgba(144, 97, 249, var(--border-opacity));\n  }\n  .sm\\:focus-within\\:border-purple-600:focus-within {\n    --border-opacity: 1;\n    border-color: #7e3af2;\n    border-color: rgba(126, 58, 242, var(--border-opacity));\n  }\n  .sm\\:focus-within\\:border-purple-700:focus-within {\n    --border-opacity: 1;\n    border-color: #6c2bd9;\n    border-color: rgba(108, 43, 217, var(--border-opacity));\n  }\n  .sm\\:focus-within\\:border-purple-800:focus-within {\n    --border-opacity: 1;\n    border-color: #5521b5;\n    border-color: rgba(85, 33, 181, var(--border-opacity));\n  }\n  .sm\\:focus-within\\:border-purple-900:focus-within {\n    --border-opacity: 1;\n    border-color: #4a1d96;\n    border-color: rgba(74, 29, 150, var(--border-opacity));\n  }\n  .sm\\:focus-within\\:border-pink-50:focus-within {\n    --border-opacity: 1;\n    border-color: #fdf2f8;\n    border-color: rgba(253, 242, 248, var(--border-opacity));\n  }\n  .sm\\:focus-within\\:border-pink-100:focus-within {\n    --border-opacity: 1;\n    border-color: #fce8f3;\n    border-color: rgba(252, 232, 243, var(--border-opacity));\n  }\n  .sm\\:focus-within\\:border-pink-200:focus-within {\n    --border-opacity: 1;\n    border-color: #fad1e8;\n    border-color: rgba(250, 209, 232, var(--border-opacity));\n  }\n  .sm\\:focus-within\\:border-pink-300:focus-within {\n    --border-opacity: 1;\n    border-color: #f8b4d9;\n    border-color: rgba(248, 180, 217, var(--border-opacity));\n  }\n  .sm\\:focus-within\\:border-pink-400:focus-within {\n    --border-opacity: 1;\n    border-color: #f17eb8;\n    border-color: rgba(241, 126, 184, var(--border-opacity));\n  }\n  .sm\\:focus-within\\:border-pink-500:focus-within {\n    --border-opacity: 1;\n    border-color: #e74694;\n    border-color: rgba(231, 70, 148, var(--border-opacity));\n  }\n  .sm\\:focus-within\\:border-pink-600:focus-within {\n    --border-opacity: 1;\n    border-color: #d61f69;\n    border-color: rgba(214, 31, 105, var(--border-opacity));\n  }\n  .sm\\:focus-within\\:border-pink-700:focus-within {\n    --border-opacity: 1;\n    border-color: #bf125d;\n    border-color: rgba(191, 18, 93, var(--border-opacity));\n  }\n  .sm\\:focus-within\\:border-pink-800:focus-within {\n    --border-opacity: 1;\n    border-color: #99154b;\n    border-color: rgba(153, 21, 75, var(--border-opacity));\n  }\n  .sm\\:focus-within\\:border-pink-900:focus-within {\n    --border-opacity: 1;\n    border-color: #751a3d;\n    border-color: rgba(117, 26, 61, var(--border-opacity));\n  }\n  .sm\\:focus-within\\:border-cool-gray-50:focus-within {\n    --border-opacity: 1;\n    border-color: #f8fafc;\n    border-color: rgba(248, 250, 252, var(--border-opacity));\n  }\n  .sm\\:focus-within\\:border-cool-gray-100:focus-within {\n    --border-opacity: 1;\n    border-color: #f1f5f9;\n    border-color: rgba(241, 245, 249, var(--border-opacity));\n  }\n  .sm\\:focus-within\\:border-cool-gray-200:focus-within {\n    --border-opacity: 1;\n    border-color: #e2e8f0;\n    border-color: rgba(226, 232, 240, var(--border-opacity));\n  }\n  .sm\\:focus-within\\:border-cool-gray-300:focus-within {\n    --border-opacity: 1;\n    border-color: #cfd8e3;\n    border-color: rgba(207, 216, 227, var(--border-opacity));\n  }\n  .sm\\:focus-within\\:border-cool-gray-400:focus-within {\n    --border-opacity: 1;\n    border-color: #97a6ba;\n    border-color: rgba(151, 166, 186, var(--border-opacity));\n  }\n  .sm\\:focus-within\\:border-cool-gray-500:focus-within {\n    --border-opacity: 1;\n    border-color: #64748b;\n    border-color: rgba(100, 116, 139, var(--border-opacity));\n  }\n  .sm\\:focus-within\\:border-cool-gray-600:focus-within {\n    --border-opacity: 1;\n    border-color: #475569;\n    border-color: rgba(71, 85, 105, var(--border-opacity));\n  }\n  .sm\\:focus-within\\:border-cool-gray-700:focus-within {\n    --border-opacity: 1;\n    border-color: #364152;\n    border-color: rgba(54, 65, 82, var(--border-opacity));\n  }\n  .sm\\:focus-within\\:border-cool-gray-800:focus-within {\n    --border-opacity: 1;\n    border-color: #27303f;\n    border-color: rgba(39, 48, 63, var(--border-opacity));\n  }\n  .sm\\:focus-within\\:border-cool-gray-900:focus-within {\n    --border-opacity: 1;\n    border-color: #1a202e;\n    border-color: rgba(26, 32, 46, var(--border-opacity));\n  }\n  .sm\\:focus\\:border-current:focus {\n    border-color: currentColor;\n  }\n  .sm\\:focus\\:border-transparent:focus {\n    border-color: transparent;\n  }\n  .sm\\:focus\\:border-white:focus {\n    --border-opacity: 1;\n    border-color: #ffffff;\n    border-color: rgba(255, 255, 255, var(--border-opacity));\n  }\n  .sm\\:focus\\:border-black:focus {\n    --border-opacity: 1;\n    border-color: #000000;\n    border-color: rgba(0, 0, 0, var(--border-opacity));\n  }\n  .sm\\:focus\\:border-gray-50:focus {\n    --border-opacity: 1;\n    border-color: #f9fafb;\n    border-color: rgba(249, 250, 251, var(--border-opacity));\n  }\n  .sm\\:focus\\:border-gray-100:focus {\n    --border-opacity: 1;\n    border-color: #f4f5f7;\n    border-color: rgba(244, 245, 247, var(--border-opacity));\n  }\n  .sm\\:focus\\:border-gray-200:focus {\n    --border-opacity: 1;\n    border-color: #e5e7eb;\n    border-color: rgba(229, 231, 235, var(--border-opacity));\n  }\n  .sm\\:focus\\:border-gray-300:focus {\n    --border-opacity: 1;\n    border-color: #d2d6dc;\n    border-color: rgba(210, 214, 220, var(--border-opacity));\n  }\n  .sm\\:focus\\:border-gray-400:focus {\n    --border-opacity: 1;\n    border-color: #9fa6b2;\n    border-color: rgba(159, 166, 178, var(--border-opacity));\n  }\n  .sm\\:focus\\:border-gray-500:focus {\n    --border-opacity: 1;\n    border-color: #6b7280;\n    border-color: rgba(107, 114, 128, var(--border-opacity));\n  }\n  .sm\\:focus\\:border-gray-600:focus {\n    --border-opacity: 1;\n    border-color: #4b5563;\n    border-color: rgba(75, 85, 99, var(--border-opacity));\n  }\n  .sm\\:focus\\:border-gray-700:focus {\n    --border-opacity: 1;\n    border-color: #374151;\n    border-color: rgba(55, 65, 81, var(--border-opacity));\n  }\n  .sm\\:focus\\:border-gray-800:focus {\n    --border-opacity: 1;\n    border-color: #252f3f;\n    border-color: rgba(37, 47, 63, var(--border-opacity));\n  }\n  .sm\\:focus\\:border-gray-900:focus {\n    --border-opacity: 1;\n    border-color: #161e2e;\n    border-color: rgba(22, 30, 46, var(--border-opacity));\n  }\n  .sm\\:focus\\:border-red-50:focus {\n    --border-opacity: 1;\n    border-color: #fdf2f2;\n    border-color: rgba(253, 242, 242, var(--border-opacity));\n  }\n  .sm\\:focus\\:border-red-100:focus {\n    --border-opacity: 1;\n    border-color: #fde8e8;\n    border-color: rgba(253, 232, 232, var(--border-opacity));\n  }\n  .sm\\:focus\\:border-red-200:focus {\n    --border-opacity: 1;\n    border-color: #fbd5d5;\n    border-color: rgba(251, 213, 213, var(--border-opacity));\n  }\n  .sm\\:focus\\:border-red-300:focus {\n    --border-opacity: 1;\n    border-color: #f8b4b4;\n    border-color: rgba(248, 180, 180, var(--border-opacity));\n  }\n  .sm\\:focus\\:border-red-400:focus {\n    --border-opacity: 1;\n    border-color: #f98080;\n    border-color: rgba(249, 128, 128, var(--border-opacity));\n  }\n  .sm\\:focus\\:border-red-500:focus {\n    --border-opacity: 1;\n    border-color: #f05252;\n    border-color: rgba(240, 82, 82, var(--border-opacity));\n  }\n  .sm\\:focus\\:border-red-600:focus {\n    --border-opacity: 1;\n    border-color: #e02424;\n    border-color: rgba(224, 36, 36, var(--border-opacity));\n  }\n  .sm\\:focus\\:border-red-700:focus {\n    --border-opacity: 1;\n    border-color: #c81e1e;\n    border-color: rgba(200, 30, 30, var(--border-opacity));\n  }\n  .sm\\:focus\\:border-red-800:focus {\n    --border-opacity: 1;\n    border-color: #9b1c1c;\n    border-color: rgba(155, 28, 28, var(--border-opacity));\n  }\n  .sm\\:focus\\:border-red-900:focus {\n    --border-opacity: 1;\n    border-color: #771d1d;\n    border-color: rgba(119, 29, 29, var(--border-opacity));\n  }\n  .sm\\:focus\\:border-orange-50:focus {\n    --border-opacity: 1;\n    border-color: #fff8f1;\n    border-color: rgba(255, 248, 241, var(--border-opacity));\n  }\n  .sm\\:focus\\:border-orange-100:focus {\n    --border-opacity: 1;\n    border-color: #feecdc;\n    border-color: rgba(254, 236, 220, var(--border-opacity));\n  }\n  .sm\\:focus\\:border-orange-200:focus {\n    --border-opacity: 1;\n    border-color: #fcd9bd;\n    border-color: rgba(252, 217, 189, var(--border-opacity));\n  }\n  .sm\\:focus\\:border-orange-300:focus {\n    --border-opacity: 1;\n    border-color: #fdba8c;\n    border-color: rgba(253, 186, 140, var(--border-opacity));\n  }\n  .sm\\:focus\\:border-orange-400:focus {\n    --border-opacity: 1;\n    border-color: #ff8a4c;\n    border-color: rgba(255, 138, 76, var(--border-opacity));\n  }\n  .sm\\:focus\\:border-orange-500:focus {\n    --border-opacity: 1;\n    border-color: #ff5a1f;\n    border-color: rgba(255, 90, 31, var(--border-opacity));\n  }\n  .sm\\:focus\\:border-orange-600:focus {\n    --border-opacity: 1;\n    border-color: #d03801;\n    border-color: rgba(208, 56, 1, var(--border-opacity));\n  }\n  .sm\\:focus\\:border-orange-700:focus {\n    --border-opacity: 1;\n    border-color: #b43403;\n    border-color: rgba(180, 52, 3, var(--border-opacity));\n  }\n  .sm\\:focus\\:border-orange-800:focus {\n    --border-opacity: 1;\n    border-color: #8a2c0d;\n    border-color: rgba(138, 44, 13, var(--border-opacity));\n  }\n  .sm\\:focus\\:border-orange-900:focus {\n    --border-opacity: 1;\n    border-color: #73230d;\n    border-color: rgba(115, 35, 13, var(--border-opacity));\n  }\n  .sm\\:focus\\:border-yellow-50:focus {\n    --border-opacity: 1;\n    border-color: #fdfdea;\n    border-color: rgba(253, 253, 234, var(--border-opacity));\n  }\n  .sm\\:focus\\:border-yellow-100:focus {\n    --border-opacity: 1;\n    border-color: #fdf6b2;\n    border-color: rgba(253, 246, 178, var(--border-opacity));\n  }\n  .sm\\:focus\\:border-yellow-200:focus {\n    --border-opacity: 1;\n    border-color: #fce96a;\n    border-color: rgba(252, 233, 106, var(--border-opacity));\n  }\n  .sm\\:focus\\:border-yellow-300:focus {\n    --border-opacity: 1;\n    border-color: #faca15;\n    border-color: rgba(250, 202, 21, var(--border-opacity));\n  }\n  .sm\\:focus\\:border-yellow-400:focus {\n    --border-opacity: 1;\n    border-color: #e3a008;\n    border-color: rgba(227, 160, 8, var(--border-opacity));\n  }\n  .sm\\:focus\\:border-yellow-500:focus {\n    --border-opacity: 1;\n    border-color: #c27803;\n    border-color: rgba(194, 120, 3, var(--border-opacity));\n  }\n  .sm\\:focus\\:border-yellow-600:focus {\n    --border-opacity: 1;\n    border-color: #9f580a;\n    border-color: rgba(159, 88, 10, var(--border-opacity));\n  }\n  .sm\\:focus\\:border-yellow-700:focus {\n    --border-opacity: 1;\n    border-color: #8e4b10;\n    border-color: rgba(142, 75, 16, var(--border-opacity));\n  }\n  .sm\\:focus\\:border-yellow-800:focus {\n    --border-opacity: 1;\n    border-color: #723b13;\n    border-color: rgba(114, 59, 19, var(--border-opacity));\n  }\n  .sm\\:focus\\:border-yellow-900:focus {\n    --border-opacity: 1;\n    border-color: #633112;\n    border-color: rgba(99, 49, 18, var(--border-opacity));\n  }\n  .sm\\:focus\\:border-green-50:focus {\n    --border-opacity: 1;\n    border-color: #f3faf7;\n    border-color: rgba(243, 250, 247, var(--border-opacity));\n  }\n  .sm\\:focus\\:border-green-100:focus {\n    --border-opacity: 1;\n    border-color: #def7ec;\n    border-color: rgba(222, 247, 236, var(--border-opacity));\n  }\n  .sm\\:focus\\:border-green-200:focus {\n    --border-opacity: 1;\n    border-color: #bcf0da;\n    border-color: rgba(188, 240, 218, var(--border-opacity));\n  }\n  .sm\\:focus\\:border-green-300:focus {\n    --border-opacity: 1;\n    border-color: #84e1bc;\n    border-color: rgba(132, 225, 188, var(--border-opacity));\n  }\n  .sm\\:focus\\:border-green-400:focus {\n    --border-opacity: 1;\n    border-color: #31c48d;\n    border-color: rgba(49, 196, 141, var(--border-opacity));\n  }\n  .sm\\:focus\\:border-green-500:focus {\n    --border-opacity: 1;\n    border-color: #0e9f6e;\n    border-color: rgba(14, 159, 110, var(--border-opacity));\n  }\n  .sm\\:focus\\:border-green-600:focus {\n    --border-opacity: 1;\n    border-color: #057a55;\n    border-color: rgba(5, 122, 85, var(--border-opacity));\n  }\n  .sm\\:focus\\:border-green-700:focus {\n    --border-opacity: 1;\n    border-color: #046c4e;\n    border-color: rgba(4, 108, 78, var(--border-opacity));\n  }\n  .sm\\:focus\\:border-green-800:focus {\n    --border-opacity: 1;\n    border-color: #03543f;\n    border-color: rgba(3, 84, 63, var(--border-opacity));\n  }\n  .sm\\:focus\\:border-green-900:focus {\n    --border-opacity: 1;\n    border-color: #014737;\n    border-color: rgba(1, 71, 55, var(--border-opacity));\n  }\n  .sm\\:focus\\:border-teal-50:focus {\n    --border-opacity: 1;\n    border-color: #edfafa;\n    border-color: rgba(237, 250, 250, var(--border-opacity));\n  }\n  .sm\\:focus\\:border-teal-100:focus {\n    --border-opacity: 1;\n    border-color: #d5f5f6;\n    border-color: rgba(213, 245, 246, var(--border-opacity));\n  }\n  .sm\\:focus\\:border-teal-200:focus {\n    --border-opacity: 1;\n    border-color: #afecef;\n    border-color: rgba(175, 236, 239, var(--border-opacity));\n  }\n  .sm\\:focus\\:border-teal-300:focus {\n    --border-opacity: 1;\n    border-color: #7edce2;\n    border-color: rgba(126, 220, 226, var(--border-opacity));\n  }\n  .sm\\:focus\\:border-teal-400:focus {\n    --border-opacity: 1;\n    border-color: #16bdca;\n    border-color: rgba(22, 189, 202, var(--border-opacity));\n  }\n  .sm\\:focus\\:border-teal-500:focus {\n    --border-opacity: 1;\n    border-color: #0694a2;\n    border-color: rgba(6, 148, 162, var(--border-opacity));\n  }\n  .sm\\:focus\\:border-teal-600:focus {\n    --border-opacity: 1;\n    border-color: #047481;\n    border-color: rgba(4, 116, 129, var(--border-opacity));\n  }\n  .sm\\:focus\\:border-teal-700:focus {\n    --border-opacity: 1;\n    border-color: #036672;\n    border-color: rgba(3, 102, 114, var(--border-opacity));\n  }\n  .sm\\:focus\\:border-teal-800:focus {\n    --border-opacity: 1;\n    border-color: #05505c;\n    border-color: rgba(5, 80, 92, var(--border-opacity));\n  }\n  .sm\\:focus\\:border-teal-900:focus {\n    --border-opacity: 1;\n    border-color: #014451;\n    border-color: rgba(1, 68, 81, var(--border-opacity));\n  }\n  .sm\\:focus\\:border-blue-50:focus {\n    --border-opacity: 1;\n    border-color: #ebf5ff;\n    border-color: rgba(235, 245, 255, var(--border-opacity));\n  }\n  .sm\\:focus\\:border-blue-100:focus {\n    --border-opacity: 1;\n    border-color: #e1effe;\n    border-color: rgba(225, 239, 254, var(--border-opacity));\n  }\n  .sm\\:focus\\:border-blue-200:focus {\n    --border-opacity: 1;\n    border-color: #c3ddfd;\n    border-color: rgba(195, 221, 253, var(--border-opacity));\n  }\n  .sm\\:focus\\:border-blue-300:focus {\n    --border-opacity: 1;\n    border-color: #a4cafe;\n    border-color: rgba(164, 202, 254, var(--border-opacity));\n  }\n  .sm\\:focus\\:border-blue-400:focus {\n    --border-opacity: 1;\n    border-color: #76a9fa;\n    border-color: rgba(118, 169, 250, var(--border-opacity));\n  }\n  .sm\\:focus\\:border-blue-500:focus {\n    --border-opacity: 1;\n    border-color: #3f83f8;\n    border-color: rgba(63, 131, 248, var(--border-opacity));\n  }\n  .sm\\:focus\\:border-blue-600:focus {\n    --border-opacity: 1;\n    border-color: #1c64f2;\n    border-color: rgba(28, 100, 242, var(--border-opacity));\n  }\n  .sm\\:focus\\:border-blue-700:focus {\n    --border-opacity: 1;\n    border-color: #1a56db;\n    border-color: rgba(26, 86, 219, var(--border-opacity));\n  }\n  .sm\\:focus\\:border-blue-800:focus {\n    --border-opacity: 1;\n    border-color: #1e429f;\n    border-color: rgba(30, 66, 159, var(--border-opacity));\n  }\n  .sm\\:focus\\:border-blue-900:focus {\n    --border-opacity: 1;\n    border-color: #233876;\n    border-color: rgba(35, 56, 118, var(--border-opacity));\n  }\n  .sm\\:focus\\:border-indigo-50:focus {\n    --border-opacity: 1;\n    border-color: #f0f5ff;\n    border-color: rgba(240, 245, 255, var(--border-opacity));\n  }\n  .sm\\:focus\\:border-indigo-100:focus {\n    --border-opacity: 1;\n    border-color: #e5edff;\n    border-color: rgba(229, 237, 255, var(--border-opacity));\n  }\n  .sm\\:focus\\:border-indigo-200:focus {\n    --border-opacity: 1;\n    border-color: #cddbfe;\n    border-color: rgba(205, 219, 254, var(--border-opacity));\n  }\n  .sm\\:focus\\:border-indigo-300:focus {\n    --border-opacity: 1;\n    border-color: #b4c6fc;\n    border-color: rgba(180, 198, 252, var(--border-opacity));\n  }\n  .sm\\:focus\\:border-indigo-400:focus {\n    --border-opacity: 1;\n    border-color: #8da2fb;\n    border-color: rgba(141, 162, 251, var(--border-opacity));\n  }\n  .sm\\:focus\\:border-indigo-500:focus {\n    --border-opacity: 1;\n    border-color: #6875f5;\n    border-color: rgba(104, 117, 245, var(--border-opacity));\n  }\n  .sm\\:focus\\:border-indigo-600:focus {\n    --border-opacity: 1;\n    border-color: #5850ec;\n    border-color: rgba(88, 80, 236, var(--border-opacity));\n  }\n  .sm\\:focus\\:border-indigo-700:focus {\n    --border-opacity: 1;\n    border-color: #5145cd;\n    border-color: rgba(81, 69, 205, var(--border-opacity));\n  }\n  .sm\\:focus\\:border-indigo-800:focus {\n    --border-opacity: 1;\n    border-color: #42389d;\n    border-color: rgba(66, 56, 157, var(--border-opacity));\n  }\n  .sm\\:focus\\:border-indigo-900:focus {\n    --border-opacity: 1;\n    border-color: #362f78;\n    border-color: rgba(54, 47, 120, var(--border-opacity));\n  }\n  .sm\\:focus\\:border-purple-50:focus {\n    --border-opacity: 1;\n    border-color: #f6f5ff;\n    border-color: rgba(246, 245, 255, var(--border-opacity));\n  }\n  .sm\\:focus\\:border-purple-100:focus {\n    --border-opacity: 1;\n    border-color: #edebfe;\n    border-color: rgba(237, 235, 254, var(--border-opacity));\n  }\n  .sm\\:focus\\:border-purple-200:focus {\n    --border-opacity: 1;\n    border-color: #dcd7fe;\n    border-color: rgba(220, 215, 254, var(--border-opacity));\n  }\n  .sm\\:focus\\:border-purple-300:focus {\n    --border-opacity: 1;\n    border-color: #cabffd;\n    border-color: rgba(202, 191, 253, var(--border-opacity));\n  }\n  .sm\\:focus\\:border-purple-400:focus {\n    --border-opacity: 1;\n    border-color: #ac94fa;\n    border-color: rgba(172, 148, 250, var(--border-opacity));\n  }\n  .sm\\:focus\\:border-purple-500:focus {\n    --border-opacity: 1;\n    border-color: #9061f9;\n    border-color: rgba(144, 97, 249, var(--border-opacity));\n  }\n  .sm\\:focus\\:border-purple-600:focus {\n    --border-opacity: 1;\n    border-color: #7e3af2;\n    border-color: rgba(126, 58, 242, var(--border-opacity));\n  }\n  .sm\\:focus\\:border-purple-700:focus {\n    --border-opacity: 1;\n    border-color: #6c2bd9;\n    border-color: rgba(108, 43, 217, var(--border-opacity));\n  }\n  .sm\\:focus\\:border-purple-800:focus {\n    --border-opacity: 1;\n    border-color: #5521b5;\n    border-color: rgba(85, 33, 181, var(--border-opacity));\n  }\n  .sm\\:focus\\:border-purple-900:focus {\n    --border-opacity: 1;\n    border-color: #4a1d96;\n    border-color: rgba(74, 29, 150, var(--border-opacity));\n  }\n  .sm\\:focus\\:border-pink-50:focus {\n    --border-opacity: 1;\n    border-color: #fdf2f8;\n    border-color: rgba(253, 242, 248, var(--border-opacity));\n  }\n  .sm\\:focus\\:border-pink-100:focus {\n    --border-opacity: 1;\n    border-color: #fce8f3;\n    border-color: rgba(252, 232, 243, var(--border-opacity));\n  }\n  .sm\\:focus\\:border-pink-200:focus {\n    --border-opacity: 1;\n    border-color: #fad1e8;\n    border-color: rgba(250, 209, 232, var(--border-opacity));\n  }\n  .sm\\:focus\\:border-pink-300:focus {\n    --border-opacity: 1;\n    border-color: #f8b4d9;\n    border-color: rgba(248, 180, 217, var(--border-opacity));\n  }\n  .sm\\:focus\\:border-pink-400:focus {\n    --border-opacity: 1;\n    border-color: #f17eb8;\n    border-color: rgba(241, 126, 184, var(--border-opacity));\n  }\n  .sm\\:focus\\:border-pink-500:focus {\n    --border-opacity: 1;\n    border-color: #e74694;\n    border-color: rgba(231, 70, 148, var(--border-opacity));\n  }\n  .sm\\:focus\\:border-pink-600:focus {\n    --border-opacity: 1;\n    border-color: #d61f69;\n    border-color: rgba(214, 31, 105, var(--border-opacity));\n  }\n  .sm\\:focus\\:border-pink-700:focus {\n    --border-opacity: 1;\n    border-color: #bf125d;\n    border-color: rgba(191, 18, 93, var(--border-opacity));\n  }\n  .sm\\:focus\\:border-pink-800:focus {\n    --border-opacity: 1;\n    border-color: #99154b;\n    border-color: rgba(153, 21, 75, var(--border-opacity));\n  }\n  .sm\\:focus\\:border-pink-900:focus {\n    --border-opacity: 1;\n    border-color: #751a3d;\n    border-color: rgba(117, 26, 61, var(--border-opacity));\n  }\n  .sm\\:focus\\:border-cool-gray-50:focus {\n    --border-opacity: 1;\n    border-color: #f8fafc;\n    border-color: rgba(248, 250, 252, var(--border-opacity));\n  }\n  .sm\\:focus\\:border-cool-gray-100:focus {\n    --border-opacity: 1;\n    border-color: #f1f5f9;\n    border-color: rgba(241, 245, 249, var(--border-opacity));\n  }\n  .sm\\:focus\\:border-cool-gray-200:focus {\n    --border-opacity: 1;\n    border-color: #e2e8f0;\n    border-color: rgba(226, 232, 240, var(--border-opacity));\n  }\n  .sm\\:focus\\:border-cool-gray-300:focus {\n    --border-opacity: 1;\n    border-color: #cfd8e3;\n    border-color: rgba(207, 216, 227, var(--border-opacity));\n  }\n  .sm\\:focus\\:border-cool-gray-400:focus {\n    --border-opacity: 1;\n    border-color: #97a6ba;\n    border-color: rgba(151, 166, 186, var(--border-opacity));\n  }\n  .sm\\:focus\\:border-cool-gray-500:focus {\n    --border-opacity: 1;\n    border-color: #64748b;\n    border-color: rgba(100, 116, 139, var(--border-opacity));\n  }\n  .sm\\:focus\\:border-cool-gray-600:focus {\n    --border-opacity: 1;\n    border-color: #475569;\n    border-color: rgba(71, 85, 105, var(--border-opacity));\n  }\n  .sm\\:focus\\:border-cool-gray-700:focus {\n    --border-opacity: 1;\n    border-color: #364152;\n    border-color: rgba(54, 65, 82, var(--border-opacity));\n  }\n  .sm\\:focus\\:border-cool-gray-800:focus {\n    --border-opacity: 1;\n    border-color: #27303f;\n    border-color: rgba(39, 48, 63, var(--border-opacity));\n  }\n  .sm\\:focus\\:border-cool-gray-900:focus {\n    --border-opacity: 1;\n    border-color: #1a202e;\n    border-color: rgba(26, 32, 46, var(--border-opacity));\n  }\n  .sm\\:border-opacity-0 {\n    --border-opacity: 0;\n  }\n  .sm\\:border-opacity-25 {\n    --border-opacity: 0.25;\n  }\n  .sm\\:border-opacity-50 {\n    --border-opacity: 0.5;\n  }\n  .sm\\:border-opacity-75 {\n    --border-opacity: 0.75;\n  }\n  .sm\\:border-opacity-100 {\n    --border-opacity: 1;\n  }\n  .sm\\:hover\\:border-opacity-0:hover {\n    --border-opacity: 0;\n  }\n  .sm\\:hover\\:border-opacity-25:hover {\n    --border-opacity: 0.25;\n  }\n  .sm\\:hover\\:border-opacity-50:hover {\n    --border-opacity: 0.5;\n  }\n  .sm\\:hover\\:border-opacity-75:hover {\n    --border-opacity: 0.75;\n  }\n  .sm\\:hover\\:border-opacity-100:hover {\n    --border-opacity: 1;\n  }\n  .sm\\:focus\\:border-opacity-0:focus {\n    --border-opacity: 0;\n  }\n  .sm\\:focus\\:border-opacity-25:focus {\n    --border-opacity: 0.25;\n  }\n  .sm\\:focus\\:border-opacity-50:focus {\n    --border-opacity: 0.5;\n  }\n  .sm\\:focus\\:border-opacity-75:focus {\n    --border-opacity: 0.75;\n  }\n  .sm\\:focus\\:border-opacity-100:focus {\n    --border-opacity: 1;\n  }\n  .sm\\:rounded-none {\n    border-radius: 0;\n  }\n  .sm\\:rounded-sm {\n    border-radius: 0.125rem;\n  }\n  .sm\\:rounded {\n    border-radius: 0.25rem;\n  }\n  .sm\\:rounded-md {\n    border-radius: 0.375rem;\n  }\n  .sm\\:rounded-lg {\n    border-radius: 0.5rem;\n  }\n  .sm\\:rounded-xl {\n    border-radius: 0.75rem;\n  }\n  .sm\\:rounded-2xl {\n    border-radius: 1rem;\n  }\n  .sm\\:rounded-3xl {\n    border-radius: 1.5rem;\n  }\n  .sm\\:rounded-full {\n    border-radius: 9999px;\n  }\n  .sm\\:rounded-t-none {\n    border-top-left-radius: 0;\n    border-top-right-radius: 0;\n  }\n  .sm\\:rounded-r-none {\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0;\n  }\n  .sm\\:rounded-b-none {\n    border-bottom-right-radius: 0;\n    border-bottom-left-radius: 0;\n  }\n  .sm\\:rounded-l-none {\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0;\n  }\n  .sm\\:rounded-t-sm {\n    border-top-left-radius: 0.125rem;\n    border-top-right-radius: 0.125rem;\n  }\n  .sm\\:rounded-r-sm {\n    border-top-right-radius: 0.125rem;\n    border-bottom-right-radius: 0.125rem;\n  }\n  .sm\\:rounded-b-sm {\n    border-bottom-right-radius: 0.125rem;\n    border-bottom-left-radius: 0.125rem;\n  }\n  .sm\\:rounded-l-sm {\n    border-top-left-radius: 0.125rem;\n    border-bottom-left-radius: 0.125rem;\n  }\n  .sm\\:rounded-t {\n    border-top-left-radius: 0.25rem;\n    border-top-right-radius: 0.25rem;\n  }\n  .sm\\:rounded-r {\n    border-top-right-radius: 0.25rem;\n    border-bottom-right-radius: 0.25rem;\n  }\n  .sm\\:rounded-b {\n    border-bottom-right-radius: 0.25rem;\n    border-bottom-left-radius: 0.25rem;\n  }\n  .sm\\:rounded-l {\n    border-top-left-radius: 0.25rem;\n    border-bottom-left-radius: 0.25rem;\n  }\n  .sm\\:rounded-t-md {\n    border-top-left-radius: 0.375rem;\n    border-top-right-radius: 0.375rem;\n  }\n  .sm\\:rounded-r-md {\n    border-top-right-radius: 0.375rem;\n    border-bottom-right-radius: 0.375rem;\n  }\n  .sm\\:rounded-b-md {\n    border-bottom-right-radius: 0.375rem;\n    border-bottom-left-radius: 0.375rem;\n  }\n  .sm\\:rounded-l-md {\n    border-top-left-radius: 0.375rem;\n    border-bottom-left-radius: 0.375rem;\n  }\n  .sm\\:rounded-t-lg {\n    border-top-left-radius: 0.5rem;\n    border-top-right-radius: 0.5rem;\n  }\n  .sm\\:rounded-r-lg {\n    border-top-right-radius: 0.5rem;\n    border-bottom-right-radius: 0.5rem;\n  }\n  .sm\\:rounded-b-lg {\n    border-bottom-right-radius: 0.5rem;\n    border-bottom-left-radius: 0.5rem;\n  }\n  .sm\\:rounded-l-lg {\n    border-top-left-radius: 0.5rem;\n    border-bottom-left-radius: 0.5rem;\n  }\n  .sm\\:rounded-t-xl {\n    border-top-left-radius: 0.75rem;\n    border-top-right-radius: 0.75rem;\n  }\n  .sm\\:rounded-r-xl {\n    border-top-right-radius: 0.75rem;\n    border-bottom-right-radius: 0.75rem;\n  }\n  .sm\\:rounded-b-xl {\n    border-bottom-right-radius: 0.75rem;\n    border-bottom-left-radius: 0.75rem;\n  }\n  .sm\\:rounded-l-xl {\n    border-top-left-radius: 0.75rem;\n    border-bottom-left-radius: 0.75rem;\n  }\n  .sm\\:rounded-t-2xl {\n    border-top-left-radius: 1rem;\n    border-top-right-radius: 1rem;\n  }\n  .sm\\:rounded-r-2xl {\n    border-top-right-radius: 1rem;\n    border-bottom-right-radius: 1rem;\n  }\n  .sm\\:rounded-b-2xl {\n    border-bottom-right-radius: 1rem;\n    border-bottom-left-radius: 1rem;\n  }\n  .sm\\:rounded-l-2xl {\n    border-top-left-radius: 1rem;\n    border-bottom-left-radius: 1rem;\n  }\n  .sm\\:rounded-t-3xl {\n    border-top-left-radius: 1.5rem;\n    border-top-right-radius: 1.5rem;\n  }\n  .sm\\:rounded-r-3xl {\n    border-top-right-radius: 1.5rem;\n    border-bottom-right-radius: 1.5rem;\n  }\n  .sm\\:rounded-b-3xl {\n    border-bottom-right-radius: 1.5rem;\n    border-bottom-left-radius: 1.5rem;\n  }\n  .sm\\:rounded-l-3xl {\n    border-top-left-radius: 1.5rem;\n    border-bottom-left-radius: 1.5rem;\n  }\n  .sm\\:rounded-t-full {\n    border-top-left-radius: 9999px;\n    border-top-right-radius: 9999px;\n  }\n  .sm\\:rounded-r-full {\n    border-top-right-radius: 9999px;\n    border-bottom-right-radius: 9999px;\n  }\n  .sm\\:rounded-b-full {\n    border-bottom-right-radius: 9999px;\n    border-bottom-left-radius: 9999px;\n  }\n  .sm\\:rounded-l-full {\n    border-top-left-radius: 9999px;\n    border-bottom-left-radius: 9999px;\n  }\n  .sm\\:rounded-tl-none {\n    border-top-left-radius: 0;\n  }\n  .sm\\:rounded-tr-none {\n    border-top-right-radius: 0;\n  }\n  .sm\\:rounded-br-none {\n    border-bottom-right-radius: 0;\n  }\n  .sm\\:rounded-bl-none {\n    border-bottom-left-radius: 0;\n  }\n  .sm\\:rounded-tl-sm {\n    border-top-left-radius: 0.125rem;\n  }\n  .sm\\:rounded-tr-sm {\n    border-top-right-radius: 0.125rem;\n  }\n  .sm\\:rounded-br-sm {\n    border-bottom-right-radius: 0.125rem;\n  }\n  .sm\\:rounded-bl-sm {\n    border-bottom-left-radius: 0.125rem;\n  }\n  .sm\\:rounded-tl {\n    border-top-left-radius: 0.25rem;\n  }\n  .sm\\:rounded-tr {\n    border-top-right-radius: 0.25rem;\n  }\n  .sm\\:rounded-br {\n    border-bottom-right-radius: 0.25rem;\n  }\n  .sm\\:rounded-bl {\n    border-bottom-left-radius: 0.25rem;\n  }\n  .sm\\:rounded-tl-md {\n    border-top-left-radius: 0.375rem;\n  }\n  .sm\\:rounded-tr-md {\n    border-top-right-radius: 0.375rem;\n  }\n  .sm\\:rounded-br-md {\n    border-bottom-right-radius: 0.375rem;\n  }\n  .sm\\:rounded-bl-md {\n    border-bottom-left-radius: 0.375rem;\n  }\n  .sm\\:rounded-tl-lg {\n    border-top-left-radius: 0.5rem;\n  }\n  .sm\\:rounded-tr-lg {\n    border-top-right-radius: 0.5rem;\n  }\n  .sm\\:rounded-br-lg {\n    border-bottom-right-radius: 0.5rem;\n  }\n  .sm\\:rounded-bl-lg {\n    border-bottom-left-radius: 0.5rem;\n  }\n  .sm\\:rounded-tl-xl {\n    border-top-left-radius: 0.75rem;\n  }\n  .sm\\:rounded-tr-xl {\n    border-top-right-radius: 0.75rem;\n  }\n  .sm\\:rounded-br-xl {\n    border-bottom-right-radius: 0.75rem;\n  }\n  .sm\\:rounded-bl-xl {\n    border-bottom-left-radius: 0.75rem;\n  }\n  .sm\\:rounded-tl-2xl {\n    border-top-left-radius: 1rem;\n  }\n  .sm\\:rounded-tr-2xl {\n    border-top-right-radius: 1rem;\n  }\n  .sm\\:rounded-br-2xl {\n    border-bottom-right-radius: 1rem;\n  }\n  .sm\\:rounded-bl-2xl {\n    border-bottom-left-radius: 1rem;\n  }\n  .sm\\:rounded-tl-3xl {\n    border-top-left-radius: 1.5rem;\n  }\n  .sm\\:rounded-tr-3xl {\n    border-top-right-radius: 1.5rem;\n  }\n  .sm\\:rounded-br-3xl {\n    border-bottom-right-radius: 1.5rem;\n  }\n  .sm\\:rounded-bl-3xl {\n    border-bottom-left-radius: 1.5rem;\n  }\n  .sm\\:rounded-tl-full {\n    border-top-left-radius: 9999px;\n  }\n  .sm\\:rounded-tr-full {\n    border-top-right-radius: 9999px;\n  }\n  .sm\\:rounded-br-full {\n    border-bottom-right-radius: 9999px;\n  }\n  .sm\\:rounded-bl-full {\n    border-bottom-left-radius: 9999px;\n  }\n  .sm\\:border-solid {\n    border-style: solid;\n  }\n  .sm\\:border-dashed {\n    border-style: dashed;\n  }\n  .sm\\:border-dotted {\n    border-style: dotted;\n  }\n  .sm\\:border-double {\n    border-style: double;\n  }\n  .sm\\:border-none {\n    border-style: none;\n  }\n  .sm\\:border-0 {\n    border-width: 0;\n  }\n  .sm\\:border-2 {\n    border-width: 2px;\n  }\n  .sm\\:border-4 {\n    border-width: 4px;\n  }\n  .sm\\:border-8 {\n    border-width: 8px;\n  }\n  .sm\\:border {\n    border-width: 1px;\n  }\n  .sm\\:border-t-0 {\n    border-top-width: 0;\n  }\n  .sm\\:border-r-0 {\n    border-right-width: 0;\n  }\n  .sm\\:border-b-0 {\n    border-bottom-width: 0;\n  }\n  .sm\\:border-l-0 {\n    border-left-width: 0;\n  }\n  .sm\\:border-t-2 {\n    border-top-width: 2px;\n  }\n  .sm\\:border-r-2 {\n    border-right-width: 2px;\n  }\n  .sm\\:border-b-2 {\n    border-bottom-width: 2px;\n  }\n  .sm\\:border-l-2 {\n    border-left-width: 2px;\n  }\n  .sm\\:border-t-4 {\n    border-top-width: 4px;\n  }\n  .sm\\:border-r-4 {\n    border-right-width: 4px;\n  }\n  .sm\\:border-b-4 {\n    border-bottom-width: 4px;\n  }\n  .sm\\:border-l-4 {\n    border-left-width: 4px;\n  }\n  .sm\\:border-t-8 {\n    border-top-width: 8px;\n  }\n  .sm\\:border-r-8 {\n    border-right-width: 8px;\n  }\n  .sm\\:border-b-8 {\n    border-bottom-width: 8px;\n  }\n  .sm\\:border-l-8 {\n    border-left-width: 8px;\n  }\n  .sm\\:border-t {\n    border-top-width: 1px;\n  }\n  .sm\\:border-r {\n    border-right-width: 1px;\n  }\n  .sm\\:border-b {\n    border-bottom-width: 1px;\n  }\n  .sm\\:border-l {\n    border-left-width: 1px;\n  }\n  .sm\\:box-border {\n    box-sizing: border-box;\n  }\n  .sm\\:box-content {\n    box-sizing: content-box;\n  }\n  .sm\\:cursor-auto {\n    cursor: auto;\n  }\n  .sm\\:cursor-default {\n    cursor: default;\n  }\n  .sm\\:cursor-pointer {\n    cursor: pointer;\n  }\n  .sm\\:cursor-wait {\n    cursor: wait;\n  }\n  .sm\\:cursor-text {\n    cursor: text;\n  }\n  .sm\\:cursor-move {\n    cursor: move;\n  }\n  .sm\\:cursor-not-allowed {\n    cursor: not-allowed;\n  }\n  .sm\\:block {\n    display: block;\n  }\n  .sm\\:inline-block {\n    display: inline-block;\n  }\n  .sm\\:inline {\n    display: inline;\n  }\n  .sm\\:flex {\n    display: flex;\n  }\n  .sm\\:inline-flex {\n    display: inline-flex;\n  }\n  .sm\\:table {\n    display: table;\n  }\n  .sm\\:table-caption {\n    display: table-caption;\n  }\n  .sm\\:table-cell {\n    display: table-cell;\n  }\n  .sm\\:table-column {\n    display: table-column;\n  }\n  .sm\\:table-column-group {\n    display: table-column-group;\n  }\n  .sm\\:table-footer-group {\n    display: table-footer-group;\n  }\n  .sm\\:table-header-group {\n    display: table-header-group;\n  }\n  .sm\\:table-row-group {\n    display: table-row-group;\n  }\n  .sm\\:table-row {\n    display: table-row;\n  }\n  .sm\\:flow-root {\n    display: flow-root;\n  }\n  .sm\\:grid {\n    display: grid;\n  }\n  .sm\\:inline-grid {\n    display: inline-grid;\n  }\n  .sm\\:contents {\n    display: contents;\n  }\n  .sm\\:hidden {\n    display: none;\n  }\n  .sm\\:flex-row {\n    flex-direction: row;\n  }\n  .sm\\:flex-row-reverse {\n    flex-direction: row-reverse;\n  }\n  .sm\\:flex-col {\n    flex-direction: column;\n  }\n  .sm\\:flex-col-reverse {\n    flex-direction: column-reverse;\n  }\n  .sm\\:flex-wrap {\n    flex-wrap: wrap;\n  }\n  .sm\\:flex-wrap-reverse {\n    flex-wrap: wrap-reverse;\n  }\n  .sm\\:flex-no-wrap {\n    flex-wrap: nowrap;\n  }\n  .sm\\:place-items-auto {\n    place-items: auto;\n  }\n  .sm\\:place-items-start {\n    place-items: start;\n  }\n  .sm\\:place-items-end {\n    place-items: end;\n  }\n  .sm\\:place-items-center {\n    place-items: center;\n  }\n  .sm\\:place-items-stretch {\n    place-items: stretch;\n  }\n  .sm\\:place-content-center {\n    place-content: center;\n  }\n  .sm\\:place-content-start {\n    place-content: start;\n  }\n  .sm\\:place-content-end {\n    place-content: end;\n  }\n  .sm\\:place-content-between {\n    place-content: space-between;\n  }\n  .sm\\:place-content-around {\n    place-content: space-around;\n  }\n  .sm\\:place-content-evenly {\n    place-content: space-evenly;\n  }\n  .sm\\:place-content-stretch {\n    place-content: stretch;\n  }\n  .sm\\:place-self-auto {\n    place-self: auto;\n  }\n  .sm\\:place-self-start {\n    place-self: start;\n  }\n  .sm\\:place-self-end {\n    place-self: end;\n  }\n  .sm\\:place-self-center {\n    place-self: center;\n  }\n  .sm\\:place-self-stretch {\n    place-self: stretch;\n  }\n  .sm\\:items-start {\n    align-items: flex-start;\n  }\n  .sm\\:items-end {\n    align-items: flex-end;\n  }\n  .sm\\:items-center {\n    align-items: center;\n  }\n  .sm\\:items-baseline {\n    align-items: baseline;\n  }\n  .sm\\:items-stretch {\n    align-items: stretch;\n  }\n  .sm\\:content-center {\n    align-content: center;\n  }\n  .sm\\:content-start {\n    align-content: flex-start;\n  }\n  .sm\\:content-end {\n    align-content: flex-end;\n  }\n  .sm\\:content-between {\n    align-content: space-between;\n  }\n  .sm\\:content-around {\n    align-content: space-around;\n  }\n  .sm\\:content-evenly {\n    align-content: space-evenly;\n  }\n  .sm\\:self-auto {\n    align-self: auto;\n  }\n  .sm\\:self-start {\n    align-self: flex-start;\n  }\n  .sm\\:self-end {\n    align-self: flex-end;\n  }\n  .sm\\:self-center {\n    align-self: center;\n  }\n  .sm\\:self-stretch {\n    align-self: stretch;\n  }\n  .sm\\:justify-items-auto {\n    justify-items: auto;\n  }\n  .sm\\:justify-items-start {\n    justify-items: start;\n  }\n  .sm\\:justify-items-end {\n    justify-items: end;\n  }\n  .sm\\:justify-items-center {\n    justify-items: center;\n  }\n  .sm\\:justify-items-stretch {\n    justify-items: stretch;\n  }\n  .sm\\:justify-start {\n    justify-content: flex-start;\n  }\n  .sm\\:justify-end {\n    justify-content: flex-end;\n  }\n  .sm\\:justify-center {\n    justify-content: center;\n  }\n  .sm\\:justify-between {\n    justify-content: space-between;\n  }\n  .sm\\:justify-around {\n    justify-content: space-around;\n  }\n  .sm\\:justify-evenly {\n    justify-content: space-evenly;\n  }\n  .sm\\:justify-self-auto {\n    justify-self: auto;\n  }\n  .sm\\:justify-self-start {\n    justify-self: start;\n  }\n  .sm\\:justify-self-end {\n    justify-self: end;\n  }\n  .sm\\:justify-self-center {\n    justify-self: center;\n  }\n  .sm\\:justify-self-stretch {\n    justify-self: stretch;\n  }\n  .sm\\:flex-1 {\n    flex: 1 1 0%;\n  }\n  .sm\\:flex-auto {\n    flex: 1 1 auto;\n  }\n  .sm\\:flex-initial {\n    flex: 0 1 auto;\n  }\n  .sm\\:flex-none {\n    flex: none;\n  }\n  .sm\\:flex-grow-0 {\n    flex-grow: 0;\n  }\n  .sm\\:flex-grow {\n    flex-grow: 1;\n  }\n  .sm\\:flex-shrink-0 {\n    flex-shrink: 0;\n  }\n  .sm\\:flex-shrink {\n    flex-shrink: 1;\n  }\n  .sm\\:order-1 {\n    order: 1;\n  }\n  .sm\\:order-2 {\n    order: 2;\n  }\n  .sm\\:order-3 {\n    order: 3;\n  }\n  .sm\\:order-4 {\n    order: 4;\n  }\n  .sm\\:order-5 {\n    order: 5;\n  }\n  .sm\\:order-6 {\n    order: 6;\n  }\n  .sm\\:order-7 {\n    order: 7;\n  }\n  .sm\\:order-8 {\n    order: 8;\n  }\n  .sm\\:order-9 {\n    order: 9;\n  }\n  .sm\\:order-10 {\n    order: 10;\n  }\n  .sm\\:order-11 {\n    order: 11;\n  }\n  .sm\\:order-12 {\n    order: 12;\n  }\n  .sm\\:order-first {\n    order: -9999;\n  }\n  .sm\\:order-last {\n    order: 9999;\n  }\n  .sm\\:order-none {\n    order: 0;\n  }\n  .sm\\:float-right {\n    float: right;\n  }\n  .sm\\:float-left {\n    float: left;\n  }\n  .sm\\:float-none {\n    float: none;\n  }\n  .sm\\:clearfix:after {\n    content: \"\";\n    display: table;\n    clear: both;\n  }\n  .sm\\:clear-left {\n    clear: left;\n  }\n  .sm\\:clear-right {\n    clear: right;\n  }\n  .sm\\:clear-both {\n    clear: both;\n  }\n  .sm\\:clear-none {\n    clear: none;\n  }\n  .sm\\:font-sans {\n    font-family: system-ui, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, \"Noto Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n  }\n  .sm\\:font-serif {\n    font-family: Georgia, Cambria, \"Times New Roman\", Times, serif;\n  }\n  .sm\\:font-mono {\n    font-family: Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace;\n  }\n  .sm\\:font-hairline {\n    font-weight: 100;\n  }\n  .sm\\:font-thin {\n    font-weight: 200;\n  }\n  .sm\\:font-light {\n    font-weight: 300;\n  }\n  .sm\\:font-normal {\n    font-weight: 400;\n  }\n  .sm\\:font-medium {\n    font-weight: 500;\n  }\n  .sm\\:font-semibold {\n    font-weight: 600;\n  }\n  .sm\\:font-bold {\n    font-weight: 700;\n  }\n  .sm\\:font-extrabold {\n    font-weight: 800;\n  }\n  .sm\\:font-black {\n    font-weight: 900;\n  }\n  .sm\\:hover\\:font-hairline:hover {\n    font-weight: 100;\n  }\n  .sm\\:hover\\:font-thin:hover {\n    font-weight: 200;\n  }\n  .sm\\:hover\\:font-light:hover {\n    font-weight: 300;\n  }\n  .sm\\:hover\\:font-normal:hover {\n    font-weight: 400;\n  }\n  .sm\\:hover\\:font-medium:hover {\n    font-weight: 500;\n  }\n  .sm\\:hover\\:font-semibold:hover {\n    font-weight: 600;\n  }\n  .sm\\:hover\\:font-bold:hover {\n    font-weight: 700;\n  }\n  .sm\\:hover\\:font-extrabold:hover {\n    font-weight: 800;\n  }\n  .sm\\:hover\\:font-black:hover {\n    font-weight: 900;\n  }\n  .sm\\:focus\\:font-hairline:focus {\n    font-weight: 100;\n  }\n  .sm\\:focus\\:font-thin:focus {\n    font-weight: 200;\n  }\n  .sm\\:focus\\:font-light:focus {\n    font-weight: 300;\n  }\n  .sm\\:focus\\:font-normal:focus {\n    font-weight: 400;\n  }\n  .sm\\:focus\\:font-medium:focus {\n    font-weight: 500;\n  }\n  .sm\\:focus\\:font-semibold:focus {\n    font-weight: 600;\n  }\n  .sm\\:focus\\:font-bold:focus {\n    font-weight: 700;\n  }\n  .sm\\:focus\\:font-extrabold:focus {\n    font-weight: 800;\n  }\n  .sm\\:focus\\:font-black:focus {\n    font-weight: 900;\n  }\n  .sm\\:h-0 {\n    height: 0;\n  }\n  .sm\\:h-1 {\n    height: 0.25rem;\n  }\n  .sm\\:h-2 {\n    height: 0.5rem;\n  }\n  .sm\\:h-3 {\n    height: 0.75rem;\n  }\n  .sm\\:h-4 {\n    height: 1rem;\n  }\n  .sm\\:h-5 {\n    height: 1.25rem;\n  }\n  .sm\\:h-6 {\n    height: 1.5rem;\n  }\n  .sm\\:h-7 {\n    height: 1.75rem;\n  }\n  .sm\\:h-8 {\n    height: 2rem;\n  }\n  .sm\\:h-9 {\n    height: 2.25rem;\n  }\n  .sm\\:h-10 {\n    height: 2.5rem;\n  }\n  .sm\\:h-11 {\n    height: 2.75rem;\n  }\n  .sm\\:h-12 {\n    height: 3rem;\n  }\n  .sm\\:h-13 {\n    height: 3.25rem;\n  }\n  .sm\\:h-14 {\n    height: 3.5rem;\n  }\n  .sm\\:h-15 {\n    height: 3.75rem;\n  }\n  .sm\\:h-16 {\n    height: 4rem;\n  }\n  .sm\\:h-20 {\n    height: 5rem;\n  }\n  .sm\\:h-24 {\n    height: 6rem;\n  }\n  .sm\\:h-28 {\n    height: 7rem;\n  }\n  .sm\\:h-32 {\n    height: 8rem;\n  }\n  .sm\\:h-36 {\n    height: 9rem;\n  }\n  .sm\\:h-40 {\n    height: 10rem;\n  }\n  .sm\\:h-44 {\n    height: 11rem;\n  }\n  .sm\\:h-48 {\n    height: 12rem;\n  }\n  .sm\\:h-52 {\n    height: 13rem;\n  }\n  .sm\\:h-56 {\n    height: 14rem;\n  }\n  .sm\\:h-60 {\n    height: 15rem;\n  }\n  .sm\\:h-64 {\n    height: 16rem;\n  }\n  .sm\\:h-72 {\n    height: 18rem;\n  }\n  .sm\\:h-80 {\n    height: 20rem;\n  }\n  .sm\\:h-96 {\n    height: 24rem;\n  }\n  .sm\\:h-auto {\n    height: auto;\n  }\n  .sm\\:h-px {\n    height: 1px;\n  }\n  .sm\\:h-0\\.5 {\n    height: 0.125rem;\n  }\n  .sm\\:h-1\\.5 {\n    height: 0.375rem;\n  }\n  .sm\\:h-2\\.5 {\n    height: 0.625rem;\n  }\n  .sm\\:h-3\\.5 {\n    height: 0.875rem;\n  }\n  .sm\\:h-1\\/2 {\n    height: 50%;\n  }\n  .sm\\:h-1\\/3 {\n    height: 33.333333%;\n  }\n  .sm\\:h-2\\/3 {\n    height: 66.666667%;\n  }\n  .sm\\:h-1\\/4 {\n    height: 25%;\n  }\n  .sm\\:h-2\\/4 {\n    height: 50%;\n  }\n  .sm\\:h-3\\/4 {\n    height: 75%;\n  }\n  .sm\\:h-1\\/5 {\n    height: 20%;\n  }\n  .sm\\:h-2\\/5 {\n    height: 40%;\n  }\n  .sm\\:h-3\\/5 {\n    height: 60%;\n  }\n  .sm\\:h-4\\/5 {\n    height: 80%;\n  }\n  .sm\\:h-1\\/6 {\n    height: 16.666667%;\n  }\n  .sm\\:h-2\\/6 {\n    height: 33.333333%;\n  }\n  .sm\\:h-3\\/6 {\n    height: 50%;\n  }\n  .sm\\:h-4\\/6 {\n    height: 66.666667%;\n  }\n  .sm\\:h-5\\/6 {\n    height: 83.333333%;\n  }\n  .sm\\:h-1\\/12 {\n    height: 8.333333%;\n  }\n  .sm\\:h-2\\/12 {\n    height: 16.666667%;\n  }\n  .sm\\:h-3\\/12 {\n    height: 25%;\n  }\n  .sm\\:h-4\\/12 {\n    height: 33.333333%;\n  }\n  .sm\\:h-5\\/12 {\n    height: 41.666667%;\n  }\n  .sm\\:h-6\\/12 {\n    height: 50%;\n  }\n  .sm\\:h-7\\/12 {\n    height: 58.333333%;\n  }\n  .sm\\:h-8\\/12 {\n    height: 66.666667%;\n  }\n  .sm\\:h-9\\/12 {\n    height: 75%;\n  }\n  .sm\\:h-10\\/12 {\n    height: 83.333333%;\n  }\n  .sm\\:h-11\\/12 {\n    height: 91.666667%;\n  }\n  .sm\\:h-full {\n    height: 100%;\n  }\n  .sm\\:h-screen {\n    height: 100vh;\n  }\n  .sm\\:text-xs {\n    font-size: 0.75rem;\n  }\n  .sm\\:text-sm {\n    font-size: 0.875rem;\n  }\n  .sm\\:text-base {\n    font-size: 1rem;\n  }\n  .sm\\:text-lg {\n    font-size: 1.125rem;\n  }\n  .sm\\:text-xl {\n    font-size: 1.25rem;\n  }\n  .sm\\:text-2xl {\n    font-size: 1.5rem;\n  }\n  .sm\\:text-3xl {\n    font-size: 1.875rem;\n  }\n  .sm\\:text-4xl {\n    font-size: 2.25rem;\n  }\n  .sm\\:text-5xl {\n    font-size: 3rem;\n  }\n  .sm\\:text-6xl {\n    font-size: 4rem;\n  }\n  .sm\\:leading-3 {\n    line-height: .75rem;\n  }\n  .sm\\:leading-4 {\n    line-height: 1rem;\n  }\n  .sm\\:leading-5 {\n    line-height: 1.25rem;\n  }\n  .sm\\:leading-6 {\n    line-height: 1.5rem;\n  }\n  .sm\\:leading-7 {\n    line-height: 1.75rem;\n  }\n  .sm\\:leading-8 {\n    line-height: 2rem;\n  }\n  .sm\\:leading-9 {\n    line-height: 2.25rem;\n  }\n  .sm\\:leading-10 {\n    line-height: 2.5rem;\n  }\n  .sm\\:leading-none {\n    line-height: 1;\n  }\n  .sm\\:leading-tight {\n    line-height: 1.25;\n  }\n  .sm\\:leading-snug {\n    line-height: 1.375;\n  }\n  .sm\\:leading-normal {\n    line-height: 1.5;\n  }\n  .sm\\:leading-relaxed {\n    line-height: 1.625;\n  }\n  .sm\\:leading-loose {\n    line-height: 2;\n  }\n  .sm\\:list-inside {\n    list-style-position: inside;\n  }\n  .sm\\:list-outside {\n    list-style-position: outside;\n  }\n  .sm\\:list-none {\n    list-style-type: none;\n  }\n  .sm\\:list-disc {\n    list-style-type: disc;\n  }\n  .sm\\:list-decimal {\n    list-style-type: decimal;\n  }\n  .sm\\:m-0 {\n    margin: 0;\n  }\n  .sm\\:m-1 {\n    margin: 0.25rem;\n  }\n  .sm\\:m-2 {\n    margin: 0.5rem;\n  }\n  .sm\\:m-3 {\n    margin: 0.75rem;\n  }\n  .sm\\:m-4 {\n    margin: 1rem;\n  }\n  .sm\\:m-5 {\n    margin: 1.25rem;\n  }\n  .sm\\:m-6 {\n    margin: 1.5rem;\n  }\n  .sm\\:m-7 {\n    margin: 1.75rem;\n  }\n  .sm\\:m-8 {\n    margin: 2rem;\n  }\n  .sm\\:m-9 {\n    margin: 2.25rem;\n  }\n  .sm\\:m-10 {\n    margin: 2.5rem;\n  }\n  .sm\\:m-11 {\n    margin: 2.75rem;\n  }\n  .sm\\:m-12 {\n    margin: 3rem;\n  }\n  .sm\\:m-13 {\n    margin: 3.25rem;\n  }\n  .sm\\:m-14 {\n    margin: 3.5rem;\n  }\n  .sm\\:m-15 {\n    margin: 3.75rem;\n  }\n  .sm\\:m-16 {\n    margin: 4rem;\n  }\n  .sm\\:m-20 {\n    margin: 5rem;\n  }\n  .sm\\:m-24 {\n    margin: 6rem;\n  }\n  .sm\\:m-28 {\n    margin: 7rem;\n  }\n  .sm\\:m-32 {\n    margin: 8rem;\n  }\n  .sm\\:m-36 {\n    margin: 9rem;\n  }\n  .sm\\:m-40 {\n    margin: 10rem;\n  }\n  .sm\\:m-44 {\n    margin: 11rem;\n  }\n  .sm\\:m-48 {\n    margin: 12rem;\n  }\n  .sm\\:m-52 {\n    margin: 13rem;\n  }\n  .sm\\:m-56 {\n    margin: 14rem;\n  }\n  .sm\\:m-60 {\n    margin: 15rem;\n  }\n  .sm\\:m-64 {\n    margin: 16rem;\n  }\n  .sm\\:m-72 {\n    margin: 18rem;\n  }\n  .sm\\:m-80 {\n    margin: 20rem;\n  }\n  .sm\\:m-96 {\n    margin: 24rem;\n  }\n  .sm\\:m-auto {\n    margin: auto;\n  }\n  .sm\\:m-px {\n    margin: 1px;\n  }\n  .sm\\:m-0\\.5 {\n    margin: 0.125rem;\n  }\n  .sm\\:m-1\\.5 {\n    margin: 0.375rem;\n  }\n  .sm\\:m-2\\.5 {\n    margin: 0.625rem;\n  }\n  .sm\\:m-3\\.5 {\n    margin: 0.875rem;\n  }\n  .sm\\:m-1\\/2 {\n    margin: 50%;\n  }\n  .sm\\:m-1\\/3 {\n    margin: 33.333333%;\n  }\n  .sm\\:m-2\\/3 {\n    margin: 66.666667%;\n  }\n  .sm\\:m-1\\/4 {\n    margin: 25%;\n  }\n  .sm\\:m-2\\/4 {\n    margin: 50%;\n  }\n  .sm\\:m-3\\/4 {\n    margin: 75%;\n  }\n  .sm\\:m-1\\/5 {\n    margin: 20%;\n  }\n  .sm\\:m-2\\/5 {\n    margin: 40%;\n  }\n  .sm\\:m-3\\/5 {\n    margin: 60%;\n  }\n  .sm\\:m-4\\/5 {\n    margin: 80%;\n  }\n  .sm\\:m-1\\/6 {\n    margin: 16.666667%;\n  }\n  .sm\\:m-2\\/6 {\n    margin: 33.333333%;\n  }\n  .sm\\:m-3\\/6 {\n    margin: 50%;\n  }\n  .sm\\:m-4\\/6 {\n    margin: 66.666667%;\n  }\n  .sm\\:m-5\\/6 {\n    margin: 83.333333%;\n  }\n  .sm\\:m-1\\/12 {\n    margin: 8.333333%;\n  }\n  .sm\\:m-2\\/12 {\n    margin: 16.666667%;\n  }\n  .sm\\:m-3\\/12 {\n    margin: 25%;\n  }\n  .sm\\:m-4\\/12 {\n    margin: 33.333333%;\n  }\n  .sm\\:m-5\\/12 {\n    margin: 41.666667%;\n  }\n  .sm\\:m-6\\/12 {\n    margin: 50%;\n  }\n  .sm\\:m-7\\/12 {\n    margin: 58.333333%;\n  }\n  .sm\\:m-8\\/12 {\n    margin: 66.666667%;\n  }\n  .sm\\:m-9\\/12 {\n    margin: 75%;\n  }\n  .sm\\:m-10\\/12 {\n    margin: 83.333333%;\n  }\n  .sm\\:m-11\\/12 {\n    margin: 91.666667%;\n  }\n  .sm\\:m-full {\n    margin: 100%;\n  }\n  .sm\\:-m-1 {\n    margin: -0.25rem;\n  }\n  .sm\\:-m-2 {\n    margin: -0.5rem;\n  }\n  .sm\\:-m-3 {\n    margin: -0.75rem;\n  }\n  .sm\\:-m-4 {\n    margin: -1rem;\n  }\n  .sm\\:-m-5 {\n    margin: -1.25rem;\n  }\n  .sm\\:-m-6 {\n    margin: -1.5rem;\n  }\n  .sm\\:-m-7 {\n    margin: -1.75rem;\n  }\n  .sm\\:-m-8 {\n    margin: -2rem;\n  }\n  .sm\\:-m-9 {\n    margin: -2.25rem;\n  }\n  .sm\\:-m-10 {\n    margin: -2.5rem;\n  }\n  .sm\\:-m-11 {\n    margin: -2.75rem;\n  }\n  .sm\\:-m-12 {\n    margin: -3rem;\n  }\n  .sm\\:-m-13 {\n    margin: -3.25rem;\n  }\n  .sm\\:-m-14 {\n    margin: -3.5rem;\n  }\n  .sm\\:-m-15 {\n    margin: -3.75rem;\n  }\n  .sm\\:-m-16 {\n    margin: -4rem;\n  }\n  .sm\\:-m-20 {\n    margin: -5rem;\n  }\n  .sm\\:-m-24 {\n    margin: -6rem;\n  }\n  .sm\\:-m-28 {\n    margin: -7rem;\n  }\n  .sm\\:-m-32 {\n    margin: -8rem;\n  }\n  .sm\\:-m-36 {\n    margin: -9rem;\n  }\n  .sm\\:-m-40 {\n    margin: -10rem;\n  }\n  .sm\\:-m-44 {\n    margin: -11rem;\n  }\n  .sm\\:-m-48 {\n    margin: -12rem;\n  }\n  .sm\\:-m-52 {\n    margin: -13rem;\n  }\n  .sm\\:-m-56 {\n    margin: -14rem;\n  }\n  .sm\\:-m-60 {\n    margin: -15rem;\n  }\n  .sm\\:-m-64 {\n    margin: -16rem;\n  }\n  .sm\\:-m-72 {\n    margin: -18rem;\n  }\n  .sm\\:-m-80 {\n    margin: -20rem;\n  }\n  .sm\\:-m-96 {\n    margin: -24rem;\n  }\n  .sm\\:-m-px {\n    margin: -1px;\n  }\n  .sm\\:-m-0\\.5 {\n    margin: -0.125rem;\n  }\n  .sm\\:-m-1\\.5 {\n    margin: -0.375rem;\n  }\n  .sm\\:-m-2\\.5 {\n    margin: -0.625rem;\n  }\n  .sm\\:-m-3\\.5 {\n    margin: -0.875rem;\n  }\n  .sm\\:-m-1\\/2 {\n    margin: -50%;\n  }\n  .sm\\:-m-1\\/3 {\n    margin: -33.33333%;\n  }\n  .sm\\:-m-2\\/3 {\n    margin: -66.66667%;\n  }\n  .sm\\:-m-1\\/4 {\n    margin: -25%;\n  }\n  .sm\\:-m-2\\/4 {\n    margin: -50%;\n  }\n  .sm\\:-m-3\\/4 {\n    margin: -75%;\n  }\n  .sm\\:-m-1\\/5 {\n    margin: -20%;\n  }\n  .sm\\:-m-2\\/5 {\n    margin: -40%;\n  }\n  .sm\\:-m-3\\/5 {\n    margin: -60%;\n  }\n  .sm\\:-m-4\\/5 {\n    margin: -80%;\n  }\n  .sm\\:-m-1\\/6 {\n    margin: -16.66667%;\n  }\n  .sm\\:-m-2\\/6 {\n    margin: -33.33333%;\n  }\n  .sm\\:-m-3\\/6 {\n    margin: -50%;\n  }\n  .sm\\:-m-4\\/6 {\n    margin: -66.66667%;\n  }\n  .sm\\:-m-5\\/6 {\n    margin: -83.33333%;\n  }\n  .sm\\:-m-1\\/12 {\n    margin: -8.33333%;\n  }\n  .sm\\:-m-2\\/12 {\n    margin: -16.66667%;\n  }\n  .sm\\:-m-3\\/12 {\n    margin: -25%;\n  }\n  .sm\\:-m-4\\/12 {\n    margin: -33.33333%;\n  }\n  .sm\\:-m-5\\/12 {\n    margin: -41.66667%;\n  }\n  .sm\\:-m-6\\/12 {\n    margin: -50%;\n  }\n  .sm\\:-m-7\\/12 {\n    margin: -58.33333%;\n  }\n  .sm\\:-m-8\\/12 {\n    margin: -66.66667%;\n  }\n  .sm\\:-m-9\\/12 {\n    margin: -75%;\n  }\n  .sm\\:-m-10\\/12 {\n    margin: -83.33333%;\n  }\n  .sm\\:-m-11\\/12 {\n    margin: -91.66667%;\n  }\n  .sm\\:-m-full {\n    margin: -100%;\n  }\n  .sm\\:my-0 {\n    margin-top: 0;\n    margin-bottom: 0;\n  }\n  .sm\\:mx-0 {\n    margin-left: 0;\n    margin-right: 0;\n  }\n  .sm\\:my-1 {\n    margin-top: 0.25rem;\n    margin-bottom: 0.25rem;\n  }\n  .sm\\:mx-1 {\n    margin-left: 0.25rem;\n    margin-right: 0.25rem;\n  }\n  .sm\\:my-2 {\n    margin-top: 0.5rem;\n    margin-bottom: 0.5rem;\n  }\n  .sm\\:mx-2 {\n    margin-left: 0.5rem;\n    margin-right: 0.5rem;\n  }\n  .sm\\:my-3 {\n    margin-top: 0.75rem;\n    margin-bottom: 0.75rem;\n  }\n  .sm\\:mx-3 {\n    margin-left: 0.75rem;\n    margin-right: 0.75rem;\n  }\n  .sm\\:my-4 {\n    margin-top: 1rem;\n    margin-bottom: 1rem;\n  }\n  .sm\\:mx-4 {\n    margin-left: 1rem;\n    margin-right: 1rem;\n  }\n  .sm\\:my-5 {\n    margin-top: 1.25rem;\n    margin-bottom: 1.25rem;\n  }\n  .sm\\:mx-5 {\n    margin-left: 1.25rem;\n    margin-right: 1.25rem;\n  }\n  .sm\\:my-6 {\n    margin-top: 1.5rem;\n    margin-bottom: 1.5rem;\n  }\n  .sm\\:mx-6 {\n    margin-left: 1.5rem;\n    margin-right: 1.5rem;\n  }\n  .sm\\:my-7 {\n    margin-top: 1.75rem;\n    margin-bottom: 1.75rem;\n  }\n  .sm\\:mx-7 {\n    margin-left: 1.75rem;\n    margin-right: 1.75rem;\n  }\n  .sm\\:my-8 {\n    margin-top: 2rem;\n    margin-bottom: 2rem;\n  }\n  .sm\\:mx-8 {\n    margin-left: 2rem;\n    margin-right: 2rem;\n  }\n  .sm\\:my-9 {\n    margin-top: 2.25rem;\n    margin-bottom: 2.25rem;\n  }\n  .sm\\:mx-9 {\n    margin-left: 2.25rem;\n    margin-right: 2.25rem;\n  }\n  .sm\\:my-10 {\n    margin-top: 2.5rem;\n    margin-bottom: 2.5rem;\n  }\n  .sm\\:mx-10 {\n    margin-left: 2.5rem;\n    margin-right: 2.5rem;\n  }\n  .sm\\:my-11 {\n    margin-top: 2.75rem;\n    margin-bottom: 2.75rem;\n  }\n  .sm\\:mx-11 {\n    margin-left: 2.75rem;\n    margin-right: 2.75rem;\n  }\n  .sm\\:my-12 {\n    margin-top: 3rem;\n    margin-bottom: 3rem;\n  }\n  .sm\\:mx-12 {\n    margin-left: 3rem;\n    margin-right: 3rem;\n  }\n  .sm\\:my-13 {\n    margin-top: 3.25rem;\n    margin-bottom: 3.25rem;\n  }\n  .sm\\:mx-13 {\n    margin-left: 3.25rem;\n    margin-right: 3.25rem;\n  }\n  .sm\\:my-14 {\n    margin-top: 3.5rem;\n    margin-bottom: 3.5rem;\n  }\n  .sm\\:mx-14 {\n    margin-left: 3.5rem;\n    margin-right: 3.5rem;\n  }\n  .sm\\:my-15 {\n    margin-top: 3.75rem;\n    margin-bottom: 3.75rem;\n  }\n  .sm\\:mx-15 {\n    margin-left: 3.75rem;\n    margin-right: 3.75rem;\n  }\n  .sm\\:my-16 {\n    margin-top: 4rem;\n    margin-bottom: 4rem;\n  }\n  .sm\\:mx-16 {\n    margin-left: 4rem;\n    margin-right: 4rem;\n  }\n  .sm\\:my-20 {\n    margin-top: 5rem;\n    margin-bottom: 5rem;\n  }\n  .sm\\:mx-20 {\n    margin-left: 5rem;\n    margin-right: 5rem;\n  }\n  .sm\\:my-24 {\n    margin-top: 6rem;\n    margin-bottom: 6rem;\n  }\n  .sm\\:mx-24 {\n    margin-left: 6rem;\n    margin-right: 6rem;\n  }\n  .sm\\:my-28 {\n    margin-top: 7rem;\n    margin-bottom: 7rem;\n  }\n  .sm\\:mx-28 {\n    margin-left: 7rem;\n    margin-right: 7rem;\n  }\n  .sm\\:my-32 {\n    margin-top: 8rem;\n    margin-bottom: 8rem;\n  }\n  .sm\\:mx-32 {\n    margin-left: 8rem;\n    margin-right: 8rem;\n  }\n  .sm\\:my-36 {\n    margin-top: 9rem;\n    margin-bottom: 9rem;\n  }\n  .sm\\:mx-36 {\n    margin-left: 9rem;\n    margin-right: 9rem;\n  }\n  .sm\\:my-40 {\n    margin-top: 10rem;\n    margin-bottom: 10rem;\n  }\n  .sm\\:mx-40 {\n    margin-left: 10rem;\n    margin-right: 10rem;\n  }\n  .sm\\:my-44 {\n    margin-top: 11rem;\n    margin-bottom: 11rem;\n  }\n  .sm\\:mx-44 {\n    margin-left: 11rem;\n    margin-right: 11rem;\n  }\n  .sm\\:my-48 {\n    margin-top: 12rem;\n    margin-bottom: 12rem;\n  }\n  .sm\\:mx-48 {\n    margin-left: 12rem;\n    margin-right: 12rem;\n  }\n  .sm\\:my-52 {\n    margin-top: 13rem;\n    margin-bottom: 13rem;\n  }\n  .sm\\:mx-52 {\n    margin-left: 13rem;\n    margin-right: 13rem;\n  }\n  .sm\\:my-56 {\n    margin-top: 14rem;\n    margin-bottom: 14rem;\n  }\n  .sm\\:mx-56 {\n    margin-left: 14rem;\n    margin-right: 14rem;\n  }\n  .sm\\:my-60 {\n    margin-top: 15rem;\n    margin-bottom: 15rem;\n  }\n  .sm\\:mx-60 {\n    margin-left: 15rem;\n    margin-right: 15rem;\n  }\n  .sm\\:my-64 {\n    margin-top: 16rem;\n    margin-bottom: 16rem;\n  }\n  .sm\\:mx-64 {\n    margin-left: 16rem;\n    margin-right: 16rem;\n  }\n  .sm\\:my-72 {\n    margin-top: 18rem;\n    margin-bottom: 18rem;\n  }\n  .sm\\:mx-72 {\n    margin-left: 18rem;\n    margin-right: 18rem;\n  }\n  .sm\\:my-80 {\n    margin-top: 20rem;\n    margin-bottom: 20rem;\n  }\n  .sm\\:mx-80 {\n    margin-left: 20rem;\n    margin-right: 20rem;\n  }\n  .sm\\:my-96 {\n    margin-top: 24rem;\n    margin-bottom: 24rem;\n  }\n  .sm\\:mx-96 {\n    margin-left: 24rem;\n    margin-right: 24rem;\n  }\n  .sm\\:my-auto {\n    margin-top: auto;\n    margin-bottom: auto;\n  }\n  .sm\\:mx-auto {\n    margin-left: auto;\n    margin-right: auto;\n  }\n  .sm\\:my-px {\n    margin-top: 1px;\n    margin-bottom: 1px;\n  }\n  .sm\\:mx-px {\n    margin-left: 1px;\n    margin-right: 1px;\n  }\n  .sm\\:my-0\\.5 {\n    margin-top: 0.125rem;\n    margin-bottom: 0.125rem;\n  }\n  .sm\\:mx-0\\.5 {\n    margin-left: 0.125rem;\n    margin-right: 0.125rem;\n  }\n  .sm\\:my-1\\.5 {\n    margin-top: 0.375rem;\n    margin-bottom: 0.375rem;\n  }\n  .sm\\:mx-1\\.5 {\n    margin-left: 0.375rem;\n    margin-right: 0.375rem;\n  }\n  .sm\\:my-2\\.5 {\n    margin-top: 0.625rem;\n    margin-bottom: 0.625rem;\n  }\n  .sm\\:mx-2\\.5 {\n    margin-left: 0.625rem;\n    margin-right: 0.625rem;\n  }\n  .sm\\:my-3\\.5 {\n    margin-top: 0.875rem;\n    margin-bottom: 0.875rem;\n  }\n  .sm\\:mx-3\\.5 {\n    margin-left: 0.875rem;\n    margin-right: 0.875rem;\n  }\n  .sm\\:my-1\\/2 {\n    margin-top: 50%;\n    margin-bottom: 50%;\n  }\n  .sm\\:mx-1\\/2 {\n    margin-left: 50%;\n    margin-right: 50%;\n  }\n  .sm\\:my-1\\/3 {\n    margin-top: 33.333333%;\n    margin-bottom: 33.333333%;\n  }\n  .sm\\:mx-1\\/3 {\n    margin-left: 33.333333%;\n    margin-right: 33.333333%;\n  }\n  .sm\\:my-2\\/3 {\n    margin-top: 66.666667%;\n    margin-bottom: 66.666667%;\n  }\n  .sm\\:mx-2\\/3 {\n    margin-left: 66.666667%;\n    margin-right: 66.666667%;\n  }\n  .sm\\:my-1\\/4 {\n    margin-top: 25%;\n    margin-bottom: 25%;\n  }\n  .sm\\:mx-1\\/4 {\n    margin-left: 25%;\n    margin-right: 25%;\n  }\n  .sm\\:my-2\\/4 {\n    margin-top: 50%;\n    margin-bottom: 50%;\n  }\n  .sm\\:mx-2\\/4 {\n    margin-left: 50%;\n    margin-right: 50%;\n  }\n  .sm\\:my-3\\/4 {\n    margin-top: 75%;\n    margin-bottom: 75%;\n  }\n  .sm\\:mx-3\\/4 {\n    margin-left: 75%;\n    margin-right: 75%;\n  }\n  .sm\\:my-1\\/5 {\n    margin-top: 20%;\n    margin-bottom: 20%;\n  }\n  .sm\\:mx-1\\/5 {\n    margin-left: 20%;\n    margin-right: 20%;\n  }\n  .sm\\:my-2\\/5 {\n    margin-top: 40%;\n    margin-bottom: 40%;\n  }\n  .sm\\:mx-2\\/5 {\n    margin-left: 40%;\n    margin-right: 40%;\n  }\n  .sm\\:my-3\\/5 {\n    margin-top: 60%;\n    margin-bottom: 60%;\n  }\n  .sm\\:mx-3\\/5 {\n    margin-left: 60%;\n    margin-right: 60%;\n  }\n  .sm\\:my-4\\/5 {\n    margin-top: 80%;\n    margin-bottom: 80%;\n  }\n  .sm\\:mx-4\\/5 {\n    margin-left: 80%;\n    margin-right: 80%;\n  }\n  .sm\\:my-1\\/6 {\n    margin-top: 16.666667%;\n    margin-bottom: 16.666667%;\n  }\n  .sm\\:mx-1\\/6 {\n    margin-left: 16.666667%;\n    margin-right: 16.666667%;\n  }\n  .sm\\:my-2\\/6 {\n    margin-top: 33.333333%;\n    margin-bottom: 33.333333%;\n  }\n  .sm\\:mx-2\\/6 {\n    margin-left: 33.333333%;\n    margin-right: 33.333333%;\n  }\n  .sm\\:my-3\\/6 {\n    margin-top: 50%;\n    margin-bottom: 50%;\n  }\n  .sm\\:mx-3\\/6 {\n    margin-left: 50%;\n    margin-right: 50%;\n  }\n  .sm\\:my-4\\/6 {\n    margin-top: 66.666667%;\n    margin-bottom: 66.666667%;\n  }\n  .sm\\:mx-4\\/6 {\n    margin-left: 66.666667%;\n    margin-right: 66.666667%;\n  }\n  .sm\\:my-5\\/6 {\n    margin-top: 83.333333%;\n    margin-bottom: 83.333333%;\n  }\n  .sm\\:mx-5\\/6 {\n    margin-left: 83.333333%;\n    margin-right: 83.333333%;\n  }\n  .sm\\:my-1\\/12 {\n    margin-top: 8.333333%;\n    margin-bottom: 8.333333%;\n  }\n  .sm\\:mx-1\\/12 {\n    margin-left: 8.333333%;\n    margin-right: 8.333333%;\n  }\n  .sm\\:my-2\\/12 {\n    margin-top: 16.666667%;\n    margin-bottom: 16.666667%;\n  }\n  .sm\\:mx-2\\/12 {\n    margin-left: 16.666667%;\n    margin-right: 16.666667%;\n  }\n  .sm\\:my-3\\/12 {\n    margin-top: 25%;\n    margin-bottom: 25%;\n  }\n  .sm\\:mx-3\\/12 {\n    margin-left: 25%;\n    margin-right: 25%;\n  }\n  .sm\\:my-4\\/12 {\n    margin-top: 33.333333%;\n    margin-bottom: 33.333333%;\n  }\n  .sm\\:mx-4\\/12 {\n    margin-left: 33.333333%;\n    margin-right: 33.333333%;\n  }\n  .sm\\:my-5\\/12 {\n    margin-top: 41.666667%;\n    margin-bottom: 41.666667%;\n  }\n  .sm\\:mx-5\\/12 {\n    margin-left: 41.666667%;\n    margin-right: 41.666667%;\n  }\n  .sm\\:my-6\\/12 {\n    margin-top: 50%;\n    margin-bottom: 50%;\n  }\n  .sm\\:mx-6\\/12 {\n    margin-left: 50%;\n    margin-right: 50%;\n  }\n  .sm\\:my-7\\/12 {\n    margin-top: 58.333333%;\n    margin-bottom: 58.333333%;\n  }\n  .sm\\:mx-7\\/12 {\n    margin-left: 58.333333%;\n    margin-right: 58.333333%;\n  }\n  .sm\\:my-8\\/12 {\n    margin-top: 66.666667%;\n    margin-bottom: 66.666667%;\n  }\n  .sm\\:mx-8\\/12 {\n    margin-left: 66.666667%;\n    margin-right: 66.666667%;\n  }\n  .sm\\:my-9\\/12 {\n    margin-top: 75%;\n    margin-bottom: 75%;\n  }\n  .sm\\:mx-9\\/12 {\n    margin-left: 75%;\n    margin-right: 75%;\n  }\n  .sm\\:my-10\\/12 {\n    margin-top: 83.333333%;\n    margin-bottom: 83.333333%;\n  }\n  .sm\\:mx-10\\/12 {\n    margin-left: 83.333333%;\n    margin-right: 83.333333%;\n  }\n  .sm\\:my-11\\/12 {\n    margin-top: 91.666667%;\n    margin-bottom: 91.666667%;\n  }\n  .sm\\:mx-11\\/12 {\n    margin-left: 91.666667%;\n    margin-right: 91.666667%;\n  }\n  .sm\\:my-full {\n    margin-top: 100%;\n    margin-bottom: 100%;\n  }\n  .sm\\:mx-full {\n    margin-left: 100%;\n    margin-right: 100%;\n  }\n  .sm\\:-my-1 {\n    margin-top: -0.25rem;\n    margin-bottom: -0.25rem;\n  }\n  .sm\\:-mx-1 {\n    margin-left: -0.25rem;\n    margin-right: -0.25rem;\n  }\n  .sm\\:-my-2 {\n    margin-top: -0.5rem;\n    margin-bottom: -0.5rem;\n  }\n  .sm\\:-mx-2 {\n    margin-left: -0.5rem;\n    margin-right: -0.5rem;\n  }\n  .sm\\:-my-3 {\n    margin-top: -0.75rem;\n    margin-bottom: -0.75rem;\n  }\n  .sm\\:-mx-3 {\n    margin-left: -0.75rem;\n    margin-right: -0.75rem;\n  }\n  .sm\\:-my-4 {\n    margin-top: -1rem;\n    margin-bottom: -1rem;\n  }\n  .sm\\:-mx-4 {\n    margin-left: -1rem;\n    margin-right: -1rem;\n  }\n  .sm\\:-my-5 {\n    margin-top: -1.25rem;\n    margin-bottom: -1.25rem;\n  }\n  .sm\\:-mx-5 {\n    margin-left: -1.25rem;\n    margin-right: -1.25rem;\n  }\n  .sm\\:-my-6 {\n    margin-top: -1.5rem;\n    margin-bottom: -1.5rem;\n  }\n  .sm\\:-mx-6 {\n    margin-left: -1.5rem;\n    margin-right: -1.5rem;\n  }\n  .sm\\:-my-7 {\n    margin-top: -1.75rem;\n    margin-bottom: -1.75rem;\n  }\n  .sm\\:-mx-7 {\n    margin-left: -1.75rem;\n    margin-right: -1.75rem;\n  }\n  .sm\\:-my-8 {\n    margin-top: -2rem;\n    margin-bottom: -2rem;\n  }\n  .sm\\:-mx-8 {\n    margin-left: -2rem;\n    margin-right: -2rem;\n  }\n  .sm\\:-my-9 {\n    margin-top: -2.25rem;\n    margin-bottom: -2.25rem;\n  }\n  .sm\\:-mx-9 {\n    margin-left: -2.25rem;\n    margin-right: -2.25rem;\n  }\n  .sm\\:-my-10 {\n    margin-top: -2.5rem;\n    margin-bottom: -2.5rem;\n  }\n  .sm\\:-mx-10 {\n    margin-left: -2.5rem;\n    margin-right: -2.5rem;\n  }\n  .sm\\:-my-11 {\n    margin-top: -2.75rem;\n    margin-bottom: -2.75rem;\n  }\n  .sm\\:-mx-11 {\n    margin-left: -2.75rem;\n    margin-right: -2.75rem;\n  }\n  .sm\\:-my-12 {\n    margin-top: -3rem;\n    margin-bottom: -3rem;\n  }\n  .sm\\:-mx-12 {\n    margin-left: -3rem;\n    margin-right: -3rem;\n  }\n  .sm\\:-my-13 {\n    margin-top: -3.25rem;\n    margin-bottom: -3.25rem;\n  }\n  .sm\\:-mx-13 {\n    margin-left: -3.25rem;\n    margin-right: -3.25rem;\n  }\n  .sm\\:-my-14 {\n    margin-top: -3.5rem;\n    margin-bottom: -3.5rem;\n  }\n  .sm\\:-mx-14 {\n    margin-left: -3.5rem;\n    margin-right: -3.5rem;\n  }\n  .sm\\:-my-15 {\n    margin-top: -3.75rem;\n    margin-bottom: -3.75rem;\n  }\n  .sm\\:-mx-15 {\n    margin-left: -3.75rem;\n    margin-right: -3.75rem;\n  }\n  .sm\\:-my-16 {\n    margin-top: -4rem;\n    margin-bottom: -4rem;\n  }\n  .sm\\:-mx-16 {\n    margin-left: -4rem;\n    margin-right: -4rem;\n  }\n  .sm\\:-my-20 {\n    margin-top: -5rem;\n    margin-bottom: -5rem;\n  }\n  .sm\\:-mx-20 {\n    margin-left: -5rem;\n    margin-right: -5rem;\n  }\n  .sm\\:-my-24 {\n    margin-top: -6rem;\n    margin-bottom: -6rem;\n  }\n  .sm\\:-mx-24 {\n    margin-left: -6rem;\n    margin-right: -6rem;\n  }\n  .sm\\:-my-28 {\n    margin-top: -7rem;\n    margin-bottom: -7rem;\n  }\n  .sm\\:-mx-28 {\n    margin-left: -7rem;\n    margin-right: -7rem;\n  }\n  .sm\\:-my-32 {\n    margin-top: -8rem;\n    margin-bottom: -8rem;\n  }\n  .sm\\:-mx-32 {\n    margin-left: -8rem;\n    margin-right: -8rem;\n  }\n  .sm\\:-my-36 {\n    margin-top: -9rem;\n    margin-bottom: -9rem;\n  }\n  .sm\\:-mx-36 {\n    margin-left: -9rem;\n    margin-right: -9rem;\n  }\n  .sm\\:-my-40 {\n    margin-top: -10rem;\n    margin-bottom: -10rem;\n  }\n  .sm\\:-mx-40 {\n    margin-left: -10rem;\n    margin-right: -10rem;\n  }\n  .sm\\:-my-44 {\n    margin-top: -11rem;\n    margin-bottom: -11rem;\n  }\n  .sm\\:-mx-44 {\n    margin-left: -11rem;\n    margin-right: -11rem;\n  }\n  .sm\\:-my-48 {\n    margin-top: -12rem;\n    margin-bottom: -12rem;\n  }\n  .sm\\:-mx-48 {\n    margin-left: -12rem;\n    margin-right: -12rem;\n  }\n  .sm\\:-my-52 {\n    margin-top: -13rem;\n    margin-bottom: -13rem;\n  }\n  .sm\\:-mx-52 {\n    margin-left: -13rem;\n    margin-right: -13rem;\n  }\n  .sm\\:-my-56 {\n    margin-top: -14rem;\n    margin-bottom: -14rem;\n  }\n  .sm\\:-mx-56 {\n    margin-left: -14rem;\n    margin-right: -14rem;\n  }\n  .sm\\:-my-60 {\n    margin-top: -15rem;\n    margin-bottom: -15rem;\n  }\n  .sm\\:-mx-60 {\n    margin-left: -15rem;\n    margin-right: -15rem;\n  }\n  .sm\\:-my-64 {\n    margin-top: -16rem;\n    margin-bottom: -16rem;\n  }\n  .sm\\:-mx-64 {\n    margin-left: -16rem;\n    margin-right: -16rem;\n  }\n  .sm\\:-my-72 {\n    margin-top: -18rem;\n    margin-bottom: -18rem;\n  }\n  .sm\\:-mx-72 {\n    margin-left: -18rem;\n    margin-right: -18rem;\n  }\n  .sm\\:-my-80 {\n    margin-top: -20rem;\n    margin-bottom: -20rem;\n  }\n  .sm\\:-mx-80 {\n    margin-left: -20rem;\n    margin-right: -20rem;\n  }\n  .sm\\:-my-96 {\n    margin-top: -24rem;\n    margin-bottom: -24rem;\n  }\n  .sm\\:-mx-96 {\n    margin-left: -24rem;\n    margin-right: -24rem;\n  }\n  .sm\\:-my-px {\n    margin-top: -1px;\n    margin-bottom: -1px;\n  }\n  .sm\\:-mx-px {\n    margin-left: -1px;\n    margin-right: -1px;\n  }\n  .sm\\:-my-0\\.5 {\n    margin-top: -0.125rem;\n    margin-bottom: -0.125rem;\n  }\n  .sm\\:-mx-0\\.5 {\n    margin-left: -0.125rem;\n    margin-right: -0.125rem;\n  }\n  .sm\\:-my-1\\.5 {\n    margin-top: -0.375rem;\n    margin-bottom: -0.375rem;\n  }\n  .sm\\:-mx-1\\.5 {\n    margin-left: -0.375rem;\n    margin-right: -0.375rem;\n  }\n  .sm\\:-my-2\\.5 {\n    margin-top: -0.625rem;\n    margin-bottom: -0.625rem;\n  }\n  .sm\\:-mx-2\\.5 {\n    margin-left: -0.625rem;\n    margin-right: -0.625rem;\n  }\n  .sm\\:-my-3\\.5 {\n    margin-top: -0.875rem;\n    margin-bottom: -0.875rem;\n  }\n  .sm\\:-mx-3\\.5 {\n    margin-left: -0.875rem;\n    margin-right: -0.875rem;\n  }\n  .sm\\:-my-1\\/2 {\n    margin-top: -50%;\n    margin-bottom: -50%;\n  }\n  .sm\\:-mx-1\\/2 {\n    margin-left: -50%;\n    margin-right: -50%;\n  }\n  .sm\\:-my-1\\/3 {\n    margin-top: -33.33333%;\n    margin-bottom: -33.33333%;\n  }\n  .sm\\:-mx-1\\/3 {\n    margin-left: -33.33333%;\n    margin-right: -33.33333%;\n  }\n  .sm\\:-my-2\\/3 {\n    margin-top: -66.66667%;\n    margin-bottom: -66.66667%;\n  }\n  .sm\\:-mx-2\\/3 {\n    margin-left: -66.66667%;\n    margin-right: -66.66667%;\n  }\n  .sm\\:-my-1\\/4 {\n    margin-top: -25%;\n    margin-bottom: -25%;\n  }\n  .sm\\:-mx-1\\/4 {\n    margin-left: -25%;\n    margin-right: -25%;\n  }\n  .sm\\:-my-2\\/4 {\n    margin-top: -50%;\n    margin-bottom: -50%;\n  }\n  .sm\\:-mx-2\\/4 {\n    margin-left: -50%;\n    margin-right: -50%;\n  }\n  .sm\\:-my-3\\/4 {\n    margin-top: -75%;\n    margin-bottom: -75%;\n  }\n  .sm\\:-mx-3\\/4 {\n    margin-left: -75%;\n    margin-right: -75%;\n  }\n  .sm\\:-my-1\\/5 {\n    margin-top: -20%;\n    margin-bottom: -20%;\n  }\n  .sm\\:-mx-1\\/5 {\n    margin-left: -20%;\n    margin-right: -20%;\n  }\n  .sm\\:-my-2\\/5 {\n    margin-top: -40%;\n    margin-bottom: -40%;\n  }\n  .sm\\:-mx-2\\/5 {\n    margin-left: -40%;\n    margin-right: -40%;\n  }\n  .sm\\:-my-3\\/5 {\n    margin-top: -60%;\n    margin-bottom: -60%;\n  }\n  .sm\\:-mx-3\\/5 {\n    margin-left: -60%;\n    margin-right: -60%;\n  }\n  .sm\\:-my-4\\/5 {\n    margin-top: -80%;\n    margin-bottom: -80%;\n  }\n  .sm\\:-mx-4\\/5 {\n    margin-left: -80%;\n    margin-right: -80%;\n  }\n  .sm\\:-my-1\\/6 {\n    margin-top: -16.66667%;\n    margin-bottom: -16.66667%;\n  }\n  .sm\\:-mx-1\\/6 {\n    margin-left: -16.66667%;\n    margin-right: -16.66667%;\n  }\n  .sm\\:-my-2\\/6 {\n    margin-top: -33.33333%;\n    margin-bottom: -33.33333%;\n  }\n  .sm\\:-mx-2\\/6 {\n    margin-left: -33.33333%;\n    margin-right: -33.33333%;\n  }\n  .sm\\:-my-3\\/6 {\n    margin-top: -50%;\n    margin-bottom: -50%;\n  }\n  .sm\\:-mx-3\\/6 {\n    margin-left: -50%;\n    margin-right: -50%;\n  }\n  .sm\\:-my-4\\/6 {\n    margin-top: -66.66667%;\n    margin-bottom: -66.66667%;\n  }\n  .sm\\:-mx-4\\/6 {\n    margin-left: -66.66667%;\n    margin-right: -66.66667%;\n  }\n  .sm\\:-my-5\\/6 {\n    margin-top: -83.33333%;\n    margin-bottom: -83.33333%;\n  }\n  .sm\\:-mx-5\\/6 {\n    margin-left: -83.33333%;\n    margin-right: -83.33333%;\n  }\n  .sm\\:-my-1\\/12 {\n    margin-top: -8.33333%;\n    margin-bottom: -8.33333%;\n  }\n  .sm\\:-mx-1\\/12 {\n    margin-left: -8.33333%;\n    margin-right: -8.33333%;\n  }\n  .sm\\:-my-2\\/12 {\n    margin-top: -16.66667%;\n    margin-bottom: -16.66667%;\n  }\n  .sm\\:-mx-2\\/12 {\n    margin-left: -16.66667%;\n    margin-right: -16.66667%;\n  }\n  .sm\\:-my-3\\/12 {\n    margin-top: -25%;\n    margin-bottom: -25%;\n  }\n  .sm\\:-mx-3\\/12 {\n    margin-left: -25%;\n    margin-right: -25%;\n  }\n  .sm\\:-my-4\\/12 {\n    margin-top: -33.33333%;\n    margin-bottom: -33.33333%;\n  }\n  .sm\\:-mx-4\\/12 {\n    margin-left: -33.33333%;\n    margin-right: -33.33333%;\n  }\n  .sm\\:-my-5\\/12 {\n    margin-top: -41.66667%;\n    margin-bottom: -41.66667%;\n  }\n  .sm\\:-mx-5\\/12 {\n    margin-left: -41.66667%;\n    margin-right: -41.66667%;\n  }\n  .sm\\:-my-6\\/12 {\n    margin-top: -50%;\n    margin-bottom: -50%;\n  }\n  .sm\\:-mx-6\\/12 {\n    margin-left: -50%;\n    margin-right: -50%;\n  }\n  .sm\\:-my-7\\/12 {\n    margin-top: -58.33333%;\n    margin-bottom: -58.33333%;\n  }\n  .sm\\:-mx-7\\/12 {\n    margin-left: -58.33333%;\n    margin-right: -58.33333%;\n  }\n  .sm\\:-my-8\\/12 {\n    margin-top: -66.66667%;\n    margin-bottom: -66.66667%;\n  }\n  .sm\\:-mx-8\\/12 {\n    margin-left: -66.66667%;\n    margin-right: -66.66667%;\n  }\n  .sm\\:-my-9\\/12 {\n    margin-top: -75%;\n    margin-bottom: -75%;\n  }\n  .sm\\:-mx-9\\/12 {\n    margin-left: -75%;\n    margin-right: -75%;\n  }\n  .sm\\:-my-10\\/12 {\n    margin-top: -83.33333%;\n    margin-bottom: -83.33333%;\n  }\n  .sm\\:-mx-10\\/12 {\n    margin-left: -83.33333%;\n    margin-right: -83.33333%;\n  }\n  .sm\\:-my-11\\/12 {\n    margin-top: -91.66667%;\n    margin-bottom: -91.66667%;\n  }\n  .sm\\:-mx-11\\/12 {\n    margin-left: -91.66667%;\n    margin-right: -91.66667%;\n  }\n  .sm\\:-my-full {\n    margin-top: -100%;\n    margin-bottom: -100%;\n  }\n  .sm\\:-mx-full {\n    margin-left: -100%;\n    margin-right: -100%;\n  }\n  .sm\\:mt-0 {\n    margin-top: 0;\n  }\n  .sm\\:mr-0 {\n    margin-right: 0;\n  }\n  .sm\\:mb-0 {\n    margin-bottom: 0;\n  }\n  .sm\\:ml-0 {\n    margin-left: 0;\n  }\n  .sm\\:mt-1 {\n    margin-top: 0.25rem;\n  }\n  .sm\\:mr-1 {\n    margin-right: 0.25rem;\n  }\n  .sm\\:mb-1 {\n    margin-bottom: 0.25rem;\n  }\n  .sm\\:ml-1 {\n    margin-left: 0.25rem;\n  }\n  .sm\\:mt-2 {\n    margin-top: 0.5rem;\n  }\n  .sm\\:mr-2 {\n    margin-right: 0.5rem;\n  }\n  .sm\\:mb-2 {\n    margin-bottom: 0.5rem;\n  }\n  .sm\\:ml-2 {\n    margin-left: 0.5rem;\n  }\n  .sm\\:mt-3 {\n    margin-top: 0.75rem;\n  }\n  .sm\\:mr-3 {\n    margin-right: 0.75rem;\n  }\n  .sm\\:mb-3 {\n    margin-bottom: 0.75rem;\n  }\n  .sm\\:ml-3 {\n    margin-left: 0.75rem;\n  }\n  .sm\\:mt-4 {\n    margin-top: 1rem;\n  }\n  .sm\\:mr-4 {\n    margin-right: 1rem;\n  }\n  .sm\\:mb-4 {\n    margin-bottom: 1rem;\n  }\n  .sm\\:ml-4 {\n    margin-left: 1rem;\n  }\n  .sm\\:mt-5 {\n    margin-top: 1.25rem;\n  }\n  .sm\\:mr-5 {\n    margin-right: 1.25rem;\n  }\n  .sm\\:mb-5 {\n    margin-bottom: 1.25rem;\n  }\n  .sm\\:ml-5 {\n    margin-left: 1.25rem;\n  }\n  .sm\\:mt-6 {\n    margin-top: 1.5rem;\n  }\n  .sm\\:mr-6 {\n    margin-right: 1.5rem;\n  }\n  .sm\\:mb-6 {\n    margin-bottom: 1.5rem;\n  }\n  .sm\\:ml-6 {\n    margin-left: 1.5rem;\n  }\n  .sm\\:mt-7 {\n    margin-top: 1.75rem;\n  }\n  .sm\\:mr-7 {\n    margin-right: 1.75rem;\n  }\n  .sm\\:mb-7 {\n    margin-bottom: 1.75rem;\n  }\n  .sm\\:ml-7 {\n    margin-left: 1.75rem;\n  }\n  .sm\\:mt-8 {\n    margin-top: 2rem;\n  }\n  .sm\\:mr-8 {\n    margin-right: 2rem;\n  }\n  .sm\\:mb-8 {\n    margin-bottom: 2rem;\n  }\n  .sm\\:ml-8 {\n    margin-left: 2rem;\n  }\n  .sm\\:mt-9 {\n    margin-top: 2.25rem;\n  }\n  .sm\\:mr-9 {\n    margin-right: 2.25rem;\n  }\n  .sm\\:mb-9 {\n    margin-bottom: 2.25rem;\n  }\n  .sm\\:ml-9 {\n    margin-left: 2.25rem;\n  }\n  .sm\\:mt-10 {\n    margin-top: 2.5rem;\n  }\n  .sm\\:mr-10 {\n    margin-right: 2.5rem;\n  }\n  .sm\\:mb-10 {\n    margin-bottom: 2.5rem;\n  }\n  .sm\\:ml-10 {\n    margin-left: 2.5rem;\n  }\n  .sm\\:mt-11 {\n    margin-top: 2.75rem;\n  }\n  .sm\\:mr-11 {\n    margin-right: 2.75rem;\n  }\n  .sm\\:mb-11 {\n    margin-bottom: 2.75rem;\n  }\n  .sm\\:ml-11 {\n    margin-left: 2.75rem;\n  }\n  .sm\\:mt-12 {\n    margin-top: 3rem;\n  }\n  .sm\\:mr-12 {\n    margin-right: 3rem;\n  }\n  .sm\\:mb-12 {\n    margin-bottom: 3rem;\n  }\n  .sm\\:ml-12 {\n    margin-left: 3rem;\n  }\n  .sm\\:mt-13 {\n    margin-top: 3.25rem;\n  }\n  .sm\\:mr-13 {\n    margin-right: 3.25rem;\n  }\n  .sm\\:mb-13 {\n    margin-bottom: 3.25rem;\n  }\n  .sm\\:ml-13 {\n    margin-left: 3.25rem;\n  }\n  .sm\\:mt-14 {\n    margin-top: 3.5rem;\n  }\n  .sm\\:mr-14 {\n    margin-right: 3.5rem;\n  }\n  .sm\\:mb-14 {\n    margin-bottom: 3.5rem;\n  }\n  .sm\\:ml-14 {\n    margin-left: 3.5rem;\n  }\n  .sm\\:mt-15 {\n    margin-top: 3.75rem;\n  }\n  .sm\\:mr-15 {\n    margin-right: 3.75rem;\n  }\n  .sm\\:mb-15 {\n    margin-bottom: 3.75rem;\n  }\n  .sm\\:ml-15 {\n    margin-left: 3.75rem;\n  }\n  .sm\\:mt-16 {\n    margin-top: 4rem;\n  }\n  .sm\\:mr-16 {\n    margin-right: 4rem;\n  }\n  .sm\\:mb-16 {\n    margin-bottom: 4rem;\n  }\n  .sm\\:ml-16 {\n    margin-left: 4rem;\n  }\n  .sm\\:mt-20 {\n    margin-top: 5rem;\n  }\n  .sm\\:mr-20 {\n    margin-right: 5rem;\n  }\n  .sm\\:mb-20 {\n    margin-bottom: 5rem;\n  }\n  .sm\\:ml-20 {\n    margin-left: 5rem;\n  }\n  .sm\\:mt-24 {\n    margin-top: 6rem;\n  }\n  .sm\\:mr-24 {\n    margin-right: 6rem;\n  }\n  .sm\\:mb-24 {\n    margin-bottom: 6rem;\n  }\n  .sm\\:ml-24 {\n    margin-left: 6rem;\n  }\n  .sm\\:mt-28 {\n    margin-top: 7rem;\n  }\n  .sm\\:mr-28 {\n    margin-right: 7rem;\n  }\n  .sm\\:mb-28 {\n    margin-bottom: 7rem;\n  }\n  .sm\\:ml-28 {\n    margin-left: 7rem;\n  }\n  .sm\\:mt-32 {\n    margin-top: 8rem;\n  }\n  .sm\\:mr-32 {\n    margin-right: 8rem;\n  }\n  .sm\\:mb-32 {\n    margin-bottom: 8rem;\n  }\n  .sm\\:ml-32 {\n    margin-left: 8rem;\n  }\n  .sm\\:mt-36 {\n    margin-top: 9rem;\n  }\n  .sm\\:mr-36 {\n    margin-right: 9rem;\n  }\n  .sm\\:mb-36 {\n    margin-bottom: 9rem;\n  }\n  .sm\\:ml-36 {\n    margin-left: 9rem;\n  }\n  .sm\\:mt-40 {\n    margin-top: 10rem;\n  }\n  .sm\\:mr-40 {\n    margin-right: 10rem;\n  }\n  .sm\\:mb-40 {\n    margin-bottom: 10rem;\n  }\n  .sm\\:ml-40 {\n    margin-left: 10rem;\n  }\n  .sm\\:mt-44 {\n    margin-top: 11rem;\n  }\n  .sm\\:mr-44 {\n    margin-right: 11rem;\n  }\n  .sm\\:mb-44 {\n    margin-bottom: 11rem;\n  }\n  .sm\\:ml-44 {\n    margin-left: 11rem;\n  }\n  .sm\\:mt-48 {\n    margin-top: 12rem;\n  }\n  .sm\\:mr-48 {\n    margin-right: 12rem;\n  }\n  .sm\\:mb-48 {\n    margin-bottom: 12rem;\n  }\n  .sm\\:ml-48 {\n    margin-left: 12rem;\n  }\n  .sm\\:mt-52 {\n    margin-top: 13rem;\n  }\n  .sm\\:mr-52 {\n    margin-right: 13rem;\n  }\n  .sm\\:mb-52 {\n    margin-bottom: 13rem;\n  }\n  .sm\\:ml-52 {\n    margin-left: 13rem;\n  }\n  .sm\\:mt-56 {\n    margin-top: 14rem;\n  }\n  .sm\\:mr-56 {\n    margin-right: 14rem;\n  }\n  .sm\\:mb-56 {\n    margin-bottom: 14rem;\n  }\n  .sm\\:ml-56 {\n    margin-left: 14rem;\n  }\n  .sm\\:mt-60 {\n    margin-top: 15rem;\n  }\n  .sm\\:mr-60 {\n    margin-right: 15rem;\n  }\n  .sm\\:mb-60 {\n    margin-bottom: 15rem;\n  }\n  .sm\\:ml-60 {\n    margin-left: 15rem;\n  }\n  .sm\\:mt-64 {\n    margin-top: 16rem;\n  }\n  .sm\\:mr-64 {\n    margin-right: 16rem;\n  }\n  .sm\\:mb-64 {\n    margin-bottom: 16rem;\n  }\n  .sm\\:ml-64 {\n    margin-left: 16rem;\n  }\n  .sm\\:mt-72 {\n    margin-top: 18rem;\n  }\n  .sm\\:mr-72 {\n    margin-right: 18rem;\n  }\n  .sm\\:mb-72 {\n    margin-bottom: 18rem;\n  }\n  .sm\\:ml-72 {\n    margin-left: 18rem;\n  }\n  .sm\\:mt-80 {\n    margin-top: 20rem;\n  }\n  .sm\\:mr-80 {\n    margin-right: 20rem;\n  }\n  .sm\\:mb-80 {\n    margin-bottom: 20rem;\n  }\n  .sm\\:ml-80 {\n    margin-left: 20rem;\n  }\n  .sm\\:mt-96 {\n    margin-top: 24rem;\n  }\n  .sm\\:mr-96 {\n    margin-right: 24rem;\n  }\n  .sm\\:mb-96 {\n    margin-bottom: 24rem;\n  }\n  .sm\\:ml-96 {\n    margin-left: 24rem;\n  }\n  .sm\\:mt-auto {\n    margin-top: auto;\n  }\n  .sm\\:mr-auto {\n    margin-right: auto;\n  }\n  .sm\\:mb-auto {\n    margin-bottom: auto;\n  }\n  .sm\\:ml-auto {\n    margin-left: auto;\n  }\n  .sm\\:mt-px {\n    margin-top: 1px;\n  }\n  .sm\\:mr-px {\n    margin-right: 1px;\n  }\n  .sm\\:mb-px {\n    margin-bottom: 1px;\n  }\n  .sm\\:ml-px {\n    margin-left: 1px;\n  }\n  .sm\\:mt-0\\.5 {\n    margin-top: 0.125rem;\n  }\n  .sm\\:mr-0\\.5 {\n    margin-right: 0.125rem;\n  }\n  .sm\\:mb-0\\.5 {\n    margin-bottom: 0.125rem;\n  }\n  .sm\\:ml-0\\.5 {\n    margin-left: 0.125rem;\n  }\n  .sm\\:mt-1\\.5 {\n    margin-top: 0.375rem;\n  }\n  .sm\\:mr-1\\.5 {\n    margin-right: 0.375rem;\n  }\n  .sm\\:mb-1\\.5 {\n    margin-bottom: 0.375rem;\n  }\n  .sm\\:ml-1\\.5 {\n    margin-left: 0.375rem;\n  }\n  .sm\\:mt-2\\.5 {\n    margin-top: 0.625rem;\n  }\n  .sm\\:mr-2\\.5 {\n    margin-right: 0.625rem;\n  }\n  .sm\\:mb-2\\.5 {\n    margin-bottom: 0.625rem;\n  }\n  .sm\\:ml-2\\.5 {\n    margin-left: 0.625rem;\n  }\n  .sm\\:mt-3\\.5 {\n    margin-top: 0.875rem;\n  }\n  .sm\\:mr-3\\.5 {\n    margin-right: 0.875rem;\n  }\n  .sm\\:mb-3\\.5 {\n    margin-bottom: 0.875rem;\n  }\n  .sm\\:ml-3\\.5 {\n    margin-left: 0.875rem;\n  }\n  .sm\\:mt-1\\/2 {\n    margin-top: 50%;\n  }\n  .sm\\:mr-1\\/2 {\n    margin-right: 50%;\n  }\n  .sm\\:mb-1\\/2 {\n    margin-bottom: 50%;\n  }\n  .sm\\:ml-1\\/2 {\n    margin-left: 50%;\n  }\n  .sm\\:mt-1\\/3 {\n    margin-top: 33.333333%;\n  }\n  .sm\\:mr-1\\/3 {\n    margin-right: 33.333333%;\n  }\n  .sm\\:mb-1\\/3 {\n    margin-bottom: 33.333333%;\n  }\n  .sm\\:ml-1\\/3 {\n    margin-left: 33.333333%;\n  }\n  .sm\\:mt-2\\/3 {\n    margin-top: 66.666667%;\n  }\n  .sm\\:mr-2\\/3 {\n    margin-right: 66.666667%;\n  }\n  .sm\\:mb-2\\/3 {\n    margin-bottom: 66.666667%;\n  }\n  .sm\\:ml-2\\/3 {\n    margin-left: 66.666667%;\n  }\n  .sm\\:mt-1\\/4 {\n    margin-top: 25%;\n  }\n  .sm\\:mr-1\\/4 {\n    margin-right: 25%;\n  }\n  .sm\\:mb-1\\/4 {\n    margin-bottom: 25%;\n  }\n  .sm\\:ml-1\\/4 {\n    margin-left: 25%;\n  }\n  .sm\\:mt-2\\/4 {\n    margin-top: 50%;\n  }\n  .sm\\:mr-2\\/4 {\n    margin-right: 50%;\n  }\n  .sm\\:mb-2\\/4 {\n    margin-bottom: 50%;\n  }\n  .sm\\:ml-2\\/4 {\n    margin-left: 50%;\n  }\n  .sm\\:mt-3\\/4 {\n    margin-top: 75%;\n  }\n  .sm\\:mr-3\\/4 {\n    margin-right: 75%;\n  }\n  .sm\\:mb-3\\/4 {\n    margin-bottom: 75%;\n  }\n  .sm\\:ml-3\\/4 {\n    margin-left: 75%;\n  }\n  .sm\\:mt-1\\/5 {\n    margin-top: 20%;\n  }\n  .sm\\:mr-1\\/5 {\n    margin-right: 20%;\n  }\n  .sm\\:mb-1\\/5 {\n    margin-bottom: 20%;\n  }\n  .sm\\:ml-1\\/5 {\n    margin-left: 20%;\n  }\n  .sm\\:mt-2\\/5 {\n    margin-top: 40%;\n  }\n  .sm\\:mr-2\\/5 {\n    margin-right: 40%;\n  }\n  .sm\\:mb-2\\/5 {\n    margin-bottom: 40%;\n  }\n  .sm\\:ml-2\\/5 {\n    margin-left: 40%;\n  }\n  .sm\\:mt-3\\/5 {\n    margin-top: 60%;\n  }\n  .sm\\:mr-3\\/5 {\n    margin-right: 60%;\n  }\n  .sm\\:mb-3\\/5 {\n    margin-bottom: 60%;\n  }\n  .sm\\:ml-3\\/5 {\n    margin-left: 60%;\n  }\n  .sm\\:mt-4\\/5 {\n    margin-top: 80%;\n  }\n  .sm\\:mr-4\\/5 {\n    margin-right: 80%;\n  }\n  .sm\\:mb-4\\/5 {\n    margin-bottom: 80%;\n  }\n  .sm\\:ml-4\\/5 {\n    margin-left: 80%;\n  }\n  .sm\\:mt-1\\/6 {\n    margin-top: 16.666667%;\n  }\n  .sm\\:mr-1\\/6 {\n    margin-right: 16.666667%;\n  }\n  .sm\\:mb-1\\/6 {\n    margin-bottom: 16.666667%;\n  }\n  .sm\\:ml-1\\/6 {\n    margin-left: 16.666667%;\n  }\n  .sm\\:mt-2\\/6 {\n    margin-top: 33.333333%;\n  }\n  .sm\\:mr-2\\/6 {\n    margin-right: 33.333333%;\n  }\n  .sm\\:mb-2\\/6 {\n    margin-bottom: 33.333333%;\n  }\n  .sm\\:ml-2\\/6 {\n    margin-left: 33.333333%;\n  }\n  .sm\\:mt-3\\/6 {\n    margin-top: 50%;\n  }\n  .sm\\:mr-3\\/6 {\n    margin-right: 50%;\n  }\n  .sm\\:mb-3\\/6 {\n    margin-bottom: 50%;\n  }\n  .sm\\:ml-3\\/6 {\n    margin-left: 50%;\n  }\n  .sm\\:mt-4\\/6 {\n    margin-top: 66.666667%;\n  }\n  .sm\\:mr-4\\/6 {\n    margin-right: 66.666667%;\n  }\n  .sm\\:mb-4\\/6 {\n    margin-bottom: 66.666667%;\n  }\n  .sm\\:ml-4\\/6 {\n    margin-left: 66.666667%;\n  }\n  .sm\\:mt-5\\/6 {\n    margin-top: 83.333333%;\n  }\n  .sm\\:mr-5\\/6 {\n    margin-right: 83.333333%;\n  }\n  .sm\\:mb-5\\/6 {\n    margin-bottom: 83.333333%;\n  }\n  .sm\\:ml-5\\/6 {\n    margin-left: 83.333333%;\n  }\n  .sm\\:mt-1\\/12 {\n    margin-top: 8.333333%;\n  }\n  .sm\\:mr-1\\/12 {\n    margin-right: 8.333333%;\n  }\n  .sm\\:mb-1\\/12 {\n    margin-bottom: 8.333333%;\n  }\n  .sm\\:ml-1\\/12 {\n    margin-left: 8.333333%;\n  }\n  .sm\\:mt-2\\/12 {\n    margin-top: 16.666667%;\n  }\n  .sm\\:mr-2\\/12 {\n    margin-right: 16.666667%;\n  }\n  .sm\\:mb-2\\/12 {\n    margin-bottom: 16.666667%;\n  }\n  .sm\\:ml-2\\/12 {\n    margin-left: 16.666667%;\n  }\n  .sm\\:mt-3\\/12 {\n    margin-top: 25%;\n  }\n  .sm\\:mr-3\\/12 {\n    margin-right: 25%;\n  }\n  .sm\\:mb-3\\/12 {\n    margin-bottom: 25%;\n  }\n  .sm\\:ml-3\\/12 {\n    margin-left: 25%;\n  }\n  .sm\\:mt-4\\/12 {\n    margin-top: 33.333333%;\n  }\n  .sm\\:mr-4\\/12 {\n    margin-right: 33.333333%;\n  }\n  .sm\\:mb-4\\/12 {\n    margin-bottom: 33.333333%;\n  }\n  .sm\\:ml-4\\/12 {\n    margin-left: 33.333333%;\n  }\n  .sm\\:mt-5\\/12 {\n    margin-top: 41.666667%;\n  }\n  .sm\\:mr-5\\/12 {\n    margin-right: 41.666667%;\n  }\n  .sm\\:mb-5\\/12 {\n    margin-bottom: 41.666667%;\n  }\n  .sm\\:ml-5\\/12 {\n    margin-left: 41.666667%;\n  }\n  .sm\\:mt-6\\/12 {\n    margin-top: 50%;\n  }\n  .sm\\:mr-6\\/12 {\n    margin-right: 50%;\n  }\n  .sm\\:mb-6\\/12 {\n    margin-bottom: 50%;\n  }\n  .sm\\:ml-6\\/12 {\n    margin-left: 50%;\n  }\n  .sm\\:mt-7\\/12 {\n    margin-top: 58.333333%;\n  }\n  .sm\\:mr-7\\/12 {\n    margin-right: 58.333333%;\n  }\n  .sm\\:mb-7\\/12 {\n    margin-bottom: 58.333333%;\n  }\n  .sm\\:ml-7\\/12 {\n    margin-left: 58.333333%;\n  }\n  .sm\\:mt-8\\/12 {\n    margin-top: 66.666667%;\n  }\n  .sm\\:mr-8\\/12 {\n    margin-right: 66.666667%;\n  }\n  .sm\\:mb-8\\/12 {\n    margin-bottom: 66.666667%;\n  }\n  .sm\\:ml-8\\/12 {\n    margin-left: 66.666667%;\n  }\n  .sm\\:mt-9\\/12 {\n    margin-top: 75%;\n  }\n  .sm\\:mr-9\\/12 {\n    margin-right: 75%;\n  }\n  .sm\\:mb-9\\/12 {\n    margin-bottom: 75%;\n  }\n  .sm\\:ml-9\\/12 {\n    margin-left: 75%;\n  }\n  .sm\\:mt-10\\/12 {\n    margin-top: 83.333333%;\n  }\n  .sm\\:mr-10\\/12 {\n    margin-right: 83.333333%;\n  }\n  .sm\\:mb-10\\/12 {\n    margin-bottom: 83.333333%;\n  }\n  .sm\\:ml-10\\/12 {\n    margin-left: 83.333333%;\n  }\n  .sm\\:mt-11\\/12 {\n    margin-top: 91.666667%;\n  }\n  .sm\\:mr-11\\/12 {\n    margin-right: 91.666667%;\n  }\n  .sm\\:mb-11\\/12 {\n    margin-bottom: 91.666667%;\n  }\n  .sm\\:ml-11\\/12 {\n    margin-left: 91.666667%;\n  }\n  .sm\\:mt-full {\n    margin-top: 100%;\n  }\n  .sm\\:mr-full {\n    margin-right: 100%;\n  }\n  .sm\\:mb-full {\n    margin-bottom: 100%;\n  }\n  .sm\\:ml-full {\n    margin-left: 100%;\n  }\n  .sm\\:-mt-1 {\n    margin-top: -0.25rem;\n  }\n  .sm\\:-mr-1 {\n    margin-right: -0.25rem;\n  }\n  .sm\\:-mb-1 {\n    margin-bottom: -0.25rem;\n  }\n  .sm\\:-ml-1 {\n    margin-left: -0.25rem;\n  }\n  .sm\\:-mt-2 {\n    margin-top: -0.5rem;\n  }\n  .sm\\:-mr-2 {\n    margin-right: -0.5rem;\n  }\n  .sm\\:-mb-2 {\n    margin-bottom: -0.5rem;\n  }\n  .sm\\:-ml-2 {\n    margin-left: -0.5rem;\n  }\n  .sm\\:-mt-3 {\n    margin-top: -0.75rem;\n  }\n  .sm\\:-mr-3 {\n    margin-right: -0.75rem;\n  }\n  .sm\\:-mb-3 {\n    margin-bottom: -0.75rem;\n  }\n  .sm\\:-ml-3 {\n    margin-left: -0.75rem;\n  }\n  .sm\\:-mt-4 {\n    margin-top: -1rem;\n  }\n  .sm\\:-mr-4 {\n    margin-right: -1rem;\n  }\n  .sm\\:-mb-4 {\n    margin-bottom: -1rem;\n  }\n  .sm\\:-ml-4 {\n    margin-left: -1rem;\n  }\n  .sm\\:-mt-5 {\n    margin-top: -1.25rem;\n  }\n  .sm\\:-mr-5 {\n    margin-right: -1.25rem;\n  }\n  .sm\\:-mb-5 {\n    margin-bottom: -1.25rem;\n  }\n  .sm\\:-ml-5 {\n    margin-left: -1.25rem;\n  }\n  .sm\\:-mt-6 {\n    margin-top: -1.5rem;\n  }\n  .sm\\:-mr-6 {\n    margin-right: -1.5rem;\n  }\n  .sm\\:-mb-6 {\n    margin-bottom: -1.5rem;\n  }\n  .sm\\:-ml-6 {\n    margin-left: -1.5rem;\n  }\n  .sm\\:-mt-7 {\n    margin-top: -1.75rem;\n  }\n  .sm\\:-mr-7 {\n    margin-right: -1.75rem;\n  }\n  .sm\\:-mb-7 {\n    margin-bottom: -1.75rem;\n  }\n  .sm\\:-ml-7 {\n    margin-left: -1.75rem;\n  }\n  .sm\\:-mt-8 {\n    margin-top: -2rem;\n  }\n  .sm\\:-mr-8 {\n    margin-right: -2rem;\n  }\n  .sm\\:-mb-8 {\n    margin-bottom: -2rem;\n  }\n  .sm\\:-ml-8 {\n    margin-left: -2rem;\n  }\n  .sm\\:-mt-9 {\n    margin-top: -2.25rem;\n  }\n  .sm\\:-mr-9 {\n    margin-right: -2.25rem;\n  }\n  .sm\\:-mb-9 {\n    margin-bottom: -2.25rem;\n  }\n  .sm\\:-ml-9 {\n    margin-left: -2.25rem;\n  }\n  .sm\\:-mt-10 {\n    margin-top: -2.5rem;\n  }\n  .sm\\:-mr-10 {\n    margin-right: -2.5rem;\n  }\n  .sm\\:-mb-10 {\n    margin-bottom: -2.5rem;\n  }\n  .sm\\:-ml-10 {\n    margin-left: -2.5rem;\n  }\n  .sm\\:-mt-11 {\n    margin-top: -2.75rem;\n  }\n  .sm\\:-mr-11 {\n    margin-right: -2.75rem;\n  }\n  .sm\\:-mb-11 {\n    margin-bottom: -2.75rem;\n  }\n  .sm\\:-ml-11 {\n    margin-left: -2.75rem;\n  }\n  .sm\\:-mt-12 {\n    margin-top: -3rem;\n  }\n  .sm\\:-mr-12 {\n    margin-right: -3rem;\n  }\n  .sm\\:-mb-12 {\n    margin-bottom: -3rem;\n  }\n  .sm\\:-ml-12 {\n    margin-left: -3rem;\n  }\n  .sm\\:-mt-13 {\n    margin-top: -3.25rem;\n  }\n  .sm\\:-mr-13 {\n    margin-right: -3.25rem;\n  }\n  .sm\\:-mb-13 {\n    margin-bottom: -3.25rem;\n  }\n  .sm\\:-ml-13 {\n    margin-left: -3.25rem;\n  }\n  .sm\\:-mt-14 {\n    margin-top: -3.5rem;\n  }\n  .sm\\:-mr-14 {\n    margin-right: -3.5rem;\n  }\n  .sm\\:-mb-14 {\n    margin-bottom: -3.5rem;\n  }\n  .sm\\:-ml-14 {\n    margin-left: -3.5rem;\n  }\n  .sm\\:-mt-15 {\n    margin-top: -3.75rem;\n  }\n  .sm\\:-mr-15 {\n    margin-right: -3.75rem;\n  }\n  .sm\\:-mb-15 {\n    margin-bottom: -3.75rem;\n  }\n  .sm\\:-ml-15 {\n    margin-left: -3.75rem;\n  }\n  .sm\\:-mt-16 {\n    margin-top: -4rem;\n  }\n  .sm\\:-mr-16 {\n    margin-right: -4rem;\n  }\n  .sm\\:-mb-16 {\n    margin-bottom: -4rem;\n  }\n  .sm\\:-ml-16 {\n    margin-left: -4rem;\n  }\n  .sm\\:-mt-20 {\n    margin-top: -5rem;\n  }\n  .sm\\:-mr-20 {\n    margin-right: -5rem;\n  }\n  .sm\\:-mb-20 {\n    margin-bottom: -5rem;\n  }\n  .sm\\:-ml-20 {\n    margin-left: -5rem;\n  }\n  .sm\\:-mt-24 {\n    margin-top: -6rem;\n  }\n  .sm\\:-mr-24 {\n    margin-right: -6rem;\n  }\n  .sm\\:-mb-24 {\n    margin-bottom: -6rem;\n  }\n  .sm\\:-ml-24 {\n    margin-left: -6rem;\n  }\n  .sm\\:-mt-28 {\n    margin-top: -7rem;\n  }\n  .sm\\:-mr-28 {\n    margin-right: -7rem;\n  }\n  .sm\\:-mb-28 {\n    margin-bottom: -7rem;\n  }\n  .sm\\:-ml-28 {\n    margin-left: -7rem;\n  }\n  .sm\\:-mt-32 {\n    margin-top: -8rem;\n  }\n  .sm\\:-mr-32 {\n    margin-right: -8rem;\n  }\n  .sm\\:-mb-32 {\n    margin-bottom: -8rem;\n  }\n  .sm\\:-ml-32 {\n    margin-left: -8rem;\n  }\n  .sm\\:-mt-36 {\n    margin-top: -9rem;\n  }\n  .sm\\:-mr-36 {\n    margin-right: -9rem;\n  }\n  .sm\\:-mb-36 {\n    margin-bottom: -9rem;\n  }\n  .sm\\:-ml-36 {\n    margin-left: -9rem;\n  }\n  .sm\\:-mt-40 {\n    margin-top: -10rem;\n  }\n  .sm\\:-mr-40 {\n    margin-right: -10rem;\n  }\n  .sm\\:-mb-40 {\n    margin-bottom: -10rem;\n  }\n  .sm\\:-ml-40 {\n    margin-left: -10rem;\n  }\n  .sm\\:-mt-44 {\n    margin-top: -11rem;\n  }\n  .sm\\:-mr-44 {\n    margin-right: -11rem;\n  }\n  .sm\\:-mb-44 {\n    margin-bottom: -11rem;\n  }\n  .sm\\:-ml-44 {\n    margin-left: -11rem;\n  }\n  .sm\\:-mt-48 {\n    margin-top: -12rem;\n  }\n  .sm\\:-mr-48 {\n    margin-right: -12rem;\n  }\n  .sm\\:-mb-48 {\n    margin-bottom: -12rem;\n  }\n  .sm\\:-ml-48 {\n    margin-left: -12rem;\n  }\n  .sm\\:-mt-52 {\n    margin-top: -13rem;\n  }\n  .sm\\:-mr-52 {\n    margin-right: -13rem;\n  }\n  .sm\\:-mb-52 {\n    margin-bottom: -13rem;\n  }\n  .sm\\:-ml-52 {\n    margin-left: -13rem;\n  }\n  .sm\\:-mt-56 {\n    margin-top: -14rem;\n  }\n  .sm\\:-mr-56 {\n    margin-right: -14rem;\n  }\n  .sm\\:-mb-56 {\n    margin-bottom: -14rem;\n  }\n  .sm\\:-ml-56 {\n    margin-left: -14rem;\n  }\n  .sm\\:-mt-60 {\n    margin-top: -15rem;\n  }\n  .sm\\:-mr-60 {\n    margin-right: -15rem;\n  }\n  .sm\\:-mb-60 {\n    margin-bottom: -15rem;\n  }\n  .sm\\:-ml-60 {\n    margin-left: -15rem;\n  }\n  .sm\\:-mt-64 {\n    margin-top: -16rem;\n  }\n  .sm\\:-mr-64 {\n    margin-right: -16rem;\n  }\n  .sm\\:-mb-64 {\n    margin-bottom: -16rem;\n  }\n  .sm\\:-ml-64 {\n    margin-left: -16rem;\n  }\n  .sm\\:-mt-72 {\n    margin-top: -18rem;\n  }\n  .sm\\:-mr-72 {\n    margin-right: -18rem;\n  }\n  .sm\\:-mb-72 {\n    margin-bottom: -18rem;\n  }\n  .sm\\:-ml-72 {\n    margin-left: -18rem;\n  }\n  .sm\\:-mt-80 {\n    margin-top: -20rem;\n  }\n  .sm\\:-mr-80 {\n    margin-right: -20rem;\n  }\n  .sm\\:-mb-80 {\n    margin-bottom: -20rem;\n  }\n  .sm\\:-ml-80 {\n    margin-left: -20rem;\n  }\n  .sm\\:-mt-96 {\n    margin-top: -24rem;\n  }\n  .sm\\:-mr-96 {\n    margin-right: -24rem;\n  }\n  .sm\\:-mb-96 {\n    margin-bottom: -24rem;\n  }\n  .sm\\:-ml-96 {\n    margin-left: -24rem;\n  }\n  .sm\\:-mt-px {\n    margin-top: -1px;\n  }\n  .sm\\:-mr-px {\n    margin-right: -1px;\n  }\n  .sm\\:-mb-px {\n    margin-bottom: -1px;\n  }\n  .sm\\:-ml-px {\n    margin-left: -1px;\n  }\n  .sm\\:-mt-0\\.5 {\n    margin-top: -0.125rem;\n  }\n  .sm\\:-mr-0\\.5 {\n    margin-right: -0.125rem;\n  }\n  .sm\\:-mb-0\\.5 {\n    margin-bottom: -0.125rem;\n  }\n  .sm\\:-ml-0\\.5 {\n    margin-left: -0.125rem;\n  }\n  .sm\\:-mt-1\\.5 {\n    margin-top: -0.375rem;\n  }\n  .sm\\:-mr-1\\.5 {\n    margin-right: -0.375rem;\n  }\n  .sm\\:-mb-1\\.5 {\n    margin-bottom: -0.375rem;\n  }\n  .sm\\:-ml-1\\.5 {\n    margin-left: -0.375rem;\n  }\n  .sm\\:-mt-2\\.5 {\n    margin-top: -0.625rem;\n  }\n  .sm\\:-mr-2\\.5 {\n    margin-right: -0.625rem;\n  }\n  .sm\\:-mb-2\\.5 {\n    margin-bottom: -0.625rem;\n  }\n  .sm\\:-ml-2\\.5 {\n    margin-left: -0.625rem;\n  }\n  .sm\\:-mt-3\\.5 {\n    margin-top: -0.875rem;\n  }\n  .sm\\:-mr-3\\.5 {\n    margin-right: -0.875rem;\n  }\n  .sm\\:-mb-3\\.5 {\n    margin-bottom: -0.875rem;\n  }\n  .sm\\:-ml-3\\.5 {\n    margin-left: -0.875rem;\n  }\n  .sm\\:-mt-1\\/2 {\n    margin-top: -50%;\n  }\n  .sm\\:-mr-1\\/2 {\n    margin-right: -50%;\n  }\n  .sm\\:-mb-1\\/2 {\n    margin-bottom: -50%;\n  }\n  .sm\\:-ml-1\\/2 {\n    margin-left: -50%;\n  }\n  .sm\\:-mt-1\\/3 {\n    margin-top: -33.33333%;\n  }\n  .sm\\:-mr-1\\/3 {\n    margin-right: -33.33333%;\n  }\n  .sm\\:-mb-1\\/3 {\n    margin-bottom: -33.33333%;\n  }\n  .sm\\:-ml-1\\/3 {\n    margin-left: -33.33333%;\n  }\n  .sm\\:-mt-2\\/3 {\n    margin-top: -66.66667%;\n  }\n  .sm\\:-mr-2\\/3 {\n    margin-right: -66.66667%;\n  }\n  .sm\\:-mb-2\\/3 {\n    margin-bottom: -66.66667%;\n  }\n  .sm\\:-ml-2\\/3 {\n    margin-left: -66.66667%;\n  }\n  .sm\\:-mt-1\\/4 {\n    margin-top: -25%;\n  }\n  .sm\\:-mr-1\\/4 {\n    margin-right: -25%;\n  }\n  .sm\\:-mb-1\\/4 {\n    margin-bottom: -25%;\n  }\n  .sm\\:-ml-1\\/4 {\n    margin-left: -25%;\n  }\n  .sm\\:-mt-2\\/4 {\n    margin-top: -50%;\n  }\n  .sm\\:-mr-2\\/4 {\n    margin-right: -50%;\n  }\n  .sm\\:-mb-2\\/4 {\n    margin-bottom: -50%;\n  }\n  .sm\\:-ml-2\\/4 {\n    margin-left: -50%;\n  }\n  .sm\\:-mt-3\\/4 {\n    margin-top: -75%;\n  }\n  .sm\\:-mr-3\\/4 {\n    margin-right: -75%;\n  }\n  .sm\\:-mb-3\\/4 {\n    margin-bottom: -75%;\n  }\n  .sm\\:-ml-3\\/4 {\n    margin-left: -75%;\n  }\n  .sm\\:-mt-1\\/5 {\n    margin-top: -20%;\n  }\n  .sm\\:-mr-1\\/5 {\n    margin-right: -20%;\n  }\n  .sm\\:-mb-1\\/5 {\n    margin-bottom: -20%;\n  }\n  .sm\\:-ml-1\\/5 {\n    margin-left: -20%;\n  }\n  .sm\\:-mt-2\\/5 {\n    margin-top: -40%;\n  }\n  .sm\\:-mr-2\\/5 {\n    margin-right: -40%;\n  }\n  .sm\\:-mb-2\\/5 {\n    margin-bottom: -40%;\n  }\n  .sm\\:-ml-2\\/5 {\n    margin-left: -40%;\n  }\n  .sm\\:-mt-3\\/5 {\n    margin-top: -60%;\n  }\n  .sm\\:-mr-3\\/5 {\n    margin-right: -60%;\n  }\n  .sm\\:-mb-3\\/5 {\n    margin-bottom: -60%;\n  }\n  .sm\\:-ml-3\\/5 {\n    margin-left: -60%;\n  }\n  .sm\\:-mt-4\\/5 {\n    margin-top: -80%;\n  }\n  .sm\\:-mr-4\\/5 {\n    margin-right: -80%;\n  }\n  .sm\\:-mb-4\\/5 {\n    margin-bottom: -80%;\n  }\n  .sm\\:-ml-4\\/5 {\n    margin-left: -80%;\n  }\n  .sm\\:-mt-1\\/6 {\n    margin-top: -16.66667%;\n  }\n  .sm\\:-mr-1\\/6 {\n    margin-right: -16.66667%;\n  }\n  .sm\\:-mb-1\\/6 {\n    margin-bottom: -16.66667%;\n  }\n  .sm\\:-ml-1\\/6 {\n    margin-left: -16.66667%;\n  }\n  .sm\\:-mt-2\\/6 {\n    margin-top: -33.33333%;\n  }\n  .sm\\:-mr-2\\/6 {\n    margin-right: -33.33333%;\n  }\n  .sm\\:-mb-2\\/6 {\n    margin-bottom: -33.33333%;\n  }\n  .sm\\:-ml-2\\/6 {\n    margin-left: -33.33333%;\n  }\n  .sm\\:-mt-3\\/6 {\n    margin-top: -50%;\n  }\n  .sm\\:-mr-3\\/6 {\n    margin-right: -50%;\n  }\n  .sm\\:-mb-3\\/6 {\n    margin-bottom: -50%;\n  }\n  .sm\\:-ml-3\\/6 {\n    margin-left: -50%;\n  }\n  .sm\\:-mt-4\\/6 {\n    margin-top: -66.66667%;\n  }\n  .sm\\:-mr-4\\/6 {\n    margin-right: -66.66667%;\n  }\n  .sm\\:-mb-4\\/6 {\n    margin-bottom: -66.66667%;\n  }\n  .sm\\:-ml-4\\/6 {\n    margin-left: -66.66667%;\n  }\n  .sm\\:-mt-5\\/6 {\n    margin-top: -83.33333%;\n  }\n  .sm\\:-mr-5\\/6 {\n    margin-right: -83.33333%;\n  }\n  .sm\\:-mb-5\\/6 {\n    margin-bottom: -83.33333%;\n  }\n  .sm\\:-ml-5\\/6 {\n    margin-left: -83.33333%;\n  }\n  .sm\\:-mt-1\\/12 {\n    margin-top: -8.33333%;\n  }\n  .sm\\:-mr-1\\/12 {\n    margin-right: -8.33333%;\n  }\n  .sm\\:-mb-1\\/12 {\n    margin-bottom: -8.33333%;\n  }\n  .sm\\:-ml-1\\/12 {\n    margin-left: -8.33333%;\n  }\n  .sm\\:-mt-2\\/12 {\n    margin-top: -16.66667%;\n  }\n  .sm\\:-mr-2\\/12 {\n    margin-right: -16.66667%;\n  }\n  .sm\\:-mb-2\\/12 {\n    margin-bottom: -16.66667%;\n  }\n  .sm\\:-ml-2\\/12 {\n    margin-left: -16.66667%;\n  }\n  .sm\\:-mt-3\\/12 {\n    margin-top: -25%;\n  }\n  .sm\\:-mr-3\\/12 {\n    margin-right: -25%;\n  }\n  .sm\\:-mb-3\\/12 {\n    margin-bottom: -25%;\n  }\n  .sm\\:-ml-3\\/12 {\n    margin-left: -25%;\n  }\n  .sm\\:-mt-4\\/12 {\n    margin-top: -33.33333%;\n  }\n  .sm\\:-mr-4\\/12 {\n    margin-right: -33.33333%;\n  }\n  .sm\\:-mb-4\\/12 {\n    margin-bottom: -33.33333%;\n  }\n  .sm\\:-ml-4\\/12 {\n    margin-left: -33.33333%;\n  }\n  .sm\\:-mt-5\\/12 {\n    margin-top: -41.66667%;\n  }\n  .sm\\:-mr-5\\/12 {\n    margin-right: -41.66667%;\n  }\n  .sm\\:-mb-5\\/12 {\n    margin-bottom: -41.66667%;\n  }\n  .sm\\:-ml-5\\/12 {\n    margin-left: -41.66667%;\n  }\n  .sm\\:-mt-6\\/12 {\n    margin-top: -50%;\n  }\n  .sm\\:-mr-6\\/12 {\n    margin-right: -50%;\n  }\n  .sm\\:-mb-6\\/12 {\n    margin-bottom: -50%;\n  }\n  .sm\\:-ml-6\\/12 {\n    margin-left: -50%;\n  }\n  .sm\\:-mt-7\\/12 {\n    margin-top: -58.33333%;\n  }\n  .sm\\:-mr-7\\/12 {\n    margin-right: -58.33333%;\n  }\n  .sm\\:-mb-7\\/12 {\n    margin-bottom: -58.33333%;\n  }\n  .sm\\:-ml-7\\/12 {\n    margin-left: -58.33333%;\n  }\n  .sm\\:-mt-8\\/12 {\n    margin-top: -66.66667%;\n  }\n  .sm\\:-mr-8\\/12 {\n    margin-right: -66.66667%;\n  }\n  .sm\\:-mb-8\\/12 {\n    margin-bottom: -66.66667%;\n  }\n  .sm\\:-ml-8\\/12 {\n    margin-left: -66.66667%;\n  }\n  .sm\\:-mt-9\\/12 {\n    margin-top: -75%;\n  }\n  .sm\\:-mr-9\\/12 {\n    margin-right: -75%;\n  }\n  .sm\\:-mb-9\\/12 {\n    margin-bottom: -75%;\n  }\n  .sm\\:-ml-9\\/12 {\n    margin-left: -75%;\n  }\n  .sm\\:-mt-10\\/12 {\n    margin-top: -83.33333%;\n  }\n  .sm\\:-mr-10\\/12 {\n    margin-right: -83.33333%;\n  }\n  .sm\\:-mb-10\\/12 {\n    margin-bottom: -83.33333%;\n  }\n  .sm\\:-ml-10\\/12 {\n    margin-left: -83.33333%;\n  }\n  .sm\\:-mt-11\\/12 {\n    margin-top: -91.66667%;\n  }\n  .sm\\:-mr-11\\/12 {\n    margin-right: -91.66667%;\n  }\n  .sm\\:-mb-11\\/12 {\n    margin-bottom: -91.66667%;\n  }\n  .sm\\:-ml-11\\/12 {\n    margin-left: -91.66667%;\n  }\n  .sm\\:-mt-full {\n    margin-top: -100%;\n  }\n  .sm\\:-mr-full {\n    margin-right: -100%;\n  }\n  .sm\\:-mb-full {\n    margin-bottom: -100%;\n  }\n  .sm\\:-ml-full {\n    margin-left: -100%;\n  }\n  .sm\\:max-h-0 {\n    max-height: 0;\n  }\n  .sm\\:max-h-1 {\n    max-height: 0.25rem;\n  }\n  .sm\\:max-h-2 {\n    max-height: 0.5rem;\n  }\n  .sm\\:max-h-3 {\n    max-height: 0.75rem;\n  }\n  .sm\\:max-h-4 {\n    max-height: 1rem;\n  }\n  .sm\\:max-h-5 {\n    max-height: 1.25rem;\n  }\n  .sm\\:max-h-6 {\n    max-height: 1.5rem;\n  }\n  .sm\\:max-h-7 {\n    max-height: 1.75rem;\n  }\n  .sm\\:max-h-8 {\n    max-height: 2rem;\n  }\n  .sm\\:max-h-9 {\n    max-height: 2.25rem;\n  }\n  .sm\\:max-h-10 {\n    max-height: 2.5rem;\n  }\n  .sm\\:max-h-11 {\n    max-height: 2.75rem;\n  }\n  .sm\\:max-h-12 {\n    max-height: 3rem;\n  }\n  .sm\\:max-h-13 {\n    max-height: 3.25rem;\n  }\n  .sm\\:max-h-14 {\n    max-height: 3.5rem;\n  }\n  .sm\\:max-h-15 {\n    max-height: 3.75rem;\n  }\n  .sm\\:max-h-16 {\n    max-height: 4rem;\n  }\n  .sm\\:max-h-20 {\n    max-height: 5rem;\n  }\n  .sm\\:max-h-24 {\n    max-height: 6rem;\n  }\n  .sm\\:max-h-28 {\n    max-height: 7rem;\n  }\n  .sm\\:max-h-32 {\n    max-height: 8rem;\n  }\n  .sm\\:max-h-36 {\n    max-height: 9rem;\n  }\n  .sm\\:max-h-40 {\n    max-height: 10rem;\n  }\n  .sm\\:max-h-44 {\n    max-height: 11rem;\n  }\n  .sm\\:max-h-48 {\n    max-height: 12rem;\n  }\n  .sm\\:max-h-52 {\n    max-height: 13rem;\n  }\n  .sm\\:max-h-56 {\n    max-height: 14rem;\n  }\n  .sm\\:max-h-60 {\n    max-height: 15rem;\n  }\n  .sm\\:max-h-64 {\n    max-height: 16rem;\n  }\n  .sm\\:max-h-72 {\n    max-height: 18rem;\n  }\n  .sm\\:max-h-80 {\n    max-height: 20rem;\n  }\n  .sm\\:max-h-96 {\n    max-height: 24rem;\n  }\n  .sm\\:max-h-screen {\n    max-height: 100vh;\n  }\n  .sm\\:max-h-px {\n    max-height: 1px;\n  }\n  .sm\\:max-h-0\\.5 {\n    max-height: 0.125rem;\n  }\n  .sm\\:max-h-1\\.5 {\n    max-height: 0.375rem;\n  }\n  .sm\\:max-h-2\\.5 {\n    max-height: 0.625rem;\n  }\n  .sm\\:max-h-3\\.5 {\n    max-height: 0.875rem;\n  }\n  .sm\\:max-h-1\\/2 {\n    max-height: 50%;\n  }\n  .sm\\:max-h-1\\/3 {\n    max-height: 33.333333%;\n  }\n  .sm\\:max-h-2\\/3 {\n    max-height: 66.666667%;\n  }\n  .sm\\:max-h-1\\/4 {\n    max-height: 25%;\n  }\n  .sm\\:max-h-2\\/4 {\n    max-height: 50%;\n  }\n  .sm\\:max-h-3\\/4 {\n    max-height: 75%;\n  }\n  .sm\\:max-h-1\\/5 {\n    max-height: 20%;\n  }\n  .sm\\:max-h-2\\/5 {\n    max-height: 40%;\n  }\n  .sm\\:max-h-3\\/5 {\n    max-height: 60%;\n  }\n  .sm\\:max-h-4\\/5 {\n    max-height: 80%;\n  }\n  .sm\\:max-h-1\\/6 {\n    max-height: 16.666667%;\n  }\n  .sm\\:max-h-2\\/6 {\n    max-height: 33.333333%;\n  }\n  .sm\\:max-h-3\\/6 {\n    max-height: 50%;\n  }\n  .sm\\:max-h-4\\/6 {\n    max-height: 66.666667%;\n  }\n  .sm\\:max-h-5\\/6 {\n    max-height: 83.333333%;\n  }\n  .sm\\:max-h-1\\/12 {\n    max-height: 8.333333%;\n  }\n  .sm\\:max-h-2\\/12 {\n    max-height: 16.666667%;\n  }\n  .sm\\:max-h-3\\/12 {\n    max-height: 25%;\n  }\n  .sm\\:max-h-4\\/12 {\n    max-height: 33.333333%;\n  }\n  .sm\\:max-h-5\\/12 {\n    max-height: 41.666667%;\n  }\n  .sm\\:max-h-6\\/12 {\n    max-height: 50%;\n  }\n  .sm\\:max-h-7\\/12 {\n    max-height: 58.333333%;\n  }\n  .sm\\:max-h-8\\/12 {\n    max-height: 66.666667%;\n  }\n  .sm\\:max-h-9\\/12 {\n    max-height: 75%;\n  }\n  .sm\\:max-h-10\\/12 {\n    max-height: 83.333333%;\n  }\n  .sm\\:max-h-11\\/12 {\n    max-height: 91.666667%;\n  }\n  .sm\\:max-h-full {\n    max-height: 100%;\n  }\n  .sm\\:max-w-0 {\n    max-width: 0rem;\n  }\n  .sm\\:max-w-none {\n    max-width: none;\n  }\n  .sm\\:max-w-xs {\n    max-width: 20rem;\n  }\n  .sm\\:max-w-sm {\n    max-width: 24rem;\n  }\n  .sm\\:max-w-md {\n    max-width: 28rem;\n  }\n  .sm\\:max-w-lg {\n    max-width: 32rem;\n  }\n  .sm\\:max-w-xl {\n    max-width: 36rem;\n  }\n  .sm\\:max-w-2xl {\n    max-width: 42rem;\n  }\n  .sm\\:max-w-3xl {\n    max-width: 48rem;\n  }\n  .sm\\:max-w-4xl {\n    max-width: 56rem;\n  }\n  .sm\\:max-w-5xl {\n    max-width: 64rem;\n  }\n  .sm\\:max-w-6xl {\n    max-width: 72rem;\n  }\n  .sm\\:max-w-7xl {\n    max-width: 80rem;\n  }\n  .sm\\:max-w-full {\n    max-width: 100%;\n  }\n  .sm\\:max-w-min-content {\n    max-width: -moz-min-content;\n    max-width: min-content;\n  }\n  .sm\\:max-w-max-content {\n    max-width: -moz-max-content;\n    max-width: max-content;\n  }\n  .sm\\:max-w-prose {\n    max-width: 65ch;\n  }\n  .sm\\:max-w-screen-sm {\n    max-width: 640px;\n  }\n  .sm\\:max-w-screen-md {\n    max-width: 768px;\n  }\n  .sm\\:max-w-screen-lg {\n    max-width: 1024px;\n  }\n  .sm\\:max-w-screen-xl {\n    max-width: 1280px;\n  }\n  .sm\\:min-h-0 {\n    min-height: 0;\n  }\n  .sm\\:min-h-full {\n    min-height: 100%;\n  }\n  .sm\\:min-h-screen {\n    min-height: 100vh;\n  }\n  .sm\\:min-w-0 {\n    min-width: 0;\n  }\n  .sm\\:min-w-full {\n    min-width: 100%;\n  }\n  .sm\\:min-w-min-content {\n    min-width: -moz-min-content;\n    min-width: min-content;\n  }\n  .sm\\:min-w-max-content {\n    min-width: -moz-max-content;\n    min-width: max-content;\n  }\n  .sm\\:object-contain {\n    -o-object-fit: contain;\n    object-fit: contain;\n  }\n  .sm\\:object-cover {\n    -o-object-fit: cover;\n    object-fit: cover;\n  }\n  .sm\\:object-fill {\n    -o-object-fit: fill;\n    object-fit: fill;\n  }\n  .sm\\:object-none {\n    -o-object-fit: none;\n    object-fit: none;\n  }\n  .sm\\:object-scale-down {\n    -o-object-fit: scale-down;\n    object-fit: scale-down;\n  }\n  .sm\\:object-bottom {\n    -o-object-position: bottom;\n    object-position: bottom;\n  }\n  .sm\\:object-center {\n    -o-object-position: center;\n    object-position: center;\n  }\n  .sm\\:object-left {\n    -o-object-position: left;\n    object-position: left;\n  }\n  .sm\\:object-left-bottom {\n    -o-object-position: left bottom;\n    object-position: left bottom;\n  }\n  .sm\\:object-left-top {\n    -o-object-position: left top;\n    object-position: left top;\n  }\n  .sm\\:object-right {\n    -o-object-position: right;\n    object-position: right;\n  }\n  .sm\\:object-right-bottom {\n    -o-object-position: right bottom;\n    object-position: right bottom;\n  }\n  .sm\\:object-right-top {\n    -o-object-position: right top;\n    object-position: right top;\n  }\n  .sm\\:object-top {\n    -o-object-position: top;\n    object-position: top;\n  }\n  .sm\\:opacity-0 {\n    opacity: 0;\n  }\n  .sm\\:opacity-25 {\n    opacity: 0.25;\n  }\n  .sm\\:opacity-50 {\n    opacity: 0.5;\n  }\n  .sm\\:opacity-75 {\n    opacity: 0.75;\n  }\n  .sm\\:opacity-100 {\n    opacity: 1;\n  }\n  .sm\\:focus-within\\:opacity-0:focus-within {\n    opacity: 0;\n  }\n  .sm\\:focus-within\\:opacity-25:focus-within {\n    opacity: 0.25;\n  }\n  .sm\\:focus-within\\:opacity-50:focus-within {\n    opacity: 0.5;\n  }\n  .sm\\:focus-within\\:opacity-75:focus-within {\n    opacity: 0.75;\n  }\n  .sm\\:focus-within\\:opacity-100:focus-within {\n    opacity: 1;\n  }\n  .group:hover .sm\\:group-hover\\:opacity-0 {\n    opacity: 0;\n  }\n  .group:hover .sm\\:group-hover\\:opacity-25 {\n    opacity: 0.25;\n  }\n  .group:hover .sm\\:group-hover\\:opacity-50 {\n    opacity: 0.5;\n  }\n  .group:hover .sm\\:group-hover\\:opacity-75 {\n    opacity: 0.75;\n  }\n  .group:hover .sm\\:group-hover\\:opacity-100 {\n    opacity: 1;\n  }\n  .group:focus .sm\\:group-focus\\:opacity-0 {\n    opacity: 0;\n  }\n  .group:focus .sm\\:group-focus\\:opacity-25 {\n    opacity: 0.25;\n  }\n  .group:focus .sm\\:group-focus\\:opacity-50 {\n    opacity: 0.5;\n  }\n  .group:focus .sm\\:group-focus\\:opacity-75 {\n    opacity: 0.75;\n  }\n  .group:focus .sm\\:group-focus\\:opacity-100 {\n    opacity: 1;\n  }\n  .sm\\:hover\\:opacity-0:hover {\n    opacity: 0;\n  }\n  .sm\\:hover\\:opacity-25:hover {\n    opacity: 0.25;\n  }\n  .sm\\:hover\\:opacity-50:hover {\n    opacity: 0.5;\n  }\n  .sm\\:hover\\:opacity-75:hover {\n    opacity: 0.75;\n  }\n  .sm\\:hover\\:opacity-100:hover {\n    opacity: 1;\n  }\n  .sm\\:focus\\:opacity-0:focus {\n    opacity: 0;\n  }\n  .sm\\:focus\\:opacity-25:focus {\n    opacity: 0.25;\n  }\n  .sm\\:focus\\:opacity-50:focus {\n    opacity: 0.5;\n  }\n  .sm\\:focus\\:opacity-75:focus {\n    opacity: 0.75;\n  }\n  .sm\\:focus\\:opacity-100:focus {\n    opacity: 1;\n  }\n  .sm\\:outline-none {\n    outline: 2px solid transparent;\n    outline-offset: 2px;\n  }\n  .sm\\:outline-white {\n    outline: 2px dotted white;\n    outline-offset: 2px;\n  }\n  .sm\\:outline-black {\n    outline: 2px dotted black;\n    outline-offset: 2px;\n  }\n  .sm\\:focus\\:outline-none:focus {\n    outline: 2px solid transparent;\n    outline-offset: 2px;\n  }\n  .sm\\:focus\\:outline-white:focus {\n    outline: 2px dotted white;\n    outline-offset: 2px;\n  }\n  .sm\\:focus\\:outline-black:focus {\n    outline: 2px dotted black;\n    outline-offset: 2px;\n  }\n  .sm\\:overflow-auto {\n    overflow: auto;\n  }\n  .sm\\:overflow-hidden {\n    overflow: hidden;\n  }\n  .sm\\:overflow-visible {\n    overflow: visible;\n  }\n  .sm\\:overflow-scroll {\n    overflow: scroll;\n  }\n  .sm\\:overflow-x-auto {\n    overflow-x: auto;\n  }\n  .sm\\:overflow-y-auto {\n    overflow-y: auto;\n  }\n  .sm\\:overflow-x-hidden {\n    overflow-x: hidden;\n  }\n  .sm\\:overflow-y-hidden {\n    overflow-y: hidden;\n  }\n  .sm\\:overflow-x-visible {\n    overflow-x: visible;\n  }\n  .sm\\:overflow-y-visible {\n    overflow-y: visible;\n  }\n  .sm\\:overflow-x-scroll {\n    overflow-x: scroll;\n  }\n  .sm\\:overflow-y-scroll {\n    overflow-y: scroll;\n  }\n  .sm\\:scrolling-touch {\n    -webkit-overflow-scrolling: touch;\n  }\n  .sm\\:scrolling-auto {\n    -webkit-overflow-scrolling: auto;\n  }\n  .sm\\:overscroll-auto {\n    overscroll-behavior: auto;\n  }\n  .sm\\:overscroll-contain {\n    overscroll-behavior: contain;\n  }\n  .sm\\:overscroll-none {\n    overscroll-behavior: none;\n  }\n  .sm\\:overscroll-y-auto {\n    overscroll-behavior-y: auto;\n  }\n  .sm\\:overscroll-y-contain {\n    overscroll-behavior-y: contain;\n  }\n  .sm\\:overscroll-y-none {\n    overscroll-behavior-y: none;\n  }\n  .sm\\:overscroll-x-auto {\n    overscroll-behavior-x: auto;\n  }\n  .sm\\:overscroll-x-contain {\n    overscroll-behavior-x: contain;\n  }\n  .sm\\:overscroll-x-none {\n    overscroll-behavior-x: none;\n  }\n  .sm\\:p-0 {\n    padding: 0;\n  }\n  .sm\\:p-1 {\n    padding: 0.25rem;\n  }\n  .sm\\:p-2 {\n    padding: 0.5rem;\n  }\n  .sm\\:p-3 {\n    padding: 0.75rem;\n  }\n  .sm\\:p-4 {\n    padding: 1rem;\n  }\n  .sm\\:p-5 {\n    padding: 1.25rem;\n  }\n  .sm\\:p-6 {\n    padding: 1.5rem;\n  }\n  .sm\\:p-7 {\n    padding: 1.75rem;\n  }\n  .sm\\:p-8 {\n    padding: 2rem;\n  }\n  .sm\\:p-9 {\n    padding: 2.25rem;\n  }\n  .sm\\:p-10 {\n    padding: 2.5rem;\n  }\n  .sm\\:p-11 {\n    padding: 2.75rem;\n  }\n  .sm\\:p-12 {\n    padding: 3rem;\n  }\n  .sm\\:p-13 {\n    padding: 3.25rem;\n  }\n  .sm\\:p-14 {\n    padding: 3.5rem;\n  }\n  .sm\\:p-15 {\n    padding: 3.75rem;\n  }\n  .sm\\:p-16 {\n    padding: 4rem;\n  }\n  .sm\\:p-20 {\n    padding: 5rem;\n  }\n  .sm\\:p-24 {\n    padding: 6rem;\n  }\n  .sm\\:p-28 {\n    padding: 7rem;\n  }\n  .sm\\:p-32 {\n    padding: 8rem;\n  }\n  .sm\\:p-36 {\n    padding: 9rem;\n  }\n  .sm\\:p-40 {\n    padding: 10rem;\n  }\n  .sm\\:p-44 {\n    padding: 11rem;\n  }\n  .sm\\:p-48 {\n    padding: 12rem;\n  }\n  .sm\\:p-52 {\n    padding: 13rem;\n  }\n  .sm\\:p-56 {\n    padding: 14rem;\n  }\n  .sm\\:p-60 {\n    padding: 15rem;\n  }\n  .sm\\:p-64 {\n    padding: 16rem;\n  }\n  .sm\\:p-72 {\n    padding: 18rem;\n  }\n  .sm\\:p-80 {\n    padding: 20rem;\n  }\n  .sm\\:p-96 {\n    padding: 24rem;\n  }\n  .sm\\:p-px {\n    padding: 1px;\n  }\n  .sm\\:p-0\\.5 {\n    padding: 0.125rem;\n  }\n  .sm\\:p-1\\.5 {\n    padding: 0.375rem;\n  }\n  .sm\\:p-2\\.5 {\n    padding: 0.625rem;\n  }\n  .sm\\:p-3\\.5 {\n    padding: 0.875rem;\n  }\n  .sm\\:p-1\\/2 {\n    padding: 50%;\n  }\n  .sm\\:p-1\\/3 {\n    padding: 33.333333%;\n  }\n  .sm\\:p-2\\/3 {\n    padding: 66.666667%;\n  }\n  .sm\\:p-1\\/4 {\n    padding: 25%;\n  }\n  .sm\\:p-2\\/4 {\n    padding: 50%;\n  }\n  .sm\\:p-3\\/4 {\n    padding: 75%;\n  }\n  .sm\\:p-1\\/5 {\n    padding: 20%;\n  }\n  .sm\\:p-2\\/5 {\n    padding: 40%;\n  }\n  .sm\\:p-3\\/5 {\n    padding: 60%;\n  }\n  .sm\\:p-4\\/5 {\n    padding: 80%;\n  }\n  .sm\\:p-1\\/6 {\n    padding: 16.666667%;\n  }\n  .sm\\:p-2\\/6 {\n    padding: 33.333333%;\n  }\n  .sm\\:p-3\\/6 {\n    padding: 50%;\n  }\n  .sm\\:p-4\\/6 {\n    padding: 66.666667%;\n  }\n  .sm\\:p-5\\/6 {\n    padding: 83.333333%;\n  }\n  .sm\\:p-1\\/12 {\n    padding: 8.333333%;\n  }\n  .sm\\:p-2\\/12 {\n    padding: 16.666667%;\n  }\n  .sm\\:p-3\\/12 {\n    padding: 25%;\n  }\n  .sm\\:p-4\\/12 {\n    padding: 33.333333%;\n  }\n  .sm\\:p-5\\/12 {\n    padding: 41.666667%;\n  }\n  .sm\\:p-6\\/12 {\n    padding: 50%;\n  }\n  .sm\\:p-7\\/12 {\n    padding: 58.333333%;\n  }\n  .sm\\:p-8\\/12 {\n    padding: 66.666667%;\n  }\n  .sm\\:p-9\\/12 {\n    padding: 75%;\n  }\n  .sm\\:p-10\\/12 {\n    padding: 83.333333%;\n  }\n  .sm\\:p-11\\/12 {\n    padding: 91.666667%;\n  }\n  .sm\\:p-full {\n    padding: 100%;\n  }\n  .sm\\:py-0 {\n    padding-top: 0;\n    padding-bottom: 0;\n  }\n  .sm\\:px-0 {\n    padding-left: 0;\n    padding-right: 0;\n  }\n  .sm\\:py-1 {\n    padding-top: 0.25rem;\n    padding-bottom: 0.25rem;\n  }\n  .sm\\:px-1 {\n    padding-left: 0.25rem;\n    padding-right: 0.25rem;\n  }\n  .sm\\:py-2 {\n    padding-top: 0.5rem;\n    padding-bottom: 0.5rem;\n  }\n  .sm\\:px-2 {\n    padding-left: 0.5rem;\n    padding-right: 0.5rem;\n  }\n  .sm\\:py-3 {\n    padding-top: 0.75rem;\n    padding-bottom: 0.75rem;\n  }\n  .sm\\:px-3 {\n    padding-left: 0.75rem;\n    padding-right: 0.75rem;\n  }\n  .sm\\:py-4 {\n    padding-top: 1rem;\n    padding-bottom: 1rem;\n  }\n  .sm\\:px-4 {\n    padding-left: 1rem;\n    padding-right: 1rem;\n  }\n  .sm\\:py-5 {\n    padding-top: 1.25rem;\n    padding-bottom: 1.25rem;\n  }\n  .sm\\:px-5 {\n    padding-left: 1.25rem;\n    padding-right: 1.25rem;\n  }\n  .sm\\:py-6 {\n    padding-top: 1.5rem;\n    padding-bottom: 1.5rem;\n  }\n  .sm\\:px-6 {\n    padding-left: 1.5rem;\n    padding-right: 1.5rem;\n  }\n  .sm\\:py-7 {\n    padding-top: 1.75rem;\n    padding-bottom: 1.75rem;\n  }\n  .sm\\:px-7 {\n    padding-left: 1.75rem;\n    padding-right: 1.75rem;\n  }\n  .sm\\:py-8 {\n    padding-top: 2rem;\n    padding-bottom: 2rem;\n  }\n  .sm\\:px-8 {\n    padding-left: 2rem;\n    padding-right: 2rem;\n  }\n  .sm\\:py-9 {\n    padding-top: 2.25rem;\n    padding-bottom: 2.25rem;\n  }\n  .sm\\:px-9 {\n    padding-left: 2.25rem;\n    padding-right: 2.25rem;\n  }\n  .sm\\:py-10 {\n    padding-top: 2.5rem;\n    padding-bottom: 2.5rem;\n  }\n  .sm\\:px-10 {\n    padding-left: 2.5rem;\n    padding-right: 2.5rem;\n  }\n  .sm\\:py-11 {\n    padding-top: 2.75rem;\n    padding-bottom: 2.75rem;\n  }\n  .sm\\:px-11 {\n    padding-left: 2.75rem;\n    padding-right: 2.75rem;\n  }\n  .sm\\:py-12 {\n    padding-top: 3rem;\n    padding-bottom: 3rem;\n  }\n  .sm\\:px-12 {\n    padding-left: 3rem;\n    padding-right: 3rem;\n  }\n  .sm\\:py-13 {\n    padding-top: 3.25rem;\n    padding-bottom: 3.25rem;\n  }\n  .sm\\:px-13 {\n    padding-left: 3.25rem;\n    padding-right: 3.25rem;\n  }\n  .sm\\:py-14 {\n    padding-top: 3.5rem;\n    padding-bottom: 3.5rem;\n  }\n  .sm\\:px-14 {\n    padding-left: 3.5rem;\n    padding-right: 3.5rem;\n  }\n  .sm\\:py-15 {\n    padding-top: 3.75rem;\n    padding-bottom: 3.75rem;\n  }\n  .sm\\:px-15 {\n    padding-left: 3.75rem;\n    padding-right: 3.75rem;\n  }\n  .sm\\:py-16 {\n    padding-top: 4rem;\n    padding-bottom: 4rem;\n  }\n  .sm\\:px-16 {\n    padding-left: 4rem;\n    padding-right: 4rem;\n  }\n  .sm\\:py-20 {\n    padding-top: 5rem;\n    padding-bottom: 5rem;\n  }\n  .sm\\:px-20 {\n    padding-left: 5rem;\n    padding-right: 5rem;\n  }\n  .sm\\:py-24 {\n    padding-top: 6rem;\n    padding-bottom: 6rem;\n  }\n  .sm\\:px-24 {\n    padding-left: 6rem;\n    padding-right: 6rem;\n  }\n  .sm\\:py-28 {\n    padding-top: 7rem;\n    padding-bottom: 7rem;\n  }\n  .sm\\:px-28 {\n    padding-left: 7rem;\n    padding-right: 7rem;\n  }\n  .sm\\:py-32 {\n    padding-top: 8rem;\n    padding-bottom: 8rem;\n  }\n  .sm\\:px-32 {\n    padding-left: 8rem;\n    padding-right: 8rem;\n  }\n  .sm\\:py-36 {\n    padding-top: 9rem;\n    padding-bottom: 9rem;\n  }\n  .sm\\:px-36 {\n    padding-left: 9rem;\n    padding-right: 9rem;\n  }\n  .sm\\:py-40 {\n    padding-top: 10rem;\n    padding-bottom: 10rem;\n  }\n  .sm\\:px-40 {\n    padding-left: 10rem;\n    padding-right: 10rem;\n  }\n  .sm\\:py-44 {\n    padding-top: 11rem;\n    padding-bottom: 11rem;\n  }\n  .sm\\:px-44 {\n    padding-left: 11rem;\n    padding-right: 11rem;\n  }\n  .sm\\:py-48 {\n    padding-top: 12rem;\n    padding-bottom: 12rem;\n  }\n  .sm\\:px-48 {\n    padding-left: 12rem;\n    padding-right: 12rem;\n  }\n  .sm\\:py-52 {\n    padding-top: 13rem;\n    padding-bottom: 13rem;\n  }\n  .sm\\:px-52 {\n    padding-left: 13rem;\n    padding-right: 13rem;\n  }\n  .sm\\:py-56 {\n    padding-top: 14rem;\n    padding-bottom: 14rem;\n  }\n  .sm\\:px-56 {\n    padding-left: 14rem;\n    padding-right: 14rem;\n  }\n  .sm\\:py-60 {\n    padding-top: 15rem;\n    padding-bottom: 15rem;\n  }\n  .sm\\:px-60 {\n    padding-left: 15rem;\n    padding-right: 15rem;\n  }\n  .sm\\:py-64 {\n    padding-top: 16rem;\n    padding-bottom: 16rem;\n  }\n  .sm\\:px-64 {\n    padding-left: 16rem;\n    padding-right: 16rem;\n  }\n  .sm\\:py-72 {\n    padding-top: 18rem;\n    padding-bottom: 18rem;\n  }\n  .sm\\:px-72 {\n    padding-left: 18rem;\n    padding-right: 18rem;\n  }\n  .sm\\:py-80 {\n    padding-top: 20rem;\n    padding-bottom: 20rem;\n  }\n  .sm\\:px-80 {\n    padding-left: 20rem;\n    padding-right: 20rem;\n  }\n  .sm\\:py-96 {\n    padding-top: 24rem;\n    padding-bottom: 24rem;\n  }\n  .sm\\:px-96 {\n    padding-left: 24rem;\n    padding-right: 24rem;\n  }\n  .sm\\:py-px {\n    padding-top: 1px;\n    padding-bottom: 1px;\n  }\n  .sm\\:px-px {\n    padding-left: 1px;\n    padding-right: 1px;\n  }\n  .sm\\:py-0\\.5 {\n    padding-top: 0.125rem;\n    padding-bottom: 0.125rem;\n  }\n  .sm\\:px-0\\.5 {\n    padding-left: 0.125rem;\n    padding-right: 0.125rem;\n  }\n  .sm\\:py-1\\.5 {\n    padding-top: 0.375rem;\n    padding-bottom: 0.375rem;\n  }\n  .sm\\:px-1\\.5 {\n    padding-left: 0.375rem;\n    padding-right: 0.375rem;\n  }\n  .sm\\:py-2\\.5 {\n    padding-top: 0.625rem;\n    padding-bottom: 0.625rem;\n  }\n  .sm\\:px-2\\.5 {\n    padding-left: 0.625rem;\n    padding-right: 0.625rem;\n  }\n  .sm\\:py-3\\.5 {\n    padding-top: 0.875rem;\n    padding-bottom: 0.875rem;\n  }\n  .sm\\:px-3\\.5 {\n    padding-left: 0.875rem;\n    padding-right: 0.875rem;\n  }\n  .sm\\:py-1\\/2 {\n    padding-top: 50%;\n    padding-bottom: 50%;\n  }\n  .sm\\:px-1\\/2 {\n    padding-left: 50%;\n    padding-right: 50%;\n  }\n  .sm\\:py-1\\/3 {\n    padding-top: 33.333333%;\n    padding-bottom: 33.333333%;\n  }\n  .sm\\:px-1\\/3 {\n    padding-left: 33.333333%;\n    padding-right: 33.333333%;\n  }\n  .sm\\:py-2\\/3 {\n    padding-top: 66.666667%;\n    padding-bottom: 66.666667%;\n  }\n  .sm\\:px-2\\/3 {\n    padding-left: 66.666667%;\n    padding-right: 66.666667%;\n  }\n  .sm\\:py-1\\/4 {\n    padding-top: 25%;\n    padding-bottom: 25%;\n  }\n  .sm\\:px-1\\/4 {\n    padding-left: 25%;\n    padding-right: 25%;\n  }\n  .sm\\:py-2\\/4 {\n    padding-top: 50%;\n    padding-bottom: 50%;\n  }\n  .sm\\:px-2\\/4 {\n    padding-left: 50%;\n    padding-right: 50%;\n  }\n  .sm\\:py-3\\/4 {\n    padding-top: 75%;\n    padding-bottom: 75%;\n  }\n  .sm\\:px-3\\/4 {\n    padding-left: 75%;\n    padding-right: 75%;\n  }\n  .sm\\:py-1\\/5 {\n    padding-top: 20%;\n    padding-bottom: 20%;\n  }\n  .sm\\:px-1\\/5 {\n    padding-left: 20%;\n    padding-right: 20%;\n  }\n  .sm\\:py-2\\/5 {\n    padding-top: 40%;\n    padding-bottom: 40%;\n  }\n  .sm\\:px-2\\/5 {\n    padding-left: 40%;\n    padding-right: 40%;\n  }\n  .sm\\:py-3\\/5 {\n    padding-top: 60%;\n    padding-bottom: 60%;\n  }\n  .sm\\:px-3\\/5 {\n    padding-left: 60%;\n    padding-right: 60%;\n  }\n  .sm\\:py-4\\/5 {\n    padding-top: 80%;\n    padding-bottom: 80%;\n  }\n  .sm\\:px-4\\/5 {\n    padding-left: 80%;\n    padding-right: 80%;\n  }\n  .sm\\:py-1\\/6 {\n    padding-top: 16.666667%;\n    padding-bottom: 16.666667%;\n  }\n  .sm\\:px-1\\/6 {\n    padding-left: 16.666667%;\n    padding-right: 16.666667%;\n  }\n  .sm\\:py-2\\/6 {\n    padding-top: 33.333333%;\n    padding-bottom: 33.333333%;\n  }\n  .sm\\:px-2\\/6 {\n    padding-left: 33.333333%;\n    padding-right: 33.333333%;\n  }\n  .sm\\:py-3\\/6 {\n    padding-top: 50%;\n    padding-bottom: 50%;\n  }\n  .sm\\:px-3\\/6 {\n    padding-left: 50%;\n    padding-right: 50%;\n  }\n  .sm\\:py-4\\/6 {\n    padding-top: 66.666667%;\n    padding-bottom: 66.666667%;\n  }\n  .sm\\:px-4\\/6 {\n    padding-left: 66.666667%;\n    padding-right: 66.666667%;\n  }\n  .sm\\:py-5\\/6 {\n    padding-top: 83.333333%;\n    padding-bottom: 83.333333%;\n  }\n  .sm\\:px-5\\/6 {\n    padding-left: 83.333333%;\n    padding-right: 83.333333%;\n  }\n  .sm\\:py-1\\/12 {\n    padding-top: 8.333333%;\n    padding-bottom: 8.333333%;\n  }\n  .sm\\:px-1\\/12 {\n    padding-left: 8.333333%;\n    padding-right: 8.333333%;\n  }\n  .sm\\:py-2\\/12 {\n    padding-top: 16.666667%;\n    padding-bottom: 16.666667%;\n  }\n  .sm\\:px-2\\/12 {\n    padding-left: 16.666667%;\n    padding-right: 16.666667%;\n  }\n  .sm\\:py-3\\/12 {\n    padding-top: 25%;\n    padding-bottom: 25%;\n  }\n  .sm\\:px-3\\/12 {\n    padding-left: 25%;\n    padding-right: 25%;\n  }\n  .sm\\:py-4\\/12 {\n    padding-top: 33.333333%;\n    padding-bottom: 33.333333%;\n  }\n  .sm\\:px-4\\/12 {\n    padding-left: 33.333333%;\n    padding-right: 33.333333%;\n  }\n  .sm\\:py-5\\/12 {\n    padding-top: 41.666667%;\n    padding-bottom: 41.666667%;\n  }\n  .sm\\:px-5\\/12 {\n    padding-left: 41.666667%;\n    padding-right: 41.666667%;\n  }\n  .sm\\:py-6\\/12 {\n    padding-top: 50%;\n    padding-bottom: 50%;\n  }\n  .sm\\:px-6\\/12 {\n    padding-left: 50%;\n    padding-right: 50%;\n  }\n  .sm\\:py-7\\/12 {\n    padding-top: 58.333333%;\n    padding-bottom: 58.333333%;\n  }\n  .sm\\:px-7\\/12 {\n    padding-left: 58.333333%;\n    padding-right: 58.333333%;\n  }\n  .sm\\:py-8\\/12 {\n    padding-top: 66.666667%;\n    padding-bottom: 66.666667%;\n  }\n  .sm\\:px-8\\/12 {\n    padding-left: 66.666667%;\n    padding-right: 66.666667%;\n  }\n  .sm\\:py-9\\/12 {\n    padding-top: 75%;\n    padding-bottom: 75%;\n  }\n  .sm\\:px-9\\/12 {\n    padding-left: 75%;\n    padding-right: 75%;\n  }\n  .sm\\:py-10\\/12 {\n    padding-top: 83.333333%;\n    padding-bottom: 83.333333%;\n  }\n  .sm\\:px-10\\/12 {\n    padding-left: 83.333333%;\n    padding-right: 83.333333%;\n  }\n  .sm\\:py-11\\/12 {\n    padding-top: 91.666667%;\n    padding-bottom: 91.666667%;\n  }\n  .sm\\:px-11\\/12 {\n    padding-left: 91.666667%;\n    padding-right: 91.666667%;\n  }\n  .sm\\:py-full {\n    padding-top: 100%;\n    padding-bottom: 100%;\n  }\n  .sm\\:px-full {\n    padding-left: 100%;\n    padding-right: 100%;\n  }\n  .sm\\:pt-0 {\n    padding-top: 0;\n  }\n  .sm\\:pr-0 {\n    padding-right: 0;\n  }\n  .sm\\:pb-0 {\n    padding-bottom: 0;\n  }\n  .sm\\:pl-0 {\n    padding-left: 0;\n  }\n  .sm\\:pt-1 {\n    padding-top: 0.25rem;\n  }\n  .sm\\:pr-1 {\n    padding-right: 0.25rem;\n  }\n  .sm\\:pb-1 {\n    padding-bottom: 0.25rem;\n  }\n  .sm\\:pl-1 {\n    padding-left: 0.25rem;\n  }\n  .sm\\:pt-2 {\n    padding-top: 0.5rem;\n  }\n  .sm\\:pr-2 {\n    padding-right: 0.5rem;\n  }\n  .sm\\:pb-2 {\n    padding-bottom: 0.5rem;\n  }\n  .sm\\:pl-2 {\n    padding-left: 0.5rem;\n  }\n  .sm\\:pt-3 {\n    padding-top: 0.75rem;\n  }\n  .sm\\:pr-3 {\n    padding-right: 0.75rem;\n  }\n  .sm\\:pb-3 {\n    padding-bottom: 0.75rem;\n  }\n  .sm\\:pl-3 {\n    padding-left: 0.75rem;\n  }\n  .sm\\:pt-4 {\n    padding-top: 1rem;\n  }\n  .sm\\:pr-4 {\n    padding-right: 1rem;\n  }\n  .sm\\:pb-4 {\n    padding-bottom: 1rem;\n  }\n  .sm\\:pl-4 {\n    padding-left: 1rem;\n  }\n  .sm\\:pt-5 {\n    padding-top: 1.25rem;\n  }\n  .sm\\:pr-5 {\n    padding-right: 1.25rem;\n  }\n  .sm\\:pb-5 {\n    padding-bottom: 1.25rem;\n  }\n  .sm\\:pl-5 {\n    padding-left: 1.25rem;\n  }\n  .sm\\:pt-6 {\n    padding-top: 1.5rem;\n  }\n  .sm\\:pr-6 {\n    padding-right: 1.5rem;\n  }\n  .sm\\:pb-6 {\n    padding-bottom: 1.5rem;\n  }\n  .sm\\:pl-6 {\n    padding-left: 1.5rem;\n  }\n  .sm\\:pt-7 {\n    padding-top: 1.75rem;\n  }\n  .sm\\:pr-7 {\n    padding-right: 1.75rem;\n  }\n  .sm\\:pb-7 {\n    padding-bottom: 1.75rem;\n  }\n  .sm\\:pl-7 {\n    padding-left: 1.75rem;\n  }\n  .sm\\:pt-8 {\n    padding-top: 2rem;\n  }\n  .sm\\:pr-8 {\n    padding-right: 2rem;\n  }\n  .sm\\:pb-8 {\n    padding-bottom: 2rem;\n  }\n  .sm\\:pl-8 {\n    padding-left: 2rem;\n  }\n  .sm\\:pt-9 {\n    padding-top: 2.25rem;\n  }\n  .sm\\:pr-9 {\n    padding-right: 2.25rem;\n  }\n  .sm\\:pb-9 {\n    padding-bottom: 2.25rem;\n  }\n  .sm\\:pl-9 {\n    padding-left: 2.25rem;\n  }\n  .sm\\:pt-10 {\n    padding-top: 2.5rem;\n  }\n  .sm\\:pr-10 {\n    padding-right: 2.5rem;\n  }\n  .sm\\:pb-10 {\n    padding-bottom: 2.5rem;\n  }\n  .sm\\:pl-10 {\n    padding-left: 2.5rem;\n  }\n  .sm\\:pt-11 {\n    padding-top: 2.75rem;\n  }\n  .sm\\:pr-11 {\n    padding-right: 2.75rem;\n  }\n  .sm\\:pb-11 {\n    padding-bottom: 2.75rem;\n  }\n  .sm\\:pl-11 {\n    padding-left: 2.75rem;\n  }\n  .sm\\:pt-12 {\n    padding-top: 3rem;\n  }\n  .sm\\:pr-12 {\n    padding-right: 3rem;\n  }\n  .sm\\:pb-12 {\n    padding-bottom: 3rem;\n  }\n  .sm\\:pl-12 {\n    padding-left: 3rem;\n  }\n  .sm\\:pt-13 {\n    padding-top: 3.25rem;\n  }\n  .sm\\:pr-13 {\n    padding-right: 3.25rem;\n  }\n  .sm\\:pb-13 {\n    padding-bottom: 3.25rem;\n  }\n  .sm\\:pl-13 {\n    padding-left: 3.25rem;\n  }\n  .sm\\:pt-14 {\n    padding-top: 3.5rem;\n  }\n  .sm\\:pr-14 {\n    padding-right: 3.5rem;\n  }\n  .sm\\:pb-14 {\n    padding-bottom: 3.5rem;\n  }\n  .sm\\:pl-14 {\n    padding-left: 3.5rem;\n  }\n  .sm\\:pt-15 {\n    padding-top: 3.75rem;\n  }\n  .sm\\:pr-15 {\n    padding-right: 3.75rem;\n  }\n  .sm\\:pb-15 {\n    padding-bottom: 3.75rem;\n  }\n  .sm\\:pl-15 {\n    padding-left: 3.75rem;\n  }\n  .sm\\:pt-16 {\n    padding-top: 4rem;\n  }\n  .sm\\:pr-16 {\n    padding-right: 4rem;\n  }\n  .sm\\:pb-16 {\n    padding-bottom: 4rem;\n  }\n  .sm\\:pl-16 {\n    padding-left: 4rem;\n  }\n  .sm\\:pt-20 {\n    padding-top: 5rem;\n  }\n  .sm\\:pr-20 {\n    padding-right: 5rem;\n  }\n  .sm\\:pb-20 {\n    padding-bottom: 5rem;\n  }\n  .sm\\:pl-20 {\n    padding-left: 5rem;\n  }\n  .sm\\:pt-24 {\n    padding-top: 6rem;\n  }\n  .sm\\:pr-24 {\n    padding-right: 6rem;\n  }\n  .sm\\:pb-24 {\n    padding-bottom: 6rem;\n  }\n  .sm\\:pl-24 {\n    padding-left: 6rem;\n  }\n  .sm\\:pt-28 {\n    padding-top: 7rem;\n  }\n  .sm\\:pr-28 {\n    padding-right: 7rem;\n  }\n  .sm\\:pb-28 {\n    padding-bottom: 7rem;\n  }\n  .sm\\:pl-28 {\n    padding-left: 7rem;\n  }\n  .sm\\:pt-32 {\n    padding-top: 8rem;\n  }\n  .sm\\:pr-32 {\n    padding-right: 8rem;\n  }\n  .sm\\:pb-32 {\n    padding-bottom: 8rem;\n  }\n  .sm\\:pl-32 {\n    padding-left: 8rem;\n  }\n  .sm\\:pt-36 {\n    padding-top: 9rem;\n  }\n  .sm\\:pr-36 {\n    padding-right: 9rem;\n  }\n  .sm\\:pb-36 {\n    padding-bottom: 9rem;\n  }\n  .sm\\:pl-36 {\n    padding-left: 9rem;\n  }\n  .sm\\:pt-40 {\n    padding-top: 10rem;\n  }\n  .sm\\:pr-40 {\n    padding-right: 10rem;\n  }\n  .sm\\:pb-40 {\n    padding-bottom: 10rem;\n  }\n  .sm\\:pl-40 {\n    padding-left: 10rem;\n  }\n  .sm\\:pt-44 {\n    padding-top: 11rem;\n  }\n  .sm\\:pr-44 {\n    padding-right: 11rem;\n  }\n  .sm\\:pb-44 {\n    padding-bottom: 11rem;\n  }\n  .sm\\:pl-44 {\n    padding-left: 11rem;\n  }\n  .sm\\:pt-48 {\n    padding-top: 12rem;\n  }\n  .sm\\:pr-48 {\n    padding-right: 12rem;\n  }\n  .sm\\:pb-48 {\n    padding-bottom: 12rem;\n  }\n  .sm\\:pl-48 {\n    padding-left: 12rem;\n  }\n  .sm\\:pt-52 {\n    padding-top: 13rem;\n  }\n  .sm\\:pr-52 {\n    padding-right: 13rem;\n  }\n  .sm\\:pb-52 {\n    padding-bottom: 13rem;\n  }\n  .sm\\:pl-52 {\n    padding-left: 13rem;\n  }\n  .sm\\:pt-56 {\n    padding-top: 14rem;\n  }\n  .sm\\:pr-56 {\n    padding-right: 14rem;\n  }\n  .sm\\:pb-56 {\n    padding-bottom: 14rem;\n  }\n  .sm\\:pl-56 {\n    padding-left: 14rem;\n  }\n  .sm\\:pt-60 {\n    padding-top: 15rem;\n  }\n  .sm\\:pr-60 {\n    padding-right: 15rem;\n  }\n  .sm\\:pb-60 {\n    padding-bottom: 15rem;\n  }\n  .sm\\:pl-60 {\n    padding-left: 15rem;\n  }\n  .sm\\:pt-64 {\n    padding-top: 16rem;\n  }\n  .sm\\:pr-64 {\n    padding-right: 16rem;\n  }\n  .sm\\:pb-64 {\n    padding-bottom: 16rem;\n  }\n  .sm\\:pl-64 {\n    padding-left: 16rem;\n  }\n  .sm\\:pt-72 {\n    padding-top: 18rem;\n  }\n  .sm\\:pr-72 {\n    padding-right: 18rem;\n  }\n  .sm\\:pb-72 {\n    padding-bottom: 18rem;\n  }\n  .sm\\:pl-72 {\n    padding-left: 18rem;\n  }\n  .sm\\:pt-80 {\n    padding-top: 20rem;\n  }\n  .sm\\:pr-80 {\n    padding-right: 20rem;\n  }\n  .sm\\:pb-80 {\n    padding-bottom: 20rem;\n  }\n  .sm\\:pl-80 {\n    padding-left: 20rem;\n  }\n  .sm\\:pt-96 {\n    padding-top: 24rem;\n  }\n  .sm\\:pr-96 {\n    padding-right: 24rem;\n  }\n  .sm\\:pb-96 {\n    padding-bottom: 24rem;\n  }\n  .sm\\:pl-96 {\n    padding-left: 24rem;\n  }\n  .sm\\:pt-px {\n    padding-top: 1px;\n  }\n  .sm\\:pr-px {\n    padding-right: 1px;\n  }\n  .sm\\:pb-px {\n    padding-bottom: 1px;\n  }\n  .sm\\:pl-px {\n    padding-left: 1px;\n  }\n  .sm\\:pt-0\\.5 {\n    padding-top: 0.125rem;\n  }\n  .sm\\:pr-0\\.5 {\n    padding-right: 0.125rem;\n  }\n  .sm\\:pb-0\\.5 {\n    padding-bottom: 0.125rem;\n  }\n  .sm\\:pl-0\\.5 {\n    padding-left: 0.125rem;\n  }\n  .sm\\:pt-1\\.5 {\n    padding-top: 0.375rem;\n  }\n  .sm\\:pr-1\\.5 {\n    padding-right: 0.375rem;\n  }\n  .sm\\:pb-1\\.5 {\n    padding-bottom: 0.375rem;\n  }\n  .sm\\:pl-1\\.5 {\n    padding-left: 0.375rem;\n  }\n  .sm\\:pt-2\\.5 {\n    padding-top: 0.625rem;\n  }\n  .sm\\:pr-2\\.5 {\n    padding-right: 0.625rem;\n  }\n  .sm\\:pb-2\\.5 {\n    padding-bottom: 0.625rem;\n  }\n  .sm\\:pl-2\\.5 {\n    padding-left: 0.625rem;\n  }\n  .sm\\:pt-3\\.5 {\n    padding-top: 0.875rem;\n  }\n  .sm\\:pr-3\\.5 {\n    padding-right: 0.875rem;\n  }\n  .sm\\:pb-3\\.5 {\n    padding-bottom: 0.875rem;\n  }\n  .sm\\:pl-3\\.5 {\n    padding-left: 0.875rem;\n  }\n  .sm\\:pt-1\\/2 {\n    padding-top: 50%;\n  }\n  .sm\\:pr-1\\/2 {\n    padding-right: 50%;\n  }\n  .sm\\:pb-1\\/2 {\n    padding-bottom: 50%;\n  }\n  .sm\\:pl-1\\/2 {\n    padding-left: 50%;\n  }\n  .sm\\:pt-1\\/3 {\n    padding-top: 33.333333%;\n  }\n  .sm\\:pr-1\\/3 {\n    padding-right: 33.333333%;\n  }\n  .sm\\:pb-1\\/3 {\n    padding-bottom: 33.333333%;\n  }\n  .sm\\:pl-1\\/3 {\n    padding-left: 33.333333%;\n  }\n  .sm\\:pt-2\\/3 {\n    padding-top: 66.666667%;\n  }\n  .sm\\:pr-2\\/3 {\n    padding-right: 66.666667%;\n  }\n  .sm\\:pb-2\\/3 {\n    padding-bottom: 66.666667%;\n  }\n  .sm\\:pl-2\\/3 {\n    padding-left: 66.666667%;\n  }\n  .sm\\:pt-1\\/4 {\n    padding-top: 25%;\n  }\n  .sm\\:pr-1\\/4 {\n    padding-right: 25%;\n  }\n  .sm\\:pb-1\\/4 {\n    padding-bottom: 25%;\n  }\n  .sm\\:pl-1\\/4 {\n    padding-left: 25%;\n  }\n  .sm\\:pt-2\\/4 {\n    padding-top: 50%;\n  }\n  .sm\\:pr-2\\/4 {\n    padding-right: 50%;\n  }\n  .sm\\:pb-2\\/4 {\n    padding-bottom: 50%;\n  }\n  .sm\\:pl-2\\/4 {\n    padding-left: 50%;\n  }\n  .sm\\:pt-3\\/4 {\n    padding-top: 75%;\n  }\n  .sm\\:pr-3\\/4 {\n    padding-right: 75%;\n  }\n  .sm\\:pb-3\\/4 {\n    padding-bottom: 75%;\n  }\n  .sm\\:pl-3\\/4 {\n    padding-left: 75%;\n  }\n  .sm\\:pt-1\\/5 {\n    padding-top: 20%;\n  }\n  .sm\\:pr-1\\/5 {\n    padding-right: 20%;\n  }\n  .sm\\:pb-1\\/5 {\n    padding-bottom: 20%;\n  }\n  .sm\\:pl-1\\/5 {\n    padding-left: 20%;\n  }\n  .sm\\:pt-2\\/5 {\n    padding-top: 40%;\n  }\n  .sm\\:pr-2\\/5 {\n    padding-right: 40%;\n  }\n  .sm\\:pb-2\\/5 {\n    padding-bottom: 40%;\n  }\n  .sm\\:pl-2\\/5 {\n    padding-left: 40%;\n  }\n  .sm\\:pt-3\\/5 {\n    padding-top: 60%;\n  }\n  .sm\\:pr-3\\/5 {\n    padding-right: 60%;\n  }\n  .sm\\:pb-3\\/5 {\n    padding-bottom: 60%;\n  }\n  .sm\\:pl-3\\/5 {\n    padding-left: 60%;\n  }\n  .sm\\:pt-4\\/5 {\n    padding-top: 80%;\n  }\n  .sm\\:pr-4\\/5 {\n    padding-right: 80%;\n  }\n  .sm\\:pb-4\\/5 {\n    padding-bottom: 80%;\n  }\n  .sm\\:pl-4\\/5 {\n    padding-left: 80%;\n  }\n  .sm\\:pt-1\\/6 {\n    padding-top: 16.666667%;\n  }\n  .sm\\:pr-1\\/6 {\n    padding-right: 16.666667%;\n  }\n  .sm\\:pb-1\\/6 {\n    padding-bottom: 16.666667%;\n  }\n  .sm\\:pl-1\\/6 {\n    padding-left: 16.666667%;\n  }\n  .sm\\:pt-2\\/6 {\n    padding-top: 33.333333%;\n  }\n  .sm\\:pr-2\\/6 {\n    padding-right: 33.333333%;\n  }\n  .sm\\:pb-2\\/6 {\n    padding-bottom: 33.333333%;\n  }\n  .sm\\:pl-2\\/6 {\n    padding-left: 33.333333%;\n  }\n  .sm\\:pt-3\\/6 {\n    padding-top: 50%;\n  }\n  .sm\\:pr-3\\/6 {\n    padding-right: 50%;\n  }\n  .sm\\:pb-3\\/6 {\n    padding-bottom: 50%;\n  }\n  .sm\\:pl-3\\/6 {\n    padding-left: 50%;\n  }\n  .sm\\:pt-4\\/6 {\n    padding-top: 66.666667%;\n  }\n  .sm\\:pr-4\\/6 {\n    padding-right: 66.666667%;\n  }\n  .sm\\:pb-4\\/6 {\n    padding-bottom: 66.666667%;\n  }\n  .sm\\:pl-4\\/6 {\n    padding-left: 66.666667%;\n  }\n  .sm\\:pt-5\\/6 {\n    padding-top: 83.333333%;\n  }\n  .sm\\:pr-5\\/6 {\n    padding-right: 83.333333%;\n  }\n  .sm\\:pb-5\\/6 {\n    padding-bottom: 83.333333%;\n  }\n  .sm\\:pl-5\\/6 {\n    padding-left: 83.333333%;\n  }\n  .sm\\:pt-1\\/12 {\n    padding-top: 8.333333%;\n  }\n  .sm\\:pr-1\\/12 {\n    padding-right: 8.333333%;\n  }\n  .sm\\:pb-1\\/12 {\n    padding-bottom: 8.333333%;\n  }\n  .sm\\:pl-1\\/12 {\n    padding-left: 8.333333%;\n  }\n  .sm\\:pt-2\\/12 {\n    padding-top: 16.666667%;\n  }\n  .sm\\:pr-2\\/12 {\n    padding-right: 16.666667%;\n  }\n  .sm\\:pb-2\\/12 {\n    padding-bottom: 16.666667%;\n  }\n  .sm\\:pl-2\\/12 {\n    padding-left: 16.666667%;\n  }\n  .sm\\:pt-3\\/12 {\n    padding-top: 25%;\n  }\n  .sm\\:pr-3\\/12 {\n    padding-right: 25%;\n  }\n  .sm\\:pb-3\\/12 {\n    padding-bottom: 25%;\n  }\n  .sm\\:pl-3\\/12 {\n    padding-left: 25%;\n  }\n  .sm\\:pt-4\\/12 {\n    padding-top: 33.333333%;\n  }\n  .sm\\:pr-4\\/12 {\n    padding-right: 33.333333%;\n  }\n  .sm\\:pb-4\\/12 {\n    padding-bottom: 33.333333%;\n  }\n  .sm\\:pl-4\\/12 {\n    padding-left: 33.333333%;\n  }\n  .sm\\:pt-5\\/12 {\n    padding-top: 41.666667%;\n  }\n  .sm\\:pr-5\\/12 {\n    padding-right: 41.666667%;\n  }\n  .sm\\:pb-5\\/12 {\n    padding-bottom: 41.666667%;\n  }\n  .sm\\:pl-5\\/12 {\n    padding-left: 41.666667%;\n  }\n  .sm\\:pt-6\\/12 {\n    padding-top: 50%;\n  }\n  .sm\\:pr-6\\/12 {\n    padding-right: 50%;\n  }\n  .sm\\:pb-6\\/12 {\n    padding-bottom: 50%;\n  }\n  .sm\\:pl-6\\/12 {\n    padding-left: 50%;\n  }\n  .sm\\:pt-7\\/12 {\n    padding-top: 58.333333%;\n  }\n  .sm\\:pr-7\\/12 {\n    padding-right: 58.333333%;\n  }\n  .sm\\:pb-7\\/12 {\n    padding-bottom: 58.333333%;\n  }\n  .sm\\:pl-7\\/12 {\n    padding-left: 58.333333%;\n  }\n  .sm\\:pt-8\\/12 {\n    padding-top: 66.666667%;\n  }\n  .sm\\:pr-8\\/12 {\n    padding-right: 66.666667%;\n  }\n  .sm\\:pb-8\\/12 {\n    padding-bottom: 66.666667%;\n  }\n  .sm\\:pl-8\\/12 {\n    padding-left: 66.666667%;\n  }\n  .sm\\:pt-9\\/12 {\n    padding-top: 75%;\n  }\n  .sm\\:pr-9\\/12 {\n    padding-right: 75%;\n  }\n  .sm\\:pb-9\\/12 {\n    padding-bottom: 75%;\n  }\n  .sm\\:pl-9\\/12 {\n    padding-left: 75%;\n  }\n  .sm\\:pt-10\\/12 {\n    padding-top: 83.333333%;\n  }\n  .sm\\:pr-10\\/12 {\n    padding-right: 83.333333%;\n  }\n  .sm\\:pb-10\\/12 {\n    padding-bottom: 83.333333%;\n  }\n  .sm\\:pl-10\\/12 {\n    padding-left: 83.333333%;\n  }\n  .sm\\:pt-11\\/12 {\n    padding-top: 91.666667%;\n  }\n  .sm\\:pr-11\\/12 {\n    padding-right: 91.666667%;\n  }\n  .sm\\:pb-11\\/12 {\n    padding-bottom: 91.666667%;\n  }\n  .sm\\:pl-11\\/12 {\n    padding-left: 91.666667%;\n  }\n  .sm\\:pt-full {\n    padding-top: 100%;\n  }\n  .sm\\:pr-full {\n    padding-right: 100%;\n  }\n  .sm\\:pb-full {\n    padding-bottom: 100%;\n  }\n  .sm\\:pl-full {\n    padding-left: 100%;\n  }\n  .sm\\:placeholder-current::-moz-placeholder {\n    color: currentColor;\n  }\n  .sm\\:placeholder-current::placeholder {\n    color: currentColor;\n  }\n  .sm\\:placeholder-transparent::-moz-placeholder {\n    color: transparent;\n  }\n  .sm\\:placeholder-transparent::placeholder {\n    color: transparent;\n  }\n  .sm\\:placeholder-white::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #ffffff;\n    color: rgba(255, 255, 255, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-white::placeholder {\n    --placeholder-opacity: 1;\n    color: #ffffff;\n    color: rgba(255, 255, 255, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-black::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #000000;\n    color: rgba(0, 0, 0, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-black::placeholder {\n    --placeholder-opacity: 1;\n    color: #000000;\n    color: rgba(0, 0, 0, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-gray-50::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #f9fafb;\n    color: rgba(249, 250, 251, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-gray-50::placeholder {\n    --placeholder-opacity: 1;\n    color: #f9fafb;\n    color: rgba(249, 250, 251, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-gray-100::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #f4f5f7;\n    color: rgba(244, 245, 247, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-gray-100::placeholder {\n    --placeholder-opacity: 1;\n    color: #f4f5f7;\n    color: rgba(244, 245, 247, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-gray-200::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #e5e7eb;\n    color: rgba(229, 231, 235, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-gray-200::placeholder {\n    --placeholder-opacity: 1;\n    color: #e5e7eb;\n    color: rgba(229, 231, 235, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-gray-300::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #d2d6dc;\n    color: rgba(210, 214, 220, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-gray-300::placeholder {\n    --placeholder-opacity: 1;\n    color: #d2d6dc;\n    color: rgba(210, 214, 220, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-gray-400::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #9fa6b2;\n    color: rgba(159, 166, 178, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-gray-400::placeholder {\n    --placeholder-opacity: 1;\n    color: #9fa6b2;\n    color: rgba(159, 166, 178, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-gray-500::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #6b7280;\n    color: rgba(107, 114, 128, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-gray-500::placeholder {\n    --placeholder-opacity: 1;\n    color: #6b7280;\n    color: rgba(107, 114, 128, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-gray-600::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #4b5563;\n    color: rgba(75, 85, 99, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-gray-600::placeholder {\n    --placeholder-opacity: 1;\n    color: #4b5563;\n    color: rgba(75, 85, 99, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-gray-700::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #374151;\n    color: rgba(55, 65, 81, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-gray-700::placeholder {\n    --placeholder-opacity: 1;\n    color: #374151;\n    color: rgba(55, 65, 81, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-gray-800::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #252f3f;\n    color: rgba(37, 47, 63, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-gray-800::placeholder {\n    --placeholder-opacity: 1;\n    color: #252f3f;\n    color: rgba(37, 47, 63, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-gray-900::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #161e2e;\n    color: rgba(22, 30, 46, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-gray-900::placeholder {\n    --placeholder-opacity: 1;\n    color: #161e2e;\n    color: rgba(22, 30, 46, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-red-50::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #fdf2f2;\n    color: rgba(253, 242, 242, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-red-50::placeholder {\n    --placeholder-opacity: 1;\n    color: #fdf2f2;\n    color: rgba(253, 242, 242, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-red-100::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #fde8e8;\n    color: rgba(253, 232, 232, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-red-100::placeholder {\n    --placeholder-opacity: 1;\n    color: #fde8e8;\n    color: rgba(253, 232, 232, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-red-200::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #fbd5d5;\n    color: rgba(251, 213, 213, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-red-200::placeholder {\n    --placeholder-opacity: 1;\n    color: #fbd5d5;\n    color: rgba(251, 213, 213, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-red-300::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #f8b4b4;\n    color: rgba(248, 180, 180, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-red-300::placeholder {\n    --placeholder-opacity: 1;\n    color: #f8b4b4;\n    color: rgba(248, 180, 180, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-red-400::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #f98080;\n    color: rgba(249, 128, 128, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-red-400::placeholder {\n    --placeholder-opacity: 1;\n    color: #f98080;\n    color: rgba(249, 128, 128, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-red-500::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #f05252;\n    color: rgba(240, 82, 82, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-red-500::placeholder {\n    --placeholder-opacity: 1;\n    color: #f05252;\n    color: rgba(240, 82, 82, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-red-600::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #e02424;\n    color: rgba(224, 36, 36, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-red-600::placeholder {\n    --placeholder-opacity: 1;\n    color: #e02424;\n    color: rgba(224, 36, 36, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-red-700::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #c81e1e;\n    color: rgba(200, 30, 30, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-red-700::placeholder {\n    --placeholder-opacity: 1;\n    color: #c81e1e;\n    color: rgba(200, 30, 30, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-red-800::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #9b1c1c;\n    color: rgba(155, 28, 28, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-red-800::placeholder {\n    --placeholder-opacity: 1;\n    color: #9b1c1c;\n    color: rgba(155, 28, 28, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-red-900::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #771d1d;\n    color: rgba(119, 29, 29, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-red-900::placeholder {\n    --placeholder-opacity: 1;\n    color: #771d1d;\n    color: rgba(119, 29, 29, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-orange-50::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #fff8f1;\n    color: rgba(255, 248, 241, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-orange-50::placeholder {\n    --placeholder-opacity: 1;\n    color: #fff8f1;\n    color: rgba(255, 248, 241, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-orange-100::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #feecdc;\n    color: rgba(254, 236, 220, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-orange-100::placeholder {\n    --placeholder-opacity: 1;\n    color: #feecdc;\n    color: rgba(254, 236, 220, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-orange-200::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #fcd9bd;\n    color: rgba(252, 217, 189, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-orange-200::placeholder {\n    --placeholder-opacity: 1;\n    color: #fcd9bd;\n    color: rgba(252, 217, 189, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-orange-300::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #fdba8c;\n    color: rgba(253, 186, 140, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-orange-300::placeholder {\n    --placeholder-opacity: 1;\n    color: #fdba8c;\n    color: rgba(253, 186, 140, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-orange-400::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #ff8a4c;\n    color: rgba(255, 138, 76, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-orange-400::placeholder {\n    --placeholder-opacity: 1;\n    color: #ff8a4c;\n    color: rgba(255, 138, 76, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-orange-500::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #ff5a1f;\n    color: rgba(255, 90, 31, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-orange-500::placeholder {\n    --placeholder-opacity: 1;\n    color: #ff5a1f;\n    color: rgba(255, 90, 31, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-orange-600::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #d03801;\n    color: rgba(208, 56, 1, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-orange-600::placeholder {\n    --placeholder-opacity: 1;\n    color: #d03801;\n    color: rgba(208, 56, 1, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-orange-700::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #b43403;\n    color: rgba(180, 52, 3, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-orange-700::placeholder {\n    --placeholder-opacity: 1;\n    color: #b43403;\n    color: rgba(180, 52, 3, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-orange-800::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #8a2c0d;\n    color: rgba(138, 44, 13, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-orange-800::placeholder {\n    --placeholder-opacity: 1;\n    color: #8a2c0d;\n    color: rgba(138, 44, 13, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-orange-900::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #73230d;\n    color: rgba(115, 35, 13, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-orange-900::placeholder {\n    --placeholder-opacity: 1;\n    color: #73230d;\n    color: rgba(115, 35, 13, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-yellow-50::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #fdfdea;\n    color: rgba(253, 253, 234, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-yellow-50::placeholder {\n    --placeholder-opacity: 1;\n    color: #fdfdea;\n    color: rgba(253, 253, 234, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-yellow-100::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #fdf6b2;\n    color: rgba(253, 246, 178, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-yellow-100::placeholder {\n    --placeholder-opacity: 1;\n    color: #fdf6b2;\n    color: rgba(253, 246, 178, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-yellow-200::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #fce96a;\n    color: rgba(252, 233, 106, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-yellow-200::placeholder {\n    --placeholder-opacity: 1;\n    color: #fce96a;\n    color: rgba(252, 233, 106, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-yellow-300::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #faca15;\n    color: rgba(250, 202, 21, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-yellow-300::placeholder {\n    --placeholder-opacity: 1;\n    color: #faca15;\n    color: rgba(250, 202, 21, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-yellow-400::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #e3a008;\n    color: rgba(227, 160, 8, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-yellow-400::placeholder {\n    --placeholder-opacity: 1;\n    color: #e3a008;\n    color: rgba(227, 160, 8, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-yellow-500::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #c27803;\n    color: rgba(194, 120, 3, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-yellow-500::placeholder {\n    --placeholder-opacity: 1;\n    color: #c27803;\n    color: rgba(194, 120, 3, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-yellow-600::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #9f580a;\n    color: rgba(159, 88, 10, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-yellow-600::placeholder {\n    --placeholder-opacity: 1;\n    color: #9f580a;\n    color: rgba(159, 88, 10, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-yellow-700::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #8e4b10;\n    color: rgba(142, 75, 16, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-yellow-700::placeholder {\n    --placeholder-opacity: 1;\n    color: #8e4b10;\n    color: rgba(142, 75, 16, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-yellow-800::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #723b13;\n    color: rgba(114, 59, 19, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-yellow-800::placeholder {\n    --placeholder-opacity: 1;\n    color: #723b13;\n    color: rgba(114, 59, 19, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-yellow-900::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #633112;\n    color: rgba(99, 49, 18, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-yellow-900::placeholder {\n    --placeholder-opacity: 1;\n    color: #633112;\n    color: rgba(99, 49, 18, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-green-50::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #f3faf7;\n    color: rgba(243, 250, 247, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-green-50::placeholder {\n    --placeholder-opacity: 1;\n    color: #f3faf7;\n    color: rgba(243, 250, 247, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-green-100::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #def7ec;\n    color: rgba(222, 247, 236, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-green-100::placeholder {\n    --placeholder-opacity: 1;\n    color: #def7ec;\n    color: rgba(222, 247, 236, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-green-200::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #bcf0da;\n    color: rgba(188, 240, 218, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-green-200::placeholder {\n    --placeholder-opacity: 1;\n    color: #bcf0da;\n    color: rgba(188, 240, 218, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-green-300::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #84e1bc;\n    color: rgba(132, 225, 188, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-green-300::placeholder {\n    --placeholder-opacity: 1;\n    color: #84e1bc;\n    color: rgba(132, 225, 188, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-green-400::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #31c48d;\n    color: rgba(49, 196, 141, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-green-400::placeholder {\n    --placeholder-opacity: 1;\n    color: #31c48d;\n    color: rgba(49, 196, 141, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-green-500::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #0e9f6e;\n    color: rgba(14, 159, 110, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-green-500::placeholder {\n    --placeholder-opacity: 1;\n    color: #0e9f6e;\n    color: rgba(14, 159, 110, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-green-600::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #057a55;\n    color: rgba(5, 122, 85, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-green-600::placeholder {\n    --placeholder-opacity: 1;\n    color: #057a55;\n    color: rgba(5, 122, 85, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-green-700::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #046c4e;\n    color: rgba(4, 108, 78, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-green-700::placeholder {\n    --placeholder-opacity: 1;\n    color: #046c4e;\n    color: rgba(4, 108, 78, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-green-800::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #03543f;\n    color: rgba(3, 84, 63, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-green-800::placeholder {\n    --placeholder-opacity: 1;\n    color: #03543f;\n    color: rgba(3, 84, 63, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-green-900::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #014737;\n    color: rgba(1, 71, 55, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-green-900::placeholder {\n    --placeholder-opacity: 1;\n    color: #014737;\n    color: rgba(1, 71, 55, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-teal-50::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #edfafa;\n    color: rgba(237, 250, 250, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-teal-50::placeholder {\n    --placeholder-opacity: 1;\n    color: #edfafa;\n    color: rgba(237, 250, 250, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-teal-100::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #d5f5f6;\n    color: rgba(213, 245, 246, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-teal-100::placeholder {\n    --placeholder-opacity: 1;\n    color: #d5f5f6;\n    color: rgba(213, 245, 246, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-teal-200::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #afecef;\n    color: rgba(175, 236, 239, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-teal-200::placeholder {\n    --placeholder-opacity: 1;\n    color: #afecef;\n    color: rgba(175, 236, 239, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-teal-300::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #7edce2;\n    color: rgba(126, 220, 226, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-teal-300::placeholder {\n    --placeholder-opacity: 1;\n    color: #7edce2;\n    color: rgba(126, 220, 226, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-teal-400::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #16bdca;\n    color: rgba(22, 189, 202, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-teal-400::placeholder {\n    --placeholder-opacity: 1;\n    color: #16bdca;\n    color: rgba(22, 189, 202, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-teal-500::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #0694a2;\n    color: rgba(6, 148, 162, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-teal-500::placeholder {\n    --placeholder-opacity: 1;\n    color: #0694a2;\n    color: rgba(6, 148, 162, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-teal-600::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #047481;\n    color: rgba(4, 116, 129, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-teal-600::placeholder {\n    --placeholder-opacity: 1;\n    color: #047481;\n    color: rgba(4, 116, 129, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-teal-700::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #036672;\n    color: rgba(3, 102, 114, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-teal-700::placeholder {\n    --placeholder-opacity: 1;\n    color: #036672;\n    color: rgba(3, 102, 114, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-teal-800::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #05505c;\n    color: rgba(5, 80, 92, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-teal-800::placeholder {\n    --placeholder-opacity: 1;\n    color: #05505c;\n    color: rgba(5, 80, 92, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-teal-900::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #014451;\n    color: rgba(1, 68, 81, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-teal-900::placeholder {\n    --placeholder-opacity: 1;\n    color: #014451;\n    color: rgba(1, 68, 81, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-blue-50::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #ebf5ff;\n    color: rgba(235, 245, 255, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-blue-50::placeholder {\n    --placeholder-opacity: 1;\n    color: #ebf5ff;\n    color: rgba(235, 245, 255, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-blue-100::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #e1effe;\n    color: rgba(225, 239, 254, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-blue-100::placeholder {\n    --placeholder-opacity: 1;\n    color: #e1effe;\n    color: rgba(225, 239, 254, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-blue-200::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #c3ddfd;\n    color: rgba(195, 221, 253, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-blue-200::placeholder {\n    --placeholder-opacity: 1;\n    color: #c3ddfd;\n    color: rgba(195, 221, 253, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-blue-300::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #a4cafe;\n    color: rgba(164, 202, 254, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-blue-300::placeholder {\n    --placeholder-opacity: 1;\n    color: #a4cafe;\n    color: rgba(164, 202, 254, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-blue-400::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #76a9fa;\n    color: rgba(118, 169, 250, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-blue-400::placeholder {\n    --placeholder-opacity: 1;\n    color: #76a9fa;\n    color: rgba(118, 169, 250, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-blue-500::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #3f83f8;\n    color: rgba(63, 131, 248, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-blue-500::placeholder {\n    --placeholder-opacity: 1;\n    color: #3f83f8;\n    color: rgba(63, 131, 248, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-blue-600::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #1c64f2;\n    color: rgba(28, 100, 242, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-blue-600::placeholder {\n    --placeholder-opacity: 1;\n    color: #1c64f2;\n    color: rgba(28, 100, 242, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-blue-700::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #1a56db;\n    color: rgba(26, 86, 219, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-blue-700::placeholder {\n    --placeholder-opacity: 1;\n    color: #1a56db;\n    color: rgba(26, 86, 219, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-blue-800::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #1e429f;\n    color: rgba(30, 66, 159, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-blue-800::placeholder {\n    --placeholder-opacity: 1;\n    color: #1e429f;\n    color: rgba(30, 66, 159, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-blue-900::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #233876;\n    color: rgba(35, 56, 118, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-blue-900::placeholder {\n    --placeholder-opacity: 1;\n    color: #233876;\n    color: rgba(35, 56, 118, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-indigo-50::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #f0f5ff;\n    color: rgba(240, 245, 255, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-indigo-50::placeholder {\n    --placeholder-opacity: 1;\n    color: #f0f5ff;\n    color: rgba(240, 245, 255, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-indigo-100::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #e5edff;\n    color: rgba(229, 237, 255, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-indigo-100::placeholder {\n    --placeholder-opacity: 1;\n    color: #e5edff;\n    color: rgba(229, 237, 255, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-indigo-200::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #cddbfe;\n    color: rgba(205, 219, 254, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-indigo-200::placeholder {\n    --placeholder-opacity: 1;\n    color: #cddbfe;\n    color: rgba(205, 219, 254, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-indigo-300::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #b4c6fc;\n    color: rgba(180, 198, 252, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-indigo-300::placeholder {\n    --placeholder-opacity: 1;\n    color: #b4c6fc;\n    color: rgba(180, 198, 252, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-indigo-400::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #8da2fb;\n    color: rgba(141, 162, 251, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-indigo-400::placeholder {\n    --placeholder-opacity: 1;\n    color: #8da2fb;\n    color: rgba(141, 162, 251, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-indigo-500::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #6875f5;\n    color: rgba(104, 117, 245, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-indigo-500::placeholder {\n    --placeholder-opacity: 1;\n    color: #6875f5;\n    color: rgba(104, 117, 245, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-indigo-600::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #5850ec;\n    color: rgba(88, 80, 236, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-indigo-600::placeholder {\n    --placeholder-opacity: 1;\n    color: #5850ec;\n    color: rgba(88, 80, 236, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-indigo-700::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #5145cd;\n    color: rgba(81, 69, 205, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-indigo-700::placeholder {\n    --placeholder-opacity: 1;\n    color: #5145cd;\n    color: rgba(81, 69, 205, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-indigo-800::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #42389d;\n    color: rgba(66, 56, 157, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-indigo-800::placeholder {\n    --placeholder-opacity: 1;\n    color: #42389d;\n    color: rgba(66, 56, 157, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-indigo-900::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #362f78;\n    color: rgba(54, 47, 120, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-indigo-900::placeholder {\n    --placeholder-opacity: 1;\n    color: #362f78;\n    color: rgba(54, 47, 120, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-purple-50::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #f6f5ff;\n    color: rgba(246, 245, 255, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-purple-50::placeholder {\n    --placeholder-opacity: 1;\n    color: #f6f5ff;\n    color: rgba(246, 245, 255, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-purple-100::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #edebfe;\n    color: rgba(237, 235, 254, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-purple-100::placeholder {\n    --placeholder-opacity: 1;\n    color: #edebfe;\n    color: rgba(237, 235, 254, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-purple-200::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #dcd7fe;\n    color: rgba(220, 215, 254, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-purple-200::placeholder {\n    --placeholder-opacity: 1;\n    color: #dcd7fe;\n    color: rgba(220, 215, 254, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-purple-300::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #cabffd;\n    color: rgba(202, 191, 253, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-purple-300::placeholder {\n    --placeholder-opacity: 1;\n    color: #cabffd;\n    color: rgba(202, 191, 253, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-purple-400::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #ac94fa;\n    color: rgba(172, 148, 250, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-purple-400::placeholder {\n    --placeholder-opacity: 1;\n    color: #ac94fa;\n    color: rgba(172, 148, 250, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-purple-500::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #9061f9;\n    color: rgba(144, 97, 249, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-purple-500::placeholder {\n    --placeholder-opacity: 1;\n    color: #9061f9;\n    color: rgba(144, 97, 249, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-purple-600::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #7e3af2;\n    color: rgba(126, 58, 242, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-purple-600::placeholder {\n    --placeholder-opacity: 1;\n    color: #7e3af2;\n    color: rgba(126, 58, 242, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-purple-700::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #6c2bd9;\n    color: rgba(108, 43, 217, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-purple-700::placeholder {\n    --placeholder-opacity: 1;\n    color: #6c2bd9;\n    color: rgba(108, 43, 217, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-purple-800::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #5521b5;\n    color: rgba(85, 33, 181, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-purple-800::placeholder {\n    --placeholder-opacity: 1;\n    color: #5521b5;\n    color: rgba(85, 33, 181, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-purple-900::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #4a1d96;\n    color: rgba(74, 29, 150, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-purple-900::placeholder {\n    --placeholder-opacity: 1;\n    color: #4a1d96;\n    color: rgba(74, 29, 150, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-pink-50::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #fdf2f8;\n    color: rgba(253, 242, 248, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-pink-50::placeholder {\n    --placeholder-opacity: 1;\n    color: #fdf2f8;\n    color: rgba(253, 242, 248, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-pink-100::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #fce8f3;\n    color: rgba(252, 232, 243, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-pink-100::placeholder {\n    --placeholder-opacity: 1;\n    color: #fce8f3;\n    color: rgba(252, 232, 243, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-pink-200::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #fad1e8;\n    color: rgba(250, 209, 232, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-pink-200::placeholder {\n    --placeholder-opacity: 1;\n    color: #fad1e8;\n    color: rgba(250, 209, 232, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-pink-300::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #f8b4d9;\n    color: rgba(248, 180, 217, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-pink-300::placeholder {\n    --placeholder-opacity: 1;\n    color: #f8b4d9;\n    color: rgba(248, 180, 217, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-pink-400::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #f17eb8;\n    color: rgba(241, 126, 184, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-pink-400::placeholder {\n    --placeholder-opacity: 1;\n    color: #f17eb8;\n    color: rgba(241, 126, 184, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-pink-500::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #e74694;\n    color: rgba(231, 70, 148, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-pink-500::placeholder {\n    --placeholder-opacity: 1;\n    color: #e74694;\n    color: rgba(231, 70, 148, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-pink-600::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #d61f69;\n    color: rgba(214, 31, 105, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-pink-600::placeholder {\n    --placeholder-opacity: 1;\n    color: #d61f69;\n    color: rgba(214, 31, 105, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-pink-700::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #bf125d;\n    color: rgba(191, 18, 93, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-pink-700::placeholder {\n    --placeholder-opacity: 1;\n    color: #bf125d;\n    color: rgba(191, 18, 93, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-pink-800::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #99154b;\n    color: rgba(153, 21, 75, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-pink-800::placeholder {\n    --placeholder-opacity: 1;\n    color: #99154b;\n    color: rgba(153, 21, 75, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-pink-900::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #751a3d;\n    color: rgba(117, 26, 61, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-pink-900::placeholder {\n    --placeholder-opacity: 1;\n    color: #751a3d;\n    color: rgba(117, 26, 61, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-cool-gray-50::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #f8fafc;\n    color: rgba(248, 250, 252, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-cool-gray-50::placeholder {\n    --placeholder-opacity: 1;\n    color: #f8fafc;\n    color: rgba(248, 250, 252, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-cool-gray-100::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #f1f5f9;\n    color: rgba(241, 245, 249, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-cool-gray-100::placeholder {\n    --placeholder-opacity: 1;\n    color: #f1f5f9;\n    color: rgba(241, 245, 249, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-cool-gray-200::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #e2e8f0;\n    color: rgba(226, 232, 240, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-cool-gray-200::placeholder {\n    --placeholder-opacity: 1;\n    color: #e2e8f0;\n    color: rgba(226, 232, 240, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-cool-gray-300::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #cfd8e3;\n    color: rgba(207, 216, 227, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-cool-gray-300::placeholder {\n    --placeholder-opacity: 1;\n    color: #cfd8e3;\n    color: rgba(207, 216, 227, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-cool-gray-400::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #97a6ba;\n    color: rgba(151, 166, 186, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-cool-gray-400::placeholder {\n    --placeholder-opacity: 1;\n    color: #97a6ba;\n    color: rgba(151, 166, 186, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-cool-gray-500::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #64748b;\n    color: rgba(100, 116, 139, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-cool-gray-500::placeholder {\n    --placeholder-opacity: 1;\n    color: #64748b;\n    color: rgba(100, 116, 139, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-cool-gray-600::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #475569;\n    color: rgba(71, 85, 105, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-cool-gray-600::placeholder {\n    --placeholder-opacity: 1;\n    color: #475569;\n    color: rgba(71, 85, 105, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-cool-gray-700::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #364152;\n    color: rgba(54, 65, 82, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-cool-gray-700::placeholder {\n    --placeholder-opacity: 1;\n    color: #364152;\n    color: rgba(54, 65, 82, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-cool-gray-800::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #27303f;\n    color: rgba(39, 48, 63, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-cool-gray-800::placeholder {\n    --placeholder-opacity: 1;\n    color: #27303f;\n    color: rgba(39, 48, 63, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-cool-gray-900::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #1a202e;\n    color: rgba(26, 32, 46, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-cool-gray-900::placeholder {\n    --placeholder-opacity: 1;\n    color: #1a202e;\n    color: rgba(26, 32, 46, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-current:focus::-moz-placeholder {\n    color: currentColor;\n  }\n  .sm\\:focus\\:placeholder-current:focus::placeholder {\n    color: currentColor;\n  }\n  .sm\\:focus\\:placeholder-transparent:focus::-moz-placeholder {\n    color: transparent;\n  }\n  .sm\\:focus\\:placeholder-transparent:focus::placeholder {\n    color: transparent;\n  }\n  .sm\\:focus\\:placeholder-white:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #ffffff;\n    color: rgba(255, 255, 255, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-white:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #ffffff;\n    color: rgba(255, 255, 255, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-black:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #000000;\n    color: rgba(0, 0, 0, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-black:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #000000;\n    color: rgba(0, 0, 0, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-gray-50:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #f9fafb;\n    color: rgba(249, 250, 251, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-gray-50:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #f9fafb;\n    color: rgba(249, 250, 251, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-gray-100:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #f4f5f7;\n    color: rgba(244, 245, 247, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-gray-100:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #f4f5f7;\n    color: rgba(244, 245, 247, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-gray-200:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #e5e7eb;\n    color: rgba(229, 231, 235, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-gray-200:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #e5e7eb;\n    color: rgba(229, 231, 235, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-gray-300:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #d2d6dc;\n    color: rgba(210, 214, 220, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-gray-300:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #d2d6dc;\n    color: rgba(210, 214, 220, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-gray-400:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #9fa6b2;\n    color: rgba(159, 166, 178, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-gray-400:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #9fa6b2;\n    color: rgba(159, 166, 178, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-gray-500:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #6b7280;\n    color: rgba(107, 114, 128, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-gray-500:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #6b7280;\n    color: rgba(107, 114, 128, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-gray-600:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #4b5563;\n    color: rgba(75, 85, 99, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-gray-600:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #4b5563;\n    color: rgba(75, 85, 99, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-gray-700:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #374151;\n    color: rgba(55, 65, 81, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-gray-700:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #374151;\n    color: rgba(55, 65, 81, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-gray-800:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #252f3f;\n    color: rgba(37, 47, 63, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-gray-800:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #252f3f;\n    color: rgba(37, 47, 63, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-gray-900:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #161e2e;\n    color: rgba(22, 30, 46, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-gray-900:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #161e2e;\n    color: rgba(22, 30, 46, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-red-50:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #fdf2f2;\n    color: rgba(253, 242, 242, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-red-50:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #fdf2f2;\n    color: rgba(253, 242, 242, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-red-100:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #fde8e8;\n    color: rgba(253, 232, 232, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-red-100:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #fde8e8;\n    color: rgba(253, 232, 232, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-red-200:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #fbd5d5;\n    color: rgba(251, 213, 213, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-red-200:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #fbd5d5;\n    color: rgba(251, 213, 213, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-red-300:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #f8b4b4;\n    color: rgba(248, 180, 180, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-red-300:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #f8b4b4;\n    color: rgba(248, 180, 180, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-red-400:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #f98080;\n    color: rgba(249, 128, 128, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-red-400:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #f98080;\n    color: rgba(249, 128, 128, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-red-500:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #f05252;\n    color: rgba(240, 82, 82, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-red-500:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #f05252;\n    color: rgba(240, 82, 82, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-red-600:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #e02424;\n    color: rgba(224, 36, 36, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-red-600:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #e02424;\n    color: rgba(224, 36, 36, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-red-700:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #c81e1e;\n    color: rgba(200, 30, 30, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-red-700:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #c81e1e;\n    color: rgba(200, 30, 30, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-red-800:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #9b1c1c;\n    color: rgba(155, 28, 28, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-red-800:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #9b1c1c;\n    color: rgba(155, 28, 28, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-red-900:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #771d1d;\n    color: rgba(119, 29, 29, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-red-900:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #771d1d;\n    color: rgba(119, 29, 29, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-orange-50:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #fff8f1;\n    color: rgba(255, 248, 241, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-orange-50:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #fff8f1;\n    color: rgba(255, 248, 241, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-orange-100:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #feecdc;\n    color: rgba(254, 236, 220, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-orange-100:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #feecdc;\n    color: rgba(254, 236, 220, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-orange-200:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #fcd9bd;\n    color: rgba(252, 217, 189, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-orange-200:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #fcd9bd;\n    color: rgba(252, 217, 189, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-orange-300:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #fdba8c;\n    color: rgba(253, 186, 140, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-orange-300:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #fdba8c;\n    color: rgba(253, 186, 140, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-orange-400:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #ff8a4c;\n    color: rgba(255, 138, 76, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-orange-400:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #ff8a4c;\n    color: rgba(255, 138, 76, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-orange-500:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #ff5a1f;\n    color: rgba(255, 90, 31, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-orange-500:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #ff5a1f;\n    color: rgba(255, 90, 31, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-orange-600:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #d03801;\n    color: rgba(208, 56, 1, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-orange-600:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #d03801;\n    color: rgba(208, 56, 1, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-orange-700:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #b43403;\n    color: rgba(180, 52, 3, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-orange-700:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #b43403;\n    color: rgba(180, 52, 3, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-orange-800:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #8a2c0d;\n    color: rgba(138, 44, 13, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-orange-800:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #8a2c0d;\n    color: rgba(138, 44, 13, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-orange-900:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #73230d;\n    color: rgba(115, 35, 13, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-orange-900:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #73230d;\n    color: rgba(115, 35, 13, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-yellow-50:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #fdfdea;\n    color: rgba(253, 253, 234, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-yellow-50:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #fdfdea;\n    color: rgba(253, 253, 234, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-yellow-100:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #fdf6b2;\n    color: rgba(253, 246, 178, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-yellow-100:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #fdf6b2;\n    color: rgba(253, 246, 178, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-yellow-200:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #fce96a;\n    color: rgba(252, 233, 106, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-yellow-200:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #fce96a;\n    color: rgba(252, 233, 106, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-yellow-300:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #faca15;\n    color: rgba(250, 202, 21, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-yellow-300:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #faca15;\n    color: rgba(250, 202, 21, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-yellow-400:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #e3a008;\n    color: rgba(227, 160, 8, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-yellow-400:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #e3a008;\n    color: rgba(227, 160, 8, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-yellow-500:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #c27803;\n    color: rgba(194, 120, 3, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-yellow-500:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #c27803;\n    color: rgba(194, 120, 3, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-yellow-600:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #9f580a;\n    color: rgba(159, 88, 10, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-yellow-600:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #9f580a;\n    color: rgba(159, 88, 10, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-yellow-700:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #8e4b10;\n    color: rgba(142, 75, 16, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-yellow-700:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #8e4b10;\n    color: rgba(142, 75, 16, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-yellow-800:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #723b13;\n    color: rgba(114, 59, 19, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-yellow-800:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #723b13;\n    color: rgba(114, 59, 19, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-yellow-900:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #633112;\n    color: rgba(99, 49, 18, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-yellow-900:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #633112;\n    color: rgba(99, 49, 18, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-green-50:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #f3faf7;\n    color: rgba(243, 250, 247, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-green-50:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #f3faf7;\n    color: rgba(243, 250, 247, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-green-100:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #def7ec;\n    color: rgba(222, 247, 236, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-green-100:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #def7ec;\n    color: rgba(222, 247, 236, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-green-200:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #bcf0da;\n    color: rgba(188, 240, 218, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-green-200:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #bcf0da;\n    color: rgba(188, 240, 218, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-green-300:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #84e1bc;\n    color: rgba(132, 225, 188, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-green-300:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #84e1bc;\n    color: rgba(132, 225, 188, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-green-400:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #31c48d;\n    color: rgba(49, 196, 141, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-green-400:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #31c48d;\n    color: rgba(49, 196, 141, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-green-500:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #0e9f6e;\n    color: rgba(14, 159, 110, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-green-500:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #0e9f6e;\n    color: rgba(14, 159, 110, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-green-600:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #057a55;\n    color: rgba(5, 122, 85, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-green-600:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #057a55;\n    color: rgba(5, 122, 85, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-green-700:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #046c4e;\n    color: rgba(4, 108, 78, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-green-700:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #046c4e;\n    color: rgba(4, 108, 78, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-green-800:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #03543f;\n    color: rgba(3, 84, 63, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-green-800:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #03543f;\n    color: rgba(3, 84, 63, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-green-900:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #014737;\n    color: rgba(1, 71, 55, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-green-900:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #014737;\n    color: rgba(1, 71, 55, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-teal-50:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #edfafa;\n    color: rgba(237, 250, 250, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-teal-50:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #edfafa;\n    color: rgba(237, 250, 250, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-teal-100:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #d5f5f6;\n    color: rgba(213, 245, 246, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-teal-100:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #d5f5f6;\n    color: rgba(213, 245, 246, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-teal-200:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #afecef;\n    color: rgba(175, 236, 239, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-teal-200:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #afecef;\n    color: rgba(175, 236, 239, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-teal-300:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #7edce2;\n    color: rgba(126, 220, 226, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-teal-300:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #7edce2;\n    color: rgba(126, 220, 226, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-teal-400:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #16bdca;\n    color: rgba(22, 189, 202, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-teal-400:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #16bdca;\n    color: rgba(22, 189, 202, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-teal-500:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #0694a2;\n    color: rgba(6, 148, 162, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-teal-500:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #0694a2;\n    color: rgba(6, 148, 162, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-teal-600:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #047481;\n    color: rgba(4, 116, 129, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-teal-600:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #047481;\n    color: rgba(4, 116, 129, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-teal-700:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #036672;\n    color: rgba(3, 102, 114, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-teal-700:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #036672;\n    color: rgba(3, 102, 114, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-teal-800:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #05505c;\n    color: rgba(5, 80, 92, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-teal-800:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #05505c;\n    color: rgba(5, 80, 92, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-teal-900:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #014451;\n    color: rgba(1, 68, 81, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-teal-900:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #014451;\n    color: rgba(1, 68, 81, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-blue-50:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #ebf5ff;\n    color: rgba(235, 245, 255, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-blue-50:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #ebf5ff;\n    color: rgba(235, 245, 255, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-blue-100:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #e1effe;\n    color: rgba(225, 239, 254, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-blue-100:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #e1effe;\n    color: rgba(225, 239, 254, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-blue-200:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #c3ddfd;\n    color: rgba(195, 221, 253, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-blue-200:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #c3ddfd;\n    color: rgba(195, 221, 253, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-blue-300:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #a4cafe;\n    color: rgba(164, 202, 254, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-blue-300:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #a4cafe;\n    color: rgba(164, 202, 254, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-blue-400:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #76a9fa;\n    color: rgba(118, 169, 250, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-blue-400:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #76a9fa;\n    color: rgba(118, 169, 250, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-blue-500:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #3f83f8;\n    color: rgba(63, 131, 248, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-blue-500:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #3f83f8;\n    color: rgba(63, 131, 248, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-blue-600:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #1c64f2;\n    color: rgba(28, 100, 242, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-blue-600:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #1c64f2;\n    color: rgba(28, 100, 242, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-blue-700:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #1a56db;\n    color: rgba(26, 86, 219, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-blue-700:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #1a56db;\n    color: rgba(26, 86, 219, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-blue-800:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #1e429f;\n    color: rgba(30, 66, 159, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-blue-800:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #1e429f;\n    color: rgba(30, 66, 159, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-blue-900:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #233876;\n    color: rgba(35, 56, 118, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-blue-900:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #233876;\n    color: rgba(35, 56, 118, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-indigo-50:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #f0f5ff;\n    color: rgba(240, 245, 255, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-indigo-50:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #f0f5ff;\n    color: rgba(240, 245, 255, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-indigo-100:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #e5edff;\n    color: rgba(229, 237, 255, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-indigo-100:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #e5edff;\n    color: rgba(229, 237, 255, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-indigo-200:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #cddbfe;\n    color: rgba(205, 219, 254, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-indigo-200:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #cddbfe;\n    color: rgba(205, 219, 254, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-indigo-300:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #b4c6fc;\n    color: rgba(180, 198, 252, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-indigo-300:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #b4c6fc;\n    color: rgba(180, 198, 252, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-indigo-400:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #8da2fb;\n    color: rgba(141, 162, 251, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-indigo-400:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #8da2fb;\n    color: rgba(141, 162, 251, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-indigo-500:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #6875f5;\n    color: rgba(104, 117, 245, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-indigo-500:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #6875f5;\n    color: rgba(104, 117, 245, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-indigo-600:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #5850ec;\n    color: rgba(88, 80, 236, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-indigo-600:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #5850ec;\n    color: rgba(88, 80, 236, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-indigo-700:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #5145cd;\n    color: rgba(81, 69, 205, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-indigo-700:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #5145cd;\n    color: rgba(81, 69, 205, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-indigo-800:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #42389d;\n    color: rgba(66, 56, 157, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-indigo-800:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #42389d;\n    color: rgba(66, 56, 157, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-indigo-900:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #362f78;\n    color: rgba(54, 47, 120, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-indigo-900:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #362f78;\n    color: rgba(54, 47, 120, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-purple-50:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #f6f5ff;\n    color: rgba(246, 245, 255, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-purple-50:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #f6f5ff;\n    color: rgba(246, 245, 255, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-purple-100:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #edebfe;\n    color: rgba(237, 235, 254, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-purple-100:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #edebfe;\n    color: rgba(237, 235, 254, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-purple-200:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #dcd7fe;\n    color: rgba(220, 215, 254, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-purple-200:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #dcd7fe;\n    color: rgba(220, 215, 254, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-purple-300:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #cabffd;\n    color: rgba(202, 191, 253, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-purple-300:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #cabffd;\n    color: rgba(202, 191, 253, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-purple-400:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #ac94fa;\n    color: rgba(172, 148, 250, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-purple-400:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #ac94fa;\n    color: rgba(172, 148, 250, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-purple-500:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #9061f9;\n    color: rgba(144, 97, 249, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-purple-500:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #9061f9;\n    color: rgba(144, 97, 249, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-purple-600:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #7e3af2;\n    color: rgba(126, 58, 242, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-purple-600:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #7e3af2;\n    color: rgba(126, 58, 242, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-purple-700:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #6c2bd9;\n    color: rgba(108, 43, 217, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-purple-700:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #6c2bd9;\n    color: rgba(108, 43, 217, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-purple-800:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #5521b5;\n    color: rgba(85, 33, 181, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-purple-800:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #5521b5;\n    color: rgba(85, 33, 181, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-purple-900:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #4a1d96;\n    color: rgba(74, 29, 150, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-purple-900:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #4a1d96;\n    color: rgba(74, 29, 150, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-pink-50:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #fdf2f8;\n    color: rgba(253, 242, 248, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-pink-50:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #fdf2f8;\n    color: rgba(253, 242, 248, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-pink-100:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #fce8f3;\n    color: rgba(252, 232, 243, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-pink-100:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #fce8f3;\n    color: rgba(252, 232, 243, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-pink-200:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #fad1e8;\n    color: rgba(250, 209, 232, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-pink-200:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #fad1e8;\n    color: rgba(250, 209, 232, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-pink-300:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #f8b4d9;\n    color: rgba(248, 180, 217, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-pink-300:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #f8b4d9;\n    color: rgba(248, 180, 217, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-pink-400:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #f17eb8;\n    color: rgba(241, 126, 184, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-pink-400:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #f17eb8;\n    color: rgba(241, 126, 184, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-pink-500:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #e74694;\n    color: rgba(231, 70, 148, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-pink-500:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #e74694;\n    color: rgba(231, 70, 148, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-pink-600:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #d61f69;\n    color: rgba(214, 31, 105, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-pink-600:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #d61f69;\n    color: rgba(214, 31, 105, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-pink-700:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #bf125d;\n    color: rgba(191, 18, 93, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-pink-700:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #bf125d;\n    color: rgba(191, 18, 93, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-pink-800:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #99154b;\n    color: rgba(153, 21, 75, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-pink-800:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #99154b;\n    color: rgba(153, 21, 75, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-pink-900:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #751a3d;\n    color: rgba(117, 26, 61, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-pink-900:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #751a3d;\n    color: rgba(117, 26, 61, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-cool-gray-50:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #f8fafc;\n    color: rgba(248, 250, 252, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-cool-gray-50:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #f8fafc;\n    color: rgba(248, 250, 252, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-cool-gray-100:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #f1f5f9;\n    color: rgba(241, 245, 249, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-cool-gray-100:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #f1f5f9;\n    color: rgba(241, 245, 249, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-cool-gray-200:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #e2e8f0;\n    color: rgba(226, 232, 240, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-cool-gray-200:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #e2e8f0;\n    color: rgba(226, 232, 240, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-cool-gray-300:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #cfd8e3;\n    color: rgba(207, 216, 227, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-cool-gray-300:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #cfd8e3;\n    color: rgba(207, 216, 227, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-cool-gray-400:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #97a6ba;\n    color: rgba(151, 166, 186, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-cool-gray-400:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #97a6ba;\n    color: rgba(151, 166, 186, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-cool-gray-500:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #64748b;\n    color: rgba(100, 116, 139, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-cool-gray-500:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #64748b;\n    color: rgba(100, 116, 139, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-cool-gray-600:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #475569;\n    color: rgba(71, 85, 105, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-cool-gray-600:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #475569;\n    color: rgba(71, 85, 105, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-cool-gray-700:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #364152;\n    color: rgba(54, 65, 82, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-cool-gray-700:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #364152;\n    color: rgba(54, 65, 82, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-cool-gray-800:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #27303f;\n    color: rgba(39, 48, 63, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-cool-gray-800:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #27303f;\n    color: rgba(39, 48, 63, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-cool-gray-900:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #1a202e;\n    color: rgba(26, 32, 46, var(--placeholder-opacity));\n  }\n  .sm\\:focus\\:placeholder-cool-gray-900:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #1a202e;\n    color: rgba(26, 32, 46, var(--placeholder-opacity));\n  }\n  .sm\\:placeholder-opacity-0::-moz-placeholder {\n    --placeholder-opacity: 0;\n  }\n  .sm\\:placeholder-opacity-0::placeholder {\n    --placeholder-opacity: 0;\n  }\n  .sm\\:placeholder-opacity-25::-moz-placeholder {\n    --placeholder-opacity: 0.25;\n  }\n  .sm\\:placeholder-opacity-25::placeholder {\n    --placeholder-opacity: 0.25;\n  }\n  .sm\\:placeholder-opacity-50::-moz-placeholder {\n    --placeholder-opacity: 0.5;\n  }\n  .sm\\:placeholder-opacity-50::placeholder {\n    --placeholder-opacity: 0.5;\n  }\n  .sm\\:placeholder-opacity-75::-moz-placeholder {\n    --placeholder-opacity: 0.75;\n  }\n  .sm\\:placeholder-opacity-75::placeholder {\n    --placeholder-opacity: 0.75;\n  }\n  .sm\\:placeholder-opacity-100::-moz-placeholder {\n    --placeholder-opacity: 1;\n  }\n  .sm\\:placeholder-opacity-100::placeholder {\n    --placeholder-opacity: 1;\n  }\n  .sm\\:focus\\:placeholder-opacity-0:focus::-moz-placeholder {\n    --placeholder-opacity: 0;\n  }\n  .sm\\:focus\\:placeholder-opacity-0:focus::placeholder {\n    --placeholder-opacity: 0;\n  }\n  .sm\\:focus\\:placeholder-opacity-25:focus::-moz-placeholder {\n    --placeholder-opacity: 0.25;\n  }\n  .sm\\:focus\\:placeholder-opacity-25:focus::placeholder {\n    --placeholder-opacity: 0.25;\n  }\n  .sm\\:focus\\:placeholder-opacity-50:focus::-moz-placeholder {\n    --placeholder-opacity: 0.5;\n  }\n  .sm\\:focus\\:placeholder-opacity-50:focus::placeholder {\n    --placeholder-opacity: 0.5;\n  }\n  .sm\\:focus\\:placeholder-opacity-75:focus::-moz-placeholder {\n    --placeholder-opacity: 0.75;\n  }\n  .sm\\:focus\\:placeholder-opacity-75:focus::placeholder {\n    --placeholder-opacity: 0.75;\n  }\n  .sm\\:focus\\:placeholder-opacity-100:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n  }\n  .sm\\:focus\\:placeholder-opacity-100:focus::placeholder {\n    --placeholder-opacity: 1;\n  }\n  .sm\\:pointer-events-none {\n    pointer-events: none;\n  }\n  .sm\\:pointer-events-auto {\n    pointer-events: auto;\n  }\n  .sm\\:static {\n    position: static;\n  }\n  .sm\\:fixed {\n    position: fixed;\n  }\n  .sm\\:absolute {\n    position: absolute;\n  }\n  .sm\\:relative {\n    position: relative;\n  }\n  .sm\\:sticky {\n    position: sticky;\n  }\n  .sm\\:inset-0 {\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n  }\n  .sm\\:inset-1 {\n    top: 0.25rem;\n    right: 0.25rem;\n    bottom: 0.25rem;\n    left: 0.25rem;\n  }\n  .sm\\:inset-2 {\n    top: 0.5rem;\n    right: 0.5rem;\n    bottom: 0.5rem;\n    left: 0.5rem;\n  }\n  .sm\\:inset-3 {\n    top: 0.75rem;\n    right: 0.75rem;\n    bottom: 0.75rem;\n    left: 0.75rem;\n  }\n  .sm\\:inset-4 {\n    top: 1rem;\n    right: 1rem;\n    bottom: 1rem;\n    left: 1rem;\n  }\n  .sm\\:inset-5 {\n    top: 1.25rem;\n    right: 1.25rem;\n    bottom: 1.25rem;\n    left: 1.25rem;\n  }\n  .sm\\:inset-6 {\n    top: 1.5rem;\n    right: 1.5rem;\n    bottom: 1.5rem;\n    left: 1.5rem;\n  }\n  .sm\\:inset-7 {\n    top: 1.75rem;\n    right: 1.75rem;\n    bottom: 1.75rem;\n    left: 1.75rem;\n  }\n  .sm\\:inset-8 {\n    top: 2rem;\n    right: 2rem;\n    bottom: 2rem;\n    left: 2rem;\n  }\n  .sm\\:inset-9 {\n    top: 2.25rem;\n    right: 2.25rem;\n    bottom: 2.25rem;\n    left: 2.25rem;\n  }\n  .sm\\:inset-10 {\n    top: 2.5rem;\n    right: 2.5rem;\n    bottom: 2.5rem;\n    left: 2.5rem;\n  }\n  .sm\\:inset-11 {\n    top: 2.75rem;\n    right: 2.75rem;\n    bottom: 2.75rem;\n    left: 2.75rem;\n  }\n  .sm\\:inset-12 {\n    top: 3rem;\n    right: 3rem;\n    bottom: 3rem;\n    left: 3rem;\n  }\n  .sm\\:inset-13 {\n    top: 3.25rem;\n    right: 3.25rem;\n    bottom: 3.25rem;\n    left: 3.25rem;\n  }\n  .sm\\:inset-14 {\n    top: 3.5rem;\n    right: 3.5rem;\n    bottom: 3.5rem;\n    left: 3.5rem;\n  }\n  .sm\\:inset-15 {\n    top: 3.75rem;\n    right: 3.75rem;\n    bottom: 3.75rem;\n    left: 3.75rem;\n  }\n  .sm\\:inset-16 {\n    top: 4rem;\n    right: 4rem;\n    bottom: 4rem;\n    left: 4rem;\n  }\n  .sm\\:inset-20 {\n    top: 5rem;\n    right: 5rem;\n    bottom: 5rem;\n    left: 5rem;\n  }\n  .sm\\:inset-24 {\n    top: 6rem;\n    right: 6rem;\n    bottom: 6rem;\n    left: 6rem;\n  }\n  .sm\\:inset-28 {\n    top: 7rem;\n    right: 7rem;\n    bottom: 7rem;\n    left: 7rem;\n  }\n  .sm\\:inset-32 {\n    top: 8rem;\n    right: 8rem;\n    bottom: 8rem;\n    left: 8rem;\n  }\n  .sm\\:inset-36 {\n    top: 9rem;\n    right: 9rem;\n    bottom: 9rem;\n    left: 9rem;\n  }\n  .sm\\:inset-40 {\n    top: 10rem;\n    right: 10rem;\n    bottom: 10rem;\n    left: 10rem;\n  }\n  .sm\\:inset-44 {\n    top: 11rem;\n    right: 11rem;\n    bottom: 11rem;\n    left: 11rem;\n  }\n  .sm\\:inset-48 {\n    top: 12rem;\n    right: 12rem;\n    bottom: 12rem;\n    left: 12rem;\n  }\n  .sm\\:inset-52 {\n    top: 13rem;\n    right: 13rem;\n    bottom: 13rem;\n    left: 13rem;\n  }\n  .sm\\:inset-56 {\n    top: 14rem;\n    right: 14rem;\n    bottom: 14rem;\n    left: 14rem;\n  }\n  .sm\\:inset-60 {\n    top: 15rem;\n    right: 15rem;\n    bottom: 15rem;\n    left: 15rem;\n  }\n  .sm\\:inset-64 {\n    top: 16rem;\n    right: 16rem;\n    bottom: 16rem;\n    left: 16rem;\n  }\n  .sm\\:inset-72 {\n    top: 18rem;\n    right: 18rem;\n    bottom: 18rem;\n    left: 18rem;\n  }\n  .sm\\:inset-80 {\n    top: 20rem;\n    right: 20rem;\n    bottom: 20rem;\n    left: 20rem;\n  }\n  .sm\\:inset-96 {\n    top: 24rem;\n    right: 24rem;\n    bottom: 24rem;\n    left: 24rem;\n  }\n  .sm\\:inset-auto {\n    top: auto;\n    right: auto;\n    bottom: auto;\n    left: auto;\n  }\n  .sm\\:inset-px {\n    top: 1px;\n    right: 1px;\n    bottom: 1px;\n    left: 1px;\n  }\n  .sm\\:inset-0\\.5 {\n    top: 0.125rem;\n    right: 0.125rem;\n    bottom: 0.125rem;\n    left: 0.125rem;\n  }\n  .sm\\:inset-1\\.5 {\n    top: 0.375rem;\n    right: 0.375rem;\n    bottom: 0.375rem;\n    left: 0.375rem;\n  }\n  .sm\\:inset-2\\.5 {\n    top: 0.625rem;\n    right: 0.625rem;\n    bottom: 0.625rem;\n    left: 0.625rem;\n  }\n  .sm\\:inset-3\\.5 {\n    top: 0.875rem;\n    right: 0.875rem;\n    bottom: 0.875rem;\n    left: 0.875rem;\n  }\n  .sm\\:inset-1\\/2 {\n    top: 50%;\n    right: 50%;\n    bottom: 50%;\n    left: 50%;\n  }\n  .sm\\:inset-1\\/3 {\n    top: 33.333333%;\n    right: 33.333333%;\n    bottom: 33.333333%;\n    left: 33.333333%;\n  }\n  .sm\\:inset-2\\/3 {\n    top: 66.666667%;\n    right: 66.666667%;\n    bottom: 66.666667%;\n    left: 66.666667%;\n  }\n  .sm\\:inset-1\\/4 {\n    top: 25%;\n    right: 25%;\n    bottom: 25%;\n    left: 25%;\n  }\n  .sm\\:inset-2\\/4 {\n    top: 50%;\n    right: 50%;\n    bottom: 50%;\n    left: 50%;\n  }\n  .sm\\:inset-3\\/4 {\n    top: 75%;\n    right: 75%;\n    bottom: 75%;\n    left: 75%;\n  }\n  .sm\\:inset-1\\/5 {\n    top: 20%;\n    right: 20%;\n    bottom: 20%;\n    left: 20%;\n  }\n  .sm\\:inset-2\\/5 {\n    top: 40%;\n    right: 40%;\n    bottom: 40%;\n    left: 40%;\n  }\n  .sm\\:inset-3\\/5 {\n    top: 60%;\n    right: 60%;\n    bottom: 60%;\n    left: 60%;\n  }\n  .sm\\:inset-4\\/5 {\n    top: 80%;\n    right: 80%;\n    bottom: 80%;\n    left: 80%;\n  }\n  .sm\\:inset-1\\/6 {\n    top: 16.666667%;\n    right: 16.666667%;\n    bottom: 16.666667%;\n    left: 16.666667%;\n  }\n  .sm\\:inset-2\\/6 {\n    top: 33.333333%;\n    right: 33.333333%;\n    bottom: 33.333333%;\n    left: 33.333333%;\n  }\n  .sm\\:inset-3\\/6 {\n    top: 50%;\n    right: 50%;\n    bottom: 50%;\n    left: 50%;\n  }\n  .sm\\:inset-4\\/6 {\n    top: 66.666667%;\n    right: 66.666667%;\n    bottom: 66.666667%;\n    left: 66.666667%;\n  }\n  .sm\\:inset-5\\/6 {\n    top: 83.333333%;\n    right: 83.333333%;\n    bottom: 83.333333%;\n    left: 83.333333%;\n  }\n  .sm\\:inset-1\\/12 {\n    top: 8.333333%;\n    right: 8.333333%;\n    bottom: 8.333333%;\n    left: 8.333333%;\n  }\n  .sm\\:inset-2\\/12 {\n    top: 16.666667%;\n    right: 16.666667%;\n    bottom: 16.666667%;\n    left: 16.666667%;\n  }\n  .sm\\:inset-3\\/12 {\n    top: 25%;\n    right: 25%;\n    bottom: 25%;\n    left: 25%;\n  }\n  .sm\\:inset-4\\/12 {\n    top: 33.333333%;\n    right: 33.333333%;\n    bottom: 33.333333%;\n    left: 33.333333%;\n  }\n  .sm\\:inset-5\\/12 {\n    top: 41.666667%;\n    right: 41.666667%;\n    bottom: 41.666667%;\n    left: 41.666667%;\n  }\n  .sm\\:inset-6\\/12 {\n    top: 50%;\n    right: 50%;\n    bottom: 50%;\n    left: 50%;\n  }\n  .sm\\:inset-7\\/12 {\n    top: 58.333333%;\n    right: 58.333333%;\n    bottom: 58.333333%;\n    left: 58.333333%;\n  }\n  .sm\\:inset-8\\/12 {\n    top: 66.666667%;\n    right: 66.666667%;\n    bottom: 66.666667%;\n    left: 66.666667%;\n  }\n  .sm\\:inset-9\\/12 {\n    top: 75%;\n    right: 75%;\n    bottom: 75%;\n    left: 75%;\n  }\n  .sm\\:inset-10\\/12 {\n    top: 83.333333%;\n    right: 83.333333%;\n    bottom: 83.333333%;\n    left: 83.333333%;\n  }\n  .sm\\:inset-11\\/12 {\n    top: 91.666667%;\n    right: 91.666667%;\n    bottom: 91.666667%;\n    left: 91.666667%;\n  }\n  .sm\\:inset-full {\n    top: 100%;\n    right: 100%;\n    bottom: 100%;\n    left: 100%;\n  }\n  .sm\\:inset-y-0 {\n    top: 0;\n    bottom: 0;\n  }\n  .sm\\:inset-x-0 {\n    right: 0;\n    left: 0;\n  }\n  .sm\\:inset-y-1 {\n    top: 0.25rem;\n    bottom: 0.25rem;\n  }\n  .sm\\:inset-x-1 {\n    right: 0.25rem;\n    left: 0.25rem;\n  }\n  .sm\\:inset-y-2 {\n    top: 0.5rem;\n    bottom: 0.5rem;\n  }\n  .sm\\:inset-x-2 {\n    right: 0.5rem;\n    left: 0.5rem;\n  }\n  .sm\\:inset-y-3 {\n    top: 0.75rem;\n    bottom: 0.75rem;\n  }\n  .sm\\:inset-x-3 {\n    right: 0.75rem;\n    left: 0.75rem;\n  }\n  .sm\\:inset-y-4 {\n    top: 1rem;\n    bottom: 1rem;\n  }\n  .sm\\:inset-x-4 {\n    right: 1rem;\n    left: 1rem;\n  }\n  .sm\\:inset-y-5 {\n    top: 1.25rem;\n    bottom: 1.25rem;\n  }\n  .sm\\:inset-x-5 {\n    right: 1.25rem;\n    left: 1.25rem;\n  }\n  .sm\\:inset-y-6 {\n    top: 1.5rem;\n    bottom: 1.5rem;\n  }\n  .sm\\:inset-x-6 {\n    right: 1.5rem;\n    left: 1.5rem;\n  }\n  .sm\\:inset-y-7 {\n    top: 1.75rem;\n    bottom: 1.75rem;\n  }\n  .sm\\:inset-x-7 {\n    right: 1.75rem;\n    left: 1.75rem;\n  }\n  .sm\\:inset-y-8 {\n    top: 2rem;\n    bottom: 2rem;\n  }\n  .sm\\:inset-x-8 {\n    right: 2rem;\n    left: 2rem;\n  }\n  .sm\\:inset-y-9 {\n    top: 2.25rem;\n    bottom: 2.25rem;\n  }\n  .sm\\:inset-x-9 {\n    right: 2.25rem;\n    left: 2.25rem;\n  }\n  .sm\\:inset-y-10 {\n    top: 2.5rem;\n    bottom: 2.5rem;\n  }\n  .sm\\:inset-x-10 {\n    right: 2.5rem;\n    left: 2.5rem;\n  }\n  .sm\\:inset-y-11 {\n    top: 2.75rem;\n    bottom: 2.75rem;\n  }\n  .sm\\:inset-x-11 {\n    right: 2.75rem;\n    left: 2.75rem;\n  }\n  .sm\\:inset-y-12 {\n    top: 3rem;\n    bottom: 3rem;\n  }\n  .sm\\:inset-x-12 {\n    right: 3rem;\n    left: 3rem;\n  }\n  .sm\\:inset-y-13 {\n    top: 3.25rem;\n    bottom: 3.25rem;\n  }\n  .sm\\:inset-x-13 {\n    right: 3.25rem;\n    left: 3.25rem;\n  }\n  .sm\\:inset-y-14 {\n    top: 3.5rem;\n    bottom: 3.5rem;\n  }\n  .sm\\:inset-x-14 {\n    right: 3.5rem;\n    left: 3.5rem;\n  }\n  .sm\\:inset-y-15 {\n    top: 3.75rem;\n    bottom: 3.75rem;\n  }\n  .sm\\:inset-x-15 {\n    right: 3.75rem;\n    left: 3.75rem;\n  }\n  .sm\\:inset-y-16 {\n    top: 4rem;\n    bottom: 4rem;\n  }\n  .sm\\:inset-x-16 {\n    right: 4rem;\n    left: 4rem;\n  }\n  .sm\\:inset-y-20 {\n    top: 5rem;\n    bottom: 5rem;\n  }\n  .sm\\:inset-x-20 {\n    right: 5rem;\n    left: 5rem;\n  }\n  .sm\\:inset-y-24 {\n    top: 6rem;\n    bottom: 6rem;\n  }\n  .sm\\:inset-x-24 {\n    right: 6rem;\n    left: 6rem;\n  }\n  .sm\\:inset-y-28 {\n    top: 7rem;\n    bottom: 7rem;\n  }\n  .sm\\:inset-x-28 {\n    right: 7rem;\n    left: 7rem;\n  }\n  .sm\\:inset-y-32 {\n    top: 8rem;\n    bottom: 8rem;\n  }\n  .sm\\:inset-x-32 {\n    right: 8rem;\n    left: 8rem;\n  }\n  .sm\\:inset-y-36 {\n    top: 9rem;\n    bottom: 9rem;\n  }\n  .sm\\:inset-x-36 {\n    right: 9rem;\n    left: 9rem;\n  }\n  .sm\\:inset-y-40 {\n    top: 10rem;\n    bottom: 10rem;\n  }\n  .sm\\:inset-x-40 {\n    right: 10rem;\n    left: 10rem;\n  }\n  .sm\\:inset-y-44 {\n    top: 11rem;\n    bottom: 11rem;\n  }\n  .sm\\:inset-x-44 {\n    right: 11rem;\n    left: 11rem;\n  }\n  .sm\\:inset-y-48 {\n    top: 12rem;\n    bottom: 12rem;\n  }\n  .sm\\:inset-x-48 {\n    right: 12rem;\n    left: 12rem;\n  }\n  .sm\\:inset-y-52 {\n    top: 13rem;\n    bottom: 13rem;\n  }\n  .sm\\:inset-x-52 {\n    right: 13rem;\n    left: 13rem;\n  }\n  .sm\\:inset-y-56 {\n    top: 14rem;\n    bottom: 14rem;\n  }\n  .sm\\:inset-x-56 {\n    right: 14rem;\n    left: 14rem;\n  }\n  .sm\\:inset-y-60 {\n    top: 15rem;\n    bottom: 15rem;\n  }\n  .sm\\:inset-x-60 {\n    right: 15rem;\n    left: 15rem;\n  }\n  .sm\\:inset-y-64 {\n    top: 16rem;\n    bottom: 16rem;\n  }\n  .sm\\:inset-x-64 {\n    right: 16rem;\n    left: 16rem;\n  }\n  .sm\\:inset-y-72 {\n    top: 18rem;\n    bottom: 18rem;\n  }\n  .sm\\:inset-x-72 {\n    right: 18rem;\n    left: 18rem;\n  }\n  .sm\\:inset-y-80 {\n    top: 20rem;\n    bottom: 20rem;\n  }\n  .sm\\:inset-x-80 {\n    right: 20rem;\n    left: 20rem;\n  }\n  .sm\\:inset-y-96 {\n    top: 24rem;\n    bottom: 24rem;\n  }\n  .sm\\:inset-x-96 {\n    right: 24rem;\n    left: 24rem;\n  }\n  .sm\\:inset-y-auto {\n    top: auto;\n    bottom: auto;\n  }\n  .sm\\:inset-x-auto {\n    right: auto;\n    left: auto;\n  }\n  .sm\\:inset-y-px {\n    top: 1px;\n    bottom: 1px;\n  }\n  .sm\\:inset-x-px {\n    right: 1px;\n    left: 1px;\n  }\n  .sm\\:inset-y-0\\.5 {\n    top: 0.125rem;\n    bottom: 0.125rem;\n  }\n  .sm\\:inset-x-0\\.5 {\n    right: 0.125rem;\n    left: 0.125rem;\n  }\n  .sm\\:inset-y-1\\.5 {\n    top: 0.375rem;\n    bottom: 0.375rem;\n  }\n  .sm\\:inset-x-1\\.5 {\n    right: 0.375rem;\n    left: 0.375rem;\n  }\n  .sm\\:inset-y-2\\.5 {\n    top: 0.625rem;\n    bottom: 0.625rem;\n  }\n  .sm\\:inset-x-2\\.5 {\n    right: 0.625rem;\n    left: 0.625rem;\n  }\n  .sm\\:inset-y-3\\.5 {\n    top: 0.875rem;\n    bottom: 0.875rem;\n  }\n  .sm\\:inset-x-3\\.5 {\n    right: 0.875rem;\n    left: 0.875rem;\n  }\n  .sm\\:inset-y-1\\/2 {\n    top: 50%;\n    bottom: 50%;\n  }\n  .sm\\:inset-x-1\\/2 {\n    right: 50%;\n    left: 50%;\n  }\n  .sm\\:inset-y-1\\/3 {\n    top: 33.333333%;\n    bottom: 33.333333%;\n  }\n  .sm\\:inset-x-1\\/3 {\n    right: 33.333333%;\n    left: 33.333333%;\n  }\n  .sm\\:inset-y-2\\/3 {\n    top: 66.666667%;\n    bottom: 66.666667%;\n  }\n  .sm\\:inset-x-2\\/3 {\n    right: 66.666667%;\n    left: 66.666667%;\n  }\n  .sm\\:inset-y-1\\/4 {\n    top: 25%;\n    bottom: 25%;\n  }\n  .sm\\:inset-x-1\\/4 {\n    right: 25%;\n    left: 25%;\n  }\n  .sm\\:inset-y-2\\/4 {\n    top: 50%;\n    bottom: 50%;\n  }\n  .sm\\:inset-x-2\\/4 {\n    right: 50%;\n    left: 50%;\n  }\n  .sm\\:inset-y-3\\/4 {\n    top: 75%;\n    bottom: 75%;\n  }\n  .sm\\:inset-x-3\\/4 {\n    right: 75%;\n    left: 75%;\n  }\n  .sm\\:inset-y-1\\/5 {\n    top: 20%;\n    bottom: 20%;\n  }\n  .sm\\:inset-x-1\\/5 {\n    right: 20%;\n    left: 20%;\n  }\n  .sm\\:inset-y-2\\/5 {\n    top: 40%;\n    bottom: 40%;\n  }\n  .sm\\:inset-x-2\\/5 {\n    right: 40%;\n    left: 40%;\n  }\n  .sm\\:inset-y-3\\/5 {\n    top: 60%;\n    bottom: 60%;\n  }\n  .sm\\:inset-x-3\\/5 {\n    right: 60%;\n    left: 60%;\n  }\n  .sm\\:inset-y-4\\/5 {\n    top: 80%;\n    bottom: 80%;\n  }\n  .sm\\:inset-x-4\\/5 {\n    right: 80%;\n    left: 80%;\n  }\n  .sm\\:inset-y-1\\/6 {\n    top: 16.666667%;\n    bottom: 16.666667%;\n  }\n  .sm\\:inset-x-1\\/6 {\n    right: 16.666667%;\n    left: 16.666667%;\n  }\n  .sm\\:inset-y-2\\/6 {\n    top: 33.333333%;\n    bottom: 33.333333%;\n  }\n  .sm\\:inset-x-2\\/6 {\n    right: 33.333333%;\n    left: 33.333333%;\n  }\n  .sm\\:inset-y-3\\/6 {\n    top: 50%;\n    bottom: 50%;\n  }\n  .sm\\:inset-x-3\\/6 {\n    right: 50%;\n    left: 50%;\n  }\n  .sm\\:inset-y-4\\/6 {\n    top: 66.666667%;\n    bottom: 66.666667%;\n  }\n  .sm\\:inset-x-4\\/6 {\n    right: 66.666667%;\n    left: 66.666667%;\n  }\n  .sm\\:inset-y-5\\/6 {\n    top: 83.333333%;\n    bottom: 83.333333%;\n  }\n  .sm\\:inset-x-5\\/6 {\n    right: 83.333333%;\n    left: 83.333333%;\n  }\n  .sm\\:inset-y-1\\/12 {\n    top: 8.333333%;\n    bottom: 8.333333%;\n  }\n  .sm\\:inset-x-1\\/12 {\n    right: 8.333333%;\n    left: 8.333333%;\n  }\n  .sm\\:inset-y-2\\/12 {\n    top: 16.666667%;\n    bottom: 16.666667%;\n  }\n  .sm\\:inset-x-2\\/12 {\n    right: 16.666667%;\n    left: 16.666667%;\n  }\n  .sm\\:inset-y-3\\/12 {\n    top: 25%;\n    bottom: 25%;\n  }\n  .sm\\:inset-x-3\\/12 {\n    right: 25%;\n    left: 25%;\n  }\n  .sm\\:inset-y-4\\/12 {\n    top: 33.333333%;\n    bottom: 33.333333%;\n  }\n  .sm\\:inset-x-4\\/12 {\n    right: 33.333333%;\n    left: 33.333333%;\n  }\n  .sm\\:inset-y-5\\/12 {\n    top: 41.666667%;\n    bottom: 41.666667%;\n  }\n  .sm\\:inset-x-5\\/12 {\n    right: 41.666667%;\n    left: 41.666667%;\n  }\n  .sm\\:inset-y-6\\/12 {\n    top: 50%;\n    bottom: 50%;\n  }\n  .sm\\:inset-x-6\\/12 {\n    right: 50%;\n    left: 50%;\n  }\n  .sm\\:inset-y-7\\/12 {\n    top: 58.333333%;\n    bottom: 58.333333%;\n  }\n  .sm\\:inset-x-7\\/12 {\n    right: 58.333333%;\n    left: 58.333333%;\n  }\n  .sm\\:inset-y-8\\/12 {\n    top: 66.666667%;\n    bottom: 66.666667%;\n  }\n  .sm\\:inset-x-8\\/12 {\n    right: 66.666667%;\n    left: 66.666667%;\n  }\n  .sm\\:inset-y-9\\/12 {\n    top: 75%;\n    bottom: 75%;\n  }\n  .sm\\:inset-x-9\\/12 {\n    right: 75%;\n    left: 75%;\n  }\n  .sm\\:inset-y-10\\/12 {\n    top: 83.333333%;\n    bottom: 83.333333%;\n  }\n  .sm\\:inset-x-10\\/12 {\n    right: 83.333333%;\n    left: 83.333333%;\n  }\n  .sm\\:inset-y-11\\/12 {\n    top: 91.666667%;\n    bottom: 91.666667%;\n  }\n  .sm\\:inset-x-11\\/12 {\n    right: 91.666667%;\n    left: 91.666667%;\n  }\n  .sm\\:inset-y-full {\n    top: 100%;\n    bottom: 100%;\n  }\n  .sm\\:inset-x-full {\n    right: 100%;\n    left: 100%;\n  }\n  .sm\\:top-0 {\n    top: 0;\n  }\n  .sm\\:right-0 {\n    right: 0;\n  }\n  .sm\\:bottom-0 {\n    bottom: 0;\n  }\n  .sm\\:left-0 {\n    left: 0;\n  }\n  .sm\\:top-1 {\n    top: 0.25rem;\n  }\n  .sm\\:right-1 {\n    right: 0.25rem;\n  }\n  .sm\\:bottom-1 {\n    bottom: 0.25rem;\n  }\n  .sm\\:left-1 {\n    left: 0.25rem;\n  }\n  .sm\\:top-2 {\n    top: 0.5rem;\n  }\n  .sm\\:right-2 {\n    right: 0.5rem;\n  }\n  .sm\\:bottom-2 {\n    bottom: 0.5rem;\n  }\n  .sm\\:left-2 {\n    left: 0.5rem;\n  }\n  .sm\\:top-3 {\n    top: 0.75rem;\n  }\n  .sm\\:right-3 {\n    right: 0.75rem;\n  }\n  .sm\\:bottom-3 {\n    bottom: 0.75rem;\n  }\n  .sm\\:left-3 {\n    left: 0.75rem;\n  }\n  .sm\\:top-4 {\n    top: 1rem;\n  }\n  .sm\\:right-4 {\n    right: 1rem;\n  }\n  .sm\\:bottom-4 {\n    bottom: 1rem;\n  }\n  .sm\\:left-4 {\n    left: 1rem;\n  }\n  .sm\\:top-5 {\n    top: 1.25rem;\n  }\n  .sm\\:right-5 {\n    right: 1.25rem;\n  }\n  .sm\\:bottom-5 {\n    bottom: 1.25rem;\n  }\n  .sm\\:left-5 {\n    left: 1.25rem;\n  }\n  .sm\\:top-6 {\n    top: 1.5rem;\n  }\n  .sm\\:right-6 {\n    right: 1.5rem;\n  }\n  .sm\\:bottom-6 {\n    bottom: 1.5rem;\n  }\n  .sm\\:left-6 {\n    left: 1.5rem;\n  }\n  .sm\\:top-7 {\n    top: 1.75rem;\n  }\n  .sm\\:right-7 {\n    right: 1.75rem;\n  }\n  .sm\\:bottom-7 {\n    bottom: 1.75rem;\n  }\n  .sm\\:left-7 {\n    left: 1.75rem;\n  }\n  .sm\\:top-8 {\n    top: 2rem;\n  }\n  .sm\\:right-8 {\n    right: 2rem;\n  }\n  .sm\\:bottom-8 {\n    bottom: 2rem;\n  }\n  .sm\\:left-8 {\n    left: 2rem;\n  }\n  .sm\\:top-9 {\n    top: 2.25rem;\n  }\n  .sm\\:right-9 {\n    right: 2.25rem;\n  }\n  .sm\\:bottom-9 {\n    bottom: 2.25rem;\n  }\n  .sm\\:left-9 {\n    left: 2.25rem;\n  }\n  .sm\\:top-10 {\n    top: 2.5rem;\n  }\n  .sm\\:right-10 {\n    right: 2.5rem;\n  }\n  .sm\\:bottom-10 {\n    bottom: 2.5rem;\n  }\n  .sm\\:left-10 {\n    left: 2.5rem;\n  }\n  .sm\\:top-11 {\n    top: 2.75rem;\n  }\n  .sm\\:right-11 {\n    right: 2.75rem;\n  }\n  .sm\\:bottom-11 {\n    bottom: 2.75rem;\n  }\n  .sm\\:left-11 {\n    left: 2.75rem;\n  }\n  .sm\\:top-12 {\n    top: 3rem;\n  }\n  .sm\\:right-12 {\n    right: 3rem;\n  }\n  .sm\\:bottom-12 {\n    bottom: 3rem;\n  }\n  .sm\\:left-12 {\n    left: 3rem;\n  }\n  .sm\\:top-13 {\n    top: 3.25rem;\n  }\n  .sm\\:right-13 {\n    right: 3.25rem;\n  }\n  .sm\\:bottom-13 {\n    bottom: 3.25rem;\n  }\n  .sm\\:left-13 {\n    left: 3.25rem;\n  }\n  .sm\\:top-14 {\n    top: 3.5rem;\n  }\n  .sm\\:right-14 {\n    right: 3.5rem;\n  }\n  .sm\\:bottom-14 {\n    bottom: 3.5rem;\n  }\n  .sm\\:left-14 {\n    left: 3.5rem;\n  }\n  .sm\\:top-15 {\n    top: 3.75rem;\n  }\n  .sm\\:right-15 {\n    right: 3.75rem;\n  }\n  .sm\\:bottom-15 {\n    bottom: 3.75rem;\n  }\n  .sm\\:left-15 {\n    left: 3.75rem;\n  }\n  .sm\\:top-16 {\n    top: 4rem;\n  }\n  .sm\\:right-16 {\n    right: 4rem;\n  }\n  .sm\\:bottom-16 {\n    bottom: 4rem;\n  }\n  .sm\\:left-16 {\n    left: 4rem;\n  }\n  .sm\\:top-20 {\n    top: 5rem;\n  }\n  .sm\\:right-20 {\n    right: 5rem;\n  }\n  .sm\\:bottom-20 {\n    bottom: 5rem;\n  }\n  .sm\\:left-20 {\n    left: 5rem;\n  }\n  .sm\\:top-24 {\n    top: 6rem;\n  }\n  .sm\\:right-24 {\n    right: 6rem;\n  }\n  .sm\\:bottom-24 {\n    bottom: 6rem;\n  }\n  .sm\\:left-24 {\n    left: 6rem;\n  }\n  .sm\\:top-28 {\n    top: 7rem;\n  }\n  .sm\\:right-28 {\n    right: 7rem;\n  }\n  .sm\\:bottom-28 {\n    bottom: 7rem;\n  }\n  .sm\\:left-28 {\n    left: 7rem;\n  }\n  .sm\\:top-32 {\n    top: 8rem;\n  }\n  .sm\\:right-32 {\n    right: 8rem;\n  }\n  .sm\\:bottom-32 {\n    bottom: 8rem;\n  }\n  .sm\\:left-32 {\n    left: 8rem;\n  }\n  .sm\\:top-36 {\n    top: 9rem;\n  }\n  .sm\\:right-36 {\n    right: 9rem;\n  }\n  .sm\\:bottom-36 {\n    bottom: 9rem;\n  }\n  .sm\\:left-36 {\n    left: 9rem;\n  }\n  .sm\\:top-40 {\n    top: 10rem;\n  }\n  .sm\\:right-40 {\n    right: 10rem;\n  }\n  .sm\\:bottom-40 {\n    bottom: 10rem;\n  }\n  .sm\\:left-40 {\n    left: 10rem;\n  }\n  .sm\\:top-44 {\n    top: 11rem;\n  }\n  .sm\\:right-44 {\n    right: 11rem;\n  }\n  .sm\\:bottom-44 {\n    bottom: 11rem;\n  }\n  .sm\\:left-44 {\n    left: 11rem;\n  }\n  .sm\\:top-48 {\n    top: 12rem;\n  }\n  .sm\\:right-48 {\n    right: 12rem;\n  }\n  .sm\\:bottom-48 {\n    bottom: 12rem;\n  }\n  .sm\\:left-48 {\n    left: 12rem;\n  }\n  .sm\\:top-52 {\n    top: 13rem;\n  }\n  .sm\\:right-52 {\n    right: 13rem;\n  }\n  .sm\\:bottom-52 {\n    bottom: 13rem;\n  }\n  .sm\\:left-52 {\n    left: 13rem;\n  }\n  .sm\\:top-56 {\n    top: 14rem;\n  }\n  .sm\\:right-56 {\n    right: 14rem;\n  }\n  .sm\\:bottom-56 {\n    bottom: 14rem;\n  }\n  .sm\\:left-56 {\n    left: 14rem;\n  }\n  .sm\\:top-60 {\n    top: 15rem;\n  }\n  .sm\\:right-60 {\n    right: 15rem;\n  }\n  .sm\\:bottom-60 {\n    bottom: 15rem;\n  }\n  .sm\\:left-60 {\n    left: 15rem;\n  }\n  .sm\\:top-64 {\n    top: 16rem;\n  }\n  .sm\\:right-64 {\n    right: 16rem;\n  }\n  .sm\\:bottom-64 {\n    bottom: 16rem;\n  }\n  .sm\\:left-64 {\n    left: 16rem;\n  }\n  .sm\\:top-72 {\n    top: 18rem;\n  }\n  .sm\\:right-72 {\n    right: 18rem;\n  }\n  .sm\\:bottom-72 {\n    bottom: 18rem;\n  }\n  .sm\\:left-72 {\n    left: 18rem;\n  }\n  .sm\\:top-80 {\n    top: 20rem;\n  }\n  .sm\\:right-80 {\n    right: 20rem;\n  }\n  .sm\\:bottom-80 {\n    bottom: 20rem;\n  }\n  .sm\\:left-80 {\n    left: 20rem;\n  }\n  .sm\\:top-96 {\n    top: 24rem;\n  }\n  .sm\\:right-96 {\n    right: 24rem;\n  }\n  .sm\\:bottom-96 {\n    bottom: 24rem;\n  }\n  .sm\\:left-96 {\n    left: 24rem;\n  }\n  .sm\\:top-auto {\n    top: auto;\n  }\n  .sm\\:right-auto {\n    right: auto;\n  }\n  .sm\\:bottom-auto {\n    bottom: auto;\n  }\n  .sm\\:left-auto {\n    left: auto;\n  }\n  .sm\\:top-px {\n    top: 1px;\n  }\n  .sm\\:right-px {\n    right: 1px;\n  }\n  .sm\\:bottom-px {\n    bottom: 1px;\n  }\n  .sm\\:left-px {\n    left: 1px;\n  }\n  .sm\\:top-0\\.5 {\n    top: 0.125rem;\n  }\n  .sm\\:right-0\\.5 {\n    right: 0.125rem;\n  }\n  .sm\\:bottom-0\\.5 {\n    bottom: 0.125rem;\n  }\n  .sm\\:left-0\\.5 {\n    left: 0.125rem;\n  }\n  .sm\\:top-1\\.5 {\n    top: 0.375rem;\n  }\n  .sm\\:right-1\\.5 {\n    right: 0.375rem;\n  }\n  .sm\\:bottom-1\\.5 {\n    bottom: 0.375rem;\n  }\n  .sm\\:left-1\\.5 {\n    left: 0.375rem;\n  }\n  .sm\\:top-2\\.5 {\n    top: 0.625rem;\n  }\n  .sm\\:right-2\\.5 {\n    right: 0.625rem;\n  }\n  .sm\\:bottom-2\\.5 {\n    bottom: 0.625rem;\n  }\n  .sm\\:left-2\\.5 {\n    left: 0.625rem;\n  }\n  .sm\\:top-3\\.5 {\n    top: 0.875rem;\n  }\n  .sm\\:right-3\\.5 {\n    right: 0.875rem;\n  }\n  .sm\\:bottom-3\\.5 {\n    bottom: 0.875rem;\n  }\n  .sm\\:left-3\\.5 {\n    left: 0.875rem;\n  }\n  .sm\\:top-1\\/2 {\n    top: 50%;\n  }\n  .sm\\:right-1\\/2 {\n    right: 50%;\n  }\n  .sm\\:bottom-1\\/2 {\n    bottom: 50%;\n  }\n  .sm\\:left-1\\/2 {\n    left: 50%;\n  }\n  .sm\\:top-1\\/3 {\n    top: 33.333333%;\n  }\n  .sm\\:right-1\\/3 {\n    right: 33.333333%;\n  }\n  .sm\\:bottom-1\\/3 {\n    bottom: 33.333333%;\n  }\n  .sm\\:left-1\\/3 {\n    left: 33.333333%;\n  }\n  .sm\\:top-2\\/3 {\n    top: 66.666667%;\n  }\n  .sm\\:right-2\\/3 {\n    right: 66.666667%;\n  }\n  .sm\\:bottom-2\\/3 {\n    bottom: 66.666667%;\n  }\n  .sm\\:left-2\\/3 {\n    left: 66.666667%;\n  }\n  .sm\\:top-1\\/4 {\n    top: 25%;\n  }\n  .sm\\:right-1\\/4 {\n    right: 25%;\n  }\n  .sm\\:bottom-1\\/4 {\n    bottom: 25%;\n  }\n  .sm\\:left-1\\/4 {\n    left: 25%;\n  }\n  .sm\\:top-2\\/4 {\n    top: 50%;\n  }\n  .sm\\:right-2\\/4 {\n    right: 50%;\n  }\n  .sm\\:bottom-2\\/4 {\n    bottom: 50%;\n  }\n  .sm\\:left-2\\/4 {\n    left: 50%;\n  }\n  .sm\\:top-3\\/4 {\n    top: 75%;\n  }\n  .sm\\:right-3\\/4 {\n    right: 75%;\n  }\n  .sm\\:bottom-3\\/4 {\n    bottom: 75%;\n  }\n  .sm\\:left-3\\/4 {\n    left: 75%;\n  }\n  .sm\\:top-1\\/5 {\n    top: 20%;\n  }\n  .sm\\:right-1\\/5 {\n    right: 20%;\n  }\n  .sm\\:bottom-1\\/5 {\n    bottom: 20%;\n  }\n  .sm\\:left-1\\/5 {\n    left: 20%;\n  }\n  .sm\\:top-2\\/5 {\n    top: 40%;\n  }\n  .sm\\:right-2\\/5 {\n    right: 40%;\n  }\n  .sm\\:bottom-2\\/5 {\n    bottom: 40%;\n  }\n  .sm\\:left-2\\/5 {\n    left: 40%;\n  }\n  .sm\\:top-3\\/5 {\n    top: 60%;\n  }\n  .sm\\:right-3\\/5 {\n    right: 60%;\n  }\n  .sm\\:bottom-3\\/5 {\n    bottom: 60%;\n  }\n  .sm\\:left-3\\/5 {\n    left: 60%;\n  }\n  .sm\\:top-4\\/5 {\n    top: 80%;\n  }\n  .sm\\:right-4\\/5 {\n    right: 80%;\n  }\n  .sm\\:bottom-4\\/5 {\n    bottom: 80%;\n  }\n  .sm\\:left-4\\/5 {\n    left: 80%;\n  }\n  .sm\\:top-1\\/6 {\n    top: 16.666667%;\n  }\n  .sm\\:right-1\\/6 {\n    right: 16.666667%;\n  }\n  .sm\\:bottom-1\\/6 {\n    bottom: 16.666667%;\n  }\n  .sm\\:left-1\\/6 {\n    left: 16.666667%;\n  }\n  .sm\\:top-2\\/6 {\n    top: 33.333333%;\n  }\n  .sm\\:right-2\\/6 {\n    right: 33.333333%;\n  }\n  .sm\\:bottom-2\\/6 {\n    bottom: 33.333333%;\n  }\n  .sm\\:left-2\\/6 {\n    left: 33.333333%;\n  }\n  .sm\\:top-3\\/6 {\n    top: 50%;\n  }\n  .sm\\:right-3\\/6 {\n    right: 50%;\n  }\n  .sm\\:bottom-3\\/6 {\n    bottom: 50%;\n  }\n  .sm\\:left-3\\/6 {\n    left: 50%;\n  }\n  .sm\\:top-4\\/6 {\n    top: 66.666667%;\n  }\n  .sm\\:right-4\\/6 {\n    right: 66.666667%;\n  }\n  .sm\\:bottom-4\\/6 {\n    bottom: 66.666667%;\n  }\n  .sm\\:left-4\\/6 {\n    left: 66.666667%;\n  }\n  .sm\\:top-5\\/6 {\n    top: 83.333333%;\n  }\n  .sm\\:right-5\\/6 {\n    right: 83.333333%;\n  }\n  .sm\\:bottom-5\\/6 {\n    bottom: 83.333333%;\n  }\n  .sm\\:left-5\\/6 {\n    left: 83.333333%;\n  }\n  .sm\\:top-1\\/12 {\n    top: 8.333333%;\n  }\n  .sm\\:right-1\\/12 {\n    right: 8.333333%;\n  }\n  .sm\\:bottom-1\\/12 {\n    bottom: 8.333333%;\n  }\n  .sm\\:left-1\\/12 {\n    left: 8.333333%;\n  }\n  .sm\\:top-2\\/12 {\n    top: 16.666667%;\n  }\n  .sm\\:right-2\\/12 {\n    right: 16.666667%;\n  }\n  .sm\\:bottom-2\\/12 {\n    bottom: 16.666667%;\n  }\n  .sm\\:left-2\\/12 {\n    left: 16.666667%;\n  }\n  .sm\\:top-3\\/12 {\n    top: 25%;\n  }\n  .sm\\:right-3\\/12 {\n    right: 25%;\n  }\n  .sm\\:bottom-3\\/12 {\n    bottom: 25%;\n  }\n  .sm\\:left-3\\/12 {\n    left: 25%;\n  }\n  .sm\\:top-4\\/12 {\n    top: 33.333333%;\n  }\n  .sm\\:right-4\\/12 {\n    right: 33.333333%;\n  }\n  .sm\\:bottom-4\\/12 {\n    bottom: 33.333333%;\n  }\n  .sm\\:left-4\\/12 {\n    left: 33.333333%;\n  }\n  .sm\\:top-5\\/12 {\n    top: 41.666667%;\n  }\n  .sm\\:right-5\\/12 {\n    right: 41.666667%;\n  }\n  .sm\\:bottom-5\\/12 {\n    bottom: 41.666667%;\n  }\n  .sm\\:left-5\\/12 {\n    left: 41.666667%;\n  }\n  .sm\\:top-6\\/12 {\n    top: 50%;\n  }\n  .sm\\:right-6\\/12 {\n    right: 50%;\n  }\n  .sm\\:bottom-6\\/12 {\n    bottom: 50%;\n  }\n  .sm\\:left-6\\/12 {\n    left: 50%;\n  }\n  .sm\\:top-7\\/12 {\n    top: 58.333333%;\n  }\n  .sm\\:right-7\\/12 {\n    right: 58.333333%;\n  }\n  .sm\\:bottom-7\\/12 {\n    bottom: 58.333333%;\n  }\n  .sm\\:left-7\\/12 {\n    left: 58.333333%;\n  }\n  .sm\\:top-8\\/12 {\n    top: 66.666667%;\n  }\n  .sm\\:right-8\\/12 {\n    right: 66.666667%;\n  }\n  .sm\\:bottom-8\\/12 {\n    bottom: 66.666667%;\n  }\n  .sm\\:left-8\\/12 {\n    left: 66.666667%;\n  }\n  .sm\\:top-9\\/12 {\n    top: 75%;\n  }\n  .sm\\:right-9\\/12 {\n    right: 75%;\n  }\n  .sm\\:bottom-9\\/12 {\n    bottom: 75%;\n  }\n  .sm\\:left-9\\/12 {\n    left: 75%;\n  }\n  .sm\\:top-10\\/12 {\n    top: 83.333333%;\n  }\n  .sm\\:right-10\\/12 {\n    right: 83.333333%;\n  }\n  .sm\\:bottom-10\\/12 {\n    bottom: 83.333333%;\n  }\n  .sm\\:left-10\\/12 {\n    left: 83.333333%;\n  }\n  .sm\\:top-11\\/12 {\n    top: 91.666667%;\n  }\n  .sm\\:right-11\\/12 {\n    right: 91.666667%;\n  }\n  .sm\\:bottom-11\\/12 {\n    bottom: 91.666667%;\n  }\n  .sm\\:left-11\\/12 {\n    left: 91.666667%;\n  }\n  .sm\\:top-full {\n    top: 100%;\n  }\n  .sm\\:right-full {\n    right: 100%;\n  }\n  .sm\\:bottom-full {\n    bottom: 100%;\n  }\n  .sm\\:left-full {\n    left: 100%;\n  }\n  .sm\\:resize-none {\n    resize: none;\n  }\n  .sm\\:resize-y {\n    resize: vertical;\n  }\n  .sm\\:resize-x {\n    resize: horizontal;\n  }\n  .sm\\:resize {\n    resize: both;\n  }\n  .sm\\:shadow-xs {\n    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.05);\n  }\n  .sm\\:shadow-sm {\n    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);\n  }\n  .sm\\:shadow {\n    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);\n  }\n  .sm\\:shadow-md {\n    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);\n  }\n  .sm\\:shadow-lg {\n    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);\n  }\n  .sm\\:shadow-xl {\n    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);\n  }\n  .sm\\:shadow-2xl {\n    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);\n  }\n  .sm\\:shadow-inner {\n    box-shadow: inset 0 2px 4px 0 rgba(0, 0, 0, 0.06);\n  }\n  .sm\\:shadow-outline {\n    box-shadow: 0 0 0 3px rgba(118, 169, 250, 0.45);\n  }\n  .sm\\:shadow-none {\n    box-shadow: none;\n  }\n  .sm\\:shadow-solid {\n    box-shadow: 0 0 0 2px currentColor;\n  }\n  .sm\\:shadow-outline-gray {\n    box-shadow: 0 0 0 3px rgba(159, 166, 178, 0.45);\n  }\n  .sm\\:shadow-outline-blue {\n    box-shadow: 0 0 0 3px rgba(164, 202, 254, 0.45);\n  }\n  .sm\\:shadow-outline-teal {\n    box-shadow: 0 0 0 3px rgba(126, 220, 226, 0.45);\n  }\n  .sm\\:shadow-outline-green {\n    box-shadow: 0 0 0 3px rgba(132, 225, 188, 0.45);\n  }\n  .sm\\:shadow-outline-yellow {\n    box-shadow: 0 0 0 3px rgba(250, 202, 21, 0.45);\n  }\n  .sm\\:shadow-outline-orange {\n    box-shadow: 0 0 0 3px rgba(253, 186, 140, 0.45);\n  }\n  .sm\\:shadow-outline-red {\n    box-shadow: 0 0 0 3px rgba(248, 180, 180, 0.45);\n  }\n  .sm\\:shadow-outline-pink {\n    box-shadow: 0 0 0 3px rgba(248, 180, 217, 0.45);\n  }\n  .sm\\:shadow-outline-purple {\n    box-shadow: 0 0 0 3px rgba(202, 191, 253, 0.45);\n  }\n  .sm\\:shadow-outline-indigo {\n    box-shadow: 0 0 0 3px rgba(180, 198, 252, 0.45);\n  }\n  .group:focus .sm\\:group-focus\\:shadow-xs {\n    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.05);\n  }\n  .group:focus .sm\\:group-focus\\:shadow-sm {\n    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);\n  }\n  .group:focus .sm\\:group-focus\\:shadow {\n    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);\n  }\n  .group:focus .sm\\:group-focus\\:shadow-md {\n    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);\n  }\n  .group:focus .sm\\:group-focus\\:shadow-lg {\n    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);\n  }\n  .group:focus .sm\\:group-focus\\:shadow-xl {\n    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);\n  }\n  .group:focus .sm\\:group-focus\\:shadow-2xl {\n    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);\n  }\n  .group:focus .sm\\:group-focus\\:shadow-inner {\n    box-shadow: inset 0 2px 4px 0 rgba(0, 0, 0, 0.06);\n  }\n  .group:focus .sm\\:group-focus\\:shadow-outline {\n    box-shadow: 0 0 0 3px rgba(118, 169, 250, 0.45);\n  }\n  .group:focus .sm\\:group-focus\\:shadow-none {\n    box-shadow: none;\n  }\n  .group:focus .sm\\:group-focus\\:shadow-solid {\n    box-shadow: 0 0 0 2px currentColor;\n  }\n  .group:focus .sm\\:group-focus\\:shadow-outline-gray {\n    box-shadow: 0 0 0 3px rgba(159, 166, 178, 0.45);\n  }\n  .group:focus .sm\\:group-focus\\:shadow-outline-blue {\n    box-shadow: 0 0 0 3px rgba(164, 202, 254, 0.45);\n  }\n  .group:focus .sm\\:group-focus\\:shadow-outline-teal {\n    box-shadow: 0 0 0 3px rgba(126, 220, 226, 0.45);\n  }\n  .group:focus .sm\\:group-focus\\:shadow-outline-green {\n    box-shadow: 0 0 0 3px rgba(132, 225, 188, 0.45);\n  }\n  .group:focus .sm\\:group-focus\\:shadow-outline-yellow {\n    box-shadow: 0 0 0 3px rgba(250, 202, 21, 0.45);\n  }\n  .group:focus .sm\\:group-focus\\:shadow-outline-orange {\n    box-shadow: 0 0 0 3px rgba(253, 186, 140, 0.45);\n  }\n  .group:focus .sm\\:group-focus\\:shadow-outline-red {\n    box-shadow: 0 0 0 3px rgba(248, 180, 180, 0.45);\n  }\n  .group:focus .sm\\:group-focus\\:shadow-outline-pink {\n    box-shadow: 0 0 0 3px rgba(248, 180, 217, 0.45);\n  }\n  .group:focus .sm\\:group-focus\\:shadow-outline-purple {\n    box-shadow: 0 0 0 3px rgba(202, 191, 253, 0.45);\n  }\n  .group:focus .sm\\:group-focus\\:shadow-outline-indigo {\n    box-shadow: 0 0 0 3px rgba(180, 198, 252, 0.45);\n  }\n  .sm\\:hover\\:shadow-xs:hover {\n    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.05);\n  }\n  .sm\\:hover\\:shadow-sm:hover {\n    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);\n  }\n  .sm\\:hover\\:shadow:hover {\n    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);\n  }\n  .sm\\:hover\\:shadow-md:hover {\n    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);\n  }\n  .sm\\:hover\\:shadow-lg:hover {\n    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);\n  }\n  .sm\\:hover\\:shadow-xl:hover {\n    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);\n  }\n  .sm\\:hover\\:shadow-2xl:hover {\n    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);\n  }\n  .sm\\:hover\\:shadow-inner:hover {\n    box-shadow: inset 0 2px 4px 0 rgba(0, 0, 0, 0.06);\n  }\n  .sm\\:hover\\:shadow-outline:hover {\n    box-shadow: 0 0 0 3px rgba(118, 169, 250, 0.45);\n  }\n  .sm\\:hover\\:shadow-none:hover {\n    box-shadow: none;\n  }\n  .sm\\:hover\\:shadow-solid:hover {\n    box-shadow: 0 0 0 2px currentColor;\n  }\n  .sm\\:hover\\:shadow-outline-gray:hover {\n    box-shadow: 0 0 0 3px rgba(159, 166, 178, 0.45);\n  }\n  .sm\\:hover\\:shadow-outline-blue:hover {\n    box-shadow: 0 0 0 3px rgba(164, 202, 254, 0.45);\n  }\n  .sm\\:hover\\:shadow-outline-teal:hover {\n    box-shadow: 0 0 0 3px rgba(126, 220, 226, 0.45);\n  }\n  .sm\\:hover\\:shadow-outline-green:hover {\n    box-shadow: 0 0 0 3px rgba(132, 225, 188, 0.45);\n  }\n  .sm\\:hover\\:shadow-outline-yellow:hover {\n    box-shadow: 0 0 0 3px rgba(250, 202, 21, 0.45);\n  }\n  .sm\\:hover\\:shadow-outline-orange:hover {\n    box-shadow: 0 0 0 3px rgba(253, 186, 140, 0.45);\n  }\n  .sm\\:hover\\:shadow-outline-red:hover {\n    box-shadow: 0 0 0 3px rgba(248, 180, 180, 0.45);\n  }\n  .sm\\:hover\\:shadow-outline-pink:hover {\n    box-shadow: 0 0 0 3px rgba(248, 180, 217, 0.45);\n  }\n  .sm\\:hover\\:shadow-outline-purple:hover {\n    box-shadow: 0 0 0 3px rgba(202, 191, 253, 0.45);\n  }\n  .sm\\:hover\\:shadow-outline-indigo:hover {\n    box-shadow: 0 0 0 3px rgba(180, 198, 252, 0.45);\n  }\n  .sm\\:focus-within\\:shadow-xs:focus-within {\n    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.05);\n  }\n  .sm\\:focus-within\\:shadow-sm:focus-within {\n    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);\n  }\n  .sm\\:focus-within\\:shadow:focus-within {\n    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);\n  }\n  .sm\\:focus-within\\:shadow-md:focus-within {\n    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);\n  }\n  .sm\\:focus-within\\:shadow-lg:focus-within {\n    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);\n  }\n  .sm\\:focus-within\\:shadow-xl:focus-within {\n    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);\n  }\n  .sm\\:focus-within\\:shadow-2xl:focus-within {\n    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);\n  }\n  .sm\\:focus-within\\:shadow-inner:focus-within {\n    box-shadow: inset 0 2px 4px 0 rgba(0, 0, 0, 0.06);\n  }\n  .sm\\:focus-within\\:shadow-outline:focus-within {\n    box-shadow: 0 0 0 3px rgba(118, 169, 250, 0.45);\n  }\n  .sm\\:focus-within\\:shadow-none:focus-within {\n    box-shadow: none;\n  }\n  .sm\\:focus-within\\:shadow-solid:focus-within {\n    box-shadow: 0 0 0 2px currentColor;\n  }\n  .sm\\:focus-within\\:shadow-outline-gray:focus-within {\n    box-shadow: 0 0 0 3px rgba(159, 166, 178, 0.45);\n  }\n  .sm\\:focus-within\\:shadow-outline-blue:focus-within {\n    box-shadow: 0 0 0 3px rgba(164, 202, 254, 0.45);\n  }\n  .sm\\:focus-within\\:shadow-outline-teal:focus-within {\n    box-shadow: 0 0 0 3px rgba(126, 220, 226, 0.45);\n  }\n  .sm\\:focus-within\\:shadow-outline-green:focus-within {\n    box-shadow: 0 0 0 3px rgba(132, 225, 188, 0.45);\n  }\n  .sm\\:focus-within\\:shadow-outline-yellow:focus-within {\n    box-shadow: 0 0 0 3px rgba(250, 202, 21, 0.45);\n  }\n  .sm\\:focus-within\\:shadow-outline-orange:focus-within {\n    box-shadow: 0 0 0 3px rgba(253, 186, 140, 0.45);\n  }\n  .sm\\:focus-within\\:shadow-outline-red:focus-within {\n    box-shadow: 0 0 0 3px rgba(248, 180, 180, 0.45);\n  }\n  .sm\\:focus-within\\:shadow-outline-pink:focus-within {\n    box-shadow: 0 0 0 3px rgba(248, 180, 217, 0.45);\n  }\n  .sm\\:focus-within\\:shadow-outline-purple:focus-within {\n    box-shadow: 0 0 0 3px rgba(202, 191, 253, 0.45);\n  }\n  .sm\\:focus-within\\:shadow-outline-indigo:focus-within {\n    box-shadow: 0 0 0 3px rgba(180, 198, 252, 0.45);\n  }\n  .sm\\:focus\\:shadow-xs:focus {\n    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.05);\n  }\n  .sm\\:focus\\:shadow-sm:focus {\n    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);\n  }\n  .sm\\:focus\\:shadow:focus {\n    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);\n  }\n  .sm\\:focus\\:shadow-md:focus {\n    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);\n  }\n  .sm\\:focus\\:shadow-lg:focus {\n    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);\n  }\n  .sm\\:focus\\:shadow-xl:focus {\n    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);\n  }\n  .sm\\:focus\\:shadow-2xl:focus {\n    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);\n  }\n  .sm\\:focus\\:shadow-inner:focus {\n    box-shadow: inset 0 2px 4px 0 rgba(0, 0, 0, 0.06);\n  }\n  .sm\\:focus\\:shadow-outline:focus {\n    box-shadow: 0 0 0 3px rgba(118, 169, 250, 0.45);\n  }\n  .sm\\:focus\\:shadow-none:focus {\n    box-shadow: none;\n  }\n  .sm\\:focus\\:shadow-solid:focus {\n    box-shadow: 0 0 0 2px currentColor;\n  }\n  .sm\\:focus\\:shadow-outline-gray:focus {\n    box-shadow: 0 0 0 3px rgba(159, 166, 178, 0.45);\n  }\n  .sm\\:focus\\:shadow-outline-blue:focus {\n    box-shadow: 0 0 0 3px rgba(164, 202, 254, 0.45);\n  }\n  .sm\\:focus\\:shadow-outline-teal:focus {\n    box-shadow: 0 0 0 3px rgba(126, 220, 226, 0.45);\n  }\n  .sm\\:focus\\:shadow-outline-green:focus {\n    box-shadow: 0 0 0 3px rgba(132, 225, 188, 0.45);\n  }\n  .sm\\:focus\\:shadow-outline-yellow:focus {\n    box-shadow: 0 0 0 3px rgba(250, 202, 21, 0.45);\n  }\n  .sm\\:focus\\:shadow-outline-orange:focus {\n    box-shadow: 0 0 0 3px rgba(253, 186, 140, 0.45);\n  }\n  .sm\\:focus\\:shadow-outline-red:focus {\n    box-shadow: 0 0 0 3px rgba(248, 180, 180, 0.45);\n  }\n  .sm\\:focus\\:shadow-outline-pink:focus {\n    box-shadow: 0 0 0 3px rgba(248, 180, 217, 0.45);\n  }\n  .sm\\:focus\\:shadow-outline-purple:focus {\n    box-shadow: 0 0 0 3px rgba(202, 191, 253, 0.45);\n  }\n  .sm\\:focus\\:shadow-outline-indigo:focus {\n    box-shadow: 0 0 0 3px rgba(180, 198, 252, 0.45);\n  }\n  .sm\\:fill-current {\n    fill: currentColor;\n  }\n  .sm\\:stroke-current {\n    stroke: currentColor;\n  }\n  .sm\\:stroke-0 {\n    stroke-width: 0;\n  }\n  .sm\\:stroke-1 {\n    stroke-width: 1;\n  }\n  .sm\\:stroke-2 {\n    stroke-width: 2;\n  }\n  .sm\\:table-auto {\n    table-layout: auto;\n  }\n  .sm\\:table-fixed {\n    table-layout: fixed;\n  }\n  .sm\\:text-left {\n    text-align: left;\n  }\n  .sm\\:text-center {\n    text-align: center;\n  }\n  .sm\\:text-right {\n    text-align: right;\n  }\n  .sm\\:text-justify {\n    text-align: justify;\n  }\n  .sm\\:text-current {\n    color: currentColor;\n  }\n  .sm\\:text-transparent {\n    color: transparent;\n  }\n  .sm\\:text-white {\n    --text-opacity: 1;\n    color: #ffffff;\n    color: rgba(255, 255, 255, var(--text-opacity));\n  }\n  .sm\\:text-black {\n    --text-opacity: 1;\n    color: #000000;\n    color: rgba(0, 0, 0, var(--text-opacity));\n  }\n  .sm\\:text-gray-50 {\n    --text-opacity: 1;\n    color: #f9fafb;\n    color: rgba(249, 250, 251, var(--text-opacity));\n  }\n  .sm\\:text-gray-100 {\n    --text-opacity: 1;\n    color: #f4f5f7;\n    color: rgba(244, 245, 247, var(--text-opacity));\n  }\n  .sm\\:text-gray-200 {\n    --text-opacity: 1;\n    color: #e5e7eb;\n    color: rgba(229, 231, 235, var(--text-opacity));\n  }\n  .sm\\:text-gray-300 {\n    --text-opacity: 1;\n    color: #d2d6dc;\n    color: rgba(210, 214, 220, var(--text-opacity));\n  }\n  .sm\\:text-gray-400 {\n    --text-opacity: 1;\n    color: #9fa6b2;\n    color: rgba(159, 166, 178, var(--text-opacity));\n  }\n  .sm\\:text-gray-500 {\n    --text-opacity: 1;\n    color: #6b7280;\n    color: rgba(107, 114, 128, var(--text-opacity));\n  }\n  .sm\\:text-gray-600 {\n    --text-opacity: 1;\n    color: #4b5563;\n    color: rgba(75, 85, 99, var(--text-opacity));\n  }\n  .sm\\:text-gray-700 {\n    --text-opacity: 1;\n    color: #374151;\n    color: rgba(55, 65, 81, var(--text-opacity));\n  }\n  .sm\\:text-gray-800 {\n    --text-opacity: 1;\n    color: #252f3f;\n    color: rgba(37, 47, 63, var(--text-opacity));\n  }\n  .sm\\:text-gray-900 {\n    --text-opacity: 1;\n    color: #161e2e;\n    color: rgba(22, 30, 46, var(--text-opacity));\n  }\n  .sm\\:text-red-50 {\n    --text-opacity: 1;\n    color: #fdf2f2;\n    color: rgba(253, 242, 242, var(--text-opacity));\n  }\n  .sm\\:text-red-100 {\n    --text-opacity: 1;\n    color: #fde8e8;\n    color: rgba(253, 232, 232, var(--text-opacity));\n  }\n  .sm\\:text-red-200 {\n    --text-opacity: 1;\n    color: #fbd5d5;\n    color: rgba(251, 213, 213, var(--text-opacity));\n  }\n  .sm\\:text-red-300 {\n    --text-opacity: 1;\n    color: #f8b4b4;\n    color: rgba(248, 180, 180, var(--text-opacity));\n  }\n  .sm\\:text-red-400 {\n    --text-opacity: 1;\n    color: #f98080;\n    color: rgba(249, 128, 128, var(--text-opacity));\n  }\n  .sm\\:text-red-500 {\n    --text-opacity: 1;\n    color: #f05252;\n    color: rgba(240, 82, 82, var(--text-opacity));\n  }\n  .sm\\:text-red-600 {\n    --text-opacity: 1;\n    color: #e02424;\n    color: rgba(224, 36, 36, var(--text-opacity));\n  }\n  .sm\\:text-red-700 {\n    --text-opacity: 1;\n    color: #c81e1e;\n    color: rgba(200, 30, 30, var(--text-opacity));\n  }\n  .sm\\:text-red-800 {\n    --text-opacity: 1;\n    color: #9b1c1c;\n    color: rgba(155, 28, 28, var(--text-opacity));\n  }\n  .sm\\:text-red-900 {\n    --text-opacity: 1;\n    color: #771d1d;\n    color: rgba(119, 29, 29, var(--text-opacity));\n  }\n  .sm\\:text-orange-50 {\n    --text-opacity: 1;\n    color: #fff8f1;\n    color: rgba(255, 248, 241, var(--text-opacity));\n  }\n  .sm\\:text-orange-100 {\n    --text-opacity: 1;\n    color: #feecdc;\n    color: rgba(254, 236, 220, var(--text-opacity));\n  }\n  .sm\\:text-orange-200 {\n    --text-opacity: 1;\n    color: #fcd9bd;\n    color: rgba(252, 217, 189, var(--text-opacity));\n  }\n  .sm\\:text-orange-300 {\n    --text-opacity: 1;\n    color: #fdba8c;\n    color: rgba(253, 186, 140, var(--text-opacity));\n  }\n  .sm\\:text-orange-400 {\n    --text-opacity: 1;\n    color: #ff8a4c;\n    color: rgba(255, 138, 76, var(--text-opacity));\n  }\n  .sm\\:text-orange-500 {\n    --text-opacity: 1;\n    color: #ff5a1f;\n    color: rgba(255, 90, 31, var(--text-opacity));\n  }\n  .sm\\:text-orange-600 {\n    --text-opacity: 1;\n    color: #d03801;\n    color: rgba(208, 56, 1, var(--text-opacity));\n  }\n  .sm\\:text-orange-700 {\n    --text-opacity: 1;\n    color: #b43403;\n    color: rgba(180, 52, 3, var(--text-opacity));\n  }\n  .sm\\:text-orange-800 {\n    --text-opacity: 1;\n    color: #8a2c0d;\n    color: rgba(138, 44, 13, var(--text-opacity));\n  }\n  .sm\\:text-orange-900 {\n    --text-opacity: 1;\n    color: #73230d;\n    color: rgba(115, 35, 13, var(--text-opacity));\n  }\n  .sm\\:text-yellow-50 {\n    --text-opacity: 1;\n    color: #fdfdea;\n    color: rgba(253, 253, 234, var(--text-opacity));\n  }\n  .sm\\:text-yellow-100 {\n    --text-opacity: 1;\n    color: #fdf6b2;\n    color: rgba(253, 246, 178, var(--text-opacity));\n  }\n  .sm\\:text-yellow-200 {\n    --text-opacity: 1;\n    color: #fce96a;\n    color: rgba(252, 233, 106, var(--text-opacity));\n  }\n  .sm\\:text-yellow-300 {\n    --text-opacity: 1;\n    color: #faca15;\n    color: rgba(250, 202, 21, var(--text-opacity));\n  }\n  .sm\\:text-yellow-400 {\n    --text-opacity: 1;\n    color: #e3a008;\n    color: rgba(227, 160, 8, var(--text-opacity));\n  }\n  .sm\\:text-yellow-500 {\n    --text-opacity: 1;\n    color: #c27803;\n    color: rgba(194, 120, 3, var(--text-opacity));\n  }\n  .sm\\:text-yellow-600 {\n    --text-opacity: 1;\n    color: #9f580a;\n    color: rgba(159, 88, 10, var(--text-opacity));\n  }\n  .sm\\:text-yellow-700 {\n    --text-opacity: 1;\n    color: #8e4b10;\n    color: rgba(142, 75, 16, var(--text-opacity));\n  }\n  .sm\\:text-yellow-800 {\n    --text-opacity: 1;\n    color: #723b13;\n    color: rgba(114, 59, 19, var(--text-opacity));\n  }\n  .sm\\:text-yellow-900 {\n    --text-opacity: 1;\n    color: #633112;\n    color: rgba(99, 49, 18, var(--text-opacity));\n  }\n  .sm\\:text-green-50 {\n    --text-opacity: 1;\n    color: #f3faf7;\n    color: rgba(243, 250, 247, var(--text-opacity));\n  }\n  .sm\\:text-green-100 {\n    --text-opacity: 1;\n    color: #def7ec;\n    color: rgba(222, 247, 236, var(--text-opacity));\n  }\n  .sm\\:text-green-200 {\n    --text-opacity: 1;\n    color: #bcf0da;\n    color: rgba(188, 240, 218, var(--text-opacity));\n  }\n  .sm\\:text-green-300 {\n    --text-opacity: 1;\n    color: #84e1bc;\n    color: rgba(132, 225, 188, var(--text-opacity));\n  }\n  .sm\\:text-green-400 {\n    --text-opacity: 1;\n    color: #31c48d;\n    color: rgba(49, 196, 141, var(--text-opacity));\n  }\n  .sm\\:text-green-500 {\n    --text-opacity: 1;\n    color: #0e9f6e;\n    color: rgba(14, 159, 110, var(--text-opacity));\n  }\n  .sm\\:text-green-600 {\n    --text-opacity: 1;\n    color: #057a55;\n    color: rgba(5, 122, 85, var(--text-opacity));\n  }\n  .sm\\:text-green-700 {\n    --text-opacity: 1;\n    color: #046c4e;\n    color: rgba(4, 108, 78, var(--text-opacity));\n  }\n  .sm\\:text-green-800 {\n    --text-opacity: 1;\n    color: #03543f;\n    color: rgba(3, 84, 63, var(--text-opacity));\n  }\n  .sm\\:text-green-900 {\n    --text-opacity: 1;\n    color: #014737;\n    color: rgba(1, 71, 55, var(--text-opacity));\n  }\n  .sm\\:text-teal-50 {\n    --text-opacity: 1;\n    color: #edfafa;\n    color: rgba(237, 250, 250, var(--text-opacity));\n  }\n  .sm\\:text-teal-100 {\n    --text-opacity: 1;\n    color: #d5f5f6;\n    color: rgba(213, 245, 246, var(--text-opacity));\n  }\n  .sm\\:text-teal-200 {\n    --text-opacity: 1;\n    color: #afecef;\n    color: rgba(175, 236, 239, var(--text-opacity));\n  }\n  .sm\\:text-teal-300 {\n    --text-opacity: 1;\n    color: #7edce2;\n    color: rgba(126, 220, 226, var(--text-opacity));\n  }\n  .sm\\:text-teal-400 {\n    --text-opacity: 1;\n    color: #16bdca;\n    color: rgba(22, 189, 202, var(--text-opacity));\n  }\n  .sm\\:text-teal-500 {\n    --text-opacity: 1;\n    color: #0694a2;\n    color: rgba(6, 148, 162, var(--text-opacity));\n  }\n  .sm\\:text-teal-600 {\n    --text-opacity: 1;\n    color: #047481;\n    color: rgba(4, 116, 129, var(--text-opacity));\n  }\n  .sm\\:text-teal-700 {\n    --text-opacity: 1;\n    color: #036672;\n    color: rgba(3, 102, 114, var(--text-opacity));\n  }\n  .sm\\:text-teal-800 {\n    --text-opacity: 1;\n    color: #05505c;\n    color: rgba(5, 80, 92, var(--text-opacity));\n  }\n  .sm\\:text-teal-900 {\n    --text-opacity: 1;\n    color: #014451;\n    color: rgba(1, 68, 81, var(--text-opacity));\n  }\n  .sm\\:text-blue-50 {\n    --text-opacity: 1;\n    color: #ebf5ff;\n    color: rgba(235, 245, 255, var(--text-opacity));\n  }\n  .sm\\:text-blue-100 {\n    --text-opacity: 1;\n    color: #e1effe;\n    color: rgba(225, 239, 254, var(--text-opacity));\n  }\n  .sm\\:text-blue-200 {\n    --text-opacity: 1;\n    color: #c3ddfd;\n    color: rgba(195, 221, 253, var(--text-opacity));\n  }\n  .sm\\:text-blue-300 {\n    --text-opacity: 1;\n    color: #a4cafe;\n    color: rgba(164, 202, 254, var(--text-opacity));\n  }\n  .sm\\:text-blue-400 {\n    --text-opacity: 1;\n    color: #76a9fa;\n    color: rgba(118, 169, 250, var(--text-opacity));\n  }\n  .sm\\:text-blue-500 {\n    --text-opacity: 1;\n    color: #3f83f8;\n    color: rgba(63, 131, 248, var(--text-opacity));\n  }\n  .sm\\:text-blue-600 {\n    --text-opacity: 1;\n    color: #1c64f2;\n    color: rgba(28, 100, 242, var(--text-opacity));\n  }\n  .sm\\:text-blue-700 {\n    --text-opacity: 1;\n    color: #1a56db;\n    color: rgba(26, 86, 219, var(--text-opacity));\n  }\n  .sm\\:text-blue-800 {\n    --text-opacity: 1;\n    color: #1e429f;\n    color: rgba(30, 66, 159, var(--text-opacity));\n  }\n  .sm\\:text-blue-900 {\n    --text-opacity: 1;\n    color: #233876;\n    color: rgba(35, 56, 118, var(--text-opacity));\n  }\n  .sm\\:text-indigo-50 {\n    --text-opacity: 1;\n    color: #f0f5ff;\n    color: rgba(240, 245, 255, var(--text-opacity));\n  }\n  .sm\\:text-indigo-100 {\n    --text-opacity: 1;\n    color: #e5edff;\n    color: rgba(229, 237, 255, var(--text-opacity));\n  }\n  .sm\\:text-indigo-200 {\n    --text-opacity: 1;\n    color: #cddbfe;\n    color: rgba(205, 219, 254, var(--text-opacity));\n  }\n  .sm\\:text-indigo-300 {\n    --text-opacity: 1;\n    color: #b4c6fc;\n    color: rgba(180, 198, 252, var(--text-opacity));\n  }\n  .sm\\:text-indigo-400 {\n    --text-opacity: 1;\n    color: #8da2fb;\n    color: rgba(141, 162, 251, var(--text-opacity));\n  }\n  .sm\\:text-indigo-500 {\n    --text-opacity: 1;\n    color: #6875f5;\n    color: rgba(104, 117, 245, var(--text-opacity));\n  }\n  .sm\\:text-indigo-600 {\n    --text-opacity: 1;\n    color: #5850ec;\n    color: rgba(88, 80, 236, var(--text-opacity));\n  }\n  .sm\\:text-indigo-700 {\n    --text-opacity: 1;\n    color: #5145cd;\n    color: rgba(81, 69, 205, var(--text-opacity));\n  }\n  .sm\\:text-indigo-800 {\n    --text-opacity: 1;\n    color: #42389d;\n    color: rgba(66, 56, 157, var(--text-opacity));\n  }\n  .sm\\:text-indigo-900 {\n    --text-opacity: 1;\n    color: #362f78;\n    color: rgba(54, 47, 120, var(--text-opacity));\n  }\n  .sm\\:text-purple-50 {\n    --text-opacity: 1;\n    color: #f6f5ff;\n    color: rgba(246, 245, 255, var(--text-opacity));\n  }\n  .sm\\:text-purple-100 {\n    --text-opacity: 1;\n    color: #edebfe;\n    color: rgba(237, 235, 254, var(--text-opacity));\n  }\n  .sm\\:text-purple-200 {\n    --text-opacity: 1;\n    color: #dcd7fe;\n    color: rgba(220, 215, 254, var(--text-opacity));\n  }\n  .sm\\:text-purple-300 {\n    --text-opacity: 1;\n    color: #cabffd;\n    color: rgba(202, 191, 253, var(--text-opacity));\n  }\n  .sm\\:text-purple-400 {\n    --text-opacity: 1;\n    color: #ac94fa;\n    color: rgba(172, 148, 250, var(--text-opacity));\n  }\n  .sm\\:text-purple-500 {\n    --text-opacity: 1;\n    color: #9061f9;\n    color: rgba(144, 97, 249, var(--text-opacity));\n  }\n  .sm\\:text-purple-600 {\n    --text-opacity: 1;\n    color: #7e3af2;\n    color: rgba(126, 58, 242, var(--text-opacity));\n  }\n  .sm\\:text-purple-700 {\n    --text-opacity: 1;\n    color: #6c2bd9;\n    color: rgba(108, 43, 217, var(--text-opacity));\n  }\n  .sm\\:text-purple-800 {\n    --text-opacity: 1;\n    color: #5521b5;\n    color: rgba(85, 33, 181, var(--text-opacity));\n  }\n  .sm\\:text-purple-900 {\n    --text-opacity: 1;\n    color: #4a1d96;\n    color: rgba(74, 29, 150, var(--text-opacity));\n  }\n  .sm\\:text-pink-50 {\n    --text-opacity: 1;\n    color: #fdf2f8;\n    color: rgba(253, 242, 248, var(--text-opacity));\n  }\n  .sm\\:text-pink-100 {\n    --text-opacity: 1;\n    color: #fce8f3;\n    color: rgba(252, 232, 243, var(--text-opacity));\n  }\n  .sm\\:text-pink-200 {\n    --text-opacity: 1;\n    color: #fad1e8;\n    color: rgba(250, 209, 232, var(--text-opacity));\n  }\n  .sm\\:text-pink-300 {\n    --text-opacity: 1;\n    color: #f8b4d9;\n    color: rgba(248, 180, 217, var(--text-opacity));\n  }\n  .sm\\:text-pink-400 {\n    --text-opacity: 1;\n    color: #f17eb8;\n    color: rgba(241, 126, 184, var(--text-opacity));\n  }\n  .sm\\:text-pink-500 {\n    --text-opacity: 1;\n    color: #e74694;\n    color: rgba(231, 70, 148, var(--text-opacity));\n  }\n  .sm\\:text-pink-600 {\n    --text-opacity: 1;\n    color: #d61f69;\n    color: rgba(214, 31, 105, var(--text-opacity));\n  }\n  .sm\\:text-pink-700 {\n    --text-opacity: 1;\n    color: #bf125d;\n    color: rgba(191, 18, 93, var(--text-opacity));\n  }\n  .sm\\:text-pink-800 {\n    --text-opacity: 1;\n    color: #99154b;\n    color: rgba(153, 21, 75, var(--text-opacity));\n  }\n  .sm\\:text-pink-900 {\n    --text-opacity: 1;\n    color: #751a3d;\n    color: rgba(117, 26, 61, var(--text-opacity));\n  }\n  .sm\\:text-cool-gray-50 {\n    --text-opacity: 1;\n    color: #f8fafc;\n    color: rgba(248, 250, 252, var(--text-opacity));\n  }\n  .sm\\:text-cool-gray-100 {\n    --text-opacity: 1;\n    color: #f1f5f9;\n    color: rgba(241, 245, 249, var(--text-opacity));\n  }\n  .sm\\:text-cool-gray-200 {\n    --text-opacity: 1;\n    color: #e2e8f0;\n    color: rgba(226, 232, 240, var(--text-opacity));\n  }\n  .sm\\:text-cool-gray-300 {\n    --text-opacity: 1;\n    color: #cfd8e3;\n    color: rgba(207, 216, 227, var(--text-opacity));\n  }\n  .sm\\:text-cool-gray-400 {\n    --text-opacity: 1;\n    color: #97a6ba;\n    color: rgba(151, 166, 186, var(--text-opacity));\n  }\n  .sm\\:text-cool-gray-500 {\n    --text-opacity: 1;\n    color: #64748b;\n    color: rgba(100, 116, 139, var(--text-opacity));\n  }\n  .sm\\:text-cool-gray-600 {\n    --text-opacity: 1;\n    color: #475569;\n    color: rgba(71, 85, 105, var(--text-opacity));\n  }\n  .sm\\:text-cool-gray-700 {\n    --text-opacity: 1;\n    color: #364152;\n    color: rgba(54, 65, 82, var(--text-opacity));\n  }\n  .sm\\:text-cool-gray-800 {\n    --text-opacity: 1;\n    color: #27303f;\n    color: rgba(39, 48, 63, var(--text-opacity));\n  }\n  .sm\\:text-cool-gray-900 {\n    --text-opacity: 1;\n    color: #1a202e;\n    color: rgba(26, 32, 46, var(--text-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:text-current {\n    color: currentColor;\n  }\n  .group:hover .sm\\:group-hover\\:text-transparent {\n    color: transparent;\n  }\n  .group:hover .sm\\:group-hover\\:text-white {\n    --text-opacity: 1;\n    color: #ffffff;\n    color: rgba(255, 255, 255, var(--text-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:text-black {\n    --text-opacity: 1;\n    color: #000000;\n    color: rgba(0, 0, 0, var(--text-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:text-gray-50 {\n    --text-opacity: 1;\n    color: #f9fafb;\n    color: rgba(249, 250, 251, var(--text-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:text-gray-100 {\n    --text-opacity: 1;\n    color: #f4f5f7;\n    color: rgba(244, 245, 247, var(--text-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:text-gray-200 {\n    --text-opacity: 1;\n    color: #e5e7eb;\n    color: rgba(229, 231, 235, var(--text-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:text-gray-300 {\n    --text-opacity: 1;\n    color: #d2d6dc;\n    color: rgba(210, 214, 220, var(--text-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:text-gray-400 {\n    --text-opacity: 1;\n    color: #9fa6b2;\n    color: rgba(159, 166, 178, var(--text-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:text-gray-500 {\n    --text-opacity: 1;\n    color: #6b7280;\n    color: rgba(107, 114, 128, var(--text-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:text-gray-600 {\n    --text-opacity: 1;\n    color: #4b5563;\n    color: rgba(75, 85, 99, var(--text-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:text-gray-700 {\n    --text-opacity: 1;\n    color: #374151;\n    color: rgba(55, 65, 81, var(--text-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:text-gray-800 {\n    --text-opacity: 1;\n    color: #252f3f;\n    color: rgba(37, 47, 63, var(--text-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:text-gray-900 {\n    --text-opacity: 1;\n    color: #161e2e;\n    color: rgba(22, 30, 46, var(--text-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:text-red-50 {\n    --text-opacity: 1;\n    color: #fdf2f2;\n    color: rgba(253, 242, 242, var(--text-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:text-red-100 {\n    --text-opacity: 1;\n    color: #fde8e8;\n    color: rgba(253, 232, 232, var(--text-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:text-red-200 {\n    --text-opacity: 1;\n    color: #fbd5d5;\n    color: rgba(251, 213, 213, var(--text-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:text-red-300 {\n    --text-opacity: 1;\n    color: #f8b4b4;\n    color: rgba(248, 180, 180, var(--text-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:text-red-400 {\n    --text-opacity: 1;\n    color: #f98080;\n    color: rgba(249, 128, 128, var(--text-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:text-red-500 {\n    --text-opacity: 1;\n    color: #f05252;\n    color: rgba(240, 82, 82, var(--text-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:text-red-600 {\n    --text-opacity: 1;\n    color: #e02424;\n    color: rgba(224, 36, 36, var(--text-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:text-red-700 {\n    --text-opacity: 1;\n    color: #c81e1e;\n    color: rgba(200, 30, 30, var(--text-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:text-red-800 {\n    --text-opacity: 1;\n    color: #9b1c1c;\n    color: rgba(155, 28, 28, var(--text-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:text-red-900 {\n    --text-opacity: 1;\n    color: #771d1d;\n    color: rgba(119, 29, 29, var(--text-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:text-orange-50 {\n    --text-opacity: 1;\n    color: #fff8f1;\n    color: rgba(255, 248, 241, var(--text-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:text-orange-100 {\n    --text-opacity: 1;\n    color: #feecdc;\n    color: rgba(254, 236, 220, var(--text-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:text-orange-200 {\n    --text-opacity: 1;\n    color: #fcd9bd;\n    color: rgba(252, 217, 189, var(--text-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:text-orange-300 {\n    --text-opacity: 1;\n    color: #fdba8c;\n    color: rgba(253, 186, 140, var(--text-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:text-orange-400 {\n    --text-opacity: 1;\n    color: #ff8a4c;\n    color: rgba(255, 138, 76, var(--text-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:text-orange-500 {\n    --text-opacity: 1;\n    color: #ff5a1f;\n    color: rgba(255, 90, 31, var(--text-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:text-orange-600 {\n    --text-opacity: 1;\n    color: #d03801;\n    color: rgba(208, 56, 1, var(--text-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:text-orange-700 {\n    --text-opacity: 1;\n    color: #b43403;\n    color: rgba(180, 52, 3, var(--text-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:text-orange-800 {\n    --text-opacity: 1;\n    color: #8a2c0d;\n    color: rgba(138, 44, 13, var(--text-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:text-orange-900 {\n    --text-opacity: 1;\n    color: #73230d;\n    color: rgba(115, 35, 13, var(--text-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:text-yellow-50 {\n    --text-opacity: 1;\n    color: #fdfdea;\n    color: rgba(253, 253, 234, var(--text-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:text-yellow-100 {\n    --text-opacity: 1;\n    color: #fdf6b2;\n    color: rgba(253, 246, 178, var(--text-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:text-yellow-200 {\n    --text-opacity: 1;\n    color: #fce96a;\n    color: rgba(252, 233, 106, var(--text-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:text-yellow-300 {\n    --text-opacity: 1;\n    color: #faca15;\n    color: rgba(250, 202, 21, var(--text-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:text-yellow-400 {\n    --text-opacity: 1;\n    color: #e3a008;\n    color: rgba(227, 160, 8, var(--text-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:text-yellow-500 {\n    --text-opacity: 1;\n    color: #c27803;\n    color: rgba(194, 120, 3, var(--text-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:text-yellow-600 {\n    --text-opacity: 1;\n    color: #9f580a;\n    color: rgba(159, 88, 10, var(--text-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:text-yellow-700 {\n    --text-opacity: 1;\n    color: #8e4b10;\n    color: rgba(142, 75, 16, var(--text-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:text-yellow-800 {\n    --text-opacity: 1;\n    color: #723b13;\n    color: rgba(114, 59, 19, var(--text-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:text-yellow-900 {\n    --text-opacity: 1;\n    color: #633112;\n    color: rgba(99, 49, 18, var(--text-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:text-green-50 {\n    --text-opacity: 1;\n    color: #f3faf7;\n    color: rgba(243, 250, 247, var(--text-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:text-green-100 {\n    --text-opacity: 1;\n    color: #def7ec;\n    color: rgba(222, 247, 236, var(--text-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:text-green-200 {\n    --text-opacity: 1;\n    color: #bcf0da;\n    color: rgba(188, 240, 218, var(--text-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:text-green-300 {\n    --text-opacity: 1;\n    color: #84e1bc;\n    color: rgba(132, 225, 188, var(--text-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:text-green-400 {\n    --text-opacity: 1;\n    color: #31c48d;\n    color: rgba(49, 196, 141, var(--text-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:text-green-500 {\n    --text-opacity: 1;\n    color: #0e9f6e;\n    color: rgba(14, 159, 110, var(--text-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:text-green-600 {\n    --text-opacity: 1;\n    color: #057a55;\n    color: rgba(5, 122, 85, var(--text-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:text-green-700 {\n    --text-opacity: 1;\n    color: #046c4e;\n    color: rgba(4, 108, 78, var(--text-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:text-green-800 {\n    --text-opacity: 1;\n    color: #03543f;\n    color: rgba(3, 84, 63, var(--text-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:text-green-900 {\n    --text-opacity: 1;\n    color: #014737;\n    color: rgba(1, 71, 55, var(--text-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:text-teal-50 {\n    --text-opacity: 1;\n    color: #edfafa;\n    color: rgba(237, 250, 250, var(--text-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:text-teal-100 {\n    --text-opacity: 1;\n    color: #d5f5f6;\n    color: rgba(213, 245, 246, var(--text-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:text-teal-200 {\n    --text-opacity: 1;\n    color: #afecef;\n    color: rgba(175, 236, 239, var(--text-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:text-teal-300 {\n    --text-opacity: 1;\n    color: #7edce2;\n    color: rgba(126, 220, 226, var(--text-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:text-teal-400 {\n    --text-opacity: 1;\n    color: #16bdca;\n    color: rgba(22, 189, 202, var(--text-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:text-teal-500 {\n    --text-opacity: 1;\n    color: #0694a2;\n    color: rgba(6, 148, 162, var(--text-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:text-teal-600 {\n    --text-opacity: 1;\n    color: #047481;\n    color: rgba(4, 116, 129, var(--text-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:text-teal-700 {\n    --text-opacity: 1;\n    color: #036672;\n    color: rgba(3, 102, 114, var(--text-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:text-teal-800 {\n    --text-opacity: 1;\n    color: #05505c;\n    color: rgba(5, 80, 92, var(--text-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:text-teal-900 {\n    --text-opacity: 1;\n    color: #014451;\n    color: rgba(1, 68, 81, var(--text-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:text-blue-50 {\n    --text-opacity: 1;\n    color: #ebf5ff;\n    color: rgba(235, 245, 255, var(--text-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:text-blue-100 {\n    --text-opacity: 1;\n    color: #e1effe;\n    color: rgba(225, 239, 254, var(--text-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:text-blue-200 {\n    --text-opacity: 1;\n    color: #c3ddfd;\n    color: rgba(195, 221, 253, var(--text-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:text-blue-300 {\n    --text-opacity: 1;\n    color: #a4cafe;\n    color: rgba(164, 202, 254, var(--text-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:text-blue-400 {\n    --text-opacity: 1;\n    color: #76a9fa;\n    color: rgba(118, 169, 250, var(--text-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:text-blue-500 {\n    --text-opacity: 1;\n    color: #3f83f8;\n    color: rgba(63, 131, 248, var(--text-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:text-blue-600 {\n    --text-opacity: 1;\n    color: #1c64f2;\n    color: rgba(28, 100, 242, var(--text-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:text-blue-700 {\n    --text-opacity: 1;\n    color: #1a56db;\n    color: rgba(26, 86, 219, var(--text-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:text-blue-800 {\n    --text-opacity: 1;\n    color: #1e429f;\n    color: rgba(30, 66, 159, var(--text-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:text-blue-900 {\n    --text-opacity: 1;\n    color: #233876;\n    color: rgba(35, 56, 118, var(--text-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:text-indigo-50 {\n    --text-opacity: 1;\n    color: #f0f5ff;\n    color: rgba(240, 245, 255, var(--text-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:text-indigo-100 {\n    --text-opacity: 1;\n    color: #e5edff;\n    color: rgba(229, 237, 255, var(--text-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:text-indigo-200 {\n    --text-opacity: 1;\n    color: #cddbfe;\n    color: rgba(205, 219, 254, var(--text-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:text-indigo-300 {\n    --text-opacity: 1;\n    color: #b4c6fc;\n    color: rgba(180, 198, 252, var(--text-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:text-indigo-400 {\n    --text-opacity: 1;\n    color: #8da2fb;\n    color: rgba(141, 162, 251, var(--text-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:text-indigo-500 {\n    --text-opacity: 1;\n    color: #6875f5;\n    color: rgba(104, 117, 245, var(--text-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:text-indigo-600 {\n    --text-opacity: 1;\n    color: #5850ec;\n    color: rgba(88, 80, 236, var(--text-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:text-indigo-700 {\n    --text-opacity: 1;\n    color: #5145cd;\n    color: rgba(81, 69, 205, var(--text-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:text-indigo-800 {\n    --text-opacity: 1;\n    color: #42389d;\n    color: rgba(66, 56, 157, var(--text-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:text-indigo-900 {\n    --text-opacity: 1;\n    color: #362f78;\n    color: rgba(54, 47, 120, var(--text-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:text-purple-50 {\n    --text-opacity: 1;\n    color: #f6f5ff;\n    color: rgba(246, 245, 255, var(--text-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:text-purple-100 {\n    --text-opacity: 1;\n    color: #edebfe;\n    color: rgba(237, 235, 254, var(--text-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:text-purple-200 {\n    --text-opacity: 1;\n    color: #dcd7fe;\n    color: rgba(220, 215, 254, var(--text-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:text-purple-300 {\n    --text-opacity: 1;\n    color: #cabffd;\n    color: rgba(202, 191, 253, var(--text-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:text-purple-400 {\n    --text-opacity: 1;\n    color: #ac94fa;\n    color: rgba(172, 148, 250, var(--text-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:text-purple-500 {\n    --text-opacity: 1;\n    color: #9061f9;\n    color: rgba(144, 97, 249, var(--text-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:text-purple-600 {\n    --text-opacity: 1;\n    color: #7e3af2;\n    color: rgba(126, 58, 242, var(--text-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:text-purple-700 {\n    --text-opacity: 1;\n    color: #6c2bd9;\n    color: rgba(108, 43, 217, var(--text-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:text-purple-800 {\n    --text-opacity: 1;\n    color: #5521b5;\n    color: rgba(85, 33, 181, var(--text-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:text-purple-900 {\n    --text-opacity: 1;\n    color: #4a1d96;\n    color: rgba(74, 29, 150, var(--text-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:text-pink-50 {\n    --text-opacity: 1;\n    color: #fdf2f8;\n    color: rgba(253, 242, 248, var(--text-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:text-pink-100 {\n    --text-opacity: 1;\n    color: #fce8f3;\n    color: rgba(252, 232, 243, var(--text-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:text-pink-200 {\n    --text-opacity: 1;\n    color: #fad1e8;\n    color: rgba(250, 209, 232, var(--text-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:text-pink-300 {\n    --text-opacity: 1;\n    color: #f8b4d9;\n    color: rgba(248, 180, 217, var(--text-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:text-pink-400 {\n    --text-opacity: 1;\n    color: #f17eb8;\n    color: rgba(241, 126, 184, var(--text-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:text-pink-500 {\n    --text-opacity: 1;\n    color: #e74694;\n    color: rgba(231, 70, 148, var(--text-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:text-pink-600 {\n    --text-opacity: 1;\n    color: #d61f69;\n    color: rgba(214, 31, 105, var(--text-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:text-pink-700 {\n    --text-opacity: 1;\n    color: #bf125d;\n    color: rgba(191, 18, 93, var(--text-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:text-pink-800 {\n    --text-opacity: 1;\n    color: #99154b;\n    color: rgba(153, 21, 75, var(--text-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:text-pink-900 {\n    --text-opacity: 1;\n    color: #751a3d;\n    color: rgba(117, 26, 61, var(--text-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:text-cool-gray-50 {\n    --text-opacity: 1;\n    color: #f8fafc;\n    color: rgba(248, 250, 252, var(--text-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:text-cool-gray-100 {\n    --text-opacity: 1;\n    color: #f1f5f9;\n    color: rgba(241, 245, 249, var(--text-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:text-cool-gray-200 {\n    --text-opacity: 1;\n    color: #e2e8f0;\n    color: rgba(226, 232, 240, var(--text-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:text-cool-gray-300 {\n    --text-opacity: 1;\n    color: #cfd8e3;\n    color: rgba(207, 216, 227, var(--text-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:text-cool-gray-400 {\n    --text-opacity: 1;\n    color: #97a6ba;\n    color: rgba(151, 166, 186, var(--text-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:text-cool-gray-500 {\n    --text-opacity: 1;\n    color: #64748b;\n    color: rgba(100, 116, 139, var(--text-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:text-cool-gray-600 {\n    --text-opacity: 1;\n    color: #475569;\n    color: rgba(71, 85, 105, var(--text-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:text-cool-gray-700 {\n    --text-opacity: 1;\n    color: #364152;\n    color: rgba(54, 65, 82, var(--text-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:text-cool-gray-800 {\n    --text-opacity: 1;\n    color: #27303f;\n    color: rgba(39, 48, 63, var(--text-opacity));\n  }\n  .group:hover .sm\\:group-hover\\:text-cool-gray-900 {\n    --text-opacity: 1;\n    color: #1a202e;\n    color: rgba(26, 32, 46, var(--text-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:text-current {\n    color: currentColor;\n  }\n  .group:focus .sm\\:group-focus\\:text-transparent {\n    color: transparent;\n  }\n  .group:focus .sm\\:group-focus\\:text-white {\n    --text-opacity: 1;\n    color: #ffffff;\n    color: rgba(255, 255, 255, var(--text-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:text-black {\n    --text-opacity: 1;\n    color: #000000;\n    color: rgba(0, 0, 0, var(--text-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:text-gray-50 {\n    --text-opacity: 1;\n    color: #f9fafb;\n    color: rgba(249, 250, 251, var(--text-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:text-gray-100 {\n    --text-opacity: 1;\n    color: #f4f5f7;\n    color: rgba(244, 245, 247, var(--text-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:text-gray-200 {\n    --text-opacity: 1;\n    color: #e5e7eb;\n    color: rgba(229, 231, 235, var(--text-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:text-gray-300 {\n    --text-opacity: 1;\n    color: #d2d6dc;\n    color: rgba(210, 214, 220, var(--text-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:text-gray-400 {\n    --text-opacity: 1;\n    color: #9fa6b2;\n    color: rgba(159, 166, 178, var(--text-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:text-gray-500 {\n    --text-opacity: 1;\n    color: #6b7280;\n    color: rgba(107, 114, 128, var(--text-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:text-gray-600 {\n    --text-opacity: 1;\n    color: #4b5563;\n    color: rgba(75, 85, 99, var(--text-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:text-gray-700 {\n    --text-opacity: 1;\n    color: #374151;\n    color: rgba(55, 65, 81, var(--text-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:text-gray-800 {\n    --text-opacity: 1;\n    color: #252f3f;\n    color: rgba(37, 47, 63, var(--text-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:text-gray-900 {\n    --text-opacity: 1;\n    color: #161e2e;\n    color: rgba(22, 30, 46, var(--text-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:text-red-50 {\n    --text-opacity: 1;\n    color: #fdf2f2;\n    color: rgba(253, 242, 242, var(--text-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:text-red-100 {\n    --text-opacity: 1;\n    color: #fde8e8;\n    color: rgba(253, 232, 232, var(--text-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:text-red-200 {\n    --text-opacity: 1;\n    color: #fbd5d5;\n    color: rgba(251, 213, 213, var(--text-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:text-red-300 {\n    --text-opacity: 1;\n    color: #f8b4b4;\n    color: rgba(248, 180, 180, var(--text-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:text-red-400 {\n    --text-opacity: 1;\n    color: #f98080;\n    color: rgba(249, 128, 128, var(--text-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:text-red-500 {\n    --text-opacity: 1;\n    color: #f05252;\n    color: rgba(240, 82, 82, var(--text-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:text-red-600 {\n    --text-opacity: 1;\n    color: #e02424;\n    color: rgba(224, 36, 36, var(--text-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:text-red-700 {\n    --text-opacity: 1;\n    color: #c81e1e;\n    color: rgba(200, 30, 30, var(--text-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:text-red-800 {\n    --text-opacity: 1;\n    color: #9b1c1c;\n    color: rgba(155, 28, 28, var(--text-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:text-red-900 {\n    --text-opacity: 1;\n    color: #771d1d;\n    color: rgba(119, 29, 29, var(--text-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:text-orange-50 {\n    --text-opacity: 1;\n    color: #fff8f1;\n    color: rgba(255, 248, 241, var(--text-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:text-orange-100 {\n    --text-opacity: 1;\n    color: #feecdc;\n    color: rgba(254, 236, 220, var(--text-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:text-orange-200 {\n    --text-opacity: 1;\n    color: #fcd9bd;\n    color: rgba(252, 217, 189, var(--text-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:text-orange-300 {\n    --text-opacity: 1;\n    color: #fdba8c;\n    color: rgba(253, 186, 140, var(--text-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:text-orange-400 {\n    --text-opacity: 1;\n    color: #ff8a4c;\n    color: rgba(255, 138, 76, var(--text-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:text-orange-500 {\n    --text-opacity: 1;\n    color: #ff5a1f;\n    color: rgba(255, 90, 31, var(--text-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:text-orange-600 {\n    --text-opacity: 1;\n    color: #d03801;\n    color: rgba(208, 56, 1, var(--text-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:text-orange-700 {\n    --text-opacity: 1;\n    color: #b43403;\n    color: rgba(180, 52, 3, var(--text-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:text-orange-800 {\n    --text-opacity: 1;\n    color: #8a2c0d;\n    color: rgba(138, 44, 13, var(--text-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:text-orange-900 {\n    --text-opacity: 1;\n    color: #73230d;\n    color: rgba(115, 35, 13, var(--text-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:text-yellow-50 {\n    --text-opacity: 1;\n    color: #fdfdea;\n    color: rgba(253, 253, 234, var(--text-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:text-yellow-100 {\n    --text-opacity: 1;\n    color: #fdf6b2;\n    color: rgba(253, 246, 178, var(--text-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:text-yellow-200 {\n    --text-opacity: 1;\n    color: #fce96a;\n    color: rgba(252, 233, 106, var(--text-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:text-yellow-300 {\n    --text-opacity: 1;\n    color: #faca15;\n    color: rgba(250, 202, 21, var(--text-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:text-yellow-400 {\n    --text-opacity: 1;\n    color: #e3a008;\n    color: rgba(227, 160, 8, var(--text-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:text-yellow-500 {\n    --text-opacity: 1;\n    color: #c27803;\n    color: rgba(194, 120, 3, var(--text-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:text-yellow-600 {\n    --text-opacity: 1;\n    color: #9f580a;\n    color: rgba(159, 88, 10, var(--text-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:text-yellow-700 {\n    --text-opacity: 1;\n    color: #8e4b10;\n    color: rgba(142, 75, 16, var(--text-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:text-yellow-800 {\n    --text-opacity: 1;\n    color: #723b13;\n    color: rgba(114, 59, 19, var(--text-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:text-yellow-900 {\n    --text-opacity: 1;\n    color: #633112;\n    color: rgba(99, 49, 18, var(--text-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:text-green-50 {\n    --text-opacity: 1;\n    color: #f3faf7;\n    color: rgba(243, 250, 247, var(--text-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:text-green-100 {\n    --text-opacity: 1;\n    color: #def7ec;\n    color: rgba(222, 247, 236, var(--text-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:text-green-200 {\n    --text-opacity: 1;\n    color: #bcf0da;\n    color: rgba(188, 240, 218, var(--text-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:text-green-300 {\n    --text-opacity: 1;\n    color: #84e1bc;\n    color: rgba(132, 225, 188, var(--text-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:text-green-400 {\n    --text-opacity: 1;\n    color: #31c48d;\n    color: rgba(49, 196, 141, var(--text-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:text-green-500 {\n    --text-opacity: 1;\n    color: #0e9f6e;\n    color: rgba(14, 159, 110, var(--text-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:text-green-600 {\n    --text-opacity: 1;\n    color: #057a55;\n    color: rgba(5, 122, 85, var(--text-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:text-green-700 {\n    --text-opacity: 1;\n    color: #046c4e;\n    color: rgba(4, 108, 78, var(--text-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:text-green-800 {\n    --text-opacity: 1;\n    color: #03543f;\n    color: rgba(3, 84, 63, var(--text-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:text-green-900 {\n    --text-opacity: 1;\n    color: #014737;\n    color: rgba(1, 71, 55, var(--text-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:text-teal-50 {\n    --text-opacity: 1;\n    color: #edfafa;\n    color: rgba(237, 250, 250, var(--text-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:text-teal-100 {\n    --text-opacity: 1;\n    color: #d5f5f6;\n    color: rgba(213, 245, 246, var(--text-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:text-teal-200 {\n    --text-opacity: 1;\n    color: #afecef;\n    color: rgba(175, 236, 239, var(--text-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:text-teal-300 {\n    --text-opacity: 1;\n    color: #7edce2;\n    color: rgba(126, 220, 226, var(--text-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:text-teal-400 {\n    --text-opacity: 1;\n    color: #16bdca;\n    color: rgba(22, 189, 202, var(--text-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:text-teal-500 {\n    --text-opacity: 1;\n    color: #0694a2;\n    color: rgba(6, 148, 162, var(--text-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:text-teal-600 {\n    --text-opacity: 1;\n    color: #047481;\n    color: rgba(4, 116, 129, var(--text-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:text-teal-700 {\n    --text-opacity: 1;\n    color: #036672;\n    color: rgba(3, 102, 114, var(--text-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:text-teal-800 {\n    --text-opacity: 1;\n    color: #05505c;\n    color: rgba(5, 80, 92, var(--text-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:text-teal-900 {\n    --text-opacity: 1;\n    color: #014451;\n    color: rgba(1, 68, 81, var(--text-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:text-blue-50 {\n    --text-opacity: 1;\n    color: #ebf5ff;\n    color: rgba(235, 245, 255, var(--text-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:text-blue-100 {\n    --text-opacity: 1;\n    color: #e1effe;\n    color: rgba(225, 239, 254, var(--text-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:text-blue-200 {\n    --text-opacity: 1;\n    color: #c3ddfd;\n    color: rgba(195, 221, 253, var(--text-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:text-blue-300 {\n    --text-opacity: 1;\n    color: #a4cafe;\n    color: rgba(164, 202, 254, var(--text-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:text-blue-400 {\n    --text-opacity: 1;\n    color: #76a9fa;\n    color: rgba(118, 169, 250, var(--text-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:text-blue-500 {\n    --text-opacity: 1;\n    color: #3f83f8;\n    color: rgba(63, 131, 248, var(--text-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:text-blue-600 {\n    --text-opacity: 1;\n    color: #1c64f2;\n    color: rgba(28, 100, 242, var(--text-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:text-blue-700 {\n    --text-opacity: 1;\n    color: #1a56db;\n    color: rgba(26, 86, 219, var(--text-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:text-blue-800 {\n    --text-opacity: 1;\n    color: #1e429f;\n    color: rgba(30, 66, 159, var(--text-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:text-blue-900 {\n    --text-opacity: 1;\n    color: #233876;\n    color: rgba(35, 56, 118, var(--text-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:text-indigo-50 {\n    --text-opacity: 1;\n    color: #f0f5ff;\n    color: rgba(240, 245, 255, var(--text-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:text-indigo-100 {\n    --text-opacity: 1;\n    color: #e5edff;\n    color: rgba(229, 237, 255, var(--text-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:text-indigo-200 {\n    --text-opacity: 1;\n    color: #cddbfe;\n    color: rgba(205, 219, 254, var(--text-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:text-indigo-300 {\n    --text-opacity: 1;\n    color: #b4c6fc;\n    color: rgba(180, 198, 252, var(--text-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:text-indigo-400 {\n    --text-opacity: 1;\n    color: #8da2fb;\n    color: rgba(141, 162, 251, var(--text-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:text-indigo-500 {\n    --text-opacity: 1;\n    color: #6875f5;\n    color: rgba(104, 117, 245, var(--text-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:text-indigo-600 {\n    --text-opacity: 1;\n    color: #5850ec;\n    color: rgba(88, 80, 236, var(--text-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:text-indigo-700 {\n    --text-opacity: 1;\n    color: #5145cd;\n    color: rgba(81, 69, 205, var(--text-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:text-indigo-800 {\n    --text-opacity: 1;\n    color: #42389d;\n    color: rgba(66, 56, 157, var(--text-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:text-indigo-900 {\n    --text-opacity: 1;\n    color: #362f78;\n    color: rgba(54, 47, 120, var(--text-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:text-purple-50 {\n    --text-opacity: 1;\n    color: #f6f5ff;\n    color: rgba(246, 245, 255, var(--text-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:text-purple-100 {\n    --text-opacity: 1;\n    color: #edebfe;\n    color: rgba(237, 235, 254, var(--text-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:text-purple-200 {\n    --text-opacity: 1;\n    color: #dcd7fe;\n    color: rgba(220, 215, 254, var(--text-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:text-purple-300 {\n    --text-opacity: 1;\n    color: #cabffd;\n    color: rgba(202, 191, 253, var(--text-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:text-purple-400 {\n    --text-opacity: 1;\n    color: #ac94fa;\n    color: rgba(172, 148, 250, var(--text-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:text-purple-500 {\n    --text-opacity: 1;\n    color: #9061f9;\n    color: rgba(144, 97, 249, var(--text-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:text-purple-600 {\n    --text-opacity: 1;\n    color: #7e3af2;\n    color: rgba(126, 58, 242, var(--text-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:text-purple-700 {\n    --text-opacity: 1;\n    color: #6c2bd9;\n    color: rgba(108, 43, 217, var(--text-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:text-purple-800 {\n    --text-opacity: 1;\n    color: #5521b5;\n    color: rgba(85, 33, 181, var(--text-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:text-purple-900 {\n    --text-opacity: 1;\n    color: #4a1d96;\n    color: rgba(74, 29, 150, var(--text-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:text-pink-50 {\n    --text-opacity: 1;\n    color: #fdf2f8;\n    color: rgba(253, 242, 248, var(--text-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:text-pink-100 {\n    --text-opacity: 1;\n    color: #fce8f3;\n    color: rgba(252, 232, 243, var(--text-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:text-pink-200 {\n    --text-opacity: 1;\n    color: #fad1e8;\n    color: rgba(250, 209, 232, var(--text-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:text-pink-300 {\n    --text-opacity: 1;\n    color: #f8b4d9;\n    color: rgba(248, 180, 217, var(--text-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:text-pink-400 {\n    --text-opacity: 1;\n    color: #f17eb8;\n    color: rgba(241, 126, 184, var(--text-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:text-pink-500 {\n    --text-opacity: 1;\n    color: #e74694;\n    color: rgba(231, 70, 148, var(--text-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:text-pink-600 {\n    --text-opacity: 1;\n    color: #d61f69;\n    color: rgba(214, 31, 105, var(--text-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:text-pink-700 {\n    --text-opacity: 1;\n    color: #bf125d;\n    color: rgba(191, 18, 93, var(--text-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:text-pink-800 {\n    --text-opacity: 1;\n    color: #99154b;\n    color: rgba(153, 21, 75, var(--text-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:text-pink-900 {\n    --text-opacity: 1;\n    color: #751a3d;\n    color: rgba(117, 26, 61, var(--text-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:text-cool-gray-50 {\n    --text-opacity: 1;\n    color: #f8fafc;\n    color: rgba(248, 250, 252, var(--text-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:text-cool-gray-100 {\n    --text-opacity: 1;\n    color: #f1f5f9;\n    color: rgba(241, 245, 249, var(--text-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:text-cool-gray-200 {\n    --text-opacity: 1;\n    color: #e2e8f0;\n    color: rgba(226, 232, 240, var(--text-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:text-cool-gray-300 {\n    --text-opacity: 1;\n    color: #cfd8e3;\n    color: rgba(207, 216, 227, var(--text-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:text-cool-gray-400 {\n    --text-opacity: 1;\n    color: #97a6ba;\n    color: rgba(151, 166, 186, var(--text-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:text-cool-gray-500 {\n    --text-opacity: 1;\n    color: #64748b;\n    color: rgba(100, 116, 139, var(--text-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:text-cool-gray-600 {\n    --text-opacity: 1;\n    color: #475569;\n    color: rgba(71, 85, 105, var(--text-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:text-cool-gray-700 {\n    --text-opacity: 1;\n    color: #364152;\n    color: rgba(54, 65, 82, var(--text-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:text-cool-gray-800 {\n    --text-opacity: 1;\n    color: #27303f;\n    color: rgba(39, 48, 63, var(--text-opacity));\n  }\n  .group:focus .sm\\:group-focus\\:text-cool-gray-900 {\n    --text-opacity: 1;\n    color: #1a202e;\n    color: rgba(26, 32, 46, var(--text-opacity));\n  }\n  .sm\\:hover\\:text-current:hover {\n    color: currentColor;\n  }\n  .sm\\:hover\\:text-transparent:hover {\n    color: transparent;\n  }\n  .sm\\:hover\\:text-white:hover {\n    --text-opacity: 1;\n    color: #ffffff;\n    color: rgba(255, 255, 255, var(--text-opacity));\n  }\n  .sm\\:hover\\:text-black:hover {\n    --text-opacity: 1;\n    color: #000000;\n    color: rgba(0, 0, 0, var(--text-opacity));\n  }\n  .sm\\:hover\\:text-gray-50:hover {\n    --text-opacity: 1;\n    color: #f9fafb;\n    color: rgba(249, 250, 251, var(--text-opacity));\n  }\n  .sm\\:hover\\:text-gray-100:hover {\n    --text-opacity: 1;\n    color: #f4f5f7;\n    color: rgba(244, 245, 247, var(--text-opacity));\n  }\n  .sm\\:hover\\:text-gray-200:hover {\n    --text-opacity: 1;\n    color: #e5e7eb;\n    color: rgba(229, 231, 235, var(--text-opacity));\n  }\n  .sm\\:hover\\:text-gray-300:hover {\n    --text-opacity: 1;\n    color: #d2d6dc;\n    color: rgba(210, 214, 220, var(--text-opacity));\n  }\n  .sm\\:hover\\:text-gray-400:hover {\n    --text-opacity: 1;\n    color: #9fa6b2;\n    color: rgba(159, 166, 178, var(--text-opacity));\n  }\n  .sm\\:hover\\:text-gray-500:hover {\n    --text-opacity: 1;\n    color: #6b7280;\n    color: rgba(107, 114, 128, var(--text-opacity));\n  }\n  .sm\\:hover\\:text-gray-600:hover {\n    --text-opacity: 1;\n    color: #4b5563;\n    color: rgba(75, 85, 99, var(--text-opacity));\n  }\n  .sm\\:hover\\:text-gray-700:hover {\n    --text-opacity: 1;\n    color: #374151;\n    color: rgba(55, 65, 81, var(--text-opacity));\n  }\n  .sm\\:hover\\:text-gray-800:hover {\n    --text-opacity: 1;\n    color: #252f3f;\n    color: rgba(37, 47, 63, var(--text-opacity));\n  }\n  .sm\\:hover\\:text-gray-900:hover {\n    --text-opacity: 1;\n    color: #161e2e;\n    color: rgba(22, 30, 46, var(--text-opacity));\n  }\n  .sm\\:hover\\:text-red-50:hover {\n    --text-opacity: 1;\n    color: #fdf2f2;\n    color: rgba(253, 242, 242, var(--text-opacity));\n  }\n  .sm\\:hover\\:text-red-100:hover {\n    --text-opacity: 1;\n    color: #fde8e8;\n    color: rgba(253, 232, 232, var(--text-opacity));\n  }\n  .sm\\:hover\\:text-red-200:hover {\n    --text-opacity: 1;\n    color: #fbd5d5;\n    color: rgba(251, 213, 213, var(--text-opacity));\n  }\n  .sm\\:hover\\:text-red-300:hover {\n    --text-opacity: 1;\n    color: #f8b4b4;\n    color: rgba(248, 180, 180, var(--text-opacity));\n  }\n  .sm\\:hover\\:text-red-400:hover {\n    --text-opacity: 1;\n    color: #f98080;\n    color: rgba(249, 128, 128, var(--text-opacity));\n  }\n  .sm\\:hover\\:text-red-500:hover {\n    --text-opacity: 1;\n    color: #f05252;\n    color: rgba(240, 82, 82, var(--text-opacity));\n  }\n  .sm\\:hover\\:text-red-600:hover {\n    --text-opacity: 1;\n    color: #e02424;\n    color: rgba(224, 36, 36, var(--text-opacity));\n  }\n  .sm\\:hover\\:text-red-700:hover {\n    --text-opacity: 1;\n    color: #c81e1e;\n    color: rgba(200, 30, 30, var(--text-opacity));\n  }\n  .sm\\:hover\\:text-red-800:hover {\n    --text-opacity: 1;\n    color: #9b1c1c;\n    color: rgba(155, 28, 28, var(--text-opacity));\n  }\n  .sm\\:hover\\:text-red-900:hover {\n    --text-opacity: 1;\n    color: #771d1d;\n    color: rgba(119, 29, 29, var(--text-opacity));\n  }\n  .sm\\:hover\\:text-orange-50:hover {\n    --text-opacity: 1;\n    color: #fff8f1;\n    color: rgba(255, 248, 241, var(--text-opacity));\n  }\n  .sm\\:hover\\:text-orange-100:hover {\n    --text-opacity: 1;\n    color: #feecdc;\n    color: rgba(254, 236, 220, var(--text-opacity));\n  }\n  .sm\\:hover\\:text-orange-200:hover {\n    --text-opacity: 1;\n    color: #fcd9bd;\n    color: rgba(252, 217, 189, var(--text-opacity));\n  }\n  .sm\\:hover\\:text-orange-300:hover {\n    --text-opacity: 1;\n    color: #fdba8c;\n    color: rgba(253, 186, 140, var(--text-opacity));\n  }\n  .sm\\:hover\\:text-orange-400:hover {\n    --text-opacity: 1;\n    color: #ff8a4c;\n    color: rgba(255, 138, 76, var(--text-opacity));\n  }\n  .sm\\:hover\\:text-orange-500:hover {\n    --text-opacity: 1;\n    color: #ff5a1f;\n    color: rgba(255, 90, 31, var(--text-opacity));\n  }\n  .sm\\:hover\\:text-orange-600:hover {\n    --text-opacity: 1;\n    color: #d03801;\n    color: rgba(208, 56, 1, var(--text-opacity));\n  }\n  .sm\\:hover\\:text-orange-700:hover {\n    --text-opacity: 1;\n    color: #b43403;\n    color: rgba(180, 52, 3, var(--text-opacity));\n  }\n  .sm\\:hover\\:text-orange-800:hover {\n    --text-opacity: 1;\n    color: #8a2c0d;\n    color: rgba(138, 44, 13, var(--text-opacity));\n  }\n  .sm\\:hover\\:text-orange-900:hover {\n    --text-opacity: 1;\n    color: #73230d;\n    color: rgba(115, 35, 13, var(--text-opacity));\n  }\n  .sm\\:hover\\:text-yellow-50:hover {\n    --text-opacity: 1;\n    color: #fdfdea;\n    color: rgba(253, 253, 234, var(--text-opacity));\n  }\n  .sm\\:hover\\:text-yellow-100:hover {\n    --text-opacity: 1;\n    color: #fdf6b2;\n    color: rgba(253, 246, 178, var(--text-opacity));\n  }\n  .sm\\:hover\\:text-yellow-200:hover {\n    --text-opacity: 1;\n    color: #fce96a;\n    color: rgba(252, 233, 106, var(--text-opacity));\n  }\n  .sm\\:hover\\:text-yellow-300:hover {\n    --text-opacity: 1;\n    color: #faca15;\n    color: rgba(250, 202, 21, var(--text-opacity));\n  }\n  .sm\\:hover\\:text-yellow-400:hover {\n    --text-opacity: 1;\n    color: #e3a008;\n    color: rgba(227, 160, 8, var(--text-opacity));\n  }\n  .sm\\:hover\\:text-yellow-500:hover {\n    --text-opacity: 1;\n    color: #c27803;\n    color: rgba(194, 120, 3, var(--text-opacity));\n  }\n  .sm\\:hover\\:text-yellow-600:hover {\n    --text-opacity: 1;\n    color: #9f580a;\n    color: rgba(159, 88, 10, var(--text-opacity));\n  }\n  .sm\\:hover\\:text-yellow-700:hover {\n    --text-opacity: 1;\n    color: #8e4b10;\n    color: rgba(142, 75, 16, var(--text-opacity));\n  }\n  .sm\\:hover\\:text-yellow-800:hover {\n    --text-opacity: 1;\n    color: #723b13;\n    color: rgba(114, 59, 19, var(--text-opacity));\n  }\n  .sm\\:hover\\:text-yellow-900:hover {\n    --text-opacity: 1;\n    color: #633112;\n    color: rgba(99, 49, 18, var(--text-opacity));\n  }\n  .sm\\:hover\\:text-green-50:hover {\n    --text-opacity: 1;\n    color: #f3faf7;\n    color: rgba(243, 250, 247, var(--text-opacity));\n  }\n  .sm\\:hover\\:text-green-100:hover {\n    --text-opacity: 1;\n    color: #def7ec;\n    color: rgba(222, 247, 236, var(--text-opacity));\n  }\n  .sm\\:hover\\:text-green-200:hover {\n    --text-opacity: 1;\n    color: #bcf0da;\n    color: rgba(188, 240, 218, var(--text-opacity));\n  }\n  .sm\\:hover\\:text-green-300:hover {\n    --text-opacity: 1;\n    color: #84e1bc;\n    color: rgba(132, 225, 188, var(--text-opacity));\n  }\n  .sm\\:hover\\:text-green-400:hover {\n    --text-opacity: 1;\n    color: #31c48d;\n    color: rgba(49, 196, 141, var(--text-opacity));\n  }\n  .sm\\:hover\\:text-green-500:hover {\n    --text-opacity: 1;\n    color: #0e9f6e;\n    color: rgba(14, 159, 110, var(--text-opacity));\n  }\n  .sm\\:hover\\:text-green-600:hover {\n    --text-opacity: 1;\n    color: #057a55;\n    color: rgba(5, 122, 85, var(--text-opacity));\n  }\n  .sm\\:hover\\:text-green-700:hover {\n    --text-opacity: 1;\n    color: #046c4e;\n    color: rgba(4, 108, 78, var(--text-opacity));\n  }\n  .sm\\:hover\\:text-green-800:hover {\n    --text-opacity: 1;\n    color: #03543f;\n    color: rgba(3, 84, 63, var(--text-opacity));\n  }\n  .sm\\:hover\\:text-green-900:hover {\n    --text-opacity: 1;\n    color: #014737;\n    color: rgba(1, 71, 55, var(--text-opacity));\n  }\n  .sm\\:hover\\:text-teal-50:hover {\n    --text-opacity: 1;\n    color: #edfafa;\n    color: rgba(237, 250, 250, var(--text-opacity));\n  }\n  .sm\\:hover\\:text-teal-100:hover {\n    --text-opacity: 1;\n    color: #d5f5f6;\n    color: rgba(213, 245, 246, var(--text-opacity));\n  }\n  .sm\\:hover\\:text-teal-200:hover {\n    --text-opacity: 1;\n    color: #afecef;\n    color: rgba(175, 236, 239, var(--text-opacity));\n  }\n  .sm\\:hover\\:text-teal-300:hover {\n    --text-opacity: 1;\n    color: #7edce2;\n    color: rgba(126, 220, 226, var(--text-opacity));\n  }\n  .sm\\:hover\\:text-teal-400:hover {\n    --text-opacity: 1;\n    color: #16bdca;\n    color: rgba(22, 189, 202, var(--text-opacity));\n  }\n  .sm\\:hover\\:text-teal-500:hover {\n    --text-opacity: 1;\n    color: #0694a2;\n    color: rgba(6, 148, 162, var(--text-opacity));\n  }\n  .sm\\:hover\\:text-teal-600:hover {\n    --text-opacity: 1;\n    color: #047481;\n    color: rgba(4, 116, 129, var(--text-opacity));\n  }\n  .sm\\:hover\\:text-teal-700:hover {\n    --text-opacity: 1;\n    color: #036672;\n    color: rgba(3, 102, 114, var(--text-opacity));\n  }\n  .sm\\:hover\\:text-teal-800:hover {\n    --text-opacity: 1;\n    color: #05505c;\n    color: rgba(5, 80, 92, var(--text-opacity));\n  }\n  .sm\\:hover\\:text-teal-900:hover {\n    --text-opacity: 1;\n    color: #014451;\n    color: rgba(1, 68, 81, var(--text-opacity));\n  }\n  .sm\\:hover\\:text-blue-50:hover {\n    --text-opacity: 1;\n    color: #ebf5ff;\n    color: rgba(235, 245, 255, var(--text-opacity));\n  }\n  .sm\\:hover\\:text-blue-100:hover {\n    --text-opacity: 1;\n    color: #e1effe;\n    color: rgba(225, 239, 254, var(--text-opacity));\n  }\n  .sm\\:hover\\:text-blue-200:hover {\n    --text-opacity: 1;\n    color: #c3ddfd;\n    color: rgba(195, 221, 253, var(--text-opacity));\n  }\n  .sm\\:hover\\:text-blue-300:hover {\n    --text-opacity: 1;\n    color: #a4cafe;\n    color: rgba(164, 202, 254, var(--text-opacity));\n  }\n  .sm\\:hover\\:text-blue-400:hover {\n    --text-opacity: 1;\n    color: #76a9fa;\n    color: rgba(118, 169, 250, var(--text-opacity));\n  }\n  .sm\\:hover\\:text-blue-500:hover {\n    --text-opacity: 1;\n    color: #3f83f8;\n    color: rgba(63, 131, 248, var(--text-opacity));\n  }\n  .sm\\:hover\\:text-blue-600:hover {\n    --text-opacity: 1;\n    color: #1c64f2;\n    color: rgba(28, 100, 242, var(--text-opacity));\n  }\n  .sm\\:hover\\:text-blue-700:hover {\n    --text-opacity: 1;\n    color: #1a56db;\n    color: rgba(26, 86, 219, var(--text-opacity));\n  }\n  .sm\\:hover\\:text-blue-800:hover {\n    --text-opacity: 1;\n    color: #1e429f;\n    color: rgba(30, 66, 159, var(--text-opacity));\n  }\n  .sm\\:hover\\:text-blue-900:hover {\n    --text-opacity: 1;\n    color: #233876;\n    color: rgba(35, 56, 118, var(--text-opacity));\n  }\n  .sm\\:hover\\:text-indigo-50:hover {\n    --text-opacity: 1;\n    color: #f0f5ff;\n    color: rgba(240, 245, 255, var(--text-opacity));\n  }\n  .sm\\:hover\\:text-indigo-100:hover {\n    --text-opacity: 1;\n    color: #e5edff;\n    color: rgba(229, 237, 255, var(--text-opacity));\n  }\n  .sm\\:hover\\:text-indigo-200:hover {\n    --text-opacity: 1;\n    color: #cddbfe;\n    color: rgba(205, 219, 254, var(--text-opacity));\n  }\n  .sm\\:hover\\:text-indigo-300:hover {\n    --text-opacity: 1;\n    color: #b4c6fc;\n    color: rgba(180, 198, 252, var(--text-opacity));\n  }\n  .sm\\:hover\\:text-indigo-400:hover {\n    --text-opacity: 1;\n    color: #8da2fb;\n    color: rgba(141, 162, 251, var(--text-opacity));\n  }\n  .sm\\:hover\\:text-indigo-500:hover {\n    --text-opacity: 1;\n    color: #6875f5;\n    color: rgba(104, 117, 245, var(--text-opacity));\n  }\n  .sm\\:hover\\:text-indigo-600:hover {\n    --text-opacity: 1;\n    color: #5850ec;\n    color: rgba(88, 80, 236, var(--text-opacity));\n  }\n  .sm\\:hover\\:text-indigo-700:hover {\n    --text-opacity: 1;\n    color: #5145cd;\n    color: rgba(81, 69, 205, var(--text-opacity));\n  }\n  .sm\\:hover\\:text-indigo-800:hover {\n    --text-opacity: 1;\n    color: #42389d;\n    color: rgba(66, 56, 157, var(--text-opacity));\n  }\n  .sm\\:hover\\:text-indigo-900:hover {\n    --text-opacity: 1;\n    color: #362f78;\n    color: rgba(54, 47, 120, var(--text-opacity));\n  }\n  .sm\\:hover\\:text-purple-50:hover {\n    --text-opacity: 1;\n    color: #f6f5ff;\n    color: rgba(246, 245, 255, var(--text-opacity));\n  }\n  .sm\\:hover\\:text-purple-100:hover {\n    --text-opacity: 1;\n    color: #edebfe;\n    color: rgba(237, 235, 254, var(--text-opacity));\n  }\n  .sm\\:hover\\:text-purple-200:hover {\n    --text-opacity: 1;\n    color: #dcd7fe;\n    color: rgba(220, 215, 254, var(--text-opacity));\n  }\n  .sm\\:hover\\:text-purple-300:hover {\n    --text-opacity: 1;\n    color: #cabffd;\n    color: rgba(202, 191, 253, var(--text-opacity));\n  }\n  .sm\\:hover\\:text-purple-400:hover {\n    --text-opacity: 1;\n    color: #ac94fa;\n    color: rgba(172, 148, 250, var(--text-opacity));\n  }\n  .sm\\:hover\\:text-purple-500:hover {\n    --text-opacity: 1;\n    color: #9061f9;\n    color: rgba(144, 97, 249, var(--text-opacity));\n  }\n  .sm\\:hover\\:text-purple-600:hover {\n    --text-opacity: 1;\n    color: #7e3af2;\n    color: rgba(126, 58, 242, var(--text-opacity));\n  }\n  .sm\\:hover\\:text-purple-700:hover {\n    --text-opacity: 1;\n    color: #6c2bd9;\n    color: rgba(108, 43, 217, var(--text-opacity));\n  }\n  .sm\\:hover\\:text-purple-800:hover {\n    --text-opacity: 1;\n    color: #5521b5;\n    color: rgba(85, 33, 181, var(--text-opacity));\n  }\n  .sm\\:hover\\:text-purple-900:hover {\n    --text-opacity: 1;\n    color: #4a1d96;\n    color: rgba(74, 29, 150, var(--text-opacity));\n  }\n  .sm\\:hover\\:text-pink-50:hover {\n    --text-opacity: 1;\n    color: #fdf2f8;\n    color: rgba(253, 242, 248, var(--text-opacity));\n  }\n  .sm\\:hover\\:text-pink-100:hover {\n    --text-opacity: 1;\n    color: #fce8f3;\n    color: rgba(252, 232, 243, var(--text-opacity));\n  }\n  .sm\\:hover\\:text-pink-200:hover {\n    --text-opacity: 1;\n    color: #fad1e8;\n    color: rgba(250, 209, 232, var(--text-opacity));\n  }\n  .sm\\:hover\\:text-pink-300:hover {\n    --text-opacity: 1;\n    color: #f8b4d9;\n    color: rgba(248, 180, 217, var(--text-opacity));\n  }\n  .sm\\:hover\\:text-pink-400:hover {\n    --text-opacity: 1;\n    color: #f17eb8;\n    color: rgba(241, 126, 184, var(--text-opacity));\n  }\n  .sm\\:hover\\:text-pink-500:hover {\n    --text-opacity: 1;\n    color: #e74694;\n    color: rgba(231, 70, 148, var(--text-opacity));\n  }\n  .sm\\:hover\\:text-pink-600:hover {\n    --text-opacity: 1;\n    color: #d61f69;\n    color: rgba(214, 31, 105, var(--text-opacity));\n  }\n  .sm\\:hover\\:text-pink-700:hover {\n    --text-opacity: 1;\n    color: #bf125d;\n    color: rgba(191, 18, 93, var(--text-opacity));\n  }\n  .sm\\:hover\\:text-pink-800:hover {\n    --text-opacity: 1;\n    color: #99154b;\n    color: rgba(153, 21, 75, var(--text-opacity));\n  }\n  .sm\\:hover\\:text-pink-900:hover {\n    --text-opacity: 1;\n    color: #751a3d;\n    color: rgba(117, 26, 61, var(--text-opacity));\n  }\n  .sm\\:hover\\:text-cool-gray-50:hover {\n    --text-opacity: 1;\n    color: #f8fafc;\n    color: rgba(248, 250, 252, var(--text-opacity));\n  }\n  .sm\\:hover\\:text-cool-gray-100:hover {\n    --text-opacity: 1;\n    color: #f1f5f9;\n    color: rgba(241, 245, 249, var(--text-opacity));\n  }\n  .sm\\:hover\\:text-cool-gray-200:hover {\n    --text-opacity: 1;\n    color: #e2e8f0;\n    color: rgba(226, 232, 240, var(--text-opacity));\n  }\n  .sm\\:hover\\:text-cool-gray-300:hover {\n    --text-opacity: 1;\n    color: #cfd8e3;\n    color: rgba(207, 216, 227, var(--text-opacity));\n  }\n  .sm\\:hover\\:text-cool-gray-400:hover {\n    --text-opacity: 1;\n    color: #97a6ba;\n    color: rgba(151, 166, 186, var(--text-opacity));\n  }\n  .sm\\:hover\\:text-cool-gray-500:hover {\n    --text-opacity: 1;\n    color: #64748b;\n    color: rgba(100, 116, 139, var(--text-opacity));\n  }\n  .sm\\:hover\\:text-cool-gray-600:hover {\n    --text-opacity: 1;\n    color: #475569;\n    color: rgba(71, 85, 105, var(--text-opacity));\n  }\n  .sm\\:hover\\:text-cool-gray-700:hover {\n    --text-opacity: 1;\n    color: #364152;\n    color: rgba(54, 65, 82, var(--text-opacity));\n  }\n  .sm\\:hover\\:text-cool-gray-800:hover {\n    --text-opacity: 1;\n    color: #27303f;\n    color: rgba(39, 48, 63, var(--text-opacity));\n  }\n  .sm\\:hover\\:text-cool-gray-900:hover {\n    --text-opacity: 1;\n    color: #1a202e;\n    color: rgba(26, 32, 46, var(--text-opacity));\n  }\n  .sm\\:focus-within\\:text-current:focus-within {\n    color: currentColor;\n  }\n  .sm\\:focus-within\\:text-transparent:focus-within {\n    color: transparent;\n  }\n  .sm\\:focus-within\\:text-white:focus-within {\n    --text-opacity: 1;\n    color: #ffffff;\n    color: rgba(255, 255, 255, var(--text-opacity));\n  }\n  .sm\\:focus-within\\:text-black:focus-within {\n    --text-opacity: 1;\n    color: #000000;\n    color: rgba(0, 0, 0, var(--text-opacity));\n  }\n  .sm\\:focus-within\\:text-gray-50:focus-within {\n    --text-opacity: 1;\n    color: #f9fafb;\n    color: rgba(249, 250, 251, var(--text-opacity));\n  }\n  .sm\\:focus-within\\:text-gray-100:focus-within {\n    --text-opacity: 1;\n    color: #f4f5f7;\n    color: rgba(244, 245, 247, var(--text-opacity));\n  }\n  .sm\\:focus-within\\:text-gray-200:focus-within {\n    --text-opacity: 1;\n    color: #e5e7eb;\n    color: rgba(229, 231, 235, var(--text-opacity));\n  }\n  .sm\\:focus-within\\:text-gray-300:focus-within {\n    --text-opacity: 1;\n    color: #d2d6dc;\n    color: rgba(210, 214, 220, var(--text-opacity));\n  }\n  .sm\\:focus-within\\:text-gray-400:focus-within {\n    --text-opacity: 1;\n    color: #9fa6b2;\n    color: rgba(159, 166, 178, var(--text-opacity));\n  }\n  .sm\\:focus-within\\:text-gray-500:focus-within {\n    --text-opacity: 1;\n    color: #6b7280;\n    color: rgba(107, 114, 128, var(--text-opacity));\n  }\n  .sm\\:focus-within\\:text-gray-600:focus-within {\n    --text-opacity: 1;\n    color: #4b5563;\n    color: rgba(75, 85, 99, var(--text-opacity));\n  }\n  .sm\\:focus-within\\:text-gray-700:focus-within {\n    --text-opacity: 1;\n    color: #374151;\n    color: rgba(55, 65, 81, var(--text-opacity));\n  }\n  .sm\\:focus-within\\:text-gray-800:focus-within {\n    --text-opacity: 1;\n    color: #252f3f;\n    color: rgba(37, 47, 63, var(--text-opacity));\n  }\n  .sm\\:focus-within\\:text-gray-900:focus-within {\n    --text-opacity: 1;\n    color: #161e2e;\n    color: rgba(22, 30, 46, var(--text-opacity));\n  }\n  .sm\\:focus-within\\:text-red-50:focus-within {\n    --text-opacity: 1;\n    color: #fdf2f2;\n    color: rgba(253, 242, 242, var(--text-opacity));\n  }\n  .sm\\:focus-within\\:text-red-100:focus-within {\n    --text-opacity: 1;\n    color: #fde8e8;\n    color: rgba(253, 232, 232, var(--text-opacity));\n  }\n  .sm\\:focus-within\\:text-red-200:focus-within {\n    --text-opacity: 1;\n    color: #fbd5d5;\n    color: rgba(251, 213, 213, var(--text-opacity));\n  }\n  .sm\\:focus-within\\:text-red-300:focus-within {\n    --text-opacity: 1;\n    color: #f8b4b4;\n    color: rgba(248, 180, 180, var(--text-opacity));\n  }\n  .sm\\:focus-within\\:text-red-400:focus-within {\n    --text-opacity: 1;\n    color: #f98080;\n    color: rgba(249, 128, 128, var(--text-opacity));\n  }\n  .sm\\:focus-within\\:text-red-500:focus-within {\n    --text-opacity: 1;\n    color: #f05252;\n    color: rgba(240, 82, 82, var(--text-opacity));\n  }\n  .sm\\:focus-within\\:text-red-600:focus-within {\n    --text-opacity: 1;\n    color: #e02424;\n    color: rgba(224, 36, 36, var(--text-opacity));\n  }\n  .sm\\:focus-within\\:text-red-700:focus-within {\n    --text-opacity: 1;\n    color: #c81e1e;\n    color: rgba(200, 30, 30, var(--text-opacity));\n  }\n  .sm\\:focus-within\\:text-red-800:focus-within {\n    --text-opacity: 1;\n    color: #9b1c1c;\n    color: rgba(155, 28, 28, var(--text-opacity));\n  }\n  .sm\\:focus-within\\:text-red-900:focus-within {\n    --text-opacity: 1;\n    color: #771d1d;\n    color: rgba(119, 29, 29, var(--text-opacity));\n  }\n  .sm\\:focus-within\\:text-orange-50:focus-within {\n    --text-opacity: 1;\n    color: #fff8f1;\n    color: rgba(255, 248, 241, var(--text-opacity));\n  }\n  .sm\\:focus-within\\:text-orange-100:focus-within {\n    --text-opacity: 1;\n    color: #feecdc;\n    color: rgba(254, 236, 220, var(--text-opacity));\n  }\n  .sm\\:focus-within\\:text-orange-200:focus-within {\n    --text-opacity: 1;\n    color: #fcd9bd;\n    color: rgba(252, 217, 189, var(--text-opacity));\n  }\n  .sm\\:focus-within\\:text-orange-300:focus-within {\n    --text-opacity: 1;\n    color: #fdba8c;\n    color: rgba(253, 186, 140, var(--text-opacity));\n  }\n  .sm\\:focus-within\\:text-orange-400:focus-within {\n    --text-opacity: 1;\n    color: #ff8a4c;\n    color: rgba(255, 138, 76, var(--text-opacity));\n  }\n  .sm\\:focus-within\\:text-orange-500:focus-within {\n    --text-opacity: 1;\n    color: #ff5a1f;\n    color: rgba(255, 90, 31, var(--text-opacity));\n  }\n  .sm\\:focus-within\\:text-orange-600:focus-within {\n    --text-opacity: 1;\n    color: #d03801;\n    color: rgba(208, 56, 1, var(--text-opacity));\n  }\n  .sm\\:focus-within\\:text-orange-700:focus-within {\n    --text-opacity: 1;\n    color: #b43403;\n    color: rgba(180, 52, 3, var(--text-opacity));\n  }\n  .sm\\:focus-within\\:text-orange-800:focus-within {\n    --text-opacity: 1;\n    color: #8a2c0d;\n    color: rgba(138, 44, 13, var(--text-opacity));\n  }\n  .sm\\:focus-within\\:text-orange-900:focus-within {\n    --text-opacity: 1;\n    color: #73230d;\n    color: rgba(115, 35, 13, var(--text-opacity));\n  }\n  .sm\\:focus-within\\:text-yellow-50:focus-within {\n    --text-opacity: 1;\n    color: #fdfdea;\n    color: rgba(253, 253, 234, var(--text-opacity));\n  }\n  .sm\\:focus-within\\:text-yellow-100:focus-within {\n    --text-opacity: 1;\n    color: #fdf6b2;\n    color: rgba(253, 246, 178, var(--text-opacity));\n  }\n  .sm\\:focus-within\\:text-yellow-200:focus-within {\n    --text-opacity: 1;\n    color: #fce96a;\n    color: rgba(252, 233, 106, var(--text-opacity));\n  }\n  .sm\\:focus-within\\:text-yellow-300:focus-within {\n    --text-opacity: 1;\n    color: #faca15;\n    color: rgba(250, 202, 21, var(--text-opacity));\n  }\n  .sm\\:focus-within\\:text-yellow-400:focus-within {\n    --text-opacity: 1;\n    color: #e3a008;\n    color: rgba(227, 160, 8, var(--text-opacity));\n  }\n  .sm\\:focus-within\\:text-yellow-500:focus-within {\n    --text-opacity: 1;\n    color: #c27803;\n    color: rgba(194, 120, 3, var(--text-opacity));\n  }\n  .sm\\:focus-within\\:text-yellow-600:focus-within {\n    --text-opacity: 1;\n    color: #9f580a;\n    color: rgba(159, 88, 10, var(--text-opacity));\n  }\n  .sm\\:focus-within\\:text-yellow-700:focus-within {\n    --text-opacity: 1;\n    color: #8e4b10;\n    color: rgba(142, 75, 16, var(--text-opacity));\n  }\n  .sm\\:focus-within\\:text-yellow-800:focus-within {\n    --text-opacity: 1;\n    color: #723b13;\n    color: rgba(114, 59, 19, var(--text-opacity));\n  }\n  .sm\\:focus-within\\:text-yellow-900:focus-within {\n    --text-opacity: 1;\n    color: #633112;\n    color: rgba(99, 49, 18, var(--text-opacity));\n  }\n  .sm\\:focus-within\\:text-green-50:focus-within {\n    --text-opacity: 1;\n    color: #f3faf7;\n    color: rgba(243, 250, 247, var(--text-opacity));\n  }\n  .sm\\:focus-within\\:text-green-100:focus-within {\n    --text-opacity: 1;\n    color: #def7ec;\n    color: rgba(222, 247, 236, var(--text-opacity));\n  }\n  .sm\\:focus-within\\:text-green-200:focus-within {\n    --text-opacity: 1;\n    color: #bcf0da;\n    color: rgba(188, 240, 218, var(--text-opacity));\n  }\n  .sm\\:focus-within\\:text-green-300:focus-within {\n    --text-opacity: 1;\n    color: #84e1bc;\n    color: rgba(132, 225, 188, var(--text-opacity));\n  }\n  .sm\\:focus-within\\:text-green-400:focus-within {\n    --text-opacity: 1;\n    color: #31c48d;\n    color: rgba(49, 196, 141, var(--text-opacity));\n  }\n  .sm\\:focus-within\\:text-green-500:focus-within {\n    --text-opacity: 1;\n    color: #0e9f6e;\n    color: rgba(14, 159, 110, var(--text-opacity));\n  }\n  .sm\\:focus-within\\:text-green-600:focus-within {\n    --text-opacity: 1;\n    color: #057a55;\n    color: rgba(5, 122, 85, var(--text-opacity));\n  }\n  .sm\\:focus-within\\:text-green-700:focus-within {\n    --text-opacity: 1;\n    color: #046c4e;\n    color: rgba(4, 108, 78, var(--text-opacity));\n  }\n  .sm\\:focus-within\\:text-green-800:focus-within {\n    --text-opacity: 1;\n    color: #03543f;\n    color: rgba(3, 84, 63, var(--text-opacity));\n  }\n  .sm\\:focus-within\\:text-green-900:focus-within {\n    --text-opacity: 1;\n    color: #014737;\n    color: rgba(1, 71, 55, var(--text-opacity));\n  }\n  .sm\\:focus-within\\:text-teal-50:focus-within {\n    --text-opacity: 1;\n    color: #edfafa;\n    color: rgba(237, 250, 250, var(--text-opacity));\n  }\n  .sm\\:focus-within\\:text-teal-100:focus-within {\n    --text-opacity: 1;\n    color: #d5f5f6;\n    color: rgba(213, 245, 246, var(--text-opacity));\n  }\n  .sm\\:focus-within\\:text-teal-200:focus-within {\n    --text-opacity: 1;\n    color: #afecef;\n    color: rgba(175, 236, 239, var(--text-opacity));\n  }\n  .sm\\:focus-within\\:text-teal-300:focus-within {\n    --text-opacity: 1;\n    color: #7edce2;\n    color: rgba(126, 220, 226, var(--text-opacity));\n  }\n  .sm\\:focus-within\\:text-teal-400:focus-within {\n    --text-opacity: 1;\n    color: #16bdca;\n    color: rgba(22, 189, 202, var(--text-opacity));\n  }\n  .sm\\:focus-within\\:text-teal-500:focus-within {\n    --text-opacity: 1;\n    color: #0694a2;\n    color: rgba(6, 148, 162, var(--text-opacity));\n  }\n  .sm\\:focus-within\\:text-teal-600:focus-within {\n    --text-opacity: 1;\n    color: #047481;\n    color: rgba(4, 116, 129, var(--text-opacity));\n  }\n  .sm\\:focus-within\\:text-teal-700:focus-within {\n    --text-opacity: 1;\n    color: #036672;\n    color: rgba(3, 102, 114, var(--text-opacity));\n  }\n  .sm\\:focus-within\\:text-teal-800:focus-within {\n    --text-opacity: 1;\n    color: #05505c;\n    color: rgba(5, 80, 92, var(--text-opacity));\n  }\n  .sm\\:focus-within\\:text-teal-900:focus-within {\n    --text-opacity: 1;\n    color: #014451;\n    color: rgba(1, 68, 81, var(--text-opacity));\n  }\n  .sm\\:focus-within\\:text-blue-50:focus-within {\n    --text-opacity: 1;\n    color: #ebf5ff;\n    color: rgba(235, 245, 255, var(--text-opacity));\n  }\n  .sm\\:focus-within\\:text-blue-100:focus-within {\n    --text-opacity: 1;\n    color: #e1effe;\n    color: rgba(225, 239, 254, var(--text-opacity));\n  }\n  .sm\\:focus-within\\:text-blue-200:focus-within {\n    --text-opacity: 1;\n    color: #c3ddfd;\n    color: rgba(195, 221, 253, var(--text-opacity));\n  }\n  .sm\\:focus-within\\:text-blue-300:focus-within {\n    --text-opacity: 1;\n    color: #a4cafe;\n    color: rgba(164, 202, 254, var(--text-opacity));\n  }\n  .sm\\:focus-within\\:text-blue-400:focus-within {\n    --text-opacity: 1;\n    color: #76a9fa;\n    color: rgba(118, 169, 250, var(--text-opacity));\n  }\n  .sm\\:focus-within\\:text-blue-500:focus-within {\n    --text-opacity: 1;\n    color: #3f83f8;\n    color: rgba(63, 131, 248, var(--text-opacity));\n  }\n  .sm\\:focus-within\\:text-blue-600:focus-within {\n    --text-opacity: 1;\n    color: #1c64f2;\n    color: rgba(28, 100, 242, var(--text-opacity));\n  }\n  .sm\\:focus-within\\:text-blue-700:focus-within {\n    --text-opacity: 1;\n    color: #1a56db;\n    color: rgba(26, 86, 219, var(--text-opacity));\n  }\n  .sm\\:focus-within\\:text-blue-800:focus-within {\n    --text-opacity: 1;\n    color: #1e429f;\n    color: rgba(30, 66, 159, var(--text-opacity));\n  }\n  .sm\\:focus-within\\:text-blue-900:focus-within {\n    --text-opacity: 1;\n    color: #233876;\n    color: rgba(35, 56, 118, var(--text-opacity));\n  }\n  .sm\\:focus-within\\:text-indigo-50:focus-within {\n    --text-opacity: 1;\n    color: #f0f5ff;\n    color: rgba(240, 245, 255, var(--text-opacity));\n  }\n  .sm\\:focus-within\\:text-indigo-100:focus-within {\n    --text-opacity: 1;\n    color: #e5edff;\n    color: rgba(229, 237, 255, var(--text-opacity));\n  }\n  .sm\\:focus-within\\:text-indigo-200:focus-within {\n    --text-opacity: 1;\n    color: #cddbfe;\n    color: rgba(205, 219, 254, var(--text-opacity));\n  }\n  .sm\\:focus-within\\:text-indigo-300:focus-within {\n    --text-opacity: 1;\n    color: #b4c6fc;\n    color: rgba(180, 198, 252, var(--text-opacity));\n  }\n  .sm\\:focus-within\\:text-indigo-400:focus-within {\n    --text-opacity: 1;\n    color: #8da2fb;\n    color: rgba(141, 162, 251, var(--text-opacity));\n  }\n  .sm\\:focus-within\\:text-indigo-500:focus-within {\n    --text-opacity: 1;\n    color: #6875f5;\n    color: rgba(104, 117, 245, var(--text-opacity));\n  }\n  .sm\\:focus-within\\:text-indigo-600:focus-within {\n    --text-opacity: 1;\n    color: #5850ec;\n    color: rgba(88, 80, 236, var(--text-opacity));\n  }\n  .sm\\:focus-within\\:text-indigo-700:focus-within {\n    --text-opacity: 1;\n    color: #5145cd;\n    color: rgba(81, 69, 205, var(--text-opacity));\n  }\n  .sm\\:focus-within\\:text-indigo-800:focus-within {\n    --text-opacity: 1;\n    color: #42389d;\n    color: rgba(66, 56, 157, var(--text-opacity));\n  }\n  .sm\\:focus-within\\:text-indigo-900:focus-within {\n    --text-opacity: 1;\n    color: #362f78;\n    color: rgba(54, 47, 120, var(--text-opacity));\n  }\n  .sm\\:focus-within\\:text-purple-50:focus-within {\n    --text-opacity: 1;\n    color: #f6f5ff;\n    color: rgba(246, 245, 255, var(--text-opacity));\n  }\n  .sm\\:focus-within\\:text-purple-100:focus-within {\n    --text-opacity: 1;\n    color: #edebfe;\n    color: rgba(237, 235, 254, var(--text-opacity));\n  }\n  .sm\\:focus-within\\:text-purple-200:focus-within {\n    --text-opacity: 1;\n    color: #dcd7fe;\n    color: rgba(220, 215, 254, var(--text-opacity));\n  }\n  .sm\\:focus-within\\:text-purple-300:focus-within {\n    --text-opacity: 1;\n    color: #cabffd;\n    color: rgba(202, 191, 253, var(--text-opacity));\n  }\n  .sm\\:focus-within\\:text-purple-400:focus-within {\n    --text-opacity: 1;\n    color: #ac94fa;\n    color: rgba(172, 148, 250, var(--text-opacity));\n  }\n  .sm\\:focus-within\\:text-purple-500:focus-within {\n    --text-opacity: 1;\n    color: #9061f9;\n    color: rgba(144, 97, 249, var(--text-opacity));\n  }\n  .sm\\:focus-within\\:text-purple-600:focus-within {\n    --text-opacity: 1;\n    color: #7e3af2;\n    color: rgba(126, 58, 242, var(--text-opacity));\n  }\n  .sm\\:focus-within\\:text-purple-700:focus-within {\n    --text-opacity: 1;\n    color: #6c2bd9;\n    color: rgba(108, 43, 217, var(--text-opacity));\n  }\n  .sm\\:focus-within\\:text-purple-800:focus-within {\n    --text-opacity: 1;\n    color: #5521b5;\n    color: rgba(85, 33, 181, var(--text-opacity));\n  }\n  .sm\\:focus-within\\:text-purple-900:focus-within {\n    --text-opacity: 1;\n    color: #4a1d96;\n    color: rgba(74, 29, 150, var(--text-opacity));\n  }\n  .sm\\:focus-within\\:text-pink-50:focus-within {\n    --text-opacity: 1;\n    color: #fdf2f8;\n    color: rgba(253, 242, 248, var(--text-opacity));\n  }\n  .sm\\:focus-within\\:text-pink-100:focus-within {\n    --text-opacity: 1;\n    color: #fce8f3;\n    color: rgba(252, 232, 243, var(--text-opacity));\n  }\n  .sm\\:focus-within\\:text-pink-200:focus-within {\n    --text-opacity: 1;\n    color: #fad1e8;\n    color: rgba(250, 209, 232, var(--text-opacity));\n  }\n  .sm\\:focus-within\\:text-pink-300:focus-within {\n    --text-opacity: 1;\n    color: #f8b4d9;\n    color: rgba(248, 180, 217, var(--text-opacity));\n  }\n  .sm\\:focus-within\\:text-pink-400:focus-within {\n    --text-opacity: 1;\n    color: #f17eb8;\n    color: rgba(241, 126, 184, var(--text-opacity));\n  }\n  .sm\\:focus-within\\:text-pink-500:focus-within {\n    --text-opacity: 1;\n    color: #e74694;\n    color: rgba(231, 70, 148, var(--text-opacity));\n  }\n  .sm\\:focus-within\\:text-pink-600:focus-within {\n    --text-opacity: 1;\n    color: #d61f69;\n    color: rgba(214, 31, 105, var(--text-opacity));\n  }\n  .sm\\:focus-within\\:text-pink-700:focus-within {\n    --text-opacity: 1;\n    color: #bf125d;\n    color: rgba(191, 18, 93, var(--text-opacity));\n  }\n  .sm\\:focus-within\\:text-pink-800:focus-within {\n    --text-opacity: 1;\n    color: #99154b;\n    color: rgba(153, 21, 75, var(--text-opacity));\n  }\n  .sm\\:focus-within\\:text-pink-900:focus-within {\n    --text-opacity: 1;\n    color: #751a3d;\n    color: rgba(117, 26, 61, var(--text-opacity));\n  }\n  .sm\\:focus-within\\:text-cool-gray-50:focus-within {\n    --text-opacity: 1;\n    color: #f8fafc;\n    color: rgba(248, 250, 252, var(--text-opacity));\n  }\n  .sm\\:focus-within\\:text-cool-gray-100:focus-within {\n    --text-opacity: 1;\n    color: #f1f5f9;\n    color: rgba(241, 245, 249, var(--text-opacity));\n  }\n  .sm\\:focus-within\\:text-cool-gray-200:focus-within {\n    --text-opacity: 1;\n    color: #e2e8f0;\n    color: rgba(226, 232, 240, var(--text-opacity));\n  }\n  .sm\\:focus-within\\:text-cool-gray-300:focus-within {\n    --text-opacity: 1;\n    color: #cfd8e3;\n    color: rgba(207, 216, 227, var(--text-opacity));\n  }\n  .sm\\:focus-within\\:text-cool-gray-400:focus-within {\n    --text-opacity: 1;\n    color: #97a6ba;\n    color: rgba(151, 166, 186, var(--text-opacity));\n  }\n  .sm\\:focus-within\\:text-cool-gray-500:focus-within {\n    --text-opacity: 1;\n    color: #64748b;\n    color: rgba(100, 116, 139, var(--text-opacity));\n  }\n  .sm\\:focus-within\\:text-cool-gray-600:focus-within {\n    --text-opacity: 1;\n    color: #475569;\n    color: rgba(71, 85, 105, var(--text-opacity));\n  }\n  .sm\\:focus-within\\:text-cool-gray-700:focus-within {\n    --text-opacity: 1;\n    color: #364152;\n    color: rgba(54, 65, 82, var(--text-opacity));\n  }\n  .sm\\:focus-within\\:text-cool-gray-800:focus-within {\n    --text-opacity: 1;\n    color: #27303f;\n    color: rgba(39, 48, 63, var(--text-opacity));\n  }\n  .sm\\:focus-within\\:text-cool-gray-900:focus-within {\n    --text-opacity: 1;\n    color: #1a202e;\n    color: rgba(26, 32, 46, var(--text-opacity));\n  }\n  .sm\\:focus\\:text-current:focus {\n    color: currentColor;\n  }\n  .sm\\:focus\\:text-transparent:focus {\n    color: transparent;\n  }\n  .sm\\:focus\\:text-white:focus {\n    --text-opacity: 1;\n    color: #ffffff;\n    color: rgba(255, 255, 255, var(--text-opacity));\n  }\n  .sm\\:focus\\:text-black:focus {\n    --text-opacity: 1;\n    color: #000000;\n    color: rgba(0, 0, 0, var(--text-opacity));\n  }\n  .sm\\:focus\\:text-gray-50:focus {\n    --text-opacity: 1;\n    color: #f9fafb;\n    color: rgba(249, 250, 251, var(--text-opacity));\n  }\n  .sm\\:focus\\:text-gray-100:focus {\n    --text-opacity: 1;\n    color: #f4f5f7;\n    color: rgba(244, 245, 247, var(--text-opacity));\n  }\n  .sm\\:focus\\:text-gray-200:focus {\n    --text-opacity: 1;\n    color: #e5e7eb;\n    color: rgba(229, 231, 235, var(--text-opacity));\n  }\n  .sm\\:focus\\:text-gray-300:focus {\n    --text-opacity: 1;\n    color: #d2d6dc;\n    color: rgba(210, 214, 220, var(--text-opacity));\n  }\n  .sm\\:focus\\:text-gray-400:focus {\n    --text-opacity: 1;\n    color: #9fa6b2;\n    color: rgba(159, 166, 178, var(--text-opacity));\n  }\n  .sm\\:focus\\:text-gray-500:focus {\n    --text-opacity: 1;\n    color: #6b7280;\n    color: rgba(107, 114, 128, var(--text-opacity));\n  }\n  .sm\\:focus\\:text-gray-600:focus {\n    --text-opacity: 1;\n    color: #4b5563;\n    color: rgba(75, 85, 99, var(--text-opacity));\n  }\n  .sm\\:focus\\:text-gray-700:focus {\n    --text-opacity: 1;\n    color: #374151;\n    color: rgba(55, 65, 81, var(--text-opacity));\n  }\n  .sm\\:focus\\:text-gray-800:focus {\n    --text-opacity: 1;\n    color: #252f3f;\n    color: rgba(37, 47, 63, var(--text-opacity));\n  }\n  .sm\\:focus\\:text-gray-900:focus {\n    --text-opacity: 1;\n    color: #161e2e;\n    color: rgba(22, 30, 46, var(--text-opacity));\n  }\n  .sm\\:focus\\:text-red-50:focus {\n    --text-opacity: 1;\n    color: #fdf2f2;\n    color: rgba(253, 242, 242, var(--text-opacity));\n  }\n  .sm\\:focus\\:text-red-100:focus {\n    --text-opacity: 1;\n    color: #fde8e8;\n    color: rgba(253, 232, 232, var(--text-opacity));\n  }\n  .sm\\:focus\\:text-red-200:focus {\n    --text-opacity: 1;\n    color: #fbd5d5;\n    color: rgba(251, 213, 213, var(--text-opacity));\n  }\n  .sm\\:focus\\:text-red-300:focus {\n    --text-opacity: 1;\n    color: #f8b4b4;\n    color: rgba(248, 180, 180, var(--text-opacity));\n  }\n  .sm\\:focus\\:text-red-400:focus {\n    --text-opacity: 1;\n    color: #f98080;\n    color: rgba(249, 128, 128, var(--text-opacity));\n  }\n  .sm\\:focus\\:text-red-500:focus {\n    --text-opacity: 1;\n    color: #f05252;\n    color: rgba(240, 82, 82, var(--text-opacity));\n  }\n  .sm\\:focus\\:text-red-600:focus {\n    --text-opacity: 1;\n    color: #e02424;\n    color: rgba(224, 36, 36, var(--text-opacity));\n  }\n  .sm\\:focus\\:text-red-700:focus {\n    --text-opacity: 1;\n    color: #c81e1e;\n    color: rgba(200, 30, 30, var(--text-opacity));\n  }\n  .sm\\:focus\\:text-red-800:focus {\n    --text-opacity: 1;\n    color: #9b1c1c;\n    color: rgba(155, 28, 28, var(--text-opacity));\n  }\n  .sm\\:focus\\:text-red-900:focus {\n    --text-opacity: 1;\n    color: #771d1d;\n    color: rgba(119, 29, 29, var(--text-opacity));\n  }\n  .sm\\:focus\\:text-orange-50:focus {\n    --text-opacity: 1;\n    color: #fff8f1;\n    color: rgba(255, 248, 241, var(--text-opacity));\n  }\n  .sm\\:focus\\:text-orange-100:focus {\n    --text-opacity: 1;\n    color: #feecdc;\n    color: rgba(254, 236, 220, var(--text-opacity));\n  }\n  .sm\\:focus\\:text-orange-200:focus {\n    --text-opacity: 1;\n    color: #fcd9bd;\n    color: rgba(252, 217, 189, var(--text-opacity));\n  }\n  .sm\\:focus\\:text-orange-300:focus {\n    --text-opacity: 1;\n    color: #fdba8c;\n    color: rgba(253, 186, 140, var(--text-opacity));\n  }\n  .sm\\:focus\\:text-orange-400:focus {\n    --text-opacity: 1;\n    color: #ff8a4c;\n    color: rgba(255, 138, 76, var(--text-opacity));\n  }\n  .sm\\:focus\\:text-orange-500:focus {\n    --text-opacity: 1;\n    color: #ff5a1f;\n    color: rgba(255, 90, 31, var(--text-opacity));\n  }\n  .sm\\:focus\\:text-orange-600:focus {\n    --text-opacity: 1;\n    color: #d03801;\n    color: rgba(208, 56, 1, var(--text-opacity));\n  }\n  .sm\\:focus\\:text-orange-700:focus {\n    --text-opacity: 1;\n    color: #b43403;\n    color: rgba(180, 52, 3, var(--text-opacity));\n  }\n  .sm\\:focus\\:text-orange-800:focus {\n    --text-opacity: 1;\n    color: #8a2c0d;\n    color: rgba(138, 44, 13, var(--text-opacity));\n  }\n  .sm\\:focus\\:text-orange-900:focus {\n    --text-opacity: 1;\n    color: #73230d;\n    color: rgba(115, 35, 13, var(--text-opacity));\n  }\n  .sm\\:focus\\:text-yellow-50:focus {\n    --text-opacity: 1;\n    color: #fdfdea;\n    color: rgba(253, 253, 234, var(--text-opacity));\n  }\n  .sm\\:focus\\:text-yellow-100:focus {\n    --text-opacity: 1;\n    color: #fdf6b2;\n    color: rgba(253, 246, 178, var(--text-opacity));\n  }\n  .sm\\:focus\\:text-yellow-200:focus {\n    --text-opacity: 1;\n    color: #fce96a;\n    color: rgba(252, 233, 106, var(--text-opacity));\n  }\n  .sm\\:focus\\:text-yellow-300:focus {\n    --text-opacity: 1;\n    color: #faca15;\n    color: rgba(250, 202, 21, var(--text-opacity));\n  }\n  .sm\\:focus\\:text-yellow-400:focus {\n    --text-opacity: 1;\n    color: #e3a008;\n    color: rgba(227, 160, 8, var(--text-opacity));\n  }\n  .sm\\:focus\\:text-yellow-500:focus {\n    --text-opacity: 1;\n    color: #c27803;\n    color: rgba(194, 120, 3, var(--text-opacity));\n  }\n  .sm\\:focus\\:text-yellow-600:focus {\n    --text-opacity: 1;\n    color: #9f580a;\n    color: rgba(159, 88, 10, var(--text-opacity));\n  }\n  .sm\\:focus\\:text-yellow-700:focus {\n    --text-opacity: 1;\n    color: #8e4b10;\n    color: rgba(142, 75, 16, var(--text-opacity));\n  }\n  .sm\\:focus\\:text-yellow-800:focus {\n    --text-opacity: 1;\n    color: #723b13;\n    color: rgba(114, 59, 19, var(--text-opacity));\n  }\n  .sm\\:focus\\:text-yellow-900:focus {\n    --text-opacity: 1;\n    color: #633112;\n    color: rgba(99, 49, 18, var(--text-opacity));\n  }\n  .sm\\:focus\\:text-green-50:focus {\n    --text-opacity: 1;\n    color: #f3faf7;\n    color: rgba(243, 250, 247, var(--text-opacity));\n  }\n  .sm\\:focus\\:text-green-100:focus {\n    --text-opacity: 1;\n    color: #def7ec;\n    color: rgba(222, 247, 236, var(--text-opacity));\n  }\n  .sm\\:focus\\:text-green-200:focus {\n    --text-opacity: 1;\n    color: #bcf0da;\n    color: rgba(188, 240, 218, var(--text-opacity));\n  }\n  .sm\\:focus\\:text-green-300:focus {\n    --text-opacity: 1;\n    color: #84e1bc;\n    color: rgba(132, 225, 188, var(--text-opacity));\n  }\n  .sm\\:focus\\:text-green-400:focus {\n    --text-opacity: 1;\n    color: #31c48d;\n    color: rgba(49, 196, 141, var(--text-opacity));\n  }\n  .sm\\:focus\\:text-green-500:focus {\n    --text-opacity: 1;\n    color: #0e9f6e;\n    color: rgba(14, 159, 110, var(--text-opacity));\n  }\n  .sm\\:focus\\:text-green-600:focus {\n    --text-opacity: 1;\n    color: #057a55;\n    color: rgba(5, 122, 85, var(--text-opacity));\n  }\n  .sm\\:focus\\:text-green-700:focus {\n    --text-opacity: 1;\n    color: #046c4e;\n    color: rgba(4, 108, 78, var(--text-opacity));\n  }\n  .sm\\:focus\\:text-green-800:focus {\n    --text-opacity: 1;\n    color: #03543f;\n    color: rgba(3, 84, 63, var(--text-opacity));\n  }\n  .sm\\:focus\\:text-green-900:focus {\n    --text-opacity: 1;\n    color: #014737;\n    color: rgba(1, 71, 55, var(--text-opacity));\n  }\n  .sm\\:focus\\:text-teal-50:focus {\n    --text-opacity: 1;\n    color: #edfafa;\n    color: rgba(237, 250, 250, var(--text-opacity));\n  }\n  .sm\\:focus\\:text-teal-100:focus {\n    --text-opacity: 1;\n    color: #d5f5f6;\n    color: rgba(213, 245, 246, var(--text-opacity));\n  }\n  .sm\\:focus\\:text-teal-200:focus {\n    --text-opacity: 1;\n    color: #afecef;\n    color: rgba(175, 236, 239, var(--text-opacity));\n  }\n  .sm\\:focus\\:text-teal-300:focus {\n    --text-opacity: 1;\n    color: #7edce2;\n    color: rgba(126, 220, 226, var(--text-opacity));\n  }\n  .sm\\:focus\\:text-teal-400:focus {\n    --text-opacity: 1;\n    color: #16bdca;\n    color: rgba(22, 189, 202, var(--text-opacity));\n  }\n  .sm\\:focus\\:text-teal-500:focus {\n    --text-opacity: 1;\n    color: #0694a2;\n    color: rgba(6, 148, 162, var(--text-opacity));\n  }\n  .sm\\:focus\\:text-teal-600:focus {\n    --text-opacity: 1;\n    color: #047481;\n    color: rgba(4, 116, 129, var(--text-opacity));\n  }\n  .sm\\:focus\\:text-teal-700:focus {\n    --text-opacity: 1;\n    color: #036672;\n    color: rgba(3, 102, 114, var(--text-opacity));\n  }\n  .sm\\:focus\\:text-teal-800:focus {\n    --text-opacity: 1;\n    color: #05505c;\n    color: rgba(5, 80, 92, var(--text-opacity));\n  }\n  .sm\\:focus\\:text-teal-900:focus {\n    --text-opacity: 1;\n    color: #014451;\n    color: rgba(1, 68, 81, var(--text-opacity));\n  }\n  .sm\\:focus\\:text-blue-50:focus {\n    --text-opacity: 1;\n    color: #ebf5ff;\n    color: rgba(235, 245, 255, var(--text-opacity));\n  }\n  .sm\\:focus\\:text-blue-100:focus {\n    --text-opacity: 1;\n    color: #e1effe;\n    color: rgba(225, 239, 254, var(--text-opacity));\n  }\n  .sm\\:focus\\:text-blue-200:focus {\n    --text-opacity: 1;\n    color: #c3ddfd;\n    color: rgba(195, 221, 253, var(--text-opacity));\n  }\n  .sm\\:focus\\:text-blue-300:focus {\n    --text-opacity: 1;\n    color: #a4cafe;\n    color: rgba(164, 202, 254, var(--text-opacity));\n  }\n  .sm\\:focus\\:text-blue-400:focus {\n    --text-opacity: 1;\n    color: #76a9fa;\n    color: rgba(118, 169, 250, var(--text-opacity));\n  }\n  .sm\\:focus\\:text-blue-500:focus {\n    --text-opacity: 1;\n    color: #3f83f8;\n    color: rgba(63, 131, 248, var(--text-opacity));\n  }\n  .sm\\:focus\\:text-blue-600:focus {\n    --text-opacity: 1;\n    color: #1c64f2;\n    color: rgba(28, 100, 242, var(--text-opacity));\n  }\n  .sm\\:focus\\:text-blue-700:focus {\n    --text-opacity: 1;\n    color: #1a56db;\n    color: rgba(26, 86, 219, var(--text-opacity));\n  }\n  .sm\\:focus\\:text-blue-800:focus {\n    --text-opacity: 1;\n    color: #1e429f;\n    color: rgba(30, 66, 159, var(--text-opacity));\n  }\n  .sm\\:focus\\:text-blue-900:focus {\n    --text-opacity: 1;\n    color: #233876;\n    color: rgba(35, 56, 118, var(--text-opacity));\n  }\n  .sm\\:focus\\:text-indigo-50:focus {\n    --text-opacity: 1;\n    color: #f0f5ff;\n    color: rgba(240, 245, 255, var(--text-opacity));\n  }\n  .sm\\:focus\\:text-indigo-100:focus {\n    --text-opacity: 1;\n    color: #e5edff;\n    color: rgba(229, 237, 255, var(--text-opacity));\n  }\n  .sm\\:focus\\:text-indigo-200:focus {\n    --text-opacity: 1;\n    color: #cddbfe;\n    color: rgba(205, 219, 254, var(--text-opacity));\n  }\n  .sm\\:focus\\:text-indigo-300:focus {\n    --text-opacity: 1;\n    color: #b4c6fc;\n    color: rgba(180, 198, 252, var(--text-opacity));\n  }\n  .sm\\:focus\\:text-indigo-400:focus {\n    --text-opacity: 1;\n    color: #8da2fb;\n    color: rgba(141, 162, 251, var(--text-opacity));\n  }\n  .sm\\:focus\\:text-indigo-500:focus {\n    --text-opacity: 1;\n    color: #6875f5;\n    color: rgba(104, 117, 245, var(--text-opacity));\n  }\n  .sm\\:focus\\:text-indigo-600:focus {\n    --text-opacity: 1;\n    color: #5850ec;\n    color: rgba(88, 80, 236, var(--text-opacity));\n  }\n  .sm\\:focus\\:text-indigo-700:focus {\n    --text-opacity: 1;\n    color: #5145cd;\n    color: rgba(81, 69, 205, var(--text-opacity));\n  }\n  .sm\\:focus\\:text-indigo-800:focus {\n    --text-opacity: 1;\n    color: #42389d;\n    color: rgba(66, 56, 157, var(--text-opacity));\n  }\n  .sm\\:focus\\:text-indigo-900:focus {\n    --text-opacity: 1;\n    color: #362f78;\n    color: rgba(54, 47, 120, var(--text-opacity));\n  }\n  .sm\\:focus\\:text-purple-50:focus {\n    --text-opacity: 1;\n    color: #f6f5ff;\n    color: rgba(246, 245, 255, var(--text-opacity));\n  }\n  .sm\\:focus\\:text-purple-100:focus {\n    --text-opacity: 1;\n    color: #edebfe;\n    color: rgba(237, 235, 254, var(--text-opacity));\n  }\n  .sm\\:focus\\:text-purple-200:focus {\n    --text-opacity: 1;\n    color: #dcd7fe;\n    color: rgba(220, 215, 254, var(--text-opacity));\n  }\n  .sm\\:focus\\:text-purple-300:focus {\n    --text-opacity: 1;\n    color: #cabffd;\n    color: rgba(202, 191, 253, var(--text-opacity));\n  }\n  .sm\\:focus\\:text-purple-400:focus {\n    --text-opacity: 1;\n    color: #ac94fa;\n    color: rgba(172, 148, 250, var(--text-opacity));\n  }\n  .sm\\:focus\\:text-purple-500:focus {\n    --text-opacity: 1;\n    color: #9061f9;\n    color: rgba(144, 97, 249, var(--text-opacity));\n  }\n  .sm\\:focus\\:text-purple-600:focus {\n    --text-opacity: 1;\n    color: #7e3af2;\n    color: rgba(126, 58, 242, var(--text-opacity));\n  }\n  .sm\\:focus\\:text-purple-700:focus {\n    --text-opacity: 1;\n    color: #6c2bd9;\n    color: rgba(108, 43, 217, var(--text-opacity));\n  }\n  .sm\\:focus\\:text-purple-800:focus {\n    --text-opacity: 1;\n    color: #5521b5;\n    color: rgba(85, 33, 181, var(--text-opacity));\n  }\n  .sm\\:focus\\:text-purple-900:focus {\n    --text-opacity: 1;\n    color: #4a1d96;\n    color: rgba(74, 29, 150, var(--text-opacity));\n  }\n  .sm\\:focus\\:text-pink-50:focus {\n    --text-opacity: 1;\n    color: #fdf2f8;\n    color: rgba(253, 242, 248, var(--text-opacity));\n  }\n  .sm\\:focus\\:text-pink-100:focus {\n    --text-opacity: 1;\n    color: #fce8f3;\n    color: rgba(252, 232, 243, var(--text-opacity));\n  }\n  .sm\\:focus\\:text-pink-200:focus {\n    --text-opacity: 1;\n    color: #fad1e8;\n    color: rgba(250, 209, 232, var(--text-opacity));\n  }\n  .sm\\:focus\\:text-pink-300:focus {\n    --text-opacity: 1;\n    color: #f8b4d9;\n    color: rgba(248, 180, 217, var(--text-opacity));\n  }\n  .sm\\:focus\\:text-pink-400:focus {\n    --text-opacity: 1;\n    color: #f17eb8;\n    color: rgba(241, 126, 184, var(--text-opacity));\n  }\n  .sm\\:focus\\:text-pink-500:focus {\n    --text-opacity: 1;\n    color: #e74694;\n    color: rgba(231, 70, 148, var(--text-opacity));\n  }\n  .sm\\:focus\\:text-pink-600:focus {\n    --text-opacity: 1;\n    color: #d61f69;\n    color: rgba(214, 31, 105, var(--text-opacity));\n  }\n  .sm\\:focus\\:text-pink-700:focus {\n    --text-opacity: 1;\n    color: #bf125d;\n    color: rgba(191, 18, 93, var(--text-opacity));\n  }\n  .sm\\:focus\\:text-pink-800:focus {\n    --text-opacity: 1;\n    color: #99154b;\n    color: rgba(153, 21, 75, var(--text-opacity));\n  }\n  .sm\\:focus\\:text-pink-900:focus {\n    --text-opacity: 1;\n    color: #751a3d;\n    color: rgba(117, 26, 61, var(--text-opacity));\n  }\n  .sm\\:focus\\:text-cool-gray-50:focus {\n    --text-opacity: 1;\n    color: #f8fafc;\n    color: rgba(248, 250, 252, var(--text-opacity));\n  }\n  .sm\\:focus\\:text-cool-gray-100:focus {\n    --text-opacity: 1;\n    color: #f1f5f9;\n    color: rgba(241, 245, 249, var(--text-opacity));\n  }\n  .sm\\:focus\\:text-cool-gray-200:focus {\n    --text-opacity: 1;\n    color: #e2e8f0;\n    color: rgba(226, 232, 240, var(--text-opacity));\n  }\n  .sm\\:focus\\:text-cool-gray-300:focus {\n    --text-opacity: 1;\n    color: #cfd8e3;\n    color: rgba(207, 216, 227, var(--text-opacity));\n  }\n  .sm\\:focus\\:text-cool-gray-400:focus {\n    --text-opacity: 1;\n    color: #97a6ba;\n    color: rgba(151, 166, 186, var(--text-opacity));\n  }\n  .sm\\:focus\\:text-cool-gray-500:focus {\n    --text-opacity: 1;\n    color: #64748b;\n    color: rgba(100, 116, 139, var(--text-opacity));\n  }\n  .sm\\:focus\\:text-cool-gray-600:focus {\n    --text-opacity: 1;\n    color: #475569;\n    color: rgba(71, 85, 105, var(--text-opacity));\n  }\n  .sm\\:focus\\:text-cool-gray-700:focus {\n    --text-opacity: 1;\n    color: #364152;\n    color: rgba(54, 65, 82, var(--text-opacity));\n  }\n  .sm\\:focus\\:text-cool-gray-800:focus {\n    --text-opacity: 1;\n    color: #27303f;\n    color: rgba(39, 48, 63, var(--text-opacity));\n  }\n  .sm\\:focus\\:text-cool-gray-900:focus {\n    --text-opacity: 1;\n    color: #1a202e;\n    color: rgba(26, 32, 46, var(--text-opacity));\n  }\n  .sm\\:active\\:text-current:active {\n    color: currentColor;\n  }\n  .sm\\:active\\:text-transparent:active {\n    color: transparent;\n  }\n  .sm\\:active\\:text-white:active {\n    --text-opacity: 1;\n    color: #ffffff;\n    color: rgba(255, 255, 255, var(--text-opacity));\n  }\n  .sm\\:active\\:text-black:active {\n    --text-opacity: 1;\n    color: #000000;\n    color: rgba(0, 0, 0, var(--text-opacity));\n  }\n  .sm\\:active\\:text-gray-50:active {\n    --text-opacity: 1;\n    color: #f9fafb;\n    color: rgba(249, 250, 251, var(--text-opacity));\n  }\n  .sm\\:active\\:text-gray-100:active {\n    --text-opacity: 1;\n    color: #f4f5f7;\n    color: rgba(244, 245, 247, var(--text-opacity));\n  }\n  .sm\\:active\\:text-gray-200:active {\n    --text-opacity: 1;\n    color: #e5e7eb;\n    color: rgba(229, 231, 235, var(--text-opacity));\n  }\n  .sm\\:active\\:text-gray-300:active {\n    --text-opacity: 1;\n    color: #d2d6dc;\n    color: rgba(210, 214, 220, var(--text-opacity));\n  }\n  .sm\\:active\\:text-gray-400:active {\n    --text-opacity: 1;\n    color: #9fa6b2;\n    color: rgba(159, 166, 178, var(--text-opacity));\n  }\n  .sm\\:active\\:text-gray-500:active {\n    --text-opacity: 1;\n    color: #6b7280;\n    color: rgba(107, 114, 128, var(--text-opacity));\n  }\n  .sm\\:active\\:text-gray-600:active {\n    --text-opacity: 1;\n    color: #4b5563;\n    color: rgba(75, 85, 99, var(--text-opacity));\n  }\n  .sm\\:active\\:text-gray-700:active {\n    --text-opacity: 1;\n    color: #374151;\n    color: rgba(55, 65, 81, var(--text-opacity));\n  }\n  .sm\\:active\\:text-gray-800:active {\n    --text-opacity: 1;\n    color: #252f3f;\n    color: rgba(37, 47, 63, var(--text-opacity));\n  }\n  .sm\\:active\\:text-gray-900:active {\n    --text-opacity: 1;\n    color: #161e2e;\n    color: rgba(22, 30, 46, var(--text-opacity));\n  }\n  .sm\\:active\\:text-red-50:active {\n    --text-opacity: 1;\n    color: #fdf2f2;\n    color: rgba(253, 242, 242, var(--text-opacity));\n  }\n  .sm\\:active\\:text-red-100:active {\n    --text-opacity: 1;\n    color: #fde8e8;\n    color: rgba(253, 232, 232, var(--text-opacity));\n  }\n  .sm\\:active\\:text-red-200:active {\n    --text-opacity: 1;\n    color: #fbd5d5;\n    color: rgba(251, 213, 213, var(--text-opacity));\n  }\n  .sm\\:active\\:text-red-300:active {\n    --text-opacity: 1;\n    color: #f8b4b4;\n    color: rgba(248, 180, 180, var(--text-opacity));\n  }\n  .sm\\:active\\:text-red-400:active {\n    --text-opacity: 1;\n    color: #f98080;\n    color: rgba(249, 128, 128, var(--text-opacity));\n  }\n  .sm\\:active\\:text-red-500:active {\n    --text-opacity: 1;\n    color: #f05252;\n    color: rgba(240, 82, 82, var(--text-opacity));\n  }\n  .sm\\:active\\:text-red-600:active {\n    --text-opacity: 1;\n    color: #e02424;\n    color: rgba(224, 36, 36, var(--text-opacity));\n  }\n  .sm\\:active\\:text-red-700:active {\n    --text-opacity: 1;\n    color: #c81e1e;\n    color: rgba(200, 30, 30, var(--text-opacity));\n  }\n  .sm\\:active\\:text-red-800:active {\n    --text-opacity: 1;\n    color: #9b1c1c;\n    color: rgba(155, 28, 28, var(--text-opacity));\n  }\n  .sm\\:active\\:text-red-900:active {\n    --text-opacity: 1;\n    color: #771d1d;\n    color: rgba(119, 29, 29, var(--text-opacity));\n  }\n  .sm\\:active\\:text-orange-50:active {\n    --text-opacity: 1;\n    color: #fff8f1;\n    color: rgba(255, 248, 241, var(--text-opacity));\n  }\n  .sm\\:active\\:text-orange-100:active {\n    --text-opacity: 1;\n    color: #feecdc;\n    color: rgba(254, 236, 220, var(--text-opacity));\n  }\n  .sm\\:active\\:text-orange-200:active {\n    --text-opacity: 1;\n    color: #fcd9bd;\n    color: rgba(252, 217, 189, var(--text-opacity));\n  }\n  .sm\\:active\\:text-orange-300:active {\n    --text-opacity: 1;\n    color: #fdba8c;\n    color: rgba(253, 186, 140, var(--text-opacity));\n  }\n  .sm\\:active\\:text-orange-400:active {\n    --text-opacity: 1;\n    color: #ff8a4c;\n    color: rgba(255, 138, 76, var(--text-opacity));\n  }\n  .sm\\:active\\:text-orange-500:active {\n    --text-opacity: 1;\n    color: #ff5a1f;\n    color: rgba(255, 90, 31, var(--text-opacity));\n  }\n  .sm\\:active\\:text-orange-600:active {\n    --text-opacity: 1;\n    color: #d03801;\n    color: rgba(208, 56, 1, var(--text-opacity));\n  }\n  .sm\\:active\\:text-orange-700:active {\n    --text-opacity: 1;\n    color: #b43403;\n    color: rgba(180, 52, 3, var(--text-opacity));\n  }\n  .sm\\:active\\:text-orange-800:active {\n    --text-opacity: 1;\n    color: #8a2c0d;\n    color: rgba(138, 44, 13, var(--text-opacity));\n  }\n  .sm\\:active\\:text-orange-900:active {\n    --text-opacity: 1;\n    color: #73230d;\n    color: rgba(115, 35, 13, var(--text-opacity));\n  }\n  .sm\\:active\\:text-yellow-50:active {\n    --text-opacity: 1;\n    color: #fdfdea;\n    color: rgba(253, 253, 234, var(--text-opacity));\n  }\n  .sm\\:active\\:text-yellow-100:active {\n    --text-opacity: 1;\n    color: #fdf6b2;\n    color: rgba(253, 246, 178, var(--text-opacity));\n  }\n  .sm\\:active\\:text-yellow-200:active {\n    --text-opacity: 1;\n    color: #fce96a;\n    color: rgba(252, 233, 106, var(--text-opacity));\n  }\n  .sm\\:active\\:text-yellow-300:active {\n    --text-opacity: 1;\n    color: #faca15;\n    color: rgba(250, 202, 21, var(--text-opacity));\n  }\n  .sm\\:active\\:text-yellow-400:active {\n    --text-opacity: 1;\n    color: #e3a008;\n    color: rgba(227, 160, 8, var(--text-opacity));\n  }\n  .sm\\:active\\:text-yellow-500:active {\n    --text-opacity: 1;\n    color: #c27803;\n    color: rgba(194, 120, 3, var(--text-opacity));\n  }\n  .sm\\:active\\:text-yellow-600:active {\n    --text-opacity: 1;\n    color: #9f580a;\n    color: rgba(159, 88, 10, var(--text-opacity));\n  }\n  .sm\\:active\\:text-yellow-700:active {\n    --text-opacity: 1;\n    color: #8e4b10;\n    color: rgba(142, 75, 16, var(--text-opacity));\n  }\n  .sm\\:active\\:text-yellow-800:active {\n    --text-opacity: 1;\n    color: #723b13;\n    color: rgba(114, 59, 19, var(--text-opacity));\n  }\n  .sm\\:active\\:text-yellow-900:active {\n    --text-opacity: 1;\n    color: #633112;\n    color: rgba(99, 49, 18, var(--text-opacity));\n  }\n  .sm\\:active\\:text-green-50:active {\n    --text-opacity: 1;\n    color: #f3faf7;\n    color: rgba(243, 250, 247, var(--text-opacity));\n  }\n  .sm\\:active\\:text-green-100:active {\n    --text-opacity: 1;\n    color: #def7ec;\n    color: rgba(222, 247, 236, var(--text-opacity));\n  }\n  .sm\\:active\\:text-green-200:active {\n    --text-opacity: 1;\n    color: #bcf0da;\n    color: rgba(188, 240, 218, var(--text-opacity));\n  }\n  .sm\\:active\\:text-green-300:active {\n    --text-opacity: 1;\n    color: #84e1bc;\n    color: rgba(132, 225, 188, var(--text-opacity));\n  }\n  .sm\\:active\\:text-green-400:active {\n    --text-opacity: 1;\n    color: #31c48d;\n    color: rgba(49, 196, 141, var(--text-opacity));\n  }\n  .sm\\:active\\:text-green-500:active {\n    --text-opacity: 1;\n    color: #0e9f6e;\n    color: rgba(14, 159, 110, var(--text-opacity));\n  }\n  .sm\\:active\\:text-green-600:active {\n    --text-opacity: 1;\n    color: #057a55;\n    color: rgba(5, 122, 85, var(--text-opacity));\n  }\n  .sm\\:active\\:text-green-700:active {\n    --text-opacity: 1;\n    color: #046c4e;\n    color: rgba(4, 108, 78, var(--text-opacity));\n  }\n  .sm\\:active\\:text-green-800:active {\n    --text-opacity: 1;\n    color: #03543f;\n    color: rgba(3, 84, 63, var(--text-opacity));\n  }\n  .sm\\:active\\:text-green-900:active {\n    --text-opacity: 1;\n    color: #014737;\n    color: rgba(1, 71, 55, var(--text-opacity));\n  }\n  .sm\\:active\\:text-teal-50:active {\n    --text-opacity: 1;\n    color: #edfafa;\n    color: rgba(237, 250, 250, var(--text-opacity));\n  }\n  .sm\\:active\\:text-teal-100:active {\n    --text-opacity: 1;\n    color: #d5f5f6;\n    color: rgba(213, 245, 246, var(--text-opacity));\n  }\n  .sm\\:active\\:text-teal-200:active {\n    --text-opacity: 1;\n    color: #afecef;\n    color: rgba(175, 236, 239, var(--text-opacity));\n  }\n  .sm\\:active\\:text-teal-300:active {\n    --text-opacity: 1;\n    color: #7edce2;\n    color: rgba(126, 220, 226, var(--text-opacity));\n  }\n  .sm\\:active\\:text-teal-400:active {\n    --text-opacity: 1;\n    color: #16bdca;\n    color: rgba(22, 189, 202, var(--text-opacity));\n  }\n  .sm\\:active\\:text-teal-500:active {\n    --text-opacity: 1;\n    color: #0694a2;\n    color: rgba(6, 148, 162, var(--text-opacity));\n  }\n  .sm\\:active\\:text-teal-600:active {\n    --text-opacity: 1;\n    color: #047481;\n    color: rgba(4, 116, 129, var(--text-opacity));\n  }\n  .sm\\:active\\:text-teal-700:active {\n    --text-opacity: 1;\n    color: #036672;\n    color: rgba(3, 102, 114, var(--text-opacity));\n  }\n  .sm\\:active\\:text-teal-800:active {\n    --text-opacity: 1;\n    color: #05505c;\n    color: rgba(5, 80, 92, var(--text-opacity));\n  }\n  .sm\\:active\\:text-teal-900:active {\n    --text-opacity: 1;\n    color: #014451;\n    color: rgba(1, 68, 81, var(--text-opacity));\n  }\n  .sm\\:active\\:text-blue-50:active {\n    --text-opacity: 1;\n    color: #ebf5ff;\n    color: rgba(235, 245, 255, var(--text-opacity));\n  }\n  .sm\\:active\\:text-blue-100:active {\n    --text-opacity: 1;\n    color: #e1effe;\n    color: rgba(225, 239, 254, var(--text-opacity));\n  }\n  .sm\\:active\\:text-blue-200:active {\n    --text-opacity: 1;\n    color: #c3ddfd;\n    color: rgba(195, 221, 253, var(--text-opacity));\n  }\n  .sm\\:active\\:text-blue-300:active {\n    --text-opacity: 1;\n    color: #a4cafe;\n    color: rgba(164, 202, 254, var(--text-opacity));\n  }\n  .sm\\:active\\:text-blue-400:active {\n    --text-opacity: 1;\n    color: #76a9fa;\n    color: rgba(118, 169, 250, var(--text-opacity));\n  }\n  .sm\\:active\\:text-blue-500:active {\n    --text-opacity: 1;\n    color: #3f83f8;\n    color: rgba(63, 131, 248, var(--text-opacity));\n  }\n  .sm\\:active\\:text-blue-600:active {\n    --text-opacity: 1;\n    color: #1c64f2;\n    color: rgba(28, 100, 242, var(--text-opacity));\n  }\n  .sm\\:active\\:text-blue-700:active {\n    --text-opacity: 1;\n    color: #1a56db;\n    color: rgba(26, 86, 219, var(--text-opacity));\n  }\n  .sm\\:active\\:text-blue-800:active {\n    --text-opacity: 1;\n    color: #1e429f;\n    color: rgba(30, 66, 159, var(--text-opacity));\n  }\n  .sm\\:active\\:text-blue-900:active {\n    --text-opacity: 1;\n    color: #233876;\n    color: rgba(35, 56, 118, var(--text-opacity));\n  }\n  .sm\\:active\\:text-indigo-50:active {\n    --text-opacity: 1;\n    color: #f0f5ff;\n    color: rgba(240, 245, 255, var(--text-opacity));\n  }\n  .sm\\:active\\:text-indigo-100:active {\n    --text-opacity: 1;\n    color: #e5edff;\n    color: rgba(229, 237, 255, var(--text-opacity));\n  }\n  .sm\\:active\\:text-indigo-200:active {\n    --text-opacity: 1;\n    color: #cddbfe;\n    color: rgba(205, 219, 254, var(--text-opacity));\n  }\n  .sm\\:active\\:text-indigo-300:active {\n    --text-opacity: 1;\n    color: #b4c6fc;\n    color: rgba(180, 198, 252, var(--text-opacity));\n  }\n  .sm\\:active\\:text-indigo-400:active {\n    --text-opacity: 1;\n    color: #8da2fb;\n    color: rgba(141, 162, 251, var(--text-opacity));\n  }\n  .sm\\:active\\:text-indigo-500:active {\n    --text-opacity: 1;\n    color: #6875f5;\n    color: rgba(104, 117, 245, var(--text-opacity));\n  }\n  .sm\\:active\\:text-indigo-600:active {\n    --text-opacity: 1;\n    color: #5850ec;\n    color: rgba(88, 80, 236, var(--text-opacity));\n  }\n  .sm\\:active\\:text-indigo-700:active {\n    --text-opacity: 1;\n    color: #5145cd;\n    color: rgba(81, 69, 205, var(--text-opacity));\n  }\n  .sm\\:active\\:text-indigo-800:active {\n    --text-opacity: 1;\n    color: #42389d;\n    color: rgba(66, 56, 157, var(--text-opacity));\n  }\n  .sm\\:active\\:text-indigo-900:active {\n    --text-opacity: 1;\n    color: #362f78;\n    color: rgba(54, 47, 120, var(--text-opacity));\n  }\n  .sm\\:active\\:text-purple-50:active {\n    --text-opacity: 1;\n    color: #f6f5ff;\n    color: rgba(246, 245, 255, var(--text-opacity));\n  }\n  .sm\\:active\\:text-purple-100:active {\n    --text-opacity: 1;\n    color: #edebfe;\n    color: rgba(237, 235, 254, var(--text-opacity));\n  }\n  .sm\\:active\\:text-purple-200:active {\n    --text-opacity: 1;\n    color: #dcd7fe;\n    color: rgba(220, 215, 254, var(--text-opacity));\n  }\n  .sm\\:active\\:text-purple-300:active {\n    --text-opacity: 1;\n    color: #cabffd;\n    color: rgba(202, 191, 253, var(--text-opacity));\n  }\n  .sm\\:active\\:text-purple-400:active {\n    --text-opacity: 1;\n    color: #ac94fa;\n    color: rgba(172, 148, 250, var(--text-opacity));\n  }\n  .sm\\:active\\:text-purple-500:active {\n    --text-opacity: 1;\n    color: #9061f9;\n    color: rgba(144, 97, 249, var(--text-opacity));\n  }\n  .sm\\:active\\:text-purple-600:active {\n    --text-opacity: 1;\n    color: #7e3af2;\n    color: rgba(126, 58, 242, var(--text-opacity));\n  }\n  .sm\\:active\\:text-purple-700:active {\n    --text-opacity: 1;\n    color: #6c2bd9;\n    color: rgba(108, 43, 217, var(--text-opacity));\n  }\n  .sm\\:active\\:text-purple-800:active {\n    --text-opacity: 1;\n    color: #5521b5;\n    color: rgba(85, 33, 181, var(--text-opacity));\n  }\n  .sm\\:active\\:text-purple-900:active {\n    --text-opacity: 1;\n    color: #4a1d96;\n    color: rgba(74, 29, 150, var(--text-opacity));\n  }\n  .sm\\:active\\:text-pink-50:active {\n    --text-opacity: 1;\n    color: #fdf2f8;\n    color: rgba(253, 242, 248, var(--text-opacity));\n  }\n  .sm\\:active\\:text-pink-100:active {\n    --text-opacity: 1;\n    color: #fce8f3;\n    color: rgba(252, 232, 243, var(--text-opacity));\n  }\n  .sm\\:active\\:text-pink-200:active {\n    --text-opacity: 1;\n    color: #fad1e8;\n    color: rgba(250, 209, 232, var(--text-opacity));\n  }\n  .sm\\:active\\:text-pink-300:active {\n    --text-opacity: 1;\n    color: #f8b4d9;\n    color: rgba(248, 180, 217, var(--text-opacity));\n  }\n  .sm\\:active\\:text-pink-400:active {\n    --text-opacity: 1;\n    color: #f17eb8;\n    color: rgba(241, 126, 184, var(--text-opacity));\n  }\n  .sm\\:active\\:text-pink-500:active {\n    --text-opacity: 1;\n    color: #e74694;\n    color: rgba(231, 70, 148, var(--text-opacity));\n  }\n  .sm\\:active\\:text-pink-600:active {\n    --text-opacity: 1;\n    color: #d61f69;\n    color: rgba(214, 31, 105, var(--text-opacity));\n  }\n  .sm\\:active\\:text-pink-700:active {\n    --text-opacity: 1;\n    color: #bf125d;\n    color: rgba(191, 18, 93, var(--text-opacity));\n  }\n  .sm\\:active\\:text-pink-800:active {\n    --text-opacity: 1;\n    color: #99154b;\n    color: rgba(153, 21, 75, var(--text-opacity));\n  }\n  .sm\\:active\\:text-pink-900:active {\n    --text-opacity: 1;\n    color: #751a3d;\n    color: rgba(117, 26, 61, var(--text-opacity));\n  }\n  .sm\\:active\\:text-cool-gray-50:active {\n    --text-opacity: 1;\n    color: #f8fafc;\n    color: rgba(248, 250, 252, var(--text-opacity));\n  }\n  .sm\\:active\\:text-cool-gray-100:active {\n    --text-opacity: 1;\n    color: #f1f5f9;\n    color: rgba(241, 245, 249, var(--text-opacity));\n  }\n  .sm\\:active\\:text-cool-gray-200:active {\n    --text-opacity: 1;\n    color: #e2e8f0;\n    color: rgba(226, 232, 240, var(--text-opacity));\n  }\n  .sm\\:active\\:text-cool-gray-300:active {\n    --text-opacity: 1;\n    color: #cfd8e3;\n    color: rgba(207, 216, 227, var(--text-opacity));\n  }\n  .sm\\:active\\:text-cool-gray-400:active {\n    --text-opacity: 1;\n    color: #97a6ba;\n    color: rgba(151, 166, 186, var(--text-opacity));\n  }\n  .sm\\:active\\:text-cool-gray-500:active {\n    --text-opacity: 1;\n    color: #64748b;\n    color: rgba(100, 116, 139, var(--text-opacity));\n  }\n  .sm\\:active\\:text-cool-gray-600:active {\n    --text-opacity: 1;\n    color: #475569;\n    color: rgba(71, 85, 105, var(--text-opacity));\n  }\n  .sm\\:active\\:text-cool-gray-700:active {\n    --text-opacity: 1;\n    color: #364152;\n    color: rgba(54, 65, 82, var(--text-opacity));\n  }\n  .sm\\:active\\:text-cool-gray-800:active {\n    --text-opacity: 1;\n    color: #27303f;\n    color: rgba(39, 48, 63, var(--text-opacity));\n  }\n  .sm\\:active\\:text-cool-gray-900:active {\n    --text-opacity: 1;\n    color: #1a202e;\n    color: rgba(26, 32, 46, var(--text-opacity));\n  }\n  .sm\\:text-opacity-0 {\n    --text-opacity: 0;\n  }\n  .sm\\:text-opacity-25 {\n    --text-opacity: 0.25;\n  }\n  .sm\\:text-opacity-50 {\n    --text-opacity: 0.5;\n  }\n  .sm\\:text-opacity-75 {\n    --text-opacity: 0.75;\n  }\n  .sm\\:text-opacity-100 {\n    --text-opacity: 1;\n  }\n  .sm\\:hover\\:text-opacity-0:hover {\n    --text-opacity: 0;\n  }\n  .sm\\:hover\\:text-opacity-25:hover {\n    --text-opacity: 0.25;\n  }\n  .sm\\:hover\\:text-opacity-50:hover {\n    --text-opacity: 0.5;\n  }\n  .sm\\:hover\\:text-opacity-75:hover {\n    --text-opacity: 0.75;\n  }\n  .sm\\:hover\\:text-opacity-100:hover {\n    --text-opacity: 1;\n  }\n  .sm\\:focus\\:text-opacity-0:focus {\n    --text-opacity: 0;\n  }\n  .sm\\:focus\\:text-opacity-25:focus {\n    --text-opacity: 0.25;\n  }\n  .sm\\:focus\\:text-opacity-50:focus {\n    --text-opacity: 0.5;\n  }\n  .sm\\:focus\\:text-opacity-75:focus {\n    --text-opacity: 0.75;\n  }\n  .sm\\:focus\\:text-opacity-100:focus {\n    --text-opacity: 1;\n  }\n  .sm\\:italic {\n    font-style: italic;\n  }\n  .sm\\:not-italic {\n    font-style: normal;\n  }\n  .sm\\:uppercase {\n    text-transform: uppercase;\n  }\n  .sm\\:lowercase {\n    text-transform: lowercase;\n  }\n  .sm\\:capitalize {\n    text-transform: capitalize;\n  }\n  .sm\\:normal-case {\n    text-transform: none;\n  }\n  .sm\\:underline {\n    text-decoration: none;\n  }\n  .sm\\:line-through {\n    text-decoration: line-through;\n  }\n  .sm\\:no-underline {\n    text-decoration: none;\n  }\n  .group:hover .sm\\:group-hover\\:underline {\n    text-decoration: none;\n  }\n  .group:hover .sm\\:group-hover\\:line-through {\n    text-decoration: line-through;\n  }\n  .group:hover .sm\\:group-hover\\:no-underline {\n    text-decoration: none;\n  }\n  .group:focus .sm\\:group-focus\\:underline {\n    text-decoration: none;\n  }\n  .group:focus .sm\\:group-focus\\:line-through {\n    text-decoration: line-through;\n  }\n  .group:focus .sm\\:group-focus\\:no-underline {\n    text-decoration: none;\n  }\n  .sm\\:hover\\:underline:hover {\n    text-decoration: none;\n  }\n  .sm\\:hover\\:line-through:hover {\n    text-decoration: line-through;\n  }\n  .sm\\:hover\\:no-underline:hover {\n    text-decoration: none;\n  }\n  .sm\\:focus\\:underline:focus {\n    text-decoration: none;\n  }\n  .sm\\:focus\\:line-through:focus {\n    text-decoration: line-through;\n  }\n  .sm\\:focus\\:no-underline:focus {\n    text-decoration: none;\n  }\n  .sm\\:antialiased {\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n  }\n  .sm\\:subpixel-antialiased {\n    -webkit-font-smoothing: auto;\n    -moz-osx-font-smoothing: auto;\n  }\n  .sm\\:ordinal, .sm\\:slashed-zero, .sm\\:lining-nums, .sm\\:oldstyle-nums, .sm\\:proportional-nums, .sm\\:tabular-nums, .sm\\:diagonal-fractions, .sm\\:stacked-fractions {\n    --font-variant-numeric-ordinal: var(--tailwind-empty,\n        /*!*/\n        /*!*/\n      );\n    --font-variant-numeric-slashed-zero: var(--tailwind-empty,\n        /*!*/\n        /*!*/\n      );\n    --font-variant-numeric-figure: var(--tailwind-empty,\n        /*!*/\n        /*!*/\n      );\n    --font-variant-numeric-spacing: var(--tailwind-empty,\n        /*!*/\n        /*!*/\n      );\n    --font-variant-numeric-fraction: var(--tailwind-empty,\n        /*!*/\n        /*!*/\n      );\n    font-variant-numeric: var(--font-variant-numeric-ordinal) var(--font-variant-numeric-slashed-zero) var(--font-variant-numeric-figure) var(--font-variant-numeric-spacing) var(--font-variant-numeric-fraction);\n  }\n  .sm\\:normal-nums {\n    font-variant-numeric: normal;\n  }\n  .sm\\:ordinal {\n    --font-variant-numeric-ordinal: ordinal;\n  }\n  .sm\\:slashed-zero {\n    --font-variant-numeric-slashed-zero: slashed-zero;\n  }\n  .sm\\:lining-nums {\n    --font-variant-numeric-figure: lining-nums;\n  }\n  .sm\\:oldstyle-nums {\n    --font-variant-numeric-figure: oldstyle-nums;\n  }\n  .sm\\:proportional-nums {\n    --font-variant-numeric-spacing: proportional-nums;\n  }\n  .sm\\:tabular-nums {\n    --font-variant-numeric-spacing: tabular-nums;\n  }\n  .sm\\:diagonal-fractions {\n    --font-variant-numeric-fraction: diagonal-fractions;\n  }\n  .sm\\:stacked-fractions {\n    --font-variant-numeric-fraction: stacked-fractions;\n  }\n  .sm\\:tracking-tighter {\n    letter-spacing: -0.05em;\n  }\n  .sm\\:tracking-tight {\n    letter-spacing: -0.025em;\n  }\n  .sm\\:tracking-normal {\n    letter-spacing: 0;\n  }\n  .sm\\:tracking-wide {\n    letter-spacing: 0.025em;\n  }\n  .sm\\:tracking-wider {\n    letter-spacing: 0.05em;\n  }\n  .sm\\:tracking-widest {\n    letter-spacing: 0.1em;\n  }\n  .sm\\:select-none {\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    user-select: none;\n  }\n  .sm\\:select-text {\n    -webkit-user-select: text;\n    -moz-user-select: text;\n    user-select: text;\n  }\n  .sm\\:select-all {\n    -webkit-user-select: all;\n    -moz-user-select: all;\n    user-select: all;\n  }\n  .sm\\:select-auto {\n    -webkit-user-select: auto;\n    -moz-user-select: auto;\n    user-select: auto;\n  }\n  .sm\\:align-baseline {\n    vertical-align: baseline;\n  }\n  .sm\\:align-top {\n    vertical-align: top;\n  }\n  .sm\\:align-middle {\n    vertical-align: middle;\n  }\n  .sm\\:align-bottom {\n    vertical-align: bottom;\n  }\n  .sm\\:align-text-top {\n    vertical-align: text-top;\n  }\n  .sm\\:align-text-bottom {\n    vertical-align: text-bottom;\n  }\n  .sm\\:visible {\n    visibility: visible;\n  }\n  .sm\\:invisible {\n    visibility: hidden;\n  }\n  .sm\\:whitespace-normal {\n    white-space: normal;\n  }\n  .sm\\:whitespace-no-wrap {\n    white-space: nowrap;\n  }\n  .sm\\:whitespace-pre {\n    white-space: pre;\n  }\n  .sm\\:whitespace-pre-line {\n    white-space: pre-line;\n  }\n  .sm\\:whitespace-pre-wrap {\n    white-space: pre-wrap;\n  }\n  .sm\\:break-normal {\n    word-wrap: normal;\n    overflow-wrap: normal;\n    word-break: normal;\n  }\n  .sm\\:break-words {\n    word-wrap: break-word;\n    overflow-wrap: break-word;\n  }\n  .sm\\:break-all {\n    word-break: break-all;\n  }\n  .sm\\:truncate {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n  .sm\\:w-0 {\n    width: 0;\n  }\n  .sm\\:w-1 {\n    width: 0.25rem;\n  }\n  .sm\\:w-2 {\n    width: 0.5rem;\n  }\n  .sm\\:w-3 {\n    width: 0.75rem;\n  }\n  .sm\\:w-4 {\n    width: 1rem;\n  }\n  .sm\\:w-5 {\n    width: 1.25rem;\n  }\n  .sm\\:w-6 {\n    width: 1.5rem;\n  }\n  .sm\\:w-7 {\n    width: 1.75rem;\n  }\n  .sm\\:w-8 {\n    width: 2rem;\n  }\n  .sm\\:w-9 {\n    width: 2.25rem;\n  }\n  .sm\\:w-10 {\n    width: 2.5rem;\n  }\n  .sm\\:w-11 {\n    width: 2.75rem;\n  }\n  .sm\\:w-12 {\n    width: 3rem;\n  }\n  .sm\\:w-13 {\n    width: 3.25rem;\n  }\n  .sm\\:w-14 {\n    width: 3.5rem;\n  }\n  .sm\\:w-15 {\n    width: 3.75rem;\n  }\n  .sm\\:w-16 {\n    width: 4rem;\n  }\n  .sm\\:w-20 {\n    width: 5rem;\n  }\n  .sm\\:w-24 {\n    width: 6rem;\n  }\n  .sm\\:w-28 {\n    width: 7rem;\n  }\n  .sm\\:w-32 {\n    width: 8rem;\n  }\n  .sm\\:w-36 {\n    width: 9rem;\n  }\n  .sm\\:w-40 {\n    width: 10rem;\n  }\n  .sm\\:w-44 {\n    width: 11rem;\n  }\n  .sm\\:w-48 {\n    width: 12rem;\n  }\n  .sm\\:w-52 {\n    width: 13rem;\n  }\n  .sm\\:w-56 {\n    width: 14rem;\n  }\n  .sm\\:w-60 {\n    width: 15rem;\n  }\n  .sm\\:w-64 {\n    width: 16rem;\n  }\n  .sm\\:w-72 {\n    width: 18rem;\n  }\n  .sm\\:w-80 {\n    width: 20rem;\n  }\n  .sm\\:w-96 {\n    width: 24rem;\n  }\n  .sm\\:w-auto {\n    width: auto;\n  }\n  .sm\\:w-px {\n    width: 1px;\n  }\n  .sm\\:w-0\\.5 {\n    width: 0.125rem;\n  }\n  .sm\\:w-1\\.5 {\n    width: 0.375rem;\n  }\n  .sm\\:w-2\\.5 {\n    width: 0.625rem;\n  }\n  .sm\\:w-3\\.5 {\n    width: 0.875rem;\n  }\n  .sm\\:w-1\\/2 {\n    width: 50%;\n  }\n  .sm\\:w-1\\/3 {\n    width: 33.333333%;\n  }\n  .sm\\:w-2\\/3 {\n    width: 66.666667%;\n  }\n  .sm\\:w-1\\/4 {\n    width: 25%;\n  }\n  .sm\\:w-2\\/4 {\n    width: 50%;\n  }\n  .sm\\:w-3\\/4 {\n    width: 75%;\n  }\n  .sm\\:w-1\\/5 {\n    width: 20%;\n  }\n  .sm\\:w-2\\/5 {\n    width: 40%;\n  }\n  .sm\\:w-3\\/5 {\n    width: 60%;\n  }\n  .sm\\:w-4\\/5 {\n    width: 80%;\n  }\n  .sm\\:w-1\\/6 {\n    width: 16.666667%;\n  }\n  .sm\\:w-2\\/6 {\n    width: 33.333333%;\n  }\n  .sm\\:w-3\\/6 {\n    width: 50%;\n  }\n  .sm\\:w-4\\/6 {\n    width: 66.666667%;\n  }\n  .sm\\:w-5\\/6 {\n    width: 83.333333%;\n  }\n  .sm\\:w-1\\/12 {\n    width: 8.333333%;\n  }\n  .sm\\:w-2\\/12 {\n    width: 16.666667%;\n  }\n  .sm\\:w-3\\/12 {\n    width: 25%;\n  }\n  .sm\\:w-4\\/12 {\n    width: 33.333333%;\n  }\n  .sm\\:w-5\\/12 {\n    width: 41.666667%;\n  }\n  .sm\\:w-6\\/12 {\n    width: 50%;\n  }\n  .sm\\:w-7\\/12 {\n    width: 58.333333%;\n  }\n  .sm\\:w-8\\/12 {\n    width: 66.666667%;\n  }\n  .sm\\:w-9\\/12 {\n    width: 75%;\n  }\n  .sm\\:w-10\\/12 {\n    width: 83.333333%;\n  }\n  .sm\\:w-11\\/12 {\n    width: 91.666667%;\n  }\n  .sm\\:w-full {\n    width: 100%;\n  }\n  .sm\\:w-screen {\n    width: 100vw;\n  }\n  .sm\\:w-min-content {\n    width: -moz-min-content;\n    width: min-content;\n  }\n  .sm\\:w-max-content {\n    width: -moz-max-content;\n    width: max-content;\n  }\n  .sm\\:z-0 {\n    z-index: 0;\n  }\n  .sm\\:z-10 {\n    z-index: 10;\n  }\n  .sm\\:z-20 {\n    z-index: 20;\n  }\n  .sm\\:z-30 {\n    z-index: 30;\n  }\n  .sm\\:z-40 {\n    z-index: 40;\n  }\n  .sm\\:z-50 {\n    z-index: 50;\n  }\n  .sm\\:z-auto {\n    z-index: auto;\n  }\n  .sm\\:focus-within\\:z-0:focus-within {\n    z-index: 0;\n  }\n  .sm\\:focus-within\\:z-10:focus-within {\n    z-index: 10;\n  }\n  .sm\\:focus-within\\:z-20:focus-within {\n    z-index: 20;\n  }\n  .sm\\:focus-within\\:z-30:focus-within {\n    z-index: 30;\n  }\n  .sm\\:focus-within\\:z-40:focus-within {\n    z-index: 40;\n  }\n  .sm\\:focus-within\\:z-50:focus-within {\n    z-index: 50;\n  }\n  .sm\\:focus-within\\:z-auto:focus-within {\n    z-index: auto;\n  }\n  .sm\\:focus\\:z-0:focus {\n    z-index: 0;\n  }\n  .sm\\:focus\\:z-10:focus {\n    z-index: 10;\n  }\n  .sm\\:focus\\:z-20:focus {\n    z-index: 20;\n  }\n  .sm\\:focus\\:z-30:focus {\n    z-index: 30;\n  }\n  .sm\\:focus\\:z-40:focus {\n    z-index: 40;\n  }\n  .sm\\:focus\\:z-50:focus {\n    z-index: 50;\n  }\n  .sm\\:focus\\:z-auto:focus {\n    z-index: auto;\n  }\n  .sm\\:gap-0 {\n    grid-gap: 0;\n    gap: 0;\n  }\n  .sm\\:gap-1 {\n    grid-gap: 0.25rem;\n    gap: 0.25rem;\n  }\n  .sm\\:gap-2 {\n    grid-gap: 0.5rem;\n    gap: 0.5rem;\n  }\n  .sm\\:gap-3 {\n    grid-gap: 0.75rem;\n    gap: 0.75rem;\n  }\n  .sm\\:gap-4 {\n    grid-gap: 1rem;\n    gap: 1rem;\n  }\n  .sm\\:gap-5 {\n    grid-gap: 1.25rem;\n    gap: 1.25rem;\n  }\n  .sm\\:gap-6 {\n    grid-gap: 1.5rem;\n    gap: 1.5rem;\n  }\n  .sm\\:gap-7 {\n    grid-gap: 1.75rem;\n    gap: 1.75rem;\n  }\n  .sm\\:gap-8 {\n    grid-gap: 2rem;\n    gap: 2rem;\n  }\n  .sm\\:gap-9 {\n    grid-gap: 2.25rem;\n    gap: 2.25rem;\n  }\n  .sm\\:gap-10 {\n    grid-gap: 2.5rem;\n    gap: 2.5rem;\n  }\n  .sm\\:gap-11 {\n    grid-gap: 2.75rem;\n    gap: 2.75rem;\n  }\n  .sm\\:gap-12 {\n    grid-gap: 3rem;\n    gap: 3rem;\n  }\n  .sm\\:gap-13 {\n    grid-gap: 3.25rem;\n    gap: 3.25rem;\n  }\n  .sm\\:gap-14 {\n    grid-gap: 3.5rem;\n    gap: 3.5rem;\n  }\n  .sm\\:gap-15 {\n    grid-gap: 3.75rem;\n    gap: 3.75rem;\n  }\n  .sm\\:gap-16 {\n    grid-gap: 4rem;\n    gap: 4rem;\n  }\n  .sm\\:gap-20 {\n    grid-gap: 5rem;\n    gap: 5rem;\n  }\n  .sm\\:gap-24 {\n    grid-gap: 6rem;\n    gap: 6rem;\n  }\n  .sm\\:gap-28 {\n    grid-gap: 7rem;\n    gap: 7rem;\n  }\n  .sm\\:gap-32 {\n    grid-gap: 8rem;\n    gap: 8rem;\n  }\n  .sm\\:gap-36 {\n    grid-gap: 9rem;\n    gap: 9rem;\n  }\n  .sm\\:gap-40 {\n    grid-gap: 10rem;\n    gap: 10rem;\n  }\n  .sm\\:gap-44 {\n    grid-gap: 11rem;\n    gap: 11rem;\n  }\n  .sm\\:gap-48 {\n    grid-gap: 12rem;\n    gap: 12rem;\n  }\n  .sm\\:gap-52 {\n    grid-gap: 13rem;\n    gap: 13rem;\n  }\n  .sm\\:gap-56 {\n    grid-gap: 14rem;\n    gap: 14rem;\n  }\n  .sm\\:gap-60 {\n    grid-gap: 15rem;\n    gap: 15rem;\n  }\n  .sm\\:gap-64 {\n    grid-gap: 16rem;\n    gap: 16rem;\n  }\n  .sm\\:gap-72 {\n    grid-gap: 18rem;\n    gap: 18rem;\n  }\n  .sm\\:gap-80 {\n    grid-gap: 20rem;\n    gap: 20rem;\n  }\n  .sm\\:gap-96 {\n    grid-gap: 24rem;\n    gap: 24rem;\n  }\n  .sm\\:gap-px {\n    grid-gap: 1px;\n    gap: 1px;\n  }\n  .sm\\:gap-0\\.5 {\n    grid-gap: 0.125rem;\n    gap: 0.125rem;\n  }\n  .sm\\:gap-1\\.5 {\n    grid-gap: 0.375rem;\n    gap: 0.375rem;\n  }\n  .sm\\:gap-2\\.5 {\n    grid-gap: 0.625rem;\n    gap: 0.625rem;\n  }\n  .sm\\:gap-3\\.5 {\n    grid-gap: 0.875rem;\n    gap: 0.875rem;\n  }\n  .sm\\:gap-1\\/2 {\n    grid-gap: 50%;\n    gap: 50%;\n  }\n  .sm\\:gap-1\\/3 {\n    grid-gap: 33.333333%;\n    gap: 33.333333%;\n  }\n  .sm\\:gap-2\\/3 {\n    grid-gap: 66.666667%;\n    gap: 66.666667%;\n  }\n  .sm\\:gap-1\\/4 {\n    grid-gap: 25%;\n    gap: 25%;\n  }\n  .sm\\:gap-2\\/4 {\n    grid-gap: 50%;\n    gap: 50%;\n  }\n  .sm\\:gap-3\\/4 {\n    grid-gap: 75%;\n    gap: 75%;\n  }\n  .sm\\:gap-1\\/5 {\n    grid-gap: 20%;\n    gap: 20%;\n  }\n  .sm\\:gap-2\\/5 {\n    grid-gap: 40%;\n    gap: 40%;\n  }\n  .sm\\:gap-3\\/5 {\n    grid-gap: 60%;\n    gap: 60%;\n  }\n  .sm\\:gap-4\\/5 {\n    grid-gap: 80%;\n    gap: 80%;\n  }\n  .sm\\:gap-1\\/6 {\n    grid-gap: 16.666667%;\n    gap: 16.666667%;\n  }\n  .sm\\:gap-2\\/6 {\n    grid-gap: 33.333333%;\n    gap: 33.333333%;\n  }\n  .sm\\:gap-3\\/6 {\n    grid-gap: 50%;\n    gap: 50%;\n  }\n  .sm\\:gap-4\\/6 {\n    grid-gap: 66.666667%;\n    gap: 66.666667%;\n  }\n  .sm\\:gap-5\\/6 {\n    grid-gap: 83.333333%;\n    gap: 83.333333%;\n  }\n  .sm\\:gap-1\\/12 {\n    grid-gap: 8.333333%;\n    gap: 8.333333%;\n  }\n  .sm\\:gap-2\\/12 {\n    grid-gap: 16.666667%;\n    gap: 16.666667%;\n  }\n  .sm\\:gap-3\\/12 {\n    grid-gap: 25%;\n    gap: 25%;\n  }\n  .sm\\:gap-4\\/12 {\n    grid-gap: 33.333333%;\n    gap: 33.333333%;\n  }\n  .sm\\:gap-5\\/12 {\n    grid-gap: 41.666667%;\n    gap: 41.666667%;\n  }\n  .sm\\:gap-6\\/12 {\n    grid-gap: 50%;\n    gap: 50%;\n  }\n  .sm\\:gap-7\\/12 {\n    grid-gap: 58.333333%;\n    gap: 58.333333%;\n  }\n  .sm\\:gap-8\\/12 {\n    grid-gap: 66.666667%;\n    gap: 66.666667%;\n  }\n  .sm\\:gap-9\\/12 {\n    grid-gap: 75%;\n    gap: 75%;\n  }\n  .sm\\:gap-10\\/12 {\n    grid-gap: 83.333333%;\n    gap: 83.333333%;\n  }\n  .sm\\:gap-11\\/12 {\n    grid-gap: 91.666667%;\n    gap: 91.666667%;\n  }\n  .sm\\:gap-full {\n    grid-gap: 100%;\n    gap: 100%;\n  }\n  .sm\\:col-gap-0 {\n    grid-column-gap: 0;\n    -moz-column-gap: 0;\n    column-gap: 0;\n  }\n  .sm\\:col-gap-1 {\n    grid-column-gap: 0.25rem;\n    -moz-column-gap: 0.25rem;\n    column-gap: 0.25rem;\n  }\n  .sm\\:col-gap-2 {\n    grid-column-gap: 0.5rem;\n    -moz-column-gap: 0.5rem;\n    column-gap: 0.5rem;\n  }\n  .sm\\:col-gap-3 {\n    grid-column-gap: 0.75rem;\n    -moz-column-gap: 0.75rem;\n    column-gap: 0.75rem;\n  }\n  .sm\\:col-gap-4 {\n    grid-column-gap: 1rem;\n    -moz-column-gap: 1rem;\n    column-gap: 1rem;\n  }\n  .sm\\:col-gap-5 {\n    grid-column-gap: 1.25rem;\n    -moz-column-gap: 1.25rem;\n    column-gap: 1.25rem;\n  }\n  .sm\\:col-gap-6 {\n    grid-column-gap: 1.5rem;\n    -moz-column-gap: 1.5rem;\n    column-gap: 1.5rem;\n  }\n  .sm\\:col-gap-7 {\n    grid-column-gap: 1.75rem;\n    -moz-column-gap: 1.75rem;\n    column-gap: 1.75rem;\n  }\n  .sm\\:col-gap-8 {\n    grid-column-gap: 2rem;\n    -moz-column-gap: 2rem;\n    column-gap: 2rem;\n  }\n  .sm\\:col-gap-9 {\n    grid-column-gap: 2.25rem;\n    -moz-column-gap: 2.25rem;\n    column-gap: 2.25rem;\n  }\n  .sm\\:col-gap-10 {\n    grid-column-gap: 2.5rem;\n    -moz-column-gap: 2.5rem;\n    column-gap: 2.5rem;\n  }\n  .sm\\:col-gap-11 {\n    grid-column-gap: 2.75rem;\n    -moz-column-gap: 2.75rem;\n    column-gap: 2.75rem;\n  }\n  .sm\\:col-gap-12 {\n    grid-column-gap: 3rem;\n    -moz-column-gap: 3rem;\n    column-gap: 3rem;\n  }\n  .sm\\:col-gap-13 {\n    grid-column-gap: 3.25rem;\n    -moz-column-gap: 3.25rem;\n    column-gap: 3.25rem;\n  }\n  .sm\\:col-gap-14 {\n    grid-column-gap: 3.5rem;\n    -moz-column-gap: 3.5rem;\n    column-gap: 3.5rem;\n  }\n  .sm\\:col-gap-15 {\n    grid-column-gap: 3.75rem;\n    -moz-column-gap: 3.75rem;\n    column-gap: 3.75rem;\n  }\n  .sm\\:col-gap-16 {\n    grid-column-gap: 4rem;\n    -moz-column-gap: 4rem;\n    column-gap: 4rem;\n  }\n  .sm\\:col-gap-20 {\n    grid-column-gap: 5rem;\n    -moz-column-gap: 5rem;\n    column-gap: 5rem;\n  }\n  .sm\\:col-gap-24 {\n    grid-column-gap: 6rem;\n    -moz-column-gap: 6rem;\n    column-gap: 6rem;\n  }\n  .sm\\:col-gap-28 {\n    grid-column-gap: 7rem;\n    -moz-column-gap: 7rem;\n    column-gap: 7rem;\n  }\n  .sm\\:col-gap-32 {\n    grid-column-gap: 8rem;\n    -moz-column-gap: 8rem;\n    column-gap: 8rem;\n  }\n  .sm\\:col-gap-36 {\n    grid-column-gap: 9rem;\n    -moz-column-gap: 9rem;\n    column-gap: 9rem;\n  }\n  .sm\\:col-gap-40 {\n    grid-column-gap: 10rem;\n    -moz-column-gap: 10rem;\n    column-gap: 10rem;\n  }\n  .sm\\:col-gap-44 {\n    grid-column-gap: 11rem;\n    -moz-column-gap: 11rem;\n    column-gap: 11rem;\n  }\n  .sm\\:col-gap-48 {\n    grid-column-gap: 12rem;\n    -moz-column-gap: 12rem;\n    column-gap: 12rem;\n  }\n  .sm\\:col-gap-52 {\n    grid-column-gap: 13rem;\n    -moz-column-gap: 13rem;\n    column-gap: 13rem;\n  }\n  .sm\\:col-gap-56 {\n    grid-column-gap: 14rem;\n    -moz-column-gap: 14rem;\n    column-gap: 14rem;\n  }\n  .sm\\:col-gap-60 {\n    grid-column-gap: 15rem;\n    -moz-column-gap: 15rem;\n    column-gap: 15rem;\n  }\n  .sm\\:col-gap-64 {\n    grid-column-gap: 16rem;\n    -moz-column-gap: 16rem;\n    column-gap: 16rem;\n  }\n  .sm\\:col-gap-72 {\n    grid-column-gap: 18rem;\n    -moz-column-gap: 18rem;\n    column-gap: 18rem;\n  }\n  .sm\\:col-gap-80 {\n    grid-column-gap: 20rem;\n    -moz-column-gap: 20rem;\n    column-gap: 20rem;\n  }\n  .sm\\:col-gap-96 {\n    grid-column-gap: 24rem;\n    -moz-column-gap: 24rem;\n    column-gap: 24rem;\n  }\n  .sm\\:col-gap-px {\n    grid-column-gap: 1px;\n    -moz-column-gap: 1px;\n    column-gap: 1px;\n  }\n  .sm\\:col-gap-0\\.5 {\n    grid-column-gap: 0.125rem;\n    -moz-column-gap: 0.125rem;\n    column-gap: 0.125rem;\n  }\n  .sm\\:col-gap-1\\.5 {\n    grid-column-gap: 0.375rem;\n    -moz-column-gap: 0.375rem;\n    column-gap: 0.375rem;\n  }\n  .sm\\:col-gap-2\\.5 {\n    grid-column-gap: 0.625rem;\n    -moz-column-gap: 0.625rem;\n    column-gap: 0.625rem;\n  }\n  .sm\\:col-gap-3\\.5 {\n    grid-column-gap: 0.875rem;\n    -moz-column-gap: 0.875rem;\n    column-gap: 0.875rem;\n  }\n  .sm\\:col-gap-1\\/2 {\n    grid-column-gap: 50%;\n    -moz-column-gap: 50%;\n    column-gap: 50%;\n  }\n  .sm\\:col-gap-1\\/3 {\n    grid-column-gap: 33.333333%;\n    -moz-column-gap: 33.333333%;\n    column-gap: 33.333333%;\n  }\n  .sm\\:col-gap-2\\/3 {\n    grid-column-gap: 66.666667%;\n    -moz-column-gap: 66.666667%;\n    column-gap: 66.666667%;\n  }\n  .sm\\:col-gap-1\\/4 {\n    grid-column-gap: 25%;\n    -moz-column-gap: 25%;\n    column-gap: 25%;\n  }\n  .sm\\:col-gap-2\\/4 {\n    grid-column-gap: 50%;\n    -moz-column-gap: 50%;\n    column-gap: 50%;\n  }\n  .sm\\:col-gap-3\\/4 {\n    grid-column-gap: 75%;\n    -moz-column-gap: 75%;\n    column-gap: 75%;\n  }\n  .sm\\:col-gap-1\\/5 {\n    grid-column-gap: 20%;\n    -moz-column-gap: 20%;\n    column-gap: 20%;\n  }\n  .sm\\:col-gap-2\\/5 {\n    grid-column-gap: 40%;\n    -moz-column-gap: 40%;\n    column-gap: 40%;\n  }\n  .sm\\:col-gap-3\\/5 {\n    grid-column-gap: 60%;\n    -moz-column-gap: 60%;\n    column-gap: 60%;\n  }\n  .sm\\:col-gap-4\\/5 {\n    grid-column-gap: 80%;\n    -moz-column-gap: 80%;\n    column-gap: 80%;\n  }\n  .sm\\:col-gap-1\\/6 {\n    grid-column-gap: 16.666667%;\n    -moz-column-gap: 16.666667%;\n    column-gap: 16.666667%;\n  }\n  .sm\\:col-gap-2\\/6 {\n    grid-column-gap: 33.333333%;\n    -moz-column-gap: 33.333333%;\n    column-gap: 33.333333%;\n  }\n  .sm\\:col-gap-3\\/6 {\n    grid-column-gap: 50%;\n    -moz-column-gap: 50%;\n    column-gap: 50%;\n  }\n  .sm\\:col-gap-4\\/6 {\n    grid-column-gap: 66.666667%;\n    -moz-column-gap: 66.666667%;\n    column-gap: 66.666667%;\n  }\n  .sm\\:col-gap-5\\/6 {\n    grid-column-gap: 83.333333%;\n    -moz-column-gap: 83.333333%;\n    column-gap: 83.333333%;\n  }\n  .sm\\:col-gap-1\\/12 {\n    grid-column-gap: 8.333333%;\n    -moz-column-gap: 8.333333%;\n    column-gap: 8.333333%;\n  }\n  .sm\\:col-gap-2\\/12 {\n    grid-column-gap: 16.666667%;\n    -moz-column-gap: 16.666667%;\n    column-gap: 16.666667%;\n  }\n  .sm\\:col-gap-3\\/12 {\n    grid-column-gap: 25%;\n    -moz-column-gap: 25%;\n    column-gap: 25%;\n  }\n  .sm\\:col-gap-4\\/12 {\n    grid-column-gap: 33.333333%;\n    -moz-column-gap: 33.333333%;\n    column-gap: 33.333333%;\n  }\n  .sm\\:col-gap-5\\/12 {\n    grid-column-gap: 41.666667%;\n    -moz-column-gap: 41.666667%;\n    column-gap: 41.666667%;\n  }\n  .sm\\:col-gap-6\\/12 {\n    grid-column-gap: 50%;\n    -moz-column-gap: 50%;\n    column-gap: 50%;\n  }\n  .sm\\:col-gap-7\\/12 {\n    grid-column-gap: 58.333333%;\n    -moz-column-gap: 58.333333%;\n    column-gap: 58.333333%;\n  }\n  .sm\\:col-gap-8\\/12 {\n    grid-column-gap: 66.666667%;\n    -moz-column-gap: 66.666667%;\n    column-gap: 66.666667%;\n  }\n  .sm\\:col-gap-9\\/12 {\n    grid-column-gap: 75%;\n    -moz-column-gap: 75%;\n    column-gap: 75%;\n  }\n  .sm\\:col-gap-10\\/12 {\n    grid-column-gap: 83.333333%;\n    -moz-column-gap: 83.333333%;\n    column-gap: 83.333333%;\n  }\n  .sm\\:col-gap-11\\/12 {\n    grid-column-gap: 91.666667%;\n    -moz-column-gap: 91.666667%;\n    column-gap: 91.666667%;\n  }\n  .sm\\:col-gap-full {\n    grid-column-gap: 100%;\n    -moz-column-gap: 100%;\n    column-gap: 100%;\n  }\n  .sm\\:gap-x-0 {\n    grid-column-gap: 0;\n    -moz-column-gap: 0;\n    column-gap: 0;\n  }\n  .sm\\:gap-x-1 {\n    grid-column-gap: 0.25rem;\n    -moz-column-gap: 0.25rem;\n    column-gap: 0.25rem;\n  }\n  .sm\\:gap-x-2 {\n    grid-column-gap: 0.5rem;\n    -moz-column-gap: 0.5rem;\n    column-gap: 0.5rem;\n  }\n  .sm\\:gap-x-3 {\n    grid-column-gap: 0.75rem;\n    -moz-column-gap: 0.75rem;\n    column-gap: 0.75rem;\n  }\n  .sm\\:gap-x-4 {\n    grid-column-gap: 1rem;\n    -moz-column-gap: 1rem;\n    column-gap: 1rem;\n  }\n  .sm\\:gap-x-5 {\n    grid-column-gap: 1.25rem;\n    -moz-column-gap: 1.25rem;\n    column-gap: 1.25rem;\n  }\n  .sm\\:gap-x-6 {\n    grid-column-gap: 1.5rem;\n    -moz-column-gap: 1.5rem;\n    column-gap: 1.5rem;\n  }\n  .sm\\:gap-x-7 {\n    grid-column-gap: 1.75rem;\n    -moz-column-gap: 1.75rem;\n    column-gap: 1.75rem;\n  }\n  .sm\\:gap-x-8 {\n    grid-column-gap: 2rem;\n    -moz-column-gap: 2rem;\n    column-gap: 2rem;\n  }\n  .sm\\:gap-x-9 {\n    grid-column-gap: 2.25rem;\n    -moz-column-gap: 2.25rem;\n    column-gap: 2.25rem;\n  }\n  .sm\\:gap-x-10 {\n    grid-column-gap: 2.5rem;\n    -moz-column-gap: 2.5rem;\n    column-gap: 2.5rem;\n  }\n  .sm\\:gap-x-11 {\n    grid-column-gap: 2.75rem;\n    -moz-column-gap: 2.75rem;\n    column-gap: 2.75rem;\n  }\n  .sm\\:gap-x-12 {\n    grid-column-gap: 3rem;\n    -moz-column-gap: 3rem;\n    column-gap: 3rem;\n  }\n  .sm\\:gap-x-13 {\n    grid-column-gap: 3.25rem;\n    -moz-column-gap: 3.25rem;\n    column-gap: 3.25rem;\n  }\n  .sm\\:gap-x-14 {\n    grid-column-gap: 3.5rem;\n    -moz-column-gap: 3.5rem;\n    column-gap: 3.5rem;\n  }\n  .sm\\:gap-x-15 {\n    grid-column-gap: 3.75rem;\n    -moz-column-gap: 3.75rem;\n    column-gap: 3.75rem;\n  }\n  .sm\\:gap-x-16 {\n    grid-column-gap: 4rem;\n    -moz-column-gap: 4rem;\n    column-gap: 4rem;\n  }\n  .sm\\:gap-x-20 {\n    grid-column-gap: 5rem;\n    -moz-column-gap: 5rem;\n    column-gap: 5rem;\n  }\n  .sm\\:gap-x-24 {\n    grid-column-gap: 6rem;\n    -moz-column-gap: 6rem;\n    column-gap: 6rem;\n  }\n  .sm\\:gap-x-28 {\n    grid-column-gap: 7rem;\n    -moz-column-gap: 7rem;\n    column-gap: 7rem;\n  }\n  .sm\\:gap-x-32 {\n    grid-column-gap: 8rem;\n    -moz-column-gap: 8rem;\n    column-gap: 8rem;\n  }\n  .sm\\:gap-x-36 {\n    grid-column-gap: 9rem;\n    -moz-column-gap: 9rem;\n    column-gap: 9rem;\n  }\n  .sm\\:gap-x-40 {\n    grid-column-gap: 10rem;\n    -moz-column-gap: 10rem;\n    column-gap: 10rem;\n  }\n  .sm\\:gap-x-44 {\n    grid-column-gap: 11rem;\n    -moz-column-gap: 11rem;\n    column-gap: 11rem;\n  }\n  .sm\\:gap-x-48 {\n    grid-column-gap: 12rem;\n    -moz-column-gap: 12rem;\n    column-gap: 12rem;\n  }\n  .sm\\:gap-x-52 {\n    grid-column-gap: 13rem;\n    -moz-column-gap: 13rem;\n    column-gap: 13rem;\n  }\n  .sm\\:gap-x-56 {\n    grid-column-gap: 14rem;\n    -moz-column-gap: 14rem;\n    column-gap: 14rem;\n  }\n  .sm\\:gap-x-60 {\n    grid-column-gap: 15rem;\n    -moz-column-gap: 15rem;\n    column-gap: 15rem;\n  }\n  .sm\\:gap-x-64 {\n    grid-column-gap: 16rem;\n    -moz-column-gap: 16rem;\n    column-gap: 16rem;\n  }\n  .sm\\:gap-x-72 {\n    grid-column-gap: 18rem;\n    -moz-column-gap: 18rem;\n    column-gap: 18rem;\n  }\n  .sm\\:gap-x-80 {\n    grid-column-gap: 20rem;\n    -moz-column-gap: 20rem;\n    column-gap: 20rem;\n  }\n  .sm\\:gap-x-96 {\n    grid-column-gap: 24rem;\n    -moz-column-gap: 24rem;\n    column-gap: 24rem;\n  }\n  .sm\\:gap-x-px {\n    grid-column-gap: 1px;\n    -moz-column-gap: 1px;\n    column-gap: 1px;\n  }\n  .sm\\:gap-x-0\\.5 {\n    grid-column-gap: 0.125rem;\n    -moz-column-gap: 0.125rem;\n    column-gap: 0.125rem;\n  }\n  .sm\\:gap-x-1\\.5 {\n    grid-column-gap: 0.375rem;\n    -moz-column-gap: 0.375rem;\n    column-gap: 0.375rem;\n  }\n  .sm\\:gap-x-2\\.5 {\n    grid-column-gap: 0.625rem;\n    -moz-column-gap: 0.625rem;\n    column-gap: 0.625rem;\n  }\n  .sm\\:gap-x-3\\.5 {\n    grid-column-gap: 0.875rem;\n    -moz-column-gap: 0.875rem;\n    column-gap: 0.875rem;\n  }\n  .sm\\:gap-x-1\\/2 {\n    grid-column-gap: 50%;\n    -moz-column-gap: 50%;\n    column-gap: 50%;\n  }\n  .sm\\:gap-x-1\\/3 {\n    grid-column-gap: 33.333333%;\n    -moz-column-gap: 33.333333%;\n    column-gap: 33.333333%;\n  }\n  .sm\\:gap-x-2\\/3 {\n    grid-column-gap: 66.666667%;\n    -moz-column-gap: 66.666667%;\n    column-gap: 66.666667%;\n  }\n  .sm\\:gap-x-1\\/4 {\n    grid-column-gap: 25%;\n    -moz-column-gap: 25%;\n    column-gap: 25%;\n  }\n  .sm\\:gap-x-2\\/4 {\n    grid-column-gap: 50%;\n    -moz-column-gap: 50%;\n    column-gap: 50%;\n  }\n  .sm\\:gap-x-3\\/4 {\n    grid-column-gap: 75%;\n    -moz-column-gap: 75%;\n    column-gap: 75%;\n  }\n  .sm\\:gap-x-1\\/5 {\n    grid-column-gap: 20%;\n    -moz-column-gap: 20%;\n    column-gap: 20%;\n  }\n  .sm\\:gap-x-2\\/5 {\n    grid-column-gap: 40%;\n    -moz-column-gap: 40%;\n    column-gap: 40%;\n  }\n  .sm\\:gap-x-3\\/5 {\n    grid-column-gap: 60%;\n    -moz-column-gap: 60%;\n    column-gap: 60%;\n  }\n  .sm\\:gap-x-4\\/5 {\n    grid-column-gap: 80%;\n    -moz-column-gap: 80%;\n    column-gap: 80%;\n  }\n  .sm\\:gap-x-1\\/6 {\n    grid-column-gap: 16.666667%;\n    -moz-column-gap: 16.666667%;\n    column-gap: 16.666667%;\n  }\n  .sm\\:gap-x-2\\/6 {\n    grid-column-gap: 33.333333%;\n    -moz-column-gap: 33.333333%;\n    column-gap: 33.333333%;\n  }\n  .sm\\:gap-x-3\\/6 {\n    grid-column-gap: 50%;\n    -moz-column-gap: 50%;\n    column-gap: 50%;\n  }\n  .sm\\:gap-x-4\\/6 {\n    grid-column-gap: 66.666667%;\n    -moz-column-gap: 66.666667%;\n    column-gap: 66.666667%;\n  }\n  .sm\\:gap-x-5\\/6 {\n    grid-column-gap: 83.333333%;\n    -moz-column-gap: 83.333333%;\n    column-gap: 83.333333%;\n  }\n  .sm\\:gap-x-1\\/12 {\n    grid-column-gap: 8.333333%;\n    -moz-column-gap: 8.333333%;\n    column-gap: 8.333333%;\n  }\n  .sm\\:gap-x-2\\/12 {\n    grid-column-gap: 16.666667%;\n    -moz-column-gap: 16.666667%;\n    column-gap: 16.666667%;\n  }\n  .sm\\:gap-x-3\\/12 {\n    grid-column-gap: 25%;\n    -moz-column-gap: 25%;\n    column-gap: 25%;\n  }\n  .sm\\:gap-x-4\\/12 {\n    grid-column-gap: 33.333333%;\n    -moz-column-gap: 33.333333%;\n    column-gap: 33.333333%;\n  }\n  .sm\\:gap-x-5\\/12 {\n    grid-column-gap: 41.666667%;\n    -moz-column-gap: 41.666667%;\n    column-gap: 41.666667%;\n  }\n  .sm\\:gap-x-6\\/12 {\n    grid-column-gap: 50%;\n    -moz-column-gap: 50%;\n    column-gap: 50%;\n  }\n  .sm\\:gap-x-7\\/12 {\n    grid-column-gap: 58.333333%;\n    -moz-column-gap: 58.333333%;\n    column-gap: 58.333333%;\n  }\n  .sm\\:gap-x-8\\/12 {\n    grid-column-gap: 66.666667%;\n    -moz-column-gap: 66.666667%;\n    column-gap: 66.666667%;\n  }\n  .sm\\:gap-x-9\\/12 {\n    grid-column-gap: 75%;\n    -moz-column-gap: 75%;\n    column-gap: 75%;\n  }\n  .sm\\:gap-x-10\\/12 {\n    grid-column-gap: 83.333333%;\n    -moz-column-gap: 83.333333%;\n    column-gap: 83.333333%;\n  }\n  .sm\\:gap-x-11\\/12 {\n    grid-column-gap: 91.666667%;\n    -moz-column-gap: 91.666667%;\n    column-gap: 91.666667%;\n  }\n  .sm\\:gap-x-full {\n    grid-column-gap: 100%;\n    -moz-column-gap: 100%;\n    column-gap: 100%;\n  }\n  .sm\\:row-gap-0 {\n    grid-row-gap: 0;\n    row-gap: 0;\n  }\n  .sm\\:row-gap-1 {\n    grid-row-gap: 0.25rem;\n    row-gap: 0.25rem;\n  }\n  .sm\\:row-gap-2 {\n    grid-row-gap: 0.5rem;\n    row-gap: 0.5rem;\n  }\n  .sm\\:row-gap-3 {\n    grid-row-gap: 0.75rem;\n    row-gap: 0.75rem;\n  }\n  .sm\\:row-gap-4 {\n    grid-row-gap: 1rem;\n    row-gap: 1rem;\n  }\n  .sm\\:row-gap-5 {\n    grid-row-gap: 1.25rem;\n    row-gap: 1.25rem;\n  }\n  .sm\\:row-gap-6 {\n    grid-row-gap: 1.5rem;\n    row-gap: 1.5rem;\n  }\n  .sm\\:row-gap-7 {\n    grid-row-gap: 1.75rem;\n    row-gap: 1.75rem;\n  }\n  .sm\\:row-gap-8 {\n    grid-row-gap: 2rem;\n    row-gap: 2rem;\n  }\n  .sm\\:row-gap-9 {\n    grid-row-gap: 2.25rem;\n    row-gap: 2.25rem;\n  }\n  .sm\\:row-gap-10 {\n    grid-row-gap: 2.5rem;\n    row-gap: 2.5rem;\n  }\n  .sm\\:row-gap-11 {\n    grid-row-gap: 2.75rem;\n    row-gap: 2.75rem;\n  }\n  .sm\\:row-gap-12 {\n    grid-row-gap: 3rem;\n    row-gap: 3rem;\n  }\n  .sm\\:row-gap-13 {\n    grid-row-gap: 3.25rem;\n    row-gap: 3.25rem;\n  }\n  .sm\\:row-gap-14 {\n    grid-row-gap: 3.5rem;\n    row-gap: 3.5rem;\n  }\n  .sm\\:row-gap-15 {\n    grid-row-gap: 3.75rem;\n    row-gap: 3.75rem;\n  }\n  .sm\\:row-gap-16 {\n    grid-row-gap: 4rem;\n    row-gap: 4rem;\n  }\n  .sm\\:row-gap-20 {\n    grid-row-gap: 5rem;\n    row-gap: 5rem;\n  }\n  .sm\\:row-gap-24 {\n    grid-row-gap: 6rem;\n    row-gap: 6rem;\n  }\n  .sm\\:row-gap-28 {\n    grid-row-gap: 7rem;\n    row-gap: 7rem;\n  }\n  .sm\\:row-gap-32 {\n    grid-row-gap: 8rem;\n    row-gap: 8rem;\n  }\n  .sm\\:row-gap-36 {\n    grid-row-gap: 9rem;\n    row-gap: 9rem;\n  }\n  .sm\\:row-gap-40 {\n    grid-row-gap: 10rem;\n    row-gap: 10rem;\n  }\n  .sm\\:row-gap-44 {\n    grid-row-gap: 11rem;\n    row-gap: 11rem;\n  }\n  .sm\\:row-gap-48 {\n    grid-row-gap: 12rem;\n    row-gap: 12rem;\n  }\n  .sm\\:row-gap-52 {\n    grid-row-gap: 13rem;\n    row-gap: 13rem;\n  }\n  .sm\\:row-gap-56 {\n    grid-row-gap: 14rem;\n    row-gap: 14rem;\n  }\n  .sm\\:row-gap-60 {\n    grid-row-gap: 15rem;\n    row-gap: 15rem;\n  }\n  .sm\\:row-gap-64 {\n    grid-row-gap: 16rem;\n    row-gap: 16rem;\n  }\n  .sm\\:row-gap-72 {\n    grid-row-gap: 18rem;\n    row-gap: 18rem;\n  }\n  .sm\\:row-gap-80 {\n    grid-row-gap: 20rem;\n    row-gap: 20rem;\n  }\n  .sm\\:row-gap-96 {\n    grid-row-gap: 24rem;\n    row-gap: 24rem;\n  }\n  .sm\\:row-gap-px {\n    grid-row-gap: 1px;\n    row-gap: 1px;\n  }\n  .sm\\:row-gap-0\\.5 {\n    grid-row-gap: 0.125rem;\n    row-gap: 0.125rem;\n  }\n  .sm\\:row-gap-1\\.5 {\n    grid-row-gap: 0.375rem;\n    row-gap: 0.375rem;\n  }\n  .sm\\:row-gap-2\\.5 {\n    grid-row-gap: 0.625rem;\n    row-gap: 0.625rem;\n  }\n  .sm\\:row-gap-3\\.5 {\n    grid-row-gap: 0.875rem;\n    row-gap: 0.875rem;\n  }\n  .sm\\:row-gap-1\\/2 {\n    grid-row-gap: 50%;\n    row-gap: 50%;\n  }\n  .sm\\:row-gap-1\\/3 {\n    grid-row-gap: 33.333333%;\n    row-gap: 33.333333%;\n  }\n  .sm\\:row-gap-2\\/3 {\n    grid-row-gap: 66.666667%;\n    row-gap: 66.666667%;\n  }\n  .sm\\:row-gap-1\\/4 {\n    grid-row-gap: 25%;\n    row-gap: 25%;\n  }\n  .sm\\:row-gap-2\\/4 {\n    grid-row-gap: 50%;\n    row-gap: 50%;\n  }\n  .sm\\:row-gap-3\\/4 {\n    grid-row-gap: 75%;\n    row-gap: 75%;\n  }\n  .sm\\:row-gap-1\\/5 {\n    grid-row-gap: 20%;\n    row-gap: 20%;\n  }\n  .sm\\:row-gap-2\\/5 {\n    grid-row-gap: 40%;\n    row-gap: 40%;\n  }\n  .sm\\:row-gap-3\\/5 {\n    grid-row-gap: 60%;\n    row-gap: 60%;\n  }\n  .sm\\:row-gap-4\\/5 {\n    grid-row-gap: 80%;\n    row-gap: 80%;\n  }\n  .sm\\:row-gap-1\\/6 {\n    grid-row-gap: 16.666667%;\n    row-gap: 16.666667%;\n  }\n  .sm\\:row-gap-2\\/6 {\n    grid-row-gap: 33.333333%;\n    row-gap: 33.333333%;\n  }\n  .sm\\:row-gap-3\\/6 {\n    grid-row-gap: 50%;\n    row-gap: 50%;\n  }\n  .sm\\:row-gap-4\\/6 {\n    grid-row-gap: 66.666667%;\n    row-gap: 66.666667%;\n  }\n  .sm\\:row-gap-5\\/6 {\n    grid-row-gap: 83.333333%;\n    row-gap: 83.333333%;\n  }\n  .sm\\:row-gap-1\\/12 {\n    grid-row-gap: 8.333333%;\n    row-gap: 8.333333%;\n  }\n  .sm\\:row-gap-2\\/12 {\n    grid-row-gap: 16.666667%;\n    row-gap: 16.666667%;\n  }\n  .sm\\:row-gap-3\\/12 {\n    grid-row-gap: 25%;\n    row-gap: 25%;\n  }\n  .sm\\:row-gap-4\\/12 {\n    grid-row-gap: 33.333333%;\n    row-gap: 33.333333%;\n  }\n  .sm\\:row-gap-5\\/12 {\n    grid-row-gap: 41.666667%;\n    row-gap: 41.666667%;\n  }\n  .sm\\:row-gap-6\\/12 {\n    grid-row-gap: 50%;\n    row-gap: 50%;\n  }\n  .sm\\:row-gap-7\\/12 {\n    grid-row-gap: 58.333333%;\n    row-gap: 58.333333%;\n  }\n  .sm\\:row-gap-8\\/12 {\n    grid-row-gap: 66.666667%;\n    row-gap: 66.666667%;\n  }\n  .sm\\:row-gap-9\\/12 {\n    grid-row-gap: 75%;\n    row-gap: 75%;\n  }\n  .sm\\:row-gap-10\\/12 {\n    grid-row-gap: 83.333333%;\n    row-gap: 83.333333%;\n  }\n  .sm\\:row-gap-11\\/12 {\n    grid-row-gap: 91.666667%;\n    row-gap: 91.666667%;\n  }\n  .sm\\:row-gap-full {\n    grid-row-gap: 100%;\n    row-gap: 100%;\n  }\n  .sm\\:gap-y-0 {\n    grid-row-gap: 0;\n    row-gap: 0;\n  }\n  .sm\\:gap-y-1 {\n    grid-row-gap: 0.25rem;\n    row-gap: 0.25rem;\n  }\n  .sm\\:gap-y-2 {\n    grid-row-gap: 0.5rem;\n    row-gap: 0.5rem;\n  }\n  .sm\\:gap-y-3 {\n    grid-row-gap: 0.75rem;\n    row-gap: 0.75rem;\n  }\n  .sm\\:gap-y-4 {\n    grid-row-gap: 1rem;\n    row-gap: 1rem;\n  }\n  .sm\\:gap-y-5 {\n    grid-row-gap: 1.25rem;\n    row-gap: 1.25rem;\n  }\n  .sm\\:gap-y-6 {\n    grid-row-gap: 1.5rem;\n    row-gap: 1.5rem;\n  }\n  .sm\\:gap-y-7 {\n    grid-row-gap: 1.75rem;\n    row-gap: 1.75rem;\n  }\n  .sm\\:gap-y-8 {\n    grid-row-gap: 2rem;\n    row-gap: 2rem;\n  }\n  .sm\\:gap-y-9 {\n    grid-row-gap: 2.25rem;\n    row-gap: 2.25rem;\n  }\n  .sm\\:gap-y-10 {\n    grid-row-gap: 2.5rem;\n    row-gap: 2.5rem;\n  }\n  .sm\\:gap-y-11 {\n    grid-row-gap: 2.75rem;\n    row-gap: 2.75rem;\n  }\n  .sm\\:gap-y-12 {\n    grid-row-gap: 3rem;\n    row-gap: 3rem;\n  }\n  .sm\\:gap-y-13 {\n    grid-row-gap: 3.25rem;\n    row-gap: 3.25rem;\n  }\n  .sm\\:gap-y-14 {\n    grid-row-gap: 3.5rem;\n    row-gap: 3.5rem;\n  }\n  .sm\\:gap-y-15 {\n    grid-row-gap: 3.75rem;\n    row-gap: 3.75rem;\n  }\n  .sm\\:gap-y-16 {\n    grid-row-gap: 4rem;\n    row-gap: 4rem;\n  }\n  .sm\\:gap-y-20 {\n    grid-row-gap: 5rem;\n    row-gap: 5rem;\n  }\n  .sm\\:gap-y-24 {\n    grid-row-gap: 6rem;\n    row-gap: 6rem;\n  }\n  .sm\\:gap-y-28 {\n    grid-row-gap: 7rem;\n    row-gap: 7rem;\n  }\n  .sm\\:gap-y-32 {\n    grid-row-gap: 8rem;\n    row-gap: 8rem;\n  }\n  .sm\\:gap-y-36 {\n    grid-row-gap: 9rem;\n    row-gap: 9rem;\n  }\n  .sm\\:gap-y-40 {\n    grid-row-gap: 10rem;\n    row-gap: 10rem;\n  }\n  .sm\\:gap-y-44 {\n    grid-row-gap: 11rem;\n    row-gap: 11rem;\n  }\n  .sm\\:gap-y-48 {\n    grid-row-gap: 12rem;\n    row-gap: 12rem;\n  }\n  .sm\\:gap-y-52 {\n    grid-row-gap: 13rem;\n    row-gap: 13rem;\n  }\n  .sm\\:gap-y-56 {\n    grid-row-gap: 14rem;\n    row-gap: 14rem;\n  }\n  .sm\\:gap-y-60 {\n    grid-row-gap: 15rem;\n    row-gap: 15rem;\n  }\n  .sm\\:gap-y-64 {\n    grid-row-gap: 16rem;\n    row-gap: 16rem;\n  }\n  .sm\\:gap-y-72 {\n    grid-row-gap: 18rem;\n    row-gap: 18rem;\n  }\n  .sm\\:gap-y-80 {\n    grid-row-gap: 20rem;\n    row-gap: 20rem;\n  }\n  .sm\\:gap-y-96 {\n    grid-row-gap: 24rem;\n    row-gap: 24rem;\n  }\n  .sm\\:gap-y-px {\n    grid-row-gap: 1px;\n    row-gap: 1px;\n  }\n  .sm\\:gap-y-0\\.5 {\n    grid-row-gap: 0.125rem;\n    row-gap: 0.125rem;\n  }\n  .sm\\:gap-y-1\\.5 {\n    grid-row-gap: 0.375rem;\n    row-gap: 0.375rem;\n  }\n  .sm\\:gap-y-2\\.5 {\n    grid-row-gap: 0.625rem;\n    row-gap: 0.625rem;\n  }\n  .sm\\:gap-y-3\\.5 {\n    grid-row-gap: 0.875rem;\n    row-gap: 0.875rem;\n  }\n  .sm\\:gap-y-1\\/2 {\n    grid-row-gap: 50%;\n    row-gap: 50%;\n  }\n  .sm\\:gap-y-1\\/3 {\n    grid-row-gap: 33.333333%;\n    row-gap: 33.333333%;\n  }\n  .sm\\:gap-y-2\\/3 {\n    grid-row-gap: 66.666667%;\n    row-gap: 66.666667%;\n  }\n  .sm\\:gap-y-1\\/4 {\n    grid-row-gap: 25%;\n    row-gap: 25%;\n  }\n  .sm\\:gap-y-2\\/4 {\n    grid-row-gap: 50%;\n    row-gap: 50%;\n  }\n  .sm\\:gap-y-3\\/4 {\n    grid-row-gap: 75%;\n    row-gap: 75%;\n  }\n  .sm\\:gap-y-1\\/5 {\n    grid-row-gap: 20%;\n    row-gap: 20%;\n  }\n  .sm\\:gap-y-2\\/5 {\n    grid-row-gap: 40%;\n    row-gap: 40%;\n  }\n  .sm\\:gap-y-3\\/5 {\n    grid-row-gap: 60%;\n    row-gap: 60%;\n  }\n  .sm\\:gap-y-4\\/5 {\n    grid-row-gap: 80%;\n    row-gap: 80%;\n  }\n  .sm\\:gap-y-1\\/6 {\n    grid-row-gap: 16.666667%;\n    row-gap: 16.666667%;\n  }\n  .sm\\:gap-y-2\\/6 {\n    grid-row-gap: 33.333333%;\n    row-gap: 33.333333%;\n  }\n  .sm\\:gap-y-3\\/6 {\n    grid-row-gap: 50%;\n    row-gap: 50%;\n  }\n  .sm\\:gap-y-4\\/6 {\n    grid-row-gap: 66.666667%;\n    row-gap: 66.666667%;\n  }\n  .sm\\:gap-y-5\\/6 {\n    grid-row-gap: 83.333333%;\n    row-gap: 83.333333%;\n  }\n  .sm\\:gap-y-1\\/12 {\n    grid-row-gap: 8.333333%;\n    row-gap: 8.333333%;\n  }\n  .sm\\:gap-y-2\\/12 {\n    grid-row-gap: 16.666667%;\n    row-gap: 16.666667%;\n  }\n  .sm\\:gap-y-3\\/12 {\n    grid-row-gap: 25%;\n    row-gap: 25%;\n  }\n  .sm\\:gap-y-4\\/12 {\n    grid-row-gap: 33.333333%;\n    row-gap: 33.333333%;\n  }\n  .sm\\:gap-y-5\\/12 {\n    grid-row-gap: 41.666667%;\n    row-gap: 41.666667%;\n  }\n  .sm\\:gap-y-6\\/12 {\n    grid-row-gap: 50%;\n    row-gap: 50%;\n  }\n  .sm\\:gap-y-7\\/12 {\n    grid-row-gap: 58.333333%;\n    row-gap: 58.333333%;\n  }\n  .sm\\:gap-y-8\\/12 {\n    grid-row-gap: 66.666667%;\n    row-gap: 66.666667%;\n  }\n  .sm\\:gap-y-9\\/12 {\n    grid-row-gap: 75%;\n    row-gap: 75%;\n  }\n  .sm\\:gap-y-10\\/12 {\n    grid-row-gap: 83.333333%;\n    row-gap: 83.333333%;\n  }\n  .sm\\:gap-y-11\\/12 {\n    grid-row-gap: 91.666667%;\n    row-gap: 91.666667%;\n  }\n  .sm\\:gap-y-full {\n    grid-row-gap: 100%;\n    row-gap: 100%;\n  }\n  .sm\\:grid-flow-row {\n    grid-auto-flow: row;\n  }\n  .sm\\:grid-flow-col {\n    grid-auto-flow: column;\n  }\n  .sm\\:grid-flow-row-dense {\n    grid-auto-flow: row dense;\n  }\n  .sm\\:grid-flow-col-dense {\n    grid-auto-flow: column dense;\n  }\n  .sm\\:grid-cols-1 {\n    grid-template-columns: repeat(1, minmax(0, 1fr));\n  }\n  .sm\\:grid-cols-2 {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n  .sm\\:grid-cols-3 {\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n  }\n  .sm\\:grid-cols-4 {\n    grid-template-columns: repeat(4, minmax(0, 1fr));\n  }\n  .sm\\:grid-cols-5 {\n    grid-template-columns: repeat(5, minmax(0, 1fr));\n  }\n  .sm\\:grid-cols-6 {\n    grid-template-columns: repeat(6, minmax(0, 1fr));\n  }\n  .sm\\:grid-cols-7 {\n    grid-template-columns: repeat(7, minmax(0, 1fr));\n  }\n  .sm\\:grid-cols-8 {\n    grid-template-columns: repeat(8, minmax(0, 1fr));\n  }\n  .sm\\:grid-cols-9 {\n    grid-template-columns: repeat(9, minmax(0, 1fr));\n  }\n  .sm\\:grid-cols-10 {\n    grid-template-columns: repeat(10, minmax(0, 1fr));\n  }\n  .sm\\:grid-cols-11 {\n    grid-template-columns: repeat(11, minmax(0, 1fr));\n  }\n  .sm\\:grid-cols-12 {\n    grid-template-columns: repeat(12, minmax(0, 1fr));\n  }\n  .sm\\:grid-cols-none {\n    grid-template-columns: none;\n  }\n  .sm\\:auto-cols-auto {\n    grid-auto-columns: auto;\n  }\n  .sm\\:auto-cols-min {\n    grid-auto-columns: min-content;\n  }\n  .sm\\:auto-cols-max {\n    grid-auto-columns: max-content;\n  }\n  .sm\\:auto-cols-fr {\n    grid-auto-columns: minmax(0, 1fr);\n  }\n  .sm\\:col-auto {\n    grid-column: auto;\n  }\n  .sm\\:col-span-1 {\n    grid-column: span 1 / span 1;\n  }\n  .sm\\:col-span-2 {\n    grid-column: span 2 / span 2;\n  }\n  .sm\\:col-span-3 {\n    grid-column: span 3 / span 3;\n  }\n  .sm\\:col-span-4 {\n    grid-column: span 4 / span 4;\n  }\n  .sm\\:col-span-5 {\n    grid-column: span 5 / span 5;\n  }\n  .sm\\:col-span-6 {\n    grid-column: span 6 / span 6;\n  }\n  .sm\\:col-span-7 {\n    grid-column: span 7 / span 7;\n  }\n  .sm\\:col-span-8 {\n    grid-column: span 8 / span 8;\n  }\n  .sm\\:col-span-9 {\n    grid-column: span 9 / span 9;\n  }\n  .sm\\:col-span-10 {\n    grid-column: span 10 / span 10;\n  }\n  .sm\\:col-span-11 {\n    grid-column: span 11 / span 11;\n  }\n  .sm\\:col-span-12 {\n    grid-column: span 12 / span 12;\n  }\n  .sm\\:col-span-full {\n    grid-column: 1 / -1;\n  }\n  .sm\\:col-start-1 {\n    grid-column-start: 1;\n  }\n  .sm\\:col-start-2 {\n    grid-column-start: 2;\n  }\n  .sm\\:col-start-3 {\n    grid-column-start: 3;\n  }\n  .sm\\:col-start-4 {\n    grid-column-start: 4;\n  }\n  .sm\\:col-start-5 {\n    grid-column-start: 5;\n  }\n  .sm\\:col-start-6 {\n    grid-column-start: 6;\n  }\n  .sm\\:col-start-7 {\n    grid-column-start: 7;\n  }\n  .sm\\:col-start-8 {\n    grid-column-start: 8;\n  }\n  .sm\\:col-start-9 {\n    grid-column-start: 9;\n  }\n  .sm\\:col-start-10 {\n    grid-column-start: 10;\n  }\n  .sm\\:col-start-11 {\n    grid-column-start: 11;\n  }\n  .sm\\:col-start-12 {\n    grid-column-start: 12;\n  }\n  .sm\\:col-start-13 {\n    grid-column-start: 13;\n  }\n  .sm\\:col-start-auto {\n    grid-column-start: auto;\n  }\n  .sm\\:col-end-1 {\n    grid-column-end: 1;\n  }\n  .sm\\:col-end-2 {\n    grid-column-end: 2;\n  }\n  .sm\\:col-end-3 {\n    grid-column-end: 3;\n  }\n  .sm\\:col-end-4 {\n    grid-column-end: 4;\n  }\n  .sm\\:col-end-5 {\n    grid-column-end: 5;\n  }\n  .sm\\:col-end-6 {\n    grid-column-end: 6;\n  }\n  .sm\\:col-end-7 {\n    grid-column-end: 7;\n  }\n  .sm\\:col-end-8 {\n    grid-column-end: 8;\n  }\n  .sm\\:col-end-9 {\n    grid-column-end: 9;\n  }\n  .sm\\:col-end-10 {\n    grid-column-end: 10;\n  }\n  .sm\\:col-end-11 {\n    grid-column-end: 11;\n  }\n  .sm\\:col-end-12 {\n    grid-column-end: 12;\n  }\n  .sm\\:col-end-13 {\n    grid-column-end: 13;\n  }\n  .sm\\:col-end-auto {\n    grid-column-end: auto;\n  }\n  .sm\\:grid-rows-1 {\n    grid-template-rows: repeat(1, minmax(0, 1fr));\n  }\n  .sm\\:grid-rows-2 {\n    grid-template-rows: repeat(2, minmax(0, 1fr));\n  }\n  .sm\\:grid-rows-3 {\n    grid-template-rows: repeat(3, minmax(0, 1fr));\n  }\n  .sm\\:grid-rows-4 {\n    grid-template-rows: repeat(4, minmax(0, 1fr));\n  }\n  .sm\\:grid-rows-5 {\n    grid-template-rows: repeat(5, minmax(0, 1fr));\n  }\n  .sm\\:grid-rows-6 {\n    grid-template-rows: repeat(6, minmax(0, 1fr));\n  }\n  .sm\\:grid-rows-none {\n    grid-template-rows: none;\n  }\n  .sm\\:auto-rows-auto {\n    grid-auto-rows: auto;\n  }\n  .sm\\:auto-rows-min {\n    grid-auto-rows: min-content;\n  }\n  .sm\\:auto-rows-max {\n    grid-auto-rows: max-content;\n  }\n  .sm\\:auto-rows-fr {\n    grid-auto-rows: minmax(0, 1fr);\n  }\n  .sm\\:row-auto {\n    grid-row: auto;\n  }\n  .sm\\:row-span-1 {\n    grid-row: span 1 / span 1;\n  }\n  .sm\\:row-span-2 {\n    grid-row: span 2 / span 2;\n  }\n  .sm\\:row-span-3 {\n    grid-row: span 3 / span 3;\n  }\n  .sm\\:row-span-4 {\n    grid-row: span 4 / span 4;\n  }\n  .sm\\:row-span-5 {\n    grid-row: span 5 / span 5;\n  }\n  .sm\\:row-span-6 {\n    grid-row: span 6 / span 6;\n  }\n  .sm\\:row-span-full {\n    grid-row: 1 / -1;\n  }\n  .sm\\:row-start-1 {\n    grid-row-start: 1;\n  }\n  .sm\\:row-start-2 {\n    grid-row-start: 2;\n  }\n  .sm\\:row-start-3 {\n    grid-row-start: 3;\n  }\n  .sm\\:row-start-4 {\n    grid-row-start: 4;\n  }\n  .sm\\:row-start-5 {\n    grid-row-start: 5;\n  }\n  .sm\\:row-start-6 {\n    grid-row-start: 6;\n  }\n  .sm\\:row-start-7 {\n    grid-row-start: 7;\n  }\n  .sm\\:row-start-auto {\n    grid-row-start: auto;\n  }\n  .sm\\:row-end-1 {\n    grid-row-end: 1;\n  }\n  .sm\\:row-end-2 {\n    grid-row-end: 2;\n  }\n  .sm\\:row-end-3 {\n    grid-row-end: 3;\n  }\n  .sm\\:row-end-4 {\n    grid-row-end: 4;\n  }\n  .sm\\:row-end-5 {\n    grid-row-end: 5;\n  }\n  .sm\\:row-end-6 {\n    grid-row-end: 6;\n  }\n  .sm\\:row-end-7 {\n    grid-row-end: 7;\n  }\n  .sm\\:row-end-auto {\n    grid-row-end: auto;\n  }\n  .sm\\:transform {\n    --transform-translate-x: 0;\n    --transform-translate-y: 0;\n    --transform-rotate: 0;\n    --transform-skew-x: 0;\n    --transform-skew-y: 0;\n    --transform-scale-x: 1;\n    --transform-scale-y: 1;\n    transform: translateX(var(--transform-translate-x)) translateY(var(--transform-translate-y)) rotate(var(--transform-rotate)) skewX(var(--transform-skew-x)) skewY(var(--transform-skew-y)) scaleX(var(--transform-scale-x)) scaleY(var(--transform-scale-y));\n  }\n  .sm\\:transform-none {\n    transform: none;\n  }\n  .sm\\:origin-center {\n    transform-origin: center;\n  }\n  .sm\\:origin-top {\n    transform-origin: top;\n  }\n  .sm\\:origin-top-right {\n    transform-origin: top right;\n  }\n  .sm\\:origin-right {\n    transform-origin: right;\n  }\n  .sm\\:origin-bottom-right {\n    transform-origin: bottom right;\n  }\n  .sm\\:origin-bottom {\n    transform-origin: bottom;\n  }\n  .sm\\:origin-bottom-left {\n    transform-origin: bottom left;\n  }\n  .sm\\:origin-left {\n    transform-origin: left;\n  }\n  .sm\\:origin-top-left {\n    transform-origin: top left;\n  }\n  .sm\\:scale-0 {\n    --transform-scale-x: 0;\n    --transform-scale-y: 0;\n  }\n  .sm\\:scale-50 {\n    --transform-scale-x: .5;\n    --transform-scale-y: .5;\n  }\n  .sm\\:scale-75 {\n    --transform-scale-x: .75;\n    --transform-scale-y: .75;\n  }\n  .sm\\:scale-90 {\n    --transform-scale-x: .9;\n    --transform-scale-y: .9;\n  }\n  .sm\\:scale-95 {\n    --transform-scale-x: .95;\n    --transform-scale-y: .95;\n  }\n  .sm\\:scale-100 {\n    --transform-scale-x: 1;\n    --transform-scale-y: 1;\n  }\n  .sm\\:scale-105 {\n    --transform-scale-x: 1.05;\n    --transform-scale-y: 1.05;\n  }\n  .sm\\:scale-110 {\n    --transform-scale-x: 1.1;\n    --transform-scale-y: 1.1;\n  }\n  .sm\\:scale-125 {\n    --transform-scale-x: 1.25;\n    --transform-scale-y: 1.25;\n  }\n  .sm\\:scale-150 {\n    --transform-scale-x: 1.5;\n    --transform-scale-y: 1.5;\n  }\n  .sm\\:scale-x-0 {\n    --transform-scale-x: 0;\n  }\n  .sm\\:scale-x-50 {\n    --transform-scale-x: .5;\n  }\n  .sm\\:scale-x-75 {\n    --transform-scale-x: .75;\n  }\n  .sm\\:scale-x-90 {\n    --transform-scale-x: .9;\n  }\n  .sm\\:scale-x-95 {\n    --transform-scale-x: .95;\n  }\n  .sm\\:scale-x-100 {\n    --transform-scale-x: 1;\n  }\n  .sm\\:scale-x-105 {\n    --transform-scale-x: 1.05;\n  }\n  .sm\\:scale-x-110 {\n    --transform-scale-x: 1.1;\n  }\n  .sm\\:scale-x-125 {\n    --transform-scale-x: 1.25;\n  }\n  .sm\\:scale-x-150 {\n    --transform-scale-x: 1.5;\n  }\n  .sm\\:scale-y-0 {\n    --transform-scale-y: 0;\n  }\n  .sm\\:scale-y-50 {\n    --transform-scale-y: .5;\n  }\n  .sm\\:scale-y-75 {\n    --transform-scale-y: .75;\n  }\n  .sm\\:scale-y-90 {\n    --transform-scale-y: .9;\n  }\n  .sm\\:scale-y-95 {\n    --transform-scale-y: .95;\n  }\n  .sm\\:scale-y-100 {\n    --transform-scale-y: 1;\n  }\n  .sm\\:scale-y-105 {\n    --transform-scale-y: 1.05;\n  }\n  .sm\\:scale-y-110 {\n    --transform-scale-y: 1.1;\n  }\n  .sm\\:scale-y-125 {\n    --transform-scale-y: 1.25;\n  }\n  .sm\\:scale-y-150 {\n    --transform-scale-y: 1.5;\n  }\n  .sm\\:hover\\:scale-0:hover {\n    --transform-scale-x: 0;\n    --transform-scale-y: 0;\n  }\n  .sm\\:hover\\:scale-50:hover {\n    --transform-scale-x: .5;\n    --transform-scale-y: .5;\n  }\n  .sm\\:hover\\:scale-75:hover {\n    --transform-scale-x: .75;\n    --transform-scale-y: .75;\n  }\n  .sm\\:hover\\:scale-90:hover {\n    --transform-scale-x: .9;\n    --transform-scale-y: .9;\n  }\n  .sm\\:hover\\:scale-95:hover {\n    --transform-scale-x: .95;\n    --transform-scale-y: .95;\n  }\n  .sm\\:hover\\:scale-100:hover {\n    --transform-scale-x: 1;\n    --transform-scale-y: 1;\n  }\n  .sm\\:hover\\:scale-105:hover {\n    --transform-scale-x: 1.05;\n    --transform-scale-y: 1.05;\n  }\n  .sm\\:hover\\:scale-110:hover {\n    --transform-scale-x: 1.1;\n    --transform-scale-y: 1.1;\n  }\n  .sm\\:hover\\:scale-125:hover {\n    --transform-scale-x: 1.25;\n    --transform-scale-y: 1.25;\n  }\n  .sm\\:hover\\:scale-150:hover {\n    --transform-scale-x: 1.5;\n    --transform-scale-y: 1.5;\n  }\n  .sm\\:hover\\:scale-x-0:hover {\n    --transform-scale-x: 0;\n  }\n  .sm\\:hover\\:scale-x-50:hover {\n    --transform-scale-x: .5;\n  }\n  .sm\\:hover\\:scale-x-75:hover {\n    --transform-scale-x: .75;\n  }\n  .sm\\:hover\\:scale-x-90:hover {\n    --transform-scale-x: .9;\n  }\n  .sm\\:hover\\:scale-x-95:hover {\n    --transform-scale-x: .95;\n  }\n  .sm\\:hover\\:scale-x-100:hover {\n    --transform-scale-x: 1;\n  }\n  .sm\\:hover\\:scale-x-105:hover {\n    --transform-scale-x: 1.05;\n  }\n  .sm\\:hover\\:scale-x-110:hover {\n    --transform-scale-x: 1.1;\n  }\n  .sm\\:hover\\:scale-x-125:hover {\n    --transform-scale-x: 1.25;\n  }\n  .sm\\:hover\\:scale-x-150:hover {\n    --transform-scale-x: 1.5;\n  }\n  .sm\\:hover\\:scale-y-0:hover {\n    --transform-scale-y: 0;\n  }\n  .sm\\:hover\\:scale-y-50:hover {\n    --transform-scale-y: .5;\n  }\n  .sm\\:hover\\:scale-y-75:hover {\n    --transform-scale-y: .75;\n  }\n  .sm\\:hover\\:scale-y-90:hover {\n    --transform-scale-y: .9;\n  }\n  .sm\\:hover\\:scale-y-95:hover {\n    --transform-scale-y: .95;\n  }\n  .sm\\:hover\\:scale-y-100:hover {\n    --transform-scale-y: 1;\n  }\n  .sm\\:hover\\:scale-y-105:hover {\n    --transform-scale-y: 1.05;\n  }\n  .sm\\:hover\\:scale-y-110:hover {\n    --transform-scale-y: 1.1;\n  }\n  .sm\\:hover\\:scale-y-125:hover {\n    --transform-scale-y: 1.25;\n  }\n  .sm\\:hover\\:scale-y-150:hover {\n    --transform-scale-y: 1.5;\n  }\n  .sm\\:focus\\:scale-0:focus {\n    --transform-scale-x: 0;\n    --transform-scale-y: 0;\n  }\n  .sm\\:focus\\:scale-50:focus {\n    --transform-scale-x: .5;\n    --transform-scale-y: .5;\n  }\n  .sm\\:focus\\:scale-75:focus {\n    --transform-scale-x: .75;\n    --transform-scale-y: .75;\n  }\n  .sm\\:focus\\:scale-90:focus {\n    --transform-scale-x: .9;\n    --transform-scale-y: .9;\n  }\n  .sm\\:focus\\:scale-95:focus {\n    --transform-scale-x: .95;\n    --transform-scale-y: .95;\n  }\n  .sm\\:focus\\:scale-100:focus {\n    --transform-scale-x: 1;\n    --transform-scale-y: 1;\n  }\n  .sm\\:focus\\:scale-105:focus {\n    --transform-scale-x: 1.05;\n    --transform-scale-y: 1.05;\n  }\n  .sm\\:focus\\:scale-110:focus {\n    --transform-scale-x: 1.1;\n    --transform-scale-y: 1.1;\n  }\n  .sm\\:focus\\:scale-125:focus {\n    --transform-scale-x: 1.25;\n    --transform-scale-y: 1.25;\n  }\n  .sm\\:focus\\:scale-150:focus {\n    --transform-scale-x: 1.5;\n    --transform-scale-y: 1.5;\n  }\n  .sm\\:focus\\:scale-x-0:focus {\n    --transform-scale-x: 0;\n  }\n  .sm\\:focus\\:scale-x-50:focus {\n    --transform-scale-x: .5;\n  }\n  .sm\\:focus\\:scale-x-75:focus {\n    --transform-scale-x: .75;\n  }\n  .sm\\:focus\\:scale-x-90:focus {\n    --transform-scale-x: .9;\n  }\n  .sm\\:focus\\:scale-x-95:focus {\n    --transform-scale-x: .95;\n  }\n  .sm\\:focus\\:scale-x-100:focus {\n    --transform-scale-x: 1;\n  }\n  .sm\\:focus\\:scale-x-105:focus {\n    --transform-scale-x: 1.05;\n  }\n  .sm\\:focus\\:scale-x-110:focus {\n    --transform-scale-x: 1.1;\n  }\n  .sm\\:focus\\:scale-x-125:focus {\n    --transform-scale-x: 1.25;\n  }\n  .sm\\:focus\\:scale-x-150:focus {\n    --transform-scale-x: 1.5;\n  }\n  .sm\\:focus\\:scale-y-0:focus {\n    --transform-scale-y: 0;\n  }\n  .sm\\:focus\\:scale-y-50:focus {\n    --transform-scale-y: .5;\n  }\n  .sm\\:focus\\:scale-y-75:focus {\n    --transform-scale-y: .75;\n  }\n  .sm\\:focus\\:scale-y-90:focus {\n    --transform-scale-y: .9;\n  }\n  .sm\\:focus\\:scale-y-95:focus {\n    --transform-scale-y: .95;\n  }\n  .sm\\:focus\\:scale-y-100:focus {\n    --transform-scale-y: 1;\n  }\n  .sm\\:focus\\:scale-y-105:focus {\n    --transform-scale-y: 1.05;\n  }\n  .sm\\:focus\\:scale-y-110:focus {\n    --transform-scale-y: 1.1;\n  }\n  .sm\\:focus\\:scale-y-125:focus {\n    --transform-scale-y: 1.25;\n  }\n  .sm\\:focus\\:scale-y-150:focus {\n    --transform-scale-y: 1.5;\n  }\n  .sm\\:rotate-0 {\n    --transform-rotate: 0;\n  }\n  .sm\\:rotate-1 {\n    --transform-rotate: 1deg;\n  }\n  .sm\\:rotate-2 {\n    --transform-rotate: 2deg;\n  }\n  .sm\\:rotate-3 {\n    --transform-rotate: 3deg;\n  }\n  .sm\\:rotate-6 {\n    --transform-rotate: 6deg;\n  }\n  .sm\\:rotate-12 {\n    --transform-rotate: 12deg;\n  }\n  .sm\\:rotate-45 {\n    --transform-rotate: 45deg;\n  }\n  .sm\\:rotate-90 {\n    --transform-rotate: 90deg;\n  }\n  .sm\\:rotate-180 {\n    --transform-rotate: 180deg;\n  }\n  .sm\\:-rotate-180 {\n    --transform-rotate: -180deg;\n  }\n  .sm\\:-rotate-90 {\n    --transform-rotate: -90deg;\n  }\n  .sm\\:-rotate-45 {\n    --transform-rotate: -45deg;\n  }\n  .sm\\:-rotate-12 {\n    --transform-rotate: -12deg;\n  }\n  .sm\\:-rotate-6 {\n    --transform-rotate: -6deg;\n  }\n  .sm\\:-rotate-3 {\n    --transform-rotate: -3deg;\n  }\n  .sm\\:-rotate-2 {\n    --transform-rotate: -2deg;\n  }\n  .sm\\:-rotate-1 {\n    --transform-rotate: -1deg;\n  }\n  .sm\\:hover\\:rotate-0:hover {\n    --transform-rotate: 0;\n  }\n  .sm\\:hover\\:rotate-1:hover {\n    --transform-rotate: 1deg;\n  }\n  .sm\\:hover\\:rotate-2:hover {\n    --transform-rotate: 2deg;\n  }\n  .sm\\:hover\\:rotate-3:hover {\n    --transform-rotate: 3deg;\n  }\n  .sm\\:hover\\:rotate-6:hover {\n    --transform-rotate: 6deg;\n  }\n  .sm\\:hover\\:rotate-12:hover {\n    --transform-rotate: 12deg;\n  }\n  .sm\\:hover\\:rotate-45:hover {\n    --transform-rotate: 45deg;\n  }\n  .sm\\:hover\\:rotate-90:hover {\n    --transform-rotate: 90deg;\n  }\n  .sm\\:hover\\:rotate-180:hover {\n    --transform-rotate: 180deg;\n  }\n  .sm\\:hover\\:-rotate-180:hover {\n    --transform-rotate: -180deg;\n  }\n  .sm\\:hover\\:-rotate-90:hover {\n    --transform-rotate: -90deg;\n  }\n  .sm\\:hover\\:-rotate-45:hover {\n    --transform-rotate: -45deg;\n  }\n  .sm\\:hover\\:-rotate-12:hover {\n    --transform-rotate: -12deg;\n  }\n  .sm\\:hover\\:-rotate-6:hover {\n    --transform-rotate: -6deg;\n  }\n  .sm\\:hover\\:-rotate-3:hover {\n    --transform-rotate: -3deg;\n  }\n  .sm\\:hover\\:-rotate-2:hover {\n    --transform-rotate: -2deg;\n  }\n  .sm\\:hover\\:-rotate-1:hover {\n    --transform-rotate: -1deg;\n  }\n  .sm\\:focus\\:rotate-0:focus {\n    --transform-rotate: 0;\n  }\n  .sm\\:focus\\:rotate-1:focus {\n    --transform-rotate: 1deg;\n  }\n  .sm\\:focus\\:rotate-2:focus {\n    --transform-rotate: 2deg;\n  }\n  .sm\\:focus\\:rotate-3:focus {\n    --transform-rotate: 3deg;\n  }\n  .sm\\:focus\\:rotate-6:focus {\n    --transform-rotate: 6deg;\n  }\n  .sm\\:focus\\:rotate-12:focus {\n    --transform-rotate: 12deg;\n  }\n  .sm\\:focus\\:rotate-45:focus {\n    --transform-rotate: 45deg;\n  }\n  .sm\\:focus\\:rotate-90:focus {\n    --transform-rotate: 90deg;\n  }\n  .sm\\:focus\\:rotate-180:focus {\n    --transform-rotate: 180deg;\n  }\n  .sm\\:focus\\:-rotate-180:focus {\n    --transform-rotate: -180deg;\n  }\n  .sm\\:focus\\:-rotate-90:focus {\n    --transform-rotate: -90deg;\n  }\n  .sm\\:focus\\:-rotate-45:focus {\n    --transform-rotate: -45deg;\n  }\n  .sm\\:focus\\:-rotate-12:focus {\n    --transform-rotate: -12deg;\n  }\n  .sm\\:focus\\:-rotate-6:focus {\n    --transform-rotate: -6deg;\n  }\n  .sm\\:focus\\:-rotate-3:focus {\n    --transform-rotate: -3deg;\n  }\n  .sm\\:focus\\:-rotate-2:focus {\n    --transform-rotate: -2deg;\n  }\n  .sm\\:focus\\:-rotate-1:focus {\n    --transform-rotate: -1deg;\n  }\n  .sm\\:translate-x-0 {\n    --transform-translate-x: 0;\n  }\n  .sm\\:translate-x-1 {\n    --transform-translate-x: 0.25rem;\n  }\n  .sm\\:translate-x-2 {\n    --transform-translate-x: 0.5rem;\n  }\n  .sm\\:translate-x-3 {\n    --transform-translate-x: 0.75rem;\n  }\n  .sm\\:translate-x-4 {\n    --transform-translate-x: 1rem;\n  }\n  .sm\\:translate-x-5 {\n    --transform-translate-x: 1.25rem;\n  }\n  .sm\\:translate-x-6 {\n    --transform-translate-x: 1.5rem;\n  }\n  .sm\\:translate-x-7 {\n    --transform-translate-x: 1.75rem;\n  }\n  .sm\\:translate-x-8 {\n    --transform-translate-x: 2rem;\n  }\n  .sm\\:translate-x-9 {\n    --transform-translate-x: 2.25rem;\n  }\n  .sm\\:translate-x-10 {\n    --transform-translate-x: 2.5rem;\n  }\n  .sm\\:translate-x-11 {\n    --transform-translate-x: 2.75rem;\n  }\n  .sm\\:translate-x-12 {\n    --transform-translate-x: 3rem;\n  }\n  .sm\\:translate-x-13 {\n    --transform-translate-x: 3.25rem;\n  }\n  .sm\\:translate-x-14 {\n    --transform-translate-x: 3.5rem;\n  }\n  .sm\\:translate-x-15 {\n    --transform-translate-x: 3.75rem;\n  }\n  .sm\\:translate-x-16 {\n    --transform-translate-x: 4rem;\n  }\n  .sm\\:translate-x-20 {\n    --transform-translate-x: 5rem;\n  }\n  .sm\\:translate-x-24 {\n    --transform-translate-x: 6rem;\n  }\n  .sm\\:translate-x-28 {\n    --transform-translate-x: 7rem;\n  }\n  .sm\\:translate-x-32 {\n    --transform-translate-x: 8rem;\n  }\n  .sm\\:translate-x-36 {\n    --transform-translate-x: 9rem;\n  }\n  .sm\\:translate-x-40 {\n    --transform-translate-x: 10rem;\n  }\n  .sm\\:translate-x-44 {\n    --transform-translate-x: 11rem;\n  }\n  .sm\\:translate-x-48 {\n    --transform-translate-x: 12rem;\n  }\n  .sm\\:translate-x-52 {\n    --transform-translate-x: 13rem;\n  }\n  .sm\\:translate-x-56 {\n    --transform-translate-x: 14rem;\n  }\n  .sm\\:translate-x-60 {\n    --transform-translate-x: 15rem;\n  }\n  .sm\\:translate-x-64 {\n    --transform-translate-x: 16rem;\n  }\n  .sm\\:translate-x-72 {\n    --transform-translate-x: 18rem;\n  }\n  .sm\\:translate-x-80 {\n    --transform-translate-x: 20rem;\n  }\n  .sm\\:translate-x-96 {\n    --transform-translate-x: 24rem;\n  }\n  .sm\\:translate-x-px {\n    --transform-translate-x: 1px;\n  }\n  .sm\\:translate-x-0\\.5 {\n    --transform-translate-x: 0.125rem;\n  }\n  .sm\\:translate-x-1\\.5 {\n    --transform-translate-x: 0.375rem;\n  }\n  .sm\\:translate-x-2\\.5 {\n    --transform-translate-x: 0.625rem;\n  }\n  .sm\\:translate-x-3\\.5 {\n    --transform-translate-x: 0.875rem;\n  }\n  .sm\\:translate-x-1\\/2 {\n    --transform-translate-x: 50%;\n  }\n  .sm\\:translate-x-1\\/3 {\n    --transform-translate-x: 33.333333%;\n  }\n  .sm\\:translate-x-2\\/3 {\n    --transform-translate-x: 66.666667%;\n  }\n  .sm\\:translate-x-1\\/4 {\n    --transform-translate-x: 25%;\n  }\n  .sm\\:translate-x-2\\/4 {\n    --transform-translate-x: 50%;\n  }\n  .sm\\:translate-x-3\\/4 {\n    --transform-translate-x: 75%;\n  }\n  .sm\\:translate-x-1\\/5 {\n    --transform-translate-x: 20%;\n  }\n  .sm\\:translate-x-2\\/5 {\n    --transform-translate-x: 40%;\n  }\n  .sm\\:translate-x-3\\/5 {\n    --transform-translate-x: 60%;\n  }\n  .sm\\:translate-x-4\\/5 {\n    --transform-translate-x: 80%;\n  }\n  .sm\\:translate-x-1\\/6 {\n    --transform-translate-x: 16.666667%;\n  }\n  .sm\\:translate-x-2\\/6 {\n    --transform-translate-x: 33.333333%;\n  }\n  .sm\\:translate-x-3\\/6 {\n    --transform-translate-x: 50%;\n  }\n  .sm\\:translate-x-4\\/6 {\n    --transform-translate-x: 66.666667%;\n  }\n  .sm\\:translate-x-5\\/6 {\n    --transform-translate-x: 83.333333%;\n  }\n  .sm\\:translate-x-1\\/12 {\n    --transform-translate-x: 8.333333%;\n  }\n  .sm\\:translate-x-2\\/12 {\n    --transform-translate-x: 16.666667%;\n  }\n  .sm\\:translate-x-3\\/12 {\n    --transform-translate-x: 25%;\n  }\n  .sm\\:translate-x-4\\/12 {\n    --transform-translate-x: 33.333333%;\n  }\n  .sm\\:translate-x-5\\/12 {\n    --transform-translate-x: 41.666667%;\n  }\n  .sm\\:translate-x-6\\/12 {\n    --transform-translate-x: 50%;\n  }\n  .sm\\:translate-x-7\\/12 {\n    --transform-translate-x: 58.333333%;\n  }\n  .sm\\:translate-x-8\\/12 {\n    --transform-translate-x: 66.666667%;\n  }\n  .sm\\:translate-x-9\\/12 {\n    --transform-translate-x: 75%;\n  }\n  .sm\\:translate-x-10\\/12 {\n    --transform-translate-x: 83.333333%;\n  }\n  .sm\\:translate-x-11\\/12 {\n    --transform-translate-x: 91.666667%;\n  }\n  .sm\\:translate-x-full {\n    --transform-translate-x: 100%;\n  }\n  .sm\\:-translate-x-1 {\n    --transform-translate-x: -0.25rem;\n  }\n  .sm\\:-translate-x-2 {\n    --transform-translate-x: -0.5rem;\n  }\n  .sm\\:-translate-x-3 {\n    --transform-translate-x: -0.75rem;\n  }\n  .sm\\:-translate-x-4 {\n    --transform-translate-x: -1rem;\n  }\n  .sm\\:-translate-x-5 {\n    --transform-translate-x: -1.25rem;\n  }\n  .sm\\:-translate-x-6 {\n    --transform-translate-x: -1.5rem;\n  }\n  .sm\\:-translate-x-7 {\n    --transform-translate-x: -1.75rem;\n  }\n  .sm\\:-translate-x-8 {\n    --transform-translate-x: -2rem;\n  }\n  .sm\\:-translate-x-9 {\n    --transform-translate-x: -2.25rem;\n  }\n  .sm\\:-translate-x-10 {\n    --transform-translate-x: -2.5rem;\n  }\n  .sm\\:-translate-x-11 {\n    --transform-translate-x: -2.75rem;\n  }\n  .sm\\:-translate-x-12 {\n    --transform-translate-x: -3rem;\n  }\n  .sm\\:-translate-x-13 {\n    --transform-translate-x: -3.25rem;\n  }\n  .sm\\:-translate-x-14 {\n    --transform-translate-x: -3.5rem;\n  }\n  .sm\\:-translate-x-15 {\n    --transform-translate-x: -3.75rem;\n  }\n  .sm\\:-translate-x-16 {\n    --transform-translate-x: -4rem;\n  }\n  .sm\\:-translate-x-20 {\n    --transform-translate-x: -5rem;\n  }\n  .sm\\:-translate-x-24 {\n    --transform-translate-x: -6rem;\n  }\n  .sm\\:-translate-x-28 {\n    --transform-translate-x: -7rem;\n  }\n  .sm\\:-translate-x-32 {\n    --transform-translate-x: -8rem;\n  }\n  .sm\\:-translate-x-36 {\n    --transform-translate-x: -9rem;\n  }\n  .sm\\:-translate-x-40 {\n    --transform-translate-x: -10rem;\n  }\n  .sm\\:-translate-x-44 {\n    --transform-translate-x: -11rem;\n  }\n  .sm\\:-translate-x-48 {\n    --transform-translate-x: -12rem;\n  }\n  .sm\\:-translate-x-52 {\n    --transform-translate-x: -13rem;\n  }\n  .sm\\:-translate-x-56 {\n    --transform-translate-x: -14rem;\n  }\n  .sm\\:-translate-x-60 {\n    --transform-translate-x: -15rem;\n  }\n  .sm\\:-translate-x-64 {\n    --transform-translate-x: -16rem;\n  }\n  .sm\\:-translate-x-72 {\n    --transform-translate-x: -18rem;\n  }\n  .sm\\:-translate-x-80 {\n    --transform-translate-x: -20rem;\n  }\n  .sm\\:-translate-x-96 {\n    --transform-translate-x: -24rem;\n  }\n  .sm\\:-translate-x-px {\n    --transform-translate-x: -1px;\n  }\n  .sm\\:-translate-x-0\\.5 {\n    --transform-translate-x: -0.125rem;\n  }\n  .sm\\:-translate-x-1\\.5 {\n    --transform-translate-x: -0.375rem;\n  }\n  .sm\\:-translate-x-2\\.5 {\n    --transform-translate-x: -0.625rem;\n  }\n  .sm\\:-translate-x-3\\.5 {\n    --transform-translate-x: -0.875rem;\n  }\n  .sm\\:-translate-x-1\\/2 {\n    --transform-translate-x: -50%;\n  }\n  .sm\\:-translate-x-1\\/3 {\n    --transform-translate-x: -33.33333%;\n  }\n  .sm\\:-translate-x-2\\/3 {\n    --transform-translate-x: -66.66667%;\n  }\n  .sm\\:-translate-x-1\\/4 {\n    --transform-translate-x: -25%;\n  }\n  .sm\\:-translate-x-2\\/4 {\n    --transform-translate-x: -50%;\n  }\n  .sm\\:-translate-x-3\\/4 {\n    --transform-translate-x: -75%;\n  }\n  .sm\\:-translate-x-1\\/5 {\n    --transform-translate-x: -20%;\n  }\n  .sm\\:-translate-x-2\\/5 {\n    --transform-translate-x: -40%;\n  }\n  .sm\\:-translate-x-3\\/5 {\n    --transform-translate-x: -60%;\n  }\n  .sm\\:-translate-x-4\\/5 {\n    --transform-translate-x: -80%;\n  }\n  .sm\\:-translate-x-1\\/6 {\n    --transform-translate-x: -16.66667%;\n  }\n  .sm\\:-translate-x-2\\/6 {\n    --transform-translate-x: -33.33333%;\n  }\n  .sm\\:-translate-x-3\\/6 {\n    --transform-translate-x: -50%;\n  }\n  .sm\\:-translate-x-4\\/6 {\n    --transform-translate-x: -66.66667%;\n  }\n  .sm\\:-translate-x-5\\/6 {\n    --transform-translate-x: -83.33333%;\n  }\n  .sm\\:-translate-x-1\\/12 {\n    --transform-translate-x: -8.33333%;\n  }\n  .sm\\:-translate-x-2\\/12 {\n    --transform-translate-x: -16.66667%;\n  }\n  .sm\\:-translate-x-3\\/12 {\n    --transform-translate-x: -25%;\n  }\n  .sm\\:-translate-x-4\\/12 {\n    --transform-translate-x: -33.33333%;\n  }\n  .sm\\:-translate-x-5\\/12 {\n    --transform-translate-x: -41.66667%;\n  }\n  .sm\\:-translate-x-6\\/12 {\n    --transform-translate-x: -50%;\n  }\n  .sm\\:-translate-x-7\\/12 {\n    --transform-translate-x: -58.33333%;\n  }\n  .sm\\:-translate-x-8\\/12 {\n    --transform-translate-x: -66.66667%;\n  }\n  .sm\\:-translate-x-9\\/12 {\n    --transform-translate-x: -75%;\n  }\n  .sm\\:-translate-x-10\\/12 {\n    --transform-translate-x: -83.33333%;\n  }\n  .sm\\:-translate-x-11\\/12 {\n    --transform-translate-x: -91.66667%;\n  }\n  .sm\\:-translate-x-full {\n    --transform-translate-x: -100%;\n  }\n  .sm\\:translate-y-0 {\n    --transform-translate-y: 0;\n  }\n  .sm\\:translate-y-1 {\n    --transform-translate-y: 0.25rem;\n  }\n  .sm\\:translate-y-2 {\n    --transform-translate-y: 0.5rem;\n  }\n  .sm\\:translate-y-3 {\n    --transform-translate-y: 0.75rem;\n  }\n  .sm\\:translate-y-4 {\n    --transform-translate-y: 1rem;\n  }\n  .sm\\:translate-y-5 {\n    --transform-translate-y: 1.25rem;\n  }\n  .sm\\:translate-y-6 {\n    --transform-translate-y: 1.5rem;\n  }\n  .sm\\:translate-y-7 {\n    --transform-translate-y: 1.75rem;\n  }\n  .sm\\:translate-y-8 {\n    --transform-translate-y: 2rem;\n  }\n  .sm\\:translate-y-9 {\n    --transform-translate-y: 2.25rem;\n  }\n  .sm\\:translate-y-10 {\n    --transform-translate-y: 2.5rem;\n  }\n  .sm\\:translate-y-11 {\n    --transform-translate-y: 2.75rem;\n  }\n  .sm\\:translate-y-12 {\n    --transform-translate-y: 3rem;\n  }\n  .sm\\:translate-y-13 {\n    --transform-translate-y: 3.25rem;\n  }\n  .sm\\:translate-y-14 {\n    --transform-translate-y: 3.5rem;\n  }\n  .sm\\:translate-y-15 {\n    --transform-translate-y: 3.75rem;\n  }\n  .sm\\:translate-y-16 {\n    --transform-translate-y: 4rem;\n  }\n  .sm\\:translate-y-20 {\n    --transform-translate-y: 5rem;\n  }\n  .sm\\:translate-y-24 {\n    --transform-translate-y: 6rem;\n  }\n  .sm\\:translate-y-28 {\n    --transform-translate-y: 7rem;\n  }\n  .sm\\:translate-y-32 {\n    --transform-translate-y: 8rem;\n  }\n  .sm\\:translate-y-36 {\n    --transform-translate-y: 9rem;\n  }\n  .sm\\:translate-y-40 {\n    --transform-translate-y: 10rem;\n  }\n  .sm\\:translate-y-44 {\n    --transform-translate-y: 11rem;\n  }\n  .sm\\:translate-y-48 {\n    --transform-translate-y: 12rem;\n  }\n  .sm\\:translate-y-52 {\n    --transform-translate-y: 13rem;\n  }\n  .sm\\:translate-y-56 {\n    --transform-translate-y: 14rem;\n  }\n  .sm\\:translate-y-60 {\n    --transform-translate-y: 15rem;\n  }\n  .sm\\:translate-y-64 {\n    --transform-translate-y: 16rem;\n  }\n  .sm\\:translate-y-72 {\n    --transform-translate-y: 18rem;\n  }\n  .sm\\:translate-y-80 {\n    --transform-translate-y: 20rem;\n  }\n  .sm\\:translate-y-96 {\n    --transform-translate-y: 24rem;\n  }\n  .sm\\:translate-y-px {\n    --transform-translate-y: 1px;\n  }\n  .sm\\:translate-y-0\\.5 {\n    --transform-translate-y: 0.125rem;\n  }\n  .sm\\:translate-y-1\\.5 {\n    --transform-translate-y: 0.375rem;\n  }\n  .sm\\:translate-y-2\\.5 {\n    --transform-translate-y: 0.625rem;\n  }\n  .sm\\:translate-y-3\\.5 {\n    --transform-translate-y: 0.875rem;\n  }\n  .sm\\:translate-y-1\\/2 {\n    --transform-translate-y: 50%;\n  }\n  .sm\\:translate-y-1\\/3 {\n    --transform-translate-y: 33.333333%;\n  }\n  .sm\\:translate-y-2\\/3 {\n    --transform-translate-y: 66.666667%;\n  }\n  .sm\\:translate-y-1\\/4 {\n    --transform-translate-y: 25%;\n  }\n  .sm\\:translate-y-2\\/4 {\n    --transform-translate-y: 50%;\n  }\n  .sm\\:translate-y-3\\/4 {\n    --transform-translate-y: 75%;\n  }\n  .sm\\:translate-y-1\\/5 {\n    --transform-translate-y: 20%;\n  }\n  .sm\\:translate-y-2\\/5 {\n    --transform-translate-y: 40%;\n  }\n  .sm\\:translate-y-3\\/5 {\n    --transform-translate-y: 60%;\n  }\n  .sm\\:translate-y-4\\/5 {\n    --transform-translate-y: 80%;\n  }\n  .sm\\:translate-y-1\\/6 {\n    --transform-translate-y: 16.666667%;\n  }\n  .sm\\:translate-y-2\\/6 {\n    --transform-translate-y: 33.333333%;\n  }\n  .sm\\:translate-y-3\\/6 {\n    --transform-translate-y: 50%;\n  }\n  .sm\\:translate-y-4\\/6 {\n    --transform-translate-y: 66.666667%;\n  }\n  .sm\\:translate-y-5\\/6 {\n    --transform-translate-y: 83.333333%;\n  }\n  .sm\\:translate-y-1\\/12 {\n    --transform-translate-y: 8.333333%;\n  }\n  .sm\\:translate-y-2\\/12 {\n    --transform-translate-y: 16.666667%;\n  }\n  .sm\\:translate-y-3\\/12 {\n    --transform-translate-y: 25%;\n  }\n  .sm\\:translate-y-4\\/12 {\n    --transform-translate-y: 33.333333%;\n  }\n  .sm\\:translate-y-5\\/12 {\n    --transform-translate-y: 41.666667%;\n  }\n  .sm\\:translate-y-6\\/12 {\n    --transform-translate-y: 50%;\n  }\n  .sm\\:translate-y-7\\/12 {\n    --transform-translate-y: 58.333333%;\n  }\n  .sm\\:translate-y-8\\/12 {\n    --transform-translate-y: 66.666667%;\n  }\n  .sm\\:translate-y-9\\/12 {\n    --transform-translate-y: 75%;\n  }\n  .sm\\:translate-y-10\\/12 {\n    --transform-translate-y: 83.333333%;\n  }\n  .sm\\:translate-y-11\\/12 {\n    --transform-translate-y: 91.666667%;\n  }\n  .sm\\:translate-y-full {\n    --transform-translate-y: 100%;\n  }\n  .sm\\:-translate-y-1 {\n    --transform-translate-y: -0.25rem;\n  }\n  .sm\\:-translate-y-2 {\n    --transform-translate-y: -0.5rem;\n  }\n  .sm\\:-translate-y-3 {\n    --transform-translate-y: -0.75rem;\n  }\n  .sm\\:-translate-y-4 {\n    --transform-translate-y: -1rem;\n  }\n  .sm\\:-translate-y-5 {\n    --transform-translate-y: -1.25rem;\n  }\n  .sm\\:-translate-y-6 {\n    --transform-translate-y: -1.5rem;\n  }\n  .sm\\:-translate-y-7 {\n    --transform-translate-y: -1.75rem;\n  }\n  .sm\\:-translate-y-8 {\n    --transform-translate-y: -2rem;\n  }\n  .sm\\:-translate-y-9 {\n    --transform-translate-y: -2.25rem;\n  }\n  .sm\\:-translate-y-10 {\n    --transform-translate-y: -2.5rem;\n  }\n  .sm\\:-translate-y-11 {\n    --transform-translate-y: -2.75rem;\n  }\n  .sm\\:-translate-y-12 {\n    --transform-translate-y: -3rem;\n  }\n  .sm\\:-translate-y-13 {\n    --transform-translate-y: -3.25rem;\n  }\n  .sm\\:-translate-y-14 {\n    --transform-translate-y: -3.5rem;\n  }\n  .sm\\:-translate-y-15 {\n    --transform-translate-y: -3.75rem;\n  }\n  .sm\\:-translate-y-16 {\n    --transform-translate-y: -4rem;\n  }\n  .sm\\:-translate-y-20 {\n    --transform-translate-y: -5rem;\n  }\n  .sm\\:-translate-y-24 {\n    --transform-translate-y: -6rem;\n  }\n  .sm\\:-translate-y-28 {\n    --transform-translate-y: -7rem;\n  }\n  .sm\\:-translate-y-32 {\n    --transform-translate-y: -8rem;\n  }\n  .sm\\:-translate-y-36 {\n    --transform-translate-y: -9rem;\n  }\n  .sm\\:-translate-y-40 {\n    --transform-translate-y: -10rem;\n  }\n  .sm\\:-translate-y-44 {\n    --transform-translate-y: -11rem;\n  }\n  .sm\\:-translate-y-48 {\n    --transform-translate-y: -12rem;\n  }\n  .sm\\:-translate-y-52 {\n    --transform-translate-y: -13rem;\n  }\n  .sm\\:-translate-y-56 {\n    --transform-translate-y: -14rem;\n  }\n  .sm\\:-translate-y-60 {\n    --transform-translate-y: -15rem;\n  }\n  .sm\\:-translate-y-64 {\n    --transform-translate-y: -16rem;\n  }\n  .sm\\:-translate-y-72 {\n    --transform-translate-y: -18rem;\n  }\n  .sm\\:-translate-y-80 {\n    --transform-translate-y: -20rem;\n  }\n  .sm\\:-translate-y-96 {\n    --transform-translate-y: -24rem;\n  }\n  .sm\\:-translate-y-px {\n    --transform-translate-y: -1px;\n  }\n  .sm\\:-translate-y-0\\.5 {\n    --transform-translate-y: -0.125rem;\n  }\n  .sm\\:-translate-y-1\\.5 {\n    --transform-translate-y: -0.375rem;\n  }\n  .sm\\:-translate-y-2\\.5 {\n    --transform-translate-y: -0.625rem;\n  }\n  .sm\\:-translate-y-3\\.5 {\n    --transform-translate-y: -0.875rem;\n  }\n  .sm\\:-translate-y-1\\/2 {\n    --transform-translate-y: -50%;\n  }\n  .sm\\:-translate-y-1\\/3 {\n    --transform-translate-y: -33.33333%;\n  }\n  .sm\\:-translate-y-2\\/3 {\n    --transform-translate-y: -66.66667%;\n  }\n  .sm\\:-translate-y-1\\/4 {\n    --transform-translate-y: -25%;\n  }\n  .sm\\:-translate-y-2\\/4 {\n    --transform-translate-y: -50%;\n  }\n  .sm\\:-translate-y-3\\/4 {\n    --transform-translate-y: -75%;\n  }\n  .sm\\:-translate-y-1\\/5 {\n    --transform-translate-y: -20%;\n  }\n  .sm\\:-translate-y-2\\/5 {\n    --transform-translate-y: -40%;\n  }\n  .sm\\:-translate-y-3\\/5 {\n    --transform-translate-y: -60%;\n  }\n  .sm\\:-translate-y-4\\/5 {\n    --transform-translate-y: -80%;\n  }\n  .sm\\:-translate-y-1\\/6 {\n    --transform-translate-y: -16.66667%;\n  }\n  .sm\\:-translate-y-2\\/6 {\n    --transform-translate-y: -33.33333%;\n  }\n  .sm\\:-translate-y-3\\/6 {\n    --transform-translate-y: -50%;\n  }\n  .sm\\:-translate-y-4\\/6 {\n    --transform-translate-y: -66.66667%;\n  }\n  .sm\\:-translate-y-5\\/6 {\n    --transform-translate-y: -83.33333%;\n  }\n  .sm\\:-translate-y-1\\/12 {\n    --transform-translate-y: -8.33333%;\n  }\n  .sm\\:-translate-y-2\\/12 {\n    --transform-translate-y: -16.66667%;\n  }\n  .sm\\:-translate-y-3\\/12 {\n    --transform-translate-y: -25%;\n  }\n  .sm\\:-translate-y-4\\/12 {\n    --transform-translate-y: -33.33333%;\n  }\n  .sm\\:-translate-y-5\\/12 {\n    --transform-translate-y: -41.66667%;\n  }\n  .sm\\:-translate-y-6\\/12 {\n    --transform-translate-y: -50%;\n  }\n  .sm\\:-translate-y-7\\/12 {\n    --transform-translate-y: -58.33333%;\n  }\n  .sm\\:-translate-y-8\\/12 {\n    --transform-translate-y: -66.66667%;\n  }\n  .sm\\:-translate-y-9\\/12 {\n    --transform-translate-y: -75%;\n  }\n  .sm\\:-translate-y-10\\/12 {\n    --transform-translate-y: -83.33333%;\n  }\n  .sm\\:-translate-y-11\\/12 {\n    --transform-translate-y: -91.66667%;\n  }\n  .sm\\:-translate-y-full {\n    --transform-translate-y: -100%;\n  }\n  .sm\\:hover\\:translate-x-0:hover {\n    --transform-translate-x: 0;\n  }\n  .sm\\:hover\\:translate-x-1:hover {\n    --transform-translate-x: 0.25rem;\n  }\n  .sm\\:hover\\:translate-x-2:hover {\n    --transform-translate-x: 0.5rem;\n  }\n  .sm\\:hover\\:translate-x-3:hover {\n    --transform-translate-x: 0.75rem;\n  }\n  .sm\\:hover\\:translate-x-4:hover {\n    --transform-translate-x: 1rem;\n  }\n  .sm\\:hover\\:translate-x-5:hover {\n    --transform-translate-x: 1.25rem;\n  }\n  .sm\\:hover\\:translate-x-6:hover {\n    --transform-translate-x: 1.5rem;\n  }\n  .sm\\:hover\\:translate-x-7:hover {\n    --transform-translate-x: 1.75rem;\n  }\n  .sm\\:hover\\:translate-x-8:hover {\n    --transform-translate-x: 2rem;\n  }\n  .sm\\:hover\\:translate-x-9:hover {\n    --transform-translate-x: 2.25rem;\n  }\n  .sm\\:hover\\:translate-x-10:hover {\n    --transform-translate-x: 2.5rem;\n  }\n  .sm\\:hover\\:translate-x-11:hover {\n    --transform-translate-x: 2.75rem;\n  }\n  .sm\\:hover\\:translate-x-12:hover {\n    --transform-translate-x: 3rem;\n  }\n  .sm\\:hover\\:translate-x-13:hover {\n    --transform-translate-x: 3.25rem;\n  }\n  .sm\\:hover\\:translate-x-14:hover {\n    --transform-translate-x: 3.5rem;\n  }\n  .sm\\:hover\\:translate-x-15:hover {\n    --transform-translate-x: 3.75rem;\n  }\n  .sm\\:hover\\:translate-x-16:hover {\n    --transform-translate-x: 4rem;\n  }\n  .sm\\:hover\\:translate-x-20:hover {\n    --transform-translate-x: 5rem;\n  }\n  .sm\\:hover\\:translate-x-24:hover {\n    --transform-translate-x: 6rem;\n  }\n  .sm\\:hover\\:translate-x-28:hover {\n    --transform-translate-x: 7rem;\n  }\n  .sm\\:hover\\:translate-x-32:hover {\n    --transform-translate-x: 8rem;\n  }\n  .sm\\:hover\\:translate-x-36:hover {\n    --transform-translate-x: 9rem;\n  }\n  .sm\\:hover\\:translate-x-40:hover {\n    --transform-translate-x: 10rem;\n  }\n  .sm\\:hover\\:translate-x-44:hover {\n    --transform-translate-x: 11rem;\n  }\n  .sm\\:hover\\:translate-x-48:hover {\n    --transform-translate-x: 12rem;\n  }\n  .sm\\:hover\\:translate-x-52:hover {\n    --transform-translate-x: 13rem;\n  }\n  .sm\\:hover\\:translate-x-56:hover {\n    --transform-translate-x: 14rem;\n  }\n  .sm\\:hover\\:translate-x-60:hover {\n    --transform-translate-x: 15rem;\n  }\n  .sm\\:hover\\:translate-x-64:hover {\n    --transform-translate-x: 16rem;\n  }\n  .sm\\:hover\\:translate-x-72:hover {\n    --transform-translate-x: 18rem;\n  }\n  .sm\\:hover\\:translate-x-80:hover {\n    --transform-translate-x: 20rem;\n  }\n  .sm\\:hover\\:translate-x-96:hover {\n    --transform-translate-x: 24rem;\n  }\n  .sm\\:hover\\:translate-x-px:hover {\n    --transform-translate-x: 1px;\n  }\n  .sm\\:hover\\:translate-x-0\\.5:hover {\n    --transform-translate-x: 0.125rem;\n  }\n  .sm\\:hover\\:translate-x-1\\.5:hover {\n    --transform-translate-x: 0.375rem;\n  }\n  .sm\\:hover\\:translate-x-2\\.5:hover {\n    --transform-translate-x: 0.625rem;\n  }\n  .sm\\:hover\\:translate-x-3\\.5:hover {\n    --transform-translate-x: 0.875rem;\n  }\n  .sm\\:hover\\:translate-x-1\\/2:hover {\n    --transform-translate-x: 50%;\n  }\n  .sm\\:hover\\:translate-x-1\\/3:hover {\n    --transform-translate-x: 33.333333%;\n  }\n  .sm\\:hover\\:translate-x-2\\/3:hover {\n    --transform-translate-x: 66.666667%;\n  }\n  .sm\\:hover\\:translate-x-1\\/4:hover {\n    --transform-translate-x: 25%;\n  }\n  .sm\\:hover\\:translate-x-2\\/4:hover {\n    --transform-translate-x: 50%;\n  }\n  .sm\\:hover\\:translate-x-3\\/4:hover {\n    --transform-translate-x: 75%;\n  }\n  .sm\\:hover\\:translate-x-1\\/5:hover {\n    --transform-translate-x: 20%;\n  }\n  .sm\\:hover\\:translate-x-2\\/5:hover {\n    --transform-translate-x: 40%;\n  }\n  .sm\\:hover\\:translate-x-3\\/5:hover {\n    --transform-translate-x: 60%;\n  }\n  .sm\\:hover\\:translate-x-4\\/5:hover {\n    --transform-translate-x: 80%;\n  }\n  .sm\\:hover\\:translate-x-1\\/6:hover {\n    --transform-translate-x: 16.666667%;\n  }\n  .sm\\:hover\\:translate-x-2\\/6:hover {\n    --transform-translate-x: 33.333333%;\n  }\n  .sm\\:hover\\:translate-x-3\\/6:hover {\n    --transform-translate-x: 50%;\n  }\n  .sm\\:hover\\:translate-x-4\\/6:hover {\n    --transform-translate-x: 66.666667%;\n  }\n  .sm\\:hover\\:translate-x-5\\/6:hover {\n    --transform-translate-x: 83.333333%;\n  }\n  .sm\\:hover\\:translate-x-1\\/12:hover {\n    --transform-translate-x: 8.333333%;\n  }\n  .sm\\:hover\\:translate-x-2\\/12:hover {\n    --transform-translate-x: 16.666667%;\n  }\n  .sm\\:hover\\:translate-x-3\\/12:hover {\n    --transform-translate-x: 25%;\n  }\n  .sm\\:hover\\:translate-x-4\\/12:hover {\n    --transform-translate-x: 33.333333%;\n  }\n  .sm\\:hover\\:translate-x-5\\/12:hover {\n    --transform-translate-x: 41.666667%;\n  }\n  .sm\\:hover\\:translate-x-6\\/12:hover {\n    --transform-translate-x: 50%;\n  }\n  .sm\\:hover\\:translate-x-7\\/12:hover {\n    --transform-translate-x: 58.333333%;\n  }\n  .sm\\:hover\\:translate-x-8\\/12:hover {\n    --transform-translate-x: 66.666667%;\n  }\n  .sm\\:hover\\:translate-x-9\\/12:hover {\n    --transform-translate-x: 75%;\n  }\n  .sm\\:hover\\:translate-x-10\\/12:hover {\n    --transform-translate-x: 83.333333%;\n  }\n  .sm\\:hover\\:translate-x-11\\/12:hover {\n    --transform-translate-x: 91.666667%;\n  }\n  .sm\\:hover\\:translate-x-full:hover {\n    --transform-translate-x: 100%;\n  }\n  .sm\\:hover\\:-translate-x-1:hover {\n    --transform-translate-x: -0.25rem;\n  }\n  .sm\\:hover\\:-translate-x-2:hover {\n    --transform-translate-x: -0.5rem;\n  }\n  .sm\\:hover\\:-translate-x-3:hover {\n    --transform-translate-x: -0.75rem;\n  }\n  .sm\\:hover\\:-translate-x-4:hover {\n    --transform-translate-x: -1rem;\n  }\n  .sm\\:hover\\:-translate-x-5:hover {\n    --transform-translate-x: -1.25rem;\n  }\n  .sm\\:hover\\:-translate-x-6:hover {\n    --transform-translate-x: -1.5rem;\n  }\n  .sm\\:hover\\:-translate-x-7:hover {\n    --transform-translate-x: -1.75rem;\n  }\n  .sm\\:hover\\:-translate-x-8:hover {\n    --transform-translate-x: -2rem;\n  }\n  .sm\\:hover\\:-translate-x-9:hover {\n    --transform-translate-x: -2.25rem;\n  }\n  .sm\\:hover\\:-translate-x-10:hover {\n    --transform-translate-x: -2.5rem;\n  }\n  .sm\\:hover\\:-translate-x-11:hover {\n    --transform-translate-x: -2.75rem;\n  }\n  .sm\\:hover\\:-translate-x-12:hover {\n    --transform-translate-x: -3rem;\n  }\n  .sm\\:hover\\:-translate-x-13:hover {\n    --transform-translate-x: -3.25rem;\n  }\n  .sm\\:hover\\:-translate-x-14:hover {\n    --transform-translate-x: -3.5rem;\n  }\n  .sm\\:hover\\:-translate-x-15:hover {\n    --transform-translate-x: -3.75rem;\n  }\n  .sm\\:hover\\:-translate-x-16:hover {\n    --transform-translate-x: -4rem;\n  }\n  .sm\\:hover\\:-translate-x-20:hover {\n    --transform-translate-x: -5rem;\n  }\n  .sm\\:hover\\:-translate-x-24:hover {\n    --transform-translate-x: -6rem;\n  }\n  .sm\\:hover\\:-translate-x-28:hover {\n    --transform-translate-x: -7rem;\n  }\n  .sm\\:hover\\:-translate-x-32:hover {\n    --transform-translate-x: -8rem;\n  }\n  .sm\\:hover\\:-translate-x-36:hover {\n    --transform-translate-x: -9rem;\n  }\n  .sm\\:hover\\:-translate-x-40:hover {\n    --transform-translate-x: -10rem;\n  }\n  .sm\\:hover\\:-translate-x-44:hover {\n    --transform-translate-x: -11rem;\n  }\n  .sm\\:hover\\:-translate-x-48:hover {\n    --transform-translate-x: -12rem;\n  }\n  .sm\\:hover\\:-translate-x-52:hover {\n    --transform-translate-x: -13rem;\n  }\n  .sm\\:hover\\:-translate-x-56:hover {\n    --transform-translate-x: -14rem;\n  }\n  .sm\\:hover\\:-translate-x-60:hover {\n    --transform-translate-x: -15rem;\n  }\n  .sm\\:hover\\:-translate-x-64:hover {\n    --transform-translate-x: -16rem;\n  }\n  .sm\\:hover\\:-translate-x-72:hover {\n    --transform-translate-x: -18rem;\n  }\n  .sm\\:hover\\:-translate-x-80:hover {\n    --transform-translate-x: -20rem;\n  }\n  .sm\\:hover\\:-translate-x-96:hover {\n    --transform-translate-x: -24rem;\n  }\n  .sm\\:hover\\:-translate-x-px:hover {\n    --transform-translate-x: -1px;\n  }\n  .sm\\:hover\\:-translate-x-0\\.5:hover {\n    --transform-translate-x: -0.125rem;\n  }\n  .sm\\:hover\\:-translate-x-1\\.5:hover {\n    --transform-translate-x: -0.375rem;\n  }\n  .sm\\:hover\\:-translate-x-2\\.5:hover {\n    --transform-translate-x: -0.625rem;\n  }\n  .sm\\:hover\\:-translate-x-3\\.5:hover {\n    --transform-translate-x: -0.875rem;\n  }\n  .sm\\:hover\\:-translate-x-1\\/2:hover {\n    --transform-translate-x: -50%;\n  }\n  .sm\\:hover\\:-translate-x-1\\/3:hover {\n    --transform-translate-x: -33.33333%;\n  }\n  .sm\\:hover\\:-translate-x-2\\/3:hover {\n    --transform-translate-x: -66.66667%;\n  }\n  .sm\\:hover\\:-translate-x-1\\/4:hover {\n    --transform-translate-x: -25%;\n  }\n  .sm\\:hover\\:-translate-x-2\\/4:hover {\n    --transform-translate-x: -50%;\n  }\n  .sm\\:hover\\:-translate-x-3\\/4:hover {\n    --transform-translate-x: -75%;\n  }\n  .sm\\:hover\\:-translate-x-1\\/5:hover {\n    --transform-translate-x: -20%;\n  }\n  .sm\\:hover\\:-translate-x-2\\/5:hover {\n    --transform-translate-x: -40%;\n  }\n  .sm\\:hover\\:-translate-x-3\\/5:hover {\n    --transform-translate-x: -60%;\n  }\n  .sm\\:hover\\:-translate-x-4\\/5:hover {\n    --transform-translate-x: -80%;\n  }\n  .sm\\:hover\\:-translate-x-1\\/6:hover {\n    --transform-translate-x: -16.66667%;\n  }\n  .sm\\:hover\\:-translate-x-2\\/6:hover {\n    --transform-translate-x: -33.33333%;\n  }\n  .sm\\:hover\\:-translate-x-3\\/6:hover {\n    --transform-translate-x: -50%;\n  }\n  .sm\\:hover\\:-translate-x-4\\/6:hover {\n    --transform-translate-x: -66.66667%;\n  }\n  .sm\\:hover\\:-translate-x-5\\/6:hover {\n    --transform-translate-x: -83.33333%;\n  }\n  .sm\\:hover\\:-translate-x-1\\/12:hover {\n    --transform-translate-x: -8.33333%;\n  }\n  .sm\\:hover\\:-translate-x-2\\/12:hover {\n    --transform-translate-x: -16.66667%;\n  }\n  .sm\\:hover\\:-translate-x-3\\/12:hover {\n    --transform-translate-x: -25%;\n  }\n  .sm\\:hover\\:-translate-x-4\\/12:hover {\n    --transform-translate-x: -33.33333%;\n  }\n  .sm\\:hover\\:-translate-x-5\\/12:hover {\n    --transform-translate-x: -41.66667%;\n  }\n  .sm\\:hover\\:-translate-x-6\\/12:hover {\n    --transform-translate-x: -50%;\n  }\n  .sm\\:hover\\:-translate-x-7\\/12:hover {\n    --transform-translate-x: -58.33333%;\n  }\n  .sm\\:hover\\:-translate-x-8\\/12:hover {\n    --transform-translate-x: -66.66667%;\n  }\n  .sm\\:hover\\:-translate-x-9\\/12:hover {\n    --transform-translate-x: -75%;\n  }\n  .sm\\:hover\\:-translate-x-10\\/12:hover {\n    --transform-translate-x: -83.33333%;\n  }\n  .sm\\:hover\\:-translate-x-11\\/12:hover {\n    --transform-translate-x: -91.66667%;\n  }\n  .sm\\:hover\\:-translate-x-full:hover {\n    --transform-translate-x: -100%;\n  }\n  .sm\\:hover\\:translate-y-0:hover {\n    --transform-translate-y: 0;\n  }\n  .sm\\:hover\\:translate-y-1:hover {\n    --transform-translate-y: 0.25rem;\n  }\n  .sm\\:hover\\:translate-y-2:hover {\n    --transform-translate-y: 0.5rem;\n  }\n  .sm\\:hover\\:translate-y-3:hover {\n    --transform-translate-y: 0.75rem;\n  }\n  .sm\\:hover\\:translate-y-4:hover {\n    --transform-translate-y: 1rem;\n  }\n  .sm\\:hover\\:translate-y-5:hover {\n    --transform-translate-y: 1.25rem;\n  }\n  .sm\\:hover\\:translate-y-6:hover {\n    --transform-translate-y: 1.5rem;\n  }\n  .sm\\:hover\\:translate-y-7:hover {\n    --transform-translate-y: 1.75rem;\n  }\n  .sm\\:hover\\:translate-y-8:hover {\n    --transform-translate-y: 2rem;\n  }\n  .sm\\:hover\\:translate-y-9:hover {\n    --transform-translate-y: 2.25rem;\n  }\n  .sm\\:hover\\:translate-y-10:hover {\n    --transform-translate-y: 2.5rem;\n  }\n  .sm\\:hover\\:translate-y-11:hover {\n    --transform-translate-y: 2.75rem;\n  }\n  .sm\\:hover\\:translate-y-12:hover {\n    --transform-translate-y: 3rem;\n  }\n  .sm\\:hover\\:translate-y-13:hover {\n    --transform-translate-y: 3.25rem;\n  }\n  .sm\\:hover\\:translate-y-14:hover {\n    --transform-translate-y: 3.5rem;\n  }\n  .sm\\:hover\\:translate-y-15:hover {\n    --transform-translate-y: 3.75rem;\n  }\n  .sm\\:hover\\:translate-y-16:hover {\n    --transform-translate-y: 4rem;\n  }\n  .sm\\:hover\\:translate-y-20:hover {\n    --transform-translate-y: 5rem;\n  }\n  .sm\\:hover\\:translate-y-24:hover {\n    --transform-translate-y: 6rem;\n  }\n  .sm\\:hover\\:translate-y-28:hover {\n    --transform-translate-y: 7rem;\n  }\n  .sm\\:hover\\:translate-y-32:hover {\n    --transform-translate-y: 8rem;\n  }\n  .sm\\:hover\\:translate-y-36:hover {\n    --transform-translate-y: 9rem;\n  }\n  .sm\\:hover\\:translate-y-40:hover {\n    --transform-translate-y: 10rem;\n  }\n  .sm\\:hover\\:translate-y-44:hover {\n    --transform-translate-y: 11rem;\n  }\n  .sm\\:hover\\:translate-y-48:hover {\n    --transform-translate-y: 12rem;\n  }\n  .sm\\:hover\\:translate-y-52:hover {\n    --transform-translate-y: 13rem;\n  }\n  .sm\\:hover\\:translate-y-56:hover {\n    --transform-translate-y: 14rem;\n  }\n  .sm\\:hover\\:translate-y-60:hover {\n    --transform-translate-y: 15rem;\n  }\n  .sm\\:hover\\:translate-y-64:hover {\n    --transform-translate-y: 16rem;\n  }\n  .sm\\:hover\\:translate-y-72:hover {\n    --transform-translate-y: 18rem;\n  }\n  .sm\\:hover\\:translate-y-80:hover {\n    --transform-translate-y: 20rem;\n  }\n  .sm\\:hover\\:translate-y-96:hover {\n    --transform-translate-y: 24rem;\n  }\n  .sm\\:hover\\:translate-y-px:hover {\n    --transform-translate-y: 1px;\n  }\n  .sm\\:hover\\:translate-y-0\\.5:hover {\n    --transform-translate-y: 0.125rem;\n  }\n  .sm\\:hover\\:translate-y-1\\.5:hover {\n    --transform-translate-y: 0.375rem;\n  }\n  .sm\\:hover\\:translate-y-2\\.5:hover {\n    --transform-translate-y: 0.625rem;\n  }\n  .sm\\:hover\\:translate-y-3\\.5:hover {\n    --transform-translate-y: 0.875rem;\n  }\n  .sm\\:hover\\:translate-y-1\\/2:hover {\n    --transform-translate-y: 50%;\n  }\n  .sm\\:hover\\:translate-y-1\\/3:hover {\n    --transform-translate-y: 33.333333%;\n  }\n  .sm\\:hover\\:translate-y-2\\/3:hover {\n    --transform-translate-y: 66.666667%;\n  }\n  .sm\\:hover\\:translate-y-1\\/4:hover {\n    --transform-translate-y: 25%;\n  }\n  .sm\\:hover\\:translate-y-2\\/4:hover {\n    --transform-translate-y: 50%;\n  }\n  .sm\\:hover\\:translate-y-3\\/4:hover {\n    --transform-translate-y: 75%;\n  }\n  .sm\\:hover\\:translate-y-1\\/5:hover {\n    --transform-translate-y: 20%;\n  }\n  .sm\\:hover\\:translate-y-2\\/5:hover {\n    --transform-translate-y: 40%;\n  }\n  .sm\\:hover\\:translate-y-3\\/5:hover {\n    --transform-translate-y: 60%;\n  }\n  .sm\\:hover\\:translate-y-4\\/5:hover {\n    --transform-translate-y: 80%;\n  }\n  .sm\\:hover\\:translate-y-1\\/6:hover {\n    --transform-translate-y: 16.666667%;\n  }\n  .sm\\:hover\\:translate-y-2\\/6:hover {\n    --transform-translate-y: 33.333333%;\n  }\n  .sm\\:hover\\:translate-y-3\\/6:hover {\n    --transform-translate-y: 50%;\n  }\n  .sm\\:hover\\:translate-y-4\\/6:hover {\n    --transform-translate-y: 66.666667%;\n  }\n  .sm\\:hover\\:translate-y-5\\/6:hover {\n    --transform-translate-y: 83.333333%;\n  }\n  .sm\\:hover\\:translate-y-1\\/12:hover {\n    --transform-translate-y: 8.333333%;\n  }\n  .sm\\:hover\\:translate-y-2\\/12:hover {\n    --transform-translate-y: 16.666667%;\n  }\n  .sm\\:hover\\:translate-y-3\\/12:hover {\n    --transform-translate-y: 25%;\n  }\n  .sm\\:hover\\:translate-y-4\\/12:hover {\n    --transform-translate-y: 33.333333%;\n  }\n  .sm\\:hover\\:translate-y-5\\/12:hover {\n    --transform-translate-y: 41.666667%;\n  }\n  .sm\\:hover\\:translate-y-6\\/12:hover {\n    --transform-translate-y: 50%;\n  }\n  .sm\\:hover\\:translate-y-7\\/12:hover {\n    --transform-translate-y: 58.333333%;\n  }\n  .sm\\:hover\\:translate-y-8\\/12:hover {\n    --transform-translate-y: 66.666667%;\n  }\n  .sm\\:hover\\:translate-y-9\\/12:hover {\n    --transform-translate-y: 75%;\n  }\n  .sm\\:hover\\:translate-y-10\\/12:hover {\n    --transform-translate-y: 83.333333%;\n  }\n  .sm\\:hover\\:translate-y-11\\/12:hover {\n    --transform-translate-y: 91.666667%;\n  }\n  .sm\\:hover\\:translate-y-full:hover {\n    --transform-translate-y: 100%;\n  }\n  .sm\\:hover\\:-translate-y-1:hover {\n    --transform-translate-y: -0.25rem;\n  }\n  .sm\\:hover\\:-translate-y-2:hover {\n    --transform-translate-y: -0.5rem;\n  }\n  .sm\\:hover\\:-translate-y-3:hover {\n    --transform-translate-y: -0.75rem;\n  }\n  .sm\\:hover\\:-translate-y-4:hover {\n    --transform-translate-y: -1rem;\n  }\n  .sm\\:hover\\:-translate-y-5:hover {\n    --transform-translate-y: -1.25rem;\n  }\n  .sm\\:hover\\:-translate-y-6:hover {\n    --transform-translate-y: -1.5rem;\n  }\n  .sm\\:hover\\:-translate-y-7:hover {\n    --transform-translate-y: -1.75rem;\n  }\n  .sm\\:hover\\:-translate-y-8:hover {\n    --transform-translate-y: -2rem;\n  }\n  .sm\\:hover\\:-translate-y-9:hover {\n    --transform-translate-y: -2.25rem;\n  }\n  .sm\\:hover\\:-translate-y-10:hover {\n    --transform-translate-y: -2.5rem;\n  }\n  .sm\\:hover\\:-translate-y-11:hover {\n    --transform-translate-y: -2.75rem;\n  }\n  .sm\\:hover\\:-translate-y-12:hover {\n    --transform-translate-y: -3rem;\n  }\n  .sm\\:hover\\:-translate-y-13:hover {\n    --transform-translate-y: -3.25rem;\n  }\n  .sm\\:hover\\:-translate-y-14:hover {\n    --transform-translate-y: -3.5rem;\n  }\n  .sm\\:hover\\:-translate-y-15:hover {\n    --transform-translate-y: -3.75rem;\n  }\n  .sm\\:hover\\:-translate-y-16:hover {\n    --transform-translate-y: -4rem;\n  }\n  .sm\\:hover\\:-translate-y-20:hover {\n    --transform-translate-y: -5rem;\n  }\n  .sm\\:hover\\:-translate-y-24:hover {\n    --transform-translate-y: -6rem;\n  }\n  .sm\\:hover\\:-translate-y-28:hover {\n    --transform-translate-y: -7rem;\n  }\n  .sm\\:hover\\:-translate-y-32:hover {\n    --transform-translate-y: -8rem;\n  }\n  .sm\\:hover\\:-translate-y-36:hover {\n    --transform-translate-y: -9rem;\n  }\n  .sm\\:hover\\:-translate-y-40:hover {\n    --transform-translate-y: -10rem;\n  }\n  .sm\\:hover\\:-translate-y-44:hover {\n    --transform-translate-y: -11rem;\n  }\n  .sm\\:hover\\:-translate-y-48:hover {\n    --transform-translate-y: -12rem;\n  }\n  .sm\\:hover\\:-translate-y-52:hover {\n    --transform-translate-y: -13rem;\n  }\n  .sm\\:hover\\:-translate-y-56:hover {\n    --transform-translate-y: -14rem;\n  }\n  .sm\\:hover\\:-translate-y-60:hover {\n    --transform-translate-y: -15rem;\n  }\n  .sm\\:hover\\:-translate-y-64:hover {\n    --transform-translate-y: -16rem;\n  }\n  .sm\\:hover\\:-translate-y-72:hover {\n    --transform-translate-y: -18rem;\n  }\n  .sm\\:hover\\:-translate-y-80:hover {\n    --transform-translate-y: -20rem;\n  }\n  .sm\\:hover\\:-translate-y-96:hover {\n    --transform-translate-y: -24rem;\n  }\n  .sm\\:hover\\:-translate-y-px:hover {\n    --transform-translate-y: -1px;\n  }\n  .sm\\:hover\\:-translate-y-0\\.5:hover {\n    --transform-translate-y: -0.125rem;\n  }\n  .sm\\:hover\\:-translate-y-1\\.5:hover {\n    --transform-translate-y: -0.375rem;\n  }\n  .sm\\:hover\\:-translate-y-2\\.5:hover {\n    --transform-translate-y: -0.625rem;\n  }\n  .sm\\:hover\\:-translate-y-3\\.5:hover {\n    --transform-translate-y: -0.875rem;\n  }\n  .sm\\:hover\\:-translate-y-1\\/2:hover {\n    --transform-translate-y: -50%;\n  }\n  .sm\\:hover\\:-translate-y-1\\/3:hover {\n    --transform-translate-y: -33.33333%;\n  }\n  .sm\\:hover\\:-translate-y-2\\/3:hover {\n    --transform-translate-y: -66.66667%;\n  }\n  .sm\\:hover\\:-translate-y-1\\/4:hover {\n    --transform-translate-y: -25%;\n  }\n  .sm\\:hover\\:-translate-y-2\\/4:hover {\n    --transform-translate-y: -50%;\n  }\n  .sm\\:hover\\:-translate-y-3\\/4:hover {\n    --transform-translate-y: -75%;\n  }\n  .sm\\:hover\\:-translate-y-1\\/5:hover {\n    --transform-translate-y: -20%;\n  }\n  .sm\\:hover\\:-translate-y-2\\/5:hover {\n    --transform-translate-y: -40%;\n  }\n  .sm\\:hover\\:-translate-y-3\\/5:hover {\n    --transform-translate-y: -60%;\n  }\n  .sm\\:hover\\:-translate-y-4\\/5:hover {\n    --transform-translate-y: -80%;\n  }\n  .sm\\:hover\\:-translate-y-1\\/6:hover {\n    --transform-translate-y: -16.66667%;\n  }\n  .sm\\:hover\\:-translate-y-2\\/6:hover {\n    --transform-translate-y: -33.33333%;\n  }\n  .sm\\:hover\\:-translate-y-3\\/6:hover {\n    --transform-translate-y: -50%;\n  }\n  .sm\\:hover\\:-translate-y-4\\/6:hover {\n    --transform-translate-y: -66.66667%;\n  }\n  .sm\\:hover\\:-translate-y-5\\/6:hover {\n    --transform-translate-y: -83.33333%;\n  }\n  .sm\\:hover\\:-translate-y-1\\/12:hover {\n    --transform-translate-y: -8.33333%;\n  }\n  .sm\\:hover\\:-translate-y-2\\/12:hover {\n    --transform-translate-y: -16.66667%;\n  }\n  .sm\\:hover\\:-translate-y-3\\/12:hover {\n    --transform-translate-y: -25%;\n  }\n  .sm\\:hover\\:-translate-y-4\\/12:hover {\n    --transform-translate-y: -33.33333%;\n  }\n  .sm\\:hover\\:-translate-y-5\\/12:hover {\n    --transform-translate-y: -41.66667%;\n  }\n  .sm\\:hover\\:-translate-y-6\\/12:hover {\n    --transform-translate-y: -50%;\n  }\n  .sm\\:hover\\:-translate-y-7\\/12:hover {\n    --transform-translate-y: -58.33333%;\n  }\n  .sm\\:hover\\:-translate-y-8\\/12:hover {\n    --transform-translate-y: -66.66667%;\n  }\n  .sm\\:hover\\:-translate-y-9\\/12:hover {\n    --transform-translate-y: -75%;\n  }\n  .sm\\:hover\\:-translate-y-10\\/12:hover {\n    --transform-translate-y: -83.33333%;\n  }\n  .sm\\:hover\\:-translate-y-11\\/12:hover {\n    --transform-translate-y: -91.66667%;\n  }\n  .sm\\:hover\\:-translate-y-full:hover {\n    --transform-translate-y: -100%;\n  }\n  .sm\\:focus\\:translate-x-0:focus {\n    --transform-translate-x: 0;\n  }\n  .sm\\:focus\\:translate-x-1:focus {\n    --transform-translate-x: 0.25rem;\n  }\n  .sm\\:focus\\:translate-x-2:focus {\n    --transform-translate-x: 0.5rem;\n  }\n  .sm\\:focus\\:translate-x-3:focus {\n    --transform-translate-x: 0.75rem;\n  }\n  .sm\\:focus\\:translate-x-4:focus {\n    --transform-translate-x: 1rem;\n  }\n  .sm\\:focus\\:translate-x-5:focus {\n    --transform-translate-x: 1.25rem;\n  }\n  .sm\\:focus\\:translate-x-6:focus {\n    --transform-translate-x: 1.5rem;\n  }\n  .sm\\:focus\\:translate-x-7:focus {\n    --transform-translate-x: 1.75rem;\n  }\n  .sm\\:focus\\:translate-x-8:focus {\n    --transform-translate-x: 2rem;\n  }\n  .sm\\:focus\\:translate-x-9:focus {\n    --transform-translate-x: 2.25rem;\n  }\n  .sm\\:focus\\:translate-x-10:focus {\n    --transform-translate-x: 2.5rem;\n  }\n  .sm\\:focus\\:translate-x-11:focus {\n    --transform-translate-x: 2.75rem;\n  }\n  .sm\\:focus\\:translate-x-12:focus {\n    --transform-translate-x: 3rem;\n  }\n  .sm\\:focus\\:translate-x-13:focus {\n    --transform-translate-x: 3.25rem;\n  }\n  .sm\\:focus\\:translate-x-14:focus {\n    --transform-translate-x: 3.5rem;\n  }\n  .sm\\:focus\\:translate-x-15:focus {\n    --transform-translate-x: 3.75rem;\n  }\n  .sm\\:focus\\:translate-x-16:focus {\n    --transform-translate-x: 4rem;\n  }\n  .sm\\:focus\\:translate-x-20:focus {\n    --transform-translate-x: 5rem;\n  }\n  .sm\\:focus\\:translate-x-24:focus {\n    --transform-translate-x: 6rem;\n  }\n  .sm\\:focus\\:translate-x-28:focus {\n    --transform-translate-x: 7rem;\n  }\n  .sm\\:focus\\:translate-x-32:focus {\n    --transform-translate-x: 8rem;\n  }\n  .sm\\:focus\\:translate-x-36:focus {\n    --transform-translate-x: 9rem;\n  }\n  .sm\\:focus\\:translate-x-40:focus {\n    --transform-translate-x: 10rem;\n  }\n  .sm\\:focus\\:translate-x-44:focus {\n    --transform-translate-x: 11rem;\n  }\n  .sm\\:focus\\:translate-x-48:focus {\n    --transform-translate-x: 12rem;\n  }\n  .sm\\:focus\\:translate-x-52:focus {\n    --transform-translate-x: 13rem;\n  }\n  .sm\\:focus\\:translate-x-56:focus {\n    --transform-translate-x: 14rem;\n  }\n  .sm\\:focus\\:translate-x-60:focus {\n    --transform-translate-x: 15rem;\n  }\n  .sm\\:focus\\:translate-x-64:focus {\n    --transform-translate-x: 16rem;\n  }\n  .sm\\:focus\\:translate-x-72:focus {\n    --transform-translate-x: 18rem;\n  }\n  .sm\\:focus\\:translate-x-80:focus {\n    --transform-translate-x: 20rem;\n  }\n  .sm\\:focus\\:translate-x-96:focus {\n    --transform-translate-x: 24rem;\n  }\n  .sm\\:focus\\:translate-x-px:focus {\n    --transform-translate-x: 1px;\n  }\n  .sm\\:focus\\:translate-x-0\\.5:focus {\n    --transform-translate-x: 0.125rem;\n  }\n  .sm\\:focus\\:translate-x-1\\.5:focus {\n    --transform-translate-x: 0.375rem;\n  }\n  .sm\\:focus\\:translate-x-2\\.5:focus {\n    --transform-translate-x: 0.625rem;\n  }\n  .sm\\:focus\\:translate-x-3\\.5:focus {\n    --transform-translate-x: 0.875rem;\n  }\n  .sm\\:focus\\:translate-x-1\\/2:focus {\n    --transform-translate-x: 50%;\n  }\n  .sm\\:focus\\:translate-x-1\\/3:focus {\n    --transform-translate-x: 33.333333%;\n  }\n  .sm\\:focus\\:translate-x-2\\/3:focus {\n    --transform-translate-x: 66.666667%;\n  }\n  .sm\\:focus\\:translate-x-1\\/4:focus {\n    --transform-translate-x: 25%;\n  }\n  .sm\\:focus\\:translate-x-2\\/4:focus {\n    --transform-translate-x: 50%;\n  }\n  .sm\\:focus\\:translate-x-3\\/4:focus {\n    --transform-translate-x: 75%;\n  }\n  .sm\\:focus\\:translate-x-1\\/5:focus {\n    --transform-translate-x: 20%;\n  }\n  .sm\\:focus\\:translate-x-2\\/5:focus {\n    --transform-translate-x: 40%;\n  }\n  .sm\\:focus\\:translate-x-3\\/5:focus {\n    --transform-translate-x: 60%;\n  }\n  .sm\\:focus\\:translate-x-4\\/5:focus {\n    --transform-translate-x: 80%;\n  }\n  .sm\\:focus\\:translate-x-1\\/6:focus {\n    --transform-translate-x: 16.666667%;\n  }\n  .sm\\:focus\\:translate-x-2\\/6:focus {\n    --transform-translate-x: 33.333333%;\n  }\n  .sm\\:focus\\:translate-x-3\\/6:focus {\n    --transform-translate-x: 50%;\n  }\n  .sm\\:focus\\:translate-x-4\\/6:focus {\n    --transform-translate-x: 66.666667%;\n  }\n  .sm\\:focus\\:translate-x-5\\/6:focus {\n    --transform-translate-x: 83.333333%;\n  }\n  .sm\\:focus\\:translate-x-1\\/12:focus {\n    --transform-translate-x: 8.333333%;\n  }\n  .sm\\:focus\\:translate-x-2\\/12:focus {\n    --transform-translate-x: 16.666667%;\n  }\n  .sm\\:focus\\:translate-x-3\\/12:focus {\n    --transform-translate-x: 25%;\n  }\n  .sm\\:focus\\:translate-x-4\\/12:focus {\n    --transform-translate-x: 33.333333%;\n  }\n  .sm\\:focus\\:translate-x-5\\/12:focus {\n    --transform-translate-x: 41.666667%;\n  }\n  .sm\\:focus\\:translate-x-6\\/12:focus {\n    --transform-translate-x: 50%;\n  }\n  .sm\\:focus\\:translate-x-7\\/12:focus {\n    --transform-translate-x: 58.333333%;\n  }\n  .sm\\:focus\\:translate-x-8\\/12:focus {\n    --transform-translate-x: 66.666667%;\n  }\n  .sm\\:focus\\:translate-x-9\\/12:focus {\n    --transform-translate-x: 75%;\n  }\n  .sm\\:focus\\:translate-x-10\\/12:focus {\n    --transform-translate-x: 83.333333%;\n  }\n  .sm\\:focus\\:translate-x-11\\/12:focus {\n    --transform-translate-x: 91.666667%;\n  }\n  .sm\\:focus\\:translate-x-full:focus {\n    --transform-translate-x: 100%;\n  }\n  .sm\\:focus\\:-translate-x-1:focus {\n    --transform-translate-x: -0.25rem;\n  }\n  .sm\\:focus\\:-translate-x-2:focus {\n    --transform-translate-x: -0.5rem;\n  }\n  .sm\\:focus\\:-translate-x-3:focus {\n    --transform-translate-x: -0.75rem;\n  }\n  .sm\\:focus\\:-translate-x-4:focus {\n    --transform-translate-x: -1rem;\n  }\n  .sm\\:focus\\:-translate-x-5:focus {\n    --transform-translate-x: -1.25rem;\n  }\n  .sm\\:focus\\:-translate-x-6:focus {\n    --transform-translate-x: -1.5rem;\n  }\n  .sm\\:focus\\:-translate-x-7:focus {\n    --transform-translate-x: -1.75rem;\n  }\n  .sm\\:focus\\:-translate-x-8:focus {\n    --transform-translate-x: -2rem;\n  }\n  .sm\\:focus\\:-translate-x-9:focus {\n    --transform-translate-x: -2.25rem;\n  }\n  .sm\\:focus\\:-translate-x-10:focus {\n    --transform-translate-x: -2.5rem;\n  }\n  .sm\\:focus\\:-translate-x-11:focus {\n    --transform-translate-x: -2.75rem;\n  }\n  .sm\\:focus\\:-translate-x-12:focus {\n    --transform-translate-x: -3rem;\n  }\n  .sm\\:focus\\:-translate-x-13:focus {\n    --transform-translate-x: -3.25rem;\n  }\n  .sm\\:focus\\:-translate-x-14:focus {\n    --transform-translate-x: -3.5rem;\n  }\n  .sm\\:focus\\:-translate-x-15:focus {\n    --transform-translate-x: -3.75rem;\n  }\n  .sm\\:focus\\:-translate-x-16:focus {\n    --transform-translate-x: -4rem;\n  }\n  .sm\\:focus\\:-translate-x-20:focus {\n    --transform-translate-x: -5rem;\n  }\n  .sm\\:focus\\:-translate-x-24:focus {\n    --transform-translate-x: -6rem;\n  }\n  .sm\\:focus\\:-translate-x-28:focus {\n    --transform-translate-x: -7rem;\n  }\n  .sm\\:focus\\:-translate-x-32:focus {\n    --transform-translate-x: -8rem;\n  }\n  .sm\\:focus\\:-translate-x-36:focus {\n    --transform-translate-x: -9rem;\n  }\n  .sm\\:focus\\:-translate-x-40:focus {\n    --transform-translate-x: -10rem;\n  }\n  .sm\\:focus\\:-translate-x-44:focus {\n    --transform-translate-x: -11rem;\n  }\n  .sm\\:focus\\:-translate-x-48:focus {\n    --transform-translate-x: -12rem;\n  }\n  .sm\\:focus\\:-translate-x-52:focus {\n    --transform-translate-x: -13rem;\n  }\n  .sm\\:focus\\:-translate-x-56:focus {\n    --transform-translate-x: -14rem;\n  }\n  .sm\\:focus\\:-translate-x-60:focus {\n    --transform-translate-x: -15rem;\n  }\n  .sm\\:focus\\:-translate-x-64:focus {\n    --transform-translate-x: -16rem;\n  }\n  .sm\\:focus\\:-translate-x-72:focus {\n    --transform-translate-x: -18rem;\n  }\n  .sm\\:focus\\:-translate-x-80:focus {\n    --transform-translate-x: -20rem;\n  }\n  .sm\\:focus\\:-translate-x-96:focus {\n    --transform-translate-x: -24rem;\n  }\n  .sm\\:focus\\:-translate-x-px:focus {\n    --transform-translate-x: -1px;\n  }\n  .sm\\:focus\\:-translate-x-0\\.5:focus {\n    --transform-translate-x: -0.125rem;\n  }\n  .sm\\:focus\\:-translate-x-1\\.5:focus {\n    --transform-translate-x: -0.375rem;\n  }\n  .sm\\:focus\\:-translate-x-2\\.5:focus {\n    --transform-translate-x: -0.625rem;\n  }\n  .sm\\:focus\\:-translate-x-3\\.5:focus {\n    --transform-translate-x: -0.875rem;\n  }\n  .sm\\:focus\\:-translate-x-1\\/2:focus {\n    --transform-translate-x: -50%;\n  }\n  .sm\\:focus\\:-translate-x-1\\/3:focus {\n    --transform-translate-x: -33.33333%;\n  }\n  .sm\\:focus\\:-translate-x-2\\/3:focus {\n    --transform-translate-x: -66.66667%;\n  }\n  .sm\\:focus\\:-translate-x-1\\/4:focus {\n    --transform-translate-x: -25%;\n  }\n  .sm\\:focus\\:-translate-x-2\\/4:focus {\n    --transform-translate-x: -50%;\n  }\n  .sm\\:focus\\:-translate-x-3\\/4:focus {\n    --transform-translate-x: -75%;\n  }\n  .sm\\:focus\\:-translate-x-1\\/5:focus {\n    --transform-translate-x: -20%;\n  }\n  .sm\\:focus\\:-translate-x-2\\/5:focus {\n    --transform-translate-x: -40%;\n  }\n  .sm\\:focus\\:-translate-x-3\\/5:focus {\n    --transform-translate-x: -60%;\n  }\n  .sm\\:focus\\:-translate-x-4\\/5:focus {\n    --transform-translate-x: -80%;\n  }\n  .sm\\:focus\\:-translate-x-1\\/6:focus {\n    --transform-translate-x: -16.66667%;\n  }\n  .sm\\:focus\\:-translate-x-2\\/6:focus {\n    --transform-translate-x: -33.33333%;\n  }\n  .sm\\:focus\\:-translate-x-3\\/6:focus {\n    --transform-translate-x: -50%;\n  }\n  .sm\\:focus\\:-translate-x-4\\/6:focus {\n    --transform-translate-x: -66.66667%;\n  }\n  .sm\\:focus\\:-translate-x-5\\/6:focus {\n    --transform-translate-x: -83.33333%;\n  }\n  .sm\\:focus\\:-translate-x-1\\/12:focus {\n    --transform-translate-x: -8.33333%;\n  }\n  .sm\\:focus\\:-translate-x-2\\/12:focus {\n    --transform-translate-x: -16.66667%;\n  }\n  .sm\\:focus\\:-translate-x-3\\/12:focus {\n    --transform-translate-x: -25%;\n  }\n  .sm\\:focus\\:-translate-x-4\\/12:focus {\n    --transform-translate-x: -33.33333%;\n  }\n  .sm\\:focus\\:-translate-x-5\\/12:focus {\n    --transform-translate-x: -41.66667%;\n  }\n  .sm\\:focus\\:-translate-x-6\\/12:focus {\n    --transform-translate-x: -50%;\n  }\n  .sm\\:focus\\:-translate-x-7\\/12:focus {\n    --transform-translate-x: -58.33333%;\n  }\n  .sm\\:focus\\:-translate-x-8\\/12:focus {\n    --transform-translate-x: -66.66667%;\n  }\n  .sm\\:focus\\:-translate-x-9\\/12:focus {\n    --transform-translate-x: -75%;\n  }\n  .sm\\:focus\\:-translate-x-10\\/12:focus {\n    --transform-translate-x: -83.33333%;\n  }\n  .sm\\:focus\\:-translate-x-11\\/12:focus {\n    --transform-translate-x: -91.66667%;\n  }\n  .sm\\:focus\\:-translate-x-full:focus {\n    --transform-translate-x: -100%;\n  }\n  .sm\\:focus\\:translate-y-0:focus {\n    --transform-translate-y: 0;\n  }\n  .sm\\:focus\\:translate-y-1:focus {\n    --transform-translate-y: 0.25rem;\n  }\n  .sm\\:focus\\:translate-y-2:focus {\n    --transform-translate-y: 0.5rem;\n  }\n  .sm\\:focus\\:translate-y-3:focus {\n    --transform-translate-y: 0.75rem;\n  }\n  .sm\\:focus\\:translate-y-4:focus {\n    --transform-translate-y: 1rem;\n  }\n  .sm\\:focus\\:translate-y-5:focus {\n    --transform-translate-y: 1.25rem;\n  }\n  .sm\\:focus\\:translate-y-6:focus {\n    --transform-translate-y: 1.5rem;\n  }\n  .sm\\:focus\\:translate-y-7:focus {\n    --transform-translate-y: 1.75rem;\n  }\n  .sm\\:focus\\:translate-y-8:focus {\n    --transform-translate-y: 2rem;\n  }\n  .sm\\:focus\\:translate-y-9:focus {\n    --transform-translate-y: 2.25rem;\n  }\n  .sm\\:focus\\:translate-y-10:focus {\n    --transform-translate-y: 2.5rem;\n  }\n  .sm\\:focus\\:translate-y-11:focus {\n    --transform-translate-y: 2.75rem;\n  }\n  .sm\\:focus\\:translate-y-12:focus {\n    --transform-translate-y: 3rem;\n  }\n  .sm\\:focus\\:translate-y-13:focus {\n    --transform-translate-y: 3.25rem;\n  }\n  .sm\\:focus\\:translate-y-14:focus {\n    --transform-translate-y: 3.5rem;\n  }\n  .sm\\:focus\\:translate-y-15:focus {\n    --transform-translate-y: 3.75rem;\n  }\n  .sm\\:focus\\:translate-y-16:focus {\n    --transform-translate-y: 4rem;\n  }\n  .sm\\:focus\\:translate-y-20:focus {\n    --transform-translate-y: 5rem;\n  }\n  .sm\\:focus\\:translate-y-24:focus {\n    --transform-translate-y: 6rem;\n  }\n  .sm\\:focus\\:translate-y-28:focus {\n    --transform-translate-y: 7rem;\n  }\n  .sm\\:focus\\:translate-y-32:focus {\n    --transform-translate-y: 8rem;\n  }\n  .sm\\:focus\\:translate-y-36:focus {\n    --transform-translate-y: 9rem;\n  }\n  .sm\\:focus\\:translate-y-40:focus {\n    --transform-translate-y: 10rem;\n  }\n  .sm\\:focus\\:translate-y-44:focus {\n    --transform-translate-y: 11rem;\n  }\n  .sm\\:focus\\:translate-y-48:focus {\n    --transform-translate-y: 12rem;\n  }\n  .sm\\:focus\\:translate-y-52:focus {\n    --transform-translate-y: 13rem;\n  }\n  .sm\\:focus\\:translate-y-56:focus {\n    --transform-translate-y: 14rem;\n  }\n  .sm\\:focus\\:translate-y-60:focus {\n    --transform-translate-y: 15rem;\n  }\n  .sm\\:focus\\:translate-y-64:focus {\n    --transform-translate-y: 16rem;\n  }\n  .sm\\:focus\\:translate-y-72:focus {\n    --transform-translate-y: 18rem;\n  }\n  .sm\\:focus\\:translate-y-80:focus {\n    --transform-translate-y: 20rem;\n  }\n  .sm\\:focus\\:translate-y-96:focus {\n    --transform-translate-y: 24rem;\n  }\n  .sm\\:focus\\:translate-y-px:focus {\n    --transform-translate-y: 1px;\n  }\n  .sm\\:focus\\:translate-y-0\\.5:focus {\n    --transform-translate-y: 0.125rem;\n  }\n  .sm\\:focus\\:translate-y-1\\.5:focus {\n    --transform-translate-y: 0.375rem;\n  }\n  .sm\\:focus\\:translate-y-2\\.5:focus {\n    --transform-translate-y: 0.625rem;\n  }\n  .sm\\:focus\\:translate-y-3\\.5:focus {\n    --transform-translate-y: 0.875rem;\n  }\n  .sm\\:focus\\:translate-y-1\\/2:focus {\n    --transform-translate-y: 50%;\n  }\n  .sm\\:focus\\:translate-y-1\\/3:focus {\n    --transform-translate-y: 33.333333%;\n  }\n  .sm\\:focus\\:translate-y-2\\/3:focus {\n    --transform-translate-y: 66.666667%;\n  }\n  .sm\\:focus\\:translate-y-1\\/4:focus {\n    --transform-translate-y: 25%;\n  }\n  .sm\\:focus\\:translate-y-2\\/4:focus {\n    --transform-translate-y: 50%;\n  }\n  .sm\\:focus\\:translate-y-3\\/4:focus {\n    --transform-translate-y: 75%;\n  }\n  .sm\\:focus\\:translate-y-1\\/5:focus {\n    --transform-translate-y: 20%;\n  }\n  .sm\\:focus\\:translate-y-2\\/5:focus {\n    --transform-translate-y: 40%;\n  }\n  .sm\\:focus\\:translate-y-3\\/5:focus {\n    --transform-translate-y: 60%;\n  }\n  .sm\\:focus\\:translate-y-4\\/5:focus {\n    --transform-translate-y: 80%;\n  }\n  .sm\\:focus\\:translate-y-1\\/6:focus {\n    --transform-translate-y: 16.666667%;\n  }\n  .sm\\:focus\\:translate-y-2\\/6:focus {\n    --transform-translate-y: 33.333333%;\n  }\n  .sm\\:focus\\:translate-y-3\\/6:focus {\n    --transform-translate-y: 50%;\n  }\n  .sm\\:focus\\:translate-y-4\\/6:focus {\n    --transform-translate-y: 66.666667%;\n  }\n  .sm\\:focus\\:translate-y-5\\/6:focus {\n    --transform-translate-y: 83.333333%;\n  }\n  .sm\\:focus\\:translate-y-1\\/12:focus {\n    --transform-translate-y: 8.333333%;\n  }\n  .sm\\:focus\\:translate-y-2\\/12:focus {\n    --transform-translate-y: 16.666667%;\n  }\n  .sm\\:focus\\:translate-y-3\\/12:focus {\n    --transform-translate-y: 25%;\n  }\n  .sm\\:focus\\:translate-y-4\\/12:focus {\n    --transform-translate-y: 33.333333%;\n  }\n  .sm\\:focus\\:translate-y-5\\/12:focus {\n    --transform-translate-y: 41.666667%;\n  }\n  .sm\\:focus\\:translate-y-6\\/12:focus {\n    --transform-translate-y: 50%;\n  }\n  .sm\\:focus\\:translate-y-7\\/12:focus {\n    --transform-translate-y: 58.333333%;\n  }\n  .sm\\:focus\\:translate-y-8\\/12:focus {\n    --transform-translate-y: 66.666667%;\n  }\n  .sm\\:focus\\:translate-y-9\\/12:focus {\n    --transform-translate-y: 75%;\n  }\n  .sm\\:focus\\:translate-y-10\\/12:focus {\n    --transform-translate-y: 83.333333%;\n  }\n  .sm\\:focus\\:translate-y-11\\/12:focus {\n    --transform-translate-y: 91.666667%;\n  }\n  .sm\\:focus\\:translate-y-full:focus {\n    --transform-translate-y: 100%;\n  }\n  .sm\\:focus\\:-translate-y-1:focus {\n    --transform-translate-y: -0.25rem;\n  }\n  .sm\\:focus\\:-translate-y-2:focus {\n    --transform-translate-y: -0.5rem;\n  }\n  .sm\\:focus\\:-translate-y-3:focus {\n    --transform-translate-y: -0.75rem;\n  }\n  .sm\\:focus\\:-translate-y-4:focus {\n    --transform-translate-y: -1rem;\n  }\n  .sm\\:focus\\:-translate-y-5:focus {\n    --transform-translate-y: -1.25rem;\n  }\n  .sm\\:focus\\:-translate-y-6:focus {\n    --transform-translate-y: -1.5rem;\n  }\n  .sm\\:focus\\:-translate-y-7:focus {\n    --transform-translate-y: -1.75rem;\n  }\n  .sm\\:focus\\:-translate-y-8:focus {\n    --transform-translate-y: -2rem;\n  }\n  .sm\\:focus\\:-translate-y-9:focus {\n    --transform-translate-y: -2.25rem;\n  }\n  .sm\\:focus\\:-translate-y-10:focus {\n    --transform-translate-y: -2.5rem;\n  }\n  .sm\\:focus\\:-translate-y-11:focus {\n    --transform-translate-y: -2.75rem;\n  }\n  .sm\\:focus\\:-translate-y-12:focus {\n    --transform-translate-y: -3rem;\n  }\n  .sm\\:focus\\:-translate-y-13:focus {\n    --transform-translate-y: -3.25rem;\n  }\n  .sm\\:focus\\:-translate-y-14:focus {\n    --transform-translate-y: -3.5rem;\n  }\n  .sm\\:focus\\:-translate-y-15:focus {\n    --transform-translate-y: -3.75rem;\n  }\n  .sm\\:focus\\:-translate-y-16:focus {\n    --transform-translate-y: -4rem;\n  }\n  .sm\\:focus\\:-translate-y-20:focus {\n    --transform-translate-y: -5rem;\n  }\n  .sm\\:focus\\:-translate-y-24:focus {\n    --transform-translate-y: -6rem;\n  }\n  .sm\\:focus\\:-translate-y-28:focus {\n    --transform-translate-y: -7rem;\n  }\n  .sm\\:focus\\:-translate-y-32:focus {\n    --transform-translate-y: -8rem;\n  }\n  .sm\\:focus\\:-translate-y-36:focus {\n    --transform-translate-y: -9rem;\n  }\n  .sm\\:focus\\:-translate-y-40:focus {\n    --transform-translate-y: -10rem;\n  }\n  .sm\\:focus\\:-translate-y-44:focus {\n    --transform-translate-y: -11rem;\n  }\n  .sm\\:focus\\:-translate-y-48:focus {\n    --transform-translate-y: -12rem;\n  }\n  .sm\\:focus\\:-translate-y-52:focus {\n    --transform-translate-y: -13rem;\n  }\n  .sm\\:focus\\:-translate-y-56:focus {\n    --transform-translate-y: -14rem;\n  }\n  .sm\\:focus\\:-translate-y-60:focus {\n    --transform-translate-y: -15rem;\n  }\n  .sm\\:focus\\:-translate-y-64:focus {\n    --transform-translate-y: -16rem;\n  }\n  .sm\\:focus\\:-translate-y-72:focus {\n    --transform-translate-y: -18rem;\n  }\n  .sm\\:focus\\:-translate-y-80:focus {\n    --transform-translate-y: -20rem;\n  }\n  .sm\\:focus\\:-translate-y-96:focus {\n    --transform-translate-y: -24rem;\n  }\n  .sm\\:focus\\:-translate-y-px:focus {\n    --transform-translate-y: -1px;\n  }\n  .sm\\:focus\\:-translate-y-0\\.5:focus {\n    --transform-translate-y: -0.125rem;\n  }\n  .sm\\:focus\\:-translate-y-1\\.5:focus {\n    --transform-translate-y: -0.375rem;\n  }\n  .sm\\:focus\\:-translate-y-2\\.5:focus {\n    --transform-translate-y: -0.625rem;\n  }\n  .sm\\:focus\\:-translate-y-3\\.5:focus {\n    --transform-translate-y: -0.875rem;\n  }\n  .sm\\:focus\\:-translate-y-1\\/2:focus {\n    --transform-translate-y: -50%;\n  }\n  .sm\\:focus\\:-translate-y-1\\/3:focus {\n    --transform-translate-y: -33.33333%;\n  }\n  .sm\\:focus\\:-translate-y-2\\/3:focus {\n    --transform-translate-y: -66.66667%;\n  }\n  .sm\\:focus\\:-translate-y-1\\/4:focus {\n    --transform-translate-y: -25%;\n  }\n  .sm\\:focus\\:-translate-y-2\\/4:focus {\n    --transform-translate-y: -50%;\n  }\n  .sm\\:focus\\:-translate-y-3\\/4:focus {\n    --transform-translate-y: -75%;\n  }\n  .sm\\:focus\\:-translate-y-1\\/5:focus {\n    --transform-translate-y: -20%;\n  }\n  .sm\\:focus\\:-translate-y-2\\/5:focus {\n    --transform-translate-y: -40%;\n  }\n  .sm\\:focus\\:-translate-y-3\\/5:focus {\n    --transform-translate-y: -60%;\n  }\n  .sm\\:focus\\:-translate-y-4\\/5:focus {\n    --transform-translate-y: -80%;\n  }\n  .sm\\:focus\\:-translate-y-1\\/6:focus {\n    --transform-translate-y: -16.66667%;\n  }\n  .sm\\:focus\\:-translate-y-2\\/6:focus {\n    --transform-translate-y: -33.33333%;\n  }\n  .sm\\:focus\\:-translate-y-3\\/6:focus {\n    --transform-translate-y: -50%;\n  }\n  .sm\\:focus\\:-translate-y-4\\/6:focus {\n    --transform-translate-y: -66.66667%;\n  }\n  .sm\\:focus\\:-translate-y-5\\/6:focus {\n    --transform-translate-y: -83.33333%;\n  }\n  .sm\\:focus\\:-translate-y-1\\/12:focus {\n    --transform-translate-y: -8.33333%;\n  }\n  .sm\\:focus\\:-translate-y-2\\/12:focus {\n    --transform-translate-y: -16.66667%;\n  }\n  .sm\\:focus\\:-translate-y-3\\/12:focus {\n    --transform-translate-y: -25%;\n  }\n  .sm\\:focus\\:-translate-y-4\\/12:focus {\n    --transform-translate-y: -33.33333%;\n  }\n  .sm\\:focus\\:-translate-y-5\\/12:focus {\n    --transform-translate-y: -41.66667%;\n  }\n  .sm\\:focus\\:-translate-y-6\\/12:focus {\n    --transform-translate-y: -50%;\n  }\n  .sm\\:focus\\:-translate-y-7\\/12:focus {\n    --transform-translate-y: -58.33333%;\n  }\n  .sm\\:focus\\:-translate-y-8\\/12:focus {\n    --transform-translate-y: -66.66667%;\n  }\n  .sm\\:focus\\:-translate-y-9\\/12:focus {\n    --transform-translate-y: -75%;\n  }\n  .sm\\:focus\\:-translate-y-10\\/12:focus {\n    --transform-translate-y: -83.33333%;\n  }\n  .sm\\:focus\\:-translate-y-11\\/12:focus {\n    --transform-translate-y: -91.66667%;\n  }\n  .sm\\:focus\\:-translate-y-full:focus {\n    --transform-translate-y: -100%;\n  }\n  .sm\\:skew-x-0 {\n    --transform-skew-x: 0;\n  }\n  .sm\\:skew-x-1 {\n    --transform-skew-x: 1deg;\n  }\n  .sm\\:skew-x-2 {\n    --transform-skew-x: 2deg;\n  }\n  .sm\\:skew-x-3 {\n    --transform-skew-x: 3deg;\n  }\n  .sm\\:skew-x-6 {\n    --transform-skew-x: 6deg;\n  }\n  .sm\\:skew-x-12 {\n    --transform-skew-x: 12deg;\n  }\n  .sm\\:-skew-x-12 {\n    --transform-skew-x: -12deg;\n  }\n  .sm\\:-skew-x-6 {\n    --transform-skew-x: -6deg;\n  }\n  .sm\\:-skew-x-3 {\n    --transform-skew-x: -3deg;\n  }\n  .sm\\:-skew-x-2 {\n    --transform-skew-x: -2deg;\n  }\n  .sm\\:-skew-x-1 {\n    --transform-skew-x: -1deg;\n  }\n  .sm\\:skew-y-0 {\n    --transform-skew-y: 0;\n  }\n  .sm\\:skew-y-1 {\n    --transform-skew-y: 1deg;\n  }\n  .sm\\:skew-y-2 {\n    --transform-skew-y: 2deg;\n  }\n  .sm\\:skew-y-3 {\n    --transform-skew-y: 3deg;\n  }\n  .sm\\:skew-y-6 {\n    --transform-skew-y: 6deg;\n  }\n  .sm\\:skew-y-12 {\n    --transform-skew-y: 12deg;\n  }\n  .sm\\:-skew-y-12 {\n    --transform-skew-y: -12deg;\n  }\n  .sm\\:-skew-y-6 {\n    --transform-skew-y: -6deg;\n  }\n  .sm\\:-skew-y-3 {\n    --transform-skew-y: -3deg;\n  }\n  .sm\\:-skew-y-2 {\n    --transform-skew-y: -2deg;\n  }\n  .sm\\:-skew-y-1 {\n    --transform-skew-y: -1deg;\n  }\n  .sm\\:hover\\:skew-x-0:hover {\n    --transform-skew-x: 0;\n  }\n  .sm\\:hover\\:skew-x-1:hover {\n    --transform-skew-x: 1deg;\n  }\n  .sm\\:hover\\:skew-x-2:hover {\n    --transform-skew-x: 2deg;\n  }\n  .sm\\:hover\\:skew-x-3:hover {\n    --transform-skew-x: 3deg;\n  }\n  .sm\\:hover\\:skew-x-6:hover {\n    --transform-skew-x: 6deg;\n  }\n  .sm\\:hover\\:skew-x-12:hover {\n    --transform-skew-x: 12deg;\n  }\n  .sm\\:hover\\:-skew-x-12:hover {\n    --transform-skew-x: -12deg;\n  }\n  .sm\\:hover\\:-skew-x-6:hover {\n    --transform-skew-x: -6deg;\n  }\n  .sm\\:hover\\:-skew-x-3:hover {\n    --transform-skew-x: -3deg;\n  }\n  .sm\\:hover\\:-skew-x-2:hover {\n    --transform-skew-x: -2deg;\n  }\n  .sm\\:hover\\:-skew-x-1:hover {\n    --transform-skew-x: -1deg;\n  }\n  .sm\\:hover\\:skew-y-0:hover {\n    --transform-skew-y: 0;\n  }\n  .sm\\:hover\\:skew-y-1:hover {\n    --transform-skew-y: 1deg;\n  }\n  .sm\\:hover\\:skew-y-2:hover {\n    --transform-skew-y: 2deg;\n  }\n  .sm\\:hover\\:skew-y-3:hover {\n    --transform-skew-y: 3deg;\n  }\n  .sm\\:hover\\:skew-y-6:hover {\n    --transform-skew-y: 6deg;\n  }\n  .sm\\:hover\\:skew-y-12:hover {\n    --transform-skew-y: 12deg;\n  }\n  .sm\\:hover\\:-skew-y-12:hover {\n    --transform-skew-y: -12deg;\n  }\n  .sm\\:hover\\:-skew-y-6:hover {\n    --transform-skew-y: -6deg;\n  }\n  .sm\\:hover\\:-skew-y-3:hover {\n    --transform-skew-y: -3deg;\n  }\n  .sm\\:hover\\:-skew-y-2:hover {\n    --transform-skew-y: -2deg;\n  }\n  .sm\\:hover\\:-skew-y-1:hover {\n    --transform-skew-y: -1deg;\n  }\n  .sm\\:focus\\:skew-x-0:focus {\n    --transform-skew-x: 0;\n  }\n  .sm\\:focus\\:skew-x-1:focus {\n    --transform-skew-x: 1deg;\n  }\n  .sm\\:focus\\:skew-x-2:focus {\n    --transform-skew-x: 2deg;\n  }\n  .sm\\:focus\\:skew-x-3:focus {\n    --transform-skew-x: 3deg;\n  }\n  .sm\\:focus\\:skew-x-6:focus {\n    --transform-skew-x: 6deg;\n  }\n  .sm\\:focus\\:skew-x-12:focus {\n    --transform-skew-x: 12deg;\n  }\n  .sm\\:focus\\:-skew-x-12:focus {\n    --transform-skew-x: -12deg;\n  }\n  .sm\\:focus\\:-skew-x-6:focus {\n    --transform-skew-x: -6deg;\n  }\n  .sm\\:focus\\:-skew-x-3:focus {\n    --transform-skew-x: -3deg;\n  }\n  .sm\\:focus\\:-skew-x-2:focus {\n    --transform-skew-x: -2deg;\n  }\n  .sm\\:focus\\:-skew-x-1:focus {\n    --transform-skew-x: -1deg;\n  }\n  .sm\\:focus\\:skew-y-0:focus {\n    --transform-skew-y: 0;\n  }\n  .sm\\:focus\\:skew-y-1:focus {\n    --transform-skew-y: 1deg;\n  }\n  .sm\\:focus\\:skew-y-2:focus {\n    --transform-skew-y: 2deg;\n  }\n  .sm\\:focus\\:skew-y-3:focus {\n    --transform-skew-y: 3deg;\n  }\n  .sm\\:focus\\:skew-y-6:focus {\n    --transform-skew-y: 6deg;\n  }\n  .sm\\:focus\\:skew-y-12:focus {\n    --transform-skew-y: 12deg;\n  }\n  .sm\\:focus\\:-skew-y-12:focus {\n    --transform-skew-y: -12deg;\n  }\n  .sm\\:focus\\:-skew-y-6:focus {\n    --transform-skew-y: -6deg;\n  }\n  .sm\\:focus\\:-skew-y-3:focus {\n    --transform-skew-y: -3deg;\n  }\n  .sm\\:focus\\:-skew-y-2:focus {\n    --transform-skew-y: -2deg;\n  }\n  .sm\\:focus\\:-skew-y-1:focus {\n    --transform-skew-y: -1deg;\n  }\n  .sm\\:transition-none {\n    transition-property: none;\n  }\n  .sm\\:transition-all {\n    transition-property: all;\n  }\n  .sm\\:transition {\n    transition-property: background-color, border-color, color, fill, stroke, opacity, box-shadow, transform;\n  }\n  .sm\\:transition-colors {\n    transition-property: background-color, border-color, color, fill, stroke;\n  }\n  .sm\\:transition-opacity {\n    transition-property: opacity;\n  }\n  .sm\\:transition-shadow {\n    transition-property: box-shadow;\n  }\n  .sm\\:transition-transform {\n    transition-property: transform;\n  }\n  .sm\\:ease-linear {\n    transition-timing-function: linear;\n  }\n  .sm\\:ease-in {\n    transition-timing-function: cubic-bezier(0.4, 0, 1, 1);\n  }\n  .sm\\:ease-out {\n    transition-timing-function: cubic-bezier(0, 0, 0.2, 1);\n  }\n  .sm\\:ease-in-out {\n    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n  }\n  .sm\\:duration-75 {\n    transition-duration: 75ms;\n  }\n  .sm\\:duration-100 {\n    transition-duration: 100ms;\n  }\n  .sm\\:duration-150 {\n    transition-duration: 150ms;\n  }\n  .sm\\:duration-200 {\n    transition-duration: 200ms;\n  }\n  .sm\\:duration-300 {\n    transition-duration: 300ms;\n  }\n  .sm\\:duration-500 {\n    transition-duration: 500ms;\n  }\n  .sm\\:duration-700 {\n    transition-duration: 700ms;\n  }\n  .sm\\:duration-1000 {\n    transition-duration: 1000ms;\n  }\n  .sm\\:delay-75 {\n    transition-delay: 75ms;\n  }\n  .sm\\:delay-100 {\n    transition-delay: 100ms;\n  }\n  .sm\\:delay-150 {\n    transition-delay: 150ms;\n  }\n  .sm\\:delay-200 {\n    transition-delay: 200ms;\n  }\n  .sm\\:delay-300 {\n    transition-delay: 300ms;\n  }\n  .sm\\:delay-500 {\n    transition-delay: 500ms;\n  }\n  .sm\\:delay-700 {\n    transition-delay: 700ms;\n  }\n  .sm\\:delay-1000 {\n    transition-delay: 1000ms;\n  }\n  .sm\\:animate-none {\n    animation: none;\n  }\n  .sm\\:animate-spin {\n    animation: spin 1s linear infinite;\n  }\n  .sm\\:animate-ping {\n    animation: ping 1s cubic-bezier(0, 0, 0.2, 1) infinite;\n  }\n  .sm\\:animate-pulse {\n    animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;\n  }\n  .sm\\:animate-bounce {\n    animation: bounce 1s infinite;\n  }\n}\n@media (min-width: 768px) {\n  .md\\:container {\n    width: 100%;\n  }\n  @media (min-width: 640px) {\n    .md\\:container {\n      max-width: 640px;\n    }\n  }\n  @media (min-width: 768px) {\n    .md\\:container {\n      max-width: 768px;\n    }\n  }\n  @media (min-width: 1024px) {\n    .md\\:container {\n      max-width: 1024px;\n    }\n  }\n  @media (min-width: 1280px) {\n    .md\\:container {\n      max-width: 1280px;\n    }\n  }\n  .md\\:prose {\n    color: #374151;\n    max-width: 65ch;\n  }\n  .md\\:prose [class~=\"lead\"] {\n    color: #4b5563;\n    font-size: 1.25em;\n    line-height: 1.6;\n    margin-top: 1.2em;\n    margin-bottom: 1.2em;\n  }\n  .md\\:prose a {\n    color: #5850ec;\n    text-decoration: none;\n    font-weight: 600;\n  }\n  .md\\:prose strong {\n    color: #161e2e;\n    font-weight: 600;\n  }\n  .md\\:prose ol {\n    counter-reset: list-counter;\n    margin-top: 1.25em;\n    margin-bottom: 1.25em;\n  }\n  .md\\:prose ol>li {\n    position: relative;\n    counter-increment: list-counter;\n    padding-left: 1.75em;\n  }\n  .md\\:prose ol>li::before {\n    content: counter(list-counter) \".\";\n    position: absolute;\n    font-weight: 400;\n    color: #6b7280;\n  }\n  .md\\:prose ul>li {\n    position: relative;\n    padding-left: 1.75em;\n  }\n  .md\\:prose ul>li::before {\n    content: \"\";\n    position: absolute;\n    background-color: #d2d6dc;\n    border-radius: 50%;\n    width: 0.375em;\n    height: 0.375em;\n    top: calc(0.875em - 0.1875em);\n    left: 0.25em;\n  }\n  .md\\:prose hr {\n    border-color: #e5e7eb;\n    border-top-width: 1px;\n    margin-top: 3em;\n    margin-bottom: 3em;\n  }\n  .md\\:prose blockquote {\n    font-weight: 500;\n    font-style: italic;\n    color: #161e2e;\n    border-left-width: 0.25rem;\n    border-left-color: #e5e7eb;\n    quotes: \"\\201C\" \"\\201D\" \"\\2018\" \"\\2019\";\n    margin-top: 1.6em;\n    margin-bottom: 1.6em;\n    padding-left: 1em;\n  }\n  .md\\:prose blockquote p:first-of-type::before {\n    content: open-quote;\n  }\n  .md\\:prose blockquote p:last-of-type::after {\n    content: close-quote;\n  }\n  .md\\:prose h1 {\n    color: #1a202c;\n    font-weight: 800;\n    font-size: 2.25em;\n    margin-top: 0;\n    margin-bottom: 0.8888889em;\n    line-height: 1.1111111;\n  }\n  .md\\:prose h2 {\n    color: #1a202c;\n    font-weight: 700;\n    font-size: 1.5em;\n    margin-top: 2em;\n    margin-bottom: 1em;\n    line-height: 1.3333333;\n  }\n  .md\\:prose h3 {\n    color: #1a202c;\n    font-weight: 600;\n    font-size: 1.25em;\n    margin-top: 1.6em;\n    margin-bottom: 0.6em;\n    line-height: 1.6;\n  }\n  .md\\:prose h4 {\n    color: #1a202c;\n    font-weight: 600;\n    margin-top: 1.5em;\n    margin-bottom: 0.5em;\n    line-height: 1.5;\n  }\n  .md\\:prose figure figcaption {\n    color: #6b7280;\n    font-size: 0.875em;\n    line-height: 1.4285714;\n    margin-top: 0.8571429em;\n  }\n  .md\\:prose code {\n    color: #161e2e;\n    font-weight: 600;\n    font-size: 0.875em;\n  }\n  .md\\:prose code::before {\n    content: \"`\";\n  }\n  .md\\:prose code::after {\n    content: \"`\";\n  }\n  .md\\:prose pre {\n    color: #e5e7eb;\n    background-color: #252f3f;\n    overflow-x: auto;\n    font-size: 0.875em;\n    line-height: 1.7142857;\n    margin-top: 1.7142857em;\n    margin-bottom: 1.7142857em;\n    border-radius: 0.375rem;\n    padding-top: 0.8571429em;\n    padding-right: 1.1428571em;\n    padding-bottom: 0.8571429em;\n    padding-left: 1.1428571em;\n  }\n  .md\\:prose pre code {\n    background-color: transparent;\n    border-width: 0;\n    border-radius: 0;\n    padding: 0;\n    font-weight: 400;\n    color: inherit;\n    font-size: inherit;\n    font-family: inherit;\n    line-height: inherit;\n  }\n  .md\\:prose pre code::before {\n    content: \"\";\n  }\n  .md\\:prose pre code::after {\n    content: \"\";\n  }\n  .md\\:prose table {\n    width: 100%;\n    table-layout: auto;\n    text-align: left;\n    margin-top: 2em;\n    margin-bottom: 2em;\n    font-size: 0.875em;\n    line-height: 1.7142857;\n  }\n  .md\\:prose thead {\n    color: #161e2e;\n    font-weight: 600;\n    border-bottom-width: 1px;\n    border-bottom-color: #d2d6dc;\n  }\n  .md\\:prose thead th {\n    vertical-align: bottom;\n    padding-right: 0.5714286em;\n    padding-bottom: 0.5714286em;\n    padding-left: 0.5714286em;\n  }\n  .md\\:prose tbody tr {\n    border-bottom-width: 1px;\n    border-bottom-color: #e5e7eb;\n  }\n  .md\\:prose tbody tr:last-child {\n    border-bottom-width: 0;\n  }\n  .md\\:prose tbody td {\n    vertical-align: top;\n    padding-top: 0.5714286em;\n    padding-right: 0.5714286em;\n    padding-bottom: 0.5714286em;\n    padding-left: 0.5714286em;\n  }\n  .md\\:prose {\n    font-size: 1rem;\n    line-height: 1.75;\n  }\n  .md\\:prose p {\n    margin-top: 1.25em;\n    margin-bottom: 1.25em;\n  }\n  .md\\:prose img {\n    margin-top: 2em;\n    margin-bottom: 2em;\n  }\n  .md\\:prose video {\n    margin-top: 2em;\n    margin-bottom: 2em;\n  }\n  .md\\:prose figure {\n    margin-top: 2em;\n    margin-bottom: 2em;\n  }\n  .md\\:prose figure>* {\n    margin-top: 0;\n    margin-bottom: 0;\n  }\n  .md\\:prose h2 code {\n    font-size: 0.875em;\n  }\n  .md\\:prose h3 code {\n    font-size: 0.9em;\n  }\n  .md\\:prose ul {\n    margin-top: 1.25em;\n    margin-bottom: 1.25em;\n  }\n  .md\\:prose li {\n    margin-top: 0.5em;\n    margin-bottom: 0.5em;\n  }\n  .md\\:prose ol>li:before {\n    left: 0;\n  }\n  .md\\:prose>ul>li p {\n    margin-top: 0.75em;\n    margin-bottom: 0.75em;\n  }\n  .md\\:prose>ul>li>*:first-child {\n    margin-top: 1.25em;\n  }\n  .md\\:prose>ul>li>*:last-child {\n    margin-bottom: 1.25em;\n  }\n  .md\\:prose>ol>li>*:first-child {\n    margin-top: 1.25em;\n  }\n  .md\\:prose>ol>li>*:last-child {\n    margin-bottom: 1.25em;\n  }\n  .md\\:prose ul ul, .md\\:prose ul ol, .md\\:prose ol ul, .md\\:prose ol ol {\n    margin-top: 0.75em;\n    margin-bottom: 0.75em;\n  }\n  .md\\:prose hr+* {\n    margin-top: 0;\n  }\n  .md\\:prose h2+* {\n    margin-top: 0;\n  }\n  .md\\:prose h3+* {\n    margin-top: 0;\n  }\n  .md\\:prose h4+* {\n    margin-top: 0;\n  }\n  .md\\:prose thead th:first-child {\n    padding-left: 0;\n  }\n  .md\\:prose thead th:last-child {\n    padding-right: 0;\n  }\n  .md\\:prose tbody td:first-child {\n    padding-left: 0;\n  }\n  .md\\:prose tbody td:last-child {\n    padding-right: 0;\n  }\n  .md\\:prose> :first-child {\n    margin-top: 0;\n  }\n  .md\\:prose> :last-child {\n    margin-bottom: 0;\n  }\n  .md\\:prose h1, .md\\:prose h2, .md\\:prose h3, .md\\:prose h4 {\n    color: #161e2e;\n  }\n  .md\\:prose-sm {\n    font-size: 0.875rem;\n    line-height: 1.7142857;\n  }\n  .md\\:prose-sm p {\n    margin-top: 1.1428571em;\n    margin-bottom: 1.1428571em;\n  }\n  .md\\:prose-sm [class~=\"lead\"] {\n    font-size: 1.2857143em;\n    line-height: 1.5555556;\n    margin-top: 0.8888889em;\n    margin-bottom: 0.8888889em;\n  }\n  .md\\:prose-sm blockquote {\n    margin-top: 1.3333333em;\n    margin-bottom: 1.3333333em;\n    padding-left: 1.1111111em;\n  }\n  .md\\:prose-sm h1 {\n    font-size: 2.1428571em;\n    margin-top: 0;\n    margin-bottom: 0.8em;\n    line-height: 1.2;\n  }\n  .md\\:prose-sm h2 {\n    font-size: 1.4285714em;\n    margin-top: 1.6em;\n    margin-bottom: 0.8em;\n    line-height: 1.4;\n  }\n  .md\\:prose-sm h3 {\n    font-size: 1.2857143em;\n    margin-top: 1.5555556em;\n    margin-bottom: 0.4444444em;\n    line-height: 1.5555556;\n  }\n  .md\\:prose-sm h4 {\n    margin-top: 1.4285714em;\n    margin-bottom: 0.5714286em;\n    line-height: 1.4285714;\n  }\n  .md\\:prose-sm img {\n    margin-top: 1.7142857em;\n    margin-bottom: 1.7142857em;\n  }\n  .md\\:prose-sm video {\n    margin-top: 1.7142857em;\n    margin-bottom: 1.7142857em;\n  }\n  .md\\:prose-sm figure {\n    margin-top: 1.7142857em;\n    margin-bottom: 1.7142857em;\n  }\n  .md\\:prose-sm figure>* {\n    margin-top: 0;\n    margin-bottom: 0;\n  }\n  .md\\:prose-sm figure figcaption {\n    font-size: 0.8571429em;\n    line-height: 1.3333333;\n    margin-top: 0.6666667em;\n  }\n  .md\\:prose-sm code {\n    font-size: 0.8571429em;\n  }\n  .md\\:prose-sm h2 code {\n    font-size: 0.9em;\n  }\n  .md\\:prose-sm h3 code {\n    font-size: 0.8888889em;\n  }\n  .md\\:prose-sm pre {\n    font-size: 0.8571429em;\n    line-height: 1.6666667;\n    margin-top: 1.6666667em;\n    margin-bottom: 1.6666667em;\n    border-radius: 0.25rem;\n    padding-top: 0.6666667em;\n    padding-right: 1em;\n    padding-bottom: 0.6666667em;\n    padding-left: 1em;\n  }\n  .md\\:prose-sm ol {\n    margin-top: 1.1428571em;\n    margin-bottom: 1.1428571em;\n  }\n  .md\\:prose-sm ul {\n    margin-top: 1.1428571em;\n    margin-bottom: 1.1428571em;\n  }\n  .md\\:prose-sm li {\n    margin-top: 0.2857143em;\n    margin-bottom: 0.2857143em;\n  }\n  .md\\:prose-sm ol>li {\n    padding-left: 1.5714286em;\n  }\n  .md\\:prose-sm ol>li:before {\n    left: 0;\n  }\n  .md\\:prose-sm ul>li {\n    padding-left: 1.5714286em;\n  }\n  .md\\:prose-sm ul>li::before {\n    height: 0.3571429em;\n    width: 0.3571429em;\n    top: calc(0.8571429em - 0.1785714em);\n    left: 0.2142857em;\n  }\n  .md\\:prose-sm>ul>li p {\n    margin-top: 0.5714286em;\n    margin-bottom: 0.5714286em;\n  }\n  .md\\:prose-sm>ul>li>*:first-child {\n    margin-top: 1.1428571em;\n  }\n  .md\\:prose-sm>ul>li>*:last-child {\n    margin-bottom: 1.1428571em;\n  }\n  .md\\:prose-sm>ol>li>*:first-child {\n    margin-top: 1.1428571em;\n  }\n  .md\\:prose-sm>ol>li>*:last-child {\n    margin-bottom: 1.1428571em;\n  }\n  .md\\:prose-sm ul ul, .md\\:prose-sm ul ol, .md\\:prose-sm ol ul, .md\\:prose-sm ol ol {\n    margin-top: 0.5714286em;\n    margin-bottom: 0.5714286em;\n  }\n  .md\\:prose-sm hr {\n    margin-top: 2.8571429em;\n    margin-bottom: 2.8571429em;\n  }\n  .md\\:prose-sm hr+* {\n    margin-top: 0;\n  }\n  .md\\:prose-sm h2+* {\n    margin-top: 0;\n  }\n  .md\\:prose-sm h3+* {\n    margin-top: 0;\n  }\n  .md\\:prose-sm h4+* {\n    margin-top: 0;\n  }\n  .md\\:prose-sm table {\n    font-size: 0.8571429em;\n    line-height: 1.5;\n  }\n  .md\\:prose-sm thead th {\n    padding-right: 1em;\n    padding-bottom: 0.6666667em;\n    padding-left: 1em;\n  }\n  .md\\:prose-sm thead th:first-child {\n    padding-left: 0;\n  }\n  .md\\:prose-sm thead th:last-child {\n    padding-right: 0;\n  }\n  .md\\:prose-sm tbody td {\n    padding-top: 0.6666667em;\n    padding-right: 1em;\n    padding-bottom: 0.6666667em;\n    padding-left: 1em;\n  }\n  .md\\:prose-sm tbody td:first-child {\n    padding-left: 0;\n  }\n  .md\\:prose-sm tbody td:last-child {\n    padding-right: 0;\n  }\n  .md\\:prose-sm> :first-child {\n    margin-top: 0;\n  }\n  .md\\:prose-sm> :last-child {\n    margin-bottom: 0;\n  }\n  .md\\:prose-lg {\n    font-size: 1.125rem;\n    line-height: 1.7777778;\n  }\n  .md\\:prose-lg p {\n    margin-top: 1.3333333em;\n    margin-bottom: 1.3333333em;\n  }\n  .md\\:prose-lg [class~=\"lead\"] {\n    font-size: 1.2222222em;\n    line-height: 1.4545455;\n    margin-top: 1.0909091em;\n    margin-bottom: 1.0909091em;\n  }\n  .md\\:prose-lg blockquote {\n    margin-top: 1.6666667em;\n    margin-bottom: 1.6666667em;\n    padding-left: 1em;\n  }\n  .md\\:prose-lg h1 {\n    font-size: 2.6666667em;\n    margin-top: 0;\n    margin-bottom: 0.8333333em;\n    line-height: 1;\n  }\n  .md\\:prose-lg h2 {\n    font-size: 1.6666667em;\n    margin-top: 1.8666667em;\n    margin-bottom: 1.0666667em;\n    line-height: 1.3333333;\n  }\n  .md\\:prose-lg h3 {\n    font-size: 1.3333333em;\n    margin-top: 1.6666667em;\n    margin-bottom: 0.6666667em;\n    line-height: 1.5;\n  }\n  .md\\:prose-lg h4 {\n    margin-top: 1.7777778em;\n    margin-bottom: 0.4444444em;\n    line-height: 1.5555556;\n  }\n  .md\\:prose-lg img {\n    margin-top: 1.7777778em;\n    margin-bottom: 1.7777778em;\n  }\n  .md\\:prose-lg video {\n    margin-top: 1.7777778em;\n    margin-bottom: 1.7777778em;\n  }\n  .md\\:prose-lg figure {\n    margin-top: 1.7777778em;\n    margin-bottom: 1.7777778em;\n  }\n  .md\\:prose-lg figure>* {\n    margin-top: 0;\n    margin-bottom: 0;\n  }\n  .md\\:prose-lg figure figcaption {\n    font-size: 0.8888889em;\n    line-height: 1.5;\n    margin-top: 1em;\n  }\n  .md\\:prose-lg code {\n    font-size: 0.8888889em;\n  }\n  .md\\:prose-lg h2 code {\n    font-size: 0.8666667em;\n  }\n  .md\\:prose-lg h3 code {\n    font-size: 0.875em;\n  }\n  .md\\:prose-lg pre {\n    font-size: 0.8888889em;\n    line-height: 1.75;\n    margin-top: 2em;\n    margin-bottom: 2em;\n    border-radius: 0.375rem;\n    padding-top: 1em;\n    padding-right: 1.5em;\n    padding-bottom: 1em;\n    padding-left: 1.5em;\n  }\n  .md\\:prose-lg ol {\n    margin-top: 1.3333333em;\n    margin-bottom: 1.3333333em;\n  }\n  .md\\:prose-lg ul {\n    margin-top: 1.3333333em;\n    margin-bottom: 1.3333333em;\n  }\n  .md\\:prose-lg li {\n    margin-top: 0.6666667em;\n    margin-bottom: 0.6666667em;\n  }\n  .md\\:prose-lg ol>li {\n    padding-left: 1.6666667em;\n  }\n  .md\\:prose-lg ol>li:before {\n    left: 0;\n  }\n  .md\\:prose-lg ul>li {\n    padding-left: 1.6666667em;\n  }\n  .md\\:prose-lg ul>li::before {\n    width: 0.3333333em;\n    height: 0.3333333em;\n    top: calc(0.8888889em - 0.1666667em);\n    left: 0.2222222em;\n  }\n  .md\\:prose-lg>ul>li p {\n    margin-top: 0.8888889em;\n    margin-bottom: 0.8888889em;\n  }\n  .md\\:prose-lg>ul>li>*:first-child {\n    margin-top: 1.3333333em;\n  }\n  .md\\:prose-lg>ul>li>*:last-child {\n    margin-bottom: 1.3333333em;\n  }\n  .md\\:prose-lg>ol>li>*:first-child {\n    margin-top: 1.3333333em;\n  }\n  .md\\:prose-lg>ol>li>*:last-child {\n    margin-bottom: 1.3333333em;\n  }\n  .md\\:prose-lg ul ul, .md\\:prose-lg ul ol, .md\\:prose-lg ol ul, .md\\:prose-lg ol ol {\n    margin-top: 0.8888889em;\n    margin-bottom: 0.8888889em;\n  }\n  .md\\:prose-lg hr {\n    margin-top: 3.1111111em;\n    margin-bottom: 3.1111111em;\n  }\n  .md\\:prose-lg hr+* {\n    margin-top: 0;\n  }\n  .md\\:prose-lg h2+* {\n    margin-top: 0;\n  }\n  .md\\:prose-lg h3+* {\n    margin-top: 0;\n  }\n  .md\\:prose-lg h4+* {\n    margin-top: 0;\n  }\n  .md\\:prose-lg table {\n    font-size: 0.8888889em;\n    line-height: 1.5;\n  }\n  .md\\:prose-lg thead th {\n    padding-right: 0.75em;\n    padding-bottom: 0.75em;\n    padding-left: 0.75em;\n  }\n  .md\\:prose-lg thead th:first-child {\n    padding-left: 0;\n  }\n  .md\\:prose-lg thead th:last-child {\n    padding-right: 0;\n  }\n  .md\\:prose-lg tbody td {\n    padding-top: 0.75em;\n    padding-right: 0.75em;\n    padding-bottom: 0.75em;\n    padding-left: 0.75em;\n  }\n  .md\\:prose-lg tbody td:first-child {\n    padding-left: 0;\n  }\n  .md\\:prose-lg tbody td:last-child {\n    padding-right: 0;\n  }\n  .md\\:prose-lg> :first-child {\n    margin-top: 0;\n  }\n  .md\\:prose-lg> :last-child {\n    margin-bottom: 0;\n  }\n  .md\\:prose-xl {\n    font-size: 1.25rem;\n    line-height: 1.8;\n  }\n  .md\\:prose-xl p {\n    margin-top: 1.2em;\n    margin-bottom: 1.2em;\n  }\n  .md\\:prose-xl [class~=\"lead\"] {\n    font-size: 1.2em;\n    line-height: 1.5;\n    margin-top: 1em;\n    margin-bottom: 1em;\n  }\n  .md\\:prose-xl blockquote {\n    margin-top: 1.6em;\n    margin-bottom: 1.6em;\n    padding-left: 1.0666667em;\n  }\n  .md\\:prose-xl h1 {\n    font-size: 2.8em;\n    margin-top: 0;\n    margin-bottom: 0.8571429em;\n    line-height: 1;\n  }\n  .md\\:prose-xl h2 {\n    font-size: 1.8em;\n    margin-top: 1.5555556em;\n    margin-bottom: 0.8888889em;\n    line-height: 1.1111111;\n  }\n  .md\\:prose-xl h3 {\n    font-size: 1.5em;\n    margin-top: 1.6em;\n    margin-bottom: 0.6666667em;\n    line-height: 1.3333333;\n  }\n  .md\\:prose-xl h4 {\n    margin-top: 1.8em;\n    margin-bottom: 0.6em;\n    line-height: 1.6;\n  }\n  .md\\:prose-xl img {\n    margin-top: 2em;\n    margin-bottom: 2em;\n  }\n  .md\\:prose-xl video {\n    margin-top: 2em;\n    margin-bottom: 2em;\n  }\n  .md\\:prose-xl figure {\n    margin-top: 2em;\n    margin-bottom: 2em;\n  }\n  .md\\:prose-xl figure>* {\n    margin-top: 0;\n    margin-bottom: 0;\n  }\n  .md\\:prose-xl figure figcaption {\n    font-size: 0.9em;\n    line-height: 1.5555556;\n    margin-top: 1em;\n  }\n  .md\\:prose-xl code {\n    font-size: 0.9em;\n  }\n  .md\\:prose-xl h2 code {\n    font-size: 0.8611111em;\n  }\n  .md\\:prose-xl h3 code {\n    font-size: 0.9em;\n  }\n  .md\\:prose-xl pre {\n    font-size: 0.9em;\n    line-height: 1.7777778;\n    margin-top: 2em;\n    margin-bottom: 2em;\n    border-radius: 0.5rem;\n    padding-top: 1.1111111em;\n    padding-right: 1.3333333em;\n    padding-bottom: 1.1111111em;\n    padding-left: 1.3333333em;\n  }\n  .md\\:prose-xl ol {\n    margin-top: 1.2em;\n    margin-bottom: 1.2em;\n  }\n  .md\\:prose-xl ul {\n    margin-top: 1.2em;\n    margin-bottom: 1.2em;\n  }\n  .md\\:prose-xl li {\n    margin-top: 0.6em;\n    margin-bottom: 0.6em;\n  }\n  .md\\:prose-xl ol>li {\n    padding-left: 1.8em;\n  }\n  .md\\:prose-xl ol>li:before {\n    left: 0;\n  }\n  .md\\:prose-xl ul>li {\n    padding-left: 1.8em;\n  }\n  .md\\:prose-xl ul>li::before {\n    width: 0.35em;\n    height: 0.35em;\n    top: calc(0.9em - 0.175em);\n    left: 0.25em;\n  }\n  .md\\:prose-xl>ul>li p {\n    margin-top: 0.8em;\n    margin-bottom: 0.8em;\n  }\n  .md\\:prose-xl>ul>li>*:first-child {\n    margin-top: 1.2em;\n  }\n  .md\\:prose-xl>ul>li>*:last-child {\n    margin-bottom: 1.2em;\n  }\n  .md\\:prose-xl>ol>li>*:first-child {\n    margin-top: 1.2em;\n  }\n  .md\\:prose-xl>ol>li>*:last-child {\n    margin-bottom: 1.2em;\n  }\n  .md\\:prose-xl ul ul, .md\\:prose-xl ul ol, .md\\:prose-xl ol ul, .md\\:prose-xl ol ol {\n    margin-top: 0.8em;\n    margin-bottom: 0.8em;\n  }\n  .md\\:prose-xl hr {\n    margin-top: 2.8em;\n    margin-bottom: 2.8em;\n  }\n  .md\\:prose-xl hr+* {\n    margin-top: 0;\n  }\n  .md\\:prose-xl h2+* {\n    margin-top: 0;\n  }\n  .md\\:prose-xl h3+* {\n    margin-top: 0;\n  }\n  .md\\:prose-xl h4+* {\n    margin-top: 0;\n  }\n  .md\\:prose-xl table {\n    font-size: 0.9em;\n    line-height: 1.5555556;\n  }\n  .md\\:prose-xl thead th {\n    padding-right: 0.6666667em;\n    padding-bottom: 0.8888889em;\n    padding-left: 0.6666667em;\n  }\n  .md\\:prose-xl thead th:first-child {\n    padding-left: 0;\n  }\n  .md\\:prose-xl thead th:last-child {\n    padding-right: 0;\n  }\n  .md\\:prose-xl tbody td {\n    padding-top: 0.8888889em;\n    padding-right: 0.6666667em;\n    padding-bottom: 0.8888889em;\n    padding-left: 0.6666667em;\n  }\n  .md\\:prose-xl tbody td:first-child {\n    padding-left: 0;\n  }\n  .md\\:prose-xl tbody td:last-child {\n    padding-right: 0;\n  }\n  .md\\:prose-xl> :first-child {\n    margin-top: 0;\n  }\n  .md\\:prose-xl> :last-child {\n    margin-bottom: 0;\n  }\n  .md\\:prose-2xl {\n    font-size: 1.5rem;\n    line-height: 1.6666667;\n  }\n  .md\\:prose-2xl p {\n    margin-top: 1.3333333em;\n    margin-bottom: 1.3333333em;\n  }\n  .md\\:prose-2xl [class~=\"lead\"] {\n    font-size: 1.25em;\n    line-height: 1.4666667;\n    margin-top: 1.0666667em;\n    margin-bottom: 1.0666667em;\n  }\n  .md\\:prose-2xl blockquote {\n    margin-top: 1.7777778em;\n    margin-bottom: 1.7777778em;\n    padding-left: 1.1111111em;\n  }\n  .md\\:prose-2xl h1 {\n    font-size: 2.6666667em;\n    margin-top: 0;\n    margin-bottom: 0.875em;\n    line-height: 1;\n  }\n  .md\\:prose-2xl h2 {\n    font-size: 2em;\n    margin-top: 1.5em;\n    margin-bottom: 0.8333333em;\n    line-height: 1.0833333;\n  }\n  .md\\:prose-2xl h3 {\n    font-size: 1.5em;\n    margin-top: 1.5555556em;\n    margin-bottom: 0.6666667em;\n    line-height: 1.2222222;\n  }\n  .md\\:prose-2xl h4 {\n    margin-top: 1.6666667em;\n    margin-bottom: 0.6666667em;\n    line-height: 1.5;\n  }\n  .md\\:prose-2xl img {\n    margin-top: 2em;\n    margin-bottom: 2em;\n  }\n  .md\\:prose-2xl video {\n    margin-top: 2em;\n    margin-bottom: 2em;\n  }\n  .md\\:prose-2xl figure {\n    margin-top: 2em;\n    margin-bottom: 2em;\n  }\n  .md\\:prose-2xl figure>* {\n    margin-top: 0;\n    margin-bottom: 0;\n  }\n  .md\\:prose-2xl figure figcaption {\n    font-size: 0.8333333em;\n    line-height: 1.6;\n    margin-top: 1em;\n  }\n  .md\\:prose-2xl code {\n    font-size: 0.8333333em;\n  }\n  .md\\:prose-2xl h2 code {\n    font-size: 0.875em;\n  }\n  .md\\:prose-2xl h3 code {\n    font-size: 0.8888889em;\n  }\n  .md\\:prose-2xl pre {\n    font-size: 0.8333333em;\n    line-height: 1.8;\n    margin-top: 2em;\n    margin-bottom: 2em;\n    border-radius: 0.5rem;\n    padding-top: 1.2em;\n    padding-right: 1.6em;\n    padding-bottom: 1.2em;\n    padding-left: 1.6em;\n  }\n  .md\\:prose-2xl ol {\n    margin-top: 1.3333333em;\n    margin-bottom: 1.3333333em;\n  }\n  .md\\:prose-2xl ul {\n    margin-top: 1.3333333em;\n    margin-bottom: 1.3333333em;\n  }\n  .md\\:prose-2xl li {\n    margin-top: 0.5em;\n    margin-bottom: 0.5em;\n  }\n  .md\\:prose-2xl ol>li {\n    padding-left: 1.6666667em;\n  }\n  .md\\:prose-2xl ol>li:before {\n    left: 0;\n  }\n  .md\\:prose-2xl ul>li {\n    padding-left: 1.6666667em;\n  }\n  .md\\:prose-2xl ul>li::before {\n    width: 0.3333333em;\n    height: 0.3333333em;\n    top: calc(0.8333333em - 0.1666667em);\n    left: 0.25em;\n  }\n  .md\\:prose-2xl>ul>li p {\n    margin-top: 0.8333333em;\n    margin-bottom: 0.8333333em;\n  }\n  .md\\:prose-2xl>ul>li>*:first-child {\n    margin-top: 1.3333333em;\n  }\n  .md\\:prose-2xl>ul>li>*:last-child {\n    margin-bottom: 1.3333333em;\n  }\n  .md\\:prose-2xl>ol>li>*:first-child {\n    margin-top: 1.3333333em;\n  }\n  .md\\:prose-2xl>ol>li>*:last-child {\n    margin-bottom: 1.3333333em;\n  }\n  .md\\:prose-2xl ul ul, .md\\:prose-2xl ul ol, .md\\:prose-2xl ol ul, .md\\:prose-2xl ol ol {\n    margin-top: 0.6666667em;\n    margin-bottom: 0.6666667em;\n  }\n  .md\\:prose-2xl hr {\n    margin-top: 3em;\n    margin-bottom: 3em;\n  }\n  .md\\:prose-2xl hr+* {\n    margin-top: 0;\n  }\n  .md\\:prose-2xl h2+* {\n    margin-top: 0;\n  }\n  .md\\:prose-2xl h3+* {\n    margin-top: 0;\n  }\n  .md\\:prose-2xl h4+* {\n    margin-top: 0;\n  }\n  .md\\:prose-2xl table {\n    font-size: 0.8333333em;\n    line-height: 1.4;\n  }\n  .md\\:prose-2xl thead th {\n    padding-right: 0.6em;\n    padding-bottom: 0.8em;\n    padding-left: 0.6em;\n  }\n  .md\\:prose-2xl thead th:first-child {\n    padding-left: 0;\n  }\n  .md\\:prose-2xl thead th:last-child {\n    padding-right: 0;\n  }\n  .md\\:prose-2xl tbody td {\n    padding-top: 0.8em;\n    padding-right: 0.6em;\n    padding-bottom: 0.8em;\n    padding-left: 0.6em;\n  }\n  .md\\:prose-2xl tbody td:first-child {\n    padding-left: 0;\n  }\n  .md\\:prose-2xl tbody td:last-child {\n    padding-right: 0;\n  }\n  .md\\:prose-2xl> :first-child {\n    margin-top: 0;\n  }\n  .md\\:prose-2xl> :last-child {\n    margin-bottom: 0;\n  }\n  .md\\:space-y-0> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(0px * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(0px * var(--space-y-reverse));\n  }\n  .md\\:space-x-0> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(0px * var(--space-x-reverse));\n    margin-left: calc(0px * calc(1 - var(--space-x-reverse)));\n  }\n  .md\\:space-y-1> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(0.25rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(0.25rem * var(--space-y-reverse));\n  }\n  .md\\:space-x-1> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(0.25rem * var(--space-x-reverse));\n    margin-left: calc(0.25rem * calc(1 - var(--space-x-reverse)));\n  }\n  .md\\:space-y-2> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(0.5rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(0.5rem * var(--space-y-reverse));\n  }\n  .md\\:space-x-2> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(0.5rem * var(--space-x-reverse));\n    margin-left: calc(0.5rem * calc(1 - var(--space-x-reverse)));\n  }\n  .md\\:space-y-3> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(0.75rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(0.75rem * var(--space-y-reverse));\n  }\n  .md\\:space-x-3> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(0.75rem * var(--space-x-reverse));\n    margin-left: calc(0.75rem * calc(1 - var(--space-x-reverse)));\n  }\n  .md\\:space-y-4> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(1rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(1rem * var(--space-y-reverse));\n  }\n  .md\\:space-x-4> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(1rem * var(--space-x-reverse));\n    margin-left: calc(1rem * calc(1 - var(--space-x-reverse)));\n  }\n  .md\\:space-y-5> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(1.25rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(1.25rem * var(--space-y-reverse));\n  }\n  .md\\:space-x-5> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(1.25rem * var(--space-x-reverse));\n    margin-left: calc(1.25rem * calc(1 - var(--space-x-reverse)));\n  }\n  .md\\:space-y-6> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(1.5rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(1.5rem * var(--space-y-reverse));\n  }\n  .md\\:space-x-6> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(1.5rem * var(--space-x-reverse));\n    margin-left: calc(1.5rem * calc(1 - var(--space-x-reverse)));\n  }\n  .md\\:space-y-7> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(1.75rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(1.75rem * var(--space-y-reverse));\n  }\n  .md\\:space-x-7> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(1.75rem * var(--space-x-reverse));\n    margin-left: calc(1.75rem * calc(1 - var(--space-x-reverse)));\n  }\n  .md\\:space-y-8> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(2rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(2rem * var(--space-y-reverse));\n  }\n  .md\\:space-x-8> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(2rem * var(--space-x-reverse));\n    margin-left: calc(2rem * calc(1 - var(--space-x-reverse)));\n  }\n  .md\\:space-y-9> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(2.25rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(2.25rem * var(--space-y-reverse));\n  }\n  .md\\:space-x-9> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(2.25rem * var(--space-x-reverse));\n    margin-left: calc(2.25rem * calc(1 - var(--space-x-reverse)));\n  }\n  .md\\:space-y-10> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(2.5rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(2.5rem * var(--space-y-reverse));\n  }\n  .md\\:space-x-10> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(2.5rem * var(--space-x-reverse));\n    margin-left: calc(2.5rem * calc(1 - var(--space-x-reverse)));\n  }\n  .md\\:space-y-11> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(2.75rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(2.75rem * var(--space-y-reverse));\n  }\n  .md\\:space-x-11> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(2.75rem * var(--space-x-reverse));\n    margin-left: calc(2.75rem * calc(1 - var(--space-x-reverse)));\n  }\n  .md\\:space-y-12> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(3rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(3rem * var(--space-y-reverse));\n  }\n  .md\\:space-x-12> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(3rem * var(--space-x-reverse));\n    margin-left: calc(3rem * calc(1 - var(--space-x-reverse)));\n  }\n  .md\\:space-y-13> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(3.25rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(3.25rem * var(--space-y-reverse));\n  }\n  .md\\:space-x-13> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(3.25rem * var(--space-x-reverse));\n    margin-left: calc(3.25rem * calc(1 - var(--space-x-reverse)));\n  }\n  .md\\:space-y-14> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(3.5rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(3.5rem * var(--space-y-reverse));\n  }\n  .md\\:space-x-14> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(3.5rem * var(--space-x-reverse));\n    margin-left: calc(3.5rem * calc(1 - var(--space-x-reverse)));\n  }\n  .md\\:space-y-15> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(3.75rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(3.75rem * var(--space-y-reverse));\n  }\n  .md\\:space-x-15> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(3.75rem * var(--space-x-reverse));\n    margin-left: calc(3.75rem * calc(1 - var(--space-x-reverse)));\n  }\n  .md\\:space-y-16> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(4rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(4rem * var(--space-y-reverse));\n  }\n  .md\\:space-x-16> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(4rem * var(--space-x-reverse));\n    margin-left: calc(4rem * calc(1 - var(--space-x-reverse)));\n  }\n  .md\\:space-y-20> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(5rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(5rem * var(--space-y-reverse));\n  }\n  .md\\:space-x-20> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(5rem * var(--space-x-reverse));\n    margin-left: calc(5rem * calc(1 - var(--space-x-reverse)));\n  }\n  .md\\:space-y-24> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(6rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(6rem * var(--space-y-reverse));\n  }\n  .md\\:space-x-24> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(6rem * var(--space-x-reverse));\n    margin-left: calc(6rem * calc(1 - var(--space-x-reverse)));\n  }\n  .md\\:space-y-28> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(7rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(7rem * var(--space-y-reverse));\n  }\n  .md\\:space-x-28> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(7rem * var(--space-x-reverse));\n    margin-left: calc(7rem * calc(1 - var(--space-x-reverse)));\n  }\n  .md\\:space-y-32> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(8rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(8rem * var(--space-y-reverse));\n  }\n  .md\\:space-x-32> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(8rem * var(--space-x-reverse));\n    margin-left: calc(8rem * calc(1 - var(--space-x-reverse)));\n  }\n  .md\\:space-y-36> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(9rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(9rem * var(--space-y-reverse));\n  }\n  .md\\:space-x-36> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(9rem * var(--space-x-reverse));\n    margin-left: calc(9rem * calc(1 - var(--space-x-reverse)));\n  }\n  .md\\:space-y-40> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(10rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(10rem * var(--space-y-reverse));\n  }\n  .md\\:space-x-40> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(10rem * var(--space-x-reverse));\n    margin-left: calc(10rem * calc(1 - var(--space-x-reverse)));\n  }\n  .md\\:space-y-44> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(11rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(11rem * var(--space-y-reverse));\n  }\n  .md\\:space-x-44> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(11rem * var(--space-x-reverse));\n    margin-left: calc(11rem * calc(1 - var(--space-x-reverse)));\n  }\n  .md\\:space-y-48> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(12rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(12rem * var(--space-y-reverse));\n  }\n  .md\\:space-x-48> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(12rem * var(--space-x-reverse));\n    margin-left: calc(12rem * calc(1 - var(--space-x-reverse)));\n  }\n  .md\\:space-y-52> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(13rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(13rem * var(--space-y-reverse));\n  }\n  .md\\:space-x-52> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(13rem * var(--space-x-reverse));\n    margin-left: calc(13rem * calc(1 - var(--space-x-reverse)));\n  }\n  .md\\:space-y-56> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(14rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(14rem * var(--space-y-reverse));\n  }\n  .md\\:space-x-56> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(14rem * var(--space-x-reverse));\n    margin-left: calc(14rem * calc(1 - var(--space-x-reverse)));\n  }\n  .md\\:space-y-60> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(15rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(15rem * var(--space-y-reverse));\n  }\n  .md\\:space-x-60> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(15rem * var(--space-x-reverse));\n    margin-left: calc(15rem * calc(1 - var(--space-x-reverse)));\n  }\n  .md\\:space-y-64> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(16rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(16rem * var(--space-y-reverse));\n  }\n  .md\\:space-x-64> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(16rem * var(--space-x-reverse));\n    margin-left: calc(16rem * calc(1 - var(--space-x-reverse)));\n  }\n  .md\\:space-y-72> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(18rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(18rem * var(--space-y-reverse));\n  }\n  .md\\:space-x-72> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(18rem * var(--space-x-reverse));\n    margin-left: calc(18rem * calc(1 - var(--space-x-reverse)));\n  }\n  .md\\:space-y-80> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(20rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(20rem * var(--space-y-reverse));\n  }\n  .md\\:space-x-80> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(20rem * var(--space-x-reverse));\n    margin-left: calc(20rem * calc(1 - var(--space-x-reverse)));\n  }\n  .md\\:space-y-96> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(24rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(24rem * var(--space-y-reverse));\n  }\n  .md\\:space-x-96> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(24rem * var(--space-x-reverse));\n    margin-left: calc(24rem * calc(1 - var(--space-x-reverse)));\n  }\n  .md\\:space-y-px> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(1px * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(1px * var(--space-y-reverse));\n  }\n  .md\\:space-x-px> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(1px * var(--space-x-reverse));\n    margin-left: calc(1px * calc(1 - var(--space-x-reverse)));\n  }\n  .md\\:space-y-0\\.5> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(0.125rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(0.125rem * var(--space-y-reverse));\n  }\n  .md\\:space-x-0\\.5> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(0.125rem * var(--space-x-reverse));\n    margin-left: calc(0.125rem * calc(1 - var(--space-x-reverse)));\n  }\n  .md\\:space-y-1\\.5> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(0.375rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(0.375rem * var(--space-y-reverse));\n  }\n  .md\\:space-x-1\\.5> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(0.375rem * var(--space-x-reverse));\n    margin-left: calc(0.375rem * calc(1 - var(--space-x-reverse)));\n  }\n  .md\\:space-y-2\\.5> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(0.625rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(0.625rem * var(--space-y-reverse));\n  }\n  .md\\:space-x-2\\.5> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(0.625rem * var(--space-x-reverse));\n    margin-left: calc(0.625rem * calc(1 - var(--space-x-reverse)));\n  }\n  .md\\:space-y-3\\.5> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(0.875rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(0.875rem * var(--space-y-reverse));\n  }\n  .md\\:space-x-3\\.5> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(0.875rem * var(--space-x-reverse));\n    margin-left: calc(0.875rem * calc(1 - var(--space-x-reverse)));\n  }\n  .md\\:space-y-1\\/2> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(50% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(50% * var(--space-y-reverse));\n  }\n  .md\\:space-x-1\\/2> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(50% * var(--space-x-reverse));\n    margin-left: calc(50% * calc(1 - var(--space-x-reverse)));\n  }\n  .md\\:space-y-1\\/3> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(33.333333% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(33.333333% * var(--space-y-reverse));\n  }\n  .md\\:space-x-1\\/3> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(33.333333% * var(--space-x-reverse));\n    margin-left: calc(33.333333% * calc(1 - var(--space-x-reverse)));\n  }\n  .md\\:space-y-2\\/3> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(66.666667% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(66.666667% * var(--space-y-reverse));\n  }\n  .md\\:space-x-2\\/3> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(66.666667% * var(--space-x-reverse));\n    margin-left: calc(66.666667% * calc(1 - var(--space-x-reverse)));\n  }\n  .md\\:space-y-1\\/4> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(25% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(25% * var(--space-y-reverse));\n  }\n  .md\\:space-x-1\\/4> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(25% * var(--space-x-reverse));\n    margin-left: calc(25% * calc(1 - var(--space-x-reverse)));\n  }\n  .md\\:space-y-2\\/4> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(50% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(50% * var(--space-y-reverse));\n  }\n  .md\\:space-x-2\\/4> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(50% * var(--space-x-reverse));\n    margin-left: calc(50% * calc(1 - var(--space-x-reverse)));\n  }\n  .md\\:space-y-3\\/4> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(75% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(75% * var(--space-y-reverse));\n  }\n  .md\\:space-x-3\\/4> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(75% * var(--space-x-reverse));\n    margin-left: calc(75% * calc(1 - var(--space-x-reverse)));\n  }\n  .md\\:space-y-1\\/5> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(20% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(20% * var(--space-y-reverse));\n  }\n  .md\\:space-x-1\\/5> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(20% * var(--space-x-reverse));\n    margin-left: calc(20% * calc(1 - var(--space-x-reverse)));\n  }\n  .md\\:space-y-2\\/5> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(40% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(40% * var(--space-y-reverse));\n  }\n  .md\\:space-x-2\\/5> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(40% * var(--space-x-reverse));\n    margin-left: calc(40% * calc(1 - var(--space-x-reverse)));\n  }\n  .md\\:space-y-3\\/5> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(60% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(60% * var(--space-y-reverse));\n  }\n  .md\\:space-x-3\\/5> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(60% * var(--space-x-reverse));\n    margin-left: calc(60% * calc(1 - var(--space-x-reverse)));\n  }\n  .md\\:space-y-4\\/5> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(80% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(80% * var(--space-y-reverse));\n  }\n  .md\\:space-x-4\\/5> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(80% * var(--space-x-reverse));\n    margin-left: calc(80% * calc(1 - var(--space-x-reverse)));\n  }\n  .md\\:space-y-1\\/6> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(16.666667% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(16.666667% * var(--space-y-reverse));\n  }\n  .md\\:space-x-1\\/6> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(16.666667% * var(--space-x-reverse));\n    margin-left: calc(16.666667% * calc(1 - var(--space-x-reverse)));\n  }\n  .md\\:space-y-2\\/6> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(33.333333% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(33.333333% * var(--space-y-reverse));\n  }\n  .md\\:space-x-2\\/6> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(33.333333% * var(--space-x-reverse));\n    margin-left: calc(33.333333% * calc(1 - var(--space-x-reverse)));\n  }\n  .md\\:space-y-3\\/6> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(50% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(50% * var(--space-y-reverse));\n  }\n  .md\\:space-x-3\\/6> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(50% * var(--space-x-reverse));\n    margin-left: calc(50% * calc(1 - var(--space-x-reverse)));\n  }\n  .md\\:space-y-4\\/6> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(66.666667% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(66.666667% * var(--space-y-reverse));\n  }\n  .md\\:space-x-4\\/6> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(66.666667% * var(--space-x-reverse));\n    margin-left: calc(66.666667% * calc(1 - var(--space-x-reverse)));\n  }\n  .md\\:space-y-5\\/6> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(83.333333% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(83.333333% * var(--space-y-reverse));\n  }\n  .md\\:space-x-5\\/6> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(83.333333% * var(--space-x-reverse));\n    margin-left: calc(83.333333% * calc(1 - var(--space-x-reverse)));\n  }\n  .md\\:space-y-1\\/12> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(8.333333% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(8.333333% * var(--space-y-reverse));\n  }\n  .md\\:space-x-1\\/12> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(8.333333% * var(--space-x-reverse));\n    margin-left: calc(8.333333% * calc(1 - var(--space-x-reverse)));\n  }\n  .md\\:space-y-2\\/12> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(16.666667% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(16.666667% * var(--space-y-reverse));\n  }\n  .md\\:space-x-2\\/12> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(16.666667% * var(--space-x-reverse));\n    margin-left: calc(16.666667% * calc(1 - var(--space-x-reverse)));\n  }\n  .md\\:space-y-3\\/12> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(25% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(25% * var(--space-y-reverse));\n  }\n  .md\\:space-x-3\\/12> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(25% * var(--space-x-reverse));\n    margin-left: calc(25% * calc(1 - var(--space-x-reverse)));\n  }\n  .md\\:space-y-4\\/12> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(33.333333% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(33.333333% * var(--space-y-reverse));\n  }\n  .md\\:space-x-4\\/12> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(33.333333% * var(--space-x-reverse));\n    margin-left: calc(33.333333% * calc(1 - var(--space-x-reverse)));\n  }\n  .md\\:space-y-5\\/12> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(41.666667% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(41.666667% * var(--space-y-reverse));\n  }\n  .md\\:space-x-5\\/12> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(41.666667% * var(--space-x-reverse));\n    margin-left: calc(41.666667% * calc(1 - var(--space-x-reverse)));\n  }\n  .md\\:space-y-6\\/12> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(50% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(50% * var(--space-y-reverse));\n  }\n  .md\\:space-x-6\\/12> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(50% * var(--space-x-reverse));\n    margin-left: calc(50% * calc(1 - var(--space-x-reverse)));\n  }\n  .md\\:space-y-7\\/12> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(58.333333% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(58.333333% * var(--space-y-reverse));\n  }\n  .md\\:space-x-7\\/12> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(58.333333% * var(--space-x-reverse));\n    margin-left: calc(58.333333% * calc(1 - var(--space-x-reverse)));\n  }\n  .md\\:space-y-8\\/12> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(66.666667% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(66.666667% * var(--space-y-reverse));\n  }\n  .md\\:space-x-8\\/12> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(66.666667% * var(--space-x-reverse));\n    margin-left: calc(66.666667% * calc(1 - var(--space-x-reverse)));\n  }\n  .md\\:space-y-9\\/12> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(75% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(75% * var(--space-y-reverse));\n  }\n  .md\\:space-x-9\\/12> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(75% * var(--space-x-reverse));\n    margin-left: calc(75% * calc(1 - var(--space-x-reverse)));\n  }\n  .md\\:space-y-10\\/12> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(83.333333% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(83.333333% * var(--space-y-reverse));\n  }\n  .md\\:space-x-10\\/12> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(83.333333% * var(--space-x-reverse));\n    margin-left: calc(83.333333% * calc(1 - var(--space-x-reverse)));\n  }\n  .md\\:space-y-11\\/12> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(91.666667% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(91.666667% * var(--space-y-reverse));\n  }\n  .md\\:space-x-11\\/12> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(91.666667% * var(--space-x-reverse));\n    margin-left: calc(91.666667% * calc(1 - var(--space-x-reverse)));\n  }\n  .md\\:space-y-full> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(100% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(100% * var(--space-y-reverse));\n  }\n  .md\\:space-x-full> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(100% * var(--space-x-reverse));\n    margin-left: calc(100% * calc(1 - var(--space-x-reverse)));\n  }\n  .md\\:-space-y-1> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-0.25rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-0.25rem * var(--space-y-reverse));\n  }\n  .md\\:-space-x-1> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-0.25rem * var(--space-x-reverse));\n    margin-left: calc(-0.25rem * calc(1 - var(--space-x-reverse)));\n  }\n  .md\\:-space-y-2> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-0.5rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-0.5rem * var(--space-y-reverse));\n  }\n  .md\\:-space-x-2> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-0.5rem * var(--space-x-reverse));\n    margin-left: calc(-0.5rem * calc(1 - var(--space-x-reverse)));\n  }\n  .md\\:-space-y-3> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-0.75rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-0.75rem * var(--space-y-reverse));\n  }\n  .md\\:-space-x-3> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-0.75rem * var(--space-x-reverse));\n    margin-left: calc(-0.75rem * calc(1 - var(--space-x-reverse)));\n  }\n  .md\\:-space-y-4> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-1rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-1rem * var(--space-y-reverse));\n  }\n  .md\\:-space-x-4> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-1rem * var(--space-x-reverse));\n    margin-left: calc(-1rem * calc(1 - var(--space-x-reverse)));\n  }\n  .md\\:-space-y-5> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-1.25rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-1.25rem * var(--space-y-reverse));\n  }\n  .md\\:-space-x-5> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-1.25rem * var(--space-x-reverse));\n    margin-left: calc(-1.25rem * calc(1 - var(--space-x-reverse)));\n  }\n  .md\\:-space-y-6> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-1.5rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-1.5rem * var(--space-y-reverse));\n  }\n  .md\\:-space-x-6> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-1.5rem * var(--space-x-reverse));\n    margin-left: calc(-1.5rem * calc(1 - var(--space-x-reverse)));\n  }\n  .md\\:-space-y-7> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-1.75rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-1.75rem * var(--space-y-reverse));\n  }\n  .md\\:-space-x-7> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-1.75rem * var(--space-x-reverse));\n    margin-left: calc(-1.75rem * calc(1 - var(--space-x-reverse)));\n  }\n  .md\\:-space-y-8> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-2rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-2rem * var(--space-y-reverse));\n  }\n  .md\\:-space-x-8> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-2rem * var(--space-x-reverse));\n    margin-left: calc(-2rem * calc(1 - var(--space-x-reverse)));\n  }\n  .md\\:-space-y-9> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-2.25rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-2.25rem * var(--space-y-reverse));\n  }\n  .md\\:-space-x-9> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-2.25rem * var(--space-x-reverse));\n    margin-left: calc(-2.25rem * calc(1 - var(--space-x-reverse)));\n  }\n  .md\\:-space-y-10> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-2.5rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-2.5rem * var(--space-y-reverse));\n  }\n  .md\\:-space-x-10> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-2.5rem * var(--space-x-reverse));\n    margin-left: calc(-2.5rem * calc(1 - var(--space-x-reverse)));\n  }\n  .md\\:-space-y-11> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-2.75rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-2.75rem * var(--space-y-reverse));\n  }\n  .md\\:-space-x-11> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-2.75rem * var(--space-x-reverse));\n    margin-left: calc(-2.75rem * calc(1 - var(--space-x-reverse)));\n  }\n  .md\\:-space-y-12> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-3rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-3rem * var(--space-y-reverse));\n  }\n  .md\\:-space-x-12> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-3rem * var(--space-x-reverse));\n    margin-left: calc(-3rem * calc(1 - var(--space-x-reverse)));\n  }\n  .md\\:-space-y-13> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-3.25rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-3.25rem * var(--space-y-reverse));\n  }\n  .md\\:-space-x-13> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-3.25rem * var(--space-x-reverse));\n    margin-left: calc(-3.25rem * calc(1 - var(--space-x-reverse)));\n  }\n  .md\\:-space-y-14> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-3.5rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-3.5rem * var(--space-y-reverse));\n  }\n  .md\\:-space-x-14> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-3.5rem * var(--space-x-reverse));\n    margin-left: calc(-3.5rem * calc(1 - var(--space-x-reverse)));\n  }\n  .md\\:-space-y-15> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-3.75rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-3.75rem * var(--space-y-reverse));\n  }\n  .md\\:-space-x-15> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-3.75rem * var(--space-x-reverse));\n    margin-left: calc(-3.75rem * calc(1 - var(--space-x-reverse)));\n  }\n  .md\\:-space-y-16> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-4rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-4rem * var(--space-y-reverse));\n  }\n  .md\\:-space-x-16> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-4rem * var(--space-x-reverse));\n    margin-left: calc(-4rem * calc(1 - var(--space-x-reverse)));\n  }\n  .md\\:-space-y-20> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-5rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-5rem * var(--space-y-reverse));\n  }\n  .md\\:-space-x-20> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-5rem * var(--space-x-reverse));\n    margin-left: calc(-5rem * calc(1 - var(--space-x-reverse)));\n  }\n  .md\\:-space-y-24> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-6rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-6rem * var(--space-y-reverse));\n  }\n  .md\\:-space-x-24> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-6rem * var(--space-x-reverse));\n    margin-left: calc(-6rem * calc(1 - var(--space-x-reverse)));\n  }\n  .md\\:-space-y-28> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-7rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-7rem * var(--space-y-reverse));\n  }\n  .md\\:-space-x-28> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-7rem * var(--space-x-reverse));\n    margin-left: calc(-7rem * calc(1 - var(--space-x-reverse)));\n  }\n  .md\\:-space-y-32> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-8rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-8rem * var(--space-y-reverse));\n  }\n  .md\\:-space-x-32> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-8rem * var(--space-x-reverse));\n    margin-left: calc(-8rem * calc(1 - var(--space-x-reverse)));\n  }\n  .md\\:-space-y-36> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-9rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-9rem * var(--space-y-reverse));\n  }\n  .md\\:-space-x-36> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-9rem * var(--space-x-reverse));\n    margin-left: calc(-9rem * calc(1 - var(--space-x-reverse)));\n  }\n  .md\\:-space-y-40> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-10rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-10rem * var(--space-y-reverse));\n  }\n  .md\\:-space-x-40> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-10rem * var(--space-x-reverse));\n    margin-left: calc(-10rem * calc(1 - var(--space-x-reverse)));\n  }\n  .md\\:-space-y-44> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-11rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-11rem * var(--space-y-reverse));\n  }\n  .md\\:-space-x-44> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-11rem * var(--space-x-reverse));\n    margin-left: calc(-11rem * calc(1 - var(--space-x-reverse)));\n  }\n  .md\\:-space-y-48> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-12rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-12rem * var(--space-y-reverse));\n  }\n  .md\\:-space-x-48> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-12rem * var(--space-x-reverse));\n    margin-left: calc(-12rem * calc(1 - var(--space-x-reverse)));\n  }\n  .md\\:-space-y-52> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-13rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-13rem * var(--space-y-reverse));\n  }\n  .md\\:-space-x-52> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-13rem * var(--space-x-reverse));\n    margin-left: calc(-13rem * calc(1 - var(--space-x-reverse)));\n  }\n  .md\\:-space-y-56> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-14rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-14rem * var(--space-y-reverse));\n  }\n  .md\\:-space-x-56> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-14rem * var(--space-x-reverse));\n    margin-left: calc(-14rem * calc(1 - var(--space-x-reverse)));\n  }\n  .md\\:-space-y-60> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-15rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-15rem * var(--space-y-reverse));\n  }\n  .md\\:-space-x-60> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-15rem * var(--space-x-reverse));\n    margin-left: calc(-15rem * calc(1 - var(--space-x-reverse)));\n  }\n  .md\\:-space-y-64> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-16rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-16rem * var(--space-y-reverse));\n  }\n  .md\\:-space-x-64> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-16rem * var(--space-x-reverse));\n    margin-left: calc(-16rem * calc(1 - var(--space-x-reverse)));\n  }\n  .md\\:-space-y-72> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-18rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-18rem * var(--space-y-reverse));\n  }\n  .md\\:-space-x-72> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-18rem * var(--space-x-reverse));\n    margin-left: calc(-18rem * calc(1 - var(--space-x-reverse)));\n  }\n  .md\\:-space-y-80> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-20rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-20rem * var(--space-y-reverse));\n  }\n  .md\\:-space-x-80> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-20rem * var(--space-x-reverse));\n    margin-left: calc(-20rem * calc(1 - var(--space-x-reverse)));\n  }\n  .md\\:-space-y-96> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-24rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-24rem * var(--space-y-reverse));\n  }\n  .md\\:-space-x-96> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-24rem * var(--space-x-reverse));\n    margin-left: calc(-24rem * calc(1 - var(--space-x-reverse)));\n  }\n  .md\\:-space-y-px> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-1px * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-1px * var(--space-y-reverse));\n  }\n  .md\\:-space-x-px> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-1px * var(--space-x-reverse));\n    margin-left: calc(-1px * calc(1 - var(--space-x-reverse)));\n  }\n  .md\\:-space-y-0\\.5> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-0.125rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-0.125rem * var(--space-y-reverse));\n  }\n  .md\\:-space-x-0\\.5> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-0.125rem * var(--space-x-reverse));\n    margin-left: calc(-0.125rem * calc(1 - var(--space-x-reverse)));\n  }\n  .md\\:-space-y-1\\.5> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-0.375rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-0.375rem * var(--space-y-reverse));\n  }\n  .md\\:-space-x-1\\.5> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-0.375rem * var(--space-x-reverse));\n    margin-left: calc(-0.375rem * calc(1 - var(--space-x-reverse)));\n  }\n  .md\\:-space-y-2\\.5> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-0.625rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-0.625rem * var(--space-y-reverse));\n  }\n  .md\\:-space-x-2\\.5> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-0.625rem * var(--space-x-reverse));\n    margin-left: calc(-0.625rem * calc(1 - var(--space-x-reverse)));\n  }\n  .md\\:-space-y-3\\.5> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-0.875rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-0.875rem * var(--space-y-reverse));\n  }\n  .md\\:-space-x-3\\.5> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-0.875rem * var(--space-x-reverse));\n    margin-left: calc(-0.875rem * calc(1 - var(--space-x-reverse)));\n  }\n  .md\\:-space-y-1\\/2> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-50% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-50% * var(--space-y-reverse));\n  }\n  .md\\:-space-x-1\\/2> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-50% * var(--space-x-reverse));\n    margin-left: calc(-50% * calc(1 - var(--space-x-reverse)));\n  }\n  .md\\:-space-y-1\\/3> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-33.33333% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-33.33333% * var(--space-y-reverse));\n  }\n  .md\\:-space-x-1\\/3> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-33.33333% * var(--space-x-reverse));\n    margin-left: calc(-33.33333% * calc(1 - var(--space-x-reverse)));\n  }\n  .md\\:-space-y-2\\/3> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-66.66667% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-66.66667% * var(--space-y-reverse));\n  }\n  .md\\:-space-x-2\\/3> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-66.66667% * var(--space-x-reverse));\n    margin-left: calc(-66.66667% * calc(1 - var(--space-x-reverse)));\n  }\n  .md\\:-space-y-1\\/4> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-25% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-25% * var(--space-y-reverse));\n  }\n  .md\\:-space-x-1\\/4> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-25% * var(--space-x-reverse));\n    margin-left: calc(-25% * calc(1 - var(--space-x-reverse)));\n  }\n  .md\\:-space-y-2\\/4> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-50% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-50% * var(--space-y-reverse));\n  }\n  .md\\:-space-x-2\\/4> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-50% * var(--space-x-reverse));\n    margin-left: calc(-50% * calc(1 - var(--space-x-reverse)));\n  }\n  .md\\:-space-y-3\\/4> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-75% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-75% * var(--space-y-reverse));\n  }\n  .md\\:-space-x-3\\/4> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-75% * var(--space-x-reverse));\n    margin-left: calc(-75% * calc(1 - var(--space-x-reverse)));\n  }\n  .md\\:-space-y-1\\/5> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-20% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-20% * var(--space-y-reverse));\n  }\n  .md\\:-space-x-1\\/5> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-20% * var(--space-x-reverse));\n    margin-left: calc(-20% * calc(1 - var(--space-x-reverse)));\n  }\n  .md\\:-space-y-2\\/5> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-40% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-40% * var(--space-y-reverse));\n  }\n  .md\\:-space-x-2\\/5> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-40% * var(--space-x-reverse));\n    margin-left: calc(-40% * calc(1 - var(--space-x-reverse)));\n  }\n  .md\\:-space-y-3\\/5> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-60% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-60% * var(--space-y-reverse));\n  }\n  .md\\:-space-x-3\\/5> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-60% * var(--space-x-reverse));\n    margin-left: calc(-60% * calc(1 - var(--space-x-reverse)));\n  }\n  .md\\:-space-y-4\\/5> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-80% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-80% * var(--space-y-reverse));\n  }\n  .md\\:-space-x-4\\/5> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-80% * var(--space-x-reverse));\n    margin-left: calc(-80% * calc(1 - var(--space-x-reverse)));\n  }\n  .md\\:-space-y-1\\/6> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-16.66667% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-16.66667% * var(--space-y-reverse));\n  }\n  .md\\:-space-x-1\\/6> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-16.66667% * var(--space-x-reverse));\n    margin-left: calc(-16.66667% * calc(1 - var(--space-x-reverse)));\n  }\n  .md\\:-space-y-2\\/6> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-33.33333% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-33.33333% * var(--space-y-reverse));\n  }\n  .md\\:-space-x-2\\/6> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-33.33333% * var(--space-x-reverse));\n    margin-left: calc(-33.33333% * calc(1 - var(--space-x-reverse)));\n  }\n  .md\\:-space-y-3\\/6> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-50% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-50% * var(--space-y-reverse));\n  }\n  .md\\:-space-x-3\\/6> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-50% * var(--space-x-reverse));\n    margin-left: calc(-50% * calc(1 - var(--space-x-reverse)));\n  }\n  .md\\:-space-y-4\\/6> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-66.66667% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-66.66667% * var(--space-y-reverse));\n  }\n  .md\\:-space-x-4\\/6> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-66.66667% * var(--space-x-reverse));\n    margin-left: calc(-66.66667% * calc(1 - var(--space-x-reverse)));\n  }\n  .md\\:-space-y-5\\/6> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-83.33333% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-83.33333% * var(--space-y-reverse));\n  }\n  .md\\:-space-x-5\\/6> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-83.33333% * var(--space-x-reverse));\n    margin-left: calc(-83.33333% * calc(1 - var(--space-x-reverse)));\n  }\n  .md\\:-space-y-1\\/12> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-8.33333% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-8.33333% * var(--space-y-reverse));\n  }\n  .md\\:-space-x-1\\/12> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-8.33333% * var(--space-x-reverse));\n    margin-left: calc(-8.33333% * calc(1 - var(--space-x-reverse)));\n  }\n  .md\\:-space-y-2\\/12> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-16.66667% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-16.66667% * var(--space-y-reverse));\n  }\n  .md\\:-space-x-2\\/12> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-16.66667% * var(--space-x-reverse));\n    margin-left: calc(-16.66667% * calc(1 - var(--space-x-reverse)));\n  }\n  .md\\:-space-y-3\\/12> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-25% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-25% * var(--space-y-reverse));\n  }\n  .md\\:-space-x-3\\/12> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-25% * var(--space-x-reverse));\n    margin-left: calc(-25% * calc(1 - var(--space-x-reverse)));\n  }\n  .md\\:-space-y-4\\/12> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-33.33333% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-33.33333% * var(--space-y-reverse));\n  }\n  .md\\:-space-x-4\\/12> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-33.33333% * var(--space-x-reverse));\n    margin-left: calc(-33.33333% * calc(1 - var(--space-x-reverse)));\n  }\n  .md\\:-space-y-5\\/12> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-41.66667% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-41.66667% * var(--space-y-reverse));\n  }\n  .md\\:-space-x-5\\/12> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-41.66667% * var(--space-x-reverse));\n    margin-left: calc(-41.66667% * calc(1 - var(--space-x-reverse)));\n  }\n  .md\\:-space-y-6\\/12> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-50% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-50% * var(--space-y-reverse));\n  }\n  .md\\:-space-x-6\\/12> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-50% * var(--space-x-reverse));\n    margin-left: calc(-50% * calc(1 - var(--space-x-reverse)));\n  }\n  .md\\:-space-y-7\\/12> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-58.33333% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-58.33333% * var(--space-y-reverse));\n  }\n  .md\\:-space-x-7\\/12> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-58.33333% * var(--space-x-reverse));\n    margin-left: calc(-58.33333% * calc(1 - var(--space-x-reverse)));\n  }\n  .md\\:-space-y-8\\/12> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-66.66667% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-66.66667% * var(--space-y-reverse));\n  }\n  .md\\:-space-x-8\\/12> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-66.66667% * var(--space-x-reverse));\n    margin-left: calc(-66.66667% * calc(1 - var(--space-x-reverse)));\n  }\n  .md\\:-space-y-9\\/12> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-75% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-75% * var(--space-y-reverse));\n  }\n  .md\\:-space-x-9\\/12> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-75% * var(--space-x-reverse));\n    margin-left: calc(-75% * calc(1 - var(--space-x-reverse)));\n  }\n  .md\\:-space-y-10\\/12> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-83.33333% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-83.33333% * var(--space-y-reverse));\n  }\n  .md\\:-space-x-10\\/12> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-83.33333% * var(--space-x-reverse));\n    margin-left: calc(-83.33333% * calc(1 - var(--space-x-reverse)));\n  }\n  .md\\:-space-y-11\\/12> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-91.66667% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-91.66667% * var(--space-y-reverse));\n  }\n  .md\\:-space-x-11\\/12> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-91.66667% * var(--space-x-reverse));\n    margin-left: calc(-91.66667% * calc(1 - var(--space-x-reverse)));\n  }\n  .md\\:-space-y-full> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-100% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-100% * var(--space-y-reverse));\n  }\n  .md\\:-space-x-full> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-100% * var(--space-x-reverse));\n    margin-left: calc(-100% * calc(1 - var(--space-x-reverse)));\n  }\n  .md\\:space-y-reverse> :not(template)~ :not(template) {\n    --space-y-reverse: 1;\n  }\n  .md\\:space-x-reverse> :not(template)~ :not(template) {\n    --space-x-reverse: 1;\n  }\n  .md\\:divide-y-0> :not(template)~ :not(template) {\n    --divide-y-reverse: 0;\n    border-top-width: calc(0px * calc(1 - var(--divide-y-reverse)));\n    border-bottom-width: calc(0px * var(--divide-y-reverse));\n  }\n  .md\\:divide-x-0> :not(template)~ :not(template) {\n    --divide-x-reverse: 0;\n    border-right-width: calc(0px * var(--divide-x-reverse));\n    border-left-width: calc(0px * calc(1 - var(--divide-x-reverse)));\n  }\n  .md\\:divide-y-2> :not(template)~ :not(template) {\n    --divide-y-reverse: 0;\n    border-top-width: calc(2px * calc(1 - var(--divide-y-reverse)));\n    border-bottom-width: calc(2px * var(--divide-y-reverse));\n  }\n  .md\\:divide-x-2> :not(template)~ :not(template) {\n    --divide-x-reverse: 0;\n    border-right-width: calc(2px * var(--divide-x-reverse));\n    border-left-width: calc(2px * calc(1 - var(--divide-x-reverse)));\n  }\n  .md\\:divide-y-4> :not(template)~ :not(template) {\n    --divide-y-reverse: 0;\n    border-top-width: calc(4px * calc(1 - var(--divide-y-reverse)));\n    border-bottom-width: calc(4px * var(--divide-y-reverse));\n  }\n  .md\\:divide-x-4> :not(template)~ :not(template) {\n    --divide-x-reverse: 0;\n    border-right-width: calc(4px * var(--divide-x-reverse));\n    border-left-width: calc(4px * calc(1 - var(--divide-x-reverse)));\n  }\n  .md\\:divide-y-8> :not(template)~ :not(template) {\n    --divide-y-reverse: 0;\n    border-top-width: calc(8px * calc(1 - var(--divide-y-reverse)));\n    border-bottom-width: calc(8px * var(--divide-y-reverse));\n  }\n  .md\\:divide-x-8> :not(template)~ :not(template) {\n    --divide-x-reverse: 0;\n    border-right-width: calc(8px * var(--divide-x-reverse));\n    border-left-width: calc(8px * calc(1 - var(--divide-x-reverse)));\n  }\n  .md\\:divide-y> :not(template)~ :not(template) {\n    --divide-y-reverse: 0;\n    border-top-width: calc(1px * calc(1 - var(--divide-y-reverse)));\n    border-bottom-width: calc(1px * var(--divide-y-reverse));\n  }\n  .md\\:divide-x> :not(template)~ :not(template) {\n    --divide-x-reverse: 0;\n    border-right-width: calc(1px * var(--divide-x-reverse));\n    border-left-width: calc(1px * calc(1 - var(--divide-x-reverse)));\n  }\n  .md\\:divide-y-reverse> :not(template)~ :not(template) {\n    --divide-y-reverse: 1;\n  }\n  .md\\:divide-x-reverse> :not(template)~ :not(template) {\n    --divide-x-reverse: 1;\n  }\n  .md\\:divide-current> :not(template)~ :not(template) {\n    border-color: currentColor;\n  }\n  .md\\:divide-transparent> :not(template)~ :not(template) {\n    border-color: transparent;\n  }\n  .md\\:divide-white> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #ffffff;\n    border-color: rgba(255, 255, 255, var(--divide-opacity));\n  }\n  .md\\:divide-black> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #000000;\n    border-color: rgba(0, 0, 0, var(--divide-opacity));\n  }\n  .md\\:divide-gray-50> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #f9fafb;\n    border-color: rgba(249, 250, 251, var(--divide-opacity));\n  }\n  .md\\:divide-gray-100> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #f4f5f7;\n    border-color: rgba(244, 245, 247, var(--divide-opacity));\n  }\n  .md\\:divide-gray-200> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #e5e7eb;\n    border-color: rgba(229, 231, 235, var(--divide-opacity));\n  }\n  .md\\:divide-gray-300> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #d2d6dc;\n    border-color: rgba(210, 214, 220, var(--divide-opacity));\n  }\n  .md\\:divide-gray-400> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #9fa6b2;\n    border-color: rgba(159, 166, 178, var(--divide-opacity));\n  }\n  .md\\:divide-gray-500> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #6b7280;\n    border-color: rgba(107, 114, 128, var(--divide-opacity));\n  }\n  .md\\:divide-gray-600> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #4b5563;\n    border-color: rgba(75, 85, 99, var(--divide-opacity));\n  }\n  .md\\:divide-gray-700> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #374151;\n    border-color: rgba(55, 65, 81, var(--divide-opacity));\n  }\n  .md\\:divide-gray-800> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #252f3f;\n    border-color: rgba(37, 47, 63, var(--divide-opacity));\n  }\n  .md\\:divide-gray-900> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #161e2e;\n    border-color: rgba(22, 30, 46, var(--divide-opacity));\n  }\n  .md\\:divide-red-50> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #fdf2f2;\n    border-color: rgba(253, 242, 242, var(--divide-opacity));\n  }\n  .md\\:divide-red-100> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #fde8e8;\n    border-color: rgba(253, 232, 232, var(--divide-opacity));\n  }\n  .md\\:divide-red-200> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #fbd5d5;\n    border-color: rgba(251, 213, 213, var(--divide-opacity));\n  }\n  .md\\:divide-red-300> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #f8b4b4;\n    border-color: rgba(248, 180, 180, var(--divide-opacity));\n  }\n  .md\\:divide-red-400> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #f98080;\n    border-color: rgba(249, 128, 128, var(--divide-opacity));\n  }\n  .md\\:divide-red-500> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #f05252;\n    border-color: rgba(240, 82, 82, var(--divide-opacity));\n  }\n  .md\\:divide-red-600> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #e02424;\n    border-color: rgba(224, 36, 36, var(--divide-opacity));\n  }\n  .md\\:divide-red-700> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #c81e1e;\n    border-color: rgba(200, 30, 30, var(--divide-opacity));\n  }\n  .md\\:divide-red-800> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #9b1c1c;\n    border-color: rgba(155, 28, 28, var(--divide-opacity));\n  }\n  .md\\:divide-red-900> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #771d1d;\n    border-color: rgba(119, 29, 29, var(--divide-opacity));\n  }\n  .md\\:divide-orange-50> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #fff8f1;\n    border-color: rgba(255, 248, 241, var(--divide-opacity));\n  }\n  .md\\:divide-orange-100> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #feecdc;\n    border-color: rgba(254, 236, 220, var(--divide-opacity));\n  }\n  .md\\:divide-orange-200> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #fcd9bd;\n    border-color: rgba(252, 217, 189, var(--divide-opacity));\n  }\n  .md\\:divide-orange-300> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #fdba8c;\n    border-color: rgba(253, 186, 140, var(--divide-opacity));\n  }\n  .md\\:divide-orange-400> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #ff8a4c;\n    border-color: rgba(255, 138, 76, var(--divide-opacity));\n  }\n  .md\\:divide-orange-500> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #ff5a1f;\n    border-color: rgba(255, 90, 31, var(--divide-opacity));\n  }\n  .md\\:divide-orange-600> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #d03801;\n    border-color: rgba(208, 56, 1, var(--divide-opacity));\n  }\n  .md\\:divide-orange-700> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #b43403;\n    border-color: rgba(180, 52, 3, var(--divide-opacity));\n  }\n  .md\\:divide-orange-800> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #8a2c0d;\n    border-color: rgba(138, 44, 13, var(--divide-opacity));\n  }\n  .md\\:divide-orange-900> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #73230d;\n    border-color: rgba(115, 35, 13, var(--divide-opacity));\n  }\n  .md\\:divide-yellow-50> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #fdfdea;\n    border-color: rgba(253, 253, 234, var(--divide-opacity));\n  }\n  .md\\:divide-yellow-100> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #fdf6b2;\n    border-color: rgba(253, 246, 178, var(--divide-opacity));\n  }\n  .md\\:divide-yellow-200> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #fce96a;\n    border-color: rgba(252, 233, 106, var(--divide-opacity));\n  }\n  .md\\:divide-yellow-300> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #faca15;\n    border-color: rgba(250, 202, 21, var(--divide-opacity));\n  }\n  .md\\:divide-yellow-400> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #e3a008;\n    border-color: rgba(227, 160, 8, var(--divide-opacity));\n  }\n  .md\\:divide-yellow-500> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #c27803;\n    border-color: rgba(194, 120, 3, var(--divide-opacity));\n  }\n  .md\\:divide-yellow-600> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #9f580a;\n    border-color: rgba(159, 88, 10, var(--divide-opacity));\n  }\n  .md\\:divide-yellow-700> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #8e4b10;\n    border-color: rgba(142, 75, 16, var(--divide-opacity));\n  }\n  .md\\:divide-yellow-800> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #723b13;\n    border-color: rgba(114, 59, 19, var(--divide-opacity));\n  }\n  .md\\:divide-yellow-900> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #633112;\n    border-color: rgba(99, 49, 18, var(--divide-opacity));\n  }\n  .md\\:divide-green-50> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #f3faf7;\n    border-color: rgba(243, 250, 247, var(--divide-opacity));\n  }\n  .md\\:divide-green-100> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #def7ec;\n    border-color: rgba(222, 247, 236, var(--divide-opacity));\n  }\n  .md\\:divide-green-200> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #bcf0da;\n    border-color: rgba(188, 240, 218, var(--divide-opacity));\n  }\n  .md\\:divide-green-300> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #84e1bc;\n    border-color: rgba(132, 225, 188, var(--divide-opacity));\n  }\n  .md\\:divide-green-400> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #31c48d;\n    border-color: rgba(49, 196, 141, var(--divide-opacity));\n  }\n  .md\\:divide-green-500> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #0e9f6e;\n    border-color: rgba(14, 159, 110, var(--divide-opacity));\n  }\n  .md\\:divide-green-600> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #057a55;\n    border-color: rgba(5, 122, 85, var(--divide-opacity));\n  }\n  .md\\:divide-green-700> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #046c4e;\n    border-color: rgba(4, 108, 78, var(--divide-opacity));\n  }\n  .md\\:divide-green-800> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #03543f;\n    border-color: rgba(3, 84, 63, var(--divide-opacity));\n  }\n  .md\\:divide-green-900> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #014737;\n    border-color: rgba(1, 71, 55, var(--divide-opacity));\n  }\n  .md\\:divide-teal-50> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #edfafa;\n    border-color: rgba(237, 250, 250, var(--divide-opacity));\n  }\n  .md\\:divide-teal-100> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #d5f5f6;\n    border-color: rgba(213, 245, 246, var(--divide-opacity));\n  }\n  .md\\:divide-teal-200> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #afecef;\n    border-color: rgba(175, 236, 239, var(--divide-opacity));\n  }\n  .md\\:divide-teal-300> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #7edce2;\n    border-color: rgba(126, 220, 226, var(--divide-opacity));\n  }\n  .md\\:divide-teal-400> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #16bdca;\n    border-color: rgba(22, 189, 202, var(--divide-opacity));\n  }\n  .md\\:divide-teal-500> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #0694a2;\n    border-color: rgba(6, 148, 162, var(--divide-opacity));\n  }\n  .md\\:divide-teal-600> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #047481;\n    border-color: rgba(4, 116, 129, var(--divide-opacity));\n  }\n  .md\\:divide-teal-700> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #036672;\n    border-color: rgba(3, 102, 114, var(--divide-opacity));\n  }\n  .md\\:divide-teal-800> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #05505c;\n    border-color: rgba(5, 80, 92, var(--divide-opacity));\n  }\n  .md\\:divide-teal-900> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #014451;\n    border-color: rgba(1, 68, 81, var(--divide-opacity));\n  }\n  .md\\:divide-blue-50> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #ebf5ff;\n    border-color: rgba(235, 245, 255, var(--divide-opacity));\n  }\n  .md\\:divide-blue-100> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #e1effe;\n    border-color: rgba(225, 239, 254, var(--divide-opacity));\n  }\n  .md\\:divide-blue-200> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #c3ddfd;\n    border-color: rgba(195, 221, 253, var(--divide-opacity));\n  }\n  .md\\:divide-blue-300> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #a4cafe;\n    border-color: rgba(164, 202, 254, var(--divide-opacity));\n  }\n  .md\\:divide-blue-400> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #76a9fa;\n    border-color: rgba(118, 169, 250, var(--divide-opacity));\n  }\n  .md\\:divide-blue-500> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #3f83f8;\n    border-color: rgba(63, 131, 248, var(--divide-opacity));\n  }\n  .md\\:divide-blue-600> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #1c64f2;\n    border-color: rgba(28, 100, 242, var(--divide-opacity));\n  }\n  .md\\:divide-blue-700> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #1a56db;\n    border-color: rgba(26, 86, 219, var(--divide-opacity));\n  }\n  .md\\:divide-blue-800> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #1e429f;\n    border-color: rgba(30, 66, 159, var(--divide-opacity));\n  }\n  .md\\:divide-blue-900> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #233876;\n    border-color: rgba(35, 56, 118, var(--divide-opacity));\n  }\n  .md\\:divide-indigo-50> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #f0f5ff;\n    border-color: rgba(240, 245, 255, var(--divide-opacity));\n  }\n  .md\\:divide-indigo-100> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #e5edff;\n    border-color: rgba(229, 237, 255, var(--divide-opacity));\n  }\n  .md\\:divide-indigo-200> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #cddbfe;\n    border-color: rgba(205, 219, 254, var(--divide-opacity));\n  }\n  .md\\:divide-indigo-300> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #b4c6fc;\n    border-color: rgba(180, 198, 252, var(--divide-opacity));\n  }\n  .md\\:divide-indigo-400> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #8da2fb;\n    border-color: rgba(141, 162, 251, var(--divide-opacity));\n  }\n  .md\\:divide-indigo-500> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #6875f5;\n    border-color: rgba(104, 117, 245, var(--divide-opacity));\n  }\n  .md\\:divide-indigo-600> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #5850ec;\n    border-color: rgba(88, 80, 236, var(--divide-opacity));\n  }\n  .md\\:divide-indigo-700> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #5145cd;\n    border-color: rgba(81, 69, 205, var(--divide-opacity));\n  }\n  .md\\:divide-indigo-800> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #42389d;\n    border-color: rgba(66, 56, 157, var(--divide-opacity));\n  }\n  .md\\:divide-indigo-900> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #362f78;\n    border-color: rgba(54, 47, 120, var(--divide-opacity));\n  }\n  .md\\:divide-purple-50> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #f6f5ff;\n    border-color: rgba(246, 245, 255, var(--divide-opacity));\n  }\n  .md\\:divide-purple-100> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #edebfe;\n    border-color: rgba(237, 235, 254, var(--divide-opacity));\n  }\n  .md\\:divide-purple-200> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #dcd7fe;\n    border-color: rgba(220, 215, 254, var(--divide-opacity));\n  }\n  .md\\:divide-purple-300> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #cabffd;\n    border-color: rgba(202, 191, 253, var(--divide-opacity));\n  }\n  .md\\:divide-purple-400> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #ac94fa;\n    border-color: rgba(172, 148, 250, var(--divide-opacity));\n  }\n  .md\\:divide-purple-500> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #9061f9;\n    border-color: rgba(144, 97, 249, var(--divide-opacity));\n  }\n  .md\\:divide-purple-600> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #7e3af2;\n    border-color: rgba(126, 58, 242, var(--divide-opacity));\n  }\n  .md\\:divide-purple-700> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #6c2bd9;\n    border-color: rgba(108, 43, 217, var(--divide-opacity));\n  }\n  .md\\:divide-purple-800> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #5521b5;\n    border-color: rgba(85, 33, 181, var(--divide-opacity));\n  }\n  .md\\:divide-purple-900> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #4a1d96;\n    border-color: rgba(74, 29, 150, var(--divide-opacity));\n  }\n  .md\\:divide-pink-50> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #fdf2f8;\n    border-color: rgba(253, 242, 248, var(--divide-opacity));\n  }\n  .md\\:divide-pink-100> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #fce8f3;\n    border-color: rgba(252, 232, 243, var(--divide-opacity));\n  }\n  .md\\:divide-pink-200> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #fad1e8;\n    border-color: rgba(250, 209, 232, var(--divide-opacity));\n  }\n  .md\\:divide-pink-300> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #f8b4d9;\n    border-color: rgba(248, 180, 217, var(--divide-opacity));\n  }\n  .md\\:divide-pink-400> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #f17eb8;\n    border-color: rgba(241, 126, 184, var(--divide-opacity));\n  }\n  .md\\:divide-pink-500> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #e74694;\n    border-color: rgba(231, 70, 148, var(--divide-opacity));\n  }\n  .md\\:divide-pink-600> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #d61f69;\n    border-color: rgba(214, 31, 105, var(--divide-opacity));\n  }\n  .md\\:divide-pink-700> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #bf125d;\n    border-color: rgba(191, 18, 93, var(--divide-opacity));\n  }\n  .md\\:divide-pink-800> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #99154b;\n    border-color: rgba(153, 21, 75, var(--divide-opacity));\n  }\n  .md\\:divide-pink-900> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #751a3d;\n    border-color: rgba(117, 26, 61, var(--divide-opacity));\n  }\n  .md\\:divide-cool-gray-50> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #f8fafc;\n    border-color: rgba(248, 250, 252, var(--divide-opacity));\n  }\n  .md\\:divide-cool-gray-100> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #f1f5f9;\n    border-color: rgba(241, 245, 249, var(--divide-opacity));\n  }\n  .md\\:divide-cool-gray-200> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #e2e8f0;\n    border-color: rgba(226, 232, 240, var(--divide-opacity));\n  }\n  .md\\:divide-cool-gray-300> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #cfd8e3;\n    border-color: rgba(207, 216, 227, var(--divide-opacity));\n  }\n  .md\\:divide-cool-gray-400> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #97a6ba;\n    border-color: rgba(151, 166, 186, var(--divide-opacity));\n  }\n  .md\\:divide-cool-gray-500> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #64748b;\n    border-color: rgba(100, 116, 139, var(--divide-opacity));\n  }\n  .md\\:divide-cool-gray-600> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #475569;\n    border-color: rgba(71, 85, 105, var(--divide-opacity));\n  }\n  .md\\:divide-cool-gray-700> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #364152;\n    border-color: rgba(54, 65, 82, var(--divide-opacity));\n  }\n  .md\\:divide-cool-gray-800> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #27303f;\n    border-color: rgba(39, 48, 63, var(--divide-opacity));\n  }\n  .md\\:divide-cool-gray-900> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #1a202e;\n    border-color: rgba(26, 32, 46, var(--divide-opacity));\n  }\n  .md\\:divide-solid> :not(template)~ :not(template) {\n    border-style: solid;\n  }\n  .md\\:divide-dashed> :not(template)~ :not(template) {\n    border-style: dashed;\n  }\n  .md\\:divide-dotted> :not(template)~ :not(template) {\n    border-style: dotted;\n  }\n  .md\\:divide-double> :not(template)~ :not(template) {\n    border-style: double;\n  }\n  .md\\:divide-none> :not(template)~ :not(template) {\n    border-style: none;\n  }\n  .md\\:divide-opacity-0> :not(template)~ :not(template) {\n    --divide-opacity: 0;\n  }\n  .md\\:divide-opacity-25> :not(template)~ :not(template) {\n    --divide-opacity: 0.25;\n  }\n  .md\\:divide-opacity-50> :not(template)~ :not(template) {\n    --divide-opacity: 0.5;\n  }\n  .md\\:divide-opacity-75> :not(template)~ :not(template) {\n    --divide-opacity: 0.75;\n  }\n  .md\\:divide-opacity-100> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n  }\n  .md\\:sr-only {\n    position: absolute;\n    width: 1px;\n    height: 1px;\n    padding: 0;\n    margin: -1px;\n    overflow: hidden;\n    clip: rect(0, 0, 0, 0);\n    white-space: nowrap;\n    border-width: 0;\n  }\n  .md\\:not-sr-only {\n    position: static;\n    width: auto;\n    height: auto;\n    padding: 0;\n    margin: 0;\n    overflow: visible;\n    clip: auto;\n    white-space: normal;\n  }\n  .md\\:focus\\:sr-only:focus {\n    position: absolute;\n    width: 1px;\n    height: 1px;\n    padding: 0;\n    margin: -1px;\n    overflow: hidden;\n    clip: rect(0, 0, 0, 0);\n    white-space: nowrap;\n    border-width: 0;\n  }\n  .md\\:focus\\:not-sr-only:focus {\n    position: static;\n    width: auto;\n    height: auto;\n    padding: 0;\n    margin: 0;\n    overflow: visible;\n    clip: auto;\n    white-space: normal;\n  }\n  .md\\:appearance-none {\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    appearance: none;\n  }\n  .md\\:bg-fixed {\n    background-attachment: fixed;\n  }\n  .md\\:bg-local {\n    background-attachment: local;\n  }\n  .md\\:bg-scroll {\n    background-attachment: scroll;\n  }\n  .md\\:bg-clip-border {\n    background-clip: border-box;\n  }\n  .md\\:bg-clip-padding {\n    background-clip: padding-box;\n  }\n  .md\\:bg-clip-content {\n    background-clip: content-box;\n  }\n  .md\\:bg-clip-text {\n    -webkit-background-clip: text;\n    background-clip: text;\n  }\n  .md\\:bg-current {\n    background-color: currentColor;\n  }\n  .md\\:bg-transparent {\n    background-color: transparent;\n  }\n  .md\\:bg-white {\n    --bg-opacity: 1;\n    background-color: #ffffff;\n    background-color: rgba(255, 255, 255, var(--bg-opacity));\n  }\n  .md\\:bg-black {\n    --bg-opacity: 1;\n    background-color: #000000;\n    background-color: rgba(0, 0, 0, var(--bg-opacity));\n  }\n  .md\\:bg-gray-50 {\n    --bg-opacity: 1;\n    background-color: #f9fafb;\n    background-color: rgba(249, 250, 251, var(--bg-opacity));\n  }\n  .md\\:bg-gray-100 {\n    --bg-opacity: 1;\n    background-color: #f4f5f7;\n    background-color: rgba(244, 245, 247, var(--bg-opacity));\n  }\n  .md\\:bg-gray-200 {\n    --bg-opacity: 1;\n    background-color: #e5e7eb;\n    background-color: rgba(229, 231, 235, var(--bg-opacity));\n  }\n  .md\\:bg-gray-300 {\n    --bg-opacity: 1;\n    background-color: #d2d6dc;\n    background-color: rgba(210, 214, 220, var(--bg-opacity));\n  }\n  .md\\:bg-gray-400 {\n    --bg-opacity: 1;\n    background-color: #9fa6b2;\n    background-color: rgba(159, 166, 178, var(--bg-opacity));\n  }\n  .md\\:bg-gray-500 {\n    --bg-opacity: 1;\n    background-color: #6b7280;\n    background-color: rgba(107, 114, 128, var(--bg-opacity));\n  }\n  .md\\:bg-gray-600 {\n    --bg-opacity: 1;\n    background-color: #4b5563;\n    background-color: rgba(75, 85, 99, var(--bg-opacity));\n  }\n  .md\\:bg-gray-700 {\n    --bg-opacity: 1;\n    background-color: #374151;\n    background-color: rgba(55, 65, 81, var(--bg-opacity));\n  }\n  .md\\:bg-gray-800 {\n    --bg-opacity: 1;\n    background-color: #252f3f;\n    background-color: rgba(37, 47, 63, var(--bg-opacity));\n  }\n  .md\\:bg-gray-900 {\n    --bg-opacity: 1;\n    background-color: #161e2e;\n    background-color: rgba(22, 30, 46, var(--bg-opacity));\n  }\n  .md\\:bg-red-50 {\n    --bg-opacity: 1;\n    background-color: #fdf2f2;\n    background-color: rgba(253, 242, 242, var(--bg-opacity));\n  }\n  .md\\:bg-red-100 {\n    --bg-opacity: 1;\n    background-color: #fde8e8;\n    background-color: rgba(253, 232, 232, var(--bg-opacity));\n  }\n  .md\\:bg-red-200 {\n    --bg-opacity: 1;\n    background-color: #fbd5d5;\n    background-color: rgba(251, 213, 213, var(--bg-opacity));\n  }\n  .md\\:bg-red-300 {\n    --bg-opacity: 1;\n    background-color: #f8b4b4;\n    background-color: rgba(248, 180, 180, var(--bg-opacity));\n  }\n  .md\\:bg-red-400 {\n    --bg-opacity: 1;\n    background-color: #f98080;\n    background-color: rgba(249, 128, 128, var(--bg-opacity));\n  }\n  .md\\:bg-red-500 {\n    --bg-opacity: 1;\n    background-color: #f05252;\n    background-color: rgba(240, 82, 82, var(--bg-opacity));\n  }\n  .md\\:bg-red-600 {\n    --bg-opacity: 1;\n    background-color: #e02424;\n    background-color: rgba(224, 36, 36, var(--bg-opacity));\n  }\n  .md\\:bg-red-700 {\n    --bg-opacity: 1;\n    background-color: #c81e1e;\n    background-color: rgba(200, 30, 30, var(--bg-opacity));\n  }\n  .md\\:bg-red-800 {\n    --bg-opacity: 1;\n    background-color: #9b1c1c;\n    background-color: rgba(155, 28, 28, var(--bg-opacity));\n  }\n  .md\\:bg-red-900 {\n    --bg-opacity: 1;\n    background-color: #771d1d;\n    background-color: rgba(119, 29, 29, var(--bg-opacity));\n  }\n  .md\\:bg-orange-50 {\n    --bg-opacity: 1;\n    background-color: #fff8f1;\n    background-color: rgba(255, 248, 241, var(--bg-opacity));\n  }\n  .md\\:bg-orange-100 {\n    --bg-opacity: 1;\n    background-color: #feecdc;\n    background-color: rgba(254, 236, 220, var(--bg-opacity));\n  }\n  .md\\:bg-orange-200 {\n    --bg-opacity: 1;\n    background-color: #fcd9bd;\n    background-color: rgba(252, 217, 189, var(--bg-opacity));\n  }\n  .md\\:bg-orange-300 {\n    --bg-opacity: 1;\n    background-color: #fdba8c;\n    background-color: rgba(253, 186, 140, var(--bg-opacity));\n  }\n  .md\\:bg-orange-400 {\n    --bg-opacity: 1;\n    background-color: #ff8a4c;\n    background-color: rgba(255, 138, 76, var(--bg-opacity));\n  }\n  .md\\:bg-orange-500 {\n    --bg-opacity: 1;\n    background-color: #ff5a1f;\n    background-color: rgba(255, 90, 31, var(--bg-opacity));\n  }\n  .md\\:bg-orange-600 {\n    --bg-opacity: 1;\n    background-color: #d03801;\n    background-color: rgba(208, 56, 1, var(--bg-opacity));\n  }\n  .md\\:bg-orange-700 {\n    --bg-opacity: 1;\n    background-color: #b43403;\n    background-color: rgba(180, 52, 3, var(--bg-opacity));\n  }\n  .md\\:bg-orange-800 {\n    --bg-opacity: 1;\n    background-color: #8a2c0d;\n    background-color: rgba(138, 44, 13, var(--bg-opacity));\n  }\n  .md\\:bg-orange-900 {\n    --bg-opacity: 1;\n    background-color: #73230d;\n    background-color: rgba(115, 35, 13, var(--bg-opacity));\n  }\n  .md\\:bg-yellow-50 {\n    --bg-opacity: 1;\n    background-color: #fdfdea;\n    background-color: rgba(253, 253, 234, var(--bg-opacity));\n  }\n  .md\\:bg-yellow-100 {\n    --bg-opacity: 1;\n    background-color: #fdf6b2;\n    background-color: rgba(253, 246, 178, var(--bg-opacity));\n  }\n  .md\\:bg-yellow-200 {\n    --bg-opacity: 1;\n    background-color: #fce96a;\n    background-color: rgba(252, 233, 106, var(--bg-opacity));\n  }\n  .md\\:bg-yellow-300 {\n    --bg-opacity: 1;\n    background-color: #faca15;\n    background-color: rgba(250, 202, 21, var(--bg-opacity));\n  }\n  .md\\:bg-yellow-400 {\n    --bg-opacity: 1;\n    background-color: #e3a008;\n    background-color: rgba(227, 160, 8, var(--bg-opacity));\n  }\n  .md\\:bg-yellow-500 {\n    --bg-opacity: 1;\n    background-color: #c27803;\n    background-color: rgba(194, 120, 3, var(--bg-opacity));\n  }\n  .md\\:bg-yellow-600 {\n    --bg-opacity: 1;\n    background-color: #9f580a;\n    background-color: rgba(159, 88, 10, var(--bg-opacity));\n  }\n  .md\\:bg-yellow-700 {\n    --bg-opacity: 1;\n    background-color: #8e4b10;\n    background-color: rgba(142, 75, 16, var(--bg-opacity));\n  }\n  .md\\:bg-yellow-800 {\n    --bg-opacity: 1;\n    background-color: #723b13;\n    background-color: rgba(114, 59, 19, var(--bg-opacity));\n  }\n  .md\\:bg-yellow-900 {\n    --bg-opacity: 1;\n    background-color: #633112;\n    background-color: rgba(99, 49, 18, var(--bg-opacity));\n  }\n  .md\\:bg-green-50 {\n    --bg-opacity: 1;\n    background-color: #f3faf7;\n    background-color: rgba(243, 250, 247, var(--bg-opacity));\n  }\n  .md\\:bg-green-100 {\n    --bg-opacity: 1;\n    background-color: #def7ec;\n    background-color: rgba(222, 247, 236, var(--bg-opacity));\n  }\n  .md\\:bg-green-200 {\n    --bg-opacity: 1;\n    background-color: #bcf0da;\n    background-color: rgba(188, 240, 218, var(--bg-opacity));\n  }\n  .md\\:bg-green-300 {\n    --bg-opacity: 1;\n    background-color: #84e1bc;\n    background-color: rgba(132, 225, 188, var(--bg-opacity));\n  }\n  .md\\:bg-green-400 {\n    --bg-opacity: 1;\n    background-color: #31c48d;\n    background-color: rgba(49, 196, 141, var(--bg-opacity));\n  }\n  .md\\:bg-green-500 {\n    --bg-opacity: 1;\n    background-color: #0e9f6e;\n    background-color: rgba(14, 159, 110, var(--bg-opacity));\n  }\n  .md\\:bg-green-600 {\n    --bg-opacity: 1;\n    background-color: #057a55;\n    background-color: rgba(5, 122, 85, var(--bg-opacity));\n  }\n  .md\\:bg-green-700 {\n    --bg-opacity: 1;\n    background-color: #046c4e;\n    background-color: rgba(4, 108, 78, var(--bg-opacity));\n  }\n  .md\\:bg-green-800 {\n    --bg-opacity: 1;\n    background-color: #03543f;\n    background-color: rgba(3, 84, 63, var(--bg-opacity));\n  }\n  .md\\:bg-green-900 {\n    --bg-opacity: 1;\n    background-color: #014737;\n    background-color: rgba(1, 71, 55, var(--bg-opacity));\n  }\n  .md\\:bg-teal-50 {\n    --bg-opacity: 1;\n    background-color: #edfafa;\n    background-color: rgba(237, 250, 250, var(--bg-opacity));\n  }\n  .md\\:bg-teal-100 {\n    --bg-opacity: 1;\n    background-color: #d5f5f6;\n    background-color: rgba(213, 245, 246, var(--bg-opacity));\n  }\n  .md\\:bg-teal-200 {\n    --bg-opacity: 1;\n    background-color: #afecef;\n    background-color: rgba(175, 236, 239, var(--bg-opacity));\n  }\n  .md\\:bg-teal-300 {\n    --bg-opacity: 1;\n    background-color: #7edce2;\n    background-color: rgba(126, 220, 226, var(--bg-opacity));\n  }\n  .md\\:bg-teal-400 {\n    --bg-opacity: 1;\n    background-color: #16bdca;\n    background-color: rgba(22, 189, 202, var(--bg-opacity));\n  }\n  .md\\:bg-teal-500 {\n    --bg-opacity: 1;\n    background-color: #0694a2;\n    background-color: rgba(6, 148, 162, var(--bg-opacity));\n  }\n  .md\\:bg-teal-600 {\n    --bg-opacity: 1;\n    background-color: #047481;\n    background-color: rgba(4, 116, 129, var(--bg-opacity));\n  }\n  .md\\:bg-teal-700 {\n    --bg-opacity: 1;\n    background-color: #036672;\n    background-color: rgba(3, 102, 114, var(--bg-opacity));\n  }\n  .md\\:bg-teal-800 {\n    --bg-opacity: 1;\n    background-color: #05505c;\n    background-color: rgba(5, 80, 92, var(--bg-opacity));\n  }\n  .md\\:bg-teal-900 {\n    --bg-opacity: 1;\n    background-color: #014451;\n    background-color: rgba(1, 68, 81, var(--bg-opacity));\n  }\n  .md\\:bg-blue-50 {\n    --bg-opacity: 1;\n    background-color: #ebf5ff;\n    background-color: rgba(235, 245, 255, var(--bg-opacity));\n  }\n  .md\\:bg-blue-100 {\n    --bg-opacity: 1;\n    background-color: #e1effe;\n    background-color: rgba(225, 239, 254, var(--bg-opacity));\n  }\n  .md\\:bg-blue-200 {\n    --bg-opacity: 1;\n    background-color: #c3ddfd;\n    background-color: rgba(195, 221, 253, var(--bg-opacity));\n  }\n  .md\\:bg-blue-300 {\n    --bg-opacity: 1;\n    background-color: #a4cafe;\n    background-color: rgba(164, 202, 254, var(--bg-opacity));\n  }\n  .md\\:bg-blue-400 {\n    --bg-opacity: 1;\n    background-color: #76a9fa;\n    background-color: rgba(118, 169, 250, var(--bg-opacity));\n  }\n  .md\\:bg-blue-500 {\n    --bg-opacity: 1;\n    background-color: #3f83f8;\n    background-color: rgba(63, 131, 248, var(--bg-opacity));\n  }\n  .md\\:bg-blue-600 {\n    --bg-opacity: 1;\n    background-color: #1c64f2;\n    background-color: rgba(28, 100, 242, var(--bg-opacity));\n  }\n  .md\\:bg-blue-700 {\n    --bg-opacity: 1;\n    background-color: #1a56db;\n    background-color: rgba(26, 86, 219, var(--bg-opacity));\n  }\n  .md\\:bg-blue-800 {\n    --bg-opacity: 1;\n    background-color: #1e429f;\n    background-color: rgba(30, 66, 159, var(--bg-opacity));\n  }\n  .md\\:bg-blue-900 {\n    --bg-opacity: 1;\n    background-color: #233876;\n    background-color: rgba(35, 56, 118, var(--bg-opacity));\n  }\n  .md\\:bg-indigo-50 {\n    --bg-opacity: 1;\n    background-color: #f0f5ff;\n    background-color: rgba(240, 245, 255, var(--bg-opacity));\n  }\n  .md\\:bg-indigo-100 {\n    --bg-opacity: 1;\n    background-color: #e5edff;\n    background-color: rgba(229, 237, 255, var(--bg-opacity));\n  }\n  .md\\:bg-indigo-200 {\n    --bg-opacity: 1;\n    background-color: #cddbfe;\n    background-color: rgba(205, 219, 254, var(--bg-opacity));\n  }\n  .md\\:bg-indigo-300 {\n    --bg-opacity: 1;\n    background-color: #b4c6fc;\n    background-color: rgba(180, 198, 252, var(--bg-opacity));\n  }\n  .md\\:bg-indigo-400 {\n    --bg-opacity: 1;\n    background-color: #8da2fb;\n    background-color: rgba(141, 162, 251, var(--bg-opacity));\n  }\n  .md\\:bg-indigo-500 {\n    --bg-opacity: 1;\n    background-color: #6875f5;\n    background-color: rgba(104, 117, 245, var(--bg-opacity));\n  }\n  .md\\:bg-indigo-600 {\n    --bg-opacity: 1;\n    background-color: #5850ec;\n    background-color: rgba(88, 80, 236, var(--bg-opacity));\n  }\n  .md\\:bg-indigo-700 {\n    --bg-opacity: 1;\n    background-color: #5145cd;\n    background-color: rgba(81, 69, 205, var(--bg-opacity));\n  }\n  .md\\:bg-indigo-800 {\n    --bg-opacity: 1;\n    background-color: #42389d;\n    background-color: rgba(66, 56, 157, var(--bg-opacity));\n  }\n  .md\\:bg-indigo-900 {\n    --bg-opacity: 1;\n    background-color: #362f78;\n    background-color: rgba(54, 47, 120, var(--bg-opacity));\n  }\n  .md\\:bg-purple-50 {\n    --bg-opacity: 1;\n    background-color: #f6f5ff;\n    background-color: rgba(246, 245, 255, var(--bg-opacity));\n  }\n  .md\\:bg-purple-100 {\n    --bg-opacity: 1;\n    background-color: #edebfe;\n    background-color: rgba(237, 235, 254, var(--bg-opacity));\n  }\n  .md\\:bg-purple-200 {\n    --bg-opacity: 1;\n    background-color: #dcd7fe;\n    background-color: rgba(220, 215, 254, var(--bg-opacity));\n  }\n  .md\\:bg-purple-300 {\n    --bg-opacity: 1;\n    background-color: #cabffd;\n    background-color: rgba(202, 191, 253, var(--bg-opacity));\n  }\n  .md\\:bg-purple-400 {\n    --bg-opacity: 1;\n    background-color: #ac94fa;\n    background-color: rgba(172, 148, 250, var(--bg-opacity));\n  }\n  .md\\:bg-purple-500 {\n    --bg-opacity: 1;\n    background-color: #9061f9;\n    background-color: rgba(144, 97, 249, var(--bg-opacity));\n  }\n  .md\\:bg-purple-600 {\n    --bg-opacity: 1;\n    background-color: #7e3af2;\n    background-color: rgba(126, 58, 242, var(--bg-opacity));\n  }\n  .md\\:bg-purple-700 {\n    --bg-opacity: 1;\n    background-color: #6c2bd9;\n    background-color: rgba(108, 43, 217, var(--bg-opacity));\n  }\n  .md\\:bg-purple-800 {\n    --bg-opacity: 1;\n    background-color: #5521b5;\n    background-color: rgba(85, 33, 181, var(--bg-opacity));\n  }\n  .md\\:bg-purple-900 {\n    --bg-opacity: 1;\n    background-color: #4a1d96;\n    background-color: rgba(74, 29, 150, var(--bg-opacity));\n  }\n  .md\\:bg-pink-50 {\n    --bg-opacity: 1;\n    background-color: #fdf2f8;\n    background-color: rgba(253, 242, 248, var(--bg-opacity));\n  }\n  .md\\:bg-pink-100 {\n    --bg-opacity: 1;\n    background-color: #fce8f3;\n    background-color: rgba(252, 232, 243, var(--bg-opacity));\n  }\n  .md\\:bg-pink-200 {\n    --bg-opacity: 1;\n    background-color: #fad1e8;\n    background-color: rgba(250, 209, 232, var(--bg-opacity));\n  }\n  .md\\:bg-pink-300 {\n    --bg-opacity: 1;\n    background-color: #f8b4d9;\n    background-color: rgba(248, 180, 217, var(--bg-opacity));\n  }\n  .md\\:bg-pink-400 {\n    --bg-opacity: 1;\n    background-color: #f17eb8;\n    background-color: rgba(241, 126, 184, var(--bg-opacity));\n  }\n  .md\\:bg-pink-500 {\n    --bg-opacity: 1;\n    background-color: #e74694;\n    background-color: rgba(231, 70, 148, var(--bg-opacity));\n  }\n  .md\\:bg-pink-600 {\n    --bg-opacity: 1;\n    background-color: #d61f69;\n    background-color: rgba(214, 31, 105, var(--bg-opacity));\n  }\n  .md\\:bg-pink-700 {\n    --bg-opacity: 1;\n    background-color: #bf125d;\n    background-color: rgba(191, 18, 93, var(--bg-opacity));\n  }\n  .md\\:bg-pink-800 {\n    --bg-opacity: 1;\n    background-color: #99154b;\n    background-color: rgba(153, 21, 75, var(--bg-opacity));\n  }\n  .md\\:bg-pink-900 {\n    --bg-opacity: 1;\n    background-color: #751a3d;\n    background-color: rgba(117, 26, 61, var(--bg-opacity));\n  }\n  .md\\:bg-cool-gray-50 {\n    --bg-opacity: 1;\n    background-color: #f8fafc;\n    background-color: rgba(248, 250, 252, var(--bg-opacity));\n  }\n  .md\\:bg-cool-gray-100 {\n    --bg-opacity: 1;\n    background-color: #f1f5f9;\n    background-color: rgba(241, 245, 249, var(--bg-opacity));\n  }\n  .md\\:bg-cool-gray-200 {\n    --bg-opacity: 1;\n    background-color: #e2e8f0;\n    background-color: rgba(226, 232, 240, var(--bg-opacity));\n  }\n  .md\\:bg-cool-gray-300 {\n    --bg-opacity: 1;\n    background-color: #cfd8e3;\n    background-color: rgba(207, 216, 227, var(--bg-opacity));\n  }\n  .md\\:bg-cool-gray-400 {\n    --bg-opacity: 1;\n    background-color: #97a6ba;\n    background-color: rgba(151, 166, 186, var(--bg-opacity));\n  }\n  .md\\:bg-cool-gray-500 {\n    --bg-opacity: 1;\n    background-color: #64748b;\n    background-color: rgba(100, 116, 139, var(--bg-opacity));\n  }\n  .md\\:bg-cool-gray-600 {\n    --bg-opacity: 1;\n    background-color: #475569;\n    background-color: rgba(71, 85, 105, var(--bg-opacity));\n  }\n  .md\\:bg-cool-gray-700 {\n    --bg-opacity: 1;\n    background-color: #364152;\n    background-color: rgba(54, 65, 82, var(--bg-opacity));\n  }\n  .md\\:bg-cool-gray-800 {\n    --bg-opacity: 1;\n    background-color: #27303f;\n    background-color: rgba(39, 48, 63, var(--bg-opacity));\n  }\n  .md\\:bg-cool-gray-900 {\n    --bg-opacity: 1;\n    background-color: #1a202e;\n    background-color: rgba(26, 32, 46, var(--bg-opacity));\n  }\n  .group:hover .md\\:group-hover\\:bg-current {\n    background-color: currentColor;\n  }\n  .group:hover .md\\:group-hover\\:bg-transparent {\n    background-color: transparent;\n  }\n  .group:hover .md\\:group-hover\\:bg-white {\n    --bg-opacity: 1;\n    background-color: #ffffff;\n    background-color: rgba(255, 255, 255, var(--bg-opacity));\n  }\n  .group:hover .md\\:group-hover\\:bg-black {\n    --bg-opacity: 1;\n    background-color: #000000;\n    background-color: rgba(0, 0, 0, var(--bg-opacity));\n  }\n  .group:hover .md\\:group-hover\\:bg-gray-50 {\n    --bg-opacity: 1;\n    background-color: #f9fafb;\n    background-color: rgba(249, 250, 251, var(--bg-opacity));\n  }\n  .group:hover .md\\:group-hover\\:bg-gray-100 {\n    --bg-opacity: 1;\n    background-color: #f4f5f7;\n    background-color: rgba(244, 245, 247, var(--bg-opacity));\n  }\n  .group:hover .md\\:group-hover\\:bg-gray-200 {\n    --bg-opacity: 1;\n    background-color: #e5e7eb;\n    background-color: rgba(229, 231, 235, var(--bg-opacity));\n  }\n  .group:hover .md\\:group-hover\\:bg-gray-300 {\n    --bg-opacity: 1;\n    background-color: #d2d6dc;\n    background-color: rgba(210, 214, 220, var(--bg-opacity));\n  }\n  .group:hover .md\\:group-hover\\:bg-gray-400 {\n    --bg-opacity: 1;\n    background-color: #9fa6b2;\n    background-color: rgba(159, 166, 178, var(--bg-opacity));\n  }\n  .group:hover .md\\:group-hover\\:bg-gray-500 {\n    --bg-opacity: 1;\n    background-color: #6b7280;\n    background-color: rgba(107, 114, 128, var(--bg-opacity));\n  }\n  .group:hover .md\\:group-hover\\:bg-gray-600 {\n    --bg-opacity: 1;\n    background-color: #4b5563;\n    background-color: rgba(75, 85, 99, var(--bg-opacity));\n  }\n  .group:hover .md\\:group-hover\\:bg-gray-700 {\n    --bg-opacity: 1;\n    background-color: #374151;\n    background-color: rgba(55, 65, 81, var(--bg-opacity));\n  }\n  .group:hover .md\\:group-hover\\:bg-gray-800 {\n    --bg-opacity: 1;\n    background-color: #252f3f;\n    background-color: rgba(37, 47, 63, var(--bg-opacity));\n  }\n  .group:hover .md\\:group-hover\\:bg-gray-900 {\n    --bg-opacity: 1;\n    background-color: #161e2e;\n    background-color: rgba(22, 30, 46, var(--bg-opacity));\n  }\n  .group:hover .md\\:group-hover\\:bg-red-50 {\n    --bg-opacity: 1;\n    background-color: #fdf2f2;\n    background-color: rgba(253, 242, 242, var(--bg-opacity));\n  }\n  .group:hover .md\\:group-hover\\:bg-red-100 {\n    --bg-opacity: 1;\n    background-color: #fde8e8;\n    background-color: rgba(253, 232, 232, var(--bg-opacity));\n  }\n  .group:hover .md\\:group-hover\\:bg-red-200 {\n    --bg-opacity: 1;\n    background-color: #fbd5d5;\n    background-color: rgba(251, 213, 213, var(--bg-opacity));\n  }\n  .group:hover .md\\:group-hover\\:bg-red-300 {\n    --bg-opacity: 1;\n    background-color: #f8b4b4;\n    background-color: rgba(248, 180, 180, var(--bg-opacity));\n  }\n  .group:hover .md\\:group-hover\\:bg-red-400 {\n    --bg-opacity: 1;\n    background-color: #f98080;\n    background-color: rgba(249, 128, 128, var(--bg-opacity));\n  }\n  .group:hover .md\\:group-hover\\:bg-red-500 {\n    --bg-opacity: 1;\n    background-color: #f05252;\n    background-color: rgba(240, 82, 82, var(--bg-opacity));\n  }\n  .group:hover .md\\:group-hover\\:bg-red-600 {\n    --bg-opacity: 1;\n    background-color: #e02424;\n    background-color: rgba(224, 36, 36, var(--bg-opacity));\n  }\n  .group:hover .md\\:group-hover\\:bg-red-700 {\n    --bg-opacity: 1;\n    background-color: #c81e1e;\n    background-color: rgba(200, 30, 30, var(--bg-opacity));\n  }\n  .group:hover .md\\:group-hover\\:bg-red-800 {\n    --bg-opacity: 1;\n    background-color: #9b1c1c;\n    background-color: rgba(155, 28, 28, var(--bg-opacity));\n  }\n  .group:hover .md\\:group-hover\\:bg-red-900 {\n    --bg-opacity: 1;\n    background-color: #771d1d;\n    background-color: rgba(119, 29, 29, var(--bg-opacity));\n  }\n  .group:hover .md\\:group-hover\\:bg-orange-50 {\n    --bg-opacity: 1;\n    background-color: #fff8f1;\n    background-color: rgba(255, 248, 241, var(--bg-opacity));\n  }\n  .group:hover .md\\:group-hover\\:bg-orange-100 {\n    --bg-opacity: 1;\n    background-color: #feecdc;\n    background-color: rgba(254, 236, 220, var(--bg-opacity));\n  }\n  .group:hover .md\\:group-hover\\:bg-orange-200 {\n    --bg-opacity: 1;\n    background-color: #fcd9bd;\n    background-color: rgba(252, 217, 189, var(--bg-opacity));\n  }\n  .group:hover .md\\:group-hover\\:bg-orange-300 {\n    --bg-opacity: 1;\n    background-color: #fdba8c;\n    background-color: rgba(253, 186, 140, var(--bg-opacity));\n  }\n  .group:hover .md\\:group-hover\\:bg-orange-400 {\n    --bg-opacity: 1;\n    background-color: #ff8a4c;\n    background-color: rgba(255, 138, 76, var(--bg-opacity));\n  }\n  .group:hover .md\\:group-hover\\:bg-orange-500 {\n    --bg-opacity: 1;\n    background-color: #ff5a1f;\n    background-color: rgba(255, 90, 31, var(--bg-opacity));\n  }\n  .group:hover .md\\:group-hover\\:bg-orange-600 {\n    --bg-opacity: 1;\n    background-color: #d03801;\n    background-color: rgba(208, 56, 1, var(--bg-opacity));\n  }\n  .group:hover .md\\:group-hover\\:bg-orange-700 {\n    --bg-opacity: 1;\n    background-color: #b43403;\n    background-color: rgba(180, 52, 3, var(--bg-opacity));\n  }\n  .group:hover .md\\:group-hover\\:bg-orange-800 {\n    --bg-opacity: 1;\n    background-color: #8a2c0d;\n    background-color: rgba(138, 44, 13, var(--bg-opacity));\n  }\n  .group:hover .md\\:group-hover\\:bg-orange-900 {\n    --bg-opacity: 1;\n    background-color: #73230d;\n    background-color: rgba(115, 35, 13, var(--bg-opacity));\n  }\n  .group:hover .md\\:group-hover\\:bg-yellow-50 {\n    --bg-opacity: 1;\n    background-color: #fdfdea;\n    background-color: rgba(253, 253, 234, var(--bg-opacity));\n  }\n  .group:hover .md\\:group-hover\\:bg-yellow-100 {\n    --bg-opacity: 1;\n    background-color: #fdf6b2;\n    background-color: rgba(253, 246, 178, var(--bg-opacity));\n  }\n  .group:hover .md\\:group-hover\\:bg-yellow-200 {\n    --bg-opacity: 1;\n    background-color: #fce96a;\n    background-color: rgba(252, 233, 106, var(--bg-opacity));\n  }\n  .group:hover .md\\:group-hover\\:bg-yellow-300 {\n    --bg-opacity: 1;\n    background-color: #faca15;\n    background-color: rgba(250, 202, 21, var(--bg-opacity));\n  }\n  .group:hover .md\\:group-hover\\:bg-yellow-400 {\n    --bg-opacity: 1;\n    background-color: #e3a008;\n    background-color: rgba(227, 160, 8, var(--bg-opacity));\n  }\n  .group:hover .md\\:group-hover\\:bg-yellow-500 {\n    --bg-opacity: 1;\n    background-color: #c27803;\n    background-color: rgba(194, 120, 3, var(--bg-opacity));\n  }\n  .group:hover .md\\:group-hover\\:bg-yellow-600 {\n    --bg-opacity: 1;\n    background-color: #9f580a;\n    background-color: rgba(159, 88, 10, var(--bg-opacity));\n  }\n  .group:hover .md\\:group-hover\\:bg-yellow-700 {\n    --bg-opacity: 1;\n    background-color: #8e4b10;\n    background-color: rgba(142, 75, 16, var(--bg-opacity));\n  }\n  .group:hover .md\\:group-hover\\:bg-yellow-800 {\n    --bg-opacity: 1;\n    background-color: #723b13;\n    background-color: rgba(114, 59, 19, var(--bg-opacity));\n  }\n  .group:hover .md\\:group-hover\\:bg-yellow-900 {\n    --bg-opacity: 1;\n    background-color: #633112;\n    background-color: rgba(99, 49, 18, var(--bg-opacity));\n  }\n  .group:hover .md\\:group-hover\\:bg-green-50 {\n    --bg-opacity: 1;\n    background-color: #f3faf7;\n    background-color: rgba(243, 250, 247, var(--bg-opacity));\n  }\n  .group:hover .md\\:group-hover\\:bg-green-100 {\n    --bg-opacity: 1;\n    background-color: #def7ec;\n    background-color: rgba(222, 247, 236, var(--bg-opacity));\n  }\n  .group:hover .md\\:group-hover\\:bg-green-200 {\n    --bg-opacity: 1;\n    background-color: #bcf0da;\n    background-color: rgba(188, 240, 218, var(--bg-opacity));\n  }\n  .group:hover .md\\:group-hover\\:bg-green-300 {\n    --bg-opacity: 1;\n    background-color: #84e1bc;\n    background-color: rgba(132, 225, 188, var(--bg-opacity));\n  }\n  .group:hover .md\\:group-hover\\:bg-green-400 {\n    --bg-opacity: 1;\n    background-color: #31c48d;\n    background-color: rgba(49, 196, 141, var(--bg-opacity));\n  }\n  .group:hover .md\\:group-hover\\:bg-green-500 {\n    --bg-opacity: 1;\n    background-color: #0e9f6e;\n    background-color: rgba(14, 159, 110, var(--bg-opacity));\n  }\n  .group:hover .md\\:group-hover\\:bg-green-600 {\n    --bg-opacity: 1;\n    background-color: #057a55;\n    background-color: rgba(5, 122, 85, var(--bg-opacity));\n  }\n  .group:hover .md\\:group-hover\\:bg-green-700 {\n    --bg-opacity: 1;\n    background-color: #046c4e;\n    background-color: rgba(4, 108, 78, var(--bg-opacity));\n  }\n  .group:hover .md\\:group-hover\\:bg-green-800 {\n    --bg-opacity: 1;\n    background-color: #03543f;\n    background-color: rgba(3, 84, 63, var(--bg-opacity));\n  }\n  .group:hover .md\\:group-hover\\:bg-green-900 {\n    --bg-opacity: 1;\n    background-color: #014737;\n    background-color: rgba(1, 71, 55, var(--bg-opacity));\n  }\n  .group:hover .md\\:group-hover\\:bg-teal-50 {\n    --bg-opacity: 1;\n    background-color: #edfafa;\n    background-color: rgba(237, 250, 250, var(--bg-opacity));\n  }\n  .group:hover .md\\:group-hover\\:bg-teal-100 {\n    --bg-opacity: 1;\n    background-color: #d5f5f6;\n    background-color: rgba(213, 245, 246, var(--bg-opacity));\n  }\n  .group:hover .md\\:group-hover\\:bg-teal-200 {\n    --bg-opacity: 1;\n    background-color: #afecef;\n    background-color: rgba(175, 236, 239, var(--bg-opacity));\n  }\n  .group:hover .md\\:group-hover\\:bg-teal-300 {\n    --bg-opacity: 1;\n    background-color: #7edce2;\n    background-color: rgba(126, 220, 226, var(--bg-opacity));\n  }\n  .group:hover .md\\:group-hover\\:bg-teal-400 {\n    --bg-opacity: 1;\n    background-color: #16bdca;\n    background-color: rgba(22, 189, 202, var(--bg-opacity));\n  }\n  .group:hover .md\\:group-hover\\:bg-teal-500 {\n    --bg-opacity: 1;\n    background-color: #0694a2;\n    background-color: rgba(6, 148, 162, var(--bg-opacity));\n  }\n  .group:hover .md\\:group-hover\\:bg-teal-600 {\n    --bg-opacity: 1;\n    background-color: #047481;\n    background-color: rgba(4, 116, 129, var(--bg-opacity));\n  }\n  .group:hover .md\\:group-hover\\:bg-teal-700 {\n    --bg-opacity: 1;\n    background-color: #036672;\n    background-color: rgba(3, 102, 114, var(--bg-opacity));\n  }\n  .group:hover .md\\:group-hover\\:bg-teal-800 {\n    --bg-opacity: 1;\n    background-color: #05505c;\n    background-color: rgba(5, 80, 92, var(--bg-opacity));\n  }\n  .group:hover .md\\:group-hover\\:bg-teal-900 {\n    --bg-opacity: 1;\n    background-color: #014451;\n    background-color: rgba(1, 68, 81, var(--bg-opacity));\n  }\n  .group:hover .md\\:group-hover\\:bg-blue-50 {\n    --bg-opacity: 1;\n    background-color: #ebf5ff;\n    background-color: rgba(235, 245, 255, var(--bg-opacity));\n  }\n  .group:hover .md\\:group-hover\\:bg-blue-100 {\n    --bg-opacity: 1;\n    background-color: #e1effe;\n    background-color: rgba(225, 239, 254, var(--bg-opacity));\n  }\n  .group:hover .md\\:group-hover\\:bg-blue-200 {\n    --bg-opacity: 1;\n    background-color: #c3ddfd;\n    background-color: rgba(195, 221, 253, var(--bg-opacity));\n  }\n  .group:hover .md\\:group-hover\\:bg-blue-300 {\n    --bg-opacity: 1;\n    background-color: #a4cafe;\n    background-color: rgba(164, 202, 254, var(--bg-opacity));\n  }\n  .group:hover .md\\:group-hover\\:bg-blue-400 {\n    --bg-opacity: 1;\n    background-color: #76a9fa;\n    background-color: rgba(118, 169, 250, var(--bg-opacity));\n  }\n  .group:hover .md\\:group-hover\\:bg-blue-500 {\n    --bg-opacity: 1;\n    background-color: #3f83f8;\n    background-color: rgba(63, 131, 248, var(--bg-opacity));\n  }\n  .group:hover .md\\:group-hover\\:bg-blue-600 {\n    --bg-opacity: 1;\n    background-color: #1c64f2;\n    background-color: rgba(28, 100, 242, var(--bg-opacity));\n  }\n  .group:hover .md\\:group-hover\\:bg-blue-700 {\n    --bg-opacity: 1;\n    background-color: #1a56db;\n    background-color: rgba(26, 86, 219, var(--bg-opacity));\n  }\n  .group:hover .md\\:group-hover\\:bg-blue-800 {\n    --bg-opacity: 1;\n    background-color: #1e429f;\n    background-color: rgba(30, 66, 159, var(--bg-opacity));\n  }\n  .group:hover .md\\:group-hover\\:bg-blue-900 {\n    --bg-opacity: 1;\n    background-color: #233876;\n    background-color: rgba(35, 56, 118, var(--bg-opacity));\n  }\n  .group:hover .md\\:group-hover\\:bg-indigo-50 {\n    --bg-opacity: 1;\n    background-color: #f0f5ff;\n    background-color: rgba(240, 245, 255, var(--bg-opacity));\n  }\n  .group:hover .md\\:group-hover\\:bg-indigo-100 {\n    --bg-opacity: 1;\n    background-color: #e5edff;\n    background-color: rgba(229, 237, 255, var(--bg-opacity));\n  }\n  .group:hover .md\\:group-hover\\:bg-indigo-200 {\n    --bg-opacity: 1;\n    background-color: #cddbfe;\n    background-color: rgba(205, 219, 254, var(--bg-opacity));\n  }\n  .group:hover .md\\:group-hover\\:bg-indigo-300 {\n    --bg-opacity: 1;\n    background-color: #b4c6fc;\n    background-color: rgba(180, 198, 252, var(--bg-opacity));\n  }\n  .group:hover .md\\:group-hover\\:bg-indigo-400 {\n    --bg-opacity: 1;\n    background-color: #8da2fb;\n    background-color: rgba(141, 162, 251, var(--bg-opacity));\n  }\n  .group:hover .md\\:group-hover\\:bg-indigo-500 {\n    --bg-opacity: 1;\n    background-color: #6875f5;\n    background-color: rgba(104, 117, 245, var(--bg-opacity));\n  }\n  .group:hover .md\\:group-hover\\:bg-indigo-600 {\n    --bg-opacity: 1;\n    background-color: #5850ec;\n    background-color: rgba(88, 80, 236, var(--bg-opacity));\n  }\n  .group:hover .md\\:group-hover\\:bg-indigo-700 {\n    --bg-opacity: 1;\n    background-color: #5145cd;\n    background-color: rgba(81, 69, 205, var(--bg-opacity));\n  }\n  .group:hover .md\\:group-hover\\:bg-indigo-800 {\n    --bg-opacity: 1;\n    background-color: #42389d;\n    background-color: rgba(66, 56, 157, var(--bg-opacity));\n  }\n  .group:hover .md\\:group-hover\\:bg-indigo-900 {\n    --bg-opacity: 1;\n    background-color: #362f78;\n    background-color: rgba(54, 47, 120, var(--bg-opacity));\n  }\n  .group:hover .md\\:group-hover\\:bg-purple-50 {\n    --bg-opacity: 1;\n    background-color: #f6f5ff;\n    background-color: rgba(246, 245, 255, var(--bg-opacity));\n  }\n  .group:hover .md\\:group-hover\\:bg-purple-100 {\n    --bg-opacity: 1;\n    background-color: #edebfe;\n    background-color: rgba(237, 235, 254, var(--bg-opacity));\n  }\n  .group:hover .md\\:group-hover\\:bg-purple-200 {\n    --bg-opacity: 1;\n    background-color: #dcd7fe;\n    background-color: rgba(220, 215, 254, var(--bg-opacity));\n  }\n  .group:hover .md\\:group-hover\\:bg-purple-300 {\n    --bg-opacity: 1;\n    background-color: #cabffd;\n    background-color: rgba(202, 191, 253, var(--bg-opacity));\n  }\n  .group:hover .md\\:group-hover\\:bg-purple-400 {\n    --bg-opacity: 1;\n    background-color: #ac94fa;\n    background-color: rgba(172, 148, 250, var(--bg-opacity));\n  }\n  .group:hover .md\\:group-hover\\:bg-purple-500 {\n    --bg-opacity: 1;\n    background-color: #9061f9;\n    background-color: rgba(144, 97, 249, var(--bg-opacity));\n  }\n  .group:hover .md\\:group-hover\\:bg-purple-600 {\n    --bg-opacity: 1;\n    background-color: #7e3af2;\n    background-color: rgba(126, 58, 242, var(--bg-opacity));\n  }\n  .group:hover .md\\:group-hover\\:bg-purple-700 {\n    --bg-opacity: 1;\n    background-color: #6c2bd9;\n    background-color: rgba(108, 43, 217, var(--bg-opacity));\n  }\n  .group:hover .md\\:group-hover\\:bg-purple-800 {\n    --bg-opacity: 1;\n    background-color: #5521b5;\n    background-color: rgba(85, 33, 181, var(--bg-opacity));\n  }\n  .group:hover .md\\:group-hover\\:bg-purple-900 {\n    --bg-opacity: 1;\n    background-color: #4a1d96;\n    background-color: rgba(74, 29, 150, var(--bg-opacity));\n  }\n  .group:hover .md\\:group-hover\\:bg-pink-50 {\n    --bg-opacity: 1;\n    background-color: #fdf2f8;\n    background-color: rgba(253, 242, 248, var(--bg-opacity));\n  }\n  .group:hover .md\\:group-hover\\:bg-pink-100 {\n    --bg-opacity: 1;\n    background-color: #fce8f3;\n    background-color: rgba(252, 232, 243, var(--bg-opacity));\n  }\n  .group:hover .md\\:group-hover\\:bg-pink-200 {\n    --bg-opacity: 1;\n    background-color: #fad1e8;\n    background-color: rgba(250, 209, 232, var(--bg-opacity));\n  }\n  .group:hover .md\\:group-hover\\:bg-pink-300 {\n    --bg-opacity: 1;\n    background-color: #f8b4d9;\n    background-color: rgba(248, 180, 217, var(--bg-opacity));\n  }\n  .group:hover .md\\:group-hover\\:bg-pink-400 {\n    --bg-opacity: 1;\n    background-color: #f17eb8;\n    background-color: rgba(241, 126, 184, var(--bg-opacity));\n  }\n  .group:hover .md\\:group-hover\\:bg-pink-500 {\n    --bg-opacity: 1;\n    background-color: #e74694;\n    background-color: rgba(231, 70, 148, var(--bg-opacity));\n  }\n  .group:hover .md\\:group-hover\\:bg-pink-600 {\n    --bg-opacity: 1;\n    background-color: #d61f69;\n    background-color: rgba(214, 31, 105, var(--bg-opacity));\n  }\n  .group:hover .md\\:group-hover\\:bg-pink-700 {\n    --bg-opacity: 1;\n    background-color: #bf125d;\n    background-color: rgba(191, 18, 93, var(--bg-opacity));\n  }\n  .group:hover .md\\:group-hover\\:bg-pink-800 {\n    --bg-opacity: 1;\n    background-color: #99154b;\n    background-color: rgba(153, 21, 75, var(--bg-opacity));\n  }\n  .group:hover .md\\:group-hover\\:bg-pink-900 {\n    --bg-opacity: 1;\n    background-color: #751a3d;\n    background-color: rgba(117, 26, 61, var(--bg-opacity));\n  }\n  .group:hover .md\\:group-hover\\:bg-cool-gray-50 {\n    --bg-opacity: 1;\n    background-color: #f8fafc;\n    background-color: rgba(248, 250, 252, var(--bg-opacity));\n  }\n  .group:hover .md\\:group-hover\\:bg-cool-gray-100 {\n    --bg-opacity: 1;\n    background-color: #f1f5f9;\n    background-color: rgba(241, 245, 249, var(--bg-opacity));\n  }\n  .group:hover .md\\:group-hover\\:bg-cool-gray-200 {\n    --bg-opacity: 1;\n    background-color: #e2e8f0;\n    background-color: rgba(226, 232, 240, var(--bg-opacity));\n  }\n  .group:hover .md\\:group-hover\\:bg-cool-gray-300 {\n    --bg-opacity: 1;\n    background-color: #cfd8e3;\n    background-color: rgba(207, 216, 227, var(--bg-opacity));\n  }\n  .group:hover .md\\:group-hover\\:bg-cool-gray-400 {\n    --bg-opacity: 1;\n    background-color: #97a6ba;\n    background-color: rgba(151, 166, 186, var(--bg-opacity));\n  }\n  .group:hover .md\\:group-hover\\:bg-cool-gray-500 {\n    --bg-opacity: 1;\n    background-color: #64748b;\n    background-color: rgba(100, 116, 139, var(--bg-opacity));\n  }\n  .group:hover .md\\:group-hover\\:bg-cool-gray-600 {\n    --bg-opacity: 1;\n    background-color: #475569;\n    background-color: rgba(71, 85, 105, var(--bg-opacity));\n  }\n  .group:hover .md\\:group-hover\\:bg-cool-gray-700 {\n    --bg-opacity: 1;\n    background-color: #364152;\n    background-color: rgba(54, 65, 82, var(--bg-opacity));\n  }\n  .group:hover .md\\:group-hover\\:bg-cool-gray-800 {\n    --bg-opacity: 1;\n    background-color: #27303f;\n    background-color: rgba(39, 48, 63, var(--bg-opacity));\n  }\n  .group:hover .md\\:group-hover\\:bg-cool-gray-900 {\n    --bg-opacity: 1;\n    background-color: #1a202e;\n    background-color: rgba(26, 32, 46, var(--bg-opacity));\n  }\n  .group:focus .md\\:group-focus\\:bg-current {\n    background-color: currentColor;\n  }\n  .group:focus .md\\:group-focus\\:bg-transparent {\n    background-color: transparent;\n  }\n  .group:focus .md\\:group-focus\\:bg-white {\n    --bg-opacity: 1;\n    background-color: #ffffff;\n    background-color: rgba(255, 255, 255, var(--bg-opacity));\n  }\n  .group:focus .md\\:group-focus\\:bg-black {\n    --bg-opacity: 1;\n    background-color: #000000;\n    background-color: rgba(0, 0, 0, var(--bg-opacity));\n  }\n  .group:focus .md\\:group-focus\\:bg-gray-50 {\n    --bg-opacity: 1;\n    background-color: #f9fafb;\n    background-color: rgba(249, 250, 251, var(--bg-opacity));\n  }\n  .group:focus .md\\:group-focus\\:bg-gray-100 {\n    --bg-opacity: 1;\n    background-color: #f4f5f7;\n    background-color: rgba(244, 245, 247, var(--bg-opacity));\n  }\n  .group:focus .md\\:group-focus\\:bg-gray-200 {\n    --bg-opacity: 1;\n    background-color: #e5e7eb;\n    background-color: rgba(229, 231, 235, var(--bg-opacity));\n  }\n  .group:focus .md\\:group-focus\\:bg-gray-300 {\n    --bg-opacity: 1;\n    background-color: #d2d6dc;\n    background-color: rgba(210, 214, 220, var(--bg-opacity));\n  }\n  .group:focus .md\\:group-focus\\:bg-gray-400 {\n    --bg-opacity: 1;\n    background-color: #9fa6b2;\n    background-color: rgba(159, 166, 178, var(--bg-opacity));\n  }\n  .group:focus .md\\:group-focus\\:bg-gray-500 {\n    --bg-opacity: 1;\n    background-color: #6b7280;\n    background-color: rgba(107, 114, 128, var(--bg-opacity));\n  }\n  .group:focus .md\\:group-focus\\:bg-gray-600 {\n    --bg-opacity: 1;\n    background-color: #4b5563;\n    background-color: rgba(75, 85, 99, var(--bg-opacity));\n  }\n  .group:focus .md\\:group-focus\\:bg-gray-700 {\n    --bg-opacity: 1;\n    background-color: #374151;\n    background-color: rgba(55, 65, 81, var(--bg-opacity));\n  }\n  .group:focus .md\\:group-focus\\:bg-gray-800 {\n    --bg-opacity: 1;\n    background-color: #252f3f;\n    background-color: rgba(37, 47, 63, var(--bg-opacity));\n  }\n  .group:focus .md\\:group-focus\\:bg-gray-900 {\n    --bg-opacity: 1;\n    background-color: #161e2e;\n    background-color: rgba(22, 30, 46, var(--bg-opacity));\n  }\n  .group:focus .md\\:group-focus\\:bg-red-50 {\n    --bg-opacity: 1;\n    background-color: #fdf2f2;\n    background-color: rgba(253, 242, 242, var(--bg-opacity));\n  }\n  .group:focus .md\\:group-focus\\:bg-red-100 {\n    --bg-opacity: 1;\n    background-color: #fde8e8;\n    background-color: rgba(253, 232, 232, var(--bg-opacity));\n  }\n  .group:focus .md\\:group-focus\\:bg-red-200 {\n    --bg-opacity: 1;\n    background-color: #fbd5d5;\n    background-color: rgba(251, 213, 213, var(--bg-opacity));\n  }\n  .group:focus .md\\:group-focus\\:bg-red-300 {\n    --bg-opacity: 1;\n    background-color: #f8b4b4;\n    background-color: rgba(248, 180, 180, var(--bg-opacity));\n  }\n  .group:focus .md\\:group-focus\\:bg-red-400 {\n    --bg-opacity: 1;\n    background-color: #f98080;\n    background-color: rgba(249, 128, 128, var(--bg-opacity));\n  }\n  .group:focus .md\\:group-focus\\:bg-red-500 {\n    --bg-opacity: 1;\n    background-color: #f05252;\n    background-color: rgba(240, 82, 82, var(--bg-opacity));\n  }\n  .group:focus .md\\:group-focus\\:bg-red-600 {\n    --bg-opacity: 1;\n    background-color: #e02424;\n    background-color: rgba(224, 36, 36, var(--bg-opacity));\n  }\n  .group:focus .md\\:group-focus\\:bg-red-700 {\n    --bg-opacity: 1;\n    background-color: #c81e1e;\n    background-color: rgba(200, 30, 30, var(--bg-opacity));\n  }\n  .group:focus .md\\:group-focus\\:bg-red-800 {\n    --bg-opacity: 1;\n    background-color: #9b1c1c;\n    background-color: rgba(155, 28, 28, var(--bg-opacity));\n  }\n  .group:focus .md\\:group-focus\\:bg-red-900 {\n    --bg-opacity: 1;\n    background-color: #771d1d;\n    background-color: rgba(119, 29, 29, var(--bg-opacity));\n  }\n  .group:focus .md\\:group-focus\\:bg-orange-50 {\n    --bg-opacity: 1;\n    background-color: #fff8f1;\n    background-color: rgba(255, 248, 241, var(--bg-opacity));\n  }\n  .group:focus .md\\:group-focus\\:bg-orange-100 {\n    --bg-opacity: 1;\n    background-color: #feecdc;\n    background-color: rgba(254, 236, 220, var(--bg-opacity));\n  }\n  .group:focus .md\\:group-focus\\:bg-orange-200 {\n    --bg-opacity: 1;\n    background-color: #fcd9bd;\n    background-color: rgba(252, 217, 189, var(--bg-opacity));\n  }\n  .group:focus .md\\:group-focus\\:bg-orange-300 {\n    --bg-opacity: 1;\n    background-color: #fdba8c;\n    background-color: rgba(253, 186, 140, var(--bg-opacity));\n  }\n  .group:focus .md\\:group-focus\\:bg-orange-400 {\n    --bg-opacity: 1;\n    background-color: #ff8a4c;\n    background-color: rgba(255, 138, 76, var(--bg-opacity));\n  }\n  .group:focus .md\\:group-focus\\:bg-orange-500 {\n    --bg-opacity: 1;\n    background-color: #ff5a1f;\n    background-color: rgba(255, 90, 31, var(--bg-opacity));\n  }\n  .group:focus .md\\:group-focus\\:bg-orange-600 {\n    --bg-opacity: 1;\n    background-color: #d03801;\n    background-color: rgba(208, 56, 1, var(--bg-opacity));\n  }\n  .group:focus .md\\:group-focus\\:bg-orange-700 {\n    --bg-opacity: 1;\n    background-color: #b43403;\n    background-color: rgba(180, 52, 3, var(--bg-opacity));\n  }\n  .group:focus .md\\:group-focus\\:bg-orange-800 {\n    --bg-opacity: 1;\n    background-color: #8a2c0d;\n    background-color: rgba(138, 44, 13, var(--bg-opacity));\n  }\n  .group:focus .md\\:group-focus\\:bg-orange-900 {\n    --bg-opacity: 1;\n    background-color: #73230d;\n    background-color: rgba(115, 35, 13, var(--bg-opacity));\n  }\n  .group:focus .md\\:group-focus\\:bg-yellow-50 {\n    --bg-opacity: 1;\n    background-color: #fdfdea;\n    background-color: rgba(253, 253, 234, var(--bg-opacity));\n  }\n  .group:focus .md\\:group-focus\\:bg-yellow-100 {\n    --bg-opacity: 1;\n    background-color: #fdf6b2;\n    background-color: rgba(253, 246, 178, var(--bg-opacity));\n  }\n  .group:focus .md\\:group-focus\\:bg-yellow-200 {\n    --bg-opacity: 1;\n    background-color: #fce96a;\n    background-color: rgba(252, 233, 106, var(--bg-opacity));\n  }\n  .group:focus .md\\:group-focus\\:bg-yellow-300 {\n    --bg-opacity: 1;\n    background-color: #faca15;\n    background-color: rgba(250, 202, 21, var(--bg-opacity));\n  }\n  .group:focus .md\\:group-focus\\:bg-yellow-400 {\n    --bg-opacity: 1;\n    background-color: #e3a008;\n    background-color: rgba(227, 160, 8, var(--bg-opacity));\n  }\n  .group:focus .md\\:group-focus\\:bg-yellow-500 {\n    --bg-opacity: 1;\n    background-color: #c27803;\n    background-color: rgba(194, 120, 3, var(--bg-opacity));\n  }\n  .group:focus .md\\:group-focus\\:bg-yellow-600 {\n    --bg-opacity: 1;\n    background-color: #9f580a;\n    background-color: rgba(159, 88, 10, var(--bg-opacity));\n  }\n  .group:focus .md\\:group-focus\\:bg-yellow-700 {\n    --bg-opacity: 1;\n    background-color: #8e4b10;\n    background-color: rgba(142, 75, 16, var(--bg-opacity));\n  }\n  .group:focus .md\\:group-focus\\:bg-yellow-800 {\n    --bg-opacity: 1;\n    background-color: #723b13;\n    background-color: rgba(114, 59, 19, var(--bg-opacity));\n  }\n  .group:focus .md\\:group-focus\\:bg-yellow-900 {\n    --bg-opacity: 1;\n    background-color: #633112;\n    background-color: rgba(99, 49, 18, var(--bg-opacity));\n  }\n  .group:focus .md\\:group-focus\\:bg-green-50 {\n    --bg-opacity: 1;\n    background-color: #f3faf7;\n    background-color: rgba(243, 250, 247, var(--bg-opacity));\n  }\n  .group:focus .md\\:group-focus\\:bg-green-100 {\n    --bg-opacity: 1;\n    background-color: #def7ec;\n    background-color: rgba(222, 247, 236, var(--bg-opacity));\n  }\n  .group:focus .md\\:group-focus\\:bg-green-200 {\n    --bg-opacity: 1;\n    background-color: #bcf0da;\n    background-color: rgba(188, 240, 218, var(--bg-opacity));\n  }\n  .group:focus .md\\:group-focus\\:bg-green-300 {\n    --bg-opacity: 1;\n    background-color: #84e1bc;\n    background-color: rgba(132, 225, 188, var(--bg-opacity));\n  }\n  .group:focus .md\\:group-focus\\:bg-green-400 {\n    --bg-opacity: 1;\n    background-color: #31c48d;\n    background-color: rgba(49, 196, 141, var(--bg-opacity));\n  }\n  .group:focus .md\\:group-focus\\:bg-green-500 {\n    --bg-opacity: 1;\n    background-color: #0e9f6e;\n    background-color: rgba(14, 159, 110, var(--bg-opacity));\n  }\n  .group:focus .md\\:group-focus\\:bg-green-600 {\n    --bg-opacity: 1;\n    background-color: #057a55;\n    background-color: rgba(5, 122, 85, var(--bg-opacity));\n  }\n  .group:focus .md\\:group-focus\\:bg-green-700 {\n    --bg-opacity: 1;\n    background-color: #046c4e;\n    background-color: rgba(4, 108, 78, var(--bg-opacity));\n  }\n  .group:focus .md\\:group-focus\\:bg-green-800 {\n    --bg-opacity: 1;\n    background-color: #03543f;\n    background-color: rgba(3, 84, 63, var(--bg-opacity));\n  }\n  .group:focus .md\\:group-focus\\:bg-green-900 {\n    --bg-opacity: 1;\n    background-color: #014737;\n    background-color: rgba(1, 71, 55, var(--bg-opacity));\n  }\n  .group:focus .md\\:group-focus\\:bg-teal-50 {\n    --bg-opacity: 1;\n    background-color: #edfafa;\n    background-color: rgba(237, 250, 250, var(--bg-opacity));\n  }\n  .group:focus .md\\:group-focus\\:bg-teal-100 {\n    --bg-opacity: 1;\n    background-color: #d5f5f6;\n    background-color: rgba(213, 245, 246, var(--bg-opacity));\n  }\n  .group:focus .md\\:group-focus\\:bg-teal-200 {\n    --bg-opacity: 1;\n    background-color: #afecef;\n    background-color: rgba(175, 236, 239, var(--bg-opacity));\n  }\n  .group:focus .md\\:group-focus\\:bg-teal-300 {\n    --bg-opacity: 1;\n    background-color: #7edce2;\n    background-color: rgba(126, 220, 226, var(--bg-opacity));\n  }\n  .group:focus .md\\:group-focus\\:bg-teal-400 {\n    --bg-opacity: 1;\n    background-color: #16bdca;\n    background-color: rgba(22, 189, 202, var(--bg-opacity));\n  }\n  .group:focus .md\\:group-focus\\:bg-teal-500 {\n    --bg-opacity: 1;\n    background-color: #0694a2;\n    background-color: rgba(6, 148, 162, var(--bg-opacity));\n  }\n  .group:focus .md\\:group-focus\\:bg-teal-600 {\n    --bg-opacity: 1;\n    background-color: #047481;\n    background-color: rgba(4, 116, 129, var(--bg-opacity));\n  }\n  .group:focus .md\\:group-focus\\:bg-teal-700 {\n    --bg-opacity: 1;\n    background-color: #036672;\n    background-color: rgba(3, 102, 114, var(--bg-opacity));\n  }\n  .group:focus .md\\:group-focus\\:bg-teal-800 {\n    --bg-opacity: 1;\n    background-color: #05505c;\n    background-color: rgba(5, 80, 92, var(--bg-opacity));\n  }\n  .group:focus .md\\:group-focus\\:bg-teal-900 {\n    --bg-opacity: 1;\n    background-color: #014451;\n    background-color: rgba(1, 68, 81, var(--bg-opacity));\n  }\n  .group:focus .md\\:group-focus\\:bg-blue-50 {\n    --bg-opacity: 1;\n    background-color: #ebf5ff;\n    background-color: rgba(235, 245, 255, var(--bg-opacity));\n  }\n  .group:focus .md\\:group-focus\\:bg-blue-100 {\n    --bg-opacity: 1;\n    background-color: #e1effe;\n    background-color: rgba(225, 239, 254, var(--bg-opacity));\n  }\n  .group:focus .md\\:group-focus\\:bg-blue-200 {\n    --bg-opacity: 1;\n    background-color: #c3ddfd;\n    background-color: rgba(195, 221, 253, var(--bg-opacity));\n  }\n  .group:focus .md\\:group-focus\\:bg-blue-300 {\n    --bg-opacity: 1;\n    background-color: #a4cafe;\n    background-color: rgba(164, 202, 254, var(--bg-opacity));\n  }\n  .group:focus .md\\:group-focus\\:bg-blue-400 {\n    --bg-opacity: 1;\n    background-color: #76a9fa;\n    background-color: rgba(118, 169, 250, var(--bg-opacity));\n  }\n  .group:focus .md\\:group-focus\\:bg-blue-500 {\n    --bg-opacity: 1;\n    background-color: #3f83f8;\n    background-color: rgba(63, 131, 248, var(--bg-opacity));\n  }\n  .group:focus .md\\:group-focus\\:bg-blue-600 {\n    --bg-opacity: 1;\n    background-color: #1c64f2;\n    background-color: rgba(28, 100, 242, var(--bg-opacity));\n  }\n  .group:focus .md\\:group-focus\\:bg-blue-700 {\n    --bg-opacity: 1;\n    background-color: #1a56db;\n    background-color: rgba(26, 86, 219, var(--bg-opacity));\n  }\n  .group:focus .md\\:group-focus\\:bg-blue-800 {\n    --bg-opacity: 1;\n    background-color: #1e429f;\n    background-color: rgba(30, 66, 159, var(--bg-opacity));\n  }\n  .group:focus .md\\:group-focus\\:bg-blue-900 {\n    --bg-opacity: 1;\n    background-color: #233876;\n    background-color: rgba(35, 56, 118, var(--bg-opacity));\n  }\n  .group:focus .md\\:group-focus\\:bg-indigo-50 {\n    --bg-opacity: 1;\n    background-color: #f0f5ff;\n    background-color: rgba(240, 245, 255, var(--bg-opacity));\n  }\n  .group:focus .md\\:group-focus\\:bg-indigo-100 {\n    --bg-opacity: 1;\n    background-color: #e5edff;\n    background-color: rgba(229, 237, 255, var(--bg-opacity));\n  }\n  .group:focus .md\\:group-focus\\:bg-indigo-200 {\n    --bg-opacity: 1;\n    background-color: #cddbfe;\n    background-color: rgba(205, 219, 254, var(--bg-opacity));\n  }\n  .group:focus .md\\:group-focus\\:bg-indigo-300 {\n    --bg-opacity: 1;\n    background-color: #b4c6fc;\n    background-color: rgba(180, 198, 252, var(--bg-opacity));\n  }\n  .group:focus .md\\:group-focus\\:bg-indigo-400 {\n    --bg-opacity: 1;\n    background-color: #8da2fb;\n    background-color: rgba(141, 162, 251, var(--bg-opacity));\n  }\n  .group:focus .md\\:group-focus\\:bg-indigo-500 {\n    --bg-opacity: 1;\n    background-color: #6875f5;\n    background-color: rgba(104, 117, 245, var(--bg-opacity));\n  }\n  .group:focus .md\\:group-focus\\:bg-indigo-600 {\n    --bg-opacity: 1;\n    background-color: #5850ec;\n    background-color: rgba(88, 80, 236, var(--bg-opacity));\n  }\n  .group:focus .md\\:group-focus\\:bg-indigo-700 {\n    --bg-opacity: 1;\n    background-color: #5145cd;\n    background-color: rgba(81, 69, 205, var(--bg-opacity));\n  }\n  .group:focus .md\\:group-focus\\:bg-indigo-800 {\n    --bg-opacity: 1;\n    background-color: #42389d;\n    background-color: rgba(66, 56, 157, var(--bg-opacity));\n  }\n  .group:focus .md\\:group-focus\\:bg-indigo-900 {\n    --bg-opacity: 1;\n    background-color: #362f78;\n    background-color: rgba(54, 47, 120, var(--bg-opacity));\n  }\n  .group:focus .md\\:group-focus\\:bg-purple-50 {\n    --bg-opacity: 1;\n    background-color: #f6f5ff;\n    background-color: rgba(246, 245, 255, var(--bg-opacity));\n  }\n  .group:focus .md\\:group-focus\\:bg-purple-100 {\n    --bg-opacity: 1;\n    background-color: #edebfe;\n    background-color: rgba(237, 235, 254, var(--bg-opacity));\n  }\n  .group:focus .md\\:group-focus\\:bg-purple-200 {\n    --bg-opacity: 1;\n    background-color: #dcd7fe;\n    background-color: rgba(220, 215, 254, var(--bg-opacity));\n  }\n  .group:focus .md\\:group-focus\\:bg-purple-300 {\n    --bg-opacity: 1;\n    background-color: #cabffd;\n    background-color: rgba(202, 191, 253, var(--bg-opacity));\n  }\n  .group:focus .md\\:group-focus\\:bg-purple-400 {\n    --bg-opacity: 1;\n    background-color: #ac94fa;\n    background-color: rgba(172, 148, 250, var(--bg-opacity));\n  }\n  .group:focus .md\\:group-focus\\:bg-purple-500 {\n    --bg-opacity: 1;\n    background-color: #9061f9;\n    background-color: rgba(144, 97, 249, var(--bg-opacity));\n  }\n  .group:focus .md\\:group-focus\\:bg-purple-600 {\n    --bg-opacity: 1;\n    background-color: #7e3af2;\n    background-color: rgba(126, 58, 242, var(--bg-opacity));\n  }\n  .group:focus .md\\:group-focus\\:bg-purple-700 {\n    --bg-opacity: 1;\n    background-color: #6c2bd9;\n    background-color: rgba(108, 43, 217, var(--bg-opacity));\n  }\n  .group:focus .md\\:group-focus\\:bg-purple-800 {\n    --bg-opacity: 1;\n    background-color: #5521b5;\n    background-color: rgba(85, 33, 181, var(--bg-opacity));\n  }\n  .group:focus .md\\:group-focus\\:bg-purple-900 {\n    --bg-opacity: 1;\n    background-color: #4a1d96;\n    background-color: rgba(74, 29, 150, var(--bg-opacity));\n  }\n  .group:focus .md\\:group-focus\\:bg-pink-50 {\n    --bg-opacity: 1;\n    background-color: #fdf2f8;\n    background-color: rgba(253, 242, 248, var(--bg-opacity));\n  }\n  .group:focus .md\\:group-focus\\:bg-pink-100 {\n    --bg-opacity: 1;\n    background-color: #fce8f3;\n    background-color: rgba(252, 232, 243, var(--bg-opacity));\n  }\n  .group:focus .md\\:group-focus\\:bg-pink-200 {\n    --bg-opacity: 1;\n    background-color: #fad1e8;\n    background-color: rgba(250, 209, 232, var(--bg-opacity));\n  }\n  .group:focus .md\\:group-focus\\:bg-pink-300 {\n    --bg-opacity: 1;\n    background-color: #f8b4d9;\n    background-color: rgba(248, 180, 217, var(--bg-opacity));\n  }\n  .group:focus .md\\:group-focus\\:bg-pink-400 {\n    --bg-opacity: 1;\n    background-color: #f17eb8;\n    background-color: rgba(241, 126, 184, var(--bg-opacity));\n  }\n  .group:focus .md\\:group-focus\\:bg-pink-500 {\n    --bg-opacity: 1;\n    background-color: #e74694;\n    background-color: rgba(231, 70, 148, var(--bg-opacity));\n  }\n  .group:focus .md\\:group-focus\\:bg-pink-600 {\n    --bg-opacity: 1;\n    background-color: #d61f69;\n    background-color: rgba(214, 31, 105, var(--bg-opacity));\n  }\n  .group:focus .md\\:group-focus\\:bg-pink-700 {\n    --bg-opacity: 1;\n    background-color: #bf125d;\n    background-color: rgba(191, 18, 93, var(--bg-opacity));\n  }\n  .group:focus .md\\:group-focus\\:bg-pink-800 {\n    --bg-opacity: 1;\n    background-color: #99154b;\n    background-color: rgba(153, 21, 75, var(--bg-opacity));\n  }\n  .group:focus .md\\:group-focus\\:bg-pink-900 {\n    --bg-opacity: 1;\n    background-color: #751a3d;\n    background-color: rgba(117, 26, 61, var(--bg-opacity));\n  }\n  .group:focus .md\\:group-focus\\:bg-cool-gray-50 {\n    --bg-opacity: 1;\n    background-color: #f8fafc;\n    background-color: rgba(248, 250, 252, var(--bg-opacity));\n  }\n  .group:focus .md\\:group-focus\\:bg-cool-gray-100 {\n    --bg-opacity: 1;\n    background-color: #f1f5f9;\n    background-color: rgba(241, 245, 249, var(--bg-opacity));\n  }\n  .group:focus .md\\:group-focus\\:bg-cool-gray-200 {\n    --bg-opacity: 1;\n    background-color: #e2e8f0;\n    background-color: rgba(226, 232, 240, var(--bg-opacity));\n  }\n  .group:focus .md\\:group-focus\\:bg-cool-gray-300 {\n    --bg-opacity: 1;\n    background-color: #cfd8e3;\n    background-color: rgba(207, 216, 227, var(--bg-opacity));\n  }\n  .group:focus .md\\:group-focus\\:bg-cool-gray-400 {\n    --bg-opacity: 1;\n    background-color: #97a6ba;\n    background-color: rgba(151, 166, 186, var(--bg-opacity));\n  }\n  .group:focus .md\\:group-focus\\:bg-cool-gray-500 {\n    --bg-opacity: 1;\n    background-color: #64748b;\n    background-color: rgba(100, 116, 139, var(--bg-opacity));\n  }\n  .group:focus .md\\:group-focus\\:bg-cool-gray-600 {\n    --bg-opacity: 1;\n    background-color: #475569;\n    background-color: rgba(71, 85, 105, var(--bg-opacity));\n  }\n  .group:focus .md\\:group-focus\\:bg-cool-gray-700 {\n    --bg-opacity: 1;\n    background-color: #364152;\n    background-color: rgba(54, 65, 82, var(--bg-opacity));\n  }\n  .group:focus .md\\:group-focus\\:bg-cool-gray-800 {\n    --bg-opacity: 1;\n    background-color: #27303f;\n    background-color: rgba(39, 48, 63, var(--bg-opacity));\n  }\n  .group:focus .md\\:group-focus\\:bg-cool-gray-900 {\n    --bg-opacity: 1;\n    background-color: #1a202e;\n    background-color: rgba(26, 32, 46, var(--bg-opacity));\n  }\n  .md\\:hover\\:bg-current:hover {\n    background-color: currentColor;\n  }\n  .md\\:hover\\:bg-transparent:hover {\n    background-color: transparent;\n  }\n  .md\\:hover\\:bg-white:hover {\n    --bg-opacity: 1;\n    background-color: #ffffff;\n    background-color: rgba(255, 255, 255, var(--bg-opacity));\n  }\n  .md\\:hover\\:bg-black:hover {\n    --bg-opacity: 1;\n    background-color: #000000;\n    background-color: rgba(0, 0, 0, var(--bg-opacity));\n  }\n  .md\\:hover\\:bg-gray-50:hover {\n    --bg-opacity: 1;\n    background-color: #f9fafb;\n    background-color: rgba(249, 250, 251, var(--bg-opacity));\n  }\n  .md\\:hover\\:bg-gray-100:hover {\n    --bg-opacity: 1;\n    background-color: #f4f5f7;\n    background-color: rgba(244, 245, 247, var(--bg-opacity));\n  }\n  .md\\:hover\\:bg-gray-200:hover {\n    --bg-opacity: 1;\n    background-color: #e5e7eb;\n    background-color: rgba(229, 231, 235, var(--bg-opacity));\n  }\n  .md\\:hover\\:bg-gray-300:hover {\n    --bg-opacity: 1;\n    background-color: #d2d6dc;\n    background-color: rgba(210, 214, 220, var(--bg-opacity));\n  }\n  .md\\:hover\\:bg-gray-400:hover {\n    --bg-opacity: 1;\n    background-color: #9fa6b2;\n    background-color: rgba(159, 166, 178, var(--bg-opacity));\n  }\n  .md\\:hover\\:bg-gray-500:hover {\n    --bg-opacity: 1;\n    background-color: #6b7280;\n    background-color: rgba(107, 114, 128, var(--bg-opacity));\n  }\n  .md\\:hover\\:bg-gray-600:hover {\n    --bg-opacity: 1;\n    background-color: #4b5563;\n    background-color: rgba(75, 85, 99, var(--bg-opacity));\n  }\n  .md\\:hover\\:bg-gray-700:hover {\n    --bg-opacity: 1;\n    background-color: #374151;\n    background-color: rgba(55, 65, 81, var(--bg-opacity));\n  }\n  .md\\:hover\\:bg-gray-800:hover {\n    --bg-opacity: 1;\n    background-color: #252f3f;\n    background-color: rgba(37, 47, 63, var(--bg-opacity));\n  }\n  .md\\:hover\\:bg-gray-900:hover {\n    --bg-opacity: 1;\n    background-color: #161e2e;\n    background-color: rgba(22, 30, 46, var(--bg-opacity));\n  }\n  .md\\:hover\\:bg-red-50:hover {\n    --bg-opacity: 1;\n    background-color: #fdf2f2;\n    background-color: rgba(253, 242, 242, var(--bg-opacity));\n  }\n  .md\\:hover\\:bg-red-100:hover {\n    --bg-opacity: 1;\n    background-color: #fde8e8;\n    background-color: rgba(253, 232, 232, var(--bg-opacity));\n  }\n  .md\\:hover\\:bg-red-200:hover {\n    --bg-opacity: 1;\n    background-color: #fbd5d5;\n    background-color: rgba(251, 213, 213, var(--bg-opacity));\n  }\n  .md\\:hover\\:bg-red-300:hover {\n    --bg-opacity: 1;\n    background-color: #f8b4b4;\n    background-color: rgba(248, 180, 180, var(--bg-opacity));\n  }\n  .md\\:hover\\:bg-red-400:hover {\n    --bg-opacity: 1;\n    background-color: #f98080;\n    background-color: rgba(249, 128, 128, var(--bg-opacity));\n  }\n  .md\\:hover\\:bg-red-500:hover {\n    --bg-opacity: 1;\n    background-color: #f05252;\n    background-color: rgba(240, 82, 82, var(--bg-opacity));\n  }\n  .md\\:hover\\:bg-red-600:hover {\n    --bg-opacity: 1;\n    background-color: #e02424;\n    background-color: rgba(224, 36, 36, var(--bg-opacity));\n  }\n  .md\\:hover\\:bg-red-700:hover {\n    --bg-opacity: 1;\n    background-color: #c81e1e;\n    background-color: rgba(200, 30, 30, var(--bg-opacity));\n  }\n  .md\\:hover\\:bg-red-800:hover {\n    --bg-opacity: 1;\n    background-color: #9b1c1c;\n    background-color: rgba(155, 28, 28, var(--bg-opacity));\n  }\n  .md\\:hover\\:bg-red-900:hover {\n    --bg-opacity: 1;\n    background-color: #771d1d;\n    background-color: rgba(119, 29, 29, var(--bg-opacity));\n  }\n  .md\\:hover\\:bg-orange-50:hover {\n    --bg-opacity: 1;\n    background-color: #fff8f1;\n    background-color: rgba(255, 248, 241, var(--bg-opacity));\n  }\n  .md\\:hover\\:bg-orange-100:hover {\n    --bg-opacity: 1;\n    background-color: #feecdc;\n    background-color: rgba(254, 236, 220, var(--bg-opacity));\n  }\n  .md\\:hover\\:bg-orange-200:hover {\n    --bg-opacity: 1;\n    background-color: #fcd9bd;\n    background-color: rgba(252, 217, 189, var(--bg-opacity));\n  }\n  .md\\:hover\\:bg-orange-300:hover {\n    --bg-opacity: 1;\n    background-color: #fdba8c;\n    background-color: rgba(253, 186, 140, var(--bg-opacity));\n  }\n  .md\\:hover\\:bg-orange-400:hover {\n    --bg-opacity: 1;\n    background-color: #ff8a4c;\n    background-color: rgba(255, 138, 76, var(--bg-opacity));\n  }\n  .md\\:hover\\:bg-orange-500:hover {\n    --bg-opacity: 1;\n    background-color: #ff5a1f;\n    background-color: rgba(255, 90, 31, var(--bg-opacity));\n  }\n  .md\\:hover\\:bg-orange-600:hover {\n    --bg-opacity: 1;\n    background-color: #d03801;\n    background-color: rgba(208, 56, 1, var(--bg-opacity));\n  }\n  .md\\:hover\\:bg-orange-700:hover {\n    --bg-opacity: 1;\n    background-color: #b43403;\n    background-color: rgba(180, 52, 3, var(--bg-opacity));\n  }\n  .md\\:hover\\:bg-orange-800:hover {\n    --bg-opacity: 1;\n    background-color: #8a2c0d;\n    background-color: rgba(138, 44, 13, var(--bg-opacity));\n  }\n  .md\\:hover\\:bg-orange-900:hover {\n    --bg-opacity: 1;\n    background-color: #73230d;\n    background-color: rgba(115, 35, 13, var(--bg-opacity));\n  }\n  .md\\:hover\\:bg-yellow-50:hover {\n    --bg-opacity: 1;\n    background-color: #fdfdea;\n    background-color: rgba(253, 253, 234, var(--bg-opacity));\n  }\n  .md\\:hover\\:bg-yellow-100:hover {\n    --bg-opacity: 1;\n    background-color: #fdf6b2;\n    background-color: rgba(253, 246, 178, var(--bg-opacity));\n  }\n  .md\\:hover\\:bg-yellow-200:hover {\n    --bg-opacity: 1;\n    background-color: #fce96a;\n    background-color: rgba(252, 233, 106, var(--bg-opacity));\n  }\n  .md\\:hover\\:bg-yellow-300:hover {\n    --bg-opacity: 1;\n    background-color: #faca15;\n    background-color: rgba(250, 202, 21, var(--bg-opacity));\n  }\n  .md\\:hover\\:bg-yellow-400:hover {\n    --bg-opacity: 1;\n    background-color: #e3a008;\n    background-color: rgba(227, 160, 8, var(--bg-opacity));\n  }\n  .md\\:hover\\:bg-yellow-500:hover {\n    --bg-opacity: 1;\n    background-color: #c27803;\n    background-color: rgba(194, 120, 3, var(--bg-opacity));\n  }\n  .md\\:hover\\:bg-yellow-600:hover {\n    --bg-opacity: 1;\n    background-color: #9f580a;\n    background-color: rgba(159, 88, 10, var(--bg-opacity));\n  }\n  .md\\:hover\\:bg-yellow-700:hover {\n    --bg-opacity: 1;\n    background-color: #8e4b10;\n    background-color: rgba(142, 75, 16, var(--bg-opacity));\n  }\n  .md\\:hover\\:bg-yellow-800:hover {\n    --bg-opacity: 1;\n    background-color: #723b13;\n    background-color: rgba(114, 59, 19, var(--bg-opacity));\n  }\n  .md\\:hover\\:bg-yellow-900:hover {\n    --bg-opacity: 1;\n    background-color: #633112;\n    background-color: rgba(99, 49, 18, var(--bg-opacity));\n  }\n  .md\\:hover\\:bg-green-50:hover {\n    --bg-opacity: 1;\n    background-color: #f3faf7;\n    background-color: rgba(243, 250, 247, var(--bg-opacity));\n  }\n  .md\\:hover\\:bg-green-100:hover {\n    --bg-opacity: 1;\n    background-color: #def7ec;\n    background-color: rgba(222, 247, 236, var(--bg-opacity));\n  }\n  .md\\:hover\\:bg-green-200:hover {\n    --bg-opacity: 1;\n    background-color: #bcf0da;\n    background-color: rgba(188, 240, 218, var(--bg-opacity));\n  }\n  .md\\:hover\\:bg-green-300:hover {\n    --bg-opacity: 1;\n    background-color: #84e1bc;\n    background-color: rgba(132, 225, 188, var(--bg-opacity));\n  }\n  .md\\:hover\\:bg-green-400:hover {\n    --bg-opacity: 1;\n    background-color: #31c48d;\n    background-color: rgba(49, 196, 141, var(--bg-opacity));\n  }\n  .md\\:hover\\:bg-green-500:hover {\n    --bg-opacity: 1;\n    background-color: #0e9f6e;\n    background-color: rgba(14, 159, 110, var(--bg-opacity));\n  }\n  .md\\:hover\\:bg-green-600:hover {\n    --bg-opacity: 1;\n    background-color: #057a55;\n    background-color: rgba(5, 122, 85, var(--bg-opacity));\n  }\n  .md\\:hover\\:bg-green-700:hover {\n    --bg-opacity: 1;\n    background-color: #046c4e;\n    background-color: rgba(4, 108, 78, var(--bg-opacity));\n  }\n  .md\\:hover\\:bg-green-800:hover {\n    --bg-opacity: 1;\n    background-color: #03543f;\n    background-color: rgba(3, 84, 63, var(--bg-opacity));\n  }\n  .md\\:hover\\:bg-green-900:hover {\n    --bg-opacity: 1;\n    background-color: #014737;\n    background-color: rgba(1, 71, 55, var(--bg-opacity));\n  }\n  .md\\:hover\\:bg-teal-50:hover {\n    --bg-opacity: 1;\n    background-color: #edfafa;\n    background-color: rgba(237, 250, 250, var(--bg-opacity));\n  }\n  .md\\:hover\\:bg-teal-100:hover {\n    --bg-opacity: 1;\n    background-color: #d5f5f6;\n    background-color: rgba(213, 245, 246, var(--bg-opacity));\n  }\n  .md\\:hover\\:bg-teal-200:hover {\n    --bg-opacity: 1;\n    background-color: #afecef;\n    background-color: rgba(175, 236, 239, var(--bg-opacity));\n  }\n  .md\\:hover\\:bg-teal-300:hover {\n    --bg-opacity: 1;\n    background-color: #7edce2;\n    background-color: rgba(126, 220, 226, var(--bg-opacity));\n  }\n  .md\\:hover\\:bg-teal-400:hover {\n    --bg-opacity: 1;\n    background-color: #16bdca;\n    background-color: rgba(22, 189, 202, var(--bg-opacity));\n  }\n  .md\\:hover\\:bg-teal-500:hover {\n    --bg-opacity: 1;\n    background-color: #0694a2;\n    background-color: rgba(6, 148, 162, var(--bg-opacity));\n  }\n  .md\\:hover\\:bg-teal-600:hover {\n    --bg-opacity: 1;\n    background-color: #047481;\n    background-color: rgba(4, 116, 129, var(--bg-opacity));\n  }\n  .md\\:hover\\:bg-teal-700:hover {\n    --bg-opacity: 1;\n    background-color: #036672;\n    background-color: rgba(3, 102, 114, var(--bg-opacity));\n  }\n  .md\\:hover\\:bg-teal-800:hover {\n    --bg-opacity: 1;\n    background-color: #05505c;\n    background-color: rgba(5, 80, 92, var(--bg-opacity));\n  }\n  .md\\:hover\\:bg-teal-900:hover {\n    --bg-opacity: 1;\n    background-color: #014451;\n    background-color: rgba(1, 68, 81, var(--bg-opacity));\n  }\n  .md\\:hover\\:bg-blue-50:hover {\n    --bg-opacity: 1;\n    background-color: #ebf5ff;\n    background-color: rgba(235, 245, 255, var(--bg-opacity));\n  }\n  .md\\:hover\\:bg-blue-100:hover {\n    --bg-opacity: 1;\n    background-color: #e1effe;\n    background-color: rgba(225, 239, 254, var(--bg-opacity));\n  }\n  .md\\:hover\\:bg-blue-200:hover {\n    --bg-opacity: 1;\n    background-color: #c3ddfd;\n    background-color: rgba(195, 221, 253, var(--bg-opacity));\n  }\n  .md\\:hover\\:bg-blue-300:hover {\n    --bg-opacity: 1;\n    background-color: #a4cafe;\n    background-color: rgba(164, 202, 254, var(--bg-opacity));\n  }\n  .md\\:hover\\:bg-blue-400:hover {\n    --bg-opacity: 1;\n    background-color: #76a9fa;\n    background-color: rgba(118, 169, 250, var(--bg-opacity));\n  }\n  .md\\:hover\\:bg-blue-500:hover {\n    --bg-opacity: 1;\n    background-color: #3f83f8;\n    background-color: rgba(63, 131, 248, var(--bg-opacity));\n  }\n  .md\\:hover\\:bg-blue-600:hover {\n    --bg-opacity: 1;\n    background-color: #1c64f2;\n    background-color: rgba(28, 100, 242, var(--bg-opacity));\n  }\n  .md\\:hover\\:bg-blue-700:hover {\n    --bg-opacity: 1;\n    background-color: #1a56db;\n    background-color: rgba(26, 86, 219, var(--bg-opacity));\n  }\n  .md\\:hover\\:bg-blue-800:hover {\n    --bg-opacity: 1;\n    background-color: #1e429f;\n    background-color: rgba(30, 66, 159, var(--bg-opacity));\n  }\n  .md\\:hover\\:bg-blue-900:hover {\n    --bg-opacity: 1;\n    background-color: #233876;\n    background-color: rgba(35, 56, 118, var(--bg-opacity));\n  }\n  .md\\:hover\\:bg-indigo-50:hover {\n    --bg-opacity: 1;\n    background-color: #f0f5ff;\n    background-color: rgba(240, 245, 255, var(--bg-opacity));\n  }\n  .md\\:hover\\:bg-indigo-100:hover {\n    --bg-opacity: 1;\n    background-color: #e5edff;\n    background-color: rgba(229, 237, 255, var(--bg-opacity));\n  }\n  .md\\:hover\\:bg-indigo-200:hover {\n    --bg-opacity: 1;\n    background-color: #cddbfe;\n    background-color: rgba(205, 219, 254, var(--bg-opacity));\n  }\n  .md\\:hover\\:bg-indigo-300:hover {\n    --bg-opacity: 1;\n    background-color: #b4c6fc;\n    background-color: rgba(180, 198, 252, var(--bg-opacity));\n  }\n  .md\\:hover\\:bg-indigo-400:hover {\n    --bg-opacity: 1;\n    background-color: #8da2fb;\n    background-color: rgba(141, 162, 251, var(--bg-opacity));\n  }\n  .md\\:hover\\:bg-indigo-500:hover {\n    --bg-opacity: 1;\n    background-color: #6875f5;\n    background-color: rgba(104, 117, 245, var(--bg-opacity));\n  }\n  .md\\:hover\\:bg-indigo-600:hover {\n    --bg-opacity: 1;\n    background-color: #5850ec;\n    background-color: rgba(88, 80, 236, var(--bg-opacity));\n  }\n  .md\\:hover\\:bg-indigo-700:hover {\n    --bg-opacity: 1;\n    background-color: #5145cd;\n    background-color: rgba(81, 69, 205, var(--bg-opacity));\n  }\n  .md\\:hover\\:bg-indigo-800:hover {\n    --bg-opacity: 1;\n    background-color: #42389d;\n    background-color: rgba(66, 56, 157, var(--bg-opacity));\n  }\n  .md\\:hover\\:bg-indigo-900:hover {\n    --bg-opacity: 1;\n    background-color: #362f78;\n    background-color: rgba(54, 47, 120, var(--bg-opacity));\n  }\n  .md\\:hover\\:bg-purple-50:hover {\n    --bg-opacity: 1;\n    background-color: #f6f5ff;\n    background-color: rgba(246, 245, 255, var(--bg-opacity));\n  }\n  .md\\:hover\\:bg-purple-100:hover {\n    --bg-opacity: 1;\n    background-color: #edebfe;\n    background-color: rgba(237, 235, 254, var(--bg-opacity));\n  }\n  .md\\:hover\\:bg-purple-200:hover {\n    --bg-opacity: 1;\n    background-color: #dcd7fe;\n    background-color: rgba(220, 215, 254, var(--bg-opacity));\n  }\n  .md\\:hover\\:bg-purple-300:hover {\n    --bg-opacity: 1;\n    background-color: #cabffd;\n    background-color: rgba(202, 191, 253, var(--bg-opacity));\n  }\n  .md\\:hover\\:bg-purple-400:hover {\n    --bg-opacity: 1;\n    background-color: #ac94fa;\n    background-color: rgba(172, 148, 250, var(--bg-opacity));\n  }\n  .md\\:hover\\:bg-purple-500:hover {\n    --bg-opacity: 1;\n    background-color: #9061f9;\n    background-color: rgba(144, 97, 249, var(--bg-opacity));\n  }\n  .md\\:hover\\:bg-purple-600:hover {\n    --bg-opacity: 1;\n    background-color: #7e3af2;\n    background-color: rgba(126, 58, 242, var(--bg-opacity));\n  }\n  .md\\:hover\\:bg-purple-700:hover {\n    --bg-opacity: 1;\n    background-color: #6c2bd9;\n    background-color: rgba(108, 43, 217, var(--bg-opacity));\n  }\n  .md\\:hover\\:bg-purple-800:hover {\n    --bg-opacity: 1;\n    background-color: #5521b5;\n    background-color: rgba(85, 33, 181, var(--bg-opacity));\n  }\n  .md\\:hover\\:bg-purple-900:hover {\n    --bg-opacity: 1;\n    background-color: #4a1d96;\n    background-color: rgba(74, 29, 150, var(--bg-opacity));\n  }\n  .md\\:hover\\:bg-pink-50:hover {\n    --bg-opacity: 1;\n    background-color: #fdf2f8;\n    background-color: rgba(253, 242, 248, var(--bg-opacity));\n  }\n  .md\\:hover\\:bg-pink-100:hover {\n    --bg-opacity: 1;\n    background-color: #fce8f3;\n    background-color: rgba(252, 232, 243, var(--bg-opacity));\n  }\n  .md\\:hover\\:bg-pink-200:hover {\n    --bg-opacity: 1;\n    background-color: #fad1e8;\n    background-color: rgba(250, 209, 232, var(--bg-opacity));\n  }\n  .md\\:hover\\:bg-pink-300:hover {\n    --bg-opacity: 1;\n    background-color: #f8b4d9;\n    background-color: rgba(248, 180, 217, var(--bg-opacity));\n  }\n  .md\\:hover\\:bg-pink-400:hover {\n    --bg-opacity: 1;\n    background-color: #f17eb8;\n    background-color: rgba(241, 126, 184, var(--bg-opacity));\n  }\n  .md\\:hover\\:bg-pink-500:hover {\n    --bg-opacity: 1;\n    background-color: #e74694;\n    background-color: rgba(231, 70, 148, var(--bg-opacity));\n  }\n  .md\\:hover\\:bg-pink-600:hover {\n    --bg-opacity: 1;\n    background-color: #d61f69;\n    background-color: rgba(214, 31, 105, var(--bg-opacity));\n  }\n  .md\\:hover\\:bg-pink-700:hover {\n    --bg-opacity: 1;\n    background-color: #bf125d;\n    background-color: rgba(191, 18, 93, var(--bg-opacity));\n  }\n  .md\\:hover\\:bg-pink-800:hover {\n    --bg-opacity: 1;\n    background-color: #99154b;\n    background-color: rgba(153, 21, 75, var(--bg-opacity));\n  }\n  .md\\:hover\\:bg-pink-900:hover {\n    --bg-opacity: 1;\n    background-color: #751a3d;\n    background-color: rgba(117, 26, 61, var(--bg-opacity));\n  }\n  .md\\:hover\\:bg-cool-gray-50:hover {\n    --bg-opacity: 1;\n    background-color: #f8fafc;\n    background-color: rgba(248, 250, 252, var(--bg-opacity));\n  }\n  .md\\:hover\\:bg-cool-gray-100:hover {\n    --bg-opacity: 1;\n    background-color: #f1f5f9;\n    background-color: rgba(241, 245, 249, var(--bg-opacity));\n  }\n  .md\\:hover\\:bg-cool-gray-200:hover {\n    --bg-opacity: 1;\n    background-color: #e2e8f0;\n    background-color: rgba(226, 232, 240, var(--bg-opacity));\n  }\n  .md\\:hover\\:bg-cool-gray-300:hover {\n    --bg-opacity: 1;\n    background-color: #cfd8e3;\n    background-color: rgba(207, 216, 227, var(--bg-opacity));\n  }\n  .md\\:hover\\:bg-cool-gray-400:hover {\n    --bg-opacity: 1;\n    background-color: #97a6ba;\n    background-color: rgba(151, 166, 186, var(--bg-opacity));\n  }\n  .md\\:hover\\:bg-cool-gray-500:hover {\n    --bg-opacity: 1;\n    background-color: #64748b;\n    background-color: rgba(100, 116, 139, var(--bg-opacity));\n  }\n  .md\\:hover\\:bg-cool-gray-600:hover {\n    --bg-opacity: 1;\n    background-color: #475569;\n    background-color: rgba(71, 85, 105, var(--bg-opacity));\n  }\n  .md\\:hover\\:bg-cool-gray-700:hover {\n    --bg-opacity: 1;\n    background-color: #364152;\n    background-color: rgba(54, 65, 82, var(--bg-opacity));\n  }\n  .md\\:hover\\:bg-cool-gray-800:hover {\n    --bg-opacity: 1;\n    background-color: #27303f;\n    background-color: rgba(39, 48, 63, var(--bg-opacity));\n  }\n  .md\\:hover\\:bg-cool-gray-900:hover {\n    --bg-opacity: 1;\n    background-color: #1a202e;\n    background-color: rgba(26, 32, 46, var(--bg-opacity));\n  }\n  .md\\:focus\\:bg-current:focus {\n    background-color: currentColor;\n  }\n  .md\\:focus\\:bg-transparent:focus {\n    background-color: transparent;\n  }\n  .md\\:focus\\:bg-white:focus {\n    --bg-opacity: 1;\n    background-color: #ffffff;\n    background-color: rgba(255, 255, 255, var(--bg-opacity));\n  }\n  .md\\:focus\\:bg-black:focus {\n    --bg-opacity: 1;\n    background-color: #000000;\n    background-color: rgba(0, 0, 0, var(--bg-opacity));\n  }\n  .md\\:focus\\:bg-gray-50:focus {\n    --bg-opacity: 1;\n    background-color: #f9fafb;\n    background-color: rgba(249, 250, 251, var(--bg-opacity));\n  }\n  .md\\:focus\\:bg-gray-100:focus {\n    --bg-opacity: 1;\n    background-color: #f4f5f7;\n    background-color: rgba(244, 245, 247, var(--bg-opacity));\n  }\n  .md\\:focus\\:bg-gray-200:focus {\n    --bg-opacity: 1;\n    background-color: #e5e7eb;\n    background-color: rgba(229, 231, 235, var(--bg-opacity));\n  }\n  .md\\:focus\\:bg-gray-300:focus {\n    --bg-opacity: 1;\n    background-color: #d2d6dc;\n    background-color: rgba(210, 214, 220, var(--bg-opacity));\n  }\n  .md\\:focus\\:bg-gray-400:focus {\n    --bg-opacity: 1;\n    background-color: #9fa6b2;\n    background-color: rgba(159, 166, 178, var(--bg-opacity));\n  }\n  .md\\:focus\\:bg-gray-500:focus {\n    --bg-opacity: 1;\n    background-color: #6b7280;\n    background-color: rgba(107, 114, 128, var(--bg-opacity));\n  }\n  .md\\:focus\\:bg-gray-600:focus {\n    --bg-opacity: 1;\n    background-color: #4b5563;\n    background-color: rgba(75, 85, 99, var(--bg-opacity));\n  }\n  .md\\:focus\\:bg-gray-700:focus {\n    --bg-opacity: 1;\n    background-color: #374151;\n    background-color: rgba(55, 65, 81, var(--bg-opacity));\n  }\n  .md\\:focus\\:bg-gray-800:focus {\n    --bg-opacity: 1;\n    background-color: #252f3f;\n    background-color: rgba(37, 47, 63, var(--bg-opacity));\n  }\n  .md\\:focus\\:bg-gray-900:focus {\n    --bg-opacity: 1;\n    background-color: #161e2e;\n    background-color: rgba(22, 30, 46, var(--bg-opacity));\n  }\n  .md\\:focus\\:bg-red-50:focus {\n    --bg-opacity: 1;\n    background-color: #fdf2f2;\n    background-color: rgba(253, 242, 242, var(--bg-opacity));\n  }\n  .md\\:focus\\:bg-red-100:focus {\n    --bg-opacity: 1;\n    background-color: #fde8e8;\n    background-color: rgba(253, 232, 232, var(--bg-opacity));\n  }\n  .md\\:focus\\:bg-red-200:focus {\n    --bg-opacity: 1;\n    background-color: #fbd5d5;\n    background-color: rgba(251, 213, 213, var(--bg-opacity));\n  }\n  .md\\:focus\\:bg-red-300:focus {\n    --bg-opacity: 1;\n    background-color: #f8b4b4;\n    background-color: rgba(248, 180, 180, var(--bg-opacity));\n  }\n  .md\\:focus\\:bg-red-400:focus {\n    --bg-opacity: 1;\n    background-color: #f98080;\n    background-color: rgba(249, 128, 128, var(--bg-opacity));\n  }\n  .md\\:focus\\:bg-red-500:focus {\n    --bg-opacity: 1;\n    background-color: #f05252;\n    background-color: rgba(240, 82, 82, var(--bg-opacity));\n  }\n  .md\\:focus\\:bg-red-600:focus {\n    --bg-opacity: 1;\n    background-color: #e02424;\n    background-color: rgba(224, 36, 36, var(--bg-opacity));\n  }\n  .md\\:focus\\:bg-red-700:focus {\n    --bg-opacity: 1;\n    background-color: #c81e1e;\n    background-color: rgba(200, 30, 30, var(--bg-opacity));\n  }\n  .md\\:focus\\:bg-red-800:focus {\n    --bg-opacity: 1;\n    background-color: #9b1c1c;\n    background-color: rgba(155, 28, 28, var(--bg-opacity));\n  }\n  .md\\:focus\\:bg-red-900:focus {\n    --bg-opacity: 1;\n    background-color: #771d1d;\n    background-color: rgba(119, 29, 29, var(--bg-opacity));\n  }\n  .md\\:focus\\:bg-orange-50:focus {\n    --bg-opacity: 1;\n    background-color: #fff8f1;\n    background-color: rgba(255, 248, 241, var(--bg-opacity));\n  }\n  .md\\:focus\\:bg-orange-100:focus {\n    --bg-opacity: 1;\n    background-color: #feecdc;\n    background-color: rgba(254, 236, 220, var(--bg-opacity));\n  }\n  .md\\:focus\\:bg-orange-200:focus {\n    --bg-opacity: 1;\n    background-color: #fcd9bd;\n    background-color: rgba(252, 217, 189, var(--bg-opacity));\n  }\n  .md\\:focus\\:bg-orange-300:focus {\n    --bg-opacity: 1;\n    background-color: #fdba8c;\n    background-color: rgba(253, 186, 140, var(--bg-opacity));\n  }\n  .md\\:focus\\:bg-orange-400:focus {\n    --bg-opacity: 1;\n    background-color: #ff8a4c;\n    background-color: rgba(255, 138, 76, var(--bg-opacity));\n  }\n  .md\\:focus\\:bg-orange-500:focus {\n    --bg-opacity: 1;\n    background-color: #ff5a1f;\n    background-color: rgba(255, 90, 31, var(--bg-opacity));\n  }\n  .md\\:focus\\:bg-orange-600:focus {\n    --bg-opacity: 1;\n    background-color: #d03801;\n    background-color: rgba(208, 56, 1, var(--bg-opacity));\n  }\n  .md\\:focus\\:bg-orange-700:focus {\n    --bg-opacity: 1;\n    background-color: #b43403;\n    background-color: rgba(180, 52, 3, var(--bg-opacity));\n  }\n  .md\\:focus\\:bg-orange-800:focus {\n    --bg-opacity: 1;\n    background-color: #8a2c0d;\n    background-color: rgba(138, 44, 13, var(--bg-opacity));\n  }\n  .md\\:focus\\:bg-orange-900:focus {\n    --bg-opacity: 1;\n    background-color: #73230d;\n    background-color: rgba(115, 35, 13, var(--bg-opacity));\n  }\n  .md\\:focus\\:bg-yellow-50:focus {\n    --bg-opacity: 1;\n    background-color: #fdfdea;\n    background-color: rgba(253, 253, 234, var(--bg-opacity));\n  }\n  .md\\:focus\\:bg-yellow-100:focus {\n    --bg-opacity: 1;\n    background-color: #fdf6b2;\n    background-color: rgba(253, 246, 178, var(--bg-opacity));\n  }\n  .md\\:focus\\:bg-yellow-200:focus {\n    --bg-opacity: 1;\n    background-color: #fce96a;\n    background-color: rgba(252, 233, 106, var(--bg-opacity));\n  }\n  .md\\:focus\\:bg-yellow-300:focus {\n    --bg-opacity: 1;\n    background-color: #faca15;\n    background-color: rgba(250, 202, 21, var(--bg-opacity));\n  }\n  .md\\:focus\\:bg-yellow-400:focus {\n    --bg-opacity: 1;\n    background-color: #e3a008;\n    background-color: rgba(227, 160, 8, var(--bg-opacity));\n  }\n  .md\\:focus\\:bg-yellow-500:focus {\n    --bg-opacity: 1;\n    background-color: #c27803;\n    background-color: rgba(194, 120, 3, var(--bg-opacity));\n  }\n  .md\\:focus\\:bg-yellow-600:focus {\n    --bg-opacity: 1;\n    background-color: #9f580a;\n    background-color: rgba(159, 88, 10, var(--bg-opacity));\n  }\n  .md\\:focus\\:bg-yellow-700:focus {\n    --bg-opacity: 1;\n    background-color: #8e4b10;\n    background-color: rgba(142, 75, 16, var(--bg-opacity));\n  }\n  .md\\:focus\\:bg-yellow-800:focus {\n    --bg-opacity: 1;\n    background-color: #723b13;\n    background-color: rgba(114, 59, 19, var(--bg-opacity));\n  }\n  .md\\:focus\\:bg-yellow-900:focus {\n    --bg-opacity: 1;\n    background-color: #633112;\n    background-color: rgba(99, 49, 18, var(--bg-opacity));\n  }\n  .md\\:focus\\:bg-green-50:focus {\n    --bg-opacity: 1;\n    background-color: #f3faf7;\n    background-color: rgba(243, 250, 247, var(--bg-opacity));\n  }\n  .md\\:focus\\:bg-green-100:focus {\n    --bg-opacity: 1;\n    background-color: #def7ec;\n    background-color: rgba(222, 247, 236, var(--bg-opacity));\n  }\n  .md\\:focus\\:bg-green-200:focus {\n    --bg-opacity: 1;\n    background-color: #bcf0da;\n    background-color: rgba(188, 240, 218, var(--bg-opacity));\n  }\n  .md\\:focus\\:bg-green-300:focus {\n    --bg-opacity: 1;\n    background-color: #84e1bc;\n    background-color: rgba(132, 225, 188, var(--bg-opacity));\n  }\n  .md\\:focus\\:bg-green-400:focus {\n    --bg-opacity: 1;\n    background-color: #31c48d;\n    background-color: rgba(49, 196, 141, var(--bg-opacity));\n  }\n  .md\\:focus\\:bg-green-500:focus {\n    --bg-opacity: 1;\n    background-color: #0e9f6e;\n    background-color: rgba(14, 159, 110, var(--bg-opacity));\n  }\n  .md\\:focus\\:bg-green-600:focus {\n    --bg-opacity: 1;\n    background-color: #057a55;\n    background-color: rgba(5, 122, 85, var(--bg-opacity));\n  }\n  .md\\:focus\\:bg-green-700:focus {\n    --bg-opacity: 1;\n    background-color: #046c4e;\n    background-color: rgba(4, 108, 78, var(--bg-opacity));\n  }\n  .md\\:focus\\:bg-green-800:focus {\n    --bg-opacity: 1;\n    background-color: #03543f;\n    background-color: rgba(3, 84, 63, var(--bg-opacity));\n  }\n  .md\\:focus\\:bg-green-900:focus {\n    --bg-opacity: 1;\n    background-color: #014737;\n    background-color: rgba(1, 71, 55, var(--bg-opacity));\n  }\n  .md\\:focus\\:bg-teal-50:focus {\n    --bg-opacity: 1;\n    background-color: #edfafa;\n    background-color: rgba(237, 250, 250, var(--bg-opacity));\n  }\n  .md\\:focus\\:bg-teal-100:focus {\n    --bg-opacity: 1;\n    background-color: #d5f5f6;\n    background-color: rgba(213, 245, 246, var(--bg-opacity));\n  }\n  .md\\:focus\\:bg-teal-200:focus {\n    --bg-opacity: 1;\n    background-color: #afecef;\n    background-color: rgba(175, 236, 239, var(--bg-opacity));\n  }\n  .md\\:focus\\:bg-teal-300:focus {\n    --bg-opacity: 1;\n    background-color: #7edce2;\n    background-color: rgba(126, 220, 226, var(--bg-opacity));\n  }\n  .md\\:focus\\:bg-teal-400:focus {\n    --bg-opacity: 1;\n    background-color: #16bdca;\n    background-color: rgba(22, 189, 202, var(--bg-opacity));\n  }\n  .md\\:focus\\:bg-teal-500:focus {\n    --bg-opacity: 1;\n    background-color: #0694a2;\n    background-color: rgba(6, 148, 162, var(--bg-opacity));\n  }\n  .md\\:focus\\:bg-teal-600:focus {\n    --bg-opacity: 1;\n    background-color: #047481;\n    background-color: rgba(4, 116, 129, var(--bg-opacity));\n  }\n  .md\\:focus\\:bg-teal-700:focus {\n    --bg-opacity: 1;\n    background-color: #036672;\n    background-color: rgba(3, 102, 114, var(--bg-opacity));\n  }\n  .md\\:focus\\:bg-teal-800:focus {\n    --bg-opacity: 1;\n    background-color: #05505c;\n    background-color: rgba(5, 80, 92, var(--bg-opacity));\n  }\n  .md\\:focus\\:bg-teal-900:focus {\n    --bg-opacity: 1;\n    background-color: #014451;\n    background-color: rgba(1, 68, 81, var(--bg-opacity));\n  }\n  .md\\:focus\\:bg-blue-50:focus {\n    --bg-opacity: 1;\n    background-color: #ebf5ff;\n    background-color: rgba(235, 245, 255, var(--bg-opacity));\n  }\n  .md\\:focus\\:bg-blue-100:focus {\n    --bg-opacity: 1;\n    background-color: #e1effe;\n    background-color: rgba(225, 239, 254, var(--bg-opacity));\n  }\n  .md\\:focus\\:bg-blue-200:focus {\n    --bg-opacity: 1;\n    background-color: #c3ddfd;\n    background-color: rgba(195, 221, 253, var(--bg-opacity));\n  }\n  .md\\:focus\\:bg-blue-300:focus {\n    --bg-opacity: 1;\n    background-color: #a4cafe;\n    background-color: rgba(164, 202, 254, var(--bg-opacity));\n  }\n  .md\\:focus\\:bg-blue-400:focus {\n    --bg-opacity: 1;\n    background-color: #76a9fa;\n    background-color: rgba(118, 169, 250, var(--bg-opacity));\n  }\n  .md\\:focus\\:bg-blue-500:focus {\n    --bg-opacity: 1;\n    background-color: #3f83f8;\n    background-color: rgba(63, 131, 248, var(--bg-opacity));\n  }\n  .md\\:focus\\:bg-blue-600:focus {\n    --bg-opacity: 1;\n    background-color: #1c64f2;\n    background-color: rgba(28, 100, 242, var(--bg-opacity));\n  }\n  .md\\:focus\\:bg-blue-700:focus {\n    --bg-opacity: 1;\n    background-color: #1a56db;\n    background-color: rgba(26, 86, 219, var(--bg-opacity));\n  }\n  .md\\:focus\\:bg-blue-800:focus {\n    --bg-opacity: 1;\n    background-color: #1e429f;\n    background-color: rgba(30, 66, 159, var(--bg-opacity));\n  }\n  .md\\:focus\\:bg-blue-900:focus {\n    --bg-opacity: 1;\n    background-color: #233876;\n    background-color: rgba(35, 56, 118, var(--bg-opacity));\n  }\n  .md\\:focus\\:bg-indigo-50:focus {\n    --bg-opacity: 1;\n    background-color: #f0f5ff;\n    background-color: rgba(240, 245, 255, var(--bg-opacity));\n  }\n  .md\\:focus\\:bg-indigo-100:focus {\n    --bg-opacity: 1;\n    background-color: #e5edff;\n    background-color: rgba(229, 237, 255, var(--bg-opacity));\n  }\n  .md\\:focus\\:bg-indigo-200:focus {\n    --bg-opacity: 1;\n    background-color: #cddbfe;\n    background-color: rgba(205, 219, 254, var(--bg-opacity));\n  }\n  .md\\:focus\\:bg-indigo-300:focus {\n    --bg-opacity: 1;\n    background-color: #b4c6fc;\n    background-color: rgba(180, 198, 252, var(--bg-opacity));\n  }\n  .md\\:focus\\:bg-indigo-400:focus {\n    --bg-opacity: 1;\n    background-color: #8da2fb;\n    background-color: rgba(141, 162, 251, var(--bg-opacity));\n  }\n  .md\\:focus\\:bg-indigo-500:focus {\n    --bg-opacity: 1;\n    background-color: #6875f5;\n    background-color: rgba(104, 117, 245, var(--bg-opacity));\n  }\n  .md\\:focus\\:bg-indigo-600:focus {\n    --bg-opacity: 1;\n    background-color: #5850ec;\n    background-color: rgba(88, 80, 236, var(--bg-opacity));\n  }\n  .md\\:focus\\:bg-indigo-700:focus {\n    --bg-opacity: 1;\n    background-color: #5145cd;\n    background-color: rgba(81, 69, 205, var(--bg-opacity));\n  }\n  .md\\:focus\\:bg-indigo-800:focus {\n    --bg-opacity: 1;\n    background-color: #42389d;\n    background-color: rgba(66, 56, 157, var(--bg-opacity));\n  }\n  .md\\:focus\\:bg-indigo-900:focus {\n    --bg-opacity: 1;\n    background-color: #362f78;\n    background-color: rgba(54, 47, 120, var(--bg-opacity));\n  }\n  .md\\:focus\\:bg-purple-50:focus {\n    --bg-opacity: 1;\n    background-color: #f6f5ff;\n    background-color: rgba(246, 245, 255, var(--bg-opacity));\n  }\n  .md\\:focus\\:bg-purple-100:focus {\n    --bg-opacity: 1;\n    background-color: #edebfe;\n    background-color: rgba(237, 235, 254, var(--bg-opacity));\n  }\n  .md\\:focus\\:bg-purple-200:focus {\n    --bg-opacity: 1;\n    background-color: #dcd7fe;\n    background-color: rgba(220, 215, 254, var(--bg-opacity));\n  }\n  .md\\:focus\\:bg-purple-300:focus {\n    --bg-opacity: 1;\n    background-color: #cabffd;\n    background-color: rgba(202, 191, 253, var(--bg-opacity));\n  }\n  .md\\:focus\\:bg-purple-400:focus {\n    --bg-opacity: 1;\n    background-color: #ac94fa;\n    background-color: rgba(172, 148, 250, var(--bg-opacity));\n  }\n  .md\\:focus\\:bg-purple-500:focus {\n    --bg-opacity: 1;\n    background-color: #9061f9;\n    background-color: rgba(144, 97, 249, var(--bg-opacity));\n  }\n  .md\\:focus\\:bg-purple-600:focus {\n    --bg-opacity: 1;\n    background-color: #7e3af2;\n    background-color: rgba(126, 58, 242, var(--bg-opacity));\n  }\n  .md\\:focus\\:bg-purple-700:focus {\n    --bg-opacity: 1;\n    background-color: #6c2bd9;\n    background-color: rgba(108, 43, 217, var(--bg-opacity));\n  }\n  .md\\:focus\\:bg-purple-800:focus {\n    --bg-opacity: 1;\n    background-color: #5521b5;\n    background-color: rgba(85, 33, 181, var(--bg-opacity));\n  }\n  .md\\:focus\\:bg-purple-900:focus {\n    --bg-opacity: 1;\n    background-color: #4a1d96;\n    background-color: rgba(74, 29, 150, var(--bg-opacity));\n  }\n  .md\\:focus\\:bg-pink-50:focus {\n    --bg-opacity: 1;\n    background-color: #fdf2f8;\n    background-color: rgba(253, 242, 248, var(--bg-opacity));\n  }\n  .md\\:focus\\:bg-pink-100:focus {\n    --bg-opacity: 1;\n    background-color: #fce8f3;\n    background-color: rgba(252, 232, 243, var(--bg-opacity));\n  }\n  .md\\:focus\\:bg-pink-200:focus {\n    --bg-opacity: 1;\n    background-color: #fad1e8;\n    background-color: rgba(250, 209, 232, var(--bg-opacity));\n  }\n  .md\\:focus\\:bg-pink-300:focus {\n    --bg-opacity: 1;\n    background-color: #f8b4d9;\n    background-color: rgba(248, 180, 217, var(--bg-opacity));\n  }\n  .md\\:focus\\:bg-pink-400:focus {\n    --bg-opacity: 1;\n    background-color: #f17eb8;\n    background-color: rgba(241, 126, 184, var(--bg-opacity));\n  }\n  .md\\:focus\\:bg-pink-500:focus {\n    --bg-opacity: 1;\n    background-color: #e74694;\n    background-color: rgba(231, 70, 148, var(--bg-opacity));\n  }\n  .md\\:focus\\:bg-pink-600:focus {\n    --bg-opacity: 1;\n    background-color: #d61f69;\n    background-color: rgba(214, 31, 105, var(--bg-opacity));\n  }\n  .md\\:focus\\:bg-pink-700:focus {\n    --bg-opacity: 1;\n    background-color: #bf125d;\n    background-color: rgba(191, 18, 93, var(--bg-opacity));\n  }\n  .md\\:focus\\:bg-pink-800:focus {\n    --bg-opacity: 1;\n    background-color: #99154b;\n    background-color: rgba(153, 21, 75, var(--bg-opacity));\n  }\n  .md\\:focus\\:bg-pink-900:focus {\n    --bg-opacity: 1;\n    background-color: #751a3d;\n    background-color: rgba(117, 26, 61, var(--bg-opacity));\n  }\n  .md\\:focus\\:bg-cool-gray-50:focus {\n    --bg-opacity: 1;\n    background-color: #f8fafc;\n    background-color: rgba(248, 250, 252, var(--bg-opacity));\n  }\n  .md\\:focus\\:bg-cool-gray-100:focus {\n    --bg-opacity: 1;\n    background-color: #f1f5f9;\n    background-color: rgba(241, 245, 249, var(--bg-opacity));\n  }\n  .md\\:focus\\:bg-cool-gray-200:focus {\n    --bg-opacity: 1;\n    background-color: #e2e8f0;\n    background-color: rgba(226, 232, 240, var(--bg-opacity));\n  }\n  .md\\:focus\\:bg-cool-gray-300:focus {\n    --bg-opacity: 1;\n    background-color: #cfd8e3;\n    background-color: rgba(207, 216, 227, var(--bg-opacity));\n  }\n  .md\\:focus\\:bg-cool-gray-400:focus {\n    --bg-opacity: 1;\n    background-color: #97a6ba;\n    background-color: rgba(151, 166, 186, var(--bg-opacity));\n  }\n  .md\\:focus\\:bg-cool-gray-500:focus {\n    --bg-opacity: 1;\n    background-color: #64748b;\n    background-color: rgba(100, 116, 139, var(--bg-opacity));\n  }\n  .md\\:focus\\:bg-cool-gray-600:focus {\n    --bg-opacity: 1;\n    background-color: #475569;\n    background-color: rgba(71, 85, 105, var(--bg-opacity));\n  }\n  .md\\:focus\\:bg-cool-gray-700:focus {\n    --bg-opacity: 1;\n    background-color: #364152;\n    background-color: rgba(54, 65, 82, var(--bg-opacity));\n  }\n  .md\\:focus\\:bg-cool-gray-800:focus {\n    --bg-opacity: 1;\n    background-color: #27303f;\n    background-color: rgba(39, 48, 63, var(--bg-opacity));\n  }\n  .md\\:focus\\:bg-cool-gray-900:focus {\n    --bg-opacity: 1;\n    background-color: #1a202e;\n    background-color: rgba(26, 32, 46, var(--bg-opacity));\n  }\n  .md\\:active\\:bg-current:active {\n    background-color: currentColor;\n  }\n  .md\\:active\\:bg-transparent:active {\n    background-color: transparent;\n  }\n  .md\\:active\\:bg-white:active {\n    --bg-opacity: 1;\n    background-color: #ffffff;\n    background-color: rgba(255, 255, 255, var(--bg-opacity));\n  }\n  .md\\:active\\:bg-black:active {\n    --bg-opacity: 1;\n    background-color: #000000;\n    background-color: rgba(0, 0, 0, var(--bg-opacity));\n  }\n  .md\\:active\\:bg-gray-50:active {\n    --bg-opacity: 1;\n    background-color: #f9fafb;\n    background-color: rgba(249, 250, 251, var(--bg-opacity));\n  }\n  .md\\:active\\:bg-gray-100:active {\n    --bg-opacity: 1;\n    background-color: #f4f5f7;\n    background-color: rgba(244, 245, 247, var(--bg-opacity));\n  }\n  .md\\:active\\:bg-gray-200:active {\n    --bg-opacity: 1;\n    background-color: #e5e7eb;\n    background-color: rgba(229, 231, 235, var(--bg-opacity));\n  }\n  .md\\:active\\:bg-gray-300:active {\n    --bg-opacity: 1;\n    background-color: #d2d6dc;\n    background-color: rgba(210, 214, 220, var(--bg-opacity));\n  }\n  .md\\:active\\:bg-gray-400:active {\n    --bg-opacity: 1;\n    background-color: #9fa6b2;\n    background-color: rgba(159, 166, 178, var(--bg-opacity));\n  }\n  .md\\:active\\:bg-gray-500:active {\n    --bg-opacity: 1;\n    background-color: #6b7280;\n    background-color: rgba(107, 114, 128, var(--bg-opacity));\n  }\n  .md\\:active\\:bg-gray-600:active {\n    --bg-opacity: 1;\n    background-color: #4b5563;\n    background-color: rgba(75, 85, 99, var(--bg-opacity));\n  }\n  .md\\:active\\:bg-gray-700:active {\n    --bg-opacity: 1;\n    background-color: #374151;\n    background-color: rgba(55, 65, 81, var(--bg-opacity));\n  }\n  .md\\:active\\:bg-gray-800:active {\n    --bg-opacity: 1;\n    background-color: #252f3f;\n    background-color: rgba(37, 47, 63, var(--bg-opacity));\n  }\n  .md\\:active\\:bg-gray-900:active {\n    --bg-opacity: 1;\n    background-color: #161e2e;\n    background-color: rgba(22, 30, 46, var(--bg-opacity));\n  }\n  .md\\:active\\:bg-red-50:active {\n    --bg-opacity: 1;\n    background-color: #fdf2f2;\n    background-color: rgba(253, 242, 242, var(--bg-opacity));\n  }\n  .md\\:active\\:bg-red-100:active {\n    --bg-opacity: 1;\n    background-color: #fde8e8;\n    background-color: rgba(253, 232, 232, var(--bg-opacity));\n  }\n  .md\\:active\\:bg-red-200:active {\n    --bg-opacity: 1;\n    background-color: #fbd5d5;\n    background-color: rgba(251, 213, 213, var(--bg-opacity));\n  }\n  .md\\:active\\:bg-red-300:active {\n    --bg-opacity: 1;\n    background-color: #f8b4b4;\n    background-color: rgba(248, 180, 180, var(--bg-opacity));\n  }\n  .md\\:active\\:bg-red-400:active {\n    --bg-opacity: 1;\n    background-color: #f98080;\n    background-color: rgba(249, 128, 128, var(--bg-opacity));\n  }\n  .md\\:active\\:bg-red-500:active {\n    --bg-opacity: 1;\n    background-color: #f05252;\n    background-color: rgba(240, 82, 82, var(--bg-opacity));\n  }\n  .md\\:active\\:bg-red-600:active {\n    --bg-opacity: 1;\n    background-color: #e02424;\n    background-color: rgba(224, 36, 36, var(--bg-opacity));\n  }\n  .md\\:active\\:bg-red-700:active {\n    --bg-opacity: 1;\n    background-color: #c81e1e;\n    background-color: rgba(200, 30, 30, var(--bg-opacity));\n  }\n  .md\\:active\\:bg-red-800:active {\n    --bg-opacity: 1;\n    background-color: #9b1c1c;\n    background-color: rgba(155, 28, 28, var(--bg-opacity));\n  }\n  .md\\:active\\:bg-red-900:active {\n    --bg-opacity: 1;\n    background-color: #771d1d;\n    background-color: rgba(119, 29, 29, var(--bg-opacity));\n  }\n  .md\\:active\\:bg-orange-50:active {\n    --bg-opacity: 1;\n    background-color: #fff8f1;\n    background-color: rgba(255, 248, 241, var(--bg-opacity));\n  }\n  .md\\:active\\:bg-orange-100:active {\n    --bg-opacity: 1;\n    background-color: #feecdc;\n    background-color: rgba(254, 236, 220, var(--bg-opacity));\n  }\n  .md\\:active\\:bg-orange-200:active {\n    --bg-opacity: 1;\n    background-color: #fcd9bd;\n    background-color: rgba(252, 217, 189, var(--bg-opacity));\n  }\n  .md\\:active\\:bg-orange-300:active {\n    --bg-opacity: 1;\n    background-color: #fdba8c;\n    background-color: rgba(253, 186, 140, var(--bg-opacity));\n  }\n  .md\\:active\\:bg-orange-400:active {\n    --bg-opacity: 1;\n    background-color: #ff8a4c;\n    background-color: rgba(255, 138, 76, var(--bg-opacity));\n  }\n  .md\\:active\\:bg-orange-500:active {\n    --bg-opacity: 1;\n    background-color: #ff5a1f;\n    background-color: rgba(255, 90, 31, var(--bg-opacity));\n  }\n  .md\\:active\\:bg-orange-600:active {\n    --bg-opacity: 1;\n    background-color: #d03801;\n    background-color: rgba(208, 56, 1, var(--bg-opacity));\n  }\n  .md\\:active\\:bg-orange-700:active {\n    --bg-opacity: 1;\n    background-color: #b43403;\n    background-color: rgba(180, 52, 3, var(--bg-opacity));\n  }\n  .md\\:active\\:bg-orange-800:active {\n    --bg-opacity: 1;\n    background-color: #8a2c0d;\n    background-color: rgba(138, 44, 13, var(--bg-opacity));\n  }\n  .md\\:active\\:bg-orange-900:active {\n    --bg-opacity: 1;\n    background-color: #73230d;\n    background-color: rgba(115, 35, 13, var(--bg-opacity));\n  }\n  .md\\:active\\:bg-yellow-50:active {\n    --bg-opacity: 1;\n    background-color: #fdfdea;\n    background-color: rgba(253, 253, 234, var(--bg-opacity));\n  }\n  .md\\:active\\:bg-yellow-100:active {\n    --bg-opacity: 1;\n    background-color: #fdf6b2;\n    background-color: rgba(253, 246, 178, var(--bg-opacity));\n  }\n  .md\\:active\\:bg-yellow-200:active {\n    --bg-opacity: 1;\n    background-color: #fce96a;\n    background-color: rgba(252, 233, 106, var(--bg-opacity));\n  }\n  .md\\:active\\:bg-yellow-300:active {\n    --bg-opacity: 1;\n    background-color: #faca15;\n    background-color: rgba(250, 202, 21, var(--bg-opacity));\n  }\n  .md\\:active\\:bg-yellow-400:active {\n    --bg-opacity: 1;\n    background-color: #e3a008;\n    background-color: rgba(227, 160, 8, var(--bg-opacity));\n  }\n  .md\\:active\\:bg-yellow-500:active {\n    --bg-opacity: 1;\n    background-color: #c27803;\n    background-color: rgba(194, 120, 3, var(--bg-opacity));\n  }\n  .md\\:active\\:bg-yellow-600:active {\n    --bg-opacity: 1;\n    background-color: #9f580a;\n    background-color: rgba(159, 88, 10, var(--bg-opacity));\n  }\n  .md\\:active\\:bg-yellow-700:active {\n    --bg-opacity: 1;\n    background-color: #8e4b10;\n    background-color: rgba(142, 75, 16, var(--bg-opacity));\n  }\n  .md\\:active\\:bg-yellow-800:active {\n    --bg-opacity: 1;\n    background-color: #723b13;\n    background-color: rgba(114, 59, 19, var(--bg-opacity));\n  }\n  .md\\:active\\:bg-yellow-900:active {\n    --bg-opacity: 1;\n    background-color: #633112;\n    background-color: rgba(99, 49, 18, var(--bg-opacity));\n  }\n  .md\\:active\\:bg-green-50:active {\n    --bg-opacity: 1;\n    background-color: #f3faf7;\n    background-color: rgba(243, 250, 247, var(--bg-opacity));\n  }\n  .md\\:active\\:bg-green-100:active {\n    --bg-opacity: 1;\n    background-color: #def7ec;\n    background-color: rgba(222, 247, 236, var(--bg-opacity));\n  }\n  .md\\:active\\:bg-green-200:active {\n    --bg-opacity: 1;\n    background-color: #bcf0da;\n    background-color: rgba(188, 240, 218, var(--bg-opacity));\n  }\n  .md\\:active\\:bg-green-300:active {\n    --bg-opacity: 1;\n    background-color: #84e1bc;\n    background-color: rgba(132, 225, 188, var(--bg-opacity));\n  }\n  .md\\:active\\:bg-green-400:active {\n    --bg-opacity: 1;\n    background-color: #31c48d;\n    background-color: rgba(49, 196, 141, var(--bg-opacity));\n  }\n  .md\\:active\\:bg-green-500:active {\n    --bg-opacity: 1;\n    background-color: #0e9f6e;\n    background-color: rgba(14, 159, 110, var(--bg-opacity));\n  }\n  .md\\:active\\:bg-green-600:active {\n    --bg-opacity: 1;\n    background-color: #057a55;\n    background-color: rgba(5, 122, 85, var(--bg-opacity));\n  }\n  .md\\:active\\:bg-green-700:active {\n    --bg-opacity: 1;\n    background-color: #046c4e;\n    background-color: rgba(4, 108, 78, var(--bg-opacity));\n  }\n  .md\\:active\\:bg-green-800:active {\n    --bg-opacity: 1;\n    background-color: #03543f;\n    background-color: rgba(3, 84, 63, var(--bg-opacity));\n  }\n  .md\\:active\\:bg-green-900:active {\n    --bg-opacity: 1;\n    background-color: #014737;\n    background-color: rgba(1, 71, 55, var(--bg-opacity));\n  }\n  .md\\:active\\:bg-teal-50:active {\n    --bg-opacity: 1;\n    background-color: #edfafa;\n    background-color: rgba(237, 250, 250, var(--bg-opacity));\n  }\n  .md\\:active\\:bg-teal-100:active {\n    --bg-opacity: 1;\n    background-color: #d5f5f6;\n    background-color: rgba(213, 245, 246, var(--bg-opacity));\n  }\n  .md\\:active\\:bg-teal-200:active {\n    --bg-opacity: 1;\n    background-color: #afecef;\n    background-color: rgba(175, 236, 239, var(--bg-opacity));\n  }\n  .md\\:active\\:bg-teal-300:active {\n    --bg-opacity: 1;\n    background-color: #7edce2;\n    background-color: rgba(126, 220, 226, var(--bg-opacity));\n  }\n  .md\\:active\\:bg-teal-400:active {\n    --bg-opacity: 1;\n    background-color: #16bdca;\n    background-color: rgba(22, 189, 202, var(--bg-opacity));\n  }\n  .md\\:active\\:bg-teal-500:active {\n    --bg-opacity: 1;\n    background-color: #0694a2;\n    background-color: rgba(6, 148, 162, var(--bg-opacity));\n  }\n  .md\\:active\\:bg-teal-600:active {\n    --bg-opacity: 1;\n    background-color: #047481;\n    background-color: rgba(4, 116, 129, var(--bg-opacity));\n  }\n  .md\\:active\\:bg-teal-700:active {\n    --bg-opacity: 1;\n    background-color: #036672;\n    background-color: rgba(3, 102, 114, var(--bg-opacity));\n  }\n  .md\\:active\\:bg-teal-800:active {\n    --bg-opacity: 1;\n    background-color: #05505c;\n    background-color: rgba(5, 80, 92, var(--bg-opacity));\n  }\n  .md\\:active\\:bg-teal-900:active {\n    --bg-opacity: 1;\n    background-color: #014451;\n    background-color: rgba(1, 68, 81, var(--bg-opacity));\n  }\n  .md\\:active\\:bg-blue-50:active {\n    --bg-opacity: 1;\n    background-color: #ebf5ff;\n    background-color: rgba(235, 245, 255, var(--bg-opacity));\n  }\n  .md\\:active\\:bg-blue-100:active {\n    --bg-opacity: 1;\n    background-color: #e1effe;\n    background-color: rgba(225, 239, 254, var(--bg-opacity));\n  }\n  .md\\:active\\:bg-blue-200:active {\n    --bg-opacity: 1;\n    background-color: #c3ddfd;\n    background-color: rgba(195, 221, 253, var(--bg-opacity));\n  }\n  .md\\:active\\:bg-blue-300:active {\n    --bg-opacity: 1;\n    background-color: #a4cafe;\n    background-color: rgba(164, 202, 254, var(--bg-opacity));\n  }\n  .md\\:active\\:bg-blue-400:active {\n    --bg-opacity: 1;\n    background-color: #76a9fa;\n    background-color: rgba(118, 169, 250, var(--bg-opacity));\n  }\n  .md\\:active\\:bg-blue-500:active {\n    --bg-opacity: 1;\n    background-color: #3f83f8;\n    background-color: rgba(63, 131, 248, var(--bg-opacity));\n  }\n  .md\\:active\\:bg-blue-600:active {\n    --bg-opacity: 1;\n    background-color: #1c64f2;\n    background-color: rgba(28, 100, 242, var(--bg-opacity));\n  }\n  .md\\:active\\:bg-blue-700:active {\n    --bg-opacity: 1;\n    background-color: #1a56db;\n    background-color: rgba(26, 86, 219, var(--bg-opacity));\n  }\n  .md\\:active\\:bg-blue-800:active {\n    --bg-opacity: 1;\n    background-color: #1e429f;\n    background-color: rgba(30, 66, 159, var(--bg-opacity));\n  }\n  .md\\:active\\:bg-blue-900:active {\n    --bg-opacity: 1;\n    background-color: #233876;\n    background-color: rgba(35, 56, 118, var(--bg-opacity));\n  }\n  .md\\:active\\:bg-indigo-50:active {\n    --bg-opacity: 1;\n    background-color: #f0f5ff;\n    background-color: rgba(240, 245, 255, var(--bg-opacity));\n  }\n  .md\\:active\\:bg-indigo-100:active {\n    --bg-opacity: 1;\n    background-color: #e5edff;\n    background-color: rgba(229, 237, 255, var(--bg-opacity));\n  }\n  .md\\:active\\:bg-indigo-200:active {\n    --bg-opacity: 1;\n    background-color: #cddbfe;\n    background-color: rgba(205, 219, 254, var(--bg-opacity));\n  }\n  .md\\:active\\:bg-indigo-300:active {\n    --bg-opacity: 1;\n    background-color: #b4c6fc;\n    background-color: rgba(180, 198, 252, var(--bg-opacity));\n  }\n  .md\\:active\\:bg-indigo-400:active {\n    --bg-opacity: 1;\n    background-color: #8da2fb;\n    background-color: rgba(141, 162, 251, var(--bg-opacity));\n  }\n  .md\\:active\\:bg-indigo-500:active {\n    --bg-opacity: 1;\n    background-color: #6875f5;\n    background-color: rgba(104, 117, 245, var(--bg-opacity));\n  }\n  .md\\:active\\:bg-indigo-600:active {\n    --bg-opacity: 1;\n    background-color: #5850ec;\n    background-color: rgba(88, 80, 236, var(--bg-opacity));\n  }\n  .md\\:active\\:bg-indigo-700:active {\n    --bg-opacity: 1;\n    background-color: #5145cd;\n    background-color: rgba(81, 69, 205, var(--bg-opacity));\n  }\n  .md\\:active\\:bg-indigo-800:active {\n    --bg-opacity: 1;\n    background-color: #42389d;\n    background-color: rgba(66, 56, 157, var(--bg-opacity));\n  }\n  .md\\:active\\:bg-indigo-900:active {\n    --bg-opacity: 1;\n    background-color: #362f78;\n    background-color: rgba(54, 47, 120, var(--bg-opacity));\n  }\n  .md\\:active\\:bg-purple-50:active {\n    --bg-opacity: 1;\n    background-color: #f6f5ff;\n    background-color: rgba(246, 245, 255, var(--bg-opacity));\n  }\n  .md\\:active\\:bg-purple-100:active {\n    --bg-opacity: 1;\n    background-color: #edebfe;\n    background-color: rgba(237, 235, 254, var(--bg-opacity));\n  }\n  .md\\:active\\:bg-purple-200:active {\n    --bg-opacity: 1;\n    background-color: #dcd7fe;\n    background-color: rgba(220, 215, 254, var(--bg-opacity));\n  }\n  .md\\:active\\:bg-purple-300:active {\n    --bg-opacity: 1;\n    background-color: #cabffd;\n    background-color: rgba(202, 191, 253, var(--bg-opacity));\n  }\n  .md\\:active\\:bg-purple-400:active {\n    --bg-opacity: 1;\n    background-color: #ac94fa;\n    background-color: rgba(172, 148, 250, var(--bg-opacity));\n  }\n  .md\\:active\\:bg-purple-500:active {\n    --bg-opacity: 1;\n    background-color: #9061f9;\n    background-color: rgba(144, 97, 249, var(--bg-opacity));\n  }\n  .md\\:active\\:bg-purple-600:active {\n    --bg-opacity: 1;\n    background-color: #7e3af2;\n    background-color: rgba(126, 58, 242, var(--bg-opacity));\n  }\n  .md\\:active\\:bg-purple-700:active {\n    --bg-opacity: 1;\n    background-color: #6c2bd9;\n    background-color: rgba(108, 43, 217, var(--bg-opacity));\n  }\n  .md\\:active\\:bg-purple-800:active {\n    --bg-opacity: 1;\n    background-color: #5521b5;\n    background-color: rgba(85, 33, 181, var(--bg-opacity));\n  }\n  .md\\:active\\:bg-purple-900:active {\n    --bg-opacity: 1;\n    background-color: #4a1d96;\n    background-color: rgba(74, 29, 150, var(--bg-opacity));\n  }\n  .md\\:active\\:bg-pink-50:active {\n    --bg-opacity: 1;\n    background-color: #fdf2f8;\n    background-color: rgba(253, 242, 248, var(--bg-opacity));\n  }\n  .md\\:active\\:bg-pink-100:active {\n    --bg-opacity: 1;\n    background-color: #fce8f3;\n    background-color: rgba(252, 232, 243, var(--bg-opacity));\n  }\n  .md\\:active\\:bg-pink-200:active {\n    --bg-opacity: 1;\n    background-color: #fad1e8;\n    background-color: rgba(250, 209, 232, var(--bg-opacity));\n  }\n  .md\\:active\\:bg-pink-300:active {\n    --bg-opacity: 1;\n    background-color: #f8b4d9;\n    background-color: rgba(248, 180, 217, var(--bg-opacity));\n  }\n  .md\\:active\\:bg-pink-400:active {\n    --bg-opacity: 1;\n    background-color: #f17eb8;\n    background-color: rgba(241, 126, 184, var(--bg-opacity));\n  }\n  .md\\:active\\:bg-pink-500:active {\n    --bg-opacity: 1;\n    background-color: #e74694;\n    background-color: rgba(231, 70, 148, var(--bg-opacity));\n  }\n  .md\\:active\\:bg-pink-600:active {\n    --bg-opacity: 1;\n    background-color: #d61f69;\n    background-color: rgba(214, 31, 105, var(--bg-opacity));\n  }\n  .md\\:active\\:bg-pink-700:active {\n    --bg-opacity: 1;\n    background-color: #bf125d;\n    background-color: rgba(191, 18, 93, var(--bg-opacity));\n  }\n  .md\\:active\\:bg-pink-800:active {\n    --bg-opacity: 1;\n    background-color: #99154b;\n    background-color: rgba(153, 21, 75, var(--bg-opacity));\n  }\n  .md\\:active\\:bg-pink-900:active {\n    --bg-opacity: 1;\n    background-color: #751a3d;\n    background-color: rgba(117, 26, 61, var(--bg-opacity));\n  }\n  .md\\:active\\:bg-cool-gray-50:active {\n    --bg-opacity: 1;\n    background-color: #f8fafc;\n    background-color: rgba(248, 250, 252, var(--bg-opacity));\n  }\n  .md\\:active\\:bg-cool-gray-100:active {\n    --bg-opacity: 1;\n    background-color: #f1f5f9;\n    background-color: rgba(241, 245, 249, var(--bg-opacity));\n  }\n  .md\\:active\\:bg-cool-gray-200:active {\n    --bg-opacity: 1;\n    background-color: #e2e8f0;\n    background-color: rgba(226, 232, 240, var(--bg-opacity));\n  }\n  .md\\:active\\:bg-cool-gray-300:active {\n    --bg-opacity: 1;\n    background-color: #cfd8e3;\n    background-color: rgba(207, 216, 227, var(--bg-opacity));\n  }\n  .md\\:active\\:bg-cool-gray-400:active {\n    --bg-opacity: 1;\n    background-color: #97a6ba;\n    background-color: rgba(151, 166, 186, var(--bg-opacity));\n  }\n  .md\\:active\\:bg-cool-gray-500:active {\n    --bg-opacity: 1;\n    background-color: #64748b;\n    background-color: rgba(100, 116, 139, var(--bg-opacity));\n  }\n  .md\\:active\\:bg-cool-gray-600:active {\n    --bg-opacity: 1;\n    background-color: #475569;\n    background-color: rgba(71, 85, 105, var(--bg-opacity));\n  }\n  .md\\:active\\:bg-cool-gray-700:active {\n    --bg-opacity: 1;\n    background-color: #364152;\n    background-color: rgba(54, 65, 82, var(--bg-opacity));\n  }\n  .md\\:active\\:bg-cool-gray-800:active {\n    --bg-opacity: 1;\n    background-color: #27303f;\n    background-color: rgba(39, 48, 63, var(--bg-opacity));\n  }\n  .md\\:active\\:bg-cool-gray-900:active {\n    --bg-opacity: 1;\n    background-color: #1a202e;\n    background-color: rgba(26, 32, 46, var(--bg-opacity));\n  }\n  .md\\:bg-none {\n    background-image: none;\n  }\n  .md\\:bg-gradient-to-t {\n    background-image: linear-gradient(to top, var(--gradient-color-stops));\n  }\n  .md\\:bg-gradient-to-tr {\n    background-image: linear-gradient(to top right, var(--gradient-color-stops));\n  }\n  .md\\:bg-gradient-to-r {\n    background-image: linear-gradient(to right, var(--gradient-color-stops));\n  }\n  .md\\:bg-gradient-to-br {\n    background-image: linear-gradient(to bottom right, var(--gradient-color-stops));\n  }\n  .md\\:bg-gradient-to-b {\n    background-image: linear-gradient(to bottom, var(--gradient-color-stops));\n  }\n  .md\\:bg-gradient-to-bl {\n    background-image: linear-gradient(to bottom left, var(--gradient-color-stops));\n  }\n  .md\\:bg-gradient-to-l {\n    background-image: linear-gradient(to left, var(--gradient-color-stops));\n  }\n  .md\\:bg-gradient-to-tl {\n    background-image: linear-gradient(to top left, var(--gradient-color-stops));\n  }\n  .md\\:from-current {\n    --gradient-from-color: currentColor;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));\n  }\n  .md\\:from-transparent {\n    --gradient-from-color: transparent;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0));\n  }\n  .md\\:from-white {\n    --gradient-from-color: #ffffff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));\n  }\n  .md\\:from-black {\n    --gradient-from-color: #000000;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0));\n  }\n  .md\\:from-gray-50 {\n    --gradient-from-color: #f9fafb;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(249, 250, 251, 0));\n  }\n  .md\\:from-gray-100 {\n    --gradient-from-color: #f4f5f7;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(244, 245, 247, 0));\n  }\n  .md\\:from-gray-200 {\n    --gradient-from-color: #e5e7eb;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(229, 231, 235, 0));\n  }\n  .md\\:from-gray-300 {\n    --gradient-from-color: #d2d6dc;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(210, 214, 220, 0));\n  }\n  .md\\:from-gray-400 {\n    --gradient-from-color: #9fa6b2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(159, 166, 178, 0));\n  }\n  .md\\:from-gray-500 {\n    --gradient-from-color: #6b7280;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(107, 114, 128, 0));\n  }\n  .md\\:from-gray-600 {\n    --gradient-from-color: #4b5563;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(75, 85, 99, 0));\n  }\n  .md\\:from-gray-700 {\n    --gradient-from-color: #374151;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(55, 65, 81, 0));\n  }\n  .md\\:from-gray-800 {\n    --gradient-from-color: #252f3f;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(37, 47, 63, 0));\n  }\n  .md\\:from-gray-900 {\n    --gradient-from-color: #161e2e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(22, 30, 46, 0));\n  }\n  .md\\:from-red-50 {\n    --gradient-from-color: #fdf2f2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 242, 242, 0));\n  }\n  .md\\:from-red-100 {\n    --gradient-from-color: #fde8e8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 232, 232, 0));\n  }\n  .md\\:from-red-200 {\n    --gradient-from-color: #fbd5d5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(251, 213, 213, 0));\n  }\n  .md\\:from-red-300 {\n    --gradient-from-color: #f8b4b4;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(248, 180, 180, 0));\n  }\n  .md\\:from-red-400 {\n    --gradient-from-color: #f98080;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(249, 128, 128, 0));\n  }\n  .md\\:from-red-500 {\n    --gradient-from-color: #f05252;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(240, 82, 82, 0));\n  }\n  .md\\:from-red-600 {\n    --gradient-from-color: #e02424;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(224, 36, 36, 0));\n  }\n  .md\\:from-red-700 {\n    --gradient-from-color: #c81e1e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(200, 30, 30, 0));\n  }\n  .md\\:from-red-800 {\n    --gradient-from-color: #9b1c1c;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(155, 28, 28, 0));\n  }\n  .md\\:from-red-900 {\n    --gradient-from-color: #771d1d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(119, 29, 29, 0));\n  }\n  .md\\:from-orange-50 {\n    --gradient-from-color: #fff8f1;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 248, 241, 0));\n  }\n  .md\\:from-orange-100 {\n    --gradient-from-color: #feecdc;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 236, 220, 0));\n  }\n  .md\\:from-orange-200 {\n    --gradient-from-color: #fcd9bd;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(252, 217, 189, 0));\n  }\n  .md\\:from-orange-300 {\n    --gradient-from-color: #fdba8c;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 186, 140, 0));\n  }\n  .md\\:from-orange-400 {\n    --gradient-from-color: #ff8a4c;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 138, 76, 0));\n  }\n  .md\\:from-orange-500 {\n    --gradient-from-color: #ff5a1f;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 90, 31, 0));\n  }\n  .md\\:from-orange-600 {\n    --gradient-from-color: #d03801;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(208, 56, 1, 0));\n  }\n  .md\\:from-orange-700 {\n    --gradient-from-color: #b43403;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(180, 52, 3, 0));\n  }\n  .md\\:from-orange-800 {\n    --gradient-from-color: #8a2c0d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(138, 44, 13, 0));\n  }\n  .md\\:from-orange-900 {\n    --gradient-from-color: #73230d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(115, 35, 13, 0));\n  }\n  .md\\:from-yellow-50 {\n    --gradient-from-color: #fdfdea;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 253, 234, 0));\n  }\n  .md\\:from-yellow-100 {\n    --gradient-from-color: #fdf6b2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 246, 178, 0));\n  }\n  .md\\:from-yellow-200 {\n    --gradient-from-color: #fce96a;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(252, 233, 106, 0));\n  }\n  .md\\:from-yellow-300 {\n    --gradient-from-color: #faca15;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(250, 202, 21, 0));\n  }\n  .md\\:from-yellow-400 {\n    --gradient-from-color: #e3a008;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(227, 160, 8, 0));\n  }\n  .md\\:from-yellow-500 {\n    --gradient-from-color: #c27803;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(194, 120, 3, 0));\n  }\n  .md\\:from-yellow-600 {\n    --gradient-from-color: #9f580a;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(159, 88, 10, 0));\n  }\n  .md\\:from-yellow-700 {\n    --gradient-from-color: #8e4b10;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(142, 75, 16, 0));\n  }\n  .md\\:from-yellow-800 {\n    --gradient-from-color: #723b13;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(114, 59, 19, 0));\n  }\n  .md\\:from-yellow-900 {\n    --gradient-from-color: #633112;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(99, 49, 18, 0));\n  }\n  .md\\:from-green-50 {\n    --gradient-from-color: #f3faf7;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(243, 250, 247, 0));\n  }\n  .md\\:from-green-100 {\n    --gradient-from-color: #def7ec;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(222, 247, 236, 0));\n  }\n  .md\\:from-green-200 {\n    --gradient-from-color: #bcf0da;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(188, 240, 218, 0));\n  }\n  .md\\:from-green-300 {\n    --gradient-from-color: #84e1bc;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(132, 225, 188, 0));\n  }\n  .md\\:from-green-400 {\n    --gradient-from-color: #31c48d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(49, 196, 141, 0));\n  }\n  .md\\:from-green-500 {\n    --gradient-from-color: #0e9f6e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(14, 159, 110, 0));\n  }\n  .md\\:from-green-600 {\n    --gradient-from-color: #057a55;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(5, 122, 85, 0));\n  }\n  .md\\:from-green-700 {\n    --gradient-from-color: #046c4e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(4, 108, 78, 0));\n  }\n  .md\\:from-green-800 {\n    --gradient-from-color: #03543f;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(3, 84, 63, 0));\n  }\n  .md\\:from-green-900 {\n    --gradient-from-color: #014737;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(1, 71, 55, 0));\n  }\n  .md\\:from-teal-50 {\n    --gradient-from-color: #edfafa;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(237, 250, 250, 0));\n  }\n  .md\\:from-teal-100 {\n    --gradient-from-color: #d5f5f6;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(213, 245, 246, 0));\n  }\n  .md\\:from-teal-200 {\n    --gradient-from-color: #afecef;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(175, 236, 239, 0));\n  }\n  .md\\:from-teal-300 {\n    --gradient-from-color: #7edce2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(126, 220, 226, 0));\n  }\n  .md\\:from-teal-400 {\n    --gradient-from-color: #16bdca;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(22, 189, 202, 0));\n  }\n  .md\\:from-teal-500 {\n    --gradient-from-color: #0694a2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(6, 148, 162, 0));\n  }\n  .md\\:from-teal-600 {\n    --gradient-from-color: #047481;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(4, 116, 129, 0));\n  }\n  .md\\:from-teal-700 {\n    --gradient-from-color: #036672;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(3, 102, 114, 0));\n  }\n  .md\\:from-teal-800 {\n    --gradient-from-color: #05505c;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(5, 80, 92, 0));\n  }\n  .md\\:from-teal-900 {\n    --gradient-from-color: #014451;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(1, 68, 81, 0));\n  }\n  .md\\:from-blue-50 {\n    --gradient-from-color: #ebf5ff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(235, 245, 255, 0));\n  }\n  .md\\:from-blue-100 {\n    --gradient-from-color: #e1effe;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(225, 239, 254, 0));\n  }\n  .md\\:from-blue-200 {\n    --gradient-from-color: #c3ddfd;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(195, 221, 253, 0));\n  }\n  .md\\:from-blue-300 {\n    --gradient-from-color: #a4cafe;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(164, 202, 254, 0));\n  }\n  .md\\:from-blue-400 {\n    --gradient-from-color: #76a9fa;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(118, 169, 250, 0));\n  }\n  .md\\:from-blue-500 {\n    --gradient-from-color: #3f83f8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(63, 131, 248, 0));\n  }\n  .md\\:from-blue-600 {\n    --gradient-from-color: #1c64f2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(28, 100, 242, 0));\n  }\n  .md\\:from-blue-700 {\n    --gradient-from-color: #1a56db;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(26, 86, 219, 0));\n  }\n  .md\\:from-blue-800 {\n    --gradient-from-color: #1e429f;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(30, 66, 159, 0));\n  }\n  .md\\:from-blue-900 {\n    --gradient-from-color: #233876;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(35, 56, 118, 0));\n  }\n  .md\\:from-indigo-50 {\n    --gradient-from-color: #f0f5ff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(240, 245, 255, 0));\n  }\n  .md\\:from-indigo-100 {\n    --gradient-from-color: #e5edff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(229, 237, 255, 0));\n  }\n  .md\\:from-indigo-200 {\n    --gradient-from-color: #cddbfe;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(205, 219, 254, 0));\n  }\n  .md\\:from-indigo-300 {\n    --gradient-from-color: #b4c6fc;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(180, 198, 252, 0));\n  }\n  .md\\:from-indigo-400 {\n    --gradient-from-color: #8da2fb;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(141, 162, 251, 0));\n  }\n  .md\\:from-indigo-500 {\n    --gradient-from-color: #6875f5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(104, 117, 245, 0));\n  }\n  .md\\:from-indigo-600 {\n    --gradient-from-color: #5850ec;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(88, 80, 236, 0));\n  }\n  .md\\:from-indigo-700 {\n    --gradient-from-color: #5145cd;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(81, 69, 205, 0));\n  }\n  .md\\:from-indigo-800 {\n    --gradient-from-color: #42389d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(66, 56, 157, 0));\n  }\n  .md\\:from-indigo-900 {\n    --gradient-from-color: #362f78;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(54, 47, 120, 0));\n  }\n  .md\\:from-purple-50 {\n    --gradient-from-color: #f6f5ff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(246, 245, 255, 0));\n  }\n  .md\\:from-purple-100 {\n    --gradient-from-color: #edebfe;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(237, 235, 254, 0));\n  }\n  .md\\:from-purple-200 {\n    --gradient-from-color: #dcd7fe;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(220, 215, 254, 0));\n  }\n  .md\\:from-purple-300 {\n    --gradient-from-color: #cabffd;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(202, 191, 253, 0));\n  }\n  .md\\:from-purple-400 {\n    --gradient-from-color: #ac94fa;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(172, 148, 250, 0));\n  }\n  .md\\:from-purple-500 {\n    --gradient-from-color: #9061f9;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(144, 97, 249, 0));\n  }\n  .md\\:from-purple-600 {\n    --gradient-from-color: #7e3af2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(126, 58, 242, 0));\n  }\n  .md\\:from-purple-700 {\n    --gradient-from-color: #6c2bd9;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(108, 43, 217, 0));\n  }\n  .md\\:from-purple-800 {\n    --gradient-from-color: #5521b5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(85, 33, 181, 0));\n  }\n  .md\\:from-purple-900 {\n    --gradient-from-color: #4a1d96;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(74, 29, 150, 0));\n  }\n  .md\\:from-pink-50 {\n    --gradient-from-color: #fdf2f8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 242, 248, 0));\n  }\n  .md\\:from-pink-100 {\n    --gradient-from-color: #fce8f3;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(252, 232, 243, 0));\n  }\n  .md\\:from-pink-200 {\n    --gradient-from-color: #fad1e8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(250, 209, 232, 0));\n  }\n  .md\\:from-pink-300 {\n    --gradient-from-color: #f8b4d9;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(248, 180, 217, 0));\n  }\n  .md\\:from-pink-400 {\n    --gradient-from-color: #f17eb8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(241, 126, 184, 0));\n  }\n  .md\\:from-pink-500 {\n    --gradient-from-color: #e74694;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(231, 70, 148, 0));\n  }\n  .md\\:from-pink-600 {\n    --gradient-from-color: #d61f69;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(214, 31, 105, 0));\n  }\n  .md\\:from-pink-700 {\n    --gradient-from-color: #bf125d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(191, 18, 93, 0));\n  }\n  .md\\:from-pink-800 {\n    --gradient-from-color: #99154b;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(153, 21, 75, 0));\n  }\n  .md\\:from-pink-900 {\n    --gradient-from-color: #751a3d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(117, 26, 61, 0));\n  }\n  .md\\:from-cool-gray-50 {\n    --gradient-from-color: #f8fafc;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(248, 250, 252, 0));\n  }\n  .md\\:from-cool-gray-100 {\n    --gradient-from-color: #f1f5f9;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(241, 245, 249, 0));\n  }\n  .md\\:from-cool-gray-200 {\n    --gradient-from-color: #e2e8f0;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(226, 232, 240, 0));\n  }\n  .md\\:from-cool-gray-300 {\n    --gradient-from-color: #cfd8e3;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(207, 216, 227, 0));\n  }\n  .md\\:from-cool-gray-400 {\n    --gradient-from-color: #97a6ba;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(151, 166, 186, 0));\n  }\n  .md\\:from-cool-gray-500 {\n    --gradient-from-color: #64748b;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(100, 116, 139, 0));\n  }\n  .md\\:from-cool-gray-600 {\n    --gradient-from-color: #475569;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(71, 85, 105, 0));\n  }\n  .md\\:from-cool-gray-700 {\n    --gradient-from-color: #364152;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(54, 65, 82, 0));\n  }\n  .md\\:from-cool-gray-800 {\n    --gradient-from-color: #27303f;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(39, 48, 63, 0));\n  }\n  .md\\:from-cool-gray-900 {\n    --gradient-from-color: #1a202e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(26, 32, 46, 0));\n  }\n  .md\\:via-current {\n    --gradient-via-color: currentColor;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));\n  }\n  .md\\:via-transparent {\n    --gradient-via-color: transparent;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0));\n  }\n  .md\\:via-white {\n    --gradient-via-color: #ffffff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));\n  }\n  .md\\:via-black {\n    --gradient-via-color: #000000;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0));\n  }\n  .md\\:via-gray-50 {\n    --gradient-via-color: #f9fafb;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(249, 250, 251, 0));\n  }\n  .md\\:via-gray-100 {\n    --gradient-via-color: #f4f5f7;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(244, 245, 247, 0));\n  }\n  .md\\:via-gray-200 {\n    --gradient-via-color: #e5e7eb;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(229, 231, 235, 0));\n  }\n  .md\\:via-gray-300 {\n    --gradient-via-color: #d2d6dc;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(210, 214, 220, 0));\n  }\n  .md\\:via-gray-400 {\n    --gradient-via-color: #9fa6b2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(159, 166, 178, 0));\n  }\n  .md\\:via-gray-500 {\n    --gradient-via-color: #6b7280;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(107, 114, 128, 0));\n  }\n  .md\\:via-gray-600 {\n    --gradient-via-color: #4b5563;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(75, 85, 99, 0));\n  }\n  .md\\:via-gray-700 {\n    --gradient-via-color: #374151;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(55, 65, 81, 0));\n  }\n  .md\\:via-gray-800 {\n    --gradient-via-color: #252f3f;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(37, 47, 63, 0));\n  }\n  .md\\:via-gray-900 {\n    --gradient-via-color: #161e2e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(22, 30, 46, 0));\n  }\n  .md\\:via-red-50 {\n    --gradient-via-color: #fdf2f2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 242, 242, 0));\n  }\n  .md\\:via-red-100 {\n    --gradient-via-color: #fde8e8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 232, 232, 0));\n  }\n  .md\\:via-red-200 {\n    --gradient-via-color: #fbd5d5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(251, 213, 213, 0));\n  }\n  .md\\:via-red-300 {\n    --gradient-via-color: #f8b4b4;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(248, 180, 180, 0));\n  }\n  .md\\:via-red-400 {\n    --gradient-via-color: #f98080;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(249, 128, 128, 0));\n  }\n  .md\\:via-red-500 {\n    --gradient-via-color: #f05252;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(240, 82, 82, 0));\n  }\n  .md\\:via-red-600 {\n    --gradient-via-color: #e02424;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(224, 36, 36, 0));\n  }\n  .md\\:via-red-700 {\n    --gradient-via-color: #c81e1e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(200, 30, 30, 0));\n  }\n  .md\\:via-red-800 {\n    --gradient-via-color: #9b1c1c;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(155, 28, 28, 0));\n  }\n  .md\\:via-red-900 {\n    --gradient-via-color: #771d1d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(119, 29, 29, 0));\n  }\n  .md\\:via-orange-50 {\n    --gradient-via-color: #fff8f1;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 248, 241, 0));\n  }\n  .md\\:via-orange-100 {\n    --gradient-via-color: #feecdc;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 236, 220, 0));\n  }\n  .md\\:via-orange-200 {\n    --gradient-via-color: #fcd9bd;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(252, 217, 189, 0));\n  }\n  .md\\:via-orange-300 {\n    --gradient-via-color: #fdba8c;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 186, 140, 0));\n  }\n  .md\\:via-orange-400 {\n    --gradient-via-color: #ff8a4c;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 138, 76, 0));\n  }\n  .md\\:via-orange-500 {\n    --gradient-via-color: #ff5a1f;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 90, 31, 0));\n  }\n  .md\\:via-orange-600 {\n    --gradient-via-color: #d03801;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(208, 56, 1, 0));\n  }\n  .md\\:via-orange-700 {\n    --gradient-via-color: #b43403;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(180, 52, 3, 0));\n  }\n  .md\\:via-orange-800 {\n    --gradient-via-color: #8a2c0d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(138, 44, 13, 0));\n  }\n  .md\\:via-orange-900 {\n    --gradient-via-color: #73230d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(115, 35, 13, 0));\n  }\n  .md\\:via-yellow-50 {\n    --gradient-via-color: #fdfdea;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 253, 234, 0));\n  }\n  .md\\:via-yellow-100 {\n    --gradient-via-color: #fdf6b2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 246, 178, 0));\n  }\n  .md\\:via-yellow-200 {\n    --gradient-via-color: #fce96a;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(252, 233, 106, 0));\n  }\n  .md\\:via-yellow-300 {\n    --gradient-via-color: #faca15;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(250, 202, 21, 0));\n  }\n  .md\\:via-yellow-400 {\n    --gradient-via-color: #e3a008;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(227, 160, 8, 0));\n  }\n  .md\\:via-yellow-500 {\n    --gradient-via-color: #c27803;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(194, 120, 3, 0));\n  }\n  .md\\:via-yellow-600 {\n    --gradient-via-color: #9f580a;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(159, 88, 10, 0));\n  }\n  .md\\:via-yellow-700 {\n    --gradient-via-color: #8e4b10;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(142, 75, 16, 0));\n  }\n  .md\\:via-yellow-800 {\n    --gradient-via-color: #723b13;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(114, 59, 19, 0));\n  }\n  .md\\:via-yellow-900 {\n    --gradient-via-color: #633112;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(99, 49, 18, 0));\n  }\n  .md\\:via-green-50 {\n    --gradient-via-color: #f3faf7;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(243, 250, 247, 0));\n  }\n  .md\\:via-green-100 {\n    --gradient-via-color: #def7ec;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(222, 247, 236, 0));\n  }\n  .md\\:via-green-200 {\n    --gradient-via-color: #bcf0da;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(188, 240, 218, 0));\n  }\n  .md\\:via-green-300 {\n    --gradient-via-color: #84e1bc;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(132, 225, 188, 0));\n  }\n  .md\\:via-green-400 {\n    --gradient-via-color: #31c48d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(49, 196, 141, 0));\n  }\n  .md\\:via-green-500 {\n    --gradient-via-color: #0e9f6e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(14, 159, 110, 0));\n  }\n  .md\\:via-green-600 {\n    --gradient-via-color: #057a55;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(5, 122, 85, 0));\n  }\n  .md\\:via-green-700 {\n    --gradient-via-color: #046c4e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(4, 108, 78, 0));\n  }\n  .md\\:via-green-800 {\n    --gradient-via-color: #03543f;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(3, 84, 63, 0));\n  }\n  .md\\:via-green-900 {\n    --gradient-via-color: #014737;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(1, 71, 55, 0));\n  }\n  .md\\:via-teal-50 {\n    --gradient-via-color: #edfafa;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(237, 250, 250, 0));\n  }\n  .md\\:via-teal-100 {\n    --gradient-via-color: #d5f5f6;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(213, 245, 246, 0));\n  }\n  .md\\:via-teal-200 {\n    --gradient-via-color: #afecef;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(175, 236, 239, 0));\n  }\n  .md\\:via-teal-300 {\n    --gradient-via-color: #7edce2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(126, 220, 226, 0));\n  }\n  .md\\:via-teal-400 {\n    --gradient-via-color: #16bdca;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(22, 189, 202, 0));\n  }\n  .md\\:via-teal-500 {\n    --gradient-via-color: #0694a2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(6, 148, 162, 0));\n  }\n  .md\\:via-teal-600 {\n    --gradient-via-color: #047481;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(4, 116, 129, 0));\n  }\n  .md\\:via-teal-700 {\n    --gradient-via-color: #036672;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(3, 102, 114, 0));\n  }\n  .md\\:via-teal-800 {\n    --gradient-via-color: #05505c;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(5, 80, 92, 0));\n  }\n  .md\\:via-teal-900 {\n    --gradient-via-color: #014451;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(1, 68, 81, 0));\n  }\n  .md\\:via-blue-50 {\n    --gradient-via-color: #ebf5ff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(235, 245, 255, 0));\n  }\n  .md\\:via-blue-100 {\n    --gradient-via-color: #e1effe;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(225, 239, 254, 0));\n  }\n  .md\\:via-blue-200 {\n    --gradient-via-color: #c3ddfd;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(195, 221, 253, 0));\n  }\n  .md\\:via-blue-300 {\n    --gradient-via-color: #a4cafe;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(164, 202, 254, 0));\n  }\n  .md\\:via-blue-400 {\n    --gradient-via-color: #76a9fa;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(118, 169, 250, 0));\n  }\n  .md\\:via-blue-500 {\n    --gradient-via-color: #3f83f8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(63, 131, 248, 0));\n  }\n  .md\\:via-blue-600 {\n    --gradient-via-color: #1c64f2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(28, 100, 242, 0));\n  }\n  .md\\:via-blue-700 {\n    --gradient-via-color: #1a56db;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(26, 86, 219, 0));\n  }\n  .md\\:via-blue-800 {\n    --gradient-via-color: #1e429f;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(30, 66, 159, 0));\n  }\n  .md\\:via-blue-900 {\n    --gradient-via-color: #233876;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(35, 56, 118, 0));\n  }\n  .md\\:via-indigo-50 {\n    --gradient-via-color: #f0f5ff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(240, 245, 255, 0));\n  }\n  .md\\:via-indigo-100 {\n    --gradient-via-color: #e5edff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(229, 237, 255, 0));\n  }\n  .md\\:via-indigo-200 {\n    --gradient-via-color: #cddbfe;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(205, 219, 254, 0));\n  }\n  .md\\:via-indigo-300 {\n    --gradient-via-color: #b4c6fc;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(180, 198, 252, 0));\n  }\n  .md\\:via-indigo-400 {\n    --gradient-via-color: #8da2fb;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(141, 162, 251, 0));\n  }\n  .md\\:via-indigo-500 {\n    --gradient-via-color: #6875f5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(104, 117, 245, 0));\n  }\n  .md\\:via-indigo-600 {\n    --gradient-via-color: #5850ec;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(88, 80, 236, 0));\n  }\n  .md\\:via-indigo-700 {\n    --gradient-via-color: #5145cd;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(81, 69, 205, 0));\n  }\n  .md\\:via-indigo-800 {\n    --gradient-via-color: #42389d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(66, 56, 157, 0));\n  }\n  .md\\:via-indigo-900 {\n    --gradient-via-color: #362f78;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(54, 47, 120, 0));\n  }\n  .md\\:via-purple-50 {\n    --gradient-via-color: #f6f5ff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(246, 245, 255, 0));\n  }\n  .md\\:via-purple-100 {\n    --gradient-via-color: #edebfe;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(237, 235, 254, 0));\n  }\n  .md\\:via-purple-200 {\n    --gradient-via-color: #dcd7fe;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(220, 215, 254, 0));\n  }\n  .md\\:via-purple-300 {\n    --gradient-via-color: #cabffd;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(202, 191, 253, 0));\n  }\n  .md\\:via-purple-400 {\n    --gradient-via-color: #ac94fa;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(172, 148, 250, 0));\n  }\n  .md\\:via-purple-500 {\n    --gradient-via-color: #9061f9;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(144, 97, 249, 0));\n  }\n  .md\\:via-purple-600 {\n    --gradient-via-color: #7e3af2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(126, 58, 242, 0));\n  }\n  .md\\:via-purple-700 {\n    --gradient-via-color: #6c2bd9;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(108, 43, 217, 0));\n  }\n  .md\\:via-purple-800 {\n    --gradient-via-color: #5521b5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(85, 33, 181, 0));\n  }\n  .md\\:via-purple-900 {\n    --gradient-via-color: #4a1d96;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(74, 29, 150, 0));\n  }\n  .md\\:via-pink-50 {\n    --gradient-via-color: #fdf2f8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 242, 248, 0));\n  }\n  .md\\:via-pink-100 {\n    --gradient-via-color: #fce8f3;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(252, 232, 243, 0));\n  }\n  .md\\:via-pink-200 {\n    --gradient-via-color: #fad1e8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(250, 209, 232, 0));\n  }\n  .md\\:via-pink-300 {\n    --gradient-via-color: #f8b4d9;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(248, 180, 217, 0));\n  }\n  .md\\:via-pink-400 {\n    --gradient-via-color: #f17eb8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(241, 126, 184, 0));\n  }\n  .md\\:via-pink-500 {\n    --gradient-via-color: #e74694;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(231, 70, 148, 0));\n  }\n  .md\\:via-pink-600 {\n    --gradient-via-color: #d61f69;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(214, 31, 105, 0));\n  }\n  .md\\:via-pink-700 {\n    --gradient-via-color: #bf125d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(191, 18, 93, 0));\n  }\n  .md\\:via-pink-800 {\n    --gradient-via-color: #99154b;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(153, 21, 75, 0));\n  }\n  .md\\:via-pink-900 {\n    --gradient-via-color: #751a3d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(117, 26, 61, 0));\n  }\n  .md\\:via-cool-gray-50 {\n    --gradient-via-color: #f8fafc;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(248, 250, 252, 0));\n  }\n  .md\\:via-cool-gray-100 {\n    --gradient-via-color: #f1f5f9;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(241, 245, 249, 0));\n  }\n  .md\\:via-cool-gray-200 {\n    --gradient-via-color: #e2e8f0;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(226, 232, 240, 0));\n  }\n  .md\\:via-cool-gray-300 {\n    --gradient-via-color: #cfd8e3;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(207, 216, 227, 0));\n  }\n  .md\\:via-cool-gray-400 {\n    --gradient-via-color: #97a6ba;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(151, 166, 186, 0));\n  }\n  .md\\:via-cool-gray-500 {\n    --gradient-via-color: #64748b;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(100, 116, 139, 0));\n  }\n  .md\\:via-cool-gray-600 {\n    --gradient-via-color: #475569;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(71, 85, 105, 0));\n  }\n  .md\\:via-cool-gray-700 {\n    --gradient-via-color: #364152;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(54, 65, 82, 0));\n  }\n  .md\\:via-cool-gray-800 {\n    --gradient-via-color: #27303f;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(39, 48, 63, 0));\n  }\n  .md\\:via-cool-gray-900 {\n    --gradient-via-color: #1a202e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(26, 32, 46, 0));\n  }\n  .md\\:to-current {\n    --gradient-to-color: currentColor;\n  }\n  .md\\:to-transparent {\n    --gradient-to-color: transparent;\n  }\n  .md\\:to-white {\n    --gradient-to-color: #ffffff;\n  }\n  .md\\:to-black {\n    --gradient-to-color: #000000;\n  }\n  .md\\:to-gray-50 {\n    --gradient-to-color: #f9fafb;\n  }\n  .md\\:to-gray-100 {\n    --gradient-to-color: #f4f5f7;\n  }\n  .md\\:to-gray-200 {\n    --gradient-to-color: #e5e7eb;\n  }\n  .md\\:to-gray-300 {\n    --gradient-to-color: #d2d6dc;\n  }\n  .md\\:to-gray-400 {\n    --gradient-to-color: #9fa6b2;\n  }\n  .md\\:to-gray-500 {\n    --gradient-to-color: #6b7280;\n  }\n  .md\\:to-gray-600 {\n    --gradient-to-color: #4b5563;\n  }\n  .md\\:to-gray-700 {\n    --gradient-to-color: #374151;\n  }\n  .md\\:to-gray-800 {\n    --gradient-to-color: #252f3f;\n  }\n  .md\\:to-gray-900 {\n    --gradient-to-color: #161e2e;\n  }\n  .md\\:to-red-50 {\n    --gradient-to-color: #fdf2f2;\n  }\n  .md\\:to-red-100 {\n    --gradient-to-color: #fde8e8;\n  }\n  .md\\:to-red-200 {\n    --gradient-to-color: #fbd5d5;\n  }\n  .md\\:to-red-300 {\n    --gradient-to-color: #f8b4b4;\n  }\n  .md\\:to-red-400 {\n    --gradient-to-color: #f98080;\n  }\n  .md\\:to-red-500 {\n    --gradient-to-color: #f05252;\n  }\n  .md\\:to-red-600 {\n    --gradient-to-color: #e02424;\n  }\n  .md\\:to-red-700 {\n    --gradient-to-color: #c81e1e;\n  }\n  .md\\:to-red-800 {\n    --gradient-to-color: #9b1c1c;\n  }\n  .md\\:to-red-900 {\n    --gradient-to-color: #771d1d;\n  }\n  .md\\:to-orange-50 {\n    --gradient-to-color: #fff8f1;\n  }\n  .md\\:to-orange-100 {\n    --gradient-to-color: #feecdc;\n  }\n  .md\\:to-orange-200 {\n    --gradient-to-color: #fcd9bd;\n  }\n  .md\\:to-orange-300 {\n    --gradient-to-color: #fdba8c;\n  }\n  .md\\:to-orange-400 {\n    --gradient-to-color: #ff8a4c;\n  }\n  .md\\:to-orange-500 {\n    --gradient-to-color: #ff5a1f;\n  }\n  .md\\:to-orange-600 {\n    --gradient-to-color: #d03801;\n  }\n  .md\\:to-orange-700 {\n    --gradient-to-color: #b43403;\n  }\n  .md\\:to-orange-800 {\n    --gradient-to-color: #8a2c0d;\n  }\n  .md\\:to-orange-900 {\n    --gradient-to-color: #73230d;\n  }\n  .md\\:to-yellow-50 {\n    --gradient-to-color: #fdfdea;\n  }\n  .md\\:to-yellow-100 {\n    --gradient-to-color: #fdf6b2;\n  }\n  .md\\:to-yellow-200 {\n    --gradient-to-color: #fce96a;\n  }\n  .md\\:to-yellow-300 {\n    --gradient-to-color: #faca15;\n  }\n  .md\\:to-yellow-400 {\n    --gradient-to-color: #e3a008;\n  }\n  .md\\:to-yellow-500 {\n    --gradient-to-color: #c27803;\n  }\n  .md\\:to-yellow-600 {\n    --gradient-to-color: #9f580a;\n  }\n  .md\\:to-yellow-700 {\n    --gradient-to-color: #8e4b10;\n  }\n  .md\\:to-yellow-800 {\n    --gradient-to-color: #723b13;\n  }\n  .md\\:to-yellow-900 {\n    --gradient-to-color: #633112;\n  }\n  .md\\:to-green-50 {\n    --gradient-to-color: #f3faf7;\n  }\n  .md\\:to-green-100 {\n    --gradient-to-color: #def7ec;\n  }\n  .md\\:to-green-200 {\n    --gradient-to-color: #bcf0da;\n  }\n  .md\\:to-green-300 {\n    --gradient-to-color: #84e1bc;\n  }\n  .md\\:to-green-400 {\n    --gradient-to-color: #31c48d;\n  }\n  .md\\:to-green-500 {\n    --gradient-to-color: #0e9f6e;\n  }\n  .md\\:to-green-600 {\n    --gradient-to-color: #057a55;\n  }\n  .md\\:to-green-700 {\n    --gradient-to-color: #046c4e;\n  }\n  .md\\:to-green-800 {\n    --gradient-to-color: #03543f;\n  }\n  .md\\:to-green-900 {\n    --gradient-to-color: #014737;\n  }\n  .md\\:to-teal-50 {\n    --gradient-to-color: #edfafa;\n  }\n  .md\\:to-teal-100 {\n    --gradient-to-color: #d5f5f6;\n  }\n  .md\\:to-teal-200 {\n    --gradient-to-color: #afecef;\n  }\n  .md\\:to-teal-300 {\n    --gradient-to-color: #7edce2;\n  }\n  .md\\:to-teal-400 {\n    --gradient-to-color: #16bdca;\n  }\n  .md\\:to-teal-500 {\n    --gradient-to-color: #0694a2;\n  }\n  .md\\:to-teal-600 {\n    --gradient-to-color: #047481;\n  }\n  .md\\:to-teal-700 {\n    --gradient-to-color: #036672;\n  }\n  .md\\:to-teal-800 {\n    --gradient-to-color: #05505c;\n  }\n  .md\\:to-teal-900 {\n    --gradient-to-color: #014451;\n  }\n  .md\\:to-blue-50 {\n    --gradient-to-color: #ebf5ff;\n  }\n  .md\\:to-blue-100 {\n    --gradient-to-color: #e1effe;\n  }\n  .md\\:to-blue-200 {\n    --gradient-to-color: #c3ddfd;\n  }\n  .md\\:to-blue-300 {\n    --gradient-to-color: #a4cafe;\n  }\n  .md\\:to-blue-400 {\n    --gradient-to-color: #76a9fa;\n  }\n  .md\\:to-blue-500 {\n    --gradient-to-color: #3f83f8;\n  }\n  .md\\:to-blue-600 {\n    --gradient-to-color: #1c64f2;\n  }\n  .md\\:to-blue-700 {\n    --gradient-to-color: #1a56db;\n  }\n  .md\\:to-blue-800 {\n    --gradient-to-color: #1e429f;\n  }\n  .md\\:to-blue-900 {\n    --gradient-to-color: #233876;\n  }\n  .md\\:to-indigo-50 {\n    --gradient-to-color: #f0f5ff;\n  }\n  .md\\:to-indigo-100 {\n    --gradient-to-color: #e5edff;\n  }\n  .md\\:to-indigo-200 {\n    --gradient-to-color: #cddbfe;\n  }\n  .md\\:to-indigo-300 {\n    --gradient-to-color: #b4c6fc;\n  }\n  .md\\:to-indigo-400 {\n    --gradient-to-color: #8da2fb;\n  }\n  .md\\:to-indigo-500 {\n    --gradient-to-color: #6875f5;\n  }\n  .md\\:to-indigo-600 {\n    --gradient-to-color: #5850ec;\n  }\n  .md\\:to-indigo-700 {\n    --gradient-to-color: #5145cd;\n  }\n  .md\\:to-indigo-800 {\n    --gradient-to-color: #42389d;\n  }\n  .md\\:to-indigo-900 {\n    --gradient-to-color: #362f78;\n  }\n  .md\\:to-purple-50 {\n    --gradient-to-color: #f6f5ff;\n  }\n  .md\\:to-purple-100 {\n    --gradient-to-color: #edebfe;\n  }\n  .md\\:to-purple-200 {\n    --gradient-to-color: #dcd7fe;\n  }\n  .md\\:to-purple-300 {\n    --gradient-to-color: #cabffd;\n  }\n  .md\\:to-purple-400 {\n    --gradient-to-color: #ac94fa;\n  }\n  .md\\:to-purple-500 {\n    --gradient-to-color: #9061f9;\n  }\n  .md\\:to-purple-600 {\n    --gradient-to-color: #7e3af2;\n  }\n  .md\\:to-purple-700 {\n    --gradient-to-color: #6c2bd9;\n  }\n  .md\\:to-purple-800 {\n    --gradient-to-color: #5521b5;\n  }\n  .md\\:to-purple-900 {\n    --gradient-to-color: #4a1d96;\n  }\n  .md\\:to-pink-50 {\n    --gradient-to-color: #fdf2f8;\n  }\n  .md\\:to-pink-100 {\n    --gradient-to-color: #fce8f3;\n  }\n  .md\\:to-pink-200 {\n    --gradient-to-color: #fad1e8;\n  }\n  .md\\:to-pink-300 {\n    --gradient-to-color: #f8b4d9;\n  }\n  .md\\:to-pink-400 {\n    --gradient-to-color: #f17eb8;\n  }\n  .md\\:to-pink-500 {\n    --gradient-to-color: #e74694;\n  }\n  .md\\:to-pink-600 {\n    --gradient-to-color: #d61f69;\n  }\n  .md\\:to-pink-700 {\n    --gradient-to-color: #bf125d;\n  }\n  .md\\:to-pink-800 {\n    --gradient-to-color: #99154b;\n  }\n  .md\\:to-pink-900 {\n    --gradient-to-color: #751a3d;\n  }\n  .md\\:to-cool-gray-50 {\n    --gradient-to-color: #f8fafc;\n  }\n  .md\\:to-cool-gray-100 {\n    --gradient-to-color: #f1f5f9;\n  }\n  .md\\:to-cool-gray-200 {\n    --gradient-to-color: #e2e8f0;\n  }\n  .md\\:to-cool-gray-300 {\n    --gradient-to-color: #cfd8e3;\n  }\n  .md\\:to-cool-gray-400 {\n    --gradient-to-color: #97a6ba;\n  }\n  .md\\:to-cool-gray-500 {\n    --gradient-to-color: #64748b;\n  }\n  .md\\:to-cool-gray-600 {\n    --gradient-to-color: #475569;\n  }\n  .md\\:to-cool-gray-700 {\n    --gradient-to-color: #364152;\n  }\n  .md\\:to-cool-gray-800 {\n    --gradient-to-color: #27303f;\n  }\n  .md\\:to-cool-gray-900 {\n    --gradient-to-color: #1a202e;\n  }\n  .md\\:hover\\:from-current:hover {\n    --gradient-from-color: currentColor;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));\n  }\n  .md\\:hover\\:from-transparent:hover {\n    --gradient-from-color: transparent;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0));\n  }\n  .md\\:hover\\:from-white:hover {\n    --gradient-from-color: #ffffff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));\n  }\n  .md\\:hover\\:from-black:hover {\n    --gradient-from-color: #000000;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0));\n  }\n  .md\\:hover\\:from-gray-50:hover {\n    --gradient-from-color: #f9fafb;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(249, 250, 251, 0));\n  }\n  .md\\:hover\\:from-gray-100:hover {\n    --gradient-from-color: #f4f5f7;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(244, 245, 247, 0));\n  }\n  .md\\:hover\\:from-gray-200:hover {\n    --gradient-from-color: #e5e7eb;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(229, 231, 235, 0));\n  }\n  .md\\:hover\\:from-gray-300:hover {\n    --gradient-from-color: #d2d6dc;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(210, 214, 220, 0));\n  }\n  .md\\:hover\\:from-gray-400:hover {\n    --gradient-from-color: #9fa6b2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(159, 166, 178, 0));\n  }\n  .md\\:hover\\:from-gray-500:hover {\n    --gradient-from-color: #6b7280;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(107, 114, 128, 0));\n  }\n  .md\\:hover\\:from-gray-600:hover {\n    --gradient-from-color: #4b5563;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(75, 85, 99, 0));\n  }\n  .md\\:hover\\:from-gray-700:hover {\n    --gradient-from-color: #374151;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(55, 65, 81, 0));\n  }\n  .md\\:hover\\:from-gray-800:hover {\n    --gradient-from-color: #252f3f;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(37, 47, 63, 0));\n  }\n  .md\\:hover\\:from-gray-900:hover {\n    --gradient-from-color: #161e2e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(22, 30, 46, 0));\n  }\n  .md\\:hover\\:from-red-50:hover {\n    --gradient-from-color: #fdf2f2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 242, 242, 0));\n  }\n  .md\\:hover\\:from-red-100:hover {\n    --gradient-from-color: #fde8e8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 232, 232, 0));\n  }\n  .md\\:hover\\:from-red-200:hover {\n    --gradient-from-color: #fbd5d5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(251, 213, 213, 0));\n  }\n  .md\\:hover\\:from-red-300:hover {\n    --gradient-from-color: #f8b4b4;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(248, 180, 180, 0));\n  }\n  .md\\:hover\\:from-red-400:hover {\n    --gradient-from-color: #f98080;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(249, 128, 128, 0));\n  }\n  .md\\:hover\\:from-red-500:hover {\n    --gradient-from-color: #f05252;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(240, 82, 82, 0));\n  }\n  .md\\:hover\\:from-red-600:hover {\n    --gradient-from-color: #e02424;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(224, 36, 36, 0));\n  }\n  .md\\:hover\\:from-red-700:hover {\n    --gradient-from-color: #c81e1e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(200, 30, 30, 0));\n  }\n  .md\\:hover\\:from-red-800:hover {\n    --gradient-from-color: #9b1c1c;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(155, 28, 28, 0));\n  }\n  .md\\:hover\\:from-red-900:hover {\n    --gradient-from-color: #771d1d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(119, 29, 29, 0));\n  }\n  .md\\:hover\\:from-orange-50:hover {\n    --gradient-from-color: #fff8f1;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 248, 241, 0));\n  }\n  .md\\:hover\\:from-orange-100:hover {\n    --gradient-from-color: #feecdc;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 236, 220, 0));\n  }\n  .md\\:hover\\:from-orange-200:hover {\n    --gradient-from-color: #fcd9bd;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(252, 217, 189, 0));\n  }\n  .md\\:hover\\:from-orange-300:hover {\n    --gradient-from-color: #fdba8c;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 186, 140, 0));\n  }\n  .md\\:hover\\:from-orange-400:hover {\n    --gradient-from-color: #ff8a4c;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 138, 76, 0));\n  }\n  .md\\:hover\\:from-orange-500:hover {\n    --gradient-from-color: #ff5a1f;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 90, 31, 0));\n  }\n  .md\\:hover\\:from-orange-600:hover {\n    --gradient-from-color: #d03801;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(208, 56, 1, 0));\n  }\n  .md\\:hover\\:from-orange-700:hover {\n    --gradient-from-color: #b43403;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(180, 52, 3, 0));\n  }\n  .md\\:hover\\:from-orange-800:hover {\n    --gradient-from-color: #8a2c0d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(138, 44, 13, 0));\n  }\n  .md\\:hover\\:from-orange-900:hover {\n    --gradient-from-color: #73230d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(115, 35, 13, 0));\n  }\n  .md\\:hover\\:from-yellow-50:hover {\n    --gradient-from-color: #fdfdea;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 253, 234, 0));\n  }\n  .md\\:hover\\:from-yellow-100:hover {\n    --gradient-from-color: #fdf6b2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 246, 178, 0));\n  }\n  .md\\:hover\\:from-yellow-200:hover {\n    --gradient-from-color: #fce96a;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(252, 233, 106, 0));\n  }\n  .md\\:hover\\:from-yellow-300:hover {\n    --gradient-from-color: #faca15;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(250, 202, 21, 0));\n  }\n  .md\\:hover\\:from-yellow-400:hover {\n    --gradient-from-color: #e3a008;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(227, 160, 8, 0));\n  }\n  .md\\:hover\\:from-yellow-500:hover {\n    --gradient-from-color: #c27803;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(194, 120, 3, 0));\n  }\n  .md\\:hover\\:from-yellow-600:hover {\n    --gradient-from-color: #9f580a;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(159, 88, 10, 0));\n  }\n  .md\\:hover\\:from-yellow-700:hover {\n    --gradient-from-color: #8e4b10;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(142, 75, 16, 0));\n  }\n  .md\\:hover\\:from-yellow-800:hover {\n    --gradient-from-color: #723b13;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(114, 59, 19, 0));\n  }\n  .md\\:hover\\:from-yellow-900:hover {\n    --gradient-from-color: #633112;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(99, 49, 18, 0));\n  }\n  .md\\:hover\\:from-green-50:hover {\n    --gradient-from-color: #f3faf7;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(243, 250, 247, 0));\n  }\n  .md\\:hover\\:from-green-100:hover {\n    --gradient-from-color: #def7ec;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(222, 247, 236, 0));\n  }\n  .md\\:hover\\:from-green-200:hover {\n    --gradient-from-color: #bcf0da;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(188, 240, 218, 0));\n  }\n  .md\\:hover\\:from-green-300:hover {\n    --gradient-from-color: #84e1bc;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(132, 225, 188, 0));\n  }\n  .md\\:hover\\:from-green-400:hover {\n    --gradient-from-color: #31c48d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(49, 196, 141, 0));\n  }\n  .md\\:hover\\:from-green-500:hover {\n    --gradient-from-color: #0e9f6e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(14, 159, 110, 0));\n  }\n  .md\\:hover\\:from-green-600:hover {\n    --gradient-from-color: #057a55;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(5, 122, 85, 0));\n  }\n  .md\\:hover\\:from-green-700:hover {\n    --gradient-from-color: #046c4e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(4, 108, 78, 0));\n  }\n  .md\\:hover\\:from-green-800:hover {\n    --gradient-from-color: #03543f;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(3, 84, 63, 0));\n  }\n  .md\\:hover\\:from-green-900:hover {\n    --gradient-from-color: #014737;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(1, 71, 55, 0));\n  }\n  .md\\:hover\\:from-teal-50:hover {\n    --gradient-from-color: #edfafa;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(237, 250, 250, 0));\n  }\n  .md\\:hover\\:from-teal-100:hover {\n    --gradient-from-color: #d5f5f6;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(213, 245, 246, 0));\n  }\n  .md\\:hover\\:from-teal-200:hover {\n    --gradient-from-color: #afecef;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(175, 236, 239, 0));\n  }\n  .md\\:hover\\:from-teal-300:hover {\n    --gradient-from-color: #7edce2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(126, 220, 226, 0));\n  }\n  .md\\:hover\\:from-teal-400:hover {\n    --gradient-from-color: #16bdca;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(22, 189, 202, 0));\n  }\n  .md\\:hover\\:from-teal-500:hover {\n    --gradient-from-color: #0694a2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(6, 148, 162, 0));\n  }\n  .md\\:hover\\:from-teal-600:hover {\n    --gradient-from-color: #047481;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(4, 116, 129, 0));\n  }\n  .md\\:hover\\:from-teal-700:hover {\n    --gradient-from-color: #036672;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(3, 102, 114, 0));\n  }\n  .md\\:hover\\:from-teal-800:hover {\n    --gradient-from-color: #05505c;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(5, 80, 92, 0));\n  }\n  .md\\:hover\\:from-teal-900:hover {\n    --gradient-from-color: #014451;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(1, 68, 81, 0));\n  }\n  .md\\:hover\\:from-blue-50:hover {\n    --gradient-from-color: #ebf5ff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(235, 245, 255, 0));\n  }\n  .md\\:hover\\:from-blue-100:hover {\n    --gradient-from-color: #e1effe;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(225, 239, 254, 0));\n  }\n  .md\\:hover\\:from-blue-200:hover {\n    --gradient-from-color: #c3ddfd;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(195, 221, 253, 0));\n  }\n  .md\\:hover\\:from-blue-300:hover {\n    --gradient-from-color: #a4cafe;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(164, 202, 254, 0));\n  }\n  .md\\:hover\\:from-blue-400:hover {\n    --gradient-from-color: #76a9fa;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(118, 169, 250, 0));\n  }\n  .md\\:hover\\:from-blue-500:hover {\n    --gradient-from-color: #3f83f8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(63, 131, 248, 0));\n  }\n  .md\\:hover\\:from-blue-600:hover {\n    --gradient-from-color: #1c64f2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(28, 100, 242, 0));\n  }\n  .md\\:hover\\:from-blue-700:hover {\n    --gradient-from-color: #1a56db;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(26, 86, 219, 0));\n  }\n  .md\\:hover\\:from-blue-800:hover {\n    --gradient-from-color: #1e429f;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(30, 66, 159, 0));\n  }\n  .md\\:hover\\:from-blue-900:hover {\n    --gradient-from-color: #233876;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(35, 56, 118, 0));\n  }\n  .md\\:hover\\:from-indigo-50:hover {\n    --gradient-from-color: #f0f5ff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(240, 245, 255, 0));\n  }\n  .md\\:hover\\:from-indigo-100:hover {\n    --gradient-from-color: #e5edff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(229, 237, 255, 0));\n  }\n  .md\\:hover\\:from-indigo-200:hover {\n    --gradient-from-color: #cddbfe;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(205, 219, 254, 0));\n  }\n  .md\\:hover\\:from-indigo-300:hover {\n    --gradient-from-color: #b4c6fc;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(180, 198, 252, 0));\n  }\n  .md\\:hover\\:from-indigo-400:hover {\n    --gradient-from-color: #8da2fb;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(141, 162, 251, 0));\n  }\n  .md\\:hover\\:from-indigo-500:hover {\n    --gradient-from-color: #6875f5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(104, 117, 245, 0));\n  }\n  .md\\:hover\\:from-indigo-600:hover {\n    --gradient-from-color: #5850ec;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(88, 80, 236, 0));\n  }\n  .md\\:hover\\:from-indigo-700:hover {\n    --gradient-from-color: #5145cd;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(81, 69, 205, 0));\n  }\n  .md\\:hover\\:from-indigo-800:hover {\n    --gradient-from-color: #42389d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(66, 56, 157, 0));\n  }\n  .md\\:hover\\:from-indigo-900:hover {\n    --gradient-from-color: #362f78;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(54, 47, 120, 0));\n  }\n  .md\\:hover\\:from-purple-50:hover {\n    --gradient-from-color: #f6f5ff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(246, 245, 255, 0));\n  }\n  .md\\:hover\\:from-purple-100:hover {\n    --gradient-from-color: #edebfe;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(237, 235, 254, 0));\n  }\n  .md\\:hover\\:from-purple-200:hover {\n    --gradient-from-color: #dcd7fe;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(220, 215, 254, 0));\n  }\n  .md\\:hover\\:from-purple-300:hover {\n    --gradient-from-color: #cabffd;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(202, 191, 253, 0));\n  }\n  .md\\:hover\\:from-purple-400:hover {\n    --gradient-from-color: #ac94fa;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(172, 148, 250, 0));\n  }\n  .md\\:hover\\:from-purple-500:hover {\n    --gradient-from-color: #9061f9;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(144, 97, 249, 0));\n  }\n  .md\\:hover\\:from-purple-600:hover {\n    --gradient-from-color: #7e3af2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(126, 58, 242, 0));\n  }\n  .md\\:hover\\:from-purple-700:hover {\n    --gradient-from-color: #6c2bd9;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(108, 43, 217, 0));\n  }\n  .md\\:hover\\:from-purple-800:hover {\n    --gradient-from-color: #5521b5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(85, 33, 181, 0));\n  }\n  .md\\:hover\\:from-purple-900:hover {\n    --gradient-from-color: #4a1d96;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(74, 29, 150, 0));\n  }\n  .md\\:hover\\:from-pink-50:hover {\n    --gradient-from-color: #fdf2f8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 242, 248, 0));\n  }\n  .md\\:hover\\:from-pink-100:hover {\n    --gradient-from-color: #fce8f3;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(252, 232, 243, 0));\n  }\n  .md\\:hover\\:from-pink-200:hover {\n    --gradient-from-color: #fad1e8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(250, 209, 232, 0));\n  }\n  .md\\:hover\\:from-pink-300:hover {\n    --gradient-from-color: #f8b4d9;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(248, 180, 217, 0));\n  }\n  .md\\:hover\\:from-pink-400:hover {\n    --gradient-from-color: #f17eb8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(241, 126, 184, 0));\n  }\n  .md\\:hover\\:from-pink-500:hover {\n    --gradient-from-color: #e74694;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(231, 70, 148, 0));\n  }\n  .md\\:hover\\:from-pink-600:hover {\n    --gradient-from-color: #d61f69;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(214, 31, 105, 0));\n  }\n  .md\\:hover\\:from-pink-700:hover {\n    --gradient-from-color: #bf125d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(191, 18, 93, 0));\n  }\n  .md\\:hover\\:from-pink-800:hover {\n    --gradient-from-color: #99154b;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(153, 21, 75, 0));\n  }\n  .md\\:hover\\:from-pink-900:hover {\n    --gradient-from-color: #751a3d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(117, 26, 61, 0));\n  }\n  .md\\:hover\\:from-cool-gray-50:hover {\n    --gradient-from-color: #f8fafc;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(248, 250, 252, 0));\n  }\n  .md\\:hover\\:from-cool-gray-100:hover {\n    --gradient-from-color: #f1f5f9;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(241, 245, 249, 0));\n  }\n  .md\\:hover\\:from-cool-gray-200:hover {\n    --gradient-from-color: #e2e8f0;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(226, 232, 240, 0));\n  }\n  .md\\:hover\\:from-cool-gray-300:hover {\n    --gradient-from-color: #cfd8e3;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(207, 216, 227, 0));\n  }\n  .md\\:hover\\:from-cool-gray-400:hover {\n    --gradient-from-color: #97a6ba;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(151, 166, 186, 0));\n  }\n  .md\\:hover\\:from-cool-gray-500:hover {\n    --gradient-from-color: #64748b;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(100, 116, 139, 0));\n  }\n  .md\\:hover\\:from-cool-gray-600:hover {\n    --gradient-from-color: #475569;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(71, 85, 105, 0));\n  }\n  .md\\:hover\\:from-cool-gray-700:hover {\n    --gradient-from-color: #364152;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(54, 65, 82, 0));\n  }\n  .md\\:hover\\:from-cool-gray-800:hover {\n    --gradient-from-color: #27303f;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(39, 48, 63, 0));\n  }\n  .md\\:hover\\:from-cool-gray-900:hover {\n    --gradient-from-color: #1a202e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(26, 32, 46, 0));\n  }\n  .md\\:hover\\:via-current:hover {\n    --gradient-via-color: currentColor;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));\n  }\n  .md\\:hover\\:via-transparent:hover {\n    --gradient-via-color: transparent;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0));\n  }\n  .md\\:hover\\:via-white:hover {\n    --gradient-via-color: #ffffff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));\n  }\n  .md\\:hover\\:via-black:hover {\n    --gradient-via-color: #000000;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0));\n  }\n  .md\\:hover\\:via-gray-50:hover {\n    --gradient-via-color: #f9fafb;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(249, 250, 251, 0));\n  }\n  .md\\:hover\\:via-gray-100:hover {\n    --gradient-via-color: #f4f5f7;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(244, 245, 247, 0));\n  }\n  .md\\:hover\\:via-gray-200:hover {\n    --gradient-via-color: #e5e7eb;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(229, 231, 235, 0));\n  }\n  .md\\:hover\\:via-gray-300:hover {\n    --gradient-via-color: #d2d6dc;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(210, 214, 220, 0));\n  }\n  .md\\:hover\\:via-gray-400:hover {\n    --gradient-via-color: #9fa6b2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(159, 166, 178, 0));\n  }\n  .md\\:hover\\:via-gray-500:hover {\n    --gradient-via-color: #6b7280;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(107, 114, 128, 0));\n  }\n  .md\\:hover\\:via-gray-600:hover {\n    --gradient-via-color: #4b5563;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(75, 85, 99, 0));\n  }\n  .md\\:hover\\:via-gray-700:hover {\n    --gradient-via-color: #374151;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(55, 65, 81, 0));\n  }\n  .md\\:hover\\:via-gray-800:hover {\n    --gradient-via-color: #252f3f;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(37, 47, 63, 0));\n  }\n  .md\\:hover\\:via-gray-900:hover {\n    --gradient-via-color: #161e2e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(22, 30, 46, 0));\n  }\n  .md\\:hover\\:via-red-50:hover {\n    --gradient-via-color: #fdf2f2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 242, 242, 0));\n  }\n  .md\\:hover\\:via-red-100:hover {\n    --gradient-via-color: #fde8e8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 232, 232, 0));\n  }\n  .md\\:hover\\:via-red-200:hover {\n    --gradient-via-color: #fbd5d5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(251, 213, 213, 0));\n  }\n  .md\\:hover\\:via-red-300:hover {\n    --gradient-via-color: #f8b4b4;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(248, 180, 180, 0));\n  }\n  .md\\:hover\\:via-red-400:hover {\n    --gradient-via-color: #f98080;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(249, 128, 128, 0));\n  }\n  .md\\:hover\\:via-red-500:hover {\n    --gradient-via-color: #f05252;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(240, 82, 82, 0));\n  }\n  .md\\:hover\\:via-red-600:hover {\n    --gradient-via-color: #e02424;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(224, 36, 36, 0));\n  }\n  .md\\:hover\\:via-red-700:hover {\n    --gradient-via-color: #c81e1e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(200, 30, 30, 0));\n  }\n  .md\\:hover\\:via-red-800:hover {\n    --gradient-via-color: #9b1c1c;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(155, 28, 28, 0));\n  }\n  .md\\:hover\\:via-red-900:hover {\n    --gradient-via-color: #771d1d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(119, 29, 29, 0));\n  }\n  .md\\:hover\\:via-orange-50:hover {\n    --gradient-via-color: #fff8f1;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 248, 241, 0));\n  }\n  .md\\:hover\\:via-orange-100:hover {\n    --gradient-via-color: #feecdc;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 236, 220, 0));\n  }\n  .md\\:hover\\:via-orange-200:hover {\n    --gradient-via-color: #fcd9bd;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(252, 217, 189, 0));\n  }\n  .md\\:hover\\:via-orange-300:hover {\n    --gradient-via-color: #fdba8c;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 186, 140, 0));\n  }\n  .md\\:hover\\:via-orange-400:hover {\n    --gradient-via-color: #ff8a4c;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 138, 76, 0));\n  }\n  .md\\:hover\\:via-orange-500:hover {\n    --gradient-via-color: #ff5a1f;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 90, 31, 0));\n  }\n  .md\\:hover\\:via-orange-600:hover {\n    --gradient-via-color: #d03801;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(208, 56, 1, 0));\n  }\n  .md\\:hover\\:via-orange-700:hover {\n    --gradient-via-color: #b43403;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(180, 52, 3, 0));\n  }\n  .md\\:hover\\:via-orange-800:hover {\n    --gradient-via-color: #8a2c0d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(138, 44, 13, 0));\n  }\n  .md\\:hover\\:via-orange-900:hover {\n    --gradient-via-color: #73230d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(115, 35, 13, 0));\n  }\n  .md\\:hover\\:via-yellow-50:hover {\n    --gradient-via-color: #fdfdea;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 253, 234, 0));\n  }\n  .md\\:hover\\:via-yellow-100:hover {\n    --gradient-via-color: #fdf6b2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 246, 178, 0));\n  }\n  .md\\:hover\\:via-yellow-200:hover {\n    --gradient-via-color: #fce96a;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(252, 233, 106, 0));\n  }\n  .md\\:hover\\:via-yellow-300:hover {\n    --gradient-via-color: #faca15;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(250, 202, 21, 0));\n  }\n  .md\\:hover\\:via-yellow-400:hover {\n    --gradient-via-color: #e3a008;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(227, 160, 8, 0));\n  }\n  .md\\:hover\\:via-yellow-500:hover {\n    --gradient-via-color: #c27803;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(194, 120, 3, 0));\n  }\n  .md\\:hover\\:via-yellow-600:hover {\n    --gradient-via-color: #9f580a;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(159, 88, 10, 0));\n  }\n  .md\\:hover\\:via-yellow-700:hover {\n    --gradient-via-color: #8e4b10;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(142, 75, 16, 0));\n  }\n  .md\\:hover\\:via-yellow-800:hover {\n    --gradient-via-color: #723b13;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(114, 59, 19, 0));\n  }\n  .md\\:hover\\:via-yellow-900:hover {\n    --gradient-via-color: #633112;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(99, 49, 18, 0));\n  }\n  .md\\:hover\\:via-green-50:hover {\n    --gradient-via-color: #f3faf7;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(243, 250, 247, 0));\n  }\n  .md\\:hover\\:via-green-100:hover {\n    --gradient-via-color: #def7ec;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(222, 247, 236, 0));\n  }\n  .md\\:hover\\:via-green-200:hover {\n    --gradient-via-color: #bcf0da;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(188, 240, 218, 0));\n  }\n  .md\\:hover\\:via-green-300:hover {\n    --gradient-via-color: #84e1bc;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(132, 225, 188, 0));\n  }\n  .md\\:hover\\:via-green-400:hover {\n    --gradient-via-color: #31c48d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(49, 196, 141, 0));\n  }\n  .md\\:hover\\:via-green-500:hover {\n    --gradient-via-color: #0e9f6e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(14, 159, 110, 0));\n  }\n  .md\\:hover\\:via-green-600:hover {\n    --gradient-via-color: #057a55;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(5, 122, 85, 0));\n  }\n  .md\\:hover\\:via-green-700:hover {\n    --gradient-via-color: #046c4e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(4, 108, 78, 0));\n  }\n  .md\\:hover\\:via-green-800:hover {\n    --gradient-via-color: #03543f;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(3, 84, 63, 0));\n  }\n  .md\\:hover\\:via-green-900:hover {\n    --gradient-via-color: #014737;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(1, 71, 55, 0));\n  }\n  .md\\:hover\\:via-teal-50:hover {\n    --gradient-via-color: #edfafa;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(237, 250, 250, 0));\n  }\n  .md\\:hover\\:via-teal-100:hover {\n    --gradient-via-color: #d5f5f6;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(213, 245, 246, 0));\n  }\n  .md\\:hover\\:via-teal-200:hover {\n    --gradient-via-color: #afecef;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(175, 236, 239, 0));\n  }\n  .md\\:hover\\:via-teal-300:hover {\n    --gradient-via-color: #7edce2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(126, 220, 226, 0));\n  }\n  .md\\:hover\\:via-teal-400:hover {\n    --gradient-via-color: #16bdca;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(22, 189, 202, 0));\n  }\n  .md\\:hover\\:via-teal-500:hover {\n    --gradient-via-color: #0694a2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(6, 148, 162, 0));\n  }\n  .md\\:hover\\:via-teal-600:hover {\n    --gradient-via-color: #047481;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(4, 116, 129, 0));\n  }\n  .md\\:hover\\:via-teal-700:hover {\n    --gradient-via-color: #036672;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(3, 102, 114, 0));\n  }\n  .md\\:hover\\:via-teal-800:hover {\n    --gradient-via-color: #05505c;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(5, 80, 92, 0));\n  }\n  .md\\:hover\\:via-teal-900:hover {\n    --gradient-via-color: #014451;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(1, 68, 81, 0));\n  }\n  .md\\:hover\\:via-blue-50:hover {\n    --gradient-via-color: #ebf5ff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(235, 245, 255, 0));\n  }\n  .md\\:hover\\:via-blue-100:hover {\n    --gradient-via-color: #e1effe;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(225, 239, 254, 0));\n  }\n  .md\\:hover\\:via-blue-200:hover {\n    --gradient-via-color: #c3ddfd;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(195, 221, 253, 0));\n  }\n  .md\\:hover\\:via-blue-300:hover {\n    --gradient-via-color: #a4cafe;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(164, 202, 254, 0));\n  }\n  .md\\:hover\\:via-blue-400:hover {\n    --gradient-via-color: #76a9fa;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(118, 169, 250, 0));\n  }\n  .md\\:hover\\:via-blue-500:hover {\n    --gradient-via-color: #3f83f8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(63, 131, 248, 0));\n  }\n  .md\\:hover\\:via-blue-600:hover {\n    --gradient-via-color: #1c64f2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(28, 100, 242, 0));\n  }\n  .md\\:hover\\:via-blue-700:hover {\n    --gradient-via-color: #1a56db;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(26, 86, 219, 0));\n  }\n  .md\\:hover\\:via-blue-800:hover {\n    --gradient-via-color: #1e429f;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(30, 66, 159, 0));\n  }\n  .md\\:hover\\:via-blue-900:hover {\n    --gradient-via-color: #233876;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(35, 56, 118, 0));\n  }\n  .md\\:hover\\:via-indigo-50:hover {\n    --gradient-via-color: #f0f5ff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(240, 245, 255, 0));\n  }\n  .md\\:hover\\:via-indigo-100:hover {\n    --gradient-via-color: #e5edff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(229, 237, 255, 0));\n  }\n  .md\\:hover\\:via-indigo-200:hover {\n    --gradient-via-color: #cddbfe;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(205, 219, 254, 0));\n  }\n  .md\\:hover\\:via-indigo-300:hover {\n    --gradient-via-color: #b4c6fc;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(180, 198, 252, 0));\n  }\n  .md\\:hover\\:via-indigo-400:hover {\n    --gradient-via-color: #8da2fb;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(141, 162, 251, 0));\n  }\n  .md\\:hover\\:via-indigo-500:hover {\n    --gradient-via-color: #6875f5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(104, 117, 245, 0));\n  }\n  .md\\:hover\\:via-indigo-600:hover {\n    --gradient-via-color: #5850ec;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(88, 80, 236, 0));\n  }\n  .md\\:hover\\:via-indigo-700:hover {\n    --gradient-via-color: #5145cd;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(81, 69, 205, 0));\n  }\n  .md\\:hover\\:via-indigo-800:hover {\n    --gradient-via-color: #42389d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(66, 56, 157, 0));\n  }\n  .md\\:hover\\:via-indigo-900:hover {\n    --gradient-via-color: #362f78;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(54, 47, 120, 0));\n  }\n  .md\\:hover\\:via-purple-50:hover {\n    --gradient-via-color: #f6f5ff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(246, 245, 255, 0));\n  }\n  .md\\:hover\\:via-purple-100:hover {\n    --gradient-via-color: #edebfe;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(237, 235, 254, 0));\n  }\n  .md\\:hover\\:via-purple-200:hover {\n    --gradient-via-color: #dcd7fe;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(220, 215, 254, 0));\n  }\n  .md\\:hover\\:via-purple-300:hover {\n    --gradient-via-color: #cabffd;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(202, 191, 253, 0));\n  }\n  .md\\:hover\\:via-purple-400:hover {\n    --gradient-via-color: #ac94fa;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(172, 148, 250, 0));\n  }\n  .md\\:hover\\:via-purple-500:hover {\n    --gradient-via-color: #9061f9;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(144, 97, 249, 0));\n  }\n  .md\\:hover\\:via-purple-600:hover {\n    --gradient-via-color: #7e3af2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(126, 58, 242, 0));\n  }\n  .md\\:hover\\:via-purple-700:hover {\n    --gradient-via-color: #6c2bd9;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(108, 43, 217, 0));\n  }\n  .md\\:hover\\:via-purple-800:hover {\n    --gradient-via-color: #5521b5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(85, 33, 181, 0));\n  }\n  .md\\:hover\\:via-purple-900:hover {\n    --gradient-via-color: #4a1d96;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(74, 29, 150, 0));\n  }\n  .md\\:hover\\:via-pink-50:hover {\n    --gradient-via-color: #fdf2f8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 242, 248, 0));\n  }\n  .md\\:hover\\:via-pink-100:hover {\n    --gradient-via-color: #fce8f3;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(252, 232, 243, 0));\n  }\n  .md\\:hover\\:via-pink-200:hover {\n    --gradient-via-color: #fad1e8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(250, 209, 232, 0));\n  }\n  .md\\:hover\\:via-pink-300:hover {\n    --gradient-via-color: #f8b4d9;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(248, 180, 217, 0));\n  }\n  .md\\:hover\\:via-pink-400:hover {\n    --gradient-via-color: #f17eb8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(241, 126, 184, 0));\n  }\n  .md\\:hover\\:via-pink-500:hover {\n    --gradient-via-color: #e74694;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(231, 70, 148, 0));\n  }\n  .md\\:hover\\:via-pink-600:hover {\n    --gradient-via-color: #d61f69;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(214, 31, 105, 0));\n  }\n  .md\\:hover\\:via-pink-700:hover {\n    --gradient-via-color: #bf125d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(191, 18, 93, 0));\n  }\n  .md\\:hover\\:via-pink-800:hover {\n    --gradient-via-color: #99154b;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(153, 21, 75, 0));\n  }\n  .md\\:hover\\:via-pink-900:hover {\n    --gradient-via-color: #751a3d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(117, 26, 61, 0));\n  }\n  .md\\:hover\\:via-cool-gray-50:hover {\n    --gradient-via-color: #f8fafc;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(248, 250, 252, 0));\n  }\n  .md\\:hover\\:via-cool-gray-100:hover {\n    --gradient-via-color: #f1f5f9;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(241, 245, 249, 0));\n  }\n  .md\\:hover\\:via-cool-gray-200:hover {\n    --gradient-via-color: #e2e8f0;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(226, 232, 240, 0));\n  }\n  .md\\:hover\\:via-cool-gray-300:hover {\n    --gradient-via-color: #cfd8e3;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(207, 216, 227, 0));\n  }\n  .md\\:hover\\:via-cool-gray-400:hover {\n    --gradient-via-color: #97a6ba;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(151, 166, 186, 0));\n  }\n  .md\\:hover\\:via-cool-gray-500:hover {\n    --gradient-via-color: #64748b;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(100, 116, 139, 0));\n  }\n  .md\\:hover\\:via-cool-gray-600:hover {\n    --gradient-via-color: #475569;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(71, 85, 105, 0));\n  }\n  .md\\:hover\\:via-cool-gray-700:hover {\n    --gradient-via-color: #364152;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(54, 65, 82, 0));\n  }\n  .md\\:hover\\:via-cool-gray-800:hover {\n    --gradient-via-color: #27303f;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(39, 48, 63, 0));\n  }\n  .md\\:hover\\:via-cool-gray-900:hover {\n    --gradient-via-color: #1a202e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(26, 32, 46, 0));\n  }\n  .md\\:hover\\:to-current:hover {\n    --gradient-to-color: currentColor;\n  }\n  .md\\:hover\\:to-transparent:hover {\n    --gradient-to-color: transparent;\n  }\n  .md\\:hover\\:to-white:hover {\n    --gradient-to-color: #ffffff;\n  }\n  .md\\:hover\\:to-black:hover {\n    --gradient-to-color: #000000;\n  }\n  .md\\:hover\\:to-gray-50:hover {\n    --gradient-to-color: #f9fafb;\n  }\n  .md\\:hover\\:to-gray-100:hover {\n    --gradient-to-color: #f4f5f7;\n  }\n  .md\\:hover\\:to-gray-200:hover {\n    --gradient-to-color: #e5e7eb;\n  }\n  .md\\:hover\\:to-gray-300:hover {\n    --gradient-to-color: #d2d6dc;\n  }\n  .md\\:hover\\:to-gray-400:hover {\n    --gradient-to-color: #9fa6b2;\n  }\n  .md\\:hover\\:to-gray-500:hover {\n    --gradient-to-color: #6b7280;\n  }\n  .md\\:hover\\:to-gray-600:hover {\n    --gradient-to-color: #4b5563;\n  }\n  .md\\:hover\\:to-gray-700:hover {\n    --gradient-to-color: #374151;\n  }\n  .md\\:hover\\:to-gray-800:hover {\n    --gradient-to-color: #252f3f;\n  }\n  .md\\:hover\\:to-gray-900:hover {\n    --gradient-to-color: #161e2e;\n  }\n  .md\\:hover\\:to-red-50:hover {\n    --gradient-to-color: #fdf2f2;\n  }\n  .md\\:hover\\:to-red-100:hover {\n    --gradient-to-color: #fde8e8;\n  }\n  .md\\:hover\\:to-red-200:hover {\n    --gradient-to-color: #fbd5d5;\n  }\n  .md\\:hover\\:to-red-300:hover {\n    --gradient-to-color: #f8b4b4;\n  }\n  .md\\:hover\\:to-red-400:hover {\n    --gradient-to-color: #f98080;\n  }\n  .md\\:hover\\:to-red-500:hover {\n    --gradient-to-color: #f05252;\n  }\n  .md\\:hover\\:to-red-600:hover {\n    --gradient-to-color: #e02424;\n  }\n  .md\\:hover\\:to-red-700:hover {\n    --gradient-to-color: #c81e1e;\n  }\n  .md\\:hover\\:to-red-800:hover {\n    --gradient-to-color: #9b1c1c;\n  }\n  .md\\:hover\\:to-red-900:hover {\n    --gradient-to-color: #771d1d;\n  }\n  .md\\:hover\\:to-orange-50:hover {\n    --gradient-to-color: #fff8f1;\n  }\n  .md\\:hover\\:to-orange-100:hover {\n    --gradient-to-color: #feecdc;\n  }\n  .md\\:hover\\:to-orange-200:hover {\n    --gradient-to-color: #fcd9bd;\n  }\n  .md\\:hover\\:to-orange-300:hover {\n    --gradient-to-color: #fdba8c;\n  }\n  .md\\:hover\\:to-orange-400:hover {\n    --gradient-to-color: #ff8a4c;\n  }\n  .md\\:hover\\:to-orange-500:hover {\n    --gradient-to-color: #ff5a1f;\n  }\n  .md\\:hover\\:to-orange-600:hover {\n    --gradient-to-color: #d03801;\n  }\n  .md\\:hover\\:to-orange-700:hover {\n    --gradient-to-color: #b43403;\n  }\n  .md\\:hover\\:to-orange-800:hover {\n    --gradient-to-color: #8a2c0d;\n  }\n  .md\\:hover\\:to-orange-900:hover {\n    --gradient-to-color: #73230d;\n  }\n  .md\\:hover\\:to-yellow-50:hover {\n    --gradient-to-color: #fdfdea;\n  }\n  .md\\:hover\\:to-yellow-100:hover {\n    --gradient-to-color: #fdf6b2;\n  }\n  .md\\:hover\\:to-yellow-200:hover {\n    --gradient-to-color: #fce96a;\n  }\n  .md\\:hover\\:to-yellow-300:hover {\n    --gradient-to-color: #faca15;\n  }\n  .md\\:hover\\:to-yellow-400:hover {\n    --gradient-to-color: #e3a008;\n  }\n  .md\\:hover\\:to-yellow-500:hover {\n    --gradient-to-color: #c27803;\n  }\n  .md\\:hover\\:to-yellow-600:hover {\n    --gradient-to-color: #9f580a;\n  }\n  .md\\:hover\\:to-yellow-700:hover {\n    --gradient-to-color: #8e4b10;\n  }\n  .md\\:hover\\:to-yellow-800:hover {\n    --gradient-to-color: #723b13;\n  }\n  .md\\:hover\\:to-yellow-900:hover {\n    --gradient-to-color: #633112;\n  }\n  .md\\:hover\\:to-green-50:hover {\n    --gradient-to-color: #f3faf7;\n  }\n  .md\\:hover\\:to-green-100:hover {\n    --gradient-to-color: #def7ec;\n  }\n  .md\\:hover\\:to-green-200:hover {\n    --gradient-to-color: #bcf0da;\n  }\n  .md\\:hover\\:to-green-300:hover {\n    --gradient-to-color: #84e1bc;\n  }\n  .md\\:hover\\:to-green-400:hover {\n    --gradient-to-color: #31c48d;\n  }\n  .md\\:hover\\:to-green-500:hover {\n    --gradient-to-color: #0e9f6e;\n  }\n  .md\\:hover\\:to-green-600:hover {\n    --gradient-to-color: #057a55;\n  }\n  .md\\:hover\\:to-green-700:hover {\n    --gradient-to-color: #046c4e;\n  }\n  .md\\:hover\\:to-green-800:hover {\n    --gradient-to-color: #03543f;\n  }\n  .md\\:hover\\:to-green-900:hover {\n    --gradient-to-color: #014737;\n  }\n  .md\\:hover\\:to-teal-50:hover {\n    --gradient-to-color: #edfafa;\n  }\n  .md\\:hover\\:to-teal-100:hover {\n    --gradient-to-color: #d5f5f6;\n  }\n  .md\\:hover\\:to-teal-200:hover {\n    --gradient-to-color: #afecef;\n  }\n  .md\\:hover\\:to-teal-300:hover {\n    --gradient-to-color: #7edce2;\n  }\n  .md\\:hover\\:to-teal-400:hover {\n    --gradient-to-color: #16bdca;\n  }\n  .md\\:hover\\:to-teal-500:hover {\n    --gradient-to-color: #0694a2;\n  }\n  .md\\:hover\\:to-teal-600:hover {\n    --gradient-to-color: #047481;\n  }\n  .md\\:hover\\:to-teal-700:hover {\n    --gradient-to-color: #036672;\n  }\n  .md\\:hover\\:to-teal-800:hover {\n    --gradient-to-color: #05505c;\n  }\n  .md\\:hover\\:to-teal-900:hover {\n    --gradient-to-color: #014451;\n  }\n  .md\\:hover\\:to-blue-50:hover {\n    --gradient-to-color: #ebf5ff;\n  }\n  .md\\:hover\\:to-blue-100:hover {\n    --gradient-to-color: #e1effe;\n  }\n  .md\\:hover\\:to-blue-200:hover {\n    --gradient-to-color: #c3ddfd;\n  }\n  .md\\:hover\\:to-blue-300:hover {\n    --gradient-to-color: #a4cafe;\n  }\n  .md\\:hover\\:to-blue-400:hover {\n    --gradient-to-color: #76a9fa;\n  }\n  .md\\:hover\\:to-blue-500:hover {\n    --gradient-to-color: #3f83f8;\n  }\n  .md\\:hover\\:to-blue-600:hover {\n    --gradient-to-color: #1c64f2;\n  }\n  .md\\:hover\\:to-blue-700:hover {\n    --gradient-to-color: #1a56db;\n  }\n  .md\\:hover\\:to-blue-800:hover {\n    --gradient-to-color: #1e429f;\n  }\n  .md\\:hover\\:to-blue-900:hover {\n    --gradient-to-color: #233876;\n  }\n  .md\\:hover\\:to-indigo-50:hover {\n    --gradient-to-color: #f0f5ff;\n  }\n  .md\\:hover\\:to-indigo-100:hover {\n    --gradient-to-color: #e5edff;\n  }\n  .md\\:hover\\:to-indigo-200:hover {\n    --gradient-to-color: #cddbfe;\n  }\n  .md\\:hover\\:to-indigo-300:hover {\n    --gradient-to-color: #b4c6fc;\n  }\n  .md\\:hover\\:to-indigo-400:hover {\n    --gradient-to-color: #8da2fb;\n  }\n  .md\\:hover\\:to-indigo-500:hover {\n    --gradient-to-color: #6875f5;\n  }\n  .md\\:hover\\:to-indigo-600:hover {\n    --gradient-to-color: #5850ec;\n  }\n  .md\\:hover\\:to-indigo-700:hover {\n    --gradient-to-color: #5145cd;\n  }\n  .md\\:hover\\:to-indigo-800:hover {\n    --gradient-to-color: #42389d;\n  }\n  .md\\:hover\\:to-indigo-900:hover {\n    --gradient-to-color: #362f78;\n  }\n  .md\\:hover\\:to-purple-50:hover {\n    --gradient-to-color: #f6f5ff;\n  }\n  .md\\:hover\\:to-purple-100:hover {\n    --gradient-to-color: #edebfe;\n  }\n  .md\\:hover\\:to-purple-200:hover {\n    --gradient-to-color: #dcd7fe;\n  }\n  .md\\:hover\\:to-purple-300:hover {\n    --gradient-to-color: #cabffd;\n  }\n  .md\\:hover\\:to-purple-400:hover {\n    --gradient-to-color: #ac94fa;\n  }\n  .md\\:hover\\:to-purple-500:hover {\n    --gradient-to-color: #9061f9;\n  }\n  .md\\:hover\\:to-purple-600:hover {\n    --gradient-to-color: #7e3af2;\n  }\n  .md\\:hover\\:to-purple-700:hover {\n    --gradient-to-color: #6c2bd9;\n  }\n  .md\\:hover\\:to-purple-800:hover {\n    --gradient-to-color: #5521b5;\n  }\n  .md\\:hover\\:to-purple-900:hover {\n    --gradient-to-color: #4a1d96;\n  }\n  .md\\:hover\\:to-pink-50:hover {\n    --gradient-to-color: #fdf2f8;\n  }\n  .md\\:hover\\:to-pink-100:hover {\n    --gradient-to-color: #fce8f3;\n  }\n  .md\\:hover\\:to-pink-200:hover {\n    --gradient-to-color: #fad1e8;\n  }\n  .md\\:hover\\:to-pink-300:hover {\n    --gradient-to-color: #f8b4d9;\n  }\n  .md\\:hover\\:to-pink-400:hover {\n    --gradient-to-color: #f17eb8;\n  }\n  .md\\:hover\\:to-pink-500:hover {\n    --gradient-to-color: #e74694;\n  }\n  .md\\:hover\\:to-pink-600:hover {\n    --gradient-to-color: #d61f69;\n  }\n  .md\\:hover\\:to-pink-700:hover {\n    --gradient-to-color: #bf125d;\n  }\n  .md\\:hover\\:to-pink-800:hover {\n    --gradient-to-color: #99154b;\n  }\n  .md\\:hover\\:to-pink-900:hover {\n    --gradient-to-color: #751a3d;\n  }\n  .md\\:hover\\:to-cool-gray-50:hover {\n    --gradient-to-color: #f8fafc;\n  }\n  .md\\:hover\\:to-cool-gray-100:hover {\n    --gradient-to-color: #f1f5f9;\n  }\n  .md\\:hover\\:to-cool-gray-200:hover {\n    --gradient-to-color: #e2e8f0;\n  }\n  .md\\:hover\\:to-cool-gray-300:hover {\n    --gradient-to-color: #cfd8e3;\n  }\n  .md\\:hover\\:to-cool-gray-400:hover {\n    --gradient-to-color: #97a6ba;\n  }\n  .md\\:hover\\:to-cool-gray-500:hover {\n    --gradient-to-color: #64748b;\n  }\n  .md\\:hover\\:to-cool-gray-600:hover {\n    --gradient-to-color: #475569;\n  }\n  .md\\:hover\\:to-cool-gray-700:hover {\n    --gradient-to-color: #364152;\n  }\n  .md\\:hover\\:to-cool-gray-800:hover {\n    --gradient-to-color: #27303f;\n  }\n  .md\\:hover\\:to-cool-gray-900:hover {\n    --gradient-to-color: #1a202e;\n  }\n  .md\\:focus\\:from-current:focus {\n    --gradient-from-color: currentColor;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));\n  }\n  .md\\:focus\\:from-transparent:focus {\n    --gradient-from-color: transparent;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0));\n  }\n  .md\\:focus\\:from-white:focus {\n    --gradient-from-color: #ffffff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));\n  }\n  .md\\:focus\\:from-black:focus {\n    --gradient-from-color: #000000;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0));\n  }\n  .md\\:focus\\:from-gray-50:focus {\n    --gradient-from-color: #f9fafb;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(249, 250, 251, 0));\n  }\n  .md\\:focus\\:from-gray-100:focus {\n    --gradient-from-color: #f4f5f7;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(244, 245, 247, 0));\n  }\n  .md\\:focus\\:from-gray-200:focus {\n    --gradient-from-color: #e5e7eb;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(229, 231, 235, 0));\n  }\n  .md\\:focus\\:from-gray-300:focus {\n    --gradient-from-color: #d2d6dc;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(210, 214, 220, 0));\n  }\n  .md\\:focus\\:from-gray-400:focus {\n    --gradient-from-color: #9fa6b2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(159, 166, 178, 0));\n  }\n  .md\\:focus\\:from-gray-500:focus {\n    --gradient-from-color: #6b7280;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(107, 114, 128, 0));\n  }\n  .md\\:focus\\:from-gray-600:focus {\n    --gradient-from-color: #4b5563;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(75, 85, 99, 0));\n  }\n  .md\\:focus\\:from-gray-700:focus {\n    --gradient-from-color: #374151;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(55, 65, 81, 0));\n  }\n  .md\\:focus\\:from-gray-800:focus {\n    --gradient-from-color: #252f3f;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(37, 47, 63, 0));\n  }\n  .md\\:focus\\:from-gray-900:focus {\n    --gradient-from-color: #161e2e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(22, 30, 46, 0));\n  }\n  .md\\:focus\\:from-red-50:focus {\n    --gradient-from-color: #fdf2f2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 242, 242, 0));\n  }\n  .md\\:focus\\:from-red-100:focus {\n    --gradient-from-color: #fde8e8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 232, 232, 0));\n  }\n  .md\\:focus\\:from-red-200:focus {\n    --gradient-from-color: #fbd5d5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(251, 213, 213, 0));\n  }\n  .md\\:focus\\:from-red-300:focus {\n    --gradient-from-color: #f8b4b4;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(248, 180, 180, 0));\n  }\n  .md\\:focus\\:from-red-400:focus {\n    --gradient-from-color: #f98080;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(249, 128, 128, 0));\n  }\n  .md\\:focus\\:from-red-500:focus {\n    --gradient-from-color: #f05252;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(240, 82, 82, 0));\n  }\n  .md\\:focus\\:from-red-600:focus {\n    --gradient-from-color: #e02424;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(224, 36, 36, 0));\n  }\n  .md\\:focus\\:from-red-700:focus {\n    --gradient-from-color: #c81e1e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(200, 30, 30, 0));\n  }\n  .md\\:focus\\:from-red-800:focus {\n    --gradient-from-color: #9b1c1c;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(155, 28, 28, 0));\n  }\n  .md\\:focus\\:from-red-900:focus {\n    --gradient-from-color: #771d1d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(119, 29, 29, 0));\n  }\n  .md\\:focus\\:from-orange-50:focus {\n    --gradient-from-color: #fff8f1;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 248, 241, 0));\n  }\n  .md\\:focus\\:from-orange-100:focus {\n    --gradient-from-color: #feecdc;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 236, 220, 0));\n  }\n  .md\\:focus\\:from-orange-200:focus {\n    --gradient-from-color: #fcd9bd;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(252, 217, 189, 0));\n  }\n  .md\\:focus\\:from-orange-300:focus {\n    --gradient-from-color: #fdba8c;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 186, 140, 0));\n  }\n  .md\\:focus\\:from-orange-400:focus {\n    --gradient-from-color: #ff8a4c;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 138, 76, 0));\n  }\n  .md\\:focus\\:from-orange-500:focus {\n    --gradient-from-color: #ff5a1f;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 90, 31, 0));\n  }\n  .md\\:focus\\:from-orange-600:focus {\n    --gradient-from-color: #d03801;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(208, 56, 1, 0));\n  }\n  .md\\:focus\\:from-orange-700:focus {\n    --gradient-from-color: #b43403;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(180, 52, 3, 0));\n  }\n  .md\\:focus\\:from-orange-800:focus {\n    --gradient-from-color: #8a2c0d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(138, 44, 13, 0));\n  }\n  .md\\:focus\\:from-orange-900:focus {\n    --gradient-from-color: #73230d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(115, 35, 13, 0));\n  }\n  .md\\:focus\\:from-yellow-50:focus {\n    --gradient-from-color: #fdfdea;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 253, 234, 0));\n  }\n  .md\\:focus\\:from-yellow-100:focus {\n    --gradient-from-color: #fdf6b2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 246, 178, 0));\n  }\n  .md\\:focus\\:from-yellow-200:focus {\n    --gradient-from-color: #fce96a;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(252, 233, 106, 0));\n  }\n  .md\\:focus\\:from-yellow-300:focus {\n    --gradient-from-color: #faca15;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(250, 202, 21, 0));\n  }\n  .md\\:focus\\:from-yellow-400:focus {\n    --gradient-from-color: #e3a008;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(227, 160, 8, 0));\n  }\n  .md\\:focus\\:from-yellow-500:focus {\n    --gradient-from-color: #c27803;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(194, 120, 3, 0));\n  }\n  .md\\:focus\\:from-yellow-600:focus {\n    --gradient-from-color: #9f580a;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(159, 88, 10, 0));\n  }\n  .md\\:focus\\:from-yellow-700:focus {\n    --gradient-from-color: #8e4b10;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(142, 75, 16, 0));\n  }\n  .md\\:focus\\:from-yellow-800:focus {\n    --gradient-from-color: #723b13;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(114, 59, 19, 0));\n  }\n  .md\\:focus\\:from-yellow-900:focus {\n    --gradient-from-color: #633112;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(99, 49, 18, 0));\n  }\n  .md\\:focus\\:from-green-50:focus {\n    --gradient-from-color: #f3faf7;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(243, 250, 247, 0));\n  }\n  .md\\:focus\\:from-green-100:focus {\n    --gradient-from-color: #def7ec;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(222, 247, 236, 0));\n  }\n  .md\\:focus\\:from-green-200:focus {\n    --gradient-from-color: #bcf0da;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(188, 240, 218, 0));\n  }\n  .md\\:focus\\:from-green-300:focus {\n    --gradient-from-color: #84e1bc;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(132, 225, 188, 0));\n  }\n  .md\\:focus\\:from-green-400:focus {\n    --gradient-from-color: #31c48d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(49, 196, 141, 0));\n  }\n  .md\\:focus\\:from-green-500:focus {\n    --gradient-from-color: #0e9f6e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(14, 159, 110, 0));\n  }\n  .md\\:focus\\:from-green-600:focus {\n    --gradient-from-color: #057a55;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(5, 122, 85, 0));\n  }\n  .md\\:focus\\:from-green-700:focus {\n    --gradient-from-color: #046c4e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(4, 108, 78, 0));\n  }\n  .md\\:focus\\:from-green-800:focus {\n    --gradient-from-color: #03543f;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(3, 84, 63, 0));\n  }\n  .md\\:focus\\:from-green-900:focus {\n    --gradient-from-color: #014737;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(1, 71, 55, 0));\n  }\n  .md\\:focus\\:from-teal-50:focus {\n    --gradient-from-color: #edfafa;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(237, 250, 250, 0));\n  }\n  .md\\:focus\\:from-teal-100:focus {\n    --gradient-from-color: #d5f5f6;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(213, 245, 246, 0));\n  }\n  .md\\:focus\\:from-teal-200:focus {\n    --gradient-from-color: #afecef;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(175, 236, 239, 0));\n  }\n  .md\\:focus\\:from-teal-300:focus {\n    --gradient-from-color: #7edce2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(126, 220, 226, 0));\n  }\n  .md\\:focus\\:from-teal-400:focus {\n    --gradient-from-color: #16bdca;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(22, 189, 202, 0));\n  }\n  .md\\:focus\\:from-teal-500:focus {\n    --gradient-from-color: #0694a2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(6, 148, 162, 0));\n  }\n  .md\\:focus\\:from-teal-600:focus {\n    --gradient-from-color: #047481;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(4, 116, 129, 0));\n  }\n  .md\\:focus\\:from-teal-700:focus {\n    --gradient-from-color: #036672;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(3, 102, 114, 0));\n  }\n  .md\\:focus\\:from-teal-800:focus {\n    --gradient-from-color: #05505c;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(5, 80, 92, 0));\n  }\n  .md\\:focus\\:from-teal-900:focus {\n    --gradient-from-color: #014451;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(1, 68, 81, 0));\n  }\n  .md\\:focus\\:from-blue-50:focus {\n    --gradient-from-color: #ebf5ff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(235, 245, 255, 0));\n  }\n  .md\\:focus\\:from-blue-100:focus {\n    --gradient-from-color: #e1effe;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(225, 239, 254, 0));\n  }\n  .md\\:focus\\:from-blue-200:focus {\n    --gradient-from-color: #c3ddfd;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(195, 221, 253, 0));\n  }\n  .md\\:focus\\:from-blue-300:focus {\n    --gradient-from-color: #a4cafe;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(164, 202, 254, 0));\n  }\n  .md\\:focus\\:from-blue-400:focus {\n    --gradient-from-color: #76a9fa;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(118, 169, 250, 0));\n  }\n  .md\\:focus\\:from-blue-500:focus {\n    --gradient-from-color: #3f83f8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(63, 131, 248, 0));\n  }\n  .md\\:focus\\:from-blue-600:focus {\n    --gradient-from-color: #1c64f2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(28, 100, 242, 0));\n  }\n  .md\\:focus\\:from-blue-700:focus {\n    --gradient-from-color: #1a56db;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(26, 86, 219, 0));\n  }\n  .md\\:focus\\:from-blue-800:focus {\n    --gradient-from-color: #1e429f;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(30, 66, 159, 0));\n  }\n  .md\\:focus\\:from-blue-900:focus {\n    --gradient-from-color: #233876;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(35, 56, 118, 0));\n  }\n  .md\\:focus\\:from-indigo-50:focus {\n    --gradient-from-color: #f0f5ff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(240, 245, 255, 0));\n  }\n  .md\\:focus\\:from-indigo-100:focus {\n    --gradient-from-color: #e5edff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(229, 237, 255, 0));\n  }\n  .md\\:focus\\:from-indigo-200:focus {\n    --gradient-from-color: #cddbfe;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(205, 219, 254, 0));\n  }\n  .md\\:focus\\:from-indigo-300:focus {\n    --gradient-from-color: #b4c6fc;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(180, 198, 252, 0));\n  }\n  .md\\:focus\\:from-indigo-400:focus {\n    --gradient-from-color: #8da2fb;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(141, 162, 251, 0));\n  }\n  .md\\:focus\\:from-indigo-500:focus {\n    --gradient-from-color: #6875f5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(104, 117, 245, 0));\n  }\n  .md\\:focus\\:from-indigo-600:focus {\n    --gradient-from-color: #5850ec;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(88, 80, 236, 0));\n  }\n  .md\\:focus\\:from-indigo-700:focus {\n    --gradient-from-color: #5145cd;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(81, 69, 205, 0));\n  }\n  .md\\:focus\\:from-indigo-800:focus {\n    --gradient-from-color: #42389d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(66, 56, 157, 0));\n  }\n  .md\\:focus\\:from-indigo-900:focus {\n    --gradient-from-color: #362f78;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(54, 47, 120, 0));\n  }\n  .md\\:focus\\:from-purple-50:focus {\n    --gradient-from-color: #f6f5ff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(246, 245, 255, 0));\n  }\n  .md\\:focus\\:from-purple-100:focus {\n    --gradient-from-color: #edebfe;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(237, 235, 254, 0));\n  }\n  .md\\:focus\\:from-purple-200:focus {\n    --gradient-from-color: #dcd7fe;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(220, 215, 254, 0));\n  }\n  .md\\:focus\\:from-purple-300:focus {\n    --gradient-from-color: #cabffd;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(202, 191, 253, 0));\n  }\n  .md\\:focus\\:from-purple-400:focus {\n    --gradient-from-color: #ac94fa;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(172, 148, 250, 0));\n  }\n  .md\\:focus\\:from-purple-500:focus {\n    --gradient-from-color: #9061f9;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(144, 97, 249, 0));\n  }\n  .md\\:focus\\:from-purple-600:focus {\n    --gradient-from-color: #7e3af2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(126, 58, 242, 0));\n  }\n  .md\\:focus\\:from-purple-700:focus {\n    --gradient-from-color: #6c2bd9;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(108, 43, 217, 0));\n  }\n  .md\\:focus\\:from-purple-800:focus {\n    --gradient-from-color: #5521b5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(85, 33, 181, 0));\n  }\n  .md\\:focus\\:from-purple-900:focus {\n    --gradient-from-color: #4a1d96;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(74, 29, 150, 0));\n  }\n  .md\\:focus\\:from-pink-50:focus {\n    --gradient-from-color: #fdf2f8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 242, 248, 0));\n  }\n  .md\\:focus\\:from-pink-100:focus {\n    --gradient-from-color: #fce8f3;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(252, 232, 243, 0));\n  }\n  .md\\:focus\\:from-pink-200:focus {\n    --gradient-from-color: #fad1e8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(250, 209, 232, 0));\n  }\n  .md\\:focus\\:from-pink-300:focus {\n    --gradient-from-color: #f8b4d9;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(248, 180, 217, 0));\n  }\n  .md\\:focus\\:from-pink-400:focus {\n    --gradient-from-color: #f17eb8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(241, 126, 184, 0));\n  }\n  .md\\:focus\\:from-pink-500:focus {\n    --gradient-from-color: #e74694;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(231, 70, 148, 0));\n  }\n  .md\\:focus\\:from-pink-600:focus {\n    --gradient-from-color: #d61f69;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(214, 31, 105, 0));\n  }\n  .md\\:focus\\:from-pink-700:focus {\n    --gradient-from-color: #bf125d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(191, 18, 93, 0));\n  }\n  .md\\:focus\\:from-pink-800:focus {\n    --gradient-from-color: #99154b;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(153, 21, 75, 0));\n  }\n  .md\\:focus\\:from-pink-900:focus {\n    --gradient-from-color: #751a3d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(117, 26, 61, 0));\n  }\n  .md\\:focus\\:from-cool-gray-50:focus {\n    --gradient-from-color: #f8fafc;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(248, 250, 252, 0));\n  }\n  .md\\:focus\\:from-cool-gray-100:focus {\n    --gradient-from-color: #f1f5f9;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(241, 245, 249, 0));\n  }\n  .md\\:focus\\:from-cool-gray-200:focus {\n    --gradient-from-color: #e2e8f0;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(226, 232, 240, 0));\n  }\n  .md\\:focus\\:from-cool-gray-300:focus {\n    --gradient-from-color: #cfd8e3;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(207, 216, 227, 0));\n  }\n  .md\\:focus\\:from-cool-gray-400:focus {\n    --gradient-from-color: #97a6ba;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(151, 166, 186, 0));\n  }\n  .md\\:focus\\:from-cool-gray-500:focus {\n    --gradient-from-color: #64748b;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(100, 116, 139, 0));\n  }\n  .md\\:focus\\:from-cool-gray-600:focus {\n    --gradient-from-color: #475569;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(71, 85, 105, 0));\n  }\n  .md\\:focus\\:from-cool-gray-700:focus {\n    --gradient-from-color: #364152;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(54, 65, 82, 0));\n  }\n  .md\\:focus\\:from-cool-gray-800:focus {\n    --gradient-from-color: #27303f;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(39, 48, 63, 0));\n  }\n  .md\\:focus\\:from-cool-gray-900:focus {\n    --gradient-from-color: #1a202e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(26, 32, 46, 0));\n  }\n  .md\\:focus\\:via-current:focus {\n    --gradient-via-color: currentColor;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));\n  }\n  .md\\:focus\\:via-transparent:focus {\n    --gradient-via-color: transparent;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0));\n  }\n  .md\\:focus\\:via-white:focus {\n    --gradient-via-color: #ffffff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));\n  }\n  .md\\:focus\\:via-black:focus {\n    --gradient-via-color: #000000;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0));\n  }\n  .md\\:focus\\:via-gray-50:focus {\n    --gradient-via-color: #f9fafb;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(249, 250, 251, 0));\n  }\n  .md\\:focus\\:via-gray-100:focus {\n    --gradient-via-color: #f4f5f7;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(244, 245, 247, 0));\n  }\n  .md\\:focus\\:via-gray-200:focus {\n    --gradient-via-color: #e5e7eb;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(229, 231, 235, 0));\n  }\n  .md\\:focus\\:via-gray-300:focus {\n    --gradient-via-color: #d2d6dc;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(210, 214, 220, 0));\n  }\n  .md\\:focus\\:via-gray-400:focus {\n    --gradient-via-color: #9fa6b2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(159, 166, 178, 0));\n  }\n  .md\\:focus\\:via-gray-500:focus {\n    --gradient-via-color: #6b7280;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(107, 114, 128, 0));\n  }\n  .md\\:focus\\:via-gray-600:focus {\n    --gradient-via-color: #4b5563;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(75, 85, 99, 0));\n  }\n  .md\\:focus\\:via-gray-700:focus {\n    --gradient-via-color: #374151;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(55, 65, 81, 0));\n  }\n  .md\\:focus\\:via-gray-800:focus {\n    --gradient-via-color: #252f3f;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(37, 47, 63, 0));\n  }\n  .md\\:focus\\:via-gray-900:focus {\n    --gradient-via-color: #161e2e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(22, 30, 46, 0));\n  }\n  .md\\:focus\\:via-red-50:focus {\n    --gradient-via-color: #fdf2f2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 242, 242, 0));\n  }\n  .md\\:focus\\:via-red-100:focus {\n    --gradient-via-color: #fde8e8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 232, 232, 0));\n  }\n  .md\\:focus\\:via-red-200:focus {\n    --gradient-via-color: #fbd5d5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(251, 213, 213, 0));\n  }\n  .md\\:focus\\:via-red-300:focus {\n    --gradient-via-color: #f8b4b4;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(248, 180, 180, 0));\n  }\n  .md\\:focus\\:via-red-400:focus {\n    --gradient-via-color: #f98080;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(249, 128, 128, 0));\n  }\n  .md\\:focus\\:via-red-500:focus {\n    --gradient-via-color: #f05252;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(240, 82, 82, 0));\n  }\n  .md\\:focus\\:via-red-600:focus {\n    --gradient-via-color: #e02424;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(224, 36, 36, 0));\n  }\n  .md\\:focus\\:via-red-700:focus {\n    --gradient-via-color: #c81e1e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(200, 30, 30, 0));\n  }\n  .md\\:focus\\:via-red-800:focus {\n    --gradient-via-color: #9b1c1c;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(155, 28, 28, 0));\n  }\n  .md\\:focus\\:via-red-900:focus {\n    --gradient-via-color: #771d1d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(119, 29, 29, 0));\n  }\n  .md\\:focus\\:via-orange-50:focus {\n    --gradient-via-color: #fff8f1;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 248, 241, 0));\n  }\n  .md\\:focus\\:via-orange-100:focus {\n    --gradient-via-color: #feecdc;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 236, 220, 0));\n  }\n  .md\\:focus\\:via-orange-200:focus {\n    --gradient-via-color: #fcd9bd;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(252, 217, 189, 0));\n  }\n  .md\\:focus\\:via-orange-300:focus {\n    --gradient-via-color: #fdba8c;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 186, 140, 0));\n  }\n  .md\\:focus\\:via-orange-400:focus {\n    --gradient-via-color: #ff8a4c;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 138, 76, 0));\n  }\n  .md\\:focus\\:via-orange-500:focus {\n    --gradient-via-color: #ff5a1f;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 90, 31, 0));\n  }\n  .md\\:focus\\:via-orange-600:focus {\n    --gradient-via-color: #d03801;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(208, 56, 1, 0));\n  }\n  .md\\:focus\\:via-orange-700:focus {\n    --gradient-via-color: #b43403;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(180, 52, 3, 0));\n  }\n  .md\\:focus\\:via-orange-800:focus {\n    --gradient-via-color: #8a2c0d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(138, 44, 13, 0));\n  }\n  .md\\:focus\\:via-orange-900:focus {\n    --gradient-via-color: #73230d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(115, 35, 13, 0));\n  }\n  .md\\:focus\\:via-yellow-50:focus {\n    --gradient-via-color: #fdfdea;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 253, 234, 0));\n  }\n  .md\\:focus\\:via-yellow-100:focus {\n    --gradient-via-color: #fdf6b2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 246, 178, 0));\n  }\n  .md\\:focus\\:via-yellow-200:focus {\n    --gradient-via-color: #fce96a;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(252, 233, 106, 0));\n  }\n  .md\\:focus\\:via-yellow-300:focus {\n    --gradient-via-color: #faca15;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(250, 202, 21, 0));\n  }\n  .md\\:focus\\:via-yellow-400:focus {\n    --gradient-via-color: #e3a008;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(227, 160, 8, 0));\n  }\n  .md\\:focus\\:via-yellow-500:focus {\n    --gradient-via-color: #c27803;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(194, 120, 3, 0));\n  }\n  .md\\:focus\\:via-yellow-600:focus {\n    --gradient-via-color: #9f580a;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(159, 88, 10, 0));\n  }\n  .md\\:focus\\:via-yellow-700:focus {\n    --gradient-via-color: #8e4b10;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(142, 75, 16, 0));\n  }\n  .md\\:focus\\:via-yellow-800:focus {\n    --gradient-via-color: #723b13;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(114, 59, 19, 0));\n  }\n  .md\\:focus\\:via-yellow-900:focus {\n    --gradient-via-color: #633112;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(99, 49, 18, 0));\n  }\n  .md\\:focus\\:via-green-50:focus {\n    --gradient-via-color: #f3faf7;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(243, 250, 247, 0));\n  }\n  .md\\:focus\\:via-green-100:focus {\n    --gradient-via-color: #def7ec;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(222, 247, 236, 0));\n  }\n  .md\\:focus\\:via-green-200:focus {\n    --gradient-via-color: #bcf0da;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(188, 240, 218, 0));\n  }\n  .md\\:focus\\:via-green-300:focus {\n    --gradient-via-color: #84e1bc;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(132, 225, 188, 0));\n  }\n  .md\\:focus\\:via-green-400:focus {\n    --gradient-via-color: #31c48d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(49, 196, 141, 0));\n  }\n  .md\\:focus\\:via-green-500:focus {\n    --gradient-via-color: #0e9f6e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(14, 159, 110, 0));\n  }\n  .md\\:focus\\:via-green-600:focus {\n    --gradient-via-color: #057a55;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(5, 122, 85, 0));\n  }\n  .md\\:focus\\:via-green-700:focus {\n    --gradient-via-color: #046c4e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(4, 108, 78, 0));\n  }\n  .md\\:focus\\:via-green-800:focus {\n    --gradient-via-color: #03543f;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(3, 84, 63, 0));\n  }\n  .md\\:focus\\:via-green-900:focus {\n    --gradient-via-color: #014737;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(1, 71, 55, 0));\n  }\n  .md\\:focus\\:via-teal-50:focus {\n    --gradient-via-color: #edfafa;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(237, 250, 250, 0));\n  }\n  .md\\:focus\\:via-teal-100:focus {\n    --gradient-via-color: #d5f5f6;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(213, 245, 246, 0));\n  }\n  .md\\:focus\\:via-teal-200:focus {\n    --gradient-via-color: #afecef;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(175, 236, 239, 0));\n  }\n  .md\\:focus\\:via-teal-300:focus {\n    --gradient-via-color: #7edce2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(126, 220, 226, 0));\n  }\n  .md\\:focus\\:via-teal-400:focus {\n    --gradient-via-color: #16bdca;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(22, 189, 202, 0));\n  }\n  .md\\:focus\\:via-teal-500:focus {\n    --gradient-via-color: #0694a2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(6, 148, 162, 0));\n  }\n  .md\\:focus\\:via-teal-600:focus {\n    --gradient-via-color: #047481;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(4, 116, 129, 0));\n  }\n  .md\\:focus\\:via-teal-700:focus {\n    --gradient-via-color: #036672;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(3, 102, 114, 0));\n  }\n  .md\\:focus\\:via-teal-800:focus {\n    --gradient-via-color: #05505c;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(5, 80, 92, 0));\n  }\n  .md\\:focus\\:via-teal-900:focus {\n    --gradient-via-color: #014451;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(1, 68, 81, 0));\n  }\n  .md\\:focus\\:via-blue-50:focus {\n    --gradient-via-color: #ebf5ff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(235, 245, 255, 0));\n  }\n  .md\\:focus\\:via-blue-100:focus {\n    --gradient-via-color: #e1effe;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(225, 239, 254, 0));\n  }\n  .md\\:focus\\:via-blue-200:focus {\n    --gradient-via-color: #c3ddfd;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(195, 221, 253, 0));\n  }\n  .md\\:focus\\:via-blue-300:focus {\n    --gradient-via-color: #a4cafe;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(164, 202, 254, 0));\n  }\n  .md\\:focus\\:via-blue-400:focus {\n    --gradient-via-color: #76a9fa;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(118, 169, 250, 0));\n  }\n  .md\\:focus\\:via-blue-500:focus {\n    --gradient-via-color: #3f83f8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(63, 131, 248, 0));\n  }\n  .md\\:focus\\:via-blue-600:focus {\n    --gradient-via-color: #1c64f2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(28, 100, 242, 0));\n  }\n  .md\\:focus\\:via-blue-700:focus {\n    --gradient-via-color: #1a56db;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(26, 86, 219, 0));\n  }\n  .md\\:focus\\:via-blue-800:focus {\n    --gradient-via-color: #1e429f;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(30, 66, 159, 0));\n  }\n  .md\\:focus\\:via-blue-900:focus {\n    --gradient-via-color: #233876;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(35, 56, 118, 0));\n  }\n  .md\\:focus\\:via-indigo-50:focus {\n    --gradient-via-color: #f0f5ff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(240, 245, 255, 0));\n  }\n  .md\\:focus\\:via-indigo-100:focus {\n    --gradient-via-color: #e5edff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(229, 237, 255, 0));\n  }\n  .md\\:focus\\:via-indigo-200:focus {\n    --gradient-via-color: #cddbfe;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(205, 219, 254, 0));\n  }\n  .md\\:focus\\:via-indigo-300:focus {\n    --gradient-via-color: #b4c6fc;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(180, 198, 252, 0));\n  }\n  .md\\:focus\\:via-indigo-400:focus {\n    --gradient-via-color: #8da2fb;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(141, 162, 251, 0));\n  }\n  .md\\:focus\\:via-indigo-500:focus {\n    --gradient-via-color: #6875f5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(104, 117, 245, 0));\n  }\n  .md\\:focus\\:via-indigo-600:focus {\n    --gradient-via-color: #5850ec;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(88, 80, 236, 0));\n  }\n  .md\\:focus\\:via-indigo-700:focus {\n    --gradient-via-color: #5145cd;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(81, 69, 205, 0));\n  }\n  .md\\:focus\\:via-indigo-800:focus {\n    --gradient-via-color: #42389d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(66, 56, 157, 0));\n  }\n  .md\\:focus\\:via-indigo-900:focus {\n    --gradient-via-color: #362f78;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(54, 47, 120, 0));\n  }\n  .md\\:focus\\:via-purple-50:focus {\n    --gradient-via-color: #f6f5ff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(246, 245, 255, 0));\n  }\n  .md\\:focus\\:via-purple-100:focus {\n    --gradient-via-color: #edebfe;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(237, 235, 254, 0));\n  }\n  .md\\:focus\\:via-purple-200:focus {\n    --gradient-via-color: #dcd7fe;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(220, 215, 254, 0));\n  }\n  .md\\:focus\\:via-purple-300:focus {\n    --gradient-via-color: #cabffd;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(202, 191, 253, 0));\n  }\n  .md\\:focus\\:via-purple-400:focus {\n    --gradient-via-color: #ac94fa;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(172, 148, 250, 0));\n  }\n  .md\\:focus\\:via-purple-500:focus {\n    --gradient-via-color: #9061f9;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(144, 97, 249, 0));\n  }\n  .md\\:focus\\:via-purple-600:focus {\n    --gradient-via-color: #7e3af2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(126, 58, 242, 0));\n  }\n  .md\\:focus\\:via-purple-700:focus {\n    --gradient-via-color: #6c2bd9;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(108, 43, 217, 0));\n  }\n  .md\\:focus\\:via-purple-800:focus {\n    --gradient-via-color: #5521b5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(85, 33, 181, 0));\n  }\n  .md\\:focus\\:via-purple-900:focus {\n    --gradient-via-color: #4a1d96;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(74, 29, 150, 0));\n  }\n  .md\\:focus\\:via-pink-50:focus {\n    --gradient-via-color: #fdf2f8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 242, 248, 0));\n  }\n  .md\\:focus\\:via-pink-100:focus {\n    --gradient-via-color: #fce8f3;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(252, 232, 243, 0));\n  }\n  .md\\:focus\\:via-pink-200:focus {\n    --gradient-via-color: #fad1e8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(250, 209, 232, 0));\n  }\n  .md\\:focus\\:via-pink-300:focus {\n    --gradient-via-color: #f8b4d9;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(248, 180, 217, 0));\n  }\n  .md\\:focus\\:via-pink-400:focus {\n    --gradient-via-color: #f17eb8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(241, 126, 184, 0));\n  }\n  .md\\:focus\\:via-pink-500:focus {\n    --gradient-via-color: #e74694;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(231, 70, 148, 0));\n  }\n  .md\\:focus\\:via-pink-600:focus {\n    --gradient-via-color: #d61f69;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(214, 31, 105, 0));\n  }\n  .md\\:focus\\:via-pink-700:focus {\n    --gradient-via-color: #bf125d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(191, 18, 93, 0));\n  }\n  .md\\:focus\\:via-pink-800:focus {\n    --gradient-via-color: #99154b;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(153, 21, 75, 0));\n  }\n  .md\\:focus\\:via-pink-900:focus {\n    --gradient-via-color: #751a3d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(117, 26, 61, 0));\n  }\n  .md\\:focus\\:via-cool-gray-50:focus {\n    --gradient-via-color: #f8fafc;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(248, 250, 252, 0));\n  }\n  .md\\:focus\\:via-cool-gray-100:focus {\n    --gradient-via-color: #f1f5f9;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(241, 245, 249, 0));\n  }\n  .md\\:focus\\:via-cool-gray-200:focus {\n    --gradient-via-color: #e2e8f0;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(226, 232, 240, 0));\n  }\n  .md\\:focus\\:via-cool-gray-300:focus {\n    --gradient-via-color: #cfd8e3;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(207, 216, 227, 0));\n  }\n  .md\\:focus\\:via-cool-gray-400:focus {\n    --gradient-via-color: #97a6ba;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(151, 166, 186, 0));\n  }\n  .md\\:focus\\:via-cool-gray-500:focus {\n    --gradient-via-color: #64748b;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(100, 116, 139, 0));\n  }\n  .md\\:focus\\:via-cool-gray-600:focus {\n    --gradient-via-color: #475569;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(71, 85, 105, 0));\n  }\n  .md\\:focus\\:via-cool-gray-700:focus {\n    --gradient-via-color: #364152;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(54, 65, 82, 0));\n  }\n  .md\\:focus\\:via-cool-gray-800:focus {\n    --gradient-via-color: #27303f;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(39, 48, 63, 0));\n  }\n  .md\\:focus\\:via-cool-gray-900:focus {\n    --gradient-via-color: #1a202e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(26, 32, 46, 0));\n  }\n  .md\\:focus\\:to-current:focus {\n    --gradient-to-color: currentColor;\n  }\n  .md\\:focus\\:to-transparent:focus {\n    --gradient-to-color: transparent;\n  }\n  .md\\:focus\\:to-white:focus {\n    --gradient-to-color: #ffffff;\n  }\n  .md\\:focus\\:to-black:focus {\n    --gradient-to-color: #000000;\n  }\n  .md\\:focus\\:to-gray-50:focus {\n    --gradient-to-color: #f9fafb;\n  }\n  .md\\:focus\\:to-gray-100:focus {\n    --gradient-to-color: #f4f5f7;\n  }\n  .md\\:focus\\:to-gray-200:focus {\n    --gradient-to-color: #e5e7eb;\n  }\n  .md\\:focus\\:to-gray-300:focus {\n    --gradient-to-color: #d2d6dc;\n  }\n  .md\\:focus\\:to-gray-400:focus {\n    --gradient-to-color: #9fa6b2;\n  }\n  .md\\:focus\\:to-gray-500:focus {\n    --gradient-to-color: #6b7280;\n  }\n  .md\\:focus\\:to-gray-600:focus {\n    --gradient-to-color: #4b5563;\n  }\n  .md\\:focus\\:to-gray-700:focus {\n    --gradient-to-color: #374151;\n  }\n  .md\\:focus\\:to-gray-800:focus {\n    --gradient-to-color: #252f3f;\n  }\n  .md\\:focus\\:to-gray-900:focus {\n    --gradient-to-color: #161e2e;\n  }\n  .md\\:focus\\:to-red-50:focus {\n    --gradient-to-color: #fdf2f2;\n  }\n  .md\\:focus\\:to-red-100:focus {\n    --gradient-to-color: #fde8e8;\n  }\n  .md\\:focus\\:to-red-200:focus {\n    --gradient-to-color: #fbd5d5;\n  }\n  .md\\:focus\\:to-red-300:focus {\n    --gradient-to-color: #f8b4b4;\n  }\n  .md\\:focus\\:to-red-400:focus {\n    --gradient-to-color: #f98080;\n  }\n  .md\\:focus\\:to-red-500:focus {\n    --gradient-to-color: #f05252;\n  }\n  .md\\:focus\\:to-red-600:focus {\n    --gradient-to-color: #e02424;\n  }\n  .md\\:focus\\:to-red-700:focus {\n    --gradient-to-color: #c81e1e;\n  }\n  .md\\:focus\\:to-red-800:focus {\n    --gradient-to-color: #9b1c1c;\n  }\n  .md\\:focus\\:to-red-900:focus {\n    --gradient-to-color: #771d1d;\n  }\n  .md\\:focus\\:to-orange-50:focus {\n    --gradient-to-color: #fff8f1;\n  }\n  .md\\:focus\\:to-orange-100:focus {\n    --gradient-to-color: #feecdc;\n  }\n  .md\\:focus\\:to-orange-200:focus {\n    --gradient-to-color: #fcd9bd;\n  }\n  .md\\:focus\\:to-orange-300:focus {\n    --gradient-to-color: #fdba8c;\n  }\n  .md\\:focus\\:to-orange-400:focus {\n    --gradient-to-color: #ff8a4c;\n  }\n  .md\\:focus\\:to-orange-500:focus {\n    --gradient-to-color: #ff5a1f;\n  }\n  .md\\:focus\\:to-orange-600:focus {\n    --gradient-to-color: #d03801;\n  }\n  .md\\:focus\\:to-orange-700:focus {\n    --gradient-to-color: #b43403;\n  }\n  .md\\:focus\\:to-orange-800:focus {\n    --gradient-to-color: #8a2c0d;\n  }\n  .md\\:focus\\:to-orange-900:focus {\n    --gradient-to-color: #73230d;\n  }\n  .md\\:focus\\:to-yellow-50:focus {\n    --gradient-to-color: #fdfdea;\n  }\n  .md\\:focus\\:to-yellow-100:focus {\n    --gradient-to-color: #fdf6b2;\n  }\n  .md\\:focus\\:to-yellow-200:focus {\n    --gradient-to-color: #fce96a;\n  }\n  .md\\:focus\\:to-yellow-300:focus {\n    --gradient-to-color: #faca15;\n  }\n  .md\\:focus\\:to-yellow-400:focus {\n    --gradient-to-color: #e3a008;\n  }\n  .md\\:focus\\:to-yellow-500:focus {\n    --gradient-to-color: #c27803;\n  }\n  .md\\:focus\\:to-yellow-600:focus {\n    --gradient-to-color: #9f580a;\n  }\n  .md\\:focus\\:to-yellow-700:focus {\n    --gradient-to-color: #8e4b10;\n  }\n  .md\\:focus\\:to-yellow-800:focus {\n    --gradient-to-color: #723b13;\n  }\n  .md\\:focus\\:to-yellow-900:focus {\n    --gradient-to-color: #633112;\n  }\n  .md\\:focus\\:to-green-50:focus {\n    --gradient-to-color: #f3faf7;\n  }\n  .md\\:focus\\:to-green-100:focus {\n    --gradient-to-color: #def7ec;\n  }\n  .md\\:focus\\:to-green-200:focus {\n    --gradient-to-color: #bcf0da;\n  }\n  .md\\:focus\\:to-green-300:focus {\n    --gradient-to-color: #84e1bc;\n  }\n  .md\\:focus\\:to-green-400:focus {\n    --gradient-to-color: #31c48d;\n  }\n  .md\\:focus\\:to-green-500:focus {\n    --gradient-to-color: #0e9f6e;\n  }\n  .md\\:focus\\:to-green-600:focus {\n    --gradient-to-color: #057a55;\n  }\n  .md\\:focus\\:to-green-700:focus {\n    --gradient-to-color: #046c4e;\n  }\n  .md\\:focus\\:to-green-800:focus {\n    --gradient-to-color: #03543f;\n  }\n  .md\\:focus\\:to-green-900:focus {\n    --gradient-to-color: #014737;\n  }\n  .md\\:focus\\:to-teal-50:focus {\n    --gradient-to-color: #edfafa;\n  }\n  .md\\:focus\\:to-teal-100:focus {\n    --gradient-to-color: #d5f5f6;\n  }\n  .md\\:focus\\:to-teal-200:focus {\n    --gradient-to-color: #afecef;\n  }\n  .md\\:focus\\:to-teal-300:focus {\n    --gradient-to-color: #7edce2;\n  }\n  .md\\:focus\\:to-teal-400:focus {\n    --gradient-to-color: #16bdca;\n  }\n  .md\\:focus\\:to-teal-500:focus {\n    --gradient-to-color: #0694a2;\n  }\n  .md\\:focus\\:to-teal-600:focus {\n    --gradient-to-color: #047481;\n  }\n  .md\\:focus\\:to-teal-700:focus {\n    --gradient-to-color: #036672;\n  }\n  .md\\:focus\\:to-teal-800:focus {\n    --gradient-to-color: #05505c;\n  }\n  .md\\:focus\\:to-teal-900:focus {\n    --gradient-to-color: #014451;\n  }\n  .md\\:focus\\:to-blue-50:focus {\n    --gradient-to-color: #ebf5ff;\n  }\n  .md\\:focus\\:to-blue-100:focus {\n    --gradient-to-color: #e1effe;\n  }\n  .md\\:focus\\:to-blue-200:focus {\n    --gradient-to-color: #c3ddfd;\n  }\n  .md\\:focus\\:to-blue-300:focus {\n    --gradient-to-color: #a4cafe;\n  }\n  .md\\:focus\\:to-blue-400:focus {\n    --gradient-to-color: #76a9fa;\n  }\n  .md\\:focus\\:to-blue-500:focus {\n    --gradient-to-color: #3f83f8;\n  }\n  .md\\:focus\\:to-blue-600:focus {\n    --gradient-to-color: #1c64f2;\n  }\n  .md\\:focus\\:to-blue-700:focus {\n    --gradient-to-color: #1a56db;\n  }\n  .md\\:focus\\:to-blue-800:focus {\n    --gradient-to-color: #1e429f;\n  }\n  .md\\:focus\\:to-blue-900:focus {\n    --gradient-to-color: #233876;\n  }\n  .md\\:focus\\:to-indigo-50:focus {\n    --gradient-to-color: #f0f5ff;\n  }\n  .md\\:focus\\:to-indigo-100:focus {\n    --gradient-to-color: #e5edff;\n  }\n  .md\\:focus\\:to-indigo-200:focus {\n    --gradient-to-color: #cddbfe;\n  }\n  .md\\:focus\\:to-indigo-300:focus {\n    --gradient-to-color: #b4c6fc;\n  }\n  .md\\:focus\\:to-indigo-400:focus {\n    --gradient-to-color: #8da2fb;\n  }\n  .md\\:focus\\:to-indigo-500:focus {\n    --gradient-to-color: #6875f5;\n  }\n  .md\\:focus\\:to-indigo-600:focus {\n    --gradient-to-color: #5850ec;\n  }\n  .md\\:focus\\:to-indigo-700:focus {\n    --gradient-to-color: #5145cd;\n  }\n  .md\\:focus\\:to-indigo-800:focus {\n    --gradient-to-color: #42389d;\n  }\n  .md\\:focus\\:to-indigo-900:focus {\n    --gradient-to-color: #362f78;\n  }\n  .md\\:focus\\:to-purple-50:focus {\n    --gradient-to-color: #f6f5ff;\n  }\n  .md\\:focus\\:to-purple-100:focus {\n    --gradient-to-color: #edebfe;\n  }\n  .md\\:focus\\:to-purple-200:focus {\n    --gradient-to-color: #dcd7fe;\n  }\n  .md\\:focus\\:to-purple-300:focus {\n    --gradient-to-color: #cabffd;\n  }\n  .md\\:focus\\:to-purple-400:focus {\n    --gradient-to-color: #ac94fa;\n  }\n  .md\\:focus\\:to-purple-500:focus {\n    --gradient-to-color: #9061f9;\n  }\n  .md\\:focus\\:to-purple-600:focus {\n    --gradient-to-color: #7e3af2;\n  }\n  .md\\:focus\\:to-purple-700:focus {\n    --gradient-to-color: #6c2bd9;\n  }\n  .md\\:focus\\:to-purple-800:focus {\n    --gradient-to-color: #5521b5;\n  }\n  .md\\:focus\\:to-purple-900:focus {\n    --gradient-to-color: #4a1d96;\n  }\n  .md\\:focus\\:to-pink-50:focus {\n    --gradient-to-color: #fdf2f8;\n  }\n  .md\\:focus\\:to-pink-100:focus {\n    --gradient-to-color: #fce8f3;\n  }\n  .md\\:focus\\:to-pink-200:focus {\n    --gradient-to-color: #fad1e8;\n  }\n  .md\\:focus\\:to-pink-300:focus {\n    --gradient-to-color: #f8b4d9;\n  }\n  .md\\:focus\\:to-pink-400:focus {\n    --gradient-to-color: #f17eb8;\n  }\n  .md\\:focus\\:to-pink-500:focus {\n    --gradient-to-color: #e74694;\n  }\n  .md\\:focus\\:to-pink-600:focus {\n    --gradient-to-color: #d61f69;\n  }\n  .md\\:focus\\:to-pink-700:focus {\n    --gradient-to-color: #bf125d;\n  }\n  .md\\:focus\\:to-pink-800:focus {\n    --gradient-to-color: #99154b;\n  }\n  .md\\:focus\\:to-pink-900:focus {\n    --gradient-to-color: #751a3d;\n  }\n  .md\\:focus\\:to-cool-gray-50:focus {\n    --gradient-to-color: #f8fafc;\n  }\n  .md\\:focus\\:to-cool-gray-100:focus {\n    --gradient-to-color: #f1f5f9;\n  }\n  .md\\:focus\\:to-cool-gray-200:focus {\n    --gradient-to-color: #e2e8f0;\n  }\n  .md\\:focus\\:to-cool-gray-300:focus {\n    --gradient-to-color: #cfd8e3;\n  }\n  .md\\:focus\\:to-cool-gray-400:focus {\n    --gradient-to-color: #97a6ba;\n  }\n  .md\\:focus\\:to-cool-gray-500:focus {\n    --gradient-to-color: #64748b;\n  }\n  .md\\:focus\\:to-cool-gray-600:focus {\n    --gradient-to-color: #475569;\n  }\n  .md\\:focus\\:to-cool-gray-700:focus {\n    --gradient-to-color: #364152;\n  }\n  .md\\:focus\\:to-cool-gray-800:focus {\n    --gradient-to-color: #27303f;\n  }\n  .md\\:focus\\:to-cool-gray-900:focus {\n    --gradient-to-color: #1a202e;\n  }\n  .md\\:bg-opacity-0 {\n    --bg-opacity: 0;\n  }\n  .md\\:bg-opacity-25 {\n    --bg-opacity: 0.25;\n  }\n  .md\\:bg-opacity-50 {\n    --bg-opacity: 0.5;\n  }\n  .md\\:bg-opacity-75 {\n    --bg-opacity: 0.75;\n  }\n  .md\\:bg-opacity-100 {\n    --bg-opacity: 1;\n  }\n  .md\\:hover\\:bg-opacity-0:hover {\n    --bg-opacity: 0;\n  }\n  .md\\:hover\\:bg-opacity-25:hover {\n    --bg-opacity: 0.25;\n  }\n  .md\\:hover\\:bg-opacity-50:hover {\n    --bg-opacity: 0.5;\n  }\n  .md\\:hover\\:bg-opacity-75:hover {\n    --bg-opacity: 0.75;\n  }\n  .md\\:hover\\:bg-opacity-100:hover {\n    --bg-opacity: 1;\n  }\n  .md\\:focus\\:bg-opacity-0:focus {\n    --bg-opacity: 0;\n  }\n  .md\\:focus\\:bg-opacity-25:focus {\n    --bg-opacity: 0.25;\n  }\n  .md\\:focus\\:bg-opacity-50:focus {\n    --bg-opacity: 0.5;\n  }\n  .md\\:focus\\:bg-opacity-75:focus {\n    --bg-opacity: 0.75;\n  }\n  .md\\:focus\\:bg-opacity-100:focus {\n    --bg-opacity: 1;\n  }\n  .md\\:bg-bottom {\n    background-position: bottom;\n  }\n  .md\\:bg-center {\n    background-position: center;\n  }\n  .md\\:bg-left {\n    background-position: left;\n  }\n  .md\\:bg-left-bottom {\n    background-position: left bottom;\n  }\n  .md\\:bg-left-top {\n    background-position: left top;\n  }\n  .md\\:bg-right {\n    background-position: right;\n  }\n  .md\\:bg-right-bottom {\n    background-position: right bottom;\n  }\n  .md\\:bg-right-top {\n    background-position: right top;\n  }\n  .md\\:bg-top {\n    background-position: top;\n  }\n  .md\\:bg-repeat {\n    background-repeat: repeat;\n  }\n  .md\\:bg-no-repeat {\n    background-repeat: no-repeat;\n  }\n  .md\\:bg-repeat-x {\n    background-repeat: repeat-x;\n  }\n  .md\\:bg-repeat-y {\n    background-repeat: repeat-y;\n  }\n  .md\\:bg-repeat-round {\n    background-repeat: round;\n  }\n  .md\\:bg-repeat-space {\n    background-repeat: space;\n  }\n  .md\\:bg-auto {\n    background-size: auto;\n  }\n  .md\\:bg-cover {\n    background-size: cover;\n  }\n  .md\\:bg-contain {\n    background-size: contain;\n  }\n  .md\\:border-collapse {\n    border-collapse: collapse;\n  }\n  .md\\:border-separate {\n    border-collapse: separate;\n  }\n  .md\\:border-current {\n    border-color: currentColor;\n  }\n  .md\\:border-transparent {\n    border-color: transparent;\n  }\n  .md\\:border-white {\n    --border-opacity: 1;\n    border-color: #ffffff;\n    border-color: rgba(255, 255, 255, var(--border-opacity));\n  }\n  .md\\:border-black {\n    --border-opacity: 1;\n    border-color: #000000;\n    border-color: rgba(0, 0, 0, var(--border-opacity));\n  }\n  .md\\:border-gray-50 {\n    --border-opacity: 1;\n    border-color: #f9fafb;\n    border-color: rgba(249, 250, 251, var(--border-opacity));\n  }\n  .md\\:border-gray-100 {\n    --border-opacity: 1;\n    border-color: #f4f5f7;\n    border-color: rgba(244, 245, 247, var(--border-opacity));\n  }\n  .md\\:border-gray-200 {\n    --border-opacity: 1;\n    border-color: #e5e7eb;\n    border-color: rgba(229, 231, 235, var(--border-opacity));\n  }\n  .md\\:border-gray-300 {\n    --border-opacity: 1;\n    border-color: #d2d6dc;\n    border-color: rgba(210, 214, 220, var(--border-opacity));\n  }\n  .md\\:border-gray-400 {\n    --border-opacity: 1;\n    border-color: #9fa6b2;\n    border-color: rgba(159, 166, 178, var(--border-opacity));\n  }\n  .md\\:border-gray-500 {\n    --border-opacity: 1;\n    border-color: #6b7280;\n    border-color: rgba(107, 114, 128, var(--border-opacity));\n  }\n  .md\\:border-gray-600 {\n    --border-opacity: 1;\n    border-color: #4b5563;\n    border-color: rgba(75, 85, 99, var(--border-opacity));\n  }\n  .md\\:border-gray-700 {\n    --border-opacity: 1;\n    border-color: #374151;\n    border-color: rgba(55, 65, 81, var(--border-opacity));\n  }\n  .md\\:border-gray-800 {\n    --border-opacity: 1;\n    border-color: #252f3f;\n    border-color: rgba(37, 47, 63, var(--border-opacity));\n  }\n  .md\\:border-gray-900 {\n    --border-opacity: 1;\n    border-color: #161e2e;\n    border-color: rgba(22, 30, 46, var(--border-opacity));\n  }\n  .md\\:border-red-50 {\n    --border-opacity: 1;\n    border-color: #fdf2f2;\n    border-color: rgba(253, 242, 242, var(--border-opacity));\n  }\n  .md\\:border-red-100 {\n    --border-opacity: 1;\n    border-color: #fde8e8;\n    border-color: rgba(253, 232, 232, var(--border-opacity));\n  }\n  .md\\:border-red-200 {\n    --border-opacity: 1;\n    border-color: #fbd5d5;\n    border-color: rgba(251, 213, 213, var(--border-opacity));\n  }\n  .md\\:border-red-300 {\n    --border-opacity: 1;\n    border-color: #f8b4b4;\n    border-color: rgba(248, 180, 180, var(--border-opacity));\n  }\n  .md\\:border-red-400 {\n    --border-opacity: 1;\n    border-color: #f98080;\n    border-color: rgba(249, 128, 128, var(--border-opacity));\n  }\n  .md\\:border-red-500 {\n    --border-opacity: 1;\n    border-color: #f05252;\n    border-color: rgba(240, 82, 82, var(--border-opacity));\n  }\n  .md\\:border-red-600 {\n    --border-opacity: 1;\n    border-color: #e02424;\n    border-color: rgba(224, 36, 36, var(--border-opacity));\n  }\n  .md\\:border-red-700 {\n    --border-opacity: 1;\n    border-color: #c81e1e;\n    border-color: rgba(200, 30, 30, var(--border-opacity));\n  }\n  .md\\:border-red-800 {\n    --border-opacity: 1;\n    border-color: #9b1c1c;\n    border-color: rgba(155, 28, 28, var(--border-opacity));\n  }\n  .md\\:border-red-900 {\n    --border-opacity: 1;\n    border-color: #771d1d;\n    border-color: rgba(119, 29, 29, var(--border-opacity));\n  }\n  .md\\:border-orange-50 {\n    --border-opacity: 1;\n    border-color: #fff8f1;\n    border-color: rgba(255, 248, 241, var(--border-opacity));\n  }\n  .md\\:border-orange-100 {\n    --border-opacity: 1;\n    border-color: #feecdc;\n    border-color: rgba(254, 236, 220, var(--border-opacity));\n  }\n  .md\\:border-orange-200 {\n    --border-opacity: 1;\n    border-color: #fcd9bd;\n    border-color: rgba(252, 217, 189, var(--border-opacity));\n  }\n  .md\\:border-orange-300 {\n    --border-opacity: 1;\n    border-color: #fdba8c;\n    border-color: rgba(253, 186, 140, var(--border-opacity));\n  }\n  .md\\:border-orange-400 {\n    --border-opacity: 1;\n    border-color: #ff8a4c;\n    border-color: rgba(255, 138, 76, var(--border-opacity));\n  }\n  .md\\:border-orange-500 {\n    --border-opacity: 1;\n    border-color: #ff5a1f;\n    border-color: rgba(255, 90, 31, var(--border-opacity));\n  }\n  .md\\:border-orange-600 {\n    --border-opacity: 1;\n    border-color: #d03801;\n    border-color: rgba(208, 56, 1, var(--border-opacity));\n  }\n  .md\\:border-orange-700 {\n    --border-opacity: 1;\n    border-color: #b43403;\n    border-color: rgba(180, 52, 3, var(--border-opacity));\n  }\n  .md\\:border-orange-800 {\n    --border-opacity: 1;\n    border-color: #8a2c0d;\n    border-color: rgba(138, 44, 13, var(--border-opacity));\n  }\n  .md\\:border-orange-900 {\n    --border-opacity: 1;\n    border-color: #73230d;\n    border-color: rgba(115, 35, 13, var(--border-opacity));\n  }\n  .md\\:border-yellow-50 {\n    --border-opacity: 1;\n    border-color: #fdfdea;\n    border-color: rgba(253, 253, 234, var(--border-opacity));\n  }\n  .md\\:border-yellow-100 {\n    --border-opacity: 1;\n    border-color: #fdf6b2;\n    border-color: rgba(253, 246, 178, var(--border-opacity));\n  }\n  .md\\:border-yellow-200 {\n    --border-opacity: 1;\n    border-color: #fce96a;\n    border-color: rgba(252, 233, 106, var(--border-opacity));\n  }\n  .md\\:border-yellow-300 {\n    --border-opacity: 1;\n    border-color: #faca15;\n    border-color: rgba(250, 202, 21, var(--border-opacity));\n  }\n  .md\\:border-yellow-400 {\n    --border-opacity: 1;\n    border-color: #e3a008;\n    border-color: rgba(227, 160, 8, var(--border-opacity));\n  }\n  .md\\:border-yellow-500 {\n    --border-opacity: 1;\n    border-color: #c27803;\n    border-color: rgba(194, 120, 3, var(--border-opacity));\n  }\n  .md\\:border-yellow-600 {\n    --border-opacity: 1;\n    border-color: #9f580a;\n    border-color: rgba(159, 88, 10, var(--border-opacity));\n  }\n  .md\\:border-yellow-700 {\n    --border-opacity: 1;\n    border-color: #8e4b10;\n    border-color: rgba(142, 75, 16, var(--border-opacity));\n  }\n  .md\\:border-yellow-800 {\n    --border-opacity: 1;\n    border-color: #723b13;\n    border-color: rgba(114, 59, 19, var(--border-opacity));\n  }\n  .md\\:border-yellow-900 {\n    --border-opacity: 1;\n    border-color: #633112;\n    border-color: rgba(99, 49, 18, var(--border-opacity));\n  }\n  .md\\:border-green-50 {\n    --border-opacity: 1;\n    border-color: #f3faf7;\n    border-color: rgba(243, 250, 247, var(--border-opacity));\n  }\n  .md\\:border-green-100 {\n    --border-opacity: 1;\n    border-color: #def7ec;\n    border-color: rgba(222, 247, 236, var(--border-opacity));\n  }\n  .md\\:border-green-200 {\n    --border-opacity: 1;\n    border-color: #bcf0da;\n    border-color: rgba(188, 240, 218, var(--border-opacity));\n  }\n  .md\\:border-green-300 {\n    --border-opacity: 1;\n    border-color: #84e1bc;\n    border-color: rgba(132, 225, 188, var(--border-opacity));\n  }\n  .md\\:border-green-400 {\n    --border-opacity: 1;\n    border-color: #31c48d;\n    border-color: rgba(49, 196, 141, var(--border-opacity));\n  }\n  .md\\:border-green-500 {\n    --border-opacity: 1;\n    border-color: #0e9f6e;\n    border-color: rgba(14, 159, 110, var(--border-opacity));\n  }\n  .md\\:border-green-600 {\n    --border-opacity: 1;\n    border-color: #057a55;\n    border-color: rgba(5, 122, 85, var(--border-opacity));\n  }\n  .md\\:border-green-700 {\n    --border-opacity: 1;\n    border-color: #046c4e;\n    border-color: rgba(4, 108, 78, var(--border-opacity));\n  }\n  .md\\:border-green-800 {\n    --border-opacity: 1;\n    border-color: #03543f;\n    border-color: rgba(3, 84, 63, var(--border-opacity));\n  }\n  .md\\:border-green-900 {\n    --border-opacity: 1;\n    border-color: #014737;\n    border-color: rgba(1, 71, 55, var(--border-opacity));\n  }\n  .md\\:border-teal-50 {\n    --border-opacity: 1;\n    border-color: #edfafa;\n    border-color: rgba(237, 250, 250, var(--border-opacity));\n  }\n  .md\\:border-teal-100 {\n    --border-opacity: 1;\n    border-color: #d5f5f6;\n    border-color: rgba(213, 245, 246, var(--border-opacity));\n  }\n  .md\\:border-teal-200 {\n    --border-opacity: 1;\n    border-color: #afecef;\n    border-color: rgba(175, 236, 239, var(--border-opacity));\n  }\n  .md\\:border-teal-300 {\n    --border-opacity: 1;\n    border-color: #7edce2;\n    border-color: rgba(126, 220, 226, var(--border-opacity));\n  }\n  .md\\:border-teal-400 {\n    --border-opacity: 1;\n    border-color: #16bdca;\n    border-color: rgba(22, 189, 202, var(--border-opacity));\n  }\n  .md\\:border-teal-500 {\n    --border-opacity: 1;\n    border-color: #0694a2;\n    border-color: rgba(6, 148, 162, var(--border-opacity));\n  }\n  .md\\:border-teal-600 {\n    --border-opacity: 1;\n    border-color: #047481;\n    border-color: rgba(4, 116, 129, var(--border-opacity));\n  }\n  .md\\:border-teal-700 {\n    --border-opacity: 1;\n    border-color: #036672;\n    border-color: rgba(3, 102, 114, var(--border-opacity));\n  }\n  .md\\:border-teal-800 {\n    --border-opacity: 1;\n    border-color: #05505c;\n    border-color: rgba(5, 80, 92, var(--border-opacity));\n  }\n  .md\\:border-teal-900 {\n    --border-opacity: 1;\n    border-color: #014451;\n    border-color: rgba(1, 68, 81, var(--border-opacity));\n  }\n  .md\\:border-blue-50 {\n    --border-opacity: 1;\n    border-color: #ebf5ff;\n    border-color: rgba(235, 245, 255, var(--border-opacity));\n  }\n  .md\\:border-blue-100 {\n    --border-opacity: 1;\n    border-color: #e1effe;\n    border-color: rgba(225, 239, 254, var(--border-opacity));\n  }\n  .md\\:border-blue-200 {\n    --border-opacity: 1;\n    border-color: #c3ddfd;\n    border-color: rgba(195, 221, 253, var(--border-opacity));\n  }\n  .md\\:border-blue-300 {\n    --border-opacity: 1;\n    border-color: #a4cafe;\n    border-color: rgba(164, 202, 254, var(--border-opacity));\n  }\n  .md\\:border-blue-400 {\n    --border-opacity: 1;\n    border-color: #76a9fa;\n    border-color: rgba(118, 169, 250, var(--border-opacity));\n  }\n  .md\\:border-blue-500 {\n    --border-opacity: 1;\n    border-color: #3f83f8;\n    border-color: rgba(63, 131, 248, var(--border-opacity));\n  }\n  .md\\:border-blue-600 {\n    --border-opacity: 1;\n    border-color: #1c64f2;\n    border-color: rgba(28, 100, 242, var(--border-opacity));\n  }\n  .md\\:border-blue-700 {\n    --border-opacity: 1;\n    border-color: #1a56db;\n    border-color: rgba(26, 86, 219, var(--border-opacity));\n  }\n  .md\\:border-blue-800 {\n    --border-opacity: 1;\n    border-color: #1e429f;\n    border-color: rgba(30, 66, 159, var(--border-opacity));\n  }\n  .md\\:border-blue-900 {\n    --border-opacity: 1;\n    border-color: #233876;\n    border-color: rgba(35, 56, 118, var(--border-opacity));\n  }\n  .md\\:border-indigo-50 {\n    --border-opacity: 1;\n    border-color: #f0f5ff;\n    border-color: rgba(240, 245, 255, var(--border-opacity));\n  }\n  .md\\:border-indigo-100 {\n    --border-opacity: 1;\n    border-color: #e5edff;\n    border-color: rgba(229, 237, 255, var(--border-opacity));\n  }\n  .md\\:border-indigo-200 {\n    --border-opacity: 1;\n    border-color: #cddbfe;\n    border-color: rgba(205, 219, 254, var(--border-opacity));\n  }\n  .md\\:border-indigo-300 {\n    --border-opacity: 1;\n    border-color: #b4c6fc;\n    border-color: rgba(180, 198, 252, var(--border-opacity));\n  }\n  .md\\:border-indigo-400 {\n    --border-opacity: 1;\n    border-color: #8da2fb;\n    border-color: rgba(141, 162, 251, var(--border-opacity));\n  }\n  .md\\:border-indigo-500 {\n    --border-opacity: 1;\n    border-color: #6875f5;\n    border-color: rgba(104, 117, 245, var(--border-opacity));\n  }\n  .md\\:border-indigo-600 {\n    --border-opacity: 1;\n    border-color: #5850ec;\n    border-color: rgba(88, 80, 236, var(--border-opacity));\n  }\n  .md\\:border-indigo-700 {\n    --border-opacity: 1;\n    border-color: #5145cd;\n    border-color: rgba(81, 69, 205, var(--border-opacity));\n  }\n  .md\\:border-indigo-800 {\n    --border-opacity: 1;\n    border-color: #42389d;\n    border-color: rgba(66, 56, 157, var(--border-opacity));\n  }\n  .md\\:border-indigo-900 {\n    --border-opacity: 1;\n    border-color: #362f78;\n    border-color: rgba(54, 47, 120, var(--border-opacity));\n  }\n  .md\\:border-purple-50 {\n    --border-opacity: 1;\n    border-color: #f6f5ff;\n    border-color: rgba(246, 245, 255, var(--border-opacity));\n  }\n  .md\\:border-purple-100 {\n    --border-opacity: 1;\n    border-color: #edebfe;\n    border-color: rgba(237, 235, 254, var(--border-opacity));\n  }\n  .md\\:border-purple-200 {\n    --border-opacity: 1;\n    border-color: #dcd7fe;\n    border-color: rgba(220, 215, 254, var(--border-opacity));\n  }\n  .md\\:border-purple-300 {\n    --border-opacity: 1;\n    border-color: #cabffd;\n    border-color: rgba(202, 191, 253, var(--border-opacity));\n  }\n  .md\\:border-purple-400 {\n    --border-opacity: 1;\n    border-color: #ac94fa;\n    border-color: rgba(172, 148, 250, var(--border-opacity));\n  }\n  .md\\:border-purple-500 {\n    --border-opacity: 1;\n    border-color: #9061f9;\n    border-color: rgba(144, 97, 249, var(--border-opacity));\n  }\n  .md\\:border-purple-600 {\n    --border-opacity: 1;\n    border-color: #7e3af2;\n    border-color: rgba(126, 58, 242, var(--border-opacity));\n  }\n  .md\\:border-purple-700 {\n    --border-opacity: 1;\n    border-color: #6c2bd9;\n    border-color: rgba(108, 43, 217, var(--border-opacity));\n  }\n  .md\\:border-purple-800 {\n    --border-opacity: 1;\n    border-color: #5521b5;\n    border-color: rgba(85, 33, 181, var(--border-opacity));\n  }\n  .md\\:border-purple-900 {\n    --border-opacity: 1;\n    border-color: #4a1d96;\n    border-color: rgba(74, 29, 150, var(--border-opacity));\n  }\n  .md\\:border-pink-50 {\n    --border-opacity: 1;\n    border-color: #fdf2f8;\n    border-color: rgba(253, 242, 248, var(--border-opacity));\n  }\n  .md\\:border-pink-100 {\n    --border-opacity: 1;\n    border-color: #fce8f3;\n    border-color: rgba(252, 232, 243, var(--border-opacity));\n  }\n  .md\\:border-pink-200 {\n    --border-opacity: 1;\n    border-color: #fad1e8;\n    border-color: rgba(250, 209, 232, var(--border-opacity));\n  }\n  .md\\:border-pink-300 {\n    --border-opacity: 1;\n    border-color: #f8b4d9;\n    border-color: rgba(248, 180, 217, var(--border-opacity));\n  }\n  .md\\:border-pink-400 {\n    --border-opacity: 1;\n    border-color: #f17eb8;\n    border-color: rgba(241, 126, 184, var(--border-opacity));\n  }\n  .md\\:border-pink-500 {\n    --border-opacity: 1;\n    border-color: #e74694;\n    border-color: rgba(231, 70, 148, var(--border-opacity));\n  }\n  .md\\:border-pink-600 {\n    --border-opacity: 1;\n    border-color: #d61f69;\n    border-color: rgba(214, 31, 105, var(--border-opacity));\n  }\n  .md\\:border-pink-700 {\n    --border-opacity: 1;\n    border-color: #bf125d;\n    border-color: rgba(191, 18, 93, var(--border-opacity));\n  }\n  .md\\:border-pink-800 {\n    --border-opacity: 1;\n    border-color: #99154b;\n    border-color: rgba(153, 21, 75, var(--border-opacity));\n  }\n  .md\\:border-pink-900 {\n    --border-opacity: 1;\n    border-color: #751a3d;\n    border-color: rgba(117, 26, 61, var(--border-opacity));\n  }\n  .md\\:border-cool-gray-50 {\n    --border-opacity: 1;\n    border-color: #f8fafc;\n    border-color: rgba(248, 250, 252, var(--border-opacity));\n  }\n  .md\\:border-cool-gray-100 {\n    --border-opacity: 1;\n    border-color: #f1f5f9;\n    border-color: rgba(241, 245, 249, var(--border-opacity));\n  }\n  .md\\:border-cool-gray-200 {\n    --border-opacity: 1;\n    border-color: #e2e8f0;\n    border-color: rgba(226, 232, 240, var(--border-opacity));\n  }\n  .md\\:border-cool-gray-300 {\n    --border-opacity: 1;\n    border-color: #cfd8e3;\n    border-color: rgba(207, 216, 227, var(--border-opacity));\n  }\n  .md\\:border-cool-gray-400 {\n    --border-opacity: 1;\n    border-color: #97a6ba;\n    border-color: rgba(151, 166, 186, var(--border-opacity));\n  }\n  .md\\:border-cool-gray-500 {\n    --border-opacity: 1;\n    border-color: #64748b;\n    border-color: rgba(100, 116, 139, var(--border-opacity));\n  }\n  .md\\:border-cool-gray-600 {\n    --border-opacity: 1;\n    border-color: #475569;\n    border-color: rgba(71, 85, 105, var(--border-opacity));\n  }\n  .md\\:border-cool-gray-700 {\n    --border-opacity: 1;\n    border-color: #364152;\n    border-color: rgba(54, 65, 82, var(--border-opacity));\n  }\n  .md\\:border-cool-gray-800 {\n    --border-opacity: 1;\n    border-color: #27303f;\n    border-color: rgba(39, 48, 63, var(--border-opacity));\n  }\n  .md\\:border-cool-gray-900 {\n    --border-opacity: 1;\n    border-color: #1a202e;\n    border-color: rgba(26, 32, 46, var(--border-opacity));\n  }\n  .group:hover .md\\:group-hover\\:border-current {\n    border-color: currentColor;\n  }\n  .group:hover .md\\:group-hover\\:border-transparent {\n    border-color: transparent;\n  }\n  .group:hover .md\\:group-hover\\:border-white {\n    --border-opacity: 1;\n    border-color: #ffffff;\n    border-color: rgba(255, 255, 255, var(--border-opacity));\n  }\n  .group:hover .md\\:group-hover\\:border-black {\n    --border-opacity: 1;\n    border-color: #000000;\n    border-color: rgba(0, 0, 0, var(--border-opacity));\n  }\n  .group:hover .md\\:group-hover\\:border-gray-50 {\n    --border-opacity: 1;\n    border-color: #f9fafb;\n    border-color: rgba(249, 250, 251, var(--border-opacity));\n  }\n  .group:hover .md\\:group-hover\\:border-gray-100 {\n    --border-opacity: 1;\n    border-color: #f4f5f7;\n    border-color: rgba(244, 245, 247, var(--border-opacity));\n  }\n  .group:hover .md\\:group-hover\\:border-gray-200 {\n    --border-opacity: 1;\n    border-color: #e5e7eb;\n    border-color: rgba(229, 231, 235, var(--border-opacity));\n  }\n  .group:hover .md\\:group-hover\\:border-gray-300 {\n    --border-opacity: 1;\n    border-color: #d2d6dc;\n    border-color: rgba(210, 214, 220, var(--border-opacity));\n  }\n  .group:hover .md\\:group-hover\\:border-gray-400 {\n    --border-opacity: 1;\n    border-color: #9fa6b2;\n    border-color: rgba(159, 166, 178, var(--border-opacity));\n  }\n  .group:hover .md\\:group-hover\\:border-gray-500 {\n    --border-opacity: 1;\n    border-color: #6b7280;\n    border-color: rgba(107, 114, 128, var(--border-opacity));\n  }\n  .group:hover .md\\:group-hover\\:border-gray-600 {\n    --border-opacity: 1;\n    border-color: #4b5563;\n    border-color: rgba(75, 85, 99, var(--border-opacity));\n  }\n  .group:hover .md\\:group-hover\\:border-gray-700 {\n    --border-opacity: 1;\n    border-color: #374151;\n    border-color: rgba(55, 65, 81, var(--border-opacity));\n  }\n  .group:hover .md\\:group-hover\\:border-gray-800 {\n    --border-opacity: 1;\n    border-color: #252f3f;\n    border-color: rgba(37, 47, 63, var(--border-opacity));\n  }\n  .group:hover .md\\:group-hover\\:border-gray-900 {\n    --border-opacity: 1;\n    border-color: #161e2e;\n    border-color: rgba(22, 30, 46, var(--border-opacity));\n  }\n  .group:hover .md\\:group-hover\\:border-red-50 {\n    --border-opacity: 1;\n    border-color: #fdf2f2;\n    border-color: rgba(253, 242, 242, var(--border-opacity));\n  }\n  .group:hover .md\\:group-hover\\:border-red-100 {\n    --border-opacity: 1;\n    border-color: #fde8e8;\n    border-color: rgba(253, 232, 232, var(--border-opacity));\n  }\n  .group:hover .md\\:group-hover\\:border-red-200 {\n    --border-opacity: 1;\n    border-color: #fbd5d5;\n    border-color: rgba(251, 213, 213, var(--border-opacity));\n  }\n  .group:hover .md\\:group-hover\\:border-red-300 {\n    --border-opacity: 1;\n    border-color: #f8b4b4;\n    border-color: rgba(248, 180, 180, var(--border-opacity));\n  }\n  .group:hover .md\\:group-hover\\:border-red-400 {\n    --border-opacity: 1;\n    border-color: #f98080;\n    border-color: rgba(249, 128, 128, var(--border-opacity));\n  }\n  .group:hover .md\\:group-hover\\:border-red-500 {\n    --border-opacity: 1;\n    border-color: #f05252;\n    border-color: rgba(240, 82, 82, var(--border-opacity));\n  }\n  .group:hover .md\\:group-hover\\:border-red-600 {\n    --border-opacity: 1;\n    border-color: #e02424;\n    border-color: rgba(224, 36, 36, var(--border-opacity));\n  }\n  .group:hover .md\\:group-hover\\:border-red-700 {\n    --border-opacity: 1;\n    border-color: #c81e1e;\n    border-color: rgba(200, 30, 30, var(--border-opacity));\n  }\n  .group:hover .md\\:group-hover\\:border-red-800 {\n    --border-opacity: 1;\n    border-color: #9b1c1c;\n    border-color: rgba(155, 28, 28, var(--border-opacity));\n  }\n  .group:hover .md\\:group-hover\\:border-red-900 {\n    --border-opacity: 1;\n    border-color: #771d1d;\n    border-color: rgba(119, 29, 29, var(--border-opacity));\n  }\n  .group:hover .md\\:group-hover\\:border-orange-50 {\n    --border-opacity: 1;\n    border-color: #fff8f1;\n    border-color: rgba(255, 248, 241, var(--border-opacity));\n  }\n  .group:hover .md\\:group-hover\\:border-orange-100 {\n    --border-opacity: 1;\n    border-color: #feecdc;\n    border-color: rgba(254, 236, 220, var(--border-opacity));\n  }\n  .group:hover .md\\:group-hover\\:border-orange-200 {\n    --border-opacity: 1;\n    border-color: #fcd9bd;\n    border-color: rgba(252, 217, 189, var(--border-opacity));\n  }\n  .group:hover .md\\:group-hover\\:border-orange-300 {\n    --border-opacity: 1;\n    border-color: #fdba8c;\n    border-color: rgba(253, 186, 140, var(--border-opacity));\n  }\n  .group:hover .md\\:group-hover\\:border-orange-400 {\n    --border-opacity: 1;\n    border-color: #ff8a4c;\n    border-color: rgba(255, 138, 76, var(--border-opacity));\n  }\n  .group:hover .md\\:group-hover\\:border-orange-500 {\n    --border-opacity: 1;\n    border-color: #ff5a1f;\n    border-color: rgba(255, 90, 31, var(--border-opacity));\n  }\n  .group:hover .md\\:group-hover\\:border-orange-600 {\n    --border-opacity: 1;\n    border-color: #d03801;\n    border-color: rgba(208, 56, 1, var(--border-opacity));\n  }\n  .group:hover .md\\:group-hover\\:border-orange-700 {\n    --border-opacity: 1;\n    border-color: #b43403;\n    border-color: rgba(180, 52, 3, var(--border-opacity));\n  }\n  .group:hover .md\\:group-hover\\:border-orange-800 {\n    --border-opacity: 1;\n    border-color: #8a2c0d;\n    border-color: rgba(138, 44, 13, var(--border-opacity));\n  }\n  .group:hover .md\\:group-hover\\:border-orange-900 {\n    --border-opacity: 1;\n    border-color: #73230d;\n    border-color: rgba(115, 35, 13, var(--border-opacity));\n  }\n  .group:hover .md\\:group-hover\\:border-yellow-50 {\n    --border-opacity: 1;\n    border-color: #fdfdea;\n    border-color: rgba(253, 253, 234, var(--border-opacity));\n  }\n  .group:hover .md\\:group-hover\\:border-yellow-100 {\n    --border-opacity: 1;\n    border-color: #fdf6b2;\n    border-color: rgba(253, 246, 178, var(--border-opacity));\n  }\n  .group:hover .md\\:group-hover\\:border-yellow-200 {\n    --border-opacity: 1;\n    border-color: #fce96a;\n    border-color: rgba(252, 233, 106, var(--border-opacity));\n  }\n  .group:hover .md\\:group-hover\\:border-yellow-300 {\n    --border-opacity: 1;\n    border-color: #faca15;\n    border-color: rgba(250, 202, 21, var(--border-opacity));\n  }\n  .group:hover .md\\:group-hover\\:border-yellow-400 {\n    --border-opacity: 1;\n    border-color: #e3a008;\n    border-color: rgba(227, 160, 8, var(--border-opacity));\n  }\n  .group:hover .md\\:group-hover\\:border-yellow-500 {\n    --border-opacity: 1;\n    border-color: #c27803;\n    border-color: rgba(194, 120, 3, var(--border-opacity));\n  }\n  .group:hover .md\\:group-hover\\:border-yellow-600 {\n    --border-opacity: 1;\n    border-color: #9f580a;\n    border-color: rgba(159, 88, 10, var(--border-opacity));\n  }\n  .group:hover .md\\:group-hover\\:border-yellow-700 {\n    --border-opacity: 1;\n    border-color: #8e4b10;\n    border-color: rgba(142, 75, 16, var(--border-opacity));\n  }\n  .group:hover .md\\:group-hover\\:border-yellow-800 {\n    --border-opacity: 1;\n    border-color: #723b13;\n    border-color: rgba(114, 59, 19, var(--border-opacity));\n  }\n  .group:hover .md\\:group-hover\\:border-yellow-900 {\n    --border-opacity: 1;\n    border-color: #633112;\n    border-color: rgba(99, 49, 18, var(--border-opacity));\n  }\n  .group:hover .md\\:group-hover\\:border-green-50 {\n    --border-opacity: 1;\n    border-color: #f3faf7;\n    border-color: rgba(243, 250, 247, var(--border-opacity));\n  }\n  .group:hover .md\\:group-hover\\:border-green-100 {\n    --border-opacity: 1;\n    border-color: #def7ec;\n    border-color: rgba(222, 247, 236, var(--border-opacity));\n  }\n  .group:hover .md\\:group-hover\\:border-green-200 {\n    --border-opacity: 1;\n    border-color: #bcf0da;\n    border-color: rgba(188, 240, 218, var(--border-opacity));\n  }\n  .group:hover .md\\:group-hover\\:border-green-300 {\n    --border-opacity: 1;\n    border-color: #84e1bc;\n    border-color: rgba(132, 225, 188, var(--border-opacity));\n  }\n  .group:hover .md\\:group-hover\\:border-green-400 {\n    --border-opacity: 1;\n    border-color: #31c48d;\n    border-color: rgba(49, 196, 141, var(--border-opacity));\n  }\n  .group:hover .md\\:group-hover\\:border-green-500 {\n    --border-opacity: 1;\n    border-color: #0e9f6e;\n    border-color: rgba(14, 159, 110, var(--border-opacity));\n  }\n  .group:hover .md\\:group-hover\\:border-green-600 {\n    --border-opacity: 1;\n    border-color: #057a55;\n    border-color: rgba(5, 122, 85, var(--border-opacity));\n  }\n  .group:hover .md\\:group-hover\\:border-green-700 {\n    --border-opacity: 1;\n    border-color: #046c4e;\n    border-color: rgba(4, 108, 78, var(--border-opacity));\n  }\n  .group:hover .md\\:group-hover\\:border-green-800 {\n    --border-opacity: 1;\n    border-color: #03543f;\n    border-color: rgba(3, 84, 63, var(--border-opacity));\n  }\n  .group:hover .md\\:group-hover\\:border-green-900 {\n    --border-opacity: 1;\n    border-color: #014737;\n    border-color: rgba(1, 71, 55, var(--border-opacity));\n  }\n  .group:hover .md\\:group-hover\\:border-teal-50 {\n    --border-opacity: 1;\n    border-color: #edfafa;\n    border-color: rgba(237, 250, 250, var(--border-opacity));\n  }\n  .group:hover .md\\:group-hover\\:border-teal-100 {\n    --border-opacity: 1;\n    border-color: #d5f5f6;\n    border-color: rgba(213, 245, 246, var(--border-opacity));\n  }\n  .group:hover .md\\:group-hover\\:border-teal-200 {\n    --border-opacity: 1;\n    border-color: #afecef;\n    border-color: rgba(175, 236, 239, var(--border-opacity));\n  }\n  .group:hover .md\\:group-hover\\:border-teal-300 {\n    --border-opacity: 1;\n    border-color: #7edce2;\n    border-color: rgba(126, 220, 226, var(--border-opacity));\n  }\n  .group:hover .md\\:group-hover\\:border-teal-400 {\n    --border-opacity: 1;\n    border-color: #16bdca;\n    border-color: rgba(22, 189, 202, var(--border-opacity));\n  }\n  .group:hover .md\\:group-hover\\:border-teal-500 {\n    --border-opacity: 1;\n    border-color: #0694a2;\n    border-color: rgba(6, 148, 162, var(--border-opacity));\n  }\n  .group:hover .md\\:group-hover\\:border-teal-600 {\n    --border-opacity: 1;\n    border-color: #047481;\n    border-color: rgba(4, 116, 129, var(--border-opacity));\n  }\n  .group:hover .md\\:group-hover\\:border-teal-700 {\n    --border-opacity: 1;\n    border-color: #036672;\n    border-color: rgba(3, 102, 114, var(--border-opacity));\n  }\n  .group:hover .md\\:group-hover\\:border-teal-800 {\n    --border-opacity: 1;\n    border-color: #05505c;\n    border-color: rgba(5, 80, 92, var(--border-opacity));\n  }\n  .group:hover .md\\:group-hover\\:border-teal-900 {\n    --border-opacity: 1;\n    border-color: #014451;\n    border-color: rgba(1, 68, 81, var(--border-opacity));\n  }\n  .group:hover .md\\:group-hover\\:border-blue-50 {\n    --border-opacity: 1;\n    border-color: #ebf5ff;\n    border-color: rgba(235, 245, 255, var(--border-opacity));\n  }\n  .group:hover .md\\:group-hover\\:border-blue-100 {\n    --border-opacity: 1;\n    border-color: #e1effe;\n    border-color: rgba(225, 239, 254, var(--border-opacity));\n  }\n  .group:hover .md\\:group-hover\\:border-blue-200 {\n    --border-opacity: 1;\n    border-color: #c3ddfd;\n    border-color: rgba(195, 221, 253, var(--border-opacity));\n  }\n  .group:hover .md\\:group-hover\\:border-blue-300 {\n    --border-opacity: 1;\n    border-color: #a4cafe;\n    border-color: rgba(164, 202, 254, var(--border-opacity));\n  }\n  .group:hover .md\\:group-hover\\:border-blue-400 {\n    --border-opacity: 1;\n    border-color: #76a9fa;\n    border-color: rgba(118, 169, 250, var(--border-opacity));\n  }\n  .group:hover .md\\:group-hover\\:border-blue-500 {\n    --border-opacity: 1;\n    border-color: #3f83f8;\n    border-color: rgba(63, 131, 248, var(--border-opacity));\n  }\n  .group:hover .md\\:group-hover\\:border-blue-600 {\n    --border-opacity: 1;\n    border-color: #1c64f2;\n    border-color: rgba(28, 100, 242, var(--border-opacity));\n  }\n  .group:hover .md\\:group-hover\\:border-blue-700 {\n    --border-opacity: 1;\n    border-color: #1a56db;\n    border-color: rgba(26, 86, 219, var(--border-opacity));\n  }\n  .group:hover .md\\:group-hover\\:border-blue-800 {\n    --border-opacity: 1;\n    border-color: #1e429f;\n    border-color: rgba(30, 66, 159, var(--border-opacity));\n  }\n  .group:hover .md\\:group-hover\\:border-blue-900 {\n    --border-opacity: 1;\n    border-color: #233876;\n    border-color: rgba(35, 56, 118, var(--border-opacity));\n  }\n  .group:hover .md\\:group-hover\\:border-indigo-50 {\n    --border-opacity: 1;\n    border-color: #f0f5ff;\n    border-color: rgba(240, 245, 255, var(--border-opacity));\n  }\n  .group:hover .md\\:group-hover\\:border-indigo-100 {\n    --border-opacity: 1;\n    border-color: #e5edff;\n    border-color: rgba(229, 237, 255, var(--border-opacity));\n  }\n  .group:hover .md\\:group-hover\\:border-indigo-200 {\n    --border-opacity: 1;\n    border-color: #cddbfe;\n    border-color: rgba(205, 219, 254, var(--border-opacity));\n  }\n  .group:hover .md\\:group-hover\\:border-indigo-300 {\n    --border-opacity: 1;\n    border-color: #b4c6fc;\n    border-color: rgba(180, 198, 252, var(--border-opacity));\n  }\n  .group:hover .md\\:group-hover\\:border-indigo-400 {\n    --border-opacity: 1;\n    border-color: #8da2fb;\n    border-color: rgba(141, 162, 251, var(--border-opacity));\n  }\n  .group:hover .md\\:group-hover\\:border-indigo-500 {\n    --border-opacity: 1;\n    border-color: #6875f5;\n    border-color: rgba(104, 117, 245, var(--border-opacity));\n  }\n  .group:hover .md\\:group-hover\\:border-indigo-600 {\n    --border-opacity: 1;\n    border-color: #5850ec;\n    border-color: rgba(88, 80, 236, var(--border-opacity));\n  }\n  .group:hover .md\\:group-hover\\:border-indigo-700 {\n    --border-opacity: 1;\n    border-color: #5145cd;\n    border-color: rgba(81, 69, 205, var(--border-opacity));\n  }\n  .group:hover .md\\:group-hover\\:border-indigo-800 {\n    --border-opacity: 1;\n    border-color: #42389d;\n    border-color: rgba(66, 56, 157, var(--border-opacity));\n  }\n  .group:hover .md\\:group-hover\\:border-indigo-900 {\n    --border-opacity: 1;\n    border-color: #362f78;\n    border-color: rgba(54, 47, 120, var(--border-opacity));\n  }\n  .group:hover .md\\:group-hover\\:border-purple-50 {\n    --border-opacity: 1;\n    border-color: #f6f5ff;\n    border-color: rgba(246, 245, 255, var(--border-opacity));\n  }\n  .group:hover .md\\:group-hover\\:border-purple-100 {\n    --border-opacity: 1;\n    border-color: #edebfe;\n    border-color: rgba(237, 235, 254, var(--border-opacity));\n  }\n  .group:hover .md\\:group-hover\\:border-purple-200 {\n    --border-opacity: 1;\n    border-color: #dcd7fe;\n    border-color: rgba(220, 215, 254, var(--border-opacity));\n  }\n  .group:hover .md\\:group-hover\\:border-purple-300 {\n    --border-opacity: 1;\n    border-color: #cabffd;\n    border-color: rgba(202, 191, 253, var(--border-opacity));\n  }\n  .group:hover .md\\:group-hover\\:border-purple-400 {\n    --border-opacity: 1;\n    border-color: #ac94fa;\n    border-color: rgba(172, 148, 250, var(--border-opacity));\n  }\n  .group:hover .md\\:group-hover\\:border-purple-500 {\n    --border-opacity: 1;\n    border-color: #9061f9;\n    border-color: rgba(144, 97, 249, var(--border-opacity));\n  }\n  .group:hover .md\\:group-hover\\:border-purple-600 {\n    --border-opacity: 1;\n    border-color: #7e3af2;\n    border-color: rgba(126, 58, 242, var(--border-opacity));\n  }\n  .group:hover .md\\:group-hover\\:border-purple-700 {\n    --border-opacity: 1;\n    border-color: #6c2bd9;\n    border-color: rgba(108, 43, 217, var(--border-opacity));\n  }\n  .group:hover .md\\:group-hover\\:border-purple-800 {\n    --border-opacity: 1;\n    border-color: #5521b5;\n    border-color: rgba(85, 33, 181, var(--border-opacity));\n  }\n  .group:hover .md\\:group-hover\\:border-purple-900 {\n    --border-opacity: 1;\n    border-color: #4a1d96;\n    border-color: rgba(74, 29, 150, var(--border-opacity));\n  }\n  .group:hover .md\\:group-hover\\:border-pink-50 {\n    --border-opacity: 1;\n    border-color: #fdf2f8;\n    border-color: rgba(253, 242, 248, var(--border-opacity));\n  }\n  .group:hover .md\\:group-hover\\:border-pink-100 {\n    --border-opacity: 1;\n    border-color: #fce8f3;\n    border-color: rgba(252, 232, 243, var(--border-opacity));\n  }\n  .group:hover .md\\:group-hover\\:border-pink-200 {\n    --border-opacity: 1;\n    border-color: #fad1e8;\n    border-color: rgba(250, 209, 232, var(--border-opacity));\n  }\n  .group:hover .md\\:group-hover\\:border-pink-300 {\n    --border-opacity: 1;\n    border-color: #f8b4d9;\n    border-color: rgba(248, 180, 217, var(--border-opacity));\n  }\n  .group:hover .md\\:group-hover\\:border-pink-400 {\n    --border-opacity: 1;\n    border-color: #f17eb8;\n    border-color: rgba(241, 126, 184, var(--border-opacity));\n  }\n  .group:hover .md\\:group-hover\\:border-pink-500 {\n    --border-opacity: 1;\n    border-color: #e74694;\n    border-color: rgba(231, 70, 148, var(--border-opacity));\n  }\n  .group:hover .md\\:group-hover\\:border-pink-600 {\n    --border-opacity: 1;\n    border-color: #d61f69;\n    border-color: rgba(214, 31, 105, var(--border-opacity));\n  }\n  .group:hover .md\\:group-hover\\:border-pink-700 {\n    --border-opacity: 1;\n    border-color: #bf125d;\n    border-color: rgba(191, 18, 93, var(--border-opacity));\n  }\n  .group:hover .md\\:group-hover\\:border-pink-800 {\n    --border-opacity: 1;\n    border-color: #99154b;\n    border-color: rgba(153, 21, 75, var(--border-opacity));\n  }\n  .group:hover .md\\:group-hover\\:border-pink-900 {\n    --border-opacity: 1;\n    border-color: #751a3d;\n    border-color: rgba(117, 26, 61, var(--border-opacity));\n  }\n  .group:hover .md\\:group-hover\\:border-cool-gray-50 {\n    --border-opacity: 1;\n    border-color: #f8fafc;\n    border-color: rgba(248, 250, 252, var(--border-opacity));\n  }\n  .group:hover .md\\:group-hover\\:border-cool-gray-100 {\n    --border-opacity: 1;\n    border-color: #f1f5f9;\n    border-color: rgba(241, 245, 249, var(--border-opacity));\n  }\n  .group:hover .md\\:group-hover\\:border-cool-gray-200 {\n    --border-opacity: 1;\n    border-color: #e2e8f0;\n    border-color: rgba(226, 232, 240, var(--border-opacity));\n  }\n  .group:hover .md\\:group-hover\\:border-cool-gray-300 {\n    --border-opacity: 1;\n    border-color: #cfd8e3;\n    border-color: rgba(207, 216, 227, var(--border-opacity));\n  }\n  .group:hover .md\\:group-hover\\:border-cool-gray-400 {\n    --border-opacity: 1;\n    border-color: #97a6ba;\n    border-color: rgba(151, 166, 186, var(--border-opacity));\n  }\n  .group:hover .md\\:group-hover\\:border-cool-gray-500 {\n    --border-opacity: 1;\n    border-color: #64748b;\n    border-color: rgba(100, 116, 139, var(--border-opacity));\n  }\n  .group:hover .md\\:group-hover\\:border-cool-gray-600 {\n    --border-opacity: 1;\n    border-color: #475569;\n    border-color: rgba(71, 85, 105, var(--border-opacity));\n  }\n  .group:hover .md\\:group-hover\\:border-cool-gray-700 {\n    --border-opacity: 1;\n    border-color: #364152;\n    border-color: rgba(54, 65, 82, var(--border-opacity));\n  }\n  .group:hover .md\\:group-hover\\:border-cool-gray-800 {\n    --border-opacity: 1;\n    border-color: #27303f;\n    border-color: rgba(39, 48, 63, var(--border-opacity));\n  }\n  .group:hover .md\\:group-hover\\:border-cool-gray-900 {\n    --border-opacity: 1;\n    border-color: #1a202e;\n    border-color: rgba(26, 32, 46, var(--border-opacity));\n  }\n  .group:focus .md\\:group-focus\\:border-current {\n    border-color: currentColor;\n  }\n  .group:focus .md\\:group-focus\\:border-transparent {\n    border-color: transparent;\n  }\n  .group:focus .md\\:group-focus\\:border-white {\n    --border-opacity: 1;\n    border-color: #ffffff;\n    border-color: rgba(255, 255, 255, var(--border-opacity));\n  }\n  .group:focus .md\\:group-focus\\:border-black {\n    --border-opacity: 1;\n    border-color: #000000;\n    border-color: rgba(0, 0, 0, var(--border-opacity));\n  }\n  .group:focus .md\\:group-focus\\:border-gray-50 {\n    --border-opacity: 1;\n    border-color: #f9fafb;\n    border-color: rgba(249, 250, 251, var(--border-opacity));\n  }\n  .group:focus .md\\:group-focus\\:border-gray-100 {\n    --border-opacity: 1;\n    border-color: #f4f5f7;\n    border-color: rgba(244, 245, 247, var(--border-opacity));\n  }\n  .group:focus .md\\:group-focus\\:border-gray-200 {\n    --border-opacity: 1;\n    border-color: #e5e7eb;\n    border-color: rgba(229, 231, 235, var(--border-opacity));\n  }\n  .group:focus .md\\:group-focus\\:border-gray-300 {\n    --border-opacity: 1;\n    border-color: #d2d6dc;\n    border-color: rgba(210, 214, 220, var(--border-opacity));\n  }\n  .group:focus .md\\:group-focus\\:border-gray-400 {\n    --border-opacity: 1;\n    border-color: #9fa6b2;\n    border-color: rgba(159, 166, 178, var(--border-opacity));\n  }\n  .group:focus .md\\:group-focus\\:border-gray-500 {\n    --border-opacity: 1;\n    border-color: #6b7280;\n    border-color: rgba(107, 114, 128, var(--border-opacity));\n  }\n  .group:focus .md\\:group-focus\\:border-gray-600 {\n    --border-opacity: 1;\n    border-color: #4b5563;\n    border-color: rgba(75, 85, 99, var(--border-opacity));\n  }\n  .group:focus .md\\:group-focus\\:border-gray-700 {\n    --border-opacity: 1;\n    border-color: #374151;\n    border-color: rgba(55, 65, 81, var(--border-opacity));\n  }\n  .group:focus .md\\:group-focus\\:border-gray-800 {\n    --border-opacity: 1;\n    border-color: #252f3f;\n    border-color: rgba(37, 47, 63, var(--border-opacity));\n  }\n  .group:focus .md\\:group-focus\\:border-gray-900 {\n    --border-opacity: 1;\n    border-color: #161e2e;\n    border-color: rgba(22, 30, 46, var(--border-opacity));\n  }\n  .group:focus .md\\:group-focus\\:border-red-50 {\n    --border-opacity: 1;\n    border-color: #fdf2f2;\n    border-color: rgba(253, 242, 242, var(--border-opacity));\n  }\n  .group:focus .md\\:group-focus\\:border-red-100 {\n    --border-opacity: 1;\n    border-color: #fde8e8;\n    border-color: rgba(253, 232, 232, var(--border-opacity));\n  }\n  .group:focus .md\\:group-focus\\:border-red-200 {\n    --border-opacity: 1;\n    border-color: #fbd5d5;\n    border-color: rgba(251, 213, 213, var(--border-opacity));\n  }\n  .group:focus .md\\:group-focus\\:border-red-300 {\n    --border-opacity: 1;\n    border-color: #f8b4b4;\n    border-color: rgba(248, 180, 180, var(--border-opacity));\n  }\n  .group:focus .md\\:group-focus\\:border-red-400 {\n    --border-opacity: 1;\n    border-color: #f98080;\n    border-color: rgba(249, 128, 128, var(--border-opacity));\n  }\n  .group:focus .md\\:group-focus\\:border-red-500 {\n    --border-opacity: 1;\n    border-color: #f05252;\n    border-color: rgba(240, 82, 82, var(--border-opacity));\n  }\n  .group:focus .md\\:group-focus\\:border-red-600 {\n    --border-opacity: 1;\n    border-color: #e02424;\n    border-color: rgba(224, 36, 36, var(--border-opacity));\n  }\n  .group:focus .md\\:group-focus\\:border-red-700 {\n    --border-opacity: 1;\n    border-color: #c81e1e;\n    border-color: rgba(200, 30, 30, var(--border-opacity));\n  }\n  .group:focus .md\\:group-focus\\:border-red-800 {\n    --border-opacity: 1;\n    border-color: #9b1c1c;\n    border-color: rgba(155, 28, 28, var(--border-opacity));\n  }\n  .group:focus .md\\:group-focus\\:border-red-900 {\n    --border-opacity: 1;\n    border-color: #771d1d;\n    border-color: rgba(119, 29, 29, var(--border-opacity));\n  }\n  .group:focus .md\\:group-focus\\:border-orange-50 {\n    --border-opacity: 1;\n    border-color: #fff8f1;\n    border-color: rgba(255, 248, 241, var(--border-opacity));\n  }\n  .group:focus .md\\:group-focus\\:border-orange-100 {\n    --border-opacity: 1;\n    border-color: #feecdc;\n    border-color: rgba(254, 236, 220, var(--border-opacity));\n  }\n  .group:focus .md\\:group-focus\\:border-orange-200 {\n    --border-opacity: 1;\n    border-color: #fcd9bd;\n    border-color: rgba(252, 217, 189, var(--border-opacity));\n  }\n  .group:focus .md\\:group-focus\\:border-orange-300 {\n    --border-opacity: 1;\n    border-color: #fdba8c;\n    border-color: rgba(253, 186, 140, var(--border-opacity));\n  }\n  .group:focus .md\\:group-focus\\:border-orange-400 {\n    --border-opacity: 1;\n    border-color: #ff8a4c;\n    border-color: rgba(255, 138, 76, var(--border-opacity));\n  }\n  .group:focus .md\\:group-focus\\:border-orange-500 {\n    --border-opacity: 1;\n    border-color: #ff5a1f;\n    border-color: rgba(255, 90, 31, var(--border-opacity));\n  }\n  .group:focus .md\\:group-focus\\:border-orange-600 {\n    --border-opacity: 1;\n    border-color: #d03801;\n    border-color: rgba(208, 56, 1, var(--border-opacity));\n  }\n  .group:focus .md\\:group-focus\\:border-orange-700 {\n    --border-opacity: 1;\n    border-color: #b43403;\n    border-color: rgba(180, 52, 3, var(--border-opacity));\n  }\n  .group:focus .md\\:group-focus\\:border-orange-800 {\n    --border-opacity: 1;\n    border-color: #8a2c0d;\n    border-color: rgba(138, 44, 13, var(--border-opacity));\n  }\n  .group:focus .md\\:group-focus\\:border-orange-900 {\n    --border-opacity: 1;\n    border-color: #73230d;\n    border-color: rgba(115, 35, 13, var(--border-opacity));\n  }\n  .group:focus .md\\:group-focus\\:border-yellow-50 {\n    --border-opacity: 1;\n    border-color: #fdfdea;\n    border-color: rgba(253, 253, 234, var(--border-opacity));\n  }\n  .group:focus .md\\:group-focus\\:border-yellow-100 {\n    --border-opacity: 1;\n    border-color: #fdf6b2;\n    border-color: rgba(253, 246, 178, var(--border-opacity));\n  }\n  .group:focus .md\\:group-focus\\:border-yellow-200 {\n    --border-opacity: 1;\n    border-color: #fce96a;\n    border-color: rgba(252, 233, 106, var(--border-opacity));\n  }\n  .group:focus .md\\:group-focus\\:border-yellow-300 {\n    --border-opacity: 1;\n    border-color: #faca15;\n    border-color: rgba(250, 202, 21, var(--border-opacity));\n  }\n  .group:focus .md\\:group-focus\\:border-yellow-400 {\n    --border-opacity: 1;\n    border-color: #e3a008;\n    border-color: rgba(227, 160, 8, var(--border-opacity));\n  }\n  .group:focus .md\\:group-focus\\:border-yellow-500 {\n    --border-opacity: 1;\n    border-color: #c27803;\n    border-color: rgba(194, 120, 3, var(--border-opacity));\n  }\n  .group:focus .md\\:group-focus\\:border-yellow-600 {\n    --border-opacity: 1;\n    border-color: #9f580a;\n    border-color: rgba(159, 88, 10, var(--border-opacity));\n  }\n  .group:focus .md\\:group-focus\\:border-yellow-700 {\n    --border-opacity: 1;\n    border-color: #8e4b10;\n    border-color: rgba(142, 75, 16, var(--border-opacity));\n  }\n  .group:focus .md\\:group-focus\\:border-yellow-800 {\n    --border-opacity: 1;\n    border-color: #723b13;\n    border-color: rgba(114, 59, 19, var(--border-opacity));\n  }\n  .group:focus .md\\:group-focus\\:border-yellow-900 {\n    --border-opacity: 1;\n    border-color: #633112;\n    border-color: rgba(99, 49, 18, var(--border-opacity));\n  }\n  .group:focus .md\\:group-focus\\:border-green-50 {\n    --border-opacity: 1;\n    border-color: #f3faf7;\n    border-color: rgba(243, 250, 247, var(--border-opacity));\n  }\n  .group:focus .md\\:group-focus\\:border-green-100 {\n    --border-opacity: 1;\n    border-color: #def7ec;\n    border-color: rgba(222, 247, 236, var(--border-opacity));\n  }\n  .group:focus .md\\:group-focus\\:border-green-200 {\n    --border-opacity: 1;\n    border-color: #bcf0da;\n    border-color: rgba(188, 240, 218, var(--border-opacity));\n  }\n  .group:focus .md\\:group-focus\\:border-green-300 {\n    --border-opacity: 1;\n    border-color: #84e1bc;\n    border-color: rgba(132, 225, 188, var(--border-opacity));\n  }\n  .group:focus .md\\:group-focus\\:border-green-400 {\n    --border-opacity: 1;\n    border-color: #31c48d;\n    border-color: rgba(49, 196, 141, var(--border-opacity));\n  }\n  .group:focus .md\\:group-focus\\:border-green-500 {\n    --border-opacity: 1;\n    border-color: #0e9f6e;\n    border-color: rgba(14, 159, 110, var(--border-opacity));\n  }\n  .group:focus .md\\:group-focus\\:border-green-600 {\n    --border-opacity: 1;\n    border-color: #057a55;\n    border-color: rgba(5, 122, 85, var(--border-opacity));\n  }\n  .group:focus .md\\:group-focus\\:border-green-700 {\n    --border-opacity: 1;\n    border-color: #046c4e;\n    border-color: rgba(4, 108, 78, var(--border-opacity));\n  }\n  .group:focus .md\\:group-focus\\:border-green-800 {\n    --border-opacity: 1;\n    border-color: #03543f;\n    border-color: rgba(3, 84, 63, var(--border-opacity));\n  }\n  .group:focus .md\\:group-focus\\:border-green-900 {\n    --border-opacity: 1;\n    border-color: #014737;\n    border-color: rgba(1, 71, 55, var(--border-opacity));\n  }\n  .group:focus .md\\:group-focus\\:border-teal-50 {\n    --border-opacity: 1;\n    border-color: #edfafa;\n    border-color: rgba(237, 250, 250, var(--border-opacity));\n  }\n  .group:focus .md\\:group-focus\\:border-teal-100 {\n    --border-opacity: 1;\n    border-color: #d5f5f6;\n    border-color: rgba(213, 245, 246, var(--border-opacity));\n  }\n  .group:focus .md\\:group-focus\\:border-teal-200 {\n    --border-opacity: 1;\n    border-color: #afecef;\n    border-color: rgba(175, 236, 239, var(--border-opacity));\n  }\n  .group:focus .md\\:group-focus\\:border-teal-300 {\n    --border-opacity: 1;\n    border-color: #7edce2;\n    border-color: rgba(126, 220, 226, var(--border-opacity));\n  }\n  .group:focus .md\\:group-focus\\:border-teal-400 {\n    --border-opacity: 1;\n    border-color: #16bdca;\n    border-color: rgba(22, 189, 202, var(--border-opacity));\n  }\n  .group:focus .md\\:group-focus\\:border-teal-500 {\n    --border-opacity: 1;\n    border-color: #0694a2;\n    border-color: rgba(6, 148, 162, var(--border-opacity));\n  }\n  .group:focus .md\\:group-focus\\:border-teal-600 {\n    --border-opacity: 1;\n    border-color: #047481;\n    border-color: rgba(4, 116, 129, var(--border-opacity));\n  }\n  .group:focus .md\\:group-focus\\:border-teal-700 {\n    --border-opacity: 1;\n    border-color: #036672;\n    border-color: rgba(3, 102, 114, var(--border-opacity));\n  }\n  .group:focus .md\\:group-focus\\:border-teal-800 {\n    --border-opacity: 1;\n    border-color: #05505c;\n    border-color: rgba(5, 80, 92, var(--border-opacity));\n  }\n  .group:focus .md\\:group-focus\\:border-teal-900 {\n    --border-opacity: 1;\n    border-color: #014451;\n    border-color: rgba(1, 68, 81, var(--border-opacity));\n  }\n  .group:focus .md\\:group-focus\\:border-blue-50 {\n    --border-opacity: 1;\n    border-color: #ebf5ff;\n    border-color: rgba(235, 245, 255, var(--border-opacity));\n  }\n  .group:focus .md\\:group-focus\\:border-blue-100 {\n    --border-opacity: 1;\n    border-color: #e1effe;\n    border-color: rgba(225, 239, 254, var(--border-opacity));\n  }\n  .group:focus .md\\:group-focus\\:border-blue-200 {\n    --border-opacity: 1;\n    border-color: #c3ddfd;\n    border-color: rgba(195, 221, 253, var(--border-opacity));\n  }\n  .group:focus .md\\:group-focus\\:border-blue-300 {\n    --border-opacity: 1;\n    border-color: #a4cafe;\n    border-color: rgba(164, 202, 254, var(--border-opacity));\n  }\n  .group:focus .md\\:group-focus\\:border-blue-400 {\n    --border-opacity: 1;\n    border-color: #76a9fa;\n    border-color: rgba(118, 169, 250, var(--border-opacity));\n  }\n  .group:focus .md\\:group-focus\\:border-blue-500 {\n    --border-opacity: 1;\n    border-color: #3f83f8;\n    border-color: rgba(63, 131, 248, var(--border-opacity));\n  }\n  .group:focus .md\\:group-focus\\:border-blue-600 {\n    --border-opacity: 1;\n    border-color: #1c64f2;\n    border-color: rgba(28, 100, 242, var(--border-opacity));\n  }\n  .group:focus .md\\:group-focus\\:border-blue-700 {\n    --border-opacity: 1;\n    border-color: #1a56db;\n    border-color: rgba(26, 86, 219, var(--border-opacity));\n  }\n  .group:focus .md\\:group-focus\\:border-blue-800 {\n    --border-opacity: 1;\n    border-color: #1e429f;\n    border-color: rgba(30, 66, 159, var(--border-opacity));\n  }\n  .group:focus .md\\:group-focus\\:border-blue-900 {\n    --border-opacity: 1;\n    border-color: #233876;\n    border-color: rgba(35, 56, 118, var(--border-opacity));\n  }\n  .group:focus .md\\:group-focus\\:border-indigo-50 {\n    --border-opacity: 1;\n    border-color: #f0f5ff;\n    border-color: rgba(240, 245, 255, var(--border-opacity));\n  }\n  .group:focus .md\\:group-focus\\:border-indigo-100 {\n    --border-opacity: 1;\n    border-color: #e5edff;\n    border-color: rgba(229, 237, 255, var(--border-opacity));\n  }\n  .group:focus .md\\:group-focus\\:border-indigo-200 {\n    --border-opacity: 1;\n    border-color: #cddbfe;\n    border-color: rgba(205, 219, 254, var(--border-opacity));\n  }\n  .group:focus .md\\:group-focus\\:border-indigo-300 {\n    --border-opacity: 1;\n    border-color: #b4c6fc;\n    border-color: rgba(180, 198, 252, var(--border-opacity));\n  }\n  .group:focus .md\\:group-focus\\:border-indigo-400 {\n    --border-opacity: 1;\n    border-color: #8da2fb;\n    border-color: rgba(141, 162, 251, var(--border-opacity));\n  }\n  .group:focus .md\\:group-focus\\:border-indigo-500 {\n    --border-opacity: 1;\n    border-color: #6875f5;\n    border-color: rgba(104, 117, 245, var(--border-opacity));\n  }\n  .group:focus .md\\:group-focus\\:border-indigo-600 {\n    --border-opacity: 1;\n    border-color: #5850ec;\n    border-color: rgba(88, 80, 236, var(--border-opacity));\n  }\n  .group:focus .md\\:group-focus\\:border-indigo-700 {\n    --border-opacity: 1;\n    border-color: #5145cd;\n    border-color: rgba(81, 69, 205, var(--border-opacity));\n  }\n  .group:focus .md\\:group-focus\\:border-indigo-800 {\n    --border-opacity: 1;\n    border-color: #42389d;\n    border-color: rgba(66, 56, 157, var(--border-opacity));\n  }\n  .group:focus .md\\:group-focus\\:border-indigo-900 {\n    --border-opacity: 1;\n    border-color: #362f78;\n    border-color: rgba(54, 47, 120, var(--border-opacity));\n  }\n  .group:focus .md\\:group-focus\\:border-purple-50 {\n    --border-opacity: 1;\n    border-color: #f6f5ff;\n    border-color: rgba(246, 245, 255, var(--border-opacity));\n  }\n  .group:focus .md\\:group-focus\\:border-purple-100 {\n    --border-opacity: 1;\n    border-color: #edebfe;\n    border-color: rgba(237, 235, 254, var(--border-opacity));\n  }\n  .group:focus .md\\:group-focus\\:border-purple-200 {\n    --border-opacity: 1;\n    border-color: #dcd7fe;\n    border-color: rgba(220, 215, 254, var(--border-opacity));\n  }\n  .group:focus .md\\:group-focus\\:border-purple-300 {\n    --border-opacity: 1;\n    border-color: #cabffd;\n    border-color: rgba(202, 191, 253, var(--border-opacity));\n  }\n  .group:focus .md\\:group-focus\\:border-purple-400 {\n    --border-opacity: 1;\n    border-color: #ac94fa;\n    border-color: rgba(172, 148, 250, var(--border-opacity));\n  }\n  .group:focus .md\\:group-focus\\:border-purple-500 {\n    --border-opacity: 1;\n    border-color: #9061f9;\n    border-color: rgba(144, 97, 249, var(--border-opacity));\n  }\n  .group:focus .md\\:group-focus\\:border-purple-600 {\n    --border-opacity: 1;\n    border-color: #7e3af2;\n    border-color: rgba(126, 58, 242, var(--border-opacity));\n  }\n  .group:focus .md\\:group-focus\\:border-purple-700 {\n    --border-opacity: 1;\n    border-color: #6c2bd9;\n    border-color: rgba(108, 43, 217, var(--border-opacity));\n  }\n  .group:focus .md\\:group-focus\\:border-purple-800 {\n    --border-opacity: 1;\n    border-color: #5521b5;\n    border-color: rgba(85, 33, 181, var(--border-opacity));\n  }\n  .group:focus .md\\:group-focus\\:border-purple-900 {\n    --border-opacity: 1;\n    border-color: #4a1d96;\n    border-color: rgba(74, 29, 150, var(--border-opacity));\n  }\n  .group:focus .md\\:group-focus\\:border-pink-50 {\n    --border-opacity: 1;\n    border-color: #fdf2f8;\n    border-color: rgba(253, 242, 248, var(--border-opacity));\n  }\n  .group:focus .md\\:group-focus\\:border-pink-100 {\n    --border-opacity: 1;\n    border-color: #fce8f3;\n    border-color: rgba(252, 232, 243, var(--border-opacity));\n  }\n  .group:focus .md\\:group-focus\\:border-pink-200 {\n    --border-opacity: 1;\n    border-color: #fad1e8;\n    border-color: rgba(250, 209, 232, var(--border-opacity));\n  }\n  .group:focus .md\\:group-focus\\:border-pink-300 {\n    --border-opacity: 1;\n    border-color: #f8b4d9;\n    border-color: rgba(248, 180, 217, var(--border-opacity));\n  }\n  .group:focus .md\\:group-focus\\:border-pink-400 {\n    --border-opacity: 1;\n    border-color: #f17eb8;\n    border-color: rgba(241, 126, 184, var(--border-opacity));\n  }\n  .group:focus .md\\:group-focus\\:border-pink-500 {\n    --border-opacity: 1;\n    border-color: #e74694;\n    border-color: rgba(231, 70, 148, var(--border-opacity));\n  }\n  .group:focus .md\\:group-focus\\:border-pink-600 {\n    --border-opacity: 1;\n    border-color: #d61f69;\n    border-color: rgba(214, 31, 105, var(--border-opacity));\n  }\n  .group:focus .md\\:group-focus\\:border-pink-700 {\n    --border-opacity: 1;\n    border-color: #bf125d;\n    border-color: rgba(191, 18, 93, var(--border-opacity));\n  }\n  .group:focus .md\\:group-focus\\:border-pink-800 {\n    --border-opacity: 1;\n    border-color: #99154b;\n    border-color: rgba(153, 21, 75, var(--border-opacity));\n  }\n  .group:focus .md\\:group-focus\\:border-pink-900 {\n    --border-opacity: 1;\n    border-color: #751a3d;\n    border-color: rgba(117, 26, 61, var(--border-opacity));\n  }\n  .group:focus .md\\:group-focus\\:border-cool-gray-50 {\n    --border-opacity: 1;\n    border-color: #f8fafc;\n    border-color: rgba(248, 250, 252, var(--border-opacity));\n  }\n  .group:focus .md\\:group-focus\\:border-cool-gray-100 {\n    --border-opacity: 1;\n    border-color: #f1f5f9;\n    border-color: rgba(241, 245, 249, var(--border-opacity));\n  }\n  .group:focus .md\\:group-focus\\:border-cool-gray-200 {\n    --border-opacity: 1;\n    border-color: #e2e8f0;\n    border-color: rgba(226, 232, 240, var(--border-opacity));\n  }\n  .group:focus .md\\:group-focus\\:border-cool-gray-300 {\n    --border-opacity: 1;\n    border-color: #cfd8e3;\n    border-color: rgba(207, 216, 227, var(--border-opacity));\n  }\n  .group:focus .md\\:group-focus\\:border-cool-gray-400 {\n    --border-opacity: 1;\n    border-color: #97a6ba;\n    border-color: rgba(151, 166, 186, var(--border-opacity));\n  }\n  .group:focus .md\\:group-focus\\:border-cool-gray-500 {\n    --border-opacity: 1;\n    border-color: #64748b;\n    border-color: rgba(100, 116, 139, var(--border-opacity));\n  }\n  .group:focus .md\\:group-focus\\:border-cool-gray-600 {\n    --border-opacity: 1;\n    border-color: #475569;\n    border-color: rgba(71, 85, 105, var(--border-opacity));\n  }\n  .group:focus .md\\:group-focus\\:border-cool-gray-700 {\n    --border-opacity: 1;\n    border-color: #364152;\n    border-color: rgba(54, 65, 82, var(--border-opacity));\n  }\n  .group:focus .md\\:group-focus\\:border-cool-gray-800 {\n    --border-opacity: 1;\n    border-color: #27303f;\n    border-color: rgba(39, 48, 63, var(--border-opacity));\n  }\n  .group:focus .md\\:group-focus\\:border-cool-gray-900 {\n    --border-opacity: 1;\n    border-color: #1a202e;\n    border-color: rgba(26, 32, 46, var(--border-opacity));\n  }\n  .md\\:hover\\:border-current:hover {\n    border-color: currentColor;\n  }\n  .md\\:hover\\:border-transparent:hover {\n    border-color: transparent;\n  }\n  .md\\:hover\\:border-white:hover {\n    --border-opacity: 1;\n    border-color: #ffffff;\n    border-color: rgba(255, 255, 255, var(--border-opacity));\n  }\n  .md\\:hover\\:border-black:hover {\n    --border-opacity: 1;\n    border-color: #000000;\n    border-color: rgba(0, 0, 0, var(--border-opacity));\n  }\n  .md\\:hover\\:border-gray-50:hover {\n    --border-opacity: 1;\n    border-color: #f9fafb;\n    border-color: rgba(249, 250, 251, var(--border-opacity));\n  }\n  .md\\:hover\\:border-gray-100:hover {\n    --border-opacity: 1;\n    border-color: #f4f5f7;\n    border-color: rgba(244, 245, 247, var(--border-opacity));\n  }\n  .md\\:hover\\:border-gray-200:hover {\n    --border-opacity: 1;\n    border-color: #e5e7eb;\n    border-color: rgba(229, 231, 235, var(--border-opacity));\n  }\n  .md\\:hover\\:border-gray-300:hover {\n    --border-opacity: 1;\n    border-color: #d2d6dc;\n    border-color: rgba(210, 214, 220, var(--border-opacity));\n  }\n  .md\\:hover\\:border-gray-400:hover {\n    --border-opacity: 1;\n    border-color: #9fa6b2;\n    border-color: rgba(159, 166, 178, var(--border-opacity));\n  }\n  .md\\:hover\\:border-gray-500:hover {\n    --border-opacity: 1;\n    border-color: #6b7280;\n    border-color: rgba(107, 114, 128, var(--border-opacity));\n  }\n  .md\\:hover\\:border-gray-600:hover {\n    --border-opacity: 1;\n    border-color: #4b5563;\n    border-color: rgba(75, 85, 99, var(--border-opacity));\n  }\n  .md\\:hover\\:border-gray-700:hover {\n    --border-opacity: 1;\n    border-color: #374151;\n    border-color: rgba(55, 65, 81, var(--border-opacity));\n  }\n  .md\\:hover\\:border-gray-800:hover {\n    --border-opacity: 1;\n    border-color: #252f3f;\n    border-color: rgba(37, 47, 63, var(--border-opacity));\n  }\n  .md\\:hover\\:border-gray-900:hover {\n    --border-opacity: 1;\n    border-color: #161e2e;\n    border-color: rgba(22, 30, 46, var(--border-opacity));\n  }\n  .md\\:hover\\:border-red-50:hover {\n    --border-opacity: 1;\n    border-color: #fdf2f2;\n    border-color: rgba(253, 242, 242, var(--border-opacity));\n  }\n  .md\\:hover\\:border-red-100:hover {\n    --border-opacity: 1;\n    border-color: #fde8e8;\n    border-color: rgba(253, 232, 232, var(--border-opacity));\n  }\n  .md\\:hover\\:border-red-200:hover {\n    --border-opacity: 1;\n    border-color: #fbd5d5;\n    border-color: rgba(251, 213, 213, var(--border-opacity));\n  }\n  .md\\:hover\\:border-red-300:hover {\n    --border-opacity: 1;\n    border-color: #f8b4b4;\n    border-color: rgba(248, 180, 180, var(--border-opacity));\n  }\n  .md\\:hover\\:border-red-400:hover {\n    --border-opacity: 1;\n    border-color: #f98080;\n    border-color: rgba(249, 128, 128, var(--border-opacity));\n  }\n  .md\\:hover\\:border-red-500:hover {\n    --border-opacity: 1;\n    border-color: #f05252;\n    border-color: rgba(240, 82, 82, var(--border-opacity));\n  }\n  .md\\:hover\\:border-red-600:hover {\n    --border-opacity: 1;\n    border-color: #e02424;\n    border-color: rgba(224, 36, 36, var(--border-opacity));\n  }\n  .md\\:hover\\:border-red-700:hover {\n    --border-opacity: 1;\n    border-color: #c81e1e;\n    border-color: rgba(200, 30, 30, var(--border-opacity));\n  }\n  .md\\:hover\\:border-red-800:hover {\n    --border-opacity: 1;\n    border-color: #9b1c1c;\n    border-color: rgba(155, 28, 28, var(--border-opacity));\n  }\n  .md\\:hover\\:border-red-900:hover {\n    --border-opacity: 1;\n    border-color: #771d1d;\n    border-color: rgba(119, 29, 29, var(--border-opacity));\n  }\n  .md\\:hover\\:border-orange-50:hover {\n    --border-opacity: 1;\n    border-color: #fff8f1;\n    border-color: rgba(255, 248, 241, var(--border-opacity));\n  }\n  .md\\:hover\\:border-orange-100:hover {\n    --border-opacity: 1;\n    border-color: #feecdc;\n    border-color: rgba(254, 236, 220, var(--border-opacity));\n  }\n  .md\\:hover\\:border-orange-200:hover {\n    --border-opacity: 1;\n    border-color: #fcd9bd;\n    border-color: rgba(252, 217, 189, var(--border-opacity));\n  }\n  .md\\:hover\\:border-orange-300:hover {\n    --border-opacity: 1;\n    border-color: #fdba8c;\n    border-color: rgba(253, 186, 140, var(--border-opacity));\n  }\n  .md\\:hover\\:border-orange-400:hover {\n    --border-opacity: 1;\n    border-color: #ff8a4c;\n    border-color: rgba(255, 138, 76, var(--border-opacity));\n  }\n  .md\\:hover\\:border-orange-500:hover {\n    --border-opacity: 1;\n    border-color: #ff5a1f;\n    border-color: rgba(255, 90, 31, var(--border-opacity));\n  }\n  .md\\:hover\\:border-orange-600:hover {\n    --border-opacity: 1;\n    border-color: #d03801;\n    border-color: rgba(208, 56, 1, var(--border-opacity));\n  }\n  .md\\:hover\\:border-orange-700:hover {\n    --border-opacity: 1;\n    border-color: #b43403;\n    border-color: rgba(180, 52, 3, var(--border-opacity));\n  }\n  .md\\:hover\\:border-orange-800:hover {\n    --border-opacity: 1;\n    border-color: #8a2c0d;\n    border-color: rgba(138, 44, 13, var(--border-opacity));\n  }\n  .md\\:hover\\:border-orange-900:hover {\n    --border-opacity: 1;\n    border-color: #73230d;\n    border-color: rgba(115, 35, 13, var(--border-opacity));\n  }\n  .md\\:hover\\:border-yellow-50:hover {\n    --border-opacity: 1;\n    border-color: #fdfdea;\n    border-color: rgba(253, 253, 234, var(--border-opacity));\n  }\n  .md\\:hover\\:border-yellow-100:hover {\n    --border-opacity: 1;\n    border-color: #fdf6b2;\n    border-color: rgba(253, 246, 178, var(--border-opacity));\n  }\n  .md\\:hover\\:border-yellow-200:hover {\n    --border-opacity: 1;\n    border-color: #fce96a;\n    border-color: rgba(252, 233, 106, var(--border-opacity));\n  }\n  .md\\:hover\\:border-yellow-300:hover {\n    --border-opacity: 1;\n    border-color: #faca15;\n    border-color: rgba(250, 202, 21, var(--border-opacity));\n  }\n  .md\\:hover\\:border-yellow-400:hover {\n    --border-opacity: 1;\n    border-color: #e3a008;\n    border-color: rgba(227, 160, 8, var(--border-opacity));\n  }\n  .md\\:hover\\:border-yellow-500:hover {\n    --border-opacity: 1;\n    border-color: #c27803;\n    border-color: rgba(194, 120, 3, var(--border-opacity));\n  }\n  .md\\:hover\\:border-yellow-600:hover {\n    --border-opacity: 1;\n    border-color: #9f580a;\n    border-color: rgba(159, 88, 10, var(--border-opacity));\n  }\n  .md\\:hover\\:border-yellow-700:hover {\n    --border-opacity: 1;\n    border-color: #8e4b10;\n    border-color: rgba(142, 75, 16, var(--border-opacity));\n  }\n  .md\\:hover\\:border-yellow-800:hover {\n    --border-opacity: 1;\n    border-color: #723b13;\n    border-color: rgba(114, 59, 19, var(--border-opacity));\n  }\n  .md\\:hover\\:border-yellow-900:hover {\n    --border-opacity: 1;\n    border-color: #633112;\n    border-color: rgba(99, 49, 18, var(--border-opacity));\n  }\n  .md\\:hover\\:border-green-50:hover {\n    --border-opacity: 1;\n    border-color: #f3faf7;\n    border-color: rgba(243, 250, 247, var(--border-opacity));\n  }\n  .md\\:hover\\:border-green-100:hover {\n    --border-opacity: 1;\n    border-color: #def7ec;\n    border-color: rgba(222, 247, 236, var(--border-opacity));\n  }\n  .md\\:hover\\:border-green-200:hover {\n    --border-opacity: 1;\n    border-color: #bcf0da;\n    border-color: rgba(188, 240, 218, var(--border-opacity));\n  }\n  .md\\:hover\\:border-green-300:hover {\n    --border-opacity: 1;\n    border-color: #84e1bc;\n    border-color: rgba(132, 225, 188, var(--border-opacity));\n  }\n  .md\\:hover\\:border-green-400:hover {\n    --border-opacity: 1;\n    border-color: #31c48d;\n    border-color: rgba(49, 196, 141, var(--border-opacity));\n  }\n  .md\\:hover\\:border-green-500:hover {\n    --border-opacity: 1;\n    border-color: #0e9f6e;\n    border-color: rgba(14, 159, 110, var(--border-opacity));\n  }\n  .md\\:hover\\:border-green-600:hover {\n    --border-opacity: 1;\n    border-color: #057a55;\n    border-color: rgba(5, 122, 85, var(--border-opacity));\n  }\n  .md\\:hover\\:border-green-700:hover {\n    --border-opacity: 1;\n    border-color: #046c4e;\n    border-color: rgba(4, 108, 78, var(--border-opacity));\n  }\n  .md\\:hover\\:border-green-800:hover {\n    --border-opacity: 1;\n    border-color: #03543f;\n    border-color: rgba(3, 84, 63, var(--border-opacity));\n  }\n  .md\\:hover\\:border-green-900:hover {\n    --border-opacity: 1;\n    border-color: #014737;\n    border-color: rgba(1, 71, 55, var(--border-opacity));\n  }\n  .md\\:hover\\:border-teal-50:hover {\n    --border-opacity: 1;\n    border-color: #edfafa;\n    border-color: rgba(237, 250, 250, var(--border-opacity));\n  }\n  .md\\:hover\\:border-teal-100:hover {\n    --border-opacity: 1;\n    border-color: #d5f5f6;\n    border-color: rgba(213, 245, 246, var(--border-opacity));\n  }\n  .md\\:hover\\:border-teal-200:hover {\n    --border-opacity: 1;\n    border-color: #afecef;\n    border-color: rgba(175, 236, 239, var(--border-opacity));\n  }\n  .md\\:hover\\:border-teal-300:hover {\n    --border-opacity: 1;\n    border-color: #7edce2;\n    border-color: rgba(126, 220, 226, var(--border-opacity));\n  }\n  .md\\:hover\\:border-teal-400:hover {\n    --border-opacity: 1;\n    border-color: #16bdca;\n    border-color: rgba(22, 189, 202, var(--border-opacity));\n  }\n  .md\\:hover\\:border-teal-500:hover {\n    --border-opacity: 1;\n    border-color: #0694a2;\n    border-color: rgba(6, 148, 162, var(--border-opacity));\n  }\n  .md\\:hover\\:border-teal-600:hover {\n    --border-opacity: 1;\n    border-color: #047481;\n    border-color: rgba(4, 116, 129, var(--border-opacity));\n  }\n  .md\\:hover\\:border-teal-700:hover {\n    --border-opacity: 1;\n    border-color: #036672;\n    border-color: rgba(3, 102, 114, var(--border-opacity));\n  }\n  .md\\:hover\\:border-teal-800:hover {\n    --border-opacity: 1;\n    border-color: #05505c;\n    border-color: rgba(5, 80, 92, var(--border-opacity));\n  }\n  .md\\:hover\\:border-teal-900:hover {\n    --border-opacity: 1;\n    border-color: #014451;\n    border-color: rgba(1, 68, 81, var(--border-opacity));\n  }\n  .md\\:hover\\:border-blue-50:hover {\n    --border-opacity: 1;\n    border-color: #ebf5ff;\n    border-color: rgba(235, 245, 255, var(--border-opacity));\n  }\n  .md\\:hover\\:border-blue-100:hover {\n    --border-opacity: 1;\n    border-color: #e1effe;\n    border-color: rgba(225, 239, 254, var(--border-opacity));\n  }\n  .md\\:hover\\:border-blue-200:hover {\n    --border-opacity: 1;\n    border-color: #c3ddfd;\n    border-color: rgba(195, 221, 253, var(--border-opacity));\n  }\n  .md\\:hover\\:border-blue-300:hover {\n    --border-opacity: 1;\n    border-color: #a4cafe;\n    border-color: rgba(164, 202, 254, var(--border-opacity));\n  }\n  .md\\:hover\\:border-blue-400:hover {\n    --border-opacity: 1;\n    border-color: #76a9fa;\n    border-color: rgba(118, 169, 250, var(--border-opacity));\n  }\n  .md\\:hover\\:border-blue-500:hover {\n    --border-opacity: 1;\n    border-color: #3f83f8;\n    border-color: rgba(63, 131, 248, var(--border-opacity));\n  }\n  .md\\:hover\\:border-blue-600:hover {\n    --border-opacity: 1;\n    border-color: #1c64f2;\n    border-color: rgba(28, 100, 242, var(--border-opacity));\n  }\n  .md\\:hover\\:border-blue-700:hover {\n    --border-opacity: 1;\n    border-color: #1a56db;\n    border-color: rgba(26, 86, 219, var(--border-opacity));\n  }\n  .md\\:hover\\:border-blue-800:hover {\n    --border-opacity: 1;\n    border-color: #1e429f;\n    border-color: rgba(30, 66, 159, var(--border-opacity));\n  }\n  .md\\:hover\\:border-blue-900:hover {\n    --border-opacity: 1;\n    border-color: #233876;\n    border-color: rgba(35, 56, 118, var(--border-opacity));\n  }\n  .md\\:hover\\:border-indigo-50:hover {\n    --border-opacity: 1;\n    border-color: #f0f5ff;\n    border-color: rgba(240, 245, 255, var(--border-opacity));\n  }\n  .md\\:hover\\:border-indigo-100:hover {\n    --border-opacity: 1;\n    border-color: #e5edff;\n    border-color: rgba(229, 237, 255, var(--border-opacity));\n  }\n  .md\\:hover\\:border-indigo-200:hover {\n    --border-opacity: 1;\n    border-color: #cddbfe;\n    border-color: rgba(205, 219, 254, var(--border-opacity));\n  }\n  .md\\:hover\\:border-indigo-300:hover {\n    --border-opacity: 1;\n    border-color: #b4c6fc;\n    border-color: rgba(180, 198, 252, var(--border-opacity));\n  }\n  .md\\:hover\\:border-indigo-400:hover {\n    --border-opacity: 1;\n    border-color: #8da2fb;\n    border-color: rgba(141, 162, 251, var(--border-opacity));\n  }\n  .md\\:hover\\:border-indigo-500:hover {\n    --border-opacity: 1;\n    border-color: #6875f5;\n    border-color: rgba(104, 117, 245, var(--border-opacity));\n  }\n  .md\\:hover\\:border-indigo-600:hover {\n    --border-opacity: 1;\n    border-color: #5850ec;\n    border-color: rgba(88, 80, 236, var(--border-opacity));\n  }\n  .md\\:hover\\:border-indigo-700:hover {\n    --border-opacity: 1;\n    border-color: #5145cd;\n    border-color: rgba(81, 69, 205, var(--border-opacity));\n  }\n  .md\\:hover\\:border-indigo-800:hover {\n    --border-opacity: 1;\n    border-color: #42389d;\n    border-color: rgba(66, 56, 157, var(--border-opacity));\n  }\n  .md\\:hover\\:border-indigo-900:hover {\n    --border-opacity: 1;\n    border-color: #362f78;\n    border-color: rgba(54, 47, 120, var(--border-opacity));\n  }\n  .md\\:hover\\:border-purple-50:hover {\n    --border-opacity: 1;\n    border-color: #f6f5ff;\n    border-color: rgba(246, 245, 255, var(--border-opacity));\n  }\n  .md\\:hover\\:border-purple-100:hover {\n    --border-opacity: 1;\n    border-color: #edebfe;\n    border-color: rgba(237, 235, 254, var(--border-opacity));\n  }\n  .md\\:hover\\:border-purple-200:hover {\n    --border-opacity: 1;\n    border-color: #dcd7fe;\n    border-color: rgba(220, 215, 254, var(--border-opacity));\n  }\n  .md\\:hover\\:border-purple-300:hover {\n    --border-opacity: 1;\n    border-color: #cabffd;\n    border-color: rgba(202, 191, 253, var(--border-opacity));\n  }\n  .md\\:hover\\:border-purple-400:hover {\n    --border-opacity: 1;\n    border-color: #ac94fa;\n    border-color: rgba(172, 148, 250, var(--border-opacity));\n  }\n  .md\\:hover\\:border-purple-500:hover {\n    --border-opacity: 1;\n    border-color: #9061f9;\n    border-color: rgba(144, 97, 249, var(--border-opacity));\n  }\n  .md\\:hover\\:border-purple-600:hover {\n    --border-opacity: 1;\n    border-color: #7e3af2;\n    border-color: rgba(126, 58, 242, var(--border-opacity));\n  }\n  .md\\:hover\\:border-purple-700:hover {\n    --border-opacity: 1;\n    border-color: #6c2bd9;\n    border-color: rgba(108, 43, 217, var(--border-opacity));\n  }\n  .md\\:hover\\:border-purple-800:hover {\n    --border-opacity: 1;\n    border-color: #5521b5;\n    border-color: rgba(85, 33, 181, var(--border-opacity));\n  }\n  .md\\:hover\\:border-purple-900:hover {\n    --border-opacity: 1;\n    border-color: #4a1d96;\n    border-color: rgba(74, 29, 150, var(--border-opacity));\n  }\n  .md\\:hover\\:border-pink-50:hover {\n    --border-opacity: 1;\n    border-color: #fdf2f8;\n    border-color: rgba(253, 242, 248, var(--border-opacity));\n  }\n  .md\\:hover\\:border-pink-100:hover {\n    --border-opacity: 1;\n    border-color: #fce8f3;\n    border-color: rgba(252, 232, 243, var(--border-opacity));\n  }\n  .md\\:hover\\:border-pink-200:hover {\n    --border-opacity: 1;\n    border-color: #fad1e8;\n    border-color: rgba(250, 209, 232, var(--border-opacity));\n  }\n  .md\\:hover\\:border-pink-300:hover {\n    --border-opacity: 1;\n    border-color: #f8b4d9;\n    border-color: rgba(248, 180, 217, var(--border-opacity));\n  }\n  .md\\:hover\\:border-pink-400:hover {\n    --border-opacity: 1;\n    border-color: #f17eb8;\n    border-color: rgba(241, 126, 184, var(--border-opacity));\n  }\n  .md\\:hover\\:border-pink-500:hover {\n    --border-opacity: 1;\n    border-color: #e74694;\n    border-color: rgba(231, 70, 148, var(--border-opacity));\n  }\n  .md\\:hover\\:border-pink-600:hover {\n    --border-opacity: 1;\n    border-color: #d61f69;\n    border-color: rgba(214, 31, 105, var(--border-opacity));\n  }\n  .md\\:hover\\:border-pink-700:hover {\n    --border-opacity: 1;\n    border-color: #bf125d;\n    border-color: rgba(191, 18, 93, var(--border-opacity));\n  }\n  .md\\:hover\\:border-pink-800:hover {\n    --border-opacity: 1;\n    border-color: #99154b;\n    border-color: rgba(153, 21, 75, var(--border-opacity));\n  }\n  .md\\:hover\\:border-pink-900:hover {\n    --border-opacity: 1;\n    border-color: #751a3d;\n    border-color: rgba(117, 26, 61, var(--border-opacity));\n  }\n  .md\\:hover\\:border-cool-gray-50:hover {\n    --border-opacity: 1;\n    border-color: #f8fafc;\n    border-color: rgba(248, 250, 252, var(--border-opacity));\n  }\n  .md\\:hover\\:border-cool-gray-100:hover {\n    --border-opacity: 1;\n    border-color: #f1f5f9;\n    border-color: rgba(241, 245, 249, var(--border-opacity));\n  }\n  .md\\:hover\\:border-cool-gray-200:hover {\n    --border-opacity: 1;\n    border-color: #e2e8f0;\n    border-color: rgba(226, 232, 240, var(--border-opacity));\n  }\n  .md\\:hover\\:border-cool-gray-300:hover {\n    --border-opacity: 1;\n    border-color: #cfd8e3;\n    border-color: rgba(207, 216, 227, var(--border-opacity));\n  }\n  .md\\:hover\\:border-cool-gray-400:hover {\n    --border-opacity: 1;\n    border-color: #97a6ba;\n    border-color: rgba(151, 166, 186, var(--border-opacity));\n  }\n  .md\\:hover\\:border-cool-gray-500:hover {\n    --border-opacity: 1;\n    border-color: #64748b;\n    border-color: rgba(100, 116, 139, var(--border-opacity));\n  }\n  .md\\:hover\\:border-cool-gray-600:hover {\n    --border-opacity: 1;\n    border-color: #475569;\n    border-color: rgba(71, 85, 105, var(--border-opacity));\n  }\n  .md\\:hover\\:border-cool-gray-700:hover {\n    --border-opacity: 1;\n    border-color: #364152;\n    border-color: rgba(54, 65, 82, var(--border-opacity));\n  }\n  .md\\:hover\\:border-cool-gray-800:hover {\n    --border-opacity: 1;\n    border-color: #27303f;\n    border-color: rgba(39, 48, 63, var(--border-opacity));\n  }\n  .md\\:hover\\:border-cool-gray-900:hover {\n    --border-opacity: 1;\n    border-color: #1a202e;\n    border-color: rgba(26, 32, 46, var(--border-opacity));\n  }\n  .md\\:focus-within\\:border-current:focus-within {\n    border-color: currentColor;\n  }\n  .md\\:focus-within\\:border-transparent:focus-within {\n    border-color: transparent;\n  }\n  .md\\:focus-within\\:border-white:focus-within {\n    --border-opacity: 1;\n    border-color: #ffffff;\n    border-color: rgba(255, 255, 255, var(--border-opacity));\n  }\n  .md\\:focus-within\\:border-black:focus-within {\n    --border-opacity: 1;\n    border-color: #000000;\n    border-color: rgba(0, 0, 0, var(--border-opacity));\n  }\n  .md\\:focus-within\\:border-gray-50:focus-within {\n    --border-opacity: 1;\n    border-color: #f9fafb;\n    border-color: rgba(249, 250, 251, var(--border-opacity));\n  }\n  .md\\:focus-within\\:border-gray-100:focus-within {\n    --border-opacity: 1;\n    border-color: #f4f5f7;\n    border-color: rgba(244, 245, 247, var(--border-opacity));\n  }\n  .md\\:focus-within\\:border-gray-200:focus-within {\n    --border-opacity: 1;\n    border-color: #e5e7eb;\n    border-color: rgba(229, 231, 235, var(--border-opacity));\n  }\n  .md\\:focus-within\\:border-gray-300:focus-within {\n    --border-opacity: 1;\n    border-color: #d2d6dc;\n    border-color: rgba(210, 214, 220, var(--border-opacity));\n  }\n  .md\\:focus-within\\:border-gray-400:focus-within {\n    --border-opacity: 1;\n    border-color: #9fa6b2;\n    border-color: rgba(159, 166, 178, var(--border-opacity));\n  }\n  .md\\:focus-within\\:border-gray-500:focus-within {\n    --border-opacity: 1;\n    border-color: #6b7280;\n    border-color: rgba(107, 114, 128, var(--border-opacity));\n  }\n  .md\\:focus-within\\:border-gray-600:focus-within {\n    --border-opacity: 1;\n    border-color: #4b5563;\n    border-color: rgba(75, 85, 99, var(--border-opacity));\n  }\n  .md\\:focus-within\\:border-gray-700:focus-within {\n    --border-opacity: 1;\n    border-color: #374151;\n    border-color: rgba(55, 65, 81, var(--border-opacity));\n  }\n  .md\\:focus-within\\:border-gray-800:focus-within {\n    --border-opacity: 1;\n    border-color: #252f3f;\n    border-color: rgba(37, 47, 63, var(--border-opacity));\n  }\n  .md\\:focus-within\\:border-gray-900:focus-within {\n    --border-opacity: 1;\n    border-color: #161e2e;\n    border-color: rgba(22, 30, 46, var(--border-opacity));\n  }\n  .md\\:focus-within\\:border-red-50:focus-within {\n    --border-opacity: 1;\n    border-color: #fdf2f2;\n    border-color: rgba(253, 242, 242, var(--border-opacity));\n  }\n  .md\\:focus-within\\:border-red-100:focus-within {\n    --border-opacity: 1;\n    border-color: #fde8e8;\n    border-color: rgba(253, 232, 232, var(--border-opacity));\n  }\n  .md\\:focus-within\\:border-red-200:focus-within {\n    --border-opacity: 1;\n    border-color: #fbd5d5;\n    border-color: rgba(251, 213, 213, var(--border-opacity));\n  }\n  .md\\:focus-within\\:border-red-300:focus-within {\n    --border-opacity: 1;\n    border-color: #f8b4b4;\n    border-color: rgba(248, 180, 180, var(--border-opacity));\n  }\n  .md\\:focus-within\\:border-red-400:focus-within {\n    --border-opacity: 1;\n    border-color: #f98080;\n    border-color: rgba(249, 128, 128, var(--border-opacity));\n  }\n  .md\\:focus-within\\:border-red-500:focus-within {\n    --border-opacity: 1;\n    border-color: #f05252;\n    border-color: rgba(240, 82, 82, var(--border-opacity));\n  }\n  .md\\:focus-within\\:border-red-600:focus-within {\n    --border-opacity: 1;\n    border-color: #e02424;\n    border-color: rgba(224, 36, 36, var(--border-opacity));\n  }\n  .md\\:focus-within\\:border-red-700:focus-within {\n    --border-opacity: 1;\n    border-color: #c81e1e;\n    border-color: rgba(200, 30, 30, var(--border-opacity));\n  }\n  .md\\:focus-within\\:border-red-800:focus-within {\n    --border-opacity: 1;\n    border-color: #9b1c1c;\n    border-color: rgba(155, 28, 28, var(--border-opacity));\n  }\n  .md\\:focus-within\\:border-red-900:focus-within {\n    --border-opacity: 1;\n    border-color: #771d1d;\n    border-color: rgba(119, 29, 29, var(--border-opacity));\n  }\n  .md\\:focus-within\\:border-orange-50:focus-within {\n    --border-opacity: 1;\n    border-color: #fff8f1;\n    border-color: rgba(255, 248, 241, var(--border-opacity));\n  }\n  .md\\:focus-within\\:border-orange-100:focus-within {\n    --border-opacity: 1;\n    border-color: #feecdc;\n    border-color: rgba(254, 236, 220, var(--border-opacity));\n  }\n  .md\\:focus-within\\:border-orange-200:focus-within {\n    --border-opacity: 1;\n    border-color: #fcd9bd;\n    border-color: rgba(252, 217, 189, var(--border-opacity));\n  }\n  .md\\:focus-within\\:border-orange-300:focus-within {\n    --border-opacity: 1;\n    border-color: #fdba8c;\n    border-color: rgba(253, 186, 140, var(--border-opacity));\n  }\n  .md\\:focus-within\\:border-orange-400:focus-within {\n    --border-opacity: 1;\n    border-color: #ff8a4c;\n    border-color: rgba(255, 138, 76, var(--border-opacity));\n  }\n  .md\\:focus-within\\:border-orange-500:focus-within {\n    --border-opacity: 1;\n    border-color: #ff5a1f;\n    border-color: rgba(255, 90, 31, var(--border-opacity));\n  }\n  .md\\:focus-within\\:border-orange-600:focus-within {\n    --border-opacity: 1;\n    border-color: #d03801;\n    border-color: rgba(208, 56, 1, var(--border-opacity));\n  }\n  .md\\:focus-within\\:border-orange-700:focus-within {\n    --border-opacity: 1;\n    border-color: #b43403;\n    border-color: rgba(180, 52, 3, var(--border-opacity));\n  }\n  .md\\:focus-within\\:border-orange-800:focus-within {\n    --border-opacity: 1;\n    border-color: #8a2c0d;\n    border-color: rgba(138, 44, 13, var(--border-opacity));\n  }\n  .md\\:focus-within\\:border-orange-900:focus-within {\n    --border-opacity: 1;\n    border-color: #73230d;\n    border-color: rgba(115, 35, 13, var(--border-opacity));\n  }\n  .md\\:focus-within\\:border-yellow-50:focus-within {\n    --border-opacity: 1;\n    border-color: #fdfdea;\n    border-color: rgba(253, 253, 234, var(--border-opacity));\n  }\n  .md\\:focus-within\\:border-yellow-100:focus-within {\n    --border-opacity: 1;\n    border-color: #fdf6b2;\n    border-color: rgba(253, 246, 178, var(--border-opacity));\n  }\n  .md\\:focus-within\\:border-yellow-200:focus-within {\n    --border-opacity: 1;\n    border-color: #fce96a;\n    border-color: rgba(252, 233, 106, var(--border-opacity));\n  }\n  .md\\:focus-within\\:border-yellow-300:focus-within {\n    --border-opacity: 1;\n    border-color: #faca15;\n    border-color: rgba(250, 202, 21, var(--border-opacity));\n  }\n  .md\\:focus-within\\:border-yellow-400:focus-within {\n    --border-opacity: 1;\n    border-color: #e3a008;\n    border-color: rgba(227, 160, 8, var(--border-opacity));\n  }\n  .md\\:focus-within\\:border-yellow-500:focus-within {\n    --border-opacity: 1;\n    border-color: #c27803;\n    border-color: rgba(194, 120, 3, var(--border-opacity));\n  }\n  .md\\:focus-within\\:border-yellow-600:focus-within {\n    --border-opacity: 1;\n    border-color: #9f580a;\n    border-color: rgba(159, 88, 10, var(--border-opacity));\n  }\n  .md\\:focus-within\\:border-yellow-700:focus-within {\n    --border-opacity: 1;\n    border-color: #8e4b10;\n    border-color: rgba(142, 75, 16, var(--border-opacity));\n  }\n  .md\\:focus-within\\:border-yellow-800:focus-within {\n    --border-opacity: 1;\n    border-color: #723b13;\n    border-color: rgba(114, 59, 19, var(--border-opacity));\n  }\n  .md\\:focus-within\\:border-yellow-900:focus-within {\n    --border-opacity: 1;\n    border-color: #633112;\n    border-color: rgba(99, 49, 18, var(--border-opacity));\n  }\n  .md\\:focus-within\\:border-green-50:focus-within {\n    --border-opacity: 1;\n    border-color: #f3faf7;\n    border-color: rgba(243, 250, 247, var(--border-opacity));\n  }\n  .md\\:focus-within\\:border-green-100:focus-within {\n    --border-opacity: 1;\n    border-color: #def7ec;\n    border-color: rgba(222, 247, 236, var(--border-opacity));\n  }\n  .md\\:focus-within\\:border-green-200:focus-within {\n    --border-opacity: 1;\n    border-color: #bcf0da;\n    border-color: rgba(188, 240, 218, var(--border-opacity));\n  }\n  .md\\:focus-within\\:border-green-300:focus-within {\n    --border-opacity: 1;\n    border-color: #84e1bc;\n    border-color: rgba(132, 225, 188, var(--border-opacity));\n  }\n  .md\\:focus-within\\:border-green-400:focus-within {\n    --border-opacity: 1;\n    border-color: #31c48d;\n    border-color: rgba(49, 196, 141, var(--border-opacity));\n  }\n  .md\\:focus-within\\:border-green-500:focus-within {\n    --border-opacity: 1;\n    border-color: #0e9f6e;\n    border-color: rgba(14, 159, 110, var(--border-opacity));\n  }\n  .md\\:focus-within\\:border-green-600:focus-within {\n    --border-opacity: 1;\n    border-color: #057a55;\n    border-color: rgba(5, 122, 85, var(--border-opacity));\n  }\n  .md\\:focus-within\\:border-green-700:focus-within {\n    --border-opacity: 1;\n    border-color: #046c4e;\n    border-color: rgba(4, 108, 78, var(--border-opacity));\n  }\n  .md\\:focus-within\\:border-green-800:focus-within {\n    --border-opacity: 1;\n    border-color: #03543f;\n    border-color: rgba(3, 84, 63, var(--border-opacity));\n  }\n  .md\\:focus-within\\:border-green-900:focus-within {\n    --border-opacity: 1;\n    border-color: #014737;\n    border-color: rgba(1, 71, 55, var(--border-opacity));\n  }\n  .md\\:focus-within\\:border-teal-50:focus-within {\n    --border-opacity: 1;\n    border-color: #edfafa;\n    border-color: rgba(237, 250, 250, var(--border-opacity));\n  }\n  .md\\:focus-within\\:border-teal-100:focus-within {\n    --border-opacity: 1;\n    border-color: #d5f5f6;\n    border-color: rgba(213, 245, 246, var(--border-opacity));\n  }\n  .md\\:focus-within\\:border-teal-200:focus-within {\n    --border-opacity: 1;\n    border-color: #afecef;\n    border-color: rgba(175, 236, 239, var(--border-opacity));\n  }\n  .md\\:focus-within\\:border-teal-300:focus-within {\n    --border-opacity: 1;\n    border-color: #7edce2;\n    border-color: rgba(126, 220, 226, var(--border-opacity));\n  }\n  .md\\:focus-within\\:border-teal-400:focus-within {\n    --border-opacity: 1;\n    border-color: #16bdca;\n    border-color: rgba(22, 189, 202, var(--border-opacity));\n  }\n  .md\\:focus-within\\:border-teal-500:focus-within {\n    --border-opacity: 1;\n    border-color: #0694a2;\n    border-color: rgba(6, 148, 162, var(--border-opacity));\n  }\n  .md\\:focus-within\\:border-teal-600:focus-within {\n    --border-opacity: 1;\n    border-color: #047481;\n    border-color: rgba(4, 116, 129, var(--border-opacity));\n  }\n  .md\\:focus-within\\:border-teal-700:focus-within {\n    --border-opacity: 1;\n    border-color: #036672;\n    border-color: rgba(3, 102, 114, var(--border-opacity));\n  }\n  .md\\:focus-within\\:border-teal-800:focus-within {\n    --border-opacity: 1;\n    border-color: #05505c;\n    border-color: rgba(5, 80, 92, var(--border-opacity));\n  }\n  .md\\:focus-within\\:border-teal-900:focus-within {\n    --border-opacity: 1;\n    border-color: #014451;\n    border-color: rgba(1, 68, 81, var(--border-opacity));\n  }\n  .md\\:focus-within\\:border-blue-50:focus-within {\n    --border-opacity: 1;\n    border-color: #ebf5ff;\n    border-color: rgba(235, 245, 255, var(--border-opacity));\n  }\n  .md\\:focus-within\\:border-blue-100:focus-within {\n    --border-opacity: 1;\n    border-color: #e1effe;\n    border-color: rgba(225, 239, 254, var(--border-opacity));\n  }\n  .md\\:focus-within\\:border-blue-200:focus-within {\n    --border-opacity: 1;\n    border-color: #c3ddfd;\n    border-color: rgba(195, 221, 253, var(--border-opacity));\n  }\n  .md\\:focus-within\\:border-blue-300:focus-within {\n    --border-opacity: 1;\n    border-color: #a4cafe;\n    border-color: rgba(164, 202, 254, var(--border-opacity));\n  }\n  .md\\:focus-within\\:border-blue-400:focus-within {\n    --border-opacity: 1;\n    border-color: #76a9fa;\n    border-color: rgba(118, 169, 250, var(--border-opacity));\n  }\n  .md\\:focus-within\\:border-blue-500:focus-within {\n    --border-opacity: 1;\n    border-color: #3f83f8;\n    border-color: rgba(63, 131, 248, var(--border-opacity));\n  }\n  .md\\:focus-within\\:border-blue-600:focus-within {\n    --border-opacity: 1;\n    border-color: #1c64f2;\n    border-color: rgba(28, 100, 242, var(--border-opacity));\n  }\n  .md\\:focus-within\\:border-blue-700:focus-within {\n    --border-opacity: 1;\n    border-color: #1a56db;\n    border-color: rgba(26, 86, 219, var(--border-opacity));\n  }\n  .md\\:focus-within\\:border-blue-800:focus-within {\n    --border-opacity: 1;\n    border-color: #1e429f;\n    border-color: rgba(30, 66, 159, var(--border-opacity));\n  }\n  .md\\:focus-within\\:border-blue-900:focus-within {\n    --border-opacity: 1;\n    border-color: #233876;\n    border-color: rgba(35, 56, 118, var(--border-opacity));\n  }\n  .md\\:focus-within\\:border-indigo-50:focus-within {\n    --border-opacity: 1;\n    border-color: #f0f5ff;\n    border-color: rgba(240, 245, 255, var(--border-opacity));\n  }\n  .md\\:focus-within\\:border-indigo-100:focus-within {\n    --border-opacity: 1;\n    border-color: #e5edff;\n    border-color: rgba(229, 237, 255, var(--border-opacity));\n  }\n  .md\\:focus-within\\:border-indigo-200:focus-within {\n    --border-opacity: 1;\n    border-color: #cddbfe;\n    border-color: rgba(205, 219, 254, var(--border-opacity));\n  }\n  .md\\:focus-within\\:border-indigo-300:focus-within {\n    --border-opacity: 1;\n    border-color: #b4c6fc;\n    border-color: rgba(180, 198, 252, var(--border-opacity));\n  }\n  .md\\:focus-within\\:border-indigo-400:focus-within {\n    --border-opacity: 1;\n    border-color: #8da2fb;\n    border-color: rgba(141, 162, 251, var(--border-opacity));\n  }\n  .md\\:focus-within\\:border-indigo-500:focus-within {\n    --border-opacity: 1;\n    border-color: #6875f5;\n    border-color: rgba(104, 117, 245, var(--border-opacity));\n  }\n  .md\\:focus-within\\:border-indigo-600:focus-within {\n    --border-opacity: 1;\n    border-color: #5850ec;\n    border-color: rgba(88, 80, 236, var(--border-opacity));\n  }\n  .md\\:focus-within\\:border-indigo-700:focus-within {\n    --border-opacity: 1;\n    border-color: #5145cd;\n    border-color: rgba(81, 69, 205, var(--border-opacity));\n  }\n  .md\\:focus-within\\:border-indigo-800:focus-within {\n    --border-opacity: 1;\n    border-color: #42389d;\n    border-color: rgba(66, 56, 157, var(--border-opacity));\n  }\n  .md\\:focus-within\\:border-indigo-900:focus-within {\n    --border-opacity: 1;\n    border-color: #362f78;\n    border-color: rgba(54, 47, 120, var(--border-opacity));\n  }\n  .md\\:focus-within\\:border-purple-50:focus-within {\n    --border-opacity: 1;\n    border-color: #f6f5ff;\n    border-color: rgba(246, 245, 255, var(--border-opacity));\n  }\n  .md\\:focus-within\\:border-purple-100:focus-within {\n    --border-opacity: 1;\n    border-color: #edebfe;\n    border-color: rgba(237, 235, 254, var(--border-opacity));\n  }\n  .md\\:focus-within\\:border-purple-200:focus-within {\n    --border-opacity: 1;\n    border-color: #dcd7fe;\n    border-color: rgba(220, 215, 254, var(--border-opacity));\n  }\n  .md\\:focus-within\\:border-purple-300:focus-within {\n    --border-opacity: 1;\n    border-color: #cabffd;\n    border-color: rgba(202, 191, 253, var(--border-opacity));\n  }\n  .md\\:focus-within\\:border-purple-400:focus-within {\n    --border-opacity: 1;\n    border-color: #ac94fa;\n    border-color: rgba(172, 148, 250, var(--border-opacity));\n  }\n  .md\\:focus-within\\:border-purple-500:focus-within {\n    --border-opacity: 1;\n    border-color: #9061f9;\n    border-color: rgba(144, 97, 249, var(--border-opacity));\n  }\n  .md\\:focus-within\\:border-purple-600:focus-within {\n    --border-opacity: 1;\n    border-color: #7e3af2;\n    border-color: rgba(126, 58, 242, var(--border-opacity));\n  }\n  .md\\:focus-within\\:border-purple-700:focus-within {\n    --border-opacity: 1;\n    border-color: #6c2bd9;\n    border-color: rgba(108, 43, 217, var(--border-opacity));\n  }\n  .md\\:focus-within\\:border-purple-800:focus-within {\n    --border-opacity: 1;\n    border-color: #5521b5;\n    border-color: rgba(85, 33, 181, var(--border-opacity));\n  }\n  .md\\:focus-within\\:border-purple-900:focus-within {\n    --border-opacity: 1;\n    border-color: #4a1d96;\n    border-color: rgba(74, 29, 150, var(--border-opacity));\n  }\n  .md\\:focus-within\\:border-pink-50:focus-within {\n    --border-opacity: 1;\n    border-color: #fdf2f8;\n    border-color: rgba(253, 242, 248, var(--border-opacity));\n  }\n  .md\\:focus-within\\:border-pink-100:focus-within {\n    --border-opacity: 1;\n    border-color: #fce8f3;\n    border-color: rgba(252, 232, 243, var(--border-opacity));\n  }\n  .md\\:focus-within\\:border-pink-200:focus-within {\n    --border-opacity: 1;\n    border-color: #fad1e8;\n    border-color: rgba(250, 209, 232, var(--border-opacity));\n  }\n  .md\\:focus-within\\:border-pink-300:focus-within {\n    --border-opacity: 1;\n    border-color: #f8b4d9;\n    border-color: rgba(248, 180, 217, var(--border-opacity));\n  }\n  .md\\:focus-within\\:border-pink-400:focus-within {\n    --border-opacity: 1;\n    border-color: #f17eb8;\n    border-color: rgba(241, 126, 184, var(--border-opacity));\n  }\n  .md\\:focus-within\\:border-pink-500:focus-within {\n    --border-opacity: 1;\n    border-color: #e74694;\n    border-color: rgba(231, 70, 148, var(--border-opacity));\n  }\n  .md\\:focus-within\\:border-pink-600:focus-within {\n    --border-opacity: 1;\n    border-color: #d61f69;\n    border-color: rgba(214, 31, 105, var(--border-opacity));\n  }\n  .md\\:focus-within\\:border-pink-700:focus-within {\n    --border-opacity: 1;\n    border-color: #bf125d;\n    border-color: rgba(191, 18, 93, var(--border-opacity));\n  }\n  .md\\:focus-within\\:border-pink-800:focus-within {\n    --border-opacity: 1;\n    border-color: #99154b;\n    border-color: rgba(153, 21, 75, var(--border-opacity));\n  }\n  .md\\:focus-within\\:border-pink-900:focus-within {\n    --border-opacity: 1;\n    border-color: #751a3d;\n    border-color: rgba(117, 26, 61, var(--border-opacity));\n  }\n  .md\\:focus-within\\:border-cool-gray-50:focus-within {\n    --border-opacity: 1;\n    border-color: #f8fafc;\n    border-color: rgba(248, 250, 252, var(--border-opacity));\n  }\n  .md\\:focus-within\\:border-cool-gray-100:focus-within {\n    --border-opacity: 1;\n    border-color: #f1f5f9;\n    border-color: rgba(241, 245, 249, var(--border-opacity));\n  }\n  .md\\:focus-within\\:border-cool-gray-200:focus-within {\n    --border-opacity: 1;\n    border-color: #e2e8f0;\n    border-color: rgba(226, 232, 240, var(--border-opacity));\n  }\n  .md\\:focus-within\\:border-cool-gray-300:focus-within {\n    --border-opacity: 1;\n    border-color: #cfd8e3;\n    border-color: rgba(207, 216, 227, var(--border-opacity));\n  }\n  .md\\:focus-within\\:border-cool-gray-400:focus-within {\n    --border-opacity: 1;\n    border-color: #97a6ba;\n    border-color: rgba(151, 166, 186, var(--border-opacity));\n  }\n  .md\\:focus-within\\:border-cool-gray-500:focus-within {\n    --border-opacity: 1;\n    border-color: #64748b;\n    border-color: rgba(100, 116, 139, var(--border-opacity));\n  }\n  .md\\:focus-within\\:border-cool-gray-600:focus-within {\n    --border-opacity: 1;\n    border-color: #475569;\n    border-color: rgba(71, 85, 105, var(--border-opacity));\n  }\n  .md\\:focus-within\\:border-cool-gray-700:focus-within {\n    --border-opacity: 1;\n    border-color: #364152;\n    border-color: rgba(54, 65, 82, var(--border-opacity));\n  }\n  .md\\:focus-within\\:border-cool-gray-800:focus-within {\n    --border-opacity: 1;\n    border-color: #27303f;\n    border-color: rgba(39, 48, 63, var(--border-opacity));\n  }\n  .md\\:focus-within\\:border-cool-gray-900:focus-within {\n    --border-opacity: 1;\n    border-color: #1a202e;\n    border-color: rgba(26, 32, 46, var(--border-opacity));\n  }\n  .md\\:focus\\:border-current:focus {\n    border-color: currentColor;\n  }\n  .md\\:focus\\:border-transparent:focus {\n    border-color: transparent;\n  }\n  .md\\:focus\\:border-white:focus {\n    --border-opacity: 1;\n    border-color: #ffffff;\n    border-color: rgba(255, 255, 255, var(--border-opacity));\n  }\n  .md\\:focus\\:border-black:focus {\n    --border-opacity: 1;\n    border-color: #000000;\n    border-color: rgba(0, 0, 0, var(--border-opacity));\n  }\n  .md\\:focus\\:border-gray-50:focus {\n    --border-opacity: 1;\n    border-color: #f9fafb;\n    border-color: rgba(249, 250, 251, var(--border-opacity));\n  }\n  .md\\:focus\\:border-gray-100:focus {\n    --border-opacity: 1;\n    border-color: #f4f5f7;\n    border-color: rgba(244, 245, 247, var(--border-opacity));\n  }\n  .md\\:focus\\:border-gray-200:focus {\n    --border-opacity: 1;\n    border-color: #e5e7eb;\n    border-color: rgba(229, 231, 235, var(--border-opacity));\n  }\n  .md\\:focus\\:border-gray-300:focus {\n    --border-opacity: 1;\n    border-color: #d2d6dc;\n    border-color: rgba(210, 214, 220, var(--border-opacity));\n  }\n  .md\\:focus\\:border-gray-400:focus {\n    --border-opacity: 1;\n    border-color: #9fa6b2;\n    border-color: rgba(159, 166, 178, var(--border-opacity));\n  }\n  .md\\:focus\\:border-gray-500:focus {\n    --border-opacity: 1;\n    border-color: #6b7280;\n    border-color: rgba(107, 114, 128, var(--border-opacity));\n  }\n  .md\\:focus\\:border-gray-600:focus {\n    --border-opacity: 1;\n    border-color: #4b5563;\n    border-color: rgba(75, 85, 99, var(--border-opacity));\n  }\n  .md\\:focus\\:border-gray-700:focus {\n    --border-opacity: 1;\n    border-color: #374151;\n    border-color: rgba(55, 65, 81, var(--border-opacity));\n  }\n  .md\\:focus\\:border-gray-800:focus {\n    --border-opacity: 1;\n    border-color: #252f3f;\n    border-color: rgba(37, 47, 63, var(--border-opacity));\n  }\n  .md\\:focus\\:border-gray-900:focus {\n    --border-opacity: 1;\n    border-color: #161e2e;\n    border-color: rgba(22, 30, 46, var(--border-opacity));\n  }\n  .md\\:focus\\:border-red-50:focus {\n    --border-opacity: 1;\n    border-color: #fdf2f2;\n    border-color: rgba(253, 242, 242, var(--border-opacity));\n  }\n  .md\\:focus\\:border-red-100:focus {\n    --border-opacity: 1;\n    border-color: #fde8e8;\n    border-color: rgba(253, 232, 232, var(--border-opacity));\n  }\n  .md\\:focus\\:border-red-200:focus {\n    --border-opacity: 1;\n    border-color: #fbd5d5;\n    border-color: rgba(251, 213, 213, var(--border-opacity));\n  }\n  .md\\:focus\\:border-red-300:focus {\n    --border-opacity: 1;\n    border-color: #f8b4b4;\n    border-color: rgba(248, 180, 180, var(--border-opacity));\n  }\n  .md\\:focus\\:border-red-400:focus {\n    --border-opacity: 1;\n    border-color: #f98080;\n    border-color: rgba(249, 128, 128, var(--border-opacity));\n  }\n  .md\\:focus\\:border-red-500:focus {\n    --border-opacity: 1;\n    border-color: #f05252;\n    border-color: rgba(240, 82, 82, var(--border-opacity));\n  }\n  .md\\:focus\\:border-red-600:focus {\n    --border-opacity: 1;\n    border-color: #e02424;\n    border-color: rgba(224, 36, 36, var(--border-opacity));\n  }\n  .md\\:focus\\:border-red-700:focus {\n    --border-opacity: 1;\n    border-color: #c81e1e;\n    border-color: rgba(200, 30, 30, var(--border-opacity));\n  }\n  .md\\:focus\\:border-red-800:focus {\n    --border-opacity: 1;\n    border-color: #9b1c1c;\n    border-color: rgba(155, 28, 28, var(--border-opacity));\n  }\n  .md\\:focus\\:border-red-900:focus {\n    --border-opacity: 1;\n    border-color: #771d1d;\n    border-color: rgba(119, 29, 29, var(--border-opacity));\n  }\n  .md\\:focus\\:border-orange-50:focus {\n    --border-opacity: 1;\n    border-color: #fff8f1;\n    border-color: rgba(255, 248, 241, var(--border-opacity));\n  }\n  .md\\:focus\\:border-orange-100:focus {\n    --border-opacity: 1;\n    border-color: #feecdc;\n    border-color: rgba(254, 236, 220, var(--border-opacity));\n  }\n  .md\\:focus\\:border-orange-200:focus {\n    --border-opacity: 1;\n    border-color: #fcd9bd;\n    border-color: rgba(252, 217, 189, var(--border-opacity));\n  }\n  .md\\:focus\\:border-orange-300:focus {\n    --border-opacity: 1;\n    border-color: #fdba8c;\n    border-color: rgba(253, 186, 140, var(--border-opacity));\n  }\n  .md\\:focus\\:border-orange-400:focus {\n    --border-opacity: 1;\n    border-color: #ff8a4c;\n    border-color: rgba(255, 138, 76, var(--border-opacity));\n  }\n  .md\\:focus\\:border-orange-500:focus {\n    --border-opacity: 1;\n    border-color: #ff5a1f;\n    border-color: rgba(255, 90, 31, var(--border-opacity));\n  }\n  .md\\:focus\\:border-orange-600:focus {\n    --border-opacity: 1;\n    border-color: #d03801;\n    border-color: rgba(208, 56, 1, var(--border-opacity));\n  }\n  .md\\:focus\\:border-orange-700:focus {\n    --border-opacity: 1;\n    border-color: #b43403;\n    border-color: rgba(180, 52, 3, var(--border-opacity));\n  }\n  .md\\:focus\\:border-orange-800:focus {\n    --border-opacity: 1;\n    border-color: #8a2c0d;\n    border-color: rgba(138, 44, 13, var(--border-opacity));\n  }\n  .md\\:focus\\:border-orange-900:focus {\n    --border-opacity: 1;\n    border-color: #73230d;\n    border-color: rgba(115, 35, 13, var(--border-opacity));\n  }\n  .md\\:focus\\:border-yellow-50:focus {\n    --border-opacity: 1;\n    border-color: #fdfdea;\n    border-color: rgba(253, 253, 234, var(--border-opacity));\n  }\n  .md\\:focus\\:border-yellow-100:focus {\n    --border-opacity: 1;\n    border-color: #fdf6b2;\n    border-color: rgba(253, 246, 178, var(--border-opacity));\n  }\n  .md\\:focus\\:border-yellow-200:focus {\n    --border-opacity: 1;\n    border-color: #fce96a;\n    border-color: rgba(252, 233, 106, var(--border-opacity));\n  }\n  .md\\:focus\\:border-yellow-300:focus {\n    --border-opacity: 1;\n    border-color: #faca15;\n    border-color: rgba(250, 202, 21, var(--border-opacity));\n  }\n  .md\\:focus\\:border-yellow-400:focus {\n    --border-opacity: 1;\n    border-color: #e3a008;\n    border-color: rgba(227, 160, 8, var(--border-opacity));\n  }\n  .md\\:focus\\:border-yellow-500:focus {\n    --border-opacity: 1;\n    border-color: #c27803;\n    border-color: rgba(194, 120, 3, var(--border-opacity));\n  }\n  .md\\:focus\\:border-yellow-600:focus {\n    --border-opacity: 1;\n    border-color: #9f580a;\n    border-color: rgba(159, 88, 10, var(--border-opacity));\n  }\n  .md\\:focus\\:border-yellow-700:focus {\n    --border-opacity: 1;\n    border-color: #8e4b10;\n    border-color: rgba(142, 75, 16, var(--border-opacity));\n  }\n  .md\\:focus\\:border-yellow-800:focus {\n    --border-opacity: 1;\n    border-color: #723b13;\n    border-color: rgba(114, 59, 19, var(--border-opacity));\n  }\n  .md\\:focus\\:border-yellow-900:focus {\n    --border-opacity: 1;\n    border-color: #633112;\n    border-color: rgba(99, 49, 18, var(--border-opacity));\n  }\n  .md\\:focus\\:border-green-50:focus {\n    --border-opacity: 1;\n    border-color: #f3faf7;\n    border-color: rgba(243, 250, 247, var(--border-opacity));\n  }\n  .md\\:focus\\:border-green-100:focus {\n    --border-opacity: 1;\n    border-color: #def7ec;\n    border-color: rgba(222, 247, 236, var(--border-opacity));\n  }\n  .md\\:focus\\:border-green-200:focus {\n    --border-opacity: 1;\n    border-color: #bcf0da;\n    border-color: rgba(188, 240, 218, var(--border-opacity));\n  }\n  .md\\:focus\\:border-green-300:focus {\n    --border-opacity: 1;\n    border-color: #84e1bc;\n    border-color: rgba(132, 225, 188, var(--border-opacity));\n  }\n  .md\\:focus\\:border-green-400:focus {\n    --border-opacity: 1;\n    border-color: #31c48d;\n    border-color: rgba(49, 196, 141, var(--border-opacity));\n  }\n  .md\\:focus\\:border-green-500:focus {\n    --border-opacity: 1;\n    border-color: #0e9f6e;\n    border-color: rgba(14, 159, 110, var(--border-opacity));\n  }\n  .md\\:focus\\:border-green-600:focus {\n    --border-opacity: 1;\n    border-color: #057a55;\n    border-color: rgba(5, 122, 85, var(--border-opacity));\n  }\n  .md\\:focus\\:border-green-700:focus {\n    --border-opacity: 1;\n    border-color: #046c4e;\n    border-color: rgba(4, 108, 78, var(--border-opacity));\n  }\n  .md\\:focus\\:border-green-800:focus {\n    --border-opacity: 1;\n    border-color: #03543f;\n    border-color: rgba(3, 84, 63, var(--border-opacity));\n  }\n  .md\\:focus\\:border-green-900:focus {\n    --border-opacity: 1;\n    border-color: #014737;\n    border-color: rgba(1, 71, 55, var(--border-opacity));\n  }\n  .md\\:focus\\:border-teal-50:focus {\n    --border-opacity: 1;\n    border-color: #edfafa;\n    border-color: rgba(237, 250, 250, var(--border-opacity));\n  }\n  .md\\:focus\\:border-teal-100:focus {\n    --border-opacity: 1;\n    border-color: #d5f5f6;\n    border-color: rgba(213, 245, 246, var(--border-opacity));\n  }\n  .md\\:focus\\:border-teal-200:focus {\n    --border-opacity: 1;\n    border-color: #afecef;\n    border-color: rgba(175, 236, 239, var(--border-opacity));\n  }\n  .md\\:focus\\:border-teal-300:focus {\n    --border-opacity: 1;\n    border-color: #7edce2;\n    border-color: rgba(126, 220, 226, var(--border-opacity));\n  }\n  .md\\:focus\\:border-teal-400:focus {\n    --border-opacity: 1;\n    border-color: #16bdca;\n    border-color: rgba(22, 189, 202, var(--border-opacity));\n  }\n  .md\\:focus\\:border-teal-500:focus {\n    --border-opacity: 1;\n    border-color: #0694a2;\n    border-color: rgba(6, 148, 162, var(--border-opacity));\n  }\n  .md\\:focus\\:border-teal-600:focus {\n    --border-opacity: 1;\n    border-color: #047481;\n    border-color: rgba(4, 116, 129, var(--border-opacity));\n  }\n  .md\\:focus\\:border-teal-700:focus {\n    --border-opacity: 1;\n    border-color: #036672;\n    border-color: rgba(3, 102, 114, var(--border-opacity));\n  }\n  .md\\:focus\\:border-teal-800:focus {\n    --border-opacity: 1;\n    border-color: #05505c;\n    border-color: rgba(5, 80, 92, var(--border-opacity));\n  }\n  .md\\:focus\\:border-teal-900:focus {\n    --border-opacity: 1;\n    border-color: #014451;\n    border-color: rgba(1, 68, 81, var(--border-opacity));\n  }\n  .md\\:focus\\:border-blue-50:focus {\n    --border-opacity: 1;\n    border-color: #ebf5ff;\n    border-color: rgba(235, 245, 255, var(--border-opacity));\n  }\n  .md\\:focus\\:border-blue-100:focus {\n    --border-opacity: 1;\n    border-color: #e1effe;\n    border-color: rgba(225, 239, 254, var(--border-opacity));\n  }\n  .md\\:focus\\:border-blue-200:focus {\n    --border-opacity: 1;\n    border-color: #c3ddfd;\n    border-color: rgba(195, 221, 253, var(--border-opacity));\n  }\n  .md\\:focus\\:border-blue-300:focus {\n    --border-opacity: 1;\n    border-color: #a4cafe;\n    border-color: rgba(164, 202, 254, var(--border-opacity));\n  }\n  .md\\:focus\\:border-blue-400:focus {\n    --border-opacity: 1;\n    border-color: #76a9fa;\n    border-color: rgba(118, 169, 250, var(--border-opacity));\n  }\n  .md\\:focus\\:border-blue-500:focus {\n    --border-opacity: 1;\n    border-color: #3f83f8;\n    border-color: rgba(63, 131, 248, var(--border-opacity));\n  }\n  .md\\:focus\\:border-blue-600:focus {\n    --border-opacity: 1;\n    border-color: #1c64f2;\n    border-color: rgba(28, 100, 242, var(--border-opacity));\n  }\n  .md\\:focus\\:border-blue-700:focus {\n    --border-opacity: 1;\n    border-color: #1a56db;\n    border-color: rgba(26, 86, 219, var(--border-opacity));\n  }\n  .md\\:focus\\:border-blue-800:focus {\n    --border-opacity: 1;\n    border-color: #1e429f;\n    border-color: rgba(30, 66, 159, var(--border-opacity));\n  }\n  .md\\:focus\\:border-blue-900:focus {\n    --border-opacity: 1;\n    border-color: #233876;\n    border-color: rgba(35, 56, 118, var(--border-opacity));\n  }\n  .md\\:focus\\:border-indigo-50:focus {\n    --border-opacity: 1;\n    border-color: #f0f5ff;\n    border-color: rgba(240, 245, 255, var(--border-opacity));\n  }\n  .md\\:focus\\:border-indigo-100:focus {\n    --border-opacity: 1;\n    border-color: #e5edff;\n    border-color: rgba(229, 237, 255, var(--border-opacity));\n  }\n  .md\\:focus\\:border-indigo-200:focus {\n    --border-opacity: 1;\n    border-color: #cddbfe;\n    border-color: rgba(205, 219, 254, var(--border-opacity));\n  }\n  .md\\:focus\\:border-indigo-300:focus {\n    --border-opacity: 1;\n    border-color: #b4c6fc;\n    border-color: rgba(180, 198, 252, var(--border-opacity));\n  }\n  .md\\:focus\\:border-indigo-400:focus {\n    --border-opacity: 1;\n    border-color: #8da2fb;\n    border-color: rgba(141, 162, 251, var(--border-opacity));\n  }\n  .md\\:focus\\:border-indigo-500:focus {\n    --border-opacity: 1;\n    border-color: #6875f5;\n    border-color: rgba(104, 117, 245, var(--border-opacity));\n  }\n  .md\\:focus\\:border-indigo-600:focus {\n    --border-opacity: 1;\n    border-color: #5850ec;\n    border-color: rgba(88, 80, 236, var(--border-opacity));\n  }\n  .md\\:focus\\:border-indigo-700:focus {\n    --border-opacity: 1;\n    border-color: #5145cd;\n    border-color: rgba(81, 69, 205, var(--border-opacity));\n  }\n  .md\\:focus\\:border-indigo-800:focus {\n    --border-opacity: 1;\n    border-color: #42389d;\n    border-color: rgba(66, 56, 157, var(--border-opacity));\n  }\n  .md\\:focus\\:border-indigo-900:focus {\n    --border-opacity: 1;\n    border-color: #362f78;\n    border-color: rgba(54, 47, 120, var(--border-opacity));\n  }\n  .md\\:focus\\:border-purple-50:focus {\n    --border-opacity: 1;\n    border-color: #f6f5ff;\n    border-color: rgba(246, 245, 255, var(--border-opacity));\n  }\n  .md\\:focus\\:border-purple-100:focus {\n    --border-opacity: 1;\n    border-color: #edebfe;\n    border-color: rgba(237, 235, 254, var(--border-opacity));\n  }\n  .md\\:focus\\:border-purple-200:focus {\n    --border-opacity: 1;\n    border-color: #dcd7fe;\n    border-color: rgba(220, 215, 254, var(--border-opacity));\n  }\n  .md\\:focus\\:border-purple-300:focus {\n    --border-opacity: 1;\n    border-color: #cabffd;\n    border-color: rgba(202, 191, 253, var(--border-opacity));\n  }\n  .md\\:focus\\:border-purple-400:focus {\n    --border-opacity: 1;\n    border-color: #ac94fa;\n    border-color: rgba(172, 148, 250, var(--border-opacity));\n  }\n  .md\\:focus\\:border-purple-500:focus {\n    --border-opacity: 1;\n    border-color: #9061f9;\n    border-color: rgba(144, 97, 249, var(--border-opacity));\n  }\n  .md\\:focus\\:border-purple-600:focus {\n    --border-opacity: 1;\n    border-color: #7e3af2;\n    border-color: rgba(126, 58, 242, var(--border-opacity));\n  }\n  .md\\:focus\\:border-purple-700:focus {\n    --border-opacity: 1;\n    border-color: #6c2bd9;\n    border-color: rgba(108, 43, 217, var(--border-opacity));\n  }\n  .md\\:focus\\:border-purple-800:focus {\n    --border-opacity: 1;\n    border-color: #5521b5;\n    border-color: rgba(85, 33, 181, var(--border-opacity));\n  }\n  .md\\:focus\\:border-purple-900:focus {\n    --border-opacity: 1;\n    border-color: #4a1d96;\n    border-color: rgba(74, 29, 150, var(--border-opacity));\n  }\n  .md\\:focus\\:border-pink-50:focus {\n    --border-opacity: 1;\n    border-color: #fdf2f8;\n    border-color: rgba(253, 242, 248, var(--border-opacity));\n  }\n  .md\\:focus\\:border-pink-100:focus {\n    --border-opacity: 1;\n    border-color: #fce8f3;\n    border-color: rgba(252, 232, 243, var(--border-opacity));\n  }\n  .md\\:focus\\:border-pink-200:focus {\n    --border-opacity: 1;\n    border-color: #fad1e8;\n    border-color: rgba(250, 209, 232, var(--border-opacity));\n  }\n  .md\\:focus\\:border-pink-300:focus {\n    --border-opacity: 1;\n    border-color: #f8b4d9;\n    border-color: rgba(248, 180, 217, var(--border-opacity));\n  }\n  .md\\:focus\\:border-pink-400:focus {\n    --border-opacity: 1;\n    border-color: #f17eb8;\n    border-color: rgba(241, 126, 184, var(--border-opacity));\n  }\n  .md\\:focus\\:border-pink-500:focus {\n    --border-opacity: 1;\n    border-color: #e74694;\n    border-color: rgba(231, 70, 148, var(--border-opacity));\n  }\n  .md\\:focus\\:border-pink-600:focus {\n    --border-opacity: 1;\n    border-color: #d61f69;\n    border-color: rgba(214, 31, 105, var(--border-opacity));\n  }\n  .md\\:focus\\:border-pink-700:focus {\n    --border-opacity: 1;\n    border-color: #bf125d;\n    border-color: rgba(191, 18, 93, var(--border-opacity));\n  }\n  .md\\:focus\\:border-pink-800:focus {\n    --border-opacity: 1;\n    border-color: #99154b;\n    border-color: rgba(153, 21, 75, var(--border-opacity));\n  }\n  .md\\:focus\\:border-pink-900:focus {\n    --border-opacity: 1;\n    border-color: #751a3d;\n    border-color: rgba(117, 26, 61, var(--border-opacity));\n  }\n  .md\\:focus\\:border-cool-gray-50:focus {\n    --border-opacity: 1;\n    border-color: #f8fafc;\n    border-color: rgba(248, 250, 252, var(--border-opacity));\n  }\n  .md\\:focus\\:border-cool-gray-100:focus {\n    --border-opacity: 1;\n    border-color: #f1f5f9;\n    border-color: rgba(241, 245, 249, var(--border-opacity));\n  }\n  .md\\:focus\\:border-cool-gray-200:focus {\n    --border-opacity: 1;\n    border-color: #e2e8f0;\n    border-color: rgba(226, 232, 240, var(--border-opacity));\n  }\n  .md\\:focus\\:border-cool-gray-300:focus {\n    --border-opacity: 1;\n    border-color: #cfd8e3;\n    border-color: rgba(207, 216, 227, var(--border-opacity));\n  }\n  .md\\:focus\\:border-cool-gray-400:focus {\n    --border-opacity: 1;\n    border-color: #97a6ba;\n    border-color: rgba(151, 166, 186, var(--border-opacity));\n  }\n  .md\\:focus\\:border-cool-gray-500:focus {\n    --border-opacity: 1;\n    border-color: #64748b;\n    border-color: rgba(100, 116, 139, var(--border-opacity));\n  }\n  .md\\:focus\\:border-cool-gray-600:focus {\n    --border-opacity: 1;\n    border-color: #475569;\n    border-color: rgba(71, 85, 105, var(--border-opacity));\n  }\n  .md\\:focus\\:border-cool-gray-700:focus {\n    --border-opacity: 1;\n    border-color: #364152;\n    border-color: rgba(54, 65, 82, var(--border-opacity));\n  }\n  .md\\:focus\\:border-cool-gray-800:focus {\n    --border-opacity: 1;\n    border-color: #27303f;\n    border-color: rgba(39, 48, 63, var(--border-opacity));\n  }\n  .md\\:focus\\:border-cool-gray-900:focus {\n    --border-opacity: 1;\n    border-color: #1a202e;\n    border-color: rgba(26, 32, 46, var(--border-opacity));\n  }\n  .md\\:border-opacity-0 {\n    --border-opacity: 0;\n  }\n  .md\\:border-opacity-25 {\n    --border-opacity: 0.25;\n  }\n  .md\\:border-opacity-50 {\n    --border-opacity: 0.5;\n  }\n  .md\\:border-opacity-75 {\n    --border-opacity: 0.75;\n  }\n  .md\\:border-opacity-100 {\n    --border-opacity: 1;\n  }\n  .md\\:hover\\:border-opacity-0:hover {\n    --border-opacity: 0;\n  }\n  .md\\:hover\\:border-opacity-25:hover {\n    --border-opacity: 0.25;\n  }\n  .md\\:hover\\:border-opacity-50:hover {\n    --border-opacity: 0.5;\n  }\n  .md\\:hover\\:border-opacity-75:hover {\n    --border-opacity: 0.75;\n  }\n  .md\\:hover\\:border-opacity-100:hover {\n    --border-opacity: 1;\n  }\n  .md\\:focus\\:border-opacity-0:focus {\n    --border-opacity: 0;\n  }\n  .md\\:focus\\:border-opacity-25:focus {\n    --border-opacity: 0.25;\n  }\n  .md\\:focus\\:border-opacity-50:focus {\n    --border-opacity: 0.5;\n  }\n  .md\\:focus\\:border-opacity-75:focus {\n    --border-opacity: 0.75;\n  }\n  .md\\:focus\\:border-opacity-100:focus {\n    --border-opacity: 1;\n  }\n  .md\\:rounded-none {\n    border-radius: 0;\n  }\n  .md\\:rounded-sm {\n    border-radius: 0.125rem;\n  }\n  .md\\:rounded {\n    border-radius: 0.25rem;\n  }\n  .md\\:rounded-md {\n    border-radius: 0.375rem;\n  }\n  .md\\:rounded-lg {\n    border-radius: 0.5rem;\n  }\n  .md\\:rounded-xl {\n    border-radius: 0.75rem;\n  }\n  .md\\:rounded-2xl {\n    border-radius: 1rem;\n  }\n  .md\\:rounded-3xl {\n    border-radius: 1.5rem;\n  }\n  .md\\:rounded-full {\n    border-radius: 9999px;\n  }\n  .md\\:rounded-t-none {\n    border-top-left-radius: 0;\n    border-top-right-radius: 0;\n  }\n  .md\\:rounded-r-none {\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0;\n  }\n  .md\\:rounded-b-none {\n    border-bottom-right-radius: 0;\n    border-bottom-left-radius: 0;\n  }\n  .md\\:rounded-l-none {\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0;\n  }\n  .md\\:rounded-t-sm {\n    border-top-left-radius: 0.125rem;\n    border-top-right-radius: 0.125rem;\n  }\n  .md\\:rounded-r-sm {\n    border-top-right-radius: 0.125rem;\n    border-bottom-right-radius: 0.125rem;\n  }\n  .md\\:rounded-b-sm {\n    border-bottom-right-radius: 0.125rem;\n    border-bottom-left-radius: 0.125rem;\n  }\n  .md\\:rounded-l-sm {\n    border-top-left-radius: 0.125rem;\n    border-bottom-left-radius: 0.125rem;\n  }\n  .md\\:rounded-t {\n    border-top-left-radius: 0.25rem;\n    border-top-right-radius: 0.25rem;\n  }\n  .md\\:rounded-r {\n    border-top-right-radius: 0.25rem;\n    border-bottom-right-radius: 0.25rem;\n  }\n  .md\\:rounded-b {\n    border-bottom-right-radius: 0.25rem;\n    border-bottom-left-radius: 0.25rem;\n  }\n  .md\\:rounded-l {\n    border-top-left-radius: 0.25rem;\n    border-bottom-left-radius: 0.25rem;\n  }\n  .md\\:rounded-t-md {\n    border-top-left-radius: 0.375rem;\n    border-top-right-radius: 0.375rem;\n  }\n  .md\\:rounded-r-md {\n    border-top-right-radius: 0.375rem;\n    border-bottom-right-radius: 0.375rem;\n  }\n  .md\\:rounded-b-md {\n    border-bottom-right-radius: 0.375rem;\n    border-bottom-left-radius: 0.375rem;\n  }\n  .md\\:rounded-l-md {\n    border-top-left-radius: 0.375rem;\n    border-bottom-left-radius: 0.375rem;\n  }\n  .md\\:rounded-t-lg {\n    border-top-left-radius: 0.5rem;\n    border-top-right-radius: 0.5rem;\n  }\n  .md\\:rounded-r-lg {\n    border-top-right-radius: 0.5rem;\n    border-bottom-right-radius: 0.5rem;\n  }\n  .md\\:rounded-b-lg {\n    border-bottom-right-radius: 0.5rem;\n    border-bottom-left-radius: 0.5rem;\n  }\n  .md\\:rounded-l-lg {\n    border-top-left-radius: 0.5rem;\n    border-bottom-left-radius: 0.5rem;\n  }\n  .md\\:rounded-t-xl {\n    border-top-left-radius: 0.75rem;\n    border-top-right-radius: 0.75rem;\n  }\n  .md\\:rounded-r-xl {\n    border-top-right-radius: 0.75rem;\n    border-bottom-right-radius: 0.75rem;\n  }\n  .md\\:rounded-b-xl {\n    border-bottom-right-radius: 0.75rem;\n    border-bottom-left-radius: 0.75rem;\n  }\n  .md\\:rounded-l-xl {\n    border-top-left-radius: 0.75rem;\n    border-bottom-left-radius: 0.75rem;\n  }\n  .md\\:rounded-t-2xl {\n    border-top-left-radius: 1rem;\n    border-top-right-radius: 1rem;\n  }\n  .md\\:rounded-r-2xl {\n    border-top-right-radius: 1rem;\n    border-bottom-right-radius: 1rem;\n  }\n  .md\\:rounded-b-2xl {\n    border-bottom-right-radius: 1rem;\n    border-bottom-left-radius: 1rem;\n  }\n  .md\\:rounded-l-2xl {\n    border-top-left-radius: 1rem;\n    border-bottom-left-radius: 1rem;\n  }\n  .md\\:rounded-t-3xl {\n    border-top-left-radius: 1.5rem;\n    border-top-right-radius: 1.5rem;\n  }\n  .md\\:rounded-r-3xl {\n    border-top-right-radius: 1.5rem;\n    border-bottom-right-radius: 1.5rem;\n  }\n  .md\\:rounded-b-3xl {\n    border-bottom-right-radius: 1.5rem;\n    border-bottom-left-radius: 1.5rem;\n  }\n  .md\\:rounded-l-3xl {\n    border-top-left-radius: 1.5rem;\n    border-bottom-left-radius: 1.5rem;\n  }\n  .md\\:rounded-t-full {\n    border-top-left-radius: 9999px;\n    border-top-right-radius: 9999px;\n  }\n  .md\\:rounded-r-full {\n    border-top-right-radius: 9999px;\n    border-bottom-right-radius: 9999px;\n  }\n  .md\\:rounded-b-full {\n    border-bottom-right-radius: 9999px;\n    border-bottom-left-radius: 9999px;\n  }\n  .md\\:rounded-l-full {\n    border-top-left-radius: 9999px;\n    border-bottom-left-radius: 9999px;\n  }\n  .md\\:rounded-tl-none {\n    border-top-left-radius: 0;\n  }\n  .md\\:rounded-tr-none {\n    border-top-right-radius: 0;\n  }\n  .md\\:rounded-br-none {\n    border-bottom-right-radius: 0;\n  }\n  .md\\:rounded-bl-none {\n    border-bottom-left-radius: 0;\n  }\n  .md\\:rounded-tl-sm {\n    border-top-left-radius: 0.125rem;\n  }\n  .md\\:rounded-tr-sm {\n    border-top-right-radius: 0.125rem;\n  }\n  .md\\:rounded-br-sm {\n    border-bottom-right-radius: 0.125rem;\n  }\n  .md\\:rounded-bl-sm {\n    border-bottom-left-radius: 0.125rem;\n  }\n  .md\\:rounded-tl {\n    border-top-left-radius: 0.25rem;\n  }\n  .md\\:rounded-tr {\n    border-top-right-radius: 0.25rem;\n  }\n  .md\\:rounded-br {\n    border-bottom-right-radius: 0.25rem;\n  }\n  .md\\:rounded-bl {\n    border-bottom-left-radius: 0.25rem;\n  }\n  .md\\:rounded-tl-md {\n    border-top-left-radius: 0.375rem;\n  }\n  .md\\:rounded-tr-md {\n    border-top-right-radius: 0.375rem;\n  }\n  .md\\:rounded-br-md {\n    border-bottom-right-radius: 0.375rem;\n  }\n  .md\\:rounded-bl-md {\n    border-bottom-left-radius: 0.375rem;\n  }\n  .md\\:rounded-tl-lg {\n    border-top-left-radius: 0.5rem;\n  }\n  .md\\:rounded-tr-lg {\n    border-top-right-radius: 0.5rem;\n  }\n  .md\\:rounded-br-lg {\n    border-bottom-right-radius: 0.5rem;\n  }\n  .md\\:rounded-bl-lg {\n    border-bottom-left-radius: 0.5rem;\n  }\n  .md\\:rounded-tl-xl {\n    border-top-left-radius: 0.75rem;\n  }\n  .md\\:rounded-tr-xl {\n    border-top-right-radius: 0.75rem;\n  }\n  .md\\:rounded-br-xl {\n    border-bottom-right-radius: 0.75rem;\n  }\n  .md\\:rounded-bl-xl {\n    border-bottom-left-radius: 0.75rem;\n  }\n  .md\\:rounded-tl-2xl {\n    border-top-left-radius: 1rem;\n  }\n  .md\\:rounded-tr-2xl {\n    border-top-right-radius: 1rem;\n  }\n  .md\\:rounded-br-2xl {\n    border-bottom-right-radius: 1rem;\n  }\n  .md\\:rounded-bl-2xl {\n    border-bottom-left-radius: 1rem;\n  }\n  .md\\:rounded-tl-3xl {\n    border-top-left-radius: 1.5rem;\n  }\n  .md\\:rounded-tr-3xl {\n    border-top-right-radius: 1.5rem;\n  }\n  .md\\:rounded-br-3xl {\n    border-bottom-right-radius: 1.5rem;\n  }\n  .md\\:rounded-bl-3xl {\n    border-bottom-left-radius: 1.5rem;\n  }\n  .md\\:rounded-tl-full {\n    border-top-left-radius: 9999px;\n  }\n  .md\\:rounded-tr-full {\n    border-top-right-radius: 9999px;\n  }\n  .md\\:rounded-br-full {\n    border-bottom-right-radius: 9999px;\n  }\n  .md\\:rounded-bl-full {\n    border-bottom-left-radius: 9999px;\n  }\n  .md\\:border-solid {\n    border-style: solid;\n  }\n  .md\\:border-dashed {\n    border-style: dashed;\n  }\n  .md\\:border-dotted {\n    border-style: dotted;\n  }\n  .md\\:border-double {\n    border-style: double;\n  }\n  .md\\:border-none {\n    border-style: none;\n  }\n  .md\\:border-0 {\n    border-width: 0;\n  }\n  .md\\:border-2 {\n    border-width: 2px;\n  }\n  .md\\:border-4 {\n    border-width: 4px;\n  }\n  .md\\:border-8 {\n    border-width: 8px;\n  }\n  .md\\:border {\n    border-width: 1px;\n  }\n  .md\\:border-t-0 {\n    border-top-width: 0;\n  }\n  .md\\:border-r-0 {\n    border-right-width: 0;\n  }\n  .md\\:border-b-0 {\n    border-bottom-width: 0;\n  }\n  .md\\:border-l-0 {\n    border-left-width: 0;\n  }\n  .md\\:border-t-2 {\n    border-top-width: 2px;\n  }\n  .md\\:border-r-2 {\n    border-right-width: 2px;\n  }\n  .md\\:border-b-2 {\n    border-bottom-width: 2px;\n  }\n  .md\\:border-l-2 {\n    border-left-width: 2px;\n  }\n  .md\\:border-t-4 {\n    border-top-width: 4px;\n  }\n  .md\\:border-r-4 {\n    border-right-width: 4px;\n  }\n  .md\\:border-b-4 {\n    border-bottom-width: 4px;\n  }\n  .md\\:border-l-4 {\n    border-left-width: 4px;\n  }\n  .md\\:border-t-8 {\n    border-top-width: 8px;\n  }\n  .md\\:border-r-8 {\n    border-right-width: 8px;\n  }\n  .md\\:border-b-8 {\n    border-bottom-width: 8px;\n  }\n  .md\\:border-l-8 {\n    border-left-width: 8px;\n  }\n  .md\\:border-t {\n    border-top-width: 1px;\n  }\n  .md\\:border-r {\n    border-right-width: 1px;\n  }\n  .md\\:border-b {\n    border-bottom-width: 1px;\n  }\n  .md\\:border-l {\n    border-left-width: 1px;\n  }\n  .md\\:box-border {\n    box-sizing: border-box;\n  }\n  .md\\:box-content {\n    box-sizing: content-box;\n  }\n  .md\\:cursor-auto {\n    cursor: auto;\n  }\n  .md\\:cursor-default {\n    cursor: default;\n  }\n  .md\\:cursor-pointer {\n    cursor: pointer;\n  }\n  .md\\:cursor-wait {\n    cursor: wait;\n  }\n  .md\\:cursor-text {\n    cursor: text;\n  }\n  .md\\:cursor-move {\n    cursor: move;\n  }\n  .md\\:cursor-not-allowed {\n    cursor: not-allowed;\n  }\n  .md\\:block {\n    display: block;\n  }\n  .md\\:inline-block {\n    display: inline-block;\n  }\n  .md\\:inline {\n    display: inline;\n  }\n  .md\\:flex {\n    display: flex;\n  }\n  .md\\:inline-flex {\n    display: inline-flex;\n  }\n  .md\\:table {\n    display: table;\n  }\n  .md\\:table-caption {\n    display: table-caption;\n  }\n  .md\\:table-cell {\n    display: table-cell;\n  }\n  .md\\:table-column {\n    display: table-column;\n  }\n  .md\\:table-column-group {\n    display: table-column-group;\n  }\n  .md\\:table-footer-group {\n    display: table-footer-group;\n  }\n  .md\\:table-header-group {\n    display: table-header-group;\n  }\n  .md\\:table-row-group {\n    display: table-row-group;\n  }\n  .md\\:table-row {\n    display: table-row;\n  }\n  .md\\:flow-root {\n    display: flow-root;\n  }\n  .md\\:grid {\n    display: grid;\n  }\n  .md\\:inline-grid {\n    display: inline-grid;\n  }\n  .md\\:contents {\n    display: contents;\n  }\n  .md\\:hidden {\n    display: none;\n  }\n  .md\\:flex-row {\n    flex-direction: row;\n  }\n  .md\\:flex-row-reverse {\n    flex-direction: row-reverse;\n  }\n  .md\\:flex-col {\n    flex-direction: column;\n  }\n  .md\\:flex-col-reverse {\n    flex-direction: column-reverse;\n  }\n  .md\\:flex-wrap {\n    flex-wrap: wrap;\n  }\n  .md\\:flex-wrap-reverse {\n    flex-wrap: wrap-reverse;\n  }\n  .md\\:flex-no-wrap {\n    flex-wrap: nowrap;\n  }\n  .md\\:place-items-auto {\n    place-items: auto;\n  }\n  .md\\:place-items-start {\n    place-items: start;\n  }\n  .md\\:place-items-end {\n    place-items: end;\n  }\n  .md\\:place-items-center {\n    place-items: center;\n  }\n  .md\\:place-items-stretch {\n    place-items: stretch;\n  }\n  .md\\:place-content-center {\n    place-content: center;\n  }\n  .md\\:place-content-start {\n    place-content: start;\n  }\n  .md\\:place-content-end {\n    place-content: end;\n  }\n  .md\\:place-content-between {\n    place-content: space-between;\n  }\n  .md\\:place-content-around {\n    place-content: space-around;\n  }\n  .md\\:place-content-evenly {\n    place-content: space-evenly;\n  }\n  .md\\:place-content-stretch {\n    place-content: stretch;\n  }\n  .md\\:place-self-auto {\n    place-self: auto;\n  }\n  .md\\:place-self-start {\n    place-self: start;\n  }\n  .md\\:place-self-end {\n    place-self: end;\n  }\n  .md\\:place-self-center {\n    place-self: center;\n  }\n  .md\\:place-self-stretch {\n    place-self: stretch;\n  }\n  .md\\:items-start {\n    align-items: flex-start;\n  }\n  .md\\:items-end {\n    align-items: flex-end;\n  }\n  .md\\:items-center {\n    align-items: center;\n  }\n  .md\\:items-baseline {\n    align-items: baseline;\n  }\n  .md\\:items-stretch {\n    align-items: stretch;\n  }\n  .md\\:content-center {\n    align-content: center;\n  }\n  .md\\:content-start {\n    align-content: flex-start;\n  }\n  .md\\:content-end {\n    align-content: flex-end;\n  }\n  .md\\:content-between {\n    align-content: space-between;\n  }\n  .md\\:content-around {\n    align-content: space-around;\n  }\n  .md\\:content-evenly {\n    align-content: space-evenly;\n  }\n  .md\\:self-auto {\n    align-self: auto;\n  }\n  .md\\:self-start {\n    align-self: flex-start;\n  }\n  .md\\:self-end {\n    align-self: flex-end;\n  }\n  .md\\:self-center {\n    align-self: center;\n  }\n  .md\\:self-stretch {\n    align-self: stretch;\n  }\n  .md\\:justify-items-auto {\n    justify-items: auto;\n  }\n  .md\\:justify-items-start {\n    justify-items: start;\n  }\n  .md\\:justify-items-end {\n    justify-items: end;\n  }\n  .md\\:justify-items-center {\n    justify-items: center;\n  }\n  .md\\:justify-items-stretch {\n    justify-items: stretch;\n  }\n  .md\\:justify-start {\n    justify-content: flex-start;\n  }\n  .md\\:justify-end {\n    justify-content: flex-end;\n  }\n  .md\\:justify-center {\n    justify-content: center;\n  }\n  .md\\:justify-between {\n    justify-content: space-between;\n  }\n  .md\\:justify-around {\n    justify-content: space-around;\n  }\n  .md\\:justify-evenly {\n    justify-content: space-evenly;\n  }\n  .md\\:justify-self-auto {\n    justify-self: auto;\n  }\n  .md\\:justify-self-start {\n    justify-self: start;\n  }\n  .md\\:justify-self-end {\n    justify-self: end;\n  }\n  .md\\:justify-self-center {\n    justify-self: center;\n  }\n  .md\\:justify-self-stretch {\n    justify-self: stretch;\n  }\n  .md\\:flex-1 {\n    flex: 1 1 0%;\n  }\n  .md\\:flex-auto {\n    flex: 1 1 auto;\n  }\n  .md\\:flex-initial {\n    flex: 0 1 auto;\n  }\n  .md\\:flex-none {\n    flex: none;\n  }\n  .md\\:flex-grow-0 {\n    flex-grow: 0;\n  }\n  .md\\:flex-grow {\n    flex-grow: 1;\n  }\n  .md\\:flex-shrink-0 {\n    flex-shrink: 0;\n  }\n  .md\\:flex-shrink {\n    flex-shrink: 1;\n  }\n  .md\\:order-1 {\n    order: 1;\n  }\n  .md\\:order-2 {\n    order: 2;\n  }\n  .md\\:order-3 {\n    order: 3;\n  }\n  .md\\:order-4 {\n    order: 4;\n  }\n  .md\\:order-5 {\n    order: 5;\n  }\n  .md\\:order-6 {\n    order: 6;\n  }\n  .md\\:order-7 {\n    order: 7;\n  }\n  .md\\:order-8 {\n    order: 8;\n  }\n  .md\\:order-9 {\n    order: 9;\n  }\n  .md\\:order-10 {\n    order: 10;\n  }\n  .md\\:order-11 {\n    order: 11;\n  }\n  .md\\:order-12 {\n    order: 12;\n  }\n  .md\\:order-first {\n    order: -9999;\n  }\n  .md\\:order-last {\n    order: 9999;\n  }\n  .md\\:order-none {\n    order: 0;\n  }\n  .md\\:float-right {\n    float: right;\n  }\n  .md\\:float-left {\n    float: left;\n  }\n  .md\\:float-none {\n    float: none;\n  }\n  .md\\:clearfix:after {\n    content: \"\";\n    display: table;\n    clear: both;\n  }\n  .md\\:clear-left {\n    clear: left;\n  }\n  .md\\:clear-right {\n    clear: right;\n  }\n  .md\\:clear-both {\n    clear: both;\n  }\n  .md\\:clear-none {\n    clear: none;\n  }\n  .md\\:font-sans {\n    font-family: system-ui, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, \"Noto Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n  }\n  .md\\:font-serif {\n    font-family: Georgia, Cambria, \"Times New Roman\", Times, serif;\n  }\n  .md\\:font-mono {\n    font-family: Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace;\n  }\n  .md\\:font-hairline {\n    font-weight: 100;\n  }\n  .md\\:font-thin {\n    font-weight: 200;\n  }\n  .md\\:font-light {\n    font-weight: 300;\n  }\n  .md\\:font-normal {\n    font-weight: 400;\n  }\n  .md\\:font-medium {\n    font-weight: 500;\n  }\n  .md\\:font-semibold {\n    font-weight: 600;\n  }\n  .md\\:font-bold {\n    font-weight: 700;\n  }\n  .md\\:font-extrabold {\n    font-weight: 800;\n  }\n  .md\\:font-black {\n    font-weight: 900;\n  }\n  .md\\:hover\\:font-hairline:hover {\n    font-weight: 100;\n  }\n  .md\\:hover\\:font-thin:hover {\n    font-weight: 200;\n  }\n  .md\\:hover\\:font-light:hover {\n    font-weight: 300;\n  }\n  .md\\:hover\\:font-normal:hover {\n    font-weight: 400;\n  }\n  .md\\:hover\\:font-medium:hover {\n    font-weight: 500;\n  }\n  .md\\:hover\\:font-semibold:hover {\n    font-weight: 600;\n  }\n  .md\\:hover\\:font-bold:hover {\n    font-weight: 700;\n  }\n  .md\\:hover\\:font-extrabold:hover {\n    font-weight: 800;\n  }\n  .md\\:hover\\:font-black:hover {\n    font-weight: 900;\n  }\n  .md\\:focus\\:font-hairline:focus {\n    font-weight: 100;\n  }\n  .md\\:focus\\:font-thin:focus {\n    font-weight: 200;\n  }\n  .md\\:focus\\:font-light:focus {\n    font-weight: 300;\n  }\n  .md\\:focus\\:font-normal:focus {\n    font-weight: 400;\n  }\n  .md\\:focus\\:font-medium:focus {\n    font-weight: 500;\n  }\n  .md\\:focus\\:font-semibold:focus {\n    font-weight: 600;\n  }\n  .md\\:focus\\:font-bold:focus {\n    font-weight: 700;\n  }\n  .md\\:focus\\:font-extrabold:focus {\n    font-weight: 800;\n  }\n  .md\\:focus\\:font-black:focus {\n    font-weight: 900;\n  }\n  .md\\:h-0 {\n    height: 0;\n  }\n  .md\\:h-1 {\n    height: 0.25rem;\n  }\n  .md\\:h-2 {\n    height: 0.5rem;\n  }\n  .md\\:h-3 {\n    height: 0.75rem;\n  }\n  .md\\:h-4 {\n    height: 1rem;\n  }\n  .md\\:h-5 {\n    height: 1.25rem;\n  }\n  .md\\:h-6 {\n    height: 1.5rem;\n  }\n  .md\\:h-7 {\n    height: 1.75rem;\n  }\n  .md\\:h-8 {\n    height: 2rem;\n  }\n  .md\\:h-9 {\n    height: 2.25rem;\n  }\n  .md\\:h-10 {\n    height: 2.5rem;\n  }\n  .md\\:h-11 {\n    height: 2.75rem;\n  }\n  .md\\:h-12 {\n    height: 3rem;\n  }\n  .md\\:h-13 {\n    height: 3.25rem;\n  }\n  .md\\:h-14 {\n    height: 3.5rem;\n  }\n  .md\\:h-15 {\n    height: 3.75rem;\n  }\n  .md\\:h-16 {\n    height: 4rem;\n  }\n  .md\\:h-20 {\n    height: 5rem;\n  }\n  .md\\:h-24 {\n    height: 6rem;\n  }\n  .md\\:h-28 {\n    height: 7rem;\n  }\n  .md\\:h-32 {\n    height: 8rem;\n  }\n  .md\\:h-36 {\n    height: 9rem;\n  }\n  .md\\:h-40 {\n    height: 10rem;\n  }\n  .md\\:h-44 {\n    height: 11rem;\n  }\n  .md\\:h-48 {\n    height: 12rem;\n  }\n  .md\\:h-52 {\n    height: 13rem;\n  }\n  .md\\:h-56 {\n    height: 14rem;\n  }\n  .md\\:h-60 {\n    height: 15rem;\n  }\n  .md\\:h-64 {\n    height: 16rem;\n  }\n  .md\\:h-72 {\n    height: 18rem;\n  }\n  .md\\:h-80 {\n    height: 20rem;\n  }\n  .md\\:h-96 {\n    height: 24rem;\n  }\n  .md\\:h-auto {\n    height: auto;\n  }\n  .md\\:h-px {\n    height: 1px;\n  }\n  .md\\:h-0\\.5 {\n    height: 0.125rem;\n  }\n  .md\\:h-1\\.5 {\n    height: 0.375rem;\n  }\n  .md\\:h-2\\.5 {\n    height: 0.625rem;\n  }\n  .md\\:h-3\\.5 {\n    height: 0.875rem;\n  }\n  .md\\:h-1\\/2 {\n    height: 50%;\n  }\n  .md\\:h-1\\/3 {\n    height: 33.333333%;\n  }\n  .md\\:h-2\\/3 {\n    height: 66.666667%;\n  }\n  .md\\:h-1\\/4 {\n    height: 25%;\n  }\n  .md\\:h-2\\/4 {\n    height: 50%;\n  }\n  .md\\:h-3\\/4 {\n    height: 75%;\n  }\n  .md\\:h-1\\/5 {\n    height: 20%;\n  }\n  .md\\:h-2\\/5 {\n    height: 40%;\n  }\n  .md\\:h-3\\/5 {\n    height: 60%;\n  }\n  .md\\:h-4\\/5 {\n    height: 80%;\n  }\n  .md\\:h-1\\/6 {\n    height: 16.666667%;\n  }\n  .md\\:h-2\\/6 {\n    height: 33.333333%;\n  }\n  .md\\:h-3\\/6 {\n    height: 50%;\n  }\n  .md\\:h-4\\/6 {\n    height: 66.666667%;\n  }\n  .md\\:h-5\\/6 {\n    height: 83.333333%;\n  }\n  .md\\:h-1\\/12 {\n    height: 8.333333%;\n  }\n  .md\\:h-2\\/12 {\n    height: 16.666667%;\n  }\n  .md\\:h-3\\/12 {\n    height: 25%;\n  }\n  .md\\:h-4\\/12 {\n    height: 33.333333%;\n  }\n  .md\\:h-5\\/12 {\n    height: 41.666667%;\n  }\n  .md\\:h-6\\/12 {\n    height: 50%;\n  }\n  .md\\:h-7\\/12 {\n    height: 58.333333%;\n  }\n  .md\\:h-8\\/12 {\n    height: 66.666667%;\n  }\n  .md\\:h-9\\/12 {\n    height: 75%;\n  }\n  .md\\:h-10\\/12 {\n    height: 83.333333%;\n  }\n  .md\\:h-11\\/12 {\n    height: 91.666667%;\n  }\n  .md\\:h-full {\n    height: 100%;\n  }\n  .md\\:h-screen {\n    height: 100vh;\n  }\n  .md\\:text-xs {\n    font-size: 0.75rem;\n  }\n  .md\\:text-sm {\n    font-size: 0.875rem;\n  }\n  .md\\:text-base {\n    font-size: 1rem;\n  }\n  .md\\:text-lg {\n    font-size: 1.125rem;\n  }\n  .md\\:text-xl {\n    font-size: 1.25rem;\n  }\n  .md\\:text-2xl {\n    font-size: 1.5rem;\n  }\n  .md\\:text-3xl {\n    font-size: 1.875rem;\n  }\n  .md\\:text-4xl {\n    font-size: 2.25rem;\n  }\n  .md\\:text-5xl {\n    font-size: 3rem;\n  }\n  .md\\:text-6xl {\n    font-size: 4rem;\n  }\n  .md\\:leading-3 {\n    line-height: .75rem;\n  }\n  .md\\:leading-4 {\n    line-height: 1rem;\n  }\n  .md\\:leading-5 {\n    line-height: 1.25rem;\n  }\n  .md\\:leading-6 {\n    line-height: 1.5rem;\n  }\n  .md\\:leading-7 {\n    line-height: 1.75rem;\n  }\n  .md\\:leading-8 {\n    line-height: 2rem;\n  }\n  .md\\:leading-9 {\n    line-height: 2.25rem;\n  }\n  .md\\:leading-10 {\n    line-height: 2.5rem;\n  }\n  .md\\:leading-none {\n    line-height: 1;\n  }\n  .md\\:leading-tight {\n    line-height: 1.25;\n  }\n  .md\\:leading-snug {\n    line-height: 1.375;\n  }\n  .md\\:leading-normal {\n    line-height: 1.5;\n  }\n  .md\\:leading-relaxed {\n    line-height: 1.625;\n  }\n  .md\\:leading-loose {\n    line-height: 2;\n  }\n  .md\\:list-inside {\n    list-style-position: inside;\n  }\n  .md\\:list-outside {\n    list-style-position: outside;\n  }\n  .md\\:list-none {\n    list-style-type: none;\n  }\n  .md\\:list-disc {\n    list-style-type: disc;\n  }\n  .md\\:list-decimal {\n    list-style-type: decimal;\n  }\n  .md\\:m-0 {\n    margin: 0;\n  }\n  .md\\:m-1 {\n    margin: 0.25rem;\n  }\n  .md\\:m-2 {\n    margin: 0.5rem;\n  }\n  .md\\:m-3 {\n    margin: 0.75rem;\n  }\n  .md\\:m-4 {\n    margin: 1rem;\n  }\n  .md\\:m-5 {\n    margin: 1.25rem;\n  }\n  .md\\:m-6 {\n    margin: 1.5rem;\n  }\n  .md\\:m-7 {\n    margin: 1.75rem;\n  }\n  .md\\:m-8 {\n    margin: 2rem;\n  }\n  .md\\:m-9 {\n    margin: 2.25rem;\n  }\n  .md\\:m-10 {\n    margin: 2.5rem;\n  }\n  .md\\:m-11 {\n    margin: 2.75rem;\n  }\n  .md\\:m-12 {\n    margin: 3rem;\n  }\n  .md\\:m-13 {\n    margin: 3.25rem;\n  }\n  .md\\:m-14 {\n    margin: 3.5rem;\n  }\n  .md\\:m-15 {\n    margin: 3.75rem;\n  }\n  .md\\:m-16 {\n    margin: 4rem;\n  }\n  .md\\:m-20 {\n    margin: 5rem;\n  }\n  .md\\:m-24 {\n    margin: 6rem;\n  }\n  .md\\:m-28 {\n    margin: 7rem;\n  }\n  .md\\:m-32 {\n    margin: 8rem;\n  }\n  .md\\:m-36 {\n    margin: 9rem;\n  }\n  .md\\:m-40 {\n    margin: 10rem;\n  }\n  .md\\:m-44 {\n    margin: 11rem;\n  }\n  .md\\:m-48 {\n    margin: 12rem;\n  }\n  .md\\:m-52 {\n    margin: 13rem;\n  }\n  .md\\:m-56 {\n    margin: 14rem;\n  }\n  .md\\:m-60 {\n    margin: 15rem;\n  }\n  .md\\:m-64 {\n    margin: 16rem;\n  }\n  .md\\:m-72 {\n    margin: 18rem;\n  }\n  .md\\:m-80 {\n    margin: 20rem;\n  }\n  .md\\:m-96 {\n    margin: 24rem;\n  }\n  .md\\:m-auto {\n    margin: auto;\n  }\n  .md\\:m-px {\n    margin: 1px;\n  }\n  .md\\:m-0\\.5 {\n    margin: 0.125rem;\n  }\n  .md\\:m-1\\.5 {\n    margin: 0.375rem;\n  }\n  .md\\:m-2\\.5 {\n    margin: 0.625rem;\n  }\n  .md\\:m-3\\.5 {\n    margin: 0.875rem;\n  }\n  .md\\:m-1\\/2 {\n    margin: 50%;\n  }\n  .md\\:m-1\\/3 {\n    margin: 33.333333%;\n  }\n  .md\\:m-2\\/3 {\n    margin: 66.666667%;\n  }\n  .md\\:m-1\\/4 {\n    margin: 25%;\n  }\n  .md\\:m-2\\/4 {\n    margin: 50%;\n  }\n  .md\\:m-3\\/4 {\n    margin: 75%;\n  }\n  .md\\:m-1\\/5 {\n    margin: 20%;\n  }\n  .md\\:m-2\\/5 {\n    margin: 40%;\n  }\n  .md\\:m-3\\/5 {\n    margin: 60%;\n  }\n  .md\\:m-4\\/5 {\n    margin: 80%;\n  }\n  .md\\:m-1\\/6 {\n    margin: 16.666667%;\n  }\n  .md\\:m-2\\/6 {\n    margin: 33.333333%;\n  }\n  .md\\:m-3\\/6 {\n    margin: 50%;\n  }\n  .md\\:m-4\\/6 {\n    margin: 66.666667%;\n  }\n  .md\\:m-5\\/6 {\n    margin: 83.333333%;\n  }\n  .md\\:m-1\\/12 {\n    margin: 8.333333%;\n  }\n  .md\\:m-2\\/12 {\n    margin: 16.666667%;\n  }\n  .md\\:m-3\\/12 {\n    margin: 25%;\n  }\n  .md\\:m-4\\/12 {\n    margin: 33.333333%;\n  }\n  .md\\:m-5\\/12 {\n    margin: 41.666667%;\n  }\n  .md\\:m-6\\/12 {\n    margin: 50%;\n  }\n  .md\\:m-7\\/12 {\n    margin: 58.333333%;\n  }\n  .md\\:m-8\\/12 {\n    margin: 66.666667%;\n  }\n  .md\\:m-9\\/12 {\n    margin: 75%;\n  }\n  .md\\:m-10\\/12 {\n    margin: 83.333333%;\n  }\n  .md\\:m-11\\/12 {\n    margin: 91.666667%;\n  }\n  .md\\:m-full {\n    margin: 100%;\n  }\n  .md\\:-m-1 {\n    margin: -0.25rem;\n  }\n  .md\\:-m-2 {\n    margin: -0.5rem;\n  }\n  .md\\:-m-3 {\n    margin: -0.75rem;\n  }\n  .md\\:-m-4 {\n    margin: -1rem;\n  }\n  .md\\:-m-5 {\n    margin: -1.25rem;\n  }\n  .md\\:-m-6 {\n    margin: -1.5rem;\n  }\n  .md\\:-m-7 {\n    margin: -1.75rem;\n  }\n  .md\\:-m-8 {\n    margin: -2rem;\n  }\n  .md\\:-m-9 {\n    margin: -2.25rem;\n  }\n  .md\\:-m-10 {\n    margin: -2.5rem;\n  }\n  .md\\:-m-11 {\n    margin: -2.75rem;\n  }\n  .md\\:-m-12 {\n    margin: -3rem;\n  }\n  .md\\:-m-13 {\n    margin: -3.25rem;\n  }\n  .md\\:-m-14 {\n    margin: -3.5rem;\n  }\n  .md\\:-m-15 {\n    margin: -3.75rem;\n  }\n  .md\\:-m-16 {\n    margin: -4rem;\n  }\n  .md\\:-m-20 {\n    margin: -5rem;\n  }\n  .md\\:-m-24 {\n    margin: -6rem;\n  }\n  .md\\:-m-28 {\n    margin: -7rem;\n  }\n  .md\\:-m-32 {\n    margin: -8rem;\n  }\n  .md\\:-m-36 {\n    margin: -9rem;\n  }\n  .md\\:-m-40 {\n    margin: -10rem;\n  }\n  .md\\:-m-44 {\n    margin: -11rem;\n  }\n  .md\\:-m-48 {\n    margin: -12rem;\n  }\n  .md\\:-m-52 {\n    margin: -13rem;\n  }\n  .md\\:-m-56 {\n    margin: -14rem;\n  }\n  .md\\:-m-60 {\n    margin: -15rem;\n  }\n  .md\\:-m-64 {\n    margin: -16rem;\n  }\n  .md\\:-m-72 {\n    margin: -18rem;\n  }\n  .md\\:-m-80 {\n    margin: -20rem;\n  }\n  .md\\:-m-96 {\n    margin: -24rem;\n  }\n  .md\\:-m-px {\n    margin: -1px;\n  }\n  .md\\:-m-0\\.5 {\n    margin: -0.125rem;\n  }\n  .md\\:-m-1\\.5 {\n    margin: -0.375rem;\n  }\n  .md\\:-m-2\\.5 {\n    margin: -0.625rem;\n  }\n  .md\\:-m-3\\.5 {\n    margin: -0.875rem;\n  }\n  .md\\:-m-1\\/2 {\n    margin: -50%;\n  }\n  .md\\:-m-1\\/3 {\n    margin: -33.33333%;\n  }\n  .md\\:-m-2\\/3 {\n    margin: -66.66667%;\n  }\n  .md\\:-m-1\\/4 {\n    margin: -25%;\n  }\n  .md\\:-m-2\\/4 {\n    margin: -50%;\n  }\n  .md\\:-m-3\\/4 {\n    margin: -75%;\n  }\n  .md\\:-m-1\\/5 {\n    margin: -20%;\n  }\n  .md\\:-m-2\\/5 {\n    margin: -40%;\n  }\n  .md\\:-m-3\\/5 {\n    margin: -60%;\n  }\n  .md\\:-m-4\\/5 {\n    margin: -80%;\n  }\n  .md\\:-m-1\\/6 {\n    margin: -16.66667%;\n  }\n  .md\\:-m-2\\/6 {\n    margin: -33.33333%;\n  }\n  .md\\:-m-3\\/6 {\n    margin: -50%;\n  }\n  .md\\:-m-4\\/6 {\n    margin: -66.66667%;\n  }\n  .md\\:-m-5\\/6 {\n    margin: -83.33333%;\n  }\n  .md\\:-m-1\\/12 {\n    margin: -8.33333%;\n  }\n  .md\\:-m-2\\/12 {\n    margin: -16.66667%;\n  }\n  .md\\:-m-3\\/12 {\n    margin: -25%;\n  }\n  .md\\:-m-4\\/12 {\n    margin: -33.33333%;\n  }\n  .md\\:-m-5\\/12 {\n    margin: -41.66667%;\n  }\n  .md\\:-m-6\\/12 {\n    margin: -50%;\n  }\n  .md\\:-m-7\\/12 {\n    margin: -58.33333%;\n  }\n  .md\\:-m-8\\/12 {\n    margin: -66.66667%;\n  }\n  .md\\:-m-9\\/12 {\n    margin: -75%;\n  }\n  .md\\:-m-10\\/12 {\n    margin: -83.33333%;\n  }\n  .md\\:-m-11\\/12 {\n    margin: -91.66667%;\n  }\n  .md\\:-m-full {\n    margin: -100%;\n  }\n  .md\\:my-0 {\n    margin-top: 0;\n    margin-bottom: 0;\n  }\n  .md\\:mx-0 {\n    margin-left: 0;\n    margin-right: 0;\n  }\n  .md\\:my-1 {\n    margin-top: 0.25rem;\n    margin-bottom: 0.25rem;\n  }\n  .md\\:mx-1 {\n    margin-left: 0.25rem;\n    margin-right: 0.25rem;\n  }\n  .md\\:my-2 {\n    margin-top: 0.5rem;\n    margin-bottom: 0.5rem;\n  }\n  .md\\:mx-2 {\n    margin-left: 0.5rem;\n    margin-right: 0.5rem;\n  }\n  .md\\:my-3 {\n    margin-top: 0.75rem;\n    margin-bottom: 0.75rem;\n  }\n  .md\\:mx-3 {\n    margin-left: 0.75rem;\n    margin-right: 0.75rem;\n  }\n  .md\\:my-4 {\n    margin-top: 1rem;\n    margin-bottom: 1rem;\n  }\n  .md\\:mx-4 {\n    margin-left: 1rem;\n    margin-right: 1rem;\n  }\n  .md\\:my-5 {\n    margin-top: 1.25rem;\n    margin-bottom: 1.25rem;\n  }\n  .md\\:mx-5 {\n    margin-left: 1.25rem;\n    margin-right: 1.25rem;\n  }\n  .md\\:my-6 {\n    margin-top: 1.5rem;\n    margin-bottom: 1.5rem;\n  }\n  .md\\:mx-6 {\n    margin-left: 1.5rem;\n    margin-right: 1.5rem;\n  }\n  .md\\:my-7 {\n    margin-top: 1.75rem;\n    margin-bottom: 1.75rem;\n  }\n  .md\\:mx-7 {\n    margin-left: 1.75rem;\n    margin-right: 1.75rem;\n  }\n  .md\\:my-8 {\n    margin-top: 2rem;\n    margin-bottom: 2rem;\n  }\n  .md\\:mx-8 {\n    margin-left: 2rem;\n    margin-right: 2rem;\n  }\n  .md\\:my-9 {\n    margin-top: 2.25rem;\n    margin-bottom: 2.25rem;\n  }\n  .md\\:mx-9 {\n    margin-left: 2.25rem;\n    margin-right: 2.25rem;\n  }\n  .md\\:my-10 {\n    margin-top: 2.5rem;\n    margin-bottom: 2.5rem;\n  }\n  .md\\:mx-10 {\n    margin-left: 2.5rem;\n    margin-right: 2.5rem;\n  }\n  .md\\:my-11 {\n    margin-top: 2.75rem;\n    margin-bottom: 2.75rem;\n  }\n  .md\\:mx-11 {\n    margin-left: 2.75rem;\n    margin-right: 2.75rem;\n  }\n  .md\\:my-12 {\n    margin-top: 3rem;\n    margin-bottom: 3rem;\n  }\n  .md\\:mx-12 {\n    margin-left: 3rem;\n    margin-right: 3rem;\n  }\n  .md\\:my-13 {\n    margin-top: 3.25rem;\n    margin-bottom: 3.25rem;\n  }\n  .md\\:mx-13 {\n    margin-left: 3.25rem;\n    margin-right: 3.25rem;\n  }\n  .md\\:my-14 {\n    margin-top: 3.5rem;\n    margin-bottom: 3.5rem;\n  }\n  .md\\:mx-14 {\n    margin-left: 3.5rem;\n    margin-right: 3.5rem;\n  }\n  .md\\:my-15 {\n    margin-top: 3.75rem;\n    margin-bottom: 3.75rem;\n  }\n  .md\\:mx-15 {\n    margin-left: 3.75rem;\n    margin-right: 3.75rem;\n  }\n  .md\\:my-16 {\n    margin-top: 4rem;\n    margin-bottom: 4rem;\n  }\n  .md\\:mx-16 {\n    margin-left: 4rem;\n    margin-right: 4rem;\n  }\n  .md\\:my-20 {\n    margin-top: 5rem;\n    margin-bottom: 5rem;\n  }\n  .md\\:mx-20 {\n    margin-left: 5rem;\n    margin-right: 5rem;\n  }\n  .md\\:my-24 {\n    margin-top: 6rem;\n    margin-bottom: 6rem;\n  }\n  .md\\:mx-24 {\n    margin-left: 6rem;\n    margin-right: 6rem;\n  }\n  .md\\:my-28 {\n    margin-top: 7rem;\n    margin-bottom: 7rem;\n  }\n  .md\\:mx-28 {\n    margin-left: 7rem;\n    margin-right: 7rem;\n  }\n  .md\\:my-32 {\n    margin-top: 8rem;\n    margin-bottom: 8rem;\n  }\n  .md\\:mx-32 {\n    margin-left: 8rem;\n    margin-right: 8rem;\n  }\n  .md\\:my-36 {\n    margin-top: 9rem;\n    margin-bottom: 9rem;\n  }\n  .md\\:mx-36 {\n    margin-left: 9rem;\n    margin-right: 9rem;\n  }\n  .md\\:my-40 {\n    margin-top: 10rem;\n    margin-bottom: 10rem;\n  }\n  .md\\:mx-40 {\n    margin-left: 10rem;\n    margin-right: 10rem;\n  }\n  .md\\:my-44 {\n    margin-top: 11rem;\n    margin-bottom: 11rem;\n  }\n  .md\\:mx-44 {\n    margin-left: 11rem;\n    margin-right: 11rem;\n  }\n  .md\\:my-48 {\n    margin-top: 12rem;\n    margin-bottom: 12rem;\n  }\n  .md\\:mx-48 {\n    margin-left: 12rem;\n    margin-right: 12rem;\n  }\n  .md\\:my-52 {\n    margin-top: 13rem;\n    margin-bottom: 13rem;\n  }\n  .md\\:mx-52 {\n    margin-left: 13rem;\n    margin-right: 13rem;\n  }\n  .md\\:my-56 {\n    margin-top: 14rem;\n    margin-bottom: 14rem;\n  }\n  .md\\:mx-56 {\n    margin-left: 14rem;\n    margin-right: 14rem;\n  }\n  .md\\:my-60 {\n    margin-top: 15rem;\n    margin-bottom: 15rem;\n  }\n  .md\\:mx-60 {\n    margin-left: 15rem;\n    margin-right: 15rem;\n  }\n  .md\\:my-64 {\n    margin-top: 16rem;\n    margin-bottom: 16rem;\n  }\n  .md\\:mx-64 {\n    margin-left: 16rem;\n    margin-right: 16rem;\n  }\n  .md\\:my-72 {\n    margin-top: 18rem;\n    margin-bottom: 18rem;\n  }\n  .md\\:mx-72 {\n    margin-left: 18rem;\n    margin-right: 18rem;\n  }\n  .md\\:my-80 {\n    margin-top: 20rem;\n    margin-bottom: 20rem;\n  }\n  .md\\:mx-80 {\n    margin-left: 20rem;\n    margin-right: 20rem;\n  }\n  .md\\:my-96 {\n    margin-top: 24rem;\n    margin-bottom: 24rem;\n  }\n  .md\\:mx-96 {\n    margin-left: 24rem;\n    margin-right: 24rem;\n  }\n  .md\\:my-auto {\n    margin-top: auto;\n    margin-bottom: auto;\n  }\n  .md\\:mx-auto {\n    margin-left: auto;\n    margin-right: auto;\n  }\n  .md\\:my-px {\n    margin-top: 1px;\n    margin-bottom: 1px;\n  }\n  .md\\:mx-px {\n    margin-left: 1px;\n    margin-right: 1px;\n  }\n  .md\\:my-0\\.5 {\n    margin-top: 0.125rem;\n    margin-bottom: 0.125rem;\n  }\n  .md\\:mx-0\\.5 {\n    margin-left: 0.125rem;\n    margin-right: 0.125rem;\n  }\n  .md\\:my-1\\.5 {\n    margin-top: 0.375rem;\n    margin-bottom: 0.375rem;\n  }\n  .md\\:mx-1\\.5 {\n    margin-left: 0.375rem;\n    margin-right: 0.375rem;\n  }\n  .md\\:my-2\\.5 {\n    margin-top: 0.625rem;\n    margin-bottom: 0.625rem;\n  }\n  .md\\:mx-2\\.5 {\n    margin-left: 0.625rem;\n    margin-right: 0.625rem;\n  }\n  .md\\:my-3\\.5 {\n    margin-top: 0.875rem;\n    margin-bottom: 0.875rem;\n  }\n  .md\\:mx-3\\.5 {\n    margin-left: 0.875rem;\n    margin-right: 0.875rem;\n  }\n  .md\\:my-1\\/2 {\n    margin-top: 50%;\n    margin-bottom: 50%;\n  }\n  .md\\:mx-1\\/2 {\n    margin-left: 50%;\n    margin-right: 50%;\n  }\n  .md\\:my-1\\/3 {\n    margin-top: 33.333333%;\n    margin-bottom: 33.333333%;\n  }\n  .md\\:mx-1\\/3 {\n    margin-left: 33.333333%;\n    margin-right: 33.333333%;\n  }\n  .md\\:my-2\\/3 {\n    margin-top: 66.666667%;\n    margin-bottom: 66.666667%;\n  }\n  .md\\:mx-2\\/3 {\n    margin-left: 66.666667%;\n    margin-right: 66.666667%;\n  }\n  .md\\:my-1\\/4 {\n    margin-top: 25%;\n    margin-bottom: 25%;\n  }\n  .md\\:mx-1\\/4 {\n    margin-left: 25%;\n    margin-right: 25%;\n  }\n  .md\\:my-2\\/4 {\n    margin-top: 50%;\n    margin-bottom: 50%;\n  }\n  .md\\:mx-2\\/4 {\n    margin-left: 50%;\n    margin-right: 50%;\n  }\n  .md\\:my-3\\/4 {\n    margin-top: 75%;\n    margin-bottom: 75%;\n  }\n  .md\\:mx-3\\/4 {\n    margin-left: 75%;\n    margin-right: 75%;\n  }\n  .md\\:my-1\\/5 {\n    margin-top: 20%;\n    margin-bottom: 20%;\n  }\n  .md\\:mx-1\\/5 {\n    margin-left: 20%;\n    margin-right: 20%;\n  }\n  .md\\:my-2\\/5 {\n    margin-top: 40%;\n    margin-bottom: 40%;\n  }\n  .md\\:mx-2\\/5 {\n    margin-left: 40%;\n    margin-right: 40%;\n  }\n  .md\\:my-3\\/5 {\n    margin-top: 60%;\n    margin-bottom: 60%;\n  }\n  .md\\:mx-3\\/5 {\n    margin-left: 60%;\n    margin-right: 60%;\n  }\n  .md\\:my-4\\/5 {\n    margin-top: 80%;\n    margin-bottom: 80%;\n  }\n  .md\\:mx-4\\/5 {\n    margin-left: 80%;\n    margin-right: 80%;\n  }\n  .md\\:my-1\\/6 {\n    margin-top: 16.666667%;\n    margin-bottom: 16.666667%;\n  }\n  .md\\:mx-1\\/6 {\n    margin-left: 16.666667%;\n    margin-right: 16.666667%;\n  }\n  .md\\:my-2\\/6 {\n    margin-top: 33.333333%;\n    margin-bottom: 33.333333%;\n  }\n  .md\\:mx-2\\/6 {\n    margin-left: 33.333333%;\n    margin-right: 33.333333%;\n  }\n  .md\\:my-3\\/6 {\n    margin-top: 50%;\n    margin-bottom: 50%;\n  }\n  .md\\:mx-3\\/6 {\n    margin-left: 50%;\n    margin-right: 50%;\n  }\n  .md\\:my-4\\/6 {\n    margin-top: 66.666667%;\n    margin-bottom: 66.666667%;\n  }\n  .md\\:mx-4\\/6 {\n    margin-left: 66.666667%;\n    margin-right: 66.666667%;\n  }\n  .md\\:my-5\\/6 {\n    margin-top: 83.333333%;\n    margin-bottom: 83.333333%;\n  }\n  .md\\:mx-5\\/6 {\n    margin-left: 83.333333%;\n    margin-right: 83.333333%;\n  }\n  .md\\:my-1\\/12 {\n    margin-top: 8.333333%;\n    margin-bottom: 8.333333%;\n  }\n  .md\\:mx-1\\/12 {\n    margin-left: 8.333333%;\n    margin-right: 8.333333%;\n  }\n  .md\\:my-2\\/12 {\n    margin-top: 16.666667%;\n    margin-bottom: 16.666667%;\n  }\n  .md\\:mx-2\\/12 {\n    margin-left: 16.666667%;\n    margin-right: 16.666667%;\n  }\n  .md\\:my-3\\/12 {\n    margin-top: 25%;\n    margin-bottom: 25%;\n  }\n  .md\\:mx-3\\/12 {\n    margin-left: 25%;\n    margin-right: 25%;\n  }\n  .md\\:my-4\\/12 {\n    margin-top: 33.333333%;\n    margin-bottom: 33.333333%;\n  }\n  .md\\:mx-4\\/12 {\n    margin-left: 33.333333%;\n    margin-right: 33.333333%;\n  }\n  .md\\:my-5\\/12 {\n    margin-top: 41.666667%;\n    margin-bottom: 41.666667%;\n  }\n  .md\\:mx-5\\/12 {\n    margin-left: 41.666667%;\n    margin-right: 41.666667%;\n  }\n  .md\\:my-6\\/12 {\n    margin-top: 50%;\n    margin-bottom: 50%;\n  }\n  .md\\:mx-6\\/12 {\n    margin-left: 50%;\n    margin-right: 50%;\n  }\n  .md\\:my-7\\/12 {\n    margin-top: 58.333333%;\n    margin-bottom: 58.333333%;\n  }\n  .md\\:mx-7\\/12 {\n    margin-left: 58.333333%;\n    margin-right: 58.333333%;\n  }\n  .md\\:my-8\\/12 {\n    margin-top: 66.666667%;\n    margin-bottom: 66.666667%;\n  }\n  .md\\:mx-8\\/12 {\n    margin-left: 66.666667%;\n    margin-right: 66.666667%;\n  }\n  .md\\:my-9\\/12 {\n    margin-top: 75%;\n    margin-bottom: 75%;\n  }\n  .md\\:mx-9\\/12 {\n    margin-left: 75%;\n    margin-right: 75%;\n  }\n  .md\\:my-10\\/12 {\n    margin-top: 83.333333%;\n    margin-bottom: 83.333333%;\n  }\n  .md\\:mx-10\\/12 {\n    margin-left: 83.333333%;\n    margin-right: 83.333333%;\n  }\n  .md\\:my-11\\/12 {\n    margin-top: 91.666667%;\n    margin-bottom: 91.666667%;\n  }\n  .md\\:mx-11\\/12 {\n    margin-left: 91.666667%;\n    margin-right: 91.666667%;\n  }\n  .md\\:my-full {\n    margin-top: 100%;\n    margin-bottom: 100%;\n  }\n  .md\\:mx-full {\n    margin-left: 100%;\n    margin-right: 100%;\n  }\n  .md\\:-my-1 {\n    margin-top: -0.25rem;\n    margin-bottom: -0.25rem;\n  }\n  .md\\:-mx-1 {\n    margin-left: -0.25rem;\n    margin-right: -0.25rem;\n  }\n  .md\\:-my-2 {\n    margin-top: -0.5rem;\n    margin-bottom: -0.5rem;\n  }\n  .md\\:-mx-2 {\n    margin-left: -0.5rem;\n    margin-right: -0.5rem;\n  }\n  .md\\:-my-3 {\n    margin-top: -0.75rem;\n    margin-bottom: -0.75rem;\n  }\n  .md\\:-mx-3 {\n    margin-left: -0.75rem;\n    margin-right: -0.75rem;\n  }\n  .md\\:-my-4 {\n    margin-top: -1rem;\n    margin-bottom: -1rem;\n  }\n  .md\\:-mx-4 {\n    margin-left: -1rem;\n    margin-right: -1rem;\n  }\n  .md\\:-my-5 {\n    margin-top: -1.25rem;\n    margin-bottom: -1.25rem;\n  }\n  .md\\:-mx-5 {\n    margin-left: -1.25rem;\n    margin-right: -1.25rem;\n  }\n  .md\\:-my-6 {\n    margin-top: -1.5rem;\n    margin-bottom: -1.5rem;\n  }\n  .md\\:-mx-6 {\n    margin-left: -1.5rem;\n    margin-right: -1.5rem;\n  }\n  .md\\:-my-7 {\n    margin-top: -1.75rem;\n    margin-bottom: -1.75rem;\n  }\n  .md\\:-mx-7 {\n    margin-left: -1.75rem;\n    margin-right: -1.75rem;\n  }\n  .md\\:-my-8 {\n    margin-top: -2rem;\n    margin-bottom: -2rem;\n  }\n  .md\\:-mx-8 {\n    margin-left: -2rem;\n    margin-right: -2rem;\n  }\n  .md\\:-my-9 {\n    margin-top: -2.25rem;\n    margin-bottom: -2.25rem;\n  }\n  .md\\:-mx-9 {\n    margin-left: -2.25rem;\n    margin-right: -2.25rem;\n  }\n  .md\\:-my-10 {\n    margin-top: -2.5rem;\n    margin-bottom: -2.5rem;\n  }\n  .md\\:-mx-10 {\n    margin-left: -2.5rem;\n    margin-right: -2.5rem;\n  }\n  .md\\:-my-11 {\n    margin-top: -2.75rem;\n    margin-bottom: -2.75rem;\n  }\n  .md\\:-mx-11 {\n    margin-left: -2.75rem;\n    margin-right: -2.75rem;\n  }\n  .md\\:-my-12 {\n    margin-top: -3rem;\n    margin-bottom: -3rem;\n  }\n  .md\\:-mx-12 {\n    margin-left: -3rem;\n    margin-right: -3rem;\n  }\n  .md\\:-my-13 {\n    margin-top: -3.25rem;\n    margin-bottom: -3.25rem;\n  }\n  .md\\:-mx-13 {\n    margin-left: -3.25rem;\n    margin-right: -3.25rem;\n  }\n  .md\\:-my-14 {\n    margin-top: -3.5rem;\n    margin-bottom: -3.5rem;\n  }\n  .md\\:-mx-14 {\n    margin-left: -3.5rem;\n    margin-right: -3.5rem;\n  }\n  .md\\:-my-15 {\n    margin-top: -3.75rem;\n    margin-bottom: -3.75rem;\n  }\n  .md\\:-mx-15 {\n    margin-left: -3.75rem;\n    margin-right: -3.75rem;\n  }\n  .md\\:-my-16 {\n    margin-top: -4rem;\n    margin-bottom: -4rem;\n  }\n  .md\\:-mx-16 {\n    margin-left: -4rem;\n    margin-right: -4rem;\n  }\n  .md\\:-my-20 {\n    margin-top: -5rem;\n    margin-bottom: -5rem;\n  }\n  .md\\:-mx-20 {\n    margin-left: -5rem;\n    margin-right: -5rem;\n  }\n  .md\\:-my-24 {\n    margin-top: -6rem;\n    margin-bottom: -6rem;\n  }\n  .md\\:-mx-24 {\n    margin-left: -6rem;\n    margin-right: -6rem;\n  }\n  .md\\:-my-28 {\n    margin-top: -7rem;\n    margin-bottom: -7rem;\n  }\n  .md\\:-mx-28 {\n    margin-left: -7rem;\n    margin-right: -7rem;\n  }\n  .md\\:-my-32 {\n    margin-top: -8rem;\n    margin-bottom: -8rem;\n  }\n  .md\\:-mx-32 {\n    margin-left: -8rem;\n    margin-right: -8rem;\n  }\n  .md\\:-my-36 {\n    margin-top: -9rem;\n    margin-bottom: -9rem;\n  }\n  .md\\:-mx-36 {\n    margin-left: -9rem;\n    margin-right: -9rem;\n  }\n  .md\\:-my-40 {\n    margin-top: -10rem;\n    margin-bottom: -10rem;\n  }\n  .md\\:-mx-40 {\n    margin-left: -10rem;\n    margin-right: -10rem;\n  }\n  .md\\:-my-44 {\n    margin-top: -11rem;\n    margin-bottom: -11rem;\n  }\n  .md\\:-mx-44 {\n    margin-left: -11rem;\n    margin-right: -11rem;\n  }\n  .md\\:-my-48 {\n    margin-top: -12rem;\n    margin-bottom: -12rem;\n  }\n  .md\\:-mx-48 {\n    margin-left: -12rem;\n    margin-right: -12rem;\n  }\n  .md\\:-my-52 {\n    margin-top: -13rem;\n    margin-bottom: -13rem;\n  }\n  .md\\:-mx-52 {\n    margin-left: -13rem;\n    margin-right: -13rem;\n  }\n  .md\\:-my-56 {\n    margin-top: -14rem;\n    margin-bottom: -14rem;\n  }\n  .md\\:-mx-56 {\n    margin-left: -14rem;\n    margin-right: -14rem;\n  }\n  .md\\:-my-60 {\n    margin-top: -15rem;\n    margin-bottom: -15rem;\n  }\n  .md\\:-mx-60 {\n    margin-left: -15rem;\n    margin-right: -15rem;\n  }\n  .md\\:-my-64 {\n    margin-top: -16rem;\n    margin-bottom: -16rem;\n  }\n  .md\\:-mx-64 {\n    margin-left: -16rem;\n    margin-right: -16rem;\n  }\n  .md\\:-my-72 {\n    margin-top: -18rem;\n    margin-bottom: -18rem;\n  }\n  .md\\:-mx-72 {\n    margin-left: -18rem;\n    margin-right: -18rem;\n  }\n  .md\\:-my-80 {\n    margin-top: -20rem;\n    margin-bottom: -20rem;\n  }\n  .md\\:-mx-80 {\n    margin-left: -20rem;\n    margin-right: -20rem;\n  }\n  .md\\:-my-96 {\n    margin-top: -24rem;\n    margin-bottom: -24rem;\n  }\n  .md\\:-mx-96 {\n    margin-left: -24rem;\n    margin-right: -24rem;\n  }\n  .md\\:-my-px {\n    margin-top: -1px;\n    margin-bottom: -1px;\n  }\n  .md\\:-mx-px {\n    margin-left: -1px;\n    margin-right: -1px;\n  }\n  .md\\:-my-0\\.5 {\n    margin-top: -0.125rem;\n    margin-bottom: -0.125rem;\n  }\n  .md\\:-mx-0\\.5 {\n    margin-left: -0.125rem;\n    margin-right: -0.125rem;\n  }\n  .md\\:-my-1\\.5 {\n    margin-top: -0.375rem;\n    margin-bottom: -0.375rem;\n  }\n  .md\\:-mx-1\\.5 {\n    margin-left: -0.375rem;\n    margin-right: -0.375rem;\n  }\n  .md\\:-my-2\\.5 {\n    margin-top: -0.625rem;\n    margin-bottom: -0.625rem;\n  }\n  .md\\:-mx-2\\.5 {\n    margin-left: -0.625rem;\n    margin-right: -0.625rem;\n  }\n  .md\\:-my-3\\.5 {\n    margin-top: -0.875rem;\n    margin-bottom: -0.875rem;\n  }\n  .md\\:-mx-3\\.5 {\n    margin-left: -0.875rem;\n    margin-right: -0.875rem;\n  }\n  .md\\:-my-1\\/2 {\n    margin-top: -50%;\n    margin-bottom: -50%;\n  }\n  .md\\:-mx-1\\/2 {\n    margin-left: -50%;\n    margin-right: -50%;\n  }\n  .md\\:-my-1\\/3 {\n    margin-top: -33.33333%;\n    margin-bottom: -33.33333%;\n  }\n  .md\\:-mx-1\\/3 {\n    margin-left: -33.33333%;\n    margin-right: -33.33333%;\n  }\n  .md\\:-my-2\\/3 {\n    margin-top: -66.66667%;\n    margin-bottom: -66.66667%;\n  }\n  .md\\:-mx-2\\/3 {\n    margin-left: -66.66667%;\n    margin-right: -66.66667%;\n  }\n  .md\\:-my-1\\/4 {\n    margin-top: -25%;\n    margin-bottom: -25%;\n  }\n  .md\\:-mx-1\\/4 {\n    margin-left: -25%;\n    margin-right: -25%;\n  }\n  .md\\:-my-2\\/4 {\n    margin-top: -50%;\n    margin-bottom: -50%;\n  }\n  .md\\:-mx-2\\/4 {\n    margin-left: -50%;\n    margin-right: -50%;\n  }\n  .md\\:-my-3\\/4 {\n    margin-top: -75%;\n    margin-bottom: -75%;\n  }\n  .md\\:-mx-3\\/4 {\n    margin-left: -75%;\n    margin-right: -75%;\n  }\n  .md\\:-my-1\\/5 {\n    margin-top: -20%;\n    margin-bottom: -20%;\n  }\n  .md\\:-mx-1\\/5 {\n    margin-left: -20%;\n    margin-right: -20%;\n  }\n  .md\\:-my-2\\/5 {\n    margin-top: -40%;\n    margin-bottom: -40%;\n  }\n  .md\\:-mx-2\\/5 {\n    margin-left: -40%;\n    margin-right: -40%;\n  }\n  .md\\:-my-3\\/5 {\n    margin-top: -60%;\n    margin-bottom: -60%;\n  }\n  .md\\:-mx-3\\/5 {\n    margin-left: -60%;\n    margin-right: -60%;\n  }\n  .md\\:-my-4\\/5 {\n    margin-top: -80%;\n    margin-bottom: -80%;\n  }\n  .md\\:-mx-4\\/5 {\n    margin-left: -80%;\n    margin-right: -80%;\n  }\n  .md\\:-my-1\\/6 {\n    margin-top: -16.66667%;\n    margin-bottom: -16.66667%;\n  }\n  .md\\:-mx-1\\/6 {\n    margin-left: -16.66667%;\n    margin-right: -16.66667%;\n  }\n  .md\\:-my-2\\/6 {\n    margin-top: -33.33333%;\n    margin-bottom: -33.33333%;\n  }\n  .md\\:-mx-2\\/6 {\n    margin-left: -33.33333%;\n    margin-right: -33.33333%;\n  }\n  .md\\:-my-3\\/6 {\n    margin-top: -50%;\n    margin-bottom: -50%;\n  }\n  .md\\:-mx-3\\/6 {\n    margin-left: -50%;\n    margin-right: -50%;\n  }\n  .md\\:-my-4\\/6 {\n    margin-top: -66.66667%;\n    margin-bottom: -66.66667%;\n  }\n  .md\\:-mx-4\\/6 {\n    margin-left: -66.66667%;\n    margin-right: -66.66667%;\n  }\n  .md\\:-my-5\\/6 {\n    margin-top: -83.33333%;\n    margin-bottom: -83.33333%;\n  }\n  .md\\:-mx-5\\/6 {\n    margin-left: -83.33333%;\n    margin-right: -83.33333%;\n  }\n  .md\\:-my-1\\/12 {\n    margin-top: -8.33333%;\n    margin-bottom: -8.33333%;\n  }\n  .md\\:-mx-1\\/12 {\n    margin-left: -8.33333%;\n    margin-right: -8.33333%;\n  }\n  .md\\:-my-2\\/12 {\n    margin-top: -16.66667%;\n    margin-bottom: -16.66667%;\n  }\n  .md\\:-mx-2\\/12 {\n    margin-left: -16.66667%;\n    margin-right: -16.66667%;\n  }\n  .md\\:-my-3\\/12 {\n    margin-top: -25%;\n    margin-bottom: -25%;\n  }\n  .md\\:-mx-3\\/12 {\n    margin-left: -25%;\n    margin-right: -25%;\n  }\n  .md\\:-my-4\\/12 {\n    margin-top: -33.33333%;\n    margin-bottom: -33.33333%;\n  }\n  .md\\:-mx-4\\/12 {\n    margin-left: -33.33333%;\n    margin-right: -33.33333%;\n  }\n  .md\\:-my-5\\/12 {\n    margin-top: -41.66667%;\n    margin-bottom: -41.66667%;\n  }\n  .md\\:-mx-5\\/12 {\n    margin-left: -41.66667%;\n    margin-right: -41.66667%;\n  }\n  .md\\:-my-6\\/12 {\n    margin-top: -50%;\n    margin-bottom: -50%;\n  }\n  .md\\:-mx-6\\/12 {\n    margin-left: -50%;\n    margin-right: -50%;\n  }\n  .md\\:-my-7\\/12 {\n    margin-top: -58.33333%;\n    margin-bottom: -58.33333%;\n  }\n  .md\\:-mx-7\\/12 {\n    margin-left: -58.33333%;\n    margin-right: -58.33333%;\n  }\n  .md\\:-my-8\\/12 {\n    margin-top: -66.66667%;\n    margin-bottom: -66.66667%;\n  }\n  .md\\:-mx-8\\/12 {\n    margin-left: -66.66667%;\n    margin-right: -66.66667%;\n  }\n  .md\\:-my-9\\/12 {\n    margin-top: -75%;\n    margin-bottom: -75%;\n  }\n  .md\\:-mx-9\\/12 {\n    margin-left: -75%;\n    margin-right: -75%;\n  }\n  .md\\:-my-10\\/12 {\n    margin-top: -83.33333%;\n    margin-bottom: -83.33333%;\n  }\n  .md\\:-mx-10\\/12 {\n    margin-left: -83.33333%;\n    margin-right: -83.33333%;\n  }\n  .md\\:-my-11\\/12 {\n    margin-top: -91.66667%;\n    margin-bottom: -91.66667%;\n  }\n  .md\\:-mx-11\\/12 {\n    margin-left: -91.66667%;\n    margin-right: -91.66667%;\n  }\n  .md\\:-my-full {\n    margin-top: -100%;\n    margin-bottom: -100%;\n  }\n  .md\\:-mx-full {\n    margin-left: -100%;\n    margin-right: -100%;\n  }\n  .md\\:mt-0 {\n    margin-top: 0;\n  }\n  .md\\:mr-0 {\n    margin-right: 0;\n  }\n  .md\\:mb-0 {\n    margin-bottom: 0;\n  }\n  .md\\:ml-0 {\n    margin-left: 0;\n  }\n  .md\\:mt-1 {\n    margin-top: 0.25rem;\n  }\n  .md\\:mr-1 {\n    margin-right: 0.25rem;\n  }\n  .md\\:mb-1 {\n    margin-bottom: 0.25rem;\n  }\n  .md\\:ml-1 {\n    margin-left: 0.25rem;\n  }\n  .md\\:mt-2 {\n    margin-top: 0.5rem;\n  }\n  .md\\:mr-2 {\n    margin-right: 0.5rem;\n  }\n  .md\\:mb-2 {\n    margin-bottom: 0.5rem;\n  }\n  .md\\:ml-2 {\n    margin-left: 0.5rem;\n  }\n  .md\\:mt-3 {\n    margin-top: 0.75rem;\n  }\n  .md\\:mr-3 {\n    margin-right: 0.75rem;\n  }\n  .md\\:mb-3 {\n    margin-bottom: 0.75rem;\n  }\n  .md\\:ml-3 {\n    margin-left: 0.75rem;\n  }\n  .md\\:mt-4 {\n    margin-top: 1rem;\n  }\n  .md\\:mr-4 {\n    margin-right: 1rem;\n  }\n  .md\\:mb-4 {\n    margin-bottom: 1rem;\n  }\n  .md\\:ml-4 {\n    margin-left: 1rem;\n  }\n  .md\\:mt-5 {\n    margin-top: 1.25rem;\n  }\n  .md\\:mr-5 {\n    margin-right: 1.25rem;\n  }\n  .md\\:mb-5 {\n    margin-bottom: 1.25rem;\n  }\n  .md\\:ml-5 {\n    margin-left: 1.25rem;\n  }\n  .md\\:mt-6 {\n    margin-top: 1.5rem;\n  }\n  .md\\:mr-6 {\n    margin-right: 1.5rem;\n  }\n  .md\\:mb-6 {\n    margin-bottom: 1.5rem;\n  }\n  .md\\:ml-6 {\n    margin-left: 1.5rem;\n  }\n  .md\\:mt-7 {\n    margin-top: 1.75rem;\n  }\n  .md\\:mr-7 {\n    margin-right: 1.75rem;\n  }\n  .md\\:mb-7 {\n    margin-bottom: 1.75rem;\n  }\n  .md\\:ml-7 {\n    margin-left: 1.75rem;\n  }\n  .md\\:mt-8 {\n    margin-top: 2rem;\n  }\n  .md\\:mr-8 {\n    margin-right: 2rem;\n  }\n  .md\\:mb-8 {\n    margin-bottom: 2rem;\n  }\n  .md\\:ml-8 {\n    margin-left: 2rem;\n  }\n  .md\\:mt-9 {\n    margin-top: 2.25rem;\n  }\n  .md\\:mr-9 {\n    margin-right: 2.25rem;\n  }\n  .md\\:mb-9 {\n    margin-bottom: 2.25rem;\n  }\n  .md\\:ml-9 {\n    margin-left: 2.25rem;\n  }\n  .md\\:mt-10 {\n    margin-top: 2.5rem;\n  }\n  .md\\:mr-10 {\n    margin-right: 2.5rem;\n  }\n  .md\\:mb-10 {\n    margin-bottom: 2.5rem;\n  }\n  .md\\:ml-10 {\n    margin-left: 2.5rem;\n  }\n  .md\\:mt-11 {\n    margin-top: 2.75rem;\n  }\n  .md\\:mr-11 {\n    margin-right: 2.75rem;\n  }\n  .md\\:mb-11 {\n    margin-bottom: 2.75rem;\n  }\n  .md\\:ml-11 {\n    margin-left: 2.75rem;\n  }\n  .md\\:mt-12 {\n    margin-top: 3rem;\n  }\n  .md\\:mr-12 {\n    margin-right: 3rem;\n  }\n  .md\\:mb-12 {\n    margin-bottom: 3rem;\n  }\n  .md\\:ml-12 {\n    margin-left: 3rem;\n  }\n  .md\\:mt-13 {\n    margin-top: 3.25rem;\n  }\n  .md\\:mr-13 {\n    margin-right: 3.25rem;\n  }\n  .md\\:mb-13 {\n    margin-bottom: 3.25rem;\n  }\n  .md\\:ml-13 {\n    margin-left: 3.25rem;\n  }\n  .md\\:mt-14 {\n    margin-top: 3.5rem;\n  }\n  .md\\:mr-14 {\n    margin-right: 3.5rem;\n  }\n  .md\\:mb-14 {\n    margin-bottom: 3.5rem;\n  }\n  .md\\:ml-14 {\n    margin-left: 3.5rem;\n  }\n  .md\\:mt-15 {\n    margin-top: 3.75rem;\n  }\n  .md\\:mr-15 {\n    margin-right: 3.75rem;\n  }\n  .md\\:mb-15 {\n    margin-bottom: 3.75rem;\n  }\n  .md\\:ml-15 {\n    margin-left: 3.75rem;\n  }\n  .md\\:mt-16 {\n    margin-top: 4rem;\n  }\n  .md\\:mr-16 {\n    margin-right: 4rem;\n  }\n  .md\\:mb-16 {\n    margin-bottom: 4rem;\n  }\n  .md\\:ml-16 {\n    margin-left: 4rem;\n  }\n  .md\\:mt-20 {\n    margin-top: 5rem;\n  }\n  .md\\:mr-20 {\n    margin-right: 5rem;\n  }\n  .md\\:mb-20 {\n    margin-bottom: 5rem;\n  }\n  .md\\:ml-20 {\n    margin-left: 5rem;\n  }\n  .md\\:mt-24 {\n    margin-top: 6rem;\n  }\n  .md\\:mr-24 {\n    margin-right: 6rem;\n  }\n  .md\\:mb-24 {\n    margin-bottom: 6rem;\n  }\n  .md\\:ml-24 {\n    margin-left: 6rem;\n  }\n  .md\\:mt-28 {\n    margin-top: 7rem;\n  }\n  .md\\:mr-28 {\n    margin-right: 7rem;\n  }\n  .md\\:mb-28 {\n    margin-bottom: 7rem;\n  }\n  .md\\:ml-28 {\n    margin-left: 7rem;\n  }\n  .md\\:mt-32 {\n    margin-top: 8rem;\n  }\n  .md\\:mr-32 {\n    margin-right: 8rem;\n  }\n  .md\\:mb-32 {\n    margin-bottom: 8rem;\n  }\n  .md\\:ml-32 {\n    margin-left: 8rem;\n  }\n  .md\\:mt-36 {\n    margin-top: 9rem;\n  }\n  .md\\:mr-36 {\n    margin-right: 9rem;\n  }\n  .md\\:mb-36 {\n    margin-bottom: 9rem;\n  }\n  .md\\:ml-36 {\n    margin-left: 9rem;\n  }\n  .md\\:mt-40 {\n    margin-top: 10rem;\n  }\n  .md\\:mr-40 {\n    margin-right: 10rem;\n  }\n  .md\\:mb-40 {\n    margin-bottom: 10rem;\n  }\n  .md\\:ml-40 {\n    margin-left: 10rem;\n  }\n  .md\\:mt-44 {\n    margin-top: 11rem;\n  }\n  .md\\:mr-44 {\n    margin-right: 11rem;\n  }\n  .md\\:mb-44 {\n    margin-bottom: 11rem;\n  }\n  .md\\:ml-44 {\n    margin-left: 11rem;\n  }\n  .md\\:mt-48 {\n    margin-top: 12rem;\n  }\n  .md\\:mr-48 {\n    margin-right: 12rem;\n  }\n  .md\\:mb-48 {\n    margin-bottom: 12rem;\n  }\n  .md\\:ml-48 {\n    margin-left: 12rem;\n  }\n  .md\\:mt-52 {\n    margin-top: 13rem;\n  }\n  .md\\:mr-52 {\n    margin-right: 13rem;\n  }\n  .md\\:mb-52 {\n    margin-bottom: 13rem;\n  }\n  .md\\:ml-52 {\n    margin-left: 13rem;\n  }\n  .md\\:mt-56 {\n    margin-top: 14rem;\n  }\n  .md\\:mr-56 {\n    margin-right: 14rem;\n  }\n  .md\\:mb-56 {\n    margin-bottom: 14rem;\n  }\n  .md\\:ml-56 {\n    margin-left: 14rem;\n  }\n  .md\\:mt-60 {\n    margin-top: 15rem;\n  }\n  .md\\:mr-60 {\n    margin-right: 15rem;\n  }\n  .md\\:mb-60 {\n    margin-bottom: 15rem;\n  }\n  .md\\:ml-60 {\n    margin-left: 15rem;\n  }\n  .md\\:mt-64 {\n    margin-top: 16rem;\n  }\n  .md\\:mr-64 {\n    margin-right: 16rem;\n  }\n  .md\\:mb-64 {\n    margin-bottom: 16rem;\n  }\n  .md\\:ml-64 {\n    margin-left: 16rem;\n  }\n  .md\\:mt-72 {\n    margin-top: 18rem;\n  }\n  .md\\:mr-72 {\n    margin-right: 18rem;\n  }\n  .md\\:mb-72 {\n    margin-bottom: 18rem;\n  }\n  .md\\:ml-72 {\n    margin-left: 18rem;\n  }\n  .md\\:mt-80 {\n    margin-top: 20rem;\n  }\n  .md\\:mr-80 {\n    margin-right: 20rem;\n  }\n  .md\\:mb-80 {\n    margin-bottom: 20rem;\n  }\n  .md\\:ml-80 {\n    margin-left: 20rem;\n  }\n  .md\\:mt-96 {\n    margin-top: 24rem;\n  }\n  .md\\:mr-96 {\n    margin-right: 24rem;\n  }\n  .md\\:mb-96 {\n    margin-bottom: 24rem;\n  }\n  .md\\:ml-96 {\n    margin-left: 24rem;\n  }\n  .md\\:mt-auto {\n    margin-top: auto;\n  }\n  .md\\:mr-auto {\n    margin-right: auto;\n  }\n  .md\\:mb-auto {\n    margin-bottom: auto;\n  }\n  .md\\:ml-auto {\n    margin-left: auto;\n  }\n  .md\\:mt-px {\n    margin-top: 1px;\n  }\n  .md\\:mr-px {\n    margin-right: 1px;\n  }\n  .md\\:mb-px {\n    margin-bottom: 1px;\n  }\n  .md\\:ml-px {\n    margin-left: 1px;\n  }\n  .md\\:mt-0\\.5 {\n    margin-top: 0.125rem;\n  }\n  .md\\:mr-0\\.5 {\n    margin-right: 0.125rem;\n  }\n  .md\\:mb-0\\.5 {\n    margin-bottom: 0.125rem;\n  }\n  .md\\:ml-0\\.5 {\n    margin-left: 0.125rem;\n  }\n  .md\\:mt-1\\.5 {\n    margin-top: 0.375rem;\n  }\n  .md\\:mr-1\\.5 {\n    margin-right: 0.375rem;\n  }\n  .md\\:mb-1\\.5 {\n    margin-bottom: 0.375rem;\n  }\n  .md\\:ml-1\\.5 {\n    margin-left: 0.375rem;\n  }\n  .md\\:mt-2\\.5 {\n    margin-top: 0.625rem;\n  }\n  .md\\:mr-2\\.5 {\n    margin-right: 0.625rem;\n  }\n  .md\\:mb-2\\.5 {\n    margin-bottom: 0.625rem;\n  }\n  .md\\:ml-2\\.5 {\n    margin-left: 0.625rem;\n  }\n  .md\\:mt-3\\.5 {\n    margin-top: 0.875rem;\n  }\n  .md\\:mr-3\\.5 {\n    margin-right: 0.875rem;\n  }\n  .md\\:mb-3\\.5 {\n    margin-bottom: 0.875rem;\n  }\n  .md\\:ml-3\\.5 {\n    margin-left: 0.875rem;\n  }\n  .md\\:mt-1\\/2 {\n    margin-top: 50%;\n  }\n  .md\\:mr-1\\/2 {\n    margin-right: 50%;\n  }\n  .md\\:mb-1\\/2 {\n    margin-bottom: 50%;\n  }\n  .md\\:ml-1\\/2 {\n    margin-left: 50%;\n  }\n  .md\\:mt-1\\/3 {\n    margin-top: 33.333333%;\n  }\n  .md\\:mr-1\\/3 {\n    margin-right: 33.333333%;\n  }\n  .md\\:mb-1\\/3 {\n    margin-bottom: 33.333333%;\n  }\n  .md\\:ml-1\\/3 {\n    margin-left: 33.333333%;\n  }\n  .md\\:mt-2\\/3 {\n    margin-top: 66.666667%;\n  }\n  .md\\:mr-2\\/3 {\n    margin-right: 66.666667%;\n  }\n  .md\\:mb-2\\/3 {\n    margin-bottom: 66.666667%;\n  }\n  .md\\:ml-2\\/3 {\n    margin-left: 66.666667%;\n  }\n  .md\\:mt-1\\/4 {\n    margin-top: 25%;\n  }\n  .md\\:mr-1\\/4 {\n    margin-right: 25%;\n  }\n  .md\\:mb-1\\/4 {\n    margin-bottom: 25%;\n  }\n  .md\\:ml-1\\/4 {\n    margin-left: 25%;\n  }\n  .md\\:mt-2\\/4 {\n    margin-top: 50%;\n  }\n  .md\\:mr-2\\/4 {\n    margin-right: 50%;\n  }\n  .md\\:mb-2\\/4 {\n    margin-bottom: 50%;\n  }\n  .md\\:ml-2\\/4 {\n    margin-left: 50%;\n  }\n  .md\\:mt-3\\/4 {\n    margin-top: 75%;\n  }\n  .md\\:mr-3\\/4 {\n    margin-right: 75%;\n  }\n  .md\\:mb-3\\/4 {\n    margin-bottom: 75%;\n  }\n  .md\\:ml-3\\/4 {\n    margin-left: 75%;\n  }\n  .md\\:mt-1\\/5 {\n    margin-top: 20%;\n  }\n  .md\\:mr-1\\/5 {\n    margin-right: 20%;\n  }\n  .md\\:mb-1\\/5 {\n    margin-bottom: 20%;\n  }\n  .md\\:ml-1\\/5 {\n    margin-left: 20%;\n  }\n  .md\\:mt-2\\/5 {\n    margin-top: 40%;\n  }\n  .md\\:mr-2\\/5 {\n    margin-right: 40%;\n  }\n  .md\\:mb-2\\/5 {\n    margin-bottom: 40%;\n  }\n  .md\\:ml-2\\/5 {\n    margin-left: 40%;\n  }\n  .md\\:mt-3\\/5 {\n    margin-top: 60%;\n  }\n  .md\\:mr-3\\/5 {\n    margin-right: 60%;\n  }\n  .md\\:mb-3\\/5 {\n    margin-bottom: 60%;\n  }\n  .md\\:ml-3\\/5 {\n    margin-left: 60%;\n  }\n  .md\\:mt-4\\/5 {\n    margin-top: 80%;\n  }\n  .md\\:mr-4\\/5 {\n    margin-right: 80%;\n  }\n  .md\\:mb-4\\/5 {\n    margin-bottom: 80%;\n  }\n  .md\\:ml-4\\/5 {\n    margin-left: 80%;\n  }\n  .md\\:mt-1\\/6 {\n    margin-top: 16.666667%;\n  }\n  .md\\:mr-1\\/6 {\n    margin-right: 16.666667%;\n  }\n  .md\\:mb-1\\/6 {\n    margin-bottom: 16.666667%;\n  }\n  .md\\:ml-1\\/6 {\n    margin-left: 16.666667%;\n  }\n  .md\\:mt-2\\/6 {\n    margin-top: 33.333333%;\n  }\n  .md\\:mr-2\\/6 {\n    margin-right: 33.333333%;\n  }\n  .md\\:mb-2\\/6 {\n    margin-bottom: 33.333333%;\n  }\n  .md\\:ml-2\\/6 {\n    margin-left: 33.333333%;\n  }\n  .md\\:mt-3\\/6 {\n    margin-top: 50%;\n  }\n  .md\\:mr-3\\/6 {\n    margin-right: 50%;\n  }\n  .md\\:mb-3\\/6 {\n    margin-bottom: 50%;\n  }\n  .md\\:ml-3\\/6 {\n    margin-left: 50%;\n  }\n  .md\\:mt-4\\/6 {\n    margin-top: 66.666667%;\n  }\n  .md\\:mr-4\\/6 {\n    margin-right: 66.666667%;\n  }\n  .md\\:mb-4\\/6 {\n    margin-bottom: 66.666667%;\n  }\n  .md\\:ml-4\\/6 {\n    margin-left: 66.666667%;\n  }\n  .md\\:mt-5\\/6 {\n    margin-top: 83.333333%;\n  }\n  .md\\:mr-5\\/6 {\n    margin-right: 83.333333%;\n  }\n  .md\\:mb-5\\/6 {\n    margin-bottom: 83.333333%;\n  }\n  .md\\:ml-5\\/6 {\n    margin-left: 83.333333%;\n  }\n  .md\\:mt-1\\/12 {\n    margin-top: 8.333333%;\n  }\n  .md\\:mr-1\\/12 {\n    margin-right: 8.333333%;\n  }\n  .md\\:mb-1\\/12 {\n    margin-bottom: 8.333333%;\n  }\n  .md\\:ml-1\\/12 {\n    margin-left: 8.333333%;\n  }\n  .md\\:mt-2\\/12 {\n    margin-top: 16.666667%;\n  }\n  .md\\:mr-2\\/12 {\n    margin-right: 16.666667%;\n  }\n  .md\\:mb-2\\/12 {\n    margin-bottom: 16.666667%;\n  }\n  .md\\:ml-2\\/12 {\n    margin-left: 16.666667%;\n  }\n  .md\\:mt-3\\/12 {\n    margin-top: 25%;\n  }\n  .md\\:mr-3\\/12 {\n    margin-right: 25%;\n  }\n  .md\\:mb-3\\/12 {\n    margin-bottom: 25%;\n  }\n  .md\\:ml-3\\/12 {\n    margin-left: 25%;\n  }\n  .md\\:mt-4\\/12 {\n    margin-top: 33.333333%;\n  }\n  .md\\:mr-4\\/12 {\n    margin-right: 33.333333%;\n  }\n  .md\\:mb-4\\/12 {\n    margin-bottom: 33.333333%;\n  }\n  .md\\:ml-4\\/12 {\n    margin-left: 33.333333%;\n  }\n  .md\\:mt-5\\/12 {\n    margin-top: 41.666667%;\n  }\n  .md\\:mr-5\\/12 {\n    margin-right: 41.666667%;\n  }\n  .md\\:mb-5\\/12 {\n    margin-bottom: 41.666667%;\n  }\n  .md\\:ml-5\\/12 {\n    margin-left: 41.666667%;\n  }\n  .md\\:mt-6\\/12 {\n    margin-top: 50%;\n  }\n  .md\\:mr-6\\/12 {\n    margin-right: 50%;\n  }\n  .md\\:mb-6\\/12 {\n    margin-bottom: 50%;\n  }\n  .md\\:ml-6\\/12 {\n    margin-left: 50%;\n  }\n  .md\\:mt-7\\/12 {\n    margin-top: 58.333333%;\n  }\n  .md\\:mr-7\\/12 {\n    margin-right: 58.333333%;\n  }\n  .md\\:mb-7\\/12 {\n    margin-bottom: 58.333333%;\n  }\n  .md\\:ml-7\\/12 {\n    margin-left: 58.333333%;\n  }\n  .md\\:mt-8\\/12 {\n    margin-top: 66.666667%;\n  }\n  .md\\:mr-8\\/12 {\n    margin-right: 66.666667%;\n  }\n  .md\\:mb-8\\/12 {\n    margin-bottom: 66.666667%;\n  }\n  .md\\:ml-8\\/12 {\n    margin-left: 66.666667%;\n  }\n  .md\\:mt-9\\/12 {\n    margin-top: 75%;\n  }\n  .md\\:mr-9\\/12 {\n    margin-right: 75%;\n  }\n  .md\\:mb-9\\/12 {\n    margin-bottom: 75%;\n  }\n  .md\\:ml-9\\/12 {\n    margin-left: 75%;\n  }\n  .md\\:mt-10\\/12 {\n    margin-top: 83.333333%;\n  }\n  .md\\:mr-10\\/12 {\n    margin-right: 83.333333%;\n  }\n  .md\\:mb-10\\/12 {\n    margin-bottom: 83.333333%;\n  }\n  .md\\:ml-10\\/12 {\n    margin-left: 83.333333%;\n  }\n  .md\\:mt-11\\/12 {\n    margin-top: 91.666667%;\n  }\n  .md\\:mr-11\\/12 {\n    margin-right: 91.666667%;\n  }\n  .md\\:mb-11\\/12 {\n    margin-bottom: 91.666667%;\n  }\n  .md\\:ml-11\\/12 {\n    margin-left: 91.666667%;\n  }\n  .md\\:mt-full {\n    margin-top: 100%;\n  }\n  .md\\:mr-full {\n    margin-right: 100%;\n  }\n  .md\\:mb-full {\n    margin-bottom: 100%;\n  }\n  .md\\:ml-full {\n    margin-left: 100%;\n  }\n  .md\\:-mt-1 {\n    margin-top: -0.25rem;\n  }\n  .md\\:-mr-1 {\n    margin-right: -0.25rem;\n  }\n  .md\\:-mb-1 {\n    margin-bottom: -0.25rem;\n  }\n  .md\\:-ml-1 {\n    margin-left: -0.25rem;\n  }\n  .md\\:-mt-2 {\n    margin-top: -0.5rem;\n  }\n  .md\\:-mr-2 {\n    margin-right: -0.5rem;\n  }\n  .md\\:-mb-2 {\n    margin-bottom: -0.5rem;\n  }\n  .md\\:-ml-2 {\n    margin-left: -0.5rem;\n  }\n  .md\\:-mt-3 {\n    margin-top: -0.75rem;\n  }\n  .md\\:-mr-3 {\n    margin-right: -0.75rem;\n  }\n  .md\\:-mb-3 {\n    margin-bottom: -0.75rem;\n  }\n  .md\\:-ml-3 {\n    margin-left: -0.75rem;\n  }\n  .md\\:-mt-4 {\n    margin-top: -1rem;\n  }\n  .md\\:-mr-4 {\n    margin-right: -1rem;\n  }\n  .md\\:-mb-4 {\n    margin-bottom: -1rem;\n  }\n  .md\\:-ml-4 {\n    margin-left: -1rem;\n  }\n  .md\\:-mt-5 {\n    margin-top: -1.25rem;\n  }\n  .md\\:-mr-5 {\n    margin-right: -1.25rem;\n  }\n  .md\\:-mb-5 {\n    margin-bottom: -1.25rem;\n  }\n  .md\\:-ml-5 {\n    margin-left: -1.25rem;\n  }\n  .md\\:-mt-6 {\n    margin-top: -1.5rem;\n  }\n  .md\\:-mr-6 {\n    margin-right: -1.5rem;\n  }\n  .md\\:-mb-6 {\n    margin-bottom: -1.5rem;\n  }\n  .md\\:-ml-6 {\n    margin-left: -1.5rem;\n  }\n  .md\\:-mt-7 {\n    margin-top: -1.75rem;\n  }\n  .md\\:-mr-7 {\n    margin-right: -1.75rem;\n  }\n  .md\\:-mb-7 {\n    margin-bottom: -1.75rem;\n  }\n  .md\\:-ml-7 {\n    margin-left: -1.75rem;\n  }\n  .md\\:-mt-8 {\n    margin-top: -2rem;\n  }\n  .md\\:-mr-8 {\n    margin-right: -2rem;\n  }\n  .md\\:-mb-8 {\n    margin-bottom: -2rem;\n  }\n  .md\\:-ml-8 {\n    margin-left: -2rem;\n  }\n  .md\\:-mt-9 {\n    margin-top: -2.25rem;\n  }\n  .md\\:-mr-9 {\n    margin-right: -2.25rem;\n  }\n  .md\\:-mb-9 {\n    margin-bottom: -2.25rem;\n  }\n  .md\\:-ml-9 {\n    margin-left: -2.25rem;\n  }\n  .md\\:-mt-10 {\n    margin-top: -2.5rem;\n  }\n  .md\\:-mr-10 {\n    margin-right: -2.5rem;\n  }\n  .md\\:-mb-10 {\n    margin-bottom: -2.5rem;\n  }\n  .md\\:-ml-10 {\n    margin-left: -2.5rem;\n  }\n  .md\\:-mt-11 {\n    margin-top: -2.75rem;\n  }\n  .md\\:-mr-11 {\n    margin-right: -2.75rem;\n  }\n  .md\\:-mb-11 {\n    margin-bottom: -2.75rem;\n  }\n  .md\\:-ml-11 {\n    margin-left: -2.75rem;\n  }\n  .md\\:-mt-12 {\n    margin-top: -3rem;\n  }\n  .md\\:-mr-12 {\n    margin-right: -3rem;\n  }\n  .md\\:-mb-12 {\n    margin-bottom: -3rem;\n  }\n  .md\\:-ml-12 {\n    margin-left: -3rem;\n  }\n  .md\\:-mt-13 {\n    margin-top: -3.25rem;\n  }\n  .md\\:-mr-13 {\n    margin-right: -3.25rem;\n  }\n  .md\\:-mb-13 {\n    margin-bottom: -3.25rem;\n  }\n  .md\\:-ml-13 {\n    margin-left: -3.25rem;\n  }\n  .md\\:-mt-14 {\n    margin-top: -3.5rem;\n  }\n  .md\\:-mr-14 {\n    margin-right: -3.5rem;\n  }\n  .md\\:-mb-14 {\n    margin-bottom: -3.5rem;\n  }\n  .md\\:-ml-14 {\n    margin-left: -3.5rem;\n  }\n  .md\\:-mt-15 {\n    margin-top: -3.75rem;\n  }\n  .md\\:-mr-15 {\n    margin-right: -3.75rem;\n  }\n  .md\\:-mb-15 {\n    margin-bottom: -3.75rem;\n  }\n  .md\\:-ml-15 {\n    margin-left: -3.75rem;\n  }\n  .md\\:-mt-16 {\n    margin-top: -4rem;\n  }\n  .md\\:-mr-16 {\n    margin-right: -4rem;\n  }\n  .md\\:-mb-16 {\n    margin-bottom: -4rem;\n  }\n  .md\\:-ml-16 {\n    margin-left: -4rem;\n  }\n  .md\\:-mt-20 {\n    margin-top: -5rem;\n  }\n  .md\\:-mr-20 {\n    margin-right: -5rem;\n  }\n  .md\\:-mb-20 {\n    margin-bottom: -5rem;\n  }\n  .md\\:-ml-20 {\n    margin-left: -5rem;\n  }\n  .md\\:-mt-24 {\n    margin-top: -6rem;\n  }\n  .md\\:-mr-24 {\n    margin-right: -6rem;\n  }\n  .md\\:-mb-24 {\n    margin-bottom: -6rem;\n  }\n  .md\\:-ml-24 {\n    margin-left: -6rem;\n  }\n  .md\\:-mt-28 {\n    margin-top: -7rem;\n  }\n  .md\\:-mr-28 {\n    margin-right: -7rem;\n  }\n  .md\\:-mb-28 {\n    margin-bottom: -7rem;\n  }\n  .md\\:-ml-28 {\n    margin-left: -7rem;\n  }\n  .md\\:-mt-32 {\n    margin-top: -8rem;\n  }\n  .md\\:-mr-32 {\n    margin-right: -8rem;\n  }\n  .md\\:-mb-32 {\n    margin-bottom: -8rem;\n  }\n  .md\\:-ml-32 {\n    margin-left: -8rem;\n  }\n  .md\\:-mt-36 {\n    margin-top: -9rem;\n  }\n  .md\\:-mr-36 {\n    margin-right: -9rem;\n  }\n  .md\\:-mb-36 {\n    margin-bottom: -9rem;\n  }\n  .md\\:-ml-36 {\n    margin-left: -9rem;\n  }\n  .md\\:-mt-40 {\n    margin-top: -10rem;\n  }\n  .md\\:-mr-40 {\n    margin-right: -10rem;\n  }\n  .md\\:-mb-40 {\n    margin-bottom: -10rem;\n  }\n  .md\\:-ml-40 {\n    margin-left: -10rem;\n  }\n  .md\\:-mt-44 {\n    margin-top: -11rem;\n  }\n  .md\\:-mr-44 {\n    margin-right: -11rem;\n  }\n  .md\\:-mb-44 {\n    margin-bottom: -11rem;\n  }\n  .md\\:-ml-44 {\n    margin-left: -11rem;\n  }\n  .md\\:-mt-48 {\n    margin-top: -12rem;\n  }\n  .md\\:-mr-48 {\n    margin-right: -12rem;\n  }\n  .md\\:-mb-48 {\n    margin-bottom: -12rem;\n  }\n  .md\\:-ml-48 {\n    margin-left: -12rem;\n  }\n  .md\\:-mt-52 {\n    margin-top: -13rem;\n  }\n  .md\\:-mr-52 {\n    margin-right: -13rem;\n  }\n  .md\\:-mb-52 {\n    margin-bottom: -13rem;\n  }\n  .md\\:-ml-52 {\n    margin-left: -13rem;\n  }\n  .md\\:-mt-56 {\n    margin-top: -14rem;\n  }\n  .md\\:-mr-56 {\n    margin-right: -14rem;\n  }\n  .md\\:-mb-56 {\n    margin-bottom: -14rem;\n  }\n  .md\\:-ml-56 {\n    margin-left: -14rem;\n  }\n  .md\\:-mt-60 {\n    margin-top: -15rem;\n  }\n  .md\\:-mr-60 {\n    margin-right: -15rem;\n  }\n  .md\\:-mb-60 {\n    margin-bottom: -15rem;\n  }\n  .md\\:-ml-60 {\n    margin-left: -15rem;\n  }\n  .md\\:-mt-64 {\n    margin-top: -16rem;\n  }\n  .md\\:-mr-64 {\n    margin-right: -16rem;\n  }\n  .md\\:-mb-64 {\n    margin-bottom: -16rem;\n  }\n  .md\\:-ml-64 {\n    margin-left: -16rem;\n  }\n  .md\\:-mt-72 {\n    margin-top: -18rem;\n  }\n  .md\\:-mr-72 {\n    margin-right: -18rem;\n  }\n  .md\\:-mb-72 {\n    margin-bottom: -18rem;\n  }\n  .md\\:-ml-72 {\n    margin-left: -18rem;\n  }\n  .md\\:-mt-80 {\n    margin-top: -20rem;\n  }\n  .md\\:-mr-80 {\n    margin-right: -20rem;\n  }\n  .md\\:-mb-80 {\n    margin-bottom: -20rem;\n  }\n  .md\\:-ml-80 {\n    margin-left: -20rem;\n  }\n  .md\\:-mt-96 {\n    margin-top: -24rem;\n  }\n  .md\\:-mr-96 {\n    margin-right: -24rem;\n  }\n  .md\\:-mb-96 {\n    margin-bottom: -24rem;\n  }\n  .md\\:-ml-96 {\n    margin-left: -24rem;\n  }\n  .md\\:-mt-px {\n    margin-top: -1px;\n  }\n  .md\\:-mr-px {\n    margin-right: -1px;\n  }\n  .md\\:-mb-px {\n    margin-bottom: -1px;\n  }\n  .md\\:-ml-px {\n    margin-left: -1px;\n  }\n  .md\\:-mt-0\\.5 {\n    margin-top: -0.125rem;\n  }\n  .md\\:-mr-0\\.5 {\n    margin-right: -0.125rem;\n  }\n  .md\\:-mb-0\\.5 {\n    margin-bottom: -0.125rem;\n  }\n  .md\\:-ml-0\\.5 {\n    margin-left: -0.125rem;\n  }\n  .md\\:-mt-1\\.5 {\n    margin-top: -0.375rem;\n  }\n  .md\\:-mr-1\\.5 {\n    margin-right: -0.375rem;\n  }\n  .md\\:-mb-1\\.5 {\n    margin-bottom: -0.375rem;\n  }\n  .md\\:-ml-1\\.5 {\n    margin-left: -0.375rem;\n  }\n  .md\\:-mt-2\\.5 {\n    margin-top: -0.625rem;\n  }\n  .md\\:-mr-2\\.5 {\n    margin-right: -0.625rem;\n  }\n  .md\\:-mb-2\\.5 {\n    margin-bottom: -0.625rem;\n  }\n  .md\\:-ml-2\\.5 {\n    margin-left: -0.625rem;\n  }\n  .md\\:-mt-3\\.5 {\n    margin-top: -0.875rem;\n  }\n  .md\\:-mr-3\\.5 {\n    margin-right: -0.875rem;\n  }\n  .md\\:-mb-3\\.5 {\n    margin-bottom: -0.875rem;\n  }\n  .md\\:-ml-3\\.5 {\n    margin-left: -0.875rem;\n  }\n  .md\\:-mt-1\\/2 {\n    margin-top: -50%;\n  }\n  .md\\:-mr-1\\/2 {\n    margin-right: -50%;\n  }\n  .md\\:-mb-1\\/2 {\n    margin-bottom: -50%;\n  }\n  .md\\:-ml-1\\/2 {\n    margin-left: -50%;\n  }\n  .md\\:-mt-1\\/3 {\n    margin-top: -33.33333%;\n  }\n  .md\\:-mr-1\\/3 {\n    margin-right: -33.33333%;\n  }\n  .md\\:-mb-1\\/3 {\n    margin-bottom: -33.33333%;\n  }\n  .md\\:-ml-1\\/3 {\n    margin-left: -33.33333%;\n  }\n  .md\\:-mt-2\\/3 {\n    margin-top: -66.66667%;\n  }\n  .md\\:-mr-2\\/3 {\n    margin-right: -66.66667%;\n  }\n  .md\\:-mb-2\\/3 {\n    margin-bottom: -66.66667%;\n  }\n  .md\\:-ml-2\\/3 {\n    margin-left: -66.66667%;\n  }\n  .md\\:-mt-1\\/4 {\n    margin-top: -25%;\n  }\n  .md\\:-mr-1\\/4 {\n    margin-right: -25%;\n  }\n  .md\\:-mb-1\\/4 {\n    margin-bottom: -25%;\n  }\n  .md\\:-ml-1\\/4 {\n    margin-left: -25%;\n  }\n  .md\\:-mt-2\\/4 {\n    margin-top: -50%;\n  }\n  .md\\:-mr-2\\/4 {\n    margin-right: -50%;\n  }\n  .md\\:-mb-2\\/4 {\n    margin-bottom: -50%;\n  }\n  .md\\:-ml-2\\/4 {\n    margin-left: -50%;\n  }\n  .md\\:-mt-3\\/4 {\n    margin-top: -75%;\n  }\n  .md\\:-mr-3\\/4 {\n    margin-right: -75%;\n  }\n  .md\\:-mb-3\\/4 {\n    margin-bottom: -75%;\n  }\n  .md\\:-ml-3\\/4 {\n    margin-left: -75%;\n  }\n  .md\\:-mt-1\\/5 {\n    margin-top: -20%;\n  }\n  .md\\:-mr-1\\/5 {\n    margin-right: -20%;\n  }\n  .md\\:-mb-1\\/5 {\n    margin-bottom: -20%;\n  }\n  .md\\:-ml-1\\/5 {\n    margin-left: -20%;\n  }\n  .md\\:-mt-2\\/5 {\n    margin-top: -40%;\n  }\n  .md\\:-mr-2\\/5 {\n    margin-right: -40%;\n  }\n  .md\\:-mb-2\\/5 {\n    margin-bottom: -40%;\n  }\n  .md\\:-ml-2\\/5 {\n    margin-left: -40%;\n  }\n  .md\\:-mt-3\\/5 {\n    margin-top: -60%;\n  }\n  .md\\:-mr-3\\/5 {\n    margin-right: -60%;\n  }\n  .md\\:-mb-3\\/5 {\n    margin-bottom: -60%;\n  }\n  .md\\:-ml-3\\/5 {\n    margin-left: -60%;\n  }\n  .md\\:-mt-4\\/5 {\n    margin-top: -80%;\n  }\n  .md\\:-mr-4\\/5 {\n    margin-right: -80%;\n  }\n  .md\\:-mb-4\\/5 {\n    margin-bottom: -80%;\n  }\n  .md\\:-ml-4\\/5 {\n    margin-left: -80%;\n  }\n  .md\\:-mt-1\\/6 {\n    margin-top: -16.66667%;\n  }\n  .md\\:-mr-1\\/6 {\n    margin-right: -16.66667%;\n  }\n  .md\\:-mb-1\\/6 {\n    margin-bottom: -16.66667%;\n  }\n  .md\\:-ml-1\\/6 {\n    margin-left: -16.66667%;\n  }\n  .md\\:-mt-2\\/6 {\n    margin-top: -33.33333%;\n  }\n  .md\\:-mr-2\\/6 {\n    margin-right: -33.33333%;\n  }\n  .md\\:-mb-2\\/6 {\n    margin-bottom: -33.33333%;\n  }\n  .md\\:-ml-2\\/6 {\n    margin-left: -33.33333%;\n  }\n  .md\\:-mt-3\\/6 {\n    margin-top: -50%;\n  }\n  .md\\:-mr-3\\/6 {\n    margin-right: -50%;\n  }\n  .md\\:-mb-3\\/6 {\n    margin-bottom: -50%;\n  }\n  .md\\:-ml-3\\/6 {\n    margin-left: -50%;\n  }\n  .md\\:-mt-4\\/6 {\n    margin-top: -66.66667%;\n  }\n  .md\\:-mr-4\\/6 {\n    margin-right: -66.66667%;\n  }\n  .md\\:-mb-4\\/6 {\n    margin-bottom: -66.66667%;\n  }\n  .md\\:-ml-4\\/6 {\n    margin-left: -66.66667%;\n  }\n  .md\\:-mt-5\\/6 {\n    margin-top: -83.33333%;\n  }\n  .md\\:-mr-5\\/6 {\n    margin-right: -83.33333%;\n  }\n  .md\\:-mb-5\\/6 {\n    margin-bottom: -83.33333%;\n  }\n  .md\\:-ml-5\\/6 {\n    margin-left: -83.33333%;\n  }\n  .md\\:-mt-1\\/12 {\n    margin-top: -8.33333%;\n  }\n  .md\\:-mr-1\\/12 {\n    margin-right: -8.33333%;\n  }\n  .md\\:-mb-1\\/12 {\n    margin-bottom: -8.33333%;\n  }\n  .md\\:-ml-1\\/12 {\n    margin-left: -8.33333%;\n  }\n  .md\\:-mt-2\\/12 {\n    margin-top: -16.66667%;\n  }\n  .md\\:-mr-2\\/12 {\n    margin-right: -16.66667%;\n  }\n  .md\\:-mb-2\\/12 {\n    margin-bottom: -16.66667%;\n  }\n  .md\\:-ml-2\\/12 {\n    margin-left: -16.66667%;\n  }\n  .md\\:-mt-3\\/12 {\n    margin-top: -25%;\n  }\n  .md\\:-mr-3\\/12 {\n    margin-right: -25%;\n  }\n  .md\\:-mb-3\\/12 {\n    margin-bottom: -25%;\n  }\n  .md\\:-ml-3\\/12 {\n    margin-left: -25%;\n  }\n  .md\\:-mt-4\\/12 {\n    margin-top: -33.33333%;\n  }\n  .md\\:-mr-4\\/12 {\n    margin-right: -33.33333%;\n  }\n  .md\\:-mb-4\\/12 {\n    margin-bottom: -33.33333%;\n  }\n  .md\\:-ml-4\\/12 {\n    margin-left: -33.33333%;\n  }\n  .md\\:-mt-5\\/12 {\n    margin-top: -41.66667%;\n  }\n  .md\\:-mr-5\\/12 {\n    margin-right: -41.66667%;\n  }\n  .md\\:-mb-5\\/12 {\n    margin-bottom: -41.66667%;\n  }\n  .md\\:-ml-5\\/12 {\n    margin-left: -41.66667%;\n  }\n  .md\\:-mt-6\\/12 {\n    margin-top: -50%;\n  }\n  .md\\:-mr-6\\/12 {\n    margin-right: -50%;\n  }\n  .md\\:-mb-6\\/12 {\n    margin-bottom: -50%;\n  }\n  .md\\:-ml-6\\/12 {\n    margin-left: -50%;\n  }\n  .md\\:-mt-7\\/12 {\n    margin-top: -58.33333%;\n  }\n  .md\\:-mr-7\\/12 {\n    margin-right: -58.33333%;\n  }\n  .md\\:-mb-7\\/12 {\n    margin-bottom: -58.33333%;\n  }\n  .md\\:-ml-7\\/12 {\n    margin-left: -58.33333%;\n  }\n  .md\\:-mt-8\\/12 {\n    margin-top: -66.66667%;\n  }\n  .md\\:-mr-8\\/12 {\n    margin-right: -66.66667%;\n  }\n  .md\\:-mb-8\\/12 {\n    margin-bottom: -66.66667%;\n  }\n  .md\\:-ml-8\\/12 {\n    margin-left: -66.66667%;\n  }\n  .md\\:-mt-9\\/12 {\n    margin-top: -75%;\n  }\n  .md\\:-mr-9\\/12 {\n    margin-right: -75%;\n  }\n  .md\\:-mb-9\\/12 {\n    margin-bottom: -75%;\n  }\n  .md\\:-ml-9\\/12 {\n    margin-left: -75%;\n  }\n  .md\\:-mt-10\\/12 {\n    margin-top: -83.33333%;\n  }\n  .md\\:-mr-10\\/12 {\n    margin-right: -83.33333%;\n  }\n  .md\\:-mb-10\\/12 {\n    margin-bottom: -83.33333%;\n  }\n  .md\\:-ml-10\\/12 {\n    margin-left: -83.33333%;\n  }\n  .md\\:-mt-11\\/12 {\n    margin-top: -91.66667%;\n  }\n  .md\\:-mr-11\\/12 {\n    margin-right: -91.66667%;\n  }\n  .md\\:-mb-11\\/12 {\n    margin-bottom: -91.66667%;\n  }\n  .md\\:-ml-11\\/12 {\n    margin-left: -91.66667%;\n  }\n  .md\\:-mt-full {\n    margin-top: -100%;\n  }\n  .md\\:-mr-full {\n    margin-right: -100%;\n  }\n  .md\\:-mb-full {\n    margin-bottom: -100%;\n  }\n  .md\\:-ml-full {\n    margin-left: -100%;\n  }\n  .md\\:max-h-0 {\n    max-height: 0;\n  }\n  .md\\:max-h-1 {\n    max-height: 0.25rem;\n  }\n  .md\\:max-h-2 {\n    max-height: 0.5rem;\n  }\n  .md\\:max-h-3 {\n    max-height: 0.75rem;\n  }\n  .md\\:max-h-4 {\n    max-height: 1rem;\n  }\n  .md\\:max-h-5 {\n    max-height: 1.25rem;\n  }\n  .md\\:max-h-6 {\n    max-height: 1.5rem;\n  }\n  .md\\:max-h-7 {\n    max-height: 1.75rem;\n  }\n  .md\\:max-h-8 {\n    max-height: 2rem;\n  }\n  .md\\:max-h-9 {\n    max-height: 2.25rem;\n  }\n  .md\\:max-h-10 {\n    max-height: 2.5rem;\n  }\n  .md\\:max-h-11 {\n    max-height: 2.75rem;\n  }\n  .md\\:max-h-12 {\n    max-height: 3rem;\n  }\n  .md\\:max-h-13 {\n    max-height: 3.25rem;\n  }\n  .md\\:max-h-14 {\n    max-height: 3.5rem;\n  }\n  .md\\:max-h-15 {\n    max-height: 3.75rem;\n  }\n  .md\\:max-h-16 {\n    max-height: 4rem;\n  }\n  .md\\:max-h-20 {\n    max-height: 5rem;\n  }\n  .md\\:max-h-24 {\n    max-height: 6rem;\n  }\n  .md\\:max-h-28 {\n    max-height: 7rem;\n  }\n  .md\\:max-h-32 {\n    max-height: 8rem;\n  }\n  .md\\:max-h-36 {\n    max-height: 9rem;\n  }\n  .md\\:max-h-40 {\n    max-height: 10rem;\n  }\n  .md\\:max-h-44 {\n    max-height: 11rem;\n  }\n  .md\\:max-h-48 {\n    max-height: 12rem;\n  }\n  .md\\:max-h-52 {\n    max-height: 13rem;\n  }\n  .md\\:max-h-56 {\n    max-height: 14rem;\n  }\n  .md\\:max-h-60 {\n    max-height: 15rem;\n  }\n  .md\\:max-h-64 {\n    max-height: 16rem;\n  }\n  .md\\:max-h-72 {\n    max-height: 18rem;\n  }\n  .md\\:max-h-80 {\n    max-height: 20rem;\n  }\n  .md\\:max-h-96 {\n    max-height: 24rem;\n  }\n  .md\\:max-h-screen {\n    max-height: 100vh;\n  }\n  .md\\:max-h-px {\n    max-height: 1px;\n  }\n  .md\\:max-h-0\\.5 {\n    max-height: 0.125rem;\n  }\n  .md\\:max-h-1\\.5 {\n    max-height: 0.375rem;\n  }\n  .md\\:max-h-2\\.5 {\n    max-height: 0.625rem;\n  }\n  .md\\:max-h-3\\.5 {\n    max-height: 0.875rem;\n  }\n  .md\\:max-h-1\\/2 {\n    max-height: 50%;\n  }\n  .md\\:max-h-1\\/3 {\n    max-height: 33.333333%;\n  }\n  .md\\:max-h-2\\/3 {\n    max-height: 66.666667%;\n  }\n  .md\\:max-h-1\\/4 {\n    max-height: 25%;\n  }\n  .md\\:max-h-2\\/4 {\n    max-height: 50%;\n  }\n  .md\\:max-h-3\\/4 {\n    max-height: 75%;\n  }\n  .md\\:max-h-1\\/5 {\n    max-height: 20%;\n  }\n  .md\\:max-h-2\\/5 {\n    max-height: 40%;\n  }\n  .md\\:max-h-3\\/5 {\n    max-height: 60%;\n  }\n  .md\\:max-h-4\\/5 {\n    max-height: 80%;\n  }\n  .md\\:max-h-1\\/6 {\n    max-height: 16.666667%;\n  }\n  .md\\:max-h-2\\/6 {\n    max-height: 33.333333%;\n  }\n  .md\\:max-h-3\\/6 {\n    max-height: 50%;\n  }\n  .md\\:max-h-4\\/6 {\n    max-height: 66.666667%;\n  }\n  .md\\:max-h-5\\/6 {\n    max-height: 83.333333%;\n  }\n  .md\\:max-h-1\\/12 {\n    max-height: 8.333333%;\n  }\n  .md\\:max-h-2\\/12 {\n    max-height: 16.666667%;\n  }\n  .md\\:max-h-3\\/12 {\n    max-height: 25%;\n  }\n  .md\\:max-h-4\\/12 {\n    max-height: 33.333333%;\n  }\n  .md\\:max-h-5\\/12 {\n    max-height: 41.666667%;\n  }\n  .md\\:max-h-6\\/12 {\n    max-height: 50%;\n  }\n  .md\\:max-h-7\\/12 {\n    max-height: 58.333333%;\n  }\n  .md\\:max-h-8\\/12 {\n    max-height: 66.666667%;\n  }\n  .md\\:max-h-9\\/12 {\n    max-height: 75%;\n  }\n  .md\\:max-h-10\\/12 {\n    max-height: 83.333333%;\n  }\n  .md\\:max-h-11\\/12 {\n    max-height: 91.666667%;\n  }\n  .md\\:max-h-full {\n    max-height: 100%;\n  }\n  .md\\:max-w-0 {\n    max-width: 0rem;\n  }\n  .md\\:max-w-none {\n    max-width: none;\n  }\n  .md\\:max-w-xs {\n    max-width: 20rem;\n  }\n  .md\\:max-w-sm {\n    max-width: 24rem;\n  }\n  .md\\:max-w-md {\n    max-width: 28rem;\n  }\n  .md\\:max-w-lg {\n    max-width: 32rem;\n  }\n  .md\\:max-w-xl {\n    max-width: 36rem;\n  }\n  .md\\:max-w-2xl {\n    max-width: 42rem;\n  }\n  .md\\:max-w-3xl {\n    max-width: 48rem;\n  }\n  .md\\:max-w-4xl {\n    max-width: 56rem;\n  }\n  .md\\:max-w-5xl {\n    max-width: 64rem;\n  }\n  .md\\:max-w-6xl {\n    max-width: 72rem;\n  }\n  .md\\:max-w-7xl {\n    max-width: 80rem;\n  }\n  .md\\:max-w-full {\n    max-width: 100%;\n  }\n  .md\\:max-w-min-content {\n    max-width: -moz-min-content;\n    max-width: min-content;\n  }\n  .md\\:max-w-max-content {\n    max-width: -moz-max-content;\n    max-width: max-content;\n  }\n  .md\\:max-w-prose {\n    max-width: 65ch;\n  }\n  .md\\:max-w-screen-sm {\n    max-width: 640px;\n  }\n  .md\\:max-w-screen-md {\n    max-width: 768px;\n  }\n  .md\\:max-w-screen-lg {\n    max-width: 1024px;\n  }\n  .md\\:max-w-screen-xl {\n    max-width: 1280px;\n  }\n  .md\\:min-h-0 {\n    min-height: 0;\n  }\n  .md\\:min-h-full {\n    min-height: 100%;\n  }\n  .md\\:min-h-screen {\n    min-height: 100vh;\n  }\n  .md\\:min-w-0 {\n    min-width: 0;\n  }\n  .md\\:min-w-full {\n    min-width: 100%;\n  }\n  .md\\:min-w-min-content {\n    min-width: -moz-min-content;\n    min-width: min-content;\n  }\n  .md\\:min-w-max-content {\n    min-width: -moz-max-content;\n    min-width: max-content;\n  }\n  .md\\:object-contain {\n    -o-object-fit: contain;\n    object-fit: contain;\n  }\n  .md\\:object-cover {\n    -o-object-fit: cover;\n    object-fit: cover;\n  }\n  .md\\:object-fill {\n    -o-object-fit: fill;\n    object-fit: fill;\n  }\n  .md\\:object-none {\n    -o-object-fit: none;\n    object-fit: none;\n  }\n  .md\\:object-scale-down {\n    -o-object-fit: scale-down;\n    object-fit: scale-down;\n  }\n  .md\\:object-bottom {\n    -o-object-position: bottom;\n    object-position: bottom;\n  }\n  .md\\:object-center {\n    -o-object-position: center;\n    object-position: center;\n  }\n  .md\\:object-left {\n    -o-object-position: left;\n    object-position: left;\n  }\n  .md\\:object-left-bottom {\n    -o-object-position: left bottom;\n    object-position: left bottom;\n  }\n  .md\\:object-left-top {\n    -o-object-position: left top;\n    object-position: left top;\n  }\n  .md\\:object-right {\n    -o-object-position: right;\n    object-position: right;\n  }\n  .md\\:object-right-bottom {\n    -o-object-position: right bottom;\n    object-position: right bottom;\n  }\n  .md\\:object-right-top {\n    -o-object-position: right top;\n    object-position: right top;\n  }\n  .md\\:object-top {\n    -o-object-position: top;\n    object-position: top;\n  }\n  .md\\:opacity-0 {\n    opacity: 0;\n  }\n  .md\\:opacity-25 {\n    opacity: 0.25;\n  }\n  .md\\:opacity-50 {\n    opacity: 0.5;\n  }\n  .md\\:opacity-75 {\n    opacity: 0.75;\n  }\n  .md\\:opacity-100 {\n    opacity: 1;\n  }\n  .md\\:focus-within\\:opacity-0:focus-within {\n    opacity: 0;\n  }\n  .md\\:focus-within\\:opacity-25:focus-within {\n    opacity: 0.25;\n  }\n  .md\\:focus-within\\:opacity-50:focus-within {\n    opacity: 0.5;\n  }\n  .md\\:focus-within\\:opacity-75:focus-within {\n    opacity: 0.75;\n  }\n  .md\\:focus-within\\:opacity-100:focus-within {\n    opacity: 1;\n  }\n  .group:hover .md\\:group-hover\\:opacity-0 {\n    opacity: 0;\n  }\n  .group:hover .md\\:group-hover\\:opacity-25 {\n    opacity: 0.25;\n  }\n  .group:hover .md\\:group-hover\\:opacity-50 {\n    opacity: 0.5;\n  }\n  .group:hover .md\\:group-hover\\:opacity-75 {\n    opacity: 0.75;\n  }\n  .group:hover .md\\:group-hover\\:opacity-100 {\n    opacity: 1;\n  }\n  .group:focus .md\\:group-focus\\:opacity-0 {\n    opacity: 0;\n  }\n  .group:focus .md\\:group-focus\\:opacity-25 {\n    opacity: 0.25;\n  }\n  .group:focus .md\\:group-focus\\:opacity-50 {\n    opacity: 0.5;\n  }\n  .group:focus .md\\:group-focus\\:opacity-75 {\n    opacity: 0.75;\n  }\n  .group:focus .md\\:group-focus\\:opacity-100 {\n    opacity: 1;\n  }\n  .md\\:hover\\:opacity-0:hover {\n    opacity: 0;\n  }\n  .md\\:hover\\:opacity-25:hover {\n    opacity: 0.25;\n  }\n  .md\\:hover\\:opacity-50:hover {\n    opacity: 0.5;\n  }\n  .md\\:hover\\:opacity-75:hover {\n    opacity: 0.75;\n  }\n  .md\\:hover\\:opacity-100:hover {\n    opacity: 1;\n  }\n  .md\\:focus\\:opacity-0:focus {\n    opacity: 0;\n  }\n  .md\\:focus\\:opacity-25:focus {\n    opacity: 0.25;\n  }\n  .md\\:focus\\:opacity-50:focus {\n    opacity: 0.5;\n  }\n  .md\\:focus\\:opacity-75:focus {\n    opacity: 0.75;\n  }\n  .md\\:focus\\:opacity-100:focus {\n    opacity: 1;\n  }\n  .md\\:outline-none {\n    outline: 2px solid transparent;\n    outline-offset: 2px;\n  }\n  .md\\:outline-white {\n    outline: 2px dotted white;\n    outline-offset: 2px;\n  }\n  .md\\:outline-black {\n    outline: 2px dotted black;\n    outline-offset: 2px;\n  }\n  .md\\:focus\\:outline-none:focus {\n    outline: 2px solid transparent;\n    outline-offset: 2px;\n  }\n  .md\\:focus\\:outline-white:focus {\n    outline: 2px dotted white;\n    outline-offset: 2px;\n  }\n  .md\\:focus\\:outline-black:focus {\n    outline: 2px dotted black;\n    outline-offset: 2px;\n  }\n  .md\\:overflow-auto {\n    overflow: auto;\n  }\n  .md\\:overflow-hidden {\n    overflow: hidden;\n  }\n  .md\\:overflow-visible {\n    overflow: visible;\n  }\n  .md\\:overflow-scroll {\n    overflow: scroll;\n  }\n  .md\\:overflow-x-auto {\n    overflow-x: auto;\n  }\n  .md\\:overflow-y-auto {\n    overflow-y: auto;\n  }\n  .md\\:overflow-x-hidden {\n    overflow-x: hidden;\n  }\n  .md\\:overflow-y-hidden {\n    overflow-y: hidden;\n  }\n  .md\\:overflow-x-visible {\n    overflow-x: visible;\n  }\n  .md\\:overflow-y-visible {\n    overflow-y: visible;\n  }\n  .md\\:overflow-x-scroll {\n    overflow-x: scroll;\n  }\n  .md\\:overflow-y-scroll {\n    overflow-y: scroll;\n  }\n  .md\\:scrolling-touch {\n    -webkit-overflow-scrolling: touch;\n  }\n  .md\\:scrolling-auto {\n    -webkit-overflow-scrolling: auto;\n  }\n  .md\\:overscroll-auto {\n    overscroll-behavior: auto;\n  }\n  .md\\:overscroll-contain {\n    overscroll-behavior: contain;\n  }\n  .md\\:overscroll-none {\n    overscroll-behavior: none;\n  }\n  .md\\:overscroll-y-auto {\n    overscroll-behavior-y: auto;\n  }\n  .md\\:overscroll-y-contain {\n    overscroll-behavior-y: contain;\n  }\n  .md\\:overscroll-y-none {\n    overscroll-behavior-y: none;\n  }\n  .md\\:overscroll-x-auto {\n    overscroll-behavior-x: auto;\n  }\n  .md\\:overscroll-x-contain {\n    overscroll-behavior-x: contain;\n  }\n  .md\\:overscroll-x-none {\n    overscroll-behavior-x: none;\n  }\n  .md\\:p-0 {\n    padding: 0;\n  }\n  .md\\:p-1 {\n    padding: 0.25rem;\n  }\n  .md\\:p-2 {\n    padding: 0.5rem;\n  }\n  .md\\:p-3 {\n    padding: 0.75rem;\n  }\n  .md\\:p-4 {\n    padding: 1rem;\n  }\n  .md\\:p-5 {\n    padding: 1.25rem;\n  }\n  .md\\:p-6 {\n    padding: 1.5rem;\n  }\n  .md\\:p-7 {\n    padding: 1.75rem;\n  }\n  .md\\:p-8 {\n    padding: 2rem;\n  }\n  .md\\:p-9 {\n    padding: 2.25rem;\n  }\n  .md\\:p-10 {\n    padding: 2.5rem;\n  }\n  .md\\:p-11 {\n    padding: 2.75rem;\n  }\n  .md\\:p-12 {\n    padding: 3rem;\n  }\n  .md\\:p-13 {\n    padding: 3.25rem;\n  }\n  .md\\:p-14 {\n    padding: 3.5rem;\n  }\n  .md\\:p-15 {\n    padding: 3.75rem;\n  }\n  .md\\:p-16 {\n    padding: 4rem;\n  }\n  .md\\:p-20 {\n    padding: 5rem;\n  }\n  .md\\:p-24 {\n    padding: 6rem;\n  }\n  .md\\:p-28 {\n    padding: 7rem;\n  }\n  .md\\:p-32 {\n    padding: 8rem;\n  }\n  .md\\:p-36 {\n    padding: 9rem;\n  }\n  .md\\:p-40 {\n    padding: 10rem;\n  }\n  .md\\:p-44 {\n    padding: 11rem;\n  }\n  .md\\:p-48 {\n    padding: 12rem;\n  }\n  .md\\:p-52 {\n    padding: 13rem;\n  }\n  .md\\:p-56 {\n    padding: 14rem;\n  }\n  .md\\:p-60 {\n    padding: 15rem;\n  }\n  .md\\:p-64 {\n    padding: 16rem;\n  }\n  .md\\:p-72 {\n    padding: 18rem;\n  }\n  .md\\:p-80 {\n    padding: 20rem;\n  }\n  .md\\:p-96 {\n    padding: 24rem;\n  }\n  .md\\:p-px {\n    padding: 1px;\n  }\n  .md\\:p-0\\.5 {\n    padding: 0.125rem;\n  }\n  .md\\:p-1\\.5 {\n    padding: 0.375rem;\n  }\n  .md\\:p-2\\.5 {\n    padding: 0.625rem;\n  }\n  .md\\:p-3\\.5 {\n    padding: 0.875rem;\n  }\n  .md\\:p-1\\/2 {\n    padding: 50%;\n  }\n  .md\\:p-1\\/3 {\n    padding: 33.333333%;\n  }\n  .md\\:p-2\\/3 {\n    padding: 66.666667%;\n  }\n  .md\\:p-1\\/4 {\n    padding: 25%;\n  }\n  .md\\:p-2\\/4 {\n    padding: 50%;\n  }\n  .md\\:p-3\\/4 {\n    padding: 75%;\n  }\n  .md\\:p-1\\/5 {\n    padding: 20%;\n  }\n  .md\\:p-2\\/5 {\n    padding: 40%;\n  }\n  .md\\:p-3\\/5 {\n    padding: 60%;\n  }\n  .md\\:p-4\\/5 {\n    padding: 80%;\n  }\n  .md\\:p-1\\/6 {\n    padding: 16.666667%;\n  }\n  .md\\:p-2\\/6 {\n    padding: 33.333333%;\n  }\n  .md\\:p-3\\/6 {\n    padding: 50%;\n  }\n  .md\\:p-4\\/6 {\n    padding: 66.666667%;\n  }\n  .md\\:p-5\\/6 {\n    padding: 83.333333%;\n  }\n  .md\\:p-1\\/12 {\n    padding: 8.333333%;\n  }\n  .md\\:p-2\\/12 {\n    padding: 16.666667%;\n  }\n  .md\\:p-3\\/12 {\n    padding: 25%;\n  }\n  .md\\:p-4\\/12 {\n    padding: 33.333333%;\n  }\n  .md\\:p-5\\/12 {\n    padding: 41.666667%;\n  }\n  .md\\:p-6\\/12 {\n    padding: 50%;\n  }\n  .md\\:p-7\\/12 {\n    padding: 58.333333%;\n  }\n  .md\\:p-8\\/12 {\n    padding: 66.666667%;\n  }\n  .md\\:p-9\\/12 {\n    padding: 75%;\n  }\n  .md\\:p-10\\/12 {\n    padding: 83.333333%;\n  }\n  .md\\:p-11\\/12 {\n    padding: 91.666667%;\n  }\n  .md\\:p-full {\n    padding: 100%;\n  }\n  .md\\:py-0 {\n    padding-top: 0;\n    padding-bottom: 0;\n  }\n  .md\\:px-0 {\n    padding-left: 0;\n    padding-right: 0;\n  }\n  .md\\:py-1 {\n    padding-top: 0.25rem;\n    padding-bottom: 0.25rem;\n  }\n  .md\\:px-1 {\n    padding-left: 0.25rem;\n    padding-right: 0.25rem;\n  }\n  .md\\:py-2 {\n    padding-top: 0.5rem;\n    padding-bottom: 0.5rem;\n  }\n  .md\\:px-2 {\n    padding-left: 0.5rem;\n    padding-right: 0.5rem;\n  }\n  .md\\:py-3 {\n    padding-top: 0.75rem;\n    padding-bottom: 0.75rem;\n  }\n  .md\\:px-3 {\n    padding-left: 0.75rem;\n    padding-right: 0.75rem;\n  }\n  .md\\:py-4 {\n    padding-top: 1rem;\n    padding-bottom: 1rem;\n  }\n  .md\\:px-4 {\n    padding-left: 1rem;\n    padding-right: 1rem;\n  }\n  .md\\:py-5 {\n    padding-top: 1.25rem;\n    padding-bottom: 1.25rem;\n  }\n  .md\\:px-5 {\n    padding-left: 1.25rem;\n    padding-right: 1.25rem;\n  }\n  .md\\:py-6 {\n    padding-top: 1.5rem;\n    padding-bottom: 1.5rem;\n  }\n  .md\\:px-6 {\n    padding-left: 1.5rem;\n    padding-right: 1.5rem;\n  }\n  .md\\:py-7 {\n    padding-top: 1.75rem;\n    padding-bottom: 1.75rem;\n  }\n  .md\\:px-7 {\n    padding-left: 1.75rem;\n    padding-right: 1.75rem;\n  }\n  .md\\:py-8 {\n    padding-top: 2rem;\n    padding-bottom: 2rem;\n  }\n  .md\\:px-8 {\n    padding-left: 2rem;\n    padding-right: 2rem;\n  }\n  .md\\:py-9 {\n    padding-top: 2.25rem;\n    padding-bottom: 2.25rem;\n  }\n  .md\\:px-9 {\n    padding-left: 2.25rem;\n    padding-right: 2.25rem;\n  }\n  .md\\:py-10 {\n    padding-top: 2.5rem;\n    padding-bottom: 2.5rem;\n  }\n  .md\\:px-10 {\n    padding-left: 2.5rem;\n    padding-right: 2.5rem;\n  }\n  .md\\:py-11 {\n    padding-top: 2.75rem;\n    padding-bottom: 2.75rem;\n  }\n  .md\\:px-11 {\n    padding-left: 2.75rem;\n    padding-right: 2.75rem;\n  }\n  .md\\:py-12 {\n    padding-top: 3rem;\n    padding-bottom: 3rem;\n  }\n  .md\\:px-12 {\n    padding-left: 3rem;\n    padding-right: 3rem;\n  }\n  .md\\:py-13 {\n    padding-top: 3.25rem;\n    padding-bottom: 3.25rem;\n  }\n  .md\\:px-13 {\n    padding-left: 3.25rem;\n    padding-right: 3.25rem;\n  }\n  .md\\:py-14 {\n    padding-top: 3.5rem;\n    padding-bottom: 3.5rem;\n  }\n  .md\\:px-14 {\n    padding-left: 3.5rem;\n    padding-right: 3.5rem;\n  }\n  .md\\:py-15 {\n    padding-top: 3.75rem;\n    padding-bottom: 3.75rem;\n  }\n  .md\\:px-15 {\n    padding-left: 3.75rem;\n    padding-right: 3.75rem;\n  }\n  .md\\:py-16 {\n    padding-top: 4rem;\n    padding-bottom: 4rem;\n  }\n  .md\\:px-16 {\n    padding-left: 4rem;\n    padding-right: 4rem;\n  }\n  .md\\:py-20 {\n    padding-top: 5rem;\n    padding-bottom: 5rem;\n  }\n  .md\\:px-20 {\n    padding-left: 5rem;\n    padding-right: 5rem;\n  }\n  .md\\:py-24 {\n    padding-top: 6rem;\n    padding-bottom: 6rem;\n  }\n  .md\\:px-24 {\n    padding-left: 6rem;\n    padding-right: 6rem;\n  }\n  .md\\:py-28 {\n    padding-top: 7rem;\n    padding-bottom: 7rem;\n  }\n  .md\\:px-28 {\n    padding-left: 7rem;\n    padding-right: 7rem;\n  }\n  .md\\:py-32 {\n    padding-top: 8rem;\n    padding-bottom: 8rem;\n  }\n  .md\\:px-32 {\n    padding-left: 8rem;\n    padding-right: 8rem;\n  }\n  .md\\:py-36 {\n    padding-top: 9rem;\n    padding-bottom: 9rem;\n  }\n  .md\\:px-36 {\n    padding-left: 9rem;\n    padding-right: 9rem;\n  }\n  .md\\:py-40 {\n    padding-top: 10rem;\n    padding-bottom: 10rem;\n  }\n  .md\\:px-40 {\n    padding-left: 10rem;\n    padding-right: 10rem;\n  }\n  .md\\:py-44 {\n    padding-top: 11rem;\n    padding-bottom: 11rem;\n  }\n  .md\\:px-44 {\n    padding-left: 11rem;\n    padding-right: 11rem;\n  }\n  .md\\:py-48 {\n    padding-top: 12rem;\n    padding-bottom: 12rem;\n  }\n  .md\\:px-48 {\n    padding-left: 12rem;\n    padding-right: 12rem;\n  }\n  .md\\:py-52 {\n    padding-top: 13rem;\n    padding-bottom: 13rem;\n  }\n  .md\\:px-52 {\n    padding-left: 13rem;\n    padding-right: 13rem;\n  }\n  .md\\:py-56 {\n    padding-top: 14rem;\n    padding-bottom: 14rem;\n  }\n  .md\\:px-56 {\n    padding-left: 14rem;\n    padding-right: 14rem;\n  }\n  .md\\:py-60 {\n    padding-top: 15rem;\n    padding-bottom: 15rem;\n  }\n  .md\\:px-60 {\n    padding-left: 15rem;\n    padding-right: 15rem;\n  }\n  .md\\:py-64 {\n    padding-top: 16rem;\n    padding-bottom: 16rem;\n  }\n  .md\\:px-64 {\n    padding-left: 16rem;\n    padding-right: 16rem;\n  }\n  .md\\:py-72 {\n    padding-top: 18rem;\n    padding-bottom: 18rem;\n  }\n  .md\\:px-72 {\n    padding-left: 18rem;\n    padding-right: 18rem;\n  }\n  .md\\:py-80 {\n    padding-top: 20rem;\n    padding-bottom: 20rem;\n  }\n  .md\\:px-80 {\n    padding-left: 20rem;\n    padding-right: 20rem;\n  }\n  .md\\:py-96 {\n    padding-top: 24rem;\n    padding-bottom: 24rem;\n  }\n  .md\\:px-96 {\n    padding-left: 24rem;\n    padding-right: 24rem;\n  }\n  .md\\:py-px {\n    padding-top: 1px;\n    padding-bottom: 1px;\n  }\n  .md\\:px-px {\n    padding-left: 1px;\n    padding-right: 1px;\n  }\n  .md\\:py-0\\.5 {\n    padding-top: 0.125rem;\n    padding-bottom: 0.125rem;\n  }\n  .md\\:px-0\\.5 {\n    padding-left: 0.125rem;\n    padding-right: 0.125rem;\n  }\n  .md\\:py-1\\.5 {\n    padding-top: 0.375rem;\n    padding-bottom: 0.375rem;\n  }\n  .md\\:px-1\\.5 {\n    padding-left: 0.375rem;\n    padding-right: 0.375rem;\n  }\n  .md\\:py-2\\.5 {\n    padding-top: 0.625rem;\n    padding-bottom: 0.625rem;\n  }\n  .md\\:px-2\\.5 {\n    padding-left: 0.625rem;\n    padding-right: 0.625rem;\n  }\n  .md\\:py-3\\.5 {\n    padding-top: 0.875rem;\n    padding-bottom: 0.875rem;\n  }\n  .md\\:px-3\\.5 {\n    padding-left: 0.875rem;\n    padding-right: 0.875rem;\n  }\n  .md\\:py-1\\/2 {\n    padding-top: 50%;\n    padding-bottom: 50%;\n  }\n  .md\\:px-1\\/2 {\n    padding-left: 50%;\n    padding-right: 50%;\n  }\n  .md\\:py-1\\/3 {\n    padding-top: 33.333333%;\n    padding-bottom: 33.333333%;\n  }\n  .md\\:px-1\\/3 {\n    padding-left: 33.333333%;\n    padding-right: 33.333333%;\n  }\n  .md\\:py-2\\/3 {\n    padding-top: 66.666667%;\n    padding-bottom: 66.666667%;\n  }\n  .md\\:px-2\\/3 {\n    padding-left: 66.666667%;\n    padding-right: 66.666667%;\n  }\n  .md\\:py-1\\/4 {\n    padding-top: 25%;\n    padding-bottom: 25%;\n  }\n  .md\\:px-1\\/4 {\n    padding-left: 25%;\n    padding-right: 25%;\n  }\n  .md\\:py-2\\/4 {\n    padding-top: 50%;\n    padding-bottom: 50%;\n  }\n  .md\\:px-2\\/4 {\n    padding-left: 50%;\n    padding-right: 50%;\n  }\n  .md\\:py-3\\/4 {\n    padding-top: 75%;\n    padding-bottom: 75%;\n  }\n  .md\\:px-3\\/4 {\n    padding-left: 75%;\n    padding-right: 75%;\n  }\n  .md\\:py-1\\/5 {\n    padding-top: 20%;\n    padding-bottom: 20%;\n  }\n  .md\\:px-1\\/5 {\n    padding-left: 20%;\n    padding-right: 20%;\n  }\n  .md\\:py-2\\/5 {\n    padding-top: 40%;\n    padding-bottom: 40%;\n  }\n  .md\\:px-2\\/5 {\n    padding-left: 40%;\n    padding-right: 40%;\n  }\n  .md\\:py-3\\/5 {\n    padding-top: 60%;\n    padding-bottom: 60%;\n  }\n  .md\\:px-3\\/5 {\n    padding-left: 60%;\n    padding-right: 60%;\n  }\n  .md\\:py-4\\/5 {\n    padding-top: 80%;\n    padding-bottom: 80%;\n  }\n  .md\\:px-4\\/5 {\n    padding-left: 80%;\n    padding-right: 80%;\n  }\n  .md\\:py-1\\/6 {\n    padding-top: 16.666667%;\n    padding-bottom: 16.666667%;\n  }\n  .md\\:px-1\\/6 {\n    padding-left: 16.666667%;\n    padding-right: 16.666667%;\n  }\n  .md\\:py-2\\/6 {\n    padding-top: 33.333333%;\n    padding-bottom: 33.333333%;\n  }\n  .md\\:px-2\\/6 {\n    padding-left: 33.333333%;\n    padding-right: 33.333333%;\n  }\n  .md\\:py-3\\/6 {\n    padding-top: 50%;\n    padding-bottom: 50%;\n  }\n  .md\\:px-3\\/6 {\n    padding-left: 50%;\n    padding-right: 50%;\n  }\n  .md\\:py-4\\/6 {\n    padding-top: 66.666667%;\n    padding-bottom: 66.666667%;\n  }\n  .md\\:px-4\\/6 {\n    padding-left: 66.666667%;\n    padding-right: 66.666667%;\n  }\n  .md\\:py-5\\/6 {\n    padding-top: 83.333333%;\n    padding-bottom: 83.333333%;\n  }\n  .md\\:px-5\\/6 {\n    padding-left: 83.333333%;\n    padding-right: 83.333333%;\n  }\n  .md\\:py-1\\/12 {\n    padding-top: 8.333333%;\n    padding-bottom: 8.333333%;\n  }\n  .md\\:px-1\\/12 {\n    padding-left: 8.333333%;\n    padding-right: 8.333333%;\n  }\n  .md\\:py-2\\/12 {\n    padding-top: 16.666667%;\n    padding-bottom: 16.666667%;\n  }\n  .md\\:px-2\\/12 {\n    padding-left: 16.666667%;\n    padding-right: 16.666667%;\n  }\n  .md\\:py-3\\/12 {\n    padding-top: 25%;\n    padding-bottom: 25%;\n  }\n  .md\\:px-3\\/12 {\n    padding-left: 25%;\n    padding-right: 25%;\n  }\n  .md\\:py-4\\/12 {\n    padding-top: 33.333333%;\n    padding-bottom: 33.333333%;\n  }\n  .md\\:px-4\\/12 {\n    padding-left: 33.333333%;\n    padding-right: 33.333333%;\n  }\n  .md\\:py-5\\/12 {\n    padding-top: 41.666667%;\n    padding-bottom: 41.666667%;\n  }\n  .md\\:px-5\\/12 {\n    padding-left: 41.666667%;\n    padding-right: 41.666667%;\n  }\n  .md\\:py-6\\/12 {\n    padding-top: 50%;\n    padding-bottom: 50%;\n  }\n  .md\\:px-6\\/12 {\n    padding-left: 50%;\n    padding-right: 50%;\n  }\n  .md\\:py-7\\/12 {\n    padding-top: 58.333333%;\n    padding-bottom: 58.333333%;\n  }\n  .md\\:px-7\\/12 {\n    padding-left: 58.333333%;\n    padding-right: 58.333333%;\n  }\n  .md\\:py-8\\/12 {\n    padding-top: 66.666667%;\n    padding-bottom: 66.666667%;\n  }\n  .md\\:px-8\\/12 {\n    padding-left: 66.666667%;\n    padding-right: 66.666667%;\n  }\n  .md\\:py-9\\/12 {\n    padding-top: 75%;\n    padding-bottom: 75%;\n  }\n  .md\\:px-9\\/12 {\n    padding-left: 75%;\n    padding-right: 75%;\n  }\n  .md\\:py-10\\/12 {\n    padding-top: 83.333333%;\n    padding-bottom: 83.333333%;\n  }\n  .md\\:px-10\\/12 {\n    padding-left: 83.333333%;\n    padding-right: 83.333333%;\n  }\n  .md\\:py-11\\/12 {\n    padding-top: 91.666667%;\n    padding-bottom: 91.666667%;\n  }\n  .md\\:px-11\\/12 {\n    padding-left: 91.666667%;\n    padding-right: 91.666667%;\n  }\n  .md\\:py-full {\n    padding-top: 100%;\n    padding-bottom: 100%;\n  }\n  .md\\:px-full {\n    padding-left: 100%;\n    padding-right: 100%;\n  }\n  .md\\:pt-0 {\n    padding-top: 0;\n  }\n  .md\\:pr-0 {\n    padding-right: 0;\n  }\n  .md\\:pb-0 {\n    padding-bottom: 0;\n  }\n  .md\\:pl-0 {\n    padding-left: 0;\n  }\n  .md\\:pt-1 {\n    padding-top: 0.25rem;\n  }\n  .md\\:pr-1 {\n    padding-right: 0.25rem;\n  }\n  .md\\:pb-1 {\n    padding-bottom: 0.25rem;\n  }\n  .md\\:pl-1 {\n    padding-left: 0.25rem;\n  }\n  .md\\:pt-2 {\n    padding-top: 0.5rem;\n  }\n  .md\\:pr-2 {\n    padding-right: 0.5rem;\n  }\n  .md\\:pb-2 {\n    padding-bottom: 0.5rem;\n  }\n  .md\\:pl-2 {\n    padding-left: 0.5rem;\n  }\n  .md\\:pt-3 {\n    padding-top: 0.75rem;\n  }\n  .md\\:pr-3 {\n    padding-right: 0.75rem;\n  }\n  .md\\:pb-3 {\n    padding-bottom: 0.75rem;\n  }\n  .md\\:pl-3 {\n    padding-left: 0.75rem;\n  }\n  .md\\:pt-4 {\n    padding-top: 1rem;\n  }\n  .md\\:pr-4 {\n    padding-right: 1rem;\n  }\n  .md\\:pb-4 {\n    padding-bottom: 1rem;\n  }\n  .md\\:pl-4 {\n    padding-left: 1rem;\n  }\n  .md\\:pt-5 {\n    padding-top: 1.25rem;\n  }\n  .md\\:pr-5 {\n    padding-right: 1.25rem;\n  }\n  .md\\:pb-5 {\n    padding-bottom: 1.25rem;\n  }\n  .md\\:pl-5 {\n    padding-left: 1.25rem;\n  }\n  .md\\:pt-6 {\n    padding-top: 1.5rem;\n  }\n  .md\\:pr-6 {\n    padding-right: 1.5rem;\n  }\n  .md\\:pb-6 {\n    padding-bottom: 1.5rem;\n  }\n  .md\\:pl-6 {\n    padding-left: 1.5rem;\n  }\n  .md\\:pt-7 {\n    padding-top: 1.75rem;\n  }\n  .md\\:pr-7 {\n    padding-right: 1.75rem;\n  }\n  .md\\:pb-7 {\n    padding-bottom: 1.75rem;\n  }\n  .md\\:pl-7 {\n    padding-left: 1.75rem;\n  }\n  .md\\:pt-8 {\n    padding-top: 2rem;\n  }\n  .md\\:pr-8 {\n    padding-right: 2rem;\n  }\n  .md\\:pb-8 {\n    padding-bottom: 2rem;\n  }\n  .md\\:pl-8 {\n    padding-left: 2rem;\n  }\n  .md\\:pt-9 {\n    padding-top: 2.25rem;\n  }\n  .md\\:pr-9 {\n    padding-right: 2.25rem;\n  }\n  .md\\:pb-9 {\n    padding-bottom: 2.25rem;\n  }\n  .md\\:pl-9 {\n    padding-left: 2.25rem;\n  }\n  .md\\:pt-10 {\n    padding-top: 2.5rem;\n  }\n  .md\\:pr-10 {\n    padding-right: 2.5rem;\n  }\n  .md\\:pb-10 {\n    padding-bottom: 2.5rem;\n  }\n  .md\\:pl-10 {\n    padding-left: 2.5rem;\n  }\n  .md\\:pt-11 {\n    padding-top: 2.75rem;\n  }\n  .md\\:pr-11 {\n    padding-right: 2.75rem;\n  }\n  .md\\:pb-11 {\n    padding-bottom: 2.75rem;\n  }\n  .md\\:pl-11 {\n    padding-left: 2.75rem;\n  }\n  .md\\:pt-12 {\n    padding-top: 3rem;\n  }\n  .md\\:pr-12 {\n    padding-right: 3rem;\n  }\n  .md\\:pb-12 {\n    padding-bottom: 3rem;\n  }\n  .md\\:pl-12 {\n    padding-left: 3rem;\n  }\n  .md\\:pt-13 {\n    padding-top: 3.25rem;\n  }\n  .md\\:pr-13 {\n    padding-right: 3.25rem;\n  }\n  .md\\:pb-13 {\n    padding-bottom: 3.25rem;\n  }\n  .md\\:pl-13 {\n    padding-left: 3.25rem;\n  }\n  .md\\:pt-14 {\n    padding-top: 3.5rem;\n  }\n  .md\\:pr-14 {\n    padding-right: 3.5rem;\n  }\n  .md\\:pb-14 {\n    padding-bottom: 3.5rem;\n  }\n  .md\\:pl-14 {\n    padding-left: 3.5rem;\n  }\n  .md\\:pt-15 {\n    padding-top: 3.75rem;\n  }\n  .md\\:pr-15 {\n    padding-right: 3.75rem;\n  }\n  .md\\:pb-15 {\n    padding-bottom: 3.75rem;\n  }\n  .md\\:pl-15 {\n    padding-left: 3.75rem;\n  }\n  .md\\:pt-16 {\n    padding-top: 4rem;\n  }\n  .md\\:pr-16 {\n    padding-right: 4rem;\n  }\n  .md\\:pb-16 {\n    padding-bottom: 4rem;\n  }\n  .md\\:pl-16 {\n    padding-left: 4rem;\n  }\n  .md\\:pt-20 {\n    padding-top: 5rem;\n  }\n  .md\\:pr-20 {\n    padding-right: 5rem;\n  }\n  .md\\:pb-20 {\n    padding-bottom: 5rem;\n  }\n  .md\\:pl-20 {\n    padding-left: 5rem;\n  }\n  .md\\:pt-24 {\n    padding-top: 6rem;\n  }\n  .md\\:pr-24 {\n    padding-right: 6rem;\n  }\n  .md\\:pb-24 {\n    padding-bottom: 6rem;\n  }\n  .md\\:pl-24 {\n    padding-left: 6rem;\n  }\n  .md\\:pt-28 {\n    padding-top: 7rem;\n  }\n  .md\\:pr-28 {\n    padding-right: 7rem;\n  }\n  .md\\:pb-28 {\n    padding-bottom: 7rem;\n  }\n  .md\\:pl-28 {\n    padding-left: 7rem;\n  }\n  .md\\:pt-32 {\n    padding-top: 8rem;\n  }\n  .md\\:pr-32 {\n    padding-right: 8rem;\n  }\n  .md\\:pb-32 {\n    padding-bottom: 8rem;\n  }\n  .md\\:pl-32 {\n    padding-left: 8rem;\n  }\n  .md\\:pt-36 {\n    padding-top: 9rem;\n  }\n  .md\\:pr-36 {\n    padding-right: 9rem;\n  }\n  .md\\:pb-36 {\n    padding-bottom: 9rem;\n  }\n  .md\\:pl-36 {\n    padding-left: 9rem;\n  }\n  .md\\:pt-40 {\n    padding-top: 10rem;\n  }\n  .md\\:pr-40 {\n    padding-right: 10rem;\n  }\n  .md\\:pb-40 {\n    padding-bottom: 10rem;\n  }\n  .md\\:pl-40 {\n    padding-left: 10rem;\n  }\n  .md\\:pt-44 {\n    padding-top: 11rem;\n  }\n  .md\\:pr-44 {\n    padding-right: 11rem;\n  }\n  .md\\:pb-44 {\n    padding-bottom: 11rem;\n  }\n  .md\\:pl-44 {\n    padding-left: 11rem;\n  }\n  .md\\:pt-48 {\n    padding-top: 12rem;\n  }\n  .md\\:pr-48 {\n    padding-right: 12rem;\n  }\n  .md\\:pb-48 {\n    padding-bottom: 12rem;\n  }\n  .md\\:pl-48 {\n    padding-left: 12rem;\n  }\n  .md\\:pt-52 {\n    padding-top: 13rem;\n  }\n  .md\\:pr-52 {\n    padding-right: 13rem;\n  }\n  .md\\:pb-52 {\n    padding-bottom: 13rem;\n  }\n  .md\\:pl-52 {\n    padding-left: 13rem;\n  }\n  .md\\:pt-56 {\n    padding-top: 14rem;\n  }\n  .md\\:pr-56 {\n    padding-right: 14rem;\n  }\n  .md\\:pb-56 {\n    padding-bottom: 14rem;\n  }\n  .md\\:pl-56 {\n    padding-left: 14rem;\n  }\n  .md\\:pt-60 {\n    padding-top: 15rem;\n  }\n  .md\\:pr-60 {\n    padding-right: 15rem;\n  }\n  .md\\:pb-60 {\n    padding-bottom: 15rem;\n  }\n  .md\\:pl-60 {\n    padding-left: 15rem;\n  }\n  .md\\:pt-64 {\n    padding-top: 16rem;\n  }\n  .md\\:pr-64 {\n    padding-right: 16rem;\n  }\n  .md\\:pb-64 {\n    padding-bottom: 16rem;\n  }\n  .md\\:pl-64 {\n    padding-left: 16rem;\n  }\n  .md\\:pt-72 {\n    padding-top: 18rem;\n  }\n  .md\\:pr-72 {\n    padding-right: 18rem;\n  }\n  .md\\:pb-72 {\n    padding-bottom: 18rem;\n  }\n  .md\\:pl-72 {\n    padding-left: 18rem;\n  }\n  .md\\:pt-80 {\n    padding-top: 20rem;\n  }\n  .md\\:pr-80 {\n    padding-right: 20rem;\n  }\n  .md\\:pb-80 {\n    padding-bottom: 20rem;\n  }\n  .md\\:pl-80 {\n    padding-left: 20rem;\n  }\n  .md\\:pt-96 {\n    padding-top: 24rem;\n  }\n  .md\\:pr-96 {\n    padding-right: 24rem;\n  }\n  .md\\:pb-96 {\n    padding-bottom: 24rem;\n  }\n  .md\\:pl-96 {\n    padding-left: 24rem;\n  }\n  .md\\:pt-px {\n    padding-top: 1px;\n  }\n  .md\\:pr-px {\n    padding-right: 1px;\n  }\n  .md\\:pb-px {\n    padding-bottom: 1px;\n  }\n  .md\\:pl-px {\n    padding-left: 1px;\n  }\n  .md\\:pt-0\\.5 {\n    padding-top: 0.125rem;\n  }\n  .md\\:pr-0\\.5 {\n    padding-right: 0.125rem;\n  }\n  .md\\:pb-0\\.5 {\n    padding-bottom: 0.125rem;\n  }\n  .md\\:pl-0\\.5 {\n    padding-left: 0.125rem;\n  }\n  .md\\:pt-1\\.5 {\n    padding-top: 0.375rem;\n  }\n  .md\\:pr-1\\.5 {\n    padding-right: 0.375rem;\n  }\n  .md\\:pb-1\\.5 {\n    padding-bottom: 0.375rem;\n  }\n  .md\\:pl-1\\.5 {\n    padding-left: 0.375rem;\n  }\n  .md\\:pt-2\\.5 {\n    padding-top: 0.625rem;\n  }\n  .md\\:pr-2\\.5 {\n    padding-right: 0.625rem;\n  }\n  .md\\:pb-2\\.5 {\n    padding-bottom: 0.625rem;\n  }\n  .md\\:pl-2\\.5 {\n    padding-left: 0.625rem;\n  }\n  .md\\:pt-3\\.5 {\n    padding-top: 0.875rem;\n  }\n  .md\\:pr-3\\.5 {\n    padding-right: 0.875rem;\n  }\n  .md\\:pb-3\\.5 {\n    padding-bottom: 0.875rem;\n  }\n  .md\\:pl-3\\.5 {\n    padding-left: 0.875rem;\n  }\n  .md\\:pt-1\\/2 {\n    padding-top: 50%;\n  }\n  .md\\:pr-1\\/2 {\n    padding-right: 50%;\n  }\n  .md\\:pb-1\\/2 {\n    padding-bottom: 50%;\n  }\n  .md\\:pl-1\\/2 {\n    padding-left: 50%;\n  }\n  .md\\:pt-1\\/3 {\n    padding-top: 33.333333%;\n  }\n  .md\\:pr-1\\/3 {\n    padding-right: 33.333333%;\n  }\n  .md\\:pb-1\\/3 {\n    padding-bottom: 33.333333%;\n  }\n  .md\\:pl-1\\/3 {\n    padding-left: 33.333333%;\n  }\n  .md\\:pt-2\\/3 {\n    padding-top: 66.666667%;\n  }\n  .md\\:pr-2\\/3 {\n    padding-right: 66.666667%;\n  }\n  .md\\:pb-2\\/3 {\n    padding-bottom: 66.666667%;\n  }\n  .md\\:pl-2\\/3 {\n    padding-left: 66.666667%;\n  }\n  .md\\:pt-1\\/4 {\n    padding-top: 25%;\n  }\n  .md\\:pr-1\\/4 {\n    padding-right: 25%;\n  }\n  .md\\:pb-1\\/4 {\n    padding-bottom: 25%;\n  }\n  .md\\:pl-1\\/4 {\n    padding-left: 25%;\n  }\n  .md\\:pt-2\\/4 {\n    padding-top: 50%;\n  }\n  .md\\:pr-2\\/4 {\n    padding-right: 50%;\n  }\n  .md\\:pb-2\\/4 {\n    padding-bottom: 50%;\n  }\n  .md\\:pl-2\\/4 {\n    padding-left: 50%;\n  }\n  .md\\:pt-3\\/4 {\n    padding-top: 75%;\n  }\n  .md\\:pr-3\\/4 {\n    padding-right: 75%;\n  }\n  .md\\:pb-3\\/4 {\n    padding-bottom: 75%;\n  }\n  .md\\:pl-3\\/4 {\n    padding-left: 75%;\n  }\n  .md\\:pt-1\\/5 {\n    padding-top: 20%;\n  }\n  .md\\:pr-1\\/5 {\n    padding-right: 20%;\n  }\n  .md\\:pb-1\\/5 {\n    padding-bottom: 20%;\n  }\n  .md\\:pl-1\\/5 {\n    padding-left: 20%;\n  }\n  .md\\:pt-2\\/5 {\n    padding-top: 40%;\n  }\n  .md\\:pr-2\\/5 {\n    padding-right: 40%;\n  }\n  .md\\:pb-2\\/5 {\n    padding-bottom: 40%;\n  }\n  .md\\:pl-2\\/5 {\n    padding-left: 40%;\n  }\n  .md\\:pt-3\\/5 {\n    padding-top: 60%;\n  }\n  .md\\:pr-3\\/5 {\n    padding-right: 60%;\n  }\n  .md\\:pb-3\\/5 {\n    padding-bottom: 60%;\n  }\n  .md\\:pl-3\\/5 {\n    padding-left: 60%;\n  }\n  .md\\:pt-4\\/5 {\n    padding-top: 80%;\n  }\n  .md\\:pr-4\\/5 {\n    padding-right: 80%;\n  }\n  .md\\:pb-4\\/5 {\n    padding-bottom: 80%;\n  }\n  .md\\:pl-4\\/5 {\n    padding-left: 80%;\n  }\n  .md\\:pt-1\\/6 {\n    padding-top: 16.666667%;\n  }\n  .md\\:pr-1\\/6 {\n    padding-right: 16.666667%;\n  }\n  .md\\:pb-1\\/6 {\n    padding-bottom: 16.666667%;\n  }\n  .md\\:pl-1\\/6 {\n    padding-left: 16.666667%;\n  }\n  .md\\:pt-2\\/6 {\n    padding-top: 33.333333%;\n  }\n  .md\\:pr-2\\/6 {\n    padding-right: 33.333333%;\n  }\n  .md\\:pb-2\\/6 {\n    padding-bottom: 33.333333%;\n  }\n  .md\\:pl-2\\/6 {\n    padding-left: 33.333333%;\n  }\n  .md\\:pt-3\\/6 {\n    padding-top: 50%;\n  }\n  .md\\:pr-3\\/6 {\n    padding-right: 50%;\n  }\n  .md\\:pb-3\\/6 {\n    padding-bottom: 50%;\n  }\n  .md\\:pl-3\\/6 {\n    padding-left: 50%;\n  }\n  .md\\:pt-4\\/6 {\n    padding-top: 66.666667%;\n  }\n  .md\\:pr-4\\/6 {\n    padding-right: 66.666667%;\n  }\n  .md\\:pb-4\\/6 {\n    padding-bottom: 66.666667%;\n  }\n  .md\\:pl-4\\/6 {\n    padding-left: 66.666667%;\n  }\n  .md\\:pt-5\\/6 {\n    padding-top: 83.333333%;\n  }\n  .md\\:pr-5\\/6 {\n    padding-right: 83.333333%;\n  }\n  .md\\:pb-5\\/6 {\n    padding-bottom: 83.333333%;\n  }\n  .md\\:pl-5\\/6 {\n    padding-left: 83.333333%;\n  }\n  .md\\:pt-1\\/12 {\n    padding-top: 8.333333%;\n  }\n  .md\\:pr-1\\/12 {\n    padding-right: 8.333333%;\n  }\n  .md\\:pb-1\\/12 {\n    padding-bottom: 8.333333%;\n  }\n  .md\\:pl-1\\/12 {\n    padding-left: 8.333333%;\n  }\n  .md\\:pt-2\\/12 {\n    padding-top: 16.666667%;\n  }\n  .md\\:pr-2\\/12 {\n    padding-right: 16.666667%;\n  }\n  .md\\:pb-2\\/12 {\n    padding-bottom: 16.666667%;\n  }\n  .md\\:pl-2\\/12 {\n    padding-left: 16.666667%;\n  }\n  .md\\:pt-3\\/12 {\n    padding-top: 25%;\n  }\n  .md\\:pr-3\\/12 {\n    padding-right: 25%;\n  }\n  .md\\:pb-3\\/12 {\n    padding-bottom: 25%;\n  }\n  .md\\:pl-3\\/12 {\n    padding-left: 25%;\n  }\n  .md\\:pt-4\\/12 {\n    padding-top: 33.333333%;\n  }\n  .md\\:pr-4\\/12 {\n    padding-right: 33.333333%;\n  }\n  .md\\:pb-4\\/12 {\n    padding-bottom: 33.333333%;\n  }\n  .md\\:pl-4\\/12 {\n    padding-left: 33.333333%;\n  }\n  .md\\:pt-5\\/12 {\n    padding-top: 41.666667%;\n  }\n  .md\\:pr-5\\/12 {\n    padding-right: 41.666667%;\n  }\n  .md\\:pb-5\\/12 {\n    padding-bottom: 41.666667%;\n  }\n  .md\\:pl-5\\/12 {\n    padding-left: 41.666667%;\n  }\n  .md\\:pt-6\\/12 {\n    padding-top: 50%;\n  }\n  .md\\:pr-6\\/12 {\n    padding-right: 50%;\n  }\n  .md\\:pb-6\\/12 {\n    padding-bottom: 50%;\n  }\n  .md\\:pl-6\\/12 {\n    padding-left: 50%;\n  }\n  .md\\:pt-7\\/12 {\n    padding-top: 58.333333%;\n  }\n  .md\\:pr-7\\/12 {\n    padding-right: 58.333333%;\n  }\n  .md\\:pb-7\\/12 {\n    padding-bottom: 58.333333%;\n  }\n  .md\\:pl-7\\/12 {\n    padding-left: 58.333333%;\n  }\n  .md\\:pt-8\\/12 {\n    padding-top: 66.666667%;\n  }\n  .md\\:pr-8\\/12 {\n    padding-right: 66.666667%;\n  }\n  .md\\:pb-8\\/12 {\n    padding-bottom: 66.666667%;\n  }\n  .md\\:pl-8\\/12 {\n    padding-left: 66.666667%;\n  }\n  .md\\:pt-9\\/12 {\n    padding-top: 75%;\n  }\n  .md\\:pr-9\\/12 {\n    padding-right: 75%;\n  }\n  .md\\:pb-9\\/12 {\n    padding-bottom: 75%;\n  }\n  .md\\:pl-9\\/12 {\n    padding-left: 75%;\n  }\n  .md\\:pt-10\\/12 {\n    padding-top: 83.333333%;\n  }\n  .md\\:pr-10\\/12 {\n    padding-right: 83.333333%;\n  }\n  .md\\:pb-10\\/12 {\n    padding-bottom: 83.333333%;\n  }\n  .md\\:pl-10\\/12 {\n    padding-left: 83.333333%;\n  }\n  .md\\:pt-11\\/12 {\n    padding-top: 91.666667%;\n  }\n  .md\\:pr-11\\/12 {\n    padding-right: 91.666667%;\n  }\n  .md\\:pb-11\\/12 {\n    padding-bottom: 91.666667%;\n  }\n  .md\\:pl-11\\/12 {\n    padding-left: 91.666667%;\n  }\n  .md\\:pt-full {\n    padding-top: 100%;\n  }\n  .md\\:pr-full {\n    padding-right: 100%;\n  }\n  .md\\:pb-full {\n    padding-bottom: 100%;\n  }\n  .md\\:pl-full {\n    padding-left: 100%;\n  }\n  .md\\:placeholder-current::-moz-placeholder {\n    color: currentColor;\n  }\n  .md\\:placeholder-current::placeholder {\n    color: currentColor;\n  }\n  .md\\:placeholder-transparent::-moz-placeholder {\n    color: transparent;\n  }\n  .md\\:placeholder-transparent::placeholder {\n    color: transparent;\n  }\n  .md\\:placeholder-white::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #ffffff;\n    color: rgba(255, 255, 255, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-white::placeholder {\n    --placeholder-opacity: 1;\n    color: #ffffff;\n    color: rgba(255, 255, 255, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-black::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #000000;\n    color: rgba(0, 0, 0, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-black::placeholder {\n    --placeholder-opacity: 1;\n    color: #000000;\n    color: rgba(0, 0, 0, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-gray-50::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #f9fafb;\n    color: rgba(249, 250, 251, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-gray-50::placeholder {\n    --placeholder-opacity: 1;\n    color: #f9fafb;\n    color: rgba(249, 250, 251, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-gray-100::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #f4f5f7;\n    color: rgba(244, 245, 247, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-gray-100::placeholder {\n    --placeholder-opacity: 1;\n    color: #f4f5f7;\n    color: rgba(244, 245, 247, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-gray-200::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #e5e7eb;\n    color: rgba(229, 231, 235, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-gray-200::placeholder {\n    --placeholder-opacity: 1;\n    color: #e5e7eb;\n    color: rgba(229, 231, 235, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-gray-300::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #d2d6dc;\n    color: rgba(210, 214, 220, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-gray-300::placeholder {\n    --placeholder-opacity: 1;\n    color: #d2d6dc;\n    color: rgba(210, 214, 220, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-gray-400::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #9fa6b2;\n    color: rgba(159, 166, 178, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-gray-400::placeholder {\n    --placeholder-opacity: 1;\n    color: #9fa6b2;\n    color: rgba(159, 166, 178, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-gray-500::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #6b7280;\n    color: rgba(107, 114, 128, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-gray-500::placeholder {\n    --placeholder-opacity: 1;\n    color: #6b7280;\n    color: rgba(107, 114, 128, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-gray-600::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #4b5563;\n    color: rgba(75, 85, 99, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-gray-600::placeholder {\n    --placeholder-opacity: 1;\n    color: #4b5563;\n    color: rgba(75, 85, 99, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-gray-700::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #374151;\n    color: rgba(55, 65, 81, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-gray-700::placeholder {\n    --placeholder-opacity: 1;\n    color: #374151;\n    color: rgba(55, 65, 81, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-gray-800::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #252f3f;\n    color: rgba(37, 47, 63, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-gray-800::placeholder {\n    --placeholder-opacity: 1;\n    color: #252f3f;\n    color: rgba(37, 47, 63, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-gray-900::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #161e2e;\n    color: rgba(22, 30, 46, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-gray-900::placeholder {\n    --placeholder-opacity: 1;\n    color: #161e2e;\n    color: rgba(22, 30, 46, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-red-50::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #fdf2f2;\n    color: rgba(253, 242, 242, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-red-50::placeholder {\n    --placeholder-opacity: 1;\n    color: #fdf2f2;\n    color: rgba(253, 242, 242, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-red-100::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #fde8e8;\n    color: rgba(253, 232, 232, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-red-100::placeholder {\n    --placeholder-opacity: 1;\n    color: #fde8e8;\n    color: rgba(253, 232, 232, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-red-200::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #fbd5d5;\n    color: rgba(251, 213, 213, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-red-200::placeholder {\n    --placeholder-opacity: 1;\n    color: #fbd5d5;\n    color: rgba(251, 213, 213, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-red-300::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #f8b4b4;\n    color: rgba(248, 180, 180, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-red-300::placeholder {\n    --placeholder-opacity: 1;\n    color: #f8b4b4;\n    color: rgba(248, 180, 180, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-red-400::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #f98080;\n    color: rgba(249, 128, 128, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-red-400::placeholder {\n    --placeholder-opacity: 1;\n    color: #f98080;\n    color: rgba(249, 128, 128, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-red-500::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #f05252;\n    color: rgba(240, 82, 82, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-red-500::placeholder {\n    --placeholder-opacity: 1;\n    color: #f05252;\n    color: rgba(240, 82, 82, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-red-600::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #e02424;\n    color: rgba(224, 36, 36, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-red-600::placeholder {\n    --placeholder-opacity: 1;\n    color: #e02424;\n    color: rgba(224, 36, 36, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-red-700::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #c81e1e;\n    color: rgba(200, 30, 30, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-red-700::placeholder {\n    --placeholder-opacity: 1;\n    color: #c81e1e;\n    color: rgba(200, 30, 30, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-red-800::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #9b1c1c;\n    color: rgba(155, 28, 28, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-red-800::placeholder {\n    --placeholder-opacity: 1;\n    color: #9b1c1c;\n    color: rgba(155, 28, 28, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-red-900::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #771d1d;\n    color: rgba(119, 29, 29, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-red-900::placeholder {\n    --placeholder-opacity: 1;\n    color: #771d1d;\n    color: rgba(119, 29, 29, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-orange-50::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #fff8f1;\n    color: rgba(255, 248, 241, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-orange-50::placeholder {\n    --placeholder-opacity: 1;\n    color: #fff8f1;\n    color: rgba(255, 248, 241, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-orange-100::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #feecdc;\n    color: rgba(254, 236, 220, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-orange-100::placeholder {\n    --placeholder-opacity: 1;\n    color: #feecdc;\n    color: rgba(254, 236, 220, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-orange-200::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #fcd9bd;\n    color: rgba(252, 217, 189, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-orange-200::placeholder {\n    --placeholder-opacity: 1;\n    color: #fcd9bd;\n    color: rgba(252, 217, 189, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-orange-300::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #fdba8c;\n    color: rgba(253, 186, 140, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-orange-300::placeholder {\n    --placeholder-opacity: 1;\n    color: #fdba8c;\n    color: rgba(253, 186, 140, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-orange-400::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #ff8a4c;\n    color: rgba(255, 138, 76, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-orange-400::placeholder {\n    --placeholder-opacity: 1;\n    color: #ff8a4c;\n    color: rgba(255, 138, 76, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-orange-500::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #ff5a1f;\n    color: rgba(255, 90, 31, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-orange-500::placeholder {\n    --placeholder-opacity: 1;\n    color: #ff5a1f;\n    color: rgba(255, 90, 31, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-orange-600::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #d03801;\n    color: rgba(208, 56, 1, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-orange-600::placeholder {\n    --placeholder-opacity: 1;\n    color: #d03801;\n    color: rgba(208, 56, 1, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-orange-700::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #b43403;\n    color: rgba(180, 52, 3, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-orange-700::placeholder {\n    --placeholder-opacity: 1;\n    color: #b43403;\n    color: rgba(180, 52, 3, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-orange-800::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #8a2c0d;\n    color: rgba(138, 44, 13, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-orange-800::placeholder {\n    --placeholder-opacity: 1;\n    color: #8a2c0d;\n    color: rgba(138, 44, 13, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-orange-900::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #73230d;\n    color: rgba(115, 35, 13, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-orange-900::placeholder {\n    --placeholder-opacity: 1;\n    color: #73230d;\n    color: rgba(115, 35, 13, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-yellow-50::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #fdfdea;\n    color: rgba(253, 253, 234, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-yellow-50::placeholder {\n    --placeholder-opacity: 1;\n    color: #fdfdea;\n    color: rgba(253, 253, 234, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-yellow-100::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #fdf6b2;\n    color: rgba(253, 246, 178, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-yellow-100::placeholder {\n    --placeholder-opacity: 1;\n    color: #fdf6b2;\n    color: rgba(253, 246, 178, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-yellow-200::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #fce96a;\n    color: rgba(252, 233, 106, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-yellow-200::placeholder {\n    --placeholder-opacity: 1;\n    color: #fce96a;\n    color: rgba(252, 233, 106, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-yellow-300::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #faca15;\n    color: rgba(250, 202, 21, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-yellow-300::placeholder {\n    --placeholder-opacity: 1;\n    color: #faca15;\n    color: rgba(250, 202, 21, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-yellow-400::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #e3a008;\n    color: rgba(227, 160, 8, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-yellow-400::placeholder {\n    --placeholder-opacity: 1;\n    color: #e3a008;\n    color: rgba(227, 160, 8, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-yellow-500::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #c27803;\n    color: rgba(194, 120, 3, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-yellow-500::placeholder {\n    --placeholder-opacity: 1;\n    color: #c27803;\n    color: rgba(194, 120, 3, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-yellow-600::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #9f580a;\n    color: rgba(159, 88, 10, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-yellow-600::placeholder {\n    --placeholder-opacity: 1;\n    color: #9f580a;\n    color: rgba(159, 88, 10, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-yellow-700::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #8e4b10;\n    color: rgba(142, 75, 16, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-yellow-700::placeholder {\n    --placeholder-opacity: 1;\n    color: #8e4b10;\n    color: rgba(142, 75, 16, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-yellow-800::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #723b13;\n    color: rgba(114, 59, 19, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-yellow-800::placeholder {\n    --placeholder-opacity: 1;\n    color: #723b13;\n    color: rgba(114, 59, 19, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-yellow-900::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #633112;\n    color: rgba(99, 49, 18, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-yellow-900::placeholder {\n    --placeholder-opacity: 1;\n    color: #633112;\n    color: rgba(99, 49, 18, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-green-50::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #f3faf7;\n    color: rgba(243, 250, 247, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-green-50::placeholder {\n    --placeholder-opacity: 1;\n    color: #f3faf7;\n    color: rgba(243, 250, 247, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-green-100::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #def7ec;\n    color: rgba(222, 247, 236, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-green-100::placeholder {\n    --placeholder-opacity: 1;\n    color: #def7ec;\n    color: rgba(222, 247, 236, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-green-200::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #bcf0da;\n    color: rgba(188, 240, 218, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-green-200::placeholder {\n    --placeholder-opacity: 1;\n    color: #bcf0da;\n    color: rgba(188, 240, 218, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-green-300::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #84e1bc;\n    color: rgba(132, 225, 188, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-green-300::placeholder {\n    --placeholder-opacity: 1;\n    color: #84e1bc;\n    color: rgba(132, 225, 188, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-green-400::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #31c48d;\n    color: rgba(49, 196, 141, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-green-400::placeholder {\n    --placeholder-opacity: 1;\n    color: #31c48d;\n    color: rgba(49, 196, 141, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-green-500::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #0e9f6e;\n    color: rgba(14, 159, 110, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-green-500::placeholder {\n    --placeholder-opacity: 1;\n    color: #0e9f6e;\n    color: rgba(14, 159, 110, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-green-600::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #057a55;\n    color: rgba(5, 122, 85, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-green-600::placeholder {\n    --placeholder-opacity: 1;\n    color: #057a55;\n    color: rgba(5, 122, 85, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-green-700::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #046c4e;\n    color: rgba(4, 108, 78, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-green-700::placeholder {\n    --placeholder-opacity: 1;\n    color: #046c4e;\n    color: rgba(4, 108, 78, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-green-800::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #03543f;\n    color: rgba(3, 84, 63, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-green-800::placeholder {\n    --placeholder-opacity: 1;\n    color: #03543f;\n    color: rgba(3, 84, 63, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-green-900::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #014737;\n    color: rgba(1, 71, 55, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-green-900::placeholder {\n    --placeholder-opacity: 1;\n    color: #014737;\n    color: rgba(1, 71, 55, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-teal-50::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #edfafa;\n    color: rgba(237, 250, 250, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-teal-50::placeholder {\n    --placeholder-opacity: 1;\n    color: #edfafa;\n    color: rgba(237, 250, 250, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-teal-100::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #d5f5f6;\n    color: rgba(213, 245, 246, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-teal-100::placeholder {\n    --placeholder-opacity: 1;\n    color: #d5f5f6;\n    color: rgba(213, 245, 246, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-teal-200::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #afecef;\n    color: rgba(175, 236, 239, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-teal-200::placeholder {\n    --placeholder-opacity: 1;\n    color: #afecef;\n    color: rgba(175, 236, 239, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-teal-300::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #7edce2;\n    color: rgba(126, 220, 226, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-teal-300::placeholder {\n    --placeholder-opacity: 1;\n    color: #7edce2;\n    color: rgba(126, 220, 226, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-teal-400::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #16bdca;\n    color: rgba(22, 189, 202, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-teal-400::placeholder {\n    --placeholder-opacity: 1;\n    color: #16bdca;\n    color: rgba(22, 189, 202, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-teal-500::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #0694a2;\n    color: rgba(6, 148, 162, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-teal-500::placeholder {\n    --placeholder-opacity: 1;\n    color: #0694a2;\n    color: rgba(6, 148, 162, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-teal-600::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #047481;\n    color: rgba(4, 116, 129, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-teal-600::placeholder {\n    --placeholder-opacity: 1;\n    color: #047481;\n    color: rgba(4, 116, 129, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-teal-700::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #036672;\n    color: rgba(3, 102, 114, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-teal-700::placeholder {\n    --placeholder-opacity: 1;\n    color: #036672;\n    color: rgba(3, 102, 114, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-teal-800::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #05505c;\n    color: rgba(5, 80, 92, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-teal-800::placeholder {\n    --placeholder-opacity: 1;\n    color: #05505c;\n    color: rgba(5, 80, 92, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-teal-900::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #014451;\n    color: rgba(1, 68, 81, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-teal-900::placeholder {\n    --placeholder-opacity: 1;\n    color: #014451;\n    color: rgba(1, 68, 81, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-blue-50::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #ebf5ff;\n    color: rgba(235, 245, 255, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-blue-50::placeholder {\n    --placeholder-opacity: 1;\n    color: #ebf5ff;\n    color: rgba(235, 245, 255, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-blue-100::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #e1effe;\n    color: rgba(225, 239, 254, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-blue-100::placeholder {\n    --placeholder-opacity: 1;\n    color: #e1effe;\n    color: rgba(225, 239, 254, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-blue-200::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #c3ddfd;\n    color: rgba(195, 221, 253, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-blue-200::placeholder {\n    --placeholder-opacity: 1;\n    color: #c3ddfd;\n    color: rgba(195, 221, 253, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-blue-300::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #a4cafe;\n    color: rgba(164, 202, 254, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-blue-300::placeholder {\n    --placeholder-opacity: 1;\n    color: #a4cafe;\n    color: rgba(164, 202, 254, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-blue-400::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #76a9fa;\n    color: rgba(118, 169, 250, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-blue-400::placeholder {\n    --placeholder-opacity: 1;\n    color: #76a9fa;\n    color: rgba(118, 169, 250, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-blue-500::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #3f83f8;\n    color: rgba(63, 131, 248, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-blue-500::placeholder {\n    --placeholder-opacity: 1;\n    color: #3f83f8;\n    color: rgba(63, 131, 248, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-blue-600::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #1c64f2;\n    color: rgba(28, 100, 242, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-blue-600::placeholder {\n    --placeholder-opacity: 1;\n    color: #1c64f2;\n    color: rgba(28, 100, 242, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-blue-700::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #1a56db;\n    color: rgba(26, 86, 219, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-blue-700::placeholder {\n    --placeholder-opacity: 1;\n    color: #1a56db;\n    color: rgba(26, 86, 219, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-blue-800::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #1e429f;\n    color: rgba(30, 66, 159, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-blue-800::placeholder {\n    --placeholder-opacity: 1;\n    color: #1e429f;\n    color: rgba(30, 66, 159, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-blue-900::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #233876;\n    color: rgba(35, 56, 118, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-blue-900::placeholder {\n    --placeholder-opacity: 1;\n    color: #233876;\n    color: rgba(35, 56, 118, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-indigo-50::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #f0f5ff;\n    color: rgba(240, 245, 255, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-indigo-50::placeholder {\n    --placeholder-opacity: 1;\n    color: #f0f5ff;\n    color: rgba(240, 245, 255, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-indigo-100::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #e5edff;\n    color: rgba(229, 237, 255, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-indigo-100::placeholder {\n    --placeholder-opacity: 1;\n    color: #e5edff;\n    color: rgba(229, 237, 255, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-indigo-200::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #cddbfe;\n    color: rgba(205, 219, 254, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-indigo-200::placeholder {\n    --placeholder-opacity: 1;\n    color: #cddbfe;\n    color: rgba(205, 219, 254, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-indigo-300::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #b4c6fc;\n    color: rgba(180, 198, 252, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-indigo-300::placeholder {\n    --placeholder-opacity: 1;\n    color: #b4c6fc;\n    color: rgba(180, 198, 252, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-indigo-400::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #8da2fb;\n    color: rgba(141, 162, 251, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-indigo-400::placeholder {\n    --placeholder-opacity: 1;\n    color: #8da2fb;\n    color: rgba(141, 162, 251, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-indigo-500::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #6875f5;\n    color: rgba(104, 117, 245, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-indigo-500::placeholder {\n    --placeholder-opacity: 1;\n    color: #6875f5;\n    color: rgba(104, 117, 245, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-indigo-600::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #5850ec;\n    color: rgba(88, 80, 236, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-indigo-600::placeholder {\n    --placeholder-opacity: 1;\n    color: #5850ec;\n    color: rgba(88, 80, 236, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-indigo-700::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #5145cd;\n    color: rgba(81, 69, 205, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-indigo-700::placeholder {\n    --placeholder-opacity: 1;\n    color: #5145cd;\n    color: rgba(81, 69, 205, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-indigo-800::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #42389d;\n    color: rgba(66, 56, 157, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-indigo-800::placeholder {\n    --placeholder-opacity: 1;\n    color: #42389d;\n    color: rgba(66, 56, 157, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-indigo-900::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #362f78;\n    color: rgba(54, 47, 120, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-indigo-900::placeholder {\n    --placeholder-opacity: 1;\n    color: #362f78;\n    color: rgba(54, 47, 120, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-purple-50::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #f6f5ff;\n    color: rgba(246, 245, 255, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-purple-50::placeholder {\n    --placeholder-opacity: 1;\n    color: #f6f5ff;\n    color: rgba(246, 245, 255, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-purple-100::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #edebfe;\n    color: rgba(237, 235, 254, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-purple-100::placeholder {\n    --placeholder-opacity: 1;\n    color: #edebfe;\n    color: rgba(237, 235, 254, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-purple-200::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #dcd7fe;\n    color: rgba(220, 215, 254, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-purple-200::placeholder {\n    --placeholder-opacity: 1;\n    color: #dcd7fe;\n    color: rgba(220, 215, 254, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-purple-300::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #cabffd;\n    color: rgba(202, 191, 253, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-purple-300::placeholder {\n    --placeholder-opacity: 1;\n    color: #cabffd;\n    color: rgba(202, 191, 253, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-purple-400::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #ac94fa;\n    color: rgba(172, 148, 250, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-purple-400::placeholder {\n    --placeholder-opacity: 1;\n    color: #ac94fa;\n    color: rgba(172, 148, 250, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-purple-500::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #9061f9;\n    color: rgba(144, 97, 249, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-purple-500::placeholder {\n    --placeholder-opacity: 1;\n    color: #9061f9;\n    color: rgba(144, 97, 249, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-purple-600::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #7e3af2;\n    color: rgba(126, 58, 242, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-purple-600::placeholder {\n    --placeholder-opacity: 1;\n    color: #7e3af2;\n    color: rgba(126, 58, 242, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-purple-700::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #6c2bd9;\n    color: rgba(108, 43, 217, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-purple-700::placeholder {\n    --placeholder-opacity: 1;\n    color: #6c2bd9;\n    color: rgba(108, 43, 217, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-purple-800::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #5521b5;\n    color: rgba(85, 33, 181, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-purple-800::placeholder {\n    --placeholder-opacity: 1;\n    color: #5521b5;\n    color: rgba(85, 33, 181, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-purple-900::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #4a1d96;\n    color: rgba(74, 29, 150, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-purple-900::placeholder {\n    --placeholder-opacity: 1;\n    color: #4a1d96;\n    color: rgba(74, 29, 150, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-pink-50::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #fdf2f8;\n    color: rgba(253, 242, 248, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-pink-50::placeholder {\n    --placeholder-opacity: 1;\n    color: #fdf2f8;\n    color: rgba(253, 242, 248, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-pink-100::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #fce8f3;\n    color: rgba(252, 232, 243, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-pink-100::placeholder {\n    --placeholder-opacity: 1;\n    color: #fce8f3;\n    color: rgba(252, 232, 243, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-pink-200::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #fad1e8;\n    color: rgba(250, 209, 232, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-pink-200::placeholder {\n    --placeholder-opacity: 1;\n    color: #fad1e8;\n    color: rgba(250, 209, 232, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-pink-300::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #f8b4d9;\n    color: rgba(248, 180, 217, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-pink-300::placeholder {\n    --placeholder-opacity: 1;\n    color: #f8b4d9;\n    color: rgba(248, 180, 217, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-pink-400::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #f17eb8;\n    color: rgba(241, 126, 184, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-pink-400::placeholder {\n    --placeholder-opacity: 1;\n    color: #f17eb8;\n    color: rgba(241, 126, 184, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-pink-500::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #e74694;\n    color: rgba(231, 70, 148, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-pink-500::placeholder {\n    --placeholder-opacity: 1;\n    color: #e74694;\n    color: rgba(231, 70, 148, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-pink-600::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #d61f69;\n    color: rgba(214, 31, 105, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-pink-600::placeholder {\n    --placeholder-opacity: 1;\n    color: #d61f69;\n    color: rgba(214, 31, 105, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-pink-700::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #bf125d;\n    color: rgba(191, 18, 93, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-pink-700::placeholder {\n    --placeholder-opacity: 1;\n    color: #bf125d;\n    color: rgba(191, 18, 93, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-pink-800::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #99154b;\n    color: rgba(153, 21, 75, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-pink-800::placeholder {\n    --placeholder-opacity: 1;\n    color: #99154b;\n    color: rgba(153, 21, 75, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-pink-900::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #751a3d;\n    color: rgba(117, 26, 61, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-pink-900::placeholder {\n    --placeholder-opacity: 1;\n    color: #751a3d;\n    color: rgba(117, 26, 61, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-cool-gray-50::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #f8fafc;\n    color: rgba(248, 250, 252, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-cool-gray-50::placeholder {\n    --placeholder-opacity: 1;\n    color: #f8fafc;\n    color: rgba(248, 250, 252, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-cool-gray-100::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #f1f5f9;\n    color: rgba(241, 245, 249, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-cool-gray-100::placeholder {\n    --placeholder-opacity: 1;\n    color: #f1f5f9;\n    color: rgba(241, 245, 249, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-cool-gray-200::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #e2e8f0;\n    color: rgba(226, 232, 240, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-cool-gray-200::placeholder {\n    --placeholder-opacity: 1;\n    color: #e2e8f0;\n    color: rgba(226, 232, 240, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-cool-gray-300::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #cfd8e3;\n    color: rgba(207, 216, 227, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-cool-gray-300::placeholder {\n    --placeholder-opacity: 1;\n    color: #cfd8e3;\n    color: rgba(207, 216, 227, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-cool-gray-400::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #97a6ba;\n    color: rgba(151, 166, 186, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-cool-gray-400::placeholder {\n    --placeholder-opacity: 1;\n    color: #97a6ba;\n    color: rgba(151, 166, 186, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-cool-gray-500::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #64748b;\n    color: rgba(100, 116, 139, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-cool-gray-500::placeholder {\n    --placeholder-opacity: 1;\n    color: #64748b;\n    color: rgba(100, 116, 139, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-cool-gray-600::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #475569;\n    color: rgba(71, 85, 105, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-cool-gray-600::placeholder {\n    --placeholder-opacity: 1;\n    color: #475569;\n    color: rgba(71, 85, 105, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-cool-gray-700::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #364152;\n    color: rgba(54, 65, 82, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-cool-gray-700::placeholder {\n    --placeholder-opacity: 1;\n    color: #364152;\n    color: rgba(54, 65, 82, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-cool-gray-800::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #27303f;\n    color: rgba(39, 48, 63, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-cool-gray-800::placeholder {\n    --placeholder-opacity: 1;\n    color: #27303f;\n    color: rgba(39, 48, 63, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-cool-gray-900::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #1a202e;\n    color: rgba(26, 32, 46, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-cool-gray-900::placeholder {\n    --placeholder-opacity: 1;\n    color: #1a202e;\n    color: rgba(26, 32, 46, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-current:focus::-moz-placeholder {\n    color: currentColor;\n  }\n  .md\\:focus\\:placeholder-current:focus::placeholder {\n    color: currentColor;\n  }\n  .md\\:focus\\:placeholder-transparent:focus::-moz-placeholder {\n    color: transparent;\n  }\n  .md\\:focus\\:placeholder-transparent:focus::placeholder {\n    color: transparent;\n  }\n  .md\\:focus\\:placeholder-white:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #ffffff;\n    color: rgba(255, 255, 255, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-white:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #ffffff;\n    color: rgba(255, 255, 255, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-black:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #000000;\n    color: rgba(0, 0, 0, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-black:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #000000;\n    color: rgba(0, 0, 0, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-gray-50:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #f9fafb;\n    color: rgba(249, 250, 251, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-gray-50:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #f9fafb;\n    color: rgba(249, 250, 251, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-gray-100:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #f4f5f7;\n    color: rgba(244, 245, 247, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-gray-100:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #f4f5f7;\n    color: rgba(244, 245, 247, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-gray-200:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #e5e7eb;\n    color: rgba(229, 231, 235, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-gray-200:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #e5e7eb;\n    color: rgba(229, 231, 235, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-gray-300:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #d2d6dc;\n    color: rgba(210, 214, 220, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-gray-300:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #d2d6dc;\n    color: rgba(210, 214, 220, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-gray-400:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #9fa6b2;\n    color: rgba(159, 166, 178, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-gray-400:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #9fa6b2;\n    color: rgba(159, 166, 178, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-gray-500:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #6b7280;\n    color: rgba(107, 114, 128, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-gray-500:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #6b7280;\n    color: rgba(107, 114, 128, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-gray-600:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #4b5563;\n    color: rgba(75, 85, 99, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-gray-600:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #4b5563;\n    color: rgba(75, 85, 99, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-gray-700:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #374151;\n    color: rgba(55, 65, 81, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-gray-700:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #374151;\n    color: rgba(55, 65, 81, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-gray-800:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #252f3f;\n    color: rgba(37, 47, 63, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-gray-800:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #252f3f;\n    color: rgba(37, 47, 63, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-gray-900:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #161e2e;\n    color: rgba(22, 30, 46, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-gray-900:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #161e2e;\n    color: rgba(22, 30, 46, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-red-50:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #fdf2f2;\n    color: rgba(253, 242, 242, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-red-50:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #fdf2f2;\n    color: rgba(253, 242, 242, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-red-100:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #fde8e8;\n    color: rgba(253, 232, 232, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-red-100:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #fde8e8;\n    color: rgba(253, 232, 232, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-red-200:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #fbd5d5;\n    color: rgba(251, 213, 213, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-red-200:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #fbd5d5;\n    color: rgba(251, 213, 213, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-red-300:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #f8b4b4;\n    color: rgba(248, 180, 180, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-red-300:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #f8b4b4;\n    color: rgba(248, 180, 180, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-red-400:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #f98080;\n    color: rgba(249, 128, 128, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-red-400:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #f98080;\n    color: rgba(249, 128, 128, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-red-500:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #f05252;\n    color: rgba(240, 82, 82, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-red-500:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #f05252;\n    color: rgba(240, 82, 82, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-red-600:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #e02424;\n    color: rgba(224, 36, 36, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-red-600:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #e02424;\n    color: rgba(224, 36, 36, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-red-700:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #c81e1e;\n    color: rgba(200, 30, 30, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-red-700:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #c81e1e;\n    color: rgba(200, 30, 30, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-red-800:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #9b1c1c;\n    color: rgba(155, 28, 28, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-red-800:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #9b1c1c;\n    color: rgba(155, 28, 28, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-red-900:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #771d1d;\n    color: rgba(119, 29, 29, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-red-900:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #771d1d;\n    color: rgba(119, 29, 29, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-orange-50:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #fff8f1;\n    color: rgba(255, 248, 241, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-orange-50:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #fff8f1;\n    color: rgba(255, 248, 241, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-orange-100:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #feecdc;\n    color: rgba(254, 236, 220, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-orange-100:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #feecdc;\n    color: rgba(254, 236, 220, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-orange-200:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #fcd9bd;\n    color: rgba(252, 217, 189, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-orange-200:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #fcd9bd;\n    color: rgba(252, 217, 189, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-orange-300:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #fdba8c;\n    color: rgba(253, 186, 140, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-orange-300:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #fdba8c;\n    color: rgba(253, 186, 140, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-orange-400:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #ff8a4c;\n    color: rgba(255, 138, 76, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-orange-400:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #ff8a4c;\n    color: rgba(255, 138, 76, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-orange-500:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #ff5a1f;\n    color: rgba(255, 90, 31, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-orange-500:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #ff5a1f;\n    color: rgba(255, 90, 31, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-orange-600:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #d03801;\n    color: rgba(208, 56, 1, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-orange-600:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #d03801;\n    color: rgba(208, 56, 1, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-orange-700:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #b43403;\n    color: rgba(180, 52, 3, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-orange-700:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #b43403;\n    color: rgba(180, 52, 3, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-orange-800:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #8a2c0d;\n    color: rgba(138, 44, 13, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-orange-800:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #8a2c0d;\n    color: rgba(138, 44, 13, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-orange-900:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #73230d;\n    color: rgba(115, 35, 13, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-orange-900:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #73230d;\n    color: rgba(115, 35, 13, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-yellow-50:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #fdfdea;\n    color: rgba(253, 253, 234, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-yellow-50:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #fdfdea;\n    color: rgba(253, 253, 234, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-yellow-100:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #fdf6b2;\n    color: rgba(253, 246, 178, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-yellow-100:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #fdf6b2;\n    color: rgba(253, 246, 178, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-yellow-200:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #fce96a;\n    color: rgba(252, 233, 106, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-yellow-200:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #fce96a;\n    color: rgba(252, 233, 106, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-yellow-300:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #faca15;\n    color: rgba(250, 202, 21, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-yellow-300:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #faca15;\n    color: rgba(250, 202, 21, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-yellow-400:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #e3a008;\n    color: rgba(227, 160, 8, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-yellow-400:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #e3a008;\n    color: rgba(227, 160, 8, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-yellow-500:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #c27803;\n    color: rgba(194, 120, 3, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-yellow-500:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #c27803;\n    color: rgba(194, 120, 3, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-yellow-600:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #9f580a;\n    color: rgba(159, 88, 10, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-yellow-600:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #9f580a;\n    color: rgba(159, 88, 10, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-yellow-700:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #8e4b10;\n    color: rgba(142, 75, 16, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-yellow-700:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #8e4b10;\n    color: rgba(142, 75, 16, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-yellow-800:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #723b13;\n    color: rgba(114, 59, 19, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-yellow-800:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #723b13;\n    color: rgba(114, 59, 19, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-yellow-900:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #633112;\n    color: rgba(99, 49, 18, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-yellow-900:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #633112;\n    color: rgba(99, 49, 18, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-green-50:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #f3faf7;\n    color: rgba(243, 250, 247, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-green-50:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #f3faf7;\n    color: rgba(243, 250, 247, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-green-100:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #def7ec;\n    color: rgba(222, 247, 236, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-green-100:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #def7ec;\n    color: rgba(222, 247, 236, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-green-200:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #bcf0da;\n    color: rgba(188, 240, 218, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-green-200:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #bcf0da;\n    color: rgba(188, 240, 218, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-green-300:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #84e1bc;\n    color: rgba(132, 225, 188, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-green-300:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #84e1bc;\n    color: rgba(132, 225, 188, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-green-400:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #31c48d;\n    color: rgba(49, 196, 141, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-green-400:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #31c48d;\n    color: rgba(49, 196, 141, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-green-500:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #0e9f6e;\n    color: rgba(14, 159, 110, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-green-500:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #0e9f6e;\n    color: rgba(14, 159, 110, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-green-600:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #057a55;\n    color: rgba(5, 122, 85, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-green-600:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #057a55;\n    color: rgba(5, 122, 85, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-green-700:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #046c4e;\n    color: rgba(4, 108, 78, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-green-700:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #046c4e;\n    color: rgba(4, 108, 78, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-green-800:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #03543f;\n    color: rgba(3, 84, 63, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-green-800:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #03543f;\n    color: rgba(3, 84, 63, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-green-900:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #014737;\n    color: rgba(1, 71, 55, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-green-900:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #014737;\n    color: rgba(1, 71, 55, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-teal-50:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #edfafa;\n    color: rgba(237, 250, 250, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-teal-50:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #edfafa;\n    color: rgba(237, 250, 250, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-teal-100:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #d5f5f6;\n    color: rgba(213, 245, 246, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-teal-100:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #d5f5f6;\n    color: rgba(213, 245, 246, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-teal-200:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #afecef;\n    color: rgba(175, 236, 239, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-teal-200:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #afecef;\n    color: rgba(175, 236, 239, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-teal-300:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #7edce2;\n    color: rgba(126, 220, 226, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-teal-300:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #7edce2;\n    color: rgba(126, 220, 226, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-teal-400:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #16bdca;\n    color: rgba(22, 189, 202, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-teal-400:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #16bdca;\n    color: rgba(22, 189, 202, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-teal-500:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #0694a2;\n    color: rgba(6, 148, 162, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-teal-500:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #0694a2;\n    color: rgba(6, 148, 162, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-teal-600:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #047481;\n    color: rgba(4, 116, 129, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-teal-600:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #047481;\n    color: rgba(4, 116, 129, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-teal-700:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #036672;\n    color: rgba(3, 102, 114, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-teal-700:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #036672;\n    color: rgba(3, 102, 114, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-teal-800:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #05505c;\n    color: rgba(5, 80, 92, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-teal-800:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #05505c;\n    color: rgba(5, 80, 92, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-teal-900:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #014451;\n    color: rgba(1, 68, 81, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-teal-900:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #014451;\n    color: rgba(1, 68, 81, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-blue-50:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #ebf5ff;\n    color: rgba(235, 245, 255, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-blue-50:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #ebf5ff;\n    color: rgba(235, 245, 255, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-blue-100:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #e1effe;\n    color: rgba(225, 239, 254, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-blue-100:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #e1effe;\n    color: rgba(225, 239, 254, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-blue-200:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #c3ddfd;\n    color: rgba(195, 221, 253, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-blue-200:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #c3ddfd;\n    color: rgba(195, 221, 253, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-blue-300:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #a4cafe;\n    color: rgba(164, 202, 254, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-blue-300:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #a4cafe;\n    color: rgba(164, 202, 254, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-blue-400:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #76a9fa;\n    color: rgba(118, 169, 250, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-blue-400:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #76a9fa;\n    color: rgba(118, 169, 250, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-blue-500:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #3f83f8;\n    color: rgba(63, 131, 248, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-blue-500:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #3f83f8;\n    color: rgba(63, 131, 248, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-blue-600:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #1c64f2;\n    color: rgba(28, 100, 242, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-blue-600:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #1c64f2;\n    color: rgba(28, 100, 242, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-blue-700:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #1a56db;\n    color: rgba(26, 86, 219, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-blue-700:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #1a56db;\n    color: rgba(26, 86, 219, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-blue-800:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #1e429f;\n    color: rgba(30, 66, 159, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-blue-800:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #1e429f;\n    color: rgba(30, 66, 159, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-blue-900:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #233876;\n    color: rgba(35, 56, 118, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-blue-900:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #233876;\n    color: rgba(35, 56, 118, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-indigo-50:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #f0f5ff;\n    color: rgba(240, 245, 255, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-indigo-50:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #f0f5ff;\n    color: rgba(240, 245, 255, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-indigo-100:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #e5edff;\n    color: rgba(229, 237, 255, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-indigo-100:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #e5edff;\n    color: rgba(229, 237, 255, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-indigo-200:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #cddbfe;\n    color: rgba(205, 219, 254, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-indigo-200:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #cddbfe;\n    color: rgba(205, 219, 254, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-indigo-300:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #b4c6fc;\n    color: rgba(180, 198, 252, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-indigo-300:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #b4c6fc;\n    color: rgba(180, 198, 252, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-indigo-400:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #8da2fb;\n    color: rgba(141, 162, 251, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-indigo-400:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #8da2fb;\n    color: rgba(141, 162, 251, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-indigo-500:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #6875f5;\n    color: rgba(104, 117, 245, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-indigo-500:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #6875f5;\n    color: rgba(104, 117, 245, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-indigo-600:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #5850ec;\n    color: rgba(88, 80, 236, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-indigo-600:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #5850ec;\n    color: rgba(88, 80, 236, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-indigo-700:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #5145cd;\n    color: rgba(81, 69, 205, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-indigo-700:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #5145cd;\n    color: rgba(81, 69, 205, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-indigo-800:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #42389d;\n    color: rgba(66, 56, 157, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-indigo-800:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #42389d;\n    color: rgba(66, 56, 157, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-indigo-900:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #362f78;\n    color: rgba(54, 47, 120, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-indigo-900:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #362f78;\n    color: rgba(54, 47, 120, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-purple-50:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #f6f5ff;\n    color: rgba(246, 245, 255, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-purple-50:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #f6f5ff;\n    color: rgba(246, 245, 255, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-purple-100:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #edebfe;\n    color: rgba(237, 235, 254, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-purple-100:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #edebfe;\n    color: rgba(237, 235, 254, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-purple-200:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #dcd7fe;\n    color: rgba(220, 215, 254, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-purple-200:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #dcd7fe;\n    color: rgba(220, 215, 254, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-purple-300:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #cabffd;\n    color: rgba(202, 191, 253, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-purple-300:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #cabffd;\n    color: rgba(202, 191, 253, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-purple-400:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #ac94fa;\n    color: rgba(172, 148, 250, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-purple-400:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #ac94fa;\n    color: rgba(172, 148, 250, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-purple-500:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #9061f9;\n    color: rgba(144, 97, 249, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-purple-500:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #9061f9;\n    color: rgba(144, 97, 249, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-purple-600:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #7e3af2;\n    color: rgba(126, 58, 242, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-purple-600:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #7e3af2;\n    color: rgba(126, 58, 242, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-purple-700:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #6c2bd9;\n    color: rgba(108, 43, 217, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-purple-700:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #6c2bd9;\n    color: rgba(108, 43, 217, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-purple-800:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #5521b5;\n    color: rgba(85, 33, 181, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-purple-800:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #5521b5;\n    color: rgba(85, 33, 181, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-purple-900:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #4a1d96;\n    color: rgba(74, 29, 150, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-purple-900:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #4a1d96;\n    color: rgba(74, 29, 150, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-pink-50:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #fdf2f8;\n    color: rgba(253, 242, 248, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-pink-50:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #fdf2f8;\n    color: rgba(253, 242, 248, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-pink-100:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #fce8f3;\n    color: rgba(252, 232, 243, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-pink-100:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #fce8f3;\n    color: rgba(252, 232, 243, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-pink-200:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #fad1e8;\n    color: rgba(250, 209, 232, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-pink-200:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #fad1e8;\n    color: rgba(250, 209, 232, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-pink-300:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #f8b4d9;\n    color: rgba(248, 180, 217, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-pink-300:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #f8b4d9;\n    color: rgba(248, 180, 217, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-pink-400:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #f17eb8;\n    color: rgba(241, 126, 184, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-pink-400:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #f17eb8;\n    color: rgba(241, 126, 184, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-pink-500:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #e74694;\n    color: rgba(231, 70, 148, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-pink-500:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #e74694;\n    color: rgba(231, 70, 148, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-pink-600:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #d61f69;\n    color: rgba(214, 31, 105, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-pink-600:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #d61f69;\n    color: rgba(214, 31, 105, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-pink-700:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #bf125d;\n    color: rgba(191, 18, 93, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-pink-700:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #bf125d;\n    color: rgba(191, 18, 93, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-pink-800:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #99154b;\n    color: rgba(153, 21, 75, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-pink-800:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #99154b;\n    color: rgba(153, 21, 75, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-pink-900:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #751a3d;\n    color: rgba(117, 26, 61, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-pink-900:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #751a3d;\n    color: rgba(117, 26, 61, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-cool-gray-50:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #f8fafc;\n    color: rgba(248, 250, 252, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-cool-gray-50:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #f8fafc;\n    color: rgba(248, 250, 252, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-cool-gray-100:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #f1f5f9;\n    color: rgba(241, 245, 249, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-cool-gray-100:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #f1f5f9;\n    color: rgba(241, 245, 249, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-cool-gray-200:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #e2e8f0;\n    color: rgba(226, 232, 240, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-cool-gray-200:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #e2e8f0;\n    color: rgba(226, 232, 240, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-cool-gray-300:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #cfd8e3;\n    color: rgba(207, 216, 227, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-cool-gray-300:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #cfd8e3;\n    color: rgba(207, 216, 227, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-cool-gray-400:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #97a6ba;\n    color: rgba(151, 166, 186, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-cool-gray-400:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #97a6ba;\n    color: rgba(151, 166, 186, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-cool-gray-500:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #64748b;\n    color: rgba(100, 116, 139, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-cool-gray-500:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #64748b;\n    color: rgba(100, 116, 139, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-cool-gray-600:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #475569;\n    color: rgba(71, 85, 105, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-cool-gray-600:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #475569;\n    color: rgba(71, 85, 105, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-cool-gray-700:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #364152;\n    color: rgba(54, 65, 82, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-cool-gray-700:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #364152;\n    color: rgba(54, 65, 82, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-cool-gray-800:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #27303f;\n    color: rgba(39, 48, 63, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-cool-gray-800:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #27303f;\n    color: rgba(39, 48, 63, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-cool-gray-900:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #1a202e;\n    color: rgba(26, 32, 46, var(--placeholder-opacity));\n  }\n  .md\\:focus\\:placeholder-cool-gray-900:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #1a202e;\n    color: rgba(26, 32, 46, var(--placeholder-opacity));\n  }\n  .md\\:placeholder-opacity-0::-moz-placeholder {\n    --placeholder-opacity: 0;\n  }\n  .md\\:placeholder-opacity-0::placeholder {\n    --placeholder-opacity: 0;\n  }\n  .md\\:placeholder-opacity-25::-moz-placeholder {\n    --placeholder-opacity: 0.25;\n  }\n  .md\\:placeholder-opacity-25::placeholder {\n    --placeholder-opacity: 0.25;\n  }\n  .md\\:placeholder-opacity-50::-moz-placeholder {\n    --placeholder-opacity: 0.5;\n  }\n  .md\\:placeholder-opacity-50::placeholder {\n    --placeholder-opacity: 0.5;\n  }\n  .md\\:placeholder-opacity-75::-moz-placeholder {\n    --placeholder-opacity: 0.75;\n  }\n  .md\\:placeholder-opacity-75::placeholder {\n    --placeholder-opacity: 0.75;\n  }\n  .md\\:placeholder-opacity-100::-moz-placeholder {\n    --placeholder-opacity: 1;\n  }\n  .md\\:placeholder-opacity-100::placeholder {\n    --placeholder-opacity: 1;\n  }\n  .md\\:focus\\:placeholder-opacity-0:focus::-moz-placeholder {\n    --placeholder-opacity: 0;\n  }\n  .md\\:focus\\:placeholder-opacity-0:focus::placeholder {\n    --placeholder-opacity: 0;\n  }\n  .md\\:focus\\:placeholder-opacity-25:focus::-moz-placeholder {\n    --placeholder-opacity: 0.25;\n  }\n  .md\\:focus\\:placeholder-opacity-25:focus::placeholder {\n    --placeholder-opacity: 0.25;\n  }\n  .md\\:focus\\:placeholder-opacity-50:focus::-moz-placeholder {\n    --placeholder-opacity: 0.5;\n  }\n  .md\\:focus\\:placeholder-opacity-50:focus::placeholder {\n    --placeholder-opacity: 0.5;\n  }\n  .md\\:focus\\:placeholder-opacity-75:focus::-moz-placeholder {\n    --placeholder-opacity: 0.75;\n  }\n  .md\\:focus\\:placeholder-opacity-75:focus::placeholder {\n    --placeholder-opacity: 0.75;\n  }\n  .md\\:focus\\:placeholder-opacity-100:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n  }\n  .md\\:focus\\:placeholder-opacity-100:focus::placeholder {\n    --placeholder-opacity: 1;\n  }\n  .md\\:pointer-events-none {\n    pointer-events: none;\n  }\n  .md\\:pointer-events-auto {\n    pointer-events: auto;\n  }\n  .md\\:static {\n    position: static;\n  }\n  .md\\:fixed {\n    position: fixed;\n  }\n  .md\\:absolute {\n    position: absolute;\n  }\n  .md\\:relative {\n    position: relative;\n  }\n  .md\\:sticky {\n    position: sticky;\n  }\n  .md\\:inset-0 {\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n  }\n  .md\\:inset-1 {\n    top: 0.25rem;\n    right: 0.25rem;\n    bottom: 0.25rem;\n    left: 0.25rem;\n  }\n  .md\\:inset-2 {\n    top: 0.5rem;\n    right: 0.5rem;\n    bottom: 0.5rem;\n    left: 0.5rem;\n  }\n  .md\\:inset-3 {\n    top: 0.75rem;\n    right: 0.75rem;\n    bottom: 0.75rem;\n    left: 0.75rem;\n  }\n  .md\\:inset-4 {\n    top: 1rem;\n    right: 1rem;\n    bottom: 1rem;\n    left: 1rem;\n  }\n  .md\\:inset-5 {\n    top: 1.25rem;\n    right: 1.25rem;\n    bottom: 1.25rem;\n    left: 1.25rem;\n  }\n  .md\\:inset-6 {\n    top: 1.5rem;\n    right: 1.5rem;\n    bottom: 1.5rem;\n    left: 1.5rem;\n  }\n  .md\\:inset-7 {\n    top: 1.75rem;\n    right: 1.75rem;\n    bottom: 1.75rem;\n    left: 1.75rem;\n  }\n  .md\\:inset-8 {\n    top: 2rem;\n    right: 2rem;\n    bottom: 2rem;\n    left: 2rem;\n  }\n  .md\\:inset-9 {\n    top: 2.25rem;\n    right: 2.25rem;\n    bottom: 2.25rem;\n    left: 2.25rem;\n  }\n  .md\\:inset-10 {\n    top: 2.5rem;\n    right: 2.5rem;\n    bottom: 2.5rem;\n    left: 2.5rem;\n  }\n  .md\\:inset-11 {\n    top: 2.75rem;\n    right: 2.75rem;\n    bottom: 2.75rem;\n    left: 2.75rem;\n  }\n  .md\\:inset-12 {\n    top: 3rem;\n    right: 3rem;\n    bottom: 3rem;\n    left: 3rem;\n  }\n  .md\\:inset-13 {\n    top: 3.25rem;\n    right: 3.25rem;\n    bottom: 3.25rem;\n    left: 3.25rem;\n  }\n  .md\\:inset-14 {\n    top: 3.5rem;\n    right: 3.5rem;\n    bottom: 3.5rem;\n    left: 3.5rem;\n  }\n  .md\\:inset-15 {\n    top: 3.75rem;\n    right: 3.75rem;\n    bottom: 3.75rem;\n    left: 3.75rem;\n  }\n  .md\\:inset-16 {\n    top: 4rem;\n    right: 4rem;\n    bottom: 4rem;\n    left: 4rem;\n  }\n  .md\\:inset-20 {\n    top: 5rem;\n    right: 5rem;\n    bottom: 5rem;\n    left: 5rem;\n  }\n  .md\\:inset-24 {\n    top: 6rem;\n    right: 6rem;\n    bottom: 6rem;\n    left: 6rem;\n  }\n  .md\\:inset-28 {\n    top: 7rem;\n    right: 7rem;\n    bottom: 7rem;\n    left: 7rem;\n  }\n  .md\\:inset-32 {\n    top: 8rem;\n    right: 8rem;\n    bottom: 8rem;\n    left: 8rem;\n  }\n  .md\\:inset-36 {\n    top: 9rem;\n    right: 9rem;\n    bottom: 9rem;\n    left: 9rem;\n  }\n  .md\\:inset-40 {\n    top: 10rem;\n    right: 10rem;\n    bottom: 10rem;\n    left: 10rem;\n  }\n  .md\\:inset-44 {\n    top: 11rem;\n    right: 11rem;\n    bottom: 11rem;\n    left: 11rem;\n  }\n  .md\\:inset-48 {\n    top: 12rem;\n    right: 12rem;\n    bottom: 12rem;\n    left: 12rem;\n  }\n  .md\\:inset-52 {\n    top: 13rem;\n    right: 13rem;\n    bottom: 13rem;\n    left: 13rem;\n  }\n  .md\\:inset-56 {\n    top: 14rem;\n    right: 14rem;\n    bottom: 14rem;\n    left: 14rem;\n  }\n  .md\\:inset-60 {\n    top: 15rem;\n    right: 15rem;\n    bottom: 15rem;\n    left: 15rem;\n  }\n  .md\\:inset-64 {\n    top: 16rem;\n    right: 16rem;\n    bottom: 16rem;\n    left: 16rem;\n  }\n  .md\\:inset-72 {\n    top: 18rem;\n    right: 18rem;\n    bottom: 18rem;\n    left: 18rem;\n  }\n  .md\\:inset-80 {\n    top: 20rem;\n    right: 20rem;\n    bottom: 20rem;\n    left: 20rem;\n  }\n  .md\\:inset-96 {\n    top: 24rem;\n    right: 24rem;\n    bottom: 24rem;\n    left: 24rem;\n  }\n  .md\\:inset-auto {\n    top: auto;\n    right: auto;\n    bottom: auto;\n    left: auto;\n  }\n  .md\\:inset-px {\n    top: 1px;\n    right: 1px;\n    bottom: 1px;\n    left: 1px;\n  }\n  .md\\:inset-0\\.5 {\n    top: 0.125rem;\n    right: 0.125rem;\n    bottom: 0.125rem;\n    left: 0.125rem;\n  }\n  .md\\:inset-1\\.5 {\n    top: 0.375rem;\n    right: 0.375rem;\n    bottom: 0.375rem;\n    left: 0.375rem;\n  }\n  .md\\:inset-2\\.5 {\n    top: 0.625rem;\n    right: 0.625rem;\n    bottom: 0.625rem;\n    left: 0.625rem;\n  }\n  .md\\:inset-3\\.5 {\n    top: 0.875rem;\n    right: 0.875rem;\n    bottom: 0.875rem;\n    left: 0.875rem;\n  }\n  .md\\:inset-1\\/2 {\n    top: 50%;\n    right: 50%;\n    bottom: 50%;\n    left: 50%;\n  }\n  .md\\:inset-1\\/3 {\n    top: 33.333333%;\n    right: 33.333333%;\n    bottom: 33.333333%;\n    left: 33.333333%;\n  }\n  .md\\:inset-2\\/3 {\n    top: 66.666667%;\n    right: 66.666667%;\n    bottom: 66.666667%;\n    left: 66.666667%;\n  }\n  .md\\:inset-1\\/4 {\n    top: 25%;\n    right: 25%;\n    bottom: 25%;\n    left: 25%;\n  }\n  .md\\:inset-2\\/4 {\n    top: 50%;\n    right: 50%;\n    bottom: 50%;\n    left: 50%;\n  }\n  .md\\:inset-3\\/4 {\n    top: 75%;\n    right: 75%;\n    bottom: 75%;\n    left: 75%;\n  }\n  .md\\:inset-1\\/5 {\n    top: 20%;\n    right: 20%;\n    bottom: 20%;\n    left: 20%;\n  }\n  .md\\:inset-2\\/5 {\n    top: 40%;\n    right: 40%;\n    bottom: 40%;\n    left: 40%;\n  }\n  .md\\:inset-3\\/5 {\n    top: 60%;\n    right: 60%;\n    bottom: 60%;\n    left: 60%;\n  }\n  .md\\:inset-4\\/5 {\n    top: 80%;\n    right: 80%;\n    bottom: 80%;\n    left: 80%;\n  }\n  .md\\:inset-1\\/6 {\n    top: 16.666667%;\n    right: 16.666667%;\n    bottom: 16.666667%;\n    left: 16.666667%;\n  }\n  .md\\:inset-2\\/6 {\n    top: 33.333333%;\n    right: 33.333333%;\n    bottom: 33.333333%;\n    left: 33.333333%;\n  }\n  .md\\:inset-3\\/6 {\n    top: 50%;\n    right: 50%;\n    bottom: 50%;\n    left: 50%;\n  }\n  .md\\:inset-4\\/6 {\n    top: 66.666667%;\n    right: 66.666667%;\n    bottom: 66.666667%;\n    left: 66.666667%;\n  }\n  .md\\:inset-5\\/6 {\n    top: 83.333333%;\n    right: 83.333333%;\n    bottom: 83.333333%;\n    left: 83.333333%;\n  }\n  .md\\:inset-1\\/12 {\n    top: 8.333333%;\n    right: 8.333333%;\n    bottom: 8.333333%;\n    left: 8.333333%;\n  }\n  .md\\:inset-2\\/12 {\n    top: 16.666667%;\n    right: 16.666667%;\n    bottom: 16.666667%;\n    left: 16.666667%;\n  }\n  .md\\:inset-3\\/12 {\n    top: 25%;\n    right: 25%;\n    bottom: 25%;\n    left: 25%;\n  }\n  .md\\:inset-4\\/12 {\n    top: 33.333333%;\n    right: 33.333333%;\n    bottom: 33.333333%;\n    left: 33.333333%;\n  }\n  .md\\:inset-5\\/12 {\n    top: 41.666667%;\n    right: 41.666667%;\n    bottom: 41.666667%;\n    left: 41.666667%;\n  }\n  .md\\:inset-6\\/12 {\n    top: 50%;\n    right: 50%;\n    bottom: 50%;\n    left: 50%;\n  }\n  .md\\:inset-7\\/12 {\n    top: 58.333333%;\n    right: 58.333333%;\n    bottom: 58.333333%;\n    left: 58.333333%;\n  }\n  .md\\:inset-8\\/12 {\n    top: 66.666667%;\n    right: 66.666667%;\n    bottom: 66.666667%;\n    left: 66.666667%;\n  }\n  .md\\:inset-9\\/12 {\n    top: 75%;\n    right: 75%;\n    bottom: 75%;\n    left: 75%;\n  }\n  .md\\:inset-10\\/12 {\n    top: 83.333333%;\n    right: 83.333333%;\n    bottom: 83.333333%;\n    left: 83.333333%;\n  }\n  .md\\:inset-11\\/12 {\n    top: 91.666667%;\n    right: 91.666667%;\n    bottom: 91.666667%;\n    left: 91.666667%;\n  }\n  .md\\:inset-full {\n    top: 100%;\n    right: 100%;\n    bottom: 100%;\n    left: 100%;\n  }\n  .md\\:inset-y-0 {\n    top: 0;\n    bottom: 0;\n  }\n  .md\\:inset-x-0 {\n    right: 0;\n    left: 0;\n  }\n  .md\\:inset-y-1 {\n    top: 0.25rem;\n    bottom: 0.25rem;\n  }\n  .md\\:inset-x-1 {\n    right: 0.25rem;\n    left: 0.25rem;\n  }\n  .md\\:inset-y-2 {\n    top: 0.5rem;\n    bottom: 0.5rem;\n  }\n  .md\\:inset-x-2 {\n    right: 0.5rem;\n    left: 0.5rem;\n  }\n  .md\\:inset-y-3 {\n    top: 0.75rem;\n    bottom: 0.75rem;\n  }\n  .md\\:inset-x-3 {\n    right: 0.75rem;\n    left: 0.75rem;\n  }\n  .md\\:inset-y-4 {\n    top: 1rem;\n    bottom: 1rem;\n  }\n  .md\\:inset-x-4 {\n    right: 1rem;\n    left: 1rem;\n  }\n  .md\\:inset-y-5 {\n    top: 1.25rem;\n    bottom: 1.25rem;\n  }\n  .md\\:inset-x-5 {\n    right: 1.25rem;\n    left: 1.25rem;\n  }\n  .md\\:inset-y-6 {\n    top: 1.5rem;\n    bottom: 1.5rem;\n  }\n  .md\\:inset-x-6 {\n    right: 1.5rem;\n    left: 1.5rem;\n  }\n  .md\\:inset-y-7 {\n    top: 1.75rem;\n    bottom: 1.75rem;\n  }\n  .md\\:inset-x-7 {\n    right: 1.75rem;\n    left: 1.75rem;\n  }\n  .md\\:inset-y-8 {\n    top: 2rem;\n    bottom: 2rem;\n  }\n  .md\\:inset-x-8 {\n    right: 2rem;\n    left: 2rem;\n  }\n  .md\\:inset-y-9 {\n    top: 2.25rem;\n    bottom: 2.25rem;\n  }\n  .md\\:inset-x-9 {\n    right: 2.25rem;\n    left: 2.25rem;\n  }\n  .md\\:inset-y-10 {\n    top: 2.5rem;\n    bottom: 2.5rem;\n  }\n  .md\\:inset-x-10 {\n    right: 2.5rem;\n    left: 2.5rem;\n  }\n  .md\\:inset-y-11 {\n    top: 2.75rem;\n    bottom: 2.75rem;\n  }\n  .md\\:inset-x-11 {\n    right: 2.75rem;\n    left: 2.75rem;\n  }\n  .md\\:inset-y-12 {\n    top: 3rem;\n    bottom: 3rem;\n  }\n  .md\\:inset-x-12 {\n    right: 3rem;\n    left: 3rem;\n  }\n  .md\\:inset-y-13 {\n    top: 3.25rem;\n    bottom: 3.25rem;\n  }\n  .md\\:inset-x-13 {\n    right: 3.25rem;\n    left: 3.25rem;\n  }\n  .md\\:inset-y-14 {\n    top: 3.5rem;\n    bottom: 3.5rem;\n  }\n  .md\\:inset-x-14 {\n    right: 3.5rem;\n    left: 3.5rem;\n  }\n  .md\\:inset-y-15 {\n    top: 3.75rem;\n    bottom: 3.75rem;\n  }\n  .md\\:inset-x-15 {\n    right: 3.75rem;\n    left: 3.75rem;\n  }\n  .md\\:inset-y-16 {\n    top: 4rem;\n    bottom: 4rem;\n  }\n  .md\\:inset-x-16 {\n    right: 4rem;\n    left: 4rem;\n  }\n  .md\\:inset-y-20 {\n    top: 5rem;\n    bottom: 5rem;\n  }\n  .md\\:inset-x-20 {\n    right: 5rem;\n    left: 5rem;\n  }\n  .md\\:inset-y-24 {\n    top: 6rem;\n    bottom: 6rem;\n  }\n  .md\\:inset-x-24 {\n    right: 6rem;\n    left: 6rem;\n  }\n  .md\\:inset-y-28 {\n    top: 7rem;\n    bottom: 7rem;\n  }\n  .md\\:inset-x-28 {\n    right: 7rem;\n    left: 7rem;\n  }\n  .md\\:inset-y-32 {\n    top: 8rem;\n    bottom: 8rem;\n  }\n  .md\\:inset-x-32 {\n    right: 8rem;\n    left: 8rem;\n  }\n  .md\\:inset-y-36 {\n    top: 9rem;\n    bottom: 9rem;\n  }\n  .md\\:inset-x-36 {\n    right: 9rem;\n    left: 9rem;\n  }\n  .md\\:inset-y-40 {\n    top: 10rem;\n    bottom: 10rem;\n  }\n  .md\\:inset-x-40 {\n    right: 10rem;\n    left: 10rem;\n  }\n  .md\\:inset-y-44 {\n    top: 11rem;\n    bottom: 11rem;\n  }\n  .md\\:inset-x-44 {\n    right: 11rem;\n    left: 11rem;\n  }\n  .md\\:inset-y-48 {\n    top: 12rem;\n    bottom: 12rem;\n  }\n  .md\\:inset-x-48 {\n    right: 12rem;\n    left: 12rem;\n  }\n  .md\\:inset-y-52 {\n    top: 13rem;\n    bottom: 13rem;\n  }\n  .md\\:inset-x-52 {\n    right: 13rem;\n    left: 13rem;\n  }\n  .md\\:inset-y-56 {\n    top: 14rem;\n    bottom: 14rem;\n  }\n  .md\\:inset-x-56 {\n    right: 14rem;\n    left: 14rem;\n  }\n  .md\\:inset-y-60 {\n    top: 15rem;\n    bottom: 15rem;\n  }\n  .md\\:inset-x-60 {\n    right: 15rem;\n    left: 15rem;\n  }\n  .md\\:inset-y-64 {\n    top: 16rem;\n    bottom: 16rem;\n  }\n  .md\\:inset-x-64 {\n    right: 16rem;\n    left: 16rem;\n  }\n  .md\\:inset-y-72 {\n    top: 18rem;\n    bottom: 18rem;\n  }\n  .md\\:inset-x-72 {\n    right: 18rem;\n    left: 18rem;\n  }\n  .md\\:inset-y-80 {\n    top: 20rem;\n    bottom: 20rem;\n  }\n  .md\\:inset-x-80 {\n    right: 20rem;\n    left: 20rem;\n  }\n  .md\\:inset-y-96 {\n    top: 24rem;\n    bottom: 24rem;\n  }\n  .md\\:inset-x-96 {\n    right: 24rem;\n    left: 24rem;\n  }\n  .md\\:inset-y-auto {\n    top: auto;\n    bottom: auto;\n  }\n  .md\\:inset-x-auto {\n    right: auto;\n    left: auto;\n  }\n  .md\\:inset-y-px {\n    top: 1px;\n    bottom: 1px;\n  }\n  .md\\:inset-x-px {\n    right: 1px;\n    left: 1px;\n  }\n  .md\\:inset-y-0\\.5 {\n    top: 0.125rem;\n    bottom: 0.125rem;\n  }\n  .md\\:inset-x-0\\.5 {\n    right: 0.125rem;\n    left: 0.125rem;\n  }\n  .md\\:inset-y-1\\.5 {\n    top: 0.375rem;\n    bottom: 0.375rem;\n  }\n  .md\\:inset-x-1\\.5 {\n    right: 0.375rem;\n    left: 0.375rem;\n  }\n  .md\\:inset-y-2\\.5 {\n    top: 0.625rem;\n    bottom: 0.625rem;\n  }\n  .md\\:inset-x-2\\.5 {\n    right: 0.625rem;\n    left: 0.625rem;\n  }\n  .md\\:inset-y-3\\.5 {\n    top: 0.875rem;\n    bottom: 0.875rem;\n  }\n  .md\\:inset-x-3\\.5 {\n    right: 0.875rem;\n    left: 0.875rem;\n  }\n  .md\\:inset-y-1\\/2 {\n    top: 50%;\n    bottom: 50%;\n  }\n  .md\\:inset-x-1\\/2 {\n    right: 50%;\n    left: 50%;\n  }\n  .md\\:inset-y-1\\/3 {\n    top: 33.333333%;\n    bottom: 33.333333%;\n  }\n  .md\\:inset-x-1\\/3 {\n    right: 33.333333%;\n    left: 33.333333%;\n  }\n  .md\\:inset-y-2\\/3 {\n    top: 66.666667%;\n    bottom: 66.666667%;\n  }\n  .md\\:inset-x-2\\/3 {\n    right: 66.666667%;\n    left: 66.666667%;\n  }\n  .md\\:inset-y-1\\/4 {\n    top: 25%;\n    bottom: 25%;\n  }\n  .md\\:inset-x-1\\/4 {\n    right: 25%;\n    left: 25%;\n  }\n  .md\\:inset-y-2\\/4 {\n    top: 50%;\n    bottom: 50%;\n  }\n  .md\\:inset-x-2\\/4 {\n    right: 50%;\n    left: 50%;\n  }\n  .md\\:inset-y-3\\/4 {\n    top: 75%;\n    bottom: 75%;\n  }\n  .md\\:inset-x-3\\/4 {\n    right: 75%;\n    left: 75%;\n  }\n  .md\\:inset-y-1\\/5 {\n    top: 20%;\n    bottom: 20%;\n  }\n  .md\\:inset-x-1\\/5 {\n    right: 20%;\n    left: 20%;\n  }\n  .md\\:inset-y-2\\/5 {\n    top: 40%;\n    bottom: 40%;\n  }\n  .md\\:inset-x-2\\/5 {\n    right: 40%;\n    left: 40%;\n  }\n  .md\\:inset-y-3\\/5 {\n    top: 60%;\n    bottom: 60%;\n  }\n  .md\\:inset-x-3\\/5 {\n    right: 60%;\n    left: 60%;\n  }\n  .md\\:inset-y-4\\/5 {\n    top: 80%;\n    bottom: 80%;\n  }\n  .md\\:inset-x-4\\/5 {\n    right: 80%;\n    left: 80%;\n  }\n  .md\\:inset-y-1\\/6 {\n    top: 16.666667%;\n    bottom: 16.666667%;\n  }\n  .md\\:inset-x-1\\/6 {\n    right: 16.666667%;\n    left: 16.666667%;\n  }\n  .md\\:inset-y-2\\/6 {\n    top: 33.333333%;\n    bottom: 33.333333%;\n  }\n  .md\\:inset-x-2\\/6 {\n    right: 33.333333%;\n    left: 33.333333%;\n  }\n  .md\\:inset-y-3\\/6 {\n    top: 50%;\n    bottom: 50%;\n  }\n  .md\\:inset-x-3\\/6 {\n    right: 50%;\n    left: 50%;\n  }\n  .md\\:inset-y-4\\/6 {\n    top: 66.666667%;\n    bottom: 66.666667%;\n  }\n  .md\\:inset-x-4\\/6 {\n    right: 66.666667%;\n    left: 66.666667%;\n  }\n  .md\\:inset-y-5\\/6 {\n    top: 83.333333%;\n    bottom: 83.333333%;\n  }\n  .md\\:inset-x-5\\/6 {\n    right: 83.333333%;\n    left: 83.333333%;\n  }\n  .md\\:inset-y-1\\/12 {\n    top: 8.333333%;\n    bottom: 8.333333%;\n  }\n  .md\\:inset-x-1\\/12 {\n    right: 8.333333%;\n    left: 8.333333%;\n  }\n  .md\\:inset-y-2\\/12 {\n    top: 16.666667%;\n    bottom: 16.666667%;\n  }\n  .md\\:inset-x-2\\/12 {\n    right: 16.666667%;\n    left: 16.666667%;\n  }\n  .md\\:inset-y-3\\/12 {\n    top: 25%;\n    bottom: 25%;\n  }\n  .md\\:inset-x-3\\/12 {\n    right: 25%;\n    left: 25%;\n  }\n  .md\\:inset-y-4\\/12 {\n    top: 33.333333%;\n    bottom: 33.333333%;\n  }\n  .md\\:inset-x-4\\/12 {\n    right: 33.333333%;\n    left: 33.333333%;\n  }\n  .md\\:inset-y-5\\/12 {\n    top: 41.666667%;\n    bottom: 41.666667%;\n  }\n  .md\\:inset-x-5\\/12 {\n    right: 41.666667%;\n    left: 41.666667%;\n  }\n  .md\\:inset-y-6\\/12 {\n    top: 50%;\n    bottom: 50%;\n  }\n  .md\\:inset-x-6\\/12 {\n    right: 50%;\n    left: 50%;\n  }\n  .md\\:inset-y-7\\/12 {\n    top: 58.333333%;\n    bottom: 58.333333%;\n  }\n  .md\\:inset-x-7\\/12 {\n    right: 58.333333%;\n    left: 58.333333%;\n  }\n  .md\\:inset-y-8\\/12 {\n    top: 66.666667%;\n    bottom: 66.666667%;\n  }\n  .md\\:inset-x-8\\/12 {\n    right: 66.666667%;\n    left: 66.666667%;\n  }\n  .md\\:inset-y-9\\/12 {\n    top: 75%;\n    bottom: 75%;\n  }\n  .md\\:inset-x-9\\/12 {\n    right: 75%;\n    left: 75%;\n  }\n  .md\\:inset-y-10\\/12 {\n    top: 83.333333%;\n    bottom: 83.333333%;\n  }\n  .md\\:inset-x-10\\/12 {\n    right: 83.333333%;\n    left: 83.333333%;\n  }\n  .md\\:inset-y-11\\/12 {\n    top: 91.666667%;\n    bottom: 91.666667%;\n  }\n  .md\\:inset-x-11\\/12 {\n    right: 91.666667%;\n    left: 91.666667%;\n  }\n  .md\\:inset-y-full {\n    top: 100%;\n    bottom: 100%;\n  }\n  .md\\:inset-x-full {\n    right: 100%;\n    left: 100%;\n  }\n  .md\\:top-0 {\n    top: 0;\n  }\n  .md\\:right-0 {\n    right: 0;\n  }\n  .md\\:bottom-0 {\n    bottom: 0;\n  }\n  .md\\:left-0 {\n    left: 0;\n  }\n  .md\\:top-1 {\n    top: 0.25rem;\n  }\n  .md\\:right-1 {\n    right: 0.25rem;\n  }\n  .md\\:bottom-1 {\n    bottom: 0.25rem;\n  }\n  .md\\:left-1 {\n    left: 0.25rem;\n  }\n  .md\\:top-2 {\n    top: 0.5rem;\n  }\n  .md\\:right-2 {\n    right: 0.5rem;\n  }\n  .md\\:bottom-2 {\n    bottom: 0.5rem;\n  }\n  .md\\:left-2 {\n    left: 0.5rem;\n  }\n  .md\\:top-3 {\n    top: 0.75rem;\n  }\n  .md\\:right-3 {\n    right: 0.75rem;\n  }\n  .md\\:bottom-3 {\n    bottom: 0.75rem;\n  }\n  .md\\:left-3 {\n    left: 0.75rem;\n  }\n  .md\\:top-4 {\n    top: 1rem;\n  }\n  .md\\:right-4 {\n    right: 1rem;\n  }\n  .md\\:bottom-4 {\n    bottom: 1rem;\n  }\n  .md\\:left-4 {\n    left: 1rem;\n  }\n  .md\\:top-5 {\n    top: 1.25rem;\n  }\n  .md\\:right-5 {\n    right: 1.25rem;\n  }\n  .md\\:bottom-5 {\n    bottom: 1.25rem;\n  }\n  .md\\:left-5 {\n    left: 1.25rem;\n  }\n  .md\\:top-6 {\n    top: 1.5rem;\n  }\n  .md\\:right-6 {\n    right: 1.5rem;\n  }\n  .md\\:bottom-6 {\n    bottom: 1.5rem;\n  }\n  .md\\:left-6 {\n    left: 1.5rem;\n  }\n  .md\\:top-7 {\n    top: 1.75rem;\n  }\n  .md\\:right-7 {\n    right: 1.75rem;\n  }\n  .md\\:bottom-7 {\n    bottom: 1.75rem;\n  }\n  .md\\:left-7 {\n    left: 1.75rem;\n  }\n  .md\\:top-8 {\n    top: 2rem;\n  }\n  .md\\:right-8 {\n    right: 2rem;\n  }\n  .md\\:bottom-8 {\n    bottom: 2rem;\n  }\n  .md\\:left-8 {\n    left: 2rem;\n  }\n  .md\\:top-9 {\n    top: 2.25rem;\n  }\n  .md\\:right-9 {\n    right: 2.25rem;\n  }\n  .md\\:bottom-9 {\n    bottom: 2.25rem;\n  }\n  .md\\:left-9 {\n    left: 2.25rem;\n  }\n  .md\\:top-10 {\n    top: 2.5rem;\n  }\n  .md\\:right-10 {\n    right: 2.5rem;\n  }\n  .md\\:bottom-10 {\n    bottom: 2.5rem;\n  }\n  .md\\:left-10 {\n    left: 2.5rem;\n  }\n  .md\\:top-11 {\n    top: 2.75rem;\n  }\n  .md\\:right-11 {\n    right: 2.75rem;\n  }\n  .md\\:bottom-11 {\n    bottom: 2.75rem;\n  }\n  .md\\:left-11 {\n    left: 2.75rem;\n  }\n  .md\\:top-12 {\n    top: 3rem;\n  }\n  .md\\:right-12 {\n    right: 3rem;\n  }\n  .md\\:bottom-12 {\n    bottom: 3rem;\n  }\n  .md\\:left-12 {\n    left: 3rem;\n  }\n  .md\\:top-13 {\n    top: 3.25rem;\n  }\n  .md\\:right-13 {\n    right: 3.25rem;\n  }\n  .md\\:bottom-13 {\n    bottom: 3.25rem;\n  }\n  .md\\:left-13 {\n    left: 3.25rem;\n  }\n  .md\\:top-14 {\n    top: 3.5rem;\n  }\n  .md\\:right-14 {\n    right: 3.5rem;\n  }\n  .md\\:bottom-14 {\n    bottom: 3.5rem;\n  }\n  .md\\:left-14 {\n    left: 3.5rem;\n  }\n  .md\\:top-15 {\n    top: 3.75rem;\n  }\n  .md\\:right-15 {\n    right: 3.75rem;\n  }\n  .md\\:bottom-15 {\n    bottom: 3.75rem;\n  }\n  .md\\:left-15 {\n    left: 3.75rem;\n  }\n  .md\\:top-16 {\n    top: 4rem;\n  }\n  .md\\:right-16 {\n    right: 4rem;\n  }\n  .md\\:bottom-16 {\n    bottom: 4rem;\n  }\n  .md\\:left-16 {\n    left: 4rem;\n  }\n  .md\\:top-20 {\n    top: 5rem;\n  }\n  .md\\:right-20 {\n    right: 5rem;\n  }\n  .md\\:bottom-20 {\n    bottom: 5rem;\n  }\n  .md\\:left-20 {\n    left: 5rem;\n  }\n  .md\\:top-24 {\n    top: 6rem;\n  }\n  .md\\:right-24 {\n    right: 6rem;\n  }\n  .md\\:bottom-24 {\n    bottom: 6rem;\n  }\n  .md\\:left-24 {\n    left: 6rem;\n  }\n  .md\\:top-28 {\n    top: 7rem;\n  }\n  .md\\:right-28 {\n    right: 7rem;\n  }\n  .md\\:bottom-28 {\n    bottom: 7rem;\n  }\n  .md\\:left-28 {\n    left: 7rem;\n  }\n  .md\\:top-32 {\n    top: 8rem;\n  }\n  .md\\:right-32 {\n    right: 8rem;\n  }\n  .md\\:bottom-32 {\n    bottom: 8rem;\n  }\n  .md\\:left-32 {\n    left: 8rem;\n  }\n  .md\\:top-36 {\n    top: 9rem;\n  }\n  .md\\:right-36 {\n    right: 9rem;\n  }\n  .md\\:bottom-36 {\n    bottom: 9rem;\n  }\n  .md\\:left-36 {\n    left: 9rem;\n  }\n  .md\\:top-40 {\n    top: 10rem;\n  }\n  .md\\:right-40 {\n    right: 10rem;\n  }\n  .md\\:bottom-40 {\n    bottom: 10rem;\n  }\n  .md\\:left-40 {\n    left: 10rem;\n  }\n  .md\\:top-44 {\n    top: 11rem;\n  }\n  .md\\:right-44 {\n    right: 11rem;\n  }\n  .md\\:bottom-44 {\n    bottom: 11rem;\n  }\n  .md\\:left-44 {\n    left: 11rem;\n  }\n  .md\\:top-48 {\n    top: 12rem;\n  }\n  .md\\:right-48 {\n    right: 12rem;\n  }\n  .md\\:bottom-48 {\n    bottom: 12rem;\n  }\n  .md\\:left-48 {\n    left: 12rem;\n  }\n  .md\\:top-52 {\n    top: 13rem;\n  }\n  .md\\:right-52 {\n    right: 13rem;\n  }\n  .md\\:bottom-52 {\n    bottom: 13rem;\n  }\n  .md\\:left-52 {\n    left: 13rem;\n  }\n  .md\\:top-56 {\n    top: 14rem;\n  }\n  .md\\:right-56 {\n    right: 14rem;\n  }\n  .md\\:bottom-56 {\n    bottom: 14rem;\n  }\n  .md\\:left-56 {\n    left: 14rem;\n  }\n  .md\\:top-60 {\n    top: 15rem;\n  }\n  .md\\:right-60 {\n    right: 15rem;\n  }\n  .md\\:bottom-60 {\n    bottom: 15rem;\n  }\n  .md\\:left-60 {\n    left: 15rem;\n  }\n  .md\\:top-64 {\n    top: 16rem;\n  }\n  .md\\:right-64 {\n    right: 16rem;\n  }\n  .md\\:bottom-64 {\n    bottom: 16rem;\n  }\n  .md\\:left-64 {\n    left: 16rem;\n  }\n  .md\\:top-72 {\n    top: 18rem;\n  }\n  .md\\:right-72 {\n    right: 18rem;\n  }\n  .md\\:bottom-72 {\n    bottom: 18rem;\n  }\n  .md\\:left-72 {\n    left: 18rem;\n  }\n  .md\\:top-80 {\n    top: 20rem;\n  }\n  .md\\:right-80 {\n    right: 20rem;\n  }\n  .md\\:bottom-80 {\n    bottom: 20rem;\n  }\n  .md\\:left-80 {\n    left: 20rem;\n  }\n  .md\\:top-96 {\n    top: 24rem;\n  }\n  .md\\:right-96 {\n    right: 24rem;\n  }\n  .md\\:bottom-96 {\n    bottom: 24rem;\n  }\n  .md\\:left-96 {\n    left: 24rem;\n  }\n  .md\\:top-auto {\n    top: auto;\n  }\n  .md\\:right-auto {\n    right: auto;\n  }\n  .md\\:bottom-auto {\n    bottom: auto;\n  }\n  .md\\:left-auto {\n    left: auto;\n  }\n  .md\\:top-px {\n    top: 1px;\n  }\n  .md\\:right-px {\n    right: 1px;\n  }\n  .md\\:bottom-px {\n    bottom: 1px;\n  }\n  .md\\:left-px {\n    left: 1px;\n  }\n  .md\\:top-0\\.5 {\n    top: 0.125rem;\n  }\n  .md\\:right-0\\.5 {\n    right: 0.125rem;\n  }\n  .md\\:bottom-0\\.5 {\n    bottom: 0.125rem;\n  }\n  .md\\:left-0\\.5 {\n    left: 0.125rem;\n  }\n  .md\\:top-1\\.5 {\n    top: 0.375rem;\n  }\n  .md\\:right-1\\.5 {\n    right: 0.375rem;\n  }\n  .md\\:bottom-1\\.5 {\n    bottom: 0.375rem;\n  }\n  .md\\:left-1\\.5 {\n    left: 0.375rem;\n  }\n  .md\\:top-2\\.5 {\n    top: 0.625rem;\n  }\n  .md\\:right-2\\.5 {\n    right: 0.625rem;\n  }\n  .md\\:bottom-2\\.5 {\n    bottom: 0.625rem;\n  }\n  .md\\:left-2\\.5 {\n    left: 0.625rem;\n  }\n  .md\\:top-3\\.5 {\n    top: 0.875rem;\n  }\n  .md\\:right-3\\.5 {\n    right: 0.875rem;\n  }\n  .md\\:bottom-3\\.5 {\n    bottom: 0.875rem;\n  }\n  .md\\:left-3\\.5 {\n    left: 0.875rem;\n  }\n  .md\\:top-1\\/2 {\n    top: 50%;\n  }\n  .md\\:right-1\\/2 {\n    right: 50%;\n  }\n  .md\\:bottom-1\\/2 {\n    bottom: 50%;\n  }\n  .md\\:left-1\\/2 {\n    left: 50%;\n  }\n  .md\\:top-1\\/3 {\n    top: 33.333333%;\n  }\n  .md\\:right-1\\/3 {\n    right: 33.333333%;\n  }\n  .md\\:bottom-1\\/3 {\n    bottom: 33.333333%;\n  }\n  .md\\:left-1\\/3 {\n    left: 33.333333%;\n  }\n  .md\\:top-2\\/3 {\n    top: 66.666667%;\n  }\n  .md\\:right-2\\/3 {\n    right: 66.666667%;\n  }\n  .md\\:bottom-2\\/3 {\n    bottom: 66.666667%;\n  }\n  .md\\:left-2\\/3 {\n    left: 66.666667%;\n  }\n  .md\\:top-1\\/4 {\n    top: 25%;\n  }\n  .md\\:right-1\\/4 {\n    right: 25%;\n  }\n  .md\\:bottom-1\\/4 {\n    bottom: 25%;\n  }\n  .md\\:left-1\\/4 {\n    left: 25%;\n  }\n  .md\\:top-2\\/4 {\n    top: 50%;\n  }\n  .md\\:right-2\\/4 {\n    right: 50%;\n  }\n  .md\\:bottom-2\\/4 {\n    bottom: 50%;\n  }\n  .md\\:left-2\\/4 {\n    left: 50%;\n  }\n  .md\\:top-3\\/4 {\n    top: 75%;\n  }\n  .md\\:right-3\\/4 {\n    right: 75%;\n  }\n  .md\\:bottom-3\\/4 {\n    bottom: 75%;\n  }\n  .md\\:left-3\\/4 {\n    left: 75%;\n  }\n  .md\\:top-1\\/5 {\n    top: 20%;\n  }\n  .md\\:right-1\\/5 {\n    right: 20%;\n  }\n  .md\\:bottom-1\\/5 {\n    bottom: 20%;\n  }\n  .md\\:left-1\\/5 {\n    left: 20%;\n  }\n  .md\\:top-2\\/5 {\n    top: 40%;\n  }\n  .md\\:right-2\\/5 {\n    right: 40%;\n  }\n  .md\\:bottom-2\\/5 {\n    bottom: 40%;\n  }\n  .md\\:left-2\\/5 {\n    left: 40%;\n  }\n  .md\\:top-3\\/5 {\n    top: 60%;\n  }\n  .md\\:right-3\\/5 {\n    right: 60%;\n  }\n  .md\\:bottom-3\\/5 {\n    bottom: 60%;\n  }\n  .md\\:left-3\\/5 {\n    left: 60%;\n  }\n  .md\\:top-4\\/5 {\n    top: 80%;\n  }\n  .md\\:right-4\\/5 {\n    right: 80%;\n  }\n  .md\\:bottom-4\\/5 {\n    bottom: 80%;\n  }\n  .md\\:left-4\\/5 {\n    left: 80%;\n  }\n  .md\\:top-1\\/6 {\n    top: 16.666667%;\n  }\n  .md\\:right-1\\/6 {\n    right: 16.666667%;\n  }\n  .md\\:bottom-1\\/6 {\n    bottom: 16.666667%;\n  }\n  .md\\:left-1\\/6 {\n    left: 16.666667%;\n  }\n  .md\\:top-2\\/6 {\n    top: 33.333333%;\n  }\n  .md\\:right-2\\/6 {\n    right: 33.333333%;\n  }\n  .md\\:bottom-2\\/6 {\n    bottom: 33.333333%;\n  }\n  .md\\:left-2\\/6 {\n    left: 33.333333%;\n  }\n  .md\\:top-3\\/6 {\n    top: 50%;\n  }\n  .md\\:right-3\\/6 {\n    right: 50%;\n  }\n  .md\\:bottom-3\\/6 {\n    bottom: 50%;\n  }\n  .md\\:left-3\\/6 {\n    left: 50%;\n  }\n  .md\\:top-4\\/6 {\n    top: 66.666667%;\n  }\n  .md\\:right-4\\/6 {\n    right: 66.666667%;\n  }\n  .md\\:bottom-4\\/6 {\n    bottom: 66.666667%;\n  }\n  .md\\:left-4\\/6 {\n    left: 66.666667%;\n  }\n  .md\\:top-5\\/6 {\n    top: 83.333333%;\n  }\n  .md\\:right-5\\/6 {\n    right: 83.333333%;\n  }\n  .md\\:bottom-5\\/6 {\n    bottom: 83.333333%;\n  }\n  .md\\:left-5\\/6 {\n    left: 83.333333%;\n  }\n  .md\\:top-1\\/12 {\n    top: 8.333333%;\n  }\n  .md\\:right-1\\/12 {\n    right: 8.333333%;\n  }\n  .md\\:bottom-1\\/12 {\n    bottom: 8.333333%;\n  }\n  .md\\:left-1\\/12 {\n    left: 8.333333%;\n  }\n  .md\\:top-2\\/12 {\n    top: 16.666667%;\n  }\n  .md\\:right-2\\/12 {\n    right: 16.666667%;\n  }\n  .md\\:bottom-2\\/12 {\n    bottom: 16.666667%;\n  }\n  .md\\:left-2\\/12 {\n    left: 16.666667%;\n  }\n  .md\\:top-3\\/12 {\n    top: 25%;\n  }\n  .md\\:right-3\\/12 {\n    right: 25%;\n  }\n  .md\\:bottom-3\\/12 {\n    bottom: 25%;\n  }\n  .md\\:left-3\\/12 {\n    left: 25%;\n  }\n  .md\\:top-4\\/12 {\n    top: 33.333333%;\n  }\n  .md\\:right-4\\/12 {\n    right: 33.333333%;\n  }\n  .md\\:bottom-4\\/12 {\n    bottom: 33.333333%;\n  }\n  .md\\:left-4\\/12 {\n    left: 33.333333%;\n  }\n  .md\\:top-5\\/12 {\n    top: 41.666667%;\n  }\n  .md\\:right-5\\/12 {\n    right: 41.666667%;\n  }\n  .md\\:bottom-5\\/12 {\n    bottom: 41.666667%;\n  }\n  .md\\:left-5\\/12 {\n    left: 41.666667%;\n  }\n  .md\\:top-6\\/12 {\n    top: 50%;\n  }\n  .md\\:right-6\\/12 {\n    right: 50%;\n  }\n  .md\\:bottom-6\\/12 {\n    bottom: 50%;\n  }\n  .md\\:left-6\\/12 {\n    left: 50%;\n  }\n  .md\\:top-7\\/12 {\n    top: 58.333333%;\n  }\n  .md\\:right-7\\/12 {\n    right: 58.333333%;\n  }\n  .md\\:bottom-7\\/12 {\n    bottom: 58.333333%;\n  }\n  .md\\:left-7\\/12 {\n    left: 58.333333%;\n  }\n  .md\\:top-8\\/12 {\n    top: 66.666667%;\n  }\n  .md\\:right-8\\/12 {\n    right: 66.666667%;\n  }\n  .md\\:bottom-8\\/12 {\n    bottom: 66.666667%;\n  }\n  .md\\:left-8\\/12 {\n    left: 66.666667%;\n  }\n  .md\\:top-9\\/12 {\n    top: 75%;\n  }\n  .md\\:right-9\\/12 {\n    right: 75%;\n  }\n  .md\\:bottom-9\\/12 {\n    bottom: 75%;\n  }\n  .md\\:left-9\\/12 {\n    left: 75%;\n  }\n  .md\\:top-10\\/12 {\n    top: 83.333333%;\n  }\n  .md\\:right-10\\/12 {\n    right: 83.333333%;\n  }\n  .md\\:bottom-10\\/12 {\n    bottom: 83.333333%;\n  }\n  .md\\:left-10\\/12 {\n    left: 83.333333%;\n  }\n  .md\\:top-11\\/12 {\n    top: 91.666667%;\n  }\n  .md\\:right-11\\/12 {\n    right: 91.666667%;\n  }\n  .md\\:bottom-11\\/12 {\n    bottom: 91.666667%;\n  }\n  .md\\:left-11\\/12 {\n    left: 91.666667%;\n  }\n  .md\\:top-full {\n    top: 100%;\n  }\n  .md\\:right-full {\n    right: 100%;\n  }\n  .md\\:bottom-full {\n    bottom: 100%;\n  }\n  .md\\:left-full {\n    left: 100%;\n  }\n  .md\\:resize-none {\n    resize: none;\n  }\n  .md\\:resize-y {\n    resize: vertical;\n  }\n  .md\\:resize-x {\n    resize: horizontal;\n  }\n  .md\\:resize {\n    resize: both;\n  }\n  .md\\:shadow-xs {\n    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.05);\n  }\n  .md\\:shadow-sm {\n    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);\n  }\n  .md\\:shadow {\n    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);\n  }\n  .md\\:shadow-md {\n    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);\n  }\n  .md\\:shadow-lg {\n    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);\n  }\n  .md\\:shadow-xl {\n    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);\n  }\n  .md\\:shadow-2xl {\n    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);\n  }\n  .md\\:shadow-inner {\n    box-shadow: inset 0 2px 4px 0 rgba(0, 0, 0, 0.06);\n  }\n  .md\\:shadow-outline {\n    box-shadow: 0 0 0 3px rgba(118, 169, 250, 0.45);\n  }\n  .md\\:shadow-none {\n    box-shadow: none;\n  }\n  .md\\:shadow-solid {\n    box-shadow: 0 0 0 2px currentColor;\n  }\n  .md\\:shadow-outline-gray {\n    box-shadow: 0 0 0 3px rgba(159, 166, 178, 0.45);\n  }\n  .md\\:shadow-outline-blue {\n    box-shadow: 0 0 0 3px rgba(164, 202, 254, 0.45);\n  }\n  .md\\:shadow-outline-teal {\n    box-shadow: 0 0 0 3px rgba(126, 220, 226, 0.45);\n  }\n  .md\\:shadow-outline-green {\n    box-shadow: 0 0 0 3px rgba(132, 225, 188, 0.45);\n  }\n  .md\\:shadow-outline-yellow {\n    box-shadow: 0 0 0 3px rgba(250, 202, 21, 0.45);\n  }\n  .md\\:shadow-outline-orange {\n    box-shadow: 0 0 0 3px rgba(253, 186, 140, 0.45);\n  }\n  .md\\:shadow-outline-red {\n    box-shadow: 0 0 0 3px rgba(248, 180, 180, 0.45);\n  }\n  .md\\:shadow-outline-pink {\n    box-shadow: 0 0 0 3px rgba(248, 180, 217, 0.45);\n  }\n  .md\\:shadow-outline-purple {\n    box-shadow: 0 0 0 3px rgba(202, 191, 253, 0.45);\n  }\n  .md\\:shadow-outline-indigo {\n    box-shadow: 0 0 0 3px rgba(180, 198, 252, 0.45);\n  }\n  .group:focus .md\\:group-focus\\:shadow-xs {\n    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.05);\n  }\n  .group:focus .md\\:group-focus\\:shadow-sm {\n    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);\n  }\n  .group:focus .md\\:group-focus\\:shadow {\n    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);\n  }\n  .group:focus .md\\:group-focus\\:shadow-md {\n    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);\n  }\n  .group:focus .md\\:group-focus\\:shadow-lg {\n    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);\n  }\n  .group:focus .md\\:group-focus\\:shadow-xl {\n    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);\n  }\n  .group:focus .md\\:group-focus\\:shadow-2xl {\n    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);\n  }\n  .group:focus .md\\:group-focus\\:shadow-inner {\n    box-shadow: inset 0 2px 4px 0 rgba(0, 0, 0, 0.06);\n  }\n  .group:focus .md\\:group-focus\\:shadow-outline {\n    box-shadow: 0 0 0 3px rgba(118, 169, 250, 0.45);\n  }\n  .group:focus .md\\:group-focus\\:shadow-none {\n    box-shadow: none;\n  }\n  .group:focus .md\\:group-focus\\:shadow-solid {\n    box-shadow: 0 0 0 2px currentColor;\n  }\n  .group:focus .md\\:group-focus\\:shadow-outline-gray {\n    box-shadow: 0 0 0 3px rgba(159, 166, 178, 0.45);\n  }\n  .group:focus .md\\:group-focus\\:shadow-outline-blue {\n    box-shadow: 0 0 0 3px rgba(164, 202, 254, 0.45);\n  }\n  .group:focus .md\\:group-focus\\:shadow-outline-teal {\n    box-shadow: 0 0 0 3px rgba(126, 220, 226, 0.45);\n  }\n  .group:focus .md\\:group-focus\\:shadow-outline-green {\n    box-shadow: 0 0 0 3px rgba(132, 225, 188, 0.45);\n  }\n  .group:focus .md\\:group-focus\\:shadow-outline-yellow {\n    box-shadow: 0 0 0 3px rgba(250, 202, 21, 0.45);\n  }\n  .group:focus .md\\:group-focus\\:shadow-outline-orange {\n    box-shadow: 0 0 0 3px rgba(253, 186, 140, 0.45);\n  }\n  .group:focus .md\\:group-focus\\:shadow-outline-red {\n    box-shadow: 0 0 0 3px rgba(248, 180, 180, 0.45);\n  }\n  .group:focus .md\\:group-focus\\:shadow-outline-pink {\n    box-shadow: 0 0 0 3px rgba(248, 180, 217, 0.45);\n  }\n  .group:focus .md\\:group-focus\\:shadow-outline-purple {\n    box-shadow: 0 0 0 3px rgba(202, 191, 253, 0.45);\n  }\n  .group:focus .md\\:group-focus\\:shadow-outline-indigo {\n    box-shadow: 0 0 0 3px rgba(180, 198, 252, 0.45);\n  }\n  .md\\:hover\\:shadow-xs:hover {\n    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.05);\n  }\n  .md\\:hover\\:shadow-sm:hover {\n    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);\n  }\n  .md\\:hover\\:shadow:hover {\n    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);\n  }\n  .md\\:hover\\:shadow-md:hover {\n    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);\n  }\n  .md\\:hover\\:shadow-lg:hover {\n    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);\n  }\n  .md\\:hover\\:shadow-xl:hover {\n    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);\n  }\n  .md\\:hover\\:shadow-2xl:hover {\n    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);\n  }\n  .md\\:hover\\:shadow-inner:hover {\n    box-shadow: inset 0 2px 4px 0 rgba(0, 0, 0, 0.06);\n  }\n  .md\\:hover\\:shadow-outline:hover {\n    box-shadow: 0 0 0 3px rgba(118, 169, 250, 0.45);\n  }\n  .md\\:hover\\:shadow-none:hover {\n    box-shadow: none;\n  }\n  .md\\:hover\\:shadow-solid:hover {\n    box-shadow: 0 0 0 2px currentColor;\n  }\n  .md\\:hover\\:shadow-outline-gray:hover {\n    box-shadow: 0 0 0 3px rgba(159, 166, 178, 0.45);\n  }\n  .md\\:hover\\:shadow-outline-blue:hover {\n    box-shadow: 0 0 0 3px rgba(164, 202, 254, 0.45);\n  }\n  .md\\:hover\\:shadow-outline-teal:hover {\n    box-shadow: 0 0 0 3px rgba(126, 220, 226, 0.45);\n  }\n  .md\\:hover\\:shadow-outline-green:hover {\n    box-shadow: 0 0 0 3px rgba(132, 225, 188, 0.45);\n  }\n  .md\\:hover\\:shadow-outline-yellow:hover {\n    box-shadow: 0 0 0 3px rgba(250, 202, 21, 0.45);\n  }\n  .md\\:hover\\:shadow-outline-orange:hover {\n    box-shadow: 0 0 0 3px rgba(253, 186, 140, 0.45);\n  }\n  .md\\:hover\\:shadow-outline-red:hover {\n    box-shadow: 0 0 0 3px rgba(248, 180, 180, 0.45);\n  }\n  .md\\:hover\\:shadow-outline-pink:hover {\n    box-shadow: 0 0 0 3px rgba(248, 180, 217, 0.45);\n  }\n  .md\\:hover\\:shadow-outline-purple:hover {\n    box-shadow: 0 0 0 3px rgba(202, 191, 253, 0.45);\n  }\n  .md\\:hover\\:shadow-outline-indigo:hover {\n    box-shadow: 0 0 0 3px rgba(180, 198, 252, 0.45);\n  }\n  .md\\:focus-within\\:shadow-xs:focus-within {\n    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.05);\n  }\n  .md\\:focus-within\\:shadow-sm:focus-within {\n    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);\n  }\n  .md\\:focus-within\\:shadow:focus-within {\n    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);\n  }\n  .md\\:focus-within\\:shadow-md:focus-within {\n    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);\n  }\n  .md\\:focus-within\\:shadow-lg:focus-within {\n    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);\n  }\n  .md\\:focus-within\\:shadow-xl:focus-within {\n    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);\n  }\n  .md\\:focus-within\\:shadow-2xl:focus-within {\n    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);\n  }\n  .md\\:focus-within\\:shadow-inner:focus-within {\n    box-shadow: inset 0 2px 4px 0 rgba(0, 0, 0, 0.06);\n  }\n  .md\\:focus-within\\:shadow-outline:focus-within {\n    box-shadow: 0 0 0 3px rgba(118, 169, 250, 0.45);\n  }\n  .md\\:focus-within\\:shadow-none:focus-within {\n    box-shadow: none;\n  }\n  .md\\:focus-within\\:shadow-solid:focus-within {\n    box-shadow: 0 0 0 2px currentColor;\n  }\n  .md\\:focus-within\\:shadow-outline-gray:focus-within {\n    box-shadow: 0 0 0 3px rgba(159, 166, 178, 0.45);\n  }\n  .md\\:focus-within\\:shadow-outline-blue:focus-within {\n    box-shadow: 0 0 0 3px rgba(164, 202, 254, 0.45);\n  }\n  .md\\:focus-within\\:shadow-outline-teal:focus-within {\n    box-shadow: 0 0 0 3px rgba(126, 220, 226, 0.45);\n  }\n  .md\\:focus-within\\:shadow-outline-green:focus-within {\n    box-shadow: 0 0 0 3px rgba(132, 225, 188, 0.45);\n  }\n  .md\\:focus-within\\:shadow-outline-yellow:focus-within {\n    box-shadow: 0 0 0 3px rgba(250, 202, 21, 0.45);\n  }\n  .md\\:focus-within\\:shadow-outline-orange:focus-within {\n    box-shadow: 0 0 0 3px rgba(253, 186, 140, 0.45);\n  }\n  .md\\:focus-within\\:shadow-outline-red:focus-within {\n    box-shadow: 0 0 0 3px rgba(248, 180, 180, 0.45);\n  }\n  .md\\:focus-within\\:shadow-outline-pink:focus-within {\n    box-shadow: 0 0 0 3px rgba(248, 180, 217, 0.45);\n  }\n  .md\\:focus-within\\:shadow-outline-purple:focus-within {\n    box-shadow: 0 0 0 3px rgba(202, 191, 253, 0.45);\n  }\n  .md\\:focus-within\\:shadow-outline-indigo:focus-within {\n    box-shadow: 0 0 0 3px rgba(180, 198, 252, 0.45);\n  }\n  .md\\:focus\\:shadow-xs:focus {\n    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.05);\n  }\n  .md\\:focus\\:shadow-sm:focus {\n    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);\n  }\n  .md\\:focus\\:shadow:focus {\n    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);\n  }\n  .md\\:focus\\:shadow-md:focus {\n    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);\n  }\n  .md\\:focus\\:shadow-lg:focus {\n    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);\n  }\n  .md\\:focus\\:shadow-xl:focus {\n    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);\n  }\n  .md\\:focus\\:shadow-2xl:focus {\n    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);\n  }\n  .md\\:focus\\:shadow-inner:focus {\n    box-shadow: inset 0 2px 4px 0 rgba(0, 0, 0, 0.06);\n  }\n  .md\\:focus\\:shadow-outline:focus {\n    box-shadow: 0 0 0 3px rgba(118, 169, 250, 0.45);\n  }\n  .md\\:focus\\:shadow-none:focus {\n    box-shadow: none;\n  }\n  .md\\:focus\\:shadow-solid:focus {\n    box-shadow: 0 0 0 2px currentColor;\n  }\n  .md\\:focus\\:shadow-outline-gray:focus {\n    box-shadow: 0 0 0 3px rgba(159, 166, 178, 0.45);\n  }\n  .md\\:focus\\:shadow-outline-blue:focus {\n    box-shadow: 0 0 0 3px rgba(164, 202, 254, 0.45);\n  }\n  .md\\:focus\\:shadow-outline-teal:focus {\n    box-shadow: 0 0 0 3px rgba(126, 220, 226, 0.45);\n  }\n  .md\\:focus\\:shadow-outline-green:focus {\n    box-shadow: 0 0 0 3px rgba(132, 225, 188, 0.45);\n  }\n  .md\\:focus\\:shadow-outline-yellow:focus {\n    box-shadow: 0 0 0 3px rgba(250, 202, 21, 0.45);\n  }\n  .md\\:focus\\:shadow-outline-orange:focus {\n    box-shadow: 0 0 0 3px rgba(253, 186, 140, 0.45);\n  }\n  .md\\:focus\\:shadow-outline-red:focus {\n    box-shadow: 0 0 0 3px rgba(248, 180, 180, 0.45);\n  }\n  .md\\:focus\\:shadow-outline-pink:focus {\n    box-shadow: 0 0 0 3px rgba(248, 180, 217, 0.45);\n  }\n  .md\\:focus\\:shadow-outline-purple:focus {\n    box-shadow: 0 0 0 3px rgba(202, 191, 253, 0.45);\n  }\n  .md\\:focus\\:shadow-outline-indigo:focus {\n    box-shadow: 0 0 0 3px rgba(180, 198, 252, 0.45);\n  }\n  .md\\:fill-current {\n    fill: currentColor;\n  }\n  .md\\:stroke-current {\n    stroke: currentColor;\n  }\n  .md\\:stroke-0 {\n    stroke-width: 0;\n  }\n  .md\\:stroke-1 {\n    stroke-width: 1;\n  }\n  .md\\:stroke-2 {\n    stroke-width: 2;\n  }\n  .md\\:table-auto {\n    table-layout: auto;\n  }\n  .md\\:table-fixed {\n    table-layout: fixed;\n  }\n  .md\\:text-left {\n    text-align: left;\n  }\n  .md\\:text-center {\n    text-align: center;\n  }\n  .md\\:text-right {\n    text-align: right;\n  }\n  .md\\:text-justify {\n    text-align: justify;\n  }\n  .md\\:text-current {\n    color: currentColor;\n  }\n  .md\\:text-transparent {\n    color: transparent;\n  }\n  .md\\:text-white {\n    --text-opacity: 1;\n    color: #ffffff;\n    color: rgba(255, 255, 255, var(--text-opacity));\n  }\n  .md\\:text-black {\n    --text-opacity: 1;\n    color: #000000;\n    color: rgba(0, 0, 0, var(--text-opacity));\n  }\n  .md\\:text-gray-50 {\n    --text-opacity: 1;\n    color: #f9fafb;\n    color: rgba(249, 250, 251, var(--text-opacity));\n  }\n  .md\\:text-gray-100 {\n    --text-opacity: 1;\n    color: #f4f5f7;\n    color: rgba(244, 245, 247, var(--text-opacity));\n  }\n  .md\\:text-gray-200 {\n    --text-opacity: 1;\n    color: #e5e7eb;\n    color: rgba(229, 231, 235, var(--text-opacity));\n  }\n  .md\\:text-gray-300 {\n    --text-opacity: 1;\n    color: #d2d6dc;\n    color: rgba(210, 214, 220, var(--text-opacity));\n  }\n  .md\\:text-gray-400 {\n    --text-opacity: 1;\n    color: #9fa6b2;\n    color: rgba(159, 166, 178, var(--text-opacity));\n  }\n  .md\\:text-gray-500 {\n    --text-opacity: 1;\n    color: #6b7280;\n    color: rgba(107, 114, 128, var(--text-opacity));\n  }\n  .md\\:text-gray-600 {\n    --text-opacity: 1;\n    color: #4b5563;\n    color: rgba(75, 85, 99, var(--text-opacity));\n  }\n  .md\\:text-gray-700 {\n    --text-opacity: 1;\n    color: #374151;\n    color: rgba(55, 65, 81, var(--text-opacity));\n  }\n  .md\\:text-gray-800 {\n    --text-opacity: 1;\n    color: #252f3f;\n    color: rgba(37, 47, 63, var(--text-opacity));\n  }\n  .md\\:text-gray-900 {\n    --text-opacity: 1;\n    color: #161e2e;\n    color: rgba(22, 30, 46, var(--text-opacity));\n  }\n  .md\\:text-red-50 {\n    --text-opacity: 1;\n    color: #fdf2f2;\n    color: rgba(253, 242, 242, var(--text-opacity));\n  }\n  .md\\:text-red-100 {\n    --text-opacity: 1;\n    color: #fde8e8;\n    color: rgba(253, 232, 232, var(--text-opacity));\n  }\n  .md\\:text-red-200 {\n    --text-opacity: 1;\n    color: #fbd5d5;\n    color: rgba(251, 213, 213, var(--text-opacity));\n  }\n  .md\\:text-red-300 {\n    --text-opacity: 1;\n    color: #f8b4b4;\n    color: rgba(248, 180, 180, var(--text-opacity));\n  }\n  .md\\:text-red-400 {\n    --text-opacity: 1;\n    color: #f98080;\n    color: rgba(249, 128, 128, var(--text-opacity));\n  }\n  .md\\:text-red-500 {\n    --text-opacity: 1;\n    color: #f05252;\n    color: rgba(240, 82, 82, var(--text-opacity));\n  }\n  .md\\:text-red-600 {\n    --text-opacity: 1;\n    color: #e02424;\n    color: rgba(224, 36, 36, var(--text-opacity));\n  }\n  .md\\:text-red-700 {\n    --text-opacity: 1;\n    color: #c81e1e;\n    color: rgba(200, 30, 30, var(--text-opacity));\n  }\n  .md\\:text-red-800 {\n    --text-opacity: 1;\n    color: #9b1c1c;\n    color: rgba(155, 28, 28, var(--text-opacity));\n  }\n  .md\\:text-red-900 {\n    --text-opacity: 1;\n    color: #771d1d;\n    color: rgba(119, 29, 29, var(--text-opacity));\n  }\n  .md\\:text-orange-50 {\n    --text-opacity: 1;\n    color: #fff8f1;\n    color: rgba(255, 248, 241, var(--text-opacity));\n  }\n  .md\\:text-orange-100 {\n    --text-opacity: 1;\n    color: #feecdc;\n    color: rgba(254, 236, 220, var(--text-opacity));\n  }\n  .md\\:text-orange-200 {\n    --text-opacity: 1;\n    color: #fcd9bd;\n    color: rgba(252, 217, 189, var(--text-opacity));\n  }\n  .md\\:text-orange-300 {\n    --text-opacity: 1;\n    color: #fdba8c;\n    color: rgba(253, 186, 140, var(--text-opacity));\n  }\n  .md\\:text-orange-400 {\n    --text-opacity: 1;\n    color: #ff8a4c;\n    color: rgba(255, 138, 76, var(--text-opacity));\n  }\n  .md\\:text-orange-500 {\n    --text-opacity: 1;\n    color: #ff5a1f;\n    color: rgba(255, 90, 31, var(--text-opacity));\n  }\n  .md\\:text-orange-600 {\n    --text-opacity: 1;\n    color: #d03801;\n    color: rgba(208, 56, 1, var(--text-opacity));\n  }\n  .md\\:text-orange-700 {\n    --text-opacity: 1;\n    color: #b43403;\n    color: rgba(180, 52, 3, var(--text-opacity));\n  }\n  .md\\:text-orange-800 {\n    --text-opacity: 1;\n    color: #8a2c0d;\n    color: rgba(138, 44, 13, var(--text-opacity));\n  }\n  .md\\:text-orange-900 {\n    --text-opacity: 1;\n    color: #73230d;\n    color: rgba(115, 35, 13, var(--text-opacity));\n  }\n  .md\\:text-yellow-50 {\n    --text-opacity: 1;\n    color: #fdfdea;\n    color: rgba(253, 253, 234, var(--text-opacity));\n  }\n  .md\\:text-yellow-100 {\n    --text-opacity: 1;\n    color: #fdf6b2;\n    color: rgba(253, 246, 178, var(--text-opacity));\n  }\n  .md\\:text-yellow-200 {\n    --text-opacity: 1;\n    color: #fce96a;\n    color: rgba(252, 233, 106, var(--text-opacity));\n  }\n  .md\\:text-yellow-300 {\n    --text-opacity: 1;\n    color: #faca15;\n    color: rgba(250, 202, 21, var(--text-opacity));\n  }\n  .md\\:text-yellow-400 {\n    --text-opacity: 1;\n    color: #e3a008;\n    color: rgba(227, 160, 8, var(--text-opacity));\n  }\n  .md\\:text-yellow-500 {\n    --text-opacity: 1;\n    color: #c27803;\n    color: rgba(194, 120, 3, var(--text-opacity));\n  }\n  .md\\:text-yellow-600 {\n    --text-opacity: 1;\n    color: #9f580a;\n    color: rgba(159, 88, 10, var(--text-opacity));\n  }\n  .md\\:text-yellow-700 {\n    --text-opacity: 1;\n    color: #8e4b10;\n    color: rgba(142, 75, 16, var(--text-opacity));\n  }\n  .md\\:text-yellow-800 {\n    --text-opacity: 1;\n    color: #723b13;\n    color: rgba(114, 59, 19, var(--text-opacity));\n  }\n  .md\\:text-yellow-900 {\n    --text-opacity: 1;\n    color: #633112;\n    color: rgba(99, 49, 18, var(--text-opacity));\n  }\n  .md\\:text-green-50 {\n    --text-opacity: 1;\n    color: #f3faf7;\n    color: rgba(243, 250, 247, var(--text-opacity));\n  }\n  .md\\:text-green-100 {\n    --text-opacity: 1;\n    color: #def7ec;\n    color: rgba(222, 247, 236, var(--text-opacity));\n  }\n  .md\\:text-green-200 {\n    --text-opacity: 1;\n    color: #bcf0da;\n    color: rgba(188, 240, 218, var(--text-opacity));\n  }\n  .md\\:text-green-300 {\n    --text-opacity: 1;\n    color: #84e1bc;\n    color: rgba(132, 225, 188, var(--text-opacity));\n  }\n  .md\\:text-green-400 {\n    --text-opacity: 1;\n    color: #31c48d;\n    color: rgba(49, 196, 141, var(--text-opacity));\n  }\n  .md\\:text-green-500 {\n    --text-opacity: 1;\n    color: #0e9f6e;\n    color: rgba(14, 159, 110, var(--text-opacity));\n  }\n  .md\\:text-green-600 {\n    --text-opacity: 1;\n    color: #057a55;\n    color: rgba(5, 122, 85, var(--text-opacity));\n  }\n  .md\\:text-green-700 {\n    --text-opacity: 1;\n    color: #046c4e;\n    color: rgba(4, 108, 78, var(--text-opacity));\n  }\n  .md\\:text-green-800 {\n    --text-opacity: 1;\n    color: #03543f;\n    color: rgba(3, 84, 63, var(--text-opacity));\n  }\n  .md\\:text-green-900 {\n    --text-opacity: 1;\n    color: #014737;\n    color: rgba(1, 71, 55, var(--text-opacity));\n  }\n  .md\\:text-teal-50 {\n    --text-opacity: 1;\n    color: #edfafa;\n    color: rgba(237, 250, 250, var(--text-opacity));\n  }\n  .md\\:text-teal-100 {\n    --text-opacity: 1;\n    color: #d5f5f6;\n    color: rgba(213, 245, 246, var(--text-opacity));\n  }\n  .md\\:text-teal-200 {\n    --text-opacity: 1;\n    color: #afecef;\n    color: rgba(175, 236, 239, var(--text-opacity));\n  }\n  .md\\:text-teal-300 {\n    --text-opacity: 1;\n    color: #7edce2;\n    color: rgba(126, 220, 226, var(--text-opacity));\n  }\n  .md\\:text-teal-400 {\n    --text-opacity: 1;\n    color: #16bdca;\n    color: rgba(22, 189, 202, var(--text-opacity));\n  }\n  .md\\:text-teal-500 {\n    --text-opacity: 1;\n    color: #0694a2;\n    color: rgba(6, 148, 162, var(--text-opacity));\n  }\n  .md\\:text-teal-600 {\n    --text-opacity: 1;\n    color: #047481;\n    color: rgba(4, 116, 129, var(--text-opacity));\n  }\n  .md\\:text-teal-700 {\n    --text-opacity: 1;\n    color: #036672;\n    color: rgba(3, 102, 114, var(--text-opacity));\n  }\n  .md\\:text-teal-800 {\n    --text-opacity: 1;\n    color: #05505c;\n    color: rgba(5, 80, 92, var(--text-opacity));\n  }\n  .md\\:text-teal-900 {\n    --text-opacity: 1;\n    color: #014451;\n    color: rgba(1, 68, 81, var(--text-opacity));\n  }\n  .md\\:text-blue-50 {\n    --text-opacity: 1;\n    color: #ebf5ff;\n    color: rgba(235, 245, 255, var(--text-opacity));\n  }\n  .md\\:text-blue-100 {\n    --text-opacity: 1;\n    color: #e1effe;\n    color: rgba(225, 239, 254, var(--text-opacity));\n  }\n  .md\\:text-blue-200 {\n    --text-opacity: 1;\n    color: #c3ddfd;\n    color: rgba(195, 221, 253, var(--text-opacity));\n  }\n  .md\\:text-blue-300 {\n    --text-opacity: 1;\n    color: #a4cafe;\n    color: rgba(164, 202, 254, var(--text-opacity));\n  }\n  .md\\:text-blue-400 {\n    --text-opacity: 1;\n    color: #76a9fa;\n    color: rgba(118, 169, 250, var(--text-opacity));\n  }\n  .md\\:text-blue-500 {\n    --text-opacity: 1;\n    color: #3f83f8;\n    color: rgba(63, 131, 248, var(--text-opacity));\n  }\n  .md\\:text-blue-600 {\n    --text-opacity: 1;\n    color: #1c64f2;\n    color: rgba(28, 100, 242, var(--text-opacity));\n  }\n  .md\\:text-blue-700 {\n    --text-opacity: 1;\n    color: #1a56db;\n    color: rgba(26, 86, 219, var(--text-opacity));\n  }\n  .md\\:text-blue-800 {\n    --text-opacity: 1;\n    color: #1e429f;\n    color: rgba(30, 66, 159, var(--text-opacity));\n  }\n  .md\\:text-blue-900 {\n    --text-opacity: 1;\n    color: #233876;\n    color: rgba(35, 56, 118, var(--text-opacity));\n  }\n  .md\\:text-indigo-50 {\n    --text-opacity: 1;\n    color: #f0f5ff;\n    color: rgba(240, 245, 255, var(--text-opacity));\n  }\n  .md\\:text-indigo-100 {\n    --text-opacity: 1;\n    color: #e5edff;\n    color: rgba(229, 237, 255, var(--text-opacity));\n  }\n  .md\\:text-indigo-200 {\n    --text-opacity: 1;\n    color: #cddbfe;\n    color: rgba(205, 219, 254, var(--text-opacity));\n  }\n  .md\\:text-indigo-300 {\n    --text-opacity: 1;\n    color: #b4c6fc;\n    color: rgba(180, 198, 252, var(--text-opacity));\n  }\n  .md\\:text-indigo-400 {\n    --text-opacity: 1;\n    color: #8da2fb;\n    color: rgba(141, 162, 251, var(--text-opacity));\n  }\n  .md\\:text-indigo-500 {\n    --text-opacity: 1;\n    color: #6875f5;\n    color: rgba(104, 117, 245, var(--text-opacity));\n  }\n  .md\\:text-indigo-600 {\n    --text-opacity: 1;\n    color: #5850ec;\n    color: rgba(88, 80, 236, var(--text-opacity));\n  }\n  .md\\:text-indigo-700 {\n    --text-opacity: 1;\n    color: #5145cd;\n    color: rgba(81, 69, 205, var(--text-opacity));\n  }\n  .md\\:text-indigo-800 {\n    --text-opacity: 1;\n    color: #42389d;\n    color: rgba(66, 56, 157, var(--text-opacity));\n  }\n  .md\\:text-indigo-900 {\n    --text-opacity: 1;\n    color: #362f78;\n    color: rgba(54, 47, 120, var(--text-opacity));\n  }\n  .md\\:text-purple-50 {\n    --text-opacity: 1;\n    color: #f6f5ff;\n    color: rgba(246, 245, 255, var(--text-opacity));\n  }\n  .md\\:text-purple-100 {\n    --text-opacity: 1;\n    color: #edebfe;\n    color: rgba(237, 235, 254, var(--text-opacity));\n  }\n  .md\\:text-purple-200 {\n    --text-opacity: 1;\n    color: #dcd7fe;\n    color: rgba(220, 215, 254, var(--text-opacity));\n  }\n  .md\\:text-purple-300 {\n    --text-opacity: 1;\n    color: #cabffd;\n    color: rgba(202, 191, 253, var(--text-opacity));\n  }\n  .md\\:text-purple-400 {\n    --text-opacity: 1;\n    color: #ac94fa;\n    color: rgba(172, 148, 250, var(--text-opacity));\n  }\n  .md\\:text-purple-500 {\n    --text-opacity: 1;\n    color: #9061f9;\n    color: rgba(144, 97, 249, var(--text-opacity));\n  }\n  .md\\:text-purple-600 {\n    --text-opacity: 1;\n    color: #7e3af2;\n    color: rgba(126, 58, 242, var(--text-opacity));\n  }\n  .md\\:text-purple-700 {\n    --text-opacity: 1;\n    color: #6c2bd9;\n    color: rgba(108, 43, 217, var(--text-opacity));\n  }\n  .md\\:text-purple-800 {\n    --text-opacity: 1;\n    color: #5521b5;\n    color: rgba(85, 33, 181, var(--text-opacity));\n  }\n  .md\\:text-purple-900 {\n    --text-opacity: 1;\n    color: #4a1d96;\n    color: rgba(74, 29, 150, var(--text-opacity));\n  }\n  .md\\:text-pink-50 {\n    --text-opacity: 1;\n    color: #fdf2f8;\n    color: rgba(253, 242, 248, var(--text-opacity));\n  }\n  .md\\:text-pink-100 {\n    --text-opacity: 1;\n    color: #fce8f3;\n    color: rgba(252, 232, 243, var(--text-opacity));\n  }\n  .md\\:text-pink-200 {\n    --text-opacity: 1;\n    color: #fad1e8;\n    color: rgba(250, 209, 232, var(--text-opacity));\n  }\n  .md\\:text-pink-300 {\n    --text-opacity: 1;\n    color: #f8b4d9;\n    color: rgba(248, 180, 217, var(--text-opacity));\n  }\n  .md\\:text-pink-400 {\n    --text-opacity: 1;\n    color: #f17eb8;\n    color: rgba(241, 126, 184, var(--text-opacity));\n  }\n  .md\\:text-pink-500 {\n    --text-opacity: 1;\n    color: #e74694;\n    color: rgba(231, 70, 148, var(--text-opacity));\n  }\n  .md\\:text-pink-600 {\n    --text-opacity: 1;\n    color: #d61f69;\n    color: rgba(214, 31, 105, var(--text-opacity));\n  }\n  .md\\:text-pink-700 {\n    --text-opacity: 1;\n    color: #bf125d;\n    color: rgba(191, 18, 93, var(--text-opacity));\n  }\n  .md\\:text-pink-800 {\n    --text-opacity: 1;\n    color: #99154b;\n    color: rgba(153, 21, 75, var(--text-opacity));\n  }\n  .md\\:text-pink-900 {\n    --text-opacity: 1;\n    color: #751a3d;\n    color: rgba(117, 26, 61, var(--text-opacity));\n  }\n  .md\\:text-cool-gray-50 {\n    --text-opacity: 1;\n    color: #f8fafc;\n    color: rgba(248, 250, 252, var(--text-opacity));\n  }\n  .md\\:text-cool-gray-100 {\n    --text-opacity: 1;\n    color: #f1f5f9;\n    color: rgba(241, 245, 249, var(--text-opacity));\n  }\n  .md\\:text-cool-gray-200 {\n    --text-opacity: 1;\n    color: #e2e8f0;\n    color: rgba(226, 232, 240, var(--text-opacity));\n  }\n  .md\\:text-cool-gray-300 {\n    --text-opacity: 1;\n    color: #cfd8e3;\n    color: rgba(207, 216, 227, var(--text-opacity));\n  }\n  .md\\:text-cool-gray-400 {\n    --text-opacity: 1;\n    color: #97a6ba;\n    color: rgba(151, 166, 186, var(--text-opacity));\n  }\n  .md\\:text-cool-gray-500 {\n    --text-opacity: 1;\n    color: #64748b;\n    color: rgba(100, 116, 139, var(--text-opacity));\n  }\n  .md\\:text-cool-gray-600 {\n    --text-opacity: 1;\n    color: #475569;\n    color: rgba(71, 85, 105, var(--text-opacity));\n  }\n  .md\\:text-cool-gray-700 {\n    --text-opacity: 1;\n    color: #364152;\n    color: rgba(54, 65, 82, var(--text-opacity));\n  }\n  .md\\:text-cool-gray-800 {\n    --text-opacity: 1;\n    color: #27303f;\n    color: rgba(39, 48, 63, var(--text-opacity));\n  }\n  .md\\:text-cool-gray-900 {\n    --text-opacity: 1;\n    color: #1a202e;\n    color: rgba(26, 32, 46, var(--text-opacity));\n  }\n  .group:hover .md\\:group-hover\\:text-current {\n    color: currentColor;\n  }\n  .group:hover .md\\:group-hover\\:text-transparent {\n    color: transparent;\n  }\n  .group:hover .md\\:group-hover\\:text-white {\n    --text-opacity: 1;\n    color: #ffffff;\n    color: rgba(255, 255, 255, var(--text-opacity));\n  }\n  .group:hover .md\\:group-hover\\:text-black {\n    --text-opacity: 1;\n    color: #000000;\n    color: rgba(0, 0, 0, var(--text-opacity));\n  }\n  .group:hover .md\\:group-hover\\:text-gray-50 {\n    --text-opacity: 1;\n    color: #f9fafb;\n    color: rgba(249, 250, 251, var(--text-opacity));\n  }\n  .group:hover .md\\:group-hover\\:text-gray-100 {\n    --text-opacity: 1;\n    color: #f4f5f7;\n    color: rgba(244, 245, 247, var(--text-opacity));\n  }\n  .group:hover .md\\:group-hover\\:text-gray-200 {\n    --text-opacity: 1;\n    color: #e5e7eb;\n    color: rgba(229, 231, 235, var(--text-opacity));\n  }\n  .group:hover .md\\:group-hover\\:text-gray-300 {\n    --text-opacity: 1;\n    color: #d2d6dc;\n    color: rgba(210, 214, 220, var(--text-opacity));\n  }\n  .group:hover .md\\:group-hover\\:text-gray-400 {\n    --text-opacity: 1;\n    color: #9fa6b2;\n    color: rgba(159, 166, 178, var(--text-opacity));\n  }\n  .group:hover .md\\:group-hover\\:text-gray-500 {\n    --text-opacity: 1;\n    color: #6b7280;\n    color: rgba(107, 114, 128, var(--text-opacity));\n  }\n  .group:hover .md\\:group-hover\\:text-gray-600 {\n    --text-opacity: 1;\n    color: #4b5563;\n    color: rgba(75, 85, 99, var(--text-opacity));\n  }\n  .group:hover .md\\:group-hover\\:text-gray-700 {\n    --text-opacity: 1;\n    color: #374151;\n    color: rgba(55, 65, 81, var(--text-opacity));\n  }\n  .group:hover .md\\:group-hover\\:text-gray-800 {\n    --text-opacity: 1;\n    color: #252f3f;\n    color: rgba(37, 47, 63, var(--text-opacity));\n  }\n  .group:hover .md\\:group-hover\\:text-gray-900 {\n    --text-opacity: 1;\n    color: #161e2e;\n    color: rgba(22, 30, 46, var(--text-opacity));\n  }\n  .group:hover .md\\:group-hover\\:text-red-50 {\n    --text-opacity: 1;\n    color: #fdf2f2;\n    color: rgba(253, 242, 242, var(--text-opacity));\n  }\n  .group:hover .md\\:group-hover\\:text-red-100 {\n    --text-opacity: 1;\n    color: #fde8e8;\n    color: rgba(253, 232, 232, var(--text-opacity));\n  }\n  .group:hover .md\\:group-hover\\:text-red-200 {\n    --text-opacity: 1;\n    color: #fbd5d5;\n    color: rgba(251, 213, 213, var(--text-opacity));\n  }\n  .group:hover .md\\:group-hover\\:text-red-300 {\n    --text-opacity: 1;\n    color: #f8b4b4;\n    color: rgba(248, 180, 180, var(--text-opacity));\n  }\n  .group:hover .md\\:group-hover\\:text-red-400 {\n    --text-opacity: 1;\n    color: #f98080;\n    color: rgba(249, 128, 128, var(--text-opacity));\n  }\n  .group:hover .md\\:group-hover\\:text-red-500 {\n    --text-opacity: 1;\n    color: #f05252;\n    color: rgba(240, 82, 82, var(--text-opacity));\n  }\n  .group:hover .md\\:group-hover\\:text-red-600 {\n    --text-opacity: 1;\n    color: #e02424;\n    color: rgba(224, 36, 36, var(--text-opacity));\n  }\n  .group:hover .md\\:group-hover\\:text-red-700 {\n    --text-opacity: 1;\n    color: #c81e1e;\n    color: rgba(200, 30, 30, var(--text-opacity));\n  }\n  .group:hover .md\\:group-hover\\:text-red-800 {\n    --text-opacity: 1;\n    color: #9b1c1c;\n    color: rgba(155, 28, 28, var(--text-opacity));\n  }\n  .group:hover .md\\:group-hover\\:text-red-900 {\n    --text-opacity: 1;\n    color: #771d1d;\n    color: rgba(119, 29, 29, var(--text-opacity));\n  }\n  .group:hover .md\\:group-hover\\:text-orange-50 {\n    --text-opacity: 1;\n    color: #fff8f1;\n    color: rgba(255, 248, 241, var(--text-opacity));\n  }\n  .group:hover .md\\:group-hover\\:text-orange-100 {\n    --text-opacity: 1;\n    color: #feecdc;\n    color: rgba(254, 236, 220, var(--text-opacity));\n  }\n  .group:hover .md\\:group-hover\\:text-orange-200 {\n    --text-opacity: 1;\n    color: #fcd9bd;\n    color: rgba(252, 217, 189, var(--text-opacity));\n  }\n  .group:hover .md\\:group-hover\\:text-orange-300 {\n    --text-opacity: 1;\n    color: #fdba8c;\n    color: rgba(253, 186, 140, var(--text-opacity));\n  }\n  .group:hover .md\\:group-hover\\:text-orange-400 {\n    --text-opacity: 1;\n    color: #ff8a4c;\n    color: rgba(255, 138, 76, var(--text-opacity));\n  }\n  .group:hover .md\\:group-hover\\:text-orange-500 {\n    --text-opacity: 1;\n    color: #ff5a1f;\n    color: rgba(255, 90, 31, var(--text-opacity));\n  }\n  .group:hover .md\\:group-hover\\:text-orange-600 {\n    --text-opacity: 1;\n    color: #d03801;\n    color: rgba(208, 56, 1, var(--text-opacity));\n  }\n  .group:hover .md\\:group-hover\\:text-orange-700 {\n    --text-opacity: 1;\n    color: #b43403;\n    color: rgba(180, 52, 3, var(--text-opacity));\n  }\n  .group:hover .md\\:group-hover\\:text-orange-800 {\n    --text-opacity: 1;\n    color: #8a2c0d;\n    color: rgba(138, 44, 13, var(--text-opacity));\n  }\n  .group:hover .md\\:group-hover\\:text-orange-900 {\n    --text-opacity: 1;\n    color: #73230d;\n    color: rgba(115, 35, 13, var(--text-opacity));\n  }\n  .group:hover .md\\:group-hover\\:text-yellow-50 {\n    --text-opacity: 1;\n    color: #fdfdea;\n    color: rgba(253, 253, 234, var(--text-opacity));\n  }\n  .group:hover .md\\:group-hover\\:text-yellow-100 {\n    --text-opacity: 1;\n    color: #fdf6b2;\n    color: rgba(253, 246, 178, var(--text-opacity));\n  }\n  .group:hover .md\\:group-hover\\:text-yellow-200 {\n    --text-opacity: 1;\n    color: #fce96a;\n    color: rgba(252, 233, 106, var(--text-opacity));\n  }\n  .group:hover .md\\:group-hover\\:text-yellow-300 {\n    --text-opacity: 1;\n    color: #faca15;\n    color: rgba(250, 202, 21, var(--text-opacity));\n  }\n  .group:hover .md\\:group-hover\\:text-yellow-400 {\n    --text-opacity: 1;\n    color: #e3a008;\n    color: rgba(227, 160, 8, var(--text-opacity));\n  }\n  .group:hover .md\\:group-hover\\:text-yellow-500 {\n    --text-opacity: 1;\n    color: #c27803;\n    color: rgba(194, 120, 3, var(--text-opacity));\n  }\n  .group:hover .md\\:group-hover\\:text-yellow-600 {\n    --text-opacity: 1;\n    color: #9f580a;\n    color: rgba(159, 88, 10, var(--text-opacity));\n  }\n  .group:hover .md\\:group-hover\\:text-yellow-700 {\n    --text-opacity: 1;\n    color: #8e4b10;\n    color: rgba(142, 75, 16, var(--text-opacity));\n  }\n  .group:hover .md\\:group-hover\\:text-yellow-800 {\n    --text-opacity: 1;\n    color: #723b13;\n    color: rgba(114, 59, 19, var(--text-opacity));\n  }\n  .group:hover .md\\:group-hover\\:text-yellow-900 {\n    --text-opacity: 1;\n    color: #633112;\n    color: rgba(99, 49, 18, var(--text-opacity));\n  }\n  .group:hover .md\\:group-hover\\:text-green-50 {\n    --text-opacity: 1;\n    color: #f3faf7;\n    color: rgba(243, 250, 247, var(--text-opacity));\n  }\n  .group:hover .md\\:group-hover\\:text-green-100 {\n    --text-opacity: 1;\n    color: #def7ec;\n    color: rgba(222, 247, 236, var(--text-opacity));\n  }\n  .group:hover .md\\:group-hover\\:text-green-200 {\n    --text-opacity: 1;\n    color: #bcf0da;\n    color: rgba(188, 240, 218, var(--text-opacity));\n  }\n  .group:hover .md\\:group-hover\\:text-green-300 {\n    --text-opacity: 1;\n    color: #84e1bc;\n    color: rgba(132, 225, 188, var(--text-opacity));\n  }\n  .group:hover .md\\:group-hover\\:text-green-400 {\n    --text-opacity: 1;\n    color: #31c48d;\n    color: rgba(49, 196, 141, var(--text-opacity));\n  }\n  .group:hover .md\\:group-hover\\:text-green-500 {\n    --text-opacity: 1;\n    color: #0e9f6e;\n    color: rgba(14, 159, 110, var(--text-opacity));\n  }\n  .group:hover .md\\:group-hover\\:text-green-600 {\n    --text-opacity: 1;\n    color: #057a55;\n    color: rgba(5, 122, 85, var(--text-opacity));\n  }\n  .group:hover .md\\:group-hover\\:text-green-700 {\n    --text-opacity: 1;\n    color: #046c4e;\n    color: rgba(4, 108, 78, var(--text-opacity));\n  }\n  .group:hover .md\\:group-hover\\:text-green-800 {\n    --text-opacity: 1;\n    color: #03543f;\n    color: rgba(3, 84, 63, var(--text-opacity));\n  }\n  .group:hover .md\\:group-hover\\:text-green-900 {\n    --text-opacity: 1;\n    color: #014737;\n    color: rgba(1, 71, 55, var(--text-opacity));\n  }\n  .group:hover .md\\:group-hover\\:text-teal-50 {\n    --text-opacity: 1;\n    color: #edfafa;\n    color: rgba(237, 250, 250, var(--text-opacity));\n  }\n  .group:hover .md\\:group-hover\\:text-teal-100 {\n    --text-opacity: 1;\n    color: #d5f5f6;\n    color: rgba(213, 245, 246, var(--text-opacity));\n  }\n  .group:hover .md\\:group-hover\\:text-teal-200 {\n    --text-opacity: 1;\n    color: #afecef;\n    color: rgba(175, 236, 239, var(--text-opacity));\n  }\n  .group:hover .md\\:group-hover\\:text-teal-300 {\n    --text-opacity: 1;\n    color: #7edce2;\n    color: rgba(126, 220, 226, var(--text-opacity));\n  }\n  .group:hover .md\\:group-hover\\:text-teal-400 {\n    --text-opacity: 1;\n    color: #16bdca;\n    color: rgba(22, 189, 202, var(--text-opacity));\n  }\n  .group:hover .md\\:group-hover\\:text-teal-500 {\n    --text-opacity: 1;\n    color: #0694a2;\n    color: rgba(6, 148, 162, var(--text-opacity));\n  }\n  .group:hover .md\\:group-hover\\:text-teal-600 {\n    --text-opacity: 1;\n    color: #047481;\n    color: rgba(4, 116, 129, var(--text-opacity));\n  }\n  .group:hover .md\\:group-hover\\:text-teal-700 {\n    --text-opacity: 1;\n    color: #036672;\n    color: rgba(3, 102, 114, var(--text-opacity));\n  }\n  .group:hover .md\\:group-hover\\:text-teal-800 {\n    --text-opacity: 1;\n    color: #05505c;\n    color: rgba(5, 80, 92, var(--text-opacity));\n  }\n  .group:hover .md\\:group-hover\\:text-teal-900 {\n    --text-opacity: 1;\n    color: #014451;\n    color: rgba(1, 68, 81, var(--text-opacity));\n  }\n  .group:hover .md\\:group-hover\\:text-blue-50 {\n    --text-opacity: 1;\n    color: #ebf5ff;\n    color: rgba(235, 245, 255, var(--text-opacity));\n  }\n  .group:hover .md\\:group-hover\\:text-blue-100 {\n    --text-opacity: 1;\n    color: #e1effe;\n    color: rgba(225, 239, 254, var(--text-opacity));\n  }\n  .group:hover .md\\:group-hover\\:text-blue-200 {\n    --text-opacity: 1;\n    color: #c3ddfd;\n    color: rgba(195, 221, 253, var(--text-opacity));\n  }\n  .group:hover .md\\:group-hover\\:text-blue-300 {\n    --text-opacity: 1;\n    color: #a4cafe;\n    color: rgba(164, 202, 254, var(--text-opacity));\n  }\n  .group:hover .md\\:group-hover\\:text-blue-400 {\n    --text-opacity: 1;\n    color: #76a9fa;\n    color: rgba(118, 169, 250, var(--text-opacity));\n  }\n  .group:hover .md\\:group-hover\\:text-blue-500 {\n    --text-opacity: 1;\n    color: #3f83f8;\n    color: rgba(63, 131, 248, var(--text-opacity));\n  }\n  .group:hover .md\\:group-hover\\:text-blue-600 {\n    --text-opacity: 1;\n    color: #1c64f2;\n    color: rgba(28, 100, 242, var(--text-opacity));\n  }\n  .group:hover .md\\:group-hover\\:text-blue-700 {\n    --text-opacity: 1;\n    color: #1a56db;\n    color: rgba(26, 86, 219, var(--text-opacity));\n  }\n  .group:hover .md\\:group-hover\\:text-blue-800 {\n    --text-opacity: 1;\n    color: #1e429f;\n    color: rgba(30, 66, 159, var(--text-opacity));\n  }\n  .group:hover .md\\:group-hover\\:text-blue-900 {\n    --text-opacity: 1;\n    color: #233876;\n    color: rgba(35, 56, 118, var(--text-opacity));\n  }\n  .group:hover .md\\:group-hover\\:text-indigo-50 {\n    --text-opacity: 1;\n    color: #f0f5ff;\n    color: rgba(240, 245, 255, var(--text-opacity));\n  }\n  .group:hover .md\\:group-hover\\:text-indigo-100 {\n    --text-opacity: 1;\n    color: #e5edff;\n    color: rgba(229, 237, 255, var(--text-opacity));\n  }\n  .group:hover .md\\:group-hover\\:text-indigo-200 {\n    --text-opacity: 1;\n    color: #cddbfe;\n    color: rgba(205, 219, 254, var(--text-opacity));\n  }\n  .group:hover .md\\:group-hover\\:text-indigo-300 {\n    --text-opacity: 1;\n    color: #b4c6fc;\n    color: rgba(180, 198, 252, var(--text-opacity));\n  }\n  .group:hover .md\\:group-hover\\:text-indigo-400 {\n    --text-opacity: 1;\n    color: #8da2fb;\n    color: rgba(141, 162, 251, var(--text-opacity));\n  }\n  .group:hover .md\\:group-hover\\:text-indigo-500 {\n    --text-opacity: 1;\n    color: #6875f5;\n    color: rgba(104, 117, 245, var(--text-opacity));\n  }\n  .group:hover .md\\:group-hover\\:text-indigo-600 {\n    --text-opacity: 1;\n    color: #5850ec;\n    color: rgba(88, 80, 236, var(--text-opacity));\n  }\n  .group:hover .md\\:group-hover\\:text-indigo-700 {\n    --text-opacity: 1;\n    color: #5145cd;\n    color: rgba(81, 69, 205, var(--text-opacity));\n  }\n  .group:hover .md\\:group-hover\\:text-indigo-800 {\n    --text-opacity: 1;\n    color: #42389d;\n    color: rgba(66, 56, 157, var(--text-opacity));\n  }\n  .group:hover .md\\:group-hover\\:text-indigo-900 {\n    --text-opacity: 1;\n    color: #362f78;\n    color: rgba(54, 47, 120, var(--text-opacity));\n  }\n  .group:hover .md\\:group-hover\\:text-purple-50 {\n    --text-opacity: 1;\n    color: #f6f5ff;\n    color: rgba(246, 245, 255, var(--text-opacity));\n  }\n  .group:hover .md\\:group-hover\\:text-purple-100 {\n    --text-opacity: 1;\n    color: #edebfe;\n    color: rgba(237, 235, 254, var(--text-opacity));\n  }\n  .group:hover .md\\:group-hover\\:text-purple-200 {\n    --text-opacity: 1;\n    color: #dcd7fe;\n    color: rgba(220, 215, 254, var(--text-opacity));\n  }\n  .group:hover .md\\:group-hover\\:text-purple-300 {\n    --text-opacity: 1;\n    color: #cabffd;\n    color: rgba(202, 191, 253, var(--text-opacity));\n  }\n  .group:hover .md\\:group-hover\\:text-purple-400 {\n    --text-opacity: 1;\n    color: #ac94fa;\n    color: rgba(172, 148, 250, var(--text-opacity));\n  }\n  .group:hover .md\\:group-hover\\:text-purple-500 {\n    --text-opacity: 1;\n    color: #9061f9;\n    color: rgba(144, 97, 249, var(--text-opacity));\n  }\n  .group:hover .md\\:group-hover\\:text-purple-600 {\n    --text-opacity: 1;\n    color: #7e3af2;\n    color: rgba(126, 58, 242, var(--text-opacity));\n  }\n  .group:hover .md\\:group-hover\\:text-purple-700 {\n    --text-opacity: 1;\n    color: #6c2bd9;\n    color: rgba(108, 43, 217, var(--text-opacity));\n  }\n  .group:hover .md\\:group-hover\\:text-purple-800 {\n    --text-opacity: 1;\n    color: #5521b5;\n    color: rgba(85, 33, 181, var(--text-opacity));\n  }\n  .group:hover .md\\:group-hover\\:text-purple-900 {\n    --text-opacity: 1;\n    color: #4a1d96;\n    color: rgba(74, 29, 150, var(--text-opacity));\n  }\n  .group:hover .md\\:group-hover\\:text-pink-50 {\n    --text-opacity: 1;\n    color: #fdf2f8;\n    color: rgba(253, 242, 248, var(--text-opacity));\n  }\n  .group:hover .md\\:group-hover\\:text-pink-100 {\n    --text-opacity: 1;\n    color: #fce8f3;\n    color: rgba(252, 232, 243, var(--text-opacity));\n  }\n  .group:hover .md\\:group-hover\\:text-pink-200 {\n    --text-opacity: 1;\n    color: #fad1e8;\n    color: rgba(250, 209, 232, var(--text-opacity));\n  }\n  .group:hover .md\\:group-hover\\:text-pink-300 {\n    --text-opacity: 1;\n    color: #f8b4d9;\n    color: rgba(248, 180, 217, var(--text-opacity));\n  }\n  .group:hover .md\\:group-hover\\:text-pink-400 {\n    --text-opacity: 1;\n    color: #f17eb8;\n    color: rgba(241, 126, 184, var(--text-opacity));\n  }\n  .group:hover .md\\:group-hover\\:text-pink-500 {\n    --text-opacity: 1;\n    color: #e74694;\n    color: rgba(231, 70, 148, var(--text-opacity));\n  }\n  .group:hover .md\\:group-hover\\:text-pink-600 {\n    --text-opacity: 1;\n    color: #d61f69;\n    color: rgba(214, 31, 105, var(--text-opacity));\n  }\n  .group:hover .md\\:group-hover\\:text-pink-700 {\n    --text-opacity: 1;\n    color: #bf125d;\n    color: rgba(191, 18, 93, var(--text-opacity));\n  }\n  .group:hover .md\\:group-hover\\:text-pink-800 {\n    --text-opacity: 1;\n    color: #99154b;\n    color: rgba(153, 21, 75, var(--text-opacity));\n  }\n  .group:hover .md\\:group-hover\\:text-pink-900 {\n    --text-opacity: 1;\n    color: #751a3d;\n    color: rgba(117, 26, 61, var(--text-opacity));\n  }\n  .group:hover .md\\:group-hover\\:text-cool-gray-50 {\n    --text-opacity: 1;\n    color: #f8fafc;\n    color: rgba(248, 250, 252, var(--text-opacity));\n  }\n  .group:hover .md\\:group-hover\\:text-cool-gray-100 {\n    --text-opacity: 1;\n    color: #f1f5f9;\n    color: rgba(241, 245, 249, var(--text-opacity));\n  }\n  .group:hover .md\\:group-hover\\:text-cool-gray-200 {\n    --text-opacity: 1;\n    color: #e2e8f0;\n    color: rgba(226, 232, 240, var(--text-opacity));\n  }\n  .group:hover .md\\:group-hover\\:text-cool-gray-300 {\n    --text-opacity: 1;\n    color: #cfd8e3;\n    color: rgba(207, 216, 227, var(--text-opacity));\n  }\n  .group:hover .md\\:group-hover\\:text-cool-gray-400 {\n    --text-opacity: 1;\n    color: #97a6ba;\n    color: rgba(151, 166, 186, var(--text-opacity));\n  }\n  .group:hover .md\\:group-hover\\:text-cool-gray-500 {\n    --text-opacity: 1;\n    color: #64748b;\n    color: rgba(100, 116, 139, var(--text-opacity));\n  }\n  .group:hover .md\\:group-hover\\:text-cool-gray-600 {\n    --text-opacity: 1;\n    color: #475569;\n    color: rgba(71, 85, 105, var(--text-opacity));\n  }\n  .group:hover .md\\:group-hover\\:text-cool-gray-700 {\n    --text-opacity: 1;\n    color: #364152;\n    color: rgba(54, 65, 82, var(--text-opacity));\n  }\n  .group:hover .md\\:group-hover\\:text-cool-gray-800 {\n    --text-opacity: 1;\n    color: #27303f;\n    color: rgba(39, 48, 63, var(--text-opacity));\n  }\n  .group:hover .md\\:group-hover\\:text-cool-gray-900 {\n    --text-opacity: 1;\n    color: #1a202e;\n    color: rgba(26, 32, 46, var(--text-opacity));\n  }\n  .group:focus .md\\:group-focus\\:text-current {\n    color: currentColor;\n  }\n  .group:focus .md\\:group-focus\\:text-transparent {\n    color: transparent;\n  }\n  .group:focus .md\\:group-focus\\:text-white {\n    --text-opacity: 1;\n    color: #ffffff;\n    color: rgba(255, 255, 255, var(--text-opacity));\n  }\n  .group:focus .md\\:group-focus\\:text-black {\n    --text-opacity: 1;\n    color: #000000;\n    color: rgba(0, 0, 0, var(--text-opacity));\n  }\n  .group:focus .md\\:group-focus\\:text-gray-50 {\n    --text-opacity: 1;\n    color: #f9fafb;\n    color: rgba(249, 250, 251, var(--text-opacity));\n  }\n  .group:focus .md\\:group-focus\\:text-gray-100 {\n    --text-opacity: 1;\n    color: #f4f5f7;\n    color: rgba(244, 245, 247, var(--text-opacity));\n  }\n  .group:focus .md\\:group-focus\\:text-gray-200 {\n    --text-opacity: 1;\n    color: #e5e7eb;\n    color: rgba(229, 231, 235, var(--text-opacity));\n  }\n  .group:focus .md\\:group-focus\\:text-gray-300 {\n    --text-opacity: 1;\n    color: #d2d6dc;\n    color: rgba(210, 214, 220, var(--text-opacity));\n  }\n  .group:focus .md\\:group-focus\\:text-gray-400 {\n    --text-opacity: 1;\n    color: #9fa6b2;\n    color: rgba(159, 166, 178, var(--text-opacity));\n  }\n  .group:focus .md\\:group-focus\\:text-gray-500 {\n    --text-opacity: 1;\n    color: #6b7280;\n    color: rgba(107, 114, 128, var(--text-opacity));\n  }\n  .group:focus .md\\:group-focus\\:text-gray-600 {\n    --text-opacity: 1;\n    color: #4b5563;\n    color: rgba(75, 85, 99, var(--text-opacity));\n  }\n  .group:focus .md\\:group-focus\\:text-gray-700 {\n    --text-opacity: 1;\n    color: #374151;\n    color: rgba(55, 65, 81, var(--text-opacity));\n  }\n  .group:focus .md\\:group-focus\\:text-gray-800 {\n    --text-opacity: 1;\n    color: #252f3f;\n    color: rgba(37, 47, 63, var(--text-opacity));\n  }\n  .group:focus .md\\:group-focus\\:text-gray-900 {\n    --text-opacity: 1;\n    color: #161e2e;\n    color: rgba(22, 30, 46, var(--text-opacity));\n  }\n  .group:focus .md\\:group-focus\\:text-red-50 {\n    --text-opacity: 1;\n    color: #fdf2f2;\n    color: rgba(253, 242, 242, var(--text-opacity));\n  }\n  .group:focus .md\\:group-focus\\:text-red-100 {\n    --text-opacity: 1;\n    color: #fde8e8;\n    color: rgba(253, 232, 232, var(--text-opacity));\n  }\n  .group:focus .md\\:group-focus\\:text-red-200 {\n    --text-opacity: 1;\n    color: #fbd5d5;\n    color: rgba(251, 213, 213, var(--text-opacity));\n  }\n  .group:focus .md\\:group-focus\\:text-red-300 {\n    --text-opacity: 1;\n    color: #f8b4b4;\n    color: rgba(248, 180, 180, var(--text-opacity));\n  }\n  .group:focus .md\\:group-focus\\:text-red-400 {\n    --text-opacity: 1;\n    color: #f98080;\n    color: rgba(249, 128, 128, var(--text-opacity));\n  }\n  .group:focus .md\\:group-focus\\:text-red-500 {\n    --text-opacity: 1;\n    color: #f05252;\n    color: rgba(240, 82, 82, var(--text-opacity));\n  }\n  .group:focus .md\\:group-focus\\:text-red-600 {\n    --text-opacity: 1;\n    color: #e02424;\n    color: rgba(224, 36, 36, var(--text-opacity));\n  }\n  .group:focus .md\\:group-focus\\:text-red-700 {\n    --text-opacity: 1;\n    color: #c81e1e;\n    color: rgba(200, 30, 30, var(--text-opacity));\n  }\n  .group:focus .md\\:group-focus\\:text-red-800 {\n    --text-opacity: 1;\n    color: #9b1c1c;\n    color: rgba(155, 28, 28, var(--text-opacity));\n  }\n  .group:focus .md\\:group-focus\\:text-red-900 {\n    --text-opacity: 1;\n    color: #771d1d;\n    color: rgba(119, 29, 29, var(--text-opacity));\n  }\n  .group:focus .md\\:group-focus\\:text-orange-50 {\n    --text-opacity: 1;\n    color: #fff8f1;\n    color: rgba(255, 248, 241, var(--text-opacity));\n  }\n  .group:focus .md\\:group-focus\\:text-orange-100 {\n    --text-opacity: 1;\n    color: #feecdc;\n    color: rgba(254, 236, 220, var(--text-opacity));\n  }\n  .group:focus .md\\:group-focus\\:text-orange-200 {\n    --text-opacity: 1;\n    color: #fcd9bd;\n    color: rgba(252, 217, 189, var(--text-opacity));\n  }\n  .group:focus .md\\:group-focus\\:text-orange-300 {\n    --text-opacity: 1;\n    color: #fdba8c;\n    color: rgba(253, 186, 140, var(--text-opacity));\n  }\n  .group:focus .md\\:group-focus\\:text-orange-400 {\n    --text-opacity: 1;\n    color: #ff8a4c;\n    color: rgba(255, 138, 76, var(--text-opacity));\n  }\n  .group:focus .md\\:group-focus\\:text-orange-500 {\n    --text-opacity: 1;\n    color: #ff5a1f;\n    color: rgba(255, 90, 31, var(--text-opacity));\n  }\n  .group:focus .md\\:group-focus\\:text-orange-600 {\n    --text-opacity: 1;\n    color: #d03801;\n    color: rgba(208, 56, 1, var(--text-opacity));\n  }\n  .group:focus .md\\:group-focus\\:text-orange-700 {\n    --text-opacity: 1;\n    color: #b43403;\n    color: rgba(180, 52, 3, var(--text-opacity));\n  }\n  .group:focus .md\\:group-focus\\:text-orange-800 {\n    --text-opacity: 1;\n    color: #8a2c0d;\n    color: rgba(138, 44, 13, var(--text-opacity));\n  }\n  .group:focus .md\\:group-focus\\:text-orange-900 {\n    --text-opacity: 1;\n    color: #73230d;\n    color: rgba(115, 35, 13, var(--text-opacity));\n  }\n  .group:focus .md\\:group-focus\\:text-yellow-50 {\n    --text-opacity: 1;\n    color: #fdfdea;\n    color: rgba(253, 253, 234, var(--text-opacity));\n  }\n  .group:focus .md\\:group-focus\\:text-yellow-100 {\n    --text-opacity: 1;\n    color: #fdf6b2;\n    color: rgba(253, 246, 178, var(--text-opacity));\n  }\n  .group:focus .md\\:group-focus\\:text-yellow-200 {\n    --text-opacity: 1;\n    color: #fce96a;\n    color: rgba(252, 233, 106, var(--text-opacity));\n  }\n  .group:focus .md\\:group-focus\\:text-yellow-300 {\n    --text-opacity: 1;\n    color: #faca15;\n    color: rgba(250, 202, 21, var(--text-opacity));\n  }\n  .group:focus .md\\:group-focus\\:text-yellow-400 {\n    --text-opacity: 1;\n    color: #e3a008;\n    color: rgba(227, 160, 8, var(--text-opacity));\n  }\n  .group:focus .md\\:group-focus\\:text-yellow-500 {\n    --text-opacity: 1;\n    color: #c27803;\n    color: rgba(194, 120, 3, var(--text-opacity));\n  }\n  .group:focus .md\\:group-focus\\:text-yellow-600 {\n    --text-opacity: 1;\n    color: #9f580a;\n    color: rgba(159, 88, 10, var(--text-opacity));\n  }\n  .group:focus .md\\:group-focus\\:text-yellow-700 {\n    --text-opacity: 1;\n    color: #8e4b10;\n    color: rgba(142, 75, 16, var(--text-opacity));\n  }\n  .group:focus .md\\:group-focus\\:text-yellow-800 {\n    --text-opacity: 1;\n    color: #723b13;\n    color: rgba(114, 59, 19, var(--text-opacity));\n  }\n  .group:focus .md\\:group-focus\\:text-yellow-900 {\n    --text-opacity: 1;\n    color: #633112;\n    color: rgba(99, 49, 18, var(--text-opacity));\n  }\n  .group:focus .md\\:group-focus\\:text-green-50 {\n    --text-opacity: 1;\n    color: #f3faf7;\n    color: rgba(243, 250, 247, var(--text-opacity));\n  }\n  .group:focus .md\\:group-focus\\:text-green-100 {\n    --text-opacity: 1;\n    color: #def7ec;\n    color: rgba(222, 247, 236, var(--text-opacity));\n  }\n  .group:focus .md\\:group-focus\\:text-green-200 {\n    --text-opacity: 1;\n    color: #bcf0da;\n    color: rgba(188, 240, 218, var(--text-opacity));\n  }\n  .group:focus .md\\:group-focus\\:text-green-300 {\n    --text-opacity: 1;\n    color: #84e1bc;\n    color: rgba(132, 225, 188, var(--text-opacity));\n  }\n  .group:focus .md\\:group-focus\\:text-green-400 {\n    --text-opacity: 1;\n    color: #31c48d;\n    color: rgba(49, 196, 141, var(--text-opacity));\n  }\n  .group:focus .md\\:group-focus\\:text-green-500 {\n    --text-opacity: 1;\n    color: #0e9f6e;\n    color: rgba(14, 159, 110, var(--text-opacity));\n  }\n  .group:focus .md\\:group-focus\\:text-green-600 {\n    --text-opacity: 1;\n    color: #057a55;\n    color: rgba(5, 122, 85, var(--text-opacity));\n  }\n  .group:focus .md\\:group-focus\\:text-green-700 {\n    --text-opacity: 1;\n    color: #046c4e;\n    color: rgba(4, 108, 78, var(--text-opacity));\n  }\n  .group:focus .md\\:group-focus\\:text-green-800 {\n    --text-opacity: 1;\n    color: #03543f;\n    color: rgba(3, 84, 63, var(--text-opacity));\n  }\n  .group:focus .md\\:group-focus\\:text-green-900 {\n    --text-opacity: 1;\n    color: #014737;\n    color: rgba(1, 71, 55, var(--text-opacity));\n  }\n  .group:focus .md\\:group-focus\\:text-teal-50 {\n    --text-opacity: 1;\n    color: #edfafa;\n    color: rgba(237, 250, 250, var(--text-opacity));\n  }\n  .group:focus .md\\:group-focus\\:text-teal-100 {\n    --text-opacity: 1;\n    color: #d5f5f6;\n    color: rgba(213, 245, 246, var(--text-opacity));\n  }\n  .group:focus .md\\:group-focus\\:text-teal-200 {\n    --text-opacity: 1;\n    color: #afecef;\n    color: rgba(175, 236, 239, var(--text-opacity));\n  }\n  .group:focus .md\\:group-focus\\:text-teal-300 {\n    --text-opacity: 1;\n    color: #7edce2;\n    color: rgba(126, 220, 226, var(--text-opacity));\n  }\n  .group:focus .md\\:group-focus\\:text-teal-400 {\n    --text-opacity: 1;\n    color: #16bdca;\n    color: rgba(22, 189, 202, var(--text-opacity));\n  }\n  .group:focus .md\\:group-focus\\:text-teal-500 {\n    --text-opacity: 1;\n    color: #0694a2;\n    color: rgba(6, 148, 162, var(--text-opacity));\n  }\n  .group:focus .md\\:group-focus\\:text-teal-600 {\n    --text-opacity: 1;\n    color: #047481;\n    color: rgba(4, 116, 129, var(--text-opacity));\n  }\n  .group:focus .md\\:group-focus\\:text-teal-700 {\n    --text-opacity: 1;\n    color: #036672;\n    color: rgba(3, 102, 114, var(--text-opacity));\n  }\n  .group:focus .md\\:group-focus\\:text-teal-800 {\n    --text-opacity: 1;\n    color: #05505c;\n    color: rgba(5, 80, 92, var(--text-opacity));\n  }\n  .group:focus .md\\:group-focus\\:text-teal-900 {\n    --text-opacity: 1;\n    color: #014451;\n    color: rgba(1, 68, 81, var(--text-opacity));\n  }\n  .group:focus .md\\:group-focus\\:text-blue-50 {\n    --text-opacity: 1;\n    color: #ebf5ff;\n    color: rgba(235, 245, 255, var(--text-opacity));\n  }\n  .group:focus .md\\:group-focus\\:text-blue-100 {\n    --text-opacity: 1;\n    color: #e1effe;\n    color: rgba(225, 239, 254, var(--text-opacity));\n  }\n  .group:focus .md\\:group-focus\\:text-blue-200 {\n    --text-opacity: 1;\n    color: #c3ddfd;\n    color: rgba(195, 221, 253, var(--text-opacity));\n  }\n  .group:focus .md\\:group-focus\\:text-blue-300 {\n    --text-opacity: 1;\n    color: #a4cafe;\n    color: rgba(164, 202, 254, var(--text-opacity));\n  }\n  .group:focus .md\\:group-focus\\:text-blue-400 {\n    --text-opacity: 1;\n    color: #76a9fa;\n    color: rgba(118, 169, 250, var(--text-opacity));\n  }\n  .group:focus .md\\:group-focus\\:text-blue-500 {\n    --text-opacity: 1;\n    color: #3f83f8;\n    color: rgba(63, 131, 248, var(--text-opacity));\n  }\n  .group:focus .md\\:group-focus\\:text-blue-600 {\n    --text-opacity: 1;\n    color: #1c64f2;\n    color: rgba(28, 100, 242, var(--text-opacity));\n  }\n  .group:focus .md\\:group-focus\\:text-blue-700 {\n    --text-opacity: 1;\n    color: #1a56db;\n    color: rgba(26, 86, 219, var(--text-opacity));\n  }\n  .group:focus .md\\:group-focus\\:text-blue-800 {\n    --text-opacity: 1;\n    color: #1e429f;\n    color: rgba(30, 66, 159, var(--text-opacity));\n  }\n  .group:focus .md\\:group-focus\\:text-blue-900 {\n    --text-opacity: 1;\n    color: #233876;\n    color: rgba(35, 56, 118, var(--text-opacity));\n  }\n  .group:focus .md\\:group-focus\\:text-indigo-50 {\n    --text-opacity: 1;\n    color: #f0f5ff;\n    color: rgba(240, 245, 255, var(--text-opacity));\n  }\n  .group:focus .md\\:group-focus\\:text-indigo-100 {\n    --text-opacity: 1;\n    color: #e5edff;\n    color: rgba(229, 237, 255, var(--text-opacity));\n  }\n  .group:focus .md\\:group-focus\\:text-indigo-200 {\n    --text-opacity: 1;\n    color: #cddbfe;\n    color: rgba(205, 219, 254, var(--text-opacity));\n  }\n  .group:focus .md\\:group-focus\\:text-indigo-300 {\n    --text-opacity: 1;\n    color: #b4c6fc;\n    color: rgba(180, 198, 252, var(--text-opacity));\n  }\n  .group:focus .md\\:group-focus\\:text-indigo-400 {\n    --text-opacity: 1;\n    color: #8da2fb;\n    color: rgba(141, 162, 251, var(--text-opacity));\n  }\n  .group:focus .md\\:group-focus\\:text-indigo-500 {\n    --text-opacity: 1;\n    color: #6875f5;\n    color: rgba(104, 117, 245, var(--text-opacity));\n  }\n  .group:focus .md\\:group-focus\\:text-indigo-600 {\n    --text-opacity: 1;\n    color: #5850ec;\n    color: rgba(88, 80, 236, var(--text-opacity));\n  }\n  .group:focus .md\\:group-focus\\:text-indigo-700 {\n    --text-opacity: 1;\n    color: #5145cd;\n    color: rgba(81, 69, 205, var(--text-opacity));\n  }\n  .group:focus .md\\:group-focus\\:text-indigo-800 {\n    --text-opacity: 1;\n    color: #42389d;\n    color: rgba(66, 56, 157, var(--text-opacity));\n  }\n  .group:focus .md\\:group-focus\\:text-indigo-900 {\n    --text-opacity: 1;\n    color: #362f78;\n    color: rgba(54, 47, 120, var(--text-opacity));\n  }\n  .group:focus .md\\:group-focus\\:text-purple-50 {\n    --text-opacity: 1;\n    color: #f6f5ff;\n    color: rgba(246, 245, 255, var(--text-opacity));\n  }\n  .group:focus .md\\:group-focus\\:text-purple-100 {\n    --text-opacity: 1;\n    color: #edebfe;\n    color: rgba(237, 235, 254, var(--text-opacity));\n  }\n  .group:focus .md\\:group-focus\\:text-purple-200 {\n    --text-opacity: 1;\n    color: #dcd7fe;\n    color: rgba(220, 215, 254, var(--text-opacity));\n  }\n  .group:focus .md\\:group-focus\\:text-purple-300 {\n    --text-opacity: 1;\n    color: #cabffd;\n    color: rgba(202, 191, 253, var(--text-opacity));\n  }\n  .group:focus .md\\:group-focus\\:text-purple-400 {\n    --text-opacity: 1;\n    color: #ac94fa;\n    color: rgba(172, 148, 250, var(--text-opacity));\n  }\n  .group:focus .md\\:group-focus\\:text-purple-500 {\n    --text-opacity: 1;\n    color: #9061f9;\n    color: rgba(144, 97, 249, var(--text-opacity));\n  }\n  .group:focus .md\\:group-focus\\:text-purple-600 {\n    --text-opacity: 1;\n    color: #7e3af2;\n    color: rgba(126, 58, 242, var(--text-opacity));\n  }\n  .group:focus .md\\:group-focus\\:text-purple-700 {\n    --text-opacity: 1;\n    color: #6c2bd9;\n    color: rgba(108, 43, 217, var(--text-opacity));\n  }\n  .group:focus .md\\:group-focus\\:text-purple-800 {\n    --text-opacity: 1;\n    color: #5521b5;\n    color: rgba(85, 33, 181, var(--text-opacity));\n  }\n  .group:focus .md\\:group-focus\\:text-purple-900 {\n    --text-opacity: 1;\n    color: #4a1d96;\n    color: rgba(74, 29, 150, var(--text-opacity));\n  }\n  .group:focus .md\\:group-focus\\:text-pink-50 {\n    --text-opacity: 1;\n    color: #fdf2f8;\n    color: rgba(253, 242, 248, var(--text-opacity));\n  }\n  .group:focus .md\\:group-focus\\:text-pink-100 {\n    --text-opacity: 1;\n    color: #fce8f3;\n    color: rgba(252, 232, 243, var(--text-opacity));\n  }\n  .group:focus .md\\:group-focus\\:text-pink-200 {\n    --text-opacity: 1;\n    color: #fad1e8;\n    color: rgba(250, 209, 232, var(--text-opacity));\n  }\n  .group:focus .md\\:group-focus\\:text-pink-300 {\n    --text-opacity: 1;\n    color: #f8b4d9;\n    color: rgba(248, 180, 217, var(--text-opacity));\n  }\n  .group:focus .md\\:group-focus\\:text-pink-400 {\n    --text-opacity: 1;\n    color: #f17eb8;\n    color: rgba(241, 126, 184, var(--text-opacity));\n  }\n  .group:focus .md\\:group-focus\\:text-pink-500 {\n    --text-opacity: 1;\n    color: #e74694;\n    color: rgba(231, 70, 148, var(--text-opacity));\n  }\n  .group:focus .md\\:group-focus\\:text-pink-600 {\n    --text-opacity: 1;\n    color: #d61f69;\n    color: rgba(214, 31, 105, var(--text-opacity));\n  }\n  .group:focus .md\\:group-focus\\:text-pink-700 {\n    --text-opacity: 1;\n    color: #bf125d;\n    color: rgba(191, 18, 93, var(--text-opacity));\n  }\n  .group:focus .md\\:group-focus\\:text-pink-800 {\n    --text-opacity: 1;\n    color: #99154b;\n    color: rgba(153, 21, 75, var(--text-opacity));\n  }\n  .group:focus .md\\:group-focus\\:text-pink-900 {\n    --text-opacity: 1;\n    color: #751a3d;\n    color: rgba(117, 26, 61, var(--text-opacity));\n  }\n  .group:focus .md\\:group-focus\\:text-cool-gray-50 {\n    --text-opacity: 1;\n    color: #f8fafc;\n    color: rgba(248, 250, 252, var(--text-opacity));\n  }\n  .group:focus .md\\:group-focus\\:text-cool-gray-100 {\n    --text-opacity: 1;\n    color: #f1f5f9;\n    color: rgba(241, 245, 249, var(--text-opacity));\n  }\n  .group:focus .md\\:group-focus\\:text-cool-gray-200 {\n    --text-opacity: 1;\n    color: #e2e8f0;\n    color: rgba(226, 232, 240, var(--text-opacity));\n  }\n  .group:focus .md\\:group-focus\\:text-cool-gray-300 {\n    --text-opacity: 1;\n    color: #cfd8e3;\n    color: rgba(207, 216, 227, var(--text-opacity));\n  }\n  .group:focus .md\\:group-focus\\:text-cool-gray-400 {\n    --text-opacity: 1;\n    color: #97a6ba;\n    color: rgba(151, 166, 186, var(--text-opacity));\n  }\n  .group:focus .md\\:group-focus\\:text-cool-gray-500 {\n    --text-opacity: 1;\n    color: #64748b;\n    color: rgba(100, 116, 139, var(--text-opacity));\n  }\n  .group:focus .md\\:group-focus\\:text-cool-gray-600 {\n    --text-opacity: 1;\n    color: #475569;\n    color: rgba(71, 85, 105, var(--text-opacity));\n  }\n  .group:focus .md\\:group-focus\\:text-cool-gray-700 {\n    --text-opacity: 1;\n    color: #364152;\n    color: rgba(54, 65, 82, var(--text-opacity));\n  }\n  .group:focus .md\\:group-focus\\:text-cool-gray-800 {\n    --text-opacity: 1;\n    color: #27303f;\n    color: rgba(39, 48, 63, var(--text-opacity));\n  }\n  .group:focus .md\\:group-focus\\:text-cool-gray-900 {\n    --text-opacity: 1;\n    color: #1a202e;\n    color: rgba(26, 32, 46, var(--text-opacity));\n  }\n  .md\\:hover\\:text-current:hover {\n    color: currentColor;\n  }\n  .md\\:hover\\:text-transparent:hover {\n    color: transparent;\n  }\n  .md\\:hover\\:text-white:hover {\n    --text-opacity: 1;\n    color: #ffffff;\n    color: rgba(255, 255, 255, var(--text-opacity));\n  }\n  .md\\:hover\\:text-black:hover {\n    --text-opacity: 1;\n    color: #000000;\n    color: rgba(0, 0, 0, var(--text-opacity));\n  }\n  .md\\:hover\\:text-gray-50:hover {\n    --text-opacity: 1;\n    color: #f9fafb;\n    color: rgba(249, 250, 251, var(--text-opacity));\n  }\n  .md\\:hover\\:text-gray-100:hover {\n    --text-opacity: 1;\n    color: #f4f5f7;\n    color: rgba(244, 245, 247, var(--text-opacity));\n  }\n  .md\\:hover\\:text-gray-200:hover {\n    --text-opacity: 1;\n    color: #e5e7eb;\n    color: rgba(229, 231, 235, var(--text-opacity));\n  }\n  .md\\:hover\\:text-gray-300:hover {\n    --text-opacity: 1;\n    color: #d2d6dc;\n    color: rgba(210, 214, 220, var(--text-opacity));\n  }\n  .md\\:hover\\:text-gray-400:hover {\n    --text-opacity: 1;\n    color: #9fa6b2;\n    color: rgba(159, 166, 178, var(--text-opacity));\n  }\n  .md\\:hover\\:text-gray-500:hover {\n    --text-opacity: 1;\n    color: #6b7280;\n    color: rgba(107, 114, 128, var(--text-opacity));\n  }\n  .md\\:hover\\:text-gray-600:hover {\n    --text-opacity: 1;\n    color: #4b5563;\n    color: rgba(75, 85, 99, var(--text-opacity));\n  }\n  .md\\:hover\\:text-gray-700:hover {\n    --text-opacity: 1;\n    color: #374151;\n    color: rgba(55, 65, 81, var(--text-opacity));\n  }\n  .md\\:hover\\:text-gray-800:hover {\n    --text-opacity: 1;\n    color: #252f3f;\n    color: rgba(37, 47, 63, var(--text-opacity));\n  }\n  .md\\:hover\\:text-gray-900:hover {\n    --text-opacity: 1;\n    color: #161e2e;\n    color: rgba(22, 30, 46, var(--text-opacity));\n  }\n  .md\\:hover\\:text-red-50:hover {\n    --text-opacity: 1;\n    color: #fdf2f2;\n    color: rgba(253, 242, 242, var(--text-opacity));\n  }\n  .md\\:hover\\:text-red-100:hover {\n    --text-opacity: 1;\n    color: #fde8e8;\n    color: rgba(253, 232, 232, var(--text-opacity));\n  }\n  .md\\:hover\\:text-red-200:hover {\n    --text-opacity: 1;\n    color: #fbd5d5;\n    color: rgba(251, 213, 213, var(--text-opacity));\n  }\n  .md\\:hover\\:text-red-300:hover {\n    --text-opacity: 1;\n    color: #f8b4b4;\n    color: rgba(248, 180, 180, var(--text-opacity));\n  }\n  .md\\:hover\\:text-red-400:hover {\n    --text-opacity: 1;\n    color: #f98080;\n    color: rgba(249, 128, 128, var(--text-opacity));\n  }\n  .md\\:hover\\:text-red-500:hover {\n    --text-opacity: 1;\n    color: #f05252;\n    color: rgba(240, 82, 82, var(--text-opacity));\n  }\n  .md\\:hover\\:text-red-600:hover {\n    --text-opacity: 1;\n    color: #e02424;\n    color: rgba(224, 36, 36, var(--text-opacity));\n  }\n  .md\\:hover\\:text-red-700:hover {\n    --text-opacity: 1;\n    color: #c81e1e;\n    color: rgba(200, 30, 30, var(--text-opacity));\n  }\n  .md\\:hover\\:text-red-800:hover {\n    --text-opacity: 1;\n    color: #9b1c1c;\n    color: rgba(155, 28, 28, var(--text-opacity));\n  }\n  .md\\:hover\\:text-red-900:hover {\n    --text-opacity: 1;\n    color: #771d1d;\n    color: rgba(119, 29, 29, var(--text-opacity));\n  }\n  .md\\:hover\\:text-orange-50:hover {\n    --text-opacity: 1;\n    color: #fff8f1;\n    color: rgba(255, 248, 241, var(--text-opacity));\n  }\n  .md\\:hover\\:text-orange-100:hover {\n    --text-opacity: 1;\n    color: #feecdc;\n    color: rgba(254, 236, 220, var(--text-opacity));\n  }\n  .md\\:hover\\:text-orange-200:hover {\n    --text-opacity: 1;\n    color: #fcd9bd;\n    color: rgba(252, 217, 189, var(--text-opacity));\n  }\n  .md\\:hover\\:text-orange-300:hover {\n    --text-opacity: 1;\n    color: #fdba8c;\n    color: rgba(253, 186, 140, var(--text-opacity));\n  }\n  .md\\:hover\\:text-orange-400:hover {\n    --text-opacity: 1;\n    color: #ff8a4c;\n    color: rgba(255, 138, 76, var(--text-opacity));\n  }\n  .md\\:hover\\:text-orange-500:hover {\n    --text-opacity: 1;\n    color: #ff5a1f;\n    color: rgba(255, 90, 31, var(--text-opacity));\n  }\n  .md\\:hover\\:text-orange-600:hover {\n    --text-opacity: 1;\n    color: #d03801;\n    color: rgba(208, 56, 1, var(--text-opacity));\n  }\n  .md\\:hover\\:text-orange-700:hover {\n    --text-opacity: 1;\n    color: #b43403;\n    color: rgba(180, 52, 3, var(--text-opacity));\n  }\n  .md\\:hover\\:text-orange-800:hover {\n    --text-opacity: 1;\n    color: #8a2c0d;\n    color: rgba(138, 44, 13, var(--text-opacity));\n  }\n  .md\\:hover\\:text-orange-900:hover {\n    --text-opacity: 1;\n    color: #73230d;\n    color: rgba(115, 35, 13, var(--text-opacity));\n  }\n  .md\\:hover\\:text-yellow-50:hover {\n    --text-opacity: 1;\n    color: #fdfdea;\n    color: rgba(253, 253, 234, var(--text-opacity));\n  }\n  .md\\:hover\\:text-yellow-100:hover {\n    --text-opacity: 1;\n    color: #fdf6b2;\n    color: rgba(253, 246, 178, var(--text-opacity));\n  }\n  .md\\:hover\\:text-yellow-200:hover {\n    --text-opacity: 1;\n    color: #fce96a;\n    color: rgba(252, 233, 106, var(--text-opacity));\n  }\n  .md\\:hover\\:text-yellow-300:hover {\n    --text-opacity: 1;\n    color: #faca15;\n    color: rgba(250, 202, 21, var(--text-opacity));\n  }\n  .md\\:hover\\:text-yellow-400:hover {\n    --text-opacity: 1;\n    color: #e3a008;\n    color: rgba(227, 160, 8, var(--text-opacity));\n  }\n  .md\\:hover\\:text-yellow-500:hover {\n    --text-opacity: 1;\n    color: #c27803;\n    color: rgba(194, 120, 3, var(--text-opacity));\n  }\n  .md\\:hover\\:text-yellow-600:hover {\n    --text-opacity: 1;\n    color: #9f580a;\n    color: rgba(159, 88, 10, var(--text-opacity));\n  }\n  .md\\:hover\\:text-yellow-700:hover {\n    --text-opacity: 1;\n    color: #8e4b10;\n    color: rgba(142, 75, 16, var(--text-opacity));\n  }\n  .md\\:hover\\:text-yellow-800:hover {\n    --text-opacity: 1;\n    color: #723b13;\n    color: rgba(114, 59, 19, var(--text-opacity));\n  }\n  .md\\:hover\\:text-yellow-900:hover {\n    --text-opacity: 1;\n    color: #633112;\n    color: rgba(99, 49, 18, var(--text-opacity));\n  }\n  .md\\:hover\\:text-green-50:hover {\n    --text-opacity: 1;\n    color: #f3faf7;\n    color: rgba(243, 250, 247, var(--text-opacity));\n  }\n  .md\\:hover\\:text-green-100:hover {\n    --text-opacity: 1;\n    color: #def7ec;\n    color: rgba(222, 247, 236, var(--text-opacity));\n  }\n  .md\\:hover\\:text-green-200:hover {\n    --text-opacity: 1;\n    color: #bcf0da;\n    color: rgba(188, 240, 218, var(--text-opacity));\n  }\n  .md\\:hover\\:text-green-300:hover {\n    --text-opacity: 1;\n    color: #84e1bc;\n    color: rgba(132, 225, 188, var(--text-opacity));\n  }\n  .md\\:hover\\:text-green-400:hover {\n    --text-opacity: 1;\n    color: #31c48d;\n    color: rgba(49, 196, 141, var(--text-opacity));\n  }\n  .md\\:hover\\:text-green-500:hover {\n    --text-opacity: 1;\n    color: #0e9f6e;\n    color: rgba(14, 159, 110, var(--text-opacity));\n  }\n  .md\\:hover\\:text-green-600:hover {\n    --text-opacity: 1;\n    color: #057a55;\n    color: rgba(5, 122, 85, var(--text-opacity));\n  }\n  .md\\:hover\\:text-green-700:hover {\n    --text-opacity: 1;\n    color: #046c4e;\n    color: rgba(4, 108, 78, var(--text-opacity));\n  }\n  .md\\:hover\\:text-green-800:hover {\n    --text-opacity: 1;\n    color: #03543f;\n    color: rgba(3, 84, 63, var(--text-opacity));\n  }\n  .md\\:hover\\:text-green-900:hover {\n    --text-opacity: 1;\n    color: #014737;\n    color: rgba(1, 71, 55, var(--text-opacity));\n  }\n  .md\\:hover\\:text-teal-50:hover {\n    --text-opacity: 1;\n    color: #edfafa;\n    color: rgba(237, 250, 250, var(--text-opacity));\n  }\n  .md\\:hover\\:text-teal-100:hover {\n    --text-opacity: 1;\n    color: #d5f5f6;\n    color: rgba(213, 245, 246, var(--text-opacity));\n  }\n  .md\\:hover\\:text-teal-200:hover {\n    --text-opacity: 1;\n    color: #afecef;\n    color: rgba(175, 236, 239, var(--text-opacity));\n  }\n  .md\\:hover\\:text-teal-300:hover {\n    --text-opacity: 1;\n    color: #7edce2;\n    color: rgba(126, 220, 226, var(--text-opacity));\n  }\n  .md\\:hover\\:text-teal-400:hover {\n    --text-opacity: 1;\n    color: #16bdca;\n    color: rgba(22, 189, 202, var(--text-opacity));\n  }\n  .md\\:hover\\:text-teal-500:hover {\n    --text-opacity: 1;\n    color: #0694a2;\n    color: rgba(6, 148, 162, var(--text-opacity));\n  }\n  .md\\:hover\\:text-teal-600:hover {\n    --text-opacity: 1;\n    color: #047481;\n    color: rgba(4, 116, 129, var(--text-opacity));\n  }\n  .md\\:hover\\:text-teal-700:hover {\n    --text-opacity: 1;\n    color: #036672;\n    color: rgba(3, 102, 114, var(--text-opacity));\n  }\n  .md\\:hover\\:text-teal-800:hover {\n    --text-opacity: 1;\n    color: #05505c;\n    color: rgba(5, 80, 92, var(--text-opacity));\n  }\n  .md\\:hover\\:text-teal-900:hover {\n    --text-opacity: 1;\n    color: #014451;\n    color: rgba(1, 68, 81, var(--text-opacity));\n  }\n  .md\\:hover\\:text-blue-50:hover {\n    --text-opacity: 1;\n    color: #ebf5ff;\n    color: rgba(235, 245, 255, var(--text-opacity));\n  }\n  .md\\:hover\\:text-blue-100:hover {\n    --text-opacity: 1;\n    color: #e1effe;\n    color: rgba(225, 239, 254, var(--text-opacity));\n  }\n  .md\\:hover\\:text-blue-200:hover {\n    --text-opacity: 1;\n    color: #c3ddfd;\n    color: rgba(195, 221, 253, var(--text-opacity));\n  }\n  .md\\:hover\\:text-blue-300:hover {\n    --text-opacity: 1;\n    color: #a4cafe;\n    color: rgba(164, 202, 254, var(--text-opacity));\n  }\n  .md\\:hover\\:text-blue-400:hover {\n    --text-opacity: 1;\n    color: #76a9fa;\n    color: rgba(118, 169, 250, var(--text-opacity));\n  }\n  .md\\:hover\\:text-blue-500:hover {\n    --text-opacity: 1;\n    color: #3f83f8;\n    color: rgba(63, 131, 248, var(--text-opacity));\n  }\n  .md\\:hover\\:text-blue-600:hover {\n    --text-opacity: 1;\n    color: #1c64f2;\n    color: rgba(28, 100, 242, var(--text-opacity));\n  }\n  .md\\:hover\\:text-blue-700:hover {\n    --text-opacity: 1;\n    color: #1a56db;\n    color: rgba(26, 86, 219, var(--text-opacity));\n  }\n  .md\\:hover\\:text-blue-800:hover {\n    --text-opacity: 1;\n    color: #1e429f;\n    color: rgba(30, 66, 159, var(--text-opacity));\n  }\n  .md\\:hover\\:text-blue-900:hover {\n    --text-opacity: 1;\n    color: #233876;\n    color: rgba(35, 56, 118, var(--text-opacity));\n  }\n  .md\\:hover\\:text-indigo-50:hover {\n    --text-opacity: 1;\n    color: #f0f5ff;\n    color: rgba(240, 245, 255, var(--text-opacity));\n  }\n  .md\\:hover\\:text-indigo-100:hover {\n    --text-opacity: 1;\n    color: #e5edff;\n    color: rgba(229, 237, 255, var(--text-opacity));\n  }\n  .md\\:hover\\:text-indigo-200:hover {\n    --text-opacity: 1;\n    color: #cddbfe;\n    color: rgba(205, 219, 254, var(--text-opacity));\n  }\n  .md\\:hover\\:text-indigo-300:hover {\n    --text-opacity: 1;\n    color: #b4c6fc;\n    color: rgba(180, 198, 252, var(--text-opacity));\n  }\n  .md\\:hover\\:text-indigo-400:hover {\n    --text-opacity: 1;\n    color: #8da2fb;\n    color: rgba(141, 162, 251, var(--text-opacity));\n  }\n  .md\\:hover\\:text-indigo-500:hover {\n    --text-opacity: 1;\n    color: #6875f5;\n    color: rgba(104, 117, 245, var(--text-opacity));\n  }\n  .md\\:hover\\:text-indigo-600:hover {\n    --text-opacity: 1;\n    color: #5850ec;\n    color: rgba(88, 80, 236, var(--text-opacity));\n  }\n  .md\\:hover\\:text-indigo-700:hover {\n    --text-opacity: 1;\n    color: #5145cd;\n    color: rgba(81, 69, 205, var(--text-opacity));\n  }\n  .md\\:hover\\:text-indigo-800:hover {\n    --text-opacity: 1;\n    color: #42389d;\n    color: rgba(66, 56, 157, var(--text-opacity));\n  }\n  .md\\:hover\\:text-indigo-900:hover {\n    --text-opacity: 1;\n    color: #362f78;\n    color: rgba(54, 47, 120, var(--text-opacity));\n  }\n  .md\\:hover\\:text-purple-50:hover {\n    --text-opacity: 1;\n    color: #f6f5ff;\n    color: rgba(246, 245, 255, var(--text-opacity));\n  }\n  .md\\:hover\\:text-purple-100:hover {\n    --text-opacity: 1;\n    color: #edebfe;\n    color: rgba(237, 235, 254, var(--text-opacity));\n  }\n  .md\\:hover\\:text-purple-200:hover {\n    --text-opacity: 1;\n    color: #dcd7fe;\n    color: rgba(220, 215, 254, var(--text-opacity));\n  }\n  .md\\:hover\\:text-purple-300:hover {\n    --text-opacity: 1;\n    color: #cabffd;\n    color: rgba(202, 191, 253, var(--text-opacity));\n  }\n  .md\\:hover\\:text-purple-400:hover {\n    --text-opacity: 1;\n    color: #ac94fa;\n    color: rgba(172, 148, 250, var(--text-opacity));\n  }\n  .md\\:hover\\:text-purple-500:hover {\n    --text-opacity: 1;\n    color: #9061f9;\n    color: rgba(144, 97, 249, var(--text-opacity));\n  }\n  .md\\:hover\\:text-purple-600:hover {\n    --text-opacity: 1;\n    color: #7e3af2;\n    color: rgba(126, 58, 242, var(--text-opacity));\n  }\n  .md\\:hover\\:text-purple-700:hover {\n    --text-opacity: 1;\n    color: #6c2bd9;\n    color: rgba(108, 43, 217, var(--text-opacity));\n  }\n  .md\\:hover\\:text-purple-800:hover {\n    --text-opacity: 1;\n    color: #5521b5;\n    color: rgba(85, 33, 181, var(--text-opacity));\n  }\n  .md\\:hover\\:text-purple-900:hover {\n    --text-opacity: 1;\n    color: #4a1d96;\n    color: rgba(74, 29, 150, var(--text-opacity));\n  }\n  .md\\:hover\\:text-pink-50:hover {\n    --text-opacity: 1;\n    color: #fdf2f8;\n    color: rgba(253, 242, 248, var(--text-opacity));\n  }\n  .md\\:hover\\:text-pink-100:hover {\n    --text-opacity: 1;\n    color: #fce8f3;\n    color: rgba(252, 232, 243, var(--text-opacity));\n  }\n  .md\\:hover\\:text-pink-200:hover {\n    --text-opacity: 1;\n    color: #fad1e8;\n    color: rgba(250, 209, 232, var(--text-opacity));\n  }\n  .md\\:hover\\:text-pink-300:hover {\n    --text-opacity: 1;\n    color: #f8b4d9;\n    color: rgba(248, 180, 217, var(--text-opacity));\n  }\n  .md\\:hover\\:text-pink-400:hover {\n    --text-opacity: 1;\n    color: #f17eb8;\n    color: rgba(241, 126, 184, var(--text-opacity));\n  }\n  .md\\:hover\\:text-pink-500:hover {\n    --text-opacity: 1;\n    color: #e74694;\n    color: rgba(231, 70, 148, var(--text-opacity));\n  }\n  .md\\:hover\\:text-pink-600:hover {\n    --text-opacity: 1;\n    color: #d61f69;\n    color: rgba(214, 31, 105, var(--text-opacity));\n  }\n  .md\\:hover\\:text-pink-700:hover {\n    --text-opacity: 1;\n    color: #bf125d;\n    color: rgba(191, 18, 93, var(--text-opacity));\n  }\n  .md\\:hover\\:text-pink-800:hover {\n    --text-opacity: 1;\n    color: #99154b;\n    color: rgba(153, 21, 75, var(--text-opacity));\n  }\n  .md\\:hover\\:text-pink-900:hover {\n    --text-opacity: 1;\n    color: #751a3d;\n    color: rgba(117, 26, 61, var(--text-opacity));\n  }\n  .md\\:hover\\:text-cool-gray-50:hover {\n    --text-opacity: 1;\n    color: #f8fafc;\n    color: rgba(248, 250, 252, var(--text-opacity));\n  }\n  .md\\:hover\\:text-cool-gray-100:hover {\n    --text-opacity: 1;\n    color: #f1f5f9;\n    color: rgba(241, 245, 249, var(--text-opacity));\n  }\n  .md\\:hover\\:text-cool-gray-200:hover {\n    --text-opacity: 1;\n    color: #e2e8f0;\n    color: rgba(226, 232, 240, var(--text-opacity));\n  }\n  .md\\:hover\\:text-cool-gray-300:hover {\n    --text-opacity: 1;\n    color: #cfd8e3;\n    color: rgba(207, 216, 227, var(--text-opacity));\n  }\n  .md\\:hover\\:text-cool-gray-400:hover {\n    --text-opacity: 1;\n    color: #97a6ba;\n    color: rgba(151, 166, 186, var(--text-opacity));\n  }\n  .md\\:hover\\:text-cool-gray-500:hover {\n    --text-opacity: 1;\n    color: #64748b;\n    color: rgba(100, 116, 139, var(--text-opacity));\n  }\n  .md\\:hover\\:text-cool-gray-600:hover {\n    --text-opacity: 1;\n    color: #475569;\n    color: rgba(71, 85, 105, var(--text-opacity));\n  }\n  .md\\:hover\\:text-cool-gray-700:hover {\n    --text-opacity: 1;\n    color: #364152;\n    color: rgba(54, 65, 82, var(--text-opacity));\n  }\n  .md\\:hover\\:text-cool-gray-800:hover {\n    --text-opacity: 1;\n    color: #27303f;\n    color: rgba(39, 48, 63, var(--text-opacity));\n  }\n  .md\\:hover\\:text-cool-gray-900:hover {\n    --text-opacity: 1;\n    color: #1a202e;\n    color: rgba(26, 32, 46, var(--text-opacity));\n  }\n  .md\\:focus-within\\:text-current:focus-within {\n    color: currentColor;\n  }\n  .md\\:focus-within\\:text-transparent:focus-within {\n    color: transparent;\n  }\n  .md\\:focus-within\\:text-white:focus-within {\n    --text-opacity: 1;\n    color: #ffffff;\n    color: rgba(255, 255, 255, var(--text-opacity));\n  }\n  .md\\:focus-within\\:text-black:focus-within {\n    --text-opacity: 1;\n    color: #000000;\n    color: rgba(0, 0, 0, var(--text-opacity));\n  }\n  .md\\:focus-within\\:text-gray-50:focus-within {\n    --text-opacity: 1;\n    color: #f9fafb;\n    color: rgba(249, 250, 251, var(--text-opacity));\n  }\n  .md\\:focus-within\\:text-gray-100:focus-within {\n    --text-opacity: 1;\n    color: #f4f5f7;\n    color: rgba(244, 245, 247, var(--text-opacity));\n  }\n  .md\\:focus-within\\:text-gray-200:focus-within {\n    --text-opacity: 1;\n    color: #e5e7eb;\n    color: rgba(229, 231, 235, var(--text-opacity));\n  }\n  .md\\:focus-within\\:text-gray-300:focus-within {\n    --text-opacity: 1;\n    color: #d2d6dc;\n    color: rgba(210, 214, 220, var(--text-opacity));\n  }\n  .md\\:focus-within\\:text-gray-400:focus-within {\n    --text-opacity: 1;\n    color: #9fa6b2;\n    color: rgba(159, 166, 178, var(--text-opacity));\n  }\n  .md\\:focus-within\\:text-gray-500:focus-within {\n    --text-opacity: 1;\n    color: #6b7280;\n    color: rgba(107, 114, 128, var(--text-opacity));\n  }\n  .md\\:focus-within\\:text-gray-600:focus-within {\n    --text-opacity: 1;\n    color: #4b5563;\n    color: rgba(75, 85, 99, var(--text-opacity));\n  }\n  .md\\:focus-within\\:text-gray-700:focus-within {\n    --text-opacity: 1;\n    color: #374151;\n    color: rgba(55, 65, 81, var(--text-opacity));\n  }\n  .md\\:focus-within\\:text-gray-800:focus-within {\n    --text-opacity: 1;\n    color: #252f3f;\n    color: rgba(37, 47, 63, var(--text-opacity));\n  }\n  .md\\:focus-within\\:text-gray-900:focus-within {\n    --text-opacity: 1;\n    color: #161e2e;\n    color: rgba(22, 30, 46, var(--text-opacity));\n  }\n  .md\\:focus-within\\:text-red-50:focus-within {\n    --text-opacity: 1;\n    color: #fdf2f2;\n    color: rgba(253, 242, 242, var(--text-opacity));\n  }\n  .md\\:focus-within\\:text-red-100:focus-within {\n    --text-opacity: 1;\n    color: #fde8e8;\n    color: rgba(253, 232, 232, var(--text-opacity));\n  }\n  .md\\:focus-within\\:text-red-200:focus-within {\n    --text-opacity: 1;\n    color: #fbd5d5;\n    color: rgba(251, 213, 213, var(--text-opacity));\n  }\n  .md\\:focus-within\\:text-red-300:focus-within {\n    --text-opacity: 1;\n    color: #f8b4b4;\n    color: rgba(248, 180, 180, var(--text-opacity));\n  }\n  .md\\:focus-within\\:text-red-400:focus-within {\n    --text-opacity: 1;\n    color: #f98080;\n    color: rgba(249, 128, 128, var(--text-opacity));\n  }\n  .md\\:focus-within\\:text-red-500:focus-within {\n    --text-opacity: 1;\n    color: #f05252;\n    color: rgba(240, 82, 82, var(--text-opacity));\n  }\n  .md\\:focus-within\\:text-red-600:focus-within {\n    --text-opacity: 1;\n    color: #e02424;\n    color: rgba(224, 36, 36, var(--text-opacity));\n  }\n  .md\\:focus-within\\:text-red-700:focus-within {\n    --text-opacity: 1;\n    color: #c81e1e;\n    color: rgba(200, 30, 30, var(--text-opacity));\n  }\n  .md\\:focus-within\\:text-red-800:focus-within {\n    --text-opacity: 1;\n    color: #9b1c1c;\n    color: rgba(155, 28, 28, var(--text-opacity));\n  }\n  .md\\:focus-within\\:text-red-900:focus-within {\n    --text-opacity: 1;\n    color: #771d1d;\n    color: rgba(119, 29, 29, var(--text-opacity));\n  }\n  .md\\:focus-within\\:text-orange-50:focus-within {\n    --text-opacity: 1;\n    color: #fff8f1;\n    color: rgba(255, 248, 241, var(--text-opacity));\n  }\n  .md\\:focus-within\\:text-orange-100:focus-within {\n    --text-opacity: 1;\n    color: #feecdc;\n    color: rgba(254, 236, 220, var(--text-opacity));\n  }\n  .md\\:focus-within\\:text-orange-200:focus-within {\n    --text-opacity: 1;\n    color: #fcd9bd;\n    color: rgba(252, 217, 189, var(--text-opacity));\n  }\n  .md\\:focus-within\\:text-orange-300:focus-within {\n    --text-opacity: 1;\n    color: #fdba8c;\n    color: rgba(253, 186, 140, var(--text-opacity));\n  }\n  .md\\:focus-within\\:text-orange-400:focus-within {\n    --text-opacity: 1;\n    color: #ff8a4c;\n    color: rgba(255, 138, 76, var(--text-opacity));\n  }\n  .md\\:focus-within\\:text-orange-500:focus-within {\n    --text-opacity: 1;\n    color: #ff5a1f;\n    color: rgba(255, 90, 31, var(--text-opacity));\n  }\n  .md\\:focus-within\\:text-orange-600:focus-within {\n    --text-opacity: 1;\n    color: #d03801;\n    color: rgba(208, 56, 1, var(--text-opacity));\n  }\n  .md\\:focus-within\\:text-orange-700:focus-within {\n    --text-opacity: 1;\n    color: #b43403;\n    color: rgba(180, 52, 3, var(--text-opacity));\n  }\n  .md\\:focus-within\\:text-orange-800:focus-within {\n    --text-opacity: 1;\n    color: #8a2c0d;\n    color: rgba(138, 44, 13, var(--text-opacity));\n  }\n  .md\\:focus-within\\:text-orange-900:focus-within {\n    --text-opacity: 1;\n    color: #73230d;\n    color: rgba(115, 35, 13, var(--text-opacity));\n  }\n  .md\\:focus-within\\:text-yellow-50:focus-within {\n    --text-opacity: 1;\n    color: #fdfdea;\n    color: rgba(253, 253, 234, var(--text-opacity));\n  }\n  .md\\:focus-within\\:text-yellow-100:focus-within {\n    --text-opacity: 1;\n    color: #fdf6b2;\n    color: rgba(253, 246, 178, var(--text-opacity));\n  }\n  .md\\:focus-within\\:text-yellow-200:focus-within {\n    --text-opacity: 1;\n    color: #fce96a;\n    color: rgba(252, 233, 106, var(--text-opacity));\n  }\n  .md\\:focus-within\\:text-yellow-300:focus-within {\n    --text-opacity: 1;\n    color: #faca15;\n    color: rgba(250, 202, 21, var(--text-opacity));\n  }\n  .md\\:focus-within\\:text-yellow-400:focus-within {\n    --text-opacity: 1;\n    color: #e3a008;\n    color: rgba(227, 160, 8, var(--text-opacity));\n  }\n  .md\\:focus-within\\:text-yellow-500:focus-within {\n    --text-opacity: 1;\n    color: #c27803;\n    color: rgba(194, 120, 3, var(--text-opacity));\n  }\n  .md\\:focus-within\\:text-yellow-600:focus-within {\n    --text-opacity: 1;\n    color: #9f580a;\n    color: rgba(159, 88, 10, var(--text-opacity));\n  }\n  .md\\:focus-within\\:text-yellow-700:focus-within {\n    --text-opacity: 1;\n    color: #8e4b10;\n    color: rgba(142, 75, 16, var(--text-opacity));\n  }\n  .md\\:focus-within\\:text-yellow-800:focus-within {\n    --text-opacity: 1;\n    color: #723b13;\n    color: rgba(114, 59, 19, var(--text-opacity));\n  }\n  .md\\:focus-within\\:text-yellow-900:focus-within {\n    --text-opacity: 1;\n    color: #633112;\n    color: rgba(99, 49, 18, var(--text-opacity));\n  }\n  .md\\:focus-within\\:text-green-50:focus-within {\n    --text-opacity: 1;\n    color: #f3faf7;\n    color: rgba(243, 250, 247, var(--text-opacity));\n  }\n  .md\\:focus-within\\:text-green-100:focus-within {\n    --text-opacity: 1;\n    color: #def7ec;\n    color: rgba(222, 247, 236, var(--text-opacity));\n  }\n  .md\\:focus-within\\:text-green-200:focus-within {\n    --text-opacity: 1;\n    color: #bcf0da;\n    color: rgba(188, 240, 218, var(--text-opacity));\n  }\n  .md\\:focus-within\\:text-green-300:focus-within {\n    --text-opacity: 1;\n    color: #84e1bc;\n    color: rgba(132, 225, 188, var(--text-opacity));\n  }\n  .md\\:focus-within\\:text-green-400:focus-within {\n    --text-opacity: 1;\n    color: #31c48d;\n    color: rgba(49, 196, 141, var(--text-opacity));\n  }\n  .md\\:focus-within\\:text-green-500:focus-within {\n    --text-opacity: 1;\n    color: #0e9f6e;\n    color: rgba(14, 159, 110, var(--text-opacity));\n  }\n  .md\\:focus-within\\:text-green-600:focus-within {\n    --text-opacity: 1;\n    color: #057a55;\n    color: rgba(5, 122, 85, var(--text-opacity));\n  }\n  .md\\:focus-within\\:text-green-700:focus-within {\n    --text-opacity: 1;\n    color: #046c4e;\n    color: rgba(4, 108, 78, var(--text-opacity));\n  }\n  .md\\:focus-within\\:text-green-800:focus-within {\n    --text-opacity: 1;\n    color: #03543f;\n    color: rgba(3, 84, 63, var(--text-opacity));\n  }\n  .md\\:focus-within\\:text-green-900:focus-within {\n    --text-opacity: 1;\n    color: #014737;\n    color: rgba(1, 71, 55, var(--text-opacity));\n  }\n  .md\\:focus-within\\:text-teal-50:focus-within {\n    --text-opacity: 1;\n    color: #edfafa;\n    color: rgba(237, 250, 250, var(--text-opacity));\n  }\n  .md\\:focus-within\\:text-teal-100:focus-within {\n    --text-opacity: 1;\n    color: #d5f5f6;\n    color: rgba(213, 245, 246, var(--text-opacity));\n  }\n  .md\\:focus-within\\:text-teal-200:focus-within {\n    --text-opacity: 1;\n    color: #afecef;\n    color: rgba(175, 236, 239, var(--text-opacity));\n  }\n  .md\\:focus-within\\:text-teal-300:focus-within {\n    --text-opacity: 1;\n    color: #7edce2;\n    color: rgba(126, 220, 226, var(--text-opacity));\n  }\n  .md\\:focus-within\\:text-teal-400:focus-within {\n    --text-opacity: 1;\n    color: #16bdca;\n    color: rgba(22, 189, 202, var(--text-opacity));\n  }\n  .md\\:focus-within\\:text-teal-500:focus-within {\n    --text-opacity: 1;\n    color: #0694a2;\n    color: rgba(6, 148, 162, var(--text-opacity));\n  }\n  .md\\:focus-within\\:text-teal-600:focus-within {\n    --text-opacity: 1;\n    color: #047481;\n    color: rgba(4, 116, 129, var(--text-opacity));\n  }\n  .md\\:focus-within\\:text-teal-700:focus-within {\n    --text-opacity: 1;\n    color: #036672;\n    color: rgba(3, 102, 114, var(--text-opacity));\n  }\n  .md\\:focus-within\\:text-teal-800:focus-within {\n    --text-opacity: 1;\n    color: #05505c;\n    color: rgba(5, 80, 92, var(--text-opacity));\n  }\n  .md\\:focus-within\\:text-teal-900:focus-within {\n    --text-opacity: 1;\n    color: #014451;\n    color: rgba(1, 68, 81, var(--text-opacity));\n  }\n  .md\\:focus-within\\:text-blue-50:focus-within {\n    --text-opacity: 1;\n    color: #ebf5ff;\n    color: rgba(235, 245, 255, var(--text-opacity));\n  }\n  .md\\:focus-within\\:text-blue-100:focus-within {\n    --text-opacity: 1;\n    color: #e1effe;\n    color: rgba(225, 239, 254, var(--text-opacity));\n  }\n  .md\\:focus-within\\:text-blue-200:focus-within {\n    --text-opacity: 1;\n    color: #c3ddfd;\n    color: rgba(195, 221, 253, var(--text-opacity));\n  }\n  .md\\:focus-within\\:text-blue-300:focus-within {\n    --text-opacity: 1;\n    color: #a4cafe;\n    color: rgba(164, 202, 254, var(--text-opacity));\n  }\n  .md\\:focus-within\\:text-blue-400:focus-within {\n    --text-opacity: 1;\n    color: #76a9fa;\n    color: rgba(118, 169, 250, var(--text-opacity));\n  }\n  .md\\:focus-within\\:text-blue-500:focus-within {\n    --text-opacity: 1;\n    color: #3f83f8;\n    color: rgba(63, 131, 248, var(--text-opacity));\n  }\n  .md\\:focus-within\\:text-blue-600:focus-within {\n    --text-opacity: 1;\n    color: #1c64f2;\n    color: rgba(28, 100, 242, var(--text-opacity));\n  }\n  .md\\:focus-within\\:text-blue-700:focus-within {\n    --text-opacity: 1;\n    color: #1a56db;\n    color: rgba(26, 86, 219, var(--text-opacity));\n  }\n  .md\\:focus-within\\:text-blue-800:focus-within {\n    --text-opacity: 1;\n    color: #1e429f;\n    color: rgba(30, 66, 159, var(--text-opacity));\n  }\n  .md\\:focus-within\\:text-blue-900:focus-within {\n    --text-opacity: 1;\n    color: #233876;\n    color: rgba(35, 56, 118, var(--text-opacity));\n  }\n  .md\\:focus-within\\:text-indigo-50:focus-within {\n    --text-opacity: 1;\n    color: #f0f5ff;\n    color: rgba(240, 245, 255, var(--text-opacity));\n  }\n  .md\\:focus-within\\:text-indigo-100:focus-within {\n    --text-opacity: 1;\n    color: #e5edff;\n    color: rgba(229, 237, 255, var(--text-opacity));\n  }\n  .md\\:focus-within\\:text-indigo-200:focus-within {\n    --text-opacity: 1;\n    color: #cddbfe;\n    color: rgba(205, 219, 254, var(--text-opacity));\n  }\n  .md\\:focus-within\\:text-indigo-300:focus-within {\n    --text-opacity: 1;\n    color: #b4c6fc;\n    color: rgba(180, 198, 252, var(--text-opacity));\n  }\n  .md\\:focus-within\\:text-indigo-400:focus-within {\n    --text-opacity: 1;\n    color: #8da2fb;\n    color: rgba(141, 162, 251, var(--text-opacity));\n  }\n  .md\\:focus-within\\:text-indigo-500:focus-within {\n    --text-opacity: 1;\n    color: #6875f5;\n    color: rgba(104, 117, 245, var(--text-opacity));\n  }\n  .md\\:focus-within\\:text-indigo-600:focus-within {\n    --text-opacity: 1;\n    color: #5850ec;\n    color: rgba(88, 80, 236, var(--text-opacity));\n  }\n  .md\\:focus-within\\:text-indigo-700:focus-within {\n    --text-opacity: 1;\n    color: #5145cd;\n    color: rgba(81, 69, 205, var(--text-opacity));\n  }\n  .md\\:focus-within\\:text-indigo-800:focus-within {\n    --text-opacity: 1;\n    color: #42389d;\n    color: rgba(66, 56, 157, var(--text-opacity));\n  }\n  .md\\:focus-within\\:text-indigo-900:focus-within {\n    --text-opacity: 1;\n    color: #362f78;\n    color: rgba(54, 47, 120, var(--text-opacity));\n  }\n  .md\\:focus-within\\:text-purple-50:focus-within {\n    --text-opacity: 1;\n    color: #f6f5ff;\n    color: rgba(246, 245, 255, var(--text-opacity));\n  }\n  .md\\:focus-within\\:text-purple-100:focus-within {\n    --text-opacity: 1;\n    color: #edebfe;\n    color: rgba(237, 235, 254, var(--text-opacity));\n  }\n  .md\\:focus-within\\:text-purple-200:focus-within {\n    --text-opacity: 1;\n    color: #dcd7fe;\n    color: rgba(220, 215, 254, var(--text-opacity));\n  }\n  .md\\:focus-within\\:text-purple-300:focus-within {\n    --text-opacity: 1;\n    color: #cabffd;\n    color: rgba(202, 191, 253, var(--text-opacity));\n  }\n  .md\\:focus-within\\:text-purple-400:focus-within {\n    --text-opacity: 1;\n    color: #ac94fa;\n    color: rgba(172, 148, 250, var(--text-opacity));\n  }\n  .md\\:focus-within\\:text-purple-500:focus-within {\n    --text-opacity: 1;\n    color: #9061f9;\n    color: rgba(144, 97, 249, var(--text-opacity));\n  }\n  .md\\:focus-within\\:text-purple-600:focus-within {\n    --text-opacity: 1;\n    color: #7e3af2;\n    color: rgba(126, 58, 242, var(--text-opacity));\n  }\n  .md\\:focus-within\\:text-purple-700:focus-within {\n    --text-opacity: 1;\n    color: #6c2bd9;\n    color: rgba(108, 43, 217, var(--text-opacity));\n  }\n  .md\\:focus-within\\:text-purple-800:focus-within {\n    --text-opacity: 1;\n    color: #5521b5;\n    color: rgba(85, 33, 181, var(--text-opacity));\n  }\n  .md\\:focus-within\\:text-purple-900:focus-within {\n    --text-opacity: 1;\n    color: #4a1d96;\n    color: rgba(74, 29, 150, var(--text-opacity));\n  }\n  .md\\:focus-within\\:text-pink-50:focus-within {\n    --text-opacity: 1;\n    color: #fdf2f8;\n    color: rgba(253, 242, 248, var(--text-opacity));\n  }\n  .md\\:focus-within\\:text-pink-100:focus-within {\n    --text-opacity: 1;\n    color: #fce8f3;\n    color: rgba(252, 232, 243, var(--text-opacity));\n  }\n  .md\\:focus-within\\:text-pink-200:focus-within {\n    --text-opacity: 1;\n    color: #fad1e8;\n    color: rgba(250, 209, 232, var(--text-opacity));\n  }\n  .md\\:focus-within\\:text-pink-300:focus-within {\n    --text-opacity: 1;\n    color: #f8b4d9;\n    color: rgba(248, 180, 217, var(--text-opacity));\n  }\n  .md\\:focus-within\\:text-pink-400:focus-within {\n    --text-opacity: 1;\n    color: #f17eb8;\n    color: rgba(241, 126, 184, var(--text-opacity));\n  }\n  .md\\:focus-within\\:text-pink-500:focus-within {\n    --text-opacity: 1;\n    color: #e74694;\n    color: rgba(231, 70, 148, var(--text-opacity));\n  }\n  .md\\:focus-within\\:text-pink-600:focus-within {\n    --text-opacity: 1;\n    color: #d61f69;\n    color: rgba(214, 31, 105, var(--text-opacity));\n  }\n  .md\\:focus-within\\:text-pink-700:focus-within {\n    --text-opacity: 1;\n    color: #bf125d;\n    color: rgba(191, 18, 93, var(--text-opacity));\n  }\n  .md\\:focus-within\\:text-pink-800:focus-within {\n    --text-opacity: 1;\n    color: #99154b;\n    color: rgba(153, 21, 75, var(--text-opacity));\n  }\n  .md\\:focus-within\\:text-pink-900:focus-within {\n    --text-opacity: 1;\n    color: #751a3d;\n    color: rgba(117, 26, 61, var(--text-opacity));\n  }\n  .md\\:focus-within\\:text-cool-gray-50:focus-within {\n    --text-opacity: 1;\n    color: #f8fafc;\n    color: rgba(248, 250, 252, var(--text-opacity));\n  }\n  .md\\:focus-within\\:text-cool-gray-100:focus-within {\n    --text-opacity: 1;\n    color: #f1f5f9;\n    color: rgba(241, 245, 249, var(--text-opacity));\n  }\n  .md\\:focus-within\\:text-cool-gray-200:focus-within {\n    --text-opacity: 1;\n    color: #e2e8f0;\n    color: rgba(226, 232, 240, var(--text-opacity));\n  }\n  .md\\:focus-within\\:text-cool-gray-300:focus-within {\n    --text-opacity: 1;\n    color: #cfd8e3;\n    color: rgba(207, 216, 227, var(--text-opacity));\n  }\n  .md\\:focus-within\\:text-cool-gray-400:focus-within {\n    --text-opacity: 1;\n    color: #97a6ba;\n    color: rgba(151, 166, 186, var(--text-opacity));\n  }\n  .md\\:focus-within\\:text-cool-gray-500:focus-within {\n    --text-opacity: 1;\n    color: #64748b;\n    color: rgba(100, 116, 139, var(--text-opacity));\n  }\n  .md\\:focus-within\\:text-cool-gray-600:focus-within {\n    --text-opacity: 1;\n    color: #475569;\n    color: rgba(71, 85, 105, var(--text-opacity));\n  }\n  .md\\:focus-within\\:text-cool-gray-700:focus-within {\n    --text-opacity: 1;\n    color: #364152;\n    color: rgba(54, 65, 82, var(--text-opacity));\n  }\n  .md\\:focus-within\\:text-cool-gray-800:focus-within {\n    --text-opacity: 1;\n    color: #27303f;\n    color: rgba(39, 48, 63, var(--text-opacity));\n  }\n  .md\\:focus-within\\:text-cool-gray-900:focus-within {\n    --text-opacity: 1;\n    color: #1a202e;\n    color: rgba(26, 32, 46, var(--text-opacity));\n  }\n  .md\\:focus\\:text-current:focus {\n    color: currentColor;\n  }\n  .md\\:focus\\:text-transparent:focus {\n    color: transparent;\n  }\n  .md\\:focus\\:text-white:focus {\n    --text-opacity: 1;\n    color: #ffffff;\n    color: rgba(255, 255, 255, var(--text-opacity));\n  }\n  .md\\:focus\\:text-black:focus {\n    --text-opacity: 1;\n    color: #000000;\n    color: rgba(0, 0, 0, var(--text-opacity));\n  }\n  .md\\:focus\\:text-gray-50:focus {\n    --text-opacity: 1;\n    color: #f9fafb;\n    color: rgba(249, 250, 251, var(--text-opacity));\n  }\n  .md\\:focus\\:text-gray-100:focus {\n    --text-opacity: 1;\n    color: #f4f5f7;\n    color: rgba(244, 245, 247, var(--text-opacity));\n  }\n  .md\\:focus\\:text-gray-200:focus {\n    --text-opacity: 1;\n    color: #e5e7eb;\n    color: rgba(229, 231, 235, var(--text-opacity));\n  }\n  .md\\:focus\\:text-gray-300:focus {\n    --text-opacity: 1;\n    color: #d2d6dc;\n    color: rgba(210, 214, 220, var(--text-opacity));\n  }\n  .md\\:focus\\:text-gray-400:focus {\n    --text-opacity: 1;\n    color: #9fa6b2;\n    color: rgba(159, 166, 178, var(--text-opacity));\n  }\n  .md\\:focus\\:text-gray-500:focus {\n    --text-opacity: 1;\n    color: #6b7280;\n    color: rgba(107, 114, 128, var(--text-opacity));\n  }\n  .md\\:focus\\:text-gray-600:focus {\n    --text-opacity: 1;\n    color: #4b5563;\n    color: rgba(75, 85, 99, var(--text-opacity));\n  }\n  .md\\:focus\\:text-gray-700:focus {\n    --text-opacity: 1;\n    color: #374151;\n    color: rgba(55, 65, 81, var(--text-opacity));\n  }\n  .md\\:focus\\:text-gray-800:focus {\n    --text-opacity: 1;\n    color: #252f3f;\n    color: rgba(37, 47, 63, var(--text-opacity));\n  }\n  .md\\:focus\\:text-gray-900:focus {\n    --text-opacity: 1;\n    color: #161e2e;\n    color: rgba(22, 30, 46, var(--text-opacity));\n  }\n  .md\\:focus\\:text-red-50:focus {\n    --text-opacity: 1;\n    color: #fdf2f2;\n    color: rgba(253, 242, 242, var(--text-opacity));\n  }\n  .md\\:focus\\:text-red-100:focus {\n    --text-opacity: 1;\n    color: #fde8e8;\n    color: rgba(253, 232, 232, var(--text-opacity));\n  }\n  .md\\:focus\\:text-red-200:focus {\n    --text-opacity: 1;\n    color: #fbd5d5;\n    color: rgba(251, 213, 213, var(--text-opacity));\n  }\n  .md\\:focus\\:text-red-300:focus {\n    --text-opacity: 1;\n    color: #f8b4b4;\n    color: rgba(248, 180, 180, var(--text-opacity));\n  }\n  .md\\:focus\\:text-red-400:focus {\n    --text-opacity: 1;\n    color: #f98080;\n    color: rgba(249, 128, 128, var(--text-opacity));\n  }\n  .md\\:focus\\:text-red-500:focus {\n    --text-opacity: 1;\n    color: #f05252;\n    color: rgba(240, 82, 82, var(--text-opacity));\n  }\n  .md\\:focus\\:text-red-600:focus {\n    --text-opacity: 1;\n    color: #e02424;\n    color: rgba(224, 36, 36, var(--text-opacity));\n  }\n  .md\\:focus\\:text-red-700:focus {\n    --text-opacity: 1;\n    color: #c81e1e;\n    color: rgba(200, 30, 30, var(--text-opacity));\n  }\n  .md\\:focus\\:text-red-800:focus {\n    --text-opacity: 1;\n    color: #9b1c1c;\n    color: rgba(155, 28, 28, var(--text-opacity));\n  }\n  .md\\:focus\\:text-red-900:focus {\n    --text-opacity: 1;\n    color: #771d1d;\n    color: rgba(119, 29, 29, var(--text-opacity));\n  }\n  .md\\:focus\\:text-orange-50:focus {\n    --text-opacity: 1;\n    color: #fff8f1;\n    color: rgba(255, 248, 241, var(--text-opacity));\n  }\n  .md\\:focus\\:text-orange-100:focus {\n    --text-opacity: 1;\n    color: #feecdc;\n    color: rgba(254, 236, 220, var(--text-opacity));\n  }\n  .md\\:focus\\:text-orange-200:focus {\n    --text-opacity: 1;\n    color: #fcd9bd;\n    color: rgba(252, 217, 189, var(--text-opacity));\n  }\n  .md\\:focus\\:text-orange-300:focus {\n    --text-opacity: 1;\n    color: #fdba8c;\n    color: rgba(253, 186, 140, var(--text-opacity));\n  }\n  .md\\:focus\\:text-orange-400:focus {\n    --text-opacity: 1;\n    color: #ff8a4c;\n    color: rgba(255, 138, 76, var(--text-opacity));\n  }\n  .md\\:focus\\:text-orange-500:focus {\n    --text-opacity: 1;\n    color: #ff5a1f;\n    color: rgba(255, 90, 31, var(--text-opacity));\n  }\n  .md\\:focus\\:text-orange-600:focus {\n    --text-opacity: 1;\n    color: #d03801;\n    color: rgba(208, 56, 1, var(--text-opacity));\n  }\n  .md\\:focus\\:text-orange-700:focus {\n    --text-opacity: 1;\n    color: #b43403;\n    color: rgba(180, 52, 3, var(--text-opacity));\n  }\n  .md\\:focus\\:text-orange-800:focus {\n    --text-opacity: 1;\n    color: #8a2c0d;\n    color: rgba(138, 44, 13, var(--text-opacity));\n  }\n  .md\\:focus\\:text-orange-900:focus {\n    --text-opacity: 1;\n    color: #73230d;\n    color: rgba(115, 35, 13, var(--text-opacity));\n  }\n  .md\\:focus\\:text-yellow-50:focus {\n    --text-opacity: 1;\n    color: #fdfdea;\n    color: rgba(253, 253, 234, var(--text-opacity));\n  }\n  .md\\:focus\\:text-yellow-100:focus {\n    --text-opacity: 1;\n    color: #fdf6b2;\n    color: rgba(253, 246, 178, var(--text-opacity));\n  }\n  .md\\:focus\\:text-yellow-200:focus {\n    --text-opacity: 1;\n    color: #fce96a;\n    color: rgba(252, 233, 106, var(--text-opacity));\n  }\n  .md\\:focus\\:text-yellow-300:focus {\n    --text-opacity: 1;\n    color: #faca15;\n    color: rgba(250, 202, 21, var(--text-opacity));\n  }\n  .md\\:focus\\:text-yellow-400:focus {\n    --text-opacity: 1;\n    color: #e3a008;\n    color: rgba(227, 160, 8, var(--text-opacity));\n  }\n  .md\\:focus\\:text-yellow-500:focus {\n    --text-opacity: 1;\n    color: #c27803;\n    color: rgba(194, 120, 3, var(--text-opacity));\n  }\n  .md\\:focus\\:text-yellow-600:focus {\n    --text-opacity: 1;\n    color: #9f580a;\n    color: rgba(159, 88, 10, var(--text-opacity));\n  }\n  .md\\:focus\\:text-yellow-700:focus {\n    --text-opacity: 1;\n    color: #8e4b10;\n    color: rgba(142, 75, 16, var(--text-opacity));\n  }\n  .md\\:focus\\:text-yellow-800:focus {\n    --text-opacity: 1;\n    color: #723b13;\n    color: rgba(114, 59, 19, var(--text-opacity));\n  }\n  .md\\:focus\\:text-yellow-900:focus {\n    --text-opacity: 1;\n    color: #633112;\n    color: rgba(99, 49, 18, var(--text-opacity));\n  }\n  .md\\:focus\\:text-green-50:focus {\n    --text-opacity: 1;\n    color: #f3faf7;\n    color: rgba(243, 250, 247, var(--text-opacity));\n  }\n  .md\\:focus\\:text-green-100:focus {\n    --text-opacity: 1;\n    color: #def7ec;\n    color: rgba(222, 247, 236, var(--text-opacity));\n  }\n  .md\\:focus\\:text-green-200:focus {\n    --text-opacity: 1;\n    color: #bcf0da;\n    color: rgba(188, 240, 218, var(--text-opacity));\n  }\n  .md\\:focus\\:text-green-300:focus {\n    --text-opacity: 1;\n    color: #84e1bc;\n    color: rgba(132, 225, 188, var(--text-opacity));\n  }\n  .md\\:focus\\:text-green-400:focus {\n    --text-opacity: 1;\n    color: #31c48d;\n    color: rgba(49, 196, 141, var(--text-opacity));\n  }\n  .md\\:focus\\:text-green-500:focus {\n    --text-opacity: 1;\n    color: #0e9f6e;\n    color: rgba(14, 159, 110, var(--text-opacity));\n  }\n  .md\\:focus\\:text-green-600:focus {\n    --text-opacity: 1;\n    color: #057a55;\n    color: rgba(5, 122, 85, var(--text-opacity));\n  }\n  .md\\:focus\\:text-green-700:focus {\n    --text-opacity: 1;\n    color: #046c4e;\n    color: rgba(4, 108, 78, var(--text-opacity));\n  }\n  .md\\:focus\\:text-green-800:focus {\n    --text-opacity: 1;\n    color: #03543f;\n    color: rgba(3, 84, 63, var(--text-opacity));\n  }\n  .md\\:focus\\:text-green-900:focus {\n    --text-opacity: 1;\n    color: #014737;\n    color: rgba(1, 71, 55, var(--text-opacity));\n  }\n  .md\\:focus\\:text-teal-50:focus {\n    --text-opacity: 1;\n    color: #edfafa;\n    color: rgba(237, 250, 250, var(--text-opacity));\n  }\n  .md\\:focus\\:text-teal-100:focus {\n    --text-opacity: 1;\n    color: #d5f5f6;\n    color: rgba(213, 245, 246, var(--text-opacity));\n  }\n  .md\\:focus\\:text-teal-200:focus {\n    --text-opacity: 1;\n    color: #afecef;\n    color: rgba(175, 236, 239, var(--text-opacity));\n  }\n  .md\\:focus\\:text-teal-300:focus {\n    --text-opacity: 1;\n    color: #7edce2;\n    color: rgba(126, 220, 226, var(--text-opacity));\n  }\n  .md\\:focus\\:text-teal-400:focus {\n    --text-opacity: 1;\n    color: #16bdca;\n    color: rgba(22, 189, 202, var(--text-opacity));\n  }\n  .md\\:focus\\:text-teal-500:focus {\n    --text-opacity: 1;\n    color: #0694a2;\n    color: rgba(6, 148, 162, var(--text-opacity));\n  }\n  .md\\:focus\\:text-teal-600:focus {\n    --text-opacity: 1;\n    color: #047481;\n    color: rgba(4, 116, 129, var(--text-opacity));\n  }\n  .md\\:focus\\:text-teal-700:focus {\n    --text-opacity: 1;\n    color: #036672;\n    color: rgba(3, 102, 114, var(--text-opacity));\n  }\n  .md\\:focus\\:text-teal-800:focus {\n    --text-opacity: 1;\n    color: #05505c;\n    color: rgba(5, 80, 92, var(--text-opacity));\n  }\n  .md\\:focus\\:text-teal-900:focus {\n    --text-opacity: 1;\n    color: #014451;\n    color: rgba(1, 68, 81, var(--text-opacity));\n  }\n  .md\\:focus\\:text-blue-50:focus {\n    --text-opacity: 1;\n    color: #ebf5ff;\n    color: rgba(235, 245, 255, var(--text-opacity));\n  }\n  .md\\:focus\\:text-blue-100:focus {\n    --text-opacity: 1;\n    color: #e1effe;\n    color: rgba(225, 239, 254, var(--text-opacity));\n  }\n  .md\\:focus\\:text-blue-200:focus {\n    --text-opacity: 1;\n    color: #c3ddfd;\n    color: rgba(195, 221, 253, var(--text-opacity));\n  }\n  .md\\:focus\\:text-blue-300:focus {\n    --text-opacity: 1;\n    color: #a4cafe;\n    color: rgba(164, 202, 254, var(--text-opacity));\n  }\n  .md\\:focus\\:text-blue-400:focus {\n    --text-opacity: 1;\n    color: #76a9fa;\n    color: rgba(118, 169, 250, var(--text-opacity));\n  }\n  .md\\:focus\\:text-blue-500:focus {\n    --text-opacity: 1;\n    color: #3f83f8;\n    color: rgba(63, 131, 248, var(--text-opacity));\n  }\n  .md\\:focus\\:text-blue-600:focus {\n    --text-opacity: 1;\n    color: #1c64f2;\n    color: rgba(28, 100, 242, var(--text-opacity));\n  }\n  .md\\:focus\\:text-blue-700:focus {\n    --text-opacity: 1;\n    color: #1a56db;\n    color: rgba(26, 86, 219, var(--text-opacity));\n  }\n  .md\\:focus\\:text-blue-800:focus {\n    --text-opacity: 1;\n    color: #1e429f;\n    color: rgba(30, 66, 159, var(--text-opacity));\n  }\n  .md\\:focus\\:text-blue-900:focus {\n    --text-opacity: 1;\n    color: #233876;\n    color: rgba(35, 56, 118, var(--text-opacity));\n  }\n  .md\\:focus\\:text-indigo-50:focus {\n    --text-opacity: 1;\n    color: #f0f5ff;\n    color: rgba(240, 245, 255, var(--text-opacity));\n  }\n  .md\\:focus\\:text-indigo-100:focus {\n    --text-opacity: 1;\n    color: #e5edff;\n    color: rgba(229, 237, 255, var(--text-opacity));\n  }\n  .md\\:focus\\:text-indigo-200:focus {\n    --text-opacity: 1;\n    color: #cddbfe;\n    color: rgba(205, 219, 254, var(--text-opacity));\n  }\n  .md\\:focus\\:text-indigo-300:focus {\n    --text-opacity: 1;\n    color: #b4c6fc;\n    color: rgba(180, 198, 252, var(--text-opacity));\n  }\n  .md\\:focus\\:text-indigo-400:focus {\n    --text-opacity: 1;\n    color: #8da2fb;\n    color: rgba(141, 162, 251, var(--text-opacity));\n  }\n  .md\\:focus\\:text-indigo-500:focus {\n    --text-opacity: 1;\n    color: #6875f5;\n    color: rgba(104, 117, 245, var(--text-opacity));\n  }\n  .md\\:focus\\:text-indigo-600:focus {\n    --text-opacity: 1;\n    color: #5850ec;\n    color: rgba(88, 80, 236, var(--text-opacity));\n  }\n  .md\\:focus\\:text-indigo-700:focus {\n    --text-opacity: 1;\n    color: #5145cd;\n    color: rgba(81, 69, 205, var(--text-opacity));\n  }\n  .md\\:focus\\:text-indigo-800:focus {\n    --text-opacity: 1;\n    color: #42389d;\n    color: rgba(66, 56, 157, var(--text-opacity));\n  }\n  .md\\:focus\\:text-indigo-900:focus {\n    --text-opacity: 1;\n    color: #362f78;\n    color: rgba(54, 47, 120, var(--text-opacity));\n  }\n  .md\\:focus\\:text-purple-50:focus {\n    --text-opacity: 1;\n    color: #f6f5ff;\n    color: rgba(246, 245, 255, var(--text-opacity));\n  }\n  .md\\:focus\\:text-purple-100:focus {\n    --text-opacity: 1;\n    color: #edebfe;\n    color: rgba(237, 235, 254, var(--text-opacity));\n  }\n  .md\\:focus\\:text-purple-200:focus {\n    --text-opacity: 1;\n    color: #dcd7fe;\n    color: rgba(220, 215, 254, var(--text-opacity));\n  }\n  .md\\:focus\\:text-purple-300:focus {\n    --text-opacity: 1;\n    color: #cabffd;\n    color: rgba(202, 191, 253, var(--text-opacity));\n  }\n  .md\\:focus\\:text-purple-400:focus {\n    --text-opacity: 1;\n    color: #ac94fa;\n    color: rgba(172, 148, 250, var(--text-opacity));\n  }\n  .md\\:focus\\:text-purple-500:focus {\n    --text-opacity: 1;\n    color: #9061f9;\n    color: rgba(144, 97, 249, var(--text-opacity));\n  }\n  .md\\:focus\\:text-purple-600:focus {\n    --text-opacity: 1;\n    color: #7e3af2;\n    color: rgba(126, 58, 242, var(--text-opacity));\n  }\n  .md\\:focus\\:text-purple-700:focus {\n    --text-opacity: 1;\n    color: #6c2bd9;\n    color: rgba(108, 43, 217, var(--text-opacity));\n  }\n  .md\\:focus\\:text-purple-800:focus {\n    --text-opacity: 1;\n    color: #5521b5;\n    color: rgba(85, 33, 181, var(--text-opacity));\n  }\n  .md\\:focus\\:text-purple-900:focus {\n    --text-opacity: 1;\n    color: #4a1d96;\n    color: rgba(74, 29, 150, var(--text-opacity));\n  }\n  .md\\:focus\\:text-pink-50:focus {\n    --text-opacity: 1;\n    color: #fdf2f8;\n    color: rgba(253, 242, 248, var(--text-opacity));\n  }\n  .md\\:focus\\:text-pink-100:focus {\n    --text-opacity: 1;\n    color: #fce8f3;\n    color: rgba(252, 232, 243, var(--text-opacity));\n  }\n  .md\\:focus\\:text-pink-200:focus {\n    --text-opacity: 1;\n    color: #fad1e8;\n    color: rgba(250, 209, 232, var(--text-opacity));\n  }\n  .md\\:focus\\:text-pink-300:focus {\n    --text-opacity: 1;\n    color: #f8b4d9;\n    color: rgba(248, 180, 217, var(--text-opacity));\n  }\n  .md\\:focus\\:text-pink-400:focus {\n    --text-opacity: 1;\n    color: #f17eb8;\n    color: rgba(241, 126, 184, var(--text-opacity));\n  }\n  .md\\:focus\\:text-pink-500:focus {\n    --text-opacity: 1;\n    color: #e74694;\n    color: rgba(231, 70, 148, var(--text-opacity));\n  }\n  .md\\:focus\\:text-pink-600:focus {\n    --text-opacity: 1;\n    color: #d61f69;\n    color: rgba(214, 31, 105, var(--text-opacity));\n  }\n  .md\\:focus\\:text-pink-700:focus {\n    --text-opacity: 1;\n    color: #bf125d;\n    color: rgba(191, 18, 93, var(--text-opacity));\n  }\n  .md\\:focus\\:text-pink-800:focus {\n    --text-opacity: 1;\n    color: #99154b;\n    color: rgba(153, 21, 75, var(--text-opacity));\n  }\n  .md\\:focus\\:text-pink-900:focus {\n    --text-opacity: 1;\n    color: #751a3d;\n    color: rgba(117, 26, 61, var(--text-opacity));\n  }\n  .md\\:focus\\:text-cool-gray-50:focus {\n    --text-opacity: 1;\n    color: #f8fafc;\n    color: rgba(248, 250, 252, var(--text-opacity));\n  }\n  .md\\:focus\\:text-cool-gray-100:focus {\n    --text-opacity: 1;\n    color: #f1f5f9;\n    color: rgba(241, 245, 249, var(--text-opacity));\n  }\n  .md\\:focus\\:text-cool-gray-200:focus {\n    --text-opacity: 1;\n    color: #e2e8f0;\n    color: rgba(226, 232, 240, var(--text-opacity));\n  }\n  .md\\:focus\\:text-cool-gray-300:focus {\n    --text-opacity: 1;\n    color: #cfd8e3;\n    color: rgba(207, 216, 227, var(--text-opacity));\n  }\n  .md\\:focus\\:text-cool-gray-400:focus {\n    --text-opacity: 1;\n    color: #97a6ba;\n    color: rgba(151, 166, 186, var(--text-opacity));\n  }\n  .md\\:focus\\:text-cool-gray-500:focus {\n    --text-opacity: 1;\n    color: #64748b;\n    color: rgba(100, 116, 139, var(--text-opacity));\n  }\n  .md\\:focus\\:text-cool-gray-600:focus {\n    --text-opacity: 1;\n    color: #475569;\n    color: rgba(71, 85, 105, var(--text-opacity));\n  }\n  .md\\:focus\\:text-cool-gray-700:focus {\n    --text-opacity: 1;\n    color: #364152;\n    color: rgba(54, 65, 82, var(--text-opacity));\n  }\n  .md\\:focus\\:text-cool-gray-800:focus {\n    --text-opacity: 1;\n    color: #27303f;\n    color: rgba(39, 48, 63, var(--text-opacity));\n  }\n  .md\\:focus\\:text-cool-gray-900:focus {\n    --text-opacity: 1;\n    color: #1a202e;\n    color: rgba(26, 32, 46, var(--text-opacity));\n  }\n  .md\\:active\\:text-current:active {\n    color: currentColor;\n  }\n  .md\\:active\\:text-transparent:active {\n    color: transparent;\n  }\n  .md\\:active\\:text-white:active {\n    --text-opacity: 1;\n    color: #ffffff;\n    color: rgba(255, 255, 255, var(--text-opacity));\n  }\n  .md\\:active\\:text-black:active {\n    --text-opacity: 1;\n    color: #000000;\n    color: rgba(0, 0, 0, var(--text-opacity));\n  }\n  .md\\:active\\:text-gray-50:active {\n    --text-opacity: 1;\n    color: #f9fafb;\n    color: rgba(249, 250, 251, var(--text-opacity));\n  }\n  .md\\:active\\:text-gray-100:active {\n    --text-opacity: 1;\n    color: #f4f5f7;\n    color: rgba(244, 245, 247, var(--text-opacity));\n  }\n  .md\\:active\\:text-gray-200:active {\n    --text-opacity: 1;\n    color: #e5e7eb;\n    color: rgba(229, 231, 235, var(--text-opacity));\n  }\n  .md\\:active\\:text-gray-300:active {\n    --text-opacity: 1;\n    color: #d2d6dc;\n    color: rgba(210, 214, 220, var(--text-opacity));\n  }\n  .md\\:active\\:text-gray-400:active {\n    --text-opacity: 1;\n    color: #9fa6b2;\n    color: rgba(159, 166, 178, var(--text-opacity));\n  }\n  .md\\:active\\:text-gray-500:active {\n    --text-opacity: 1;\n    color: #6b7280;\n    color: rgba(107, 114, 128, var(--text-opacity));\n  }\n  .md\\:active\\:text-gray-600:active {\n    --text-opacity: 1;\n    color: #4b5563;\n    color: rgba(75, 85, 99, var(--text-opacity));\n  }\n  .md\\:active\\:text-gray-700:active {\n    --text-opacity: 1;\n    color: #374151;\n    color: rgba(55, 65, 81, var(--text-opacity));\n  }\n  .md\\:active\\:text-gray-800:active {\n    --text-opacity: 1;\n    color: #252f3f;\n    color: rgba(37, 47, 63, var(--text-opacity));\n  }\n  .md\\:active\\:text-gray-900:active {\n    --text-opacity: 1;\n    color: #161e2e;\n    color: rgba(22, 30, 46, var(--text-opacity));\n  }\n  .md\\:active\\:text-red-50:active {\n    --text-opacity: 1;\n    color: #fdf2f2;\n    color: rgba(253, 242, 242, var(--text-opacity));\n  }\n  .md\\:active\\:text-red-100:active {\n    --text-opacity: 1;\n    color: #fde8e8;\n    color: rgba(253, 232, 232, var(--text-opacity));\n  }\n  .md\\:active\\:text-red-200:active {\n    --text-opacity: 1;\n    color: #fbd5d5;\n    color: rgba(251, 213, 213, var(--text-opacity));\n  }\n  .md\\:active\\:text-red-300:active {\n    --text-opacity: 1;\n    color: #f8b4b4;\n    color: rgba(248, 180, 180, var(--text-opacity));\n  }\n  .md\\:active\\:text-red-400:active {\n    --text-opacity: 1;\n    color: #f98080;\n    color: rgba(249, 128, 128, var(--text-opacity));\n  }\n  .md\\:active\\:text-red-500:active {\n    --text-opacity: 1;\n    color: #f05252;\n    color: rgba(240, 82, 82, var(--text-opacity));\n  }\n  .md\\:active\\:text-red-600:active {\n    --text-opacity: 1;\n    color: #e02424;\n    color: rgba(224, 36, 36, var(--text-opacity));\n  }\n  .md\\:active\\:text-red-700:active {\n    --text-opacity: 1;\n    color: #c81e1e;\n    color: rgba(200, 30, 30, var(--text-opacity));\n  }\n  .md\\:active\\:text-red-800:active {\n    --text-opacity: 1;\n    color: #9b1c1c;\n    color: rgba(155, 28, 28, var(--text-opacity));\n  }\n  .md\\:active\\:text-red-900:active {\n    --text-opacity: 1;\n    color: #771d1d;\n    color: rgba(119, 29, 29, var(--text-opacity));\n  }\n  .md\\:active\\:text-orange-50:active {\n    --text-opacity: 1;\n    color: #fff8f1;\n    color: rgba(255, 248, 241, var(--text-opacity));\n  }\n  .md\\:active\\:text-orange-100:active {\n    --text-opacity: 1;\n    color: #feecdc;\n    color: rgba(254, 236, 220, var(--text-opacity));\n  }\n  .md\\:active\\:text-orange-200:active {\n    --text-opacity: 1;\n    color: #fcd9bd;\n    color: rgba(252, 217, 189, var(--text-opacity));\n  }\n  .md\\:active\\:text-orange-300:active {\n    --text-opacity: 1;\n    color: #fdba8c;\n    color: rgba(253, 186, 140, var(--text-opacity));\n  }\n  .md\\:active\\:text-orange-400:active {\n    --text-opacity: 1;\n    color: #ff8a4c;\n    color: rgba(255, 138, 76, var(--text-opacity));\n  }\n  .md\\:active\\:text-orange-500:active {\n    --text-opacity: 1;\n    color: #ff5a1f;\n    color: rgba(255, 90, 31, var(--text-opacity));\n  }\n  .md\\:active\\:text-orange-600:active {\n    --text-opacity: 1;\n    color: #d03801;\n    color: rgba(208, 56, 1, var(--text-opacity));\n  }\n  .md\\:active\\:text-orange-700:active {\n    --text-opacity: 1;\n    color: #b43403;\n    color: rgba(180, 52, 3, var(--text-opacity));\n  }\n  .md\\:active\\:text-orange-800:active {\n    --text-opacity: 1;\n    color: #8a2c0d;\n    color: rgba(138, 44, 13, var(--text-opacity));\n  }\n  .md\\:active\\:text-orange-900:active {\n    --text-opacity: 1;\n    color: #73230d;\n    color: rgba(115, 35, 13, var(--text-opacity));\n  }\n  .md\\:active\\:text-yellow-50:active {\n    --text-opacity: 1;\n    color: #fdfdea;\n    color: rgba(253, 253, 234, var(--text-opacity));\n  }\n  .md\\:active\\:text-yellow-100:active {\n    --text-opacity: 1;\n    color: #fdf6b2;\n    color: rgba(253, 246, 178, var(--text-opacity));\n  }\n  .md\\:active\\:text-yellow-200:active {\n    --text-opacity: 1;\n    color: #fce96a;\n    color: rgba(252, 233, 106, var(--text-opacity));\n  }\n  .md\\:active\\:text-yellow-300:active {\n    --text-opacity: 1;\n    color: #faca15;\n    color: rgba(250, 202, 21, var(--text-opacity));\n  }\n  .md\\:active\\:text-yellow-400:active {\n    --text-opacity: 1;\n    color: #e3a008;\n    color: rgba(227, 160, 8, var(--text-opacity));\n  }\n  .md\\:active\\:text-yellow-500:active {\n    --text-opacity: 1;\n    color: #c27803;\n    color: rgba(194, 120, 3, var(--text-opacity));\n  }\n  .md\\:active\\:text-yellow-600:active {\n    --text-opacity: 1;\n    color: #9f580a;\n    color: rgba(159, 88, 10, var(--text-opacity));\n  }\n  .md\\:active\\:text-yellow-700:active {\n    --text-opacity: 1;\n    color: #8e4b10;\n    color: rgba(142, 75, 16, var(--text-opacity));\n  }\n  .md\\:active\\:text-yellow-800:active {\n    --text-opacity: 1;\n    color: #723b13;\n    color: rgba(114, 59, 19, var(--text-opacity));\n  }\n  .md\\:active\\:text-yellow-900:active {\n    --text-opacity: 1;\n    color: #633112;\n    color: rgba(99, 49, 18, var(--text-opacity));\n  }\n  .md\\:active\\:text-green-50:active {\n    --text-opacity: 1;\n    color: #f3faf7;\n    color: rgba(243, 250, 247, var(--text-opacity));\n  }\n  .md\\:active\\:text-green-100:active {\n    --text-opacity: 1;\n    color: #def7ec;\n    color: rgba(222, 247, 236, var(--text-opacity));\n  }\n  .md\\:active\\:text-green-200:active {\n    --text-opacity: 1;\n    color: #bcf0da;\n    color: rgba(188, 240, 218, var(--text-opacity));\n  }\n  .md\\:active\\:text-green-300:active {\n    --text-opacity: 1;\n    color: #84e1bc;\n    color: rgba(132, 225, 188, var(--text-opacity));\n  }\n  .md\\:active\\:text-green-400:active {\n    --text-opacity: 1;\n    color: #31c48d;\n    color: rgba(49, 196, 141, var(--text-opacity));\n  }\n  .md\\:active\\:text-green-500:active {\n    --text-opacity: 1;\n    color: #0e9f6e;\n    color: rgba(14, 159, 110, var(--text-opacity));\n  }\n  .md\\:active\\:text-green-600:active {\n    --text-opacity: 1;\n    color: #057a55;\n    color: rgba(5, 122, 85, var(--text-opacity));\n  }\n  .md\\:active\\:text-green-700:active {\n    --text-opacity: 1;\n    color: #046c4e;\n    color: rgba(4, 108, 78, var(--text-opacity));\n  }\n  .md\\:active\\:text-green-800:active {\n    --text-opacity: 1;\n    color: #03543f;\n    color: rgba(3, 84, 63, var(--text-opacity));\n  }\n  .md\\:active\\:text-green-900:active {\n    --text-opacity: 1;\n    color: #014737;\n    color: rgba(1, 71, 55, var(--text-opacity));\n  }\n  .md\\:active\\:text-teal-50:active {\n    --text-opacity: 1;\n    color: #edfafa;\n    color: rgba(237, 250, 250, var(--text-opacity));\n  }\n  .md\\:active\\:text-teal-100:active {\n    --text-opacity: 1;\n    color: #d5f5f6;\n    color: rgba(213, 245, 246, var(--text-opacity));\n  }\n  .md\\:active\\:text-teal-200:active {\n    --text-opacity: 1;\n    color: #afecef;\n    color: rgba(175, 236, 239, var(--text-opacity));\n  }\n  .md\\:active\\:text-teal-300:active {\n    --text-opacity: 1;\n    color: #7edce2;\n    color: rgba(126, 220, 226, var(--text-opacity));\n  }\n  .md\\:active\\:text-teal-400:active {\n    --text-opacity: 1;\n    color: #16bdca;\n    color: rgba(22, 189, 202, var(--text-opacity));\n  }\n  .md\\:active\\:text-teal-500:active {\n    --text-opacity: 1;\n    color: #0694a2;\n    color: rgba(6, 148, 162, var(--text-opacity));\n  }\n  .md\\:active\\:text-teal-600:active {\n    --text-opacity: 1;\n    color: #047481;\n    color: rgba(4, 116, 129, var(--text-opacity));\n  }\n  .md\\:active\\:text-teal-700:active {\n    --text-opacity: 1;\n    color: #036672;\n    color: rgba(3, 102, 114, var(--text-opacity));\n  }\n  .md\\:active\\:text-teal-800:active {\n    --text-opacity: 1;\n    color: #05505c;\n    color: rgba(5, 80, 92, var(--text-opacity));\n  }\n  .md\\:active\\:text-teal-900:active {\n    --text-opacity: 1;\n    color: #014451;\n    color: rgba(1, 68, 81, var(--text-opacity));\n  }\n  .md\\:active\\:text-blue-50:active {\n    --text-opacity: 1;\n    color: #ebf5ff;\n    color: rgba(235, 245, 255, var(--text-opacity));\n  }\n  .md\\:active\\:text-blue-100:active {\n    --text-opacity: 1;\n    color: #e1effe;\n    color: rgba(225, 239, 254, var(--text-opacity));\n  }\n  .md\\:active\\:text-blue-200:active {\n    --text-opacity: 1;\n    color: #c3ddfd;\n    color: rgba(195, 221, 253, var(--text-opacity));\n  }\n  .md\\:active\\:text-blue-300:active {\n    --text-opacity: 1;\n    color: #a4cafe;\n    color: rgba(164, 202, 254, var(--text-opacity));\n  }\n  .md\\:active\\:text-blue-400:active {\n    --text-opacity: 1;\n    color: #76a9fa;\n    color: rgba(118, 169, 250, var(--text-opacity));\n  }\n  .md\\:active\\:text-blue-500:active {\n    --text-opacity: 1;\n    color: #3f83f8;\n    color: rgba(63, 131, 248, var(--text-opacity));\n  }\n  .md\\:active\\:text-blue-600:active {\n    --text-opacity: 1;\n    color: #1c64f2;\n    color: rgba(28, 100, 242, var(--text-opacity));\n  }\n  .md\\:active\\:text-blue-700:active {\n    --text-opacity: 1;\n    color: #1a56db;\n    color: rgba(26, 86, 219, var(--text-opacity));\n  }\n  .md\\:active\\:text-blue-800:active {\n    --text-opacity: 1;\n    color: #1e429f;\n    color: rgba(30, 66, 159, var(--text-opacity));\n  }\n  .md\\:active\\:text-blue-900:active {\n    --text-opacity: 1;\n    color: #233876;\n    color: rgba(35, 56, 118, var(--text-opacity));\n  }\n  .md\\:active\\:text-indigo-50:active {\n    --text-opacity: 1;\n    color: #f0f5ff;\n    color: rgba(240, 245, 255, var(--text-opacity));\n  }\n  .md\\:active\\:text-indigo-100:active {\n    --text-opacity: 1;\n    color: #e5edff;\n    color: rgba(229, 237, 255, var(--text-opacity));\n  }\n  .md\\:active\\:text-indigo-200:active {\n    --text-opacity: 1;\n    color: #cddbfe;\n    color: rgba(205, 219, 254, var(--text-opacity));\n  }\n  .md\\:active\\:text-indigo-300:active {\n    --text-opacity: 1;\n    color: #b4c6fc;\n    color: rgba(180, 198, 252, var(--text-opacity));\n  }\n  .md\\:active\\:text-indigo-400:active {\n    --text-opacity: 1;\n    color: #8da2fb;\n    color: rgba(141, 162, 251, var(--text-opacity));\n  }\n  .md\\:active\\:text-indigo-500:active {\n    --text-opacity: 1;\n    color: #6875f5;\n    color: rgba(104, 117, 245, var(--text-opacity));\n  }\n  .md\\:active\\:text-indigo-600:active {\n    --text-opacity: 1;\n    color: #5850ec;\n    color: rgba(88, 80, 236, var(--text-opacity));\n  }\n  .md\\:active\\:text-indigo-700:active {\n    --text-opacity: 1;\n    color: #5145cd;\n    color: rgba(81, 69, 205, var(--text-opacity));\n  }\n  .md\\:active\\:text-indigo-800:active {\n    --text-opacity: 1;\n    color: #42389d;\n    color: rgba(66, 56, 157, var(--text-opacity));\n  }\n  .md\\:active\\:text-indigo-900:active {\n    --text-opacity: 1;\n    color: #362f78;\n    color: rgba(54, 47, 120, var(--text-opacity));\n  }\n  .md\\:active\\:text-purple-50:active {\n    --text-opacity: 1;\n    color: #f6f5ff;\n    color: rgba(246, 245, 255, var(--text-opacity));\n  }\n  .md\\:active\\:text-purple-100:active {\n    --text-opacity: 1;\n    color: #edebfe;\n    color: rgba(237, 235, 254, var(--text-opacity));\n  }\n  .md\\:active\\:text-purple-200:active {\n    --text-opacity: 1;\n    color: #dcd7fe;\n    color: rgba(220, 215, 254, var(--text-opacity));\n  }\n  .md\\:active\\:text-purple-300:active {\n    --text-opacity: 1;\n    color: #cabffd;\n    color: rgba(202, 191, 253, var(--text-opacity));\n  }\n  .md\\:active\\:text-purple-400:active {\n    --text-opacity: 1;\n    color: #ac94fa;\n    color: rgba(172, 148, 250, var(--text-opacity));\n  }\n  .md\\:active\\:text-purple-500:active {\n    --text-opacity: 1;\n    color: #9061f9;\n    color: rgba(144, 97, 249, var(--text-opacity));\n  }\n  .md\\:active\\:text-purple-600:active {\n    --text-opacity: 1;\n    color: #7e3af2;\n    color: rgba(126, 58, 242, var(--text-opacity));\n  }\n  .md\\:active\\:text-purple-700:active {\n    --text-opacity: 1;\n    color: #6c2bd9;\n    color: rgba(108, 43, 217, var(--text-opacity));\n  }\n  .md\\:active\\:text-purple-800:active {\n    --text-opacity: 1;\n    color: #5521b5;\n    color: rgba(85, 33, 181, var(--text-opacity));\n  }\n  .md\\:active\\:text-purple-900:active {\n    --text-opacity: 1;\n    color: #4a1d96;\n    color: rgba(74, 29, 150, var(--text-opacity));\n  }\n  .md\\:active\\:text-pink-50:active {\n    --text-opacity: 1;\n    color: #fdf2f8;\n    color: rgba(253, 242, 248, var(--text-opacity));\n  }\n  .md\\:active\\:text-pink-100:active {\n    --text-opacity: 1;\n    color: #fce8f3;\n    color: rgba(252, 232, 243, var(--text-opacity));\n  }\n  .md\\:active\\:text-pink-200:active {\n    --text-opacity: 1;\n    color: #fad1e8;\n    color: rgba(250, 209, 232, var(--text-opacity));\n  }\n  .md\\:active\\:text-pink-300:active {\n    --text-opacity: 1;\n    color: #f8b4d9;\n    color: rgba(248, 180, 217, var(--text-opacity));\n  }\n  .md\\:active\\:text-pink-400:active {\n    --text-opacity: 1;\n    color: #f17eb8;\n    color: rgba(241, 126, 184, var(--text-opacity));\n  }\n  .md\\:active\\:text-pink-500:active {\n    --text-opacity: 1;\n    color: #e74694;\n    color: rgba(231, 70, 148, var(--text-opacity));\n  }\n  .md\\:active\\:text-pink-600:active {\n    --text-opacity: 1;\n    color: #d61f69;\n    color: rgba(214, 31, 105, var(--text-opacity));\n  }\n  .md\\:active\\:text-pink-700:active {\n    --text-opacity: 1;\n    color: #bf125d;\n    color: rgba(191, 18, 93, var(--text-opacity));\n  }\n  .md\\:active\\:text-pink-800:active {\n    --text-opacity: 1;\n    color: #99154b;\n    color: rgba(153, 21, 75, var(--text-opacity));\n  }\n  .md\\:active\\:text-pink-900:active {\n    --text-opacity: 1;\n    color: #751a3d;\n    color: rgba(117, 26, 61, var(--text-opacity));\n  }\n  .md\\:active\\:text-cool-gray-50:active {\n    --text-opacity: 1;\n    color: #f8fafc;\n    color: rgba(248, 250, 252, var(--text-opacity));\n  }\n  .md\\:active\\:text-cool-gray-100:active {\n    --text-opacity: 1;\n    color: #f1f5f9;\n    color: rgba(241, 245, 249, var(--text-opacity));\n  }\n  .md\\:active\\:text-cool-gray-200:active {\n    --text-opacity: 1;\n    color: #e2e8f0;\n    color: rgba(226, 232, 240, var(--text-opacity));\n  }\n  .md\\:active\\:text-cool-gray-300:active {\n    --text-opacity: 1;\n    color: #cfd8e3;\n    color: rgba(207, 216, 227, var(--text-opacity));\n  }\n  .md\\:active\\:text-cool-gray-400:active {\n    --text-opacity: 1;\n    color: #97a6ba;\n    color: rgba(151, 166, 186, var(--text-opacity));\n  }\n  .md\\:active\\:text-cool-gray-500:active {\n    --text-opacity: 1;\n    color: #64748b;\n    color: rgba(100, 116, 139, var(--text-opacity));\n  }\n  .md\\:active\\:text-cool-gray-600:active {\n    --text-opacity: 1;\n    color: #475569;\n    color: rgba(71, 85, 105, var(--text-opacity));\n  }\n  .md\\:active\\:text-cool-gray-700:active {\n    --text-opacity: 1;\n    color: #364152;\n    color: rgba(54, 65, 82, var(--text-opacity));\n  }\n  .md\\:active\\:text-cool-gray-800:active {\n    --text-opacity: 1;\n    color: #27303f;\n    color: rgba(39, 48, 63, var(--text-opacity));\n  }\n  .md\\:active\\:text-cool-gray-900:active {\n    --text-opacity: 1;\n    color: #1a202e;\n    color: rgba(26, 32, 46, var(--text-opacity));\n  }\n  .md\\:text-opacity-0 {\n    --text-opacity: 0;\n  }\n  .md\\:text-opacity-25 {\n    --text-opacity: 0.25;\n  }\n  .md\\:text-opacity-50 {\n    --text-opacity: 0.5;\n  }\n  .md\\:text-opacity-75 {\n    --text-opacity: 0.75;\n  }\n  .md\\:text-opacity-100 {\n    --text-opacity: 1;\n  }\n  .md\\:hover\\:text-opacity-0:hover {\n    --text-opacity: 0;\n  }\n  .md\\:hover\\:text-opacity-25:hover {\n    --text-opacity: 0.25;\n  }\n  .md\\:hover\\:text-opacity-50:hover {\n    --text-opacity: 0.5;\n  }\n  .md\\:hover\\:text-opacity-75:hover {\n    --text-opacity: 0.75;\n  }\n  .md\\:hover\\:text-opacity-100:hover {\n    --text-opacity: 1;\n  }\n  .md\\:focus\\:text-opacity-0:focus {\n    --text-opacity: 0;\n  }\n  .md\\:focus\\:text-opacity-25:focus {\n    --text-opacity: 0.25;\n  }\n  .md\\:focus\\:text-opacity-50:focus {\n    --text-opacity: 0.5;\n  }\n  .md\\:focus\\:text-opacity-75:focus {\n    --text-opacity: 0.75;\n  }\n  .md\\:focus\\:text-opacity-100:focus {\n    --text-opacity: 1;\n  }\n  .md\\:italic {\n    font-style: italic;\n  }\n  .md\\:not-italic {\n    font-style: normal;\n  }\n  .md\\:uppercase {\n    text-transform: uppercase;\n  }\n  .md\\:lowercase {\n    text-transform: lowercase;\n  }\n  .md\\:capitalize {\n    text-transform: capitalize;\n  }\n  .md\\:normal-case {\n    text-transform: none;\n  }\n  .md\\:underline {\n    text-decoration: none;\n  }\n  .md\\:line-through {\n    text-decoration: line-through;\n  }\n  .md\\:no-underline {\n    text-decoration: none;\n  }\n  .group:hover .md\\:group-hover\\:underline {\n    text-decoration: none;\n  }\n  .group:hover .md\\:group-hover\\:line-through {\n    text-decoration: line-through;\n  }\n  .group:hover .md\\:group-hover\\:no-underline {\n    text-decoration: none;\n  }\n  .group:focus .md\\:group-focus\\:underline {\n    text-decoration: none;\n  }\n  .group:focus .md\\:group-focus\\:line-through {\n    text-decoration: line-through;\n  }\n  .group:focus .md\\:group-focus\\:no-underline {\n    text-decoration: none;\n  }\n  .md\\:hover\\:underline:hover {\n    text-decoration: none;\n  }\n  .md\\:hover\\:line-through:hover {\n    text-decoration: line-through;\n  }\n  .md\\:hover\\:no-underline:hover {\n    text-decoration: none;\n  }\n  .md\\:focus\\:underline:focus {\n    text-decoration: none;\n  }\n  .md\\:focus\\:line-through:focus {\n    text-decoration: line-through;\n  }\n  .md\\:focus\\:no-underline:focus {\n    text-decoration: none;\n  }\n  .md\\:antialiased {\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n  }\n  .md\\:subpixel-antialiased {\n    -webkit-font-smoothing: auto;\n    -moz-osx-font-smoothing: auto;\n  }\n  .md\\:ordinal, .md\\:slashed-zero, .md\\:lining-nums, .md\\:oldstyle-nums, .md\\:proportional-nums, .md\\:tabular-nums, .md\\:diagonal-fractions, .md\\:stacked-fractions {\n    --font-variant-numeric-ordinal: var(--tailwind-empty,\n        /*!*/\n        /*!*/\n      );\n    --font-variant-numeric-slashed-zero: var(--tailwind-empty,\n        /*!*/\n        /*!*/\n      );\n    --font-variant-numeric-figure: var(--tailwind-empty,\n        /*!*/\n        /*!*/\n      );\n    --font-variant-numeric-spacing: var(--tailwind-empty,\n        /*!*/\n        /*!*/\n      );\n    --font-variant-numeric-fraction: var(--tailwind-empty,\n        /*!*/\n        /*!*/\n      );\n    font-variant-numeric: var(--font-variant-numeric-ordinal) var(--font-variant-numeric-slashed-zero) var(--font-variant-numeric-figure) var(--font-variant-numeric-spacing) var(--font-variant-numeric-fraction);\n  }\n  .md\\:normal-nums {\n    font-variant-numeric: normal;\n  }\n  .md\\:ordinal {\n    --font-variant-numeric-ordinal: ordinal;\n  }\n  .md\\:slashed-zero {\n    --font-variant-numeric-slashed-zero: slashed-zero;\n  }\n  .md\\:lining-nums {\n    --font-variant-numeric-figure: lining-nums;\n  }\n  .md\\:oldstyle-nums {\n    --font-variant-numeric-figure: oldstyle-nums;\n  }\n  .md\\:proportional-nums {\n    --font-variant-numeric-spacing: proportional-nums;\n  }\n  .md\\:tabular-nums {\n    --font-variant-numeric-spacing: tabular-nums;\n  }\n  .md\\:diagonal-fractions {\n    --font-variant-numeric-fraction: diagonal-fractions;\n  }\n  .md\\:stacked-fractions {\n    --font-variant-numeric-fraction: stacked-fractions;\n  }\n  .md\\:tracking-tighter {\n    letter-spacing: -0.05em;\n  }\n  .md\\:tracking-tight {\n    letter-spacing: -0.025em;\n  }\n  .md\\:tracking-normal {\n    letter-spacing: 0;\n  }\n  .md\\:tracking-wide {\n    letter-spacing: 0.025em;\n  }\n  .md\\:tracking-wider {\n    letter-spacing: 0.05em;\n  }\n  .md\\:tracking-widest {\n    letter-spacing: 0.1em;\n  }\n  .md\\:select-none {\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    user-select: none;\n  }\n  .md\\:select-text {\n    -webkit-user-select: text;\n    -moz-user-select: text;\n    user-select: text;\n  }\n  .md\\:select-all {\n    -webkit-user-select: all;\n    -moz-user-select: all;\n    user-select: all;\n  }\n  .md\\:select-auto {\n    -webkit-user-select: auto;\n    -moz-user-select: auto;\n    user-select: auto;\n  }\n  .md\\:align-baseline {\n    vertical-align: baseline;\n  }\n  .md\\:align-top {\n    vertical-align: top;\n  }\n  .md\\:align-middle {\n    vertical-align: middle;\n  }\n  .md\\:align-bottom {\n    vertical-align: bottom;\n  }\n  .md\\:align-text-top {\n    vertical-align: text-top;\n  }\n  .md\\:align-text-bottom {\n    vertical-align: text-bottom;\n  }\n  .md\\:visible {\n    visibility: visible;\n  }\n  .md\\:invisible {\n    visibility: hidden;\n  }\n  .md\\:whitespace-normal {\n    white-space: normal;\n  }\n  .md\\:whitespace-no-wrap {\n    white-space: nowrap;\n  }\n  .md\\:whitespace-pre {\n    white-space: pre;\n  }\n  .md\\:whitespace-pre-line {\n    white-space: pre-line;\n  }\n  .md\\:whitespace-pre-wrap {\n    white-space: pre-wrap;\n  }\n  .md\\:break-normal {\n    word-wrap: normal;\n    overflow-wrap: normal;\n    word-break: normal;\n  }\n  .md\\:break-words {\n    word-wrap: break-word;\n    overflow-wrap: break-word;\n  }\n  .md\\:break-all {\n    word-break: break-all;\n  }\n  .md\\:truncate {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n  .md\\:w-0 {\n    width: 0;\n  }\n  .md\\:w-1 {\n    width: 0.25rem;\n  }\n  .md\\:w-2 {\n    width: 0.5rem;\n  }\n  .md\\:w-3 {\n    width: 0.75rem;\n  }\n  .md\\:w-4 {\n    width: 1rem;\n  }\n  .md\\:w-5 {\n    width: 1.25rem;\n  }\n  .md\\:w-6 {\n    width: 1.5rem;\n  }\n  .md\\:w-7 {\n    width: 1.75rem;\n  }\n  .md\\:w-8 {\n    width: 2rem;\n  }\n  .md\\:w-9 {\n    width: 2.25rem;\n  }\n  .md\\:w-10 {\n    width: 2.5rem;\n  }\n  .md\\:w-11 {\n    width: 2.75rem;\n  }\n  .md\\:w-12 {\n    width: 3rem;\n  }\n  .md\\:w-13 {\n    width: 3.25rem;\n  }\n  .md\\:w-14 {\n    width: 3.5rem;\n  }\n  .md\\:w-15 {\n    width: 3.75rem;\n  }\n  .md\\:w-16 {\n    width: 4rem;\n  }\n  .md\\:w-20 {\n    width: 5rem;\n  }\n  .md\\:w-24 {\n    width: 6rem;\n  }\n  .md\\:w-28 {\n    width: 7rem;\n  }\n  .md\\:w-32 {\n    width: 8rem;\n  }\n  .md\\:w-36 {\n    width: 9rem;\n  }\n  .md\\:w-40 {\n    width: 10rem;\n  }\n  .md\\:w-44 {\n    width: 11rem;\n  }\n  .md\\:w-48 {\n    width: 12rem;\n  }\n  .md\\:w-52 {\n    width: 13rem;\n  }\n  .md\\:w-56 {\n    width: 14rem;\n  }\n  .md\\:w-60 {\n    width: 15rem;\n  }\n  .md\\:w-64 {\n    width: 16rem;\n  }\n  .md\\:w-72 {\n    width: 18rem;\n  }\n  .md\\:w-80 {\n    width: 20rem;\n  }\n  .md\\:w-96 {\n    width: 24rem;\n  }\n  .md\\:w-auto {\n    width: auto;\n  }\n  .md\\:w-px {\n    width: 1px;\n  }\n  .md\\:w-0\\.5 {\n    width: 0.125rem;\n  }\n  .md\\:w-1\\.5 {\n    width: 0.375rem;\n  }\n  .md\\:w-2\\.5 {\n    width: 0.625rem;\n  }\n  .md\\:w-3\\.5 {\n    width: 0.875rem;\n  }\n  .md\\:w-1\\/2 {\n    width: 50%;\n  }\n  .md\\:w-1\\/3 {\n    width: 33.333333%;\n  }\n  .md\\:w-2\\/3 {\n    width: 66.666667%;\n  }\n  .md\\:w-1\\/4 {\n    width: 25%;\n  }\n  .md\\:w-2\\/4 {\n    width: 50%;\n  }\n  .md\\:w-3\\/4 {\n    width: 75%;\n  }\n  .md\\:w-1\\/5 {\n    width: 20%;\n  }\n  .md\\:w-2\\/5 {\n    width: 40%;\n  }\n  .md\\:w-3\\/5 {\n    width: 60%;\n  }\n  .md\\:w-4\\/5 {\n    width: 80%;\n  }\n  .md\\:w-1\\/6 {\n    width: 16.666667%;\n  }\n  .md\\:w-2\\/6 {\n    width: 33.333333%;\n  }\n  .md\\:w-3\\/6 {\n    width: 50%;\n  }\n  .md\\:w-4\\/6 {\n    width: 66.666667%;\n  }\n  .md\\:w-5\\/6 {\n    width: 83.333333%;\n  }\n  .md\\:w-1\\/12 {\n    width: 8.333333%;\n  }\n  .md\\:w-2\\/12 {\n    width: 16.666667%;\n  }\n  .md\\:w-3\\/12 {\n    width: 25%;\n  }\n  .md\\:w-4\\/12 {\n    width: 33.333333%;\n  }\n  .md\\:w-5\\/12 {\n    width: 41.666667%;\n  }\n  .md\\:w-6\\/12 {\n    width: 50%;\n  }\n  .md\\:w-7\\/12 {\n    width: 58.333333%;\n  }\n  .md\\:w-8\\/12 {\n    width: 66.666667%;\n  }\n  .md\\:w-9\\/12 {\n    width: 75%;\n  }\n  .md\\:w-10\\/12 {\n    width: 83.333333%;\n  }\n  .md\\:w-11\\/12 {\n    width: 91.666667%;\n  }\n  .md\\:w-full {\n    width: 100%;\n  }\n  .md\\:w-screen {\n    width: 100vw;\n  }\n  .md\\:w-min-content {\n    width: -moz-min-content;\n    width: min-content;\n  }\n  .md\\:w-max-content {\n    width: -moz-max-content;\n    width: max-content;\n  }\n  .md\\:z-0 {\n    z-index: 0;\n  }\n  .md\\:z-10 {\n    z-index: 10;\n  }\n  .md\\:z-20 {\n    z-index: 20;\n  }\n  .md\\:z-30 {\n    z-index: 30;\n  }\n  .md\\:z-40 {\n    z-index: 40;\n  }\n  .md\\:z-50 {\n    z-index: 50;\n  }\n  .md\\:z-auto {\n    z-index: auto;\n  }\n  .md\\:focus-within\\:z-0:focus-within {\n    z-index: 0;\n  }\n  .md\\:focus-within\\:z-10:focus-within {\n    z-index: 10;\n  }\n  .md\\:focus-within\\:z-20:focus-within {\n    z-index: 20;\n  }\n  .md\\:focus-within\\:z-30:focus-within {\n    z-index: 30;\n  }\n  .md\\:focus-within\\:z-40:focus-within {\n    z-index: 40;\n  }\n  .md\\:focus-within\\:z-50:focus-within {\n    z-index: 50;\n  }\n  .md\\:focus-within\\:z-auto:focus-within {\n    z-index: auto;\n  }\n  .md\\:focus\\:z-0:focus {\n    z-index: 0;\n  }\n  .md\\:focus\\:z-10:focus {\n    z-index: 10;\n  }\n  .md\\:focus\\:z-20:focus {\n    z-index: 20;\n  }\n  .md\\:focus\\:z-30:focus {\n    z-index: 30;\n  }\n  .md\\:focus\\:z-40:focus {\n    z-index: 40;\n  }\n  .md\\:focus\\:z-50:focus {\n    z-index: 50;\n  }\n  .md\\:focus\\:z-auto:focus {\n    z-index: auto;\n  }\n  .md\\:gap-0 {\n    grid-gap: 0;\n    gap: 0;\n  }\n  .md\\:gap-1 {\n    grid-gap: 0.25rem;\n    gap: 0.25rem;\n  }\n  .md\\:gap-2 {\n    grid-gap: 0.5rem;\n    gap: 0.5rem;\n  }\n  .md\\:gap-3 {\n    grid-gap: 0.75rem;\n    gap: 0.75rem;\n  }\n  .md\\:gap-4 {\n    grid-gap: 1rem;\n    gap: 1rem;\n  }\n  .md\\:gap-5 {\n    grid-gap: 1.25rem;\n    gap: 1.25rem;\n  }\n  .md\\:gap-6 {\n    grid-gap: 1.5rem;\n    gap: 1.5rem;\n  }\n  .md\\:gap-7 {\n    grid-gap: 1.75rem;\n    gap: 1.75rem;\n  }\n  .md\\:gap-8 {\n    grid-gap: 2rem;\n    gap: 2rem;\n  }\n  .md\\:gap-9 {\n    grid-gap: 2.25rem;\n    gap: 2.25rem;\n  }\n  .md\\:gap-10 {\n    grid-gap: 2.5rem;\n    gap: 2.5rem;\n  }\n  .md\\:gap-11 {\n    grid-gap: 2.75rem;\n    gap: 2.75rem;\n  }\n  .md\\:gap-12 {\n    grid-gap: 3rem;\n    gap: 3rem;\n  }\n  .md\\:gap-13 {\n    grid-gap: 3.25rem;\n    gap: 3.25rem;\n  }\n  .md\\:gap-14 {\n    grid-gap: 3.5rem;\n    gap: 3.5rem;\n  }\n  .md\\:gap-15 {\n    grid-gap: 3.75rem;\n    gap: 3.75rem;\n  }\n  .md\\:gap-16 {\n    grid-gap: 4rem;\n    gap: 4rem;\n  }\n  .md\\:gap-20 {\n    grid-gap: 5rem;\n    gap: 5rem;\n  }\n  .md\\:gap-24 {\n    grid-gap: 6rem;\n    gap: 6rem;\n  }\n  .md\\:gap-28 {\n    grid-gap: 7rem;\n    gap: 7rem;\n  }\n  .md\\:gap-32 {\n    grid-gap: 8rem;\n    gap: 8rem;\n  }\n  .md\\:gap-36 {\n    grid-gap: 9rem;\n    gap: 9rem;\n  }\n  .md\\:gap-40 {\n    grid-gap: 10rem;\n    gap: 10rem;\n  }\n  .md\\:gap-44 {\n    grid-gap: 11rem;\n    gap: 11rem;\n  }\n  .md\\:gap-48 {\n    grid-gap: 12rem;\n    gap: 12rem;\n  }\n  .md\\:gap-52 {\n    grid-gap: 13rem;\n    gap: 13rem;\n  }\n  .md\\:gap-56 {\n    grid-gap: 14rem;\n    gap: 14rem;\n  }\n  .md\\:gap-60 {\n    grid-gap: 15rem;\n    gap: 15rem;\n  }\n  .md\\:gap-64 {\n    grid-gap: 16rem;\n    gap: 16rem;\n  }\n  .md\\:gap-72 {\n    grid-gap: 18rem;\n    gap: 18rem;\n  }\n  .md\\:gap-80 {\n    grid-gap: 20rem;\n    gap: 20rem;\n  }\n  .md\\:gap-96 {\n    grid-gap: 24rem;\n    gap: 24rem;\n  }\n  .md\\:gap-px {\n    grid-gap: 1px;\n    gap: 1px;\n  }\n  .md\\:gap-0\\.5 {\n    grid-gap: 0.125rem;\n    gap: 0.125rem;\n  }\n  .md\\:gap-1\\.5 {\n    grid-gap: 0.375rem;\n    gap: 0.375rem;\n  }\n  .md\\:gap-2\\.5 {\n    grid-gap: 0.625rem;\n    gap: 0.625rem;\n  }\n  .md\\:gap-3\\.5 {\n    grid-gap: 0.875rem;\n    gap: 0.875rem;\n  }\n  .md\\:gap-1\\/2 {\n    grid-gap: 50%;\n    gap: 50%;\n  }\n  .md\\:gap-1\\/3 {\n    grid-gap: 33.333333%;\n    gap: 33.333333%;\n  }\n  .md\\:gap-2\\/3 {\n    grid-gap: 66.666667%;\n    gap: 66.666667%;\n  }\n  .md\\:gap-1\\/4 {\n    grid-gap: 25%;\n    gap: 25%;\n  }\n  .md\\:gap-2\\/4 {\n    grid-gap: 50%;\n    gap: 50%;\n  }\n  .md\\:gap-3\\/4 {\n    grid-gap: 75%;\n    gap: 75%;\n  }\n  .md\\:gap-1\\/5 {\n    grid-gap: 20%;\n    gap: 20%;\n  }\n  .md\\:gap-2\\/5 {\n    grid-gap: 40%;\n    gap: 40%;\n  }\n  .md\\:gap-3\\/5 {\n    grid-gap: 60%;\n    gap: 60%;\n  }\n  .md\\:gap-4\\/5 {\n    grid-gap: 80%;\n    gap: 80%;\n  }\n  .md\\:gap-1\\/6 {\n    grid-gap: 16.666667%;\n    gap: 16.666667%;\n  }\n  .md\\:gap-2\\/6 {\n    grid-gap: 33.333333%;\n    gap: 33.333333%;\n  }\n  .md\\:gap-3\\/6 {\n    grid-gap: 50%;\n    gap: 50%;\n  }\n  .md\\:gap-4\\/6 {\n    grid-gap: 66.666667%;\n    gap: 66.666667%;\n  }\n  .md\\:gap-5\\/6 {\n    grid-gap: 83.333333%;\n    gap: 83.333333%;\n  }\n  .md\\:gap-1\\/12 {\n    grid-gap: 8.333333%;\n    gap: 8.333333%;\n  }\n  .md\\:gap-2\\/12 {\n    grid-gap: 16.666667%;\n    gap: 16.666667%;\n  }\n  .md\\:gap-3\\/12 {\n    grid-gap: 25%;\n    gap: 25%;\n  }\n  .md\\:gap-4\\/12 {\n    grid-gap: 33.333333%;\n    gap: 33.333333%;\n  }\n  .md\\:gap-5\\/12 {\n    grid-gap: 41.666667%;\n    gap: 41.666667%;\n  }\n  .md\\:gap-6\\/12 {\n    grid-gap: 50%;\n    gap: 50%;\n  }\n  .md\\:gap-7\\/12 {\n    grid-gap: 58.333333%;\n    gap: 58.333333%;\n  }\n  .md\\:gap-8\\/12 {\n    grid-gap: 66.666667%;\n    gap: 66.666667%;\n  }\n  .md\\:gap-9\\/12 {\n    grid-gap: 75%;\n    gap: 75%;\n  }\n  .md\\:gap-10\\/12 {\n    grid-gap: 83.333333%;\n    gap: 83.333333%;\n  }\n  .md\\:gap-11\\/12 {\n    grid-gap: 91.666667%;\n    gap: 91.666667%;\n  }\n  .md\\:gap-full {\n    grid-gap: 100%;\n    gap: 100%;\n  }\n  .md\\:col-gap-0 {\n    grid-column-gap: 0;\n    -moz-column-gap: 0;\n    column-gap: 0;\n  }\n  .md\\:col-gap-1 {\n    grid-column-gap: 0.25rem;\n    -moz-column-gap: 0.25rem;\n    column-gap: 0.25rem;\n  }\n  .md\\:col-gap-2 {\n    grid-column-gap: 0.5rem;\n    -moz-column-gap: 0.5rem;\n    column-gap: 0.5rem;\n  }\n  .md\\:col-gap-3 {\n    grid-column-gap: 0.75rem;\n    -moz-column-gap: 0.75rem;\n    column-gap: 0.75rem;\n  }\n  .md\\:col-gap-4 {\n    grid-column-gap: 1rem;\n    -moz-column-gap: 1rem;\n    column-gap: 1rem;\n  }\n  .md\\:col-gap-5 {\n    grid-column-gap: 1.25rem;\n    -moz-column-gap: 1.25rem;\n    column-gap: 1.25rem;\n  }\n  .md\\:col-gap-6 {\n    grid-column-gap: 1.5rem;\n    -moz-column-gap: 1.5rem;\n    column-gap: 1.5rem;\n  }\n  .md\\:col-gap-7 {\n    grid-column-gap: 1.75rem;\n    -moz-column-gap: 1.75rem;\n    column-gap: 1.75rem;\n  }\n  .md\\:col-gap-8 {\n    grid-column-gap: 2rem;\n    -moz-column-gap: 2rem;\n    column-gap: 2rem;\n  }\n  .md\\:col-gap-9 {\n    grid-column-gap: 2.25rem;\n    -moz-column-gap: 2.25rem;\n    column-gap: 2.25rem;\n  }\n  .md\\:col-gap-10 {\n    grid-column-gap: 2.5rem;\n    -moz-column-gap: 2.5rem;\n    column-gap: 2.5rem;\n  }\n  .md\\:col-gap-11 {\n    grid-column-gap: 2.75rem;\n    -moz-column-gap: 2.75rem;\n    column-gap: 2.75rem;\n  }\n  .md\\:col-gap-12 {\n    grid-column-gap: 3rem;\n    -moz-column-gap: 3rem;\n    column-gap: 3rem;\n  }\n  .md\\:col-gap-13 {\n    grid-column-gap: 3.25rem;\n    -moz-column-gap: 3.25rem;\n    column-gap: 3.25rem;\n  }\n  .md\\:col-gap-14 {\n    grid-column-gap: 3.5rem;\n    -moz-column-gap: 3.5rem;\n    column-gap: 3.5rem;\n  }\n  .md\\:col-gap-15 {\n    grid-column-gap: 3.75rem;\n    -moz-column-gap: 3.75rem;\n    column-gap: 3.75rem;\n  }\n  .md\\:col-gap-16 {\n    grid-column-gap: 4rem;\n    -moz-column-gap: 4rem;\n    column-gap: 4rem;\n  }\n  .md\\:col-gap-20 {\n    grid-column-gap: 5rem;\n    -moz-column-gap: 5rem;\n    column-gap: 5rem;\n  }\n  .md\\:col-gap-24 {\n    grid-column-gap: 6rem;\n    -moz-column-gap: 6rem;\n    column-gap: 6rem;\n  }\n  .md\\:col-gap-28 {\n    grid-column-gap: 7rem;\n    -moz-column-gap: 7rem;\n    column-gap: 7rem;\n  }\n  .md\\:col-gap-32 {\n    grid-column-gap: 8rem;\n    -moz-column-gap: 8rem;\n    column-gap: 8rem;\n  }\n  .md\\:col-gap-36 {\n    grid-column-gap: 9rem;\n    -moz-column-gap: 9rem;\n    column-gap: 9rem;\n  }\n  .md\\:col-gap-40 {\n    grid-column-gap: 10rem;\n    -moz-column-gap: 10rem;\n    column-gap: 10rem;\n  }\n  .md\\:col-gap-44 {\n    grid-column-gap: 11rem;\n    -moz-column-gap: 11rem;\n    column-gap: 11rem;\n  }\n  .md\\:col-gap-48 {\n    grid-column-gap: 12rem;\n    -moz-column-gap: 12rem;\n    column-gap: 12rem;\n  }\n  .md\\:col-gap-52 {\n    grid-column-gap: 13rem;\n    -moz-column-gap: 13rem;\n    column-gap: 13rem;\n  }\n  .md\\:col-gap-56 {\n    grid-column-gap: 14rem;\n    -moz-column-gap: 14rem;\n    column-gap: 14rem;\n  }\n  .md\\:col-gap-60 {\n    grid-column-gap: 15rem;\n    -moz-column-gap: 15rem;\n    column-gap: 15rem;\n  }\n  .md\\:col-gap-64 {\n    grid-column-gap: 16rem;\n    -moz-column-gap: 16rem;\n    column-gap: 16rem;\n  }\n  .md\\:col-gap-72 {\n    grid-column-gap: 18rem;\n    -moz-column-gap: 18rem;\n    column-gap: 18rem;\n  }\n  .md\\:col-gap-80 {\n    grid-column-gap: 20rem;\n    -moz-column-gap: 20rem;\n    column-gap: 20rem;\n  }\n  .md\\:col-gap-96 {\n    grid-column-gap: 24rem;\n    -moz-column-gap: 24rem;\n    column-gap: 24rem;\n  }\n  .md\\:col-gap-px {\n    grid-column-gap: 1px;\n    -moz-column-gap: 1px;\n    column-gap: 1px;\n  }\n  .md\\:col-gap-0\\.5 {\n    grid-column-gap: 0.125rem;\n    -moz-column-gap: 0.125rem;\n    column-gap: 0.125rem;\n  }\n  .md\\:col-gap-1\\.5 {\n    grid-column-gap: 0.375rem;\n    -moz-column-gap: 0.375rem;\n    column-gap: 0.375rem;\n  }\n  .md\\:col-gap-2\\.5 {\n    grid-column-gap: 0.625rem;\n    -moz-column-gap: 0.625rem;\n    column-gap: 0.625rem;\n  }\n  .md\\:col-gap-3\\.5 {\n    grid-column-gap: 0.875rem;\n    -moz-column-gap: 0.875rem;\n    column-gap: 0.875rem;\n  }\n  .md\\:col-gap-1\\/2 {\n    grid-column-gap: 50%;\n    -moz-column-gap: 50%;\n    column-gap: 50%;\n  }\n  .md\\:col-gap-1\\/3 {\n    grid-column-gap: 33.333333%;\n    -moz-column-gap: 33.333333%;\n    column-gap: 33.333333%;\n  }\n  .md\\:col-gap-2\\/3 {\n    grid-column-gap: 66.666667%;\n    -moz-column-gap: 66.666667%;\n    column-gap: 66.666667%;\n  }\n  .md\\:col-gap-1\\/4 {\n    grid-column-gap: 25%;\n    -moz-column-gap: 25%;\n    column-gap: 25%;\n  }\n  .md\\:col-gap-2\\/4 {\n    grid-column-gap: 50%;\n    -moz-column-gap: 50%;\n    column-gap: 50%;\n  }\n  .md\\:col-gap-3\\/4 {\n    grid-column-gap: 75%;\n    -moz-column-gap: 75%;\n    column-gap: 75%;\n  }\n  .md\\:col-gap-1\\/5 {\n    grid-column-gap: 20%;\n    -moz-column-gap: 20%;\n    column-gap: 20%;\n  }\n  .md\\:col-gap-2\\/5 {\n    grid-column-gap: 40%;\n    -moz-column-gap: 40%;\n    column-gap: 40%;\n  }\n  .md\\:col-gap-3\\/5 {\n    grid-column-gap: 60%;\n    -moz-column-gap: 60%;\n    column-gap: 60%;\n  }\n  .md\\:col-gap-4\\/5 {\n    grid-column-gap: 80%;\n    -moz-column-gap: 80%;\n    column-gap: 80%;\n  }\n  .md\\:col-gap-1\\/6 {\n    grid-column-gap: 16.666667%;\n    -moz-column-gap: 16.666667%;\n    column-gap: 16.666667%;\n  }\n  .md\\:col-gap-2\\/6 {\n    grid-column-gap: 33.333333%;\n    -moz-column-gap: 33.333333%;\n    column-gap: 33.333333%;\n  }\n  .md\\:col-gap-3\\/6 {\n    grid-column-gap: 50%;\n    -moz-column-gap: 50%;\n    column-gap: 50%;\n  }\n  .md\\:col-gap-4\\/6 {\n    grid-column-gap: 66.666667%;\n    -moz-column-gap: 66.666667%;\n    column-gap: 66.666667%;\n  }\n  .md\\:col-gap-5\\/6 {\n    grid-column-gap: 83.333333%;\n    -moz-column-gap: 83.333333%;\n    column-gap: 83.333333%;\n  }\n  .md\\:col-gap-1\\/12 {\n    grid-column-gap: 8.333333%;\n    -moz-column-gap: 8.333333%;\n    column-gap: 8.333333%;\n  }\n  .md\\:col-gap-2\\/12 {\n    grid-column-gap: 16.666667%;\n    -moz-column-gap: 16.666667%;\n    column-gap: 16.666667%;\n  }\n  .md\\:col-gap-3\\/12 {\n    grid-column-gap: 25%;\n    -moz-column-gap: 25%;\n    column-gap: 25%;\n  }\n  .md\\:col-gap-4\\/12 {\n    grid-column-gap: 33.333333%;\n    -moz-column-gap: 33.333333%;\n    column-gap: 33.333333%;\n  }\n  .md\\:col-gap-5\\/12 {\n    grid-column-gap: 41.666667%;\n    -moz-column-gap: 41.666667%;\n    column-gap: 41.666667%;\n  }\n  .md\\:col-gap-6\\/12 {\n    grid-column-gap: 50%;\n    -moz-column-gap: 50%;\n    column-gap: 50%;\n  }\n  .md\\:col-gap-7\\/12 {\n    grid-column-gap: 58.333333%;\n    -moz-column-gap: 58.333333%;\n    column-gap: 58.333333%;\n  }\n  .md\\:col-gap-8\\/12 {\n    grid-column-gap: 66.666667%;\n    -moz-column-gap: 66.666667%;\n    column-gap: 66.666667%;\n  }\n  .md\\:col-gap-9\\/12 {\n    grid-column-gap: 75%;\n    -moz-column-gap: 75%;\n    column-gap: 75%;\n  }\n  .md\\:col-gap-10\\/12 {\n    grid-column-gap: 83.333333%;\n    -moz-column-gap: 83.333333%;\n    column-gap: 83.333333%;\n  }\n  .md\\:col-gap-11\\/12 {\n    grid-column-gap: 91.666667%;\n    -moz-column-gap: 91.666667%;\n    column-gap: 91.666667%;\n  }\n  .md\\:col-gap-full {\n    grid-column-gap: 100%;\n    -moz-column-gap: 100%;\n    column-gap: 100%;\n  }\n  .md\\:gap-x-0 {\n    grid-column-gap: 0;\n    -moz-column-gap: 0;\n    column-gap: 0;\n  }\n  .md\\:gap-x-1 {\n    grid-column-gap: 0.25rem;\n    -moz-column-gap: 0.25rem;\n    column-gap: 0.25rem;\n  }\n  .md\\:gap-x-2 {\n    grid-column-gap: 0.5rem;\n    -moz-column-gap: 0.5rem;\n    column-gap: 0.5rem;\n  }\n  .md\\:gap-x-3 {\n    grid-column-gap: 0.75rem;\n    -moz-column-gap: 0.75rem;\n    column-gap: 0.75rem;\n  }\n  .md\\:gap-x-4 {\n    grid-column-gap: 1rem;\n    -moz-column-gap: 1rem;\n    column-gap: 1rem;\n  }\n  .md\\:gap-x-5 {\n    grid-column-gap: 1.25rem;\n    -moz-column-gap: 1.25rem;\n    column-gap: 1.25rem;\n  }\n  .md\\:gap-x-6 {\n    grid-column-gap: 1.5rem;\n    -moz-column-gap: 1.5rem;\n    column-gap: 1.5rem;\n  }\n  .md\\:gap-x-7 {\n    grid-column-gap: 1.75rem;\n    -moz-column-gap: 1.75rem;\n    column-gap: 1.75rem;\n  }\n  .md\\:gap-x-8 {\n    grid-column-gap: 2rem;\n    -moz-column-gap: 2rem;\n    column-gap: 2rem;\n  }\n  .md\\:gap-x-9 {\n    grid-column-gap: 2.25rem;\n    -moz-column-gap: 2.25rem;\n    column-gap: 2.25rem;\n  }\n  .md\\:gap-x-10 {\n    grid-column-gap: 2.5rem;\n    -moz-column-gap: 2.5rem;\n    column-gap: 2.5rem;\n  }\n  .md\\:gap-x-11 {\n    grid-column-gap: 2.75rem;\n    -moz-column-gap: 2.75rem;\n    column-gap: 2.75rem;\n  }\n  .md\\:gap-x-12 {\n    grid-column-gap: 3rem;\n    -moz-column-gap: 3rem;\n    column-gap: 3rem;\n  }\n  .md\\:gap-x-13 {\n    grid-column-gap: 3.25rem;\n    -moz-column-gap: 3.25rem;\n    column-gap: 3.25rem;\n  }\n  .md\\:gap-x-14 {\n    grid-column-gap: 3.5rem;\n    -moz-column-gap: 3.5rem;\n    column-gap: 3.5rem;\n  }\n  .md\\:gap-x-15 {\n    grid-column-gap: 3.75rem;\n    -moz-column-gap: 3.75rem;\n    column-gap: 3.75rem;\n  }\n  .md\\:gap-x-16 {\n    grid-column-gap: 4rem;\n    -moz-column-gap: 4rem;\n    column-gap: 4rem;\n  }\n  .md\\:gap-x-20 {\n    grid-column-gap: 5rem;\n    -moz-column-gap: 5rem;\n    column-gap: 5rem;\n  }\n  .md\\:gap-x-24 {\n    grid-column-gap: 6rem;\n    -moz-column-gap: 6rem;\n    column-gap: 6rem;\n  }\n  .md\\:gap-x-28 {\n    grid-column-gap: 7rem;\n    -moz-column-gap: 7rem;\n    column-gap: 7rem;\n  }\n  .md\\:gap-x-32 {\n    grid-column-gap: 8rem;\n    -moz-column-gap: 8rem;\n    column-gap: 8rem;\n  }\n  .md\\:gap-x-36 {\n    grid-column-gap: 9rem;\n    -moz-column-gap: 9rem;\n    column-gap: 9rem;\n  }\n  .md\\:gap-x-40 {\n    grid-column-gap: 10rem;\n    -moz-column-gap: 10rem;\n    column-gap: 10rem;\n  }\n  .md\\:gap-x-44 {\n    grid-column-gap: 11rem;\n    -moz-column-gap: 11rem;\n    column-gap: 11rem;\n  }\n  .md\\:gap-x-48 {\n    grid-column-gap: 12rem;\n    -moz-column-gap: 12rem;\n    column-gap: 12rem;\n  }\n  .md\\:gap-x-52 {\n    grid-column-gap: 13rem;\n    -moz-column-gap: 13rem;\n    column-gap: 13rem;\n  }\n  .md\\:gap-x-56 {\n    grid-column-gap: 14rem;\n    -moz-column-gap: 14rem;\n    column-gap: 14rem;\n  }\n  .md\\:gap-x-60 {\n    grid-column-gap: 15rem;\n    -moz-column-gap: 15rem;\n    column-gap: 15rem;\n  }\n  .md\\:gap-x-64 {\n    grid-column-gap: 16rem;\n    -moz-column-gap: 16rem;\n    column-gap: 16rem;\n  }\n  .md\\:gap-x-72 {\n    grid-column-gap: 18rem;\n    -moz-column-gap: 18rem;\n    column-gap: 18rem;\n  }\n  .md\\:gap-x-80 {\n    grid-column-gap: 20rem;\n    -moz-column-gap: 20rem;\n    column-gap: 20rem;\n  }\n  .md\\:gap-x-96 {\n    grid-column-gap: 24rem;\n    -moz-column-gap: 24rem;\n    column-gap: 24rem;\n  }\n  .md\\:gap-x-px {\n    grid-column-gap: 1px;\n    -moz-column-gap: 1px;\n    column-gap: 1px;\n  }\n  .md\\:gap-x-0\\.5 {\n    grid-column-gap: 0.125rem;\n    -moz-column-gap: 0.125rem;\n    column-gap: 0.125rem;\n  }\n  .md\\:gap-x-1\\.5 {\n    grid-column-gap: 0.375rem;\n    -moz-column-gap: 0.375rem;\n    column-gap: 0.375rem;\n  }\n  .md\\:gap-x-2\\.5 {\n    grid-column-gap: 0.625rem;\n    -moz-column-gap: 0.625rem;\n    column-gap: 0.625rem;\n  }\n  .md\\:gap-x-3\\.5 {\n    grid-column-gap: 0.875rem;\n    -moz-column-gap: 0.875rem;\n    column-gap: 0.875rem;\n  }\n  .md\\:gap-x-1\\/2 {\n    grid-column-gap: 50%;\n    -moz-column-gap: 50%;\n    column-gap: 50%;\n  }\n  .md\\:gap-x-1\\/3 {\n    grid-column-gap: 33.333333%;\n    -moz-column-gap: 33.333333%;\n    column-gap: 33.333333%;\n  }\n  .md\\:gap-x-2\\/3 {\n    grid-column-gap: 66.666667%;\n    -moz-column-gap: 66.666667%;\n    column-gap: 66.666667%;\n  }\n  .md\\:gap-x-1\\/4 {\n    grid-column-gap: 25%;\n    -moz-column-gap: 25%;\n    column-gap: 25%;\n  }\n  .md\\:gap-x-2\\/4 {\n    grid-column-gap: 50%;\n    -moz-column-gap: 50%;\n    column-gap: 50%;\n  }\n  .md\\:gap-x-3\\/4 {\n    grid-column-gap: 75%;\n    -moz-column-gap: 75%;\n    column-gap: 75%;\n  }\n  .md\\:gap-x-1\\/5 {\n    grid-column-gap: 20%;\n    -moz-column-gap: 20%;\n    column-gap: 20%;\n  }\n  .md\\:gap-x-2\\/5 {\n    grid-column-gap: 40%;\n    -moz-column-gap: 40%;\n    column-gap: 40%;\n  }\n  .md\\:gap-x-3\\/5 {\n    grid-column-gap: 60%;\n    -moz-column-gap: 60%;\n    column-gap: 60%;\n  }\n  .md\\:gap-x-4\\/5 {\n    grid-column-gap: 80%;\n    -moz-column-gap: 80%;\n    column-gap: 80%;\n  }\n  .md\\:gap-x-1\\/6 {\n    grid-column-gap: 16.666667%;\n    -moz-column-gap: 16.666667%;\n    column-gap: 16.666667%;\n  }\n  .md\\:gap-x-2\\/6 {\n    grid-column-gap: 33.333333%;\n    -moz-column-gap: 33.333333%;\n    column-gap: 33.333333%;\n  }\n  .md\\:gap-x-3\\/6 {\n    grid-column-gap: 50%;\n    -moz-column-gap: 50%;\n    column-gap: 50%;\n  }\n  .md\\:gap-x-4\\/6 {\n    grid-column-gap: 66.666667%;\n    -moz-column-gap: 66.666667%;\n    column-gap: 66.666667%;\n  }\n  .md\\:gap-x-5\\/6 {\n    grid-column-gap: 83.333333%;\n    -moz-column-gap: 83.333333%;\n    column-gap: 83.333333%;\n  }\n  .md\\:gap-x-1\\/12 {\n    grid-column-gap: 8.333333%;\n    -moz-column-gap: 8.333333%;\n    column-gap: 8.333333%;\n  }\n  .md\\:gap-x-2\\/12 {\n    grid-column-gap: 16.666667%;\n    -moz-column-gap: 16.666667%;\n    column-gap: 16.666667%;\n  }\n  .md\\:gap-x-3\\/12 {\n    grid-column-gap: 25%;\n    -moz-column-gap: 25%;\n    column-gap: 25%;\n  }\n  .md\\:gap-x-4\\/12 {\n    grid-column-gap: 33.333333%;\n    -moz-column-gap: 33.333333%;\n    column-gap: 33.333333%;\n  }\n  .md\\:gap-x-5\\/12 {\n    grid-column-gap: 41.666667%;\n    -moz-column-gap: 41.666667%;\n    column-gap: 41.666667%;\n  }\n  .md\\:gap-x-6\\/12 {\n    grid-column-gap: 50%;\n    -moz-column-gap: 50%;\n    column-gap: 50%;\n  }\n  .md\\:gap-x-7\\/12 {\n    grid-column-gap: 58.333333%;\n    -moz-column-gap: 58.333333%;\n    column-gap: 58.333333%;\n  }\n  .md\\:gap-x-8\\/12 {\n    grid-column-gap: 66.666667%;\n    -moz-column-gap: 66.666667%;\n    column-gap: 66.666667%;\n  }\n  .md\\:gap-x-9\\/12 {\n    grid-column-gap: 75%;\n    -moz-column-gap: 75%;\n    column-gap: 75%;\n  }\n  .md\\:gap-x-10\\/12 {\n    grid-column-gap: 83.333333%;\n    -moz-column-gap: 83.333333%;\n    column-gap: 83.333333%;\n  }\n  .md\\:gap-x-11\\/12 {\n    grid-column-gap: 91.666667%;\n    -moz-column-gap: 91.666667%;\n    column-gap: 91.666667%;\n  }\n  .md\\:gap-x-full {\n    grid-column-gap: 100%;\n    -moz-column-gap: 100%;\n    column-gap: 100%;\n  }\n  .md\\:row-gap-0 {\n    grid-row-gap: 0;\n    row-gap: 0;\n  }\n  .md\\:row-gap-1 {\n    grid-row-gap: 0.25rem;\n    row-gap: 0.25rem;\n  }\n  .md\\:row-gap-2 {\n    grid-row-gap: 0.5rem;\n    row-gap: 0.5rem;\n  }\n  .md\\:row-gap-3 {\n    grid-row-gap: 0.75rem;\n    row-gap: 0.75rem;\n  }\n  .md\\:row-gap-4 {\n    grid-row-gap: 1rem;\n    row-gap: 1rem;\n  }\n  .md\\:row-gap-5 {\n    grid-row-gap: 1.25rem;\n    row-gap: 1.25rem;\n  }\n  .md\\:row-gap-6 {\n    grid-row-gap: 1.5rem;\n    row-gap: 1.5rem;\n  }\n  .md\\:row-gap-7 {\n    grid-row-gap: 1.75rem;\n    row-gap: 1.75rem;\n  }\n  .md\\:row-gap-8 {\n    grid-row-gap: 2rem;\n    row-gap: 2rem;\n  }\n  .md\\:row-gap-9 {\n    grid-row-gap: 2.25rem;\n    row-gap: 2.25rem;\n  }\n  .md\\:row-gap-10 {\n    grid-row-gap: 2.5rem;\n    row-gap: 2.5rem;\n  }\n  .md\\:row-gap-11 {\n    grid-row-gap: 2.75rem;\n    row-gap: 2.75rem;\n  }\n  .md\\:row-gap-12 {\n    grid-row-gap: 3rem;\n    row-gap: 3rem;\n  }\n  .md\\:row-gap-13 {\n    grid-row-gap: 3.25rem;\n    row-gap: 3.25rem;\n  }\n  .md\\:row-gap-14 {\n    grid-row-gap: 3.5rem;\n    row-gap: 3.5rem;\n  }\n  .md\\:row-gap-15 {\n    grid-row-gap: 3.75rem;\n    row-gap: 3.75rem;\n  }\n  .md\\:row-gap-16 {\n    grid-row-gap: 4rem;\n    row-gap: 4rem;\n  }\n  .md\\:row-gap-20 {\n    grid-row-gap: 5rem;\n    row-gap: 5rem;\n  }\n  .md\\:row-gap-24 {\n    grid-row-gap: 6rem;\n    row-gap: 6rem;\n  }\n  .md\\:row-gap-28 {\n    grid-row-gap: 7rem;\n    row-gap: 7rem;\n  }\n  .md\\:row-gap-32 {\n    grid-row-gap: 8rem;\n    row-gap: 8rem;\n  }\n  .md\\:row-gap-36 {\n    grid-row-gap: 9rem;\n    row-gap: 9rem;\n  }\n  .md\\:row-gap-40 {\n    grid-row-gap: 10rem;\n    row-gap: 10rem;\n  }\n  .md\\:row-gap-44 {\n    grid-row-gap: 11rem;\n    row-gap: 11rem;\n  }\n  .md\\:row-gap-48 {\n    grid-row-gap: 12rem;\n    row-gap: 12rem;\n  }\n  .md\\:row-gap-52 {\n    grid-row-gap: 13rem;\n    row-gap: 13rem;\n  }\n  .md\\:row-gap-56 {\n    grid-row-gap: 14rem;\n    row-gap: 14rem;\n  }\n  .md\\:row-gap-60 {\n    grid-row-gap: 15rem;\n    row-gap: 15rem;\n  }\n  .md\\:row-gap-64 {\n    grid-row-gap: 16rem;\n    row-gap: 16rem;\n  }\n  .md\\:row-gap-72 {\n    grid-row-gap: 18rem;\n    row-gap: 18rem;\n  }\n  .md\\:row-gap-80 {\n    grid-row-gap: 20rem;\n    row-gap: 20rem;\n  }\n  .md\\:row-gap-96 {\n    grid-row-gap: 24rem;\n    row-gap: 24rem;\n  }\n  .md\\:row-gap-px {\n    grid-row-gap: 1px;\n    row-gap: 1px;\n  }\n  .md\\:row-gap-0\\.5 {\n    grid-row-gap: 0.125rem;\n    row-gap: 0.125rem;\n  }\n  .md\\:row-gap-1\\.5 {\n    grid-row-gap: 0.375rem;\n    row-gap: 0.375rem;\n  }\n  .md\\:row-gap-2\\.5 {\n    grid-row-gap: 0.625rem;\n    row-gap: 0.625rem;\n  }\n  .md\\:row-gap-3\\.5 {\n    grid-row-gap: 0.875rem;\n    row-gap: 0.875rem;\n  }\n  .md\\:row-gap-1\\/2 {\n    grid-row-gap: 50%;\n    row-gap: 50%;\n  }\n  .md\\:row-gap-1\\/3 {\n    grid-row-gap: 33.333333%;\n    row-gap: 33.333333%;\n  }\n  .md\\:row-gap-2\\/3 {\n    grid-row-gap: 66.666667%;\n    row-gap: 66.666667%;\n  }\n  .md\\:row-gap-1\\/4 {\n    grid-row-gap: 25%;\n    row-gap: 25%;\n  }\n  .md\\:row-gap-2\\/4 {\n    grid-row-gap: 50%;\n    row-gap: 50%;\n  }\n  .md\\:row-gap-3\\/4 {\n    grid-row-gap: 75%;\n    row-gap: 75%;\n  }\n  .md\\:row-gap-1\\/5 {\n    grid-row-gap: 20%;\n    row-gap: 20%;\n  }\n  .md\\:row-gap-2\\/5 {\n    grid-row-gap: 40%;\n    row-gap: 40%;\n  }\n  .md\\:row-gap-3\\/5 {\n    grid-row-gap: 60%;\n    row-gap: 60%;\n  }\n  .md\\:row-gap-4\\/5 {\n    grid-row-gap: 80%;\n    row-gap: 80%;\n  }\n  .md\\:row-gap-1\\/6 {\n    grid-row-gap: 16.666667%;\n    row-gap: 16.666667%;\n  }\n  .md\\:row-gap-2\\/6 {\n    grid-row-gap: 33.333333%;\n    row-gap: 33.333333%;\n  }\n  .md\\:row-gap-3\\/6 {\n    grid-row-gap: 50%;\n    row-gap: 50%;\n  }\n  .md\\:row-gap-4\\/6 {\n    grid-row-gap: 66.666667%;\n    row-gap: 66.666667%;\n  }\n  .md\\:row-gap-5\\/6 {\n    grid-row-gap: 83.333333%;\n    row-gap: 83.333333%;\n  }\n  .md\\:row-gap-1\\/12 {\n    grid-row-gap: 8.333333%;\n    row-gap: 8.333333%;\n  }\n  .md\\:row-gap-2\\/12 {\n    grid-row-gap: 16.666667%;\n    row-gap: 16.666667%;\n  }\n  .md\\:row-gap-3\\/12 {\n    grid-row-gap: 25%;\n    row-gap: 25%;\n  }\n  .md\\:row-gap-4\\/12 {\n    grid-row-gap: 33.333333%;\n    row-gap: 33.333333%;\n  }\n  .md\\:row-gap-5\\/12 {\n    grid-row-gap: 41.666667%;\n    row-gap: 41.666667%;\n  }\n  .md\\:row-gap-6\\/12 {\n    grid-row-gap: 50%;\n    row-gap: 50%;\n  }\n  .md\\:row-gap-7\\/12 {\n    grid-row-gap: 58.333333%;\n    row-gap: 58.333333%;\n  }\n  .md\\:row-gap-8\\/12 {\n    grid-row-gap: 66.666667%;\n    row-gap: 66.666667%;\n  }\n  .md\\:row-gap-9\\/12 {\n    grid-row-gap: 75%;\n    row-gap: 75%;\n  }\n  .md\\:row-gap-10\\/12 {\n    grid-row-gap: 83.333333%;\n    row-gap: 83.333333%;\n  }\n  .md\\:row-gap-11\\/12 {\n    grid-row-gap: 91.666667%;\n    row-gap: 91.666667%;\n  }\n  .md\\:row-gap-full {\n    grid-row-gap: 100%;\n    row-gap: 100%;\n  }\n  .md\\:gap-y-0 {\n    grid-row-gap: 0;\n    row-gap: 0;\n  }\n  .md\\:gap-y-1 {\n    grid-row-gap: 0.25rem;\n    row-gap: 0.25rem;\n  }\n  .md\\:gap-y-2 {\n    grid-row-gap: 0.5rem;\n    row-gap: 0.5rem;\n  }\n  .md\\:gap-y-3 {\n    grid-row-gap: 0.75rem;\n    row-gap: 0.75rem;\n  }\n  .md\\:gap-y-4 {\n    grid-row-gap: 1rem;\n    row-gap: 1rem;\n  }\n  .md\\:gap-y-5 {\n    grid-row-gap: 1.25rem;\n    row-gap: 1.25rem;\n  }\n  .md\\:gap-y-6 {\n    grid-row-gap: 1.5rem;\n    row-gap: 1.5rem;\n  }\n  .md\\:gap-y-7 {\n    grid-row-gap: 1.75rem;\n    row-gap: 1.75rem;\n  }\n  .md\\:gap-y-8 {\n    grid-row-gap: 2rem;\n    row-gap: 2rem;\n  }\n  .md\\:gap-y-9 {\n    grid-row-gap: 2.25rem;\n    row-gap: 2.25rem;\n  }\n  .md\\:gap-y-10 {\n    grid-row-gap: 2.5rem;\n    row-gap: 2.5rem;\n  }\n  .md\\:gap-y-11 {\n    grid-row-gap: 2.75rem;\n    row-gap: 2.75rem;\n  }\n  .md\\:gap-y-12 {\n    grid-row-gap: 3rem;\n    row-gap: 3rem;\n  }\n  .md\\:gap-y-13 {\n    grid-row-gap: 3.25rem;\n    row-gap: 3.25rem;\n  }\n  .md\\:gap-y-14 {\n    grid-row-gap: 3.5rem;\n    row-gap: 3.5rem;\n  }\n  .md\\:gap-y-15 {\n    grid-row-gap: 3.75rem;\n    row-gap: 3.75rem;\n  }\n  .md\\:gap-y-16 {\n    grid-row-gap: 4rem;\n    row-gap: 4rem;\n  }\n  .md\\:gap-y-20 {\n    grid-row-gap: 5rem;\n    row-gap: 5rem;\n  }\n  .md\\:gap-y-24 {\n    grid-row-gap: 6rem;\n    row-gap: 6rem;\n  }\n  .md\\:gap-y-28 {\n    grid-row-gap: 7rem;\n    row-gap: 7rem;\n  }\n  .md\\:gap-y-32 {\n    grid-row-gap: 8rem;\n    row-gap: 8rem;\n  }\n  .md\\:gap-y-36 {\n    grid-row-gap: 9rem;\n    row-gap: 9rem;\n  }\n  .md\\:gap-y-40 {\n    grid-row-gap: 10rem;\n    row-gap: 10rem;\n  }\n  .md\\:gap-y-44 {\n    grid-row-gap: 11rem;\n    row-gap: 11rem;\n  }\n  .md\\:gap-y-48 {\n    grid-row-gap: 12rem;\n    row-gap: 12rem;\n  }\n  .md\\:gap-y-52 {\n    grid-row-gap: 13rem;\n    row-gap: 13rem;\n  }\n  .md\\:gap-y-56 {\n    grid-row-gap: 14rem;\n    row-gap: 14rem;\n  }\n  .md\\:gap-y-60 {\n    grid-row-gap: 15rem;\n    row-gap: 15rem;\n  }\n  .md\\:gap-y-64 {\n    grid-row-gap: 16rem;\n    row-gap: 16rem;\n  }\n  .md\\:gap-y-72 {\n    grid-row-gap: 18rem;\n    row-gap: 18rem;\n  }\n  .md\\:gap-y-80 {\n    grid-row-gap: 20rem;\n    row-gap: 20rem;\n  }\n  .md\\:gap-y-96 {\n    grid-row-gap: 24rem;\n    row-gap: 24rem;\n  }\n  .md\\:gap-y-px {\n    grid-row-gap: 1px;\n    row-gap: 1px;\n  }\n  .md\\:gap-y-0\\.5 {\n    grid-row-gap: 0.125rem;\n    row-gap: 0.125rem;\n  }\n  .md\\:gap-y-1\\.5 {\n    grid-row-gap: 0.375rem;\n    row-gap: 0.375rem;\n  }\n  .md\\:gap-y-2\\.5 {\n    grid-row-gap: 0.625rem;\n    row-gap: 0.625rem;\n  }\n  .md\\:gap-y-3\\.5 {\n    grid-row-gap: 0.875rem;\n    row-gap: 0.875rem;\n  }\n  .md\\:gap-y-1\\/2 {\n    grid-row-gap: 50%;\n    row-gap: 50%;\n  }\n  .md\\:gap-y-1\\/3 {\n    grid-row-gap: 33.333333%;\n    row-gap: 33.333333%;\n  }\n  .md\\:gap-y-2\\/3 {\n    grid-row-gap: 66.666667%;\n    row-gap: 66.666667%;\n  }\n  .md\\:gap-y-1\\/4 {\n    grid-row-gap: 25%;\n    row-gap: 25%;\n  }\n  .md\\:gap-y-2\\/4 {\n    grid-row-gap: 50%;\n    row-gap: 50%;\n  }\n  .md\\:gap-y-3\\/4 {\n    grid-row-gap: 75%;\n    row-gap: 75%;\n  }\n  .md\\:gap-y-1\\/5 {\n    grid-row-gap: 20%;\n    row-gap: 20%;\n  }\n  .md\\:gap-y-2\\/5 {\n    grid-row-gap: 40%;\n    row-gap: 40%;\n  }\n  .md\\:gap-y-3\\/5 {\n    grid-row-gap: 60%;\n    row-gap: 60%;\n  }\n  .md\\:gap-y-4\\/5 {\n    grid-row-gap: 80%;\n    row-gap: 80%;\n  }\n  .md\\:gap-y-1\\/6 {\n    grid-row-gap: 16.666667%;\n    row-gap: 16.666667%;\n  }\n  .md\\:gap-y-2\\/6 {\n    grid-row-gap: 33.333333%;\n    row-gap: 33.333333%;\n  }\n  .md\\:gap-y-3\\/6 {\n    grid-row-gap: 50%;\n    row-gap: 50%;\n  }\n  .md\\:gap-y-4\\/6 {\n    grid-row-gap: 66.666667%;\n    row-gap: 66.666667%;\n  }\n  .md\\:gap-y-5\\/6 {\n    grid-row-gap: 83.333333%;\n    row-gap: 83.333333%;\n  }\n  .md\\:gap-y-1\\/12 {\n    grid-row-gap: 8.333333%;\n    row-gap: 8.333333%;\n  }\n  .md\\:gap-y-2\\/12 {\n    grid-row-gap: 16.666667%;\n    row-gap: 16.666667%;\n  }\n  .md\\:gap-y-3\\/12 {\n    grid-row-gap: 25%;\n    row-gap: 25%;\n  }\n  .md\\:gap-y-4\\/12 {\n    grid-row-gap: 33.333333%;\n    row-gap: 33.333333%;\n  }\n  .md\\:gap-y-5\\/12 {\n    grid-row-gap: 41.666667%;\n    row-gap: 41.666667%;\n  }\n  .md\\:gap-y-6\\/12 {\n    grid-row-gap: 50%;\n    row-gap: 50%;\n  }\n  .md\\:gap-y-7\\/12 {\n    grid-row-gap: 58.333333%;\n    row-gap: 58.333333%;\n  }\n  .md\\:gap-y-8\\/12 {\n    grid-row-gap: 66.666667%;\n    row-gap: 66.666667%;\n  }\n  .md\\:gap-y-9\\/12 {\n    grid-row-gap: 75%;\n    row-gap: 75%;\n  }\n  .md\\:gap-y-10\\/12 {\n    grid-row-gap: 83.333333%;\n    row-gap: 83.333333%;\n  }\n  .md\\:gap-y-11\\/12 {\n    grid-row-gap: 91.666667%;\n    row-gap: 91.666667%;\n  }\n  .md\\:gap-y-full {\n    grid-row-gap: 100%;\n    row-gap: 100%;\n  }\n  .md\\:grid-flow-row {\n    grid-auto-flow: row;\n  }\n  .md\\:grid-flow-col {\n    grid-auto-flow: column;\n  }\n  .md\\:grid-flow-row-dense {\n    grid-auto-flow: row dense;\n  }\n  .md\\:grid-flow-col-dense {\n    grid-auto-flow: column dense;\n  }\n  .md\\:grid-cols-1 {\n    grid-template-columns: repeat(1, minmax(0, 1fr));\n  }\n  .md\\:grid-cols-2 {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n  .md\\:grid-cols-3 {\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n  }\n  .md\\:grid-cols-4 {\n    grid-template-columns: repeat(4, minmax(0, 1fr));\n  }\n  .md\\:grid-cols-5 {\n    grid-template-columns: repeat(5, minmax(0, 1fr));\n  }\n  .md\\:grid-cols-6 {\n    grid-template-columns: repeat(6, minmax(0, 1fr));\n  }\n  .md\\:grid-cols-7 {\n    grid-template-columns: repeat(7, minmax(0, 1fr));\n  }\n  .md\\:grid-cols-8 {\n    grid-template-columns: repeat(8, minmax(0, 1fr));\n  }\n  .md\\:grid-cols-9 {\n    grid-template-columns: repeat(9, minmax(0, 1fr));\n  }\n  .md\\:grid-cols-10 {\n    grid-template-columns: repeat(10, minmax(0, 1fr));\n  }\n  .md\\:grid-cols-11 {\n    grid-template-columns: repeat(11, minmax(0, 1fr));\n  }\n  .md\\:grid-cols-12 {\n    grid-template-columns: repeat(12, minmax(0, 1fr));\n  }\n  .md\\:grid-cols-none {\n    grid-template-columns: none;\n  }\n  .md\\:auto-cols-auto {\n    grid-auto-columns: auto;\n  }\n  .md\\:auto-cols-min {\n    grid-auto-columns: min-content;\n  }\n  .md\\:auto-cols-max {\n    grid-auto-columns: max-content;\n  }\n  .md\\:auto-cols-fr {\n    grid-auto-columns: minmax(0, 1fr);\n  }\n  .md\\:col-auto {\n    grid-column: auto;\n  }\n  .md\\:col-span-1 {\n    grid-column: span 1 / span 1;\n  }\n  .md\\:col-span-2 {\n    grid-column: span 2 / span 2;\n  }\n  .md\\:col-span-3 {\n    grid-column: span 3 / span 3;\n  }\n  .md\\:col-span-4 {\n    grid-column: span 4 / span 4;\n  }\n  .md\\:col-span-5 {\n    grid-column: span 5 / span 5;\n  }\n  .md\\:col-span-6 {\n    grid-column: span 6 / span 6;\n  }\n  .md\\:col-span-7 {\n    grid-column: span 7 / span 7;\n  }\n  .md\\:col-span-8 {\n    grid-column: span 8 / span 8;\n  }\n  .md\\:col-span-9 {\n    grid-column: span 9 / span 9;\n  }\n  .md\\:col-span-10 {\n    grid-column: span 10 / span 10;\n  }\n  .md\\:col-span-11 {\n    grid-column: span 11 / span 11;\n  }\n  .md\\:col-span-12 {\n    grid-column: span 12 / span 12;\n  }\n  .md\\:col-span-full {\n    grid-column: 1 / -1;\n  }\n  .md\\:col-start-1 {\n    grid-column-start: 1;\n  }\n  .md\\:col-start-2 {\n    grid-column-start: 2;\n  }\n  .md\\:col-start-3 {\n    grid-column-start: 3;\n  }\n  .md\\:col-start-4 {\n    grid-column-start: 4;\n  }\n  .md\\:col-start-5 {\n    grid-column-start: 5;\n  }\n  .md\\:col-start-6 {\n    grid-column-start: 6;\n  }\n  .md\\:col-start-7 {\n    grid-column-start: 7;\n  }\n  .md\\:col-start-8 {\n    grid-column-start: 8;\n  }\n  .md\\:col-start-9 {\n    grid-column-start: 9;\n  }\n  .md\\:col-start-10 {\n    grid-column-start: 10;\n  }\n  .md\\:col-start-11 {\n    grid-column-start: 11;\n  }\n  .md\\:col-start-12 {\n    grid-column-start: 12;\n  }\n  .md\\:col-start-13 {\n    grid-column-start: 13;\n  }\n  .md\\:col-start-auto {\n    grid-column-start: auto;\n  }\n  .md\\:col-end-1 {\n    grid-column-end: 1;\n  }\n  .md\\:col-end-2 {\n    grid-column-end: 2;\n  }\n  .md\\:col-end-3 {\n    grid-column-end: 3;\n  }\n  .md\\:col-end-4 {\n    grid-column-end: 4;\n  }\n  .md\\:col-end-5 {\n    grid-column-end: 5;\n  }\n  .md\\:col-end-6 {\n    grid-column-end: 6;\n  }\n  .md\\:col-end-7 {\n    grid-column-end: 7;\n  }\n  .md\\:col-end-8 {\n    grid-column-end: 8;\n  }\n  .md\\:col-end-9 {\n    grid-column-end: 9;\n  }\n  .md\\:col-end-10 {\n    grid-column-end: 10;\n  }\n  .md\\:col-end-11 {\n    grid-column-end: 11;\n  }\n  .md\\:col-end-12 {\n    grid-column-end: 12;\n  }\n  .md\\:col-end-13 {\n    grid-column-end: 13;\n  }\n  .md\\:col-end-auto {\n    grid-column-end: auto;\n  }\n  .md\\:grid-rows-1 {\n    grid-template-rows: repeat(1, minmax(0, 1fr));\n  }\n  .md\\:grid-rows-2 {\n    grid-template-rows: repeat(2, minmax(0, 1fr));\n  }\n  .md\\:grid-rows-3 {\n    grid-template-rows: repeat(3, minmax(0, 1fr));\n  }\n  .md\\:grid-rows-4 {\n    grid-template-rows: repeat(4, minmax(0, 1fr));\n  }\n  .md\\:grid-rows-5 {\n    grid-template-rows: repeat(5, minmax(0, 1fr));\n  }\n  .md\\:grid-rows-6 {\n    grid-template-rows: repeat(6, minmax(0, 1fr));\n  }\n  .md\\:grid-rows-none {\n    grid-template-rows: none;\n  }\n  .md\\:auto-rows-auto {\n    grid-auto-rows: auto;\n  }\n  .md\\:auto-rows-min {\n    grid-auto-rows: min-content;\n  }\n  .md\\:auto-rows-max {\n    grid-auto-rows: max-content;\n  }\n  .md\\:auto-rows-fr {\n    grid-auto-rows: minmax(0, 1fr);\n  }\n  .md\\:row-auto {\n    grid-row: auto;\n  }\n  .md\\:row-span-1 {\n    grid-row: span 1 / span 1;\n  }\n  .md\\:row-span-2 {\n    grid-row: span 2 / span 2;\n  }\n  .md\\:row-span-3 {\n    grid-row: span 3 / span 3;\n  }\n  .md\\:row-span-4 {\n    grid-row: span 4 / span 4;\n  }\n  .md\\:row-span-5 {\n    grid-row: span 5 / span 5;\n  }\n  .md\\:row-span-6 {\n    grid-row: span 6 / span 6;\n  }\n  .md\\:row-span-full {\n    grid-row: 1 / -1;\n  }\n  .md\\:row-start-1 {\n    grid-row-start: 1;\n  }\n  .md\\:row-start-2 {\n    grid-row-start: 2;\n  }\n  .md\\:row-start-3 {\n    grid-row-start: 3;\n  }\n  .md\\:row-start-4 {\n    grid-row-start: 4;\n  }\n  .md\\:row-start-5 {\n    grid-row-start: 5;\n  }\n  .md\\:row-start-6 {\n    grid-row-start: 6;\n  }\n  .md\\:row-start-7 {\n    grid-row-start: 7;\n  }\n  .md\\:row-start-auto {\n    grid-row-start: auto;\n  }\n  .md\\:row-end-1 {\n    grid-row-end: 1;\n  }\n  .md\\:row-end-2 {\n    grid-row-end: 2;\n  }\n  .md\\:row-end-3 {\n    grid-row-end: 3;\n  }\n  .md\\:row-end-4 {\n    grid-row-end: 4;\n  }\n  .md\\:row-end-5 {\n    grid-row-end: 5;\n  }\n  .md\\:row-end-6 {\n    grid-row-end: 6;\n  }\n  .md\\:row-end-7 {\n    grid-row-end: 7;\n  }\n  .md\\:row-end-auto {\n    grid-row-end: auto;\n  }\n  .md\\:transform {\n    --transform-translate-x: 0;\n    --transform-translate-y: 0;\n    --transform-rotate: 0;\n    --transform-skew-x: 0;\n    --transform-skew-y: 0;\n    --transform-scale-x: 1;\n    --transform-scale-y: 1;\n    transform: translateX(var(--transform-translate-x)) translateY(var(--transform-translate-y)) rotate(var(--transform-rotate)) skewX(var(--transform-skew-x)) skewY(var(--transform-skew-y)) scaleX(var(--transform-scale-x)) scaleY(var(--transform-scale-y));\n  }\n  .md\\:transform-none {\n    transform: none;\n  }\n  .md\\:origin-center {\n    transform-origin: center;\n  }\n  .md\\:origin-top {\n    transform-origin: top;\n  }\n  .md\\:origin-top-right {\n    transform-origin: top right;\n  }\n  .md\\:origin-right {\n    transform-origin: right;\n  }\n  .md\\:origin-bottom-right {\n    transform-origin: bottom right;\n  }\n  .md\\:origin-bottom {\n    transform-origin: bottom;\n  }\n  .md\\:origin-bottom-left {\n    transform-origin: bottom left;\n  }\n  .md\\:origin-left {\n    transform-origin: left;\n  }\n  .md\\:origin-top-left {\n    transform-origin: top left;\n  }\n  .md\\:scale-0 {\n    --transform-scale-x: 0;\n    --transform-scale-y: 0;\n  }\n  .md\\:scale-50 {\n    --transform-scale-x: .5;\n    --transform-scale-y: .5;\n  }\n  .md\\:scale-75 {\n    --transform-scale-x: .75;\n    --transform-scale-y: .75;\n  }\n  .md\\:scale-90 {\n    --transform-scale-x: .9;\n    --transform-scale-y: .9;\n  }\n  .md\\:scale-95 {\n    --transform-scale-x: .95;\n    --transform-scale-y: .95;\n  }\n  .md\\:scale-100 {\n    --transform-scale-x: 1;\n    --transform-scale-y: 1;\n  }\n  .md\\:scale-105 {\n    --transform-scale-x: 1.05;\n    --transform-scale-y: 1.05;\n  }\n  .md\\:scale-110 {\n    --transform-scale-x: 1.1;\n    --transform-scale-y: 1.1;\n  }\n  .md\\:scale-125 {\n    --transform-scale-x: 1.25;\n    --transform-scale-y: 1.25;\n  }\n  .md\\:scale-150 {\n    --transform-scale-x: 1.5;\n    --transform-scale-y: 1.5;\n  }\n  .md\\:scale-x-0 {\n    --transform-scale-x: 0;\n  }\n  .md\\:scale-x-50 {\n    --transform-scale-x: .5;\n  }\n  .md\\:scale-x-75 {\n    --transform-scale-x: .75;\n  }\n  .md\\:scale-x-90 {\n    --transform-scale-x: .9;\n  }\n  .md\\:scale-x-95 {\n    --transform-scale-x: .95;\n  }\n  .md\\:scale-x-100 {\n    --transform-scale-x: 1;\n  }\n  .md\\:scale-x-105 {\n    --transform-scale-x: 1.05;\n  }\n  .md\\:scale-x-110 {\n    --transform-scale-x: 1.1;\n  }\n  .md\\:scale-x-125 {\n    --transform-scale-x: 1.25;\n  }\n  .md\\:scale-x-150 {\n    --transform-scale-x: 1.5;\n  }\n  .md\\:scale-y-0 {\n    --transform-scale-y: 0;\n  }\n  .md\\:scale-y-50 {\n    --transform-scale-y: .5;\n  }\n  .md\\:scale-y-75 {\n    --transform-scale-y: .75;\n  }\n  .md\\:scale-y-90 {\n    --transform-scale-y: .9;\n  }\n  .md\\:scale-y-95 {\n    --transform-scale-y: .95;\n  }\n  .md\\:scale-y-100 {\n    --transform-scale-y: 1;\n  }\n  .md\\:scale-y-105 {\n    --transform-scale-y: 1.05;\n  }\n  .md\\:scale-y-110 {\n    --transform-scale-y: 1.1;\n  }\n  .md\\:scale-y-125 {\n    --transform-scale-y: 1.25;\n  }\n  .md\\:scale-y-150 {\n    --transform-scale-y: 1.5;\n  }\n  .md\\:hover\\:scale-0:hover {\n    --transform-scale-x: 0;\n    --transform-scale-y: 0;\n  }\n  .md\\:hover\\:scale-50:hover {\n    --transform-scale-x: .5;\n    --transform-scale-y: .5;\n  }\n  .md\\:hover\\:scale-75:hover {\n    --transform-scale-x: .75;\n    --transform-scale-y: .75;\n  }\n  .md\\:hover\\:scale-90:hover {\n    --transform-scale-x: .9;\n    --transform-scale-y: .9;\n  }\n  .md\\:hover\\:scale-95:hover {\n    --transform-scale-x: .95;\n    --transform-scale-y: .95;\n  }\n  .md\\:hover\\:scale-100:hover {\n    --transform-scale-x: 1;\n    --transform-scale-y: 1;\n  }\n  .md\\:hover\\:scale-105:hover {\n    --transform-scale-x: 1.05;\n    --transform-scale-y: 1.05;\n  }\n  .md\\:hover\\:scale-110:hover {\n    --transform-scale-x: 1.1;\n    --transform-scale-y: 1.1;\n  }\n  .md\\:hover\\:scale-125:hover {\n    --transform-scale-x: 1.25;\n    --transform-scale-y: 1.25;\n  }\n  .md\\:hover\\:scale-150:hover {\n    --transform-scale-x: 1.5;\n    --transform-scale-y: 1.5;\n  }\n  .md\\:hover\\:scale-x-0:hover {\n    --transform-scale-x: 0;\n  }\n  .md\\:hover\\:scale-x-50:hover {\n    --transform-scale-x: .5;\n  }\n  .md\\:hover\\:scale-x-75:hover {\n    --transform-scale-x: .75;\n  }\n  .md\\:hover\\:scale-x-90:hover {\n    --transform-scale-x: .9;\n  }\n  .md\\:hover\\:scale-x-95:hover {\n    --transform-scale-x: .95;\n  }\n  .md\\:hover\\:scale-x-100:hover {\n    --transform-scale-x: 1;\n  }\n  .md\\:hover\\:scale-x-105:hover {\n    --transform-scale-x: 1.05;\n  }\n  .md\\:hover\\:scale-x-110:hover {\n    --transform-scale-x: 1.1;\n  }\n  .md\\:hover\\:scale-x-125:hover {\n    --transform-scale-x: 1.25;\n  }\n  .md\\:hover\\:scale-x-150:hover {\n    --transform-scale-x: 1.5;\n  }\n  .md\\:hover\\:scale-y-0:hover {\n    --transform-scale-y: 0;\n  }\n  .md\\:hover\\:scale-y-50:hover {\n    --transform-scale-y: .5;\n  }\n  .md\\:hover\\:scale-y-75:hover {\n    --transform-scale-y: .75;\n  }\n  .md\\:hover\\:scale-y-90:hover {\n    --transform-scale-y: .9;\n  }\n  .md\\:hover\\:scale-y-95:hover {\n    --transform-scale-y: .95;\n  }\n  .md\\:hover\\:scale-y-100:hover {\n    --transform-scale-y: 1;\n  }\n  .md\\:hover\\:scale-y-105:hover {\n    --transform-scale-y: 1.05;\n  }\n  .md\\:hover\\:scale-y-110:hover {\n    --transform-scale-y: 1.1;\n  }\n  .md\\:hover\\:scale-y-125:hover {\n    --transform-scale-y: 1.25;\n  }\n  .md\\:hover\\:scale-y-150:hover {\n    --transform-scale-y: 1.5;\n  }\n  .md\\:focus\\:scale-0:focus {\n    --transform-scale-x: 0;\n    --transform-scale-y: 0;\n  }\n  .md\\:focus\\:scale-50:focus {\n    --transform-scale-x: .5;\n    --transform-scale-y: .5;\n  }\n  .md\\:focus\\:scale-75:focus {\n    --transform-scale-x: .75;\n    --transform-scale-y: .75;\n  }\n  .md\\:focus\\:scale-90:focus {\n    --transform-scale-x: .9;\n    --transform-scale-y: .9;\n  }\n  .md\\:focus\\:scale-95:focus {\n    --transform-scale-x: .95;\n    --transform-scale-y: .95;\n  }\n  .md\\:focus\\:scale-100:focus {\n    --transform-scale-x: 1;\n    --transform-scale-y: 1;\n  }\n  .md\\:focus\\:scale-105:focus {\n    --transform-scale-x: 1.05;\n    --transform-scale-y: 1.05;\n  }\n  .md\\:focus\\:scale-110:focus {\n    --transform-scale-x: 1.1;\n    --transform-scale-y: 1.1;\n  }\n  .md\\:focus\\:scale-125:focus {\n    --transform-scale-x: 1.25;\n    --transform-scale-y: 1.25;\n  }\n  .md\\:focus\\:scale-150:focus {\n    --transform-scale-x: 1.5;\n    --transform-scale-y: 1.5;\n  }\n  .md\\:focus\\:scale-x-0:focus {\n    --transform-scale-x: 0;\n  }\n  .md\\:focus\\:scale-x-50:focus {\n    --transform-scale-x: .5;\n  }\n  .md\\:focus\\:scale-x-75:focus {\n    --transform-scale-x: .75;\n  }\n  .md\\:focus\\:scale-x-90:focus {\n    --transform-scale-x: .9;\n  }\n  .md\\:focus\\:scale-x-95:focus {\n    --transform-scale-x: .95;\n  }\n  .md\\:focus\\:scale-x-100:focus {\n    --transform-scale-x: 1;\n  }\n  .md\\:focus\\:scale-x-105:focus {\n    --transform-scale-x: 1.05;\n  }\n  .md\\:focus\\:scale-x-110:focus {\n    --transform-scale-x: 1.1;\n  }\n  .md\\:focus\\:scale-x-125:focus {\n    --transform-scale-x: 1.25;\n  }\n  .md\\:focus\\:scale-x-150:focus {\n    --transform-scale-x: 1.5;\n  }\n  .md\\:focus\\:scale-y-0:focus {\n    --transform-scale-y: 0;\n  }\n  .md\\:focus\\:scale-y-50:focus {\n    --transform-scale-y: .5;\n  }\n  .md\\:focus\\:scale-y-75:focus {\n    --transform-scale-y: .75;\n  }\n  .md\\:focus\\:scale-y-90:focus {\n    --transform-scale-y: .9;\n  }\n  .md\\:focus\\:scale-y-95:focus {\n    --transform-scale-y: .95;\n  }\n  .md\\:focus\\:scale-y-100:focus {\n    --transform-scale-y: 1;\n  }\n  .md\\:focus\\:scale-y-105:focus {\n    --transform-scale-y: 1.05;\n  }\n  .md\\:focus\\:scale-y-110:focus {\n    --transform-scale-y: 1.1;\n  }\n  .md\\:focus\\:scale-y-125:focus {\n    --transform-scale-y: 1.25;\n  }\n  .md\\:focus\\:scale-y-150:focus {\n    --transform-scale-y: 1.5;\n  }\n  .md\\:rotate-0 {\n    --transform-rotate: 0;\n  }\n  .md\\:rotate-1 {\n    --transform-rotate: 1deg;\n  }\n  .md\\:rotate-2 {\n    --transform-rotate: 2deg;\n  }\n  .md\\:rotate-3 {\n    --transform-rotate: 3deg;\n  }\n  .md\\:rotate-6 {\n    --transform-rotate: 6deg;\n  }\n  .md\\:rotate-12 {\n    --transform-rotate: 12deg;\n  }\n  .md\\:rotate-45 {\n    --transform-rotate: 45deg;\n  }\n  .md\\:rotate-90 {\n    --transform-rotate: 90deg;\n  }\n  .md\\:rotate-180 {\n    --transform-rotate: 180deg;\n  }\n  .md\\:-rotate-180 {\n    --transform-rotate: -180deg;\n  }\n  .md\\:-rotate-90 {\n    --transform-rotate: -90deg;\n  }\n  .md\\:-rotate-45 {\n    --transform-rotate: -45deg;\n  }\n  .md\\:-rotate-12 {\n    --transform-rotate: -12deg;\n  }\n  .md\\:-rotate-6 {\n    --transform-rotate: -6deg;\n  }\n  .md\\:-rotate-3 {\n    --transform-rotate: -3deg;\n  }\n  .md\\:-rotate-2 {\n    --transform-rotate: -2deg;\n  }\n  .md\\:-rotate-1 {\n    --transform-rotate: -1deg;\n  }\n  .md\\:hover\\:rotate-0:hover {\n    --transform-rotate: 0;\n  }\n  .md\\:hover\\:rotate-1:hover {\n    --transform-rotate: 1deg;\n  }\n  .md\\:hover\\:rotate-2:hover {\n    --transform-rotate: 2deg;\n  }\n  .md\\:hover\\:rotate-3:hover {\n    --transform-rotate: 3deg;\n  }\n  .md\\:hover\\:rotate-6:hover {\n    --transform-rotate: 6deg;\n  }\n  .md\\:hover\\:rotate-12:hover {\n    --transform-rotate: 12deg;\n  }\n  .md\\:hover\\:rotate-45:hover {\n    --transform-rotate: 45deg;\n  }\n  .md\\:hover\\:rotate-90:hover {\n    --transform-rotate: 90deg;\n  }\n  .md\\:hover\\:rotate-180:hover {\n    --transform-rotate: 180deg;\n  }\n  .md\\:hover\\:-rotate-180:hover {\n    --transform-rotate: -180deg;\n  }\n  .md\\:hover\\:-rotate-90:hover {\n    --transform-rotate: -90deg;\n  }\n  .md\\:hover\\:-rotate-45:hover {\n    --transform-rotate: -45deg;\n  }\n  .md\\:hover\\:-rotate-12:hover {\n    --transform-rotate: -12deg;\n  }\n  .md\\:hover\\:-rotate-6:hover {\n    --transform-rotate: -6deg;\n  }\n  .md\\:hover\\:-rotate-3:hover {\n    --transform-rotate: -3deg;\n  }\n  .md\\:hover\\:-rotate-2:hover {\n    --transform-rotate: -2deg;\n  }\n  .md\\:hover\\:-rotate-1:hover {\n    --transform-rotate: -1deg;\n  }\n  .md\\:focus\\:rotate-0:focus {\n    --transform-rotate: 0;\n  }\n  .md\\:focus\\:rotate-1:focus {\n    --transform-rotate: 1deg;\n  }\n  .md\\:focus\\:rotate-2:focus {\n    --transform-rotate: 2deg;\n  }\n  .md\\:focus\\:rotate-3:focus {\n    --transform-rotate: 3deg;\n  }\n  .md\\:focus\\:rotate-6:focus {\n    --transform-rotate: 6deg;\n  }\n  .md\\:focus\\:rotate-12:focus {\n    --transform-rotate: 12deg;\n  }\n  .md\\:focus\\:rotate-45:focus {\n    --transform-rotate: 45deg;\n  }\n  .md\\:focus\\:rotate-90:focus {\n    --transform-rotate: 90deg;\n  }\n  .md\\:focus\\:rotate-180:focus {\n    --transform-rotate: 180deg;\n  }\n  .md\\:focus\\:-rotate-180:focus {\n    --transform-rotate: -180deg;\n  }\n  .md\\:focus\\:-rotate-90:focus {\n    --transform-rotate: -90deg;\n  }\n  .md\\:focus\\:-rotate-45:focus {\n    --transform-rotate: -45deg;\n  }\n  .md\\:focus\\:-rotate-12:focus {\n    --transform-rotate: -12deg;\n  }\n  .md\\:focus\\:-rotate-6:focus {\n    --transform-rotate: -6deg;\n  }\n  .md\\:focus\\:-rotate-3:focus {\n    --transform-rotate: -3deg;\n  }\n  .md\\:focus\\:-rotate-2:focus {\n    --transform-rotate: -2deg;\n  }\n  .md\\:focus\\:-rotate-1:focus {\n    --transform-rotate: -1deg;\n  }\n  .md\\:translate-x-0 {\n    --transform-translate-x: 0;\n  }\n  .md\\:translate-x-1 {\n    --transform-translate-x: 0.25rem;\n  }\n  .md\\:translate-x-2 {\n    --transform-translate-x: 0.5rem;\n  }\n  .md\\:translate-x-3 {\n    --transform-translate-x: 0.75rem;\n  }\n  .md\\:translate-x-4 {\n    --transform-translate-x: 1rem;\n  }\n  .md\\:translate-x-5 {\n    --transform-translate-x: 1.25rem;\n  }\n  .md\\:translate-x-6 {\n    --transform-translate-x: 1.5rem;\n  }\n  .md\\:translate-x-7 {\n    --transform-translate-x: 1.75rem;\n  }\n  .md\\:translate-x-8 {\n    --transform-translate-x: 2rem;\n  }\n  .md\\:translate-x-9 {\n    --transform-translate-x: 2.25rem;\n  }\n  .md\\:translate-x-10 {\n    --transform-translate-x: 2.5rem;\n  }\n  .md\\:translate-x-11 {\n    --transform-translate-x: 2.75rem;\n  }\n  .md\\:translate-x-12 {\n    --transform-translate-x: 3rem;\n  }\n  .md\\:translate-x-13 {\n    --transform-translate-x: 3.25rem;\n  }\n  .md\\:translate-x-14 {\n    --transform-translate-x: 3.5rem;\n  }\n  .md\\:translate-x-15 {\n    --transform-translate-x: 3.75rem;\n  }\n  .md\\:translate-x-16 {\n    --transform-translate-x: 4rem;\n  }\n  .md\\:translate-x-20 {\n    --transform-translate-x: 5rem;\n  }\n  .md\\:translate-x-24 {\n    --transform-translate-x: 6rem;\n  }\n  .md\\:translate-x-28 {\n    --transform-translate-x: 7rem;\n  }\n  .md\\:translate-x-32 {\n    --transform-translate-x: 8rem;\n  }\n  .md\\:translate-x-36 {\n    --transform-translate-x: 9rem;\n  }\n  .md\\:translate-x-40 {\n    --transform-translate-x: 10rem;\n  }\n  .md\\:translate-x-44 {\n    --transform-translate-x: 11rem;\n  }\n  .md\\:translate-x-48 {\n    --transform-translate-x: 12rem;\n  }\n  .md\\:translate-x-52 {\n    --transform-translate-x: 13rem;\n  }\n  .md\\:translate-x-56 {\n    --transform-translate-x: 14rem;\n  }\n  .md\\:translate-x-60 {\n    --transform-translate-x: 15rem;\n  }\n  .md\\:translate-x-64 {\n    --transform-translate-x: 16rem;\n  }\n  .md\\:translate-x-72 {\n    --transform-translate-x: 18rem;\n  }\n  .md\\:translate-x-80 {\n    --transform-translate-x: 20rem;\n  }\n  .md\\:translate-x-96 {\n    --transform-translate-x: 24rem;\n  }\n  .md\\:translate-x-px {\n    --transform-translate-x: 1px;\n  }\n  .md\\:translate-x-0\\.5 {\n    --transform-translate-x: 0.125rem;\n  }\n  .md\\:translate-x-1\\.5 {\n    --transform-translate-x: 0.375rem;\n  }\n  .md\\:translate-x-2\\.5 {\n    --transform-translate-x: 0.625rem;\n  }\n  .md\\:translate-x-3\\.5 {\n    --transform-translate-x: 0.875rem;\n  }\n  .md\\:translate-x-1\\/2 {\n    --transform-translate-x: 50%;\n  }\n  .md\\:translate-x-1\\/3 {\n    --transform-translate-x: 33.333333%;\n  }\n  .md\\:translate-x-2\\/3 {\n    --transform-translate-x: 66.666667%;\n  }\n  .md\\:translate-x-1\\/4 {\n    --transform-translate-x: 25%;\n  }\n  .md\\:translate-x-2\\/4 {\n    --transform-translate-x: 50%;\n  }\n  .md\\:translate-x-3\\/4 {\n    --transform-translate-x: 75%;\n  }\n  .md\\:translate-x-1\\/5 {\n    --transform-translate-x: 20%;\n  }\n  .md\\:translate-x-2\\/5 {\n    --transform-translate-x: 40%;\n  }\n  .md\\:translate-x-3\\/5 {\n    --transform-translate-x: 60%;\n  }\n  .md\\:translate-x-4\\/5 {\n    --transform-translate-x: 80%;\n  }\n  .md\\:translate-x-1\\/6 {\n    --transform-translate-x: 16.666667%;\n  }\n  .md\\:translate-x-2\\/6 {\n    --transform-translate-x: 33.333333%;\n  }\n  .md\\:translate-x-3\\/6 {\n    --transform-translate-x: 50%;\n  }\n  .md\\:translate-x-4\\/6 {\n    --transform-translate-x: 66.666667%;\n  }\n  .md\\:translate-x-5\\/6 {\n    --transform-translate-x: 83.333333%;\n  }\n  .md\\:translate-x-1\\/12 {\n    --transform-translate-x: 8.333333%;\n  }\n  .md\\:translate-x-2\\/12 {\n    --transform-translate-x: 16.666667%;\n  }\n  .md\\:translate-x-3\\/12 {\n    --transform-translate-x: 25%;\n  }\n  .md\\:translate-x-4\\/12 {\n    --transform-translate-x: 33.333333%;\n  }\n  .md\\:translate-x-5\\/12 {\n    --transform-translate-x: 41.666667%;\n  }\n  .md\\:translate-x-6\\/12 {\n    --transform-translate-x: 50%;\n  }\n  .md\\:translate-x-7\\/12 {\n    --transform-translate-x: 58.333333%;\n  }\n  .md\\:translate-x-8\\/12 {\n    --transform-translate-x: 66.666667%;\n  }\n  .md\\:translate-x-9\\/12 {\n    --transform-translate-x: 75%;\n  }\n  .md\\:translate-x-10\\/12 {\n    --transform-translate-x: 83.333333%;\n  }\n  .md\\:translate-x-11\\/12 {\n    --transform-translate-x: 91.666667%;\n  }\n  .md\\:translate-x-full {\n    --transform-translate-x: 100%;\n  }\n  .md\\:-translate-x-1 {\n    --transform-translate-x: -0.25rem;\n  }\n  .md\\:-translate-x-2 {\n    --transform-translate-x: -0.5rem;\n  }\n  .md\\:-translate-x-3 {\n    --transform-translate-x: -0.75rem;\n  }\n  .md\\:-translate-x-4 {\n    --transform-translate-x: -1rem;\n  }\n  .md\\:-translate-x-5 {\n    --transform-translate-x: -1.25rem;\n  }\n  .md\\:-translate-x-6 {\n    --transform-translate-x: -1.5rem;\n  }\n  .md\\:-translate-x-7 {\n    --transform-translate-x: -1.75rem;\n  }\n  .md\\:-translate-x-8 {\n    --transform-translate-x: -2rem;\n  }\n  .md\\:-translate-x-9 {\n    --transform-translate-x: -2.25rem;\n  }\n  .md\\:-translate-x-10 {\n    --transform-translate-x: -2.5rem;\n  }\n  .md\\:-translate-x-11 {\n    --transform-translate-x: -2.75rem;\n  }\n  .md\\:-translate-x-12 {\n    --transform-translate-x: -3rem;\n  }\n  .md\\:-translate-x-13 {\n    --transform-translate-x: -3.25rem;\n  }\n  .md\\:-translate-x-14 {\n    --transform-translate-x: -3.5rem;\n  }\n  .md\\:-translate-x-15 {\n    --transform-translate-x: -3.75rem;\n  }\n  .md\\:-translate-x-16 {\n    --transform-translate-x: -4rem;\n  }\n  .md\\:-translate-x-20 {\n    --transform-translate-x: -5rem;\n  }\n  .md\\:-translate-x-24 {\n    --transform-translate-x: -6rem;\n  }\n  .md\\:-translate-x-28 {\n    --transform-translate-x: -7rem;\n  }\n  .md\\:-translate-x-32 {\n    --transform-translate-x: -8rem;\n  }\n  .md\\:-translate-x-36 {\n    --transform-translate-x: -9rem;\n  }\n  .md\\:-translate-x-40 {\n    --transform-translate-x: -10rem;\n  }\n  .md\\:-translate-x-44 {\n    --transform-translate-x: -11rem;\n  }\n  .md\\:-translate-x-48 {\n    --transform-translate-x: -12rem;\n  }\n  .md\\:-translate-x-52 {\n    --transform-translate-x: -13rem;\n  }\n  .md\\:-translate-x-56 {\n    --transform-translate-x: -14rem;\n  }\n  .md\\:-translate-x-60 {\n    --transform-translate-x: -15rem;\n  }\n  .md\\:-translate-x-64 {\n    --transform-translate-x: -16rem;\n  }\n  .md\\:-translate-x-72 {\n    --transform-translate-x: -18rem;\n  }\n  .md\\:-translate-x-80 {\n    --transform-translate-x: -20rem;\n  }\n  .md\\:-translate-x-96 {\n    --transform-translate-x: -24rem;\n  }\n  .md\\:-translate-x-px {\n    --transform-translate-x: -1px;\n  }\n  .md\\:-translate-x-0\\.5 {\n    --transform-translate-x: -0.125rem;\n  }\n  .md\\:-translate-x-1\\.5 {\n    --transform-translate-x: -0.375rem;\n  }\n  .md\\:-translate-x-2\\.5 {\n    --transform-translate-x: -0.625rem;\n  }\n  .md\\:-translate-x-3\\.5 {\n    --transform-translate-x: -0.875rem;\n  }\n  .md\\:-translate-x-1\\/2 {\n    --transform-translate-x: -50%;\n  }\n  .md\\:-translate-x-1\\/3 {\n    --transform-translate-x: -33.33333%;\n  }\n  .md\\:-translate-x-2\\/3 {\n    --transform-translate-x: -66.66667%;\n  }\n  .md\\:-translate-x-1\\/4 {\n    --transform-translate-x: -25%;\n  }\n  .md\\:-translate-x-2\\/4 {\n    --transform-translate-x: -50%;\n  }\n  .md\\:-translate-x-3\\/4 {\n    --transform-translate-x: -75%;\n  }\n  .md\\:-translate-x-1\\/5 {\n    --transform-translate-x: -20%;\n  }\n  .md\\:-translate-x-2\\/5 {\n    --transform-translate-x: -40%;\n  }\n  .md\\:-translate-x-3\\/5 {\n    --transform-translate-x: -60%;\n  }\n  .md\\:-translate-x-4\\/5 {\n    --transform-translate-x: -80%;\n  }\n  .md\\:-translate-x-1\\/6 {\n    --transform-translate-x: -16.66667%;\n  }\n  .md\\:-translate-x-2\\/6 {\n    --transform-translate-x: -33.33333%;\n  }\n  .md\\:-translate-x-3\\/6 {\n    --transform-translate-x: -50%;\n  }\n  .md\\:-translate-x-4\\/6 {\n    --transform-translate-x: -66.66667%;\n  }\n  .md\\:-translate-x-5\\/6 {\n    --transform-translate-x: -83.33333%;\n  }\n  .md\\:-translate-x-1\\/12 {\n    --transform-translate-x: -8.33333%;\n  }\n  .md\\:-translate-x-2\\/12 {\n    --transform-translate-x: -16.66667%;\n  }\n  .md\\:-translate-x-3\\/12 {\n    --transform-translate-x: -25%;\n  }\n  .md\\:-translate-x-4\\/12 {\n    --transform-translate-x: -33.33333%;\n  }\n  .md\\:-translate-x-5\\/12 {\n    --transform-translate-x: -41.66667%;\n  }\n  .md\\:-translate-x-6\\/12 {\n    --transform-translate-x: -50%;\n  }\n  .md\\:-translate-x-7\\/12 {\n    --transform-translate-x: -58.33333%;\n  }\n  .md\\:-translate-x-8\\/12 {\n    --transform-translate-x: -66.66667%;\n  }\n  .md\\:-translate-x-9\\/12 {\n    --transform-translate-x: -75%;\n  }\n  .md\\:-translate-x-10\\/12 {\n    --transform-translate-x: -83.33333%;\n  }\n  .md\\:-translate-x-11\\/12 {\n    --transform-translate-x: -91.66667%;\n  }\n  .md\\:-translate-x-full {\n    --transform-translate-x: -100%;\n  }\n  .md\\:translate-y-0 {\n    --transform-translate-y: 0;\n  }\n  .md\\:translate-y-1 {\n    --transform-translate-y: 0.25rem;\n  }\n  .md\\:translate-y-2 {\n    --transform-translate-y: 0.5rem;\n  }\n  .md\\:translate-y-3 {\n    --transform-translate-y: 0.75rem;\n  }\n  .md\\:translate-y-4 {\n    --transform-translate-y: 1rem;\n  }\n  .md\\:translate-y-5 {\n    --transform-translate-y: 1.25rem;\n  }\n  .md\\:translate-y-6 {\n    --transform-translate-y: 1.5rem;\n  }\n  .md\\:translate-y-7 {\n    --transform-translate-y: 1.75rem;\n  }\n  .md\\:translate-y-8 {\n    --transform-translate-y: 2rem;\n  }\n  .md\\:translate-y-9 {\n    --transform-translate-y: 2.25rem;\n  }\n  .md\\:translate-y-10 {\n    --transform-translate-y: 2.5rem;\n  }\n  .md\\:translate-y-11 {\n    --transform-translate-y: 2.75rem;\n  }\n  .md\\:translate-y-12 {\n    --transform-translate-y: 3rem;\n  }\n  .md\\:translate-y-13 {\n    --transform-translate-y: 3.25rem;\n  }\n  .md\\:translate-y-14 {\n    --transform-translate-y: 3.5rem;\n  }\n  .md\\:translate-y-15 {\n    --transform-translate-y: 3.75rem;\n  }\n  .md\\:translate-y-16 {\n    --transform-translate-y: 4rem;\n  }\n  .md\\:translate-y-20 {\n    --transform-translate-y: 5rem;\n  }\n  .md\\:translate-y-24 {\n    --transform-translate-y: 6rem;\n  }\n  .md\\:translate-y-28 {\n    --transform-translate-y: 7rem;\n  }\n  .md\\:translate-y-32 {\n    --transform-translate-y: 8rem;\n  }\n  .md\\:translate-y-36 {\n    --transform-translate-y: 9rem;\n  }\n  .md\\:translate-y-40 {\n    --transform-translate-y: 10rem;\n  }\n  .md\\:translate-y-44 {\n    --transform-translate-y: 11rem;\n  }\n  .md\\:translate-y-48 {\n    --transform-translate-y: 12rem;\n  }\n  .md\\:translate-y-52 {\n    --transform-translate-y: 13rem;\n  }\n  .md\\:translate-y-56 {\n    --transform-translate-y: 14rem;\n  }\n  .md\\:translate-y-60 {\n    --transform-translate-y: 15rem;\n  }\n  .md\\:translate-y-64 {\n    --transform-translate-y: 16rem;\n  }\n  .md\\:translate-y-72 {\n    --transform-translate-y: 18rem;\n  }\n  .md\\:translate-y-80 {\n    --transform-translate-y: 20rem;\n  }\n  .md\\:translate-y-96 {\n    --transform-translate-y: 24rem;\n  }\n  .md\\:translate-y-px {\n    --transform-translate-y: 1px;\n  }\n  .md\\:translate-y-0\\.5 {\n    --transform-translate-y: 0.125rem;\n  }\n  .md\\:translate-y-1\\.5 {\n    --transform-translate-y: 0.375rem;\n  }\n  .md\\:translate-y-2\\.5 {\n    --transform-translate-y: 0.625rem;\n  }\n  .md\\:translate-y-3\\.5 {\n    --transform-translate-y: 0.875rem;\n  }\n  .md\\:translate-y-1\\/2 {\n    --transform-translate-y: 50%;\n  }\n  .md\\:translate-y-1\\/3 {\n    --transform-translate-y: 33.333333%;\n  }\n  .md\\:translate-y-2\\/3 {\n    --transform-translate-y: 66.666667%;\n  }\n  .md\\:translate-y-1\\/4 {\n    --transform-translate-y: 25%;\n  }\n  .md\\:translate-y-2\\/4 {\n    --transform-translate-y: 50%;\n  }\n  .md\\:translate-y-3\\/4 {\n    --transform-translate-y: 75%;\n  }\n  .md\\:translate-y-1\\/5 {\n    --transform-translate-y: 20%;\n  }\n  .md\\:translate-y-2\\/5 {\n    --transform-translate-y: 40%;\n  }\n  .md\\:translate-y-3\\/5 {\n    --transform-translate-y: 60%;\n  }\n  .md\\:translate-y-4\\/5 {\n    --transform-translate-y: 80%;\n  }\n  .md\\:translate-y-1\\/6 {\n    --transform-translate-y: 16.666667%;\n  }\n  .md\\:translate-y-2\\/6 {\n    --transform-translate-y: 33.333333%;\n  }\n  .md\\:translate-y-3\\/6 {\n    --transform-translate-y: 50%;\n  }\n  .md\\:translate-y-4\\/6 {\n    --transform-translate-y: 66.666667%;\n  }\n  .md\\:translate-y-5\\/6 {\n    --transform-translate-y: 83.333333%;\n  }\n  .md\\:translate-y-1\\/12 {\n    --transform-translate-y: 8.333333%;\n  }\n  .md\\:translate-y-2\\/12 {\n    --transform-translate-y: 16.666667%;\n  }\n  .md\\:translate-y-3\\/12 {\n    --transform-translate-y: 25%;\n  }\n  .md\\:translate-y-4\\/12 {\n    --transform-translate-y: 33.333333%;\n  }\n  .md\\:translate-y-5\\/12 {\n    --transform-translate-y: 41.666667%;\n  }\n  .md\\:translate-y-6\\/12 {\n    --transform-translate-y: 50%;\n  }\n  .md\\:translate-y-7\\/12 {\n    --transform-translate-y: 58.333333%;\n  }\n  .md\\:translate-y-8\\/12 {\n    --transform-translate-y: 66.666667%;\n  }\n  .md\\:translate-y-9\\/12 {\n    --transform-translate-y: 75%;\n  }\n  .md\\:translate-y-10\\/12 {\n    --transform-translate-y: 83.333333%;\n  }\n  .md\\:translate-y-11\\/12 {\n    --transform-translate-y: 91.666667%;\n  }\n  .md\\:translate-y-full {\n    --transform-translate-y: 100%;\n  }\n  .md\\:-translate-y-1 {\n    --transform-translate-y: -0.25rem;\n  }\n  .md\\:-translate-y-2 {\n    --transform-translate-y: -0.5rem;\n  }\n  .md\\:-translate-y-3 {\n    --transform-translate-y: -0.75rem;\n  }\n  .md\\:-translate-y-4 {\n    --transform-translate-y: -1rem;\n  }\n  .md\\:-translate-y-5 {\n    --transform-translate-y: -1.25rem;\n  }\n  .md\\:-translate-y-6 {\n    --transform-translate-y: -1.5rem;\n  }\n  .md\\:-translate-y-7 {\n    --transform-translate-y: -1.75rem;\n  }\n  .md\\:-translate-y-8 {\n    --transform-translate-y: -2rem;\n  }\n  .md\\:-translate-y-9 {\n    --transform-translate-y: -2.25rem;\n  }\n  .md\\:-translate-y-10 {\n    --transform-translate-y: -2.5rem;\n  }\n  .md\\:-translate-y-11 {\n    --transform-translate-y: -2.75rem;\n  }\n  .md\\:-translate-y-12 {\n    --transform-translate-y: -3rem;\n  }\n  .md\\:-translate-y-13 {\n    --transform-translate-y: -3.25rem;\n  }\n  .md\\:-translate-y-14 {\n    --transform-translate-y: -3.5rem;\n  }\n  .md\\:-translate-y-15 {\n    --transform-translate-y: -3.75rem;\n  }\n  .md\\:-translate-y-16 {\n    --transform-translate-y: -4rem;\n  }\n  .md\\:-translate-y-20 {\n    --transform-translate-y: -5rem;\n  }\n  .md\\:-translate-y-24 {\n    --transform-translate-y: -6rem;\n  }\n  .md\\:-translate-y-28 {\n    --transform-translate-y: -7rem;\n  }\n  .md\\:-translate-y-32 {\n    --transform-translate-y: -8rem;\n  }\n  .md\\:-translate-y-36 {\n    --transform-translate-y: -9rem;\n  }\n  .md\\:-translate-y-40 {\n    --transform-translate-y: -10rem;\n  }\n  .md\\:-translate-y-44 {\n    --transform-translate-y: -11rem;\n  }\n  .md\\:-translate-y-48 {\n    --transform-translate-y: -12rem;\n  }\n  .md\\:-translate-y-52 {\n    --transform-translate-y: -13rem;\n  }\n  .md\\:-translate-y-56 {\n    --transform-translate-y: -14rem;\n  }\n  .md\\:-translate-y-60 {\n    --transform-translate-y: -15rem;\n  }\n  .md\\:-translate-y-64 {\n    --transform-translate-y: -16rem;\n  }\n  .md\\:-translate-y-72 {\n    --transform-translate-y: -18rem;\n  }\n  .md\\:-translate-y-80 {\n    --transform-translate-y: -20rem;\n  }\n  .md\\:-translate-y-96 {\n    --transform-translate-y: -24rem;\n  }\n  .md\\:-translate-y-px {\n    --transform-translate-y: -1px;\n  }\n  .md\\:-translate-y-0\\.5 {\n    --transform-translate-y: -0.125rem;\n  }\n  .md\\:-translate-y-1\\.5 {\n    --transform-translate-y: -0.375rem;\n  }\n  .md\\:-translate-y-2\\.5 {\n    --transform-translate-y: -0.625rem;\n  }\n  .md\\:-translate-y-3\\.5 {\n    --transform-translate-y: -0.875rem;\n  }\n  .md\\:-translate-y-1\\/2 {\n    --transform-translate-y: -50%;\n  }\n  .md\\:-translate-y-1\\/3 {\n    --transform-translate-y: -33.33333%;\n  }\n  .md\\:-translate-y-2\\/3 {\n    --transform-translate-y: -66.66667%;\n  }\n  .md\\:-translate-y-1\\/4 {\n    --transform-translate-y: -25%;\n  }\n  .md\\:-translate-y-2\\/4 {\n    --transform-translate-y: -50%;\n  }\n  .md\\:-translate-y-3\\/4 {\n    --transform-translate-y: -75%;\n  }\n  .md\\:-translate-y-1\\/5 {\n    --transform-translate-y: -20%;\n  }\n  .md\\:-translate-y-2\\/5 {\n    --transform-translate-y: -40%;\n  }\n  .md\\:-translate-y-3\\/5 {\n    --transform-translate-y: -60%;\n  }\n  .md\\:-translate-y-4\\/5 {\n    --transform-translate-y: -80%;\n  }\n  .md\\:-translate-y-1\\/6 {\n    --transform-translate-y: -16.66667%;\n  }\n  .md\\:-translate-y-2\\/6 {\n    --transform-translate-y: -33.33333%;\n  }\n  .md\\:-translate-y-3\\/6 {\n    --transform-translate-y: -50%;\n  }\n  .md\\:-translate-y-4\\/6 {\n    --transform-translate-y: -66.66667%;\n  }\n  .md\\:-translate-y-5\\/6 {\n    --transform-translate-y: -83.33333%;\n  }\n  .md\\:-translate-y-1\\/12 {\n    --transform-translate-y: -8.33333%;\n  }\n  .md\\:-translate-y-2\\/12 {\n    --transform-translate-y: -16.66667%;\n  }\n  .md\\:-translate-y-3\\/12 {\n    --transform-translate-y: -25%;\n  }\n  .md\\:-translate-y-4\\/12 {\n    --transform-translate-y: -33.33333%;\n  }\n  .md\\:-translate-y-5\\/12 {\n    --transform-translate-y: -41.66667%;\n  }\n  .md\\:-translate-y-6\\/12 {\n    --transform-translate-y: -50%;\n  }\n  .md\\:-translate-y-7\\/12 {\n    --transform-translate-y: -58.33333%;\n  }\n  .md\\:-translate-y-8\\/12 {\n    --transform-translate-y: -66.66667%;\n  }\n  .md\\:-translate-y-9\\/12 {\n    --transform-translate-y: -75%;\n  }\n  .md\\:-translate-y-10\\/12 {\n    --transform-translate-y: -83.33333%;\n  }\n  .md\\:-translate-y-11\\/12 {\n    --transform-translate-y: -91.66667%;\n  }\n  .md\\:-translate-y-full {\n    --transform-translate-y: -100%;\n  }\n  .md\\:hover\\:translate-x-0:hover {\n    --transform-translate-x: 0;\n  }\n  .md\\:hover\\:translate-x-1:hover {\n    --transform-translate-x: 0.25rem;\n  }\n  .md\\:hover\\:translate-x-2:hover {\n    --transform-translate-x: 0.5rem;\n  }\n  .md\\:hover\\:translate-x-3:hover {\n    --transform-translate-x: 0.75rem;\n  }\n  .md\\:hover\\:translate-x-4:hover {\n    --transform-translate-x: 1rem;\n  }\n  .md\\:hover\\:translate-x-5:hover {\n    --transform-translate-x: 1.25rem;\n  }\n  .md\\:hover\\:translate-x-6:hover {\n    --transform-translate-x: 1.5rem;\n  }\n  .md\\:hover\\:translate-x-7:hover {\n    --transform-translate-x: 1.75rem;\n  }\n  .md\\:hover\\:translate-x-8:hover {\n    --transform-translate-x: 2rem;\n  }\n  .md\\:hover\\:translate-x-9:hover {\n    --transform-translate-x: 2.25rem;\n  }\n  .md\\:hover\\:translate-x-10:hover {\n    --transform-translate-x: 2.5rem;\n  }\n  .md\\:hover\\:translate-x-11:hover {\n    --transform-translate-x: 2.75rem;\n  }\n  .md\\:hover\\:translate-x-12:hover {\n    --transform-translate-x: 3rem;\n  }\n  .md\\:hover\\:translate-x-13:hover {\n    --transform-translate-x: 3.25rem;\n  }\n  .md\\:hover\\:translate-x-14:hover {\n    --transform-translate-x: 3.5rem;\n  }\n  .md\\:hover\\:translate-x-15:hover {\n    --transform-translate-x: 3.75rem;\n  }\n  .md\\:hover\\:translate-x-16:hover {\n    --transform-translate-x: 4rem;\n  }\n  .md\\:hover\\:translate-x-20:hover {\n    --transform-translate-x: 5rem;\n  }\n  .md\\:hover\\:translate-x-24:hover {\n    --transform-translate-x: 6rem;\n  }\n  .md\\:hover\\:translate-x-28:hover {\n    --transform-translate-x: 7rem;\n  }\n  .md\\:hover\\:translate-x-32:hover {\n    --transform-translate-x: 8rem;\n  }\n  .md\\:hover\\:translate-x-36:hover {\n    --transform-translate-x: 9rem;\n  }\n  .md\\:hover\\:translate-x-40:hover {\n    --transform-translate-x: 10rem;\n  }\n  .md\\:hover\\:translate-x-44:hover {\n    --transform-translate-x: 11rem;\n  }\n  .md\\:hover\\:translate-x-48:hover {\n    --transform-translate-x: 12rem;\n  }\n  .md\\:hover\\:translate-x-52:hover {\n    --transform-translate-x: 13rem;\n  }\n  .md\\:hover\\:translate-x-56:hover {\n    --transform-translate-x: 14rem;\n  }\n  .md\\:hover\\:translate-x-60:hover {\n    --transform-translate-x: 15rem;\n  }\n  .md\\:hover\\:translate-x-64:hover {\n    --transform-translate-x: 16rem;\n  }\n  .md\\:hover\\:translate-x-72:hover {\n    --transform-translate-x: 18rem;\n  }\n  .md\\:hover\\:translate-x-80:hover {\n    --transform-translate-x: 20rem;\n  }\n  .md\\:hover\\:translate-x-96:hover {\n    --transform-translate-x: 24rem;\n  }\n  .md\\:hover\\:translate-x-px:hover {\n    --transform-translate-x: 1px;\n  }\n  .md\\:hover\\:translate-x-0\\.5:hover {\n    --transform-translate-x: 0.125rem;\n  }\n  .md\\:hover\\:translate-x-1\\.5:hover {\n    --transform-translate-x: 0.375rem;\n  }\n  .md\\:hover\\:translate-x-2\\.5:hover {\n    --transform-translate-x: 0.625rem;\n  }\n  .md\\:hover\\:translate-x-3\\.5:hover {\n    --transform-translate-x: 0.875rem;\n  }\n  .md\\:hover\\:translate-x-1\\/2:hover {\n    --transform-translate-x: 50%;\n  }\n  .md\\:hover\\:translate-x-1\\/3:hover {\n    --transform-translate-x: 33.333333%;\n  }\n  .md\\:hover\\:translate-x-2\\/3:hover {\n    --transform-translate-x: 66.666667%;\n  }\n  .md\\:hover\\:translate-x-1\\/4:hover {\n    --transform-translate-x: 25%;\n  }\n  .md\\:hover\\:translate-x-2\\/4:hover {\n    --transform-translate-x: 50%;\n  }\n  .md\\:hover\\:translate-x-3\\/4:hover {\n    --transform-translate-x: 75%;\n  }\n  .md\\:hover\\:translate-x-1\\/5:hover {\n    --transform-translate-x: 20%;\n  }\n  .md\\:hover\\:translate-x-2\\/5:hover {\n    --transform-translate-x: 40%;\n  }\n  .md\\:hover\\:translate-x-3\\/5:hover {\n    --transform-translate-x: 60%;\n  }\n  .md\\:hover\\:translate-x-4\\/5:hover {\n    --transform-translate-x: 80%;\n  }\n  .md\\:hover\\:translate-x-1\\/6:hover {\n    --transform-translate-x: 16.666667%;\n  }\n  .md\\:hover\\:translate-x-2\\/6:hover {\n    --transform-translate-x: 33.333333%;\n  }\n  .md\\:hover\\:translate-x-3\\/6:hover {\n    --transform-translate-x: 50%;\n  }\n  .md\\:hover\\:translate-x-4\\/6:hover {\n    --transform-translate-x: 66.666667%;\n  }\n  .md\\:hover\\:translate-x-5\\/6:hover {\n    --transform-translate-x: 83.333333%;\n  }\n  .md\\:hover\\:translate-x-1\\/12:hover {\n    --transform-translate-x: 8.333333%;\n  }\n  .md\\:hover\\:translate-x-2\\/12:hover {\n    --transform-translate-x: 16.666667%;\n  }\n  .md\\:hover\\:translate-x-3\\/12:hover {\n    --transform-translate-x: 25%;\n  }\n  .md\\:hover\\:translate-x-4\\/12:hover {\n    --transform-translate-x: 33.333333%;\n  }\n  .md\\:hover\\:translate-x-5\\/12:hover {\n    --transform-translate-x: 41.666667%;\n  }\n  .md\\:hover\\:translate-x-6\\/12:hover {\n    --transform-translate-x: 50%;\n  }\n  .md\\:hover\\:translate-x-7\\/12:hover {\n    --transform-translate-x: 58.333333%;\n  }\n  .md\\:hover\\:translate-x-8\\/12:hover {\n    --transform-translate-x: 66.666667%;\n  }\n  .md\\:hover\\:translate-x-9\\/12:hover {\n    --transform-translate-x: 75%;\n  }\n  .md\\:hover\\:translate-x-10\\/12:hover {\n    --transform-translate-x: 83.333333%;\n  }\n  .md\\:hover\\:translate-x-11\\/12:hover {\n    --transform-translate-x: 91.666667%;\n  }\n  .md\\:hover\\:translate-x-full:hover {\n    --transform-translate-x: 100%;\n  }\n  .md\\:hover\\:-translate-x-1:hover {\n    --transform-translate-x: -0.25rem;\n  }\n  .md\\:hover\\:-translate-x-2:hover {\n    --transform-translate-x: -0.5rem;\n  }\n  .md\\:hover\\:-translate-x-3:hover {\n    --transform-translate-x: -0.75rem;\n  }\n  .md\\:hover\\:-translate-x-4:hover {\n    --transform-translate-x: -1rem;\n  }\n  .md\\:hover\\:-translate-x-5:hover {\n    --transform-translate-x: -1.25rem;\n  }\n  .md\\:hover\\:-translate-x-6:hover {\n    --transform-translate-x: -1.5rem;\n  }\n  .md\\:hover\\:-translate-x-7:hover {\n    --transform-translate-x: -1.75rem;\n  }\n  .md\\:hover\\:-translate-x-8:hover {\n    --transform-translate-x: -2rem;\n  }\n  .md\\:hover\\:-translate-x-9:hover {\n    --transform-translate-x: -2.25rem;\n  }\n  .md\\:hover\\:-translate-x-10:hover {\n    --transform-translate-x: -2.5rem;\n  }\n  .md\\:hover\\:-translate-x-11:hover {\n    --transform-translate-x: -2.75rem;\n  }\n  .md\\:hover\\:-translate-x-12:hover {\n    --transform-translate-x: -3rem;\n  }\n  .md\\:hover\\:-translate-x-13:hover {\n    --transform-translate-x: -3.25rem;\n  }\n  .md\\:hover\\:-translate-x-14:hover {\n    --transform-translate-x: -3.5rem;\n  }\n  .md\\:hover\\:-translate-x-15:hover {\n    --transform-translate-x: -3.75rem;\n  }\n  .md\\:hover\\:-translate-x-16:hover {\n    --transform-translate-x: -4rem;\n  }\n  .md\\:hover\\:-translate-x-20:hover {\n    --transform-translate-x: -5rem;\n  }\n  .md\\:hover\\:-translate-x-24:hover {\n    --transform-translate-x: -6rem;\n  }\n  .md\\:hover\\:-translate-x-28:hover {\n    --transform-translate-x: -7rem;\n  }\n  .md\\:hover\\:-translate-x-32:hover {\n    --transform-translate-x: -8rem;\n  }\n  .md\\:hover\\:-translate-x-36:hover {\n    --transform-translate-x: -9rem;\n  }\n  .md\\:hover\\:-translate-x-40:hover {\n    --transform-translate-x: -10rem;\n  }\n  .md\\:hover\\:-translate-x-44:hover {\n    --transform-translate-x: -11rem;\n  }\n  .md\\:hover\\:-translate-x-48:hover {\n    --transform-translate-x: -12rem;\n  }\n  .md\\:hover\\:-translate-x-52:hover {\n    --transform-translate-x: -13rem;\n  }\n  .md\\:hover\\:-translate-x-56:hover {\n    --transform-translate-x: -14rem;\n  }\n  .md\\:hover\\:-translate-x-60:hover {\n    --transform-translate-x: -15rem;\n  }\n  .md\\:hover\\:-translate-x-64:hover {\n    --transform-translate-x: -16rem;\n  }\n  .md\\:hover\\:-translate-x-72:hover {\n    --transform-translate-x: -18rem;\n  }\n  .md\\:hover\\:-translate-x-80:hover {\n    --transform-translate-x: -20rem;\n  }\n  .md\\:hover\\:-translate-x-96:hover {\n    --transform-translate-x: -24rem;\n  }\n  .md\\:hover\\:-translate-x-px:hover {\n    --transform-translate-x: -1px;\n  }\n  .md\\:hover\\:-translate-x-0\\.5:hover {\n    --transform-translate-x: -0.125rem;\n  }\n  .md\\:hover\\:-translate-x-1\\.5:hover {\n    --transform-translate-x: -0.375rem;\n  }\n  .md\\:hover\\:-translate-x-2\\.5:hover {\n    --transform-translate-x: -0.625rem;\n  }\n  .md\\:hover\\:-translate-x-3\\.5:hover {\n    --transform-translate-x: -0.875rem;\n  }\n  .md\\:hover\\:-translate-x-1\\/2:hover {\n    --transform-translate-x: -50%;\n  }\n  .md\\:hover\\:-translate-x-1\\/3:hover {\n    --transform-translate-x: -33.33333%;\n  }\n  .md\\:hover\\:-translate-x-2\\/3:hover {\n    --transform-translate-x: -66.66667%;\n  }\n  .md\\:hover\\:-translate-x-1\\/4:hover {\n    --transform-translate-x: -25%;\n  }\n  .md\\:hover\\:-translate-x-2\\/4:hover {\n    --transform-translate-x: -50%;\n  }\n  .md\\:hover\\:-translate-x-3\\/4:hover {\n    --transform-translate-x: -75%;\n  }\n  .md\\:hover\\:-translate-x-1\\/5:hover {\n    --transform-translate-x: -20%;\n  }\n  .md\\:hover\\:-translate-x-2\\/5:hover {\n    --transform-translate-x: -40%;\n  }\n  .md\\:hover\\:-translate-x-3\\/5:hover {\n    --transform-translate-x: -60%;\n  }\n  .md\\:hover\\:-translate-x-4\\/5:hover {\n    --transform-translate-x: -80%;\n  }\n  .md\\:hover\\:-translate-x-1\\/6:hover {\n    --transform-translate-x: -16.66667%;\n  }\n  .md\\:hover\\:-translate-x-2\\/6:hover {\n    --transform-translate-x: -33.33333%;\n  }\n  .md\\:hover\\:-translate-x-3\\/6:hover {\n    --transform-translate-x: -50%;\n  }\n  .md\\:hover\\:-translate-x-4\\/6:hover {\n    --transform-translate-x: -66.66667%;\n  }\n  .md\\:hover\\:-translate-x-5\\/6:hover {\n    --transform-translate-x: -83.33333%;\n  }\n  .md\\:hover\\:-translate-x-1\\/12:hover {\n    --transform-translate-x: -8.33333%;\n  }\n  .md\\:hover\\:-translate-x-2\\/12:hover {\n    --transform-translate-x: -16.66667%;\n  }\n  .md\\:hover\\:-translate-x-3\\/12:hover {\n    --transform-translate-x: -25%;\n  }\n  .md\\:hover\\:-translate-x-4\\/12:hover {\n    --transform-translate-x: -33.33333%;\n  }\n  .md\\:hover\\:-translate-x-5\\/12:hover {\n    --transform-translate-x: -41.66667%;\n  }\n  .md\\:hover\\:-translate-x-6\\/12:hover {\n    --transform-translate-x: -50%;\n  }\n  .md\\:hover\\:-translate-x-7\\/12:hover {\n    --transform-translate-x: -58.33333%;\n  }\n  .md\\:hover\\:-translate-x-8\\/12:hover {\n    --transform-translate-x: -66.66667%;\n  }\n  .md\\:hover\\:-translate-x-9\\/12:hover {\n    --transform-translate-x: -75%;\n  }\n  .md\\:hover\\:-translate-x-10\\/12:hover {\n    --transform-translate-x: -83.33333%;\n  }\n  .md\\:hover\\:-translate-x-11\\/12:hover {\n    --transform-translate-x: -91.66667%;\n  }\n  .md\\:hover\\:-translate-x-full:hover {\n    --transform-translate-x: -100%;\n  }\n  .md\\:hover\\:translate-y-0:hover {\n    --transform-translate-y: 0;\n  }\n  .md\\:hover\\:translate-y-1:hover {\n    --transform-translate-y: 0.25rem;\n  }\n  .md\\:hover\\:translate-y-2:hover {\n    --transform-translate-y: 0.5rem;\n  }\n  .md\\:hover\\:translate-y-3:hover {\n    --transform-translate-y: 0.75rem;\n  }\n  .md\\:hover\\:translate-y-4:hover {\n    --transform-translate-y: 1rem;\n  }\n  .md\\:hover\\:translate-y-5:hover {\n    --transform-translate-y: 1.25rem;\n  }\n  .md\\:hover\\:translate-y-6:hover {\n    --transform-translate-y: 1.5rem;\n  }\n  .md\\:hover\\:translate-y-7:hover {\n    --transform-translate-y: 1.75rem;\n  }\n  .md\\:hover\\:translate-y-8:hover {\n    --transform-translate-y: 2rem;\n  }\n  .md\\:hover\\:translate-y-9:hover {\n    --transform-translate-y: 2.25rem;\n  }\n  .md\\:hover\\:translate-y-10:hover {\n    --transform-translate-y: 2.5rem;\n  }\n  .md\\:hover\\:translate-y-11:hover {\n    --transform-translate-y: 2.75rem;\n  }\n  .md\\:hover\\:translate-y-12:hover {\n    --transform-translate-y: 3rem;\n  }\n  .md\\:hover\\:translate-y-13:hover {\n    --transform-translate-y: 3.25rem;\n  }\n  .md\\:hover\\:translate-y-14:hover {\n    --transform-translate-y: 3.5rem;\n  }\n  .md\\:hover\\:translate-y-15:hover {\n    --transform-translate-y: 3.75rem;\n  }\n  .md\\:hover\\:translate-y-16:hover {\n    --transform-translate-y: 4rem;\n  }\n  .md\\:hover\\:translate-y-20:hover {\n    --transform-translate-y: 5rem;\n  }\n  .md\\:hover\\:translate-y-24:hover {\n    --transform-translate-y: 6rem;\n  }\n  .md\\:hover\\:translate-y-28:hover {\n    --transform-translate-y: 7rem;\n  }\n  .md\\:hover\\:translate-y-32:hover {\n    --transform-translate-y: 8rem;\n  }\n  .md\\:hover\\:translate-y-36:hover {\n    --transform-translate-y: 9rem;\n  }\n  .md\\:hover\\:translate-y-40:hover {\n    --transform-translate-y: 10rem;\n  }\n  .md\\:hover\\:translate-y-44:hover {\n    --transform-translate-y: 11rem;\n  }\n  .md\\:hover\\:translate-y-48:hover {\n    --transform-translate-y: 12rem;\n  }\n  .md\\:hover\\:translate-y-52:hover {\n    --transform-translate-y: 13rem;\n  }\n  .md\\:hover\\:translate-y-56:hover {\n    --transform-translate-y: 14rem;\n  }\n  .md\\:hover\\:translate-y-60:hover {\n    --transform-translate-y: 15rem;\n  }\n  .md\\:hover\\:translate-y-64:hover {\n    --transform-translate-y: 16rem;\n  }\n  .md\\:hover\\:translate-y-72:hover {\n    --transform-translate-y: 18rem;\n  }\n  .md\\:hover\\:translate-y-80:hover {\n    --transform-translate-y: 20rem;\n  }\n  .md\\:hover\\:translate-y-96:hover {\n    --transform-translate-y: 24rem;\n  }\n  .md\\:hover\\:translate-y-px:hover {\n    --transform-translate-y: 1px;\n  }\n  .md\\:hover\\:translate-y-0\\.5:hover {\n    --transform-translate-y: 0.125rem;\n  }\n  .md\\:hover\\:translate-y-1\\.5:hover {\n    --transform-translate-y: 0.375rem;\n  }\n  .md\\:hover\\:translate-y-2\\.5:hover {\n    --transform-translate-y: 0.625rem;\n  }\n  .md\\:hover\\:translate-y-3\\.5:hover {\n    --transform-translate-y: 0.875rem;\n  }\n  .md\\:hover\\:translate-y-1\\/2:hover {\n    --transform-translate-y: 50%;\n  }\n  .md\\:hover\\:translate-y-1\\/3:hover {\n    --transform-translate-y: 33.333333%;\n  }\n  .md\\:hover\\:translate-y-2\\/3:hover {\n    --transform-translate-y: 66.666667%;\n  }\n  .md\\:hover\\:translate-y-1\\/4:hover {\n    --transform-translate-y: 25%;\n  }\n  .md\\:hover\\:translate-y-2\\/4:hover {\n    --transform-translate-y: 50%;\n  }\n  .md\\:hover\\:translate-y-3\\/4:hover {\n    --transform-translate-y: 75%;\n  }\n  .md\\:hover\\:translate-y-1\\/5:hover {\n    --transform-translate-y: 20%;\n  }\n  .md\\:hover\\:translate-y-2\\/5:hover {\n    --transform-translate-y: 40%;\n  }\n  .md\\:hover\\:translate-y-3\\/5:hover {\n    --transform-translate-y: 60%;\n  }\n  .md\\:hover\\:translate-y-4\\/5:hover {\n    --transform-translate-y: 80%;\n  }\n  .md\\:hover\\:translate-y-1\\/6:hover {\n    --transform-translate-y: 16.666667%;\n  }\n  .md\\:hover\\:translate-y-2\\/6:hover {\n    --transform-translate-y: 33.333333%;\n  }\n  .md\\:hover\\:translate-y-3\\/6:hover {\n    --transform-translate-y: 50%;\n  }\n  .md\\:hover\\:translate-y-4\\/6:hover {\n    --transform-translate-y: 66.666667%;\n  }\n  .md\\:hover\\:translate-y-5\\/6:hover {\n    --transform-translate-y: 83.333333%;\n  }\n  .md\\:hover\\:translate-y-1\\/12:hover {\n    --transform-translate-y: 8.333333%;\n  }\n  .md\\:hover\\:translate-y-2\\/12:hover {\n    --transform-translate-y: 16.666667%;\n  }\n  .md\\:hover\\:translate-y-3\\/12:hover {\n    --transform-translate-y: 25%;\n  }\n  .md\\:hover\\:translate-y-4\\/12:hover {\n    --transform-translate-y: 33.333333%;\n  }\n  .md\\:hover\\:translate-y-5\\/12:hover {\n    --transform-translate-y: 41.666667%;\n  }\n  .md\\:hover\\:translate-y-6\\/12:hover {\n    --transform-translate-y: 50%;\n  }\n  .md\\:hover\\:translate-y-7\\/12:hover {\n    --transform-translate-y: 58.333333%;\n  }\n  .md\\:hover\\:translate-y-8\\/12:hover {\n    --transform-translate-y: 66.666667%;\n  }\n  .md\\:hover\\:translate-y-9\\/12:hover {\n    --transform-translate-y: 75%;\n  }\n  .md\\:hover\\:translate-y-10\\/12:hover {\n    --transform-translate-y: 83.333333%;\n  }\n  .md\\:hover\\:translate-y-11\\/12:hover {\n    --transform-translate-y: 91.666667%;\n  }\n  .md\\:hover\\:translate-y-full:hover {\n    --transform-translate-y: 100%;\n  }\n  .md\\:hover\\:-translate-y-1:hover {\n    --transform-translate-y: -0.25rem;\n  }\n  .md\\:hover\\:-translate-y-2:hover {\n    --transform-translate-y: -0.5rem;\n  }\n  .md\\:hover\\:-translate-y-3:hover {\n    --transform-translate-y: -0.75rem;\n  }\n  .md\\:hover\\:-translate-y-4:hover {\n    --transform-translate-y: -1rem;\n  }\n  .md\\:hover\\:-translate-y-5:hover {\n    --transform-translate-y: -1.25rem;\n  }\n  .md\\:hover\\:-translate-y-6:hover {\n    --transform-translate-y: -1.5rem;\n  }\n  .md\\:hover\\:-translate-y-7:hover {\n    --transform-translate-y: -1.75rem;\n  }\n  .md\\:hover\\:-translate-y-8:hover {\n    --transform-translate-y: -2rem;\n  }\n  .md\\:hover\\:-translate-y-9:hover {\n    --transform-translate-y: -2.25rem;\n  }\n  .md\\:hover\\:-translate-y-10:hover {\n    --transform-translate-y: -2.5rem;\n  }\n  .md\\:hover\\:-translate-y-11:hover {\n    --transform-translate-y: -2.75rem;\n  }\n  .md\\:hover\\:-translate-y-12:hover {\n    --transform-translate-y: -3rem;\n  }\n  .md\\:hover\\:-translate-y-13:hover {\n    --transform-translate-y: -3.25rem;\n  }\n  .md\\:hover\\:-translate-y-14:hover {\n    --transform-translate-y: -3.5rem;\n  }\n  .md\\:hover\\:-translate-y-15:hover {\n    --transform-translate-y: -3.75rem;\n  }\n  .md\\:hover\\:-translate-y-16:hover {\n    --transform-translate-y: -4rem;\n  }\n  .md\\:hover\\:-translate-y-20:hover {\n    --transform-translate-y: -5rem;\n  }\n  .md\\:hover\\:-translate-y-24:hover {\n    --transform-translate-y: -6rem;\n  }\n  .md\\:hover\\:-translate-y-28:hover {\n    --transform-translate-y: -7rem;\n  }\n  .md\\:hover\\:-translate-y-32:hover {\n    --transform-translate-y: -8rem;\n  }\n  .md\\:hover\\:-translate-y-36:hover {\n    --transform-translate-y: -9rem;\n  }\n  .md\\:hover\\:-translate-y-40:hover {\n    --transform-translate-y: -10rem;\n  }\n  .md\\:hover\\:-translate-y-44:hover {\n    --transform-translate-y: -11rem;\n  }\n  .md\\:hover\\:-translate-y-48:hover {\n    --transform-translate-y: -12rem;\n  }\n  .md\\:hover\\:-translate-y-52:hover {\n    --transform-translate-y: -13rem;\n  }\n  .md\\:hover\\:-translate-y-56:hover {\n    --transform-translate-y: -14rem;\n  }\n  .md\\:hover\\:-translate-y-60:hover {\n    --transform-translate-y: -15rem;\n  }\n  .md\\:hover\\:-translate-y-64:hover {\n    --transform-translate-y: -16rem;\n  }\n  .md\\:hover\\:-translate-y-72:hover {\n    --transform-translate-y: -18rem;\n  }\n  .md\\:hover\\:-translate-y-80:hover {\n    --transform-translate-y: -20rem;\n  }\n  .md\\:hover\\:-translate-y-96:hover {\n    --transform-translate-y: -24rem;\n  }\n  .md\\:hover\\:-translate-y-px:hover {\n    --transform-translate-y: -1px;\n  }\n  .md\\:hover\\:-translate-y-0\\.5:hover {\n    --transform-translate-y: -0.125rem;\n  }\n  .md\\:hover\\:-translate-y-1\\.5:hover {\n    --transform-translate-y: -0.375rem;\n  }\n  .md\\:hover\\:-translate-y-2\\.5:hover {\n    --transform-translate-y: -0.625rem;\n  }\n  .md\\:hover\\:-translate-y-3\\.5:hover {\n    --transform-translate-y: -0.875rem;\n  }\n  .md\\:hover\\:-translate-y-1\\/2:hover {\n    --transform-translate-y: -50%;\n  }\n  .md\\:hover\\:-translate-y-1\\/3:hover {\n    --transform-translate-y: -33.33333%;\n  }\n  .md\\:hover\\:-translate-y-2\\/3:hover {\n    --transform-translate-y: -66.66667%;\n  }\n  .md\\:hover\\:-translate-y-1\\/4:hover {\n    --transform-translate-y: -25%;\n  }\n  .md\\:hover\\:-translate-y-2\\/4:hover {\n    --transform-translate-y: -50%;\n  }\n  .md\\:hover\\:-translate-y-3\\/4:hover {\n    --transform-translate-y: -75%;\n  }\n  .md\\:hover\\:-translate-y-1\\/5:hover {\n    --transform-translate-y: -20%;\n  }\n  .md\\:hover\\:-translate-y-2\\/5:hover {\n    --transform-translate-y: -40%;\n  }\n  .md\\:hover\\:-translate-y-3\\/5:hover {\n    --transform-translate-y: -60%;\n  }\n  .md\\:hover\\:-translate-y-4\\/5:hover {\n    --transform-translate-y: -80%;\n  }\n  .md\\:hover\\:-translate-y-1\\/6:hover {\n    --transform-translate-y: -16.66667%;\n  }\n  .md\\:hover\\:-translate-y-2\\/6:hover {\n    --transform-translate-y: -33.33333%;\n  }\n  .md\\:hover\\:-translate-y-3\\/6:hover {\n    --transform-translate-y: -50%;\n  }\n  .md\\:hover\\:-translate-y-4\\/6:hover {\n    --transform-translate-y: -66.66667%;\n  }\n  .md\\:hover\\:-translate-y-5\\/6:hover {\n    --transform-translate-y: -83.33333%;\n  }\n  .md\\:hover\\:-translate-y-1\\/12:hover {\n    --transform-translate-y: -8.33333%;\n  }\n  .md\\:hover\\:-translate-y-2\\/12:hover {\n    --transform-translate-y: -16.66667%;\n  }\n  .md\\:hover\\:-translate-y-3\\/12:hover {\n    --transform-translate-y: -25%;\n  }\n  .md\\:hover\\:-translate-y-4\\/12:hover {\n    --transform-translate-y: -33.33333%;\n  }\n  .md\\:hover\\:-translate-y-5\\/12:hover {\n    --transform-translate-y: -41.66667%;\n  }\n  .md\\:hover\\:-translate-y-6\\/12:hover {\n    --transform-translate-y: -50%;\n  }\n  .md\\:hover\\:-translate-y-7\\/12:hover {\n    --transform-translate-y: -58.33333%;\n  }\n  .md\\:hover\\:-translate-y-8\\/12:hover {\n    --transform-translate-y: -66.66667%;\n  }\n  .md\\:hover\\:-translate-y-9\\/12:hover {\n    --transform-translate-y: -75%;\n  }\n  .md\\:hover\\:-translate-y-10\\/12:hover {\n    --transform-translate-y: -83.33333%;\n  }\n  .md\\:hover\\:-translate-y-11\\/12:hover {\n    --transform-translate-y: -91.66667%;\n  }\n  .md\\:hover\\:-translate-y-full:hover {\n    --transform-translate-y: -100%;\n  }\n  .md\\:focus\\:translate-x-0:focus {\n    --transform-translate-x: 0;\n  }\n  .md\\:focus\\:translate-x-1:focus {\n    --transform-translate-x: 0.25rem;\n  }\n  .md\\:focus\\:translate-x-2:focus {\n    --transform-translate-x: 0.5rem;\n  }\n  .md\\:focus\\:translate-x-3:focus {\n    --transform-translate-x: 0.75rem;\n  }\n  .md\\:focus\\:translate-x-4:focus {\n    --transform-translate-x: 1rem;\n  }\n  .md\\:focus\\:translate-x-5:focus {\n    --transform-translate-x: 1.25rem;\n  }\n  .md\\:focus\\:translate-x-6:focus {\n    --transform-translate-x: 1.5rem;\n  }\n  .md\\:focus\\:translate-x-7:focus {\n    --transform-translate-x: 1.75rem;\n  }\n  .md\\:focus\\:translate-x-8:focus {\n    --transform-translate-x: 2rem;\n  }\n  .md\\:focus\\:translate-x-9:focus {\n    --transform-translate-x: 2.25rem;\n  }\n  .md\\:focus\\:translate-x-10:focus {\n    --transform-translate-x: 2.5rem;\n  }\n  .md\\:focus\\:translate-x-11:focus {\n    --transform-translate-x: 2.75rem;\n  }\n  .md\\:focus\\:translate-x-12:focus {\n    --transform-translate-x: 3rem;\n  }\n  .md\\:focus\\:translate-x-13:focus {\n    --transform-translate-x: 3.25rem;\n  }\n  .md\\:focus\\:translate-x-14:focus {\n    --transform-translate-x: 3.5rem;\n  }\n  .md\\:focus\\:translate-x-15:focus {\n    --transform-translate-x: 3.75rem;\n  }\n  .md\\:focus\\:translate-x-16:focus {\n    --transform-translate-x: 4rem;\n  }\n  .md\\:focus\\:translate-x-20:focus {\n    --transform-translate-x: 5rem;\n  }\n  .md\\:focus\\:translate-x-24:focus {\n    --transform-translate-x: 6rem;\n  }\n  .md\\:focus\\:translate-x-28:focus {\n    --transform-translate-x: 7rem;\n  }\n  .md\\:focus\\:translate-x-32:focus {\n    --transform-translate-x: 8rem;\n  }\n  .md\\:focus\\:translate-x-36:focus {\n    --transform-translate-x: 9rem;\n  }\n  .md\\:focus\\:translate-x-40:focus {\n    --transform-translate-x: 10rem;\n  }\n  .md\\:focus\\:translate-x-44:focus {\n    --transform-translate-x: 11rem;\n  }\n  .md\\:focus\\:translate-x-48:focus {\n    --transform-translate-x: 12rem;\n  }\n  .md\\:focus\\:translate-x-52:focus {\n    --transform-translate-x: 13rem;\n  }\n  .md\\:focus\\:translate-x-56:focus {\n    --transform-translate-x: 14rem;\n  }\n  .md\\:focus\\:translate-x-60:focus {\n    --transform-translate-x: 15rem;\n  }\n  .md\\:focus\\:translate-x-64:focus {\n    --transform-translate-x: 16rem;\n  }\n  .md\\:focus\\:translate-x-72:focus {\n    --transform-translate-x: 18rem;\n  }\n  .md\\:focus\\:translate-x-80:focus {\n    --transform-translate-x: 20rem;\n  }\n  .md\\:focus\\:translate-x-96:focus {\n    --transform-translate-x: 24rem;\n  }\n  .md\\:focus\\:translate-x-px:focus {\n    --transform-translate-x: 1px;\n  }\n  .md\\:focus\\:translate-x-0\\.5:focus {\n    --transform-translate-x: 0.125rem;\n  }\n  .md\\:focus\\:translate-x-1\\.5:focus {\n    --transform-translate-x: 0.375rem;\n  }\n  .md\\:focus\\:translate-x-2\\.5:focus {\n    --transform-translate-x: 0.625rem;\n  }\n  .md\\:focus\\:translate-x-3\\.5:focus {\n    --transform-translate-x: 0.875rem;\n  }\n  .md\\:focus\\:translate-x-1\\/2:focus {\n    --transform-translate-x: 50%;\n  }\n  .md\\:focus\\:translate-x-1\\/3:focus {\n    --transform-translate-x: 33.333333%;\n  }\n  .md\\:focus\\:translate-x-2\\/3:focus {\n    --transform-translate-x: 66.666667%;\n  }\n  .md\\:focus\\:translate-x-1\\/4:focus {\n    --transform-translate-x: 25%;\n  }\n  .md\\:focus\\:translate-x-2\\/4:focus {\n    --transform-translate-x: 50%;\n  }\n  .md\\:focus\\:translate-x-3\\/4:focus {\n    --transform-translate-x: 75%;\n  }\n  .md\\:focus\\:translate-x-1\\/5:focus {\n    --transform-translate-x: 20%;\n  }\n  .md\\:focus\\:translate-x-2\\/5:focus {\n    --transform-translate-x: 40%;\n  }\n  .md\\:focus\\:translate-x-3\\/5:focus {\n    --transform-translate-x: 60%;\n  }\n  .md\\:focus\\:translate-x-4\\/5:focus {\n    --transform-translate-x: 80%;\n  }\n  .md\\:focus\\:translate-x-1\\/6:focus {\n    --transform-translate-x: 16.666667%;\n  }\n  .md\\:focus\\:translate-x-2\\/6:focus {\n    --transform-translate-x: 33.333333%;\n  }\n  .md\\:focus\\:translate-x-3\\/6:focus {\n    --transform-translate-x: 50%;\n  }\n  .md\\:focus\\:translate-x-4\\/6:focus {\n    --transform-translate-x: 66.666667%;\n  }\n  .md\\:focus\\:translate-x-5\\/6:focus {\n    --transform-translate-x: 83.333333%;\n  }\n  .md\\:focus\\:translate-x-1\\/12:focus {\n    --transform-translate-x: 8.333333%;\n  }\n  .md\\:focus\\:translate-x-2\\/12:focus {\n    --transform-translate-x: 16.666667%;\n  }\n  .md\\:focus\\:translate-x-3\\/12:focus {\n    --transform-translate-x: 25%;\n  }\n  .md\\:focus\\:translate-x-4\\/12:focus {\n    --transform-translate-x: 33.333333%;\n  }\n  .md\\:focus\\:translate-x-5\\/12:focus {\n    --transform-translate-x: 41.666667%;\n  }\n  .md\\:focus\\:translate-x-6\\/12:focus {\n    --transform-translate-x: 50%;\n  }\n  .md\\:focus\\:translate-x-7\\/12:focus {\n    --transform-translate-x: 58.333333%;\n  }\n  .md\\:focus\\:translate-x-8\\/12:focus {\n    --transform-translate-x: 66.666667%;\n  }\n  .md\\:focus\\:translate-x-9\\/12:focus {\n    --transform-translate-x: 75%;\n  }\n  .md\\:focus\\:translate-x-10\\/12:focus {\n    --transform-translate-x: 83.333333%;\n  }\n  .md\\:focus\\:translate-x-11\\/12:focus {\n    --transform-translate-x: 91.666667%;\n  }\n  .md\\:focus\\:translate-x-full:focus {\n    --transform-translate-x: 100%;\n  }\n  .md\\:focus\\:-translate-x-1:focus {\n    --transform-translate-x: -0.25rem;\n  }\n  .md\\:focus\\:-translate-x-2:focus {\n    --transform-translate-x: -0.5rem;\n  }\n  .md\\:focus\\:-translate-x-3:focus {\n    --transform-translate-x: -0.75rem;\n  }\n  .md\\:focus\\:-translate-x-4:focus {\n    --transform-translate-x: -1rem;\n  }\n  .md\\:focus\\:-translate-x-5:focus {\n    --transform-translate-x: -1.25rem;\n  }\n  .md\\:focus\\:-translate-x-6:focus {\n    --transform-translate-x: -1.5rem;\n  }\n  .md\\:focus\\:-translate-x-7:focus {\n    --transform-translate-x: -1.75rem;\n  }\n  .md\\:focus\\:-translate-x-8:focus {\n    --transform-translate-x: -2rem;\n  }\n  .md\\:focus\\:-translate-x-9:focus {\n    --transform-translate-x: -2.25rem;\n  }\n  .md\\:focus\\:-translate-x-10:focus {\n    --transform-translate-x: -2.5rem;\n  }\n  .md\\:focus\\:-translate-x-11:focus {\n    --transform-translate-x: -2.75rem;\n  }\n  .md\\:focus\\:-translate-x-12:focus {\n    --transform-translate-x: -3rem;\n  }\n  .md\\:focus\\:-translate-x-13:focus {\n    --transform-translate-x: -3.25rem;\n  }\n  .md\\:focus\\:-translate-x-14:focus {\n    --transform-translate-x: -3.5rem;\n  }\n  .md\\:focus\\:-translate-x-15:focus {\n    --transform-translate-x: -3.75rem;\n  }\n  .md\\:focus\\:-translate-x-16:focus {\n    --transform-translate-x: -4rem;\n  }\n  .md\\:focus\\:-translate-x-20:focus {\n    --transform-translate-x: -5rem;\n  }\n  .md\\:focus\\:-translate-x-24:focus {\n    --transform-translate-x: -6rem;\n  }\n  .md\\:focus\\:-translate-x-28:focus {\n    --transform-translate-x: -7rem;\n  }\n  .md\\:focus\\:-translate-x-32:focus {\n    --transform-translate-x: -8rem;\n  }\n  .md\\:focus\\:-translate-x-36:focus {\n    --transform-translate-x: -9rem;\n  }\n  .md\\:focus\\:-translate-x-40:focus {\n    --transform-translate-x: -10rem;\n  }\n  .md\\:focus\\:-translate-x-44:focus {\n    --transform-translate-x: -11rem;\n  }\n  .md\\:focus\\:-translate-x-48:focus {\n    --transform-translate-x: -12rem;\n  }\n  .md\\:focus\\:-translate-x-52:focus {\n    --transform-translate-x: -13rem;\n  }\n  .md\\:focus\\:-translate-x-56:focus {\n    --transform-translate-x: -14rem;\n  }\n  .md\\:focus\\:-translate-x-60:focus {\n    --transform-translate-x: -15rem;\n  }\n  .md\\:focus\\:-translate-x-64:focus {\n    --transform-translate-x: -16rem;\n  }\n  .md\\:focus\\:-translate-x-72:focus {\n    --transform-translate-x: -18rem;\n  }\n  .md\\:focus\\:-translate-x-80:focus {\n    --transform-translate-x: -20rem;\n  }\n  .md\\:focus\\:-translate-x-96:focus {\n    --transform-translate-x: -24rem;\n  }\n  .md\\:focus\\:-translate-x-px:focus {\n    --transform-translate-x: -1px;\n  }\n  .md\\:focus\\:-translate-x-0\\.5:focus {\n    --transform-translate-x: -0.125rem;\n  }\n  .md\\:focus\\:-translate-x-1\\.5:focus {\n    --transform-translate-x: -0.375rem;\n  }\n  .md\\:focus\\:-translate-x-2\\.5:focus {\n    --transform-translate-x: -0.625rem;\n  }\n  .md\\:focus\\:-translate-x-3\\.5:focus {\n    --transform-translate-x: -0.875rem;\n  }\n  .md\\:focus\\:-translate-x-1\\/2:focus {\n    --transform-translate-x: -50%;\n  }\n  .md\\:focus\\:-translate-x-1\\/3:focus {\n    --transform-translate-x: -33.33333%;\n  }\n  .md\\:focus\\:-translate-x-2\\/3:focus {\n    --transform-translate-x: -66.66667%;\n  }\n  .md\\:focus\\:-translate-x-1\\/4:focus {\n    --transform-translate-x: -25%;\n  }\n  .md\\:focus\\:-translate-x-2\\/4:focus {\n    --transform-translate-x: -50%;\n  }\n  .md\\:focus\\:-translate-x-3\\/4:focus {\n    --transform-translate-x: -75%;\n  }\n  .md\\:focus\\:-translate-x-1\\/5:focus {\n    --transform-translate-x: -20%;\n  }\n  .md\\:focus\\:-translate-x-2\\/5:focus {\n    --transform-translate-x: -40%;\n  }\n  .md\\:focus\\:-translate-x-3\\/5:focus {\n    --transform-translate-x: -60%;\n  }\n  .md\\:focus\\:-translate-x-4\\/5:focus {\n    --transform-translate-x: -80%;\n  }\n  .md\\:focus\\:-translate-x-1\\/6:focus {\n    --transform-translate-x: -16.66667%;\n  }\n  .md\\:focus\\:-translate-x-2\\/6:focus {\n    --transform-translate-x: -33.33333%;\n  }\n  .md\\:focus\\:-translate-x-3\\/6:focus {\n    --transform-translate-x: -50%;\n  }\n  .md\\:focus\\:-translate-x-4\\/6:focus {\n    --transform-translate-x: -66.66667%;\n  }\n  .md\\:focus\\:-translate-x-5\\/6:focus {\n    --transform-translate-x: -83.33333%;\n  }\n  .md\\:focus\\:-translate-x-1\\/12:focus {\n    --transform-translate-x: -8.33333%;\n  }\n  .md\\:focus\\:-translate-x-2\\/12:focus {\n    --transform-translate-x: -16.66667%;\n  }\n  .md\\:focus\\:-translate-x-3\\/12:focus {\n    --transform-translate-x: -25%;\n  }\n  .md\\:focus\\:-translate-x-4\\/12:focus {\n    --transform-translate-x: -33.33333%;\n  }\n  .md\\:focus\\:-translate-x-5\\/12:focus {\n    --transform-translate-x: -41.66667%;\n  }\n  .md\\:focus\\:-translate-x-6\\/12:focus {\n    --transform-translate-x: -50%;\n  }\n  .md\\:focus\\:-translate-x-7\\/12:focus {\n    --transform-translate-x: -58.33333%;\n  }\n  .md\\:focus\\:-translate-x-8\\/12:focus {\n    --transform-translate-x: -66.66667%;\n  }\n  .md\\:focus\\:-translate-x-9\\/12:focus {\n    --transform-translate-x: -75%;\n  }\n  .md\\:focus\\:-translate-x-10\\/12:focus {\n    --transform-translate-x: -83.33333%;\n  }\n  .md\\:focus\\:-translate-x-11\\/12:focus {\n    --transform-translate-x: -91.66667%;\n  }\n  .md\\:focus\\:-translate-x-full:focus {\n    --transform-translate-x: -100%;\n  }\n  .md\\:focus\\:translate-y-0:focus {\n    --transform-translate-y: 0;\n  }\n  .md\\:focus\\:translate-y-1:focus {\n    --transform-translate-y: 0.25rem;\n  }\n  .md\\:focus\\:translate-y-2:focus {\n    --transform-translate-y: 0.5rem;\n  }\n  .md\\:focus\\:translate-y-3:focus {\n    --transform-translate-y: 0.75rem;\n  }\n  .md\\:focus\\:translate-y-4:focus {\n    --transform-translate-y: 1rem;\n  }\n  .md\\:focus\\:translate-y-5:focus {\n    --transform-translate-y: 1.25rem;\n  }\n  .md\\:focus\\:translate-y-6:focus {\n    --transform-translate-y: 1.5rem;\n  }\n  .md\\:focus\\:translate-y-7:focus {\n    --transform-translate-y: 1.75rem;\n  }\n  .md\\:focus\\:translate-y-8:focus {\n    --transform-translate-y: 2rem;\n  }\n  .md\\:focus\\:translate-y-9:focus {\n    --transform-translate-y: 2.25rem;\n  }\n  .md\\:focus\\:translate-y-10:focus {\n    --transform-translate-y: 2.5rem;\n  }\n  .md\\:focus\\:translate-y-11:focus {\n    --transform-translate-y: 2.75rem;\n  }\n  .md\\:focus\\:translate-y-12:focus {\n    --transform-translate-y: 3rem;\n  }\n  .md\\:focus\\:translate-y-13:focus {\n    --transform-translate-y: 3.25rem;\n  }\n  .md\\:focus\\:translate-y-14:focus {\n    --transform-translate-y: 3.5rem;\n  }\n  .md\\:focus\\:translate-y-15:focus {\n    --transform-translate-y: 3.75rem;\n  }\n  .md\\:focus\\:translate-y-16:focus {\n    --transform-translate-y: 4rem;\n  }\n  .md\\:focus\\:translate-y-20:focus {\n    --transform-translate-y: 5rem;\n  }\n  .md\\:focus\\:translate-y-24:focus {\n    --transform-translate-y: 6rem;\n  }\n  .md\\:focus\\:translate-y-28:focus {\n    --transform-translate-y: 7rem;\n  }\n  .md\\:focus\\:translate-y-32:focus {\n    --transform-translate-y: 8rem;\n  }\n  .md\\:focus\\:translate-y-36:focus {\n    --transform-translate-y: 9rem;\n  }\n  .md\\:focus\\:translate-y-40:focus {\n    --transform-translate-y: 10rem;\n  }\n  .md\\:focus\\:translate-y-44:focus {\n    --transform-translate-y: 11rem;\n  }\n  .md\\:focus\\:translate-y-48:focus {\n    --transform-translate-y: 12rem;\n  }\n  .md\\:focus\\:translate-y-52:focus {\n    --transform-translate-y: 13rem;\n  }\n  .md\\:focus\\:translate-y-56:focus {\n    --transform-translate-y: 14rem;\n  }\n  .md\\:focus\\:translate-y-60:focus {\n    --transform-translate-y: 15rem;\n  }\n  .md\\:focus\\:translate-y-64:focus {\n    --transform-translate-y: 16rem;\n  }\n  .md\\:focus\\:translate-y-72:focus {\n    --transform-translate-y: 18rem;\n  }\n  .md\\:focus\\:translate-y-80:focus {\n    --transform-translate-y: 20rem;\n  }\n  .md\\:focus\\:translate-y-96:focus {\n    --transform-translate-y: 24rem;\n  }\n  .md\\:focus\\:translate-y-px:focus {\n    --transform-translate-y: 1px;\n  }\n  .md\\:focus\\:translate-y-0\\.5:focus {\n    --transform-translate-y: 0.125rem;\n  }\n  .md\\:focus\\:translate-y-1\\.5:focus {\n    --transform-translate-y: 0.375rem;\n  }\n  .md\\:focus\\:translate-y-2\\.5:focus {\n    --transform-translate-y: 0.625rem;\n  }\n  .md\\:focus\\:translate-y-3\\.5:focus {\n    --transform-translate-y: 0.875rem;\n  }\n  .md\\:focus\\:translate-y-1\\/2:focus {\n    --transform-translate-y: 50%;\n  }\n  .md\\:focus\\:translate-y-1\\/3:focus {\n    --transform-translate-y: 33.333333%;\n  }\n  .md\\:focus\\:translate-y-2\\/3:focus {\n    --transform-translate-y: 66.666667%;\n  }\n  .md\\:focus\\:translate-y-1\\/4:focus {\n    --transform-translate-y: 25%;\n  }\n  .md\\:focus\\:translate-y-2\\/4:focus {\n    --transform-translate-y: 50%;\n  }\n  .md\\:focus\\:translate-y-3\\/4:focus {\n    --transform-translate-y: 75%;\n  }\n  .md\\:focus\\:translate-y-1\\/5:focus {\n    --transform-translate-y: 20%;\n  }\n  .md\\:focus\\:translate-y-2\\/5:focus {\n    --transform-translate-y: 40%;\n  }\n  .md\\:focus\\:translate-y-3\\/5:focus {\n    --transform-translate-y: 60%;\n  }\n  .md\\:focus\\:translate-y-4\\/5:focus {\n    --transform-translate-y: 80%;\n  }\n  .md\\:focus\\:translate-y-1\\/6:focus {\n    --transform-translate-y: 16.666667%;\n  }\n  .md\\:focus\\:translate-y-2\\/6:focus {\n    --transform-translate-y: 33.333333%;\n  }\n  .md\\:focus\\:translate-y-3\\/6:focus {\n    --transform-translate-y: 50%;\n  }\n  .md\\:focus\\:translate-y-4\\/6:focus {\n    --transform-translate-y: 66.666667%;\n  }\n  .md\\:focus\\:translate-y-5\\/6:focus {\n    --transform-translate-y: 83.333333%;\n  }\n  .md\\:focus\\:translate-y-1\\/12:focus {\n    --transform-translate-y: 8.333333%;\n  }\n  .md\\:focus\\:translate-y-2\\/12:focus {\n    --transform-translate-y: 16.666667%;\n  }\n  .md\\:focus\\:translate-y-3\\/12:focus {\n    --transform-translate-y: 25%;\n  }\n  .md\\:focus\\:translate-y-4\\/12:focus {\n    --transform-translate-y: 33.333333%;\n  }\n  .md\\:focus\\:translate-y-5\\/12:focus {\n    --transform-translate-y: 41.666667%;\n  }\n  .md\\:focus\\:translate-y-6\\/12:focus {\n    --transform-translate-y: 50%;\n  }\n  .md\\:focus\\:translate-y-7\\/12:focus {\n    --transform-translate-y: 58.333333%;\n  }\n  .md\\:focus\\:translate-y-8\\/12:focus {\n    --transform-translate-y: 66.666667%;\n  }\n  .md\\:focus\\:translate-y-9\\/12:focus {\n    --transform-translate-y: 75%;\n  }\n  .md\\:focus\\:translate-y-10\\/12:focus {\n    --transform-translate-y: 83.333333%;\n  }\n  .md\\:focus\\:translate-y-11\\/12:focus {\n    --transform-translate-y: 91.666667%;\n  }\n  .md\\:focus\\:translate-y-full:focus {\n    --transform-translate-y: 100%;\n  }\n  .md\\:focus\\:-translate-y-1:focus {\n    --transform-translate-y: -0.25rem;\n  }\n  .md\\:focus\\:-translate-y-2:focus {\n    --transform-translate-y: -0.5rem;\n  }\n  .md\\:focus\\:-translate-y-3:focus {\n    --transform-translate-y: -0.75rem;\n  }\n  .md\\:focus\\:-translate-y-4:focus {\n    --transform-translate-y: -1rem;\n  }\n  .md\\:focus\\:-translate-y-5:focus {\n    --transform-translate-y: -1.25rem;\n  }\n  .md\\:focus\\:-translate-y-6:focus {\n    --transform-translate-y: -1.5rem;\n  }\n  .md\\:focus\\:-translate-y-7:focus {\n    --transform-translate-y: -1.75rem;\n  }\n  .md\\:focus\\:-translate-y-8:focus {\n    --transform-translate-y: -2rem;\n  }\n  .md\\:focus\\:-translate-y-9:focus {\n    --transform-translate-y: -2.25rem;\n  }\n  .md\\:focus\\:-translate-y-10:focus {\n    --transform-translate-y: -2.5rem;\n  }\n  .md\\:focus\\:-translate-y-11:focus {\n    --transform-translate-y: -2.75rem;\n  }\n  .md\\:focus\\:-translate-y-12:focus {\n    --transform-translate-y: -3rem;\n  }\n  .md\\:focus\\:-translate-y-13:focus {\n    --transform-translate-y: -3.25rem;\n  }\n  .md\\:focus\\:-translate-y-14:focus {\n    --transform-translate-y: -3.5rem;\n  }\n  .md\\:focus\\:-translate-y-15:focus {\n    --transform-translate-y: -3.75rem;\n  }\n  .md\\:focus\\:-translate-y-16:focus {\n    --transform-translate-y: -4rem;\n  }\n  .md\\:focus\\:-translate-y-20:focus {\n    --transform-translate-y: -5rem;\n  }\n  .md\\:focus\\:-translate-y-24:focus {\n    --transform-translate-y: -6rem;\n  }\n  .md\\:focus\\:-translate-y-28:focus {\n    --transform-translate-y: -7rem;\n  }\n  .md\\:focus\\:-translate-y-32:focus {\n    --transform-translate-y: -8rem;\n  }\n  .md\\:focus\\:-translate-y-36:focus {\n    --transform-translate-y: -9rem;\n  }\n  .md\\:focus\\:-translate-y-40:focus {\n    --transform-translate-y: -10rem;\n  }\n  .md\\:focus\\:-translate-y-44:focus {\n    --transform-translate-y: -11rem;\n  }\n  .md\\:focus\\:-translate-y-48:focus {\n    --transform-translate-y: -12rem;\n  }\n  .md\\:focus\\:-translate-y-52:focus {\n    --transform-translate-y: -13rem;\n  }\n  .md\\:focus\\:-translate-y-56:focus {\n    --transform-translate-y: -14rem;\n  }\n  .md\\:focus\\:-translate-y-60:focus {\n    --transform-translate-y: -15rem;\n  }\n  .md\\:focus\\:-translate-y-64:focus {\n    --transform-translate-y: -16rem;\n  }\n  .md\\:focus\\:-translate-y-72:focus {\n    --transform-translate-y: -18rem;\n  }\n  .md\\:focus\\:-translate-y-80:focus {\n    --transform-translate-y: -20rem;\n  }\n  .md\\:focus\\:-translate-y-96:focus {\n    --transform-translate-y: -24rem;\n  }\n  .md\\:focus\\:-translate-y-px:focus {\n    --transform-translate-y: -1px;\n  }\n  .md\\:focus\\:-translate-y-0\\.5:focus {\n    --transform-translate-y: -0.125rem;\n  }\n  .md\\:focus\\:-translate-y-1\\.5:focus {\n    --transform-translate-y: -0.375rem;\n  }\n  .md\\:focus\\:-translate-y-2\\.5:focus {\n    --transform-translate-y: -0.625rem;\n  }\n  .md\\:focus\\:-translate-y-3\\.5:focus {\n    --transform-translate-y: -0.875rem;\n  }\n  .md\\:focus\\:-translate-y-1\\/2:focus {\n    --transform-translate-y: -50%;\n  }\n  .md\\:focus\\:-translate-y-1\\/3:focus {\n    --transform-translate-y: -33.33333%;\n  }\n  .md\\:focus\\:-translate-y-2\\/3:focus {\n    --transform-translate-y: -66.66667%;\n  }\n  .md\\:focus\\:-translate-y-1\\/4:focus {\n    --transform-translate-y: -25%;\n  }\n  .md\\:focus\\:-translate-y-2\\/4:focus {\n    --transform-translate-y: -50%;\n  }\n  .md\\:focus\\:-translate-y-3\\/4:focus {\n    --transform-translate-y: -75%;\n  }\n  .md\\:focus\\:-translate-y-1\\/5:focus {\n    --transform-translate-y: -20%;\n  }\n  .md\\:focus\\:-translate-y-2\\/5:focus {\n    --transform-translate-y: -40%;\n  }\n  .md\\:focus\\:-translate-y-3\\/5:focus {\n    --transform-translate-y: -60%;\n  }\n  .md\\:focus\\:-translate-y-4\\/5:focus {\n    --transform-translate-y: -80%;\n  }\n  .md\\:focus\\:-translate-y-1\\/6:focus {\n    --transform-translate-y: -16.66667%;\n  }\n  .md\\:focus\\:-translate-y-2\\/6:focus {\n    --transform-translate-y: -33.33333%;\n  }\n  .md\\:focus\\:-translate-y-3\\/6:focus {\n    --transform-translate-y: -50%;\n  }\n  .md\\:focus\\:-translate-y-4\\/6:focus {\n    --transform-translate-y: -66.66667%;\n  }\n  .md\\:focus\\:-translate-y-5\\/6:focus {\n    --transform-translate-y: -83.33333%;\n  }\n  .md\\:focus\\:-translate-y-1\\/12:focus {\n    --transform-translate-y: -8.33333%;\n  }\n  .md\\:focus\\:-translate-y-2\\/12:focus {\n    --transform-translate-y: -16.66667%;\n  }\n  .md\\:focus\\:-translate-y-3\\/12:focus {\n    --transform-translate-y: -25%;\n  }\n  .md\\:focus\\:-translate-y-4\\/12:focus {\n    --transform-translate-y: -33.33333%;\n  }\n  .md\\:focus\\:-translate-y-5\\/12:focus {\n    --transform-translate-y: -41.66667%;\n  }\n  .md\\:focus\\:-translate-y-6\\/12:focus {\n    --transform-translate-y: -50%;\n  }\n  .md\\:focus\\:-translate-y-7\\/12:focus {\n    --transform-translate-y: -58.33333%;\n  }\n  .md\\:focus\\:-translate-y-8\\/12:focus {\n    --transform-translate-y: -66.66667%;\n  }\n  .md\\:focus\\:-translate-y-9\\/12:focus {\n    --transform-translate-y: -75%;\n  }\n  .md\\:focus\\:-translate-y-10\\/12:focus {\n    --transform-translate-y: -83.33333%;\n  }\n  .md\\:focus\\:-translate-y-11\\/12:focus {\n    --transform-translate-y: -91.66667%;\n  }\n  .md\\:focus\\:-translate-y-full:focus {\n    --transform-translate-y: -100%;\n  }\n  .md\\:skew-x-0 {\n    --transform-skew-x: 0;\n  }\n  .md\\:skew-x-1 {\n    --transform-skew-x: 1deg;\n  }\n  .md\\:skew-x-2 {\n    --transform-skew-x: 2deg;\n  }\n  .md\\:skew-x-3 {\n    --transform-skew-x: 3deg;\n  }\n  .md\\:skew-x-6 {\n    --transform-skew-x: 6deg;\n  }\n  .md\\:skew-x-12 {\n    --transform-skew-x: 12deg;\n  }\n  .md\\:-skew-x-12 {\n    --transform-skew-x: -12deg;\n  }\n  .md\\:-skew-x-6 {\n    --transform-skew-x: -6deg;\n  }\n  .md\\:-skew-x-3 {\n    --transform-skew-x: -3deg;\n  }\n  .md\\:-skew-x-2 {\n    --transform-skew-x: -2deg;\n  }\n  .md\\:-skew-x-1 {\n    --transform-skew-x: -1deg;\n  }\n  .md\\:skew-y-0 {\n    --transform-skew-y: 0;\n  }\n  .md\\:skew-y-1 {\n    --transform-skew-y: 1deg;\n  }\n  .md\\:skew-y-2 {\n    --transform-skew-y: 2deg;\n  }\n  .md\\:skew-y-3 {\n    --transform-skew-y: 3deg;\n  }\n  .md\\:skew-y-6 {\n    --transform-skew-y: 6deg;\n  }\n  .md\\:skew-y-12 {\n    --transform-skew-y: 12deg;\n  }\n  .md\\:-skew-y-12 {\n    --transform-skew-y: -12deg;\n  }\n  .md\\:-skew-y-6 {\n    --transform-skew-y: -6deg;\n  }\n  .md\\:-skew-y-3 {\n    --transform-skew-y: -3deg;\n  }\n  .md\\:-skew-y-2 {\n    --transform-skew-y: -2deg;\n  }\n  .md\\:-skew-y-1 {\n    --transform-skew-y: -1deg;\n  }\n  .md\\:hover\\:skew-x-0:hover {\n    --transform-skew-x: 0;\n  }\n  .md\\:hover\\:skew-x-1:hover {\n    --transform-skew-x: 1deg;\n  }\n  .md\\:hover\\:skew-x-2:hover {\n    --transform-skew-x: 2deg;\n  }\n  .md\\:hover\\:skew-x-3:hover {\n    --transform-skew-x: 3deg;\n  }\n  .md\\:hover\\:skew-x-6:hover {\n    --transform-skew-x: 6deg;\n  }\n  .md\\:hover\\:skew-x-12:hover {\n    --transform-skew-x: 12deg;\n  }\n  .md\\:hover\\:-skew-x-12:hover {\n    --transform-skew-x: -12deg;\n  }\n  .md\\:hover\\:-skew-x-6:hover {\n    --transform-skew-x: -6deg;\n  }\n  .md\\:hover\\:-skew-x-3:hover {\n    --transform-skew-x: -3deg;\n  }\n  .md\\:hover\\:-skew-x-2:hover {\n    --transform-skew-x: -2deg;\n  }\n  .md\\:hover\\:-skew-x-1:hover {\n    --transform-skew-x: -1deg;\n  }\n  .md\\:hover\\:skew-y-0:hover {\n    --transform-skew-y: 0;\n  }\n  .md\\:hover\\:skew-y-1:hover {\n    --transform-skew-y: 1deg;\n  }\n  .md\\:hover\\:skew-y-2:hover {\n    --transform-skew-y: 2deg;\n  }\n  .md\\:hover\\:skew-y-3:hover {\n    --transform-skew-y: 3deg;\n  }\n  .md\\:hover\\:skew-y-6:hover {\n    --transform-skew-y: 6deg;\n  }\n  .md\\:hover\\:skew-y-12:hover {\n    --transform-skew-y: 12deg;\n  }\n  .md\\:hover\\:-skew-y-12:hover {\n    --transform-skew-y: -12deg;\n  }\n  .md\\:hover\\:-skew-y-6:hover {\n    --transform-skew-y: -6deg;\n  }\n  .md\\:hover\\:-skew-y-3:hover {\n    --transform-skew-y: -3deg;\n  }\n  .md\\:hover\\:-skew-y-2:hover {\n    --transform-skew-y: -2deg;\n  }\n  .md\\:hover\\:-skew-y-1:hover {\n    --transform-skew-y: -1deg;\n  }\n  .md\\:focus\\:skew-x-0:focus {\n    --transform-skew-x: 0;\n  }\n  .md\\:focus\\:skew-x-1:focus {\n    --transform-skew-x: 1deg;\n  }\n  .md\\:focus\\:skew-x-2:focus {\n    --transform-skew-x: 2deg;\n  }\n  .md\\:focus\\:skew-x-3:focus {\n    --transform-skew-x: 3deg;\n  }\n  .md\\:focus\\:skew-x-6:focus {\n    --transform-skew-x: 6deg;\n  }\n  .md\\:focus\\:skew-x-12:focus {\n    --transform-skew-x: 12deg;\n  }\n  .md\\:focus\\:-skew-x-12:focus {\n    --transform-skew-x: -12deg;\n  }\n  .md\\:focus\\:-skew-x-6:focus {\n    --transform-skew-x: -6deg;\n  }\n  .md\\:focus\\:-skew-x-3:focus {\n    --transform-skew-x: -3deg;\n  }\n  .md\\:focus\\:-skew-x-2:focus {\n    --transform-skew-x: -2deg;\n  }\n  .md\\:focus\\:-skew-x-1:focus {\n    --transform-skew-x: -1deg;\n  }\n  .md\\:focus\\:skew-y-0:focus {\n    --transform-skew-y: 0;\n  }\n  .md\\:focus\\:skew-y-1:focus {\n    --transform-skew-y: 1deg;\n  }\n  .md\\:focus\\:skew-y-2:focus {\n    --transform-skew-y: 2deg;\n  }\n  .md\\:focus\\:skew-y-3:focus {\n    --transform-skew-y: 3deg;\n  }\n  .md\\:focus\\:skew-y-6:focus {\n    --transform-skew-y: 6deg;\n  }\n  .md\\:focus\\:skew-y-12:focus {\n    --transform-skew-y: 12deg;\n  }\n  .md\\:focus\\:-skew-y-12:focus {\n    --transform-skew-y: -12deg;\n  }\n  .md\\:focus\\:-skew-y-6:focus {\n    --transform-skew-y: -6deg;\n  }\n  .md\\:focus\\:-skew-y-3:focus {\n    --transform-skew-y: -3deg;\n  }\n  .md\\:focus\\:-skew-y-2:focus {\n    --transform-skew-y: -2deg;\n  }\n  .md\\:focus\\:-skew-y-1:focus {\n    --transform-skew-y: -1deg;\n  }\n  .md\\:transition-none {\n    transition-property: none;\n  }\n  .md\\:transition-all {\n    transition-property: all;\n  }\n  .md\\:transition {\n    transition-property: background-color, border-color, color, fill, stroke, opacity, box-shadow, transform;\n  }\n  .md\\:transition-colors {\n    transition-property: background-color, border-color, color, fill, stroke;\n  }\n  .md\\:transition-opacity {\n    transition-property: opacity;\n  }\n  .md\\:transition-shadow {\n    transition-property: box-shadow;\n  }\n  .md\\:transition-transform {\n    transition-property: transform;\n  }\n  .md\\:ease-linear {\n    transition-timing-function: linear;\n  }\n  .md\\:ease-in {\n    transition-timing-function: cubic-bezier(0.4, 0, 1, 1);\n  }\n  .md\\:ease-out {\n    transition-timing-function: cubic-bezier(0, 0, 0.2, 1);\n  }\n  .md\\:ease-in-out {\n    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n  }\n  .md\\:duration-75 {\n    transition-duration: 75ms;\n  }\n  .md\\:duration-100 {\n    transition-duration: 100ms;\n  }\n  .md\\:duration-150 {\n    transition-duration: 150ms;\n  }\n  .md\\:duration-200 {\n    transition-duration: 200ms;\n  }\n  .md\\:duration-300 {\n    transition-duration: 300ms;\n  }\n  .md\\:duration-500 {\n    transition-duration: 500ms;\n  }\n  .md\\:duration-700 {\n    transition-duration: 700ms;\n  }\n  .md\\:duration-1000 {\n    transition-duration: 1000ms;\n  }\n  .md\\:delay-75 {\n    transition-delay: 75ms;\n  }\n  .md\\:delay-100 {\n    transition-delay: 100ms;\n  }\n  .md\\:delay-150 {\n    transition-delay: 150ms;\n  }\n  .md\\:delay-200 {\n    transition-delay: 200ms;\n  }\n  .md\\:delay-300 {\n    transition-delay: 300ms;\n  }\n  .md\\:delay-500 {\n    transition-delay: 500ms;\n  }\n  .md\\:delay-700 {\n    transition-delay: 700ms;\n  }\n  .md\\:delay-1000 {\n    transition-delay: 1000ms;\n  }\n  .md\\:animate-none {\n    animation: none;\n  }\n  .md\\:animate-spin {\n    animation: spin 1s linear infinite;\n  }\n  .md\\:animate-ping {\n    animation: ping 1s cubic-bezier(0, 0, 0.2, 1) infinite;\n  }\n  .md\\:animate-pulse {\n    animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;\n  }\n  .md\\:animate-bounce {\n    animation: bounce 1s infinite;\n  }\n}\n@media (min-width: 1024px) {\n  .lg\\:container {\n    width: 100%;\n  }\n  @media (min-width: 640px) {\n    .lg\\:container {\n      max-width: 640px;\n    }\n  }\n  @media (min-width: 768px) {\n    .lg\\:container {\n      max-width: 768px;\n    }\n  }\n  @media (min-width: 1024px) {\n    .lg\\:container {\n      max-width: 1024px;\n    }\n  }\n  @media (min-width: 1280px) {\n    .lg\\:container {\n      max-width: 1280px;\n    }\n  }\n  .lg\\:prose {\n    color: #374151;\n    max-width: 65ch;\n  }\n  .lg\\:prose [class~=\"lead\"] {\n    color: #4b5563;\n    font-size: 1.25em;\n    line-height: 1.6;\n    margin-top: 1.2em;\n    margin-bottom: 1.2em;\n  }\n  .lg\\:prose a {\n    color: #5850ec;\n    text-decoration: none;\n    font-weight: 600;\n  }\n  .lg\\:prose strong {\n    color: #161e2e;\n    font-weight: 600;\n  }\n  .lg\\:prose ol {\n    counter-reset: list-counter;\n    margin-top: 1.25em;\n    margin-bottom: 1.25em;\n  }\n  .lg\\:prose ol>li {\n    position: relative;\n    counter-increment: list-counter;\n    padding-left: 1.75em;\n  }\n  .lg\\:prose ol>li::before {\n    content: counter(list-counter) \".\";\n    position: absolute;\n    font-weight: 400;\n    color: #6b7280;\n  }\n  .lg\\:prose ul>li {\n    position: relative;\n    padding-left: 1.75em;\n  }\n  .lg\\:prose ul>li::before {\n    content: \"\";\n    position: absolute;\n    background-color: #d2d6dc;\n    border-radius: 50%;\n    width: 0.375em;\n    height: 0.375em;\n    top: calc(0.875em - 0.1875em);\n    left: 0.25em;\n  }\n  .lg\\:prose hr {\n    border-color: #e5e7eb;\n    border-top-width: 1px;\n    margin-top: 3em;\n    margin-bottom: 3em;\n  }\n  .lg\\:prose blockquote {\n    font-weight: 500;\n    font-style: italic;\n    color: #161e2e;\n    border-left-width: 0.25rem;\n    border-left-color: #e5e7eb;\n    quotes: \"\\201C\" \"\\201D\" \"\\2018\" \"\\2019\";\n    margin-top: 1.6em;\n    margin-bottom: 1.6em;\n    padding-left: 1em;\n  }\n  .lg\\:prose blockquote p:first-of-type::before {\n    content: open-quote;\n  }\n  .lg\\:prose blockquote p:last-of-type::after {\n    content: close-quote;\n  }\n  .lg\\:prose h1 {\n    color: #1a202c;\n    font-weight: 800;\n    font-size: 2.25em;\n    margin-top: 0;\n    margin-bottom: 0.8888889em;\n    line-height: 1.1111111;\n  }\n  .lg\\:prose h2 {\n    color: #1a202c;\n    font-weight: 700;\n    font-size: 1.5em;\n    margin-top: 2em;\n    margin-bottom: 1em;\n    line-height: 1.3333333;\n  }\n  .lg\\:prose h3 {\n    color: #1a202c;\n    font-weight: 600;\n    font-size: 1.25em;\n    margin-top: 1.6em;\n    margin-bottom: 0.6em;\n    line-height: 1.6;\n  }\n  .lg\\:prose h4 {\n    color: #1a202c;\n    font-weight: 600;\n    margin-top: 1.5em;\n    margin-bottom: 0.5em;\n    line-height: 1.5;\n  }\n  .lg\\:prose figure figcaption {\n    color: #6b7280;\n    font-size: 0.875em;\n    line-height: 1.4285714;\n    margin-top: 0.8571429em;\n  }\n  .lg\\:prose code {\n    color: #161e2e;\n    font-weight: 600;\n    font-size: 0.875em;\n  }\n  .lg\\:prose code::before {\n    content: \"`\";\n  }\n  .lg\\:prose code::after {\n    content: \"`\";\n  }\n  .lg\\:prose pre {\n    color: #e5e7eb;\n    background-color: #252f3f;\n    overflow-x: auto;\n    font-size: 0.875em;\n    line-height: 1.7142857;\n    margin-top: 1.7142857em;\n    margin-bottom: 1.7142857em;\n    border-radius: 0.375rem;\n    padding-top: 0.8571429em;\n    padding-right: 1.1428571em;\n    padding-bottom: 0.8571429em;\n    padding-left: 1.1428571em;\n  }\n  .lg\\:prose pre code {\n    background-color: transparent;\n    border-width: 0;\n    border-radius: 0;\n    padding: 0;\n    font-weight: 400;\n    color: inherit;\n    font-size: inherit;\n    font-family: inherit;\n    line-height: inherit;\n  }\n  .lg\\:prose pre code::before {\n    content: \"\";\n  }\n  .lg\\:prose pre code::after {\n    content: \"\";\n  }\n  .lg\\:prose table {\n    width: 100%;\n    table-layout: auto;\n    text-align: left;\n    margin-top: 2em;\n    margin-bottom: 2em;\n    font-size: 0.875em;\n    line-height: 1.7142857;\n  }\n  .lg\\:prose thead {\n    color: #161e2e;\n    font-weight: 600;\n    border-bottom-width: 1px;\n    border-bottom-color: #d2d6dc;\n  }\n  .lg\\:prose thead th {\n    vertical-align: bottom;\n    padding-right: 0.5714286em;\n    padding-bottom: 0.5714286em;\n    padding-left: 0.5714286em;\n  }\n  .lg\\:prose tbody tr {\n    border-bottom-width: 1px;\n    border-bottom-color: #e5e7eb;\n  }\n  .lg\\:prose tbody tr:last-child {\n    border-bottom-width: 0;\n  }\n  .lg\\:prose tbody td {\n    vertical-align: top;\n    padding-top: 0.5714286em;\n    padding-right: 0.5714286em;\n    padding-bottom: 0.5714286em;\n    padding-left: 0.5714286em;\n  }\n  .lg\\:prose {\n    font-size: 1rem;\n    line-height: 1.75;\n  }\n  .lg\\:prose p {\n    margin-top: 1.25em;\n    margin-bottom: 1.25em;\n  }\n  .lg\\:prose img {\n    margin-top: 2em;\n    margin-bottom: 2em;\n  }\n  .lg\\:prose video {\n    margin-top: 2em;\n    margin-bottom: 2em;\n  }\n  .lg\\:prose figure {\n    margin-top: 2em;\n    margin-bottom: 2em;\n  }\n  .lg\\:prose figure>* {\n    margin-top: 0;\n    margin-bottom: 0;\n  }\n  .lg\\:prose h2 code {\n    font-size: 0.875em;\n  }\n  .lg\\:prose h3 code {\n    font-size: 0.9em;\n  }\n  .lg\\:prose ul {\n    margin-top: 1.25em;\n    margin-bottom: 1.25em;\n  }\n  .lg\\:prose li {\n    margin-top: 0.5em;\n    margin-bottom: 0.5em;\n  }\n  .lg\\:prose ol>li:before {\n    left: 0;\n  }\n  .lg\\:prose>ul>li p {\n    margin-top: 0.75em;\n    margin-bottom: 0.75em;\n  }\n  .lg\\:prose>ul>li>*:first-child {\n    margin-top: 1.25em;\n  }\n  .lg\\:prose>ul>li>*:last-child {\n    margin-bottom: 1.25em;\n  }\n  .lg\\:prose>ol>li>*:first-child {\n    margin-top: 1.25em;\n  }\n  .lg\\:prose>ol>li>*:last-child {\n    margin-bottom: 1.25em;\n  }\n  .lg\\:prose ul ul, .lg\\:prose ul ol, .lg\\:prose ol ul, .lg\\:prose ol ol {\n    margin-top: 0.75em;\n    margin-bottom: 0.75em;\n  }\n  .lg\\:prose hr+* {\n    margin-top: 0;\n  }\n  .lg\\:prose h2+* {\n    margin-top: 0;\n  }\n  .lg\\:prose h3+* {\n    margin-top: 0;\n  }\n  .lg\\:prose h4+* {\n    margin-top: 0;\n  }\n  .lg\\:prose thead th:first-child {\n    padding-left: 0;\n  }\n  .lg\\:prose thead th:last-child {\n    padding-right: 0;\n  }\n  .lg\\:prose tbody td:first-child {\n    padding-left: 0;\n  }\n  .lg\\:prose tbody td:last-child {\n    padding-right: 0;\n  }\n  .lg\\:prose> :first-child {\n    margin-top: 0;\n  }\n  .lg\\:prose> :last-child {\n    margin-bottom: 0;\n  }\n  .lg\\:prose h1, .lg\\:prose h2, .lg\\:prose h3, .lg\\:prose h4 {\n    color: #161e2e;\n  }\n  .lg\\:prose-sm {\n    font-size: 0.875rem;\n    line-height: 1.7142857;\n  }\n  .lg\\:prose-sm p {\n    margin-top: 1.1428571em;\n    margin-bottom: 1.1428571em;\n  }\n  .lg\\:prose-sm [class~=\"lead\"] {\n    font-size: 1.2857143em;\n    line-height: 1.5555556;\n    margin-top: 0.8888889em;\n    margin-bottom: 0.8888889em;\n  }\n  .lg\\:prose-sm blockquote {\n    margin-top: 1.3333333em;\n    margin-bottom: 1.3333333em;\n    padding-left: 1.1111111em;\n  }\n  .lg\\:prose-sm h1 {\n    font-size: 2.1428571em;\n    margin-top: 0;\n    margin-bottom: 0.8em;\n    line-height: 1.2;\n  }\n  .lg\\:prose-sm h2 {\n    font-size: 1.4285714em;\n    margin-top: 1.6em;\n    margin-bottom: 0.8em;\n    line-height: 1.4;\n  }\n  .lg\\:prose-sm h3 {\n    font-size: 1.2857143em;\n    margin-top: 1.5555556em;\n    margin-bottom: 0.4444444em;\n    line-height: 1.5555556;\n  }\n  .lg\\:prose-sm h4 {\n    margin-top: 1.4285714em;\n    margin-bottom: 0.5714286em;\n    line-height: 1.4285714;\n  }\n  .lg\\:prose-sm img {\n    margin-top: 1.7142857em;\n    margin-bottom: 1.7142857em;\n  }\n  .lg\\:prose-sm video {\n    margin-top: 1.7142857em;\n    margin-bottom: 1.7142857em;\n  }\n  .lg\\:prose-sm figure {\n    margin-top: 1.7142857em;\n    margin-bottom: 1.7142857em;\n  }\n  .lg\\:prose-sm figure>* {\n    margin-top: 0;\n    margin-bottom: 0;\n  }\n  .lg\\:prose-sm figure figcaption {\n    font-size: 0.8571429em;\n    line-height: 1.3333333;\n    margin-top: 0.6666667em;\n  }\n  .lg\\:prose-sm code {\n    font-size: 0.8571429em;\n  }\n  .lg\\:prose-sm h2 code {\n    font-size: 0.9em;\n  }\n  .lg\\:prose-sm h3 code {\n    font-size: 0.8888889em;\n  }\n  .lg\\:prose-sm pre {\n    font-size: 0.8571429em;\n    line-height: 1.6666667;\n    margin-top: 1.6666667em;\n    margin-bottom: 1.6666667em;\n    border-radius: 0.25rem;\n    padding-top: 0.6666667em;\n    padding-right: 1em;\n    padding-bottom: 0.6666667em;\n    padding-left: 1em;\n  }\n  .lg\\:prose-sm ol {\n    margin-top: 1.1428571em;\n    margin-bottom: 1.1428571em;\n  }\n  .lg\\:prose-sm ul {\n    margin-top: 1.1428571em;\n    margin-bottom: 1.1428571em;\n  }\n  .lg\\:prose-sm li {\n    margin-top: 0.2857143em;\n    margin-bottom: 0.2857143em;\n  }\n  .lg\\:prose-sm ol>li {\n    padding-left: 1.5714286em;\n  }\n  .lg\\:prose-sm ol>li:before {\n    left: 0;\n  }\n  .lg\\:prose-sm ul>li {\n    padding-left: 1.5714286em;\n  }\n  .lg\\:prose-sm ul>li::before {\n    height: 0.3571429em;\n    width: 0.3571429em;\n    top: calc(0.8571429em - 0.1785714em);\n    left: 0.2142857em;\n  }\n  .lg\\:prose-sm>ul>li p {\n    margin-top: 0.5714286em;\n    margin-bottom: 0.5714286em;\n  }\n  .lg\\:prose-sm>ul>li>*:first-child {\n    margin-top: 1.1428571em;\n  }\n  .lg\\:prose-sm>ul>li>*:last-child {\n    margin-bottom: 1.1428571em;\n  }\n  .lg\\:prose-sm>ol>li>*:first-child {\n    margin-top: 1.1428571em;\n  }\n  .lg\\:prose-sm>ol>li>*:last-child {\n    margin-bottom: 1.1428571em;\n  }\n  .lg\\:prose-sm ul ul, .lg\\:prose-sm ul ol, .lg\\:prose-sm ol ul, .lg\\:prose-sm ol ol {\n    margin-top: 0.5714286em;\n    margin-bottom: 0.5714286em;\n  }\n  .lg\\:prose-sm hr {\n    margin-top: 2.8571429em;\n    margin-bottom: 2.8571429em;\n  }\n  .lg\\:prose-sm hr+* {\n    margin-top: 0;\n  }\n  .lg\\:prose-sm h2+* {\n    margin-top: 0;\n  }\n  .lg\\:prose-sm h3+* {\n    margin-top: 0;\n  }\n  .lg\\:prose-sm h4+* {\n    margin-top: 0;\n  }\n  .lg\\:prose-sm table {\n    font-size: 0.8571429em;\n    line-height: 1.5;\n  }\n  .lg\\:prose-sm thead th {\n    padding-right: 1em;\n    padding-bottom: 0.6666667em;\n    padding-left: 1em;\n  }\n  .lg\\:prose-sm thead th:first-child {\n    padding-left: 0;\n  }\n  .lg\\:prose-sm thead th:last-child {\n    padding-right: 0;\n  }\n  .lg\\:prose-sm tbody td {\n    padding-top: 0.6666667em;\n    padding-right: 1em;\n    padding-bottom: 0.6666667em;\n    padding-left: 1em;\n  }\n  .lg\\:prose-sm tbody td:first-child {\n    padding-left: 0;\n  }\n  .lg\\:prose-sm tbody td:last-child {\n    padding-right: 0;\n  }\n  .lg\\:prose-sm> :first-child {\n    margin-top: 0;\n  }\n  .lg\\:prose-sm> :last-child {\n    margin-bottom: 0;\n  }\n  .lg\\:prose-lg {\n    font-size: 1.125rem;\n    line-height: 1.7777778;\n  }\n  .lg\\:prose-lg p {\n    margin-top: 1.3333333em;\n    margin-bottom: 1.3333333em;\n  }\n  .lg\\:prose-lg [class~=\"lead\"] {\n    font-size: 1.2222222em;\n    line-height: 1.4545455;\n    margin-top: 1.0909091em;\n    margin-bottom: 1.0909091em;\n  }\n  .lg\\:prose-lg blockquote {\n    margin-top: 1.6666667em;\n    margin-bottom: 1.6666667em;\n    padding-left: 1em;\n  }\n  .lg\\:prose-lg h1 {\n    font-size: 2.6666667em;\n    margin-top: 0;\n    margin-bottom: 0.8333333em;\n    line-height: 1;\n  }\n  .lg\\:prose-lg h2 {\n    font-size: 1.6666667em;\n    margin-top: 1.8666667em;\n    margin-bottom: 1.0666667em;\n    line-height: 1.3333333;\n  }\n  .lg\\:prose-lg h3 {\n    font-size: 1.3333333em;\n    margin-top: 1.6666667em;\n    margin-bottom: 0.6666667em;\n    line-height: 1.5;\n  }\n  .lg\\:prose-lg h4 {\n    margin-top: 1.7777778em;\n    margin-bottom: 0.4444444em;\n    line-height: 1.5555556;\n  }\n  .lg\\:prose-lg img {\n    margin-top: 1.7777778em;\n    margin-bottom: 1.7777778em;\n  }\n  .lg\\:prose-lg video {\n    margin-top: 1.7777778em;\n    margin-bottom: 1.7777778em;\n  }\n  .lg\\:prose-lg figure {\n    margin-top: 1.7777778em;\n    margin-bottom: 1.7777778em;\n  }\n  .lg\\:prose-lg figure>* {\n    margin-top: 0;\n    margin-bottom: 0;\n  }\n  .lg\\:prose-lg figure figcaption {\n    font-size: 0.8888889em;\n    line-height: 1.5;\n    margin-top: 1em;\n  }\n  .lg\\:prose-lg code {\n    font-size: 0.8888889em;\n  }\n  .lg\\:prose-lg h2 code {\n    font-size: 0.8666667em;\n  }\n  .lg\\:prose-lg h3 code {\n    font-size: 0.875em;\n  }\n  .lg\\:prose-lg pre {\n    font-size: 0.8888889em;\n    line-height: 1.75;\n    margin-top: 2em;\n    margin-bottom: 2em;\n    border-radius: 0.375rem;\n    padding-top: 1em;\n    padding-right: 1.5em;\n    padding-bottom: 1em;\n    padding-left: 1.5em;\n  }\n  .lg\\:prose-lg ol {\n    margin-top: 1.3333333em;\n    margin-bottom: 1.3333333em;\n  }\n  .lg\\:prose-lg ul {\n    margin-top: 1.3333333em;\n    margin-bottom: 1.3333333em;\n  }\n  .lg\\:prose-lg li {\n    margin-top: 0.6666667em;\n    margin-bottom: 0.6666667em;\n  }\n  .lg\\:prose-lg ol>li {\n    padding-left: 1.6666667em;\n  }\n  .lg\\:prose-lg ol>li:before {\n    left: 0;\n  }\n  .lg\\:prose-lg ul>li {\n    padding-left: 1.6666667em;\n  }\n  .lg\\:prose-lg ul>li::before {\n    width: 0.3333333em;\n    height: 0.3333333em;\n    top: calc(0.8888889em - 0.1666667em);\n    left: 0.2222222em;\n  }\n  .lg\\:prose-lg>ul>li p {\n    margin-top: 0.8888889em;\n    margin-bottom: 0.8888889em;\n  }\n  .lg\\:prose-lg>ul>li>*:first-child {\n    margin-top: 1.3333333em;\n  }\n  .lg\\:prose-lg>ul>li>*:last-child {\n    margin-bottom: 1.3333333em;\n  }\n  .lg\\:prose-lg>ol>li>*:first-child {\n    margin-top: 1.3333333em;\n  }\n  .lg\\:prose-lg>ol>li>*:last-child {\n    margin-bottom: 1.3333333em;\n  }\n  .lg\\:prose-lg ul ul, .lg\\:prose-lg ul ol, .lg\\:prose-lg ol ul, .lg\\:prose-lg ol ol {\n    margin-top: 0.8888889em;\n    margin-bottom: 0.8888889em;\n  }\n  .lg\\:prose-lg hr {\n    margin-top: 3.1111111em;\n    margin-bottom: 3.1111111em;\n  }\n  .lg\\:prose-lg hr+* {\n    margin-top: 0;\n  }\n  .lg\\:prose-lg h2+* {\n    margin-top: 0;\n  }\n  .lg\\:prose-lg h3+* {\n    margin-top: 0;\n  }\n  .lg\\:prose-lg h4+* {\n    margin-top: 0;\n  }\n  .lg\\:prose-lg table {\n    font-size: 0.8888889em;\n    line-height: 1.5;\n  }\n  .lg\\:prose-lg thead th {\n    padding-right: 0.75em;\n    padding-bottom: 0.75em;\n    padding-left: 0.75em;\n  }\n  .lg\\:prose-lg thead th:first-child {\n    padding-left: 0;\n  }\n  .lg\\:prose-lg thead th:last-child {\n    padding-right: 0;\n  }\n  .lg\\:prose-lg tbody td {\n    padding-top: 0.75em;\n    padding-right: 0.75em;\n    padding-bottom: 0.75em;\n    padding-left: 0.75em;\n  }\n  .lg\\:prose-lg tbody td:first-child {\n    padding-left: 0;\n  }\n  .lg\\:prose-lg tbody td:last-child {\n    padding-right: 0;\n  }\n  .lg\\:prose-lg> :first-child {\n    margin-top: 0;\n  }\n  .lg\\:prose-lg> :last-child {\n    margin-bottom: 0;\n  }\n  .lg\\:prose-xl {\n    font-size: 1.25rem;\n    line-height: 1.8;\n  }\n  .lg\\:prose-xl p {\n    margin-top: 1.2em;\n    margin-bottom: 1.2em;\n  }\n  .lg\\:prose-xl [class~=\"lead\"] {\n    font-size: 1.2em;\n    line-height: 1.5;\n    margin-top: 1em;\n    margin-bottom: 1em;\n  }\n  .lg\\:prose-xl blockquote {\n    margin-top: 1.6em;\n    margin-bottom: 1.6em;\n    padding-left: 1.0666667em;\n  }\n  .lg\\:prose-xl h1 {\n    font-size: 2.8em;\n    margin-top: 0;\n    margin-bottom: 0.8571429em;\n    line-height: 1;\n  }\n  .lg\\:prose-xl h2 {\n    font-size: 1.8em;\n    margin-top: 1.5555556em;\n    margin-bottom: 0.8888889em;\n    line-height: 1.1111111;\n  }\n  .lg\\:prose-xl h3 {\n    font-size: 1.5em;\n    margin-top: 1.6em;\n    margin-bottom: 0.6666667em;\n    line-height: 1.3333333;\n  }\n  .lg\\:prose-xl h4 {\n    margin-top: 1.8em;\n    margin-bottom: 0.6em;\n    line-height: 1.6;\n  }\n  .lg\\:prose-xl img {\n    margin-top: 2em;\n    margin-bottom: 2em;\n  }\n  .lg\\:prose-xl video {\n    margin-top: 2em;\n    margin-bottom: 2em;\n  }\n  .lg\\:prose-xl figure {\n    margin-top: 2em;\n    margin-bottom: 2em;\n  }\n  .lg\\:prose-xl figure>* {\n    margin-top: 0;\n    margin-bottom: 0;\n  }\n  .lg\\:prose-xl figure figcaption {\n    font-size: 0.9em;\n    line-height: 1.5555556;\n    margin-top: 1em;\n  }\n  .lg\\:prose-xl code {\n    font-size: 0.9em;\n  }\n  .lg\\:prose-xl h2 code {\n    font-size: 0.8611111em;\n  }\n  .lg\\:prose-xl h3 code {\n    font-size: 0.9em;\n  }\n  .lg\\:prose-xl pre {\n    font-size: 0.9em;\n    line-height: 1.7777778;\n    margin-top: 2em;\n    margin-bottom: 2em;\n    border-radius: 0.5rem;\n    padding-top: 1.1111111em;\n    padding-right: 1.3333333em;\n    padding-bottom: 1.1111111em;\n    padding-left: 1.3333333em;\n  }\n  .lg\\:prose-xl ol {\n    margin-top: 1.2em;\n    margin-bottom: 1.2em;\n  }\n  .lg\\:prose-xl ul {\n    margin-top: 1.2em;\n    margin-bottom: 1.2em;\n  }\n  .lg\\:prose-xl li {\n    margin-top: 0.6em;\n    margin-bottom: 0.6em;\n  }\n  .lg\\:prose-xl ol>li {\n    padding-left: 1.8em;\n  }\n  .lg\\:prose-xl ol>li:before {\n    left: 0;\n  }\n  .lg\\:prose-xl ul>li {\n    padding-left: 1.8em;\n  }\n  .lg\\:prose-xl ul>li::before {\n    width: 0.35em;\n    height: 0.35em;\n    top: calc(0.9em - 0.175em);\n    left: 0.25em;\n  }\n  .lg\\:prose-xl>ul>li p {\n    margin-top: 0.8em;\n    margin-bottom: 0.8em;\n  }\n  .lg\\:prose-xl>ul>li>*:first-child {\n    margin-top: 1.2em;\n  }\n  .lg\\:prose-xl>ul>li>*:last-child {\n    margin-bottom: 1.2em;\n  }\n  .lg\\:prose-xl>ol>li>*:first-child {\n    margin-top: 1.2em;\n  }\n  .lg\\:prose-xl>ol>li>*:last-child {\n    margin-bottom: 1.2em;\n  }\n  .lg\\:prose-xl ul ul, .lg\\:prose-xl ul ol, .lg\\:prose-xl ol ul, .lg\\:prose-xl ol ol {\n    margin-top: 0.8em;\n    margin-bottom: 0.8em;\n  }\n  .lg\\:prose-xl hr {\n    margin-top: 2.8em;\n    margin-bottom: 2.8em;\n  }\n  .lg\\:prose-xl hr+* {\n    margin-top: 0;\n  }\n  .lg\\:prose-xl h2+* {\n    margin-top: 0;\n  }\n  .lg\\:prose-xl h3+* {\n    margin-top: 0;\n  }\n  .lg\\:prose-xl h4+* {\n    margin-top: 0;\n  }\n  .lg\\:prose-xl table {\n    font-size: 0.9em;\n    line-height: 1.5555556;\n  }\n  .lg\\:prose-xl thead th {\n    padding-right: 0.6666667em;\n    padding-bottom: 0.8888889em;\n    padding-left: 0.6666667em;\n  }\n  .lg\\:prose-xl thead th:first-child {\n    padding-left: 0;\n  }\n  .lg\\:prose-xl thead th:last-child {\n    padding-right: 0;\n  }\n  .lg\\:prose-xl tbody td {\n    padding-top: 0.8888889em;\n    padding-right: 0.6666667em;\n    padding-bottom: 0.8888889em;\n    padding-left: 0.6666667em;\n  }\n  .lg\\:prose-xl tbody td:first-child {\n    padding-left: 0;\n  }\n  .lg\\:prose-xl tbody td:last-child {\n    padding-right: 0;\n  }\n  .lg\\:prose-xl> :first-child {\n    margin-top: 0;\n  }\n  .lg\\:prose-xl> :last-child {\n    margin-bottom: 0;\n  }\n  .lg\\:prose-2xl {\n    font-size: 1.5rem;\n    line-height: 1.6666667;\n  }\n  .lg\\:prose-2xl p {\n    margin-top: 1.3333333em;\n    margin-bottom: 1.3333333em;\n  }\n  .lg\\:prose-2xl [class~=\"lead\"] {\n    font-size: 1.25em;\n    line-height: 1.4666667;\n    margin-top: 1.0666667em;\n    margin-bottom: 1.0666667em;\n  }\n  .lg\\:prose-2xl blockquote {\n    margin-top: 1.7777778em;\n    margin-bottom: 1.7777778em;\n    padding-left: 1.1111111em;\n  }\n  .lg\\:prose-2xl h1 {\n    font-size: 2.6666667em;\n    margin-top: 0;\n    margin-bottom: 0.875em;\n    line-height: 1;\n  }\n  .lg\\:prose-2xl h2 {\n    font-size: 2em;\n    margin-top: 1.5em;\n    margin-bottom: 0.8333333em;\n    line-height: 1.0833333;\n  }\n  .lg\\:prose-2xl h3 {\n    font-size: 1.5em;\n    margin-top: 1.5555556em;\n    margin-bottom: 0.6666667em;\n    line-height: 1.2222222;\n  }\n  .lg\\:prose-2xl h4 {\n    margin-top: 1.6666667em;\n    margin-bottom: 0.6666667em;\n    line-height: 1.5;\n  }\n  .lg\\:prose-2xl img {\n    margin-top: 2em;\n    margin-bottom: 2em;\n  }\n  .lg\\:prose-2xl video {\n    margin-top: 2em;\n    margin-bottom: 2em;\n  }\n  .lg\\:prose-2xl figure {\n    margin-top: 2em;\n    margin-bottom: 2em;\n  }\n  .lg\\:prose-2xl figure>* {\n    margin-top: 0;\n    margin-bottom: 0;\n  }\n  .lg\\:prose-2xl figure figcaption {\n    font-size: 0.8333333em;\n    line-height: 1.6;\n    margin-top: 1em;\n  }\n  .lg\\:prose-2xl code {\n    font-size: 0.8333333em;\n  }\n  .lg\\:prose-2xl h2 code {\n    font-size: 0.875em;\n  }\n  .lg\\:prose-2xl h3 code {\n    font-size: 0.8888889em;\n  }\n  .lg\\:prose-2xl pre {\n    font-size: 0.8333333em;\n    line-height: 1.8;\n    margin-top: 2em;\n    margin-bottom: 2em;\n    border-radius: 0.5rem;\n    padding-top: 1.2em;\n    padding-right: 1.6em;\n    padding-bottom: 1.2em;\n    padding-left: 1.6em;\n  }\n  .lg\\:prose-2xl ol {\n    margin-top: 1.3333333em;\n    margin-bottom: 1.3333333em;\n  }\n  .lg\\:prose-2xl ul {\n    margin-top: 1.3333333em;\n    margin-bottom: 1.3333333em;\n  }\n  .lg\\:prose-2xl li {\n    margin-top: 0.5em;\n    margin-bottom: 0.5em;\n  }\n  .lg\\:prose-2xl ol>li {\n    padding-left: 1.6666667em;\n  }\n  .lg\\:prose-2xl ol>li:before {\n    left: 0;\n  }\n  .lg\\:prose-2xl ul>li {\n    padding-left: 1.6666667em;\n  }\n  .lg\\:prose-2xl ul>li::before {\n    width: 0.3333333em;\n    height: 0.3333333em;\n    top: calc(0.8333333em - 0.1666667em);\n    left: 0.25em;\n  }\n  .lg\\:prose-2xl>ul>li p {\n    margin-top: 0.8333333em;\n    margin-bottom: 0.8333333em;\n  }\n  .lg\\:prose-2xl>ul>li>*:first-child {\n    margin-top: 1.3333333em;\n  }\n  .lg\\:prose-2xl>ul>li>*:last-child {\n    margin-bottom: 1.3333333em;\n  }\n  .lg\\:prose-2xl>ol>li>*:first-child {\n    margin-top: 1.3333333em;\n  }\n  .lg\\:prose-2xl>ol>li>*:last-child {\n    margin-bottom: 1.3333333em;\n  }\n  .lg\\:prose-2xl ul ul, .lg\\:prose-2xl ul ol, .lg\\:prose-2xl ol ul, .lg\\:prose-2xl ol ol {\n    margin-top: 0.6666667em;\n    margin-bottom: 0.6666667em;\n  }\n  .lg\\:prose-2xl hr {\n    margin-top: 3em;\n    margin-bottom: 3em;\n  }\n  .lg\\:prose-2xl hr+* {\n    margin-top: 0;\n  }\n  .lg\\:prose-2xl h2+* {\n    margin-top: 0;\n  }\n  .lg\\:prose-2xl h3+* {\n    margin-top: 0;\n  }\n  .lg\\:prose-2xl h4+* {\n    margin-top: 0;\n  }\n  .lg\\:prose-2xl table {\n    font-size: 0.8333333em;\n    line-height: 1.4;\n  }\n  .lg\\:prose-2xl thead th {\n    padding-right: 0.6em;\n    padding-bottom: 0.8em;\n    padding-left: 0.6em;\n  }\n  .lg\\:prose-2xl thead th:first-child {\n    padding-left: 0;\n  }\n  .lg\\:prose-2xl thead th:last-child {\n    padding-right: 0;\n  }\n  .lg\\:prose-2xl tbody td {\n    padding-top: 0.8em;\n    padding-right: 0.6em;\n    padding-bottom: 0.8em;\n    padding-left: 0.6em;\n  }\n  .lg\\:prose-2xl tbody td:first-child {\n    padding-left: 0;\n  }\n  .lg\\:prose-2xl tbody td:last-child {\n    padding-right: 0;\n  }\n  .lg\\:prose-2xl> :first-child {\n    margin-top: 0;\n  }\n  .lg\\:prose-2xl> :last-child {\n    margin-bottom: 0;\n  }\n  .lg\\:space-y-0> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(0px * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(0px * var(--space-y-reverse));\n  }\n  .lg\\:space-x-0> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(0px * var(--space-x-reverse));\n    margin-left: calc(0px * calc(1 - var(--space-x-reverse)));\n  }\n  .lg\\:space-y-1> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(0.25rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(0.25rem * var(--space-y-reverse));\n  }\n  .lg\\:space-x-1> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(0.25rem * var(--space-x-reverse));\n    margin-left: calc(0.25rem * calc(1 - var(--space-x-reverse)));\n  }\n  .lg\\:space-y-2> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(0.5rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(0.5rem * var(--space-y-reverse));\n  }\n  .lg\\:space-x-2> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(0.5rem * var(--space-x-reverse));\n    margin-left: calc(0.5rem * calc(1 - var(--space-x-reverse)));\n  }\n  .lg\\:space-y-3> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(0.75rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(0.75rem * var(--space-y-reverse));\n  }\n  .lg\\:space-x-3> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(0.75rem * var(--space-x-reverse));\n    margin-left: calc(0.75rem * calc(1 - var(--space-x-reverse)));\n  }\n  .lg\\:space-y-4> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(1rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(1rem * var(--space-y-reverse));\n  }\n  .lg\\:space-x-4> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(1rem * var(--space-x-reverse));\n    margin-left: calc(1rem * calc(1 - var(--space-x-reverse)));\n  }\n  .lg\\:space-y-5> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(1.25rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(1.25rem * var(--space-y-reverse));\n  }\n  .lg\\:space-x-5> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(1.25rem * var(--space-x-reverse));\n    margin-left: calc(1.25rem * calc(1 - var(--space-x-reverse)));\n  }\n  .lg\\:space-y-6> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(1.5rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(1.5rem * var(--space-y-reverse));\n  }\n  .lg\\:space-x-6> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(1.5rem * var(--space-x-reverse));\n    margin-left: calc(1.5rem * calc(1 - var(--space-x-reverse)));\n  }\n  .lg\\:space-y-7> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(1.75rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(1.75rem * var(--space-y-reverse));\n  }\n  .lg\\:space-x-7> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(1.75rem * var(--space-x-reverse));\n    margin-left: calc(1.75rem * calc(1 - var(--space-x-reverse)));\n  }\n  .lg\\:space-y-8> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(2rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(2rem * var(--space-y-reverse));\n  }\n  .lg\\:space-x-8> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(2rem * var(--space-x-reverse));\n    margin-left: calc(2rem * calc(1 - var(--space-x-reverse)));\n  }\n  .lg\\:space-y-9> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(2.25rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(2.25rem * var(--space-y-reverse));\n  }\n  .lg\\:space-x-9> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(2.25rem * var(--space-x-reverse));\n    margin-left: calc(2.25rem * calc(1 - var(--space-x-reverse)));\n  }\n  .lg\\:space-y-10> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(2.5rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(2.5rem * var(--space-y-reverse));\n  }\n  .lg\\:space-x-10> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(2.5rem * var(--space-x-reverse));\n    margin-left: calc(2.5rem * calc(1 - var(--space-x-reverse)));\n  }\n  .lg\\:space-y-11> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(2.75rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(2.75rem * var(--space-y-reverse));\n  }\n  .lg\\:space-x-11> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(2.75rem * var(--space-x-reverse));\n    margin-left: calc(2.75rem * calc(1 - var(--space-x-reverse)));\n  }\n  .lg\\:space-y-12> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(3rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(3rem * var(--space-y-reverse));\n  }\n  .lg\\:space-x-12> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(3rem * var(--space-x-reverse));\n    margin-left: calc(3rem * calc(1 - var(--space-x-reverse)));\n  }\n  .lg\\:space-y-13> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(3.25rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(3.25rem * var(--space-y-reverse));\n  }\n  .lg\\:space-x-13> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(3.25rem * var(--space-x-reverse));\n    margin-left: calc(3.25rem * calc(1 - var(--space-x-reverse)));\n  }\n  .lg\\:space-y-14> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(3.5rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(3.5rem * var(--space-y-reverse));\n  }\n  .lg\\:space-x-14> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(3.5rem * var(--space-x-reverse));\n    margin-left: calc(3.5rem * calc(1 - var(--space-x-reverse)));\n  }\n  .lg\\:space-y-15> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(3.75rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(3.75rem * var(--space-y-reverse));\n  }\n  .lg\\:space-x-15> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(3.75rem * var(--space-x-reverse));\n    margin-left: calc(3.75rem * calc(1 - var(--space-x-reverse)));\n  }\n  .lg\\:space-y-16> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(4rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(4rem * var(--space-y-reverse));\n  }\n  .lg\\:space-x-16> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(4rem * var(--space-x-reverse));\n    margin-left: calc(4rem * calc(1 - var(--space-x-reverse)));\n  }\n  .lg\\:space-y-20> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(5rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(5rem * var(--space-y-reverse));\n  }\n  .lg\\:space-x-20> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(5rem * var(--space-x-reverse));\n    margin-left: calc(5rem * calc(1 - var(--space-x-reverse)));\n  }\n  .lg\\:space-y-24> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(6rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(6rem * var(--space-y-reverse));\n  }\n  .lg\\:space-x-24> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(6rem * var(--space-x-reverse));\n    margin-left: calc(6rem * calc(1 - var(--space-x-reverse)));\n  }\n  .lg\\:space-y-28> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(7rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(7rem * var(--space-y-reverse));\n  }\n  .lg\\:space-x-28> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(7rem * var(--space-x-reverse));\n    margin-left: calc(7rem * calc(1 - var(--space-x-reverse)));\n  }\n  .lg\\:space-y-32> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(8rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(8rem * var(--space-y-reverse));\n  }\n  .lg\\:space-x-32> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(8rem * var(--space-x-reverse));\n    margin-left: calc(8rem * calc(1 - var(--space-x-reverse)));\n  }\n  .lg\\:space-y-36> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(9rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(9rem * var(--space-y-reverse));\n  }\n  .lg\\:space-x-36> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(9rem * var(--space-x-reverse));\n    margin-left: calc(9rem * calc(1 - var(--space-x-reverse)));\n  }\n  .lg\\:space-y-40> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(10rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(10rem * var(--space-y-reverse));\n  }\n  .lg\\:space-x-40> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(10rem * var(--space-x-reverse));\n    margin-left: calc(10rem * calc(1 - var(--space-x-reverse)));\n  }\n  .lg\\:space-y-44> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(11rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(11rem * var(--space-y-reverse));\n  }\n  .lg\\:space-x-44> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(11rem * var(--space-x-reverse));\n    margin-left: calc(11rem * calc(1 - var(--space-x-reverse)));\n  }\n  .lg\\:space-y-48> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(12rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(12rem * var(--space-y-reverse));\n  }\n  .lg\\:space-x-48> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(12rem * var(--space-x-reverse));\n    margin-left: calc(12rem * calc(1 - var(--space-x-reverse)));\n  }\n  .lg\\:space-y-52> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(13rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(13rem * var(--space-y-reverse));\n  }\n  .lg\\:space-x-52> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(13rem * var(--space-x-reverse));\n    margin-left: calc(13rem * calc(1 - var(--space-x-reverse)));\n  }\n  .lg\\:space-y-56> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(14rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(14rem * var(--space-y-reverse));\n  }\n  .lg\\:space-x-56> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(14rem * var(--space-x-reverse));\n    margin-left: calc(14rem * calc(1 - var(--space-x-reverse)));\n  }\n  .lg\\:space-y-60> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(15rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(15rem * var(--space-y-reverse));\n  }\n  .lg\\:space-x-60> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(15rem * var(--space-x-reverse));\n    margin-left: calc(15rem * calc(1 - var(--space-x-reverse)));\n  }\n  .lg\\:space-y-64> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(16rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(16rem * var(--space-y-reverse));\n  }\n  .lg\\:space-x-64> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(16rem * var(--space-x-reverse));\n    margin-left: calc(16rem * calc(1 - var(--space-x-reverse)));\n  }\n  .lg\\:space-y-72> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(18rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(18rem * var(--space-y-reverse));\n  }\n  .lg\\:space-x-72> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(18rem * var(--space-x-reverse));\n    margin-left: calc(18rem * calc(1 - var(--space-x-reverse)));\n  }\n  .lg\\:space-y-80> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(20rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(20rem * var(--space-y-reverse));\n  }\n  .lg\\:space-x-80> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(20rem * var(--space-x-reverse));\n    margin-left: calc(20rem * calc(1 - var(--space-x-reverse)));\n  }\n  .lg\\:space-y-96> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(24rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(24rem * var(--space-y-reverse));\n  }\n  .lg\\:space-x-96> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(24rem * var(--space-x-reverse));\n    margin-left: calc(24rem * calc(1 - var(--space-x-reverse)));\n  }\n  .lg\\:space-y-px> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(1px * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(1px * var(--space-y-reverse));\n  }\n  .lg\\:space-x-px> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(1px * var(--space-x-reverse));\n    margin-left: calc(1px * calc(1 - var(--space-x-reverse)));\n  }\n  .lg\\:space-y-0\\.5> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(0.125rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(0.125rem * var(--space-y-reverse));\n  }\n  .lg\\:space-x-0\\.5> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(0.125rem * var(--space-x-reverse));\n    margin-left: calc(0.125rem * calc(1 - var(--space-x-reverse)));\n  }\n  .lg\\:space-y-1\\.5> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(0.375rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(0.375rem * var(--space-y-reverse));\n  }\n  .lg\\:space-x-1\\.5> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(0.375rem * var(--space-x-reverse));\n    margin-left: calc(0.375rem * calc(1 - var(--space-x-reverse)));\n  }\n  .lg\\:space-y-2\\.5> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(0.625rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(0.625rem * var(--space-y-reverse));\n  }\n  .lg\\:space-x-2\\.5> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(0.625rem * var(--space-x-reverse));\n    margin-left: calc(0.625rem * calc(1 - var(--space-x-reverse)));\n  }\n  .lg\\:space-y-3\\.5> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(0.875rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(0.875rem * var(--space-y-reverse));\n  }\n  .lg\\:space-x-3\\.5> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(0.875rem * var(--space-x-reverse));\n    margin-left: calc(0.875rem * calc(1 - var(--space-x-reverse)));\n  }\n  .lg\\:space-y-1\\/2> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(50% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(50% * var(--space-y-reverse));\n  }\n  .lg\\:space-x-1\\/2> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(50% * var(--space-x-reverse));\n    margin-left: calc(50% * calc(1 - var(--space-x-reverse)));\n  }\n  .lg\\:space-y-1\\/3> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(33.333333% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(33.333333% * var(--space-y-reverse));\n  }\n  .lg\\:space-x-1\\/3> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(33.333333% * var(--space-x-reverse));\n    margin-left: calc(33.333333% * calc(1 - var(--space-x-reverse)));\n  }\n  .lg\\:space-y-2\\/3> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(66.666667% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(66.666667% * var(--space-y-reverse));\n  }\n  .lg\\:space-x-2\\/3> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(66.666667% * var(--space-x-reverse));\n    margin-left: calc(66.666667% * calc(1 - var(--space-x-reverse)));\n  }\n  .lg\\:space-y-1\\/4> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(25% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(25% * var(--space-y-reverse));\n  }\n  .lg\\:space-x-1\\/4> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(25% * var(--space-x-reverse));\n    margin-left: calc(25% * calc(1 - var(--space-x-reverse)));\n  }\n  .lg\\:space-y-2\\/4> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(50% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(50% * var(--space-y-reverse));\n  }\n  .lg\\:space-x-2\\/4> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(50% * var(--space-x-reverse));\n    margin-left: calc(50% * calc(1 - var(--space-x-reverse)));\n  }\n  .lg\\:space-y-3\\/4> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(75% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(75% * var(--space-y-reverse));\n  }\n  .lg\\:space-x-3\\/4> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(75% * var(--space-x-reverse));\n    margin-left: calc(75% * calc(1 - var(--space-x-reverse)));\n  }\n  .lg\\:space-y-1\\/5> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(20% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(20% * var(--space-y-reverse));\n  }\n  .lg\\:space-x-1\\/5> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(20% * var(--space-x-reverse));\n    margin-left: calc(20% * calc(1 - var(--space-x-reverse)));\n  }\n  .lg\\:space-y-2\\/5> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(40% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(40% * var(--space-y-reverse));\n  }\n  .lg\\:space-x-2\\/5> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(40% * var(--space-x-reverse));\n    margin-left: calc(40% * calc(1 - var(--space-x-reverse)));\n  }\n  .lg\\:space-y-3\\/5> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(60% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(60% * var(--space-y-reverse));\n  }\n  .lg\\:space-x-3\\/5> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(60% * var(--space-x-reverse));\n    margin-left: calc(60% * calc(1 - var(--space-x-reverse)));\n  }\n  .lg\\:space-y-4\\/5> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(80% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(80% * var(--space-y-reverse));\n  }\n  .lg\\:space-x-4\\/5> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(80% * var(--space-x-reverse));\n    margin-left: calc(80% * calc(1 - var(--space-x-reverse)));\n  }\n  .lg\\:space-y-1\\/6> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(16.666667% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(16.666667% * var(--space-y-reverse));\n  }\n  .lg\\:space-x-1\\/6> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(16.666667% * var(--space-x-reverse));\n    margin-left: calc(16.666667% * calc(1 - var(--space-x-reverse)));\n  }\n  .lg\\:space-y-2\\/6> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(33.333333% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(33.333333% * var(--space-y-reverse));\n  }\n  .lg\\:space-x-2\\/6> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(33.333333% * var(--space-x-reverse));\n    margin-left: calc(33.333333% * calc(1 - var(--space-x-reverse)));\n  }\n  .lg\\:space-y-3\\/6> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(50% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(50% * var(--space-y-reverse));\n  }\n  .lg\\:space-x-3\\/6> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(50% * var(--space-x-reverse));\n    margin-left: calc(50% * calc(1 - var(--space-x-reverse)));\n  }\n  .lg\\:space-y-4\\/6> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(66.666667% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(66.666667% * var(--space-y-reverse));\n  }\n  .lg\\:space-x-4\\/6> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(66.666667% * var(--space-x-reverse));\n    margin-left: calc(66.666667% * calc(1 - var(--space-x-reverse)));\n  }\n  .lg\\:space-y-5\\/6> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(83.333333% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(83.333333% * var(--space-y-reverse));\n  }\n  .lg\\:space-x-5\\/6> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(83.333333% * var(--space-x-reverse));\n    margin-left: calc(83.333333% * calc(1 - var(--space-x-reverse)));\n  }\n  .lg\\:space-y-1\\/12> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(8.333333% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(8.333333% * var(--space-y-reverse));\n  }\n  .lg\\:space-x-1\\/12> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(8.333333% * var(--space-x-reverse));\n    margin-left: calc(8.333333% * calc(1 - var(--space-x-reverse)));\n  }\n  .lg\\:space-y-2\\/12> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(16.666667% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(16.666667% * var(--space-y-reverse));\n  }\n  .lg\\:space-x-2\\/12> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(16.666667% * var(--space-x-reverse));\n    margin-left: calc(16.666667% * calc(1 - var(--space-x-reverse)));\n  }\n  .lg\\:space-y-3\\/12> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(25% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(25% * var(--space-y-reverse));\n  }\n  .lg\\:space-x-3\\/12> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(25% * var(--space-x-reverse));\n    margin-left: calc(25% * calc(1 - var(--space-x-reverse)));\n  }\n  .lg\\:space-y-4\\/12> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(33.333333% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(33.333333% * var(--space-y-reverse));\n  }\n  .lg\\:space-x-4\\/12> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(33.333333% * var(--space-x-reverse));\n    margin-left: calc(33.333333% * calc(1 - var(--space-x-reverse)));\n  }\n  .lg\\:space-y-5\\/12> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(41.666667% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(41.666667% * var(--space-y-reverse));\n  }\n  .lg\\:space-x-5\\/12> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(41.666667% * var(--space-x-reverse));\n    margin-left: calc(41.666667% * calc(1 - var(--space-x-reverse)));\n  }\n  .lg\\:space-y-6\\/12> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(50% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(50% * var(--space-y-reverse));\n  }\n  .lg\\:space-x-6\\/12> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(50% * var(--space-x-reverse));\n    margin-left: calc(50% * calc(1 - var(--space-x-reverse)));\n  }\n  .lg\\:space-y-7\\/12> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(58.333333% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(58.333333% * var(--space-y-reverse));\n  }\n  .lg\\:space-x-7\\/12> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(58.333333% * var(--space-x-reverse));\n    margin-left: calc(58.333333% * calc(1 - var(--space-x-reverse)));\n  }\n  .lg\\:space-y-8\\/12> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(66.666667% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(66.666667% * var(--space-y-reverse));\n  }\n  .lg\\:space-x-8\\/12> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(66.666667% * var(--space-x-reverse));\n    margin-left: calc(66.666667% * calc(1 - var(--space-x-reverse)));\n  }\n  .lg\\:space-y-9\\/12> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(75% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(75% * var(--space-y-reverse));\n  }\n  .lg\\:space-x-9\\/12> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(75% * var(--space-x-reverse));\n    margin-left: calc(75% * calc(1 - var(--space-x-reverse)));\n  }\n  .lg\\:space-y-10\\/12> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(83.333333% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(83.333333% * var(--space-y-reverse));\n  }\n  .lg\\:space-x-10\\/12> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(83.333333% * var(--space-x-reverse));\n    margin-left: calc(83.333333% * calc(1 - var(--space-x-reverse)));\n  }\n  .lg\\:space-y-11\\/12> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(91.666667% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(91.666667% * var(--space-y-reverse));\n  }\n  .lg\\:space-x-11\\/12> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(91.666667% * var(--space-x-reverse));\n    margin-left: calc(91.666667% * calc(1 - var(--space-x-reverse)));\n  }\n  .lg\\:space-y-full> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(100% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(100% * var(--space-y-reverse));\n  }\n  .lg\\:space-x-full> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(100% * var(--space-x-reverse));\n    margin-left: calc(100% * calc(1 - var(--space-x-reverse)));\n  }\n  .lg\\:-space-y-1> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-0.25rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-0.25rem * var(--space-y-reverse));\n  }\n  .lg\\:-space-x-1> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-0.25rem * var(--space-x-reverse));\n    margin-left: calc(-0.25rem * calc(1 - var(--space-x-reverse)));\n  }\n  .lg\\:-space-y-2> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-0.5rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-0.5rem * var(--space-y-reverse));\n  }\n  .lg\\:-space-x-2> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-0.5rem * var(--space-x-reverse));\n    margin-left: calc(-0.5rem * calc(1 - var(--space-x-reverse)));\n  }\n  .lg\\:-space-y-3> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-0.75rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-0.75rem * var(--space-y-reverse));\n  }\n  .lg\\:-space-x-3> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-0.75rem * var(--space-x-reverse));\n    margin-left: calc(-0.75rem * calc(1 - var(--space-x-reverse)));\n  }\n  .lg\\:-space-y-4> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-1rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-1rem * var(--space-y-reverse));\n  }\n  .lg\\:-space-x-4> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-1rem * var(--space-x-reverse));\n    margin-left: calc(-1rem * calc(1 - var(--space-x-reverse)));\n  }\n  .lg\\:-space-y-5> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-1.25rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-1.25rem * var(--space-y-reverse));\n  }\n  .lg\\:-space-x-5> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-1.25rem * var(--space-x-reverse));\n    margin-left: calc(-1.25rem * calc(1 - var(--space-x-reverse)));\n  }\n  .lg\\:-space-y-6> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-1.5rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-1.5rem * var(--space-y-reverse));\n  }\n  .lg\\:-space-x-6> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-1.5rem * var(--space-x-reverse));\n    margin-left: calc(-1.5rem * calc(1 - var(--space-x-reverse)));\n  }\n  .lg\\:-space-y-7> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-1.75rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-1.75rem * var(--space-y-reverse));\n  }\n  .lg\\:-space-x-7> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-1.75rem * var(--space-x-reverse));\n    margin-left: calc(-1.75rem * calc(1 - var(--space-x-reverse)));\n  }\n  .lg\\:-space-y-8> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-2rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-2rem * var(--space-y-reverse));\n  }\n  .lg\\:-space-x-8> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-2rem * var(--space-x-reverse));\n    margin-left: calc(-2rem * calc(1 - var(--space-x-reverse)));\n  }\n  .lg\\:-space-y-9> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-2.25rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-2.25rem * var(--space-y-reverse));\n  }\n  .lg\\:-space-x-9> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-2.25rem * var(--space-x-reverse));\n    margin-left: calc(-2.25rem * calc(1 - var(--space-x-reverse)));\n  }\n  .lg\\:-space-y-10> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-2.5rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-2.5rem * var(--space-y-reverse));\n  }\n  .lg\\:-space-x-10> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-2.5rem * var(--space-x-reverse));\n    margin-left: calc(-2.5rem * calc(1 - var(--space-x-reverse)));\n  }\n  .lg\\:-space-y-11> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-2.75rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-2.75rem * var(--space-y-reverse));\n  }\n  .lg\\:-space-x-11> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-2.75rem * var(--space-x-reverse));\n    margin-left: calc(-2.75rem * calc(1 - var(--space-x-reverse)));\n  }\n  .lg\\:-space-y-12> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-3rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-3rem * var(--space-y-reverse));\n  }\n  .lg\\:-space-x-12> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-3rem * var(--space-x-reverse));\n    margin-left: calc(-3rem * calc(1 - var(--space-x-reverse)));\n  }\n  .lg\\:-space-y-13> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-3.25rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-3.25rem * var(--space-y-reverse));\n  }\n  .lg\\:-space-x-13> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-3.25rem * var(--space-x-reverse));\n    margin-left: calc(-3.25rem * calc(1 - var(--space-x-reverse)));\n  }\n  .lg\\:-space-y-14> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-3.5rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-3.5rem * var(--space-y-reverse));\n  }\n  .lg\\:-space-x-14> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-3.5rem * var(--space-x-reverse));\n    margin-left: calc(-3.5rem * calc(1 - var(--space-x-reverse)));\n  }\n  .lg\\:-space-y-15> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-3.75rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-3.75rem * var(--space-y-reverse));\n  }\n  .lg\\:-space-x-15> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-3.75rem * var(--space-x-reverse));\n    margin-left: calc(-3.75rem * calc(1 - var(--space-x-reverse)));\n  }\n  .lg\\:-space-y-16> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-4rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-4rem * var(--space-y-reverse));\n  }\n  .lg\\:-space-x-16> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-4rem * var(--space-x-reverse));\n    margin-left: calc(-4rem * calc(1 - var(--space-x-reverse)));\n  }\n  .lg\\:-space-y-20> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-5rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-5rem * var(--space-y-reverse));\n  }\n  .lg\\:-space-x-20> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-5rem * var(--space-x-reverse));\n    margin-left: calc(-5rem * calc(1 - var(--space-x-reverse)));\n  }\n  .lg\\:-space-y-24> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-6rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-6rem * var(--space-y-reverse));\n  }\n  .lg\\:-space-x-24> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-6rem * var(--space-x-reverse));\n    margin-left: calc(-6rem * calc(1 - var(--space-x-reverse)));\n  }\n  .lg\\:-space-y-28> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-7rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-7rem * var(--space-y-reverse));\n  }\n  .lg\\:-space-x-28> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-7rem * var(--space-x-reverse));\n    margin-left: calc(-7rem * calc(1 - var(--space-x-reverse)));\n  }\n  .lg\\:-space-y-32> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-8rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-8rem * var(--space-y-reverse));\n  }\n  .lg\\:-space-x-32> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-8rem * var(--space-x-reverse));\n    margin-left: calc(-8rem * calc(1 - var(--space-x-reverse)));\n  }\n  .lg\\:-space-y-36> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-9rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-9rem * var(--space-y-reverse));\n  }\n  .lg\\:-space-x-36> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-9rem * var(--space-x-reverse));\n    margin-left: calc(-9rem * calc(1 - var(--space-x-reverse)));\n  }\n  .lg\\:-space-y-40> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-10rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-10rem * var(--space-y-reverse));\n  }\n  .lg\\:-space-x-40> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-10rem * var(--space-x-reverse));\n    margin-left: calc(-10rem * calc(1 - var(--space-x-reverse)));\n  }\n  .lg\\:-space-y-44> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-11rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-11rem * var(--space-y-reverse));\n  }\n  .lg\\:-space-x-44> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-11rem * var(--space-x-reverse));\n    margin-left: calc(-11rem * calc(1 - var(--space-x-reverse)));\n  }\n  .lg\\:-space-y-48> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-12rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-12rem * var(--space-y-reverse));\n  }\n  .lg\\:-space-x-48> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-12rem * var(--space-x-reverse));\n    margin-left: calc(-12rem * calc(1 - var(--space-x-reverse)));\n  }\n  .lg\\:-space-y-52> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-13rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-13rem * var(--space-y-reverse));\n  }\n  .lg\\:-space-x-52> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-13rem * var(--space-x-reverse));\n    margin-left: calc(-13rem * calc(1 - var(--space-x-reverse)));\n  }\n  .lg\\:-space-y-56> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-14rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-14rem * var(--space-y-reverse));\n  }\n  .lg\\:-space-x-56> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-14rem * var(--space-x-reverse));\n    margin-left: calc(-14rem * calc(1 - var(--space-x-reverse)));\n  }\n  .lg\\:-space-y-60> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-15rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-15rem * var(--space-y-reverse));\n  }\n  .lg\\:-space-x-60> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-15rem * var(--space-x-reverse));\n    margin-left: calc(-15rem * calc(1 - var(--space-x-reverse)));\n  }\n  .lg\\:-space-y-64> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-16rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-16rem * var(--space-y-reverse));\n  }\n  .lg\\:-space-x-64> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-16rem * var(--space-x-reverse));\n    margin-left: calc(-16rem * calc(1 - var(--space-x-reverse)));\n  }\n  .lg\\:-space-y-72> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-18rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-18rem * var(--space-y-reverse));\n  }\n  .lg\\:-space-x-72> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-18rem * var(--space-x-reverse));\n    margin-left: calc(-18rem * calc(1 - var(--space-x-reverse)));\n  }\n  .lg\\:-space-y-80> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-20rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-20rem * var(--space-y-reverse));\n  }\n  .lg\\:-space-x-80> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-20rem * var(--space-x-reverse));\n    margin-left: calc(-20rem * calc(1 - var(--space-x-reverse)));\n  }\n  .lg\\:-space-y-96> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-24rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-24rem * var(--space-y-reverse));\n  }\n  .lg\\:-space-x-96> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-24rem * var(--space-x-reverse));\n    margin-left: calc(-24rem * calc(1 - var(--space-x-reverse)));\n  }\n  .lg\\:-space-y-px> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-1px * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-1px * var(--space-y-reverse));\n  }\n  .lg\\:-space-x-px> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-1px * var(--space-x-reverse));\n    margin-left: calc(-1px * calc(1 - var(--space-x-reverse)));\n  }\n  .lg\\:-space-y-0\\.5> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-0.125rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-0.125rem * var(--space-y-reverse));\n  }\n  .lg\\:-space-x-0\\.5> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-0.125rem * var(--space-x-reverse));\n    margin-left: calc(-0.125rem * calc(1 - var(--space-x-reverse)));\n  }\n  .lg\\:-space-y-1\\.5> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-0.375rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-0.375rem * var(--space-y-reverse));\n  }\n  .lg\\:-space-x-1\\.5> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-0.375rem * var(--space-x-reverse));\n    margin-left: calc(-0.375rem * calc(1 - var(--space-x-reverse)));\n  }\n  .lg\\:-space-y-2\\.5> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-0.625rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-0.625rem * var(--space-y-reverse));\n  }\n  .lg\\:-space-x-2\\.5> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-0.625rem * var(--space-x-reverse));\n    margin-left: calc(-0.625rem * calc(1 - var(--space-x-reverse)));\n  }\n  .lg\\:-space-y-3\\.5> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-0.875rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-0.875rem * var(--space-y-reverse));\n  }\n  .lg\\:-space-x-3\\.5> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-0.875rem * var(--space-x-reverse));\n    margin-left: calc(-0.875rem * calc(1 - var(--space-x-reverse)));\n  }\n  .lg\\:-space-y-1\\/2> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-50% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-50% * var(--space-y-reverse));\n  }\n  .lg\\:-space-x-1\\/2> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-50% * var(--space-x-reverse));\n    margin-left: calc(-50% * calc(1 - var(--space-x-reverse)));\n  }\n  .lg\\:-space-y-1\\/3> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-33.33333% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-33.33333% * var(--space-y-reverse));\n  }\n  .lg\\:-space-x-1\\/3> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-33.33333% * var(--space-x-reverse));\n    margin-left: calc(-33.33333% * calc(1 - var(--space-x-reverse)));\n  }\n  .lg\\:-space-y-2\\/3> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-66.66667% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-66.66667% * var(--space-y-reverse));\n  }\n  .lg\\:-space-x-2\\/3> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-66.66667% * var(--space-x-reverse));\n    margin-left: calc(-66.66667% * calc(1 - var(--space-x-reverse)));\n  }\n  .lg\\:-space-y-1\\/4> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-25% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-25% * var(--space-y-reverse));\n  }\n  .lg\\:-space-x-1\\/4> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-25% * var(--space-x-reverse));\n    margin-left: calc(-25% * calc(1 - var(--space-x-reverse)));\n  }\n  .lg\\:-space-y-2\\/4> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-50% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-50% * var(--space-y-reverse));\n  }\n  .lg\\:-space-x-2\\/4> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-50% * var(--space-x-reverse));\n    margin-left: calc(-50% * calc(1 - var(--space-x-reverse)));\n  }\n  .lg\\:-space-y-3\\/4> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-75% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-75% * var(--space-y-reverse));\n  }\n  .lg\\:-space-x-3\\/4> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-75% * var(--space-x-reverse));\n    margin-left: calc(-75% * calc(1 - var(--space-x-reverse)));\n  }\n  .lg\\:-space-y-1\\/5> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-20% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-20% * var(--space-y-reverse));\n  }\n  .lg\\:-space-x-1\\/5> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-20% * var(--space-x-reverse));\n    margin-left: calc(-20% * calc(1 - var(--space-x-reverse)));\n  }\n  .lg\\:-space-y-2\\/5> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-40% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-40% * var(--space-y-reverse));\n  }\n  .lg\\:-space-x-2\\/5> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-40% * var(--space-x-reverse));\n    margin-left: calc(-40% * calc(1 - var(--space-x-reverse)));\n  }\n  .lg\\:-space-y-3\\/5> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-60% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-60% * var(--space-y-reverse));\n  }\n  .lg\\:-space-x-3\\/5> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-60% * var(--space-x-reverse));\n    margin-left: calc(-60% * calc(1 - var(--space-x-reverse)));\n  }\n  .lg\\:-space-y-4\\/5> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-80% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-80% * var(--space-y-reverse));\n  }\n  .lg\\:-space-x-4\\/5> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-80% * var(--space-x-reverse));\n    margin-left: calc(-80% * calc(1 - var(--space-x-reverse)));\n  }\n  .lg\\:-space-y-1\\/6> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-16.66667% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-16.66667% * var(--space-y-reverse));\n  }\n  .lg\\:-space-x-1\\/6> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-16.66667% * var(--space-x-reverse));\n    margin-left: calc(-16.66667% * calc(1 - var(--space-x-reverse)));\n  }\n  .lg\\:-space-y-2\\/6> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-33.33333% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-33.33333% * var(--space-y-reverse));\n  }\n  .lg\\:-space-x-2\\/6> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-33.33333% * var(--space-x-reverse));\n    margin-left: calc(-33.33333% * calc(1 - var(--space-x-reverse)));\n  }\n  .lg\\:-space-y-3\\/6> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-50% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-50% * var(--space-y-reverse));\n  }\n  .lg\\:-space-x-3\\/6> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-50% * var(--space-x-reverse));\n    margin-left: calc(-50% * calc(1 - var(--space-x-reverse)));\n  }\n  .lg\\:-space-y-4\\/6> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-66.66667% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-66.66667% * var(--space-y-reverse));\n  }\n  .lg\\:-space-x-4\\/6> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-66.66667% * var(--space-x-reverse));\n    margin-left: calc(-66.66667% * calc(1 - var(--space-x-reverse)));\n  }\n  .lg\\:-space-y-5\\/6> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-83.33333% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-83.33333% * var(--space-y-reverse));\n  }\n  .lg\\:-space-x-5\\/6> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-83.33333% * var(--space-x-reverse));\n    margin-left: calc(-83.33333% * calc(1 - var(--space-x-reverse)));\n  }\n  .lg\\:-space-y-1\\/12> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-8.33333% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-8.33333% * var(--space-y-reverse));\n  }\n  .lg\\:-space-x-1\\/12> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-8.33333% * var(--space-x-reverse));\n    margin-left: calc(-8.33333% * calc(1 - var(--space-x-reverse)));\n  }\n  .lg\\:-space-y-2\\/12> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-16.66667% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-16.66667% * var(--space-y-reverse));\n  }\n  .lg\\:-space-x-2\\/12> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-16.66667% * var(--space-x-reverse));\n    margin-left: calc(-16.66667% * calc(1 - var(--space-x-reverse)));\n  }\n  .lg\\:-space-y-3\\/12> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-25% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-25% * var(--space-y-reverse));\n  }\n  .lg\\:-space-x-3\\/12> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-25% * var(--space-x-reverse));\n    margin-left: calc(-25% * calc(1 - var(--space-x-reverse)));\n  }\n  .lg\\:-space-y-4\\/12> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-33.33333% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-33.33333% * var(--space-y-reverse));\n  }\n  .lg\\:-space-x-4\\/12> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-33.33333% * var(--space-x-reverse));\n    margin-left: calc(-33.33333% * calc(1 - var(--space-x-reverse)));\n  }\n  .lg\\:-space-y-5\\/12> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-41.66667% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-41.66667% * var(--space-y-reverse));\n  }\n  .lg\\:-space-x-5\\/12> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-41.66667% * var(--space-x-reverse));\n    margin-left: calc(-41.66667% * calc(1 - var(--space-x-reverse)));\n  }\n  .lg\\:-space-y-6\\/12> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-50% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-50% * var(--space-y-reverse));\n  }\n  .lg\\:-space-x-6\\/12> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-50% * var(--space-x-reverse));\n    margin-left: calc(-50% * calc(1 - var(--space-x-reverse)));\n  }\n  .lg\\:-space-y-7\\/12> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-58.33333% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-58.33333% * var(--space-y-reverse));\n  }\n  .lg\\:-space-x-7\\/12> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-58.33333% * var(--space-x-reverse));\n    margin-left: calc(-58.33333% * calc(1 - var(--space-x-reverse)));\n  }\n  .lg\\:-space-y-8\\/12> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-66.66667% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-66.66667% * var(--space-y-reverse));\n  }\n  .lg\\:-space-x-8\\/12> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-66.66667% * var(--space-x-reverse));\n    margin-left: calc(-66.66667% * calc(1 - var(--space-x-reverse)));\n  }\n  .lg\\:-space-y-9\\/12> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-75% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-75% * var(--space-y-reverse));\n  }\n  .lg\\:-space-x-9\\/12> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-75% * var(--space-x-reverse));\n    margin-left: calc(-75% * calc(1 - var(--space-x-reverse)));\n  }\n  .lg\\:-space-y-10\\/12> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-83.33333% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-83.33333% * var(--space-y-reverse));\n  }\n  .lg\\:-space-x-10\\/12> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-83.33333% * var(--space-x-reverse));\n    margin-left: calc(-83.33333% * calc(1 - var(--space-x-reverse)));\n  }\n  .lg\\:-space-y-11\\/12> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-91.66667% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-91.66667% * var(--space-y-reverse));\n  }\n  .lg\\:-space-x-11\\/12> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-91.66667% * var(--space-x-reverse));\n    margin-left: calc(-91.66667% * calc(1 - var(--space-x-reverse)));\n  }\n  .lg\\:-space-y-full> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-100% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-100% * var(--space-y-reverse));\n  }\n  .lg\\:-space-x-full> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-100% * var(--space-x-reverse));\n    margin-left: calc(-100% * calc(1 - var(--space-x-reverse)));\n  }\n  .lg\\:space-y-reverse> :not(template)~ :not(template) {\n    --space-y-reverse: 1;\n  }\n  .lg\\:space-x-reverse> :not(template)~ :not(template) {\n    --space-x-reverse: 1;\n  }\n  .lg\\:divide-y-0> :not(template)~ :not(template) {\n    --divide-y-reverse: 0;\n    border-top-width: calc(0px * calc(1 - var(--divide-y-reverse)));\n    border-bottom-width: calc(0px * var(--divide-y-reverse));\n  }\n  .lg\\:divide-x-0> :not(template)~ :not(template) {\n    --divide-x-reverse: 0;\n    border-right-width: calc(0px * var(--divide-x-reverse));\n    border-left-width: calc(0px * calc(1 - var(--divide-x-reverse)));\n  }\n  .lg\\:divide-y-2> :not(template)~ :not(template) {\n    --divide-y-reverse: 0;\n    border-top-width: calc(2px * calc(1 - var(--divide-y-reverse)));\n    border-bottom-width: calc(2px * var(--divide-y-reverse));\n  }\n  .lg\\:divide-x-2> :not(template)~ :not(template) {\n    --divide-x-reverse: 0;\n    border-right-width: calc(2px * var(--divide-x-reverse));\n    border-left-width: calc(2px * calc(1 - var(--divide-x-reverse)));\n  }\n  .lg\\:divide-y-4> :not(template)~ :not(template) {\n    --divide-y-reverse: 0;\n    border-top-width: calc(4px * calc(1 - var(--divide-y-reverse)));\n    border-bottom-width: calc(4px * var(--divide-y-reverse));\n  }\n  .lg\\:divide-x-4> :not(template)~ :not(template) {\n    --divide-x-reverse: 0;\n    border-right-width: calc(4px * var(--divide-x-reverse));\n    border-left-width: calc(4px * calc(1 - var(--divide-x-reverse)));\n  }\n  .lg\\:divide-y-8> :not(template)~ :not(template) {\n    --divide-y-reverse: 0;\n    border-top-width: calc(8px * calc(1 - var(--divide-y-reverse)));\n    border-bottom-width: calc(8px * var(--divide-y-reverse));\n  }\n  .lg\\:divide-x-8> :not(template)~ :not(template) {\n    --divide-x-reverse: 0;\n    border-right-width: calc(8px * var(--divide-x-reverse));\n    border-left-width: calc(8px * calc(1 - var(--divide-x-reverse)));\n  }\n  .lg\\:divide-y> :not(template)~ :not(template) {\n    --divide-y-reverse: 0;\n    border-top-width: calc(1px * calc(1 - var(--divide-y-reverse)));\n    border-bottom-width: calc(1px * var(--divide-y-reverse));\n  }\n  .lg\\:divide-x> :not(template)~ :not(template) {\n    --divide-x-reverse: 0;\n    border-right-width: calc(1px * var(--divide-x-reverse));\n    border-left-width: calc(1px * calc(1 - var(--divide-x-reverse)));\n  }\n  .lg\\:divide-y-reverse> :not(template)~ :not(template) {\n    --divide-y-reverse: 1;\n  }\n  .lg\\:divide-x-reverse> :not(template)~ :not(template) {\n    --divide-x-reverse: 1;\n  }\n  .lg\\:divide-current> :not(template)~ :not(template) {\n    border-color: currentColor;\n  }\n  .lg\\:divide-transparent> :not(template)~ :not(template) {\n    border-color: transparent;\n  }\n  .lg\\:divide-white> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #ffffff;\n    border-color: rgba(255, 255, 255, var(--divide-opacity));\n  }\n  .lg\\:divide-black> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #000000;\n    border-color: rgba(0, 0, 0, var(--divide-opacity));\n  }\n  .lg\\:divide-gray-50> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #f9fafb;\n    border-color: rgba(249, 250, 251, var(--divide-opacity));\n  }\n  .lg\\:divide-gray-100> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #f4f5f7;\n    border-color: rgba(244, 245, 247, var(--divide-opacity));\n  }\n  .lg\\:divide-gray-200> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #e5e7eb;\n    border-color: rgba(229, 231, 235, var(--divide-opacity));\n  }\n  .lg\\:divide-gray-300> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #d2d6dc;\n    border-color: rgba(210, 214, 220, var(--divide-opacity));\n  }\n  .lg\\:divide-gray-400> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #9fa6b2;\n    border-color: rgba(159, 166, 178, var(--divide-opacity));\n  }\n  .lg\\:divide-gray-500> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #6b7280;\n    border-color: rgba(107, 114, 128, var(--divide-opacity));\n  }\n  .lg\\:divide-gray-600> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #4b5563;\n    border-color: rgba(75, 85, 99, var(--divide-opacity));\n  }\n  .lg\\:divide-gray-700> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #374151;\n    border-color: rgba(55, 65, 81, var(--divide-opacity));\n  }\n  .lg\\:divide-gray-800> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #252f3f;\n    border-color: rgba(37, 47, 63, var(--divide-opacity));\n  }\n  .lg\\:divide-gray-900> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #161e2e;\n    border-color: rgba(22, 30, 46, var(--divide-opacity));\n  }\n  .lg\\:divide-red-50> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #fdf2f2;\n    border-color: rgba(253, 242, 242, var(--divide-opacity));\n  }\n  .lg\\:divide-red-100> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #fde8e8;\n    border-color: rgba(253, 232, 232, var(--divide-opacity));\n  }\n  .lg\\:divide-red-200> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #fbd5d5;\n    border-color: rgba(251, 213, 213, var(--divide-opacity));\n  }\n  .lg\\:divide-red-300> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #f8b4b4;\n    border-color: rgba(248, 180, 180, var(--divide-opacity));\n  }\n  .lg\\:divide-red-400> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #f98080;\n    border-color: rgba(249, 128, 128, var(--divide-opacity));\n  }\n  .lg\\:divide-red-500> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #f05252;\n    border-color: rgba(240, 82, 82, var(--divide-opacity));\n  }\n  .lg\\:divide-red-600> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #e02424;\n    border-color: rgba(224, 36, 36, var(--divide-opacity));\n  }\n  .lg\\:divide-red-700> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #c81e1e;\n    border-color: rgba(200, 30, 30, var(--divide-opacity));\n  }\n  .lg\\:divide-red-800> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #9b1c1c;\n    border-color: rgba(155, 28, 28, var(--divide-opacity));\n  }\n  .lg\\:divide-red-900> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #771d1d;\n    border-color: rgba(119, 29, 29, var(--divide-opacity));\n  }\n  .lg\\:divide-orange-50> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #fff8f1;\n    border-color: rgba(255, 248, 241, var(--divide-opacity));\n  }\n  .lg\\:divide-orange-100> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #feecdc;\n    border-color: rgba(254, 236, 220, var(--divide-opacity));\n  }\n  .lg\\:divide-orange-200> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #fcd9bd;\n    border-color: rgba(252, 217, 189, var(--divide-opacity));\n  }\n  .lg\\:divide-orange-300> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #fdba8c;\n    border-color: rgba(253, 186, 140, var(--divide-opacity));\n  }\n  .lg\\:divide-orange-400> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #ff8a4c;\n    border-color: rgba(255, 138, 76, var(--divide-opacity));\n  }\n  .lg\\:divide-orange-500> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #ff5a1f;\n    border-color: rgba(255, 90, 31, var(--divide-opacity));\n  }\n  .lg\\:divide-orange-600> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #d03801;\n    border-color: rgba(208, 56, 1, var(--divide-opacity));\n  }\n  .lg\\:divide-orange-700> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #b43403;\n    border-color: rgba(180, 52, 3, var(--divide-opacity));\n  }\n  .lg\\:divide-orange-800> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #8a2c0d;\n    border-color: rgba(138, 44, 13, var(--divide-opacity));\n  }\n  .lg\\:divide-orange-900> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #73230d;\n    border-color: rgba(115, 35, 13, var(--divide-opacity));\n  }\n  .lg\\:divide-yellow-50> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #fdfdea;\n    border-color: rgba(253, 253, 234, var(--divide-opacity));\n  }\n  .lg\\:divide-yellow-100> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #fdf6b2;\n    border-color: rgba(253, 246, 178, var(--divide-opacity));\n  }\n  .lg\\:divide-yellow-200> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #fce96a;\n    border-color: rgba(252, 233, 106, var(--divide-opacity));\n  }\n  .lg\\:divide-yellow-300> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #faca15;\n    border-color: rgba(250, 202, 21, var(--divide-opacity));\n  }\n  .lg\\:divide-yellow-400> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #e3a008;\n    border-color: rgba(227, 160, 8, var(--divide-opacity));\n  }\n  .lg\\:divide-yellow-500> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #c27803;\n    border-color: rgba(194, 120, 3, var(--divide-opacity));\n  }\n  .lg\\:divide-yellow-600> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #9f580a;\n    border-color: rgba(159, 88, 10, var(--divide-opacity));\n  }\n  .lg\\:divide-yellow-700> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #8e4b10;\n    border-color: rgba(142, 75, 16, var(--divide-opacity));\n  }\n  .lg\\:divide-yellow-800> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #723b13;\n    border-color: rgba(114, 59, 19, var(--divide-opacity));\n  }\n  .lg\\:divide-yellow-900> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #633112;\n    border-color: rgba(99, 49, 18, var(--divide-opacity));\n  }\n  .lg\\:divide-green-50> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #f3faf7;\n    border-color: rgba(243, 250, 247, var(--divide-opacity));\n  }\n  .lg\\:divide-green-100> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #def7ec;\n    border-color: rgba(222, 247, 236, var(--divide-opacity));\n  }\n  .lg\\:divide-green-200> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #bcf0da;\n    border-color: rgba(188, 240, 218, var(--divide-opacity));\n  }\n  .lg\\:divide-green-300> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #84e1bc;\n    border-color: rgba(132, 225, 188, var(--divide-opacity));\n  }\n  .lg\\:divide-green-400> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #31c48d;\n    border-color: rgba(49, 196, 141, var(--divide-opacity));\n  }\n  .lg\\:divide-green-500> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #0e9f6e;\n    border-color: rgba(14, 159, 110, var(--divide-opacity));\n  }\n  .lg\\:divide-green-600> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #057a55;\n    border-color: rgba(5, 122, 85, var(--divide-opacity));\n  }\n  .lg\\:divide-green-700> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #046c4e;\n    border-color: rgba(4, 108, 78, var(--divide-opacity));\n  }\n  .lg\\:divide-green-800> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #03543f;\n    border-color: rgba(3, 84, 63, var(--divide-opacity));\n  }\n  .lg\\:divide-green-900> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #014737;\n    border-color: rgba(1, 71, 55, var(--divide-opacity));\n  }\n  .lg\\:divide-teal-50> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #edfafa;\n    border-color: rgba(237, 250, 250, var(--divide-opacity));\n  }\n  .lg\\:divide-teal-100> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #d5f5f6;\n    border-color: rgba(213, 245, 246, var(--divide-opacity));\n  }\n  .lg\\:divide-teal-200> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #afecef;\n    border-color: rgba(175, 236, 239, var(--divide-opacity));\n  }\n  .lg\\:divide-teal-300> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #7edce2;\n    border-color: rgba(126, 220, 226, var(--divide-opacity));\n  }\n  .lg\\:divide-teal-400> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #16bdca;\n    border-color: rgba(22, 189, 202, var(--divide-opacity));\n  }\n  .lg\\:divide-teal-500> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #0694a2;\n    border-color: rgba(6, 148, 162, var(--divide-opacity));\n  }\n  .lg\\:divide-teal-600> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #047481;\n    border-color: rgba(4, 116, 129, var(--divide-opacity));\n  }\n  .lg\\:divide-teal-700> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #036672;\n    border-color: rgba(3, 102, 114, var(--divide-opacity));\n  }\n  .lg\\:divide-teal-800> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #05505c;\n    border-color: rgba(5, 80, 92, var(--divide-opacity));\n  }\n  .lg\\:divide-teal-900> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #014451;\n    border-color: rgba(1, 68, 81, var(--divide-opacity));\n  }\n  .lg\\:divide-blue-50> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #ebf5ff;\n    border-color: rgba(235, 245, 255, var(--divide-opacity));\n  }\n  .lg\\:divide-blue-100> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #e1effe;\n    border-color: rgba(225, 239, 254, var(--divide-opacity));\n  }\n  .lg\\:divide-blue-200> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #c3ddfd;\n    border-color: rgba(195, 221, 253, var(--divide-opacity));\n  }\n  .lg\\:divide-blue-300> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #a4cafe;\n    border-color: rgba(164, 202, 254, var(--divide-opacity));\n  }\n  .lg\\:divide-blue-400> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #76a9fa;\n    border-color: rgba(118, 169, 250, var(--divide-opacity));\n  }\n  .lg\\:divide-blue-500> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #3f83f8;\n    border-color: rgba(63, 131, 248, var(--divide-opacity));\n  }\n  .lg\\:divide-blue-600> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #1c64f2;\n    border-color: rgba(28, 100, 242, var(--divide-opacity));\n  }\n  .lg\\:divide-blue-700> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #1a56db;\n    border-color: rgba(26, 86, 219, var(--divide-opacity));\n  }\n  .lg\\:divide-blue-800> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #1e429f;\n    border-color: rgba(30, 66, 159, var(--divide-opacity));\n  }\n  .lg\\:divide-blue-900> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #233876;\n    border-color: rgba(35, 56, 118, var(--divide-opacity));\n  }\n  .lg\\:divide-indigo-50> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #f0f5ff;\n    border-color: rgba(240, 245, 255, var(--divide-opacity));\n  }\n  .lg\\:divide-indigo-100> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #e5edff;\n    border-color: rgba(229, 237, 255, var(--divide-opacity));\n  }\n  .lg\\:divide-indigo-200> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #cddbfe;\n    border-color: rgba(205, 219, 254, var(--divide-opacity));\n  }\n  .lg\\:divide-indigo-300> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #b4c6fc;\n    border-color: rgba(180, 198, 252, var(--divide-opacity));\n  }\n  .lg\\:divide-indigo-400> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #8da2fb;\n    border-color: rgba(141, 162, 251, var(--divide-opacity));\n  }\n  .lg\\:divide-indigo-500> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #6875f5;\n    border-color: rgba(104, 117, 245, var(--divide-opacity));\n  }\n  .lg\\:divide-indigo-600> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #5850ec;\n    border-color: rgba(88, 80, 236, var(--divide-opacity));\n  }\n  .lg\\:divide-indigo-700> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #5145cd;\n    border-color: rgba(81, 69, 205, var(--divide-opacity));\n  }\n  .lg\\:divide-indigo-800> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #42389d;\n    border-color: rgba(66, 56, 157, var(--divide-opacity));\n  }\n  .lg\\:divide-indigo-900> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #362f78;\n    border-color: rgba(54, 47, 120, var(--divide-opacity));\n  }\n  .lg\\:divide-purple-50> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #f6f5ff;\n    border-color: rgba(246, 245, 255, var(--divide-opacity));\n  }\n  .lg\\:divide-purple-100> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #edebfe;\n    border-color: rgba(237, 235, 254, var(--divide-opacity));\n  }\n  .lg\\:divide-purple-200> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #dcd7fe;\n    border-color: rgba(220, 215, 254, var(--divide-opacity));\n  }\n  .lg\\:divide-purple-300> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #cabffd;\n    border-color: rgba(202, 191, 253, var(--divide-opacity));\n  }\n  .lg\\:divide-purple-400> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #ac94fa;\n    border-color: rgba(172, 148, 250, var(--divide-opacity));\n  }\n  .lg\\:divide-purple-500> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #9061f9;\n    border-color: rgba(144, 97, 249, var(--divide-opacity));\n  }\n  .lg\\:divide-purple-600> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #7e3af2;\n    border-color: rgba(126, 58, 242, var(--divide-opacity));\n  }\n  .lg\\:divide-purple-700> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #6c2bd9;\n    border-color: rgba(108, 43, 217, var(--divide-opacity));\n  }\n  .lg\\:divide-purple-800> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #5521b5;\n    border-color: rgba(85, 33, 181, var(--divide-opacity));\n  }\n  .lg\\:divide-purple-900> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #4a1d96;\n    border-color: rgba(74, 29, 150, var(--divide-opacity));\n  }\n  .lg\\:divide-pink-50> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #fdf2f8;\n    border-color: rgba(253, 242, 248, var(--divide-opacity));\n  }\n  .lg\\:divide-pink-100> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #fce8f3;\n    border-color: rgba(252, 232, 243, var(--divide-opacity));\n  }\n  .lg\\:divide-pink-200> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #fad1e8;\n    border-color: rgba(250, 209, 232, var(--divide-opacity));\n  }\n  .lg\\:divide-pink-300> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #f8b4d9;\n    border-color: rgba(248, 180, 217, var(--divide-opacity));\n  }\n  .lg\\:divide-pink-400> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #f17eb8;\n    border-color: rgba(241, 126, 184, var(--divide-opacity));\n  }\n  .lg\\:divide-pink-500> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #e74694;\n    border-color: rgba(231, 70, 148, var(--divide-opacity));\n  }\n  .lg\\:divide-pink-600> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #d61f69;\n    border-color: rgba(214, 31, 105, var(--divide-opacity));\n  }\n  .lg\\:divide-pink-700> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #bf125d;\n    border-color: rgba(191, 18, 93, var(--divide-opacity));\n  }\n  .lg\\:divide-pink-800> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #99154b;\n    border-color: rgba(153, 21, 75, var(--divide-opacity));\n  }\n  .lg\\:divide-pink-900> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #751a3d;\n    border-color: rgba(117, 26, 61, var(--divide-opacity));\n  }\n  .lg\\:divide-cool-gray-50> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #f8fafc;\n    border-color: rgba(248, 250, 252, var(--divide-opacity));\n  }\n  .lg\\:divide-cool-gray-100> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #f1f5f9;\n    border-color: rgba(241, 245, 249, var(--divide-opacity));\n  }\n  .lg\\:divide-cool-gray-200> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #e2e8f0;\n    border-color: rgba(226, 232, 240, var(--divide-opacity));\n  }\n  .lg\\:divide-cool-gray-300> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #cfd8e3;\n    border-color: rgba(207, 216, 227, var(--divide-opacity));\n  }\n  .lg\\:divide-cool-gray-400> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #97a6ba;\n    border-color: rgba(151, 166, 186, var(--divide-opacity));\n  }\n  .lg\\:divide-cool-gray-500> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #64748b;\n    border-color: rgba(100, 116, 139, var(--divide-opacity));\n  }\n  .lg\\:divide-cool-gray-600> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #475569;\n    border-color: rgba(71, 85, 105, var(--divide-opacity));\n  }\n  .lg\\:divide-cool-gray-700> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #364152;\n    border-color: rgba(54, 65, 82, var(--divide-opacity));\n  }\n  .lg\\:divide-cool-gray-800> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #27303f;\n    border-color: rgba(39, 48, 63, var(--divide-opacity));\n  }\n  .lg\\:divide-cool-gray-900> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #1a202e;\n    border-color: rgba(26, 32, 46, var(--divide-opacity));\n  }\n  .lg\\:divide-solid> :not(template)~ :not(template) {\n    border-style: solid;\n  }\n  .lg\\:divide-dashed> :not(template)~ :not(template) {\n    border-style: dashed;\n  }\n  .lg\\:divide-dotted> :not(template)~ :not(template) {\n    border-style: dotted;\n  }\n  .lg\\:divide-double> :not(template)~ :not(template) {\n    border-style: double;\n  }\n  .lg\\:divide-none> :not(template)~ :not(template) {\n    border-style: none;\n  }\n  .lg\\:divide-opacity-0> :not(template)~ :not(template) {\n    --divide-opacity: 0;\n  }\n  .lg\\:divide-opacity-25> :not(template)~ :not(template) {\n    --divide-opacity: 0.25;\n  }\n  .lg\\:divide-opacity-50> :not(template)~ :not(template) {\n    --divide-opacity: 0.5;\n  }\n  .lg\\:divide-opacity-75> :not(template)~ :not(template) {\n    --divide-opacity: 0.75;\n  }\n  .lg\\:divide-opacity-100> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n  }\n  .lg\\:sr-only {\n    position: absolute;\n    width: 1px;\n    height: 1px;\n    padding: 0;\n    margin: -1px;\n    overflow: hidden;\n    clip: rect(0, 0, 0, 0);\n    white-space: nowrap;\n    border-width: 0;\n  }\n  .lg\\:not-sr-only {\n    position: static;\n    width: auto;\n    height: auto;\n    padding: 0;\n    margin: 0;\n    overflow: visible;\n    clip: auto;\n    white-space: normal;\n  }\n  .lg\\:focus\\:sr-only:focus {\n    position: absolute;\n    width: 1px;\n    height: 1px;\n    padding: 0;\n    margin: -1px;\n    overflow: hidden;\n    clip: rect(0, 0, 0, 0);\n    white-space: nowrap;\n    border-width: 0;\n  }\n  .lg\\:focus\\:not-sr-only:focus {\n    position: static;\n    width: auto;\n    height: auto;\n    padding: 0;\n    margin: 0;\n    overflow: visible;\n    clip: auto;\n    white-space: normal;\n  }\n  .lg\\:appearance-none {\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    appearance: none;\n  }\n  .lg\\:bg-fixed {\n    background-attachment: fixed;\n  }\n  .lg\\:bg-local {\n    background-attachment: local;\n  }\n  .lg\\:bg-scroll {\n    background-attachment: scroll;\n  }\n  .lg\\:bg-clip-border {\n    background-clip: border-box;\n  }\n  .lg\\:bg-clip-padding {\n    background-clip: padding-box;\n  }\n  .lg\\:bg-clip-content {\n    background-clip: content-box;\n  }\n  .lg\\:bg-clip-text {\n    -webkit-background-clip: text;\n    background-clip: text;\n  }\n  .lg\\:bg-current {\n    background-color: currentColor;\n  }\n  .lg\\:bg-transparent {\n    background-color: transparent;\n  }\n  .lg\\:bg-white {\n    --bg-opacity: 1;\n    background-color: #ffffff;\n    background-color: rgba(255, 255, 255, var(--bg-opacity));\n  }\n  .lg\\:bg-black {\n    --bg-opacity: 1;\n    background-color: #000000;\n    background-color: rgba(0, 0, 0, var(--bg-opacity));\n  }\n  .lg\\:bg-gray-50 {\n    --bg-opacity: 1;\n    background-color: #f9fafb;\n    background-color: rgba(249, 250, 251, var(--bg-opacity));\n  }\n  .lg\\:bg-gray-100 {\n    --bg-opacity: 1;\n    background-color: #f4f5f7;\n    background-color: rgba(244, 245, 247, var(--bg-opacity));\n  }\n  .lg\\:bg-gray-200 {\n    --bg-opacity: 1;\n    background-color: #e5e7eb;\n    background-color: rgba(229, 231, 235, var(--bg-opacity));\n  }\n  .lg\\:bg-gray-300 {\n    --bg-opacity: 1;\n    background-color: #d2d6dc;\n    background-color: rgba(210, 214, 220, var(--bg-opacity));\n  }\n  .lg\\:bg-gray-400 {\n    --bg-opacity: 1;\n    background-color: #9fa6b2;\n    background-color: rgba(159, 166, 178, var(--bg-opacity));\n  }\n  .lg\\:bg-gray-500 {\n    --bg-opacity: 1;\n    background-color: #6b7280;\n    background-color: rgba(107, 114, 128, var(--bg-opacity));\n  }\n  .lg\\:bg-gray-600 {\n    --bg-opacity: 1;\n    background-color: #4b5563;\n    background-color: rgba(75, 85, 99, var(--bg-opacity));\n  }\n  .lg\\:bg-gray-700 {\n    --bg-opacity: 1;\n    background-color: #374151;\n    background-color: rgba(55, 65, 81, var(--bg-opacity));\n  }\n  .lg\\:bg-gray-800 {\n    --bg-opacity: 1;\n    background-color: #252f3f;\n    background-color: rgba(37, 47, 63, var(--bg-opacity));\n  }\n  .lg\\:bg-gray-900 {\n    --bg-opacity: 1;\n    background-color: #161e2e;\n    background-color: rgba(22, 30, 46, var(--bg-opacity));\n  }\n  .lg\\:bg-red-50 {\n    --bg-opacity: 1;\n    background-color: #fdf2f2;\n    background-color: rgba(253, 242, 242, var(--bg-opacity));\n  }\n  .lg\\:bg-red-100 {\n    --bg-opacity: 1;\n    background-color: #fde8e8;\n    background-color: rgba(253, 232, 232, var(--bg-opacity));\n  }\n  .lg\\:bg-red-200 {\n    --bg-opacity: 1;\n    background-color: #fbd5d5;\n    background-color: rgba(251, 213, 213, var(--bg-opacity));\n  }\n  .lg\\:bg-red-300 {\n    --bg-opacity: 1;\n    background-color: #f8b4b4;\n    background-color: rgba(248, 180, 180, var(--bg-opacity));\n  }\n  .lg\\:bg-red-400 {\n    --bg-opacity: 1;\n    background-color: #f98080;\n    background-color: rgba(249, 128, 128, var(--bg-opacity));\n  }\n  .lg\\:bg-red-500 {\n    --bg-opacity: 1;\n    background-color: #f05252;\n    background-color: rgba(240, 82, 82, var(--bg-opacity));\n  }\n  .lg\\:bg-red-600 {\n    --bg-opacity: 1;\n    background-color: #e02424;\n    background-color: rgba(224, 36, 36, var(--bg-opacity));\n  }\n  .lg\\:bg-red-700 {\n    --bg-opacity: 1;\n    background-color: #c81e1e;\n    background-color: rgba(200, 30, 30, var(--bg-opacity));\n  }\n  .lg\\:bg-red-800 {\n    --bg-opacity: 1;\n    background-color: #9b1c1c;\n    background-color: rgba(155, 28, 28, var(--bg-opacity));\n  }\n  .lg\\:bg-red-900 {\n    --bg-opacity: 1;\n    background-color: #771d1d;\n    background-color: rgba(119, 29, 29, var(--bg-opacity));\n  }\n  .lg\\:bg-orange-50 {\n    --bg-opacity: 1;\n    background-color: #fff8f1;\n    background-color: rgba(255, 248, 241, var(--bg-opacity));\n  }\n  .lg\\:bg-orange-100 {\n    --bg-opacity: 1;\n    background-color: #feecdc;\n    background-color: rgba(254, 236, 220, var(--bg-opacity));\n  }\n  .lg\\:bg-orange-200 {\n    --bg-opacity: 1;\n    background-color: #fcd9bd;\n    background-color: rgba(252, 217, 189, var(--bg-opacity));\n  }\n  .lg\\:bg-orange-300 {\n    --bg-opacity: 1;\n    background-color: #fdba8c;\n    background-color: rgba(253, 186, 140, var(--bg-opacity));\n  }\n  .lg\\:bg-orange-400 {\n    --bg-opacity: 1;\n    background-color: #ff8a4c;\n    background-color: rgba(255, 138, 76, var(--bg-opacity));\n  }\n  .lg\\:bg-orange-500 {\n    --bg-opacity: 1;\n    background-color: #ff5a1f;\n    background-color: rgba(255, 90, 31, var(--bg-opacity));\n  }\n  .lg\\:bg-orange-600 {\n    --bg-opacity: 1;\n    background-color: #d03801;\n    background-color: rgba(208, 56, 1, var(--bg-opacity));\n  }\n  .lg\\:bg-orange-700 {\n    --bg-opacity: 1;\n    background-color: #b43403;\n    background-color: rgba(180, 52, 3, var(--bg-opacity));\n  }\n  .lg\\:bg-orange-800 {\n    --bg-opacity: 1;\n    background-color: #8a2c0d;\n    background-color: rgba(138, 44, 13, var(--bg-opacity));\n  }\n  .lg\\:bg-orange-900 {\n    --bg-opacity: 1;\n    background-color: #73230d;\n    background-color: rgba(115, 35, 13, var(--bg-opacity));\n  }\n  .lg\\:bg-yellow-50 {\n    --bg-opacity: 1;\n    background-color: #fdfdea;\n    background-color: rgba(253, 253, 234, var(--bg-opacity));\n  }\n  .lg\\:bg-yellow-100 {\n    --bg-opacity: 1;\n    background-color: #fdf6b2;\n    background-color: rgba(253, 246, 178, var(--bg-opacity));\n  }\n  .lg\\:bg-yellow-200 {\n    --bg-opacity: 1;\n    background-color: #fce96a;\n    background-color: rgba(252, 233, 106, var(--bg-opacity));\n  }\n  .lg\\:bg-yellow-300 {\n    --bg-opacity: 1;\n    background-color: #faca15;\n    background-color: rgba(250, 202, 21, var(--bg-opacity));\n  }\n  .lg\\:bg-yellow-400 {\n    --bg-opacity: 1;\n    background-color: #e3a008;\n    background-color: rgba(227, 160, 8, var(--bg-opacity));\n  }\n  .lg\\:bg-yellow-500 {\n    --bg-opacity: 1;\n    background-color: #c27803;\n    background-color: rgba(194, 120, 3, var(--bg-opacity));\n  }\n  .lg\\:bg-yellow-600 {\n    --bg-opacity: 1;\n    background-color: #9f580a;\n    background-color: rgba(159, 88, 10, var(--bg-opacity));\n  }\n  .lg\\:bg-yellow-700 {\n    --bg-opacity: 1;\n    background-color: #8e4b10;\n    background-color: rgba(142, 75, 16, var(--bg-opacity));\n  }\n  .lg\\:bg-yellow-800 {\n    --bg-opacity: 1;\n    background-color: #723b13;\n    background-color: rgba(114, 59, 19, var(--bg-opacity));\n  }\n  .lg\\:bg-yellow-900 {\n    --bg-opacity: 1;\n    background-color: #633112;\n    background-color: rgba(99, 49, 18, var(--bg-opacity));\n  }\n  .lg\\:bg-green-50 {\n    --bg-opacity: 1;\n    background-color: #f3faf7;\n    background-color: rgba(243, 250, 247, var(--bg-opacity));\n  }\n  .lg\\:bg-green-100 {\n    --bg-opacity: 1;\n    background-color: #def7ec;\n    background-color: rgba(222, 247, 236, var(--bg-opacity));\n  }\n  .lg\\:bg-green-200 {\n    --bg-opacity: 1;\n    background-color: #bcf0da;\n    background-color: rgba(188, 240, 218, var(--bg-opacity));\n  }\n  .lg\\:bg-green-300 {\n    --bg-opacity: 1;\n    background-color: #84e1bc;\n    background-color: rgba(132, 225, 188, var(--bg-opacity));\n  }\n  .lg\\:bg-green-400 {\n    --bg-opacity: 1;\n    background-color: #31c48d;\n    background-color: rgba(49, 196, 141, var(--bg-opacity));\n  }\n  .lg\\:bg-green-500 {\n    --bg-opacity: 1;\n    background-color: #0e9f6e;\n    background-color: rgba(14, 159, 110, var(--bg-opacity));\n  }\n  .lg\\:bg-green-600 {\n    --bg-opacity: 1;\n    background-color: #057a55;\n    background-color: rgba(5, 122, 85, var(--bg-opacity));\n  }\n  .lg\\:bg-green-700 {\n    --bg-opacity: 1;\n    background-color: #046c4e;\n    background-color: rgba(4, 108, 78, var(--bg-opacity));\n  }\n  .lg\\:bg-green-800 {\n    --bg-opacity: 1;\n    background-color: #03543f;\n    background-color: rgba(3, 84, 63, var(--bg-opacity));\n  }\n  .lg\\:bg-green-900 {\n    --bg-opacity: 1;\n    background-color: #014737;\n    background-color: rgba(1, 71, 55, var(--bg-opacity));\n  }\n  .lg\\:bg-teal-50 {\n    --bg-opacity: 1;\n    background-color: #edfafa;\n    background-color: rgba(237, 250, 250, var(--bg-opacity));\n  }\n  .lg\\:bg-teal-100 {\n    --bg-opacity: 1;\n    background-color: #d5f5f6;\n    background-color: rgba(213, 245, 246, var(--bg-opacity));\n  }\n  .lg\\:bg-teal-200 {\n    --bg-opacity: 1;\n    background-color: #afecef;\n    background-color: rgba(175, 236, 239, var(--bg-opacity));\n  }\n  .lg\\:bg-teal-300 {\n    --bg-opacity: 1;\n    background-color: #7edce2;\n    background-color: rgba(126, 220, 226, var(--bg-opacity));\n  }\n  .lg\\:bg-teal-400 {\n    --bg-opacity: 1;\n    background-color: #16bdca;\n    background-color: rgba(22, 189, 202, var(--bg-opacity));\n  }\n  .lg\\:bg-teal-500 {\n    --bg-opacity: 1;\n    background-color: #0694a2;\n    background-color: rgba(6, 148, 162, var(--bg-opacity));\n  }\n  .lg\\:bg-teal-600 {\n    --bg-opacity: 1;\n    background-color: #047481;\n    background-color: rgba(4, 116, 129, var(--bg-opacity));\n  }\n  .lg\\:bg-teal-700 {\n    --bg-opacity: 1;\n    background-color: #036672;\n    background-color: rgba(3, 102, 114, var(--bg-opacity));\n  }\n  .lg\\:bg-teal-800 {\n    --bg-opacity: 1;\n    background-color: #05505c;\n    background-color: rgba(5, 80, 92, var(--bg-opacity));\n  }\n  .lg\\:bg-teal-900 {\n    --bg-opacity: 1;\n    background-color: #014451;\n    background-color: rgba(1, 68, 81, var(--bg-opacity));\n  }\n  .lg\\:bg-blue-50 {\n    --bg-opacity: 1;\n    background-color: #ebf5ff;\n    background-color: rgba(235, 245, 255, var(--bg-opacity));\n  }\n  .lg\\:bg-blue-100 {\n    --bg-opacity: 1;\n    background-color: #e1effe;\n    background-color: rgba(225, 239, 254, var(--bg-opacity));\n  }\n  .lg\\:bg-blue-200 {\n    --bg-opacity: 1;\n    background-color: #c3ddfd;\n    background-color: rgba(195, 221, 253, var(--bg-opacity));\n  }\n  .lg\\:bg-blue-300 {\n    --bg-opacity: 1;\n    background-color: #a4cafe;\n    background-color: rgba(164, 202, 254, var(--bg-opacity));\n  }\n  .lg\\:bg-blue-400 {\n    --bg-opacity: 1;\n    background-color: #76a9fa;\n    background-color: rgba(118, 169, 250, var(--bg-opacity));\n  }\n  .lg\\:bg-blue-500 {\n    --bg-opacity: 1;\n    background-color: #3f83f8;\n    background-color: rgba(63, 131, 248, var(--bg-opacity));\n  }\n  .lg\\:bg-blue-600 {\n    --bg-opacity: 1;\n    background-color: #1c64f2;\n    background-color: rgba(28, 100, 242, var(--bg-opacity));\n  }\n  .lg\\:bg-blue-700 {\n    --bg-opacity: 1;\n    background-color: #1a56db;\n    background-color: rgba(26, 86, 219, var(--bg-opacity));\n  }\n  .lg\\:bg-blue-800 {\n    --bg-opacity: 1;\n    background-color: #1e429f;\n    background-color: rgba(30, 66, 159, var(--bg-opacity));\n  }\n  .lg\\:bg-blue-900 {\n    --bg-opacity: 1;\n    background-color: #233876;\n    background-color: rgba(35, 56, 118, var(--bg-opacity));\n  }\n  .lg\\:bg-indigo-50 {\n    --bg-opacity: 1;\n    background-color: #f0f5ff;\n    background-color: rgba(240, 245, 255, var(--bg-opacity));\n  }\n  .lg\\:bg-indigo-100 {\n    --bg-opacity: 1;\n    background-color: #e5edff;\n    background-color: rgba(229, 237, 255, var(--bg-opacity));\n  }\n  .lg\\:bg-indigo-200 {\n    --bg-opacity: 1;\n    background-color: #cddbfe;\n    background-color: rgba(205, 219, 254, var(--bg-opacity));\n  }\n  .lg\\:bg-indigo-300 {\n    --bg-opacity: 1;\n    background-color: #b4c6fc;\n    background-color: rgba(180, 198, 252, var(--bg-opacity));\n  }\n  .lg\\:bg-indigo-400 {\n    --bg-opacity: 1;\n    background-color: #8da2fb;\n    background-color: rgba(141, 162, 251, var(--bg-opacity));\n  }\n  .lg\\:bg-indigo-500 {\n    --bg-opacity: 1;\n    background-color: #6875f5;\n    background-color: rgba(104, 117, 245, var(--bg-opacity));\n  }\n  .lg\\:bg-indigo-600 {\n    --bg-opacity: 1;\n    background-color: #5850ec;\n    background-color: rgba(88, 80, 236, var(--bg-opacity));\n  }\n  .lg\\:bg-indigo-700 {\n    --bg-opacity: 1;\n    background-color: #5145cd;\n    background-color: rgba(81, 69, 205, var(--bg-opacity));\n  }\n  .lg\\:bg-indigo-800 {\n    --bg-opacity: 1;\n    background-color: #42389d;\n    background-color: rgba(66, 56, 157, var(--bg-opacity));\n  }\n  .lg\\:bg-indigo-900 {\n    --bg-opacity: 1;\n    background-color: #362f78;\n    background-color: rgba(54, 47, 120, var(--bg-opacity));\n  }\n  .lg\\:bg-purple-50 {\n    --bg-opacity: 1;\n    background-color: #f6f5ff;\n    background-color: rgba(246, 245, 255, var(--bg-opacity));\n  }\n  .lg\\:bg-purple-100 {\n    --bg-opacity: 1;\n    background-color: #edebfe;\n    background-color: rgba(237, 235, 254, var(--bg-opacity));\n  }\n  .lg\\:bg-purple-200 {\n    --bg-opacity: 1;\n    background-color: #dcd7fe;\n    background-color: rgba(220, 215, 254, var(--bg-opacity));\n  }\n  .lg\\:bg-purple-300 {\n    --bg-opacity: 1;\n    background-color: #cabffd;\n    background-color: rgba(202, 191, 253, var(--bg-opacity));\n  }\n  .lg\\:bg-purple-400 {\n    --bg-opacity: 1;\n    background-color: #ac94fa;\n    background-color: rgba(172, 148, 250, var(--bg-opacity));\n  }\n  .lg\\:bg-purple-500 {\n    --bg-opacity: 1;\n    background-color: #9061f9;\n    background-color: rgba(144, 97, 249, var(--bg-opacity));\n  }\n  .lg\\:bg-purple-600 {\n    --bg-opacity: 1;\n    background-color: #7e3af2;\n    background-color: rgba(126, 58, 242, var(--bg-opacity));\n  }\n  .lg\\:bg-purple-700 {\n    --bg-opacity: 1;\n    background-color: #6c2bd9;\n    background-color: rgba(108, 43, 217, var(--bg-opacity));\n  }\n  .lg\\:bg-purple-800 {\n    --bg-opacity: 1;\n    background-color: #5521b5;\n    background-color: rgba(85, 33, 181, var(--bg-opacity));\n  }\n  .lg\\:bg-purple-900 {\n    --bg-opacity: 1;\n    background-color: #4a1d96;\n    background-color: rgba(74, 29, 150, var(--bg-opacity));\n  }\n  .lg\\:bg-pink-50 {\n    --bg-opacity: 1;\n    background-color: #fdf2f8;\n    background-color: rgba(253, 242, 248, var(--bg-opacity));\n  }\n  .lg\\:bg-pink-100 {\n    --bg-opacity: 1;\n    background-color: #fce8f3;\n    background-color: rgba(252, 232, 243, var(--bg-opacity));\n  }\n  .lg\\:bg-pink-200 {\n    --bg-opacity: 1;\n    background-color: #fad1e8;\n    background-color: rgba(250, 209, 232, var(--bg-opacity));\n  }\n  .lg\\:bg-pink-300 {\n    --bg-opacity: 1;\n    background-color: #f8b4d9;\n    background-color: rgba(248, 180, 217, var(--bg-opacity));\n  }\n  .lg\\:bg-pink-400 {\n    --bg-opacity: 1;\n    background-color: #f17eb8;\n    background-color: rgba(241, 126, 184, var(--bg-opacity));\n  }\n  .lg\\:bg-pink-500 {\n    --bg-opacity: 1;\n    background-color: #e74694;\n    background-color: rgba(231, 70, 148, var(--bg-opacity));\n  }\n  .lg\\:bg-pink-600 {\n    --bg-opacity: 1;\n    background-color: #d61f69;\n    background-color: rgba(214, 31, 105, var(--bg-opacity));\n  }\n  .lg\\:bg-pink-700 {\n    --bg-opacity: 1;\n    background-color: #bf125d;\n    background-color: rgba(191, 18, 93, var(--bg-opacity));\n  }\n  .lg\\:bg-pink-800 {\n    --bg-opacity: 1;\n    background-color: #99154b;\n    background-color: rgba(153, 21, 75, var(--bg-opacity));\n  }\n  .lg\\:bg-pink-900 {\n    --bg-opacity: 1;\n    background-color: #751a3d;\n    background-color: rgba(117, 26, 61, var(--bg-opacity));\n  }\n  .lg\\:bg-cool-gray-50 {\n    --bg-opacity: 1;\n    background-color: #f8fafc;\n    background-color: rgba(248, 250, 252, var(--bg-opacity));\n  }\n  .lg\\:bg-cool-gray-100 {\n    --bg-opacity: 1;\n    background-color: #f1f5f9;\n    background-color: rgba(241, 245, 249, var(--bg-opacity));\n  }\n  .lg\\:bg-cool-gray-200 {\n    --bg-opacity: 1;\n    background-color: #e2e8f0;\n    background-color: rgba(226, 232, 240, var(--bg-opacity));\n  }\n  .lg\\:bg-cool-gray-300 {\n    --bg-opacity: 1;\n    background-color: #cfd8e3;\n    background-color: rgba(207, 216, 227, var(--bg-opacity));\n  }\n  .lg\\:bg-cool-gray-400 {\n    --bg-opacity: 1;\n    background-color: #97a6ba;\n    background-color: rgba(151, 166, 186, var(--bg-opacity));\n  }\n  .lg\\:bg-cool-gray-500 {\n    --bg-opacity: 1;\n    background-color: #64748b;\n    background-color: rgba(100, 116, 139, var(--bg-opacity));\n  }\n  .lg\\:bg-cool-gray-600 {\n    --bg-opacity: 1;\n    background-color: #475569;\n    background-color: rgba(71, 85, 105, var(--bg-opacity));\n  }\n  .lg\\:bg-cool-gray-700 {\n    --bg-opacity: 1;\n    background-color: #364152;\n    background-color: rgba(54, 65, 82, var(--bg-opacity));\n  }\n  .lg\\:bg-cool-gray-800 {\n    --bg-opacity: 1;\n    background-color: #27303f;\n    background-color: rgba(39, 48, 63, var(--bg-opacity));\n  }\n  .lg\\:bg-cool-gray-900 {\n    --bg-opacity: 1;\n    background-color: #1a202e;\n    background-color: rgba(26, 32, 46, var(--bg-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:bg-current {\n    background-color: currentColor;\n  }\n  .group:hover .lg\\:group-hover\\:bg-transparent {\n    background-color: transparent;\n  }\n  .group:hover .lg\\:group-hover\\:bg-white {\n    --bg-opacity: 1;\n    background-color: #ffffff;\n    background-color: rgba(255, 255, 255, var(--bg-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:bg-black {\n    --bg-opacity: 1;\n    background-color: #000000;\n    background-color: rgba(0, 0, 0, var(--bg-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:bg-gray-50 {\n    --bg-opacity: 1;\n    background-color: #f9fafb;\n    background-color: rgba(249, 250, 251, var(--bg-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:bg-gray-100 {\n    --bg-opacity: 1;\n    background-color: #f4f5f7;\n    background-color: rgba(244, 245, 247, var(--bg-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:bg-gray-200 {\n    --bg-opacity: 1;\n    background-color: #e5e7eb;\n    background-color: rgba(229, 231, 235, var(--bg-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:bg-gray-300 {\n    --bg-opacity: 1;\n    background-color: #d2d6dc;\n    background-color: rgba(210, 214, 220, var(--bg-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:bg-gray-400 {\n    --bg-opacity: 1;\n    background-color: #9fa6b2;\n    background-color: rgba(159, 166, 178, var(--bg-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:bg-gray-500 {\n    --bg-opacity: 1;\n    background-color: #6b7280;\n    background-color: rgba(107, 114, 128, var(--bg-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:bg-gray-600 {\n    --bg-opacity: 1;\n    background-color: #4b5563;\n    background-color: rgba(75, 85, 99, var(--bg-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:bg-gray-700 {\n    --bg-opacity: 1;\n    background-color: #374151;\n    background-color: rgba(55, 65, 81, var(--bg-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:bg-gray-800 {\n    --bg-opacity: 1;\n    background-color: #252f3f;\n    background-color: rgba(37, 47, 63, var(--bg-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:bg-gray-900 {\n    --bg-opacity: 1;\n    background-color: #161e2e;\n    background-color: rgba(22, 30, 46, var(--bg-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:bg-red-50 {\n    --bg-opacity: 1;\n    background-color: #fdf2f2;\n    background-color: rgba(253, 242, 242, var(--bg-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:bg-red-100 {\n    --bg-opacity: 1;\n    background-color: #fde8e8;\n    background-color: rgba(253, 232, 232, var(--bg-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:bg-red-200 {\n    --bg-opacity: 1;\n    background-color: #fbd5d5;\n    background-color: rgba(251, 213, 213, var(--bg-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:bg-red-300 {\n    --bg-opacity: 1;\n    background-color: #f8b4b4;\n    background-color: rgba(248, 180, 180, var(--bg-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:bg-red-400 {\n    --bg-opacity: 1;\n    background-color: #f98080;\n    background-color: rgba(249, 128, 128, var(--bg-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:bg-red-500 {\n    --bg-opacity: 1;\n    background-color: #f05252;\n    background-color: rgba(240, 82, 82, var(--bg-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:bg-red-600 {\n    --bg-opacity: 1;\n    background-color: #e02424;\n    background-color: rgba(224, 36, 36, var(--bg-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:bg-red-700 {\n    --bg-opacity: 1;\n    background-color: #c81e1e;\n    background-color: rgba(200, 30, 30, var(--bg-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:bg-red-800 {\n    --bg-opacity: 1;\n    background-color: #9b1c1c;\n    background-color: rgba(155, 28, 28, var(--bg-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:bg-red-900 {\n    --bg-opacity: 1;\n    background-color: #771d1d;\n    background-color: rgba(119, 29, 29, var(--bg-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:bg-orange-50 {\n    --bg-opacity: 1;\n    background-color: #fff8f1;\n    background-color: rgba(255, 248, 241, var(--bg-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:bg-orange-100 {\n    --bg-opacity: 1;\n    background-color: #feecdc;\n    background-color: rgba(254, 236, 220, var(--bg-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:bg-orange-200 {\n    --bg-opacity: 1;\n    background-color: #fcd9bd;\n    background-color: rgba(252, 217, 189, var(--bg-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:bg-orange-300 {\n    --bg-opacity: 1;\n    background-color: #fdba8c;\n    background-color: rgba(253, 186, 140, var(--bg-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:bg-orange-400 {\n    --bg-opacity: 1;\n    background-color: #ff8a4c;\n    background-color: rgba(255, 138, 76, var(--bg-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:bg-orange-500 {\n    --bg-opacity: 1;\n    background-color: #ff5a1f;\n    background-color: rgba(255, 90, 31, var(--bg-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:bg-orange-600 {\n    --bg-opacity: 1;\n    background-color: #d03801;\n    background-color: rgba(208, 56, 1, var(--bg-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:bg-orange-700 {\n    --bg-opacity: 1;\n    background-color: #b43403;\n    background-color: rgba(180, 52, 3, var(--bg-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:bg-orange-800 {\n    --bg-opacity: 1;\n    background-color: #8a2c0d;\n    background-color: rgba(138, 44, 13, var(--bg-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:bg-orange-900 {\n    --bg-opacity: 1;\n    background-color: #73230d;\n    background-color: rgba(115, 35, 13, var(--bg-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:bg-yellow-50 {\n    --bg-opacity: 1;\n    background-color: #fdfdea;\n    background-color: rgba(253, 253, 234, var(--bg-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:bg-yellow-100 {\n    --bg-opacity: 1;\n    background-color: #fdf6b2;\n    background-color: rgba(253, 246, 178, var(--bg-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:bg-yellow-200 {\n    --bg-opacity: 1;\n    background-color: #fce96a;\n    background-color: rgba(252, 233, 106, var(--bg-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:bg-yellow-300 {\n    --bg-opacity: 1;\n    background-color: #faca15;\n    background-color: rgba(250, 202, 21, var(--bg-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:bg-yellow-400 {\n    --bg-opacity: 1;\n    background-color: #e3a008;\n    background-color: rgba(227, 160, 8, var(--bg-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:bg-yellow-500 {\n    --bg-opacity: 1;\n    background-color: #c27803;\n    background-color: rgba(194, 120, 3, var(--bg-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:bg-yellow-600 {\n    --bg-opacity: 1;\n    background-color: #9f580a;\n    background-color: rgba(159, 88, 10, var(--bg-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:bg-yellow-700 {\n    --bg-opacity: 1;\n    background-color: #8e4b10;\n    background-color: rgba(142, 75, 16, var(--bg-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:bg-yellow-800 {\n    --bg-opacity: 1;\n    background-color: #723b13;\n    background-color: rgba(114, 59, 19, var(--bg-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:bg-yellow-900 {\n    --bg-opacity: 1;\n    background-color: #633112;\n    background-color: rgba(99, 49, 18, var(--bg-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:bg-green-50 {\n    --bg-opacity: 1;\n    background-color: #f3faf7;\n    background-color: rgba(243, 250, 247, var(--bg-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:bg-green-100 {\n    --bg-opacity: 1;\n    background-color: #def7ec;\n    background-color: rgba(222, 247, 236, var(--bg-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:bg-green-200 {\n    --bg-opacity: 1;\n    background-color: #bcf0da;\n    background-color: rgba(188, 240, 218, var(--bg-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:bg-green-300 {\n    --bg-opacity: 1;\n    background-color: #84e1bc;\n    background-color: rgba(132, 225, 188, var(--bg-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:bg-green-400 {\n    --bg-opacity: 1;\n    background-color: #31c48d;\n    background-color: rgba(49, 196, 141, var(--bg-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:bg-green-500 {\n    --bg-opacity: 1;\n    background-color: #0e9f6e;\n    background-color: rgba(14, 159, 110, var(--bg-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:bg-green-600 {\n    --bg-opacity: 1;\n    background-color: #057a55;\n    background-color: rgba(5, 122, 85, var(--bg-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:bg-green-700 {\n    --bg-opacity: 1;\n    background-color: #046c4e;\n    background-color: rgba(4, 108, 78, var(--bg-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:bg-green-800 {\n    --bg-opacity: 1;\n    background-color: #03543f;\n    background-color: rgba(3, 84, 63, var(--bg-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:bg-green-900 {\n    --bg-opacity: 1;\n    background-color: #014737;\n    background-color: rgba(1, 71, 55, var(--bg-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:bg-teal-50 {\n    --bg-opacity: 1;\n    background-color: #edfafa;\n    background-color: rgba(237, 250, 250, var(--bg-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:bg-teal-100 {\n    --bg-opacity: 1;\n    background-color: #d5f5f6;\n    background-color: rgba(213, 245, 246, var(--bg-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:bg-teal-200 {\n    --bg-opacity: 1;\n    background-color: #afecef;\n    background-color: rgba(175, 236, 239, var(--bg-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:bg-teal-300 {\n    --bg-opacity: 1;\n    background-color: #7edce2;\n    background-color: rgba(126, 220, 226, var(--bg-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:bg-teal-400 {\n    --bg-opacity: 1;\n    background-color: #16bdca;\n    background-color: rgba(22, 189, 202, var(--bg-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:bg-teal-500 {\n    --bg-opacity: 1;\n    background-color: #0694a2;\n    background-color: rgba(6, 148, 162, var(--bg-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:bg-teal-600 {\n    --bg-opacity: 1;\n    background-color: #047481;\n    background-color: rgba(4, 116, 129, var(--bg-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:bg-teal-700 {\n    --bg-opacity: 1;\n    background-color: #036672;\n    background-color: rgba(3, 102, 114, var(--bg-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:bg-teal-800 {\n    --bg-opacity: 1;\n    background-color: #05505c;\n    background-color: rgba(5, 80, 92, var(--bg-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:bg-teal-900 {\n    --bg-opacity: 1;\n    background-color: #014451;\n    background-color: rgba(1, 68, 81, var(--bg-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:bg-blue-50 {\n    --bg-opacity: 1;\n    background-color: #ebf5ff;\n    background-color: rgba(235, 245, 255, var(--bg-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:bg-blue-100 {\n    --bg-opacity: 1;\n    background-color: #e1effe;\n    background-color: rgba(225, 239, 254, var(--bg-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:bg-blue-200 {\n    --bg-opacity: 1;\n    background-color: #c3ddfd;\n    background-color: rgba(195, 221, 253, var(--bg-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:bg-blue-300 {\n    --bg-opacity: 1;\n    background-color: #a4cafe;\n    background-color: rgba(164, 202, 254, var(--bg-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:bg-blue-400 {\n    --bg-opacity: 1;\n    background-color: #76a9fa;\n    background-color: rgba(118, 169, 250, var(--bg-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:bg-blue-500 {\n    --bg-opacity: 1;\n    background-color: #3f83f8;\n    background-color: rgba(63, 131, 248, var(--bg-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:bg-blue-600 {\n    --bg-opacity: 1;\n    background-color: #1c64f2;\n    background-color: rgba(28, 100, 242, var(--bg-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:bg-blue-700 {\n    --bg-opacity: 1;\n    background-color: #1a56db;\n    background-color: rgba(26, 86, 219, var(--bg-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:bg-blue-800 {\n    --bg-opacity: 1;\n    background-color: #1e429f;\n    background-color: rgba(30, 66, 159, var(--bg-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:bg-blue-900 {\n    --bg-opacity: 1;\n    background-color: #233876;\n    background-color: rgba(35, 56, 118, var(--bg-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:bg-indigo-50 {\n    --bg-opacity: 1;\n    background-color: #f0f5ff;\n    background-color: rgba(240, 245, 255, var(--bg-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:bg-indigo-100 {\n    --bg-opacity: 1;\n    background-color: #e5edff;\n    background-color: rgba(229, 237, 255, var(--bg-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:bg-indigo-200 {\n    --bg-opacity: 1;\n    background-color: #cddbfe;\n    background-color: rgba(205, 219, 254, var(--bg-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:bg-indigo-300 {\n    --bg-opacity: 1;\n    background-color: #b4c6fc;\n    background-color: rgba(180, 198, 252, var(--bg-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:bg-indigo-400 {\n    --bg-opacity: 1;\n    background-color: #8da2fb;\n    background-color: rgba(141, 162, 251, var(--bg-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:bg-indigo-500 {\n    --bg-opacity: 1;\n    background-color: #6875f5;\n    background-color: rgba(104, 117, 245, var(--bg-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:bg-indigo-600 {\n    --bg-opacity: 1;\n    background-color: #5850ec;\n    background-color: rgba(88, 80, 236, var(--bg-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:bg-indigo-700 {\n    --bg-opacity: 1;\n    background-color: #5145cd;\n    background-color: rgba(81, 69, 205, var(--bg-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:bg-indigo-800 {\n    --bg-opacity: 1;\n    background-color: #42389d;\n    background-color: rgba(66, 56, 157, var(--bg-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:bg-indigo-900 {\n    --bg-opacity: 1;\n    background-color: #362f78;\n    background-color: rgba(54, 47, 120, var(--bg-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:bg-purple-50 {\n    --bg-opacity: 1;\n    background-color: #f6f5ff;\n    background-color: rgba(246, 245, 255, var(--bg-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:bg-purple-100 {\n    --bg-opacity: 1;\n    background-color: #edebfe;\n    background-color: rgba(237, 235, 254, var(--bg-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:bg-purple-200 {\n    --bg-opacity: 1;\n    background-color: #dcd7fe;\n    background-color: rgba(220, 215, 254, var(--bg-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:bg-purple-300 {\n    --bg-opacity: 1;\n    background-color: #cabffd;\n    background-color: rgba(202, 191, 253, var(--bg-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:bg-purple-400 {\n    --bg-opacity: 1;\n    background-color: #ac94fa;\n    background-color: rgba(172, 148, 250, var(--bg-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:bg-purple-500 {\n    --bg-opacity: 1;\n    background-color: #9061f9;\n    background-color: rgba(144, 97, 249, var(--bg-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:bg-purple-600 {\n    --bg-opacity: 1;\n    background-color: #7e3af2;\n    background-color: rgba(126, 58, 242, var(--bg-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:bg-purple-700 {\n    --bg-opacity: 1;\n    background-color: #6c2bd9;\n    background-color: rgba(108, 43, 217, var(--bg-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:bg-purple-800 {\n    --bg-opacity: 1;\n    background-color: #5521b5;\n    background-color: rgba(85, 33, 181, var(--bg-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:bg-purple-900 {\n    --bg-opacity: 1;\n    background-color: #4a1d96;\n    background-color: rgba(74, 29, 150, var(--bg-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:bg-pink-50 {\n    --bg-opacity: 1;\n    background-color: #fdf2f8;\n    background-color: rgba(253, 242, 248, var(--bg-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:bg-pink-100 {\n    --bg-opacity: 1;\n    background-color: #fce8f3;\n    background-color: rgba(252, 232, 243, var(--bg-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:bg-pink-200 {\n    --bg-opacity: 1;\n    background-color: #fad1e8;\n    background-color: rgba(250, 209, 232, var(--bg-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:bg-pink-300 {\n    --bg-opacity: 1;\n    background-color: #f8b4d9;\n    background-color: rgba(248, 180, 217, var(--bg-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:bg-pink-400 {\n    --bg-opacity: 1;\n    background-color: #f17eb8;\n    background-color: rgba(241, 126, 184, var(--bg-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:bg-pink-500 {\n    --bg-opacity: 1;\n    background-color: #e74694;\n    background-color: rgba(231, 70, 148, var(--bg-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:bg-pink-600 {\n    --bg-opacity: 1;\n    background-color: #d61f69;\n    background-color: rgba(214, 31, 105, var(--bg-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:bg-pink-700 {\n    --bg-opacity: 1;\n    background-color: #bf125d;\n    background-color: rgba(191, 18, 93, var(--bg-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:bg-pink-800 {\n    --bg-opacity: 1;\n    background-color: #99154b;\n    background-color: rgba(153, 21, 75, var(--bg-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:bg-pink-900 {\n    --bg-opacity: 1;\n    background-color: #751a3d;\n    background-color: rgba(117, 26, 61, var(--bg-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:bg-cool-gray-50 {\n    --bg-opacity: 1;\n    background-color: #f8fafc;\n    background-color: rgba(248, 250, 252, var(--bg-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:bg-cool-gray-100 {\n    --bg-opacity: 1;\n    background-color: #f1f5f9;\n    background-color: rgba(241, 245, 249, var(--bg-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:bg-cool-gray-200 {\n    --bg-opacity: 1;\n    background-color: #e2e8f0;\n    background-color: rgba(226, 232, 240, var(--bg-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:bg-cool-gray-300 {\n    --bg-opacity: 1;\n    background-color: #cfd8e3;\n    background-color: rgba(207, 216, 227, var(--bg-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:bg-cool-gray-400 {\n    --bg-opacity: 1;\n    background-color: #97a6ba;\n    background-color: rgba(151, 166, 186, var(--bg-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:bg-cool-gray-500 {\n    --bg-opacity: 1;\n    background-color: #64748b;\n    background-color: rgba(100, 116, 139, var(--bg-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:bg-cool-gray-600 {\n    --bg-opacity: 1;\n    background-color: #475569;\n    background-color: rgba(71, 85, 105, var(--bg-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:bg-cool-gray-700 {\n    --bg-opacity: 1;\n    background-color: #364152;\n    background-color: rgba(54, 65, 82, var(--bg-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:bg-cool-gray-800 {\n    --bg-opacity: 1;\n    background-color: #27303f;\n    background-color: rgba(39, 48, 63, var(--bg-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:bg-cool-gray-900 {\n    --bg-opacity: 1;\n    background-color: #1a202e;\n    background-color: rgba(26, 32, 46, var(--bg-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:bg-current {\n    background-color: currentColor;\n  }\n  .group:focus .lg\\:group-focus\\:bg-transparent {\n    background-color: transparent;\n  }\n  .group:focus .lg\\:group-focus\\:bg-white {\n    --bg-opacity: 1;\n    background-color: #ffffff;\n    background-color: rgba(255, 255, 255, var(--bg-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:bg-black {\n    --bg-opacity: 1;\n    background-color: #000000;\n    background-color: rgba(0, 0, 0, var(--bg-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:bg-gray-50 {\n    --bg-opacity: 1;\n    background-color: #f9fafb;\n    background-color: rgba(249, 250, 251, var(--bg-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:bg-gray-100 {\n    --bg-opacity: 1;\n    background-color: #f4f5f7;\n    background-color: rgba(244, 245, 247, var(--bg-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:bg-gray-200 {\n    --bg-opacity: 1;\n    background-color: #e5e7eb;\n    background-color: rgba(229, 231, 235, var(--bg-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:bg-gray-300 {\n    --bg-opacity: 1;\n    background-color: #d2d6dc;\n    background-color: rgba(210, 214, 220, var(--bg-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:bg-gray-400 {\n    --bg-opacity: 1;\n    background-color: #9fa6b2;\n    background-color: rgba(159, 166, 178, var(--bg-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:bg-gray-500 {\n    --bg-opacity: 1;\n    background-color: #6b7280;\n    background-color: rgba(107, 114, 128, var(--bg-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:bg-gray-600 {\n    --bg-opacity: 1;\n    background-color: #4b5563;\n    background-color: rgba(75, 85, 99, var(--bg-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:bg-gray-700 {\n    --bg-opacity: 1;\n    background-color: #374151;\n    background-color: rgba(55, 65, 81, var(--bg-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:bg-gray-800 {\n    --bg-opacity: 1;\n    background-color: #252f3f;\n    background-color: rgba(37, 47, 63, var(--bg-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:bg-gray-900 {\n    --bg-opacity: 1;\n    background-color: #161e2e;\n    background-color: rgba(22, 30, 46, var(--bg-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:bg-red-50 {\n    --bg-opacity: 1;\n    background-color: #fdf2f2;\n    background-color: rgba(253, 242, 242, var(--bg-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:bg-red-100 {\n    --bg-opacity: 1;\n    background-color: #fde8e8;\n    background-color: rgba(253, 232, 232, var(--bg-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:bg-red-200 {\n    --bg-opacity: 1;\n    background-color: #fbd5d5;\n    background-color: rgba(251, 213, 213, var(--bg-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:bg-red-300 {\n    --bg-opacity: 1;\n    background-color: #f8b4b4;\n    background-color: rgba(248, 180, 180, var(--bg-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:bg-red-400 {\n    --bg-opacity: 1;\n    background-color: #f98080;\n    background-color: rgba(249, 128, 128, var(--bg-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:bg-red-500 {\n    --bg-opacity: 1;\n    background-color: #f05252;\n    background-color: rgba(240, 82, 82, var(--bg-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:bg-red-600 {\n    --bg-opacity: 1;\n    background-color: #e02424;\n    background-color: rgba(224, 36, 36, var(--bg-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:bg-red-700 {\n    --bg-opacity: 1;\n    background-color: #c81e1e;\n    background-color: rgba(200, 30, 30, var(--bg-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:bg-red-800 {\n    --bg-opacity: 1;\n    background-color: #9b1c1c;\n    background-color: rgba(155, 28, 28, var(--bg-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:bg-red-900 {\n    --bg-opacity: 1;\n    background-color: #771d1d;\n    background-color: rgba(119, 29, 29, var(--bg-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:bg-orange-50 {\n    --bg-opacity: 1;\n    background-color: #fff8f1;\n    background-color: rgba(255, 248, 241, var(--bg-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:bg-orange-100 {\n    --bg-opacity: 1;\n    background-color: #feecdc;\n    background-color: rgba(254, 236, 220, var(--bg-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:bg-orange-200 {\n    --bg-opacity: 1;\n    background-color: #fcd9bd;\n    background-color: rgba(252, 217, 189, var(--bg-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:bg-orange-300 {\n    --bg-opacity: 1;\n    background-color: #fdba8c;\n    background-color: rgba(253, 186, 140, var(--bg-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:bg-orange-400 {\n    --bg-opacity: 1;\n    background-color: #ff8a4c;\n    background-color: rgba(255, 138, 76, var(--bg-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:bg-orange-500 {\n    --bg-opacity: 1;\n    background-color: #ff5a1f;\n    background-color: rgba(255, 90, 31, var(--bg-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:bg-orange-600 {\n    --bg-opacity: 1;\n    background-color: #d03801;\n    background-color: rgba(208, 56, 1, var(--bg-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:bg-orange-700 {\n    --bg-opacity: 1;\n    background-color: #b43403;\n    background-color: rgba(180, 52, 3, var(--bg-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:bg-orange-800 {\n    --bg-opacity: 1;\n    background-color: #8a2c0d;\n    background-color: rgba(138, 44, 13, var(--bg-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:bg-orange-900 {\n    --bg-opacity: 1;\n    background-color: #73230d;\n    background-color: rgba(115, 35, 13, var(--bg-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:bg-yellow-50 {\n    --bg-opacity: 1;\n    background-color: #fdfdea;\n    background-color: rgba(253, 253, 234, var(--bg-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:bg-yellow-100 {\n    --bg-opacity: 1;\n    background-color: #fdf6b2;\n    background-color: rgba(253, 246, 178, var(--bg-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:bg-yellow-200 {\n    --bg-opacity: 1;\n    background-color: #fce96a;\n    background-color: rgba(252, 233, 106, var(--bg-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:bg-yellow-300 {\n    --bg-opacity: 1;\n    background-color: #faca15;\n    background-color: rgba(250, 202, 21, var(--bg-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:bg-yellow-400 {\n    --bg-opacity: 1;\n    background-color: #e3a008;\n    background-color: rgba(227, 160, 8, var(--bg-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:bg-yellow-500 {\n    --bg-opacity: 1;\n    background-color: #c27803;\n    background-color: rgba(194, 120, 3, var(--bg-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:bg-yellow-600 {\n    --bg-opacity: 1;\n    background-color: #9f580a;\n    background-color: rgba(159, 88, 10, var(--bg-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:bg-yellow-700 {\n    --bg-opacity: 1;\n    background-color: #8e4b10;\n    background-color: rgba(142, 75, 16, var(--bg-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:bg-yellow-800 {\n    --bg-opacity: 1;\n    background-color: #723b13;\n    background-color: rgba(114, 59, 19, var(--bg-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:bg-yellow-900 {\n    --bg-opacity: 1;\n    background-color: #633112;\n    background-color: rgba(99, 49, 18, var(--bg-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:bg-green-50 {\n    --bg-opacity: 1;\n    background-color: #f3faf7;\n    background-color: rgba(243, 250, 247, var(--bg-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:bg-green-100 {\n    --bg-opacity: 1;\n    background-color: #def7ec;\n    background-color: rgba(222, 247, 236, var(--bg-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:bg-green-200 {\n    --bg-opacity: 1;\n    background-color: #bcf0da;\n    background-color: rgba(188, 240, 218, var(--bg-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:bg-green-300 {\n    --bg-opacity: 1;\n    background-color: #84e1bc;\n    background-color: rgba(132, 225, 188, var(--bg-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:bg-green-400 {\n    --bg-opacity: 1;\n    background-color: #31c48d;\n    background-color: rgba(49, 196, 141, var(--bg-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:bg-green-500 {\n    --bg-opacity: 1;\n    background-color: #0e9f6e;\n    background-color: rgba(14, 159, 110, var(--bg-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:bg-green-600 {\n    --bg-opacity: 1;\n    background-color: #057a55;\n    background-color: rgba(5, 122, 85, var(--bg-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:bg-green-700 {\n    --bg-opacity: 1;\n    background-color: #046c4e;\n    background-color: rgba(4, 108, 78, var(--bg-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:bg-green-800 {\n    --bg-opacity: 1;\n    background-color: #03543f;\n    background-color: rgba(3, 84, 63, var(--bg-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:bg-green-900 {\n    --bg-opacity: 1;\n    background-color: #014737;\n    background-color: rgba(1, 71, 55, var(--bg-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:bg-teal-50 {\n    --bg-opacity: 1;\n    background-color: #edfafa;\n    background-color: rgba(237, 250, 250, var(--bg-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:bg-teal-100 {\n    --bg-opacity: 1;\n    background-color: #d5f5f6;\n    background-color: rgba(213, 245, 246, var(--bg-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:bg-teal-200 {\n    --bg-opacity: 1;\n    background-color: #afecef;\n    background-color: rgba(175, 236, 239, var(--bg-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:bg-teal-300 {\n    --bg-opacity: 1;\n    background-color: #7edce2;\n    background-color: rgba(126, 220, 226, var(--bg-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:bg-teal-400 {\n    --bg-opacity: 1;\n    background-color: #16bdca;\n    background-color: rgba(22, 189, 202, var(--bg-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:bg-teal-500 {\n    --bg-opacity: 1;\n    background-color: #0694a2;\n    background-color: rgba(6, 148, 162, var(--bg-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:bg-teal-600 {\n    --bg-opacity: 1;\n    background-color: #047481;\n    background-color: rgba(4, 116, 129, var(--bg-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:bg-teal-700 {\n    --bg-opacity: 1;\n    background-color: #036672;\n    background-color: rgba(3, 102, 114, var(--bg-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:bg-teal-800 {\n    --bg-opacity: 1;\n    background-color: #05505c;\n    background-color: rgba(5, 80, 92, var(--bg-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:bg-teal-900 {\n    --bg-opacity: 1;\n    background-color: #014451;\n    background-color: rgba(1, 68, 81, var(--bg-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:bg-blue-50 {\n    --bg-opacity: 1;\n    background-color: #ebf5ff;\n    background-color: rgba(235, 245, 255, var(--bg-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:bg-blue-100 {\n    --bg-opacity: 1;\n    background-color: #e1effe;\n    background-color: rgba(225, 239, 254, var(--bg-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:bg-blue-200 {\n    --bg-opacity: 1;\n    background-color: #c3ddfd;\n    background-color: rgba(195, 221, 253, var(--bg-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:bg-blue-300 {\n    --bg-opacity: 1;\n    background-color: #a4cafe;\n    background-color: rgba(164, 202, 254, var(--bg-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:bg-blue-400 {\n    --bg-opacity: 1;\n    background-color: #76a9fa;\n    background-color: rgba(118, 169, 250, var(--bg-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:bg-blue-500 {\n    --bg-opacity: 1;\n    background-color: #3f83f8;\n    background-color: rgba(63, 131, 248, var(--bg-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:bg-blue-600 {\n    --bg-opacity: 1;\n    background-color: #1c64f2;\n    background-color: rgba(28, 100, 242, var(--bg-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:bg-blue-700 {\n    --bg-opacity: 1;\n    background-color: #1a56db;\n    background-color: rgba(26, 86, 219, var(--bg-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:bg-blue-800 {\n    --bg-opacity: 1;\n    background-color: #1e429f;\n    background-color: rgba(30, 66, 159, var(--bg-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:bg-blue-900 {\n    --bg-opacity: 1;\n    background-color: #233876;\n    background-color: rgba(35, 56, 118, var(--bg-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:bg-indigo-50 {\n    --bg-opacity: 1;\n    background-color: #f0f5ff;\n    background-color: rgba(240, 245, 255, var(--bg-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:bg-indigo-100 {\n    --bg-opacity: 1;\n    background-color: #e5edff;\n    background-color: rgba(229, 237, 255, var(--bg-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:bg-indigo-200 {\n    --bg-opacity: 1;\n    background-color: #cddbfe;\n    background-color: rgba(205, 219, 254, var(--bg-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:bg-indigo-300 {\n    --bg-opacity: 1;\n    background-color: #b4c6fc;\n    background-color: rgba(180, 198, 252, var(--bg-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:bg-indigo-400 {\n    --bg-opacity: 1;\n    background-color: #8da2fb;\n    background-color: rgba(141, 162, 251, var(--bg-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:bg-indigo-500 {\n    --bg-opacity: 1;\n    background-color: #6875f5;\n    background-color: rgba(104, 117, 245, var(--bg-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:bg-indigo-600 {\n    --bg-opacity: 1;\n    background-color: #5850ec;\n    background-color: rgba(88, 80, 236, var(--bg-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:bg-indigo-700 {\n    --bg-opacity: 1;\n    background-color: #5145cd;\n    background-color: rgba(81, 69, 205, var(--bg-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:bg-indigo-800 {\n    --bg-opacity: 1;\n    background-color: #42389d;\n    background-color: rgba(66, 56, 157, var(--bg-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:bg-indigo-900 {\n    --bg-opacity: 1;\n    background-color: #362f78;\n    background-color: rgba(54, 47, 120, var(--bg-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:bg-purple-50 {\n    --bg-opacity: 1;\n    background-color: #f6f5ff;\n    background-color: rgba(246, 245, 255, var(--bg-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:bg-purple-100 {\n    --bg-opacity: 1;\n    background-color: #edebfe;\n    background-color: rgba(237, 235, 254, var(--bg-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:bg-purple-200 {\n    --bg-opacity: 1;\n    background-color: #dcd7fe;\n    background-color: rgba(220, 215, 254, var(--bg-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:bg-purple-300 {\n    --bg-opacity: 1;\n    background-color: #cabffd;\n    background-color: rgba(202, 191, 253, var(--bg-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:bg-purple-400 {\n    --bg-opacity: 1;\n    background-color: #ac94fa;\n    background-color: rgba(172, 148, 250, var(--bg-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:bg-purple-500 {\n    --bg-opacity: 1;\n    background-color: #9061f9;\n    background-color: rgba(144, 97, 249, var(--bg-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:bg-purple-600 {\n    --bg-opacity: 1;\n    background-color: #7e3af2;\n    background-color: rgba(126, 58, 242, var(--bg-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:bg-purple-700 {\n    --bg-opacity: 1;\n    background-color: #6c2bd9;\n    background-color: rgba(108, 43, 217, var(--bg-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:bg-purple-800 {\n    --bg-opacity: 1;\n    background-color: #5521b5;\n    background-color: rgba(85, 33, 181, var(--bg-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:bg-purple-900 {\n    --bg-opacity: 1;\n    background-color: #4a1d96;\n    background-color: rgba(74, 29, 150, var(--bg-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:bg-pink-50 {\n    --bg-opacity: 1;\n    background-color: #fdf2f8;\n    background-color: rgba(253, 242, 248, var(--bg-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:bg-pink-100 {\n    --bg-opacity: 1;\n    background-color: #fce8f3;\n    background-color: rgba(252, 232, 243, var(--bg-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:bg-pink-200 {\n    --bg-opacity: 1;\n    background-color: #fad1e8;\n    background-color: rgba(250, 209, 232, var(--bg-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:bg-pink-300 {\n    --bg-opacity: 1;\n    background-color: #f8b4d9;\n    background-color: rgba(248, 180, 217, var(--bg-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:bg-pink-400 {\n    --bg-opacity: 1;\n    background-color: #f17eb8;\n    background-color: rgba(241, 126, 184, var(--bg-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:bg-pink-500 {\n    --bg-opacity: 1;\n    background-color: #e74694;\n    background-color: rgba(231, 70, 148, var(--bg-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:bg-pink-600 {\n    --bg-opacity: 1;\n    background-color: #d61f69;\n    background-color: rgba(214, 31, 105, var(--bg-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:bg-pink-700 {\n    --bg-opacity: 1;\n    background-color: #bf125d;\n    background-color: rgba(191, 18, 93, var(--bg-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:bg-pink-800 {\n    --bg-opacity: 1;\n    background-color: #99154b;\n    background-color: rgba(153, 21, 75, var(--bg-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:bg-pink-900 {\n    --bg-opacity: 1;\n    background-color: #751a3d;\n    background-color: rgba(117, 26, 61, var(--bg-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:bg-cool-gray-50 {\n    --bg-opacity: 1;\n    background-color: #f8fafc;\n    background-color: rgba(248, 250, 252, var(--bg-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:bg-cool-gray-100 {\n    --bg-opacity: 1;\n    background-color: #f1f5f9;\n    background-color: rgba(241, 245, 249, var(--bg-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:bg-cool-gray-200 {\n    --bg-opacity: 1;\n    background-color: #e2e8f0;\n    background-color: rgba(226, 232, 240, var(--bg-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:bg-cool-gray-300 {\n    --bg-opacity: 1;\n    background-color: #cfd8e3;\n    background-color: rgba(207, 216, 227, var(--bg-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:bg-cool-gray-400 {\n    --bg-opacity: 1;\n    background-color: #97a6ba;\n    background-color: rgba(151, 166, 186, var(--bg-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:bg-cool-gray-500 {\n    --bg-opacity: 1;\n    background-color: #64748b;\n    background-color: rgba(100, 116, 139, var(--bg-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:bg-cool-gray-600 {\n    --bg-opacity: 1;\n    background-color: #475569;\n    background-color: rgba(71, 85, 105, var(--bg-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:bg-cool-gray-700 {\n    --bg-opacity: 1;\n    background-color: #364152;\n    background-color: rgba(54, 65, 82, var(--bg-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:bg-cool-gray-800 {\n    --bg-opacity: 1;\n    background-color: #27303f;\n    background-color: rgba(39, 48, 63, var(--bg-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:bg-cool-gray-900 {\n    --bg-opacity: 1;\n    background-color: #1a202e;\n    background-color: rgba(26, 32, 46, var(--bg-opacity));\n  }\n  .lg\\:hover\\:bg-current:hover {\n    background-color: currentColor;\n  }\n  .lg\\:hover\\:bg-transparent:hover {\n    background-color: transparent;\n  }\n  .lg\\:hover\\:bg-white:hover {\n    --bg-opacity: 1;\n    background-color: #ffffff;\n    background-color: rgba(255, 255, 255, var(--bg-opacity));\n  }\n  .lg\\:hover\\:bg-black:hover {\n    --bg-opacity: 1;\n    background-color: #000000;\n    background-color: rgba(0, 0, 0, var(--bg-opacity));\n  }\n  .lg\\:hover\\:bg-gray-50:hover {\n    --bg-opacity: 1;\n    background-color: #f9fafb;\n    background-color: rgba(249, 250, 251, var(--bg-opacity));\n  }\n  .lg\\:hover\\:bg-gray-100:hover {\n    --bg-opacity: 1;\n    background-color: #f4f5f7;\n    background-color: rgba(244, 245, 247, var(--bg-opacity));\n  }\n  .lg\\:hover\\:bg-gray-200:hover {\n    --bg-opacity: 1;\n    background-color: #e5e7eb;\n    background-color: rgba(229, 231, 235, var(--bg-opacity));\n  }\n  .lg\\:hover\\:bg-gray-300:hover {\n    --bg-opacity: 1;\n    background-color: #d2d6dc;\n    background-color: rgba(210, 214, 220, var(--bg-opacity));\n  }\n  .lg\\:hover\\:bg-gray-400:hover {\n    --bg-opacity: 1;\n    background-color: #9fa6b2;\n    background-color: rgba(159, 166, 178, var(--bg-opacity));\n  }\n  .lg\\:hover\\:bg-gray-500:hover {\n    --bg-opacity: 1;\n    background-color: #6b7280;\n    background-color: rgba(107, 114, 128, var(--bg-opacity));\n  }\n  .lg\\:hover\\:bg-gray-600:hover {\n    --bg-opacity: 1;\n    background-color: #4b5563;\n    background-color: rgba(75, 85, 99, var(--bg-opacity));\n  }\n  .lg\\:hover\\:bg-gray-700:hover {\n    --bg-opacity: 1;\n    background-color: #374151;\n    background-color: rgba(55, 65, 81, var(--bg-opacity));\n  }\n  .lg\\:hover\\:bg-gray-800:hover {\n    --bg-opacity: 1;\n    background-color: #252f3f;\n    background-color: rgba(37, 47, 63, var(--bg-opacity));\n  }\n  .lg\\:hover\\:bg-gray-900:hover {\n    --bg-opacity: 1;\n    background-color: #161e2e;\n    background-color: rgba(22, 30, 46, var(--bg-opacity));\n  }\n  .lg\\:hover\\:bg-red-50:hover {\n    --bg-opacity: 1;\n    background-color: #fdf2f2;\n    background-color: rgba(253, 242, 242, var(--bg-opacity));\n  }\n  .lg\\:hover\\:bg-red-100:hover {\n    --bg-opacity: 1;\n    background-color: #fde8e8;\n    background-color: rgba(253, 232, 232, var(--bg-opacity));\n  }\n  .lg\\:hover\\:bg-red-200:hover {\n    --bg-opacity: 1;\n    background-color: #fbd5d5;\n    background-color: rgba(251, 213, 213, var(--bg-opacity));\n  }\n  .lg\\:hover\\:bg-red-300:hover {\n    --bg-opacity: 1;\n    background-color: #f8b4b4;\n    background-color: rgba(248, 180, 180, var(--bg-opacity));\n  }\n  .lg\\:hover\\:bg-red-400:hover {\n    --bg-opacity: 1;\n    background-color: #f98080;\n    background-color: rgba(249, 128, 128, var(--bg-opacity));\n  }\n  .lg\\:hover\\:bg-red-500:hover {\n    --bg-opacity: 1;\n    background-color: #f05252;\n    background-color: rgba(240, 82, 82, var(--bg-opacity));\n  }\n  .lg\\:hover\\:bg-red-600:hover {\n    --bg-opacity: 1;\n    background-color: #e02424;\n    background-color: rgba(224, 36, 36, var(--bg-opacity));\n  }\n  .lg\\:hover\\:bg-red-700:hover {\n    --bg-opacity: 1;\n    background-color: #c81e1e;\n    background-color: rgba(200, 30, 30, var(--bg-opacity));\n  }\n  .lg\\:hover\\:bg-red-800:hover {\n    --bg-opacity: 1;\n    background-color: #9b1c1c;\n    background-color: rgba(155, 28, 28, var(--bg-opacity));\n  }\n  .lg\\:hover\\:bg-red-900:hover {\n    --bg-opacity: 1;\n    background-color: #771d1d;\n    background-color: rgba(119, 29, 29, var(--bg-opacity));\n  }\n  .lg\\:hover\\:bg-orange-50:hover {\n    --bg-opacity: 1;\n    background-color: #fff8f1;\n    background-color: rgba(255, 248, 241, var(--bg-opacity));\n  }\n  .lg\\:hover\\:bg-orange-100:hover {\n    --bg-opacity: 1;\n    background-color: #feecdc;\n    background-color: rgba(254, 236, 220, var(--bg-opacity));\n  }\n  .lg\\:hover\\:bg-orange-200:hover {\n    --bg-opacity: 1;\n    background-color: #fcd9bd;\n    background-color: rgba(252, 217, 189, var(--bg-opacity));\n  }\n  .lg\\:hover\\:bg-orange-300:hover {\n    --bg-opacity: 1;\n    background-color: #fdba8c;\n    background-color: rgba(253, 186, 140, var(--bg-opacity));\n  }\n  .lg\\:hover\\:bg-orange-400:hover {\n    --bg-opacity: 1;\n    background-color: #ff8a4c;\n    background-color: rgba(255, 138, 76, var(--bg-opacity));\n  }\n  .lg\\:hover\\:bg-orange-500:hover {\n    --bg-opacity: 1;\n    background-color: #ff5a1f;\n    background-color: rgba(255, 90, 31, var(--bg-opacity));\n  }\n  .lg\\:hover\\:bg-orange-600:hover {\n    --bg-opacity: 1;\n    background-color: #d03801;\n    background-color: rgba(208, 56, 1, var(--bg-opacity));\n  }\n  .lg\\:hover\\:bg-orange-700:hover {\n    --bg-opacity: 1;\n    background-color: #b43403;\n    background-color: rgba(180, 52, 3, var(--bg-opacity));\n  }\n  .lg\\:hover\\:bg-orange-800:hover {\n    --bg-opacity: 1;\n    background-color: #8a2c0d;\n    background-color: rgba(138, 44, 13, var(--bg-opacity));\n  }\n  .lg\\:hover\\:bg-orange-900:hover {\n    --bg-opacity: 1;\n    background-color: #73230d;\n    background-color: rgba(115, 35, 13, var(--bg-opacity));\n  }\n  .lg\\:hover\\:bg-yellow-50:hover {\n    --bg-opacity: 1;\n    background-color: #fdfdea;\n    background-color: rgba(253, 253, 234, var(--bg-opacity));\n  }\n  .lg\\:hover\\:bg-yellow-100:hover {\n    --bg-opacity: 1;\n    background-color: #fdf6b2;\n    background-color: rgba(253, 246, 178, var(--bg-opacity));\n  }\n  .lg\\:hover\\:bg-yellow-200:hover {\n    --bg-opacity: 1;\n    background-color: #fce96a;\n    background-color: rgba(252, 233, 106, var(--bg-opacity));\n  }\n  .lg\\:hover\\:bg-yellow-300:hover {\n    --bg-opacity: 1;\n    background-color: #faca15;\n    background-color: rgba(250, 202, 21, var(--bg-opacity));\n  }\n  .lg\\:hover\\:bg-yellow-400:hover {\n    --bg-opacity: 1;\n    background-color: #e3a008;\n    background-color: rgba(227, 160, 8, var(--bg-opacity));\n  }\n  .lg\\:hover\\:bg-yellow-500:hover {\n    --bg-opacity: 1;\n    background-color: #c27803;\n    background-color: rgba(194, 120, 3, var(--bg-opacity));\n  }\n  .lg\\:hover\\:bg-yellow-600:hover {\n    --bg-opacity: 1;\n    background-color: #9f580a;\n    background-color: rgba(159, 88, 10, var(--bg-opacity));\n  }\n  .lg\\:hover\\:bg-yellow-700:hover {\n    --bg-opacity: 1;\n    background-color: #8e4b10;\n    background-color: rgba(142, 75, 16, var(--bg-opacity));\n  }\n  .lg\\:hover\\:bg-yellow-800:hover {\n    --bg-opacity: 1;\n    background-color: #723b13;\n    background-color: rgba(114, 59, 19, var(--bg-opacity));\n  }\n  .lg\\:hover\\:bg-yellow-900:hover {\n    --bg-opacity: 1;\n    background-color: #633112;\n    background-color: rgba(99, 49, 18, var(--bg-opacity));\n  }\n  .lg\\:hover\\:bg-green-50:hover {\n    --bg-opacity: 1;\n    background-color: #f3faf7;\n    background-color: rgba(243, 250, 247, var(--bg-opacity));\n  }\n  .lg\\:hover\\:bg-green-100:hover {\n    --bg-opacity: 1;\n    background-color: #def7ec;\n    background-color: rgba(222, 247, 236, var(--bg-opacity));\n  }\n  .lg\\:hover\\:bg-green-200:hover {\n    --bg-opacity: 1;\n    background-color: #bcf0da;\n    background-color: rgba(188, 240, 218, var(--bg-opacity));\n  }\n  .lg\\:hover\\:bg-green-300:hover {\n    --bg-opacity: 1;\n    background-color: #84e1bc;\n    background-color: rgba(132, 225, 188, var(--bg-opacity));\n  }\n  .lg\\:hover\\:bg-green-400:hover {\n    --bg-opacity: 1;\n    background-color: #31c48d;\n    background-color: rgba(49, 196, 141, var(--bg-opacity));\n  }\n  .lg\\:hover\\:bg-green-500:hover {\n    --bg-opacity: 1;\n    background-color: #0e9f6e;\n    background-color: rgba(14, 159, 110, var(--bg-opacity));\n  }\n  .lg\\:hover\\:bg-green-600:hover {\n    --bg-opacity: 1;\n    background-color: #057a55;\n    background-color: rgba(5, 122, 85, var(--bg-opacity));\n  }\n  .lg\\:hover\\:bg-green-700:hover {\n    --bg-opacity: 1;\n    background-color: #046c4e;\n    background-color: rgba(4, 108, 78, var(--bg-opacity));\n  }\n  .lg\\:hover\\:bg-green-800:hover {\n    --bg-opacity: 1;\n    background-color: #03543f;\n    background-color: rgba(3, 84, 63, var(--bg-opacity));\n  }\n  .lg\\:hover\\:bg-green-900:hover {\n    --bg-opacity: 1;\n    background-color: #014737;\n    background-color: rgba(1, 71, 55, var(--bg-opacity));\n  }\n  .lg\\:hover\\:bg-teal-50:hover {\n    --bg-opacity: 1;\n    background-color: #edfafa;\n    background-color: rgba(237, 250, 250, var(--bg-opacity));\n  }\n  .lg\\:hover\\:bg-teal-100:hover {\n    --bg-opacity: 1;\n    background-color: #d5f5f6;\n    background-color: rgba(213, 245, 246, var(--bg-opacity));\n  }\n  .lg\\:hover\\:bg-teal-200:hover {\n    --bg-opacity: 1;\n    background-color: #afecef;\n    background-color: rgba(175, 236, 239, var(--bg-opacity));\n  }\n  .lg\\:hover\\:bg-teal-300:hover {\n    --bg-opacity: 1;\n    background-color: #7edce2;\n    background-color: rgba(126, 220, 226, var(--bg-opacity));\n  }\n  .lg\\:hover\\:bg-teal-400:hover {\n    --bg-opacity: 1;\n    background-color: #16bdca;\n    background-color: rgba(22, 189, 202, var(--bg-opacity));\n  }\n  .lg\\:hover\\:bg-teal-500:hover {\n    --bg-opacity: 1;\n    background-color: #0694a2;\n    background-color: rgba(6, 148, 162, var(--bg-opacity));\n  }\n  .lg\\:hover\\:bg-teal-600:hover {\n    --bg-opacity: 1;\n    background-color: #047481;\n    background-color: rgba(4, 116, 129, var(--bg-opacity));\n  }\n  .lg\\:hover\\:bg-teal-700:hover {\n    --bg-opacity: 1;\n    background-color: #036672;\n    background-color: rgba(3, 102, 114, var(--bg-opacity));\n  }\n  .lg\\:hover\\:bg-teal-800:hover {\n    --bg-opacity: 1;\n    background-color: #05505c;\n    background-color: rgba(5, 80, 92, var(--bg-opacity));\n  }\n  .lg\\:hover\\:bg-teal-900:hover {\n    --bg-opacity: 1;\n    background-color: #014451;\n    background-color: rgba(1, 68, 81, var(--bg-opacity));\n  }\n  .lg\\:hover\\:bg-blue-50:hover {\n    --bg-opacity: 1;\n    background-color: #ebf5ff;\n    background-color: rgba(235, 245, 255, var(--bg-opacity));\n  }\n  .lg\\:hover\\:bg-blue-100:hover {\n    --bg-opacity: 1;\n    background-color: #e1effe;\n    background-color: rgba(225, 239, 254, var(--bg-opacity));\n  }\n  .lg\\:hover\\:bg-blue-200:hover {\n    --bg-opacity: 1;\n    background-color: #c3ddfd;\n    background-color: rgba(195, 221, 253, var(--bg-opacity));\n  }\n  .lg\\:hover\\:bg-blue-300:hover {\n    --bg-opacity: 1;\n    background-color: #a4cafe;\n    background-color: rgba(164, 202, 254, var(--bg-opacity));\n  }\n  .lg\\:hover\\:bg-blue-400:hover {\n    --bg-opacity: 1;\n    background-color: #76a9fa;\n    background-color: rgba(118, 169, 250, var(--bg-opacity));\n  }\n  .lg\\:hover\\:bg-blue-500:hover {\n    --bg-opacity: 1;\n    background-color: #3f83f8;\n    background-color: rgba(63, 131, 248, var(--bg-opacity));\n  }\n  .lg\\:hover\\:bg-blue-600:hover {\n    --bg-opacity: 1;\n    background-color: #1c64f2;\n    background-color: rgba(28, 100, 242, var(--bg-opacity));\n  }\n  .lg\\:hover\\:bg-blue-700:hover {\n    --bg-opacity: 1;\n    background-color: #1a56db;\n    background-color: rgba(26, 86, 219, var(--bg-opacity));\n  }\n  .lg\\:hover\\:bg-blue-800:hover {\n    --bg-opacity: 1;\n    background-color: #1e429f;\n    background-color: rgba(30, 66, 159, var(--bg-opacity));\n  }\n  .lg\\:hover\\:bg-blue-900:hover {\n    --bg-opacity: 1;\n    background-color: #233876;\n    background-color: rgba(35, 56, 118, var(--bg-opacity));\n  }\n  .lg\\:hover\\:bg-indigo-50:hover {\n    --bg-opacity: 1;\n    background-color: #f0f5ff;\n    background-color: rgba(240, 245, 255, var(--bg-opacity));\n  }\n  .lg\\:hover\\:bg-indigo-100:hover {\n    --bg-opacity: 1;\n    background-color: #e5edff;\n    background-color: rgba(229, 237, 255, var(--bg-opacity));\n  }\n  .lg\\:hover\\:bg-indigo-200:hover {\n    --bg-opacity: 1;\n    background-color: #cddbfe;\n    background-color: rgba(205, 219, 254, var(--bg-opacity));\n  }\n  .lg\\:hover\\:bg-indigo-300:hover {\n    --bg-opacity: 1;\n    background-color: #b4c6fc;\n    background-color: rgba(180, 198, 252, var(--bg-opacity));\n  }\n  .lg\\:hover\\:bg-indigo-400:hover {\n    --bg-opacity: 1;\n    background-color: #8da2fb;\n    background-color: rgba(141, 162, 251, var(--bg-opacity));\n  }\n  .lg\\:hover\\:bg-indigo-500:hover {\n    --bg-opacity: 1;\n    background-color: #6875f5;\n    background-color: rgba(104, 117, 245, var(--bg-opacity));\n  }\n  .lg\\:hover\\:bg-indigo-600:hover {\n    --bg-opacity: 1;\n    background-color: #5850ec;\n    background-color: rgba(88, 80, 236, var(--bg-opacity));\n  }\n  .lg\\:hover\\:bg-indigo-700:hover {\n    --bg-opacity: 1;\n    background-color: #5145cd;\n    background-color: rgba(81, 69, 205, var(--bg-opacity));\n  }\n  .lg\\:hover\\:bg-indigo-800:hover {\n    --bg-opacity: 1;\n    background-color: #42389d;\n    background-color: rgba(66, 56, 157, var(--bg-opacity));\n  }\n  .lg\\:hover\\:bg-indigo-900:hover {\n    --bg-opacity: 1;\n    background-color: #362f78;\n    background-color: rgba(54, 47, 120, var(--bg-opacity));\n  }\n  .lg\\:hover\\:bg-purple-50:hover {\n    --bg-opacity: 1;\n    background-color: #f6f5ff;\n    background-color: rgba(246, 245, 255, var(--bg-opacity));\n  }\n  .lg\\:hover\\:bg-purple-100:hover {\n    --bg-opacity: 1;\n    background-color: #edebfe;\n    background-color: rgba(237, 235, 254, var(--bg-opacity));\n  }\n  .lg\\:hover\\:bg-purple-200:hover {\n    --bg-opacity: 1;\n    background-color: #dcd7fe;\n    background-color: rgba(220, 215, 254, var(--bg-opacity));\n  }\n  .lg\\:hover\\:bg-purple-300:hover {\n    --bg-opacity: 1;\n    background-color: #cabffd;\n    background-color: rgba(202, 191, 253, var(--bg-opacity));\n  }\n  .lg\\:hover\\:bg-purple-400:hover {\n    --bg-opacity: 1;\n    background-color: #ac94fa;\n    background-color: rgba(172, 148, 250, var(--bg-opacity));\n  }\n  .lg\\:hover\\:bg-purple-500:hover {\n    --bg-opacity: 1;\n    background-color: #9061f9;\n    background-color: rgba(144, 97, 249, var(--bg-opacity));\n  }\n  .lg\\:hover\\:bg-purple-600:hover {\n    --bg-opacity: 1;\n    background-color: #7e3af2;\n    background-color: rgba(126, 58, 242, var(--bg-opacity));\n  }\n  .lg\\:hover\\:bg-purple-700:hover {\n    --bg-opacity: 1;\n    background-color: #6c2bd9;\n    background-color: rgba(108, 43, 217, var(--bg-opacity));\n  }\n  .lg\\:hover\\:bg-purple-800:hover {\n    --bg-opacity: 1;\n    background-color: #5521b5;\n    background-color: rgba(85, 33, 181, var(--bg-opacity));\n  }\n  .lg\\:hover\\:bg-purple-900:hover {\n    --bg-opacity: 1;\n    background-color: #4a1d96;\n    background-color: rgba(74, 29, 150, var(--bg-opacity));\n  }\n  .lg\\:hover\\:bg-pink-50:hover {\n    --bg-opacity: 1;\n    background-color: #fdf2f8;\n    background-color: rgba(253, 242, 248, var(--bg-opacity));\n  }\n  .lg\\:hover\\:bg-pink-100:hover {\n    --bg-opacity: 1;\n    background-color: #fce8f3;\n    background-color: rgba(252, 232, 243, var(--bg-opacity));\n  }\n  .lg\\:hover\\:bg-pink-200:hover {\n    --bg-opacity: 1;\n    background-color: #fad1e8;\n    background-color: rgba(250, 209, 232, var(--bg-opacity));\n  }\n  .lg\\:hover\\:bg-pink-300:hover {\n    --bg-opacity: 1;\n    background-color: #f8b4d9;\n    background-color: rgba(248, 180, 217, var(--bg-opacity));\n  }\n  .lg\\:hover\\:bg-pink-400:hover {\n    --bg-opacity: 1;\n    background-color: #f17eb8;\n    background-color: rgba(241, 126, 184, var(--bg-opacity));\n  }\n  .lg\\:hover\\:bg-pink-500:hover {\n    --bg-opacity: 1;\n    background-color: #e74694;\n    background-color: rgba(231, 70, 148, var(--bg-opacity));\n  }\n  .lg\\:hover\\:bg-pink-600:hover {\n    --bg-opacity: 1;\n    background-color: #d61f69;\n    background-color: rgba(214, 31, 105, var(--bg-opacity));\n  }\n  .lg\\:hover\\:bg-pink-700:hover {\n    --bg-opacity: 1;\n    background-color: #bf125d;\n    background-color: rgba(191, 18, 93, var(--bg-opacity));\n  }\n  .lg\\:hover\\:bg-pink-800:hover {\n    --bg-opacity: 1;\n    background-color: #99154b;\n    background-color: rgba(153, 21, 75, var(--bg-opacity));\n  }\n  .lg\\:hover\\:bg-pink-900:hover {\n    --bg-opacity: 1;\n    background-color: #751a3d;\n    background-color: rgba(117, 26, 61, var(--bg-opacity));\n  }\n  .lg\\:hover\\:bg-cool-gray-50:hover {\n    --bg-opacity: 1;\n    background-color: #f8fafc;\n    background-color: rgba(248, 250, 252, var(--bg-opacity));\n  }\n  .lg\\:hover\\:bg-cool-gray-100:hover {\n    --bg-opacity: 1;\n    background-color: #f1f5f9;\n    background-color: rgba(241, 245, 249, var(--bg-opacity));\n  }\n  .lg\\:hover\\:bg-cool-gray-200:hover {\n    --bg-opacity: 1;\n    background-color: #e2e8f0;\n    background-color: rgba(226, 232, 240, var(--bg-opacity));\n  }\n  .lg\\:hover\\:bg-cool-gray-300:hover {\n    --bg-opacity: 1;\n    background-color: #cfd8e3;\n    background-color: rgba(207, 216, 227, var(--bg-opacity));\n  }\n  .lg\\:hover\\:bg-cool-gray-400:hover {\n    --bg-opacity: 1;\n    background-color: #97a6ba;\n    background-color: rgba(151, 166, 186, var(--bg-opacity));\n  }\n  .lg\\:hover\\:bg-cool-gray-500:hover {\n    --bg-opacity: 1;\n    background-color: #64748b;\n    background-color: rgba(100, 116, 139, var(--bg-opacity));\n  }\n  .lg\\:hover\\:bg-cool-gray-600:hover {\n    --bg-opacity: 1;\n    background-color: #475569;\n    background-color: rgba(71, 85, 105, var(--bg-opacity));\n  }\n  .lg\\:hover\\:bg-cool-gray-700:hover {\n    --bg-opacity: 1;\n    background-color: #364152;\n    background-color: rgba(54, 65, 82, var(--bg-opacity));\n  }\n  .lg\\:hover\\:bg-cool-gray-800:hover {\n    --bg-opacity: 1;\n    background-color: #27303f;\n    background-color: rgba(39, 48, 63, var(--bg-opacity));\n  }\n  .lg\\:hover\\:bg-cool-gray-900:hover {\n    --bg-opacity: 1;\n    background-color: #1a202e;\n    background-color: rgba(26, 32, 46, var(--bg-opacity));\n  }\n  .lg\\:focus\\:bg-current:focus {\n    background-color: currentColor;\n  }\n  .lg\\:focus\\:bg-transparent:focus {\n    background-color: transparent;\n  }\n  .lg\\:focus\\:bg-white:focus {\n    --bg-opacity: 1;\n    background-color: #ffffff;\n    background-color: rgba(255, 255, 255, var(--bg-opacity));\n  }\n  .lg\\:focus\\:bg-black:focus {\n    --bg-opacity: 1;\n    background-color: #000000;\n    background-color: rgba(0, 0, 0, var(--bg-opacity));\n  }\n  .lg\\:focus\\:bg-gray-50:focus {\n    --bg-opacity: 1;\n    background-color: #f9fafb;\n    background-color: rgba(249, 250, 251, var(--bg-opacity));\n  }\n  .lg\\:focus\\:bg-gray-100:focus {\n    --bg-opacity: 1;\n    background-color: #f4f5f7;\n    background-color: rgba(244, 245, 247, var(--bg-opacity));\n  }\n  .lg\\:focus\\:bg-gray-200:focus {\n    --bg-opacity: 1;\n    background-color: #e5e7eb;\n    background-color: rgba(229, 231, 235, var(--bg-opacity));\n  }\n  .lg\\:focus\\:bg-gray-300:focus {\n    --bg-opacity: 1;\n    background-color: #d2d6dc;\n    background-color: rgba(210, 214, 220, var(--bg-opacity));\n  }\n  .lg\\:focus\\:bg-gray-400:focus {\n    --bg-opacity: 1;\n    background-color: #9fa6b2;\n    background-color: rgba(159, 166, 178, var(--bg-opacity));\n  }\n  .lg\\:focus\\:bg-gray-500:focus {\n    --bg-opacity: 1;\n    background-color: #6b7280;\n    background-color: rgba(107, 114, 128, var(--bg-opacity));\n  }\n  .lg\\:focus\\:bg-gray-600:focus {\n    --bg-opacity: 1;\n    background-color: #4b5563;\n    background-color: rgba(75, 85, 99, var(--bg-opacity));\n  }\n  .lg\\:focus\\:bg-gray-700:focus {\n    --bg-opacity: 1;\n    background-color: #374151;\n    background-color: rgba(55, 65, 81, var(--bg-opacity));\n  }\n  .lg\\:focus\\:bg-gray-800:focus {\n    --bg-opacity: 1;\n    background-color: #252f3f;\n    background-color: rgba(37, 47, 63, var(--bg-opacity));\n  }\n  .lg\\:focus\\:bg-gray-900:focus {\n    --bg-opacity: 1;\n    background-color: #161e2e;\n    background-color: rgba(22, 30, 46, var(--bg-opacity));\n  }\n  .lg\\:focus\\:bg-red-50:focus {\n    --bg-opacity: 1;\n    background-color: #fdf2f2;\n    background-color: rgba(253, 242, 242, var(--bg-opacity));\n  }\n  .lg\\:focus\\:bg-red-100:focus {\n    --bg-opacity: 1;\n    background-color: #fde8e8;\n    background-color: rgba(253, 232, 232, var(--bg-opacity));\n  }\n  .lg\\:focus\\:bg-red-200:focus {\n    --bg-opacity: 1;\n    background-color: #fbd5d5;\n    background-color: rgba(251, 213, 213, var(--bg-opacity));\n  }\n  .lg\\:focus\\:bg-red-300:focus {\n    --bg-opacity: 1;\n    background-color: #f8b4b4;\n    background-color: rgba(248, 180, 180, var(--bg-opacity));\n  }\n  .lg\\:focus\\:bg-red-400:focus {\n    --bg-opacity: 1;\n    background-color: #f98080;\n    background-color: rgba(249, 128, 128, var(--bg-opacity));\n  }\n  .lg\\:focus\\:bg-red-500:focus {\n    --bg-opacity: 1;\n    background-color: #f05252;\n    background-color: rgba(240, 82, 82, var(--bg-opacity));\n  }\n  .lg\\:focus\\:bg-red-600:focus {\n    --bg-opacity: 1;\n    background-color: #e02424;\n    background-color: rgba(224, 36, 36, var(--bg-opacity));\n  }\n  .lg\\:focus\\:bg-red-700:focus {\n    --bg-opacity: 1;\n    background-color: #c81e1e;\n    background-color: rgba(200, 30, 30, var(--bg-opacity));\n  }\n  .lg\\:focus\\:bg-red-800:focus {\n    --bg-opacity: 1;\n    background-color: #9b1c1c;\n    background-color: rgba(155, 28, 28, var(--bg-opacity));\n  }\n  .lg\\:focus\\:bg-red-900:focus {\n    --bg-opacity: 1;\n    background-color: #771d1d;\n    background-color: rgba(119, 29, 29, var(--bg-opacity));\n  }\n  .lg\\:focus\\:bg-orange-50:focus {\n    --bg-opacity: 1;\n    background-color: #fff8f1;\n    background-color: rgba(255, 248, 241, var(--bg-opacity));\n  }\n  .lg\\:focus\\:bg-orange-100:focus {\n    --bg-opacity: 1;\n    background-color: #feecdc;\n    background-color: rgba(254, 236, 220, var(--bg-opacity));\n  }\n  .lg\\:focus\\:bg-orange-200:focus {\n    --bg-opacity: 1;\n    background-color: #fcd9bd;\n    background-color: rgba(252, 217, 189, var(--bg-opacity));\n  }\n  .lg\\:focus\\:bg-orange-300:focus {\n    --bg-opacity: 1;\n    background-color: #fdba8c;\n    background-color: rgba(253, 186, 140, var(--bg-opacity));\n  }\n  .lg\\:focus\\:bg-orange-400:focus {\n    --bg-opacity: 1;\n    background-color: #ff8a4c;\n    background-color: rgba(255, 138, 76, var(--bg-opacity));\n  }\n  .lg\\:focus\\:bg-orange-500:focus {\n    --bg-opacity: 1;\n    background-color: #ff5a1f;\n    background-color: rgba(255, 90, 31, var(--bg-opacity));\n  }\n  .lg\\:focus\\:bg-orange-600:focus {\n    --bg-opacity: 1;\n    background-color: #d03801;\n    background-color: rgba(208, 56, 1, var(--bg-opacity));\n  }\n  .lg\\:focus\\:bg-orange-700:focus {\n    --bg-opacity: 1;\n    background-color: #b43403;\n    background-color: rgba(180, 52, 3, var(--bg-opacity));\n  }\n  .lg\\:focus\\:bg-orange-800:focus {\n    --bg-opacity: 1;\n    background-color: #8a2c0d;\n    background-color: rgba(138, 44, 13, var(--bg-opacity));\n  }\n  .lg\\:focus\\:bg-orange-900:focus {\n    --bg-opacity: 1;\n    background-color: #73230d;\n    background-color: rgba(115, 35, 13, var(--bg-opacity));\n  }\n  .lg\\:focus\\:bg-yellow-50:focus {\n    --bg-opacity: 1;\n    background-color: #fdfdea;\n    background-color: rgba(253, 253, 234, var(--bg-opacity));\n  }\n  .lg\\:focus\\:bg-yellow-100:focus {\n    --bg-opacity: 1;\n    background-color: #fdf6b2;\n    background-color: rgba(253, 246, 178, var(--bg-opacity));\n  }\n  .lg\\:focus\\:bg-yellow-200:focus {\n    --bg-opacity: 1;\n    background-color: #fce96a;\n    background-color: rgba(252, 233, 106, var(--bg-opacity));\n  }\n  .lg\\:focus\\:bg-yellow-300:focus {\n    --bg-opacity: 1;\n    background-color: #faca15;\n    background-color: rgba(250, 202, 21, var(--bg-opacity));\n  }\n  .lg\\:focus\\:bg-yellow-400:focus {\n    --bg-opacity: 1;\n    background-color: #e3a008;\n    background-color: rgba(227, 160, 8, var(--bg-opacity));\n  }\n  .lg\\:focus\\:bg-yellow-500:focus {\n    --bg-opacity: 1;\n    background-color: #c27803;\n    background-color: rgba(194, 120, 3, var(--bg-opacity));\n  }\n  .lg\\:focus\\:bg-yellow-600:focus {\n    --bg-opacity: 1;\n    background-color: #9f580a;\n    background-color: rgba(159, 88, 10, var(--bg-opacity));\n  }\n  .lg\\:focus\\:bg-yellow-700:focus {\n    --bg-opacity: 1;\n    background-color: #8e4b10;\n    background-color: rgba(142, 75, 16, var(--bg-opacity));\n  }\n  .lg\\:focus\\:bg-yellow-800:focus {\n    --bg-opacity: 1;\n    background-color: #723b13;\n    background-color: rgba(114, 59, 19, var(--bg-opacity));\n  }\n  .lg\\:focus\\:bg-yellow-900:focus {\n    --bg-opacity: 1;\n    background-color: #633112;\n    background-color: rgba(99, 49, 18, var(--bg-opacity));\n  }\n  .lg\\:focus\\:bg-green-50:focus {\n    --bg-opacity: 1;\n    background-color: #f3faf7;\n    background-color: rgba(243, 250, 247, var(--bg-opacity));\n  }\n  .lg\\:focus\\:bg-green-100:focus {\n    --bg-opacity: 1;\n    background-color: #def7ec;\n    background-color: rgba(222, 247, 236, var(--bg-opacity));\n  }\n  .lg\\:focus\\:bg-green-200:focus {\n    --bg-opacity: 1;\n    background-color: #bcf0da;\n    background-color: rgba(188, 240, 218, var(--bg-opacity));\n  }\n  .lg\\:focus\\:bg-green-300:focus {\n    --bg-opacity: 1;\n    background-color: #84e1bc;\n    background-color: rgba(132, 225, 188, var(--bg-opacity));\n  }\n  .lg\\:focus\\:bg-green-400:focus {\n    --bg-opacity: 1;\n    background-color: #31c48d;\n    background-color: rgba(49, 196, 141, var(--bg-opacity));\n  }\n  .lg\\:focus\\:bg-green-500:focus {\n    --bg-opacity: 1;\n    background-color: #0e9f6e;\n    background-color: rgba(14, 159, 110, var(--bg-opacity));\n  }\n  .lg\\:focus\\:bg-green-600:focus {\n    --bg-opacity: 1;\n    background-color: #057a55;\n    background-color: rgba(5, 122, 85, var(--bg-opacity));\n  }\n  .lg\\:focus\\:bg-green-700:focus {\n    --bg-opacity: 1;\n    background-color: #046c4e;\n    background-color: rgba(4, 108, 78, var(--bg-opacity));\n  }\n  .lg\\:focus\\:bg-green-800:focus {\n    --bg-opacity: 1;\n    background-color: #03543f;\n    background-color: rgba(3, 84, 63, var(--bg-opacity));\n  }\n  .lg\\:focus\\:bg-green-900:focus {\n    --bg-opacity: 1;\n    background-color: #014737;\n    background-color: rgba(1, 71, 55, var(--bg-opacity));\n  }\n  .lg\\:focus\\:bg-teal-50:focus {\n    --bg-opacity: 1;\n    background-color: #edfafa;\n    background-color: rgba(237, 250, 250, var(--bg-opacity));\n  }\n  .lg\\:focus\\:bg-teal-100:focus {\n    --bg-opacity: 1;\n    background-color: #d5f5f6;\n    background-color: rgba(213, 245, 246, var(--bg-opacity));\n  }\n  .lg\\:focus\\:bg-teal-200:focus {\n    --bg-opacity: 1;\n    background-color: #afecef;\n    background-color: rgba(175, 236, 239, var(--bg-opacity));\n  }\n  .lg\\:focus\\:bg-teal-300:focus {\n    --bg-opacity: 1;\n    background-color: #7edce2;\n    background-color: rgba(126, 220, 226, var(--bg-opacity));\n  }\n  .lg\\:focus\\:bg-teal-400:focus {\n    --bg-opacity: 1;\n    background-color: #16bdca;\n    background-color: rgba(22, 189, 202, var(--bg-opacity));\n  }\n  .lg\\:focus\\:bg-teal-500:focus {\n    --bg-opacity: 1;\n    background-color: #0694a2;\n    background-color: rgba(6, 148, 162, var(--bg-opacity));\n  }\n  .lg\\:focus\\:bg-teal-600:focus {\n    --bg-opacity: 1;\n    background-color: #047481;\n    background-color: rgba(4, 116, 129, var(--bg-opacity));\n  }\n  .lg\\:focus\\:bg-teal-700:focus {\n    --bg-opacity: 1;\n    background-color: #036672;\n    background-color: rgba(3, 102, 114, var(--bg-opacity));\n  }\n  .lg\\:focus\\:bg-teal-800:focus {\n    --bg-opacity: 1;\n    background-color: #05505c;\n    background-color: rgba(5, 80, 92, var(--bg-opacity));\n  }\n  .lg\\:focus\\:bg-teal-900:focus {\n    --bg-opacity: 1;\n    background-color: #014451;\n    background-color: rgba(1, 68, 81, var(--bg-opacity));\n  }\n  .lg\\:focus\\:bg-blue-50:focus {\n    --bg-opacity: 1;\n    background-color: #ebf5ff;\n    background-color: rgba(235, 245, 255, var(--bg-opacity));\n  }\n  .lg\\:focus\\:bg-blue-100:focus {\n    --bg-opacity: 1;\n    background-color: #e1effe;\n    background-color: rgba(225, 239, 254, var(--bg-opacity));\n  }\n  .lg\\:focus\\:bg-blue-200:focus {\n    --bg-opacity: 1;\n    background-color: #c3ddfd;\n    background-color: rgba(195, 221, 253, var(--bg-opacity));\n  }\n  .lg\\:focus\\:bg-blue-300:focus {\n    --bg-opacity: 1;\n    background-color: #a4cafe;\n    background-color: rgba(164, 202, 254, var(--bg-opacity));\n  }\n  .lg\\:focus\\:bg-blue-400:focus {\n    --bg-opacity: 1;\n    background-color: #76a9fa;\n    background-color: rgba(118, 169, 250, var(--bg-opacity));\n  }\n  .lg\\:focus\\:bg-blue-500:focus {\n    --bg-opacity: 1;\n    background-color: #3f83f8;\n    background-color: rgba(63, 131, 248, var(--bg-opacity));\n  }\n  .lg\\:focus\\:bg-blue-600:focus {\n    --bg-opacity: 1;\n    background-color: #1c64f2;\n    background-color: rgba(28, 100, 242, var(--bg-opacity));\n  }\n  .lg\\:focus\\:bg-blue-700:focus {\n    --bg-opacity: 1;\n    background-color: #1a56db;\n    background-color: rgba(26, 86, 219, var(--bg-opacity));\n  }\n  .lg\\:focus\\:bg-blue-800:focus {\n    --bg-opacity: 1;\n    background-color: #1e429f;\n    background-color: rgba(30, 66, 159, var(--bg-opacity));\n  }\n  .lg\\:focus\\:bg-blue-900:focus {\n    --bg-opacity: 1;\n    background-color: #233876;\n    background-color: rgba(35, 56, 118, var(--bg-opacity));\n  }\n  .lg\\:focus\\:bg-indigo-50:focus {\n    --bg-opacity: 1;\n    background-color: #f0f5ff;\n    background-color: rgba(240, 245, 255, var(--bg-opacity));\n  }\n  .lg\\:focus\\:bg-indigo-100:focus {\n    --bg-opacity: 1;\n    background-color: #e5edff;\n    background-color: rgba(229, 237, 255, var(--bg-opacity));\n  }\n  .lg\\:focus\\:bg-indigo-200:focus {\n    --bg-opacity: 1;\n    background-color: #cddbfe;\n    background-color: rgba(205, 219, 254, var(--bg-opacity));\n  }\n  .lg\\:focus\\:bg-indigo-300:focus {\n    --bg-opacity: 1;\n    background-color: #b4c6fc;\n    background-color: rgba(180, 198, 252, var(--bg-opacity));\n  }\n  .lg\\:focus\\:bg-indigo-400:focus {\n    --bg-opacity: 1;\n    background-color: #8da2fb;\n    background-color: rgba(141, 162, 251, var(--bg-opacity));\n  }\n  .lg\\:focus\\:bg-indigo-500:focus {\n    --bg-opacity: 1;\n    background-color: #6875f5;\n    background-color: rgba(104, 117, 245, var(--bg-opacity));\n  }\n  .lg\\:focus\\:bg-indigo-600:focus {\n    --bg-opacity: 1;\n    background-color: #5850ec;\n    background-color: rgba(88, 80, 236, var(--bg-opacity));\n  }\n  .lg\\:focus\\:bg-indigo-700:focus {\n    --bg-opacity: 1;\n    background-color: #5145cd;\n    background-color: rgba(81, 69, 205, var(--bg-opacity));\n  }\n  .lg\\:focus\\:bg-indigo-800:focus {\n    --bg-opacity: 1;\n    background-color: #42389d;\n    background-color: rgba(66, 56, 157, var(--bg-opacity));\n  }\n  .lg\\:focus\\:bg-indigo-900:focus {\n    --bg-opacity: 1;\n    background-color: #362f78;\n    background-color: rgba(54, 47, 120, var(--bg-opacity));\n  }\n  .lg\\:focus\\:bg-purple-50:focus {\n    --bg-opacity: 1;\n    background-color: #f6f5ff;\n    background-color: rgba(246, 245, 255, var(--bg-opacity));\n  }\n  .lg\\:focus\\:bg-purple-100:focus {\n    --bg-opacity: 1;\n    background-color: #edebfe;\n    background-color: rgba(237, 235, 254, var(--bg-opacity));\n  }\n  .lg\\:focus\\:bg-purple-200:focus {\n    --bg-opacity: 1;\n    background-color: #dcd7fe;\n    background-color: rgba(220, 215, 254, var(--bg-opacity));\n  }\n  .lg\\:focus\\:bg-purple-300:focus {\n    --bg-opacity: 1;\n    background-color: #cabffd;\n    background-color: rgba(202, 191, 253, var(--bg-opacity));\n  }\n  .lg\\:focus\\:bg-purple-400:focus {\n    --bg-opacity: 1;\n    background-color: #ac94fa;\n    background-color: rgba(172, 148, 250, var(--bg-opacity));\n  }\n  .lg\\:focus\\:bg-purple-500:focus {\n    --bg-opacity: 1;\n    background-color: #9061f9;\n    background-color: rgba(144, 97, 249, var(--bg-opacity));\n  }\n  .lg\\:focus\\:bg-purple-600:focus {\n    --bg-opacity: 1;\n    background-color: #7e3af2;\n    background-color: rgba(126, 58, 242, var(--bg-opacity));\n  }\n  .lg\\:focus\\:bg-purple-700:focus {\n    --bg-opacity: 1;\n    background-color: #6c2bd9;\n    background-color: rgba(108, 43, 217, var(--bg-opacity));\n  }\n  .lg\\:focus\\:bg-purple-800:focus {\n    --bg-opacity: 1;\n    background-color: #5521b5;\n    background-color: rgba(85, 33, 181, var(--bg-opacity));\n  }\n  .lg\\:focus\\:bg-purple-900:focus {\n    --bg-opacity: 1;\n    background-color: #4a1d96;\n    background-color: rgba(74, 29, 150, var(--bg-opacity));\n  }\n  .lg\\:focus\\:bg-pink-50:focus {\n    --bg-opacity: 1;\n    background-color: #fdf2f8;\n    background-color: rgba(253, 242, 248, var(--bg-opacity));\n  }\n  .lg\\:focus\\:bg-pink-100:focus {\n    --bg-opacity: 1;\n    background-color: #fce8f3;\n    background-color: rgba(252, 232, 243, var(--bg-opacity));\n  }\n  .lg\\:focus\\:bg-pink-200:focus {\n    --bg-opacity: 1;\n    background-color: #fad1e8;\n    background-color: rgba(250, 209, 232, var(--bg-opacity));\n  }\n  .lg\\:focus\\:bg-pink-300:focus {\n    --bg-opacity: 1;\n    background-color: #f8b4d9;\n    background-color: rgba(248, 180, 217, var(--bg-opacity));\n  }\n  .lg\\:focus\\:bg-pink-400:focus {\n    --bg-opacity: 1;\n    background-color: #f17eb8;\n    background-color: rgba(241, 126, 184, var(--bg-opacity));\n  }\n  .lg\\:focus\\:bg-pink-500:focus {\n    --bg-opacity: 1;\n    background-color: #e74694;\n    background-color: rgba(231, 70, 148, var(--bg-opacity));\n  }\n  .lg\\:focus\\:bg-pink-600:focus {\n    --bg-opacity: 1;\n    background-color: #d61f69;\n    background-color: rgba(214, 31, 105, var(--bg-opacity));\n  }\n  .lg\\:focus\\:bg-pink-700:focus {\n    --bg-opacity: 1;\n    background-color: #bf125d;\n    background-color: rgba(191, 18, 93, var(--bg-opacity));\n  }\n  .lg\\:focus\\:bg-pink-800:focus {\n    --bg-opacity: 1;\n    background-color: #99154b;\n    background-color: rgba(153, 21, 75, var(--bg-opacity));\n  }\n  .lg\\:focus\\:bg-pink-900:focus {\n    --bg-opacity: 1;\n    background-color: #751a3d;\n    background-color: rgba(117, 26, 61, var(--bg-opacity));\n  }\n  .lg\\:focus\\:bg-cool-gray-50:focus {\n    --bg-opacity: 1;\n    background-color: #f8fafc;\n    background-color: rgba(248, 250, 252, var(--bg-opacity));\n  }\n  .lg\\:focus\\:bg-cool-gray-100:focus {\n    --bg-opacity: 1;\n    background-color: #f1f5f9;\n    background-color: rgba(241, 245, 249, var(--bg-opacity));\n  }\n  .lg\\:focus\\:bg-cool-gray-200:focus {\n    --bg-opacity: 1;\n    background-color: #e2e8f0;\n    background-color: rgba(226, 232, 240, var(--bg-opacity));\n  }\n  .lg\\:focus\\:bg-cool-gray-300:focus {\n    --bg-opacity: 1;\n    background-color: #cfd8e3;\n    background-color: rgba(207, 216, 227, var(--bg-opacity));\n  }\n  .lg\\:focus\\:bg-cool-gray-400:focus {\n    --bg-opacity: 1;\n    background-color: #97a6ba;\n    background-color: rgba(151, 166, 186, var(--bg-opacity));\n  }\n  .lg\\:focus\\:bg-cool-gray-500:focus {\n    --bg-opacity: 1;\n    background-color: #64748b;\n    background-color: rgba(100, 116, 139, var(--bg-opacity));\n  }\n  .lg\\:focus\\:bg-cool-gray-600:focus {\n    --bg-opacity: 1;\n    background-color: #475569;\n    background-color: rgba(71, 85, 105, var(--bg-opacity));\n  }\n  .lg\\:focus\\:bg-cool-gray-700:focus {\n    --bg-opacity: 1;\n    background-color: #364152;\n    background-color: rgba(54, 65, 82, var(--bg-opacity));\n  }\n  .lg\\:focus\\:bg-cool-gray-800:focus {\n    --bg-opacity: 1;\n    background-color: #27303f;\n    background-color: rgba(39, 48, 63, var(--bg-opacity));\n  }\n  .lg\\:focus\\:bg-cool-gray-900:focus {\n    --bg-opacity: 1;\n    background-color: #1a202e;\n    background-color: rgba(26, 32, 46, var(--bg-opacity));\n  }\n  .lg\\:active\\:bg-current:active {\n    background-color: currentColor;\n  }\n  .lg\\:active\\:bg-transparent:active {\n    background-color: transparent;\n  }\n  .lg\\:active\\:bg-white:active {\n    --bg-opacity: 1;\n    background-color: #ffffff;\n    background-color: rgba(255, 255, 255, var(--bg-opacity));\n  }\n  .lg\\:active\\:bg-black:active {\n    --bg-opacity: 1;\n    background-color: #000000;\n    background-color: rgba(0, 0, 0, var(--bg-opacity));\n  }\n  .lg\\:active\\:bg-gray-50:active {\n    --bg-opacity: 1;\n    background-color: #f9fafb;\n    background-color: rgba(249, 250, 251, var(--bg-opacity));\n  }\n  .lg\\:active\\:bg-gray-100:active {\n    --bg-opacity: 1;\n    background-color: #f4f5f7;\n    background-color: rgba(244, 245, 247, var(--bg-opacity));\n  }\n  .lg\\:active\\:bg-gray-200:active {\n    --bg-opacity: 1;\n    background-color: #e5e7eb;\n    background-color: rgba(229, 231, 235, var(--bg-opacity));\n  }\n  .lg\\:active\\:bg-gray-300:active {\n    --bg-opacity: 1;\n    background-color: #d2d6dc;\n    background-color: rgba(210, 214, 220, var(--bg-opacity));\n  }\n  .lg\\:active\\:bg-gray-400:active {\n    --bg-opacity: 1;\n    background-color: #9fa6b2;\n    background-color: rgba(159, 166, 178, var(--bg-opacity));\n  }\n  .lg\\:active\\:bg-gray-500:active {\n    --bg-opacity: 1;\n    background-color: #6b7280;\n    background-color: rgba(107, 114, 128, var(--bg-opacity));\n  }\n  .lg\\:active\\:bg-gray-600:active {\n    --bg-opacity: 1;\n    background-color: #4b5563;\n    background-color: rgba(75, 85, 99, var(--bg-opacity));\n  }\n  .lg\\:active\\:bg-gray-700:active {\n    --bg-opacity: 1;\n    background-color: #374151;\n    background-color: rgba(55, 65, 81, var(--bg-opacity));\n  }\n  .lg\\:active\\:bg-gray-800:active {\n    --bg-opacity: 1;\n    background-color: #252f3f;\n    background-color: rgba(37, 47, 63, var(--bg-opacity));\n  }\n  .lg\\:active\\:bg-gray-900:active {\n    --bg-opacity: 1;\n    background-color: #161e2e;\n    background-color: rgba(22, 30, 46, var(--bg-opacity));\n  }\n  .lg\\:active\\:bg-red-50:active {\n    --bg-opacity: 1;\n    background-color: #fdf2f2;\n    background-color: rgba(253, 242, 242, var(--bg-opacity));\n  }\n  .lg\\:active\\:bg-red-100:active {\n    --bg-opacity: 1;\n    background-color: #fde8e8;\n    background-color: rgba(253, 232, 232, var(--bg-opacity));\n  }\n  .lg\\:active\\:bg-red-200:active {\n    --bg-opacity: 1;\n    background-color: #fbd5d5;\n    background-color: rgba(251, 213, 213, var(--bg-opacity));\n  }\n  .lg\\:active\\:bg-red-300:active {\n    --bg-opacity: 1;\n    background-color: #f8b4b4;\n    background-color: rgba(248, 180, 180, var(--bg-opacity));\n  }\n  .lg\\:active\\:bg-red-400:active {\n    --bg-opacity: 1;\n    background-color: #f98080;\n    background-color: rgba(249, 128, 128, var(--bg-opacity));\n  }\n  .lg\\:active\\:bg-red-500:active {\n    --bg-opacity: 1;\n    background-color: #f05252;\n    background-color: rgba(240, 82, 82, var(--bg-opacity));\n  }\n  .lg\\:active\\:bg-red-600:active {\n    --bg-opacity: 1;\n    background-color: #e02424;\n    background-color: rgba(224, 36, 36, var(--bg-opacity));\n  }\n  .lg\\:active\\:bg-red-700:active {\n    --bg-opacity: 1;\n    background-color: #c81e1e;\n    background-color: rgba(200, 30, 30, var(--bg-opacity));\n  }\n  .lg\\:active\\:bg-red-800:active {\n    --bg-opacity: 1;\n    background-color: #9b1c1c;\n    background-color: rgba(155, 28, 28, var(--bg-opacity));\n  }\n  .lg\\:active\\:bg-red-900:active {\n    --bg-opacity: 1;\n    background-color: #771d1d;\n    background-color: rgba(119, 29, 29, var(--bg-opacity));\n  }\n  .lg\\:active\\:bg-orange-50:active {\n    --bg-opacity: 1;\n    background-color: #fff8f1;\n    background-color: rgba(255, 248, 241, var(--bg-opacity));\n  }\n  .lg\\:active\\:bg-orange-100:active {\n    --bg-opacity: 1;\n    background-color: #feecdc;\n    background-color: rgba(254, 236, 220, var(--bg-opacity));\n  }\n  .lg\\:active\\:bg-orange-200:active {\n    --bg-opacity: 1;\n    background-color: #fcd9bd;\n    background-color: rgba(252, 217, 189, var(--bg-opacity));\n  }\n  .lg\\:active\\:bg-orange-300:active {\n    --bg-opacity: 1;\n    background-color: #fdba8c;\n    background-color: rgba(253, 186, 140, var(--bg-opacity));\n  }\n  .lg\\:active\\:bg-orange-400:active {\n    --bg-opacity: 1;\n    background-color: #ff8a4c;\n    background-color: rgba(255, 138, 76, var(--bg-opacity));\n  }\n  .lg\\:active\\:bg-orange-500:active {\n    --bg-opacity: 1;\n    background-color: #ff5a1f;\n    background-color: rgba(255, 90, 31, var(--bg-opacity));\n  }\n  .lg\\:active\\:bg-orange-600:active {\n    --bg-opacity: 1;\n    background-color: #d03801;\n    background-color: rgba(208, 56, 1, var(--bg-opacity));\n  }\n  .lg\\:active\\:bg-orange-700:active {\n    --bg-opacity: 1;\n    background-color: #b43403;\n    background-color: rgba(180, 52, 3, var(--bg-opacity));\n  }\n  .lg\\:active\\:bg-orange-800:active {\n    --bg-opacity: 1;\n    background-color: #8a2c0d;\n    background-color: rgba(138, 44, 13, var(--bg-opacity));\n  }\n  .lg\\:active\\:bg-orange-900:active {\n    --bg-opacity: 1;\n    background-color: #73230d;\n    background-color: rgba(115, 35, 13, var(--bg-opacity));\n  }\n  .lg\\:active\\:bg-yellow-50:active {\n    --bg-opacity: 1;\n    background-color: #fdfdea;\n    background-color: rgba(253, 253, 234, var(--bg-opacity));\n  }\n  .lg\\:active\\:bg-yellow-100:active {\n    --bg-opacity: 1;\n    background-color: #fdf6b2;\n    background-color: rgba(253, 246, 178, var(--bg-opacity));\n  }\n  .lg\\:active\\:bg-yellow-200:active {\n    --bg-opacity: 1;\n    background-color: #fce96a;\n    background-color: rgba(252, 233, 106, var(--bg-opacity));\n  }\n  .lg\\:active\\:bg-yellow-300:active {\n    --bg-opacity: 1;\n    background-color: #faca15;\n    background-color: rgba(250, 202, 21, var(--bg-opacity));\n  }\n  .lg\\:active\\:bg-yellow-400:active {\n    --bg-opacity: 1;\n    background-color: #e3a008;\n    background-color: rgba(227, 160, 8, var(--bg-opacity));\n  }\n  .lg\\:active\\:bg-yellow-500:active {\n    --bg-opacity: 1;\n    background-color: #c27803;\n    background-color: rgba(194, 120, 3, var(--bg-opacity));\n  }\n  .lg\\:active\\:bg-yellow-600:active {\n    --bg-opacity: 1;\n    background-color: #9f580a;\n    background-color: rgba(159, 88, 10, var(--bg-opacity));\n  }\n  .lg\\:active\\:bg-yellow-700:active {\n    --bg-opacity: 1;\n    background-color: #8e4b10;\n    background-color: rgba(142, 75, 16, var(--bg-opacity));\n  }\n  .lg\\:active\\:bg-yellow-800:active {\n    --bg-opacity: 1;\n    background-color: #723b13;\n    background-color: rgba(114, 59, 19, var(--bg-opacity));\n  }\n  .lg\\:active\\:bg-yellow-900:active {\n    --bg-opacity: 1;\n    background-color: #633112;\n    background-color: rgba(99, 49, 18, var(--bg-opacity));\n  }\n  .lg\\:active\\:bg-green-50:active {\n    --bg-opacity: 1;\n    background-color: #f3faf7;\n    background-color: rgba(243, 250, 247, var(--bg-opacity));\n  }\n  .lg\\:active\\:bg-green-100:active {\n    --bg-opacity: 1;\n    background-color: #def7ec;\n    background-color: rgba(222, 247, 236, var(--bg-opacity));\n  }\n  .lg\\:active\\:bg-green-200:active {\n    --bg-opacity: 1;\n    background-color: #bcf0da;\n    background-color: rgba(188, 240, 218, var(--bg-opacity));\n  }\n  .lg\\:active\\:bg-green-300:active {\n    --bg-opacity: 1;\n    background-color: #84e1bc;\n    background-color: rgba(132, 225, 188, var(--bg-opacity));\n  }\n  .lg\\:active\\:bg-green-400:active {\n    --bg-opacity: 1;\n    background-color: #31c48d;\n    background-color: rgba(49, 196, 141, var(--bg-opacity));\n  }\n  .lg\\:active\\:bg-green-500:active {\n    --bg-opacity: 1;\n    background-color: #0e9f6e;\n    background-color: rgba(14, 159, 110, var(--bg-opacity));\n  }\n  .lg\\:active\\:bg-green-600:active {\n    --bg-opacity: 1;\n    background-color: #057a55;\n    background-color: rgba(5, 122, 85, var(--bg-opacity));\n  }\n  .lg\\:active\\:bg-green-700:active {\n    --bg-opacity: 1;\n    background-color: #046c4e;\n    background-color: rgba(4, 108, 78, var(--bg-opacity));\n  }\n  .lg\\:active\\:bg-green-800:active {\n    --bg-opacity: 1;\n    background-color: #03543f;\n    background-color: rgba(3, 84, 63, var(--bg-opacity));\n  }\n  .lg\\:active\\:bg-green-900:active {\n    --bg-opacity: 1;\n    background-color: #014737;\n    background-color: rgba(1, 71, 55, var(--bg-opacity));\n  }\n  .lg\\:active\\:bg-teal-50:active {\n    --bg-opacity: 1;\n    background-color: #edfafa;\n    background-color: rgba(237, 250, 250, var(--bg-opacity));\n  }\n  .lg\\:active\\:bg-teal-100:active {\n    --bg-opacity: 1;\n    background-color: #d5f5f6;\n    background-color: rgba(213, 245, 246, var(--bg-opacity));\n  }\n  .lg\\:active\\:bg-teal-200:active {\n    --bg-opacity: 1;\n    background-color: #afecef;\n    background-color: rgba(175, 236, 239, var(--bg-opacity));\n  }\n  .lg\\:active\\:bg-teal-300:active {\n    --bg-opacity: 1;\n    background-color: #7edce2;\n    background-color: rgba(126, 220, 226, var(--bg-opacity));\n  }\n  .lg\\:active\\:bg-teal-400:active {\n    --bg-opacity: 1;\n    background-color: #16bdca;\n    background-color: rgba(22, 189, 202, var(--bg-opacity));\n  }\n  .lg\\:active\\:bg-teal-500:active {\n    --bg-opacity: 1;\n    background-color: #0694a2;\n    background-color: rgba(6, 148, 162, var(--bg-opacity));\n  }\n  .lg\\:active\\:bg-teal-600:active {\n    --bg-opacity: 1;\n    background-color: #047481;\n    background-color: rgba(4, 116, 129, var(--bg-opacity));\n  }\n  .lg\\:active\\:bg-teal-700:active {\n    --bg-opacity: 1;\n    background-color: #036672;\n    background-color: rgba(3, 102, 114, var(--bg-opacity));\n  }\n  .lg\\:active\\:bg-teal-800:active {\n    --bg-opacity: 1;\n    background-color: #05505c;\n    background-color: rgba(5, 80, 92, var(--bg-opacity));\n  }\n  .lg\\:active\\:bg-teal-900:active {\n    --bg-opacity: 1;\n    background-color: #014451;\n    background-color: rgba(1, 68, 81, var(--bg-opacity));\n  }\n  .lg\\:active\\:bg-blue-50:active {\n    --bg-opacity: 1;\n    background-color: #ebf5ff;\n    background-color: rgba(235, 245, 255, var(--bg-opacity));\n  }\n  .lg\\:active\\:bg-blue-100:active {\n    --bg-opacity: 1;\n    background-color: #e1effe;\n    background-color: rgba(225, 239, 254, var(--bg-opacity));\n  }\n  .lg\\:active\\:bg-blue-200:active {\n    --bg-opacity: 1;\n    background-color: #c3ddfd;\n    background-color: rgba(195, 221, 253, var(--bg-opacity));\n  }\n  .lg\\:active\\:bg-blue-300:active {\n    --bg-opacity: 1;\n    background-color: #a4cafe;\n    background-color: rgba(164, 202, 254, var(--bg-opacity));\n  }\n  .lg\\:active\\:bg-blue-400:active {\n    --bg-opacity: 1;\n    background-color: #76a9fa;\n    background-color: rgba(118, 169, 250, var(--bg-opacity));\n  }\n  .lg\\:active\\:bg-blue-500:active {\n    --bg-opacity: 1;\n    background-color: #3f83f8;\n    background-color: rgba(63, 131, 248, var(--bg-opacity));\n  }\n  .lg\\:active\\:bg-blue-600:active {\n    --bg-opacity: 1;\n    background-color: #1c64f2;\n    background-color: rgba(28, 100, 242, var(--bg-opacity));\n  }\n  .lg\\:active\\:bg-blue-700:active {\n    --bg-opacity: 1;\n    background-color: #1a56db;\n    background-color: rgba(26, 86, 219, var(--bg-opacity));\n  }\n  .lg\\:active\\:bg-blue-800:active {\n    --bg-opacity: 1;\n    background-color: #1e429f;\n    background-color: rgba(30, 66, 159, var(--bg-opacity));\n  }\n  .lg\\:active\\:bg-blue-900:active {\n    --bg-opacity: 1;\n    background-color: #233876;\n    background-color: rgba(35, 56, 118, var(--bg-opacity));\n  }\n  .lg\\:active\\:bg-indigo-50:active {\n    --bg-opacity: 1;\n    background-color: #f0f5ff;\n    background-color: rgba(240, 245, 255, var(--bg-opacity));\n  }\n  .lg\\:active\\:bg-indigo-100:active {\n    --bg-opacity: 1;\n    background-color: #e5edff;\n    background-color: rgba(229, 237, 255, var(--bg-opacity));\n  }\n  .lg\\:active\\:bg-indigo-200:active {\n    --bg-opacity: 1;\n    background-color: #cddbfe;\n    background-color: rgba(205, 219, 254, var(--bg-opacity));\n  }\n  .lg\\:active\\:bg-indigo-300:active {\n    --bg-opacity: 1;\n    background-color: #b4c6fc;\n    background-color: rgba(180, 198, 252, var(--bg-opacity));\n  }\n  .lg\\:active\\:bg-indigo-400:active {\n    --bg-opacity: 1;\n    background-color: #8da2fb;\n    background-color: rgba(141, 162, 251, var(--bg-opacity));\n  }\n  .lg\\:active\\:bg-indigo-500:active {\n    --bg-opacity: 1;\n    background-color: #6875f5;\n    background-color: rgba(104, 117, 245, var(--bg-opacity));\n  }\n  .lg\\:active\\:bg-indigo-600:active {\n    --bg-opacity: 1;\n    background-color: #5850ec;\n    background-color: rgba(88, 80, 236, var(--bg-opacity));\n  }\n  .lg\\:active\\:bg-indigo-700:active {\n    --bg-opacity: 1;\n    background-color: #5145cd;\n    background-color: rgba(81, 69, 205, var(--bg-opacity));\n  }\n  .lg\\:active\\:bg-indigo-800:active {\n    --bg-opacity: 1;\n    background-color: #42389d;\n    background-color: rgba(66, 56, 157, var(--bg-opacity));\n  }\n  .lg\\:active\\:bg-indigo-900:active {\n    --bg-opacity: 1;\n    background-color: #362f78;\n    background-color: rgba(54, 47, 120, var(--bg-opacity));\n  }\n  .lg\\:active\\:bg-purple-50:active {\n    --bg-opacity: 1;\n    background-color: #f6f5ff;\n    background-color: rgba(246, 245, 255, var(--bg-opacity));\n  }\n  .lg\\:active\\:bg-purple-100:active {\n    --bg-opacity: 1;\n    background-color: #edebfe;\n    background-color: rgba(237, 235, 254, var(--bg-opacity));\n  }\n  .lg\\:active\\:bg-purple-200:active {\n    --bg-opacity: 1;\n    background-color: #dcd7fe;\n    background-color: rgba(220, 215, 254, var(--bg-opacity));\n  }\n  .lg\\:active\\:bg-purple-300:active {\n    --bg-opacity: 1;\n    background-color: #cabffd;\n    background-color: rgba(202, 191, 253, var(--bg-opacity));\n  }\n  .lg\\:active\\:bg-purple-400:active {\n    --bg-opacity: 1;\n    background-color: #ac94fa;\n    background-color: rgba(172, 148, 250, var(--bg-opacity));\n  }\n  .lg\\:active\\:bg-purple-500:active {\n    --bg-opacity: 1;\n    background-color: #9061f9;\n    background-color: rgba(144, 97, 249, var(--bg-opacity));\n  }\n  .lg\\:active\\:bg-purple-600:active {\n    --bg-opacity: 1;\n    background-color: #7e3af2;\n    background-color: rgba(126, 58, 242, var(--bg-opacity));\n  }\n  .lg\\:active\\:bg-purple-700:active {\n    --bg-opacity: 1;\n    background-color: #6c2bd9;\n    background-color: rgba(108, 43, 217, var(--bg-opacity));\n  }\n  .lg\\:active\\:bg-purple-800:active {\n    --bg-opacity: 1;\n    background-color: #5521b5;\n    background-color: rgba(85, 33, 181, var(--bg-opacity));\n  }\n  .lg\\:active\\:bg-purple-900:active {\n    --bg-opacity: 1;\n    background-color: #4a1d96;\n    background-color: rgba(74, 29, 150, var(--bg-opacity));\n  }\n  .lg\\:active\\:bg-pink-50:active {\n    --bg-opacity: 1;\n    background-color: #fdf2f8;\n    background-color: rgba(253, 242, 248, var(--bg-opacity));\n  }\n  .lg\\:active\\:bg-pink-100:active {\n    --bg-opacity: 1;\n    background-color: #fce8f3;\n    background-color: rgba(252, 232, 243, var(--bg-opacity));\n  }\n  .lg\\:active\\:bg-pink-200:active {\n    --bg-opacity: 1;\n    background-color: #fad1e8;\n    background-color: rgba(250, 209, 232, var(--bg-opacity));\n  }\n  .lg\\:active\\:bg-pink-300:active {\n    --bg-opacity: 1;\n    background-color: #f8b4d9;\n    background-color: rgba(248, 180, 217, var(--bg-opacity));\n  }\n  .lg\\:active\\:bg-pink-400:active {\n    --bg-opacity: 1;\n    background-color: #f17eb8;\n    background-color: rgba(241, 126, 184, var(--bg-opacity));\n  }\n  .lg\\:active\\:bg-pink-500:active {\n    --bg-opacity: 1;\n    background-color: #e74694;\n    background-color: rgba(231, 70, 148, var(--bg-opacity));\n  }\n  .lg\\:active\\:bg-pink-600:active {\n    --bg-opacity: 1;\n    background-color: #d61f69;\n    background-color: rgba(214, 31, 105, var(--bg-opacity));\n  }\n  .lg\\:active\\:bg-pink-700:active {\n    --bg-opacity: 1;\n    background-color: #bf125d;\n    background-color: rgba(191, 18, 93, var(--bg-opacity));\n  }\n  .lg\\:active\\:bg-pink-800:active {\n    --bg-opacity: 1;\n    background-color: #99154b;\n    background-color: rgba(153, 21, 75, var(--bg-opacity));\n  }\n  .lg\\:active\\:bg-pink-900:active {\n    --bg-opacity: 1;\n    background-color: #751a3d;\n    background-color: rgba(117, 26, 61, var(--bg-opacity));\n  }\n  .lg\\:active\\:bg-cool-gray-50:active {\n    --bg-opacity: 1;\n    background-color: #f8fafc;\n    background-color: rgba(248, 250, 252, var(--bg-opacity));\n  }\n  .lg\\:active\\:bg-cool-gray-100:active {\n    --bg-opacity: 1;\n    background-color: #f1f5f9;\n    background-color: rgba(241, 245, 249, var(--bg-opacity));\n  }\n  .lg\\:active\\:bg-cool-gray-200:active {\n    --bg-opacity: 1;\n    background-color: #e2e8f0;\n    background-color: rgba(226, 232, 240, var(--bg-opacity));\n  }\n  .lg\\:active\\:bg-cool-gray-300:active {\n    --bg-opacity: 1;\n    background-color: #cfd8e3;\n    background-color: rgba(207, 216, 227, var(--bg-opacity));\n  }\n  .lg\\:active\\:bg-cool-gray-400:active {\n    --bg-opacity: 1;\n    background-color: #97a6ba;\n    background-color: rgba(151, 166, 186, var(--bg-opacity));\n  }\n  .lg\\:active\\:bg-cool-gray-500:active {\n    --bg-opacity: 1;\n    background-color: #64748b;\n    background-color: rgba(100, 116, 139, var(--bg-opacity));\n  }\n  .lg\\:active\\:bg-cool-gray-600:active {\n    --bg-opacity: 1;\n    background-color: #475569;\n    background-color: rgba(71, 85, 105, var(--bg-opacity));\n  }\n  .lg\\:active\\:bg-cool-gray-700:active {\n    --bg-opacity: 1;\n    background-color: #364152;\n    background-color: rgba(54, 65, 82, var(--bg-opacity));\n  }\n  .lg\\:active\\:bg-cool-gray-800:active {\n    --bg-opacity: 1;\n    background-color: #27303f;\n    background-color: rgba(39, 48, 63, var(--bg-opacity));\n  }\n  .lg\\:active\\:bg-cool-gray-900:active {\n    --bg-opacity: 1;\n    background-color: #1a202e;\n    background-color: rgba(26, 32, 46, var(--bg-opacity));\n  }\n  .lg\\:bg-none {\n    background-image: none;\n  }\n  .lg\\:bg-gradient-to-t {\n    background-image: linear-gradient(to top, var(--gradient-color-stops));\n  }\n  .lg\\:bg-gradient-to-tr {\n    background-image: linear-gradient(to top right, var(--gradient-color-stops));\n  }\n  .lg\\:bg-gradient-to-r {\n    background-image: linear-gradient(to right, var(--gradient-color-stops));\n  }\n  .lg\\:bg-gradient-to-br {\n    background-image: linear-gradient(to bottom right, var(--gradient-color-stops));\n  }\n  .lg\\:bg-gradient-to-b {\n    background-image: linear-gradient(to bottom, var(--gradient-color-stops));\n  }\n  .lg\\:bg-gradient-to-bl {\n    background-image: linear-gradient(to bottom left, var(--gradient-color-stops));\n  }\n  .lg\\:bg-gradient-to-l {\n    background-image: linear-gradient(to left, var(--gradient-color-stops));\n  }\n  .lg\\:bg-gradient-to-tl {\n    background-image: linear-gradient(to top left, var(--gradient-color-stops));\n  }\n  .lg\\:from-current {\n    --gradient-from-color: currentColor;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));\n  }\n  .lg\\:from-transparent {\n    --gradient-from-color: transparent;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0));\n  }\n  .lg\\:from-white {\n    --gradient-from-color: #ffffff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));\n  }\n  .lg\\:from-black {\n    --gradient-from-color: #000000;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0));\n  }\n  .lg\\:from-gray-50 {\n    --gradient-from-color: #f9fafb;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(249, 250, 251, 0));\n  }\n  .lg\\:from-gray-100 {\n    --gradient-from-color: #f4f5f7;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(244, 245, 247, 0));\n  }\n  .lg\\:from-gray-200 {\n    --gradient-from-color: #e5e7eb;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(229, 231, 235, 0));\n  }\n  .lg\\:from-gray-300 {\n    --gradient-from-color: #d2d6dc;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(210, 214, 220, 0));\n  }\n  .lg\\:from-gray-400 {\n    --gradient-from-color: #9fa6b2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(159, 166, 178, 0));\n  }\n  .lg\\:from-gray-500 {\n    --gradient-from-color: #6b7280;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(107, 114, 128, 0));\n  }\n  .lg\\:from-gray-600 {\n    --gradient-from-color: #4b5563;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(75, 85, 99, 0));\n  }\n  .lg\\:from-gray-700 {\n    --gradient-from-color: #374151;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(55, 65, 81, 0));\n  }\n  .lg\\:from-gray-800 {\n    --gradient-from-color: #252f3f;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(37, 47, 63, 0));\n  }\n  .lg\\:from-gray-900 {\n    --gradient-from-color: #161e2e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(22, 30, 46, 0));\n  }\n  .lg\\:from-red-50 {\n    --gradient-from-color: #fdf2f2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 242, 242, 0));\n  }\n  .lg\\:from-red-100 {\n    --gradient-from-color: #fde8e8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 232, 232, 0));\n  }\n  .lg\\:from-red-200 {\n    --gradient-from-color: #fbd5d5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(251, 213, 213, 0));\n  }\n  .lg\\:from-red-300 {\n    --gradient-from-color: #f8b4b4;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(248, 180, 180, 0));\n  }\n  .lg\\:from-red-400 {\n    --gradient-from-color: #f98080;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(249, 128, 128, 0));\n  }\n  .lg\\:from-red-500 {\n    --gradient-from-color: #f05252;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(240, 82, 82, 0));\n  }\n  .lg\\:from-red-600 {\n    --gradient-from-color: #e02424;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(224, 36, 36, 0));\n  }\n  .lg\\:from-red-700 {\n    --gradient-from-color: #c81e1e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(200, 30, 30, 0));\n  }\n  .lg\\:from-red-800 {\n    --gradient-from-color: #9b1c1c;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(155, 28, 28, 0));\n  }\n  .lg\\:from-red-900 {\n    --gradient-from-color: #771d1d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(119, 29, 29, 0));\n  }\n  .lg\\:from-orange-50 {\n    --gradient-from-color: #fff8f1;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 248, 241, 0));\n  }\n  .lg\\:from-orange-100 {\n    --gradient-from-color: #feecdc;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 236, 220, 0));\n  }\n  .lg\\:from-orange-200 {\n    --gradient-from-color: #fcd9bd;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(252, 217, 189, 0));\n  }\n  .lg\\:from-orange-300 {\n    --gradient-from-color: #fdba8c;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 186, 140, 0));\n  }\n  .lg\\:from-orange-400 {\n    --gradient-from-color: #ff8a4c;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 138, 76, 0));\n  }\n  .lg\\:from-orange-500 {\n    --gradient-from-color: #ff5a1f;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 90, 31, 0));\n  }\n  .lg\\:from-orange-600 {\n    --gradient-from-color: #d03801;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(208, 56, 1, 0));\n  }\n  .lg\\:from-orange-700 {\n    --gradient-from-color: #b43403;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(180, 52, 3, 0));\n  }\n  .lg\\:from-orange-800 {\n    --gradient-from-color: #8a2c0d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(138, 44, 13, 0));\n  }\n  .lg\\:from-orange-900 {\n    --gradient-from-color: #73230d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(115, 35, 13, 0));\n  }\n  .lg\\:from-yellow-50 {\n    --gradient-from-color: #fdfdea;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 253, 234, 0));\n  }\n  .lg\\:from-yellow-100 {\n    --gradient-from-color: #fdf6b2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 246, 178, 0));\n  }\n  .lg\\:from-yellow-200 {\n    --gradient-from-color: #fce96a;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(252, 233, 106, 0));\n  }\n  .lg\\:from-yellow-300 {\n    --gradient-from-color: #faca15;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(250, 202, 21, 0));\n  }\n  .lg\\:from-yellow-400 {\n    --gradient-from-color: #e3a008;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(227, 160, 8, 0));\n  }\n  .lg\\:from-yellow-500 {\n    --gradient-from-color: #c27803;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(194, 120, 3, 0));\n  }\n  .lg\\:from-yellow-600 {\n    --gradient-from-color: #9f580a;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(159, 88, 10, 0));\n  }\n  .lg\\:from-yellow-700 {\n    --gradient-from-color: #8e4b10;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(142, 75, 16, 0));\n  }\n  .lg\\:from-yellow-800 {\n    --gradient-from-color: #723b13;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(114, 59, 19, 0));\n  }\n  .lg\\:from-yellow-900 {\n    --gradient-from-color: #633112;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(99, 49, 18, 0));\n  }\n  .lg\\:from-green-50 {\n    --gradient-from-color: #f3faf7;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(243, 250, 247, 0));\n  }\n  .lg\\:from-green-100 {\n    --gradient-from-color: #def7ec;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(222, 247, 236, 0));\n  }\n  .lg\\:from-green-200 {\n    --gradient-from-color: #bcf0da;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(188, 240, 218, 0));\n  }\n  .lg\\:from-green-300 {\n    --gradient-from-color: #84e1bc;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(132, 225, 188, 0));\n  }\n  .lg\\:from-green-400 {\n    --gradient-from-color: #31c48d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(49, 196, 141, 0));\n  }\n  .lg\\:from-green-500 {\n    --gradient-from-color: #0e9f6e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(14, 159, 110, 0));\n  }\n  .lg\\:from-green-600 {\n    --gradient-from-color: #057a55;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(5, 122, 85, 0));\n  }\n  .lg\\:from-green-700 {\n    --gradient-from-color: #046c4e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(4, 108, 78, 0));\n  }\n  .lg\\:from-green-800 {\n    --gradient-from-color: #03543f;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(3, 84, 63, 0));\n  }\n  .lg\\:from-green-900 {\n    --gradient-from-color: #014737;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(1, 71, 55, 0));\n  }\n  .lg\\:from-teal-50 {\n    --gradient-from-color: #edfafa;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(237, 250, 250, 0));\n  }\n  .lg\\:from-teal-100 {\n    --gradient-from-color: #d5f5f6;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(213, 245, 246, 0));\n  }\n  .lg\\:from-teal-200 {\n    --gradient-from-color: #afecef;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(175, 236, 239, 0));\n  }\n  .lg\\:from-teal-300 {\n    --gradient-from-color: #7edce2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(126, 220, 226, 0));\n  }\n  .lg\\:from-teal-400 {\n    --gradient-from-color: #16bdca;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(22, 189, 202, 0));\n  }\n  .lg\\:from-teal-500 {\n    --gradient-from-color: #0694a2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(6, 148, 162, 0));\n  }\n  .lg\\:from-teal-600 {\n    --gradient-from-color: #047481;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(4, 116, 129, 0));\n  }\n  .lg\\:from-teal-700 {\n    --gradient-from-color: #036672;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(3, 102, 114, 0));\n  }\n  .lg\\:from-teal-800 {\n    --gradient-from-color: #05505c;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(5, 80, 92, 0));\n  }\n  .lg\\:from-teal-900 {\n    --gradient-from-color: #014451;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(1, 68, 81, 0));\n  }\n  .lg\\:from-blue-50 {\n    --gradient-from-color: #ebf5ff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(235, 245, 255, 0));\n  }\n  .lg\\:from-blue-100 {\n    --gradient-from-color: #e1effe;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(225, 239, 254, 0));\n  }\n  .lg\\:from-blue-200 {\n    --gradient-from-color: #c3ddfd;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(195, 221, 253, 0));\n  }\n  .lg\\:from-blue-300 {\n    --gradient-from-color: #a4cafe;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(164, 202, 254, 0));\n  }\n  .lg\\:from-blue-400 {\n    --gradient-from-color: #76a9fa;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(118, 169, 250, 0));\n  }\n  .lg\\:from-blue-500 {\n    --gradient-from-color: #3f83f8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(63, 131, 248, 0));\n  }\n  .lg\\:from-blue-600 {\n    --gradient-from-color: #1c64f2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(28, 100, 242, 0));\n  }\n  .lg\\:from-blue-700 {\n    --gradient-from-color: #1a56db;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(26, 86, 219, 0));\n  }\n  .lg\\:from-blue-800 {\n    --gradient-from-color: #1e429f;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(30, 66, 159, 0));\n  }\n  .lg\\:from-blue-900 {\n    --gradient-from-color: #233876;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(35, 56, 118, 0));\n  }\n  .lg\\:from-indigo-50 {\n    --gradient-from-color: #f0f5ff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(240, 245, 255, 0));\n  }\n  .lg\\:from-indigo-100 {\n    --gradient-from-color: #e5edff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(229, 237, 255, 0));\n  }\n  .lg\\:from-indigo-200 {\n    --gradient-from-color: #cddbfe;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(205, 219, 254, 0));\n  }\n  .lg\\:from-indigo-300 {\n    --gradient-from-color: #b4c6fc;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(180, 198, 252, 0));\n  }\n  .lg\\:from-indigo-400 {\n    --gradient-from-color: #8da2fb;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(141, 162, 251, 0));\n  }\n  .lg\\:from-indigo-500 {\n    --gradient-from-color: #6875f5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(104, 117, 245, 0));\n  }\n  .lg\\:from-indigo-600 {\n    --gradient-from-color: #5850ec;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(88, 80, 236, 0));\n  }\n  .lg\\:from-indigo-700 {\n    --gradient-from-color: #5145cd;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(81, 69, 205, 0));\n  }\n  .lg\\:from-indigo-800 {\n    --gradient-from-color: #42389d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(66, 56, 157, 0));\n  }\n  .lg\\:from-indigo-900 {\n    --gradient-from-color: #362f78;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(54, 47, 120, 0));\n  }\n  .lg\\:from-purple-50 {\n    --gradient-from-color: #f6f5ff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(246, 245, 255, 0));\n  }\n  .lg\\:from-purple-100 {\n    --gradient-from-color: #edebfe;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(237, 235, 254, 0));\n  }\n  .lg\\:from-purple-200 {\n    --gradient-from-color: #dcd7fe;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(220, 215, 254, 0));\n  }\n  .lg\\:from-purple-300 {\n    --gradient-from-color: #cabffd;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(202, 191, 253, 0));\n  }\n  .lg\\:from-purple-400 {\n    --gradient-from-color: #ac94fa;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(172, 148, 250, 0));\n  }\n  .lg\\:from-purple-500 {\n    --gradient-from-color: #9061f9;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(144, 97, 249, 0));\n  }\n  .lg\\:from-purple-600 {\n    --gradient-from-color: #7e3af2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(126, 58, 242, 0));\n  }\n  .lg\\:from-purple-700 {\n    --gradient-from-color: #6c2bd9;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(108, 43, 217, 0));\n  }\n  .lg\\:from-purple-800 {\n    --gradient-from-color: #5521b5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(85, 33, 181, 0));\n  }\n  .lg\\:from-purple-900 {\n    --gradient-from-color: #4a1d96;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(74, 29, 150, 0));\n  }\n  .lg\\:from-pink-50 {\n    --gradient-from-color: #fdf2f8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 242, 248, 0));\n  }\n  .lg\\:from-pink-100 {\n    --gradient-from-color: #fce8f3;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(252, 232, 243, 0));\n  }\n  .lg\\:from-pink-200 {\n    --gradient-from-color: #fad1e8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(250, 209, 232, 0));\n  }\n  .lg\\:from-pink-300 {\n    --gradient-from-color: #f8b4d9;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(248, 180, 217, 0));\n  }\n  .lg\\:from-pink-400 {\n    --gradient-from-color: #f17eb8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(241, 126, 184, 0));\n  }\n  .lg\\:from-pink-500 {\n    --gradient-from-color: #e74694;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(231, 70, 148, 0));\n  }\n  .lg\\:from-pink-600 {\n    --gradient-from-color: #d61f69;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(214, 31, 105, 0));\n  }\n  .lg\\:from-pink-700 {\n    --gradient-from-color: #bf125d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(191, 18, 93, 0));\n  }\n  .lg\\:from-pink-800 {\n    --gradient-from-color: #99154b;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(153, 21, 75, 0));\n  }\n  .lg\\:from-pink-900 {\n    --gradient-from-color: #751a3d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(117, 26, 61, 0));\n  }\n  .lg\\:from-cool-gray-50 {\n    --gradient-from-color: #f8fafc;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(248, 250, 252, 0));\n  }\n  .lg\\:from-cool-gray-100 {\n    --gradient-from-color: #f1f5f9;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(241, 245, 249, 0));\n  }\n  .lg\\:from-cool-gray-200 {\n    --gradient-from-color: #e2e8f0;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(226, 232, 240, 0));\n  }\n  .lg\\:from-cool-gray-300 {\n    --gradient-from-color: #cfd8e3;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(207, 216, 227, 0));\n  }\n  .lg\\:from-cool-gray-400 {\n    --gradient-from-color: #97a6ba;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(151, 166, 186, 0));\n  }\n  .lg\\:from-cool-gray-500 {\n    --gradient-from-color: #64748b;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(100, 116, 139, 0));\n  }\n  .lg\\:from-cool-gray-600 {\n    --gradient-from-color: #475569;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(71, 85, 105, 0));\n  }\n  .lg\\:from-cool-gray-700 {\n    --gradient-from-color: #364152;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(54, 65, 82, 0));\n  }\n  .lg\\:from-cool-gray-800 {\n    --gradient-from-color: #27303f;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(39, 48, 63, 0));\n  }\n  .lg\\:from-cool-gray-900 {\n    --gradient-from-color: #1a202e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(26, 32, 46, 0));\n  }\n  .lg\\:via-current {\n    --gradient-via-color: currentColor;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));\n  }\n  .lg\\:via-transparent {\n    --gradient-via-color: transparent;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0));\n  }\n  .lg\\:via-white {\n    --gradient-via-color: #ffffff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));\n  }\n  .lg\\:via-black {\n    --gradient-via-color: #000000;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0));\n  }\n  .lg\\:via-gray-50 {\n    --gradient-via-color: #f9fafb;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(249, 250, 251, 0));\n  }\n  .lg\\:via-gray-100 {\n    --gradient-via-color: #f4f5f7;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(244, 245, 247, 0));\n  }\n  .lg\\:via-gray-200 {\n    --gradient-via-color: #e5e7eb;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(229, 231, 235, 0));\n  }\n  .lg\\:via-gray-300 {\n    --gradient-via-color: #d2d6dc;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(210, 214, 220, 0));\n  }\n  .lg\\:via-gray-400 {\n    --gradient-via-color: #9fa6b2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(159, 166, 178, 0));\n  }\n  .lg\\:via-gray-500 {\n    --gradient-via-color: #6b7280;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(107, 114, 128, 0));\n  }\n  .lg\\:via-gray-600 {\n    --gradient-via-color: #4b5563;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(75, 85, 99, 0));\n  }\n  .lg\\:via-gray-700 {\n    --gradient-via-color: #374151;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(55, 65, 81, 0));\n  }\n  .lg\\:via-gray-800 {\n    --gradient-via-color: #252f3f;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(37, 47, 63, 0));\n  }\n  .lg\\:via-gray-900 {\n    --gradient-via-color: #161e2e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(22, 30, 46, 0));\n  }\n  .lg\\:via-red-50 {\n    --gradient-via-color: #fdf2f2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 242, 242, 0));\n  }\n  .lg\\:via-red-100 {\n    --gradient-via-color: #fde8e8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 232, 232, 0));\n  }\n  .lg\\:via-red-200 {\n    --gradient-via-color: #fbd5d5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(251, 213, 213, 0));\n  }\n  .lg\\:via-red-300 {\n    --gradient-via-color: #f8b4b4;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(248, 180, 180, 0));\n  }\n  .lg\\:via-red-400 {\n    --gradient-via-color: #f98080;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(249, 128, 128, 0));\n  }\n  .lg\\:via-red-500 {\n    --gradient-via-color: #f05252;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(240, 82, 82, 0));\n  }\n  .lg\\:via-red-600 {\n    --gradient-via-color: #e02424;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(224, 36, 36, 0));\n  }\n  .lg\\:via-red-700 {\n    --gradient-via-color: #c81e1e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(200, 30, 30, 0));\n  }\n  .lg\\:via-red-800 {\n    --gradient-via-color: #9b1c1c;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(155, 28, 28, 0));\n  }\n  .lg\\:via-red-900 {\n    --gradient-via-color: #771d1d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(119, 29, 29, 0));\n  }\n  .lg\\:via-orange-50 {\n    --gradient-via-color: #fff8f1;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 248, 241, 0));\n  }\n  .lg\\:via-orange-100 {\n    --gradient-via-color: #feecdc;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 236, 220, 0));\n  }\n  .lg\\:via-orange-200 {\n    --gradient-via-color: #fcd9bd;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(252, 217, 189, 0));\n  }\n  .lg\\:via-orange-300 {\n    --gradient-via-color: #fdba8c;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 186, 140, 0));\n  }\n  .lg\\:via-orange-400 {\n    --gradient-via-color: #ff8a4c;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 138, 76, 0));\n  }\n  .lg\\:via-orange-500 {\n    --gradient-via-color: #ff5a1f;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 90, 31, 0));\n  }\n  .lg\\:via-orange-600 {\n    --gradient-via-color: #d03801;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(208, 56, 1, 0));\n  }\n  .lg\\:via-orange-700 {\n    --gradient-via-color: #b43403;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(180, 52, 3, 0));\n  }\n  .lg\\:via-orange-800 {\n    --gradient-via-color: #8a2c0d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(138, 44, 13, 0));\n  }\n  .lg\\:via-orange-900 {\n    --gradient-via-color: #73230d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(115, 35, 13, 0));\n  }\n  .lg\\:via-yellow-50 {\n    --gradient-via-color: #fdfdea;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 253, 234, 0));\n  }\n  .lg\\:via-yellow-100 {\n    --gradient-via-color: #fdf6b2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 246, 178, 0));\n  }\n  .lg\\:via-yellow-200 {\n    --gradient-via-color: #fce96a;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(252, 233, 106, 0));\n  }\n  .lg\\:via-yellow-300 {\n    --gradient-via-color: #faca15;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(250, 202, 21, 0));\n  }\n  .lg\\:via-yellow-400 {\n    --gradient-via-color: #e3a008;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(227, 160, 8, 0));\n  }\n  .lg\\:via-yellow-500 {\n    --gradient-via-color: #c27803;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(194, 120, 3, 0));\n  }\n  .lg\\:via-yellow-600 {\n    --gradient-via-color: #9f580a;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(159, 88, 10, 0));\n  }\n  .lg\\:via-yellow-700 {\n    --gradient-via-color: #8e4b10;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(142, 75, 16, 0));\n  }\n  .lg\\:via-yellow-800 {\n    --gradient-via-color: #723b13;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(114, 59, 19, 0));\n  }\n  .lg\\:via-yellow-900 {\n    --gradient-via-color: #633112;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(99, 49, 18, 0));\n  }\n  .lg\\:via-green-50 {\n    --gradient-via-color: #f3faf7;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(243, 250, 247, 0));\n  }\n  .lg\\:via-green-100 {\n    --gradient-via-color: #def7ec;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(222, 247, 236, 0));\n  }\n  .lg\\:via-green-200 {\n    --gradient-via-color: #bcf0da;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(188, 240, 218, 0));\n  }\n  .lg\\:via-green-300 {\n    --gradient-via-color: #84e1bc;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(132, 225, 188, 0));\n  }\n  .lg\\:via-green-400 {\n    --gradient-via-color: #31c48d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(49, 196, 141, 0));\n  }\n  .lg\\:via-green-500 {\n    --gradient-via-color: #0e9f6e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(14, 159, 110, 0));\n  }\n  .lg\\:via-green-600 {\n    --gradient-via-color: #057a55;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(5, 122, 85, 0));\n  }\n  .lg\\:via-green-700 {\n    --gradient-via-color: #046c4e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(4, 108, 78, 0));\n  }\n  .lg\\:via-green-800 {\n    --gradient-via-color: #03543f;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(3, 84, 63, 0));\n  }\n  .lg\\:via-green-900 {\n    --gradient-via-color: #014737;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(1, 71, 55, 0));\n  }\n  .lg\\:via-teal-50 {\n    --gradient-via-color: #edfafa;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(237, 250, 250, 0));\n  }\n  .lg\\:via-teal-100 {\n    --gradient-via-color: #d5f5f6;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(213, 245, 246, 0));\n  }\n  .lg\\:via-teal-200 {\n    --gradient-via-color: #afecef;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(175, 236, 239, 0));\n  }\n  .lg\\:via-teal-300 {\n    --gradient-via-color: #7edce2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(126, 220, 226, 0));\n  }\n  .lg\\:via-teal-400 {\n    --gradient-via-color: #16bdca;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(22, 189, 202, 0));\n  }\n  .lg\\:via-teal-500 {\n    --gradient-via-color: #0694a2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(6, 148, 162, 0));\n  }\n  .lg\\:via-teal-600 {\n    --gradient-via-color: #047481;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(4, 116, 129, 0));\n  }\n  .lg\\:via-teal-700 {\n    --gradient-via-color: #036672;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(3, 102, 114, 0));\n  }\n  .lg\\:via-teal-800 {\n    --gradient-via-color: #05505c;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(5, 80, 92, 0));\n  }\n  .lg\\:via-teal-900 {\n    --gradient-via-color: #014451;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(1, 68, 81, 0));\n  }\n  .lg\\:via-blue-50 {\n    --gradient-via-color: #ebf5ff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(235, 245, 255, 0));\n  }\n  .lg\\:via-blue-100 {\n    --gradient-via-color: #e1effe;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(225, 239, 254, 0));\n  }\n  .lg\\:via-blue-200 {\n    --gradient-via-color: #c3ddfd;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(195, 221, 253, 0));\n  }\n  .lg\\:via-blue-300 {\n    --gradient-via-color: #a4cafe;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(164, 202, 254, 0));\n  }\n  .lg\\:via-blue-400 {\n    --gradient-via-color: #76a9fa;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(118, 169, 250, 0));\n  }\n  .lg\\:via-blue-500 {\n    --gradient-via-color: #3f83f8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(63, 131, 248, 0));\n  }\n  .lg\\:via-blue-600 {\n    --gradient-via-color: #1c64f2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(28, 100, 242, 0));\n  }\n  .lg\\:via-blue-700 {\n    --gradient-via-color: #1a56db;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(26, 86, 219, 0));\n  }\n  .lg\\:via-blue-800 {\n    --gradient-via-color: #1e429f;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(30, 66, 159, 0));\n  }\n  .lg\\:via-blue-900 {\n    --gradient-via-color: #233876;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(35, 56, 118, 0));\n  }\n  .lg\\:via-indigo-50 {\n    --gradient-via-color: #f0f5ff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(240, 245, 255, 0));\n  }\n  .lg\\:via-indigo-100 {\n    --gradient-via-color: #e5edff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(229, 237, 255, 0));\n  }\n  .lg\\:via-indigo-200 {\n    --gradient-via-color: #cddbfe;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(205, 219, 254, 0));\n  }\n  .lg\\:via-indigo-300 {\n    --gradient-via-color: #b4c6fc;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(180, 198, 252, 0));\n  }\n  .lg\\:via-indigo-400 {\n    --gradient-via-color: #8da2fb;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(141, 162, 251, 0));\n  }\n  .lg\\:via-indigo-500 {\n    --gradient-via-color: #6875f5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(104, 117, 245, 0));\n  }\n  .lg\\:via-indigo-600 {\n    --gradient-via-color: #5850ec;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(88, 80, 236, 0));\n  }\n  .lg\\:via-indigo-700 {\n    --gradient-via-color: #5145cd;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(81, 69, 205, 0));\n  }\n  .lg\\:via-indigo-800 {\n    --gradient-via-color: #42389d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(66, 56, 157, 0));\n  }\n  .lg\\:via-indigo-900 {\n    --gradient-via-color: #362f78;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(54, 47, 120, 0));\n  }\n  .lg\\:via-purple-50 {\n    --gradient-via-color: #f6f5ff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(246, 245, 255, 0));\n  }\n  .lg\\:via-purple-100 {\n    --gradient-via-color: #edebfe;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(237, 235, 254, 0));\n  }\n  .lg\\:via-purple-200 {\n    --gradient-via-color: #dcd7fe;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(220, 215, 254, 0));\n  }\n  .lg\\:via-purple-300 {\n    --gradient-via-color: #cabffd;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(202, 191, 253, 0));\n  }\n  .lg\\:via-purple-400 {\n    --gradient-via-color: #ac94fa;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(172, 148, 250, 0));\n  }\n  .lg\\:via-purple-500 {\n    --gradient-via-color: #9061f9;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(144, 97, 249, 0));\n  }\n  .lg\\:via-purple-600 {\n    --gradient-via-color: #7e3af2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(126, 58, 242, 0));\n  }\n  .lg\\:via-purple-700 {\n    --gradient-via-color: #6c2bd9;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(108, 43, 217, 0));\n  }\n  .lg\\:via-purple-800 {\n    --gradient-via-color: #5521b5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(85, 33, 181, 0));\n  }\n  .lg\\:via-purple-900 {\n    --gradient-via-color: #4a1d96;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(74, 29, 150, 0));\n  }\n  .lg\\:via-pink-50 {\n    --gradient-via-color: #fdf2f8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 242, 248, 0));\n  }\n  .lg\\:via-pink-100 {\n    --gradient-via-color: #fce8f3;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(252, 232, 243, 0));\n  }\n  .lg\\:via-pink-200 {\n    --gradient-via-color: #fad1e8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(250, 209, 232, 0));\n  }\n  .lg\\:via-pink-300 {\n    --gradient-via-color: #f8b4d9;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(248, 180, 217, 0));\n  }\n  .lg\\:via-pink-400 {\n    --gradient-via-color: #f17eb8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(241, 126, 184, 0));\n  }\n  .lg\\:via-pink-500 {\n    --gradient-via-color: #e74694;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(231, 70, 148, 0));\n  }\n  .lg\\:via-pink-600 {\n    --gradient-via-color: #d61f69;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(214, 31, 105, 0));\n  }\n  .lg\\:via-pink-700 {\n    --gradient-via-color: #bf125d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(191, 18, 93, 0));\n  }\n  .lg\\:via-pink-800 {\n    --gradient-via-color: #99154b;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(153, 21, 75, 0));\n  }\n  .lg\\:via-pink-900 {\n    --gradient-via-color: #751a3d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(117, 26, 61, 0));\n  }\n  .lg\\:via-cool-gray-50 {\n    --gradient-via-color: #f8fafc;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(248, 250, 252, 0));\n  }\n  .lg\\:via-cool-gray-100 {\n    --gradient-via-color: #f1f5f9;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(241, 245, 249, 0));\n  }\n  .lg\\:via-cool-gray-200 {\n    --gradient-via-color: #e2e8f0;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(226, 232, 240, 0));\n  }\n  .lg\\:via-cool-gray-300 {\n    --gradient-via-color: #cfd8e3;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(207, 216, 227, 0));\n  }\n  .lg\\:via-cool-gray-400 {\n    --gradient-via-color: #97a6ba;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(151, 166, 186, 0));\n  }\n  .lg\\:via-cool-gray-500 {\n    --gradient-via-color: #64748b;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(100, 116, 139, 0));\n  }\n  .lg\\:via-cool-gray-600 {\n    --gradient-via-color: #475569;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(71, 85, 105, 0));\n  }\n  .lg\\:via-cool-gray-700 {\n    --gradient-via-color: #364152;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(54, 65, 82, 0));\n  }\n  .lg\\:via-cool-gray-800 {\n    --gradient-via-color: #27303f;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(39, 48, 63, 0));\n  }\n  .lg\\:via-cool-gray-900 {\n    --gradient-via-color: #1a202e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(26, 32, 46, 0));\n  }\n  .lg\\:to-current {\n    --gradient-to-color: currentColor;\n  }\n  .lg\\:to-transparent {\n    --gradient-to-color: transparent;\n  }\n  .lg\\:to-white {\n    --gradient-to-color: #ffffff;\n  }\n  .lg\\:to-black {\n    --gradient-to-color: #000000;\n  }\n  .lg\\:to-gray-50 {\n    --gradient-to-color: #f9fafb;\n  }\n  .lg\\:to-gray-100 {\n    --gradient-to-color: #f4f5f7;\n  }\n  .lg\\:to-gray-200 {\n    --gradient-to-color: #e5e7eb;\n  }\n  .lg\\:to-gray-300 {\n    --gradient-to-color: #d2d6dc;\n  }\n  .lg\\:to-gray-400 {\n    --gradient-to-color: #9fa6b2;\n  }\n  .lg\\:to-gray-500 {\n    --gradient-to-color: #6b7280;\n  }\n  .lg\\:to-gray-600 {\n    --gradient-to-color: #4b5563;\n  }\n  .lg\\:to-gray-700 {\n    --gradient-to-color: #374151;\n  }\n  .lg\\:to-gray-800 {\n    --gradient-to-color: #252f3f;\n  }\n  .lg\\:to-gray-900 {\n    --gradient-to-color: #161e2e;\n  }\n  .lg\\:to-red-50 {\n    --gradient-to-color: #fdf2f2;\n  }\n  .lg\\:to-red-100 {\n    --gradient-to-color: #fde8e8;\n  }\n  .lg\\:to-red-200 {\n    --gradient-to-color: #fbd5d5;\n  }\n  .lg\\:to-red-300 {\n    --gradient-to-color: #f8b4b4;\n  }\n  .lg\\:to-red-400 {\n    --gradient-to-color: #f98080;\n  }\n  .lg\\:to-red-500 {\n    --gradient-to-color: #f05252;\n  }\n  .lg\\:to-red-600 {\n    --gradient-to-color: #e02424;\n  }\n  .lg\\:to-red-700 {\n    --gradient-to-color: #c81e1e;\n  }\n  .lg\\:to-red-800 {\n    --gradient-to-color: #9b1c1c;\n  }\n  .lg\\:to-red-900 {\n    --gradient-to-color: #771d1d;\n  }\n  .lg\\:to-orange-50 {\n    --gradient-to-color: #fff8f1;\n  }\n  .lg\\:to-orange-100 {\n    --gradient-to-color: #feecdc;\n  }\n  .lg\\:to-orange-200 {\n    --gradient-to-color: #fcd9bd;\n  }\n  .lg\\:to-orange-300 {\n    --gradient-to-color: #fdba8c;\n  }\n  .lg\\:to-orange-400 {\n    --gradient-to-color: #ff8a4c;\n  }\n  .lg\\:to-orange-500 {\n    --gradient-to-color: #ff5a1f;\n  }\n  .lg\\:to-orange-600 {\n    --gradient-to-color: #d03801;\n  }\n  .lg\\:to-orange-700 {\n    --gradient-to-color: #b43403;\n  }\n  .lg\\:to-orange-800 {\n    --gradient-to-color: #8a2c0d;\n  }\n  .lg\\:to-orange-900 {\n    --gradient-to-color: #73230d;\n  }\n  .lg\\:to-yellow-50 {\n    --gradient-to-color: #fdfdea;\n  }\n  .lg\\:to-yellow-100 {\n    --gradient-to-color: #fdf6b2;\n  }\n  .lg\\:to-yellow-200 {\n    --gradient-to-color: #fce96a;\n  }\n  .lg\\:to-yellow-300 {\n    --gradient-to-color: #faca15;\n  }\n  .lg\\:to-yellow-400 {\n    --gradient-to-color: #e3a008;\n  }\n  .lg\\:to-yellow-500 {\n    --gradient-to-color: #c27803;\n  }\n  .lg\\:to-yellow-600 {\n    --gradient-to-color: #9f580a;\n  }\n  .lg\\:to-yellow-700 {\n    --gradient-to-color: #8e4b10;\n  }\n  .lg\\:to-yellow-800 {\n    --gradient-to-color: #723b13;\n  }\n  .lg\\:to-yellow-900 {\n    --gradient-to-color: #633112;\n  }\n  .lg\\:to-green-50 {\n    --gradient-to-color: #f3faf7;\n  }\n  .lg\\:to-green-100 {\n    --gradient-to-color: #def7ec;\n  }\n  .lg\\:to-green-200 {\n    --gradient-to-color: #bcf0da;\n  }\n  .lg\\:to-green-300 {\n    --gradient-to-color: #84e1bc;\n  }\n  .lg\\:to-green-400 {\n    --gradient-to-color: #31c48d;\n  }\n  .lg\\:to-green-500 {\n    --gradient-to-color: #0e9f6e;\n  }\n  .lg\\:to-green-600 {\n    --gradient-to-color: #057a55;\n  }\n  .lg\\:to-green-700 {\n    --gradient-to-color: #046c4e;\n  }\n  .lg\\:to-green-800 {\n    --gradient-to-color: #03543f;\n  }\n  .lg\\:to-green-900 {\n    --gradient-to-color: #014737;\n  }\n  .lg\\:to-teal-50 {\n    --gradient-to-color: #edfafa;\n  }\n  .lg\\:to-teal-100 {\n    --gradient-to-color: #d5f5f6;\n  }\n  .lg\\:to-teal-200 {\n    --gradient-to-color: #afecef;\n  }\n  .lg\\:to-teal-300 {\n    --gradient-to-color: #7edce2;\n  }\n  .lg\\:to-teal-400 {\n    --gradient-to-color: #16bdca;\n  }\n  .lg\\:to-teal-500 {\n    --gradient-to-color: #0694a2;\n  }\n  .lg\\:to-teal-600 {\n    --gradient-to-color: #047481;\n  }\n  .lg\\:to-teal-700 {\n    --gradient-to-color: #036672;\n  }\n  .lg\\:to-teal-800 {\n    --gradient-to-color: #05505c;\n  }\n  .lg\\:to-teal-900 {\n    --gradient-to-color: #014451;\n  }\n  .lg\\:to-blue-50 {\n    --gradient-to-color: #ebf5ff;\n  }\n  .lg\\:to-blue-100 {\n    --gradient-to-color: #e1effe;\n  }\n  .lg\\:to-blue-200 {\n    --gradient-to-color: #c3ddfd;\n  }\n  .lg\\:to-blue-300 {\n    --gradient-to-color: #a4cafe;\n  }\n  .lg\\:to-blue-400 {\n    --gradient-to-color: #76a9fa;\n  }\n  .lg\\:to-blue-500 {\n    --gradient-to-color: #3f83f8;\n  }\n  .lg\\:to-blue-600 {\n    --gradient-to-color: #1c64f2;\n  }\n  .lg\\:to-blue-700 {\n    --gradient-to-color: #1a56db;\n  }\n  .lg\\:to-blue-800 {\n    --gradient-to-color: #1e429f;\n  }\n  .lg\\:to-blue-900 {\n    --gradient-to-color: #233876;\n  }\n  .lg\\:to-indigo-50 {\n    --gradient-to-color: #f0f5ff;\n  }\n  .lg\\:to-indigo-100 {\n    --gradient-to-color: #e5edff;\n  }\n  .lg\\:to-indigo-200 {\n    --gradient-to-color: #cddbfe;\n  }\n  .lg\\:to-indigo-300 {\n    --gradient-to-color: #b4c6fc;\n  }\n  .lg\\:to-indigo-400 {\n    --gradient-to-color: #8da2fb;\n  }\n  .lg\\:to-indigo-500 {\n    --gradient-to-color: #6875f5;\n  }\n  .lg\\:to-indigo-600 {\n    --gradient-to-color: #5850ec;\n  }\n  .lg\\:to-indigo-700 {\n    --gradient-to-color: #5145cd;\n  }\n  .lg\\:to-indigo-800 {\n    --gradient-to-color: #42389d;\n  }\n  .lg\\:to-indigo-900 {\n    --gradient-to-color: #362f78;\n  }\n  .lg\\:to-purple-50 {\n    --gradient-to-color: #f6f5ff;\n  }\n  .lg\\:to-purple-100 {\n    --gradient-to-color: #edebfe;\n  }\n  .lg\\:to-purple-200 {\n    --gradient-to-color: #dcd7fe;\n  }\n  .lg\\:to-purple-300 {\n    --gradient-to-color: #cabffd;\n  }\n  .lg\\:to-purple-400 {\n    --gradient-to-color: #ac94fa;\n  }\n  .lg\\:to-purple-500 {\n    --gradient-to-color: #9061f9;\n  }\n  .lg\\:to-purple-600 {\n    --gradient-to-color: #7e3af2;\n  }\n  .lg\\:to-purple-700 {\n    --gradient-to-color: #6c2bd9;\n  }\n  .lg\\:to-purple-800 {\n    --gradient-to-color: #5521b5;\n  }\n  .lg\\:to-purple-900 {\n    --gradient-to-color: #4a1d96;\n  }\n  .lg\\:to-pink-50 {\n    --gradient-to-color: #fdf2f8;\n  }\n  .lg\\:to-pink-100 {\n    --gradient-to-color: #fce8f3;\n  }\n  .lg\\:to-pink-200 {\n    --gradient-to-color: #fad1e8;\n  }\n  .lg\\:to-pink-300 {\n    --gradient-to-color: #f8b4d9;\n  }\n  .lg\\:to-pink-400 {\n    --gradient-to-color: #f17eb8;\n  }\n  .lg\\:to-pink-500 {\n    --gradient-to-color: #e74694;\n  }\n  .lg\\:to-pink-600 {\n    --gradient-to-color: #d61f69;\n  }\n  .lg\\:to-pink-700 {\n    --gradient-to-color: #bf125d;\n  }\n  .lg\\:to-pink-800 {\n    --gradient-to-color: #99154b;\n  }\n  .lg\\:to-pink-900 {\n    --gradient-to-color: #751a3d;\n  }\n  .lg\\:to-cool-gray-50 {\n    --gradient-to-color: #f8fafc;\n  }\n  .lg\\:to-cool-gray-100 {\n    --gradient-to-color: #f1f5f9;\n  }\n  .lg\\:to-cool-gray-200 {\n    --gradient-to-color: #e2e8f0;\n  }\n  .lg\\:to-cool-gray-300 {\n    --gradient-to-color: #cfd8e3;\n  }\n  .lg\\:to-cool-gray-400 {\n    --gradient-to-color: #97a6ba;\n  }\n  .lg\\:to-cool-gray-500 {\n    --gradient-to-color: #64748b;\n  }\n  .lg\\:to-cool-gray-600 {\n    --gradient-to-color: #475569;\n  }\n  .lg\\:to-cool-gray-700 {\n    --gradient-to-color: #364152;\n  }\n  .lg\\:to-cool-gray-800 {\n    --gradient-to-color: #27303f;\n  }\n  .lg\\:to-cool-gray-900 {\n    --gradient-to-color: #1a202e;\n  }\n  .lg\\:hover\\:from-current:hover {\n    --gradient-from-color: currentColor;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));\n  }\n  .lg\\:hover\\:from-transparent:hover {\n    --gradient-from-color: transparent;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0));\n  }\n  .lg\\:hover\\:from-white:hover {\n    --gradient-from-color: #ffffff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));\n  }\n  .lg\\:hover\\:from-black:hover {\n    --gradient-from-color: #000000;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0));\n  }\n  .lg\\:hover\\:from-gray-50:hover {\n    --gradient-from-color: #f9fafb;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(249, 250, 251, 0));\n  }\n  .lg\\:hover\\:from-gray-100:hover {\n    --gradient-from-color: #f4f5f7;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(244, 245, 247, 0));\n  }\n  .lg\\:hover\\:from-gray-200:hover {\n    --gradient-from-color: #e5e7eb;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(229, 231, 235, 0));\n  }\n  .lg\\:hover\\:from-gray-300:hover {\n    --gradient-from-color: #d2d6dc;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(210, 214, 220, 0));\n  }\n  .lg\\:hover\\:from-gray-400:hover {\n    --gradient-from-color: #9fa6b2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(159, 166, 178, 0));\n  }\n  .lg\\:hover\\:from-gray-500:hover {\n    --gradient-from-color: #6b7280;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(107, 114, 128, 0));\n  }\n  .lg\\:hover\\:from-gray-600:hover {\n    --gradient-from-color: #4b5563;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(75, 85, 99, 0));\n  }\n  .lg\\:hover\\:from-gray-700:hover {\n    --gradient-from-color: #374151;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(55, 65, 81, 0));\n  }\n  .lg\\:hover\\:from-gray-800:hover {\n    --gradient-from-color: #252f3f;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(37, 47, 63, 0));\n  }\n  .lg\\:hover\\:from-gray-900:hover {\n    --gradient-from-color: #161e2e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(22, 30, 46, 0));\n  }\n  .lg\\:hover\\:from-red-50:hover {\n    --gradient-from-color: #fdf2f2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 242, 242, 0));\n  }\n  .lg\\:hover\\:from-red-100:hover {\n    --gradient-from-color: #fde8e8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 232, 232, 0));\n  }\n  .lg\\:hover\\:from-red-200:hover {\n    --gradient-from-color: #fbd5d5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(251, 213, 213, 0));\n  }\n  .lg\\:hover\\:from-red-300:hover {\n    --gradient-from-color: #f8b4b4;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(248, 180, 180, 0));\n  }\n  .lg\\:hover\\:from-red-400:hover {\n    --gradient-from-color: #f98080;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(249, 128, 128, 0));\n  }\n  .lg\\:hover\\:from-red-500:hover {\n    --gradient-from-color: #f05252;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(240, 82, 82, 0));\n  }\n  .lg\\:hover\\:from-red-600:hover {\n    --gradient-from-color: #e02424;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(224, 36, 36, 0));\n  }\n  .lg\\:hover\\:from-red-700:hover {\n    --gradient-from-color: #c81e1e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(200, 30, 30, 0));\n  }\n  .lg\\:hover\\:from-red-800:hover {\n    --gradient-from-color: #9b1c1c;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(155, 28, 28, 0));\n  }\n  .lg\\:hover\\:from-red-900:hover {\n    --gradient-from-color: #771d1d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(119, 29, 29, 0));\n  }\n  .lg\\:hover\\:from-orange-50:hover {\n    --gradient-from-color: #fff8f1;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 248, 241, 0));\n  }\n  .lg\\:hover\\:from-orange-100:hover {\n    --gradient-from-color: #feecdc;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 236, 220, 0));\n  }\n  .lg\\:hover\\:from-orange-200:hover {\n    --gradient-from-color: #fcd9bd;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(252, 217, 189, 0));\n  }\n  .lg\\:hover\\:from-orange-300:hover {\n    --gradient-from-color: #fdba8c;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 186, 140, 0));\n  }\n  .lg\\:hover\\:from-orange-400:hover {\n    --gradient-from-color: #ff8a4c;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 138, 76, 0));\n  }\n  .lg\\:hover\\:from-orange-500:hover {\n    --gradient-from-color: #ff5a1f;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 90, 31, 0));\n  }\n  .lg\\:hover\\:from-orange-600:hover {\n    --gradient-from-color: #d03801;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(208, 56, 1, 0));\n  }\n  .lg\\:hover\\:from-orange-700:hover {\n    --gradient-from-color: #b43403;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(180, 52, 3, 0));\n  }\n  .lg\\:hover\\:from-orange-800:hover {\n    --gradient-from-color: #8a2c0d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(138, 44, 13, 0));\n  }\n  .lg\\:hover\\:from-orange-900:hover {\n    --gradient-from-color: #73230d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(115, 35, 13, 0));\n  }\n  .lg\\:hover\\:from-yellow-50:hover {\n    --gradient-from-color: #fdfdea;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 253, 234, 0));\n  }\n  .lg\\:hover\\:from-yellow-100:hover {\n    --gradient-from-color: #fdf6b2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 246, 178, 0));\n  }\n  .lg\\:hover\\:from-yellow-200:hover {\n    --gradient-from-color: #fce96a;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(252, 233, 106, 0));\n  }\n  .lg\\:hover\\:from-yellow-300:hover {\n    --gradient-from-color: #faca15;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(250, 202, 21, 0));\n  }\n  .lg\\:hover\\:from-yellow-400:hover {\n    --gradient-from-color: #e3a008;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(227, 160, 8, 0));\n  }\n  .lg\\:hover\\:from-yellow-500:hover {\n    --gradient-from-color: #c27803;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(194, 120, 3, 0));\n  }\n  .lg\\:hover\\:from-yellow-600:hover {\n    --gradient-from-color: #9f580a;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(159, 88, 10, 0));\n  }\n  .lg\\:hover\\:from-yellow-700:hover {\n    --gradient-from-color: #8e4b10;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(142, 75, 16, 0));\n  }\n  .lg\\:hover\\:from-yellow-800:hover {\n    --gradient-from-color: #723b13;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(114, 59, 19, 0));\n  }\n  .lg\\:hover\\:from-yellow-900:hover {\n    --gradient-from-color: #633112;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(99, 49, 18, 0));\n  }\n  .lg\\:hover\\:from-green-50:hover {\n    --gradient-from-color: #f3faf7;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(243, 250, 247, 0));\n  }\n  .lg\\:hover\\:from-green-100:hover {\n    --gradient-from-color: #def7ec;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(222, 247, 236, 0));\n  }\n  .lg\\:hover\\:from-green-200:hover {\n    --gradient-from-color: #bcf0da;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(188, 240, 218, 0));\n  }\n  .lg\\:hover\\:from-green-300:hover {\n    --gradient-from-color: #84e1bc;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(132, 225, 188, 0));\n  }\n  .lg\\:hover\\:from-green-400:hover {\n    --gradient-from-color: #31c48d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(49, 196, 141, 0));\n  }\n  .lg\\:hover\\:from-green-500:hover {\n    --gradient-from-color: #0e9f6e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(14, 159, 110, 0));\n  }\n  .lg\\:hover\\:from-green-600:hover {\n    --gradient-from-color: #057a55;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(5, 122, 85, 0));\n  }\n  .lg\\:hover\\:from-green-700:hover {\n    --gradient-from-color: #046c4e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(4, 108, 78, 0));\n  }\n  .lg\\:hover\\:from-green-800:hover {\n    --gradient-from-color: #03543f;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(3, 84, 63, 0));\n  }\n  .lg\\:hover\\:from-green-900:hover {\n    --gradient-from-color: #014737;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(1, 71, 55, 0));\n  }\n  .lg\\:hover\\:from-teal-50:hover {\n    --gradient-from-color: #edfafa;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(237, 250, 250, 0));\n  }\n  .lg\\:hover\\:from-teal-100:hover {\n    --gradient-from-color: #d5f5f6;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(213, 245, 246, 0));\n  }\n  .lg\\:hover\\:from-teal-200:hover {\n    --gradient-from-color: #afecef;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(175, 236, 239, 0));\n  }\n  .lg\\:hover\\:from-teal-300:hover {\n    --gradient-from-color: #7edce2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(126, 220, 226, 0));\n  }\n  .lg\\:hover\\:from-teal-400:hover {\n    --gradient-from-color: #16bdca;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(22, 189, 202, 0));\n  }\n  .lg\\:hover\\:from-teal-500:hover {\n    --gradient-from-color: #0694a2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(6, 148, 162, 0));\n  }\n  .lg\\:hover\\:from-teal-600:hover {\n    --gradient-from-color: #047481;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(4, 116, 129, 0));\n  }\n  .lg\\:hover\\:from-teal-700:hover {\n    --gradient-from-color: #036672;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(3, 102, 114, 0));\n  }\n  .lg\\:hover\\:from-teal-800:hover {\n    --gradient-from-color: #05505c;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(5, 80, 92, 0));\n  }\n  .lg\\:hover\\:from-teal-900:hover {\n    --gradient-from-color: #014451;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(1, 68, 81, 0));\n  }\n  .lg\\:hover\\:from-blue-50:hover {\n    --gradient-from-color: #ebf5ff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(235, 245, 255, 0));\n  }\n  .lg\\:hover\\:from-blue-100:hover {\n    --gradient-from-color: #e1effe;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(225, 239, 254, 0));\n  }\n  .lg\\:hover\\:from-blue-200:hover {\n    --gradient-from-color: #c3ddfd;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(195, 221, 253, 0));\n  }\n  .lg\\:hover\\:from-blue-300:hover {\n    --gradient-from-color: #a4cafe;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(164, 202, 254, 0));\n  }\n  .lg\\:hover\\:from-blue-400:hover {\n    --gradient-from-color: #76a9fa;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(118, 169, 250, 0));\n  }\n  .lg\\:hover\\:from-blue-500:hover {\n    --gradient-from-color: #3f83f8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(63, 131, 248, 0));\n  }\n  .lg\\:hover\\:from-blue-600:hover {\n    --gradient-from-color: #1c64f2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(28, 100, 242, 0));\n  }\n  .lg\\:hover\\:from-blue-700:hover {\n    --gradient-from-color: #1a56db;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(26, 86, 219, 0));\n  }\n  .lg\\:hover\\:from-blue-800:hover {\n    --gradient-from-color: #1e429f;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(30, 66, 159, 0));\n  }\n  .lg\\:hover\\:from-blue-900:hover {\n    --gradient-from-color: #233876;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(35, 56, 118, 0));\n  }\n  .lg\\:hover\\:from-indigo-50:hover {\n    --gradient-from-color: #f0f5ff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(240, 245, 255, 0));\n  }\n  .lg\\:hover\\:from-indigo-100:hover {\n    --gradient-from-color: #e5edff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(229, 237, 255, 0));\n  }\n  .lg\\:hover\\:from-indigo-200:hover {\n    --gradient-from-color: #cddbfe;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(205, 219, 254, 0));\n  }\n  .lg\\:hover\\:from-indigo-300:hover {\n    --gradient-from-color: #b4c6fc;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(180, 198, 252, 0));\n  }\n  .lg\\:hover\\:from-indigo-400:hover {\n    --gradient-from-color: #8da2fb;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(141, 162, 251, 0));\n  }\n  .lg\\:hover\\:from-indigo-500:hover {\n    --gradient-from-color: #6875f5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(104, 117, 245, 0));\n  }\n  .lg\\:hover\\:from-indigo-600:hover {\n    --gradient-from-color: #5850ec;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(88, 80, 236, 0));\n  }\n  .lg\\:hover\\:from-indigo-700:hover {\n    --gradient-from-color: #5145cd;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(81, 69, 205, 0));\n  }\n  .lg\\:hover\\:from-indigo-800:hover {\n    --gradient-from-color: #42389d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(66, 56, 157, 0));\n  }\n  .lg\\:hover\\:from-indigo-900:hover {\n    --gradient-from-color: #362f78;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(54, 47, 120, 0));\n  }\n  .lg\\:hover\\:from-purple-50:hover {\n    --gradient-from-color: #f6f5ff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(246, 245, 255, 0));\n  }\n  .lg\\:hover\\:from-purple-100:hover {\n    --gradient-from-color: #edebfe;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(237, 235, 254, 0));\n  }\n  .lg\\:hover\\:from-purple-200:hover {\n    --gradient-from-color: #dcd7fe;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(220, 215, 254, 0));\n  }\n  .lg\\:hover\\:from-purple-300:hover {\n    --gradient-from-color: #cabffd;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(202, 191, 253, 0));\n  }\n  .lg\\:hover\\:from-purple-400:hover {\n    --gradient-from-color: #ac94fa;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(172, 148, 250, 0));\n  }\n  .lg\\:hover\\:from-purple-500:hover {\n    --gradient-from-color: #9061f9;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(144, 97, 249, 0));\n  }\n  .lg\\:hover\\:from-purple-600:hover {\n    --gradient-from-color: #7e3af2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(126, 58, 242, 0));\n  }\n  .lg\\:hover\\:from-purple-700:hover {\n    --gradient-from-color: #6c2bd9;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(108, 43, 217, 0));\n  }\n  .lg\\:hover\\:from-purple-800:hover {\n    --gradient-from-color: #5521b5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(85, 33, 181, 0));\n  }\n  .lg\\:hover\\:from-purple-900:hover {\n    --gradient-from-color: #4a1d96;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(74, 29, 150, 0));\n  }\n  .lg\\:hover\\:from-pink-50:hover {\n    --gradient-from-color: #fdf2f8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 242, 248, 0));\n  }\n  .lg\\:hover\\:from-pink-100:hover {\n    --gradient-from-color: #fce8f3;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(252, 232, 243, 0));\n  }\n  .lg\\:hover\\:from-pink-200:hover {\n    --gradient-from-color: #fad1e8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(250, 209, 232, 0));\n  }\n  .lg\\:hover\\:from-pink-300:hover {\n    --gradient-from-color: #f8b4d9;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(248, 180, 217, 0));\n  }\n  .lg\\:hover\\:from-pink-400:hover {\n    --gradient-from-color: #f17eb8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(241, 126, 184, 0));\n  }\n  .lg\\:hover\\:from-pink-500:hover {\n    --gradient-from-color: #e74694;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(231, 70, 148, 0));\n  }\n  .lg\\:hover\\:from-pink-600:hover {\n    --gradient-from-color: #d61f69;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(214, 31, 105, 0));\n  }\n  .lg\\:hover\\:from-pink-700:hover {\n    --gradient-from-color: #bf125d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(191, 18, 93, 0));\n  }\n  .lg\\:hover\\:from-pink-800:hover {\n    --gradient-from-color: #99154b;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(153, 21, 75, 0));\n  }\n  .lg\\:hover\\:from-pink-900:hover {\n    --gradient-from-color: #751a3d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(117, 26, 61, 0));\n  }\n  .lg\\:hover\\:from-cool-gray-50:hover {\n    --gradient-from-color: #f8fafc;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(248, 250, 252, 0));\n  }\n  .lg\\:hover\\:from-cool-gray-100:hover {\n    --gradient-from-color: #f1f5f9;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(241, 245, 249, 0));\n  }\n  .lg\\:hover\\:from-cool-gray-200:hover {\n    --gradient-from-color: #e2e8f0;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(226, 232, 240, 0));\n  }\n  .lg\\:hover\\:from-cool-gray-300:hover {\n    --gradient-from-color: #cfd8e3;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(207, 216, 227, 0));\n  }\n  .lg\\:hover\\:from-cool-gray-400:hover {\n    --gradient-from-color: #97a6ba;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(151, 166, 186, 0));\n  }\n  .lg\\:hover\\:from-cool-gray-500:hover {\n    --gradient-from-color: #64748b;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(100, 116, 139, 0));\n  }\n  .lg\\:hover\\:from-cool-gray-600:hover {\n    --gradient-from-color: #475569;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(71, 85, 105, 0));\n  }\n  .lg\\:hover\\:from-cool-gray-700:hover {\n    --gradient-from-color: #364152;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(54, 65, 82, 0));\n  }\n  .lg\\:hover\\:from-cool-gray-800:hover {\n    --gradient-from-color: #27303f;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(39, 48, 63, 0));\n  }\n  .lg\\:hover\\:from-cool-gray-900:hover {\n    --gradient-from-color: #1a202e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(26, 32, 46, 0));\n  }\n  .lg\\:hover\\:via-current:hover {\n    --gradient-via-color: currentColor;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));\n  }\n  .lg\\:hover\\:via-transparent:hover {\n    --gradient-via-color: transparent;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0));\n  }\n  .lg\\:hover\\:via-white:hover {\n    --gradient-via-color: #ffffff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));\n  }\n  .lg\\:hover\\:via-black:hover {\n    --gradient-via-color: #000000;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0));\n  }\n  .lg\\:hover\\:via-gray-50:hover {\n    --gradient-via-color: #f9fafb;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(249, 250, 251, 0));\n  }\n  .lg\\:hover\\:via-gray-100:hover {\n    --gradient-via-color: #f4f5f7;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(244, 245, 247, 0));\n  }\n  .lg\\:hover\\:via-gray-200:hover {\n    --gradient-via-color: #e5e7eb;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(229, 231, 235, 0));\n  }\n  .lg\\:hover\\:via-gray-300:hover {\n    --gradient-via-color: #d2d6dc;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(210, 214, 220, 0));\n  }\n  .lg\\:hover\\:via-gray-400:hover {\n    --gradient-via-color: #9fa6b2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(159, 166, 178, 0));\n  }\n  .lg\\:hover\\:via-gray-500:hover {\n    --gradient-via-color: #6b7280;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(107, 114, 128, 0));\n  }\n  .lg\\:hover\\:via-gray-600:hover {\n    --gradient-via-color: #4b5563;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(75, 85, 99, 0));\n  }\n  .lg\\:hover\\:via-gray-700:hover {\n    --gradient-via-color: #374151;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(55, 65, 81, 0));\n  }\n  .lg\\:hover\\:via-gray-800:hover {\n    --gradient-via-color: #252f3f;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(37, 47, 63, 0));\n  }\n  .lg\\:hover\\:via-gray-900:hover {\n    --gradient-via-color: #161e2e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(22, 30, 46, 0));\n  }\n  .lg\\:hover\\:via-red-50:hover {\n    --gradient-via-color: #fdf2f2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 242, 242, 0));\n  }\n  .lg\\:hover\\:via-red-100:hover {\n    --gradient-via-color: #fde8e8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 232, 232, 0));\n  }\n  .lg\\:hover\\:via-red-200:hover {\n    --gradient-via-color: #fbd5d5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(251, 213, 213, 0));\n  }\n  .lg\\:hover\\:via-red-300:hover {\n    --gradient-via-color: #f8b4b4;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(248, 180, 180, 0));\n  }\n  .lg\\:hover\\:via-red-400:hover {\n    --gradient-via-color: #f98080;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(249, 128, 128, 0));\n  }\n  .lg\\:hover\\:via-red-500:hover {\n    --gradient-via-color: #f05252;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(240, 82, 82, 0));\n  }\n  .lg\\:hover\\:via-red-600:hover {\n    --gradient-via-color: #e02424;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(224, 36, 36, 0));\n  }\n  .lg\\:hover\\:via-red-700:hover {\n    --gradient-via-color: #c81e1e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(200, 30, 30, 0));\n  }\n  .lg\\:hover\\:via-red-800:hover {\n    --gradient-via-color: #9b1c1c;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(155, 28, 28, 0));\n  }\n  .lg\\:hover\\:via-red-900:hover {\n    --gradient-via-color: #771d1d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(119, 29, 29, 0));\n  }\n  .lg\\:hover\\:via-orange-50:hover {\n    --gradient-via-color: #fff8f1;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 248, 241, 0));\n  }\n  .lg\\:hover\\:via-orange-100:hover {\n    --gradient-via-color: #feecdc;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 236, 220, 0));\n  }\n  .lg\\:hover\\:via-orange-200:hover {\n    --gradient-via-color: #fcd9bd;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(252, 217, 189, 0));\n  }\n  .lg\\:hover\\:via-orange-300:hover {\n    --gradient-via-color: #fdba8c;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 186, 140, 0));\n  }\n  .lg\\:hover\\:via-orange-400:hover {\n    --gradient-via-color: #ff8a4c;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 138, 76, 0));\n  }\n  .lg\\:hover\\:via-orange-500:hover {\n    --gradient-via-color: #ff5a1f;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 90, 31, 0));\n  }\n  .lg\\:hover\\:via-orange-600:hover {\n    --gradient-via-color: #d03801;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(208, 56, 1, 0));\n  }\n  .lg\\:hover\\:via-orange-700:hover {\n    --gradient-via-color: #b43403;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(180, 52, 3, 0));\n  }\n  .lg\\:hover\\:via-orange-800:hover {\n    --gradient-via-color: #8a2c0d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(138, 44, 13, 0));\n  }\n  .lg\\:hover\\:via-orange-900:hover {\n    --gradient-via-color: #73230d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(115, 35, 13, 0));\n  }\n  .lg\\:hover\\:via-yellow-50:hover {\n    --gradient-via-color: #fdfdea;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 253, 234, 0));\n  }\n  .lg\\:hover\\:via-yellow-100:hover {\n    --gradient-via-color: #fdf6b2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 246, 178, 0));\n  }\n  .lg\\:hover\\:via-yellow-200:hover {\n    --gradient-via-color: #fce96a;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(252, 233, 106, 0));\n  }\n  .lg\\:hover\\:via-yellow-300:hover {\n    --gradient-via-color: #faca15;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(250, 202, 21, 0));\n  }\n  .lg\\:hover\\:via-yellow-400:hover {\n    --gradient-via-color: #e3a008;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(227, 160, 8, 0));\n  }\n  .lg\\:hover\\:via-yellow-500:hover {\n    --gradient-via-color: #c27803;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(194, 120, 3, 0));\n  }\n  .lg\\:hover\\:via-yellow-600:hover {\n    --gradient-via-color: #9f580a;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(159, 88, 10, 0));\n  }\n  .lg\\:hover\\:via-yellow-700:hover {\n    --gradient-via-color: #8e4b10;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(142, 75, 16, 0));\n  }\n  .lg\\:hover\\:via-yellow-800:hover {\n    --gradient-via-color: #723b13;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(114, 59, 19, 0));\n  }\n  .lg\\:hover\\:via-yellow-900:hover {\n    --gradient-via-color: #633112;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(99, 49, 18, 0));\n  }\n  .lg\\:hover\\:via-green-50:hover {\n    --gradient-via-color: #f3faf7;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(243, 250, 247, 0));\n  }\n  .lg\\:hover\\:via-green-100:hover {\n    --gradient-via-color: #def7ec;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(222, 247, 236, 0));\n  }\n  .lg\\:hover\\:via-green-200:hover {\n    --gradient-via-color: #bcf0da;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(188, 240, 218, 0));\n  }\n  .lg\\:hover\\:via-green-300:hover {\n    --gradient-via-color: #84e1bc;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(132, 225, 188, 0));\n  }\n  .lg\\:hover\\:via-green-400:hover {\n    --gradient-via-color: #31c48d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(49, 196, 141, 0));\n  }\n  .lg\\:hover\\:via-green-500:hover {\n    --gradient-via-color: #0e9f6e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(14, 159, 110, 0));\n  }\n  .lg\\:hover\\:via-green-600:hover {\n    --gradient-via-color: #057a55;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(5, 122, 85, 0));\n  }\n  .lg\\:hover\\:via-green-700:hover {\n    --gradient-via-color: #046c4e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(4, 108, 78, 0));\n  }\n  .lg\\:hover\\:via-green-800:hover {\n    --gradient-via-color: #03543f;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(3, 84, 63, 0));\n  }\n  .lg\\:hover\\:via-green-900:hover {\n    --gradient-via-color: #014737;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(1, 71, 55, 0));\n  }\n  .lg\\:hover\\:via-teal-50:hover {\n    --gradient-via-color: #edfafa;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(237, 250, 250, 0));\n  }\n  .lg\\:hover\\:via-teal-100:hover {\n    --gradient-via-color: #d5f5f6;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(213, 245, 246, 0));\n  }\n  .lg\\:hover\\:via-teal-200:hover {\n    --gradient-via-color: #afecef;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(175, 236, 239, 0));\n  }\n  .lg\\:hover\\:via-teal-300:hover {\n    --gradient-via-color: #7edce2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(126, 220, 226, 0));\n  }\n  .lg\\:hover\\:via-teal-400:hover {\n    --gradient-via-color: #16bdca;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(22, 189, 202, 0));\n  }\n  .lg\\:hover\\:via-teal-500:hover {\n    --gradient-via-color: #0694a2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(6, 148, 162, 0));\n  }\n  .lg\\:hover\\:via-teal-600:hover {\n    --gradient-via-color: #047481;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(4, 116, 129, 0));\n  }\n  .lg\\:hover\\:via-teal-700:hover {\n    --gradient-via-color: #036672;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(3, 102, 114, 0));\n  }\n  .lg\\:hover\\:via-teal-800:hover {\n    --gradient-via-color: #05505c;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(5, 80, 92, 0));\n  }\n  .lg\\:hover\\:via-teal-900:hover {\n    --gradient-via-color: #014451;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(1, 68, 81, 0));\n  }\n  .lg\\:hover\\:via-blue-50:hover {\n    --gradient-via-color: #ebf5ff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(235, 245, 255, 0));\n  }\n  .lg\\:hover\\:via-blue-100:hover {\n    --gradient-via-color: #e1effe;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(225, 239, 254, 0));\n  }\n  .lg\\:hover\\:via-blue-200:hover {\n    --gradient-via-color: #c3ddfd;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(195, 221, 253, 0));\n  }\n  .lg\\:hover\\:via-blue-300:hover {\n    --gradient-via-color: #a4cafe;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(164, 202, 254, 0));\n  }\n  .lg\\:hover\\:via-blue-400:hover {\n    --gradient-via-color: #76a9fa;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(118, 169, 250, 0));\n  }\n  .lg\\:hover\\:via-blue-500:hover {\n    --gradient-via-color: #3f83f8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(63, 131, 248, 0));\n  }\n  .lg\\:hover\\:via-blue-600:hover {\n    --gradient-via-color: #1c64f2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(28, 100, 242, 0));\n  }\n  .lg\\:hover\\:via-blue-700:hover {\n    --gradient-via-color: #1a56db;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(26, 86, 219, 0));\n  }\n  .lg\\:hover\\:via-blue-800:hover {\n    --gradient-via-color: #1e429f;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(30, 66, 159, 0));\n  }\n  .lg\\:hover\\:via-blue-900:hover {\n    --gradient-via-color: #233876;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(35, 56, 118, 0));\n  }\n  .lg\\:hover\\:via-indigo-50:hover {\n    --gradient-via-color: #f0f5ff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(240, 245, 255, 0));\n  }\n  .lg\\:hover\\:via-indigo-100:hover {\n    --gradient-via-color: #e5edff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(229, 237, 255, 0));\n  }\n  .lg\\:hover\\:via-indigo-200:hover {\n    --gradient-via-color: #cddbfe;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(205, 219, 254, 0));\n  }\n  .lg\\:hover\\:via-indigo-300:hover {\n    --gradient-via-color: #b4c6fc;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(180, 198, 252, 0));\n  }\n  .lg\\:hover\\:via-indigo-400:hover {\n    --gradient-via-color: #8da2fb;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(141, 162, 251, 0));\n  }\n  .lg\\:hover\\:via-indigo-500:hover {\n    --gradient-via-color: #6875f5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(104, 117, 245, 0));\n  }\n  .lg\\:hover\\:via-indigo-600:hover {\n    --gradient-via-color: #5850ec;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(88, 80, 236, 0));\n  }\n  .lg\\:hover\\:via-indigo-700:hover {\n    --gradient-via-color: #5145cd;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(81, 69, 205, 0));\n  }\n  .lg\\:hover\\:via-indigo-800:hover {\n    --gradient-via-color: #42389d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(66, 56, 157, 0));\n  }\n  .lg\\:hover\\:via-indigo-900:hover {\n    --gradient-via-color: #362f78;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(54, 47, 120, 0));\n  }\n  .lg\\:hover\\:via-purple-50:hover {\n    --gradient-via-color: #f6f5ff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(246, 245, 255, 0));\n  }\n  .lg\\:hover\\:via-purple-100:hover {\n    --gradient-via-color: #edebfe;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(237, 235, 254, 0));\n  }\n  .lg\\:hover\\:via-purple-200:hover {\n    --gradient-via-color: #dcd7fe;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(220, 215, 254, 0));\n  }\n  .lg\\:hover\\:via-purple-300:hover {\n    --gradient-via-color: #cabffd;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(202, 191, 253, 0));\n  }\n  .lg\\:hover\\:via-purple-400:hover {\n    --gradient-via-color: #ac94fa;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(172, 148, 250, 0));\n  }\n  .lg\\:hover\\:via-purple-500:hover {\n    --gradient-via-color: #9061f9;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(144, 97, 249, 0));\n  }\n  .lg\\:hover\\:via-purple-600:hover {\n    --gradient-via-color: #7e3af2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(126, 58, 242, 0));\n  }\n  .lg\\:hover\\:via-purple-700:hover {\n    --gradient-via-color: #6c2bd9;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(108, 43, 217, 0));\n  }\n  .lg\\:hover\\:via-purple-800:hover {\n    --gradient-via-color: #5521b5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(85, 33, 181, 0));\n  }\n  .lg\\:hover\\:via-purple-900:hover {\n    --gradient-via-color: #4a1d96;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(74, 29, 150, 0));\n  }\n  .lg\\:hover\\:via-pink-50:hover {\n    --gradient-via-color: #fdf2f8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 242, 248, 0));\n  }\n  .lg\\:hover\\:via-pink-100:hover {\n    --gradient-via-color: #fce8f3;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(252, 232, 243, 0));\n  }\n  .lg\\:hover\\:via-pink-200:hover {\n    --gradient-via-color: #fad1e8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(250, 209, 232, 0));\n  }\n  .lg\\:hover\\:via-pink-300:hover {\n    --gradient-via-color: #f8b4d9;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(248, 180, 217, 0));\n  }\n  .lg\\:hover\\:via-pink-400:hover {\n    --gradient-via-color: #f17eb8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(241, 126, 184, 0));\n  }\n  .lg\\:hover\\:via-pink-500:hover {\n    --gradient-via-color: #e74694;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(231, 70, 148, 0));\n  }\n  .lg\\:hover\\:via-pink-600:hover {\n    --gradient-via-color: #d61f69;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(214, 31, 105, 0));\n  }\n  .lg\\:hover\\:via-pink-700:hover {\n    --gradient-via-color: #bf125d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(191, 18, 93, 0));\n  }\n  .lg\\:hover\\:via-pink-800:hover {\n    --gradient-via-color: #99154b;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(153, 21, 75, 0));\n  }\n  .lg\\:hover\\:via-pink-900:hover {\n    --gradient-via-color: #751a3d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(117, 26, 61, 0));\n  }\n  .lg\\:hover\\:via-cool-gray-50:hover {\n    --gradient-via-color: #f8fafc;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(248, 250, 252, 0));\n  }\n  .lg\\:hover\\:via-cool-gray-100:hover {\n    --gradient-via-color: #f1f5f9;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(241, 245, 249, 0));\n  }\n  .lg\\:hover\\:via-cool-gray-200:hover {\n    --gradient-via-color: #e2e8f0;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(226, 232, 240, 0));\n  }\n  .lg\\:hover\\:via-cool-gray-300:hover {\n    --gradient-via-color: #cfd8e3;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(207, 216, 227, 0));\n  }\n  .lg\\:hover\\:via-cool-gray-400:hover {\n    --gradient-via-color: #97a6ba;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(151, 166, 186, 0));\n  }\n  .lg\\:hover\\:via-cool-gray-500:hover {\n    --gradient-via-color: #64748b;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(100, 116, 139, 0));\n  }\n  .lg\\:hover\\:via-cool-gray-600:hover {\n    --gradient-via-color: #475569;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(71, 85, 105, 0));\n  }\n  .lg\\:hover\\:via-cool-gray-700:hover {\n    --gradient-via-color: #364152;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(54, 65, 82, 0));\n  }\n  .lg\\:hover\\:via-cool-gray-800:hover {\n    --gradient-via-color: #27303f;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(39, 48, 63, 0));\n  }\n  .lg\\:hover\\:via-cool-gray-900:hover {\n    --gradient-via-color: #1a202e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(26, 32, 46, 0));\n  }\n  .lg\\:hover\\:to-current:hover {\n    --gradient-to-color: currentColor;\n  }\n  .lg\\:hover\\:to-transparent:hover {\n    --gradient-to-color: transparent;\n  }\n  .lg\\:hover\\:to-white:hover {\n    --gradient-to-color: #ffffff;\n  }\n  .lg\\:hover\\:to-black:hover {\n    --gradient-to-color: #000000;\n  }\n  .lg\\:hover\\:to-gray-50:hover {\n    --gradient-to-color: #f9fafb;\n  }\n  .lg\\:hover\\:to-gray-100:hover {\n    --gradient-to-color: #f4f5f7;\n  }\n  .lg\\:hover\\:to-gray-200:hover {\n    --gradient-to-color: #e5e7eb;\n  }\n  .lg\\:hover\\:to-gray-300:hover {\n    --gradient-to-color: #d2d6dc;\n  }\n  .lg\\:hover\\:to-gray-400:hover {\n    --gradient-to-color: #9fa6b2;\n  }\n  .lg\\:hover\\:to-gray-500:hover {\n    --gradient-to-color: #6b7280;\n  }\n  .lg\\:hover\\:to-gray-600:hover {\n    --gradient-to-color: #4b5563;\n  }\n  .lg\\:hover\\:to-gray-700:hover {\n    --gradient-to-color: #374151;\n  }\n  .lg\\:hover\\:to-gray-800:hover {\n    --gradient-to-color: #252f3f;\n  }\n  .lg\\:hover\\:to-gray-900:hover {\n    --gradient-to-color: #161e2e;\n  }\n  .lg\\:hover\\:to-red-50:hover {\n    --gradient-to-color: #fdf2f2;\n  }\n  .lg\\:hover\\:to-red-100:hover {\n    --gradient-to-color: #fde8e8;\n  }\n  .lg\\:hover\\:to-red-200:hover {\n    --gradient-to-color: #fbd5d5;\n  }\n  .lg\\:hover\\:to-red-300:hover {\n    --gradient-to-color: #f8b4b4;\n  }\n  .lg\\:hover\\:to-red-400:hover {\n    --gradient-to-color: #f98080;\n  }\n  .lg\\:hover\\:to-red-500:hover {\n    --gradient-to-color: #f05252;\n  }\n  .lg\\:hover\\:to-red-600:hover {\n    --gradient-to-color: #e02424;\n  }\n  .lg\\:hover\\:to-red-700:hover {\n    --gradient-to-color: #c81e1e;\n  }\n  .lg\\:hover\\:to-red-800:hover {\n    --gradient-to-color: #9b1c1c;\n  }\n  .lg\\:hover\\:to-red-900:hover {\n    --gradient-to-color: #771d1d;\n  }\n  .lg\\:hover\\:to-orange-50:hover {\n    --gradient-to-color: #fff8f1;\n  }\n  .lg\\:hover\\:to-orange-100:hover {\n    --gradient-to-color: #feecdc;\n  }\n  .lg\\:hover\\:to-orange-200:hover {\n    --gradient-to-color: #fcd9bd;\n  }\n  .lg\\:hover\\:to-orange-300:hover {\n    --gradient-to-color: #fdba8c;\n  }\n  .lg\\:hover\\:to-orange-400:hover {\n    --gradient-to-color: #ff8a4c;\n  }\n  .lg\\:hover\\:to-orange-500:hover {\n    --gradient-to-color: #ff5a1f;\n  }\n  .lg\\:hover\\:to-orange-600:hover {\n    --gradient-to-color: #d03801;\n  }\n  .lg\\:hover\\:to-orange-700:hover {\n    --gradient-to-color: #b43403;\n  }\n  .lg\\:hover\\:to-orange-800:hover {\n    --gradient-to-color: #8a2c0d;\n  }\n  .lg\\:hover\\:to-orange-900:hover {\n    --gradient-to-color: #73230d;\n  }\n  .lg\\:hover\\:to-yellow-50:hover {\n    --gradient-to-color: #fdfdea;\n  }\n  .lg\\:hover\\:to-yellow-100:hover {\n    --gradient-to-color: #fdf6b2;\n  }\n  .lg\\:hover\\:to-yellow-200:hover {\n    --gradient-to-color: #fce96a;\n  }\n  .lg\\:hover\\:to-yellow-300:hover {\n    --gradient-to-color: #faca15;\n  }\n  .lg\\:hover\\:to-yellow-400:hover {\n    --gradient-to-color: #e3a008;\n  }\n  .lg\\:hover\\:to-yellow-500:hover {\n    --gradient-to-color: #c27803;\n  }\n  .lg\\:hover\\:to-yellow-600:hover {\n    --gradient-to-color: #9f580a;\n  }\n  .lg\\:hover\\:to-yellow-700:hover {\n    --gradient-to-color: #8e4b10;\n  }\n  .lg\\:hover\\:to-yellow-800:hover {\n    --gradient-to-color: #723b13;\n  }\n  .lg\\:hover\\:to-yellow-900:hover {\n    --gradient-to-color: #633112;\n  }\n  .lg\\:hover\\:to-green-50:hover {\n    --gradient-to-color: #f3faf7;\n  }\n  .lg\\:hover\\:to-green-100:hover {\n    --gradient-to-color: #def7ec;\n  }\n  .lg\\:hover\\:to-green-200:hover {\n    --gradient-to-color: #bcf0da;\n  }\n  .lg\\:hover\\:to-green-300:hover {\n    --gradient-to-color: #84e1bc;\n  }\n  .lg\\:hover\\:to-green-400:hover {\n    --gradient-to-color: #31c48d;\n  }\n  .lg\\:hover\\:to-green-500:hover {\n    --gradient-to-color: #0e9f6e;\n  }\n  .lg\\:hover\\:to-green-600:hover {\n    --gradient-to-color: #057a55;\n  }\n  .lg\\:hover\\:to-green-700:hover {\n    --gradient-to-color: #046c4e;\n  }\n  .lg\\:hover\\:to-green-800:hover {\n    --gradient-to-color: #03543f;\n  }\n  .lg\\:hover\\:to-green-900:hover {\n    --gradient-to-color: #014737;\n  }\n  .lg\\:hover\\:to-teal-50:hover {\n    --gradient-to-color: #edfafa;\n  }\n  .lg\\:hover\\:to-teal-100:hover {\n    --gradient-to-color: #d5f5f6;\n  }\n  .lg\\:hover\\:to-teal-200:hover {\n    --gradient-to-color: #afecef;\n  }\n  .lg\\:hover\\:to-teal-300:hover {\n    --gradient-to-color: #7edce2;\n  }\n  .lg\\:hover\\:to-teal-400:hover {\n    --gradient-to-color: #16bdca;\n  }\n  .lg\\:hover\\:to-teal-500:hover {\n    --gradient-to-color: #0694a2;\n  }\n  .lg\\:hover\\:to-teal-600:hover {\n    --gradient-to-color: #047481;\n  }\n  .lg\\:hover\\:to-teal-700:hover {\n    --gradient-to-color: #036672;\n  }\n  .lg\\:hover\\:to-teal-800:hover {\n    --gradient-to-color: #05505c;\n  }\n  .lg\\:hover\\:to-teal-900:hover {\n    --gradient-to-color: #014451;\n  }\n  .lg\\:hover\\:to-blue-50:hover {\n    --gradient-to-color: #ebf5ff;\n  }\n  .lg\\:hover\\:to-blue-100:hover {\n    --gradient-to-color: #e1effe;\n  }\n  .lg\\:hover\\:to-blue-200:hover {\n    --gradient-to-color: #c3ddfd;\n  }\n  .lg\\:hover\\:to-blue-300:hover {\n    --gradient-to-color: #a4cafe;\n  }\n  .lg\\:hover\\:to-blue-400:hover {\n    --gradient-to-color: #76a9fa;\n  }\n  .lg\\:hover\\:to-blue-500:hover {\n    --gradient-to-color: #3f83f8;\n  }\n  .lg\\:hover\\:to-blue-600:hover {\n    --gradient-to-color: #1c64f2;\n  }\n  .lg\\:hover\\:to-blue-700:hover {\n    --gradient-to-color: #1a56db;\n  }\n  .lg\\:hover\\:to-blue-800:hover {\n    --gradient-to-color: #1e429f;\n  }\n  .lg\\:hover\\:to-blue-900:hover {\n    --gradient-to-color: #233876;\n  }\n  .lg\\:hover\\:to-indigo-50:hover {\n    --gradient-to-color: #f0f5ff;\n  }\n  .lg\\:hover\\:to-indigo-100:hover {\n    --gradient-to-color: #e5edff;\n  }\n  .lg\\:hover\\:to-indigo-200:hover {\n    --gradient-to-color: #cddbfe;\n  }\n  .lg\\:hover\\:to-indigo-300:hover {\n    --gradient-to-color: #b4c6fc;\n  }\n  .lg\\:hover\\:to-indigo-400:hover {\n    --gradient-to-color: #8da2fb;\n  }\n  .lg\\:hover\\:to-indigo-500:hover {\n    --gradient-to-color: #6875f5;\n  }\n  .lg\\:hover\\:to-indigo-600:hover {\n    --gradient-to-color: #5850ec;\n  }\n  .lg\\:hover\\:to-indigo-700:hover {\n    --gradient-to-color: #5145cd;\n  }\n  .lg\\:hover\\:to-indigo-800:hover {\n    --gradient-to-color: #42389d;\n  }\n  .lg\\:hover\\:to-indigo-900:hover {\n    --gradient-to-color: #362f78;\n  }\n  .lg\\:hover\\:to-purple-50:hover {\n    --gradient-to-color: #f6f5ff;\n  }\n  .lg\\:hover\\:to-purple-100:hover {\n    --gradient-to-color: #edebfe;\n  }\n  .lg\\:hover\\:to-purple-200:hover {\n    --gradient-to-color: #dcd7fe;\n  }\n  .lg\\:hover\\:to-purple-300:hover {\n    --gradient-to-color: #cabffd;\n  }\n  .lg\\:hover\\:to-purple-400:hover {\n    --gradient-to-color: #ac94fa;\n  }\n  .lg\\:hover\\:to-purple-500:hover {\n    --gradient-to-color: #9061f9;\n  }\n  .lg\\:hover\\:to-purple-600:hover {\n    --gradient-to-color: #7e3af2;\n  }\n  .lg\\:hover\\:to-purple-700:hover {\n    --gradient-to-color: #6c2bd9;\n  }\n  .lg\\:hover\\:to-purple-800:hover {\n    --gradient-to-color: #5521b5;\n  }\n  .lg\\:hover\\:to-purple-900:hover {\n    --gradient-to-color: #4a1d96;\n  }\n  .lg\\:hover\\:to-pink-50:hover {\n    --gradient-to-color: #fdf2f8;\n  }\n  .lg\\:hover\\:to-pink-100:hover {\n    --gradient-to-color: #fce8f3;\n  }\n  .lg\\:hover\\:to-pink-200:hover {\n    --gradient-to-color: #fad1e8;\n  }\n  .lg\\:hover\\:to-pink-300:hover {\n    --gradient-to-color: #f8b4d9;\n  }\n  .lg\\:hover\\:to-pink-400:hover {\n    --gradient-to-color: #f17eb8;\n  }\n  .lg\\:hover\\:to-pink-500:hover {\n    --gradient-to-color: #e74694;\n  }\n  .lg\\:hover\\:to-pink-600:hover {\n    --gradient-to-color: #d61f69;\n  }\n  .lg\\:hover\\:to-pink-700:hover {\n    --gradient-to-color: #bf125d;\n  }\n  .lg\\:hover\\:to-pink-800:hover {\n    --gradient-to-color: #99154b;\n  }\n  .lg\\:hover\\:to-pink-900:hover {\n    --gradient-to-color: #751a3d;\n  }\n  .lg\\:hover\\:to-cool-gray-50:hover {\n    --gradient-to-color: #f8fafc;\n  }\n  .lg\\:hover\\:to-cool-gray-100:hover {\n    --gradient-to-color: #f1f5f9;\n  }\n  .lg\\:hover\\:to-cool-gray-200:hover {\n    --gradient-to-color: #e2e8f0;\n  }\n  .lg\\:hover\\:to-cool-gray-300:hover {\n    --gradient-to-color: #cfd8e3;\n  }\n  .lg\\:hover\\:to-cool-gray-400:hover {\n    --gradient-to-color: #97a6ba;\n  }\n  .lg\\:hover\\:to-cool-gray-500:hover {\n    --gradient-to-color: #64748b;\n  }\n  .lg\\:hover\\:to-cool-gray-600:hover {\n    --gradient-to-color: #475569;\n  }\n  .lg\\:hover\\:to-cool-gray-700:hover {\n    --gradient-to-color: #364152;\n  }\n  .lg\\:hover\\:to-cool-gray-800:hover {\n    --gradient-to-color: #27303f;\n  }\n  .lg\\:hover\\:to-cool-gray-900:hover {\n    --gradient-to-color: #1a202e;\n  }\n  .lg\\:focus\\:from-current:focus {\n    --gradient-from-color: currentColor;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));\n  }\n  .lg\\:focus\\:from-transparent:focus {\n    --gradient-from-color: transparent;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0));\n  }\n  .lg\\:focus\\:from-white:focus {\n    --gradient-from-color: #ffffff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));\n  }\n  .lg\\:focus\\:from-black:focus {\n    --gradient-from-color: #000000;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0));\n  }\n  .lg\\:focus\\:from-gray-50:focus {\n    --gradient-from-color: #f9fafb;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(249, 250, 251, 0));\n  }\n  .lg\\:focus\\:from-gray-100:focus {\n    --gradient-from-color: #f4f5f7;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(244, 245, 247, 0));\n  }\n  .lg\\:focus\\:from-gray-200:focus {\n    --gradient-from-color: #e5e7eb;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(229, 231, 235, 0));\n  }\n  .lg\\:focus\\:from-gray-300:focus {\n    --gradient-from-color: #d2d6dc;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(210, 214, 220, 0));\n  }\n  .lg\\:focus\\:from-gray-400:focus {\n    --gradient-from-color: #9fa6b2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(159, 166, 178, 0));\n  }\n  .lg\\:focus\\:from-gray-500:focus {\n    --gradient-from-color: #6b7280;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(107, 114, 128, 0));\n  }\n  .lg\\:focus\\:from-gray-600:focus {\n    --gradient-from-color: #4b5563;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(75, 85, 99, 0));\n  }\n  .lg\\:focus\\:from-gray-700:focus {\n    --gradient-from-color: #374151;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(55, 65, 81, 0));\n  }\n  .lg\\:focus\\:from-gray-800:focus {\n    --gradient-from-color: #252f3f;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(37, 47, 63, 0));\n  }\n  .lg\\:focus\\:from-gray-900:focus {\n    --gradient-from-color: #161e2e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(22, 30, 46, 0));\n  }\n  .lg\\:focus\\:from-red-50:focus {\n    --gradient-from-color: #fdf2f2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 242, 242, 0));\n  }\n  .lg\\:focus\\:from-red-100:focus {\n    --gradient-from-color: #fde8e8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 232, 232, 0));\n  }\n  .lg\\:focus\\:from-red-200:focus {\n    --gradient-from-color: #fbd5d5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(251, 213, 213, 0));\n  }\n  .lg\\:focus\\:from-red-300:focus {\n    --gradient-from-color: #f8b4b4;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(248, 180, 180, 0));\n  }\n  .lg\\:focus\\:from-red-400:focus {\n    --gradient-from-color: #f98080;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(249, 128, 128, 0));\n  }\n  .lg\\:focus\\:from-red-500:focus {\n    --gradient-from-color: #f05252;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(240, 82, 82, 0));\n  }\n  .lg\\:focus\\:from-red-600:focus {\n    --gradient-from-color: #e02424;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(224, 36, 36, 0));\n  }\n  .lg\\:focus\\:from-red-700:focus {\n    --gradient-from-color: #c81e1e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(200, 30, 30, 0));\n  }\n  .lg\\:focus\\:from-red-800:focus {\n    --gradient-from-color: #9b1c1c;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(155, 28, 28, 0));\n  }\n  .lg\\:focus\\:from-red-900:focus {\n    --gradient-from-color: #771d1d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(119, 29, 29, 0));\n  }\n  .lg\\:focus\\:from-orange-50:focus {\n    --gradient-from-color: #fff8f1;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 248, 241, 0));\n  }\n  .lg\\:focus\\:from-orange-100:focus {\n    --gradient-from-color: #feecdc;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 236, 220, 0));\n  }\n  .lg\\:focus\\:from-orange-200:focus {\n    --gradient-from-color: #fcd9bd;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(252, 217, 189, 0));\n  }\n  .lg\\:focus\\:from-orange-300:focus {\n    --gradient-from-color: #fdba8c;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 186, 140, 0));\n  }\n  .lg\\:focus\\:from-orange-400:focus {\n    --gradient-from-color: #ff8a4c;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 138, 76, 0));\n  }\n  .lg\\:focus\\:from-orange-500:focus {\n    --gradient-from-color: #ff5a1f;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 90, 31, 0));\n  }\n  .lg\\:focus\\:from-orange-600:focus {\n    --gradient-from-color: #d03801;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(208, 56, 1, 0));\n  }\n  .lg\\:focus\\:from-orange-700:focus {\n    --gradient-from-color: #b43403;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(180, 52, 3, 0));\n  }\n  .lg\\:focus\\:from-orange-800:focus {\n    --gradient-from-color: #8a2c0d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(138, 44, 13, 0));\n  }\n  .lg\\:focus\\:from-orange-900:focus {\n    --gradient-from-color: #73230d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(115, 35, 13, 0));\n  }\n  .lg\\:focus\\:from-yellow-50:focus {\n    --gradient-from-color: #fdfdea;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 253, 234, 0));\n  }\n  .lg\\:focus\\:from-yellow-100:focus {\n    --gradient-from-color: #fdf6b2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 246, 178, 0));\n  }\n  .lg\\:focus\\:from-yellow-200:focus {\n    --gradient-from-color: #fce96a;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(252, 233, 106, 0));\n  }\n  .lg\\:focus\\:from-yellow-300:focus {\n    --gradient-from-color: #faca15;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(250, 202, 21, 0));\n  }\n  .lg\\:focus\\:from-yellow-400:focus {\n    --gradient-from-color: #e3a008;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(227, 160, 8, 0));\n  }\n  .lg\\:focus\\:from-yellow-500:focus {\n    --gradient-from-color: #c27803;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(194, 120, 3, 0));\n  }\n  .lg\\:focus\\:from-yellow-600:focus {\n    --gradient-from-color: #9f580a;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(159, 88, 10, 0));\n  }\n  .lg\\:focus\\:from-yellow-700:focus {\n    --gradient-from-color: #8e4b10;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(142, 75, 16, 0));\n  }\n  .lg\\:focus\\:from-yellow-800:focus {\n    --gradient-from-color: #723b13;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(114, 59, 19, 0));\n  }\n  .lg\\:focus\\:from-yellow-900:focus {\n    --gradient-from-color: #633112;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(99, 49, 18, 0));\n  }\n  .lg\\:focus\\:from-green-50:focus {\n    --gradient-from-color: #f3faf7;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(243, 250, 247, 0));\n  }\n  .lg\\:focus\\:from-green-100:focus {\n    --gradient-from-color: #def7ec;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(222, 247, 236, 0));\n  }\n  .lg\\:focus\\:from-green-200:focus {\n    --gradient-from-color: #bcf0da;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(188, 240, 218, 0));\n  }\n  .lg\\:focus\\:from-green-300:focus {\n    --gradient-from-color: #84e1bc;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(132, 225, 188, 0));\n  }\n  .lg\\:focus\\:from-green-400:focus {\n    --gradient-from-color: #31c48d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(49, 196, 141, 0));\n  }\n  .lg\\:focus\\:from-green-500:focus {\n    --gradient-from-color: #0e9f6e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(14, 159, 110, 0));\n  }\n  .lg\\:focus\\:from-green-600:focus {\n    --gradient-from-color: #057a55;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(5, 122, 85, 0));\n  }\n  .lg\\:focus\\:from-green-700:focus {\n    --gradient-from-color: #046c4e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(4, 108, 78, 0));\n  }\n  .lg\\:focus\\:from-green-800:focus {\n    --gradient-from-color: #03543f;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(3, 84, 63, 0));\n  }\n  .lg\\:focus\\:from-green-900:focus {\n    --gradient-from-color: #014737;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(1, 71, 55, 0));\n  }\n  .lg\\:focus\\:from-teal-50:focus {\n    --gradient-from-color: #edfafa;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(237, 250, 250, 0));\n  }\n  .lg\\:focus\\:from-teal-100:focus {\n    --gradient-from-color: #d5f5f6;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(213, 245, 246, 0));\n  }\n  .lg\\:focus\\:from-teal-200:focus {\n    --gradient-from-color: #afecef;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(175, 236, 239, 0));\n  }\n  .lg\\:focus\\:from-teal-300:focus {\n    --gradient-from-color: #7edce2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(126, 220, 226, 0));\n  }\n  .lg\\:focus\\:from-teal-400:focus {\n    --gradient-from-color: #16bdca;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(22, 189, 202, 0));\n  }\n  .lg\\:focus\\:from-teal-500:focus {\n    --gradient-from-color: #0694a2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(6, 148, 162, 0));\n  }\n  .lg\\:focus\\:from-teal-600:focus {\n    --gradient-from-color: #047481;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(4, 116, 129, 0));\n  }\n  .lg\\:focus\\:from-teal-700:focus {\n    --gradient-from-color: #036672;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(3, 102, 114, 0));\n  }\n  .lg\\:focus\\:from-teal-800:focus {\n    --gradient-from-color: #05505c;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(5, 80, 92, 0));\n  }\n  .lg\\:focus\\:from-teal-900:focus {\n    --gradient-from-color: #014451;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(1, 68, 81, 0));\n  }\n  .lg\\:focus\\:from-blue-50:focus {\n    --gradient-from-color: #ebf5ff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(235, 245, 255, 0));\n  }\n  .lg\\:focus\\:from-blue-100:focus {\n    --gradient-from-color: #e1effe;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(225, 239, 254, 0));\n  }\n  .lg\\:focus\\:from-blue-200:focus {\n    --gradient-from-color: #c3ddfd;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(195, 221, 253, 0));\n  }\n  .lg\\:focus\\:from-blue-300:focus {\n    --gradient-from-color: #a4cafe;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(164, 202, 254, 0));\n  }\n  .lg\\:focus\\:from-blue-400:focus {\n    --gradient-from-color: #76a9fa;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(118, 169, 250, 0));\n  }\n  .lg\\:focus\\:from-blue-500:focus {\n    --gradient-from-color: #3f83f8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(63, 131, 248, 0));\n  }\n  .lg\\:focus\\:from-blue-600:focus {\n    --gradient-from-color: #1c64f2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(28, 100, 242, 0));\n  }\n  .lg\\:focus\\:from-blue-700:focus {\n    --gradient-from-color: #1a56db;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(26, 86, 219, 0));\n  }\n  .lg\\:focus\\:from-blue-800:focus {\n    --gradient-from-color: #1e429f;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(30, 66, 159, 0));\n  }\n  .lg\\:focus\\:from-blue-900:focus {\n    --gradient-from-color: #233876;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(35, 56, 118, 0));\n  }\n  .lg\\:focus\\:from-indigo-50:focus {\n    --gradient-from-color: #f0f5ff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(240, 245, 255, 0));\n  }\n  .lg\\:focus\\:from-indigo-100:focus {\n    --gradient-from-color: #e5edff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(229, 237, 255, 0));\n  }\n  .lg\\:focus\\:from-indigo-200:focus {\n    --gradient-from-color: #cddbfe;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(205, 219, 254, 0));\n  }\n  .lg\\:focus\\:from-indigo-300:focus {\n    --gradient-from-color: #b4c6fc;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(180, 198, 252, 0));\n  }\n  .lg\\:focus\\:from-indigo-400:focus {\n    --gradient-from-color: #8da2fb;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(141, 162, 251, 0));\n  }\n  .lg\\:focus\\:from-indigo-500:focus {\n    --gradient-from-color: #6875f5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(104, 117, 245, 0));\n  }\n  .lg\\:focus\\:from-indigo-600:focus {\n    --gradient-from-color: #5850ec;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(88, 80, 236, 0));\n  }\n  .lg\\:focus\\:from-indigo-700:focus {\n    --gradient-from-color: #5145cd;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(81, 69, 205, 0));\n  }\n  .lg\\:focus\\:from-indigo-800:focus {\n    --gradient-from-color: #42389d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(66, 56, 157, 0));\n  }\n  .lg\\:focus\\:from-indigo-900:focus {\n    --gradient-from-color: #362f78;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(54, 47, 120, 0));\n  }\n  .lg\\:focus\\:from-purple-50:focus {\n    --gradient-from-color: #f6f5ff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(246, 245, 255, 0));\n  }\n  .lg\\:focus\\:from-purple-100:focus {\n    --gradient-from-color: #edebfe;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(237, 235, 254, 0));\n  }\n  .lg\\:focus\\:from-purple-200:focus {\n    --gradient-from-color: #dcd7fe;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(220, 215, 254, 0));\n  }\n  .lg\\:focus\\:from-purple-300:focus {\n    --gradient-from-color: #cabffd;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(202, 191, 253, 0));\n  }\n  .lg\\:focus\\:from-purple-400:focus {\n    --gradient-from-color: #ac94fa;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(172, 148, 250, 0));\n  }\n  .lg\\:focus\\:from-purple-500:focus {\n    --gradient-from-color: #9061f9;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(144, 97, 249, 0));\n  }\n  .lg\\:focus\\:from-purple-600:focus {\n    --gradient-from-color: #7e3af2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(126, 58, 242, 0));\n  }\n  .lg\\:focus\\:from-purple-700:focus {\n    --gradient-from-color: #6c2bd9;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(108, 43, 217, 0));\n  }\n  .lg\\:focus\\:from-purple-800:focus {\n    --gradient-from-color: #5521b5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(85, 33, 181, 0));\n  }\n  .lg\\:focus\\:from-purple-900:focus {\n    --gradient-from-color: #4a1d96;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(74, 29, 150, 0));\n  }\n  .lg\\:focus\\:from-pink-50:focus {\n    --gradient-from-color: #fdf2f8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 242, 248, 0));\n  }\n  .lg\\:focus\\:from-pink-100:focus {\n    --gradient-from-color: #fce8f3;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(252, 232, 243, 0));\n  }\n  .lg\\:focus\\:from-pink-200:focus {\n    --gradient-from-color: #fad1e8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(250, 209, 232, 0));\n  }\n  .lg\\:focus\\:from-pink-300:focus {\n    --gradient-from-color: #f8b4d9;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(248, 180, 217, 0));\n  }\n  .lg\\:focus\\:from-pink-400:focus {\n    --gradient-from-color: #f17eb8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(241, 126, 184, 0));\n  }\n  .lg\\:focus\\:from-pink-500:focus {\n    --gradient-from-color: #e74694;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(231, 70, 148, 0));\n  }\n  .lg\\:focus\\:from-pink-600:focus {\n    --gradient-from-color: #d61f69;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(214, 31, 105, 0));\n  }\n  .lg\\:focus\\:from-pink-700:focus {\n    --gradient-from-color: #bf125d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(191, 18, 93, 0));\n  }\n  .lg\\:focus\\:from-pink-800:focus {\n    --gradient-from-color: #99154b;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(153, 21, 75, 0));\n  }\n  .lg\\:focus\\:from-pink-900:focus {\n    --gradient-from-color: #751a3d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(117, 26, 61, 0));\n  }\n  .lg\\:focus\\:from-cool-gray-50:focus {\n    --gradient-from-color: #f8fafc;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(248, 250, 252, 0));\n  }\n  .lg\\:focus\\:from-cool-gray-100:focus {\n    --gradient-from-color: #f1f5f9;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(241, 245, 249, 0));\n  }\n  .lg\\:focus\\:from-cool-gray-200:focus {\n    --gradient-from-color: #e2e8f0;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(226, 232, 240, 0));\n  }\n  .lg\\:focus\\:from-cool-gray-300:focus {\n    --gradient-from-color: #cfd8e3;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(207, 216, 227, 0));\n  }\n  .lg\\:focus\\:from-cool-gray-400:focus {\n    --gradient-from-color: #97a6ba;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(151, 166, 186, 0));\n  }\n  .lg\\:focus\\:from-cool-gray-500:focus {\n    --gradient-from-color: #64748b;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(100, 116, 139, 0));\n  }\n  .lg\\:focus\\:from-cool-gray-600:focus {\n    --gradient-from-color: #475569;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(71, 85, 105, 0));\n  }\n  .lg\\:focus\\:from-cool-gray-700:focus {\n    --gradient-from-color: #364152;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(54, 65, 82, 0));\n  }\n  .lg\\:focus\\:from-cool-gray-800:focus {\n    --gradient-from-color: #27303f;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(39, 48, 63, 0));\n  }\n  .lg\\:focus\\:from-cool-gray-900:focus {\n    --gradient-from-color: #1a202e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(26, 32, 46, 0));\n  }\n  .lg\\:focus\\:via-current:focus {\n    --gradient-via-color: currentColor;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));\n  }\n  .lg\\:focus\\:via-transparent:focus {\n    --gradient-via-color: transparent;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0));\n  }\n  .lg\\:focus\\:via-white:focus {\n    --gradient-via-color: #ffffff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));\n  }\n  .lg\\:focus\\:via-black:focus {\n    --gradient-via-color: #000000;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0));\n  }\n  .lg\\:focus\\:via-gray-50:focus {\n    --gradient-via-color: #f9fafb;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(249, 250, 251, 0));\n  }\n  .lg\\:focus\\:via-gray-100:focus {\n    --gradient-via-color: #f4f5f7;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(244, 245, 247, 0));\n  }\n  .lg\\:focus\\:via-gray-200:focus {\n    --gradient-via-color: #e5e7eb;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(229, 231, 235, 0));\n  }\n  .lg\\:focus\\:via-gray-300:focus {\n    --gradient-via-color: #d2d6dc;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(210, 214, 220, 0));\n  }\n  .lg\\:focus\\:via-gray-400:focus {\n    --gradient-via-color: #9fa6b2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(159, 166, 178, 0));\n  }\n  .lg\\:focus\\:via-gray-500:focus {\n    --gradient-via-color: #6b7280;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(107, 114, 128, 0));\n  }\n  .lg\\:focus\\:via-gray-600:focus {\n    --gradient-via-color: #4b5563;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(75, 85, 99, 0));\n  }\n  .lg\\:focus\\:via-gray-700:focus {\n    --gradient-via-color: #374151;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(55, 65, 81, 0));\n  }\n  .lg\\:focus\\:via-gray-800:focus {\n    --gradient-via-color: #252f3f;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(37, 47, 63, 0));\n  }\n  .lg\\:focus\\:via-gray-900:focus {\n    --gradient-via-color: #161e2e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(22, 30, 46, 0));\n  }\n  .lg\\:focus\\:via-red-50:focus {\n    --gradient-via-color: #fdf2f2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 242, 242, 0));\n  }\n  .lg\\:focus\\:via-red-100:focus {\n    --gradient-via-color: #fde8e8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 232, 232, 0));\n  }\n  .lg\\:focus\\:via-red-200:focus {\n    --gradient-via-color: #fbd5d5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(251, 213, 213, 0));\n  }\n  .lg\\:focus\\:via-red-300:focus {\n    --gradient-via-color: #f8b4b4;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(248, 180, 180, 0));\n  }\n  .lg\\:focus\\:via-red-400:focus {\n    --gradient-via-color: #f98080;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(249, 128, 128, 0));\n  }\n  .lg\\:focus\\:via-red-500:focus {\n    --gradient-via-color: #f05252;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(240, 82, 82, 0));\n  }\n  .lg\\:focus\\:via-red-600:focus {\n    --gradient-via-color: #e02424;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(224, 36, 36, 0));\n  }\n  .lg\\:focus\\:via-red-700:focus {\n    --gradient-via-color: #c81e1e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(200, 30, 30, 0));\n  }\n  .lg\\:focus\\:via-red-800:focus {\n    --gradient-via-color: #9b1c1c;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(155, 28, 28, 0));\n  }\n  .lg\\:focus\\:via-red-900:focus {\n    --gradient-via-color: #771d1d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(119, 29, 29, 0));\n  }\n  .lg\\:focus\\:via-orange-50:focus {\n    --gradient-via-color: #fff8f1;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 248, 241, 0));\n  }\n  .lg\\:focus\\:via-orange-100:focus {\n    --gradient-via-color: #feecdc;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 236, 220, 0));\n  }\n  .lg\\:focus\\:via-orange-200:focus {\n    --gradient-via-color: #fcd9bd;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(252, 217, 189, 0));\n  }\n  .lg\\:focus\\:via-orange-300:focus {\n    --gradient-via-color: #fdba8c;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 186, 140, 0));\n  }\n  .lg\\:focus\\:via-orange-400:focus {\n    --gradient-via-color: #ff8a4c;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 138, 76, 0));\n  }\n  .lg\\:focus\\:via-orange-500:focus {\n    --gradient-via-color: #ff5a1f;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 90, 31, 0));\n  }\n  .lg\\:focus\\:via-orange-600:focus {\n    --gradient-via-color: #d03801;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(208, 56, 1, 0));\n  }\n  .lg\\:focus\\:via-orange-700:focus {\n    --gradient-via-color: #b43403;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(180, 52, 3, 0));\n  }\n  .lg\\:focus\\:via-orange-800:focus {\n    --gradient-via-color: #8a2c0d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(138, 44, 13, 0));\n  }\n  .lg\\:focus\\:via-orange-900:focus {\n    --gradient-via-color: #73230d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(115, 35, 13, 0));\n  }\n  .lg\\:focus\\:via-yellow-50:focus {\n    --gradient-via-color: #fdfdea;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 253, 234, 0));\n  }\n  .lg\\:focus\\:via-yellow-100:focus {\n    --gradient-via-color: #fdf6b2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 246, 178, 0));\n  }\n  .lg\\:focus\\:via-yellow-200:focus {\n    --gradient-via-color: #fce96a;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(252, 233, 106, 0));\n  }\n  .lg\\:focus\\:via-yellow-300:focus {\n    --gradient-via-color: #faca15;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(250, 202, 21, 0));\n  }\n  .lg\\:focus\\:via-yellow-400:focus {\n    --gradient-via-color: #e3a008;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(227, 160, 8, 0));\n  }\n  .lg\\:focus\\:via-yellow-500:focus {\n    --gradient-via-color: #c27803;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(194, 120, 3, 0));\n  }\n  .lg\\:focus\\:via-yellow-600:focus {\n    --gradient-via-color: #9f580a;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(159, 88, 10, 0));\n  }\n  .lg\\:focus\\:via-yellow-700:focus {\n    --gradient-via-color: #8e4b10;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(142, 75, 16, 0));\n  }\n  .lg\\:focus\\:via-yellow-800:focus {\n    --gradient-via-color: #723b13;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(114, 59, 19, 0));\n  }\n  .lg\\:focus\\:via-yellow-900:focus {\n    --gradient-via-color: #633112;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(99, 49, 18, 0));\n  }\n  .lg\\:focus\\:via-green-50:focus {\n    --gradient-via-color: #f3faf7;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(243, 250, 247, 0));\n  }\n  .lg\\:focus\\:via-green-100:focus {\n    --gradient-via-color: #def7ec;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(222, 247, 236, 0));\n  }\n  .lg\\:focus\\:via-green-200:focus {\n    --gradient-via-color: #bcf0da;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(188, 240, 218, 0));\n  }\n  .lg\\:focus\\:via-green-300:focus {\n    --gradient-via-color: #84e1bc;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(132, 225, 188, 0));\n  }\n  .lg\\:focus\\:via-green-400:focus {\n    --gradient-via-color: #31c48d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(49, 196, 141, 0));\n  }\n  .lg\\:focus\\:via-green-500:focus {\n    --gradient-via-color: #0e9f6e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(14, 159, 110, 0));\n  }\n  .lg\\:focus\\:via-green-600:focus {\n    --gradient-via-color: #057a55;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(5, 122, 85, 0));\n  }\n  .lg\\:focus\\:via-green-700:focus {\n    --gradient-via-color: #046c4e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(4, 108, 78, 0));\n  }\n  .lg\\:focus\\:via-green-800:focus {\n    --gradient-via-color: #03543f;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(3, 84, 63, 0));\n  }\n  .lg\\:focus\\:via-green-900:focus {\n    --gradient-via-color: #014737;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(1, 71, 55, 0));\n  }\n  .lg\\:focus\\:via-teal-50:focus {\n    --gradient-via-color: #edfafa;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(237, 250, 250, 0));\n  }\n  .lg\\:focus\\:via-teal-100:focus {\n    --gradient-via-color: #d5f5f6;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(213, 245, 246, 0));\n  }\n  .lg\\:focus\\:via-teal-200:focus {\n    --gradient-via-color: #afecef;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(175, 236, 239, 0));\n  }\n  .lg\\:focus\\:via-teal-300:focus {\n    --gradient-via-color: #7edce2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(126, 220, 226, 0));\n  }\n  .lg\\:focus\\:via-teal-400:focus {\n    --gradient-via-color: #16bdca;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(22, 189, 202, 0));\n  }\n  .lg\\:focus\\:via-teal-500:focus {\n    --gradient-via-color: #0694a2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(6, 148, 162, 0));\n  }\n  .lg\\:focus\\:via-teal-600:focus {\n    --gradient-via-color: #047481;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(4, 116, 129, 0));\n  }\n  .lg\\:focus\\:via-teal-700:focus {\n    --gradient-via-color: #036672;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(3, 102, 114, 0));\n  }\n  .lg\\:focus\\:via-teal-800:focus {\n    --gradient-via-color: #05505c;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(5, 80, 92, 0));\n  }\n  .lg\\:focus\\:via-teal-900:focus {\n    --gradient-via-color: #014451;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(1, 68, 81, 0));\n  }\n  .lg\\:focus\\:via-blue-50:focus {\n    --gradient-via-color: #ebf5ff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(235, 245, 255, 0));\n  }\n  .lg\\:focus\\:via-blue-100:focus {\n    --gradient-via-color: #e1effe;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(225, 239, 254, 0));\n  }\n  .lg\\:focus\\:via-blue-200:focus {\n    --gradient-via-color: #c3ddfd;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(195, 221, 253, 0));\n  }\n  .lg\\:focus\\:via-blue-300:focus {\n    --gradient-via-color: #a4cafe;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(164, 202, 254, 0));\n  }\n  .lg\\:focus\\:via-blue-400:focus {\n    --gradient-via-color: #76a9fa;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(118, 169, 250, 0));\n  }\n  .lg\\:focus\\:via-blue-500:focus {\n    --gradient-via-color: #3f83f8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(63, 131, 248, 0));\n  }\n  .lg\\:focus\\:via-blue-600:focus {\n    --gradient-via-color: #1c64f2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(28, 100, 242, 0));\n  }\n  .lg\\:focus\\:via-blue-700:focus {\n    --gradient-via-color: #1a56db;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(26, 86, 219, 0));\n  }\n  .lg\\:focus\\:via-blue-800:focus {\n    --gradient-via-color: #1e429f;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(30, 66, 159, 0));\n  }\n  .lg\\:focus\\:via-blue-900:focus {\n    --gradient-via-color: #233876;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(35, 56, 118, 0));\n  }\n  .lg\\:focus\\:via-indigo-50:focus {\n    --gradient-via-color: #f0f5ff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(240, 245, 255, 0));\n  }\n  .lg\\:focus\\:via-indigo-100:focus {\n    --gradient-via-color: #e5edff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(229, 237, 255, 0));\n  }\n  .lg\\:focus\\:via-indigo-200:focus {\n    --gradient-via-color: #cddbfe;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(205, 219, 254, 0));\n  }\n  .lg\\:focus\\:via-indigo-300:focus {\n    --gradient-via-color: #b4c6fc;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(180, 198, 252, 0));\n  }\n  .lg\\:focus\\:via-indigo-400:focus {\n    --gradient-via-color: #8da2fb;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(141, 162, 251, 0));\n  }\n  .lg\\:focus\\:via-indigo-500:focus {\n    --gradient-via-color: #6875f5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(104, 117, 245, 0));\n  }\n  .lg\\:focus\\:via-indigo-600:focus {\n    --gradient-via-color: #5850ec;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(88, 80, 236, 0));\n  }\n  .lg\\:focus\\:via-indigo-700:focus {\n    --gradient-via-color: #5145cd;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(81, 69, 205, 0));\n  }\n  .lg\\:focus\\:via-indigo-800:focus {\n    --gradient-via-color: #42389d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(66, 56, 157, 0));\n  }\n  .lg\\:focus\\:via-indigo-900:focus {\n    --gradient-via-color: #362f78;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(54, 47, 120, 0));\n  }\n  .lg\\:focus\\:via-purple-50:focus {\n    --gradient-via-color: #f6f5ff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(246, 245, 255, 0));\n  }\n  .lg\\:focus\\:via-purple-100:focus {\n    --gradient-via-color: #edebfe;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(237, 235, 254, 0));\n  }\n  .lg\\:focus\\:via-purple-200:focus {\n    --gradient-via-color: #dcd7fe;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(220, 215, 254, 0));\n  }\n  .lg\\:focus\\:via-purple-300:focus {\n    --gradient-via-color: #cabffd;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(202, 191, 253, 0));\n  }\n  .lg\\:focus\\:via-purple-400:focus {\n    --gradient-via-color: #ac94fa;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(172, 148, 250, 0));\n  }\n  .lg\\:focus\\:via-purple-500:focus {\n    --gradient-via-color: #9061f9;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(144, 97, 249, 0));\n  }\n  .lg\\:focus\\:via-purple-600:focus {\n    --gradient-via-color: #7e3af2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(126, 58, 242, 0));\n  }\n  .lg\\:focus\\:via-purple-700:focus {\n    --gradient-via-color: #6c2bd9;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(108, 43, 217, 0));\n  }\n  .lg\\:focus\\:via-purple-800:focus {\n    --gradient-via-color: #5521b5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(85, 33, 181, 0));\n  }\n  .lg\\:focus\\:via-purple-900:focus {\n    --gradient-via-color: #4a1d96;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(74, 29, 150, 0));\n  }\n  .lg\\:focus\\:via-pink-50:focus {\n    --gradient-via-color: #fdf2f8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 242, 248, 0));\n  }\n  .lg\\:focus\\:via-pink-100:focus {\n    --gradient-via-color: #fce8f3;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(252, 232, 243, 0));\n  }\n  .lg\\:focus\\:via-pink-200:focus {\n    --gradient-via-color: #fad1e8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(250, 209, 232, 0));\n  }\n  .lg\\:focus\\:via-pink-300:focus {\n    --gradient-via-color: #f8b4d9;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(248, 180, 217, 0));\n  }\n  .lg\\:focus\\:via-pink-400:focus {\n    --gradient-via-color: #f17eb8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(241, 126, 184, 0));\n  }\n  .lg\\:focus\\:via-pink-500:focus {\n    --gradient-via-color: #e74694;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(231, 70, 148, 0));\n  }\n  .lg\\:focus\\:via-pink-600:focus {\n    --gradient-via-color: #d61f69;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(214, 31, 105, 0));\n  }\n  .lg\\:focus\\:via-pink-700:focus {\n    --gradient-via-color: #bf125d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(191, 18, 93, 0));\n  }\n  .lg\\:focus\\:via-pink-800:focus {\n    --gradient-via-color: #99154b;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(153, 21, 75, 0));\n  }\n  .lg\\:focus\\:via-pink-900:focus {\n    --gradient-via-color: #751a3d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(117, 26, 61, 0));\n  }\n  .lg\\:focus\\:via-cool-gray-50:focus {\n    --gradient-via-color: #f8fafc;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(248, 250, 252, 0));\n  }\n  .lg\\:focus\\:via-cool-gray-100:focus {\n    --gradient-via-color: #f1f5f9;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(241, 245, 249, 0));\n  }\n  .lg\\:focus\\:via-cool-gray-200:focus {\n    --gradient-via-color: #e2e8f0;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(226, 232, 240, 0));\n  }\n  .lg\\:focus\\:via-cool-gray-300:focus {\n    --gradient-via-color: #cfd8e3;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(207, 216, 227, 0));\n  }\n  .lg\\:focus\\:via-cool-gray-400:focus {\n    --gradient-via-color: #97a6ba;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(151, 166, 186, 0));\n  }\n  .lg\\:focus\\:via-cool-gray-500:focus {\n    --gradient-via-color: #64748b;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(100, 116, 139, 0));\n  }\n  .lg\\:focus\\:via-cool-gray-600:focus {\n    --gradient-via-color: #475569;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(71, 85, 105, 0));\n  }\n  .lg\\:focus\\:via-cool-gray-700:focus {\n    --gradient-via-color: #364152;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(54, 65, 82, 0));\n  }\n  .lg\\:focus\\:via-cool-gray-800:focus {\n    --gradient-via-color: #27303f;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(39, 48, 63, 0));\n  }\n  .lg\\:focus\\:via-cool-gray-900:focus {\n    --gradient-via-color: #1a202e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(26, 32, 46, 0));\n  }\n  .lg\\:focus\\:to-current:focus {\n    --gradient-to-color: currentColor;\n  }\n  .lg\\:focus\\:to-transparent:focus {\n    --gradient-to-color: transparent;\n  }\n  .lg\\:focus\\:to-white:focus {\n    --gradient-to-color: #ffffff;\n  }\n  .lg\\:focus\\:to-black:focus {\n    --gradient-to-color: #000000;\n  }\n  .lg\\:focus\\:to-gray-50:focus {\n    --gradient-to-color: #f9fafb;\n  }\n  .lg\\:focus\\:to-gray-100:focus {\n    --gradient-to-color: #f4f5f7;\n  }\n  .lg\\:focus\\:to-gray-200:focus {\n    --gradient-to-color: #e5e7eb;\n  }\n  .lg\\:focus\\:to-gray-300:focus {\n    --gradient-to-color: #d2d6dc;\n  }\n  .lg\\:focus\\:to-gray-400:focus {\n    --gradient-to-color: #9fa6b2;\n  }\n  .lg\\:focus\\:to-gray-500:focus {\n    --gradient-to-color: #6b7280;\n  }\n  .lg\\:focus\\:to-gray-600:focus {\n    --gradient-to-color: #4b5563;\n  }\n  .lg\\:focus\\:to-gray-700:focus {\n    --gradient-to-color: #374151;\n  }\n  .lg\\:focus\\:to-gray-800:focus {\n    --gradient-to-color: #252f3f;\n  }\n  .lg\\:focus\\:to-gray-900:focus {\n    --gradient-to-color: #161e2e;\n  }\n  .lg\\:focus\\:to-red-50:focus {\n    --gradient-to-color: #fdf2f2;\n  }\n  .lg\\:focus\\:to-red-100:focus {\n    --gradient-to-color: #fde8e8;\n  }\n  .lg\\:focus\\:to-red-200:focus {\n    --gradient-to-color: #fbd5d5;\n  }\n  .lg\\:focus\\:to-red-300:focus {\n    --gradient-to-color: #f8b4b4;\n  }\n  .lg\\:focus\\:to-red-400:focus {\n    --gradient-to-color: #f98080;\n  }\n  .lg\\:focus\\:to-red-500:focus {\n    --gradient-to-color: #f05252;\n  }\n  .lg\\:focus\\:to-red-600:focus {\n    --gradient-to-color: #e02424;\n  }\n  .lg\\:focus\\:to-red-700:focus {\n    --gradient-to-color: #c81e1e;\n  }\n  .lg\\:focus\\:to-red-800:focus {\n    --gradient-to-color: #9b1c1c;\n  }\n  .lg\\:focus\\:to-red-900:focus {\n    --gradient-to-color: #771d1d;\n  }\n  .lg\\:focus\\:to-orange-50:focus {\n    --gradient-to-color: #fff8f1;\n  }\n  .lg\\:focus\\:to-orange-100:focus {\n    --gradient-to-color: #feecdc;\n  }\n  .lg\\:focus\\:to-orange-200:focus {\n    --gradient-to-color: #fcd9bd;\n  }\n  .lg\\:focus\\:to-orange-300:focus {\n    --gradient-to-color: #fdba8c;\n  }\n  .lg\\:focus\\:to-orange-400:focus {\n    --gradient-to-color: #ff8a4c;\n  }\n  .lg\\:focus\\:to-orange-500:focus {\n    --gradient-to-color: #ff5a1f;\n  }\n  .lg\\:focus\\:to-orange-600:focus {\n    --gradient-to-color: #d03801;\n  }\n  .lg\\:focus\\:to-orange-700:focus {\n    --gradient-to-color: #b43403;\n  }\n  .lg\\:focus\\:to-orange-800:focus {\n    --gradient-to-color: #8a2c0d;\n  }\n  .lg\\:focus\\:to-orange-900:focus {\n    --gradient-to-color: #73230d;\n  }\n  .lg\\:focus\\:to-yellow-50:focus {\n    --gradient-to-color: #fdfdea;\n  }\n  .lg\\:focus\\:to-yellow-100:focus {\n    --gradient-to-color: #fdf6b2;\n  }\n  .lg\\:focus\\:to-yellow-200:focus {\n    --gradient-to-color: #fce96a;\n  }\n  .lg\\:focus\\:to-yellow-300:focus {\n    --gradient-to-color: #faca15;\n  }\n  .lg\\:focus\\:to-yellow-400:focus {\n    --gradient-to-color: #e3a008;\n  }\n  .lg\\:focus\\:to-yellow-500:focus {\n    --gradient-to-color: #c27803;\n  }\n  .lg\\:focus\\:to-yellow-600:focus {\n    --gradient-to-color: #9f580a;\n  }\n  .lg\\:focus\\:to-yellow-700:focus {\n    --gradient-to-color: #8e4b10;\n  }\n  .lg\\:focus\\:to-yellow-800:focus {\n    --gradient-to-color: #723b13;\n  }\n  .lg\\:focus\\:to-yellow-900:focus {\n    --gradient-to-color: #633112;\n  }\n  .lg\\:focus\\:to-green-50:focus {\n    --gradient-to-color: #f3faf7;\n  }\n  .lg\\:focus\\:to-green-100:focus {\n    --gradient-to-color: #def7ec;\n  }\n  .lg\\:focus\\:to-green-200:focus {\n    --gradient-to-color: #bcf0da;\n  }\n  .lg\\:focus\\:to-green-300:focus {\n    --gradient-to-color: #84e1bc;\n  }\n  .lg\\:focus\\:to-green-400:focus {\n    --gradient-to-color: #31c48d;\n  }\n  .lg\\:focus\\:to-green-500:focus {\n    --gradient-to-color: #0e9f6e;\n  }\n  .lg\\:focus\\:to-green-600:focus {\n    --gradient-to-color: #057a55;\n  }\n  .lg\\:focus\\:to-green-700:focus {\n    --gradient-to-color: #046c4e;\n  }\n  .lg\\:focus\\:to-green-800:focus {\n    --gradient-to-color: #03543f;\n  }\n  .lg\\:focus\\:to-green-900:focus {\n    --gradient-to-color: #014737;\n  }\n  .lg\\:focus\\:to-teal-50:focus {\n    --gradient-to-color: #edfafa;\n  }\n  .lg\\:focus\\:to-teal-100:focus {\n    --gradient-to-color: #d5f5f6;\n  }\n  .lg\\:focus\\:to-teal-200:focus {\n    --gradient-to-color: #afecef;\n  }\n  .lg\\:focus\\:to-teal-300:focus {\n    --gradient-to-color: #7edce2;\n  }\n  .lg\\:focus\\:to-teal-400:focus {\n    --gradient-to-color: #16bdca;\n  }\n  .lg\\:focus\\:to-teal-500:focus {\n    --gradient-to-color: #0694a2;\n  }\n  .lg\\:focus\\:to-teal-600:focus {\n    --gradient-to-color: #047481;\n  }\n  .lg\\:focus\\:to-teal-700:focus {\n    --gradient-to-color: #036672;\n  }\n  .lg\\:focus\\:to-teal-800:focus {\n    --gradient-to-color: #05505c;\n  }\n  .lg\\:focus\\:to-teal-900:focus {\n    --gradient-to-color: #014451;\n  }\n  .lg\\:focus\\:to-blue-50:focus {\n    --gradient-to-color: #ebf5ff;\n  }\n  .lg\\:focus\\:to-blue-100:focus {\n    --gradient-to-color: #e1effe;\n  }\n  .lg\\:focus\\:to-blue-200:focus {\n    --gradient-to-color: #c3ddfd;\n  }\n  .lg\\:focus\\:to-blue-300:focus {\n    --gradient-to-color: #a4cafe;\n  }\n  .lg\\:focus\\:to-blue-400:focus {\n    --gradient-to-color: #76a9fa;\n  }\n  .lg\\:focus\\:to-blue-500:focus {\n    --gradient-to-color: #3f83f8;\n  }\n  .lg\\:focus\\:to-blue-600:focus {\n    --gradient-to-color: #1c64f2;\n  }\n  .lg\\:focus\\:to-blue-700:focus {\n    --gradient-to-color: #1a56db;\n  }\n  .lg\\:focus\\:to-blue-800:focus {\n    --gradient-to-color: #1e429f;\n  }\n  .lg\\:focus\\:to-blue-900:focus {\n    --gradient-to-color: #233876;\n  }\n  .lg\\:focus\\:to-indigo-50:focus {\n    --gradient-to-color: #f0f5ff;\n  }\n  .lg\\:focus\\:to-indigo-100:focus {\n    --gradient-to-color: #e5edff;\n  }\n  .lg\\:focus\\:to-indigo-200:focus {\n    --gradient-to-color: #cddbfe;\n  }\n  .lg\\:focus\\:to-indigo-300:focus {\n    --gradient-to-color: #b4c6fc;\n  }\n  .lg\\:focus\\:to-indigo-400:focus {\n    --gradient-to-color: #8da2fb;\n  }\n  .lg\\:focus\\:to-indigo-500:focus {\n    --gradient-to-color: #6875f5;\n  }\n  .lg\\:focus\\:to-indigo-600:focus {\n    --gradient-to-color: #5850ec;\n  }\n  .lg\\:focus\\:to-indigo-700:focus {\n    --gradient-to-color: #5145cd;\n  }\n  .lg\\:focus\\:to-indigo-800:focus {\n    --gradient-to-color: #42389d;\n  }\n  .lg\\:focus\\:to-indigo-900:focus {\n    --gradient-to-color: #362f78;\n  }\n  .lg\\:focus\\:to-purple-50:focus {\n    --gradient-to-color: #f6f5ff;\n  }\n  .lg\\:focus\\:to-purple-100:focus {\n    --gradient-to-color: #edebfe;\n  }\n  .lg\\:focus\\:to-purple-200:focus {\n    --gradient-to-color: #dcd7fe;\n  }\n  .lg\\:focus\\:to-purple-300:focus {\n    --gradient-to-color: #cabffd;\n  }\n  .lg\\:focus\\:to-purple-400:focus {\n    --gradient-to-color: #ac94fa;\n  }\n  .lg\\:focus\\:to-purple-500:focus {\n    --gradient-to-color: #9061f9;\n  }\n  .lg\\:focus\\:to-purple-600:focus {\n    --gradient-to-color: #7e3af2;\n  }\n  .lg\\:focus\\:to-purple-700:focus {\n    --gradient-to-color: #6c2bd9;\n  }\n  .lg\\:focus\\:to-purple-800:focus {\n    --gradient-to-color: #5521b5;\n  }\n  .lg\\:focus\\:to-purple-900:focus {\n    --gradient-to-color: #4a1d96;\n  }\n  .lg\\:focus\\:to-pink-50:focus {\n    --gradient-to-color: #fdf2f8;\n  }\n  .lg\\:focus\\:to-pink-100:focus {\n    --gradient-to-color: #fce8f3;\n  }\n  .lg\\:focus\\:to-pink-200:focus {\n    --gradient-to-color: #fad1e8;\n  }\n  .lg\\:focus\\:to-pink-300:focus {\n    --gradient-to-color: #f8b4d9;\n  }\n  .lg\\:focus\\:to-pink-400:focus {\n    --gradient-to-color: #f17eb8;\n  }\n  .lg\\:focus\\:to-pink-500:focus {\n    --gradient-to-color: #e74694;\n  }\n  .lg\\:focus\\:to-pink-600:focus {\n    --gradient-to-color: #d61f69;\n  }\n  .lg\\:focus\\:to-pink-700:focus {\n    --gradient-to-color: #bf125d;\n  }\n  .lg\\:focus\\:to-pink-800:focus {\n    --gradient-to-color: #99154b;\n  }\n  .lg\\:focus\\:to-pink-900:focus {\n    --gradient-to-color: #751a3d;\n  }\n  .lg\\:focus\\:to-cool-gray-50:focus {\n    --gradient-to-color: #f8fafc;\n  }\n  .lg\\:focus\\:to-cool-gray-100:focus {\n    --gradient-to-color: #f1f5f9;\n  }\n  .lg\\:focus\\:to-cool-gray-200:focus {\n    --gradient-to-color: #e2e8f0;\n  }\n  .lg\\:focus\\:to-cool-gray-300:focus {\n    --gradient-to-color: #cfd8e3;\n  }\n  .lg\\:focus\\:to-cool-gray-400:focus {\n    --gradient-to-color: #97a6ba;\n  }\n  .lg\\:focus\\:to-cool-gray-500:focus {\n    --gradient-to-color: #64748b;\n  }\n  .lg\\:focus\\:to-cool-gray-600:focus {\n    --gradient-to-color: #475569;\n  }\n  .lg\\:focus\\:to-cool-gray-700:focus {\n    --gradient-to-color: #364152;\n  }\n  .lg\\:focus\\:to-cool-gray-800:focus {\n    --gradient-to-color: #27303f;\n  }\n  .lg\\:focus\\:to-cool-gray-900:focus {\n    --gradient-to-color: #1a202e;\n  }\n  .lg\\:bg-opacity-0 {\n    --bg-opacity: 0;\n  }\n  .lg\\:bg-opacity-25 {\n    --bg-opacity: 0.25;\n  }\n  .lg\\:bg-opacity-50 {\n    --bg-opacity: 0.5;\n  }\n  .lg\\:bg-opacity-75 {\n    --bg-opacity: 0.75;\n  }\n  .lg\\:bg-opacity-100 {\n    --bg-opacity: 1;\n  }\n  .lg\\:hover\\:bg-opacity-0:hover {\n    --bg-opacity: 0;\n  }\n  .lg\\:hover\\:bg-opacity-25:hover {\n    --bg-opacity: 0.25;\n  }\n  .lg\\:hover\\:bg-opacity-50:hover {\n    --bg-opacity: 0.5;\n  }\n  .lg\\:hover\\:bg-opacity-75:hover {\n    --bg-opacity: 0.75;\n  }\n  .lg\\:hover\\:bg-opacity-100:hover {\n    --bg-opacity: 1;\n  }\n  .lg\\:focus\\:bg-opacity-0:focus {\n    --bg-opacity: 0;\n  }\n  .lg\\:focus\\:bg-opacity-25:focus {\n    --bg-opacity: 0.25;\n  }\n  .lg\\:focus\\:bg-opacity-50:focus {\n    --bg-opacity: 0.5;\n  }\n  .lg\\:focus\\:bg-opacity-75:focus {\n    --bg-opacity: 0.75;\n  }\n  .lg\\:focus\\:bg-opacity-100:focus {\n    --bg-opacity: 1;\n  }\n  .lg\\:bg-bottom {\n    background-position: bottom;\n  }\n  .lg\\:bg-center {\n    background-position: center;\n  }\n  .lg\\:bg-left {\n    background-position: left;\n  }\n  .lg\\:bg-left-bottom {\n    background-position: left bottom;\n  }\n  .lg\\:bg-left-top {\n    background-position: left top;\n  }\n  .lg\\:bg-right {\n    background-position: right;\n  }\n  .lg\\:bg-right-bottom {\n    background-position: right bottom;\n  }\n  .lg\\:bg-right-top {\n    background-position: right top;\n  }\n  .lg\\:bg-top {\n    background-position: top;\n  }\n  .lg\\:bg-repeat {\n    background-repeat: repeat;\n  }\n  .lg\\:bg-no-repeat {\n    background-repeat: no-repeat;\n  }\n  .lg\\:bg-repeat-x {\n    background-repeat: repeat-x;\n  }\n  .lg\\:bg-repeat-y {\n    background-repeat: repeat-y;\n  }\n  .lg\\:bg-repeat-round {\n    background-repeat: round;\n  }\n  .lg\\:bg-repeat-space {\n    background-repeat: space;\n  }\n  .lg\\:bg-auto {\n    background-size: auto;\n  }\n  .lg\\:bg-cover {\n    background-size: cover;\n  }\n  .lg\\:bg-contain {\n    background-size: contain;\n  }\n  .lg\\:border-collapse {\n    border-collapse: collapse;\n  }\n  .lg\\:border-separate {\n    border-collapse: separate;\n  }\n  .lg\\:border-current {\n    border-color: currentColor;\n  }\n  .lg\\:border-transparent {\n    border-color: transparent;\n  }\n  .lg\\:border-white {\n    --border-opacity: 1;\n    border-color: #ffffff;\n    border-color: rgba(255, 255, 255, var(--border-opacity));\n  }\n  .lg\\:border-black {\n    --border-opacity: 1;\n    border-color: #000000;\n    border-color: rgba(0, 0, 0, var(--border-opacity));\n  }\n  .lg\\:border-gray-50 {\n    --border-opacity: 1;\n    border-color: #f9fafb;\n    border-color: rgba(249, 250, 251, var(--border-opacity));\n  }\n  .lg\\:border-gray-100 {\n    --border-opacity: 1;\n    border-color: #f4f5f7;\n    border-color: rgba(244, 245, 247, var(--border-opacity));\n  }\n  .lg\\:border-gray-200 {\n    --border-opacity: 1;\n    border-color: #e5e7eb;\n    border-color: rgba(229, 231, 235, var(--border-opacity));\n  }\n  .lg\\:border-gray-300 {\n    --border-opacity: 1;\n    border-color: #d2d6dc;\n    border-color: rgba(210, 214, 220, var(--border-opacity));\n  }\n  .lg\\:border-gray-400 {\n    --border-opacity: 1;\n    border-color: #9fa6b2;\n    border-color: rgba(159, 166, 178, var(--border-opacity));\n  }\n  .lg\\:border-gray-500 {\n    --border-opacity: 1;\n    border-color: #6b7280;\n    border-color: rgba(107, 114, 128, var(--border-opacity));\n  }\n  .lg\\:border-gray-600 {\n    --border-opacity: 1;\n    border-color: #4b5563;\n    border-color: rgba(75, 85, 99, var(--border-opacity));\n  }\n  .lg\\:border-gray-700 {\n    --border-opacity: 1;\n    border-color: #374151;\n    border-color: rgba(55, 65, 81, var(--border-opacity));\n  }\n  .lg\\:border-gray-800 {\n    --border-opacity: 1;\n    border-color: #252f3f;\n    border-color: rgba(37, 47, 63, var(--border-opacity));\n  }\n  .lg\\:border-gray-900 {\n    --border-opacity: 1;\n    border-color: #161e2e;\n    border-color: rgba(22, 30, 46, var(--border-opacity));\n  }\n  .lg\\:border-red-50 {\n    --border-opacity: 1;\n    border-color: #fdf2f2;\n    border-color: rgba(253, 242, 242, var(--border-opacity));\n  }\n  .lg\\:border-red-100 {\n    --border-opacity: 1;\n    border-color: #fde8e8;\n    border-color: rgba(253, 232, 232, var(--border-opacity));\n  }\n  .lg\\:border-red-200 {\n    --border-opacity: 1;\n    border-color: #fbd5d5;\n    border-color: rgba(251, 213, 213, var(--border-opacity));\n  }\n  .lg\\:border-red-300 {\n    --border-opacity: 1;\n    border-color: #f8b4b4;\n    border-color: rgba(248, 180, 180, var(--border-opacity));\n  }\n  .lg\\:border-red-400 {\n    --border-opacity: 1;\n    border-color: #f98080;\n    border-color: rgba(249, 128, 128, var(--border-opacity));\n  }\n  .lg\\:border-red-500 {\n    --border-opacity: 1;\n    border-color: #f05252;\n    border-color: rgba(240, 82, 82, var(--border-opacity));\n  }\n  .lg\\:border-red-600 {\n    --border-opacity: 1;\n    border-color: #e02424;\n    border-color: rgba(224, 36, 36, var(--border-opacity));\n  }\n  .lg\\:border-red-700 {\n    --border-opacity: 1;\n    border-color: #c81e1e;\n    border-color: rgba(200, 30, 30, var(--border-opacity));\n  }\n  .lg\\:border-red-800 {\n    --border-opacity: 1;\n    border-color: #9b1c1c;\n    border-color: rgba(155, 28, 28, var(--border-opacity));\n  }\n  .lg\\:border-red-900 {\n    --border-opacity: 1;\n    border-color: #771d1d;\n    border-color: rgba(119, 29, 29, var(--border-opacity));\n  }\n  .lg\\:border-orange-50 {\n    --border-opacity: 1;\n    border-color: #fff8f1;\n    border-color: rgba(255, 248, 241, var(--border-opacity));\n  }\n  .lg\\:border-orange-100 {\n    --border-opacity: 1;\n    border-color: #feecdc;\n    border-color: rgba(254, 236, 220, var(--border-opacity));\n  }\n  .lg\\:border-orange-200 {\n    --border-opacity: 1;\n    border-color: #fcd9bd;\n    border-color: rgba(252, 217, 189, var(--border-opacity));\n  }\n  .lg\\:border-orange-300 {\n    --border-opacity: 1;\n    border-color: #fdba8c;\n    border-color: rgba(253, 186, 140, var(--border-opacity));\n  }\n  .lg\\:border-orange-400 {\n    --border-opacity: 1;\n    border-color: #ff8a4c;\n    border-color: rgba(255, 138, 76, var(--border-opacity));\n  }\n  .lg\\:border-orange-500 {\n    --border-opacity: 1;\n    border-color: #ff5a1f;\n    border-color: rgba(255, 90, 31, var(--border-opacity));\n  }\n  .lg\\:border-orange-600 {\n    --border-opacity: 1;\n    border-color: #d03801;\n    border-color: rgba(208, 56, 1, var(--border-opacity));\n  }\n  .lg\\:border-orange-700 {\n    --border-opacity: 1;\n    border-color: #b43403;\n    border-color: rgba(180, 52, 3, var(--border-opacity));\n  }\n  .lg\\:border-orange-800 {\n    --border-opacity: 1;\n    border-color: #8a2c0d;\n    border-color: rgba(138, 44, 13, var(--border-opacity));\n  }\n  .lg\\:border-orange-900 {\n    --border-opacity: 1;\n    border-color: #73230d;\n    border-color: rgba(115, 35, 13, var(--border-opacity));\n  }\n  .lg\\:border-yellow-50 {\n    --border-opacity: 1;\n    border-color: #fdfdea;\n    border-color: rgba(253, 253, 234, var(--border-opacity));\n  }\n  .lg\\:border-yellow-100 {\n    --border-opacity: 1;\n    border-color: #fdf6b2;\n    border-color: rgba(253, 246, 178, var(--border-opacity));\n  }\n  .lg\\:border-yellow-200 {\n    --border-opacity: 1;\n    border-color: #fce96a;\n    border-color: rgba(252, 233, 106, var(--border-opacity));\n  }\n  .lg\\:border-yellow-300 {\n    --border-opacity: 1;\n    border-color: #faca15;\n    border-color: rgba(250, 202, 21, var(--border-opacity));\n  }\n  .lg\\:border-yellow-400 {\n    --border-opacity: 1;\n    border-color: #e3a008;\n    border-color: rgba(227, 160, 8, var(--border-opacity));\n  }\n  .lg\\:border-yellow-500 {\n    --border-opacity: 1;\n    border-color: #c27803;\n    border-color: rgba(194, 120, 3, var(--border-opacity));\n  }\n  .lg\\:border-yellow-600 {\n    --border-opacity: 1;\n    border-color: #9f580a;\n    border-color: rgba(159, 88, 10, var(--border-opacity));\n  }\n  .lg\\:border-yellow-700 {\n    --border-opacity: 1;\n    border-color: #8e4b10;\n    border-color: rgba(142, 75, 16, var(--border-opacity));\n  }\n  .lg\\:border-yellow-800 {\n    --border-opacity: 1;\n    border-color: #723b13;\n    border-color: rgba(114, 59, 19, var(--border-opacity));\n  }\n  .lg\\:border-yellow-900 {\n    --border-opacity: 1;\n    border-color: #633112;\n    border-color: rgba(99, 49, 18, var(--border-opacity));\n  }\n  .lg\\:border-green-50 {\n    --border-opacity: 1;\n    border-color: #f3faf7;\n    border-color: rgba(243, 250, 247, var(--border-opacity));\n  }\n  .lg\\:border-green-100 {\n    --border-opacity: 1;\n    border-color: #def7ec;\n    border-color: rgba(222, 247, 236, var(--border-opacity));\n  }\n  .lg\\:border-green-200 {\n    --border-opacity: 1;\n    border-color: #bcf0da;\n    border-color: rgba(188, 240, 218, var(--border-opacity));\n  }\n  .lg\\:border-green-300 {\n    --border-opacity: 1;\n    border-color: #84e1bc;\n    border-color: rgba(132, 225, 188, var(--border-opacity));\n  }\n  .lg\\:border-green-400 {\n    --border-opacity: 1;\n    border-color: #31c48d;\n    border-color: rgba(49, 196, 141, var(--border-opacity));\n  }\n  .lg\\:border-green-500 {\n    --border-opacity: 1;\n    border-color: #0e9f6e;\n    border-color: rgba(14, 159, 110, var(--border-opacity));\n  }\n  .lg\\:border-green-600 {\n    --border-opacity: 1;\n    border-color: #057a55;\n    border-color: rgba(5, 122, 85, var(--border-opacity));\n  }\n  .lg\\:border-green-700 {\n    --border-opacity: 1;\n    border-color: #046c4e;\n    border-color: rgba(4, 108, 78, var(--border-opacity));\n  }\n  .lg\\:border-green-800 {\n    --border-opacity: 1;\n    border-color: #03543f;\n    border-color: rgba(3, 84, 63, var(--border-opacity));\n  }\n  .lg\\:border-green-900 {\n    --border-opacity: 1;\n    border-color: #014737;\n    border-color: rgba(1, 71, 55, var(--border-opacity));\n  }\n  .lg\\:border-teal-50 {\n    --border-opacity: 1;\n    border-color: #edfafa;\n    border-color: rgba(237, 250, 250, var(--border-opacity));\n  }\n  .lg\\:border-teal-100 {\n    --border-opacity: 1;\n    border-color: #d5f5f6;\n    border-color: rgba(213, 245, 246, var(--border-opacity));\n  }\n  .lg\\:border-teal-200 {\n    --border-opacity: 1;\n    border-color: #afecef;\n    border-color: rgba(175, 236, 239, var(--border-opacity));\n  }\n  .lg\\:border-teal-300 {\n    --border-opacity: 1;\n    border-color: #7edce2;\n    border-color: rgba(126, 220, 226, var(--border-opacity));\n  }\n  .lg\\:border-teal-400 {\n    --border-opacity: 1;\n    border-color: #16bdca;\n    border-color: rgba(22, 189, 202, var(--border-opacity));\n  }\n  .lg\\:border-teal-500 {\n    --border-opacity: 1;\n    border-color: #0694a2;\n    border-color: rgba(6, 148, 162, var(--border-opacity));\n  }\n  .lg\\:border-teal-600 {\n    --border-opacity: 1;\n    border-color: #047481;\n    border-color: rgba(4, 116, 129, var(--border-opacity));\n  }\n  .lg\\:border-teal-700 {\n    --border-opacity: 1;\n    border-color: #036672;\n    border-color: rgba(3, 102, 114, var(--border-opacity));\n  }\n  .lg\\:border-teal-800 {\n    --border-opacity: 1;\n    border-color: #05505c;\n    border-color: rgba(5, 80, 92, var(--border-opacity));\n  }\n  .lg\\:border-teal-900 {\n    --border-opacity: 1;\n    border-color: #014451;\n    border-color: rgba(1, 68, 81, var(--border-opacity));\n  }\n  .lg\\:border-blue-50 {\n    --border-opacity: 1;\n    border-color: #ebf5ff;\n    border-color: rgba(235, 245, 255, var(--border-opacity));\n  }\n  .lg\\:border-blue-100 {\n    --border-opacity: 1;\n    border-color: #e1effe;\n    border-color: rgba(225, 239, 254, var(--border-opacity));\n  }\n  .lg\\:border-blue-200 {\n    --border-opacity: 1;\n    border-color: #c3ddfd;\n    border-color: rgba(195, 221, 253, var(--border-opacity));\n  }\n  .lg\\:border-blue-300 {\n    --border-opacity: 1;\n    border-color: #a4cafe;\n    border-color: rgba(164, 202, 254, var(--border-opacity));\n  }\n  .lg\\:border-blue-400 {\n    --border-opacity: 1;\n    border-color: #76a9fa;\n    border-color: rgba(118, 169, 250, var(--border-opacity));\n  }\n  .lg\\:border-blue-500 {\n    --border-opacity: 1;\n    border-color: #3f83f8;\n    border-color: rgba(63, 131, 248, var(--border-opacity));\n  }\n  .lg\\:border-blue-600 {\n    --border-opacity: 1;\n    border-color: #1c64f2;\n    border-color: rgba(28, 100, 242, var(--border-opacity));\n  }\n  .lg\\:border-blue-700 {\n    --border-opacity: 1;\n    border-color: #1a56db;\n    border-color: rgba(26, 86, 219, var(--border-opacity));\n  }\n  .lg\\:border-blue-800 {\n    --border-opacity: 1;\n    border-color: #1e429f;\n    border-color: rgba(30, 66, 159, var(--border-opacity));\n  }\n  .lg\\:border-blue-900 {\n    --border-opacity: 1;\n    border-color: #233876;\n    border-color: rgba(35, 56, 118, var(--border-opacity));\n  }\n  .lg\\:border-indigo-50 {\n    --border-opacity: 1;\n    border-color: #f0f5ff;\n    border-color: rgba(240, 245, 255, var(--border-opacity));\n  }\n  .lg\\:border-indigo-100 {\n    --border-opacity: 1;\n    border-color: #e5edff;\n    border-color: rgba(229, 237, 255, var(--border-opacity));\n  }\n  .lg\\:border-indigo-200 {\n    --border-opacity: 1;\n    border-color: #cddbfe;\n    border-color: rgba(205, 219, 254, var(--border-opacity));\n  }\n  .lg\\:border-indigo-300 {\n    --border-opacity: 1;\n    border-color: #b4c6fc;\n    border-color: rgba(180, 198, 252, var(--border-opacity));\n  }\n  .lg\\:border-indigo-400 {\n    --border-opacity: 1;\n    border-color: #8da2fb;\n    border-color: rgba(141, 162, 251, var(--border-opacity));\n  }\n  .lg\\:border-indigo-500 {\n    --border-opacity: 1;\n    border-color: #6875f5;\n    border-color: rgba(104, 117, 245, var(--border-opacity));\n  }\n  .lg\\:border-indigo-600 {\n    --border-opacity: 1;\n    border-color: #5850ec;\n    border-color: rgba(88, 80, 236, var(--border-opacity));\n  }\n  .lg\\:border-indigo-700 {\n    --border-opacity: 1;\n    border-color: #5145cd;\n    border-color: rgba(81, 69, 205, var(--border-opacity));\n  }\n  .lg\\:border-indigo-800 {\n    --border-opacity: 1;\n    border-color: #42389d;\n    border-color: rgba(66, 56, 157, var(--border-opacity));\n  }\n  .lg\\:border-indigo-900 {\n    --border-opacity: 1;\n    border-color: #362f78;\n    border-color: rgba(54, 47, 120, var(--border-opacity));\n  }\n  .lg\\:border-purple-50 {\n    --border-opacity: 1;\n    border-color: #f6f5ff;\n    border-color: rgba(246, 245, 255, var(--border-opacity));\n  }\n  .lg\\:border-purple-100 {\n    --border-opacity: 1;\n    border-color: #edebfe;\n    border-color: rgba(237, 235, 254, var(--border-opacity));\n  }\n  .lg\\:border-purple-200 {\n    --border-opacity: 1;\n    border-color: #dcd7fe;\n    border-color: rgba(220, 215, 254, var(--border-opacity));\n  }\n  .lg\\:border-purple-300 {\n    --border-opacity: 1;\n    border-color: #cabffd;\n    border-color: rgba(202, 191, 253, var(--border-opacity));\n  }\n  .lg\\:border-purple-400 {\n    --border-opacity: 1;\n    border-color: #ac94fa;\n    border-color: rgba(172, 148, 250, var(--border-opacity));\n  }\n  .lg\\:border-purple-500 {\n    --border-opacity: 1;\n    border-color: #9061f9;\n    border-color: rgba(144, 97, 249, var(--border-opacity));\n  }\n  .lg\\:border-purple-600 {\n    --border-opacity: 1;\n    border-color: #7e3af2;\n    border-color: rgba(126, 58, 242, var(--border-opacity));\n  }\n  .lg\\:border-purple-700 {\n    --border-opacity: 1;\n    border-color: #6c2bd9;\n    border-color: rgba(108, 43, 217, var(--border-opacity));\n  }\n  .lg\\:border-purple-800 {\n    --border-opacity: 1;\n    border-color: #5521b5;\n    border-color: rgba(85, 33, 181, var(--border-opacity));\n  }\n  .lg\\:border-purple-900 {\n    --border-opacity: 1;\n    border-color: #4a1d96;\n    border-color: rgba(74, 29, 150, var(--border-opacity));\n  }\n  .lg\\:border-pink-50 {\n    --border-opacity: 1;\n    border-color: #fdf2f8;\n    border-color: rgba(253, 242, 248, var(--border-opacity));\n  }\n  .lg\\:border-pink-100 {\n    --border-opacity: 1;\n    border-color: #fce8f3;\n    border-color: rgba(252, 232, 243, var(--border-opacity));\n  }\n  .lg\\:border-pink-200 {\n    --border-opacity: 1;\n    border-color: #fad1e8;\n    border-color: rgba(250, 209, 232, var(--border-opacity));\n  }\n  .lg\\:border-pink-300 {\n    --border-opacity: 1;\n    border-color: #f8b4d9;\n    border-color: rgba(248, 180, 217, var(--border-opacity));\n  }\n  .lg\\:border-pink-400 {\n    --border-opacity: 1;\n    border-color: #f17eb8;\n    border-color: rgba(241, 126, 184, var(--border-opacity));\n  }\n  .lg\\:border-pink-500 {\n    --border-opacity: 1;\n    border-color: #e74694;\n    border-color: rgba(231, 70, 148, var(--border-opacity));\n  }\n  .lg\\:border-pink-600 {\n    --border-opacity: 1;\n    border-color: #d61f69;\n    border-color: rgba(214, 31, 105, var(--border-opacity));\n  }\n  .lg\\:border-pink-700 {\n    --border-opacity: 1;\n    border-color: #bf125d;\n    border-color: rgba(191, 18, 93, var(--border-opacity));\n  }\n  .lg\\:border-pink-800 {\n    --border-opacity: 1;\n    border-color: #99154b;\n    border-color: rgba(153, 21, 75, var(--border-opacity));\n  }\n  .lg\\:border-pink-900 {\n    --border-opacity: 1;\n    border-color: #751a3d;\n    border-color: rgba(117, 26, 61, var(--border-opacity));\n  }\n  .lg\\:border-cool-gray-50 {\n    --border-opacity: 1;\n    border-color: #f8fafc;\n    border-color: rgba(248, 250, 252, var(--border-opacity));\n  }\n  .lg\\:border-cool-gray-100 {\n    --border-opacity: 1;\n    border-color: #f1f5f9;\n    border-color: rgba(241, 245, 249, var(--border-opacity));\n  }\n  .lg\\:border-cool-gray-200 {\n    --border-opacity: 1;\n    border-color: #e2e8f0;\n    border-color: rgba(226, 232, 240, var(--border-opacity));\n  }\n  .lg\\:border-cool-gray-300 {\n    --border-opacity: 1;\n    border-color: #cfd8e3;\n    border-color: rgba(207, 216, 227, var(--border-opacity));\n  }\n  .lg\\:border-cool-gray-400 {\n    --border-opacity: 1;\n    border-color: #97a6ba;\n    border-color: rgba(151, 166, 186, var(--border-opacity));\n  }\n  .lg\\:border-cool-gray-500 {\n    --border-opacity: 1;\n    border-color: #64748b;\n    border-color: rgba(100, 116, 139, var(--border-opacity));\n  }\n  .lg\\:border-cool-gray-600 {\n    --border-opacity: 1;\n    border-color: #475569;\n    border-color: rgba(71, 85, 105, var(--border-opacity));\n  }\n  .lg\\:border-cool-gray-700 {\n    --border-opacity: 1;\n    border-color: #364152;\n    border-color: rgba(54, 65, 82, var(--border-opacity));\n  }\n  .lg\\:border-cool-gray-800 {\n    --border-opacity: 1;\n    border-color: #27303f;\n    border-color: rgba(39, 48, 63, var(--border-opacity));\n  }\n  .lg\\:border-cool-gray-900 {\n    --border-opacity: 1;\n    border-color: #1a202e;\n    border-color: rgba(26, 32, 46, var(--border-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:border-current {\n    border-color: currentColor;\n  }\n  .group:hover .lg\\:group-hover\\:border-transparent {\n    border-color: transparent;\n  }\n  .group:hover .lg\\:group-hover\\:border-white {\n    --border-opacity: 1;\n    border-color: #ffffff;\n    border-color: rgba(255, 255, 255, var(--border-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:border-black {\n    --border-opacity: 1;\n    border-color: #000000;\n    border-color: rgba(0, 0, 0, var(--border-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:border-gray-50 {\n    --border-opacity: 1;\n    border-color: #f9fafb;\n    border-color: rgba(249, 250, 251, var(--border-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:border-gray-100 {\n    --border-opacity: 1;\n    border-color: #f4f5f7;\n    border-color: rgba(244, 245, 247, var(--border-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:border-gray-200 {\n    --border-opacity: 1;\n    border-color: #e5e7eb;\n    border-color: rgba(229, 231, 235, var(--border-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:border-gray-300 {\n    --border-opacity: 1;\n    border-color: #d2d6dc;\n    border-color: rgba(210, 214, 220, var(--border-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:border-gray-400 {\n    --border-opacity: 1;\n    border-color: #9fa6b2;\n    border-color: rgba(159, 166, 178, var(--border-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:border-gray-500 {\n    --border-opacity: 1;\n    border-color: #6b7280;\n    border-color: rgba(107, 114, 128, var(--border-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:border-gray-600 {\n    --border-opacity: 1;\n    border-color: #4b5563;\n    border-color: rgba(75, 85, 99, var(--border-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:border-gray-700 {\n    --border-opacity: 1;\n    border-color: #374151;\n    border-color: rgba(55, 65, 81, var(--border-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:border-gray-800 {\n    --border-opacity: 1;\n    border-color: #252f3f;\n    border-color: rgba(37, 47, 63, var(--border-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:border-gray-900 {\n    --border-opacity: 1;\n    border-color: #161e2e;\n    border-color: rgba(22, 30, 46, var(--border-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:border-red-50 {\n    --border-opacity: 1;\n    border-color: #fdf2f2;\n    border-color: rgba(253, 242, 242, var(--border-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:border-red-100 {\n    --border-opacity: 1;\n    border-color: #fde8e8;\n    border-color: rgba(253, 232, 232, var(--border-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:border-red-200 {\n    --border-opacity: 1;\n    border-color: #fbd5d5;\n    border-color: rgba(251, 213, 213, var(--border-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:border-red-300 {\n    --border-opacity: 1;\n    border-color: #f8b4b4;\n    border-color: rgba(248, 180, 180, var(--border-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:border-red-400 {\n    --border-opacity: 1;\n    border-color: #f98080;\n    border-color: rgba(249, 128, 128, var(--border-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:border-red-500 {\n    --border-opacity: 1;\n    border-color: #f05252;\n    border-color: rgba(240, 82, 82, var(--border-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:border-red-600 {\n    --border-opacity: 1;\n    border-color: #e02424;\n    border-color: rgba(224, 36, 36, var(--border-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:border-red-700 {\n    --border-opacity: 1;\n    border-color: #c81e1e;\n    border-color: rgba(200, 30, 30, var(--border-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:border-red-800 {\n    --border-opacity: 1;\n    border-color: #9b1c1c;\n    border-color: rgba(155, 28, 28, var(--border-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:border-red-900 {\n    --border-opacity: 1;\n    border-color: #771d1d;\n    border-color: rgba(119, 29, 29, var(--border-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:border-orange-50 {\n    --border-opacity: 1;\n    border-color: #fff8f1;\n    border-color: rgba(255, 248, 241, var(--border-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:border-orange-100 {\n    --border-opacity: 1;\n    border-color: #feecdc;\n    border-color: rgba(254, 236, 220, var(--border-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:border-orange-200 {\n    --border-opacity: 1;\n    border-color: #fcd9bd;\n    border-color: rgba(252, 217, 189, var(--border-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:border-orange-300 {\n    --border-opacity: 1;\n    border-color: #fdba8c;\n    border-color: rgba(253, 186, 140, var(--border-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:border-orange-400 {\n    --border-opacity: 1;\n    border-color: #ff8a4c;\n    border-color: rgba(255, 138, 76, var(--border-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:border-orange-500 {\n    --border-opacity: 1;\n    border-color: #ff5a1f;\n    border-color: rgba(255, 90, 31, var(--border-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:border-orange-600 {\n    --border-opacity: 1;\n    border-color: #d03801;\n    border-color: rgba(208, 56, 1, var(--border-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:border-orange-700 {\n    --border-opacity: 1;\n    border-color: #b43403;\n    border-color: rgba(180, 52, 3, var(--border-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:border-orange-800 {\n    --border-opacity: 1;\n    border-color: #8a2c0d;\n    border-color: rgba(138, 44, 13, var(--border-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:border-orange-900 {\n    --border-opacity: 1;\n    border-color: #73230d;\n    border-color: rgba(115, 35, 13, var(--border-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:border-yellow-50 {\n    --border-opacity: 1;\n    border-color: #fdfdea;\n    border-color: rgba(253, 253, 234, var(--border-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:border-yellow-100 {\n    --border-opacity: 1;\n    border-color: #fdf6b2;\n    border-color: rgba(253, 246, 178, var(--border-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:border-yellow-200 {\n    --border-opacity: 1;\n    border-color: #fce96a;\n    border-color: rgba(252, 233, 106, var(--border-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:border-yellow-300 {\n    --border-opacity: 1;\n    border-color: #faca15;\n    border-color: rgba(250, 202, 21, var(--border-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:border-yellow-400 {\n    --border-opacity: 1;\n    border-color: #e3a008;\n    border-color: rgba(227, 160, 8, var(--border-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:border-yellow-500 {\n    --border-opacity: 1;\n    border-color: #c27803;\n    border-color: rgba(194, 120, 3, var(--border-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:border-yellow-600 {\n    --border-opacity: 1;\n    border-color: #9f580a;\n    border-color: rgba(159, 88, 10, var(--border-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:border-yellow-700 {\n    --border-opacity: 1;\n    border-color: #8e4b10;\n    border-color: rgba(142, 75, 16, var(--border-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:border-yellow-800 {\n    --border-opacity: 1;\n    border-color: #723b13;\n    border-color: rgba(114, 59, 19, var(--border-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:border-yellow-900 {\n    --border-opacity: 1;\n    border-color: #633112;\n    border-color: rgba(99, 49, 18, var(--border-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:border-green-50 {\n    --border-opacity: 1;\n    border-color: #f3faf7;\n    border-color: rgba(243, 250, 247, var(--border-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:border-green-100 {\n    --border-opacity: 1;\n    border-color: #def7ec;\n    border-color: rgba(222, 247, 236, var(--border-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:border-green-200 {\n    --border-opacity: 1;\n    border-color: #bcf0da;\n    border-color: rgba(188, 240, 218, var(--border-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:border-green-300 {\n    --border-opacity: 1;\n    border-color: #84e1bc;\n    border-color: rgba(132, 225, 188, var(--border-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:border-green-400 {\n    --border-opacity: 1;\n    border-color: #31c48d;\n    border-color: rgba(49, 196, 141, var(--border-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:border-green-500 {\n    --border-opacity: 1;\n    border-color: #0e9f6e;\n    border-color: rgba(14, 159, 110, var(--border-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:border-green-600 {\n    --border-opacity: 1;\n    border-color: #057a55;\n    border-color: rgba(5, 122, 85, var(--border-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:border-green-700 {\n    --border-opacity: 1;\n    border-color: #046c4e;\n    border-color: rgba(4, 108, 78, var(--border-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:border-green-800 {\n    --border-opacity: 1;\n    border-color: #03543f;\n    border-color: rgba(3, 84, 63, var(--border-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:border-green-900 {\n    --border-opacity: 1;\n    border-color: #014737;\n    border-color: rgba(1, 71, 55, var(--border-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:border-teal-50 {\n    --border-opacity: 1;\n    border-color: #edfafa;\n    border-color: rgba(237, 250, 250, var(--border-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:border-teal-100 {\n    --border-opacity: 1;\n    border-color: #d5f5f6;\n    border-color: rgba(213, 245, 246, var(--border-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:border-teal-200 {\n    --border-opacity: 1;\n    border-color: #afecef;\n    border-color: rgba(175, 236, 239, var(--border-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:border-teal-300 {\n    --border-opacity: 1;\n    border-color: #7edce2;\n    border-color: rgba(126, 220, 226, var(--border-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:border-teal-400 {\n    --border-opacity: 1;\n    border-color: #16bdca;\n    border-color: rgba(22, 189, 202, var(--border-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:border-teal-500 {\n    --border-opacity: 1;\n    border-color: #0694a2;\n    border-color: rgba(6, 148, 162, var(--border-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:border-teal-600 {\n    --border-opacity: 1;\n    border-color: #047481;\n    border-color: rgba(4, 116, 129, var(--border-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:border-teal-700 {\n    --border-opacity: 1;\n    border-color: #036672;\n    border-color: rgba(3, 102, 114, var(--border-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:border-teal-800 {\n    --border-opacity: 1;\n    border-color: #05505c;\n    border-color: rgba(5, 80, 92, var(--border-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:border-teal-900 {\n    --border-opacity: 1;\n    border-color: #014451;\n    border-color: rgba(1, 68, 81, var(--border-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:border-blue-50 {\n    --border-opacity: 1;\n    border-color: #ebf5ff;\n    border-color: rgba(235, 245, 255, var(--border-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:border-blue-100 {\n    --border-opacity: 1;\n    border-color: #e1effe;\n    border-color: rgba(225, 239, 254, var(--border-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:border-blue-200 {\n    --border-opacity: 1;\n    border-color: #c3ddfd;\n    border-color: rgba(195, 221, 253, var(--border-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:border-blue-300 {\n    --border-opacity: 1;\n    border-color: #a4cafe;\n    border-color: rgba(164, 202, 254, var(--border-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:border-blue-400 {\n    --border-opacity: 1;\n    border-color: #76a9fa;\n    border-color: rgba(118, 169, 250, var(--border-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:border-blue-500 {\n    --border-opacity: 1;\n    border-color: #3f83f8;\n    border-color: rgba(63, 131, 248, var(--border-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:border-blue-600 {\n    --border-opacity: 1;\n    border-color: #1c64f2;\n    border-color: rgba(28, 100, 242, var(--border-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:border-blue-700 {\n    --border-opacity: 1;\n    border-color: #1a56db;\n    border-color: rgba(26, 86, 219, var(--border-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:border-blue-800 {\n    --border-opacity: 1;\n    border-color: #1e429f;\n    border-color: rgba(30, 66, 159, var(--border-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:border-blue-900 {\n    --border-opacity: 1;\n    border-color: #233876;\n    border-color: rgba(35, 56, 118, var(--border-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:border-indigo-50 {\n    --border-opacity: 1;\n    border-color: #f0f5ff;\n    border-color: rgba(240, 245, 255, var(--border-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:border-indigo-100 {\n    --border-opacity: 1;\n    border-color: #e5edff;\n    border-color: rgba(229, 237, 255, var(--border-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:border-indigo-200 {\n    --border-opacity: 1;\n    border-color: #cddbfe;\n    border-color: rgba(205, 219, 254, var(--border-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:border-indigo-300 {\n    --border-opacity: 1;\n    border-color: #b4c6fc;\n    border-color: rgba(180, 198, 252, var(--border-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:border-indigo-400 {\n    --border-opacity: 1;\n    border-color: #8da2fb;\n    border-color: rgba(141, 162, 251, var(--border-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:border-indigo-500 {\n    --border-opacity: 1;\n    border-color: #6875f5;\n    border-color: rgba(104, 117, 245, var(--border-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:border-indigo-600 {\n    --border-opacity: 1;\n    border-color: #5850ec;\n    border-color: rgba(88, 80, 236, var(--border-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:border-indigo-700 {\n    --border-opacity: 1;\n    border-color: #5145cd;\n    border-color: rgba(81, 69, 205, var(--border-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:border-indigo-800 {\n    --border-opacity: 1;\n    border-color: #42389d;\n    border-color: rgba(66, 56, 157, var(--border-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:border-indigo-900 {\n    --border-opacity: 1;\n    border-color: #362f78;\n    border-color: rgba(54, 47, 120, var(--border-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:border-purple-50 {\n    --border-opacity: 1;\n    border-color: #f6f5ff;\n    border-color: rgba(246, 245, 255, var(--border-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:border-purple-100 {\n    --border-opacity: 1;\n    border-color: #edebfe;\n    border-color: rgba(237, 235, 254, var(--border-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:border-purple-200 {\n    --border-opacity: 1;\n    border-color: #dcd7fe;\n    border-color: rgba(220, 215, 254, var(--border-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:border-purple-300 {\n    --border-opacity: 1;\n    border-color: #cabffd;\n    border-color: rgba(202, 191, 253, var(--border-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:border-purple-400 {\n    --border-opacity: 1;\n    border-color: #ac94fa;\n    border-color: rgba(172, 148, 250, var(--border-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:border-purple-500 {\n    --border-opacity: 1;\n    border-color: #9061f9;\n    border-color: rgba(144, 97, 249, var(--border-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:border-purple-600 {\n    --border-opacity: 1;\n    border-color: #7e3af2;\n    border-color: rgba(126, 58, 242, var(--border-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:border-purple-700 {\n    --border-opacity: 1;\n    border-color: #6c2bd9;\n    border-color: rgba(108, 43, 217, var(--border-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:border-purple-800 {\n    --border-opacity: 1;\n    border-color: #5521b5;\n    border-color: rgba(85, 33, 181, var(--border-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:border-purple-900 {\n    --border-opacity: 1;\n    border-color: #4a1d96;\n    border-color: rgba(74, 29, 150, var(--border-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:border-pink-50 {\n    --border-opacity: 1;\n    border-color: #fdf2f8;\n    border-color: rgba(253, 242, 248, var(--border-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:border-pink-100 {\n    --border-opacity: 1;\n    border-color: #fce8f3;\n    border-color: rgba(252, 232, 243, var(--border-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:border-pink-200 {\n    --border-opacity: 1;\n    border-color: #fad1e8;\n    border-color: rgba(250, 209, 232, var(--border-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:border-pink-300 {\n    --border-opacity: 1;\n    border-color: #f8b4d9;\n    border-color: rgba(248, 180, 217, var(--border-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:border-pink-400 {\n    --border-opacity: 1;\n    border-color: #f17eb8;\n    border-color: rgba(241, 126, 184, var(--border-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:border-pink-500 {\n    --border-opacity: 1;\n    border-color: #e74694;\n    border-color: rgba(231, 70, 148, var(--border-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:border-pink-600 {\n    --border-opacity: 1;\n    border-color: #d61f69;\n    border-color: rgba(214, 31, 105, var(--border-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:border-pink-700 {\n    --border-opacity: 1;\n    border-color: #bf125d;\n    border-color: rgba(191, 18, 93, var(--border-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:border-pink-800 {\n    --border-opacity: 1;\n    border-color: #99154b;\n    border-color: rgba(153, 21, 75, var(--border-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:border-pink-900 {\n    --border-opacity: 1;\n    border-color: #751a3d;\n    border-color: rgba(117, 26, 61, var(--border-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:border-cool-gray-50 {\n    --border-opacity: 1;\n    border-color: #f8fafc;\n    border-color: rgba(248, 250, 252, var(--border-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:border-cool-gray-100 {\n    --border-opacity: 1;\n    border-color: #f1f5f9;\n    border-color: rgba(241, 245, 249, var(--border-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:border-cool-gray-200 {\n    --border-opacity: 1;\n    border-color: #e2e8f0;\n    border-color: rgba(226, 232, 240, var(--border-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:border-cool-gray-300 {\n    --border-opacity: 1;\n    border-color: #cfd8e3;\n    border-color: rgba(207, 216, 227, var(--border-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:border-cool-gray-400 {\n    --border-opacity: 1;\n    border-color: #97a6ba;\n    border-color: rgba(151, 166, 186, var(--border-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:border-cool-gray-500 {\n    --border-opacity: 1;\n    border-color: #64748b;\n    border-color: rgba(100, 116, 139, var(--border-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:border-cool-gray-600 {\n    --border-opacity: 1;\n    border-color: #475569;\n    border-color: rgba(71, 85, 105, var(--border-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:border-cool-gray-700 {\n    --border-opacity: 1;\n    border-color: #364152;\n    border-color: rgba(54, 65, 82, var(--border-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:border-cool-gray-800 {\n    --border-opacity: 1;\n    border-color: #27303f;\n    border-color: rgba(39, 48, 63, var(--border-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:border-cool-gray-900 {\n    --border-opacity: 1;\n    border-color: #1a202e;\n    border-color: rgba(26, 32, 46, var(--border-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:border-current {\n    border-color: currentColor;\n  }\n  .group:focus .lg\\:group-focus\\:border-transparent {\n    border-color: transparent;\n  }\n  .group:focus .lg\\:group-focus\\:border-white {\n    --border-opacity: 1;\n    border-color: #ffffff;\n    border-color: rgba(255, 255, 255, var(--border-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:border-black {\n    --border-opacity: 1;\n    border-color: #000000;\n    border-color: rgba(0, 0, 0, var(--border-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:border-gray-50 {\n    --border-opacity: 1;\n    border-color: #f9fafb;\n    border-color: rgba(249, 250, 251, var(--border-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:border-gray-100 {\n    --border-opacity: 1;\n    border-color: #f4f5f7;\n    border-color: rgba(244, 245, 247, var(--border-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:border-gray-200 {\n    --border-opacity: 1;\n    border-color: #e5e7eb;\n    border-color: rgba(229, 231, 235, var(--border-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:border-gray-300 {\n    --border-opacity: 1;\n    border-color: #d2d6dc;\n    border-color: rgba(210, 214, 220, var(--border-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:border-gray-400 {\n    --border-opacity: 1;\n    border-color: #9fa6b2;\n    border-color: rgba(159, 166, 178, var(--border-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:border-gray-500 {\n    --border-opacity: 1;\n    border-color: #6b7280;\n    border-color: rgba(107, 114, 128, var(--border-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:border-gray-600 {\n    --border-opacity: 1;\n    border-color: #4b5563;\n    border-color: rgba(75, 85, 99, var(--border-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:border-gray-700 {\n    --border-opacity: 1;\n    border-color: #374151;\n    border-color: rgba(55, 65, 81, var(--border-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:border-gray-800 {\n    --border-opacity: 1;\n    border-color: #252f3f;\n    border-color: rgba(37, 47, 63, var(--border-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:border-gray-900 {\n    --border-opacity: 1;\n    border-color: #161e2e;\n    border-color: rgba(22, 30, 46, var(--border-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:border-red-50 {\n    --border-opacity: 1;\n    border-color: #fdf2f2;\n    border-color: rgba(253, 242, 242, var(--border-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:border-red-100 {\n    --border-opacity: 1;\n    border-color: #fde8e8;\n    border-color: rgba(253, 232, 232, var(--border-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:border-red-200 {\n    --border-opacity: 1;\n    border-color: #fbd5d5;\n    border-color: rgba(251, 213, 213, var(--border-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:border-red-300 {\n    --border-opacity: 1;\n    border-color: #f8b4b4;\n    border-color: rgba(248, 180, 180, var(--border-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:border-red-400 {\n    --border-opacity: 1;\n    border-color: #f98080;\n    border-color: rgba(249, 128, 128, var(--border-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:border-red-500 {\n    --border-opacity: 1;\n    border-color: #f05252;\n    border-color: rgba(240, 82, 82, var(--border-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:border-red-600 {\n    --border-opacity: 1;\n    border-color: #e02424;\n    border-color: rgba(224, 36, 36, var(--border-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:border-red-700 {\n    --border-opacity: 1;\n    border-color: #c81e1e;\n    border-color: rgba(200, 30, 30, var(--border-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:border-red-800 {\n    --border-opacity: 1;\n    border-color: #9b1c1c;\n    border-color: rgba(155, 28, 28, var(--border-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:border-red-900 {\n    --border-opacity: 1;\n    border-color: #771d1d;\n    border-color: rgba(119, 29, 29, var(--border-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:border-orange-50 {\n    --border-opacity: 1;\n    border-color: #fff8f1;\n    border-color: rgba(255, 248, 241, var(--border-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:border-orange-100 {\n    --border-opacity: 1;\n    border-color: #feecdc;\n    border-color: rgba(254, 236, 220, var(--border-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:border-orange-200 {\n    --border-opacity: 1;\n    border-color: #fcd9bd;\n    border-color: rgba(252, 217, 189, var(--border-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:border-orange-300 {\n    --border-opacity: 1;\n    border-color: #fdba8c;\n    border-color: rgba(253, 186, 140, var(--border-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:border-orange-400 {\n    --border-opacity: 1;\n    border-color: #ff8a4c;\n    border-color: rgba(255, 138, 76, var(--border-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:border-orange-500 {\n    --border-opacity: 1;\n    border-color: #ff5a1f;\n    border-color: rgba(255, 90, 31, var(--border-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:border-orange-600 {\n    --border-opacity: 1;\n    border-color: #d03801;\n    border-color: rgba(208, 56, 1, var(--border-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:border-orange-700 {\n    --border-opacity: 1;\n    border-color: #b43403;\n    border-color: rgba(180, 52, 3, var(--border-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:border-orange-800 {\n    --border-opacity: 1;\n    border-color: #8a2c0d;\n    border-color: rgba(138, 44, 13, var(--border-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:border-orange-900 {\n    --border-opacity: 1;\n    border-color: #73230d;\n    border-color: rgba(115, 35, 13, var(--border-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:border-yellow-50 {\n    --border-opacity: 1;\n    border-color: #fdfdea;\n    border-color: rgba(253, 253, 234, var(--border-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:border-yellow-100 {\n    --border-opacity: 1;\n    border-color: #fdf6b2;\n    border-color: rgba(253, 246, 178, var(--border-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:border-yellow-200 {\n    --border-opacity: 1;\n    border-color: #fce96a;\n    border-color: rgba(252, 233, 106, var(--border-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:border-yellow-300 {\n    --border-opacity: 1;\n    border-color: #faca15;\n    border-color: rgba(250, 202, 21, var(--border-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:border-yellow-400 {\n    --border-opacity: 1;\n    border-color: #e3a008;\n    border-color: rgba(227, 160, 8, var(--border-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:border-yellow-500 {\n    --border-opacity: 1;\n    border-color: #c27803;\n    border-color: rgba(194, 120, 3, var(--border-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:border-yellow-600 {\n    --border-opacity: 1;\n    border-color: #9f580a;\n    border-color: rgba(159, 88, 10, var(--border-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:border-yellow-700 {\n    --border-opacity: 1;\n    border-color: #8e4b10;\n    border-color: rgba(142, 75, 16, var(--border-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:border-yellow-800 {\n    --border-opacity: 1;\n    border-color: #723b13;\n    border-color: rgba(114, 59, 19, var(--border-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:border-yellow-900 {\n    --border-opacity: 1;\n    border-color: #633112;\n    border-color: rgba(99, 49, 18, var(--border-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:border-green-50 {\n    --border-opacity: 1;\n    border-color: #f3faf7;\n    border-color: rgba(243, 250, 247, var(--border-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:border-green-100 {\n    --border-opacity: 1;\n    border-color: #def7ec;\n    border-color: rgba(222, 247, 236, var(--border-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:border-green-200 {\n    --border-opacity: 1;\n    border-color: #bcf0da;\n    border-color: rgba(188, 240, 218, var(--border-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:border-green-300 {\n    --border-opacity: 1;\n    border-color: #84e1bc;\n    border-color: rgba(132, 225, 188, var(--border-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:border-green-400 {\n    --border-opacity: 1;\n    border-color: #31c48d;\n    border-color: rgba(49, 196, 141, var(--border-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:border-green-500 {\n    --border-opacity: 1;\n    border-color: #0e9f6e;\n    border-color: rgba(14, 159, 110, var(--border-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:border-green-600 {\n    --border-opacity: 1;\n    border-color: #057a55;\n    border-color: rgba(5, 122, 85, var(--border-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:border-green-700 {\n    --border-opacity: 1;\n    border-color: #046c4e;\n    border-color: rgba(4, 108, 78, var(--border-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:border-green-800 {\n    --border-opacity: 1;\n    border-color: #03543f;\n    border-color: rgba(3, 84, 63, var(--border-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:border-green-900 {\n    --border-opacity: 1;\n    border-color: #014737;\n    border-color: rgba(1, 71, 55, var(--border-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:border-teal-50 {\n    --border-opacity: 1;\n    border-color: #edfafa;\n    border-color: rgba(237, 250, 250, var(--border-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:border-teal-100 {\n    --border-opacity: 1;\n    border-color: #d5f5f6;\n    border-color: rgba(213, 245, 246, var(--border-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:border-teal-200 {\n    --border-opacity: 1;\n    border-color: #afecef;\n    border-color: rgba(175, 236, 239, var(--border-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:border-teal-300 {\n    --border-opacity: 1;\n    border-color: #7edce2;\n    border-color: rgba(126, 220, 226, var(--border-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:border-teal-400 {\n    --border-opacity: 1;\n    border-color: #16bdca;\n    border-color: rgba(22, 189, 202, var(--border-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:border-teal-500 {\n    --border-opacity: 1;\n    border-color: #0694a2;\n    border-color: rgba(6, 148, 162, var(--border-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:border-teal-600 {\n    --border-opacity: 1;\n    border-color: #047481;\n    border-color: rgba(4, 116, 129, var(--border-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:border-teal-700 {\n    --border-opacity: 1;\n    border-color: #036672;\n    border-color: rgba(3, 102, 114, var(--border-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:border-teal-800 {\n    --border-opacity: 1;\n    border-color: #05505c;\n    border-color: rgba(5, 80, 92, var(--border-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:border-teal-900 {\n    --border-opacity: 1;\n    border-color: #014451;\n    border-color: rgba(1, 68, 81, var(--border-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:border-blue-50 {\n    --border-opacity: 1;\n    border-color: #ebf5ff;\n    border-color: rgba(235, 245, 255, var(--border-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:border-blue-100 {\n    --border-opacity: 1;\n    border-color: #e1effe;\n    border-color: rgba(225, 239, 254, var(--border-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:border-blue-200 {\n    --border-opacity: 1;\n    border-color: #c3ddfd;\n    border-color: rgba(195, 221, 253, var(--border-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:border-blue-300 {\n    --border-opacity: 1;\n    border-color: #a4cafe;\n    border-color: rgba(164, 202, 254, var(--border-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:border-blue-400 {\n    --border-opacity: 1;\n    border-color: #76a9fa;\n    border-color: rgba(118, 169, 250, var(--border-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:border-blue-500 {\n    --border-opacity: 1;\n    border-color: #3f83f8;\n    border-color: rgba(63, 131, 248, var(--border-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:border-blue-600 {\n    --border-opacity: 1;\n    border-color: #1c64f2;\n    border-color: rgba(28, 100, 242, var(--border-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:border-blue-700 {\n    --border-opacity: 1;\n    border-color: #1a56db;\n    border-color: rgba(26, 86, 219, var(--border-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:border-blue-800 {\n    --border-opacity: 1;\n    border-color: #1e429f;\n    border-color: rgba(30, 66, 159, var(--border-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:border-blue-900 {\n    --border-opacity: 1;\n    border-color: #233876;\n    border-color: rgba(35, 56, 118, var(--border-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:border-indigo-50 {\n    --border-opacity: 1;\n    border-color: #f0f5ff;\n    border-color: rgba(240, 245, 255, var(--border-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:border-indigo-100 {\n    --border-opacity: 1;\n    border-color: #e5edff;\n    border-color: rgba(229, 237, 255, var(--border-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:border-indigo-200 {\n    --border-opacity: 1;\n    border-color: #cddbfe;\n    border-color: rgba(205, 219, 254, var(--border-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:border-indigo-300 {\n    --border-opacity: 1;\n    border-color: #b4c6fc;\n    border-color: rgba(180, 198, 252, var(--border-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:border-indigo-400 {\n    --border-opacity: 1;\n    border-color: #8da2fb;\n    border-color: rgba(141, 162, 251, var(--border-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:border-indigo-500 {\n    --border-opacity: 1;\n    border-color: #6875f5;\n    border-color: rgba(104, 117, 245, var(--border-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:border-indigo-600 {\n    --border-opacity: 1;\n    border-color: #5850ec;\n    border-color: rgba(88, 80, 236, var(--border-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:border-indigo-700 {\n    --border-opacity: 1;\n    border-color: #5145cd;\n    border-color: rgba(81, 69, 205, var(--border-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:border-indigo-800 {\n    --border-opacity: 1;\n    border-color: #42389d;\n    border-color: rgba(66, 56, 157, var(--border-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:border-indigo-900 {\n    --border-opacity: 1;\n    border-color: #362f78;\n    border-color: rgba(54, 47, 120, var(--border-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:border-purple-50 {\n    --border-opacity: 1;\n    border-color: #f6f5ff;\n    border-color: rgba(246, 245, 255, var(--border-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:border-purple-100 {\n    --border-opacity: 1;\n    border-color: #edebfe;\n    border-color: rgba(237, 235, 254, var(--border-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:border-purple-200 {\n    --border-opacity: 1;\n    border-color: #dcd7fe;\n    border-color: rgba(220, 215, 254, var(--border-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:border-purple-300 {\n    --border-opacity: 1;\n    border-color: #cabffd;\n    border-color: rgba(202, 191, 253, var(--border-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:border-purple-400 {\n    --border-opacity: 1;\n    border-color: #ac94fa;\n    border-color: rgba(172, 148, 250, var(--border-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:border-purple-500 {\n    --border-opacity: 1;\n    border-color: #9061f9;\n    border-color: rgba(144, 97, 249, var(--border-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:border-purple-600 {\n    --border-opacity: 1;\n    border-color: #7e3af2;\n    border-color: rgba(126, 58, 242, var(--border-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:border-purple-700 {\n    --border-opacity: 1;\n    border-color: #6c2bd9;\n    border-color: rgba(108, 43, 217, var(--border-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:border-purple-800 {\n    --border-opacity: 1;\n    border-color: #5521b5;\n    border-color: rgba(85, 33, 181, var(--border-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:border-purple-900 {\n    --border-opacity: 1;\n    border-color: #4a1d96;\n    border-color: rgba(74, 29, 150, var(--border-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:border-pink-50 {\n    --border-opacity: 1;\n    border-color: #fdf2f8;\n    border-color: rgba(253, 242, 248, var(--border-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:border-pink-100 {\n    --border-opacity: 1;\n    border-color: #fce8f3;\n    border-color: rgba(252, 232, 243, var(--border-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:border-pink-200 {\n    --border-opacity: 1;\n    border-color: #fad1e8;\n    border-color: rgba(250, 209, 232, var(--border-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:border-pink-300 {\n    --border-opacity: 1;\n    border-color: #f8b4d9;\n    border-color: rgba(248, 180, 217, var(--border-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:border-pink-400 {\n    --border-opacity: 1;\n    border-color: #f17eb8;\n    border-color: rgba(241, 126, 184, var(--border-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:border-pink-500 {\n    --border-opacity: 1;\n    border-color: #e74694;\n    border-color: rgba(231, 70, 148, var(--border-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:border-pink-600 {\n    --border-opacity: 1;\n    border-color: #d61f69;\n    border-color: rgba(214, 31, 105, var(--border-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:border-pink-700 {\n    --border-opacity: 1;\n    border-color: #bf125d;\n    border-color: rgba(191, 18, 93, var(--border-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:border-pink-800 {\n    --border-opacity: 1;\n    border-color: #99154b;\n    border-color: rgba(153, 21, 75, var(--border-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:border-pink-900 {\n    --border-opacity: 1;\n    border-color: #751a3d;\n    border-color: rgba(117, 26, 61, var(--border-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:border-cool-gray-50 {\n    --border-opacity: 1;\n    border-color: #f8fafc;\n    border-color: rgba(248, 250, 252, var(--border-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:border-cool-gray-100 {\n    --border-opacity: 1;\n    border-color: #f1f5f9;\n    border-color: rgba(241, 245, 249, var(--border-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:border-cool-gray-200 {\n    --border-opacity: 1;\n    border-color: #e2e8f0;\n    border-color: rgba(226, 232, 240, var(--border-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:border-cool-gray-300 {\n    --border-opacity: 1;\n    border-color: #cfd8e3;\n    border-color: rgba(207, 216, 227, var(--border-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:border-cool-gray-400 {\n    --border-opacity: 1;\n    border-color: #97a6ba;\n    border-color: rgba(151, 166, 186, var(--border-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:border-cool-gray-500 {\n    --border-opacity: 1;\n    border-color: #64748b;\n    border-color: rgba(100, 116, 139, var(--border-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:border-cool-gray-600 {\n    --border-opacity: 1;\n    border-color: #475569;\n    border-color: rgba(71, 85, 105, var(--border-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:border-cool-gray-700 {\n    --border-opacity: 1;\n    border-color: #364152;\n    border-color: rgba(54, 65, 82, var(--border-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:border-cool-gray-800 {\n    --border-opacity: 1;\n    border-color: #27303f;\n    border-color: rgba(39, 48, 63, var(--border-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:border-cool-gray-900 {\n    --border-opacity: 1;\n    border-color: #1a202e;\n    border-color: rgba(26, 32, 46, var(--border-opacity));\n  }\n  .lg\\:hover\\:border-current:hover {\n    border-color: currentColor;\n  }\n  .lg\\:hover\\:border-transparent:hover {\n    border-color: transparent;\n  }\n  .lg\\:hover\\:border-white:hover {\n    --border-opacity: 1;\n    border-color: #ffffff;\n    border-color: rgba(255, 255, 255, var(--border-opacity));\n  }\n  .lg\\:hover\\:border-black:hover {\n    --border-opacity: 1;\n    border-color: #000000;\n    border-color: rgba(0, 0, 0, var(--border-opacity));\n  }\n  .lg\\:hover\\:border-gray-50:hover {\n    --border-opacity: 1;\n    border-color: #f9fafb;\n    border-color: rgba(249, 250, 251, var(--border-opacity));\n  }\n  .lg\\:hover\\:border-gray-100:hover {\n    --border-opacity: 1;\n    border-color: #f4f5f7;\n    border-color: rgba(244, 245, 247, var(--border-opacity));\n  }\n  .lg\\:hover\\:border-gray-200:hover {\n    --border-opacity: 1;\n    border-color: #e5e7eb;\n    border-color: rgba(229, 231, 235, var(--border-opacity));\n  }\n  .lg\\:hover\\:border-gray-300:hover {\n    --border-opacity: 1;\n    border-color: #d2d6dc;\n    border-color: rgba(210, 214, 220, var(--border-opacity));\n  }\n  .lg\\:hover\\:border-gray-400:hover {\n    --border-opacity: 1;\n    border-color: #9fa6b2;\n    border-color: rgba(159, 166, 178, var(--border-opacity));\n  }\n  .lg\\:hover\\:border-gray-500:hover {\n    --border-opacity: 1;\n    border-color: #6b7280;\n    border-color: rgba(107, 114, 128, var(--border-opacity));\n  }\n  .lg\\:hover\\:border-gray-600:hover {\n    --border-opacity: 1;\n    border-color: #4b5563;\n    border-color: rgba(75, 85, 99, var(--border-opacity));\n  }\n  .lg\\:hover\\:border-gray-700:hover {\n    --border-opacity: 1;\n    border-color: #374151;\n    border-color: rgba(55, 65, 81, var(--border-opacity));\n  }\n  .lg\\:hover\\:border-gray-800:hover {\n    --border-opacity: 1;\n    border-color: #252f3f;\n    border-color: rgba(37, 47, 63, var(--border-opacity));\n  }\n  .lg\\:hover\\:border-gray-900:hover {\n    --border-opacity: 1;\n    border-color: #161e2e;\n    border-color: rgba(22, 30, 46, var(--border-opacity));\n  }\n  .lg\\:hover\\:border-red-50:hover {\n    --border-opacity: 1;\n    border-color: #fdf2f2;\n    border-color: rgba(253, 242, 242, var(--border-opacity));\n  }\n  .lg\\:hover\\:border-red-100:hover {\n    --border-opacity: 1;\n    border-color: #fde8e8;\n    border-color: rgba(253, 232, 232, var(--border-opacity));\n  }\n  .lg\\:hover\\:border-red-200:hover {\n    --border-opacity: 1;\n    border-color: #fbd5d5;\n    border-color: rgba(251, 213, 213, var(--border-opacity));\n  }\n  .lg\\:hover\\:border-red-300:hover {\n    --border-opacity: 1;\n    border-color: #f8b4b4;\n    border-color: rgba(248, 180, 180, var(--border-opacity));\n  }\n  .lg\\:hover\\:border-red-400:hover {\n    --border-opacity: 1;\n    border-color: #f98080;\n    border-color: rgba(249, 128, 128, var(--border-opacity));\n  }\n  .lg\\:hover\\:border-red-500:hover {\n    --border-opacity: 1;\n    border-color: #f05252;\n    border-color: rgba(240, 82, 82, var(--border-opacity));\n  }\n  .lg\\:hover\\:border-red-600:hover {\n    --border-opacity: 1;\n    border-color: #e02424;\n    border-color: rgba(224, 36, 36, var(--border-opacity));\n  }\n  .lg\\:hover\\:border-red-700:hover {\n    --border-opacity: 1;\n    border-color: #c81e1e;\n    border-color: rgba(200, 30, 30, var(--border-opacity));\n  }\n  .lg\\:hover\\:border-red-800:hover {\n    --border-opacity: 1;\n    border-color: #9b1c1c;\n    border-color: rgba(155, 28, 28, var(--border-opacity));\n  }\n  .lg\\:hover\\:border-red-900:hover {\n    --border-opacity: 1;\n    border-color: #771d1d;\n    border-color: rgba(119, 29, 29, var(--border-opacity));\n  }\n  .lg\\:hover\\:border-orange-50:hover {\n    --border-opacity: 1;\n    border-color: #fff8f1;\n    border-color: rgba(255, 248, 241, var(--border-opacity));\n  }\n  .lg\\:hover\\:border-orange-100:hover {\n    --border-opacity: 1;\n    border-color: #feecdc;\n    border-color: rgba(254, 236, 220, var(--border-opacity));\n  }\n  .lg\\:hover\\:border-orange-200:hover {\n    --border-opacity: 1;\n    border-color: #fcd9bd;\n    border-color: rgba(252, 217, 189, var(--border-opacity));\n  }\n  .lg\\:hover\\:border-orange-300:hover {\n    --border-opacity: 1;\n    border-color: #fdba8c;\n    border-color: rgba(253, 186, 140, var(--border-opacity));\n  }\n  .lg\\:hover\\:border-orange-400:hover {\n    --border-opacity: 1;\n    border-color: #ff8a4c;\n    border-color: rgba(255, 138, 76, var(--border-opacity));\n  }\n  .lg\\:hover\\:border-orange-500:hover {\n    --border-opacity: 1;\n    border-color: #ff5a1f;\n    border-color: rgba(255, 90, 31, var(--border-opacity));\n  }\n  .lg\\:hover\\:border-orange-600:hover {\n    --border-opacity: 1;\n    border-color: #d03801;\n    border-color: rgba(208, 56, 1, var(--border-opacity));\n  }\n  .lg\\:hover\\:border-orange-700:hover {\n    --border-opacity: 1;\n    border-color: #b43403;\n    border-color: rgba(180, 52, 3, var(--border-opacity));\n  }\n  .lg\\:hover\\:border-orange-800:hover {\n    --border-opacity: 1;\n    border-color: #8a2c0d;\n    border-color: rgba(138, 44, 13, var(--border-opacity));\n  }\n  .lg\\:hover\\:border-orange-900:hover {\n    --border-opacity: 1;\n    border-color: #73230d;\n    border-color: rgba(115, 35, 13, var(--border-opacity));\n  }\n  .lg\\:hover\\:border-yellow-50:hover {\n    --border-opacity: 1;\n    border-color: #fdfdea;\n    border-color: rgba(253, 253, 234, var(--border-opacity));\n  }\n  .lg\\:hover\\:border-yellow-100:hover {\n    --border-opacity: 1;\n    border-color: #fdf6b2;\n    border-color: rgba(253, 246, 178, var(--border-opacity));\n  }\n  .lg\\:hover\\:border-yellow-200:hover {\n    --border-opacity: 1;\n    border-color: #fce96a;\n    border-color: rgba(252, 233, 106, var(--border-opacity));\n  }\n  .lg\\:hover\\:border-yellow-300:hover {\n    --border-opacity: 1;\n    border-color: #faca15;\n    border-color: rgba(250, 202, 21, var(--border-opacity));\n  }\n  .lg\\:hover\\:border-yellow-400:hover {\n    --border-opacity: 1;\n    border-color: #e3a008;\n    border-color: rgba(227, 160, 8, var(--border-opacity));\n  }\n  .lg\\:hover\\:border-yellow-500:hover {\n    --border-opacity: 1;\n    border-color: #c27803;\n    border-color: rgba(194, 120, 3, var(--border-opacity));\n  }\n  .lg\\:hover\\:border-yellow-600:hover {\n    --border-opacity: 1;\n    border-color: #9f580a;\n    border-color: rgba(159, 88, 10, var(--border-opacity));\n  }\n  .lg\\:hover\\:border-yellow-700:hover {\n    --border-opacity: 1;\n    border-color: #8e4b10;\n    border-color: rgba(142, 75, 16, var(--border-opacity));\n  }\n  .lg\\:hover\\:border-yellow-800:hover {\n    --border-opacity: 1;\n    border-color: #723b13;\n    border-color: rgba(114, 59, 19, var(--border-opacity));\n  }\n  .lg\\:hover\\:border-yellow-900:hover {\n    --border-opacity: 1;\n    border-color: #633112;\n    border-color: rgba(99, 49, 18, var(--border-opacity));\n  }\n  .lg\\:hover\\:border-green-50:hover {\n    --border-opacity: 1;\n    border-color: #f3faf7;\n    border-color: rgba(243, 250, 247, var(--border-opacity));\n  }\n  .lg\\:hover\\:border-green-100:hover {\n    --border-opacity: 1;\n    border-color: #def7ec;\n    border-color: rgba(222, 247, 236, var(--border-opacity));\n  }\n  .lg\\:hover\\:border-green-200:hover {\n    --border-opacity: 1;\n    border-color: #bcf0da;\n    border-color: rgba(188, 240, 218, var(--border-opacity));\n  }\n  .lg\\:hover\\:border-green-300:hover {\n    --border-opacity: 1;\n    border-color: #84e1bc;\n    border-color: rgba(132, 225, 188, var(--border-opacity));\n  }\n  .lg\\:hover\\:border-green-400:hover {\n    --border-opacity: 1;\n    border-color: #31c48d;\n    border-color: rgba(49, 196, 141, var(--border-opacity));\n  }\n  .lg\\:hover\\:border-green-500:hover {\n    --border-opacity: 1;\n    border-color: #0e9f6e;\n    border-color: rgba(14, 159, 110, var(--border-opacity));\n  }\n  .lg\\:hover\\:border-green-600:hover {\n    --border-opacity: 1;\n    border-color: #057a55;\n    border-color: rgba(5, 122, 85, var(--border-opacity));\n  }\n  .lg\\:hover\\:border-green-700:hover {\n    --border-opacity: 1;\n    border-color: #046c4e;\n    border-color: rgba(4, 108, 78, var(--border-opacity));\n  }\n  .lg\\:hover\\:border-green-800:hover {\n    --border-opacity: 1;\n    border-color: #03543f;\n    border-color: rgba(3, 84, 63, var(--border-opacity));\n  }\n  .lg\\:hover\\:border-green-900:hover {\n    --border-opacity: 1;\n    border-color: #014737;\n    border-color: rgba(1, 71, 55, var(--border-opacity));\n  }\n  .lg\\:hover\\:border-teal-50:hover {\n    --border-opacity: 1;\n    border-color: #edfafa;\n    border-color: rgba(237, 250, 250, var(--border-opacity));\n  }\n  .lg\\:hover\\:border-teal-100:hover {\n    --border-opacity: 1;\n    border-color: #d5f5f6;\n    border-color: rgba(213, 245, 246, var(--border-opacity));\n  }\n  .lg\\:hover\\:border-teal-200:hover {\n    --border-opacity: 1;\n    border-color: #afecef;\n    border-color: rgba(175, 236, 239, var(--border-opacity));\n  }\n  .lg\\:hover\\:border-teal-300:hover {\n    --border-opacity: 1;\n    border-color: #7edce2;\n    border-color: rgba(126, 220, 226, var(--border-opacity));\n  }\n  .lg\\:hover\\:border-teal-400:hover {\n    --border-opacity: 1;\n    border-color: #16bdca;\n    border-color: rgba(22, 189, 202, var(--border-opacity));\n  }\n  .lg\\:hover\\:border-teal-500:hover {\n    --border-opacity: 1;\n    border-color: #0694a2;\n    border-color: rgba(6, 148, 162, var(--border-opacity));\n  }\n  .lg\\:hover\\:border-teal-600:hover {\n    --border-opacity: 1;\n    border-color: #047481;\n    border-color: rgba(4, 116, 129, var(--border-opacity));\n  }\n  .lg\\:hover\\:border-teal-700:hover {\n    --border-opacity: 1;\n    border-color: #036672;\n    border-color: rgba(3, 102, 114, var(--border-opacity));\n  }\n  .lg\\:hover\\:border-teal-800:hover {\n    --border-opacity: 1;\n    border-color: #05505c;\n    border-color: rgba(5, 80, 92, var(--border-opacity));\n  }\n  .lg\\:hover\\:border-teal-900:hover {\n    --border-opacity: 1;\n    border-color: #014451;\n    border-color: rgba(1, 68, 81, var(--border-opacity));\n  }\n  .lg\\:hover\\:border-blue-50:hover {\n    --border-opacity: 1;\n    border-color: #ebf5ff;\n    border-color: rgba(235, 245, 255, var(--border-opacity));\n  }\n  .lg\\:hover\\:border-blue-100:hover {\n    --border-opacity: 1;\n    border-color: #e1effe;\n    border-color: rgba(225, 239, 254, var(--border-opacity));\n  }\n  .lg\\:hover\\:border-blue-200:hover {\n    --border-opacity: 1;\n    border-color: #c3ddfd;\n    border-color: rgba(195, 221, 253, var(--border-opacity));\n  }\n  .lg\\:hover\\:border-blue-300:hover {\n    --border-opacity: 1;\n    border-color: #a4cafe;\n    border-color: rgba(164, 202, 254, var(--border-opacity));\n  }\n  .lg\\:hover\\:border-blue-400:hover {\n    --border-opacity: 1;\n    border-color: #76a9fa;\n    border-color: rgba(118, 169, 250, var(--border-opacity));\n  }\n  .lg\\:hover\\:border-blue-500:hover {\n    --border-opacity: 1;\n    border-color: #3f83f8;\n    border-color: rgba(63, 131, 248, var(--border-opacity));\n  }\n  .lg\\:hover\\:border-blue-600:hover {\n    --border-opacity: 1;\n    border-color: #1c64f2;\n    border-color: rgba(28, 100, 242, var(--border-opacity));\n  }\n  .lg\\:hover\\:border-blue-700:hover {\n    --border-opacity: 1;\n    border-color: #1a56db;\n    border-color: rgba(26, 86, 219, var(--border-opacity));\n  }\n  .lg\\:hover\\:border-blue-800:hover {\n    --border-opacity: 1;\n    border-color: #1e429f;\n    border-color: rgba(30, 66, 159, var(--border-opacity));\n  }\n  .lg\\:hover\\:border-blue-900:hover {\n    --border-opacity: 1;\n    border-color: #233876;\n    border-color: rgba(35, 56, 118, var(--border-opacity));\n  }\n  .lg\\:hover\\:border-indigo-50:hover {\n    --border-opacity: 1;\n    border-color: #f0f5ff;\n    border-color: rgba(240, 245, 255, var(--border-opacity));\n  }\n  .lg\\:hover\\:border-indigo-100:hover {\n    --border-opacity: 1;\n    border-color: #e5edff;\n    border-color: rgba(229, 237, 255, var(--border-opacity));\n  }\n  .lg\\:hover\\:border-indigo-200:hover {\n    --border-opacity: 1;\n    border-color: #cddbfe;\n    border-color: rgba(205, 219, 254, var(--border-opacity));\n  }\n  .lg\\:hover\\:border-indigo-300:hover {\n    --border-opacity: 1;\n    border-color: #b4c6fc;\n    border-color: rgba(180, 198, 252, var(--border-opacity));\n  }\n  .lg\\:hover\\:border-indigo-400:hover {\n    --border-opacity: 1;\n    border-color: #8da2fb;\n    border-color: rgba(141, 162, 251, var(--border-opacity));\n  }\n  .lg\\:hover\\:border-indigo-500:hover {\n    --border-opacity: 1;\n    border-color: #6875f5;\n    border-color: rgba(104, 117, 245, var(--border-opacity));\n  }\n  .lg\\:hover\\:border-indigo-600:hover {\n    --border-opacity: 1;\n    border-color: #5850ec;\n    border-color: rgba(88, 80, 236, var(--border-opacity));\n  }\n  .lg\\:hover\\:border-indigo-700:hover {\n    --border-opacity: 1;\n    border-color: #5145cd;\n    border-color: rgba(81, 69, 205, var(--border-opacity));\n  }\n  .lg\\:hover\\:border-indigo-800:hover {\n    --border-opacity: 1;\n    border-color: #42389d;\n    border-color: rgba(66, 56, 157, var(--border-opacity));\n  }\n  .lg\\:hover\\:border-indigo-900:hover {\n    --border-opacity: 1;\n    border-color: #362f78;\n    border-color: rgba(54, 47, 120, var(--border-opacity));\n  }\n  .lg\\:hover\\:border-purple-50:hover {\n    --border-opacity: 1;\n    border-color: #f6f5ff;\n    border-color: rgba(246, 245, 255, var(--border-opacity));\n  }\n  .lg\\:hover\\:border-purple-100:hover {\n    --border-opacity: 1;\n    border-color: #edebfe;\n    border-color: rgba(237, 235, 254, var(--border-opacity));\n  }\n  .lg\\:hover\\:border-purple-200:hover {\n    --border-opacity: 1;\n    border-color: #dcd7fe;\n    border-color: rgba(220, 215, 254, var(--border-opacity));\n  }\n  .lg\\:hover\\:border-purple-300:hover {\n    --border-opacity: 1;\n    border-color: #cabffd;\n    border-color: rgba(202, 191, 253, var(--border-opacity));\n  }\n  .lg\\:hover\\:border-purple-400:hover {\n    --border-opacity: 1;\n    border-color: #ac94fa;\n    border-color: rgba(172, 148, 250, var(--border-opacity));\n  }\n  .lg\\:hover\\:border-purple-500:hover {\n    --border-opacity: 1;\n    border-color: #9061f9;\n    border-color: rgba(144, 97, 249, var(--border-opacity));\n  }\n  .lg\\:hover\\:border-purple-600:hover {\n    --border-opacity: 1;\n    border-color: #7e3af2;\n    border-color: rgba(126, 58, 242, var(--border-opacity));\n  }\n  .lg\\:hover\\:border-purple-700:hover {\n    --border-opacity: 1;\n    border-color: #6c2bd9;\n    border-color: rgba(108, 43, 217, var(--border-opacity));\n  }\n  .lg\\:hover\\:border-purple-800:hover {\n    --border-opacity: 1;\n    border-color: #5521b5;\n    border-color: rgba(85, 33, 181, var(--border-opacity));\n  }\n  .lg\\:hover\\:border-purple-900:hover {\n    --border-opacity: 1;\n    border-color: #4a1d96;\n    border-color: rgba(74, 29, 150, var(--border-opacity));\n  }\n  .lg\\:hover\\:border-pink-50:hover {\n    --border-opacity: 1;\n    border-color: #fdf2f8;\n    border-color: rgba(253, 242, 248, var(--border-opacity));\n  }\n  .lg\\:hover\\:border-pink-100:hover {\n    --border-opacity: 1;\n    border-color: #fce8f3;\n    border-color: rgba(252, 232, 243, var(--border-opacity));\n  }\n  .lg\\:hover\\:border-pink-200:hover {\n    --border-opacity: 1;\n    border-color: #fad1e8;\n    border-color: rgba(250, 209, 232, var(--border-opacity));\n  }\n  .lg\\:hover\\:border-pink-300:hover {\n    --border-opacity: 1;\n    border-color: #f8b4d9;\n    border-color: rgba(248, 180, 217, var(--border-opacity));\n  }\n  .lg\\:hover\\:border-pink-400:hover {\n    --border-opacity: 1;\n    border-color: #f17eb8;\n    border-color: rgba(241, 126, 184, var(--border-opacity));\n  }\n  .lg\\:hover\\:border-pink-500:hover {\n    --border-opacity: 1;\n    border-color: #e74694;\n    border-color: rgba(231, 70, 148, var(--border-opacity));\n  }\n  .lg\\:hover\\:border-pink-600:hover {\n    --border-opacity: 1;\n    border-color: #d61f69;\n    border-color: rgba(214, 31, 105, var(--border-opacity));\n  }\n  .lg\\:hover\\:border-pink-700:hover {\n    --border-opacity: 1;\n    border-color: #bf125d;\n    border-color: rgba(191, 18, 93, var(--border-opacity));\n  }\n  .lg\\:hover\\:border-pink-800:hover {\n    --border-opacity: 1;\n    border-color: #99154b;\n    border-color: rgba(153, 21, 75, var(--border-opacity));\n  }\n  .lg\\:hover\\:border-pink-900:hover {\n    --border-opacity: 1;\n    border-color: #751a3d;\n    border-color: rgba(117, 26, 61, var(--border-opacity));\n  }\n  .lg\\:hover\\:border-cool-gray-50:hover {\n    --border-opacity: 1;\n    border-color: #f8fafc;\n    border-color: rgba(248, 250, 252, var(--border-opacity));\n  }\n  .lg\\:hover\\:border-cool-gray-100:hover {\n    --border-opacity: 1;\n    border-color: #f1f5f9;\n    border-color: rgba(241, 245, 249, var(--border-opacity));\n  }\n  .lg\\:hover\\:border-cool-gray-200:hover {\n    --border-opacity: 1;\n    border-color: #e2e8f0;\n    border-color: rgba(226, 232, 240, var(--border-opacity));\n  }\n  .lg\\:hover\\:border-cool-gray-300:hover {\n    --border-opacity: 1;\n    border-color: #cfd8e3;\n    border-color: rgba(207, 216, 227, var(--border-opacity));\n  }\n  .lg\\:hover\\:border-cool-gray-400:hover {\n    --border-opacity: 1;\n    border-color: #97a6ba;\n    border-color: rgba(151, 166, 186, var(--border-opacity));\n  }\n  .lg\\:hover\\:border-cool-gray-500:hover {\n    --border-opacity: 1;\n    border-color: #64748b;\n    border-color: rgba(100, 116, 139, var(--border-opacity));\n  }\n  .lg\\:hover\\:border-cool-gray-600:hover {\n    --border-opacity: 1;\n    border-color: #475569;\n    border-color: rgba(71, 85, 105, var(--border-opacity));\n  }\n  .lg\\:hover\\:border-cool-gray-700:hover {\n    --border-opacity: 1;\n    border-color: #364152;\n    border-color: rgba(54, 65, 82, var(--border-opacity));\n  }\n  .lg\\:hover\\:border-cool-gray-800:hover {\n    --border-opacity: 1;\n    border-color: #27303f;\n    border-color: rgba(39, 48, 63, var(--border-opacity));\n  }\n  .lg\\:hover\\:border-cool-gray-900:hover {\n    --border-opacity: 1;\n    border-color: #1a202e;\n    border-color: rgba(26, 32, 46, var(--border-opacity));\n  }\n  .lg\\:focus-within\\:border-current:focus-within {\n    border-color: currentColor;\n  }\n  .lg\\:focus-within\\:border-transparent:focus-within {\n    border-color: transparent;\n  }\n  .lg\\:focus-within\\:border-white:focus-within {\n    --border-opacity: 1;\n    border-color: #ffffff;\n    border-color: rgba(255, 255, 255, var(--border-opacity));\n  }\n  .lg\\:focus-within\\:border-black:focus-within {\n    --border-opacity: 1;\n    border-color: #000000;\n    border-color: rgba(0, 0, 0, var(--border-opacity));\n  }\n  .lg\\:focus-within\\:border-gray-50:focus-within {\n    --border-opacity: 1;\n    border-color: #f9fafb;\n    border-color: rgba(249, 250, 251, var(--border-opacity));\n  }\n  .lg\\:focus-within\\:border-gray-100:focus-within {\n    --border-opacity: 1;\n    border-color: #f4f5f7;\n    border-color: rgba(244, 245, 247, var(--border-opacity));\n  }\n  .lg\\:focus-within\\:border-gray-200:focus-within {\n    --border-opacity: 1;\n    border-color: #e5e7eb;\n    border-color: rgba(229, 231, 235, var(--border-opacity));\n  }\n  .lg\\:focus-within\\:border-gray-300:focus-within {\n    --border-opacity: 1;\n    border-color: #d2d6dc;\n    border-color: rgba(210, 214, 220, var(--border-opacity));\n  }\n  .lg\\:focus-within\\:border-gray-400:focus-within {\n    --border-opacity: 1;\n    border-color: #9fa6b2;\n    border-color: rgba(159, 166, 178, var(--border-opacity));\n  }\n  .lg\\:focus-within\\:border-gray-500:focus-within {\n    --border-opacity: 1;\n    border-color: #6b7280;\n    border-color: rgba(107, 114, 128, var(--border-opacity));\n  }\n  .lg\\:focus-within\\:border-gray-600:focus-within {\n    --border-opacity: 1;\n    border-color: #4b5563;\n    border-color: rgba(75, 85, 99, var(--border-opacity));\n  }\n  .lg\\:focus-within\\:border-gray-700:focus-within {\n    --border-opacity: 1;\n    border-color: #374151;\n    border-color: rgba(55, 65, 81, var(--border-opacity));\n  }\n  .lg\\:focus-within\\:border-gray-800:focus-within {\n    --border-opacity: 1;\n    border-color: #252f3f;\n    border-color: rgba(37, 47, 63, var(--border-opacity));\n  }\n  .lg\\:focus-within\\:border-gray-900:focus-within {\n    --border-opacity: 1;\n    border-color: #161e2e;\n    border-color: rgba(22, 30, 46, var(--border-opacity));\n  }\n  .lg\\:focus-within\\:border-red-50:focus-within {\n    --border-opacity: 1;\n    border-color: #fdf2f2;\n    border-color: rgba(253, 242, 242, var(--border-opacity));\n  }\n  .lg\\:focus-within\\:border-red-100:focus-within {\n    --border-opacity: 1;\n    border-color: #fde8e8;\n    border-color: rgba(253, 232, 232, var(--border-opacity));\n  }\n  .lg\\:focus-within\\:border-red-200:focus-within {\n    --border-opacity: 1;\n    border-color: #fbd5d5;\n    border-color: rgba(251, 213, 213, var(--border-opacity));\n  }\n  .lg\\:focus-within\\:border-red-300:focus-within {\n    --border-opacity: 1;\n    border-color: #f8b4b4;\n    border-color: rgba(248, 180, 180, var(--border-opacity));\n  }\n  .lg\\:focus-within\\:border-red-400:focus-within {\n    --border-opacity: 1;\n    border-color: #f98080;\n    border-color: rgba(249, 128, 128, var(--border-opacity));\n  }\n  .lg\\:focus-within\\:border-red-500:focus-within {\n    --border-opacity: 1;\n    border-color: #f05252;\n    border-color: rgba(240, 82, 82, var(--border-opacity));\n  }\n  .lg\\:focus-within\\:border-red-600:focus-within {\n    --border-opacity: 1;\n    border-color: #e02424;\n    border-color: rgba(224, 36, 36, var(--border-opacity));\n  }\n  .lg\\:focus-within\\:border-red-700:focus-within {\n    --border-opacity: 1;\n    border-color: #c81e1e;\n    border-color: rgba(200, 30, 30, var(--border-opacity));\n  }\n  .lg\\:focus-within\\:border-red-800:focus-within {\n    --border-opacity: 1;\n    border-color: #9b1c1c;\n    border-color: rgba(155, 28, 28, var(--border-opacity));\n  }\n  .lg\\:focus-within\\:border-red-900:focus-within {\n    --border-opacity: 1;\n    border-color: #771d1d;\n    border-color: rgba(119, 29, 29, var(--border-opacity));\n  }\n  .lg\\:focus-within\\:border-orange-50:focus-within {\n    --border-opacity: 1;\n    border-color: #fff8f1;\n    border-color: rgba(255, 248, 241, var(--border-opacity));\n  }\n  .lg\\:focus-within\\:border-orange-100:focus-within {\n    --border-opacity: 1;\n    border-color: #feecdc;\n    border-color: rgba(254, 236, 220, var(--border-opacity));\n  }\n  .lg\\:focus-within\\:border-orange-200:focus-within {\n    --border-opacity: 1;\n    border-color: #fcd9bd;\n    border-color: rgba(252, 217, 189, var(--border-opacity));\n  }\n  .lg\\:focus-within\\:border-orange-300:focus-within {\n    --border-opacity: 1;\n    border-color: #fdba8c;\n    border-color: rgba(253, 186, 140, var(--border-opacity));\n  }\n  .lg\\:focus-within\\:border-orange-400:focus-within {\n    --border-opacity: 1;\n    border-color: #ff8a4c;\n    border-color: rgba(255, 138, 76, var(--border-opacity));\n  }\n  .lg\\:focus-within\\:border-orange-500:focus-within {\n    --border-opacity: 1;\n    border-color: #ff5a1f;\n    border-color: rgba(255, 90, 31, var(--border-opacity));\n  }\n  .lg\\:focus-within\\:border-orange-600:focus-within {\n    --border-opacity: 1;\n    border-color: #d03801;\n    border-color: rgba(208, 56, 1, var(--border-opacity));\n  }\n  .lg\\:focus-within\\:border-orange-700:focus-within {\n    --border-opacity: 1;\n    border-color: #b43403;\n    border-color: rgba(180, 52, 3, var(--border-opacity));\n  }\n  .lg\\:focus-within\\:border-orange-800:focus-within {\n    --border-opacity: 1;\n    border-color: #8a2c0d;\n    border-color: rgba(138, 44, 13, var(--border-opacity));\n  }\n  .lg\\:focus-within\\:border-orange-900:focus-within {\n    --border-opacity: 1;\n    border-color: #73230d;\n    border-color: rgba(115, 35, 13, var(--border-opacity));\n  }\n  .lg\\:focus-within\\:border-yellow-50:focus-within {\n    --border-opacity: 1;\n    border-color: #fdfdea;\n    border-color: rgba(253, 253, 234, var(--border-opacity));\n  }\n  .lg\\:focus-within\\:border-yellow-100:focus-within {\n    --border-opacity: 1;\n    border-color: #fdf6b2;\n    border-color: rgba(253, 246, 178, var(--border-opacity));\n  }\n  .lg\\:focus-within\\:border-yellow-200:focus-within {\n    --border-opacity: 1;\n    border-color: #fce96a;\n    border-color: rgba(252, 233, 106, var(--border-opacity));\n  }\n  .lg\\:focus-within\\:border-yellow-300:focus-within {\n    --border-opacity: 1;\n    border-color: #faca15;\n    border-color: rgba(250, 202, 21, var(--border-opacity));\n  }\n  .lg\\:focus-within\\:border-yellow-400:focus-within {\n    --border-opacity: 1;\n    border-color: #e3a008;\n    border-color: rgba(227, 160, 8, var(--border-opacity));\n  }\n  .lg\\:focus-within\\:border-yellow-500:focus-within {\n    --border-opacity: 1;\n    border-color: #c27803;\n    border-color: rgba(194, 120, 3, var(--border-opacity));\n  }\n  .lg\\:focus-within\\:border-yellow-600:focus-within {\n    --border-opacity: 1;\n    border-color: #9f580a;\n    border-color: rgba(159, 88, 10, var(--border-opacity));\n  }\n  .lg\\:focus-within\\:border-yellow-700:focus-within {\n    --border-opacity: 1;\n    border-color: #8e4b10;\n    border-color: rgba(142, 75, 16, var(--border-opacity));\n  }\n  .lg\\:focus-within\\:border-yellow-800:focus-within {\n    --border-opacity: 1;\n    border-color: #723b13;\n    border-color: rgba(114, 59, 19, var(--border-opacity));\n  }\n  .lg\\:focus-within\\:border-yellow-900:focus-within {\n    --border-opacity: 1;\n    border-color: #633112;\n    border-color: rgba(99, 49, 18, var(--border-opacity));\n  }\n  .lg\\:focus-within\\:border-green-50:focus-within {\n    --border-opacity: 1;\n    border-color: #f3faf7;\n    border-color: rgba(243, 250, 247, var(--border-opacity));\n  }\n  .lg\\:focus-within\\:border-green-100:focus-within {\n    --border-opacity: 1;\n    border-color: #def7ec;\n    border-color: rgba(222, 247, 236, var(--border-opacity));\n  }\n  .lg\\:focus-within\\:border-green-200:focus-within {\n    --border-opacity: 1;\n    border-color: #bcf0da;\n    border-color: rgba(188, 240, 218, var(--border-opacity));\n  }\n  .lg\\:focus-within\\:border-green-300:focus-within {\n    --border-opacity: 1;\n    border-color: #84e1bc;\n    border-color: rgba(132, 225, 188, var(--border-opacity));\n  }\n  .lg\\:focus-within\\:border-green-400:focus-within {\n    --border-opacity: 1;\n    border-color: #31c48d;\n    border-color: rgba(49, 196, 141, var(--border-opacity));\n  }\n  .lg\\:focus-within\\:border-green-500:focus-within {\n    --border-opacity: 1;\n    border-color: #0e9f6e;\n    border-color: rgba(14, 159, 110, var(--border-opacity));\n  }\n  .lg\\:focus-within\\:border-green-600:focus-within {\n    --border-opacity: 1;\n    border-color: #057a55;\n    border-color: rgba(5, 122, 85, var(--border-opacity));\n  }\n  .lg\\:focus-within\\:border-green-700:focus-within {\n    --border-opacity: 1;\n    border-color: #046c4e;\n    border-color: rgba(4, 108, 78, var(--border-opacity));\n  }\n  .lg\\:focus-within\\:border-green-800:focus-within {\n    --border-opacity: 1;\n    border-color: #03543f;\n    border-color: rgba(3, 84, 63, var(--border-opacity));\n  }\n  .lg\\:focus-within\\:border-green-900:focus-within {\n    --border-opacity: 1;\n    border-color: #014737;\n    border-color: rgba(1, 71, 55, var(--border-opacity));\n  }\n  .lg\\:focus-within\\:border-teal-50:focus-within {\n    --border-opacity: 1;\n    border-color: #edfafa;\n    border-color: rgba(237, 250, 250, var(--border-opacity));\n  }\n  .lg\\:focus-within\\:border-teal-100:focus-within {\n    --border-opacity: 1;\n    border-color: #d5f5f6;\n    border-color: rgba(213, 245, 246, var(--border-opacity));\n  }\n  .lg\\:focus-within\\:border-teal-200:focus-within {\n    --border-opacity: 1;\n    border-color: #afecef;\n    border-color: rgba(175, 236, 239, var(--border-opacity));\n  }\n  .lg\\:focus-within\\:border-teal-300:focus-within {\n    --border-opacity: 1;\n    border-color: #7edce2;\n    border-color: rgba(126, 220, 226, var(--border-opacity));\n  }\n  .lg\\:focus-within\\:border-teal-400:focus-within {\n    --border-opacity: 1;\n    border-color: #16bdca;\n    border-color: rgba(22, 189, 202, var(--border-opacity));\n  }\n  .lg\\:focus-within\\:border-teal-500:focus-within {\n    --border-opacity: 1;\n    border-color: #0694a2;\n    border-color: rgba(6, 148, 162, var(--border-opacity));\n  }\n  .lg\\:focus-within\\:border-teal-600:focus-within {\n    --border-opacity: 1;\n    border-color: #047481;\n    border-color: rgba(4, 116, 129, var(--border-opacity));\n  }\n  .lg\\:focus-within\\:border-teal-700:focus-within {\n    --border-opacity: 1;\n    border-color: #036672;\n    border-color: rgba(3, 102, 114, var(--border-opacity));\n  }\n  .lg\\:focus-within\\:border-teal-800:focus-within {\n    --border-opacity: 1;\n    border-color: #05505c;\n    border-color: rgba(5, 80, 92, var(--border-opacity));\n  }\n  .lg\\:focus-within\\:border-teal-900:focus-within {\n    --border-opacity: 1;\n    border-color: #014451;\n    border-color: rgba(1, 68, 81, var(--border-opacity));\n  }\n  .lg\\:focus-within\\:border-blue-50:focus-within {\n    --border-opacity: 1;\n    border-color: #ebf5ff;\n    border-color: rgba(235, 245, 255, var(--border-opacity));\n  }\n  .lg\\:focus-within\\:border-blue-100:focus-within {\n    --border-opacity: 1;\n    border-color: #e1effe;\n    border-color: rgba(225, 239, 254, var(--border-opacity));\n  }\n  .lg\\:focus-within\\:border-blue-200:focus-within {\n    --border-opacity: 1;\n    border-color: #c3ddfd;\n    border-color: rgba(195, 221, 253, var(--border-opacity));\n  }\n  .lg\\:focus-within\\:border-blue-300:focus-within {\n    --border-opacity: 1;\n    border-color: #a4cafe;\n    border-color: rgba(164, 202, 254, var(--border-opacity));\n  }\n  .lg\\:focus-within\\:border-blue-400:focus-within {\n    --border-opacity: 1;\n    border-color: #76a9fa;\n    border-color: rgba(118, 169, 250, var(--border-opacity));\n  }\n  .lg\\:focus-within\\:border-blue-500:focus-within {\n    --border-opacity: 1;\n    border-color: #3f83f8;\n    border-color: rgba(63, 131, 248, var(--border-opacity));\n  }\n  .lg\\:focus-within\\:border-blue-600:focus-within {\n    --border-opacity: 1;\n    border-color: #1c64f2;\n    border-color: rgba(28, 100, 242, var(--border-opacity));\n  }\n  .lg\\:focus-within\\:border-blue-700:focus-within {\n    --border-opacity: 1;\n    border-color: #1a56db;\n    border-color: rgba(26, 86, 219, var(--border-opacity));\n  }\n  .lg\\:focus-within\\:border-blue-800:focus-within {\n    --border-opacity: 1;\n    border-color: #1e429f;\n    border-color: rgba(30, 66, 159, var(--border-opacity));\n  }\n  .lg\\:focus-within\\:border-blue-900:focus-within {\n    --border-opacity: 1;\n    border-color: #233876;\n    border-color: rgba(35, 56, 118, var(--border-opacity));\n  }\n  .lg\\:focus-within\\:border-indigo-50:focus-within {\n    --border-opacity: 1;\n    border-color: #f0f5ff;\n    border-color: rgba(240, 245, 255, var(--border-opacity));\n  }\n  .lg\\:focus-within\\:border-indigo-100:focus-within {\n    --border-opacity: 1;\n    border-color: #e5edff;\n    border-color: rgba(229, 237, 255, var(--border-opacity));\n  }\n  .lg\\:focus-within\\:border-indigo-200:focus-within {\n    --border-opacity: 1;\n    border-color: #cddbfe;\n    border-color: rgba(205, 219, 254, var(--border-opacity));\n  }\n  .lg\\:focus-within\\:border-indigo-300:focus-within {\n    --border-opacity: 1;\n    border-color: #b4c6fc;\n    border-color: rgba(180, 198, 252, var(--border-opacity));\n  }\n  .lg\\:focus-within\\:border-indigo-400:focus-within {\n    --border-opacity: 1;\n    border-color: #8da2fb;\n    border-color: rgba(141, 162, 251, var(--border-opacity));\n  }\n  .lg\\:focus-within\\:border-indigo-500:focus-within {\n    --border-opacity: 1;\n    border-color: #6875f5;\n    border-color: rgba(104, 117, 245, var(--border-opacity));\n  }\n  .lg\\:focus-within\\:border-indigo-600:focus-within {\n    --border-opacity: 1;\n    border-color: #5850ec;\n    border-color: rgba(88, 80, 236, var(--border-opacity));\n  }\n  .lg\\:focus-within\\:border-indigo-700:focus-within {\n    --border-opacity: 1;\n    border-color: #5145cd;\n    border-color: rgba(81, 69, 205, var(--border-opacity));\n  }\n  .lg\\:focus-within\\:border-indigo-800:focus-within {\n    --border-opacity: 1;\n    border-color: #42389d;\n    border-color: rgba(66, 56, 157, var(--border-opacity));\n  }\n  .lg\\:focus-within\\:border-indigo-900:focus-within {\n    --border-opacity: 1;\n    border-color: #362f78;\n    border-color: rgba(54, 47, 120, var(--border-opacity));\n  }\n  .lg\\:focus-within\\:border-purple-50:focus-within {\n    --border-opacity: 1;\n    border-color: #f6f5ff;\n    border-color: rgba(246, 245, 255, var(--border-opacity));\n  }\n  .lg\\:focus-within\\:border-purple-100:focus-within {\n    --border-opacity: 1;\n    border-color: #edebfe;\n    border-color: rgba(237, 235, 254, var(--border-opacity));\n  }\n  .lg\\:focus-within\\:border-purple-200:focus-within {\n    --border-opacity: 1;\n    border-color: #dcd7fe;\n    border-color: rgba(220, 215, 254, var(--border-opacity));\n  }\n  .lg\\:focus-within\\:border-purple-300:focus-within {\n    --border-opacity: 1;\n    border-color: #cabffd;\n    border-color: rgba(202, 191, 253, var(--border-opacity));\n  }\n  .lg\\:focus-within\\:border-purple-400:focus-within {\n    --border-opacity: 1;\n    border-color: #ac94fa;\n    border-color: rgba(172, 148, 250, var(--border-opacity));\n  }\n  .lg\\:focus-within\\:border-purple-500:focus-within {\n    --border-opacity: 1;\n    border-color: #9061f9;\n    border-color: rgba(144, 97, 249, var(--border-opacity));\n  }\n  .lg\\:focus-within\\:border-purple-600:focus-within {\n    --border-opacity: 1;\n    border-color: #7e3af2;\n    border-color: rgba(126, 58, 242, var(--border-opacity));\n  }\n  .lg\\:focus-within\\:border-purple-700:focus-within {\n    --border-opacity: 1;\n    border-color: #6c2bd9;\n    border-color: rgba(108, 43, 217, var(--border-opacity));\n  }\n  .lg\\:focus-within\\:border-purple-800:focus-within {\n    --border-opacity: 1;\n    border-color: #5521b5;\n    border-color: rgba(85, 33, 181, var(--border-opacity));\n  }\n  .lg\\:focus-within\\:border-purple-900:focus-within {\n    --border-opacity: 1;\n    border-color: #4a1d96;\n    border-color: rgba(74, 29, 150, var(--border-opacity));\n  }\n  .lg\\:focus-within\\:border-pink-50:focus-within {\n    --border-opacity: 1;\n    border-color: #fdf2f8;\n    border-color: rgba(253, 242, 248, var(--border-opacity));\n  }\n  .lg\\:focus-within\\:border-pink-100:focus-within {\n    --border-opacity: 1;\n    border-color: #fce8f3;\n    border-color: rgba(252, 232, 243, var(--border-opacity));\n  }\n  .lg\\:focus-within\\:border-pink-200:focus-within {\n    --border-opacity: 1;\n    border-color: #fad1e8;\n    border-color: rgba(250, 209, 232, var(--border-opacity));\n  }\n  .lg\\:focus-within\\:border-pink-300:focus-within {\n    --border-opacity: 1;\n    border-color: #f8b4d9;\n    border-color: rgba(248, 180, 217, var(--border-opacity));\n  }\n  .lg\\:focus-within\\:border-pink-400:focus-within {\n    --border-opacity: 1;\n    border-color: #f17eb8;\n    border-color: rgba(241, 126, 184, var(--border-opacity));\n  }\n  .lg\\:focus-within\\:border-pink-500:focus-within {\n    --border-opacity: 1;\n    border-color: #e74694;\n    border-color: rgba(231, 70, 148, var(--border-opacity));\n  }\n  .lg\\:focus-within\\:border-pink-600:focus-within {\n    --border-opacity: 1;\n    border-color: #d61f69;\n    border-color: rgba(214, 31, 105, var(--border-opacity));\n  }\n  .lg\\:focus-within\\:border-pink-700:focus-within {\n    --border-opacity: 1;\n    border-color: #bf125d;\n    border-color: rgba(191, 18, 93, var(--border-opacity));\n  }\n  .lg\\:focus-within\\:border-pink-800:focus-within {\n    --border-opacity: 1;\n    border-color: #99154b;\n    border-color: rgba(153, 21, 75, var(--border-opacity));\n  }\n  .lg\\:focus-within\\:border-pink-900:focus-within {\n    --border-opacity: 1;\n    border-color: #751a3d;\n    border-color: rgba(117, 26, 61, var(--border-opacity));\n  }\n  .lg\\:focus-within\\:border-cool-gray-50:focus-within {\n    --border-opacity: 1;\n    border-color: #f8fafc;\n    border-color: rgba(248, 250, 252, var(--border-opacity));\n  }\n  .lg\\:focus-within\\:border-cool-gray-100:focus-within {\n    --border-opacity: 1;\n    border-color: #f1f5f9;\n    border-color: rgba(241, 245, 249, var(--border-opacity));\n  }\n  .lg\\:focus-within\\:border-cool-gray-200:focus-within {\n    --border-opacity: 1;\n    border-color: #e2e8f0;\n    border-color: rgba(226, 232, 240, var(--border-opacity));\n  }\n  .lg\\:focus-within\\:border-cool-gray-300:focus-within {\n    --border-opacity: 1;\n    border-color: #cfd8e3;\n    border-color: rgba(207, 216, 227, var(--border-opacity));\n  }\n  .lg\\:focus-within\\:border-cool-gray-400:focus-within {\n    --border-opacity: 1;\n    border-color: #97a6ba;\n    border-color: rgba(151, 166, 186, var(--border-opacity));\n  }\n  .lg\\:focus-within\\:border-cool-gray-500:focus-within {\n    --border-opacity: 1;\n    border-color: #64748b;\n    border-color: rgba(100, 116, 139, var(--border-opacity));\n  }\n  .lg\\:focus-within\\:border-cool-gray-600:focus-within {\n    --border-opacity: 1;\n    border-color: #475569;\n    border-color: rgba(71, 85, 105, var(--border-opacity));\n  }\n  .lg\\:focus-within\\:border-cool-gray-700:focus-within {\n    --border-opacity: 1;\n    border-color: #364152;\n    border-color: rgba(54, 65, 82, var(--border-opacity));\n  }\n  .lg\\:focus-within\\:border-cool-gray-800:focus-within {\n    --border-opacity: 1;\n    border-color: #27303f;\n    border-color: rgba(39, 48, 63, var(--border-opacity));\n  }\n  .lg\\:focus-within\\:border-cool-gray-900:focus-within {\n    --border-opacity: 1;\n    border-color: #1a202e;\n    border-color: rgba(26, 32, 46, var(--border-opacity));\n  }\n  .lg\\:focus\\:border-current:focus {\n    border-color: currentColor;\n  }\n  .lg\\:focus\\:border-transparent:focus {\n    border-color: transparent;\n  }\n  .lg\\:focus\\:border-white:focus {\n    --border-opacity: 1;\n    border-color: #ffffff;\n    border-color: rgba(255, 255, 255, var(--border-opacity));\n  }\n  .lg\\:focus\\:border-black:focus {\n    --border-opacity: 1;\n    border-color: #000000;\n    border-color: rgba(0, 0, 0, var(--border-opacity));\n  }\n  .lg\\:focus\\:border-gray-50:focus {\n    --border-opacity: 1;\n    border-color: #f9fafb;\n    border-color: rgba(249, 250, 251, var(--border-opacity));\n  }\n  .lg\\:focus\\:border-gray-100:focus {\n    --border-opacity: 1;\n    border-color: #f4f5f7;\n    border-color: rgba(244, 245, 247, var(--border-opacity));\n  }\n  .lg\\:focus\\:border-gray-200:focus {\n    --border-opacity: 1;\n    border-color: #e5e7eb;\n    border-color: rgba(229, 231, 235, var(--border-opacity));\n  }\n  .lg\\:focus\\:border-gray-300:focus {\n    --border-opacity: 1;\n    border-color: #d2d6dc;\n    border-color: rgba(210, 214, 220, var(--border-opacity));\n  }\n  .lg\\:focus\\:border-gray-400:focus {\n    --border-opacity: 1;\n    border-color: #9fa6b2;\n    border-color: rgba(159, 166, 178, var(--border-opacity));\n  }\n  .lg\\:focus\\:border-gray-500:focus {\n    --border-opacity: 1;\n    border-color: #6b7280;\n    border-color: rgba(107, 114, 128, var(--border-opacity));\n  }\n  .lg\\:focus\\:border-gray-600:focus {\n    --border-opacity: 1;\n    border-color: #4b5563;\n    border-color: rgba(75, 85, 99, var(--border-opacity));\n  }\n  .lg\\:focus\\:border-gray-700:focus {\n    --border-opacity: 1;\n    border-color: #374151;\n    border-color: rgba(55, 65, 81, var(--border-opacity));\n  }\n  .lg\\:focus\\:border-gray-800:focus {\n    --border-opacity: 1;\n    border-color: #252f3f;\n    border-color: rgba(37, 47, 63, var(--border-opacity));\n  }\n  .lg\\:focus\\:border-gray-900:focus {\n    --border-opacity: 1;\n    border-color: #161e2e;\n    border-color: rgba(22, 30, 46, var(--border-opacity));\n  }\n  .lg\\:focus\\:border-red-50:focus {\n    --border-opacity: 1;\n    border-color: #fdf2f2;\n    border-color: rgba(253, 242, 242, var(--border-opacity));\n  }\n  .lg\\:focus\\:border-red-100:focus {\n    --border-opacity: 1;\n    border-color: #fde8e8;\n    border-color: rgba(253, 232, 232, var(--border-opacity));\n  }\n  .lg\\:focus\\:border-red-200:focus {\n    --border-opacity: 1;\n    border-color: #fbd5d5;\n    border-color: rgba(251, 213, 213, var(--border-opacity));\n  }\n  .lg\\:focus\\:border-red-300:focus {\n    --border-opacity: 1;\n    border-color: #f8b4b4;\n    border-color: rgba(248, 180, 180, var(--border-opacity));\n  }\n  .lg\\:focus\\:border-red-400:focus {\n    --border-opacity: 1;\n    border-color: #f98080;\n    border-color: rgba(249, 128, 128, var(--border-opacity));\n  }\n  .lg\\:focus\\:border-red-500:focus {\n    --border-opacity: 1;\n    border-color: #f05252;\n    border-color: rgba(240, 82, 82, var(--border-opacity));\n  }\n  .lg\\:focus\\:border-red-600:focus {\n    --border-opacity: 1;\n    border-color: #e02424;\n    border-color: rgba(224, 36, 36, var(--border-opacity));\n  }\n  .lg\\:focus\\:border-red-700:focus {\n    --border-opacity: 1;\n    border-color: #c81e1e;\n    border-color: rgba(200, 30, 30, var(--border-opacity));\n  }\n  .lg\\:focus\\:border-red-800:focus {\n    --border-opacity: 1;\n    border-color: #9b1c1c;\n    border-color: rgba(155, 28, 28, var(--border-opacity));\n  }\n  .lg\\:focus\\:border-red-900:focus {\n    --border-opacity: 1;\n    border-color: #771d1d;\n    border-color: rgba(119, 29, 29, var(--border-opacity));\n  }\n  .lg\\:focus\\:border-orange-50:focus {\n    --border-opacity: 1;\n    border-color: #fff8f1;\n    border-color: rgba(255, 248, 241, var(--border-opacity));\n  }\n  .lg\\:focus\\:border-orange-100:focus {\n    --border-opacity: 1;\n    border-color: #feecdc;\n    border-color: rgba(254, 236, 220, var(--border-opacity));\n  }\n  .lg\\:focus\\:border-orange-200:focus {\n    --border-opacity: 1;\n    border-color: #fcd9bd;\n    border-color: rgba(252, 217, 189, var(--border-opacity));\n  }\n  .lg\\:focus\\:border-orange-300:focus {\n    --border-opacity: 1;\n    border-color: #fdba8c;\n    border-color: rgba(253, 186, 140, var(--border-opacity));\n  }\n  .lg\\:focus\\:border-orange-400:focus {\n    --border-opacity: 1;\n    border-color: #ff8a4c;\n    border-color: rgba(255, 138, 76, var(--border-opacity));\n  }\n  .lg\\:focus\\:border-orange-500:focus {\n    --border-opacity: 1;\n    border-color: #ff5a1f;\n    border-color: rgba(255, 90, 31, var(--border-opacity));\n  }\n  .lg\\:focus\\:border-orange-600:focus {\n    --border-opacity: 1;\n    border-color: #d03801;\n    border-color: rgba(208, 56, 1, var(--border-opacity));\n  }\n  .lg\\:focus\\:border-orange-700:focus {\n    --border-opacity: 1;\n    border-color: #b43403;\n    border-color: rgba(180, 52, 3, var(--border-opacity));\n  }\n  .lg\\:focus\\:border-orange-800:focus {\n    --border-opacity: 1;\n    border-color: #8a2c0d;\n    border-color: rgba(138, 44, 13, var(--border-opacity));\n  }\n  .lg\\:focus\\:border-orange-900:focus {\n    --border-opacity: 1;\n    border-color: #73230d;\n    border-color: rgba(115, 35, 13, var(--border-opacity));\n  }\n  .lg\\:focus\\:border-yellow-50:focus {\n    --border-opacity: 1;\n    border-color: #fdfdea;\n    border-color: rgba(253, 253, 234, var(--border-opacity));\n  }\n  .lg\\:focus\\:border-yellow-100:focus {\n    --border-opacity: 1;\n    border-color: #fdf6b2;\n    border-color: rgba(253, 246, 178, var(--border-opacity));\n  }\n  .lg\\:focus\\:border-yellow-200:focus {\n    --border-opacity: 1;\n    border-color: #fce96a;\n    border-color: rgba(252, 233, 106, var(--border-opacity));\n  }\n  .lg\\:focus\\:border-yellow-300:focus {\n    --border-opacity: 1;\n    border-color: #faca15;\n    border-color: rgba(250, 202, 21, var(--border-opacity));\n  }\n  .lg\\:focus\\:border-yellow-400:focus {\n    --border-opacity: 1;\n    border-color: #e3a008;\n    border-color: rgba(227, 160, 8, var(--border-opacity));\n  }\n  .lg\\:focus\\:border-yellow-500:focus {\n    --border-opacity: 1;\n    border-color: #c27803;\n    border-color: rgba(194, 120, 3, var(--border-opacity));\n  }\n  .lg\\:focus\\:border-yellow-600:focus {\n    --border-opacity: 1;\n    border-color: #9f580a;\n    border-color: rgba(159, 88, 10, var(--border-opacity));\n  }\n  .lg\\:focus\\:border-yellow-700:focus {\n    --border-opacity: 1;\n    border-color: #8e4b10;\n    border-color: rgba(142, 75, 16, var(--border-opacity));\n  }\n  .lg\\:focus\\:border-yellow-800:focus {\n    --border-opacity: 1;\n    border-color: #723b13;\n    border-color: rgba(114, 59, 19, var(--border-opacity));\n  }\n  .lg\\:focus\\:border-yellow-900:focus {\n    --border-opacity: 1;\n    border-color: #633112;\n    border-color: rgba(99, 49, 18, var(--border-opacity));\n  }\n  .lg\\:focus\\:border-green-50:focus {\n    --border-opacity: 1;\n    border-color: #f3faf7;\n    border-color: rgba(243, 250, 247, var(--border-opacity));\n  }\n  .lg\\:focus\\:border-green-100:focus {\n    --border-opacity: 1;\n    border-color: #def7ec;\n    border-color: rgba(222, 247, 236, var(--border-opacity));\n  }\n  .lg\\:focus\\:border-green-200:focus {\n    --border-opacity: 1;\n    border-color: #bcf0da;\n    border-color: rgba(188, 240, 218, var(--border-opacity));\n  }\n  .lg\\:focus\\:border-green-300:focus {\n    --border-opacity: 1;\n    border-color: #84e1bc;\n    border-color: rgba(132, 225, 188, var(--border-opacity));\n  }\n  .lg\\:focus\\:border-green-400:focus {\n    --border-opacity: 1;\n    border-color: #31c48d;\n    border-color: rgba(49, 196, 141, var(--border-opacity));\n  }\n  .lg\\:focus\\:border-green-500:focus {\n    --border-opacity: 1;\n    border-color: #0e9f6e;\n    border-color: rgba(14, 159, 110, var(--border-opacity));\n  }\n  .lg\\:focus\\:border-green-600:focus {\n    --border-opacity: 1;\n    border-color: #057a55;\n    border-color: rgba(5, 122, 85, var(--border-opacity));\n  }\n  .lg\\:focus\\:border-green-700:focus {\n    --border-opacity: 1;\n    border-color: #046c4e;\n    border-color: rgba(4, 108, 78, var(--border-opacity));\n  }\n  .lg\\:focus\\:border-green-800:focus {\n    --border-opacity: 1;\n    border-color: #03543f;\n    border-color: rgba(3, 84, 63, var(--border-opacity));\n  }\n  .lg\\:focus\\:border-green-900:focus {\n    --border-opacity: 1;\n    border-color: #014737;\n    border-color: rgba(1, 71, 55, var(--border-opacity));\n  }\n  .lg\\:focus\\:border-teal-50:focus {\n    --border-opacity: 1;\n    border-color: #edfafa;\n    border-color: rgba(237, 250, 250, var(--border-opacity));\n  }\n  .lg\\:focus\\:border-teal-100:focus {\n    --border-opacity: 1;\n    border-color: #d5f5f6;\n    border-color: rgba(213, 245, 246, var(--border-opacity));\n  }\n  .lg\\:focus\\:border-teal-200:focus {\n    --border-opacity: 1;\n    border-color: #afecef;\n    border-color: rgba(175, 236, 239, var(--border-opacity));\n  }\n  .lg\\:focus\\:border-teal-300:focus {\n    --border-opacity: 1;\n    border-color: #7edce2;\n    border-color: rgba(126, 220, 226, var(--border-opacity));\n  }\n  .lg\\:focus\\:border-teal-400:focus {\n    --border-opacity: 1;\n    border-color: #16bdca;\n    border-color: rgba(22, 189, 202, var(--border-opacity));\n  }\n  .lg\\:focus\\:border-teal-500:focus {\n    --border-opacity: 1;\n    border-color: #0694a2;\n    border-color: rgba(6, 148, 162, var(--border-opacity));\n  }\n  .lg\\:focus\\:border-teal-600:focus {\n    --border-opacity: 1;\n    border-color: #047481;\n    border-color: rgba(4, 116, 129, var(--border-opacity));\n  }\n  .lg\\:focus\\:border-teal-700:focus {\n    --border-opacity: 1;\n    border-color: #036672;\n    border-color: rgba(3, 102, 114, var(--border-opacity));\n  }\n  .lg\\:focus\\:border-teal-800:focus {\n    --border-opacity: 1;\n    border-color: #05505c;\n    border-color: rgba(5, 80, 92, var(--border-opacity));\n  }\n  .lg\\:focus\\:border-teal-900:focus {\n    --border-opacity: 1;\n    border-color: #014451;\n    border-color: rgba(1, 68, 81, var(--border-opacity));\n  }\n  .lg\\:focus\\:border-blue-50:focus {\n    --border-opacity: 1;\n    border-color: #ebf5ff;\n    border-color: rgba(235, 245, 255, var(--border-opacity));\n  }\n  .lg\\:focus\\:border-blue-100:focus {\n    --border-opacity: 1;\n    border-color: #e1effe;\n    border-color: rgba(225, 239, 254, var(--border-opacity));\n  }\n  .lg\\:focus\\:border-blue-200:focus {\n    --border-opacity: 1;\n    border-color: #c3ddfd;\n    border-color: rgba(195, 221, 253, var(--border-opacity));\n  }\n  .lg\\:focus\\:border-blue-300:focus {\n    --border-opacity: 1;\n    border-color: #a4cafe;\n    border-color: rgba(164, 202, 254, var(--border-opacity));\n  }\n  .lg\\:focus\\:border-blue-400:focus {\n    --border-opacity: 1;\n    border-color: #76a9fa;\n    border-color: rgba(118, 169, 250, var(--border-opacity));\n  }\n  .lg\\:focus\\:border-blue-500:focus {\n    --border-opacity: 1;\n    border-color: #3f83f8;\n    border-color: rgba(63, 131, 248, var(--border-opacity));\n  }\n  .lg\\:focus\\:border-blue-600:focus {\n    --border-opacity: 1;\n    border-color: #1c64f2;\n    border-color: rgba(28, 100, 242, var(--border-opacity));\n  }\n  .lg\\:focus\\:border-blue-700:focus {\n    --border-opacity: 1;\n    border-color: #1a56db;\n    border-color: rgba(26, 86, 219, var(--border-opacity));\n  }\n  .lg\\:focus\\:border-blue-800:focus {\n    --border-opacity: 1;\n    border-color: #1e429f;\n    border-color: rgba(30, 66, 159, var(--border-opacity));\n  }\n  .lg\\:focus\\:border-blue-900:focus {\n    --border-opacity: 1;\n    border-color: #233876;\n    border-color: rgba(35, 56, 118, var(--border-opacity));\n  }\n  .lg\\:focus\\:border-indigo-50:focus {\n    --border-opacity: 1;\n    border-color: #f0f5ff;\n    border-color: rgba(240, 245, 255, var(--border-opacity));\n  }\n  .lg\\:focus\\:border-indigo-100:focus {\n    --border-opacity: 1;\n    border-color: #e5edff;\n    border-color: rgba(229, 237, 255, var(--border-opacity));\n  }\n  .lg\\:focus\\:border-indigo-200:focus {\n    --border-opacity: 1;\n    border-color: #cddbfe;\n    border-color: rgba(205, 219, 254, var(--border-opacity));\n  }\n  .lg\\:focus\\:border-indigo-300:focus {\n    --border-opacity: 1;\n    border-color: #b4c6fc;\n    border-color: rgba(180, 198, 252, var(--border-opacity));\n  }\n  .lg\\:focus\\:border-indigo-400:focus {\n    --border-opacity: 1;\n    border-color: #8da2fb;\n    border-color: rgba(141, 162, 251, var(--border-opacity));\n  }\n  .lg\\:focus\\:border-indigo-500:focus {\n    --border-opacity: 1;\n    border-color: #6875f5;\n    border-color: rgba(104, 117, 245, var(--border-opacity));\n  }\n  .lg\\:focus\\:border-indigo-600:focus {\n    --border-opacity: 1;\n    border-color: #5850ec;\n    border-color: rgba(88, 80, 236, var(--border-opacity));\n  }\n  .lg\\:focus\\:border-indigo-700:focus {\n    --border-opacity: 1;\n    border-color: #5145cd;\n    border-color: rgba(81, 69, 205, var(--border-opacity));\n  }\n  .lg\\:focus\\:border-indigo-800:focus {\n    --border-opacity: 1;\n    border-color: #42389d;\n    border-color: rgba(66, 56, 157, var(--border-opacity));\n  }\n  .lg\\:focus\\:border-indigo-900:focus {\n    --border-opacity: 1;\n    border-color: #362f78;\n    border-color: rgba(54, 47, 120, var(--border-opacity));\n  }\n  .lg\\:focus\\:border-purple-50:focus {\n    --border-opacity: 1;\n    border-color: #f6f5ff;\n    border-color: rgba(246, 245, 255, var(--border-opacity));\n  }\n  .lg\\:focus\\:border-purple-100:focus {\n    --border-opacity: 1;\n    border-color: #edebfe;\n    border-color: rgba(237, 235, 254, var(--border-opacity));\n  }\n  .lg\\:focus\\:border-purple-200:focus {\n    --border-opacity: 1;\n    border-color: #dcd7fe;\n    border-color: rgba(220, 215, 254, var(--border-opacity));\n  }\n  .lg\\:focus\\:border-purple-300:focus {\n    --border-opacity: 1;\n    border-color: #cabffd;\n    border-color: rgba(202, 191, 253, var(--border-opacity));\n  }\n  .lg\\:focus\\:border-purple-400:focus {\n    --border-opacity: 1;\n    border-color: #ac94fa;\n    border-color: rgba(172, 148, 250, var(--border-opacity));\n  }\n  .lg\\:focus\\:border-purple-500:focus {\n    --border-opacity: 1;\n    border-color: #9061f9;\n    border-color: rgba(144, 97, 249, var(--border-opacity));\n  }\n  .lg\\:focus\\:border-purple-600:focus {\n    --border-opacity: 1;\n    border-color: #7e3af2;\n    border-color: rgba(126, 58, 242, var(--border-opacity));\n  }\n  .lg\\:focus\\:border-purple-700:focus {\n    --border-opacity: 1;\n    border-color: #6c2bd9;\n    border-color: rgba(108, 43, 217, var(--border-opacity));\n  }\n  .lg\\:focus\\:border-purple-800:focus {\n    --border-opacity: 1;\n    border-color: #5521b5;\n    border-color: rgba(85, 33, 181, var(--border-opacity));\n  }\n  .lg\\:focus\\:border-purple-900:focus {\n    --border-opacity: 1;\n    border-color: #4a1d96;\n    border-color: rgba(74, 29, 150, var(--border-opacity));\n  }\n  .lg\\:focus\\:border-pink-50:focus {\n    --border-opacity: 1;\n    border-color: #fdf2f8;\n    border-color: rgba(253, 242, 248, var(--border-opacity));\n  }\n  .lg\\:focus\\:border-pink-100:focus {\n    --border-opacity: 1;\n    border-color: #fce8f3;\n    border-color: rgba(252, 232, 243, var(--border-opacity));\n  }\n  .lg\\:focus\\:border-pink-200:focus {\n    --border-opacity: 1;\n    border-color: #fad1e8;\n    border-color: rgba(250, 209, 232, var(--border-opacity));\n  }\n  .lg\\:focus\\:border-pink-300:focus {\n    --border-opacity: 1;\n    border-color: #f8b4d9;\n    border-color: rgba(248, 180, 217, var(--border-opacity));\n  }\n  .lg\\:focus\\:border-pink-400:focus {\n    --border-opacity: 1;\n    border-color: #f17eb8;\n    border-color: rgba(241, 126, 184, var(--border-opacity));\n  }\n  .lg\\:focus\\:border-pink-500:focus {\n    --border-opacity: 1;\n    border-color: #e74694;\n    border-color: rgba(231, 70, 148, var(--border-opacity));\n  }\n  .lg\\:focus\\:border-pink-600:focus {\n    --border-opacity: 1;\n    border-color: #d61f69;\n    border-color: rgba(214, 31, 105, var(--border-opacity));\n  }\n  .lg\\:focus\\:border-pink-700:focus {\n    --border-opacity: 1;\n    border-color: #bf125d;\n    border-color: rgba(191, 18, 93, var(--border-opacity));\n  }\n  .lg\\:focus\\:border-pink-800:focus {\n    --border-opacity: 1;\n    border-color: #99154b;\n    border-color: rgba(153, 21, 75, var(--border-opacity));\n  }\n  .lg\\:focus\\:border-pink-900:focus {\n    --border-opacity: 1;\n    border-color: #751a3d;\n    border-color: rgba(117, 26, 61, var(--border-opacity));\n  }\n  .lg\\:focus\\:border-cool-gray-50:focus {\n    --border-opacity: 1;\n    border-color: #f8fafc;\n    border-color: rgba(248, 250, 252, var(--border-opacity));\n  }\n  .lg\\:focus\\:border-cool-gray-100:focus {\n    --border-opacity: 1;\n    border-color: #f1f5f9;\n    border-color: rgba(241, 245, 249, var(--border-opacity));\n  }\n  .lg\\:focus\\:border-cool-gray-200:focus {\n    --border-opacity: 1;\n    border-color: #e2e8f0;\n    border-color: rgba(226, 232, 240, var(--border-opacity));\n  }\n  .lg\\:focus\\:border-cool-gray-300:focus {\n    --border-opacity: 1;\n    border-color: #cfd8e3;\n    border-color: rgba(207, 216, 227, var(--border-opacity));\n  }\n  .lg\\:focus\\:border-cool-gray-400:focus {\n    --border-opacity: 1;\n    border-color: #97a6ba;\n    border-color: rgba(151, 166, 186, var(--border-opacity));\n  }\n  .lg\\:focus\\:border-cool-gray-500:focus {\n    --border-opacity: 1;\n    border-color: #64748b;\n    border-color: rgba(100, 116, 139, var(--border-opacity));\n  }\n  .lg\\:focus\\:border-cool-gray-600:focus {\n    --border-opacity: 1;\n    border-color: #475569;\n    border-color: rgba(71, 85, 105, var(--border-opacity));\n  }\n  .lg\\:focus\\:border-cool-gray-700:focus {\n    --border-opacity: 1;\n    border-color: #364152;\n    border-color: rgba(54, 65, 82, var(--border-opacity));\n  }\n  .lg\\:focus\\:border-cool-gray-800:focus {\n    --border-opacity: 1;\n    border-color: #27303f;\n    border-color: rgba(39, 48, 63, var(--border-opacity));\n  }\n  .lg\\:focus\\:border-cool-gray-900:focus {\n    --border-opacity: 1;\n    border-color: #1a202e;\n    border-color: rgba(26, 32, 46, var(--border-opacity));\n  }\n  .lg\\:border-opacity-0 {\n    --border-opacity: 0;\n  }\n  .lg\\:border-opacity-25 {\n    --border-opacity: 0.25;\n  }\n  .lg\\:border-opacity-50 {\n    --border-opacity: 0.5;\n  }\n  .lg\\:border-opacity-75 {\n    --border-opacity: 0.75;\n  }\n  .lg\\:border-opacity-100 {\n    --border-opacity: 1;\n  }\n  .lg\\:hover\\:border-opacity-0:hover {\n    --border-opacity: 0;\n  }\n  .lg\\:hover\\:border-opacity-25:hover {\n    --border-opacity: 0.25;\n  }\n  .lg\\:hover\\:border-opacity-50:hover {\n    --border-opacity: 0.5;\n  }\n  .lg\\:hover\\:border-opacity-75:hover {\n    --border-opacity: 0.75;\n  }\n  .lg\\:hover\\:border-opacity-100:hover {\n    --border-opacity: 1;\n  }\n  .lg\\:focus\\:border-opacity-0:focus {\n    --border-opacity: 0;\n  }\n  .lg\\:focus\\:border-opacity-25:focus {\n    --border-opacity: 0.25;\n  }\n  .lg\\:focus\\:border-opacity-50:focus {\n    --border-opacity: 0.5;\n  }\n  .lg\\:focus\\:border-opacity-75:focus {\n    --border-opacity: 0.75;\n  }\n  .lg\\:focus\\:border-opacity-100:focus {\n    --border-opacity: 1;\n  }\n  .lg\\:rounded-none {\n    border-radius: 0;\n  }\n  .lg\\:rounded-sm {\n    border-radius: 0.125rem;\n  }\n  .lg\\:rounded {\n    border-radius: 0.25rem;\n  }\n  .lg\\:rounded-md {\n    border-radius: 0.375rem;\n  }\n  .lg\\:rounded-lg {\n    border-radius: 0.5rem;\n  }\n  .lg\\:rounded-xl {\n    border-radius: 0.75rem;\n  }\n  .lg\\:rounded-2xl {\n    border-radius: 1rem;\n  }\n  .lg\\:rounded-3xl {\n    border-radius: 1.5rem;\n  }\n  .lg\\:rounded-full {\n    border-radius: 9999px;\n  }\n  .lg\\:rounded-t-none {\n    border-top-left-radius: 0;\n    border-top-right-radius: 0;\n  }\n  .lg\\:rounded-r-none {\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0;\n  }\n  .lg\\:rounded-b-none {\n    border-bottom-right-radius: 0;\n    border-bottom-left-radius: 0;\n  }\n  .lg\\:rounded-l-none {\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0;\n  }\n  .lg\\:rounded-t-sm {\n    border-top-left-radius: 0.125rem;\n    border-top-right-radius: 0.125rem;\n  }\n  .lg\\:rounded-r-sm {\n    border-top-right-radius: 0.125rem;\n    border-bottom-right-radius: 0.125rem;\n  }\n  .lg\\:rounded-b-sm {\n    border-bottom-right-radius: 0.125rem;\n    border-bottom-left-radius: 0.125rem;\n  }\n  .lg\\:rounded-l-sm {\n    border-top-left-radius: 0.125rem;\n    border-bottom-left-radius: 0.125rem;\n  }\n  .lg\\:rounded-t {\n    border-top-left-radius: 0.25rem;\n    border-top-right-radius: 0.25rem;\n  }\n  .lg\\:rounded-r {\n    border-top-right-radius: 0.25rem;\n    border-bottom-right-radius: 0.25rem;\n  }\n  .lg\\:rounded-b {\n    border-bottom-right-radius: 0.25rem;\n    border-bottom-left-radius: 0.25rem;\n  }\n  .lg\\:rounded-l {\n    border-top-left-radius: 0.25rem;\n    border-bottom-left-radius: 0.25rem;\n  }\n  .lg\\:rounded-t-md {\n    border-top-left-radius: 0.375rem;\n    border-top-right-radius: 0.375rem;\n  }\n  .lg\\:rounded-r-md {\n    border-top-right-radius: 0.375rem;\n    border-bottom-right-radius: 0.375rem;\n  }\n  .lg\\:rounded-b-md {\n    border-bottom-right-radius: 0.375rem;\n    border-bottom-left-radius: 0.375rem;\n  }\n  .lg\\:rounded-l-md {\n    border-top-left-radius: 0.375rem;\n    border-bottom-left-radius: 0.375rem;\n  }\n  .lg\\:rounded-t-lg {\n    border-top-left-radius: 0.5rem;\n    border-top-right-radius: 0.5rem;\n  }\n  .lg\\:rounded-r-lg {\n    border-top-right-radius: 0.5rem;\n    border-bottom-right-radius: 0.5rem;\n  }\n  .lg\\:rounded-b-lg {\n    border-bottom-right-radius: 0.5rem;\n    border-bottom-left-radius: 0.5rem;\n  }\n  .lg\\:rounded-l-lg {\n    border-top-left-radius: 0.5rem;\n    border-bottom-left-radius: 0.5rem;\n  }\n  .lg\\:rounded-t-xl {\n    border-top-left-radius: 0.75rem;\n    border-top-right-radius: 0.75rem;\n  }\n  .lg\\:rounded-r-xl {\n    border-top-right-radius: 0.75rem;\n    border-bottom-right-radius: 0.75rem;\n  }\n  .lg\\:rounded-b-xl {\n    border-bottom-right-radius: 0.75rem;\n    border-bottom-left-radius: 0.75rem;\n  }\n  .lg\\:rounded-l-xl {\n    border-top-left-radius: 0.75rem;\n    border-bottom-left-radius: 0.75rem;\n  }\n  .lg\\:rounded-t-2xl {\n    border-top-left-radius: 1rem;\n    border-top-right-radius: 1rem;\n  }\n  .lg\\:rounded-r-2xl {\n    border-top-right-radius: 1rem;\n    border-bottom-right-radius: 1rem;\n  }\n  .lg\\:rounded-b-2xl {\n    border-bottom-right-radius: 1rem;\n    border-bottom-left-radius: 1rem;\n  }\n  .lg\\:rounded-l-2xl {\n    border-top-left-radius: 1rem;\n    border-bottom-left-radius: 1rem;\n  }\n  .lg\\:rounded-t-3xl {\n    border-top-left-radius: 1.5rem;\n    border-top-right-radius: 1.5rem;\n  }\n  .lg\\:rounded-r-3xl {\n    border-top-right-radius: 1.5rem;\n    border-bottom-right-radius: 1.5rem;\n  }\n  .lg\\:rounded-b-3xl {\n    border-bottom-right-radius: 1.5rem;\n    border-bottom-left-radius: 1.5rem;\n  }\n  .lg\\:rounded-l-3xl {\n    border-top-left-radius: 1.5rem;\n    border-bottom-left-radius: 1.5rem;\n  }\n  .lg\\:rounded-t-full {\n    border-top-left-radius: 9999px;\n    border-top-right-radius: 9999px;\n  }\n  .lg\\:rounded-r-full {\n    border-top-right-radius: 9999px;\n    border-bottom-right-radius: 9999px;\n  }\n  .lg\\:rounded-b-full {\n    border-bottom-right-radius: 9999px;\n    border-bottom-left-radius: 9999px;\n  }\n  .lg\\:rounded-l-full {\n    border-top-left-radius: 9999px;\n    border-bottom-left-radius: 9999px;\n  }\n  .lg\\:rounded-tl-none {\n    border-top-left-radius: 0;\n  }\n  .lg\\:rounded-tr-none {\n    border-top-right-radius: 0;\n  }\n  .lg\\:rounded-br-none {\n    border-bottom-right-radius: 0;\n  }\n  .lg\\:rounded-bl-none {\n    border-bottom-left-radius: 0;\n  }\n  .lg\\:rounded-tl-sm {\n    border-top-left-radius: 0.125rem;\n  }\n  .lg\\:rounded-tr-sm {\n    border-top-right-radius: 0.125rem;\n  }\n  .lg\\:rounded-br-sm {\n    border-bottom-right-radius: 0.125rem;\n  }\n  .lg\\:rounded-bl-sm {\n    border-bottom-left-radius: 0.125rem;\n  }\n  .lg\\:rounded-tl {\n    border-top-left-radius: 0.25rem;\n  }\n  .lg\\:rounded-tr {\n    border-top-right-radius: 0.25rem;\n  }\n  .lg\\:rounded-br {\n    border-bottom-right-radius: 0.25rem;\n  }\n  .lg\\:rounded-bl {\n    border-bottom-left-radius: 0.25rem;\n  }\n  .lg\\:rounded-tl-md {\n    border-top-left-radius: 0.375rem;\n  }\n  .lg\\:rounded-tr-md {\n    border-top-right-radius: 0.375rem;\n  }\n  .lg\\:rounded-br-md {\n    border-bottom-right-radius: 0.375rem;\n  }\n  .lg\\:rounded-bl-md {\n    border-bottom-left-radius: 0.375rem;\n  }\n  .lg\\:rounded-tl-lg {\n    border-top-left-radius: 0.5rem;\n  }\n  .lg\\:rounded-tr-lg {\n    border-top-right-radius: 0.5rem;\n  }\n  .lg\\:rounded-br-lg {\n    border-bottom-right-radius: 0.5rem;\n  }\n  .lg\\:rounded-bl-lg {\n    border-bottom-left-radius: 0.5rem;\n  }\n  .lg\\:rounded-tl-xl {\n    border-top-left-radius: 0.75rem;\n  }\n  .lg\\:rounded-tr-xl {\n    border-top-right-radius: 0.75rem;\n  }\n  .lg\\:rounded-br-xl {\n    border-bottom-right-radius: 0.75rem;\n  }\n  .lg\\:rounded-bl-xl {\n    border-bottom-left-radius: 0.75rem;\n  }\n  .lg\\:rounded-tl-2xl {\n    border-top-left-radius: 1rem;\n  }\n  .lg\\:rounded-tr-2xl {\n    border-top-right-radius: 1rem;\n  }\n  .lg\\:rounded-br-2xl {\n    border-bottom-right-radius: 1rem;\n  }\n  .lg\\:rounded-bl-2xl {\n    border-bottom-left-radius: 1rem;\n  }\n  .lg\\:rounded-tl-3xl {\n    border-top-left-radius: 1.5rem;\n  }\n  .lg\\:rounded-tr-3xl {\n    border-top-right-radius: 1.5rem;\n  }\n  .lg\\:rounded-br-3xl {\n    border-bottom-right-radius: 1.5rem;\n  }\n  .lg\\:rounded-bl-3xl {\n    border-bottom-left-radius: 1.5rem;\n  }\n  .lg\\:rounded-tl-full {\n    border-top-left-radius: 9999px;\n  }\n  .lg\\:rounded-tr-full {\n    border-top-right-radius: 9999px;\n  }\n  .lg\\:rounded-br-full {\n    border-bottom-right-radius: 9999px;\n  }\n  .lg\\:rounded-bl-full {\n    border-bottom-left-radius: 9999px;\n  }\n  .lg\\:border-solid {\n    border-style: solid;\n  }\n  .lg\\:border-dashed {\n    border-style: dashed;\n  }\n  .lg\\:border-dotted {\n    border-style: dotted;\n  }\n  .lg\\:border-double {\n    border-style: double;\n  }\n  .lg\\:border-none {\n    border-style: none;\n  }\n  .lg\\:border-0 {\n    border-width: 0;\n  }\n  .lg\\:border-2 {\n    border-width: 2px;\n  }\n  .lg\\:border-4 {\n    border-width: 4px;\n  }\n  .lg\\:border-8 {\n    border-width: 8px;\n  }\n  .lg\\:border {\n    border-width: 1px;\n  }\n  .lg\\:border-t-0 {\n    border-top-width: 0;\n  }\n  .lg\\:border-r-0 {\n    border-right-width: 0;\n  }\n  .lg\\:border-b-0 {\n    border-bottom-width: 0;\n  }\n  .lg\\:border-l-0 {\n    border-left-width: 0;\n  }\n  .lg\\:border-t-2 {\n    border-top-width: 2px;\n  }\n  .lg\\:border-r-2 {\n    border-right-width: 2px;\n  }\n  .lg\\:border-b-2 {\n    border-bottom-width: 2px;\n  }\n  .lg\\:border-l-2 {\n    border-left-width: 2px;\n  }\n  .lg\\:border-t-4 {\n    border-top-width: 4px;\n  }\n  .lg\\:border-r-4 {\n    border-right-width: 4px;\n  }\n  .lg\\:border-b-4 {\n    border-bottom-width: 4px;\n  }\n  .lg\\:border-l-4 {\n    border-left-width: 4px;\n  }\n  .lg\\:border-t-8 {\n    border-top-width: 8px;\n  }\n  .lg\\:border-r-8 {\n    border-right-width: 8px;\n  }\n  .lg\\:border-b-8 {\n    border-bottom-width: 8px;\n  }\n  .lg\\:border-l-8 {\n    border-left-width: 8px;\n  }\n  .lg\\:border-t {\n    border-top-width: 1px;\n  }\n  .lg\\:border-r {\n    border-right-width: 1px;\n  }\n  .lg\\:border-b {\n    border-bottom-width: 1px;\n  }\n  .lg\\:border-l {\n    border-left-width: 1px;\n  }\n  .lg\\:box-border {\n    box-sizing: border-box;\n  }\n  .lg\\:box-content {\n    box-sizing: content-box;\n  }\n  .lg\\:cursor-auto {\n    cursor: auto;\n  }\n  .lg\\:cursor-default {\n    cursor: default;\n  }\n  .lg\\:cursor-pointer {\n    cursor: pointer;\n  }\n  .lg\\:cursor-wait {\n    cursor: wait;\n  }\n  .lg\\:cursor-text {\n    cursor: text;\n  }\n  .lg\\:cursor-move {\n    cursor: move;\n  }\n  .lg\\:cursor-not-allowed {\n    cursor: not-allowed;\n  }\n  .lg\\:block {\n    display: block;\n  }\n  .lg\\:inline-block {\n    display: inline-block;\n  }\n  .lg\\:inline {\n    display: inline;\n  }\n  .lg\\:flex {\n    display: flex;\n  }\n  .lg\\:inline-flex {\n    display: inline-flex;\n  }\n  .lg\\:table {\n    display: table;\n  }\n  .lg\\:table-caption {\n    display: table-caption;\n  }\n  .lg\\:table-cell {\n    display: table-cell;\n  }\n  .lg\\:table-column {\n    display: table-column;\n  }\n  .lg\\:table-column-group {\n    display: table-column-group;\n  }\n  .lg\\:table-footer-group {\n    display: table-footer-group;\n  }\n  .lg\\:table-header-group {\n    display: table-header-group;\n  }\n  .lg\\:table-row-group {\n    display: table-row-group;\n  }\n  .lg\\:table-row {\n    display: table-row;\n  }\n  .lg\\:flow-root {\n    display: flow-root;\n  }\n  .lg\\:grid {\n    display: grid;\n  }\n  .lg\\:inline-grid {\n    display: inline-grid;\n  }\n  .lg\\:contents {\n    display: contents;\n  }\n  .lg\\:hidden {\n    display: none;\n  }\n  .lg\\:flex-row {\n    flex-direction: row;\n  }\n  .lg\\:flex-row-reverse {\n    flex-direction: row-reverse;\n  }\n  .lg\\:flex-col {\n    flex-direction: column;\n  }\n  .lg\\:flex-col-reverse {\n    flex-direction: column-reverse;\n  }\n  .lg\\:flex-wrap {\n    flex-wrap: wrap;\n  }\n  .lg\\:flex-wrap-reverse {\n    flex-wrap: wrap-reverse;\n  }\n  .lg\\:flex-no-wrap {\n    flex-wrap: nowrap;\n  }\n  .lg\\:place-items-auto {\n    place-items: auto;\n  }\n  .lg\\:place-items-start {\n    place-items: start;\n  }\n  .lg\\:place-items-end {\n    place-items: end;\n  }\n  .lg\\:place-items-center {\n    place-items: center;\n  }\n  .lg\\:place-items-stretch {\n    place-items: stretch;\n  }\n  .lg\\:place-content-center {\n    place-content: center;\n  }\n  .lg\\:place-content-start {\n    place-content: start;\n  }\n  .lg\\:place-content-end {\n    place-content: end;\n  }\n  .lg\\:place-content-between {\n    place-content: space-between;\n  }\n  .lg\\:place-content-around {\n    place-content: space-around;\n  }\n  .lg\\:place-content-evenly {\n    place-content: space-evenly;\n  }\n  .lg\\:place-content-stretch {\n    place-content: stretch;\n  }\n  .lg\\:place-self-auto {\n    place-self: auto;\n  }\n  .lg\\:place-self-start {\n    place-self: start;\n  }\n  .lg\\:place-self-end {\n    place-self: end;\n  }\n  .lg\\:place-self-center {\n    place-self: center;\n  }\n  .lg\\:place-self-stretch {\n    place-self: stretch;\n  }\n  .lg\\:items-start {\n    align-items: flex-start;\n  }\n  .lg\\:items-end {\n    align-items: flex-end;\n  }\n  .lg\\:items-center {\n    align-items: center;\n  }\n  .lg\\:items-baseline {\n    align-items: baseline;\n  }\n  .lg\\:items-stretch {\n    align-items: stretch;\n  }\n  .lg\\:content-center {\n    align-content: center;\n  }\n  .lg\\:content-start {\n    align-content: flex-start;\n  }\n  .lg\\:content-end {\n    align-content: flex-end;\n  }\n  .lg\\:content-between {\n    align-content: space-between;\n  }\n  .lg\\:content-around {\n    align-content: space-around;\n  }\n  .lg\\:content-evenly {\n    align-content: space-evenly;\n  }\n  .lg\\:self-auto {\n    align-self: auto;\n  }\n  .lg\\:self-start {\n    align-self: flex-start;\n  }\n  .lg\\:self-end {\n    align-self: flex-end;\n  }\n  .lg\\:self-center {\n    align-self: center;\n  }\n  .lg\\:self-stretch {\n    align-self: stretch;\n  }\n  .lg\\:justify-items-auto {\n    justify-items: auto;\n  }\n  .lg\\:justify-items-start {\n    justify-items: start;\n  }\n  .lg\\:justify-items-end {\n    justify-items: end;\n  }\n  .lg\\:justify-items-center {\n    justify-items: center;\n  }\n  .lg\\:justify-items-stretch {\n    justify-items: stretch;\n  }\n  .lg\\:justify-start {\n    justify-content: flex-start;\n  }\n  .lg\\:justify-end {\n    justify-content: flex-end;\n  }\n  .lg\\:justify-center {\n    justify-content: center;\n  }\n  .lg\\:justify-between {\n    justify-content: space-between;\n  }\n  .lg\\:justify-around {\n    justify-content: space-around;\n  }\n  .lg\\:justify-evenly {\n    justify-content: space-evenly;\n  }\n  .lg\\:justify-self-auto {\n    justify-self: auto;\n  }\n  .lg\\:justify-self-start {\n    justify-self: start;\n  }\n  .lg\\:justify-self-end {\n    justify-self: end;\n  }\n  .lg\\:justify-self-center {\n    justify-self: center;\n  }\n  .lg\\:justify-self-stretch {\n    justify-self: stretch;\n  }\n  .lg\\:flex-1 {\n    flex: 1 1 0%;\n  }\n  .lg\\:flex-auto {\n    flex: 1 1 auto;\n  }\n  .lg\\:flex-initial {\n    flex: 0 1 auto;\n  }\n  .lg\\:flex-none {\n    flex: none;\n  }\n  .lg\\:flex-grow-0 {\n    flex-grow: 0;\n  }\n  .lg\\:flex-grow {\n    flex-grow: 1;\n  }\n  .lg\\:flex-shrink-0 {\n    flex-shrink: 0;\n  }\n  .lg\\:flex-shrink {\n    flex-shrink: 1;\n  }\n  .lg\\:order-1 {\n    order: 1;\n  }\n  .lg\\:order-2 {\n    order: 2;\n  }\n  .lg\\:order-3 {\n    order: 3;\n  }\n  .lg\\:order-4 {\n    order: 4;\n  }\n  .lg\\:order-5 {\n    order: 5;\n  }\n  .lg\\:order-6 {\n    order: 6;\n  }\n  .lg\\:order-7 {\n    order: 7;\n  }\n  .lg\\:order-8 {\n    order: 8;\n  }\n  .lg\\:order-9 {\n    order: 9;\n  }\n  .lg\\:order-10 {\n    order: 10;\n  }\n  .lg\\:order-11 {\n    order: 11;\n  }\n  .lg\\:order-12 {\n    order: 12;\n  }\n  .lg\\:order-first {\n    order: -9999;\n  }\n  .lg\\:order-last {\n    order: 9999;\n  }\n  .lg\\:order-none {\n    order: 0;\n  }\n  .lg\\:float-right {\n    float: right;\n  }\n  .lg\\:float-left {\n    float: left;\n  }\n  .lg\\:float-none {\n    float: none;\n  }\n  .lg\\:clearfix:after {\n    content: \"\";\n    display: table;\n    clear: both;\n  }\n  .lg\\:clear-left {\n    clear: left;\n  }\n  .lg\\:clear-right {\n    clear: right;\n  }\n  .lg\\:clear-both {\n    clear: both;\n  }\n  .lg\\:clear-none {\n    clear: none;\n  }\n  .lg\\:font-sans {\n    font-family: system-ui, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, \"Noto Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n  }\n  .lg\\:font-serif {\n    font-family: Georgia, Cambria, \"Times New Roman\", Times, serif;\n  }\n  .lg\\:font-mono {\n    font-family: Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace;\n  }\n  .lg\\:font-hairline {\n    font-weight: 100;\n  }\n  .lg\\:font-thin {\n    font-weight: 200;\n  }\n  .lg\\:font-light {\n    font-weight: 300;\n  }\n  .lg\\:font-normal {\n    font-weight: 400;\n  }\n  .lg\\:font-medium {\n    font-weight: 500;\n  }\n  .lg\\:font-semibold {\n    font-weight: 600;\n  }\n  .lg\\:font-bold {\n    font-weight: 700;\n  }\n  .lg\\:font-extrabold {\n    font-weight: 800;\n  }\n  .lg\\:font-black {\n    font-weight: 900;\n  }\n  .lg\\:hover\\:font-hairline:hover {\n    font-weight: 100;\n  }\n  .lg\\:hover\\:font-thin:hover {\n    font-weight: 200;\n  }\n  .lg\\:hover\\:font-light:hover {\n    font-weight: 300;\n  }\n  .lg\\:hover\\:font-normal:hover {\n    font-weight: 400;\n  }\n  .lg\\:hover\\:font-medium:hover {\n    font-weight: 500;\n  }\n  .lg\\:hover\\:font-semibold:hover {\n    font-weight: 600;\n  }\n  .lg\\:hover\\:font-bold:hover {\n    font-weight: 700;\n  }\n  .lg\\:hover\\:font-extrabold:hover {\n    font-weight: 800;\n  }\n  .lg\\:hover\\:font-black:hover {\n    font-weight: 900;\n  }\n  .lg\\:focus\\:font-hairline:focus {\n    font-weight: 100;\n  }\n  .lg\\:focus\\:font-thin:focus {\n    font-weight: 200;\n  }\n  .lg\\:focus\\:font-light:focus {\n    font-weight: 300;\n  }\n  .lg\\:focus\\:font-normal:focus {\n    font-weight: 400;\n  }\n  .lg\\:focus\\:font-medium:focus {\n    font-weight: 500;\n  }\n  .lg\\:focus\\:font-semibold:focus {\n    font-weight: 600;\n  }\n  .lg\\:focus\\:font-bold:focus {\n    font-weight: 700;\n  }\n  .lg\\:focus\\:font-extrabold:focus {\n    font-weight: 800;\n  }\n  .lg\\:focus\\:font-black:focus {\n    font-weight: 900;\n  }\n  .lg\\:h-0 {\n    height: 0;\n  }\n  .lg\\:h-1 {\n    height: 0.25rem;\n  }\n  .lg\\:h-2 {\n    height: 0.5rem;\n  }\n  .lg\\:h-3 {\n    height: 0.75rem;\n  }\n  .lg\\:h-4 {\n    height: 1rem;\n  }\n  .lg\\:h-5 {\n    height: 1.25rem;\n  }\n  .lg\\:h-6 {\n    height: 1.5rem;\n  }\n  .lg\\:h-7 {\n    height: 1.75rem;\n  }\n  .lg\\:h-8 {\n    height: 2rem;\n  }\n  .lg\\:h-9 {\n    height: 2.25rem;\n  }\n  .lg\\:h-10 {\n    height: 2.5rem;\n  }\n  .lg\\:h-11 {\n    height: 2.75rem;\n  }\n  .lg\\:h-12 {\n    height: 3rem;\n  }\n  .lg\\:h-13 {\n    height: 3.25rem;\n  }\n  .lg\\:h-14 {\n    height: 3.5rem;\n  }\n  .lg\\:h-15 {\n    height: 3.75rem;\n  }\n  .lg\\:h-16 {\n    height: 4rem;\n  }\n  .lg\\:h-20 {\n    height: 5rem;\n  }\n  .lg\\:h-24 {\n    height: 6rem;\n  }\n  .lg\\:h-28 {\n    height: 7rem;\n  }\n  .lg\\:h-32 {\n    height: 8rem;\n  }\n  .lg\\:h-36 {\n    height: 9rem;\n  }\n  .lg\\:h-40 {\n    height: 10rem;\n  }\n  .lg\\:h-44 {\n    height: 11rem;\n  }\n  .lg\\:h-48 {\n    height: 12rem;\n  }\n  .lg\\:h-52 {\n    height: 13rem;\n  }\n  .lg\\:h-56 {\n    height: 14rem;\n  }\n  .lg\\:h-60 {\n    height: 15rem;\n  }\n  .lg\\:h-64 {\n    height: 16rem;\n  }\n  .lg\\:h-72 {\n    height: 18rem;\n  }\n  .lg\\:h-80 {\n    height: 20rem;\n  }\n  .lg\\:h-96 {\n    height: 24rem;\n  }\n  .lg\\:h-auto {\n    height: auto;\n  }\n  .lg\\:h-px {\n    height: 1px;\n  }\n  .lg\\:h-0\\.5 {\n    height: 0.125rem;\n  }\n  .lg\\:h-1\\.5 {\n    height: 0.375rem;\n  }\n  .lg\\:h-2\\.5 {\n    height: 0.625rem;\n  }\n  .lg\\:h-3\\.5 {\n    height: 0.875rem;\n  }\n  .lg\\:h-1\\/2 {\n    height: 50%;\n  }\n  .lg\\:h-1\\/3 {\n    height: 33.333333%;\n  }\n  .lg\\:h-2\\/3 {\n    height: 66.666667%;\n  }\n  .lg\\:h-1\\/4 {\n    height: 25%;\n  }\n  .lg\\:h-2\\/4 {\n    height: 50%;\n  }\n  .lg\\:h-3\\/4 {\n    height: 75%;\n  }\n  .lg\\:h-1\\/5 {\n    height: 20%;\n  }\n  .lg\\:h-2\\/5 {\n    height: 40%;\n  }\n  .lg\\:h-3\\/5 {\n    height: 60%;\n  }\n  .lg\\:h-4\\/5 {\n    height: 80%;\n  }\n  .lg\\:h-1\\/6 {\n    height: 16.666667%;\n  }\n  .lg\\:h-2\\/6 {\n    height: 33.333333%;\n  }\n  .lg\\:h-3\\/6 {\n    height: 50%;\n  }\n  .lg\\:h-4\\/6 {\n    height: 66.666667%;\n  }\n  .lg\\:h-5\\/6 {\n    height: 83.333333%;\n  }\n  .lg\\:h-1\\/12 {\n    height: 8.333333%;\n  }\n  .lg\\:h-2\\/12 {\n    height: 16.666667%;\n  }\n  .lg\\:h-3\\/12 {\n    height: 25%;\n  }\n  .lg\\:h-4\\/12 {\n    height: 33.333333%;\n  }\n  .lg\\:h-5\\/12 {\n    height: 41.666667%;\n  }\n  .lg\\:h-6\\/12 {\n    height: 50%;\n  }\n  .lg\\:h-7\\/12 {\n    height: 58.333333%;\n  }\n  .lg\\:h-8\\/12 {\n    height: 66.666667%;\n  }\n  .lg\\:h-9\\/12 {\n    height: 75%;\n  }\n  .lg\\:h-10\\/12 {\n    height: 83.333333%;\n  }\n  .lg\\:h-11\\/12 {\n    height: 91.666667%;\n  }\n  .lg\\:h-full {\n    height: 100%;\n  }\n  .lg\\:h-screen {\n    height: 100vh;\n  }\n  .lg\\:text-xs {\n    font-size: 0.75rem;\n  }\n  .lg\\:text-sm {\n    font-size: 0.875rem;\n  }\n  .lg\\:text-base {\n    font-size: 1rem;\n  }\n  .lg\\:text-lg {\n    font-size: 1.125rem;\n  }\n  .lg\\:text-xl {\n    font-size: 1.25rem;\n  }\n  .lg\\:text-2xl {\n    font-size: 1.5rem;\n  }\n  .lg\\:text-3xl {\n    font-size: 1.875rem;\n  }\n  .lg\\:text-4xl {\n    font-size: 2.25rem;\n  }\n  .lg\\:text-5xl {\n    font-size: 3rem;\n  }\n  .lg\\:text-6xl {\n    font-size: 4rem;\n  }\n  .lg\\:leading-3 {\n    line-height: .75rem;\n  }\n  .lg\\:leading-4 {\n    line-height: 1rem;\n  }\n  .lg\\:leading-5 {\n    line-height: 1.25rem;\n  }\n  .lg\\:leading-6 {\n    line-height: 1.5rem;\n  }\n  .lg\\:leading-7 {\n    line-height: 1.75rem;\n  }\n  .lg\\:leading-8 {\n    line-height: 2rem;\n  }\n  .lg\\:leading-9 {\n    line-height: 2.25rem;\n  }\n  .lg\\:leading-10 {\n    line-height: 2.5rem;\n  }\n  .lg\\:leading-none {\n    line-height: 1;\n  }\n  .lg\\:leading-tight {\n    line-height: 1.25;\n  }\n  .lg\\:leading-snug {\n    line-height: 1.375;\n  }\n  .lg\\:leading-normal {\n    line-height: 1.5;\n  }\n  .lg\\:leading-relaxed {\n    line-height: 1.625;\n  }\n  .lg\\:leading-loose {\n    line-height: 2;\n  }\n  .lg\\:list-inside {\n    list-style-position: inside;\n  }\n  .lg\\:list-outside {\n    list-style-position: outside;\n  }\n  .lg\\:list-none {\n    list-style-type: none;\n  }\n  .lg\\:list-disc {\n    list-style-type: disc;\n  }\n  .lg\\:list-decimal {\n    list-style-type: decimal;\n  }\n  .lg\\:m-0 {\n    margin: 0;\n  }\n  .lg\\:m-1 {\n    margin: 0.25rem;\n  }\n  .lg\\:m-2 {\n    margin: 0.5rem;\n  }\n  .lg\\:m-3 {\n    margin: 0.75rem;\n  }\n  .lg\\:m-4 {\n    margin: 1rem;\n  }\n  .lg\\:m-5 {\n    margin: 1.25rem;\n  }\n  .lg\\:m-6 {\n    margin: 1.5rem;\n  }\n  .lg\\:m-7 {\n    margin: 1.75rem;\n  }\n  .lg\\:m-8 {\n    margin: 2rem;\n  }\n  .lg\\:m-9 {\n    margin: 2.25rem;\n  }\n  .lg\\:m-10 {\n    margin: 2.5rem;\n  }\n  .lg\\:m-11 {\n    margin: 2.75rem;\n  }\n  .lg\\:m-12 {\n    margin: 3rem;\n  }\n  .lg\\:m-13 {\n    margin: 3.25rem;\n  }\n  .lg\\:m-14 {\n    margin: 3.5rem;\n  }\n  .lg\\:m-15 {\n    margin: 3.75rem;\n  }\n  .lg\\:m-16 {\n    margin: 4rem;\n  }\n  .lg\\:m-20 {\n    margin: 5rem;\n  }\n  .lg\\:m-24 {\n    margin: 6rem;\n  }\n  .lg\\:m-28 {\n    margin: 7rem;\n  }\n  .lg\\:m-32 {\n    margin: 8rem;\n  }\n  .lg\\:m-36 {\n    margin: 9rem;\n  }\n  .lg\\:m-40 {\n    margin: 10rem;\n  }\n  .lg\\:m-44 {\n    margin: 11rem;\n  }\n  .lg\\:m-48 {\n    margin: 12rem;\n  }\n  .lg\\:m-52 {\n    margin: 13rem;\n  }\n  .lg\\:m-56 {\n    margin: 14rem;\n  }\n  .lg\\:m-60 {\n    margin: 15rem;\n  }\n  .lg\\:m-64 {\n    margin: 16rem;\n  }\n  .lg\\:m-72 {\n    margin: 18rem;\n  }\n  .lg\\:m-80 {\n    margin: 20rem;\n  }\n  .lg\\:m-96 {\n    margin: 24rem;\n  }\n  .lg\\:m-auto {\n    margin: auto;\n  }\n  .lg\\:m-px {\n    margin: 1px;\n  }\n  .lg\\:m-0\\.5 {\n    margin: 0.125rem;\n  }\n  .lg\\:m-1\\.5 {\n    margin: 0.375rem;\n  }\n  .lg\\:m-2\\.5 {\n    margin: 0.625rem;\n  }\n  .lg\\:m-3\\.5 {\n    margin: 0.875rem;\n  }\n  .lg\\:m-1\\/2 {\n    margin: 50%;\n  }\n  .lg\\:m-1\\/3 {\n    margin: 33.333333%;\n  }\n  .lg\\:m-2\\/3 {\n    margin: 66.666667%;\n  }\n  .lg\\:m-1\\/4 {\n    margin: 25%;\n  }\n  .lg\\:m-2\\/4 {\n    margin: 50%;\n  }\n  .lg\\:m-3\\/4 {\n    margin: 75%;\n  }\n  .lg\\:m-1\\/5 {\n    margin: 20%;\n  }\n  .lg\\:m-2\\/5 {\n    margin: 40%;\n  }\n  .lg\\:m-3\\/5 {\n    margin: 60%;\n  }\n  .lg\\:m-4\\/5 {\n    margin: 80%;\n  }\n  .lg\\:m-1\\/6 {\n    margin: 16.666667%;\n  }\n  .lg\\:m-2\\/6 {\n    margin: 33.333333%;\n  }\n  .lg\\:m-3\\/6 {\n    margin: 50%;\n  }\n  .lg\\:m-4\\/6 {\n    margin: 66.666667%;\n  }\n  .lg\\:m-5\\/6 {\n    margin: 83.333333%;\n  }\n  .lg\\:m-1\\/12 {\n    margin: 8.333333%;\n  }\n  .lg\\:m-2\\/12 {\n    margin: 16.666667%;\n  }\n  .lg\\:m-3\\/12 {\n    margin: 25%;\n  }\n  .lg\\:m-4\\/12 {\n    margin: 33.333333%;\n  }\n  .lg\\:m-5\\/12 {\n    margin: 41.666667%;\n  }\n  .lg\\:m-6\\/12 {\n    margin: 50%;\n  }\n  .lg\\:m-7\\/12 {\n    margin: 58.333333%;\n  }\n  .lg\\:m-8\\/12 {\n    margin: 66.666667%;\n  }\n  .lg\\:m-9\\/12 {\n    margin: 75%;\n  }\n  .lg\\:m-10\\/12 {\n    margin: 83.333333%;\n  }\n  .lg\\:m-11\\/12 {\n    margin: 91.666667%;\n  }\n  .lg\\:m-full {\n    margin: 100%;\n  }\n  .lg\\:-m-1 {\n    margin: -0.25rem;\n  }\n  .lg\\:-m-2 {\n    margin: -0.5rem;\n  }\n  .lg\\:-m-3 {\n    margin: -0.75rem;\n  }\n  .lg\\:-m-4 {\n    margin: -1rem;\n  }\n  .lg\\:-m-5 {\n    margin: -1.25rem;\n  }\n  .lg\\:-m-6 {\n    margin: -1.5rem;\n  }\n  .lg\\:-m-7 {\n    margin: -1.75rem;\n  }\n  .lg\\:-m-8 {\n    margin: -2rem;\n  }\n  .lg\\:-m-9 {\n    margin: -2.25rem;\n  }\n  .lg\\:-m-10 {\n    margin: -2.5rem;\n  }\n  .lg\\:-m-11 {\n    margin: -2.75rem;\n  }\n  .lg\\:-m-12 {\n    margin: -3rem;\n  }\n  .lg\\:-m-13 {\n    margin: -3.25rem;\n  }\n  .lg\\:-m-14 {\n    margin: -3.5rem;\n  }\n  .lg\\:-m-15 {\n    margin: -3.75rem;\n  }\n  .lg\\:-m-16 {\n    margin: -4rem;\n  }\n  .lg\\:-m-20 {\n    margin: -5rem;\n  }\n  .lg\\:-m-24 {\n    margin: -6rem;\n  }\n  .lg\\:-m-28 {\n    margin: -7rem;\n  }\n  .lg\\:-m-32 {\n    margin: -8rem;\n  }\n  .lg\\:-m-36 {\n    margin: -9rem;\n  }\n  .lg\\:-m-40 {\n    margin: -10rem;\n  }\n  .lg\\:-m-44 {\n    margin: -11rem;\n  }\n  .lg\\:-m-48 {\n    margin: -12rem;\n  }\n  .lg\\:-m-52 {\n    margin: -13rem;\n  }\n  .lg\\:-m-56 {\n    margin: -14rem;\n  }\n  .lg\\:-m-60 {\n    margin: -15rem;\n  }\n  .lg\\:-m-64 {\n    margin: -16rem;\n  }\n  .lg\\:-m-72 {\n    margin: -18rem;\n  }\n  .lg\\:-m-80 {\n    margin: -20rem;\n  }\n  .lg\\:-m-96 {\n    margin: -24rem;\n  }\n  .lg\\:-m-px {\n    margin: -1px;\n  }\n  .lg\\:-m-0\\.5 {\n    margin: -0.125rem;\n  }\n  .lg\\:-m-1\\.5 {\n    margin: -0.375rem;\n  }\n  .lg\\:-m-2\\.5 {\n    margin: -0.625rem;\n  }\n  .lg\\:-m-3\\.5 {\n    margin: -0.875rem;\n  }\n  .lg\\:-m-1\\/2 {\n    margin: -50%;\n  }\n  .lg\\:-m-1\\/3 {\n    margin: -33.33333%;\n  }\n  .lg\\:-m-2\\/3 {\n    margin: -66.66667%;\n  }\n  .lg\\:-m-1\\/4 {\n    margin: -25%;\n  }\n  .lg\\:-m-2\\/4 {\n    margin: -50%;\n  }\n  .lg\\:-m-3\\/4 {\n    margin: -75%;\n  }\n  .lg\\:-m-1\\/5 {\n    margin: -20%;\n  }\n  .lg\\:-m-2\\/5 {\n    margin: -40%;\n  }\n  .lg\\:-m-3\\/5 {\n    margin: -60%;\n  }\n  .lg\\:-m-4\\/5 {\n    margin: -80%;\n  }\n  .lg\\:-m-1\\/6 {\n    margin: -16.66667%;\n  }\n  .lg\\:-m-2\\/6 {\n    margin: -33.33333%;\n  }\n  .lg\\:-m-3\\/6 {\n    margin: -50%;\n  }\n  .lg\\:-m-4\\/6 {\n    margin: -66.66667%;\n  }\n  .lg\\:-m-5\\/6 {\n    margin: -83.33333%;\n  }\n  .lg\\:-m-1\\/12 {\n    margin: -8.33333%;\n  }\n  .lg\\:-m-2\\/12 {\n    margin: -16.66667%;\n  }\n  .lg\\:-m-3\\/12 {\n    margin: -25%;\n  }\n  .lg\\:-m-4\\/12 {\n    margin: -33.33333%;\n  }\n  .lg\\:-m-5\\/12 {\n    margin: -41.66667%;\n  }\n  .lg\\:-m-6\\/12 {\n    margin: -50%;\n  }\n  .lg\\:-m-7\\/12 {\n    margin: -58.33333%;\n  }\n  .lg\\:-m-8\\/12 {\n    margin: -66.66667%;\n  }\n  .lg\\:-m-9\\/12 {\n    margin: -75%;\n  }\n  .lg\\:-m-10\\/12 {\n    margin: -83.33333%;\n  }\n  .lg\\:-m-11\\/12 {\n    margin: -91.66667%;\n  }\n  .lg\\:-m-full {\n    margin: -100%;\n  }\n  .lg\\:my-0 {\n    margin-top: 0;\n    margin-bottom: 0;\n  }\n  .lg\\:mx-0 {\n    margin-left: 0;\n    margin-right: 0;\n  }\n  .lg\\:my-1 {\n    margin-top: 0.25rem;\n    margin-bottom: 0.25rem;\n  }\n  .lg\\:mx-1 {\n    margin-left: 0.25rem;\n    margin-right: 0.25rem;\n  }\n  .lg\\:my-2 {\n    margin-top: 0.5rem;\n    margin-bottom: 0.5rem;\n  }\n  .lg\\:mx-2 {\n    margin-left: 0.5rem;\n    margin-right: 0.5rem;\n  }\n  .lg\\:my-3 {\n    margin-top: 0.75rem;\n    margin-bottom: 0.75rem;\n  }\n  .lg\\:mx-3 {\n    margin-left: 0.75rem;\n    margin-right: 0.75rem;\n  }\n  .lg\\:my-4 {\n    margin-top: 1rem;\n    margin-bottom: 1rem;\n  }\n  .lg\\:mx-4 {\n    margin-left: 1rem;\n    margin-right: 1rem;\n  }\n  .lg\\:my-5 {\n    margin-top: 1.25rem;\n    margin-bottom: 1.25rem;\n  }\n  .lg\\:mx-5 {\n    margin-left: 1.25rem;\n    margin-right: 1.25rem;\n  }\n  .lg\\:my-6 {\n    margin-top: 1.5rem;\n    margin-bottom: 1.5rem;\n  }\n  .lg\\:mx-6 {\n    margin-left: 1.5rem;\n    margin-right: 1.5rem;\n  }\n  .lg\\:my-7 {\n    margin-top: 1.75rem;\n    margin-bottom: 1.75rem;\n  }\n  .lg\\:mx-7 {\n    margin-left: 1.75rem;\n    margin-right: 1.75rem;\n  }\n  .lg\\:my-8 {\n    margin-top: 2rem;\n    margin-bottom: 2rem;\n  }\n  .lg\\:mx-8 {\n    margin-left: 2rem;\n    margin-right: 2rem;\n  }\n  .lg\\:my-9 {\n    margin-top: 2.25rem;\n    margin-bottom: 2.25rem;\n  }\n  .lg\\:mx-9 {\n    margin-left: 2.25rem;\n    margin-right: 2.25rem;\n  }\n  .lg\\:my-10 {\n    margin-top: 2.5rem;\n    margin-bottom: 2.5rem;\n  }\n  .lg\\:mx-10 {\n    margin-left: 2.5rem;\n    margin-right: 2.5rem;\n  }\n  .lg\\:my-11 {\n    margin-top: 2.75rem;\n    margin-bottom: 2.75rem;\n  }\n  .lg\\:mx-11 {\n    margin-left: 2.75rem;\n    margin-right: 2.75rem;\n  }\n  .lg\\:my-12 {\n    margin-top: 3rem;\n    margin-bottom: 3rem;\n  }\n  .lg\\:mx-12 {\n    margin-left: 3rem;\n    margin-right: 3rem;\n  }\n  .lg\\:my-13 {\n    margin-top: 3.25rem;\n    margin-bottom: 3.25rem;\n  }\n  .lg\\:mx-13 {\n    margin-left: 3.25rem;\n    margin-right: 3.25rem;\n  }\n  .lg\\:my-14 {\n    margin-top: 3.5rem;\n    margin-bottom: 3.5rem;\n  }\n  .lg\\:mx-14 {\n    margin-left: 3.5rem;\n    margin-right: 3.5rem;\n  }\n  .lg\\:my-15 {\n    margin-top: 3.75rem;\n    margin-bottom: 3.75rem;\n  }\n  .lg\\:mx-15 {\n    margin-left: 3.75rem;\n    margin-right: 3.75rem;\n  }\n  .lg\\:my-16 {\n    margin-top: 4rem;\n    margin-bottom: 4rem;\n  }\n  .lg\\:mx-16 {\n    margin-left: 4rem;\n    margin-right: 4rem;\n  }\n  .lg\\:my-20 {\n    margin-top: 5rem;\n    margin-bottom: 5rem;\n  }\n  .lg\\:mx-20 {\n    margin-left: 5rem;\n    margin-right: 5rem;\n  }\n  .lg\\:my-24 {\n    margin-top: 6rem;\n    margin-bottom: 6rem;\n  }\n  .lg\\:mx-24 {\n    margin-left: 6rem;\n    margin-right: 6rem;\n  }\n  .lg\\:my-28 {\n    margin-top: 7rem;\n    margin-bottom: 7rem;\n  }\n  .lg\\:mx-28 {\n    margin-left: 7rem;\n    margin-right: 7rem;\n  }\n  .lg\\:my-32 {\n    margin-top: 8rem;\n    margin-bottom: 8rem;\n  }\n  .lg\\:mx-32 {\n    margin-left: 8rem;\n    margin-right: 8rem;\n  }\n  .lg\\:my-36 {\n    margin-top: 9rem;\n    margin-bottom: 9rem;\n  }\n  .lg\\:mx-36 {\n    margin-left: 9rem;\n    margin-right: 9rem;\n  }\n  .lg\\:my-40 {\n    margin-top: 10rem;\n    margin-bottom: 10rem;\n  }\n  .lg\\:mx-40 {\n    margin-left: 10rem;\n    margin-right: 10rem;\n  }\n  .lg\\:my-44 {\n    margin-top: 11rem;\n    margin-bottom: 11rem;\n  }\n  .lg\\:mx-44 {\n    margin-left: 11rem;\n    margin-right: 11rem;\n  }\n  .lg\\:my-48 {\n    margin-top: 12rem;\n    margin-bottom: 12rem;\n  }\n  .lg\\:mx-48 {\n    margin-left: 12rem;\n    margin-right: 12rem;\n  }\n  .lg\\:my-52 {\n    margin-top: 13rem;\n    margin-bottom: 13rem;\n  }\n  .lg\\:mx-52 {\n    margin-left: 13rem;\n    margin-right: 13rem;\n  }\n  .lg\\:my-56 {\n    margin-top: 14rem;\n    margin-bottom: 14rem;\n  }\n  .lg\\:mx-56 {\n    margin-left: 14rem;\n    margin-right: 14rem;\n  }\n  .lg\\:my-60 {\n    margin-top: 15rem;\n    margin-bottom: 15rem;\n  }\n  .lg\\:mx-60 {\n    margin-left: 15rem;\n    margin-right: 15rem;\n  }\n  .lg\\:my-64 {\n    margin-top: 16rem;\n    margin-bottom: 16rem;\n  }\n  .lg\\:mx-64 {\n    margin-left: 16rem;\n    margin-right: 16rem;\n  }\n  .lg\\:my-72 {\n    margin-top: 18rem;\n    margin-bottom: 18rem;\n  }\n  .lg\\:mx-72 {\n    margin-left: 18rem;\n    margin-right: 18rem;\n  }\n  .lg\\:my-80 {\n    margin-top: 20rem;\n    margin-bottom: 20rem;\n  }\n  .lg\\:mx-80 {\n    margin-left: 20rem;\n    margin-right: 20rem;\n  }\n  .lg\\:my-96 {\n    margin-top: 24rem;\n    margin-bottom: 24rem;\n  }\n  .lg\\:mx-96 {\n    margin-left: 24rem;\n    margin-right: 24rem;\n  }\n  .lg\\:my-auto {\n    margin-top: auto;\n    margin-bottom: auto;\n  }\n  .lg\\:mx-auto {\n    margin-left: auto;\n    margin-right: auto;\n  }\n  .lg\\:my-px {\n    margin-top: 1px;\n    margin-bottom: 1px;\n  }\n  .lg\\:mx-px {\n    margin-left: 1px;\n    margin-right: 1px;\n  }\n  .lg\\:my-0\\.5 {\n    margin-top: 0.125rem;\n    margin-bottom: 0.125rem;\n  }\n  .lg\\:mx-0\\.5 {\n    margin-left: 0.125rem;\n    margin-right: 0.125rem;\n  }\n  .lg\\:my-1\\.5 {\n    margin-top: 0.375rem;\n    margin-bottom: 0.375rem;\n  }\n  .lg\\:mx-1\\.5 {\n    margin-left: 0.375rem;\n    margin-right: 0.375rem;\n  }\n  .lg\\:my-2\\.5 {\n    margin-top: 0.625rem;\n    margin-bottom: 0.625rem;\n  }\n  .lg\\:mx-2\\.5 {\n    margin-left: 0.625rem;\n    margin-right: 0.625rem;\n  }\n  .lg\\:my-3\\.5 {\n    margin-top: 0.875rem;\n    margin-bottom: 0.875rem;\n  }\n  .lg\\:mx-3\\.5 {\n    margin-left: 0.875rem;\n    margin-right: 0.875rem;\n  }\n  .lg\\:my-1\\/2 {\n    margin-top: 50%;\n    margin-bottom: 50%;\n  }\n  .lg\\:mx-1\\/2 {\n    margin-left: 50%;\n    margin-right: 50%;\n  }\n  .lg\\:my-1\\/3 {\n    margin-top: 33.333333%;\n    margin-bottom: 33.333333%;\n  }\n  .lg\\:mx-1\\/3 {\n    margin-left: 33.333333%;\n    margin-right: 33.333333%;\n  }\n  .lg\\:my-2\\/3 {\n    margin-top: 66.666667%;\n    margin-bottom: 66.666667%;\n  }\n  .lg\\:mx-2\\/3 {\n    margin-left: 66.666667%;\n    margin-right: 66.666667%;\n  }\n  .lg\\:my-1\\/4 {\n    margin-top: 25%;\n    margin-bottom: 25%;\n  }\n  .lg\\:mx-1\\/4 {\n    margin-left: 25%;\n    margin-right: 25%;\n  }\n  .lg\\:my-2\\/4 {\n    margin-top: 50%;\n    margin-bottom: 50%;\n  }\n  .lg\\:mx-2\\/4 {\n    margin-left: 50%;\n    margin-right: 50%;\n  }\n  .lg\\:my-3\\/4 {\n    margin-top: 75%;\n    margin-bottom: 75%;\n  }\n  .lg\\:mx-3\\/4 {\n    margin-left: 75%;\n    margin-right: 75%;\n  }\n  .lg\\:my-1\\/5 {\n    margin-top: 20%;\n    margin-bottom: 20%;\n  }\n  .lg\\:mx-1\\/5 {\n    margin-left: 20%;\n    margin-right: 20%;\n  }\n  .lg\\:my-2\\/5 {\n    margin-top: 40%;\n    margin-bottom: 40%;\n  }\n  .lg\\:mx-2\\/5 {\n    margin-left: 40%;\n    margin-right: 40%;\n  }\n  .lg\\:my-3\\/5 {\n    margin-top: 60%;\n    margin-bottom: 60%;\n  }\n  .lg\\:mx-3\\/5 {\n    margin-left: 60%;\n    margin-right: 60%;\n  }\n  .lg\\:my-4\\/5 {\n    margin-top: 80%;\n    margin-bottom: 80%;\n  }\n  .lg\\:mx-4\\/5 {\n    margin-left: 80%;\n    margin-right: 80%;\n  }\n  .lg\\:my-1\\/6 {\n    margin-top: 16.666667%;\n    margin-bottom: 16.666667%;\n  }\n  .lg\\:mx-1\\/6 {\n    margin-left: 16.666667%;\n    margin-right: 16.666667%;\n  }\n  .lg\\:my-2\\/6 {\n    margin-top: 33.333333%;\n    margin-bottom: 33.333333%;\n  }\n  .lg\\:mx-2\\/6 {\n    margin-left: 33.333333%;\n    margin-right: 33.333333%;\n  }\n  .lg\\:my-3\\/6 {\n    margin-top: 50%;\n    margin-bottom: 50%;\n  }\n  .lg\\:mx-3\\/6 {\n    margin-left: 50%;\n    margin-right: 50%;\n  }\n  .lg\\:my-4\\/6 {\n    margin-top: 66.666667%;\n    margin-bottom: 66.666667%;\n  }\n  .lg\\:mx-4\\/6 {\n    margin-left: 66.666667%;\n    margin-right: 66.666667%;\n  }\n  .lg\\:my-5\\/6 {\n    margin-top: 83.333333%;\n    margin-bottom: 83.333333%;\n  }\n  .lg\\:mx-5\\/6 {\n    margin-left: 83.333333%;\n    margin-right: 83.333333%;\n  }\n  .lg\\:my-1\\/12 {\n    margin-top: 8.333333%;\n    margin-bottom: 8.333333%;\n  }\n  .lg\\:mx-1\\/12 {\n    margin-left: 8.333333%;\n    margin-right: 8.333333%;\n  }\n  .lg\\:my-2\\/12 {\n    margin-top: 16.666667%;\n    margin-bottom: 16.666667%;\n  }\n  .lg\\:mx-2\\/12 {\n    margin-left: 16.666667%;\n    margin-right: 16.666667%;\n  }\n  .lg\\:my-3\\/12 {\n    margin-top: 25%;\n    margin-bottom: 25%;\n  }\n  .lg\\:mx-3\\/12 {\n    margin-left: 25%;\n    margin-right: 25%;\n  }\n  .lg\\:my-4\\/12 {\n    margin-top: 33.333333%;\n    margin-bottom: 33.333333%;\n  }\n  .lg\\:mx-4\\/12 {\n    margin-left: 33.333333%;\n    margin-right: 33.333333%;\n  }\n  .lg\\:my-5\\/12 {\n    margin-top: 41.666667%;\n    margin-bottom: 41.666667%;\n  }\n  .lg\\:mx-5\\/12 {\n    margin-left: 41.666667%;\n    margin-right: 41.666667%;\n  }\n  .lg\\:my-6\\/12 {\n    margin-top: 50%;\n    margin-bottom: 50%;\n  }\n  .lg\\:mx-6\\/12 {\n    margin-left: 50%;\n    margin-right: 50%;\n  }\n  .lg\\:my-7\\/12 {\n    margin-top: 58.333333%;\n    margin-bottom: 58.333333%;\n  }\n  .lg\\:mx-7\\/12 {\n    margin-left: 58.333333%;\n    margin-right: 58.333333%;\n  }\n  .lg\\:my-8\\/12 {\n    margin-top: 66.666667%;\n    margin-bottom: 66.666667%;\n  }\n  .lg\\:mx-8\\/12 {\n    margin-left: 66.666667%;\n    margin-right: 66.666667%;\n  }\n  .lg\\:my-9\\/12 {\n    margin-top: 75%;\n    margin-bottom: 75%;\n  }\n  .lg\\:mx-9\\/12 {\n    margin-left: 75%;\n    margin-right: 75%;\n  }\n  .lg\\:my-10\\/12 {\n    margin-top: 83.333333%;\n    margin-bottom: 83.333333%;\n  }\n  .lg\\:mx-10\\/12 {\n    margin-left: 83.333333%;\n    margin-right: 83.333333%;\n  }\n  .lg\\:my-11\\/12 {\n    margin-top: 91.666667%;\n    margin-bottom: 91.666667%;\n  }\n  .lg\\:mx-11\\/12 {\n    margin-left: 91.666667%;\n    margin-right: 91.666667%;\n  }\n  .lg\\:my-full {\n    margin-top: 100%;\n    margin-bottom: 100%;\n  }\n  .lg\\:mx-full {\n    margin-left: 100%;\n    margin-right: 100%;\n  }\n  .lg\\:-my-1 {\n    margin-top: -0.25rem;\n    margin-bottom: -0.25rem;\n  }\n  .lg\\:-mx-1 {\n    margin-left: -0.25rem;\n    margin-right: -0.25rem;\n  }\n  .lg\\:-my-2 {\n    margin-top: -0.5rem;\n    margin-bottom: -0.5rem;\n  }\n  .lg\\:-mx-2 {\n    margin-left: -0.5rem;\n    margin-right: -0.5rem;\n  }\n  .lg\\:-my-3 {\n    margin-top: -0.75rem;\n    margin-bottom: -0.75rem;\n  }\n  .lg\\:-mx-3 {\n    margin-left: -0.75rem;\n    margin-right: -0.75rem;\n  }\n  .lg\\:-my-4 {\n    margin-top: -1rem;\n    margin-bottom: -1rem;\n  }\n  .lg\\:-mx-4 {\n    margin-left: -1rem;\n    margin-right: -1rem;\n  }\n  .lg\\:-my-5 {\n    margin-top: -1.25rem;\n    margin-bottom: -1.25rem;\n  }\n  .lg\\:-mx-5 {\n    margin-left: -1.25rem;\n    margin-right: -1.25rem;\n  }\n  .lg\\:-my-6 {\n    margin-top: -1.5rem;\n    margin-bottom: -1.5rem;\n  }\n  .lg\\:-mx-6 {\n    margin-left: -1.5rem;\n    margin-right: -1.5rem;\n  }\n  .lg\\:-my-7 {\n    margin-top: -1.75rem;\n    margin-bottom: -1.75rem;\n  }\n  .lg\\:-mx-7 {\n    margin-left: -1.75rem;\n    margin-right: -1.75rem;\n  }\n  .lg\\:-my-8 {\n    margin-top: -2rem;\n    margin-bottom: -2rem;\n  }\n  .lg\\:-mx-8 {\n    margin-left: -2rem;\n    margin-right: -2rem;\n  }\n  .lg\\:-my-9 {\n    margin-top: -2.25rem;\n    margin-bottom: -2.25rem;\n  }\n  .lg\\:-mx-9 {\n    margin-left: -2.25rem;\n    margin-right: -2.25rem;\n  }\n  .lg\\:-my-10 {\n    margin-top: -2.5rem;\n    margin-bottom: -2.5rem;\n  }\n  .lg\\:-mx-10 {\n    margin-left: -2.5rem;\n    margin-right: -2.5rem;\n  }\n  .lg\\:-my-11 {\n    margin-top: -2.75rem;\n    margin-bottom: -2.75rem;\n  }\n  .lg\\:-mx-11 {\n    margin-left: -2.75rem;\n    margin-right: -2.75rem;\n  }\n  .lg\\:-my-12 {\n    margin-top: -3rem;\n    margin-bottom: -3rem;\n  }\n  .lg\\:-mx-12 {\n    margin-left: -3rem;\n    margin-right: -3rem;\n  }\n  .lg\\:-my-13 {\n    margin-top: -3.25rem;\n    margin-bottom: -3.25rem;\n  }\n  .lg\\:-mx-13 {\n    margin-left: -3.25rem;\n    margin-right: -3.25rem;\n  }\n  .lg\\:-my-14 {\n    margin-top: -3.5rem;\n    margin-bottom: -3.5rem;\n  }\n  .lg\\:-mx-14 {\n    margin-left: -3.5rem;\n    margin-right: -3.5rem;\n  }\n  .lg\\:-my-15 {\n    margin-top: -3.75rem;\n    margin-bottom: -3.75rem;\n  }\n  .lg\\:-mx-15 {\n    margin-left: -3.75rem;\n    margin-right: -3.75rem;\n  }\n  .lg\\:-my-16 {\n    margin-top: -4rem;\n    margin-bottom: -4rem;\n  }\n  .lg\\:-mx-16 {\n    margin-left: -4rem;\n    margin-right: -4rem;\n  }\n  .lg\\:-my-20 {\n    margin-top: -5rem;\n    margin-bottom: -5rem;\n  }\n  .lg\\:-mx-20 {\n    margin-left: -5rem;\n    margin-right: -5rem;\n  }\n  .lg\\:-my-24 {\n    margin-top: -6rem;\n    margin-bottom: -6rem;\n  }\n  .lg\\:-mx-24 {\n    margin-left: -6rem;\n    margin-right: -6rem;\n  }\n  .lg\\:-my-28 {\n    margin-top: -7rem;\n    margin-bottom: -7rem;\n  }\n  .lg\\:-mx-28 {\n    margin-left: -7rem;\n    margin-right: -7rem;\n  }\n  .lg\\:-my-32 {\n    margin-top: -8rem;\n    margin-bottom: -8rem;\n  }\n  .lg\\:-mx-32 {\n    margin-left: -8rem;\n    margin-right: -8rem;\n  }\n  .lg\\:-my-36 {\n    margin-top: -9rem;\n    margin-bottom: -9rem;\n  }\n  .lg\\:-mx-36 {\n    margin-left: -9rem;\n    margin-right: -9rem;\n  }\n  .lg\\:-my-40 {\n    margin-top: -10rem;\n    margin-bottom: -10rem;\n  }\n  .lg\\:-mx-40 {\n    margin-left: -10rem;\n    margin-right: -10rem;\n  }\n  .lg\\:-my-44 {\n    margin-top: -11rem;\n    margin-bottom: -11rem;\n  }\n  .lg\\:-mx-44 {\n    margin-left: -11rem;\n    margin-right: -11rem;\n  }\n  .lg\\:-my-48 {\n    margin-top: -12rem;\n    margin-bottom: -12rem;\n  }\n  .lg\\:-mx-48 {\n    margin-left: -12rem;\n    margin-right: -12rem;\n  }\n  .lg\\:-my-52 {\n    margin-top: -13rem;\n    margin-bottom: -13rem;\n  }\n  .lg\\:-mx-52 {\n    margin-left: -13rem;\n    margin-right: -13rem;\n  }\n  .lg\\:-my-56 {\n    margin-top: -14rem;\n    margin-bottom: -14rem;\n  }\n  .lg\\:-mx-56 {\n    margin-left: -14rem;\n    margin-right: -14rem;\n  }\n  .lg\\:-my-60 {\n    margin-top: -15rem;\n    margin-bottom: -15rem;\n  }\n  .lg\\:-mx-60 {\n    margin-left: -15rem;\n    margin-right: -15rem;\n  }\n  .lg\\:-my-64 {\n    margin-top: -16rem;\n    margin-bottom: -16rem;\n  }\n  .lg\\:-mx-64 {\n    margin-left: -16rem;\n    margin-right: -16rem;\n  }\n  .lg\\:-my-72 {\n    margin-top: -18rem;\n    margin-bottom: -18rem;\n  }\n  .lg\\:-mx-72 {\n    margin-left: -18rem;\n    margin-right: -18rem;\n  }\n  .lg\\:-my-80 {\n    margin-top: -20rem;\n    margin-bottom: -20rem;\n  }\n  .lg\\:-mx-80 {\n    margin-left: -20rem;\n    margin-right: -20rem;\n  }\n  .lg\\:-my-96 {\n    margin-top: -24rem;\n    margin-bottom: -24rem;\n  }\n  .lg\\:-mx-96 {\n    margin-left: -24rem;\n    margin-right: -24rem;\n  }\n  .lg\\:-my-px {\n    margin-top: -1px;\n    margin-bottom: -1px;\n  }\n  .lg\\:-mx-px {\n    margin-left: -1px;\n    margin-right: -1px;\n  }\n  .lg\\:-my-0\\.5 {\n    margin-top: -0.125rem;\n    margin-bottom: -0.125rem;\n  }\n  .lg\\:-mx-0\\.5 {\n    margin-left: -0.125rem;\n    margin-right: -0.125rem;\n  }\n  .lg\\:-my-1\\.5 {\n    margin-top: -0.375rem;\n    margin-bottom: -0.375rem;\n  }\n  .lg\\:-mx-1\\.5 {\n    margin-left: -0.375rem;\n    margin-right: -0.375rem;\n  }\n  .lg\\:-my-2\\.5 {\n    margin-top: -0.625rem;\n    margin-bottom: -0.625rem;\n  }\n  .lg\\:-mx-2\\.5 {\n    margin-left: -0.625rem;\n    margin-right: -0.625rem;\n  }\n  .lg\\:-my-3\\.5 {\n    margin-top: -0.875rem;\n    margin-bottom: -0.875rem;\n  }\n  .lg\\:-mx-3\\.5 {\n    margin-left: -0.875rem;\n    margin-right: -0.875rem;\n  }\n  .lg\\:-my-1\\/2 {\n    margin-top: -50%;\n    margin-bottom: -50%;\n  }\n  .lg\\:-mx-1\\/2 {\n    margin-left: -50%;\n    margin-right: -50%;\n  }\n  .lg\\:-my-1\\/3 {\n    margin-top: -33.33333%;\n    margin-bottom: -33.33333%;\n  }\n  .lg\\:-mx-1\\/3 {\n    margin-left: -33.33333%;\n    margin-right: -33.33333%;\n  }\n  .lg\\:-my-2\\/3 {\n    margin-top: -66.66667%;\n    margin-bottom: -66.66667%;\n  }\n  .lg\\:-mx-2\\/3 {\n    margin-left: -66.66667%;\n    margin-right: -66.66667%;\n  }\n  .lg\\:-my-1\\/4 {\n    margin-top: -25%;\n    margin-bottom: -25%;\n  }\n  .lg\\:-mx-1\\/4 {\n    margin-left: -25%;\n    margin-right: -25%;\n  }\n  .lg\\:-my-2\\/4 {\n    margin-top: -50%;\n    margin-bottom: -50%;\n  }\n  .lg\\:-mx-2\\/4 {\n    margin-left: -50%;\n    margin-right: -50%;\n  }\n  .lg\\:-my-3\\/4 {\n    margin-top: -75%;\n    margin-bottom: -75%;\n  }\n  .lg\\:-mx-3\\/4 {\n    margin-left: -75%;\n    margin-right: -75%;\n  }\n  .lg\\:-my-1\\/5 {\n    margin-top: -20%;\n    margin-bottom: -20%;\n  }\n  .lg\\:-mx-1\\/5 {\n    margin-left: -20%;\n    margin-right: -20%;\n  }\n  .lg\\:-my-2\\/5 {\n    margin-top: -40%;\n    margin-bottom: -40%;\n  }\n  .lg\\:-mx-2\\/5 {\n    margin-left: -40%;\n    margin-right: -40%;\n  }\n  .lg\\:-my-3\\/5 {\n    margin-top: -60%;\n    margin-bottom: -60%;\n  }\n  .lg\\:-mx-3\\/5 {\n    margin-left: -60%;\n    margin-right: -60%;\n  }\n  .lg\\:-my-4\\/5 {\n    margin-top: -80%;\n    margin-bottom: -80%;\n  }\n  .lg\\:-mx-4\\/5 {\n    margin-left: -80%;\n    margin-right: -80%;\n  }\n  .lg\\:-my-1\\/6 {\n    margin-top: -16.66667%;\n    margin-bottom: -16.66667%;\n  }\n  .lg\\:-mx-1\\/6 {\n    margin-left: -16.66667%;\n    margin-right: -16.66667%;\n  }\n  .lg\\:-my-2\\/6 {\n    margin-top: -33.33333%;\n    margin-bottom: -33.33333%;\n  }\n  .lg\\:-mx-2\\/6 {\n    margin-left: -33.33333%;\n    margin-right: -33.33333%;\n  }\n  .lg\\:-my-3\\/6 {\n    margin-top: -50%;\n    margin-bottom: -50%;\n  }\n  .lg\\:-mx-3\\/6 {\n    margin-left: -50%;\n    margin-right: -50%;\n  }\n  .lg\\:-my-4\\/6 {\n    margin-top: -66.66667%;\n    margin-bottom: -66.66667%;\n  }\n  .lg\\:-mx-4\\/6 {\n    margin-left: -66.66667%;\n    margin-right: -66.66667%;\n  }\n  .lg\\:-my-5\\/6 {\n    margin-top: -83.33333%;\n    margin-bottom: -83.33333%;\n  }\n  .lg\\:-mx-5\\/6 {\n    margin-left: -83.33333%;\n    margin-right: -83.33333%;\n  }\n  .lg\\:-my-1\\/12 {\n    margin-top: -8.33333%;\n    margin-bottom: -8.33333%;\n  }\n  .lg\\:-mx-1\\/12 {\n    margin-left: -8.33333%;\n    margin-right: -8.33333%;\n  }\n  .lg\\:-my-2\\/12 {\n    margin-top: -16.66667%;\n    margin-bottom: -16.66667%;\n  }\n  .lg\\:-mx-2\\/12 {\n    margin-left: -16.66667%;\n    margin-right: -16.66667%;\n  }\n  .lg\\:-my-3\\/12 {\n    margin-top: -25%;\n    margin-bottom: -25%;\n  }\n  .lg\\:-mx-3\\/12 {\n    margin-left: -25%;\n    margin-right: -25%;\n  }\n  .lg\\:-my-4\\/12 {\n    margin-top: -33.33333%;\n    margin-bottom: -33.33333%;\n  }\n  .lg\\:-mx-4\\/12 {\n    margin-left: -33.33333%;\n    margin-right: -33.33333%;\n  }\n  .lg\\:-my-5\\/12 {\n    margin-top: -41.66667%;\n    margin-bottom: -41.66667%;\n  }\n  .lg\\:-mx-5\\/12 {\n    margin-left: -41.66667%;\n    margin-right: -41.66667%;\n  }\n  .lg\\:-my-6\\/12 {\n    margin-top: -50%;\n    margin-bottom: -50%;\n  }\n  .lg\\:-mx-6\\/12 {\n    margin-left: -50%;\n    margin-right: -50%;\n  }\n  .lg\\:-my-7\\/12 {\n    margin-top: -58.33333%;\n    margin-bottom: -58.33333%;\n  }\n  .lg\\:-mx-7\\/12 {\n    margin-left: -58.33333%;\n    margin-right: -58.33333%;\n  }\n  .lg\\:-my-8\\/12 {\n    margin-top: -66.66667%;\n    margin-bottom: -66.66667%;\n  }\n  .lg\\:-mx-8\\/12 {\n    margin-left: -66.66667%;\n    margin-right: -66.66667%;\n  }\n  .lg\\:-my-9\\/12 {\n    margin-top: -75%;\n    margin-bottom: -75%;\n  }\n  .lg\\:-mx-9\\/12 {\n    margin-left: -75%;\n    margin-right: -75%;\n  }\n  .lg\\:-my-10\\/12 {\n    margin-top: -83.33333%;\n    margin-bottom: -83.33333%;\n  }\n  .lg\\:-mx-10\\/12 {\n    margin-left: -83.33333%;\n    margin-right: -83.33333%;\n  }\n  .lg\\:-my-11\\/12 {\n    margin-top: -91.66667%;\n    margin-bottom: -91.66667%;\n  }\n  .lg\\:-mx-11\\/12 {\n    margin-left: -91.66667%;\n    margin-right: -91.66667%;\n  }\n  .lg\\:-my-full {\n    margin-top: -100%;\n    margin-bottom: -100%;\n  }\n  .lg\\:-mx-full {\n    margin-left: -100%;\n    margin-right: -100%;\n  }\n  .lg\\:mt-0 {\n    margin-top: 0;\n  }\n  .lg\\:mr-0 {\n    margin-right: 0;\n  }\n  .lg\\:mb-0 {\n    margin-bottom: 0;\n  }\n  .lg\\:ml-0 {\n    margin-left: 0;\n  }\n  .lg\\:mt-1 {\n    margin-top: 0.25rem;\n  }\n  .lg\\:mr-1 {\n    margin-right: 0.25rem;\n  }\n  .lg\\:mb-1 {\n    margin-bottom: 0.25rem;\n  }\n  .lg\\:ml-1 {\n    margin-left: 0.25rem;\n  }\n  .lg\\:mt-2 {\n    margin-top: 0.5rem;\n  }\n  .lg\\:mr-2 {\n    margin-right: 0.5rem;\n  }\n  .lg\\:mb-2 {\n    margin-bottom: 0.5rem;\n  }\n  .lg\\:ml-2 {\n    margin-left: 0.5rem;\n  }\n  .lg\\:mt-3 {\n    margin-top: 0.75rem;\n  }\n  .lg\\:mr-3 {\n    margin-right: 0.75rem;\n  }\n  .lg\\:mb-3 {\n    margin-bottom: 0.75rem;\n  }\n  .lg\\:ml-3 {\n    margin-left: 0.75rem;\n  }\n  .lg\\:mt-4 {\n    margin-top: 1rem;\n  }\n  .lg\\:mr-4 {\n    margin-right: 1rem;\n  }\n  .lg\\:mb-4 {\n    margin-bottom: 1rem;\n  }\n  .lg\\:ml-4 {\n    margin-left: 1rem;\n  }\n  .lg\\:mt-5 {\n    margin-top: 1.25rem;\n  }\n  .lg\\:mr-5 {\n    margin-right: 1.25rem;\n  }\n  .lg\\:mb-5 {\n    margin-bottom: 1.25rem;\n  }\n  .lg\\:ml-5 {\n    margin-left: 1.25rem;\n  }\n  .lg\\:mt-6 {\n    margin-top: 1.5rem;\n  }\n  .lg\\:mr-6 {\n    margin-right: 1.5rem;\n  }\n  .lg\\:mb-6 {\n    margin-bottom: 1.5rem;\n  }\n  .lg\\:ml-6 {\n    margin-left: 1.5rem;\n  }\n  .lg\\:mt-7 {\n    margin-top: 1.75rem;\n  }\n  .lg\\:mr-7 {\n    margin-right: 1.75rem;\n  }\n  .lg\\:mb-7 {\n    margin-bottom: 1.75rem;\n  }\n  .lg\\:ml-7 {\n    margin-left: 1.75rem;\n  }\n  .lg\\:mt-8 {\n    margin-top: 2rem;\n  }\n  .lg\\:mr-8 {\n    margin-right: 2rem;\n  }\n  .lg\\:mb-8 {\n    margin-bottom: 2rem;\n  }\n  .lg\\:ml-8 {\n    margin-left: 2rem;\n  }\n  .lg\\:mt-9 {\n    margin-top: 2.25rem;\n  }\n  .lg\\:mr-9 {\n    margin-right: 2.25rem;\n  }\n  .lg\\:mb-9 {\n    margin-bottom: 2.25rem;\n  }\n  .lg\\:ml-9 {\n    margin-left: 2.25rem;\n  }\n  .lg\\:mt-10 {\n    margin-top: 2.5rem;\n  }\n  .lg\\:mr-10 {\n    margin-right: 2.5rem;\n  }\n  .lg\\:mb-10 {\n    margin-bottom: 2.5rem;\n  }\n  .lg\\:ml-10 {\n    margin-left: 2.5rem;\n  }\n  .lg\\:mt-11 {\n    margin-top: 2.75rem;\n  }\n  .lg\\:mr-11 {\n    margin-right: 2.75rem;\n  }\n  .lg\\:mb-11 {\n    margin-bottom: 2.75rem;\n  }\n  .lg\\:ml-11 {\n    margin-left: 2.75rem;\n  }\n  .lg\\:mt-12 {\n    margin-top: 3rem;\n  }\n  .lg\\:mr-12 {\n    margin-right: 3rem;\n  }\n  .lg\\:mb-12 {\n    margin-bottom: 3rem;\n  }\n  .lg\\:ml-12 {\n    margin-left: 3rem;\n  }\n  .lg\\:mt-13 {\n    margin-top: 3.25rem;\n  }\n  .lg\\:mr-13 {\n    margin-right: 3.25rem;\n  }\n  .lg\\:mb-13 {\n    margin-bottom: 3.25rem;\n  }\n  .lg\\:ml-13 {\n    margin-left: 3.25rem;\n  }\n  .lg\\:mt-14 {\n    margin-top: 3.5rem;\n  }\n  .lg\\:mr-14 {\n    margin-right: 3.5rem;\n  }\n  .lg\\:mb-14 {\n    margin-bottom: 3.5rem;\n  }\n  .lg\\:ml-14 {\n    margin-left: 3.5rem;\n  }\n  .lg\\:mt-15 {\n    margin-top: 3.75rem;\n  }\n  .lg\\:mr-15 {\n    margin-right: 3.75rem;\n  }\n  .lg\\:mb-15 {\n    margin-bottom: 3.75rem;\n  }\n  .lg\\:ml-15 {\n    margin-left: 3.75rem;\n  }\n  .lg\\:mt-16 {\n    margin-top: 4rem;\n  }\n  .lg\\:mr-16 {\n    margin-right: 4rem;\n  }\n  .lg\\:mb-16 {\n    margin-bottom: 4rem;\n  }\n  .lg\\:ml-16 {\n    margin-left: 4rem;\n  }\n  .lg\\:mt-20 {\n    margin-top: 5rem;\n  }\n  .lg\\:mr-20 {\n    margin-right: 5rem;\n  }\n  .lg\\:mb-20 {\n    margin-bottom: 5rem;\n  }\n  .lg\\:ml-20 {\n    margin-left: 5rem;\n  }\n  .lg\\:mt-24 {\n    margin-top: 6rem;\n  }\n  .lg\\:mr-24 {\n    margin-right: 6rem;\n  }\n  .lg\\:mb-24 {\n    margin-bottom: 6rem;\n  }\n  .lg\\:ml-24 {\n    margin-left: 6rem;\n  }\n  .lg\\:mt-28 {\n    margin-top: 7rem;\n  }\n  .lg\\:mr-28 {\n    margin-right: 7rem;\n  }\n  .lg\\:mb-28 {\n    margin-bottom: 7rem;\n  }\n  .lg\\:ml-28 {\n    margin-left: 7rem;\n  }\n  .lg\\:mt-32 {\n    margin-top: 8rem;\n  }\n  .lg\\:mr-32 {\n    margin-right: 8rem;\n  }\n  .lg\\:mb-32 {\n    margin-bottom: 8rem;\n  }\n  .lg\\:ml-32 {\n    margin-left: 8rem;\n  }\n  .lg\\:mt-36 {\n    margin-top: 9rem;\n  }\n  .lg\\:mr-36 {\n    margin-right: 9rem;\n  }\n  .lg\\:mb-36 {\n    margin-bottom: 9rem;\n  }\n  .lg\\:ml-36 {\n    margin-left: 9rem;\n  }\n  .lg\\:mt-40 {\n    margin-top: 10rem;\n  }\n  .lg\\:mr-40 {\n    margin-right: 10rem;\n  }\n  .lg\\:mb-40 {\n    margin-bottom: 10rem;\n  }\n  .lg\\:ml-40 {\n    margin-left: 10rem;\n  }\n  .lg\\:mt-44 {\n    margin-top: 11rem;\n  }\n  .lg\\:mr-44 {\n    margin-right: 11rem;\n  }\n  .lg\\:mb-44 {\n    margin-bottom: 11rem;\n  }\n  .lg\\:ml-44 {\n    margin-left: 11rem;\n  }\n  .lg\\:mt-48 {\n    margin-top: 12rem;\n  }\n  .lg\\:mr-48 {\n    margin-right: 12rem;\n  }\n  .lg\\:mb-48 {\n    margin-bottom: 12rem;\n  }\n  .lg\\:ml-48 {\n    margin-left: 12rem;\n  }\n  .lg\\:mt-52 {\n    margin-top: 13rem;\n  }\n  .lg\\:mr-52 {\n    margin-right: 13rem;\n  }\n  .lg\\:mb-52 {\n    margin-bottom: 13rem;\n  }\n  .lg\\:ml-52 {\n    margin-left: 13rem;\n  }\n  .lg\\:mt-56 {\n    margin-top: 14rem;\n  }\n  .lg\\:mr-56 {\n    margin-right: 14rem;\n  }\n  .lg\\:mb-56 {\n    margin-bottom: 14rem;\n  }\n  .lg\\:ml-56 {\n    margin-left: 14rem;\n  }\n  .lg\\:mt-60 {\n    margin-top: 15rem;\n  }\n  .lg\\:mr-60 {\n    margin-right: 15rem;\n  }\n  .lg\\:mb-60 {\n    margin-bottom: 15rem;\n  }\n  .lg\\:ml-60 {\n    margin-left: 15rem;\n  }\n  .lg\\:mt-64 {\n    margin-top: 16rem;\n  }\n  .lg\\:mr-64 {\n    margin-right: 16rem;\n  }\n  .lg\\:mb-64 {\n    margin-bottom: 16rem;\n  }\n  .lg\\:ml-64 {\n    margin-left: 16rem;\n  }\n  .lg\\:mt-72 {\n    margin-top: 18rem;\n  }\n  .lg\\:mr-72 {\n    margin-right: 18rem;\n  }\n  .lg\\:mb-72 {\n    margin-bottom: 18rem;\n  }\n  .lg\\:ml-72 {\n    margin-left: 18rem;\n  }\n  .lg\\:mt-80 {\n    margin-top: 20rem;\n  }\n  .lg\\:mr-80 {\n    margin-right: 20rem;\n  }\n  .lg\\:mb-80 {\n    margin-bottom: 20rem;\n  }\n  .lg\\:ml-80 {\n    margin-left: 20rem;\n  }\n  .lg\\:mt-96 {\n    margin-top: 24rem;\n  }\n  .lg\\:mr-96 {\n    margin-right: 24rem;\n  }\n  .lg\\:mb-96 {\n    margin-bottom: 24rem;\n  }\n  .lg\\:ml-96 {\n    margin-left: 24rem;\n  }\n  .lg\\:mt-auto {\n    margin-top: auto;\n  }\n  .lg\\:mr-auto {\n    margin-right: auto;\n  }\n  .lg\\:mb-auto {\n    margin-bottom: auto;\n  }\n  .lg\\:ml-auto {\n    margin-left: auto;\n  }\n  .lg\\:mt-px {\n    margin-top: 1px;\n  }\n  .lg\\:mr-px {\n    margin-right: 1px;\n  }\n  .lg\\:mb-px {\n    margin-bottom: 1px;\n  }\n  .lg\\:ml-px {\n    margin-left: 1px;\n  }\n  .lg\\:mt-0\\.5 {\n    margin-top: 0.125rem;\n  }\n  .lg\\:mr-0\\.5 {\n    margin-right: 0.125rem;\n  }\n  .lg\\:mb-0\\.5 {\n    margin-bottom: 0.125rem;\n  }\n  .lg\\:ml-0\\.5 {\n    margin-left: 0.125rem;\n  }\n  .lg\\:mt-1\\.5 {\n    margin-top: 0.375rem;\n  }\n  .lg\\:mr-1\\.5 {\n    margin-right: 0.375rem;\n  }\n  .lg\\:mb-1\\.5 {\n    margin-bottom: 0.375rem;\n  }\n  .lg\\:ml-1\\.5 {\n    margin-left: 0.375rem;\n  }\n  .lg\\:mt-2\\.5 {\n    margin-top: 0.625rem;\n  }\n  .lg\\:mr-2\\.5 {\n    margin-right: 0.625rem;\n  }\n  .lg\\:mb-2\\.5 {\n    margin-bottom: 0.625rem;\n  }\n  .lg\\:ml-2\\.5 {\n    margin-left: 0.625rem;\n  }\n  .lg\\:mt-3\\.5 {\n    margin-top: 0.875rem;\n  }\n  .lg\\:mr-3\\.5 {\n    margin-right: 0.875rem;\n  }\n  .lg\\:mb-3\\.5 {\n    margin-bottom: 0.875rem;\n  }\n  .lg\\:ml-3\\.5 {\n    margin-left: 0.875rem;\n  }\n  .lg\\:mt-1\\/2 {\n    margin-top: 50%;\n  }\n  .lg\\:mr-1\\/2 {\n    margin-right: 50%;\n  }\n  .lg\\:mb-1\\/2 {\n    margin-bottom: 50%;\n  }\n  .lg\\:ml-1\\/2 {\n    margin-left: 50%;\n  }\n  .lg\\:mt-1\\/3 {\n    margin-top: 33.333333%;\n  }\n  .lg\\:mr-1\\/3 {\n    margin-right: 33.333333%;\n  }\n  .lg\\:mb-1\\/3 {\n    margin-bottom: 33.333333%;\n  }\n  .lg\\:ml-1\\/3 {\n    margin-left: 33.333333%;\n  }\n  .lg\\:mt-2\\/3 {\n    margin-top: 66.666667%;\n  }\n  .lg\\:mr-2\\/3 {\n    margin-right: 66.666667%;\n  }\n  .lg\\:mb-2\\/3 {\n    margin-bottom: 66.666667%;\n  }\n  .lg\\:ml-2\\/3 {\n    margin-left: 66.666667%;\n  }\n  .lg\\:mt-1\\/4 {\n    margin-top: 25%;\n  }\n  .lg\\:mr-1\\/4 {\n    margin-right: 25%;\n  }\n  .lg\\:mb-1\\/4 {\n    margin-bottom: 25%;\n  }\n  .lg\\:ml-1\\/4 {\n    margin-left: 25%;\n  }\n  .lg\\:mt-2\\/4 {\n    margin-top: 50%;\n  }\n  .lg\\:mr-2\\/4 {\n    margin-right: 50%;\n  }\n  .lg\\:mb-2\\/4 {\n    margin-bottom: 50%;\n  }\n  .lg\\:ml-2\\/4 {\n    margin-left: 50%;\n  }\n  .lg\\:mt-3\\/4 {\n    margin-top: 75%;\n  }\n  .lg\\:mr-3\\/4 {\n    margin-right: 75%;\n  }\n  .lg\\:mb-3\\/4 {\n    margin-bottom: 75%;\n  }\n  .lg\\:ml-3\\/4 {\n    margin-left: 75%;\n  }\n  .lg\\:mt-1\\/5 {\n    margin-top: 20%;\n  }\n  .lg\\:mr-1\\/5 {\n    margin-right: 20%;\n  }\n  .lg\\:mb-1\\/5 {\n    margin-bottom: 20%;\n  }\n  .lg\\:ml-1\\/5 {\n    margin-left: 20%;\n  }\n  .lg\\:mt-2\\/5 {\n    margin-top: 40%;\n  }\n  .lg\\:mr-2\\/5 {\n    margin-right: 40%;\n  }\n  .lg\\:mb-2\\/5 {\n    margin-bottom: 40%;\n  }\n  .lg\\:ml-2\\/5 {\n    margin-left: 40%;\n  }\n  .lg\\:mt-3\\/5 {\n    margin-top: 60%;\n  }\n  .lg\\:mr-3\\/5 {\n    margin-right: 60%;\n  }\n  .lg\\:mb-3\\/5 {\n    margin-bottom: 60%;\n  }\n  .lg\\:ml-3\\/5 {\n    margin-left: 60%;\n  }\n  .lg\\:mt-4\\/5 {\n    margin-top: 80%;\n  }\n  .lg\\:mr-4\\/5 {\n    margin-right: 80%;\n  }\n  .lg\\:mb-4\\/5 {\n    margin-bottom: 80%;\n  }\n  .lg\\:ml-4\\/5 {\n    margin-left: 80%;\n  }\n  .lg\\:mt-1\\/6 {\n    margin-top: 16.666667%;\n  }\n  .lg\\:mr-1\\/6 {\n    margin-right: 16.666667%;\n  }\n  .lg\\:mb-1\\/6 {\n    margin-bottom: 16.666667%;\n  }\n  .lg\\:ml-1\\/6 {\n    margin-left: 16.666667%;\n  }\n  .lg\\:mt-2\\/6 {\n    margin-top: 33.333333%;\n  }\n  .lg\\:mr-2\\/6 {\n    margin-right: 33.333333%;\n  }\n  .lg\\:mb-2\\/6 {\n    margin-bottom: 33.333333%;\n  }\n  .lg\\:ml-2\\/6 {\n    margin-left: 33.333333%;\n  }\n  .lg\\:mt-3\\/6 {\n    margin-top: 50%;\n  }\n  .lg\\:mr-3\\/6 {\n    margin-right: 50%;\n  }\n  .lg\\:mb-3\\/6 {\n    margin-bottom: 50%;\n  }\n  .lg\\:ml-3\\/6 {\n    margin-left: 50%;\n  }\n  .lg\\:mt-4\\/6 {\n    margin-top: 66.666667%;\n  }\n  .lg\\:mr-4\\/6 {\n    margin-right: 66.666667%;\n  }\n  .lg\\:mb-4\\/6 {\n    margin-bottom: 66.666667%;\n  }\n  .lg\\:ml-4\\/6 {\n    margin-left: 66.666667%;\n  }\n  .lg\\:mt-5\\/6 {\n    margin-top: 83.333333%;\n  }\n  .lg\\:mr-5\\/6 {\n    margin-right: 83.333333%;\n  }\n  .lg\\:mb-5\\/6 {\n    margin-bottom: 83.333333%;\n  }\n  .lg\\:ml-5\\/6 {\n    margin-left: 83.333333%;\n  }\n  .lg\\:mt-1\\/12 {\n    margin-top: 8.333333%;\n  }\n  .lg\\:mr-1\\/12 {\n    margin-right: 8.333333%;\n  }\n  .lg\\:mb-1\\/12 {\n    margin-bottom: 8.333333%;\n  }\n  .lg\\:ml-1\\/12 {\n    margin-left: 8.333333%;\n  }\n  .lg\\:mt-2\\/12 {\n    margin-top: 16.666667%;\n  }\n  .lg\\:mr-2\\/12 {\n    margin-right: 16.666667%;\n  }\n  .lg\\:mb-2\\/12 {\n    margin-bottom: 16.666667%;\n  }\n  .lg\\:ml-2\\/12 {\n    margin-left: 16.666667%;\n  }\n  .lg\\:mt-3\\/12 {\n    margin-top: 25%;\n  }\n  .lg\\:mr-3\\/12 {\n    margin-right: 25%;\n  }\n  .lg\\:mb-3\\/12 {\n    margin-bottom: 25%;\n  }\n  .lg\\:ml-3\\/12 {\n    margin-left: 25%;\n  }\n  .lg\\:mt-4\\/12 {\n    margin-top: 33.333333%;\n  }\n  .lg\\:mr-4\\/12 {\n    margin-right: 33.333333%;\n  }\n  .lg\\:mb-4\\/12 {\n    margin-bottom: 33.333333%;\n  }\n  .lg\\:ml-4\\/12 {\n    margin-left: 33.333333%;\n  }\n  .lg\\:mt-5\\/12 {\n    margin-top: 41.666667%;\n  }\n  .lg\\:mr-5\\/12 {\n    margin-right: 41.666667%;\n  }\n  .lg\\:mb-5\\/12 {\n    margin-bottom: 41.666667%;\n  }\n  .lg\\:ml-5\\/12 {\n    margin-left: 41.666667%;\n  }\n  .lg\\:mt-6\\/12 {\n    margin-top: 50%;\n  }\n  .lg\\:mr-6\\/12 {\n    margin-right: 50%;\n  }\n  .lg\\:mb-6\\/12 {\n    margin-bottom: 50%;\n  }\n  .lg\\:ml-6\\/12 {\n    margin-left: 50%;\n  }\n  .lg\\:mt-7\\/12 {\n    margin-top: 58.333333%;\n  }\n  .lg\\:mr-7\\/12 {\n    margin-right: 58.333333%;\n  }\n  .lg\\:mb-7\\/12 {\n    margin-bottom: 58.333333%;\n  }\n  .lg\\:ml-7\\/12 {\n    margin-left: 58.333333%;\n  }\n  .lg\\:mt-8\\/12 {\n    margin-top: 66.666667%;\n  }\n  .lg\\:mr-8\\/12 {\n    margin-right: 66.666667%;\n  }\n  .lg\\:mb-8\\/12 {\n    margin-bottom: 66.666667%;\n  }\n  .lg\\:ml-8\\/12 {\n    margin-left: 66.666667%;\n  }\n  .lg\\:mt-9\\/12 {\n    margin-top: 75%;\n  }\n  .lg\\:mr-9\\/12 {\n    margin-right: 75%;\n  }\n  .lg\\:mb-9\\/12 {\n    margin-bottom: 75%;\n  }\n  .lg\\:ml-9\\/12 {\n    margin-left: 75%;\n  }\n  .lg\\:mt-10\\/12 {\n    margin-top: 83.333333%;\n  }\n  .lg\\:mr-10\\/12 {\n    margin-right: 83.333333%;\n  }\n  .lg\\:mb-10\\/12 {\n    margin-bottom: 83.333333%;\n  }\n  .lg\\:ml-10\\/12 {\n    margin-left: 83.333333%;\n  }\n  .lg\\:mt-11\\/12 {\n    margin-top: 91.666667%;\n  }\n  .lg\\:mr-11\\/12 {\n    margin-right: 91.666667%;\n  }\n  .lg\\:mb-11\\/12 {\n    margin-bottom: 91.666667%;\n  }\n  .lg\\:ml-11\\/12 {\n    margin-left: 91.666667%;\n  }\n  .lg\\:mt-full {\n    margin-top: 100%;\n  }\n  .lg\\:mr-full {\n    margin-right: 100%;\n  }\n  .lg\\:mb-full {\n    margin-bottom: 100%;\n  }\n  .lg\\:ml-full {\n    margin-left: 100%;\n  }\n  .lg\\:-mt-1 {\n    margin-top: -0.25rem;\n  }\n  .lg\\:-mr-1 {\n    margin-right: -0.25rem;\n  }\n  .lg\\:-mb-1 {\n    margin-bottom: -0.25rem;\n  }\n  .lg\\:-ml-1 {\n    margin-left: -0.25rem;\n  }\n  .lg\\:-mt-2 {\n    margin-top: -0.5rem;\n  }\n  .lg\\:-mr-2 {\n    margin-right: -0.5rem;\n  }\n  .lg\\:-mb-2 {\n    margin-bottom: -0.5rem;\n  }\n  .lg\\:-ml-2 {\n    margin-left: -0.5rem;\n  }\n  .lg\\:-mt-3 {\n    margin-top: -0.75rem;\n  }\n  .lg\\:-mr-3 {\n    margin-right: -0.75rem;\n  }\n  .lg\\:-mb-3 {\n    margin-bottom: -0.75rem;\n  }\n  .lg\\:-ml-3 {\n    margin-left: -0.75rem;\n  }\n  .lg\\:-mt-4 {\n    margin-top: -1rem;\n  }\n  .lg\\:-mr-4 {\n    margin-right: -1rem;\n  }\n  .lg\\:-mb-4 {\n    margin-bottom: -1rem;\n  }\n  .lg\\:-ml-4 {\n    margin-left: -1rem;\n  }\n  .lg\\:-mt-5 {\n    margin-top: -1.25rem;\n  }\n  .lg\\:-mr-5 {\n    margin-right: -1.25rem;\n  }\n  .lg\\:-mb-5 {\n    margin-bottom: -1.25rem;\n  }\n  .lg\\:-ml-5 {\n    margin-left: -1.25rem;\n  }\n  .lg\\:-mt-6 {\n    margin-top: -1.5rem;\n  }\n  .lg\\:-mr-6 {\n    margin-right: -1.5rem;\n  }\n  .lg\\:-mb-6 {\n    margin-bottom: -1.5rem;\n  }\n  .lg\\:-ml-6 {\n    margin-left: -1.5rem;\n  }\n  .lg\\:-mt-7 {\n    margin-top: -1.75rem;\n  }\n  .lg\\:-mr-7 {\n    margin-right: -1.75rem;\n  }\n  .lg\\:-mb-7 {\n    margin-bottom: -1.75rem;\n  }\n  .lg\\:-ml-7 {\n    margin-left: -1.75rem;\n  }\n  .lg\\:-mt-8 {\n    margin-top: -2rem;\n  }\n  .lg\\:-mr-8 {\n    margin-right: -2rem;\n  }\n  .lg\\:-mb-8 {\n    margin-bottom: -2rem;\n  }\n  .lg\\:-ml-8 {\n    margin-left: -2rem;\n  }\n  .lg\\:-mt-9 {\n    margin-top: -2.25rem;\n  }\n  .lg\\:-mr-9 {\n    margin-right: -2.25rem;\n  }\n  .lg\\:-mb-9 {\n    margin-bottom: -2.25rem;\n  }\n  .lg\\:-ml-9 {\n    margin-left: -2.25rem;\n  }\n  .lg\\:-mt-10 {\n    margin-top: -2.5rem;\n  }\n  .lg\\:-mr-10 {\n    margin-right: -2.5rem;\n  }\n  .lg\\:-mb-10 {\n    margin-bottom: -2.5rem;\n  }\n  .lg\\:-ml-10 {\n    margin-left: -2.5rem;\n  }\n  .lg\\:-mt-11 {\n    margin-top: -2.75rem;\n  }\n  .lg\\:-mr-11 {\n    margin-right: -2.75rem;\n  }\n  .lg\\:-mb-11 {\n    margin-bottom: -2.75rem;\n  }\n  .lg\\:-ml-11 {\n    margin-left: -2.75rem;\n  }\n  .lg\\:-mt-12 {\n    margin-top: -3rem;\n  }\n  .lg\\:-mr-12 {\n    margin-right: -3rem;\n  }\n  .lg\\:-mb-12 {\n    margin-bottom: -3rem;\n  }\n  .lg\\:-ml-12 {\n    margin-left: -3rem;\n  }\n  .lg\\:-mt-13 {\n    margin-top: -3.25rem;\n  }\n  .lg\\:-mr-13 {\n    margin-right: -3.25rem;\n  }\n  .lg\\:-mb-13 {\n    margin-bottom: -3.25rem;\n  }\n  .lg\\:-ml-13 {\n    margin-left: -3.25rem;\n  }\n  .lg\\:-mt-14 {\n    margin-top: -3.5rem;\n  }\n  .lg\\:-mr-14 {\n    margin-right: -3.5rem;\n  }\n  .lg\\:-mb-14 {\n    margin-bottom: -3.5rem;\n  }\n  .lg\\:-ml-14 {\n    margin-left: -3.5rem;\n  }\n  .lg\\:-mt-15 {\n    margin-top: -3.75rem;\n  }\n  .lg\\:-mr-15 {\n    margin-right: -3.75rem;\n  }\n  .lg\\:-mb-15 {\n    margin-bottom: -3.75rem;\n  }\n  .lg\\:-ml-15 {\n    margin-left: -3.75rem;\n  }\n  .lg\\:-mt-16 {\n    margin-top: -4rem;\n  }\n  .lg\\:-mr-16 {\n    margin-right: -4rem;\n  }\n  .lg\\:-mb-16 {\n    margin-bottom: -4rem;\n  }\n  .lg\\:-ml-16 {\n    margin-left: -4rem;\n  }\n  .lg\\:-mt-20 {\n    margin-top: -5rem;\n  }\n  .lg\\:-mr-20 {\n    margin-right: -5rem;\n  }\n  .lg\\:-mb-20 {\n    margin-bottom: -5rem;\n  }\n  .lg\\:-ml-20 {\n    margin-left: -5rem;\n  }\n  .lg\\:-mt-24 {\n    margin-top: -6rem;\n  }\n  .lg\\:-mr-24 {\n    margin-right: -6rem;\n  }\n  .lg\\:-mb-24 {\n    margin-bottom: -6rem;\n  }\n  .lg\\:-ml-24 {\n    margin-left: -6rem;\n  }\n  .lg\\:-mt-28 {\n    margin-top: -7rem;\n  }\n  .lg\\:-mr-28 {\n    margin-right: -7rem;\n  }\n  .lg\\:-mb-28 {\n    margin-bottom: -7rem;\n  }\n  .lg\\:-ml-28 {\n    margin-left: -7rem;\n  }\n  .lg\\:-mt-32 {\n    margin-top: -8rem;\n  }\n  .lg\\:-mr-32 {\n    margin-right: -8rem;\n  }\n  .lg\\:-mb-32 {\n    margin-bottom: -8rem;\n  }\n  .lg\\:-ml-32 {\n    margin-left: -8rem;\n  }\n  .lg\\:-mt-36 {\n    margin-top: -9rem;\n  }\n  .lg\\:-mr-36 {\n    margin-right: -9rem;\n  }\n  .lg\\:-mb-36 {\n    margin-bottom: -9rem;\n  }\n  .lg\\:-ml-36 {\n    margin-left: -9rem;\n  }\n  .lg\\:-mt-40 {\n    margin-top: -10rem;\n  }\n  .lg\\:-mr-40 {\n    margin-right: -10rem;\n  }\n  .lg\\:-mb-40 {\n    margin-bottom: -10rem;\n  }\n  .lg\\:-ml-40 {\n    margin-left: -10rem;\n  }\n  .lg\\:-mt-44 {\n    margin-top: -11rem;\n  }\n  .lg\\:-mr-44 {\n    margin-right: -11rem;\n  }\n  .lg\\:-mb-44 {\n    margin-bottom: -11rem;\n  }\n  .lg\\:-ml-44 {\n    margin-left: -11rem;\n  }\n  .lg\\:-mt-48 {\n    margin-top: -12rem;\n  }\n  .lg\\:-mr-48 {\n    margin-right: -12rem;\n  }\n  .lg\\:-mb-48 {\n    margin-bottom: -12rem;\n  }\n  .lg\\:-ml-48 {\n    margin-left: -12rem;\n  }\n  .lg\\:-mt-52 {\n    margin-top: -13rem;\n  }\n  .lg\\:-mr-52 {\n    margin-right: -13rem;\n  }\n  .lg\\:-mb-52 {\n    margin-bottom: -13rem;\n  }\n  .lg\\:-ml-52 {\n    margin-left: -13rem;\n  }\n  .lg\\:-mt-56 {\n    margin-top: -14rem;\n  }\n  .lg\\:-mr-56 {\n    margin-right: -14rem;\n  }\n  .lg\\:-mb-56 {\n    margin-bottom: -14rem;\n  }\n  .lg\\:-ml-56 {\n    margin-left: -14rem;\n  }\n  .lg\\:-mt-60 {\n    margin-top: -15rem;\n  }\n  .lg\\:-mr-60 {\n    margin-right: -15rem;\n  }\n  .lg\\:-mb-60 {\n    margin-bottom: -15rem;\n  }\n  .lg\\:-ml-60 {\n    margin-left: -15rem;\n  }\n  .lg\\:-mt-64 {\n    margin-top: -16rem;\n  }\n  .lg\\:-mr-64 {\n    margin-right: -16rem;\n  }\n  .lg\\:-mb-64 {\n    margin-bottom: -16rem;\n  }\n  .lg\\:-ml-64 {\n    margin-left: -16rem;\n  }\n  .lg\\:-mt-72 {\n    margin-top: -18rem;\n  }\n  .lg\\:-mr-72 {\n    margin-right: -18rem;\n  }\n  .lg\\:-mb-72 {\n    margin-bottom: -18rem;\n  }\n  .lg\\:-ml-72 {\n    margin-left: -18rem;\n  }\n  .lg\\:-mt-80 {\n    margin-top: -20rem;\n  }\n  .lg\\:-mr-80 {\n    margin-right: -20rem;\n  }\n  .lg\\:-mb-80 {\n    margin-bottom: -20rem;\n  }\n  .lg\\:-ml-80 {\n    margin-left: -20rem;\n  }\n  .lg\\:-mt-96 {\n    margin-top: -24rem;\n  }\n  .lg\\:-mr-96 {\n    margin-right: -24rem;\n  }\n  .lg\\:-mb-96 {\n    margin-bottom: -24rem;\n  }\n  .lg\\:-ml-96 {\n    margin-left: -24rem;\n  }\n  .lg\\:-mt-px {\n    margin-top: -1px;\n  }\n  .lg\\:-mr-px {\n    margin-right: -1px;\n  }\n  .lg\\:-mb-px {\n    margin-bottom: -1px;\n  }\n  .lg\\:-ml-px {\n    margin-left: -1px;\n  }\n  .lg\\:-mt-0\\.5 {\n    margin-top: -0.125rem;\n  }\n  .lg\\:-mr-0\\.5 {\n    margin-right: -0.125rem;\n  }\n  .lg\\:-mb-0\\.5 {\n    margin-bottom: -0.125rem;\n  }\n  .lg\\:-ml-0\\.5 {\n    margin-left: -0.125rem;\n  }\n  .lg\\:-mt-1\\.5 {\n    margin-top: -0.375rem;\n  }\n  .lg\\:-mr-1\\.5 {\n    margin-right: -0.375rem;\n  }\n  .lg\\:-mb-1\\.5 {\n    margin-bottom: -0.375rem;\n  }\n  .lg\\:-ml-1\\.5 {\n    margin-left: -0.375rem;\n  }\n  .lg\\:-mt-2\\.5 {\n    margin-top: -0.625rem;\n  }\n  .lg\\:-mr-2\\.5 {\n    margin-right: -0.625rem;\n  }\n  .lg\\:-mb-2\\.5 {\n    margin-bottom: -0.625rem;\n  }\n  .lg\\:-ml-2\\.5 {\n    margin-left: -0.625rem;\n  }\n  .lg\\:-mt-3\\.5 {\n    margin-top: -0.875rem;\n  }\n  .lg\\:-mr-3\\.5 {\n    margin-right: -0.875rem;\n  }\n  .lg\\:-mb-3\\.5 {\n    margin-bottom: -0.875rem;\n  }\n  .lg\\:-ml-3\\.5 {\n    margin-left: -0.875rem;\n  }\n  .lg\\:-mt-1\\/2 {\n    margin-top: -50%;\n  }\n  .lg\\:-mr-1\\/2 {\n    margin-right: -50%;\n  }\n  .lg\\:-mb-1\\/2 {\n    margin-bottom: -50%;\n  }\n  .lg\\:-ml-1\\/2 {\n    margin-left: -50%;\n  }\n  .lg\\:-mt-1\\/3 {\n    margin-top: -33.33333%;\n  }\n  .lg\\:-mr-1\\/3 {\n    margin-right: -33.33333%;\n  }\n  .lg\\:-mb-1\\/3 {\n    margin-bottom: -33.33333%;\n  }\n  .lg\\:-ml-1\\/3 {\n    margin-left: -33.33333%;\n  }\n  .lg\\:-mt-2\\/3 {\n    margin-top: -66.66667%;\n  }\n  .lg\\:-mr-2\\/3 {\n    margin-right: -66.66667%;\n  }\n  .lg\\:-mb-2\\/3 {\n    margin-bottom: -66.66667%;\n  }\n  .lg\\:-ml-2\\/3 {\n    margin-left: -66.66667%;\n  }\n  .lg\\:-mt-1\\/4 {\n    margin-top: -25%;\n  }\n  .lg\\:-mr-1\\/4 {\n    margin-right: -25%;\n  }\n  .lg\\:-mb-1\\/4 {\n    margin-bottom: -25%;\n  }\n  .lg\\:-ml-1\\/4 {\n    margin-left: -25%;\n  }\n  .lg\\:-mt-2\\/4 {\n    margin-top: -50%;\n  }\n  .lg\\:-mr-2\\/4 {\n    margin-right: -50%;\n  }\n  .lg\\:-mb-2\\/4 {\n    margin-bottom: -50%;\n  }\n  .lg\\:-ml-2\\/4 {\n    margin-left: -50%;\n  }\n  .lg\\:-mt-3\\/4 {\n    margin-top: -75%;\n  }\n  .lg\\:-mr-3\\/4 {\n    margin-right: -75%;\n  }\n  .lg\\:-mb-3\\/4 {\n    margin-bottom: -75%;\n  }\n  .lg\\:-ml-3\\/4 {\n    margin-left: -75%;\n  }\n  .lg\\:-mt-1\\/5 {\n    margin-top: -20%;\n  }\n  .lg\\:-mr-1\\/5 {\n    margin-right: -20%;\n  }\n  .lg\\:-mb-1\\/5 {\n    margin-bottom: -20%;\n  }\n  .lg\\:-ml-1\\/5 {\n    margin-left: -20%;\n  }\n  .lg\\:-mt-2\\/5 {\n    margin-top: -40%;\n  }\n  .lg\\:-mr-2\\/5 {\n    margin-right: -40%;\n  }\n  .lg\\:-mb-2\\/5 {\n    margin-bottom: -40%;\n  }\n  .lg\\:-ml-2\\/5 {\n    margin-left: -40%;\n  }\n  .lg\\:-mt-3\\/5 {\n    margin-top: -60%;\n  }\n  .lg\\:-mr-3\\/5 {\n    margin-right: -60%;\n  }\n  .lg\\:-mb-3\\/5 {\n    margin-bottom: -60%;\n  }\n  .lg\\:-ml-3\\/5 {\n    margin-left: -60%;\n  }\n  .lg\\:-mt-4\\/5 {\n    margin-top: -80%;\n  }\n  .lg\\:-mr-4\\/5 {\n    margin-right: -80%;\n  }\n  .lg\\:-mb-4\\/5 {\n    margin-bottom: -80%;\n  }\n  .lg\\:-ml-4\\/5 {\n    margin-left: -80%;\n  }\n  .lg\\:-mt-1\\/6 {\n    margin-top: -16.66667%;\n  }\n  .lg\\:-mr-1\\/6 {\n    margin-right: -16.66667%;\n  }\n  .lg\\:-mb-1\\/6 {\n    margin-bottom: -16.66667%;\n  }\n  .lg\\:-ml-1\\/6 {\n    margin-left: -16.66667%;\n  }\n  .lg\\:-mt-2\\/6 {\n    margin-top: -33.33333%;\n  }\n  .lg\\:-mr-2\\/6 {\n    margin-right: -33.33333%;\n  }\n  .lg\\:-mb-2\\/6 {\n    margin-bottom: -33.33333%;\n  }\n  .lg\\:-ml-2\\/6 {\n    margin-left: -33.33333%;\n  }\n  .lg\\:-mt-3\\/6 {\n    margin-top: -50%;\n  }\n  .lg\\:-mr-3\\/6 {\n    margin-right: -50%;\n  }\n  .lg\\:-mb-3\\/6 {\n    margin-bottom: -50%;\n  }\n  .lg\\:-ml-3\\/6 {\n    margin-left: -50%;\n  }\n  .lg\\:-mt-4\\/6 {\n    margin-top: -66.66667%;\n  }\n  .lg\\:-mr-4\\/6 {\n    margin-right: -66.66667%;\n  }\n  .lg\\:-mb-4\\/6 {\n    margin-bottom: -66.66667%;\n  }\n  .lg\\:-ml-4\\/6 {\n    margin-left: -66.66667%;\n  }\n  .lg\\:-mt-5\\/6 {\n    margin-top: -83.33333%;\n  }\n  .lg\\:-mr-5\\/6 {\n    margin-right: -83.33333%;\n  }\n  .lg\\:-mb-5\\/6 {\n    margin-bottom: -83.33333%;\n  }\n  .lg\\:-ml-5\\/6 {\n    margin-left: -83.33333%;\n  }\n  .lg\\:-mt-1\\/12 {\n    margin-top: -8.33333%;\n  }\n  .lg\\:-mr-1\\/12 {\n    margin-right: -8.33333%;\n  }\n  .lg\\:-mb-1\\/12 {\n    margin-bottom: -8.33333%;\n  }\n  .lg\\:-ml-1\\/12 {\n    margin-left: -8.33333%;\n  }\n  .lg\\:-mt-2\\/12 {\n    margin-top: -16.66667%;\n  }\n  .lg\\:-mr-2\\/12 {\n    margin-right: -16.66667%;\n  }\n  .lg\\:-mb-2\\/12 {\n    margin-bottom: -16.66667%;\n  }\n  .lg\\:-ml-2\\/12 {\n    margin-left: -16.66667%;\n  }\n  .lg\\:-mt-3\\/12 {\n    margin-top: -25%;\n  }\n  .lg\\:-mr-3\\/12 {\n    margin-right: -25%;\n  }\n  .lg\\:-mb-3\\/12 {\n    margin-bottom: -25%;\n  }\n  .lg\\:-ml-3\\/12 {\n    margin-left: -25%;\n  }\n  .lg\\:-mt-4\\/12 {\n    margin-top: -33.33333%;\n  }\n  .lg\\:-mr-4\\/12 {\n    margin-right: -33.33333%;\n  }\n  .lg\\:-mb-4\\/12 {\n    margin-bottom: -33.33333%;\n  }\n  .lg\\:-ml-4\\/12 {\n    margin-left: -33.33333%;\n  }\n  .lg\\:-mt-5\\/12 {\n    margin-top: -41.66667%;\n  }\n  .lg\\:-mr-5\\/12 {\n    margin-right: -41.66667%;\n  }\n  .lg\\:-mb-5\\/12 {\n    margin-bottom: -41.66667%;\n  }\n  .lg\\:-ml-5\\/12 {\n    margin-left: -41.66667%;\n  }\n  .lg\\:-mt-6\\/12 {\n    margin-top: -50%;\n  }\n  .lg\\:-mr-6\\/12 {\n    margin-right: -50%;\n  }\n  .lg\\:-mb-6\\/12 {\n    margin-bottom: -50%;\n  }\n  .lg\\:-ml-6\\/12 {\n    margin-left: -50%;\n  }\n  .lg\\:-mt-7\\/12 {\n    margin-top: -58.33333%;\n  }\n  .lg\\:-mr-7\\/12 {\n    margin-right: -58.33333%;\n  }\n  .lg\\:-mb-7\\/12 {\n    margin-bottom: -58.33333%;\n  }\n  .lg\\:-ml-7\\/12 {\n    margin-left: -58.33333%;\n  }\n  .lg\\:-mt-8\\/12 {\n    margin-top: -66.66667%;\n  }\n  .lg\\:-mr-8\\/12 {\n    margin-right: -66.66667%;\n  }\n  .lg\\:-mb-8\\/12 {\n    margin-bottom: -66.66667%;\n  }\n  .lg\\:-ml-8\\/12 {\n    margin-left: -66.66667%;\n  }\n  .lg\\:-mt-9\\/12 {\n    margin-top: -75%;\n  }\n  .lg\\:-mr-9\\/12 {\n    margin-right: -75%;\n  }\n  .lg\\:-mb-9\\/12 {\n    margin-bottom: -75%;\n  }\n  .lg\\:-ml-9\\/12 {\n    margin-left: -75%;\n  }\n  .lg\\:-mt-10\\/12 {\n    margin-top: -83.33333%;\n  }\n  .lg\\:-mr-10\\/12 {\n    margin-right: -83.33333%;\n  }\n  .lg\\:-mb-10\\/12 {\n    margin-bottom: -83.33333%;\n  }\n  .lg\\:-ml-10\\/12 {\n    margin-left: -83.33333%;\n  }\n  .lg\\:-mt-11\\/12 {\n    margin-top: -91.66667%;\n  }\n  .lg\\:-mr-11\\/12 {\n    margin-right: -91.66667%;\n  }\n  .lg\\:-mb-11\\/12 {\n    margin-bottom: -91.66667%;\n  }\n  .lg\\:-ml-11\\/12 {\n    margin-left: -91.66667%;\n  }\n  .lg\\:-mt-full {\n    margin-top: -100%;\n  }\n  .lg\\:-mr-full {\n    margin-right: -100%;\n  }\n  .lg\\:-mb-full {\n    margin-bottom: -100%;\n  }\n  .lg\\:-ml-full {\n    margin-left: -100%;\n  }\n  .lg\\:max-h-0 {\n    max-height: 0;\n  }\n  .lg\\:max-h-1 {\n    max-height: 0.25rem;\n  }\n  .lg\\:max-h-2 {\n    max-height: 0.5rem;\n  }\n  .lg\\:max-h-3 {\n    max-height: 0.75rem;\n  }\n  .lg\\:max-h-4 {\n    max-height: 1rem;\n  }\n  .lg\\:max-h-5 {\n    max-height: 1.25rem;\n  }\n  .lg\\:max-h-6 {\n    max-height: 1.5rem;\n  }\n  .lg\\:max-h-7 {\n    max-height: 1.75rem;\n  }\n  .lg\\:max-h-8 {\n    max-height: 2rem;\n  }\n  .lg\\:max-h-9 {\n    max-height: 2.25rem;\n  }\n  .lg\\:max-h-10 {\n    max-height: 2.5rem;\n  }\n  .lg\\:max-h-11 {\n    max-height: 2.75rem;\n  }\n  .lg\\:max-h-12 {\n    max-height: 3rem;\n  }\n  .lg\\:max-h-13 {\n    max-height: 3.25rem;\n  }\n  .lg\\:max-h-14 {\n    max-height: 3.5rem;\n  }\n  .lg\\:max-h-15 {\n    max-height: 3.75rem;\n  }\n  .lg\\:max-h-16 {\n    max-height: 4rem;\n  }\n  .lg\\:max-h-20 {\n    max-height: 5rem;\n  }\n  .lg\\:max-h-24 {\n    max-height: 6rem;\n  }\n  .lg\\:max-h-28 {\n    max-height: 7rem;\n  }\n  .lg\\:max-h-32 {\n    max-height: 8rem;\n  }\n  .lg\\:max-h-36 {\n    max-height: 9rem;\n  }\n  .lg\\:max-h-40 {\n    max-height: 10rem;\n  }\n  .lg\\:max-h-44 {\n    max-height: 11rem;\n  }\n  .lg\\:max-h-48 {\n    max-height: 12rem;\n  }\n  .lg\\:max-h-52 {\n    max-height: 13rem;\n  }\n  .lg\\:max-h-56 {\n    max-height: 14rem;\n  }\n  .lg\\:max-h-60 {\n    max-height: 15rem;\n  }\n  .lg\\:max-h-64 {\n    max-height: 16rem;\n  }\n  .lg\\:max-h-72 {\n    max-height: 18rem;\n  }\n  .lg\\:max-h-80 {\n    max-height: 20rem;\n  }\n  .lg\\:max-h-96 {\n    max-height: 24rem;\n  }\n  .lg\\:max-h-screen {\n    max-height: 100vh;\n  }\n  .lg\\:max-h-px {\n    max-height: 1px;\n  }\n  .lg\\:max-h-0\\.5 {\n    max-height: 0.125rem;\n  }\n  .lg\\:max-h-1\\.5 {\n    max-height: 0.375rem;\n  }\n  .lg\\:max-h-2\\.5 {\n    max-height: 0.625rem;\n  }\n  .lg\\:max-h-3\\.5 {\n    max-height: 0.875rem;\n  }\n  .lg\\:max-h-1\\/2 {\n    max-height: 50%;\n  }\n  .lg\\:max-h-1\\/3 {\n    max-height: 33.333333%;\n  }\n  .lg\\:max-h-2\\/3 {\n    max-height: 66.666667%;\n  }\n  .lg\\:max-h-1\\/4 {\n    max-height: 25%;\n  }\n  .lg\\:max-h-2\\/4 {\n    max-height: 50%;\n  }\n  .lg\\:max-h-3\\/4 {\n    max-height: 75%;\n  }\n  .lg\\:max-h-1\\/5 {\n    max-height: 20%;\n  }\n  .lg\\:max-h-2\\/5 {\n    max-height: 40%;\n  }\n  .lg\\:max-h-3\\/5 {\n    max-height: 60%;\n  }\n  .lg\\:max-h-4\\/5 {\n    max-height: 80%;\n  }\n  .lg\\:max-h-1\\/6 {\n    max-height: 16.666667%;\n  }\n  .lg\\:max-h-2\\/6 {\n    max-height: 33.333333%;\n  }\n  .lg\\:max-h-3\\/6 {\n    max-height: 50%;\n  }\n  .lg\\:max-h-4\\/6 {\n    max-height: 66.666667%;\n  }\n  .lg\\:max-h-5\\/6 {\n    max-height: 83.333333%;\n  }\n  .lg\\:max-h-1\\/12 {\n    max-height: 8.333333%;\n  }\n  .lg\\:max-h-2\\/12 {\n    max-height: 16.666667%;\n  }\n  .lg\\:max-h-3\\/12 {\n    max-height: 25%;\n  }\n  .lg\\:max-h-4\\/12 {\n    max-height: 33.333333%;\n  }\n  .lg\\:max-h-5\\/12 {\n    max-height: 41.666667%;\n  }\n  .lg\\:max-h-6\\/12 {\n    max-height: 50%;\n  }\n  .lg\\:max-h-7\\/12 {\n    max-height: 58.333333%;\n  }\n  .lg\\:max-h-8\\/12 {\n    max-height: 66.666667%;\n  }\n  .lg\\:max-h-9\\/12 {\n    max-height: 75%;\n  }\n  .lg\\:max-h-10\\/12 {\n    max-height: 83.333333%;\n  }\n  .lg\\:max-h-11\\/12 {\n    max-height: 91.666667%;\n  }\n  .lg\\:max-h-full {\n    max-height: 100%;\n  }\n  .lg\\:max-w-0 {\n    max-width: 0rem;\n  }\n  .lg\\:max-w-none {\n    max-width: none;\n  }\n  .lg\\:max-w-xs {\n    max-width: 20rem;\n  }\n  .lg\\:max-w-sm {\n    max-width: 24rem;\n  }\n  .lg\\:max-w-md {\n    max-width: 28rem;\n  }\n  .lg\\:max-w-lg {\n    max-width: 32rem;\n  }\n  .lg\\:max-w-xl {\n    max-width: 36rem;\n  }\n  .lg\\:max-w-2xl {\n    max-width: 42rem;\n  }\n  .lg\\:max-w-3xl {\n    max-width: 48rem;\n  }\n  .lg\\:max-w-4xl {\n    max-width: 56rem;\n  }\n  .lg\\:max-w-5xl {\n    max-width: 64rem;\n  }\n  .lg\\:max-w-6xl {\n    max-width: 72rem;\n  }\n  .lg\\:max-w-7xl {\n    max-width: 80rem;\n  }\n  .lg\\:max-w-full {\n    max-width: 100%;\n  }\n  .lg\\:max-w-min-content {\n    max-width: -moz-min-content;\n    max-width: min-content;\n  }\n  .lg\\:max-w-max-content {\n    max-width: -moz-max-content;\n    max-width: max-content;\n  }\n  .lg\\:max-w-prose {\n    max-width: 65ch;\n  }\n  .lg\\:max-w-screen-sm {\n    max-width: 640px;\n  }\n  .lg\\:max-w-screen-md {\n    max-width: 768px;\n  }\n  .lg\\:max-w-screen-lg {\n    max-width: 1024px;\n  }\n  .lg\\:max-w-screen-xl {\n    max-width: 1280px;\n  }\n  .lg\\:min-h-0 {\n    min-height: 0;\n  }\n  .lg\\:min-h-full {\n    min-height: 100%;\n  }\n  .lg\\:min-h-screen {\n    min-height: 100vh;\n  }\n  .lg\\:min-w-0 {\n    min-width: 0;\n  }\n  .lg\\:min-w-full {\n    min-width: 100%;\n  }\n  .lg\\:min-w-min-content {\n    min-width: -moz-min-content;\n    min-width: min-content;\n  }\n  .lg\\:min-w-max-content {\n    min-width: -moz-max-content;\n    min-width: max-content;\n  }\n  .lg\\:object-contain {\n    -o-object-fit: contain;\n    object-fit: contain;\n  }\n  .lg\\:object-cover {\n    -o-object-fit: cover;\n    object-fit: cover;\n  }\n  .lg\\:object-fill {\n    -o-object-fit: fill;\n    object-fit: fill;\n  }\n  .lg\\:object-none {\n    -o-object-fit: none;\n    object-fit: none;\n  }\n  .lg\\:object-scale-down {\n    -o-object-fit: scale-down;\n    object-fit: scale-down;\n  }\n  .lg\\:object-bottom {\n    -o-object-position: bottom;\n    object-position: bottom;\n  }\n  .lg\\:object-center {\n    -o-object-position: center;\n    object-position: center;\n  }\n  .lg\\:object-left {\n    -o-object-position: left;\n    object-position: left;\n  }\n  .lg\\:object-left-bottom {\n    -o-object-position: left bottom;\n    object-position: left bottom;\n  }\n  .lg\\:object-left-top {\n    -o-object-position: left top;\n    object-position: left top;\n  }\n  .lg\\:object-right {\n    -o-object-position: right;\n    object-position: right;\n  }\n  .lg\\:object-right-bottom {\n    -o-object-position: right bottom;\n    object-position: right bottom;\n  }\n  .lg\\:object-right-top {\n    -o-object-position: right top;\n    object-position: right top;\n  }\n  .lg\\:object-top {\n    -o-object-position: top;\n    object-position: top;\n  }\n  .lg\\:opacity-0 {\n    opacity: 0;\n  }\n  .lg\\:opacity-25 {\n    opacity: 0.25;\n  }\n  .lg\\:opacity-50 {\n    opacity: 0.5;\n  }\n  .lg\\:opacity-75 {\n    opacity: 0.75;\n  }\n  .lg\\:opacity-100 {\n    opacity: 1;\n  }\n  .lg\\:focus-within\\:opacity-0:focus-within {\n    opacity: 0;\n  }\n  .lg\\:focus-within\\:opacity-25:focus-within {\n    opacity: 0.25;\n  }\n  .lg\\:focus-within\\:opacity-50:focus-within {\n    opacity: 0.5;\n  }\n  .lg\\:focus-within\\:opacity-75:focus-within {\n    opacity: 0.75;\n  }\n  .lg\\:focus-within\\:opacity-100:focus-within {\n    opacity: 1;\n  }\n  .group:hover .lg\\:group-hover\\:opacity-0 {\n    opacity: 0;\n  }\n  .group:hover .lg\\:group-hover\\:opacity-25 {\n    opacity: 0.25;\n  }\n  .group:hover .lg\\:group-hover\\:opacity-50 {\n    opacity: 0.5;\n  }\n  .group:hover .lg\\:group-hover\\:opacity-75 {\n    opacity: 0.75;\n  }\n  .group:hover .lg\\:group-hover\\:opacity-100 {\n    opacity: 1;\n  }\n  .group:focus .lg\\:group-focus\\:opacity-0 {\n    opacity: 0;\n  }\n  .group:focus .lg\\:group-focus\\:opacity-25 {\n    opacity: 0.25;\n  }\n  .group:focus .lg\\:group-focus\\:opacity-50 {\n    opacity: 0.5;\n  }\n  .group:focus .lg\\:group-focus\\:opacity-75 {\n    opacity: 0.75;\n  }\n  .group:focus .lg\\:group-focus\\:opacity-100 {\n    opacity: 1;\n  }\n  .lg\\:hover\\:opacity-0:hover {\n    opacity: 0;\n  }\n  .lg\\:hover\\:opacity-25:hover {\n    opacity: 0.25;\n  }\n  .lg\\:hover\\:opacity-50:hover {\n    opacity: 0.5;\n  }\n  .lg\\:hover\\:opacity-75:hover {\n    opacity: 0.75;\n  }\n  .lg\\:hover\\:opacity-100:hover {\n    opacity: 1;\n  }\n  .lg\\:focus\\:opacity-0:focus {\n    opacity: 0;\n  }\n  .lg\\:focus\\:opacity-25:focus {\n    opacity: 0.25;\n  }\n  .lg\\:focus\\:opacity-50:focus {\n    opacity: 0.5;\n  }\n  .lg\\:focus\\:opacity-75:focus {\n    opacity: 0.75;\n  }\n  .lg\\:focus\\:opacity-100:focus {\n    opacity: 1;\n  }\n  .lg\\:outline-none {\n    outline: 2px solid transparent;\n    outline-offset: 2px;\n  }\n  .lg\\:outline-white {\n    outline: 2px dotted white;\n    outline-offset: 2px;\n  }\n  .lg\\:outline-black {\n    outline: 2px dotted black;\n    outline-offset: 2px;\n  }\n  .lg\\:focus\\:outline-none:focus {\n    outline: 2px solid transparent;\n    outline-offset: 2px;\n  }\n  .lg\\:focus\\:outline-white:focus {\n    outline: 2px dotted white;\n    outline-offset: 2px;\n  }\n  .lg\\:focus\\:outline-black:focus {\n    outline: 2px dotted black;\n    outline-offset: 2px;\n  }\n  .lg\\:overflow-auto {\n    overflow: auto;\n  }\n  .lg\\:overflow-hidden {\n    overflow: hidden;\n  }\n  .lg\\:overflow-visible {\n    overflow: visible;\n  }\n  .lg\\:overflow-scroll {\n    overflow: scroll;\n  }\n  .lg\\:overflow-x-auto {\n    overflow-x: auto;\n  }\n  .lg\\:overflow-y-auto {\n    overflow-y: auto;\n  }\n  .lg\\:overflow-x-hidden {\n    overflow-x: hidden;\n  }\n  .lg\\:overflow-y-hidden {\n    overflow-y: hidden;\n  }\n  .lg\\:overflow-x-visible {\n    overflow-x: visible;\n  }\n  .lg\\:overflow-y-visible {\n    overflow-y: visible;\n  }\n  .lg\\:overflow-x-scroll {\n    overflow-x: scroll;\n  }\n  .lg\\:overflow-y-scroll {\n    overflow-y: scroll;\n  }\n  .lg\\:scrolling-touch {\n    -webkit-overflow-scrolling: touch;\n  }\n  .lg\\:scrolling-auto {\n    -webkit-overflow-scrolling: auto;\n  }\n  .lg\\:overscroll-auto {\n    overscroll-behavior: auto;\n  }\n  .lg\\:overscroll-contain {\n    overscroll-behavior: contain;\n  }\n  .lg\\:overscroll-none {\n    overscroll-behavior: none;\n  }\n  .lg\\:overscroll-y-auto {\n    overscroll-behavior-y: auto;\n  }\n  .lg\\:overscroll-y-contain {\n    overscroll-behavior-y: contain;\n  }\n  .lg\\:overscroll-y-none {\n    overscroll-behavior-y: none;\n  }\n  .lg\\:overscroll-x-auto {\n    overscroll-behavior-x: auto;\n  }\n  .lg\\:overscroll-x-contain {\n    overscroll-behavior-x: contain;\n  }\n  .lg\\:overscroll-x-none {\n    overscroll-behavior-x: none;\n  }\n  .lg\\:p-0 {\n    padding: 0;\n  }\n  .lg\\:p-1 {\n    padding: 0.25rem;\n  }\n  .lg\\:p-2 {\n    padding: 0.5rem;\n  }\n  .lg\\:p-3 {\n    padding: 0.75rem;\n  }\n  .lg\\:p-4 {\n    padding: 1rem;\n  }\n  .lg\\:p-5 {\n    padding: 1.25rem;\n  }\n  .lg\\:p-6 {\n    padding: 1.5rem;\n  }\n  .lg\\:p-7 {\n    padding: 1.75rem;\n  }\n  .lg\\:p-8 {\n    padding: 2rem;\n  }\n  .lg\\:p-9 {\n    padding: 2.25rem;\n  }\n  .lg\\:p-10 {\n    padding: 2.5rem;\n  }\n  .lg\\:p-11 {\n    padding: 2.75rem;\n  }\n  .lg\\:p-12 {\n    padding: 3rem;\n  }\n  .lg\\:p-13 {\n    padding: 3.25rem;\n  }\n  .lg\\:p-14 {\n    padding: 3.5rem;\n  }\n  .lg\\:p-15 {\n    padding: 3.75rem;\n  }\n  .lg\\:p-16 {\n    padding: 4rem;\n  }\n  .lg\\:p-20 {\n    padding: 5rem;\n  }\n  .lg\\:p-24 {\n    padding: 6rem;\n  }\n  .lg\\:p-28 {\n    padding: 7rem;\n  }\n  .lg\\:p-32 {\n    padding: 8rem;\n  }\n  .lg\\:p-36 {\n    padding: 9rem;\n  }\n  .lg\\:p-40 {\n    padding: 10rem;\n  }\n  .lg\\:p-44 {\n    padding: 11rem;\n  }\n  .lg\\:p-48 {\n    padding: 12rem;\n  }\n  .lg\\:p-52 {\n    padding: 13rem;\n  }\n  .lg\\:p-56 {\n    padding: 14rem;\n  }\n  .lg\\:p-60 {\n    padding: 15rem;\n  }\n  .lg\\:p-64 {\n    padding: 16rem;\n  }\n  .lg\\:p-72 {\n    padding: 18rem;\n  }\n  .lg\\:p-80 {\n    padding: 20rem;\n  }\n  .lg\\:p-96 {\n    padding: 24rem;\n  }\n  .lg\\:p-px {\n    padding: 1px;\n  }\n  .lg\\:p-0\\.5 {\n    padding: 0.125rem;\n  }\n  .lg\\:p-1\\.5 {\n    padding: 0.375rem;\n  }\n  .lg\\:p-2\\.5 {\n    padding: 0.625rem;\n  }\n  .lg\\:p-3\\.5 {\n    padding: 0.875rem;\n  }\n  .lg\\:p-1\\/2 {\n    padding: 50%;\n  }\n  .lg\\:p-1\\/3 {\n    padding: 33.333333%;\n  }\n  .lg\\:p-2\\/3 {\n    padding: 66.666667%;\n  }\n  .lg\\:p-1\\/4 {\n    padding: 25%;\n  }\n  .lg\\:p-2\\/4 {\n    padding: 50%;\n  }\n  .lg\\:p-3\\/4 {\n    padding: 75%;\n  }\n  .lg\\:p-1\\/5 {\n    padding: 20%;\n  }\n  .lg\\:p-2\\/5 {\n    padding: 40%;\n  }\n  .lg\\:p-3\\/5 {\n    padding: 60%;\n  }\n  .lg\\:p-4\\/5 {\n    padding: 80%;\n  }\n  .lg\\:p-1\\/6 {\n    padding: 16.666667%;\n  }\n  .lg\\:p-2\\/6 {\n    padding: 33.333333%;\n  }\n  .lg\\:p-3\\/6 {\n    padding: 50%;\n  }\n  .lg\\:p-4\\/6 {\n    padding: 66.666667%;\n  }\n  .lg\\:p-5\\/6 {\n    padding: 83.333333%;\n  }\n  .lg\\:p-1\\/12 {\n    padding: 8.333333%;\n  }\n  .lg\\:p-2\\/12 {\n    padding: 16.666667%;\n  }\n  .lg\\:p-3\\/12 {\n    padding: 25%;\n  }\n  .lg\\:p-4\\/12 {\n    padding: 33.333333%;\n  }\n  .lg\\:p-5\\/12 {\n    padding: 41.666667%;\n  }\n  .lg\\:p-6\\/12 {\n    padding: 50%;\n  }\n  .lg\\:p-7\\/12 {\n    padding: 58.333333%;\n  }\n  .lg\\:p-8\\/12 {\n    padding: 66.666667%;\n  }\n  .lg\\:p-9\\/12 {\n    padding: 75%;\n  }\n  .lg\\:p-10\\/12 {\n    padding: 83.333333%;\n  }\n  .lg\\:p-11\\/12 {\n    padding: 91.666667%;\n  }\n  .lg\\:p-full {\n    padding: 100%;\n  }\n  .lg\\:py-0 {\n    padding-top: 0;\n    padding-bottom: 0;\n  }\n  .lg\\:px-0 {\n    padding-left: 0;\n    padding-right: 0;\n  }\n  .lg\\:py-1 {\n    padding-top: 0.25rem;\n    padding-bottom: 0.25rem;\n  }\n  .lg\\:px-1 {\n    padding-left: 0.25rem;\n    padding-right: 0.25rem;\n  }\n  .lg\\:py-2 {\n    padding-top: 0.5rem;\n    padding-bottom: 0.5rem;\n  }\n  .lg\\:px-2 {\n    padding-left: 0.5rem;\n    padding-right: 0.5rem;\n  }\n  .lg\\:py-3 {\n    padding-top: 0.75rem;\n    padding-bottom: 0.75rem;\n  }\n  .lg\\:px-3 {\n    padding-left: 0.75rem;\n    padding-right: 0.75rem;\n  }\n  .lg\\:py-4 {\n    padding-top: 1rem;\n    padding-bottom: 1rem;\n  }\n  .lg\\:px-4 {\n    padding-left: 1rem;\n    padding-right: 1rem;\n  }\n  .lg\\:py-5 {\n    padding-top: 1.25rem;\n    padding-bottom: 1.25rem;\n  }\n  .lg\\:px-5 {\n    padding-left: 1.25rem;\n    padding-right: 1.25rem;\n  }\n  .lg\\:py-6 {\n    padding-top: 1.5rem;\n    padding-bottom: 1.5rem;\n  }\n  .lg\\:px-6 {\n    padding-left: 1.5rem;\n    padding-right: 1.5rem;\n  }\n  .lg\\:py-7 {\n    padding-top: 1.75rem;\n    padding-bottom: 1.75rem;\n  }\n  .lg\\:px-7 {\n    padding-left: 1.75rem;\n    padding-right: 1.75rem;\n  }\n  .lg\\:py-8 {\n    padding-top: 2rem;\n    padding-bottom: 2rem;\n  }\n  .lg\\:px-8 {\n    padding-left: 2rem;\n    padding-right: 2rem;\n  }\n  .lg\\:py-9 {\n    padding-top: 2.25rem;\n    padding-bottom: 2.25rem;\n  }\n  .lg\\:px-9 {\n    padding-left: 2.25rem;\n    padding-right: 2.25rem;\n  }\n  .lg\\:py-10 {\n    padding-top: 2.5rem;\n    padding-bottom: 2.5rem;\n  }\n  .lg\\:px-10 {\n    padding-left: 2.5rem;\n    padding-right: 2.5rem;\n  }\n  .lg\\:py-11 {\n    padding-top: 2.75rem;\n    padding-bottom: 2.75rem;\n  }\n  .lg\\:px-11 {\n    padding-left: 2.75rem;\n    padding-right: 2.75rem;\n  }\n  .lg\\:py-12 {\n    padding-top: 3rem;\n    padding-bottom: 3rem;\n  }\n  .lg\\:px-12 {\n    padding-left: 3rem;\n    padding-right: 3rem;\n  }\n  .lg\\:py-13 {\n    padding-top: 3.25rem;\n    padding-bottom: 3.25rem;\n  }\n  .lg\\:px-13 {\n    padding-left: 3.25rem;\n    padding-right: 3.25rem;\n  }\n  .lg\\:py-14 {\n    padding-top: 3.5rem;\n    padding-bottom: 3.5rem;\n  }\n  .lg\\:px-14 {\n    padding-left: 3.5rem;\n    padding-right: 3.5rem;\n  }\n  .lg\\:py-15 {\n    padding-top: 3.75rem;\n    padding-bottom: 3.75rem;\n  }\n  .lg\\:px-15 {\n    padding-left: 3.75rem;\n    padding-right: 3.75rem;\n  }\n  .lg\\:py-16 {\n    padding-top: 4rem;\n    padding-bottom: 4rem;\n  }\n  .lg\\:px-16 {\n    padding-left: 4rem;\n    padding-right: 4rem;\n  }\n  .lg\\:py-20 {\n    padding-top: 5rem;\n    padding-bottom: 5rem;\n  }\n  .lg\\:px-20 {\n    padding-left: 5rem;\n    padding-right: 5rem;\n  }\n  .lg\\:py-24 {\n    padding-top: 6rem;\n    padding-bottom: 6rem;\n  }\n  .lg\\:px-24 {\n    padding-left: 6rem;\n    padding-right: 6rem;\n  }\n  .lg\\:py-28 {\n    padding-top: 7rem;\n    padding-bottom: 7rem;\n  }\n  .lg\\:px-28 {\n    padding-left: 7rem;\n    padding-right: 7rem;\n  }\n  .lg\\:py-32 {\n    padding-top: 8rem;\n    padding-bottom: 8rem;\n  }\n  .lg\\:px-32 {\n    padding-left: 8rem;\n    padding-right: 8rem;\n  }\n  .lg\\:py-36 {\n    padding-top: 9rem;\n    padding-bottom: 9rem;\n  }\n  .lg\\:px-36 {\n    padding-left: 9rem;\n    padding-right: 9rem;\n  }\n  .lg\\:py-40 {\n    padding-top: 10rem;\n    padding-bottom: 10rem;\n  }\n  .lg\\:px-40 {\n    padding-left: 10rem;\n    padding-right: 10rem;\n  }\n  .lg\\:py-44 {\n    padding-top: 11rem;\n    padding-bottom: 11rem;\n  }\n  .lg\\:px-44 {\n    padding-left: 11rem;\n    padding-right: 11rem;\n  }\n  .lg\\:py-48 {\n    padding-top: 12rem;\n    padding-bottom: 12rem;\n  }\n  .lg\\:px-48 {\n    padding-left: 12rem;\n    padding-right: 12rem;\n  }\n  .lg\\:py-52 {\n    padding-top: 13rem;\n    padding-bottom: 13rem;\n  }\n  .lg\\:px-52 {\n    padding-left: 13rem;\n    padding-right: 13rem;\n  }\n  .lg\\:py-56 {\n    padding-top: 14rem;\n    padding-bottom: 14rem;\n  }\n  .lg\\:px-56 {\n    padding-left: 14rem;\n    padding-right: 14rem;\n  }\n  .lg\\:py-60 {\n    padding-top: 15rem;\n    padding-bottom: 15rem;\n  }\n  .lg\\:px-60 {\n    padding-left: 15rem;\n    padding-right: 15rem;\n  }\n  .lg\\:py-64 {\n    padding-top: 16rem;\n    padding-bottom: 16rem;\n  }\n  .lg\\:px-64 {\n    padding-left: 16rem;\n    padding-right: 16rem;\n  }\n  .lg\\:py-72 {\n    padding-top: 18rem;\n    padding-bottom: 18rem;\n  }\n  .lg\\:px-72 {\n    padding-left: 18rem;\n    padding-right: 18rem;\n  }\n  .lg\\:py-80 {\n    padding-top: 20rem;\n    padding-bottom: 20rem;\n  }\n  .lg\\:px-80 {\n    padding-left: 20rem;\n    padding-right: 20rem;\n  }\n  .lg\\:py-96 {\n    padding-top: 24rem;\n    padding-bottom: 24rem;\n  }\n  .lg\\:px-96 {\n    padding-left: 24rem;\n    padding-right: 24rem;\n  }\n  .lg\\:py-px {\n    padding-top: 1px;\n    padding-bottom: 1px;\n  }\n  .lg\\:px-px {\n    padding-left: 1px;\n    padding-right: 1px;\n  }\n  .lg\\:py-0\\.5 {\n    padding-top: 0.125rem;\n    padding-bottom: 0.125rem;\n  }\n  .lg\\:px-0\\.5 {\n    padding-left: 0.125rem;\n    padding-right: 0.125rem;\n  }\n  .lg\\:py-1\\.5 {\n    padding-top: 0.375rem;\n    padding-bottom: 0.375rem;\n  }\n  .lg\\:px-1\\.5 {\n    padding-left: 0.375rem;\n    padding-right: 0.375rem;\n  }\n  .lg\\:py-2\\.5 {\n    padding-top: 0.625rem;\n    padding-bottom: 0.625rem;\n  }\n  .lg\\:px-2\\.5 {\n    padding-left: 0.625rem;\n    padding-right: 0.625rem;\n  }\n  .lg\\:py-3\\.5 {\n    padding-top: 0.875rem;\n    padding-bottom: 0.875rem;\n  }\n  .lg\\:px-3\\.5 {\n    padding-left: 0.875rem;\n    padding-right: 0.875rem;\n  }\n  .lg\\:py-1\\/2 {\n    padding-top: 50%;\n    padding-bottom: 50%;\n  }\n  .lg\\:px-1\\/2 {\n    padding-left: 50%;\n    padding-right: 50%;\n  }\n  .lg\\:py-1\\/3 {\n    padding-top: 33.333333%;\n    padding-bottom: 33.333333%;\n  }\n  .lg\\:px-1\\/3 {\n    padding-left: 33.333333%;\n    padding-right: 33.333333%;\n  }\n  .lg\\:py-2\\/3 {\n    padding-top: 66.666667%;\n    padding-bottom: 66.666667%;\n  }\n  .lg\\:px-2\\/3 {\n    padding-left: 66.666667%;\n    padding-right: 66.666667%;\n  }\n  .lg\\:py-1\\/4 {\n    padding-top: 25%;\n    padding-bottom: 25%;\n  }\n  .lg\\:px-1\\/4 {\n    padding-left: 25%;\n    padding-right: 25%;\n  }\n  .lg\\:py-2\\/4 {\n    padding-top: 50%;\n    padding-bottom: 50%;\n  }\n  .lg\\:px-2\\/4 {\n    padding-left: 50%;\n    padding-right: 50%;\n  }\n  .lg\\:py-3\\/4 {\n    padding-top: 75%;\n    padding-bottom: 75%;\n  }\n  .lg\\:px-3\\/4 {\n    padding-left: 75%;\n    padding-right: 75%;\n  }\n  .lg\\:py-1\\/5 {\n    padding-top: 20%;\n    padding-bottom: 20%;\n  }\n  .lg\\:px-1\\/5 {\n    padding-left: 20%;\n    padding-right: 20%;\n  }\n  .lg\\:py-2\\/5 {\n    padding-top: 40%;\n    padding-bottom: 40%;\n  }\n  .lg\\:px-2\\/5 {\n    padding-left: 40%;\n    padding-right: 40%;\n  }\n  .lg\\:py-3\\/5 {\n    padding-top: 60%;\n    padding-bottom: 60%;\n  }\n  .lg\\:px-3\\/5 {\n    padding-left: 60%;\n    padding-right: 60%;\n  }\n  .lg\\:py-4\\/5 {\n    padding-top: 80%;\n    padding-bottom: 80%;\n  }\n  .lg\\:px-4\\/5 {\n    padding-left: 80%;\n    padding-right: 80%;\n  }\n  .lg\\:py-1\\/6 {\n    padding-top: 16.666667%;\n    padding-bottom: 16.666667%;\n  }\n  .lg\\:px-1\\/6 {\n    padding-left: 16.666667%;\n    padding-right: 16.666667%;\n  }\n  .lg\\:py-2\\/6 {\n    padding-top: 33.333333%;\n    padding-bottom: 33.333333%;\n  }\n  .lg\\:px-2\\/6 {\n    padding-left: 33.333333%;\n    padding-right: 33.333333%;\n  }\n  .lg\\:py-3\\/6 {\n    padding-top: 50%;\n    padding-bottom: 50%;\n  }\n  .lg\\:px-3\\/6 {\n    padding-left: 50%;\n    padding-right: 50%;\n  }\n  .lg\\:py-4\\/6 {\n    padding-top: 66.666667%;\n    padding-bottom: 66.666667%;\n  }\n  .lg\\:px-4\\/6 {\n    padding-left: 66.666667%;\n    padding-right: 66.666667%;\n  }\n  .lg\\:py-5\\/6 {\n    padding-top: 83.333333%;\n    padding-bottom: 83.333333%;\n  }\n  .lg\\:px-5\\/6 {\n    padding-left: 83.333333%;\n    padding-right: 83.333333%;\n  }\n  .lg\\:py-1\\/12 {\n    padding-top: 8.333333%;\n    padding-bottom: 8.333333%;\n  }\n  .lg\\:px-1\\/12 {\n    padding-left: 8.333333%;\n    padding-right: 8.333333%;\n  }\n  .lg\\:py-2\\/12 {\n    padding-top: 16.666667%;\n    padding-bottom: 16.666667%;\n  }\n  .lg\\:px-2\\/12 {\n    padding-left: 16.666667%;\n    padding-right: 16.666667%;\n  }\n  .lg\\:py-3\\/12 {\n    padding-top: 25%;\n    padding-bottom: 25%;\n  }\n  .lg\\:px-3\\/12 {\n    padding-left: 25%;\n    padding-right: 25%;\n  }\n  .lg\\:py-4\\/12 {\n    padding-top: 33.333333%;\n    padding-bottom: 33.333333%;\n  }\n  .lg\\:px-4\\/12 {\n    padding-left: 33.333333%;\n    padding-right: 33.333333%;\n  }\n  .lg\\:py-5\\/12 {\n    padding-top: 41.666667%;\n    padding-bottom: 41.666667%;\n  }\n  .lg\\:px-5\\/12 {\n    padding-left: 41.666667%;\n    padding-right: 41.666667%;\n  }\n  .lg\\:py-6\\/12 {\n    padding-top: 50%;\n    padding-bottom: 50%;\n  }\n  .lg\\:px-6\\/12 {\n    padding-left: 50%;\n    padding-right: 50%;\n  }\n  .lg\\:py-7\\/12 {\n    padding-top: 58.333333%;\n    padding-bottom: 58.333333%;\n  }\n  .lg\\:px-7\\/12 {\n    padding-left: 58.333333%;\n    padding-right: 58.333333%;\n  }\n  .lg\\:py-8\\/12 {\n    padding-top: 66.666667%;\n    padding-bottom: 66.666667%;\n  }\n  .lg\\:px-8\\/12 {\n    padding-left: 66.666667%;\n    padding-right: 66.666667%;\n  }\n  .lg\\:py-9\\/12 {\n    padding-top: 75%;\n    padding-bottom: 75%;\n  }\n  .lg\\:px-9\\/12 {\n    padding-left: 75%;\n    padding-right: 75%;\n  }\n  .lg\\:py-10\\/12 {\n    padding-top: 83.333333%;\n    padding-bottom: 83.333333%;\n  }\n  .lg\\:px-10\\/12 {\n    padding-left: 83.333333%;\n    padding-right: 83.333333%;\n  }\n  .lg\\:py-11\\/12 {\n    padding-top: 91.666667%;\n    padding-bottom: 91.666667%;\n  }\n  .lg\\:px-11\\/12 {\n    padding-left: 91.666667%;\n    padding-right: 91.666667%;\n  }\n  .lg\\:py-full {\n    padding-top: 100%;\n    padding-bottom: 100%;\n  }\n  .lg\\:px-full {\n    padding-left: 100%;\n    padding-right: 100%;\n  }\n  .lg\\:pt-0 {\n    padding-top: 0;\n  }\n  .lg\\:pr-0 {\n    padding-right: 0;\n  }\n  .lg\\:pb-0 {\n    padding-bottom: 0;\n  }\n  .lg\\:pl-0 {\n    padding-left: 0;\n  }\n  .lg\\:pt-1 {\n    padding-top: 0.25rem;\n  }\n  .lg\\:pr-1 {\n    padding-right: 0.25rem;\n  }\n  .lg\\:pb-1 {\n    padding-bottom: 0.25rem;\n  }\n  .lg\\:pl-1 {\n    padding-left: 0.25rem;\n  }\n  .lg\\:pt-2 {\n    padding-top: 0.5rem;\n  }\n  .lg\\:pr-2 {\n    padding-right: 0.5rem;\n  }\n  .lg\\:pb-2 {\n    padding-bottom: 0.5rem;\n  }\n  .lg\\:pl-2 {\n    padding-left: 0.5rem;\n  }\n  .lg\\:pt-3 {\n    padding-top: 0.75rem;\n  }\n  .lg\\:pr-3 {\n    padding-right: 0.75rem;\n  }\n  .lg\\:pb-3 {\n    padding-bottom: 0.75rem;\n  }\n  .lg\\:pl-3 {\n    padding-left: 0.75rem;\n  }\n  .lg\\:pt-4 {\n    padding-top: 1rem;\n  }\n  .lg\\:pr-4 {\n    padding-right: 1rem;\n  }\n  .lg\\:pb-4 {\n    padding-bottom: 1rem;\n  }\n  .lg\\:pl-4 {\n    padding-left: 1rem;\n  }\n  .lg\\:pt-5 {\n    padding-top: 1.25rem;\n  }\n  .lg\\:pr-5 {\n    padding-right: 1.25rem;\n  }\n  .lg\\:pb-5 {\n    padding-bottom: 1.25rem;\n  }\n  .lg\\:pl-5 {\n    padding-left: 1.25rem;\n  }\n  .lg\\:pt-6 {\n    padding-top: 1.5rem;\n  }\n  .lg\\:pr-6 {\n    padding-right: 1.5rem;\n  }\n  .lg\\:pb-6 {\n    padding-bottom: 1.5rem;\n  }\n  .lg\\:pl-6 {\n    padding-left: 1.5rem;\n  }\n  .lg\\:pt-7 {\n    padding-top: 1.75rem;\n  }\n  .lg\\:pr-7 {\n    padding-right: 1.75rem;\n  }\n  .lg\\:pb-7 {\n    padding-bottom: 1.75rem;\n  }\n  .lg\\:pl-7 {\n    padding-left: 1.75rem;\n  }\n  .lg\\:pt-8 {\n    padding-top: 2rem;\n  }\n  .lg\\:pr-8 {\n    padding-right: 2rem;\n  }\n  .lg\\:pb-8 {\n    padding-bottom: 2rem;\n  }\n  .lg\\:pl-8 {\n    padding-left: 2rem;\n  }\n  .lg\\:pt-9 {\n    padding-top: 2.25rem;\n  }\n  .lg\\:pr-9 {\n    padding-right: 2.25rem;\n  }\n  .lg\\:pb-9 {\n    padding-bottom: 2.25rem;\n  }\n  .lg\\:pl-9 {\n    padding-left: 2.25rem;\n  }\n  .lg\\:pt-10 {\n    padding-top: 2.5rem;\n  }\n  .lg\\:pr-10 {\n    padding-right: 2.5rem;\n  }\n  .lg\\:pb-10 {\n    padding-bottom: 2.5rem;\n  }\n  .lg\\:pl-10 {\n    padding-left: 2.5rem;\n  }\n  .lg\\:pt-11 {\n    padding-top: 2.75rem;\n  }\n  .lg\\:pr-11 {\n    padding-right: 2.75rem;\n  }\n  .lg\\:pb-11 {\n    padding-bottom: 2.75rem;\n  }\n  .lg\\:pl-11 {\n    padding-left: 2.75rem;\n  }\n  .lg\\:pt-12 {\n    padding-top: 3rem;\n  }\n  .lg\\:pr-12 {\n    padding-right: 3rem;\n  }\n  .lg\\:pb-12 {\n    padding-bottom: 3rem;\n  }\n  .lg\\:pl-12 {\n    padding-left: 3rem;\n  }\n  .lg\\:pt-13 {\n    padding-top: 3.25rem;\n  }\n  .lg\\:pr-13 {\n    padding-right: 3.25rem;\n  }\n  .lg\\:pb-13 {\n    padding-bottom: 3.25rem;\n  }\n  .lg\\:pl-13 {\n    padding-left: 3.25rem;\n  }\n  .lg\\:pt-14 {\n    padding-top: 3.5rem;\n  }\n  .lg\\:pr-14 {\n    padding-right: 3.5rem;\n  }\n  .lg\\:pb-14 {\n    padding-bottom: 3.5rem;\n  }\n  .lg\\:pl-14 {\n    padding-left: 3.5rem;\n  }\n  .lg\\:pt-15 {\n    padding-top: 3.75rem;\n  }\n  .lg\\:pr-15 {\n    padding-right: 3.75rem;\n  }\n  .lg\\:pb-15 {\n    padding-bottom: 3.75rem;\n  }\n  .lg\\:pl-15 {\n    padding-left: 3.75rem;\n  }\n  .lg\\:pt-16 {\n    padding-top: 4rem;\n  }\n  .lg\\:pr-16 {\n    padding-right: 4rem;\n  }\n  .lg\\:pb-16 {\n    padding-bottom: 4rem;\n  }\n  .lg\\:pl-16 {\n    padding-left: 4rem;\n  }\n  .lg\\:pt-20 {\n    padding-top: 5rem;\n  }\n  .lg\\:pr-20 {\n    padding-right: 5rem;\n  }\n  .lg\\:pb-20 {\n    padding-bottom: 5rem;\n  }\n  .lg\\:pl-20 {\n    padding-left: 5rem;\n  }\n  .lg\\:pt-24 {\n    padding-top: 6rem;\n  }\n  .lg\\:pr-24 {\n    padding-right: 6rem;\n  }\n  .lg\\:pb-24 {\n    padding-bottom: 6rem;\n  }\n  .lg\\:pl-24 {\n    padding-left: 6rem;\n  }\n  .lg\\:pt-28 {\n    padding-top: 7rem;\n  }\n  .lg\\:pr-28 {\n    padding-right: 7rem;\n  }\n  .lg\\:pb-28 {\n    padding-bottom: 7rem;\n  }\n  .lg\\:pl-28 {\n    padding-left: 7rem;\n  }\n  .lg\\:pt-32 {\n    padding-top: 8rem;\n  }\n  .lg\\:pr-32 {\n    padding-right: 8rem;\n  }\n  .lg\\:pb-32 {\n    padding-bottom: 8rem;\n  }\n  .lg\\:pl-32 {\n    padding-left: 8rem;\n  }\n  .lg\\:pt-36 {\n    padding-top: 9rem;\n  }\n  .lg\\:pr-36 {\n    padding-right: 9rem;\n  }\n  .lg\\:pb-36 {\n    padding-bottom: 9rem;\n  }\n  .lg\\:pl-36 {\n    padding-left: 9rem;\n  }\n  .lg\\:pt-40 {\n    padding-top: 10rem;\n  }\n  .lg\\:pr-40 {\n    padding-right: 10rem;\n  }\n  .lg\\:pb-40 {\n    padding-bottom: 10rem;\n  }\n  .lg\\:pl-40 {\n    padding-left: 10rem;\n  }\n  .lg\\:pt-44 {\n    padding-top: 11rem;\n  }\n  .lg\\:pr-44 {\n    padding-right: 11rem;\n  }\n  .lg\\:pb-44 {\n    padding-bottom: 11rem;\n  }\n  .lg\\:pl-44 {\n    padding-left: 11rem;\n  }\n  .lg\\:pt-48 {\n    padding-top: 12rem;\n  }\n  .lg\\:pr-48 {\n    padding-right: 12rem;\n  }\n  .lg\\:pb-48 {\n    padding-bottom: 12rem;\n  }\n  .lg\\:pl-48 {\n    padding-left: 12rem;\n  }\n  .lg\\:pt-52 {\n    padding-top: 13rem;\n  }\n  .lg\\:pr-52 {\n    padding-right: 13rem;\n  }\n  .lg\\:pb-52 {\n    padding-bottom: 13rem;\n  }\n  .lg\\:pl-52 {\n    padding-left: 13rem;\n  }\n  .lg\\:pt-56 {\n    padding-top: 14rem;\n  }\n  .lg\\:pr-56 {\n    padding-right: 14rem;\n  }\n  .lg\\:pb-56 {\n    padding-bottom: 14rem;\n  }\n  .lg\\:pl-56 {\n    padding-left: 14rem;\n  }\n  .lg\\:pt-60 {\n    padding-top: 15rem;\n  }\n  .lg\\:pr-60 {\n    padding-right: 15rem;\n  }\n  .lg\\:pb-60 {\n    padding-bottom: 15rem;\n  }\n  .lg\\:pl-60 {\n    padding-left: 15rem;\n  }\n  .lg\\:pt-64 {\n    padding-top: 16rem;\n  }\n  .lg\\:pr-64 {\n    padding-right: 16rem;\n  }\n  .lg\\:pb-64 {\n    padding-bottom: 16rem;\n  }\n  .lg\\:pl-64 {\n    padding-left: 16rem;\n  }\n  .lg\\:pt-72 {\n    padding-top: 18rem;\n  }\n  .lg\\:pr-72 {\n    padding-right: 18rem;\n  }\n  .lg\\:pb-72 {\n    padding-bottom: 18rem;\n  }\n  .lg\\:pl-72 {\n    padding-left: 18rem;\n  }\n  .lg\\:pt-80 {\n    padding-top: 20rem;\n  }\n  .lg\\:pr-80 {\n    padding-right: 20rem;\n  }\n  .lg\\:pb-80 {\n    padding-bottom: 20rem;\n  }\n  .lg\\:pl-80 {\n    padding-left: 20rem;\n  }\n  .lg\\:pt-96 {\n    padding-top: 24rem;\n  }\n  .lg\\:pr-96 {\n    padding-right: 24rem;\n  }\n  .lg\\:pb-96 {\n    padding-bottom: 24rem;\n  }\n  .lg\\:pl-96 {\n    padding-left: 24rem;\n  }\n  .lg\\:pt-px {\n    padding-top: 1px;\n  }\n  .lg\\:pr-px {\n    padding-right: 1px;\n  }\n  .lg\\:pb-px {\n    padding-bottom: 1px;\n  }\n  .lg\\:pl-px {\n    padding-left: 1px;\n  }\n  .lg\\:pt-0\\.5 {\n    padding-top: 0.125rem;\n  }\n  .lg\\:pr-0\\.5 {\n    padding-right: 0.125rem;\n  }\n  .lg\\:pb-0\\.5 {\n    padding-bottom: 0.125rem;\n  }\n  .lg\\:pl-0\\.5 {\n    padding-left: 0.125rem;\n  }\n  .lg\\:pt-1\\.5 {\n    padding-top: 0.375rem;\n  }\n  .lg\\:pr-1\\.5 {\n    padding-right: 0.375rem;\n  }\n  .lg\\:pb-1\\.5 {\n    padding-bottom: 0.375rem;\n  }\n  .lg\\:pl-1\\.5 {\n    padding-left: 0.375rem;\n  }\n  .lg\\:pt-2\\.5 {\n    padding-top: 0.625rem;\n  }\n  .lg\\:pr-2\\.5 {\n    padding-right: 0.625rem;\n  }\n  .lg\\:pb-2\\.5 {\n    padding-bottom: 0.625rem;\n  }\n  .lg\\:pl-2\\.5 {\n    padding-left: 0.625rem;\n  }\n  .lg\\:pt-3\\.5 {\n    padding-top: 0.875rem;\n  }\n  .lg\\:pr-3\\.5 {\n    padding-right: 0.875rem;\n  }\n  .lg\\:pb-3\\.5 {\n    padding-bottom: 0.875rem;\n  }\n  .lg\\:pl-3\\.5 {\n    padding-left: 0.875rem;\n  }\n  .lg\\:pt-1\\/2 {\n    padding-top: 50%;\n  }\n  .lg\\:pr-1\\/2 {\n    padding-right: 50%;\n  }\n  .lg\\:pb-1\\/2 {\n    padding-bottom: 50%;\n  }\n  .lg\\:pl-1\\/2 {\n    padding-left: 50%;\n  }\n  .lg\\:pt-1\\/3 {\n    padding-top: 33.333333%;\n  }\n  .lg\\:pr-1\\/3 {\n    padding-right: 33.333333%;\n  }\n  .lg\\:pb-1\\/3 {\n    padding-bottom: 33.333333%;\n  }\n  .lg\\:pl-1\\/3 {\n    padding-left: 33.333333%;\n  }\n  .lg\\:pt-2\\/3 {\n    padding-top: 66.666667%;\n  }\n  .lg\\:pr-2\\/3 {\n    padding-right: 66.666667%;\n  }\n  .lg\\:pb-2\\/3 {\n    padding-bottom: 66.666667%;\n  }\n  .lg\\:pl-2\\/3 {\n    padding-left: 66.666667%;\n  }\n  .lg\\:pt-1\\/4 {\n    padding-top: 25%;\n  }\n  .lg\\:pr-1\\/4 {\n    padding-right: 25%;\n  }\n  .lg\\:pb-1\\/4 {\n    padding-bottom: 25%;\n  }\n  .lg\\:pl-1\\/4 {\n    padding-left: 25%;\n  }\n  .lg\\:pt-2\\/4 {\n    padding-top: 50%;\n  }\n  .lg\\:pr-2\\/4 {\n    padding-right: 50%;\n  }\n  .lg\\:pb-2\\/4 {\n    padding-bottom: 50%;\n  }\n  .lg\\:pl-2\\/4 {\n    padding-left: 50%;\n  }\n  .lg\\:pt-3\\/4 {\n    padding-top: 75%;\n  }\n  .lg\\:pr-3\\/4 {\n    padding-right: 75%;\n  }\n  .lg\\:pb-3\\/4 {\n    padding-bottom: 75%;\n  }\n  .lg\\:pl-3\\/4 {\n    padding-left: 75%;\n  }\n  .lg\\:pt-1\\/5 {\n    padding-top: 20%;\n  }\n  .lg\\:pr-1\\/5 {\n    padding-right: 20%;\n  }\n  .lg\\:pb-1\\/5 {\n    padding-bottom: 20%;\n  }\n  .lg\\:pl-1\\/5 {\n    padding-left: 20%;\n  }\n  .lg\\:pt-2\\/5 {\n    padding-top: 40%;\n  }\n  .lg\\:pr-2\\/5 {\n    padding-right: 40%;\n  }\n  .lg\\:pb-2\\/5 {\n    padding-bottom: 40%;\n  }\n  .lg\\:pl-2\\/5 {\n    padding-left: 40%;\n  }\n  .lg\\:pt-3\\/5 {\n    padding-top: 60%;\n  }\n  .lg\\:pr-3\\/5 {\n    padding-right: 60%;\n  }\n  .lg\\:pb-3\\/5 {\n    padding-bottom: 60%;\n  }\n  .lg\\:pl-3\\/5 {\n    padding-left: 60%;\n  }\n  .lg\\:pt-4\\/5 {\n    padding-top: 80%;\n  }\n  .lg\\:pr-4\\/5 {\n    padding-right: 80%;\n  }\n  .lg\\:pb-4\\/5 {\n    padding-bottom: 80%;\n  }\n  .lg\\:pl-4\\/5 {\n    padding-left: 80%;\n  }\n  .lg\\:pt-1\\/6 {\n    padding-top: 16.666667%;\n  }\n  .lg\\:pr-1\\/6 {\n    padding-right: 16.666667%;\n  }\n  .lg\\:pb-1\\/6 {\n    padding-bottom: 16.666667%;\n  }\n  .lg\\:pl-1\\/6 {\n    padding-left: 16.666667%;\n  }\n  .lg\\:pt-2\\/6 {\n    padding-top: 33.333333%;\n  }\n  .lg\\:pr-2\\/6 {\n    padding-right: 33.333333%;\n  }\n  .lg\\:pb-2\\/6 {\n    padding-bottom: 33.333333%;\n  }\n  .lg\\:pl-2\\/6 {\n    padding-left: 33.333333%;\n  }\n  .lg\\:pt-3\\/6 {\n    padding-top: 50%;\n  }\n  .lg\\:pr-3\\/6 {\n    padding-right: 50%;\n  }\n  .lg\\:pb-3\\/6 {\n    padding-bottom: 50%;\n  }\n  .lg\\:pl-3\\/6 {\n    padding-left: 50%;\n  }\n  .lg\\:pt-4\\/6 {\n    padding-top: 66.666667%;\n  }\n  .lg\\:pr-4\\/6 {\n    padding-right: 66.666667%;\n  }\n  .lg\\:pb-4\\/6 {\n    padding-bottom: 66.666667%;\n  }\n  .lg\\:pl-4\\/6 {\n    padding-left: 66.666667%;\n  }\n  .lg\\:pt-5\\/6 {\n    padding-top: 83.333333%;\n  }\n  .lg\\:pr-5\\/6 {\n    padding-right: 83.333333%;\n  }\n  .lg\\:pb-5\\/6 {\n    padding-bottom: 83.333333%;\n  }\n  .lg\\:pl-5\\/6 {\n    padding-left: 83.333333%;\n  }\n  .lg\\:pt-1\\/12 {\n    padding-top: 8.333333%;\n  }\n  .lg\\:pr-1\\/12 {\n    padding-right: 8.333333%;\n  }\n  .lg\\:pb-1\\/12 {\n    padding-bottom: 8.333333%;\n  }\n  .lg\\:pl-1\\/12 {\n    padding-left: 8.333333%;\n  }\n  .lg\\:pt-2\\/12 {\n    padding-top: 16.666667%;\n  }\n  .lg\\:pr-2\\/12 {\n    padding-right: 16.666667%;\n  }\n  .lg\\:pb-2\\/12 {\n    padding-bottom: 16.666667%;\n  }\n  .lg\\:pl-2\\/12 {\n    padding-left: 16.666667%;\n  }\n  .lg\\:pt-3\\/12 {\n    padding-top: 25%;\n  }\n  .lg\\:pr-3\\/12 {\n    padding-right: 25%;\n  }\n  .lg\\:pb-3\\/12 {\n    padding-bottom: 25%;\n  }\n  .lg\\:pl-3\\/12 {\n    padding-left: 25%;\n  }\n  .lg\\:pt-4\\/12 {\n    padding-top: 33.333333%;\n  }\n  .lg\\:pr-4\\/12 {\n    padding-right: 33.333333%;\n  }\n  .lg\\:pb-4\\/12 {\n    padding-bottom: 33.333333%;\n  }\n  .lg\\:pl-4\\/12 {\n    padding-left: 33.333333%;\n  }\n  .lg\\:pt-5\\/12 {\n    padding-top: 41.666667%;\n  }\n  .lg\\:pr-5\\/12 {\n    padding-right: 41.666667%;\n  }\n  .lg\\:pb-5\\/12 {\n    padding-bottom: 41.666667%;\n  }\n  .lg\\:pl-5\\/12 {\n    padding-left: 41.666667%;\n  }\n  .lg\\:pt-6\\/12 {\n    padding-top: 50%;\n  }\n  .lg\\:pr-6\\/12 {\n    padding-right: 50%;\n  }\n  .lg\\:pb-6\\/12 {\n    padding-bottom: 50%;\n  }\n  .lg\\:pl-6\\/12 {\n    padding-left: 50%;\n  }\n  .lg\\:pt-7\\/12 {\n    padding-top: 58.333333%;\n  }\n  .lg\\:pr-7\\/12 {\n    padding-right: 58.333333%;\n  }\n  .lg\\:pb-7\\/12 {\n    padding-bottom: 58.333333%;\n  }\n  .lg\\:pl-7\\/12 {\n    padding-left: 58.333333%;\n  }\n  .lg\\:pt-8\\/12 {\n    padding-top: 66.666667%;\n  }\n  .lg\\:pr-8\\/12 {\n    padding-right: 66.666667%;\n  }\n  .lg\\:pb-8\\/12 {\n    padding-bottom: 66.666667%;\n  }\n  .lg\\:pl-8\\/12 {\n    padding-left: 66.666667%;\n  }\n  .lg\\:pt-9\\/12 {\n    padding-top: 75%;\n  }\n  .lg\\:pr-9\\/12 {\n    padding-right: 75%;\n  }\n  .lg\\:pb-9\\/12 {\n    padding-bottom: 75%;\n  }\n  .lg\\:pl-9\\/12 {\n    padding-left: 75%;\n  }\n  .lg\\:pt-10\\/12 {\n    padding-top: 83.333333%;\n  }\n  .lg\\:pr-10\\/12 {\n    padding-right: 83.333333%;\n  }\n  .lg\\:pb-10\\/12 {\n    padding-bottom: 83.333333%;\n  }\n  .lg\\:pl-10\\/12 {\n    padding-left: 83.333333%;\n  }\n  .lg\\:pt-11\\/12 {\n    padding-top: 91.666667%;\n  }\n  .lg\\:pr-11\\/12 {\n    padding-right: 91.666667%;\n  }\n  .lg\\:pb-11\\/12 {\n    padding-bottom: 91.666667%;\n  }\n  .lg\\:pl-11\\/12 {\n    padding-left: 91.666667%;\n  }\n  .lg\\:pt-full {\n    padding-top: 100%;\n  }\n  .lg\\:pr-full {\n    padding-right: 100%;\n  }\n  .lg\\:pb-full {\n    padding-bottom: 100%;\n  }\n  .lg\\:pl-full {\n    padding-left: 100%;\n  }\n  .lg\\:placeholder-current::-moz-placeholder {\n    color: currentColor;\n  }\n  .lg\\:placeholder-current::placeholder {\n    color: currentColor;\n  }\n  .lg\\:placeholder-transparent::-moz-placeholder {\n    color: transparent;\n  }\n  .lg\\:placeholder-transparent::placeholder {\n    color: transparent;\n  }\n  .lg\\:placeholder-white::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #ffffff;\n    color: rgba(255, 255, 255, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-white::placeholder {\n    --placeholder-opacity: 1;\n    color: #ffffff;\n    color: rgba(255, 255, 255, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-black::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #000000;\n    color: rgba(0, 0, 0, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-black::placeholder {\n    --placeholder-opacity: 1;\n    color: #000000;\n    color: rgba(0, 0, 0, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-gray-50::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #f9fafb;\n    color: rgba(249, 250, 251, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-gray-50::placeholder {\n    --placeholder-opacity: 1;\n    color: #f9fafb;\n    color: rgba(249, 250, 251, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-gray-100::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #f4f5f7;\n    color: rgba(244, 245, 247, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-gray-100::placeholder {\n    --placeholder-opacity: 1;\n    color: #f4f5f7;\n    color: rgba(244, 245, 247, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-gray-200::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #e5e7eb;\n    color: rgba(229, 231, 235, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-gray-200::placeholder {\n    --placeholder-opacity: 1;\n    color: #e5e7eb;\n    color: rgba(229, 231, 235, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-gray-300::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #d2d6dc;\n    color: rgba(210, 214, 220, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-gray-300::placeholder {\n    --placeholder-opacity: 1;\n    color: #d2d6dc;\n    color: rgba(210, 214, 220, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-gray-400::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #9fa6b2;\n    color: rgba(159, 166, 178, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-gray-400::placeholder {\n    --placeholder-opacity: 1;\n    color: #9fa6b2;\n    color: rgba(159, 166, 178, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-gray-500::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #6b7280;\n    color: rgba(107, 114, 128, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-gray-500::placeholder {\n    --placeholder-opacity: 1;\n    color: #6b7280;\n    color: rgba(107, 114, 128, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-gray-600::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #4b5563;\n    color: rgba(75, 85, 99, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-gray-600::placeholder {\n    --placeholder-opacity: 1;\n    color: #4b5563;\n    color: rgba(75, 85, 99, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-gray-700::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #374151;\n    color: rgba(55, 65, 81, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-gray-700::placeholder {\n    --placeholder-opacity: 1;\n    color: #374151;\n    color: rgba(55, 65, 81, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-gray-800::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #252f3f;\n    color: rgba(37, 47, 63, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-gray-800::placeholder {\n    --placeholder-opacity: 1;\n    color: #252f3f;\n    color: rgba(37, 47, 63, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-gray-900::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #161e2e;\n    color: rgba(22, 30, 46, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-gray-900::placeholder {\n    --placeholder-opacity: 1;\n    color: #161e2e;\n    color: rgba(22, 30, 46, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-red-50::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #fdf2f2;\n    color: rgba(253, 242, 242, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-red-50::placeholder {\n    --placeholder-opacity: 1;\n    color: #fdf2f2;\n    color: rgba(253, 242, 242, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-red-100::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #fde8e8;\n    color: rgba(253, 232, 232, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-red-100::placeholder {\n    --placeholder-opacity: 1;\n    color: #fde8e8;\n    color: rgba(253, 232, 232, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-red-200::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #fbd5d5;\n    color: rgba(251, 213, 213, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-red-200::placeholder {\n    --placeholder-opacity: 1;\n    color: #fbd5d5;\n    color: rgba(251, 213, 213, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-red-300::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #f8b4b4;\n    color: rgba(248, 180, 180, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-red-300::placeholder {\n    --placeholder-opacity: 1;\n    color: #f8b4b4;\n    color: rgba(248, 180, 180, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-red-400::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #f98080;\n    color: rgba(249, 128, 128, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-red-400::placeholder {\n    --placeholder-opacity: 1;\n    color: #f98080;\n    color: rgba(249, 128, 128, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-red-500::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #f05252;\n    color: rgba(240, 82, 82, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-red-500::placeholder {\n    --placeholder-opacity: 1;\n    color: #f05252;\n    color: rgba(240, 82, 82, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-red-600::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #e02424;\n    color: rgba(224, 36, 36, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-red-600::placeholder {\n    --placeholder-opacity: 1;\n    color: #e02424;\n    color: rgba(224, 36, 36, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-red-700::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #c81e1e;\n    color: rgba(200, 30, 30, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-red-700::placeholder {\n    --placeholder-opacity: 1;\n    color: #c81e1e;\n    color: rgba(200, 30, 30, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-red-800::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #9b1c1c;\n    color: rgba(155, 28, 28, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-red-800::placeholder {\n    --placeholder-opacity: 1;\n    color: #9b1c1c;\n    color: rgba(155, 28, 28, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-red-900::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #771d1d;\n    color: rgba(119, 29, 29, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-red-900::placeholder {\n    --placeholder-opacity: 1;\n    color: #771d1d;\n    color: rgba(119, 29, 29, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-orange-50::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #fff8f1;\n    color: rgba(255, 248, 241, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-orange-50::placeholder {\n    --placeholder-opacity: 1;\n    color: #fff8f1;\n    color: rgba(255, 248, 241, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-orange-100::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #feecdc;\n    color: rgba(254, 236, 220, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-orange-100::placeholder {\n    --placeholder-opacity: 1;\n    color: #feecdc;\n    color: rgba(254, 236, 220, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-orange-200::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #fcd9bd;\n    color: rgba(252, 217, 189, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-orange-200::placeholder {\n    --placeholder-opacity: 1;\n    color: #fcd9bd;\n    color: rgba(252, 217, 189, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-orange-300::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #fdba8c;\n    color: rgba(253, 186, 140, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-orange-300::placeholder {\n    --placeholder-opacity: 1;\n    color: #fdba8c;\n    color: rgba(253, 186, 140, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-orange-400::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #ff8a4c;\n    color: rgba(255, 138, 76, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-orange-400::placeholder {\n    --placeholder-opacity: 1;\n    color: #ff8a4c;\n    color: rgba(255, 138, 76, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-orange-500::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #ff5a1f;\n    color: rgba(255, 90, 31, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-orange-500::placeholder {\n    --placeholder-opacity: 1;\n    color: #ff5a1f;\n    color: rgba(255, 90, 31, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-orange-600::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #d03801;\n    color: rgba(208, 56, 1, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-orange-600::placeholder {\n    --placeholder-opacity: 1;\n    color: #d03801;\n    color: rgba(208, 56, 1, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-orange-700::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #b43403;\n    color: rgba(180, 52, 3, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-orange-700::placeholder {\n    --placeholder-opacity: 1;\n    color: #b43403;\n    color: rgba(180, 52, 3, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-orange-800::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #8a2c0d;\n    color: rgba(138, 44, 13, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-orange-800::placeholder {\n    --placeholder-opacity: 1;\n    color: #8a2c0d;\n    color: rgba(138, 44, 13, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-orange-900::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #73230d;\n    color: rgba(115, 35, 13, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-orange-900::placeholder {\n    --placeholder-opacity: 1;\n    color: #73230d;\n    color: rgba(115, 35, 13, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-yellow-50::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #fdfdea;\n    color: rgba(253, 253, 234, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-yellow-50::placeholder {\n    --placeholder-opacity: 1;\n    color: #fdfdea;\n    color: rgba(253, 253, 234, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-yellow-100::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #fdf6b2;\n    color: rgba(253, 246, 178, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-yellow-100::placeholder {\n    --placeholder-opacity: 1;\n    color: #fdf6b2;\n    color: rgba(253, 246, 178, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-yellow-200::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #fce96a;\n    color: rgba(252, 233, 106, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-yellow-200::placeholder {\n    --placeholder-opacity: 1;\n    color: #fce96a;\n    color: rgba(252, 233, 106, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-yellow-300::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #faca15;\n    color: rgba(250, 202, 21, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-yellow-300::placeholder {\n    --placeholder-opacity: 1;\n    color: #faca15;\n    color: rgba(250, 202, 21, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-yellow-400::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #e3a008;\n    color: rgba(227, 160, 8, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-yellow-400::placeholder {\n    --placeholder-opacity: 1;\n    color: #e3a008;\n    color: rgba(227, 160, 8, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-yellow-500::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #c27803;\n    color: rgba(194, 120, 3, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-yellow-500::placeholder {\n    --placeholder-opacity: 1;\n    color: #c27803;\n    color: rgba(194, 120, 3, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-yellow-600::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #9f580a;\n    color: rgba(159, 88, 10, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-yellow-600::placeholder {\n    --placeholder-opacity: 1;\n    color: #9f580a;\n    color: rgba(159, 88, 10, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-yellow-700::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #8e4b10;\n    color: rgba(142, 75, 16, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-yellow-700::placeholder {\n    --placeholder-opacity: 1;\n    color: #8e4b10;\n    color: rgba(142, 75, 16, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-yellow-800::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #723b13;\n    color: rgba(114, 59, 19, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-yellow-800::placeholder {\n    --placeholder-opacity: 1;\n    color: #723b13;\n    color: rgba(114, 59, 19, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-yellow-900::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #633112;\n    color: rgba(99, 49, 18, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-yellow-900::placeholder {\n    --placeholder-opacity: 1;\n    color: #633112;\n    color: rgba(99, 49, 18, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-green-50::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #f3faf7;\n    color: rgba(243, 250, 247, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-green-50::placeholder {\n    --placeholder-opacity: 1;\n    color: #f3faf7;\n    color: rgba(243, 250, 247, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-green-100::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #def7ec;\n    color: rgba(222, 247, 236, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-green-100::placeholder {\n    --placeholder-opacity: 1;\n    color: #def7ec;\n    color: rgba(222, 247, 236, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-green-200::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #bcf0da;\n    color: rgba(188, 240, 218, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-green-200::placeholder {\n    --placeholder-opacity: 1;\n    color: #bcf0da;\n    color: rgba(188, 240, 218, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-green-300::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #84e1bc;\n    color: rgba(132, 225, 188, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-green-300::placeholder {\n    --placeholder-opacity: 1;\n    color: #84e1bc;\n    color: rgba(132, 225, 188, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-green-400::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #31c48d;\n    color: rgba(49, 196, 141, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-green-400::placeholder {\n    --placeholder-opacity: 1;\n    color: #31c48d;\n    color: rgba(49, 196, 141, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-green-500::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #0e9f6e;\n    color: rgba(14, 159, 110, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-green-500::placeholder {\n    --placeholder-opacity: 1;\n    color: #0e9f6e;\n    color: rgba(14, 159, 110, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-green-600::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #057a55;\n    color: rgba(5, 122, 85, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-green-600::placeholder {\n    --placeholder-opacity: 1;\n    color: #057a55;\n    color: rgba(5, 122, 85, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-green-700::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #046c4e;\n    color: rgba(4, 108, 78, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-green-700::placeholder {\n    --placeholder-opacity: 1;\n    color: #046c4e;\n    color: rgba(4, 108, 78, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-green-800::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #03543f;\n    color: rgba(3, 84, 63, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-green-800::placeholder {\n    --placeholder-opacity: 1;\n    color: #03543f;\n    color: rgba(3, 84, 63, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-green-900::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #014737;\n    color: rgba(1, 71, 55, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-green-900::placeholder {\n    --placeholder-opacity: 1;\n    color: #014737;\n    color: rgba(1, 71, 55, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-teal-50::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #edfafa;\n    color: rgba(237, 250, 250, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-teal-50::placeholder {\n    --placeholder-opacity: 1;\n    color: #edfafa;\n    color: rgba(237, 250, 250, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-teal-100::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #d5f5f6;\n    color: rgba(213, 245, 246, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-teal-100::placeholder {\n    --placeholder-opacity: 1;\n    color: #d5f5f6;\n    color: rgba(213, 245, 246, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-teal-200::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #afecef;\n    color: rgba(175, 236, 239, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-teal-200::placeholder {\n    --placeholder-opacity: 1;\n    color: #afecef;\n    color: rgba(175, 236, 239, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-teal-300::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #7edce2;\n    color: rgba(126, 220, 226, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-teal-300::placeholder {\n    --placeholder-opacity: 1;\n    color: #7edce2;\n    color: rgba(126, 220, 226, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-teal-400::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #16bdca;\n    color: rgba(22, 189, 202, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-teal-400::placeholder {\n    --placeholder-opacity: 1;\n    color: #16bdca;\n    color: rgba(22, 189, 202, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-teal-500::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #0694a2;\n    color: rgba(6, 148, 162, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-teal-500::placeholder {\n    --placeholder-opacity: 1;\n    color: #0694a2;\n    color: rgba(6, 148, 162, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-teal-600::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #047481;\n    color: rgba(4, 116, 129, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-teal-600::placeholder {\n    --placeholder-opacity: 1;\n    color: #047481;\n    color: rgba(4, 116, 129, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-teal-700::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #036672;\n    color: rgba(3, 102, 114, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-teal-700::placeholder {\n    --placeholder-opacity: 1;\n    color: #036672;\n    color: rgba(3, 102, 114, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-teal-800::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #05505c;\n    color: rgba(5, 80, 92, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-teal-800::placeholder {\n    --placeholder-opacity: 1;\n    color: #05505c;\n    color: rgba(5, 80, 92, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-teal-900::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #014451;\n    color: rgba(1, 68, 81, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-teal-900::placeholder {\n    --placeholder-opacity: 1;\n    color: #014451;\n    color: rgba(1, 68, 81, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-blue-50::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #ebf5ff;\n    color: rgba(235, 245, 255, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-blue-50::placeholder {\n    --placeholder-opacity: 1;\n    color: #ebf5ff;\n    color: rgba(235, 245, 255, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-blue-100::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #e1effe;\n    color: rgba(225, 239, 254, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-blue-100::placeholder {\n    --placeholder-opacity: 1;\n    color: #e1effe;\n    color: rgba(225, 239, 254, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-blue-200::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #c3ddfd;\n    color: rgba(195, 221, 253, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-blue-200::placeholder {\n    --placeholder-opacity: 1;\n    color: #c3ddfd;\n    color: rgba(195, 221, 253, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-blue-300::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #a4cafe;\n    color: rgba(164, 202, 254, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-blue-300::placeholder {\n    --placeholder-opacity: 1;\n    color: #a4cafe;\n    color: rgba(164, 202, 254, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-blue-400::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #76a9fa;\n    color: rgba(118, 169, 250, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-blue-400::placeholder {\n    --placeholder-opacity: 1;\n    color: #76a9fa;\n    color: rgba(118, 169, 250, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-blue-500::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #3f83f8;\n    color: rgba(63, 131, 248, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-blue-500::placeholder {\n    --placeholder-opacity: 1;\n    color: #3f83f8;\n    color: rgba(63, 131, 248, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-blue-600::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #1c64f2;\n    color: rgba(28, 100, 242, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-blue-600::placeholder {\n    --placeholder-opacity: 1;\n    color: #1c64f2;\n    color: rgba(28, 100, 242, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-blue-700::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #1a56db;\n    color: rgba(26, 86, 219, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-blue-700::placeholder {\n    --placeholder-opacity: 1;\n    color: #1a56db;\n    color: rgba(26, 86, 219, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-blue-800::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #1e429f;\n    color: rgba(30, 66, 159, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-blue-800::placeholder {\n    --placeholder-opacity: 1;\n    color: #1e429f;\n    color: rgba(30, 66, 159, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-blue-900::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #233876;\n    color: rgba(35, 56, 118, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-blue-900::placeholder {\n    --placeholder-opacity: 1;\n    color: #233876;\n    color: rgba(35, 56, 118, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-indigo-50::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #f0f5ff;\n    color: rgba(240, 245, 255, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-indigo-50::placeholder {\n    --placeholder-opacity: 1;\n    color: #f0f5ff;\n    color: rgba(240, 245, 255, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-indigo-100::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #e5edff;\n    color: rgba(229, 237, 255, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-indigo-100::placeholder {\n    --placeholder-opacity: 1;\n    color: #e5edff;\n    color: rgba(229, 237, 255, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-indigo-200::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #cddbfe;\n    color: rgba(205, 219, 254, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-indigo-200::placeholder {\n    --placeholder-opacity: 1;\n    color: #cddbfe;\n    color: rgba(205, 219, 254, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-indigo-300::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #b4c6fc;\n    color: rgba(180, 198, 252, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-indigo-300::placeholder {\n    --placeholder-opacity: 1;\n    color: #b4c6fc;\n    color: rgba(180, 198, 252, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-indigo-400::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #8da2fb;\n    color: rgba(141, 162, 251, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-indigo-400::placeholder {\n    --placeholder-opacity: 1;\n    color: #8da2fb;\n    color: rgba(141, 162, 251, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-indigo-500::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #6875f5;\n    color: rgba(104, 117, 245, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-indigo-500::placeholder {\n    --placeholder-opacity: 1;\n    color: #6875f5;\n    color: rgba(104, 117, 245, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-indigo-600::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #5850ec;\n    color: rgba(88, 80, 236, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-indigo-600::placeholder {\n    --placeholder-opacity: 1;\n    color: #5850ec;\n    color: rgba(88, 80, 236, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-indigo-700::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #5145cd;\n    color: rgba(81, 69, 205, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-indigo-700::placeholder {\n    --placeholder-opacity: 1;\n    color: #5145cd;\n    color: rgba(81, 69, 205, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-indigo-800::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #42389d;\n    color: rgba(66, 56, 157, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-indigo-800::placeholder {\n    --placeholder-opacity: 1;\n    color: #42389d;\n    color: rgba(66, 56, 157, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-indigo-900::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #362f78;\n    color: rgba(54, 47, 120, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-indigo-900::placeholder {\n    --placeholder-opacity: 1;\n    color: #362f78;\n    color: rgba(54, 47, 120, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-purple-50::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #f6f5ff;\n    color: rgba(246, 245, 255, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-purple-50::placeholder {\n    --placeholder-opacity: 1;\n    color: #f6f5ff;\n    color: rgba(246, 245, 255, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-purple-100::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #edebfe;\n    color: rgba(237, 235, 254, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-purple-100::placeholder {\n    --placeholder-opacity: 1;\n    color: #edebfe;\n    color: rgba(237, 235, 254, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-purple-200::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #dcd7fe;\n    color: rgba(220, 215, 254, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-purple-200::placeholder {\n    --placeholder-opacity: 1;\n    color: #dcd7fe;\n    color: rgba(220, 215, 254, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-purple-300::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #cabffd;\n    color: rgba(202, 191, 253, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-purple-300::placeholder {\n    --placeholder-opacity: 1;\n    color: #cabffd;\n    color: rgba(202, 191, 253, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-purple-400::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #ac94fa;\n    color: rgba(172, 148, 250, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-purple-400::placeholder {\n    --placeholder-opacity: 1;\n    color: #ac94fa;\n    color: rgba(172, 148, 250, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-purple-500::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #9061f9;\n    color: rgba(144, 97, 249, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-purple-500::placeholder {\n    --placeholder-opacity: 1;\n    color: #9061f9;\n    color: rgba(144, 97, 249, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-purple-600::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #7e3af2;\n    color: rgba(126, 58, 242, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-purple-600::placeholder {\n    --placeholder-opacity: 1;\n    color: #7e3af2;\n    color: rgba(126, 58, 242, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-purple-700::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #6c2bd9;\n    color: rgba(108, 43, 217, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-purple-700::placeholder {\n    --placeholder-opacity: 1;\n    color: #6c2bd9;\n    color: rgba(108, 43, 217, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-purple-800::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #5521b5;\n    color: rgba(85, 33, 181, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-purple-800::placeholder {\n    --placeholder-opacity: 1;\n    color: #5521b5;\n    color: rgba(85, 33, 181, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-purple-900::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #4a1d96;\n    color: rgba(74, 29, 150, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-purple-900::placeholder {\n    --placeholder-opacity: 1;\n    color: #4a1d96;\n    color: rgba(74, 29, 150, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-pink-50::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #fdf2f8;\n    color: rgba(253, 242, 248, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-pink-50::placeholder {\n    --placeholder-opacity: 1;\n    color: #fdf2f8;\n    color: rgba(253, 242, 248, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-pink-100::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #fce8f3;\n    color: rgba(252, 232, 243, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-pink-100::placeholder {\n    --placeholder-opacity: 1;\n    color: #fce8f3;\n    color: rgba(252, 232, 243, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-pink-200::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #fad1e8;\n    color: rgba(250, 209, 232, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-pink-200::placeholder {\n    --placeholder-opacity: 1;\n    color: #fad1e8;\n    color: rgba(250, 209, 232, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-pink-300::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #f8b4d9;\n    color: rgba(248, 180, 217, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-pink-300::placeholder {\n    --placeholder-opacity: 1;\n    color: #f8b4d9;\n    color: rgba(248, 180, 217, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-pink-400::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #f17eb8;\n    color: rgba(241, 126, 184, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-pink-400::placeholder {\n    --placeholder-opacity: 1;\n    color: #f17eb8;\n    color: rgba(241, 126, 184, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-pink-500::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #e74694;\n    color: rgba(231, 70, 148, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-pink-500::placeholder {\n    --placeholder-opacity: 1;\n    color: #e74694;\n    color: rgba(231, 70, 148, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-pink-600::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #d61f69;\n    color: rgba(214, 31, 105, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-pink-600::placeholder {\n    --placeholder-opacity: 1;\n    color: #d61f69;\n    color: rgba(214, 31, 105, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-pink-700::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #bf125d;\n    color: rgba(191, 18, 93, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-pink-700::placeholder {\n    --placeholder-opacity: 1;\n    color: #bf125d;\n    color: rgba(191, 18, 93, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-pink-800::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #99154b;\n    color: rgba(153, 21, 75, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-pink-800::placeholder {\n    --placeholder-opacity: 1;\n    color: #99154b;\n    color: rgba(153, 21, 75, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-pink-900::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #751a3d;\n    color: rgba(117, 26, 61, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-pink-900::placeholder {\n    --placeholder-opacity: 1;\n    color: #751a3d;\n    color: rgba(117, 26, 61, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-cool-gray-50::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #f8fafc;\n    color: rgba(248, 250, 252, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-cool-gray-50::placeholder {\n    --placeholder-opacity: 1;\n    color: #f8fafc;\n    color: rgba(248, 250, 252, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-cool-gray-100::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #f1f5f9;\n    color: rgba(241, 245, 249, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-cool-gray-100::placeholder {\n    --placeholder-opacity: 1;\n    color: #f1f5f9;\n    color: rgba(241, 245, 249, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-cool-gray-200::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #e2e8f0;\n    color: rgba(226, 232, 240, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-cool-gray-200::placeholder {\n    --placeholder-opacity: 1;\n    color: #e2e8f0;\n    color: rgba(226, 232, 240, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-cool-gray-300::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #cfd8e3;\n    color: rgba(207, 216, 227, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-cool-gray-300::placeholder {\n    --placeholder-opacity: 1;\n    color: #cfd8e3;\n    color: rgba(207, 216, 227, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-cool-gray-400::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #97a6ba;\n    color: rgba(151, 166, 186, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-cool-gray-400::placeholder {\n    --placeholder-opacity: 1;\n    color: #97a6ba;\n    color: rgba(151, 166, 186, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-cool-gray-500::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #64748b;\n    color: rgba(100, 116, 139, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-cool-gray-500::placeholder {\n    --placeholder-opacity: 1;\n    color: #64748b;\n    color: rgba(100, 116, 139, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-cool-gray-600::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #475569;\n    color: rgba(71, 85, 105, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-cool-gray-600::placeholder {\n    --placeholder-opacity: 1;\n    color: #475569;\n    color: rgba(71, 85, 105, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-cool-gray-700::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #364152;\n    color: rgba(54, 65, 82, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-cool-gray-700::placeholder {\n    --placeholder-opacity: 1;\n    color: #364152;\n    color: rgba(54, 65, 82, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-cool-gray-800::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #27303f;\n    color: rgba(39, 48, 63, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-cool-gray-800::placeholder {\n    --placeholder-opacity: 1;\n    color: #27303f;\n    color: rgba(39, 48, 63, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-cool-gray-900::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #1a202e;\n    color: rgba(26, 32, 46, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-cool-gray-900::placeholder {\n    --placeholder-opacity: 1;\n    color: #1a202e;\n    color: rgba(26, 32, 46, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-current:focus::-moz-placeholder {\n    color: currentColor;\n  }\n  .lg\\:focus\\:placeholder-current:focus::placeholder {\n    color: currentColor;\n  }\n  .lg\\:focus\\:placeholder-transparent:focus::-moz-placeholder {\n    color: transparent;\n  }\n  .lg\\:focus\\:placeholder-transparent:focus::placeholder {\n    color: transparent;\n  }\n  .lg\\:focus\\:placeholder-white:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #ffffff;\n    color: rgba(255, 255, 255, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-white:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #ffffff;\n    color: rgba(255, 255, 255, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-black:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #000000;\n    color: rgba(0, 0, 0, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-black:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #000000;\n    color: rgba(0, 0, 0, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-gray-50:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #f9fafb;\n    color: rgba(249, 250, 251, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-gray-50:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #f9fafb;\n    color: rgba(249, 250, 251, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-gray-100:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #f4f5f7;\n    color: rgba(244, 245, 247, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-gray-100:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #f4f5f7;\n    color: rgba(244, 245, 247, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-gray-200:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #e5e7eb;\n    color: rgba(229, 231, 235, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-gray-200:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #e5e7eb;\n    color: rgba(229, 231, 235, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-gray-300:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #d2d6dc;\n    color: rgba(210, 214, 220, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-gray-300:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #d2d6dc;\n    color: rgba(210, 214, 220, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-gray-400:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #9fa6b2;\n    color: rgba(159, 166, 178, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-gray-400:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #9fa6b2;\n    color: rgba(159, 166, 178, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-gray-500:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #6b7280;\n    color: rgba(107, 114, 128, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-gray-500:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #6b7280;\n    color: rgba(107, 114, 128, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-gray-600:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #4b5563;\n    color: rgba(75, 85, 99, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-gray-600:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #4b5563;\n    color: rgba(75, 85, 99, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-gray-700:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #374151;\n    color: rgba(55, 65, 81, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-gray-700:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #374151;\n    color: rgba(55, 65, 81, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-gray-800:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #252f3f;\n    color: rgba(37, 47, 63, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-gray-800:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #252f3f;\n    color: rgba(37, 47, 63, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-gray-900:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #161e2e;\n    color: rgba(22, 30, 46, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-gray-900:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #161e2e;\n    color: rgba(22, 30, 46, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-red-50:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #fdf2f2;\n    color: rgba(253, 242, 242, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-red-50:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #fdf2f2;\n    color: rgba(253, 242, 242, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-red-100:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #fde8e8;\n    color: rgba(253, 232, 232, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-red-100:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #fde8e8;\n    color: rgba(253, 232, 232, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-red-200:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #fbd5d5;\n    color: rgba(251, 213, 213, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-red-200:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #fbd5d5;\n    color: rgba(251, 213, 213, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-red-300:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #f8b4b4;\n    color: rgba(248, 180, 180, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-red-300:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #f8b4b4;\n    color: rgba(248, 180, 180, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-red-400:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #f98080;\n    color: rgba(249, 128, 128, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-red-400:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #f98080;\n    color: rgba(249, 128, 128, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-red-500:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #f05252;\n    color: rgba(240, 82, 82, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-red-500:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #f05252;\n    color: rgba(240, 82, 82, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-red-600:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #e02424;\n    color: rgba(224, 36, 36, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-red-600:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #e02424;\n    color: rgba(224, 36, 36, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-red-700:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #c81e1e;\n    color: rgba(200, 30, 30, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-red-700:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #c81e1e;\n    color: rgba(200, 30, 30, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-red-800:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #9b1c1c;\n    color: rgba(155, 28, 28, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-red-800:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #9b1c1c;\n    color: rgba(155, 28, 28, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-red-900:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #771d1d;\n    color: rgba(119, 29, 29, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-red-900:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #771d1d;\n    color: rgba(119, 29, 29, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-orange-50:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #fff8f1;\n    color: rgba(255, 248, 241, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-orange-50:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #fff8f1;\n    color: rgba(255, 248, 241, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-orange-100:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #feecdc;\n    color: rgba(254, 236, 220, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-orange-100:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #feecdc;\n    color: rgba(254, 236, 220, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-orange-200:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #fcd9bd;\n    color: rgba(252, 217, 189, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-orange-200:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #fcd9bd;\n    color: rgba(252, 217, 189, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-orange-300:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #fdba8c;\n    color: rgba(253, 186, 140, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-orange-300:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #fdba8c;\n    color: rgba(253, 186, 140, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-orange-400:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #ff8a4c;\n    color: rgba(255, 138, 76, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-orange-400:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #ff8a4c;\n    color: rgba(255, 138, 76, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-orange-500:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #ff5a1f;\n    color: rgba(255, 90, 31, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-orange-500:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #ff5a1f;\n    color: rgba(255, 90, 31, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-orange-600:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #d03801;\n    color: rgba(208, 56, 1, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-orange-600:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #d03801;\n    color: rgba(208, 56, 1, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-orange-700:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #b43403;\n    color: rgba(180, 52, 3, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-orange-700:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #b43403;\n    color: rgba(180, 52, 3, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-orange-800:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #8a2c0d;\n    color: rgba(138, 44, 13, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-orange-800:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #8a2c0d;\n    color: rgba(138, 44, 13, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-orange-900:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #73230d;\n    color: rgba(115, 35, 13, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-orange-900:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #73230d;\n    color: rgba(115, 35, 13, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-yellow-50:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #fdfdea;\n    color: rgba(253, 253, 234, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-yellow-50:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #fdfdea;\n    color: rgba(253, 253, 234, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-yellow-100:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #fdf6b2;\n    color: rgba(253, 246, 178, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-yellow-100:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #fdf6b2;\n    color: rgba(253, 246, 178, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-yellow-200:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #fce96a;\n    color: rgba(252, 233, 106, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-yellow-200:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #fce96a;\n    color: rgba(252, 233, 106, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-yellow-300:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #faca15;\n    color: rgba(250, 202, 21, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-yellow-300:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #faca15;\n    color: rgba(250, 202, 21, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-yellow-400:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #e3a008;\n    color: rgba(227, 160, 8, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-yellow-400:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #e3a008;\n    color: rgba(227, 160, 8, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-yellow-500:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #c27803;\n    color: rgba(194, 120, 3, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-yellow-500:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #c27803;\n    color: rgba(194, 120, 3, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-yellow-600:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #9f580a;\n    color: rgba(159, 88, 10, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-yellow-600:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #9f580a;\n    color: rgba(159, 88, 10, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-yellow-700:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #8e4b10;\n    color: rgba(142, 75, 16, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-yellow-700:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #8e4b10;\n    color: rgba(142, 75, 16, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-yellow-800:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #723b13;\n    color: rgba(114, 59, 19, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-yellow-800:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #723b13;\n    color: rgba(114, 59, 19, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-yellow-900:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #633112;\n    color: rgba(99, 49, 18, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-yellow-900:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #633112;\n    color: rgba(99, 49, 18, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-green-50:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #f3faf7;\n    color: rgba(243, 250, 247, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-green-50:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #f3faf7;\n    color: rgba(243, 250, 247, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-green-100:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #def7ec;\n    color: rgba(222, 247, 236, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-green-100:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #def7ec;\n    color: rgba(222, 247, 236, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-green-200:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #bcf0da;\n    color: rgba(188, 240, 218, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-green-200:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #bcf0da;\n    color: rgba(188, 240, 218, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-green-300:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #84e1bc;\n    color: rgba(132, 225, 188, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-green-300:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #84e1bc;\n    color: rgba(132, 225, 188, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-green-400:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #31c48d;\n    color: rgba(49, 196, 141, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-green-400:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #31c48d;\n    color: rgba(49, 196, 141, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-green-500:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #0e9f6e;\n    color: rgba(14, 159, 110, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-green-500:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #0e9f6e;\n    color: rgba(14, 159, 110, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-green-600:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #057a55;\n    color: rgba(5, 122, 85, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-green-600:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #057a55;\n    color: rgba(5, 122, 85, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-green-700:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #046c4e;\n    color: rgba(4, 108, 78, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-green-700:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #046c4e;\n    color: rgba(4, 108, 78, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-green-800:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #03543f;\n    color: rgba(3, 84, 63, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-green-800:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #03543f;\n    color: rgba(3, 84, 63, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-green-900:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #014737;\n    color: rgba(1, 71, 55, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-green-900:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #014737;\n    color: rgba(1, 71, 55, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-teal-50:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #edfafa;\n    color: rgba(237, 250, 250, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-teal-50:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #edfafa;\n    color: rgba(237, 250, 250, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-teal-100:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #d5f5f6;\n    color: rgba(213, 245, 246, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-teal-100:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #d5f5f6;\n    color: rgba(213, 245, 246, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-teal-200:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #afecef;\n    color: rgba(175, 236, 239, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-teal-200:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #afecef;\n    color: rgba(175, 236, 239, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-teal-300:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #7edce2;\n    color: rgba(126, 220, 226, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-teal-300:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #7edce2;\n    color: rgba(126, 220, 226, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-teal-400:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #16bdca;\n    color: rgba(22, 189, 202, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-teal-400:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #16bdca;\n    color: rgba(22, 189, 202, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-teal-500:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #0694a2;\n    color: rgba(6, 148, 162, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-teal-500:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #0694a2;\n    color: rgba(6, 148, 162, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-teal-600:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #047481;\n    color: rgba(4, 116, 129, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-teal-600:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #047481;\n    color: rgba(4, 116, 129, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-teal-700:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #036672;\n    color: rgba(3, 102, 114, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-teal-700:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #036672;\n    color: rgba(3, 102, 114, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-teal-800:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #05505c;\n    color: rgba(5, 80, 92, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-teal-800:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #05505c;\n    color: rgba(5, 80, 92, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-teal-900:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #014451;\n    color: rgba(1, 68, 81, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-teal-900:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #014451;\n    color: rgba(1, 68, 81, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-blue-50:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #ebf5ff;\n    color: rgba(235, 245, 255, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-blue-50:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #ebf5ff;\n    color: rgba(235, 245, 255, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-blue-100:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #e1effe;\n    color: rgba(225, 239, 254, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-blue-100:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #e1effe;\n    color: rgba(225, 239, 254, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-blue-200:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #c3ddfd;\n    color: rgba(195, 221, 253, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-blue-200:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #c3ddfd;\n    color: rgba(195, 221, 253, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-blue-300:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #a4cafe;\n    color: rgba(164, 202, 254, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-blue-300:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #a4cafe;\n    color: rgba(164, 202, 254, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-blue-400:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #76a9fa;\n    color: rgba(118, 169, 250, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-blue-400:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #76a9fa;\n    color: rgba(118, 169, 250, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-blue-500:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #3f83f8;\n    color: rgba(63, 131, 248, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-blue-500:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #3f83f8;\n    color: rgba(63, 131, 248, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-blue-600:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #1c64f2;\n    color: rgba(28, 100, 242, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-blue-600:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #1c64f2;\n    color: rgba(28, 100, 242, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-blue-700:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #1a56db;\n    color: rgba(26, 86, 219, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-blue-700:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #1a56db;\n    color: rgba(26, 86, 219, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-blue-800:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #1e429f;\n    color: rgba(30, 66, 159, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-blue-800:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #1e429f;\n    color: rgba(30, 66, 159, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-blue-900:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #233876;\n    color: rgba(35, 56, 118, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-blue-900:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #233876;\n    color: rgba(35, 56, 118, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-indigo-50:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #f0f5ff;\n    color: rgba(240, 245, 255, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-indigo-50:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #f0f5ff;\n    color: rgba(240, 245, 255, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-indigo-100:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #e5edff;\n    color: rgba(229, 237, 255, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-indigo-100:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #e5edff;\n    color: rgba(229, 237, 255, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-indigo-200:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #cddbfe;\n    color: rgba(205, 219, 254, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-indigo-200:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #cddbfe;\n    color: rgba(205, 219, 254, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-indigo-300:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #b4c6fc;\n    color: rgba(180, 198, 252, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-indigo-300:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #b4c6fc;\n    color: rgba(180, 198, 252, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-indigo-400:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #8da2fb;\n    color: rgba(141, 162, 251, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-indigo-400:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #8da2fb;\n    color: rgba(141, 162, 251, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-indigo-500:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #6875f5;\n    color: rgba(104, 117, 245, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-indigo-500:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #6875f5;\n    color: rgba(104, 117, 245, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-indigo-600:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #5850ec;\n    color: rgba(88, 80, 236, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-indigo-600:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #5850ec;\n    color: rgba(88, 80, 236, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-indigo-700:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #5145cd;\n    color: rgba(81, 69, 205, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-indigo-700:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #5145cd;\n    color: rgba(81, 69, 205, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-indigo-800:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #42389d;\n    color: rgba(66, 56, 157, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-indigo-800:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #42389d;\n    color: rgba(66, 56, 157, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-indigo-900:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #362f78;\n    color: rgba(54, 47, 120, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-indigo-900:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #362f78;\n    color: rgba(54, 47, 120, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-purple-50:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #f6f5ff;\n    color: rgba(246, 245, 255, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-purple-50:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #f6f5ff;\n    color: rgba(246, 245, 255, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-purple-100:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #edebfe;\n    color: rgba(237, 235, 254, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-purple-100:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #edebfe;\n    color: rgba(237, 235, 254, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-purple-200:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #dcd7fe;\n    color: rgba(220, 215, 254, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-purple-200:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #dcd7fe;\n    color: rgba(220, 215, 254, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-purple-300:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #cabffd;\n    color: rgba(202, 191, 253, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-purple-300:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #cabffd;\n    color: rgba(202, 191, 253, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-purple-400:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #ac94fa;\n    color: rgba(172, 148, 250, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-purple-400:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #ac94fa;\n    color: rgba(172, 148, 250, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-purple-500:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #9061f9;\n    color: rgba(144, 97, 249, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-purple-500:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #9061f9;\n    color: rgba(144, 97, 249, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-purple-600:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #7e3af2;\n    color: rgba(126, 58, 242, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-purple-600:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #7e3af2;\n    color: rgba(126, 58, 242, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-purple-700:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #6c2bd9;\n    color: rgba(108, 43, 217, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-purple-700:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #6c2bd9;\n    color: rgba(108, 43, 217, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-purple-800:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #5521b5;\n    color: rgba(85, 33, 181, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-purple-800:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #5521b5;\n    color: rgba(85, 33, 181, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-purple-900:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #4a1d96;\n    color: rgba(74, 29, 150, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-purple-900:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #4a1d96;\n    color: rgba(74, 29, 150, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-pink-50:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #fdf2f8;\n    color: rgba(253, 242, 248, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-pink-50:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #fdf2f8;\n    color: rgba(253, 242, 248, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-pink-100:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #fce8f3;\n    color: rgba(252, 232, 243, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-pink-100:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #fce8f3;\n    color: rgba(252, 232, 243, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-pink-200:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #fad1e8;\n    color: rgba(250, 209, 232, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-pink-200:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #fad1e8;\n    color: rgba(250, 209, 232, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-pink-300:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #f8b4d9;\n    color: rgba(248, 180, 217, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-pink-300:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #f8b4d9;\n    color: rgba(248, 180, 217, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-pink-400:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #f17eb8;\n    color: rgba(241, 126, 184, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-pink-400:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #f17eb8;\n    color: rgba(241, 126, 184, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-pink-500:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #e74694;\n    color: rgba(231, 70, 148, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-pink-500:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #e74694;\n    color: rgba(231, 70, 148, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-pink-600:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #d61f69;\n    color: rgba(214, 31, 105, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-pink-600:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #d61f69;\n    color: rgba(214, 31, 105, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-pink-700:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #bf125d;\n    color: rgba(191, 18, 93, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-pink-700:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #bf125d;\n    color: rgba(191, 18, 93, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-pink-800:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #99154b;\n    color: rgba(153, 21, 75, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-pink-800:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #99154b;\n    color: rgba(153, 21, 75, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-pink-900:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #751a3d;\n    color: rgba(117, 26, 61, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-pink-900:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #751a3d;\n    color: rgba(117, 26, 61, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-cool-gray-50:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #f8fafc;\n    color: rgba(248, 250, 252, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-cool-gray-50:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #f8fafc;\n    color: rgba(248, 250, 252, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-cool-gray-100:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #f1f5f9;\n    color: rgba(241, 245, 249, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-cool-gray-100:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #f1f5f9;\n    color: rgba(241, 245, 249, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-cool-gray-200:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #e2e8f0;\n    color: rgba(226, 232, 240, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-cool-gray-200:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #e2e8f0;\n    color: rgba(226, 232, 240, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-cool-gray-300:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #cfd8e3;\n    color: rgba(207, 216, 227, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-cool-gray-300:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #cfd8e3;\n    color: rgba(207, 216, 227, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-cool-gray-400:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #97a6ba;\n    color: rgba(151, 166, 186, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-cool-gray-400:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #97a6ba;\n    color: rgba(151, 166, 186, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-cool-gray-500:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #64748b;\n    color: rgba(100, 116, 139, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-cool-gray-500:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #64748b;\n    color: rgba(100, 116, 139, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-cool-gray-600:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #475569;\n    color: rgba(71, 85, 105, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-cool-gray-600:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #475569;\n    color: rgba(71, 85, 105, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-cool-gray-700:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #364152;\n    color: rgba(54, 65, 82, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-cool-gray-700:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #364152;\n    color: rgba(54, 65, 82, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-cool-gray-800:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #27303f;\n    color: rgba(39, 48, 63, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-cool-gray-800:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #27303f;\n    color: rgba(39, 48, 63, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-cool-gray-900:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #1a202e;\n    color: rgba(26, 32, 46, var(--placeholder-opacity));\n  }\n  .lg\\:focus\\:placeholder-cool-gray-900:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #1a202e;\n    color: rgba(26, 32, 46, var(--placeholder-opacity));\n  }\n  .lg\\:placeholder-opacity-0::-moz-placeholder {\n    --placeholder-opacity: 0;\n  }\n  .lg\\:placeholder-opacity-0::placeholder {\n    --placeholder-opacity: 0;\n  }\n  .lg\\:placeholder-opacity-25::-moz-placeholder {\n    --placeholder-opacity: 0.25;\n  }\n  .lg\\:placeholder-opacity-25::placeholder {\n    --placeholder-opacity: 0.25;\n  }\n  .lg\\:placeholder-opacity-50::-moz-placeholder {\n    --placeholder-opacity: 0.5;\n  }\n  .lg\\:placeholder-opacity-50::placeholder {\n    --placeholder-opacity: 0.5;\n  }\n  .lg\\:placeholder-opacity-75::-moz-placeholder {\n    --placeholder-opacity: 0.75;\n  }\n  .lg\\:placeholder-opacity-75::placeholder {\n    --placeholder-opacity: 0.75;\n  }\n  .lg\\:placeholder-opacity-100::-moz-placeholder {\n    --placeholder-opacity: 1;\n  }\n  .lg\\:placeholder-opacity-100::placeholder {\n    --placeholder-opacity: 1;\n  }\n  .lg\\:focus\\:placeholder-opacity-0:focus::-moz-placeholder {\n    --placeholder-opacity: 0;\n  }\n  .lg\\:focus\\:placeholder-opacity-0:focus::placeholder {\n    --placeholder-opacity: 0;\n  }\n  .lg\\:focus\\:placeholder-opacity-25:focus::-moz-placeholder {\n    --placeholder-opacity: 0.25;\n  }\n  .lg\\:focus\\:placeholder-opacity-25:focus::placeholder {\n    --placeholder-opacity: 0.25;\n  }\n  .lg\\:focus\\:placeholder-opacity-50:focus::-moz-placeholder {\n    --placeholder-opacity: 0.5;\n  }\n  .lg\\:focus\\:placeholder-opacity-50:focus::placeholder {\n    --placeholder-opacity: 0.5;\n  }\n  .lg\\:focus\\:placeholder-opacity-75:focus::-moz-placeholder {\n    --placeholder-opacity: 0.75;\n  }\n  .lg\\:focus\\:placeholder-opacity-75:focus::placeholder {\n    --placeholder-opacity: 0.75;\n  }\n  .lg\\:focus\\:placeholder-opacity-100:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n  }\n  .lg\\:focus\\:placeholder-opacity-100:focus::placeholder {\n    --placeholder-opacity: 1;\n  }\n  .lg\\:pointer-events-none {\n    pointer-events: none;\n  }\n  .lg\\:pointer-events-auto {\n    pointer-events: auto;\n  }\n  .lg\\:static {\n    position: static;\n  }\n  .lg\\:fixed {\n    position: fixed;\n  }\n  .lg\\:absolute {\n    position: absolute;\n  }\n  .lg\\:relative {\n    position: relative;\n  }\n  .lg\\:sticky {\n    position: sticky;\n  }\n  .lg\\:inset-0 {\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n  }\n  .lg\\:inset-1 {\n    top: 0.25rem;\n    right: 0.25rem;\n    bottom: 0.25rem;\n    left: 0.25rem;\n  }\n  .lg\\:inset-2 {\n    top: 0.5rem;\n    right: 0.5rem;\n    bottom: 0.5rem;\n    left: 0.5rem;\n  }\n  .lg\\:inset-3 {\n    top: 0.75rem;\n    right: 0.75rem;\n    bottom: 0.75rem;\n    left: 0.75rem;\n  }\n  .lg\\:inset-4 {\n    top: 1rem;\n    right: 1rem;\n    bottom: 1rem;\n    left: 1rem;\n  }\n  .lg\\:inset-5 {\n    top: 1.25rem;\n    right: 1.25rem;\n    bottom: 1.25rem;\n    left: 1.25rem;\n  }\n  .lg\\:inset-6 {\n    top: 1.5rem;\n    right: 1.5rem;\n    bottom: 1.5rem;\n    left: 1.5rem;\n  }\n  .lg\\:inset-7 {\n    top: 1.75rem;\n    right: 1.75rem;\n    bottom: 1.75rem;\n    left: 1.75rem;\n  }\n  .lg\\:inset-8 {\n    top: 2rem;\n    right: 2rem;\n    bottom: 2rem;\n    left: 2rem;\n  }\n  .lg\\:inset-9 {\n    top: 2.25rem;\n    right: 2.25rem;\n    bottom: 2.25rem;\n    left: 2.25rem;\n  }\n  .lg\\:inset-10 {\n    top: 2.5rem;\n    right: 2.5rem;\n    bottom: 2.5rem;\n    left: 2.5rem;\n  }\n  .lg\\:inset-11 {\n    top: 2.75rem;\n    right: 2.75rem;\n    bottom: 2.75rem;\n    left: 2.75rem;\n  }\n  .lg\\:inset-12 {\n    top: 3rem;\n    right: 3rem;\n    bottom: 3rem;\n    left: 3rem;\n  }\n  .lg\\:inset-13 {\n    top: 3.25rem;\n    right: 3.25rem;\n    bottom: 3.25rem;\n    left: 3.25rem;\n  }\n  .lg\\:inset-14 {\n    top: 3.5rem;\n    right: 3.5rem;\n    bottom: 3.5rem;\n    left: 3.5rem;\n  }\n  .lg\\:inset-15 {\n    top: 3.75rem;\n    right: 3.75rem;\n    bottom: 3.75rem;\n    left: 3.75rem;\n  }\n  .lg\\:inset-16 {\n    top: 4rem;\n    right: 4rem;\n    bottom: 4rem;\n    left: 4rem;\n  }\n  .lg\\:inset-20 {\n    top: 5rem;\n    right: 5rem;\n    bottom: 5rem;\n    left: 5rem;\n  }\n  .lg\\:inset-24 {\n    top: 6rem;\n    right: 6rem;\n    bottom: 6rem;\n    left: 6rem;\n  }\n  .lg\\:inset-28 {\n    top: 7rem;\n    right: 7rem;\n    bottom: 7rem;\n    left: 7rem;\n  }\n  .lg\\:inset-32 {\n    top: 8rem;\n    right: 8rem;\n    bottom: 8rem;\n    left: 8rem;\n  }\n  .lg\\:inset-36 {\n    top: 9rem;\n    right: 9rem;\n    bottom: 9rem;\n    left: 9rem;\n  }\n  .lg\\:inset-40 {\n    top: 10rem;\n    right: 10rem;\n    bottom: 10rem;\n    left: 10rem;\n  }\n  .lg\\:inset-44 {\n    top: 11rem;\n    right: 11rem;\n    bottom: 11rem;\n    left: 11rem;\n  }\n  .lg\\:inset-48 {\n    top: 12rem;\n    right: 12rem;\n    bottom: 12rem;\n    left: 12rem;\n  }\n  .lg\\:inset-52 {\n    top: 13rem;\n    right: 13rem;\n    bottom: 13rem;\n    left: 13rem;\n  }\n  .lg\\:inset-56 {\n    top: 14rem;\n    right: 14rem;\n    bottom: 14rem;\n    left: 14rem;\n  }\n  .lg\\:inset-60 {\n    top: 15rem;\n    right: 15rem;\n    bottom: 15rem;\n    left: 15rem;\n  }\n  .lg\\:inset-64 {\n    top: 16rem;\n    right: 16rem;\n    bottom: 16rem;\n    left: 16rem;\n  }\n  .lg\\:inset-72 {\n    top: 18rem;\n    right: 18rem;\n    bottom: 18rem;\n    left: 18rem;\n  }\n  .lg\\:inset-80 {\n    top: 20rem;\n    right: 20rem;\n    bottom: 20rem;\n    left: 20rem;\n  }\n  .lg\\:inset-96 {\n    top: 24rem;\n    right: 24rem;\n    bottom: 24rem;\n    left: 24rem;\n  }\n  .lg\\:inset-auto {\n    top: auto;\n    right: auto;\n    bottom: auto;\n    left: auto;\n  }\n  .lg\\:inset-px {\n    top: 1px;\n    right: 1px;\n    bottom: 1px;\n    left: 1px;\n  }\n  .lg\\:inset-0\\.5 {\n    top: 0.125rem;\n    right: 0.125rem;\n    bottom: 0.125rem;\n    left: 0.125rem;\n  }\n  .lg\\:inset-1\\.5 {\n    top: 0.375rem;\n    right: 0.375rem;\n    bottom: 0.375rem;\n    left: 0.375rem;\n  }\n  .lg\\:inset-2\\.5 {\n    top: 0.625rem;\n    right: 0.625rem;\n    bottom: 0.625rem;\n    left: 0.625rem;\n  }\n  .lg\\:inset-3\\.5 {\n    top: 0.875rem;\n    right: 0.875rem;\n    bottom: 0.875rem;\n    left: 0.875rem;\n  }\n  .lg\\:inset-1\\/2 {\n    top: 50%;\n    right: 50%;\n    bottom: 50%;\n    left: 50%;\n  }\n  .lg\\:inset-1\\/3 {\n    top: 33.333333%;\n    right: 33.333333%;\n    bottom: 33.333333%;\n    left: 33.333333%;\n  }\n  .lg\\:inset-2\\/3 {\n    top: 66.666667%;\n    right: 66.666667%;\n    bottom: 66.666667%;\n    left: 66.666667%;\n  }\n  .lg\\:inset-1\\/4 {\n    top: 25%;\n    right: 25%;\n    bottom: 25%;\n    left: 25%;\n  }\n  .lg\\:inset-2\\/4 {\n    top: 50%;\n    right: 50%;\n    bottom: 50%;\n    left: 50%;\n  }\n  .lg\\:inset-3\\/4 {\n    top: 75%;\n    right: 75%;\n    bottom: 75%;\n    left: 75%;\n  }\n  .lg\\:inset-1\\/5 {\n    top: 20%;\n    right: 20%;\n    bottom: 20%;\n    left: 20%;\n  }\n  .lg\\:inset-2\\/5 {\n    top: 40%;\n    right: 40%;\n    bottom: 40%;\n    left: 40%;\n  }\n  .lg\\:inset-3\\/5 {\n    top: 60%;\n    right: 60%;\n    bottom: 60%;\n    left: 60%;\n  }\n  .lg\\:inset-4\\/5 {\n    top: 80%;\n    right: 80%;\n    bottom: 80%;\n    left: 80%;\n  }\n  .lg\\:inset-1\\/6 {\n    top: 16.666667%;\n    right: 16.666667%;\n    bottom: 16.666667%;\n    left: 16.666667%;\n  }\n  .lg\\:inset-2\\/6 {\n    top: 33.333333%;\n    right: 33.333333%;\n    bottom: 33.333333%;\n    left: 33.333333%;\n  }\n  .lg\\:inset-3\\/6 {\n    top: 50%;\n    right: 50%;\n    bottom: 50%;\n    left: 50%;\n  }\n  .lg\\:inset-4\\/6 {\n    top: 66.666667%;\n    right: 66.666667%;\n    bottom: 66.666667%;\n    left: 66.666667%;\n  }\n  .lg\\:inset-5\\/6 {\n    top: 83.333333%;\n    right: 83.333333%;\n    bottom: 83.333333%;\n    left: 83.333333%;\n  }\n  .lg\\:inset-1\\/12 {\n    top: 8.333333%;\n    right: 8.333333%;\n    bottom: 8.333333%;\n    left: 8.333333%;\n  }\n  .lg\\:inset-2\\/12 {\n    top: 16.666667%;\n    right: 16.666667%;\n    bottom: 16.666667%;\n    left: 16.666667%;\n  }\n  .lg\\:inset-3\\/12 {\n    top: 25%;\n    right: 25%;\n    bottom: 25%;\n    left: 25%;\n  }\n  .lg\\:inset-4\\/12 {\n    top: 33.333333%;\n    right: 33.333333%;\n    bottom: 33.333333%;\n    left: 33.333333%;\n  }\n  .lg\\:inset-5\\/12 {\n    top: 41.666667%;\n    right: 41.666667%;\n    bottom: 41.666667%;\n    left: 41.666667%;\n  }\n  .lg\\:inset-6\\/12 {\n    top: 50%;\n    right: 50%;\n    bottom: 50%;\n    left: 50%;\n  }\n  .lg\\:inset-7\\/12 {\n    top: 58.333333%;\n    right: 58.333333%;\n    bottom: 58.333333%;\n    left: 58.333333%;\n  }\n  .lg\\:inset-8\\/12 {\n    top: 66.666667%;\n    right: 66.666667%;\n    bottom: 66.666667%;\n    left: 66.666667%;\n  }\n  .lg\\:inset-9\\/12 {\n    top: 75%;\n    right: 75%;\n    bottom: 75%;\n    left: 75%;\n  }\n  .lg\\:inset-10\\/12 {\n    top: 83.333333%;\n    right: 83.333333%;\n    bottom: 83.333333%;\n    left: 83.333333%;\n  }\n  .lg\\:inset-11\\/12 {\n    top: 91.666667%;\n    right: 91.666667%;\n    bottom: 91.666667%;\n    left: 91.666667%;\n  }\n  .lg\\:inset-full {\n    top: 100%;\n    right: 100%;\n    bottom: 100%;\n    left: 100%;\n  }\n  .lg\\:inset-y-0 {\n    top: 0;\n    bottom: 0;\n  }\n  .lg\\:inset-x-0 {\n    right: 0;\n    left: 0;\n  }\n  .lg\\:inset-y-1 {\n    top: 0.25rem;\n    bottom: 0.25rem;\n  }\n  .lg\\:inset-x-1 {\n    right: 0.25rem;\n    left: 0.25rem;\n  }\n  .lg\\:inset-y-2 {\n    top: 0.5rem;\n    bottom: 0.5rem;\n  }\n  .lg\\:inset-x-2 {\n    right: 0.5rem;\n    left: 0.5rem;\n  }\n  .lg\\:inset-y-3 {\n    top: 0.75rem;\n    bottom: 0.75rem;\n  }\n  .lg\\:inset-x-3 {\n    right: 0.75rem;\n    left: 0.75rem;\n  }\n  .lg\\:inset-y-4 {\n    top: 1rem;\n    bottom: 1rem;\n  }\n  .lg\\:inset-x-4 {\n    right: 1rem;\n    left: 1rem;\n  }\n  .lg\\:inset-y-5 {\n    top: 1.25rem;\n    bottom: 1.25rem;\n  }\n  .lg\\:inset-x-5 {\n    right: 1.25rem;\n    left: 1.25rem;\n  }\n  .lg\\:inset-y-6 {\n    top: 1.5rem;\n    bottom: 1.5rem;\n  }\n  .lg\\:inset-x-6 {\n    right: 1.5rem;\n    left: 1.5rem;\n  }\n  .lg\\:inset-y-7 {\n    top: 1.75rem;\n    bottom: 1.75rem;\n  }\n  .lg\\:inset-x-7 {\n    right: 1.75rem;\n    left: 1.75rem;\n  }\n  .lg\\:inset-y-8 {\n    top: 2rem;\n    bottom: 2rem;\n  }\n  .lg\\:inset-x-8 {\n    right: 2rem;\n    left: 2rem;\n  }\n  .lg\\:inset-y-9 {\n    top: 2.25rem;\n    bottom: 2.25rem;\n  }\n  .lg\\:inset-x-9 {\n    right: 2.25rem;\n    left: 2.25rem;\n  }\n  .lg\\:inset-y-10 {\n    top: 2.5rem;\n    bottom: 2.5rem;\n  }\n  .lg\\:inset-x-10 {\n    right: 2.5rem;\n    left: 2.5rem;\n  }\n  .lg\\:inset-y-11 {\n    top: 2.75rem;\n    bottom: 2.75rem;\n  }\n  .lg\\:inset-x-11 {\n    right: 2.75rem;\n    left: 2.75rem;\n  }\n  .lg\\:inset-y-12 {\n    top: 3rem;\n    bottom: 3rem;\n  }\n  .lg\\:inset-x-12 {\n    right: 3rem;\n    left: 3rem;\n  }\n  .lg\\:inset-y-13 {\n    top: 3.25rem;\n    bottom: 3.25rem;\n  }\n  .lg\\:inset-x-13 {\n    right: 3.25rem;\n    left: 3.25rem;\n  }\n  .lg\\:inset-y-14 {\n    top: 3.5rem;\n    bottom: 3.5rem;\n  }\n  .lg\\:inset-x-14 {\n    right: 3.5rem;\n    left: 3.5rem;\n  }\n  .lg\\:inset-y-15 {\n    top: 3.75rem;\n    bottom: 3.75rem;\n  }\n  .lg\\:inset-x-15 {\n    right: 3.75rem;\n    left: 3.75rem;\n  }\n  .lg\\:inset-y-16 {\n    top: 4rem;\n    bottom: 4rem;\n  }\n  .lg\\:inset-x-16 {\n    right: 4rem;\n    left: 4rem;\n  }\n  .lg\\:inset-y-20 {\n    top: 5rem;\n    bottom: 5rem;\n  }\n  .lg\\:inset-x-20 {\n    right: 5rem;\n    left: 5rem;\n  }\n  .lg\\:inset-y-24 {\n    top: 6rem;\n    bottom: 6rem;\n  }\n  .lg\\:inset-x-24 {\n    right: 6rem;\n    left: 6rem;\n  }\n  .lg\\:inset-y-28 {\n    top: 7rem;\n    bottom: 7rem;\n  }\n  .lg\\:inset-x-28 {\n    right: 7rem;\n    left: 7rem;\n  }\n  .lg\\:inset-y-32 {\n    top: 8rem;\n    bottom: 8rem;\n  }\n  .lg\\:inset-x-32 {\n    right: 8rem;\n    left: 8rem;\n  }\n  .lg\\:inset-y-36 {\n    top: 9rem;\n    bottom: 9rem;\n  }\n  .lg\\:inset-x-36 {\n    right: 9rem;\n    left: 9rem;\n  }\n  .lg\\:inset-y-40 {\n    top: 10rem;\n    bottom: 10rem;\n  }\n  .lg\\:inset-x-40 {\n    right: 10rem;\n    left: 10rem;\n  }\n  .lg\\:inset-y-44 {\n    top: 11rem;\n    bottom: 11rem;\n  }\n  .lg\\:inset-x-44 {\n    right: 11rem;\n    left: 11rem;\n  }\n  .lg\\:inset-y-48 {\n    top: 12rem;\n    bottom: 12rem;\n  }\n  .lg\\:inset-x-48 {\n    right: 12rem;\n    left: 12rem;\n  }\n  .lg\\:inset-y-52 {\n    top: 13rem;\n    bottom: 13rem;\n  }\n  .lg\\:inset-x-52 {\n    right: 13rem;\n    left: 13rem;\n  }\n  .lg\\:inset-y-56 {\n    top: 14rem;\n    bottom: 14rem;\n  }\n  .lg\\:inset-x-56 {\n    right: 14rem;\n    left: 14rem;\n  }\n  .lg\\:inset-y-60 {\n    top: 15rem;\n    bottom: 15rem;\n  }\n  .lg\\:inset-x-60 {\n    right: 15rem;\n    left: 15rem;\n  }\n  .lg\\:inset-y-64 {\n    top: 16rem;\n    bottom: 16rem;\n  }\n  .lg\\:inset-x-64 {\n    right: 16rem;\n    left: 16rem;\n  }\n  .lg\\:inset-y-72 {\n    top: 18rem;\n    bottom: 18rem;\n  }\n  .lg\\:inset-x-72 {\n    right: 18rem;\n    left: 18rem;\n  }\n  .lg\\:inset-y-80 {\n    top: 20rem;\n    bottom: 20rem;\n  }\n  .lg\\:inset-x-80 {\n    right: 20rem;\n    left: 20rem;\n  }\n  .lg\\:inset-y-96 {\n    top: 24rem;\n    bottom: 24rem;\n  }\n  .lg\\:inset-x-96 {\n    right: 24rem;\n    left: 24rem;\n  }\n  .lg\\:inset-y-auto {\n    top: auto;\n    bottom: auto;\n  }\n  .lg\\:inset-x-auto {\n    right: auto;\n    left: auto;\n  }\n  .lg\\:inset-y-px {\n    top: 1px;\n    bottom: 1px;\n  }\n  .lg\\:inset-x-px {\n    right: 1px;\n    left: 1px;\n  }\n  .lg\\:inset-y-0\\.5 {\n    top: 0.125rem;\n    bottom: 0.125rem;\n  }\n  .lg\\:inset-x-0\\.5 {\n    right: 0.125rem;\n    left: 0.125rem;\n  }\n  .lg\\:inset-y-1\\.5 {\n    top: 0.375rem;\n    bottom: 0.375rem;\n  }\n  .lg\\:inset-x-1\\.5 {\n    right: 0.375rem;\n    left: 0.375rem;\n  }\n  .lg\\:inset-y-2\\.5 {\n    top: 0.625rem;\n    bottom: 0.625rem;\n  }\n  .lg\\:inset-x-2\\.5 {\n    right: 0.625rem;\n    left: 0.625rem;\n  }\n  .lg\\:inset-y-3\\.5 {\n    top: 0.875rem;\n    bottom: 0.875rem;\n  }\n  .lg\\:inset-x-3\\.5 {\n    right: 0.875rem;\n    left: 0.875rem;\n  }\n  .lg\\:inset-y-1\\/2 {\n    top: 50%;\n    bottom: 50%;\n  }\n  .lg\\:inset-x-1\\/2 {\n    right: 50%;\n    left: 50%;\n  }\n  .lg\\:inset-y-1\\/3 {\n    top: 33.333333%;\n    bottom: 33.333333%;\n  }\n  .lg\\:inset-x-1\\/3 {\n    right: 33.333333%;\n    left: 33.333333%;\n  }\n  .lg\\:inset-y-2\\/3 {\n    top: 66.666667%;\n    bottom: 66.666667%;\n  }\n  .lg\\:inset-x-2\\/3 {\n    right: 66.666667%;\n    left: 66.666667%;\n  }\n  .lg\\:inset-y-1\\/4 {\n    top: 25%;\n    bottom: 25%;\n  }\n  .lg\\:inset-x-1\\/4 {\n    right: 25%;\n    left: 25%;\n  }\n  .lg\\:inset-y-2\\/4 {\n    top: 50%;\n    bottom: 50%;\n  }\n  .lg\\:inset-x-2\\/4 {\n    right: 50%;\n    left: 50%;\n  }\n  .lg\\:inset-y-3\\/4 {\n    top: 75%;\n    bottom: 75%;\n  }\n  .lg\\:inset-x-3\\/4 {\n    right: 75%;\n    left: 75%;\n  }\n  .lg\\:inset-y-1\\/5 {\n    top: 20%;\n    bottom: 20%;\n  }\n  .lg\\:inset-x-1\\/5 {\n    right: 20%;\n    left: 20%;\n  }\n  .lg\\:inset-y-2\\/5 {\n    top: 40%;\n    bottom: 40%;\n  }\n  .lg\\:inset-x-2\\/5 {\n    right: 40%;\n    left: 40%;\n  }\n  .lg\\:inset-y-3\\/5 {\n    top: 60%;\n    bottom: 60%;\n  }\n  .lg\\:inset-x-3\\/5 {\n    right: 60%;\n    left: 60%;\n  }\n  .lg\\:inset-y-4\\/5 {\n    top: 80%;\n    bottom: 80%;\n  }\n  .lg\\:inset-x-4\\/5 {\n    right: 80%;\n    left: 80%;\n  }\n  .lg\\:inset-y-1\\/6 {\n    top: 16.666667%;\n    bottom: 16.666667%;\n  }\n  .lg\\:inset-x-1\\/6 {\n    right: 16.666667%;\n    left: 16.666667%;\n  }\n  .lg\\:inset-y-2\\/6 {\n    top: 33.333333%;\n    bottom: 33.333333%;\n  }\n  .lg\\:inset-x-2\\/6 {\n    right: 33.333333%;\n    left: 33.333333%;\n  }\n  .lg\\:inset-y-3\\/6 {\n    top: 50%;\n    bottom: 50%;\n  }\n  .lg\\:inset-x-3\\/6 {\n    right: 50%;\n    left: 50%;\n  }\n  .lg\\:inset-y-4\\/6 {\n    top: 66.666667%;\n    bottom: 66.666667%;\n  }\n  .lg\\:inset-x-4\\/6 {\n    right: 66.666667%;\n    left: 66.666667%;\n  }\n  .lg\\:inset-y-5\\/6 {\n    top: 83.333333%;\n    bottom: 83.333333%;\n  }\n  .lg\\:inset-x-5\\/6 {\n    right: 83.333333%;\n    left: 83.333333%;\n  }\n  .lg\\:inset-y-1\\/12 {\n    top: 8.333333%;\n    bottom: 8.333333%;\n  }\n  .lg\\:inset-x-1\\/12 {\n    right: 8.333333%;\n    left: 8.333333%;\n  }\n  .lg\\:inset-y-2\\/12 {\n    top: 16.666667%;\n    bottom: 16.666667%;\n  }\n  .lg\\:inset-x-2\\/12 {\n    right: 16.666667%;\n    left: 16.666667%;\n  }\n  .lg\\:inset-y-3\\/12 {\n    top: 25%;\n    bottom: 25%;\n  }\n  .lg\\:inset-x-3\\/12 {\n    right: 25%;\n    left: 25%;\n  }\n  .lg\\:inset-y-4\\/12 {\n    top: 33.333333%;\n    bottom: 33.333333%;\n  }\n  .lg\\:inset-x-4\\/12 {\n    right: 33.333333%;\n    left: 33.333333%;\n  }\n  .lg\\:inset-y-5\\/12 {\n    top: 41.666667%;\n    bottom: 41.666667%;\n  }\n  .lg\\:inset-x-5\\/12 {\n    right: 41.666667%;\n    left: 41.666667%;\n  }\n  .lg\\:inset-y-6\\/12 {\n    top: 50%;\n    bottom: 50%;\n  }\n  .lg\\:inset-x-6\\/12 {\n    right: 50%;\n    left: 50%;\n  }\n  .lg\\:inset-y-7\\/12 {\n    top: 58.333333%;\n    bottom: 58.333333%;\n  }\n  .lg\\:inset-x-7\\/12 {\n    right: 58.333333%;\n    left: 58.333333%;\n  }\n  .lg\\:inset-y-8\\/12 {\n    top: 66.666667%;\n    bottom: 66.666667%;\n  }\n  .lg\\:inset-x-8\\/12 {\n    right: 66.666667%;\n    left: 66.666667%;\n  }\n  .lg\\:inset-y-9\\/12 {\n    top: 75%;\n    bottom: 75%;\n  }\n  .lg\\:inset-x-9\\/12 {\n    right: 75%;\n    left: 75%;\n  }\n  .lg\\:inset-y-10\\/12 {\n    top: 83.333333%;\n    bottom: 83.333333%;\n  }\n  .lg\\:inset-x-10\\/12 {\n    right: 83.333333%;\n    left: 83.333333%;\n  }\n  .lg\\:inset-y-11\\/12 {\n    top: 91.666667%;\n    bottom: 91.666667%;\n  }\n  .lg\\:inset-x-11\\/12 {\n    right: 91.666667%;\n    left: 91.666667%;\n  }\n  .lg\\:inset-y-full {\n    top: 100%;\n    bottom: 100%;\n  }\n  .lg\\:inset-x-full {\n    right: 100%;\n    left: 100%;\n  }\n  .lg\\:top-0 {\n    top: 0;\n  }\n  .lg\\:right-0 {\n    right: 0;\n  }\n  .lg\\:bottom-0 {\n    bottom: 0;\n  }\n  .lg\\:left-0 {\n    left: 0;\n  }\n  .lg\\:top-1 {\n    top: 0.25rem;\n  }\n  .lg\\:right-1 {\n    right: 0.25rem;\n  }\n  .lg\\:bottom-1 {\n    bottom: 0.25rem;\n  }\n  .lg\\:left-1 {\n    left: 0.25rem;\n  }\n  .lg\\:top-2 {\n    top: 0.5rem;\n  }\n  .lg\\:right-2 {\n    right: 0.5rem;\n  }\n  .lg\\:bottom-2 {\n    bottom: 0.5rem;\n  }\n  .lg\\:left-2 {\n    left: 0.5rem;\n  }\n  .lg\\:top-3 {\n    top: 0.75rem;\n  }\n  .lg\\:right-3 {\n    right: 0.75rem;\n  }\n  .lg\\:bottom-3 {\n    bottom: 0.75rem;\n  }\n  .lg\\:left-3 {\n    left: 0.75rem;\n  }\n  .lg\\:top-4 {\n    top: 1rem;\n  }\n  .lg\\:right-4 {\n    right: 1rem;\n  }\n  .lg\\:bottom-4 {\n    bottom: 1rem;\n  }\n  .lg\\:left-4 {\n    left: 1rem;\n  }\n  .lg\\:top-5 {\n    top: 1.25rem;\n  }\n  .lg\\:right-5 {\n    right: 1.25rem;\n  }\n  .lg\\:bottom-5 {\n    bottom: 1.25rem;\n  }\n  .lg\\:left-5 {\n    left: 1.25rem;\n  }\n  .lg\\:top-6 {\n    top: 1.5rem;\n  }\n  .lg\\:right-6 {\n    right: 1.5rem;\n  }\n  .lg\\:bottom-6 {\n    bottom: 1.5rem;\n  }\n  .lg\\:left-6 {\n    left: 1.5rem;\n  }\n  .lg\\:top-7 {\n    top: 1.75rem;\n  }\n  .lg\\:right-7 {\n    right: 1.75rem;\n  }\n  .lg\\:bottom-7 {\n    bottom: 1.75rem;\n  }\n  .lg\\:left-7 {\n    left: 1.75rem;\n  }\n  .lg\\:top-8 {\n    top: 2rem;\n  }\n  .lg\\:right-8 {\n    right: 2rem;\n  }\n  .lg\\:bottom-8 {\n    bottom: 2rem;\n  }\n  .lg\\:left-8 {\n    left: 2rem;\n  }\n  .lg\\:top-9 {\n    top: 2.25rem;\n  }\n  .lg\\:right-9 {\n    right: 2.25rem;\n  }\n  .lg\\:bottom-9 {\n    bottom: 2.25rem;\n  }\n  .lg\\:left-9 {\n    left: 2.25rem;\n  }\n  .lg\\:top-10 {\n    top: 2.5rem;\n  }\n  .lg\\:right-10 {\n    right: 2.5rem;\n  }\n  .lg\\:bottom-10 {\n    bottom: 2.5rem;\n  }\n  .lg\\:left-10 {\n    left: 2.5rem;\n  }\n  .lg\\:top-11 {\n    top: 2.75rem;\n  }\n  .lg\\:right-11 {\n    right: 2.75rem;\n  }\n  .lg\\:bottom-11 {\n    bottom: 2.75rem;\n  }\n  .lg\\:left-11 {\n    left: 2.75rem;\n  }\n  .lg\\:top-12 {\n    top: 3rem;\n  }\n  .lg\\:right-12 {\n    right: 3rem;\n  }\n  .lg\\:bottom-12 {\n    bottom: 3rem;\n  }\n  .lg\\:left-12 {\n    left: 3rem;\n  }\n  .lg\\:top-13 {\n    top: 3.25rem;\n  }\n  .lg\\:right-13 {\n    right: 3.25rem;\n  }\n  .lg\\:bottom-13 {\n    bottom: 3.25rem;\n  }\n  .lg\\:left-13 {\n    left: 3.25rem;\n  }\n  .lg\\:top-14 {\n    top: 3.5rem;\n  }\n  .lg\\:right-14 {\n    right: 3.5rem;\n  }\n  .lg\\:bottom-14 {\n    bottom: 3.5rem;\n  }\n  .lg\\:left-14 {\n    left: 3.5rem;\n  }\n  .lg\\:top-15 {\n    top: 3.75rem;\n  }\n  .lg\\:right-15 {\n    right: 3.75rem;\n  }\n  .lg\\:bottom-15 {\n    bottom: 3.75rem;\n  }\n  .lg\\:left-15 {\n    left: 3.75rem;\n  }\n  .lg\\:top-16 {\n    top: 4rem;\n  }\n  .lg\\:right-16 {\n    right: 4rem;\n  }\n  .lg\\:bottom-16 {\n    bottom: 4rem;\n  }\n  .lg\\:left-16 {\n    left: 4rem;\n  }\n  .lg\\:top-20 {\n    top: 5rem;\n  }\n  .lg\\:right-20 {\n    right: 5rem;\n  }\n  .lg\\:bottom-20 {\n    bottom: 5rem;\n  }\n  .lg\\:left-20 {\n    left: 5rem;\n  }\n  .lg\\:top-24 {\n    top: 6rem;\n  }\n  .lg\\:right-24 {\n    right: 6rem;\n  }\n  .lg\\:bottom-24 {\n    bottom: 6rem;\n  }\n  .lg\\:left-24 {\n    left: 6rem;\n  }\n  .lg\\:top-28 {\n    top: 7rem;\n  }\n  .lg\\:right-28 {\n    right: 7rem;\n  }\n  .lg\\:bottom-28 {\n    bottom: 7rem;\n  }\n  .lg\\:left-28 {\n    left: 7rem;\n  }\n  .lg\\:top-32 {\n    top: 8rem;\n  }\n  .lg\\:right-32 {\n    right: 8rem;\n  }\n  .lg\\:bottom-32 {\n    bottom: 8rem;\n  }\n  .lg\\:left-32 {\n    left: 8rem;\n  }\n  .lg\\:top-36 {\n    top: 9rem;\n  }\n  .lg\\:right-36 {\n    right: 9rem;\n  }\n  .lg\\:bottom-36 {\n    bottom: 9rem;\n  }\n  .lg\\:left-36 {\n    left: 9rem;\n  }\n  .lg\\:top-40 {\n    top: 10rem;\n  }\n  .lg\\:right-40 {\n    right: 10rem;\n  }\n  .lg\\:bottom-40 {\n    bottom: 10rem;\n  }\n  .lg\\:left-40 {\n    left: 10rem;\n  }\n  .lg\\:top-44 {\n    top: 11rem;\n  }\n  .lg\\:right-44 {\n    right: 11rem;\n  }\n  .lg\\:bottom-44 {\n    bottom: 11rem;\n  }\n  .lg\\:left-44 {\n    left: 11rem;\n  }\n  .lg\\:top-48 {\n    top: 12rem;\n  }\n  .lg\\:right-48 {\n    right: 12rem;\n  }\n  .lg\\:bottom-48 {\n    bottom: 12rem;\n  }\n  .lg\\:left-48 {\n    left: 12rem;\n  }\n  .lg\\:top-52 {\n    top: 13rem;\n  }\n  .lg\\:right-52 {\n    right: 13rem;\n  }\n  .lg\\:bottom-52 {\n    bottom: 13rem;\n  }\n  .lg\\:left-52 {\n    left: 13rem;\n  }\n  .lg\\:top-56 {\n    top: 14rem;\n  }\n  .lg\\:right-56 {\n    right: 14rem;\n  }\n  .lg\\:bottom-56 {\n    bottom: 14rem;\n  }\n  .lg\\:left-56 {\n    left: 14rem;\n  }\n  .lg\\:top-60 {\n    top: 15rem;\n  }\n  .lg\\:right-60 {\n    right: 15rem;\n  }\n  .lg\\:bottom-60 {\n    bottom: 15rem;\n  }\n  .lg\\:left-60 {\n    left: 15rem;\n  }\n  .lg\\:top-64 {\n    top: 16rem;\n  }\n  .lg\\:right-64 {\n    right: 16rem;\n  }\n  .lg\\:bottom-64 {\n    bottom: 16rem;\n  }\n  .lg\\:left-64 {\n    left: 16rem;\n  }\n  .lg\\:top-72 {\n    top: 18rem;\n  }\n  .lg\\:right-72 {\n    right: 18rem;\n  }\n  .lg\\:bottom-72 {\n    bottom: 18rem;\n  }\n  .lg\\:left-72 {\n    left: 18rem;\n  }\n  .lg\\:top-80 {\n    top: 20rem;\n  }\n  .lg\\:right-80 {\n    right: 20rem;\n  }\n  .lg\\:bottom-80 {\n    bottom: 20rem;\n  }\n  .lg\\:left-80 {\n    left: 20rem;\n  }\n  .lg\\:top-96 {\n    top: 24rem;\n  }\n  .lg\\:right-96 {\n    right: 24rem;\n  }\n  .lg\\:bottom-96 {\n    bottom: 24rem;\n  }\n  .lg\\:left-96 {\n    left: 24rem;\n  }\n  .lg\\:top-auto {\n    top: auto;\n  }\n  .lg\\:right-auto {\n    right: auto;\n  }\n  .lg\\:bottom-auto {\n    bottom: auto;\n  }\n  .lg\\:left-auto {\n    left: auto;\n  }\n  .lg\\:top-px {\n    top: 1px;\n  }\n  .lg\\:right-px {\n    right: 1px;\n  }\n  .lg\\:bottom-px {\n    bottom: 1px;\n  }\n  .lg\\:left-px {\n    left: 1px;\n  }\n  .lg\\:top-0\\.5 {\n    top: 0.125rem;\n  }\n  .lg\\:right-0\\.5 {\n    right: 0.125rem;\n  }\n  .lg\\:bottom-0\\.5 {\n    bottom: 0.125rem;\n  }\n  .lg\\:left-0\\.5 {\n    left: 0.125rem;\n  }\n  .lg\\:top-1\\.5 {\n    top: 0.375rem;\n  }\n  .lg\\:right-1\\.5 {\n    right: 0.375rem;\n  }\n  .lg\\:bottom-1\\.5 {\n    bottom: 0.375rem;\n  }\n  .lg\\:left-1\\.5 {\n    left: 0.375rem;\n  }\n  .lg\\:top-2\\.5 {\n    top: 0.625rem;\n  }\n  .lg\\:right-2\\.5 {\n    right: 0.625rem;\n  }\n  .lg\\:bottom-2\\.5 {\n    bottom: 0.625rem;\n  }\n  .lg\\:left-2\\.5 {\n    left: 0.625rem;\n  }\n  .lg\\:top-3\\.5 {\n    top: 0.875rem;\n  }\n  .lg\\:right-3\\.5 {\n    right: 0.875rem;\n  }\n  .lg\\:bottom-3\\.5 {\n    bottom: 0.875rem;\n  }\n  .lg\\:left-3\\.5 {\n    left: 0.875rem;\n  }\n  .lg\\:top-1\\/2 {\n    top: 50%;\n  }\n  .lg\\:right-1\\/2 {\n    right: 50%;\n  }\n  .lg\\:bottom-1\\/2 {\n    bottom: 50%;\n  }\n  .lg\\:left-1\\/2 {\n    left: 50%;\n  }\n  .lg\\:top-1\\/3 {\n    top: 33.333333%;\n  }\n  .lg\\:right-1\\/3 {\n    right: 33.333333%;\n  }\n  .lg\\:bottom-1\\/3 {\n    bottom: 33.333333%;\n  }\n  .lg\\:left-1\\/3 {\n    left: 33.333333%;\n  }\n  .lg\\:top-2\\/3 {\n    top: 66.666667%;\n  }\n  .lg\\:right-2\\/3 {\n    right: 66.666667%;\n  }\n  .lg\\:bottom-2\\/3 {\n    bottom: 66.666667%;\n  }\n  .lg\\:left-2\\/3 {\n    left: 66.666667%;\n  }\n  .lg\\:top-1\\/4 {\n    top: 25%;\n  }\n  .lg\\:right-1\\/4 {\n    right: 25%;\n  }\n  .lg\\:bottom-1\\/4 {\n    bottom: 25%;\n  }\n  .lg\\:left-1\\/4 {\n    left: 25%;\n  }\n  .lg\\:top-2\\/4 {\n    top: 50%;\n  }\n  .lg\\:right-2\\/4 {\n    right: 50%;\n  }\n  .lg\\:bottom-2\\/4 {\n    bottom: 50%;\n  }\n  .lg\\:left-2\\/4 {\n    left: 50%;\n  }\n  .lg\\:top-3\\/4 {\n    top: 75%;\n  }\n  .lg\\:right-3\\/4 {\n    right: 75%;\n  }\n  .lg\\:bottom-3\\/4 {\n    bottom: 75%;\n  }\n  .lg\\:left-3\\/4 {\n    left: 75%;\n  }\n  .lg\\:top-1\\/5 {\n    top: 20%;\n  }\n  .lg\\:right-1\\/5 {\n    right: 20%;\n  }\n  .lg\\:bottom-1\\/5 {\n    bottom: 20%;\n  }\n  .lg\\:left-1\\/5 {\n    left: 20%;\n  }\n  .lg\\:top-2\\/5 {\n    top: 40%;\n  }\n  .lg\\:right-2\\/5 {\n    right: 40%;\n  }\n  .lg\\:bottom-2\\/5 {\n    bottom: 40%;\n  }\n  .lg\\:left-2\\/5 {\n    left: 40%;\n  }\n  .lg\\:top-3\\/5 {\n    top: 60%;\n  }\n  .lg\\:right-3\\/5 {\n    right: 60%;\n  }\n  .lg\\:bottom-3\\/5 {\n    bottom: 60%;\n  }\n  .lg\\:left-3\\/5 {\n    left: 60%;\n  }\n  .lg\\:top-4\\/5 {\n    top: 80%;\n  }\n  .lg\\:right-4\\/5 {\n    right: 80%;\n  }\n  .lg\\:bottom-4\\/5 {\n    bottom: 80%;\n  }\n  .lg\\:left-4\\/5 {\n    left: 80%;\n  }\n  .lg\\:top-1\\/6 {\n    top: 16.666667%;\n  }\n  .lg\\:right-1\\/6 {\n    right: 16.666667%;\n  }\n  .lg\\:bottom-1\\/6 {\n    bottom: 16.666667%;\n  }\n  .lg\\:left-1\\/6 {\n    left: 16.666667%;\n  }\n  .lg\\:top-2\\/6 {\n    top: 33.333333%;\n  }\n  .lg\\:right-2\\/6 {\n    right: 33.333333%;\n  }\n  .lg\\:bottom-2\\/6 {\n    bottom: 33.333333%;\n  }\n  .lg\\:left-2\\/6 {\n    left: 33.333333%;\n  }\n  .lg\\:top-3\\/6 {\n    top: 50%;\n  }\n  .lg\\:right-3\\/6 {\n    right: 50%;\n  }\n  .lg\\:bottom-3\\/6 {\n    bottom: 50%;\n  }\n  .lg\\:left-3\\/6 {\n    left: 50%;\n  }\n  .lg\\:top-4\\/6 {\n    top: 66.666667%;\n  }\n  .lg\\:right-4\\/6 {\n    right: 66.666667%;\n  }\n  .lg\\:bottom-4\\/6 {\n    bottom: 66.666667%;\n  }\n  .lg\\:left-4\\/6 {\n    left: 66.666667%;\n  }\n  .lg\\:top-5\\/6 {\n    top: 83.333333%;\n  }\n  .lg\\:right-5\\/6 {\n    right: 83.333333%;\n  }\n  .lg\\:bottom-5\\/6 {\n    bottom: 83.333333%;\n  }\n  .lg\\:left-5\\/6 {\n    left: 83.333333%;\n  }\n  .lg\\:top-1\\/12 {\n    top: 8.333333%;\n  }\n  .lg\\:right-1\\/12 {\n    right: 8.333333%;\n  }\n  .lg\\:bottom-1\\/12 {\n    bottom: 8.333333%;\n  }\n  .lg\\:left-1\\/12 {\n    left: 8.333333%;\n  }\n  .lg\\:top-2\\/12 {\n    top: 16.666667%;\n  }\n  .lg\\:right-2\\/12 {\n    right: 16.666667%;\n  }\n  .lg\\:bottom-2\\/12 {\n    bottom: 16.666667%;\n  }\n  .lg\\:left-2\\/12 {\n    left: 16.666667%;\n  }\n  .lg\\:top-3\\/12 {\n    top: 25%;\n  }\n  .lg\\:right-3\\/12 {\n    right: 25%;\n  }\n  .lg\\:bottom-3\\/12 {\n    bottom: 25%;\n  }\n  .lg\\:left-3\\/12 {\n    left: 25%;\n  }\n  .lg\\:top-4\\/12 {\n    top: 33.333333%;\n  }\n  .lg\\:right-4\\/12 {\n    right: 33.333333%;\n  }\n  .lg\\:bottom-4\\/12 {\n    bottom: 33.333333%;\n  }\n  .lg\\:left-4\\/12 {\n    left: 33.333333%;\n  }\n  .lg\\:top-5\\/12 {\n    top: 41.666667%;\n  }\n  .lg\\:right-5\\/12 {\n    right: 41.666667%;\n  }\n  .lg\\:bottom-5\\/12 {\n    bottom: 41.666667%;\n  }\n  .lg\\:left-5\\/12 {\n    left: 41.666667%;\n  }\n  .lg\\:top-6\\/12 {\n    top: 50%;\n  }\n  .lg\\:right-6\\/12 {\n    right: 50%;\n  }\n  .lg\\:bottom-6\\/12 {\n    bottom: 50%;\n  }\n  .lg\\:left-6\\/12 {\n    left: 50%;\n  }\n  .lg\\:top-7\\/12 {\n    top: 58.333333%;\n  }\n  .lg\\:right-7\\/12 {\n    right: 58.333333%;\n  }\n  .lg\\:bottom-7\\/12 {\n    bottom: 58.333333%;\n  }\n  .lg\\:left-7\\/12 {\n    left: 58.333333%;\n  }\n  .lg\\:top-8\\/12 {\n    top: 66.666667%;\n  }\n  .lg\\:right-8\\/12 {\n    right: 66.666667%;\n  }\n  .lg\\:bottom-8\\/12 {\n    bottom: 66.666667%;\n  }\n  .lg\\:left-8\\/12 {\n    left: 66.666667%;\n  }\n  .lg\\:top-9\\/12 {\n    top: 75%;\n  }\n  .lg\\:right-9\\/12 {\n    right: 75%;\n  }\n  .lg\\:bottom-9\\/12 {\n    bottom: 75%;\n  }\n  .lg\\:left-9\\/12 {\n    left: 75%;\n  }\n  .lg\\:top-10\\/12 {\n    top: 83.333333%;\n  }\n  .lg\\:right-10\\/12 {\n    right: 83.333333%;\n  }\n  .lg\\:bottom-10\\/12 {\n    bottom: 83.333333%;\n  }\n  .lg\\:left-10\\/12 {\n    left: 83.333333%;\n  }\n  .lg\\:top-11\\/12 {\n    top: 91.666667%;\n  }\n  .lg\\:right-11\\/12 {\n    right: 91.666667%;\n  }\n  .lg\\:bottom-11\\/12 {\n    bottom: 91.666667%;\n  }\n  .lg\\:left-11\\/12 {\n    left: 91.666667%;\n  }\n  .lg\\:top-full {\n    top: 100%;\n  }\n  .lg\\:right-full {\n    right: 100%;\n  }\n  .lg\\:bottom-full {\n    bottom: 100%;\n  }\n  .lg\\:left-full {\n    left: 100%;\n  }\n  .lg\\:resize-none {\n    resize: none;\n  }\n  .lg\\:resize-y {\n    resize: vertical;\n  }\n  .lg\\:resize-x {\n    resize: horizontal;\n  }\n  .lg\\:resize {\n    resize: both;\n  }\n  .lg\\:shadow-xs {\n    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.05);\n  }\n  .lg\\:shadow-sm {\n    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);\n  }\n  .lg\\:shadow {\n    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);\n  }\n  .lg\\:shadow-md {\n    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);\n  }\n  .lg\\:shadow-lg {\n    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);\n  }\n  .lg\\:shadow-xl {\n    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);\n  }\n  .lg\\:shadow-2xl {\n    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);\n  }\n  .lg\\:shadow-inner {\n    box-shadow: inset 0 2px 4px 0 rgba(0, 0, 0, 0.06);\n  }\n  .lg\\:shadow-outline {\n    box-shadow: 0 0 0 3px rgba(118, 169, 250, 0.45);\n  }\n  .lg\\:shadow-none {\n    box-shadow: none;\n  }\n  .lg\\:shadow-solid {\n    box-shadow: 0 0 0 2px currentColor;\n  }\n  .lg\\:shadow-outline-gray {\n    box-shadow: 0 0 0 3px rgba(159, 166, 178, 0.45);\n  }\n  .lg\\:shadow-outline-blue {\n    box-shadow: 0 0 0 3px rgba(164, 202, 254, 0.45);\n  }\n  .lg\\:shadow-outline-teal {\n    box-shadow: 0 0 0 3px rgba(126, 220, 226, 0.45);\n  }\n  .lg\\:shadow-outline-green {\n    box-shadow: 0 0 0 3px rgba(132, 225, 188, 0.45);\n  }\n  .lg\\:shadow-outline-yellow {\n    box-shadow: 0 0 0 3px rgba(250, 202, 21, 0.45);\n  }\n  .lg\\:shadow-outline-orange {\n    box-shadow: 0 0 0 3px rgba(253, 186, 140, 0.45);\n  }\n  .lg\\:shadow-outline-red {\n    box-shadow: 0 0 0 3px rgba(248, 180, 180, 0.45);\n  }\n  .lg\\:shadow-outline-pink {\n    box-shadow: 0 0 0 3px rgba(248, 180, 217, 0.45);\n  }\n  .lg\\:shadow-outline-purple {\n    box-shadow: 0 0 0 3px rgba(202, 191, 253, 0.45);\n  }\n  .lg\\:shadow-outline-indigo {\n    box-shadow: 0 0 0 3px rgba(180, 198, 252, 0.45);\n  }\n  .group:focus .lg\\:group-focus\\:shadow-xs {\n    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.05);\n  }\n  .group:focus .lg\\:group-focus\\:shadow-sm {\n    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);\n  }\n  .group:focus .lg\\:group-focus\\:shadow {\n    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);\n  }\n  .group:focus .lg\\:group-focus\\:shadow-md {\n    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);\n  }\n  .group:focus .lg\\:group-focus\\:shadow-lg {\n    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);\n  }\n  .group:focus .lg\\:group-focus\\:shadow-xl {\n    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);\n  }\n  .group:focus .lg\\:group-focus\\:shadow-2xl {\n    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);\n  }\n  .group:focus .lg\\:group-focus\\:shadow-inner {\n    box-shadow: inset 0 2px 4px 0 rgba(0, 0, 0, 0.06);\n  }\n  .group:focus .lg\\:group-focus\\:shadow-outline {\n    box-shadow: 0 0 0 3px rgba(118, 169, 250, 0.45);\n  }\n  .group:focus .lg\\:group-focus\\:shadow-none {\n    box-shadow: none;\n  }\n  .group:focus .lg\\:group-focus\\:shadow-solid {\n    box-shadow: 0 0 0 2px currentColor;\n  }\n  .group:focus .lg\\:group-focus\\:shadow-outline-gray {\n    box-shadow: 0 0 0 3px rgba(159, 166, 178, 0.45);\n  }\n  .group:focus .lg\\:group-focus\\:shadow-outline-blue {\n    box-shadow: 0 0 0 3px rgba(164, 202, 254, 0.45);\n  }\n  .group:focus .lg\\:group-focus\\:shadow-outline-teal {\n    box-shadow: 0 0 0 3px rgba(126, 220, 226, 0.45);\n  }\n  .group:focus .lg\\:group-focus\\:shadow-outline-green {\n    box-shadow: 0 0 0 3px rgba(132, 225, 188, 0.45);\n  }\n  .group:focus .lg\\:group-focus\\:shadow-outline-yellow {\n    box-shadow: 0 0 0 3px rgba(250, 202, 21, 0.45);\n  }\n  .group:focus .lg\\:group-focus\\:shadow-outline-orange {\n    box-shadow: 0 0 0 3px rgba(253, 186, 140, 0.45);\n  }\n  .group:focus .lg\\:group-focus\\:shadow-outline-red {\n    box-shadow: 0 0 0 3px rgba(248, 180, 180, 0.45);\n  }\n  .group:focus .lg\\:group-focus\\:shadow-outline-pink {\n    box-shadow: 0 0 0 3px rgba(248, 180, 217, 0.45);\n  }\n  .group:focus .lg\\:group-focus\\:shadow-outline-purple {\n    box-shadow: 0 0 0 3px rgba(202, 191, 253, 0.45);\n  }\n  .group:focus .lg\\:group-focus\\:shadow-outline-indigo {\n    box-shadow: 0 0 0 3px rgba(180, 198, 252, 0.45);\n  }\n  .lg\\:hover\\:shadow-xs:hover {\n    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.05);\n  }\n  .lg\\:hover\\:shadow-sm:hover {\n    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);\n  }\n  .lg\\:hover\\:shadow:hover {\n    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);\n  }\n  .lg\\:hover\\:shadow-md:hover {\n    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);\n  }\n  .lg\\:hover\\:shadow-lg:hover {\n    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);\n  }\n  .lg\\:hover\\:shadow-xl:hover {\n    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);\n  }\n  .lg\\:hover\\:shadow-2xl:hover {\n    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);\n  }\n  .lg\\:hover\\:shadow-inner:hover {\n    box-shadow: inset 0 2px 4px 0 rgba(0, 0, 0, 0.06);\n  }\n  .lg\\:hover\\:shadow-outline:hover {\n    box-shadow: 0 0 0 3px rgba(118, 169, 250, 0.45);\n  }\n  .lg\\:hover\\:shadow-none:hover {\n    box-shadow: none;\n  }\n  .lg\\:hover\\:shadow-solid:hover {\n    box-shadow: 0 0 0 2px currentColor;\n  }\n  .lg\\:hover\\:shadow-outline-gray:hover {\n    box-shadow: 0 0 0 3px rgba(159, 166, 178, 0.45);\n  }\n  .lg\\:hover\\:shadow-outline-blue:hover {\n    box-shadow: 0 0 0 3px rgba(164, 202, 254, 0.45);\n  }\n  .lg\\:hover\\:shadow-outline-teal:hover {\n    box-shadow: 0 0 0 3px rgba(126, 220, 226, 0.45);\n  }\n  .lg\\:hover\\:shadow-outline-green:hover {\n    box-shadow: 0 0 0 3px rgba(132, 225, 188, 0.45);\n  }\n  .lg\\:hover\\:shadow-outline-yellow:hover {\n    box-shadow: 0 0 0 3px rgba(250, 202, 21, 0.45);\n  }\n  .lg\\:hover\\:shadow-outline-orange:hover {\n    box-shadow: 0 0 0 3px rgba(253, 186, 140, 0.45);\n  }\n  .lg\\:hover\\:shadow-outline-red:hover {\n    box-shadow: 0 0 0 3px rgba(248, 180, 180, 0.45);\n  }\n  .lg\\:hover\\:shadow-outline-pink:hover {\n    box-shadow: 0 0 0 3px rgba(248, 180, 217, 0.45);\n  }\n  .lg\\:hover\\:shadow-outline-purple:hover {\n    box-shadow: 0 0 0 3px rgba(202, 191, 253, 0.45);\n  }\n  .lg\\:hover\\:shadow-outline-indigo:hover {\n    box-shadow: 0 0 0 3px rgba(180, 198, 252, 0.45);\n  }\n  .lg\\:focus-within\\:shadow-xs:focus-within {\n    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.05);\n  }\n  .lg\\:focus-within\\:shadow-sm:focus-within {\n    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);\n  }\n  .lg\\:focus-within\\:shadow:focus-within {\n    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);\n  }\n  .lg\\:focus-within\\:shadow-md:focus-within {\n    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);\n  }\n  .lg\\:focus-within\\:shadow-lg:focus-within {\n    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);\n  }\n  .lg\\:focus-within\\:shadow-xl:focus-within {\n    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);\n  }\n  .lg\\:focus-within\\:shadow-2xl:focus-within {\n    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);\n  }\n  .lg\\:focus-within\\:shadow-inner:focus-within {\n    box-shadow: inset 0 2px 4px 0 rgba(0, 0, 0, 0.06);\n  }\n  .lg\\:focus-within\\:shadow-outline:focus-within {\n    box-shadow: 0 0 0 3px rgba(118, 169, 250, 0.45);\n  }\n  .lg\\:focus-within\\:shadow-none:focus-within {\n    box-shadow: none;\n  }\n  .lg\\:focus-within\\:shadow-solid:focus-within {\n    box-shadow: 0 0 0 2px currentColor;\n  }\n  .lg\\:focus-within\\:shadow-outline-gray:focus-within {\n    box-shadow: 0 0 0 3px rgba(159, 166, 178, 0.45);\n  }\n  .lg\\:focus-within\\:shadow-outline-blue:focus-within {\n    box-shadow: 0 0 0 3px rgba(164, 202, 254, 0.45);\n  }\n  .lg\\:focus-within\\:shadow-outline-teal:focus-within {\n    box-shadow: 0 0 0 3px rgba(126, 220, 226, 0.45);\n  }\n  .lg\\:focus-within\\:shadow-outline-green:focus-within {\n    box-shadow: 0 0 0 3px rgba(132, 225, 188, 0.45);\n  }\n  .lg\\:focus-within\\:shadow-outline-yellow:focus-within {\n    box-shadow: 0 0 0 3px rgba(250, 202, 21, 0.45);\n  }\n  .lg\\:focus-within\\:shadow-outline-orange:focus-within {\n    box-shadow: 0 0 0 3px rgba(253, 186, 140, 0.45);\n  }\n  .lg\\:focus-within\\:shadow-outline-red:focus-within {\n    box-shadow: 0 0 0 3px rgba(248, 180, 180, 0.45);\n  }\n  .lg\\:focus-within\\:shadow-outline-pink:focus-within {\n    box-shadow: 0 0 0 3px rgba(248, 180, 217, 0.45);\n  }\n  .lg\\:focus-within\\:shadow-outline-purple:focus-within {\n    box-shadow: 0 0 0 3px rgba(202, 191, 253, 0.45);\n  }\n  .lg\\:focus-within\\:shadow-outline-indigo:focus-within {\n    box-shadow: 0 0 0 3px rgba(180, 198, 252, 0.45);\n  }\n  .lg\\:focus\\:shadow-xs:focus {\n    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.05);\n  }\n  .lg\\:focus\\:shadow-sm:focus {\n    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);\n  }\n  .lg\\:focus\\:shadow:focus {\n    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);\n  }\n  .lg\\:focus\\:shadow-md:focus {\n    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);\n  }\n  .lg\\:focus\\:shadow-lg:focus {\n    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);\n  }\n  .lg\\:focus\\:shadow-xl:focus {\n    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);\n  }\n  .lg\\:focus\\:shadow-2xl:focus {\n    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);\n  }\n  .lg\\:focus\\:shadow-inner:focus {\n    box-shadow: inset 0 2px 4px 0 rgba(0, 0, 0, 0.06);\n  }\n  .lg\\:focus\\:shadow-outline:focus {\n    box-shadow: 0 0 0 3px rgba(118, 169, 250, 0.45);\n  }\n  .lg\\:focus\\:shadow-none:focus {\n    box-shadow: none;\n  }\n  .lg\\:focus\\:shadow-solid:focus {\n    box-shadow: 0 0 0 2px currentColor;\n  }\n  .lg\\:focus\\:shadow-outline-gray:focus {\n    box-shadow: 0 0 0 3px rgba(159, 166, 178, 0.45);\n  }\n  .lg\\:focus\\:shadow-outline-blue:focus {\n    box-shadow: 0 0 0 3px rgba(164, 202, 254, 0.45);\n  }\n  .lg\\:focus\\:shadow-outline-teal:focus {\n    box-shadow: 0 0 0 3px rgba(126, 220, 226, 0.45);\n  }\n  .lg\\:focus\\:shadow-outline-green:focus {\n    box-shadow: 0 0 0 3px rgba(132, 225, 188, 0.45);\n  }\n  .lg\\:focus\\:shadow-outline-yellow:focus {\n    box-shadow: 0 0 0 3px rgba(250, 202, 21, 0.45);\n  }\n  .lg\\:focus\\:shadow-outline-orange:focus {\n    box-shadow: 0 0 0 3px rgba(253, 186, 140, 0.45);\n  }\n  .lg\\:focus\\:shadow-outline-red:focus {\n    box-shadow: 0 0 0 3px rgba(248, 180, 180, 0.45);\n  }\n  .lg\\:focus\\:shadow-outline-pink:focus {\n    box-shadow: 0 0 0 3px rgba(248, 180, 217, 0.45);\n  }\n  .lg\\:focus\\:shadow-outline-purple:focus {\n    box-shadow: 0 0 0 3px rgba(202, 191, 253, 0.45);\n  }\n  .lg\\:focus\\:shadow-outline-indigo:focus {\n    box-shadow: 0 0 0 3px rgba(180, 198, 252, 0.45);\n  }\n  .lg\\:fill-current {\n    fill: currentColor;\n  }\n  .lg\\:stroke-current {\n    stroke: currentColor;\n  }\n  .lg\\:stroke-0 {\n    stroke-width: 0;\n  }\n  .lg\\:stroke-1 {\n    stroke-width: 1;\n  }\n  .lg\\:stroke-2 {\n    stroke-width: 2;\n  }\n  .lg\\:table-auto {\n    table-layout: auto;\n  }\n  .lg\\:table-fixed {\n    table-layout: fixed;\n  }\n  .lg\\:text-left {\n    text-align: left;\n  }\n  .lg\\:text-center {\n    text-align: center;\n  }\n  .lg\\:text-right {\n    text-align: right;\n  }\n  .lg\\:text-justify {\n    text-align: justify;\n  }\n  .lg\\:text-current {\n    color: currentColor;\n  }\n  .lg\\:text-transparent {\n    color: transparent;\n  }\n  .lg\\:text-white {\n    --text-opacity: 1;\n    color: #ffffff;\n    color: rgba(255, 255, 255, var(--text-opacity));\n  }\n  .lg\\:text-black {\n    --text-opacity: 1;\n    color: #000000;\n    color: rgba(0, 0, 0, var(--text-opacity));\n  }\n  .lg\\:text-gray-50 {\n    --text-opacity: 1;\n    color: #f9fafb;\n    color: rgba(249, 250, 251, var(--text-opacity));\n  }\n  .lg\\:text-gray-100 {\n    --text-opacity: 1;\n    color: #f4f5f7;\n    color: rgba(244, 245, 247, var(--text-opacity));\n  }\n  .lg\\:text-gray-200 {\n    --text-opacity: 1;\n    color: #e5e7eb;\n    color: rgba(229, 231, 235, var(--text-opacity));\n  }\n  .lg\\:text-gray-300 {\n    --text-opacity: 1;\n    color: #d2d6dc;\n    color: rgba(210, 214, 220, var(--text-opacity));\n  }\n  .lg\\:text-gray-400 {\n    --text-opacity: 1;\n    color: #9fa6b2;\n    color: rgba(159, 166, 178, var(--text-opacity));\n  }\n  .lg\\:text-gray-500 {\n    --text-opacity: 1;\n    color: #6b7280;\n    color: rgba(107, 114, 128, var(--text-opacity));\n  }\n  .lg\\:text-gray-600 {\n    --text-opacity: 1;\n    color: #4b5563;\n    color: rgba(75, 85, 99, var(--text-opacity));\n  }\n  .lg\\:text-gray-700 {\n    --text-opacity: 1;\n    color: #374151;\n    color: rgba(55, 65, 81, var(--text-opacity));\n  }\n  .lg\\:text-gray-800 {\n    --text-opacity: 1;\n    color: #252f3f;\n    color: rgba(37, 47, 63, var(--text-opacity));\n  }\n  .lg\\:text-gray-900 {\n    --text-opacity: 1;\n    color: #161e2e;\n    color: rgba(22, 30, 46, var(--text-opacity));\n  }\n  .lg\\:text-red-50 {\n    --text-opacity: 1;\n    color: #fdf2f2;\n    color: rgba(253, 242, 242, var(--text-opacity));\n  }\n  .lg\\:text-red-100 {\n    --text-opacity: 1;\n    color: #fde8e8;\n    color: rgba(253, 232, 232, var(--text-opacity));\n  }\n  .lg\\:text-red-200 {\n    --text-opacity: 1;\n    color: #fbd5d5;\n    color: rgba(251, 213, 213, var(--text-opacity));\n  }\n  .lg\\:text-red-300 {\n    --text-opacity: 1;\n    color: #f8b4b4;\n    color: rgba(248, 180, 180, var(--text-opacity));\n  }\n  .lg\\:text-red-400 {\n    --text-opacity: 1;\n    color: #f98080;\n    color: rgba(249, 128, 128, var(--text-opacity));\n  }\n  .lg\\:text-red-500 {\n    --text-opacity: 1;\n    color: #f05252;\n    color: rgba(240, 82, 82, var(--text-opacity));\n  }\n  .lg\\:text-red-600 {\n    --text-opacity: 1;\n    color: #e02424;\n    color: rgba(224, 36, 36, var(--text-opacity));\n  }\n  .lg\\:text-red-700 {\n    --text-opacity: 1;\n    color: #c81e1e;\n    color: rgba(200, 30, 30, var(--text-opacity));\n  }\n  .lg\\:text-red-800 {\n    --text-opacity: 1;\n    color: #9b1c1c;\n    color: rgba(155, 28, 28, var(--text-opacity));\n  }\n  .lg\\:text-red-900 {\n    --text-opacity: 1;\n    color: #771d1d;\n    color: rgba(119, 29, 29, var(--text-opacity));\n  }\n  .lg\\:text-orange-50 {\n    --text-opacity: 1;\n    color: #fff8f1;\n    color: rgba(255, 248, 241, var(--text-opacity));\n  }\n  .lg\\:text-orange-100 {\n    --text-opacity: 1;\n    color: #feecdc;\n    color: rgba(254, 236, 220, var(--text-opacity));\n  }\n  .lg\\:text-orange-200 {\n    --text-opacity: 1;\n    color: #fcd9bd;\n    color: rgba(252, 217, 189, var(--text-opacity));\n  }\n  .lg\\:text-orange-300 {\n    --text-opacity: 1;\n    color: #fdba8c;\n    color: rgba(253, 186, 140, var(--text-opacity));\n  }\n  .lg\\:text-orange-400 {\n    --text-opacity: 1;\n    color: #ff8a4c;\n    color: rgba(255, 138, 76, var(--text-opacity));\n  }\n  .lg\\:text-orange-500 {\n    --text-opacity: 1;\n    color: #ff5a1f;\n    color: rgba(255, 90, 31, var(--text-opacity));\n  }\n  .lg\\:text-orange-600 {\n    --text-opacity: 1;\n    color: #d03801;\n    color: rgba(208, 56, 1, var(--text-opacity));\n  }\n  .lg\\:text-orange-700 {\n    --text-opacity: 1;\n    color: #b43403;\n    color: rgba(180, 52, 3, var(--text-opacity));\n  }\n  .lg\\:text-orange-800 {\n    --text-opacity: 1;\n    color: #8a2c0d;\n    color: rgba(138, 44, 13, var(--text-opacity));\n  }\n  .lg\\:text-orange-900 {\n    --text-opacity: 1;\n    color: #73230d;\n    color: rgba(115, 35, 13, var(--text-opacity));\n  }\n  .lg\\:text-yellow-50 {\n    --text-opacity: 1;\n    color: #fdfdea;\n    color: rgba(253, 253, 234, var(--text-opacity));\n  }\n  .lg\\:text-yellow-100 {\n    --text-opacity: 1;\n    color: #fdf6b2;\n    color: rgba(253, 246, 178, var(--text-opacity));\n  }\n  .lg\\:text-yellow-200 {\n    --text-opacity: 1;\n    color: #fce96a;\n    color: rgba(252, 233, 106, var(--text-opacity));\n  }\n  .lg\\:text-yellow-300 {\n    --text-opacity: 1;\n    color: #faca15;\n    color: rgba(250, 202, 21, var(--text-opacity));\n  }\n  .lg\\:text-yellow-400 {\n    --text-opacity: 1;\n    color: #e3a008;\n    color: rgba(227, 160, 8, var(--text-opacity));\n  }\n  .lg\\:text-yellow-500 {\n    --text-opacity: 1;\n    color: #c27803;\n    color: rgba(194, 120, 3, var(--text-opacity));\n  }\n  .lg\\:text-yellow-600 {\n    --text-opacity: 1;\n    color: #9f580a;\n    color: rgba(159, 88, 10, var(--text-opacity));\n  }\n  .lg\\:text-yellow-700 {\n    --text-opacity: 1;\n    color: #8e4b10;\n    color: rgba(142, 75, 16, var(--text-opacity));\n  }\n  .lg\\:text-yellow-800 {\n    --text-opacity: 1;\n    color: #723b13;\n    color: rgba(114, 59, 19, var(--text-opacity));\n  }\n  .lg\\:text-yellow-900 {\n    --text-opacity: 1;\n    color: #633112;\n    color: rgba(99, 49, 18, var(--text-opacity));\n  }\n  .lg\\:text-green-50 {\n    --text-opacity: 1;\n    color: #f3faf7;\n    color: rgba(243, 250, 247, var(--text-opacity));\n  }\n  .lg\\:text-green-100 {\n    --text-opacity: 1;\n    color: #def7ec;\n    color: rgba(222, 247, 236, var(--text-opacity));\n  }\n  .lg\\:text-green-200 {\n    --text-opacity: 1;\n    color: #bcf0da;\n    color: rgba(188, 240, 218, var(--text-opacity));\n  }\n  .lg\\:text-green-300 {\n    --text-opacity: 1;\n    color: #84e1bc;\n    color: rgba(132, 225, 188, var(--text-opacity));\n  }\n  .lg\\:text-green-400 {\n    --text-opacity: 1;\n    color: #31c48d;\n    color: rgba(49, 196, 141, var(--text-opacity));\n  }\n  .lg\\:text-green-500 {\n    --text-opacity: 1;\n    color: #0e9f6e;\n    color: rgba(14, 159, 110, var(--text-opacity));\n  }\n  .lg\\:text-green-600 {\n    --text-opacity: 1;\n    color: #057a55;\n    color: rgba(5, 122, 85, var(--text-opacity));\n  }\n  .lg\\:text-green-700 {\n    --text-opacity: 1;\n    color: #046c4e;\n    color: rgba(4, 108, 78, var(--text-opacity));\n  }\n  .lg\\:text-green-800 {\n    --text-opacity: 1;\n    color: #03543f;\n    color: rgba(3, 84, 63, var(--text-opacity));\n  }\n  .lg\\:text-green-900 {\n    --text-opacity: 1;\n    color: #014737;\n    color: rgba(1, 71, 55, var(--text-opacity));\n  }\n  .lg\\:text-teal-50 {\n    --text-opacity: 1;\n    color: #edfafa;\n    color: rgba(237, 250, 250, var(--text-opacity));\n  }\n  .lg\\:text-teal-100 {\n    --text-opacity: 1;\n    color: #d5f5f6;\n    color: rgba(213, 245, 246, var(--text-opacity));\n  }\n  .lg\\:text-teal-200 {\n    --text-opacity: 1;\n    color: #afecef;\n    color: rgba(175, 236, 239, var(--text-opacity));\n  }\n  .lg\\:text-teal-300 {\n    --text-opacity: 1;\n    color: #7edce2;\n    color: rgba(126, 220, 226, var(--text-opacity));\n  }\n  .lg\\:text-teal-400 {\n    --text-opacity: 1;\n    color: #16bdca;\n    color: rgba(22, 189, 202, var(--text-opacity));\n  }\n  .lg\\:text-teal-500 {\n    --text-opacity: 1;\n    color: #0694a2;\n    color: rgba(6, 148, 162, var(--text-opacity));\n  }\n  .lg\\:text-teal-600 {\n    --text-opacity: 1;\n    color: #047481;\n    color: rgba(4, 116, 129, var(--text-opacity));\n  }\n  .lg\\:text-teal-700 {\n    --text-opacity: 1;\n    color: #036672;\n    color: rgba(3, 102, 114, var(--text-opacity));\n  }\n  .lg\\:text-teal-800 {\n    --text-opacity: 1;\n    color: #05505c;\n    color: rgba(5, 80, 92, var(--text-opacity));\n  }\n  .lg\\:text-teal-900 {\n    --text-opacity: 1;\n    color: #014451;\n    color: rgba(1, 68, 81, var(--text-opacity));\n  }\n  .lg\\:text-blue-50 {\n    --text-opacity: 1;\n    color: #ebf5ff;\n    color: rgba(235, 245, 255, var(--text-opacity));\n  }\n  .lg\\:text-blue-100 {\n    --text-opacity: 1;\n    color: #e1effe;\n    color: rgba(225, 239, 254, var(--text-opacity));\n  }\n  .lg\\:text-blue-200 {\n    --text-opacity: 1;\n    color: #c3ddfd;\n    color: rgba(195, 221, 253, var(--text-opacity));\n  }\n  .lg\\:text-blue-300 {\n    --text-opacity: 1;\n    color: #a4cafe;\n    color: rgba(164, 202, 254, var(--text-opacity));\n  }\n  .lg\\:text-blue-400 {\n    --text-opacity: 1;\n    color: #76a9fa;\n    color: rgba(118, 169, 250, var(--text-opacity));\n  }\n  .lg\\:text-blue-500 {\n    --text-opacity: 1;\n    color: #3f83f8;\n    color: rgba(63, 131, 248, var(--text-opacity));\n  }\n  .lg\\:text-blue-600 {\n    --text-opacity: 1;\n    color: #1c64f2;\n    color: rgba(28, 100, 242, var(--text-opacity));\n  }\n  .lg\\:text-blue-700 {\n    --text-opacity: 1;\n    color: #1a56db;\n    color: rgba(26, 86, 219, var(--text-opacity));\n  }\n  .lg\\:text-blue-800 {\n    --text-opacity: 1;\n    color: #1e429f;\n    color: rgba(30, 66, 159, var(--text-opacity));\n  }\n  .lg\\:text-blue-900 {\n    --text-opacity: 1;\n    color: #233876;\n    color: rgba(35, 56, 118, var(--text-opacity));\n  }\n  .lg\\:text-indigo-50 {\n    --text-opacity: 1;\n    color: #f0f5ff;\n    color: rgba(240, 245, 255, var(--text-opacity));\n  }\n  .lg\\:text-indigo-100 {\n    --text-opacity: 1;\n    color: #e5edff;\n    color: rgba(229, 237, 255, var(--text-opacity));\n  }\n  .lg\\:text-indigo-200 {\n    --text-opacity: 1;\n    color: #cddbfe;\n    color: rgba(205, 219, 254, var(--text-opacity));\n  }\n  .lg\\:text-indigo-300 {\n    --text-opacity: 1;\n    color: #b4c6fc;\n    color: rgba(180, 198, 252, var(--text-opacity));\n  }\n  .lg\\:text-indigo-400 {\n    --text-opacity: 1;\n    color: #8da2fb;\n    color: rgba(141, 162, 251, var(--text-opacity));\n  }\n  .lg\\:text-indigo-500 {\n    --text-opacity: 1;\n    color: #6875f5;\n    color: rgba(104, 117, 245, var(--text-opacity));\n  }\n  .lg\\:text-indigo-600 {\n    --text-opacity: 1;\n    color: #5850ec;\n    color: rgba(88, 80, 236, var(--text-opacity));\n  }\n  .lg\\:text-indigo-700 {\n    --text-opacity: 1;\n    color: #5145cd;\n    color: rgba(81, 69, 205, var(--text-opacity));\n  }\n  .lg\\:text-indigo-800 {\n    --text-opacity: 1;\n    color: #42389d;\n    color: rgba(66, 56, 157, var(--text-opacity));\n  }\n  .lg\\:text-indigo-900 {\n    --text-opacity: 1;\n    color: #362f78;\n    color: rgba(54, 47, 120, var(--text-opacity));\n  }\n  .lg\\:text-purple-50 {\n    --text-opacity: 1;\n    color: #f6f5ff;\n    color: rgba(246, 245, 255, var(--text-opacity));\n  }\n  .lg\\:text-purple-100 {\n    --text-opacity: 1;\n    color: #edebfe;\n    color: rgba(237, 235, 254, var(--text-opacity));\n  }\n  .lg\\:text-purple-200 {\n    --text-opacity: 1;\n    color: #dcd7fe;\n    color: rgba(220, 215, 254, var(--text-opacity));\n  }\n  .lg\\:text-purple-300 {\n    --text-opacity: 1;\n    color: #cabffd;\n    color: rgba(202, 191, 253, var(--text-opacity));\n  }\n  .lg\\:text-purple-400 {\n    --text-opacity: 1;\n    color: #ac94fa;\n    color: rgba(172, 148, 250, var(--text-opacity));\n  }\n  .lg\\:text-purple-500 {\n    --text-opacity: 1;\n    color: #9061f9;\n    color: rgba(144, 97, 249, var(--text-opacity));\n  }\n  .lg\\:text-purple-600 {\n    --text-opacity: 1;\n    color: #7e3af2;\n    color: rgba(126, 58, 242, var(--text-opacity));\n  }\n  .lg\\:text-purple-700 {\n    --text-opacity: 1;\n    color: #6c2bd9;\n    color: rgba(108, 43, 217, var(--text-opacity));\n  }\n  .lg\\:text-purple-800 {\n    --text-opacity: 1;\n    color: #5521b5;\n    color: rgba(85, 33, 181, var(--text-opacity));\n  }\n  .lg\\:text-purple-900 {\n    --text-opacity: 1;\n    color: #4a1d96;\n    color: rgba(74, 29, 150, var(--text-opacity));\n  }\n  .lg\\:text-pink-50 {\n    --text-opacity: 1;\n    color: #fdf2f8;\n    color: rgba(253, 242, 248, var(--text-opacity));\n  }\n  .lg\\:text-pink-100 {\n    --text-opacity: 1;\n    color: #fce8f3;\n    color: rgba(252, 232, 243, var(--text-opacity));\n  }\n  .lg\\:text-pink-200 {\n    --text-opacity: 1;\n    color: #fad1e8;\n    color: rgba(250, 209, 232, var(--text-opacity));\n  }\n  .lg\\:text-pink-300 {\n    --text-opacity: 1;\n    color: #f8b4d9;\n    color: rgba(248, 180, 217, var(--text-opacity));\n  }\n  .lg\\:text-pink-400 {\n    --text-opacity: 1;\n    color: #f17eb8;\n    color: rgba(241, 126, 184, var(--text-opacity));\n  }\n  .lg\\:text-pink-500 {\n    --text-opacity: 1;\n    color: #e74694;\n    color: rgba(231, 70, 148, var(--text-opacity));\n  }\n  .lg\\:text-pink-600 {\n    --text-opacity: 1;\n    color: #d61f69;\n    color: rgba(214, 31, 105, var(--text-opacity));\n  }\n  .lg\\:text-pink-700 {\n    --text-opacity: 1;\n    color: #bf125d;\n    color: rgba(191, 18, 93, var(--text-opacity));\n  }\n  .lg\\:text-pink-800 {\n    --text-opacity: 1;\n    color: #99154b;\n    color: rgba(153, 21, 75, var(--text-opacity));\n  }\n  .lg\\:text-pink-900 {\n    --text-opacity: 1;\n    color: #751a3d;\n    color: rgba(117, 26, 61, var(--text-opacity));\n  }\n  .lg\\:text-cool-gray-50 {\n    --text-opacity: 1;\n    color: #f8fafc;\n    color: rgba(248, 250, 252, var(--text-opacity));\n  }\n  .lg\\:text-cool-gray-100 {\n    --text-opacity: 1;\n    color: #f1f5f9;\n    color: rgba(241, 245, 249, var(--text-opacity));\n  }\n  .lg\\:text-cool-gray-200 {\n    --text-opacity: 1;\n    color: #e2e8f0;\n    color: rgba(226, 232, 240, var(--text-opacity));\n  }\n  .lg\\:text-cool-gray-300 {\n    --text-opacity: 1;\n    color: #cfd8e3;\n    color: rgba(207, 216, 227, var(--text-opacity));\n  }\n  .lg\\:text-cool-gray-400 {\n    --text-opacity: 1;\n    color: #97a6ba;\n    color: rgba(151, 166, 186, var(--text-opacity));\n  }\n  .lg\\:text-cool-gray-500 {\n    --text-opacity: 1;\n    color: #64748b;\n    color: rgba(100, 116, 139, var(--text-opacity));\n  }\n  .lg\\:text-cool-gray-600 {\n    --text-opacity: 1;\n    color: #475569;\n    color: rgba(71, 85, 105, var(--text-opacity));\n  }\n  .lg\\:text-cool-gray-700 {\n    --text-opacity: 1;\n    color: #364152;\n    color: rgba(54, 65, 82, var(--text-opacity));\n  }\n  .lg\\:text-cool-gray-800 {\n    --text-opacity: 1;\n    color: #27303f;\n    color: rgba(39, 48, 63, var(--text-opacity));\n  }\n  .lg\\:text-cool-gray-900 {\n    --text-opacity: 1;\n    color: #1a202e;\n    color: rgba(26, 32, 46, var(--text-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:text-current {\n    color: currentColor;\n  }\n  .group:hover .lg\\:group-hover\\:text-transparent {\n    color: transparent;\n  }\n  .group:hover .lg\\:group-hover\\:text-white {\n    --text-opacity: 1;\n    color: #ffffff;\n    color: rgba(255, 255, 255, var(--text-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:text-black {\n    --text-opacity: 1;\n    color: #000000;\n    color: rgba(0, 0, 0, var(--text-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:text-gray-50 {\n    --text-opacity: 1;\n    color: #f9fafb;\n    color: rgba(249, 250, 251, var(--text-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:text-gray-100 {\n    --text-opacity: 1;\n    color: #f4f5f7;\n    color: rgba(244, 245, 247, var(--text-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:text-gray-200 {\n    --text-opacity: 1;\n    color: #e5e7eb;\n    color: rgba(229, 231, 235, var(--text-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:text-gray-300 {\n    --text-opacity: 1;\n    color: #d2d6dc;\n    color: rgba(210, 214, 220, var(--text-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:text-gray-400 {\n    --text-opacity: 1;\n    color: #9fa6b2;\n    color: rgba(159, 166, 178, var(--text-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:text-gray-500 {\n    --text-opacity: 1;\n    color: #6b7280;\n    color: rgba(107, 114, 128, var(--text-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:text-gray-600 {\n    --text-opacity: 1;\n    color: #4b5563;\n    color: rgba(75, 85, 99, var(--text-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:text-gray-700 {\n    --text-opacity: 1;\n    color: #374151;\n    color: rgba(55, 65, 81, var(--text-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:text-gray-800 {\n    --text-opacity: 1;\n    color: #252f3f;\n    color: rgba(37, 47, 63, var(--text-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:text-gray-900 {\n    --text-opacity: 1;\n    color: #161e2e;\n    color: rgba(22, 30, 46, var(--text-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:text-red-50 {\n    --text-opacity: 1;\n    color: #fdf2f2;\n    color: rgba(253, 242, 242, var(--text-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:text-red-100 {\n    --text-opacity: 1;\n    color: #fde8e8;\n    color: rgba(253, 232, 232, var(--text-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:text-red-200 {\n    --text-opacity: 1;\n    color: #fbd5d5;\n    color: rgba(251, 213, 213, var(--text-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:text-red-300 {\n    --text-opacity: 1;\n    color: #f8b4b4;\n    color: rgba(248, 180, 180, var(--text-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:text-red-400 {\n    --text-opacity: 1;\n    color: #f98080;\n    color: rgba(249, 128, 128, var(--text-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:text-red-500 {\n    --text-opacity: 1;\n    color: #f05252;\n    color: rgba(240, 82, 82, var(--text-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:text-red-600 {\n    --text-opacity: 1;\n    color: #e02424;\n    color: rgba(224, 36, 36, var(--text-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:text-red-700 {\n    --text-opacity: 1;\n    color: #c81e1e;\n    color: rgba(200, 30, 30, var(--text-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:text-red-800 {\n    --text-opacity: 1;\n    color: #9b1c1c;\n    color: rgba(155, 28, 28, var(--text-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:text-red-900 {\n    --text-opacity: 1;\n    color: #771d1d;\n    color: rgba(119, 29, 29, var(--text-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:text-orange-50 {\n    --text-opacity: 1;\n    color: #fff8f1;\n    color: rgba(255, 248, 241, var(--text-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:text-orange-100 {\n    --text-opacity: 1;\n    color: #feecdc;\n    color: rgba(254, 236, 220, var(--text-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:text-orange-200 {\n    --text-opacity: 1;\n    color: #fcd9bd;\n    color: rgba(252, 217, 189, var(--text-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:text-orange-300 {\n    --text-opacity: 1;\n    color: #fdba8c;\n    color: rgba(253, 186, 140, var(--text-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:text-orange-400 {\n    --text-opacity: 1;\n    color: #ff8a4c;\n    color: rgba(255, 138, 76, var(--text-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:text-orange-500 {\n    --text-opacity: 1;\n    color: #ff5a1f;\n    color: rgba(255, 90, 31, var(--text-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:text-orange-600 {\n    --text-opacity: 1;\n    color: #d03801;\n    color: rgba(208, 56, 1, var(--text-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:text-orange-700 {\n    --text-opacity: 1;\n    color: #b43403;\n    color: rgba(180, 52, 3, var(--text-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:text-orange-800 {\n    --text-opacity: 1;\n    color: #8a2c0d;\n    color: rgba(138, 44, 13, var(--text-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:text-orange-900 {\n    --text-opacity: 1;\n    color: #73230d;\n    color: rgba(115, 35, 13, var(--text-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:text-yellow-50 {\n    --text-opacity: 1;\n    color: #fdfdea;\n    color: rgba(253, 253, 234, var(--text-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:text-yellow-100 {\n    --text-opacity: 1;\n    color: #fdf6b2;\n    color: rgba(253, 246, 178, var(--text-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:text-yellow-200 {\n    --text-opacity: 1;\n    color: #fce96a;\n    color: rgba(252, 233, 106, var(--text-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:text-yellow-300 {\n    --text-opacity: 1;\n    color: #faca15;\n    color: rgba(250, 202, 21, var(--text-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:text-yellow-400 {\n    --text-opacity: 1;\n    color: #e3a008;\n    color: rgba(227, 160, 8, var(--text-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:text-yellow-500 {\n    --text-opacity: 1;\n    color: #c27803;\n    color: rgba(194, 120, 3, var(--text-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:text-yellow-600 {\n    --text-opacity: 1;\n    color: #9f580a;\n    color: rgba(159, 88, 10, var(--text-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:text-yellow-700 {\n    --text-opacity: 1;\n    color: #8e4b10;\n    color: rgba(142, 75, 16, var(--text-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:text-yellow-800 {\n    --text-opacity: 1;\n    color: #723b13;\n    color: rgba(114, 59, 19, var(--text-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:text-yellow-900 {\n    --text-opacity: 1;\n    color: #633112;\n    color: rgba(99, 49, 18, var(--text-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:text-green-50 {\n    --text-opacity: 1;\n    color: #f3faf7;\n    color: rgba(243, 250, 247, var(--text-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:text-green-100 {\n    --text-opacity: 1;\n    color: #def7ec;\n    color: rgba(222, 247, 236, var(--text-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:text-green-200 {\n    --text-opacity: 1;\n    color: #bcf0da;\n    color: rgba(188, 240, 218, var(--text-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:text-green-300 {\n    --text-opacity: 1;\n    color: #84e1bc;\n    color: rgba(132, 225, 188, var(--text-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:text-green-400 {\n    --text-opacity: 1;\n    color: #31c48d;\n    color: rgba(49, 196, 141, var(--text-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:text-green-500 {\n    --text-opacity: 1;\n    color: #0e9f6e;\n    color: rgba(14, 159, 110, var(--text-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:text-green-600 {\n    --text-opacity: 1;\n    color: #057a55;\n    color: rgba(5, 122, 85, var(--text-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:text-green-700 {\n    --text-opacity: 1;\n    color: #046c4e;\n    color: rgba(4, 108, 78, var(--text-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:text-green-800 {\n    --text-opacity: 1;\n    color: #03543f;\n    color: rgba(3, 84, 63, var(--text-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:text-green-900 {\n    --text-opacity: 1;\n    color: #014737;\n    color: rgba(1, 71, 55, var(--text-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:text-teal-50 {\n    --text-opacity: 1;\n    color: #edfafa;\n    color: rgba(237, 250, 250, var(--text-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:text-teal-100 {\n    --text-opacity: 1;\n    color: #d5f5f6;\n    color: rgba(213, 245, 246, var(--text-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:text-teal-200 {\n    --text-opacity: 1;\n    color: #afecef;\n    color: rgba(175, 236, 239, var(--text-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:text-teal-300 {\n    --text-opacity: 1;\n    color: #7edce2;\n    color: rgba(126, 220, 226, var(--text-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:text-teal-400 {\n    --text-opacity: 1;\n    color: #16bdca;\n    color: rgba(22, 189, 202, var(--text-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:text-teal-500 {\n    --text-opacity: 1;\n    color: #0694a2;\n    color: rgba(6, 148, 162, var(--text-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:text-teal-600 {\n    --text-opacity: 1;\n    color: #047481;\n    color: rgba(4, 116, 129, var(--text-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:text-teal-700 {\n    --text-opacity: 1;\n    color: #036672;\n    color: rgba(3, 102, 114, var(--text-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:text-teal-800 {\n    --text-opacity: 1;\n    color: #05505c;\n    color: rgba(5, 80, 92, var(--text-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:text-teal-900 {\n    --text-opacity: 1;\n    color: #014451;\n    color: rgba(1, 68, 81, var(--text-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:text-blue-50 {\n    --text-opacity: 1;\n    color: #ebf5ff;\n    color: rgba(235, 245, 255, var(--text-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:text-blue-100 {\n    --text-opacity: 1;\n    color: #e1effe;\n    color: rgba(225, 239, 254, var(--text-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:text-blue-200 {\n    --text-opacity: 1;\n    color: #c3ddfd;\n    color: rgba(195, 221, 253, var(--text-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:text-blue-300 {\n    --text-opacity: 1;\n    color: #a4cafe;\n    color: rgba(164, 202, 254, var(--text-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:text-blue-400 {\n    --text-opacity: 1;\n    color: #76a9fa;\n    color: rgba(118, 169, 250, var(--text-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:text-blue-500 {\n    --text-opacity: 1;\n    color: #3f83f8;\n    color: rgba(63, 131, 248, var(--text-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:text-blue-600 {\n    --text-opacity: 1;\n    color: #1c64f2;\n    color: rgba(28, 100, 242, var(--text-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:text-blue-700 {\n    --text-opacity: 1;\n    color: #1a56db;\n    color: rgba(26, 86, 219, var(--text-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:text-blue-800 {\n    --text-opacity: 1;\n    color: #1e429f;\n    color: rgba(30, 66, 159, var(--text-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:text-blue-900 {\n    --text-opacity: 1;\n    color: #233876;\n    color: rgba(35, 56, 118, var(--text-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:text-indigo-50 {\n    --text-opacity: 1;\n    color: #f0f5ff;\n    color: rgba(240, 245, 255, var(--text-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:text-indigo-100 {\n    --text-opacity: 1;\n    color: #e5edff;\n    color: rgba(229, 237, 255, var(--text-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:text-indigo-200 {\n    --text-opacity: 1;\n    color: #cddbfe;\n    color: rgba(205, 219, 254, var(--text-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:text-indigo-300 {\n    --text-opacity: 1;\n    color: #b4c6fc;\n    color: rgba(180, 198, 252, var(--text-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:text-indigo-400 {\n    --text-opacity: 1;\n    color: #8da2fb;\n    color: rgba(141, 162, 251, var(--text-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:text-indigo-500 {\n    --text-opacity: 1;\n    color: #6875f5;\n    color: rgba(104, 117, 245, var(--text-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:text-indigo-600 {\n    --text-opacity: 1;\n    color: #5850ec;\n    color: rgba(88, 80, 236, var(--text-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:text-indigo-700 {\n    --text-opacity: 1;\n    color: #5145cd;\n    color: rgba(81, 69, 205, var(--text-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:text-indigo-800 {\n    --text-opacity: 1;\n    color: #42389d;\n    color: rgba(66, 56, 157, var(--text-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:text-indigo-900 {\n    --text-opacity: 1;\n    color: #362f78;\n    color: rgba(54, 47, 120, var(--text-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:text-purple-50 {\n    --text-opacity: 1;\n    color: #f6f5ff;\n    color: rgba(246, 245, 255, var(--text-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:text-purple-100 {\n    --text-opacity: 1;\n    color: #edebfe;\n    color: rgba(237, 235, 254, var(--text-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:text-purple-200 {\n    --text-opacity: 1;\n    color: #dcd7fe;\n    color: rgba(220, 215, 254, var(--text-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:text-purple-300 {\n    --text-opacity: 1;\n    color: #cabffd;\n    color: rgba(202, 191, 253, var(--text-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:text-purple-400 {\n    --text-opacity: 1;\n    color: #ac94fa;\n    color: rgba(172, 148, 250, var(--text-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:text-purple-500 {\n    --text-opacity: 1;\n    color: #9061f9;\n    color: rgba(144, 97, 249, var(--text-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:text-purple-600 {\n    --text-opacity: 1;\n    color: #7e3af2;\n    color: rgba(126, 58, 242, var(--text-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:text-purple-700 {\n    --text-opacity: 1;\n    color: #6c2bd9;\n    color: rgba(108, 43, 217, var(--text-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:text-purple-800 {\n    --text-opacity: 1;\n    color: #5521b5;\n    color: rgba(85, 33, 181, var(--text-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:text-purple-900 {\n    --text-opacity: 1;\n    color: #4a1d96;\n    color: rgba(74, 29, 150, var(--text-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:text-pink-50 {\n    --text-opacity: 1;\n    color: #fdf2f8;\n    color: rgba(253, 242, 248, var(--text-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:text-pink-100 {\n    --text-opacity: 1;\n    color: #fce8f3;\n    color: rgba(252, 232, 243, var(--text-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:text-pink-200 {\n    --text-opacity: 1;\n    color: #fad1e8;\n    color: rgba(250, 209, 232, var(--text-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:text-pink-300 {\n    --text-opacity: 1;\n    color: #f8b4d9;\n    color: rgba(248, 180, 217, var(--text-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:text-pink-400 {\n    --text-opacity: 1;\n    color: #f17eb8;\n    color: rgba(241, 126, 184, var(--text-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:text-pink-500 {\n    --text-opacity: 1;\n    color: #e74694;\n    color: rgba(231, 70, 148, var(--text-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:text-pink-600 {\n    --text-opacity: 1;\n    color: #d61f69;\n    color: rgba(214, 31, 105, var(--text-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:text-pink-700 {\n    --text-opacity: 1;\n    color: #bf125d;\n    color: rgba(191, 18, 93, var(--text-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:text-pink-800 {\n    --text-opacity: 1;\n    color: #99154b;\n    color: rgba(153, 21, 75, var(--text-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:text-pink-900 {\n    --text-opacity: 1;\n    color: #751a3d;\n    color: rgba(117, 26, 61, var(--text-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:text-cool-gray-50 {\n    --text-opacity: 1;\n    color: #f8fafc;\n    color: rgba(248, 250, 252, var(--text-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:text-cool-gray-100 {\n    --text-opacity: 1;\n    color: #f1f5f9;\n    color: rgba(241, 245, 249, var(--text-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:text-cool-gray-200 {\n    --text-opacity: 1;\n    color: #e2e8f0;\n    color: rgba(226, 232, 240, var(--text-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:text-cool-gray-300 {\n    --text-opacity: 1;\n    color: #cfd8e3;\n    color: rgba(207, 216, 227, var(--text-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:text-cool-gray-400 {\n    --text-opacity: 1;\n    color: #97a6ba;\n    color: rgba(151, 166, 186, var(--text-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:text-cool-gray-500 {\n    --text-opacity: 1;\n    color: #64748b;\n    color: rgba(100, 116, 139, var(--text-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:text-cool-gray-600 {\n    --text-opacity: 1;\n    color: #475569;\n    color: rgba(71, 85, 105, var(--text-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:text-cool-gray-700 {\n    --text-opacity: 1;\n    color: #364152;\n    color: rgba(54, 65, 82, var(--text-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:text-cool-gray-800 {\n    --text-opacity: 1;\n    color: #27303f;\n    color: rgba(39, 48, 63, var(--text-opacity));\n  }\n  .group:hover .lg\\:group-hover\\:text-cool-gray-900 {\n    --text-opacity: 1;\n    color: #1a202e;\n    color: rgba(26, 32, 46, var(--text-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:text-current {\n    color: currentColor;\n  }\n  .group:focus .lg\\:group-focus\\:text-transparent {\n    color: transparent;\n  }\n  .group:focus .lg\\:group-focus\\:text-white {\n    --text-opacity: 1;\n    color: #ffffff;\n    color: rgba(255, 255, 255, var(--text-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:text-black {\n    --text-opacity: 1;\n    color: #000000;\n    color: rgba(0, 0, 0, var(--text-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:text-gray-50 {\n    --text-opacity: 1;\n    color: #f9fafb;\n    color: rgba(249, 250, 251, var(--text-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:text-gray-100 {\n    --text-opacity: 1;\n    color: #f4f5f7;\n    color: rgba(244, 245, 247, var(--text-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:text-gray-200 {\n    --text-opacity: 1;\n    color: #e5e7eb;\n    color: rgba(229, 231, 235, var(--text-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:text-gray-300 {\n    --text-opacity: 1;\n    color: #d2d6dc;\n    color: rgba(210, 214, 220, var(--text-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:text-gray-400 {\n    --text-opacity: 1;\n    color: #9fa6b2;\n    color: rgba(159, 166, 178, var(--text-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:text-gray-500 {\n    --text-opacity: 1;\n    color: #6b7280;\n    color: rgba(107, 114, 128, var(--text-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:text-gray-600 {\n    --text-opacity: 1;\n    color: #4b5563;\n    color: rgba(75, 85, 99, var(--text-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:text-gray-700 {\n    --text-opacity: 1;\n    color: #374151;\n    color: rgba(55, 65, 81, var(--text-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:text-gray-800 {\n    --text-opacity: 1;\n    color: #252f3f;\n    color: rgba(37, 47, 63, var(--text-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:text-gray-900 {\n    --text-opacity: 1;\n    color: #161e2e;\n    color: rgba(22, 30, 46, var(--text-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:text-red-50 {\n    --text-opacity: 1;\n    color: #fdf2f2;\n    color: rgba(253, 242, 242, var(--text-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:text-red-100 {\n    --text-opacity: 1;\n    color: #fde8e8;\n    color: rgba(253, 232, 232, var(--text-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:text-red-200 {\n    --text-opacity: 1;\n    color: #fbd5d5;\n    color: rgba(251, 213, 213, var(--text-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:text-red-300 {\n    --text-opacity: 1;\n    color: #f8b4b4;\n    color: rgba(248, 180, 180, var(--text-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:text-red-400 {\n    --text-opacity: 1;\n    color: #f98080;\n    color: rgba(249, 128, 128, var(--text-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:text-red-500 {\n    --text-opacity: 1;\n    color: #f05252;\n    color: rgba(240, 82, 82, var(--text-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:text-red-600 {\n    --text-opacity: 1;\n    color: #e02424;\n    color: rgba(224, 36, 36, var(--text-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:text-red-700 {\n    --text-opacity: 1;\n    color: #c81e1e;\n    color: rgba(200, 30, 30, var(--text-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:text-red-800 {\n    --text-opacity: 1;\n    color: #9b1c1c;\n    color: rgba(155, 28, 28, var(--text-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:text-red-900 {\n    --text-opacity: 1;\n    color: #771d1d;\n    color: rgba(119, 29, 29, var(--text-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:text-orange-50 {\n    --text-opacity: 1;\n    color: #fff8f1;\n    color: rgba(255, 248, 241, var(--text-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:text-orange-100 {\n    --text-opacity: 1;\n    color: #feecdc;\n    color: rgba(254, 236, 220, var(--text-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:text-orange-200 {\n    --text-opacity: 1;\n    color: #fcd9bd;\n    color: rgba(252, 217, 189, var(--text-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:text-orange-300 {\n    --text-opacity: 1;\n    color: #fdba8c;\n    color: rgba(253, 186, 140, var(--text-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:text-orange-400 {\n    --text-opacity: 1;\n    color: #ff8a4c;\n    color: rgba(255, 138, 76, var(--text-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:text-orange-500 {\n    --text-opacity: 1;\n    color: #ff5a1f;\n    color: rgba(255, 90, 31, var(--text-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:text-orange-600 {\n    --text-opacity: 1;\n    color: #d03801;\n    color: rgba(208, 56, 1, var(--text-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:text-orange-700 {\n    --text-opacity: 1;\n    color: #b43403;\n    color: rgba(180, 52, 3, var(--text-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:text-orange-800 {\n    --text-opacity: 1;\n    color: #8a2c0d;\n    color: rgba(138, 44, 13, var(--text-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:text-orange-900 {\n    --text-opacity: 1;\n    color: #73230d;\n    color: rgba(115, 35, 13, var(--text-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:text-yellow-50 {\n    --text-opacity: 1;\n    color: #fdfdea;\n    color: rgba(253, 253, 234, var(--text-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:text-yellow-100 {\n    --text-opacity: 1;\n    color: #fdf6b2;\n    color: rgba(253, 246, 178, var(--text-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:text-yellow-200 {\n    --text-opacity: 1;\n    color: #fce96a;\n    color: rgba(252, 233, 106, var(--text-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:text-yellow-300 {\n    --text-opacity: 1;\n    color: #faca15;\n    color: rgba(250, 202, 21, var(--text-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:text-yellow-400 {\n    --text-opacity: 1;\n    color: #e3a008;\n    color: rgba(227, 160, 8, var(--text-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:text-yellow-500 {\n    --text-opacity: 1;\n    color: #c27803;\n    color: rgba(194, 120, 3, var(--text-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:text-yellow-600 {\n    --text-opacity: 1;\n    color: #9f580a;\n    color: rgba(159, 88, 10, var(--text-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:text-yellow-700 {\n    --text-opacity: 1;\n    color: #8e4b10;\n    color: rgba(142, 75, 16, var(--text-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:text-yellow-800 {\n    --text-opacity: 1;\n    color: #723b13;\n    color: rgba(114, 59, 19, var(--text-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:text-yellow-900 {\n    --text-opacity: 1;\n    color: #633112;\n    color: rgba(99, 49, 18, var(--text-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:text-green-50 {\n    --text-opacity: 1;\n    color: #f3faf7;\n    color: rgba(243, 250, 247, var(--text-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:text-green-100 {\n    --text-opacity: 1;\n    color: #def7ec;\n    color: rgba(222, 247, 236, var(--text-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:text-green-200 {\n    --text-opacity: 1;\n    color: #bcf0da;\n    color: rgba(188, 240, 218, var(--text-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:text-green-300 {\n    --text-opacity: 1;\n    color: #84e1bc;\n    color: rgba(132, 225, 188, var(--text-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:text-green-400 {\n    --text-opacity: 1;\n    color: #31c48d;\n    color: rgba(49, 196, 141, var(--text-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:text-green-500 {\n    --text-opacity: 1;\n    color: #0e9f6e;\n    color: rgba(14, 159, 110, var(--text-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:text-green-600 {\n    --text-opacity: 1;\n    color: #057a55;\n    color: rgba(5, 122, 85, var(--text-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:text-green-700 {\n    --text-opacity: 1;\n    color: #046c4e;\n    color: rgba(4, 108, 78, var(--text-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:text-green-800 {\n    --text-opacity: 1;\n    color: #03543f;\n    color: rgba(3, 84, 63, var(--text-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:text-green-900 {\n    --text-opacity: 1;\n    color: #014737;\n    color: rgba(1, 71, 55, var(--text-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:text-teal-50 {\n    --text-opacity: 1;\n    color: #edfafa;\n    color: rgba(237, 250, 250, var(--text-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:text-teal-100 {\n    --text-opacity: 1;\n    color: #d5f5f6;\n    color: rgba(213, 245, 246, var(--text-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:text-teal-200 {\n    --text-opacity: 1;\n    color: #afecef;\n    color: rgba(175, 236, 239, var(--text-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:text-teal-300 {\n    --text-opacity: 1;\n    color: #7edce2;\n    color: rgba(126, 220, 226, var(--text-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:text-teal-400 {\n    --text-opacity: 1;\n    color: #16bdca;\n    color: rgba(22, 189, 202, var(--text-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:text-teal-500 {\n    --text-opacity: 1;\n    color: #0694a2;\n    color: rgba(6, 148, 162, var(--text-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:text-teal-600 {\n    --text-opacity: 1;\n    color: #047481;\n    color: rgba(4, 116, 129, var(--text-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:text-teal-700 {\n    --text-opacity: 1;\n    color: #036672;\n    color: rgba(3, 102, 114, var(--text-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:text-teal-800 {\n    --text-opacity: 1;\n    color: #05505c;\n    color: rgba(5, 80, 92, var(--text-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:text-teal-900 {\n    --text-opacity: 1;\n    color: #014451;\n    color: rgba(1, 68, 81, var(--text-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:text-blue-50 {\n    --text-opacity: 1;\n    color: #ebf5ff;\n    color: rgba(235, 245, 255, var(--text-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:text-blue-100 {\n    --text-opacity: 1;\n    color: #e1effe;\n    color: rgba(225, 239, 254, var(--text-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:text-blue-200 {\n    --text-opacity: 1;\n    color: #c3ddfd;\n    color: rgba(195, 221, 253, var(--text-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:text-blue-300 {\n    --text-opacity: 1;\n    color: #a4cafe;\n    color: rgba(164, 202, 254, var(--text-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:text-blue-400 {\n    --text-opacity: 1;\n    color: #76a9fa;\n    color: rgba(118, 169, 250, var(--text-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:text-blue-500 {\n    --text-opacity: 1;\n    color: #3f83f8;\n    color: rgba(63, 131, 248, var(--text-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:text-blue-600 {\n    --text-opacity: 1;\n    color: #1c64f2;\n    color: rgba(28, 100, 242, var(--text-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:text-blue-700 {\n    --text-opacity: 1;\n    color: #1a56db;\n    color: rgba(26, 86, 219, var(--text-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:text-blue-800 {\n    --text-opacity: 1;\n    color: #1e429f;\n    color: rgba(30, 66, 159, var(--text-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:text-blue-900 {\n    --text-opacity: 1;\n    color: #233876;\n    color: rgba(35, 56, 118, var(--text-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:text-indigo-50 {\n    --text-opacity: 1;\n    color: #f0f5ff;\n    color: rgba(240, 245, 255, var(--text-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:text-indigo-100 {\n    --text-opacity: 1;\n    color: #e5edff;\n    color: rgba(229, 237, 255, var(--text-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:text-indigo-200 {\n    --text-opacity: 1;\n    color: #cddbfe;\n    color: rgba(205, 219, 254, var(--text-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:text-indigo-300 {\n    --text-opacity: 1;\n    color: #b4c6fc;\n    color: rgba(180, 198, 252, var(--text-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:text-indigo-400 {\n    --text-opacity: 1;\n    color: #8da2fb;\n    color: rgba(141, 162, 251, var(--text-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:text-indigo-500 {\n    --text-opacity: 1;\n    color: #6875f5;\n    color: rgba(104, 117, 245, var(--text-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:text-indigo-600 {\n    --text-opacity: 1;\n    color: #5850ec;\n    color: rgba(88, 80, 236, var(--text-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:text-indigo-700 {\n    --text-opacity: 1;\n    color: #5145cd;\n    color: rgba(81, 69, 205, var(--text-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:text-indigo-800 {\n    --text-opacity: 1;\n    color: #42389d;\n    color: rgba(66, 56, 157, var(--text-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:text-indigo-900 {\n    --text-opacity: 1;\n    color: #362f78;\n    color: rgba(54, 47, 120, var(--text-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:text-purple-50 {\n    --text-opacity: 1;\n    color: #f6f5ff;\n    color: rgba(246, 245, 255, var(--text-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:text-purple-100 {\n    --text-opacity: 1;\n    color: #edebfe;\n    color: rgba(237, 235, 254, var(--text-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:text-purple-200 {\n    --text-opacity: 1;\n    color: #dcd7fe;\n    color: rgba(220, 215, 254, var(--text-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:text-purple-300 {\n    --text-opacity: 1;\n    color: #cabffd;\n    color: rgba(202, 191, 253, var(--text-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:text-purple-400 {\n    --text-opacity: 1;\n    color: #ac94fa;\n    color: rgba(172, 148, 250, var(--text-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:text-purple-500 {\n    --text-opacity: 1;\n    color: #9061f9;\n    color: rgba(144, 97, 249, var(--text-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:text-purple-600 {\n    --text-opacity: 1;\n    color: #7e3af2;\n    color: rgba(126, 58, 242, var(--text-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:text-purple-700 {\n    --text-opacity: 1;\n    color: #6c2bd9;\n    color: rgba(108, 43, 217, var(--text-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:text-purple-800 {\n    --text-opacity: 1;\n    color: #5521b5;\n    color: rgba(85, 33, 181, var(--text-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:text-purple-900 {\n    --text-opacity: 1;\n    color: #4a1d96;\n    color: rgba(74, 29, 150, var(--text-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:text-pink-50 {\n    --text-opacity: 1;\n    color: #fdf2f8;\n    color: rgba(253, 242, 248, var(--text-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:text-pink-100 {\n    --text-opacity: 1;\n    color: #fce8f3;\n    color: rgba(252, 232, 243, var(--text-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:text-pink-200 {\n    --text-opacity: 1;\n    color: #fad1e8;\n    color: rgba(250, 209, 232, var(--text-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:text-pink-300 {\n    --text-opacity: 1;\n    color: #f8b4d9;\n    color: rgba(248, 180, 217, var(--text-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:text-pink-400 {\n    --text-opacity: 1;\n    color: #f17eb8;\n    color: rgba(241, 126, 184, var(--text-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:text-pink-500 {\n    --text-opacity: 1;\n    color: #e74694;\n    color: rgba(231, 70, 148, var(--text-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:text-pink-600 {\n    --text-opacity: 1;\n    color: #d61f69;\n    color: rgba(214, 31, 105, var(--text-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:text-pink-700 {\n    --text-opacity: 1;\n    color: #bf125d;\n    color: rgba(191, 18, 93, var(--text-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:text-pink-800 {\n    --text-opacity: 1;\n    color: #99154b;\n    color: rgba(153, 21, 75, var(--text-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:text-pink-900 {\n    --text-opacity: 1;\n    color: #751a3d;\n    color: rgba(117, 26, 61, var(--text-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:text-cool-gray-50 {\n    --text-opacity: 1;\n    color: #f8fafc;\n    color: rgba(248, 250, 252, var(--text-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:text-cool-gray-100 {\n    --text-opacity: 1;\n    color: #f1f5f9;\n    color: rgba(241, 245, 249, var(--text-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:text-cool-gray-200 {\n    --text-opacity: 1;\n    color: #e2e8f0;\n    color: rgba(226, 232, 240, var(--text-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:text-cool-gray-300 {\n    --text-opacity: 1;\n    color: #cfd8e3;\n    color: rgba(207, 216, 227, var(--text-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:text-cool-gray-400 {\n    --text-opacity: 1;\n    color: #97a6ba;\n    color: rgba(151, 166, 186, var(--text-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:text-cool-gray-500 {\n    --text-opacity: 1;\n    color: #64748b;\n    color: rgba(100, 116, 139, var(--text-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:text-cool-gray-600 {\n    --text-opacity: 1;\n    color: #475569;\n    color: rgba(71, 85, 105, var(--text-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:text-cool-gray-700 {\n    --text-opacity: 1;\n    color: #364152;\n    color: rgba(54, 65, 82, var(--text-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:text-cool-gray-800 {\n    --text-opacity: 1;\n    color: #27303f;\n    color: rgba(39, 48, 63, var(--text-opacity));\n  }\n  .group:focus .lg\\:group-focus\\:text-cool-gray-900 {\n    --text-opacity: 1;\n    color: #1a202e;\n    color: rgba(26, 32, 46, var(--text-opacity));\n  }\n  .lg\\:hover\\:text-current:hover {\n    color: currentColor;\n  }\n  .lg\\:hover\\:text-transparent:hover {\n    color: transparent;\n  }\n  .lg\\:hover\\:text-white:hover {\n    --text-opacity: 1;\n    color: #ffffff;\n    color: rgba(255, 255, 255, var(--text-opacity));\n  }\n  .lg\\:hover\\:text-black:hover {\n    --text-opacity: 1;\n    color: #000000;\n    color: rgba(0, 0, 0, var(--text-opacity));\n  }\n  .lg\\:hover\\:text-gray-50:hover {\n    --text-opacity: 1;\n    color: #f9fafb;\n    color: rgba(249, 250, 251, var(--text-opacity));\n  }\n  .lg\\:hover\\:text-gray-100:hover {\n    --text-opacity: 1;\n    color: #f4f5f7;\n    color: rgba(244, 245, 247, var(--text-opacity));\n  }\n  .lg\\:hover\\:text-gray-200:hover {\n    --text-opacity: 1;\n    color: #e5e7eb;\n    color: rgba(229, 231, 235, var(--text-opacity));\n  }\n  .lg\\:hover\\:text-gray-300:hover {\n    --text-opacity: 1;\n    color: #d2d6dc;\n    color: rgba(210, 214, 220, var(--text-opacity));\n  }\n  .lg\\:hover\\:text-gray-400:hover {\n    --text-opacity: 1;\n    color: #9fa6b2;\n    color: rgba(159, 166, 178, var(--text-opacity));\n  }\n  .lg\\:hover\\:text-gray-500:hover {\n    --text-opacity: 1;\n    color: #6b7280;\n    color: rgba(107, 114, 128, var(--text-opacity));\n  }\n  .lg\\:hover\\:text-gray-600:hover {\n    --text-opacity: 1;\n    color: #4b5563;\n    color: rgba(75, 85, 99, var(--text-opacity));\n  }\n  .lg\\:hover\\:text-gray-700:hover {\n    --text-opacity: 1;\n    color: #374151;\n    color: rgba(55, 65, 81, var(--text-opacity));\n  }\n  .lg\\:hover\\:text-gray-800:hover {\n    --text-opacity: 1;\n    color: #252f3f;\n    color: rgba(37, 47, 63, var(--text-opacity));\n  }\n  .lg\\:hover\\:text-gray-900:hover {\n    --text-opacity: 1;\n    color: #161e2e;\n    color: rgba(22, 30, 46, var(--text-opacity));\n  }\n  .lg\\:hover\\:text-red-50:hover {\n    --text-opacity: 1;\n    color: #fdf2f2;\n    color: rgba(253, 242, 242, var(--text-opacity));\n  }\n  .lg\\:hover\\:text-red-100:hover {\n    --text-opacity: 1;\n    color: #fde8e8;\n    color: rgba(253, 232, 232, var(--text-opacity));\n  }\n  .lg\\:hover\\:text-red-200:hover {\n    --text-opacity: 1;\n    color: #fbd5d5;\n    color: rgba(251, 213, 213, var(--text-opacity));\n  }\n  .lg\\:hover\\:text-red-300:hover {\n    --text-opacity: 1;\n    color: #f8b4b4;\n    color: rgba(248, 180, 180, var(--text-opacity));\n  }\n  .lg\\:hover\\:text-red-400:hover {\n    --text-opacity: 1;\n    color: #f98080;\n    color: rgba(249, 128, 128, var(--text-opacity));\n  }\n  .lg\\:hover\\:text-red-500:hover {\n    --text-opacity: 1;\n    color: #f05252;\n    color: rgba(240, 82, 82, var(--text-opacity));\n  }\n  .lg\\:hover\\:text-red-600:hover {\n    --text-opacity: 1;\n    color: #e02424;\n    color: rgba(224, 36, 36, var(--text-opacity));\n  }\n  .lg\\:hover\\:text-red-700:hover {\n    --text-opacity: 1;\n    color: #c81e1e;\n    color: rgba(200, 30, 30, var(--text-opacity));\n  }\n  .lg\\:hover\\:text-red-800:hover {\n    --text-opacity: 1;\n    color: #9b1c1c;\n    color: rgba(155, 28, 28, var(--text-opacity));\n  }\n  .lg\\:hover\\:text-red-900:hover {\n    --text-opacity: 1;\n    color: #771d1d;\n    color: rgba(119, 29, 29, var(--text-opacity));\n  }\n  .lg\\:hover\\:text-orange-50:hover {\n    --text-opacity: 1;\n    color: #fff8f1;\n    color: rgba(255, 248, 241, var(--text-opacity));\n  }\n  .lg\\:hover\\:text-orange-100:hover {\n    --text-opacity: 1;\n    color: #feecdc;\n    color: rgba(254, 236, 220, var(--text-opacity));\n  }\n  .lg\\:hover\\:text-orange-200:hover {\n    --text-opacity: 1;\n    color: #fcd9bd;\n    color: rgba(252, 217, 189, var(--text-opacity));\n  }\n  .lg\\:hover\\:text-orange-300:hover {\n    --text-opacity: 1;\n    color: #fdba8c;\n    color: rgba(253, 186, 140, var(--text-opacity));\n  }\n  .lg\\:hover\\:text-orange-400:hover {\n    --text-opacity: 1;\n    color: #ff8a4c;\n    color: rgba(255, 138, 76, var(--text-opacity));\n  }\n  .lg\\:hover\\:text-orange-500:hover {\n    --text-opacity: 1;\n    color: #ff5a1f;\n    color: rgba(255, 90, 31, var(--text-opacity));\n  }\n  .lg\\:hover\\:text-orange-600:hover {\n    --text-opacity: 1;\n    color: #d03801;\n    color: rgba(208, 56, 1, var(--text-opacity));\n  }\n  .lg\\:hover\\:text-orange-700:hover {\n    --text-opacity: 1;\n    color: #b43403;\n    color: rgba(180, 52, 3, var(--text-opacity));\n  }\n  .lg\\:hover\\:text-orange-800:hover {\n    --text-opacity: 1;\n    color: #8a2c0d;\n    color: rgba(138, 44, 13, var(--text-opacity));\n  }\n  .lg\\:hover\\:text-orange-900:hover {\n    --text-opacity: 1;\n    color: #73230d;\n    color: rgba(115, 35, 13, var(--text-opacity));\n  }\n  .lg\\:hover\\:text-yellow-50:hover {\n    --text-opacity: 1;\n    color: #fdfdea;\n    color: rgba(253, 253, 234, var(--text-opacity));\n  }\n  .lg\\:hover\\:text-yellow-100:hover {\n    --text-opacity: 1;\n    color: #fdf6b2;\n    color: rgba(253, 246, 178, var(--text-opacity));\n  }\n  .lg\\:hover\\:text-yellow-200:hover {\n    --text-opacity: 1;\n    color: #fce96a;\n    color: rgba(252, 233, 106, var(--text-opacity));\n  }\n  .lg\\:hover\\:text-yellow-300:hover {\n    --text-opacity: 1;\n    color: #faca15;\n    color: rgba(250, 202, 21, var(--text-opacity));\n  }\n  .lg\\:hover\\:text-yellow-400:hover {\n    --text-opacity: 1;\n    color: #e3a008;\n    color: rgba(227, 160, 8, var(--text-opacity));\n  }\n  .lg\\:hover\\:text-yellow-500:hover {\n    --text-opacity: 1;\n    color: #c27803;\n    color: rgba(194, 120, 3, var(--text-opacity));\n  }\n  .lg\\:hover\\:text-yellow-600:hover {\n    --text-opacity: 1;\n    color: #9f580a;\n    color: rgba(159, 88, 10, var(--text-opacity));\n  }\n  .lg\\:hover\\:text-yellow-700:hover {\n    --text-opacity: 1;\n    color: #8e4b10;\n    color: rgba(142, 75, 16, var(--text-opacity));\n  }\n  .lg\\:hover\\:text-yellow-800:hover {\n    --text-opacity: 1;\n    color: #723b13;\n    color: rgba(114, 59, 19, var(--text-opacity));\n  }\n  .lg\\:hover\\:text-yellow-900:hover {\n    --text-opacity: 1;\n    color: #633112;\n    color: rgba(99, 49, 18, var(--text-opacity));\n  }\n  .lg\\:hover\\:text-green-50:hover {\n    --text-opacity: 1;\n    color: #f3faf7;\n    color: rgba(243, 250, 247, var(--text-opacity));\n  }\n  .lg\\:hover\\:text-green-100:hover {\n    --text-opacity: 1;\n    color: #def7ec;\n    color: rgba(222, 247, 236, var(--text-opacity));\n  }\n  .lg\\:hover\\:text-green-200:hover {\n    --text-opacity: 1;\n    color: #bcf0da;\n    color: rgba(188, 240, 218, var(--text-opacity));\n  }\n  .lg\\:hover\\:text-green-300:hover {\n    --text-opacity: 1;\n    color: #84e1bc;\n    color: rgba(132, 225, 188, var(--text-opacity));\n  }\n  .lg\\:hover\\:text-green-400:hover {\n    --text-opacity: 1;\n    color: #31c48d;\n    color: rgba(49, 196, 141, var(--text-opacity));\n  }\n  .lg\\:hover\\:text-green-500:hover {\n    --text-opacity: 1;\n    color: #0e9f6e;\n    color: rgba(14, 159, 110, var(--text-opacity));\n  }\n  .lg\\:hover\\:text-green-600:hover {\n    --text-opacity: 1;\n    color: #057a55;\n    color: rgba(5, 122, 85, var(--text-opacity));\n  }\n  .lg\\:hover\\:text-green-700:hover {\n    --text-opacity: 1;\n    color: #046c4e;\n    color: rgba(4, 108, 78, var(--text-opacity));\n  }\n  .lg\\:hover\\:text-green-800:hover {\n    --text-opacity: 1;\n    color: #03543f;\n    color: rgba(3, 84, 63, var(--text-opacity));\n  }\n  .lg\\:hover\\:text-green-900:hover {\n    --text-opacity: 1;\n    color: #014737;\n    color: rgba(1, 71, 55, var(--text-opacity));\n  }\n  .lg\\:hover\\:text-teal-50:hover {\n    --text-opacity: 1;\n    color: #edfafa;\n    color: rgba(237, 250, 250, var(--text-opacity));\n  }\n  .lg\\:hover\\:text-teal-100:hover {\n    --text-opacity: 1;\n    color: #d5f5f6;\n    color: rgba(213, 245, 246, var(--text-opacity));\n  }\n  .lg\\:hover\\:text-teal-200:hover {\n    --text-opacity: 1;\n    color: #afecef;\n    color: rgba(175, 236, 239, var(--text-opacity));\n  }\n  .lg\\:hover\\:text-teal-300:hover {\n    --text-opacity: 1;\n    color: #7edce2;\n    color: rgba(126, 220, 226, var(--text-opacity));\n  }\n  .lg\\:hover\\:text-teal-400:hover {\n    --text-opacity: 1;\n    color: #16bdca;\n    color: rgba(22, 189, 202, var(--text-opacity));\n  }\n  .lg\\:hover\\:text-teal-500:hover {\n    --text-opacity: 1;\n    color: #0694a2;\n    color: rgba(6, 148, 162, var(--text-opacity));\n  }\n  .lg\\:hover\\:text-teal-600:hover {\n    --text-opacity: 1;\n    color: #047481;\n    color: rgba(4, 116, 129, var(--text-opacity));\n  }\n  .lg\\:hover\\:text-teal-700:hover {\n    --text-opacity: 1;\n    color: #036672;\n    color: rgba(3, 102, 114, var(--text-opacity));\n  }\n  .lg\\:hover\\:text-teal-800:hover {\n    --text-opacity: 1;\n    color: #05505c;\n    color: rgba(5, 80, 92, var(--text-opacity));\n  }\n  .lg\\:hover\\:text-teal-900:hover {\n    --text-opacity: 1;\n    color: #014451;\n    color: rgba(1, 68, 81, var(--text-opacity));\n  }\n  .lg\\:hover\\:text-blue-50:hover {\n    --text-opacity: 1;\n    color: #ebf5ff;\n    color: rgba(235, 245, 255, var(--text-opacity));\n  }\n  .lg\\:hover\\:text-blue-100:hover {\n    --text-opacity: 1;\n    color: #e1effe;\n    color: rgba(225, 239, 254, var(--text-opacity));\n  }\n  .lg\\:hover\\:text-blue-200:hover {\n    --text-opacity: 1;\n    color: #c3ddfd;\n    color: rgba(195, 221, 253, var(--text-opacity));\n  }\n  .lg\\:hover\\:text-blue-300:hover {\n    --text-opacity: 1;\n    color: #a4cafe;\n    color: rgba(164, 202, 254, var(--text-opacity));\n  }\n  .lg\\:hover\\:text-blue-400:hover {\n    --text-opacity: 1;\n    color: #76a9fa;\n    color: rgba(118, 169, 250, var(--text-opacity));\n  }\n  .lg\\:hover\\:text-blue-500:hover {\n    --text-opacity: 1;\n    color: #3f83f8;\n    color: rgba(63, 131, 248, var(--text-opacity));\n  }\n  .lg\\:hover\\:text-blue-600:hover {\n    --text-opacity: 1;\n    color: #1c64f2;\n    color: rgba(28, 100, 242, var(--text-opacity));\n  }\n  .lg\\:hover\\:text-blue-700:hover {\n    --text-opacity: 1;\n    color: #1a56db;\n    color: rgba(26, 86, 219, var(--text-opacity));\n  }\n  .lg\\:hover\\:text-blue-800:hover {\n    --text-opacity: 1;\n    color: #1e429f;\n    color: rgba(30, 66, 159, var(--text-opacity));\n  }\n  .lg\\:hover\\:text-blue-900:hover {\n    --text-opacity: 1;\n    color: #233876;\n    color: rgba(35, 56, 118, var(--text-opacity));\n  }\n  .lg\\:hover\\:text-indigo-50:hover {\n    --text-opacity: 1;\n    color: #f0f5ff;\n    color: rgba(240, 245, 255, var(--text-opacity));\n  }\n  .lg\\:hover\\:text-indigo-100:hover {\n    --text-opacity: 1;\n    color: #e5edff;\n    color: rgba(229, 237, 255, var(--text-opacity));\n  }\n  .lg\\:hover\\:text-indigo-200:hover {\n    --text-opacity: 1;\n    color: #cddbfe;\n    color: rgba(205, 219, 254, var(--text-opacity));\n  }\n  .lg\\:hover\\:text-indigo-300:hover {\n    --text-opacity: 1;\n    color: #b4c6fc;\n    color: rgba(180, 198, 252, var(--text-opacity));\n  }\n  .lg\\:hover\\:text-indigo-400:hover {\n    --text-opacity: 1;\n    color: #8da2fb;\n    color: rgba(141, 162, 251, var(--text-opacity));\n  }\n  .lg\\:hover\\:text-indigo-500:hover {\n    --text-opacity: 1;\n    color: #6875f5;\n    color: rgba(104, 117, 245, var(--text-opacity));\n  }\n  .lg\\:hover\\:text-indigo-600:hover {\n    --text-opacity: 1;\n    color: #5850ec;\n    color: rgba(88, 80, 236, var(--text-opacity));\n  }\n  .lg\\:hover\\:text-indigo-700:hover {\n    --text-opacity: 1;\n    color: #5145cd;\n    color: rgba(81, 69, 205, var(--text-opacity));\n  }\n  .lg\\:hover\\:text-indigo-800:hover {\n    --text-opacity: 1;\n    color: #42389d;\n    color: rgba(66, 56, 157, var(--text-opacity));\n  }\n  .lg\\:hover\\:text-indigo-900:hover {\n    --text-opacity: 1;\n    color: #362f78;\n    color: rgba(54, 47, 120, var(--text-opacity));\n  }\n  .lg\\:hover\\:text-purple-50:hover {\n    --text-opacity: 1;\n    color: #f6f5ff;\n    color: rgba(246, 245, 255, var(--text-opacity));\n  }\n  .lg\\:hover\\:text-purple-100:hover {\n    --text-opacity: 1;\n    color: #edebfe;\n    color: rgba(237, 235, 254, var(--text-opacity));\n  }\n  .lg\\:hover\\:text-purple-200:hover {\n    --text-opacity: 1;\n    color: #dcd7fe;\n    color: rgba(220, 215, 254, var(--text-opacity));\n  }\n  .lg\\:hover\\:text-purple-300:hover {\n    --text-opacity: 1;\n    color: #cabffd;\n    color: rgba(202, 191, 253, var(--text-opacity));\n  }\n  .lg\\:hover\\:text-purple-400:hover {\n    --text-opacity: 1;\n    color: #ac94fa;\n    color: rgba(172, 148, 250, var(--text-opacity));\n  }\n  .lg\\:hover\\:text-purple-500:hover {\n    --text-opacity: 1;\n    color: #9061f9;\n    color: rgba(144, 97, 249, var(--text-opacity));\n  }\n  .lg\\:hover\\:text-purple-600:hover {\n    --text-opacity: 1;\n    color: #7e3af2;\n    color: rgba(126, 58, 242, var(--text-opacity));\n  }\n  .lg\\:hover\\:text-purple-700:hover {\n    --text-opacity: 1;\n    color: #6c2bd9;\n    color: rgba(108, 43, 217, var(--text-opacity));\n  }\n  .lg\\:hover\\:text-purple-800:hover {\n    --text-opacity: 1;\n    color: #5521b5;\n    color: rgba(85, 33, 181, var(--text-opacity));\n  }\n  .lg\\:hover\\:text-purple-900:hover {\n    --text-opacity: 1;\n    color: #4a1d96;\n    color: rgba(74, 29, 150, var(--text-opacity));\n  }\n  .lg\\:hover\\:text-pink-50:hover {\n    --text-opacity: 1;\n    color: #fdf2f8;\n    color: rgba(253, 242, 248, var(--text-opacity));\n  }\n  .lg\\:hover\\:text-pink-100:hover {\n    --text-opacity: 1;\n    color: #fce8f3;\n    color: rgba(252, 232, 243, var(--text-opacity));\n  }\n  .lg\\:hover\\:text-pink-200:hover {\n    --text-opacity: 1;\n    color: #fad1e8;\n    color: rgba(250, 209, 232, var(--text-opacity));\n  }\n  .lg\\:hover\\:text-pink-300:hover {\n    --text-opacity: 1;\n    color: #f8b4d9;\n    color: rgba(248, 180, 217, var(--text-opacity));\n  }\n  .lg\\:hover\\:text-pink-400:hover {\n    --text-opacity: 1;\n    color: #f17eb8;\n    color: rgba(241, 126, 184, var(--text-opacity));\n  }\n  .lg\\:hover\\:text-pink-500:hover {\n    --text-opacity: 1;\n    color: #e74694;\n    color: rgba(231, 70, 148, var(--text-opacity));\n  }\n  .lg\\:hover\\:text-pink-600:hover {\n    --text-opacity: 1;\n    color: #d61f69;\n    color: rgba(214, 31, 105, var(--text-opacity));\n  }\n  .lg\\:hover\\:text-pink-700:hover {\n    --text-opacity: 1;\n    color: #bf125d;\n    color: rgba(191, 18, 93, var(--text-opacity));\n  }\n  .lg\\:hover\\:text-pink-800:hover {\n    --text-opacity: 1;\n    color: #99154b;\n    color: rgba(153, 21, 75, var(--text-opacity));\n  }\n  .lg\\:hover\\:text-pink-900:hover {\n    --text-opacity: 1;\n    color: #751a3d;\n    color: rgba(117, 26, 61, var(--text-opacity));\n  }\n  .lg\\:hover\\:text-cool-gray-50:hover {\n    --text-opacity: 1;\n    color: #f8fafc;\n    color: rgba(248, 250, 252, var(--text-opacity));\n  }\n  .lg\\:hover\\:text-cool-gray-100:hover {\n    --text-opacity: 1;\n    color: #f1f5f9;\n    color: rgba(241, 245, 249, var(--text-opacity));\n  }\n  .lg\\:hover\\:text-cool-gray-200:hover {\n    --text-opacity: 1;\n    color: #e2e8f0;\n    color: rgba(226, 232, 240, var(--text-opacity));\n  }\n  .lg\\:hover\\:text-cool-gray-300:hover {\n    --text-opacity: 1;\n    color: #cfd8e3;\n    color: rgba(207, 216, 227, var(--text-opacity));\n  }\n  .lg\\:hover\\:text-cool-gray-400:hover {\n    --text-opacity: 1;\n    color: #97a6ba;\n    color: rgba(151, 166, 186, var(--text-opacity));\n  }\n  .lg\\:hover\\:text-cool-gray-500:hover {\n    --text-opacity: 1;\n    color: #64748b;\n    color: rgba(100, 116, 139, var(--text-opacity));\n  }\n  .lg\\:hover\\:text-cool-gray-600:hover {\n    --text-opacity: 1;\n    color: #475569;\n    color: rgba(71, 85, 105, var(--text-opacity));\n  }\n  .lg\\:hover\\:text-cool-gray-700:hover {\n    --text-opacity: 1;\n    color: #364152;\n    color: rgba(54, 65, 82, var(--text-opacity));\n  }\n  .lg\\:hover\\:text-cool-gray-800:hover {\n    --text-opacity: 1;\n    color: #27303f;\n    color: rgba(39, 48, 63, var(--text-opacity));\n  }\n  .lg\\:hover\\:text-cool-gray-900:hover {\n    --text-opacity: 1;\n    color: #1a202e;\n    color: rgba(26, 32, 46, var(--text-opacity));\n  }\n  .lg\\:focus-within\\:text-current:focus-within {\n    color: currentColor;\n  }\n  .lg\\:focus-within\\:text-transparent:focus-within {\n    color: transparent;\n  }\n  .lg\\:focus-within\\:text-white:focus-within {\n    --text-opacity: 1;\n    color: #ffffff;\n    color: rgba(255, 255, 255, var(--text-opacity));\n  }\n  .lg\\:focus-within\\:text-black:focus-within {\n    --text-opacity: 1;\n    color: #000000;\n    color: rgba(0, 0, 0, var(--text-opacity));\n  }\n  .lg\\:focus-within\\:text-gray-50:focus-within {\n    --text-opacity: 1;\n    color: #f9fafb;\n    color: rgba(249, 250, 251, var(--text-opacity));\n  }\n  .lg\\:focus-within\\:text-gray-100:focus-within {\n    --text-opacity: 1;\n    color: #f4f5f7;\n    color: rgba(244, 245, 247, var(--text-opacity));\n  }\n  .lg\\:focus-within\\:text-gray-200:focus-within {\n    --text-opacity: 1;\n    color: #e5e7eb;\n    color: rgba(229, 231, 235, var(--text-opacity));\n  }\n  .lg\\:focus-within\\:text-gray-300:focus-within {\n    --text-opacity: 1;\n    color: #d2d6dc;\n    color: rgba(210, 214, 220, var(--text-opacity));\n  }\n  .lg\\:focus-within\\:text-gray-400:focus-within {\n    --text-opacity: 1;\n    color: #9fa6b2;\n    color: rgba(159, 166, 178, var(--text-opacity));\n  }\n  .lg\\:focus-within\\:text-gray-500:focus-within {\n    --text-opacity: 1;\n    color: #6b7280;\n    color: rgba(107, 114, 128, var(--text-opacity));\n  }\n  .lg\\:focus-within\\:text-gray-600:focus-within {\n    --text-opacity: 1;\n    color: #4b5563;\n    color: rgba(75, 85, 99, var(--text-opacity));\n  }\n  .lg\\:focus-within\\:text-gray-700:focus-within {\n    --text-opacity: 1;\n    color: #374151;\n    color: rgba(55, 65, 81, var(--text-opacity));\n  }\n  .lg\\:focus-within\\:text-gray-800:focus-within {\n    --text-opacity: 1;\n    color: #252f3f;\n    color: rgba(37, 47, 63, var(--text-opacity));\n  }\n  .lg\\:focus-within\\:text-gray-900:focus-within {\n    --text-opacity: 1;\n    color: #161e2e;\n    color: rgba(22, 30, 46, var(--text-opacity));\n  }\n  .lg\\:focus-within\\:text-red-50:focus-within {\n    --text-opacity: 1;\n    color: #fdf2f2;\n    color: rgba(253, 242, 242, var(--text-opacity));\n  }\n  .lg\\:focus-within\\:text-red-100:focus-within {\n    --text-opacity: 1;\n    color: #fde8e8;\n    color: rgba(253, 232, 232, var(--text-opacity));\n  }\n  .lg\\:focus-within\\:text-red-200:focus-within {\n    --text-opacity: 1;\n    color: #fbd5d5;\n    color: rgba(251, 213, 213, var(--text-opacity));\n  }\n  .lg\\:focus-within\\:text-red-300:focus-within {\n    --text-opacity: 1;\n    color: #f8b4b4;\n    color: rgba(248, 180, 180, var(--text-opacity));\n  }\n  .lg\\:focus-within\\:text-red-400:focus-within {\n    --text-opacity: 1;\n    color: #f98080;\n    color: rgba(249, 128, 128, var(--text-opacity));\n  }\n  .lg\\:focus-within\\:text-red-500:focus-within {\n    --text-opacity: 1;\n    color: #f05252;\n    color: rgba(240, 82, 82, var(--text-opacity));\n  }\n  .lg\\:focus-within\\:text-red-600:focus-within {\n    --text-opacity: 1;\n    color: #e02424;\n    color: rgba(224, 36, 36, var(--text-opacity));\n  }\n  .lg\\:focus-within\\:text-red-700:focus-within {\n    --text-opacity: 1;\n    color: #c81e1e;\n    color: rgba(200, 30, 30, var(--text-opacity));\n  }\n  .lg\\:focus-within\\:text-red-800:focus-within {\n    --text-opacity: 1;\n    color: #9b1c1c;\n    color: rgba(155, 28, 28, var(--text-opacity));\n  }\n  .lg\\:focus-within\\:text-red-900:focus-within {\n    --text-opacity: 1;\n    color: #771d1d;\n    color: rgba(119, 29, 29, var(--text-opacity));\n  }\n  .lg\\:focus-within\\:text-orange-50:focus-within {\n    --text-opacity: 1;\n    color: #fff8f1;\n    color: rgba(255, 248, 241, var(--text-opacity));\n  }\n  .lg\\:focus-within\\:text-orange-100:focus-within {\n    --text-opacity: 1;\n    color: #feecdc;\n    color: rgba(254, 236, 220, var(--text-opacity));\n  }\n  .lg\\:focus-within\\:text-orange-200:focus-within {\n    --text-opacity: 1;\n    color: #fcd9bd;\n    color: rgba(252, 217, 189, var(--text-opacity));\n  }\n  .lg\\:focus-within\\:text-orange-300:focus-within {\n    --text-opacity: 1;\n    color: #fdba8c;\n    color: rgba(253, 186, 140, var(--text-opacity));\n  }\n  .lg\\:focus-within\\:text-orange-400:focus-within {\n    --text-opacity: 1;\n    color: #ff8a4c;\n    color: rgba(255, 138, 76, var(--text-opacity));\n  }\n  .lg\\:focus-within\\:text-orange-500:focus-within {\n    --text-opacity: 1;\n    color: #ff5a1f;\n    color: rgba(255, 90, 31, var(--text-opacity));\n  }\n  .lg\\:focus-within\\:text-orange-600:focus-within {\n    --text-opacity: 1;\n    color: #d03801;\n    color: rgba(208, 56, 1, var(--text-opacity));\n  }\n  .lg\\:focus-within\\:text-orange-700:focus-within {\n    --text-opacity: 1;\n    color: #b43403;\n    color: rgba(180, 52, 3, var(--text-opacity));\n  }\n  .lg\\:focus-within\\:text-orange-800:focus-within {\n    --text-opacity: 1;\n    color: #8a2c0d;\n    color: rgba(138, 44, 13, var(--text-opacity));\n  }\n  .lg\\:focus-within\\:text-orange-900:focus-within {\n    --text-opacity: 1;\n    color: #73230d;\n    color: rgba(115, 35, 13, var(--text-opacity));\n  }\n  .lg\\:focus-within\\:text-yellow-50:focus-within {\n    --text-opacity: 1;\n    color: #fdfdea;\n    color: rgba(253, 253, 234, var(--text-opacity));\n  }\n  .lg\\:focus-within\\:text-yellow-100:focus-within {\n    --text-opacity: 1;\n    color: #fdf6b2;\n    color: rgba(253, 246, 178, var(--text-opacity));\n  }\n  .lg\\:focus-within\\:text-yellow-200:focus-within {\n    --text-opacity: 1;\n    color: #fce96a;\n    color: rgba(252, 233, 106, var(--text-opacity));\n  }\n  .lg\\:focus-within\\:text-yellow-300:focus-within {\n    --text-opacity: 1;\n    color: #faca15;\n    color: rgba(250, 202, 21, var(--text-opacity));\n  }\n  .lg\\:focus-within\\:text-yellow-400:focus-within {\n    --text-opacity: 1;\n    color: #e3a008;\n    color: rgba(227, 160, 8, var(--text-opacity));\n  }\n  .lg\\:focus-within\\:text-yellow-500:focus-within {\n    --text-opacity: 1;\n    color: #c27803;\n    color: rgba(194, 120, 3, var(--text-opacity));\n  }\n  .lg\\:focus-within\\:text-yellow-600:focus-within {\n    --text-opacity: 1;\n    color: #9f580a;\n    color: rgba(159, 88, 10, var(--text-opacity));\n  }\n  .lg\\:focus-within\\:text-yellow-700:focus-within {\n    --text-opacity: 1;\n    color: #8e4b10;\n    color: rgba(142, 75, 16, var(--text-opacity));\n  }\n  .lg\\:focus-within\\:text-yellow-800:focus-within {\n    --text-opacity: 1;\n    color: #723b13;\n    color: rgba(114, 59, 19, var(--text-opacity));\n  }\n  .lg\\:focus-within\\:text-yellow-900:focus-within {\n    --text-opacity: 1;\n    color: #633112;\n    color: rgba(99, 49, 18, var(--text-opacity));\n  }\n  .lg\\:focus-within\\:text-green-50:focus-within {\n    --text-opacity: 1;\n    color: #f3faf7;\n    color: rgba(243, 250, 247, var(--text-opacity));\n  }\n  .lg\\:focus-within\\:text-green-100:focus-within {\n    --text-opacity: 1;\n    color: #def7ec;\n    color: rgba(222, 247, 236, var(--text-opacity));\n  }\n  .lg\\:focus-within\\:text-green-200:focus-within {\n    --text-opacity: 1;\n    color: #bcf0da;\n    color: rgba(188, 240, 218, var(--text-opacity));\n  }\n  .lg\\:focus-within\\:text-green-300:focus-within {\n    --text-opacity: 1;\n    color: #84e1bc;\n    color: rgba(132, 225, 188, var(--text-opacity));\n  }\n  .lg\\:focus-within\\:text-green-400:focus-within {\n    --text-opacity: 1;\n    color: #31c48d;\n    color: rgba(49, 196, 141, var(--text-opacity));\n  }\n  .lg\\:focus-within\\:text-green-500:focus-within {\n    --text-opacity: 1;\n    color: #0e9f6e;\n    color: rgba(14, 159, 110, var(--text-opacity));\n  }\n  .lg\\:focus-within\\:text-green-600:focus-within {\n    --text-opacity: 1;\n    color: #057a55;\n    color: rgba(5, 122, 85, var(--text-opacity));\n  }\n  .lg\\:focus-within\\:text-green-700:focus-within {\n    --text-opacity: 1;\n    color: #046c4e;\n    color: rgba(4, 108, 78, var(--text-opacity));\n  }\n  .lg\\:focus-within\\:text-green-800:focus-within {\n    --text-opacity: 1;\n    color: #03543f;\n    color: rgba(3, 84, 63, var(--text-opacity));\n  }\n  .lg\\:focus-within\\:text-green-900:focus-within {\n    --text-opacity: 1;\n    color: #014737;\n    color: rgba(1, 71, 55, var(--text-opacity));\n  }\n  .lg\\:focus-within\\:text-teal-50:focus-within {\n    --text-opacity: 1;\n    color: #edfafa;\n    color: rgba(237, 250, 250, var(--text-opacity));\n  }\n  .lg\\:focus-within\\:text-teal-100:focus-within {\n    --text-opacity: 1;\n    color: #d5f5f6;\n    color: rgba(213, 245, 246, var(--text-opacity));\n  }\n  .lg\\:focus-within\\:text-teal-200:focus-within {\n    --text-opacity: 1;\n    color: #afecef;\n    color: rgba(175, 236, 239, var(--text-opacity));\n  }\n  .lg\\:focus-within\\:text-teal-300:focus-within {\n    --text-opacity: 1;\n    color: #7edce2;\n    color: rgba(126, 220, 226, var(--text-opacity));\n  }\n  .lg\\:focus-within\\:text-teal-400:focus-within {\n    --text-opacity: 1;\n    color: #16bdca;\n    color: rgba(22, 189, 202, var(--text-opacity));\n  }\n  .lg\\:focus-within\\:text-teal-500:focus-within {\n    --text-opacity: 1;\n    color: #0694a2;\n    color: rgba(6, 148, 162, var(--text-opacity));\n  }\n  .lg\\:focus-within\\:text-teal-600:focus-within {\n    --text-opacity: 1;\n    color: #047481;\n    color: rgba(4, 116, 129, var(--text-opacity));\n  }\n  .lg\\:focus-within\\:text-teal-700:focus-within {\n    --text-opacity: 1;\n    color: #036672;\n    color: rgba(3, 102, 114, var(--text-opacity));\n  }\n  .lg\\:focus-within\\:text-teal-800:focus-within {\n    --text-opacity: 1;\n    color: #05505c;\n    color: rgba(5, 80, 92, var(--text-opacity));\n  }\n  .lg\\:focus-within\\:text-teal-900:focus-within {\n    --text-opacity: 1;\n    color: #014451;\n    color: rgba(1, 68, 81, var(--text-opacity));\n  }\n  .lg\\:focus-within\\:text-blue-50:focus-within {\n    --text-opacity: 1;\n    color: #ebf5ff;\n    color: rgba(235, 245, 255, var(--text-opacity));\n  }\n  .lg\\:focus-within\\:text-blue-100:focus-within {\n    --text-opacity: 1;\n    color: #e1effe;\n    color: rgba(225, 239, 254, var(--text-opacity));\n  }\n  .lg\\:focus-within\\:text-blue-200:focus-within {\n    --text-opacity: 1;\n    color: #c3ddfd;\n    color: rgba(195, 221, 253, var(--text-opacity));\n  }\n  .lg\\:focus-within\\:text-blue-300:focus-within {\n    --text-opacity: 1;\n    color: #a4cafe;\n    color: rgba(164, 202, 254, var(--text-opacity));\n  }\n  .lg\\:focus-within\\:text-blue-400:focus-within {\n    --text-opacity: 1;\n    color: #76a9fa;\n    color: rgba(118, 169, 250, var(--text-opacity));\n  }\n  .lg\\:focus-within\\:text-blue-500:focus-within {\n    --text-opacity: 1;\n    color: #3f83f8;\n    color: rgba(63, 131, 248, var(--text-opacity));\n  }\n  .lg\\:focus-within\\:text-blue-600:focus-within {\n    --text-opacity: 1;\n    color: #1c64f2;\n    color: rgba(28, 100, 242, var(--text-opacity));\n  }\n  .lg\\:focus-within\\:text-blue-700:focus-within {\n    --text-opacity: 1;\n    color: #1a56db;\n    color: rgba(26, 86, 219, var(--text-opacity));\n  }\n  .lg\\:focus-within\\:text-blue-800:focus-within {\n    --text-opacity: 1;\n    color: #1e429f;\n    color: rgba(30, 66, 159, var(--text-opacity));\n  }\n  .lg\\:focus-within\\:text-blue-900:focus-within {\n    --text-opacity: 1;\n    color: #233876;\n    color: rgba(35, 56, 118, var(--text-opacity));\n  }\n  .lg\\:focus-within\\:text-indigo-50:focus-within {\n    --text-opacity: 1;\n    color: #f0f5ff;\n    color: rgba(240, 245, 255, var(--text-opacity));\n  }\n  .lg\\:focus-within\\:text-indigo-100:focus-within {\n    --text-opacity: 1;\n    color: #e5edff;\n    color: rgba(229, 237, 255, var(--text-opacity));\n  }\n  .lg\\:focus-within\\:text-indigo-200:focus-within {\n    --text-opacity: 1;\n    color: #cddbfe;\n    color: rgba(205, 219, 254, var(--text-opacity));\n  }\n  .lg\\:focus-within\\:text-indigo-300:focus-within {\n    --text-opacity: 1;\n    color: #b4c6fc;\n    color: rgba(180, 198, 252, var(--text-opacity));\n  }\n  .lg\\:focus-within\\:text-indigo-400:focus-within {\n    --text-opacity: 1;\n    color: #8da2fb;\n    color: rgba(141, 162, 251, var(--text-opacity));\n  }\n  .lg\\:focus-within\\:text-indigo-500:focus-within {\n    --text-opacity: 1;\n    color: #6875f5;\n    color: rgba(104, 117, 245, var(--text-opacity));\n  }\n  .lg\\:focus-within\\:text-indigo-600:focus-within {\n    --text-opacity: 1;\n    color: #5850ec;\n    color: rgba(88, 80, 236, var(--text-opacity));\n  }\n  .lg\\:focus-within\\:text-indigo-700:focus-within {\n    --text-opacity: 1;\n    color: #5145cd;\n    color: rgba(81, 69, 205, var(--text-opacity));\n  }\n  .lg\\:focus-within\\:text-indigo-800:focus-within {\n    --text-opacity: 1;\n    color: #42389d;\n    color: rgba(66, 56, 157, var(--text-opacity));\n  }\n  .lg\\:focus-within\\:text-indigo-900:focus-within {\n    --text-opacity: 1;\n    color: #362f78;\n    color: rgba(54, 47, 120, var(--text-opacity));\n  }\n  .lg\\:focus-within\\:text-purple-50:focus-within {\n    --text-opacity: 1;\n    color: #f6f5ff;\n    color: rgba(246, 245, 255, var(--text-opacity));\n  }\n  .lg\\:focus-within\\:text-purple-100:focus-within {\n    --text-opacity: 1;\n    color: #edebfe;\n    color: rgba(237, 235, 254, var(--text-opacity));\n  }\n  .lg\\:focus-within\\:text-purple-200:focus-within {\n    --text-opacity: 1;\n    color: #dcd7fe;\n    color: rgba(220, 215, 254, var(--text-opacity));\n  }\n  .lg\\:focus-within\\:text-purple-300:focus-within {\n    --text-opacity: 1;\n    color: #cabffd;\n    color: rgba(202, 191, 253, var(--text-opacity));\n  }\n  .lg\\:focus-within\\:text-purple-400:focus-within {\n    --text-opacity: 1;\n    color: #ac94fa;\n    color: rgba(172, 148, 250, var(--text-opacity));\n  }\n  .lg\\:focus-within\\:text-purple-500:focus-within {\n    --text-opacity: 1;\n    color: #9061f9;\n    color: rgba(144, 97, 249, var(--text-opacity));\n  }\n  .lg\\:focus-within\\:text-purple-600:focus-within {\n    --text-opacity: 1;\n    color: #7e3af2;\n    color: rgba(126, 58, 242, var(--text-opacity));\n  }\n  .lg\\:focus-within\\:text-purple-700:focus-within {\n    --text-opacity: 1;\n    color: #6c2bd9;\n    color: rgba(108, 43, 217, var(--text-opacity));\n  }\n  .lg\\:focus-within\\:text-purple-800:focus-within {\n    --text-opacity: 1;\n    color: #5521b5;\n    color: rgba(85, 33, 181, var(--text-opacity));\n  }\n  .lg\\:focus-within\\:text-purple-900:focus-within {\n    --text-opacity: 1;\n    color: #4a1d96;\n    color: rgba(74, 29, 150, var(--text-opacity));\n  }\n  .lg\\:focus-within\\:text-pink-50:focus-within {\n    --text-opacity: 1;\n    color: #fdf2f8;\n    color: rgba(253, 242, 248, var(--text-opacity));\n  }\n  .lg\\:focus-within\\:text-pink-100:focus-within {\n    --text-opacity: 1;\n    color: #fce8f3;\n    color: rgba(252, 232, 243, var(--text-opacity));\n  }\n  .lg\\:focus-within\\:text-pink-200:focus-within {\n    --text-opacity: 1;\n    color: #fad1e8;\n    color: rgba(250, 209, 232, var(--text-opacity));\n  }\n  .lg\\:focus-within\\:text-pink-300:focus-within {\n    --text-opacity: 1;\n    color: #f8b4d9;\n    color: rgba(248, 180, 217, var(--text-opacity));\n  }\n  .lg\\:focus-within\\:text-pink-400:focus-within {\n    --text-opacity: 1;\n    color: #f17eb8;\n    color: rgba(241, 126, 184, var(--text-opacity));\n  }\n  .lg\\:focus-within\\:text-pink-500:focus-within {\n    --text-opacity: 1;\n    color: #e74694;\n    color: rgba(231, 70, 148, var(--text-opacity));\n  }\n  .lg\\:focus-within\\:text-pink-600:focus-within {\n    --text-opacity: 1;\n    color: #d61f69;\n    color: rgba(214, 31, 105, var(--text-opacity));\n  }\n  .lg\\:focus-within\\:text-pink-700:focus-within {\n    --text-opacity: 1;\n    color: #bf125d;\n    color: rgba(191, 18, 93, var(--text-opacity));\n  }\n  .lg\\:focus-within\\:text-pink-800:focus-within {\n    --text-opacity: 1;\n    color: #99154b;\n    color: rgba(153, 21, 75, var(--text-opacity));\n  }\n  .lg\\:focus-within\\:text-pink-900:focus-within {\n    --text-opacity: 1;\n    color: #751a3d;\n    color: rgba(117, 26, 61, var(--text-opacity));\n  }\n  .lg\\:focus-within\\:text-cool-gray-50:focus-within {\n    --text-opacity: 1;\n    color: #f8fafc;\n    color: rgba(248, 250, 252, var(--text-opacity));\n  }\n  .lg\\:focus-within\\:text-cool-gray-100:focus-within {\n    --text-opacity: 1;\n    color: #f1f5f9;\n    color: rgba(241, 245, 249, var(--text-opacity));\n  }\n  .lg\\:focus-within\\:text-cool-gray-200:focus-within {\n    --text-opacity: 1;\n    color: #e2e8f0;\n    color: rgba(226, 232, 240, var(--text-opacity));\n  }\n  .lg\\:focus-within\\:text-cool-gray-300:focus-within {\n    --text-opacity: 1;\n    color: #cfd8e3;\n    color: rgba(207, 216, 227, var(--text-opacity));\n  }\n  .lg\\:focus-within\\:text-cool-gray-400:focus-within {\n    --text-opacity: 1;\n    color: #97a6ba;\n    color: rgba(151, 166, 186, var(--text-opacity));\n  }\n  .lg\\:focus-within\\:text-cool-gray-500:focus-within {\n    --text-opacity: 1;\n    color: #64748b;\n    color: rgba(100, 116, 139, var(--text-opacity));\n  }\n  .lg\\:focus-within\\:text-cool-gray-600:focus-within {\n    --text-opacity: 1;\n    color: #475569;\n    color: rgba(71, 85, 105, var(--text-opacity));\n  }\n  .lg\\:focus-within\\:text-cool-gray-700:focus-within {\n    --text-opacity: 1;\n    color: #364152;\n    color: rgba(54, 65, 82, var(--text-opacity));\n  }\n  .lg\\:focus-within\\:text-cool-gray-800:focus-within {\n    --text-opacity: 1;\n    color: #27303f;\n    color: rgba(39, 48, 63, var(--text-opacity));\n  }\n  .lg\\:focus-within\\:text-cool-gray-900:focus-within {\n    --text-opacity: 1;\n    color: #1a202e;\n    color: rgba(26, 32, 46, var(--text-opacity));\n  }\n  .lg\\:focus\\:text-current:focus {\n    color: currentColor;\n  }\n  .lg\\:focus\\:text-transparent:focus {\n    color: transparent;\n  }\n  .lg\\:focus\\:text-white:focus {\n    --text-opacity: 1;\n    color: #ffffff;\n    color: rgba(255, 255, 255, var(--text-opacity));\n  }\n  .lg\\:focus\\:text-black:focus {\n    --text-opacity: 1;\n    color: #000000;\n    color: rgba(0, 0, 0, var(--text-opacity));\n  }\n  .lg\\:focus\\:text-gray-50:focus {\n    --text-opacity: 1;\n    color: #f9fafb;\n    color: rgba(249, 250, 251, var(--text-opacity));\n  }\n  .lg\\:focus\\:text-gray-100:focus {\n    --text-opacity: 1;\n    color: #f4f5f7;\n    color: rgba(244, 245, 247, var(--text-opacity));\n  }\n  .lg\\:focus\\:text-gray-200:focus {\n    --text-opacity: 1;\n    color: #e5e7eb;\n    color: rgba(229, 231, 235, var(--text-opacity));\n  }\n  .lg\\:focus\\:text-gray-300:focus {\n    --text-opacity: 1;\n    color: #d2d6dc;\n    color: rgba(210, 214, 220, var(--text-opacity));\n  }\n  .lg\\:focus\\:text-gray-400:focus {\n    --text-opacity: 1;\n    color: #9fa6b2;\n    color: rgba(159, 166, 178, var(--text-opacity));\n  }\n  .lg\\:focus\\:text-gray-500:focus {\n    --text-opacity: 1;\n    color: #6b7280;\n    color: rgba(107, 114, 128, var(--text-opacity));\n  }\n  .lg\\:focus\\:text-gray-600:focus {\n    --text-opacity: 1;\n    color: #4b5563;\n    color: rgba(75, 85, 99, var(--text-opacity));\n  }\n  .lg\\:focus\\:text-gray-700:focus {\n    --text-opacity: 1;\n    color: #374151;\n    color: rgba(55, 65, 81, var(--text-opacity));\n  }\n  .lg\\:focus\\:text-gray-800:focus {\n    --text-opacity: 1;\n    color: #252f3f;\n    color: rgba(37, 47, 63, var(--text-opacity));\n  }\n  .lg\\:focus\\:text-gray-900:focus {\n    --text-opacity: 1;\n    color: #161e2e;\n    color: rgba(22, 30, 46, var(--text-opacity));\n  }\n  .lg\\:focus\\:text-red-50:focus {\n    --text-opacity: 1;\n    color: #fdf2f2;\n    color: rgba(253, 242, 242, var(--text-opacity));\n  }\n  .lg\\:focus\\:text-red-100:focus {\n    --text-opacity: 1;\n    color: #fde8e8;\n    color: rgba(253, 232, 232, var(--text-opacity));\n  }\n  .lg\\:focus\\:text-red-200:focus {\n    --text-opacity: 1;\n    color: #fbd5d5;\n    color: rgba(251, 213, 213, var(--text-opacity));\n  }\n  .lg\\:focus\\:text-red-300:focus {\n    --text-opacity: 1;\n    color: #f8b4b4;\n    color: rgba(248, 180, 180, var(--text-opacity));\n  }\n  .lg\\:focus\\:text-red-400:focus {\n    --text-opacity: 1;\n    color: #f98080;\n    color: rgba(249, 128, 128, var(--text-opacity));\n  }\n  .lg\\:focus\\:text-red-500:focus {\n    --text-opacity: 1;\n    color: #f05252;\n    color: rgba(240, 82, 82, var(--text-opacity));\n  }\n  .lg\\:focus\\:text-red-600:focus {\n    --text-opacity: 1;\n    color: #e02424;\n    color: rgba(224, 36, 36, var(--text-opacity));\n  }\n  .lg\\:focus\\:text-red-700:focus {\n    --text-opacity: 1;\n    color: #c81e1e;\n    color: rgba(200, 30, 30, var(--text-opacity));\n  }\n  .lg\\:focus\\:text-red-800:focus {\n    --text-opacity: 1;\n    color: #9b1c1c;\n    color: rgba(155, 28, 28, var(--text-opacity));\n  }\n  .lg\\:focus\\:text-red-900:focus {\n    --text-opacity: 1;\n    color: #771d1d;\n    color: rgba(119, 29, 29, var(--text-opacity));\n  }\n  .lg\\:focus\\:text-orange-50:focus {\n    --text-opacity: 1;\n    color: #fff8f1;\n    color: rgba(255, 248, 241, var(--text-opacity));\n  }\n  .lg\\:focus\\:text-orange-100:focus {\n    --text-opacity: 1;\n    color: #feecdc;\n    color: rgba(254, 236, 220, var(--text-opacity));\n  }\n  .lg\\:focus\\:text-orange-200:focus {\n    --text-opacity: 1;\n    color: #fcd9bd;\n    color: rgba(252, 217, 189, var(--text-opacity));\n  }\n  .lg\\:focus\\:text-orange-300:focus {\n    --text-opacity: 1;\n    color: #fdba8c;\n    color: rgba(253, 186, 140, var(--text-opacity));\n  }\n  .lg\\:focus\\:text-orange-400:focus {\n    --text-opacity: 1;\n    color: #ff8a4c;\n    color: rgba(255, 138, 76, var(--text-opacity));\n  }\n  .lg\\:focus\\:text-orange-500:focus {\n    --text-opacity: 1;\n    color: #ff5a1f;\n    color: rgba(255, 90, 31, var(--text-opacity));\n  }\n  .lg\\:focus\\:text-orange-600:focus {\n    --text-opacity: 1;\n    color: #d03801;\n    color: rgba(208, 56, 1, var(--text-opacity));\n  }\n  .lg\\:focus\\:text-orange-700:focus {\n    --text-opacity: 1;\n    color: #b43403;\n    color: rgba(180, 52, 3, var(--text-opacity));\n  }\n  .lg\\:focus\\:text-orange-800:focus {\n    --text-opacity: 1;\n    color: #8a2c0d;\n    color: rgba(138, 44, 13, var(--text-opacity));\n  }\n  .lg\\:focus\\:text-orange-900:focus {\n    --text-opacity: 1;\n    color: #73230d;\n    color: rgba(115, 35, 13, var(--text-opacity));\n  }\n  .lg\\:focus\\:text-yellow-50:focus {\n    --text-opacity: 1;\n    color: #fdfdea;\n    color: rgba(253, 253, 234, var(--text-opacity));\n  }\n  .lg\\:focus\\:text-yellow-100:focus {\n    --text-opacity: 1;\n    color: #fdf6b2;\n    color: rgba(253, 246, 178, var(--text-opacity));\n  }\n  .lg\\:focus\\:text-yellow-200:focus {\n    --text-opacity: 1;\n    color: #fce96a;\n    color: rgba(252, 233, 106, var(--text-opacity));\n  }\n  .lg\\:focus\\:text-yellow-300:focus {\n    --text-opacity: 1;\n    color: #faca15;\n    color: rgba(250, 202, 21, var(--text-opacity));\n  }\n  .lg\\:focus\\:text-yellow-400:focus {\n    --text-opacity: 1;\n    color: #e3a008;\n    color: rgba(227, 160, 8, var(--text-opacity));\n  }\n  .lg\\:focus\\:text-yellow-500:focus {\n    --text-opacity: 1;\n    color: #c27803;\n    color: rgba(194, 120, 3, var(--text-opacity));\n  }\n  .lg\\:focus\\:text-yellow-600:focus {\n    --text-opacity: 1;\n    color: #9f580a;\n    color: rgba(159, 88, 10, var(--text-opacity));\n  }\n  .lg\\:focus\\:text-yellow-700:focus {\n    --text-opacity: 1;\n    color: #8e4b10;\n    color: rgba(142, 75, 16, var(--text-opacity));\n  }\n  .lg\\:focus\\:text-yellow-800:focus {\n    --text-opacity: 1;\n    color: #723b13;\n    color: rgba(114, 59, 19, var(--text-opacity));\n  }\n  .lg\\:focus\\:text-yellow-900:focus {\n    --text-opacity: 1;\n    color: #633112;\n    color: rgba(99, 49, 18, var(--text-opacity));\n  }\n  .lg\\:focus\\:text-green-50:focus {\n    --text-opacity: 1;\n    color: #f3faf7;\n    color: rgba(243, 250, 247, var(--text-opacity));\n  }\n  .lg\\:focus\\:text-green-100:focus {\n    --text-opacity: 1;\n    color: #def7ec;\n    color: rgba(222, 247, 236, var(--text-opacity));\n  }\n  .lg\\:focus\\:text-green-200:focus {\n    --text-opacity: 1;\n    color: #bcf0da;\n    color: rgba(188, 240, 218, var(--text-opacity));\n  }\n  .lg\\:focus\\:text-green-300:focus {\n    --text-opacity: 1;\n    color: #84e1bc;\n    color: rgba(132, 225, 188, var(--text-opacity));\n  }\n  .lg\\:focus\\:text-green-400:focus {\n    --text-opacity: 1;\n    color: #31c48d;\n    color: rgba(49, 196, 141, var(--text-opacity));\n  }\n  .lg\\:focus\\:text-green-500:focus {\n    --text-opacity: 1;\n    color: #0e9f6e;\n    color: rgba(14, 159, 110, var(--text-opacity));\n  }\n  .lg\\:focus\\:text-green-600:focus {\n    --text-opacity: 1;\n    color: #057a55;\n    color: rgba(5, 122, 85, var(--text-opacity));\n  }\n  .lg\\:focus\\:text-green-700:focus {\n    --text-opacity: 1;\n    color: #046c4e;\n    color: rgba(4, 108, 78, var(--text-opacity));\n  }\n  .lg\\:focus\\:text-green-800:focus {\n    --text-opacity: 1;\n    color: #03543f;\n    color: rgba(3, 84, 63, var(--text-opacity));\n  }\n  .lg\\:focus\\:text-green-900:focus {\n    --text-opacity: 1;\n    color: #014737;\n    color: rgba(1, 71, 55, var(--text-opacity));\n  }\n  .lg\\:focus\\:text-teal-50:focus {\n    --text-opacity: 1;\n    color: #edfafa;\n    color: rgba(237, 250, 250, var(--text-opacity));\n  }\n  .lg\\:focus\\:text-teal-100:focus {\n    --text-opacity: 1;\n    color: #d5f5f6;\n    color: rgba(213, 245, 246, var(--text-opacity));\n  }\n  .lg\\:focus\\:text-teal-200:focus {\n    --text-opacity: 1;\n    color: #afecef;\n    color: rgba(175, 236, 239, var(--text-opacity));\n  }\n  .lg\\:focus\\:text-teal-300:focus {\n    --text-opacity: 1;\n    color: #7edce2;\n    color: rgba(126, 220, 226, var(--text-opacity));\n  }\n  .lg\\:focus\\:text-teal-400:focus {\n    --text-opacity: 1;\n    color: #16bdca;\n    color: rgba(22, 189, 202, var(--text-opacity));\n  }\n  .lg\\:focus\\:text-teal-500:focus {\n    --text-opacity: 1;\n    color: #0694a2;\n    color: rgba(6, 148, 162, var(--text-opacity));\n  }\n  .lg\\:focus\\:text-teal-600:focus {\n    --text-opacity: 1;\n    color: #047481;\n    color: rgba(4, 116, 129, var(--text-opacity));\n  }\n  .lg\\:focus\\:text-teal-700:focus {\n    --text-opacity: 1;\n    color: #036672;\n    color: rgba(3, 102, 114, var(--text-opacity));\n  }\n  .lg\\:focus\\:text-teal-800:focus {\n    --text-opacity: 1;\n    color: #05505c;\n    color: rgba(5, 80, 92, var(--text-opacity));\n  }\n  .lg\\:focus\\:text-teal-900:focus {\n    --text-opacity: 1;\n    color: #014451;\n    color: rgba(1, 68, 81, var(--text-opacity));\n  }\n  .lg\\:focus\\:text-blue-50:focus {\n    --text-opacity: 1;\n    color: #ebf5ff;\n    color: rgba(235, 245, 255, var(--text-opacity));\n  }\n  .lg\\:focus\\:text-blue-100:focus {\n    --text-opacity: 1;\n    color: #e1effe;\n    color: rgba(225, 239, 254, var(--text-opacity));\n  }\n  .lg\\:focus\\:text-blue-200:focus {\n    --text-opacity: 1;\n    color: #c3ddfd;\n    color: rgba(195, 221, 253, var(--text-opacity));\n  }\n  .lg\\:focus\\:text-blue-300:focus {\n    --text-opacity: 1;\n    color: #a4cafe;\n    color: rgba(164, 202, 254, var(--text-opacity));\n  }\n  .lg\\:focus\\:text-blue-400:focus {\n    --text-opacity: 1;\n    color: #76a9fa;\n    color: rgba(118, 169, 250, var(--text-opacity));\n  }\n  .lg\\:focus\\:text-blue-500:focus {\n    --text-opacity: 1;\n    color: #3f83f8;\n    color: rgba(63, 131, 248, var(--text-opacity));\n  }\n  .lg\\:focus\\:text-blue-600:focus {\n    --text-opacity: 1;\n    color: #1c64f2;\n    color: rgba(28, 100, 242, var(--text-opacity));\n  }\n  .lg\\:focus\\:text-blue-700:focus {\n    --text-opacity: 1;\n    color: #1a56db;\n    color: rgba(26, 86, 219, var(--text-opacity));\n  }\n  .lg\\:focus\\:text-blue-800:focus {\n    --text-opacity: 1;\n    color: #1e429f;\n    color: rgba(30, 66, 159, var(--text-opacity));\n  }\n  .lg\\:focus\\:text-blue-900:focus {\n    --text-opacity: 1;\n    color: #233876;\n    color: rgba(35, 56, 118, var(--text-opacity));\n  }\n  .lg\\:focus\\:text-indigo-50:focus {\n    --text-opacity: 1;\n    color: #f0f5ff;\n    color: rgba(240, 245, 255, var(--text-opacity));\n  }\n  .lg\\:focus\\:text-indigo-100:focus {\n    --text-opacity: 1;\n    color: #e5edff;\n    color: rgba(229, 237, 255, var(--text-opacity));\n  }\n  .lg\\:focus\\:text-indigo-200:focus {\n    --text-opacity: 1;\n    color: #cddbfe;\n    color: rgba(205, 219, 254, var(--text-opacity));\n  }\n  .lg\\:focus\\:text-indigo-300:focus {\n    --text-opacity: 1;\n    color: #b4c6fc;\n    color: rgba(180, 198, 252, var(--text-opacity));\n  }\n  .lg\\:focus\\:text-indigo-400:focus {\n    --text-opacity: 1;\n    color: #8da2fb;\n    color: rgba(141, 162, 251, var(--text-opacity));\n  }\n  .lg\\:focus\\:text-indigo-500:focus {\n    --text-opacity: 1;\n    color: #6875f5;\n    color: rgba(104, 117, 245, var(--text-opacity));\n  }\n  .lg\\:focus\\:text-indigo-600:focus {\n    --text-opacity: 1;\n    color: #5850ec;\n    color: rgba(88, 80, 236, var(--text-opacity));\n  }\n  .lg\\:focus\\:text-indigo-700:focus {\n    --text-opacity: 1;\n    color: #5145cd;\n    color: rgba(81, 69, 205, var(--text-opacity));\n  }\n  .lg\\:focus\\:text-indigo-800:focus {\n    --text-opacity: 1;\n    color: #42389d;\n    color: rgba(66, 56, 157, var(--text-opacity));\n  }\n  .lg\\:focus\\:text-indigo-900:focus {\n    --text-opacity: 1;\n    color: #362f78;\n    color: rgba(54, 47, 120, var(--text-opacity));\n  }\n  .lg\\:focus\\:text-purple-50:focus {\n    --text-opacity: 1;\n    color: #f6f5ff;\n    color: rgba(246, 245, 255, var(--text-opacity));\n  }\n  .lg\\:focus\\:text-purple-100:focus {\n    --text-opacity: 1;\n    color: #edebfe;\n    color: rgba(237, 235, 254, var(--text-opacity));\n  }\n  .lg\\:focus\\:text-purple-200:focus {\n    --text-opacity: 1;\n    color: #dcd7fe;\n    color: rgba(220, 215, 254, var(--text-opacity));\n  }\n  .lg\\:focus\\:text-purple-300:focus {\n    --text-opacity: 1;\n    color: #cabffd;\n    color: rgba(202, 191, 253, var(--text-opacity));\n  }\n  .lg\\:focus\\:text-purple-400:focus {\n    --text-opacity: 1;\n    color: #ac94fa;\n    color: rgba(172, 148, 250, var(--text-opacity));\n  }\n  .lg\\:focus\\:text-purple-500:focus {\n    --text-opacity: 1;\n    color: #9061f9;\n    color: rgba(144, 97, 249, var(--text-opacity));\n  }\n  .lg\\:focus\\:text-purple-600:focus {\n    --text-opacity: 1;\n    color: #7e3af2;\n    color: rgba(126, 58, 242, var(--text-opacity));\n  }\n  .lg\\:focus\\:text-purple-700:focus {\n    --text-opacity: 1;\n    color: #6c2bd9;\n    color: rgba(108, 43, 217, var(--text-opacity));\n  }\n  .lg\\:focus\\:text-purple-800:focus {\n    --text-opacity: 1;\n    color: #5521b5;\n    color: rgba(85, 33, 181, var(--text-opacity));\n  }\n  .lg\\:focus\\:text-purple-900:focus {\n    --text-opacity: 1;\n    color: #4a1d96;\n    color: rgba(74, 29, 150, var(--text-opacity));\n  }\n  .lg\\:focus\\:text-pink-50:focus {\n    --text-opacity: 1;\n    color: #fdf2f8;\n    color: rgba(253, 242, 248, var(--text-opacity));\n  }\n  .lg\\:focus\\:text-pink-100:focus {\n    --text-opacity: 1;\n    color: #fce8f3;\n    color: rgba(252, 232, 243, var(--text-opacity));\n  }\n  .lg\\:focus\\:text-pink-200:focus {\n    --text-opacity: 1;\n    color: #fad1e8;\n    color: rgba(250, 209, 232, var(--text-opacity));\n  }\n  .lg\\:focus\\:text-pink-300:focus {\n    --text-opacity: 1;\n    color: #f8b4d9;\n    color: rgba(248, 180, 217, var(--text-opacity));\n  }\n  .lg\\:focus\\:text-pink-400:focus {\n    --text-opacity: 1;\n    color: #f17eb8;\n    color: rgba(241, 126, 184, var(--text-opacity));\n  }\n  .lg\\:focus\\:text-pink-500:focus {\n    --text-opacity: 1;\n    color: #e74694;\n    color: rgba(231, 70, 148, var(--text-opacity));\n  }\n  .lg\\:focus\\:text-pink-600:focus {\n    --text-opacity: 1;\n    color: #d61f69;\n    color: rgba(214, 31, 105, var(--text-opacity));\n  }\n  .lg\\:focus\\:text-pink-700:focus {\n    --text-opacity: 1;\n    color: #bf125d;\n    color: rgba(191, 18, 93, var(--text-opacity));\n  }\n  .lg\\:focus\\:text-pink-800:focus {\n    --text-opacity: 1;\n    color: #99154b;\n    color: rgba(153, 21, 75, var(--text-opacity));\n  }\n  .lg\\:focus\\:text-pink-900:focus {\n    --text-opacity: 1;\n    color: #751a3d;\n    color: rgba(117, 26, 61, var(--text-opacity));\n  }\n  .lg\\:focus\\:text-cool-gray-50:focus {\n    --text-opacity: 1;\n    color: #f8fafc;\n    color: rgba(248, 250, 252, var(--text-opacity));\n  }\n  .lg\\:focus\\:text-cool-gray-100:focus {\n    --text-opacity: 1;\n    color: #f1f5f9;\n    color: rgba(241, 245, 249, var(--text-opacity));\n  }\n  .lg\\:focus\\:text-cool-gray-200:focus {\n    --text-opacity: 1;\n    color: #e2e8f0;\n    color: rgba(226, 232, 240, var(--text-opacity));\n  }\n  .lg\\:focus\\:text-cool-gray-300:focus {\n    --text-opacity: 1;\n    color: #cfd8e3;\n    color: rgba(207, 216, 227, var(--text-opacity));\n  }\n  .lg\\:focus\\:text-cool-gray-400:focus {\n    --text-opacity: 1;\n    color: #97a6ba;\n    color: rgba(151, 166, 186, var(--text-opacity));\n  }\n  .lg\\:focus\\:text-cool-gray-500:focus {\n    --text-opacity: 1;\n    color: #64748b;\n    color: rgba(100, 116, 139, var(--text-opacity));\n  }\n  .lg\\:focus\\:text-cool-gray-600:focus {\n    --text-opacity: 1;\n    color: #475569;\n    color: rgba(71, 85, 105, var(--text-opacity));\n  }\n  .lg\\:focus\\:text-cool-gray-700:focus {\n    --text-opacity: 1;\n    color: #364152;\n    color: rgba(54, 65, 82, var(--text-opacity));\n  }\n  .lg\\:focus\\:text-cool-gray-800:focus {\n    --text-opacity: 1;\n    color: #27303f;\n    color: rgba(39, 48, 63, var(--text-opacity));\n  }\n  .lg\\:focus\\:text-cool-gray-900:focus {\n    --text-opacity: 1;\n    color: #1a202e;\n    color: rgba(26, 32, 46, var(--text-opacity));\n  }\n  .lg\\:active\\:text-current:active {\n    color: currentColor;\n  }\n  .lg\\:active\\:text-transparent:active {\n    color: transparent;\n  }\n  .lg\\:active\\:text-white:active {\n    --text-opacity: 1;\n    color: #ffffff;\n    color: rgba(255, 255, 255, var(--text-opacity));\n  }\n  .lg\\:active\\:text-black:active {\n    --text-opacity: 1;\n    color: #000000;\n    color: rgba(0, 0, 0, var(--text-opacity));\n  }\n  .lg\\:active\\:text-gray-50:active {\n    --text-opacity: 1;\n    color: #f9fafb;\n    color: rgba(249, 250, 251, var(--text-opacity));\n  }\n  .lg\\:active\\:text-gray-100:active {\n    --text-opacity: 1;\n    color: #f4f5f7;\n    color: rgba(244, 245, 247, var(--text-opacity));\n  }\n  .lg\\:active\\:text-gray-200:active {\n    --text-opacity: 1;\n    color: #e5e7eb;\n    color: rgba(229, 231, 235, var(--text-opacity));\n  }\n  .lg\\:active\\:text-gray-300:active {\n    --text-opacity: 1;\n    color: #d2d6dc;\n    color: rgba(210, 214, 220, var(--text-opacity));\n  }\n  .lg\\:active\\:text-gray-400:active {\n    --text-opacity: 1;\n    color: #9fa6b2;\n    color: rgba(159, 166, 178, var(--text-opacity));\n  }\n  .lg\\:active\\:text-gray-500:active {\n    --text-opacity: 1;\n    color: #6b7280;\n    color: rgba(107, 114, 128, var(--text-opacity));\n  }\n  .lg\\:active\\:text-gray-600:active {\n    --text-opacity: 1;\n    color: #4b5563;\n    color: rgba(75, 85, 99, var(--text-opacity));\n  }\n  .lg\\:active\\:text-gray-700:active {\n    --text-opacity: 1;\n    color: #374151;\n    color: rgba(55, 65, 81, var(--text-opacity));\n  }\n  .lg\\:active\\:text-gray-800:active {\n    --text-opacity: 1;\n    color: #252f3f;\n    color: rgba(37, 47, 63, var(--text-opacity));\n  }\n  .lg\\:active\\:text-gray-900:active {\n    --text-opacity: 1;\n    color: #161e2e;\n    color: rgba(22, 30, 46, var(--text-opacity));\n  }\n  .lg\\:active\\:text-red-50:active {\n    --text-opacity: 1;\n    color: #fdf2f2;\n    color: rgba(253, 242, 242, var(--text-opacity));\n  }\n  .lg\\:active\\:text-red-100:active {\n    --text-opacity: 1;\n    color: #fde8e8;\n    color: rgba(253, 232, 232, var(--text-opacity));\n  }\n  .lg\\:active\\:text-red-200:active {\n    --text-opacity: 1;\n    color: #fbd5d5;\n    color: rgba(251, 213, 213, var(--text-opacity));\n  }\n  .lg\\:active\\:text-red-300:active {\n    --text-opacity: 1;\n    color: #f8b4b4;\n    color: rgba(248, 180, 180, var(--text-opacity));\n  }\n  .lg\\:active\\:text-red-400:active {\n    --text-opacity: 1;\n    color: #f98080;\n    color: rgba(249, 128, 128, var(--text-opacity));\n  }\n  .lg\\:active\\:text-red-500:active {\n    --text-opacity: 1;\n    color: #f05252;\n    color: rgba(240, 82, 82, var(--text-opacity));\n  }\n  .lg\\:active\\:text-red-600:active {\n    --text-opacity: 1;\n    color: #e02424;\n    color: rgba(224, 36, 36, var(--text-opacity));\n  }\n  .lg\\:active\\:text-red-700:active {\n    --text-opacity: 1;\n    color: #c81e1e;\n    color: rgba(200, 30, 30, var(--text-opacity));\n  }\n  .lg\\:active\\:text-red-800:active {\n    --text-opacity: 1;\n    color: #9b1c1c;\n    color: rgba(155, 28, 28, var(--text-opacity));\n  }\n  .lg\\:active\\:text-red-900:active {\n    --text-opacity: 1;\n    color: #771d1d;\n    color: rgba(119, 29, 29, var(--text-opacity));\n  }\n  .lg\\:active\\:text-orange-50:active {\n    --text-opacity: 1;\n    color: #fff8f1;\n    color: rgba(255, 248, 241, var(--text-opacity));\n  }\n  .lg\\:active\\:text-orange-100:active {\n    --text-opacity: 1;\n    color: #feecdc;\n    color: rgba(254, 236, 220, var(--text-opacity));\n  }\n  .lg\\:active\\:text-orange-200:active {\n    --text-opacity: 1;\n    color: #fcd9bd;\n    color: rgba(252, 217, 189, var(--text-opacity));\n  }\n  .lg\\:active\\:text-orange-300:active {\n    --text-opacity: 1;\n    color: #fdba8c;\n    color: rgba(253, 186, 140, var(--text-opacity));\n  }\n  .lg\\:active\\:text-orange-400:active {\n    --text-opacity: 1;\n    color: #ff8a4c;\n    color: rgba(255, 138, 76, var(--text-opacity));\n  }\n  .lg\\:active\\:text-orange-500:active {\n    --text-opacity: 1;\n    color: #ff5a1f;\n    color: rgba(255, 90, 31, var(--text-opacity));\n  }\n  .lg\\:active\\:text-orange-600:active {\n    --text-opacity: 1;\n    color: #d03801;\n    color: rgba(208, 56, 1, var(--text-opacity));\n  }\n  .lg\\:active\\:text-orange-700:active {\n    --text-opacity: 1;\n    color: #b43403;\n    color: rgba(180, 52, 3, var(--text-opacity));\n  }\n  .lg\\:active\\:text-orange-800:active {\n    --text-opacity: 1;\n    color: #8a2c0d;\n    color: rgba(138, 44, 13, var(--text-opacity));\n  }\n  .lg\\:active\\:text-orange-900:active {\n    --text-opacity: 1;\n    color: #73230d;\n    color: rgba(115, 35, 13, var(--text-opacity));\n  }\n  .lg\\:active\\:text-yellow-50:active {\n    --text-opacity: 1;\n    color: #fdfdea;\n    color: rgba(253, 253, 234, var(--text-opacity));\n  }\n  .lg\\:active\\:text-yellow-100:active {\n    --text-opacity: 1;\n    color: #fdf6b2;\n    color: rgba(253, 246, 178, var(--text-opacity));\n  }\n  .lg\\:active\\:text-yellow-200:active {\n    --text-opacity: 1;\n    color: #fce96a;\n    color: rgba(252, 233, 106, var(--text-opacity));\n  }\n  .lg\\:active\\:text-yellow-300:active {\n    --text-opacity: 1;\n    color: #faca15;\n    color: rgba(250, 202, 21, var(--text-opacity));\n  }\n  .lg\\:active\\:text-yellow-400:active {\n    --text-opacity: 1;\n    color: #e3a008;\n    color: rgba(227, 160, 8, var(--text-opacity));\n  }\n  .lg\\:active\\:text-yellow-500:active {\n    --text-opacity: 1;\n    color: #c27803;\n    color: rgba(194, 120, 3, var(--text-opacity));\n  }\n  .lg\\:active\\:text-yellow-600:active {\n    --text-opacity: 1;\n    color: #9f580a;\n    color: rgba(159, 88, 10, var(--text-opacity));\n  }\n  .lg\\:active\\:text-yellow-700:active {\n    --text-opacity: 1;\n    color: #8e4b10;\n    color: rgba(142, 75, 16, var(--text-opacity));\n  }\n  .lg\\:active\\:text-yellow-800:active {\n    --text-opacity: 1;\n    color: #723b13;\n    color: rgba(114, 59, 19, var(--text-opacity));\n  }\n  .lg\\:active\\:text-yellow-900:active {\n    --text-opacity: 1;\n    color: #633112;\n    color: rgba(99, 49, 18, var(--text-opacity));\n  }\n  .lg\\:active\\:text-green-50:active {\n    --text-opacity: 1;\n    color: #f3faf7;\n    color: rgba(243, 250, 247, var(--text-opacity));\n  }\n  .lg\\:active\\:text-green-100:active {\n    --text-opacity: 1;\n    color: #def7ec;\n    color: rgba(222, 247, 236, var(--text-opacity));\n  }\n  .lg\\:active\\:text-green-200:active {\n    --text-opacity: 1;\n    color: #bcf0da;\n    color: rgba(188, 240, 218, var(--text-opacity));\n  }\n  .lg\\:active\\:text-green-300:active {\n    --text-opacity: 1;\n    color: #84e1bc;\n    color: rgba(132, 225, 188, var(--text-opacity));\n  }\n  .lg\\:active\\:text-green-400:active {\n    --text-opacity: 1;\n    color: #31c48d;\n    color: rgba(49, 196, 141, var(--text-opacity));\n  }\n  .lg\\:active\\:text-green-500:active {\n    --text-opacity: 1;\n    color: #0e9f6e;\n    color: rgba(14, 159, 110, var(--text-opacity));\n  }\n  .lg\\:active\\:text-green-600:active {\n    --text-opacity: 1;\n    color: #057a55;\n    color: rgba(5, 122, 85, var(--text-opacity));\n  }\n  .lg\\:active\\:text-green-700:active {\n    --text-opacity: 1;\n    color: #046c4e;\n    color: rgba(4, 108, 78, var(--text-opacity));\n  }\n  .lg\\:active\\:text-green-800:active {\n    --text-opacity: 1;\n    color: #03543f;\n    color: rgba(3, 84, 63, var(--text-opacity));\n  }\n  .lg\\:active\\:text-green-900:active {\n    --text-opacity: 1;\n    color: #014737;\n    color: rgba(1, 71, 55, var(--text-opacity));\n  }\n  .lg\\:active\\:text-teal-50:active {\n    --text-opacity: 1;\n    color: #edfafa;\n    color: rgba(237, 250, 250, var(--text-opacity));\n  }\n  .lg\\:active\\:text-teal-100:active {\n    --text-opacity: 1;\n    color: #d5f5f6;\n    color: rgba(213, 245, 246, var(--text-opacity));\n  }\n  .lg\\:active\\:text-teal-200:active {\n    --text-opacity: 1;\n    color: #afecef;\n    color: rgba(175, 236, 239, var(--text-opacity));\n  }\n  .lg\\:active\\:text-teal-300:active {\n    --text-opacity: 1;\n    color: #7edce2;\n    color: rgba(126, 220, 226, var(--text-opacity));\n  }\n  .lg\\:active\\:text-teal-400:active {\n    --text-opacity: 1;\n    color: #16bdca;\n    color: rgba(22, 189, 202, var(--text-opacity));\n  }\n  .lg\\:active\\:text-teal-500:active {\n    --text-opacity: 1;\n    color: #0694a2;\n    color: rgba(6, 148, 162, var(--text-opacity));\n  }\n  .lg\\:active\\:text-teal-600:active {\n    --text-opacity: 1;\n    color: #047481;\n    color: rgba(4, 116, 129, var(--text-opacity));\n  }\n  .lg\\:active\\:text-teal-700:active {\n    --text-opacity: 1;\n    color: #036672;\n    color: rgba(3, 102, 114, var(--text-opacity));\n  }\n  .lg\\:active\\:text-teal-800:active {\n    --text-opacity: 1;\n    color: #05505c;\n    color: rgba(5, 80, 92, var(--text-opacity));\n  }\n  .lg\\:active\\:text-teal-900:active {\n    --text-opacity: 1;\n    color: #014451;\n    color: rgba(1, 68, 81, var(--text-opacity));\n  }\n  .lg\\:active\\:text-blue-50:active {\n    --text-opacity: 1;\n    color: #ebf5ff;\n    color: rgba(235, 245, 255, var(--text-opacity));\n  }\n  .lg\\:active\\:text-blue-100:active {\n    --text-opacity: 1;\n    color: #e1effe;\n    color: rgba(225, 239, 254, var(--text-opacity));\n  }\n  .lg\\:active\\:text-blue-200:active {\n    --text-opacity: 1;\n    color: #c3ddfd;\n    color: rgba(195, 221, 253, var(--text-opacity));\n  }\n  .lg\\:active\\:text-blue-300:active {\n    --text-opacity: 1;\n    color: #a4cafe;\n    color: rgba(164, 202, 254, var(--text-opacity));\n  }\n  .lg\\:active\\:text-blue-400:active {\n    --text-opacity: 1;\n    color: #76a9fa;\n    color: rgba(118, 169, 250, var(--text-opacity));\n  }\n  .lg\\:active\\:text-blue-500:active {\n    --text-opacity: 1;\n    color: #3f83f8;\n    color: rgba(63, 131, 248, var(--text-opacity));\n  }\n  .lg\\:active\\:text-blue-600:active {\n    --text-opacity: 1;\n    color: #1c64f2;\n    color: rgba(28, 100, 242, var(--text-opacity));\n  }\n  .lg\\:active\\:text-blue-700:active {\n    --text-opacity: 1;\n    color: #1a56db;\n    color: rgba(26, 86, 219, var(--text-opacity));\n  }\n  .lg\\:active\\:text-blue-800:active {\n    --text-opacity: 1;\n    color: #1e429f;\n    color: rgba(30, 66, 159, var(--text-opacity));\n  }\n  .lg\\:active\\:text-blue-900:active {\n    --text-opacity: 1;\n    color: #233876;\n    color: rgba(35, 56, 118, var(--text-opacity));\n  }\n  .lg\\:active\\:text-indigo-50:active {\n    --text-opacity: 1;\n    color: #f0f5ff;\n    color: rgba(240, 245, 255, var(--text-opacity));\n  }\n  .lg\\:active\\:text-indigo-100:active {\n    --text-opacity: 1;\n    color: #e5edff;\n    color: rgba(229, 237, 255, var(--text-opacity));\n  }\n  .lg\\:active\\:text-indigo-200:active {\n    --text-opacity: 1;\n    color: #cddbfe;\n    color: rgba(205, 219, 254, var(--text-opacity));\n  }\n  .lg\\:active\\:text-indigo-300:active {\n    --text-opacity: 1;\n    color: #b4c6fc;\n    color: rgba(180, 198, 252, var(--text-opacity));\n  }\n  .lg\\:active\\:text-indigo-400:active {\n    --text-opacity: 1;\n    color: #8da2fb;\n    color: rgba(141, 162, 251, var(--text-opacity));\n  }\n  .lg\\:active\\:text-indigo-500:active {\n    --text-opacity: 1;\n    color: #6875f5;\n    color: rgba(104, 117, 245, var(--text-opacity));\n  }\n  .lg\\:active\\:text-indigo-600:active {\n    --text-opacity: 1;\n    color: #5850ec;\n    color: rgba(88, 80, 236, var(--text-opacity));\n  }\n  .lg\\:active\\:text-indigo-700:active {\n    --text-opacity: 1;\n    color: #5145cd;\n    color: rgba(81, 69, 205, var(--text-opacity));\n  }\n  .lg\\:active\\:text-indigo-800:active {\n    --text-opacity: 1;\n    color: #42389d;\n    color: rgba(66, 56, 157, var(--text-opacity));\n  }\n  .lg\\:active\\:text-indigo-900:active {\n    --text-opacity: 1;\n    color: #362f78;\n    color: rgba(54, 47, 120, var(--text-opacity));\n  }\n  .lg\\:active\\:text-purple-50:active {\n    --text-opacity: 1;\n    color: #f6f5ff;\n    color: rgba(246, 245, 255, var(--text-opacity));\n  }\n  .lg\\:active\\:text-purple-100:active {\n    --text-opacity: 1;\n    color: #edebfe;\n    color: rgba(237, 235, 254, var(--text-opacity));\n  }\n  .lg\\:active\\:text-purple-200:active {\n    --text-opacity: 1;\n    color: #dcd7fe;\n    color: rgba(220, 215, 254, var(--text-opacity));\n  }\n  .lg\\:active\\:text-purple-300:active {\n    --text-opacity: 1;\n    color: #cabffd;\n    color: rgba(202, 191, 253, var(--text-opacity));\n  }\n  .lg\\:active\\:text-purple-400:active {\n    --text-opacity: 1;\n    color: #ac94fa;\n    color: rgba(172, 148, 250, var(--text-opacity));\n  }\n  .lg\\:active\\:text-purple-500:active {\n    --text-opacity: 1;\n    color: #9061f9;\n    color: rgba(144, 97, 249, var(--text-opacity));\n  }\n  .lg\\:active\\:text-purple-600:active {\n    --text-opacity: 1;\n    color: #7e3af2;\n    color: rgba(126, 58, 242, var(--text-opacity));\n  }\n  .lg\\:active\\:text-purple-700:active {\n    --text-opacity: 1;\n    color: #6c2bd9;\n    color: rgba(108, 43, 217, var(--text-opacity));\n  }\n  .lg\\:active\\:text-purple-800:active {\n    --text-opacity: 1;\n    color: #5521b5;\n    color: rgba(85, 33, 181, var(--text-opacity));\n  }\n  .lg\\:active\\:text-purple-900:active {\n    --text-opacity: 1;\n    color: #4a1d96;\n    color: rgba(74, 29, 150, var(--text-opacity));\n  }\n  .lg\\:active\\:text-pink-50:active {\n    --text-opacity: 1;\n    color: #fdf2f8;\n    color: rgba(253, 242, 248, var(--text-opacity));\n  }\n  .lg\\:active\\:text-pink-100:active {\n    --text-opacity: 1;\n    color: #fce8f3;\n    color: rgba(252, 232, 243, var(--text-opacity));\n  }\n  .lg\\:active\\:text-pink-200:active {\n    --text-opacity: 1;\n    color: #fad1e8;\n    color: rgba(250, 209, 232, var(--text-opacity));\n  }\n  .lg\\:active\\:text-pink-300:active {\n    --text-opacity: 1;\n    color: #f8b4d9;\n    color: rgba(248, 180, 217, var(--text-opacity));\n  }\n  .lg\\:active\\:text-pink-400:active {\n    --text-opacity: 1;\n    color: #f17eb8;\n    color: rgba(241, 126, 184, var(--text-opacity));\n  }\n  .lg\\:active\\:text-pink-500:active {\n    --text-opacity: 1;\n    color: #e74694;\n    color: rgba(231, 70, 148, var(--text-opacity));\n  }\n  .lg\\:active\\:text-pink-600:active {\n    --text-opacity: 1;\n    color: #d61f69;\n    color: rgba(214, 31, 105, var(--text-opacity));\n  }\n  .lg\\:active\\:text-pink-700:active {\n    --text-opacity: 1;\n    color: #bf125d;\n    color: rgba(191, 18, 93, var(--text-opacity));\n  }\n  .lg\\:active\\:text-pink-800:active {\n    --text-opacity: 1;\n    color: #99154b;\n    color: rgba(153, 21, 75, var(--text-opacity));\n  }\n  .lg\\:active\\:text-pink-900:active {\n    --text-opacity: 1;\n    color: #751a3d;\n    color: rgba(117, 26, 61, var(--text-opacity));\n  }\n  .lg\\:active\\:text-cool-gray-50:active {\n    --text-opacity: 1;\n    color: #f8fafc;\n    color: rgba(248, 250, 252, var(--text-opacity));\n  }\n  .lg\\:active\\:text-cool-gray-100:active {\n    --text-opacity: 1;\n    color: #f1f5f9;\n    color: rgba(241, 245, 249, var(--text-opacity));\n  }\n  .lg\\:active\\:text-cool-gray-200:active {\n    --text-opacity: 1;\n    color: #e2e8f0;\n    color: rgba(226, 232, 240, var(--text-opacity));\n  }\n  .lg\\:active\\:text-cool-gray-300:active {\n    --text-opacity: 1;\n    color: #cfd8e3;\n    color: rgba(207, 216, 227, var(--text-opacity));\n  }\n  .lg\\:active\\:text-cool-gray-400:active {\n    --text-opacity: 1;\n    color: #97a6ba;\n    color: rgba(151, 166, 186, var(--text-opacity));\n  }\n  .lg\\:active\\:text-cool-gray-500:active {\n    --text-opacity: 1;\n    color: #64748b;\n    color: rgba(100, 116, 139, var(--text-opacity));\n  }\n  .lg\\:active\\:text-cool-gray-600:active {\n    --text-opacity: 1;\n    color: #475569;\n    color: rgba(71, 85, 105, var(--text-opacity));\n  }\n  .lg\\:active\\:text-cool-gray-700:active {\n    --text-opacity: 1;\n    color: #364152;\n    color: rgba(54, 65, 82, var(--text-opacity));\n  }\n  .lg\\:active\\:text-cool-gray-800:active {\n    --text-opacity: 1;\n    color: #27303f;\n    color: rgba(39, 48, 63, var(--text-opacity));\n  }\n  .lg\\:active\\:text-cool-gray-900:active {\n    --text-opacity: 1;\n    color: #1a202e;\n    color: rgba(26, 32, 46, var(--text-opacity));\n  }\n  .lg\\:text-opacity-0 {\n    --text-opacity: 0;\n  }\n  .lg\\:text-opacity-25 {\n    --text-opacity: 0.25;\n  }\n  .lg\\:text-opacity-50 {\n    --text-opacity: 0.5;\n  }\n  .lg\\:text-opacity-75 {\n    --text-opacity: 0.75;\n  }\n  .lg\\:text-opacity-100 {\n    --text-opacity: 1;\n  }\n  .lg\\:hover\\:text-opacity-0:hover {\n    --text-opacity: 0;\n  }\n  .lg\\:hover\\:text-opacity-25:hover {\n    --text-opacity: 0.25;\n  }\n  .lg\\:hover\\:text-opacity-50:hover {\n    --text-opacity: 0.5;\n  }\n  .lg\\:hover\\:text-opacity-75:hover {\n    --text-opacity: 0.75;\n  }\n  .lg\\:hover\\:text-opacity-100:hover {\n    --text-opacity: 1;\n  }\n  .lg\\:focus\\:text-opacity-0:focus {\n    --text-opacity: 0;\n  }\n  .lg\\:focus\\:text-opacity-25:focus {\n    --text-opacity: 0.25;\n  }\n  .lg\\:focus\\:text-opacity-50:focus {\n    --text-opacity: 0.5;\n  }\n  .lg\\:focus\\:text-opacity-75:focus {\n    --text-opacity: 0.75;\n  }\n  .lg\\:focus\\:text-opacity-100:focus {\n    --text-opacity: 1;\n  }\n  .lg\\:italic {\n    font-style: italic;\n  }\n  .lg\\:not-italic {\n    font-style: normal;\n  }\n  .lg\\:uppercase {\n    text-transform: uppercase;\n  }\n  .lg\\:lowercase {\n    text-transform: lowercase;\n  }\n  .lg\\:capitalize {\n    text-transform: capitalize;\n  }\n  .lg\\:normal-case {\n    text-transform: none;\n  }\n  .lg\\:underline {\n    text-decoration: none;\n  }\n  .lg\\:line-through {\n    text-decoration: line-through;\n  }\n  .lg\\:no-underline {\n    text-decoration: none;\n  }\n  .group:hover .lg\\:group-hover\\:underline {\n    text-decoration: none;\n  }\n  .group:hover .lg\\:group-hover\\:line-through {\n    text-decoration: line-through;\n  }\n  .group:hover .lg\\:group-hover\\:no-underline {\n    text-decoration: none;\n  }\n  .group:focus .lg\\:group-focus\\:underline {\n    text-decoration: none;\n  }\n  .group:focus .lg\\:group-focus\\:line-through {\n    text-decoration: line-through;\n  }\n  .group:focus .lg\\:group-focus\\:no-underline {\n    text-decoration: none;\n  }\n  .lg\\:hover\\:underline:hover {\n    text-decoration: none;\n  }\n  .lg\\:hover\\:line-through:hover {\n    text-decoration: line-through;\n  }\n  .lg\\:hover\\:no-underline:hover {\n    text-decoration: none;\n  }\n  .lg\\:focus\\:underline:focus {\n    text-decoration: none;\n  }\n  .lg\\:focus\\:line-through:focus {\n    text-decoration: line-through;\n  }\n  .lg\\:focus\\:no-underline:focus {\n    text-decoration: none;\n  }\n  .lg\\:antialiased {\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n  }\n  .lg\\:subpixel-antialiased {\n    -webkit-font-smoothing: auto;\n    -moz-osx-font-smoothing: auto;\n  }\n  .lg\\:ordinal, .lg\\:slashed-zero, .lg\\:lining-nums, .lg\\:oldstyle-nums, .lg\\:proportional-nums, .lg\\:tabular-nums, .lg\\:diagonal-fractions, .lg\\:stacked-fractions {\n    --font-variant-numeric-ordinal: var(--tailwind-empty,\n        /*!*/\n        /*!*/\n      );\n    --font-variant-numeric-slashed-zero: var(--tailwind-empty,\n        /*!*/\n        /*!*/\n      );\n    --font-variant-numeric-figure: var(--tailwind-empty,\n        /*!*/\n        /*!*/\n      );\n    --font-variant-numeric-spacing: var(--tailwind-empty,\n        /*!*/\n        /*!*/\n      );\n    --font-variant-numeric-fraction: var(--tailwind-empty,\n        /*!*/\n        /*!*/\n      );\n    font-variant-numeric: var(--font-variant-numeric-ordinal) var(--font-variant-numeric-slashed-zero) var(--font-variant-numeric-figure) var(--font-variant-numeric-spacing) var(--font-variant-numeric-fraction);\n  }\n  .lg\\:normal-nums {\n    font-variant-numeric: normal;\n  }\n  .lg\\:ordinal {\n    --font-variant-numeric-ordinal: ordinal;\n  }\n  .lg\\:slashed-zero {\n    --font-variant-numeric-slashed-zero: slashed-zero;\n  }\n  .lg\\:lining-nums {\n    --font-variant-numeric-figure: lining-nums;\n  }\n  .lg\\:oldstyle-nums {\n    --font-variant-numeric-figure: oldstyle-nums;\n  }\n  .lg\\:proportional-nums {\n    --font-variant-numeric-spacing: proportional-nums;\n  }\n  .lg\\:tabular-nums {\n    --font-variant-numeric-spacing: tabular-nums;\n  }\n  .lg\\:diagonal-fractions {\n    --font-variant-numeric-fraction: diagonal-fractions;\n  }\n  .lg\\:stacked-fractions {\n    --font-variant-numeric-fraction: stacked-fractions;\n  }\n  .lg\\:tracking-tighter {\n    letter-spacing: -0.05em;\n  }\n  .lg\\:tracking-tight {\n    letter-spacing: -0.025em;\n  }\n  .lg\\:tracking-normal {\n    letter-spacing: 0;\n  }\n  .lg\\:tracking-wide {\n    letter-spacing: 0.025em;\n  }\n  .lg\\:tracking-wider {\n    letter-spacing: 0.05em;\n  }\n  .lg\\:tracking-widest {\n    letter-spacing: 0.1em;\n  }\n  .lg\\:select-none {\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    user-select: none;\n  }\n  .lg\\:select-text {\n    -webkit-user-select: text;\n    -moz-user-select: text;\n    user-select: text;\n  }\n  .lg\\:select-all {\n    -webkit-user-select: all;\n    -moz-user-select: all;\n    user-select: all;\n  }\n  .lg\\:select-auto {\n    -webkit-user-select: auto;\n    -moz-user-select: auto;\n    user-select: auto;\n  }\n  .lg\\:align-baseline {\n    vertical-align: baseline;\n  }\n  .lg\\:align-top {\n    vertical-align: top;\n  }\n  .lg\\:align-middle {\n    vertical-align: middle;\n  }\n  .lg\\:align-bottom {\n    vertical-align: bottom;\n  }\n  .lg\\:align-text-top {\n    vertical-align: text-top;\n  }\n  .lg\\:align-text-bottom {\n    vertical-align: text-bottom;\n  }\n  .lg\\:visible {\n    visibility: visible;\n  }\n  .lg\\:invisible {\n    visibility: hidden;\n  }\n  .lg\\:whitespace-normal {\n    white-space: normal;\n  }\n  .lg\\:whitespace-no-wrap {\n    white-space: nowrap;\n  }\n  .lg\\:whitespace-pre {\n    white-space: pre;\n  }\n  .lg\\:whitespace-pre-line {\n    white-space: pre-line;\n  }\n  .lg\\:whitespace-pre-wrap {\n    white-space: pre-wrap;\n  }\n  .lg\\:break-normal {\n    word-wrap: normal;\n    overflow-wrap: normal;\n    word-break: normal;\n  }\n  .lg\\:break-words {\n    word-wrap: break-word;\n    overflow-wrap: break-word;\n  }\n  .lg\\:break-all {\n    word-break: break-all;\n  }\n  .lg\\:truncate {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n  .lg\\:w-0 {\n    width: 0;\n  }\n  .lg\\:w-1 {\n    width: 0.25rem;\n  }\n  .lg\\:w-2 {\n    width: 0.5rem;\n  }\n  .lg\\:w-3 {\n    width: 0.75rem;\n  }\n  .lg\\:w-4 {\n    width: 1rem;\n  }\n  .lg\\:w-5 {\n    width: 1.25rem;\n  }\n  .lg\\:w-6 {\n    width: 1.5rem;\n  }\n  .lg\\:w-7 {\n    width: 1.75rem;\n  }\n  .lg\\:w-8 {\n    width: 2rem;\n  }\n  .lg\\:w-9 {\n    width: 2.25rem;\n  }\n  .lg\\:w-10 {\n    width: 2.5rem;\n  }\n  .lg\\:w-11 {\n    width: 2.75rem;\n  }\n  .lg\\:w-12 {\n    width: 3rem;\n  }\n  .lg\\:w-13 {\n    width: 3.25rem;\n  }\n  .lg\\:w-14 {\n    width: 3.5rem;\n  }\n  .lg\\:w-15 {\n    width: 3.75rem;\n  }\n  .lg\\:w-16 {\n    width: 4rem;\n  }\n  .lg\\:w-20 {\n    width: 5rem;\n  }\n  .lg\\:w-24 {\n    width: 6rem;\n  }\n  .lg\\:w-28 {\n    width: 7rem;\n  }\n  .lg\\:w-32 {\n    width: 8rem;\n  }\n  .lg\\:w-36 {\n    width: 9rem;\n  }\n  .lg\\:w-40 {\n    width: 10rem;\n  }\n  .lg\\:w-44 {\n    width: 11rem;\n  }\n  .lg\\:w-48 {\n    width: 12rem;\n  }\n  .lg\\:w-52 {\n    width: 13rem;\n  }\n  .lg\\:w-56 {\n    width: 14rem;\n  }\n  .lg\\:w-60 {\n    width: 15rem;\n  }\n  .lg\\:w-64 {\n    width: 16rem;\n  }\n  .lg\\:w-72 {\n    width: 18rem;\n  }\n  .lg\\:w-80 {\n    width: 20rem;\n  }\n  .lg\\:w-96 {\n    width: 24rem;\n  }\n  .lg\\:w-auto {\n    width: auto;\n  }\n  .lg\\:w-px {\n    width: 1px;\n  }\n  .lg\\:w-0\\.5 {\n    width: 0.125rem;\n  }\n  .lg\\:w-1\\.5 {\n    width: 0.375rem;\n  }\n  .lg\\:w-2\\.5 {\n    width: 0.625rem;\n  }\n  .lg\\:w-3\\.5 {\n    width: 0.875rem;\n  }\n  .lg\\:w-1\\/2 {\n    width: 50%;\n  }\n  .lg\\:w-1\\/3 {\n    width: 33.333333%;\n  }\n  .lg\\:w-2\\/3 {\n    width: 66.666667%;\n  }\n  .lg\\:w-1\\/4 {\n    width: 25%;\n  }\n  .lg\\:w-2\\/4 {\n    width: 50%;\n  }\n  .lg\\:w-3\\/4 {\n    width: 75%;\n  }\n  .lg\\:w-1\\/5 {\n    width: 20%;\n  }\n  .lg\\:w-2\\/5 {\n    width: 40%;\n  }\n  .lg\\:w-3\\/5 {\n    width: 60%;\n  }\n  .lg\\:w-4\\/5 {\n    width: 80%;\n  }\n  .lg\\:w-1\\/6 {\n    width: 16.666667%;\n  }\n  .lg\\:w-2\\/6 {\n    width: 33.333333%;\n  }\n  .lg\\:w-3\\/6 {\n    width: 50%;\n  }\n  .lg\\:w-4\\/6 {\n    width: 66.666667%;\n  }\n  .lg\\:w-5\\/6 {\n    width: 83.333333%;\n  }\n  .lg\\:w-1\\/12 {\n    width: 8.333333%;\n  }\n  .lg\\:w-2\\/12 {\n    width: 16.666667%;\n  }\n  .lg\\:w-3\\/12 {\n    width: 25%;\n  }\n  .lg\\:w-4\\/12 {\n    width: 33.333333%;\n  }\n  .lg\\:w-5\\/12 {\n    width: 41.666667%;\n  }\n  .lg\\:w-6\\/12 {\n    width: 50%;\n  }\n  .lg\\:w-7\\/12 {\n    width: 58.333333%;\n  }\n  .lg\\:w-8\\/12 {\n    width: 66.666667%;\n  }\n  .lg\\:w-9\\/12 {\n    width: 75%;\n  }\n  .lg\\:w-10\\/12 {\n    width: 83.333333%;\n  }\n  .lg\\:w-11\\/12 {\n    width: 91.666667%;\n  }\n  .lg\\:w-full {\n    width: 100%;\n  }\n  .lg\\:w-screen {\n    width: 100vw;\n  }\n  .lg\\:w-min-content {\n    width: -moz-min-content;\n    width: min-content;\n  }\n  .lg\\:w-max-content {\n    width: -moz-max-content;\n    width: max-content;\n  }\n  .lg\\:z-0 {\n    z-index: 0;\n  }\n  .lg\\:z-10 {\n    z-index: 10;\n  }\n  .lg\\:z-20 {\n    z-index: 20;\n  }\n  .lg\\:z-30 {\n    z-index: 30;\n  }\n  .lg\\:z-40 {\n    z-index: 40;\n  }\n  .lg\\:z-50 {\n    z-index: 50;\n  }\n  .lg\\:z-auto {\n    z-index: auto;\n  }\n  .lg\\:focus-within\\:z-0:focus-within {\n    z-index: 0;\n  }\n  .lg\\:focus-within\\:z-10:focus-within {\n    z-index: 10;\n  }\n  .lg\\:focus-within\\:z-20:focus-within {\n    z-index: 20;\n  }\n  .lg\\:focus-within\\:z-30:focus-within {\n    z-index: 30;\n  }\n  .lg\\:focus-within\\:z-40:focus-within {\n    z-index: 40;\n  }\n  .lg\\:focus-within\\:z-50:focus-within {\n    z-index: 50;\n  }\n  .lg\\:focus-within\\:z-auto:focus-within {\n    z-index: auto;\n  }\n  .lg\\:focus\\:z-0:focus {\n    z-index: 0;\n  }\n  .lg\\:focus\\:z-10:focus {\n    z-index: 10;\n  }\n  .lg\\:focus\\:z-20:focus {\n    z-index: 20;\n  }\n  .lg\\:focus\\:z-30:focus {\n    z-index: 30;\n  }\n  .lg\\:focus\\:z-40:focus {\n    z-index: 40;\n  }\n  .lg\\:focus\\:z-50:focus {\n    z-index: 50;\n  }\n  .lg\\:focus\\:z-auto:focus {\n    z-index: auto;\n  }\n  .lg\\:gap-0 {\n    grid-gap: 0;\n    gap: 0;\n  }\n  .lg\\:gap-1 {\n    grid-gap: 0.25rem;\n    gap: 0.25rem;\n  }\n  .lg\\:gap-2 {\n    grid-gap: 0.5rem;\n    gap: 0.5rem;\n  }\n  .lg\\:gap-3 {\n    grid-gap: 0.75rem;\n    gap: 0.75rem;\n  }\n  .lg\\:gap-4 {\n    grid-gap: 1rem;\n    gap: 1rem;\n  }\n  .lg\\:gap-5 {\n    grid-gap: 1.25rem;\n    gap: 1.25rem;\n  }\n  .lg\\:gap-6 {\n    grid-gap: 1.5rem;\n    gap: 1.5rem;\n  }\n  .lg\\:gap-7 {\n    grid-gap: 1.75rem;\n    gap: 1.75rem;\n  }\n  .lg\\:gap-8 {\n    grid-gap: 2rem;\n    gap: 2rem;\n  }\n  .lg\\:gap-9 {\n    grid-gap: 2.25rem;\n    gap: 2.25rem;\n  }\n  .lg\\:gap-10 {\n    grid-gap: 2.5rem;\n    gap: 2.5rem;\n  }\n  .lg\\:gap-11 {\n    grid-gap: 2.75rem;\n    gap: 2.75rem;\n  }\n  .lg\\:gap-12 {\n    grid-gap: 3rem;\n    gap: 3rem;\n  }\n  .lg\\:gap-13 {\n    grid-gap: 3.25rem;\n    gap: 3.25rem;\n  }\n  .lg\\:gap-14 {\n    grid-gap: 3.5rem;\n    gap: 3.5rem;\n  }\n  .lg\\:gap-15 {\n    grid-gap: 3.75rem;\n    gap: 3.75rem;\n  }\n  .lg\\:gap-16 {\n    grid-gap: 4rem;\n    gap: 4rem;\n  }\n  .lg\\:gap-20 {\n    grid-gap: 5rem;\n    gap: 5rem;\n  }\n  .lg\\:gap-24 {\n    grid-gap: 6rem;\n    gap: 6rem;\n  }\n  .lg\\:gap-28 {\n    grid-gap: 7rem;\n    gap: 7rem;\n  }\n  .lg\\:gap-32 {\n    grid-gap: 8rem;\n    gap: 8rem;\n  }\n  .lg\\:gap-36 {\n    grid-gap: 9rem;\n    gap: 9rem;\n  }\n  .lg\\:gap-40 {\n    grid-gap: 10rem;\n    gap: 10rem;\n  }\n  .lg\\:gap-44 {\n    grid-gap: 11rem;\n    gap: 11rem;\n  }\n  .lg\\:gap-48 {\n    grid-gap: 12rem;\n    gap: 12rem;\n  }\n  .lg\\:gap-52 {\n    grid-gap: 13rem;\n    gap: 13rem;\n  }\n  .lg\\:gap-56 {\n    grid-gap: 14rem;\n    gap: 14rem;\n  }\n  .lg\\:gap-60 {\n    grid-gap: 15rem;\n    gap: 15rem;\n  }\n  .lg\\:gap-64 {\n    grid-gap: 16rem;\n    gap: 16rem;\n  }\n  .lg\\:gap-72 {\n    grid-gap: 18rem;\n    gap: 18rem;\n  }\n  .lg\\:gap-80 {\n    grid-gap: 20rem;\n    gap: 20rem;\n  }\n  .lg\\:gap-96 {\n    grid-gap: 24rem;\n    gap: 24rem;\n  }\n  .lg\\:gap-px {\n    grid-gap: 1px;\n    gap: 1px;\n  }\n  .lg\\:gap-0\\.5 {\n    grid-gap: 0.125rem;\n    gap: 0.125rem;\n  }\n  .lg\\:gap-1\\.5 {\n    grid-gap: 0.375rem;\n    gap: 0.375rem;\n  }\n  .lg\\:gap-2\\.5 {\n    grid-gap: 0.625rem;\n    gap: 0.625rem;\n  }\n  .lg\\:gap-3\\.5 {\n    grid-gap: 0.875rem;\n    gap: 0.875rem;\n  }\n  .lg\\:gap-1\\/2 {\n    grid-gap: 50%;\n    gap: 50%;\n  }\n  .lg\\:gap-1\\/3 {\n    grid-gap: 33.333333%;\n    gap: 33.333333%;\n  }\n  .lg\\:gap-2\\/3 {\n    grid-gap: 66.666667%;\n    gap: 66.666667%;\n  }\n  .lg\\:gap-1\\/4 {\n    grid-gap: 25%;\n    gap: 25%;\n  }\n  .lg\\:gap-2\\/4 {\n    grid-gap: 50%;\n    gap: 50%;\n  }\n  .lg\\:gap-3\\/4 {\n    grid-gap: 75%;\n    gap: 75%;\n  }\n  .lg\\:gap-1\\/5 {\n    grid-gap: 20%;\n    gap: 20%;\n  }\n  .lg\\:gap-2\\/5 {\n    grid-gap: 40%;\n    gap: 40%;\n  }\n  .lg\\:gap-3\\/5 {\n    grid-gap: 60%;\n    gap: 60%;\n  }\n  .lg\\:gap-4\\/5 {\n    grid-gap: 80%;\n    gap: 80%;\n  }\n  .lg\\:gap-1\\/6 {\n    grid-gap: 16.666667%;\n    gap: 16.666667%;\n  }\n  .lg\\:gap-2\\/6 {\n    grid-gap: 33.333333%;\n    gap: 33.333333%;\n  }\n  .lg\\:gap-3\\/6 {\n    grid-gap: 50%;\n    gap: 50%;\n  }\n  .lg\\:gap-4\\/6 {\n    grid-gap: 66.666667%;\n    gap: 66.666667%;\n  }\n  .lg\\:gap-5\\/6 {\n    grid-gap: 83.333333%;\n    gap: 83.333333%;\n  }\n  .lg\\:gap-1\\/12 {\n    grid-gap: 8.333333%;\n    gap: 8.333333%;\n  }\n  .lg\\:gap-2\\/12 {\n    grid-gap: 16.666667%;\n    gap: 16.666667%;\n  }\n  .lg\\:gap-3\\/12 {\n    grid-gap: 25%;\n    gap: 25%;\n  }\n  .lg\\:gap-4\\/12 {\n    grid-gap: 33.333333%;\n    gap: 33.333333%;\n  }\n  .lg\\:gap-5\\/12 {\n    grid-gap: 41.666667%;\n    gap: 41.666667%;\n  }\n  .lg\\:gap-6\\/12 {\n    grid-gap: 50%;\n    gap: 50%;\n  }\n  .lg\\:gap-7\\/12 {\n    grid-gap: 58.333333%;\n    gap: 58.333333%;\n  }\n  .lg\\:gap-8\\/12 {\n    grid-gap: 66.666667%;\n    gap: 66.666667%;\n  }\n  .lg\\:gap-9\\/12 {\n    grid-gap: 75%;\n    gap: 75%;\n  }\n  .lg\\:gap-10\\/12 {\n    grid-gap: 83.333333%;\n    gap: 83.333333%;\n  }\n  .lg\\:gap-11\\/12 {\n    grid-gap: 91.666667%;\n    gap: 91.666667%;\n  }\n  .lg\\:gap-full {\n    grid-gap: 100%;\n    gap: 100%;\n  }\n  .lg\\:col-gap-0 {\n    grid-column-gap: 0;\n    -moz-column-gap: 0;\n    column-gap: 0;\n  }\n  .lg\\:col-gap-1 {\n    grid-column-gap: 0.25rem;\n    -moz-column-gap: 0.25rem;\n    column-gap: 0.25rem;\n  }\n  .lg\\:col-gap-2 {\n    grid-column-gap: 0.5rem;\n    -moz-column-gap: 0.5rem;\n    column-gap: 0.5rem;\n  }\n  .lg\\:col-gap-3 {\n    grid-column-gap: 0.75rem;\n    -moz-column-gap: 0.75rem;\n    column-gap: 0.75rem;\n  }\n  .lg\\:col-gap-4 {\n    grid-column-gap: 1rem;\n    -moz-column-gap: 1rem;\n    column-gap: 1rem;\n  }\n  .lg\\:col-gap-5 {\n    grid-column-gap: 1.25rem;\n    -moz-column-gap: 1.25rem;\n    column-gap: 1.25rem;\n  }\n  .lg\\:col-gap-6 {\n    grid-column-gap: 1.5rem;\n    -moz-column-gap: 1.5rem;\n    column-gap: 1.5rem;\n  }\n  .lg\\:col-gap-7 {\n    grid-column-gap: 1.75rem;\n    -moz-column-gap: 1.75rem;\n    column-gap: 1.75rem;\n  }\n  .lg\\:col-gap-8 {\n    grid-column-gap: 2rem;\n    -moz-column-gap: 2rem;\n    column-gap: 2rem;\n  }\n  .lg\\:col-gap-9 {\n    grid-column-gap: 2.25rem;\n    -moz-column-gap: 2.25rem;\n    column-gap: 2.25rem;\n  }\n  .lg\\:col-gap-10 {\n    grid-column-gap: 2.5rem;\n    -moz-column-gap: 2.5rem;\n    column-gap: 2.5rem;\n  }\n  .lg\\:col-gap-11 {\n    grid-column-gap: 2.75rem;\n    -moz-column-gap: 2.75rem;\n    column-gap: 2.75rem;\n  }\n  .lg\\:col-gap-12 {\n    grid-column-gap: 3rem;\n    -moz-column-gap: 3rem;\n    column-gap: 3rem;\n  }\n  .lg\\:col-gap-13 {\n    grid-column-gap: 3.25rem;\n    -moz-column-gap: 3.25rem;\n    column-gap: 3.25rem;\n  }\n  .lg\\:col-gap-14 {\n    grid-column-gap: 3.5rem;\n    -moz-column-gap: 3.5rem;\n    column-gap: 3.5rem;\n  }\n  .lg\\:col-gap-15 {\n    grid-column-gap: 3.75rem;\n    -moz-column-gap: 3.75rem;\n    column-gap: 3.75rem;\n  }\n  .lg\\:col-gap-16 {\n    grid-column-gap: 4rem;\n    -moz-column-gap: 4rem;\n    column-gap: 4rem;\n  }\n  .lg\\:col-gap-20 {\n    grid-column-gap: 5rem;\n    -moz-column-gap: 5rem;\n    column-gap: 5rem;\n  }\n  .lg\\:col-gap-24 {\n    grid-column-gap: 6rem;\n    -moz-column-gap: 6rem;\n    column-gap: 6rem;\n  }\n  .lg\\:col-gap-28 {\n    grid-column-gap: 7rem;\n    -moz-column-gap: 7rem;\n    column-gap: 7rem;\n  }\n  .lg\\:col-gap-32 {\n    grid-column-gap: 8rem;\n    -moz-column-gap: 8rem;\n    column-gap: 8rem;\n  }\n  .lg\\:col-gap-36 {\n    grid-column-gap: 9rem;\n    -moz-column-gap: 9rem;\n    column-gap: 9rem;\n  }\n  .lg\\:col-gap-40 {\n    grid-column-gap: 10rem;\n    -moz-column-gap: 10rem;\n    column-gap: 10rem;\n  }\n  .lg\\:col-gap-44 {\n    grid-column-gap: 11rem;\n    -moz-column-gap: 11rem;\n    column-gap: 11rem;\n  }\n  .lg\\:col-gap-48 {\n    grid-column-gap: 12rem;\n    -moz-column-gap: 12rem;\n    column-gap: 12rem;\n  }\n  .lg\\:col-gap-52 {\n    grid-column-gap: 13rem;\n    -moz-column-gap: 13rem;\n    column-gap: 13rem;\n  }\n  .lg\\:col-gap-56 {\n    grid-column-gap: 14rem;\n    -moz-column-gap: 14rem;\n    column-gap: 14rem;\n  }\n  .lg\\:col-gap-60 {\n    grid-column-gap: 15rem;\n    -moz-column-gap: 15rem;\n    column-gap: 15rem;\n  }\n  .lg\\:col-gap-64 {\n    grid-column-gap: 16rem;\n    -moz-column-gap: 16rem;\n    column-gap: 16rem;\n  }\n  .lg\\:col-gap-72 {\n    grid-column-gap: 18rem;\n    -moz-column-gap: 18rem;\n    column-gap: 18rem;\n  }\n  .lg\\:col-gap-80 {\n    grid-column-gap: 20rem;\n    -moz-column-gap: 20rem;\n    column-gap: 20rem;\n  }\n  .lg\\:col-gap-96 {\n    grid-column-gap: 24rem;\n    -moz-column-gap: 24rem;\n    column-gap: 24rem;\n  }\n  .lg\\:col-gap-px {\n    grid-column-gap: 1px;\n    -moz-column-gap: 1px;\n    column-gap: 1px;\n  }\n  .lg\\:col-gap-0\\.5 {\n    grid-column-gap: 0.125rem;\n    -moz-column-gap: 0.125rem;\n    column-gap: 0.125rem;\n  }\n  .lg\\:col-gap-1\\.5 {\n    grid-column-gap: 0.375rem;\n    -moz-column-gap: 0.375rem;\n    column-gap: 0.375rem;\n  }\n  .lg\\:col-gap-2\\.5 {\n    grid-column-gap: 0.625rem;\n    -moz-column-gap: 0.625rem;\n    column-gap: 0.625rem;\n  }\n  .lg\\:col-gap-3\\.5 {\n    grid-column-gap: 0.875rem;\n    -moz-column-gap: 0.875rem;\n    column-gap: 0.875rem;\n  }\n  .lg\\:col-gap-1\\/2 {\n    grid-column-gap: 50%;\n    -moz-column-gap: 50%;\n    column-gap: 50%;\n  }\n  .lg\\:col-gap-1\\/3 {\n    grid-column-gap: 33.333333%;\n    -moz-column-gap: 33.333333%;\n    column-gap: 33.333333%;\n  }\n  .lg\\:col-gap-2\\/3 {\n    grid-column-gap: 66.666667%;\n    -moz-column-gap: 66.666667%;\n    column-gap: 66.666667%;\n  }\n  .lg\\:col-gap-1\\/4 {\n    grid-column-gap: 25%;\n    -moz-column-gap: 25%;\n    column-gap: 25%;\n  }\n  .lg\\:col-gap-2\\/4 {\n    grid-column-gap: 50%;\n    -moz-column-gap: 50%;\n    column-gap: 50%;\n  }\n  .lg\\:col-gap-3\\/4 {\n    grid-column-gap: 75%;\n    -moz-column-gap: 75%;\n    column-gap: 75%;\n  }\n  .lg\\:col-gap-1\\/5 {\n    grid-column-gap: 20%;\n    -moz-column-gap: 20%;\n    column-gap: 20%;\n  }\n  .lg\\:col-gap-2\\/5 {\n    grid-column-gap: 40%;\n    -moz-column-gap: 40%;\n    column-gap: 40%;\n  }\n  .lg\\:col-gap-3\\/5 {\n    grid-column-gap: 60%;\n    -moz-column-gap: 60%;\n    column-gap: 60%;\n  }\n  .lg\\:col-gap-4\\/5 {\n    grid-column-gap: 80%;\n    -moz-column-gap: 80%;\n    column-gap: 80%;\n  }\n  .lg\\:col-gap-1\\/6 {\n    grid-column-gap: 16.666667%;\n    -moz-column-gap: 16.666667%;\n    column-gap: 16.666667%;\n  }\n  .lg\\:col-gap-2\\/6 {\n    grid-column-gap: 33.333333%;\n    -moz-column-gap: 33.333333%;\n    column-gap: 33.333333%;\n  }\n  .lg\\:col-gap-3\\/6 {\n    grid-column-gap: 50%;\n    -moz-column-gap: 50%;\n    column-gap: 50%;\n  }\n  .lg\\:col-gap-4\\/6 {\n    grid-column-gap: 66.666667%;\n    -moz-column-gap: 66.666667%;\n    column-gap: 66.666667%;\n  }\n  .lg\\:col-gap-5\\/6 {\n    grid-column-gap: 83.333333%;\n    -moz-column-gap: 83.333333%;\n    column-gap: 83.333333%;\n  }\n  .lg\\:col-gap-1\\/12 {\n    grid-column-gap: 8.333333%;\n    -moz-column-gap: 8.333333%;\n    column-gap: 8.333333%;\n  }\n  .lg\\:col-gap-2\\/12 {\n    grid-column-gap: 16.666667%;\n    -moz-column-gap: 16.666667%;\n    column-gap: 16.666667%;\n  }\n  .lg\\:col-gap-3\\/12 {\n    grid-column-gap: 25%;\n    -moz-column-gap: 25%;\n    column-gap: 25%;\n  }\n  .lg\\:col-gap-4\\/12 {\n    grid-column-gap: 33.333333%;\n    -moz-column-gap: 33.333333%;\n    column-gap: 33.333333%;\n  }\n  .lg\\:col-gap-5\\/12 {\n    grid-column-gap: 41.666667%;\n    -moz-column-gap: 41.666667%;\n    column-gap: 41.666667%;\n  }\n  .lg\\:col-gap-6\\/12 {\n    grid-column-gap: 50%;\n    -moz-column-gap: 50%;\n    column-gap: 50%;\n  }\n  .lg\\:col-gap-7\\/12 {\n    grid-column-gap: 58.333333%;\n    -moz-column-gap: 58.333333%;\n    column-gap: 58.333333%;\n  }\n  .lg\\:col-gap-8\\/12 {\n    grid-column-gap: 66.666667%;\n    -moz-column-gap: 66.666667%;\n    column-gap: 66.666667%;\n  }\n  .lg\\:col-gap-9\\/12 {\n    grid-column-gap: 75%;\n    -moz-column-gap: 75%;\n    column-gap: 75%;\n  }\n  .lg\\:col-gap-10\\/12 {\n    grid-column-gap: 83.333333%;\n    -moz-column-gap: 83.333333%;\n    column-gap: 83.333333%;\n  }\n  .lg\\:col-gap-11\\/12 {\n    grid-column-gap: 91.666667%;\n    -moz-column-gap: 91.666667%;\n    column-gap: 91.666667%;\n  }\n  .lg\\:col-gap-full {\n    grid-column-gap: 100%;\n    -moz-column-gap: 100%;\n    column-gap: 100%;\n  }\n  .lg\\:gap-x-0 {\n    grid-column-gap: 0;\n    -moz-column-gap: 0;\n    column-gap: 0;\n  }\n  .lg\\:gap-x-1 {\n    grid-column-gap: 0.25rem;\n    -moz-column-gap: 0.25rem;\n    column-gap: 0.25rem;\n  }\n  .lg\\:gap-x-2 {\n    grid-column-gap: 0.5rem;\n    -moz-column-gap: 0.5rem;\n    column-gap: 0.5rem;\n  }\n  .lg\\:gap-x-3 {\n    grid-column-gap: 0.75rem;\n    -moz-column-gap: 0.75rem;\n    column-gap: 0.75rem;\n  }\n  .lg\\:gap-x-4 {\n    grid-column-gap: 1rem;\n    -moz-column-gap: 1rem;\n    column-gap: 1rem;\n  }\n  .lg\\:gap-x-5 {\n    grid-column-gap: 1.25rem;\n    -moz-column-gap: 1.25rem;\n    column-gap: 1.25rem;\n  }\n  .lg\\:gap-x-6 {\n    grid-column-gap: 1.5rem;\n    -moz-column-gap: 1.5rem;\n    column-gap: 1.5rem;\n  }\n  .lg\\:gap-x-7 {\n    grid-column-gap: 1.75rem;\n    -moz-column-gap: 1.75rem;\n    column-gap: 1.75rem;\n  }\n  .lg\\:gap-x-8 {\n    grid-column-gap: 2rem;\n    -moz-column-gap: 2rem;\n    column-gap: 2rem;\n  }\n  .lg\\:gap-x-9 {\n    grid-column-gap: 2.25rem;\n    -moz-column-gap: 2.25rem;\n    column-gap: 2.25rem;\n  }\n  .lg\\:gap-x-10 {\n    grid-column-gap: 2.5rem;\n    -moz-column-gap: 2.5rem;\n    column-gap: 2.5rem;\n  }\n  .lg\\:gap-x-11 {\n    grid-column-gap: 2.75rem;\n    -moz-column-gap: 2.75rem;\n    column-gap: 2.75rem;\n  }\n  .lg\\:gap-x-12 {\n    grid-column-gap: 3rem;\n    -moz-column-gap: 3rem;\n    column-gap: 3rem;\n  }\n  .lg\\:gap-x-13 {\n    grid-column-gap: 3.25rem;\n    -moz-column-gap: 3.25rem;\n    column-gap: 3.25rem;\n  }\n  .lg\\:gap-x-14 {\n    grid-column-gap: 3.5rem;\n    -moz-column-gap: 3.5rem;\n    column-gap: 3.5rem;\n  }\n  .lg\\:gap-x-15 {\n    grid-column-gap: 3.75rem;\n    -moz-column-gap: 3.75rem;\n    column-gap: 3.75rem;\n  }\n  .lg\\:gap-x-16 {\n    grid-column-gap: 4rem;\n    -moz-column-gap: 4rem;\n    column-gap: 4rem;\n  }\n  .lg\\:gap-x-20 {\n    grid-column-gap: 5rem;\n    -moz-column-gap: 5rem;\n    column-gap: 5rem;\n  }\n  .lg\\:gap-x-24 {\n    grid-column-gap: 6rem;\n    -moz-column-gap: 6rem;\n    column-gap: 6rem;\n  }\n  .lg\\:gap-x-28 {\n    grid-column-gap: 7rem;\n    -moz-column-gap: 7rem;\n    column-gap: 7rem;\n  }\n  .lg\\:gap-x-32 {\n    grid-column-gap: 8rem;\n    -moz-column-gap: 8rem;\n    column-gap: 8rem;\n  }\n  .lg\\:gap-x-36 {\n    grid-column-gap: 9rem;\n    -moz-column-gap: 9rem;\n    column-gap: 9rem;\n  }\n  .lg\\:gap-x-40 {\n    grid-column-gap: 10rem;\n    -moz-column-gap: 10rem;\n    column-gap: 10rem;\n  }\n  .lg\\:gap-x-44 {\n    grid-column-gap: 11rem;\n    -moz-column-gap: 11rem;\n    column-gap: 11rem;\n  }\n  .lg\\:gap-x-48 {\n    grid-column-gap: 12rem;\n    -moz-column-gap: 12rem;\n    column-gap: 12rem;\n  }\n  .lg\\:gap-x-52 {\n    grid-column-gap: 13rem;\n    -moz-column-gap: 13rem;\n    column-gap: 13rem;\n  }\n  .lg\\:gap-x-56 {\n    grid-column-gap: 14rem;\n    -moz-column-gap: 14rem;\n    column-gap: 14rem;\n  }\n  .lg\\:gap-x-60 {\n    grid-column-gap: 15rem;\n    -moz-column-gap: 15rem;\n    column-gap: 15rem;\n  }\n  .lg\\:gap-x-64 {\n    grid-column-gap: 16rem;\n    -moz-column-gap: 16rem;\n    column-gap: 16rem;\n  }\n  .lg\\:gap-x-72 {\n    grid-column-gap: 18rem;\n    -moz-column-gap: 18rem;\n    column-gap: 18rem;\n  }\n  .lg\\:gap-x-80 {\n    grid-column-gap: 20rem;\n    -moz-column-gap: 20rem;\n    column-gap: 20rem;\n  }\n  .lg\\:gap-x-96 {\n    grid-column-gap: 24rem;\n    -moz-column-gap: 24rem;\n    column-gap: 24rem;\n  }\n  .lg\\:gap-x-px {\n    grid-column-gap: 1px;\n    -moz-column-gap: 1px;\n    column-gap: 1px;\n  }\n  .lg\\:gap-x-0\\.5 {\n    grid-column-gap: 0.125rem;\n    -moz-column-gap: 0.125rem;\n    column-gap: 0.125rem;\n  }\n  .lg\\:gap-x-1\\.5 {\n    grid-column-gap: 0.375rem;\n    -moz-column-gap: 0.375rem;\n    column-gap: 0.375rem;\n  }\n  .lg\\:gap-x-2\\.5 {\n    grid-column-gap: 0.625rem;\n    -moz-column-gap: 0.625rem;\n    column-gap: 0.625rem;\n  }\n  .lg\\:gap-x-3\\.5 {\n    grid-column-gap: 0.875rem;\n    -moz-column-gap: 0.875rem;\n    column-gap: 0.875rem;\n  }\n  .lg\\:gap-x-1\\/2 {\n    grid-column-gap: 50%;\n    -moz-column-gap: 50%;\n    column-gap: 50%;\n  }\n  .lg\\:gap-x-1\\/3 {\n    grid-column-gap: 33.333333%;\n    -moz-column-gap: 33.333333%;\n    column-gap: 33.333333%;\n  }\n  .lg\\:gap-x-2\\/3 {\n    grid-column-gap: 66.666667%;\n    -moz-column-gap: 66.666667%;\n    column-gap: 66.666667%;\n  }\n  .lg\\:gap-x-1\\/4 {\n    grid-column-gap: 25%;\n    -moz-column-gap: 25%;\n    column-gap: 25%;\n  }\n  .lg\\:gap-x-2\\/4 {\n    grid-column-gap: 50%;\n    -moz-column-gap: 50%;\n    column-gap: 50%;\n  }\n  .lg\\:gap-x-3\\/4 {\n    grid-column-gap: 75%;\n    -moz-column-gap: 75%;\n    column-gap: 75%;\n  }\n  .lg\\:gap-x-1\\/5 {\n    grid-column-gap: 20%;\n    -moz-column-gap: 20%;\n    column-gap: 20%;\n  }\n  .lg\\:gap-x-2\\/5 {\n    grid-column-gap: 40%;\n    -moz-column-gap: 40%;\n    column-gap: 40%;\n  }\n  .lg\\:gap-x-3\\/5 {\n    grid-column-gap: 60%;\n    -moz-column-gap: 60%;\n    column-gap: 60%;\n  }\n  .lg\\:gap-x-4\\/5 {\n    grid-column-gap: 80%;\n    -moz-column-gap: 80%;\n    column-gap: 80%;\n  }\n  .lg\\:gap-x-1\\/6 {\n    grid-column-gap: 16.666667%;\n    -moz-column-gap: 16.666667%;\n    column-gap: 16.666667%;\n  }\n  .lg\\:gap-x-2\\/6 {\n    grid-column-gap: 33.333333%;\n    -moz-column-gap: 33.333333%;\n    column-gap: 33.333333%;\n  }\n  .lg\\:gap-x-3\\/6 {\n    grid-column-gap: 50%;\n    -moz-column-gap: 50%;\n    column-gap: 50%;\n  }\n  .lg\\:gap-x-4\\/6 {\n    grid-column-gap: 66.666667%;\n    -moz-column-gap: 66.666667%;\n    column-gap: 66.666667%;\n  }\n  .lg\\:gap-x-5\\/6 {\n    grid-column-gap: 83.333333%;\n    -moz-column-gap: 83.333333%;\n    column-gap: 83.333333%;\n  }\n  .lg\\:gap-x-1\\/12 {\n    grid-column-gap: 8.333333%;\n    -moz-column-gap: 8.333333%;\n    column-gap: 8.333333%;\n  }\n  .lg\\:gap-x-2\\/12 {\n    grid-column-gap: 16.666667%;\n    -moz-column-gap: 16.666667%;\n    column-gap: 16.666667%;\n  }\n  .lg\\:gap-x-3\\/12 {\n    grid-column-gap: 25%;\n    -moz-column-gap: 25%;\n    column-gap: 25%;\n  }\n  .lg\\:gap-x-4\\/12 {\n    grid-column-gap: 33.333333%;\n    -moz-column-gap: 33.333333%;\n    column-gap: 33.333333%;\n  }\n  .lg\\:gap-x-5\\/12 {\n    grid-column-gap: 41.666667%;\n    -moz-column-gap: 41.666667%;\n    column-gap: 41.666667%;\n  }\n  .lg\\:gap-x-6\\/12 {\n    grid-column-gap: 50%;\n    -moz-column-gap: 50%;\n    column-gap: 50%;\n  }\n  .lg\\:gap-x-7\\/12 {\n    grid-column-gap: 58.333333%;\n    -moz-column-gap: 58.333333%;\n    column-gap: 58.333333%;\n  }\n  .lg\\:gap-x-8\\/12 {\n    grid-column-gap: 66.666667%;\n    -moz-column-gap: 66.666667%;\n    column-gap: 66.666667%;\n  }\n  .lg\\:gap-x-9\\/12 {\n    grid-column-gap: 75%;\n    -moz-column-gap: 75%;\n    column-gap: 75%;\n  }\n  .lg\\:gap-x-10\\/12 {\n    grid-column-gap: 83.333333%;\n    -moz-column-gap: 83.333333%;\n    column-gap: 83.333333%;\n  }\n  .lg\\:gap-x-11\\/12 {\n    grid-column-gap: 91.666667%;\n    -moz-column-gap: 91.666667%;\n    column-gap: 91.666667%;\n  }\n  .lg\\:gap-x-full {\n    grid-column-gap: 100%;\n    -moz-column-gap: 100%;\n    column-gap: 100%;\n  }\n  .lg\\:row-gap-0 {\n    grid-row-gap: 0;\n    row-gap: 0;\n  }\n  .lg\\:row-gap-1 {\n    grid-row-gap: 0.25rem;\n    row-gap: 0.25rem;\n  }\n  .lg\\:row-gap-2 {\n    grid-row-gap: 0.5rem;\n    row-gap: 0.5rem;\n  }\n  .lg\\:row-gap-3 {\n    grid-row-gap: 0.75rem;\n    row-gap: 0.75rem;\n  }\n  .lg\\:row-gap-4 {\n    grid-row-gap: 1rem;\n    row-gap: 1rem;\n  }\n  .lg\\:row-gap-5 {\n    grid-row-gap: 1.25rem;\n    row-gap: 1.25rem;\n  }\n  .lg\\:row-gap-6 {\n    grid-row-gap: 1.5rem;\n    row-gap: 1.5rem;\n  }\n  .lg\\:row-gap-7 {\n    grid-row-gap: 1.75rem;\n    row-gap: 1.75rem;\n  }\n  .lg\\:row-gap-8 {\n    grid-row-gap: 2rem;\n    row-gap: 2rem;\n  }\n  .lg\\:row-gap-9 {\n    grid-row-gap: 2.25rem;\n    row-gap: 2.25rem;\n  }\n  .lg\\:row-gap-10 {\n    grid-row-gap: 2.5rem;\n    row-gap: 2.5rem;\n  }\n  .lg\\:row-gap-11 {\n    grid-row-gap: 2.75rem;\n    row-gap: 2.75rem;\n  }\n  .lg\\:row-gap-12 {\n    grid-row-gap: 3rem;\n    row-gap: 3rem;\n  }\n  .lg\\:row-gap-13 {\n    grid-row-gap: 3.25rem;\n    row-gap: 3.25rem;\n  }\n  .lg\\:row-gap-14 {\n    grid-row-gap: 3.5rem;\n    row-gap: 3.5rem;\n  }\n  .lg\\:row-gap-15 {\n    grid-row-gap: 3.75rem;\n    row-gap: 3.75rem;\n  }\n  .lg\\:row-gap-16 {\n    grid-row-gap: 4rem;\n    row-gap: 4rem;\n  }\n  .lg\\:row-gap-20 {\n    grid-row-gap: 5rem;\n    row-gap: 5rem;\n  }\n  .lg\\:row-gap-24 {\n    grid-row-gap: 6rem;\n    row-gap: 6rem;\n  }\n  .lg\\:row-gap-28 {\n    grid-row-gap: 7rem;\n    row-gap: 7rem;\n  }\n  .lg\\:row-gap-32 {\n    grid-row-gap: 8rem;\n    row-gap: 8rem;\n  }\n  .lg\\:row-gap-36 {\n    grid-row-gap: 9rem;\n    row-gap: 9rem;\n  }\n  .lg\\:row-gap-40 {\n    grid-row-gap: 10rem;\n    row-gap: 10rem;\n  }\n  .lg\\:row-gap-44 {\n    grid-row-gap: 11rem;\n    row-gap: 11rem;\n  }\n  .lg\\:row-gap-48 {\n    grid-row-gap: 12rem;\n    row-gap: 12rem;\n  }\n  .lg\\:row-gap-52 {\n    grid-row-gap: 13rem;\n    row-gap: 13rem;\n  }\n  .lg\\:row-gap-56 {\n    grid-row-gap: 14rem;\n    row-gap: 14rem;\n  }\n  .lg\\:row-gap-60 {\n    grid-row-gap: 15rem;\n    row-gap: 15rem;\n  }\n  .lg\\:row-gap-64 {\n    grid-row-gap: 16rem;\n    row-gap: 16rem;\n  }\n  .lg\\:row-gap-72 {\n    grid-row-gap: 18rem;\n    row-gap: 18rem;\n  }\n  .lg\\:row-gap-80 {\n    grid-row-gap: 20rem;\n    row-gap: 20rem;\n  }\n  .lg\\:row-gap-96 {\n    grid-row-gap: 24rem;\n    row-gap: 24rem;\n  }\n  .lg\\:row-gap-px {\n    grid-row-gap: 1px;\n    row-gap: 1px;\n  }\n  .lg\\:row-gap-0\\.5 {\n    grid-row-gap: 0.125rem;\n    row-gap: 0.125rem;\n  }\n  .lg\\:row-gap-1\\.5 {\n    grid-row-gap: 0.375rem;\n    row-gap: 0.375rem;\n  }\n  .lg\\:row-gap-2\\.5 {\n    grid-row-gap: 0.625rem;\n    row-gap: 0.625rem;\n  }\n  .lg\\:row-gap-3\\.5 {\n    grid-row-gap: 0.875rem;\n    row-gap: 0.875rem;\n  }\n  .lg\\:row-gap-1\\/2 {\n    grid-row-gap: 50%;\n    row-gap: 50%;\n  }\n  .lg\\:row-gap-1\\/3 {\n    grid-row-gap: 33.333333%;\n    row-gap: 33.333333%;\n  }\n  .lg\\:row-gap-2\\/3 {\n    grid-row-gap: 66.666667%;\n    row-gap: 66.666667%;\n  }\n  .lg\\:row-gap-1\\/4 {\n    grid-row-gap: 25%;\n    row-gap: 25%;\n  }\n  .lg\\:row-gap-2\\/4 {\n    grid-row-gap: 50%;\n    row-gap: 50%;\n  }\n  .lg\\:row-gap-3\\/4 {\n    grid-row-gap: 75%;\n    row-gap: 75%;\n  }\n  .lg\\:row-gap-1\\/5 {\n    grid-row-gap: 20%;\n    row-gap: 20%;\n  }\n  .lg\\:row-gap-2\\/5 {\n    grid-row-gap: 40%;\n    row-gap: 40%;\n  }\n  .lg\\:row-gap-3\\/5 {\n    grid-row-gap: 60%;\n    row-gap: 60%;\n  }\n  .lg\\:row-gap-4\\/5 {\n    grid-row-gap: 80%;\n    row-gap: 80%;\n  }\n  .lg\\:row-gap-1\\/6 {\n    grid-row-gap: 16.666667%;\n    row-gap: 16.666667%;\n  }\n  .lg\\:row-gap-2\\/6 {\n    grid-row-gap: 33.333333%;\n    row-gap: 33.333333%;\n  }\n  .lg\\:row-gap-3\\/6 {\n    grid-row-gap: 50%;\n    row-gap: 50%;\n  }\n  .lg\\:row-gap-4\\/6 {\n    grid-row-gap: 66.666667%;\n    row-gap: 66.666667%;\n  }\n  .lg\\:row-gap-5\\/6 {\n    grid-row-gap: 83.333333%;\n    row-gap: 83.333333%;\n  }\n  .lg\\:row-gap-1\\/12 {\n    grid-row-gap: 8.333333%;\n    row-gap: 8.333333%;\n  }\n  .lg\\:row-gap-2\\/12 {\n    grid-row-gap: 16.666667%;\n    row-gap: 16.666667%;\n  }\n  .lg\\:row-gap-3\\/12 {\n    grid-row-gap: 25%;\n    row-gap: 25%;\n  }\n  .lg\\:row-gap-4\\/12 {\n    grid-row-gap: 33.333333%;\n    row-gap: 33.333333%;\n  }\n  .lg\\:row-gap-5\\/12 {\n    grid-row-gap: 41.666667%;\n    row-gap: 41.666667%;\n  }\n  .lg\\:row-gap-6\\/12 {\n    grid-row-gap: 50%;\n    row-gap: 50%;\n  }\n  .lg\\:row-gap-7\\/12 {\n    grid-row-gap: 58.333333%;\n    row-gap: 58.333333%;\n  }\n  .lg\\:row-gap-8\\/12 {\n    grid-row-gap: 66.666667%;\n    row-gap: 66.666667%;\n  }\n  .lg\\:row-gap-9\\/12 {\n    grid-row-gap: 75%;\n    row-gap: 75%;\n  }\n  .lg\\:row-gap-10\\/12 {\n    grid-row-gap: 83.333333%;\n    row-gap: 83.333333%;\n  }\n  .lg\\:row-gap-11\\/12 {\n    grid-row-gap: 91.666667%;\n    row-gap: 91.666667%;\n  }\n  .lg\\:row-gap-full {\n    grid-row-gap: 100%;\n    row-gap: 100%;\n  }\n  .lg\\:gap-y-0 {\n    grid-row-gap: 0;\n    row-gap: 0;\n  }\n  .lg\\:gap-y-1 {\n    grid-row-gap: 0.25rem;\n    row-gap: 0.25rem;\n  }\n  .lg\\:gap-y-2 {\n    grid-row-gap: 0.5rem;\n    row-gap: 0.5rem;\n  }\n  .lg\\:gap-y-3 {\n    grid-row-gap: 0.75rem;\n    row-gap: 0.75rem;\n  }\n  .lg\\:gap-y-4 {\n    grid-row-gap: 1rem;\n    row-gap: 1rem;\n  }\n  .lg\\:gap-y-5 {\n    grid-row-gap: 1.25rem;\n    row-gap: 1.25rem;\n  }\n  .lg\\:gap-y-6 {\n    grid-row-gap: 1.5rem;\n    row-gap: 1.5rem;\n  }\n  .lg\\:gap-y-7 {\n    grid-row-gap: 1.75rem;\n    row-gap: 1.75rem;\n  }\n  .lg\\:gap-y-8 {\n    grid-row-gap: 2rem;\n    row-gap: 2rem;\n  }\n  .lg\\:gap-y-9 {\n    grid-row-gap: 2.25rem;\n    row-gap: 2.25rem;\n  }\n  .lg\\:gap-y-10 {\n    grid-row-gap: 2.5rem;\n    row-gap: 2.5rem;\n  }\n  .lg\\:gap-y-11 {\n    grid-row-gap: 2.75rem;\n    row-gap: 2.75rem;\n  }\n  .lg\\:gap-y-12 {\n    grid-row-gap: 3rem;\n    row-gap: 3rem;\n  }\n  .lg\\:gap-y-13 {\n    grid-row-gap: 3.25rem;\n    row-gap: 3.25rem;\n  }\n  .lg\\:gap-y-14 {\n    grid-row-gap: 3.5rem;\n    row-gap: 3.5rem;\n  }\n  .lg\\:gap-y-15 {\n    grid-row-gap: 3.75rem;\n    row-gap: 3.75rem;\n  }\n  .lg\\:gap-y-16 {\n    grid-row-gap: 4rem;\n    row-gap: 4rem;\n  }\n  .lg\\:gap-y-20 {\n    grid-row-gap: 5rem;\n    row-gap: 5rem;\n  }\n  .lg\\:gap-y-24 {\n    grid-row-gap: 6rem;\n    row-gap: 6rem;\n  }\n  .lg\\:gap-y-28 {\n    grid-row-gap: 7rem;\n    row-gap: 7rem;\n  }\n  .lg\\:gap-y-32 {\n    grid-row-gap: 8rem;\n    row-gap: 8rem;\n  }\n  .lg\\:gap-y-36 {\n    grid-row-gap: 9rem;\n    row-gap: 9rem;\n  }\n  .lg\\:gap-y-40 {\n    grid-row-gap: 10rem;\n    row-gap: 10rem;\n  }\n  .lg\\:gap-y-44 {\n    grid-row-gap: 11rem;\n    row-gap: 11rem;\n  }\n  .lg\\:gap-y-48 {\n    grid-row-gap: 12rem;\n    row-gap: 12rem;\n  }\n  .lg\\:gap-y-52 {\n    grid-row-gap: 13rem;\n    row-gap: 13rem;\n  }\n  .lg\\:gap-y-56 {\n    grid-row-gap: 14rem;\n    row-gap: 14rem;\n  }\n  .lg\\:gap-y-60 {\n    grid-row-gap: 15rem;\n    row-gap: 15rem;\n  }\n  .lg\\:gap-y-64 {\n    grid-row-gap: 16rem;\n    row-gap: 16rem;\n  }\n  .lg\\:gap-y-72 {\n    grid-row-gap: 18rem;\n    row-gap: 18rem;\n  }\n  .lg\\:gap-y-80 {\n    grid-row-gap: 20rem;\n    row-gap: 20rem;\n  }\n  .lg\\:gap-y-96 {\n    grid-row-gap: 24rem;\n    row-gap: 24rem;\n  }\n  .lg\\:gap-y-px {\n    grid-row-gap: 1px;\n    row-gap: 1px;\n  }\n  .lg\\:gap-y-0\\.5 {\n    grid-row-gap: 0.125rem;\n    row-gap: 0.125rem;\n  }\n  .lg\\:gap-y-1\\.5 {\n    grid-row-gap: 0.375rem;\n    row-gap: 0.375rem;\n  }\n  .lg\\:gap-y-2\\.5 {\n    grid-row-gap: 0.625rem;\n    row-gap: 0.625rem;\n  }\n  .lg\\:gap-y-3\\.5 {\n    grid-row-gap: 0.875rem;\n    row-gap: 0.875rem;\n  }\n  .lg\\:gap-y-1\\/2 {\n    grid-row-gap: 50%;\n    row-gap: 50%;\n  }\n  .lg\\:gap-y-1\\/3 {\n    grid-row-gap: 33.333333%;\n    row-gap: 33.333333%;\n  }\n  .lg\\:gap-y-2\\/3 {\n    grid-row-gap: 66.666667%;\n    row-gap: 66.666667%;\n  }\n  .lg\\:gap-y-1\\/4 {\n    grid-row-gap: 25%;\n    row-gap: 25%;\n  }\n  .lg\\:gap-y-2\\/4 {\n    grid-row-gap: 50%;\n    row-gap: 50%;\n  }\n  .lg\\:gap-y-3\\/4 {\n    grid-row-gap: 75%;\n    row-gap: 75%;\n  }\n  .lg\\:gap-y-1\\/5 {\n    grid-row-gap: 20%;\n    row-gap: 20%;\n  }\n  .lg\\:gap-y-2\\/5 {\n    grid-row-gap: 40%;\n    row-gap: 40%;\n  }\n  .lg\\:gap-y-3\\/5 {\n    grid-row-gap: 60%;\n    row-gap: 60%;\n  }\n  .lg\\:gap-y-4\\/5 {\n    grid-row-gap: 80%;\n    row-gap: 80%;\n  }\n  .lg\\:gap-y-1\\/6 {\n    grid-row-gap: 16.666667%;\n    row-gap: 16.666667%;\n  }\n  .lg\\:gap-y-2\\/6 {\n    grid-row-gap: 33.333333%;\n    row-gap: 33.333333%;\n  }\n  .lg\\:gap-y-3\\/6 {\n    grid-row-gap: 50%;\n    row-gap: 50%;\n  }\n  .lg\\:gap-y-4\\/6 {\n    grid-row-gap: 66.666667%;\n    row-gap: 66.666667%;\n  }\n  .lg\\:gap-y-5\\/6 {\n    grid-row-gap: 83.333333%;\n    row-gap: 83.333333%;\n  }\n  .lg\\:gap-y-1\\/12 {\n    grid-row-gap: 8.333333%;\n    row-gap: 8.333333%;\n  }\n  .lg\\:gap-y-2\\/12 {\n    grid-row-gap: 16.666667%;\n    row-gap: 16.666667%;\n  }\n  .lg\\:gap-y-3\\/12 {\n    grid-row-gap: 25%;\n    row-gap: 25%;\n  }\n  .lg\\:gap-y-4\\/12 {\n    grid-row-gap: 33.333333%;\n    row-gap: 33.333333%;\n  }\n  .lg\\:gap-y-5\\/12 {\n    grid-row-gap: 41.666667%;\n    row-gap: 41.666667%;\n  }\n  .lg\\:gap-y-6\\/12 {\n    grid-row-gap: 50%;\n    row-gap: 50%;\n  }\n  .lg\\:gap-y-7\\/12 {\n    grid-row-gap: 58.333333%;\n    row-gap: 58.333333%;\n  }\n  .lg\\:gap-y-8\\/12 {\n    grid-row-gap: 66.666667%;\n    row-gap: 66.666667%;\n  }\n  .lg\\:gap-y-9\\/12 {\n    grid-row-gap: 75%;\n    row-gap: 75%;\n  }\n  .lg\\:gap-y-10\\/12 {\n    grid-row-gap: 83.333333%;\n    row-gap: 83.333333%;\n  }\n  .lg\\:gap-y-11\\/12 {\n    grid-row-gap: 91.666667%;\n    row-gap: 91.666667%;\n  }\n  .lg\\:gap-y-full {\n    grid-row-gap: 100%;\n    row-gap: 100%;\n  }\n  .lg\\:grid-flow-row {\n    grid-auto-flow: row;\n  }\n  .lg\\:grid-flow-col {\n    grid-auto-flow: column;\n  }\n  .lg\\:grid-flow-row-dense {\n    grid-auto-flow: row dense;\n  }\n  .lg\\:grid-flow-col-dense {\n    grid-auto-flow: column dense;\n  }\n  .lg\\:grid-cols-1 {\n    grid-template-columns: repeat(1, minmax(0, 1fr));\n  }\n  .lg\\:grid-cols-2 {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n  .lg\\:grid-cols-3 {\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n  }\n  .lg\\:grid-cols-4 {\n    grid-template-columns: repeat(4, minmax(0, 1fr));\n  }\n  .lg\\:grid-cols-5 {\n    grid-template-columns: repeat(5, minmax(0, 1fr));\n  }\n  .lg\\:grid-cols-6 {\n    grid-template-columns: repeat(6, minmax(0, 1fr));\n  }\n  .lg\\:grid-cols-7 {\n    grid-template-columns: repeat(7, minmax(0, 1fr));\n  }\n  .lg\\:grid-cols-8 {\n    grid-template-columns: repeat(8, minmax(0, 1fr));\n  }\n  .lg\\:grid-cols-9 {\n    grid-template-columns: repeat(9, minmax(0, 1fr));\n  }\n  .lg\\:grid-cols-10 {\n    grid-template-columns: repeat(10, minmax(0, 1fr));\n  }\n  .lg\\:grid-cols-11 {\n    grid-template-columns: repeat(11, minmax(0, 1fr));\n  }\n  .lg\\:grid-cols-12 {\n    grid-template-columns: repeat(12, minmax(0, 1fr));\n  }\n  .lg\\:grid-cols-none {\n    grid-template-columns: none;\n  }\n  .lg\\:auto-cols-auto {\n    grid-auto-columns: auto;\n  }\n  .lg\\:auto-cols-min {\n    grid-auto-columns: min-content;\n  }\n  .lg\\:auto-cols-max {\n    grid-auto-columns: max-content;\n  }\n  .lg\\:auto-cols-fr {\n    grid-auto-columns: minmax(0, 1fr);\n  }\n  .lg\\:col-auto {\n    grid-column: auto;\n  }\n  .lg\\:col-span-1 {\n    grid-column: span 1 / span 1;\n  }\n  .lg\\:col-span-2 {\n    grid-column: span 2 / span 2;\n  }\n  .lg\\:col-span-3 {\n    grid-column: span 3 / span 3;\n  }\n  .lg\\:col-span-4 {\n    grid-column: span 4 / span 4;\n  }\n  .lg\\:col-span-5 {\n    grid-column: span 5 / span 5;\n  }\n  .lg\\:col-span-6 {\n    grid-column: span 6 / span 6;\n  }\n  .lg\\:col-span-7 {\n    grid-column: span 7 / span 7;\n  }\n  .lg\\:col-span-8 {\n    grid-column: span 8 / span 8;\n  }\n  .lg\\:col-span-9 {\n    grid-column: span 9 / span 9;\n  }\n  .lg\\:col-span-10 {\n    grid-column: span 10 / span 10;\n  }\n  .lg\\:col-span-11 {\n    grid-column: span 11 / span 11;\n  }\n  .lg\\:col-span-12 {\n    grid-column: span 12 / span 12;\n  }\n  .lg\\:col-span-full {\n    grid-column: 1 / -1;\n  }\n  .lg\\:col-start-1 {\n    grid-column-start: 1;\n  }\n  .lg\\:col-start-2 {\n    grid-column-start: 2;\n  }\n  .lg\\:col-start-3 {\n    grid-column-start: 3;\n  }\n  .lg\\:col-start-4 {\n    grid-column-start: 4;\n  }\n  .lg\\:col-start-5 {\n    grid-column-start: 5;\n  }\n  .lg\\:col-start-6 {\n    grid-column-start: 6;\n  }\n  .lg\\:col-start-7 {\n    grid-column-start: 7;\n  }\n  .lg\\:col-start-8 {\n    grid-column-start: 8;\n  }\n  .lg\\:col-start-9 {\n    grid-column-start: 9;\n  }\n  .lg\\:col-start-10 {\n    grid-column-start: 10;\n  }\n  .lg\\:col-start-11 {\n    grid-column-start: 11;\n  }\n  .lg\\:col-start-12 {\n    grid-column-start: 12;\n  }\n  .lg\\:col-start-13 {\n    grid-column-start: 13;\n  }\n  .lg\\:col-start-auto {\n    grid-column-start: auto;\n  }\n  .lg\\:col-end-1 {\n    grid-column-end: 1;\n  }\n  .lg\\:col-end-2 {\n    grid-column-end: 2;\n  }\n  .lg\\:col-end-3 {\n    grid-column-end: 3;\n  }\n  .lg\\:col-end-4 {\n    grid-column-end: 4;\n  }\n  .lg\\:col-end-5 {\n    grid-column-end: 5;\n  }\n  .lg\\:col-end-6 {\n    grid-column-end: 6;\n  }\n  .lg\\:col-end-7 {\n    grid-column-end: 7;\n  }\n  .lg\\:col-end-8 {\n    grid-column-end: 8;\n  }\n  .lg\\:col-end-9 {\n    grid-column-end: 9;\n  }\n  .lg\\:col-end-10 {\n    grid-column-end: 10;\n  }\n  .lg\\:col-end-11 {\n    grid-column-end: 11;\n  }\n  .lg\\:col-end-12 {\n    grid-column-end: 12;\n  }\n  .lg\\:col-end-13 {\n    grid-column-end: 13;\n  }\n  .lg\\:col-end-auto {\n    grid-column-end: auto;\n  }\n  .lg\\:grid-rows-1 {\n    grid-template-rows: repeat(1, minmax(0, 1fr));\n  }\n  .lg\\:grid-rows-2 {\n    grid-template-rows: repeat(2, minmax(0, 1fr));\n  }\n  .lg\\:grid-rows-3 {\n    grid-template-rows: repeat(3, minmax(0, 1fr));\n  }\n  .lg\\:grid-rows-4 {\n    grid-template-rows: repeat(4, minmax(0, 1fr));\n  }\n  .lg\\:grid-rows-5 {\n    grid-template-rows: repeat(5, minmax(0, 1fr));\n  }\n  .lg\\:grid-rows-6 {\n    grid-template-rows: repeat(6, minmax(0, 1fr));\n  }\n  .lg\\:grid-rows-none {\n    grid-template-rows: none;\n  }\n  .lg\\:auto-rows-auto {\n    grid-auto-rows: auto;\n  }\n  .lg\\:auto-rows-min {\n    grid-auto-rows: min-content;\n  }\n  .lg\\:auto-rows-max {\n    grid-auto-rows: max-content;\n  }\n  .lg\\:auto-rows-fr {\n    grid-auto-rows: minmax(0, 1fr);\n  }\n  .lg\\:row-auto {\n    grid-row: auto;\n  }\n  .lg\\:row-span-1 {\n    grid-row: span 1 / span 1;\n  }\n  .lg\\:row-span-2 {\n    grid-row: span 2 / span 2;\n  }\n  .lg\\:row-span-3 {\n    grid-row: span 3 / span 3;\n  }\n  .lg\\:row-span-4 {\n    grid-row: span 4 / span 4;\n  }\n  .lg\\:row-span-5 {\n    grid-row: span 5 / span 5;\n  }\n  .lg\\:row-span-6 {\n    grid-row: span 6 / span 6;\n  }\n  .lg\\:row-span-full {\n    grid-row: 1 / -1;\n  }\n  .lg\\:row-start-1 {\n    grid-row-start: 1;\n  }\n  .lg\\:row-start-2 {\n    grid-row-start: 2;\n  }\n  .lg\\:row-start-3 {\n    grid-row-start: 3;\n  }\n  .lg\\:row-start-4 {\n    grid-row-start: 4;\n  }\n  .lg\\:row-start-5 {\n    grid-row-start: 5;\n  }\n  .lg\\:row-start-6 {\n    grid-row-start: 6;\n  }\n  .lg\\:row-start-7 {\n    grid-row-start: 7;\n  }\n  .lg\\:row-start-auto {\n    grid-row-start: auto;\n  }\n  .lg\\:row-end-1 {\n    grid-row-end: 1;\n  }\n  .lg\\:row-end-2 {\n    grid-row-end: 2;\n  }\n  .lg\\:row-end-3 {\n    grid-row-end: 3;\n  }\n  .lg\\:row-end-4 {\n    grid-row-end: 4;\n  }\n  .lg\\:row-end-5 {\n    grid-row-end: 5;\n  }\n  .lg\\:row-end-6 {\n    grid-row-end: 6;\n  }\n  .lg\\:row-end-7 {\n    grid-row-end: 7;\n  }\n  .lg\\:row-end-auto {\n    grid-row-end: auto;\n  }\n  .lg\\:transform {\n    --transform-translate-x: 0;\n    --transform-translate-y: 0;\n    --transform-rotate: 0;\n    --transform-skew-x: 0;\n    --transform-skew-y: 0;\n    --transform-scale-x: 1;\n    --transform-scale-y: 1;\n    transform: translateX(var(--transform-translate-x)) translateY(var(--transform-translate-y)) rotate(var(--transform-rotate)) skewX(var(--transform-skew-x)) skewY(var(--transform-skew-y)) scaleX(var(--transform-scale-x)) scaleY(var(--transform-scale-y));\n  }\n  .lg\\:transform-none {\n    transform: none;\n  }\n  .lg\\:origin-center {\n    transform-origin: center;\n  }\n  .lg\\:origin-top {\n    transform-origin: top;\n  }\n  .lg\\:origin-top-right {\n    transform-origin: top right;\n  }\n  .lg\\:origin-right {\n    transform-origin: right;\n  }\n  .lg\\:origin-bottom-right {\n    transform-origin: bottom right;\n  }\n  .lg\\:origin-bottom {\n    transform-origin: bottom;\n  }\n  .lg\\:origin-bottom-left {\n    transform-origin: bottom left;\n  }\n  .lg\\:origin-left {\n    transform-origin: left;\n  }\n  .lg\\:origin-top-left {\n    transform-origin: top left;\n  }\n  .lg\\:scale-0 {\n    --transform-scale-x: 0;\n    --transform-scale-y: 0;\n  }\n  .lg\\:scale-50 {\n    --transform-scale-x: .5;\n    --transform-scale-y: .5;\n  }\n  .lg\\:scale-75 {\n    --transform-scale-x: .75;\n    --transform-scale-y: .75;\n  }\n  .lg\\:scale-90 {\n    --transform-scale-x: .9;\n    --transform-scale-y: .9;\n  }\n  .lg\\:scale-95 {\n    --transform-scale-x: .95;\n    --transform-scale-y: .95;\n  }\n  .lg\\:scale-100 {\n    --transform-scale-x: 1;\n    --transform-scale-y: 1;\n  }\n  .lg\\:scale-105 {\n    --transform-scale-x: 1.05;\n    --transform-scale-y: 1.05;\n  }\n  .lg\\:scale-110 {\n    --transform-scale-x: 1.1;\n    --transform-scale-y: 1.1;\n  }\n  .lg\\:scale-125 {\n    --transform-scale-x: 1.25;\n    --transform-scale-y: 1.25;\n  }\n  .lg\\:scale-150 {\n    --transform-scale-x: 1.5;\n    --transform-scale-y: 1.5;\n  }\n  .lg\\:scale-x-0 {\n    --transform-scale-x: 0;\n  }\n  .lg\\:scale-x-50 {\n    --transform-scale-x: .5;\n  }\n  .lg\\:scale-x-75 {\n    --transform-scale-x: .75;\n  }\n  .lg\\:scale-x-90 {\n    --transform-scale-x: .9;\n  }\n  .lg\\:scale-x-95 {\n    --transform-scale-x: .95;\n  }\n  .lg\\:scale-x-100 {\n    --transform-scale-x: 1;\n  }\n  .lg\\:scale-x-105 {\n    --transform-scale-x: 1.05;\n  }\n  .lg\\:scale-x-110 {\n    --transform-scale-x: 1.1;\n  }\n  .lg\\:scale-x-125 {\n    --transform-scale-x: 1.25;\n  }\n  .lg\\:scale-x-150 {\n    --transform-scale-x: 1.5;\n  }\n  .lg\\:scale-y-0 {\n    --transform-scale-y: 0;\n  }\n  .lg\\:scale-y-50 {\n    --transform-scale-y: .5;\n  }\n  .lg\\:scale-y-75 {\n    --transform-scale-y: .75;\n  }\n  .lg\\:scale-y-90 {\n    --transform-scale-y: .9;\n  }\n  .lg\\:scale-y-95 {\n    --transform-scale-y: .95;\n  }\n  .lg\\:scale-y-100 {\n    --transform-scale-y: 1;\n  }\n  .lg\\:scale-y-105 {\n    --transform-scale-y: 1.05;\n  }\n  .lg\\:scale-y-110 {\n    --transform-scale-y: 1.1;\n  }\n  .lg\\:scale-y-125 {\n    --transform-scale-y: 1.25;\n  }\n  .lg\\:scale-y-150 {\n    --transform-scale-y: 1.5;\n  }\n  .lg\\:hover\\:scale-0:hover {\n    --transform-scale-x: 0;\n    --transform-scale-y: 0;\n  }\n  .lg\\:hover\\:scale-50:hover {\n    --transform-scale-x: .5;\n    --transform-scale-y: .5;\n  }\n  .lg\\:hover\\:scale-75:hover {\n    --transform-scale-x: .75;\n    --transform-scale-y: .75;\n  }\n  .lg\\:hover\\:scale-90:hover {\n    --transform-scale-x: .9;\n    --transform-scale-y: .9;\n  }\n  .lg\\:hover\\:scale-95:hover {\n    --transform-scale-x: .95;\n    --transform-scale-y: .95;\n  }\n  .lg\\:hover\\:scale-100:hover {\n    --transform-scale-x: 1;\n    --transform-scale-y: 1;\n  }\n  .lg\\:hover\\:scale-105:hover {\n    --transform-scale-x: 1.05;\n    --transform-scale-y: 1.05;\n  }\n  .lg\\:hover\\:scale-110:hover {\n    --transform-scale-x: 1.1;\n    --transform-scale-y: 1.1;\n  }\n  .lg\\:hover\\:scale-125:hover {\n    --transform-scale-x: 1.25;\n    --transform-scale-y: 1.25;\n  }\n  .lg\\:hover\\:scale-150:hover {\n    --transform-scale-x: 1.5;\n    --transform-scale-y: 1.5;\n  }\n  .lg\\:hover\\:scale-x-0:hover {\n    --transform-scale-x: 0;\n  }\n  .lg\\:hover\\:scale-x-50:hover {\n    --transform-scale-x: .5;\n  }\n  .lg\\:hover\\:scale-x-75:hover {\n    --transform-scale-x: .75;\n  }\n  .lg\\:hover\\:scale-x-90:hover {\n    --transform-scale-x: .9;\n  }\n  .lg\\:hover\\:scale-x-95:hover {\n    --transform-scale-x: .95;\n  }\n  .lg\\:hover\\:scale-x-100:hover {\n    --transform-scale-x: 1;\n  }\n  .lg\\:hover\\:scale-x-105:hover {\n    --transform-scale-x: 1.05;\n  }\n  .lg\\:hover\\:scale-x-110:hover {\n    --transform-scale-x: 1.1;\n  }\n  .lg\\:hover\\:scale-x-125:hover {\n    --transform-scale-x: 1.25;\n  }\n  .lg\\:hover\\:scale-x-150:hover {\n    --transform-scale-x: 1.5;\n  }\n  .lg\\:hover\\:scale-y-0:hover {\n    --transform-scale-y: 0;\n  }\n  .lg\\:hover\\:scale-y-50:hover {\n    --transform-scale-y: .5;\n  }\n  .lg\\:hover\\:scale-y-75:hover {\n    --transform-scale-y: .75;\n  }\n  .lg\\:hover\\:scale-y-90:hover {\n    --transform-scale-y: .9;\n  }\n  .lg\\:hover\\:scale-y-95:hover {\n    --transform-scale-y: .95;\n  }\n  .lg\\:hover\\:scale-y-100:hover {\n    --transform-scale-y: 1;\n  }\n  .lg\\:hover\\:scale-y-105:hover {\n    --transform-scale-y: 1.05;\n  }\n  .lg\\:hover\\:scale-y-110:hover {\n    --transform-scale-y: 1.1;\n  }\n  .lg\\:hover\\:scale-y-125:hover {\n    --transform-scale-y: 1.25;\n  }\n  .lg\\:hover\\:scale-y-150:hover {\n    --transform-scale-y: 1.5;\n  }\n  .lg\\:focus\\:scale-0:focus {\n    --transform-scale-x: 0;\n    --transform-scale-y: 0;\n  }\n  .lg\\:focus\\:scale-50:focus {\n    --transform-scale-x: .5;\n    --transform-scale-y: .5;\n  }\n  .lg\\:focus\\:scale-75:focus {\n    --transform-scale-x: .75;\n    --transform-scale-y: .75;\n  }\n  .lg\\:focus\\:scale-90:focus {\n    --transform-scale-x: .9;\n    --transform-scale-y: .9;\n  }\n  .lg\\:focus\\:scale-95:focus {\n    --transform-scale-x: .95;\n    --transform-scale-y: .95;\n  }\n  .lg\\:focus\\:scale-100:focus {\n    --transform-scale-x: 1;\n    --transform-scale-y: 1;\n  }\n  .lg\\:focus\\:scale-105:focus {\n    --transform-scale-x: 1.05;\n    --transform-scale-y: 1.05;\n  }\n  .lg\\:focus\\:scale-110:focus {\n    --transform-scale-x: 1.1;\n    --transform-scale-y: 1.1;\n  }\n  .lg\\:focus\\:scale-125:focus {\n    --transform-scale-x: 1.25;\n    --transform-scale-y: 1.25;\n  }\n  .lg\\:focus\\:scale-150:focus {\n    --transform-scale-x: 1.5;\n    --transform-scale-y: 1.5;\n  }\n  .lg\\:focus\\:scale-x-0:focus {\n    --transform-scale-x: 0;\n  }\n  .lg\\:focus\\:scale-x-50:focus {\n    --transform-scale-x: .5;\n  }\n  .lg\\:focus\\:scale-x-75:focus {\n    --transform-scale-x: .75;\n  }\n  .lg\\:focus\\:scale-x-90:focus {\n    --transform-scale-x: .9;\n  }\n  .lg\\:focus\\:scale-x-95:focus {\n    --transform-scale-x: .95;\n  }\n  .lg\\:focus\\:scale-x-100:focus {\n    --transform-scale-x: 1;\n  }\n  .lg\\:focus\\:scale-x-105:focus {\n    --transform-scale-x: 1.05;\n  }\n  .lg\\:focus\\:scale-x-110:focus {\n    --transform-scale-x: 1.1;\n  }\n  .lg\\:focus\\:scale-x-125:focus {\n    --transform-scale-x: 1.25;\n  }\n  .lg\\:focus\\:scale-x-150:focus {\n    --transform-scale-x: 1.5;\n  }\n  .lg\\:focus\\:scale-y-0:focus {\n    --transform-scale-y: 0;\n  }\n  .lg\\:focus\\:scale-y-50:focus {\n    --transform-scale-y: .5;\n  }\n  .lg\\:focus\\:scale-y-75:focus {\n    --transform-scale-y: .75;\n  }\n  .lg\\:focus\\:scale-y-90:focus {\n    --transform-scale-y: .9;\n  }\n  .lg\\:focus\\:scale-y-95:focus {\n    --transform-scale-y: .95;\n  }\n  .lg\\:focus\\:scale-y-100:focus {\n    --transform-scale-y: 1;\n  }\n  .lg\\:focus\\:scale-y-105:focus {\n    --transform-scale-y: 1.05;\n  }\n  .lg\\:focus\\:scale-y-110:focus {\n    --transform-scale-y: 1.1;\n  }\n  .lg\\:focus\\:scale-y-125:focus {\n    --transform-scale-y: 1.25;\n  }\n  .lg\\:focus\\:scale-y-150:focus {\n    --transform-scale-y: 1.5;\n  }\n  .lg\\:rotate-0 {\n    --transform-rotate: 0;\n  }\n  .lg\\:rotate-1 {\n    --transform-rotate: 1deg;\n  }\n  .lg\\:rotate-2 {\n    --transform-rotate: 2deg;\n  }\n  .lg\\:rotate-3 {\n    --transform-rotate: 3deg;\n  }\n  .lg\\:rotate-6 {\n    --transform-rotate: 6deg;\n  }\n  .lg\\:rotate-12 {\n    --transform-rotate: 12deg;\n  }\n  .lg\\:rotate-45 {\n    --transform-rotate: 45deg;\n  }\n  .lg\\:rotate-90 {\n    --transform-rotate: 90deg;\n  }\n  .lg\\:rotate-180 {\n    --transform-rotate: 180deg;\n  }\n  .lg\\:-rotate-180 {\n    --transform-rotate: -180deg;\n  }\n  .lg\\:-rotate-90 {\n    --transform-rotate: -90deg;\n  }\n  .lg\\:-rotate-45 {\n    --transform-rotate: -45deg;\n  }\n  .lg\\:-rotate-12 {\n    --transform-rotate: -12deg;\n  }\n  .lg\\:-rotate-6 {\n    --transform-rotate: -6deg;\n  }\n  .lg\\:-rotate-3 {\n    --transform-rotate: -3deg;\n  }\n  .lg\\:-rotate-2 {\n    --transform-rotate: -2deg;\n  }\n  .lg\\:-rotate-1 {\n    --transform-rotate: -1deg;\n  }\n  .lg\\:hover\\:rotate-0:hover {\n    --transform-rotate: 0;\n  }\n  .lg\\:hover\\:rotate-1:hover {\n    --transform-rotate: 1deg;\n  }\n  .lg\\:hover\\:rotate-2:hover {\n    --transform-rotate: 2deg;\n  }\n  .lg\\:hover\\:rotate-3:hover {\n    --transform-rotate: 3deg;\n  }\n  .lg\\:hover\\:rotate-6:hover {\n    --transform-rotate: 6deg;\n  }\n  .lg\\:hover\\:rotate-12:hover {\n    --transform-rotate: 12deg;\n  }\n  .lg\\:hover\\:rotate-45:hover {\n    --transform-rotate: 45deg;\n  }\n  .lg\\:hover\\:rotate-90:hover {\n    --transform-rotate: 90deg;\n  }\n  .lg\\:hover\\:rotate-180:hover {\n    --transform-rotate: 180deg;\n  }\n  .lg\\:hover\\:-rotate-180:hover {\n    --transform-rotate: -180deg;\n  }\n  .lg\\:hover\\:-rotate-90:hover {\n    --transform-rotate: -90deg;\n  }\n  .lg\\:hover\\:-rotate-45:hover {\n    --transform-rotate: -45deg;\n  }\n  .lg\\:hover\\:-rotate-12:hover {\n    --transform-rotate: -12deg;\n  }\n  .lg\\:hover\\:-rotate-6:hover {\n    --transform-rotate: -6deg;\n  }\n  .lg\\:hover\\:-rotate-3:hover {\n    --transform-rotate: -3deg;\n  }\n  .lg\\:hover\\:-rotate-2:hover {\n    --transform-rotate: -2deg;\n  }\n  .lg\\:hover\\:-rotate-1:hover {\n    --transform-rotate: -1deg;\n  }\n  .lg\\:focus\\:rotate-0:focus {\n    --transform-rotate: 0;\n  }\n  .lg\\:focus\\:rotate-1:focus {\n    --transform-rotate: 1deg;\n  }\n  .lg\\:focus\\:rotate-2:focus {\n    --transform-rotate: 2deg;\n  }\n  .lg\\:focus\\:rotate-3:focus {\n    --transform-rotate: 3deg;\n  }\n  .lg\\:focus\\:rotate-6:focus {\n    --transform-rotate: 6deg;\n  }\n  .lg\\:focus\\:rotate-12:focus {\n    --transform-rotate: 12deg;\n  }\n  .lg\\:focus\\:rotate-45:focus {\n    --transform-rotate: 45deg;\n  }\n  .lg\\:focus\\:rotate-90:focus {\n    --transform-rotate: 90deg;\n  }\n  .lg\\:focus\\:rotate-180:focus {\n    --transform-rotate: 180deg;\n  }\n  .lg\\:focus\\:-rotate-180:focus {\n    --transform-rotate: -180deg;\n  }\n  .lg\\:focus\\:-rotate-90:focus {\n    --transform-rotate: -90deg;\n  }\n  .lg\\:focus\\:-rotate-45:focus {\n    --transform-rotate: -45deg;\n  }\n  .lg\\:focus\\:-rotate-12:focus {\n    --transform-rotate: -12deg;\n  }\n  .lg\\:focus\\:-rotate-6:focus {\n    --transform-rotate: -6deg;\n  }\n  .lg\\:focus\\:-rotate-3:focus {\n    --transform-rotate: -3deg;\n  }\n  .lg\\:focus\\:-rotate-2:focus {\n    --transform-rotate: -2deg;\n  }\n  .lg\\:focus\\:-rotate-1:focus {\n    --transform-rotate: -1deg;\n  }\n  .lg\\:translate-x-0 {\n    --transform-translate-x: 0;\n  }\n  .lg\\:translate-x-1 {\n    --transform-translate-x: 0.25rem;\n  }\n  .lg\\:translate-x-2 {\n    --transform-translate-x: 0.5rem;\n  }\n  .lg\\:translate-x-3 {\n    --transform-translate-x: 0.75rem;\n  }\n  .lg\\:translate-x-4 {\n    --transform-translate-x: 1rem;\n  }\n  .lg\\:translate-x-5 {\n    --transform-translate-x: 1.25rem;\n  }\n  .lg\\:translate-x-6 {\n    --transform-translate-x: 1.5rem;\n  }\n  .lg\\:translate-x-7 {\n    --transform-translate-x: 1.75rem;\n  }\n  .lg\\:translate-x-8 {\n    --transform-translate-x: 2rem;\n  }\n  .lg\\:translate-x-9 {\n    --transform-translate-x: 2.25rem;\n  }\n  .lg\\:translate-x-10 {\n    --transform-translate-x: 2.5rem;\n  }\n  .lg\\:translate-x-11 {\n    --transform-translate-x: 2.75rem;\n  }\n  .lg\\:translate-x-12 {\n    --transform-translate-x: 3rem;\n  }\n  .lg\\:translate-x-13 {\n    --transform-translate-x: 3.25rem;\n  }\n  .lg\\:translate-x-14 {\n    --transform-translate-x: 3.5rem;\n  }\n  .lg\\:translate-x-15 {\n    --transform-translate-x: 3.75rem;\n  }\n  .lg\\:translate-x-16 {\n    --transform-translate-x: 4rem;\n  }\n  .lg\\:translate-x-20 {\n    --transform-translate-x: 5rem;\n  }\n  .lg\\:translate-x-24 {\n    --transform-translate-x: 6rem;\n  }\n  .lg\\:translate-x-28 {\n    --transform-translate-x: 7rem;\n  }\n  .lg\\:translate-x-32 {\n    --transform-translate-x: 8rem;\n  }\n  .lg\\:translate-x-36 {\n    --transform-translate-x: 9rem;\n  }\n  .lg\\:translate-x-40 {\n    --transform-translate-x: 10rem;\n  }\n  .lg\\:translate-x-44 {\n    --transform-translate-x: 11rem;\n  }\n  .lg\\:translate-x-48 {\n    --transform-translate-x: 12rem;\n  }\n  .lg\\:translate-x-52 {\n    --transform-translate-x: 13rem;\n  }\n  .lg\\:translate-x-56 {\n    --transform-translate-x: 14rem;\n  }\n  .lg\\:translate-x-60 {\n    --transform-translate-x: 15rem;\n  }\n  .lg\\:translate-x-64 {\n    --transform-translate-x: 16rem;\n  }\n  .lg\\:translate-x-72 {\n    --transform-translate-x: 18rem;\n  }\n  .lg\\:translate-x-80 {\n    --transform-translate-x: 20rem;\n  }\n  .lg\\:translate-x-96 {\n    --transform-translate-x: 24rem;\n  }\n  .lg\\:translate-x-px {\n    --transform-translate-x: 1px;\n  }\n  .lg\\:translate-x-0\\.5 {\n    --transform-translate-x: 0.125rem;\n  }\n  .lg\\:translate-x-1\\.5 {\n    --transform-translate-x: 0.375rem;\n  }\n  .lg\\:translate-x-2\\.5 {\n    --transform-translate-x: 0.625rem;\n  }\n  .lg\\:translate-x-3\\.5 {\n    --transform-translate-x: 0.875rem;\n  }\n  .lg\\:translate-x-1\\/2 {\n    --transform-translate-x: 50%;\n  }\n  .lg\\:translate-x-1\\/3 {\n    --transform-translate-x: 33.333333%;\n  }\n  .lg\\:translate-x-2\\/3 {\n    --transform-translate-x: 66.666667%;\n  }\n  .lg\\:translate-x-1\\/4 {\n    --transform-translate-x: 25%;\n  }\n  .lg\\:translate-x-2\\/4 {\n    --transform-translate-x: 50%;\n  }\n  .lg\\:translate-x-3\\/4 {\n    --transform-translate-x: 75%;\n  }\n  .lg\\:translate-x-1\\/5 {\n    --transform-translate-x: 20%;\n  }\n  .lg\\:translate-x-2\\/5 {\n    --transform-translate-x: 40%;\n  }\n  .lg\\:translate-x-3\\/5 {\n    --transform-translate-x: 60%;\n  }\n  .lg\\:translate-x-4\\/5 {\n    --transform-translate-x: 80%;\n  }\n  .lg\\:translate-x-1\\/6 {\n    --transform-translate-x: 16.666667%;\n  }\n  .lg\\:translate-x-2\\/6 {\n    --transform-translate-x: 33.333333%;\n  }\n  .lg\\:translate-x-3\\/6 {\n    --transform-translate-x: 50%;\n  }\n  .lg\\:translate-x-4\\/6 {\n    --transform-translate-x: 66.666667%;\n  }\n  .lg\\:translate-x-5\\/6 {\n    --transform-translate-x: 83.333333%;\n  }\n  .lg\\:translate-x-1\\/12 {\n    --transform-translate-x: 8.333333%;\n  }\n  .lg\\:translate-x-2\\/12 {\n    --transform-translate-x: 16.666667%;\n  }\n  .lg\\:translate-x-3\\/12 {\n    --transform-translate-x: 25%;\n  }\n  .lg\\:translate-x-4\\/12 {\n    --transform-translate-x: 33.333333%;\n  }\n  .lg\\:translate-x-5\\/12 {\n    --transform-translate-x: 41.666667%;\n  }\n  .lg\\:translate-x-6\\/12 {\n    --transform-translate-x: 50%;\n  }\n  .lg\\:translate-x-7\\/12 {\n    --transform-translate-x: 58.333333%;\n  }\n  .lg\\:translate-x-8\\/12 {\n    --transform-translate-x: 66.666667%;\n  }\n  .lg\\:translate-x-9\\/12 {\n    --transform-translate-x: 75%;\n  }\n  .lg\\:translate-x-10\\/12 {\n    --transform-translate-x: 83.333333%;\n  }\n  .lg\\:translate-x-11\\/12 {\n    --transform-translate-x: 91.666667%;\n  }\n  .lg\\:translate-x-full {\n    --transform-translate-x: 100%;\n  }\n  .lg\\:-translate-x-1 {\n    --transform-translate-x: -0.25rem;\n  }\n  .lg\\:-translate-x-2 {\n    --transform-translate-x: -0.5rem;\n  }\n  .lg\\:-translate-x-3 {\n    --transform-translate-x: -0.75rem;\n  }\n  .lg\\:-translate-x-4 {\n    --transform-translate-x: -1rem;\n  }\n  .lg\\:-translate-x-5 {\n    --transform-translate-x: -1.25rem;\n  }\n  .lg\\:-translate-x-6 {\n    --transform-translate-x: -1.5rem;\n  }\n  .lg\\:-translate-x-7 {\n    --transform-translate-x: -1.75rem;\n  }\n  .lg\\:-translate-x-8 {\n    --transform-translate-x: -2rem;\n  }\n  .lg\\:-translate-x-9 {\n    --transform-translate-x: -2.25rem;\n  }\n  .lg\\:-translate-x-10 {\n    --transform-translate-x: -2.5rem;\n  }\n  .lg\\:-translate-x-11 {\n    --transform-translate-x: -2.75rem;\n  }\n  .lg\\:-translate-x-12 {\n    --transform-translate-x: -3rem;\n  }\n  .lg\\:-translate-x-13 {\n    --transform-translate-x: -3.25rem;\n  }\n  .lg\\:-translate-x-14 {\n    --transform-translate-x: -3.5rem;\n  }\n  .lg\\:-translate-x-15 {\n    --transform-translate-x: -3.75rem;\n  }\n  .lg\\:-translate-x-16 {\n    --transform-translate-x: -4rem;\n  }\n  .lg\\:-translate-x-20 {\n    --transform-translate-x: -5rem;\n  }\n  .lg\\:-translate-x-24 {\n    --transform-translate-x: -6rem;\n  }\n  .lg\\:-translate-x-28 {\n    --transform-translate-x: -7rem;\n  }\n  .lg\\:-translate-x-32 {\n    --transform-translate-x: -8rem;\n  }\n  .lg\\:-translate-x-36 {\n    --transform-translate-x: -9rem;\n  }\n  .lg\\:-translate-x-40 {\n    --transform-translate-x: -10rem;\n  }\n  .lg\\:-translate-x-44 {\n    --transform-translate-x: -11rem;\n  }\n  .lg\\:-translate-x-48 {\n    --transform-translate-x: -12rem;\n  }\n  .lg\\:-translate-x-52 {\n    --transform-translate-x: -13rem;\n  }\n  .lg\\:-translate-x-56 {\n    --transform-translate-x: -14rem;\n  }\n  .lg\\:-translate-x-60 {\n    --transform-translate-x: -15rem;\n  }\n  .lg\\:-translate-x-64 {\n    --transform-translate-x: -16rem;\n  }\n  .lg\\:-translate-x-72 {\n    --transform-translate-x: -18rem;\n  }\n  .lg\\:-translate-x-80 {\n    --transform-translate-x: -20rem;\n  }\n  .lg\\:-translate-x-96 {\n    --transform-translate-x: -24rem;\n  }\n  .lg\\:-translate-x-px {\n    --transform-translate-x: -1px;\n  }\n  .lg\\:-translate-x-0\\.5 {\n    --transform-translate-x: -0.125rem;\n  }\n  .lg\\:-translate-x-1\\.5 {\n    --transform-translate-x: -0.375rem;\n  }\n  .lg\\:-translate-x-2\\.5 {\n    --transform-translate-x: -0.625rem;\n  }\n  .lg\\:-translate-x-3\\.5 {\n    --transform-translate-x: -0.875rem;\n  }\n  .lg\\:-translate-x-1\\/2 {\n    --transform-translate-x: -50%;\n  }\n  .lg\\:-translate-x-1\\/3 {\n    --transform-translate-x: -33.33333%;\n  }\n  .lg\\:-translate-x-2\\/3 {\n    --transform-translate-x: -66.66667%;\n  }\n  .lg\\:-translate-x-1\\/4 {\n    --transform-translate-x: -25%;\n  }\n  .lg\\:-translate-x-2\\/4 {\n    --transform-translate-x: -50%;\n  }\n  .lg\\:-translate-x-3\\/4 {\n    --transform-translate-x: -75%;\n  }\n  .lg\\:-translate-x-1\\/5 {\n    --transform-translate-x: -20%;\n  }\n  .lg\\:-translate-x-2\\/5 {\n    --transform-translate-x: -40%;\n  }\n  .lg\\:-translate-x-3\\/5 {\n    --transform-translate-x: -60%;\n  }\n  .lg\\:-translate-x-4\\/5 {\n    --transform-translate-x: -80%;\n  }\n  .lg\\:-translate-x-1\\/6 {\n    --transform-translate-x: -16.66667%;\n  }\n  .lg\\:-translate-x-2\\/6 {\n    --transform-translate-x: -33.33333%;\n  }\n  .lg\\:-translate-x-3\\/6 {\n    --transform-translate-x: -50%;\n  }\n  .lg\\:-translate-x-4\\/6 {\n    --transform-translate-x: -66.66667%;\n  }\n  .lg\\:-translate-x-5\\/6 {\n    --transform-translate-x: -83.33333%;\n  }\n  .lg\\:-translate-x-1\\/12 {\n    --transform-translate-x: -8.33333%;\n  }\n  .lg\\:-translate-x-2\\/12 {\n    --transform-translate-x: -16.66667%;\n  }\n  .lg\\:-translate-x-3\\/12 {\n    --transform-translate-x: -25%;\n  }\n  .lg\\:-translate-x-4\\/12 {\n    --transform-translate-x: -33.33333%;\n  }\n  .lg\\:-translate-x-5\\/12 {\n    --transform-translate-x: -41.66667%;\n  }\n  .lg\\:-translate-x-6\\/12 {\n    --transform-translate-x: -50%;\n  }\n  .lg\\:-translate-x-7\\/12 {\n    --transform-translate-x: -58.33333%;\n  }\n  .lg\\:-translate-x-8\\/12 {\n    --transform-translate-x: -66.66667%;\n  }\n  .lg\\:-translate-x-9\\/12 {\n    --transform-translate-x: -75%;\n  }\n  .lg\\:-translate-x-10\\/12 {\n    --transform-translate-x: -83.33333%;\n  }\n  .lg\\:-translate-x-11\\/12 {\n    --transform-translate-x: -91.66667%;\n  }\n  .lg\\:-translate-x-full {\n    --transform-translate-x: -100%;\n  }\n  .lg\\:translate-y-0 {\n    --transform-translate-y: 0;\n  }\n  .lg\\:translate-y-1 {\n    --transform-translate-y: 0.25rem;\n  }\n  .lg\\:translate-y-2 {\n    --transform-translate-y: 0.5rem;\n  }\n  .lg\\:translate-y-3 {\n    --transform-translate-y: 0.75rem;\n  }\n  .lg\\:translate-y-4 {\n    --transform-translate-y: 1rem;\n  }\n  .lg\\:translate-y-5 {\n    --transform-translate-y: 1.25rem;\n  }\n  .lg\\:translate-y-6 {\n    --transform-translate-y: 1.5rem;\n  }\n  .lg\\:translate-y-7 {\n    --transform-translate-y: 1.75rem;\n  }\n  .lg\\:translate-y-8 {\n    --transform-translate-y: 2rem;\n  }\n  .lg\\:translate-y-9 {\n    --transform-translate-y: 2.25rem;\n  }\n  .lg\\:translate-y-10 {\n    --transform-translate-y: 2.5rem;\n  }\n  .lg\\:translate-y-11 {\n    --transform-translate-y: 2.75rem;\n  }\n  .lg\\:translate-y-12 {\n    --transform-translate-y: 3rem;\n  }\n  .lg\\:translate-y-13 {\n    --transform-translate-y: 3.25rem;\n  }\n  .lg\\:translate-y-14 {\n    --transform-translate-y: 3.5rem;\n  }\n  .lg\\:translate-y-15 {\n    --transform-translate-y: 3.75rem;\n  }\n  .lg\\:translate-y-16 {\n    --transform-translate-y: 4rem;\n  }\n  .lg\\:translate-y-20 {\n    --transform-translate-y: 5rem;\n  }\n  .lg\\:translate-y-24 {\n    --transform-translate-y: 6rem;\n  }\n  .lg\\:translate-y-28 {\n    --transform-translate-y: 7rem;\n  }\n  .lg\\:translate-y-32 {\n    --transform-translate-y: 8rem;\n  }\n  .lg\\:translate-y-36 {\n    --transform-translate-y: 9rem;\n  }\n  .lg\\:translate-y-40 {\n    --transform-translate-y: 10rem;\n  }\n  .lg\\:translate-y-44 {\n    --transform-translate-y: 11rem;\n  }\n  .lg\\:translate-y-48 {\n    --transform-translate-y: 12rem;\n  }\n  .lg\\:translate-y-52 {\n    --transform-translate-y: 13rem;\n  }\n  .lg\\:translate-y-56 {\n    --transform-translate-y: 14rem;\n  }\n  .lg\\:translate-y-60 {\n    --transform-translate-y: 15rem;\n  }\n  .lg\\:translate-y-64 {\n    --transform-translate-y: 16rem;\n  }\n  .lg\\:translate-y-72 {\n    --transform-translate-y: 18rem;\n  }\n  .lg\\:translate-y-80 {\n    --transform-translate-y: 20rem;\n  }\n  .lg\\:translate-y-96 {\n    --transform-translate-y: 24rem;\n  }\n  .lg\\:translate-y-px {\n    --transform-translate-y: 1px;\n  }\n  .lg\\:translate-y-0\\.5 {\n    --transform-translate-y: 0.125rem;\n  }\n  .lg\\:translate-y-1\\.5 {\n    --transform-translate-y: 0.375rem;\n  }\n  .lg\\:translate-y-2\\.5 {\n    --transform-translate-y: 0.625rem;\n  }\n  .lg\\:translate-y-3\\.5 {\n    --transform-translate-y: 0.875rem;\n  }\n  .lg\\:translate-y-1\\/2 {\n    --transform-translate-y: 50%;\n  }\n  .lg\\:translate-y-1\\/3 {\n    --transform-translate-y: 33.333333%;\n  }\n  .lg\\:translate-y-2\\/3 {\n    --transform-translate-y: 66.666667%;\n  }\n  .lg\\:translate-y-1\\/4 {\n    --transform-translate-y: 25%;\n  }\n  .lg\\:translate-y-2\\/4 {\n    --transform-translate-y: 50%;\n  }\n  .lg\\:translate-y-3\\/4 {\n    --transform-translate-y: 75%;\n  }\n  .lg\\:translate-y-1\\/5 {\n    --transform-translate-y: 20%;\n  }\n  .lg\\:translate-y-2\\/5 {\n    --transform-translate-y: 40%;\n  }\n  .lg\\:translate-y-3\\/5 {\n    --transform-translate-y: 60%;\n  }\n  .lg\\:translate-y-4\\/5 {\n    --transform-translate-y: 80%;\n  }\n  .lg\\:translate-y-1\\/6 {\n    --transform-translate-y: 16.666667%;\n  }\n  .lg\\:translate-y-2\\/6 {\n    --transform-translate-y: 33.333333%;\n  }\n  .lg\\:translate-y-3\\/6 {\n    --transform-translate-y: 50%;\n  }\n  .lg\\:translate-y-4\\/6 {\n    --transform-translate-y: 66.666667%;\n  }\n  .lg\\:translate-y-5\\/6 {\n    --transform-translate-y: 83.333333%;\n  }\n  .lg\\:translate-y-1\\/12 {\n    --transform-translate-y: 8.333333%;\n  }\n  .lg\\:translate-y-2\\/12 {\n    --transform-translate-y: 16.666667%;\n  }\n  .lg\\:translate-y-3\\/12 {\n    --transform-translate-y: 25%;\n  }\n  .lg\\:translate-y-4\\/12 {\n    --transform-translate-y: 33.333333%;\n  }\n  .lg\\:translate-y-5\\/12 {\n    --transform-translate-y: 41.666667%;\n  }\n  .lg\\:translate-y-6\\/12 {\n    --transform-translate-y: 50%;\n  }\n  .lg\\:translate-y-7\\/12 {\n    --transform-translate-y: 58.333333%;\n  }\n  .lg\\:translate-y-8\\/12 {\n    --transform-translate-y: 66.666667%;\n  }\n  .lg\\:translate-y-9\\/12 {\n    --transform-translate-y: 75%;\n  }\n  .lg\\:translate-y-10\\/12 {\n    --transform-translate-y: 83.333333%;\n  }\n  .lg\\:translate-y-11\\/12 {\n    --transform-translate-y: 91.666667%;\n  }\n  .lg\\:translate-y-full {\n    --transform-translate-y: 100%;\n  }\n  .lg\\:-translate-y-1 {\n    --transform-translate-y: -0.25rem;\n  }\n  .lg\\:-translate-y-2 {\n    --transform-translate-y: -0.5rem;\n  }\n  .lg\\:-translate-y-3 {\n    --transform-translate-y: -0.75rem;\n  }\n  .lg\\:-translate-y-4 {\n    --transform-translate-y: -1rem;\n  }\n  .lg\\:-translate-y-5 {\n    --transform-translate-y: -1.25rem;\n  }\n  .lg\\:-translate-y-6 {\n    --transform-translate-y: -1.5rem;\n  }\n  .lg\\:-translate-y-7 {\n    --transform-translate-y: -1.75rem;\n  }\n  .lg\\:-translate-y-8 {\n    --transform-translate-y: -2rem;\n  }\n  .lg\\:-translate-y-9 {\n    --transform-translate-y: -2.25rem;\n  }\n  .lg\\:-translate-y-10 {\n    --transform-translate-y: -2.5rem;\n  }\n  .lg\\:-translate-y-11 {\n    --transform-translate-y: -2.75rem;\n  }\n  .lg\\:-translate-y-12 {\n    --transform-translate-y: -3rem;\n  }\n  .lg\\:-translate-y-13 {\n    --transform-translate-y: -3.25rem;\n  }\n  .lg\\:-translate-y-14 {\n    --transform-translate-y: -3.5rem;\n  }\n  .lg\\:-translate-y-15 {\n    --transform-translate-y: -3.75rem;\n  }\n  .lg\\:-translate-y-16 {\n    --transform-translate-y: -4rem;\n  }\n  .lg\\:-translate-y-20 {\n    --transform-translate-y: -5rem;\n  }\n  .lg\\:-translate-y-24 {\n    --transform-translate-y: -6rem;\n  }\n  .lg\\:-translate-y-28 {\n    --transform-translate-y: -7rem;\n  }\n  .lg\\:-translate-y-32 {\n    --transform-translate-y: -8rem;\n  }\n  .lg\\:-translate-y-36 {\n    --transform-translate-y: -9rem;\n  }\n  .lg\\:-translate-y-40 {\n    --transform-translate-y: -10rem;\n  }\n  .lg\\:-translate-y-44 {\n    --transform-translate-y: -11rem;\n  }\n  .lg\\:-translate-y-48 {\n    --transform-translate-y: -12rem;\n  }\n  .lg\\:-translate-y-52 {\n    --transform-translate-y: -13rem;\n  }\n  .lg\\:-translate-y-56 {\n    --transform-translate-y: -14rem;\n  }\n  .lg\\:-translate-y-60 {\n    --transform-translate-y: -15rem;\n  }\n  .lg\\:-translate-y-64 {\n    --transform-translate-y: -16rem;\n  }\n  .lg\\:-translate-y-72 {\n    --transform-translate-y: -18rem;\n  }\n  .lg\\:-translate-y-80 {\n    --transform-translate-y: -20rem;\n  }\n  .lg\\:-translate-y-96 {\n    --transform-translate-y: -24rem;\n  }\n  .lg\\:-translate-y-px {\n    --transform-translate-y: -1px;\n  }\n  .lg\\:-translate-y-0\\.5 {\n    --transform-translate-y: -0.125rem;\n  }\n  .lg\\:-translate-y-1\\.5 {\n    --transform-translate-y: -0.375rem;\n  }\n  .lg\\:-translate-y-2\\.5 {\n    --transform-translate-y: -0.625rem;\n  }\n  .lg\\:-translate-y-3\\.5 {\n    --transform-translate-y: -0.875rem;\n  }\n  .lg\\:-translate-y-1\\/2 {\n    --transform-translate-y: -50%;\n  }\n  .lg\\:-translate-y-1\\/3 {\n    --transform-translate-y: -33.33333%;\n  }\n  .lg\\:-translate-y-2\\/3 {\n    --transform-translate-y: -66.66667%;\n  }\n  .lg\\:-translate-y-1\\/4 {\n    --transform-translate-y: -25%;\n  }\n  .lg\\:-translate-y-2\\/4 {\n    --transform-translate-y: -50%;\n  }\n  .lg\\:-translate-y-3\\/4 {\n    --transform-translate-y: -75%;\n  }\n  .lg\\:-translate-y-1\\/5 {\n    --transform-translate-y: -20%;\n  }\n  .lg\\:-translate-y-2\\/5 {\n    --transform-translate-y: -40%;\n  }\n  .lg\\:-translate-y-3\\/5 {\n    --transform-translate-y: -60%;\n  }\n  .lg\\:-translate-y-4\\/5 {\n    --transform-translate-y: -80%;\n  }\n  .lg\\:-translate-y-1\\/6 {\n    --transform-translate-y: -16.66667%;\n  }\n  .lg\\:-translate-y-2\\/6 {\n    --transform-translate-y: -33.33333%;\n  }\n  .lg\\:-translate-y-3\\/6 {\n    --transform-translate-y: -50%;\n  }\n  .lg\\:-translate-y-4\\/6 {\n    --transform-translate-y: -66.66667%;\n  }\n  .lg\\:-translate-y-5\\/6 {\n    --transform-translate-y: -83.33333%;\n  }\n  .lg\\:-translate-y-1\\/12 {\n    --transform-translate-y: -8.33333%;\n  }\n  .lg\\:-translate-y-2\\/12 {\n    --transform-translate-y: -16.66667%;\n  }\n  .lg\\:-translate-y-3\\/12 {\n    --transform-translate-y: -25%;\n  }\n  .lg\\:-translate-y-4\\/12 {\n    --transform-translate-y: -33.33333%;\n  }\n  .lg\\:-translate-y-5\\/12 {\n    --transform-translate-y: -41.66667%;\n  }\n  .lg\\:-translate-y-6\\/12 {\n    --transform-translate-y: -50%;\n  }\n  .lg\\:-translate-y-7\\/12 {\n    --transform-translate-y: -58.33333%;\n  }\n  .lg\\:-translate-y-8\\/12 {\n    --transform-translate-y: -66.66667%;\n  }\n  .lg\\:-translate-y-9\\/12 {\n    --transform-translate-y: -75%;\n  }\n  .lg\\:-translate-y-10\\/12 {\n    --transform-translate-y: -83.33333%;\n  }\n  .lg\\:-translate-y-11\\/12 {\n    --transform-translate-y: -91.66667%;\n  }\n  .lg\\:-translate-y-full {\n    --transform-translate-y: -100%;\n  }\n  .lg\\:hover\\:translate-x-0:hover {\n    --transform-translate-x: 0;\n  }\n  .lg\\:hover\\:translate-x-1:hover {\n    --transform-translate-x: 0.25rem;\n  }\n  .lg\\:hover\\:translate-x-2:hover {\n    --transform-translate-x: 0.5rem;\n  }\n  .lg\\:hover\\:translate-x-3:hover {\n    --transform-translate-x: 0.75rem;\n  }\n  .lg\\:hover\\:translate-x-4:hover {\n    --transform-translate-x: 1rem;\n  }\n  .lg\\:hover\\:translate-x-5:hover {\n    --transform-translate-x: 1.25rem;\n  }\n  .lg\\:hover\\:translate-x-6:hover {\n    --transform-translate-x: 1.5rem;\n  }\n  .lg\\:hover\\:translate-x-7:hover {\n    --transform-translate-x: 1.75rem;\n  }\n  .lg\\:hover\\:translate-x-8:hover {\n    --transform-translate-x: 2rem;\n  }\n  .lg\\:hover\\:translate-x-9:hover {\n    --transform-translate-x: 2.25rem;\n  }\n  .lg\\:hover\\:translate-x-10:hover {\n    --transform-translate-x: 2.5rem;\n  }\n  .lg\\:hover\\:translate-x-11:hover {\n    --transform-translate-x: 2.75rem;\n  }\n  .lg\\:hover\\:translate-x-12:hover {\n    --transform-translate-x: 3rem;\n  }\n  .lg\\:hover\\:translate-x-13:hover {\n    --transform-translate-x: 3.25rem;\n  }\n  .lg\\:hover\\:translate-x-14:hover {\n    --transform-translate-x: 3.5rem;\n  }\n  .lg\\:hover\\:translate-x-15:hover {\n    --transform-translate-x: 3.75rem;\n  }\n  .lg\\:hover\\:translate-x-16:hover {\n    --transform-translate-x: 4rem;\n  }\n  .lg\\:hover\\:translate-x-20:hover {\n    --transform-translate-x: 5rem;\n  }\n  .lg\\:hover\\:translate-x-24:hover {\n    --transform-translate-x: 6rem;\n  }\n  .lg\\:hover\\:translate-x-28:hover {\n    --transform-translate-x: 7rem;\n  }\n  .lg\\:hover\\:translate-x-32:hover {\n    --transform-translate-x: 8rem;\n  }\n  .lg\\:hover\\:translate-x-36:hover {\n    --transform-translate-x: 9rem;\n  }\n  .lg\\:hover\\:translate-x-40:hover {\n    --transform-translate-x: 10rem;\n  }\n  .lg\\:hover\\:translate-x-44:hover {\n    --transform-translate-x: 11rem;\n  }\n  .lg\\:hover\\:translate-x-48:hover {\n    --transform-translate-x: 12rem;\n  }\n  .lg\\:hover\\:translate-x-52:hover {\n    --transform-translate-x: 13rem;\n  }\n  .lg\\:hover\\:translate-x-56:hover {\n    --transform-translate-x: 14rem;\n  }\n  .lg\\:hover\\:translate-x-60:hover {\n    --transform-translate-x: 15rem;\n  }\n  .lg\\:hover\\:translate-x-64:hover {\n    --transform-translate-x: 16rem;\n  }\n  .lg\\:hover\\:translate-x-72:hover {\n    --transform-translate-x: 18rem;\n  }\n  .lg\\:hover\\:translate-x-80:hover {\n    --transform-translate-x: 20rem;\n  }\n  .lg\\:hover\\:translate-x-96:hover {\n    --transform-translate-x: 24rem;\n  }\n  .lg\\:hover\\:translate-x-px:hover {\n    --transform-translate-x: 1px;\n  }\n  .lg\\:hover\\:translate-x-0\\.5:hover {\n    --transform-translate-x: 0.125rem;\n  }\n  .lg\\:hover\\:translate-x-1\\.5:hover {\n    --transform-translate-x: 0.375rem;\n  }\n  .lg\\:hover\\:translate-x-2\\.5:hover {\n    --transform-translate-x: 0.625rem;\n  }\n  .lg\\:hover\\:translate-x-3\\.5:hover {\n    --transform-translate-x: 0.875rem;\n  }\n  .lg\\:hover\\:translate-x-1\\/2:hover {\n    --transform-translate-x: 50%;\n  }\n  .lg\\:hover\\:translate-x-1\\/3:hover {\n    --transform-translate-x: 33.333333%;\n  }\n  .lg\\:hover\\:translate-x-2\\/3:hover {\n    --transform-translate-x: 66.666667%;\n  }\n  .lg\\:hover\\:translate-x-1\\/4:hover {\n    --transform-translate-x: 25%;\n  }\n  .lg\\:hover\\:translate-x-2\\/4:hover {\n    --transform-translate-x: 50%;\n  }\n  .lg\\:hover\\:translate-x-3\\/4:hover {\n    --transform-translate-x: 75%;\n  }\n  .lg\\:hover\\:translate-x-1\\/5:hover {\n    --transform-translate-x: 20%;\n  }\n  .lg\\:hover\\:translate-x-2\\/5:hover {\n    --transform-translate-x: 40%;\n  }\n  .lg\\:hover\\:translate-x-3\\/5:hover {\n    --transform-translate-x: 60%;\n  }\n  .lg\\:hover\\:translate-x-4\\/5:hover {\n    --transform-translate-x: 80%;\n  }\n  .lg\\:hover\\:translate-x-1\\/6:hover {\n    --transform-translate-x: 16.666667%;\n  }\n  .lg\\:hover\\:translate-x-2\\/6:hover {\n    --transform-translate-x: 33.333333%;\n  }\n  .lg\\:hover\\:translate-x-3\\/6:hover {\n    --transform-translate-x: 50%;\n  }\n  .lg\\:hover\\:translate-x-4\\/6:hover {\n    --transform-translate-x: 66.666667%;\n  }\n  .lg\\:hover\\:translate-x-5\\/6:hover {\n    --transform-translate-x: 83.333333%;\n  }\n  .lg\\:hover\\:translate-x-1\\/12:hover {\n    --transform-translate-x: 8.333333%;\n  }\n  .lg\\:hover\\:translate-x-2\\/12:hover {\n    --transform-translate-x: 16.666667%;\n  }\n  .lg\\:hover\\:translate-x-3\\/12:hover {\n    --transform-translate-x: 25%;\n  }\n  .lg\\:hover\\:translate-x-4\\/12:hover {\n    --transform-translate-x: 33.333333%;\n  }\n  .lg\\:hover\\:translate-x-5\\/12:hover {\n    --transform-translate-x: 41.666667%;\n  }\n  .lg\\:hover\\:translate-x-6\\/12:hover {\n    --transform-translate-x: 50%;\n  }\n  .lg\\:hover\\:translate-x-7\\/12:hover {\n    --transform-translate-x: 58.333333%;\n  }\n  .lg\\:hover\\:translate-x-8\\/12:hover {\n    --transform-translate-x: 66.666667%;\n  }\n  .lg\\:hover\\:translate-x-9\\/12:hover {\n    --transform-translate-x: 75%;\n  }\n  .lg\\:hover\\:translate-x-10\\/12:hover {\n    --transform-translate-x: 83.333333%;\n  }\n  .lg\\:hover\\:translate-x-11\\/12:hover {\n    --transform-translate-x: 91.666667%;\n  }\n  .lg\\:hover\\:translate-x-full:hover {\n    --transform-translate-x: 100%;\n  }\n  .lg\\:hover\\:-translate-x-1:hover {\n    --transform-translate-x: -0.25rem;\n  }\n  .lg\\:hover\\:-translate-x-2:hover {\n    --transform-translate-x: -0.5rem;\n  }\n  .lg\\:hover\\:-translate-x-3:hover {\n    --transform-translate-x: -0.75rem;\n  }\n  .lg\\:hover\\:-translate-x-4:hover {\n    --transform-translate-x: -1rem;\n  }\n  .lg\\:hover\\:-translate-x-5:hover {\n    --transform-translate-x: -1.25rem;\n  }\n  .lg\\:hover\\:-translate-x-6:hover {\n    --transform-translate-x: -1.5rem;\n  }\n  .lg\\:hover\\:-translate-x-7:hover {\n    --transform-translate-x: -1.75rem;\n  }\n  .lg\\:hover\\:-translate-x-8:hover {\n    --transform-translate-x: -2rem;\n  }\n  .lg\\:hover\\:-translate-x-9:hover {\n    --transform-translate-x: -2.25rem;\n  }\n  .lg\\:hover\\:-translate-x-10:hover {\n    --transform-translate-x: -2.5rem;\n  }\n  .lg\\:hover\\:-translate-x-11:hover {\n    --transform-translate-x: -2.75rem;\n  }\n  .lg\\:hover\\:-translate-x-12:hover {\n    --transform-translate-x: -3rem;\n  }\n  .lg\\:hover\\:-translate-x-13:hover {\n    --transform-translate-x: -3.25rem;\n  }\n  .lg\\:hover\\:-translate-x-14:hover {\n    --transform-translate-x: -3.5rem;\n  }\n  .lg\\:hover\\:-translate-x-15:hover {\n    --transform-translate-x: -3.75rem;\n  }\n  .lg\\:hover\\:-translate-x-16:hover {\n    --transform-translate-x: -4rem;\n  }\n  .lg\\:hover\\:-translate-x-20:hover {\n    --transform-translate-x: -5rem;\n  }\n  .lg\\:hover\\:-translate-x-24:hover {\n    --transform-translate-x: -6rem;\n  }\n  .lg\\:hover\\:-translate-x-28:hover {\n    --transform-translate-x: -7rem;\n  }\n  .lg\\:hover\\:-translate-x-32:hover {\n    --transform-translate-x: -8rem;\n  }\n  .lg\\:hover\\:-translate-x-36:hover {\n    --transform-translate-x: -9rem;\n  }\n  .lg\\:hover\\:-translate-x-40:hover {\n    --transform-translate-x: -10rem;\n  }\n  .lg\\:hover\\:-translate-x-44:hover {\n    --transform-translate-x: -11rem;\n  }\n  .lg\\:hover\\:-translate-x-48:hover {\n    --transform-translate-x: -12rem;\n  }\n  .lg\\:hover\\:-translate-x-52:hover {\n    --transform-translate-x: -13rem;\n  }\n  .lg\\:hover\\:-translate-x-56:hover {\n    --transform-translate-x: -14rem;\n  }\n  .lg\\:hover\\:-translate-x-60:hover {\n    --transform-translate-x: -15rem;\n  }\n  .lg\\:hover\\:-translate-x-64:hover {\n    --transform-translate-x: -16rem;\n  }\n  .lg\\:hover\\:-translate-x-72:hover {\n    --transform-translate-x: -18rem;\n  }\n  .lg\\:hover\\:-translate-x-80:hover {\n    --transform-translate-x: -20rem;\n  }\n  .lg\\:hover\\:-translate-x-96:hover {\n    --transform-translate-x: -24rem;\n  }\n  .lg\\:hover\\:-translate-x-px:hover {\n    --transform-translate-x: -1px;\n  }\n  .lg\\:hover\\:-translate-x-0\\.5:hover {\n    --transform-translate-x: -0.125rem;\n  }\n  .lg\\:hover\\:-translate-x-1\\.5:hover {\n    --transform-translate-x: -0.375rem;\n  }\n  .lg\\:hover\\:-translate-x-2\\.5:hover {\n    --transform-translate-x: -0.625rem;\n  }\n  .lg\\:hover\\:-translate-x-3\\.5:hover {\n    --transform-translate-x: -0.875rem;\n  }\n  .lg\\:hover\\:-translate-x-1\\/2:hover {\n    --transform-translate-x: -50%;\n  }\n  .lg\\:hover\\:-translate-x-1\\/3:hover {\n    --transform-translate-x: -33.33333%;\n  }\n  .lg\\:hover\\:-translate-x-2\\/3:hover {\n    --transform-translate-x: -66.66667%;\n  }\n  .lg\\:hover\\:-translate-x-1\\/4:hover {\n    --transform-translate-x: -25%;\n  }\n  .lg\\:hover\\:-translate-x-2\\/4:hover {\n    --transform-translate-x: -50%;\n  }\n  .lg\\:hover\\:-translate-x-3\\/4:hover {\n    --transform-translate-x: -75%;\n  }\n  .lg\\:hover\\:-translate-x-1\\/5:hover {\n    --transform-translate-x: -20%;\n  }\n  .lg\\:hover\\:-translate-x-2\\/5:hover {\n    --transform-translate-x: -40%;\n  }\n  .lg\\:hover\\:-translate-x-3\\/5:hover {\n    --transform-translate-x: -60%;\n  }\n  .lg\\:hover\\:-translate-x-4\\/5:hover {\n    --transform-translate-x: -80%;\n  }\n  .lg\\:hover\\:-translate-x-1\\/6:hover {\n    --transform-translate-x: -16.66667%;\n  }\n  .lg\\:hover\\:-translate-x-2\\/6:hover {\n    --transform-translate-x: -33.33333%;\n  }\n  .lg\\:hover\\:-translate-x-3\\/6:hover {\n    --transform-translate-x: -50%;\n  }\n  .lg\\:hover\\:-translate-x-4\\/6:hover {\n    --transform-translate-x: -66.66667%;\n  }\n  .lg\\:hover\\:-translate-x-5\\/6:hover {\n    --transform-translate-x: -83.33333%;\n  }\n  .lg\\:hover\\:-translate-x-1\\/12:hover {\n    --transform-translate-x: -8.33333%;\n  }\n  .lg\\:hover\\:-translate-x-2\\/12:hover {\n    --transform-translate-x: -16.66667%;\n  }\n  .lg\\:hover\\:-translate-x-3\\/12:hover {\n    --transform-translate-x: -25%;\n  }\n  .lg\\:hover\\:-translate-x-4\\/12:hover {\n    --transform-translate-x: -33.33333%;\n  }\n  .lg\\:hover\\:-translate-x-5\\/12:hover {\n    --transform-translate-x: -41.66667%;\n  }\n  .lg\\:hover\\:-translate-x-6\\/12:hover {\n    --transform-translate-x: -50%;\n  }\n  .lg\\:hover\\:-translate-x-7\\/12:hover {\n    --transform-translate-x: -58.33333%;\n  }\n  .lg\\:hover\\:-translate-x-8\\/12:hover {\n    --transform-translate-x: -66.66667%;\n  }\n  .lg\\:hover\\:-translate-x-9\\/12:hover {\n    --transform-translate-x: -75%;\n  }\n  .lg\\:hover\\:-translate-x-10\\/12:hover {\n    --transform-translate-x: -83.33333%;\n  }\n  .lg\\:hover\\:-translate-x-11\\/12:hover {\n    --transform-translate-x: -91.66667%;\n  }\n  .lg\\:hover\\:-translate-x-full:hover {\n    --transform-translate-x: -100%;\n  }\n  .lg\\:hover\\:translate-y-0:hover {\n    --transform-translate-y: 0;\n  }\n  .lg\\:hover\\:translate-y-1:hover {\n    --transform-translate-y: 0.25rem;\n  }\n  .lg\\:hover\\:translate-y-2:hover {\n    --transform-translate-y: 0.5rem;\n  }\n  .lg\\:hover\\:translate-y-3:hover {\n    --transform-translate-y: 0.75rem;\n  }\n  .lg\\:hover\\:translate-y-4:hover {\n    --transform-translate-y: 1rem;\n  }\n  .lg\\:hover\\:translate-y-5:hover {\n    --transform-translate-y: 1.25rem;\n  }\n  .lg\\:hover\\:translate-y-6:hover {\n    --transform-translate-y: 1.5rem;\n  }\n  .lg\\:hover\\:translate-y-7:hover {\n    --transform-translate-y: 1.75rem;\n  }\n  .lg\\:hover\\:translate-y-8:hover {\n    --transform-translate-y: 2rem;\n  }\n  .lg\\:hover\\:translate-y-9:hover {\n    --transform-translate-y: 2.25rem;\n  }\n  .lg\\:hover\\:translate-y-10:hover {\n    --transform-translate-y: 2.5rem;\n  }\n  .lg\\:hover\\:translate-y-11:hover {\n    --transform-translate-y: 2.75rem;\n  }\n  .lg\\:hover\\:translate-y-12:hover {\n    --transform-translate-y: 3rem;\n  }\n  .lg\\:hover\\:translate-y-13:hover {\n    --transform-translate-y: 3.25rem;\n  }\n  .lg\\:hover\\:translate-y-14:hover {\n    --transform-translate-y: 3.5rem;\n  }\n  .lg\\:hover\\:translate-y-15:hover {\n    --transform-translate-y: 3.75rem;\n  }\n  .lg\\:hover\\:translate-y-16:hover {\n    --transform-translate-y: 4rem;\n  }\n  .lg\\:hover\\:translate-y-20:hover {\n    --transform-translate-y: 5rem;\n  }\n  .lg\\:hover\\:translate-y-24:hover {\n    --transform-translate-y: 6rem;\n  }\n  .lg\\:hover\\:translate-y-28:hover {\n    --transform-translate-y: 7rem;\n  }\n  .lg\\:hover\\:translate-y-32:hover {\n    --transform-translate-y: 8rem;\n  }\n  .lg\\:hover\\:translate-y-36:hover {\n    --transform-translate-y: 9rem;\n  }\n  .lg\\:hover\\:translate-y-40:hover {\n    --transform-translate-y: 10rem;\n  }\n  .lg\\:hover\\:translate-y-44:hover {\n    --transform-translate-y: 11rem;\n  }\n  .lg\\:hover\\:translate-y-48:hover {\n    --transform-translate-y: 12rem;\n  }\n  .lg\\:hover\\:translate-y-52:hover {\n    --transform-translate-y: 13rem;\n  }\n  .lg\\:hover\\:translate-y-56:hover {\n    --transform-translate-y: 14rem;\n  }\n  .lg\\:hover\\:translate-y-60:hover {\n    --transform-translate-y: 15rem;\n  }\n  .lg\\:hover\\:translate-y-64:hover {\n    --transform-translate-y: 16rem;\n  }\n  .lg\\:hover\\:translate-y-72:hover {\n    --transform-translate-y: 18rem;\n  }\n  .lg\\:hover\\:translate-y-80:hover {\n    --transform-translate-y: 20rem;\n  }\n  .lg\\:hover\\:translate-y-96:hover {\n    --transform-translate-y: 24rem;\n  }\n  .lg\\:hover\\:translate-y-px:hover {\n    --transform-translate-y: 1px;\n  }\n  .lg\\:hover\\:translate-y-0\\.5:hover {\n    --transform-translate-y: 0.125rem;\n  }\n  .lg\\:hover\\:translate-y-1\\.5:hover {\n    --transform-translate-y: 0.375rem;\n  }\n  .lg\\:hover\\:translate-y-2\\.5:hover {\n    --transform-translate-y: 0.625rem;\n  }\n  .lg\\:hover\\:translate-y-3\\.5:hover {\n    --transform-translate-y: 0.875rem;\n  }\n  .lg\\:hover\\:translate-y-1\\/2:hover {\n    --transform-translate-y: 50%;\n  }\n  .lg\\:hover\\:translate-y-1\\/3:hover {\n    --transform-translate-y: 33.333333%;\n  }\n  .lg\\:hover\\:translate-y-2\\/3:hover {\n    --transform-translate-y: 66.666667%;\n  }\n  .lg\\:hover\\:translate-y-1\\/4:hover {\n    --transform-translate-y: 25%;\n  }\n  .lg\\:hover\\:translate-y-2\\/4:hover {\n    --transform-translate-y: 50%;\n  }\n  .lg\\:hover\\:translate-y-3\\/4:hover {\n    --transform-translate-y: 75%;\n  }\n  .lg\\:hover\\:translate-y-1\\/5:hover {\n    --transform-translate-y: 20%;\n  }\n  .lg\\:hover\\:translate-y-2\\/5:hover {\n    --transform-translate-y: 40%;\n  }\n  .lg\\:hover\\:translate-y-3\\/5:hover {\n    --transform-translate-y: 60%;\n  }\n  .lg\\:hover\\:translate-y-4\\/5:hover {\n    --transform-translate-y: 80%;\n  }\n  .lg\\:hover\\:translate-y-1\\/6:hover {\n    --transform-translate-y: 16.666667%;\n  }\n  .lg\\:hover\\:translate-y-2\\/6:hover {\n    --transform-translate-y: 33.333333%;\n  }\n  .lg\\:hover\\:translate-y-3\\/6:hover {\n    --transform-translate-y: 50%;\n  }\n  .lg\\:hover\\:translate-y-4\\/6:hover {\n    --transform-translate-y: 66.666667%;\n  }\n  .lg\\:hover\\:translate-y-5\\/6:hover {\n    --transform-translate-y: 83.333333%;\n  }\n  .lg\\:hover\\:translate-y-1\\/12:hover {\n    --transform-translate-y: 8.333333%;\n  }\n  .lg\\:hover\\:translate-y-2\\/12:hover {\n    --transform-translate-y: 16.666667%;\n  }\n  .lg\\:hover\\:translate-y-3\\/12:hover {\n    --transform-translate-y: 25%;\n  }\n  .lg\\:hover\\:translate-y-4\\/12:hover {\n    --transform-translate-y: 33.333333%;\n  }\n  .lg\\:hover\\:translate-y-5\\/12:hover {\n    --transform-translate-y: 41.666667%;\n  }\n  .lg\\:hover\\:translate-y-6\\/12:hover {\n    --transform-translate-y: 50%;\n  }\n  .lg\\:hover\\:translate-y-7\\/12:hover {\n    --transform-translate-y: 58.333333%;\n  }\n  .lg\\:hover\\:translate-y-8\\/12:hover {\n    --transform-translate-y: 66.666667%;\n  }\n  .lg\\:hover\\:translate-y-9\\/12:hover {\n    --transform-translate-y: 75%;\n  }\n  .lg\\:hover\\:translate-y-10\\/12:hover {\n    --transform-translate-y: 83.333333%;\n  }\n  .lg\\:hover\\:translate-y-11\\/12:hover {\n    --transform-translate-y: 91.666667%;\n  }\n  .lg\\:hover\\:translate-y-full:hover {\n    --transform-translate-y: 100%;\n  }\n  .lg\\:hover\\:-translate-y-1:hover {\n    --transform-translate-y: -0.25rem;\n  }\n  .lg\\:hover\\:-translate-y-2:hover {\n    --transform-translate-y: -0.5rem;\n  }\n  .lg\\:hover\\:-translate-y-3:hover {\n    --transform-translate-y: -0.75rem;\n  }\n  .lg\\:hover\\:-translate-y-4:hover {\n    --transform-translate-y: -1rem;\n  }\n  .lg\\:hover\\:-translate-y-5:hover {\n    --transform-translate-y: -1.25rem;\n  }\n  .lg\\:hover\\:-translate-y-6:hover {\n    --transform-translate-y: -1.5rem;\n  }\n  .lg\\:hover\\:-translate-y-7:hover {\n    --transform-translate-y: -1.75rem;\n  }\n  .lg\\:hover\\:-translate-y-8:hover {\n    --transform-translate-y: -2rem;\n  }\n  .lg\\:hover\\:-translate-y-9:hover {\n    --transform-translate-y: -2.25rem;\n  }\n  .lg\\:hover\\:-translate-y-10:hover {\n    --transform-translate-y: -2.5rem;\n  }\n  .lg\\:hover\\:-translate-y-11:hover {\n    --transform-translate-y: -2.75rem;\n  }\n  .lg\\:hover\\:-translate-y-12:hover {\n    --transform-translate-y: -3rem;\n  }\n  .lg\\:hover\\:-translate-y-13:hover {\n    --transform-translate-y: -3.25rem;\n  }\n  .lg\\:hover\\:-translate-y-14:hover {\n    --transform-translate-y: -3.5rem;\n  }\n  .lg\\:hover\\:-translate-y-15:hover {\n    --transform-translate-y: -3.75rem;\n  }\n  .lg\\:hover\\:-translate-y-16:hover {\n    --transform-translate-y: -4rem;\n  }\n  .lg\\:hover\\:-translate-y-20:hover {\n    --transform-translate-y: -5rem;\n  }\n  .lg\\:hover\\:-translate-y-24:hover {\n    --transform-translate-y: -6rem;\n  }\n  .lg\\:hover\\:-translate-y-28:hover {\n    --transform-translate-y: -7rem;\n  }\n  .lg\\:hover\\:-translate-y-32:hover {\n    --transform-translate-y: -8rem;\n  }\n  .lg\\:hover\\:-translate-y-36:hover {\n    --transform-translate-y: -9rem;\n  }\n  .lg\\:hover\\:-translate-y-40:hover {\n    --transform-translate-y: -10rem;\n  }\n  .lg\\:hover\\:-translate-y-44:hover {\n    --transform-translate-y: -11rem;\n  }\n  .lg\\:hover\\:-translate-y-48:hover {\n    --transform-translate-y: -12rem;\n  }\n  .lg\\:hover\\:-translate-y-52:hover {\n    --transform-translate-y: -13rem;\n  }\n  .lg\\:hover\\:-translate-y-56:hover {\n    --transform-translate-y: -14rem;\n  }\n  .lg\\:hover\\:-translate-y-60:hover {\n    --transform-translate-y: -15rem;\n  }\n  .lg\\:hover\\:-translate-y-64:hover {\n    --transform-translate-y: -16rem;\n  }\n  .lg\\:hover\\:-translate-y-72:hover {\n    --transform-translate-y: -18rem;\n  }\n  .lg\\:hover\\:-translate-y-80:hover {\n    --transform-translate-y: -20rem;\n  }\n  .lg\\:hover\\:-translate-y-96:hover {\n    --transform-translate-y: -24rem;\n  }\n  .lg\\:hover\\:-translate-y-px:hover {\n    --transform-translate-y: -1px;\n  }\n  .lg\\:hover\\:-translate-y-0\\.5:hover {\n    --transform-translate-y: -0.125rem;\n  }\n  .lg\\:hover\\:-translate-y-1\\.5:hover {\n    --transform-translate-y: -0.375rem;\n  }\n  .lg\\:hover\\:-translate-y-2\\.5:hover {\n    --transform-translate-y: -0.625rem;\n  }\n  .lg\\:hover\\:-translate-y-3\\.5:hover {\n    --transform-translate-y: -0.875rem;\n  }\n  .lg\\:hover\\:-translate-y-1\\/2:hover {\n    --transform-translate-y: -50%;\n  }\n  .lg\\:hover\\:-translate-y-1\\/3:hover {\n    --transform-translate-y: -33.33333%;\n  }\n  .lg\\:hover\\:-translate-y-2\\/3:hover {\n    --transform-translate-y: -66.66667%;\n  }\n  .lg\\:hover\\:-translate-y-1\\/4:hover {\n    --transform-translate-y: -25%;\n  }\n  .lg\\:hover\\:-translate-y-2\\/4:hover {\n    --transform-translate-y: -50%;\n  }\n  .lg\\:hover\\:-translate-y-3\\/4:hover {\n    --transform-translate-y: -75%;\n  }\n  .lg\\:hover\\:-translate-y-1\\/5:hover {\n    --transform-translate-y: -20%;\n  }\n  .lg\\:hover\\:-translate-y-2\\/5:hover {\n    --transform-translate-y: -40%;\n  }\n  .lg\\:hover\\:-translate-y-3\\/5:hover {\n    --transform-translate-y: -60%;\n  }\n  .lg\\:hover\\:-translate-y-4\\/5:hover {\n    --transform-translate-y: -80%;\n  }\n  .lg\\:hover\\:-translate-y-1\\/6:hover {\n    --transform-translate-y: -16.66667%;\n  }\n  .lg\\:hover\\:-translate-y-2\\/6:hover {\n    --transform-translate-y: -33.33333%;\n  }\n  .lg\\:hover\\:-translate-y-3\\/6:hover {\n    --transform-translate-y: -50%;\n  }\n  .lg\\:hover\\:-translate-y-4\\/6:hover {\n    --transform-translate-y: -66.66667%;\n  }\n  .lg\\:hover\\:-translate-y-5\\/6:hover {\n    --transform-translate-y: -83.33333%;\n  }\n  .lg\\:hover\\:-translate-y-1\\/12:hover {\n    --transform-translate-y: -8.33333%;\n  }\n  .lg\\:hover\\:-translate-y-2\\/12:hover {\n    --transform-translate-y: -16.66667%;\n  }\n  .lg\\:hover\\:-translate-y-3\\/12:hover {\n    --transform-translate-y: -25%;\n  }\n  .lg\\:hover\\:-translate-y-4\\/12:hover {\n    --transform-translate-y: -33.33333%;\n  }\n  .lg\\:hover\\:-translate-y-5\\/12:hover {\n    --transform-translate-y: -41.66667%;\n  }\n  .lg\\:hover\\:-translate-y-6\\/12:hover {\n    --transform-translate-y: -50%;\n  }\n  .lg\\:hover\\:-translate-y-7\\/12:hover {\n    --transform-translate-y: -58.33333%;\n  }\n  .lg\\:hover\\:-translate-y-8\\/12:hover {\n    --transform-translate-y: -66.66667%;\n  }\n  .lg\\:hover\\:-translate-y-9\\/12:hover {\n    --transform-translate-y: -75%;\n  }\n  .lg\\:hover\\:-translate-y-10\\/12:hover {\n    --transform-translate-y: -83.33333%;\n  }\n  .lg\\:hover\\:-translate-y-11\\/12:hover {\n    --transform-translate-y: -91.66667%;\n  }\n  .lg\\:hover\\:-translate-y-full:hover {\n    --transform-translate-y: -100%;\n  }\n  .lg\\:focus\\:translate-x-0:focus {\n    --transform-translate-x: 0;\n  }\n  .lg\\:focus\\:translate-x-1:focus {\n    --transform-translate-x: 0.25rem;\n  }\n  .lg\\:focus\\:translate-x-2:focus {\n    --transform-translate-x: 0.5rem;\n  }\n  .lg\\:focus\\:translate-x-3:focus {\n    --transform-translate-x: 0.75rem;\n  }\n  .lg\\:focus\\:translate-x-4:focus {\n    --transform-translate-x: 1rem;\n  }\n  .lg\\:focus\\:translate-x-5:focus {\n    --transform-translate-x: 1.25rem;\n  }\n  .lg\\:focus\\:translate-x-6:focus {\n    --transform-translate-x: 1.5rem;\n  }\n  .lg\\:focus\\:translate-x-7:focus {\n    --transform-translate-x: 1.75rem;\n  }\n  .lg\\:focus\\:translate-x-8:focus {\n    --transform-translate-x: 2rem;\n  }\n  .lg\\:focus\\:translate-x-9:focus {\n    --transform-translate-x: 2.25rem;\n  }\n  .lg\\:focus\\:translate-x-10:focus {\n    --transform-translate-x: 2.5rem;\n  }\n  .lg\\:focus\\:translate-x-11:focus {\n    --transform-translate-x: 2.75rem;\n  }\n  .lg\\:focus\\:translate-x-12:focus {\n    --transform-translate-x: 3rem;\n  }\n  .lg\\:focus\\:translate-x-13:focus {\n    --transform-translate-x: 3.25rem;\n  }\n  .lg\\:focus\\:translate-x-14:focus {\n    --transform-translate-x: 3.5rem;\n  }\n  .lg\\:focus\\:translate-x-15:focus {\n    --transform-translate-x: 3.75rem;\n  }\n  .lg\\:focus\\:translate-x-16:focus {\n    --transform-translate-x: 4rem;\n  }\n  .lg\\:focus\\:translate-x-20:focus {\n    --transform-translate-x: 5rem;\n  }\n  .lg\\:focus\\:translate-x-24:focus {\n    --transform-translate-x: 6rem;\n  }\n  .lg\\:focus\\:translate-x-28:focus {\n    --transform-translate-x: 7rem;\n  }\n  .lg\\:focus\\:translate-x-32:focus {\n    --transform-translate-x: 8rem;\n  }\n  .lg\\:focus\\:translate-x-36:focus {\n    --transform-translate-x: 9rem;\n  }\n  .lg\\:focus\\:translate-x-40:focus {\n    --transform-translate-x: 10rem;\n  }\n  .lg\\:focus\\:translate-x-44:focus {\n    --transform-translate-x: 11rem;\n  }\n  .lg\\:focus\\:translate-x-48:focus {\n    --transform-translate-x: 12rem;\n  }\n  .lg\\:focus\\:translate-x-52:focus {\n    --transform-translate-x: 13rem;\n  }\n  .lg\\:focus\\:translate-x-56:focus {\n    --transform-translate-x: 14rem;\n  }\n  .lg\\:focus\\:translate-x-60:focus {\n    --transform-translate-x: 15rem;\n  }\n  .lg\\:focus\\:translate-x-64:focus {\n    --transform-translate-x: 16rem;\n  }\n  .lg\\:focus\\:translate-x-72:focus {\n    --transform-translate-x: 18rem;\n  }\n  .lg\\:focus\\:translate-x-80:focus {\n    --transform-translate-x: 20rem;\n  }\n  .lg\\:focus\\:translate-x-96:focus {\n    --transform-translate-x: 24rem;\n  }\n  .lg\\:focus\\:translate-x-px:focus {\n    --transform-translate-x: 1px;\n  }\n  .lg\\:focus\\:translate-x-0\\.5:focus {\n    --transform-translate-x: 0.125rem;\n  }\n  .lg\\:focus\\:translate-x-1\\.5:focus {\n    --transform-translate-x: 0.375rem;\n  }\n  .lg\\:focus\\:translate-x-2\\.5:focus {\n    --transform-translate-x: 0.625rem;\n  }\n  .lg\\:focus\\:translate-x-3\\.5:focus {\n    --transform-translate-x: 0.875rem;\n  }\n  .lg\\:focus\\:translate-x-1\\/2:focus {\n    --transform-translate-x: 50%;\n  }\n  .lg\\:focus\\:translate-x-1\\/3:focus {\n    --transform-translate-x: 33.333333%;\n  }\n  .lg\\:focus\\:translate-x-2\\/3:focus {\n    --transform-translate-x: 66.666667%;\n  }\n  .lg\\:focus\\:translate-x-1\\/4:focus {\n    --transform-translate-x: 25%;\n  }\n  .lg\\:focus\\:translate-x-2\\/4:focus {\n    --transform-translate-x: 50%;\n  }\n  .lg\\:focus\\:translate-x-3\\/4:focus {\n    --transform-translate-x: 75%;\n  }\n  .lg\\:focus\\:translate-x-1\\/5:focus {\n    --transform-translate-x: 20%;\n  }\n  .lg\\:focus\\:translate-x-2\\/5:focus {\n    --transform-translate-x: 40%;\n  }\n  .lg\\:focus\\:translate-x-3\\/5:focus {\n    --transform-translate-x: 60%;\n  }\n  .lg\\:focus\\:translate-x-4\\/5:focus {\n    --transform-translate-x: 80%;\n  }\n  .lg\\:focus\\:translate-x-1\\/6:focus {\n    --transform-translate-x: 16.666667%;\n  }\n  .lg\\:focus\\:translate-x-2\\/6:focus {\n    --transform-translate-x: 33.333333%;\n  }\n  .lg\\:focus\\:translate-x-3\\/6:focus {\n    --transform-translate-x: 50%;\n  }\n  .lg\\:focus\\:translate-x-4\\/6:focus {\n    --transform-translate-x: 66.666667%;\n  }\n  .lg\\:focus\\:translate-x-5\\/6:focus {\n    --transform-translate-x: 83.333333%;\n  }\n  .lg\\:focus\\:translate-x-1\\/12:focus {\n    --transform-translate-x: 8.333333%;\n  }\n  .lg\\:focus\\:translate-x-2\\/12:focus {\n    --transform-translate-x: 16.666667%;\n  }\n  .lg\\:focus\\:translate-x-3\\/12:focus {\n    --transform-translate-x: 25%;\n  }\n  .lg\\:focus\\:translate-x-4\\/12:focus {\n    --transform-translate-x: 33.333333%;\n  }\n  .lg\\:focus\\:translate-x-5\\/12:focus {\n    --transform-translate-x: 41.666667%;\n  }\n  .lg\\:focus\\:translate-x-6\\/12:focus {\n    --transform-translate-x: 50%;\n  }\n  .lg\\:focus\\:translate-x-7\\/12:focus {\n    --transform-translate-x: 58.333333%;\n  }\n  .lg\\:focus\\:translate-x-8\\/12:focus {\n    --transform-translate-x: 66.666667%;\n  }\n  .lg\\:focus\\:translate-x-9\\/12:focus {\n    --transform-translate-x: 75%;\n  }\n  .lg\\:focus\\:translate-x-10\\/12:focus {\n    --transform-translate-x: 83.333333%;\n  }\n  .lg\\:focus\\:translate-x-11\\/12:focus {\n    --transform-translate-x: 91.666667%;\n  }\n  .lg\\:focus\\:translate-x-full:focus {\n    --transform-translate-x: 100%;\n  }\n  .lg\\:focus\\:-translate-x-1:focus {\n    --transform-translate-x: -0.25rem;\n  }\n  .lg\\:focus\\:-translate-x-2:focus {\n    --transform-translate-x: -0.5rem;\n  }\n  .lg\\:focus\\:-translate-x-3:focus {\n    --transform-translate-x: -0.75rem;\n  }\n  .lg\\:focus\\:-translate-x-4:focus {\n    --transform-translate-x: -1rem;\n  }\n  .lg\\:focus\\:-translate-x-5:focus {\n    --transform-translate-x: -1.25rem;\n  }\n  .lg\\:focus\\:-translate-x-6:focus {\n    --transform-translate-x: -1.5rem;\n  }\n  .lg\\:focus\\:-translate-x-7:focus {\n    --transform-translate-x: -1.75rem;\n  }\n  .lg\\:focus\\:-translate-x-8:focus {\n    --transform-translate-x: -2rem;\n  }\n  .lg\\:focus\\:-translate-x-9:focus {\n    --transform-translate-x: -2.25rem;\n  }\n  .lg\\:focus\\:-translate-x-10:focus {\n    --transform-translate-x: -2.5rem;\n  }\n  .lg\\:focus\\:-translate-x-11:focus {\n    --transform-translate-x: -2.75rem;\n  }\n  .lg\\:focus\\:-translate-x-12:focus {\n    --transform-translate-x: -3rem;\n  }\n  .lg\\:focus\\:-translate-x-13:focus {\n    --transform-translate-x: -3.25rem;\n  }\n  .lg\\:focus\\:-translate-x-14:focus {\n    --transform-translate-x: -3.5rem;\n  }\n  .lg\\:focus\\:-translate-x-15:focus {\n    --transform-translate-x: -3.75rem;\n  }\n  .lg\\:focus\\:-translate-x-16:focus {\n    --transform-translate-x: -4rem;\n  }\n  .lg\\:focus\\:-translate-x-20:focus {\n    --transform-translate-x: -5rem;\n  }\n  .lg\\:focus\\:-translate-x-24:focus {\n    --transform-translate-x: -6rem;\n  }\n  .lg\\:focus\\:-translate-x-28:focus {\n    --transform-translate-x: -7rem;\n  }\n  .lg\\:focus\\:-translate-x-32:focus {\n    --transform-translate-x: -8rem;\n  }\n  .lg\\:focus\\:-translate-x-36:focus {\n    --transform-translate-x: -9rem;\n  }\n  .lg\\:focus\\:-translate-x-40:focus {\n    --transform-translate-x: -10rem;\n  }\n  .lg\\:focus\\:-translate-x-44:focus {\n    --transform-translate-x: -11rem;\n  }\n  .lg\\:focus\\:-translate-x-48:focus {\n    --transform-translate-x: -12rem;\n  }\n  .lg\\:focus\\:-translate-x-52:focus {\n    --transform-translate-x: -13rem;\n  }\n  .lg\\:focus\\:-translate-x-56:focus {\n    --transform-translate-x: -14rem;\n  }\n  .lg\\:focus\\:-translate-x-60:focus {\n    --transform-translate-x: -15rem;\n  }\n  .lg\\:focus\\:-translate-x-64:focus {\n    --transform-translate-x: -16rem;\n  }\n  .lg\\:focus\\:-translate-x-72:focus {\n    --transform-translate-x: -18rem;\n  }\n  .lg\\:focus\\:-translate-x-80:focus {\n    --transform-translate-x: -20rem;\n  }\n  .lg\\:focus\\:-translate-x-96:focus {\n    --transform-translate-x: -24rem;\n  }\n  .lg\\:focus\\:-translate-x-px:focus {\n    --transform-translate-x: -1px;\n  }\n  .lg\\:focus\\:-translate-x-0\\.5:focus {\n    --transform-translate-x: -0.125rem;\n  }\n  .lg\\:focus\\:-translate-x-1\\.5:focus {\n    --transform-translate-x: -0.375rem;\n  }\n  .lg\\:focus\\:-translate-x-2\\.5:focus {\n    --transform-translate-x: -0.625rem;\n  }\n  .lg\\:focus\\:-translate-x-3\\.5:focus {\n    --transform-translate-x: -0.875rem;\n  }\n  .lg\\:focus\\:-translate-x-1\\/2:focus {\n    --transform-translate-x: -50%;\n  }\n  .lg\\:focus\\:-translate-x-1\\/3:focus {\n    --transform-translate-x: -33.33333%;\n  }\n  .lg\\:focus\\:-translate-x-2\\/3:focus {\n    --transform-translate-x: -66.66667%;\n  }\n  .lg\\:focus\\:-translate-x-1\\/4:focus {\n    --transform-translate-x: -25%;\n  }\n  .lg\\:focus\\:-translate-x-2\\/4:focus {\n    --transform-translate-x: -50%;\n  }\n  .lg\\:focus\\:-translate-x-3\\/4:focus {\n    --transform-translate-x: -75%;\n  }\n  .lg\\:focus\\:-translate-x-1\\/5:focus {\n    --transform-translate-x: -20%;\n  }\n  .lg\\:focus\\:-translate-x-2\\/5:focus {\n    --transform-translate-x: -40%;\n  }\n  .lg\\:focus\\:-translate-x-3\\/5:focus {\n    --transform-translate-x: -60%;\n  }\n  .lg\\:focus\\:-translate-x-4\\/5:focus {\n    --transform-translate-x: -80%;\n  }\n  .lg\\:focus\\:-translate-x-1\\/6:focus {\n    --transform-translate-x: -16.66667%;\n  }\n  .lg\\:focus\\:-translate-x-2\\/6:focus {\n    --transform-translate-x: -33.33333%;\n  }\n  .lg\\:focus\\:-translate-x-3\\/6:focus {\n    --transform-translate-x: -50%;\n  }\n  .lg\\:focus\\:-translate-x-4\\/6:focus {\n    --transform-translate-x: -66.66667%;\n  }\n  .lg\\:focus\\:-translate-x-5\\/6:focus {\n    --transform-translate-x: -83.33333%;\n  }\n  .lg\\:focus\\:-translate-x-1\\/12:focus {\n    --transform-translate-x: -8.33333%;\n  }\n  .lg\\:focus\\:-translate-x-2\\/12:focus {\n    --transform-translate-x: -16.66667%;\n  }\n  .lg\\:focus\\:-translate-x-3\\/12:focus {\n    --transform-translate-x: -25%;\n  }\n  .lg\\:focus\\:-translate-x-4\\/12:focus {\n    --transform-translate-x: -33.33333%;\n  }\n  .lg\\:focus\\:-translate-x-5\\/12:focus {\n    --transform-translate-x: -41.66667%;\n  }\n  .lg\\:focus\\:-translate-x-6\\/12:focus {\n    --transform-translate-x: -50%;\n  }\n  .lg\\:focus\\:-translate-x-7\\/12:focus {\n    --transform-translate-x: -58.33333%;\n  }\n  .lg\\:focus\\:-translate-x-8\\/12:focus {\n    --transform-translate-x: -66.66667%;\n  }\n  .lg\\:focus\\:-translate-x-9\\/12:focus {\n    --transform-translate-x: -75%;\n  }\n  .lg\\:focus\\:-translate-x-10\\/12:focus {\n    --transform-translate-x: -83.33333%;\n  }\n  .lg\\:focus\\:-translate-x-11\\/12:focus {\n    --transform-translate-x: -91.66667%;\n  }\n  .lg\\:focus\\:-translate-x-full:focus {\n    --transform-translate-x: -100%;\n  }\n  .lg\\:focus\\:translate-y-0:focus {\n    --transform-translate-y: 0;\n  }\n  .lg\\:focus\\:translate-y-1:focus {\n    --transform-translate-y: 0.25rem;\n  }\n  .lg\\:focus\\:translate-y-2:focus {\n    --transform-translate-y: 0.5rem;\n  }\n  .lg\\:focus\\:translate-y-3:focus {\n    --transform-translate-y: 0.75rem;\n  }\n  .lg\\:focus\\:translate-y-4:focus {\n    --transform-translate-y: 1rem;\n  }\n  .lg\\:focus\\:translate-y-5:focus {\n    --transform-translate-y: 1.25rem;\n  }\n  .lg\\:focus\\:translate-y-6:focus {\n    --transform-translate-y: 1.5rem;\n  }\n  .lg\\:focus\\:translate-y-7:focus {\n    --transform-translate-y: 1.75rem;\n  }\n  .lg\\:focus\\:translate-y-8:focus {\n    --transform-translate-y: 2rem;\n  }\n  .lg\\:focus\\:translate-y-9:focus {\n    --transform-translate-y: 2.25rem;\n  }\n  .lg\\:focus\\:translate-y-10:focus {\n    --transform-translate-y: 2.5rem;\n  }\n  .lg\\:focus\\:translate-y-11:focus {\n    --transform-translate-y: 2.75rem;\n  }\n  .lg\\:focus\\:translate-y-12:focus {\n    --transform-translate-y: 3rem;\n  }\n  .lg\\:focus\\:translate-y-13:focus {\n    --transform-translate-y: 3.25rem;\n  }\n  .lg\\:focus\\:translate-y-14:focus {\n    --transform-translate-y: 3.5rem;\n  }\n  .lg\\:focus\\:translate-y-15:focus {\n    --transform-translate-y: 3.75rem;\n  }\n  .lg\\:focus\\:translate-y-16:focus {\n    --transform-translate-y: 4rem;\n  }\n  .lg\\:focus\\:translate-y-20:focus {\n    --transform-translate-y: 5rem;\n  }\n  .lg\\:focus\\:translate-y-24:focus {\n    --transform-translate-y: 6rem;\n  }\n  .lg\\:focus\\:translate-y-28:focus {\n    --transform-translate-y: 7rem;\n  }\n  .lg\\:focus\\:translate-y-32:focus {\n    --transform-translate-y: 8rem;\n  }\n  .lg\\:focus\\:translate-y-36:focus {\n    --transform-translate-y: 9rem;\n  }\n  .lg\\:focus\\:translate-y-40:focus {\n    --transform-translate-y: 10rem;\n  }\n  .lg\\:focus\\:translate-y-44:focus {\n    --transform-translate-y: 11rem;\n  }\n  .lg\\:focus\\:translate-y-48:focus {\n    --transform-translate-y: 12rem;\n  }\n  .lg\\:focus\\:translate-y-52:focus {\n    --transform-translate-y: 13rem;\n  }\n  .lg\\:focus\\:translate-y-56:focus {\n    --transform-translate-y: 14rem;\n  }\n  .lg\\:focus\\:translate-y-60:focus {\n    --transform-translate-y: 15rem;\n  }\n  .lg\\:focus\\:translate-y-64:focus {\n    --transform-translate-y: 16rem;\n  }\n  .lg\\:focus\\:translate-y-72:focus {\n    --transform-translate-y: 18rem;\n  }\n  .lg\\:focus\\:translate-y-80:focus {\n    --transform-translate-y: 20rem;\n  }\n  .lg\\:focus\\:translate-y-96:focus {\n    --transform-translate-y: 24rem;\n  }\n  .lg\\:focus\\:translate-y-px:focus {\n    --transform-translate-y: 1px;\n  }\n  .lg\\:focus\\:translate-y-0\\.5:focus {\n    --transform-translate-y: 0.125rem;\n  }\n  .lg\\:focus\\:translate-y-1\\.5:focus {\n    --transform-translate-y: 0.375rem;\n  }\n  .lg\\:focus\\:translate-y-2\\.5:focus {\n    --transform-translate-y: 0.625rem;\n  }\n  .lg\\:focus\\:translate-y-3\\.5:focus {\n    --transform-translate-y: 0.875rem;\n  }\n  .lg\\:focus\\:translate-y-1\\/2:focus {\n    --transform-translate-y: 50%;\n  }\n  .lg\\:focus\\:translate-y-1\\/3:focus {\n    --transform-translate-y: 33.333333%;\n  }\n  .lg\\:focus\\:translate-y-2\\/3:focus {\n    --transform-translate-y: 66.666667%;\n  }\n  .lg\\:focus\\:translate-y-1\\/4:focus {\n    --transform-translate-y: 25%;\n  }\n  .lg\\:focus\\:translate-y-2\\/4:focus {\n    --transform-translate-y: 50%;\n  }\n  .lg\\:focus\\:translate-y-3\\/4:focus {\n    --transform-translate-y: 75%;\n  }\n  .lg\\:focus\\:translate-y-1\\/5:focus {\n    --transform-translate-y: 20%;\n  }\n  .lg\\:focus\\:translate-y-2\\/5:focus {\n    --transform-translate-y: 40%;\n  }\n  .lg\\:focus\\:translate-y-3\\/5:focus {\n    --transform-translate-y: 60%;\n  }\n  .lg\\:focus\\:translate-y-4\\/5:focus {\n    --transform-translate-y: 80%;\n  }\n  .lg\\:focus\\:translate-y-1\\/6:focus {\n    --transform-translate-y: 16.666667%;\n  }\n  .lg\\:focus\\:translate-y-2\\/6:focus {\n    --transform-translate-y: 33.333333%;\n  }\n  .lg\\:focus\\:translate-y-3\\/6:focus {\n    --transform-translate-y: 50%;\n  }\n  .lg\\:focus\\:translate-y-4\\/6:focus {\n    --transform-translate-y: 66.666667%;\n  }\n  .lg\\:focus\\:translate-y-5\\/6:focus {\n    --transform-translate-y: 83.333333%;\n  }\n  .lg\\:focus\\:translate-y-1\\/12:focus {\n    --transform-translate-y: 8.333333%;\n  }\n  .lg\\:focus\\:translate-y-2\\/12:focus {\n    --transform-translate-y: 16.666667%;\n  }\n  .lg\\:focus\\:translate-y-3\\/12:focus {\n    --transform-translate-y: 25%;\n  }\n  .lg\\:focus\\:translate-y-4\\/12:focus {\n    --transform-translate-y: 33.333333%;\n  }\n  .lg\\:focus\\:translate-y-5\\/12:focus {\n    --transform-translate-y: 41.666667%;\n  }\n  .lg\\:focus\\:translate-y-6\\/12:focus {\n    --transform-translate-y: 50%;\n  }\n  .lg\\:focus\\:translate-y-7\\/12:focus {\n    --transform-translate-y: 58.333333%;\n  }\n  .lg\\:focus\\:translate-y-8\\/12:focus {\n    --transform-translate-y: 66.666667%;\n  }\n  .lg\\:focus\\:translate-y-9\\/12:focus {\n    --transform-translate-y: 75%;\n  }\n  .lg\\:focus\\:translate-y-10\\/12:focus {\n    --transform-translate-y: 83.333333%;\n  }\n  .lg\\:focus\\:translate-y-11\\/12:focus {\n    --transform-translate-y: 91.666667%;\n  }\n  .lg\\:focus\\:translate-y-full:focus {\n    --transform-translate-y: 100%;\n  }\n  .lg\\:focus\\:-translate-y-1:focus {\n    --transform-translate-y: -0.25rem;\n  }\n  .lg\\:focus\\:-translate-y-2:focus {\n    --transform-translate-y: -0.5rem;\n  }\n  .lg\\:focus\\:-translate-y-3:focus {\n    --transform-translate-y: -0.75rem;\n  }\n  .lg\\:focus\\:-translate-y-4:focus {\n    --transform-translate-y: -1rem;\n  }\n  .lg\\:focus\\:-translate-y-5:focus {\n    --transform-translate-y: -1.25rem;\n  }\n  .lg\\:focus\\:-translate-y-6:focus {\n    --transform-translate-y: -1.5rem;\n  }\n  .lg\\:focus\\:-translate-y-7:focus {\n    --transform-translate-y: -1.75rem;\n  }\n  .lg\\:focus\\:-translate-y-8:focus {\n    --transform-translate-y: -2rem;\n  }\n  .lg\\:focus\\:-translate-y-9:focus {\n    --transform-translate-y: -2.25rem;\n  }\n  .lg\\:focus\\:-translate-y-10:focus {\n    --transform-translate-y: -2.5rem;\n  }\n  .lg\\:focus\\:-translate-y-11:focus {\n    --transform-translate-y: -2.75rem;\n  }\n  .lg\\:focus\\:-translate-y-12:focus {\n    --transform-translate-y: -3rem;\n  }\n  .lg\\:focus\\:-translate-y-13:focus {\n    --transform-translate-y: -3.25rem;\n  }\n  .lg\\:focus\\:-translate-y-14:focus {\n    --transform-translate-y: -3.5rem;\n  }\n  .lg\\:focus\\:-translate-y-15:focus {\n    --transform-translate-y: -3.75rem;\n  }\n  .lg\\:focus\\:-translate-y-16:focus {\n    --transform-translate-y: -4rem;\n  }\n  .lg\\:focus\\:-translate-y-20:focus {\n    --transform-translate-y: -5rem;\n  }\n  .lg\\:focus\\:-translate-y-24:focus {\n    --transform-translate-y: -6rem;\n  }\n  .lg\\:focus\\:-translate-y-28:focus {\n    --transform-translate-y: -7rem;\n  }\n  .lg\\:focus\\:-translate-y-32:focus {\n    --transform-translate-y: -8rem;\n  }\n  .lg\\:focus\\:-translate-y-36:focus {\n    --transform-translate-y: -9rem;\n  }\n  .lg\\:focus\\:-translate-y-40:focus {\n    --transform-translate-y: -10rem;\n  }\n  .lg\\:focus\\:-translate-y-44:focus {\n    --transform-translate-y: -11rem;\n  }\n  .lg\\:focus\\:-translate-y-48:focus {\n    --transform-translate-y: -12rem;\n  }\n  .lg\\:focus\\:-translate-y-52:focus {\n    --transform-translate-y: -13rem;\n  }\n  .lg\\:focus\\:-translate-y-56:focus {\n    --transform-translate-y: -14rem;\n  }\n  .lg\\:focus\\:-translate-y-60:focus {\n    --transform-translate-y: -15rem;\n  }\n  .lg\\:focus\\:-translate-y-64:focus {\n    --transform-translate-y: -16rem;\n  }\n  .lg\\:focus\\:-translate-y-72:focus {\n    --transform-translate-y: -18rem;\n  }\n  .lg\\:focus\\:-translate-y-80:focus {\n    --transform-translate-y: -20rem;\n  }\n  .lg\\:focus\\:-translate-y-96:focus {\n    --transform-translate-y: -24rem;\n  }\n  .lg\\:focus\\:-translate-y-px:focus {\n    --transform-translate-y: -1px;\n  }\n  .lg\\:focus\\:-translate-y-0\\.5:focus {\n    --transform-translate-y: -0.125rem;\n  }\n  .lg\\:focus\\:-translate-y-1\\.5:focus {\n    --transform-translate-y: -0.375rem;\n  }\n  .lg\\:focus\\:-translate-y-2\\.5:focus {\n    --transform-translate-y: -0.625rem;\n  }\n  .lg\\:focus\\:-translate-y-3\\.5:focus {\n    --transform-translate-y: -0.875rem;\n  }\n  .lg\\:focus\\:-translate-y-1\\/2:focus {\n    --transform-translate-y: -50%;\n  }\n  .lg\\:focus\\:-translate-y-1\\/3:focus {\n    --transform-translate-y: -33.33333%;\n  }\n  .lg\\:focus\\:-translate-y-2\\/3:focus {\n    --transform-translate-y: -66.66667%;\n  }\n  .lg\\:focus\\:-translate-y-1\\/4:focus {\n    --transform-translate-y: -25%;\n  }\n  .lg\\:focus\\:-translate-y-2\\/4:focus {\n    --transform-translate-y: -50%;\n  }\n  .lg\\:focus\\:-translate-y-3\\/4:focus {\n    --transform-translate-y: -75%;\n  }\n  .lg\\:focus\\:-translate-y-1\\/5:focus {\n    --transform-translate-y: -20%;\n  }\n  .lg\\:focus\\:-translate-y-2\\/5:focus {\n    --transform-translate-y: -40%;\n  }\n  .lg\\:focus\\:-translate-y-3\\/5:focus {\n    --transform-translate-y: -60%;\n  }\n  .lg\\:focus\\:-translate-y-4\\/5:focus {\n    --transform-translate-y: -80%;\n  }\n  .lg\\:focus\\:-translate-y-1\\/6:focus {\n    --transform-translate-y: -16.66667%;\n  }\n  .lg\\:focus\\:-translate-y-2\\/6:focus {\n    --transform-translate-y: -33.33333%;\n  }\n  .lg\\:focus\\:-translate-y-3\\/6:focus {\n    --transform-translate-y: -50%;\n  }\n  .lg\\:focus\\:-translate-y-4\\/6:focus {\n    --transform-translate-y: -66.66667%;\n  }\n  .lg\\:focus\\:-translate-y-5\\/6:focus {\n    --transform-translate-y: -83.33333%;\n  }\n  .lg\\:focus\\:-translate-y-1\\/12:focus {\n    --transform-translate-y: -8.33333%;\n  }\n  .lg\\:focus\\:-translate-y-2\\/12:focus {\n    --transform-translate-y: -16.66667%;\n  }\n  .lg\\:focus\\:-translate-y-3\\/12:focus {\n    --transform-translate-y: -25%;\n  }\n  .lg\\:focus\\:-translate-y-4\\/12:focus {\n    --transform-translate-y: -33.33333%;\n  }\n  .lg\\:focus\\:-translate-y-5\\/12:focus {\n    --transform-translate-y: -41.66667%;\n  }\n  .lg\\:focus\\:-translate-y-6\\/12:focus {\n    --transform-translate-y: -50%;\n  }\n  .lg\\:focus\\:-translate-y-7\\/12:focus {\n    --transform-translate-y: -58.33333%;\n  }\n  .lg\\:focus\\:-translate-y-8\\/12:focus {\n    --transform-translate-y: -66.66667%;\n  }\n  .lg\\:focus\\:-translate-y-9\\/12:focus {\n    --transform-translate-y: -75%;\n  }\n  .lg\\:focus\\:-translate-y-10\\/12:focus {\n    --transform-translate-y: -83.33333%;\n  }\n  .lg\\:focus\\:-translate-y-11\\/12:focus {\n    --transform-translate-y: -91.66667%;\n  }\n  .lg\\:focus\\:-translate-y-full:focus {\n    --transform-translate-y: -100%;\n  }\n  .lg\\:skew-x-0 {\n    --transform-skew-x: 0;\n  }\n  .lg\\:skew-x-1 {\n    --transform-skew-x: 1deg;\n  }\n  .lg\\:skew-x-2 {\n    --transform-skew-x: 2deg;\n  }\n  .lg\\:skew-x-3 {\n    --transform-skew-x: 3deg;\n  }\n  .lg\\:skew-x-6 {\n    --transform-skew-x: 6deg;\n  }\n  .lg\\:skew-x-12 {\n    --transform-skew-x: 12deg;\n  }\n  .lg\\:-skew-x-12 {\n    --transform-skew-x: -12deg;\n  }\n  .lg\\:-skew-x-6 {\n    --transform-skew-x: -6deg;\n  }\n  .lg\\:-skew-x-3 {\n    --transform-skew-x: -3deg;\n  }\n  .lg\\:-skew-x-2 {\n    --transform-skew-x: -2deg;\n  }\n  .lg\\:-skew-x-1 {\n    --transform-skew-x: -1deg;\n  }\n  .lg\\:skew-y-0 {\n    --transform-skew-y: 0;\n  }\n  .lg\\:skew-y-1 {\n    --transform-skew-y: 1deg;\n  }\n  .lg\\:skew-y-2 {\n    --transform-skew-y: 2deg;\n  }\n  .lg\\:skew-y-3 {\n    --transform-skew-y: 3deg;\n  }\n  .lg\\:skew-y-6 {\n    --transform-skew-y: 6deg;\n  }\n  .lg\\:skew-y-12 {\n    --transform-skew-y: 12deg;\n  }\n  .lg\\:-skew-y-12 {\n    --transform-skew-y: -12deg;\n  }\n  .lg\\:-skew-y-6 {\n    --transform-skew-y: -6deg;\n  }\n  .lg\\:-skew-y-3 {\n    --transform-skew-y: -3deg;\n  }\n  .lg\\:-skew-y-2 {\n    --transform-skew-y: -2deg;\n  }\n  .lg\\:-skew-y-1 {\n    --transform-skew-y: -1deg;\n  }\n  .lg\\:hover\\:skew-x-0:hover {\n    --transform-skew-x: 0;\n  }\n  .lg\\:hover\\:skew-x-1:hover {\n    --transform-skew-x: 1deg;\n  }\n  .lg\\:hover\\:skew-x-2:hover {\n    --transform-skew-x: 2deg;\n  }\n  .lg\\:hover\\:skew-x-3:hover {\n    --transform-skew-x: 3deg;\n  }\n  .lg\\:hover\\:skew-x-6:hover {\n    --transform-skew-x: 6deg;\n  }\n  .lg\\:hover\\:skew-x-12:hover {\n    --transform-skew-x: 12deg;\n  }\n  .lg\\:hover\\:-skew-x-12:hover {\n    --transform-skew-x: -12deg;\n  }\n  .lg\\:hover\\:-skew-x-6:hover {\n    --transform-skew-x: -6deg;\n  }\n  .lg\\:hover\\:-skew-x-3:hover {\n    --transform-skew-x: -3deg;\n  }\n  .lg\\:hover\\:-skew-x-2:hover {\n    --transform-skew-x: -2deg;\n  }\n  .lg\\:hover\\:-skew-x-1:hover {\n    --transform-skew-x: -1deg;\n  }\n  .lg\\:hover\\:skew-y-0:hover {\n    --transform-skew-y: 0;\n  }\n  .lg\\:hover\\:skew-y-1:hover {\n    --transform-skew-y: 1deg;\n  }\n  .lg\\:hover\\:skew-y-2:hover {\n    --transform-skew-y: 2deg;\n  }\n  .lg\\:hover\\:skew-y-3:hover {\n    --transform-skew-y: 3deg;\n  }\n  .lg\\:hover\\:skew-y-6:hover {\n    --transform-skew-y: 6deg;\n  }\n  .lg\\:hover\\:skew-y-12:hover {\n    --transform-skew-y: 12deg;\n  }\n  .lg\\:hover\\:-skew-y-12:hover {\n    --transform-skew-y: -12deg;\n  }\n  .lg\\:hover\\:-skew-y-6:hover {\n    --transform-skew-y: -6deg;\n  }\n  .lg\\:hover\\:-skew-y-3:hover {\n    --transform-skew-y: -3deg;\n  }\n  .lg\\:hover\\:-skew-y-2:hover {\n    --transform-skew-y: -2deg;\n  }\n  .lg\\:hover\\:-skew-y-1:hover {\n    --transform-skew-y: -1deg;\n  }\n  .lg\\:focus\\:skew-x-0:focus {\n    --transform-skew-x: 0;\n  }\n  .lg\\:focus\\:skew-x-1:focus {\n    --transform-skew-x: 1deg;\n  }\n  .lg\\:focus\\:skew-x-2:focus {\n    --transform-skew-x: 2deg;\n  }\n  .lg\\:focus\\:skew-x-3:focus {\n    --transform-skew-x: 3deg;\n  }\n  .lg\\:focus\\:skew-x-6:focus {\n    --transform-skew-x: 6deg;\n  }\n  .lg\\:focus\\:skew-x-12:focus {\n    --transform-skew-x: 12deg;\n  }\n  .lg\\:focus\\:-skew-x-12:focus {\n    --transform-skew-x: -12deg;\n  }\n  .lg\\:focus\\:-skew-x-6:focus {\n    --transform-skew-x: -6deg;\n  }\n  .lg\\:focus\\:-skew-x-3:focus {\n    --transform-skew-x: -3deg;\n  }\n  .lg\\:focus\\:-skew-x-2:focus {\n    --transform-skew-x: -2deg;\n  }\n  .lg\\:focus\\:-skew-x-1:focus {\n    --transform-skew-x: -1deg;\n  }\n  .lg\\:focus\\:skew-y-0:focus {\n    --transform-skew-y: 0;\n  }\n  .lg\\:focus\\:skew-y-1:focus {\n    --transform-skew-y: 1deg;\n  }\n  .lg\\:focus\\:skew-y-2:focus {\n    --transform-skew-y: 2deg;\n  }\n  .lg\\:focus\\:skew-y-3:focus {\n    --transform-skew-y: 3deg;\n  }\n  .lg\\:focus\\:skew-y-6:focus {\n    --transform-skew-y: 6deg;\n  }\n  .lg\\:focus\\:skew-y-12:focus {\n    --transform-skew-y: 12deg;\n  }\n  .lg\\:focus\\:-skew-y-12:focus {\n    --transform-skew-y: -12deg;\n  }\n  .lg\\:focus\\:-skew-y-6:focus {\n    --transform-skew-y: -6deg;\n  }\n  .lg\\:focus\\:-skew-y-3:focus {\n    --transform-skew-y: -3deg;\n  }\n  .lg\\:focus\\:-skew-y-2:focus {\n    --transform-skew-y: -2deg;\n  }\n  .lg\\:focus\\:-skew-y-1:focus {\n    --transform-skew-y: -1deg;\n  }\n  .lg\\:transition-none {\n    transition-property: none;\n  }\n  .lg\\:transition-all {\n    transition-property: all;\n  }\n  .lg\\:transition {\n    transition-property: background-color, border-color, color, fill, stroke, opacity, box-shadow, transform;\n  }\n  .lg\\:transition-colors {\n    transition-property: background-color, border-color, color, fill, stroke;\n  }\n  .lg\\:transition-opacity {\n    transition-property: opacity;\n  }\n  .lg\\:transition-shadow {\n    transition-property: box-shadow;\n  }\n  .lg\\:transition-transform {\n    transition-property: transform;\n  }\n  .lg\\:ease-linear {\n    transition-timing-function: linear;\n  }\n  .lg\\:ease-in {\n    transition-timing-function: cubic-bezier(0.4, 0, 1, 1);\n  }\n  .lg\\:ease-out {\n    transition-timing-function: cubic-bezier(0, 0, 0.2, 1);\n  }\n  .lg\\:ease-in-out {\n    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n  }\n  .lg\\:duration-75 {\n    transition-duration: 75ms;\n  }\n  .lg\\:duration-100 {\n    transition-duration: 100ms;\n  }\n  .lg\\:duration-150 {\n    transition-duration: 150ms;\n  }\n  .lg\\:duration-200 {\n    transition-duration: 200ms;\n  }\n  .lg\\:duration-300 {\n    transition-duration: 300ms;\n  }\n  .lg\\:duration-500 {\n    transition-duration: 500ms;\n  }\n  .lg\\:duration-700 {\n    transition-duration: 700ms;\n  }\n  .lg\\:duration-1000 {\n    transition-duration: 1000ms;\n  }\n  .lg\\:delay-75 {\n    transition-delay: 75ms;\n  }\n  .lg\\:delay-100 {\n    transition-delay: 100ms;\n  }\n  .lg\\:delay-150 {\n    transition-delay: 150ms;\n  }\n  .lg\\:delay-200 {\n    transition-delay: 200ms;\n  }\n  .lg\\:delay-300 {\n    transition-delay: 300ms;\n  }\n  .lg\\:delay-500 {\n    transition-delay: 500ms;\n  }\n  .lg\\:delay-700 {\n    transition-delay: 700ms;\n  }\n  .lg\\:delay-1000 {\n    transition-delay: 1000ms;\n  }\n  .lg\\:animate-none {\n    animation: none;\n  }\n  .lg\\:animate-spin {\n    animation: spin 1s linear infinite;\n  }\n  .lg\\:animate-ping {\n    animation: ping 1s cubic-bezier(0, 0, 0.2, 1) infinite;\n  }\n  .lg\\:animate-pulse {\n    animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;\n  }\n  .lg\\:animate-bounce {\n    animation: bounce 1s infinite;\n  }\n}\n@media (min-width: 1280px) {\n  .xl\\:container {\n    width: 100%;\n  }\n  @media (min-width: 640px) {\n    .xl\\:container {\n      max-width: 640px;\n    }\n  }\n  @media (min-width: 768px) {\n    .xl\\:container {\n      max-width: 768px;\n    }\n  }\n  @media (min-width: 1024px) {\n    .xl\\:container {\n      max-width: 1024px;\n    }\n  }\n  @media (min-width: 1280px) {\n    .xl\\:container {\n      max-width: 1280px;\n    }\n  }\n  .xl\\:prose {\n    color: #374151;\n    max-width: 65ch;\n  }\n  .xl\\:prose [class~=\"lead\"] {\n    color: #4b5563;\n    font-size: 1.25em;\n    line-height: 1.6;\n    margin-top: 1.2em;\n    margin-bottom: 1.2em;\n  }\n  .xl\\:prose a {\n    color: #5850ec;\n    text-decoration: none;\n    font-weight: 600;\n  }\n  .xl\\:prose strong {\n    color: #161e2e;\n    font-weight: 600;\n  }\n  .xl\\:prose ol {\n    counter-reset: list-counter;\n    margin-top: 1.25em;\n    margin-bottom: 1.25em;\n  }\n  .xl\\:prose ol>li {\n    position: relative;\n    counter-increment: list-counter;\n    padding-left: 1.75em;\n  }\n  .xl\\:prose ol>li::before {\n    content: counter(list-counter) \".\";\n    position: absolute;\n    font-weight: 400;\n    color: #6b7280;\n  }\n  .xl\\:prose ul>li {\n    position: relative;\n    padding-left: 1.75em;\n  }\n  .xl\\:prose ul>li::before {\n    content: \"\";\n    position: absolute;\n    background-color: #d2d6dc;\n    border-radius: 50%;\n    width: 0.375em;\n    height: 0.375em;\n    top: calc(0.875em - 0.1875em);\n    left: 0.25em;\n  }\n  .xl\\:prose hr {\n    border-color: #e5e7eb;\n    border-top-width: 1px;\n    margin-top: 3em;\n    margin-bottom: 3em;\n  }\n  .xl\\:prose blockquote {\n    font-weight: 500;\n    font-style: italic;\n    color: #161e2e;\n    border-left-width: 0.25rem;\n    border-left-color: #e5e7eb;\n    quotes: \"\\201C\" \"\\201D\" \"\\2018\" \"\\2019\";\n    margin-top: 1.6em;\n    margin-bottom: 1.6em;\n    padding-left: 1em;\n  }\n  .xl\\:prose blockquote p:first-of-type::before {\n    content: open-quote;\n  }\n  .xl\\:prose blockquote p:last-of-type::after {\n    content: close-quote;\n  }\n  .xl\\:prose h1 {\n    color: #1a202c;\n    font-weight: 800;\n    font-size: 2.25em;\n    margin-top: 0;\n    margin-bottom: 0.8888889em;\n    line-height: 1.1111111;\n  }\n  .xl\\:prose h2 {\n    color: #1a202c;\n    font-weight: 700;\n    font-size: 1.5em;\n    margin-top: 2em;\n    margin-bottom: 1em;\n    line-height: 1.3333333;\n  }\n  .xl\\:prose h3 {\n    color: #1a202c;\n    font-weight: 600;\n    font-size: 1.25em;\n    margin-top: 1.6em;\n    margin-bottom: 0.6em;\n    line-height: 1.6;\n  }\n  .xl\\:prose h4 {\n    color: #1a202c;\n    font-weight: 600;\n    margin-top: 1.5em;\n    margin-bottom: 0.5em;\n    line-height: 1.5;\n  }\n  .xl\\:prose figure figcaption {\n    color: #6b7280;\n    font-size: 0.875em;\n    line-height: 1.4285714;\n    margin-top: 0.8571429em;\n  }\n  .xl\\:prose code {\n    color: #161e2e;\n    font-weight: 600;\n    font-size: 0.875em;\n  }\n  .xl\\:prose code::before {\n    content: \"`\";\n  }\n  .xl\\:prose code::after {\n    content: \"`\";\n  }\n  .xl\\:prose pre {\n    color: #e5e7eb;\n    background-color: #252f3f;\n    overflow-x: auto;\n    font-size: 0.875em;\n    line-height: 1.7142857;\n    margin-top: 1.7142857em;\n    margin-bottom: 1.7142857em;\n    border-radius: 0.375rem;\n    padding-top: 0.8571429em;\n    padding-right: 1.1428571em;\n    padding-bottom: 0.8571429em;\n    padding-left: 1.1428571em;\n  }\n  .xl\\:prose pre code {\n    background-color: transparent;\n    border-width: 0;\n    border-radius: 0;\n    padding: 0;\n    font-weight: 400;\n    color: inherit;\n    font-size: inherit;\n    font-family: inherit;\n    line-height: inherit;\n  }\n  .xl\\:prose pre code::before {\n    content: \"\";\n  }\n  .xl\\:prose pre code::after {\n    content: \"\";\n  }\n  .xl\\:prose table {\n    width: 100%;\n    table-layout: auto;\n    text-align: left;\n    margin-top: 2em;\n    margin-bottom: 2em;\n    font-size: 0.875em;\n    line-height: 1.7142857;\n  }\n  .xl\\:prose thead {\n    color: #161e2e;\n    font-weight: 600;\n    border-bottom-width: 1px;\n    border-bottom-color: #d2d6dc;\n  }\n  .xl\\:prose thead th {\n    vertical-align: bottom;\n    padding-right: 0.5714286em;\n    padding-bottom: 0.5714286em;\n    padding-left: 0.5714286em;\n  }\n  .xl\\:prose tbody tr {\n    border-bottom-width: 1px;\n    border-bottom-color: #e5e7eb;\n  }\n  .xl\\:prose tbody tr:last-child {\n    border-bottom-width: 0;\n  }\n  .xl\\:prose tbody td {\n    vertical-align: top;\n    padding-top: 0.5714286em;\n    padding-right: 0.5714286em;\n    padding-bottom: 0.5714286em;\n    padding-left: 0.5714286em;\n  }\n  .xl\\:prose {\n    font-size: 1rem;\n    line-height: 1.75;\n  }\n  .xl\\:prose p {\n    margin-top: 1.25em;\n    margin-bottom: 1.25em;\n  }\n  .xl\\:prose img {\n    margin-top: 2em;\n    margin-bottom: 2em;\n  }\n  .xl\\:prose video {\n    margin-top: 2em;\n    margin-bottom: 2em;\n  }\n  .xl\\:prose figure {\n    margin-top: 2em;\n    margin-bottom: 2em;\n  }\n  .xl\\:prose figure>* {\n    margin-top: 0;\n    margin-bottom: 0;\n  }\n  .xl\\:prose h2 code {\n    font-size: 0.875em;\n  }\n  .xl\\:prose h3 code {\n    font-size: 0.9em;\n  }\n  .xl\\:prose ul {\n    margin-top: 1.25em;\n    margin-bottom: 1.25em;\n  }\n  .xl\\:prose li {\n    margin-top: 0.5em;\n    margin-bottom: 0.5em;\n  }\n  .xl\\:prose ol>li:before {\n    left: 0;\n  }\n  .xl\\:prose>ul>li p {\n    margin-top: 0.75em;\n    margin-bottom: 0.75em;\n  }\n  .xl\\:prose>ul>li>*:first-child {\n    margin-top: 1.25em;\n  }\n  .xl\\:prose>ul>li>*:last-child {\n    margin-bottom: 1.25em;\n  }\n  .xl\\:prose>ol>li>*:first-child {\n    margin-top: 1.25em;\n  }\n  .xl\\:prose>ol>li>*:last-child {\n    margin-bottom: 1.25em;\n  }\n  .xl\\:prose ul ul, .xl\\:prose ul ol, .xl\\:prose ol ul, .xl\\:prose ol ol {\n    margin-top: 0.75em;\n    margin-bottom: 0.75em;\n  }\n  .xl\\:prose hr+* {\n    margin-top: 0;\n  }\n  .xl\\:prose h2+* {\n    margin-top: 0;\n  }\n  .xl\\:prose h3+* {\n    margin-top: 0;\n  }\n  .xl\\:prose h4+* {\n    margin-top: 0;\n  }\n  .xl\\:prose thead th:first-child {\n    padding-left: 0;\n  }\n  .xl\\:prose thead th:last-child {\n    padding-right: 0;\n  }\n  .xl\\:prose tbody td:first-child {\n    padding-left: 0;\n  }\n  .xl\\:prose tbody td:last-child {\n    padding-right: 0;\n  }\n  .xl\\:prose> :first-child {\n    margin-top: 0;\n  }\n  .xl\\:prose> :last-child {\n    margin-bottom: 0;\n  }\n  .xl\\:prose h1, .xl\\:prose h2, .xl\\:prose h3, .xl\\:prose h4 {\n    color: #161e2e;\n  }\n  .xl\\:prose-sm {\n    font-size: 0.875rem;\n    line-height: 1.7142857;\n  }\n  .xl\\:prose-sm p {\n    margin-top: 1.1428571em;\n    margin-bottom: 1.1428571em;\n  }\n  .xl\\:prose-sm [class~=\"lead\"] {\n    font-size: 1.2857143em;\n    line-height: 1.5555556;\n    margin-top: 0.8888889em;\n    margin-bottom: 0.8888889em;\n  }\n  .xl\\:prose-sm blockquote {\n    margin-top: 1.3333333em;\n    margin-bottom: 1.3333333em;\n    padding-left: 1.1111111em;\n  }\n  .xl\\:prose-sm h1 {\n    font-size: 2.1428571em;\n    margin-top: 0;\n    margin-bottom: 0.8em;\n    line-height: 1.2;\n  }\n  .xl\\:prose-sm h2 {\n    font-size: 1.4285714em;\n    margin-top: 1.6em;\n    margin-bottom: 0.8em;\n    line-height: 1.4;\n  }\n  .xl\\:prose-sm h3 {\n    font-size: 1.2857143em;\n    margin-top: 1.5555556em;\n    margin-bottom: 0.4444444em;\n    line-height: 1.5555556;\n  }\n  .xl\\:prose-sm h4 {\n    margin-top: 1.4285714em;\n    margin-bottom: 0.5714286em;\n    line-height: 1.4285714;\n  }\n  .xl\\:prose-sm img {\n    margin-top: 1.7142857em;\n    margin-bottom: 1.7142857em;\n  }\n  .xl\\:prose-sm video {\n    margin-top: 1.7142857em;\n    margin-bottom: 1.7142857em;\n  }\n  .xl\\:prose-sm figure {\n    margin-top: 1.7142857em;\n    margin-bottom: 1.7142857em;\n  }\n  .xl\\:prose-sm figure>* {\n    margin-top: 0;\n    margin-bottom: 0;\n  }\n  .xl\\:prose-sm figure figcaption {\n    font-size: 0.8571429em;\n    line-height: 1.3333333;\n    margin-top: 0.6666667em;\n  }\n  .xl\\:prose-sm code {\n    font-size: 0.8571429em;\n  }\n  .xl\\:prose-sm h2 code {\n    font-size: 0.9em;\n  }\n  .xl\\:prose-sm h3 code {\n    font-size: 0.8888889em;\n  }\n  .xl\\:prose-sm pre {\n    font-size: 0.8571429em;\n    line-height: 1.6666667;\n    margin-top: 1.6666667em;\n    margin-bottom: 1.6666667em;\n    border-radius: 0.25rem;\n    padding-top: 0.6666667em;\n    padding-right: 1em;\n    padding-bottom: 0.6666667em;\n    padding-left: 1em;\n  }\n  .xl\\:prose-sm ol {\n    margin-top: 1.1428571em;\n    margin-bottom: 1.1428571em;\n  }\n  .xl\\:prose-sm ul {\n    margin-top: 1.1428571em;\n    margin-bottom: 1.1428571em;\n  }\n  .xl\\:prose-sm li {\n    margin-top: 0.2857143em;\n    margin-bottom: 0.2857143em;\n  }\n  .xl\\:prose-sm ol>li {\n    padding-left: 1.5714286em;\n  }\n  .xl\\:prose-sm ol>li:before {\n    left: 0;\n  }\n  .xl\\:prose-sm ul>li {\n    padding-left: 1.5714286em;\n  }\n  .xl\\:prose-sm ul>li::before {\n    height: 0.3571429em;\n    width: 0.3571429em;\n    top: calc(0.8571429em - 0.1785714em);\n    left: 0.2142857em;\n  }\n  .xl\\:prose-sm>ul>li p {\n    margin-top: 0.5714286em;\n    margin-bottom: 0.5714286em;\n  }\n  .xl\\:prose-sm>ul>li>*:first-child {\n    margin-top: 1.1428571em;\n  }\n  .xl\\:prose-sm>ul>li>*:last-child {\n    margin-bottom: 1.1428571em;\n  }\n  .xl\\:prose-sm>ol>li>*:first-child {\n    margin-top: 1.1428571em;\n  }\n  .xl\\:prose-sm>ol>li>*:last-child {\n    margin-bottom: 1.1428571em;\n  }\n  .xl\\:prose-sm ul ul, .xl\\:prose-sm ul ol, .xl\\:prose-sm ol ul, .xl\\:prose-sm ol ol {\n    margin-top: 0.5714286em;\n    margin-bottom: 0.5714286em;\n  }\n  .xl\\:prose-sm hr {\n    margin-top: 2.8571429em;\n    margin-bottom: 2.8571429em;\n  }\n  .xl\\:prose-sm hr+* {\n    margin-top: 0;\n  }\n  .xl\\:prose-sm h2+* {\n    margin-top: 0;\n  }\n  .xl\\:prose-sm h3+* {\n    margin-top: 0;\n  }\n  .xl\\:prose-sm h4+* {\n    margin-top: 0;\n  }\n  .xl\\:prose-sm table {\n    font-size: 0.8571429em;\n    line-height: 1.5;\n  }\n  .xl\\:prose-sm thead th {\n    padding-right: 1em;\n    padding-bottom: 0.6666667em;\n    padding-left: 1em;\n  }\n  .xl\\:prose-sm thead th:first-child {\n    padding-left: 0;\n  }\n  .xl\\:prose-sm thead th:last-child {\n    padding-right: 0;\n  }\n  .xl\\:prose-sm tbody td {\n    padding-top: 0.6666667em;\n    padding-right: 1em;\n    padding-bottom: 0.6666667em;\n    padding-left: 1em;\n  }\n  .xl\\:prose-sm tbody td:first-child {\n    padding-left: 0;\n  }\n  .xl\\:prose-sm tbody td:last-child {\n    padding-right: 0;\n  }\n  .xl\\:prose-sm> :first-child {\n    margin-top: 0;\n  }\n  .xl\\:prose-sm> :last-child {\n    margin-bottom: 0;\n  }\n  .xl\\:prose-lg {\n    font-size: 1.125rem;\n    line-height: 1.7777778;\n  }\n  .xl\\:prose-lg p {\n    margin-top: 1.3333333em;\n    margin-bottom: 1.3333333em;\n  }\n  .xl\\:prose-lg [class~=\"lead\"] {\n    font-size: 1.2222222em;\n    line-height: 1.4545455;\n    margin-top: 1.0909091em;\n    margin-bottom: 1.0909091em;\n  }\n  .xl\\:prose-lg blockquote {\n    margin-top: 1.6666667em;\n    margin-bottom: 1.6666667em;\n    padding-left: 1em;\n  }\n  .xl\\:prose-lg h1 {\n    font-size: 2.6666667em;\n    margin-top: 0;\n    margin-bottom: 0.8333333em;\n    line-height: 1;\n  }\n  .xl\\:prose-lg h2 {\n    font-size: 1.6666667em;\n    margin-top: 1.8666667em;\n    margin-bottom: 1.0666667em;\n    line-height: 1.3333333;\n  }\n  .xl\\:prose-lg h3 {\n    font-size: 1.3333333em;\n    margin-top: 1.6666667em;\n    margin-bottom: 0.6666667em;\n    line-height: 1.5;\n  }\n  .xl\\:prose-lg h4 {\n    margin-top: 1.7777778em;\n    margin-bottom: 0.4444444em;\n    line-height: 1.5555556;\n  }\n  .xl\\:prose-lg img {\n    margin-top: 1.7777778em;\n    margin-bottom: 1.7777778em;\n  }\n  .xl\\:prose-lg video {\n    margin-top: 1.7777778em;\n    margin-bottom: 1.7777778em;\n  }\n  .xl\\:prose-lg figure {\n    margin-top: 1.7777778em;\n    margin-bottom: 1.7777778em;\n  }\n  .xl\\:prose-lg figure>* {\n    margin-top: 0;\n    margin-bottom: 0;\n  }\n  .xl\\:prose-lg figure figcaption {\n    font-size: 0.8888889em;\n    line-height: 1.5;\n    margin-top: 1em;\n  }\n  .xl\\:prose-lg code {\n    font-size: 0.8888889em;\n  }\n  .xl\\:prose-lg h2 code {\n    font-size: 0.8666667em;\n  }\n  .xl\\:prose-lg h3 code {\n    font-size: 0.875em;\n  }\n  .xl\\:prose-lg pre {\n    font-size: 0.8888889em;\n    line-height: 1.75;\n    margin-top: 2em;\n    margin-bottom: 2em;\n    border-radius: 0.375rem;\n    padding-top: 1em;\n    padding-right: 1.5em;\n    padding-bottom: 1em;\n    padding-left: 1.5em;\n  }\n  .xl\\:prose-lg ol {\n    margin-top: 1.3333333em;\n    margin-bottom: 1.3333333em;\n  }\n  .xl\\:prose-lg ul {\n    margin-top: 1.3333333em;\n    margin-bottom: 1.3333333em;\n  }\n  .xl\\:prose-lg li {\n    margin-top: 0.6666667em;\n    margin-bottom: 0.6666667em;\n  }\n  .xl\\:prose-lg ol>li {\n    padding-left: 1.6666667em;\n  }\n  .xl\\:prose-lg ol>li:before {\n    left: 0;\n  }\n  .xl\\:prose-lg ul>li {\n    padding-left: 1.6666667em;\n  }\n  .xl\\:prose-lg ul>li::before {\n    width: 0.3333333em;\n    height: 0.3333333em;\n    top: calc(0.8888889em - 0.1666667em);\n    left: 0.2222222em;\n  }\n  .xl\\:prose-lg>ul>li p {\n    margin-top: 0.8888889em;\n    margin-bottom: 0.8888889em;\n  }\n  .xl\\:prose-lg>ul>li>*:first-child {\n    margin-top: 1.3333333em;\n  }\n  .xl\\:prose-lg>ul>li>*:last-child {\n    margin-bottom: 1.3333333em;\n  }\n  .xl\\:prose-lg>ol>li>*:first-child {\n    margin-top: 1.3333333em;\n  }\n  .xl\\:prose-lg>ol>li>*:last-child {\n    margin-bottom: 1.3333333em;\n  }\n  .xl\\:prose-lg ul ul, .xl\\:prose-lg ul ol, .xl\\:prose-lg ol ul, .xl\\:prose-lg ol ol {\n    margin-top: 0.8888889em;\n    margin-bottom: 0.8888889em;\n  }\n  .xl\\:prose-lg hr {\n    margin-top: 3.1111111em;\n    margin-bottom: 3.1111111em;\n  }\n  .xl\\:prose-lg hr+* {\n    margin-top: 0;\n  }\n  .xl\\:prose-lg h2+* {\n    margin-top: 0;\n  }\n  .xl\\:prose-lg h3+* {\n    margin-top: 0;\n  }\n  .xl\\:prose-lg h4+* {\n    margin-top: 0;\n  }\n  .xl\\:prose-lg table {\n    font-size: 0.8888889em;\n    line-height: 1.5;\n  }\n  .xl\\:prose-lg thead th {\n    padding-right: 0.75em;\n    padding-bottom: 0.75em;\n    padding-left: 0.75em;\n  }\n  .xl\\:prose-lg thead th:first-child {\n    padding-left: 0;\n  }\n  .xl\\:prose-lg thead th:last-child {\n    padding-right: 0;\n  }\n  .xl\\:prose-lg tbody td {\n    padding-top: 0.75em;\n    padding-right: 0.75em;\n    padding-bottom: 0.75em;\n    padding-left: 0.75em;\n  }\n  .xl\\:prose-lg tbody td:first-child {\n    padding-left: 0;\n  }\n  .xl\\:prose-lg tbody td:last-child {\n    padding-right: 0;\n  }\n  .xl\\:prose-lg> :first-child {\n    margin-top: 0;\n  }\n  .xl\\:prose-lg> :last-child {\n    margin-bottom: 0;\n  }\n  .xl\\:prose-xl {\n    font-size: 1.25rem;\n    line-height: 1.8;\n  }\n  .xl\\:prose-xl p {\n    margin-top: 1.2em;\n    margin-bottom: 1.2em;\n  }\n  .xl\\:prose-xl [class~=\"lead\"] {\n    font-size: 1.2em;\n    line-height: 1.5;\n    margin-top: 1em;\n    margin-bottom: 1em;\n  }\n  .xl\\:prose-xl blockquote {\n    margin-top: 1.6em;\n    margin-bottom: 1.6em;\n    padding-left: 1.0666667em;\n  }\n  .xl\\:prose-xl h1 {\n    font-size: 2.8em;\n    margin-top: 0;\n    margin-bottom: 0.8571429em;\n    line-height: 1;\n  }\n  .xl\\:prose-xl h2 {\n    font-size: 1.8em;\n    margin-top: 1.5555556em;\n    margin-bottom: 0.8888889em;\n    line-height: 1.1111111;\n  }\n  .xl\\:prose-xl h3 {\n    font-size: 1.5em;\n    margin-top: 1.6em;\n    margin-bottom: 0.6666667em;\n    line-height: 1.3333333;\n  }\n  .xl\\:prose-xl h4 {\n    margin-top: 1.8em;\n    margin-bottom: 0.6em;\n    line-height: 1.6;\n  }\n  .xl\\:prose-xl img {\n    margin-top: 2em;\n    margin-bottom: 2em;\n  }\n  .xl\\:prose-xl video {\n    margin-top: 2em;\n    margin-bottom: 2em;\n  }\n  .xl\\:prose-xl figure {\n    margin-top: 2em;\n    margin-bottom: 2em;\n  }\n  .xl\\:prose-xl figure>* {\n    margin-top: 0;\n    margin-bottom: 0;\n  }\n  .xl\\:prose-xl figure figcaption {\n    font-size: 0.9em;\n    line-height: 1.5555556;\n    margin-top: 1em;\n  }\n  .xl\\:prose-xl code {\n    font-size: 0.9em;\n  }\n  .xl\\:prose-xl h2 code {\n    font-size: 0.8611111em;\n  }\n  .xl\\:prose-xl h3 code {\n    font-size: 0.9em;\n  }\n  .xl\\:prose-xl pre {\n    font-size: 0.9em;\n    line-height: 1.7777778;\n    margin-top: 2em;\n    margin-bottom: 2em;\n    border-radius: 0.5rem;\n    padding-top: 1.1111111em;\n    padding-right: 1.3333333em;\n    padding-bottom: 1.1111111em;\n    padding-left: 1.3333333em;\n  }\n  .xl\\:prose-xl ol {\n    margin-top: 1.2em;\n    margin-bottom: 1.2em;\n  }\n  .xl\\:prose-xl ul {\n    margin-top: 1.2em;\n    margin-bottom: 1.2em;\n  }\n  .xl\\:prose-xl li {\n    margin-top: 0.6em;\n    margin-bottom: 0.6em;\n  }\n  .xl\\:prose-xl ol>li {\n    padding-left: 1.8em;\n  }\n  .xl\\:prose-xl ol>li:before {\n    left: 0;\n  }\n  .xl\\:prose-xl ul>li {\n    padding-left: 1.8em;\n  }\n  .xl\\:prose-xl ul>li::before {\n    width: 0.35em;\n    height: 0.35em;\n    top: calc(0.9em - 0.175em);\n    left: 0.25em;\n  }\n  .xl\\:prose-xl>ul>li p {\n    margin-top: 0.8em;\n    margin-bottom: 0.8em;\n  }\n  .xl\\:prose-xl>ul>li>*:first-child {\n    margin-top: 1.2em;\n  }\n  .xl\\:prose-xl>ul>li>*:last-child {\n    margin-bottom: 1.2em;\n  }\n  .xl\\:prose-xl>ol>li>*:first-child {\n    margin-top: 1.2em;\n  }\n  .xl\\:prose-xl>ol>li>*:last-child {\n    margin-bottom: 1.2em;\n  }\n  .xl\\:prose-xl ul ul, .xl\\:prose-xl ul ol, .xl\\:prose-xl ol ul, .xl\\:prose-xl ol ol {\n    margin-top: 0.8em;\n    margin-bottom: 0.8em;\n  }\n  .xl\\:prose-xl hr {\n    margin-top: 2.8em;\n    margin-bottom: 2.8em;\n  }\n  .xl\\:prose-xl hr+* {\n    margin-top: 0;\n  }\n  .xl\\:prose-xl h2+* {\n    margin-top: 0;\n  }\n  .xl\\:prose-xl h3+* {\n    margin-top: 0;\n  }\n  .xl\\:prose-xl h4+* {\n    margin-top: 0;\n  }\n  .xl\\:prose-xl table {\n    font-size: 0.9em;\n    line-height: 1.5555556;\n  }\n  .xl\\:prose-xl thead th {\n    padding-right: 0.6666667em;\n    padding-bottom: 0.8888889em;\n    padding-left: 0.6666667em;\n  }\n  .xl\\:prose-xl thead th:first-child {\n    padding-left: 0;\n  }\n  .xl\\:prose-xl thead th:last-child {\n    padding-right: 0;\n  }\n  .xl\\:prose-xl tbody td {\n    padding-top: 0.8888889em;\n    padding-right: 0.6666667em;\n    padding-bottom: 0.8888889em;\n    padding-left: 0.6666667em;\n  }\n  .xl\\:prose-xl tbody td:first-child {\n    padding-left: 0;\n  }\n  .xl\\:prose-xl tbody td:last-child {\n    padding-right: 0;\n  }\n  .xl\\:prose-xl> :first-child {\n    margin-top: 0;\n  }\n  .xl\\:prose-xl> :last-child {\n    margin-bottom: 0;\n  }\n  .xl\\:prose-2xl {\n    font-size: 1.5rem;\n    line-height: 1.6666667;\n  }\n  .xl\\:prose-2xl p {\n    margin-top: 1.3333333em;\n    margin-bottom: 1.3333333em;\n  }\n  .xl\\:prose-2xl [class~=\"lead\"] {\n    font-size: 1.25em;\n    line-height: 1.4666667;\n    margin-top: 1.0666667em;\n    margin-bottom: 1.0666667em;\n  }\n  .xl\\:prose-2xl blockquote {\n    margin-top: 1.7777778em;\n    margin-bottom: 1.7777778em;\n    padding-left: 1.1111111em;\n  }\n  .xl\\:prose-2xl h1 {\n    font-size: 2.6666667em;\n    margin-top: 0;\n    margin-bottom: 0.875em;\n    line-height: 1;\n  }\n  .xl\\:prose-2xl h2 {\n    font-size: 2em;\n    margin-top: 1.5em;\n    margin-bottom: 0.8333333em;\n    line-height: 1.0833333;\n  }\n  .xl\\:prose-2xl h3 {\n    font-size: 1.5em;\n    margin-top: 1.5555556em;\n    margin-bottom: 0.6666667em;\n    line-height: 1.2222222;\n  }\n  .xl\\:prose-2xl h4 {\n    margin-top: 1.6666667em;\n    margin-bottom: 0.6666667em;\n    line-height: 1.5;\n  }\n  .xl\\:prose-2xl img {\n    margin-top: 2em;\n    margin-bottom: 2em;\n  }\n  .xl\\:prose-2xl video {\n    margin-top: 2em;\n    margin-bottom: 2em;\n  }\n  .xl\\:prose-2xl figure {\n    margin-top: 2em;\n    margin-bottom: 2em;\n  }\n  .xl\\:prose-2xl figure>* {\n    margin-top: 0;\n    margin-bottom: 0;\n  }\n  .xl\\:prose-2xl figure figcaption {\n    font-size: 0.8333333em;\n    line-height: 1.6;\n    margin-top: 1em;\n  }\n  .xl\\:prose-2xl code {\n    font-size: 0.8333333em;\n  }\n  .xl\\:prose-2xl h2 code {\n    font-size: 0.875em;\n  }\n  .xl\\:prose-2xl h3 code {\n    font-size: 0.8888889em;\n  }\n  .xl\\:prose-2xl pre {\n    font-size: 0.8333333em;\n    line-height: 1.8;\n    margin-top: 2em;\n    margin-bottom: 2em;\n    border-radius: 0.5rem;\n    padding-top: 1.2em;\n    padding-right: 1.6em;\n    padding-bottom: 1.2em;\n    padding-left: 1.6em;\n  }\n  .xl\\:prose-2xl ol {\n    margin-top: 1.3333333em;\n    margin-bottom: 1.3333333em;\n  }\n  .xl\\:prose-2xl ul {\n    margin-top: 1.3333333em;\n    margin-bottom: 1.3333333em;\n  }\n  .xl\\:prose-2xl li {\n    margin-top: 0.5em;\n    margin-bottom: 0.5em;\n  }\n  .xl\\:prose-2xl ol>li {\n    padding-left: 1.6666667em;\n  }\n  .xl\\:prose-2xl ol>li:before {\n    left: 0;\n  }\n  .xl\\:prose-2xl ul>li {\n    padding-left: 1.6666667em;\n  }\n  .xl\\:prose-2xl ul>li::before {\n    width: 0.3333333em;\n    height: 0.3333333em;\n    top: calc(0.8333333em - 0.1666667em);\n    left: 0.25em;\n  }\n  .xl\\:prose-2xl>ul>li p {\n    margin-top: 0.8333333em;\n    margin-bottom: 0.8333333em;\n  }\n  .xl\\:prose-2xl>ul>li>*:first-child {\n    margin-top: 1.3333333em;\n  }\n  .xl\\:prose-2xl>ul>li>*:last-child {\n    margin-bottom: 1.3333333em;\n  }\n  .xl\\:prose-2xl>ol>li>*:first-child {\n    margin-top: 1.3333333em;\n  }\n  .xl\\:prose-2xl>ol>li>*:last-child {\n    margin-bottom: 1.3333333em;\n  }\n  .xl\\:prose-2xl ul ul, .xl\\:prose-2xl ul ol, .xl\\:prose-2xl ol ul, .xl\\:prose-2xl ol ol {\n    margin-top: 0.6666667em;\n    margin-bottom: 0.6666667em;\n  }\n  .xl\\:prose-2xl hr {\n    margin-top: 3em;\n    margin-bottom: 3em;\n  }\n  .xl\\:prose-2xl hr+* {\n    margin-top: 0;\n  }\n  .xl\\:prose-2xl h2+* {\n    margin-top: 0;\n  }\n  .xl\\:prose-2xl h3+* {\n    margin-top: 0;\n  }\n  .xl\\:prose-2xl h4+* {\n    margin-top: 0;\n  }\n  .xl\\:prose-2xl table {\n    font-size: 0.8333333em;\n    line-height: 1.4;\n  }\n  .xl\\:prose-2xl thead th {\n    padding-right: 0.6em;\n    padding-bottom: 0.8em;\n    padding-left: 0.6em;\n  }\n  .xl\\:prose-2xl thead th:first-child {\n    padding-left: 0;\n  }\n  .xl\\:prose-2xl thead th:last-child {\n    padding-right: 0;\n  }\n  .xl\\:prose-2xl tbody td {\n    padding-top: 0.8em;\n    padding-right: 0.6em;\n    padding-bottom: 0.8em;\n    padding-left: 0.6em;\n  }\n  .xl\\:prose-2xl tbody td:first-child {\n    padding-left: 0;\n  }\n  .xl\\:prose-2xl tbody td:last-child {\n    padding-right: 0;\n  }\n  .xl\\:prose-2xl> :first-child {\n    margin-top: 0;\n  }\n  .xl\\:prose-2xl> :last-child {\n    margin-bottom: 0;\n  }\n  .xl\\:space-y-0> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(0px * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(0px * var(--space-y-reverse));\n  }\n  .xl\\:space-x-0> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(0px * var(--space-x-reverse));\n    margin-left: calc(0px * calc(1 - var(--space-x-reverse)));\n  }\n  .xl\\:space-y-1> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(0.25rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(0.25rem * var(--space-y-reverse));\n  }\n  .xl\\:space-x-1> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(0.25rem * var(--space-x-reverse));\n    margin-left: calc(0.25rem * calc(1 - var(--space-x-reverse)));\n  }\n  .xl\\:space-y-2> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(0.5rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(0.5rem * var(--space-y-reverse));\n  }\n  .xl\\:space-x-2> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(0.5rem * var(--space-x-reverse));\n    margin-left: calc(0.5rem * calc(1 - var(--space-x-reverse)));\n  }\n  .xl\\:space-y-3> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(0.75rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(0.75rem * var(--space-y-reverse));\n  }\n  .xl\\:space-x-3> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(0.75rem * var(--space-x-reverse));\n    margin-left: calc(0.75rem * calc(1 - var(--space-x-reverse)));\n  }\n  .xl\\:space-y-4> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(1rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(1rem * var(--space-y-reverse));\n  }\n  .xl\\:space-x-4> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(1rem * var(--space-x-reverse));\n    margin-left: calc(1rem * calc(1 - var(--space-x-reverse)));\n  }\n  .xl\\:space-y-5> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(1.25rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(1.25rem * var(--space-y-reverse));\n  }\n  .xl\\:space-x-5> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(1.25rem * var(--space-x-reverse));\n    margin-left: calc(1.25rem * calc(1 - var(--space-x-reverse)));\n  }\n  .xl\\:space-y-6> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(1.5rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(1.5rem * var(--space-y-reverse));\n  }\n  .xl\\:space-x-6> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(1.5rem * var(--space-x-reverse));\n    margin-left: calc(1.5rem * calc(1 - var(--space-x-reverse)));\n  }\n  .xl\\:space-y-7> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(1.75rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(1.75rem * var(--space-y-reverse));\n  }\n  .xl\\:space-x-7> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(1.75rem * var(--space-x-reverse));\n    margin-left: calc(1.75rem * calc(1 - var(--space-x-reverse)));\n  }\n  .xl\\:space-y-8> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(2rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(2rem * var(--space-y-reverse));\n  }\n  .xl\\:space-x-8> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(2rem * var(--space-x-reverse));\n    margin-left: calc(2rem * calc(1 - var(--space-x-reverse)));\n  }\n  .xl\\:space-y-9> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(2.25rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(2.25rem * var(--space-y-reverse));\n  }\n  .xl\\:space-x-9> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(2.25rem * var(--space-x-reverse));\n    margin-left: calc(2.25rem * calc(1 - var(--space-x-reverse)));\n  }\n  .xl\\:space-y-10> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(2.5rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(2.5rem * var(--space-y-reverse));\n  }\n  .xl\\:space-x-10> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(2.5rem * var(--space-x-reverse));\n    margin-left: calc(2.5rem * calc(1 - var(--space-x-reverse)));\n  }\n  .xl\\:space-y-11> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(2.75rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(2.75rem * var(--space-y-reverse));\n  }\n  .xl\\:space-x-11> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(2.75rem * var(--space-x-reverse));\n    margin-left: calc(2.75rem * calc(1 - var(--space-x-reverse)));\n  }\n  .xl\\:space-y-12> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(3rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(3rem * var(--space-y-reverse));\n  }\n  .xl\\:space-x-12> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(3rem * var(--space-x-reverse));\n    margin-left: calc(3rem * calc(1 - var(--space-x-reverse)));\n  }\n  .xl\\:space-y-13> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(3.25rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(3.25rem * var(--space-y-reverse));\n  }\n  .xl\\:space-x-13> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(3.25rem * var(--space-x-reverse));\n    margin-left: calc(3.25rem * calc(1 - var(--space-x-reverse)));\n  }\n  .xl\\:space-y-14> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(3.5rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(3.5rem * var(--space-y-reverse));\n  }\n  .xl\\:space-x-14> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(3.5rem * var(--space-x-reverse));\n    margin-left: calc(3.5rem * calc(1 - var(--space-x-reverse)));\n  }\n  .xl\\:space-y-15> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(3.75rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(3.75rem * var(--space-y-reverse));\n  }\n  .xl\\:space-x-15> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(3.75rem * var(--space-x-reverse));\n    margin-left: calc(3.75rem * calc(1 - var(--space-x-reverse)));\n  }\n  .xl\\:space-y-16> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(4rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(4rem * var(--space-y-reverse));\n  }\n  .xl\\:space-x-16> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(4rem * var(--space-x-reverse));\n    margin-left: calc(4rem * calc(1 - var(--space-x-reverse)));\n  }\n  .xl\\:space-y-20> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(5rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(5rem * var(--space-y-reverse));\n  }\n  .xl\\:space-x-20> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(5rem * var(--space-x-reverse));\n    margin-left: calc(5rem * calc(1 - var(--space-x-reverse)));\n  }\n  .xl\\:space-y-24> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(6rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(6rem * var(--space-y-reverse));\n  }\n  .xl\\:space-x-24> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(6rem * var(--space-x-reverse));\n    margin-left: calc(6rem * calc(1 - var(--space-x-reverse)));\n  }\n  .xl\\:space-y-28> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(7rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(7rem * var(--space-y-reverse));\n  }\n  .xl\\:space-x-28> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(7rem * var(--space-x-reverse));\n    margin-left: calc(7rem * calc(1 - var(--space-x-reverse)));\n  }\n  .xl\\:space-y-32> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(8rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(8rem * var(--space-y-reverse));\n  }\n  .xl\\:space-x-32> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(8rem * var(--space-x-reverse));\n    margin-left: calc(8rem * calc(1 - var(--space-x-reverse)));\n  }\n  .xl\\:space-y-36> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(9rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(9rem * var(--space-y-reverse));\n  }\n  .xl\\:space-x-36> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(9rem * var(--space-x-reverse));\n    margin-left: calc(9rem * calc(1 - var(--space-x-reverse)));\n  }\n  .xl\\:space-y-40> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(10rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(10rem * var(--space-y-reverse));\n  }\n  .xl\\:space-x-40> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(10rem * var(--space-x-reverse));\n    margin-left: calc(10rem * calc(1 - var(--space-x-reverse)));\n  }\n  .xl\\:space-y-44> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(11rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(11rem * var(--space-y-reverse));\n  }\n  .xl\\:space-x-44> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(11rem * var(--space-x-reverse));\n    margin-left: calc(11rem * calc(1 - var(--space-x-reverse)));\n  }\n  .xl\\:space-y-48> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(12rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(12rem * var(--space-y-reverse));\n  }\n  .xl\\:space-x-48> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(12rem * var(--space-x-reverse));\n    margin-left: calc(12rem * calc(1 - var(--space-x-reverse)));\n  }\n  .xl\\:space-y-52> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(13rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(13rem * var(--space-y-reverse));\n  }\n  .xl\\:space-x-52> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(13rem * var(--space-x-reverse));\n    margin-left: calc(13rem * calc(1 - var(--space-x-reverse)));\n  }\n  .xl\\:space-y-56> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(14rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(14rem * var(--space-y-reverse));\n  }\n  .xl\\:space-x-56> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(14rem * var(--space-x-reverse));\n    margin-left: calc(14rem * calc(1 - var(--space-x-reverse)));\n  }\n  .xl\\:space-y-60> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(15rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(15rem * var(--space-y-reverse));\n  }\n  .xl\\:space-x-60> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(15rem * var(--space-x-reverse));\n    margin-left: calc(15rem * calc(1 - var(--space-x-reverse)));\n  }\n  .xl\\:space-y-64> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(16rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(16rem * var(--space-y-reverse));\n  }\n  .xl\\:space-x-64> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(16rem * var(--space-x-reverse));\n    margin-left: calc(16rem * calc(1 - var(--space-x-reverse)));\n  }\n  .xl\\:space-y-72> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(18rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(18rem * var(--space-y-reverse));\n  }\n  .xl\\:space-x-72> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(18rem * var(--space-x-reverse));\n    margin-left: calc(18rem * calc(1 - var(--space-x-reverse)));\n  }\n  .xl\\:space-y-80> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(20rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(20rem * var(--space-y-reverse));\n  }\n  .xl\\:space-x-80> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(20rem * var(--space-x-reverse));\n    margin-left: calc(20rem * calc(1 - var(--space-x-reverse)));\n  }\n  .xl\\:space-y-96> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(24rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(24rem * var(--space-y-reverse));\n  }\n  .xl\\:space-x-96> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(24rem * var(--space-x-reverse));\n    margin-left: calc(24rem * calc(1 - var(--space-x-reverse)));\n  }\n  .xl\\:space-y-px> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(1px * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(1px * var(--space-y-reverse));\n  }\n  .xl\\:space-x-px> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(1px * var(--space-x-reverse));\n    margin-left: calc(1px * calc(1 - var(--space-x-reverse)));\n  }\n  .xl\\:space-y-0\\.5> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(0.125rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(0.125rem * var(--space-y-reverse));\n  }\n  .xl\\:space-x-0\\.5> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(0.125rem * var(--space-x-reverse));\n    margin-left: calc(0.125rem * calc(1 - var(--space-x-reverse)));\n  }\n  .xl\\:space-y-1\\.5> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(0.375rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(0.375rem * var(--space-y-reverse));\n  }\n  .xl\\:space-x-1\\.5> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(0.375rem * var(--space-x-reverse));\n    margin-left: calc(0.375rem * calc(1 - var(--space-x-reverse)));\n  }\n  .xl\\:space-y-2\\.5> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(0.625rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(0.625rem * var(--space-y-reverse));\n  }\n  .xl\\:space-x-2\\.5> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(0.625rem * var(--space-x-reverse));\n    margin-left: calc(0.625rem * calc(1 - var(--space-x-reverse)));\n  }\n  .xl\\:space-y-3\\.5> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(0.875rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(0.875rem * var(--space-y-reverse));\n  }\n  .xl\\:space-x-3\\.5> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(0.875rem * var(--space-x-reverse));\n    margin-left: calc(0.875rem * calc(1 - var(--space-x-reverse)));\n  }\n  .xl\\:space-y-1\\/2> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(50% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(50% * var(--space-y-reverse));\n  }\n  .xl\\:space-x-1\\/2> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(50% * var(--space-x-reverse));\n    margin-left: calc(50% * calc(1 - var(--space-x-reverse)));\n  }\n  .xl\\:space-y-1\\/3> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(33.333333% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(33.333333% * var(--space-y-reverse));\n  }\n  .xl\\:space-x-1\\/3> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(33.333333% * var(--space-x-reverse));\n    margin-left: calc(33.333333% * calc(1 - var(--space-x-reverse)));\n  }\n  .xl\\:space-y-2\\/3> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(66.666667% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(66.666667% * var(--space-y-reverse));\n  }\n  .xl\\:space-x-2\\/3> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(66.666667% * var(--space-x-reverse));\n    margin-left: calc(66.666667% * calc(1 - var(--space-x-reverse)));\n  }\n  .xl\\:space-y-1\\/4> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(25% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(25% * var(--space-y-reverse));\n  }\n  .xl\\:space-x-1\\/4> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(25% * var(--space-x-reverse));\n    margin-left: calc(25% * calc(1 - var(--space-x-reverse)));\n  }\n  .xl\\:space-y-2\\/4> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(50% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(50% * var(--space-y-reverse));\n  }\n  .xl\\:space-x-2\\/4> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(50% * var(--space-x-reverse));\n    margin-left: calc(50% * calc(1 - var(--space-x-reverse)));\n  }\n  .xl\\:space-y-3\\/4> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(75% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(75% * var(--space-y-reverse));\n  }\n  .xl\\:space-x-3\\/4> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(75% * var(--space-x-reverse));\n    margin-left: calc(75% * calc(1 - var(--space-x-reverse)));\n  }\n  .xl\\:space-y-1\\/5> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(20% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(20% * var(--space-y-reverse));\n  }\n  .xl\\:space-x-1\\/5> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(20% * var(--space-x-reverse));\n    margin-left: calc(20% * calc(1 - var(--space-x-reverse)));\n  }\n  .xl\\:space-y-2\\/5> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(40% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(40% * var(--space-y-reverse));\n  }\n  .xl\\:space-x-2\\/5> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(40% * var(--space-x-reverse));\n    margin-left: calc(40% * calc(1 - var(--space-x-reverse)));\n  }\n  .xl\\:space-y-3\\/5> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(60% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(60% * var(--space-y-reverse));\n  }\n  .xl\\:space-x-3\\/5> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(60% * var(--space-x-reverse));\n    margin-left: calc(60% * calc(1 - var(--space-x-reverse)));\n  }\n  .xl\\:space-y-4\\/5> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(80% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(80% * var(--space-y-reverse));\n  }\n  .xl\\:space-x-4\\/5> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(80% * var(--space-x-reverse));\n    margin-left: calc(80% * calc(1 - var(--space-x-reverse)));\n  }\n  .xl\\:space-y-1\\/6> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(16.666667% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(16.666667% * var(--space-y-reverse));\n  }\n  .xl\\:space-x-1\\/6> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(16.666667% * var(--space-x-reverse));\n    margin-left: calc(16.666667% * calc(1 - var(--space-x-reverse)));\n  }\n  .xl\\:space-y-2\\/6> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(33.333333% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(33.333333% * var(--space-y-reverse));\n  }\n  .xl\\:space-x-2\\/6> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(33.333333% * var(--space-x-reverse));\n    margin-left: calc(33.333333% * calc(1 - var(--space-x-reverse)));\n  }\n  .xl\\:space-y-3\\/6> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(50% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(50% * var(--space-y-reverse));\n  }\n  .xl\\:space-x-3\\/6> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(50% * var(--space-x-reverse));\n    margin-left: calc(50% * calc(1 - var(--space-x-reverse)));\n  }\n  .xl\\:space-y-4\\/6> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(66.666667% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(66.666667% * var(--space-y-reverse));\n  }\n  .xl\\:space-x-4\\/6> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(66.666667% * var(--space-x-reverse));\n    margin-left: calc(66.666667% * calc(1 - var(--space-x-reverse)));\n  }\n  .xl\\:space-y-5\\/6> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(83.333333% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(83.333333% * var(--space-y-reverse));\n  }\n  .xl\\:space-x-5\\/6> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(83.333333% * var(--space-x-reverse));\n    margin-left: calc(83.333333% * calc(1 - var(--space-x-reverse)));\n  }\n  .xl\\:space-y-1\\/12> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(8.333333% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(8.333333% * var(--space-y-reverse));\n  }\n  .xl\\:space-x-1\\/12> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(8.333333% * var(--space-x-reverse));\n    margin-left: calc(8.333333% * calc(1 - var(--space-x-reverse)));\n  }\n  .xl\\:space-y-2\\/12> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(16.666667% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(16.666667% * var(--space-y-reverse));\n  }\n  .xl\\:space-x-2\\/12> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(16.666667% * var(--space-x-reverse));\n    margin-left: calc(16.666667% * calc(1 - var(--space-x-reverse)));\n  }\n  .xl\\:space-y-3\\/12> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(25% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(25% * var(--space-y-reverse));\n  }\n  .xl\\:space-x-3\\/12> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(25% * var(--space-x-reverse));\n    margin-left: calc(25% * calc(1 - var(--space-x-reverse)));\n  }\n  .xl\\:space-y-4\\/12> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(33.333333% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(33.333333% * var(--space-y-reverse));\n  }\n  .xl\\:space-x-4\\/12> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(33.333333% * var(--space-x-reverse));\n    margin-left: calc(33.333333% * calc(1 - var(--space-x-reverse)));\n  }\n  .xl\\:space-y-5\\/12> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(41.666667% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(41.666667% * var(--space-y-reverse));\n  }\n  .xl\\:space-x-5\\/12> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(41.666667% * var(--space-x-reverse));\n    margin-left: calc(41.666667% * calc(1 - var(--space-x-reverse)));\n  }\n  .xl\\:space-y-6\\/12> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(50% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(50% * var(--space-y-reverse));\n  }\n  .xl\\:space-x-6\\/12> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(50% * var(--space-x-reverse));\n    margin-left: calc(50% * calc(1 - var(--space-x-reverse)));\n  }\n  .xl\\:space-y-7\\/12> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(58.333333% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(58.333333% * var(--space-y-reverse));\n  }\n  .xl\\:space-x-7\\/12> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(58.333333% * var(--space-x-reverse));\n    margin-left: calc(58.333333% * calc(1 - var(--space-x-reverse)));\n  }\n  .xl\\:space-y-8\\/12> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(66.666667% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(66.666667% * var(--space-y-reverse));\n  }\n  .xl\\:space-x-8\\/12> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(66.666667% * var(--space-x-reverse));\n    margin-left: calc(66.666667% * calc(1 - var(--space-x-reverse)));\n  }\n  .xl\\:space-y-9\\/12> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(75% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(75% * var(--space-y-reverse));\n  }\n  .xl\\:space-x-9\\/12> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(75% * var(--space-x-reverse));\n    margin-left: calc(75% * calc(1 - var(--space-x-reverse)));\n  }\n  .xl\\:space-y-10\\/12> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(83.333333% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(83.333333% * var(--space-y-reverse));\n  }\n  .xl\\:space-x-10\\/12> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(83.333333% * var(--space-x-reverse));\n    margin-left: calc(83.333333% * calc(1 - var(--space-x-reverse)));\n  }\n  .xl\\:space-y-11\\/12> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(91.666667% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(91.666667% * var(--space-y-reverse));\n  }\n  .xl\\:space-x-11\\/12> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(91.666667% * var(--space-x-reverse));\n    margin-left: calc(91.666667% * calc(1 - var(--space-x-reverse)));\n  }\n  .xl\\:space-y-full> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(100% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(100% * var(--space-y-reverse));\n  }\n  .xl\\:space-x-full> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(100% * var(--space-x-reverse));\n    margin-left: calc(100% * calc(1 - var(--space-x-reverse)));\n  }\n  .xl\\:-space-y-1> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-0.25rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-0.25rem * var(--space-y-reverse));\n  }\n  .xl\\:-space-x-1> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-0.25rem * var(--space-x-reverse));\n    margin-left: calc(-0.25rem * calc(1 - var(--space-x-reverse)));\n  }\n  .xl\\:-space-y-2> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-0.5rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-0.5rem * var(--space-y-reverse));\n  }\n  .xl\\:-space-x-2> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-0.5rem * var(--space-x-reverse));\n    margin-left: calc(-0.5rem * calc(1 - var(--space-x-reverse)));\n  }\n  .xl\\:-space-y-3> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-0.75rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-0.75rem * var(--space-y-reverse));\n  }\n  .xl\\:-space-x-3> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-0.75rem * var(--space-x-reverse));\n    margin-left: calc(-0.75rem * calc(1 - var(--space-x-reverse)));\n  }\n  .xl\\:-space-y-4> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-1rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-1rem * var(--space-y-reverse));\n  }\n  .xl\\:-space-x-4> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-1rem * var(--space-x-reverse));\n    margin-left: calc(-1rem * calc(1 - var(--space-x-reverse)));\n  }\n  .xl\\:-space-y-5> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-1.25rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-1.25rem * var(--space-y-reverse));\n  }\n  .xl\\:-space-x-5> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-1.25rem * var(--space-x-reverse));\n    margin-left: calc(-1.25rem * calc(1 - var(--space-x-reverse)));\n  }\n  .xl\\:-space-y-6> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-1.5rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-1.5rem * var(--space-y-reverse));\n  }\n  .xl\\:-space-x-6> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-1.5rem * var(--space-x-reverse));\n    margin-left: calc(-1.5rem * calc(1 - var(--space-x-reverse)));\n  }\n  .xl\\:-space-y-7> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-1.75rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-1.75rem * var(--space-y-reverse));\n  }\n  .xl\\:-space-x-7> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-1.75rem * var(--space-x-reverse));\n    margin-left: calc(-1.75rem * calc(1 - var(--space-x-reverse)));\n  }\n  .xl\\:-space-y-8> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-2rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-2rem * var(--space-y-reverse));\n  }\n  .xl\\:-space-x-8> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-2rem * var(--space-x-reverse));\n    margin-left: calc(-2rem * calc(1 - var(--space-x-reverse)));\n  }\n  .xl\\:-space-y-9> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-2.25rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-2.25rem * var(--space-y-reverse));\n  }\n  .xl\\:-space-x-9> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-2.25rem * var(--space-x-reverse));\n    margin-left: calc(-2.25rem * calc(1 - var(--space-x-reverse)));\n  }\n  .xl\\:-space-y-10> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-2.5rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-2.5rem * var(--space-y-reverse));\n  }\n  .xl\\:-space-x-10> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-2.5rem * var(--space-x-reverse));\n    margin-left: calc(-2.5rem * calc(1 - var(--space-x-reverse)));\n  }\n  .xl\\:-space-y-11> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-2.75rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-2.75rem * var(--space-y-reverse));\n  }\n  .xl\\:-space-x-11> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-2.75rem * var(--space-x-reverse));\n    margin-left: calc(-2.75rem * calc(1 - var(--space-x-reverse)));\n  }\n  .xl\\:-space-y-12> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-3rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-3rem * var(--space-y-reverse));\n  }\n  .xl\\:-space-x-12> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-3rem * var(--space-x-reverse));\n    margin-left: calc(-3rem * calc(1 - var(--space-x-reverse)));\n  }\n  .xl\\:-space-y-13> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-3.25rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-3.25rem * var(--space-y-reverse));\n  }\n  .xl\\:-space-x-13> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-3.25rem * var(--space-x-reverse));\n    margin-left: calc(-3.25rem * calc(1 - var(--space-x-reverse)));\n  }\n  .xl\\:-space-y-14> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-3.5rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-3.5rem * var(--space-y-reverse));\n  }\n  .xl\\:-space-x-14> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-3.5rem * var(--space-x-reverse));\n    margin-left: calc(-3.5rem * calc(1 - var(--space-x-reverse)));\n  }\n  .xl\\:-space-y-15> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-3.75rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-3.75rem * var(--space-y-reverse));\n  }\n  .xl\\:-space-x-15> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-3.75rem * var(--space-x-reverse));\n    margin-left: calc(-3.75rem * calc(1 - var(--space-x-reverse)));\n  }\n  .xl\\:-space-y-16> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-4rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-4rem * var(--space-y-reverse));\n  }\n  .xl\\:-space-x-16> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-4rem * var(--space-x-reverse));\n    margin-left: calc(-4rem * calc(1 - var(--space-x-reverse)));\n  }\n  .xl\\:-space-y-20> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-5rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-5rem * var(--space-y-reverse));\n  }\n  .xl\\:-space-x-20> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-5rem * var(--space-x-reverse));\n    margin-left: calc(-5rem * calc(1 - var(--space-x-reverse)));\n  }\n  .xl\\:-space-y-24> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-6rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-6rem * var(--space-y-reverse));\n  }\n  .xl\\:-space-x-24> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-6rem * var(--space-x-reverse));\n    margin-left: calc(-6rem * calc(1 - var(--space-x-reverse)));\n  }\n  .xl\\:-space-y-28> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-7rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-7rem * var(--space-y-reverse));\n  }\n  .xl\\:-space-x-28> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-7rem * var(--space-x-reverse));\n    margin-left: calc(-7rem * calc(1 - var(--space-x-reverse)));\n  }\n  .xl\\:-space-y-32> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-8rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-8rem * var(--space-y-reverse));\n  }\n  .xl\\:-space-x-32> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-8rem * var(--space-x-reverse));\n    margin-left: calc(-8rem * calc(1 - var(--space-x-reverse)));\n  }\n  .xl\\:-space-y-36> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-9rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-9rem * var(--space-y-reverse));\n  }\n  .xl\\:-space-x-36> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-9rem * var(--space-x-reverse));\n    margin-left: calc(-9rem * calc(1 - var(--space-x-reverse)));\n  }\n  .xl\\:-space-y-40> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-10rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-10rem * var(--space-y-reverse));\n  }\n  .xl\\:-space-x-40> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-10rem * var(--space-x-reverse));\n    margin-left: calc(-10rem * calc(1 - var(--space-x-reverse)));\n  }\n  .xl\\:-space-y-44> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-11rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-11rem * var(--space-y-reverse));\n  }\n  .xl\\:-space-x-44> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-11rem * var(--space-x-reverse));\n    margin-left: calc(-11rem * calc(1 - var(--space-x-reverse)));\n  }\n  .xl\\:-space-y-48> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-12rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-12rem * var(--space-y-reverse));\n  }\n  .xl\\:-space-x-48> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-12rem * var(--space-x-reverse));\n    margin-left: calc(-12rem * calc(1 - var(--space-x-reverse)));\n  }\n  .xl\\:-space-y-52> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-13rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-13rem * var(--space-y-reverse));\n  }\n  .xl\\:-space-x-52> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-13rem * var(--space-x-reverse));\n    margin-left: calc(-13rem * calc(1 - var(--space-x-reverse)));\n  }\n  .xl\\:-space-y-56> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-14rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-14rem * var(--space-y-reverse));\n  }\n  .xl\\:-space-x-56> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-14rem * var(--space-x-reverse));\n    margin-left: calc(-14rem * calc(1 - var(--space-x-reverse)));\n  }\n  .xl\\:-space-y-60> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-15rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-15rem * var(--space-y-reverse));\n  }\n  .xl\\:-space-x-60> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-15rem * var(--space-x-reverse));\n    margin-left: calc(-15rem * calc(1 - var(--space-x-reverse)));\n  }\n  .xl\\:-space-y-64> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-16rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-16rem * var(--space-y-reverse));\n  }\n  .xl\\:-space-x-64> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-16rem * var(--space-x-reverse));\n    margin-left: calc(-16rem * calc(1 - var(--space-x-reverse)));\n  }\n  .xl\\:-space-y-72> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-18rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-18rem * var(--space-y-reverse));\n  }\n  .xl\\:-space-x-72> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-18rem * var(--space-x-reverse));\n    margin-left: calc(-18rem * calc(1 - var(--space-x-reverse)));\n  }\n  .xl\\:-space-y-80> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-20rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-20rem * var(--space-y-reverse));\n  }\n  .xl\\:-space-x-80> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-20rem * var(--space-x-reverse));\n    margin-left: calc(-20rem * calc(1 - var(--space-x-reverse)));\n  }\n  .xl\\:-space-y-96> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-24rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-24rem * var(--space-y-reverse));\n  }\n  .xl\\:-space-x-96> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-24rem * var(--space-x-reverse));\n    margin-left: calc(-24rem * calc(1 - var(--space-x-reverse)));\n  }\n  .xl\\:-space-y-px> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-1px * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-1px * var(--space-y-reverse));\n  }\n  .xl\\:-space-x-px> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-1px * var(--space-x-reverse));\n    margin-left: calc(-1px * calc(1 - var(--space-x-reverse)));\n  }\n  .xl\\:-space-y-0\\.5> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-0.125rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-0.125rem * var(--space-y-reverse));\n  }\n  .xl\\:-space-x-0\\.5> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-0.125rem * var(--space-x-reverse));\n    margin-left: calc(-0.125rem * calc(1 - var(--space-x-reverse)));\n  }\n  .xl\\:-space-y-1\\.5> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-0.375rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-0.375rem * var(--space-y-reverse));\n  }\n  .xl\\:-space-x-1\\.5> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-0.375rem * var(--space-x-reverse));\n    margin-left: calc(-0.375rem * calc(1 - var(--space-x-reverse)));\n  }\n  .xl\\:-space-y-2\\.5> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-0.625rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-0.625rem * var(--space-y-reverse));\n  }\n  .xl\\:-space-x-2\\.5> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-0.625rem * var(--space-x-reverse));\n    margin-left: calc(-0.625rem * calc(1 - var(--space-x-reverse)));\n  }\n  .xl\\:-space-y-3\\.5> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-0.875rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-0.875rem * var(--space-y-reverse));\n  }\n  .xl\\:-space-x-3\\.5> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-0.875rem * var(--space-x-reverse));\n    margin-left: calc(-0.875rem * calc(1 - var(--space-x-reverse)));\n  }\n  .xl\\:-space-y-1\\/2> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-50% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-50% * var(--space-y-reverse));\n  }\n  .xl\\:-space-x-1\\/2> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-50% * var(--space-x-reverse));\n    margin-left: calc(-50% * calc(1 - var(--space-x-reverse)));\n  }\n  .xl\\:-space-y-1\\/3> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-33.33333% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-33.33333% * var(--space-y-reverse));\n  }\n  .xl\\:-space-x-1\\/3> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-33.33333% * var(--space-x-reverse));\n    margin-left: calc(-33.33333% * calc(1 - var(--space-x-reverse)));\n  }\n  .xl\\:-space-y-2\\/3> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-66.66667% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-66.66667% * var(--space-y-reverse));\n  }\n  .xl\\:-space-x-2\\/3> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-66.66667% * var(--space-x-reverse));\n    margin-left: calc(-66.66667% * calc(1 - var(--space-x-reverse)));\n  }\n  .xl\\:-space-y-1\\/4> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-25% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-25% * var(--space-y-reverse));\n  }\n  .xl\\:-space-x-1\\/4> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-25% * var(--space-x-reverse));\n    margin-left: calc(-25% * calc(1 - var(--space-x-reverse)));\n  }\n  .xl\\:-space-y-2\\/4> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-50% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-50% * var(--space-y-reverse));\n  }\n  .xl\\:-space-x-2\\/4> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-50% * var(--space-x-reverse));\n    margin-left: calc(-50% * calc(1 - var(--space-x-reverse)));\n  }\n  .xl\\:-space-y-3\\/4> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-75% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-75% * var(--space-y-reverse));\n  }\n  .xl\\:-space-x-3\\/4> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-75% * var(--space-x-reverse));\n    margin-left: calc(-75% * calc(1 - var(--space-x-reverse)));\n  }\n  .xl\\:-space-y-1\\/5> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-20% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-20% * var(--space-y-reverse));\n  }\n  .xl\\:-space-x-1\\/5> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-20% * var(--space-x-reverse));\n    margin-left: calc(-20% * calc(1 - var(--space-x-reverse)));\n  }\n  .xl\\:-space-y-2\\/5> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-40% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-40% * var(--space-y-reverse));\n  }\n  .xl\\:-space-x-2\\/5> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-40% * var(--space-x-reverse));\n    margin-left: calc(-40% * calc(1 - var(--space-x-reverse)));\n  }\n  .xl\\:-space-y-3\\/5> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-60% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-60% * var(--space-y-reverse));\n  }\n  .xl\\:-space-x-3\\/5> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-60% * var(--space-x-reverse));\n    margin-left: calc(-60% * calc(1 - var(--space-x-reverse)));\n  }\n  .xl\\:-space-y-4\\/5> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-80% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-80% * var(--space-y-reverse));\n  }\n  .xl\\:-space-x-4\\/5> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-80% * var(--space-x-reverse));\n    margin-left: calc(-80% * calc(1 - var(--space-x-reverse)));\n  }\n  .xl\\:-space-y-1\\/6> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-16.66667% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-16.66667% * var(--space-y-reverse));\n  }\n  .xl\\:-space-x-1\\/6> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-16.66667% * var(--space-x-reverse));\n    margin-left: calc(-16.66667% * calc(1 - var(--space-x-reverse)));\n  }\n  .xl\\:-space-y-2\\/6> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-33.33333% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-33.33333% * var(--space-y-reverse));\n  }\n  .xl\\:-space-x-2\\/6> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-33.33333% * var(--space-x-reverse));\n    margin-left: calc(-33.33333% * calc(1 - var(--space-x-reverse)));\n  }\n  .xl\\:-space-y-3\\/6> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-50% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-50% * var(--space-y-reverse));\n  }\n  .xl\\:-space-x-3\\/6> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-50% * var(--space-x-reverse));\n    margin-left: calc(-50% * calc(1 - var(--space-x-reverse)));\n  }\n  .xl\\:-space-y-4\\/6> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-66.66667% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-66.66667% * var(--space-y-reverse));\n  }\n  .xl\\:-space-x-4\\/6> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-66.66667% * var(--space-x-reverse));\n    margin-left: calc(-66.66667% * calc(1 - var(--space-x-reverse)));\n  }\n  .xl\\:-space-y-5\\/6> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-83.33333% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-83.33333% * var(--space-y-reverse));\n  }\n  .xl\\:-space-x-5\\/6> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-83.33333% * var(--space-x-reverse));\n    margin-left: calc(-83.33333% * calc(1 - var(--space-x-reverse)));\n  }\n  .xl\\:-space-y-1\\/12> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-8.33333% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-8.33333% * var(--space-y-reverse));\n  }\n  .xl\\:-space-x-1\\/12> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-8.33333% * var(--space-x-reverse));\n    margin-left: calc(-8.33333% * calc(1 - var(--space-x-reverse)));\n  }\n  .xl\\:-space-y-2\\/12> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-16.66667% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-16.66667% * var(--space-y-reverse));\n  }\n  .xl\\:-space-x-2\\/12> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-16.66667% * var(--space-x-reverse));\n    margin-left: calc(-16.66667% * calc(1 - var(--space-x-reverse)));\n  }\n  .xl\\:-space-y-3\\/12> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-25% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-25% * var(--space-y-reverse));\n  }\n  .xl\\:-space-x-3\\/12> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-25% * var(--space-x-reverse));\n    margin-left: calc(-25% * calc(1 - var(--space-x-reverse)));\n  }\n  .xl\\:-space-y-4\\/12> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-33.33333% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-33.33333% * var(--space-y-reverse));\n  }\n  .xl\\:-space-x-4\\/12> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-33.33333% * var(--space-x-reverse));\n    margin-left: calc(-33.33333% * calc(1 - var(--space-x-reverse)));\n  }\n  .xl\\:-space-y-5\\/12> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-41.66667% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-41.66667% * var(--space-y-reverse));\n  }\n  .xl\\:-space-x-5\\/12> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-41.66667% * var(--space-x-reverse));\n    margin-left: calc(-41.66667% * calc(1 - var(--space-x-reverse)));\n  }\n  .xl\\:-space-y-6\\/12> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-50% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-50% * var(--space-y-reverse));\n  }\n  .xl\\:-space-x-6\\/12> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-50% * var(--space-x-reverse));\n    margin-left: calc(-50% * calc(1 - var(--space-x-reverse)));\n  }\n  .xl\\:-space-y-7\\/12> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-58.33333% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-58.33333% * var(--space-y-reverse));\n  }\n  .xl\\:-space-x-7\\/12> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-58.33333% * var(--space-x-reverse));\n    margin-left: calc(-58.33333% * calc(1 - var(--space-x-reverse)));\n  }\n  .xl\\:-space-y-8\\/12> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-66.66667% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-66.66667% * var(--space-y-reverse));\n  }\n  .xl\\:-space-x-8\\/12> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-66.66667% * var(--space-x-reverse));\n    margin-left: calc(-66.66667% * calc(1 - var(--space-x-reverse)));\n  }\n  .xl\\:-space-y-9\\/12> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-75% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-75% * var(--space-y-reverse));\n  }\n  .xl\\:-space-x-9\\/12> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-75% * var(--space-x-reverse));\n    margin-left: calc(-75% * calc(1 - var(--space-x-reverse)));\n  }\n  .xl\\:-space-y-10\\/12> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-83.33333% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-83.33333% * var(--space-y-reverse));\n  }\n  .xl\\:-space-x-10\\/12> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-83.33333% * var(--space-x-reverse));\n    margin-left: calc(-83.33333% * calc(1 - var(--space-x-reverse)));\n  }\n  .xl\\:-space-y-11\\/12> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-91.66667% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-91.66667% * var(--space-y-reverse));\n  }\n  .xl\\:-space-x-11\\/12> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-91.66667% * var(--space-x-reverse));\n    margin-left: calc(-91.66667% * calc(1 - var(--space-x-reverse)));\n  }\n  .xl\\:-space-y-full> :not(template)~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-100% * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-100% * var(--space-y-reverse));\n  }\n  .xl\\:-space-x-full> :not(template)~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-100% * var(--space-x-reverse));\n    margin-left: calc(-100% * calc(1 - var(--space-x-reverse)));\n  }\n  .xl\\:space-y-reverse> :not(template)~ :not(template) {\n    --space-y-reverse: 1;\n  }\n  .xl\\:space-x-reverse> :not(template)~ :not(template) {\n    --space-x-reverse: 1;\n  }\n  .xl\\:divide-y-0> :not(template)~ :not(template) {\n    --divide-y-reverse: 0;\n    border-top-width: calc(0px * calc(1 - var(--divide-y-reverse)));\n    border-bottom-width: calc(0px * var(--divide-y-reverse));\n  }\n  .xl\\:divide-x-0> :not(template)~ :not(template) {\n    --divide-x-reverse: 0;\n    border-right-width: calc(0px * var(--divide-x-reverse));\n    border-left-width: calc(0px * calc(1 - var(--divide-x-reverse)));\n  }\n  .xl\\:divide-y-2> :not(template)~ :not(template) {\n    --divide-y-reverse: 0;\n    border-top-width: calc(2px * calc(1 - var(--divide-y-reverse)));\n    border-bottom-width: calc(2px * var(--divide-y-reverse));\n  }\n  .xl\\:divide-x-2> :not(template)~ :not(template) {\n    --divide-x-reverse: 0;\n    border-right-width: calc(2px * var(--divide-x-reverse));\n    border-left-width: calc(2px * calc(1 - var(--divide-x-reverse)));\n  }\n  .xl\\:divide-y-4> :not(template)~ :not(template) {\n    --divide-y-reverse: 0;\n    border-top-width: calc(4px * calc(1 - var(--divide-y-reverse)));\n    border-bottom-width: calc(4px * var(--divide-y-reverse));\n  }\n  .xl\\:divide-x-4> :not(template)~ :not(template) {\n    --divide-x-reverse: 0;\n    border-right-width: calc(4px * var(--divide-x-reverse));\n    border-left-width: calc(4px * calc(1 - var(--divide-x-reverse)));\n  }\n  .xl\\:divide-y-8> :not(template)~ :not(template) {\n    --divide-y-reverse: 0;\n    border-top-width: calc(8px * calc(1 - var(--divide-y-reverse)));\n    border-bottom-width: calc(8px * var(--divide-y-reverse));\n  }\n  .xl\\:divide-x-8> :not(template)~ :not(template) {\n    --divide-x-reverse: 0;\n    border-right-width: calc(8px * var(--divide-x-reverse));\n    border-left-width: calc(8px * calc(1 - var(--divide-x-reverse)));\n  }\n  .xl\\:divide-y> :not(template)~ :not(template) {\n    --divide-y-reverse: 0;\n    border-top-width: calc(1px * calc(1 - var(--divide-y-reverse)));\n    border-bottom-width: calc(1px * var(--divide-y-reverse));\n  }\n  .xl\\:divide-x> :not(template)~ :not(template) {\n    --divide-x-reverse: 0;\n    border-right-width: calc(1px * var(--divide-x-reverse));\n    border-left-width: calc(1px * calc(1 - var(--divide-x-reverse)));\n  }\n  .xl\\:divide-y-reverse> :not(template)~ :not(template) {\n    --divide-y-reverse: 1;\n  }\n  .xl\\:divide-x-reverse> :not(template)~ :not(template) {\n    --divide-x-reverse: 1;\n  }\n  .xl\\:divide-current> :not(template)~ :not(template) {\n    border-color: currentColor;\n  }\n  .xl\\:divide-transparent> :not(template)~ :not(template) {\n    border-color: transparent;\n  }\n  .xl\\:divide-white> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #ffffff;\n    border-color: rgba(255, 255, 255, var(--divide-opacity));\n  }\n  .xl\\:divide-black> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #000000;\n    border-color: rgba(0, 0, 0, var(--divide-opacity));\n  }\n  .xl\\:divide-gray-50> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #f9fafb;\n    border-color: rgba(249, 250, 251, var(--divide-opacity));\n  }\n  .xl\\:divide-gray-100> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #f4f5f7;\n    border-color: rgba(244, 245, 247, var(--divide-opacity));\n  }\n  .xl\\:divide-gray-200> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #e5e7eb;\n    border-color: rgba(229, 231, 235, var(--divide-opacity));\n  }\n  .xl\\:divide-gray-300> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #d2d6dc;\n    border-color: rgba(210, 214, 220, var(--divide-opacity));\n  }\n  .xl\\:divide-gray-400> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #9fa6b2;\n    border-color: rgba(159, 166, 178, var(--divide-opacity));\n  }\n  .xl\\:divide-gray-500> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #6b7280;\n    border-color: rgba(107, 114, 128, var(--divide-opacity));\n  }\n  .xl\\:divide-gray-600> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #4b5563;\n    border-color: rgba(75, 85, 99, var(--divide-opacity));\n  }\n  .xl\\:divide-gray-700> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #374151;\n    border-color: rgba(55, 65, 81, var(--divide-opacity));\n  }\n  .xl\\:divide-gray-800> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #252f3f;\n    border-color: rgba(37, 47, 63, var(--divide-opacity));\n  }\n  .xl\\:divide-gray-900> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #161e2e;\n    border-color: rgba(22, 30, 46, var(--divide-opacity));\n  }\n  .xl\\:divide-red-50> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #fdf2f2;\n    border-color: rgba(253, 242, 242, var(--divide-opacity));\n  }\n  .xl\\:divide-red-100> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #fde8e8;\n    border-color: rgba(253, 232, 232, var(--divide-opacity));\n  }\n  .xl\\:divide-red-200> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #fbd5d5;\n    border-color: rgba(251, 213, 213, var(--divide-opacity));\n  }\n  .xl\\:divide-red-300> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #f8b4b4;\n    border-color: rgba(248, 180, 180, var(--divide-opacity));\n  }\n  .xl\\:divide-red-400> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #f98080;\n    border-color: rgba(249, 128, 128, var(--divide-opacity));\n  }\n  .xl\\:divide-red-500> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #f05252;\n    border-color: rgba(240, 82, 82, var(--divide-opacity));\n  }\n  .xl\\:divide-red-600> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #e02424;\n    border-color: rgba(224, 36, 36, var(--divide-opacity));\n  }\n  .xl\\:divide-red-700> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #c81e1e;\n    border-color: rgba(200, 30, 30, var(--divide-opacity));\n  }\n  .xl\\:divide-red-800> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #9b1c1c;\n    border-color: rgba(155, 28, 28, var(--divide-opacity));\n  }\n  .xl\\:divide-red-900> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #771d1d;\n    border-color: rgba(119, 29, 29, var(--divide-opacity));\n  }\n  .xl\\:divide-orange-50> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #fff8f1;\n    border-color: rgba(255, 248, 241, var(--divide-opacity));\n  }\n  .xl\\:divide-orange-100> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #feecdc;\n    border-color: rgba(254, 236, 220, var(--divide-opacity));\n  }\n  .xl\\:divide-orange-200> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #fcd9bd;\n    border-color: rgba(252, 217, 189, var(--divide-opacity));\n  }\n  .xl\\:divide-orange-300> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #fdba8c;\n    border-color: rgba(253, 186, 140, var(--divide-opacity));\n  }\n  .xl\\:divide-orange-400> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #ff8a4c;\n    border-color: rgba(255, 138, 76, var(--divide-opacity));\n  }\n  .xl\\:divide-orange-500> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #ff5a1f;\n    border-color: rgba(255, 90, 31, var(--divide-opacity));\n  }\n  .xl\\:divide-orange-600> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #d03801;\n    border-color: rgba(208, 56, 1, var(--divide-opacity));\n  }\n  .xl\\:divide-orange-700> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #b43403;\n    border-color: rgba(180, 52, 3, var(--divide-opacity));\n  }\n  .xl\\:divide-orange-800> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #8a2c0d;\n    border-color: rgba(138, 44, 13, var(--divide-opacity));\n  }\n  .xl\\:divide-orange-900> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #73230d;\n    border-color: rgba(115, 35, 13, var(--divide-opacity));\n  }\n  .xl\\:divide-yellow-50> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #fdfdea;\n    border-color: rgba(253, 253, 234, var(--divide-opacity));\n  }\n  .xl\\:divide-yellow-100> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #fdf6b2;\n    border-color: rgba(253, 246, 178, var(--divide-opacity));\n  }\n  .xl\\:divide-yellow-200> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #fce96a;\n    border-color: rgba(252, 233, 106, var(--divide-opacity));\n  }\n  .xl\\:divide-yellow-300> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #faca15;\n    border-color: rgba(250, 202, 21, var(--divide-opacity));\n  }\n  .xl\\:divide-yellow-400> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #e3a008;\n    border-color: rgba(227, 160, 8, var(--divide-opacity));\n  }\n  .xl\\:divide-yellow-500> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #c27803;\n    border-color: rgba(194, 120, 3, var(--divide-opacity));\n  }\n  .xl\\:divide-yellow-600> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #9f580a;\n    border-color: rgba(159, 88, 10, var(--divide-opacity));\n  }\n  .xl\\:divide-yellow-700> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #8e4b10;\n    border-color: rgba(142, 75, 16, var(--divide-opacity));\n  }\n  .xl\\:divide-yellow-800> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #723b13;\n    border-color: rgba(114, 59, 19, var(--divide-opacity));\n  }\n  .xl\\:divide-yellow-900> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #633112;\n    border-color: rgba(99, 49, 18, var(--divide-opacity));\n  }\n  .xl\\:divide-green-50> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #f3faf7;\n    border-color: rgba(243, 250, 247, var(--divide-opacity));\n  }\n  .xl\\:divide-green-100> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #def7ec;\n    border-color: rgba(222, 247, 236, var(--divide-opacity));\n  }\n  .xl\\:divide-green-200> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #bcf0da;\n    border-color: rgba(188, 240, 218, var(--divide-opacity));\n  }\n  .xl\\:divide-green-300> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #84e1bc;\n    border-color: rgba(132, 225, 188, var(--divide-opacity));\n  }\n  .xl\\:divide-green-400> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #31c48d;\n    border-color: rgba(49, 196, 141, var(--divide-opacity));\n  }\n  .xl\\:divide-green-500> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #0e9f6e;\n    border-color: rgba(14, 159, 110, var(--divide-opacity));\n  }\n  .xl\\:divide-green-600> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #057a55;\n    border-color: rgba(5, 122, 85, var(--divide-opacity));\n  }\n  .xl\\:divide-green-700> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #046c4e;\n    border-color: rgba(4, 108, 78, var(--divide-opacity));\n  }\n  .xl\\:divide-green-800> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #03543f;\n    border-color: rgba(3, 84, 63, var(--divide-opacity));\n  }\n  .xl\\:divide-green-900> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #014737;\n    border-color: rgba(1, 71, 55, var(--divide-opacity));\n  }\n  .xl\\:divide-teal-50> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #edfafa;\n    border-color: rgba(237, 250, 250, var(--divide-opacity));\n  }\n  .xl\\:divide-teal-100> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #d5f5f6;\n    border-color: rgba(213, 245, 246, var(--divide-opacity));\n  }\n  .xl\\:divide-teal-200> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #afecef;\n    border-color: rgba(175, 236, 239, var(--divide-opacity));\n  }\n  .xl\\:divide-teal-300> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #7edce2;\n    border-color: rgba(126, 220, 226, var(--divide-opacity));\n  }\n  .xl\\:divide-teal-400> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #16bdca;\n    border-color: rgba(22, 189, 202, var(--divide-opacity));\n  }\n  .xl\\:divide-teal-500> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #0694a2;\n    border-color: rgba(6, 148, 162, var(--divide-opacity));\n  }\n  .xl\\:divide-teal-600> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #047481;\n    border-color: rgba(4, 116, 129, var(--divide-opacity));\n  }\n  .xl\\:divide-teal-700> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #036672;\n    border-color: rgba(3, 102, 114, var(--divide-opacity));\n  }\n  .xl\\:divide-teal-800> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #05505c;\n    border-color: rgba(5, 80, 92, var(--divide-opacity));\n  }\n  .xl\\:divide-teal-900> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #014451;\n    border-color: rgba(1, 68, 81, var(--divide-opacity));\n  }\n  .xl\\:divide-blue-50> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #ebf5ff;\n    border-color: rgba(235, 245, 255, var(--divide-opacity));\n  }\n  .xl\\:divide-blue-100> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #e1effe;\n    border-color: rgba(225, 239, 254, var(--divide-opacity));\n  }\n  .xl\\:divide-blue-200> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #c3ddfd;\n    border-color: rgba(195, 221, 253, var(--divide-opacity));\n  }\n  .xl\\:divide-blue-300> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #a4cafe;\n    border-color: rgba(164, 202, 254, var(--divide-opacity));\n  }\n  .xl\\:divide-blue-400> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #76a9fa;\n    border-color: rgba(118, 169, 250, var(--divide-opacity));\n  }\n  .xl\\:divide-blue-500> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #3f83f8;\n    border-color: rgba(63, 131, 248, var(--divide-opacity));\n  }\n  .xl\\:divide-blue-600> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #1c64f2;\n    border-color: rgba(28, 100, 242, var(--divide-opacity));\n  }\n  .xl\\:divide-blue-700> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #1a56db;\n    border-color: rgba(26, 86, 219, var(--divide-opacity));\n  }\n  .xl\\:divide-blue-800> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #1e429f;\n    border-color: rgba(30, 66, 159, var(--divide-opacity));\n  }\n  .xl\\:divide-blue-900> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #233876;\n    border-color: rgba(35, 56, 118, var(--divide-opacity));\n  }\n  .xl\\:divide-indigo-50> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #f0f5ff;\n    border-color: rgba(240, 245, 255, var(--divide-opacity));\n  }\n  .xl\\:divide-indigo-100> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #e5edff;\n    border-color: rgba(229, 237, 255, var(--divide-opacity));\n  }\n  .xl\\:divide-indigo-200> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #cddbfe;\n    border-color: rgba(205, 219, 254, var(--divide-opacity));\n  }\n  .xl\\:divide-indigo-300> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #b4c6fc;\n    border-color: rgba(180, 198, 252, var(--divide-opacity));\n  }\n  .xl\\:divide-indigo-400> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #8da2fb;\n    border-color: rgba(141, 162, 251, var(--divide-opacity));\n  }\n  .xl\\:divide-indigo-500> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #6875f5;\n    border-color: rgba(104, 117, 245, var(--divide-opacity));\n  }\n  .xl\\:divide-indigo-600> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #5850ec;\n    border-color: rgba(88, 80, 236, var(--divide-opacity));\n  }\n  .xl\\:divide-indigo-700> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #5145cd;\n    border-color: rgba(81, 69, 205, var(--divide-opacity));\n  }\n  .xl\\:divide-indigo-800> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #42389d;\n    border-color: rgba(66, 56, 157, var(--divide-opacity));\n  }\n  .xl\\:divide-indigo-900> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #362f78;\n    border-color: rgba(54, 47, 120, var(--divide-opacity));\n  }\n  .xl\\:divide-purple-50> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #f6f5ff;\n    border-color: rgba(246, 245, 255, var(--divide-opacity));\n  }\n  .xl\\:divide-purple-100> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #edebfe;\n    border-color: rgba(237, 235, 254, var(--divide-opacity));\n  }\n  .xl\\:divide-purple-200> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #dcd7fe;\n    border-color: rgba(220, 215, 254, var(--divide-opacity));\n  }\n  .xl\\:divide-purple-300> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #cabffd;\n    border-color: rgba(202, 191, 253, var(--divide-opacity));\n  }\n  .xl\\:divide-purple-400> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #ac94fa;\n    border-color: rgba(172, 148, 250, var(--divide-opacity));\n  }\n  .xl\\:divide-purple-500> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #9061f9;\n    border-color: rgba(144, 97, 249, var(--divide-opacity));\n  }\n  .xl\\:divide-purple-600> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #7e3af2;\n    border-color: rgba(126, 58, 242, var(--divide-opacity));\n  }\n  .xl\\:divide-purple-700> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #6c2bd9;\n    border-color: rgba(108, 43, 217, var(--divide-opacity));\n  }\n  .xl\\:divide-purple-800> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #5521b5;\n    border-color: rgba(85, 33, 181, var(--divide-opacity));\n  }\n  .xl\\:divide-purple-900> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #4a1d96;\n    border-color: rgba(74, 29, 150, var(--divide-opacity));\n  }\n  .xl\\:divide-pink-50> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #fdf2f8;\n    border-color: rgba(253, 242, 248, var(--divide-opacity));\n  }\n  .xl\\:divide-pink-100> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #fce8f3;\n    border-color: rgba(252, 232, 243, var(--divide-opacity));\n  }\n  .xl\\:divide-pink-200> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #fad1e8;\n    border-color: rgba(250, 209, 232, var(--divide-opacity));\n  }\n  .xl\\:divide-pink-300> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #f8b4d9;\n    border-color: rgba(248, 180, 217, var(--divide-opacity));\n  }\n  .xl\\:divide-pink-400> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #f17eb8;\n    border-color: rgba(241, 126, 184, var(--divide-opacity));\n  }\n  .xl\\:divide-pink-500> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #e74694;\n    border-color: rgba(231, 70, 148, var(--divide-opacity));\n  }\n  .xl\\:divide-pink-600> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #d61f69;\n    border-color: rgba(214, 31, 105, var(--divide-opacity));\n  }\n  .xl\\:divide-pink-700> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #bf125d;\n    border-color: rgba(191, 18, 93, var(--divide-opacity));\n  }\n  .xl\\:divide-pink-800> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #99154b;\n    border-color: rgba(153, 21, 75, var(--divide-opacity));\n  }\n  .xl\\:divide-pink-900> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #751a3d;\n    border-color: rgba(117, 26, 61, var(--divide-opacity));\n  }\n  .xl\\:divide-cool-gray-50> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #f8fafc;\n    border-color: rgba(248, 250, 252, var(--divide-opacity));\n  }\n  .xl\\:divide-cool-gray-100> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #f1f5f9;\n    border-color: rgba(241, 245, 249, var(--divide-opacity));\n  }\n  .xl\\:divide-cool-gray-200> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #e2e8f0;\n    border-color: rgba(226, 232, 240, var(--divide-opacity));\n  }\n  .xl\\:divide-cool-gray-300> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #cfd8e3;\n    border-color: rgba(207, 216, 227, var(--divide-opacity));\n  }\n  .xl\\:divide-cool-gray-400> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #97a6ba;\n    border-color: rgba(151, 166, 186, var(--divide-opacity));\n  }\n  .xl\\:divide-cool-gray-500> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #64748b;\n    border-color: rgba(100, 116, 139, var(--divide-opacity));\n  }\n  .xl\\:divide-cool-gray-600> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #475569;\n    border-color: rgba(71, 85, 105, var(--divide-opacity));\n  }\n  .xl\\:divide-cool-gray-700> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #364152;\n    border-color: rgba(54, 65, 82, var(--divide-opacity));\n  }\n  .xl\\:divide-cool-gray-800> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #27303f;\n    border-color: rgba(39, 48, 63, var(--divide-opacity));\n  }\n  .xl\\:divide-cool-gray-900> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #1a202e;\n    border-color: rgba(26, 32, 46, var(--divide-opacity));\n  }\n  .xl\\:divide-solid> :not(template)~ :not(template) {\n    border-style: solid;\n  }\n  .xl\\:divide-dashed> :not(template)~ :not(template) {\n    border-style: dashed;\n  }\n  .xl\\:divide-dotted> :not(template)~ :not(template) {\n    border-style: dotted;\n  }\n  .xl\\:divide-double> :not(template)~ :not(template) {\n    border-style: double;\n  }\n  .xl\\:divide-none> :not(template)~ :not(template) {\n    border-style: none;\n  }\n  .xl\\:divide-opacity-0> :not(template)~ :not(template) {\n    --divide-opacity: 0;\n  }\n  .xl\\:divide-opacity-25> :not(template)~ :not(template) {\n    --divide-opacity: 0.25;\n  }\n  .xl\\:divide-opacity-50> :not(template)~ :not(template) {\n    --divide-opacity: 0.5;\n  }\n  .xl\\:divide-opacity-75> :not(template)~ :not(template) {\n    --divide-opacity: 0.75;\n  }\n  .xl\\:divide-opacity-100> :not(template)~ :not(template) {\n    --divide-opacity: 1;\n  }\n  .xl\\:sr-only {\n    position: absolute;\n    width: 1px;\n    height: 1px;\n    padding: 0;\n    margin: -1px;\n    overflow: hidden;\n    clip: rect(0, 0, 0, 0);\n    white-space: nowrap;\n    border-width: 0;\n  }\n  .xl\\:not-sr-only {\n    position: static;\n    width: auto;\n    height: auto;\n    padding: 0;\n    margin: 0;\n    overflow: visible;\n    clip: auto;\n    white-space: normal;\n  }\n  .xl\\:focus\\:sr-only:focus {\n    position: absolute;\n    width: 1px;\n    height: 1px;\n    padding: 0;\n    margin: -1px;\n    overflow: hidden;\n    clip: rect(0, 0, 0, 0);\n    white-space: nowrap;\n    border-width: 0;\n  }\n  .xl\\:focus\\:not-sr-only:focus {\n    position: static;\n    width: auto;\n    height: auto;\n    padding: 0;\n    margin: 0;\n    overflow: visible;\n    clip: auto;\n    white-space: normal;\n  }\n  .xl\\:appearance-none {\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    appearance: none;\n  }\n  .xl\\:bg-fixed {\n    background-attachment: fixed;\n  }\n  .xl\\:bg-local {\n    background-attachment: local;\n  }\n  .xl\\:bg-scroll {\n    background-attachment: scroll;\n  }\n  .xl\\:bg-clip-border {\n    background-clip: border-box;\n  }\n  .xl\\:bg-clip-padding {\n    background-clip: padding-box;\n  }\n  .xl\\:bg-clip-content {\n    background-clip: content-box;\n  }\n  .xl\\:bg-clip-text {\n    -webkit-background-clip: text;\n    background-clip: text;\n  }\n  .xl\\:bg-current {\n    background-color: currentColor;\n  }\n  .xl\\:bg-transparent {\n    background-color: transparent;\n  }\n  .xl\\:bg-white {\n    --bg-opacity: 1;\n    background-color: #ffffff;\n    background-color: rgba(255, 255, 255, var(--bg-opacity));\n  }\n  .xl\\:bg-black {\n    --bg-opacity: 1;\n    background-color: #000000;\n    background-color: rgba(0, 0, 0, var(--bg-opacity));\n  }\n  .xl\\:bg-gray-50 {\n    --bg-opacity: 1;\n    background-color: #f9fafb;\n    background-color: rgba(249, 250, 251, var(--bg-opacity));\n  }\n  .xl\\:bg-gray-100 {\n    --bg-opacity: 1;\n    background-color: #f4f5f7;\n    background-color: rgba(244, 245, 247, var(--bg-opacity));\n  }\n  .xl\\:bg-gray-200 {\n    --bg-opacity: 1;\n    background-color: #e5e7eb;\n    background-color: rgba(229, 231, 235, var(--bg-opacity));\n  }\n  .xl\\:bg-gray-300 {\n    --bg-opacity: 1;\n    background-color: #d2d6dc;\n    background-color: rgba(210, 214, 220, var(--bg-opacity));\n  }\n  .xl\\:bg-gray-400 {\n    --bg-opacity: 1;\n    background-color: #9fa6b2;\n    background-color: rgba(159, 166, 178, var(--bg-opacity));\n  }\n  .xl\\:bg-gray-500 {\n    --bg-opacity: 1;\n    background-color: #6b7280;\n    background-color: rgba(107, 114, 128, var(--bg-opacity));\n  }\n  .xl\\:bg-gray-600 {\n    --bg-opacity: 1;\n    background-color: #4b5563;\n    background-color: rgba(75, 85, 99, var(--bg-opacity));\n  }\n  .xl\\:bg-gray-700 {\n    --bg-opacity: 1;\n    background-color: #374151;\n    background-color: rgba(55, 65, 81, var(--bg-opacity));\n  }\n  .xl\\:bg-gray-800 {\n    --bg-opacity: 1;\n    background-color: #252f3f;\n    background-color: rgba(37, 47, 63, var(--bg-opacity));\n  }\n  .xl\\:bg-gray-900 {\n    --bg-opacity: 1;\n    background-color: #161e2e;\n    background-color: rgba(22, 30, 46, var(--bg-opacity));\n  }\n  .xl\\:bg-red-50 {\n    --bg-opacity: 1;\n    background-color: #fdf2f2;\n    background-color: rgba(253, 242, 242, var(--bg-opacity));\n  }\n  .xl\\:bg-red-100 {\n    --bg-opacity: 1;\n    background-color: #fde8e8;\n    background-color: rgba(253, 232, 232, var(--bg-opacity));\n  }\n  .xl\\:bg-red-200 {\n    --bg-opacity: 1;\n    background-color: #fbd5d5;\n    background-color: rgba(251, 213, 213, var(--bg-opacity));\n  }\n  .xl\\:bg-red-300 {\n    --bg-opacity: 1;\n    background-color: #f8b4b4;\n    background-color: rgba(248, 180, 180, var(--bg-opacity));\n  }\n  .xl\\:bg-red-400 {\n    --bg-opacity: 1;\n    background-color: #f98080;\n    background-color: rgba(249, 128, 128, var(--bg-opacity));\n  }\n  .xl\\:bg-red-500 {\n    --bg-opacity: 1;\n    background-color: #f05252;\n    background-color: rgba(240, 82, 82, var(--bg-opacity));\n  }\n  .xl\\:bg-red-600 {\n    --bg-opacity: 1;\n    background-color: #e02424;\n    background-color: rgba(224, 36, 36, var(--bg-opacity));\n  }\n  .xl\\:bg-red-700 {\n    --bg-opacity: 1;\n    background-color: #c81e1e;\n    background-color: rgba(200, 30, 30, var(--bg-opacity));\n  }\n  .xl\\:bg-red-800 {\n    --bg-opacity: 1;\n    background-color: #9b1c1c;\n    background-color: rgba(155, 28, 28, var(--bg-opacity));\n  }\n  .xl\\:bg-red-900 {\n    --bg-opacity: 1;\n    background-color: #771d1d;\n    background-color: rgba(119, 29, 29, var(--bg-opacity));\n  }\n  .xl\\:bg-orange-50 {\n    --bg-opacity: 1;\n    background-color: #fff8f1;\n    background-color: rgba(255, 248, 241, var(--bg-opacity));\n  }\n  .xl\\:bg-orange-100 {\n    --bg-opacity: 1;\n    background-color: #feecdc;\n    background-color: rgba(254, 236, 220, var(--bg-opacity));\n  }\n  .xl\\:bg-orange-200 {\n    --bg-opacity: 1;\n    background-color: #fcd9bd;\n    background-color: rgba(252, 217, 189, var(--bg-opacity));\n  }\n  .xl\\:bg-orange-300 {\n    --bg-opacity: 1;\n    background-color: #fdba8c;\n    background-color: rgba(253, 186, 140, var(--bg-opacity));\n  }\n  .xl\\:bg-orange-400 {\n    --bg-opacity: 1;\n    background-color: #ff8a4c;\n    background-color: rgba(255, 138, 76, var(--bg-opacity));\n  }\n  .xl\\:bg-orange-500 {\n    --bg-opacity: 1;\n    background-color: #ff5a1f;\n    background-color: rgba(255, 90, 31, var(--bg-opacity));\n  }\n  .xl\\:bg-orange-600 {\n    --bg-opacity: 1;\n    background-color: #d03801;\n    background-color: rgba(208, 56, 1, var(--bg-opacity));\n  }\n  .xl\\:bg-orange-700 {\n    --bg-opacity: 1;\n    background-color: #b43403;\n    background-color: rgba(180, 52, 3, var(--bg-opacity));\n  }\n  .xl\\:bg-orange-800 {\n    --bg-opacity: 1;\n    background-color: #8a2c0d;\n    background-color: rgba(138, 44, 13, var(--bg-opacity));\n  }\n  .xl\\:bg-orange-900 {\n    --bg-opacity: 1;\n    background-color: #73230d;\n    background-color: rgba(115, 35, 13, var(--bg-opacity));\n  }\n  .xl\\:bg-yellow-50 {\n    --bg-opacity: 1;\n    background-color: #fdfdea;\n    background-color: rgba(253, 253, 234, var(--bg-opacity));\n  }\n  .xl\\:bg-yellow-100 {\n    --bg-opacity: 1;\n    background-color: #fdf6b2;\n    background-color: rgba(253, 246, 178, var(--bg-opacity));\n  }\n  .xl\\:bg-yellow-200 {\n    --bg-opacity: 1;\n    background-color: #fce96a;\n    background-color: rgba(252, 233, 106, var(--bg-opacity));\n  }\n  .xl\\:bg-yellow-300 {\n    --bg-opacity: 1;\n    background-color: #faca15;\n    background-color: rgba(250, 202, 21, var(--bg-opacity));\n  }\n  .xl\\:bg-yellow-400 {\n    --bg-opacity: 1;\n    background-color: #e3a008;\n    background-color: rgba(227, 160, 8, var(--bg-opacity));\n  }\n  .xl\\:bg-yellow-500 {\n    --bg-opacity: 1;\n    background-color: #c27803;\n    background-color: rgba(194, 120, 3, var(--bg-opacity));\n  }\n  .xl\\:bg-yellow-600 {\n    --bg-opacity: 1;\n    background-color: #9f580a;\n    background-color: rgba(159, 88, 10, var(--bg-opacity));\n  }\n  .xl\\:bg-yellow-700 {\n    --bg-opacity: 1;\n    background-color: #8e4b10;\n    background-color: rgba(142, 75, 16, var(--bg-opacity));\n  }\n  .xl\\:bg-yellow-800 {\n    --bg-opacity: 1;\n    background-color: #723b13;\n    background-color: rgba(114, 59, 19, var(--bg-opacity));\n  }\n  .xl\\:bg-yellow-900 {\n    --bg-opacity: 1;\n    background-color: #633112;\n    background-color: rgba(99, 49, 18, var(--bg-opacity));\n  }\n  .xl\\:bg-green-50 {\n    --bg-opacity: 1;\n    background-color: #f3faf7;\n    background-color: rgba(243, 250, 247, var(--bg-opacity));\n  }\n  .xl\\:bg-green-100 {\n    --bg-opacity: 1;\n    background-color: #def7ec;\n    background-color: rgba(222, 247, 236, var(--bg-opacity));\n  }\n  .xl\\:bg-green-200 {\n    --bg-opacity: 1;\n    background-color: #bcf0da;\n    background-color: rgba(188, 240, 218, var(--bg-opacity));\n  }\n  .xl\\:bg-green-300 {\n    --bg-opacity: 1;\n    background-color: #84e1bc;\n    background-color: rgba(132, 225, 188, var(--bg-opacity));\n  }\n  .xl\\:bg-green-400 {\n    --bg-opacity: 1;\n    background-color: #31c48d;\n    background-color: rgba(49, 196, 141, var(--bg-opacity));\n  }\n  .xl\\:bg-green-500 {\n    --bg-opacity: 1;\n    background-color: #0e9f6e;\n    background-color: rgba(14, 159, 110, var(--bg-opacity));\n  }\n  .xl\\:bg-green-600 {\n    --bg-opacity: 1;\n    background-color: #057a55;\n    background-color: rgba(5, 122, 85, var(--bg-opacity));\n  }\n  .xl\\:bg-green-700 {\n    --bg-opacity: 1;\n    background-color: #046c4e;\n    background-color: rgba(4, 108, 78, var(--bg-opacity));\n  }\n  .xl\\:bg-green-800 {\n    --bg-opacity: 1;\n    background-color: #03543f;\n    background-color: rgba(3, 84, 63, var(--bg-opacity));\n  }\n  .xl\\:bg-green-900 {\n    --bg-opacity: 1;\n    background-color: #014737;\n    background-color: rgba(1, 71, 55, var(--bg-opacity));\n  }\n  .xl\\:bg-teal-50 {\n    --bg-opacity: 1;\n    background-color: #edfafa;\n    background-color: rgba(237, 250, 250, var(--bg-opacity));\n  }\n  .xl\\:bg-teal-100 {\n    --bg-opacity: 1;\n    background-color: #d5f5f6;\n    background-color: rgba(213, 245, 246, var(--bg-opacity));\n  }\n  .xl\\:bg-teal-200 {\n    --bg-opacity: 1;\n    background-color: #afecef;\n    background-color: rgba(175, 236, 239, var(--bg-opacity));\n  }\n  .xl\\:bg-teal-300 {\n    --bg-opacity: 1;\n    background-color: #7edce2;\n    background-color: rgba(126, 220, 226, var(--bg-opacity));\n  }\n  .xl\\:bg-teal-400 {\n    --bg-opacity: 1;\n    background-color: #16bdca;\n    background-color: rgba(22, 189, 202, var(--bg-opacity));\n  }\n  .xl\\:bg-teal-500 {\n    --bg-opacity: 1;\n    background-color: #0694a2;\n    background-color: rgba(6, 148, 162, var(--bg-opacity));\n  }\n  .xl\\:bg-teal-600 {\n    --bg-opacity: 1;\n    background-color: #047481;\n    background-color: rgba(4, 116, 129, var(--bg-opacity));\n  }\n  .xl\\:bg-teal-700 {\n    --bg-opacity: 1;\n    background-color: #036672;\n    background-color: rgba(3, 102, 114, var(--bg-opacity));\n  }\n  .xl\\:bg-teal-800 {\n    --bg-opacity: 1;\n    background-color: #05505c;\n    background-color: rgba(5, 80, 92, var(--bg-opacity));\n  }\n  .xl\\:bg-teal-900 {\n    --bg-opacity: 1;\n    background-color: #014451;\n    background-color: rgba(1, 68, 81, var(--bg-opacity));\n  }\n  .xl\\:bg-blue-50 {\n    --bg-opacity: 1;\n    background-color: #ebf5ff;\n    background-color: rgba(235, 245, 255, var(--bg-opacity));\n  }\n  .xl\\:bg-blue-100 {\n    --bg-opacity: 1;\n    background-color: #e1effe;\n    background-color: rgba(225, 239, 254, var(--bg-opacity));\n  }\n  .xl\\:bg-blue-200 {\n    --bg-opacity: 1;\n    background-color: #c3ddfd;\n    background-color: rgba(195, 221, 253, var(--bg-opacity));\n  }\n  .xl\\:bg-blue-300 {\n    --bg-opacity: 1;\n    background-color: #a4cafe;\n    background-color: rgba(164, 202, 254, var(--bg-opacity));\n  }\n  .xl\\:bg-blue-400 {\n    --bg-opacity: 1;\n    background-color: #76a9fa;\n    background-color: rgba(118, 169, 250, var(--bg-opacity));\n  }\n  .xl\\:bg-blue-500 {\n    --bg-opacity: 1;\n    background-color: #3f83f8;\n    background-color: rgba(63, 131, 248, var(--bg-opacity));\n  }\n  .xl\\:bg-blue-600 {\n    --bg-opacity: 1;\n    background-color: #1c64f2;\n    background-color: rgba(28, 100, 242, var(--bg-opacity));\n  }\n  .xl\\:bg-blue-700 {\n    --bg-opacity: 1;\n    background-color: #1a56db;\n    background-color: rgba(26, 86, 219, var(--bg-opacity));\n  }\n  .xl\\:bg-blue-800 {\n    --bg-opacity: 1;\n    background-color: #1e429f;\n    background-color: rgba(30, 66, 159, var(--bg-opacity));\n  }\n  .xl\\:bg-blue-900 {\n    --bg-opacity: 1;\n    background-color: #233876;\n    background-color: rgba(35, 56, 118, var(--bg-opacity));\n  }\n  .xl\\:bg-indigo-50 {\n    --bg-opacity: 1;\n    background-color: #f0f5ff;\n    background-color: rgba(240, 245, 255, var(--bg-opacity));\n  }\n  .xl\\:bg-indigo-100 {\n    --bg-opacity: 1;\n    background-color: #e5edff;\n    background-color: rgba(229, 237, 255, var(--bg-opacity));\n  }\n  .xl\\:bg-indigo-200 {\n    --bg-opacity: 1;\n    background-color: #cddbfe;\n    background-color: rgba(205, 219, 254, var(--bg-opacity));\n  }\n  .xl\\:bg-indigo-300 {\n    --bg-opacity: 1;\n    background-color: #b4c6fc;\n    background-color: rgba(180, 198, 252, var(--bg-opacity));\n  }\n  .xl\\:bg-indigo-400 {\n    --bg-opacity: 1;\n    background-color: #8da2fb;\n    background-color: rgba(141, 162, 251, var(--bg-opacity));\n  }\n  .xl\\:bg-indigo-500 {\n    --bg-opacity: 1;\n    background-color: #6875f5;\n    background-color: rgba(104, 117, 245, var(--bg-opacity));\n  }\n  .xl\\:bg-indigo-600 {\n    --bg-opacity: 1;\n    background-color: #5850ec;\n    background-color: rgba(88, 80, 236, var(--bg-opacity));\n  }\n  .xl\\:bg-indigo-700 {\n    --bg-opacity: 1;\n    background-color: #5145cd;\n    background-color: rgba(81, 69, 205, var(--bg-opacity));\n  }\n  .xl\\:bg-indigo-800 {\n    --bg-opacity: 1;\n    background-color: #42389d;\n    background-color: rgba(66, 56, 157, var(--bg-opacity));\n  }\n  .xl\\:bg-indigo-900 {\n    --bg-opacity: 1;\n    background-color: #362f78;\n    background-color: rgba(54, 47, 120, var(--bg-opacity));\n  }\n  .xl\\:bg-purple-50 {\n    --bg-opacity: 1;\n    background-color: #f6f5ff;\n    background-color: rgba(246, 245, 255, var(--bg-opacity));\n  }\n  .xl\\:bg-purple-100 {\n    --bg-opacity: 1;\n    background-color: #edebfe;\n    background-color: rgba(237, 235, 254, var(--bg-opacity));\n  }\n  .xl\\:bg-purple-200 {\n    --bg-opacity: 1;\n    background-color: #dcd7fe;\n    background-color: rgba(220, 215, 254, var(--bg-opacity));\n  }\n  .xl\\:bg-purple-300 {\n    --bg-opacity: 1;\n    background-color: #cabffd;\n    background-color: rgba(202, 191, 253, var(--bg-opacity));\n  }\n  .xl\\:bg-purple-400 {\n    --bg-opacity: 1;\n    background-color: #ac94fa;\n    background-color: rgba(172, 148, 250, var(--bg-opacity));\n  }\n  .xl\\:bg-purple-500 {\n    --bg-opacity: 1;\n    background-color: #9061f9;\n    background-color: rgba(144, 97, 249, var(--bg-opacity));\n  }\n  .xl\\:bg-purple-600 {\n    --bg-opacity: 1;\n    background-color: #7e3af2;\n    background-color: rgba(126, 58, 242, var(--bg-opacity));\n  }\n  .xl\\:bg-purple-700 {\n    --bg-opacity: 1;\n    background-color: #6c2bd9;\n    background-color: rgba(108, 43, 217, var(--bg-opacity));\n  }\n  .xl\\:bg-purple-800 {\n    --bg-opacity: 1;\n    background-color: #5521b5;\n    background-color: rgba(85, 33, 181, var(--bg-opacity));\n  }\n  .xl\\:bg-purple-900 {\n    --bg-opacity: 1;\n    background-color: #4a1d96;\n    background-color: rgba(74, 29, 150, var(--bg-opacity));\n  }\n  .xl\\:bg-pink-50 {\n    --bg-opacity: 1;\n    background-color: #fdf2f8;\n    background-color: rgba(253, 242, 248, var(--bg-opacity));\n  }\n  .xl\\:bg-pink-100 {\n    --bg-opacity: 1;\n    background-color: #fce8f3;\n    background-color: rgba(252, 232, 243, var(--bg-opacity));\n  }\n  .xl\\:bg-pink-200 {\n    --bg-opacity: 1;\n    background-color: #fad1e8;\n    background-color: rgba(250, 209, 232, var(--bg-opacity));\n  }\n  .xl\\:bg-pink-300 {\n    --bg-opacity: 1;\n    background-color: #f8b4d9;\n    background-color: rgba(248, 180, 217, var(--bg-opacity));\n  }\n  .xl\\:bg-pink-400 {\n    --bg-opacity: 1;\n    background-color: #f17eb8;\n    background-color: rgba(241, 126, 184, var(--bg-opacity));\n  }\n  .xl\\:bg-pink-500 {\n    --bg-opacity: 1;\n    background-color: #e74694;\n    background-color: rgba(231, 70, 148, var(--bg-opacity));\n  }\n  .xl\\:bg-pink-600 {\n    --bg-opacity: 1;\n    background-color: #d61f69;\n    background-color: rgba(214, 31, 105, var(--bg-opacity));\n  }\n  .xl\\:bg-pink-700 {\n    --bg-opacity: 1;\n    background-color: #bf125d;\n    background-color: rgba(191, 18, 93, var(--bg-opacity));\n  }\n  .xl\\:bg-pink-800 {\n    --bg-opacity: 1;\n    background-color: #99154b;\n    background-color: rgba(153, 21, 75, var(--bg-opacity));\n  }\n  .xl\\:bg-pink-900 {\n    --bg-opacity: 1;\n    background-color: #751a3d;\n    background-color: rgba(117, 26, 61, var(--bg-opacity));\n  }\n  .xl\\:bg-cool-gray-50 {\n    --bg-opacity: 1;\n    background-color: #f8fafc;\n    background-color: rgba(248, 250, 252, var(--bg-opacity));\n  }\n  .xl\\:bg-cool-gray-100 {\n    --bg-opacity: 1;\n    background-color: #f1f5f9;\n    background-color: rgba(241, 245, 249, var(--bg-opacity));\n  }\n  .xl\\:bg-cool-gray-200 {\n    --bg-opacity: 1;\n    background-color: #e2e8f0;\n    background-color: rgba(226, 232, 240, var(--bg-opacity));\n  }\n  .xl\\:bg-cool-gray-300 {\n    --bg-opacity: 1;\n    background-color: #cfd8e3;\n    background-color: rgba(207, 216, 227, var(--bg-opacity));\n  }\n  .xl\\:bg-cool-gray-400 {\n    --bg-opacity: 1;\n    background-color: #97a6ba;\n    background-color: rgba(151, 166, 186, var(--bg-opacity));\n  }\n  .xl\\:bg-cool-gray-500 {\n    --bg-opacity: 1;\n    background-color: #64748b;\n    background-color: rgba(100, 116, 139, var(--bg-opacity));\n  }\n  .xl\\:bg-cool-gray-600 {\n    --bg-opacity: 1;\n    background-color: #475569;\n    background-color: rgba(71, 85, 105, var(--bg-opacity));\n  }\n  .xl\\:bg-cool-gray-700 {\n    --bg-opacity: 1;\n    background-color: #364152;\n    background-color: rgba(54, 65, 82, var(--bg-opacity));\n  }\n  .xl\\:bg-cool-gray-800 {\n    --bg-opacity: 1;\n    background-color: #27303f;\n    background-color: rgba(39, 48, 63, var(--bg-opacity));\n  }\n  .xl\\:bg-cool-gray-900 {\n    --bg-opacity: 1;\n    background-color: #1a202e;\n    background-color: rgba(26, 32, 46, var(--bg-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:bg-current {\n    background-color: currentColor;\n  }\n  .group:hover .xl\\:group-hover\\:bg-transparent {\n    background-color: transparent;\n  }\n  .group:hover .xl\\:group-hover\\:bg-white {\n    --bg-opacity: 1;\n    background-color: #ffffff;\n    background-color: rgba(255, 255, 255, var(--bg-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:bg-black {\n    --bg-opacity: 1;\n    background-color: #000000;\n    background-color: rgba(0, 0, 0, var(--bg-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:bg-gray-50 {\n    --bg-opacity: 1;\n    background-color: #f9fafb;\n    background-color: rgba(249, 250, 251, var(--bg-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:bg-gray-100 {\n    --bg-opacity: 1;\n    background-color: #f4f5f7;\n    background-color: rgba(244, 245, 247, var(--bg-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:bg-gray-200 {\n    --bg-opacity: 1;\n    background-color: #e5e7eb;\n    background-color: rgba(229, 231, 235, var(--bg-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:bg-gray-300 {\n    --bg-opacity: 1;\n    background-color: #d2d6dc;\n    background-color: rgba(210, 214, 220, var(--bg-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:bg-gray-400 {\n    --bg-opacity: 1;\n    background-color: #9fa6b2;\n    background-color: rgba(159, 166, 178, var(--bg-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:bg-gray-500 {\n    --bg-opacity: 1;\n    background-color: #6b7280;\n    background-color: rgba(107, 114, 128, var(--bg-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:bg-gray-600 {\n    --bg-opacity: 1;\n    background-color: #4b5563;\n    background-color: rgba(75, 85, 99, var(--bg-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:bg-gray-700 {\n    --bg-opacity: 1;\n    background-color: #374151;\n    background-color: rgba(55, 65, 81, var(--bg-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:bg-gray-800 {\n    --bg-opacity: 1;\n    background-color: #252f3f;\n    background-color: rgba(37, 47, 63, var(--bg-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:bg-gray-900 {\n    --bg-opacity: 1;\n    background-color: #161e2e;\n    background-color: rgba(22, 30, 46, var(--bg-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:bg-red-50 {\n    --bg-opacity: 1;\n    background-color: #fdf2f2;\n    background-color: rgba(253, 242, 242, var(--bg-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:bg-red-100 {\n    --bg-opacity: 1;\n    background-color: #fde8e8;\n    background-color: rgba(253, 232, 232, var(--bg-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:bg-red-200 {\n    --bg-opacity: 1;\n    background-color: #fbd5d5;\n    background-color: rgba(251, 213, 213, var(--bg-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:bg-red-300 {\n    --bg-opacity: 1;\n    background-color: #f8b4b4;\n    background-color: rgba(248, 180, 180, var(--bg-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:bg-red-400 {\n    --bg-opacity: 1;\n    background-color: #f98080;\n    background-color: rgba(249, 128, 128, var(--bg-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:bg-red-500 {\n    --bg-opacity: 1;\n    background-color: #f05252;\n    background-color: rgba(240, 82, 82, var(--bg-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:bg-red-600 {\n    --bg-opacity: 1;\n    background-color: #e02424;\n    background-color: rgba(224, 36, 36, var(--bg-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:bg-red-700 {\n    --bg-opacity: 1;\n    background-color: #c81e1e;\n    background-color: rgba(200, 30, 30, var(--bg-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:bg-red-800 {\n    --bg-opacity: 1;\n    background-color: #9b1c1c;\n    background-color: rgba(155, 28, 28, var(--bg-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:bg-red-900 {\n    --bg-opacity: 1;\n    background-color: #771d1d;\n    background-color: rgba(119, 29, 29, var(--bg-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:bg-orange-50 {\n    --bg-opacity: 1;\n    background-color: #fff8f1;\n    background-color: rgba(255, 248, 241, var(--bg-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:bg-orange-100 {\n    --bg-opacity: 1;\n    background-color: #feecdc;\n    background-color: rgba(254, 236, 220, var(--bg-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:bg-orange-200 {\n    --bg-opacity: 1;\n    background-color: #fcd9bd;\n    background-color: rgba(252, 217, 189, var(--bg-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:bg-orange-300 {\n    --bg-opacity: 1;\n    background-color: #fdba8c;\n    background-color: rgba(253, 186, 140, var(--bg-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:bg-orange-400 {\n    --bg-opacity: 1;\n    background-color: #ff8a4c;\n    background-color: rgba(255, 138, 76, var(--bg-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:bg-orange-500 {\n    --bg-opacity: 1;\n    background-color: #ff5a1f;\n    background-color: rgba(255, 90, 31, var(--bg-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:bg-orange-600 {\n    --bg-opacity: 1;\n    background-color: #d03801;\n    background-color: rgba(208, 56, 1, var(--bg-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:bg-orange-700 {\n    --bg-opacity: 1;\n    background-color: #b43403;\n    background-color: rgba(180, 52, 3, var(--bg-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:bg-orange-800 {\n    --bg-opacity: 1;\n    background-color: #8a2c0d;\n    background-color: rgba(138, 44, 13, var(--bg-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:bg-orange-900 {\n    --bg-opacity: 1;\n    background-color: #73230d;\n    background-color: rgba(115, 35, 13, var(--bg-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:bg-yellow-50 {\n    --bg-opacity: 1;\n    background-color: #fdfdea;\n    background-color: rgba(253, 253, 234, var(--bg-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:bg-yellow-100 {\n    --bg-opacity: 1;\n    background-color: #fdf6b2;\n    background-color: rgba(253, 246, 178, var(--bg-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:bg-yellow-200 {\n    --bg-opacity: 1;\n    background-color: #fce96a;\n    background-color: rgba(252, 233, 106, var(--bg-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:bg-yellow-300 {\n    --bg-opacity: 1;\n    background-color: #faca15;\n    background-color: rgba(250, 202, 21, var(--bg-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:bg-yellow-400 {\n    --bg-opacity: 1;\n    background-color: #e3a008;\n    background-color: rgba(227, 160, 8, var(--bg-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:bg-yellow-500 {\n    --bg-opacity: 1;\n    background-color: #c27803;\n    background-color: rgba(194, 120, 3, var(--bg-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:bg-yellow-600 {\n    --bg-opacity: 1;\n    background-color: #9f580a;\n    background-color: rgba(159, 88, 10, var(--bg-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:bg-yellow-700 {\n    --bg-opacity: 1;\n    background-color: #8e4b10;\n    background-color: rgba(142, 75, 16, var(--bg-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:bg-yellow-800 {\n    --bg-opacity: 1;\n    background-color: #723b13;\n    background-color: rgba(114, 59, 19, var(--bg-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:bg-yellow-900 {\n    --bg-opacity: 1;\n    background-color: #633112;\n    background-color: rgba(99, 49, 18, var(--bg-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:bg-green-50 {\n    --bg-opacity: 1;\n    background-color: #f3faf7;\n    background-color: rgba(243, 250, 247, var(--bg-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:bg-green-100 {\n    --bg-opacity: 1;\n    background-color: #def7ec;\n    background-color: rgba(222, 247, 236, var(--bg-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:bg-green-200 {\n    --bg-opacity: 1;\n    background-color: #bcf0da;\n    background-color: rgba(188, 240, 218, var(--bg-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:bg-green-300 {\n    --bg-opacity: 1;\n    background-color: #84e1bc;\n    background-color: rgba(132, 225, 188, var(--bg-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:bg-green-400 {\n    --bg-opacity: 1;\n    background-color: #31c48d;\n    background-color: rgba(49, 196, 141, var(--bg-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:bg-green-500 {\n    --bg-opacity: 1;\n    background-color: #0e9f6e;\n    background-color: rgba(14, 159, 110, var(--bg-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:bg-green-600 {\n    --bg-opacity: 1;\n    background-color: #057a55;\n    background-color: rgba(5, 122, 85, var(--bg-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:bg-green-700 {\n    --bg-opacity: 1;\n    background-color: #046c4e;\n    background-color: rgba(4, 108, 78, var(--bg-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:bg-green-800 {\n    --bg-opacity: 1;\n    background-color: #03543f;\n    background-color: rgba(3, 84, 63, var(--bg-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:bg-green-900 {\n    --bg-opacity: 1;\n    background-color: #014737;\n    background-color: rgba(1, 71, 55, var(--bg-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:bg-teal-50 {\n    --bg-opacity: 1;\n    background-color: #edfafa;\n    background-color: rgba(237, 250, 250, var(--bg-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:bg-teal-100 {\n    --bg-opacity: 1;\n    background-color: #d5f5f6;\n    background-color: rgba(213, 245, 246, var(--bg-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:bg-teal-200 {\n    --bg-opacity: 1;\n    background-color: #afecef;\n    background-color: rgba(175, 236, 239, var(--bg-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:bg-teal-300 {\n    --bg-opacity: 1;\n    background-color: #7edce2;\n    background-color: rgba(126, 220, 226, var(--bg-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:bg-teal-400 {\n    --bg-opacity: 1;\n    background-color: #16bdca;\n    background-color: rgba(22, 189, 202, var(--bg-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:bg-teal-500 {\n    --bg-opacity: 1;\n    background-color: #0694a2;\n    background-color: rgba(6, 148, 162, var(--bg-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:bg-teal-600 {\n    --bg-opacity: 1;\n    background-color: #047481;\n    background-color: rgba(4, 116, 129, var(--bg-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:bg-teal-700 {\n    --bg-opacity: 1;\n    background-color: #036672;\n    background-color: rgba(3, 102, 114, var(--bg-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:bg-teal-800 {\n    --bg-opacity: 1;\n    background-color: #05505c;\n    background-color: rgba(5, 80, 92, var(--bg-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:bg-teal-900 {\n    --bg-opacity: 1;\n    background-color: #014451;\n    background-color: rgba(1, 68, 81, var(--bg-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:bg-blue-50 {\n    --bg-opacity: 1;\n    background-color: #ebf5ff;\n    background-color: rgba(235, 245, 255, var(--bg-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:bg-blue-100 {\n    --bg-opacity: 1;\n    background-color: #e1effe;\n    background-color: rgba(225, 239, 254, var(--bg-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:bg-blue-200 {\n    --bg-opacity: 1;\n    background-color: #c3ddfd;\n    background-color: rgba(195, 221, 253, var(--bg-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:bg-blue-300 {\n    --bg-opacity: 1;\n    background-color: #a4cafe;\n    background-color: rgba(164, 202, 254, var(--bg-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:bg-blue-400 {\n    --bg-opacity: 1;\n    background-color: #76a9fa;\n    background-color: rgba(118, 169, 250, var(--bg-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:bg-blue-500 {\n    --bg-opacity: 1;\n    background-color: #3f83f8;\n    background-color: rgba(63, 131, 248, var(--bg-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:bg-blue-600 {\n    --bg-opacity: 1;\n    background-color: #1c64f2;\n    background-color: rgba(28, 100, 242, var(--bg-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:bg-blue-700 {\n    --bg-opacity: 1;\n    background-color: #1a56db;\n    background-color: rgba(26, 86, 219, var(--bg-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:bg-blue-800 {\n    --bg-opacity: 1;\n    background-color: #1e429f;\n    background-color: rgba(30, 66, 159, var(--bg-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:bg-blue-900 {\n    --bg-opacity: 1;\n    background-color: #233876;\n    background-color: rgba(35, 56, 118, var(--bg-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:bg-indigo-50 {\n    --bg-opacity: 1;\n    background-color: #f0f5ff;\n    background-color: rgba(240, 245, 255, var(--bg-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:bg-indigo-100 {\n    --bg-opacity: 1;\n    background-color: #e5edff;\n    background-color: rgba(229, 237, 255, var(--bg-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:bg-indigo-200 {\n    --bg-opacity: 1;\n    background-color: #cddbfe;\n    background-color: rgba(205, 219, 254, var(--bg-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:bg-indigo-300 {\n    --bg-opacity: 1;\n    background-color: #b4c6fc;\n    background-color: rgba(180, 198, 252, var(--bg-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:bg-indigo-400 {\n    --bg-opacity: 1;\n    background-color: #8da2fb;\n    background-color: rgba(141, 162, 251, var(--bg-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:bg-indigo-500 {\n    --bg-opacity: 1;\n    background-color: #6875f5;\n    background-color: rgba(104, 117, 245, var(--bg-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:bg-indigo-600 {\n    --bg-opacity: 1;\n    background-color: #5850ec;\n    background-color: rgba(88, 80, 236, var(--bg-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:bg-indigo-700 {\n    --bg-opacity: 1;\n    background-color: #5145cd;\n    background-color: rgba(81, 69, 205, var(--bg-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:bg-indigo-800 {\n    --bg-opacity: 1;\n    background-color: #42389d;\n    background-color: rgba(66, 56, 157, var(--bg-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:bg-indigo-900 {\n    --bg-opacity: 1;\n    background-color: #362f78;\n    background-color: rgba(54, 47, 120, var(--bg-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:bg-purple-50 {\n    --bg-opacity: 1;\n    background-color: #f6f5ff;\n    background-color: rgba(246, 245, 255, var(--bg-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:bg-purple-100 {\n    --bg-opacity: 1;\n    background-color: #edebfe;\n    background-color: rgba(237, 235, 254, var(--bg-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:bg-purple-200 {\n    --bg-opacity: 1;\n    background-color: #dcd7fe;\n    background-color: rgba(220, 215, 254, var(--bg-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:bg-purple-300 {\n    --bg-opacity: 1;\n    background-color: #cabffd;\n    background-color: rgba(202, 191, 253, var(--bg-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:bg-purple-400 {\n    --bg-opacity: 1;\n    background-color: #ac94fa;\n    background-color: rgba(172, 148, 250, var(--bg-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:bg-purple-500 {\n    --bg-opacity: 1;\n    background-color: #9061f9;\n    background-color: rgba(144, 97, 249, var(--bg-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:bg-purple-600 {\n    --bg-opacity: 1;\n    background-color: #7e3af2;\n    background-color: rgba(126, 58, 242, var(--bg-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:bg-purple-700 {\n    --bg-opacity: 1;\n    background-color: #6c2bd9;\n    background-color: rgba(108, 43, 217, var(--bg-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:bg-purple-800 {\n    --bg-opacity: 1;\n    background-color: #5521b5;\n    background-color: rgba(85, 33, 181, var(--bg-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:bg-purple-900 {\n    --bg-opacity: 1;\n    background-color: #4a1d96;\n    background-color: rgba(74, 29, 150, var(--bg-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:bg-pink-50 {\n    --bg-opacity: 1;\n    background-color: #fdf2f8;\n    background-color: rgba(253, 242, 248, var(--bg-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:bg-pink-100 {\n    --bg-opacity: 1;\n    background-color: #fce8f3;\n    background-color: rgba(252, 232, 243, var(--bg-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:bg-pink-200 {\n    --bg-opacity: 1;\n    background-color: #fad1e8;\n    background-color: rgba(250, 209, 232, var(--bg-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:bg-pink-300 {\n    --bg-opacity: 1;\n    background-color: #f8b4d9;\n    background-color: rgba(248, 180, 217, var(--bg-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:bg-pink-400 {\n    --bg-opacity: 1;\n    background-color: #f17eb8;\n    background-color: rgba(241, 126, 184, var(--bg-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:bg-pink-500 {\n    --bg-opacity: 1;\n    background-color: #e74694;\n    background-color: rgba(231, 70, 148, var(--bg-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:bg-pink-600 {\n    --bg-opacity: 1;\n    background-color: #d61f69;\n    background-color: rgba(214, 31, 105, var(--bg-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:bg-pink-700 {\n    --bg-opacity: 1;\n    background-color: #bf125d;\n    background-color: rgba(191, 18, 93, var(--bg-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:bg-pink-800 {\n    --bg-opacity: 1;\n    background-color: #99154b;\n    background-color: rgba(153, 21, 75, var(--bg-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:bg-pink-900 {\n    --bg-opacity: 1;\n    background-color: #751a3d;\n    background-color: rgba(117, 26, 61, var(--bg-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:bg-cool-gray-50 {\n    --bg-opacity: 1;\n    background-color: #f8fafc;\n    background-color: rgba(248, 250, 252, var(--bg-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:bg-cool-gray-100 {\n    --bg-opacity: 1;\n    background-color: #f1f5f9;\n    background-color: rgba(241, 245, 249, var(--bg-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:bg-cool-gray-200 {\n    --bg-opacity: 1;\n    background-color: #e2e8f0;\n    background-color: rgba(226, 232, 240, var(--bg-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:bg-cool-gray-300 {\n    --bg-opacity: 1;\n    background-color: #cfd8e3;\n    background-color: rgba(207, 216, 227, var(--bg-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:bg-cool-gray-400 {\n    --bg-opacity: 1;\n    background-color: #97a6ba;\n    background-color: rgba(151, 166, 186, var(--bg-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:bg-cool-gray-500 {\n    --bg-opacity: 1;\n    background-color: #64748b;\n    background-color: rgba(100, 116, 139, var(--bg-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:bg-cool-gray-600 {\n    --bg-opacity: 1;\n    background-color: #475569;\n    background-color: rgba(71, 85, 105, var(--bg-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:bg-cool-gray-700 {\n    --bg-opacity: 1;\n    background-color: #364152;\n    background-color: rgba(54, 65, 82, var(--bg-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:bg-cool-gray-800 {\n    --bg-opacity: 1;\n    background-color: #27303f;\n    background-color: rgba(39, 48, 63, var(--bg-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:bg-cool-gray-900 {\n    --bg-opacity: 1;\n    background-color: #1a202e;\n    background-color: rgba(26, 32, 46, var(--bg-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:bg-current {\n    background-color: currentColor;\n  }\n  .group:focus .xl\\:group-focus\\:bg-transparent {\n    background-color: transparent;\n  }\n  .group:focus .xl\\:group-focus\\:bg-white {\n    --bg-opacity: 1;\n    background-color: #ffffff;\n    background-color: rgba(255, 255, 255, var(--bg-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:bg-black {\n    --bg-opacity: 1;\n    background-color: #000000;\n    background-color: rgba(0, 0, 0, var(--bg-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:bg-gray-50 {\n    --bg-opacity: 1;\n    background-color: #f9fafb;\n    background-color: rgba(249, 250, 251, var(--bg-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:bg-gray-100 {\n    --bg-opacity: 1;\n    background-color: #f4f5f7;\n    background-color: rgba(244, 245, 247, var(--bg-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:bg-gray-200 {\n    --bg-opacity: 1;\n    background-color: #e5e7eb;\n    background-color: rgba(229, 231, 235, var(--bg-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:bg-gray-300 {\n    --bg-opacity: 1;\n    background-color: #d2d6dc;\n    background-color: rgba(210, 214, 220, var(--bg-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:bg-gray-400 {\n    --bg-opacity: 1;\n    background-color: #9fa6b2;\n    background-color: rgba(159, 166, 178, var(--bg-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:bg-gray-500 {\n    --bg-opacity: 1;\n    background-color: #6b7280;\n    background-color: rgba(107, 114, 128, var(--bg-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:bg-gray-600 {\n    --bg-opacity: 1;\n    background-color: #4b5563;\n    background-color: rgba(75, 85, 99, var(--bg-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:bg-gray-700 {\n    --bg-opacity: 1;\n    background-color: #374151;\n    background-color: rgba(55, 65, 81, var(--bg-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:bg-gray-800 {\n    --bg-opacity: 1;\n    background-color: #252f3f;\n    background-color: rgba(37, 47, 63, var(--bg-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:bg-gray-900 {\n    --bg-opacity: 1;\n    background-color: #161e2e;\n    background-color: rgba(22, 30, 46, var(--bg-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:bg-red-50 {\n    --bg-opacity: 1;\n    background-color: #fdf2f2;\n    background-color: rgba(253, 242, 242, var(--bg-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:bg-red-100 {\n    --bg-opacity: 1;\n    background-color: #fde8e8;\n    background-color: rgba(253, 232, 232, var(--bg-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:bg-red-200 {\n    --bg-opacity: 1;\n    background-color: #fbd5d5;\n    background-color: rgba(251, 213, 213, var(--bg-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:bg-red-300 {\n    --bg-opacity: 1;\n    background-color: #f8b4b4;\n    background-color: rgba(248, 180, 180, var(--bg-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:bg-red-400 {\n    --bg-opacity: 1;\n    background-color: #f98080;\n    background-color: rgba(249, 128, 128, var(--bg-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:bg-red-500 {\n    --bg-opacity: 1;\n    background-color: #f05252;\n    background-color: rgba(240, 82, 82, var(--bg-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:bg-red-600 {\n    --bg-opacity: 1;\n    background-color: #e02424;\n    background-color: rgba(224, 36, 36, var(--bg-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:bg-red-700 {\n    --bg-opacity: 1;\n    background-color: #c81e1e;\n    background-color: rgba(200, 30, 30, var(--bg-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:bg-red-800 {\n    --bg-opacity: 1;\n    background-color: #9b1c1c;\n    background-color: rgba(155, 28, 28, var(--bg-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:bg-red-900 {\n    --bg-opacity: 1;\n    background-color: #771d1d;\n    background-color: rgba(119, 29, 29, var(--bg-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:bg-orange-50 {\n    --bg-opacity: 1;\n    background-color: #fff8f1;\n    background-color: rgba(255, 248, 241, var(--bg-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:bg-orange-100 {\n    --bg-opacity: 1;\n    background-color: #feecdc;\n    background-color: rgba(254, 236, 220, var(--bg-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:bg-orange-200 {\n    --bg-opacity: 1;\n    background-color: #fcd9bd;\n    background-color: rgba(252, 217, 189, var(--bg-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:bg-orange-300 {\n    --bg-opacity: 1;\n    background-color: #fdba8c;\n    background-color: rgba(253, 186, 140, var(--bg-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:bg-orange-400 {\n    --bg-opacity: 1;\n    background-color: #ff8a4c;\n    background-color: rgba(255, 138, 76, var(--bg-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:bg-orange-500 {\n    --bg-opacity: 1;\n    background-color: #ff5a1f;\n    background-color: rgba(255, 90, 31, var(--bg-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:bg-orange-600 {\n    --bg-opacity: 1;\n    background-color: #d03801;\n    background-color: rgba(208, 56, 1, var(--bg-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:bg-orange-700 {\n    --bg-opacity: 1;\n    background-color: #b43403;\n    background-color: rgba(180, 52, 3, var(--bg-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:bg-orange-800 {\n    --bg-opacity: 1;\n    background-color: #8a2c0d;\n    background-color: rgba(138, 44, 13, var(--bg-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:bg-orange-900 {\n    --bg-opacity: 1;\n    background-color: #73230d;\n    background-color: rgba(115, 35, 13, var(--bg-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:bg-yellow-50 {\n    --bg-opacity: 1;\n    background-color: #fdfdea;\n    background-color: rgba(253, 253, 234, var(--bg-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:bg-yellow-100 {\n    --bg-opacity: 1;\n    background-color: #fdf6b2;\n    background-color: rgba(253, 246, 178, var(--bg-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:bg-yellow-200 {\n    --bg-opacity: 1;\n    background-color: #fce96a;\n    background-color: rgba(252, 233, 106, var(--bg-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:bg-yellow-300 {\n    --bg-opacity: 1;\n    background-color: #faca15;\n    background-color: rgba(250, 202, 21, var(--bg-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:bg-yellow-400 {\n    --bg-opacity: 1;\n    background-color: #e3a008;\n    background-color: rgba(227, 160, 8, var(--bg-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:bg-yellow-500 {\n    --bg-opacity: 1;\n    background-color: #c27803;\n    background-color: rgba(194, 120, 3, var(--bg-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:bg-yellow-600 {\n    --bg-opacity: 1;\n    background-color: #9f580a;\n    background-color: rgba(159, 88, 10, var(--bg-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:bg-yellow-700 {\n    --bg-opacity: 1;\n    background-color: #8e4b10;\n    background-color: rgba(142, 75, 16, var(--bg-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:bg-yellow-800 {\n    --bg-opacity: 1;\n    background-color: #723b13;\n    background-color: rgba(114, 59, 19, var(--bg-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:bg-yellow-900 {\n    --bg-opacity: 1;\n    background-color: #633112;\n    background-color: rgba(99, 49, 18, var(--bg-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:bg-green-50 {\n    --bg-opacity: 1;\n    background-color: #f3faf7;\n    background-color: rgba(243, 250, 247, var(--bg-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:bg-green-100 {\n    --bg-opacity: 1;\n    background-color: #def7ec;\n    background-color: rgba(222, 247, 236, var(--bg-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:bg-green-200 {\n    --bg-opacity: 1;\n    background-color: #bcf0da;\n    background-color: rgba(188, 240, 218, var(--bg-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:bg-green-300 {\n    --bg-opacity: 1;\n    background-color: #84e1bc;\n    background-color: rgba(132, 225, 188, var(--bg-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:bg-green-400 {\n    --bg-opacity: 1;\n    background-color: #31c48d;\n    background-color: rgba(49, 196, 141, var(--bg-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:bg-green-500 {\n    --bg-opacity: 1;\n    background-color: #0e9f6e;\n    background-color: rgba(14, 159, 110, var(--bg-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:bg-green-600 {\n    --bg-opacity: 1;\n    background-color: #057a55;\n    background-color: rgba(5, 122, 85, var(--bg-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:bg-green-700 {\n    --bg-opacity: 1;\n    background-color: #046c4e;\n    background-color: rgba(4, 108, 78, var(--bg-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:bg-green-800 {\n    --bg-opacity: 1;\n    background-color: #03543f;\n    background-color: rgba(3, 84, 63, var(--bg-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:bg-green-900 {\n    --bg-opacity: 1;\n    background-color: #014737;\n    background-color: rgba(1, 71, 55, var(--bg-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:bg-teal-50 {\n    --bg-opacity: 1;\n    background-color: #edfafa;\n    background-color: rgba(237, 250, 250, var(--bg-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:bg-teal-100 {\n    --bg-opacity: 1;\n    background-color: #d5f5f6;\n    background-color: rgba(213, 245, 246, var(--bg-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:bg-teal-200 {\n    --bg-opacity: 1;\n    background-color: #afecef;\n    background-color: rgba(175, 236, 239, var(--bg-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:bg-teal-300 {\n    --bg-opacity: 1;\n    background-color: #7edce2;\n    background-color: rgba(126, 220, 226, var(--bg-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:bg-teal-400 {\n    --bg-opacity: 1;\n    background-color: #16bdca;\n    background-color: rgba(22, 189, 202, var(--bg-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:bg-teal-500 {\n    --bg-opacity: 1;\n    background-color: #0694a2;\n    background-color: rgba(6, 148, 162, var(--bg-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:bg-teal-600 {\n    --bg-opacity: 1;\n    background-color: #047481;\n    background-color: rgba(4, 116, 129, var(--bg-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:bg-teal-700 {\n    --bg-opacity: 1;\n    background-color: #036672;\n    background-color: rgba(3, 102, 114, var(--bg-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:bg-teal-800 {\n    --bg-opacity: 1;\n    background-color: #05505c;\n    background-color: rgba(5, 80, 92, var(--bg-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:bg-teal-900 {\n    --bg-opacity: 1;\n    background-color: #014451;\n    background-color: rgba(1, 68, 81, var(--bg-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:bg-blue-50 {\n    --bg-opacity: 1;\n    background-color: #ebf5ff;\n    background-color: rgba(235, 245, 255, var(--bg-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:bg-blue-100 {\n    --bg-opacity: 1;\n    background-color: #e1effe;\n    background-color: rgba(225, 239, 254, var(--bg-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:bg-blue-200 {\n    --bg-opacity: 1;\n    background-color: #c3ddfd;\n    background-color: rgba(195, 221, 253, var(--bg-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:bg-blue-300 {\n    --bg-opacity: 1;\n    background-color: #a4cafe;\n    background-color: rgba(164, 202, 254, var(--bg-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:bg-blue-400 {\n    --bg-opacity: 1;\n    background-color: #76a9fa;\n    background-color: rgba(118, 169, 250, var(--bg-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:bg-blue-500 {\n    --bg-opacity: 1;\n    background-color: #3f83f8;\n    background-color: rgba(63, 131, 248, var(--bg-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:bg-blue-600 {\n    --bg-opacity: 1;\n    background-color: #1c64f2;\n    background-color: rgba(28, 100, 242, var(--bg-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:bg-blue-700 {\n    --bg-opacity: 1;\n    background-color: #1a56db;\n    background-color: rgba(26, 86, 219, var(--bg-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:bg-blue-800 {\n    --bg-opacity: 1;\n    background-color: #1e429f;\n    background-color: rgba(30, 66, 159, var(--bg-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:bg-blue-900 {\n    --bg-opacity: 1;\n    background-color: #233876;\n    background-color: rgba(35, 56, 118, var(--bg-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:bg-indigo-50 {\n    --bg-opacity: 1;\n    background-color: #f0f5ff;\n    background-color: rgba(240, 245, 255, var(--bg-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:bg-indigo-100 {\n    --bg-opacity: 1;\n    background-color: #e5edff;\n    background-color: rgba(229, 237, 255, var(--bg-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:bg-indigo-200 {\n    --bg-opacity: 1;\n    background-color: #cddbfe;\n    background-color: rgba(205, 219, 254, var(--bg-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:bg-indigo-300 {\n    --bg-opacity: 1;\n    background-color: #b4c6fc;\n    background-color: rgba(180, 198, 252, var(--bg-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:bg-indigo-400 {\n    --bg-opacity: 1;\n    background-color: #8da2fb;\n    background-color: rgba(141, 162, 251, var(--bg-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:bg-indigo-500 {\n    --bg-opacity: 1;\n    background-color: #6875f5;\n    background-color: rgba(104, 117, 245, var(--bg-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:bg-indigo-600 {\n    --bg-opacity: 1;\n    background-color: #5850ec;\n    background-color: rgba(88, 80, 236, var(--bg-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:bg-indigo-700 {\n    --bg-opacity: 1;\n    background-color: #5145cd;\n    background-color: rgba(81, 69, 205, var(--bg-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:bg-indigo-800 {\n    --bg-opacity: 1;\n    background-color: #42389d;\n    background-color: rgba(66, 56, 157, var(--bg-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:bg-indigo-900 {\n    --bg-opacity: 1;\n    background-color: #362f78;\n    background-color: rgba(54, 47, 120, var(--bg-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:bg-purple-50 {\n    --bg-opacity: 1;\n    background-color: #f6f5ff;\n    background-color: rgba(246, 245, 255, var(--bg-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:bg-purple-100 {\n    --bg-opacity: 1;\n    background-color: #edebfe;\n    background-color: rgba(237, 235, 254, var(--bg-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:bg-purple-200 {\n    --bg-opacity: 1;\n    background-color: #dcd7fe;\n    background-color: rgba(220, 215, 254, var(--bg-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:bg-purple-300 {\n    --bg-opacity: 1;\n    background-color: #cabffd;\n    background-color: rgba(202, 191, 253, var(--bg-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:bg-purple-400 {\n    --bg-opacity: 1;\n    background-color: #ac94fa;\n    background-color: rgba(172, 148, 250, var(--bg-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:bg-purple-500 {\n    --bg-opacity: 1;\n    background-color: #9061f9;\n    background-color: rgba(144, 97, 249, var(--bg-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:bg-purple-600 {\n    --bg-opacity: 1;\n    background-color: #7e3af2;\n    background-color: rgba(126, 58, 242, var(--bg-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:bg-purple-700 {\n    --bg-opacity: 1;\n    background-color: #6c2bd9;\n    background-color: rgba(108, 43, 217, var(--bg-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:bg-purple-800 {\n    --bg-opacity: 1;\n    background-color: #5521b5;\n    background-color: rgba(85, 33, 181, var(--bg-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:bg-purple-900 {\n    --bg-opacity: 1;\n    background-color: #4a1d96;\n    background-color: rgba(74, 29, 150, var(--bg-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:bg-pink-50 {\n    --bg-opacity: 1;\n    background-color: #fdf2f8;\n    background-color: rgba(253, 242, 248, var(--bg-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:bg-pink-100 {\n    --bg-opacity: 1;\n    background-color: #fce8f3;\n    background-color: rgba(252, 232, 243, var(--bg-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:bg-pink-200 {\n    --bg-opacity: 1;\n    background-color: #fad1e8;\n    background-color: rgba(250, 209, 232, var(--bg-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:bg-pink-300 {\n    --bg-opacity: 1;\n    background-color: #f8b4d9;\n    background-color: rgba(248, 180, 217, var(--bg-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:bg-pink-400 {\n    --bg-opacity: 1;\n    background-color: #f17eb8;\n    background-color: rgba(241, 126, 184, var(--bg-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:bg-pink-500 {\n    --bg-opacity: 1;\n    background-color: #e74694;\n    background-color: rgba(231, 70, 148, var(--bg-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:bg-pink-600 {\n    --bg-opacity: 1;\n    background-color: #d61f69;\n    background-color: rgba(214, 31, 105, var(--bg-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:bg-pink-700 {\n    --bg-opacity: 1;\n    background-color: #bf125d;\n    background-color: rgba(191, 18, 93, var(--bg-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:bg-pink-800 {\n    --bg-opacity: 1;\n    background-color: #99154b;\n    background-color: rgba(153, 21, 75, var(--bg-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:bg-pink-900 {\n    --bg-opacity: 1;\n    background-color: #751a3d;\n    background-color: rgba(117, 26, 61, var(--bg-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:bg-cool-gray-50 {\n    --bg-opacity: 1;\n    background-color: #f8fafc;\n    background-color: rgba(248, 250, 252, var(--bg-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:bg-cool-gray-100 {\n    --bg-opacity: 1;\n    background-color: #f1f5f9;\n    background-color: rgba(241, 245, 249, var(--bg-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:bg-cool-gray-200 {\n    --bg-opacity: 1;\n    background-color: #e2e8f0;\n    background-color: rgba(226, 232, 240, var(--bg-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:bg-cool-gray-300 {\n    --bg-opacity: 1;\n    background-color: #cfd8e3;\n    background-color: rgba(207, 216, 227, var(--bg-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:bg-cool-gray-400 {\n    --bg-opacity: 1;\n    background-color: #97a6ba;\n    background-color: rgba(151, 166, 186, var(--bg-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:bg-cool-gray-500 {\n    --bg-opacity: 1;\n    background-color: #64748b;\n    background-color: rgba(100, 116, 139, var(--bg-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:bg-cool-gray-600 {\n    --bg-opacity: 1;\n    background-color: #475569;\n    background-color: rgba(71, 85, 105, var(--bg-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:bg-cool-gray-700 {\n    --bg-opacity: 1;\n    background-color: #364152;\n    background-color: rgba(54, 65, 82, var(--bg-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:bg-cool-gray-800 {\n    --bg-opacity: 1;\n    background-color: #27303f;\n    background-color: rgba(39, 48, 63, var(--bg-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:bg-cool-gray-900 {\n    --bg-opacity: 1;\n    background-color: #1a202e;\n    background-color: rgba(26, 32, 46, var(--bg-opacity));\n  }\n  .xl\\:hover\\:bg-current:hover {\n    background-color: currentColor;\n  }\n  .xl\\:hover\\:bg-transparent:hover {\n    background-color: transparent;\n  }\n  .xl\\:hover\\:bg-white:hover {\n    --bg-opacity: 1;\n    background-color: #ffffff;\n    background-color: rgba(255, 255, 255, var(--bg-opacity));\n  }\n  .xl\\:hover\\:bg-black:hover {\n    --bg-opacity: 1;\n    background-color: #000000;\n    background-color: rgba(0, 0, 0, var(--bg-opacity));\n  }\n  .xl\\:hover\\:bg-gray-50:hover {\n    --bg-opacity: 1;\n    background-color: #f9fafb;\n    background-color: rgba(249, 250, 251, var(--bg-opacity));\n  }\n  .xl\\:hover\\:bg-gray-100:hover {\n    --bg-opacity: 1;\n    background-color: #f4f5f7;\n    background-color: rgba(244, 245, 247, var(--bg-opacity));\n  }\n  .xl\\:hover\\:bg-gray-200:hover {\n    --bg-opacity: 1;\n    background-color: #e5e7eb;\n    background-color: rgba(229, 231, 235, var(--bg-opacity));\n  }\n  .xl\\:hover\\:bg-gray-300:hover {\n    --bg-opacity: 1;\n    background-color: #d2d6dc;\n    background-color: rgba(210, 214, 220, var(--bg-opacity));\n  }\n  .xl\\:hover\\:bg-gray-400:hover {\n    --bg-opacity: 1;\n    background-color: #9fa6b2;\n    background-color: rgba(159, 166, 178, var(--bg-opacity));\n  }\n  .xl\\:hover\\:bg-gray-500:hover {\n    --bg-opacity: 1;\n    background-color: #6b7280;\n    background-color: rgba(107, 114, 128, var(--bg-opacity));\n  }\n  .xl\\:hover\\:bg-gray-600:hover {\n    --bg-opacity: 1;\n    background-color: #4b5563;\n    background-color: rgba(75, 85, 99, var(--bg-opacity));\n  }\n  .xl\\:hover\\:bg-gray-700:hover {\n    --bg-opacity: 1;\n    background-color: #374151;\n    background-color: rgba(55, 65, 81, var(--bg-opacity));\n  }\n  .xl\\:hover\\:bg-gray-800:hover {\n    --bg-opacity: 1;\n    background-color: #252f3f;\n    background-color: rgba(37, 47, 63, var(--bg-opacity));\n  }\n  .xl\\:hover\\:bg-gray-900:hover {\n    --bg-opacity: 1;\n    background-color: #161e2e;\n    background-color: rgba(22, 30, 46, var(--bg-opacity));\n  }\n  .xl\\:hover\\:bg-red-50:hover {\n    --bg-opacity: 1;\n    background-color: #fdf2f2;\n    background-color: rgba(253, 242, 242, var(--bg-opacity));\n  }\n  .xl\\:hover\\:bg-red-100:hover {\n    --bg-opacity: 1;\n    background-color: #fde8e8;\n    background-color: rgba(253, 232, 232, var(--bg-opacity));\n  }\n  .xl\\:hover\\:bg-red-200:hover {\n    --bg-opacity: 1;\n    background-color: #fbd5d5;\n    background-color: rgba(251, 213, 213, var(--bg-opacity));\n  }\n  .xl\\:hover\\:bg-red-300:hover {\n    --bg-opacity: 1;\n    background-color: #f8b4b4;\n    background-color: rgba(248, 180, 180, var(--bg-opacity));\n  }\n  .xl\\:hover\\:bg-red-400:hover {\n    --bg-opacity: 1;\n    background-color: #f98080;\n    background-color: rgba(249, 128, 128, var(--bg-opacity));\n  }\n  .xl\\:hover\\:bg-red-500:hover {\n    --bg-opacity: 1;\n    background-color: #f05252;\n    background-color: rgba(240, 82, 82, var(--bg-opacity));\n  }\n  .xl\\:hover\\:bg-red-600:hover {\n    --bg-opacity: 1;\n    background-color: #e02424;\n    background-color: rgba(224, 36, 36, var(--bg-opacity));\n  }\n  .xl\\:hover\\:bg-red-700:hover {\n    --bg-opacity: 1;\n    background-color: #c81e1e;\n    background-color: rgba(200, 30, 30, var(--bg-opacity));\n  }\n  .xl\\:hover\\:bg-red-800:hover {\n    --bg-opacity: 1;\n    background-color: #9b1c1c;\n    background-color: rgba(155, 28, 28, var(--bg-opacity));\n  }\n  .xl\\:hover\\:bg-red-900:hover {\n    --bg-opacity: 1;\n    background-color: #771d1d;\n    background-color: rgba(119, 29, 29, var(--bg-opacity));\n  }\n  .xl\\:hover\\:bg-orange-50:hover {\n    --bg-opacity: 1;\n    background-color: #fff8f1;\n    background-color: rgba(255, 248, 241, var(--bg-opacity));\n  }\n  .xl\\:hover\\:bg-orange-100:hover {\n    --bg-opacity: 1;\n    background-color: #feecdc;\n    background-color: rgba(254, 236, 220, var(--bg-opacity));\n  }\n  .xl\\:hover\\:bg-orange-200:hover {\n    --bg-opacity: 1;\n    background-color: #fcd9bd;\n    background-color: rgba(252, 217, 189, var(--bg-opacity));\n  }\n  .xl\\:hover\\:bg-orange-300:hover {\n    --bg-opacity: 1;\n    background-color: #fdba8c;\n    background-color: rgba(253, 186, 140, var(--bg-opacity));\n  }\n  .xl\\:hover\\:bg-orange-400:hover {\n    --bg-opacity: 1;\n    background-color: #ff8a4c;\n    background-color: rgba(255, 138, 76, var(--bg-opacity));\n  }\n  .xl\\:hover\\:bg-orange-500:hover {\n    --bg-opacity: 1;\n    background-color: #ff5a1f;\n    background-color: rgba(255, 90, 31, var(--bg-opacity));\n  }\n  .xl\\:hover\\:bg-orange-600:hover {\n    --bg-opacity: 1;\n    background-color: #d03801;\n    background-color: rgba(208, 56, 1, var(--bg-opacity));\n  }\n  .xl\\:hover\\:bg-orange-700:hover {\n    --bg-opacity: 1;\n    background-color: #b43403;\n    background-color: rgba(180, 52, 3, var(--bg-opacity));\n  }\n  .xl\\:hover\\:bg-orange-800:hover {\n    --bg-opacity: 1;\n    background-color: #8a2c0d;\n    background-color: rgba(138, 44, 13, var(--bg-opacity));\n  }\n  .xl\\:hover\\:bg-orange-900:hover {\n    --bg-opacity: 1;\n    background-color: #73230d;\n    background-color: rgba(115, 35, 13, var(--bg-opacity));\n  }\n  .xl\\:hover\\:bg-yellow-50:hover {\n    --bg-opacity: 1;\n    background-color: #fdfdea;\n    background-color: rgba(253, 253, 234, var(--bg-opacity));\n  }\n  .xl\\:hover\\:bg-yellow-100:hover {\n    --bg-opacity: 1;\n    background-color: #fdf6b2;\n    background-color: rgba(253, 246, 178, var(--bg-opacity));\n  }\n  .xl\\:hover\\:bg-yellow-200:hover {\n    --bg-opacity: 1;\n    background-color: #fce96a;\n    background-color: rgba(252, 233, 106, var(--bg-opacity));\n  }\n  .xl\\:hover\\:bg-yellow-300:hover {\n    --bg-opacity: 1;\n    background-color: #faca15;\n    background-color: rgba(250, 202, 21, var(--bg-opacity));\n  }\n  .xl\\:hover\\:bg-yellow-400:hover {\n    --bg-opacity: 1;\n    background-color: #e3a008;\n    background-color: rgba(227, 160, 8, var(--bg-opacity));\n  }\n  .xl\\:hover\\:bg-yellow-500:hover {\n    --bg-opacity: 1;\n    background-color: #c27803;\n    background-color: rgba(194, 120, 3, var(--bg-opacity));\n  }\n  .xl\\:hover\\:bg-yellow-600:hover {\n    --bg-opacity: 1;\n    background-color: #9f580a;\n    background-color: rgba(159, 88, 10, var(--bg-opacity));\n  }\n  .xl\\:hover\\:bg-yellow-700:hover {\n    --bg-opacity: 1;\n    background-color: #8e4b10;\n    background-color: rgba(142, 75, 16, var(--bg-opacity));\n  }\n  .xl\\:hover\\:bg-yellow-800:hover {\n    --bg-opacity: 1;\n    background-color: #723b13;\n    background-color: rgba(114, 59, 19, var(--bg-opacity));\n  }\n  .xl\\:hover\\:bg-yellow-900:hover {\n    --bg-opacity: 1;\n    background-color: #633112;\n    background-color: rgba(99, 49, 18, var(--bg-opacity));\n  }\n  .xl\\:hover\\:bg-green-50:hover {\n    --bg-opacity: 1;\n    background-color: #f3faf7;\n    background-color: rgba(243, 250, 247, var(--bg-opacity));\n  }\n  .xl\\:hover\\:bg-green-100:hover {\n    --bg-opacity: 1;\n    background-color: #def7ec;\n    background-color: rgba(222, 247, 236, var(--bg-opacity));\n  }\n  .xl\\:hover\\:bg-green-200:hover {\n    --bg-opacity: 1;\n    background-color: #bcf0da;\n    background-color: rgba(188, 240, 218, var(--bg-opacity));\n  }\n  .xl\\:hover\\:bg-green-300:hover {\n    --bg-opacity: 1;\n    background-color: #84e1bc;\n    background-color: rgba(132, 225, 188, var(--bg-opacity));\n  }\n  .xl\\:hover\\:bg-green-400:hover {\n    --bg-opacity: 1;\n    background-color: #31c48d;\n    background-color: rgba(49, 196, 141, var(--bg-opacity));\n  }\n  .xl\\:hover\\:bg-green-500:hover {\n    --bg-opacity: 1;\n    background-color: #0e9f6e;\n    background-color: rgba(14, 159, 110, var(--bg-opacity));\n  }\n  .xl\\:hover\\:bg-green-600:hover {\n    --bg-opacity: 1;\n    background-color: #057a55;\n    background-color: rgba(5, 122, 85, var(--bg-opacity));\n  }\n  .xl\\:hover\\:bg-green-700:hover {\n    --bg-opacity: 1;\n    background-color: #046c4e;\n    background-color: rgba(4, 108, 78, var(--bg-opacity));\n  }\n  .xl\\:hover\\:bg-green-800:hover {\n    --bg-opacity: 1;\n    background-color: #03543f;\n    background-color: rgba(3, 84, 63, var(--bg-opacity));\n  }\n  .xl\\:hover\\:bg-green-900:hover {\n    --bg-opacity: 1;\n    background-color: #014737;\n    background-color: rgba(1, 71, 55, var(--bg-opacity));\n  }\n  .xl\\:hover\\:bg-teal-50:hover {\n    --bg-opacity: 1;\n    background-color: #edfafa;\n    background-color: rgba(237, 250, 250, var(--bg-opacity));\n  }\n  .xl\\:hover\\:bg-teal-100:hover {\n    --bg-opacity: 1;\n    background-color: #d5f5f6;\n    background-color: rgba(213, 245, 246, var(--bg-opacity));\n  }\n  .xl\\:hover\\:bg-teal-200:hover {\n    --bg-opacity: 1;\n    background-color: #afecef;\n    background-color: rgba(175, 236, 239, var(--bg-opacity));\n  }\n  .xl\\:hover\\:bg-teal-300:hover {\n    --bg-opacity: 1;\n    background-color: #7edce2;\n    background-color: rgba(126, 220, 226, var(--bg-opacity));\n  }\n  .xl\\:hover\\:bg-teal-400:hover {\n    --bg-opacity: 1;\n    background-color: #16bdca;\n    background-color: rgba(22, 189, 202, var(--bg-opacity));\n  }\n  .xl\\:hover\\:bg-teal-500:hover {\n    --bg-opacity: 1;\n    background-color: #0694a2;\n    background-color: rgba(6, 148, 162, var(--bg-opacity));\n  }\n  .xl\\:hover\\:bg-teal-600:hover {\n    --bg-opacity: 1;\n    background-color: #047481;\n    background-color: rgba(4, 116, 129, var(--bg-opacity));\n  }\n  .xl\\:hover\\:bg-teal-700:hover {\n    --bg-opacity: 1;\n    background-color: #036672;\n    background-color: rgba(3, 102, 114, var(--bg-opacity));\n  }\n  .xl\\:hover\\:bg-teal-800:hover {\n    --bg-opacity: 1;\n    background-color: #05505c;\n    background-color: rgba(5, 80, 92, var(--bg-opacity));\n  }\n  .xl\\:hover\\:bg-teal-900:hover {\n    --bg-opacity: 1;\n    background-color: #014451;\n    background-color: rgba(1, 68, 81, var(--bg-opacity));\n  }\n  .xl\\:hover\\:bg-blue-50:hover {\n    --bg-opacity: 1;\n    background-color: #ebf5ff;\n    background-color: rgba(235, 245, 255, var(--bg-opacity));\n  }\n  .xl\\:hover\\:bg-blue-100:hover {\n    --bg-opacity: 1;\n    background-color: #e1effe;\n    background-color: rgba(225, 239, 254, var(--bg-opacity));\n  }\n  .xl\\:hover\\:bg-blue-200:hover {\n    --bg-opacity: 1;\n    background-color: #c3ddfd;\n    background-color: rgba(195, 221, 253, var(--bg-opacity));\n  }\n  .xl\\:hover\\:bg-blue-300:hover {\n    --bg-opacity: 1;\n    background-color: #a4cafe;\n    background-color: rgba(164, 202, 254, var(--bg-opacity));\n  }\n  .xl\\:hover\\:bg-blue-400:hover {\n    --bg-opacity: 1;\n    background-color: #76a9fa;\n    background-color: rgba(118, 169, 250, var(--bg-opacity));\n  }\n  .xl\\:hover\\:bg-blue-500:hover {\n    --bg-opacity: 1;\n    background-color: #3f83f8;\n    background-color: rgba(63, 131, 248, var(--bg-opacity));\n  }\n  .xl\\:hover\\:bg-blue-600:hover {\n    --bg-opacity: 1;\n    background-color: #1c64f2;\n    background-color: rgba(28, 100, 242, var(--bg-opacity));\n  }\n  .xl\\:hover\\:bg-blue-700:hover {\n    --bg-opacity: 1;\n    background-color: #1a56db;\n    background-color: rgba(26, 86, 219, var(--bg-opacity));\n  }\n  .xl\\:hover\\:bg-blue-800:hover {\n    --bg-opacity: 1;\n    background-color: #1e429f;\n    background-color: rgba(30, 66, 159, var(--bg-opacity));\n  }\n  .xl\\:hover\\:bg-blue-900:hover {\n    --bg-opacity: 1;\n    background-color: #233876;\n    background-color: rgba(35, 56, 118, var(--bg-opacity));\n  }\n  .xl\\:hover\\:bg-indigo-50:hover {\n    --bg-opacity: 1;\n    background-color: #f0f5ff;\n    background-color: rgba(240, 245, 255, var(--bg-opacity));\n  }\n  .xl\\:hover\\:bg-indigo-100:hover {\n    --bg-opacity: 1;\n    background-color: #e5edff;\n    background-color: rgba(229, 237, 255, var(--bg-opacity));\n  }\n  .xl\\:hover\\:bg-indigo-200:hover {\n    --bg-opacity: 1;\n    background-color: #cddbfe;\n    background-color: rgba(205, 219, 254, var(--bg-opacity));\n  }\n  .xl\\:hover\\:bg-indigo-300:hover {\n    --bg-opacity: 1;\n    background-color: #b4c6fc;\n    background-color: rgba(180, 198, 252, var(--bg-opacity));\n  }\n  .xl\\:hover\\:bg-indigo-400:hover {\n    --bg-opacity: 1;\n    background-color: #8da2fb;\n    background-color: rgba(141, 162, 251, var(--bg-opacity));\n  }\n  .xl\\:hover\\:bg-indigo-500:hover {\n    --bg-opacity: 1;\n    background-color: #6875f5;\n    background-color: rgba(104, 117, 245, var(--bg-opacity));\n  }\n  .xl\\:hover\\:bg-indigo-600:hover {\n    --bg-opacity: 1;\n    background-color: #5850ec;\n    background-color: rgba(88, 80, 236, var(--bg-opacity));\n  }\n  .xl\\:hover\\:bg-indigo-700:hover {\n    --bg-opacity: 1;\n    background-color: #5145cd;\n    background-color: rgba(81, 69, 205, var(--bg-opacity));\n  }\n  .xl\\:hover\\:bg-indigo-800:hover {\n    --bg-opacity: 1;\n    background-color: #42389d;\n    background-color: rgba(66, 56, 157, var(--bg-opacity));\n  }\n  .xl\\:hover\\:bg-indigo-900:hover {\n    --bg-opacity: 1;\n    background-color: #362f78;\n    background-color: rgba(54, 47, 120, var(--bg-opacity));\n  }\n  .xl\\:hover\\:bg-purple-50:hover {\n    --bg-opacity: 1;\n    background-color: #f6f5ff;\n    background-color: rgba(246, 245, 255, var(--bg-opacity));\n  }\n  .xl\\:hover\\:bg-purple-100:hover {\n    --bg-opacity: 1;\n    background-color: #edebfe;\n    background-color: rgba(237, 235, 254, var(--bg-opacity));\n  }\n  .xl\\:hover\\:bg-purple-200:hover {\n    --bg-opacity: 1;\n    background-color: #dcd7fe;\n    background-color: rgba(220, 215, 254, var(--bg-opacity));\n  }\n  .xl\\:hover\\:bg-purple-300:hover {\n    --bg-opacity: 1;\n    background-color: #cabffd;\n    background-color: rgba(202, 191, 253, var(--bg-opacity));\n  }\n  .xl\\:hover\\:bg-purple-400:hover {\n    --bg-opacity: 1;\n    background-color: #ac94fa;\n    background-color: rgba(172, 148, 250, var(--bg-opacity));\n  }\n  .xl\\:hover\\:bg-purple-500:hover {\n    --bg-opacity: 1;\n    background-color: #9061f9;\n    background-color: rgba(144, 97, 249, var(--bg-opacity));\n  }\n  .xl\\:hover\\:bg-purple-600:hover {\n    --bg-opacity: 1;\n    background-color: #7e3af2;\n    background-color: rgba(126, 58, 242, var(--bg-opacity));\n  }\n  .xl\\:hover\\:bg-purple-700:hover {\n    --bg-opacity: 1;\n    background-color: #6c2bd9;\n    background-color: rgba(108, 43, 217, var(--bg-opacity));\n  }\n  .xl\\:hover\\:bg-purple-800:hover {\n    --bg-opacity: 1;\n    background-color: #5521b5;\n    background-color: rgba(85, 33, 181, var(--bg-opacity));\n  }\n  .xl\\:hover\\:bg-purple-900:hover {\n    --bg-opacity: 1;\n    background-color: #4a1d96;\n    background-color: rgba(74, 29, 150, var(--bg-opacity));\n  }\n  .xl\\:hover\\:bg-pink-50:hover {\n    --bg-opacity: 1;\n    background-color: #fdf2f8;\n    background-color: rgba(253, 242, 248, var(--bg-opacity));\n  }\n  .xl\\:hover\\:bg-pink-100:hover {\n    --bg-opacity: 1;\n    background-color: #fce8f3;\n    background-color: rgba(252, 232, 243, var(--bg-opacity));\n  }\n  .xl\\:hover\\:bg-pink-200:hover {\n    --bg-opacity: 1;\n    background-color: #fad1e8;\n    background-color: rgba(250, 209, 232, var(--bg-opacity));\n  }\n  .xl\\:hover\\:bg-pink-300:hover {\n    --bg-opacity: 1;\n    background-color: #f8b4d9;\n    background-color: rgba(248, 180, 217, var(--bg-opacity));\n  }\n  .xl\\:hover\\:bg-pink-400:hover {\n    --bg-opacity: 1;\n    background-color: #f17eb8;\n    background-color: rgba(241, 126, 184, var(--bg-opacity));\n  }\n  .xl\\:hover\\:bg-pink-500:hover {\n    --bg-opacity: 1;\n    background-color: #e74694;\n    background-color: rgba(231, 70, 148, var(--bg-opacity));\n  }\n  .xl\\:hover\\:bg-pink-600:hover {\n    --bg-opacity: 1;\n    background-color: #d61f69;\n    background-color: rgba(214, 31, 105, var(--bg-opacity));\n  }\n  .xl\\:hover\\:bg-pink-700:hover {\n    --bg-opacity: 1;\n    background-color: #bf125d;\n    background-color: rgba(191, 18, 93, var(--bg-opacity));\n  }\n  .xl\\:hover\\:bg-pink-800:hover {\n    --bg-opacity: 1;\n    background-color: #99154b;\n    background-color: rgba(153, 21, 75, var(--bg-opacity));\n  }\n  .xl\\:hover\\:bg-pink-900:hover {\n    --bg-opacity: 1;\n    background-color: #751a3d;\n    background-color: rgba(117, 26, 61, var(--bg-opacity));\n  }\n  .xl\\:hover\\:bg-cool-gray-50:hover {\n    --bg-opacity: 1;\n    background-color: #f8fafc;\n    background-color: rgba(248, 250, 252, var(--bg-opacity));\n  }\n  .xl\\:hover\\:bg-cool-gray-100:hover {\n    --bg-opacity: 1;\n    background-color: #f1f5f9;\n    background-color: rgba(241, 245, 249, var(--bg-opacity));\n  }\n  .xl\\:hover\\:bg-cool-gray-200:hover {\n    --bg-opacity: 1;\n    background-color: #e2e8f0;\n    background-color: rgba(226, 232, 240, var(--bg-opacity));\n  }\n  .xl\\:hover\\:bg-cool-gray-300:hover {\n    --bg-opacity: 1;\n    background-color: #cfd8e3;\n    background-color: rgba(207, 216, 227, var(--bg-opacity));\n  }\n  .xl\\:hover\\:bg-cool-gray-400:hover {\n    --bg-opacity: 1;\n    background-color: #97a6ba;\n    background-color: rgba(151, 166, 186, var(--bg-opacity));\n  }\n  .xl\\:hover\\:bg-cool-gray-500:hover {\n    --bg-opacity: 1;\n    background-color: #64748b;\n    background-color: rgba(100, 116, 139, var(--bg-opacity));\n  }\n  .xl\\:hover\\:bg-cool-gray-600:hover {\n    --bg-opacity: 1;\n    background-color: #475569;\n    background-color: rgba(71, 85, 105, var(--bg-opacity));\n  }\n  .xl\\:hover\\:bg-cool-gray-700:hover {\n    --bg-opacity: 1;\n    background-color: #364152;\n    background-color: rgba(54, 65, 82, var(--bg-opacity));\n  }\n  .xl\\:hover\\:bg-cool-gray-800:hover {\n    --bg-opacity: 1;\n    background-color: #27303f;\n    background-color: rgba(39, 48, 63, var(--bg-opacity));\n  }\n  .xl\\:hover\\:bg-cool-gray-900:hover {\n    --bg-opacity: 1;\n    background-color: #1a202e;\n    background-color: rgba(26, 32, 46, var(--bg-opacity));\n  }\n  .xl\\:focus\\:bg-current:focus {\n    background-color: currentColor;\n  }\n  .xl\\:focus\\:bg-transparent:focus {\n    background-color: transparent;\n  }\n  .xl\\:focus\\:bg-white:focus {\n    --bg-opacity: 1;\n    background-color: #ffffff;\n    background-color: rgba(255, 255, 255, var(--bg-opacity));\n  }\n  .xl\\:focus\\:bg-black:focus {\n    --bg-opacity: 1;\n    background-color: #000000;\n    background-color: rgba(0, 0, 0, var(--bg-opacity));\n  }\n  .xl\\:focus\\:bg-gray-50:focus {\n    --bg-opacity: 1;\n    background-color: #f9fafb;\n    background-color: rgba(249, 250, 251, var(--bg-opacity));\n  }\n  .xl\\:focus\\:bg-gray-100:focus {\n    --bg-opacity: 1;\n    background-color: #f4f5f7;\n    background-color: rgba(244, 245, 247, var(--bg-opacity));\n  }\n  .xl\\:focus\\:bg-gray-200:focus {\n    --bg-opacity: 1;\n    background-color: #e5e7eb;\n    background-color: rgba(229, 231, 235, var(--bg-opacity));\n  }\n  .xl\\:focus\\:bg-gray-300:focus {\n    --bg-opacity: 1;\n    background-color: #d2d6dc;\n    background-color: rgba(210, 214, 220, var(--bg-opacity));\n  }\n  .xl\\:focus\\:bg-gray-400:focus {\n    --bg-opacity: 1;\n    background-color: #9fa6b2;\n    background-color: rgba(159, 166, 178, var(--bg-opacity));\n  }\n  .xl\\:focus\\:bg-gray-500:focus {\n    --bg-opacity: 1;\n    background-color: #6b7280;\n    background-color: rgba(107, 114, 128, var(--bg-opacity));\n  }\n  .xl\\:focus\\:bg-gray-600:focus {\n    --bg-opacity: 1;\n    background-color: #4b5563;\n    background-color: rgba(75, 85, 99, var(--bg-opacity));\n  }\n  .xl\\:focus\\:bg-gray-700:focus {\n    --bg-opacity: 1;\n    background-color: #374151;\n    background-color: rgba(55, 65, 81, var(--bg-opacity));\n  }\n  .xl\\:focus\\:bg-gray-800:focus {\n    --bg-opacity: 1;\n    background-color: #252f3f;\n    background-color: rgba(37, 47, 63, var(--bg-opacity));\n  }\n  .xl\\:focus\\:bg-gray-900:focus {\n    --bg-opacity: 1;\n    background-color: #161e2e;\n    background-color: rgba(22, 30, 46, var(--bg-opacity));\n  }\n  .xl\\:focus\\:bg-red-50:focus {\n    --bg-opacity: 1;\n    background-color: #fdf2f2;\n    background-color: rgba(253, 242, 242, var(--bg-opacity));\n  }\n  .xl\\:focus\\:bg-red-100:focus {\n    --bg-opacity: 1;\n    background-color: #fde8e8;\n    background-color: rgba(253, 232, 232, var(--bg-opacity));\n  }\n  .xl\\:focus\\:bg-red-200:focus {\n    --bg-opacity: 1;\n    background-color: #fbd5d5;\n    background-color: rgba(251, 213, 213, var(--bg-opacity));\n  }\n  .xl\\:focus\\:bg-red-300:focus {\n    --bg-opacity: 1;\n    background-color: #f8b4b4;\n    background-color: rgba(248, 180, 180, var(--bg-opacity));\n  }\n  .xl\\:focus\\:bg-red-400:focus {\n    --bg-opacity: 1;\n    background-color: #f98080;\n    background-color: rgba(249, 128, 128, var(--bg-opacity));\n  }\n  .xl\\:focus\\:bg-red-500:focus {\n    --bg-opacity: 1;\n    background-color: #f05252;\n    background-color: rgba(240, 82, 82, var(--bg-opacity));\n  }\n  .xl\\:focus\\:bg-red-600:focus {\n    --bg-opacity: 1;\n    background-color: #e02424;\n    background-color: rgba(224, 36, 36, var(--bg-opacity));\n  }\n  .xl\\:focus\\:bg-red-700:focus {\n    --bg-opacity: 1;\n    background-color: #c81e1e;\n    background-color: rgba(200, 30, 30, var(--bg-opacity));\n  }\n  .xl\\:focus\\:bg-red-800:focus {\n    --bg-opacity: 1;\n    background-color: #9b1c1c;\n    background-color: rgba(155, 28, 28, var(--bg-opacity));\n  }\n  .xl\\:focus\\:bg-red-900:focus {\n    --bg-opacity: 1;\n    background-color: #771d1d;\n    background-color: rgba(119, 29, 29, var(--bg-opacity));\n  }\n  .xl\\:focus\\:bg-orange-50:focus {\n    --bg-opacity: 1;\n    background-color: #fff8f1;\n    background-color: rgba(255, 248, 241, var(--bg-opacity));\n  }\n  .xl\\:focus\\:bg-orange-100:focus {\n    --bg-opacity: 1;\n    background-color: #feecdc;\n    background-color: rgba(254, 236, 220, var(--bg-opacity));\n  }\n  .xl\\:focus\\:bg-orange-200:focus {\n    --bg-opacity: 1;\n    background-color: #fcd9bd;\n    background-color: rgba(252, 217, 189, var(--bg-opacity));\n  }\n  .xl\\:focus\\:bg-orange-300:focus {\n    --bg-opacity: 1;\n    background-color: #fdba8c;\n    background-color: rgba(253, 186, 140, var(--bg-opacity));\n  }\n  .xl\\:focus\\:bg-orange-400:focus {\n    --bg-opacity: 1;\n    background-color: #ff8a4c;\n    background-color: rgba(255, 138, 76, var(--bg-opacity));\n  }\n  .xl\\:focus\\:bg-orange-500:focus {\n    --bg-opacity: 1;\n    background-color: #ff5a1f;\n    background-color: rgba(255, 90, 31, var(--bg-opacity));\n  }\n  .xl\\:focus\\:bg-orange-600:focus {\n    --bg-opacity: 1;\n    background-color: #d03801;\n    background-color: rgba(208, 56, 1, var(--bg-opacity));\n  }\n  .xl\\:focus\\:bg-orange-700:focus {\n    --bg-opacity: 1;\n    background-color: #b43403;\n    background-color: rgba(180, 52, 3, var(--bg-opacity));\n  }\n  .xl\\:focus\\:bg-orange-800:focus {\n    --bg-opacity: 1;\n    background-color: #8a2c0d;\n    background-color: rgba(138, 44, 13, var(--bg-opacity));\n  }\n  .xl\\:focus\\:bg-orange-900:focus {\n    --bg-opacity: 1;\n    background-color: #73230d;\n    background-color: rgba(115, 35, 13, var(--bg-opacity));\n  }\n  .xl\\:focus\\:bg-yellow-50:focus {\n    --bg-opacity: 1;\n    background-color: #fdfdea;\n    background-color: rgba(253, 253, 234, var(--bg-opacity));\n  }\n  .xl\\:focus\\:bg-yellow-100:focus {\n    --bg-opacity: 1;\n    background-color: #fdf6b2;\n    background-color: rgba(253, 246, 178, var(--bg-opacity));\n  }\n  .xl\\:focus\\:bg-yellow-200:focus {\n    --bg-opacity: 1;\n    background-color: #fce96a;\n    background-color: rgba(252, 233, 106, var(--bg-opacity));\n  }\n  .xl\\:focus\\:bg-yellow-300:focus {\n    --bg-opacity: 1;\n    background-color: #faca15;\n    background-color: rgba(250, 202, 21, var(--bg-opacity));\n  }\n  .xl\\:focus\\:bg-yellow-400:focus {\n    --bg-opacity: 1;\n    background-color: #e3a008;\n    background-color: rgba(227, 160, 8, var(--bg-opacity));\n  }\n  .xl\\:focus\\:bg-yellow-500:focus {\n    --bg-opacity: 1;\n    background-color: #c27803;\n    background-color: rgba(194, 120, 3, var(--bg-opacity));\n  }\n  .xl\\:focus\\:bg-yellow-600:focus {\n    --bg-opacity: 1;\n    background-color: #9f580a;\n    background-color: rgba(159, 88, 10, var(--bg-opacity));\n  }\n  .xl\\:focus\\:bg-yellow-700:focus {\n    --bg-opacity: 1;\n    background-color: #8e4b10;\n    background-color: rgba(142, 75, 16, var(--bg-opacity));\n  }\n  .xl\\:focus\\:bg-yellow-800:focus {\n    --bg-opacity: 1;\n    background-color: #723b13;\n    background-color: rgba(114, 59, 19, var(--bg-opacity));\n  }\n  .xl\\:focus\\:bg-yellow-900:focus {\n    --bg-opacity: 1;\n    background-color: #633112;\n    background-color: rgba(99, 49, 18, var(--bg-opacity));\n  }\n  .xl\\:focus\\:bg-green-50:focus {\n    --bg-opacity: 1;\n    background-color: #f3faf7;\n    background-color: rgba(243, 250, 247, var(--bg-opacity));\n  }\n  .xl\\:focus\\:bg-green-100:focus {\n    --bg-opacity: 1;\n    background-color: #def7ec;\n    background-color: rgba(222, 247, 236, var(--bg-opacity));\n  }\n  .xl\\:focus\\:bg-green-200:focus {\n    --bg-opacity: 1;\n    background-color: #bcf0da;\n    background-color: rgba(188, 240, 218, var(--bg-opacity));\n  }\n  .xl\\:focus\\:bg-green-300:focus {\n    --bg-opacity: 1;\n    background-color: #84e1bc;\n    background-color: rgba(132, 225, 188, var(--bg-opacity));\n  }\n  .xl\\:focus\\:bg-green-400:focus {\n    --bg-opacity: 1;\n    background-color: #31c48d;\n    background-color: rgba(49, 196, 141, var(--bg-opacity));\n  }\n  .xl\\:focus\\:bg-green-500:focus {\n    --bg-opacity: 1;\n    background-color: #0e9f6e;\n    background-color: rgba(14, 159, 110, var(--bg-opacity));\n  }\n  .xl\\:focus\\:bg-green-600:focus {\n    --bg-opacity: 1;\n    background-color: #057a55;\n    background-color: rgba(5, 122, 85, var(--bg-opacity));\n  }\n  .xl\\:focus\\:bg-green-700:focus {\n    --bg-opacity: 1;\n    background-color: #046c4e;\n    background-color: rgba(4, 108, 78, var(--bg-opacity));\n  }\n  .xl\\:focus\\:bg-green-800:focus {\n    --bg-opacity: 1;\n    background-color: #03543f;\n    background-color: rgba(3, 84, 63, var(--bg-opacity));\n  }\n  .xl\\:focus\\:bg-green-900:focus {\n    --bg-opacity: 1;\n    background-color: #014737;\n    background-color: rgba(1, 71, 55, var(--bg-opacity));\n  }\n  .xl\\:focus\\:bg-teal-50:focus {\n    --bg-opacity: 1;\n    background-color: #edfafa;\n    background-color: rgba(237, 250, 250, var(--bg-opacity));\n  }\n  .xl\\:focus\\:bg-teal-100:focus {\n    --bg-opacity: 1;\n    background-color: #d5f5f6;\n    background-color: rgba(213, 245, 246, var(--bg-opacity));\n  }\n  .xl\\:focus\\:bg-teal-200:focus {\n    --bg-opacity: 1;\n    background-color: #afecef;\n    background-color: rgba(175, 236, 239, var(--bg-opacity));\n  }\n  .xl\\:focus\\:bg-teal-300:focus {\n    --bg-opacity: 1;\n    background-color: #7edce2;\n    background-color: rgba(126, 220, 226, var(--bg-opacity));\n  }\n  .xl\\:focus\\:bg-teal-400:focus {\n    --bg-opacity: 1;\n    background-color: #16bdca;\n    background-color: rgba(22, 189, 202, var(--bg-opacity));\n  }\n  .xl\\:focus\\:bg-teal-500:focus {\n    --bg-opacity: 1;\n    background-color: #0694a2;\n    background-color: rgba(6, 148, 162, var(--bg-opacity));\n  }\n  .xl\\:focus\\:bg-teal-600:focus {\n    --bg-opacity: 1;\n    background-color: #047481;\n    background-color: rgba(4, 116, 129, var(--bg-opacity));\n  }\n  .xl\\:focus\\:bg-teal-700:focus {\n    --bg-opacity: 1;\n    background-color: #036672;\n    background-color: rgba(3, 102, 114, var(--bg-opacity));\n  }\n  .xl\\:focus\\:bg-teal-800:focus {\n    --bg-opacity: 1;\n    background-color: #05505c;\n    background-color: rgba(5, 80, 92, var(--bg-opacity));\n  }\n  .xl\\:focus\\:bg-teal-900:focus {\n    --bg-opacity: 1;\n    background-color: #014451;\n    background-color: rgba(1, 68, 81, var(--bg-opacity));\n  }\n  .xl\\:focus\\:bg-blue-50:focus {\n    --bg-opacity: 1;\n    background-color: #ebf5ff;\n    background-color: rgba(235, 245, 255, var(--bg-opacity));\n  }\n  .xl\\:focus\\:bg-blue-100:focus {\n    --bg-opacity: 1;\n    background-color: #e1effe;\n    background-color: rgba(225, 239, 254, var(--bg-opacity));\n  }\n  .xl\\:focus\\:bg-blue-200:focus {\n    --bg-opacity: 1;\n    background-color: #c3ddfd;\n    background-color: rgba(195, 221, 253, var(--bg-opacity));\n  }\n  .xl\\:focus\\:bg-blue-300:focus {\n    --bg-opacity: 1;\n    background-color: #a4cafe;\n    background-color: rgba(164, 202, 254, var(--bg-opacity));\n  }\n  .xl\\:focus\\:bg-blue-400:focus {\n    --bg-opacity: 1;\n    background-color: #76a9fa;\n    background-color: rgba(118, 169, 250, var(--bg-opacity));\n  }\n  .xl\\:focus\\:bg-blue-500:focus {\n    --bg-opacity: 1;\n    background-color: #3f83f8;\n    background-color: rgba(63, 131, 248, var(--bg-opacity));\n  }\n  .xl\\:focus\\:bg-blue-600:focus {\n    --bg-opacity: 1;\n    background-color: #1c64f2;\n    background-color: rgba(28, 100, 242, var(--bg-opacity));\n  }\n  .xl\\:focus\\:bg-blue-700:focus {\n    --bg-opacity: 1;\n    background-color: #1a56db;\n    background-color: rgba(26, 86, 219, var(--bg-opacity));\n  }\n  .xl\\:focus\\:bg-blue-800:focus {\n    --bg-opacity: 1;\n    background-color: #1e429f;\n    background-color: rgba(30, 66, 159, var(--bg-opacity));\n  }\n  .xl\\:focus\\:bg-blue-900:focus {\n    --bg-opacity: 1;\n    background-color: #233876;\n    background-color: rgba(35, 56, 118, var(--bg-opacity));\n  }\n  .xl\\:focus\\:bg-indigo-50:focus {\n    --bg-opacity: 1;\n    background-color: #f0f5ff;\n    background-color: rgba(240, 245, 255, var(--bg-opacity));\n  }\n  .xl\\:focus\\:bg-indigo-100:focus {\n    --bg-opacity: 1;\n    background-color: #e5edff;\n    background-color: rgba(229, 237, 255, var(--bg-opacity));\n  }\n  .xl\\:focus\\:bg-indigo-200:focus {\n    --bg-opacity: 1;\n    background-color: #cddbfe;\n    background-color: rgba(205, 219, 254, var(--bg-opacity));\n  }\n  .xl\\:focus\\:bg-indigo-300:focus {\n    --bg-opacity: 1;\n    background-color: #b4c6fc;\n    background-color: rgba(180, 198, 252, var(--bg-opacity));\n  }\n  .xl\\:focus\\:bg-indigo-400:focus {\n    --bg-opacity: 1;\n    background-color: #8da2fb;\n    background-color: rgba(141, 162, 251, var(--bg-opacity));\n  }\n  .xl\\:focus\\:bg-indigo-500:focus {\n    --bg-opacity: 1;\n    background-color: #6875f5;\n    background-color: rgba(104, 117, 245, var(--bg-opacity));\n  }\n  .xl\\:focus\\:bg-indigo-600:focus {\n    --bg-opacity: 1;\n    background-color: #5850ec;\n    background-color: rgba(88, 80, 236, var(--bg-opacity));\n  }\n  .xl\\:focus\\:bg-indigo-700:focus {\n    --bg-opacity: 1;\n    background-color: #5145cd;\n    background-color: rgba(81, 69, 205, var(--bg-opacity));\n  }\n  .xl\\:focus\\:bg-indigo-800:focus {\n    --bg-opacity: 1;\n    background-color: #42389d;\n    background-color: rgba(66, 56, 157, var(--bg-opacity));\n  }\n  .xl\\:focus\\:bg-indigo-900:focus {\n    --bg-opacity: 1;\n    background-color: #362f78;\n    background-color: rgba(54, 47, 120, var(--bg-opacity));\n  }\n  .xl\\:focus\\:bg-purple-50:focus {\n    --bg-opacity: 1;\n    background-color: #f6f5ff;\n    background-color: rgba(246, 245, 255, var(--bg-opacity));\n  }\n  .xl\\:focus\\:bg-purple-100:focus {\n    --bg-opacity: 1;\n    background-color: #edebfe;\n    background-color: rgba(237, 235, 254, var(--bg-opacity));\n  }\n  .xl\\:focus\\:bg-purple-200:focus {\n    --bg-opacity: 1;\n    background-color: #dcd7fe;\n    background-color: rgba(220, 215, 254, var(--bg-opacity));\n  }\n  .xl\\:focus\\:bg-purple-300:focus {\n    --bg-opacity: 1;\n    background-color: #cabffd;\n    background-color: rgba(202, 191, 253, var(--bg-opacity));\n  }\n  .xl\\:focus\\:bg-purple-400:focus {\n    --bg-opacity: 1;\n    background-color: #ac94fa;\n    background-color: rgba(172, 148, 250, var(--bg-opacity));\n  }\n  .xl\\:focus\\:bg-purple-500:focus {\n    --bg-opacity: 1;\n    background-color: #9061f9;\n    background-color: rgba(144, 97, 249, var(--bg-opacity));\n  }\n  .xl\\:focus\\:bg-purple-600:focus {\n    --bg-opacity: 1;\n    background-color: #7e3af2;\n    background-color: rgba(126, 58, 242, var(--bg-opacity));\n  }\n  .xl\\:focus\\:bg-purple-700:focus {\n    --bg-opacity: 1;\n    background-color: #6c2bd9;\n    background-color: rgba(108, 43, 217, var(--bg-opacity));\n  }\n  .xl\\:focus\\:bg-purple-800:focus {\n    --bg-opacity: 1;\n    background-color: #5521b5;\n    background-color: rgba(85, 33, 181, var(--bg-opacity));\n  }\n  .xl\\:focus\\:bg-purple-900:focus {\n    --bg-opacity: 1;\n    background-color: #4a1d96;\n    background-color: rgba(74, 29, 150, var(--bg-opacity));\n  }\n  .xl\\:focus\\:bg-pink-50:focus {\n    --bg-opacity: 1;\n    background-color: #fdf2f8;\n    background-color: rgba(253, 242, 248, var(--bg-opacity));\n  }\n  .xl\\:focus\\:bg-pink-100:focus {\n    --bg-opacity: 1;\n    background-color: #fce8f3;\n    background-color: rgba(252, 232, 243, var(--bg-opacity));\n  }\n  .xl\\:focus\\:bg-pink-200:focus {\n    --bg-opacity: 1;\n    background-color: #fad1e8;\n    background-color: rgba(250, 209, 232, var(--bg-opacity));\n  }\n  .xl\\:focus\\:bg-pink-300:focus {\n    --bg-opacity: 1;\n    background-color: #f8b4d9;\n    background-color: rgba(248, 180, 217, var(--bg-opacity));\n  }\n  .xl\\:focus\\:bg-pink-400:focus {\n    --bg-opacity: 1;\n    background-color: #f17eb8;\n    background-color: rgba(241, 126, 184, var(--bg-opacity));\n  }\n  .xl\\:focus\\:bg-pink-500:focus {\n    --bg-opacity: 1;\n    background-color: #e74694;\n    background-color: rgba(231, 70, 148, var(--bg-opacity));\n  }\n  .xl\\:focus\\:bg-pink-600:focus {\n    --bg-opacity: 1;\n    background-color: #d61f69;\n    background-color: rgba(214, 31, 105, var(--bg-opacity));\n  }\n  .xl\\:focus\\:bg-pink-700:focus {\n    --bg-opacity: 1;\n    background-color: #bf125d;\n    background-color: rgba(191, 18, 93, var(--bg-opacity));\n  }\n  .xl\\:focus\\:bg-pink-800:focus {\n    --bg-opacity: 1;\n    background-color: #99154b;\n    background-color: rgba(153, 21, 75, var(--bg-opacity));\n  }\n  .xl\\:focus\\:bg-pink-900:focus {\n    --bg-opacity: 1;\n    background-color: #751a3d;\n    background-color: rgba(117, 26, 61, var(--bg-opacity));\n  }\n  .xl\\:focus\\:bg-cool-gray-50:focus {\n    --bg-opacity: 1;\n    background-color: #f8fafc;\n    background-color: rgba(248, 250, 252, var(--bg-opacity));\n  }\n  .xl\\:focus\\:bg-cool-gray-100:focus {\n    --bg-opacity: 1;\n    background-color: #f1f5f9;\n    background-color: rgba(241, 245, 249, var(--bg-opacity));\n  }\n  .xl\\:focus\\:bg-cool-gray-200:focus {\n    --bg-opacity: 1;\n    background-color: #e2e8f0;\n    background-color: rgba(226, 232, 240, var(--bg-opacity));\n  }\n  .xl\\:focus\\:bg-cool-gray-300:focus {\n    --bg-opacity: 1;\n    background-color: #cfd8e3;\n    background-color: rgba(207, 216, 227, var(--bg-opacity));\n  }\n  .xl\\:focus\\:bg-cool-gray-400:focus {\n    --bg-opacity: 1;\n    background-color: #97a6ba;\n    background-color: rgba(151, 166, 186, var(--bg-opacity));\n  }\n  .xl\\:focus\\:bg-cool-gray-500:focus {\n    --bg-opacity: 1;\n    background-color: #64748b;\n    background-color: rgba(100, 116, 139, var(--bg-opacity));\n  }\n  .xl\\:focus\\:bg-cool-gray-600:focus {\n    --bg-opacity: 1;\n    background-color: #475569;\n    background-color: rgba(71, 85, 105, var(--bg-opacity));\n  }\n  .xl\\:focus\\:bg-cool-gray-700:focus {\n    --bg-opacity: 1;\n    background-color: #364152;\n    background-color: rgba(54, 65, 82, var(--bg-opacity));\n  }\n  .xl\\:focus\\:bg-cool-gray-800:focus {\n    --bg-opacity: 1;\n    background-color: #27303f;\n    background-color: rgba(39, 48, 63, var(--bg-opacity));\n  }\n  .xl\\:focus\\:bg-cool-gray-900:focus {\n    --bg-opacity: 1;\n    background-color: #1a202e;\n    background-color: rgba(26, 32, 46, var(--bg-opacity));\n  }\n  .xl\\:active\\:bg-current:active {\n    background-color: currentColor;\n  }\n  .xl\\:active\\:bg-transparent:active {\n    background-color: transparent;\n  }\n  .xl\\:active\\:bg-white:active {\n    --bg-opacity: 1;\n    background-color: #ffffff;\n    background-color: rgba(255, 255, 255, var(--bg-opacity));\n  }\n  .xl\\:active\\:bg-black:active {\n    --bg-opacity: 1;\n    background-color: #000000;\n    background-color: rgba(0, 0, 0, var(--bg-opacity));\n  }\n  .xl\\:active\\:bg-gray-50:active {\n    --bg-opacity: 1;\n    background-color: #f9fafb;\n    background-color: rgba(249, 250, 251, var(--bg-opacity));\n  }\n  .xl\\:active\\:bg-gray-100:active {\n    --bg-opacity: 1;\n    background-color: #f4f5f7;\n    background-color: rgba(244, 245, 247, var(--bg-opacity));\n  }\n  .xl\\:active\\:bg-gray-200:active {\n    --bg-opacity: 1;\n    background-color: #e5e7eb;\n    background-color: rgba(229, 231, 235, var(--bg-opacity));\n  }\n  .xl\\:active\\:bg-gray-300:active {\n    --bg-opacity: 1;\n    background-color: #d2d6dc;\n    background-color: rgba(210, 214, 220, var(--bg-opacity));\n  }\n  .xl\\:active\\:bg-gray-400:active {\n    --bg-opacity: 1;\n    background-color: #9fa6b2;\n    background-color: rgba(159, 166, 178, var(--bg-opacity));\n  }\n  .xl\\:active\\:bg-gray-500:active {\n    --bg-opacity: 1;\n    background-color: #6b7280;\n    background-color: rgba(107, 114, 128, var(--bg-opacity));\n  }\n  .xl\\:active\\:bg-gray-600:active {\n    --bg-opacity: 1;\n    background-color: #4b5563;\n    background-color: rgba(75, 85, 99, var(--bg-opacity));\n  }\n  .xl\\:active\\:bg-gray-700:active {\n    --bg-opacity: 1;\n    background-color: #374151;\n    background-color: rgba(55, 65, 81, var(--bg-opacity));\n  }\n  .xl\\:active\\:bg-gray-800:active {\n    --bg-opacity: 1;\n    background-color: #252f3f;\n    background-color: rgba(37, 47, 63, var(--bg-opacity));\n  }\n  .xl\\:active\\:bg-gray-900:active {\n    --bg-opacity: 1;\n    background-color: #161e2e;\n    background-color: rgba(22, 30, 46, var(--bg-opacity));\n  }\n  .xl\\:active\\:bg-red-50:active {\n    --bg-opacity: 1;\n    background-color: #fdf2f2;\n    background-color: rgba(253, 242, 242, var(--bg-opacity));\n  }\n  .xl\\:active\\:bg-red-100:active {\n    --bg-opacity: 1;\n    background-color: #fde8e8;\n    background-color: rgba(253, 232, 232, var(--bg-opacity));\n  }\n  .xl\\:active\\:bg-red-200:active {\n    --bg-opacity: 1;\n    background-color: #fbd5d5;\n    background-color: rgba(251, 213, 213, var(--bg-opacity));\n  }\n  .xl\\:active\\:bg-red-300:active {\n    --bg-opacity: 1;\n    background-color: #f8b4b4;\n    background-color: rgba(248, 180, 180, var(--bg-opacity));\n  }\n  .xl\\:active\\:bg-red-400:active {\n    --bg-opacity: 1;\n    background-color: #f98080;\n    background-color: rgba(249, 128, 128, var(--bg-opacity));\n  }\n  .xl\\:active\\:bg-red-500:active {\n    --bg-opacity: 1;\n    background-color: #f05252;\n    background-color: rgba(240, 82, 82, var(--bg-opacity));\n  }\n  .xl\\:active\\:bg-red-600:active {\n    --bg-opacity: 1;\n    background-color: #e02424;\n    background-color: rgba(224, 36, 36, var(--bg-opacity));\n  }\n  .xl\\:active\\:bg-red-700:active {\n    --bg-opacity: 1;\n    background-color: #c81e1e;\n    background-color: rgba(200, 30, 30, var(--bg-opacity));\n  }\n  .xl\\:active\\:bg-red-800:active {\n    --bg-opacity: 1;\n    background-color: #9b1c1c;\n    background-color: rgba(155, 28, 28, var(--bg-opacity));\n  }\n  .xl\\:active\\:bg-red-900:active {\n    --bg-opacity: 1;\n    background-color: #771d1d;\n    background-color: rgba(119, 29, 29, var(--bg-opacity));\n  }\n  .xl\\:active\\:bg-orange-50:active {\n    --bg-opacity: 1;\n    background-color: #fff8f1;\n    background-color: rgba(255, 248, 241, var(--bg-opacity));\n  }\n  .xl\\:active\\:bg-orange-100:active {\n    --bg-opacity: 1;\n    background-color: #feecdc;\n    background-color: rgba(254, 236, 220, var(--bg-opacity));\n  }\n  .xl\\:active\\:bg-orange-200:active {\n    --bg-opacity: 1;\n    background-color: #fcd9bd;\n    background-color: rgba(252, 217, 189, var(--bg-opacity));\n  }\n  .xl\\:active\\:bg-orange-300:active {\n    --bg-opacity: 1;\n    background-color: #fdba8c;\n    background-color: rgba(253, 186, 140, var(--bg-opacity));\n  }\n  .xl\\:active\\:bg-orange-400:active {\n    --bg-opacity: 1;\n    background-color: #ff8a4c;\n    background-color: rgba(255, 138, 76, var(--bg-opacity));\n  }\n  .xl\\:active\\:bg-orange-500:active {\n    --bg-opacity: 1;\n    background-color: #ff5a1f;\n    background-color: rgba(255, 90, 31, var(--bg-opacity));\n  }\n  .xl\\:active\\:bg-orange-600:active {\n    --bg-opacity: 1;\n    background-color: #d03801;\n    background-color: rgba(208, 56, 1, var(--bg-opacity));\n  }\n  .xl\\:active\\:bg-orange-700:active {\n    --bg-opacity: 1;\n    background-color: #b43403;\n    background-color: rgba(180, 52, 3, var(--bg-opacity));\n  }\n  .xl\\:active\\:bg-orange-800:active {\n    --bg-opacity: 1;\n    background-color: #8a2c0d;\n    background-color: rgba(138, 44, 13, var(--bg-opacity));\n  }\n  .xl\\:active\\:bg-orange-900:active {\n    --bg-opacity: 1;\n    background-color: #73230d;\n    background-color: rgba(115, 35, 13, var(--bg-opacity));\n  }\n  .xl\\:active\\:bg-yellow-50:active {\n    --bg-opacity: 1;\n    background-color: #fdfdea;\n    background-color: rgba(253, 253, 234, var(--bg-opacity));\n  }\n  .xl\\:active\\:bg-yellow-100:active {\n    --bg-opacity: 1;\n    background-color: #fdf6b2;\n    background-color: rgba(253, 246, 178, var(--bg-opacity));\n  }\n  .xl\\:active\\:bg-yellow-200:active {\n    --bg-opacity: 1;\n    background-color: #fce96a;\n    background-color: rgba(252, 233, 106, var(--bg-opacity));\n  }\n  .xl\\:active\\:bg-yellow-300:active {\n    --bg-opacity: 1;\n    background-color: #faca15;\n    background-color: rgba(250, 202, 21, var(--bg-opacity));\n  }\n  .xl\\:active\\:bg-yellow-400:active {\n    --bg-opacity: 1;\n    background-color: #e3a008;\n    background-color: rgba(227, 160, 8, var(--bg-opacity));\n  }\n  .xl\\:active\\:bg-yellow-500:active {\n    --bg-opacity: 1;\n    background-color: #c27803;\n    background-color: rgba(194, 120, 3, var(--bg-opacity));\n  }\n  .xl\\:active\\:bg-yellow-600:active {\n    --bg-opacity: 1;\n    background-color: #9f580a;\n    background-color: rgba(159, 88, 10, var(--bg-opacity));\n  }\n  .xl\\:active\\:bg-yellow-700:active {\n    --bg-opacity: 1;\n    background-color: #8e4b10;\n    background-color: rgba(142, 75, 16, var(--bg-opacity));\n  }\n  .xl\\:active\\:bg-yellow-800:active {\n    --bg-opacity: 1;\n    background-color: #723b13;\n    background-color: rgba(114, 59, 19, var(--bg-opacity));\n  }\n  .xl\\:active\\:bg-yellow-900:active {\n    --bg-opacity: 1;\n    background-color: #633112;\n    background-color: rgba(99, 49, 18, var(--bg-opacity));\n  }\n  .xl\\:active\\:bg-green-50:active {\n    --bg-opacity: 1;\n    background-color: #f3faf7;\n    background-color: rgba(243, 250, 247, var(--bg-opacity));\n  }\n  .xl\\:active\\:bg-green-100:active {\n    --bg-opacity: 1;\n    background-color: #def7ec;\n    background-color: rgba(222, 247, 236, var(--bg-opacity));\n  }\n  .xl\\:active\\:bg-green-200:active {\n    --bg-opacity: 1;\n    background-color: #bcf0da;\n    background-color: rgba(188, 240, 218, var(--bg-opacity));\n  }\n  .xl\\:active\\:bg-green-300:active {\n    --bg-opacity: 1;\n    background-color: #84e1bc;\n    background-color: rgba(132, 225, 188, var(--bg-opacity));\n  }\n  .xl\\:active\\:bg-green-400:active {\n    --bg-opacity: 1;\n    background-color: #31c48d;\n    background-color: rgba(49, 196, 141, var(--bg-opacity));\n  }\n  .xl\\:active\\:bg-green-500:active {\n    --bg-opacity: 1;\n    background-color: #0e9f6e;\n    background-color: rgba(14, 159, 110, var(--bg-opacity));\n  }\n  .xl\\:active\\:bg-green-600:active {\n    --bg-opacity: 1;\n    background-color: #057a55;\n    background-color: rgba(5, 122, 85, var(--bg-opacity));\n  }\n  .xl\\:active\\:bg-green-700:active {\n    --bg-opacity: 1;\n    background-color: #046c4e;\n    background-color: rgba(4, 108, 78, var(--bg-opacity));\n  }\n  .xl\\:active\\:bg-green-800:active {\n    --bg-opacity: 1;\n    background-color: #03543f;\n    background-color: rgba(3, 84, 63, var(--bg-opacity));\n  }\n  .xl\\:active\\:bg-green-900:active {\n    --bg-opacity: 1;\n    background-color: #014737;\n    background-color: rgba(1, 71, 55, var(--bg-opacity));\n  }\n  .xl\\:active\\:bg-teal-50:active {\n    --bg-opacity: 1;\n    background-color: #edfafa;\n    background-color: rgba(237, 250, 250, var(--bg-opacity));\n  }\n  .xl\\:active\\:bg-teal-100:active {\n    --bg-opacity: 1;\n    background-color: #d5f5f6;\n    background-color: rgba(213, 245, 246, var(--bg-opacity));\n  }\n  .xl\\:active\\:bg-teal-200:active {\n    --bg-opacity: 1;\n    background-color: #afecef;\n    background-color: rgba(175, 236, 239, var(--bg-opacity));\n  }\n  .xl\\:active\\:bg-teal-300:active {\n    --bg-opacity: 1;\n    background-color: #7edce2;\n    background-color: rgba(126, 220, 226, var(--bg-opacity));\n  }\n  .xl\\:active\\:bg-teal-400:active {\n    --bg-opacity: 1;\n    background-color: #16bdca;\n    background-color: rgba(22, 189, 202, var(--bg-opacity));\n  }\n  .xl\\:active\\:bg-teal-500:active {\n    --bg-opacity: 1;\n    background-color: #0694a2;\n    background-color: rgba(6, 148, 162, var(--bg-opacity));\n  }\n  .xl\\:active\\:bg-teal-600:active {\n    --bg-opacity: 1;\n    background-color: #047481;\n    background-color: rgba(4, 116, 129, var(--bg-opacity));\n  }\n  .xl\\:active\\:bg-teal-700:active {\n    --bg-opacity: 1;\n    background-color: #036672;\n    background-color: rgba(3, 102, 114, var(--bg-opacity));\n  }\n  .xl\\:active\\:bg-teal-800:active {\n    --bg-opacity: 1;\n    background-color: #05505c;\n    background-color: rgba(5, 80, 92, var(--bg-opacity));\n  }\n  .xl\\:active\\:bg-teal-900:active {\n    --bg-opacity: 1;\n    background-color: #014451;\n    background-color: rgba(1, 68, 81, var(--bg-opacity));\n  }\n  .xl\\:active\\:bg-blue-50:active {\n    --bg-opacity: 1;\n    background-color: #ebf5ff;\n    background-color: rgba(235, 245, 255, var(--bg-opacity));\n  }\n  .xl\\:active\\:bg-blue-100:active {\n    --bg-opacity: 1;\n    background-color: #e1effe;\n    background-color: rgba(225, 239, 254, var(--bg-opacity));\n  }\n  .xl\\:active\\:bg-blue-200:active {\n    --bg-opacity: 1;\n    background-color: #c3ddfd;\n    background-color: rgba(195, 221, 253, var(--bg-opacity));\n  }\n  .xl\\:active\\:bg-blue-300:active {\n    --bg-opacity: 1;\n    background-color: #a4cafe;\n    background-color: rgba(164, 202, 254, var(--bg-opacity));\n  }\n  .xl\\:active\\:bg-blue-400:active {\n    --bg-opacity: 1;\n    background-color: #76a9fa;\n    background-color: rgba(118, 169, 250, var(--bg-opacity));\n  }\n  .xl\\:active\\:bg-blue-500:active {\n    --bg-opacity: 1;\n    background-color: #3f83f8;\n    background-color: rgba(63, 131, 248, var(--bg-opacity));\n  }\n  .xl\\:active\\:bg-blue-600:active {\n    --bg-opacity: 1;\n    background-color: #1c64f2;\n    background-color: rgba(28, 100, 242, var(--bg-opacity));\n  }\n  .xl\\:active\\:bg-blue-700:active {\n    --bg-opacity: 1;\n    background-color: #1a56db;\n    background-color: rgba(26, 86, 219, var(--bg-opacity));\n  }\n  .xl\\:active\\:bg-blue-800:active {\n    --bg-opacity: 1;\n    background-color: #1e429f;\n    background-color: rgba(30, 66, 159, var(--bg-opacity));\n  }\n  .xl\\:active\\:bg-blue-900:active {\n    --bg-opacity: 1;\n    background-color: #233876;\n    background-color: rgba(35, 56, 118, var(--bg-opacity));\n  }\n  .xl\\:active\\:bg-indigo-50:active {\n    --bg-opacity: 1;\n    background-color: #f0f5ff;\n    background-color: rgba(240, 245, 255, var(--bg-opacity));\n  }\n  .xl\\:active\\:bg-indigo-100:active {\n    --bg-opacity: 1;\n    background-color: #e5edff;\n    background-color: rgba(229, 237, 255, var(--bg-opacity));\n  }\n  .xl\\:active\\:bg-indigo-200:active {\n    --bg-opacity: 1;\n    background-color: #cddbfe;\n    background-color: rgba(205, 219, 254, var(--bg-opacity));\n  }\n  .xl\\:active\\:bg-indigo-300:active {\n    --bg-opacity: 1;\n    background-color: #b4c6fc;\n    background-color: rgba(180, 198, 252, var(--bg-opacity));\n  }\n  .xl\\:active\\:bg-indigo-400:active {\n    --bg-opacity: 1;\n    background-color: #8da2fb;\n    background-color: rgba(141, 162, 251, var(--bg-opacity));\n  }\n  .xl\\:active\\:bg-indigo-500:active {\n    --bg-opacity: 1;\n    background-color: #6875f5;\n    background-color: rgba(104, 117, 245, var(--bg-opacity));\n  }\n  .xl\\:active\\:bg-indigo-600:active {\n    --bg-opacity: 1;\n    background-color: #5850ec;\n    background-color: rgba(88, 80, 236, var(--bg-opacity));\n  }\n  .xl\\:active\\:bg-indigo-700:active {\n    --bg-opacity: 1;\n    background-color: #5145cd;\n    background-color: rgba(81, 69, 205, var(--bg-opacity));\n  }\n  .xl\\:active\\:bg-indigo-800:active {\n    --bg-opacity: 1;\n    background-color: #42389d;\n    background-color: rgba(66, 56, 157, var(--bg-opacity));\n  }\n  .xl\\:active\\:bg-indigo-900:active {\n    --bg-opacity: 1;\n    background-color: #362f78;\n    background-color: rgba(54, 47, 120, var(--bg-opacity));\n  }\n  .xl\\:active\\:bg-purple-50:active {\n    --bg-opacity: 1;\n    background-color: #f6f5ff;\n    background-color: rgba(246, 245, 255, var(--bg-opacity));\n  }\n  .xl\\:active\\:bg-purple-100:active {\n    --bg-opacity: 1;\n    background-color: #edebfe;\n    background-color: rgba(237, 235, 254, var(--bg-opacity));\n  }\n  .xl\\:active\\:bg-purple-200:active {\n    --bg-opacity: 1;\n    background-color: #dcd7fe;\n    background-color: rgba(220, 215, 254, var(--bg-opacity));\n  }\n  .xl\\:active\\:bg-purple-300:active {\n    --bg-opacity: 1;\n    background-color: #cabffd;\n    background-color: rgba(202, 191, 253, var(--bg-opacity));\n  }\n  .xl\\:active\\:bg-purple-400:active {\n    --bg-opacity: 1;\n    background-color: #ac94fa;\n    background-color: rgba(172, 148, 250, var(--bg-opacity));\n  }\n  .xl\\:active\\:bg-purple-500:active {\n    --bg-opacity: 1;\n    background-color: #9061f9;\n    background-color: rgba(144, 97, 249, var(--bg-opacity));\n  }\n  .xl\\:active\\:bg-purple-600:active {\n    --bg-opacity: 1;\n    background-color: #7e3af2;\n    background-color: rgba(126, 58, 242, var(--bg-opacity));\n  }\n  .xl\\:active\\:bg-purple-700:active {\n    --bg-opacity: 1;\n    background-color: #6c2bd9;\n    background-color: rgba(108, 43, 217, var(--bg-opacity));\n  }\n  .xl\\:active\\:bg-purple-800:active {\n    --bg-opacity: 1;\n    background-color: #5521b5;\n    background-color: rgba(85, 33, 181, var(--bg-opacity));\n  }\n  .xl\\:active\\:bg-purple-900:active {\n    --bg-opacity: 1;\n    background-color: #4a1d96;\n    background-color: rgba(74, 29, 150, var(--bg-opacity));\n  }\n  .xl\\:active\\:bg-pink-50:active {\n    --bg-opacity: 1;\n    background-color: #fdf2f8;\n    background-color: rgba(253, 242, 248, var(--bg-opacity));\n  }\n  .xl\\:active\\:bg-pink-100:active {\n    --bg-opacity: 1;\n    background-color: #fce8f3;\n    background-color: rgba(252, 232, 243, var(--bg-opacity));\n  }\n  .xl\\:active\\:bg-pink-200:active {\n    --bg-opacity: 1;\n    background-color: #fad1e8;\n    background-color: rgba(250, 209, 232, var(--bg-opacity));\n  }\n  .xl\\:active\\:bg-pink-300:active {\n    --bg-opacity: 1;\n    background-color: #f8b4d9;\n    background-color: rgba(248, 180, 217, var(--bg-opacity));\n  }\n  .xl\\:active\\:bg-pink-400:active {\n    --bg-opacity: 1;\n    background-color: #f17eb8;\n    background-color: rgba(241, 126, 184, var(--bg-opacity));\n  }\n  .xl\\:active\\:bg-pink-500:active {\n    --bg-opacity: 1;\n    background-color: #e74694;\n    background-color: rgba(231, 70, 148, var(--bg-opacity));\n  }\n  .xl\\:active\\:bg-pink-600:active {\n    --bg-opacity: 1;\n    background-color: #d61f69;\n    background-color: rgba(214, 31, 105, var(--bg-opacity));\n  }\n  .xl\\:active\\:bg-pink-700:active {\n    --bg-opacity: 1;\n    background-color: #bf125d;\n    background-color: rgba(191, 18, 93, var(--bg-opacity));\n  }\n  .xl\\:active\\:bg-pink-800:active {\n    --bg-opacity: 1;\n    background-color: #99154b;\n    background-color: rgba(153, 21, 75, var(--bg-opacity));\n  }\n  .xl\\:active\\:bg-pink-900:active {\n    --bg-opacity: 1;\n    background-color: #751a3d;\n    background-color: rgba(117, 26, 61, var(--bg-opacity));\n  }\n  .xl\\:active\\:bg-cool-gray-50:active {\n    --bg-opacity: 1;\n    background-color: #f8fafc;\n    background-color: rgba(248, 250, 252, var(--bg-opacity));\n  }\n  .xl\\:active\\:bg-cool-gray-100:active {\n    --bg-opacity: 1;\n    background-color: #f1f5f9;\n    background-color: rgba(241, 245, 249, var(--bg-opacity));\n  }\n  .xl\\:active\\:bg-cool-gray-200:active {\n    --bg-opacity: 1;\n    background-color: #e2e8f0;\n    background-color: rgba(226, 232, 240, var(--bg-opacity));\n  }\n  .xl\\:active\\:bg-cool-gray-300:active {\n    --bg-opacity: 1;\n    background-color: #cfd8e3;\n    background-color: rgba(207, 216, 227, var(--bg-opacity));\n  }\n  .xl\\:active\\:bg-cool-gray-400:active {\n    --bg-opacity: 1;\n    background-color: #97a6ba;\n    background-color: rgba(151, 166, 186, var(--bg-opacity));\n  }\n  .xl\\:active\\:bg-cool-gray-500:active {\n    --bg-opacity: 1;\n    background-color: #64748b;\n    background-color: rgba(100, 116, 139, var(--bg-opacity));\n  }\n  .xl\\:active\\:bg-cool-gray-600:active {\n    --bg-opacity: 1;\n    background-color: #475569;\n    background-color: rgba(71, 85, 105, var(--bg-opacity));\n  }\n  .xl\\:active\\:bg-cool-gray-700:active {\n    --bg-opacity: 1;\n    background-color: #364152;\n    background-color: rgba(54, 65, 82, var(--bg-opacity));\n  }\n  .xl\\:active\\:bg-cool-gray-800:active {\n    --bg-opacity: 1;\n    background-color: #27303f;\n    background-color: rgba(39, 48, 63, var(--bg-opacity));\n  }\n  .xl\\:active\\:bg-cool-gray-900:active {\n    --bg-opacity: 1;\n    background-color: #1a202e;\n    background-color: rgba(26, 32, 46, var(--bg-opacity));\n  }\n  .xl\\:bg-none {\n    background-image: none;\n  }\n  .xl\\:bg-gradient-to-t {\n    background-image: linear-gradient(to top, var(--gradient-color-stops));\n  }\n  .xl\\:bg-gradient-to-tr {\n    background-image: linear-gradient(to top right, var(--gradient-color-stops));\n  }\n  .xl\\:bg-gradient-to-r {\n    background-image: linear-gradient(to right, var(--gradient-color-stops));\n  }\n  .xl\\:bg-gradient-to-br {\n    background-image: linear-gradient(to bottom right, var(--gradient-color-stops));\n  }\n  .xl\\:bg-gradient-to-b {\n    background-image: linear-gradient(to bottom, var(--gradient-color-stops));\n  }\n  .xl\\:bg-gradient-to-bl {\n    background-image: linear-gradient(to bottom left, var(--gradient-color-stops));\n  }\n  .xl\\:bg-gradient-to-l {\n    background-image: linear-gradient(to left, var(--gradient-color-stops));\n  }\n  .xl\\:bg-gradient-to-tl {\n    background-image: linear-gradient(to top left, var(--gradient-color-stops));\n  }\n  .xl\\:from-current {\n    --gradient-from-color: currentColor;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));\n  }\n  .xl\\:from-transparent {\n    --gradient-from-color: transparent;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0));\n  }\n  .xl\\:from-white {\n    --gradient-from-color: #ffffff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));\n  }\n  .xl\\:from-black {\n    --gradient-from-color: #000000;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0));\n  }\n  .xl\\:from-gray-50 {\n    --gradient-from-color: #f9fafb;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(249, 250, 251, 0));\n  }\n  .xl\\:from-gray-100 {\n    --gradient-from-color: #f4f5f7;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(244, 245, 247, 0));\n  }\n  .xl\\:from-gray-200 {\n    --gradient-from-color: #e5e7eb;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(229, 231, 235, 0));\n  }\n  .xl\\:from-gray-300 {\n    --gradient-from-color: #d2d6dc;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(210, 214, 220, 0));\n  }\n  .xl\\:from-gray-400 {\n    --gradient-from-color: #9fa6b2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(159, 166, 178, 0));\n  }\n  .xl\\:from-gray-500 {\n    --gradient-from-color: #6b7280;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(107, 114, 128, 0));\n  }\n  .xl\\:from-gray-600 {\n    --gradient-from-color: #4b5563;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(75, 85, 99, 0));\n  }\n  .xl\\:from-gray-700 {\n    --gradient-from-color: #374151;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(55, 65, 81, 0));\n  }\n  .xl\\:from-gray-800 {\n    --gradient-from-color: #252f3f;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(37, 47, 63, 0));\n  }\n  .xl\\:from-gray-900 {\n    --gradient-from-color: #161e2e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(22, 30, 46, 0));\n  }\n  .xl\\:from-red-50 {\n    --gradient-from-color: #fdf2f2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 242, 242, 0));\n  }\n  .xl\\:from-red-100 {\n    --gradient-from-color: #fde8e8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 232, 232, 0));\n  }\n  .xl\\:from-red-200 {\n    --gradient-from-color: #fbd5d5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(251, 213, 213, 0));\n  }\n  .xl\\:from-red-300 {\n    --gradient-from-color: #f8b4b4;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(248, 180, 180, 0));\n  }\n  .xl\\:from-red-400 {\n    --gradient-from-color: #f98080;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(249, 128, 128, 0));\n  }\n  .xl\\:from-red-500 {\n    --gradient-from-color: #f05252;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(240, 82, 82, 0));\n  }\n  .xl\\:from-red-600 {\n    --gradient-from-color: #e02424;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(224, 36, 36, 0));\n  }\n  .xl\\:from-red-700 {\n    --gradient-from-color: #c81e1e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(200, 30, 30, 0));\n  }\n  .xl\\:from-red-800 {\n    --gradient-from-color: #9b1c1c;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(155, 28, 28, 0));\n  }\n  .xl\\:from-red-900 {\n    --gradient-from-color: #771d1d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(119, 29, 29, 0));\n  }\n  .xl\\:from-orange-50 {\n    --gradient-from-color: #fff8f1;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 248, 241, 0));\n  }\n  .xl\\:from-orange-100 {\n    --gradient-from-color: #feecdc;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 236, 220, 0));\n  }\n  .xl\\:from-orange-200 {\n    --gradient-from-color: #fcd9bd;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(252, 217, 189, 0));\n  }\n  .xl\\:from-orange-300 {\n    --gradient-from-color: #fdba8c;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 186, 140, 0));\n  }\n  .xl\\:from-orange-400 {\n    --gradient-from-color: #ff8a4c;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 138, 76, 0));\n  }\n  .xl\\:from-orange-500 {\n    --gradient-from-color: #ff5a1f;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 90, 31, 0));\n  }\n  .xl\\:from-orange-600 {\n    --gradient-from-color: #d03801;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(208, 56, 1, 0));\n  }\n  .xl\\:from-orange-700 {\n    --gradient-from-color: #b43403;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(180, 52, 3, 0));\n  }\n  .xl\\:from-orange-800 {\n    --gradient-from-color: #8a2c0d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(138, 44, 13, 0));\n  }\n  .xl\\:from-orange-900 {\n    --gradient-from-color: #73230d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(115, 35, 13, 0));\n  }\n  .xl\\:from-yellow-50 {\n    --gradient-from-color: #fdfdea;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 253, 234, 0));\n  }\n  .xl\\:from-yellow-100 {\n    --gradient-from-color: #fdf6b2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 246, 178, 0));\n  }\n  .xl\\:from-yellow-200 {\n    --gradient-from-color: #fce96a;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(252, 233, 106, 0));\n  }\n  .xl\\:from-yellow-300 {\n    --gradient-from-color: #faca15;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(250, 202, 21, 0));\n  }\n  .xl\\:from-yellow-400 {\n    --gradient-from-color: #e3a008;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(227, 160, 8, 0));\n  }\n  .xl\\:from-yellow-500 {\n    --gradient-from-color: #c27803;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(194, 120, 3, 0));\n  }\n  .xl\\:from-yellow-600 {\n    --gradient-from-color: #9f580a;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(159, 88, 10, 0));\n  }\n  .xl\\:from-yellow-700 {\n    --gradient-from-color: #8e4b10;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(142, 75, 16, 0));\n  }\n  .xl\\:from-yellow-800 {\n    --gradient-from-color: #723b13;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(114, 59, 19, 0));\n  }\n  .xl\\:from-yellow-900 {\n    --gradient-from-color: #633112;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(99, 49, 18, 0));\n  }\n  .xl\\:from-green-50 {\n    --gradient-from-color: #f3faf7;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(243, 250, 247, 0));\n  }\n  .xl\\:from-green-100 {\n    --gradient-from-color: #def7ec;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(222, 247, 236, 0));\n  }\n  .xl\\:from-green-200 {\n    --gradient-from-color: #bcf0da;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(188, 240, 218, 0));\n  }\n  .xl\\:from-green-300 {\n    --gradient-from-color: #84e1bc;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(132, 225, 188, 0));\n  }\n  .xl\\:from-green-400 {\n    --gradient-from-color: #31c48d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(49, 196, 141, 0));\n  }\n  .xl\\:from-green-500 {\n    --gradient-from-color: #0e9f6e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(14, 159, 110, 0));\n  }\n  .xl\\:from-green-600 {\n    --gradient-from-color: #057a55;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(5, 122, 85, 0));\n  }\n  .xl\\:from-green-700 {\n    --gradient-from-color: #046c4e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(4, 108, 78, 0));\n  }\n  .xl\\:from-green-800 {\n    --gradient-from-color: #03543f;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(3, 84, 63, 0));\n  }\n  .xl\\:from-green-900 {\n    --gradient-from-color: #014737;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(1, 71, 55, 0));\n  }\n  .xl\\:from-teal-50 {\n    --gradient-from-color: #edfafa;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(237, 250, 250, 0));\n  }\n  .xl\\:from-teal-100 {\n    --gradient-from-color: #d5f5f6;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(213, 245, 246, 0));\n  }\n  .xl\\:from-teal-200 {\n    --gradient-from-color: #afecef;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(175, 236, 239, 0));\n  }\n  .xl\\:from-teal-300 {\n    --gradient-from-color: #7edce2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(126, 220, 226, 0));\n  }\n  .xl\\:from-teal-400 {\n    --gradient-from-color: #16bdca;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(22, 189, 202, 0));\n  }\n  .xl\\:from-teal-500 {\n    --gradient-from-color: #0694a2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(6, 148, 162, 0));\n  }\n  .xl\\:from-teal-600 {\n    --gradient-from-color: #047481;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(4, 116, 129, 0));\n  }\n  .xl\\:from-teal-700 {\n    --gradient-from-color: #036672;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(3, 102, 114, 0));\n  }\n  .xl\\:from-teal-800 {\n    --gradient-from-color: #05505c;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(5, 80, 92, 0));\n  }\n  .xl\\:from-teal-900 {\n    --gradient-from-color: #014451;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(1, 68, 81, 0));\n  }\n  .xl\\:from-blue-50 {\n    --gradient-from-color: #ebf5ff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(235, 245, 255, 0));\n  }\n  .xl\\:from-blue-100 {\n    --gradient-from-color: #e1effe;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(225, 239, 254, 0));\n  }\n  .xl\\:from-blue-200 {\n    --gradient-from-color: #c3ddfd;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(195, 221, 253, 0));\n  }\n  .xl\\:from-blue-300 {\n    --gradient-from-color: #a4cafe;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(164, 202, 254, 0));\n  }\n  .xl\\:from-blue-400 {\n    --gradient-from-color: #76a9fa;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(118, 169, 250, 0));\n  }\n  .xl\\:from-blue-500 {\n    --gradient-from-color: #3f83f8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(63, 131, 248, 0));\n  }\n  .xl\\:from-blue-600 {\n    --gradient-from-color: #1c64f2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(28, 100, 242, 0));\n  }\n  .xl\\:from-blue-700 {\n    --gradient-from-color: #1a56db;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(26, 86, 219, 0));\n  }\n  .xl\\:from-blue-800 {\n    --gradient-from-color: #1e429f;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(30, 66, 159, 0));\n  }\n  .xl\\:from-blue-900 {\n    --gradient-from-color: #233876;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(35, 56, 118, 0));\n  }\n  .xl\\:from-indigo-50 {\n    --gradient-from-color: #f0f5ff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(240, 245, 255, 0));\n  }\n  .xl\\:from-indigo-100 {\n    --gradient-from-color: #e5edff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(229, 237, 255, 0));\n  }\n  .xl\\:from-indigo-200 {\n    --gradient-from-color: #cddbfe;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(205, 219, 254, 0));\n  }\n  .xl\\:from-indigo-300 {\n    --gradient-from-color: #b4c6fc;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(180, 198, 252, 0));\n  }\n  .xl\\:from-indigo-400 {\n    --gradient-from-color: #8da2fb;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(141, 162, 251, 0));\n  }\n  .xl\\:from-indigo-500 {\n    --gradient-from-color: #6875f5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(104, 117, 245, 0));\n  }\n  .xl\\:from-indigo-600 {\n    --gradient-from-color: #5850ec;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(88, 80, 236, 0));\n  }\n  .xl\\:from-indigo-700 {\n    --gradient-from-color: #5145cd;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(81, 69, 205, 0));\n  }\n  .xl\\:from-indigo-800 {\n    --gradient-from-color: #42389d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(66, 56, 157, 0));\n  }\n  .xl\\:from-indigo-900 {\n    --gradient-from-color: #362f78;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(54, 47, 120, 0));\n  }\n  .xl\\:from-purple-50 {\n    --gradient-from-color: #f6f5ff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(246, 245, 255, 0));\n  }\n  .xl\\:from-purple-100 {\n    --gradient-from-color: #edebfe;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(237, 235, 254, 0));\n  }\n  .xl\\:from-purple-200 {\n    --gradient-from-color: #dcd7fe;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(220, 215, 254, 0));\n  }\n  .xl\\:from-purple-300 {\n    --gradient-from-color: #cabffd;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(202, 191, 253, 0));\n  }\n  .xl\\:from-purple-400 {\n    --gradient-from-color: #ac94fa;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(172, 148, 250, 0));\n  }\n  .xl\\:from-purple-500 {\n    --gradient-from-color: #9061f9;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(144, 97, 249, 0));\n  }\n  .xl\\:from-purple-600 {\n    --gradient-from-color: #7e3af2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(126, 58, 242, 0));\n  }\n  .xl\\:from-purple-700 {\n    --gradient-from-color: #6c2bd9;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(108, 43, 217, 0));\n  }\n  .xl\\:from-purple-800 {\n    --gradient-from-color: #5521b5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(85, 33, 181, 0));\n  }\n  .xl\\:from-purple-900 {\n    --gradient-from-color: #4a1d96;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(74, 29, 150, 0));\n  }\n  .xl\\:from-pink-50 {\n    --gradient-from-color: #fdf2f8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 242, 248, 0));\n  }\n  .xl\\:from-pink-100 {\n    --gradient-from-color: #fce8f3;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(252, 232, 243, 0));\n  }\n  .xl\\:from-pink-200 {\n    --gradient-from-color: #fad1e8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(250, 209, 232, 0));\n  }\n  .xl\\:from-pink-300 {\n    --gradient-from-color: #f8b4d9;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(248, 180, 217, 0));\n  }\n  .xl\\:from-pink-400 {\n    --gradient-from-color: #f17eb8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(241, 126, 184, 0));\n  }\n  .xl\\:from-pink-500 {\n    --gradient-from-color: #e74694;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(231, 70, 148, 0));\n  }\n  .xl\\:from-pink-600 {\n    --gradient-from-color: #d61f69;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(214, 31, 105, 0));\n  }\n  .xl\\:from-pink-700 {\n    --gradient-from-color: #bf125d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(191, 18, 93, 0));\n  }\n  .xl\\:from-pink-800 {\n    --gradient-from-color: #99154b;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(153, 21, 75, 0));\n  }\n  .xl\\:from-pink-900 {\n    --gradient-from-color: #751a3d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(117, 26, 61, 0));\n  }\n  .xl\\:from-cool-gray-50 {\n    --gradient-from-color: #f8fafc;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(248, 250, 252, 0));\n  }\n  .xl\\:from-cool-gray-100 {\n    --gradient-from-color: #f1f5f9;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(241, 245, 249, 0));\n  }\n  .xl\\:from-cool-gray-200 {\n    --gradient-from-color: #e2e8f0;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(226, 232, 240, 0));\n  }\n  .xl\\:from-cool-gray-300 {\n    --gradient-from-color: #cfd8e3;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(207, 216, 227, 0));\n  }\n  .xl\\:from-cool-gray-400 {\n    --gradient-from-color: #97a6ba;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(151, 166, 186, 0));\n  }\n  .xl\\:from-cool-gray-500 {\n    --gradient-from-color: #64748b;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(100, 116, 139, 0));\n  }\n  .xl\\:from-cool-gray-600 {\n    --gradient-from-color: #475569;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(71, 85, 105, 0));\n  }\n  .xl\\:from-cool-gray-700 {\n    --gradient-from-color: #364152;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(54, 65, 82, 0));\n  }\n  .xl\\:from-cool-gray-800 {\n    --gradient-from-color: #27303f;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(39, 48, 63, 0));\n  }\n  .xl\\:from-cool-gray-900 {\n    --gradient-from-color: #1a202e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(26, 32, 46, 0));\n  }\n  .xl\\:via-current {\n    --gradient-via-color: currentColor;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));\n  }\n  .xl\\:via-transparent {\n    --gradient-via-color: transparent;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0));\n  }\n  .xl\\:via-white {\n    --gradient-via-color: #ffffff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));\n  }\n  .xl\\:via-black {\n    --gradient-via-color: #000000;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0));\n  }\n  .xl\\:via-gray-50 {\n    --gradient-via-color: #f9fafb;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(249, 250, 251, 0));\n  }\n  .xl\\:via-gray-100 {\n    --gradient-via-color: #f4f5f7;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(244, 245, 247, 0));\n  }\n  .xl\\:via-gray-200 {\n    --gradient-via-color: #e5e7eb;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(229, 231, 235, 0));\n  }\n  .xl\\:via-gray-300 {\n    --gradient-via-color: #d2d6dc;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(210, 214, 220, 0));\n  }\n  .xl\\:via-gray-400 {\n    --gradient-via-color: #9fa6b2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(159, 166, 178, 0));\n  }\n  .xl\\:via-gray-500 {\n    --gradient-via-color: #6b7280;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(107, 114, 128, 0));\n  }\n  .xl\\:via-gray-600 {\n    --gradient-via-color: #4b5563;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(75, 85, 99, 0));\n  }\n  .xl\\:via-gray-700 {\n    --gradient-via-color: #374151;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(55, 65, 81, 0));\n  }\n  .xl\\:via-gray-800 {\n    --gradient-via-color: #252f3f;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(37, 47, 63, 0));\n  }\n  .xl\\:via-gray-900 {\n    --gradient-via-color: #161e2e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(22, 30, 46, 0));\n  }\n  .xl\\:via-red-50 {\n    --gradient-via-color: #fdf2f2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 242, 242, 0));\n  }\n  .xl\\:via-red-100 {\n    --gradient-via-color: #fde8e8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 232, 232, 0));\n  }\n  .xl\\:via-red-200 {\n    --gradient-via-color: #fbd5d5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(251, 213, 213, 0));\n  }\n  .xl\\:via-red-300 {\n    --gradient-via-color: #f8b4b4;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(248, 180, 180, 0));\n  }\n  .xl\\:via-red-400 {\n    --gradient-via-color: #f98080;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(249, 128, 128, 0));\n  }\n  .xl\\:via-red-500 {\n    --gradient-via-color: #f05252;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(240, 82, 82, 0));\n  }\n  .xl\\:via-red-600 {\n    --gradient-via-color: #e02424;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(224, 36, 36, 0));\n  }\n  .xl\\:via-red-700 {\n    --gradient-via-color: #c81e1e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(200, 30, 30, 0));\n  }\n  .xl\\:via-red-800 {\n    --gradient-via-color: #9b1c1c;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(155, 28, 28, 0));\n  }\n  .xl\\:via-red-900 {\n    --gradient-via-color: #771d1d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(119, 29, 29, 0));\n  }\n  .xl\\:via-orange-50 {\n    --gradient-via-color: #fff8f1;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 248, 241, 0));\n  }\n  .xl\\:via-orange-100 {\n    --gradient-via-color: #feecdc;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 236, 220, 0));\n  }\n  .xl\\:via-orange-200 {\n    --gradient-via-color: #fcd9bd;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(252, 217, 189, 0));\n  }\n  .xl\\:via-orange-300 {\n    --gradient-via-color: #fdba8c;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 186, 140, 0));\n  }\n  .xl\\:via-orange-400 {\n    --gradient-via-color: #ff8a4c;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 138, 76, 0));\n  }\n  .xl\\:via-orange-500 {\n    --gradient-via-color: #ff5a1f;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 90, 31, 0));\n  }\n  .xl\\:via-orange-600 {\n    --gradient-via-color: #d03801;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(208, 56, 1, 0));\n  }\n  .xl\\:via-orange-700 {\n    --gradient-via-color: #b43403;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(180, 52, 3, 0));\n  }\n  .xl\\:via-orange-800 {\n    --gradient-via-color: #8a2c0d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(138, 44, 13, 0));\n  }\n  .xl\\:via-orange-900 {\n    --gradient-via-color: #73230d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(115, 35, 13, 0));\n  }\n  .xl\\:via-yellow-50 {\n    --gradient-via-color: #fdfdea;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 253, 234, 0));\n  }\n  .xl\\:via-yellow-100 {\n    --gradient-via-color: #fdf6b2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 246, 178, 0));\n  }\n  .xl\\:via-yellow-200 {\n    --gradient-via-color: #fce96a;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(252, 233, 106, 0));\n  }\n  .xl\\:via-yellow-300 {\n    --gradient-via-color: #faca15;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(250, 202, 21, 0));\n  }\n  .xl\\:via-yellow-400 {\n    --gradient-via-color: #e3a008;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(227, 160, 8, 0));\n  }\n  .xl\\:via-yellow-500 {\n    --gradient-via-color: #c27803;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(194, 120, 3, 0));\n  }\n  .xl\\:via-yellow-600 {\n    --gradient-via-color: #9f580a;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(159, 88, 10, 0));\n  }\n  .xl\\:via-yellow-700 {\n    --gradient-via-color: #8e4b10;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(142, 75, 16, 0));\n  }\n  .xl\\:via-yellow-800 {\n    --gradient-via-color: #723b13;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(114, 59, 19, 0));\n  }\n  .xl\\:via-yellow-900 {\n    --gradient-via-color: #633112;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(99, 49, 18, 0));\n  }\n  .xl\\:via-green-50 {\n    --gradient-via-color: #f3faf7;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(243, 250, 247, 0));\n  }\n  .xl\\:via-green-100 {\n    --gradient-via-color: #def7ec;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(222, 247, 236, 0));\n  }\n  .xl\\:via-green-200 {\n    --gradient-via-color: #bcf0da;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(188, 240, 218, 0));\n  }\n  .xl\\:via-green-300 {\n    --gradient-via-color: #84e1bc;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(132, 225, 188, 0));\n  }\n  .xl\\:via-green-400 {\n    --gradient-via-color: #31c48d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(49, 196, 141, 0));\n  }\n  .xl\\:via-green-500 {\n    --gradient-via-color: #0e9f6e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(14, 159, 110, 0));\n  }\n  .xl\\:via-green-600 {\n    --gradient-via-color: #057a55;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(5, 122, 85, 0));\n  }\n  .xl\\:via-green-700 {\n    --gradient-via-color: #046c4e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(4, 108, 78, 0));\n  }\n  .xl\\:via-green-800 {\n    --gradient-via-color: #03543f;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(3, 84, 63, 0));\n  }\n  .xl\\:via-green-900 {\n    --gradient-via-color: #014737;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(1, 71, 55, 0));\n  }\n  .xl\\:via-teal-50 {\n    --gradient-via-color: #edfafa;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(237, 250, 250, 0));\n  }\n  .xl\\:via-teal-100 {\n    --gradient-via-color: #d5f5f6;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(213, 245, 246, 0));\n  }\n  .xl\\:via-teal-200 {\n    --gradient-via-color: #afecef;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(175, 236, 239, 0));\n  }\n  .xl\\:via-teal-300 {\n    --gradient-via-color: #7edce2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(126, 220, 226, 0));\n  }\n  .xl\\:via-teal-400 {\n    --gradient-via-color: #16bdca;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(22, 189, 202, 0));\n  }\n  .xl\\:via-teal-500 {\n    --gradient-via-color: #0694a2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(6, 148, 162, 0));\n  }\n  .xl\\:via-teal-600 {\n    --gradient-via-color: #047481;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(4, 116, 129, 0));\n  }\n  .xl\\:via-teal-700 {\n    --gradient-via-color: #036672;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(3, 102, 114, 0));\n  }\n  .xl\\:via-teal-800 {\n    --gradient-via-color: #05505c;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(5, 80, 92, 0));\n  }\n  .xl\\:via-teal-900 {\n    --gradient-via-color: #014451;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(1, 68, 81, 0));\n  }\n  .xl\\:via-blue-50 {\n    --gradient-via-color: #ebf5ff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(235, 245, 255, 0));\n  }\n  .xl\\:via-blue-100 {\n    --gradient-via-color: #e1effe;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(225, 239, 254, 0));\n  }\n  .xl\\:via-blue-200 {\n    --gradient-via-color: #c3ddfd;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(195, 221, 253, 0));\n  }\n  .xl\\:via-blue-300 {\n    --gradient-via-color: #a4cafe;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(164, 202, 254, 0));\n  }\n  .xl\\:via-blue-400 {\n    --gradient-via-color: #76a9fa;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(118, 169, 250, 0));\n  }\n  .xl\\:via-blue-500 {\n    --gradient-via-color: #3f83f8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(63, 131, 248, 0));\n  }\n  .xl\\:via-blue-600 {\n    --gradient-via-color: #1c64f2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(28, 100, 242, 0));\n  }\n  .xl\\:via-blue-700 {\n    --gradient-via-color: #1a56db;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(26, 86, 219, 0));\n  }\n  .xl\\:via-blue-800 {\n    --gradient-via-color: #1e429f;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(30, 66, 159, 0));\n  }\n  .xl\\:via-blue-900 {\n    --gradient-via-color: #233876;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(35, 56, 118, 0));\n  }\n  .xl\\:via-indigo-50 {\n    --gradient-via-color: #f0f5ff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(240, 245, 255, 0));\n  }\n  .xl\\:via-indigo-100 {\n    --gradient-via-color: #e5edff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(229, 237, 255, 0));\n  }\n  .xl\\:via-indigo-200 {\n    --gradient-via-color: #cddbfe;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(205, 219, 254, 0));\n  }\n  .xl\\:via-indigo-300 {\n    --gradient-via-color: #b4c6fc;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(180, 198, 252, 0));\n  }\n  .xl\\:via-indigo-400 {\n    --gradient-via-color: #8da2fb;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(141, 162, 251, 0));\n  }\n  .xl\\:via-indigo-500 {\n    --gradient-via-color: #6875f5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(104, 117, 245, 0));\n  }\n  .xl\\:via-indigo-600 {\n    --gradient-via-color: #5850ec;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(88, 80, 236, 0));\n  }\n  .xl\\:via-indigo-700 {\n    --gradient-via-color: #5145cd;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(81, 69, 205, 0));\n  }\n  .xl\\:via-indigo-800 {\n    --gradient-via-color: #42389d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(66, 56, 157, 0));\n  }\n  .xl\\:via-indigo-900 {\n    --gradient-via-color: #362f78;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(54, 47, 120, 0));\n  }\n  .xl\\:via-purple-50 {\n    --gradient-via-color: #f6f5ff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(246, 245, 255, 0));\n  }\n  .xl\\:via-purple-100 {\n    --gradient-via-color: #edebfe;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(237, 235, 254, 0));\n  }\n  .xl\\:via-purple-200 {\n    --gradient-via-color: #dcd7fe;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(220, 215, 254, 0));\n  }\n  .xl\\:via-purple-300 {\n    --gradient-via-color: #cabffd;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(202, 191, 253, 0));\n  }\n  .xl\\:via-purple-400 {\n    --gradient-via-color: #ac94fa;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(172, 148, 250, 0));\n  }\n  .xl\\:via-purple-500 {\n    --gradient-via-color: #9061f9;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(144, 97, 249, 0));\n  }\n  .xl\\:via-purple-600 {\n    --gradient-via-color: #7e3af2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(126, 58, 242, 0));\n  }\n  .xl\\:via-purple-700 {\n    --gradient-via-color: #6c2bd9;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(108, 43, 217, 0));\n  }\n  .xl\\:via-purple-800 {\n    --gradient-via-color: #5521b5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(85, 33, 181, 0));\n  }\n  .xl\\:via-purple-900 {\n    --gradient-via-color: #4a1d96;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(74, 29, 150, 0));\n  }\n  .xl\\:via-pink-50 {\n    --gradient-via-color: #fdf2f8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 242, 248, 0));\n  }\n  .xl\\:via-pink-100 {\n    --gradient-via-color: #fce8f3;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(252, 232, 243, 0));\n  }\n  .xl\\:via-pink-200 {\n    --gradient-via-color: #fad1e8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(250, 209, 232, 0));\n  }\n  .xl\\:via-pink-300 {\n    --gradient-via-color: #f8b4d9;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(248, 180, 217, 0));\n  }\n  .xl\\:via-pink-400 {\n    --gradient-via-color: #f17eb8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(241, 126, 184, 0));\n  }\n  .xl\\:via-pink-500 {\n    --gradient-via-color: #e74694;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(231, 70, 148, 0));\n  }\n  .xl\\:via-pink-600 {\n    --gradient-via-color: #d61f69;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(214, 31, 105, 0));\n  }\n  .xl\\:via-pink-700 {\n    --gradient-via-color: #bf125d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(191, 18, 93, 0));\n  }\n  .xl\\:via-pink-800 {\n    --gradient-via-color: #99154b;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(153, 21, 75, 0));\n  }\n  .xl\\:via-pink-900 {\n    --gradient-via-color: #751a3d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(117, 26, 61, 0));\n  }\n  .xl\\:via-cool-gray-50 {\n    --gradient-via-color: #f8fafc;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(248, 250, 252, 0));\n  }\n  .xl\\:via-cool-gray-100 {\n    --gradient-via-color: #f1f5f9;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(241, 245, 249, 0));\n  }\n  .xl\\:via-cool-gray-200 {\n    --gradient-via-color: #e2e8f0;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(226, 232, 240, 0));\n  }\n  .xl\\:via-cool-gray-300 {\n    --gradient-via-color: #cfd8e3;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(207, 216, 227, 0));\n  }\n  .xl\\:via-cool-gray-400 {\n    --gradient-via-color: #97a6ba;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(151, 166, 186, 0));\n  }\n  .xl\\:via-cool-gray-500 {\n    --gradient-via-color: #64748b;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(100, 116, 139, 0));\n  }\n  .xl\\:via-cool-gray-600 {\n    --gradient-via-color: #475569;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(71, 85, 105, 0));\n  }\n  .xl\\:via-cool-gray-700 {\n    --gradient-via-color: #364152;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(54, 65, 82, 0));\n  }\n  .xl\\:via-cool-gray-800 {\n    --gradient-via-color: #27303f;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(39, 48, 63, 0));\n  }\n  .xl\\:via-cool-gray-900 {\n    --gradient-via-color: #1a202e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(26, 32, 46, 0));\n  }\n  .xl\\:to-current {\n    --gradient-to-color: currentColor;\n  }\n  .xl\\:to-transparent {\n    --gradient-to-color: transparent;\n  }\n  .xl\\:to-white {\n    --gradient-to-color: #ffffff;\n  }\n  .xl\\:to-black {\n    --gradient-to-color: #000000;\n  }\n  .xl\\:to-gray-50 {\n    --gradient-to-color: #f9fafb;\n  }\n  .xl\\:to-gray-100 {\n    --gradient-to-color: #f4f5f7;\n  }\n  .xl\\:to-gray-200 {\n    --gradient-to-color: #e5e7eb;\n  }\n  .xl\\:to-gray-300 {\n    --gradient-to-color: #d2d6dc;\n  }\n  .xl\\:to-gray-400 {\n    --gradient-to-color: #9fa6b2;\n  }\n  .xl\\:to-gray-500 {\n    --gradient-to-color: #6b7280;\n  }\n  .xl\\:to-gray-600 {\n    --gradient-to-color: #4b5563;\n  }\n  .xl\\:to-gray-700 {\n    --gradient-to-color: #374151;\n  }\n  .xl\\:to-gray-800 {\n    --gradient-to-color: #252f3f;\n  }\n  .xl\\:to-gray-900 {\n    --gradient-to-color: #161e2e;\n  }\n  .xl\\:to-red-50 {\n    --gradient-to-color: #fdf2f2;\n  }\n  .xl\\:to-red-100 {\n    --gradient-to-color: #fde8e8;\n  }\n  .xl\\:to-red-200 {\n    --gradient-to-color: #fbd5d5;\n  }\n  .xl\\:to-red-300 {\n    --gradient-to-color: #f8b4b4;\n  }\n  .xl\\:to-red-400 {\n    --gradient-to-color: #f98080;\n  }\n  .xl\\:to-red-500 {\n    --gradient-to-color: #f05252;\n  }\n  .xl\\:to-red-600 {\n    --gradient-to-color: #e02424;\n  }\n  .xl\\:to-red-700 {\n    --gradient-to-color: #c81e1e;\n  }\n  .xl\\:to-red-800 {\n    --gradient-to-color: #9b1c1c;\n  }\n  .xl\\:to-red-900 {\n    --gradient-to-color: #771d1d;\n  }\n  .xl\\:to-orange-50 {\n    --gradient-to-color: #fff8f1;\n  }\n  .xl\\:to-orange-100 {\n    --gradient-to-color: #feecdc;\n  }\n  .xl\\:to-orange-200 {\n    --gradient-to-color: #fcd9bd;\n  }\n  .xl\\:to-orange-300 {\n    --gradient-to-color: #fdba8c;\n  }\n  .xl\\:to-orange-400 {\n    --gradient-to-color: #ff8a4c;\n  }\n  .xl\\:to-orange-500 {\n    --gradient-to-color: #ff5a1f;\n  }\n  .xl\\:to-orange-600 {\n    --gradient-to-color: #d03801;\n  }\n  .xl\\:to-orange-700 {\n    --gradient-to-color: #b43403;\n  }\n  .xl\\:to-orange-800 {\n    --gradient-to-color: #8a2c0d;\n  }\n  .xl\\:to-orange-900 {\n    --gradient-to-color: #73230d;\n  }\n  .xl\\:to-yellow-50 {\n    --gradient-to-color: #fdfdea;\n  }\n  .xl\\:to-yellow-100 {\n    --gradient-to-color: #fdf6b2;\n  }\n  .xl\\:to-yellow-200 {\n    --gradient-to-color: #fce96a;\n  }\n  .xl\\:to-yellow-300 {\n    --gradient-to-color: #faca15;\n  }\n  .xl\\:to-yellow-400 {\n    --gradient-to-color: #e3a008;\n  }\n  .xl\\:to-yellow-500 {\n    --gradient-to-color: #c27803;\n  }\n  .xl\\:to-yellow-600 {\n    --gradient-to-color: #9f580a;\n  }\n  .xl\\:to-yellow-700 {\n    --gradient-to-color: #8e4b10;\n  }\n  .xl\\:to-yellow-800 {\n    --gradient-to-color: #723b13;\n  }\n  .xl\\:to-yellow-900 {\n    --gradient-to-color: #633112;\n  }\n  .xl\\:to-green-50 {\n    --gradient-to-color: #f3faf7;\n  }\n  .xl\\:to-green-100 {\n    --gradient-to-color: #def7ec;\n  }\n  .xl\\:to-green-200 {\n    --gradient-to-color: #bcf0da;\n  }\n  .xl\\:to-green-300 {\n    --gradient-to-color: #84e1bc;\n  }\n  .xl\\:to-green-400 {\n    --gradient-to-color: #31c48d;\n  }\n  .xl\\:to-green-500 {\n    --gradient-to-color: #0e9f6e;\n  }\n  .xl\\:to-green-600 {\n    --gradient-to-color: #057a55;\n  }\n  .xl\\:to-green-700 {\n    --gradient-to-color: #046c4e;\n  }\n  .xl\\:to-green-800 {\n    --gradient-to-color: #03543f;\n  }\n  .xl\\:to-green-900 {\n    --gradient-to-color: #014737;\n  }\n  .xl\\:to-teal-50 {\n    --gradient-to-color: #edfafa;\n  }\n  .xl\\:to-teal-100 {\n    --gradient-to-color: #d5f5f6;\n  }\n  .xl\\:to-teal-200 {\n    --gradient-to-color: #afecef;\n  }\n  .xl\\:to-teal-300 {\n    --gradient-to-color: #7edce2;\n  }\n  .xl\\:to-teal-400 {\n    --gradient-to-color: #16bdca;\n  }\n  .xl\\:to-teal-500 {\n    --gradient-to-color: #0694a2;\n  }\n  .xl\\:to-teal-600 {\n    --gradient-to-color: #047481;\n  }\n  .xl\\:to-teal-700 {\n    --gradient-to-color: #036672;\n  }\n  .xl\\:to-teal-800 {\n    --gradient-to-color: #05505c;\n  }\n  .xl\\:to-teal-900 {\n    --gradient-to-color: #014451;\n  }\n  .xl\\:to-blue-50 {\n    --gradient-to-color: #ebf5ff;\n  }\n  .xl\\:to-blue-100 {\n    --gradient-to-color: #e1effe;\n  }\n  .xl\\:to-blue-200 {\n    --gradient-to-color: #c3ddfd;\n  }\n  .xl\\:to-blue-300 {\n    --gradient-to-color: #a4cafe;\n  }\n  .xl\\:to-blue-400 {\n    --gradient-to-color: #76a9fa;\n  }\n  .xl\\:to-blue-500 {\n    --gradient-to-color: #3f83f8;\n  }\n  .xl\\:to-blue-600 {\n    --gradient-to-color: #1c64f2;\n  }\n  .xl\\:to-blue-700 {\n    --gradient-to-color: #1a56db;\n  }\n  .xl\\:to-blue-800 {\n    --gradient-to-color: #1e429f;\n  }\n  .xl\\:to-blue-900 {\n    --gradient-to-color: #233876;\n  }\n  .xl\\:to-indigo-50 {\n    --gradient-to-color: #f0f5ff;\n  }\n  .xl\\:to-indigo-100 {\n    --gradient-to-color: #e5edff;\n  }\n  .xl\\:to-indigo-200 {\n    --gradient-to-color: #cddbfe;\n  }\n  .xl\\:to-indigo-300 {\n    --gradient-to-color: #b4c6fc;\n  }\n  .xl\\:to-indigo-400 {\n    --gradient-to-color: #8da2fb;\n  }\n  .xl\\:to-indigo-500 {\n    --gradient-to-color: #6875f5;\n  }\n  .xl\\:to-indigo-600 {\n    --gradient-to-color: #5850ec;\n  }\n  .xl\\:to-indigo-700 {\n    --gradient-to-color: #5145cd;\n  }\n  .xl\\:to-indigo-800 {\n    --gradient-to-color: #42389d;\n  }\n  .xl\\:to-indigo-900 {\n    --gradient-to-color: #362f78;\n  }\n  .xl\\:to-purple-50 {\n    --gradient-to-color: #f6f5ff;\n  }\n  .xl\\:to-purple-100 {\n    --gradient-to-color: #edebfe;\n  }\n  .xl\\:to-purple-200 {\n    --gradient-to-color: #dcd7fe;\n  }\n  .xl\\:to-purple-300 {\n    --gradient-to-color: #cabffd;\n  }\n  .xl\\:to-purple-400 {\n    --gradient-to-color: #ac94fa;\n  }\n  .xl\\:to-purple-500 {\n    --gradient-to-color: #9061f9;\n  }\n  .xl\\:to-purple-600 {\n    --gradient-to-color: #7e3af2;\n  }\n  .xl\\:to-purple-700 {\n    --gradient-to-color: #6c2bd9;\n  }\n  .xl\\:to-purple-800 {\n    --gradient-to-color: #5521b5;\n  }\n  .xl\\:to-purple-900 {\n    --gradient-to-color: #4a1d96;\n  }\n  .xl\\:to-pink-50 {\n    --gradient-to-color: #fdf2f8;\n  }\n  .xl\\:to-pink-100 {\n    --gradient-to-color: #fce8f3;\n  }\n  .xl\\:to-pink-200 {\n    --gradient-to-color: #fad1e8;\n  }\n  .xl\\:to-pink-300 {\n    --gradient-to-color: #f8b4d9;\n  }\n  .xl\\:to-pink-400 {\n    --gradient-to-color: #f17eb8;\n  }\n  .xl\\:to-pink-500 {\n    --gradient-to-color: #e74694;\n  }\n  .xl\\:to-pink-600 {\n    --gradient-to-color: #d61f69;\n  }\n  .xl\\:to-pink-700 {\n    --gradient-to-color: #bf125d;\n  }\n  .xl\\:to-pink-800 {\n    --gradient-to-color: #99154b;\n  }\n  .xl\\:to-pink-900 {\n    --gradient-to-color: #751a3d;\n  }\n  .xl\\:to-cool-gray-50 {\n    --gradient-to-color: #f8fafc;\n  }\n  .xl\\:to-cool-gray-100 {\n    --gradient-to-color: #f1f5f9;\n  }\n  .xl\\:to-cool-gray-200 {\n    --gradient-to-color: #e2e8f0;\n  }\n  .xl\\:to-cool-gray-300 {\n    --gradient-to-color: #cfd8e3;\n  }\n  .xl\\:to-cool-gray-400 {\n    --gradient-to-color: #97a6ba;\n  }\n  .xl\\:to-cool-gray-500 {\n    --gradient-to-color: #64748b;\n  }\n  .xl\\:to-cool-gray-600 {\n    --gradient-to-color: #475569;\n  }\n  .xl\\:to-cool-gray-700 {\n    --gradient-to-color: #364152;\n  }\n  .xl\\:to-cool-gray-800 {\n    --gradient-to-color: #27303f;\n  }\n  .xl\\:to-cool-gray-900 {\n    --gradient-to-color: #1a202e;\n  }\n  .xl\\:hover\\:from-current:hover {\n    --gradient-from-color: currentColor;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));\n  }\n  .xl\\:hover\\:from-transparent:hover {\n    --gradient-from-color: transparent;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0));\n  }\n  .xl\\:hover\\:from-white:hover {\n    --gradient-from-color: #ffffff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));\n  }\n  .xl\\:hover\\:from-black:hover {\n    --gradient-from-color: #000000;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0));\n  }\n  .xl\\:hover\\:from-gray-50:hover {\n    --gradient-from-color: #f9fafb;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(249, 250, 251, 0));\n  }\n  .xl\\:hover\\:from-gray-100:hover {\n    --gradient-from-color: #f4f5f7;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(244, 245, 247, 0));\n  }\n  .xl\\:hover\\:from-gray-200:hover {\n    --gradient-from-color: #e5e7eb;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(229, 231, 235, 0));\n  }\n  .xl\\:hover\\:from-gray-300:hover {\n    --gradient-from-color: #d2d6dc;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(210, 214, 220, 0));\n  }\n  .xl\\:hover\\:from-gray-400:hover {\n    --gradient-from-color: #9fa6b2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(159, 166, 178, 0));\n  }\n  .xl\\:hover\\:from-gray-500:hover {\n    --gradient-from-color: #6b7280;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(107, 114, 128, 0));\n  }\n  .xl\\:hover\\:from-gray-600:hover {\n    --gradient-from-color: #4b5563;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(75, 85, 99, 0));\n  }\n  .xl\\:hover\\:from-gray-700:hover {\n    --gradient-from-color: #374151;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(55, 65, 81, 0));\n  }\n  .xl\\:hover\\:from-gray-800:hover {\n    --gradient-from-color: #252f3f;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(37, 47, 63, 0));\n  }\n  .xl\\:hover\\:from-gray-900:hover {\n    --gradient-from-color: #161e2e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(22, 30, 46, 0));\n  }\n  .xl\\:hover\\:from-red-50:hover {\n    --gradient-from-color: #fdf2f2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 242, 242, 0));\n  }\n  .xl\\:hover\\:from-red-100:hover {\n    --gradient-from-color: #fde8e8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 232, 232, 0));\n  }\n  .xl\\:hover\\:from-red-200:hover {\n    --gradient-from-color: #fbd5d5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(251, 213, 213, 0));\n  }\n  .xl\\:hover\\:from-red-300:hover {\n    --gradient-from-color: #f8b4b4;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(248, 180, 180, 0));\n  }\n  .xl\\:hover\\:from-red-400:hover {\n    --gradient-from-color: #f98080;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(249, 128, 128, 0));\n  }\n  .xl\\:hover\\:from-red-500:hover {\n    --gradient-from-color: #f05252;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(240, 82, 82, 0));\n  }\n  .xl\\:hover\\:from-red-600:hover {\n    --gradient-from-color: #e02424;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(224, 36, 36, 0));\n  }\n  .xl\\:hover\\:from-red-700:hover {\n    --gradient-from-color: #c81e1e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(200, 30, 30, 0));\n  }\n  .xl\\:hover\\:from-red-800:hover {\n    --gradient-from-color: #9b1c1c;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(155, 28, 28, 0));\n  }\n  .xl\\:hover\\:from-red-900:hover {\n    --gradient-from-color: #771d1d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(119, 29, 29, 0));\n  }\n  .xl\\:hover\\:from-orange-50:hover {\n    --gradient-from-color: #fff8f1;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 248, 241, 0));\n  }\n  .xl\\:hover\\:from-orange-100:hover {\n    --gradient-from-color: #feecdc;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 236, 220, 0));\n  }\n  .xl\\:hover\\:from-orange-200:hover {\n    --gradient-from-color: #fcd9bd;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(252, 217, 189, 0));\n  }\n  .xl\\:hover\\:from-orange-300:hover {\n    --gradient-from-color: #fdba8c;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 186, 140, 0));\n  }\n  .xl\\:hover\\:from-orange-400:hover {\n    --gradient-from-color: #ff8a4c;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 138, 76, 0));\n  }\n  .xl\\:hover\\:from-orange-500:hover {\n    --gradient-from-color: #ff5a1f;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 90, 31, 0));\n  }\n  .xl\\:hover\\:from-orange-600:hover {\n    --gradient-from-color: #d03801;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(208, 56, 1, 0));\n  }\n  .xl\\:hover\\:from-orange-700:hover {\n    --gradient-from-color: #b43403;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(180, 52, 3, 0));\n  }\n  .xl\\:hover\\:from-orange-800:hover {\n    --gradient-from-color: #8a2c0d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(138, 44, 13, 0));\n  }\n  .xl\\:hover\\:from-orange-900:hover {\n    --gradient-from-color: #73230d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(115, 35, 13, 0));\n  }\n  .xl\\:hover\\:from-yellow-50:hover {\n    --gradient-from-color: #fdfdea;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 253, 234, 0));\n  }\n  .xl\\:hover\\:from-yellow-100:hover {\n    --gradient-from-color: #fdf6b2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 246, 178, 0));\n  }\n  .xl\\:hover\\:from-yellow-200:hover {\n    --gradient-from-color: #fce96a;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(252, 233, 106, 0));\n  }\n  .xl\\:hover\\:from-yellow-300:hover {\n    --gradient-from-color: #faca15;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(250, 202, 21, 0));\n  }\n  .xl\\:hover\\:from-yellow-400:hover {\n    --gradient-from-color: #e3a008;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(227, 160, 8, 0));\n  }\n  .xl\\:hover\\:from-yellow-500:hover {\n    --gradient-from-color: #c27803;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(194, 120, 3, 0));\n  }\n  .xl\\:hover\\:from-yellow-600:hover {\n    --gradient-from-color: #9f580a;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(159, 88, 10, 0));\n  }\n  .xl\\:hover\\:from-yellow-700:hover {\n    --gradient-from-color: #8e4b10;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(142, 75, 16, 0));\n  }\n  .xl\\:hover\\:from-yellow-800:hover {\n    --gradient-from-color: #723b13;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(114, 59, 19, 0));\n  }\n  .xl\\:hover\\:from-yellow-900:hover {\n    --gradient-from-color: #633112;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(99, 49, 18, 0));\n  }\n  .xl\\:hover\\:from-green-50:hover {\n    --gradient-from-color: #f3faf7;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(243, 250, 247, 0));\n  }\n  .xl\\:hover\\:from-green-100:hover {\n    --gradient-from-color: #def7ec;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(222, 247, 236, 0));\n  }\n  .xl\\:hover\\:from-green-200:hover {\n    --gradient-from-color: #bcf0da;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(188, 240, 218, 0));\n  }\n  .xl\\:hover\\:from-green-300:hover {\n    --gradient-from-color: #84e1bc;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(132, 225, 188, 0));\n  }\n  .xl\\:hover\\:from-green-400:hover {\n    --gradient-from-color: #31c48d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(49, 196, 141, 0));\n  }\n  .xl\\:hover\\:from-green-500:hover {\n    --gradient-from-color: #0e9f6e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(14, 159, 110, 0));\n  }\n  .xl\\:hover\\:from-green-600:hover {\n    --gradient-from-color: #057a55;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(5, 122, 85, 0));\n  }\n  .xl\\:hover\\:from-green-700:hover {\n    --gradient-from-color: #046c4e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(4, 108, 78, 0));\n  }\n  .xl\\:hover\\:from-green-800:hover {\n    --gradient-from-color: #03543f;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(3, 84, 63, 0));\n  }\n  .xl\\:hover\\:from-green-900:hover {\n    --gradient-from-color: #014737;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(1, 71, 55, 0));\n  }\n  .xl\\:hover\\:from-teal-50:hover {\n    --gradient-from-color: #edfafa;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(237, 250, 250, 0));\n  }\n  .xl\\:hover\\:from-teal-100:hover {\n    --gradient-from-color: #d5f5f6;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(213, 245, 246, 0));\n  }\n  .xl\\:hover\\:from-teal-200:hover {\n    --gradient-from-color: #afecef;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(175, 236, 239, 0));\n  }\n  .xl\\:hover\\:from-teal-300:hover {\n    --gradient-from-color: #7edce2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(126, 220, 226, 0));\n  }\n  .xl\\:hover\\:from-teal-400:hover {\n    --gradient-from-color: #16bdca;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(22, 189, 202, 0));\n  }\n  .xl\\:hover\\:from-teal-500:hover {\n    --gradient-from-color: #0694a2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(6, 148, 162, 0));\n  }\n  .xl\\:hover\\:from-teal-600:hover {\n    --gradient-from-color: #047481;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(4, 116, 129, 0));\n  }\n  .xl\\:hover\\:from-teal-700:hover {\n    --gradient-from-color: #036672;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(3, 102, 114, 0));\n  }\n  .xl\\:hover\\:from-teal-800:hover {\n    --gradient-from-color: #05505c;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(5, 80, 92, 0));\n  }\n  .xl\\:hover\\:from-teal-900:hover {\n    --gradient-from-color: #014451;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(1, 68, 81, 0));\n  }\n  .xl\\:hover\\:from-blue-50:hover {\n    --gradient-from-color: #ebf5ff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(235, 245, 255, 0));\n  }\n  .xl\\:hover\\:from-blue-100:hover {\n    --gradient-from-color: #e1effe;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(225, 239, 254, 0));\n  }\n  .xl\\:hover\\:from-blue-200:hover {\n    --gradient-from-color: #c3ddfd;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(195, 221, 253, 0));\n  }\n  .xl\\:hover\\:from-blue-300:hover {\n    --gradient-from-color: #a4cafe;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(164, 202, 254, 0));\n  }\n  .xl\\:hover\\:from-blue-400:hover {\n    --gradient-from-color: #76a9fa;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(118, 169, 250, 0));\n  }\n  .xl\\:hover\\:from-blue-500:hover {\n    --gradient-from-color: #3f83f8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(63, 131, 248, 0));\n  }\n  .xl\\:hover\\:from-blue-600:hover {\n    --gradient-from-color: #1c64f2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(28, 100, 242, 0));\n  }\n  .xl\\:hover\\:from-blue-700:hover {\n    --gradient-from-color: #1a56db;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(26, 86, 219, 0));\n  }\n  .xl\\:hover\\:from-blue-800:hover {\n    --gradient-from-color: #1e429f;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(30, 66, 159, 0));\n  }\n  .xl\\:hover\\:from-blue-900:hover {\n    --gradient-from-color: #233876;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(35, 56, 118, 0));\n  }\n  .xl\\:hover\\:from-indigo-50:hover {\n    --gradient-from-color: #f0f5ff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(240, 245, 255, 0));\n  }\n  .xl\\:hover\\:from-indigo-100:hover {\n    --gradient-from-color: #e5edff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(229, 237, 255, 0));\n  }\n  .xl\\:hover\\:from-indigo-200:hover {\n    --gradient-from-color: #cddbfe;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(205, 219, 254, 0));\n  }\n  .xl\\:hover\\:from-indigo-300:hover {\n    --gradient-from-color: #b4c6fc;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(180, 198, 252, 0));\n  }\n  .xl\\:hover\\:from-indigo-400:hover {\n    --gradient-from-color: #8da2fb;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(141, 162, 251, 0));\n  }\n  .xl\\:hover\\:from-indigo-500:hover {\n    --gradient-from-color: #6875f5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(104, 117, 245, 0));\n  }\n  .xl\\:hover\\:from-indigo-600:hover {\n    --gradient-from-color: #5850ec;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(88, 80, 236, 0));\n  }\n  .xl\\:hover\\:from-indigo-700:hover {\n    --gradient-from-color: #5145cd;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(81, 69, 205, 0));\n  }\n  .xl\\:hover\\:from-indigo-800:hover {\n    --gradient-from-color: #42389d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(66, 56, 157, 0));\n  }\n  .xl\\:hover\\:from-indigo-900:hover {\n    --gradient-from-color: #362f78;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(54, 47, 120, 0));\n  }\n  .xl\\:hover\\:from-purple-50:hover {\n    --gradient-from-color: #f6f5ff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(246, 245, 255, 0));\n  }\n  .xl\\:hover\\:from-purple-100:hover {\n    --gradient-from-color: #edebfe;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(237, 235, 254, 0));\n  }\n  .xl\\:hover\\:from-purple-200:hover {\n    --gradient-from-color: #dcd7fe;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(220, 215, 254, 0));\n  }\n  .xl\\:hover\\:from-purple-300:hover {\n    --gradient-from-color: #cabffd;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(202, 191, 253, 0));\n  }\n  .xl\\:hover\\:from-purple-400:hover {\n    --gradient-from-color: #ac94fa;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(172, 148, 250, 0));\n  }\n  .xl\\:hover\\:from-purple-500:hover {\n    --gradient-from-color: #9061f9;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(144, 97, 249, 0));\n  }\n  .xl\\:hover\\:from-purple-600:hover {\n    --gradient-from-color: #7e3af2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(126, 58, 242, 0));\n  }\n  .xl\\:hover\\:from-purple-700:hover {\n    --gradient-from-color: #6c2bd9;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(108, 43, 217, 0));\n  }\n  .xl\\:hover\\:from-purple-800:hover {\n    --gradient-from-color: #5521b5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(85, 33, 181, 0));\n  }\n  .xl\\:hover\\:from-purple-900:hover {\n    --gradient-from-color: #4a1d96;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(74, 29, 150, 0));\n  }\n  .xl\\:hover\\:from-pink-50:hover {\n    --gradient-from-color: #fdf2f8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 242, 248, 0));\n  }\n  .xl\\:hover\\:from-pink-100:hover {\n    --gradient-from-color: #fce8f3;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(252, 232, 243, 0));\n  }\n  .xl\\:hover\\:from-pink-200:hover {\n    --gradient-from-color: #fad1e8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(250, 209, 232, 0));\n  }\n  .xl\\:hover\\:from-pink-300:hover {\n    --gradient-from-color: #f8b4d9;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(248, 180, 217, 0));\n  }\n  .xl\\:hover\\:from-pink-400:hover {\n    --gradient-from-color: #f17eb8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(241, 126, 184, 0));\n  }\n  .xl\\:hover\\:from-pink-500:hover {\n    --gradient-from-color: #e74694;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(231, 70, 148, 0));\n  }\n  .xl\\:hover\\:from-pink-600:hover {\n    --gradient-from-color: #d61f69;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(214, 31, 105, 0));\n  }\n  .xl\\:hover\\:from-pink-700:hover {\n    --gradient-from-color: #bf125d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(191, 18, 93, 0));\n  }\n  .xl\\:hover\\:from-pink-800:hover {\n    --gradient-from-color: #99154b;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(153, 21, 75, 0));\n  }\n  .xl\\:hover\\:from-pink-900:hover {\n    --gradient-from-color: #751a3d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(117, 26, 61, 0));\n  }\n  .xl\\:hover\\:from-cool-gray-50:hover {\n    --gradient-from-color: #f8fafc;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(248, 250, 252, 0));\n  }\n  .xl\\:hover\\:from-cool-gray-100:hover {\n    --gradient-from-color: #f1f5f9;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(241, 245, 249, 0));\n  }\n  .xl\\:hover\\:from-cool-gray-200:hover {\n    --gradient-from-color: #e2e8f0;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(226, 232, 240, 0));\n  }\n  .xl\\:hover\\:from-cool-gray-300:hover {\n    --gradient-from-color: #cfd8e3;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(207, 216, 227, 0));\n  }\n  .xl\\:hover\\:from-cool-gray-400:hover {\n    --gradient-from-color: #97a6ba;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(151, 166, 186, 0));\n  }\n  .xl\\:hover\\:from-cool-gray-500:hover {\n    --gradient-from-color: #64748b;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(100, 116, 139, 0));\n  }\n  .xl\\:hover\\:from-cool-gray-600:hover {\n    --gradient-from-color: #475569;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(71, 85, 105, 0));\n  }\n  .xl\\:hover\\:from-cool-gray-700:hover {\n    --gradient-from-color: #364152;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(54, 65, 82, 0));\n  }\n  .xl\\:hover\\:from-cool-gray-800:hover {\n    --gradient-from-color: #27303f;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(39, 48, 63, 0));\n  }\n  .xl\\:hover\\:from-cool-gray-900:hover {\n    --gradient-from-color: #1a202e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(26, 32, 46, 0));\n  }\n  .xl\\:hover\\:via-current:hover {\n    --gradient-via-color: currentColor;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));\n  }\n  .xl\\:hover\\:via-transparent:hover {\n    --gradient-via-color: transparent;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0));\n  }\n  .xl\\:hover\\:via-white:hover {\n    --gradient-via-color: #ffffff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));\n  }\n  .xl\\:hover\\:via-black:hover {\n    --gradient-via-color: #000000;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0));\n  }\n  .xl\\:hover\\:via-gray-50:hover {\n    --gradient-via-color: #f9fafb;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(249, 250, 251, 0));\n  }\n  .xl\\:hover\\:via-gray-100:hover {\n    --gradient-via-color: #f4f5f7;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(244, 245, 247, 0));\n  }\n  .xl\\:hover\\:via-gray-200:hover {\n    --gradient-via-color: #e5e7eb;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(229, 231, 235, 0));\n  }\n  .xl\\:hover\\:via-gray-300:hover {\n    --gradient-via-color: #d2d6dc;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(210, 214, 220, 0));\n  }\n  .xl\\:hover\\:via-gray-400:hover {\n    --gradient-via-color: #9fa6b2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(159, 166, 178, 0));\n  }\n  .xl\\:hover\\:via-gray-500:hover {\n    --gradient-via-color: #6b7280;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(107, 114, 128, 0));\n  }\n  .xl\\:hover\\:via-gray-600:hover {\n    --gradient-via-color: #4b5563;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(75, 85, 99, 0));\n  }\n  .xl\\:hover\\:via-gray-700:hover {\n    --gradient-via-color: #374151;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(55, 65, 81, 0));\n  }\n  .xl\\:hover\\:via-gray-800:hover {\n    --gradient-via-color: #252f3f;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(37, 47, 63, 0));\n  }\n  .xl\\:hover\\:via-gray-900:hover {\n    --gradient-via-color: #161e2e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(22, 30, 46, 0));\n  }\n  .xl\\:hover\\:via-red-50:hover {\n    --gradient-via-color: #fdf2f2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 242, 242, 0));\n  }\n  .xl\\:hover\\:via-red-100:hover {\n    --gradient-via-color: #fde8e8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 232, 232, 0));\n  }\n  .xl\\:hover\\:via-red-200:hover {\n    --gradient-via-color: #fbd5d5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(251, 213, 213, 0));\n  }\n  .xl\\:hover\\:via-red-300:hover {\n    --gradient-via-color: #f8b4b4;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(248, 180, 180, 0));\n  }\n  .xl\\:hover\\:via-red-400:hover {\n    --gradient-via-color: #f98080;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(249, 128, 128, 0));\n  }\n  .xl\\:hover\\:via-red-500:hover {\n    --gradient-via-color: #f05252;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(240, 82, 82, 0));\n  }\n  .xl\\:hover\\:via-red-600:hover {\n    --gradient-via-color: #e02424;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(224, 36, 36, 0));\n  }\n  .xl\\:hover\\:via-red-700:hover {\n    --gradient-via-color: #c81e1e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(200, 30, 30, 0));\n  }\n  .xl\\:hover\\:via-red-800:hover {\n    --gradient-via-color: #9b1c1c;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(155, 28, 28, 0));\n  }\n  .xl\\:hover\\:via-red-900:hover {\n    --gradient-via-color: #771d1d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(119, 29, 29, 0));\n  }\n  .xl\\:hover\\:via-orange-50:hover {\n    --gradient-via-color: #fff8f1;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 248, 241, 0));\n  }\n  .xl\\:hover\\:via-orange-100:hover {\n    --gradient-via-color: #feecdc;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 236, 220, 0));\n  }\n  .xl\\:hover\\:via-orange-200:hover {\n    --gradient-via-color: #fcd9bd;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(252, 217, 189, 0));\n  }\n  .xl\\:hover\\:via-orange-300:hover {\n    --gradient-via-color: #fdba8c;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 186, 140, 0));\n  }\n  .xl\\:hover\\:via-orange-400:hover {\n    --gradient-via-color: #ff8a4c;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 138, 76, 0));\n  }\n  .xl\\:hover\\:via-orange-500:hover {\n    --gradient-via-color: #ff5a1f;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 90, 31, 0));\n  }\n  .xl\\:hover\\:via-orange-600:hover {\n    --gradient-via-color: #d03801;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(208, 56, 1, 0));\n  }\n  .xl\\:hover\\:via-orange-700:hover {\n    --gradient-via-color: #b43403;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(180, 52, 3, 0));\n  }\n  .xl\\:hover\\:via-orange-800:hover {\n    --gradient-via-color: #8a2c0d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(138, 44, 13, 0));\n  }\n  .xl\\:hover\\:via-orange-900:hover {\n    --gradient-via-color: #73230d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(115, 35, 13, 0));\n  }\n  .xl\\:hover\\:via-yellow-50:hover {\n    --gradient-via-color: #fdfdea;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 253, 234, 0));\n  }\n  .xl\\:hover\\:via-yellow-100:hover {\n    --gradient-via-color: #fdf6b2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 246, 178, 0));\n  }\n  .xl\\:hover\\:via-yellow-200:hover {\n    --gradient-via-color: #fce96a;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(252, 233, 106, 0));\n  }\n  .xl\\:hover\\:via-yellow-300:hover {\n    --gradient-via-color: #faca15;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(250, 202, 21, 0));\n  }\n  .xl\\:hover\\:via-yellow-400:hover {\n    --gradient-via-color: #e3a008;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(227, 160, 8, 0));\n  }\n  .xl\\:hover\\:via-yellow-500:hover {\n    --gradient-via-color: #c27803;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(194, 120, 3, 0));\n  }\n  .xl\\:hover\\:via-yellow-600:hover {\n    --gradient-via-color: #9f580a;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(159, 88, 10, 0));\n  }\n  .xl\\:hover\\:via-yellow-700:hover {\n    --gradient-via-color: #8e4b10;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(142, 75, 16, 0));\n  }\n  .xl\\:hover\\:via-yellow-800:hover {\n    --gradient-via-color: #723b13;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(114, 59, 19, 0));\n  }\n  .xl\\:hover\\:via-yellow-900:hover {\n    --gradient-via-color: #633112;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(99, 49, 18, 0));\n  }\n  .xl\\:hover\\:via-green-50:hover {\n    --gradient-via-color: #f3faf7;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(243, 250, 247, 0));\n  }\n  .xl\\:hover\\:via-green-100:hover {\n    --gradient-via-color: #def7ec;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(222, 247, 236, 0));\n  }\n  .xl\\:hover\\:via-green-200:hover {\n    --gradient-via-color: #bcf0da;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(188, 240, 218, 0));\n  }\n  .xl\\:hover\\:via-green-300:hover {\n    --gradient-via-color: #84e1bc;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(132, 225, 188, 0));\n  }\n  .xl\\:hover\\:via-green-400:hover {\n    --gradient-via-color: #31c48d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(49, 196, 141, 0));\n  }\n  .xl\\:hover\\:via-green-500:hover {\n    --gradient-via-color: #0e9f6e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(14, 159, 110, 0));\n  }\n  .xl\\:hover\\:via-green-600:hover {\n    --gradient-via-color: #057a55;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(5, 122, 85, 0));\n  }\n  .xl\\:hover\\:via-green-700:hover {\n    --gradient-via-color: #046c4e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(4, 108, 78, 0));\n  }\n  .xl\\:hover\\:via-green-800:hover {\n    --gradient-via-color: #03543f;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(3, 84, 63, 0));\n  }\n  .xl\\:hover\\:via-green-900:hover {\n    --gradient-via-color: #014737;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(1, 71, 55, 0));\n  }\n  .xl\\:hover\\:via-teal-50:hover {\n    --gradient-via-color: #edfafa;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(237, 250, 250, 0));\n  }\n  .xl\\:hover\\:via-teal-100:hover {\n    --gradient-via-color: #d5f5f6;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(213, 245, 246, 0));\n  }\n  .xl\\:hover\\:via-teal-200:hover {\n    --gradient-via-color: #afecef;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(175, 236, 239, 0));\n  }\n  .xl\\:hover\\:via-teal-300:hover {\n    --gradient-via-color: #7edce2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(126, 220, 226, 0));\n  }\n  .xl\\:hover\\:via-teal-400:hover {\n    --gradient-via-color: #16bdca;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(22, 189, 202, 0));\n  }\n  .xl\\:hover\\:via-teal-500:hover {\n    --gradient-via-color: #0694a2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(6, 148, 162, 0));\n  }\n  .xl\\:hover\\:via-teal-600:hover {\n    --gradient-via-color: #047481;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(4, 116, 129, 0));\n  }\n  .xl\\:hover\\:via-teal-700:hover {\n    --gradient-via-color: #036672;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(3, 102, 114, 0));\n  }\n  .xl\\:hover\\:via-teal-800:hover {\n    --gradient-via-color: #05505c;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(5, 80, 92, 0));\n  }\n  .xl\\:hover\\:via-teal-900:hover {\n    --gradient-via-color: #014451;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(1, 68, 81, 0));\n  }\n  .xl\\:hover\\:via-blue-50:hover {\n    --gradient-via-color: #ebf5ff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(235, 245, 255, 0));\n  }\n  .xl\\:hover\\:via-blue-100:hover {\n    --gradient-via-color: #e1effe;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(225, 239, 254, 0));\n  }\n  .xl\\:hover\\:via-blue-200:hover {\n    --gradient-via-color: #c3ddfd;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(195, 221, 253, 0));\n  }\n  .xl\\:hover\\:via-blue-300:hover {\n    --gradient-via-color: #a4cafe;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(164, 202, 254, 0));\n  }\n  .xl\\:hover\\:via-blue-400:hover {\n    --gradient-via-color: #76a9fa;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(118, 169, 250, 0));\n  }\n  .xl\\:hover\\:via-blue-500:hover {\n    --gradient-via-color: #3f83f8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(63, 131, 248, 0));\n  }\n  .xl\\:hover\\:via-blue-600:hover {\n    --gradient-via-color: #1c64f2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(28, 100, 242, 0));\n  }\n  .xl\\:hover\\:via-blue-700:hover {\n    --gradient-via-color: #1a56db;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(26, 86, 219, 0));\n  }\n  .xl\\:hover\\:via-blue-800:hover {\n    --gradient-via-color: #1e429f;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(30, 66, 159, 0));\n  }\n  .xl\\:hover\\:via-blue-900:hover {\n    --gradient-via-color: #233876;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(35, 56, 118, 0));\n  }\n  .xl\\:hover\\:via-indigo-50:hover {\n    --gradient-via-color: #f0f5ff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(240, 245, 255, 0));\n  }\n  .xl\\:hover\\:via-indigo-100:hover {\n    --gradient-via-color: #e5edff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(229, 237, 255, 0));\n  }\n  .xl\\:hover\\:via-indigo-200:hover {\n    --gradient-via-color: #cddbfe;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(205, 219, 254, 0));\n  }\n  .xl\\:hover\\:via-indigo-300:hover {\n    --gradient-via-color: #b4c6fc;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(180, 198, 252, 0));\n  }\n  .xl\\:hover\\:via-indigo-400:hover {\n    --gradient-via-color: #8da2fb;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(141, 162, 251, 0));\n  }\n  .xl\\:hover\\:via-indigo-500:hover {\n    --gradient-via-color: #6875f5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(104, 117, 245, 0));\n  }\n  .xl\\:hover\\:via-indigo-600:hover {\n    --gradient-via-color: #5850ec;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(88, 80, 236, 0));\n  }\n  .xl\\:hover\\:via-indigo-700:hover {\n    --gradient-via-color: #5145cd;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(81, 69, 205, 0));\n  }\n  .xl\\:hover\\:via-indigo-800:hover {\n    --gradient-via-color: #42389d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(66, 56, 157, 0));\n  }\n  .xl\\:hover\\:via-indigo-900:hover {\n    --gradient-via-color: #362f78;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(54, 47, 120, 0));\n  }\n  .xl\\:hover\\:via-purple-50:hover {\n    --gradient-via-color: #f6f5ff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(246, 245, 255, 0));\n  }\n  .xl\\:hover\\:via-purple-100:hover {\n    --gradient-via-color: #edebfe;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(237, 235, 254, 0));\n  }\n  .xl\\:hover\\:via-purple-200:hover {\n    --gradient-via-color: #dcd7fe;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(220, 215, 254, 0));\n  }\n  .xl\\:hover\\:via-purple-300:hover {\n    --gradient-via-color: #cabffd;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(202, 191, 253, 0));\n  }\n  .xl\\:hover\\:via-purple-400:hover {\n    --gradient-via-color: #ac94fa;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(172, 148, 250, 0));\n  }\n  .xl\\:hover\\:via-purple-500:hover {\n    --gradient-via-color: #9061f9;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(144, 97, 249, 0));\n  }\n  .xl\\:hover\\:via-purple-600:hover {\n    --gradient-via-color: #7e3af2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(126, 58, 242, 0));\n  }\n  .xl\\:hover\\:via-purple-700:hover {\n    --gradient-via-color: #6c2bd9;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(108, 43, 217, 0));\n  }\n  .xl\\:hover\\:via-purple-800:hover {\n    --gradient-via-color: #5521b5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(85, 33, 181, 0));\n  }\n  .xl\\:hover\\:via-purple-900:hover {\n    --gradient-via-color: #4a1d96;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(74, 29, 150, 0));\n  }\n  .xl\\:hover\\:via-pink-50:hover {\n    --gradient-via-color: #fdf2f8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 242, 248, 0));\n  }\n  .xl\\:hover\\:via-pink-100:hover {\n    --gradient-via-color: #fce8f3;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(252, 232, 243, 0));\n  }\n  .xl\\:hover\\:via-pink-200:hover {\n    --gradient-via-color: #fad1e8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(250, 209, 232, 0));\n  }\n  .xl\\:hover\\:via-pink-300:hover {\n    --gradient-via-color: #f8b4d9;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(248, 180, 217, 0));\n  }\n  .xl\\:hover\\:via-pink-400:hover {\n    --gradient-via-color: #f17eb8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(241, 126, 184, 0));\n  }\n  .xl\\:hover\\:via-pink-500:hover {\n    --gradient-via-color: #e74694;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(231, 70, 148, 0));\n  }\n  .xl\\:hover\\:via-pink-600:hover {\n    --gradient-via-color: #d61f69;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(214, 31, 105, 0));\n  }\n  .xl\\:hover\\:via-pink-700:hover {\n    --gradient-via-color: #bf125d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(191, 18, 93, 0));\n  }\n  .xl\\:hover\\:via-pink-800:hover {\n    --gradient-via-color: #99154b;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(153, 21, 75, 0));\n  }\n  .xl\\:hover\\:via-pink-900:hover {\n    --gradient-via-color: #751a3d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(117, 26, 61, 0));\n  }\n  .xl\\:hover\\:via-cool-gray-50:hover {\n    --gradient-via-color: #f8fafc;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(248, 250, 252, 0));\n  }\n  .xl\\:hover\\:via-cool-gray-100:hover {\n    --gradient-via-color: #f1f5f9;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(241, 245, 249, 0));\n  }\n  .xl\\:hover\\:via-cool-gray-200:hover {\n    --gradient-via-color: #e2e8f0;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(226, 232, 240, 0));\n  }\n  .xl\\:hover\\:via-cool-gray-300:hover {\n    --gradient-via-color: #cfd8e3;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(207, 216, 227, 0));\n  }\n  .xl\\:hover\\:via-cool-gray-400:hover {\n    --gradient-via-color: #97a6ba;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(151, 166, 186, 0));\n  }\n  .xl\\:hover\\:via-cool-gray-500:hover {\n    --gradient-via-color: #64748b;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(100, 116, 139, 0));\n  }\n  .xl\\:hover\\:via-cool-gray-600:hover {\n    --gradient-via-color: #475569;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(71, 85, 105, 0));\n  }\n  .xl\\:hover\\:via-cool-gray-700:hover {\n    --gradient-via-color: #364152;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(54, 65, 82, 0));\n  }\n  .xl\\:hover\\:via-cool-gray-800:hover {\n    --gradient-via-color: #27303f;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(39, 48, 63, 0));\n  }\n  .xl\\:hover\\:via-cool-gray-900:hover {\n    --gradient-via-color: #1a202e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(26, 32, 46, 0));\n  }\n  .xl\\:hover\\:to-current:hover {\n    --gradient-to-color: currentColor;\n  }\n  .xl\\:hover\\:to-transparent:hover {\n    --gradient-to-color: transparent;\n  }\n  .xl\\:hover\\:to-white:hover {\n    --gradient-to-color: #ffffff;\n  }\n  .xl\\:hover\\:to-black:hover {\n    --gradient-to-color: #000000;\n  }\n  .xl\\:hover\\:to-gray-50:hover {\n    --gradient-to-color: #f9fafb;\n  }\n  .xl\\:hover\\:to-gray-100:hover {\n    --gradient-to-color: #f4f5f7;\n  }\n  .xl\\:hover\\:to-gray-200:hover {\n    --gradient-to-color: #e5e7eb;\n  }\n  .xl\\:hover\\:to-gray-300:hover {\n    --gradient-to-color: #d2d6dc;\n  }\n  .xl\\:hover\\:to-gray-400:hover {\n    --gradient-to-color: #9fa6b2;\n  }\n  .xl\\:hover\\:to-gray-500:hover {\n    --gradient-to-color: #6b7280;\n  }\n  .xl\\:hover\\:to-gray-600:hover {\n    --gradient-to-color: #4b5563;\n  }\n  .xl\\:hover\\:to-gray-700:hover {\n    --gradient-to-color: #374151;\n  }\n  .xl\\:hover\\:to-gray-800:hover {\n    --gradient-to-color: #252f3f;\n  }\n  .xl\\:hover\\:to-gray-900:hover {\n    --gradient-to-color: #161e2e;\n  }\n  .xl\\:hover\\:to-red-50:hover {\n    --gradient-to-color: #fdf2f2;\n  }\n  .xl\\:hover\\:to-red-100:hover {\n    --gradient-to-color: #fde8e8;\n  }\n  .xl\\:hover\\:to-red-200:hover {\n    --gradient-to-color: #fbd5d5;\n  }\n  .xl\\:hover\\:to-red-300:hover {\n    --gradient-to-color: #f8b4b4;\n  }\n  .xl\\:hover\\:to-red-400:hover {\n    --gradient-to-color: #f98080;\n  }\n  .xl\\:hover\\:to-red-500:hover {\n    --gradient-to-color: #f05252;\n  }\n  .xl\\:hover\\:to-red-600:hover {\n    --gradient-to-color: #e02424;\n  }\n  .xl\\:hover\\:to-red-700:hover {\n    --gradient-to-color: #c81e1e;\n  }\n  .xl\\:hover\\:to-red-800:hover {\n    --gradient-to-color: #9b1c1c;\n  }\n  .xl\\:hover\\:to-red-900:hover {\n    --gradient-to-color: #771d1d;\n  }\n  .xl\\:hover\\:to-orange-50:hover {\n    --gradient-to-color: #fff8f1;\n  }\n  .xl\\:hover\\:to-orange-100:hover {\n    --gradient-to-color: #feecdc;\n  }\n  .xl\\:hover\\:to-orange-200:hover {\n    --gradient-to-color: #fcd9bd;\n  }\n  .xl\\:hover\\:to-orange-300:hover {\n    --gradient-to-color: #fdba8c;\n  }\n  .xl\\:hover\\:to-orange-400:hover {\n    --gradient-to-color: #ff8a4c;\n  }\n  .xl\\:hover\\:to-orange-500:hover {\n    --gradient-to-color: #ff5a1f;\n  }\n  .xl\\:hover\\:to-orange-600:hover {\n    --gradient-to-color: #d03801;\n  }\n  .xl\\:hover\\:to-orange-700:hover {\n    --gradient-to-color: #b43403;\n  }\n  .xl\\:hover\\:to-orange-800:hover {\n    --gradient-to-color: #8a2c0d;\n  }\n  .xl\\:hover\\:to-orange-900:hover {\n    --gradient-to-color: #73230d;\n  }\n  .xl\\:hover\\:to-yellow-50:hover {\n    --gradient-to-color: #fdfdea;\n  }\n  .xl\\:hover\\:to-yellow-100:hover {\n    --gradient-to-color: #fdf6b2;\n  }\n  .xl\\:hover\\:to-yellow-200:hover {\n    --gradient-to-color: #fce96a;\n  }\n  .xl\\:hover\\:to-yellow-300:hover {\n    --gradient-to-color: #faca15;\n  }\n  .xl\\:hover\\:to-yellow-400:hover {\n    --gradient-to-color: #e3a008;\n  }\n  .xl\\:hover\\:to-yellow-500:hover {\n    --gradient-to-color: #c27803;\n  }\n  .xl\\:hover\\:to-yellow-600:hover {\n    --gradient-to-color: #9f580a;\n  }\n  .xl\\:hover\\:to-yellow-700:hover {\n    --gradient-to-color: #8e4b10;\n  }\n  .xl\\:hover\\:to-yellow-800:hover {\n    --gradient-to-color: #723b13;\n  }\n  .xl\\:hover\\:to-yellow-900:hover {\n    --gradient-to-color: #633112;\n  }\n  .xl\\:hover\\:to-green-50:hover {\n    --gradient-to-color: #f3faf7;\n  }\n  .xl\\:hover\\:to-green-100:hover {\n    --gradient-to-color: #def7ec;\n  }\n  .xl\\:hover\\:to-green-200:hover {\n    --gradient-to-color: #bcf0da;\n  }\n  .xl\\:hover\\:to-green-300:hover {\n    --gradient-to-color: #84e1bc;\n  }\n  .xl\\:hover\\:to-green-400:hover {\n    --gradient-to-color: #31c48d;\n  }\n  .xl\\:hover\\:to-green-500:hover {\n    --gradient-to-color: #0e9f6e;\n  }\n  .xl\\:hover\\:to-green-600:hover {\n    --gradient-to-color: #057a55;\n  }\n  .xl\\:hover\\:to-green-700:hover {\n    --gradient-to-color: #046c4e;\n  }\n  .xl\\:hover\\:to-green-800:hover {\n    --gradient-to-color: #03543f;\n  }\n  .xl\\:hover\\:to-green-900:hover {\n    --gradient-to-color: #014737;\n  }\n  .xl\\:hover\\:to-teal-50:hover {\n    --gradient-to-color: #edfafa;\n  }\n  .xl\\:hover\\:to-teal-100:hover {\n    --gradient-to-color: #d5f5f6;\n  }\n  .xl\\:hover\\:to-teal-200:hover {\n    --gradient-to-color: #afecef;\n  }\n  .xl\\:hover\\:to-teal-300:hover {\n    --gradient-to-color: #7edce2;\n  }\n  .xl\\:hover\\:to-teal-400:hover {\n    --gradient-to-color: #16bdca;\n  }\n  .xl\\:hover\\:to-teal-500:hover {\n    --gradient-to-color: #0694a2;\n  }\n  .xl\\:hover\\:to-teal-600:hover {\n    --gradient-to-color: #047481;\n  }\n  .xl\\:hover\\:to-teal-700:hover {\n    --gradient-to-color: #036672;\n  }\n  .xl\\:hover\\:to-teal-800:hover {\n    --gradient-to-color: #05505c;\n  }\n  .xl\\:hover\\:to-teal-900:hover {\n    --gradient-to-color: #014451;\n  }\n  .xl\\:hover\\:to-blue-50:hover {\n    --gradient-to-color: #ebf5ff;\n  }\n  .xl\\:hover\\:to-blue-100:hover {\n    --gradient-to-color: #e1effe;\n  }\n  .xl\\:hover\\:to-blue-200:hover {\n    --gradient-to-color: #c3ddfd;\n  }\n  .xl\\:hover\\:to-blue-300:hover {\n    --gradient-to-color: #a4cafe;\n  }\n  .xl\\:hover\\:to-blue-400:hover {\n    --gradient-to-color: #76a9fa;\n  }\n  .xl\\:hover\\:to-blue-500:hover {\n    --gradient-to-color: #3f83f8;\n  }\n  .xl\\:hover\\:to-blue-600:hover {\n    --gradient-to-color: #1c64f2;\n  }\n  .xl\\:hover\\:to-blue-700:hover {\n    --gradient-to-color: #1a56db;\n  }\n  .xl\\:hover\\:to-blue-800:hover {\n    --gradient-to-color: #1e429f;\n  }\n  .xl\\:hover\\:to-blue-900:hover {\n    --gradient-to-color: #233876;\n  }\n  .xl\\:hover\\:to-indigo-50:hover {\n    --gradient-to-color: #f0f5ff;\n  }\n  .xl\\:hover\\:to-indigo-100:hover {\n    --gradient-to-color: #e5edff;\n  }\n  .xl\\:hover\\:to-indigo-200:hover {\n    --gradient-to-color: #cddbfe;\n  }\n  .xl\\:hover\\:to-indigo-300:hover {\n    --gradient-to-color: #b4c6fc;\n  }\n  .xl\\:hover\\:to-indigo-400:hover {\n    --gradient-to-color: #8da2fb;\n  }\n  .xl\\:hover\\:to-indigo-500:hover {\n    --gradient-to-color: #6875f5;\n  }\n  .xl\\:hover\\:to-indigo-600:hover {\n    --gradient-to-color: #5850ec;\n  }\n  .xl\\:hover\\:to-indigo-700:hover {\n    --gradient-to-color: #5145cd;\n  }\n  .xl\\:hover\\:to-indigo-800:hover {\n    --gradient-to-color: #42389d;\n  }\n  .xl\\:hover\\:to-indigo-900:hover {\n    --gradient-to-color: #362f78;\n  }\n  .xl\\:hover\\:to-purple-50:hover {\n    --gradient-to-color: #f6f5ff;\n  }\n  .xl\\:hover\\:to-purple-100:hover {\n    --gradient-to-color: #edebfe;\n  }\n  .xl\\:hover\\:to-purple-200:hover {\n    --gradient-to-color: #dcd7fe;\n  }\n  .xl\\:hover\\:to-purple-300:hover {\n    --gradient-to-color: #cabffd;\n  }\n  .xl\\:hover\\:to-purple-400:hover {\n    --gradient-to-color: #ac94fa;\n  }\n  .xl\\:hover\\:to-purple-500:hover {\n    --gradient-to-color: #9061f9;\n  }\n  .xl\\:hover\\:to-purple-600:hover {\n    --gradient-to-color: #7e3af2;\n  }\n  .xl\\:hover\\:to-purple-700:hover {\n    --gradient-to-color: #6c2bd9;\n  }\n  .xl\\:hover\\:to-purple-800:hover {\n    --gradient-to-color: #5521b5;\n  }\n  .xl\\:hover\\:to-purple-900:hover {\n    --gradient-to-color: #4a1d96;\n  }\n  .xl\\:hover\\:to-pink-50:hover {\n    --gradient-to-color: #fdf2f8;\n  }\n  .xl\\:hover\\:to-pink-100:hover {\n    --gradient-to-color: #fce8f3;\n  }\n  .xl\\:hover\\:to-pink-200:hover {\n    --gradient-to-color: #fad1e8;\n  }\n  .xl\\:hover\\:to-pink-300:hover {\n    --gradient-to-color: #f8b4d9;\n  }\n  .xl\\:hover\\:to-pink-400:hover {\n    --gradient-to-color: #f17eb8;\n  }\n  .xl\\:hover\\:to-pink-500:hover {\n    --gradient-to-color: #e74694;\n  }\n  .xl\\:hover\\:to-pink-600:hover {\n    --gradient-to-color: #d61f69;\n  }\n  .xl\\:hover\\:to-pink-700:hover {\n    --gradient-to-color: #bf125d;\n  }\n  .xl\\:hover\\:to-pink-800:hover {\n    --gradient-to-color: #99154b;\n  }\n  .xl\\:hover\\:to-pink-900:hover {\n    --gradient-to-color: #751a3d;\n  }\n  .xl\\:hover\\:to-cool-gray-50:hover {\n    --gradient-to-color: #f8fafc;\n  }\n  .xl\\:hover\\:to-cool-gray-100:hover {\n    --gradient-to-color: #f1f5f9;\n  }\n  .xl\\:hover\\:to-cool-gray-200:hover {\n    --gradient-to-color: #e2e8f0;\n  }\n  .xl\\:hover\\:to-cool-gray-300:hover {\n    --gradient-to-color: #cfd8e3;\n  }\n  .xl\\:hover\\:to-cool-gray-400:hover {\n    --gradient-to-color: #97a6ba;\n  }\n  .xl\\:hover\\:to-cool-gray-500:hover {\n    --gradient-to-color: #64748b;\n  }\n  .xl\\:hover\\:to-cool-gray-600:hover {\n    --gradient-to-color: #475569;\n  }\n  .xl\\:hover\\:to-cool-gray-700:hover {\n    --gradient-to-color: #364152;\n  }\n  .xl\\:hover\\:to-cool-gray-800:hover {\n    --gradient-to-color: #27303f;\n  }\n  .xl\\:hover\\:to-cool-gray-900:hover {\n    --gradient-to-color: #1a202e;\n  }\n  .xl\\:focus\\:from-current:focus {\n    --gradient-from-color: currentColor;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));\n  }\n  .xl\\:focus\\:from-transparent:focus {\n    --gradient-from-color: transparent;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0));\n  }\n  .xl\\:focus\\:from-white:focus {\n    --gradient-from-color: #ffffff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));\n  }\n  .xl\\:focus\\:from-black:focus {\n    --gradient-from-color: #000000;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0));\n  }\n  .xl\\:focus\\:from-gray-50:focus {\n    --gradient-from-color: #f9fafb;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(249, 250, 251, 0));\n  }\n  .xl\\:focus\\:from-gray-100:focus {\n    --gradient-from-color: #f4f5f7;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(244, 245, 247, 0));\n  }\n  .xl\\:focus\\:from-gray-200:focus {\n    --gradient-from-color: #e5e7eb;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(229, 231, 235, 0));\n  }\n  .xl\\:focus\\:from-gray-300:focus {\n    --gradient-from-color: #d2d6dc;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(210, 214, 220, 0));\n  }\n  .xl\\:focus\\:from-gray-400:focus {\n    --gradient-from-color: #9fa6b2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(159, 166, 178, 0));\n  }\n  .xl\\:focus\\:from-gray-500:focus {\n    --gradient-from-color: #6b7280;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(107, 114, 128, 0));\n  }\n  .xl\\:focus\\:from-gray-600:focus {\n    --gradient-from-color: #4b5563;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(75, 85, 99, 0));\n  }\n  .xl\\:focus\\:from-gray-700:focus {\n    --gradient-from-color: #374151;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(55, 65, 81, 0));\n  }\n  .xl\\:focus\\:from-gray-800:focus {\n    --gradient-from-color: #252f3f;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(37, 47, 63, 0));\n  }\n  .xl\\:focus\\:from-gray-900:focus {\n    --gradient-from-color: #161e2e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(22, 30, 46, 0));\n  }\n  .xl\\:focus\\:from-red-50:focus {\n    --gradient-from-color: #fdf2f2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 242, 242, 0));\n  }\n  .xl\\:focus\\:from-red-100:focus {\n    --gradient-from-color: #fde8e8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 232, 232, 0));\n  }\n  .xl\\:focus\\:from-red-200:focus {\n    --gradient-from-color: #fbd5d5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(251, 213, 213, 0));\n  }\n  .xl\\:focus\\:from-red-300:focus {\n    --gradient-from-color: #f8b4b4;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(248, 180, 180, 0));\n  }\n  .xl\\:focus\\:from-red-400:focus {\n    --gradient-from-color: #f98080;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(249, 128, 128, 0));\n  }\n  .xl\\:focus\\:from-red-500:focus {\n    --gradient-from-color: #f05252;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(240, 82, 82, 0));\n  }\n  .xl\\:focus\\:from-red-600:focus {\n    --gradient-from-color: #e02424;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(224, 36, 36, 0));\n  }\n  .xl\\:focus\\:from-red-700:focus {\n    --gradient-from-color: #c81e1e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(200, 30, 30, 0));\n  }\n  .xl\\:focus\\:from-red-800:focus {\n    --gradient-from-color: #9b1c1c;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(155, 28, 28, 0));\n  }\n  .xl\\:focus\\:from-red-900:focus {\n    --gradient-from-color: #771d1d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(119, 29, 29, 0));\n  }\n  .xl\\:focus\\:from-orange-50:focus {\n    --gradient-from-color: #fff8f1;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 248, 241, 0));\n  }\n  .xl\\:focus\\:from-orange-100:focus {\n    --gradient-from-color: #feecdc;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 236, 220, 0));\n  }\n  .xl\\:focus\\:from-orange-200:focus {\n    --gradient-from-color: #fcd9bd;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(252, 217, 189, 0));\n  }\n  .xl\\:focus\\:from-orange-300:focus {\n    --gradient-from-color: #fdba8c;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 186, 140, 0));\n  }\n  .xl\\:focus\\:from-orange-400:focus {\n    --gradient-from-color: #ff8a4c;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 138, 76, 0));\n  }\n  .xl\\:focus\\:from-orange-500:focus {\n    --gradient-from-color: #ff5a1f;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 90, 31, 0));\n  }\n  .xl\\:focus\\:from-orange-600:focus {\n    --gradient-from-color: #d03801;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(208, 56, 1, 0));\n  }\n  .xl\\:focus\\:from-orange-700:focus {\n    --gradient-from-color: #b43403;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(180, 52, 3, 0));\n  }\n  .xl\\:focus\\:from-orange-800:focus {\n    --gradient-from-color: #8a2c0d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(138, 44, 13, 0));\n  }\n  .xl\\:focus\\:from-orange-900:focus {\n    --gradient-from-color: #73230d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(115, 35, 13, 0));\n  }\n  .xl\\:focus\\:from-yellow-50:focus {\n    --gradient-from-color: #fdfdea;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 253, 234, 0));\n  }\n  .xl\\:focus\\:from-yellow-100:focus {\n    --gradient-from-color: #fdf6b2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 246, 178, 0));\n  }\n  .xl\\:focus\\:from-yellow-200:focus {\n    --gradient-from-color: #fce96a;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(252, 233, 106, 0));\n  }\n  .xl\\:focus\\:from-yellow-300:focus {\n    --gradient-from-color: #faca15;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(250, 202, 21, 0));\n  }\n  .xl\\:focus\\:from-yellow-400:focus {\n    --gradient-from-color: #e3a008;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(227, 160, 8, 0));\n  }\n  .xl\\:focus\\:from-yellow-500:focus {\n    --gradient-from-color: #c27803;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(194, 120, 3, 0));\n  }\n  .xl\\:focus\\:from-yellow-600:focus {\n    --gradient-from-color: #9f580a;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(159, 88, 10, 0));\n  }\n  .xl\\:focus\\:from-yellow-700:focus {\n    --gradient-from-color: #8e4b10;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(142, 75, 16, 0));\n  }\n  .xl\\:focus\\:from-yellow-800:focus {\n    --gradient-from-color: #723b13;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(114, 59, 19, 0));\n  }\n  .xl\\:focus\\:from-yellow-900:focus {\n    --gradient-from-color: #633112;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(99, 49, 18, 0));\n  }\n  .xl\\:focus\\:from-green-50:focus {\n    --gradient-from-color: #f3faf7;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(243, 250, 247, 0));\n  }\n  .xl\\:focus\\:from-green-100:focus {\n    --gradient-from-color: #def7ec;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(222, 247, 236, 0));\n  }\n  .xl\\:focus\\:from-green-200:focus {\n    --gradient-from-color: #bcf0da;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(188, 240, 218, 0));\n  }\n  .xl\\:focus\\:from-green-300:focus {\n    --gradient-from-color: #84e1bc;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(132, 225, 188, 0));\n  }\n  .xl\\:focus\\:from-green-400:focus {\n    --gradient-from-color: #31c48d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(49, 196, 141, 0));\n  }\n  .xl\\:focus\\:from-green-500:focus {\n    --gradient-from-color: #0e9f6e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(14, 159, 110, 0));\n  }\n  .xl\\:focus\\:from-green-600:focus {\n    --gradient-from-color: #057a55;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(5, 122, 85, 0));\n  }\n  .xl\\:focus\\:from-green-700:focus {\n    --gradient-from-color: #046c4e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(4, 108, 78, 0));\n  }\n  .xl\\:focus\\:from-green-800:focus {\n    --gradient-from-color: #03543f;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(3, 84, 63, 0));\n  }\n  .xl\\:focus\\:from-green-900:focus {\n    --gradient-from-color: #014737;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(1, 71, 55, 0));\n  }\n  .xl\\:focus\\:from-teal-50:focus {\n    --gradient-from-color: #edfafa;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(237, 250, 250, 0));\n  }\n  .xl\\:focus\\:from-teal-100:focus {\n    --gradient-from-color: #d5f5f6;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(213, 245, 246, 0));\n  }\n  .xl\\:focus\\:from-teal-200:focus {\n    --gradient-from-color: #afecef;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(175, 236, 239, 0));\n  }\n  .xl\\:focus\\:from-teal-300:focus {\n    --gradient-from-color: #7edce2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(126, 220, 226, 0));\n  }\n  .xl\\:focus\\:from-teal-400:focus {\n    --gradient-from-color: #16bdca;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(22, 189, 202, 0));\n  }\n  .xl\\:focus\\:from-teal-500:focus {\n    --gradient-from-color: #0694a2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(6, 148, 162, 0));\n  }\n  .xl\\:focus\\:from-teal-600:focus {\n    --gradient-from-color: #047481;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(4, 116, 129, 0));\n  }\n  .xl\\:focus\\:from-teal-700:focus {\n    --gradient-from-color: #036672;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(3, 102, 114, 0));\n  }\n  .xl\\:focus\\:from-teal-800:focus {\n    --gradient-from-color: #05505c;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(5, 80, 92, 0));\n  }\n  .xl\\:focus\\:from-teal-900:focus {\n    --gradient-from-color: #014451;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(1, 68, 81, 0));\n  }\n  .xl\\:focus\\:from-blue-50:focus {\n    --gradient-from-color: #ebf5ff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(235, 245, 255, 0));\n  }\n  .xl\\:focus\\:from-blue-100:focus {\n    --gradient-from-color: #e1effe;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(225, 239, 254, 0));\n  }\n  .xl\\:focus\\:from-blue-200:focus {\n    --gradient-from-color: #c3ddfd;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(195, 221, 253, 0));\n  }\n  .xl\\:focus\\:from-blue-300:focus {\n    --gradient-from-color: #a4cafe;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(164, 202, 254, 0));\n  }\n  .xl\\:focus\\:from-blue-400:focus {\n    --gradient-from-color: #76a9fa;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(118, 169, 250, 0));\n  }\n  .xl\\:focus\\:from-blue-500:focus {\n    --gradient-from-color: #3f83f8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(63, 131, 248, 0));\n  }\n  .xl\\:focus\\:from-blue-600:focus {\n    --gradient-from-color: #1c64f2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(28, 100, 242, 0));\n  }\n  .xl\\:focus\\:from-blue-700:focus {\n    --gradient-from-color: #1a56db;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(26, 86, 219, 0));\n  }\n  .xl\\:focus\\:from-blue-800:focus {\n    --gradient-from-color: #1e429f;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(30, 66, 159, 0));\n  }\n  .xl\\:focus\\:from-blue-900:focus {\n    --gradient-from-color: #233876;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(35, 56, 118, 0));\n  }\n  .xl\\:focus\\:from-indigo-50:focus {\n    --gradient-from-color: #f0f5ff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(240, 245, 255, 0));\n  }\n  .xl\\:focus\\:from-indigo-100:focus {\n    --gradient-from-color: #e5edff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(229, 237, 255, 0));\n  }\n  .xl\\:focus\\:from-indigo-200:focus {\n    --gradient-from-color: #cddbfe;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(205, 219, 254, 0));\n  }\n  .xl\\:focus\\:from-indigo-300:focus {\n    --gradient-from-color: #b4c6fc;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(180, 198, 252, 0));\n  }\n  .xl\\:focus\\:from-indigo-400:focus {\n    --gradient-from-color: #8da2fb;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(141, 162, 251, 0));\n  }\n  .xl\\:focus\\:from-indigo-500:focus {\n    --gradient-from-color: #6875f5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(104, 117, 245, 0));\n  }\n  .xl\\:focus\\:from-indigo-600:focus {\n    --gradient-from-color: #5850ec;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(88, 80, 236, 0));\n  }\n  .xl\\:focus\\:from-indigo-700:focus {\n    --gradient-from-color: #5145cd;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(81, 69, 205, 0));\n  }\n  .xl\\:focus\\:from-indigo-800:focus {\n    --gradient-from-color: #42389d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(66, 56, 157, 0));\n  }\n  .xl\\:focus\\:from-indigo-900:focus {\n    --gradient-from-color: #362f78;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(54, 47, 120, 0));\n  }\n  .xl\\:focus\\:from-purple-50:focus {\n    --gradient-from-color: #f6f5ff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(246, 245, 255, 0));\n  }\n  .xl\\:focus\\:from-purple-100:focus {\n    --gradient-from-color: #edebfe;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(237, 235, 254, 0));\n  }\n  .xl\\:focus\\:from-purple-200:focus {\n    --gradient-from-color: #dcd7fe;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(220, 215, 254, 0));\n  }\n  .xl\\:focus\\:from-purple-300:focus {\n    --gradient-from-color: #cabffd;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(202, 191, 253, 0));\n  }\n  .xl\\:focus\\:from-purple-400:focus {\n    --gradient-from-color: #ac94fa;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(172, 148, 250, 0));\n  }\n  .xl\\:focus\\:from-purple-500:focus {\n    --gradient-from-color: #9061f9;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(144, 97, 249, 0));\n  }\n  .xl\\:focus\\:from-purple-600:focus {\n    --gradient-from-color: #7e3af2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(126, 58, 242, 0));\n  }\n  .xl\\:focus\\:from-purple-700:focus {\n    --gradient-from-color: #6c2bd9;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(108, 43, 217, 0));\n  }\n  .xl\\:focus\\:from-purple-800:focus {\n    --gradient-from-color: #5521b5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(85, 33, 181, 0));\n  }\n  .xl\\:focus\\:from-purple-900:focus {\n    --gradient-from-color: #4a1d96;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(74, 29, 150, 0));\n  }\n  .xl\\:focus\\:from-pink-50:focus {\n    --gradient-from-color: #fdf2f8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 242, 248, 0));\n  }\n  .xl\\:focus\\:from-pink-100:focus {\n    --gradient-from-color: #fce8f3;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(252, 232, 243, 0));\n  }\n  .xl\\:focus\\:from-pink-200:focus {\n    --gradient-from-color: #fad1e8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(250, 209, 232, 0));\n  }\n  .xl\\:focus\\:from-pink-300:focus {\n    --gradient-from-color: #f8b4d9;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(248, 180, 217, 0));\n  }\n  .xl\\:focus\\:from-pink-400:focus {\n    --gradient-from-color: #f17eb8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(241, 126, 184, 0));\n  }\n  .xl\\:focus\\:from-pink-500:focus {\n    --gradient-from-color: #e74694;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(231, 70, 148, 0));\n  }\n  .xl\\:focus\\:from-pink-600:focus {\n    --gradient-from-color: #d61f69;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(214, 31, 105, 0));\n  }\n  .xl\\:focus\\:from-pink-700:focus {\n    --gradient-from-color: #bf125d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(191, 18, 93, 0));\n  }\n  .xl\\:focus\\:from-pink-800:focus {\n    --gradient-from-color: #99154b;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(153, 21, 75, 0));\n  }\n  .xl\\:focus\\:from-pink-900:focus {\n    --gradient-from-color: #751a3d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(117, 26, 61, 0));\n  }\n  .xl\\:focus\\:from-cool-gray-50:focus {\n    --gradient-from-color: #f8fafc;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(248, 250, 252, 0));\n  }\n  .xl\\:focus\\:from-cool-gray-100:focus {\n    --gradient-from-color: #f1f5f9;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(241, 245, 249, 0));\n  }\n  .xl\\:focus\\:from-cool-gray-200:focus {\n    --gradient-from-color: #e2e8f0;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(226, 232, 240, 0));\n  }\n  .xl\\:focus\\:from-cool-gray-300:focus {\n    --gradient-from-color: #cfd8e3;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(207, 216, 227, 0));\n  }\n  .xl\\:focus\\:from-cool-gray-400:focus {\n    --gradient-from-color: #97a6ba;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(151, 166, 186, 0));\n  }\n  .xl\\:focus\\:from-cool-gray-500:focus {\n    --gradient-from-color: #64748b;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(100, 116, 139, 0));\n  }\n  .xl\\:focus\\:from-cool-gray-600:focus {\n    --gradient-from-color: #475569;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(71, 85, 105, 0));\n  }\n  .xl\\:focus\\:from-cool-gray-700:focus {\n    --gradient-from-color: #364152;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(54, 65, 82, 0));\n  }\n  .xl\\:focus\\:from-cool-gray-800:focus {\n    --gradient-from-color: #27303f;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(39, 48, 63, 0));\n  }\n  .xl\\:focus\\:from-cool-gray-900:focus {\n    --gradient-from-color: #1a202e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(26, 32, 46, 0));\n  }\n  .xl\\:focus\\:via-current:focus {\n    --gradient-via-color: currentColor;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));\n  }\n  .xl\\:focus\\:via-transparent:focus {\n    --gradient-via-color: transparent;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0));\n  }\n  .xl\\:focus\\:via-white:focus {\n    --gradient-via-color: #ffffff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));\n  }\n  .xl\\:focus\\:via-black:focus {\n    --gradient-via-color: #000000;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0));\n  }\n  .xl\\:focus\\:via-gray-50:focus {\n    --gradient-via-color: #f9fafb;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(249, 250, 251, 0));\n  }\n  .xl\\:focus\\:via-gray-100:focus {\n    --gradient-via-color: #f4f5f7;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(244, 245, 247, 0));\n  }\n  .xl\\:focus\\:via-gray-200:focus {\n    --gradient-via-color: #e5e7eb;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(229, 231, 235, 0));\n  }\n  .xl\\:focus\\:via-gray-300:focus {\n    --gradient-via-color: #d2d6dc;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(210, 214, 220, 0));\n  }\n  .xl\\:focus\\:via-gray-400:focus {\n    --gradient-via-color: #9fa6b2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(159, 166, 178, 0));\n  }\n  .xl\\:focus\\:via-gray-500:focus {\n    --gradient-via-color: #6b7280;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(107, 114, 128, 0));\n  }\n  .xl\\:focus\\:via-gray-600:focus {\n    --gradient-via-color: #4b5563;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(75, 85, 99, 0));\n  }\n  .xl\\:focus\\:via-gray-700:focus {\n    --gradient-via-color: #374151;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(55, 65, 81, 0));\n  }\n  .xl\\:focus\\:via-gray-800:focus {\n    --gradient-via-color: #252f3f;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(37, 47, 63, 0));\n  }\n  .xl\\:focus\\:via-gray-900:focus {\n    --gradient-via-color: #161e2e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(22, 30, 46, 0));\n  }\n  .xl\\:focus\\:via-red-50:focus {\n    --gradient-via-color: #fdf2f2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 242, 242, 0));\n  }\n  .xl\\:focus\\:via-red-100:focus {\n    --gradient-via-color: #fde8e8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 232, 232, 0));\n  }\n  .xl\\:focus\\:via-red-200:focus {\n    --gradient-via-color: #fbd5d5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(251, 213, 213, 0));\n  }\n  .xl\\:focus\\:via-red-300:focus {\n    --gradient-via-color: #f8b4b4;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(248, 180, 180, 0));\n  }\n  .xl\\:focus\\:via-red-400:focus {\n    --gradient-via-color: #f98080;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(249, 128, 128, 0));\n  }\n  .xl\\:focus\\:via-red-500:focus {\n    --gradient-via-color: #f05252;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(240, 82, 82, 0));\n  }\n  .xl\\:focus\\:via-red-600:focus {\n    --gradient-via-color: #e02424;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(224, 36, 36, 0));\n  }\n  .xl\\:focus\\:via-red-700:focus {\n    --gradient-via-color: #c81e1e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(200, 30, 30, 0));\n  }\n  .xl\\:focus\\:via-red-800:focus {\n    --gradient-via-color: #9b1c1c;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(155, 28, 28, 0));\n  }\n  .xl\\:focus\\:via-red-900:focus {\n    --gradient-via-color: #771d1d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(119, 29, 29, 0));\n  }\n  .xl\\:focus\\:via-orange-50:focus {\n    --gradient-via-color: #fff8f1;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 248, 241, 0));\n  }\n  .xl\\:focus\\:via-orange-100:focus {\n    --gradient-via-color: #feecdc;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 236, 220, 0));\n  }\n  .xl\\:focus\\:via-orange-200:focus {\n    --gradient-via-color: #fcd9bd;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(252, 217, 189, 0));\n  }\n  .xl\\:focus\\:via-orange-300:focus {\n    --gradient-via-color: #fdba8c;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 186, 140, 0));\n  }\n  .xl\\:focus\\:via-orange-400:focus {\n    --gradient-via-color: #ff8a4c;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 138, 76, 0));\n  }\n  .xl\\:focus\\:via-orange-500:focus {\n    --gradient-via-color: #ff5a1f;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 90, 31, 0));\n  }\n  .xl\\:focus\\:via-orange-600:focus {\n    --gradient-via-color: #d03801;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(208, 56, 1, 0));\n  }\n  .xl\\:focus\\:via-orange-700:focus {\n    --gradient-via-color: #b43403;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(180, 52, 3, 0));\n  }\n  .xl\\:focus\\:via-orange-800:focus {\n    --gradient-via-color: #8a2c0d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(138, 44, 13, 0));\n  }\n  .xl\\:focus\\:via-orange-900:focus {\n    --gradient-via-color: #73230d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(115, 35, 13, 0));\n  }\n  .xl\\:focus\\:via-yellow-50:focus {\n    --gradient-via-color: #fdfdea;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 253, 234, 0));\n  }\n  .xl\\:focus\\:via-yellow-100:focus {\n    --gradient-via-color: #fdf6b2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 246, 178, 0));\n  }\n  .xl\\:focus\\:via-yellow-200:focus {\n    --gradient-via-color: #fce96a;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(252, 233, 106, 0));\n  }\n  .xl\\:focus\\:via-yellow-300:focus {\n    --gradient-via-color: #faca15;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(250, 202, 21, 0));\n  }\n  .xl\\:focus\\:via-yellow-400:focus {\n    --gradient-via-color: #e3a008;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(227, 160, 8, 0));\n  }\n  .xl\\:focus\\:via-yellow-500:focus {\n    --gradient-via-color: #c27803;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(194, 120, 3, 0));\n  }\n  .xl\\:focus\\:via-yellow-600:focus {\n    --gradient-via-color: #9f580a;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(159, 88, 10, 0));\n  }\n  .xl\\:focus\\:via-yellow-700:focus {\n    --gradient-via-color: #8e4b10;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(142, 75, 16, 0));\n  }\n  .xl\\:focus\\:via-yellow-800:focus {\n    --gradient-via-color: #723b13;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(114, 59, 19, 0));\n  }\n  .xl\\:focus\\:via-yellow-900:focus {\n    --gradient-via-color: #633112;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(99, 49, 18, 0));\n  }\n  .xl\\:focus\\:via-green-50:focus {\n    --gradient-via-color: #f3faf7;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(243, 250, 247, 0));\n  }\n  .xl\\:focus\\:via-green-100:focus {\n    --gradient-via-color: #def7ec;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(222, 247, 236, 0));\n  }\n  .xl\\:focus\\:via-green-200:focus {\n    --gradient-via-color: #bcf0da;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(188, 240, 218, 0));\n  }\n  .xl\\:focus\\:via-green-300:focus {\n    --gradient-via-color: #84e1bc;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(132, 225, 188, 0));\n  }\n  .xl\\:focus\\:via-green-400:focus {\n    --gradient-via-color: #31c48d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(49, 196, 141, 0));\n  }\n  .xl\\:focus\\:via-green-500:focus {\n    --gradient-via-color: #0e9f6e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(14, 159, 110, 0));\n  }\n  .xl\\:focus\\:via-green-600:focus {\n    --gradient-via-color: #057a55;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(5, 122, 85, 0));\n  }\n  .xl\\:focus\\:via-green-700:focus {\n    --gradient-via-color: #046c4e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(4, 108, 78, 0));\n  }\n  .xl\\:focus\\:via-green-800:focus {\n    --gradient-via-color: #03543f;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(3, 84, 63, 0));\n  }\n  .xl\\:focus\\:via-green-900:focus {\n    --gradient-via-color: #014737;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(1, 71, 55, 0));\n  }\n  .xl\\:focus\\:via-teal-50:focus {\n    --gradient-via-color: #edfafa;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(237, 250, 250, 0));\n  }\n  .xl\\:focus\\:via-teal-100:focus {\n    --gradient-via-color: #d5f5f6;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(213, 245, 246, 0));\n  }\n  .xl\\:focus\\:via-teal-200:focus {\n    --gradient-via-color: #afecef;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(175, 236, 239, 0));\n  }\n  .xl\\:focus\\:via-teal-300:focus {\n    --gradient-via-color: #7edce2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(126, 220, 226, 0));\n  }\n  .xl\\:focus\\:via-teal-400:focus {\n    --gradient-via-color: #16bdca;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(22, 189, 202, 0));\n  }\n  .xl\\:focus\\:via-teal-500:focus {\n    --gradient-via-color: #0694a2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(6, 148, 162, 0));\n  }\n  .xl\\:focus\\:via-teal-600:focus {\n    --gradient-via-color: #047481;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(4, 116, 129, 0));\n  }\n  .xl\\:focus\\:via-teal-700:focus {\n    --gradient-via-color: #036672;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(3, 102, 114, 0));\n  }\n  .xl\\:focus\\:via-teal-800:focus {\n    --gradient-via-color: #05505c;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(5, 80, 92, 0));\n  }\n  .xl\\:focus\\:via-teal-900:focus {\n    --gradient-via-color: #014451;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(1, 68, 81, 0));\n  }\n  .xl\\:focus\\:via-blue-50:focus {\n    --gradient-via-color: #ebf5ff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(235, 245, 255, 0));\n  }\n  .xl\\:focus\\:via-blue-100:focus {\n    --gradient-via-color: #e1effe;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(225, 239, 254, 0));\n  }\n  .xl\\:focus\\:via-blue-200:focus {\n    --gradient-via-color: #c3ddfd;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(195, 221, 253, 0));\n  }\n  .xl\\:focus\\:via-blue-300:focus {\n    --gradient-via-color: #a4cafe;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(164, 202, 254, 0));\n  }\n  .xl\\:focus\\:via-blue-400:focus {\n    --gradient-via-color: #76a9fa;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(118, 169, 250, 0));\n  }\n  .xl\\:focus\\:via-blue-500:focus {\n    --gradient-via-color: #3f83f8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(63, 131, 248, 0));\n  }\n  .xl\\:focus\\:via-blue-600:focus {\n    --gradient-via-color: #1c64f2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(28, 100, 242, 0));\n  }\n  .xl\\:focus\\:via-blue-700:focus {\n    --gradient-via-color: #1a56db;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(26, 86, 219, 0));\n  }\n  .xl\\:focus\\:via-blue-800:focus {\n    --gradient-via-color: #1e429f;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(30, 66, 159, 0));\n  }\n  .xl\\:focus\\:via-blue-900:focus {\n    --gradient-via-color: #233876;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(35, 56, 118, 0));\n  }\n  .xl\\:focus\\:via-indigo-50:focus {\n    --gradient-via-color: #f0f5ff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(240, 245, 255, 0));\n  }\n  .xl\\:focus\\:via-indigo-100:focus {\n    --gradient-via-color: #e5edff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(229, 237, 255, 0));\n  }\n  .xl\\:focus\\:via-indigo-200:focus {\n    --gradient-via-color: #cddbfe;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(205, 219, 254, 0));\n  }\n  .xl\\:focus\\:via-indigo-300:focus {\n    --gradient-via-color: #b4c6fc;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(180, 198, 252, 0));\n  }\n  .xl\\:focus\\:via-indigo-400:focus {\n    --gradient-via-color: #8da2fb;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(141, 162, 251, 0));\n  }\n  .xl\\:focus\\:via-indigo-500:focus {\n    --gradient-via-color: #6875f5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(104, 117, 245, 0));\n  }\n  .xl\\:focus\\:via-indigo-600:focus {\n    --gradient-via-color: #5850ec;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(88, 80, 236, 0));\n  }\n  .xl\\:focus\\:via-indigo-700:focus {\n    --gradient-via-color: #5145cd;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(81, 69, 205, 0));\n  }\n  .xl\\:focus\\:via-indigo-800:focus {\n    --gradient-via-color: #42389d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(66, 56, 157, 0));\n  }\n  .xl\\:focus\\:via-indigo-900:focus {\n    --gradient-via-color: #362f78;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(54, 47, 120, 0));\n  }\n  .xl\\:focus\\:via-purple-50:focus {\n    --gradient-via-color: #f6f5ff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(246, 245, 255, 0));\n  }\n  .xl\\:focus\\:via-purple-100:focus {\n    --gradient-via-color: #edebfe;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(237, 235, 254, 0));\n  }\n  .xl\\:focus\\:via-purple-200:focus {\n    --gradient-via-color: #dcd7fe;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(220, 215, 254, 0));\n  }\n  .xl\\:focus\\:via-purple-300:focus {\n    --gradient-via-color: #cabffd;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(202, 191, 253, 0));\n  }\n  .xl\\:focus\\:via-purple-400:focus {\n    --gradient-via-color: #ac94fa;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(172, 148, 250, 0));\n  }\n  .xl\\:focus\\:via-purple-500:focus {\n    --gradient-via-color: #9061f9;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(144, 97, 249, 0));\n  }\n  .xl\\:focus\\:via-purple-600:focus {\n    --gradient-via-color: #7e3af2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(126, 58, 242, 0));\n  }\n  .xl\\:focus\\:via-purple-700:focus {\n    --gradient-via-color: #6c2bd9;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(108, 43, 217, 0));\n  }\n  .xl\\:focus\\:via-purple-800:focus {\n    --gradient-via-color: #5521b5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(85, 33, 181, 0));\n  }\n  .xl\\:focus\\:via-purple-900:focus {\n    --gradient-via-color: #4a1d96;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(74, 29, 150, 0));\n  }\n  .xl\\:focus\\:via-pink-50:focus {\n    --gradient-via-color: #fdf2f8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 242, 248, 0));\n  }\n  .xl\\:focus\\:via-pink-100:focus {\n    --gradient-via-color: #fce8f3;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(252, 232, 243, 0));\n  }\n  .xl\\:focus\\:via-pink-200:focus {\n    --gradient-via-color: #fad1e8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(250, 209, 232, 0));\n  }\n  .xl\\:focus\\:via-pink-300:focus {\n    --gradient-via-color: #f8b4d9;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(248, 180, 217, 0));\n  }\n  .xl\\:focus\\:via-pink-400:focus {\n    --gradient-via-color: #f17eb8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(241, 126, 184, 0));\n  }\n  .xl\\:focus\\:via-pink-500:focus {\n    --gradient-via-color: #e74694;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(231, 70, 148, 0));\n  }\n  .xl\\:focus\\:via-pink-600:focus {\n    --gradient-via-color: #d61f69;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(214, 31, 105, 0));\n  }\n  .xl\\:focus\\:via-pink-700:focus {\n    --gradient-via-color: #bf125d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(191, 18, 93, 0));\n  }\n  .xl\\:focus\\:via-pink-800:focus {\n    --gradient-via-color: #99154b;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(153, 21, 75, 0));\n  }\n  .xl\\:focus\\:via-pink-900:focus {\n    --gradient-via-color: #751a3d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(117, 26, 61, 0));\n  }\n  .xl\\:focus\\:via-cool-gray-50:focus {\n    --gradient-via-color: #f8fafc;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(248, 250, 252, 0));\n  }\n  .xl\\:focus\\:via-cool-gray-100:focus {\n    --gradient-via-color: #f1f5f9;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(241, 245, 249, 0));\n  }\n  .xl\\:focus\\:via-cool-gray-200:focus {\n    --gradient-via-color: #e2e8f0;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(226, 232, 240, 0));\n  }\n  .xl\\:focus\\:via-cool-gray-300:focus {\n    --gradient-via-color: #cfd8e3;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(207, 216, 227, 0));\n  }\n  .xl\\:focus\\:via-cool-gray-400:focus {\n    --gradient-via-color: #97a6ba;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(151, 166, 186, 0));\n  }\n  .xl\\:focus\\:via-cool-gray-500:focus {\n    --gradient-via-color: #64748b;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(100, 116, 139, 0));\n  }\n  .xl\\:focus\\:via-cool-gray-600:focus {\n    --gradient-via-color: #475569;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(71, 85, 105, 0));\n  }\n  .xl\\:focus\\:via-cool-gray-700:focus {\n    --gradient-via-color: #364152;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(54, 65, 82, 0));\n  }\n  .xl\\:focus\\:via-cool-gray-800:focus {\n    --gradient-via-color: #27303f;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(39, 48, 63, 0));\n  }\n  .xl\\:focus\\:via-cool-gray-900:focus {\n    --gradient-via-color: #1a202e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(26, 32, 46, 0));\n  }\n  .xl\\:focus\\:to-current:focus {\n    --gradient-to-color: currentColor;\n  }\n  .xl\\:focus\\:to-transparent:focus {\n    --gradient-to-color: transparent;\n  }\n  .xl\\:focus\\:to-white:focus {\n    --gradient-to-color: #ffffff;\n  }\n  .xl\\:focus\\:to-black:focus {\n    --gradient-to-color: #000000;\n  }\n  .xl\\:focus\\:to-gray-50:focus {\n    --gradient-to-color: #f9fafb;\n  }\n  .xl\\:focus\\:to-gray-100:focus {\n    --gradient-to-color: #f4f5f7;\n  }\n  .xl\\:focus\\:to-gray-200:focus {\n    --gradient-to-color: #e5e7eb;\n  }\n  .xl\\:focus\\:to-gray-300:focus {\n    --gradient-to-color: #d2d6dc;\n  }\n  .xl\\:focus\\:to-gray-400:focus {\n    --gradient-to-color: #9fa6b2;\n  }\n  .xl\\:focus\\:to-gray-500:focus {\n    --gradient-to-color: #6b7280;\n  }\n  .xl\\:focus\\:to-gray-600:focus {\n    --gradient-to-color: #4b5563;\n  }\n  .xl\\:focus\\:to-gray-700:focus {\n    --gradient-to-color: #374151;\n  }\n  .xl\\:focus\\:to-gray-800:focus {\n    --gradient-to-color: #252f3f;\n  }\n  .xl\\:focus\\:to-gray-900:focus {\n    --gradient-to-color: #161e2e;\n  }\n  .xl\\:focus\\:to-red-50:focus {\n    --gradient-to-color: #fdf2f2;\n  }\n  .xl\\:focus\\:to-red-100:focus {\n    --gradient-to-color: #fde8e8;\n  }\n  .xl\\:focus\\:to-red-200:focus {\n    --gradient-to-color: #fbd5d5;\n  }\n  .xl\\:focus\\:to-red-300:focus {\n    --gradient-to-color: #f8b4b4;\n  }\n  .xl\\:focus\\:to-red-400:focus {\n    --gradient-to-color: #f98080;\n  }\n  .xl\\:focus\\:to-red-500:focus {\n    --gradient-to-color: #f05252;\n  }\n  .xl\\:focus\\:to-red-600:focus {\n    --gradient-to-color: #e02424;\n  }\n  .xl\\:focus\\:to-red-700:focus {\n    --gradient-to-color: #c81e1e;\n  }\n  .xl\\:focus\\:to-red-800:focus {\n    --gradient-to-color: #9b1c1c;\n  }\n  .xl\\:focus\\:to-red-900:focus {\n    --gradient-to-color: #771d1d;\n  }\n  .xl\\:focus\\:to-orange-50:focus {\n    --gradient-to-color: #fff8f1;\n  }\n  .xl\\:focus\\:to-orange-100:focus {\n    --gradient-to-color: #feecdc;\n  }\n  .xl\\:focus\\:to-orange-200:focus {\n    --gradient-to-color: #fcd9bd;\n  }\n  .xl\\:focus\\:to-orange-300:focus {\n    --gradient-to-color: #fdba8c;\n  }\n  .xl\\:focus\\:to-orange-400:focus {\n    --gradient-to-color: #ff8a4c;\n  }\n  .xl\\:focus\\:to-orange-500:focus {\n    --gradient-to-color: #ff5a1f;\n  }\n  .xl\\:focus\\:to-orange-600:focus {\n    --gradient-to-color: #d03801;\n  }\n  .xl\\:focus\\:to-orange-700:focus {\n    --gradient-to-color: #b43403;\n  }\n  .xl\\:focus\\:to-orange-800:focus {\n    --gradient-to-color: #8a2c0d;\n  }\n  .xl\\:focus\\:to-orange-900:focus {\n    --gradient-to-color: #73230d;\n  }\n  .xl\\:focus\\:to-yellow-50:focus {\n    --gradient-to-color: #fdfdea;\n  }\n  .xl\\:focus\\:to-yellow-100:focus {\n    --gradient-to-color: #fdf6b2;\n  }\n  .xl\\:focus\\:to-yellow-200:focus {\n    --gradient-to-color: #fce96a;\n  }\n  .xl\\:focus\\:to-yellow-300:focus {\n    --gradient-to-color: #faca15;\n  }\n  .xl\\:focus\\:to-yellow-400:focus {\n    --gradient-to-color: #e3a008;\n  }\n  .xl\\:focus\\:to-yellow-500:focus {\n    --gradient-to-color: #c27803;\n  }\n  .xl\\:focus\\:to-yellow-600:focus {\n    --gradient-to-color: #9f580a;\n  }\n  .xl\\:focus\\:to-yellow-700:focus {\n    --gradient-to-color: #8e4b10;\n  }\n  .xl\\:focus\\:to-yellow-800:focus {\n    --gradient-to-color: #723b13;\n  }\n  .xl\\:focus\\:to-yellow-900:focus {\n    --gradient-to-color: #633112;\n  }\n  .xl\\:focus\\:to-green-50:focus {\n    --gradient-to-color: #f3faf7;\n  }\n  .xl\\:focus\\:to-green-100:focus {\n    --gradient-to-color: #def7ec;\n  }\n  .xl\\:focus\\:to-green-200:focus {\n    --gradient-to-color: #bcf0da;\n  }\n  .xl\\:focus\\:to-green-300:focus {\n    --gradient-to-color: #84e1bc;\n  }\n  .xl\\:focus\\:to-green-400:focus {\n    --gradient-to-color: #31c48d;\n  }\n  .xl\\:focus\\:to-green-500:focus {\n    --gradient-to-color: #0e9f6e;\n  }\n  .xl\\:focus\\:to-green-600:focus {\n    --gradient-to-color: #057a55;\n  }\n  .xl\\:focus\\:to-green-700:focus {\n    --gradient-to-color: #046c4e;\n  }\n  .xl\\:focus\\:to-green-800:focus {\n    --gradient-to-color: #03543f;\n  }\n  .xl\\:focus\\:to-green-900:focus {\n    --gradient-to-color: #014737;\n  }\n  .xl\\:focus\\:to-teal-50:focus {\n    --gradient-to-color: #edfafa;\n  }\n  .xl\\:focus\\:to-teal-100:focus {\n    --gradient-to-color: #d5f5f6;\n  }\n  .xl\\:focus\\:to-teal-200:focus {\n    --gradient-to-color: #afecef;\n  }\n  .xl\\:focus\\:to-teal-300:focus {\n    --gradient-to-color: #7edce2;\n  }\n  .xl\\:focus\\:to-teal-400:focus {\n    --gradient-to-color: #16bdca;\n  }\n  .xl\\:focus\\:to-teal-500:focus {\n    --gradient-to-color: #0694a2;\n  }\n  .xl\\:focus\\:to-teal-600:focus {\n    --gradient-to-color: #047481;\n  }\n  .xl\\:focus\\:to-teal-700:focus {\n    --gradient-to-color: #036672;\n  }\n  .xl\\:focus\\:to-teal-800:focus {\n    --gradient-to-color: #05505c;\n  }\n  .xl\\:focus\\:to-teal-900:focus {\n    --gradient-to-color: #014451;\n  }\n  .xl\\:focus\\:to-blue-50:focus {\n    --gradient-to-color: #ebf5ff;\n  }\n  .xl\\:focus\\:to-blue-100:focus {\n    --gradient-to-color: #e1effe;\n  }\n  .xl\\:focus\\:to-blue-200:focus {\n    --gradient-to-color: #c3ddfd;\n  }\n  .xl\\:focus\\:to-blue-300:focus {\n    --gradient-to-color: #a4cafe;\n  }\n  .xl\\:focus\\:to-blue-400:focus {\n    --gradient-to-color: #76a9fa;\n  }\n  .xl\\:focus\\:to-blue-500:focus {\n    --gradient-to-color: #3f83f8;\n  }\n  .xl\\:focus\\:to-blue-600:focus {\n    --gradient-to-color: #1c64f2;\n  }\n  .xl\\:focus\\:to-blue-700:focus {\n    --gradient-to-color: #1a56db;\n  }\n  .xl\\:focus\\:to-blue-800:focus {\n    --gradient-to-color: #1e429f;\n  }\n  .xl\\:focus\\:to-blue-900:focus {\n    --gradient-to-color: #233876;\n  }\n  .xl\\:focus\\:to-indigo-50:focus {\n    --gradient-to-color: #f0f5ff;\n  }\n  .xl\\:focus\\:to-indigo-100:focus {\n    --gradient-to-color: #e5edff;\n  }\n  .xl\\:focus\\:to-indigo-200:focus {\n    --gradient-to-color: #cddbfe;\n  }\n  .xl\\:focus\\:to-indigo-300:focus {\n    --gradient-to-color: #b4c6fc;\n  }\n  .xl\\:focus\\:to-indigo-400:focus {\n    --gradient-to-color: #8da2fb;\n  }\n  .xl\\:focus\\:to-indigo-500:focus {\n    --gradient-to-color: #6875f5;\n  }\n  .xl\\:focus\\:to-indigo-600:focus {\n    --gradient-to-color: #5850ec;\n  }\n  .xl\\:focus\\:to-indigo-700:focus {\n    --gradient-to-color: #5145cd;\n  }\n  .xl\\:focus\\:to-indigo-800:focus {\n    --gradient-to-color: #42389d;\n  }\n  .xl\\:focus\\:to-indigo-900:focus {\n    --gradient-to-color: #362f78;\n  }\n  .xl\\:focus\\:to-purple-50:focus {\n    --gradient-to-color: #f6f5ff;\n  }\n  .xl\\:focus\\:to-purple-100:focus {\n    --gradient-to-color: #edebfe;\n  }\n  .xl\\:focus\\:to-purple-200:focus {\n    --gradient-to-color: #dcd7fe;\n  }\n  .xl\\:focus\\:to-purple-300:focus {\n    --gradient-to-color: #cabffd;\n  }\n  .xl\\:focus\\:to-purple-400:focus {\n    --gradient-to-color: #ac94fa;\n  }\n  .xl\\:focus\\:to-purple-500:focus {\n    --gradient-to-color: #9061f9;\n  }\n  .xl\\:focus\\:to-purple-600:focus {\n    --gradient-to-color: #7e3af2;\n  }\n  .xl\\:focus\\:to-purple-700:focus {\n    --gradient-to-color: #6c2bd9;\n  }\n  .xl\\:focus\\:to-purple-800:focus {\n    --gradient-to-color: #5521b5;\n  }\n  .xl\\:focus\\:to-purple-900:focus {\n    --gradient-to-color: #4a1d96;\n  }\n  .xl\\:focus\\:to-pink-50:focus {\n    --gradient-to-color: #fdf2f8;\n  }\n  .xl\\:focus\\:to-pink-100:focus {\n    --gradient-to-color: #fce8f3;\n  }\n  .xl\\:focus\\:to-pink-200:focus {\n    --gradient-to-color: #fad1e8;\n  }\n  .xl\\:focus\\:to-pink-300:focus {\n    --gradient-to-color: #f8b4d9;\n  }\n  .xl\\:focus\\:to-pink-400:focus {\n    --gradient-to-color: #f17eb8;\n  }\n  .xl\\:focus\\:to-pink-500:focus {\n    --gradient-to-color: #e74694;\n  }\n  .xl\\:focus\\:to-pink-600:focus {\n    --gradient-to-color: #d61f69;\n  }\n  .xl\\:focus\\:to-pink-700:focus {\n    --gradient-to-color: #bf125d;\n  }\n  .xl\\:focus\\:to-pink-800:focus {\n    --gradient-to-color: #99154b;\n  }\n  .xl\\:focus\\:to-pink-900:focus {\n    --gradient-to-color: #751a3d;\n  }\n  .xl\\:focus\\:to-cool-gray-50:focus {\n    --gradient-to-color: #f8fafc;\n  }\n  .xl\\:focus\\:to-cool-gray-100:focus {\n    --gradient-to-color: #f1f5f9;\n  }\n  .xl\\:focus\\:to-cool-gray-200:focus {\n    --gradient-to-color: #e2e8f0;\n  }\n  .xl\\:focus\\:to-cool-gray-300:focus {\n    --gradient-to-color: #cfd8e3;\n  }\n  .xl\\:focus\\:to-cool-gray-400:focus {\n    --gradient-to-color: #97a6ba;\n  }\n  .xl\\:focus\\:to-cool-gray-500:focus {\n    --gradient-to-color: #64748b;\n  }\n  .xl\\:focus\\:to-cool-gray-600:focus {\n    --gradient-to-color: #475569;\n  }\n  .xl\\:focus\\:to-cool-gray-700:focus {\n    --gradient-to-color: #364152;\n  }\n  .xl\\:focus\\:to-cool-gray-800:focus {\n    --gradient-to-color: #27303f;\n  }\n  .xl\\:focus\\:to-cool-gray-900:focus {\n    --gradient-to-color: #1a202e;\n  }\n  .xl\\:bg-opacity-0 {\n    --bg-opacity: 0;\n  }\n  .xl\\:bg-opacity-25 {\n    --bg-opacity: 0.25;\n  }\n  .xl\\:bg-opacity-50 {\n    --bg-opacity: 0.5;\n  }\n  .xl\\:bg-opacity-75 {\n    --bg-opacity: 0.75;\n  }\n  .xl\\:bg-opacity-100 {\n    --bg-opacity: 1;\n  }\n  .xl\\:hover\\:bg-opacity-0:hover {\n    --bg-opacity: 0;\n  }\n  .xl\\:hover\\:bg-opacity-25:hover {\n    --bg-opacity: 0.25;\n  }\n  .xl\\:hover\\:bg-opacity-50:hover {\n    --bg-opacity: 0.5;\n  }\n  .xl\\:hover\\:bg-opacity-75:hover {\n    --bg-opacity: 0.75;\n  }\n  .xl\\:hover\\:bg-opacity-100:hover {\n    --bg-opacity: 1;\n  }\n  .xl\\:focus\\:bg-opacity-0:focus {\n    --bg-opacity: 0;\n  }\n  .xl\\:focus\\:bg-opacity-25:focus {\n    --bg-opacity: 0.25;\n  }\n  .xl\\:focus\\:bg-opacity-50:focus {\n    --bg-opacity: 0.5;\n  }\n  .xl\\:focus\\:bg-opacity-75:focus {\n    --bg-opacity: 0.75;\n  }\n  .xl\\:focus\\:bg-opacity-100:focus {\n    --bg-opacity: 1;\n  }\n  .xl\\:bg-bottom {\n    background-position: bottom;\n  }\n  .xl\\:bg-center {\n    background-position: center;\n  }\n  .xl\\:bg-left {\n    background-position: left;\n  }\n  .xl\\:bg-left-bottom {\n    background-position: left bottom;\n  }\n  .xl\\:bg-left-top {\n    background-position: left top;\n  }\n  .xl\\:bg-right {\n    background-position: right;\n  }\n  .xl\\:bg-right-bottom {\n    background-position: right bottom;\n  }\n  .xl\\:bg-right-top {\n    background-position: right top;\n  }\n  .xl\\:bg-top {\n    background-position: top;\n  }\n  .xl\\:bg-repeat {\n    background-repeat: repeat;\n  }\n  .xl\\:bg-no-repeat {\n    background-repeat: no-repeat;\n  }\n  .xl\\:bg-repeat-x {\n    background-repeat: repeat-x;\n  }\n  .xl\\:bg-repeat-y {\n    background-repeat: repeat-y;\n  }\n  .xl\\:bg-repeat-round {\n    background-repeat: round;\n  }\n  .xl\\:bg-repeat-space {\n    background-repeat: space;\n  }\n  .xl\\:bg-auto {\n    background-size: auto;\n  }\n  .xl\\:bg-cover {\n    background-size: cover;\n  }\n  .xl\\:bg-contain {\n    background-size: contain;\n  }\n  .xl\\:border-collapse {\n    border-collapse: collapse;\n  }\n  .xl\\:border-separate {\n    border-collapse: separate;\n  }\n  .xl\\:border-current {\n    border-color: currentColor;\n  }\n  .xl\\:border-transparent {\n    border-color: transparent;\n  }\n  .xl\\:border-white {\n    --border-opacity: 1;\n    border-color: #ffffff;\n    border-color: rgba(255, 255, 255, var(--border-opacity));\n  }\n  .xl\\:border-black {\n    --border-opacity: 1;\n    border-color: #000000;\n    border-color: rgba(0, 0, 0, var(--border-opacity));\n  }\n  .xl\\:border-gray-50 {\n    --border-opacity: 1;\n    border-color: #f9fafb;\n    border-color: rgba(249, 250, 251, var(--border-opacity));\n  }\n  .xl\\:border-gray-100 {\n    --border-opacity: 1;\n    border-color: #f4f5f7;\n    border-color: rgba(244, 245, 247, var(--border-opacity));\n  }\n  .xl\\:border-gray-200 {\n    --border-opacity: 1;\n    border-color: #e5e7eb;\n    border-color: rgba(229, 231, 235, var(--border-opacity));\n  }\n  .xl\\:border-gray-300 {\n    --border-opacity: 1;\n    border-color: #d2d6dc;\n    border-color: rgba(210, 214, 220, var(--border-opacity));\n  }\n  .xl\\:border-gray-400 {\n    --border-opacity: 1;\n    border-color: #9fa6b2;\n    border-color: rgba(159, 166, 178, var(--border-opacity));\n  }\n  .xl\\:border-gray-500 {\n    --border-opacity: 1;\n    border-color: #6b7280;\n    border-color: rgba(107, 114, 128, var(--border-opacity));\n  }\n  .xl\\:border-gray-600 {\n    --border-opacity: 1;\n    border-color: #4b5563;\n    border-color: rgba(75, 85, 99, var(--border-opacity));\n  }\n  .xl\\:border-gray-700 {\n    --border-opacity: 1;\n    border-color: #374151;\n    border-color: rgba(55, 65, 81, var(--border-opacity));\n  }\n  .xl\\:border-gray-800 {\n    --border-opacity: 1;\n    border-color: #252f3f;\n    border-color: rgba(37, 47, 63, var(--border-opacity));\n  }\n  .xl\\:border-gray-900 {\n    --border-opacity: 1;\n    border-color: #161e2e;\n    border-color: rgba(22, 30, 46, var(--border-opacity));\n  }\n  .xl\\:border-red-50 {\n    --border-opacity: 1;\n    border-color: #fdf2f2;\n    border-color: rgba(253, 242, 242, var(--border-opacity));\n  }\n  .xl\\:border-red-100 {\n    --border-opacity: 1;\n    border-color: #fde8e8;\n    border-color: rgba(253, 232, 232, var(--border-opacity));\n  }\n  .xl\\:border-red-200 {\n    --border-opacity: 1;\n    border-color: #fbd5d5;\n    border-color: rgba(251, 213, 213, var(--border-opacity));\n  }\n  .xl\\:border-red-300 {\n    --border-opacity: 1;\n    border-color: #f8b4b4;\n    border-color: rgba(248, 180, 180, var(--border-opacity));\n  }\n  .xl\\:border-red-400 {\n    --border-opacity: 1;\n    border-color: #f98080;\n    border-color: rgba(249, 128, 128, var(--border-opacity));\n  }\n  .xl\\:border-red-500 {\n    --border-opacity: 1;\n    border-color: #f05252;\n    border-color: rgba(240, 82, 82, var(--border-opacity));\n  }\n  .xl\\:border-red-600 {\n    --border-opacity: 1;\n    border-color: #e02424;\n    border-color: rgba(224, 36, 36, var(--border-opacity));\n  }\n  .xl\\:border-red-700 {\n    --border-opacity: 1;\n    border-color: #c81e1e;\n    border-color: rgba(200, 30, 30, var(--border-opacity));\n  }\n  .xl\\:border-red-800 {\n    --border-opacity: 1;\n    border-color: #9b1c1c;\n    border-color: rgba(155, 28, 28, var(--border-opacity));\n  }\n  .xl\\:border-red-900 {\n    --border-opacity: 1;\n    border-color: #771d1d;\n    border-color: rgba(119, 29, 29, var(--border-opacity));\n  }\n  .xl\\:border-orange-50 {\n    --border-opacity: 1;\n    border-color: #fff8f1;\n    border-color: rgba(255, 248, 241, var(--border-opacity));\n  }\n  .xl\\:border-orange-100 {\n    --border-opacity: 1;\n    border-color: #feecdc;\n    border-color: rgba(254, 236, 220, var(--border-opacity));\n  }\n  .xl\\:border-orange-200 {\n    --border-opacity: 1;\n    border-color: #fcd9bd;\n    border-color: rgba(252, 217, 189, var(--border-opacity));\n  }\n  .xl\\:border-orange-300 {\n    --border-opacity: 1;\n    border-color: #fdba8c;\n    border-color: rgba(253, 186, 140, var(--border-opacity));\n  }\n  .xl\\:border-orange-400 {\n    --border-opacity: 1;\n    border-color: #ff8a4c;\n    border-color: rgba(255, 138, 76, var(--border-opacity));\n  }\n  .xl\\:border-orange-500 {\n    --border-opacity: 1;\n    border-color: #ff5a1f;\n    border-color: rgba(255, 90, 31, var(--border-opacity));\n  }\n  .xl\\:border-orange-600 {\n    --border-opacity: 1;\n    border-color: #d03801;\n    border-color: rgba(208, 56, 1, var(--border-opacity));\n  }\n  .xl\\:border-orange-700 {\n    --border-opacity: 1;\n    border-color: #b43403;\n    border-color: rgba(180, 52, 3, var(--border-opacity));\n  }\n  .xl\\:border-orange-800 {\n    --border-opacity: 1;\n    border-color: #8a2c0d;\n    border-color: rgba(138, 44, 13, var(--border-opacity));\n  }\n  .xl\\:border-orange-900 {\n    --border-opacity: 1;\n    border-color: #73230d;\n    border-color: rgba(115, 35, 13, var(--border-opacity));\n  }\n  .xl\\:border-yellow-50 {\n    --border-opacity: 1;\n    border-color: #fdfdea;\n    border-color: rgba(253, 253, 234, var(--border-opacity));\n  }\n  .xl\\:border-yellow-100 {\n    --border-opacity: 1;\n    border-color: #fdf6b2;\n    border-color: rgba(253, 246, 178, var(--border-opacity));\n  }\n  .xl\\:border-yellow-200 {\n    --border-opacity: 1;\n    border-color: #fce96a;\n    border-color: rgba(252, 233, 106, var(--border-opacity));\n  }\n  .xl\\:border-yellow-300 {\n    --border-opacity: 1;\n    border-color: #faca15;\n    border-color: rgba(250, 202, 21, var(--border-opacity));\n  }\n  .xl\\:border-yellow-400 {\n    --border-opacity: 1;\n    border-color: #e3a008;\n    border-color: rgba(227, 160, 8, var(--border-opacity));\n  }\n  .xl\\:border-yellow-500 {\n    --border-opacity: 1;\n    border-color: #c27803;\n    border-color: rgba(194, 120, 3, var(--border-opacity));\n  }\n  .xl\\:border-yellow-600 {\n    --border-opacity: 1;\n    border-color: #9f580a;\n    border-color: rgba(159, 88, 10, var(--border-opacity));\n  }\n  .xl\\:border-yellow-700 {\n    --border-opacity: 1;\n    border-color: #8e4b10;\n    border-color: rgba(142, 75, 16, var(--border-opacity));\n  }\n  .xl\\:border-yellow-800 {\n    --border-opacity: 1;\n    border-color: #723b13;\n    border-color: rgba(114, 59, 19, var(--border-opacity));\n  }\n  .xl\\:border-yellow-900 {\n    --border-opacity: 1;\n    border-color: #633112;\n    border-color: rgba(99, 49, 18, var(--border-opacity));\n  }\n  .xl\\:border-green-50 {\n    --border-opacity: 1;\n    border-color: #f3faf7;\n    border-color: rgba(243, 250, 247, var(--border-opacity));\n  }\n  .xl\\:border-green-100 {\n    --border-opacity: 1;\n    border-color: #def7ec;\n    border-color: rgba(222, 247, 236, var(--border-opacity));\n  }\n  .xl\\:border-green-200 {\n    --border-opacity: 1;\n    border-color: #bcf0da;\n    border-color: rgba(188, 240, 218, var(--border-opacity));\n  }\n  .xl\\:border-green-300 {\n    --border-opacity: 1;\n    border-color: #84e1bc;\n    border-color: rgba(132, 225, 188, var(--border-opacity));\n  }\n  .xl\\:border-green-400 {\n    --border-opacity: 1;\n    border-color: #31c48d;\n    border-color: rgba(49, 196, 141, var(--border-opacity));\n  }\n  .xl\\:border-green-500 {\n    --border-opacity: 1;\n    border-color: #0e9f6e;\n    border-color: rgba(14, 159, 110, var(--border-opacity));\n  }\n  .xl\\:border-green-600 {\n    --border-opacity: 1;\n    border-color: #057a55;\n    border-color: rgba(5, 122, 85, var(--border-opacity));\n  }\n  .xl\\:border-green-700 {\n    --border-opacity: 1;\n    border-color: #046c4e;\n    border-color: rgba(4, 108, 78, var(--border-opacity));\n  }\n  .xl\\:border-green-800 {\n    --border-opacity: 1;\n    border-color: #03543f;\n    border-color: rgba(3, 84, 63, var(--border-opacity));\n  }\n  .xl\\:border-green-900 {\n    --border-opacity: 1;\n    border-color: #014737;\n    border-color: rgba(1, 71, 55, var(--border-opacity));\n  }\n  .xl\\:border-teal-50 {\n    --border-opacity: 1;\n    border-color: #edfafa;\n    border-color: rgba(237, 250, 250, var(--border-opacity));\n  }\n  .xl\\:border-teal-100 {\n    --border-opacity: 1;\n    border-color: #d5f5f6;\n    border-color: rgba(213, 245, 246, var(--border-opacity));\n  }\n  .xl\\:border-teal-200 {\n    --border-opacity: 1;\n    border-color: #afecef;\n    border-color: rgba(175, 236, 239, var(--border-opacity));\n  }\n  .xl\\:border-teal-300 {\n    --border-opacity: 1;\n    border-color: #7edce2;\n    border-color: rgba(126, 220, 226, var(--border-opacity));\n  }\n  .xl\\:border-teal-400 {\n    --border-opacity: 1;\n    border-color: #16bdca;\n    border-color: rgba(22, 189, 202, var(--border-opacity));\n  }\n  .xl\\:border-teal-500 {\n    --border-opacity: 1;\n    border-color: #0694a2;\n    border-color: rgba(6, 148, 162, var(--border-opacity));\n  }\n  .xl\\:border-teal-600 {\n    --border-opacity: 1;\n    border-color: #047481;\n    border-color: rgba(4, 116, 129, var(--border-opacity));\n  }\n  .xl\\:border-teal-700 {\n    --border-opacity: 1;\n    border-color: #036672;\n    border-color: rgba(3, 102, 114, var(--border-opacity));\n  }\n  .xl\\:border-teal-800 {\n    --border-opacity: 1;\n    border-color: #05505c;\n    border-color: rgba(5, 80, 92, var(--border-opacity));\n  }\n  .xl\\:border-teal-900 {\n    --border-opacity: 1;\n    border-color: #014451;\n    border-color: rgba(1, 68, 81, var(--border-opacity));\n  }\n  .xl\\:border-blue-50 {\n    --border-opacity: 1;\n    border-color: #ebf5ff;\n    border-color: rgba(235, 245, 255, var(--border-opacity));\n  }\n  .xl\\:border-blue-100 {\n    --border-opacity: 1;\n    border-color: #e1effe;\n    border-color: rgba(225, 239, 254, var(--border-opacity));\n  }\n  .xl\\:border-blue-200 {\n    --border-opacity: 1;\n    border-color: #c3ddfd;\n    border-color: rgba(195, 221, 253, var(--border-opacity));\n  }\n  .xl\\:border-blue-300 {\n    --border-opacity: 1;\n    border-color: #a4cafe;\n    border-color: rgba(164, 202, 254, var(--border-opacity));\n  }\n  .xl\\:border-blue-400 {\n    --border-opacity: 1;\n    border-color: #76a9fa;\n    border-color: rgba(118, 169, 250, var(--border-opacity));\n  }\n  .xl\\:border-blue-500 {\n    --border-opacity: 1;\n    border-color: #3f83f8;\n    border-color: rgba(63, 131, 248, var(--border-opacity));\n  }\n  .xl\\:border-blue-600 {\n    --border-opacity: 1;\n    border-color: #1c64f2;\n    border-color: rgba(28, 100, 242, var(--border-opacity));\n  }\n  .xl\\:border-blue-700 {\n    --border-opacity: 1;\n    border-color: #1a56db;\n    border-color: rgba(26, 86, 219, var(--border-opacity));\n  }\n  .xl\\:border-blue-800 {\n    --border-opacity: 1;\n    border-color: #1e429f;\n    border-color: rgba(30, 66, 159, var(--border-opacity));\n  }\n  .xl\\:border-blue-900 {\n    --border-opacity: 1;\n    border-color: #233876;\n    border-color: rgba(35, 56, 118, var(--border-opacity));\n  }\n  .xl\\:border-indigo-50 {\n    --border-opacity: 1;\n    border-color: #f0f5ff;\n    border-color: rgba(240, 245, 255, var(--border-opacity));\n  }\n  .xl\\:border-indigo-100 {\n    --border-opacity: 1;\n    border-color: #e5edff;\n    border-color: rgba(229, 237, 255, var(--border-opacity));\n  }\n  .xl\\:border-indigo-200 {\n    --border-opacity: 1;\n    border-color: #cddbfe;\n    border-color: rgba(205, 219, 254, var(--border-opacity));\n  }\n  .xl\\:border-indigo-300 {\n    --border-opacity: 1;\n    border-color: #b4c6fc;\n    border-color: rgba(180, 198, 252, var(--border-opacity));\n  }\n  .xl\\:border-indigo-400 {\n    --border-opacity: 1;\n    border-color: #8da2fb;\n    border-color: rgba(141, 162, 251, var(--border-opacity));\n  }\n  .xl\\:border-indigo-500 {\n    --border-opacity: 1;\n    border-color: #6875f5;\n    border-color: rgba(104, 117, 245, var(--border-opacity));\n  }\n  .xl\\:border-indigo-600 {\n    --border-opacity: 1;\n    border-color: #5850ec;\n    border-color: rgba(88, 80, 236, var(--border-opacity));\n  }\n  .xl\\:border-indigo-700 {\n    --border-opacity: 1;\n    border-color: #5145cd;\n    border-color: rgba(81, 69, 205, var(--border-opacity));\n  }\n  .xl\\:border-indigo-800 {\n    --border-opacity: 1;\n    border-color: #42389d;\n    border-color: rgba(66, 56, 157, var(--border-opacity));\n  }\n  .xl\\:border-indigo-900 {\n    --border-opacity: 1;\n    border-color: #362f78;\n    border-color: rgba(54, 47, 120, var(--border-opacity));\n  }\n  .xl\\:border-purple-50 {\n    --border-opacity: 1;\n    border-color: #f6f5ff;\n    border-color: rgba(246, 245, 255, var(--border-opacity));\n  }\n  .xl\\:border-purple-100 {\n    --border-opacity: 1;\n    border-color: #edebfe;\n    border-color: rgba(237, 235, 254, var(--border-opacity));\n  }\n  .xl\\:border-purple-200 {\n    --border-opacity: 1;\n    border-color: #dcd7fe;\n    border-color: rgba(220, 215, 254, var(--border-opacity));\n  }\n  .xl\\:border-purple-300 {\n    --border-opacity: 1;\n    border-color: #cabffd;\n    border-color: rgba(202, 191, 253, var(--border-opacity));\n  }\n  .xl\\:border-purple-400 {\n    --border-opacity: 1;\n    border-color: #ac94fa;\n    border-color: rgba(172, 148, 250, var(--border-opacity));\n  }\n  .xl\\:border-purple-500 {\n    --border-opacity: 1;\n    border-color: #9061f9;\n    border-color: rgba(144, 97, 249, var(--border-opacity));\n  }\n  .xl\\:border-purple-600 {\n    --border-opacity: 1;\n    border-color: #7e3af2;\n    border-color: rgba(126, 58, 242, var(--border-opacity));\n  }\n  .xl\\:border-purple-700 {\n    --border-opacity: 1;\n    border-color: #6c2bd9;\n    border-color: rgba(108, 43, 217, var(--border-opacity));\n  }\n  .xl\\:border-purple-800 {\n    --border-opacity: 1;\n    border-color: #5521b5;\n    border-color: rgba(85, 33, 181, var(--border-opacity));\n  }\n  .xl\\:border-purple-900 {\n    --border-opacity: 1;\n    border-color: #4a1d96;\n    border-color: rgba(74, 29, 150, var(--border-opacity));\n  }\n  .xl\\:border-pink-50 {\n    --border-opacity: 1;\n    border-color: #fdf2f8;\n    border-color: rgba(253, 242, 248, var(--border-opacity));\n  }\n  .xl\\:border-pink-100 {\n    --border-opacity: 1;\n    border-color: #fce8f3;\n    border-color: rgba(252, 232, 243, var(--border-opacity));\n  }\n  .xl\\:border-pink-200 {\n    --border-opacity: 1;\n    border-color: #fad1e8;\n    border-color: rgba(250, 209, 232, var(--border-opacity));\n  }\n  .xl\\:border-pink-300 {\n    --border-opacity: 1;\n    border-color: #f8b4d9;\n    border-color: rgba(248, 180, 217, var(--border-opacity));\n  }\n  .xl\\:border-pink-400 {\n    --border-opacity: 1;\n    border-color: #f17eb8;\n    border-color: rgba(241, 126, 184, var(--border-opacity));\n  }\n  .xl\\:border-pink-500 {\n    --border-opacity: 1;\n    border-color: #e74694;\n    border-color: rgba(231, 70, 148, var(--border-opacity));\n  }\n  .xl\\:border-pink-600 {\n    --border-opacity: 1;\n    border-color: #d61f69;\n    border-color: rgba(214, 31, 105, var(--border-opacity));\n  }\n  .xl\\:border-pink-700 {\n    --border-opacity: 1;\n    border-color: #bf125d;\n    border-color: rgba(191, 18, 93, var(--border-opacity));\n  }\n  .xl\\:border-pink-800 {\n    --border-opacity: 1;\n    border-color: #99154b;\n    border-color: rgba(153, 21, 75, var(--border-opacity));\n  }\n  .xl\\:border-pink-900 {\n    --border-opacity: 1;\n    border-color: #751a3d;\n    border-color: rgba(117, 26, 61, var(--border-opacity));\n  }\n  .xl\\:border-cool-gray-50 {\n    --border-opacity: 1;\n    border-color: #f8fafc;\n    border-color: rgba(248, 250, 252, var(--border-opacity));\n  }\n  .xl\\:border-cool-gray-100 {\n    --border-opacity: 1;\n    border-color: #f1f5f9;\n    border-color: rgba(241, 245, 249, var(--border-opacity));\n  }\n  .xl\\:border-cool-gray-200 {\n    --border-opacity: 1;\n    border-color: #e2e8f0;\n    border-color: rgba(226, 232, 240, var(--border-opacity));\n  }\n  .xl\\:border-cool-gray-300 {\n    --border-opacity: 1;\n    border-color: #cfd8e3;\n    border-color: rgba(207, 216, 227, var(--border-opacity));\n  }\n  .xl\\:border-cool-gray-400 {\n    --border-opacity: 1;\n    border-color: #97a6ba;\n    border-color: rgba(151, 166, 186, var(--border-opacity));\n  }\n  .xl\\:border-cool-gray-500 {\n    --border-opacity: 1;\n    border-color: #64748b;\n    border-color: rgba(100, 116, 139, var(--border-opacity));\n  }\n  .xl\\:border-cool-gray-600 {\n    --border-opacity: 1;\n    border-color: #475569;\n    border-color: rgba(71, 85, 105, var(--border-opacity));\n  }\n  .xl\\:border-cool-gray-700 {\n    --border-opacity: 1;\n    border-color: #364152;\n    border-color: rgba(54, 65, 82, var(--border-opacity));\n  }\n  .xl\\:border-cool-gray-800 {\n    --border-opacity: 1;\n    border-color: #27303f;\n    border-color: rgba(39, 48, 63, var(--border-opacity));\n  }\n  .xl\\:border-cool-gray-900 {\n    --border-opacity: 1;\n    border-color: #1a202e;\n    border-color: rgba(26, 32, 46, var(--border-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:border-current {\n    border-color: currentColor;\n  }\n  .group:hover .xl\\:group-hover\\:border-transparent {\n    border-color: transparent;\n  }\n  .group:hover .xl\\:group-hover\\:border-white {\n    --border-opacity: 1;\n    border-color: #ffffff;\n    border-color: rgba(255, 255, 255, var(--border-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:border-black {\n    --border-opacity: 1;\n    border-color: #000000;\n    border-color: rgba(0, 0, 0, var(--border-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:border-gray-50 {\n    --border-opacity: 1;\n    border-color: #f9fafb;\n    border-color: rgba(249, 250, 251, var(--border-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:border-gray-100 {\n    --border-opacity: 1;\n    border-color: #f4f5f7;\n    border-color: rgba(244, 245, 247, var(--border-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:border-gray-200 {\n    --border-opacity: 1;\n    border-color: #e5e7eb;\n    border-color: rgba(229, 231, 235, var(--border-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:border-gray-300 {\n    --border-opacity: 1;\n    border-color: #d2d6dc;\n    border-color: rgba(210, 214, 220, var(--border-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:border-gray-400 {\n    --border-opacity: 1;\n    border-color: #9fa6b2;\n    border-color: rgba(159, 166, 178, var(--border-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:border-gray-500 {\n    --border-opacity: 1;\n    border-color: #6b7280;\n    border-color: rgba(107, 114, 128, var(--border-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:border-gray-600 {\n    --border-opacity: 1;\n    border-color: #4b5563;\n    border-color: rgba(75, 85, 99, var(--border-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:border-gray-700 {\n    --border-opacity: 1;\n    border-color: #374151;\n    border-color: rgba(55, 65, 81, var(--border-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:border-gray-800 {\n    --border-opacity: 1;\n    border-color: #252f3f;\n    border-color: rgba(37, 47, 63, var(--border-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:border-gray-900 {\n    --border-opacity: 1;\n    border-color: #161e2e;\n    border-color: rgba(22, 30, 46, var(--border-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:border-red-50 {\n    --border-opacity: 1;\n    border-color: #fdf2f2;\n    border-color: rgba(253, 242, 242, var(--border-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:border-red-100 {\n    --border-opacity: 1;\n    border-color: #fde8e8;\n    border-color: rgba(253, 232, 232, var(--border-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:border-red-200 {\n    --border-opacity: 1;\n    border-color: #fbd5d5;\n    border-color: rgba(251, 213, 213, var(--border-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:border-red-300 {\n    --border-opacity: 1;\n    border-color: #f8b4b4;\n    border-color: rgba(248, 180, 180, var(--border-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:border-red-400 {\n    --border-opacity: 1;\n    border-color: #f98080;\n    border-color: rgba(249, 128, 128, var(--border-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:border-red-500 {\n    --border-opacity: 1;\n    border-color: #f05252;\n    border-color: rgba(240, 82, 82, var(--border-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:border-red-600 {\n    --border-opacity: 1;\n    border-color: #e02424;\n    border-color: rgba(224, 36, 36, var(--border-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:border-red-700 {\n    --border-opacity: 1;\n    border-color: #c81e1e;\n    border-color: rgba(200, 30, 30, var(--border-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:border-red-800 {\n    --border-opacity: 1;\n    border-color: #9b1c1c;\n    border-color: rgba(155, 28, 28, var(--border-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:border-red-900 {\n    --border-opacity: 1;\n    border-color: #771d1d;\n    border-color: rgba(119, 29, 29, var(--border-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:border-orange-50 {\n    --border-opacity: 1;\n    border-color: #fff8f1;\n    border-color: rgba(255, 248, 241, var(--border-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:border-orange-100 {\n    --border-opacity: 1;\n    border-color: #feecdc;\n    border-color: rgba(254, 236, 220, var(--border-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:border-orange-200 {\n    --border-opacity: 1;\n    border-color: #fcd9bd;\n    border-color: rgba(252, 217, 189, var(--border-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:border-orange-300 {\n    --border-opacity: 1;\n    border-color: #fdba8c;\n    border-color: rgba(253, 186, 140, var(--border-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:border-orange-400 {\n    --border-opacity: 1;\n    border-color: #ff8a4c;\n    border-color: rgba(255, 138, 76, var(--border-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:border-orange-500 {\n    --border-opacity: 1;\n    border-color: #ff5a1f;\n    border-color: rgba(255, 90, 31, var(--border-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:border-orange-600 {\n    --border-opacity: 1;\n    border-color: #d03801;\n    border-color: rgba(208, 56, 1, var(--border-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:border-orange-700 {\n    --border-opacity: 1;\n    border-color: #b43403;\n    border-color: rgba(180, 52, 3, var(--border-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:border-orange-800 {\n    --border-opacity: 1;\n    border-color: #8a2c0d;\n    border-color: rgba(138, 44, 13, var(--border-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:border-orange-900 {\n    --border-opacity: 1;\n    border-color: #73230d;\n    border-color: rgba(115, 35, 13, var(--border-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:border-yellow-50 {\n    --border-opacity: 1;\n    border-color: #fdfdea;\n    border-color: rgba(253, 253, 234, var(--border-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:border-yellow-100 {\n    --border-opacity: 1;\n    border-color: #fdf6b2;\n    border-color: rgba(253, 246, 178, var(--border-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:border-yellow-200 {\n    --border-opacity: 1;\n    border-color: #fce96a;\n    border-color: rgba(252, 233, 106, var(--border-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:border-yellow-300 {\n    --border-opacity: 1;\n    border-color: #faca15;\n    border-color: rgba(250, 202, 21, var(--border-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:border-yellow-400 {\n    --border-opacity: 1;\n    border-color: #e3a008;\n    border-color: rgba(227, 160, 8, var(--border-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:border-yellow-500 {\n    --border-opacity: 1;\n    border-color: #c27803;\n    border-color: rgba(194, 120, 3, var(--border-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:border-yellow-600 {\n    --border-opacity: 1;\n    border-color: #9f580a;\n    border-color: rgba(159, 88, 10, var(--border-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:border-yellow-700 {\n    --border-opacity: 1;\n    border-color: #8e4b10;\n    border-color: rgba(142, 75, 16, var(--border-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:border-yellow-800 {\n    --border-opacity: 1;\n    border-color: #723b13;\n    border-color: rgba(114, 59, 19, var(--border-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:border-yellow-900 {\n    --border-opacity: 1;\n    border-color: #633112;\n    border-color: rgba(99, 49, 18, var(--border-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:border-green-50 {\n    --border-opacity: 1;\n    border-color: #f3faf7;\n    border-color: rgba(243, 250, 247, var(--border-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:border-green-100 {\n    --border-opacity: 1;\n    border-color: #def7ec;\n    border-color: rgba(222, 247, 236, var(--border-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:border-green-200 {\n    --border-opacity: 1;\n    border-color: #bcf0da;\n    border-color: rgba(188, 240, 218, var(--border-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:border-green-300 {\n    --border-opacity: 1;\n    border-color: #84e1bc;\n    border-color: rgba(132, 225, 188, var(--border-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:border-green-400 {\n    --border-opacity: 1;\n    border-color: #31c48d;\n    border-color: rgba(49, 196, 141, var(--border-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:border-green-500 {\n    --border-opacity: 1;\n    border-color: #0e9f6e;\n    border-color: rgba(14, 159, 110, var(--border-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:border-green-600 {\n    --border-opacity: 1;\n    border-color: #057a55;\n    border-color: rgba(5, 122, 85, var(--border-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:border-green-700 {\n    --border-opacity: 1;\n    border-color: #046c4e;\n    border-color: rgba(4, 108, 78, var(--border-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:border-green-800 {\n    --border-opacity: 1;\n    border-color: #03543f;\n    border-color: rgba(3, 84, 63, var(--border-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:border-green-900 {\n    --border-opacity: 1;\n    border-color: #014737;\n    border-color: rgba(1, 71, 55, var(--border-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:border-teal-50 {\n    --border-opacity: 1;\n    border-color: #edfafa;\n    border-color: rgba(237, 250, 250, var(--border-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:border-teal-100 {\n    --border-opacity: 1;\n    border-color: #d5f5f6;\n    border-color: rgba(213, 245, 246, var(--border-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:border-teal-200 {\n    --border-opacity: 1;\n    border-color: #afecef;\n    border-color: rgba(175, 236, 239, var(--border-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:border-teal-300 {\n    --border-opacity: 1;\n    border-color: #7edce2;\n    border-color: rgba(126, 220, 226, var(--border-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:border-teal-400 {\n    --border-opacity: 1;\n    border-color: #16bdca;\n    border-color: rgba(22, 189, 202, var(--border-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:border-teal-500 {\n    --border-opacity: 1;\n    border-color: #0694a2;\n    border-color: rgba(6, 148, 162, var(--border-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:border-teal-600 {\n    --border-opacity: 1;\n    border-color: #047481;\n    border-color: rgba(4, 116, 129, var(--border-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:border-teal-700 {\n    --border-opacity: 1;\n    border-color: #036672;\n    border-color: rgba(3, 102, 114, var(--border-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:border-teal-800 {\n    --border-opacity: 1;\n    border-color: #05505c;\n    border-color: rgba(5, 80, 92, var(--border-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:border-teal-900 {\n    --border-opacity: 1;\n    border-color: #014451;\n    border-color: rgba(1, 68, 81, var(--border-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:border-blue-50 {\n    --border-opacity: 1;\n    border-color: #ebf5ff;\n    border-color: rgba(235, 245, 255, var(--border-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:border-blue-100 {\n    --border-opacity: 1;\n    border-color: #e1effe;\n    border-color: rgba(225, 239, 254, var(--border-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:border-blue-200 {\n    --border-opacity: 1;\n    border-color: #c3ddfd;\n    border-color: rgba(195, 221, 253, var(--border-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:border-blue-300 {\n    --border-opacity: 1;\n    border-color: #a4cafe;\n    border-color: rgba(164, 202, 254, var(--border-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:border-blue-400 {\n    --border-opacity: 1;\n    border-color: #76a9fa;\n    border-color: rgba(118, 169, 250, var(--border-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:border-blue-500 {\n    --border-opacity: 1;\n    border-color: #3f83f8;\n    border-color: rgba(63, 131, 248, var(--border-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:border-blue-600 {\n    --border-opacity: 1;\n    border-color: #1c64f2;\n    border-color: rgba(28, 100, 242, var(--border-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:border-blue-700 {\n    --border-opacity: 1;\n    border-color: #1a56db;\n    border-color: rgba(26, 86, 219, var(--border-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:border-blue-800 {\n    --border-opacity: 1;\n    border-color: #1e429f;\n    border-color: rgba(30, 66, 159, var(--border-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:border-blue-900 {\n    --border-opacity: 1;\n    border-color: #233876;\n    border-color: rgba(35, 56, 118, var(--border-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:border-indigo-50 {\n    --border-opacity: 1;\n    border-color: #f0f5ff;\n    border-color: rgba(240, 245, 255, var(--border-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:border-indigo-100 {\n    --border-opacity: 1;\n    border-color: #e5edff;\n    border-color: rgba(229, 237, 255, var(--border-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:border-indigo-200 {\n    --border-opacity: 1;\n    border-color: #cddbfe;\n    border-color: rgba(205, 219, 254, var(--border-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:border-indigo-300 {\n    --border-opacity: 1;\n    border-color: #b4c6fc;\n    border-color: rgba(180, 198, 252, var(--border-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:border-indigo-400 {\n    --border-opacity: 1;\n    border-color: #8da2fb;\n    border-color: rgba(141, 162, 251, var(--border-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:border-indigo-500 {\n    --border-opacity: 1;\n    border-color: #6875f5;\n    border-color: rgba(104, 117, 245, var(--border-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:border-indigo-600 {\n    --border-opacity: 1;\n    border-color: #5850ec;\n    border-color: rgba(88, 80, 236, var(--border-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:border-indigo-700 {\n    --border-opacity: 1;\n    border-color: #5145cd;\n    border-color: rgba(81, 69, 205, var(--border-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:border-indigo-800 {\n    --border-opacity: 1;\n    border-color: #42389d;\n    border-color: rgba(66, 56, 157, var(--border-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:border-indigo-900 {\n    --border-opacity: 1;\n    border-color: #362f78;\n    border-color: rgba(54, 47, 120, var(--border-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:border-purple-50 {\n    --border-opacity: 1;\n    border-color: #f6f5ff;\n    border-color: rgba(246, 245, 255, var(--border-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:border-purple-100 {\n    --border-opacity: 1;\n    border-color: #edebfe;\n    border-color: rgba(237, 235, 254, var(--border-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:border-purple-200 {\n    --border-opacity: 1;\n    border-color: #dcd7fe;\n    border-color: rgba(220, 215, 254, var(--border-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:border-purple-300 {\n    --border-opacity: 1;\n    border-color: #cabffd;\n    border-color: rgba(202, 191, 253, var(--border-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:border-purple-400 {\n    --border-opacity: 1;\n    border-color: #ac94fa;\n    border-color: rgba(172, 148, 250, var(--border-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:border-purple-500 {\n    --border-opacity: 1;\n    border-color: #9061f9;\n    border-color: rgba(144, 97, 249, var(--border-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:border-purple-600 {\n    --border-opacity: 1;\n    border-color: #7e3af2;\n    border-color: rgba(126, 58, 242, var(--border-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:border-purple-700 {\n    --border-opacity: 1;\n    border-color: #6c2bd9;\n    border-color: rgba(108, 43, 217, var(--border-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:border-purple-800 {\n    --border-opacity: 1;\n    border-color: #5521b5;\n    border-color: rgba(85, 33, 181, var(--border-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:border-purple-900 {\n    --border-opacity: 1;\n    border-color: #4a1d96;\n    border-color: rgba(74, 29, 150, var(--border-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:border-pink-50 {\n    --border-opacity: 1;\n    border-color: #fdf2f8;\n    border-color: rgba(253, 242, 248, var(--border-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:border-pink-100 {\n    --border-opacity: 1;\n    border-color: #fce8f3;\n    border-color: rgba(252, 232, 243, var(--border-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:border-pink-200 {\n    --border-opacity: 1;\n    border-color: #fad1e8;\n    border-color: rgba(250, 209, 232, var(--border-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:border-pink-300 {\n    --border-opacity: 1;\n    border-color: #f8b4d9;\n    border-color: rgba(248, 180, 217, var(--border-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:border-pink-400 {\n    --border-opacity: 1;\n    border-color: #f17eb8;\n    border-color: rgba(241, 126, 184, var(--border-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:border-pink-500 {\n    --border-opacity: 1;\n    border-color: #e74694;\n    border-color: rgba(231, 70, 148, var(--border-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:border-pink-600 {\n    --border-opacity: 1;\n    border-color: #d61f69;\n    border-color: rgba(214, 31, 105, var(--border-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:border-pink-700 {\n    --border-opacity: 1;\n    border-color: #bf125d;\n    border-color: rgba(191, 18, 93, var(--border-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:border-pink-800 {\n    --border-opacity: 1;\n    border-color: #99154b;\n    border-color: rgba(153, 21, 75, var(--border-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:border-pink-900 {\n    --border-opacity: 1;\n    border-color: #751a3d;\n    border-color: rgba(117, 26, 61, var(--border-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:border-cool-gray-50 {\n    --border-opacity: 1;\n    border-color: #f8fafc;\n    border-color: rgba(248, 250, 252, var(--border-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:border-cool-gray-100 {\n    --border-opacity: 1;\n    border-color: #f1f5f9;\n    border-color: rgba(241, 245, 249, var(--border-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:border-cool-gray-200 {\n    --border-opacity: 1;\n    border-color: #e2e8f0;\n    border-color: rgba(226, 232, 240, var(--border-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:border-cool-gray-300 {\n    --border-opacity: 1;\n    border-color: #cfd8e3;\n    border-color: rgba(207, 216, 227, var(--border-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:border-cool-gray-400 {\n    --border-opacity: 1;\n    border-color: #97a6ba;\n    border-color: rgba(151, 166, 186, var(--border-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:border-cool-gray-500 {\n    --border-opacity: 1;\n    border-color: #64748b;\n    border-color: rgba(100, 116, 139, var(--border-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:border-cool-gray-600 {\n    --border-opacity: 1;\n    border-color: #475569;\n    border-color: rgba(71, 85, 105, var(--border-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:border-cool-gray-700 {\n    --border-opacity: 1;\n    border-color: #364152;\n    border-color: rgba(54, 65, 82, var(--border-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:border-cool-gray-800 {\n    --border-opacity: 1;\n    border-color: #27303f;\n    border-color: rgba(39, 48, 63, var(--border-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:border-cool-gray-900 {\n    --border-opacity: 1;\n    border-color: #1a202e;\n    border-color: rgba(26, 32, 46, var(--border-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:border-current {\n    border-color: currentColor;\n  }\n  .group:focus .xl\\:group-focus\\:border-transparent {\n    border-color: transparent;\n  }\n  .group:focus .xl\\:group-focus\\:border-white {\n    --border-opacity: 1;\n    border-color: #ffffff;\n    border-color: rgba(255, 255, 255, var(--border-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:border-black {\n    --border-opacity: 1;\n    border-color: #000000;\n    border-color: rgba(0, 0, 0, var(--border-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:border-gray-50 {\n    --border-opacity: 1;\n    border-color: #f9fafb;\n    border-color: rgba(249, 250, 251, var(--border-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:border-gray-100 {\n    --border-opacity: 1;\n    border-color: #f4f5f7;\n    border-color: rgba(244, 245, 247, var(--border-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:border-gray-200 {\n    --border-opacity: 1;\n    border-color: #e5e7eb;\n    border-color: rgba(229, 231, 235, var(--border-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:border-gray-300 {\n    --border-opacity: 1;\n    border-color: #d2d6dc;\n    border-color: rgba(210, 214, 220, var(--border-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:border-gray-400 {\n    --border-opacity: 1;\n    border-color: #9fa6b2;\n    border-color: rgba(159, 166, 178, var(--border-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:border-gray-500 {\n    --border-opacity: 1;\n    border-color: #6b7280;\n    border-color: rgba(107, 114, 128, var(--border-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:border-gray-600 {\n    --border-opacity: 1;\n    border-color: #4b5563;\n    border-color: rgba(75, 85, 99, var(--border-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:border-gray-700 {\n    --border-opacity: 1;\n    border-color: #374151;\n    border-color: rgba(55, 65, 81, var(--border-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:border-gray-800 {\n    --border-opacity: 1;\n    border-color: #252f3f;\n    border-color: rgba(37, 47, 63, var(--border-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:border-gray-900 {\n    --border-opacity: 1;\n    border-color: #161e2e;\n    border-color: rgba(22, 30, 46, var(--border-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:border-red-50 {\n    --border-opacity: 1;\n    border-color: #fdf2f2;\n    border-color: rgba(253, 242, 242, var(--border-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:border-red-100 {\n    --border-opacity: 1;\n    border-color: #fde8e8;\n    border-color: rgba(253, 232, 232, var(--border-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:border-red-200 {\n    --border-opacity: 1;\n    border-color: #fbd5d5;\n    border-color: rgba(251, 213, 213, var(--border-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:border-red-300 {\n    --border-opacity: 1;\n    border-color: #f8b4b4;\n    border-color: rgba(248, 180, 180, var(--border-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:border-red-400 {\n    --border-opacity: 1;\n    border-color: #f98080;\n    border-color: rgba(249, 128, 128, var(--border-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:border-red-500 {\n    --border-opacity: 1;\n    border-color: #f05252;\n    border-color: rgba(240, 82, 82, var(--border-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:border-red-600 {\n    --border-opacity: 1;\n    border-color: #e02424;\n    border-color: rgba(224, 36, 36, var(--border-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:border-red-700 {\n    --border-opacity: 1;\n    border-color: #c81e1e;\n    border-color: rgba(200, 30, 30, var(--border-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:border-red-800 {\n    --border-opacity: 1;\n    border-color: #9b1c1c;\n    border-color: rgba(155, 28, 28, var(--border-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:border-red-900 {\n    --border-opacity: 1;\n    border-color: #771d1d;\n    border-color: rgba(119, 29, 29, var(--border-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:border-orange-50 {\n    --border-opacity: 1;\n    border-color: #fff8f1;\n    border-color: rgba(255, 248, 241, var(--border-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:border-orange-100 {\n    --border-opacity: 1;\n    border-color: #feecdc;\n    border-color: rgba(254, 236, 220, var(--border-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:border-orange-200 {\n    --border-opacity: 1;\n    border-color: #fcd9bd;\n    border-color: rgba(252, 217, 189, var(--border-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:border-orange-300 {\n    --border-opacity: 1;\n    border-color: #fdba8c;\n    border-color: rgba(253, 186, 140, var(--border-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:border-orange-400 {\n    --border-opacity: 1;\n    border-color: #ff8a4c;\n    border-color: rgba(255, 138, 76, var(--border-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:border-orange-500 {\n    --border-opacity: 1;\n    border-color: #ff5a1f;\n    border-color: rgba(255, 90, 31, var(--border-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:border-orange-600 {\n    --border-opacity: 1;\n    border-color: #d03801;\n    border-color: rgba(208, 56, 1, var(--border-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:border-orange-700 {\n    --border-opacity: 1;\n    border-color: #b43403;\n    border-color: rgba(180, 52, 3, var(--border-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:border-orange-800 {\n    --border-opacity: 1;\n    border-color: #8a2c0d;\n    border-color: rgba(138, 44, 13, var(--border-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:border-orange-900 {\n    --border-opacity: 1;\n    border-color: #73230d;\n    border-color: rgba(115, 35, 13, var(--border-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:border-yellow-50 {\n    --border-opacity: 1;\n    border-color: #fdfdea;\n    border-color: rgba(253, 253, 234, var(--border-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:border-yellow-100 {\n    --border-opacity: 1;\n    border-color: #fdf6b2;\n    border-color: rgba(253, 246, 178, var(--border-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:border-yellow-200 {\n    --border-opacity: 1;\n    border-color: #fce96a;\n    border-color: rgba(252, 233, 106, var(--border-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:border-yellow-300 {\n    --border-opacity: 1;\n    border-color: #faca15;\n    border-color: rgba(250, 202, 21, var(--border-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:border-yellow-400 {\n    --border-opacity: 1;\n    border-color: #e3a008;\n    border-color: rgba(227, 160, 8, var(--border-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:border-yellow-500 {\n    --border-opacity: 1;\n    border-color: #c27803;\n    border-color: rgba(194, 120, 3, var(--border-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:border-yellow-600 {\n    --border-opacity: 1;\n    border-color: #9f580a;\n    border-color: rgba(159, 88, 10, var(--border-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:border-yellow-700 {\n    --border-opacity: 1;\n    border-color: #8e4b10;\n    border-color: rgba(142, 75, 16, var(--border-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:border-yellow-800 {\n    --border-opacity: 1;\n    border-color: #723b13;\n    border-color: rgba(114, 59, 19, var(--border-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:border-yellow-900 {\n    --border-opacity: 1;\n    border-color: #633112;\n    border-color: rgba(99, 49, 18, var(--border-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:border-green-50 {\n    --border-opacity: 1;\n    border-color: #f3faf7;\n    border-color: rgba(243, 250, 247, var(--border-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:border-green-100 {\n    --border-opacity: 1;\n    border-color: #def7ec;\n    border-color: rgba(222, 247, 236, var(--border-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:border-green-200 {\n    --border-opacity: 1;\n    border-color: #bcf0da;\n    border-color: rgba(188, 240, 218, var(--border-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:border-green-300 {\n    --border-opacity: 1;\n    border-color: #84e1bc;\n    border-color: rgba(132, 225, 188, var(--border-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:border-green-400 {\n    --border-opacity: 1;\n    border-color: #31c48d;\n    border-color: rgba(49, 196, 141, var(--border-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:border-green-500 {\n    --border-opacity: 1;\n    border-color: #0e9f6e;\n    border-color: rgba(14, 159, 110, var(--border-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:border-green-600 {\n    --border-opacity: 1;\n    border-color: #057a55;\n    border-color: rgba(5, 122, 85, var(--border-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:border-green-700 {\n    --border-opacity: 1;\n    border-color: #046c4e;\n    border-color: rgba(4, 108, 78, var(--border-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:border-green-800 {\n    --border-opacity: 1;\n    border-color: #03543f;\n    border-color: rgba(3, 84, 63, var(--border-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:border-green-900 {\n    --border-opacity: 1;\n    border-color: #014737;\n    border-color: rgba(1, 71, 55, var(--border-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:border-teal-50 {\n    --border-opacity: 1;\n    border-color: #edfafa;\n    border-color: rgba(237, 250, 250, var(--border-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:border-teal-100 {\n    --border-opacity: 1;\n    border-color: #d5f5f6;\n    border-color: rgba(213, 245, 246, var(--border-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:border-teal-200 {\n    --border-opacity: 1;\n    border-color: #afecef;\n    border-color: rgba(175, 236, 239, var(--border-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:border-teal-300 {\n    --border-opacity: 1;\n    border-color: #7edce2;\n    border-color: rgba(126, 220, 226, var(--border-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:border-teal-400 {\n    --border-opacity: 1;\n    border-color: #16bdca;\n    border-color: rgba(22, 189, 202, var(--border-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:border-teal-500 {\n    --border-opacity: 1;\n    border-color: #0694a2;\n    border-color: rgba(6, 148, 162, var(--border-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:border-teal-600 {\n    --border-opacity: 1;\n    border-color: #047481;\n    border-color: rgba(4, 116, 129, var(--border-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:border-teal-700 {\n    --border-opacity: 1;\n    border-color: #036672;\n    border-color: rgba(3, 102, 114, var(--border-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:border-teal-800 {\n    --border-opacity: 1;\n    border-color: #05505c;\n    border-color: rgba(5, 80, 92, var(--border-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:border-teal-900 {\n    --border-opacity: 1;\n    border-color: #014451;\n    border-color: rgba(1, 68, 81, var(--border-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:border-blue-50 {\n    --border-opacity: 1;\n    border-color: #ebf5ff;\n    border-color: rgba(235, 245, 255, var(--border-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:border-blue-100 {\n    --border-opacity: 1;\n    border-color: #e1effe;\n    border-color: rgba(225, 239, 254, var(--border-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:border-blue-200 {\n    --border-opacity: 1;\n    border-color: #c3ddfd;\n    border-color: rgba(195, 221, 253, var(--border-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:border-blue-300 {\n    --border-opacity: 1;\n    border-color: #a4cafe;\n    border-color: rgba(164, 202, 254, var(--border-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:border-blue-400 {\n    --border-opacity: 1;\n    border-color: #76a9fa;\n    border-color: rgba(118, 169, 250, var(--border-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:border-blue-500 {\n    --border-opacity: 1;\n    border-color: #3f83f8;\n    border-color: rgba(63, 131, 248, var(--border-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:border-blue-600 {\n    --border-opacity: 1;\n    border-color: #1c64f2;\n    border-color: rgba(28, 100, 242, var(--border-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:border-blue-700 {\n    --border-opacity: 1;\n    border-color: #1a56db;\n    border-color: rgba(26, 86, 219, var(--border-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:border-blue-800 {\n    --border-opacity: 1;\n    border-color: #1e429f;\n    border-color: rgba(30, 66, 159, var(--border-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:border-blue-900 {\n    --border-opacity: 1;\n    border-color: #233876;\n    border-color: rgba(35, 56, 118, var(--border-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:border-indigo-50 {\n    --border-opacity: 1;\n    border-color: #f0f5ff;\n    border-color: rgba(240, 245, 255, var(--border-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:border-indigo-100 {\n    --border-opacity: 1;\n    border-color: #e5edff;\n    border-color: rgba(229, 237, 255, var(--border-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:border-indigo-200 {\n    --border-opacity: 1;\n    border-color: #cddbfe;\n    border-color: rgba(205, 219, 254, var(--border-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:border-indigo-300 {\n    --border-opacity: 1;\n    border-color: #b4c6fc;\n    border-color: rgba(180, 198, 252, var(--border-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:border-indigo-400 {\n    --border-opacity: 1;\n    border-color: #8da2fb;\n    border-color: rgba(141, 162, 251, var(--border-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:border-indigo-500 {\n    --border-opacity: 1;\n    border-color: #6875f5;\n    border-color: rgba(104, 117, 245, var(--border-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:border-indigo-600 {\n    --border-opacity: 1;\n    border-color: #5850ec;\n    border-color: rgba(88, 80, 236, var(--border-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:border-indigo-700 {\n    --border-opacity: 1;\n    border-color: #5145cd;\n    border-color: rgba(81, 69, 205, var(--border-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:border-indigo-800 {\n    --border-opacity: 1;\n    border-color: #42389d;\n    border-color: rgba(66, 56, 157, var(--border-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:border-indigo-900 {\n    --border-opacity: 1;\n    border-color: #362f78;\n    border-color: rgba(54, 47, 120, var(--border-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:border-purple-50 {\n    --border-opacity: 1;\n    border-color: #f6f5ff;\n    border-color: rgba(246, 245, 255, var(--border-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:border-purple-100 {\n    --border-opacity: 1;\n    border-color: #edebfe;\n    border-color: rgba(237, 235, 254, var(--border-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:border-purple-200 {\n    --border-opacity: 1;\n    border-color: #dcd7fe;\n    border-color: rgba(220, 215, 254, var(--border-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:border-purple-300 {\n    --border-opacity: 1;\n    border-color: #cabffd;\n    border-color: rgba(202, 191, 253, var(--border-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:border-purple-400 {\n    --border-opacity: 1;\n    border-color: #ac94fa;\n    border-color: rgba(172, 148, 250, var(--border-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:border-purple-500 {\n    --border-opacity: 1;\n    border-color: #9061f9;\n    border-color: rgba(144, 97, 249, var(--border-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:border-purple-600 {\n    --border-opacity: 1;\n    border-color: #7e3af2;\n    border-color: rgba(126, 58, 242, var(--border-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:border-purple-700 {\n    --border-opacity: 1;\n    border-color: #6c2bd9;\n    border-color: rgba(108, 43, 217, var(--border-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:border-purple-800 {\n    --border-opacity: 1;\n    border-color: #5521b5;\n    border-color: rgba(85, 33, 181, var(--border-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:border-purple-900 {\n    --border-opacity: 1;\n    border-color: #4a1d96;\n    border-color: rgba(74, 29, 150, var(--border-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:border-pink-50 {\n    --border-opacity: 1;\n    border-color: #fdf2f8;\n    border-color: rgba(253, 242, 248, var(--border-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:border-pink-100 {\n    --border-opacity: 1;\n    border-color: #fce8f3;\n    border-color: rgba(252, 232, 243, var(--border-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:border-pink-200 {\n    --border-opacity: 1;\n    border-color: #fad1e8;\n    border-color: rgba(250, 209, 232, var(--border-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:border-pink-300 {\n    --border-opacity: 1;\n    border-color: #f8b4d9;\n    border-color: rgba(248, 180, 217, var(--border-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:border-pink-400 {\n    --border-opacity: 1;\n    border-color: #f17eb8;\n    border-color: rgba(241, 126, 184, var(--border-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:border-pink-500 {\n    --border-opacity: 1;\n    border-color: #e74694;\n    border-color: rgba(231, 70, 148, var(--border-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:border-pink-600 {\n    --border-opacity: 1;\n    border-color: #d61f69;\n    border-color: rgba(214, 31, 105, var(--border-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:border-pink-700 {\n    --border-opacity: 1;\n    border-color: #bf125d;\n    border-color: rgba(191, 18, 93, var(--border-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:border-pink-800 {\n    --border-opacity: 1;\n    border-color: #99154b;\n    border-color: rgba(153, 21, 75, var(--border-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:border-pink-900 {\n    --border-opacity: 1;\n    border-color: #751a3d;\n    border-color: rgba(117, 26, 61, var(--border-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:border-cool-gray-50 {\n    --border-opacity: 1;\n    border-color: #f8fafc;\n    border-color: rgba(248, 250, 252, var(--border-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:border-cool-gray-100 {\n    --border-opacity: 1;\n    border-color: #f1f5f9;\n    border-color: rgba(241, 245, 249, var(--border-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:border-cool-gray-200 {\n    --border-opacity: 1;\n    border-color: #e2e8f0;\n    border-color: rgba(226, 232, 240, var(--border-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:border-cool-gray-300 {\n    --border-opacity: 1;\n    border-color: #cfd8e3;\n    border-color: rgba(207, 216, 227, var(--border-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:border-cool-gray-400 {\n    --border-opacity: 1;\n    border-color: #97a6ba;\n    border-color: rgba(151, 166, 186, var(--border-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:border-cool-gray-500 {\n    --border-opacity: 1;\n    border-color: #64748b;\n    border-color: rgba(100, 116, 139, var(--border-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:border-cool-gray-600 {\n    --border-opacity: 1;\n    border-color: #475569;\n    border-color: rgba(71, 85, 105, var(--border-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:border-cool-gray-700 {\n    --border-opacity: 1;\n    border-color: #364152;\n    border-color: rgba(54, 65, 82, var(--border-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:border-cool-gray-800 {\n    --border-opacity: 1;\n    border-color: #27303f;\n    border-color: rgba(39, 48, 63, var(--border-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:border-cool-gray-900 {\n    --border-opacity: 1;\n    border-color: #1a202e;\n    border-color: rgba(26, 32, 46, var(--border-opacity));\n  }\n  .xl\\:hover\\:border-current:hover {\n    border-color: currentColor;\n  }\n  .xl\\:hover\\:border-transparent:hover {\n    border-color: transparent;\n  }\n  .xl\\:hover\\:border-white:hover {\n    --border-opacity: 1;\n    border-color: #ffffff;\n    border-color: rgba(255, 255, 255, var(--border-opacity));\n  }\n  .xl\\:hover\\:border-black:hover {\n    --border-opacity: 1;\n    border-color: #000000;\n    border-color: rgba(0, 0, 0, var(--border-opacity));\n  }\n  .xl\\:hover\\:border-gray-50:hover {\n    --border-opacity: 1;\n    border-color: #f9fafb;\n    border-color: rgba(249, 250, 251, var(--border-opacity));\n  }\n  .xl\\:hover\\:border-gray-100:hover {\n    --border-opacity: 1;\n    border-color: #f4f5f7;\n    border-color: rgba(244, 245, 247, var(--border-opacity));\n  }\n  .xl\\:hover\\:border-gray-200:hover {\n    --border-opacity: 1;\n    border-color: #e5e7eb;\n    border-color: rgba(229, 231, 235, var(--border-opacity));\n  }\n  .xl\\:hover\\:border-gray-300:hover {\n    --border-opacity: 1;\n    border-color: #d2d6dc;\n    border-color: rgba(210, 214, 220, var(--border-opacity));\n  }\n  .xl\\:hover\\:border-gray-400:hover {\n    --border-opacity: 1;\n    border-color: #9fa6b2;\n    border-color: rgba(159, 166, 178, var(--border-opacity));\n  }\n  .xl\\:hover\\:border-gray-500:hover {\n    --border-opacity: 1;\n    border-color: #6b7280;\n    border-color: rgba(107, 114, 128, var(--border-opacity));\n  }\n  .xl\\:hover\\:border-gray-600:hover {\n    --border-opacity: 1;\n    border-color: #4b5563;\n    border-color: rgba(75, 85, 99, var(--border-opacity));\n  }\n  .xl\\:hover\\:border-gray-700:hover {\n    --border-opacity: 1;\n    border-color: #374151;\n    border-color: rgba(55, 65, 81, var(--border-opacity));\n  }\n  .xl\\:hover\\:border-gray-800:hover {\n    --border-opacity: 1;\n    border-color: #252f3f;\n    border-color: rgba(37, 47, 63, var(--border-opacity));\n  }\n  .xl\\:hover\\:border-gray-900:hover {\n    --border-opacity: 1;\n    border-color: #161e2e;\n    border-color: rgba(22, 30, 46, var(--border-opacity));\n  }\n  .xl\\:hover\\:border-red-50:hover {\n    --border-opacity: 1;\n    border-color: #fdf2f2;\n    border-color: rgba(253, 242, 242, var(--border-opacity));\n  }\n  .xl\\:hover\\:border-red-100:hover {\n    --border-opacity: 1;\n    border-color: #fde8e8;\n    border-color: rgba(253, 232, 232, var(--border-opacity));\n  }\n  .xl\\:hover\\:border-red-200:hover {\n    --border-opacity: 1;\n    border-color: #fbd5d5;\n    border-color: rgba(251, 213, 213, var(--border-opacity));\n  }\n  .xl\\:hover\\:border-red-300:hover {\n    --border-opacity: 1;\n    border-color: #f8b4b4;\n    border-color: rgba(248, 180, 180, var(--border-opacity));\n  }\n  .xl\\:hover\\:border-red-400:hover {\n    --border-opacity: 1;\n    border-color: #f98080;\n    border-color: rgba(249, 128, 128, var(--border-opacity));\n  }\n  .xl\\:hover\\:border-red-500:hover {\n    --border-opacity: 1;\n    border-color: #f05252;\n    border-color: rgba(240, 82, 82, var(--border-opacity));\n  }\n  .xl\\:hover\\:border-red-600:hover {\n    --border-opacity: 1;\n    border-color: #e02424;\n    border-color: rgba(224, 36, 36, var(--border-opacity));\n  }\n  .xl\\:hover\\:border-red-700:hover {\n    --border-opacity: 1;\n    border-color: #c81e1e;\n    border-color: rgba(200, 30, 30, var(--border-opacity));\n  }\n  .xl\\:hover\\:border-red-800:hover {\n    --border-opacity: 1;\n    border-color: #9b1c1c;\n    border-color: rgba(155, 28, 28, var(--border-opacity));\n  }\n  .xl\\:hover\\:border-red-900:hover {\n    --border-opacity: 1;\n    border-color: #771d1d;\n    border-color: rgba(119, 29, 29, var(--border-opacity));\n  }\n  .xl\\:hover\\:border-orange-50:hover {\n    --border-opacity: 1;\n    border-color: #fff8f1;\n    border-color: rgba(255, 248, 241, var(--border-opacity));\n  }\n  .xl\\:hover\\:border-orange-100:hover {\n    --border-opacity: 1;\n    border-color: #feecdc;\n    border-color: rgba(254, 236, 220, var(--border-opacity));\n  }\n  .xl\\:hover\\:border-orange-200:hover {\n    --border-opacity: 1;\n    border-color: #fcd9bd;\n    border-color: rgba(252, 217, 189, var(--border-opacity));\n  }\n  .xl\\:hover\\:border-orange-300:hover {\n    --border-opacity: 1;\n    border-color: #fdba8c;\n    border-color: rgba(253, 186, 140, var(--border-opacity));\n  }\n  .xl\\:hover\\:border-orange-400:hover {\n    --border-opacity: 1;\n    border-color: #ff8a4c;\n    border-color: rgba(255, 138, 76, var(--border-opacity));\n  }\n  .xl\\:hover\\:border-orange-500:hover {\n    --border-opacity: 1;\n    border-color: #ff5a1f;\n    border-color: rgba(255, 90, 31, var(--border-opacity));\n  }\n  .xl\\:hover\\:border-orange-600:hover {\n    --border-opacity: 1;\n    border-color: #d03801;\n    border-color: rgba(208, 56, 1, var(--border-opacity));\n  }\n  .xl\\:hover\\:border-orange-700:hover {\n    --border-opacity: 1;\n    border-color: #b43403;\n    border-color: rgba(180, 52, 3, var(--border-opacity));\n  }\n  .xl\\:hover\\:border-orange-800:hover {\n    --border-opacity: 1;\n    border-color: #8a2c0d;\n    border-color: rgba(138, 44, 13, var(--border-opacity));\n  }\n  .xl\\:hover\\:border-orange-900:hover {\n    --border-opacity: 1;\n    border-color: #73230d;\n    border-color: rgba(115, 35, 13, var(--border-opacity));\n  }\n  .xl\\:hover\\:border-yellow-50:hover {\n    --border-opacity: 1;\n    border-color: #fdfdea;\n    border-color: rgba(253, 253, 234, var(--border-opacity));\n  }\n  .xl\\:hover\\:border-yellow-100:hover {\n    --border-opacity: 1;\n    border-color: #fdf6b2;\n    border-color: rgba(253, 246, 178, var(--border-opacity));\n  }\n  .xl\\:hover\\:border-yellow-200:hover {\n    --border-opacity: 1;\n    border-color: #fce96a;\n    border-color: rgba(252, 233, 106, var(--border-opacity));\n  }\n  .xl\\:hover\\:border-yellow-300:hover {\n    --border-opacity: 1;\n    border-color: #faca15;\n    border-color: rgba(250, 202, 21, var(--border-opacity));\n  }\n  .xl\\:hover\\:border-yellow-400:hover {\n    --border-opacity: 1;\n    border-color: #e3a008;\n    border-color: rgba(227, 160, 8, var(--border-opacity));\n  }\n  .xl\\:hover\\:border-yellow-500:hover {\n    --border-opacity: 1;\n    border-color: #c27803;\n    border-color: rgba(194, 120, 3, var(--border-opacity));\n  }\n  .xl\\:hover\\:border-yellow-600:hover {\n    --border-opacity: 1;\n    border-color: #9f580a;\n    border-color: rgba(159, 88, 10, var(--border-opacity));\n  }\n  .xl\\:hover\\:border-yellow-700:hover {\n    --border-opacity: 1;\n    border-color: #8e4b10;\n    border-color: rgba(142, 75, 16, var(--border-opacity));\n  }\n  .xl\\:hover\\:border-yellow-800:hover {\n    --border-opacity: 1;\n    border-color: #723b13;\n    border-color: rgba(114, 59, 19, var(--border-opacity));\n  }\n  .xl\\:hover\\:border-yellow-900:hover {\n    --border-opacity: 1;\n    border-color: #633112;\n    border-color: rgba(99, 49, 18, var(--border-opacity));\n  }\n  .xl\\:hover\\:border-green-50:hover {\n    --border-opacity: 1;\n    border-color: #f3faf7;\n    border-color: rgba(243, 250, 247, var(--border-opacity));\n  }\n  .xl\\:hover\\:border-green-100:hover {\n    --border-opacity: 1;\n    border-color: #def7ec;\n    border-color: rgba(222, 247, 236, var(--border-opacity));\n  }\n  .xl\\:hover\\:border-green-200:hover {\n    --border-opacity: 1;\n    border-color: #bcf0da;\n    border-color: rgba(188, 240, 218, var(--border-opacity));\n  }\n  .xl\\:hover\\:border-green-300:hover {\n    --border-opacity: 1;\n    border-color: #84e1bc;\n    border-color: rgba(132, 225, 188, var(--border-opacity));\n  }\n  .xl\\:hover\\:border-green-400:hover {\n    --border-opacity: 1;\n    border-color: #31c48d;\n    border-color: rgba(49, 196, 141, var(--border-opacity));\n  }\n  .xl\\:hover\\:border-green-500:hover {\n    --border-opacity: 1;\n    border-color: #0e9f6e;\n    border-color: rgba(14, 159, 110, var(--border-opacity));\n  }\n  .xl\\:hover\\:border-green-600:hover {\n    --border-opacity: 1;\n    border-color: #057a55;\n    border-color: rgba(5, 122, 85, var(--border-opacity));\n  }\n  .xl\\:hover\\:border-green-700:hover {\n    --border-opacity: 1;\n    border-color: #046c4e;\n    border-color: rgba(4, 108, 78, var(--border-opacity));\n  }\n  .xl\\:hover\\:border-green-800:hover {\n    --border-opacity: 1;\n    border-color: #03543f;\n    border-color: rgba(3, 84, 63, var(--border-opacity));\n  }\n  .xl\\:hover\\:border-green-900:hover {\n    --border-opacity: 1;\n    border-color: #014737;\n    border-color: rgba(1, 71, 55, var(--border-opacity));\n  }\n  .xl\\:hover\\:border-teal-50:hover {\n    --border-opacity: 1;\n    border-color: #edfafa;\n    border-color: rgba(237, 250, 250, var(--border-opacity));\n  }\n  .xl\\:hover\\:border-teal-100:hover {\n    --border-opacity: 1;\n    border-color: #d5f5f6;\n    border-color: rgba(213, 245, 246, var(--border-opacity));\n  }\n  .xl\\:hover\\:border-teal-200:hover {\n    --border-opacity: 1;\n    border-color: #afecef;\n    border-color: rgba(175, 236, 239, var(--border-opacity));\n  }\n  .xl\\:hover\\:border-teal-300:hover {\n    --border-opacity: 1;\n    border-color: #7edce2;\n    border-color: rgba(126, 220, 226, var(--border-opacity));\n  }\n  .xl\\:hover\\:border-teal-400:hover {\n    --border-opacity: 1;\n    border-color: #16bdca;\n    border-color: rgba(22, 189, 202, var(--border-opacity));\n  }\n  .xl\\:hover\\:border-teal-500:hover {\n    --border-opacity: 1;\n    border-color: #0694a2;\n    border-color: rgba(6, 148, 162, var(--border-opacity));\n  }\n  .xl\\:hover\\:border-teal-600:hover {\n    --border-opacity: 1;\n    border-color: #047481;\n    border-color: rgba(4, 116, 129, var(--border-opacity));\n  }\n  .xl\\:hover\\:border-teal-700:hover {\n    --border-opacity: 1;\n    border-color: #036672;\n    border-color: rgba(3, 102, 114, var(--border-opacity));\n  }\n  .xl\\:hover\\:border-teal-800:hover {\n    --border-opacity: 1;\n    border-color: #05505c;\n    border-color: rgba(5, 80, 92, var(--border-opacity));\n  }\n  .xl\\:hover\\:border-teal-900:hover {\n    --border-opacity: 1;\n    border-color: #014451;\n    border-color: rgba(1, 68, 81, var(--border-opacity));\n  }\n  .xl\\:hover\\:border-blue-50:hover {\n    --border-opacity: 1;\n    border-color: #ebf5ff;\n    border-color: rgba(235, 245, 255, var(--border-opacity));\n  }\n  .xl\\:hover\\:border-blue-100:hover {\n    --border-opacity: 1;\n    border-color: #e1effe;\n    border-color: rgba(225, 239, 254, var(--border-opacity));\n  }\n  .xl\\:hover\\:border-blue-200:hover {\n    --border-opacity: 1;\n    border-color: #c3ddfd;\n    border-color: rgba(195, 221, 253, var(--border-opacity));\n  }\n  .xl\\:hover\\:border-blue-300:hover {\n    --border-opacity: 1;\n    border-color: #a4cafe;\n    border-color: rgba(164, 202, 254, var(--border-opacity));\n  }\n  .xl\\:hover\\:border-blue-400:hover {\n    --border-opacity: 1;\n    border-color: #76a9fa;\n    border-color: rgba(118, 169, 250, var(--border-opacity));\n  }\n  .xl\\:hover\\:border-blue-500:hover {\n    --border-opacity: 1;\n    border-color: #3f83f8;\n    border-color: rgba(63, 131, 248, var(--border-opacity));\n  }\n  .xl\\:hover\\:border-blue-600:hover {\n    --border-opacity: 1;\n    border-color: #1c64f2;\n    border-color: rgba(28, 100, 242, var(--border-opacity));\n  }\n  .xl\\:hover\\:border-blue-700:hover {\n    --border-opacity: 1;\n    border-color: #1a56db;\n    border-color: rgba(26, 86, 219, var(--border-opacity));\n  }\n  .xl\\:hover\\:border-blue-800:hover {\n    --border-opacity: 1;\n    border-color: #1e429f;\n    border-color: rgba(30, 66, 159, var(--border-opacity));\n  }\n  .xl\\:hover\\:border-blue-900:hover {\n    --border-opacity: 1;\n    border-color: #233876;\n    border-color: rgba(35, 56, 118, var(--border-opacity));\n  }\n  .xl\\:hover\\:border-indigo-50:hover {\n    --border-opacity: 1;\n    border-color: #f0f5ff;\n    border-color: rgba(240, 245, 255, var(--border-opacity));\n  }\n  .xl\\:hover\\:border-indigo-100:hover {\n    --border-opacity: 1;\n    border-color: #e5edff;\n    border-color: rgba(229, 237, 255, var(--border-opacity));\n  }\n  .xl\\:hover\\:border-indigo-200:hover {\n    --border-opacity: 1;\n    border-color: #cddbfe;\n    border-color: rgba(205, 219, 254, var(--border-opacity));\n  }\n  .xl\\:hover\\:border-indigo-300:hover {\n    --border-opacity: 1;\n    border-color: #b4c6fc;\n    border-color: rgba(180, 198, 252, var(--border-opacity));\n  }\n  .xl\\:hover\\:border-indigo-400:hover {\n    --border-opacity: 1;\n    border-color: #8da2fb;\n    border-color: rgba(141, 162, 251, var(--border-opacity));\n  }\n  .xl\\:hover\\:border-indigo-500:hover {\n    --border-opacity: 1;\n    border-color: #6875f5;\n    border-color: rgba(104, 117, 245, var(--border-opacity));\n  }\n  .xl\\:hover\\:border-indigo-600:hover {\n    --border-opacity: 1;\n    border-color: #5850ec;\n    border-color: rgba(88, 80, 236, var(--border-opacity));\n  }\n  .xl\\:hover\\:border-indigo-700:hover {\n    --border-opacity: 1;\n    border-color: #5145cd;\n    border-color: rgba(81, 69, 205, var(--border-opacity));\n  }\n  .xl\\:hover\\:border-indigo-800:hover {\n    --border-opacity: 1;\n    border-color: #42389d;\n    border-color: rgba(66, 56, 157, var(--border-opacity));\n  }\n  .xl\\:hover\\:border-indigo-900:hover {\n    --border-opacity: 1;\n    border-color: #362f78;\n    border-color: rgba(54, 47, 120, var(--border-opacity));\n  }\n  .xl\\:hover\\:border-purple-50:hover {\n    --border-opacity: 1;\n    border-color: #f6f5ff;\n    border-color: rgba(246, 245, 255, var(--border-opacity));\n  }\n  .xl\\:hover\\:border-purple-100:hover {\n    --border-opacity: 1;\n    border-color: #edebfe;\n    border-color: rgba(237, 235, 254, var(--border-opacity));\n  }\n  .xl\\:hover\\:border-purple-200:hover {\n    --border-opacity: 1;\n    border-color: #dcd7fe;\n    border-color: rgba(220, 215, 254, var(--border-opacity));\n  }\n  .xl\\:hover\\:border-purple-300:hover {\n    --border-opacity: 1;\n    border-color: #cabffd;\n    border-color: rgba(202, 191, 253, var(--border-opacity));\n  }\n  .xl\\:hover\\:border-purple-400:hover {\n    --border-opacity: 1;\n    border-color: #ac94fa;\n    border-color: rgba(172, 148, 250, var(--border-opacity));\n  }\n  .xl\\:hover\\:border-purple-500:hover {\n    --border-opacity: 1;\n    border-color: #9061f9;\n    border-color: rgba(144, 97, 249, var(--border-opacity));\n  }\n  .xl\\:hover\\:border-purple-600:hover {\n    --border-opacity: 1;\n    border-color: #7e3af2;\n    border-color: rgba(126, 58, 242, var(--border-opacity));\n  }\n  .xl\\:hover\\:border-purple-700:hover {\n    --border-opacity: 1;\n    border-color: #6c2bd9;\n    border-color: rgba(108, 43, 217, var(--border-opacity));\n  }\n  .xl\\:hover\\:border-purple-800:hover {\n    --border-opacity: 1;\n    border-color: #5521b5;\n    border-color: rgba(85, 33, 181, var(--border-opacity));\n  }\n  .xl\\:hover\\:border-purple-900:hover {\n    --border-opacity: 1;\n    border-color: #4a1d96;\n    border-color: rgba(74, 29, 150, var(--border-opacity));\n  }\n  .xl\\:hover\\:border-pink-50:hover {\n    --border-opacity: 1;\n    border-color: #fdf2f8;\n    border-color: rgba(253, 242, 248, var(--border-opacity));\n  }\n  .xl\\:hover\\:border-pink-100:hover {\n    --border-opacity: 1;\n    border-color: #fce8f3;\n    border-color: rgba(252, 232, 243, var(--border-opacity));\n  }\n  .xl\\:hover\\:border-pink-200:hover {\n    --border-opacity: 1;\n    border-color: #fad1e8;\n    border-color: rgba(250, 209, 232, var(--border-opacity));\n  }\n  .xl\\:hover\\:border-pink-300:hover {\n    --border-opacity: 1;\n    border-color: #f8b4d9;\n    border-color: rgba(248, 180, 217, var(--border-opacity));\n  }\n  .xl\\:hover\\:border-pink-400:hover {\n    --border-opacity: 1;\n    border-color: #f17eb8;\n    border-color: rgba(241, 126, 184, var(--border-opacity));\n  }\n  .xl\\:hover\\:border-pink-500:hover {\n    --border-opacity: 1;\n    border-color: #e74694;\n    border-color: rgba(231, 70, 148, var(--border-opacity));\n  }\n  .xl\\:hover\\:border-pink-600:hover {\n    --border-opacity: 1;\n    border-color: #d61f69;\n    border-color: rgba(214, 31, 105, var(--border-opacity));\n  }\n  .xl\\:hover\\:border-pink-700:hover {\n    --border-opacity: 1;\n    border-color: #bf125d;\n    border-color: rgba(191, 18, 93, var(--border-opacity));\n  }\n  .xl\\:hover\\:border-pink-800:hover {\n    --border-opacity: 1;\n    border-color: #99154b;\n    border-color: rgba(153, 21, 75, var(--border-opacity));\n  }\n  .xl\\:hover\\:border-pink-900:hover {\n    --border-opacity: 1;\n    border-color: #751a3d;\n    border-color: rgba(117, 26, 61, var(--border-opacity));\n  }\n  .xl\\:hover\\:border-cool-gray-50:hover {\n    --border-opacity: 1;\n    border-color: #f8fafc;\n    border-color: rgba(248, 250, 252, var(--border-opacity));\n  }\n  .xl\\:hover\\:border-cool-gray-100:hover {\n    --border-opacity: 1;\n    border-color: #f1f5f9;\n    border-color: rgba(241, 245, 249, var(--border-opacity));\n  }\n  .xl\\:hover\\:border-cool-gray-200:hover {\n    --border-opacity: 1;\n    border-color: #e2e8f0;\n    border-color: rgba(226, 232, 240, var(--border-opacity));\n  }\n  .xl\\:hover\\:border-cool-gray-300:hover {\n    --border-opacity: 1;\n    border-color: #cfd8e3;\n    border-color: rgba(207, 216, 227, var(--border-opacity));\n  }\n  .xl\\:hover\\:border-cool-gray-400:hover {\n    --border-opacity: 1;\n    border-color: #97a6ba;\n    border-color: rgba(151, 166, 186, var(--border-opacity));\n  }\n  .xl\\:hover\\:border-cool-gray-500:hover {\n    --border-opacity: 1;\n    border-color: #64748b;\n    border-color: rgba(100, 116, 139, var(--border-opacity));\n  }\n  .xl\\:hover\\:border-cool-gray-600:hover {\n    --border-opacity: 1;\n    border-color: #475569;\n    border-color: rgba(71, 85, 105, var(--border-opacity));\n  }\n  .xl\\:hover\\:border-cool-gray-700:hover {\n    --border-opacity: 1;\n    border-color: #364152;\n    border-color: rgba(54, 65, 82, var(--border-opacity));\n  }\n  .xl\\:hover\\:border-cool-gray-800:hover {\n    --border-opacity: 1;\n    border-color: #27303f;\n    border-color: rgba(39, 48, 63, var(--border-opacity));\n  }\n  .xl\\:hover\\:border-cool-gray-900:hover {\n    --border-opacity: 1;\n    border-color: #1a202e;\n    border-color: rgba(26, 32, 46, var(--border-opacity));\n  }\n  .xl\\:focus-within\\:border-current:focus-within {\n    border-color: currentColor;\n  }\n  .xl\\:focus-within\\:border-transparent:focus-within {\n    border-color: transparent;\n  }\n  .xl\\:focus-within\\:border-white:focus-within {\n    --border-opacity: 1;\n    border-color: #ffffff;\n    border-color: rgba(255, 255, 255, var(--border-opacity));\n  }\n  .xl\\:focus-within\\:border-black:focus-within {\n    --border-opacity: 1;\n    border-color: #000000;\n    border-color: rgba(0, 0, 0, var(--border-opacity));\n  }\n  .xl\\:focus-within\\:border-gray-50:focus-within {\n    --border-opacity: 1;\n    border-color: #f9fafb;\n    border-color: rgba(249, 250, 251, var(--border-opacity));\n  }\n  .xl\\:focus-within\\:border-gray-100:focus-within {\n    --border-opacity: 1;\n    border-color: #f4f5f7;\n    border-color: rgba(244, 245, 247, var(--border-opacity));\n  }\n  .xl\\:focus-within\\:border-gray-200:focus-within {\n    --border-opacity: 1;\n    border-color: #e5e7eb;\n    border-color: rgba(229, 231, 235, var(--border-opacity));\n  }\n  .xl\\:focus-within\\:border-gray-300:focus-within {\n    --border-opacity: 1;\n    border-color: #d2d6dc;\n    border-color: rgba(210, 214, 220, var(--border-opacity));\n  }\n  .xl\\:focus-within\\:border-gray-400:focus-within {\n    --border-opacity: 1;\n    border-color: #9fa6b2;\n    border-color: rgba(159, 166, 178, var(--border-opacity));\n  }\n  .xl\\:focus-within\\:border-gray-500:focus-within {\n    --border-opacity: 1;\n    border-color: #6b7280;\n    border-color: rgba(107, 114, 128, var(--border-opacity));\n  }\n  .xl\\:focus-within\\:border-gray-600:focus-within {\n    --border-opacity: 1;\n    border-color: #4b5563;\n    border-color: rgba(75, 85, 99, var(--border-opacity));\n  }\n  .xl\\:focus-within\\:border-gray-700:focus-within {\n    --border-opacity: 1;\n    border-color: #374151;\n    border-color: rgba(55, 65, 81, var(--border-opacity));\n  }\n  .xl\\:focus-within\\:border-gray-800:focus-within {\n    --border-opacity: 1;\n    border-color: #252f3f;\n    border-color: rgba(37, 47, 63, var(--border-opacity));\n  }\n  .xl\\:focus-within\\:border-gray-900:focus-within {\n    --border-opacity: 1;\n    border-color: #161e2e;\n    border-color: rgba(22, 30, 46, var(--border-opacity));\n  }\n  .xl\\:focus-within\\:border-red-50:focus-within {\n    --border-opacity: 1;\n    border-color: #fdf2f2;\n    border-color: rgba(253, 242, 242, var(--border-opacity));\n  }\n  .xl\\:focus-within\\:border-red-100:focus-within {\n    --border-opacity: 1;\n    border-color: #fde8e8;\n    border-color: rgba(253, 232, 232, var(--border-opacity));\n  }\n  .xl\\:focus-within\\:border-red-200:focus-within {\n    --border-opacity: 1;\n    border-color: #fbd5d5;\n    border-color: rgba(251, 213, 213, var(--border-opacity));\n  }\n  .xl\\:focus-within\\:border-red-300:focus-within {\n    --border-opacity: 1;\n    border-color: #f8b4b4;\n    border-color: rgba(248, 180, 180, var(--border-opacity));\n  }\n  .xl\\:focus-within\\:border-red-400:focus-within {\n    --border-opacity: 1;\n    border-color: #f98080;\n    border-color: rgba(249, 128, 128, var(--border-opacity));\n  }\n  .xl\\:focus-within\\:border-red-500:focus-within {\n    --border-opacity: 1;\n    border-color: #f05252;\n    border-color: rgba(240, 82, 82, var(--border-opacity));\n  }\n  .xl\\:focus-within\\:border-red-600:focus-within {\n    --border-opacity: 1;\n    border-color: #e02424;\n    border-color: rgba(224, 36, 36, var(--border-opacity));\n  }\n  .xl\\:focus-within\\:border-red-700:focus-within {\n    --border-opacity: 1;\n    border-color: #c81e1e;\n    border-color: rgba(200, 30, 30, var(--border-opacity));\n  }\n  .xl\\:focus-within\\:border-red-800:focus-within {\n    --border-opacity: 1;\n    border-color: #9b1c1c;\n    border-color: rgba(155, 28, 28, var(--border-opacity));\n  }\n  .xl\\:focus-within\\:border-red-900:focus-within {\n    --border-opacity: 1;\n    border-color: #771d1d;\n    border-color: rgba(119, 29, 29, var(--border-opacity));\n  }\n  .xl\\:focus-within\\:border-orange-50:focus-within {\n    --border-opacity: 1;\n    border-color: #fff8f1;\n    border-color: rgba(255, 248, 241, var(--border-opacity));\n  }\n  .xl\\:focus-within\\:border-orange-100:focus-within {\n    --border-opacity: 1;\n    border-color: #feecdc;\n    border-color: rgba(254, 236, 220, var(--border-opacity));\n  }\n  .xl\\:focus-within\\:border-orange-200:focus-within {\n    --border-opacity: 1;\n    border-color: #fcd9bd;\n    border-color: rgba(252, 217, 189, var(--border-opacity));\n  }\n  .xl\\:focus-within\\:border-orange-300:focus-within {\n    --border-opacity: 1;\n    border-color: #fdba8c;\n    border-color: rgba(253, 186, 140, var(--border-opacity));\n  }\n  .xl\\:focus-within\\:border-orange-400:focus-within {\n    --border-opacity: 1;\n    border-color: #ff8a4c;\n    border-color: rgba(255, 138, 76, var(--border-opacity));\n  }\n  .xl\\:focus-within\\:border-orange-500:focus-within {\n    --border-opacity: 1;\n    border-color: #ff5a1f;\n    border-color: rgba(255, 90, 31, var(--border-opacity));\n  }\n  .xl\\:focus-within\\:border-orange-600:focus-within {\n    --border-opacity: 1;\n    border-color: #d03801;\n    border-color: rgba(208, 56, 1, var(--border-opacity));\n  }\n  .xl\\:focus-within\\:border-orange-700:focus-within {\n    --border-opacity: 1;\n    border-color: #b43403;\n    border-color: rgba(180, 52, 3, var(--border-opacity));\n  }\n  .xl\\:focus-within\\:border-orange-800:focus-within {\n    --border-opacity: 1;\n    border-color: #8a2c0d;\n    border-color: rgba(138, 44, 13, var(--border-opacity));\n  }\n  .xl\\:focus-within\\:border-orange-900:focus-within {\n    --border-opacity: 1;\n    border-color: #73230d;\n    border-color: rgba(115, 35, 13, var(--border-opacity));\n  }\n  .xl\\:focus-within\\:border-yellow-50:focus-within {\n    --border-opacity: 1;\n    border-color: #fdfdea;\n    border-color: rgba(253, 253, 234, var(--border-opacity));\n  }\n  .xl\\:focus-within\\:border-yellow-100:focus-within {\n    --border-opacity: 1;\n    border-color: #fdf6b2;\n    border-color: rgba(253, 246, 178, var(--border-opacity));\n  }\n  .xl\\:focus-within\\:border-yellow-200:focus-within {\n    --border-opacity: 1;\n    border-color: #fce96a;\n    border-color: rgba(252, 233, 106, var(--border-opacity));\n  }\n  .xl\\:focus-within\\:border-yellow-300:focus-within {\n    --border-opacity: 1;\n    border-color: #faca15;\n    border-color: rgba(250, 202, 21, var(--border-opacity));\n  }\n  .xl\\:focus-within\\:border-yellow-400:focus-within {\n    --border-opacity: 1;\n    border-color: #e3a008;\n    border-color: rgba(227, 160, 8, var(--border-opacity));\n  }\n  .xl\\:focus-within\\:border-yellow-500:focus-within {\n    --border-opacity: 1;\n    border-color: #c27803;\n    border-color: rgba(194, 120, 3, var(--border-opacity));\n  }\n  .xl\\:focus-within\\:border-yellow-600:focus-within {\n    --border-opacity: 1;\n    border-color: #9f580a;\n    border-color: rgba(159, 88, 10, var(--border-opacity));\n  }\n  .xl\\:focus-within\\:border-yellow-700:focus-within {\n    --border-opacity: 1;\n    border-color: #8e4b10;\n    border-color: rgba(142, 75, 16, var(--border-opacity));\n  }\n  .xl\\:focus-within\\:border-yellow-800:focus-within {\n    --border-opacity: 1;\n    border-color: #723b13;\n    border-color: rgba(114, 59, 19, var(--border-opacity));\n  }\n  .xl\\:focus-within\\:border-yellow-900:focus-within {\n    --border-opacity: 1;\n    border-color: #633112;\n    border-color: rgba(99, 49, 18, var(--border-opacity));\n  }\n  .xl\\:focus-within\\:border-green-50:focus-within {\n    --border-opacity: 1;\n    border-color: #f3faf7;\n    border-color: rgba(243, 250, 247, var(--border-opacity));\n  }\n  .xl\\:focus-within\\:border-green-100:focus-within {\n    --border-opacity: 1;\n    border-color: #def7ec;\n    border-color: rgba(222, 247, 236, var(--border-opacity));\n  }\n  .xl\\:focus-within\\:border-green-200:focus-within {\n    --border-opacity: 1;\n    border-color: #bcf0da;\n    border-color: rgba(188, 240, 218, var(--border-opacity));\n  }\n  .xl\\:focus-within\\:border-green-300:focus-within {\n    --border-opacity: 1;\n    border-color: #84e1bc;\n    border-color: rgba(132, 225, 188, var(--border-opacity));\n  }\n  .xl\\:focus-within\\:border-green-400:focus-within {\n    --border-opacity: 1;\n    border-color: #31c48d;\n    border-color: rgba(49, 196, 141, var(--border-opacity));\n  }\n  .xl\\:focus-within\\:border-green-500:focus-within {\n    --border-opacity: 1;\n    border-color: #0e9f6e;\n    border-color: rgba(14, 159, 110, var(--border-opacity));\n  }\n  .xl\\:focus-within\\:border-green-600:focus-within {\n    --border-opacity: 1;\n    border-color: #057a55;\n    border-color: rgba(5, 122, 85, var(--border-opacity));\n  }\n  .xl\\:focus-within\\:border-green-700:focus-within {\n    --border-opacity: 1;\n    border-color: #046c4e;\n    border-color: rgba(4, 108, 78, var(--border-opacity));\n  }\n  .xl\\:focus-within\\:border-green-800:focus-within {\n    --border-opacity: 1;\n    border-color: #03543f;\n    border-color: rgba(3, 84, 63, var(--border-opacity));\n  }\n  .xl\\:focus-within\\:border-green-900:focus-within {\n    --border-opacity: 1;\n    border-color: #014737;\n    border-color: rgba(1, 71, 55, var(--border-opacity));\n  }\n  .xl\\:focus-within\\:border-teal-50:focus-within {\n    --border-opacity: 1;\n    border-color: #edfafa;\n    border-color: rgba(237, 250, 250, var(--border-opacity));\n  }\n  .xl\\:focus-within\\:border-teal-100:focus-within {\n    --border-opacity: 1;\n    border-color: #d5f5f6;\n    border-color: rgba(213, 245, 246, var(--border-opacity));\n  }\n  .xl\\:focus-within\\:border-teal-200:focus-within {\n    --border-opacity: 1;\n    border-color: #afecef;\n    border-color: rgba(175, 236, 239, var(--border-opacity));\n  }\n  .xl\\:focus-within\\:border-teal-300:focus-within {\n    --border-opacity: 1;\n    border-color: #7edce2;\n    border-color: rgba(126, 220, 226, var(--border-opacity));\n  }\n  .xl\\:focus-within\\:border-teal-400:focus-within {\n    --border-opacity: 1;\n    border-color: #16bdca;\n    border-color: rgba(22, 189, 202, var(--border-opacity));\n  }\n  .xl\\:focus-within\\:border-teal-500:focus-within {\n    --border-opacity: 1;\n    border-color: #0694a2;\n    border-color: rgba(6, 148, 162, var(--border-opacity));\n  }\n  .xl\\:focus-within\\:border-teal-600:focus-within {\n    --border-opacity: 1;\n    border-color: #047481;\n    border-color: rgba(4, 116, 129, var(--border-opacity));\n  }\n  .xl\\:focus-within\\:border-teal-700:focus-within {\n    --border-opacity: 1;\n    border-color: #036672;\n    border-color: rgba(3, 102, 114, var(--border-opacity));\n  }\n  .xl\\:focus-within\\:border-teal-800:focus-within {\n    --border-opacity: 1;\n    border-color: #05505c;\n    border-color: rgba(5, 80, 92, var(--border-opacity));\n  }\n  .xl\\:focus-within\\:border-teal-900:focus-within {\n    --border-opacity: 1;\n    border-color: #014451;\n    border-color: rgba(1, 68, 81, var(--border-opacity));\n  }\n  .xl\\:focus-within\\:border-blue-50:focus-within {\n    --border-opacity: 1;\n    border-color: #ebf5ff;\n    border-color: rgba(235, 245, 255, var(--border-opacity));\n  }\n  .xl\\:focus-within\\:border-blue-100:focus-within {\n    --border-opacity: 1;\n    border-color: #e1effe;\n    border-color: rgba(225, 239, 254, var(--border-opacity));\n  }\n  .xl\\:focus-within\\:border-blue-200:focus-within {\n    --border-opacity: 1;\n    border-color: #c3ddfd;\n    border-color: rgba(195, 221, 253, var(--border-opacity));\n  }\n  .xl\\:focus-within\\:border-blue-300:focus-within {\n    --border-opacity: 1;\n    border-color: #a4cafe;\n    border-color: rgba(164, 202, 254, var(--border-opacity));\n  }\n  .xl\\:focus-within\\:border-blue-400:focus-within {\n    --border-opacity: 1;\n    border-color: #76a9fa;\n    border-color: rgba(118, 169, 250, var(--border-opacity));\n  }\n  .xl\\:focus-within\\:border-blue-500:focus-within {\n    --border-opacity: 1;\n    border-color: #3f83f8;\n    border-color: rgba(63, 131, 248, var(--border-opacity));\n  }\n  .xl\\:focus-within\\:border-blue-600:focus-within {\n    --border-opacity: 1;\n    border-color: #1c64f2;\n    border-color: rgba(28, 100, 242, var(--border-opacity));\n  }\n  .xl\\:focus-within\\:border-blue-700:focus-within {\n    --border-opacity: 1;\n    border-color: #1a56db;\n    border-color: rgba(26, 86, 219, var(--border-opacity));\n  }\n  .xl\\:focus-within\\:border-blue-800:focus-within {\n    --border-opacity: 1;\n    border-color: #1e429f;\n    border-color: rgba(30, 66, 159, var(--border-opacity));\n  }\n  .xl\\:focus-within\\:border-blue-900:focus-within {\n    --border-opacity: 1;\n    border-color: #233876;\n    border-color: rgba(35, 56, 118, var(--border-opacity));\n  }\n  .xl\\:focus-within\\:border-indigo-50:focus-within {\n    --border-opacity: 1;\n    border-color: #f0f5ff;\n    border-color: rgba(240, 245, 255, var(--border-opacity));\n  }\n  .xl\\:focus-within\\:border-indigo-100:focus-within {\n    --border-opacity: 1;\n    border-color: #e5edff;\n    border-color: rgba(229, 237, 255, var(--border-opacity));\n  }\n  .xl\\:focus-within\\:border-indigo-200:focus-within {\n    --border-opacity: 1;\n    border-color: #cddbfe;\n    border-color: rgba(205, 219, 254, var(--border-opacity));\n  }\n  .xl\\:focus-within\\:border-indigo-300:focus-within {\n    --border-opacity: 1;\n    border-color: #b4c6fc;\n    border-color: rgba(180, 198, 252, var(--border-opacity));\n  }\n  .xl\\:focus-within\\:border-indigo-400:focus-within {\n    --border-opacity: 1;\n    border-color: #8da2fb;\n    border-color: rgba(141, 162, 251, var(--border-opacity));\n  }\n  .xl\\:focus-within\\:border-indigo-500:focus-within {\n    --border-opacity: 1;\n    border-color: #6875f5;\n    border-color: rgba(104, 117, 245, var(--border-opacity));\n  }\n  .xl\\:focus-within\\:border-indigo-600:focus-within {\n    --border-opacity: 1;\n    border-color: #5850ec;\n    border-color: rgba(88, 80, 236, var(--border-opacity));\n  }\n  .xl\\:focus-within\\:border-indigo-700:focus-within {\n    --border-opacity: 1;\n    border-color: #5145cd;\n    border-color: rgba(81, 69, 205, var(--border-opacity));\n  }\n  .xl\\:focus-within\\:border-indigo-800:focus-within {\n    --border-opacity: 1;\n    border-color: #42389d;\n    border-color: rgba(66, 56, 157, var(--border-opacity));\n  }\n  .xl\\:focus-within\\:border-indigo-900:focus-within {\n    --border-opacity: 1;\n    border-color: #362f78;\n    border-color: rgba(54, 47, 120, var(--border-opacity));\n  }\n  .xl\\:focus-within\\:border-purple-50:focus-within {\n    --border-opacity: 1;\n    border-color: #f6f5ff;\n    border-color: rgba(246, 245, 255, var(--border-opacity));\n  }\n  .xl\\:focus-within\\:border-purple-100:focus-within {\n    --border-opacity: 1;\n    border-color: #edebfe;\n    border-color: rgba(237, 235, 254, var(--border-opacity));\n  }\n  .xl\\:focus-within\\:border-purple-200:focus-within {\n    --border-opacity: 1;\n    border-color: #dcd7fe;\n    border-color: rgba(220, 215, 254, var(--border-opacity));\n  }\n  .xl\\:focus-within\\:border-purple-300:focus-within {\n    --border-opacity: 1;\n    border-color: #cabffd;\n    border-color: rgba(202, 191, 253, var(--border-opacity));\n  }\n  .xl\\:focus-within\\:border-purple-400:focus-within {\n    --border-opacity: 1;\n    border-color: #ac94fa;\n    border-color: rgba(172, 148, 250, var(--border-opacity));\n  }\n  .xl\\:focus-within\\:border-purple-500:focus-within {\n    --border-opacity: 1;\n    border-color: #9061f9;\n    border-color: rgba(144, 97, 249, var(--border-opacity));\n  }\n  .xl\\:focus-within\\:border-purple-600:focus-within {\n    --border-opacity: 1;\n    border-color: #7e3af2;\n    border-color: rgba(126, 58, 242, var(--border-opacity));\n  }\n  .xl\\:focus-within\\:border-purple-700:focus-within {\n    --border-opacity: 1;\n    border-color: #6c2bd9;\n    border-color: rgba(108, 43, 217, var(--border-opacity));\n  }\n  .xl\\:focus-within\\:border-purple-800:focus-within {\n    --border-opacity: 1;\n    border-color: #5521b5;\n    border-color: rgba(85, 33, 181, var(--border-opacity));\n  }\n  .xl\\:focus-within\\:border-purple-900:focus-within {\n    --border-opacity: 1;\n    border-color: #4a1d96;\n    border-color: rgba(74, 29, 150, var(--border-opacity));\n  }\n  .xl\\:focus-within\\:border-pink-50:focus-within {\n    --border-opacity: 1;\n    border-color: #fdf2f8;\n    border-color: rgba(253, 242, 248, var(--border-opacity));\n  }\n  .xl\\:focus-within\\:border-pink-100:focus-within {\n    --border-opacity: 1;\n    border-color: #fce8f3;\n    border-color: rgba(252, 232, 243, var(--border-opacity));\n  }\n  .xl\\:focus-within\\:border-pink-200:focus-within {\n    --border-opacity: 1;\n    border-color: #fad1e8;\n    border-color: rgba(250, 209, 232, var(--border-opacity));\n  }\n  .xl\\:focus-within\\:border-pink-300:focus-within {\n    --border-opacity: 1;\n    border-color: #f8b4d9;\n    border-color: rgba(248, 180, 217, var(--border-opacity));\n  }\n  .xl\\:focus-within\\:border-pink-400:focus-within {\n    --border-opacity: 1;\n    border-color: #f17eb8;\n    border-color: rgba(241, 126, 184, var(--border-opacity));\n  }\n  .xl\\:focus-within\\:border-pink-500:focus-within {\n    --border-opacity: 1;\n    border-color: #e74694;\n    border-color: rgba(231, 70, 148, var(--border-opacity));\n  }\n  .xl\\:focus-within\\:border-pink-600:focus-within {\n    --border-opacity: 1;\n    border-color: #d61f69;\n    border-color: rgba(214, 31, 105, var(--border-opacity));\n  }\n  .xl\\:focus-within\\:border-pink-700:focus-within {\n    --border-opacity: 1;\n    border-color: #bf125d;\n    border-color: rgba(191, 18, 93, var(--border-opacity));\n  }\n  .xl\\:focus-within\\:border-pink-800:focus-within {\n    --border-opacity: 1;\n    border-color: #99154b;\n    border-color: rgba(153, 21, 75, var(--border-opacity));\n  }\n  .xl\\:focus-within\\:border-pink-900:focus-within {\n    --border-opacity: 1;\n    border-color: #751a3d;\n    border-color: rgba(117, 26, 61, var(--border-opacity));\n  }\n  .xl\\:focus-within\\:border-cool-gray-50:focus-within {\n    --border-opacity: 1;\n    border-color: #f8fafc;\n    border-color: rgba(248, 250, 252, var(--border-opacity));\n  }\n  .xl\\:focus-within\\:border-cool-gray-100:focus-within {\n    --border-opacity: 1;\n    border-color: #f1f5f9;\n    border-color: rgba(241, 245, 249, var(--border-opacity));\n  }\n  .xl\\:focus-within\\:border-cool-gray-200:focus-within {\n    --border-opacity: 1;\n    border-color: #e2e8f0;\n    border-color: rgba(226, 232, 240, var(--border-opacity));\n  }\n  .xl\\:focus-within\\:border-cool-gray-300:focus-within {\n    --border-opacity: 1;\n    border-color: #cfd8e3;\n    border-color: rgba(207, 216, 227, var(--border-opacity));\n  }\n  .xl\\:focus-within\\:border-cool-gray-400:focus-within {\n    --border-opacity: 1;\n    border-color: #97a6ba;\n    border-color: rgba(151, 166, 186, var(--border-opacity));\n  }\n  .xl\\:focus-within\\:border-cool-gray-500:focus-within {\n    --border-opacity: 1;\n    border-color: #64748b;\n    border-color: rgba(100, 116, 139, var(--border-opacity));\n  }\n  .xl\\:focus-within\\:border-cool-gray-600:focus-within {\n    --border-opacity: 1;\n    border-color: #475569;\n    border-color: rgba(71, 85, 105, var(--border-opacity));\n  }\n  .xl\\:focus-within\\:border-cool-gray-700:focus-within {\n    --border-opacity: 1;\n    border-color: #364152;\n    border-color: rgba(54, 65, 82, var(--border-opacity));\n  }\n  .xl\\:focus-within\\:border-cool-gray-800:focus-within {\n    --border-opacity: 1;\n    border-color: #27303f;\n    border-color: rgba(39, 48, 63, var(--border-opacity));\n  }\n  .xl\\:focus-within\\:border-cool-gray-900:focus-within {\n    --border-opacity: 1;\n    border-color: #1a202e;\n    border-color: rgba(26, 32, 46, var(--border-opacity));\n  }\n  .xl\\:focus\\:border-current:focus {\n    border-color: currentColor;\n  }\n  .xl\\:focus\\:border-transparent:focus {\n    border-color: transparent;\n  }\n  .xl\\:focus\\:border-white:focus {\n    --border-opacity: 1;\n    border-color: #ffffff;\n    border-color: rgba(255, 255, 255, var(--border-opacity));\n  }\n  .xl\\:focus\\:border-black:focus {\n    --border-opacity: 1;\n    border-color: #000000;\n    border-color: rgba(0, 0, 0, var(--border-opacity));\n  }\n  .xl\\:focus\\:border-gray-50:focus {\n    --border-opacity: 1;\n    border-color: #f9fafb;\n    border-color: rgba(249, 250, 251, var(--border-opacity));\n  }\n  .xl\\:focus\\:border-gray-100:focus {\n    --border-opacity: 1;\n    border-color: #f4f5f7;\n    border-color: rgba(244, 245, 247, var(--border-opacity));\n  }\n  .xl\\:focus\\:border-gray-200:focus {\n    --border-opacity: 1;\n    border-color: #e5e7eb;\n    border-color: rgba(229, 231, 235, var(--border-opacity));\n  }\n  .xl\\:focus\\:border-gray-300:focus {\n    --border-opacity: 1;\n    border-color: #d2d6dc;\n    border-color: rgba(210, 214, 220, var(--border-opacity));\n  }\n  .xl\\:focus\\:border-gray-400:focus {\n    --border-opacity: 1;\n    border-color: #9fa6b2;\n    border-color: rgba(159, 166, 178, var(--border-opacity));\n  }\n  .xl\\:focus\\:border-gray-500:focus {\n    --border-opacity: 1;\n    border-color: #6b7280;\n    border-color: rgba(107, 114, 128, var(--border-opacity));\n  }\n  .xl\\:focus\\:border-gray-600:focus {\n    --border-opacity: 1;\n    border-color: #4b5563;\n    border-color: rgba(75, 85, 99, var(--border-opacity));\n  }\n  .xl\\:focus\\:border-gray-700:focus {\n    --border-opacity: 1;\n    border-color: #374151;\n    border-color: rgba(55, 65, 81, var(--border-opacity));\n  }\n  .xl\\:focus\\:border-gray-800:focus {\n    --border-opacity: 1;\n    border-color: #252f3f;\n    border-color: rgba(37, 47, 63, var(--border-opacity));\n  }\n  .xl\\:focus\\:border-gray-900:focus {\n    --border-opacity: 1;\n    border-color: #161e2e;\n    border-color: rgba(22, 30, 46, var(--border-opacity));\n  }\n  .xl\\:focus\\:border-red-50:focus {\n    --border-opacity: 1;\n    border-color: #fdf2f2;\n    border-color: rgba(253, 242, 242, var(--border-opacity));\n  }\n  .xl\\:focus\\:border-red-100:focus {\n    --border-opacity: 1;\n    border-color: #fde8e8;\n    border-color: rgba(253, 232, 232, var(--border-opacity));\n  }\n  .xl\\:focus\\:border-red-200:focus {\n    --border-opacity: 1;\n    border-color: #fbd5d5;\n    border-color: rgba(251, 213, 213, var(--border-opacity));\n  }\n  .xl\\:focus\\:border-red-300:focus {\n    --border-opacity: 1;\n    border-color: #f8b4b4;\n    border-color: rgba(248, 180, 180, var(--border-opacity));\n  }\n  .xl\\:focus\\:border-red-400:focus {\n    --border-opacity: 1;\n    border-color: #f98080;\n    border-color: rgba(249, 128, 128, var(--border-opacity));\n  }\n  .xl\\:focus\\:border-red-500:focus {\n    --border-opacity: 1;\n    border-color: #f05252;\n    border-color: rgba(240, 82, 82, var(--border-opacity));\n  }\n  .xl\\:focus\\:border-red-600:focus {\n    --border-opacity: 1;\n    border-color: #e02424;\n    border-color: rgba(224, 36, 36, var(--border-opacity));\n  }\n  .xl\\:focus\\:border-red-700:focus {\n    --border-opacity: 1;\n    border-color: #c81e1e;\n    border-color: rgba(200, 30, 30, var(--border-opacity));\n  }\n  .xl\\:focus\\:border-red-800:focus {\n    --border-opacity: 1;\n    border-color: #9b1c1c;\n    border-color: rgba(155, 28, 28, var(--border-opacity));\n  }\n  .xl\\:focus\\:border-red-900:focus {\n    --border-opacity: 1;\n    border-color: #771d1d;\n    border-color: rgba(119, 29, 29, var(--border-opacity));\n  }\n  .xl\\:focus\\:border-orange-50:focus {\n    --border-opacity: 1;\n    border-color: #fff8f1;\n    border-color: rgba(255, 248, 241, var(--border-opacity));\n  }\n  .xl\\:focus\\:border-orange-100:focus {\n    --border-opacity: 1;\n    border-color: #feecdc;\n    border-color: rgba(254, 236, 220, var(--border-opacity));\n  }\n  .xl\\:focus\\:border-orange-200:focus {\n    --border-opacity: 1;\n    border-color: #fcd9bd;\n    border-color: rgba(252, 217, 189, var(--border-opacity));\n  }\n  .xl\\:focus\\:border-orange-300:focus {\n    --border-opacity: 1;\n    border-color: #fdba8c;\n    border-color: rgba(253, 186, 140, var(--border-opacity));\n  }\n  .xl\\:focus\\:border-orange-400:focus {\n    --border-opacity: 1;\n    border-color: #ff8a4c;\n    border-color: rgba(255, 138, 76, var(--border-opacity));\n  }\n  .xl\\:focus\\:border-orange-500:focus {\n    --border-opacity: 1;\n    border-color: #ff5a1f;\n    border-color: rgba(255, 90, 31, var(--border-opacity));\n  }\n  .xl\\:focus\\:border-orange-600:focus {\n    --border-opacity: 1;\n    border-color: #d03801;\n    border-color: rgba(208, 56, 1, var(--border-opacity));\n  }\n  .xl\\:focus\\:border-orange-700:focus {\n    --border-opacity: 1;\n    border-color: #b43403;\n    border-color: rgba(180, 52, 3, var(--border-opacity));\n  }\n  .xl\\:focus\\:border-orange-800:focus {\n    --border-opacity: 1;\n    border-color: #8a2c0d;\n    border-color: rgba(138, 44, 13, var(--border-opacity));\n  }\n  .xl\\:focus\\:border-orange-900:focus {\n    --border-opacity: 1;\n    border-color: #73230d;\n    border-color: rgba(115, 35, 13, var(--border-opacity));\n  }\n  .xl\\:focus\\:border-yellow-50:focus {\n    --border-opacity: 1;\n    border-color: #fdfdea;\n    border-color: rgba(253, 253, 234, var(--border-opacity));\n  }\n  .xl\\:focus\\:border-yellow-100:focus {\n    --border-opacity: 1;\n    border-color: #fdf6b2;\n    border-color: rgba(253, 246, 178, var(--border-opacity));\n  }\n  .xl\\:focus\\:border-yellow-200:focus {\n    --border-opacity: 1;\n    border-color: #fce96a;\n    border-color: rgba(252, 233, 106, var(--border-opacity));\n  }\n  .xl\\:focus\\:border-yellow-300:focus {\n    --border-opacity: 1;\n    border-color: #faca15;\n    border-color: rgba(250, 202, 21, var(--border-opacity));\n  }\n  .xl\\:focus\\:border-yellow-400:focus {\n    --border-opacity: 1;\n    border-color: #e3a008;\n    border-color: rgba(227, 160, 8, var(--border-opacity));\n  }\n  .xl\\:focus\\:border-yellow-500:focus {\n    --border-opacity: 1;\n    border-color: #c27803;\n    border-color: rgba(194, 120, 3, var(--border-opacity));\n  }\n  .xl\\:focus\\:border-yellow-600:focus {\n    --border-opacity: 1;\n    border-color: #9f580a;\n    border-color: rgba(159, 88, 10, var(--border-opacity));\n  }\n  .xl\\:focus\\:border-yellow-700:focus {\n    --border-opacity: 1;\n    border-color: #8e4b10;\n    border-color: rgba(142, 75, 16, var(--border-opacity));\n  }\n  .xl\\:focus\\:border-yellow-800:focus {\n    --border-opacity: 1;\n    border-color: #723b13;\n    border-color: rgba(114, 59, 19, var(--border-opacity));\n  }\n  .xl\\:focus\\:border-yellow-900:focus {\n    --border-opacity: 1;\n    border-color: #633112;\n    border-color: rgba(99, 49, 18, var(--border-opacity));\n  }\n  .xl\\:focus\\:border-green-50:focus {\n    --border-opacity: 1;\n    border-color: #f3faf7;\n    border-color: rgba(243, 250, 247, var(--border-opacity));\n  }\n  .xl\\:focus\\:border-green-100:focus {\n    --border-opacity: 1;\n    border-color: #def7ec;\n    border-color: rgba(222, 247, 236, var(--border-opacity));\n  }\n  .xl\\:focus\\:border-green-200:focus {\n    --border-opacity: 1;\n    border-color: #bcf0da;\n    border-color: rgba(188, 240, 218, var(--border-opacity));\n  }\n  .xl\\:focus\\:border-green-300:focus {\n    --border-opacity: 1;\n    border-color: #84e1bc;\n    border-color: rgba(132, 225, 188, var(--border-opacity));\n  }\n  .xl\\:focus\\:border-green-400:focus {\n    --border-opacity: 1;\n    border-color: #31c48d;\n    border-color: rgba(49, 196, 141, var(--border-opacity));\n  }\n  .xl\\:focus\\:border-green-500:focus {\n    --border-opacity: 1;\n    border-color: #0e9f6e;\n    border-color: rgba(14, 159, 110, var(--border-opacity));\n  }\n  .xl\\:focus\\:border-green-600:focus {\n    --border-opacity: 1;\n    border-color: #057a55;\n    border-color: rgba(5, 122, 85, var(--border-opacity));\n  }\n  .xl\\:focus\\:border-green-700:focus {\n    --border-opacity: 1;\n    border-color: #046c4e;\n    border-color: rgba(4, 108, 78, var(--border-opacity));\n  }\n  .xl\\:focus\\:border-green-800:focus {\n    --border-opacity: 1;\n    border-color: #03543f;\n    border-color: rgba(3, 84, 63, var(--border-opacity));\n  }\n  .xl\\:focus\\:border-green-900:focus {\n    --border-opacity: 1;\n    border-color: #014737;\n    border-color: rgba(1, 71, 55, var(--border-opacity));\n  }\n  .xl\\:focus\\:border-teal-50:focus {\n    --border-opacity: 1;\n    border-color: #edfafa;\n    border-color: rgba(237, 250, 250, var(--border-opacity));\n  }\n  .xl\\:focus\\:border-teal-100:focus {\n    --border-opacity: 1;\n    border-color: #d5f5f6;\n    border-color: rgba(213, 245, 246, var(--border-opacity));\n  }\n  .xl\\:focus\\:border-teal-200:focus {\n    --border-opacity: 1;\n    border-color: #afecef;\n    border-color: rgba(175, 236, 239, var(--border-opacity));\n  }\n  .xl\\:focus\\:border-teal-300:focus {\n    --border-opacity: 1;\n    border-color: #7edce2;\n    border-color: rgba(126, 220, 226, var(--border-opacity));\n  }\n  .xl\\:focus\\:border-teal-400:focus {\n    --border-opacity: 1;\n    border-color: #16bdca;\n    border-color: rgba(22, 189, 202, var(--border-opacity));\n  }\n  .xl\\:focus\\:border-teal-500:focus {\n    --border-opacity: 1;\n    border-color: #0694a2;\n    border-color: rgba(6, 148, 162, var(--border-opacity));\n  }\n  .xl\\:focus\\:border-teal-600:focus {\n    --border-opacity: 1;\n    border-color: #047481;\n    border-color: rgba(4, 116, 129, var(--border-opacity));\n  }\n  .xl\\:focus\\:border-teal-700:focus {\n    --border-opacity: 1;\n    border-color: #036672;\n    border-color: rgba(3, 102, 114, var(--border-opacity));\n  }\n  .xl\\:focus\\:border-teal-800:focus {\n    --border-opacity: 1;\n    border-color: #05505c;\n    border-color: rgba(5, 80, 92, var(--border-opacity));\n  }\n  .xl\\:focus\\:border-teal-900:focus {\n    --border-opacity: 1;\n    border-color: #014451;\n    border-color: rgba(1, 68, 81, var(--border-opacity));\n  }\n  .xl\\:focus\\:border-blue-50:focus {\n    --border-opacity: 1;\n    border-color: #ebf5ff;\n    border-color: rgba(235, 245, 255, var(--border-opacity));\n  }\n  .xl\\:focus\\:border-blue-100:focus {\n    --border-opacity: 1;\n    border-color: #e1effe;\n    border-color: rgba(225, 239, 254, var(--border-opacity));\n  }\n  .xl\\:focus\\:border-blue-200:focus {\n    --border-opacity: 1;\n    border-color: #c3ddfd;\n    border-color: rgba(195, 221, 253, var(--border-opacity));\n  }\n  .xl\\:focus\\:border-blue-300:focus {\n    --border-opacity: 1;\n    border-color: #a4cafe;\n    border-color: rgba(164, 202, 254, var(--border-opacity));\n  }\n  .xl\\:focus\\:border-blue-400:focus {\n    --border-opacity: 1;\n    border-color: #76a9fa;\n    border-color: rgba(118, 169, 250, var(--border-opacity));\n  }\n  .xl\\:focus\\:border-blue-500:focus {\n    --border-opacity: 1;\n    border-color: #3f83f8;\n    border-color: rgba(63, 131, 248, var(--border-opacity));\n  }\n  .xl\\:focus\\:border-blue-600:focus {\n    --border-opacity: 1;\n    border-color: #1c64f2;\n    border-color: rgba(28, 100, 242, var(--border-opacity));\n  }\n  .xl\\:focus\\:border-blue-700:focus {\n    --border-opacity: 1;\n    border-color: #1a56db;\n    border-color: rgba(26, 86, 219, var(--border-opacity));\n  }\n  .xl\\:focus\\:border-blue-800:focus {\n    --border-opacity: 1;\n    border-color: #1e429f;\n    border-color: rgba(30, 66, 159, var(--border-opacity));\n  }\n  .xl\\:focus\\:border-blue-900:focus {\n    --border-opacity: 1;\n    border-color: #233876;\n    border-color: rgba(35, 56, 118, var(--border-opacity));\n  }\n  .xl\\:focus\\:border-indigo-50:focus {\n    --border-opacity: 1;\n    border-color: #f0f5ff;\n    border-color: rgba(240, 245, 255, var(--border-opacity));\n  }\n  .xl\\:focus\\:border-indigo-100:focus {\n    --border-opacity: 1;\n    border-color: #e5edff;\n    border-color: rgba(229, 237, 255, var(--border-opacity));\n  }\n  .xl\\:focus\\:border-indigo-200:focus {\n    --border-opacity: 1;\n    border-color: #cddbfe;\n    border-color: rgba(205, 219, 254, var(--border-opacity));\n  }\n  .xl\\:focus\\:border-indigo-300:focus {\n    --border-opacity: 1;\n    border-color: #b4c6fc;\n    border-color: rgba(180, 198, 252, var(--border-opacity));\n  }\n  .xl\\:focus\\:border-indigo-400:focus {\n    --border-opacity: 1;\n    border-color: #8da2fb;\n    border-color: rgba(141, 162, 251, var(--border-opacity));\n  }\n  .xl\\:focus\\:border-indigo-500:focus {\n    --border-opacity: 1;\n    border-color: #6875f5;\n    border-color: rgba(104, 117, 245, var(--border-opacity));\n  }\n  .xl\\:focus\\:border-indigo-600:focus {\n    --border-opacity: 1;\n    border-color: #5850ec;\n    border-color: rgba(88, 80, 236, var(--border-opacity));\n  }\n  .xl\\:focus\\:border-indigo-700:focus {\n    --border-opacity: 1;\n    border-color: #5145cd;\n    border-color: rgba(81, 69, 205, var(--border-opacity));\n  }\n  .xl\\:focus\\:border-indigo-800:focus {\n    --border-opacity: 1;\n    border-color: #42389d;\n    border-color: rgba(66, 56, 157, var(--border-opacity));\n  }\n  .xl\\:focus\\:border-indigo-900:focus {\n    --border-opacity: 1;\n    border-color: #362f78;\n    border-color: rgba(54, 47, 120, var(--border-opacity));\n  }\n  .xl\\:focus\\:border-purple-50:focus {\n    --border-opacity: 1;\n    border-color: #f6f5ff;\n    border-color: rgba(246, 245, 255, var(--border-opacity));\n  }\n  .xl\\:focus\\:border-purple-100:focus {\n    --border-opacity: 1;\n    border-color: #edebfe;\n    border-color: rgba(237, 235, 254, var(--border-opacity));\n  }\n  .xl\\:focus\\:border-purple-200:focus {\n    --border-opacity: 1;\n    border-color: #dcd7fe;\n    border-color: rgba(220, 215, 254, var(--border-opacity));\n  }\n  .xl\\:focus\\:border-purple-300:focus {\n    --border-opacity: 1;\n    border-color: #cabffd;\n    border-color: rgba(202, 191, 253, var(--border-opacity));\n  }\n  .xl\\:focus\\:border-purple-400:focus {\n    --border-opacity: 1;\n    border-color: #ac94fa;\n    border-color: rgba(172, 148, 250, var(--border-opacity));\n  }\n  .xl\\:focus\\:border-purple-500:focus {\n    --border-opacity: 1;\n    border-color: #9061f9;\n    border-color: rgba(144, 97, 249, var(--border-opacity));\n  }\n  .xl\\:focus\\:border-purple-600:focus {\n    --border-opacity: 1;\n    border-color: #7e3af2;\n    border-color: rgba(126, 58, 242, var(--border-opacity));\n  }\n  .xl\\:focus\\:border-purple-700:focus {\n    --border-opacity: 1;\n    border-color: #6c2bd9;\n    border-color: rgba(108, 43, 217, var(--border-opacity));\n  }\n  .xl\\:focus\\:border-purple-800:focus {\n    --border-opacity: 1;\n    border-color: #5521b5;\n    border-color: rgba(85, 33, 181, var(--border-opacity));\n  }\n  .xl\\:focus\\:border-purple-900:focus {\n    --border-opacity: 1;\n    border-color: #4a1d96;\n    border-color: rgba(74, 29, 150, var(--border-opacity));\n  }\n  .xl\\:focus\\:border-pink-50:focus {\n    --border-opacity: 1;\n    border-color: #fdf2f8;\n    border-color: rgba(253, 242, 248, var(--border-opacity));\n  }\n  .xl\\:focus\\:border-pink-100:focus {\n    --border-opacity: 1;\n    border-color: #fce8f3;\n    border-color: rgba(252, 232, 243, var(--border-opacity));\n  }\n  .xl\\:focus\\:border-pink-200:focus {\n    --border-opacity: 1;\n    border-color: #fad1e8;\n    border-color: rgba(250, 209, 232, var(--border-opacity));\n  }\n  .xl\\:focus\\:border-pink-300:focus {\n    --border-opacity: 1;\n    border-color: #f8b4d9;\n    border-color: rgba(248, 180, 217, var(--border-opacity));\n  }\n  .xl\\:focus\\:border-pink-400:focus {\n    --border-opacity: 1;\n    border-color: #f17eb8;\n    border-color: rgba(241, 126, 184, var(--border-opacity));\n  }\n  .xl\\:focus\\:border-pink-500:focus {\n    --border-opacity: 1;\n    border-color: #e74694;\n    border-color: rgba(231, 70, 148, var(--border-opacity));\n  }\n  .xl\\:focus\\:border-pink-600:focus {\n    --border-opacity: 1;\n    border-color: #d61f69;\n    border-color: rgba(214, 31, 105, var(--border-opacity));\n  }\n  .xl\\:focus\\:border-pink-700:focus {\n    --border-opacity: 1;\n    border-color: #bf125d;\n    border-color: rgba(191, 18, 93, var(--border-opacity));\n  }\n  .xl\\:focus\\:border-pink-800:focus {\n    --border-opacity: 1;\n    border-color: #99154b;\n    border-color: rgba(153, 21, 75, var(--border-opacity));\n  }\n  .xl\\:focus\\:border-pink-900:focus {\n    --border-opacity: 1;\n    border-color: #751a3d;\n    border-color: rgba(117, 26, 61, var(--border-opacity));\n  }\n  .xl\\:focus\\:border-cool-gray-50:focus {\n    --border-opacity: 1;\n    border-color: #f8fafc;\n    border-color: rgba(248, 250, 252, var(--border-opacity));\n  }\n  .xl\\:focus\\:border-cool-gray-100:focus {\n    --border-opacity: 1;\n    border-color: #f1f5f9;\n    border-color: rgba(241, 245, 249, var(--border-opacity));\n  }\n  .xl\\:focus\\:border-cool-gray-200:focus {\n    --border-opacity: 1;\n    border-color: #e2e8f0;\n    border-color: rgba(226, 232, 240, var(--border-opacity));\n  }\n  .xl\\:focus\\:border-cool-gray-300:focus {\n    --border-opacity: 1;\n    border-color: #cfd8e3;\n    border-color: rgba(207, 216, 227, var(--border-opacity));\n  }\n  .xl\\:focus\\:border-cool-gray-400:focus {\n    --border-opacity: 1;\n    border-color: #97a6ba;\n    border-color: rgba(151, 166, 186, var(--border-opacity));\n  }\n  .xl\\:focus\\:border-cool-gray-500:focus {\n    --border-opacity: 1;\n    border-color: #64748b;\n    border-color: rgba(100, 116, 139, var(--border-opacity));\n  }\n  .xl\\:focus\\:border-cool-gray-600:focus {\n    --border-opacity: 1;\n    border-color: #475569;\n    border-color: rgba(71, 85, 105, var(--border-opacity));\n  }\n  .xl\\:focus\\:border-cool-gray-700:focus {\n    --border-opacity: 1;\n    border-color: #364152;\n    border-color: rgba(54, 65, 82, var(--border-opacity));\n  }\n  .xl\\:focus\\:border-cool-gray-800:focus {\n    --border-opacity: 1;\n    border-color: #27303f;\n    border-color: rgba(39, 48, 63, var(--border-opacity));\n  }\n  .xl\\:focus\\:border-cool-gray-900:focus {\n    --border-opacity: 1;\n    border-color: #1a202e;\n    border-color: rgba(26, 32, 46, var(--border-opacity));\n  }\n  .xl\\:border-opacity-0 {\n    --border-opacity: 0;\n  }\n  .xl\\:border-opacity-25 {\n    --border-opacity: 0.25;\n  }\n  .xl\\:border-opacity-50 {\n    --border-opacity: 0.5;\n  }\n  .xl\\:border-opacity-75 {\n    --border-opacity: 0.75;\n  }\n  .xl\\:border-opacity-100 {\n    --border-opacity: 1;\n  }\n  .xl\\:hover\\:border-opacity-0:hover {\n    --border-opacity: 0;\n  }\n  .xl\\:hover\\:border-opacity-25:hover {\n    --border-opacity: 0.25;\n  }\n  .xl\\:hover\\:border-opacity-50:hover {\n    --border-opacity: 0.5;\n  }\n  .xl\\:hover\\:border-opacity-75:hover {\n    --border-opacity: 0.75;\n  }\n  .xl\\:hover\\:border-opacity-100:hover {\n    --border-opacity: 1;\n  }\n  .xl\\:focus\\:border-opacity-0:focus {\n    --border-opacity: 0;\n  }\n  .xl\\:focus\\:border-opacity-25:focus {\n    --border-opacity: 0.25;\n  }\n  .xl\\:focus\\:border-opacity-50:focus {\n    --border-opacity: 0.5;\n  }\n  .xl\\:focus\\:border-opacity-75:focus {\n    --border-opacity: 0.75;\n  }\n  .xl\\:focus\\:border-opacity-100:focus {\n    --border-opacity: 1;\n  }\n  .xl\\:rounded-none {\n    border-radius: 0;\n  }\n  .xl\\:rounded-sm {\n    border-radius: 0.125rem;\n  }\n  .xl\\:rounded {\n    border-radius: 0.25rem;\n  }\n  .xl\\:rounded-md {\n    border-radius: 0.375rem;\n  }\n  .xl\\:rounded-lg {\n    border-radius: 0.5rem;\n  }\n  .xl\\:rounded-xl {\n    border-radius: 0.75rem;\n  }\n  .xl\\:rounded-2xl {\n    border-radius: 1rem;\n  }\n  .xl\\:rounded-3xl {\n    border-radius: 1.5rem;\n  }\n  .xl\\:rounded-full {\n    border-radius: 9999px;\n  }\n  .xl\\:rounded-t-none {\n    border-top-left-radius: 0;\n    border-top-right-radius: 0;\n  }\n  .xl\\:rounded-r-none {\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0;\n  }\n  .xl\\:rounded-b-none {\n    border-bottom-right-radius: 0;\n    border-bottom-left-radius: 0;\n  }\n  .xl\\:rounded-l-none {\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0;\n  }\n  .xl\\:rounded-t-sm {\n    border-top-left-radius: 0.125rem;\n    border-top-right-radius: 0.125rem;\n  }\n  .xl\\:rounded-r-sm {\n    border-top-right-radius: 0.125rem;\n    border-bottom-right-radius: 0.125rem;\n  }\n  .xl\\:rounded-b-sm {\n    border-bottom-right-radius: 0.125rem;\n    border-bottom-left-radius: 0.125rem;\n  }\n  .xl\\:rounded-l-sm {\n    border-top-left-radius: 0.125rem;\n    border-bottom-left-radius: 0.125rem;\n  }\n  .xl\\:rounded-t {\n    border-top-left-radius: 0.25rem;\n    border-top-right-radius: 0.25rem;\n  }\n  .xl\\:rounded-r {\n    border-top-right-radius: 0.25rem;\n    border-bottom-right-radius: 0.25rem;\n  }\n  .xl\\:rounded-b {\n    border-bottom-right-radius: 0.25rem;\n    border-bottom-left-radius: 0.25rem;\n  }\n  .xl\\:rounded-l {\n    border-top-left-radius: 0.25rem;\n    border-bottom-left-radius: 0.25rem;\n  }\n  .xl\\:rounded-t-md {\n    border-top-left-radius: 0.375rem;\n    border-top-right-radius: 0.375rem;\n  }\n  .xl\\:rounded-r-md {\n    border-top-right-radius: 0.375rem;\n    border-bottom-right-radius: 0.375rem;\n  }\n  .xl\\:rounded-b-md {\n    border-bottom-right-radius: 0.375rem;\n    border-bottom-left-radius: 0.375rem;\n  }\n  .xl\\:rounded-l-md {\n    border-top-left-radius: 0.375rem;\n    border-bottom-left-radius: 0.375rem;\n  }\n  .xl\\:rounded-t-lg {\n    border-top-left-radius: 0.5rem;\n    border-top-right-radius: 0.5rem;\n  }\n  .xl\\:rounded-r-lg {\n    border-top-right-radius: 0.5rem;\n    border-bottom-right-radius: 0.5rem;\n  }\n  .xl\\:rounded-b-lg {\n    border-bottom-right-radius: 0.5rem;\n    border-bottom-left-radius: 0.5rem;\n  }\n  .xl\\:rounded-l-lg {\n    border-top-left-radius: 0.5rem;\n    border-bottom-left-radius: 0.5rem;\n  }\n  .xl\\:rounded-t-xl {\n    border-top-left-radius: 0.75rem;\n    border-top-right-radius: 0.75rem;\n  }\n  .xl\\:rounded-r-xl {\n    border-top-right-radius: 0.75rem;\n    border-bottom-right-radius: 0.75rem;\n  }\n  .xl\\:rounded-b-xl {\n    border-bottom-right-radius: 0.75rem;\n    border-bottom-left-radius: 0.75rem;\n  }\n  .xl\\:rounded-l-xl {\n    border-top-left-radius: 0.75rem;\n    border-bottom-left-radius: 0.75rem;\n  }\n  .xl\\:rounded-t-2xl {\n    border-top-left-radius: 1rem;\n    border-top-right-radius: 1rem;\n  }\n  .xl\\:rounded-r-2xl {\n    border-top-right-radius: 1rem;\n    border-bottom-right-radius: 1rem;\n  }\n  .xl\\:rounded-b-2xl {\n    border-bottom-right-radius: 1rem;\n    border-bottom-left-radius: 1rem;\n  }\n  .xl\\:rounded-l-2xl {\n    border-top-left-radius: 1rem;\n    border-bottom-left-radius: 1rem;\n  }\n  .xl\\:rounded-t-3xl {\n    border-top-left-radius: 1.5rem;\n    border-top-right-radius: 1.5rem;\n  }\n  .xl\\:rounded-r-3xl {\n    border-top-right-radius: 1.5rem;\n    border-bottom-right-radius: 1.5rem;\n  }\n  .xl\\:rounded-b-3xl {\n    border-bottom-right-radius: 1.5rem;\n    border-bottom-left-radius: 1.5rem;\n  }\n  .xl\\:rounded-l-3xl {\n    border-top-left-radius: 1.5rem;\n    border-bottom-left-radius: 1.5rem;\n  }\n  .xl\\:rounded-t-full {\n    border-top-left-radius: 9999px;\n    border-top-right-radius: 9999px;\n  }\n  .xl\\:rounded-r-full {\n    border-top-right-radius: 9999px;\n    border-bottom-right-radius: 9999px;\n  }\n  .xl\\:rounded-b-full {\n    border-bottom-right-radius: 9999px;\n    border-bottom-left-radius: 9999px;\n  }\n  .xl\\:rounded-l-full {\n    border-top-left-radius: 9999px;\n    border-bottom-left-radius: 9999px;\n  }\n  .xl\\:rounded-tl-none {\n    border-top-left-radius: 0;\n  }\n  .xl\\:rounded-tr-none {\n    border-top-right-radius: 0;\n  }\n  .xl\\:rounded-br-none {\n    border-bottom-right-radius: 0;\n  }\n  .xl\\:rounded-bl-none {\n    border-bottom-left-radius: 0;\n  }\n  .xl\\:rounded-tl-sm {\n    border-top-left-radius: 0.125rem;\n  }\n  .xl\\:rounded-tr-sm {\n    border-top-right-radius: 0.125rem;\n  }\n  .xl\\:rounded-br-sm {\n    border-bottom-right-radius: 0.125rem;\n  }\n  .xl\\:rounded-bl-sm {\n    border-bottom-left-radius: 0.125rem;\n  }\n  .xl\\:rounded-tl {\n    border-top-left-radius: 0.25rem;\n  }\n  .xl\\:rounded-tr {\n    border-top-right-radius: 0.25rem;\n  }\n  .xl\\:rounded-br {\n    border-bottom-right-radius: 0.25rem;\n  }\n  .xl\\:rounded-bl {\n    border-bottom-left-radius: 0.25rem;\n  }\n  .xl\\:rounded-tl-md {\n    border-top-left-radius: 0.375rem;\n  }\n  .xl\\:rounded-tr-md {\n    border-top-right-radius: 0.375rem;\n  }\n  .xl\\:rounded-br-md {\n    border-bottom-right-radius: 0.375rem;\n  }\n  .xl\\:rounded-bl-md {\n    border-bottom-left-radius: 0.375rem;\n  }\n  .xl\\:rounded-tl-lg {\n    border-top-left-radius: 0.5rem;\n  }\n  .xl\\:rounded-tr-lg {\n    border-top-right-radius: 0.5rem;\n  }\n  .xl\\:rounded-br-lg {\n    border-bottom-right-radius: 0.5rem;\n  }\n  .xl\\:rounded-bl-lg {\n    border-bottom-left-radius: 0.5rem;\n  }\n  .xl\\:rounded-tl-xl {\n    border-top-left-radius: 0.75rem;\n  }\n  .xl\\:rounded-tr-xl {\n    border-top-right-radius: 0.75rem;\n  }\n  .xl\\:rounded-br-xl {\n    border-bottom-right-radius: 0.75rem;\n  }\n  .xl\\:rounded-bl-xl {\n    border-bottom-left-radius: 0.75rem;\n  }\n  .xl\\:rounded-tl-2xl {\n    border-top-left-radius: 1rem;\n  }\n  .xl\\:rounded-tr-2xl {\n    border-top-right-radius: 1rem;\n  }\n  .xl\\:rounded-br-2xl {\n    border-bottom-right-radius: 1rem;\n  }\n  .xl\\:rounded-bl-2xl {\n    border-bottom-left-radius: 1rem;\n  }\n  .xl\\:rounded-tl-3xl {\n    border-top-left-radius: 1.5rem;\n  }\n  .xl\\:rounded-tr-3xl {\n    border-top-right-radius: 1.5rem;\n  }\n  .xl\\:rounded-br-3xl {\n    border-bottom-right-radius: 1.5rem;\n  }\n  .xl\\:rounded-bl-3xl {\n    border-bottom-left-radius: 1.5rem;\n  }\n  .xl\\:rounded-tl-full {\n    border-top-left-radius: 9999px;\n  }\n  .xl\\:rounded-tr-full {\n    border-top-right-radius: 9999px;\n  }\n  .xl\\:rounded-br-full {\n    border-bottom-right-radius: 9999px;\n  }\n  .xl\\:rounded-bl-full {\n    border-bottom-left-radius: 9999px;\n  }\n  .xl\\:border-solid {\n    border-style: solid;\n  }\n  .xl\\:border-dashed {\n    border-style: dashed;\n  }\n  .xl\\:border-dotted {\n    border-style: dotted;\n  }\n  .xl\\:border-double {\n    border-style: double;\n  }\n  .xl\\:border-none {\n    border-style: none;\n  }\n  .xl\\:border-0 {\n    border-width: 0;\n  }\n  .xl\\:border-2 {\n    border-width: 2px;\n  }\n  .xl\\:border-4 {\n    border-width: 4px;\n  }\n  .xl\\:border-8 {\n    border-width: 8px;\n  }\n  .xl\\:border {\n    border-width: 1px;\n  }\n  .xl\\:border-t-0 {\n    border-top-width: 0;\n  }\n  .xl\\:border-r-0 {\n    border-right-width: 0;\n  }\n  .xl\\:border-b-0 {\n    border-bottom-width: 0;\n  }\n  .xl\\:border-l-0 {\n    border-left-width: 0;\n  }\n  .xl\\:border-t-2 {\n    border-top-width: 2px;\n  }\n  .xl\\:border-r-2 {\n    border-right-width: 2px;\n  }\n  .xl\\:border-b-2 {\n    border-bottom-width: 2px;\n  }\n  .xl\\:border-l-2 {\n    border-left-width: 2px;\n  }\n  .xl\\:border-t-4 {\n    border-top-width: 4px;\n  }\n  .xl\\:border-r-4 {\n    border-right-width: 4px;\n  }\n  .xl\\:border-b-4 {\n    border-bottom-width: 4px;\n  }\n  .xl\\:border-l-4 {\n    border-left-width: 4px;\n  }\n  .xl\\:border-t-8 {\n    border-top-width: 8px;\n  }\n  .xl\\:border-r-8 {\n    border-right-width: 8px;\n  }\n  .xl\\:border-b-8 {\n    border-bottom-width: 8px;\n  }\n  .xl\\:border-l-8 {\n    border-left-width: 8px;\n  }\n  .xl\\:border-t {\n    border-top-width: 1px;\n  }\n  .xl\\:border-r {\n    border-right-width: 1px;\n  }\n  .xl\\:border-b {\n    border-bottom-width: 1px;\n  }\n  .xl\\:border-l {\n    border-left-width: 1px;\n  }\n  .xl\\:box-border {\n    box-sizing: border-box;\n  }\n  .xl\\:box-content {\n    box-sizing: content-box;\n  }\n  .xl\\:cursor-auto {\n    cursor: auto;\n  }\n  .xl\\:cursor-default {\n    cursor: default;\n  }\n  .xl\\:cursor-pointer {\n    cursor: pointer;\n  }\n  .xl\\:cursor-wait {\n    cursor: wait;\n  }\n  .xl\\:cursor-text {\n    cursor: text;\n  }\n  .xl\\:cursor-move {\n    cursor: move;\n  }\n  .xl\\:cursor-not-allowed {\n    cursor: not-allowed;\n  }\n  .xl\\:block {\n    display: block;\n  }\n  .xl\\:inline-block {\n    display: inline-block;\n  }\n  .xl\\:inline {\n    display: inline;\n  }\n  .xl\\:flex {\n    display: flex;\n  }\n  .xl\\:inline-flex {\n    display: inline-flex;\n  }\n  .xl\\:table {\n    display: table;\n  }\n  .xl\\:table-caption {\n    display: table-caption;\n  }\n  .xl\\:table-cell {\n    display: table-cell;\n  }\n  .xl\\:table-column {\n    display: table-column;\n  }\n  .xl\\:table-column-group {\n    display: table-column-group;\n  }\n  .xl\\:table-footer-group {\n    display: table-footer-group;\n  }\n  .xl\\:table-header-group {\n    display: table-header-group;\n  }\n  .xl\\:table-row-group {\n    display: table-row-group;\n  }\n  .xl\\:table-row {\n    display: table-row;\n  }\n  .xl\\:flow-root {\n    display: flow-root;\n  }\n  .xl\\:grid {\n    display: grid;\n  }\n  .xl\\:inline-grid {\n    display: inline-grid;\n  }\n  .xl\\:contents {\n    display: contents;\n  }\n  .xl\\:hidden {\n    display: none;\n  }\n  .xl\\:flex-row {\n    flex-direction: row;\n  }\n  .xl\\:flex-row-reverse {\n    flex-direction: row-reverse;\n  }\n  .xl\\:flex-col {\n    flex-direction: column;\n  }\n  .xl\\:flex-col-reverse {\n    flex-direction: column-reverse;\n  }\n  .xl\\:flex-wrap {\n    flex-wrap: wrap;\n  }\n  .xl\\:flex-wrap-reverse {\n    flex-wrap: wrap-reverse;\n  }\n  .xl\\:flex-no-wrap {\n    flex-wrap: nowrap;\n  }\n  .xl\\:place-items-auto {\n    place-items: auto;\n  }\n  .xl\\:place-items-start {\n    place-items: start;\n  }\n  .xl\\:place-items-end {\n    place-items: end;\n  }\n  .xl\\:place-items-center {\n    place-items: center;\n  }\n  .xl\\:place-items-stretch {\n    place-items: stretch;\n  }\n  .xl\\:place-content-center {\n    place-content: center;\n  }\n  .xl\\:place-content-start {\n    place-content: start;\n  }\n  .xl\\:place-content-end {\n    place-content: end;\n  }\n  .xl\\:place-content-between {\n    place-content: space-between;\n  }\n  .xl\\:place-content-around {\n    place-content: space-around;\n  }\n  .xl\\:place-content-evenly {\n    place-content: space-evenly;\n  }\n  .xl\\:place-content-stretch {\n    place-content: stretch;\n  }\n  .xl\\:place-self-auto {\n    place-self: auto;\n  }\n  .xl\\:place-self-start {\n    place-self: start;\n  }\n  .xl\\:place-self-end {\n    place-self: end;\n  }\n  .xl\\:place-self-center {\n    place-self: center;\n  }\n  .xl\\:place-self-stretch {\n    place-self: stretch;\n  }\n  .xl\\:items-start {\n    align-items: flex-start;\n  }\n  .xl\\:items-end {\n    align-items: flex-end;\n  }\n  .xl\\:items-center {\n    align-items: center;\n  }\n  .xl\\:items-baseline {\n    align-items: baseline;\n  }\n  .xl\\:items-stretch {\n    align-items: stretch;\n  }\n  .xl\\:content-center {\n    align-content: center;\n  }\n  .xl\\:content-start {\n    align-content: flex-start;\n  }\n  .xl\\:content-end {\n    align-content: flex-end;\n  }\n  .xl\\:content-between {\n    align-content: space-between;\n  }\n  .xl\\:content-around {\n    align-content: space-around;\n  }\n  .xl\\:content-evenly {\n    align-content: space-evenly;\n  }\n  .xl\\:self-auto {\n    align-self: auto;\n  }\n  .xl\\:self-start {\n    align-self: flex-start;\n  }\n  .xl\\:self-end {\n    align-self: flex-end;\n  }\n  .xl\\:self-center {\n    align-self: center;\n  }\n  .xl\\:self-stretch {\n    align-self: stretch;\n  }\n  .xl\\:justify-items-auto {\n    justify-items: auto;\n  }\n  .xl\\:justify-items-start {\n    justify-items: start;\n  }\n  .xl\\:justify-items-end {\n    justify-items: end;\n  }\n  .xl\\:justify-items-center {\n    justify-items: center;\n  }\n  .xl\\:justify-items-stretch {\n    justify-items: stretch;\n  }\n  .xl\\:justify-start {\n    justify-content: flex-start;\n  }\n  .xl\\:justify-end {\n    justify-content: flex-end;\n  }\n  .xl\\:justify-center {\n    justify-content: center;\n  }\n  .xl\\:justify-between {\n    justify-content: space-between;\n  }\n  .xl\\:justify-around {\n    justify-content: space-around;\n  }\n  .xl\\:justify-evenly {\n    justify-content: space-evenly;\n  }\n  .xl\\:justify-self-auto {\n    justify-self: auto;\n  }\n  .xl\\:justify-self-start {\n    justify-self: start;\n  }\n  .xl\\:justify-self-end {\n    justify-self: end;\n  }\n  .xl\\:justify-self-center {\n    justify-self: center;\n  }\n  .xl\\:justify-self-stretch {\n    justify-self: stretch;\n  }\n  .xl\\:flex-1 {\n    flex: 1 1 0%;\n  }\n  .xl\\:flex-auto {\n    flex: 1 1 auto;\n  }\n  .xl\\:flex-initial {\n    flex: 0 1 auto;\n  }\n  .xl\\:flex-none {\n    flex: none;\n  }\n  .xl\\:flex-grow-0 {\n    flex-grow: 0;\n  }\n  .xl\\:flex-grow {\n    flex-grow: 1;\n  }\n  .xl\\:flex-shrink-0 {\n    flex-shrink: 0;\n  }\n  .xl\\:flex-shrink {\n    flex-shrink: 1;\n  }\n  .xl\\:order-1 {\n    order: 1;\n  }\n  .xl\\:order-2 {\n    order: 2;\n  }\n  .xl\\:order-3 {\n    order: 3;\n  }\n  .xl\\:order-4 {\n    order: 4;\n  }\n  .xl\\:order-5 {\n    order: 5;\n  }\n  .xl\\:order-6 {\n    order: 6;\n  }\n  .xl\\:order-7 {\n    order: 7;\n  }\n  .xl\\:order-8 {\n    order: 8;\n  }\n  .xl\\:order-9 {\n    order: 9;\n  }\n  .xl\\:order-10 {\n    order: 10;\n  }\n  .xl\\:order-11 {\n    order: 11;\n  }\n  .xl\\:order-12 {\n    order: 12;\n  }\n  .xl\\:order-first {\n    order: -9999;\n  }\n  .xl\\:order-last {\n    order: 9999;\n  }\n  .xl\\:order-none {\n    order: 0;\n  }\n  .xl\\:float-right {\n    float: right;\n  }\n  .xl\\:float-left {\n    float: left;\n  }\n  .xl\\:float-none {\n    float: none;\n  }\n  .xl\\:clearfix:after {\n    content: \"\";\n    display: table;\n    clear: both;\n  }\n  .xl\\:clear-left {\n    clear: left;\n  }\n  .xl\\:clear-right {\n    clear: right;\n  }\n  .xl\\:clear-both {\n    clear: both;\n  }\n  .xl\\:clear-none {\n    clear: none;\n  }\n  .xl\\:font-sans {\n    font-family: system-ui, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, \"Noto Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n  }\n  .xl\\:font-serif {\n    font-family: Georgia, Cambria, \"Times New Roman\", Times, serif;\n  }\n  .xl\\:font-mono {\n    font-family: Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace;\n  }\n  .xl\\:font-hairline {\n    font-weight: 100;\n  }\n  .xl\\:font-thin {\n    font-weight: 200;\n  }\n  .xl\\:font-light {\n    font-weight: 300;\n  }\n  .xl\\:font-normal {\n    font-weight: 400;\n  }\n  .xl\\:font-medium {\n    font-weight: 500;\n  }\n  .xl\\:font-semibold {\n    font-weight: 600;\n  }\n  .xl\\:font-bold {\n    font-weight: 700;\n  }\n  .xl\\:font-extrabold {\n    font-weight: 800;\n  }\n  .xl\\:font-black {\n    font-weight: 900;\n  }\n  .xl\\:hover\\:font-hairline:hover {\n    font-weight: 100;\n  }\n  .xl\\:hover\\:font-thin:hover {\n    font-weight: 200;\n  }\n  .xl\\:hover\\:font-light:hover {\n    font-weight: 300;\n  }\n  .xl\\:hover\\:font-normal:hover {\n    font-weight: 400;\n  }\n  .xl\\:hover\\:font-medium:hover {\n    font-weight: 500;\n  }\n  .xl\\:hover\\:font-semibold:hover {\n    font-weight: 600;\n  }\n  .xl\\:hover\\:font-bold:hover {\n    font-weight: 700;\n  }\n  .xl\\:hover\\:font-extrabold:hover {\n    font-weight: 800;\n  }\n  .xl\\:hover\\:font-black:hover {\n    font-weight: 900;\n  }\n  .xl\\:focus\\:font-hairline:focus {\n    font-weight: 100;\n  }\n  .xl\\:focus\\:font-thin:focus {\n    font-weight: 200;\n  }\n  .xl\\:focus\\:font-light:focus {\n    font-weight: 300;\n  }\n  .xl\\:focus\\:font-normal:focus {\n    font-weight: 400;\n  }\n  .xl\\:focus\\:font-medium:focus {\n    font-weight: 500;\n  }\n  .xl\\:focus\\:font-semibold:focus {\n    font-weight: 600;\n  }\n  .xl\\:focus\\:font-bold:focus {\n    font-weight: 700;\n  }\n  .xl\\:focus\\:font-extrabold:focus {\n    font-weight: 800;\n  }\n  .xl\\:focus\\:font-black:focus {\n    font-weight: 900;\n  }\n  .xl\\:h-0 {\n    height: 0;\n  }\n  .xl\\:h-1 {\n    height: 0.25rem;\n  }\n  .xl\\:h-2 {\n    height: 0.5rem;\n  }\n  .xl\\:h-3 {\n    height: 0.75rem;\n  }\n  .xl\\:h-4 {\n    height: 1rem;\n  }\n  .xl\\:h-5 {\n    height: 1.25rem;\n  }\n  .xl\\:h-6 {\n    height: 1.5rem;\n  }\n  .xl\\:h-7 {\n    height: 1.75rem;\n  }\n  .xl\\:h-8 {\n    height: 2rem;\n  }\n  .xl\\:h-9 {\n    height: 2.25rem;\n  }\n  .xl\\:h-10 {\n    height: 2.5rem;\n  }\n  .xl\\:h-11 {\n    height: 2.75rem;\n  }\n  .xl\\:h-12 {\n    height: 3rem;\n  }\n  .xl\\:h-13 {\n    height: 3.25rem;\n  }\n  .xl\\:h-14 {\n    height: 3.5rem;\n  }\n  .xl\\:h-15 {\n    height: 3.75rem;\n  }\n  .xl\\:h-16 {\n    height: 4rem;\n  }\n  .xl\\:h-20 {\n    height: 5rem;\n  }\n  .xl\\:h-24 {\n    height: 6rem;\n  }\n  .xl\\:h-28 {\n    height: 7rem;\n  }\n  .xl\\:h-32 {\n    height: 8rem;\n  }\n  .xl\\:h-36 {\n    height: 9rem;\n  }\n  .xl\\:h-40 {\n    height: 10rem;\n  }\n  .xl\\:h-44 {\n    height: 11rem;\n  }\n  .xl\\:h-48 {\n    height: 12rem;\n  }\n  .xl\\:h-52 {\n    height: 13rem;\n  }\n  .xl\\:h-56 {\n    height: 14rem;\n  }\n  .xl\\:h-60 {\n    height: 15rem;\n  }\n  .xl\\:h-64 {\n    height: 16rem;\n  }\n  .xl\\:h-72 {\n    height: 18rem;\n  }\n  .xl\\:h-80 {\n    height: 20rem;\n  }\n  .xl\\:h-96 {\n    height: 24rem;\n  }\n  .xl\\:h-auto {\n    height: auto;\n  }\n  .xl\\:h-px {\n    height: 1px;\n  }\n  .xl\\:h-0\\.5 {\n    height: 0.125rem;\n  }\n  .xl\\:h-1\\.5 {\n    height: 0.375rem;\n  }\n  .xl\\:h-2\\.5 {\n    height: 0.625rem;\n  }\n  .xl\\:h-3\\.5 {\n    height: 0.875rem;\n  }\n  .xl\\:h-1\\/2 {\n    height: 50%;\n  }\n  .xl\\:h-1\\/3 {\n    height: 33.333333%;\n  }\n  .xl\\:h-2\\/3 {\n    height: 66.666667%;\n  }\n  .xl\\:h-1\\/4 {\n    height: 25%;\n  }\n  .xl\\:h-2\\/4 {\n    height: 50%;\n  }\n  .xl\\:h-3\\/4 {\n    height: 75%;\n  }\n  .xl\\:h-1\\/5 {\n    height: 20%;\n  }\n  .xl\\:h-2\\/5 {\n    height: 40%;\n  }\n  .xl\\:h-3\\/5 {\n    height: 60%;\n  }\n  .xl\\:h-4\\/5 {\n    height: 80%;\n  }\n  .xl\\:h-1\\/6 {\n    height: 16.666667%;\n  }\n  .xl\\:h-2\\/6 {\n    height: 33.333333%;\n  }\n  .xl\\:h-3\\/6 {\n    height: 50%;\n  }\n  .xl\\:h-4\\/6 {\n    height: 66.666667%;\n  }\n  .xl\\:h-5\\/6 {\n    height: 83.333333%;\n  }\n  .xl\\:h-1\\/12 {\n    height: 8.333333%;\n  }\n  .xl\\:h-2\\/12 {\n    height: 16.666667%;\n  }\n  .xl\\:h-3\\/12 {\n    height: 25%;\n  }\n  .xl\\:h-4\\/12 {\n    height: 33.333333%;\n  }\n  .xl\\:h-5\\/12 {\n    height: 41.666667%;\n  }\n  .xl\\:h-6\\/12 {\n    height: 50%;\n  }\n  .xl\\:h-7\\/12 {\n    height: 58.333333%;\n  }\n  .xl\\:h-8\\/12 {\n    height: 66.666667%;\n  }\n  .xl\\:h-9\\/12 {\n    height: 75%;\n  }\n  .xl\\:h-10\\/12 {\n    height: 83.333333%;\n  }\n  .xl\\:h-11\\/12 {\n    height: 91.666667%;\n  }\n  .xl\\:h-full {\n    height: 100%;\n  }\n  .xl\\:h-screen {\n    height: 100vh;\n  }\n  .xl\\:text-xs {\n    font-size: 0.75rem;\n  }\n  .xl\\:text-sm {\n    font-size: 0.875rem;\n  }\n  .xl\\:text-base {\n    font-size: 1rem;\n  }\n  .xl\\:text-lg {\n    font-size: 1.125rem;\n  }\n  .xl\\:text-xl {\n    font-size: 1.25rem;\n  }\n  .xl\\:text-2xl {\n    font-size: 1.5rem;\n  }\n  .xl\\:text-3xl {\n    font-size: 1.875rem;\n  }\n  .xl\\:text-4xl {\n    font-size: 2.25rem;\n  }\n  .xl\\:text-5xl {\n    font-size: 3rem;\n  }\n  .xl\\:text-6xl {\n    font-size: 4rem;\n  }\n  .xl\\:leading-3 {\n    line-height: .75rem;\n  }\n  .xl\\:leading-4 {\n    line-height: 1rem;\n  }\n  .xl\\:leading-5 {\n    line-height: 1.25rem;\n  }\n  .xl\\:leading-6 {\n    line-height: 1.5rem;\n  }\n  .xl\\:leading-7 {\n    line-height: 1.75rem;\n  }\n  .xl\\:leading-8 {\n    line-height: 2rem;\n  }\n  .xl\\:leading-9 {\n    line-height: 2.25rem;\n  }\n  .xl\\:leading-10 {\n    line-height: 2.5rem;\n  }\n  .xl\\:leading-none {\n    line-height: 1;\n  }\n  .xl\\:leading-tight {\n    line-height: 1.25;\n  }\n  .xl\\:leading-snug {\n    line-height: 1.375;\n  }\n  .xl\\:leading-normal {\n    line-height: 1.5;\n  }\n  .xl\\:leading-relaxed {\n    line-height: 1.625;\n  }\n  .xl\\:leading-loose {\n    line-height: 2;\n  }\n  .xl\\:list-inside {\n    list-style-position: inside;\n  }\n  .xl\\:list-outside {\n    list-style-position: outside;\n  }\n  .xl\\:list-none {\n    list-style-type: none;\n  }\n  .xl\\:list-disc {\n    list-style-type: disc;\n  }\n  .xl\\:list-decimal {\n    list-style-type: decimal;\n  }\n  .xl\\:m-0 {\n    margin: 0;\n  }\n  .xl\\:m-1 {\n    margin: 0.25rem;\n  }\n  .xl\\:m-2 {\n    margin: 0.5rem;\n  }\n  .xl\\:m-3 {\n    margin: 0.75rem;\n  }\n  .xl\\:m-4 {\n    margin: 1rem;\n  }\n  .xl\\:m-5 {\n    margin: 1.25rem;\n  }\n  .xl\\:m-6 {\n    margin: 1.5rem;\n  }\n  .xl\\:m-7 {\n    margin: 1.75rem;\n  }\n  .xl\\:m-8 {\n    margin: 2rem;\n  }\n  .xl\\:m-9 {\n    margin: 2.25rem;\n  }\n  .xl\\:m-10 {\n    margin: 2.5rem;\n  }\n  .xl\\:m-11 {\n    margin: 2.75rem;\n  }\n  .xl\\:m-12 {\n    margin: 3rem;\n  }\n  .xl\\:m-13 {\n    margin: 3.25rem;\n  }\n  .xl\\:m-14 {\n    margin: 3.5rem;\n  }\n  .xl\\:m-15 {\n    margin: 3.75rem;\n  }\n  .xl\\:m-16 {\n    margin: 4rem;\n  }\n  .xl\\:m-20 {\n    margin: 5rem;\n  }\n  .xl\\:m-24 {\n    margin: 6rem;\n  }\n  .xl\\:m-28 {\n    margin: 7rem;\n  }\n  .xl\\:m-32 {\n    margin: 8rem;\n  }\n  .xl\\:m-36 {\n    margin: 9rem;\n  }\n  .xl\\:m-40 {\n    margin: 10rem;\n  }\n  .xl\\:m-44 {\n    margin: 11rem;\n  }\n  .xl\\:m-48 {\n    margin: 12rem;\n  }\n  .xl\\:m-52 {\n    margin: 13rem;\n  }\n  .xl\\:m-56 {\n    margin: 14rem;\n  }\n  .xl\\:m-60 {\n    margin: 15rem;\n  }\n  .xl\\:m-64 {\n    margin: 16rem;\n  }\n  .xl\\:m-72 {\n    margin: 18rem;\n  }\n  .xl\\:m-80 {\n    margin: 20rem;\n  }\n  .xl\\:m-96 {\n    margin: 24rem;\n  }\n  .xl\\:m-auto {\n    margin: auto;\n  }\n  .xl\\:m-px {\n    margin: 1px;\n  }\n  .xl\\:m-0\\.5 {\n    margin: 0.125rem;\n  }\n  .xl\\:m-1\\.5 {\n    margin: 0.375rem;\n  }\n  .xl\\:m-2\\.5 {\n    margin: 0.625rem;\n  }\n  .xl\\:m-3\\.5 {\n    margin: 0.875rem;\n  }\n  .xl\\:m-1\\/2 {\n    margin: 50%;\n  }\n  .xl\\:m-1\\/3 {\n    margin: 33.333333%;\n  }\n  .xl\\:m-2\\/3 {\n    margin: 66.666667%;\n  }\n  .xl\\:m-1\\/4 {\n    margin: 25%;\n  }\n  .xl\\:m-2\\/4 {\n    margin: 50%;\n  }\n  .xl\\:m-3\\/4 {\n    margin: 75%;\n  }\n  .xl\\:m-1\\/5 {\n    margin: 20%;\n  }\n  .xl\\:m-2\\/5 {\n    margin: 40%;\n  }\n  .xl\\:m-3\\/5 {\n    margin: 60%;\n  }\n  .xl\\:m-4\\/5 {\n    margin: 80%;\n  }\n  .xl\\:m-1\\/6 {\n    margin: 16.666667%;\n  }\n  .xl\\:m-2\\/6 {\n    margin: 33.333333%;\n  }\n  .xl\\:m-3\\/6 {\n    margin: 50%;\n  }\n  .xl\\:m-4\\/6 {\n    margin: 66.666667%;\n  }\n  .xl\\:m-5\\/6 {\n    margin: 83.333333%;\n  }\n  .xl\\:m-1\\/12 {\n    margin: 8.333333%;\n  }\n  .xl\\:m-2\\/12 {\n    margin: 16.666667%;\n  }\n  .xl\\:m-3\\/12 {\n    margin: 25%;\n  }\n  .xl\\:m-4\\/12 {\n    margin: 33.333333%;\n  }\n  .xl\\:m-5\\/12 {\n    margin: 41.666667%;\n  }\n  .xl\\:m-6\\/12 {\n    margin: 50%;\n  }\n  .xl\\:m-7\\/12 {\n    margin: 58.333333%;\n  }\n  .xl\\:m-8\\/12 {\n    margin: 66.666667%;\n  }\n  .xl\\:m-9\\/12 {\n    margin: 75%;\n  }\n  .xl\\:m-10\\/12 {\n    margin: 83.333333%;\n  }\n  .xl\\:m-11\\/12 {\n    margin: 91.666667%;\n  }\n  .xl\\:m-full {\n    margin: 100%;\n  }\n  .xl\\:-m-1 {\n    margin: -0.25rem;\n  }\n  .xl\\:-m-2 {\n    margin: -0.5rem;\n  }\n  .xl\\:-m-3 {\n    margin: -0.75rem;\n  }\n  .xl\\:-m-4 {\n    margin: -1rem;\n  }\n  .xl\\:-m-5 {\n    margin: -1.25rem;\n  }\n  .xl\\:-m-6 {\n    margin: -1.5rem;\n  }\n  .xl\\:-m-7 {\n    margin: -1.75rem;\n  }\n  .xl\\:-m-8 {\n    margin: -2rem;\n  }\n  .xl\\:-m-9 {\n    margin: -2.25rem;\n  }\n  .xl\\:-m-10 {\n    margin: -2.5rem;\n  }\n  .xl\\:-m-11 {\n    margin: -2.75rem;\n  }\n  .xl\\:-m-12 {\n    margin: -3rem;\n  }\n  .xl\\:-m-13 {\n    margin: -3.25rem;\n  }\n  .xl\\:-m-14 {\n    margin: -3.5rem;\n  }\n  .xl\\:-m-15 {\n    margin: -3.75rem;\n  }\n  .xl\\:-m-16 {\n    margin: -4rem;\n  }\n  .xl\\:-m-20 {\n    margin: -5rem;\n  }\n  .xl\\:-m-24 {\n    margin: -6rem;\n  }\n  .xl\\:-m-28 {\n    margin: -7rem;\n  }\n  .xl\\:-m-32 {\n    margin: -8rem;\n  }\n  .xl\\:-m-36 {\n    margin: -9rem;\n  }\n  .xl\\:-m-40 {\n    margin: -10rem;\n  }\n  .xl\\:-m-44 {\n    margin: -11rem;\n  }\n  .xl\\:-m-48 {\n    margin: -12rem;\n  }\n  .xl\\:-m-52 {\n    margin: -13rem;\n  }\n  .xl\\:-m-56 {\n    margin: -14rem;\n  }\n  .xl\\:-m-60 {\n    margin: -15rem;\n  }\n  .xl\\:-m-64 {\n    margin: -16rem;\n  }\n  .xl\\:-m-72 {\n    margin: -18rem;\n  }\n  .xl\\:-m-80 {\n    margin: -20rem;\n  }\n  .xl\\:-m-96 {\n    margin: -24rem;\n  }\n  .xl\\:-m-px {\n    margin: -1px;\n  }\n  .xl\\:-m-0\\.5 {\n    margin: -0.125rem;\n  }\n  .xl\\:-m-1\\.5 {\n    margin: -0.375rem;\n  }\n  .xl\\:-m-2\\.5 {\n    margin: -0.625rem;\n  }\n  .xl\\:-m-3\\.5 {\n    margin: -0.875rem;\n  }\n  .xl\\:-m-1\\/2 {\n    margin: -50%;\n  }\n  .xl\\:-m-1\\/3 {\n    margin: -33.33333%;\n  }\n  .xl\\:-m-2\\/3 {\n    margin: -66.66667%;\n  }\n  .xl\\:-m-1\\/4 {\n    margin: -25%;\n  }\n  .xl\\:-m-2\\/4 {\n    margin: -50%;\n  }\n  .xl\\:-m-3\\/4 {\n    margin: -75%;\n  }\n  .xl\\:-m-1\\/5 {\n    margin: -20%;\n  }\n  .xl\\:-m-2\\/5 {\n    margin: -40%;\n  }\n  .xl\\:-m-3\\/5 {\n    margin: -60%;\n  }\n  .xl\\:-m-4\\/5 {\n    margin: -80%;\n  }\n  .xl\\:-m-1\\/6 {\n    margin: -16.66667%;\n  }\n  .xl\\:-m-2\\/6 {\n    margin: -33.33333%;\n  }\n  .xl\\:-m-3\\/6 {\n    margin: -50%;\n  }\n  .xl\\:-m-4\\/6 {\n    margin: -66.66667%;\n  }\n  .xl\\:-m-5\\/6 {\n    margin: -83.33333%;\n  }\n  .xl\\:-m-1\\/12 {\n    margin: -8.33333%;\n  }\n  .xl\\:-m-2\\/12 {\n    margin: -16.66667%;\n  }\n  .xl\\:-m-3\\/12 {\n    margin: -25%;\n  }\n  .xl\\:-m-4\\/12 {\n    margin: -33.33333%;\n  }\n  .xl\\:-m-5\\/12 {\n    margin: -41.66667%;\n  }\n  .xl\\:-m-6\\/12 {\n    margin: -50%;\n  }\n  .xl\\:-m-7\\/12 {\n    margin: -58.33333%;\n  }\n  .xl\\:-m-8\\/12 {\n    margin: -66.66667%;\n  }\n  .xl\\:-m-9\\/12 {\n    margin: -75%;\n  }\n  .xl\\:-m-10\\/12 {\n    margin: -83.33333%;\n  }\n  .xl\\:-m-11\\/12 {\n    margin: -91.66667%;\n  }\n  .xl\\:-m-full {\n    margin: -100%;\n  }\n  .xl\\:my-0 {\n    margin-top: 0;\n    margin-bottom: 0;\n  }\n  .xl\\:mx-0 {\n    margin-left: 0;\n    margin-right: 0;\n  }\n  .xl\\:my-1 {\n    margin-top: 0.25rem;\n    margin-bottom: 0.25rem;\n  }\n  .xl\\:mx-1 {\n    margin-left: 0.25rem;\n    margin-right: 0.25rem;\n  }\n  .xl\\:my-2 {\n    margin-top: 0.5rem;\n    margin-bottom: 0.5rem;\n  }\n  .xl\\:mx-2 {\n    margin-left: 0.5rem;\n    margin-right: 0.5rem;\n  }\n  .xl\\:my-3 {\n    margin-top: 0.75rem;\n    margin-bottom: 0.75rem;\n  }\n  .xl\\:mx-3 {\n    margin-left: 0.75rem;\n    margin-right: 0.75rem;\n  }\n  .xl\\:my-4 {\n    margin-top: 1rem;\n    margin-bottom: 1rem;\n  }\n  .xl\\:mx-4 {\n    margin-left: 1rem;\n    margin-right: 1rem;\n  }\n  .xl\\:my-5 {\n    margin-top: 1.25rem;\n    margin-bottom: 1.25rem;\n  }\n  .xl\\:mx-5 {\n    margin-left: 1.25rem;\n    margin-right: 1.25rem;\n  }\n  .xl\\:my-6 {\n    margin-top: 1.5rem;\n    margin-bottom: 1.5rem;\n  }\n  .xl\\:mx-6 {\n    margin-left: 1.5rem;\n    margin-right: 1.5rem;\n  }\n  .xl\\:my-7 {\n    margin-top: 1.75rem;\n    margin-bottom: 1.75rem;\n  }\n  .xl\\:mx-7 {\n    margin-left: 1.75rem;\n    margin-right: 1.75rem;\n  }\n  .xl\\:my-8 {\n    margin-top: 2rem;\n    margin-bottom: 2rem;\n  }\n  .xl\\:mx-8 {\n    margin-left: 2rem;\n    margin-right: 2rem;\n  }\n  .xl\\:my-9 {\n    margin-top: 2.25rem;\n    margin-bottom: 2.25rem;\n  }\n  .xl\\:mx-9 {\n    margin-left: 2.25rem;\n    margin-right: 2.25rem;\n  }\n  .xl\\:my-10 {\n    margin-top: 2.5rem;\n    margin-bottom: 2.5rem;\n  }\n  .xl\\:mx-10 {\n    margin-left: 2.5rem;\n    margin-right: 2.5rem;\n  }\n  .xl\\:my-11 {\n    margin-top: 2.75rem;\n    margin-bottom: 2.75rem;\n  }\n  .xl\\:mx-11 {\n    margin-left: 2.75rem;\n    margin-right: 2.75rem;\n  }\n  .xl\\:my-12 {\n    margin-top: 3rem;\n    margin-bottom: 3rem;\n  }\n  .xl\\:mx-12 {\n    margin-left: 3rem;\n    margin-right: 3rem;\n  }\n  .xl\\:my-13 {\n    margin-top: 3.25rem;\n    margin-bottom: 3.25rem;\n  }\n  .xl\\:mx-13 {\n    margin-left: 3.25rem;\n    margin-right: 3.25rem;\n  }\n  .xl\\:my-14 {\n    margin-top: 3.5rem;\n    margin-bottom: 3.5rem;\n  }\n  .xl\\:mx-14 {\n    margin-left: 3.5rem;\n    margin-right: 3.5rem;\n  }\n  .xl\\:my-15 {\n    margin-top: 3.75rem;\n    margin-bottom: 3.75rem;\n  }\n  .xl\\:mx-15 {\n    margin-left: 3.75rem;\n    margin-right: 3.75rem;\n  }\n  .xl\\:my-16 {\n    margin-top: 4rem;\n    margin-bottom: 4rem;\n  }\n  .xl\\:mx-16 {\n    margin-left: 4rem;\n    margin-right: 4rem;\n  }\n  .xl\\:my-20 {\n    margin-top: 5rem;\n    margin-bottom: 5rem;\n  }\n  .xl\\:mx-20 {\n    margin-left: 5rem;\n    margin-right: 5rem;\n  }\n  .xl\\:my-24 {\n    margin-top: 6rem;\n    margin-bottom: 6rem;\n  }\n  .xl\\:mx-24 {\n    margin-left: 6rem;\n    margin-right: 6rem;\n  }\n  .xl\\:my-28 {\n    margin-top: 7rem;\n    margin-bottom: 7rem;\n  }\n  .xl\\:mx-28 {\n    margin-left: 7rem;\n    margin-right: 7rem;\n  }\n  .xl\\:my-32 {\n    margin-top: 8rem;\n    margin-bottom: 8rem;\n  }\n  .xl\\:mx-32 {\n    margin-left: 8rem;\n    margin-right: 8rem;\n  }\n  .xl\\:my-36 {\n    margin-top: 9rem;\n    margin-bottom: 9rem;\n  }\n  .xl\\:mx-36 {\n    margin-left: 9rem;\n    margin-right: 9rem;\n  }\n  .xl\\:my-40 {\n    margin-top: 10rem;\n    margin-bottom: 10rem;\n  }\n  .xl\\:mx-40 {\n    margin-left: 10rem;\n    margin-right: 10rem;\n  }\n  .xl\\:my-44 {\n    margin-top: 11rem;\n    margin-bottom: 11rem;\n  }\n  .xl\\:mx-44 {\n    margin-left: 11rem;\n    margin-right: 11rem;\n  }\n  .xl\\:my-48 {\n    margin-top: 12rem;\n    margin-bottom: 12rem;\n  }\n  .xl\\:mx-48 {\n    margin-left: 12rem;\n    margin-right: 12rem;\n  }\n  .xl\\:my-52 {\n    margin-top: 13rem;\n    margin-bottom: 13rem;\n  }\n  .xl\\:mx-52 {\n    margin-left: 13rem;\n    margin-right: 13rem;\n  }\n  .xl\\:my-56 {\n    margin-top: 14rem;\n    margin-bottom: 14rem;\n  }\n  .xl\\:mx-56 {\n    margin-left: 14rem;\n    margin-right: 14rem;\n  }\n  .xl\\:my-60 {\n    margin-top: 15rem;\n    margin-bottom: 15rem;\n  }\n  .xl\\:mx-60 {\n    margin-left: 15rem;\n    margin-right: 15rem;\n  }\n  .xl\\:my-64 {\n    margin-top: 16rem;\n    margin-bottom: 16rem;\n  }\n  .xl\\:mx-64 {\n    margin-left: 16rem;\n    margin-right: 16rem;\n  }\n  .xl\\:my-72 {\n    margin-top: 18rem;\n    margin-bottom: 18rem;\n  }\n  .xl\\:mx-72 {\n    margin-left: 18rem;\n    margin-right: 18rem;\n  }\n  .xl\\:my-80 {\n    margin-top: 20rem;\n    margin-bottom: 20rem;\n  }\n  .xl\\:mx-80 {\n    margin-left: 20rem;\n    margin-right: 20rem;\n  }\n  .xl\\:my-96 {\n    margin-top: 24rem;\n    margin-bottom: 24rem;\n  }\n  .xl\\:mx-96 {\n    margin-left: 24rem;\n    margin-right: 24rem;\n  }\n  .xl\\:my-auto {\n    margin-top: auto;\n    margin-bottom: auto;\n  }\n  .xl\\:mx-auto {\n    margin-left: auto;\n    margin-right: auto;\n  }\n  .xl\\:my-px {\n    margin-top: 1px;\n    margin-bottom: 1px;\n  }\n  .xl\\:mx-px {\n    margin-left: 1px;\n    margin-right: 1px;\n  }\n  .xl\\:my-0\\.5 {\n    margin-top: 0.125rem;\n    margin-bottom: 0.125rem;\n  }\n  .xl\\:mx-0\\.5 {\n    margin-left: 0.125rem;\n    margin-right: 0.125rem;\n  }\n  .xl\\:my-1\\.5 {\n    margin-top: 0.375rem;\n    margin-bottom: 0.375rem;\n  }\n  .xl\\:mx-1\\.5 {\n    margin-left: 0.375rem;\n    margin-right: 0.375rem;\n  }\n  .xl\\:my-2\\.5 {\n    margin-top: 0.625rem;\n    margin-bottom: 0.625rem;\n  }\n  .xl\\:mx-2\\.5 {\n    margin-left: 0.625rem;\n    margin-right: 0.625rem;\n  }\n  .xl\\:my-3\\.5 {\n    margin-top: 0.875rem;\n    margin-bottom: 0.875rem;\n  }\n  .xl\\:mx-3\\.5 {\n    margin-left: 0.875rem;\n    margin-right: 0.875rem;\n  }\n  .xl\\:my-1\\/2 {\n    margin-top: 50%;\n    margin-bottom: 50%;\n  }\n  .xl\\:mx-1\\/2 {\n    margin-left: 50%;\n    margin-right: 50%;\n  }\n  .xl\\:my-1\\/3 {\n    margin-top: 33.333333%;\n    margin-bottom: 33.333333%;\n  }\n  .xl\\:mx-1\\/3 {\n    margin-left: 33.333333%;\n    margin-right: 33.333333%;\n  }\n  .xl\\:my-2\\/3 {\n    margin-top: 66.666667%;\n    margin-bottom: 66.666667%;\n  }\n  .xl\\:mx-2\\/3 {\n    margin-left: 66.666667%;\n    margin-right: 66.666667%;\n  }\n  .xl\\:my-1\\/4 {\n    margin-top: 25%;\n    margin-bottom: 25%;\n  }\n  .xl\\:mx-1\\/4 {\n    margin-left: 25%;\n    margin-right: 25%;\n  }\n  .xl\\:my-2\\/4 {\n    margin-top: 50%;\n    margin-bottom: 50%;\n  }\n  .xl\\:mx-2\\/4 {\n    margin-left: 50%;\n    margin-right: 50%;\n  }\n  .xl\\:my-3\\/4 {\n    margin-top: 75%;\n    margin-bottom: 75%;\n  }\n  .xl\\:mx-3\\/4 {\n    margin-left: 75%;\n    margin-right: 75%;\n  }\n  .xl\\:my-1\\/5 {\n    margin-top: 20%;\n    margin-bottom: 20%;\n  }\n  .xl\\:mx-1\\/5 {\n    margin-left: 20%;\n    margin-right: 20%;\n  }\n  .xl\\:my-2\\/5 {\n    margin-top: 40%;\n    margin-bottom: 40%;\n  }\n  .xl\\:mx-2\\/5 {\n    margin-left: 40%;\n    margin-right: 40%;\n  }\n  .xl\\:my-3\\/5 {\n    margin-top: 60%;\n    margin-bottom: 60%;\n  }\n  .xl\\:mx-3\\/5 {\n    margin-left: 60%;\n    margin-right: 60%;\n  }\n  .xl\\:my-4\\/5 {\n    margin-top: 80%;\n    margin-bottom: 80%;\n  }\n  .xl\\:mx-4\\/5 {\n    margin-left: 80%;\n    margin-right: 80%;\n  }\n  .xl\\:my-1\\/6 {\n    margin-top: 16.666667%;\n    margin-bottom: 16.666667%;\n  }\n  .xl\\:mx-1\\/6 {\n    margin-left: 16.666667%;\n    margin-right: 16.666667%;\n  }\n  .xl\\:my-2\\/6 {\n    margin-top: 33.333333%;\n    margin-bottom: 33.333333%;\n  }\n  .xl\\:mx-2\\/6 {\n    margin-left: 33.333333%;\n    margin-right: 33.333333%;\n  }\n  .xl\\:my-3\\/6 {\n    margin-top: 50%;\n    margin-bottom: 50%;\n  }\n  .xl\\:mx-3\\/6 {\n    margin-left: 50%;\n    margin-right: 50%;\n  }\n  .xl\\:my-4\\/6 {\n    margin-top: 66.666667%;\n    margin-bottom: 66.666667%;\n  }\n  .xl\\:mx-4\\/6 {\n    margin-left: 66.666667%;\n    margin-right: 66.666667%;\n  }\n  .xl\\:my-5\\/6 {\n    margin-top: 83.333333%;\n    margin-bottom: 83.333333%;\n  }\n  .xl\\:mx-5\\/6 {\n    margin-left: 83.333333%;\n    margin-right: 83.333333%;\n  }\n  .xl\\:my-1\\/12 {\n    margin-top: 8.333333%;\n    margin-bottom: 8.333333%;\n  }\n  .xl\\:mx-1\\/12 {\n    margin-left: 8.333333%;\n    margin-right: 8.333333%;\n  }\n  .xl\\:my-2\\/12 {\n    margin-top: 16.666667%;\n    margin-bottom: 16.666667%;\n  }\n  .xl\\:mx-2\\/12 {\n    margin-left: 16.666667%;\n    margin-right: 16.666667%;\n  }\n  .xl\\:my-3\\/12 {\n    margin-top: 25%;\n    margin-bottom: 25%;\n  }\n  .xl\\:mx-3\\/12 {\n    margin-left: 25%;\n    margin-right: 25%;\n  }\n  .xl\\:my-4\\/12 {\n    margin-top: 33.333333%;\n    margin-bottom: 33.333333%;\n  }\n  .xl\\:mx-4\\/12 {\n    margin-left: 33.333333%;\n    margin-right: 33.333333%;\n  }\n  .xl\\:my-5\\/12 {\n    margin-top: 41.666667%;\n    margin-bottom: 41.666667%;\n  }\n  .xl\\:mx-5\\/12 {\n    margin-left: 41.666667%;\n    margin-right: 41.666667%;\n  }\n  .xl\\:my-6\\/12 {\n    margin-top: 50%;\n    margin-bottom: 50%;\n  }\n  .xl\\:mx-6\\/12 {\n    margin-left: 50%;\n    margin-right: 50%;\n  }\n  .xl\\:my-7\\/12 {\n    margin-top: 58.333333%;\n    margin-bottom: 58.333333%;\n  }\n  .xl\\:mx-7\\/12 {\n    margin-left: 58.333333%;\n    margin-right: 58.333333%;\n  }\n  .xl\\:my-8\\/12 {\n    margin-top: 66.666667%;\n    margin-bottom: 66.666667%;\n  }\n  .xl\\:mx-8\\/12 {\n    margin-left: 66.666667%;\n    margin-right: 66.666667%;\n  }\n  .xl\\:my-9\\/12 {\n    margin-top: 75%;\n    margin-bottom: 75%;\n  }\n  .xl\\:mx-9\\/12 {\n    margin-left: 75%;\n    margin-right: 75%;\n  }\n  .xl\\:my-10\\/12 {\n    margin-top: 83.333333%;\n    margin-bottom: 83.333333%;\n  }\n  .xl\\:mx-10\\/12 {\n    margin-left: 83.333333%;\n    margin-right: 83.333333%;\n  }\n  .xl\\:my-11\\/12 {\n    margin-top: 91.666667%;\n    margin-bottom: 91.666667%;\n  }\n  .xl\\:mx-11\\/12 {\n    margin-left: 91.666667%;\n    margin-right: 91.666667%;\n  }\n  .xl\\:my-full {\n    margin-top: 100%;\n    margin-bottom: 100%;\n  }\n  .xl\\:mx-full {\n    margin-left: 100%;\n    margin-right: 100%;\n  }\n  .xl\\:-my-1 {\n    margin-top: -0.25rem;\n    margin-bottom: -0.25rem;\n  }\n  .xl\\:-mx-1 {\n    margin-left: -0.25rem;\n    margin-right: -0.25rem;\n  }\n  .xl\\:-my-2 {\n    margin-top: -0.5rem;\n    margin-bottom: -0.5rem;\n  }\n  .xl\\:-mx-2 {\n    margin-left: -0.5rem;\n    margin-right: -0.5rem;\n  }\n  .xl\\:-my-3 {\n    margin-top: -0.75rem;\n    margin-bottom: -0.75rem;\n  }\n  .xl\\:-mx-3 {\n    margin-left: -0.75rem;\n    margin-right: -0.75rem;\n  }\n  .xl\\:-my-4 {\n    margin-top: -1rem;\n    margin-bottom: -1rem;\n  }\n  .xl\\:-mx-4 {\n    margin-left: -1rem;\n    margin-right: -1rem;\n  }\n  .xl\\:-my-5 {\n    margin-top: -1.25rem;\n    margin-bottom: -1.25rem;\n  }\n  .xl\\:-mx-5 {\n    margin-left: -1.25rem;\n    margin-right: -1.25rem;\n  }\n  .xl\\:-my-6 {\n    margin-top: -1.5rem;\n    margin-bottom: -1.5rem;\n  }\n  .xl\\:-mx-6 {\n    margin-left: -1.5rem;\n    margin-right: -1.5rem;\n  }\n  .xl\\:-my-7 {\n    margin-top: -1.75rem;\n    margin-bottom: -1.75rem;\n  }\n  .xl\\:-mx-7 {\n    margin-left: -1.75rem;\n    margin-right: -1.75rem;\n  }\n  .xl\\:-my-8 {\n    margin-top: -2rem;\n    margin-bottom: -2rem;\n  }\n  .xl\\:-mx-8 {\n    margin-left: -2rem;\n    margin-right: -2rem;\n  }\n  .xl\\:-my-9 {\n    margin-top: -2.25rem;\n    margin-bottom: -2.25rem;\n  }\n  .xl\\:-mx-9 {\n    margin-left: -2.25rem;\n    margin-right: -2.25rem;\n  }\n  .xl\\:-my-10 {\n    margin-top: -2.5rem;\n    margin-bottom: -2.5rem;\n  }\n  .xl\\:-mx-10 {\n    margin-left: -2.5rem;\n    margin-right: -2.5rem;\n  }\n  .xl\\:-my-11 {\n    margin-top: -2.75rem;\n    margin-bottom: -2.75rem;\n  }\n  .xl\\:-mx-11 {\n    margin-left: -2.75rem;\n    margin-right: -2.75rem;\n  }\n  .xl\\:-my-12 {\n    margin-top: -3rem;\n    margin-bottom: -3rem;\n  }\n  .xl\\:-mx-12 {\n    margin-left: -3rem;\n    margin-right: -3rem;\n  }\n  .xl\\:-my-13 {\n    margin-top: -3.25rem;\n    margin-bottom: -3.25rem;\n  }\n  .xl\\:-mx-13 {\n    margin-left: -3.25rem;\n    margin-right: -3.25rem;\n  }\n  .xl\\:-my-14 {\n    margin-top: -3.5rem;\n    margin-bottom: -3.5rem;\n  }\n  .xl\\:-mx-14 {\n    margin-left: -3.5rem;\n    margin-right: -3.5rem;\n  }\n  .xl\\:-my-15 {\n    margin-top: -3.75rem;\n    margin-bottom: -3.75rem;\n  }\n  .xl\\:-mx-15 {\n    margin-left: -3.75rem;\n    margin-right: -3.75rem;\n  }\n  .xl\\:-my-16 {\n    margin-top: -4rem;\n    margin-bottom: -4rem;\n  }\n  .xl\\:-mx-16 {\n    margin-left: -4rem;\n    margin-right: -4rem;\n  }\n  .xl\\:-my-20 {\n    margin-top: -5rem;\n    margin-bottom: -5rem;\n  }\n  .xl\\:-mx-20 {\n    margin-left: -5rem;\n    margin-right: -5rem;\n  }\n  .xl\\:-my-24 {\n    margin-top: -6rem;\n    margin-bottom: -6rem;\n  }\n  .xl\\:-mx-24 {\n    margin-left: -6rem;\n    margin-right: -6rem;\n  }\n  .xl\\:-my-28 {\n    margin-top: -7rem;\n    margin-bottom: -7rem;\n  }\n  .xl\\:-mx-28 {\n    margin-left: -7rem;\n    margin-right: -7rem;\n  }\n  .xl\\:-my-32 {\n    margin-top: -8rem;\n    margin-bottom: -8rem;\n  }\n  .xl\\:-mx-32 {\n    margin-left: -8rem;\n    margin-right: -8rem;\n  }\n  .xl\\:-my-36 {\n    margin-top: -9rem;\n    margin-bottom: -9rem;\n  }\n  .xl\\:-mx-36 {\n    margin-left: -9rem;\n    margin-right: -9rem;\n  }\n  .xl\\:-my-40 {\n    margin-top: -10rem;\n    margin-bottom: -10rem;\n  }\n  .xl\\:-mx-40 {\n    margin-left: -10rem;\n    margin-right: -10rem;\n  }\n  .xl\\:-my-44 {\n    margin-top: -11rem;\n    margin-bottom: -11rem;\n  }\n  .xl\\:-mx-44 {\n    margin-left: -11rem;\n    margin-right: -11rem;\n  }\n  .xl\\:-my-48 {\n    margin-top: -12rem;\n    margin-bottom: -12rem;\n  }\n  .xl\\:-mx-48 {\n    margin-left: -12rem;\n    margin-right: -12rem;\n  }\n  .xl\\:-my-52 {\n    margin-top: -13rem;\n    margin-bottom: -13rem;\n  }\n  .xl\\:-mx-52 {\n    margin-left: -13rem;\n    margin-right: -13rem;\n  }\n  .xl\\:-my-56 {\n    margin-top: -14rem;\n    margin-bottom: -14rem;\n  }\n  .xl\\:-mx-56 {\n    margin-left: -14rem;\n    margin-right: -14rem;\n  }\n  .xl\\:-my-60 {\n    margin-top: -15rem;\n    margin-bottom: -15rem;\n  }\n  .xl\\:-mx-60 {\n    margin-left: -15rem;\n    margin-right: -15rem;\n  }\n  .xl\\:-my-64 {\n    margin-top: -16rem;\n    margin-bottom: -16rem;\n  }\n  .xl\\:-mx-64 {\n    margin-left: -16rem;\n    margin-right: -16rem;\n  }\n  .xl\\:-my-72 {\n    margin-top: -18rem;\n    margin-bottom: -18rem;\n  }\n  .xl\\:-mx-72 {\n    margin-left: -18rem;\n    margin-right: -18rem;\n  }\n  .xl\\:-my-80 {\n    margin-top: -20rem;\n    margin-bottom: -20rem;\n  }\n  .xl\\:-mx-80 {\n    margin-left: -20rem;\n    margin-right: -20rem;\n  }\n  .xl\\:-my-96 {\n    margin-top: -24rem;\n    margin-bottom: -24rem;\n  }\n  .xl\\:-mx-96 {\n    margin-left: -24rem;\n    margin-right: -24rem;\n  }\n  .xl\\:-my-px {\n    margin-top: -1px;\n    margin-bottom: -1px;\n  }\n  .xl\\:-mx-px {\n    margin-left: -1px;\n    margin-right: -1px;\n  }\n  .xl\\:-my-0\\.5 {\n    margin-top: -0.125rem;\n    margin-bottom: -0.125rem;\n  }\n  .xl\\:-mx-0\\.5 {\n    margin-left: -0.125rem;\n    margin-right: -0.125rem;\n  }\n  .xl\\:-my-1\\.5 {\n    margin-top: -0.375rem;\n    margin-bottom: -0.375rem;\n  }\n  .xl\\:-mx-1\\.5 {\n    margin-left: -0.375rem;\n    margin-right: -0.375rem;\n  }\n  .xl\\:-my-2\\.5 {\n    margin-top: -0.625rem;\n    margin-bottom: -0.625rem;\n  }\n  .xl\\:-mx-2\\.5 {\n    margin-left: -0.625rem;\n    margin-right: -0.625rem;\n  }\n  .xl\\:-my-3\\.5 {\n    margin-top: -0.875rem;\n    margin-bottom: -0.875rem;\n  }\n  .xl\\:-mx-3\\.5 {\n    margin-left: -0.875rem;\n    margin-right: -0.875rem;\n  }\n  .xl\\:-my-1\\/2 {\n    margin-top: -50%;\n    margin-bottom: -50%;\n  }\n  .xl\\:-mx-1\\/2 {\n    margin-left: -50%;\n    margin-right: -50%;\n  }\n  .xl\\:-my-1\\/3 {\n    margin-top: -33.33333%;\n    margin-bottom: -33.33333%;\n  }\n  .xl\\:-mx-1\\/3 {\n    margin-left: -33.33333%;\n    margin-right: -33.33333%;\n  }\n  .xl\\:-my-2\\/3 {\n    margin-top: -66.66667%;\n    margin-bottom: -66.66667%;\n  }\n  .xl\\:-mx-2\\/3 {\n    margin-left: -66.66667%;\n    margin-right: -66.66667%;\n  }\n  .xl\\:-my-1\\/4 {\n    margin-top: -25%;\n    margin-bottom: -25%;\n  }\n  .xl\\:-mx-1\\/4 {\n    margin-left: -25%;\n    margin-right: -25%;\n  }\n  .xl\\:-my-2\\/4 {\n    margin-top: -50%;\n    margin-bottom: -50%;\n  }\n  .xl\\:-mx-2\\/4 {\n    margin-left: -50%;\n    margin-right: -50%;\n  }\n  .xl\\:-my-3\\/4 {\n    margin-top: -75%;\n    margin-bottom: -75%;\n  }\n  .xl\\:-mx-3\\/4 {\n    margin-left: -75%;\n    margin-right: -75%;\n  }\n  .xl\\:-my-1\\/5 {\n    margin-top: -20%;\n    margin-bottom: -20%;\n  }\n  .xl\\:-mx-1\\/5 {\n    margin-left: -20%;\n    margin-right: -20%;\n  }\n  .xl\\:-my-2\\/5 {\n    margin-top: -40%;\n    margin-bottom: -40%;\n  }\n  .xl\\:-mx-2\\/5 {\n    margin-left: -40%;\n    margin-right: -40%;\n  }\n  .xl\\:-my-3\\/5 {\n    margin-top: -60%;\n    margin-bottom: -60%;\n  }\n  .xl\\:-mx-3\\/5 {\n    margin-left: -60%;\n    margin-right: -60%;\n  }\n  .xl\\:-my-4\\/5 {\n    margin-top: -80%;\n    margin-bottom: -80%;\n  }\n  .xl\\:-mx-4\\/5 {\n    margin-left: -80%;\n    margin-right: -80%;\n  }\n  .xl\\:-my-1\\/6 {\n    margin-top: -16.66667%;\n    margin-bottom: -16.66667%;\n  }\n  .xl\\:-mx-1\\/6 {\n    margin-left: -16.66667%;\n    margin-right: -16.66667%;\n  }\n  .xl\\:-my-2\\/6 {\n    margin-top: -33.33333%;\n    margin-bottom: -33.33333%;\n  }\n  .xl\\:-mx-2\\/6 {\n    margin-left: -33.33333%;\n    margin-right: -33.33333%;\n  }\n  .xl\\:-my-3\\/6 {\n    margin-top: -50%;\n    margin-bottom: -50%;\n  }\n  .xl\\:-mx-3\\/6 {\n    margin-left: -50%;\n    margin-right: -50%;\n  }\n  .xl\\:-my-4\\/6 {\n    margin-top: -66.66667%;\n    margin-bottom: -66.66667%;\n  }\n  .xl\\:-mx-4\\/6 {\n    margin-left: -66.66667%;\n    margin-right: -66.66667%;\n  }\n  .xl\\:-my-5\\/6 {\n    margin-top: -83.33333%;\n    margin-bottom: -83.33333%;\n  }\n  .xl\\:-mx-5\\/6 {\n    margin-left: -83.33333%;\n    margin-right: -83.33333%;\n  }\n  .xl\\:-my-1\\/12 {\n    margin-top: -8.33333%;\n    margin-bottom: -8.33333%;\n  }\n  .xl\\:-mx-1\\/12 {\n    margin-left: -8.33333%;\n    margin-right: -8.33333%;\n  }\n  .xl\\:-my-2\\/12 {\n    margin-top: -16.66667%;\n    margin-bottom: -16.66667%;\n  }\n  .xl\\:-mx-2\\/12 {\n    margin-left: -16.66667%;\n    margin-right: -16.66667%;\n  }\n  .xl\\:-my-3\\/12 {\n    margin-top: -25%;\n    margin-bottom: -25%;\n  }\n  .xl\\:-mx-3\\/12 {\n    margin-left: -25%;\n    margin-right: -25%;\n  }\n  .xl\\:-my-4\\/12 {\n    margin-top: -33.33333%;\n    margin-bottom: -33.33333%;\n  }\n  .xl\\:-mx-4\\/12 {\n    margin-left: -33.33333%;\n    margin-right: -33.33333%;\n  }\n  .xl\\:-my-5\\/12 {\n    margin-top: -41.66667%;\n    margin-bottom: -41.66667%;\n  }\n  .xl\\:-mx-5\\/12 {\n    margin-left: -41.66667%;\n    margin-right: -41.66667%;\n  }\n  .xl\\:-my-6\\/12 {\n    margin-top: -50%;\n    margin-bottom: -50%;\n  }\n  .xl\\:-mx-6\\/12 {\n    margin-left: -50%;\n    margin-right: -50%;\n  }\n  .xl\\:-my-7\\/12 {\n    margin-top: -58.33333%;\n    margin-bottom: -58.33333%;\n  }\n  .xl\\:-mx-7\\/12 {\n    margin-left: -58.33333%;\n    margin-right: -58.33333%;\n  }\n  .xl\\:-my-8\\/12 {\n    margin-top: -66.66667%;\n    margin-bottom: -66.66667%;\n  }\n  .xl\\:-mx-8\\/12 {\n    margin-left: -66.66667%;\n    margin-right: -66.66667%;\n  }\n  .xl\\:-my-9\\/12 {\n    margin-top: -75%;\n    margin-bottom: -75%;\n  }\n  .xl\\:-mx-9\\/12 {\n    margin-left: -75%;\n    margin-right: -75%;\n  }\n  .xl\\:-my-10\\/12 {\n    margin-top: -83.33333%;\n    margin-bottom: -83.33333%;\n  }\n  .xl\\:-mx-10\\/12 {\n    margin-left: -83.33333%;\n    margin-right: -83.33333%;\n  }\n  .xl\\:-my-11\\/12 {\n    margin-top: -91.66667%;\n    margin-bottom: -91.66667%;\n  }\n  .xl\\:-mx-11\\/12 {\n    margin-left: -91.66667%;\n    margin-right: -91.66667%;\n  }\n  .xl\\:-my-full {\n    margin-top: -100%;\n    margin-bottom: -100%;\n  }\n  .xl\\:-mx-full {\n    margin-left: -100%;\n    margin-right: -100%;\n  }\n  .xl\\:mt-0 {\n    margin-top: 0;\n  }\n  .xl\\:mr-0 {\n    margin-right: 0;\n  }\n  .xl\\:mb-0 {\n    margin-bottom: 0;\n  }\n  .xl\\:ml-0 {\n    margin-left: 0;\n  }\n  .xl\\:mt-1 {\n    margin-top: 0.25rem;\n  }\n  .xl\\:mr-1 {\n    margin-right: 0.25rem;\n  }\n  .xl\\:mb-1 {\n    margin-bottom: 0.25rem;\n  }\n  .xl\\:ml-1 {\n    margin-left: 0.25rem;\n  }\n  .xl\\:mt-2 {\n    margin-top: 0.5rem;\n  }\n  .xl\\:mr-2 {\n    margin-right: 0.5rem;\n  }\n  .xl\\:mb-2 {\n    margin-bottom: 0.5rem;\n  }\n  .xl\\:ml-2 {\n    margin-left: 0.5rem;\n  }\n  .xl\\:mt-3 {\n    margin-top: 0.75rem;\n  }\n  .xl\\:mr-3 {\n    margin-right: 0.75rem;\n  }\n  .xl\\:mb-3 {\n    margin-bottom: 0.75rem;\n  }\n  .xl\\:ml-3 {\n    margin-left: 0.75rem;\n  }\n  .xl\\:mt-4 {\n    margin-top: 1rem;\n  }\n  .xl\\:mr-4 {\n    margin-right: 1rem;\n  }\n  .xl\\:mb-4 {\n    margin-bottom: 1rem;\n  }\n  .xl\\:ml-4 {\n    margin-left: 1rem;\n  }\n  .xl\\:mt-5 {\n    margin-top: 1.25rem;\n  }\n  .xl\\:mr-5 {\n    margin-right: 1.25rem;\n  }\n  .xl\\:mb-5 {\n    margin-bottom: 1.25rem;\n  }\n  .xl\\:ml-5 {\n    margin-left: 1.25rem;\n  }\n  .xl\\:mt-6 {\n    margin-top: 1.5rem;\n  }\n  .xl\\:mr-6 {\n    margin-right: 1.5rem;\n  }\n  .xl\\:mb-6 {\n    margin-bottom: 1.5rem;\n  }\n  .xl\\:ml-6 {\n    margin-left: 1.5rem;\n  }\n  .xl\\:mt-7 {\n    margin-top: 1.75rem;\n  }\n  .xl\\:mr-7 {\n    margin-right: 1.75rem;\n  }\n  .xl\\:mb-7 {\n    margin-bottom: 1.75rem;\n  }\n  .xl\\:ml-7 {\n    margin-left: 1.75rem;\n  }\n  .xl\\:mt-8 {\n    margin-top: 2rem;\n  }\n  .xl\\:mr-8 {\n    margin-right: 2rem;\n  }\n  .xl\\:mb-8 {\n    margin-bottom: 2rem;\n  }\n  .xl\\:ml-8 {\n    margin-left: 2rem;\n  }\n  .xl\\:mt-9 {\n    margin-top: 2.25rem;\n  }\n  .xl\\:mr-9 {\n    margin-right: 2.25rem;\n  }\n  .xl\\:mb-9 {\n    margin-bottom: 2.25rem;\n  }\n  .xl\\:ml-9 {\n    margin-left: 2.25rem;\n  }\n  .xl\\:mt-10 {\n    margin-top: 2.5rem;\n  }\n  .xl\\:mr-10 {\n    margin-right: 2.5rem;\n  }\n  .xl\\:mb-10 {\n    margin-bottom: 2.5rem;\n  }\n  .xl\\:ml-10 {\n    margin-left: 2.5rem;\n  }\n  .xl\\:mt-11 {\n    margin-top: 2.75rem;\n  }\n  .xl\\:mr-11 {\n    margin-right: 2.75rem;\n  }\n  .xl\\:mb-11 {\n    margin-bottom: 2.75rem;\n  }\n  .xl\\:ml-11 {\n    margin-left: 2.75rem;\n  }\n  .xl\\:mt-12 {\n    margin-top: 3rem;\n  }\n  .xl\\:mr-12 {\n    margin-right: 3rem;\n  }\n  .xl\\:mb-12 {\n    margin-bottom: 3rem;\n  }\n  .xl\\:ml-12 {\n    margin-left: 3rem;\n  }\n  .xl\\:mt-13 {\n    margin-top: 3.25rem;\n  }\n  .xl\\:mr-13 {\n    margin-right: 3.25rem;\n  }\n  .xl\\:mb-13 {\n    margin-bottom: 3.25rem;\n  }\n  .xl\\:ml-13 {\n    margin-left: 3.25rem;\n  }\n  .xl\\:mt-14 {\n    margin-top: 3.5rem;\n  }\n  .xl\\:mr-14 {\n    margin-right: 3.5rem;\n  }\n  .xl\\:mb-14 {\n    margin-bottom: 3.5rem;\n  }\n  .xl\\:ml-14 {\n    margin-left: 3.5rem;\n  }\n  .xl\\:mt-15 {\n    margin-top: 3.75rem;\n  }\n  .xl\\:mr-15 {\n    margin-right: 3.75rem;\n  }\n  .xl\\:mb-15 {\n    margin-bottom: 3.75rem;\n  }\n  .xl\\:ml-15 {\n    margin-left: 3.75rem;\n  }\n  .xl\\:mt-16 {\n    margin-top: 4rem;\n  }\n  .xl\\:mr-16 {\n    margin-right: 4rem;\n  }\n  .xl\\:mb-16 {\n    margin-bottom: 4rem;\n  }\n  .xl\\:ml-16 {\n    margin-left: 4rem;\n  }\n  .xl\\:mt-20 {\n    margin-top: 5rem;\n  }\n  .xl\\:mr-20 {\n    margin-right: 5rem;\n  }\n  .xl\\:mb-20 {\n    margin-bottom: 5rem;\n  }\n  .xl\\:ml-20 {\n    margin-left: 5rem;\n  }\n  .xl\\:mt-24 {\n    margin-top: 6rem;\n  }\n  .xl\\:mr-24 {\n    margin-right: 6rem;\n  }\n  .xl\\:mb-24 {\n    margin-bottom: 6rem;\n  }\n  .xl\\:ml-24 {\n    margin-left: 6rem;\n  }\n  .xl\\:mt-28 {\n    margin-top: 7rem;\n  }\n  .xl\\:mr-28 {\n    margin-right: 7rem;\n  }\n  .xl\\:mb-28 {\n    margin-bottom: 7rem;\n  }\n  .xl\\:ml-28 {\n    margin-left: 7rem;\n  }\n  .xl\\:mt-32 {\n    margin-top: 8rem;\n  }\n  .xl\\:mr-32 {\n    margin-right: 8rem;\n  }\n  .xl\\:mb-32 {\n    margin-bottom: 8rem;\n  }\n  .xl\\:ml-32 {\n    margin-left: 8rem;\n  }\n  .xl\\:mt-36 {\n    margin-top: 9rem;\n  }\n  .xl\\:mr-36 {\n    margin-right: 9rem;\n  }\n  .xl\\:mb-36 {\n    margin-bottom: 9rem;\n  }\n  .xl\\:ml-36 {\n    margin-left: 9rem;\n  }\n  .xl\\:mt-40 {\n    margin-top: 10rem;\n  }\n  .xl\\:mr-40 {\n    margin-right: 10rem;\n  }\n  .xl\\:mb-40 {\n    margin-bottom: 10rem;\n  }\n  .xl\\:ml-40 {\n    margin-left: 10rem;\n  }\n  .xl\\:mt-44 {\n    margin-top: 11rem;\n  }\n  .xl\\:mr-44 {\n    margin-right: 11rem;\n  }\n  .xl\\:mb-44 {\n    margin-bottom: 11rem;\n  }\n  .xl\\:ml-44 {\n    margin-left: 11rem;\n  }\n  .xl\\:mt-48 {\n    margin-top: 12rem;\n  }\n  .xl\\:mr-48 {\n    margin-right: 12rem;\n  }\n  .xl\\:mb-48 {\n    margin-bottom: 12rem;\n  }\n  .xl\\:ml-48 {\n    margin-left: 12rem;\n  }\n  .xl\\:mt-52 {\n    margin-top: 13rem;\n  }\n  .xl\\:mr-52 {\n    margin-right: 13rem;\n  }\n  .xl\\:mb-52 {\n    margin-bottom: 13rem;\n  }\n  .xl\\:ml-52 {\n    margin-left: 13rem;\n  }\n  .xl\\:mt-56 {\n    margin-top: 14rem;\n  }\n  .xl\\:mr-56 {\n    margin-right: 14rem;\n  }\n  .xl\\:mb-56 {\n    margin-bottom: 14rem;\n  }\n  .xl\\:ml-56 {\n    margin-left: 14rem;\n  }\n  .xl\\:mt-60 {\n    margin-top: 15rem;\n  }\n  .xl\\:mr-60 {\n    margin-right: 15rem;\n  }\n  .xl\\:mb-60 {\n    margin-bottom: 15rem;\n  }\n  .xl\\:ml-60 {\n    margin-left: 15rem;\n  }\n  .xl\\:mt-64 {\n    margin-top: 16rem;\n  }\n  .xl\\:mr-64 {\n    margin-right: 16rem;\n  }\n  .xl\\:mb-64 {\n    margin-bottom: 16rem;\n  }\n  .xl\\:ml-64 {\n    margin-left: 16rem;\n  }\n  .xl\\:mt-72 {\n    margin-top: 18rem;\n  }\n  .xl\\:mr-72 {\n    margin-right: 18rem;\n  }\n  .xl\\:mb-72 {\n    margin-bottom: 18rem;\n  }\n  .xl\\:ml-72 {\n    margin-left: 18rem;\n  }\n  .xl\\:mt-80 {\n    margin-top: 20rem;\n  }\n  .xl\\:mr-80 {\n    margin-right: 20rem;\n  }\n  .xl\\:mb-80 {\n    margin-bottom: 20rem;\n  }\n  .xl\\:ml-80 {\n    margin-left: 20rem;\n  }\n  .xl\\:mt-96 {\n    margin-top: 24rem;\n  }\n  .xl\\:mr-96 {\n    margin-right: 24rem;\n  }\n  .xl\\:mb-96 {\n    margin-bottom: 24rem;\n  }\n  .xl\\:ml-96 {\n    margin-left: 24rem;\n  }\n  .xl\\:mt-auto {\n    margin-top: auto;\n  }\n  .xl\\:mr-auto {\n    margin-right: auto;\n  }\n  .xl\\:mb-auto {\n    margin-bottom: auto;\n  }\n  .xl\\:ml-auto {\n    margin-left: auto;\n  }\n  .xl\\:mt-px {\n    margin-top: 1px;\n  }\n  .xl\\:mr-px {\n    margin-right: 1px;\n  }\n  .xl\\:mb-px {\n    margin-bottom: 1px;\n  }\n  .xl\\:ml-px {\n    margin-left: 1px;\n  }\n  .xl\\:mt-0\\.5 {\n    margin-top: 0.125rem;\n  }\n  .xl\\:mr-0\\.5 {\n    margin-right: 0.125rem;\n  }\n  .xl\\:mb-0\\.5 {\n    margin-bottom: 0.125rem;\n  }\n  .xl\\:ml-0\\.5 {\n    margin-left: 0.125rem;\n  }\n  .xl\\:mt-1\\.5 {\n    margin-top: 0.375rem;\n  }\n  .xl\\:mr-1\\.5 {\n    margin-right: 0.375rem;\n  }\n  .xl\\:mb-1\\.5 {\n    margin-bottom: 0.375rem;\n  }\n  .xl\\:ml-1\\.5 {\n    margin-left: 0.375rem;\n  }\n  .xl\\:mt-2\\.5 {\n    margin-top: 0.625rem;\n  }\n  .xl\\:mr-2\\.5 {\n    margin-right: 0.625rem;\n  }\n  .xl\\:mb-2\\.5 {\n    margin-bottom: 0.625rem;\n  }\n  .xl\\:ml-2\\.5 {\n    margin-left: 0.625rem;\n  }\n  .xl\\:mt-3\\.5 {\n    margin-top: 0.875rem;\n  }\n  .xl\\:mr-3\\.5 {\n    margin-right: 0.875rem;\n  }\n  .xl\\:mb-3\\.5 {\n    margin-bottom: 0.875rem;\n  }\n  .xl\\:ml-3\\.5 {\n    margin-left: 0.875rem;\n  }\n  .xl\\:mt-1\\/2 {\n    margin-top: 50%;\n  }\n  .xl\\:mr-1\\/2 {\n    margin-right: 50%;\n  }\n  .xl\\:mb-1\\/2 {\n    margin-bottom: 50%;\n  }\n  .xl\\:ml-1\\/2 {\n    margin-left: 50%;\n  }\n  .xl\\:mt-1\\/3 {\n    margin-top: 33.333333%;\n  }\n  .xl\\:mr-1\\/3 {\n    margin-right: 33.333333%;\n  }\n  .xl\\:mb-1\\/3 {\n    margin-bottom: 33.333333%;\n  }\n  .xl\\:ml-1\\/3 {\n    margin-left: 33.333333%;\n  }\n  .xl\\:mt-2\\/3 {\n    margin-top: 66.666667%;\n  }\n  .xl\\:mr-2\\/3 {\n    margin-right: 66.666667%;\n  }\n  .xl\\:mb-2\\/3 {\n    margin-bottom: 66.666667%;\n  }\n  .xl\\:ml-2\\/3 {\n    margin-left: 66.666667%;\n  }\n  .xl\\:mt-1\\/4 {\n    margin-top: 25%;\n  }\n  .xl\\:mr-1\\/4 {\n    margin-right: 25%;\n  }\n  .xl\\:mb-1\\/4 {\n    margin-bottom: 25%;\n  }\n  .xl\\:ml-1\\/4 {\n    margin-left: 25%;\n  }\n  .xl\\:mt-2\\/4 {\n    margin-top: 50%;\n  }\n  .xl\\:mr-2\\/4 {\n    margin-right: 50%;\n  }\n  .xl\\:mb-2\\/4 {\n    margin-bottom: 50%;\n  }\n  .xl\\:ml-2\\/4 {\n    margin-left: 50%;\n  }\n  .xl\\:mt-3\\/4 {\n    margin-top: 75%;\n  }\n  .xl\\:mr-3\\/4 {\n    margin-right: 75%;\n  }\n  .xl\\:mb-3\\/4 {\n    margin-bottom: 75%;\n  }\n  .xl\\:ml-3\\/4 {\n    margin-left: 75%;\n  }\n  .xl\\:mt-1\\/5 {\n    margin-top: 20%;\n  }\n  .xl\\:mr-1\\/5 {\n    margin-right: 20%;\n  }\n  .xl\\:mb-1\\/5 {\n    margin-bottom: 20%;\n  }\n  .xl\\:ml-1\\/5 {\n    margin-left: 20%;\n  }\n  .xl\\:mt-2\\/5 {\n    margin-top: 40%;\n  }\n  .xl\\:mr-2\\/5 {\n    margin-right: 40%;\n  }\n  .xl\\:mb-2\\/5 {\n    margin-bottom: 40%;\n  }\n  .xl\\:ml-2\\/5 {\n    margin-left: 40%;\n  }\n  .xl\\:mt-3\\/5 {\n    margin-top: 60%;\n  }\n  .xl\\:mr-3\\/5 {\n    margin-right: 60%;\n  }\n  .xl\\:mb-3\\/5 {\n    margin-bottom: 60%;\n  }\n  .xl\\:ml-3\\/5 {\n    margin-left: 60%;\n  }\n  .xl\\:mt-4\\/5 {\n    margin-top: 80%;\n  }\n  .xl\\:mr-4\\/5 {\n    margin-right: 80%;\n  }\n  .xl\\:mb-4\\/5 {\n    margin-bottom: 80%;\n  }\n  .xl\\:ml-4\\/5 {\n    margin-left: 80%;\n  }\n  .xl\\:mt-1\\/6 {\n    margin-top: 16.666667%;\n  }\n  .xl\\:mr-1\\/6 {\n    margin-right: 16.666667%;\n  }\n  .xl\\:mb-1\\/6 {\n    margin-bottom: 16.666667%;\n  }\n  .xl\\:ml-1\\/6 {\n    margin-left: 16.666667%;\n  }\n  .xl\\:mt-2\\/6 {\n    margin-top: 33.333333%;\n  }\n  .xl\\:mr-2\\/6 {\n    margin-right: 33.333333%;\n  }\n  .xl\\:mb-2\\/6 {\n    margin-bottom: 33.333333%;\n  }\n  .xl\\:ml-2\\/6 {\n    margin-left: 33.333333%;\n  }\n  .xl\\:mt-3\\/6 {\n    margin-top: 50%;\n  }\n  .xl\\:mr-3\\/6 {\n    margin-right: 50%;\n  }\n  .xl\\:mb-3\\/6 {\n    margin-bottom: 50%;\n  }\n  .xl\\:ml-3\\/6 {\n    margin-left: 50%;\n  }\n  .xl\\:mt-4\\/6 {\n    margin-top: 66.666667%;\n  }\n  .xl\\:mr-4\\/6 {\n    margin-right: 66.666667%;\n  }\n  .xl\\:mb-4\\/6 {\n    margin-bottom: 66.666667%;\n  }\n  .xl\\:ml-4\\/6 {\n    margin-left: 66.666667%;\n  }\n  .xl\\:mt-5\\/6 {\n    margin-top: 83.333333%;\n  }\n  .xl\\:mr-5\\/6 {\n    margin-right: 83.333333%;\n  }\n  .xl\\:mb-5\\/6 {\n    margin-bottom: 83.333333%;\n  }\n  .xl\\:ml-5\\/6 {\n    margin-left: 83.333333%;\n  }\n  .xl\\:mt-1\\/12 {\n    margin-top: 8.333333%;\n  }\n  .xl\\:mr-1\\/12 {\n    margin-right: 8.333333%;\n  }\n  .xl\\:mb-1\\/12 {\n    margin-bottom: 8.333333%;\n  }\n  .xl\\:ml-1\\/12 {\n    margin-left: 8.333333%;\n  }\n  .xl\\:mt-2\\/12 {\n    margin-top: 16.666667%;\n  }\n  .xl\\:mr-2\\/12 {\n    margin-right: 16.666667%;\n  }\n  .xl\\:mb-2\\/12 {\n    margin-bottom: 16.666667%;\n  }\n  .xl\\:ml-2\\/12 {\n    margin-left: 16.666667%;\n  }\n  .xl\\:mt-3\\/12 {\n    margin-top: 25%;\n  }\n  .xl\\:mr-3\\/12 {\n    margin-right: 25%;\n  }\n  .xl\\:mb-3\\/12 {\n    margin-bottom: 25%;\n  }\n  .xl\\:ml-3\\/12 {\n    margin-left: 25%;\n  }\n  .xl\\:mt-4\\/12 {\n    margin-top: 33.333333%;\n  }\n  .xl\\:mr-4\\/12 {\n    margin-right: 33.333333%;\n  }\n  .xl\\:mb-4\\/12 {\n    margin-bottom: 33.333333%;\n  }\n  .xl\\:ml-4\\/12 {\n    margin-left: 33.333333%;\n  }\n  .xl\\:mt-5\\/12 {\n    margin-top: 41.666667%;\n  }\n  .xl\\:mr-5\\/12 {\n    margin-right: 41.666667%;\n  }\n  .xl\\:mb-5\\/12 {\n    margin-bottom: 41.666667%;\n  }\n  .xl\\:ml-5\\/12 {\n    margin-left: 41.666667%;\n  }\n  .xl\\:mt-6\\/12 {\n    margin-top: 50%;\n  }\n  .xl\\:mr-6\\/12 {\n    margin-right: 50%;\n  }\n  .xl\\:mb-6\\/12 {\n    margin-bottom: 50%;\n  }\n  .xl\\:ml-6\\/12 {\n    margin-left: 50%;\n  }\n  .xl\\:mt-7\\/12 {\n    margin-top: 58.333333%;\n  }\n  .xl\\:mr-7\\/12 {\n    margin-right: 58.333333%;\n  }\n  .xl\\:mb-7\\/12 {\n    margin-bottom: 58.333333%;\n  }\n  .xl\\:ml-7\\/12 {\n    margin-left: 58.333333%;\n  }\n  .xl\\:mt-8\\/12 {\n    margin-top: 66.666667%;\n  }\n  .xl\\:mr-8\\/12 {\n    margin-right: 66.666667%;\n  }\n  .xl\\:mb-8\\/12 {\n    margin-bottom: 66.666667%;\n  }\n  .xl\\:ml-8\\/12 {\n    margin-left: 66.666667%;\n  }\n  .xl\\:mt-9\\/12 {\n    margin-top: 75%;\n  }\n  .xl\\:mr-9\\/12 {\n    margin-right: 75%;\n  }\n  .xl\\:mb-9\\/12 {\n    margin-bottom: 75%;\n  }\n  .xl\\:ml-9\\/12 {\n    margin-left: 75%;\n  }\n  .xl\\:mt-10\\/12 {\n    margin-top: 83.333333%;\n  }\n  .xl\\:mr-10\\/12 {\n    margin-right: 83.333333%;\n  }\n  .xl\\:mb-10\\/12 {\n    margin-bottom: 83.333333%;\n  }\n  .xl\\:ml-10\\/12 {\n    margin-left: 83.333333%;\n  }\n  .xl\\:mt-11\\/12 {\n    margin-top: 91.666667%;\n  }\n  .xl\\:mr-11\\/12 {\n    margin-right: 91.666667%;\n  }\n  .xl\\:mb-11\\/12 {\n    margin-bottom: 91.666667%;\n  }\n  .xl\\:ml-11\\/12 {\n    margin-left: 91.666667%;\n  }\n  .xl\\:mt-full {\n    margin-top: 100%;\n  }\n  .xl\\:mr-full {\n    margin-right: 100%;\n  }\n  .xl\\:mb-full {\n    margin-bottom: 100%;\n  }\n  .xl\\:ml-full {\n    margin-left: 100%;\n  }\n  .xl\\:-mt-1 {\n    margin-top: -0.25rem;\n  }\n  .xl\\:-mr-1 {\n    margin-right: -0.25rem;\n  }\n  .xl\\:-mb-1 {\n    margin-bottom: -0.25rem;\n  }\n  .xl\\:-ml-1 {\n    margin-left: -0.25rem;\n  }\n  .xl\\:-mt-2 {\n    margin-top: -0.5rem;\n  }\n  .xl\\:-mr-2 {\n    margin-right: -0.5rem;\n  }\n  .xl\\:-mb-2 {\n    margin-bottom: -0.5rem;\n  }\n  .xl\\:-ml-2 {\n    margin-left: -0.5rem;\n  }\n  .xl\\:-mt-3 {\n    margin-top: -0.75rem;\n  }\n  .xl\\:-mr-3 {\n    margin-right: -0.75rem;\n  }\n  .xl\\:-mb-3 {\n    margin-bottom: -0.75rem;\n  }\n  .xl\\:-ml-3 {\n    margin-left: -0.75rem;\n  }\n  .xl\\:-mt-4 {\n    margin-top: -1rem;\n  }\n  .xl\\:-mr-4 {\n    margin-right: -1rem;\n  }\n  .xl\\:-mb-4 {\n    margin-bottom: -1rem;\n  }\n  .xl\\:-ml-4 {\n    margin-left: -1rem;\n  }\n  .xl\\:-mt-5 {\n    margin-top: -1.25rem;\n  }\n  .xl\\:-mr-5 {\n    margin-right: -1.25rem;\n  }\n  .xl\\:-mb-5 {\n    margin-bottom: -1.25rem;\n  }\n  .xl\\:-ml-5 {\n    margin-left: -1.25rem;\n  }\n  .xl\\:-mt-6 {\n    margin-top: -1.5rem;\n  }\n  .xl\\:-mr-6 {\n    margin-right: -1.5rem;\n  }\n  .xl\\:-mb-6 {\n    margin-bottom: -1.5rem;\n  }\n  .xl\\:-ml-6 {\n    margin-left: -1.5rem;\n  }\n  .xl\\:-mt-7 {\n    margin-top: -1.75rem;\n  }\n  .xl\\:-mr-7 {\n    margin-right: -1.75rem;\n  }\n  .xl\\:-mb-7 {\n    margin-bottom: -1.75rem;\n  }\n  .xl\\:-ml-7 {\n    margin-left: -1.75rem;\n  }\n  .xl\\:-mt-8 {\n    margin-top: -2rem;\n  }\n  .xl\\:-mr-8 {\n    margin-right: -2rem;\n  }\n  .xl\\:-mb-8 {\n    margin-bottom: -2rem;\n  }\n  .xl\\:-ml-8 {\n    margin-left: -2rem;\n  }\n  .xl\\:-mt-9 {\n    margin-top: -2.25rem;\n  }\n  .xl\\:-mr-9 {\n    margin-right: -2.25rem;\n  }\n  .xl\\:-mb-9 {\n    margin-bottom: -2.25rem;\n  }\n  .xl\\:-ml-9 {\n    margin-left: -2.25rem;\n  }\n  .xl\\:-mt-10 {\n    margin-top: -2.5rem;\n  }\n  .xl\\:-mr-10 {\n    margin-right: -2.5rem;\n  }\n  .xl\\:-mb-10 {\n    margin-bottom: -2.5rem;\n  }\n  .xl\\:-ml-10 {\n    margin-left: -2.5rem;\n  }\n  .xl\\:-mt-11 {\n    margin-top: -2.75rem;\n  }\n  .xl\\:-mr-11 {\n    margin-right: -2.75rem;\n  }\n  .xl\\:-mb-11 {\n    margin-bottom: -2.75rem;\n  }\n  .xl\\:-ml-11 {\n    margin-left: -2.75rem;\n  }\n  .xl\\:-mt-12 {\n    margin-top: -3rem;\n  }\n  .xl\\:-mr-12 {\n    margin-right: -3rem;\n  }\n  .xl\\:-mb-12 {\n    margin-bottom: -3rem;\n  }\n  .xl\\:-ml-12 {\n    margin-left: -3rem;\n  }\n  .xl\\:-mt-13 {\n    margin-top: -3.25rem;\n  }\n  .xl\\:-mr-13 {\n    margin-right: -3.25rem;\n  }\n  .xl\\:-mb-13 {\n    margin-bottom: -3.25rem;\n  }\n  .xl\\:-ml-13 {\n    margin-left: -3.25rem;\n  }\n  .xl\\:-mt-14 {\n    margin-top: -3.5rem;\n  }\n  .xl\\:-mr-14 {\n    margin-right: -3.5rem;\n  }\n  .xl\\:-mb-14 {\n    margin-bottom: -3.5rem;\n  }\n  .xl\\:-ml-14 {\n    margin-left: -3.5rem;\n  }\n  .xl\\:-mt-15 {\n    margin-top: -3.75rem;\n  }\n  .xl\\:-mr-15 {\n    margin-right: -3.75rem;\n  }\n  .xl\\:-mb-15 {\n    margin-bottom: -3.75rem;\n  }\n  .xl\\:-ml-15 {\n    margin-left: -3.75rem;\n  }\n  .xl\\:-mt-16 {\n    margin-top: -4rem;\n  }\n  .xl\\:-mr-16 {\n    margin-right: -4rem;\n  }\n  .xl\\:-mb-16 {\n    margin-bottom: -4rem;\n  }\n  .xl\\:-ml-16 {\n    margin-left: -4rem;\n  }\n  .xl\\:-mt-20 {\n    margin-top: -5rem;\n  }\n  .xl\\:-mr-20 {\n    margin-right: -5rem;\n  }\n  .xl\\:-mb-20 {\n    margin-bottom: -5rem;\n  }\n  .xl\\:-ml-20 {\n    margin-left: -5rem;\n  }\n  .xl\\:-mt-24 {\n    margin-top: -6rem;\n  }\n  .xl\\:-mr-24 {\n    margin-right: -6rem;\n  }\n  .xl\\:-mb-24 {\n    margin-bottom: -6rem;\n  }\n  .xl\\:-ml-24 {\n    margin-left: -6rem;\n  }\n  .xl\\:-mt-28 {\n    margin-top: -7rem;\n  }\n  .xl\\:-mr-28 {\n    margin-right: -7rem;\n  }\n  .xl\\:-mb-28 {\n    margin-bottom: -7rem;\n  }\n  .xl\\:-ml-28 {\n    margin-left: -7rem;\n  }\n  .xl\\:-mt-32 {\n    margin-top: -8rem;\n  }\n  .xl\\:-mr-32 {\n    margin-right: -8rem;\n  }\n  .xl\\:-mb-32 {\n    margin-bottom: -8rem;\n  }\n  .xl\\:-ml-32 {\n    margin-left: -8rem;\n  }\n  .xl\\:-mt-36 {\n    margin-top: -9rem;\n  }\n  .xl\\:-mr-36 {\n    margin-right: -9rem;\n  }\n  .xl\\:-mb-36 {\n    margin-bottom: -9rem;\n  }\n  .xl\\:-ml-36 {\n    margin-left: -9rem;\n  }\n  .xl\\:-mt-40 {\n    margin-top: -10rem;\n  }\n  .xl\\:-mr-40 {\n    margin-right: -10rem;\n  }\n  .xl\\:-mb-40 {\n    margin-bottom: -10rem;\n  }\n  .xl\\:-ml-40 {\n    margin-left: -10rem;\n  }\n  .xl\\:-mt-44 {\n    margin-top: -11rem;\n  }\n  .xl\\:-mr-44 {\n    margin-right: -11rem;\n  }\n  .xl\\:-mb-44 {\n    margin-bottom: -11rem;\n  }\n  .xl\\:-ml-44 {\n    margin-left: -11rem;\n  }\n  .xl\\:-mt-48 {\n    margin-top: -12rem;\n  }\n  .xl\\:-mr-48 {\n    margin-right: -12rem;\n  }\n  .xl\\:-mb-48 {\n    margin-bottom: -12rem;\n  }\n  .xl\\:-ml-48 {\n    margin-left: -12rem;\n  }\n  .xl\\:-mt-52 {\n    margin-top: -13rem;\n  }\n  .xl\\:-mr-52 {\n    margin-right: -13rem;\n  }\n  .xl\\:-mb-52 {\n    margin-bottom: -13rem;\n  }\n  .xl\\:-ml-52 {\n    margin-left: -13rem;\n  }\n  .xl\\:-mt-56 {\n    margin-top: -14rem;\n  }\n  .xl\\:-mr-56 {\n    margin-right: -14rem;\n  }\n  .xl\\:-mb-56 {\n    margin-bottom: -14rem;\n  }\n  .xl\\:-ml-56 {\n    margin-left: -14rem;\n  }\n  .xl\\:-mt-60 {\n    margin-top: -15rem;\n  }\n  .xl\\:-mr-60 {\n    margin-right: -15rem;\n  }\n  .xl\\:-mb-60 {\n    margin-bottom: -15rem;\n  }\n  .xl\\:-ml-60 {\n    margin-left: -15rem;\n  }\n  .xl\\:-mt-64 {\n    margin-top: -16rem;\n  }\n  .xl\\:-mr-64 {\n    margin-right: -16rem;\n  }\n  .xl\\:-mb-64 {\n    margin-bottom: -16rem;\n  }\n  .xl\\:-ml-64 {\n    margin-left: -16rem;\n  }\n  .xl\\:-mt-72 {\n    margin-top: -18rem;\n  }\n  .xl\\:-mr-72 {\n    margin-right: -18rem;\n  }\n  .xl\\:-mb-72 {\n    margin-bottom: -18rem;\n  }\n  .xl\\:-ml-72 {\n    margin-left: -18rem;\n  }\n  .xl\\:-mt-80 {\n    margin-top: -20rem;\n  }\n  .xl\\:-mr-80 {\n    margin-right: -20rem;\n  }\n  .xl\\:-mb-80 {\n    margin-bottom: -20rem;\n  }\n  .xl\\:-ml-80 {\n    margin-left: -20rem;\n  }\n  .xl\\:-mt-96 {\n    margin-top: -24rem;\n  }\n  .xl\\:-mr-96 {\n    margin-right: -24rem;\n  }\n  .xl\\:-mb-96 {\n    margin-bottom: -24rem;\n  }\n  .xl\\:-ml-96 {\n    margin-left: -24rem;\n  }\n  .xl\\:-mt-px {\n    margin-top: -1px;\n  }\n  .xl\\:-mr-px {\n    margin-right: -1px;\n  }\n  .xl\\:-mb-px {\n    margin-bottom: -1px;\n  }\n  .xl\\:-ml-px {\n    margin-left: -1px;\n  }\n  .xl\\:-mt-0\\.5 {\n    margin-top: -0.125rem;\n  }\n  .xl\\:-mr-0\\.5 {\n    margin-right: -0.125rem;\n  }\n  .xl\\:-mb-0\\.5 {\n    margin-bottom: -0.125rem;\n  }\n  .xl\\:-ml-0\\.5 {\n    margin-left: -0.125rem;\n  }\n  .xl\\:-mt-1\\.5 {\n    margin-top: -0.375rem;\n  }\n  .xl\\:-mr-1\\.5 {\n    margin-right: -0.375rem;\n  }\n  .xl\\:-mb-1\\.5 {\n    margin-bottom: -0.375rem;\n  }\n  .xl\\:-ml-1\\.5 {\n    margin-left: -0.375rem;\n  }\n  .xl\\:-mt-2\\.5 {\n    margin-top: -0.625rem;\n  }\n  .xl\\:-mr-2\\.5 {\n    margin-right: -0.625rem;\n  }\n  .xl\\:-mb-2\\.5 {\n    margin-bottom: -0.625rem;\n  }\n  .xl\\:-ml-2\\.5 {\n    margin-left: -0.625rem;\n  }\n  .xl\\:-mt-3\\.5 {\n    margin-top: -0.875rem;\n  }\n  .xl\\:-mr-3\\.5 {\n    margin-right: -0.875rem;\n  }\n  .xl\\:-mb-3\\.5 {\n    margin-bottom: -0.875rem;\n  }\n  .xl\\:-ml-3\\.5 {\n    margin-left: -0.875rem;\n  }\n  .xl\\:-mt-1\\/2 {\n    margin-top: -50%;\n  }\n  .xl\\:-mr-1\\/2 {\n    margin-right: -50%;\n  }\n  .xl\\:-mb-1\\/2 {\n    margin-bottom: -50%;\n  }\n  .xl\\:-ml-1\\/2 {\n    margin-left: -50%;\n  }\n  .xl\\:-mt-1\\/3 {\n    margin-top: -33.33333%;\n  }\n  .xl\\:-mr-1\\/3 {\n    margin-right: -33.33333%;\n  }\n  .xl\\:-mb-1\\/3 {\n    margin-bottom: -33.33333%;\n  }\n  .xl\\:-ml-1\\/3 {\n    margin-left: -33.33333%;\n  }\n  .xl\\:-mt-2\\/3 {\n    margin-top: -66.66667%;\n  }\n  .xl\\:-mr-2\\/3 {\n    margin-right: -66.66667%;\n  }\n  .xl\\:-mb-2\\/3 {\n    margin-bottom: -66.66667%;\n  }\n  .xl\\:-ml-2\\/3 {\n    margin-left: -66.66667%;\n  }\n  .xl\\:-mt-1\\/4 {\n    margin-top: -25%;\n  }\n  .xl\\:-mr-1\\/4 {\n    margin-right: -25%;\n  }\n  .xl\\:-mb-1\\/4 {\n    margin-bottom: -25%;\n  }\n  .xl\\:-ml-1\\/4 {\n    margin-left: -25%;\n  }\n  .xl\\:-mt-2\\/4 {\n    margin-top: -50%;\n  }\n  .xl\\:-mr-2\\/4 {\n    margin-right: -50%;\n  }\n  .xl\\:-mb-2\\/4 {\n    margin-bottom: -50%;\n  }\n  .xl\\:-ml-2\\/4 {\n    margin-left: -50%;\n  }\n  .xl\\:-mt-3\\/4 {\n    margin-top: -75%;\n  }\n  .xl\\:-mr-3\\/4 {\n    margin-right: -75%;\n  }\n  .xl\\:-mb-3\\/4 {\n    margin-bottom: -75%;\n  }\n  .xl\\:-ml-3\\/4 {\n    margin-left: -75%;\n  }\n  .xl\\:-mt-1\\/5 {\n    margin-top: -20%;\n  }\n  .xl\\:-mr-1\\/5 {\n    margin-right: -20%;\n  }\n  .xl\\:-mb-1\\/5 {\n    margin-bottom: -20%;\n  }\n  .xl\\:-ml-1\\/5 {\n    margin-left: -20%;\n  }\n  .xl\\:-mt-2\\/5 {\n    margin-top: -40%;\n  }\n  .xl\\:-mr-2\\/5 {\n    margin-right: -40%;\n  }\n  .xl\\:-mb-2\\/5 {\n    margin-bottom: -40%;\n  }\n  .xl\\:-ml-2\\/5 {\n    margin-left: -40%;\n  }\n  .xl\\:-mt-3\\/5 {\n    margin-top: -60%;\n  }\n  .xl\\:-mr-3\\/5 {\n    margin-right: -60%;\n  }\n  .xl\\:-mb-3\\/5 {\n    margin-bottom: -60%;\n  }\n  .xl\\:-ml-3\\/5 {\n    margin-left: -60%;\n  }\n  .xl\\:-mt-4\\/5 {\n    margin-top: -80%;\n  }\n  .xl\\:-mr-4\\/5 {\n    margin-right: -80%;\n  }\n  .xl\\:-mb-4\\/5 {\n    margin-bottom: -80%;\n  }\n  .xl\\:-ml-4\\/5 {\n    margin-left: -80%;\n  }\n  .xl\\:-mt-1\\/6 {\n    margin-top: -16.66667%;\n  }\n  .xl\\:-mr-1\\/6 {\n    margin-right: -16.66667%;\n  }\n  .xl\\:-mb-1\\/6 {\n    margin-bottom: -16.66667%;\n  }\n  .xl\\:-ml-1\\/6 {\n    margin-left: -16.66667%;\n  }\n  .xl\\:-mt-2\\/6 {\n    margin-top: -33.33333%;\n  }\n  .xl\\:-mr-2\\/6 {\n    margin-right: -33.33333%;\n  }\n  .xl\\:-mb-2\\/6 {\n    margin-bottom: -33.33333%;\n  }\n  .xl\\:-ml-2\\/6 {\n    margin-left: -33.33333%;\n  }\n  .xl\\:-mt-3\\/6 {\n    margin-top: -50%;\n  }\n  .xl\\:-mr-3\\/6 {\n    margin-right: -50%;\n  }\n  .xl\\:-mb-3\\/6 {\n    margin-bottom: -50%;\n  }\n  .xl\\:-ml-3\\/6 {\n    margin-left: -50%;\n  }\n  .xl\\:-mt-4\\/6 {\n    margin-top: -66.66667%;\n  }\n  .xl\\:-mr-4\\/6 {\n    margin-right: -66.66667%;\n  }\n  .xl\\:-mb-4\\/6 {\n    margin-bottom: -66.66667%;\n  }\n  .xl\\:-ml-4\\/6 {\n    margin-left: -66.66667%;\n  }\n  .xl\\:-mt-5\\/6 {\n    margin-top: -83.33333%;\n  }\n  .xl\\:-mr-5\\/6 {\n    margin-right: -83.33333%;\n  }\n  .xl\\:-mb-5\\/6 {\n    margin-bottom: -83.33333%;\n  }\n  .xl\\:-ml-5\\/6 {\n    margin-left: -83.33333%;\n  }\n  .xl\\:-mt-1\\/12 {\n    margin-top: -8.33333%;\n  }\n  .xl\\:-mr-1\\/12 {\n    margin-right: -8.33333%;\n  }\n  .xl\\:-mb-1\\/12 {\n    margin-bottom: -8.33333%;\n  }\n  .xl\\:-ml-1\\/12 {\n    margin-left: -8.33333%;\n  }\n  .xl\\:-mt-2\\/12 {\n    margin-top: -16.66667%;\n  }\n  .xl\\:-mr-2\\/12 {\n    margin-right: -16.66667%;\n  }\n  .xl\\:-mb-2\\/12 {\n    margin-bottom: -16.66667%;\n  }\n  .xl\\:-ml-2\\/12 {\n    margin-left: -16.66667%;\n  }\n  .xl\\:-mt-3\\/12 {\n    margin-top: -25%;\n  }\n  .xl\\:-mr-3\\/12 {\n    margin-right: -25%;\n  }\n  .xl\\:-mb-3\\/12 {\n    margin-bottom: -25%;\n  }\n  .xl\\:-ml-3\\/12 {\n    margin-left: -25%;\n  }\n  .xl\\:-mt-4\\/12 {\n    margin-top: -33.33333%;\n  }\n  .xl\\:-mr-4\\/12 {\n    margin-right: -33.33333%;\n  }\n  .xl\\:-mb-4\\/12 {\n    margin-bottom: -33.33333%;\n  }\n  .xl\\:-ml-4\\/12 {\n    margin-left: -33.33333%;\n  }\n  .xl\\:-mt-5\\/12 {\n    margin-top: -41.66667%;\n  }\n  .xl\\:-mr-5\\/12 {\n    margin-right: -41.66667%;\n  }\n  .xl\\:-mb-5\\/12 {\n    margin-bottom: -41.66667%;\n  }\n  .xl\\:-ml-5\\/12 {\n    margin-left: -41.66667%;\n  }\n  .xl\\:-mt-6\\/12 {\n    margin-top: -50%;\n  }\n  .xl\\:-mr-6\\/12 {\n    margin-right: -50%;\n  }\n  .xl\\:-mb-6\\/12 {\n    margin-bottom: -50%;\n  }\n  .xl\\:-ml-6\\/12 {\n    margin-left: -50%;\n  }\n  .xl\\:-mt-7\\/12 {\n    margin-top: -58.33333%;\n  }\n  .xl\\:-mr-7\\/12 {\n    margin-right: -58.33333%;\n  }\n  .xl\\:-mb-7\\/12 {\n    margin-bottom: -58.33333%;\n  }\n  .xl\\:-ml-7\\/12 {\n    margin-left: -58.33333%;\n  }\n  .xl\\:-mt-8\\/12 {\n    margin-top: -66.66667%;\n  }\n  .xl\\:-mr-8\\/12 {\n    margin-right: -66.66667%;\n  }\n  .xl\\:-mb-8\\/12 {\n    margin-bottom: -66.66667%;\n  }\n  .xl\\:-ml-8\\/12 {\n    margin-left: -66.66667%;\n  }\n  .xl\\:-mt-9\\/12 {\n    margin-top: -75%;\n  }\n  .xl\\:-mr-9\\/12 {\n    margin-right: -75%;\n  }\n  .xl\\:-mb-9\\/12 {\n    margin-bottom: -75%;\n  }\n  .xl\\:-ml-9\\/12 {\n    margin-left: -75%;\n  }\n  .xl\\:-mt-10\\/12 {\n    margin-top: -83.33333%;\n  }\n  .xl\\:-mr-10\\/12 {\n    margin-right: -83.33333%;\n  }\n  .xl\\:-mb-10\\/12 {\n    margin-bottom: -83.33333%;\n  }\n  .xl\\:-ml-10\\/12 {\n    margin-left: -83.33333%;\n  }\n  .xl\\:-mt-11\\/12 {\n    margin-top: -91.66667%;\n  }\n  .xl\\:-mr-11\\/12 {\n    margin-right: -91.66667%;\n  }\n  .xl\\:-mb-11\\/12 {\n    margin-bottom: -91.66667%;\n  }\n  .xl\\:-ml-11\\/12 {\n    margin-left: -91.66667%;\n  }\n  .xl\\:-mt-full {\n    margin-top: -100%;\n  }\n  .xl\\:-mr-full {\n    margin-right: -100%;\n  }\n  .xl\\:-mb-full {\n    margin-bottom: -100%;\n  }\n  .xl\\:-ml-full {\n    margin-left: -100%;\n  }\n  .xl\\:max-h-0 {\n    max-height: 0;\n  }\n  .xl\\:max-h-1 {\n    max-height: 0.25rem;\n  }\n  .xl\\:max-h-2 {\n    max-height: 0.5rem;\n  }\n  .xl\\:max-h-3 {\n    max-height: 0.75rem;\n  }\n  .xl\\:max-h-4 {\n    max-height: 1rem;\n  }\n  .xl\\:max-h-5 {\n    max-height: 1.25rem;\n  }\n  .xl\\:max-h-6 {\n    max-height: 1.5rem;\n  }\n  .xl\\:max-h-7 {\n    max-height: 1.75rem;\n  }\n  .xl\\:max-h-8 {\n    max-height: 2rem;\n  }\n  .xl\\:max-h-9 {\n    max-height: 2.25rem;\n  }\n  .xl\\:max-h-10 {\n    max-height: 2.5rem;\n  }\n  .xl\\:max-h-11 {\n    max-height: 2.75rem;\n  }\n  .xl\\:max-h-12 {\n    max-height: 3rem;\n  }\n  .xl\\:max-h-13 {\n    max-height: 3.25rem;\n  }\n  .xl\\:max-h-14 {\n    max-height: 3.5rem;\n  }\n  .xl\\:max-h-15 {\n    max-height: 3.75rem;\n  }\n  .xl\\:max-h-16 {\n    max-height: 4rem;\n  }\n  .xl\\:max-h-20 {\n    max-height: 5rem;\n  }\n  .xl\\:max-h-24 {\n    max-height: 6rem;\n  }\n  .xl\\:max-h-28 {\n    max-height: 7rem;\n  }\n  .xl\\:max-h-32 {\n    max-height: 8rem;\n  }\n  .xl\\:max-h-36 {\n    max-height: 9rem;\n  }\n  .xl\\:max-h-40 {\n    max-height: 10rem;\n  }\n  .xl\\:max-h-44 {\n    max-height: 11rem;\n  }\n  .xl\\:max-h-48 {\n    max-height: 12rem;\n  }\n  .xl\\:max-h-52 {\n    max-height: 13rem;\n  }\n  .xl\\:max-h-56 {\n    max-height: 14rem;\n  }\n  .xl\\:max-h-60 {\n    max-height: 15rem;\n  }\n  .xl\\:max-h-64 {\n    max-height: 16rem;\n  }\n  .xl\\:max-h-72 {\n    max-height: 18rem;\n  }\n  .xl\\:max-h-80 {\n    max-height: 20rem;\n  }\n  .xl\\:max-h-96 {\n    max-height: 24rem;\n  }\n  .xl\\:max-h-screen {\n    max-height: 100vh;\n  }\n  .xl\\:max-h-px {\n    max-height: 1px;\n  }\n  .xl\\:max-h-0\\.5 {\n    max-height: 0.125rem;\n  }\n  .xl\\:max-h-1\\.5 {\n    max-height: 0.375rem;\n  }\n  .xl\\:max-h-2\\.5 {\n    max-height: 0.625rem;\n  }\n  .xl\\:max-h-3\\.5 {\n    max-height: 0.875rem;\n  }\n  .xl\\:max-h-1\\/2 {\n    max-height: 50%;\n  }\n  .xl\\:max-h-1\\/3 {\n    max-height: 33.333333%;\n  }\n  .xl\\:max-h-2\\/3 {\n    max-height: 66.666667%;\n  }\n  .xl\\:max-h-1\\/4 {\n    max-height: 25%;\n  }\n  .xl\\:max-h-2\\/4 {\n    max-height: 50%;\n  }\n  .xl\\:max-h-3\\/4 {\n    max-height: 75%;\n  }\n  .xl\\:max-h-1\\/5 {\n    max-height: 20%;\n  }\n  .xl\\:max-h-2\\/5 {\n    max-height: 40%;\n  }\n  .xl\\:max-h-3\\/5 {\n    max-height: 60%;\n  }\n  .xl\\:max-h-4\\/5 {\n    max-height: 80%;\n  }\n  .xl\\:max-h-1\\/6 {\n    max-height: 16.666667%;\n  }\n  .xl\\:max-h-2\\/6 {\n    max-height: 33.333333%;\n  }\n  .xl\\:max-h-3\\/6 {\n    max-height: 50%;\n  }\n  .xl\\:max-h-4\\/6 {\n    max-height: 66.666667%;\n  }\n  .xl\\:max-h-5\\/6 {\n    max-height: 83.333333%;\n  }\n  .xl\\:max-h-1\\/12 {\n    max-height: 8.333333%;\n  }\n  .xl\\:max-h-2\\/12 {\n    max-height: 16.666667%;\n  }\n  .xl\\:max-h-3\\/12 {\n    max-height: 25%;\n  }\n  .xl\\:max-h-4\\/12 {\n    max-height: 33.333333%;\n  }\n  .xl\\:max-h-5\\/12 {\n    max-height: 41.666667%;\n  }\n  .xl\\:max-h-6\\/12 {\n    max-height: 50%;\n  }\n  .xl\\:max-h-7\\/12 {\n    max-height: 58.333333%;\n  }\n  .xl\\:max-h-8\\/12 {\n    max-height: 66.666667%;\n  }\n  .xl\\:max-h-9\\/12 {\n    max-height: 75%;\n  }\n  .xl\\:max-h-10\\/12 {\n    max-height: 83.333333%;\n  }\n  .xl\\:max-h-11\\/12 {\n    max-height: 91.666667%;\n  }\n  .xl\\:max-h-full {\n    max-height: 100%;\n  }\n  .xl\\:max-w-0 {\n    max-width: 0rem;\n  }\n  .xl\\:max-w-none {\n    max-width: none;\n  }\n  .xl\\:max-w-xs {\n    max-width: 20rem;\n  }\n  .xl\\:max-w-sm {\n    max-width: 24rem;\n  }\n  .xl\\:max-w-md {\n    max-width: 28rem;\n  }\n  .xl\\:max-w-lg {\n    max-width: 32rem;\n  }\n  .xl\\:max-w-xl {\n    max-width: 36rem;\n  }\n  .xl\\:max-w-2xl {\n    max-width: 42rem;\n  }\n  .xl\\:max-w-3xl {\n    max-width: 48rem;\n  }\n  .xl\\:max-w-4xl {\n    max-width: 56rem;\n  }\n  .xl\\:max-w-5xl {\n    max-width: 64rem;\n  }\n  .xl\\:max-w-6xl {\n    max-width: 72rem;\n  }\n  .xl\\:max-w-7xl {\n    max-width: 80rem;\n  }\n  .xl\\:max-w-full {\n    max-width: 100%;\n  }\n  .xl\\:max-w-min-content {\n    max-width: -moz-min-content;\n    max-width: min-content;\n  }\n  .xl\\:max-w-max-content {\n    max-width: -moz-max-content;\n    max-width: max-content;\n  }\n  .xl\\:max-w-prose {\n    max-width: 65ch;\n  }\n  .xl\\:max-w-screen-sm {\n    max-width: 640px;\n  }\n  .xl\\:max-w-screen-md {\n    max-width: 768px;\n  }\n  .xl\\:max-w-screen-lg {\n    max-width: 1024px;\n  }\n  .xl\\:max-w-screen-xl {\n    max-width: 1280px;\n  }\n  .xl\\:min-h-0 {\n    min-height: 0;\n  }\n  .xl\\:min-h-full {\n    min-height: 100%;\n  }\n  .xl\\:min-h-screen {\n    min-height: 100vh;\n  }\n  .xl\\:min-w-0 {\n    min-width: 0;\n  }\n  .xl\\:min-w-full {\n    min-width: 100%;\n  }\n  .xl\\:min-w-min-content {\n    min-width: -moz-min-content;\n    min-width: min-content;\n  }\n  .xl\\:min-w-max-content {\n    min-width: -moz-max-content;\n    min-width: max-content;\n  }\n  .xl\\:object-contain {\n    -o-object-fit: contain;\n    object-fit: contain;\n  }\n  .xl\\:object-cover {\n    -o-object-fit: cover;\n    object-fit: cover;\n  }\n  .xl\\:object-fill {\n    -o-object-fit: fill;\n    object-fit: fill;\n  }\n  .xl\\:object-none {\n    -o-object-fit: none;\n    object-fit: none;\n  }\n  .xl\\:object-scale-down {\n    -o-object-fit: scale-down;\n    object-fit: scale-down;\n  }\n  .xl\\:object-bottom {\n    -o-object-position: bottom;\n    object-position: bottom;\n  }\n  .xl\\:object-center {\n    -o-object-position: center;\n    object-position: center;\n  }\n  .xl\\:object-left {\n    -o-object-position: left;\n    object-position: left;\n  }\n  .xl\\:object-left-bottom {\n    -o-object-position: left bottom;\n    object-position: left bottom;\n  }\n  .xl\\:object-left-top {\n    -o-object-position: left top;\n    object-position: left top;\n  }\n  .xl\\:object-right {\n    -o-object-position: right;\n    object-position: right;\n  }\n  .xl\\:object-right-bottom {\n    -o-object-position: right bottom;\n    object-position: right bottom;\n  }\n  .xl\\:object-right-top {\n    -o-object-position: right top;\n    object-position: right top;\n  }\n  .xl\\:object-top {\n    -o-object-position: top;\n    object-position: top;\n  }\n  .xl\\:opacity-0 {\n    opacity: 0;\n  }\n  .xl\\:opacity-25 {\n    opacity: 0.25;\n  }\n  .xl\\:opacity-50 {\n    opacity: 0.5;\n  }\n  .xl\\:opacity-75 {\n    opacity: 0.75;\n  }\n  .xl\\:opacity-100 {\n    opacity: 1;\n  }\n  .xl\\:focus-within\\:opacity-0:focus-within {\n    opacity: 0;\n  }\n  .xl\\:focus-within\\:opacity-25:focus-within {\n    opacity: 0.25;\n  }\n  .xl\\:focus-within\\:opacity-50:focus-within {\n    opacity: 0.5;\n  }\n  .xl\\:focus-within\\:opacity-75:focus-within {\n    opacity: 0.75;\n  }\n  .xl\\:focus-within\\:opacity-100:focus-within {\n    opacity: 1;\n  }\n  .group:hover .xl\\:group-hover\\:opacity-0 {\n    opacity: 0;\n  }\n  .group:hover .xl\\:group-hover\\:opacity-25 {\n    opacity: 0.25;\n  }\n  .group:hover .xl\\:group-hover\\:opacity-50 {\n    opacity: 0.5;\n  }\n  .group:hover .xl\\:group-hover\\:opacity-75 {\n    opacity: 0.75;\n  }\n  .group:hover .xl\\:group-hover\\:opacity-100 {\n    opacity: 1;\n  }\n  .group:focus .xl\\:group-focus\\:opacity-0 {\n    opacity: 0;\n  }\n  .group:focus .xl\\:group-focus\\:opacity-25 {\n    opacity: 0.25;\n  }\n  .group:focus .xl\\:group-focus\\:opacity-50 {\n    opacity: 0.5;\n  }\n  .group:focus .xl\\:group-focus\\:opacity-75 {\n    opacity: 0.75;\n  }\n  .group:focus .xl\\:group-focus\\:opacity-100 {\n    opacity: 1;\n  }\n  .xl\\:hover\\:opacity-0:hover {\n    opacity: 0;\n  }\n  .xl\\:hover\\:opacity-25:hover {\n    opacity: 0.25;\n  }\n  .xl\\:hover\\:opacity-50:hover {\n    opacity: 0.5;\n  }\n  .xl\\:hover\\:opacity-75:hover {\n    opacity: 0.75;\n  }\n  .xl\\:hover\\:opacity-100:hover {\n    opacity: 1;\n  }\n  .xl\\:focus\\:opacity-0:focus {\n    opacity: 0;\n  }\n  .xl\\:focus\\:opacity-25:focus {\n    opacity: 0.25;\n  }\n  .xl\\:focus\\:opacity-50:focus {\n    opacity: 0.5;\n  }\n  .xl\\:focus\\:opacity-75:focus {\n    opacity: 0.75;\n  }\n  .xl\\:focus\\:opacity-100:focus {\n    opacity: 1;\n  }\n  .xl\\:outline-none {\n    outline: 2px solid transparent;\n    outline-offset: 2px;\n  }\n  .xl\\:outline-white {\n    outline: 2px dotted white;\n    outline-offset: 2px;\n  }\n  .xl\\:outline-black {\n    outline: 2px dotted black;\n    outline-offset: 2px;\n  }\n  .xl\\:focus\\:outline-none:focus {\n    outline: 2px solid transparent;\n    outline-offset: 2px;\n  }\n  .xl\\:focus\\:outline-white:focus {\n    outline: 2px dotted white;\n    outline-offset: 2px;\n  }\n  .xl\\:focus\\:outline-black:focus {\n    outline: 2px dotted black;\n    outline-offset: 2px;\n  }\n  .xl\\:overflow-auto {\n    overflow: auto;\n  }\n  .xl\\:overflow-hidden {\n    overflow: hidden;\n  }\n  .xl\\:overflow-visible {\n    overflow: visible;\n  }\n  .xl\\:overflow-scroll {\n    overflow: scroll;\n  }\n  .xl\\:overflow-x-auto {\n    overflow-x: hidden;\n  }\n  .xl\\:overflow-y-auto {\n    overflow-y: auto;\n  }\n  .xl\\:overflow-x-hidden {\n    overflow-x: hidden;\n  }\n  .xl\\:overflow-y-hidden {\n    overflow-y: hidden;\n  }\n  .xl\\:overflow-x-visible {\n    overflow-x: visible;\n  }\n  .xl\\:overflow-y-visible {\n    overflow-y: visible;\n  }\n  .xl\\:overflow-x-scroll {\n    overflow-x: hidden;\n  }\n  .xl\\:overflow-y-scroll {\n    overflow-y: scroll;\n  }\n  .xl\\:scrolling-touch {\n    -webkit-overflow-scrolling: touch;\n  }\n  .xl\\:scrolling-auto {\n    -webkit-overflow-scrolling: auto;\n  }\n  .xl\\:overscroll-auto {\n    overscroll-behavior: auto;\n  }\n  .xl\\:overscroll-contain {\n    overscroll-behavior: contain;\n  }\n  .xl\\:overscroll-none {\n    overscroll-behavior: none;\n  }\n  .xl\\:overscroll-y-auto {\n    overscroll-behavior-y: auto;\n  }\n  .xl\\:overscroll-y-contain {\n    overscroll-behavior-y: contain;\n  }\n  .xl\\:overscroll-y-none {\n    overscroll-behavior-y: none;\n  }\n  .xl\\:overscroll-x-auto {\n    overscroll-behavior-x: auto;\n  }\n  .xl\\:overscroll-x-contain {\n    overscroll-behavior-x: contain;\n  }\n  .xl\\:overscroll-x-none {\n    overscroll-behavior-x: none;\n  }\n  .xl\\:p-0 {\n    padding: 0;\n  }\n  .xl\\:p-1 {\n    padding: 0.25rem;\n  }\n  .xl\\:p-2 {\n    padding: 0.5rem;\n  }\n  .xl\\:p-3 {\n    padding: 0.75rem;\n  }\n  .xl\\:p-4 {\n    padding: 1rem;\n  }\n  .xl\\:p-5 {\n    padding: 1.25rem;\n  }\n  .xl\\:p-6 {\n    padding: 1.5rem;\n  }\n  .xl\\:p-7 {\n    padding: 1.75rem;\n  }\n  .xl\\:p-8 {\n    padding: 2rem;\n  }\n  .xl\\:p-9 {\n    padding: 2.25rem;\n  }\n  .xl\\:p-10 {\n    padding: 2.5rem;\n  }\n  .xl\\:p-11 {\n    padding: 2.75rem;\n  }\n  .xl\\:p-12 {\n    padding: 3rem;\n  }\n  .xl\\:p-13 {\n    padding: 3.25rem;\n  }\n  .xl\\:p-14 {\n    padding: 3.5rem;\n  }\n  .xl\\:p-15 {\n    padding: 3.75rem;\n  }\n  .xl\\:p-16 {\n    padding: 4rem;\n  }\n  .xl\\:p-20 {\n    padding: 5rem;\n  }\n  .xl\\:p-24 {\n    padding: 6rem;\n  }\n  .xl\\:p-28 {\n    padding: 7rem;\n  }\n  .xl\\:p-32 {\n    padding: 8rem;\n  }\n  .xl\\:p-36 {\n    padding: 9rem;\n  }\n  .xl\\:p-40 {\n    padding: 10rem;\n  }\n  .xl\\:p-44 {\n    padding: 11rem;\n  }\n  .xl\\:p-48 {\n    padding: 12rem;\n  }\n  .xl\\:p-52 {\n    padding: 13rem;\n  }\n  .xl\\:p-56 {\n    padding: 14rem;\n  }\n  .xl\\:p-60 {\n    padding: 15rem;\n  }\n  .xl\\:p-64 {\n    padding: 16rem;\n  }\n  .xl\\:p-72 {\n    padding: 18rem;\n  }\n  .xl\\:p-80 {\n    padding: 20rem;\n  }\n  .xl\\:p-96 {\n    padding: 24rem;\n  }\n  .xl\\:p-px {\n    padding: 1px;\n  }\n  .xl\\:p-0\\.5 {\n    padding: 0.125rem;\n  }\n  .xl\\:p-1\\.5 {\n    padding: 0.375rem;\n  }\n  .xl\\:p-2\\.5 {\n    padding: 0.625rem;\n  }\n  .xl\\:p-3\\.5 {\n    padding: 0.875rem;\n  }\n  .xl\\:p-1\\/2 {\n    padding: 50%;\n  }\n  .xl\\:p-1\\/3 {\n    padding: 33.333333%;\n  }\n  .xl\\:p-2\\/3 {\n    padding: 66.666667%;\n  }\n  .xl\\:p-1\\/4 {\n    padding: 25%;\n  }\n  .xl\\:p-2\\/4 {\n    padding: 50%;\n  }\n  .xl\\:p-3\\/4 {\n    padding: 75%;\n  }\n  .xl\\:p-1\\/5 {\n    padding: 20%;\n  }\n  .xl\\:p-2\\/5 {\n    padding: 40%;\n  }\n  .xl\\:p-3\\/5 {\n    padding: 60%;\n  }\n  .xl\\:p-4\\/5 {\n    padding: 80%;\n  }\n  .xl\\:p-1\\/6 {\n    padding: 16.666667%;\n  }\n  .xl\\:p-2\\/6 {\n    padding: 33.333333%;\n  }\n  .xl\\:p-3\\/6 {\n    padding: 50%;\n  }\n  .xl\\:p-4\\/6 {\n    padding: 66.666667%;\n  }\n  .xl\\:p-5\\/6 {\n    padding: 83.333333%;\n  }\n  .xl\\:p-1\\/12 {\n    padding: 8.333333%;\n  }\n  .xl\\:p-2\\/12 {\n    padding: 16.666667%;\n  }\n  .xl\\:p-3\\/12 {\n    padding: 25%;\n  }\n  .xl\\:p-4\\/12 {\n    padding: 33.333333%;\n  }\n  .xl\\:p-5\\/12 {\n    padding: 41.666667%;\n  }\n  .xl\\:p-6\\/12 {\n    padding: 50%;\n  }\n  .xl\\:p-7\\/12 {\n    padding: 58.333333%;\n  }\n  .xl\\:p-8\\/12 {\n    padding: 66.666667%;\n  }\n  .xl\\:p-9\\/12 {\n    padding: 75%;\n  }\n  .xl\\:p-10\\/12 {\n    padding: 83.333333%;\n  }\n  .xl\\:p-11\\/12 {\n    padding: 91.666667%;\n  }\n  .xl\\:p-full {\n    padding: 100%;\n  }\n  .xl\\:py-0 {\n    padding-top: 0;\n    padding-bottom: 0;\n  }\n  .xl\\:px-0 {\n    padding-left: 0;\n    padding-right: 0;\n  }\n  .xl\\:py-1 {\n    padding-top: 0.25rem;\n    padding-bottom: 0.25rem;\n  }\n  .xl\\:px-1 {\n    padding-left: 0.25rem;\n    padding-right: 0.25rem;\n  }\n  .xl\\:py-2 {\n    padding-top: 0.5rem;\n    padding-bottom: 0.5rem;\n  }\n  .xl\\:px-2 {\n    padding-left: 0.5rem;\n    padding-right: 0.5rem;\n  }\n  .xl\\:py-3 {\n    padding-top: 0.75rem;\n    padding-bottom: 0.75rem;\n  }\n  .xl\\:px-3 {\n    padding-left: 0.75rem;\n    padding-right: 0.75rem;\n  }\n  .xl\\:py-4 {\n    padding-top: 1rem;\n    padding-bottom: 1rem;\n  }\n  .xl\\:px-4 {\n    padding-left: 1rem;\n    padding-right: 1rem;\n  }\n  .xl\\:py-5 {\n    padding-top: 1.25rem;\n    padding-bottom: 1.25rem;\n  }\n  .xl\\:px-5 {\n    padding-left: 1.25rem;\n    padding-right: 1.25rem;\n  }\n  .xl\\:py-6 {\n    padding-top: 1.5rem;\n    padding-bottom: 1.5rem;\n  }\n  .xl\\:px-6 {\n    padding-left: 1.5rem;\n    padding-right: 1.5rem;\n  }\n  .xl\\:py-7 {\n    padding-top: 1.75rem;\n    padding-bottom: 1.75rem;\n  }\n  .xl\\:px-7 {\n    padding-left: 1.75rem;\n    padding-right: 1.75rem;\n  }\n  .xl\\:py-8 {\n    padding-top: 2rem;\n    padding-bottom: 2rem;\n  }\n  .xl\\:px-8 {\n    padding-left: 2rem;\n    padding-right: 2rem;\n  }\n  .xl\\:py-9 {\n    padding-top: 2.25rem;\n    padding-bottom: 2.25rem;\n  }\n  .xl\\:px-9 {\n    padding-left: 2.25rem;\n    padding-right: 2.25rem;\n  }\n  .xl\\:py-10 {\n    padding-top: 2.5rem;\n    padding-bottom: 2.5rem;\n  }\n  .xl\\:px-10 {\n    padding-left: 2.5rem;\n    padding-right: 2.5rem;\n  }\n  .xl\\:py-11 {\n    padding-top: 2.75rem;\n    padding-bottom: 2.75rem;\n  }\n  .xl\\:px-11 {\n    padding-left: 2.75rem;\n    padding-right: 2.75rem;\n  }\n  .xl\\:py-12 {\n    padding-top: 3rem;\n    padding-bottom: 3rem;\n  }\n  .xl\\:px-12 {\n    padding-left: 3rem;\n    padding-right: 3rem;\n  }\n  .xl\\:py-13 {\n    padding-top: 3.25rem;\n    padding-bottom: 3.25rem;\n  }\n  .xl\\:px-13 {\n    padding-left: 3.25rem;\n    padding-right: 3.25rem;\n  }\n  .xl\\:py-14 {\n    padding-top: 3.5rem;\n    padding-bottom: 3.5rem;\n  }\n  .xl\\:px-14 {\n    padding-left: 3.5rem;\n    padding-right: 3.5rem;\n  }\n  .xl\\:py-15 {\n    padding-top: 3.75rem;\n    padding-bottom: 3.75rem;\n  }\n  .xl\\:px-15 {\n    padding-left: 3.75rem;\n    padding-right: 3.75rem;\n  }\n  .xl\\:py-16 {\n    padding-top: 4rem;\n    padding-bottom: 4rem;\n  }\n  .xl\\:px-16 {\n    padding-left: 4rem;\n    padding-right: 4rem;\n  }\n  .xl\\:py-20 {\n    padding-top: 5rem;\n    padding-bottom: 5rem;\n  }\n  .xl\\:px-20 {\n    padding-left: 5rem;\n    padding-right: 5rem;\n  }\n  .xl\\:py-24 {\n    padding-top: 6rem;\n    padding-bottom: 6rem;\n  }\n  .xl\\:px-24 {\n    padding-left: 6rem;\n    padding-right: 6rem;\n  }\n  .xl\\:py-28 {\n    padding-top: 7rem;\n    padding-bottom: 7rem;\n  }\n  .xl\\:px-28 {\n    padding-left: 7rem;\n    padding-right: 7rem;\n  }\n  .xl\\:py-32 {\n    padding-top: 8rem;\n    padding-bottom: 8rem;\n  }\n  .xl\\:px-32 {\n    padding-left: 8rem;\n    padding-right: 8rem;\n  }\n  .xl\\:py-36 {\n    padding-top: 9rem;\n    padding-bottom: 9rem;\n  }\n  .xl\\:px-36 {\n    padding-left: 9rem;\n    padding-right: 9rem;\n  }\n  .xl\\:py-40 {\n    padding-top: 10rem;\n    padding-bottom: 10rem;\n  }\n  .xl\\:px-40 {\n    padding-left: 10rem;\n    padding-right: 10rem;\n  }\n  .xl\\:py-44 {\n    padding-top: 11rem;\n    padding-bottom: 11rem;\n  }\n  .xl\\:px-44 {\n    padding-left: 11rem;\n    padding-right: 11rem;\n  }\n  .xl\\:py-48 {\n    padding-top: 12rem;\n    padding-bottom: 12rem;\n  }\n  .xl\\:px-48 {\n    padding-left: 12rem;\n    padding-right: 12rem;\n  }\n  .xl\\:py-52 {\n    padding-top: 13rem;\n    padding-bottom: 13rem;\n  }\n  .xl\\:px-52 {\n    padding-left: 13rem;\n    padding-right: 13rem;\n  }\n  .xl\\:py-56 {\n    padding-top: 14rem;\n    padding-bottom: 14rem;\n  }\n  .xl\\:px-56 {\n    padding-left: 14rem;\n    padding-right: 14rem;\n  }\n  .xl\\:py-60 {\n    padding-top: 15rem;\n    padding-bottom: 15rem;\n  }\n  .xl\\:px-60 {\n    padding-left: 15rem;\n    padding-right: 15rem;\n  }\n  .xl\\:py-64 {\n    padding-top: 16rem;\n    padding-bottom: 16rem;\n  }\n  .xl\\:px-64 {\n    padding-left: 16rem;\n    padding-right: 16rem;\n  }\n  .xl\\:py-72 {\n    padding-top: 18rem;\n    padding-bottom: 18rem;\n  }\n  .xl\\:px-72 {\n    padding-left: 18rem;\n    padding-right: 18rem;\n  }\n  .xl\\:py-80 {\n    padding-top: 20rem;\n    padding-bottom: 20rem;\n  }\n  .xl\\:px-80 {\n    padding-left: 20rem;\n    padding-right: 20rem;\n  }\n  .xl\\:py-96 {\n    padding-top: 24rem;\n    padding-bottom: 24rem;\n  }\n  .xl\\:px-96 {\n    padding-left: 24rem;\n    padding-right: 24rem;\n  }\n  .xl\\:py-px {\n    padding-top: 1px;\n    padding-bottom: 1px;\n  }\n  .xl\\:px-px {\n    padding-left: 1px;\n    padding-right: 1px;\n  }\n  .xl\\:py-0\\.5 {\n    padding-top: 0.125rem;\n    padding-bottom: 0.125rem;\n  }\n  .xl\\:px-0\\.5 {\n    padding-left: 0.125rem;\n    padding-right: 0.125rem;\n  }\n  .xl\\:py-1\\.5 {\n    padding-top: 0.375rem;\n    padding-bottom: 0.375rem;\n  }\n  .xl\\:px-1\\.5 {\n    padding-left: 0.375rem;\n    padding-right: 0.375rem;\n  }\n  .xl\\:py-2\\.5 {\n    padding-top: 0.625rem;\n    padding-bottom: 0.625rem;\n  }\n  .xl\\:px-2\\.5 {\n    padding-left: 0.625rem;\n    padding-right: 0.625rem;\n  }\n  .xl\\:py-3\\.5 {\n    padding-top: 0.875rem;\n    padding-bottom: 0.875rem;\n  }\n  .xl\\:px-3\\.5 {\n    padding-left: 0.875rem;\n    padding-right: 0.875rem;\n  }\n  .xl\\:py-1\\/2 {\n    padding-top: 50%;\n    padding-bottom: 50%;\n  }\n  .xl\\:px-1\\/2 {\n    padding-left: 50%;\n    padding-right: 50%;\n  }\n  .xl\\:py-1\\/3 {\n    padding-top: 33.333333%;\n    padding-bottom: 33.333333%;\n  }\n  .xl\\:px-1\\/3 {\n    padding-left: 33.333333%;\n    padding-right: 33.333333%;\n  }\n  .xl\\:py-2\\/3 {\n    padding-top: 66.666667%;\n    padding-bottom: 66.666667%;\n  }\n  .xl\\:px-2\\/3 {\n    padding-left: 66.666667%;\n    padding-right: 66.666667%;\n  }\n  .xl\\:py-1\\/4 {\n    padding-top: 25%;\n    padding-bottom: 25%;\n  }\n  .xl\\:px-1\\/4 {\n    padding-left: 25%;\n    padding-right: 25%;\n  }\n  .xl\\:py-2\\/4 {\n    padding-top: 50%;\n    padding-bottom: 50%;\n  }\n  .xl\\:px-2\\/4 {\n    padding-left: 50%;\n    padding-right: 50%;\n  }\n  .xl\\:py-3\\/4 {\n    padding-top: 75%;\n    padding-bottom: 75%;\n  }\n  .xl\\:px-3\\/4 {\n    padding-left: 75%;\n    padding-right: 75%;\n  }\n  .xl\\:py-1\\/5 {\n    padding-top: 20%;\n    padding-bottom: 20%;\n  }\n  .xl\\:px-1\\/5 {\n    padding-left: 20%;\n    padding-right: 20%;\n  }\n  .xl\\:py-2\\/5 {\n    padding-top: 40%;\n    padding-bottom: 40%;\n  }\n  .xl\\:px-2\\/5 {\n    padding-left: 40%;\n    padding-right: 40%;\n  }\n  .xl\\:py-3\\/5 {\n    padding-top: 60%;\n    padding-bottom: 60%;\n  }\n  .xl\\:px-3\\/5 {\n    padding-left: 60%;\n    padding-right: 60%;\n  }\n  .xl\\:py-4\\/5 {\n    padding-top: 80%;\n    padding-bottom: 80%;\n  }\n  .xl\\:px-4\\/5 {\n    padding-left: 80%;\n    padding-right: 80%;\n  }\n  .xl\\:py-1\\/6 {\n    padding-top: 16.666667%;\n    padding-bottom: 16.666667%;\n  }\n  .xl\\:px-1\\/6 {\n    padding-left: 16.666667%;\n    padding-right: 16.666667%;\n  }\n  .xl\\:py-2\\/6 {\n    padding-top: 33.333333%;\n    padding-bottom: 33.333333%;\n  }\n  .xl\\:px-2\\/6 {\n    padding-left: 33.333333%;\n    padding-right: 33.333333%;\n  }\n  .xl\\:py-3\\/6 {\n    padding-top: 50%;\n    padding-bottom: 50%;\n  }\n  .xl\\:px-3\\/6 {\n    padding-left: 50%;\n    padding-right: 50%;\n  }\n  .xl\\:py-4\\/6 {\n    padding-top: 66.666667%;\n    padding-bottom: 66.666667%;\n  }\n  .xl\\:px-4\\/6 {\n    padding-left: 66.666667%;\n    padding-right: 66.666667%;\n  }\n  .xl\\:py-5\\/6 {\n    padding-top: 83.333333%;\n    padding-bottom: 83.333333%;\n  }\n  .xl\\:px-5\\/6 {\n    padding-left: 83.333333%;\n    padding-right: 83.333333%;\n  }\n  .xl\\:py-1\\/12 {\n    padding-top: 8.333333%;\n    padding-bottom: 8.333333%;\n  }\n  .xl\\:px-1\\/12 {\n    padding-left: 8.333333%;\n    padding-right: 8.333333%;\n  }\n  .xl\\:py-2\\/12 {\n    padding-top: 16.666667%;\n    padding-bottom: 16.666667%;\n  }\n  .xl\\:px-2\\/12 {\n    padding-left: 16.666667%;\n    padding-right: 16.666667%;\n  }\n  .xl\\:py-3\\/12 {\n    padding-top: 25%;\n    padding-bottom: 25%;\n  }\n  .xl\\:px-3\\/12 {\n    padding-left: 25%;\n    padding-right: 25%;\n  }\n  .xl\\:py-4\\/12 {\n    padding-top: 33.333333%;\n    padding-bottom: 33.333333%;\n  }\n  .xl\\:px-4\\/12 {\n    padding-left: 33.333333%;\n    padding-right: 33.333333%;\n  }\n  .xl\\:py-5\\/12 {\n    padding-top: 41.666667%;\n    padding-bottom: 41.666667%;\n  }\n  .xl\\:px-5\\/12 {\n    padding-left: 41.666667%;\n    padding-right: 41.666667%;\n  }\n  .xl\\:py-6\\/12 {\n    padding-top: 50%;\n    padding-bottom: 50%;\n  }\n  .xl\\:px-6\\/12 {\n    padding-left: 50%;\n    padding-right: 50%;\n  }\n  .xl\\:py-7\\/12 {\n    padding-top: 58.333333%;\n    padding-bottom: 58.333333%;\n  }\n  .xl\\:px-7\\/12 {\n    padding-left: 58.333333%;\n    padding-right: 58.333333%;\n  }\n  .xl\\:py-8\\/12 {\n    padding-top: 66.666667%;\n    padding-bottom: 66.666667%;\n  }\n  .xl\\:px-8\\/12 {\n    padding-left: 66.666667%;\n    padding-right: 66.666667%;\n  }\n  .xl\\:py-9\\/12 {\n    padding-top: 75%;\n    padding-bottom: 75%;\n  }\n  .xl\\:px-9\\/12 {\n    padding-left: 75%;\n    padding-right: 75%;\n  }\n  .xl\\:py-10\\/12 {\n    padding-top: 83.333333%;\n    padding-bottom: 83.333333%;\n  }\n  .xl\\:px-10\\/12 {\n    padding-left: 83.333333%;\n    padding-right: 83.333333%;\n  }\n  .xl\\:py-11\\/12 {\n    padding-top: 91.666667%;\n    padding-bottom: 91.666667%;\n  }\n  .xl\\:px-11\\/12 {\n    padding-left: 91.666667%;\n    padding-right: 91.666667%;\n  }\n  .xl\\:py-full {\n    padding-top: 100%;\n    padding-bottom: 100%;\n  }\n  .xl\\:px-full {\n    padding-left: 100%;\n    padding-right: 100%;\n  }\n  .xl\\:pt-0 {\n    padding-top: 0;\n  }\n  .xl\\:pr-0 {\n    padding-right: 0;\n  }\n  .xl\\:pb-0 {\n    padding-bottom: 0;\n  }\n  .xl\\:pl-0 {\n    padding-left: 0;\n  }\n  .xl\\:pt-1 {\n    padding-top: 0.25rem;\n  }\n  .xl\\:pr-1 {\n    padding-right: 0.25rem;\n  }\n  .xl\\:pb-1 {\n    padding-bottom: 0.25rem;\n  }\n  .xl\\:pl-1 {\n    padding-left: 0.25rem;\n  }\n  .xl\\:pt-2 {\n    padding-top: 0.5rem;\n  }\n  .xl\\:pr-2 {\n    padding-right: 0.5rem;\n  }\n  .xl\\:pb-2 {\n    padding-bottom: 0.5rem;\n  }\n  .xl\\:pl-2 {\n    padding-left: 0.5rem;\n  }\n  .xl\\:pt-3 {\n    padding-top: 0.75rem;\n  }\n  .xl\\:pr-3 {\n    padding-right: 0.75rem;\n  }\n  .xl\\:pb-3 {\n    padding-bottom: 0.75rem;\n  }\n  .xl\\:pl-3 {\n    padding-left: 0.75rem;\n  }\n  .xl\\:pt-4 {\n    padding-top: 1rem;\n  }\n  .xl\\:pr-4 {\n    padding-right: 1rem;\n  }\n  .xl\\:pb-4 {\n    padding-bottom: 1rem;\n  }\n  .xl\\:pl-4 {\n    padding-left: 1rem;\n  }\n  .xl\\:pt-5 {\n    padding-top: 1.25rem;\n  }\n  .xl\\:pr-5 {\n    padding-right: 1.25rem;\n  }\n  .xl\\:pb-5 {\n    padding-bottom: 1.25rem;\n  }\n  .xl\\:pl-5 {\n    padding-left: 1.25rem;\n  }\n  .xl\\:pt-6 {\n    padding-top: 1.5rem;\n  }\n  .xl\\:pr-6 {\n    padding-right: 1.5rem;\n  }\n  .xl\\:pb-6 {\n    padding-bottom: 1.5rem;\n  }\n  .xl\\:pl-6 {\n    padding-left: 1.5rem;\n  }\n  .xl\\:pt-7 {\n    padding-top: 1.75rem;\n  }\n  .xl\\:pr-7 {\n    padding-right: 1.75rem;\n  }\n  .xl\\:pb-7 {\n    padding-bottom: 1.75rem;\n  }\n  .xl\\:pl-7 {\n    padding-left: 1.75rem;\n  }\n  .xl\\:pt-8 {\n    padding-top: 2rem;\n  }\n  .xl\\:pr-8 {\n    padding-right: 2rem;\n  }\n  .xl\\:pb-8 {\n    padding-bottom: 2rem;\n  }\n  .xl\\:pl-8 {\n    padding-left: 2rem;\n  }\n  .xl\\:pt-9 {\n    padding-top: 2.25rem;\n  }\n  .xl\\:pr-9 {\n    padding-right: 2.25rem;\n  }\n  .xl\\:pb-9 {\n    padding-bottom: 2.25rem;\n  }\n  .xl\\:pl-9 {\n    padding-left: 2.25rem;\n  }\n  .xl\\:pt-10 {\n    padding-top: 2.5rem;\n  }\n  .xl\\:pr-10 {\n    padding-right: 2.5rem;\n  }\n  .xl\\:pb-10 {\n    padding-bottom: 2.5rem;\n  }\n  .xl\\:pl-10 {\n    padding-left: 2.5rem;\n  }\n  .xl\\:pt-11 {\n    padding-top: 2.75rem;\n  }\n  .xl\\:pr-11 {\n    padding-right: 2.75rem;\n  }\n  .xl\\:pb-11 {\n    padding-bottom: 2.75rem;\n  }\n  .xl\\:pl-11 {\n    padding-left: 2.75rem;\n  }\n  .xl\\:pt-12 {\n    padding-top: 3rem;\n  }\n  .xl\\:pr-12 {\n    padding-right: 3rem;\n  }\n  .xl\\:pb-12 {\n    padding-bottom: 3rem;\n  }\n  .xl\\:pl-12 {\n    padding-left: 3rem;\n  }\n  .xl\\:pt-13 {\n    padding-top: 3.25rem;\n  }\n  .xl\\:pr-13 {\n    padding-right: 3.25rem;\n  }\n  .xl\\:pb-13 {\n    padding-bottom: 3.25rem;\n  }\n  .xl\\:pl-13 {\n    padding-left: 3.25rem;\n  }\n  .xl\\:pt-14 {\n    padding-top: 3.5rem;\n  }\n  .xl\\:pr-14 {\n    padding-right: 3.5rem;\n  }\n  .xl\\:pb-14 {\n    padding-bottom: 3.5rem;\n  }\n  .xl\\:pl-14 {\n    padding-left: 3.5rem;\n  }\n  .xl\\:pt-15 {\n    padding-top: 3.75rem;\n  }\n  .xl\\:pr-15 {\n    padding-right: 3.75rem;\n  }\n  .xl\\:pb-15 {\n    padding-bottom: 3.75rem;\n  }\n  .xl\\:pl-15 {\n    padding-left: 3.75rem;\n  }\n  .xl\\:pt-16 {\n    padding-top: 4rem;\n  }\n  .xl\\:pr-16 {\n    padding-right: 4rem;\n  }\n  .xl\\:pb-16 {\n    padding-bottom: 4rem;\n  }\n  .xl\\:pl-16 {\n    padding-left: 4rem;\n  }\n  .xl\\:pt-20 {\n    padding-top: 5rem;\n  }\n  .xl\\:pr-20 {\n    padding-right: 5rem;\n  }\n  .xl\\:pb-20 {\n    padding-bottom: 5rem;\n  }\n  .xl\\:pl-20 {\n    padding-left: 5rem;\n  }\n  .xl\\:pt-24 {\n    padding-top: 6rem;\n  }\n  .xl\\:pr-24 {\n    padding-right: 6rem;\n  }\n  .xl\\:pb-24 {\n    padding-bottom: 6rem;\n  }\n  .xl\\:pl-24 {\n    padding-left: 6rem;\n  }\n  .xl\\:pt-28 {\n    padding-top: 7rem;\n  }\n  .xl\\:pr-28 {\n    padding-right: 7rem;\n  }\n  .xl\\:pb-28 {\n    padding-bottom: 7rem;\n  }\n  .xl\\:pl-28 {\n    padding-left: 7rem;\n  }\n  .xl\\:pt-32 {\n    padding-top: 8rem;\n  }\n  .xl\\:pr-32 {\n    padding-right: 8rem;\n  }\n  .xl\\:pb-32 {\n    padding-bottom: 8rem;\n  }\n  .xl\\:pl-32 {\n    padding-left: 8rem;\n  }\n  .xl\\:pt-36 {\n    padding-top: 9rem;\n  }\n  .xl\\:pr-36 {\n    padding-right: 9rem;\n  }\n  .xl\\:pb-36 {\n    padding-bottom: 9rem;\n  }\n  .xl\\:pl-36 {\n    padding-left: 9rem;\n  }\n  .xl\\:pt-40 {\n    padding-top: 10rem;\n  }\n  .xl\\:pr-40 {\n    padding-right: 10rem;\n  }\n  .xl\\:pb-40 {\n    padding-bottom: 10rem;\n  }\n  .xl\\:pl-40 {\n    padding-left: 10rem;\n  }\n  .xl\\:pt-44 {\n    padding-top: 11rem;\n  }\n  .xl\\:pr-44 {\n    padding-right: 11rem;\n  }\n  .xl\\:pb-44 {\n    padding-bottom: 11rem;\n  }\n  .xl\\:pl-44 {\n    padding-left: 11rem;\n  }\n  .xl\\:pt-48 {\n    padding-top: 12rem;\n  }\n  .xl\\:pr-48 {\n    padding-right: 12rem;\n  }\n  .xl\\:pb-48 {\n    padding-bottom: 12rem;\n  }\n  .xl\\:pl-48 {\n    padding-left: 12rem;\n  }\n  .xl\\:pt-52 {\n    padding-top: 13rem;\n  }\n  .xl\\:pr-52 {\n    padding-right: 13rem;\n  }\n  .xl\\:pb-52 {\n    padding-bottom: 13rem;\n  }\n  .xl\\:pl-52 {\n    padding-left: 13rem;\n  }\n  .xl\\:pt-56 {\n    padding-top: 14rem;\n  }\n  .xl\\:pr-56 {\n    padding-right: 14rem;\n  }\n  .xl\\:pb-56 {\n    padding-bottom: 14rem;\n  }\n  .xl\\:pl-56 {\n    padding-left: 14rem;\n  }\n  .xl\\:pt-60 {\n    padding-top: 15rem;\n  }\n  .xl\\:pr-60 {\n    padding-right: 15rem;\n  }\n  .xl\\:pb-60 {\n    padding-bottom: 15rem;\n  }\n  .xl\\:pl-60 {\n    padding-left: 15rem;\n  }\n  .xl\\:pt-64 {\n    padding-top: 16rem;\n  }\n  .xl\\:pr-64 {\n    padding-right: 16rem;\n  }\n  .xl\\:pb-64 {\n    padding-bottom: 16rem;\n  }\n  .xl\\:pl-64 {\n    padding-left: 16rem;\n  }\n  .xl\\:pt-72 {\n    padding-top: 18rem;\n  }\n  .xl\\:pr-72 {\n    padding-right: 18rem;\n  }\n  .xl\\:pb-72 {\n    padding-bottom: 18rem;\n  }\n  .xl\\:pl-72 {\n    padding-left: 18rem;\n  }\n  .xl\\:pt-80 {\n    padding-top: 20rem;\n  }\n  .xl\\:pr-80 {\n    padding-right: 20rem;\n  }\n  .xl\\:pb-80 {\n    padding-bottom: 20rem;\n  }\n  .xl\\:pl-80 {\n    padding-left: 20rem;\n  }\n  .xl\\:pt-96 {\n    padding-top: 24rem;\n  }\n  .xl\\:pr-96 {\n    padding-right: 24rem;\n  }\n  .xl\\:pb-96 {\n    padding-bottom: 24rem;\n  }\n  .xl\\:pl-96 {\n    padding-left: 24rem;\n  }\n  .xl\\:pt-px {\n    padding-top: 1px;\n  }\n  .xl\\:pr-px {\n    padding-right: 1px;\n  }\n  .xl\\:pb-px {\n    padding-bottom: 1px;\n  }\n  .xl\\:pl-px {\n    padding-left: 1px;\n  }\n  .xl\\:pt-0\\.5 {\n    padding-top: 0.125rem;\n  }\n  .xl\\:pr-0\\.5 {\n    padding-right: 0.125rem;\n  }\n  .xl\\:pb-0\\.5 {\n    padding-bottom: 0.125rem;\n  }\n  .xl\\:pl-0\\.5 {\n    padding-left: 0.125rem;\n  }\n  .xl\\:pt-1\\.5 {\n    padding-top: 0.375rem;\n  }\n  .xl\\:pr-1\\.5 {\n    padding-right: 0.375rem;\n  }\n  .xl\\:pb-1\\.5 {\n    padding-bottom: 0.375rem;\n  }\n  .xl\\:pl-1\\.5 {\n    padding-left: 0.375rem;\n  }\n  .xl\\:pt-2\\.5 {\n    padding-top: 0.625rem;\n  }\n  .xl\\:pr-2\\.5 {\n    padding-right: 0.625rem;\n  }\n  .xl\\:pb-2\\.5 {\n    padding-bottom: 0.625rem;\n  }\n  .xl\\:pl-2\\.5 {\n    padding-left: 0.625rem;\n  }\n  .xl\\:pt-3\\.5 {\n    padding-top: 0.875rem;\n  }\n  .xl\\:pr-3\\.5 {\n    padding-right: 0.875rem;\n  }\n  .xl\\:pb-3\\.5 {\n    padding-bottom: 0.875rem;\n  }\n  .xl\\:pl-3\\.5 {\n    padding-left: 0.875rem;\n  }\n  .xl\\:pt-1\\/2 {\n    padding-top: 50%;\n  }\n  .xl\\:pr-1\\/2 {\n    padding-right: 50%;\n  }\n  .xl\\:pb-1\\/2 {\n    padding-bottom: 50%;\n  }\n  .xl\\:pl-1\\/2 {\n    padding-left: 50%;\n  }\n  .xl\\:pt-1\\/3 {\n    padding-top: 33.333333%;\n  }\n  .xl\\:pr-1\\/3 {\n    padding-right: 33.333333%;\n  }\n  .xl\\:pb-1\\/3 {\n    padding-bottom: 33.333333%;\n  }\n  .xl\\:pl-1\\/3 {\n    padding-left: 33.333333%;\n  }\n  .xl\\:pt-2\\/3 {\n    padding-top: 66.666667%;\n  }\n  .xl\\:pr-2\\/3 {\n    padding-right: 66.666667%;\n  }\n  .xl\\:pb-2\\/3 {\n    padding-bottom: 66.666667%;\n  }\n  .xl\\:pl-2\\/3 {\n    padding-left: 66.666667%;\n  }\n  .xl\\:pt-1\\/4 {\n    padding-top: 25%;\n  }\n  .xl\\:pr-1\\/4 {\n    padding-right: 25%;\n  }\n  .xl\\:pb-1\\/4 {\n    padding-bottom: 25%;\n  }\n  .xl\\:pl-1\\/4 {\n    padding-left: 25%;\n  }\n  .xl\\:pt-2\\/4 {\n    padding-top: 50%;\n  }\n  .xl\\:pr-2\\/4 {\n    padding-right: 50%;\n  }\n  .xl\\:pb-2\\/4 {\n    padding-bottom: 50%;\n  }\n  .xl\\:pl-2\\/4 {\n    padding-left: 50%;\n  }\n  .xl\\:pt-3\\/4 {\n    padding-top: 75%;\n  }\n  .xl\\:pr-3\\/4 {\n    padding-right: 75%;\n  }\n  .xl\\:pb-3\\/4 {\n    padding-bottom: 75%;\n  }\n  .xl\\:pl-3\\/4 {\n    padding-left: 75%;\n  }\n  .xl\\:pt-1\\/5 {\n    padding-top: 20%;\n  }\n  .xl\\:pr-1\\/5 {\n    padding-right: 20%;\n  }\n  .xl\\:pb-1\\/5 {\n    padding-bottom: 20%;\n  }\n  .xl\\:pl-1\\/5 {\n    padding-left: 20%;\n  }\n  .xl\\:pt-2\\/5 {\n    padding-top: 40%;\n  }\n  .xl\\:pr-2\\/5 {\n    padding-right: 40%;\n  }\n  .xl\\:pb-2\\/5 {\n    padding-bottom: 40%;\n  }\n  .xl\\:pl-2\\/5 {\n    padding-left: 40%;\n  }\n  .xl\\:pt-3\\/5 {\n    padding-top: 60%;\n  }\n  .xl\\:pr-3\\/5 {\n    padding-right: 60%;\n  }\n  .xl\\:pb-3\\/5 {\n    padding-bottom: 60%;\n  }\n  .xl\\:pl-3\\/5 {\n    padding-left: 60%;\n  }\n  .xl\\:pt-4\\/5 {\n    padding-top: 80%;\n  }\n  .xl\\:pr-4\\/5 {\n    padding-right: 80%;\n  }\n  .xl\\:pb-4\\/5 {\n    padding-bottom: 80%;\n  }\n  .xl\\:pl-4\\/5 {\n    padding-left: 80%;\n  }\n  .xl\\:pt-1\\/6 {\n    padding-top: 16.666667%;\n  }\n  .xl\\:pr-1\\/6 {\n    padding-right: 16.666667%;\n  }\n  .xl\\:pb-1\\/6 {\n    padding-bottom: 16.666667%;\n  }\n  .xl\\:pl-1\\/6 {\n    padding-left: 16.666667%;\n  }\n  .xl\\:pt-2\\/6 {\n    padding-top: 33.333333%;\n  }\n  .xl\\:pr-2\\/6 {\n    padding-right: 33.333333%;\n  }\n  .xl\\:pb-2\\/6 {\n    padding-bottom: 33.333333%;\n  }\n  .xl\\:pl-2\\/6 {\n    padding-left: 33.333333%;\n  }\n  .xl\\:pt-3\\/6 {\n    padding-top: 50%;\n  }\n  .xl\\:pr-3\\/6 {\n    padding-right: 50%;\n  }\n  .xl\\:pb-3\\/6 {\n    padding-bottom: 50%;\n  }\n  .xl\\:pl-3\\/6 {\n    padding-left: 50%;\n  }\n  .xl\\:pt-4\\/6 {\n    padding-top: 66.666667%;\n  }\n  .xl\\:pr-4\\/6 {\n    padding-right: 66.666667%;\n  }\n  .xl\\:pb-4\\/6 {\n    padding-bottom: 66.666667%;\n  }\n  .xl\\:pl-4\\/6 {\n    padding-left: 66.666667%;\n  }\n  .xl\\:pt-5\\/6 {\n    padding-top: 83.333333%;\n  }\n  .xl\\:pr-5\\/6 {\n    padding-right: 83.333333%;\n  }\n  .xl\\:pb-5\\/6 {\n    padding-bottom: 83.333333%;\n  }\n  .xl\\:pl-5\\/6 {\n    padding-left: 83.333333%;\n  }\n  .xl\\:pt-1\\/12 {\n    padding-top: 8.333333%;\n  }\n  .xl\\:pr-1\\/12 {\n    padding-right: 8.333333%;\n  }\n  .xl\\:pb-1\\/12 {\n    padding-bottom: 8.333333%;\n  }\n  .xl\\:pl-1\\/12 {\n    padding-left: 8.333333%;\n  }\n  .xl\\:pt-2\\/12 {\n    padding-top: 16.666667%;\n  }\n  .xl\\:pr-2\\/12 {\n    padding-right: 16.666667%;\n  }\n  .xl\\:pb-2\\/12 {\n    padding-bottom: 16.666667%;\n  }\n  .xl\\:pl-2\\/12 {\n    padding-left: 16.666667%;\n  }\n  .xl\\:pt-3\\/12 {\n    padding-top: 25%;\n  }\n  .xl\\:pr-3\\/12 {\n    padding-right: 25%;\n  }\n  .xl\\:pb-3\\/12 {\n    padding-bottom: 25%;\n  }\n  .xl\\:pl-3\\/12 {\n    padding-left: 25%;\n  }\n  .xl\\:pt-4\\/12 {\n    padding-top: 33.333333%;\n  }\n  .xl\\:pr-4\\/12 {\n    padding-right: 33.333333%;\n  }\n  .xl\\:pb-4\\/12 {\n    padding-bottom: 33.333333%;\n  }\n  .xl\\:pl-4\\/12 {\n    padding-left: 33.333333%;\n  }\n  .xl\\:pt-5\\/12 {\n    padding-top: 41.666667%;\n  }\n  .xl\\:pr-5\\/12 {\n    padding-right: 41.666667%;\n  }\n  .xl\\:pb-5\\/12 {\n    padding-bottom: 41.666667%;\n  }\n  .xl\\:pl-5\\/12 {\n    padding-left: 41.666667%;\n  }\n  .xl\\:pt-6\\/12 {\n    padding-top: 50%;\n  }\n  .xl\\:pr-6\\/12 {\n    padding-right: 50%;\n  }\n  .xl\\:pb-6\\/12 {\n    padding-bottom: 50%;\n  }\n  .xl\\:pl-6\\/12 {\n    padding-left: 50%;\n  }\n  .xl\\:pt-7\\/12 {\n    padding-top: 58.333333%;\n  }\n  .xl\\:pr-7\\/12 {\n    padding-right: 58.333333%;\n  }\n  .xl\\:pb-7\\/12 {\n    padding-bottom: 58.333333%;\n  }\n  .xl\\:pl-7\\/12 {\n    padding-left: 58.333333%;\n  }\n  .xl\\:pt-8\\/12 {\n    padding-top: 66.666667%;\n  }\n  .xl\\:pr-8\\/12 {\n    padding-right: 66.666667%;\n  }\n  .xl\\:pb-8\\/12 {\n    padding-bottom: 66.666667%;\n  }\n  .xl\\:pl-8\\/12 {\n    padding-left: 66.666667%;\n  }\n  .xl\\:pt-9\\/12 {\n    padding-top: 75%;\n  }\n  .xl\\:pr-9\\/12 {\n    padding-right: 75%;\n  }\n  .xl\\:pb-9\\/12 {\n    padding-bottom: 75%;\n  }\n  .xl\\:pl-9\\/12 {\n    padding-left: 75%;\n  }\n  .xl\\:pt-10\\/12 {\n    padding-top: 83.333333%;\n  }\n  .xl\\:pr-10\\/12 {\n    padding-right: 83.333333%;\n  }\n  .xl\\:pb-10\\/12 {\n    padding-bottom: 83.333333%;\n  }\n  .xl\\:pl-10\\/12 {\n    padding-left: 83.333333%;\n  }\n  .xl\\:pt-11\\/12 {\n    padding-top: 91.666667%;\n  }\n  .xl\\:pr-11\\/12 {\n    padding-right: 91.666667%;\n  }\n  .xl\\:pb-11\\/12 {\n    padding-bottom: 91.666667%;\n  }\n  .xl\\:pl-11\\/12 {\n    padding-left: 91.666667%;\n  }\n  .xl\\:pt-full {\n    padding-top: 100%;\n  }\n  .xl\\:pr-full {\n    padding-right: 100%;\n  }\n  .xl\\:pb-full {\n    padding-bottom: 100%;\n  }\n  .xl\\:pl-full {\n    padding-left: 100%;\n  }\n  .xl\\:placeholder-current::-moz-placeholder {\n    color: currentColor;\n  }\n  .xl\\:placeholder-current::placeholder {\n    color: currentColor;\n  }\n  .xl\\:placeholder-transparent::-moz-placeholder {\n    color: transparent;\n  }\n  .xl\\:placeholder-transparent::placeholder {\n    color: transparent;\n  }\n  .xl\\:placeholder-white::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #ffffff;\n    color: rgba(255, 255, 255, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-white::placeholder {\n    --placeholder-opacity: 1;\n    color: #ffffff;\n    color: rgba(255, 255, 255, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-black::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #000000;\n    color: rgba(0, 0, 0, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-black::placeholder {\n    --placeholder-opacity: 1;\n    color: #000000;\n    color: rgba(0, 0, 0, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-gray-50::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #f9fafb;\n    color: rgba(249, 250, 251, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-gray-50::placeholder {\n    --placeholder-opacity: 1;\n    color: #f9fafb;\n    color: rgba(249, 250, 251, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-gray-100::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #f4f5f7;\n    color: rgba(244, 245, 247, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-gray-100::placeholder {\n    --placeholder-opacity: 1;\n    color: #f4f5f7;\n    color: rgba(244, 245, 247, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-gray-200::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #e5e7eb;\n    color: rgba(229, 231, 235, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-gray-200::placeholder {\n    --placeholder-opacity: 1;\n    color: #e5e7eb;\n    color: rgba(229, 231, 235, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-gray-300::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #d2d6dc;\n    color: rgba(210, 214, 220, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-gray-300::placeholder {\n    --placeholder-opacity: 1;\n    color: #d2d6dc;\n    color: rgba(210, 214, 220, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-gray-400::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #9fa6b2;\n    color: rgba(159, 166, 178, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-gray-400::placeholder {\n    --placeholder-opacity: 1;\n    color: #9fa6b2;\n    color: rgba(159, 166, 178, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-gray-500::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #6b7280;\n    color: rgba(107, 114, 128, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-gray-500::placeholder {\n    --placeholder-opacity: 1;\n    color: #6b7280;\n    color: rgba(107, 114, 128, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-gray-600::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #4b5563;\n    color: rgba(75, 85, 99, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-gray-600::placeholder {\n    --placeholder-opacity: 1;\n    color: #4b5563;\n    color: rgba(75, 85, 99, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-gray-700::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #374151;\n    color: rgba(55, 65, 81, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-gray-700::placeholder {\n    --placeholder-opacity: 1;\n    color: #374151;\n    color: rgba(55, 65, 81, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-gray-800::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #252f3f;\n    color: rgba(37, 47, 63, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-gray-800::placeholder {\n    --placeholder-opacity: 1;\n    color: #252f3f;\n    color: rgba(37, 47, 63, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-gray-900::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #161e2e;\n    color: rgba(22, 30, 46, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-gray-900::placeholder {\n    --placeholder-opacity: 1;\n    color: #161e2e;\n    color: rgba(22, 30, 46, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-red-50::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #fdf2f2;\n    color: rgba(253, 242, 242, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-red-50::placeholder {\n    --placeholder-opacity: 1;\n    color: #fdf2f2;\n    color: rgba(253, 242, 242, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-red-100::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #fde8e8;\n    color: rgba(253, 232, 232, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-red-100::placeholder {\n    --placeholder-opacity: 1;\n    color: #fde8e8;\n    color: rgba(253, 232, 232, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-red-200::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #fbd5d5;\n    color: rgba(251, 213, 213, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-red-200::placeholder {\n    --placeholder-opacity: 1;\n    color: #fbd5d5;\n    color: rgba(251, 213, 213, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-red-300::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #f8b4b4;\n    color: rgba(248, 180, 180, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-red-300::placeholder {\n    --placeholder-opacity: 1;\n    color: #f8b4b4;\n    color: rgba(248, 180, 180, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-red-400::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #f98080;\n    color: rgba(249, 128, 128, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-red-400::placeholder {\n    --placeholder-opacity: 1;\n    color: #f98080;\n    color: rgba(249, 128, 128, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-red-500::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #f05252;\n    color: rgba(240, 82, 82, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-red-500::placeholder {\n    --placeholder-opacity: 1;\n    color: #f05252;\n    color: rgba(240, 82, 82, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-red-600::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #e02424;\n    color: rgba(224, 36, 36, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-red-600::placeholder {\n    --placeholder-opacity: 1;\n    color: #e02424;\n    color: rgba(224, 36, 36, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-red-700::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #c81e1e;\n    color: rgba(200, 30, 30, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-red-700::placeholder {\n    --placeholder-opacity: 1;\n    color: #c81e1e;\n    color: rgba(200, 30, 30, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-red-800::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #9b1c1c;\n    color: rgba(155, 28, 28, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-red-800::placeholder {\n    --placeholder-opacity: 1;\n    color: #9b1c1c;\n    color: rgba(155, 28, 28, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-red-900::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #771d1d;\n    color: rgba(119, 29, 29, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-red-900::placeholder {\n    --placeholder-opacity: 1;\n    color: #771d1d;\n    color: rgba(119, 29, 29, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-orange-50::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #fff8f1;\n    color: rgba(255, 248, 241, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-orange-50::placeholder {\n    --placeholder-opacity: 1;\n    color: #fff8f1;\n    color: rgba(255, 248, 241, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-orange-100::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #feecdc;\n    color: rgba(254, 236, 220, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-orange-100::placeholder {\n    --placeholder-opacity: 1;\n    color: #feecdc;\n    color: rgba(254, 236, 220, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-orange-200::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #fcd9bd;\n    color: rgba(252, 217, 189, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-orange-200::placeholder {\n    --placeholder-opacity: 1;\n    color: #fcd9bd;\n    color: rgba(252, 217, 189, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-orange-300::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #fdba8c;\n    color: rgba(253, 186, 140, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-orange-300::placeholder {\n    --placeholder-opacity: 1;\n    color: #fdba8c;\n    color: rgba(253, 186, 140, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-orange-400::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #ff8a4c;\n    color: rgba(255, 138, 76, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-orange-400::placeholder {\n    --placeholder-opacity: 1;\n    color: #ff8a4c;\n    color: rgba(255, 138, 76, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-orange-500::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #ff5a1f;\n    color: rgba(255, 90, 31, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-orange-500::placeholder {\n    --placeholder-opacity: 1;\n    color: #ff5a1f;\n    color: rgba(255, 90, 31, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-orange-600::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #d03801;\n    color: rgba(208, 56, 1, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-orange-600::placeholder {\n    --placeholder-opacity: 1;\n    color: #d03801;\n    color: rgba(208, 56, 1, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-orange-700::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #b43403;\n    color: rgba(180, 52, 3, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-orange-700::placeholder {\n    --placeholder-opacity: 1;\n    color: #b43403;\n    color: rgba(180, 52, 3, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-orange-800::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #8a2c0d;\n    color: rgba(138, 44, 13, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-orange-800::placeholder {\n    --placeholder-opacity: 1;\n    color: #8a2c0d;\n    color: rgba(138, 44, 13, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-orange-900::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #73230d;\n    color: rgba(115, 35, 13, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-orange-900::placeholder {\n    --placeholder-opacity: 1;\n    color: #73230d;\n    color: rgba(115, 35, 13, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-yellow-50::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #fdfdea;\n    color: rgba(253, 253, 234, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-yellow-50::placeholder {\n    --placeholder-opacity: 1;\n    color: #fdfdea;\n    color: rgba(253, 253, 234, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-yellow-100::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #fdf6b2;\n    color: rgba(253, 246, 178, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-yellow-100::placeholder {\n    --placeholder-opacity: 1;\n    color: #fdf6b2;\n    color: rgba(253, 246, 178, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-yellow-200::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #fce96a;\n    color: rgba(252, 233, 106, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-yellow-200::placeholder {\n    --placeholder-opacity: 1;\n    color: #fce96a;\n    color: rgba(252, 233, 106, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-yellow-300::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #faca15;\n    color: rgba(250, 202, 21, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-yellow-300::placeholder {\n    --placeholder-opacity: 1;\n    color: #faca15;\n    color: rgba(250, 202, 21, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-yellow-400::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #e3a008;\n    color: rgba(227, 160, 8, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-yellow-400::placeholder {\n    --placeholder-opacity: 1;\n    color: #e3a008;\n    color: rgba(227, 160, 8, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-yellow-500::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #c27803;\n    color: rgba(194, 120, 3, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-yellow-500::placeholder {\n    --placeholder-opacity: 1;\n    color: #c27803;\n    color: rgba(194, 120, 3, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-yellow-600::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #9f580a;\n    color: rgba(159, 88, 10, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-yellow-600::placeholder {\n    --placeholder-opacity: 1;\n    color: #9f580a;\n    color: rgba(159, 88, 10, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-yellow-700::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #8e4b10;\n    color: rgba(142, 75, 16, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-yellow-700::placeholder {\n    --placeholder-opacity: 1;\n    color: #8e4b10;\n    color: rgba(142, 75, 16, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-yellow-800::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #723b13;\n    color: rgba(114, 59, 19, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-yellow-800::placeholder {\n    --placeholder-opacity: 1;\n    color: #723b13;\n    color: rgba(114, 59, 19, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-yellow-900::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #633112;\n    color: rgba(99, 49, 18, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-yellow-900::placeholder {\n    --placeholder-opacity: 1;\n    color: #633112;\n    color: rgba(99, 49, 18, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-green-50::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #f3faf7;\n    color: rgba(243, 250, 247, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-green-50::placeholder {\n    --placeholder-opacity: 1;\n    color: #f3faf7;\n    color: rgba(243, 250, 247, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-green-100::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #def7ec;\n    color: rgba(222, 247, 236, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-green-100::placeholder {\n    --placeholder-opacity: 1;\n    color: #def7ec;\n    color: rgba(222, 247, 236, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-green-200::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #bcf0da;\n    color: rgba(188, 240, 218, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-green-200::placeholder {\n    --placeholder-opacity: 1;\n    color: #bcf0da;\n    color: rgba(188, 240, 218, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-green-300::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #84e1bc;\n    color: rgba(132, 225, 188, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-green-300::placeholder {\n    --placeholder-opacity: 1;\n    color: #84e1bc;\n    color: rgba(132, 225, 188, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-green-400::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #31c48d;\n    color: rgba(49, 196, 141, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-green-400::placeholder {\n    --placeholder-opacity: 1;\n    color: #31c48d;\n    color: rgba(49, 196, 141, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-green-500::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #0e9f6e;\n    color: rgba(14, 159, 110, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-green-500::placeholder {\n    --placeholder-opacity: 1;\n    color: #0e9f6e;\n    color: rgba(14, 159, 110, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-green-600::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #057a55;\n    color: rgba(5, 122, 85, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-green-600::placeholder {\n    --placeholder-opacity: 1;\n    color: #057a55;\n    color: rgba(5, 122, 85, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-green-700::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #046c4e;\n    color: rgba(4, 108, 78, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-green-700::placeholder {\n    --placeholder-opacity: 1;\n    color: #046c4e;\n    color: rgba(4, 108, 78, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-green-800::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #03543f;\n    color: rgba(3, 84, 63, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-green-800::placeholder {\n    --placeholder-opacity: 1;\n    color: #03543f;\n    color: rgba(3, 84, 63, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-green-900::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #014737;\n    color: rgba(1, 71, 55, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-green-900::placeholder {\n    --placeholder-opacity: 1;\n    color: #014737;\n    color: rgba(1, 71, 55, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-teal-50::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #edfafa;\n    color: rgba(237, 250, 250, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-teal-50::placeholder {\n    --placeholder-opacity: 1;\n    color: #edfafa;\n    color: rgba(237, 250, 250, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-teal-100::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #d5f5f6;\n    color: rgba(213, 245, 246, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-teal-100::placeholder {\n    --placeholder-opacity: 1;\n    color: #d5f5f6;\n    color: rgba(213, 245, 246, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-teal-200::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #afecef;\n    color: rgba(175, 236, 239, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-teal-200::placeholder {\n    --placeholder-opacity: 1;\n    color: #afecef;\n    color: rgba(175, 236, 239, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-teal-300::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #7edce2;\n    color: rgba(126, 220, 226, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-teal-300::placeholder {\n    --placeholder-opacity: 1;\n    color: #7edce2;\n    color: rgba(126, 220, 226, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-teal-400::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #16bdca;\n    color: rgba(22, 189, 202, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-teal-400::placeholder {\n    --placeholder-opacity: 1;\n    color: #16bdca;\n    color: rgba(22, 189, 202, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-teal-500::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #0694a2;\n    color: rgba(6, 148, 162, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-teal-500::placeholder {\n    --placeholder-opacity: 1;\n    color: #0694a2;\n    color: rgba(6, 148, 162, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-teal-600::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #047481;\n    color: rgba(4, 116, 129, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-teal-600::placeholder {\n    --placeholder-opacity: 1;\n    color: #047481;\n    color: rgba(4, 116, 129, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-teal-700::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #036672;\n    color: rgba(3, 102, 114, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-teal-700::placeholder {\n    --placeholder-opacity: 1;\n    color: #036672;\n    color: rgba(3, 102, 114, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-teal-800::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #05505c;\n    color: rgba(5, 80, 92, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-teal-800::placeholder {\n    --placeholder-opacity: 1;\n    color: #05505c;\n    color: rgba(5, 80, 92, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-teal-900::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #014451;\n    color: rgba(1, 68, 81, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-teal-900::placeholder {\n    --placeholder-opacity: 1;\n    color: #014451;\n    color: rgba(1, 68, 81, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-blue-50::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #ebf5ff;\n    color: rgba(235, 245, 255, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-blue-50::placeholder {\n    --placeholder-opacity: 1;\n    color: #ebf5ff;\n    color: rgba(235, 245, 255, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-blue-100::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #e1effe;\n    color: rgba(225, 239, 254, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-blue-100::placeholder {\n    --placeholder-opacity: 1;\n    color: #e1effe;\n    color: rgba(225, 239, 254, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-blue-200::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #c3ddfd;\n    color: rgba(195, 221, 253, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-blue-200::placeholder {\n    --placeholder-opacity: 1;\n    color: #c3ddfd;\n    color: rgba(195, 221, 253, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-blue-300::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #a4cafe;\n    color: rgba(164, 202, 254, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-blue-300::placeholder {\n    --placeholder-opacity: 1;\n    color: #a4cafe;\n    color: rgba(164, 202, 254, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-blue-400::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #76a9fa;\n    color: rgba(118, 169, 250, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-blue-400::placeholder {\n    --placeholder-opacity: 1;\n    color: #76a9fa;\n    color: rgba(118, 169, 250, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-blue-500::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #3f83f8;\n    color: rgba(63, 131, 248, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-blue-500::placeholder {\n    --placeholder-opacity: 1;\n    color: #3f83f8;\n    color: rgba(63, 131, 248, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-blue-600::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #1c64f2;\n    color: rgba(28, 100, 242, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-blue-600::placeholder {\n    --placeholder-opacity: 1;\n    color: #1c64f2;\n    color: rgba(28, 100, 242, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-blue-700::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #1a56db;\n    color: rgba(26, 86, 219, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-blue-700::placeholder {\n    --placeholder-opacity: 1;\n    color: #1a56db;\n    color: rgba(26, 86, 219, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-blue-800::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #1e429f;\n    color: rgba(30, 66, 159, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-blue-800::placeholder {\n    --placeholder-opacity: 1;\n    color: #1e429f;\n    color: rgba(30, 66, 159, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-blue-900::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #233876;\n    color: rgba(35, 56, 118, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-blue-900::placeholder {\n    --placeholder-opacity: 1;\n    color: #233876;\n    color: rgba(35, 56, 118, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-indigo-50::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #f0f5ff;\n    color: rgba(240, 245, 255, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-indigo-50::placeholder {\n    --placeholder-opacity: 1;\n    color: #f0f5ff;\n    color: rgba(240, 245, 255, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-indigo-100::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #e5edff;\n    color: rgba(229, 237, 255, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-indigo-100::placeholder {\n    --placeholder-opacity: 1;\n    color: #e5edff;\n    color: rgba(229, 237, 255, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-indigo-200::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #cddbfe;\n    color: rgba(205, 219, 254, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-indigo-200::placeholder {\n    --placeholder-opacity: 1;\n    color: #cddbfe;\n    color: rgba(205, 219, 254, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-indigo-300::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #b4c6fc;\n    color: rgba(180, 198, 252, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-indigo-300::placeholder {\n    --placeholder-opacity: 1;\n    color: #b4c6fc;\n    color: rgba(180, 198, 252, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-indigo-400::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #8da2fb;\n    color: rgba(141, 162, 251, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-indigo-400::placeholder {\n    --placeholder-opacity: 1;\n    color: #8da2fb;\n    color: rgba(141, 162, 251, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-indigo-500::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #6875f5;\n    color: rgba(104, 117, 245, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-indigo-500::placeholder {\n    --placeholder-opacity: 1;\n    color: #6875f5;\n    color: rgba(104, 117, 245, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-indigo-600::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #5850ec;\n    color: rgba(88, 80, 236, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-indigo-600::placeholder {\n    --placeholder-opacity: 1;\n    color: #5850ec;\n    color: rgba(88, 80, 236, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-indigo-700::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #5145cd;\n    color: rgba(81, 69, 205, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-indigo-700::placeholder {\n    --placeholder-opacity: 1;\n    color: #5145cd;\n    color: rgba(81, 69, 205, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-indigo-800::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #42389d;\n    color: rgba(66, 56, 157, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-indigo-800::placeholder {\n    --placeholder-opacity: 1;\n    color: #42389d;\n    color: rgba(66, 56, 157, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-indigo-900::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #362f78;\n    color: rgba(54, 47, 120, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-indigo-900::placeholder {\n    --placeholder-opacity: 1;\n    color: #362f78;\n    color: rgba(54, 47, 120, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-purple-50::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #f6f5ff;\n    color: rgba(246, 245, 255, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-purple-50::placeholder {\n    --placeholder-opacity: 1;\n    color: #f6f5ff;\n    color: rgba(246, 245, 255, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-purple-100::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #edebfe;\n    color: rgba(237, 235, 254, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-purple-100::placeholder {\n    --placeholder-opacity: 1;\n    color: #edebfe;\n    color: rgba(237, 235, 254, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-purple-200::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #dcd7fe;\n    color: rgba(220, 215, 254, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-purple-200::placeholder {\n    --placeholder-opacity: 1;\n    color: #dcd7fe;\n    color: rgba(220, 215, 254, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-purple-300::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #cabffd;\n    color: rgba(202, 191, 253, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-purple-300::placeholder {\n    --placeholder-opacity: 1;\n    color: #cabffd;\n    color: rgba(202, 191, 253, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-purple-400::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #ac94fa;\n    color: rgba(172, 148, 250, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-purple-400::placeholder {\n    --placeholder-opacity: 1;\n    color: #ac94fa;\n    color: rgba(172, 148, 250, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-purple-500::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #9061f9;\n    color: rgba(144, 97, 249, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-purple-500::placeholder {\n    --placeholder-opacity: 1;\n    color: #9061f9;\n    color: rgba(144, 97, 249, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-purple-600::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #7e3af2;\n    color: rgba(126, 58, 242, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-purple-600::placeholder {\n    --placeholder-opacity: 1;\n    color: #7e3af2;\n    color: rgba(126, 58, 242, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-purple-700::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #6c2bd9;\n    color: rgba(108, 43, 217, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-purple-700::placeholder {\n    --placeholder-opacity: 1;\n    color: #6c2bd9;\n    color: rgba(108, 43, 217, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-purple-800::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #5521b5;\n    color: rgba(85, 33, 181, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-purple-800::placeholder {\n    --placeholder-opacity: 1;\n    color: #5521b5;\n    color: rgba(85, 33, 181, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-purple-900::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #4a1d96;\n    color: rgba(74, 29, 150, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-purple-900::placeholder {\n    --placeholder-opacity: 1;\n    color: #4a1d96;\n    color: rgba(74, 29, 150, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-pink-50::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #fdf2f8;\n    color: rgba(253, 242, 248, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-pink-50::placeholder {\n    --placeholder-opacity: 1;\n    color: #fdf2f8;\n    color: rgba(253, 242, 248, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-pink-100::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #fce8f3;\n    color: rgba(252, 232, 243, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-pink-100::placeholder {\n    --placeholder-opacity: 1;\n    color: #fce8f3;\n    color: rgba(252, 232, 243, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-pink-200::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #fad1e8;\n    color: rgba(250, 209, 232, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-pink-200::placeholder {\n    --placeholder-opacity: 1;\n    color: #fad1e8;\n    color: rgba(250, 209, 232, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-pink-300::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #f8b4d9;\n    color: rgba(248, 180, 217, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-pink-300::placeholder {\n    --placeholder-opacity: 1;\n    color: #f8b4d9;\n    color: rgba(248, 180, 217, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-pink-400::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #f17eb8;\n    color: rgba(241, 126, 184, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-pink-400::placeholder {\n    --placeholder-opacity: 1;\n    color: #f17eb8;\n    color: rgba(241, 126, 184, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-pink-500::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #e74694;\n    color: rgba(231, 70, 148, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-pink-500::placeholder {\n    --placeholder-opacity: 1;\n    color: #e74694;\n    color: rgba(231, 70, 148, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-pink-600::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #d61f69;\n    color: rgba(214, 31, 105, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-pink-600::placeholder {\n    --placeholder-opacity: 1;\n    color: #d61f69;\n    color: rgba(214, 31, 105, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-pink-700::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #bf125d;\n    color: rgba(191, 18, 93, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-pink-700::placeholder {\n    --placeholder-opacity: 1;\n    color: #bf125d;\n    color: rgba(191, 18, 93, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-pink-800::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #99154b;\n    color: rgba(153, 21, 75, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-pink-800::placeholder {\n    --placeholder-opacity: 1;\n    color: #99154b;\n    color: rgba(153, 21, 75, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-pink-900::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #751a3d;\n    color: rgba(117, 26, 61, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-pink-900::placeholder {\n    --placeholder-opacity: 1;\n    color: #751a3d;\n    color: rgba(117, 26, 61, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-cool-gray-50::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #f8fafc;\n    color: rgba(248, 250, 252, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-cool-gray-50::placeholder {\n    --placeholder-opacity: 1;\n    color: #f8fafc;\n    color: rgba(248, 250, 252, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-cool-gray-100::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #f1f5f9;\n    color: rgba(241, 245, 249, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-cool-gray-100::placeholder {\n    --placeholder-opacity: 1;\n    color: #f1f5f9;\n    color: rgba(241, 245, 249, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-cool-gray-200::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #e2e8f0;\n    color: rgba(226, 232, 240, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-cool-gray-200::placeholder {\n    --placeholder-opacity: 1;\n    color: #e2e8f0;\n    color: rgba(226, 232, 240, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-cool-gray-300::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #cfd8e3;\n    color: rgba(207, 216, 227, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-cool-gray-300::placeholder {\n    --placeholder-opacity: 1;\n    color: #cfd8e3;\n    color: rgba(207, 216, 227, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-cool-gray-400::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #97a6ba;\n    color: rgba(151, 166, 186, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-cool-gray-400::placeholder {\n    --placeholder-opacity: 1;\n    color: #97a6ba;\n    color: rgba(151, 166, 186, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-cool-gray-500::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #64748b;\n    color: rgba(100, 116, 139, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-cool-gray-500::placeholder {\n    --placeholder-opacity: 1;\n    color: #64748b;\n    color: rgba(100, 116, 139, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-cool-gray-600::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #475569;\n    color: rgba(71, 85, 105, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-cool-gray-600::placeholder {\n    --placeholder-opacity: 1;\n    color: #475569;\n    color: rgba(71, 85, 105, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-cool-gray-700::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #364152;\n    color: rgba(54, 65, 82, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-cool-gray-700::placeholder {\n    --placeholder-opacity: 1;\n    color: #364152;\n    color: rgba(54, 65, 82, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-cool-gray-800::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #27303f;\n    color: rgba(39, 48, 63, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-cool-gray-800::placeholder {\n    --placeholder-opacity: 1;\n    color: #27303f;\n    color: rgba(39, 48, 63, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-cool-gray-900::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #1a202e;\n    color: rgba(26, 32, 46, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-cool-gray-900::placeholder {\n    --placeholder-opacity: 1;\n    color: #1a202e;\n    color: rgba(26, 32, 46, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-current:focus::-moz-placeholder {\n    color: currentColor;\n  }\n  .xl\\:focus\\:placeholder-current:focus::placeholder {\n    color: currentColor;\n  }\n  .xl\\:focus\\:placeholder-transparent:focus::-moz-placeholder {\n    color: transparent;\n  }\n  .xl\\:focus\\:placeholder-transparent:focus::placeholder {\n    color: transparent;\n  }\n  .xl\\:focus\\:placeholder-white:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #ffffff;\n    color: rgba(255, 255, 255, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-white:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #ffffff;\n    color: rgba(255, 255, 255, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-black:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #000000;\n    color: rgba(0, 0, 0, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-black:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #000000;\n    color: rgba(0, 0, 0, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-gray-50:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #f9fafb;\n    color: rgba(249, 250, 251, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-gray-50:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #f9fafb;\n    color: rgba(249, 250, 251, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-gray-100:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #f4f5f7;\n    color: rgba(244, 245, 247, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-gray-100:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #f4f5f7;\n    color: rgba(244, 245, 247, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-gray-200:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #e5e7eb;\n    color: rgba(229, 231, 235, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-gray-200:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #e5e7eb;\n    color: rgba(229, 231, 235, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-gray-300:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #d2d6dc;\n    color: rgba(210, 214, 220, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-gray-300:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #d2d6dc;\n    color: rgba(210, 214, 220, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-gray-400:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #9fa6b2;\n    color: rgba(159, 166, 178, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-gray-400:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #9fa6b2;\n    color: rgba(159, 166, 178, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-gray-500:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #6b7280;\n    color: rgba(107, 114, 128, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-gray-500:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #6b7280;\n    color: rgba(107, 114, 128, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-gray-600:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #4b5563;\n    color: rgba(75, 85, 99, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-gray-600:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #4b5563;\n    color: rgba(75, 85, 99, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-gray-700:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #374151;\n    color: rgba(55, 65, 81, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-gray-700:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #374151;\n    color: rgba(55, 65, 81, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-gray-800:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #252f3f;\n    color: rgba(37, 47, 63, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-gray-800:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #252f3f;\n    color: rgba(37, 47, 63, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-gray-900:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #161e2e;\n    color: rgba(22, 30, 46, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-gray-900:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #161e2e;\n    color: rgba(22, 30, 46, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-red-50:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #fdf2f2;\n    color: rgba(253, 242, 242, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-red-50:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #fdf2f2;\n    color: rgba(253, 242, 242, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-red-100:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #fde8e8;\n    color: rgba(253, 232, 232, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-red-100:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #fde8e8;\n    color: rgba(253, 232, 232, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-red-200:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #fbd5d5;\n    color: rgba(251, 213, 213, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-red-200:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #fbd5d5;\n    color: rgba(251, 213, 213, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-red-300:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #f8b4b4;\n    color: rgba(248, 180, 180, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-red-300:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #f8b4b4;\n    color: rgba(248, 180, 180, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-red-400:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #f98080;\n    color: rgba(249, 128, 128, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-red-400:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #f98080;\n    color: rgba(249, 128, 128, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-red-500:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #f05252;\n    color: rgba(240, 82, 82, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-red-500:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #f05252;\n    color: rgba(240, 82, 82, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-red-600:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #e02424;\n    color: rgba(224, 36, 36, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-red-600:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #e02424;\n    color: rgba(224, 36, 36, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-red-700:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #c81e1e;\n    color: rgba(200, 30, 30, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-red-700:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #c81e1e;\n    color: rgba(200, 30, 30, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-red-800:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #9b1c1c;\n    color: rgba(155, 28, 28, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-red-800:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #9b1c1c;\n    color: rgba(155, 28, 28, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-red-900:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #771d1d;\n    color: rgba(119, 29, 29, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-red-900:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #771d1d;\n    color: rgba(119, 29, 29, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-orange-50:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #fff8f1;\n    color: rgba(255, 248, 241, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-orange-50:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #fff8f1;\n    color: rgba(255, 248, 241, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-orange-100:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #feecdc;\n    color: rgba(254, 236, 220, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-orange-100:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #feecdc;\n    color: rgba(254, 236, 220, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-orange-200:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #fcd9bd;\n    color: rgba(252, 217, 189, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-orange-200:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #fcd9bd;\n    color: rgba(252, 217, 189, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-orange-300:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #fdba8c;\n    color: rgba(253, 186, 140, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-orange-300:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #fdba8c;\n    color: rgba(253, 186, 140, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-orange-400:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #ff8a4c;\n    color: rgba(255, 138, 76, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-orange-400:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #ff8a4c;\n    color: rgba(255, 138, 76, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-orange-500:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #ff5a1f;\n    color: rgba(255, 90, 31, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-orange-500:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #ff5a1f;\n    color: rgba(255, 90, 31, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-orange-600:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #d03801;\n    color: rgba(208, 56, 1, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-orange-600:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #d03801;\n    color: rgba(208, 56, 1, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-orange-700:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #b43403;\n    color: rgba(180, 52, 3, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-orange-700:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #b43403;\n    color: rgba(180, 52, 3, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-orange-800:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #8a2c0d;\n    color: rgba(138, 44, 13, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-orange-800:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #8a2c0d;\n    color: rgba(138, 44, 13, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-orange-900:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #73230d;\n    color: rgba(115, 35, 13, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-orange-900:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #73230d;\n    color: rgba(115, 35, 13, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-yellow-50:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #fdfdea;\n    color: rgba(253, 253, 234, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-yellow-50:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #fdfdea;\n    color: rgba(253, 253, 234, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-yellow-100:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #fdf6b2;\n    color: rgba(253, 246, 178, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-yellow-100:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #fdf6b2;\n    color: rgba(253, 246, 178, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-yellow-200:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #fce96a;\n    color: rgba(252, 233, 106, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-yellow-200:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #fce96a;\n    color: rgba(252, 233, 106, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-yellow-300:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #faca15;\n    color: rgba(250, 202, 21, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-yellow-300:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #faca15;\n    color: rgba(250, 202, 21, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-yellow-400:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #e3a008;\n    color: rgba(227, 160, 8, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-yellow-400:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #e3a008;\n    color: rgba(227, 160, 8, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-yellow-500:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #c27803;\n    color: rgba(194, 120, 3, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-yellow-500:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #c27803;\n    color: rgba(194, 120, 3, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-yellow-600:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #9f580a;\n    color: rgba(159, 88, 10, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-yellow-600:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #9f580a;\n    color: rgba(159, 88, 10, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-yellow-700:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #8e4b10;\n    color: rgba(142, 75, 16, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-yellow-700:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #8e4b10;\n    color: rgba(142, 75, 16, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-yellow-800:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #723b13;\n    color: rgba(114, 59, 19, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-yellow-800:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #723b13;\n    color: rgba(114, 59, 19, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-yellow-900:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #633112;\n    color: rgba(99, 49, 18, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-yellow-900:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #633112;\n    color: rgba(99, 49, 18, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-green-50:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #f3faf7;\n    color: rgba(243, 250, 247, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-green-50:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #f3faf7;\n    color: rgba(243, 250, 247, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-green-100:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #def7ec;\n    color: rgba(222, 247, 236, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-green-100:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #def7ec;\n    color: rgba(222, 247, 236, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-green-200:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #bcf0da;\n    color: rgba(188, 240, 218, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-green-200:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #bcf0da;\n    color: rgba(188, 240, 218, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-green-300:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #84e1bc;\n    color: rgba(132, 225, 188, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-green-300:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #84e1bc;\n    color: rgba(132, 225, 188, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-green-400:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #31c48d;\n    color: rgba(49, 196, 141, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-green-400:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #31c48d;\n    color: rgba(49, 196, 141, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-green-500:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #0e9f6e;\n    color: rgba(14, 159, 110, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-green-500:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #0e9f6e;\n    color: rgba(14, 159, 110, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-green-600:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #057a55;\n    color: rgba(5, 122, 85, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-green-600:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #057a55;\n    color: rgba(5, 122, 85, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-green-700:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #046c4e;\n    color: rgba(4, 108, 78, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-green-700:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #046c4e;\n    color: rgba(4, 108, 78, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-green-800:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #03543f;\n    color: rgba(3, 84, 63, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-green-800:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #03543f;\n    color: rgba(3, 84, 63, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-green-900:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #014737;\n    color: rgba(1, 71, 55, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-green-900:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #014737;\n    color: rgba(1, 71, 55, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-teal-50:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #edfafa;\n    color: rgba(237, 250, 250, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-teal-50:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #edfafa;\n    color: rgba(237, 250, 250, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-teal-100:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #d5f5f6;\n    color: rgba(213, 245, 246, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-teal-100:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #d5f5f6;\n    color: rgba(213, 245, 246, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-teal-200:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #afecef;\n    color: rgba(175, 236, 239, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-teal-200:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #afecef;\n    color: rgba(175, 236, 239, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-teal-300:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #7edce2;\n    color: rgba(126, 220, 226, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-teal-300:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #7edce2;\n    color: rgba(126, 220, 226, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-teal-400:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #16bdca;\n    color: rgba(22, 189, 202, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-teal-400:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #16bdca;\n    color: rgba(22, 189, 202, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-teal-500:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #0694a2;\n    color: rgba(6, 148, 162, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-teal-500:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #0694a2;\n    color: rgba(6, 148, 162, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-teal-600:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #047481;\n    color: rgba(4, 116, 129, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-teal-600:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #047481;\n    color: rgba(4, 116, 129, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-teal-700:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #036672;\n    color: rgba(3, 102, 114, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-teal-700:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #036672;\n    color: rgba(3, 102, 114, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-teal-800:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #05505c;\n    color: rgba(5, 80, 92, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-teal-800:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #05505c;\n    color: rgba(5, 80, 92, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-teal-900:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #014451;\n    color: rgba(1, 68, 81, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-teal-900:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #014451;\n    color: rgba(1, 68, 81, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-blue-50:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #ebf5ff;\n    color: rgba(235, 245, 255, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-blue-50:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #ebf5ff;\n    color: rgba(235, 245, 255, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-blue-100:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #e1effe;\n    color: rgba(225, 239, 254, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-blue-100:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #e1effe;\n    color: rgba(225, 239, 254, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-blue-200:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #c3ddfd;\n    color: rgba(195, 221, 253, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-blue-200:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #c3ddfd;\n    color: rgba(195, 221, 253, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-blue-300:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #a4cafe;\n    color: rgba(164, 202, 254, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-blue-300:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #a4cafe;\n    color: rgba(164, 202, 254, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-blue-400:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #76a9fa;\n    color: rgba(118, 169, 250, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-blue-400:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #76a9fa;\n    color: rgba(118, 169, 250, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-blue-500:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #3f83f8;\n    color: rgba(63, 131, 248, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-blue-500:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #3f83f8;\n    color: rgba(63, 131, 248, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-blue-600:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #1c64f2;\n    color: rgba(28, 100, 242, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-blue-600:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #1c64f2;\n    color: rgba(28, 100, 242, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-blue-700:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #1a56db;\n    color: rgba(26, 86, 219, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-blue-700:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #1a56db;\n    color: rgba(26, 86, 219, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-blue-800:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #1e429f;\n    color: rgba(30, 66, 159, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-blue-800:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #1e429f;\n    color: rgba(30, 66, 159, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-blue-900:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #233876;\n    color: rgba(35, 56, 118, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-blue-900:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #233876;\n    color: rgba(35, 56, 118, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-indigo-50:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #f0f5ff;\n    color: rgba(240, 245, 255, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-indigo-50:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #f0f5ff;\n    color: rgba(240, 245, 255, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-indigo-100:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #e5edff;\n    color: rgba(229, 237, 255, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-indigo-100:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #e5edff;\n    color: rgba(229, 237, 255, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-indigo-200:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #cddbfe;\n    color: rgba(205, 219, 254, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-indigo-200:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #cddbfe;\n    color: rgba(205, 219, 254, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-indigo-300:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #b4c6fc;\n    color: rgba(180, 198, 252, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-indigo-300:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #b4c6fc;\n    color: rgba(180, 198, 252, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-indigo-400:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #8da2fb;\n    color: rgba(141, 162, 251, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-indigo-400:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #8da2fb;\n    color: rgba(141, 162, 251, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-indigo-500:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #6875f5;\n    color: rgba(104, 117, 245, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-indigo-500:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #6875f5;\n    color: rgba(104, 117, 245, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-indigo-600:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #5850ec;\n    color: rgba(88, 80, 236, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-indigo-600:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #5850ec;\n    color: rgba(88, 80, 236, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-indigo-700:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #5145cd;\n    color: rgba(81, 69, 205, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-indigo-700:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #5145cd;\n    color: rgba(81, 69, 205, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-indigo-800:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #42389d;\n    color: rgba(66, 56, 157, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-indigo-800:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #42389d;\n    color: rgba(66, 56, 157, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-indigo-900:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #362f78;\n    color: rgba(54, 47, 120, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-indigo-900:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #362f78;\n    color: rgba(54, 47, 120, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-purple-50:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #f6f5ff;\n    color: rgba(246, 245, 255, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-purple-50:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #f6f5ff;\n    color: rgba(246, 245, 255, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-purple-100:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #edebfe;\n    color: rgba(237, 235, 254, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-purple-100:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #edebfe;\n    color: rgba(237, 235, 254, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-purple-200:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #dcd7fe;\n    color: rgba(220, 215, 254, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-purple-200:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #dcd7fe;\n    color: rgba(220, 215, 254, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-purple-300:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #cabffd;\n    color: rgba(202, 191, 253, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-purple-300:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #cabffd;\n    color: rgba(202, 191, 253, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-purple-400:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #ac94fa;\n    color: rgba(172, 148, 250, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-purple-400:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #ac94fa;\n    color: rgba(172, 148, 250, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-purple-500:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #9061f9;\n    color: rgba(144, 97, 249, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-purple-500:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #9061f9;\n    color: rgba(144, 97, 249, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-purple-600:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #7e3af2;\n    color: rgba(126, 58, 242, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-purple-600:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #7e3af2;\n    color: rgba(126, 58, 242, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-purple-700:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #6c2bd9;\n    color: rgba(108, 43, 217, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-purple-700:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #6c2bd9;\n    color: rgba(108, 43, 217, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-purple-800:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #5521b5;\n    color: rgba(85, 33, 181, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-purple-800:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #5521b5;\n    color: rgba(85, 33, 181, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-purple-900:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #4a1d96;\n    color: rgba(74, 29, 150, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-purple-900:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #4a1d96;\n    color: rgba(74, 29, 150, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-pink-50:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #fdf2f8;\n    color: rgba(253, 242, 248, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-pink-50:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #fdf2f8;\n    color: rgba(253, 242, 248, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-pink-100:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #fce8f3;\n    color: rgba(252, 232, 243, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-pink-100:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #fce8f3;\n    color: rgba(252, 232, 243, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-pink-200:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #fad1e8;\n    color: rgba(250, 209, 232, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-pink-200:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #fad1e8;\n    color: rgba(250, 209, 232, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-pink-300:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #f8b4d9;\n    color: rgba(248, 180, 217, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-pink-300:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #f8b4d9;\n    color: rgba(248, 180, 217, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-pink-400:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #f17eb8;\n    color: rgba(241, 126, 184, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-pink-400:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #f17eb8;\n    color: rgba(241, 126, 184, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-pink-500:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #e74694;\n    color: rgba(231, 70, 148, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-pink-500:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #e74694;\n    color: rgba(231, 70, 148, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-pink-600:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #d61f69;\n    color: rgba(214, 31, 105, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-pink-600:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #d61f69;\n    color: rgba(214, 31, 105, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-pink-700:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #bf125d;\n    color: rgba(191, 18, 93, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-pink-700:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #bf125d;\n    color: rgba(191, 18, 93, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-pink-800:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #99154b;\n    color: rgba(153, 21, 75, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-pink-800:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #99154b;\n    color: rgba(153, 21, 75, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-pink-900:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #751a3d;\n    color: rgba(117, 26, 61, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-pink-900:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #751a3d;\n    color: rgba(117, 26, 61, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-cool-gray-50:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #f8fafc;\n    color: rgba(248, 250, 252, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-cool-gray-50:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #f8fafc;\n    color: rgba(248, 250, 252, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-cool-gray-100:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #f1f5f9;\n    color: rgba(241, 245, 249, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-cool-gray-100:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #f1f5f9;\n    color: rgba(241, 245, 249, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-cool-gray-200:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #e2e8f0;\n    color: rgba(226, 232, 240, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-cool-gray-200:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #e2e8f0;\n    color: rgba(226, 232, 240, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-cool-gray-300:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #cfd8e3;\n    color: rgba(207, 216, 227, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-cool-gray-300:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #cfd8e3;\n    color: rgba(207, 216, 227, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-cool-gray-400:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #97a6ba;\n    color: rgba(151, 166, 186, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-cool-gray-400:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #97a6ba;\n    color: rgba(151, 166, 186, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-cool-gray-500:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #64748b;\n    color: rgba(100, 116, 139, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-cool-gray-500:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #64748b;\n    color: rgba(100, 116, 139, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-cool-gray-600:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #475569;\n    color: rgba(71, 85, 105, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-cool-gray-600:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #475569;\n    color: rgba(71, 85, 105, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-cool-gray-700:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #364152;\n    color: rgba(54, 65, 82, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-cool-gray-700:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #364152;\n    color: rgba(54, 65, 82, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-cool-gray-800:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #27303f;\n    color: rgba(39, 48, 63, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-cool-gray-800:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #27303f;\n    color: rgba(39, 48, 63, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-cool-gray-900:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n    color: #1a202e;\n    color: rgba(26, 32, 46, var(--placeholder-opacity));\n  }\n  .xl\\:focus\\:placeholder-cool-gray-900:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #1a202e;\n    color: rgba(26, 32, 46, var(--placeholder-opacity));\n  }\n  .xl\\:placeholder-opacity-0::-moz-placeholder {\n    --placeholder-opacity: 0;\n  }\n  .xl\\:placeholder-opacity-0::placeholder {\n    --placeholder-opacity: 0;\n  }\n  .xl\\:placeholder-opacity-25::-moz-placeholder {\n    --placeholder-opacity: 0.25;\n  }\n  .xl\\:placeholder-opacity-25::placeholder {\n    --placeholder-opacity: 0.25;\n  }\n  .xl\\:placeholder-opacity-50::-moz-placeholder {\n    --placeholder-opacity: 0.5;\n  }\n  .xl\\:placeholder-opacity-50::placeholder {\n    --placeholder-opacity: 0.5;\n  }\n  .xl\\:placeholder-opacity-75::-moz-placeholder {\n    --placeholder-opacity: 0.75;\n  }\n  .xl\\:placeholder-opacity-75::placeholder {\n    --placeholder-opacity: 0.75;\n  }\n  .xl\\:placeholder-opacity-100::-moz-placeholder {\n    --placeholder-opacity: 1;\n  }\n  .xl\\:placeholder-opacity-100::placeholder {\n    --placeholder-opacity: 1;\n  }\n  .xl\\:focus\\:placeholder-opacity-0:focus::-moz-placeholder {\n    --placeholder-opacity: 0;\n  }\n  .xl\\:focus\\:placeholder-opacity-0:focus::placeholder {\n    --placeholder-opacity: 0;\n  }\n  .xl\\:focus\\:placeholder-opacity-25:focus::-moz-placeholder {\n    --placeholder-opacity: 0.25;\n  }\n  .xl\\:focus\\:placeholder-opacity-25:focus::placeholder {\n    --placeholder-opacity: 0.25;\n  }\n  .xl\\:focus\\:placeholder-opacity-50:focus::-moz-placeholder {\n    --placeholder-opacity: 0.5;\n  }\n  .xl\\:focus\\:placeholder-opacity-50:focus::placeholder {\n    --placeholder-opacity: 0.5;\n  }\n  .xl\\:focus\\:placeholder-opacity-75:focus::-moz-placeholder {\n    --placeholder-opacity: 0.75;\n  }\n  .xl\\:focus\\:placeholder-opacity-75:focus::placeholder {\n    --placeholder-opacity: 0.75;\n  }\n  .xl\\:focus\\:placeholder-opacity-100:focus::-moz-placeholder {\n    --placeholder-opacity: 1;\n  }\n  .xl\\:focus\\:placeholder-opacity-100:focus::placeholder {\n    --placeholder-opacity: 1;\n  }\n  .xl\\:pointer-events-none {\n    pointer-events: none;\n  }\n  .xl\\:pointer-events-auto {\n    pointer-events: auto;\n  }\n  .xl\\:static {\n    position: static;\n  }\n  .xl\\:fixed {\n    position: fixed;\n  }\n  .xl\\:absolute {\n    position: absolute;\n  }\n  .xl\\:relative {\n    position: relative;\n  }\n  .xl\\:sticky {\n    position: sticky;\n  }\n  .xl\\:inset-0 {\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n  }\n  .xl\\:inset-1 {\n    top: 0.25rem;\n    right: 0.25rem;\n    bottom: 0.25rem;\n    left: 0.25rem;\n  }\n  .xl\\:inset-2 {\n    top: 0.5rem;\n    right: 0.5rem;\n    bottom: 0.5rem;\n    left: 0.5rem;\n  }\n  .xl\\:inset-3 {\n    top: 0.75rem;\n    right: 0.75rem;\n    bottom: 0.75rem;\n    left: 0.75rem;\n  }\n  .xl\\:inset-4 {\n    top: 1rem;\n    right: 1rem;\n    bottom: 1rem;\n    left: 1rem;\n  }\n  .xl\\:inset-5 {\n    top: 1.25rem;\n    right: 1.25rem;\n    bottom: 1.25rem;\n    left: 1.25rem;\n  }\n  .xl\\:inset-6 {\n    top: 1.5rem;\n    right: 1.5rem;\n    bottom: 1.5rem;\n    left: 1.5rem;\n  }\n  .xl\\:inset-7 {\n    top: 1.75rem;\n    right: 1.75rem;\n    bottom: 1.75rem;\n    left: 1.75rem;\n  }\n  .xl\\:inset-8 {\n    top: 2rem;\n    right: 2rem;\n    bottom: 2rem;\n    left: 2rem;\n  }\n  .xl\\:inset-9 {\n    top: 2.25rem;\n    right: 2.25rem;\n    bottom: 2.25rem;\n    left: 2.25rem;\n  }\n  .xl\\:inset-10 {\n    top: 2.5rem;\n    right: 2.5rem;\n    bottom: 2.5rem;\n    left: 2.5rem;\n  }\n  .xl\\:inset-11 {\n    top: 2.75rem;\n    right: 2.75rem;\n    bottom: 2.75rem;\n    left: 2.75rem;\n  }\n  .xl\\:inset-12 {\n    top: 3rem;\n    right: 3rem;\n    bottom: 3rem;\n    left: 3rem;\n  }\n  .xl\\:inset-13 {\n    top: 3.25rem;\n    right: 3.25rem;\n    bottom: 3.25rem;\n    left: 3.25rem;\n  }\n  .xl\\:inset-14 {\n    top: 3.5rem;\n    right: 3.5rem;\n    bottom: 3.5rem;\n    left: 3.5rem;\n  }\n  .xl\\:inset-15 {\n    top: 3.75rem;\n    right: 3.75rem;\n    bottom: 3.75rem;\n    left: 3.75rem;\n  }\n  .xl\\:inset-16 {\n    top: 4rem;\n    right: 4rem;\n    bottom: 4rem;\n    left: 4rem;\n  }\n  .xl\\:inset-20 {\n    top: 5rem;\n    right: 5rem;\n    bottom: 5rem;\n    left: 5rem;\n  }\n  .xl\\:inset-24 {\n    top: 6rem;\n    right: 6rem;\n    bottom: 6rem;\n    left: 6rem;\n  }\n  .xl\\:inset-28 {\n    top: 7rem;\n    right: 7rem;\n    bottom: 7rem;\n    left: 7rem;\n  }\n  .xl\\:inset-32 {\n    top: 8rem;\n    right: 8rem;\n    bottom: 8rem;\n    left: 8rem;\n  }\n  .xl\\:inset-36 {\n    top: 9rem;\n    right: 9rem;\n    bottom: 9rem;\n    left: 9rem;\n  }\n  .xl\\:inset-40 {\n    top: 10rem;\n    right: 10rem;\n    bottom: 10rem;\n    left: 10rem;\n  }\n  .xl\\:inset-44 {\n    top: 11rem;\n    right: 11rem;\n    bottom: 11rem;\n    left: 11rem;\n  }\n  .xl\\:inset-48 {\n    top: 12rem;\n    right: 12rem;\n    bottom: 12rem;\n    left: 12rem;\n  }\n  .xl\\:inset-52 {\n    top: 13rem;\n    right: 13rem;\n    bottom: 13rem;\n    left: 13rem;\n  }\n  .xl\\:inset-56 {\n    top: 14rem;\n    right: 14rem;\n    bottom: 14rem;\n    left: 14rem;\n  }\n  .xl\\:inset-60 {\n    top: 15rem;\n    right: 15rem;\n    bottom: 15rem;\n    left: 15rem;\n  }\n  .xl\\:inset-64 {\n    top: 16rem;\n    right: 16rem;\n    bottom: 16rem;\n    left: 16rem;\n  }\n  .xl\\:inset-72 {\n    top: 18rem;\n    right: 18rem;\n    bottom: 18rem;\n    left: 18rem;\n  }\n  .xl\\:inset-80 {\n    top: 20rem;\n    right: 20rem;\n    bottom: 20rem;\n    left: 20rem;\n  }\n  .xl\\:inset-96 {\n    top: 24rem;\n    right: 24rem;\n    bottom: 24rem;\n    left: 24rem;\n  }\n  .xl\\:inset-auto {\n    top: auto;\n    right: auto;\n    bottom: auto;\n    left: auto;\n  }\n  .xl\\:inset-px {\n    top: 1px;\n    right: 1px;\n    bottom: 1px;\n    left: 1px;\n  }\n  .xl\\:inset-0\\.5 {\n    top: 0.125rem;\n    right: 0.125rem;\n    bottom: 0.125rem;\n    left: 0.125rem;\n  }\n  .xl\\:inset-1\\.5 {\n    top: 0.375rem;\n    right: 0.375rem;\n    bottom: 0.375rem;\n    left: 0.375rem;\n  }\n  .xl\\:inset-2\\.5 {\n    top: 0.625rem;\n    right: 0.625rem;\n    bottom: 0.625rem;\n    left: 0.625rem;\n  }\n  .xl\\:inset-3\\.5 {\n    top: 0.875rem;\n    right: 0.875rem;\n    bottom: 0.875rem;\n    left: 0.875rem;\n  }\n  .xl\\:inset-1\\/2 {\n    top: 50%;\n    right: 50%;\n    bottom: 50%;\n    left: 50%;\n  }\n  .xl\\:inset-1\\/3 {\n    top: 33.333333%;\n    right: 33.333333%;\n    bottom: 33.333333%;\n    left: 33.333333%;\n  }\n  .xl\\:inset-2\\/3 {\n    top: 66.666667%;\n    right: 66.666667%;\n    bottom: 66.666667%;\n    left: 66.666667%;\n  }\n  .xl\\:inset-1\\/4 {\n    top: 25%;\n    right: 25%;\n    bottom: 25%;\n    left: 25%;\n  }\n  .xl\\:inset-2\\/4 {\n    top: 50%;\n    right: 50%;\n    bottom: 50%;\n    left: 50%;\n  }\n  .xl\\:inset-3\\/4 {\n    top: 75%;\n    right: 75%;\n    bottom: 75%;\n    left: 75%;\n  }\n  .xl\\:inset-1\\/5 {\n    top: 20%;\n    right: 20%;\n    bottom: 20%;\n    left: 20%;\n  }\n  .xl\\:inset-2\\/5 {\n    top: 40%;\n    right: 40%;\n    bottom: 40%;\n    left: 40%;\n  }\n  .xl\\:inset-3\\/5 {\n    top: 60%;\n    right: 60%;\n    bottom: 60%;\n    left: 60%;\n  }\n  .xl\\:inset-4\\/5 {\n    top: 80%;\n    right: 80%;\n    bottom: 80%;\n    left: 80%;\n  }\n  .xl\\:inset-1\\/6 {\n    top: 16.666667%;\n    right: 16.666667%;\n    bottom: 16.666667%;\n    left: 16.666667%;\n  }\n  .xl\\:inset-2\\/6 {\n    top: 33.333333%;\n    right: 33.333333%;\n    bottom: 33.333333%;\n    left: 33.333333%;\n  }\n  .xl\\:inset-3\\/6 {\n    top: 50%;\n    right: 50%;\n    bottom: 50%;\n    left: 50%;\n  }\n  .xl\\:inset-4\\/6 {\n    top: 66.666667%;\n    right: 66.666667%;\n    bottom: 66.666667%;\n    left: 66.666667%;\n  }\n  .xl\\:inset-5\\/6 {\n    top: 83.333333%;\n    right: 83.333333%;\n    bottom: 83.333333%;\n    left: 83.333333%;\n  }\n  .xl\\:inset-1\\/12 {\n    top: 8.333333%;\n    right: 8.333333%;\n    bottom: 8.333333%;\n    left: 8.333333%;\n  }\n  .xl\\:inset-2\\/12 {\n    top: 16.666667%;\n    right: 16.666667%;\n    bottom: 16.666667%;\n    left: 16.666667%;\n  }\n  .xl\\:inset-3\\/12 {\n    top: 25%;\n    right: 25%;\n    bottom: 25%;\n    left: 25%;\n  }\n  .xl\\:inset-4\\/12 {\n    top: 33.333333%;\n    right: 33.333333%;\n    bottom: 33.333333%;\n    left: 33.333333%;\n  }\n  .xl\\:inset-5\\/12 {\n    top: 41.666667%;\n    right: 41.666667%;\n    bottom: 41.666667%;\n    left: 41.666667%;\n  }\n  .xl\\:inset-6\\/12 {\n    top: 50%;\n    right: 50%;\n    bottom: 50%;\n    left: 50%;\n  }\n  .xl\\:inset-7\\/12 {\n    top: 58.333333%;\n    right: 58.333333%;\n    bottom: 58.333333%;\n    left: 58.333333%;\n  }\n  .xl\\:inset-8\\/12 {\n    top: 66.666667%;\n    right: 66.666667%;\n    bottom: 66.666667%;\n    left: 66.666667%;\n  }\n  .xl\\:inset-9\\/12 {\n    top: 75%;\n    right: 75%;\n    bottom: 75%;\n    left: 75%;\n  }\n  .xl\\:inset-10\\/12 {\n    top: 83.333333%;\n    right: 83.333333%;\n    bottom: 83.333333%;\n    left: 83.333333%;\n  }\n  .xl\\:inset-11\\/12 {\n    top: 91.666667%;\n    right: 91.666667%;\n    bottom: 91.666667%;\n    left: 91.666667%;\n  }\n  .xl\\:inset-full {\n    top: 100%;\n    right: 100%;\n    bottom: 100%;\n    left: 100%;\n  }\n  .xl\\:inset-y-0 {\n    top: 0;\n    bottom: 0;\n  }\n  .xl\\:inset-x-0 {\n    right: 0;\n    left: 0;\n  }\n  .xl\\:inset-y-1 {\n    top: 0.25rem;\n    bottom: 0.25rem;\n  }\n  .xl\\:inset-x-1 {\n    right: 0.25rem;\n    left: 0.25rem;\n  }\n  .xl\\:inset-y-2 {\n    top: 0.5rem;\n    bottom: 0.5rem;\n  }\n  .xl\\:inset-x-2 {\n    right: 0.5rem;\n    left: 0.5rem;\n  }\n  .xl\\:inset-y-3 {\n    top: 0.75rem;\n    bottom: 0.75rem;\n  }\n  .xl\\:inset-x-3 {\n    right: 0.75rem;\n    left: 0.75rem;\n  }\n  .xl\\:inset-y-4 {\n    top: 1rem;\n    bottom: 1rem;\n  }\n  .xl\\:inset-x-4 {\n    right: 1rem;\n    left: 1rem;\n  }\n  .xl\\:inset-y-5 {\n    top: 1.25rem;\n    bottom: 1.25rem;\n  }\n  .xl\\:inset-x-5 {\n    right: 1.25rem;\n    left: 1.25rem;\n  }\n  .xl\\:inset-y-6 {\n    top: 1.5rem;\n    bottom: 1.5rem;\n  }\n  .xl\\:inset-x-6 {\n    right: 1.5rem;\n    left: 1.5rem;\n  }\n  .xl\\:inset-y-7 {\n    top: 1.75rem;\n    bottom: 1.75rem;\n  }\n  .xl\\:inset-x-7 {\n    right: 1.75rem;\n    left: 1.75rem;\n  }\n  .xl\\:inset-y-8 {\n    top: 2rem;\n    bottom: 2rem;\n  }\n  .xl\\:inset-x-8 {\n    right: 2rem;\n    left: 2rem;\n  }\n  .xl\\:inset-y-9 {\n    top: 2.25rem;\n    bottom: 2.25rem;\n  }\n  .xl\\:inset-x-9 {\n    right: 2.25rem;\n    left: 2.25rem;\n  }\n  .xl\\:inset-y-10 {\n    top: 2.5rem;\n    bottom: 2.5rem;\n  }\n  .xl\\:inset-x-10 {\n    right: 2.5rem;\n    left: 2.5rem;\n  }\n  .xl\\:inset-y-11 {\n    top: 2.75rem;\n    bottom: 2.75rem;\n  }\n  .xl\\:inset-x-11 {\n    right: 2.75rem;\n    left: 2.75rem;\n  }\n  .xl\\:inset-y-12 {\n    top: 3rem;\n    bottom: 3rem;\n  }\n  .xl\\:inset-x-12 {\n    right: 3rem;\n    left: 3rem;\n  }\n  .xl\\:inset-y-13 {\n    top: 3.25rem;\n    bottom: 3.25rem;\n  }\n  .xl\\:inset-x-13 {\n    right: 3.25rem;\n    left: 3.25rem;\n  }\n  .xl\\:inset-y-14 {\n    top: 3.5rem;\n    bottom: 3.5rem;\n  }\n  .xl\\:inset-x-14 {\n    right: 3.5rem;\n    left: 3.5rem;\n  }\n  .xl\\:inset-y-15 {\n    top: 3.75rem;\n    bottom: 3.75rem;\n  }\n  .xl\\:inset-x-15 {\n    right: 3.75rem;\n    left: 3.75rem;\n  }\n  .xl\\:inset-y-16 {\n    top: 4rem;\n    bottom: 4rem;\n  }\n  .xl\\:inset-x-16 {\n    right: 4rem;\n    left: 4rem;\n  }\n  .xl\\:inset-y-20 {\n    top: 5rem;\n    bottom: 5rem;\n  }\n  .xl\\:inset-x-20 {\n    right: 5rem;\n    left: 5rem;\n  }\n  .xl\\:inset-y-24 {\n    top: 6rem;\n    bottom: 6rem;\n  }\n  .xl\\:inset-x-24 {\n    right: 6rem;\n    left: 6rem;\n  }\n  .xl\\:inset-y-28 {\n    top: 7rem;\n    bottom: 7rem;\n  }\n  .xl\\:inset-x-28 {\n    right: 7rem;\n    left: 7rem;\n  }\n  .xl\\:inset-y-32 {\n    top: 8rem;\n    bottom: 8rem;\n  }\n  .xl\\:inset-x-32 {\n    right: 8rem;\n    left: 8rem;\n  }\n  .xl\\:inset-y-36 {\n    top: 9rem;\n    bottom: 9rem;\n  }\n  .xl\\:inset-x-36 {\n    right: 9rem;\n    left: 9rem;\n  }\n  .xl\\:inset-y-40 {\n    top: 10rem;\n    bottom: 10rem;\n  }\n  .xl\\:inset-x-40 {\n    right: 10rem;\n    left: 10rem;\n  }\n  .xl\\:inset-y-44 {\n    top: 11rem;\n    bottom: 11rem;\n  }\n  .xl\\:inset-x-44 {\n    right: 11rem;\n    left: 11rem;\n  }\n  .xl\\:inset-y-48 {\n    top: 12rem;\n    bottom: 12rem;\n  }\n  .xl\\:inset-x-48 {\n    right: 12rem;\n    left: 12rem;\n  }\n  .xl\\:inset-y-52 {\n    top: 13rem;\n    bottom: 13rem;\n  }\n  .xl\\:inset-x-52 {\n    right: 13rem;\n    left: 13rem;\n  }\n  .xl\\:inset-y-56 {\n    top: 14rem;\n    bottom: 14rem;\n  }\n  .xl\\:inset-x-56 {\n    right: 14rem;\n    left: 14rem;\n  }\n  .xl\\:inset-y-60 {\n    top: 15rem;\n    bottom: 15rem;\n  }\n  .xl\\:inset-x-60 {\n    right: 15rem;\n    left: 15rem;\n  }\n  .xl\\:inset-y-64 {\n    top: 16rem;\n    bottom: 16rem;\n  }\n  .xl\\:inset-x-64 {\n    right: 16rem;\n    left: 16rem;\n  }\n  .xl\\:inset-y-72 {\n    top: 18rem;\n    bottom: 18rem;\n  }\n  .xl\\:inset-x-72 {\n    right: 18rem;\n    left: 18rem;\n  }\n  .xl\\:inset-y-80 {\n    top: 20rem;\n    bottom: 20rem;\n  }\n  .xl\\:inset-x-80 {\n    right: 20rem;\n    left: 20rem;\n  }\n  .xl\\:inset-y-96 {\n    top: 24rem;\n    bottom: 24rem;\n  }\n  .xl\\:inset-x-96 {\n    right: 24rem;\n    left: 24rem;\n  }\n  .xl\\:inset-y-auto {\n    top: auto;\n    bottom: auto;\n  }\n  .xl\\:inset-x-auto {\n    right: auto;\n    left: auto;\n  }\n  .xl\\:inset-y-px {\n    top: 1px;\n    bottom: 1px;\n  }\n  .xl\\:inset-x-px {\n    right: 1px;\n    left: 1px;\n  }\n  .xl\\:inset-y-0\\.5 {\n    top: 0.125rem;\n    bottom: 0.125rem;\n  }\n  .xl\\:inset-x-0\\.5 {\n    right: 0.125rem;\n    left: 0.125rem;\n  }\n  .xl\\:inset-y-1\\.5 {\n    top: 0.375rem;\n    bottom: 0.375rem;\n  }\n  .xl\\:inset-x-1\\.5 {\n    right: 0.375rem;\n    left: 0.375rem;\n  }\n  .xl\\:inset-y-2\\.5 {\n    top: 0.625rem;\n    bottom: 0.625rem;\n  }\n  .xl\\:inset-x-2\\.5 {\n    right: 0.625rem;\n    left: 0.625rem;\n  }\n  .xl\\:inset-y-3\\.5 {\n    top: 0.875rem;\n    bottom: 0.875rem;\n  }\n  .xl\\:inset-x-3\\.5 {\n    right: 0.875rem;\n    left: 0.875rem;\n  }\n  .xl\\:inset-y-1\\/2 {\n    top: 50%;\n    bottom: 50%;\n  }\n  .xl\\:inset-x-1\\/2 {\n    right: 50%;\n    left: 50%;\n  }\n  .xl\\:inset-y-1\\/3 {\n    top: 33.333333%;\n    bottom: 33.333333%;\n  }\n  .xl\\:inset-x-1\\/3 {\n    right: 33.333333%;\n    left: 33.333333%;\n  }\n  .xl\\:inset-y-2\\/3 {\n    top: 66.666667%;\n    bottom: 66.666667%;\n  }\n  .xl\\:inset-x-2\\/3 {\n    right: 66.666667%;\n    left: 66.666667%;\n  }\n  .xl\\:inset-y-1\\/4 {\n    top: 25%;\n    bottom: 25%;\n  }\n  .xl\\:inset-x-1\\/4 {\n    right: 25%;\n    left: 25%;\n  }\n  .xl\\:inset-y-2\\/4 {\n    top: 50%;\n    bottom: 50%;\n  }\n  .xl\\:inset-x-2\\/4 {\n    right: 50%;\n    left: 50%;\n  }\n  .xl\\:inset-y-3\\/4 {\n    top: 75%;\n    bottom: 75%;\n  }\n  .xl\\:inset-x-3\\/4 {\n    right: 75%;\n    left: 75%;\n  }\n  .xl\\:inset-y-1\\/5 {\n    top: 20%;\n    bottom: 20%;\n  }\n  .xl\\:inset-x-1\\/5 {\n    right: 20%;\n    left: 20%;\n  }\n  .xl\\:inset-y-2\\/5 {\n    top: 40%;\n    bottom: 40%;\n  }\n  .xl\\:inset-x-2\\/5 {\n    right: 40%;\n    left: 40%;\n  }\n  .xl\\:inset-y-3\\/5 {\n    top: 60%;\n    bottom: 60%;\n  }\n  .xl\\:inset-x-3\\/5 {\n    right: 60%;\n    left: 60%;\n  }\n  .xl\\:inset-y-4\\/5 {\n    top: 80%;\n    bottom: 80%;\n  }\n  .xl\\:inset-x-4\\/5 {\n    right: 80%;\n    left: 80%;\n  }\n  .xl\\:inset-y-1\\/6 {\n    top: 16.666667%;\n    bottom: 16.666667%;\n  }\n  .xl\\:inset-x-1\\/6 {\n    right: 16.666667%;\n    left: 16.666667%;\n  }\n  .xl\\:inset-y-2\\/6 {\n    top: 33.333333%;\n    bottom: 33.333333%;\n  }\n  .xl\\:inset-x-2\\/6 {\n    right: 33.333333%;\n    left: 33.333333%;\n  }\n  .xl\\:inset-y-3\\/6 {\n    top: 50%;\n    bottom: 50%;\n  }\n  .xl\\:inset-x-3\\/6 {\n    right: 50%;\n    left: 50%;\n  }\n  .xl\\:inset-y-4\\/6 {\n    top: 66.666667%;\n    bottom: 66.666667%;\n  }\n  .xl\\:inset-x-4\\/6 {\n    right: 66.666667%;\n    left: 66.666667%;\n  }\n  .xl\\:inset-y-5\\/6 {\n    top: 83.333333%;\n    bottom: 83.333333%;\n  }\n  .xl\\:inset-x-5\\/6 {\n    right: 83.333333%;\n    left: 83.333333%;\n  }\n  .xl\\:inset-y-1\\/12 {\n    top: 8.333333%;\n    bottom: 8.333333%;\n  }\n  .xl\\:inset-x-1\\/12 {\n    right: 8.333333%;\n    left: 8.333333%;\n  }\n  .xl\\:inset-y-2\\/12 {\n    top: 16.666667%;\n    bottom: 16.666667%;\n  }\n  .xl\\:inset-x-2\\/12 {\n    right: 16.666667%;\n    left: 16.666667%;\n  }\n  .xl\\:inset-y-3\\/12 {\n    top: 25%;\n    bottom: 25%;\n  }\n  .xl\\:inset-x-3\\/12 {\n    right: 25%;\n    left: 25%;\n  }\n  .xl\\:inset-y-4\\/12 {\n    top: 33.333333%;\n    bottom: 33.333333%;\n  }\n  .xl\\:inset-x-4\\/12 {\n    right: 33.333333%;\n    left: 33.333333%;\n  }\n  .xl\\:inset-y-5\\/12 {\n    top: 41.666667%;\n    bottom: 41.666667%;\n  }\n  .xl\\:inset-x-5\\/12 {\n    right: 41.666667%;\n    left: 41.666667%;\n  }\n  .xl\\:inset-y-6\\/12 {\n    top: 50%;\n    bottom: 50%;\n  }\n  .xl\\:inset-x-6\\/12 {\n    right: 50%;\n    left: 50%;\n  }\n  .xl\\:inset-y-7\\/12 {\n    top: 58.333333%;\n    bottom: 58.333333%;\n  }\n  .xl\\:inset-x-7\\/12 {\n    right: 58.333333%;\n    left: 58.333333%;\n  }\n  .xl\\:inset-y-8\\/12 {\n    top: 66.666667%;\n    bottom: 66.666667%;\n  }\n  .xl\\:inset-x-8\\/12 {\n    right: 66.666667%;\n    left: 66.666667%;\n  }\n  .xl\\:inset-y-9\\/12 {\n    top: 75%;\n    bottom: 75%;\n  }\n  .xl\\:inset-x-9\\/12 {\n    right: 75%;\n    left: 75%;\n  }\n  .xl\\:inset-y-10\\/12 {\n    top: 83.333333%;\n    bottom: 83.333333%;\n  }\n  .xl\\:inset-x-10\\/12 {\n    right: 83.333333%;\n    left: 83.333333%;\n  }\n  .xl\\:inset-y-11\\/12 {\n    top: 91.666667%;\n    bottom: 91.666667%;\n  }\n  .xl\\:inset-x-11\\/12 {\n    right: 91.666667%;\n    left: 91.666667%;\n  }\n  .xl\\:inset-y-full {\n    top: 100%;\n    bottom: 100%;\n  }\n  .xl\\:inset-x-full {\n    right: 100%;\n    left: 100%;\n  }\n  .xl\\:top-0 {\n    top: 0;\n  }\n  .xl\\:right-0 {\n    right: 0;\n  }\n  .xl\\:bottom-0 {\n    bottom: 0;\n  }\n  .xl\\:left-0 {\n    left: 0;\n  }\n  .xl\\:top-1 {\n    top: 0.25rem;\n  }\n  .xl\\:right-1 {\n    right: 0.25rem;\n  }\n  .xl\\:bottom-1 {\n    bottom: 0.25rem;\n  }\n  .xl\\:left-1 {\n    left: 0.25rem;\n  }\n  .xl\\:top-2 {\n    top: 0.5rem;\n  }\n  .xl\\:right-2 {\n    right: 0.5rem;\n  }\n  .xl\\:bottom-2 {\n    bottom: 0.5rem;\n  }\n  .xl\\:left-2 {\n    left: 0.5rem;\n  }\n  .xl\\:top-3 {\n    top: 0.75rem;\n  }\n  .xl\\:right-3 {\n    right: 0.75rem;\n  }\n  .xl\\:bottom-3 {\n    bottom: 0.75rem;\n  }\n  .xl\\:left-3 {\n    left: 0.75rem;\n  }\n  .xl\\:top-4 {\n    top: 1rem;\n  }\n  .xl\\:right-4 {\n    right: 1rem;\n  }\n  .xl\\:bottom-4 {\n    bottom: 1rem;\n  }\n  .xl\\:left-4 {\n    left: 1rem;\n  }\n  .xl\\:top-5 {\n    top: 1.25rem;\n  }\n  .xl\\:right-5 {\n    right: 1.25rem;\n  }\n  .xl\\:bottom-5 {\n    bottom: 1.25rem;\n  }\n  .xl\\:left-5 {\n    left: 1.25rem;\n  }\n  .xl\\:top-6 {\n    top: 1.5rem;\n  }\n  .xl\\:right-6 {\n    right: 1.5rem;\n  }\n  .xl\\:bottom-6 {\n    bottom: 1.5rem;\n  }\n  .xl\\:left-6 {\n    left: 1.5rem;\n  }\n  .xl\\:top-7 {\n    top: 1.75rem;\n  }\n  .xl\\:right-7 {\n    right: 1.75rem;\n  }\n  .xl\\:bottom-7 {\n    bottom: 1.75rem;\n  }\n  .xl\\:left-7 {\n    left: 1.75rem;\n  }\n  .xl\\:top-8 {\n    top: 2rem;\n  }\n  .xl\\:right-8 {\n    right: 2rem;\n  }\n  .xl\\:bottom-8 {\n    bottom: 2rem;\n  }\n  .xl\\:left-8 {\n    left: 2rem;\n  }\n  .xl\\:top-9 {\n    top: 2.25rem;\n  }\n  .xl\\:right-9 {\n    right: 2.25rem;\n  }\n  .xl\\:bottom-9 {\n    bottom: 2.25rem;\n  }\n  .xl\\:left-9 {\n    left: 2.25rem;\n  }\n  .xl\\:top-10 {\n    top: 2.5rem;\n  }\n  .xl\\:right-10 {\n    right: 2.5rem;\n  }\n  .xl\\:bottom-10 {\n    bottom: 2.5rem;\n  }\n  .xl\\:left-10 {\n    left: 2.5rem;\n  }\n  .xl\\:top-11 {\n    top: 2.75rem;\n  }\n  .xl\\:right-11 {\n    right: 2.75rem;\n  }\n  .xl\\:bottom-11 {\n    bottom: 2.75rem;\n  }\n  .xl\\:left-11 {\n    left: 2.75rem;\n  }\n  .xl\\:top-12 {\n    top: 3rem;\n  }\n  .xl\\:right-12 {\n    right: 3rem;\n  }\n  .xl\\:bottom-12 {\n    bottom: 3rem;\n  }\n  .xl\\:left-12 {\n    left: 3rem;\n  }\n  .xl\\:top-13 {\n    top: 3.25rem;\n  }\n  .xl\\:right-13 {\n    right: 3.25rem;\n  }\n  .xl\\:bottom-13 {\n    bottom: 3.25rem;\n  }\n  .xl\\:left-13 {\n    left: 3.25rem;\n  }\n  .xl\\:top-14 {\n    top: 3.5rem;\n  }\n  .xl\\:right-14 {\n    right: 3.5rem;\n  }\n  .xl\\:bottom-14 {\n    bottom: 3.5rem;\n  }\n  .xl\\:left-14 {\n    left: 3.5rem;\n  }\n  .xl\\:top-15 {\n    top: 3.75rem;\n  }\n  .xl\\:right-15 {\n    right: 3.75rem;\n  }\n  .xl\\:bottom-15 {\n    bottom: 3.75rem;\n  }\n  .xl\\:left-15 {\n    left: 3.75rem;\n  }\n  .xl\\:top-16 {\n    top: 4rem;\n  }\n  .xl\\:right-16 {\n    right: 4rem;\n  }\n  .xl\\:bottom-16 {\n    bottom: 4rem;\n  }\n  .xl\\:left-16 {\n    left: 4rem;\n  }\n  .xl\\:top-20 {\n    top: 5rem;\n  }\n  .xl\\:right-20 {\n    right: 5rem;\n  }\n  .xl\\:bottom-20 {\n    bottom: 5rem;\n  }\n  .xl\\:left-20 {\n    left: 5rem;\n  }\n  .xl\\:top-24 {\n    top: 6rem;\n  }\n  .xl\\:right-24 {\n    right: 6rem;\n  }\n  .xl\\:bottom-24 {\n    bottom: 6rem;\n  }\n  .xl\\:left-24 {\n    left: 6rem;\n  }\n  .xl\\:top-28 {\n    top: 7rem;\n  }\n  .xl\\:right-28 {\n    right: 7rem;\n  }\n  .xl\\:bottom-28 {\n    bottom: 7rem;\n  }\n  .xl\\:left-28 {\n    left: 7rem;\n  }\n  .xl\\:top-32 {\n    top: 8rem;\n  }\n  .xl\\:right-32 {\n    right: 8rem;\n  }\n  .xl\\:bottom-32 {\n    bottom: 8rem;\n  }\n  .xl\\:left-32 {\n    left: 8rem;\n  }\n  .xl\\:top-36 {\n    top: 9rem;\n  }\n  .xl\\:right-36 {\n    right: 9rem;\n  }\n  .xl\\:bottom-36 {\n    bottom: 9rem;\n  }\n  .xl\\:left-36 {\n    left: 9rem;\n  }\n  .xl\\:top-40 {\n    top: 10rem;\n  }\n  .xl\\:right-40 {\n    right: 10rem;\n  }\n  .xl\\:bottom-40 {\n    bottom: 10rem;\n  }\n  .xl\\:left-40 {\n    left: 10rem;\n  }\n  .xl\\:top-44 {\n    top: 11rem;\n  }\n  .xl\\:right-44 {\n    right: 11rem;\n  }\n  .xl\\:bottom-44 {\n    bottom: 11rem;\n  }\n  .xl\\:left-44 {\n    left: 11rem;\n  }\n  .xl\\:top-48 {\n    top: 12rem;\n  }\n  .xl\\:right-48 {\n    right: 12rem;\n  }\n  .xl\\:bottom-48 {\n    bottom: 12rem;\n  }\n  .xl\\:left-48 {\n    left: 12rem;\n  }\n  .xl\\:top-52 {\n    top: 13rem;\n  }\n  .xl\\:right-52 {\n    right: 13rem;\n  }\n  .xl\\:bottom-52 {\n    bottom: 13rem;\n  }\n  .xl\\:left-52 {\n    left: 13rem;\n  }\n  .xl\\:top-56 {\n    top: 14rem;\n  }\n  .xl\\:right-56 {\n    right: 14rem;\n  }\n  .xl\\:bottom-56 {\n    bottom: 14rem;\n  }\n  .xl\\:left-56 {\n    left: 14rem;\n  }\n  .xl\\:top-60 {\n    top: 15rem;\n  }\n  .xl\\:right-60 {\n    right: 15rem;\n  }\n  .xl\\:bottom-60 {\n    bottom: 15rem;\n  }\n  .xl\\:left-60 {\n    left: 15rem;\n  }\n  .xl\\:top-64 {\n    top: 16rem;\n  }\n  .xl\\:right-64 {\n    right: 16rem;\n  }\n  .xl\\:bottom-64 {\n    bottom: 16rem;\n  }\n  .xl\\:left-64 {\n    left: 16rem;\n  }\n  .xl\\:top-72 {\n    top: 18rem;\n  }\n  .xl\\:right-72 {\n    right: 18rem;\n  }\n  .xl\\:bottom-72 {\n    bottom: 18rem;\n  }\n  .xl\\:left-72 {\n    left: 18rem;\n  }\n  .xl\\:top-80 {\n    top: 20rem;\n  }\n  .xl\\:right-80 {\n    right: 20rem;\n  }\n  .xl\\:bottom-80 {\n    bottom: 20rem;\n  }\n  .xl\\:left-80 {\n    left: 20rem;\n  }\n  .xl\\:top-96 {\n    top: 24rem;\n  }\n  .xl\\:right-96 {\n    right: 24rem;\n  }\n  .xl\\:bottom-96 {\n    bottom: 24rem;\n  }\n  .xl\\:left-96 {\n    left: 24rem;\n  }\n  .xl\\:top-auto {\n    top: auto;\n  }\n  .xl\\:right-auto {\n    right: auto;\n  }\n  .xl\\:bottom-auto {\n    bottom: auto;\n  }\n  .xl\\:left-auto {\n    left: auto;\n  }\n  .xl\\:top-px {\n    top: 1px;\n  }\n  .xl\\:right-px {\n    right: 1px;\n  }\n  .xl\\:bottom-px {\n    bottom: 1px;\n  }\n  .xl\\:left-px {\n    left: 1px;\n  }\n  .xl\\:top-0\\.5 {\n    top: 0.125rem;\n  }\n  .xl\\:right-0\\.5 {\n    right: 0.125rem;\n  }\n  .xl\\:bottom-0\\.5 {\n    bottom: 0.125rem;\n  }\n  .xl\\:left-0\\.5 {\n    left: 0.125rem;\n  }\n  .xl\\:top-1\\.5 {\n    top: 0.375rem;\n  }\n  .xl\\:right-1\\.5 {\n    right: 0.375rem;\n  }\n  .xl\\:bottom-1\\.5 {\n    bottom: 0.375rem;\n  }\n  .xl\\:left-1\\.5 {\n    left: 0.375rem;\n  }\n  .xl\\:top-2\\.5 {\n    top: 0.625rem;\n  }\n  .xl\\:right-2\\.5 {\n    right: 0.625rem;\n  }\n  .xl\\:bottom-2\\.5 {\n    bottom: 0.625rem;\n  }\n  .xl\\:left-2\\.5 {\n    left: 0.625rem;\n  }\n  .xl\\:top-3\\.5 {\n    top: 0.875rem;\n  }\n  .xl\\:right-3\\.5 {\n    right: 0.875rem;\n  }\n  .xl\\:bottom-3\\.5 {\n    bottom: 0.875rem;\n  }\n  .xl\\:left-3\\.5 {\n    left: 0.875rem;\n  }\n  .xl\\:top-1\\/2 {\n    top: 50%;\n  }\n  .xl\\:right-1\\/2 {\n    right: 50%;\n  }\n  .xl\\:bottom-1\\/2 {\n    bottom: 50%;\n  }\n  .xl\\:left-1\\/2 {\n    left: 50%;\n  }\n  .xl\\:top-1\\/3 {\n    top: 33.333333%;\n  }\n  .xl\\:right-1\\/3 {\n    right: 33.333333%;\n  }\n  .xl\\:bottom-1\\/3 {\n    bottom: 33.333333%;\n  }\n  .xl\\:left-1\\/3 {\n    left: 33.333333%;\n  }\n  .xl\\:top-2\\/3 {\n    top: 66.666667%;\n  }\n  .xl\\:right-2\\/3 {\n    right: 66.666667%;\n  }\n  .xl\\:bottom-2\\/3 {\n    bottom: 66.666667%;\n  }\n  .xl\\:left-2\\/3 {\n    left: 66.666667%;\n  }\n  .xl\\:top-1\\/4 {\n    top: 25%;\n  }\n  .xl\\:right-1\\/4 {\n    right: 25%;\n  }\n  .xl\\:bottom-1\\/4 {\n    bottom: 25%;\n  }\n  .xl\\:left-1\\/4 {\n    left: 25%;\n  }\n  .xl\\:top-2\\/4 {\n    top: 50%;\n  }\n  .xl\\:right-2\\/4 {\n    right: 50%;\n  }\n  .xl\\:bottom-2\\/4 {\n    bottom: 50%;\n  }\n  .xl\\:left-2\\/4 {\n    left: 50%;\n  }\n  .xl\\:top-3\\/4 {\n    top: 75%;\n  }\n  .xl\\:right-3\\/4 {\n    right: 75%;\n  }\n  .xl\\:bottom-3\\/4 {\n    bottom: 75%;\n  }\n  .xl\\:left-3\\/4 {\n    left: 75%;\n  }\n  .xl\\:top-1\\/5 {\n    top: 20%;\n  }\n  .xl\\:right-1\\/5 {\n    right: 20%;\n  }\n  .xl\\:bottom-1\\/5 {\n    bottom: 20%;\n  }\n  .xl\\:left-1\\/5 {\n    left: 20%;\n  }\n  .xl\\:top-2\\/5 {\n    top: 40%;\n  }\n  .xl\\:right-2\\/5 {\n    right: 40%;\n  }\n  .xl\\:bottom-2\\/5 {\n    bottom: 40%;\n  }\n  .xl\\:left-2\\/5 {\n    left: 40%;\n  }\n  .xl\\:top-3\\/5 {\n    top: 60%;\n  }\n  .xl\\:right-3\\/5 {\n    right: 60%;\n  }\n  .xl\\:bottom-3\\/5 {\n    bottom: 60%;\n  }\n  .xl\\:left-3\\/5 {\n    left: 60%;\n  }\n  .xl\\:top-4\\/5 {\n    top: 80%;\n  }\n  .xl\\:right-4\\/5 {\n    right: 80%;\n  }\n  .xl\\:bottom-4\\/5 {\n    bottom: 80%;\n  }\n  .xl\\:left-4\\/5 {\n    left: 80%;\n  }\n  .xl\\:top-1\\/6 {\n    top: 16.666667%;\n  }\n  .xl\\:right-1\\/6 {\n    right: 16.666667%;\n  }\n  .xl\\:bottom-1\\/6 {\n    bottom: 16.666667%;\n  }\n  .xl\\:left-1\\/6 {\n    left: 16.666667%;\n  }\n  .xl\\:top-2\\/6 {\n    top: 33.333333%;\n  }\n  .xl\\:right-2\\/6 {\n    right: 33.333333%;\n  }\n  .xl\\:bottom-2\\/6 {\n    bottom: 33.333333%;\n  }\n  .xl\\:left-2\\/6 {\n    left: 33.333333%;\n  }\n  .xl\\:top-3\\/6 {\n    top: 50%;\n  }\n  .xl\\:right-3\\/6 {\n    right: 50%;\n  }\n  .xl\\:bottom-3\\/6 {\n    bottom: 50%;\n  }\n  .xl\\:left-3\\/6 {\n    left: 50%;\n  }\n  .xl\\:top-4\\/6 {\n    top: 66.666667%;\n  }\n  .xl\\:right-4\\/6 {\n    right: 66.666667%;\n  }\n  .xl\\:bottom-4\\/6 {\n    bottom: 66.666667%;\n  }\n  .xl\\:left-4\\/6 {\n    left: 66.666667%;\n  }\n  .xl\\:top-5\\/6 {\n    top: 83.333333%;\n  }\n  .xl\\:right-5\\/6 {\n    right: 83.333333%;\n  }\n  .xl\\:bottom-5\\/6 {\n    bottom: 83.333333%;\n  }\n  .xl\\:left-5\\/6 {\n    left: 83.333333%;\n  }\n  .xl\\:top-1\\/12 {\n    top: 8.333333%;\n  }\n  .xl\\:right-1\\/12 {\n    right: 8.333333%;\n  }\n  .xl\\:bottom-1\\/12 {\n    bottom: 8.333333%;\n  }\n  .xl\\:left-1\\/12 {\n    left: 8.333333%;\n  }\n  .xl\\:top-2\\/12 {\n    top: 16.666667%;\n  }\n  .xl\\:right-2\\/12 {\n    right: 16.666667%;\n  }\n  .xl\\:bottom-2\\/12 {\n    bottom: 16.666667%;\n  }\n  .xl\\:left-2\\/12 {\n    left: 16.666667%;\n  }\n  .xl\\:top-3\\/12 {\n    top: 25%;\n  }\n  .xl\\:right-3\\/12 {\n    right: 25%;\n  }\n  .xl\\:bottom-3\\/12 {\n    bottom: 25%;\n  }\n  .xl\\:left-3\\/12 {\n    left: 25%;\n  }\n  .xl\\:top-4\\/12 {\n    top: 33.333333%;\n  }\n  .xl\\:right-4\\/12 {\n    right: 33.333333%;\n  }\n  .xl\\:bottom-4\\/12 {\n    bottom: 33.333333%;\n  }\n  .xl\\:left-4\\/12 {\n    left: 33.333333%;\n  }\n  .xl\\:top-5\\/12 {\n    top: 41.666667%;\n  }\n  .xl\\:right-5\\/12 {\n    right: 41.666667%;\n  }\n  .xl\\:bottom-5\\/12 {\n    bottom: 41.666667%;\n  }\n  .xl\\:left-5\\/12 {\n    left: 41.666667%;\n  }\n  .xl\\:top-6\\/12 {\n    top: 50%;\n  }\n  .xl\\:right-6\\/12 {\n    right: 50%;\n  }\n  .xl\\:bottom-6\\/12 {\n    bottom: 50%;\n  }\n  .xl\\:left-6\\/12 {\n    left: 50%;\n  }\n  .xl\\:top-7\\/12 {\n    top: 58.333333%;\n  }\n  .xl\\:right-7\\/12 {\n    right: 58.333333%;\n  }\n  .xl\\:bottom-7\\/12 {\n    bottom: 58.333333%;\n  }\n  .xl\\:left-7\\/12 {\n    left: 58.333333%;\n  }\n  .xl\\:top-8\\/12 {\n    top: 66.666667%;\n  }\n  .xl\\:right-8\\/12 {\n    right: 66.666667%;\n  }\n  .xl\\:bottom-8\\/12 {\n    bottom: 66.666667%;\n  }\n  .xl\\:left-8\\/12 {\n    left: 66.666667%;\n  }\n  .xl\\:top-9\\/12 {\n    top: 75%;\n  }\n  .xl\\:right-9\\/12 {\n    right: 75%;\n  }\n  .xl\\:bottom-9\\/12 {\n    bottom: 75%;\n  }\n  .xl\\:left-9\\/12 {\n    left: 75%;\n  }\n  .xl\\:top-10\\/12 {\n    top: 83.333333%;\n  }\n  .xl\\:right-10\\/12 {\n    right: 83.333333%;\n  }\n  .xl\\:bottom-10\\/12 {\n    bottom: 83.333333%;\n  }\n  .xl\\:left-10\\/12 {\n    left: 83.333333%;\n  }\n  .xl\\:top-11\\/12 {\n    top: 91.666667%;\n  }\n  .xl\\:right-11\\/12 {\n    right: 91.666667%;\n  }\n  .xl\\:bottom-11\\/12 {\n    bottom: 91.666667%;\n  }\n  .xl\\:left-11\\/12 {\n    left: 91.666667%;\n  }\n  .xl\\:top-full {\n    top: 100%;\n  }\n  .xl\\:right-full {\n    right: 100%;\n  }\n  .xl\\:bottom-full {\n    bottom: 100%;\n  }\n  .xl\\:left-full {\n    left: 100%;\n  }\n  .xl\\:resize-none {\n    resize: none;\n  }\n  .xl\\:resize-y {\n    resize: vertical;\n  }\n  .xl\\:resize-x {\n    resize: horizontal;\n  }\n  .xl\\:resize {\n    resize: both;\n  }\n  .xl\\:shadow-xs {\n    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.05);\n  }\n  .xl\\:shadow-sm {\n    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);\n  }\n  .xl\\:shadow {\n    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);\n  }\n  .xl\\:shadow-md {\n    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);\n  }\n  .xl\\:shadow-lg {\n    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);\n  }\n  .xl\\:shadow-xl {\n    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);\n  }\n  .xl\\:shadow-2xl {\n    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);\n  }\n  .xl\\:shadow-inner {\n    box-shadow: inset 0 2px 4px 0 rgba(0, 0, 0, 0.06);\n  }\n  .xl\\:shadow-outline {\n    box-shadow: 0 0 0 3px rgba(118, 169, 250, 0.45);\n  }\n  .xl\\:shadow-none {\n    box-shadow: none;\n  }\n  .xl\\:shadow-solid {\n    box-shadow: 0 0 0 2px currentColor;\n  }\n  .xl\\:shadow-outline-gray {\n    box-shadow: 0 0 0 3px rgba(159, 166, 178, 0.45);\n  }\n  .xl\\:shadow-outline-blue {\n    box-shadow: 0 0 0 3px rgba(164, 202, 254, 0.45);\n  }\n  .xl\\:shadow-outline-teal {\n    box-shadow: 0 0 0 3px rgba(126, 220, 226, 0.45);\n  }\n  .xl\\:shadow-outline-green {\n    box-shadow: 0 0 0 3px rgba(132, 225, 188, 0.45);\n  }\n  .xl\\:shadow-outline-yellow {\n    box-shadow: 0 0 0 3px rgba(250, 202, 21, 0.45);\n  }\n  .xl\\:shadow-outline-orange {\n    box-shadow: 0 0 0 3px rgba(253, 186, 140, 0.45);\n  }\n  .xl\\:shadow-outline-red {\n    box-shadow: 0 0 0 3px rgba(248, 180, 180, 0.45);\n  }\n  .xl\\:shadow-outline-pink {\n    box-shadow: 0 0 0 3px rgba(248, 180, 217, 0.45);\n  }\n  .xl\\:shadow-outline-purple {\n    box-shadow: 0 0 0 3px rgba(202, 191, 253, 0.45);\n  }\n  .xl\\:shadow-outline-indigo {\n    box-shadow: 0 0 0 3px rgba(180, 198, 252, 0.45);\n  }\n  .group:focus .xl\\:group-focus\\:shadow-xs {\n    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.05);\n  }\n  .group:focus .xl\\:group-focus\\:shadow-sm {\n    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);\n  }\n  .group:focus .xl\\:group-focus\\:shadow {\n    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);\n  }\n  .group:focus .xl\\:group-focus\\:shadow-md {\n    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);\n  }\n  .group:focus .xl\\:group-focus\\:shadow-lg {\n    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);\n  }\n  .group:focus .xl\\:group-focus\\:shadow-xl {\n    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);\n  }\n  .group:focus .xl\\:group-focus\\:shadow-2xl {\n    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);\n  }\n  .group:focus .xl\\:group-focus\\:shadow-inner {\n    box-shadow: inset 0 2px 4px 0 rgba(0, 0, 0, 0.06);\n  }\n  .group:focus .xl\\:group-focus\\:shadow-outline {\n    box-shadow: 0 0 0 3px rgba(118, 169, 250, 0.45);\n  }\n  .group:focus .xl\\:group-focus\\:shadow-none {\n    box-shadow: none;\n  }\n  .group:focus .xl\\:group-focus\\:shadow-solid {\n    box-shadow: 0 0 0 2px currentColor;\n  }\n  .group:focus .xl\\:group-focus\\:shadow-outline-gray {\n    box-shadow: 0 0 0 3px rgba(159, 166, 178, 0.45);\n  }\n  .group:focus .xl\\:group-focus\\:shadow-outline-blue {\n    box-shadow: 0 0 0 3px rgba(164, 202, 254, 0.45);\n  }\n  .group:focus .xl\\:group-focus\\:shadow-outline-teal {\n    box-shadow: 0 0 0 3px rgba(126, 220, 226, 0.45);\n  }\n  .group:focus .xl\\:group-focus\\:shadow-outline-green {\n    box-shadow: 0 0 0 3px rgba(132, 225, 188, 0.45);\n  }\n  .group:focus .xl\\:group-focus\\:shadow-outline-yellow {\n    box-shadow: 0 0 0 3px rgba(250, 202, 21, 0.45);\n  }\n  .group:focus .xl\\:group-focus\\:shadow-outline-orange {\n    box-shadow: 0 0 0 3px rgba(253, 186, 140, 0.45);\n  }\n  .group:focus .xl\\:group-focus\\:shadow-outline-red {\n    box-shadow: 0 0 0 3px rgba(248, 180, 180, 0.45);\n  }\n  .group:focus .xl\\:group-focus\\:shadow-outline-pink {\n    box-shadow: 0 0 0 3px rgba(248, 180, 217, 0.45);\n  }\n  .group:focus .xl\\:group-focus\\:shadow-outline-purple {\n    box-shadow: 0 0 0 3px rgba(202, 191, 253, 0.45);\n  }\n  .group:focus .xl\\:group-focus\\:shadow-outline-indigo {\n    box-shadow: 0 0 0 3px rgba(180, 198, 252, 0.45);\n  }\n  .xl\\:hover\\:shadow-xs:hover {\n    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.05);\n  }\n  .xl\\:hover\\:shadow-sm:hover {\n    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);\n  }\n  .xl\\:hover\\:shadow:hover {\n    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);\n  }\n  .xl\\:hover\\:shadow-md:hover {\n    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);\n  }\n  .xl\\:hover\\:shadow-lg:hover {\n    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);\n  }\n  .xl\\:hover\\:shadow-xl:hover {\n    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);\n  }\n  .xl\\:hover\\:shadow-2xl:hover {\n    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);\n  }\n  .xl\\:hover\\:shadow-inner:hover {\n    box-shadow: inset 0 2px 4px 0 rgba(0, 0, 0, 0.06);\n  }\n  .xl\\:hover\\:shadow-outline:hover {\n    box-shadow: 0 0 0 3px rgba(118, 169, 250, 0.45);\n  }\n  .xl\\:hover\\:shadow-none:hover {\n    box-shadow: none;\n  }\n  .xl\\:hover\\:shadow-solid:hover {\n    box-shadow: 0 0 0 2px currentColor;\n  }\n  .xl\\:hover\\:shadow-outline-gray:hover {\n    box-shadow: 0 0 0 3px rgba(159, 166, 178, 0.45);\n  }\n  .xl\\:hover\\:shadow-outline-blue:hover {\n    box-shadow: 0 0 0 3px rgba(164, 202, 254, 0.45);\n  }\n  .xl\\:hover\\:shadow-outline-teal:hover {\n    box-shadow: 0 0 0 3px rgba(126, 220, 226, 0.45);\n  }\n  .xl\\:hover\\:shadow-outline-green:hover {\n    box-shadow: 0 0 0 3px rgba(132, 225, 188, 0.45);\n  }\n  .xl\\:hover\\:shadow-outline-yellow:hover {\n    box-shadow: 0 0 0 3px rgba(250, 202, 21, 0.45);\n  }\n  .xl\\:hover\\:shadow-outline-orange:hover {\n    box-shadow: 0 0 0 3px rgba(253, 186, 140, 0.45);\n  }\n  .xl\\:hover\\:shadow-outline-red:hover {\n    box-shadow: 0 0 0 3px rgba(248, 180, 180, 0.45);\n  }\n  .xl\\:hover\\:shadow-outline-pink:hover {\n    box-shadow: 0 0 0 3px rgba(248, 180, 217, 0.45);\n  }\n  .xl\\:hover\\:shadow-outline-purple:hover {\n    box-shadow: 0 0 0 3px rgba(202, 191, 253, 0.45);\n  }\n  .xl\\:hover\\:shadow-outline-indigo:hover {\n    box-shadow: 0 0 0 3px rgba(180, 198, 252, 0.45);\n  }\n  .xl\\:focus-within\\:shadow-xs:focus-within {\n    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.05);\n  }\n  .xl\\:focus-within\\:shadow-sm:focus-within {\n    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);\n  }\n  .xl\\:focus-within\\:shadow:focus-within {\n    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);\n  }\n  .xl\\:focus-within\\:shadow-md:focus-within {\n    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);\n  }\n  .xl\\:focus-within\\:shadow-lg:focus-within {\n    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);\n  }\n  .xl\\:focus-within\\:shadow-xl:focus-within {\n    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);\n  }\n  .xl\\:focus-within\\:shadow-2xl:focus-within {\n    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);\n  }\n  .xl\\:focus-within\\:shadow-inner:focus-within {\n    box-shadow: inset 0 2px 4px 0 rgba(0, 0, 0, 0.06);\n  }\n  .xl\\:focus-within\\:shadow-outline:focus-within {\n    box-shadow: 0 0 0 3px rgba(118, 169, 250, 0.45);\n  }\n  .xl\\:focus-within\\:shadow-none:focus-within {\n    box-shadow: none;\n  }\n  .xl\\:focus-within\\:shadow-solid:focus-within {\n    box-shadow: 0 0 0 2px currentColor;\n  }\n  .xl\\:focus-within\\:shadow-outline-gray:focus-within {\n    box-shadow: 0 0 0 3px rgba(159, 166, 178, 0.45);\n  }\n  .xl\\:focus-within\\:shadow-outline-blue:focus-within {\n    box-shadow: 0 0 0 3px rgba(164, 202, 254, 0.45);\n  }\n  .xl\\:focus-within\\:shadow-outline-teal:focus-within {\n    box-shadow: 0 0 0 3px rgba(126, 220, 226, 0.45);\n  }\n  .xl\\:focus-within\\:shadow-outline-green:focus-within {\n    box-shadow: 0 0 0 3px rgba(132, 225, 188, 0.45);\n  }\n  .xl\\:focus-within\\:shadow-outline-yellow:focus-within {\n    box-shadow: 0 0 0 3px rgba(250, 202, 21, 0.45);\n  }\n  .xl\\:focus-within\\:shadow-outline-orange:focus-within {\n    box-shadow: 0 0 0 3px rgba(253, 186, 140, 0.45);\n  }\n  .xl\\:focus-within\\:shadow-outline-red:focus-within {\n    box-shadow: 0 0 0 3px rgba(248, 180, 180, 0.45);\n  }\n  .xl\\:focus-within\\:shadow-outline-pink:focus-within {\n    box-shadow: 0 0 0 3px rgba(248, 180, 217, 0.45);\n  }\n  .xl\\:focus-within\\:shadow-outline-purple:focus-within {\n    box-shadow: 0 0 0 3px rgba(202, 191, 253, 0.45);\n  }\n  .xl\\:focus-within\\:shadow-outline-indigo:focus-within {\n    box-shadow: 0 0 0 3px rgba(180, 198, 252, 0.45);\n  }\n  .xl\\:focus\\:shadow-xs:focus {\n    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.05);\n  }\n  .xl\\:focus\\:shadow-sm:focus {\n    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);\n  }\n  .xl\\:focus\\:shadow:focus {\n    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);\n  }\n  .xl\\:focus\\:shadow-md:focus {\n    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);\n  }\n  .xl\\:focus\\:shadow-lg:focus {\n    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);\n  }\n  .xl\\:focus\\:shadow-xl:focus {\n    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);\n  }\n  .xl\\:focus\\:shadow-2xl:focus {\n    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);\n  }\n  .xl\\:focus\\:shadow-inner:focus {\n    box-shadow: inset 0 2px 4px 0 rgba(0, 0, 0, 0.06);\n  }\n  .xl\\:focus\\:shadow-outline:focus {\n    box-shadow: 0 0 0 3px rgba(118, 169, 250, 0.45);\n  }\n  .xl\\:focus\\:shadow-none:focus {\n    box-shadow: none;\n  }\n  .xl\\:focus\\:shadow-solid:focus {\n    box-shadow: 0 0 0 2px currentColor;\n  }\n  .xl\\:focus\\:shadow-outline-gray:focus {\n    box-shadow: 0 0 0 3px rgba(159, 166, 178, 0.45);\n  }\n  .xl\\:focus\\:shadow-outline-blue:focus {\n    box-shadow: 0 0 0 3px rgba(164, 202, 254, 0.45);\n  }\n  .xl\\:focus\\:shadow-outline-teal:focus {\n    box-shadow: 0 0 0 3px rgba(126, 220, 226, 0.45);\n  }\n  .xl\\:focus\\:shadow-outline-green:focus {\n    box-shadow: 0 0 0 3px rgba(132, 225, 188, 0.45);\n  }\n  .xl\\:focus\\:shadow-outline-yellow:focus {\n    box-shadow: 0 0 0 3px rgba(250, 202, 21, 0.45);\n  }\n  .xl\\:focus\\:shadow-outline-orange:focus {\n    box-shadow: 0 0 0 3px rgba(253, 186, 140, 0.45);\n  }\n  .xl\\:focus\\:shadow-outline-red:focus {\n    box-shadow: 0 0 0 3px rgba(248, 180, 180, 0.45);\n  }\n  .xl\\:focus\\:shadow-outline-pink:focus {\n    box-shadow: 0 0 0 3px rgba(248, 180, 217, 0.45);\n  }\n  .xl\\:focus\\:shadow-outline-purple:focus {\n    box-shadow: 0 0 0 3px rgba(202, 191, 253, 0.45);\n  }\n  .xl\\:focus\\:shadow-outline-indigo:focus {\n    box-shadow: 0 0 0 3px rgba(180, 198, 252, 0.45);\n  }\n  .xl\\:fill-current {\n    fill: currentColor;\n  }\n  .xl\\:stroke-current {\n    stroke: currentColor;\n  }\n  .xl\\:stroke-0 {\n    stroke-width: 0;\n  }\n  .xl\\:stroke-1 {\n    stroke-width: 1;\n  }\n  .xl\\:stroke-2 {\n    stroke-width: 2;\n  }\n  .xl\\:table-auto {\n    table-layout: auto;\n  }\n  .xl\\:table-fixed {\n    table-layout: fixed;\n  }\n  .xl\\:text-left {\n    text-align: left;\n  }\n  .xl\\:text-center {\n    text-align: center;\n  }\n  .xl\\:text-right {\n    text-align: right;\n  }\n  .xl\\:text-justify {\n    text-align: justify;\n  }\n  .xl\\:text-current {\n    color: currentColor;\n  }\n  .xl\\:text-transparent {\n    color: transparent;\n  }\n  .xl\\:text-white {\n    --text-opacity: 1;\n    color: #ffffff;\n    color: rgba(255, 255, 255, var(--text-opacity));\n  }\n  .xl\\:text-black {\n    --text-opacity: 1;\n    color: #000000;\n    color: rgba(0, 0, 0, var(--text-opacity));\n  }\n  .xl\\:text-gray-50 {\n    --text-opacity: 1;\n    color: #f9fafb;\n    color: rgba(249, 250, 251, var(--text-opacity));\n  }\n  .xl\\:text-gray-100 {\n    --text-opacity: 1;\n    color: #f4f5f7;\n    color: rgba(244, 245, 247, var(--text-opacity));\n  }\n  .xl\\:text-gray-200 {\n    --text-opacity: 1;\n    color: #e5e7eb;\n    color: rgba(229, 231, 235, var(--text-opacity));\n  }\n  .xl\\:text-gray-300 {\n    --text-opacity: 1;\n    color: #d2d6dc;\n    color: rgba(210, 214, 220, var(--text-opacity));\n  }\n  .xl\\:text-gray-400 {\n    --text-opacity: 1;\n    color: #9fa6b2;\n    color: rgba(159, 166, 178, var(--text-opacity));\n  }\n  .xl\\:text-gray-500 {\n    --text-opacity: 1;\n    color: #6b7280;\n    color: rgba(107, 114, 128, var(--text-opacity));\n  }\n  .xl\\:text-gray-600 {\n    --text-opacity: 1;\n    color: #4b5563;\n    color: rgba(75, 85, 99, var(--text-opacity));\n  }\n  .xl\\:text-gray-700 {\n    --text-opacity: 1;\n    color: #374151;\n    color: rgba(55, 65, 81, var(--text-opacity));\n  }\n  .xl\\:text-gray-800 {\n    --text-opacity: 1;\n    color: #252f3f;\n    color: rgba(37, 47, 63, var(--text-opacity));\n  }\n  .xl\\:text-gray-900 {\n    --text-opacity: 1;\n    color: #161e2e;\n    color: rgba(22, 30, 46, var(--text-opacity));\n  }\n  .xl\\:text-red-50 {\n    --text-opacity: 1;\n    color: #fdf2f2;\n    color: rgba(253, 242, 242, var(--text-opacity));\n  }\n  .xl\\:text-red-100 {\n    --text-opacity: 1;\n    color: #fde8e8;\n    color: rgba(253, 232, 232, var(--text-opacity));\n  }\n  .xl\\:text-red-200 {\n    --text-opacity: 1;\n    color: #fbd5d5;\n    color: rgba(251, 213, 213, var(--text-opacity));\n  }\n  .xl\\:text-red-300 {\n    --text-opacity: 1;\n    color: #f8b4b4;\n    color: rgba(248, 180, 180, var(--text-opacity));\n  }\n  .xl\\:text-red-400 {\n    --text-opacity: 1;\n    color: #f98080;\n    color: rgba(249, 128, 128, var(--text-opacity));\n  }\n  .xl\\:text-red-500 {\n    --text-opacity: 1;\n    color: #f05252;\n    color: rgba(240, 82, 82, var(--text-opacity));\n  }\n  .xl\\:text-red-600 {\n    --text-opacity: 1;\n    color: #e02424;\n    color: rgba(224, 36, 36, var(--text-opacity));\n  }\n  .xl\\:text-red-700 {\n    --text-opacity: 1;\n    color: #c81e1e;\n    color: rgba(200, 30, 30, var(--text-opacity));\n  }\n  .xl\\:text-red-800 {\n    --text-opacity: 1;\n    color: #9b1c1c;\n    color: rgba(155, 28, 28, var(--text-opacity));\n  }\n  .xl\\:text-red-900 {\n    --text-opacity: 1;\n    color: #771d1d;\n    color: rgba(119, 29, 29, var(--text-opacity));\n  }\n  .xl\\:text-orange-50 {\n    --text-opacity: 1;\n    color: #fff8f1;\n    color: rgba(255, 248, 241, var(--text-opacity));\n  }\n  .xl\\:text-orange-100 {\n    --text-opacity: 1;\n    color: #feecdc;\n    color: rgba(254, 236, 220, var(--text-opacity));\n  }\n  .xl\\:text-orange-200 {\n    --text-opacity: 1;\n    color: #fcd9bd;\n    color: rgba(252, 217, 189, var(--text-opacity));\n  }\n  .xl\\:text-orange-300 {\n    --text-opacity: 1;\n    color: #fdba8c;\n    color: rgba(253, 186, 140, var(--text-opacity));\n  }\n  .xl\\:text-orange-400 {\n    --text-opacity: 1;\n    color: #ff8a4c;\n    color: rgba(255, 138, 76, var(--text-opacity));\n  }\n  .xl\\:text-orange-500 {\n    --text-opacity: 1;\n    color: #ff5a1f;\n    color: rgba(255, 90, 31, var(--text-opacity));\n  }\n  .xl\\:text-orange-600 {\n    --text-opacity: 1;\n    color: #d03801;\n    color: rgba(208, 56, 1, var(--text-opacity));\n  }\n  .xl\\:text-orange-700 {\n    --text-opacity: 1;\n    color: #b43403;\n    color: rgba(180, 52, 3, var(--text-opacity));\n  }\n  .xl\\:text-orange-800 {\n    --text-opacity: 1;\n    color: #8a2c0d;\n    color: rgba(138, 44, 13, var(--text-opacity));\n  }\n  .xl\\:text-orange-900 {\n    --text-opacity: 1;\n    color: #73230d;\n    color: rgba(115, 35, 13, var(--text-opacity));\n  }\n  .xl\\:text-yellow-50 {\n    --text-opacity: 1;\n    color: #fdfdea;\n    color: rgba(253, 253, 234, var(--text-opacity));\n  }\n  .xl\\:text-yellow-100 {\n    --text-opacity: 1;\n    color: #fdf6b2;\n    color: rgba(253, 246, 178, var(--text-opacity));\n  }\n  .xl\\:text-yellow-200 {\n    --text-opacity: 1;\n    color: #fce96a;\n    color: rgba(252, 233, 106, var(--text-opacity));\n  }\n  .xl\\:text-yellow-300 {\n    --text-opacity: 1;\n    color: #faca15;\n    color: rgba(250, 202, 21, var(--text-opacity));\n  }\n  .xl\\:text-yellow-400 {\n    --text-opacity: 1;\n    color: #e3a008;\n    color: rgba(227, 160, 8, var(--text-opacity));\n  }\n  .xl\\:text-yellow-500 {\n    --text-opacity: 1;\n    color: #c27803;\n    color: rgba(194, 120, 3, var(--text-opacity));\n  }\n  .xl\\:text-yellow-600 {\n    --text-opacity: 1;\n    color: #9f580a;\n    color: rgba(159, 88, 10, var(--text-opacity));\n  }\n  .xl\\:text-yellow-700 {\n    --text-opacity: 1;\n    color: #8e4b10;\n    color: rgba(142, 75, 16, var(--text-opacity));\n  }\n  .xl\\:text-yellow-800 {\n    --text-opacity: 1;\n    color: #723b13;\n    color: rgba(114, 59, 19, var(--text-opacity));\n  }\n  .xl\\:text-yellow-900 {\n    --text-opacity: 1;\n    color: #633112;\n    color: rgba(99, 49, 18, var(--text-opacity));\n  }\n  .xl\\:text-green-50 {\n    --text-opacity: 1;\n    color: #f3faf7;\n    color: rgba(243, 250, 247, var(--text-opacity));\n  }\n  .xl\\:text-green-100 {\n    --text-opacity: 1;\n    color: #def7ec;\n    color: rgba(222, 247, 236, var(--text-opacity));\n  }\n  .xl\\:text-green-200 {\n    --text-opacity: 1;\n    color: #bcf0da;\n    color: rgba(188, 240, 218, var(--text-opacity));\n  }\n  .xl\\:text-green-300 {\n    --text-opacity: 1;\n    color: #84e1bc;\n    color: rgba(132, 225, 188, var(--text-opacity));\n  }\n  .xl\\:text-green-400 {\n    --text-opacity: 1;\n    color: #31c48d;\n    color: rgba(49, 196, 141, var(--text-opacity));\n  }\n  .xl\\:text-green-500 {\n    --text-opacity: 1;\n    color: #0e9f6e;\n    color: rgba(14, 159, 110, var(--text-opacity));\n  }\n  .xl\\:text-green-600 {\n    --text-opacity: 1;\n    color: #057a55;\n    color: rgba(5, 122, 85, var(--text-opacity));\n  }\n  .xl\\:text-green-700 {\n    --text-opacity: 1;\n    color: #046c4e;\n    color: rgba(4, 108, 78, var(--text-opacity));\n  }\n  .xl\\:text-green-800 {\n    --text-opacity: 1;\n    color: #03543f;\n    color: rgba(3, 84, 63, var(--text-opacity));\n  }\n  .xl\\:text-green-900 {\n    --text-opacity: 1;\n    color: #014737;\n    color: rgba(1, 71, 55, var(--text-opacity));\n  }\n  .xl\\:text-teal-50 {\n    --text-opacity: 1;\n    color: #edfafa;\n    color: rgba(237, 250, 250, var(--text-opacity));\n  }\n  .xl\\:text-teal-100 {\n    --text-opacity: 1;\n    color: #d5f5f6;\n    color: rgba(213, 245, 246, var(--text-opacity));\n  }\n  .xl\\:text-teal-200 {\n    --text-opacity: 1;\n    color: #afecef;\n    color: rgba(175, 236, 239, var(--text-opacity));\n  }\n  .xl\\:text-teal-300 {\n    --text-opacity: 1;\n    color: #7edce2;\n    color: rgba(126, 220, 226, var(--text-opacity));\n  }\n  .xl\\:text-teal-400 {\n    --text-opacity: 1;\n    color: #16bdca;\n    color: rgba(22, 189, 202, var(--text-opacity));\n  }\n  .xl\\:text-teal-500 {\n    --text-opacity: 1;\n    color: #0694a2;\n    color: rgba(6, 148, 162, var(--text-opacity));\n  }\n  .xl\\:text-teal-600 {\n    --text-opacity: 1;\n    color: #047481;\n    color: rgba(4, 116, 129, var(--text-opacity));\n  }\n  .xl\\:text-teal-700 {\n    --text-opacity: 1;\n    color: #036672;\n    color: rgba(3, 102, 114, var(--text-opacity));\n  }\n  .xl\\:text-teal-800 {\n    --text-opacity: 1;\n    color: #05505c;\n    color: rgba(5, 80, 92, var(--text-opacity));\n  }\n  .xl\\:text-teal-900 {\n    --text-opacity: 1;\n    color: #014451;\n    color: rgba(1, 68, 81, var(--text-opacity));\n  }\n  .xl\\:text-blue-50 {\n    --text-opacity: 1;\n    color: #ebf5ff;\n    color: rgba(235, 245, 255, var(--text-opacity));\n  }\n  .xl\\:text-blue-100 {\n    --text-opacity: 1;\n    color: #e1effe;\n    color: rgba(225, 239, 254, var(--text-opacity));\n  }\n  .xl\\:text-blue-200 {\n    --text-opacity: 1;\n    color: #c3ddfd;\n    color: rgba(195, 221, 253, var(--text-opacity));\n  }\n  .xl\\:text-blue-300 {\n    --text-opacity: 1;\n    color: #a4cafe;\n    color: rgba(164, 202, 254, var(--text-opacity));\n  }\n  .xl\\:text-blue-400 {\n    --text-opacity: 1;\n    color: #76a9fa;\n    color: rgba(118, 169, 250, var(--text-opacity));\n  }\n  .xl\\:text-blue-500 {\n    --text-opacity: 1;\n    color: #3f83f8;\n    color: rgba(63, 131, 248, var(--text-opacity));\n  }\n  .xl\\:text-blue-600 {\n    --text-opacity: 1;\n    color: #1c64f2;\n    color: rgba(28, 100, 242, var(--text-opacity));\n  }\n  .xl\\:text-blue-700 {\n    --text-opacity: 1;\n    color: #1a56db;\n    color: rgba(26, 86, 219, var(--text-opacity));\n  }\n  .xl\\:text-blue-800 {\n    --text-opacity: 1;\n    color: #1e429f;\n    color: rgba(30, 66, 159, var(--text-opacity));\n  }\n  .xl\\:text-blue-900 {\n    --text-opacity: 1;\n    color: #233876;\n    color: rgba(35, 56, 118, var(--text-opacity));\n  }\n  .xl\\:text-indigo-50 {\n    --text-opacity: 1;\n    color: #f0f5ff;\n    color: rgba(240, 245, 255, var(--text-opacity));\n  }\n  .xl\\:text-indigo-100 {\n    --text-opacity: 1;\n    color: #e5edff;\n    color: rgba(229, 237, 255, var(--text-opacity));\n  }\n  .xl\\:text-indigo-200 {\n    --text-opacity: 1;\n    color: #cddbfe;\n    color: rgba(205, 219, 254, var(--text-opacity));\n  }\n  .xl\\:text-indigo-300 {\n    --text-opacity: 1;\n    color: #b4c6fc;\n    color: rgba(180, 198, 252, var(--text-opacity));\n  }\n  .xl\\:text-indigo-400 {\n    --text-opacity: 1;\n    color: #8da2fb;\n    color: rgba(141, 162, 251, var(--text-opacity));\n  }\n  .xl\\:text-indigo-500 {\n    --text-opacity: 1;\n    color: #6875f5;\n    color: rgba(104, 117, 245, var(--text-opacity));\n  }\n  .xl\\:text-indigo-600 {\n    --text-opacity: 1;\n    color: #5850ec;\n    color: rgba(88, 80, 236, var(--text-opacity));\n  }\n  .xl\\:text-indigo-700 {\n    --text-opacity: 1;\n    color: #5145cd;\n    color: rgba(81, 69, 205, var(--text-opacity));\n  }\n  .xl\\:text-indigo-800 {\n    --text-opacity: 1;\n    color: #42389d;\n    color: rgba(66, 56, 157, var(--text-opacity));\n  }\n  .xl\\:text-indigo-900 {\n    --text-opacity: 1;\n    color: #362f78;\n    color: rgba(54, 47, 120, var(--text-opacity));\n  }\n  .xl\\:text-purple-50 {\n    --text-opacity: 1;\n    color: #f6f5ff;\n    color: rgba(246, 245, 255, var(--text-opacity));\n  }\n  .xl\\:text-purple-100 {\n    --text-opacity: 1;\n    color: #edebfe;\n    color: rgba(237, 235, 254, var(--text-opacity));\n  }\n  .xl\\:text-purple-200 {\n    --text-opacity: 1;\n    color: #dcd7fe;\n    color: rgba(220, 215, 254, var(--text-opacity));\n  }\n  .xl\\:text-purple-300 {\n    --text-opacity: 1;\n    color: #cabffd;\n    color: rgba(202, 191, 253, var(--text-opacity));\n  }\n  .xl\\:text-purple-400 {\n    --text-opacity: 1;\n    color: #ac94fa;\n    color: rgba(172, 148, 250, var(--text-opacity));\n  }\n  .xl\\:text-purple-500 {\n    --text-opacity: 1;\n    color: #9061f9;\n    color: rgba(144, 97, 249, var(--text-opacity));\n  }\n  .xl\\:text-purple-600 {\n    --text-opacity: 1;\n    color: #7e3af2;\n    color: rgba(126, 58, 242, var(--text-opacity));\n  }\n  .xl\\:text-purple-700 {\n    --text-opacity: 1;\n    color: #6c2bd9;\n    color: rgba(108, 43, 217, var(--text-opacity));\n  }\n  .xl\\:text-purple-800 {\n    --text-opacity: 1;\n    color: #5521b5;\n    color: rgba(85, 33, 181, var(--text-opacity));\n  }\n  .xl\\:text-purple-900 {\n    --text-opacity: 1;\n    color: #4a1d96;\n    color: rgba(74, 29, 150, var(--text-opacity));\n  }\n  .xl\\:text-pink-50 {\n    --text-opacity: 1;\n    color: #fdf2f8;\n    color: rgba(253, 242, 248, var(--text-opacity));\n  }\n  .xl\\:text-pink-100 {\n    --text-opacity: 1;\n    color: #fce8f3;\n    color: rgba(252, 232, 243, var(--text-opacity));\n  }\n  .xl\\:text-pink-200 {\n    --text-opacity: 1;\n    color: #fad1e8;\n    color: rgba(250, 209, 232, var(--text-opacity));\n  }\n  .xl\\:text-pink-300 {\n    --text-opacity: 1;\n    color: #f8b4d9;\n    color: rgba(248, 180, 217, var(--text-opacity));\n  }\n  .xl\\:text-pink-400 {\n    --text-opacity: 1;\n    color: #f17eb8;\n    color: rgba(241, 126, 184, var(--text-opacity));\n  }\n  .xl\\:text-pink-500 {\n    --text-opacity: 1;\n    color: #e74694;\n    color: rgba(231, 70, 148, var(--text-opacity));\n  }\n  .xl\\:text-pink-600 {\n    --text-opacity: 1;\n    color: #d61f69;\n    color: rgba(214, 31, 105, var(--text-opacity));\n  }\n  .xl\\:text-pink-700 {\n    --text-opacity: 1;\n    color: #bf125d;\n    color: rgba(191, 18, 93, var(--text-opacity));\n  }\n  .xl\\:text-pink-800 {\n    --text-opacity: 1;\n    color: #99154b;\n    color: rgba(153, 21, 75, var(--text-opacity));\n  }\n  .xl\\:text-pink-900 {\n    --text-opacity: 1;\n    color: #751a3d;\n    color: rgba(117, 26, 61, var(--text-opacity));\n  }\n  .xl\\:text-cool-gray-50 {\n    --text-opacity: 1;\n    color: #f8fafc;\n    color: rgba(248, 250, 252, var(--text-opacity));\n  }\n  .xl\\:text-cool-gray-100 {\n    --text-opacity: 1;\n    color: #f1f5f9;\n    color: rgba(241, 245, 249, var(--text-opacity));\n  }\n  .xl\\:text-cool-gray-200 {\n    --text-opacity: 1;\n    color: #e2e8f0;\n    color: rgba(226, 232, 240, var(--text-opacity));\n  }\n  .xl\\:text-cool-gray-300 {\n    --text-opacity: 1;\n    color: #cfd8e3;\n    color: rgba(207, 216, 227, var(--text-opacity));\n  }\n  .xl\\:text-cool-gray-400 {\n    --text-opacity: 1;\n    color: #97a6ba;\n    color: rgba(151, 166, 186, var(--text-opacity));\n  }\n  .xl\\:text-cool-gray-500 {\n    --text-opacity: 1;\n    color: #64748b;\n    color: rgba(100, 116, 139, var(--text-opacity));\n  }\n  .xl\\:text-cool-gray-600 {\n    --text-opacity: 1;\n    color: #475569;\n    color: rgba(71, 85, 105, var(--text-opacity));\n  }\n  .xl\\:text-cool-gray-700 {\n    --text-opacity: 1;\n    color: #364152;\n    color: rgba(54, 65, 82, var(--text-opacity));\n  }\n  .xl\\:text-cool-gray-800 {\n    --text-opacity: 1;\n    color: #27303f;\n    color: rgba(39, 48, 63, var(--text-opacity));\n  }\n  .xl\\:text-cool-gray-900 {\n    --text-opacity: 1;\n    color: #1a202e;\n    color: rgba(26, 32, 46, var(--text-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:text-current {\n    color: currentColor;\n  }\n  .group:hover .xl\\:group-hover\\:text-transparent {\n    color: transparent;\n  }\n  .group:hover .xl\\:group-hover\\:text-white {\n    --text-opacity: 1;\n    color: #ffffff;\n    color: rgba(255, 255, 255, var(--text-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:text-black {\n    --text-opacity: 1;\n    color: #000000;\n    color: rgba(0, 0, 0, var(--text-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:text-gray-50 {\n    --text-opacity: 1;\n    color: #f9fafb;\n    color: rgba(249, 250, 251, var(--text-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:text-gray-100 {\n    --text-opacity: 1;\n    color: #f4f5f7;\n    color: rgba(244, 245, 247, var(--text-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:text-gray-200 {\n    --text-opacity: 1;\n    color: #e5e7eb;\n    color: rgba(229, 231, 235, var(--text-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:text-gray-300 {\n    --text-opacity: 1;\n    color: #d2d6dc;\n    color: rgba(210, 214, 220, var(--text-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:text-gray-400 {\n    --text-opacity: 1;\n    color: #9fa6b2;\n    color: rgba(159, 166, 178, var(--text-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:text-gray-500 {\n    --text-opacity: 1;\n    color: #6b7280;\n    color: rgba(107, 114, 128, var(--text-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:text-gray-600 {\n    --text-opacity: 1;\n    color: #4b5563;\n    color: rgba(75, 85, 99, var(--text-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:text-gray-700 {\n    --text-opacity: 1;\n    color: #374151;\n    color: rgba(55, 65, 81, var(--text-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:text-gray-800 {\n    --text-opacity: 1;\n    color: #252f3f;\n    color: rgba(37, 47, 63, var(--text-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:text-gray-900 {\n    --text-opacity: 1;\n    color: #161e2e;\n    color: rgba(22, 30, 46, var(--text-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:text-red-50 {\n    --text-opacity: 1;\n    color: #fdf2f2;\n    color: rgba(253, 242, 242, var(--text-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:text-red-100 {\n    --text-opacity: 1;\n    color: #fde8e8;\n    color: rgba(253, 232, 232, var(--text-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:text-red-200 {\n    --text-opacity: 1;\n    color: #fbd5d5;\n    color: rgba(251, 213, 213, var(--text-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:text-red-300 {\n    --text-opacity: 1;\n    color: #f8b4b4;\n    color: rgba(248, 180, 180, var(--text-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:text-red-400 {\n    --text-opacity: 1;\n    color: #f98080;\n    color: rgba(249, 128, 128, var(--text-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:text-red-500 {\n    --text-opacity: 1;\n    color: #f05252;\n    color: rgba(240, 82, 82, var(--text-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:text-red-600 {\n    --text-opacity: 1;\n    color: #e02424;\n    color: rgba(224, 36, 36, var(--text-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:text-red-700 {\n    --text-opacity: 1;\n    color: #c81e1e;\n    color: rgba(200, 30, 30, var(--text-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:text-red-800 {\n    --text-opacity: 1;\n    color: #9b1c1c;\n    color: rgba(155, 28, 28, var(--text-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:text-red-900 {\n    --text-opacity: 1;\n    color: #771d1d;\n    color: rgba(119, 29, 29, var(--text-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:text-orange-50 {\n    --text-opacity: 1;\n    color: #fff8f1;\n    color: rgba(255, 248, 241, var(--text-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:text-orange-100 {\n    --text-opacity: 1;\n    color: #feecdc;\n    color: rgba(254, 236, 220, var(--text-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:text-orange-200 {\n    --text-opacity: 1;\n    color: #fcd9bd;\n    color: rgba(252, 217, 189, var(--text-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:text-orange-300 {\n    --text-opacity: 1;\n    color: #fdba8c;\n    color: rgba(253, 186, 140, var(--text-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:text-orange-400 {\n    --text-opacity: 1;\n    color: #ff8a4c;\n    color: rgba(255, 138, 76, var(--text-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:text-orange-500 {\n    --text-opacity: 1;\n    color: #ff5a1f;\n    color: rgba(255, 90, 31, var(--text-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:text-orange-600 {\n    --text-opacity: 1;\n    color: #d03801;\n    color: rgba(208, 56, 1, var(--text-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:text-orange-700 {\n    --text-opacity: 1;\n    color: #b43403;\n    color: rgba(180, 52, 3, var(--text-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:text-orange-800 {\n    --text-opacity: 1;\n    color: #8a2c0d;\n    color: rgba(138, 44, 13, var(--text-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:text-orange-900 {\n    --text-opacity: 1;\n    color: #73230d;\n    color: rgba(115, 35, 13, var(--text-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:text-yellow-50 {\n    --text-opacity: 1;\n    color: #fdfdea;\n    color: rgba(253, 253, 234, var(--text-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:text-yellow-100 {\n    --text-opacity: 1;\n    color: #fdf6b2;\n    color: rgba(253, 246, 178, var(--text-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:text-yellow-200 {\n    --text-opacity: 1;\n    color: #fce96a;\n    color: rgba(252, 233, 106, var(--text-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:text-yellow-300 {\n    --text-opacity: 1;\n    color: #faca15;\n    color: rgba(250, 202, 21, var(--text-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:text-yellow-400 {\n    --text-opacity: 1;\n    color: #e3a008;\n    color: rgba(227, 160, 8, var(--text-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:text-yellow-500 {\n    --text-opacity: 1;\n    color: #c27803;\n    color: rgba(194, 120, 3, var(--text-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:text-yellow-600 {\n    --text-opacity: 1;\n    color: #9f580a;\n    color: rgba(159, 88, 10, var(--text-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:text-yellow-700 {\n    --text-opacity: 1;\n    color: #8e4b10;\n    color: rgba(142, 75, 16, var(--text-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:text-yellow-800 {\n    --text-opacity: 1;\n    color: #723b13;\n    color: rgba(114, 59, 19, var(--text-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:text-yellow-900 {\n    --text-opacity: 1;\n    color: #633112;\n    color: rgba(99, 49, 18, var(--text-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:text-green-50 {\n    --text-opacity: 1;\n    color: #f3faf7;\n    color: rgba(243, 250, 247, var(--text-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:text-green-100 {\n    --text-opacity: 1;\n    color: #def7ec;\n    color: rgba(222, 247, 236, var(--text-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:text-green-200 {\n    --text-opacity: 1;\n    color: #bcf0da;\n    color: rgba(188, 240, 218, var(--text-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:text-green-300 {\n    --text-opacity: 1;\n    color: #84e1bc;\n    color: rgba(132, 225, 188, var(--text-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:text-green-400 {\n    --text-opacity: 1;\n    color: #31c48d;\n    color: rgba(49, 196, 141, var(--text-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:text-green-500 {\n    --text-opacity: 1;\n    color: #0e9f6e;\n    color: rgba(14, 159, 110, var(--text-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:text-green-600 {\n    --text-opacity: 1;\n    color: #057a55;\n    color: rgba(5, 122, 85, var(--text-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:text-green-700 {\n    --text-opacity: 1;\n    color: #046c4e;\n    color: rgba(4, 108, 78, var(--text-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:text-green-800 {\n    --text-opacity: 1;\n    color: #03543f;\n    color: rgba(3, 84, 63, var(--text-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:text-green-900 {\n    --text-opacity: 1;\n    color: #014737;\n    color: rgba(1, 71, 55, var(--text-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:text-teal-50 {\n    --text-opacity: 1;\n    color: #edfafa;\n    color: rgba(237, 250, 250, var(--text-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:text-teal-100 {\n    --text-opacity: 1;\n    color: #d5f5f6;\n    color: rgba(213, 245, 246, var(--text-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:text-teal-200 {\n    --text-opacity: 1;\n    color: #afecef;\n    color: rgba(175, 236, 239, var(--text-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:text-teal-300 {\n    --text-opacity: 1;\n    color: #7edce2;\n    color: rgba(126, 220, 226, var(--text-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:text-teal-400 {\n    --text-opacity: 1;\n    color: #16bdca;\n    color: rgba(22, 189, 202, var(--text-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:text-teal-500 {\n    --text-opacity: 1;\n    color: #0694a2;\n    color: rgba(6, 148, 162, var(--text-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:text-teal-600 {\n    --text-opacity: 1;\n    color: #047481;\n    color: rgba(4, 116, 129, var(--text-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:text-teal-700 {\n    --text-opacity: 1;\n    color: #036672;\n    color: rgba(3, 102, 114, var(--text-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:text-teal-800 {\n    --text-opacity: 1;\n    color: #05505c;\n    color: rgba(5, 80, 92, var(--text-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:text-teal-900 {\n    --text-opacity: 1;\n    color: #014451;\n    color: rgba(1, 68, 81, var(--text-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:text-blue-50 {\n    --text-opacity: 1;\n    color: #ebf5ff;\n    color: rgba(235, 245, 255, var(--text-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:text-blue-100 {\n    --text-opacity: 1;\n    color: #e1effe;\n    color: rgba(225, 239, 254, var(--text-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:text-blue-200 {\n    --text-opacity: 1;\n    color: #c3ddfd;\n    color: rgba(195, 221, 253, var(--text-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:text-blue-300 {\n    --text-opacity: 1;\n    color: #a4cafe;\n    color: rgba(164, 202, 254, var(--text-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:text-blue-400 {\n    --text-opacity: 1;\n    color: #76a9fa;\n    color: rgba(118, 169, 250, var(--text-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:text-blue-500 {\n    --text-opacity: 1;\n    color: #3f83f8;\n    color: rgba(63, 131, 248, var(--text-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:text-blue-600 {\n    --text-opacity: 1;\n    color: #1c64f2;\n    color: rgba(28, 100, 242, var(--text-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:text-blue-700 {\n    --text-opacity: 1;\n    color: #1a56db;\n    color: rgba(26, 86, 219, var(--text-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:text-blue-800 {\n    --text-opacity: 1;\n    color: #1e429f;\n    color: rgba(30, 66, 159, var(--text-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:text-blue-900 {\n    --text-opacity: 1;\n    color: #233876;\n    color: rgba(35, 56, 118, var(--text-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:text-indigo-50 {\n    --text-opacity: 1;\n    color: #f0f5ff;\n    color: rgba(240, 245, 255, var(--text-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:text-indigo-100 {\n    --text-opacity: 1;\n    color: #e5edff;\n    color: rgba(229, 237, 255, var(--text-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:text-indigo-200 {\n    --text-opacity: 1;\n    color: #cddbfe;\n    color: rgba(205, 219, 254, var(--text-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:text-indigo-300 {\n    --text-opacity: 1;\n    color: #b4c6fc;\n    color: rgba(180, 198, 252, var(--text-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:text-indigo-400 {\n    --text-opacity: 1;\n    color: #8da2fb;\n    color: rgba(141, 162, 251, var(--text-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:text-indigo-500 {\n    --text-opacity: 1;\n    color: #6875f5;\n    color: rgba(104, 117, 245, var(--text-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:text-indigo-600 {\n    --text-opacity: 1;\n    color: #5850ec;\n    color: rgba(88, 80, 236, var(--text-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:text-indigo-700 {\n    --text-opacity: 1;\n    color: #5145cd;\n    color: rgba(81, 69, 205, var(--text-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:text-indigo-800 {\n    --text-opacity: 1;\n    color: #42389d;\n    color: rgba(66, 56, 157, var(--text-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:text-indigo-900 {\n    --text-opacity: 1;\n    color: #362f78;\n    color: rgba(54, 47, 120, var(--text-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:text-purple-50 {\n    --text-opacity: 1;\n    color: #f6f5ff;\n    color: rgba(246, 245, 255, var(--text-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:text-purple-100 {\n    --text-opacity: 1;\n    color: #edebfe;\n    color: rgba(237, 235, 254, var(--text-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:text-purple-200 {\n    --text-opacity: 1;\n    color: #dcd7fe;\n    color: rgba(220, 215, 254, var(--text-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:text-purple-300 {\n    --text-opacity: 1;\n    color: #cabffd;\n    color: rgba(202, 191, 253, var(--text-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:text-purple-400 {\n    --text-opacity: 1;\n    color: #ac94fa;\n    color: rgba(172, 148, 250, var(--text-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:text-purple-500 {\n    --text-opacity: 1;\n    color: #9061f9;\n    color: rgba(144, 97, 249, var(--text-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:text-purple-600 {\n    --text-opacity: 1;\n    color: #7e3af2;\n    color: rgba(126, 58, 242, var(--text-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:text-purple-700 {\n    --text-opacity: 1;\n    color: #6c2bd9;\n    color: rgba(108, 43, 217, var(--text-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:text-purple-800 {\n    --text-opacity: 1;\n    color: #5521b5;\n    color: rgba(85, 33, 181, var(--text-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:text-purple-900 {\n    --text-opacity: 1;\n    color: #4a1d96;\n    color: rgba(74, 29, 150, var(--text-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:text-pink-50 {\n    --text-opacity: 1;\n    color: #fdf2f8;\n    color: rgba(253, 242, 248, var(--text-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:text-pink-100 {\n    --text-opacity: 1;\n    color: #fce8f3;\n    color: rgba(252, 232, 243, var(--text-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:text-pink-200 {\n    --text-opacity: 1;\n    color: #fad1e8;\n    color: rgba(250, 209, 232, var(--text-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:text-pink-300 {\n    --text-opacity: 1;\n    color: #f8b4d9;\n    color: rgba(248, 180, 217, var(--text-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:text-pink-400 {\n    --text-opacity: 1;\n    color: #f17eb8;\n    color: rgba(241, 126, 184, var(--text-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:text-pink-500 {\n    --text-opacity: 1;\n    color: #e74694;\n    color: rgba(231, 70, 148, var(--text-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:text-pink-600 {\n    --text-opacity: 1;\n    color: #d61f69;\n    color: rgba(214, 31, 105, var(--text-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:text-pink-700 {\n    --text-opacity: 1;\n    color: #bf125d;\n    color: rgba(191, 18, 93, var(--text-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:text-pink-800 {\n    --text-opacity: 1;\n    color: #99154b;\n    color: rgba(153, 21, 75, var(--text-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:text-pink-900 {\n    --text-opacity: 1;\n    color: #751a3d;\n    color: rgba(117, 26, 61, var(--text-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:text-cool-gray-50 {\n    --text-opacity: 1;\n    color: #f8fafc;\n    color: rgba(248, 250, 252, var(--text-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:text-cool-gray-100 {\n    --text-opacity: 1;\n    color: #f1f5f9;\n    color: rgba(241, 245, 249, var(--text-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:text-cool-gray-200 {\n    --text-opacity: 1;\n    color: #e2e8f0;\n    color: rgba(226, 232, 240, var(--text-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:text-cool-gray-300 {\n    --text-opacity: 1;\n    color: #cfd8e3;\n    color: rgba(207, 216, 227, var(--text-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:text-cool-gray-400 {\n    --text-opacity: 1;\n    color: #97a6ba;\n    color: rgba(151, 166, 186, var(--text-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:text-cool-gray-500 {\n    --text-opacity: 1;\n    color: #64748b;\n    color: rgba(100, 116, 139, var(--text-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:text-cool-gray-600 {\n    --text-opacity: 1;\n    color: #475569;\n    color: rgba(71, 85, 105, var(--text-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:text-cool-gray-700 {\n    --text-opacity: 1;\n    color: #364152;\n    color: rgba(54, 65, 82, var(--text-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:text-cool-gray-800 {\n    --text-opacity: 1;\n    color: #27303f;\n    color: rgba(39, 48, 63, var(--text-opacity));\n  }\n  .group:hover .xl\\:group-hover\\:text-cool-gray-900 {\n    --text-opacity: 1;\n    color: #1a202e;\n    color: rgba(26, 32, 46, var(--text-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:text-current {\n    color: currentColor;\n  }\n  .group:focus .xl\\:group-focus\\:text-transparent {\n    color: transparent;\n  }\n  .group:focus .xl\\:group-focus\\:text-white {\n    --text-opacity: 1;\n    color: #ffffff;\n    color: rgba(255, 255, 255, var(--text-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:text-black {\n    --text-opacity: 1;\n    color: #000000;\n    color: rgba(0, 0, 0, var(--text-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:text-gray-50 {\n    --text-opacity: 1;\n    color: #f9fafb;\n    color: rgba(249, 250, 251, var(--text-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:text-gray-100 {\n    --text-opacity: 1;\n    color: #f4f5f7;\n    color: rgba(244, 245, 247, var(--text-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:text-gray-200 {\n    --text-opacity: 1;\n    color: #e5e7eb;\n    color: rgba(229, 231, 235, var(--text-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:text-gray-300 {\n    --text-opacity: 1;\n    color: #d2d6dc;\n    color: rgba(210, 214, 220, var(--text-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:text-gray-400 {\n    --text-opacity: 1;\n    color: #9fa6b2;\n    color: rgba(159, 166, 178, var(--text-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:text-gray-500 {\n    --text-opacity: 1;\n    color: #6b7280;\n    color: rgba(107, 114, 128, var(--text-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:text-gray-600 {\n    --text-opacity: 1;\n    color: #4b5563;\n    color: rgba(75, 85, 99, var(--text-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:text-gray-700 {\n    --text-opacity: 1;\n    color: #374151;\n    color: rgba(55, 65, 81, var(--text-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:text-gray-800 {\n    --text-opacity: 1;\n    color: #252f3f;\n    color: rgba(37, 47, 63, var(--text-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:text-gray-900 {\n    --text-opacity: 1;\n    color: #161e2e;\n    color: rgba(22, 30, 46, var(--text-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:text-red-50 {\n    --text-opacity: 1;\n    color: #fdf2f2;\n    color: rgba(253, 242, 242, var(--text-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:text-red-100 {\n    --text-opacity: 1;\n    color: #fde8e8;\n    color: rgba(253, 232, 232, var(--text-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:text-red-200 {\n    --text-opacity: 1;\n    color: #fbd5d5;\n    color: rgba(251, 213, 213, var(--text-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:text-red-300 {\n    --text-opacity: 1;\n    color: #f8b4b4;\n    color: rgba(248, 180, 180, var(--text-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:text-red-400 {\n    --text-opacity: 1;\n    color: #f98080;\n    color: rgba(249, 128, 128, var(--text-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:text-red-500 {\n    --text-opacity: 1;\n    color: #f05252;\n    color: rgba(240, 82, 82, var(--text-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:text-red-600 {\n    --text-opacity: 1;\n    color: #e02424;\n    color: rgba(224, 36, 36, var(--text-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:text-red-700 {\n    --text-opacity: 1;\n    color: #c81e1e;\n    color: rgba(200, 30, 30, var(--text-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:text-red-800 {\n    --text-opacity: 1;\n    color: #9b1c1c;\n    color: rgba(155, 28, 28, var(--text-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:text-red-900 {\n    --text-opacity: 1;\n    color: #771d1d;\n    color: rgba(119, 29, 29, var(--text-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:text-orange-50 {\n    --text-opacity: 1;\n    color: #fff8f1;\n    color: rgba(255, 248, 241, var(--text-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:text-orange-100 {\n    --text-opacity: 1;\n    color: #feecdc;\n    color: rgba(254, 236, 220, var(--text-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:text-orange-200 {\n    --text-opacity: 1;\n    color: #fcd9bd;\n    color: rgba(252, 217, 189, var(--text-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:text-orange-300 {\n    --text-opacity: 1;\n    color: #fdba8c;\n    color: rgba(253, 186, 140, var(--text-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:text-orange-400 {\n    --text-opacity: 1;\n    color: #ff8a4c;\n    color: rgba(255, 138, 76, var(--text-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:text-orange-500 {\n    --text-opacity: 1;\n    color: #ff5a1f;\n    color: rgba(255, 90, 31, var(--text-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:text-orange-600 {\n    --text-opacity: 1;\n    color: #d03801;\n    color: rgba(208, 56, 1, var(--text-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:text-orange-700 {\n    --text-opacity: 1;\n    color: #b43403;\n    color: rgba(180, 52, 3, var(--text-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:text-orange-800 {\n    --text-opacity: 1;\n    color: #8a2c0d;\n    color: rgba(138, 44, 13, var(--text-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:text-orange-900 {\n    --text-opacity: 1;\n    color: #73230d;\n    color: rgba(115, 35, 13, var(--text-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:text-yellow-50 {\n    --text-opacity: 1;\n    color: #fdfdea;\n    color: rgba(253, 253, 234, var(--text-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:text-yellow-100 {\n    --text-opacity: 1;\n    color: #fdf6b2;\n    color: rgba(253, 246, 178, var(--text-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:text-yellow-200 {\n    --text-opacity: 1;\n    color: #fce96a;\n    color: rgba(252, 233, 106, var(--text-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:text-yellow-300 {\n    --text-opacity: 1;\n    color: #faca15;\n    color: rgba(250, 202, 21, var(--text-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:text-yellow-400 {\n    --text-opacity: 1;\n    color: #e3a008;\n    color: rgba(227, 160, 8, var(--text-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:text-yellow-500 {\n    --text-opacity: 1;\n    color: #c27803;\n    color: rgba(194, 120, 3, var(--text-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:text-yellow-600 {\n    --text-opacity: 1;\n    color: #9f580a;\n    color: rgba(159, 88, 10, var(--text-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:text-yellow-700 {\n    --text-opacity: 1;\n    color: #8e4b10;\n    color: rgba(142, 75, 16, var(--text-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:text-yellow-800 {\n    --text-opacity: 1;\n    color: #723b13;\n    color: rgba(114, 59, 19, var(--text-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:text-yellow-900 {\n    --text-opacity: 1;\n    color: #633112;\n    color: rgba(99, 49, 18, var(--text-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:text-green-50 {\n    --text-opacity: 1;\n    color: #f3faf7;\n    color: rgba(243, 250, 247, var(--text-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:text-green-100 {\n    --text-opacity: 1;\n    color: #def7ec;\n    color: rgba(222, 247, 236, var(--text-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:text-green-200 {\n    --text-opacity: 1;\n    color: #bcf0da;\n    color: rgba(188, 240, 218, var(--text-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:text-green-300 {\n    --text-opacity: 1;\n    color: #84e1bc;\n    color: rgba(132, 225, 188, var(--text-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:text-green-400 {\n    --text-opacity: 1;\n    color: #31c48d;\n    color: rgba(49, 196, 141, var(--text-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:text-green-500 {\n    --text-opacity: 1;\n    color: #0e9f6e;\n    color: rgba(14, 159, 110, var(--text-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:text-green-600 {\n    --text-opacity: 1;\n    color: #057a55;\n    color: rgba(5, 122, 85, var(--text-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:text-green-700 {\n    --text-opacity: 1;\n    color: #046c4e;\n    color: rgba(4, 108, 78, var(--text-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:text-green-800 {\n    --text-opacity: 1;\n    color: #03543f;\n    color: rgba(3, 84, 63, var(--text-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:text-green-900 {\n    --text-opacity: 1;\n    color: #014737;\n    color: rgba(1, 71, 55, var(--text-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:text-teal-50 {\n    --text-opacity: 1;\n    color: #edfafa;\n    color: rgba(237, 250, 250, var(--text-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:text-teal-100 {\n    --text-opacity: 1;\n    color: #d5f5f6;\n    color: rgba(213, 245, 246, var(--text-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:text-teal-200 {\n    --text-opacity: 1;\n    color: #afecef;\n    color: rgba(175, 236, 239, var(--text-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:text-teal-300 {\n    --text-opacity: 1;\n    color: #7edce2;\n    color: rgba(126, 220, 226, var(--text-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:text-teal-400 {\n    --text-opacity: 1;\n    color: #16bdca;\n    color: rgba(22, 189, 202, var(--text-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:text-teal-500 {\n    --text-opacity: 1;\n    color: #0694a2;\n    color: rgba(6, 148, 162, var(--text-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:text-teal-600 {\n    --text-opacity: 1;\n    color: #047481;\n    color: rgba(4, 116, 129, var(--text-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:text-teal-700 {\n    --text-opacity: 1;\n    color: #036672;\n    color: rgba(3, 102, 114, var(--text-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:text-teal-800 {\n    --text-opacity: 1;\n    color: #05505c;\n    color: rgba(5, 80, 92, var(--text-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:text-teal-900 {\n    --text-opacity: 1;\n    color: #014451;\n    color: rgba(1, 68, 81, var(--text-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:text-blue-50 {\n    --text-opacity: 1;\n    color: #ebf5ff;\n    color: rgba(235, 245, 255, var(--text-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:text-blue-100 {\n    --text-opacity: 1;\n    color: #e1effe;\n    color: rgba(225, 239, 254, var(--text-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:text-blue-200 {\n    --text-opacity: 1;\n    color: #c3ddfd;\n    color: rgba(195, 221, 253, var(--text-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:text-blue-300 {\n    --text-opacity: 1;\n    color: #a4cafe;\n    color: rgba(164, 202, 254, var(--text-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:text-blue-400 {\n    --text-opacity: 1;\n    color: #76a9fa;\n    color: rgba(118, 169, 250, var(--text-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:text-blue-500 {\n    --text-opacity: 1;\n    color: #3f83f8;\n    color: rgba(63, 131, 248, var(--text-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:text-blue-600 {\n    --text-opacity: 1;\n    color: #1c64f2;\n    color: rgba(28, 100, 242, var(--text-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:text-blue-700 {\n    --text-opacity: 1;\n    color: #1a56db;\n    color: rgba(26, 86, 219, var(--text-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:text-blue-800 {\n    --text-opacity: 1;\n    color: #1e429f;\n    color: rgba(30, 66, 159, var(--text-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:text-blue-900 {\n    --text-opacity: 1;\n    color: #233876;\n    color: rgba(35, 56, 118, var(--text-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:text-indigo-50 {\n    --text-opacity: 1;\n    color: #f0f5ff;\n    color: rgba(240, 245, 255, var(--text-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:text-indigo-100 {\n    --text-opacity: 1;\n    color: #e5edff;\n    color: rgba(229, 237, 255, var(--text-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:text-indigo-200 {\n    --text-opacity: 1;\n    color: #cddbfe;\n    color: rgba(205, 219, 254, var(--text-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:text-indigo-300 {\n    --text-opacity: 1;\n    color: #b4c6fc;\n    color: rgba(180, 198, 252, var(--text-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:text-indigo-400 {\n    --text-opacity: 1;\n    color: #8da2fb;\n    color: rgba(141, 162, 251, var(--text-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:text-indigo-500 {\n    --text-opacity: 1;\n    color: #6875f5;\n    color: rgba(104, 117, 245, var(--text-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:text-indigo-600 {\n    --text-opacity: 1;\n    color: #5850ec;\n    color: rgba(88, 80, 236, var(--text-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:text-indigo-700 {\n    --text-opacity: 1;\n    color: #5145cd;\n    color: rgba(81, 69, 205, var(--text-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:text-indigo-800 {\n    --text-opacity: 1;\n    color: #42389d;\n    color: rgba(66, 56, 157, var(--text-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:text-indigo-900 {\n    --text-opacity: 1;\n    color: #362f78;\n    color: rgba(54, 47, 120, var(--text-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:text-purple-50 {\n    --text-opacity: 1;\n    color: #f6f5ff;\n    color: rgba(246, 245, 255, var(--text-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:text-purple-100 {\n    --text-opacity: 1;\n    color: #edebfe;\n    color: rgba(237, 235, 254, var(--text-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:text-purple-200 {\n    --text-opacity: 1;\n    color: #dcd7fe;\n    color: rgba(220, 215, 254, var(--text-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:text-purple-300 {\n    --text-opacity: 1;\n    color: #cabffd;\n    color: rgba(202, 191, 253, var(--text-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:text-purple-400 {\n    --text-opacity: 1;\n    color: #ac94fa;\n    color: rgba(172, 148, 250, var(--text-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:text-purple-500 {\n    --text-opacity: 1;\n    color: #9061f9;\n    color: rgba(144, 97, 249, var(--text-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:text-purple-600 {\n    --text-opacity: 1;\n    color: #7e3af2;\n    color: rgba(126, 58, 242, var(--text-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:text-purple-700 {\n    --text-opacity: 1;\n    color: #6c2bd9;\n    color: rgba(108, 43, 217, var(--text-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:text-purple-800 {\n    --text-opacity: 1;\n    color: #5521b5;\n    color: rgba(85, 33, 181, var(--text-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:text-purple-900 {\n    --text-opacity: 1;\n    color: #4a1d96;\n    color: rgba(74, 29, 150, var(--text-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:text-pink-50 {\n    --text-opacity: 1;\n    color: #fdf2f8;\n    color: rgba(253, 242, 248, var(--text-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:text-pink-100 {\n    --text-opacity: 1;\n    color: #fce8f3;\n    color: rgba(252, 232, 243, var(--text-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:text-pink-200 {\n    --text-opacity: 1;\n    color: #fad1e8;\n    color: rgba(250, 209, 232, var(--text-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:text-pink-300 {\n    --text-opacity: 1;\n    color: #f8b4d9;\n    color: rgba(248, 180, 217, var(--text-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:text-pink-400 {\n    --text-opacity: 1;\n    color: #f17eb8;\n    color: rgba(241, 126, 184, var(--text-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:text-pink-500 {\n    --text-opacity: 1;\n    color: #e74694;\n    color: rgba(231, 70, 148, var(--text-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:text-pink-600 {\n    --text-opacity: 1;\n    color: #d61f69;\n    color: rgba(214, 31, 105, var(--text-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:text-pink-700 {\n    --text-opacity: 1;\n    color: #bf125d;\n    color: rgba(191, 18, 93, var(--text-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:text-pink-800 {\n    --text-opacity: 1;\n    color: #99154b;\n    color: rgba(153, 21, 75, var(--text-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:text-pink-900 {\n    --text-opacity: 1;\n    color: #751a3d;\n    color: rgba(117, 26, 61, var(--text-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:text-cool-gray-50 {\n    --text-opacity: 1;\n    color: #f8fafc;\n    color: rgba(248, 250, 252, var(--text-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:text-cool-gray-100 {\n    --text-opacity: 1;\n    color: #f1f5f9;\n    color: rgba(241, 245, 249, var(--text-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:text-cool-gray-200 {\n    --text-opacity: 1;\n    color: #e2e8f0;\n    color: rgba(226, 232, 240, var(--text-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:text-cool-gray-300 {\n    --text-opacity: 1;\n    color: #cfd8e3;\n    color: rgba(207, 216, 227, var(--text-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:text-cool-gray-400 {\n    --text-opacity: 1;\n    color: #97a6ba;\n    color: rgba(151, 166, 186, var(--text-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:text-cool-gray-500 {\n    --text-opacity: 1;\n    color: #64748b;\n    color: rgba(100, 116, 139, var(--text-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:text-cool-gray-600 {\n    --text-opacity: 1;\n    color: #475569;\n    color: rgba(71, 85, 105, var(--text-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:text-cool-gray-700 {\n    --text-opacity: 1;\n    color: #364152;\n    color: rgba(54, 65, 82, var(--text-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:text-cool-gray-800 {\n    --text-opacity: 1;\n    color: #27303f;\n    color: rgba(39, 48, 63, var(--text-opacity));\n  }\n  .group:focus .xl\\:group-focus\\:text-cool-gray-900 {\n    --text-opacity: 1;\n    color: #1a202e;\n    color: rgba(26, 32, 46, var(--text-opacity));\n  }\n  .xl\\:hover\\:text-current:hover {\n    color: currentColor;\n  }\n  .xl\\:hover\\:text-transparent:hover {\n    color: transparent;\n  }\n  .xl\\:hover\\:text-white:hover {\n    --text-opacity: 1;\n    color: #ffffff;\n    color: rgba(255, 255, 255, var(--text-opacity));\n  }\n  .xl\\:hover\\:text-black:hover {\n    --text-opacity: 1;\n    color: #000000;\n    color: rgba(0, 0, 0, var(--text-opacity));\n  }\n  .xl\\:hover\\:text-gray-50:hover {\n    --text-opacity: 1;\n    color: #f9fafb;\n    color: rgba(249, 250, 251, var(--text-opacity));\n  }\n  .xl\\:hover\\:text-gray-100:hover {\n    --text-opacity: 1;\n    color: #f4f5f7;\n    color: rgba(244, 245, 247, var(--text-opacity));\n  }\n  .xl\\:hover\\:text-gray-200:hover {\n    --text-opacity: 1;\n    color: #e5e7eb;\n    color: rgba(229, 231, 235, var(--text-opacity));\n  }\n  .xl\\:hover\\:text-gray-300:hover {\n    --text-opacity: 1;\n    color: #d2d6dc;\n    color: rgba(210, 214, 220, var(--text-opacity));\n  }\n  .xl\\:hover\\:text-gray-400:hover {\n    --text-opacity: 1;\n    color: #9fa6b2;\n    color: rgba(159, 166, 178, var(--text-opacity));\n  }\n  .xl\\:hover\\:text-gray-500:hover {\n    --text-opacity: 1;\n    color: #6b7280;\n    color: rgba(107, 114, 128, var(--text-opacity));\n  }\n  .xl\\:hover\\:text-gray-600:hover {\n    --text-opacity: 1;\n    color: #4b5563;\n    color: rgba(75, 85, 99, var(--text-opacity));\n  }\n  .xl\\:hover\\:text-gray-700:hover {\n    --text-opacity: 1;\n    color: #374151;\n    color: rgba(55, 65, 81, var(--text-opacity));\n  }\n  .xl\\:hover\\:text-gray-800:hover {\n    --text-opacity: 1;\n    color: #252f3f;\n    color: rgba(37, 47, 63, var(--text-opacity));\n  }\n  .xl\\:hover\\:text-gray-900:hover {\n    --text-opacity: 1;\n    color: #161e2e;\n    color: rgba(22, 30, 46, var(--text-opacity));\n  }\n  .xl\\:hover\\:text-red-50:hover {\n    --text-opacity: 1;\n    color: #fdf2f2;\n    color: rgba(253, 242, 242, var(--text-opacity));\n  }\n  .xl\\:hover\\:text-red-100:hover {\n    --text-opacity: 1;\n    color: #fde8e8;\n    color: rgba(253, 232, 232, var(--text-opacity));\n  }\n  .xl\\:hover\\:text-red-200:hover {\n    --text-opacity: 1;\n    color: #fbd5d5;\n    color: rgba(251, 213, 213, var(--text-opacity));\n  }\n  .xl\\:hover\\:text-red-300:hover {\n    --text-opacity: 1;\n    color: #f8b4b4;\n    color: rgba(248, 180, 180, var(--text-opacity));\n  }\n  .xl\\:hover\\:text-red-400:hover {\n    --text-opacity: 1;\n    color: #f98080;\n    color: rgba(249, 128, 128, var(--text-opacity));\n  }\n  .xl\\:hover\\:text-red-500:hover {\n    --text-opacity: 1;\n    color: #f05252;\n    color: rgba(240, 82, 82, var(--text-opacity));\n  }\n  .xl\\:hover\\:text-red-600:hover {\n    --text-opacity: 1;\n    color: #e02424;\n    color: rgba(224, 36, 36, var(--text-opacity));\n  }\n  .xl\\:hover\\:text-red-700:hover {\n    --text-opacity: 1;\n    color: #c81e1e;\n    color: rgba(200, 30, 30, var(--text-opacity));\n  }\n  .xl\\:hover\\:text-red-800:hover {\n    --text-opacity: 1;\n    color: #9b1c1c;\n    color: rgba(155, 28, 28, var(--text-opacity));\n  }\n  .xl\\:hover\\:text-red-900:hover {\n    --text-opacity: 1;\n    color: #771d1d;\n    color: rgba(119, 29, 29, var(--text-opacity));\n  }\n  .xl\\:hover\\:text-orange-50:hover {\n    --text-opacity: 1;\n    color: #fff8f1;\n    color: rgba(255, 248, 241, var(--text-opacity));\n  }\n  .xl\\:hover\\:text-orange-100:hover {\n    --text-opacity: 1;\n    color: #feecdc;\n    color: rgba(254, 236, 220, var(--text-opacity));\n  }\n  .xl\\:hover\\:text-orange-200:hover {\n    --text-opacity: 1;\n    color: #fcd9bd;\n    color: rgba(252, 217, 189, var(--text-opacity));\n  }\n  .xl\\:hover\\:text-orange-300:hover {\n    --text-opacity: 1;\n    color: #fdba8c;\n    color: rgba(253, 186, 140, var(--text-opacity));\n  }\n  .xl\\:hover\\:text-orange-400:hover {\n    --text-opacity: 1;\n    color: #ff8a4c;\n    color: rgba(255, 138, 76, var(--text-opacity));\n  }\n  .xl\\:hover\\:text-orange-500:hover {\n    --text-opacity: 1;\n    color: #ff5a1f;\n    color: rgba(255, 90, 31, var(--text-opacity));\n  }\n  .xl\\:hover\\:text-orange-600:hover {\n    --text-opacity: 1;\n    color: #d03801;\n    color: rgba(208, 56, 1, var(--text-opacity));\n  }\n  .xl\\:hover\\:text-orange-700:hover {\n    --text-opacity: 1;\n    color: #b43403;\n    color: rgba(180, 52, 3, var(--text-opacity));\n  }\n  .xl\\:hover\\:text-orange-800:hover {\n    --text-opacity: 1;\n    color: #8a2c0d;\n    color: rgba(138, 44, 13, var(--text-opacity));\n  }\n  .xl\\:hover\\:text-orange-900:hover {\n    --text-opacity: 1;\n    color: #73230d;\n    color: rgba(115, 35, 13, var(--text-opacity));\n  }\n  .xl\\:hover\\:text-yellow-50:hover {\n    --text-opacity: 1;\n    color: #fdfdea;\n    color: rgba(253, 253, 234, var(--text-opacity));\n  }\n  .xl\\:hover\\:text-yellow-100:hover {\n    --text-opacity: 1;\n    color: #fdf6b2;\n    color: rgba(253, 246, 178, var(--text-opacity));\n  }\n  .xl\\:hover\\:text-yellow-200:hover {\n    --text-opacity: 1;\n    color: #fce96a;\n    color: rgba(252, 233, 106, var(--text-opacity));\n  }\n  .xl\\:hover\\:text-yellow-300:hover {\n    --text-opacity: 1;\n    color: #faca15;\n    color: rgba(250, 202, 21, var(--text-opacity));\n  }\n  .xl\\:hover\\:text-yellow-400:hover {\n    --text-opacity: 1;\n    color: #e3a008;\n    color: rgba(227, 160, 8, var(--text-opacity));\n  }\n  .xl\\:hover\\:text-yellow-500:hover {\n    --text-opacity: 1;\n    color: #c27803;\n    color: rgba(194, 120, 3, var(--text-opacity));\n  }\n  .xl\\:hover\\:text-yellow-600:hover {\n    --text-opacity: 1;\n    color: #9f580a;\n    color: rgba(159, 88, 10, var(--text-opacity));\n  }\n  .xl\\:hover\\:text-yellow-700:hover {\n    --text-opacity: 1;\n    color: #8e4b10;\n    color: rgba(142, 75, 16, var(--text-opacity));\n  }\n  .xl\\:hover\\:text-yellow-800:hover {\n    --text-opacity: 1;\n    color: #723b13;\n    color: rgba(114, 59, 19, var(--text-opacity));\n  }\n  .xl\\:hover\\:text-yellow-900:hover {\n    --text-opacity: 1;\n    color: #633112;\n    color: rgba(99, 49, 18, var(--text-opacity));\n  }\n  .xl\\:hover\\:text-green-50:hover {\n    --text-opacity: 1;\n    color: #f3faf7;\n    color: rgba(243, 250, 247, var(--text-opacity));\n  }\n  .xl\\:hover\\:text-green-100:hover {\n    --text-opacity: 1;\n    color: #def7ec;\n    color: rgba(222, 247, 236, var(--text-opacity));\n  }\n  .xl\\:hover\\:text-green-200:hover {\n    --text-opacity: 1;\n    color: #bcf0da;\n    color: rgba(188, 240, 218, var(--text-opacity));\n  }\n  .xl\\:hover\\:text-green-300:hover {\n    --text-opacity: 1;\n    color: #84e1bc;\n    color: rgba(132, 225, 188, var(--text-opacity));\n  }\n  .xl\\:hover\\:text-green-400:hover {\n    --text-opacity: 1;\n    color: #31c48d;\n    color: rgba(49, 196, 141, var(--text-opacity));\n  }\n  .xl\\:hover\\:text-green-500:hover {\n    --text-opacity: 1;\n    color: #0e9f6e;\n    color: rgba(14, 159, 110, var(--text-opacity));\n  }\n  .xl\\:hover\\:text-green-600:hover {\n    --text-opacity: 1;\n    color: #057a55;\n    color: rgba(5, 122, 85, var(--text-opacity));\n  }\n  .xl\\:hover\\:text-green-700:hover {\n    --text-opacity: 1;\n    color: #046c4e;\n    color: rgba(4, 108, 78, var(--text-opacity));\n  }\n  .xl\\:hover\\:text-green-800:hover {\n    --text-opacity: 1;\n    color: #03543f;\n    color: rgba(3, 84, 63, var(--text-opacity));\n  }\n  .xl\\:hover\\:text-green-900:hover {\n    --text-opacity: 1;\n    color: #014737;\n    color: rgba(1, 71, 55, var(--text-opacity));\n  }\n  .xl\\:hover\\:text-teal-50:hover {\n    --text-opacity: 1;\n    color: #edfafa;\n    color: rgba(237, 250, 250, var(--text-opacity));\n  }\n  .xl\\:hover\\:text-teal-100:hover {\n    --text-opacity: 1;\n    color: #d5f5f6;\n    color: rgba(213, 245, 246, var(--text-opacity));\n  }\n  .xl\\:hover\\:text-teal-200:hover {\n    --text-opacity: 1;\n    color: #afecef;\n    color: rgba(175, 236, 239, var(--text-opacity));\n  }\n  .xl\\:hover\\:text-teal-300:hover {\n    --text-opacity: 1;\n    color: #7edce2;\n    color: rgba(126, 220, 226, var(--text-opacity));\n  }\n  .xl\\:hover\\:text-teal-400:hover {\n    --text-opacity: 1;\n    color: #16bdca;\n    color: rgba(22, 189, 202, var(--text-opacity));\n  }\n  .xl\\:hover\\:text-teal-500:hover {\n    --text-opacity: 1;\n    color: #0694a2;\n    color: rgba(6, 148, 162, var(--text-opacity));\n  }\n  .xl\\:hover\\:text-teal-600:hover {\n    --text-opacity: 1;\n    color: #047481;\n    color: rgba(4, 116, 129, var(--text-opacity));\n  }\n  .xl\\:hover\\:text-teal-700:hover {\n    --text-opacity: 1;\n    color: #036672;\n    color: rgba(3, 102, 114, var(--text-opacity));\n  }\n  .xl\\:hover\\:text-teal-800:hover {\n    --text-opacity: 1;\n    color: #05505c;\n    color: rgba(5, 80, 92, var(--text-opacity));\n  }\n  .xl\\:hover\\:text-teal-900:hover {\n    --text-opacity: 1;\n    color: #014451;\n    color: rgba(1, 68, 81, var(--text-opacity));\n  }\n  .xl\\:hover\\:text-blue-50:hover {\n    --text-opacity: 1;\n    color: #ebf5ff;\n    color: rgba(235, 245, 255, var(--text-opacity));\n  }\n  .xl\\:hover\\:text-blue-100:hover {\n    --text-opacity: 1;\n    color: #e1effe;\n    color: rgba(225, 239, 254, var(--text-opacity));\n  }\n  .xl\\:hover\\:text-blue-200:hover {\n    --text-opacity: 1;\n    color: #c3ddfd;\n    color: rgba(195, 221, 253, var(--text-opacity));\n  }\n  .xl\\:hover\\:text-blue-300:hover {\n    --text-opacity: 1;\n    color: #a4cafe;\n    color: rgba(164, 202, 254, var(--text-opacity));\n  }\n  .xl\\:hover\\:text-blue-400:hover {\n    --text-opacity: 1;\n    color: #76a9fa;\n    color: rgba(118, 169, 250, var(--text-opacity));\n  }\n  .xl\\:hover\\:text-blue-500:hover {\n    --text-opacity: 1;\n    color: #3f83f8;\n    color: rgba(63, 131, 248, var(--text-opacity));\n  }\n  .xl\\:hover\\:text-blue-600:hover {\n    --text-opacity: 1;\n    color: #1c64f2;\n    color: rgba(28, 100, 242, var(--text-opacity));\n  }\n  .xl\\:hover\\:text-blue-700:hover {\n    --text-opacity: 1;\n    color: #1a56db;\n    color: rgba(26, 86, 219, var(--text-opacity));\n  }\n  .xl\\:hover\\:text-blue-800:hover {\n    --text-opacity: 1;\n    color: #1e429f;\n    color: rgba(30, 66, 159, var(--text-opacity));\n  }\n  .xl\\:hover\\:text-blue-900:hover {\n    --text-opacity: 1;\n    color: #233876;\n    color: rgba(35, 56, 118, var(--text-opacity));\n  }\n  .xl\\:hover\\:text-indigo-50:hover {\n    --text-opacity: 1;\n    color: #f0f5ff;\n    color: rgba(240, 245, 255, var(--text-opacity));\n  }\n  .xl\\:hover\\:text-indigo-100:hover {\n    --text-opacity: 1;\n    color: #e5edff;\n    color: rgba(229, 237, 255, var(--text-opacity));\n  }\n  .xl\\:hover\\:text-indigo-200:hover {\n    --text-opacity: 1;\n    color: #cddbfe;\n    color: rgba(205, 219, 254, var(--text-opacity));\n  }\n  .xl\\:hover\\:text-indigo-300:hover {\n    --text-opacity: 1;\n    color: #b4c6fc;\n    color: rgba(180, 198, 252, var(--text-opacity));\n  }\n  .xl\\:hover\\:text-indigo-400:hover {\n    --text-opacity: 1;\n    color: #8da2fb;\n    color: rgba(141, 162, 251, var(--text-opacity));\n  }\n  .xl\\:hover\\:text-indigo-500:hover {\n    --text-opacity: 1;\n    color: #6875f5;\n    color: rgba(104, 117, 245, var(--text-opacity));\n  }\n  .xl\\:hover\\:text-indigo-600:hover {\n    --text-opacity: 1;\n    color: #5850ec;\n    color: rgba(88, 80, 236, var(--text-opacity));\n  }\n  .xl\\:hover\\:text-indigo-700:hover {\n    --text-opacity: 1;\n    color: #5145cd;\n    color: rgba(81, 69, 205, var(--text-opacity));\n  }\n  .xl\\:hover\\:text-indigo-800:hover {\n    --text-opacity: 1;\n    color: #42389d;\n    color: rgba(66, 56, 157, var(--text-opacity));\n  }\n  .xl\\:hover\\:text-indigo-900:hover {\n    --text-opacity: 1;\n    color: #362f78;\n    color: rgba(54, 47, 120, var(--text-opacity));\n  }\n  .xl\\:hover\\:text-purple-50:hover {\n    --text-opacity: 1;\n    color: #f6f5ff;\n    color: rgba(246, 245, 255, var(--text-opacity));\n  }\n  .xl\\:hover\\:text-purple-100:hover {\n    --text-opacity: 1;\n    color: #edebfe;\n    color: rgba(237, 235, 254, var(--text-opacity));\n  }\n  .xl\\:hover\\:text-purple-200:hover {\n    --text-opacity: 1;\n    color: #dcd7fe;\n    color: rgba(220, 215, 254, var(--text-opacity));\n  }\n  .xl\\:hover\\:text-purple-300:hover {\n    --text-opacity: 1;\n    color: #cabffd;\n    color: rgba(202, 191, 253, var(--text-opacity));\n  }\n  .xl\\:hover\\:text-purple-400:hover {\n    --text-opacity: 1;\n    color: #ac94fa;\n    color: rgba(172, 148, 250, var(--text-opacity));\n  }\n  .xl\\:hover\\:text-purple-500:hover {\n    --text-opacity: 1;\n    color: #9061f9;\n    color: rgba(144, 97, 249, var(--text-opacity));\n  }\n  .xl\\:hover\\:text-purple-600:hover {\n    --text-opacity: 1;\n    color: #7e3af2;\n    color: rgba(126, 58, 242, var(--text-opacity));\n  }\n  .xl\\:hover\\:text-purple-700:hover {\n    --text-opacity: 1;\n    color: #6c2bd9;\n    color: rgba(108, 43, 217, var(--text-opacity));\n  }\n  .xl\\:hover\\:text-purple-800:hover {\n    --text-opacity: 1;\n    color: #5521b5;\n    color: rgba(85, 33, 181, var(--text-opacity));\n  }\n  .xl\\:hover\\:text-purple-900:hover {\n    --text-opacity: 1;\n    color: #4a1d96;\n    color: rgba(74, 29, 150, var(--text-opacity));\n  }\n  .xl\\:hover\\:text-pink-50:hover {\n    --text-opacity: 1;\n    color: #fdf2f8;\n    color: rgba(253, 242, 248, var(--text-opacity));\n  }\n  .xl\\:hover\\:text-pink-100:hover {\n    --text-opacity: 1;\n    color: #fce8f3;\n    color: rgba(252, 232, 243, var(--text-opacity));\n  }\n  .xl\\:hover\\:text-pink-200:hover {\n    --text-opacity: 1;\n    color: #fad1e8;\n    color: rgba(250, 209, 232, var(--text-opacity));\n  }\n  .xl\\:hover\\:text-pink-300:hover {\n    --text-opacity: 1;\n    color: #f8b4d9;\n    color: rgba(248, 180, 217, var(--text-opacity));\n  }\n  .xl\\:hover\\:text-pink-400:hover {\n    --text-opacity: 1;\n    color: #f17eb8;\n    color: rgba(241, 126, 184, var(--text-opacity));\n  }\n  .xl\\:hover\\:text-pink-500:hover {\n    --text-opacity: 1;\n    color: #e74694;\n    color: rgba(231, 70, 148, var(--text-opacity));\n  }\n  .xl\\:hover\\:text-pink-600:hover {\n    --text-opacity: 1;\n    color: #d61f69;\n    color: rgba(214, 31, 105, var(--text-opacity));\n  }\n  .xl\\:hover\\:text-pink-700:hover {\n    --text-opacity: 1;\n    color: #bf125d;\n    color: rgba(191, 18, 93, var(--text-opacity));\n  }\n  .xl\\:hover\\:text-pink-800:hover {\n    --text-opacity: 1;\n    color: #99154b;\n    color: rgba(153, 21, 75, var(--text-opacity));\n  }\n  .xl\\:hover\\:text-pink-900:hover {\n    --text-opacity: 1;\n    color: #751a3d;\n    color: rgba(117, 26, 61, var(--text-opacity));\n  }\n  .xl\\:hover\\:text-cool-gray-50:hover {\n    --text-opacity: 1;\n    color: #f8fafc;\n    color: rgba(248, 250, 252, var(--text-opacity));\n  }\n  .xl\\:hover\\:text-cool-gray-100:hover {\n    --text-opacity: 1;\n    color: #f1f5f9;\n    color: rgba(241, 245, 249, var(--text-opacity));\n  }\n  .xl\\:hover\\:text-cool-gray-200:hover {\n    --text-opacity: 1;\n    color: #e2e8f0;\n    color: rgba(226, 232, 240, var(--text-opacity));\n  }\n  .xl\\:hover\\:text-cool-gray-300:hover {\n    --text-opacity: 1;\n    color: #cfd8e3;\n    color: rgba(207, 216, 227, var(--text-opacity));\n  }\n  .xl\\:hover\\:text-cool-gray-400:hover {\n    --text-opacity: 1;\n    color: #97a6ba;\n    color: rgba(151, 166, 186, var(--text-opacity));\n  }\n  .xl\\:hover\\:text-cool-gray-500:hover {\n    --text-opacity: 1;\n    color: #64748b;\n    color: rgba(100, 116, 139, var(--text-opacity));\n  }\n  .xl\\:hover\\:text-cool-gray-600:hover {\n    --text-opacity: 1;\n    color: #475569;\n    color: rgba(71, 85, 105, var(--text-opacity));\n  }\n  .xl\\:hover\\:text-cool-gray-700:hover {\n    --text-opacity: 1;\n    color: #364152;\n    color: rgba(54, 65, 82, var(--text-opacity));\n  }\n  .xl\\:hover\\:text-cool-gray-800:hover {\n    --text-opacity: 1;\n    color: #27303f;\n    color: rgba(39, 48, 63, var(--text-opacity));\n  }\n  .xl\\:hover\\:text-cool-gray-900:hover {\n    --text-opacity: 1;\n    color: #1a202e;\n    color: rgba(26, 32, 46, var(--text-opacity));\n  }\n  .xl\\:focus-within\\:text-current:focus-within {\n    color: currentColor;\n  }\n  .xl\\:focus-within\\:text-transparent:focus-within {\n    color: transparent;\n  }\n  .xl\\:focus-within\\:text-white:focus-within {\n    --text-opacity: 1;\n    color: #ffffff;\n    color: rgba(255, 255, 255, var(--text-opacity));\n  }\n  .xl\\:focus-within\\:text-black:focus-within {\n    --text-opacity: 1;\n    color: #000000;\n    color: rgba(0, 0, 0, var(--text-opacity));\n  }\n  .xl\\:focus-within\\:text-gray-50:focus-within {\n    --text-opacity: 1;\n    color: #f9fafb;\n    color: rgba(249, 250, 251, var(--text-opacity));\n  }\n  .xl\\:focus-within\\:text-gray-100:focus-within {\n    --text-opacity: 1;\n    color: #f4f5f7;\n    color: rgba(244, 245, 247, var(--text-opacity));\n  }\n  .xl\\:focus-within\\:text-gray-200:focus-within {\n    --text-opacity: 1;\n    color: #e5e7eb;\n    color: rgba(229, 231, 235, var(--text-opacity));\n  }\n  .xl\\:focus-within\\:text-gray-300:focus-within {\n    --text-opacity: 1;\n    color: #d2d6dc;\n    color: rgba(210, 214, 220, var(--text-opacity));\n  }\n  .xl\\:focus-within\\:text-gray-400:focus-within {\n    --text-opacity: 1;\n    color: #9fa6b2;\n    color: rgba(159, 166, 178, var(--text-opacity));\n  }\n  .xl\\:focus-within\\:text-gray-500:focus-within {\n    --text-opacity: 1;\n    color: #6b7280;\n    color: rgba(107, 114, 128, var(--text-opacity));\n  }\n  .xl\\:focus-within\\:text-gray-600:focus-within {\n    --text-opacity: 1;\n    color: #4b5563;\n    color: rgba(75, 85, 99, var(--text-opacity));\n  }\n  .xl\\:focus-within\\:text-gray-700:focus-within {\n    --text-opacity: 1;\n    color: #374151;\n    color: rgba(55, 65, 81, var(--text-opacity));\n  }\n  .xl\\:focus-within\\:text-gray-800:focus-within {\n    --text-opacity: 1;\n    color: #252f3f;\n    color: rgba(37, 47, 63, var(--text-opacity));\n  }\n  .xl\\:focus-within\\:text-gray-900:focus-within {\n    --text-opacity: 1;\n    color: #161e2e;\n    color: rgba(22, 30, 46, var(--text-opacity));\n  }\n  .xl\\:focus-within\\:text-red-50:focus-within {\n    --text-opacity: 1;\n    color: #fdf2f2;\n    color: rgba(253, 242, 242, var(--text-opacity));\n  }\n  .xl\\:focus-within\\:text-red-100:focus-within {\n    --text-opacity: 1;\n    color: #fde8e8;\n    color: rgba(253, 232, 232, var(--text-opacity));\n  }\n  .xl\\:focus-within\\:text-red-200:focus-within {\n    --text-opacity: 1;\n    color: #fbd5d5;\n    color: rgba(251, 213, 213, var(--text-opacity));\n  }\n  .xl\\:focus-within\\:text-red-300:focus-within {\n    --text-opacity: 1;\n    color: #f8b4b4;\n    color: rgba(248, 180, 180, var(--text-opacity));\n  }\n  .xl\\:focus-within\\:text-red-400:focus-within {\n    --text-opacity: 1;\n    color: #f98080;\n    color: rgba(249, 128, 128, var(--text-opacity));\n  }\n  .xl\\:focus-within\\:text-red-500:focus-within {\n    --text-opacity: 1;\n    color: #f05252;\n    color: rgba(240, 82, 82, var(--text-opacity));\n  }\n  .xl\\:focus-within\\:text-red-600:focus-within {\n    --text-opacity: 1;\n    color: #e02424;\n    color: rgba(224, 36, 36, var(--text-opacity));\n  }\n  .xl\\:focus-within\\:text-red-700:focus-within {\n    --text-opacity: 1;\n    color: #c81e1e;\n    color: rgba(200, 30, 30, var(--text-opacity));\n  }\n  .xl\\:focus-within\\:text-red-800:focus-within {\n    --text-opacity: 1;\n    color: #9b1c1c;\n    color: rgba(155, 28, 28, var(--text-opacity));\n  }\n  .xl\\:focus-within\\:text-red-900:focus-within {\n    --text-opacity: 1;\n    color: #771d1d;\n    color: rgba(119, 29, 29, var(--text-opacity));\n  }\n  .xl\\:focus-within\\:text-orange-50:focus-within {\n    --text-opacity: 1;\n    color: #fff8f1;\n    color: rgba(255, 248, 241, var(--text-opacity));\n  }\n  .xl\\:focus-within\\:text-orange-100:focus-within {\n    --text-opacity: 1;\n    color: #feecdc;\n    color: rgba(254, 236, 220, var(--text-opacity));\n  }\n  .xl\\:focus-within\\:text-orange-200:focus-within {\n    --text-opacity: 1;\n    color: #fcd9bd;\n    color: rgba(252, 217, 189, var(--text-opacity));\n  }\n  .xl\\:focus-within\\:text-orange-300:focus-within {\n    --text-opacity: 1;\n    color: #fdba8c;\n    color: rgba(253, 186, 140, var(--text-opacity));\n  }\n  .xl\\:focus-within\\:text-orange-400:focus-within {\n    --text-opacity: 1;\n    color: #ff8a4c;\n    color: rgba(255, 138, 76, var(--text-opacity));\n  }\n  .xl\\:focus-within\\:text-orange-500:focus-within {\n    --text-opacity: 1;\n    color: #ff5a1f;\n    color: rgba(255, 90, 31, var(--text-opacity));\n  }\n  .xl\\:focus-within\\:text-orange-600:focus-within {\n    --text-opacity: 1;\n    color: #d03801;\n    color: rgba(208, 56, 1, var(--text-opacity));\n  }\n  .xl\\:focus-within\\:text-orange-700:focus-within {\n    --text-opacity: 1;\n    color: #b43403;\n    color: rgba(180, 52, 3, var(--text-opacity));\n  }\n  .xl\\:focus-within\\:text-orange-800:focus-within {\n    --text-opacity: 1;\n    color: #8a2c0d;\n    color: rgba(138, 44, 13, var(--text-opacity));\n  }\n  .xl\\:focus-within\\:text-orange-900:focus-within {\n    --text-opacity: 1;\n    color: #73230d;\n    color: rgba(115, 35, 13, var(--text-opacity));\n  }\n  .xl\\:focus-within\\:text-yellow-50:focus-within {\n    --text-opacity: 1;\n    color: #fdfdea;\n    color: rgba(253, 253, 234, var(--text-opacity));\n  }\n  .xl\\:focus-within\\:text-yellow-100:focus-within {\n    --text-opacity: 1;\n    color: #fdf6b2;\n    color: rgba(253, 246, 178, var(--text-opacity));\n  }\n  .xl\\:focus-within\\:text-yellow-200:focus-within {\n    --text-opacity: 1;\n    color: #fce96a;\n    color: rgba(252, 233, 106, var(--text-opacity));\n  }\n  .xl\\:focus-within\\:text-yellow-300:focus-within {\n    --text-opacity: 1;\n    color: #faca15;\n    color: rgba(250, 202, 21, var(--text-opacity));\n  }\n  .xl\\:focus-within\\:text-yellow-400:focus-within {\n    --text-opacity: 1;\n    color: #e3a008;\n    color: rgba(227, 160, 8, var(--text-opacity));\n  }\n  .xl\\:focus-within\\:text-yellow-500:focus-within {\n    --text-opacity: 1;\n    color: #c27803;\n    color: rgba(194, 120, 3, var(--text-opacity));\n  }\n  .xl\\:focus-within\\:text-yellow-600:focus-within {\n    --text-opacity: 1;\n    color: #9f580a;\n    color: rgba(159, 88, 10, var(--text-opacity));\n  }\n  .xl\\:focus-within\\:text-yellow-700:focus-within {\n    --text-opacity: 1;\n    color: #8e4b10;\n    color: rgba(142, 75, 16, var(--text-opacity));\n  }\n  .xl\\:focus-within\\:text-yellow-800:focus-within {\n    --text-opacity: 1;\n    color: #723b13;\n    color: rgba(114, 59, 19, var(--text-opacity));\n  }\n  .xl\\:focus-within\\:text-yellow-900:focus-within {\n    --text-opacity: 1;\n    color: #633112;\n    color: rgba(99, 49, 18, var(--text-opacity));\n  }\n  .xl\\:focus-within\\:text-green-50:focus-within {\n    --text-opacity: 1;\n    color: #f3faf7;\n    color: rgba(243, 250, 247, var(--text-opacity));\n  }\n  .xl\\:focus-within\\:text-green-100:focus-within {\n    --text-opacity: 1;\n    color: #def7ec;\n    color: rgba(222, 247, 236, var(--text-opacity));\n  }\n  .xl\\:focus-within\\:text-green-200:focus-within {\n    --text-opacity: 1;\n    color: #bcf0da;\n    color: rgba(188, 240, 218, var(--text-opacity));\n  }\n  .xl\\:focus-within\\:text-green-300:focus-within {\n    --text-opacity: 1;\n    color: #84e1bc;\n    color: rgba(132, 225, 188, var(--text-opacity));\n  }\n  .xl\\:focus-within\\:text-green-400:focus-within {\n    --text-opacity: 1;\n    color: #31c48d;\n    color: rgba(49, 196, 141, var(--text-opacity));\n  }\n  .xl\\:focus-within\\:text-green-500:focus-within {\n    --text-opacity: 1;\n    color: #0e9f6e;\n    color: rgba(14, 159, 110, var(--text-opacity));\n  }\n  .xl\\:focus-within\\:text-green-600:focus-within {\n    --text-opacity: 1;\n    color: #057a55;\n    color: rgba(5, 122, 85, var(--text-opacity));\n  }\n  .xl\\:focus-within\\:text-green-700:focus-within {\n    --text-opacity: 1;\n    color: #046c4e;\n    color: rgba(4, 108, 78, var(--text-opacity));\n  }\n  .xl\\:focus-within\\:text-green-800:focus-within {\n    --text-opacity: 1;\n    color: #03543f;\n    color: rgba(3, 84, 63, var(--text-opacity));\n  }\n  .xl\\:focus-within\\:text-green-900:focus-within {\n    --text-opacity: 1;\n    color: #014737;\n    color: rgba(1, 71, 55, var(--text-opacity));\n  }\n  .xl\\:focus-within\\:text-teal-50:focus-within {\n    --text-opacity: 1;\n    color: #edfafa;\n    color: rgba(237, 250, 250, var(--text-opacity));\n  }\n  .xl\\:focus-within\\:text-teal-100:focus-within {\n    --text-opacity: 1;\n    color: #d5f5f6;\n    color: rgba(213, 245, 246, var(--text-opacity));\n  }\n  .xl\\:focus-within\\:text-teal-200:focus-within {\n    --text-opacity: 1;\n    color: #afecef;\n    color: rgba(175, 236, 239, var(--text-opacity));\n  }\n  .xl\\:focus-within\\:text-teal-300:focus-within {\n    --text-opacity: 1;\n    color: #7edce2;\n    color: rgba(126, 220, 226, var(--text-opacity));\n  }\n  .xl\\:focus-within\\:text-teal-400:focus-within {\n    --text-opacity: 1;\n    color: #16bdca;\n    color: rgba(22, 189, 202, var(--text-opacity));\n  }\n  .xl\\:focus-within\\:text-teal-500:focus-within {\n    --text-opacity: 1;\n    color: #0694a2;\n    color: rgba(6, 148, 162, var(--text-opacity));\n  }\n  .xl\\:focus-within\\:text-teal-600:focus-within {\n    --text-opacity: 1;\n    color: #047481;\n    color: rgba(4, 116, 129, var(--text-opacity));\n  }\n  .xl\\:focus-within\\:text-teal-700:focus-within {\n    --text-opacity: 1;\n    color: #036672;\n    color: rgba(3, 102, 114, var(--text-opacity));\n  }\n  .xl\\:focus-within\\:text-teal-800:focus-within {\n    --text-opacity: 1;\n    color: #05505c;\n    color: rgba(5, 80, 92, var(--text-opacity));\n  }\n  .xl\\:focus-within\\:text-teal-900:focus-within {\n    --text-opacity: 1;\n    color: #014451;\n    color: rgba(1, 68, 81, var(--text-opacity));\n  }\n  .xl\\:focus-within\\:text-blue-50:focus-within {\n    --text-opacity: 1;\n    color: #ebf5ff;\n    color: rgba(235, 245, 255, var(--text-opacity));\n  }\n  .xl\\:focus-within\\:text-blue-100:focus-within {\n    --text-opacity: 1;\n    color: #e1effe;\n    color: rgba(225, 239, 254, var(--text-opacity));\n  }\n  .xl\\:focus-within\\:text-blue-200:focus-within {\n    --text-opacity: 1;\n    color: #c3ddfd;\n    color: rgba(195, 221, 253, var(--text-opacity));\n  }\n  .xl\\:focus-within\\:text-blue-300:focus-within {\n    --text-opacity: 1;\n    color: #a4cafe;\n    color: rgba(164, 202, 254, var(--text-opacity));\n  }\n  .xl\\:focus-within\\:text-blue-400:focus-within {\n    --text-opacity: 1;\n    color: #76a9fa;\n    color: rgba(118, 169, 250, var(--text-opacity));\n  }\n  .xl\\:focus-within\\:text-blue-500:focus-within {\n    --text-opacity: 1;\n    color: #3f83f8;\n    color: rgba(63, 131, 248, var(--text-opacity));\n  }\n  .xl\\:focus-within\\:text-blue-600:focus-within {\n    --text-opacity: 1;\n    color: #1c64f2;\n    color: rgba(28, 100, 242, var(--text-opacity));\n  }\n  .xl\\:focus-within\\:text-blue-700:focus-within {\n    --text-opacity: 1;\n    color: #1a56db;\n    color: rgba(26, 86, 219, var(--text-opacity));\n  }\n  .xl\\:focus-within\\:text-blue-800:focus-within {\n    --text-opacity: 1;\n    color: #1e429f;\n    color: rgba(30, 66, 159, var(--text-opacity));\n  }\n  .xl\\:focus-within\\:text-blue-900:focus-within {\n    --text-opacity: 1;\n    color: #233876;\n    color: rgba(35, 56, 118, var(--text-opacity));\n  }\n  .xl\\:focus-within\\:text-indigo-50:focus-within {\n    --text-opacity: 1;\n    color: #f0f5ff;\n    color: rgba(240, 245, 255, var(--text-opacity));\n  }\n  .xl\\:focus-within\\:text-indigo-100:focus-within {\n    --text-opacity: 1;\n    color: #e5edff;\n    color: rgba(229, 237, 255, var(--text-opacity));\n  }\n  .xl\\:focus-within\\:text-indigo-200:focus-within {\n    --text-opacity: 1;\n    color: #cddbfe;\n    color: rgba(205, 219, 254, var(--text-opacity));\n  }\n  .xl\\:focus-within\\:text-indigo-300:focus-within {\n    --text-opacity: 1;\n    color: #b4c6fc;\n    color: rgba(180, 198, 252, var(--text-opacity));\n  }\n  .xl\\:focus-within\\:text-indigo-400:focus-within {\n    --text-opacity: 1;\n    color: #8da2fb;\n    color: rgba(141, 162, 251, var(--text-opacity));\n  }\n  .xl\\:focus-within\\:text-indigo-500:focus-within {\n    --text-opacity: 1;\n    color: #6875f5;\n    color: rgba(104, 117, 245, var(--text-opacity));\n  }\n  .xl\\:focus-within\\:text-indigo-600:focus-within {\n    --text-opacity: 1;\n    color: #5850ec;\n    color: rgba(88, 80, 236, var(--text-opacity));\n  }\n  .xl\\:focus-within\\:text-indigo-700:focus-within {\n    --text-opacity: 1;\n    color: #5145cd;\n    color: rgba(81, 69, 205, var(--text-opacity));\n  }\n  .xl\\:focus-within\\:text-indigo-800:focus-within {\n    --text-opacity: 1;\n    color: #42389d;\n    color: rgba(66, 56, 157, var(--text-opacity));\n  }\n  .xl\\:focus-within\\:text-indigo-900:focus-within {\n    --text-opacity: 1;\n    color: #362f78;\n    color: rgba(54, 47, 120, var(--text-opacity));\n  }\n  .xl\\:focus-within\\:text-purple-50:focus-within {\n    --text-opacity: 1;\n    color: #f6f5ff;\n    color: rgba(246, 245, 255, var(--text-opacity));\n  }\n  .xl\\:focus-within\\:text-purple-100:focus-within {\n    --text-opacity: 1;\n    color: #edebfe;\n    color: rgba(237, 235, 254, var(--text-opacity));\n  }\n  .xl\\:focus-within\\:text-purple-200:focus-within {\n    --text-opacity: 1;\n    color: #dcd7fe;\n    color: rgba(220, 215, 254, var(--text-opacity));\n  }\n  .xl\\:focus-within\\:text-purple-300:focus-within {\n    --text-opacity: 1;\n    color: #cabffd;\n    color: rgba(202, 191, 253, var(--text-opacity));\n  }\n  .xl\\:focus-within\\:text-purple-400:focus-within {\n    --text-opacity: 1;\n    color: #ac94fa;\n    color: rgba(172, 148, 250, var(--text-opacity));\n  }\n  .xl\\:focus-within\\:text-purple-500:focus-within {\n    --text-opacity: 1;\n    color: #9061f9;\n    color: rgba(144, 97, 249, var(--text-opacity));\n  }\n  .xl\\:focus-within\\:text-purple-600:focus-within {\n    --text-opacity: 1;\n    color: #7e3af2;\n    color: rgba(126, 58, 242, var(--text-opacity));\n  }\n  .xl\\:focus-within\\:text-purple-700:focus-within {\n    --text-opacity: 1;\n    color: #6c2bd9;\n    color: rgba(108, 43, 217, var(--text-opacity));\n  }\n  .xl\\:focus-within\\:text-purple-800:focus-within {\n    --text-opacity: 1;\n    color: #5521b5;\n    color: rgba(85, 33, 181, var(--text-opacity));\n  }\n  .xl\\:focus-within\\:text-purple-900:focus-within {\n    --text-opacity: 1;\n    color: #4a1d96;\n    color: rgba(74, 29, 150, var(--text-opacity));\n  }\n  .xl\\:focus-within\\:text-pink-50:focus-within {\n    --text-opacity: 1;\n    color: #fdf2f8;\n    color: rgba(253, 242, 248, var(--text-opacity));\n  }\n  .xl\\:focus-within\\:text-pink-100:focus-within {\n    --text-opacity: 1;\n    color: #fce8f3;\n    color: rgba(252, 232, 243, var(--text-opacity));\n  }\n  .xl\\:focus-within\\:text-pink-200:focus-within {\n    --text-opacity: 1;\n    color: #fad1e8;\n    color: rgba(250, 209, 232, var(--text-opacity));\n  }\n  .xl\\:focus-within\\:text-pink-300:focus-within {\n    --text-opacity: 1;\n    color: #f8b4d9;\n    color: rgba(248, 180, 217, var(--text-opacity));\n  }\n  .xl\\:focus-within\\:text-pink-400:focus-within {\n    --text-opacity: 1;\n    color: #f17eb8;\n    color: rgba(241, 126, 184, var(--text-opacity));\n  }\n  .xl\\:focus-within\\:text-pink-500:focus-within {\n    --text-opacity: 1;\n    color: #e74694;\n    color: rgba(231, 70, 148, var(--text-opacity));\n  }\n  .xl\\:focus-within\\:text-pink-600:focus-within {\n    --text-opacity: 1;\n    color: #d61f69;\n    color: rgba(214, 31, 105, var(--text-opacity));\n  }\n  .xl\\:focus-within\\:text-pink-700:focus-within {\n    --text-opacity: 1;\n    color: #bf125d;\n    color: rgba(191, 18, 93, var(--text-opacity));\n  }\n  .xl\\:focus-within\\:text-pink-800:focus-within {\n    --text-opacity: 1;\n    color: #99154b;\n    color: rgba(153, 21, 75, var(--text-opacity));\n  }\n  .xl\\:focus-within\\:text-pink-900:focus-within {\n    --text-opacity: 1;\n    color: #751a3d;\n    color: rgba(117, 26, 61, var(--text-opacity));\n  }\n  .xl\\:focus-within\\:text-cool-gray-50:focus-within {\n    --text-opacity: 1;\n    color: #f8fafc;\n    color: rgba(248, 250, 252, var(--text-opacity));\n  }\n  .xl\\:focus-within\\:text-cool-gray-100:focus-within {\n    --text-opacity: 1;\n    color: #f1f5f9;\n    color: rgba(241, 245, 249, var(--text-opacity));\n  }\n  .xl\\:focus-within\\:text-cool-gray-200:focus-within {\n    --text-opacity: 1;\n    color: #e2e8f0;\n    color: rgba(226, 232, 240, var(--text-opacity));\n  }\n  .xl\\:focus-within\\:text-cool-gray-300:focus-within {\n    --text-opacity: 1;\n    color: #cfd8e3;\n    color: rgba(207, 216, 227, var(--text-opacity));\n  }\n  .xl\\:focus-within\\:text-cool-gray-400:focus-within {\n    --text-opacity: 1;\n    color: #97a6ba;\n    color: rgba(151, 166, 186, var(--text-opacity));\n  }\n  .xl\\:focus-within\\:text-cool-gray-500:focus-within {\n    --text-opacity: 1;\n    color: #64748b;\n    color: rgba(100, 116, 139, var(--text-opacity));\n  }\n  .xl\\:focus-within\\:text-cool-gray-600:focus-within {\n    --text-opacity: 1;\n    color: #475569;\n    color: rgba(71, 85, 105, var(--text-opacity));\n  }\n  .xl\\:focus-within\\:text-cool-gray-700:focus-within {\n    --text-opacity: 1;\n    color: #364152;\n    color: rgba(54, 65, 82, var(--text-opacity));\n  }\n  .xl\\:focus-within\\:text-cool-gray-800:focus-within {\n    --text-opacity: 1;\n    color: #27303f;\n    color: rgba(39, 48, 63, var(--text-opacity));\n  }\n  .xl\\:focus-within\\:text-cool-gray-900:focus-within {\n    --text-opacity: 1;\n    color: #1a202e;\n    color: rgba(26, 32, 46, var(--text-opacity));\n  }\n  .xl\\:focus\\:text-current:focus {\n    color: currentColor;\n  }\n  .xl\\:focus\\:text-transparent:focus {\n    color: transparent;\n  }\n  .xl\\:focus\\:text-white:focus {\n    --text-opacity: 1;\n    color: #ffffff;\n    color: rgba(255, 255, 255, var(--text-opacity));\n  }\n  .xl\\:focus\\:text-black:focus {\n    --text-opacity: 1;\n    color: #000000;\n    color: rgba(0, 0, 0, var(--text-opacity));\n  }\n  .xl\\:focus\\:text-gray-50:focus {\n    --text-opacity: 1;\n    color: #f9fafb;\n    color: rgba(249, 250, 251, var(--text-opacity));\n  }\n  .xl\\:focus\\:text-gray-100:focus {\n    --text-opacity: 1;\n    color: #f4f5f7;\n    color: rgba(244, 245, 247, var(--text-opacity));\n  }\n  .xl\\:focus\\:text-gray-200:focus {\n    --text-opacity: 1;\n    color: #e5e7eb;\n    color: rgba(229, 231, 235, var(--text-opacity));\n  }\n  .xl\\:focus\\:text-gray-300:focus {\n    --text-opacity: 1;\n    color: #d2d6dc;\n    color: rgba(210, 214, 220, var(--text-opacity));\n  }\n  .xl\\:focus\\:text-gray-400:focus {\n    --text-opacity: 1;\n    color: #9fa6b2;\n    color: rgba(159, 166, 178, var(--text-opacity));\n  }\n  .xl\\:focus\\:text-gray-500:focus {\n    --text-opacity: 1;\n    color: #6b7280;\n    color: rgba(107, 114, 128, var(--text-opacity));\n  }\n  .xl\\:focus\\:text-gray-600:focus {\n    --text-opacity: 1;\n    color: #4b5563;\n    color: rgba(75, 85, 99, var(--text-opacity));\n  }\n  .xl\\:focus\\:text-gray-700:focus {\n    --text-opacity: 1;\n    color: #374151;\n    color: rgba(55, 65, 81, var(--text-opacity));\n  }\n  .xl\\:focus\\:text-gray-800:focus {\n    --text-opacity: 1;\n    color: #252f3f;\n    color: rgba(37, 47, 63, var(--text-opacity));\n  }\n  .xl\\:focus\\:text-gray-900:focus {\n    --text-opacity: 1;\n    color: #161e2e;\n    color: rgba(22, 30, 46, var(--text-opacity));\n  }\n  .xl\\:focus\\:text-red-50:focus {\n    --text-opacity: 1;\n    color: #fdf2f2;\n    color: rgba(253, 242, 242, var(--text-opacity));\n  }\n  .xl\\:focus\\:text-red-100:focus {\n    --text-opacity: 1;\n    color: #fde8e8;\n    color: rgba(253, 232, 232, var(--text-opacity));\n  }\n  .xl\\:focus\\:text-red-200:focus {\n    --text-opacity: 1;\n    color: #fbd5d5;\n    color: rgba(251, 213, 213, var(--text-opacity));\n  }\n  .xl\\:focus\\:text-red-300:focus {\n    --text-opacity: 1;\n    color: #f8b4b4;\n    color: rgba(248, 180, 180, var(--text-opacity));\n  }\n  .xl\\:focus\\:text-red-400:focus {\n    --text-opacity: 1;\n    color: #f98080;\n    color: rgba(249, 128, 128, var(--text-opacity));\n  }\n  .xl\\:focus\\:text-red-500:focus {\n    --text-opacity: 1;\n    color: #f05252;\n    color: rgba(240, 82, 82, var(--text-opacity));\n  }\n  .xl\\:focus\\:text-red-600:focus {\n    --text-opacity: 1;\n    color: #e02424;\n    color: rgba(224, 36, 36, var(--text-opacity));\n  }\n  .xl\\:focus\\:text-red-700:focus {\n    --text-opacity: 1;\n    color: #c81e1e;\n    color: rgba(200, 30, 30, var(--text-opacity));\n  }\n  .xl\\:focus\\:text-red-800:focus {\n    --text-opacity: 1;\n    color: #9b1c1c;\n    color: rgba(155, 28, 28, var(--text-opacity));\n  }\n  .xl\\:focus\\:text-red-900:focus {\n    --text-opacity: 1;\n    color: #771d1d;\n    color: rgba(119, 29, 29, var(--text-opacity));\n  }\n  .xl\\:focus\\:text-orange-50:focus {\n    --text-opacity: 1;\n    color: #fff8f1;\n    color: rgba(255, 248, 241, var(--text-opacity));\n  }\n  .xl\\:focus\\:text-orange-100:focus {\n    --text-opacity: 1;\n    color: #feecdc;\n    color: rgba(254, 236, 220, var(--text-opacity));\n  }\n  .xl\\:focus\\:text-orange-200:focus {\n    --text-opacity: 1;\n    color: #fcd9bd;\n    color: rgba(252, 217, 189, var(--text-opacity));\n  }\n  .xl\\:focus\\:text-orange-300:focus {\n    --text-opacity: 1;\n    color: #fdba8c;\n    color: rgba(253, 186, 140, var(--text-opacity));\n  }\n  .xl\\:focus\\:text-orange-400:focus {\n    --text-opacity: 1;\n    color: #ff8a4c;\n    color: rgba(255, 138, 76, var(--text-opacity));\n  }\n  .xl\\:focus\\:text-orange-500:focus {\n    --text-opacity: 1;\n    color: #ff5a1f;\n    color: rgba(255, 90, 31, var(--text-opacity));\n  }\n  .xl\\:focus\\:text-orange-600:focus {\n    --text-opacity: 1;\n    color: #d03801;\n    color: rgba(208, 56, 1, var(--text-opacity));\n  }\n  .xl\\:focus\\:text-orange-700:focus {\n    --text-opacity: 1;\n    color: #b43403;\n    color: rgba(180, 52, 3, var(--text-opacity));\n  }\n  .xl\\:focus\\:text-orange-800:focus {\n    --text-opacity: 1;\n    color: #8a2c0d;\n    color: rgba(138, 44, 13, var(--text-opacity));\n  }\n  .xl\\:focus\\:text-orange-900:focus {\n    --text-opacity: 1;\n    color: #73230d;\n    color: rgba(115, 35, 13, var(--text-opacity));\n  }\n  .xl\\:focus\\:text-yellow-50:focus {\n    --text-opacity: 1;\n    color: #fdfdea;\n    color: rgba(253, 253, 234, var(--text-opacity));\n  }\n  .xl\\:focus\\:text-yellow-100:focus {\n    --text-opacity: 1;\n    color: #fdf6b2;\n    color: rgba(253, 246, 178, var(--text-opacity));\n  }\n  .xl\\:focus\\:text-yellow-200:focus {\n    --text-opacity: 1;\n    color: #fce96a;\n    color: rgba(252, 233, 106, var(--text-opacity));\n  }\n  .xl\\:focus\\:text-yellow-300:focus {\n    --text-opacity: 1;\n    color: #faca15;\n    color: rgba(250, 202, 21, var(--text-opacity));\n  }\n  .xl\\:focus\\:text-yellow-400:focus {\n    --text-opacity: 1;\n    color: #e3a008;\n    color: rgba(227, 160, 8, var(--text-opacity));\n  }\n  .xl\\:focus\\:text-yellow-500:focus {\n    --text-opacity: 1;\n    color: #c27803;\n    color: rgba(194, 120, 3, var(--text-opacity));\n  }\n  .xl\\:focus\\:text-yellow-600:focus {\n    --text-opacity: 1;\n    color: #9f580a;\n    color: rgba(159, 88, 10, var(--text-opacity));\n  }\n  .xl\\:focus\\:text-yellow-700:focus {\n    --text-opacity: 1;\n    color: #8e4b10;\n    color: rgba(142, 75, 16, var(--text-opacity));\n  }\n  .xl\\:focus\\:text-yellow-800:focus {\n    --text-opacity: 1;\n    color: #723b13;\n    color: rgba(114, 59, 19, var(--text-opacity));\n  }\n  .xl\\:focus\\:text-yellow-900:focus {\n    --text-opacity: 1;\n    color: #633112;\n    color: rgba(99, 49, 18, var(--text-opacity));\n  }\n  .xl\\:focus\\:text-green-50:focus {\n    --text-opacity: 1;\n    color: #f3faf7;\n    color: rgba(243, 250, 247, var(--text-opacity));\n  }\n  .xl\\:focus\\:text-green-100:focus {\n    --text-opacity: 1;\n    color: #def7ec;\n    color: rgba(222, 247, 236, var(--text-opacity));\n  }\n  .xl\\:focus\\:text-green-200:focus {\n    --text-opacity: 1;\n    color: #bcf0da;\n    color: rgba(188, 240, 218, var(--text-opacity));\n  }\n  .xl\\:focus\\:text-green-300:focus {\n    --text-opacity: 1;\n    color: #84e1bc;\n    color: rgba(132, 225, 188, var(--text-opacity));\n  }\n  .xl\\:focus\\:text-green-400:focus {\n    --text-opacity: 1;\n    color: #31c48d;\n    color: rgba(49, 196, 141, var(--text-opacity));\n  }\n  .xl\\:focus\\:text-green-500:focus {\n    --text-opacity: 1;\n    color: #0e9f6e;\n    color: rgba(14, 159, 110, var(--text-opacity));\n  }\n  .xl\\:focus\\:text-green-600:focus {\n    --text-opacity: 1;\n    color: #057a55;\n    color: rgba(5, 122, 85, var(--text-opacity));\n  }\n  .xl\\:focus\\:text-green-700:focus {\n    --text-opacity: 1;\n    color: #046c4e;\n    color: rgba(4, 108, 78, var(--text-opacity));\n  }\n  .xl\\:focus\\:text-green-800:focus {\n    --text-opacity: 1;\n    color: #03543f;\n    color: rgba(3, 84, 63, var(--text-opacity));\n  }\n  .xl\\:focus\\:text-green-900:focus {\n    --text-opacity: 1;\n    color: #014737;\n    color: rgba(1, 71, 55, var(--text-opacity));\n  }\n  .xl\\:focus\\:text-teal-50:focus {\n    --text-opacity: 1;\n    color: #edfafa;\n    color: rgba(237, 250, 250, var(--text-opacity));\n  }\n  .xl\\:focus\\:text-teal-100:focus {\n    --text-opacity: 1;\n    color: #d5f5f6;\n    color: rgba(213, 245, 246, var(--text-opacity));\n  }\n  .xl\\:focus\\:text-teal-200:focus {\n    --text-opacity: 1;\n    color: #afecef;\n    color: rgba(175, 236, 239, var(--text-opacity));\n  }\n  .xl\\:focus\\:text-teal-300:focus {\n    --text-opacity: 1;\n    color: #7edce2;\n    color: rgba(126, 220, 226, var(--text-opacity));\n  }\n  .xl\\:focus\\:text-teal-400:focus {\n    --text-opacity: 1;\n    color: #16bdca;\n    color: rgba(22, 189, 202, var(--text-opacity));\n  }\n  .xl\\:focus\\:text-teal-500:focus {\n    --text-opacity: 1;\n    color: #0694a2;\n    color: rgba(6, 148, 162, var(--text-opacity));\n  }\n  .xl\\:focus\\:text-teal-600:focus {\n    --text-opacity: 1;\n    color: #047481;\n    color: rgba(4, 116, 129, var(--text-opacity));\n  }\n  .xl\\:focus\\:text-teal-700:focus {\n    --text-opacity: 1;\n    color: #036672;\n    color: rgba(3, 102, 114, var(--text-opacity));\n  }\n  .xl\\:focus\\:text-teal-800:focus {\n    --text-opacity: 1;\n    color: #05505c;\n    color: rgba(5, 80, 92, var(--text-opacity));\n  }\n  .xl\\:focus\\:text-teal-900:focus {\n    --text-opacity: 1;\n    color: #014451;\n    color: rgba(1, 68, 81, var(--text-opacity));\n  }\n  .xl\\:focus\\:text-blue-50:focus {\n    --text-opacity: 1;\n    color: #ebf5ff;\n    color: rgba(235, 245, 255, var(--text-opacity));\n  }\n  .xl\\:focus\\:text-blue-100:focus {\n    --text-opacity: 1;\n    color: #e1effe;\n    color: rgba(225, 239, 254, var(--text-opacity));\n  }\n  .xl\\:focus\\:text-blue-200:focus {\n    --text-opacity: 1;\n    color: #c3ddfd;\n    color: rgba(195, 221, 253, var(--text-opacity));\n  }\n  .xl\\:focus\\:text-blue-300:focus {\n    --text-opacity: 1;\n    color: #a4cafe;\n    color: rgba(164, 202, 254, var(--text-opacity));\n  }\n  .xl\\:focus\\:text-blue-400:focus {\n    --text-opacity: 1;\n    color: #76a9fa;\n    color: rgba(118, 169, 250, var(--text-opacity));\n  }\n  .xl\\:focus\\:text-blue-500:focus {\n    --text-opacity: 1;\n    color: #3f83f8;\n    color: rgba(63, 131, 248, var(--text-opacity));\n  }\n  .xl\\:focus\\:text-blue-600:focus {\n    --text-opacity: 1;\n    color: #1c64f2;\n    color: rgba(28, 100, 242, var(--text-opacity));\n  }\n  .xl\\:focus\\:text-blue-700:focus {\n    --text-opacity: 1;\n    color: #1a56db;\n    color: rgba(26, 86, 219, var(--text-opacity));\n  }\n  .xl\\:focus\\:text-blue-800:focus {\n    --text-opacity: 1;\n    color: #1e429f;\n    color: rgba(30, 66, 159, var(--text-opacity));\n  }\n  .xl\\:focus\\:text-blue-900:focus {\n    --text-opacity: 1;\n    color: #233876;\n    color: rgba(35, 56, 118, var(--text-opacity));\n  }\n  .xl\\:focus\\:text-indigo-50:focus {\n    --text-opacity: 1;\n    color: #f0f5ff;\n    color: rgba(240, 245, 255, var(--text-opacity));\n  }\n  .xl\\:focus\\:text-indigo-100:focus {\n    --text-opacity: 1;\n    color: #e5edff;\n    color: rgba(229, 237, 255, var(--text-opacity));\n  }\n  .xl\\:focus\\:text-indigo-200:focus {\n    --text-opacity: 1;\n    color: #cddbfe;\n    color: rgba(205, 219, 254, var(--text-opacity));\n  }\n  .xl\\:focus\\:text-indigo-300:focus {\n    --text-opacity: 1;\n    color: #b4c6fc;\n    color: rgba(180, 198, 252, var(--text-opacity));\n  }\n  .xl\\:focus\\:text-indigo-400:focus {\n    --text-opacity: 1;\n    color: #8da2fb;\n    color: rgba(141, 162, 251, var(--text-opacity));\n  }\n  .xl\\:focus\\:text-indigo-500:focus {\n    --text-opacity: 1;\n    color: #6875f5;\n    color: rgba(104, 117, 245, var(--text-opacity));\n  }\n  .xl\\:focus\\:text-indigo-600:focus {\n    --text-opacity: 1;\n    color: #5850ec;\n    color: rgba(88, 80, 236, var(--text-opacity));\n  }\n  .xl\\:focus\\:text-indigo-700:focus {\n    --text-opacity: 1;\n    color: #5145cd;\n    color: rgba(81, 69, 205, var(--text-opacity));\n  }\n  .xl\\:focus\\:text-indigo-800:focus {\n    --text-opacity: 1;\n    color: #42389d;\n    color: rgba(66, 56, 157, var(--text-opacity));\n  }\n  .xl\\:focus\\:text-indigo-900:focus {\n    --text-opacity: 1;\n    color: #362f78;\n    color: rgba(54, 47, 120, var(--text-opacity));\n  }\n  .xl\\:focus\\:text-purple-50:focus {\n    --text-opacity: 1;\n    color: #f6f5ff;\n    color: rgba(246, 245, 255, var(--text-opacity));\n  }\n  .xl\\:focus\\:text-purple-100:focus {\n    --text-opacity: 1;\n    color: #edebfe;\n    color: rgba(237, 235, 254, var(--text-opacity));\n  }\n  .xl\\:focus\\:text-purple-200:focus {\n    --text-opacity: 1;\n    color: #dcd7fe;\n    color: rgba(220, 215, 254, var(--text-opacity));\n  }\n  .xl\\:focus\\:text-purple-300:focus {\n    --text-opacity: 1;\n    color: #cabffd;\n    color: rgba(202, 191, 253, var(--text-opacity));\n  }\n  .xl\\:focus\\:text-purple-400:focus {\n    --text-opacity: 1;\n    color: #ac94fa;\n    color: rgba(172, 148, 250, var(--text-opacity));\n  }\n  .xl\\:focus\\:text-purple-500:focus {\n    --text-opacity: 1;\n    color: #9061f9;\n    color: rgba(144, 97, 249, var(--text-opacity));\n  }\n  .xl\\:focus\\:text-purple-600:focus {\n    --text-opacity: 1;\n    color: #7e3af2;\n    color: rgba(126, 58, 242, var(--text-opacity));\n  }\n  .xl\\:focus\\:text-purple-700:focus {\n    --text-opacity: 1;\n    color: #6c2bd9;\n    color: rgba(108, 43, 217, var(--text-opacity));\n  }\n  .xl\\:focus\\:text-purple-800:focus {\n    --text-opacity: 1;\n    color: #5521b5;\n    color: rgba(85, 33, 181, var(--text-opacity));\n  }\n  .xl\\:focus\\:text-purple-900:focus {\n    --text-opacity: 1;\n    color: #4a1d96;\n    color: rgba(74, 29, 150, var(--text-opacity));\n  }\n  .xl\\:focus\\:text-pink-50:focus {\n    --text-opacity: 1;\n    color: #fdf2f8;\n    color: rgba(253, 242, 248, var(--text-opacity));\n  }\n  .xl\\:focus\\:text-pink-100:focus {\n    --text-opacity: 1;\n    color: #fce8f3;\n    color: rgba(252, 232, 243, var(--text-opacity));\n  }\n  .xl\\:focus\\:text-pink-200:focus {\n    --text-opacity: 1;\n    color: #fad1e8;\n    color: rgba(250, 209, 232, var(--text-opacity));\n  }\n  .xl\\:focus\\:text-pink-300:focus {\n    --text-opacity: 1;\n    color: #f8b4d9;\n    color: rgba(248, 180, 217, var(--text-opacity));\n  }\n  .xl\\:focus\\:text-pink-400:focus {\n    --text-opacity: 1;\n    color: #f17eb8;\n    color: rgba(241, 126, 184, var(--text-opacity));\n  }\n  .xl\\:focus\\:text-pink-500:focus {\n    --text-opacity: 1;\n    color: #e74694;\n    color: rgba(231, 70, 148, var(--text-opacity));\n  }\n  .xl\\:focus\\:text-pink-600:focus {\n    --text-opacity: 1;\n    color: #d61f69;\n    color: rgba(214, 31, 105, var(--text-opacity));\n  }\n  .xl\\:focus\\:text-pink-700:focus {\n    --text-opacity: 1;\n    color: #bf125d;\n    color: rgba(191, 18, 93, var(--text-opacity));\n  }\n  .xl\\:focus\\:text-pink-800:focus {\n    --text-opacity: 1;\n    color: #99154b;\n    color: rgba(153, 21, 75, var(--text-opacity));\n  }\n  .xl\\:focus\\:text-pink-900:focus {\n    --text-opacity: 1;\n    color: #751a3d;\n    color: rgba(117, 26, 61, var(--text-opacity));\n  }\n  .xl\\:focus\\:text-cool-gray-50:focus {\n    --text-opacity: 1;\n    color: #f8fafc;\n    color: rgba(248, 250, 252, var(--text-opacity));\n  }\n  .xl\\:focus\\:text-cool-gray-100:focus {\n    --text-opacity: 1;\n    color: #f1f5f9;\n    color: rgba(241, 245, 249, var(--text-opacity));\n  }\n  .xl\\:focus\\:text-cool-gray-200:focus {\n    --text-opacity: 1;\n    color: #e2e8f0;\n    color: rgba(226, 232, 240, var(--text-opacity));\n  }\n  .xl\\:focus\\:text-cool-gray-300:focus {\n    --text-opacity: 1;\n    color: #cfd8e3;\n    color: rgba(207, 216, 227, var(--text-opacity));\n  }\n  .xl\\:focus\\:text-cool-gray-400:focus {\n    --text-opacity: 1;\n    color: #97a6ba;\n    color: rgba(151, 166, 186, var(--text-opacity));\n  }\n  .xl\\:focus\\:text-cool-gray-500:focus {\n    --text-opacity: 1;\n    color: #64748b;\n    color: rgba(100, 116, 139, var(--text-opacity));\n  }\n  .xl\\:focus\\:text-cool-gray-600:focus {\n    --text-opacity: 1;\n    color: #475569;\n    color: rgba(71, 85, 105, var(--text-opacity));\n  }\n  .xl\\:focus\\:text-cool-gray-700:focus {\n    --text-opacity: 1;\n    color: #364152;\n    color: rgba(54, 65, 82, var(--text-opacity));\n  }\n  .xl\\:focus\\:text-cool-gray-800:focus {\n    --text-opacity: 1;\n    color: #27303f;\n    color: rgba(39, 48, 63, var(--text-opacity));\n  }\n  .xl\\:focus\\:text-cool-gray-900:focus {\n    --text-opacity: 1;\n    color: #1a202e;\n    color: rgba(26, 32, 46, var(--text-opacity));\n  }\n  .xl\\:active\\:text-current:active {\n    color: currentColor;\n  }\n  .xl\\:active\\:text-transparent:active {\n    color: transparent;\n  }\n  .xl\\:active\\:text-white:active {\n    --text-opacity: 1;\n    color: #ffffff;\n    color: rgba(255, 255, 255, var(--text-opacity));\n  }\n  .xl\\:active\\:text-black:active {\n    --text-opacity: 1;\n    color: #000000;\n    color: rgba(0, 0, 0, var(--text-opacity));\n  }\n  .xl\\:active\\:text-gray-50:active {\n    --text-opacity: 1;\n    color: #f9fafb;\n    color: rgba(249, 250, 251, var(--text-opacity));\n  }\n  .xl\\:active\\:text-gray-100:active {\n    --text-opacity: 1;\n    color: #f4f5f7;\n    color: rgba(244, 245, 247, var(--text-opacity));\n  }\n  .xl\\:active\\:text-gray-200:active {\n    --text-opacity: 1;\n    color: #e5e7eb;\n    color: rgba(229, 231, 235, var(--text-opacity));\n  }\n  .xl\\:active\\:text-gray-300:active {\n    --text-opacity: 1;\n    color: #d2d6dc;\n    color: rgba(210, 214, 220, var(--text-opacity));\n  }\n  .xl\\:active\\:text-gray-400:active {\n    --text-opacity: 1;\n    color: #9fa6b2;\n    color: rgba(159, 166, 178, var(--text-opacity));\n  }\n  .xl\\:active\\:text-gray-500:active {\n    --text-opacity: 1;\n    color: #6b7280;\n    color: rgba(107, 114, 128, var(--text-opacity));\n  }\n  .xl\\:active\\:text-gray-600:active {\n    --text-opacity: 1;\n    color: #4b5563;\n    color: rgba(75, 85, 99, var(--text-opacity));\n  }\n  .xl\\:active\\:text-gray-700:active {\n    --text-opacity: 1;\n    color: #374151;\n    color: rgba(55, 65, 81, var(--text-opacity));\n  }\n  .xl\\:active\\:text-gray-800:active {\n    --text-opacity: 1;\n    color: #252f3f;\n    color: rgba(37, 47, 63, var(--text-opacity));\n  }\n  .xl\\:active\\:text-gray-900:active {\n    --text-opacity: 1;\n    color: #161e2e;\n    color: rgba(22, 30, 46, var(--text-opacity));\n  }\n  .xl\\:active\\:text-red-50:active {\n    --text-opacity: 1;\n    color: #fdf2f2;\n    color: rgba(253, 242, 242, var(--text-opacity));\n  }\n  .xl\\:active\\:text-red-100:active {\n    --text-opacity: 1;\n    color: #fde8e8;\n    color: rgba(253, 232, 232, var(--text-opacity));\n  }\n  .xl\\:active\\:text-red-200:active {\n    --text-opacity: 1;\n    color: #fbd5d5;\n    color: rgba(251, 213, 213, var(--text-opacity));\n  }\n  .xl\\:active\\:text-red-300:active {\n    --text-opacity: 1;\n    color: #f8b4b4;\n    color: rgba(248, 180, 180, var(--text-opacity));\n  }\n  .xl\\:active\\:text-red-400:active {\n    --text-opacity: 1;\n    color: #f98080;\n    color: rgba(249, 128, 128, var(--text-opacity));\n  }\n  .xl\\:active\\:text-red-500:active {\n    --text-opacity: 1;\n    color: #f05252;\n    color: rgba(240, 82, 82, var(--text-opacity));\n  }\n  .xl\\:active\\:text-red-600:active {\n    --text-opacity: 1;\n    color: #e02424;\n    color: rgba(224, 36, 36, var(--text-opacity));\n  }\n  .xl\\:active\\:text-red-700:active {\n    --text-opacity: 1;\n    color: #c81e1e;\n    color: rgba(200, 30, 30, var(--text-opacity));\n  }\n  .xl\\:active\\:text-red-800:active {\n    --text-opacity: 1;\n    color: #9b1c1c;\n    color: rgba(155, 28, 28, var(--text-opacity));\n  }\n  .xl\\:active\\:text-red-900:active {\n    --text-opacity: 1;\n    color: #771d1d;\n    color: rgba(119, 29, 29, var(--text-opacity));\n  }\n  .xl\\:active\\:text-orange-50:active {\n    --text-opacity: 1;\n    color: #fff8f1;\n    color: rgba(255, 248, 241, var(--text-opacity));\n  }\n  .xl\\:active\\:text-orange-100:active {\n    --text-opacity: 1;\n    color: #feecdc;\n    color: rgba(254, 236, 220, var(--text-opacity));\n  }\n  .xl\\:active\\:text-orange-200:active {\n    --text-opacity: 1;\n    color: #fcd9bd;\n    color: rgba(252, 217, 189, var(--text-opacity));\n  }\n  .xl\\:active\\:text-orange-300:active {\n    --text-opacity: 1;\n    color: #fdba8c;\n    color: rgba(253, 186, 140, var(--text-opacity));\n  }\n  .xl\\:active\\:text-orange-400:active {\n    --text-opacity: 1;\n    color: #ff8a4c;\n    color: rgba(255, 138, 76, var(--text-opacity));\n  }\n  .xl\\:active\\:text-orange-500:active {\n    --text-opacity: 1;\n    color: #ff5a1f;\n    color: rgba(255, 90, 31, var(--text-opacity));\n  }\n  .xl\\:active\\:text-orange-600:active {\n    --text-opacity: 1;\n    color: #d03801;\n    color: rgba(208, 56, 1, var(--text-opacity));\n  }\n  .xl\\:active\\:text-orange-700:active {\n    --text-opacity: 1;\n    color: #b43403;\n    color: rgba(180, 52, 3, var(--text-opacity));\n  }\n  .xl\\:active\\:text-orange-800:active {\n    --text-opacity: 1;\n    color: #8a2c0d;\n    color: rgba(138, 44, 13, var(--text-opacity));\n  }\n  .xl\\:active\\:text-orange-900:active {\n    --text-opacity: 1;\n    color: #73230d;\n    color: rgba(115, 35, 13, var(--text-opacity));\n  }\n  .xl\\:active\\:text-yellow-50:active {\n    --text-opacity: 1;\n    color: #fdfdea;\n    color: rgba(253, 253, 234, var(--text-opacity));\n  }\n  .xl\\:active\\:text-yellow-100:active {\n    --text-opacity: 1;\n    color: #fdf6b2;\n    color: rgba(253, 246, 178, var(--text-opacity));\n  }\n  .xl\\:active\\:text-yellow-200:active {\n    --text-opacity: 1;\n    color: #fce96a;\n    color: rgba(252, 233, 106, var(--text-opacity));\n  }\n  .xl\\:active\\:text-yellow-300:active {\n    --text-opacity: 1;\n    color: #faca15;\n    color: rgba(250, 202, 21, var(--text-opacity));\n  }\n  .xl\\:active\\:text-yellow-400:active {\n    --text-opacity: 1;\n    color: #e3a008;\n    color: rgba(227, 160, 8, var(--text-opacity));\n  }\n  .xl\\:active\\:text-yellow-500:active {\n    --text-opacity: 1;\n    color: #c27803;\n    color: rgba(194, 120, 3, var(--text-opacity));\n  }\n  .xl\\:active\\:text-yellow-600:active {\n    --text-opacity: 1;\n    color: #9f580a;\n    color: rgba(159, 88, 10, var(--text-opacity));\n  }\n  .xl\\:active\\:text-yellow-700:active {\n    --text-opacity: 1;\n    color: #8e4b10;\n    color: rgba(142, 75, 16, var(--text-opacity));\n  }\n  .xl\\:active\\:text-yellow-800:active {\n    --text-opacity: 1;\n    color: #723b13;\n    color: rgba(114, 59, 19, var(--text-opacity));\n  }\n  .xl\\:active\\:text-yellow-900:active {\n    --text-opacity: 1;\n    color: #633112;\n    color: rgba(99, 49, 18, var(--text-opacity));\n  }\n  .xl\\:active\\:text-green-50:active {\n    --text-opacity: 1;\n    color: #f3faf7;\n    color: rgba(243, 250, 247, var(--text-opacity));\n  }\n  .xl\\:active\\:text-green-100:active {\n    --text-opacity: 1;\n    color: #def7ec;\n    color: rgba(222, 247, 236, var(--text-opacity));\n  }\n  .xl\\:active\\:text-green-200:active {\n    --text-opacity: 1;\n    color: #bcf0da;\n    color: rgba(188, 240, 218, var(--text-opacity));\n  }\n  .xl\\:active\\:text-green-300:active {\n    --text-opacity: 1;\n    color: #84e1bc;\n    color: rgba(132, 225, 188, var(--text-opacity));\n  }\n  .xl\\:active\\:text-green-400:active {\n    --text-opacity: 1;\n    color: #31c48d;\n    color: rgba(49, 196, 141, var(--text-opacity));\n  }\n  .xl\\:active\\:text-green-500:active {\n    --text-opacity: 1;\n    color: #0e9f6e;\n    color: rgba(14, 159, 110, var(--text-opacity));\n  }\n  .xl\\:active\\:text-green-600:active {\n    --text-opacity: 1;\n    color: #057a55;\n    color: rgba(5, 122, 85, var(--text-opacity));\n  }\n  .xl\\:active\\:text-green-700:active {\n    --text-opacity: 1;\n    color: #046c4e;\n    color: rgba(4, 108, 78, var(--text-opacity));\n  }\n  .xl\\:active\\:text-green-800:active {\n    --text-opacity: 1;\n    color: #03543f;\n    color: rgba(3, 84, 63, var(--text-opacity));\n  }\n  .xl\\:active\\:text-green-900:active {\n    --text-opacity: 1;\n    color: #014737;\n    color: rgba(1, 71, 55, var(--text-opacity));\n  }\n  .xl\\:active\\:text-teal-50:active {\n    --text-opacity: 1;\n    color: #edfafa;\n    color: rgba(237, 250, 250, var(--text-opacity));\n  }\n  .xl\\:active\\:text-teal-100:active {\n    --text-opacity: 1;\n    color: #d5f5f6;\n    color: rgba(213, 245, 246, var(--text-opacity));\n  }\n  .xl\\:active\\:text-teal-200:active {\n    --text-opacity: 1;\n    color: #afecef;\n    color: rgba(175, 236, 239, var(--text-opacity));\n  }\n  .xl\\:active\\:text-teal-300:active {\n    --text-opacity: 1;\n    color: #7edce2;\n    color: rgba(126, 220, 226, var(--text-opacity));\n  }\n  .xl\\:active\\:text-teal-400:active {\n    --text-opacity: 1;\n    color: #16bdca;\n    color: rgba(22, 189, 202, var(--text-opacity));\n  }\n  .xl\\:active\\:text-teal-500:active {\n    --text-opacity: 1;\n    color: #0694a2;\n    color: rgba(6, 148, 162, var(--text-opacity));\n  }\n  .xl\\:active\\:text-teal-600:active {\n    --text-opacity: 1;\n    color: #047481;\n    color: rgba(4, 116, 129, var(--text-opacity));\n  }\n  .xl\\:active\\:text-teal-700:active {\n    --text-opacity: 1;\n    color: #036672;\n    color: rgba(3, 102, 114, var(--text-opacity));\n  }\n  .xl\\:active\\:text-teal-800:active {\n    --text-opacity: 1;\n    color: #05505c;\n    color: rgba(5, 80, 92, var(--text-opacity));\n  }\n  .xl\\:active\\:text-teal-900:active {\n    --text-opacity: 1;\n    color: #014451;\n    color: rgba(1, 68, 81, var(--text-opacity));\n  }\n  .xl\\:active\\:text-blue-50:active {\n    --text-opacity: 1;\n    color: #ebf5ff;\n    color: rgba(235, 245, 255, var(--text-opacity));\n  }\n  .xl\\:active\\:text-blue-100:active {\n    --text-opacity: 1;\n    color: #e1effe;\n    color: rgba(225, 239, 254, var(--text-opacity));\n  }\n  .xl\\:active\\:text-blue-200:active {\n    --text-opacity: 1;\n    color: #c3ddfd;\n    color: rgba(195, 221, 253, var(--text-opacity));\n  }\n  .xl\\:active\\:text-blue-300:active {\n    --text-opacity: 1;\n    color: #a4cafe;\n    color: rgba(164, 202, 254, var(--text-opacity));\n  }\n  .xl\\:active\\:text-blue-400:active {\n    --text-opacity: 1;\n    color: #76a9fa;\n    color: rgba(118, 169, 250, var(--text-opacity));\n  }\n  .xl\\:active\\:text-blue-500:active {\n    --text-opacity: 1;\n    color: #3f83f8;\n    color: rgba(63, 131, 248, var(--text-opacity));\n  }\n  .xl\\:active\\:text-blue-600:active {\n    --text-opacity: 1;\n    color: #1c64f2;\n    color: rgba(28, 100, 242, var(--text-opacity));\n  }\n  .xl\\:active\\:text-blue-700:active {\n    --text-opacity: 1;\n    color: #1a56db;\n    color: rgba(26, 86, 219, var(--text-opacity));\n  }\n  .xl\\:active\\:text-blue-800:active {\n    --text-opacity: 1;\n    color: #1e429f;\n    color: rgba(30, 66, 159, var(--text-opacity));\n  }\n  .xl\\:active\\:text-blue-900:active {\n    --text-opacity: 1;\n    color: #233876;\n    color: rgba(35, 56, 118, var(--text-opacity));\n  }\n  .xl\\:active\\:text-indigo-50:active {\n    --text-opacity: 1;\n    color: #f0f5ff;\n    color: rgba(240, 245, 255, var(--text-opacity));\n  }\n  .xl\\:active\\:text-indigo-100:active {\n    --text-opacity: 1;\n    color: #e5edff;\n    color: rgba(229, 237, 255, var(--text-opacity));\n  }\n  .xl\\:active\\:text-indigo-200:active {\n    --text-opacity: 1;\n    color: #cddbfe;\n    color: rgba(205, 219, 254, var(--text-opacity));\n  }\n  .xl\\:active\\:text-indigo-300:active {\n    --text-opacity: 1;\n    color: #b4c6fc;\n    color: rgba(180, 198, 252, var(--text-opacity));\n  }\n  .xl\\:active\\:text-indigo-400:active {\n    --text-opacity: 1;\n    color: #8da2fb;\n    color: rgba(141, 162, 251, var(--text-opacity));\n  }\n  .xl\\:active\\:text-indigo-500:active {\n    --text-opacity: 1;\n    color: #6875f5;\n    color: rgba(104, 117, 245, var(--text-opacity));\n  }\n  .xl\\:active\\:text-indigo-600:active {\n    --text-opacity: 1;\n    color: #5850ec;\n    color: rgba(88, 80, 236, var(--text-opacity));\n  }\n  .xl\\:active\\:text-indigo-700:active {\n    --text-opacity: 1;\n    color: #5145cd;\n    color: rgba(81, 69, 205, var(--text-opacity));\n  }\n  .xl\\:active\\:text-indigo-800:active {\n    --text-opacity: 1;\n    color: #42389d;\n    color: rgba(66, 56, 157, var(--text-opacity));\n  }\n  .xl\\:active\\:text-indigo-900:active {\n    --text-opacity: 1;\n    color: #362f78;\n    color: rgba(54, 47, 120, var(--text-opacity));\n  }\n  .xl\\:active\\:text-purple-50:active {\n    --text-opacity: 1;\n    color: #f6f5ff;\n    color: rgba(246, 245, 255, var(--text-opacity));\n  }\n  .xl\\:active\\:text-purple-100:active {\n    --text-opacity: 1;\n    color: #edebfe;\n    color: rgba(237, 235, 254, var(--text-opacity));\n  }\n  .xl\\:active\\:text-purple-200:active {\n    --text-opacity: 1;\n    color: #dcd7fe;\n    color: rgba(220, 215, 254, var(--text-opacity));\n  }\n  .xl\\:active\\:text-purple-300:active {\n    --text-opacity: 1;\n    color: #cabffd;\n    color: rgba(202, 191, 253, var(--text-opacity));\n  }\n  .xl\\:active\\:text-purple-400:active {\n    --text-opacity: 1;\n    color: #ac94fa;\n    color: rgba(172, 148, 250, var(--text-opacity));\n  }\n  .xl\\:active\\:text-purple-500:active {\n    --text-opacity: 1;\n    color: #9061f9;\n    color: rgba(144, 97, 249, var(--text-opacity));\n  }\n  .xl\\:active\\:text-purple-600:active {\n    --text-opacity: 1;\n    color: #7e3af2;\n    color: rgba(126, 58, 242, var(--text-opacity));\n  }\n  .xl\\:active\\:text-purple-700:active {\n    --text-opacity: 1;\n    color: #6c2bd9;\n    color: rgba(108, 43, 217, var(--text-opacity));\n  }\n  .xl\\:active\\:text-purple-800:active {\n    --text-opacity: 1;\n    color: #5521b5;\n    color: rgba(85, 33, 181, var(--text-opacity));\n  }\n  .xl\\:active\\:text-purple-900:active {\n    --text-opacity: 1;\n    color: #4a1d96;\n    color: rgba(74, 29, 150, var(--text-opacity));\n  }\n  .xl\\:active\\:text-pink-50:active {\n    --text-opacity: 1;\n    color: #fdf2f8;\n    color: rgba(253, 242, 248, var(--text-opacity));\n  }\n  .xl\\:active\\:text-pink-100:active {\n    --text-opacity: 1;\n    color: #fce8f3;\n    color: rgba(252, 232, 243, var(--text-opacity));\n  }\n  .xl\\:active\\:text-pink-200:active {\n    --text-opacity: 1;\n    color: #fad1e8;\n    color: rgba(250, 209, 232, var(--text-opacity));\n  }\n  .xl\\:active\\:text-pink-300:active {\n    --text-opacity: 1;\n    color: #f8b4d9;\n    color: rgba(248, 180, 217, var(--text-opacity));\n  }\n  .xl\\:active\\:text-pink-400:active {\n    --text-opacity: 1;\n    color: #f17eb8;\n    color: rgba(241, 126, 184, var(--text-opacity));\n  }\n  .xl\\:active\\:text-pink-500:active {\n    --text-opacity: 1;\n    color: #e74694;\n    color: rgba(231, 70, 148, var(--text-opacity));\n  }\n  .xl\\:active\\:text-pink-600:active {\n    --text-opacity: 1;\n    color: #d61f69;\n    color: rgba(214, 31, 105, var(--text-opacity));\n  }\n  .xl\\:active\\:text-pink-700:active {\n    --text-opacity: 1;\n    color: #bf125d;\n    color: rgba(191, 18, 93, var(--text-opacity));\n  }\n  .xl\\:active\\:text-pink-800:active {\n    --text-opacity: 1;\n    color: #99154b;\n    color: rgba(153, 21, 75, var(--text-opacity));\n  }\n  .xl\\:active\\:text-pink-900:active {\n    --text-opacity: 1;\n    color: #751a3d;\n    color: rgba(117, 26, 61, var(--text-opacity));\n  }\n  .xl\\:active\\:text-cool-gray-50:active {\n    --text-opacity: 1;\n    color: #f8fafc;\n    color: rgba(248, 250, 252, var(--text-opacity));\n  }\n  .xl\\:active\\:text-cool-gray-100:active {\n    --text-opacity: 1;\n    color: #f1f5f9;\n    color: rgba(241, 245, 249, var(--text-opacity));\n  }\n  .xl\\:active\\:text-cool-gray-200:active {\n    --text-opacity: 1;\n    color: #e2e8f0;\n    color: rgba(226, 232, 240, var(--text-opacity));\n  }\n  .xl\\:active\\:text-cool-gray-300:active {\n    --text-opacity: 1;\n    color: #cfd8e3;\n    color: rgba(207, 216, 227, var(--text-opacity));\n  }\n  .xl\\:active\\:text-cool-gray-400:active {\n    --text-opacity: 1;\n    color: #97a6ba;\n    color: rgba(151, 166, 186, var(--text-opacity));\n  }\n  .xl\\:active\\:text-cool-gray-500:active {\n    --text-opacity: 1;\n    color: #64748b;\n    color: rgba(100, 116, 139, var(--text-opacity));\n  }\n  .xl\\:active\\:text-cool-gray-600:active {\n    --text-opacity: 1;\n    color: #475569;\n    color: rgba(71, 85, 105, var(--text-opacity));\n  }\n  .xl\\:active\\:text-cool-gray-700:active {\n    --text-opacity: 1;\n    color: #364152;\n    color: rgba(54, 65, 82, var(--text-opacity));\n  }\n  .xl\\:active\\:text-cool-gray-800:active {\n    --text-opacity: 1;\n    color: #27303f;\n    color: rgba(39, 48, 63, var(--text-opacity));\n  }\n  .xl\\:active\\:text-cool-gray-900:active {\n    --text-opacity: 1;\n    color: #1a202e;\n    color: rgba(26, 32, 46, var(--text-opacity));\n  }\n  .xl\\:text-opacity-0 {\n    --text-opacity: 0;\n  }\n  .xl\\:text-opacity-25 {\n    --text-opacity: 0.25;\n  }\n  .xl\\:text-opacity-50 {\n    --text-opacity: 0.5;\n  }\n  .xl\\:text-opacity-75 {\n    --text-opacity: 0.75;\n  }\n  .xl\\:text-opacity-100 {\n    --text-opacity: 1;\n  }\n  .xl\\:hover\\:text-opacity-0:hover {\n    --text-opacity: 0;\n  }\n  .xl\\:hover\\:text-opacity-25:hover {\n    --text-opacity: 0.25;\n  }\n  .xl\\:hover\\:text-opacity-50:hover {\n    --text-opacity: 0.5;\n  }\n  .xl\\:hover\\:text-opacity-75:hover {\n    --text-opacity: 0.75;\n  }\n  .xl\\:hover\\:text-opacity-100:hover {\n    --text-opacity: 1;\n  }\n  .xl\\:focus\\:text-opacity-0:focus {\n    --text-opacity: 0;\n  }\n  .xl\\:focus\\:text-opacity-25:focus {\n    --text-opacity: 0.25;\n  }\n  .xl\\:focus\\:text-opacity-50:focus {\n    --text-opacity: 0.5;\n  }\n  .xl\\:focus\\:text-opacity-75:focus {\n    --text-opacity: 0.75;\n  }\n  .xl\\:focus\\:text-opacity-100:focus {\n    --text-opacity: 1;\n  }\n  .xl\\:italic {\n    font-style: italic;\n  }\n  .xl\\:not-italic {\n    font-style: normal;\n  }\n  .xl\\:uppercase {\n    text-transform: uppercase;\n  }\n  .xl\\:lowercase {\n    text-transform: lowercase;\n  }\n  .xl\\:capitalize {\n    text-transform: capitalize;\n  }\n  .xl\\:normal-case {\n    text-transform: none;\n  }\n  .xl\\:underline {\n    text-decoration: none;\n  }\n  .xl\\:line-through {\n    text-decoration: line-through;\n  }\n  .xl\\:no-underline {\n    text-decoration: none;\n  }\n  .group:hover .xl\\:group-hover\\:underline {\n    text-decoration: none;\n  }\n  .group:hover .xl\\:group-hover\\:line-through {\n    text-decoration: line-through;\n  }\n  .group:hover .xl\\:group-hover\\:no-underline {\n    text-decoration: none;\n  }\n  .group:focus .xl\\:group-focus\\:underline {\n    text-decoration: none;\n  }\n  .group:focus .xl\\:group-focus\\:line-through {\n    text-decoration: line-through;\n  }\n  .group:focus .xl\\:group-focus\\:no-underline {\n    text-decoration: none;\n  }\n  .xl\\:hover\\:underline:hover {\n    text-decoration: none;\n  }\n  .xl\\:hover\\:line-through:hover {\n    text-decoration: line-through;\n  }\n  .xl\\:hover\\:no-underline:hover {\n    text-decoration: none;\n  }\n  .xl\\:focus\\:underline:focus {\n    text-decoration: none;\n  }\n  .xl\\:focus\\:line-through:focus {\n    text-decoration: line-through;\n  }\n  .xl\\:focus\\:no-underline:focus {\n    text-decoration: none;\n  }\n  .xl\\:antialiased {\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n  }\n  .xl\\:subpixel-antialiased {\n    -webkit-font-smoothing: auto;\n    -moz-osx-font-smoothing: auto;\n  }\n  .xl\\:ordinal, .xl\\:slashed-zero, .xl\\:lining-nums, .xl\\:oldstyle-nums, .xl\\:proportional-nums, .xl\\:tabular-nums, .xl\\:diagonal-fractions, .xl\\:stacked-fractions {\n    --font-variant-numeric-ordinal: var(--tailwind-empty,\n        /*!*/\n        /*!*/\n      );\n    --font-variant-numeric-slashed-zero: var(--tailwind-empty,\n        /*!*/\n        /*!*/\n      );\n    --font-variant-numeric-figure: var(--tailwind-empty,\n        /*!*/\n        /*!*/\n      );\n    --font-variant-numeric-spacing: var(--tailwind-empty,\n        /*!*/\n        /*!*/\n      );\n    --font-variant-numeric-fraction: var(--tailwind-empty,\n        /*!*/\n        /*!*/\n      );\n    font-variant-numeric: var(--font-variant-numeric-ordinal) var(--font-variant-numeric-slashed-zero) var(--font-variant-numeric-figure) var(--font-variant-numeric-spacing) var(--font-variant-numeric-fraction);\n  }\n  .xl\\:normal-nums {\n    font-variant-numeric: normal;\n  }\n  .xl\\:ordinal {\n    --font-variant-numeric-ordinal: ordinal;\n  }\n  .xl\\:slashed-zero {\n    --font-variant-numeric-slashed-zero: slashed-zero;\n  }\n  .xl\\:lining-nums {\n    --font-variant-numeric-figure: lining-nums;\n  }\n  .xl\\:oldstyle-nums {\n    --font-variant-numeric-figure: oldstyle-nums;\n  }\n  .xl\\:proportional-nums {\n    --font-variant-numeric-spacing: proportional-nums;\n  }\n  .xl\\:tabular-nums {\n    --font-variant-numeric-spacing: tabular-nums;\n  }\n  .xl\\:diagonal-fractions {\n    --font-variant-numeric-fraction: diagonal-fractions;\n  }\n  .xl\\:stacked-fractions {\n    --font-variant-numeric-fraction: stacked-fractions;\n  }\n  .xl\\:tracking-tighter {\n    letter-spacing: -0.05em;\n  }\n  .xl\\:tracking-tight {\n    letter-spacing: -0.025em;\n  }\n  .xl\\:tracking-normal {\n    letter-spacing: 0;\n  }\n  .xl\\:tracking-wide {\n    letter-spacing: 0.025em;\n  }\n  .xl\\:tracking-wider {\n    letter-spacing: 0.05em;\n  }\n  .xl\\:tracking-widest {\n    letter-spacing: 0.1em;\n  }\n  .xl\\:select-none {\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    user-select: none;\n  }\n  .xl\\:select-text {\n    -webkit-user-select: text;\n    -moz-user-select: text;\n    user-select: text;\n  }\n  .xl\\:select-all {\n    -webkit-user-select: all;\n    -moz-user-select: all;\n    user-select: all;\n  }\n  .xl\\:select-auto {\n    -webkit-user-select: auto;\n    -moz-user-select: auto;\n    user-select: auto;\n  }\n  .xl\\:align-baseline {\n    vertical-align: baseline;\n  }\n  .xl\\:align-top {\n    vertical-align: top;\n  }\n  .xl\\:align-middle {\n    vertical-align: middle;\n  }\n  .xl\\:align-bottom {\n    vertical-align: bottom;\n  }\n  .xl\\:align-text-top {\n    vertical-align: text-top;\n  }\n  .xl\\:align-text-bottom {\n    vertical-align: text-bottom;\n  }\n  .xl\\:visible {\n    visibility: visible;\n  }\n  .xl\\:invisible {\n    visibility: hidden;\n  }\n  .xl\\:whitespace-normal {\n    white-space: normal;\n  }\n  .xl\\:whitespace-no-wrap {\n    white-space: nowrap;\n  }\n  .xl\\:whitespace-pre {\n    white-space: pre;\n  }\n  .xl\\:whitespace-pre-line {\n    white-space: pre-line;\n  }\n  .xl\\:whitespace-pre-wrap {\n    white-space: pre-wrap;\n  }\n  .xl\\:break-normal {\n    word-wrap: normal;\n    overflow-wrap: normal;\n    word-break: normal;\n  }\n  .xl\\:break-words {\n    word-wrap: break-word;\n    overflow-wrap: break-word;\n  }\n  .xl\\:break-all {\n    word-break: break-all;\n  }\n  .xl\\:truncate {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n  .xl\\:w-0 {\n    width: 0;\n  }\n  .xl\\:w-1 {\n    width: 0.25rem;\n  }\n  .xl\\:w-2 {\n    width: 0.5rem;\n  }\n  .xl\\:w-3 {\n    width: 0.75rem;\n  }\n  .xl\\:w-4 {\n    width: 1rem;\n  }\n  .xl\\:w-5 {\n    width: 1.25rem;\n  }\n  .xl\\:w-6 {\n    width: 1.5rem;\n  }\n  .xl\\:w-7 {\n    width: 1.75rem;\n  }\n  .xl\\:w-8 {\n    width: 2rem;\n  }\n  .xl\\:w-9 {\n    width: 2.25rem;\n  }\n  .xl\\:w-10 {\n    width: 2.5rem;\n  }\n  .xl\\:w-11 {\n    width: 2.75rem;\n  }\n  .xl\\:w-12 {\n    width: 3rem;\n  }\n  .xl\\:w-13 {\n    width: 3.25rem;\n  }\n  .xl\\:w-14 {\n    width: 3.5rem;\n  }\n  .xl\\:w-15 {\n    width: 3.75rem;\n  }\n  .xl\\:w-16 {\n    width: 4rem;\n  }\n  .xl\\:w-20 {\n    width: 5rem;\n  }\n  .xl\\:w-24 {\n    width: 6rem;\n  }\n  .xl\\:w-28 {\n    width: 7rem;\n  }\n  .xl\\:w-32 {\n    width: 8rem;\n  }\n  .xl\\:w-36 {\n    width: 9rem;\n  }\n  .xl\\:w-40 {\n    width: 10rem;\n  }\n  .xl\\:w-44 {\n    width: 11rem;\n  }\n  .xl\\:w-48 {\n    width: 12rem;\n  }\n  .xl\\:w-52 {\n    width: 13rem;\n  }\n  .xl\\:w-56 {\n    width: 14rem;\n  }\n  .xl\\:w-60 {\n    width: 15rem;\n  }\n  .xl\\:w-64 {\n    width: 16rem;\n  }\n  .xl\\:w-72 {\n    width: 18rem;\n  }\n  .xl\\:w-80 {\n    width: 20rem;\n  }\n  .xl\\:w-96 {\n    width: 24rem;\n  }\n  .xl\\:w-auto {\n    width: auto;\n  }\n  .xl\\:w-px {\n    width: 1px;\n  }\n  .xl\\:w-0\\.5 {\n    width: 0.125rem;\n  }\n  .xl\\:w-1\\.5 {\n    width: 0.375rem;\n  }\n  .xl\\:w-2\\.5 {\n    width: 0.625rem;\n  }\n  .xl\\:w-3\\.5 {\n    width: 0.875rem;\n  }\n  .xl\\:w-1\\/2 {\n    width: 50%;\n  }\n  .xl\\:w-1\\/3 {\n    width: 33.333333%;\n  }\n  .xl\\:w-2\\/3 {\n    width: 66.666667%;\n  }\n  .xl\\:w-1\\/4 {\n    width: 25%;\n  }\n  .xl\\:w-2\\/4 {\n    width: 50%;\n  }\n  .xl\\:w-3\\/4 {\n    width: 75%;\n  }\n  .xl\\:w-1\\/5 {\n    width: 20%;\n  }\n  .xl\\:w-2\\/5 {\n    width: 40%;\n  }\n  .xl\\:w-3\\/5 {\n    width: 60%;\n  }\n  .xl\\:w-4\\/5 {\n    width: 80%;\n  }\n  .xl\\:w-1\\/6 {\n    width: 16.666667%;\n  }\n  .xl\\:w-2\\/6 {\n    width: 33.333333%;\n  }\n  .xl\\:w-3\\/6 {\n    width: 50%;\n  }\n  .xl\\:w-4\\/6 {\n    width: 66.666667%;\n  }\n  .xl\\:w-5\\/6 {\n    width: 83.333333%;\n  }\n  .xl\\:w-1\\/12 {\n    width: 8.333333%;\n  }\n  .xl\\:w-2\\/12 {\n    width: 16.666667%;\n  }\n  .xl\\:w-3\\/12 {\n    width: 25%;\n  }\n  .xl\\:w-4\\/12 {\n    width: 33.333333%;\n  }\n  .xl\\:w-5\\/12 {\n    width: 41.666667%;\n  }\n  .xl\\:w-6\\/12 {\n    width: 50%;\n  }\n  .xl\\:w-7\\/12 {\n    width: 58.333333%;\n  }\n  .xl\\:w-8\\/12 {\n    width: 66.666667%;\n  }\n  .xl\\:w-9\\/12 {\n    width: 75%;\n  }\n  .xl\\:w-10\\/12 {\n    width: 83.333333%;\n  }\n  .xl\\:w-11\\/12 {\n    width: 91.666667%;\n  }\n  .xl\\:w-full {\n    width: 100%;\n  }\n  .xl\\:w-screen {\n    width: 100vw;\n  }\n  .xl\\:w-min-content {\n    width: -moz-min-content;\n    width: min-content;\n  }\n  .xl\\:w-max-content {\n    width: -moz-max-content;\n    width: max-content;\n  }\n  .xl\\:z-0 {\n    z-index: 0;\n  }\n  .xl\\:z-10 {\n    z-index: 10;\n  }\n  .xl\\:z-20 {\n    z-index: 20;\n  }\n  .xl\\:z-30 {\n    z-index: 30;\n  }\n  .xl\\:z-40 {\n    z-index: 40;\n  }\n  .xl\\:z-50 {\n    z-index: 50;\n  }\n  .xl\\:z-auto {\n    z-index: auto;\n  }\n  .xl\\:focus-within\\:z-0:focus-within {\n    z-index: 0;\n  }\n  .xl\\:focus-within\\:z-10:focus-within {\n    z-index: 10;\n  }\n  .xl\\:focus-within\\:z-20:focus-within {\n    z-index: 20;\n  }\n  .xl\\:focus-within\\:z-30:focus-within {\n    z-index: 30;\n  }\n  .xl\\:focus-within\\:z-40:focus-within {\n    z-index: 40;\n  }\n  .xl\\:focus-within\\:z-50:focus-within {\n    z-index: 50;\n  }\n  .xl\\:focus-within\\:z-auto:focus-within {\n    z-index: auto;\n  }\n  .xl\\:focus\\:z-0:focus {\n    z-index: 0;\n  }\n  .xl\\:focus\\:z-10:focus {\n    z-index: 10;\n  }\n  .xl\\:focus\\:z-20:focus {\n    z-index: 20;\n  }\n  .xl\\:focus\\:z-30:focus {\n    z-index: 30;\n  }\n  .xl\\:focus\\:z-40:focus {\n    z-index: 40;\n  }\n  .xl\\:focus\\:z-50:focus {\n    z-index: 50;\n  }\n  .xl\\:focus\\:z-auto:focus {\n    z-index: auto;\n  }\n  .xl\\:gap-0 {\n    grid-gap: 0;\n    gap: 0;\n  }\n  .xl\\:gap-1 {\n    grid-gap: 0.25rem;\n    gap: 0.25rem;\n  }\n  .xl\\:gap-2 {\n    grid-gap: 0.5rem;\n    gap: 0.5rem;\n  }\n  .xl\\:gap-3 {\n    grid-gap: 0.75rem;\n    gap: 0.75rem;\n  }\n  .xl\\:gap-4 {\n    grid-gap: 1rem;\n    gap: 1rem;\n  }\n  .xl\\:gap-5 {\n    grid-gap: 1.25rem;\n    gap: 1.25rem;\n  }\n  .xl\\:gap-6 {\n    grid-gap: 1.5rem;\n    gap: 1.5rem;\n  }\n  .xl\\:gap-7 {\n    grid-gap: 1.75rem;\n    gap: 1.75rem;\n  }\n  .xl\\:gap-8 {\n    grid-gap: 2rem;\n    gap: 2rem;\n  }\n  .xl\\:gap-9 {\n    grid-gap: 2.25rem;\n    gap: 2.25rem;\n  }\n  .xl\\:gap-10 {\n    grid-gap: 2.5rem;\n    gap: 2.5rem;\n  }\n  .xl\\:gap-11 {\n    grid-gap: 2.75rem;\n    gap: 2.75rem;\n  }\n  .xl\\:gap-12 {\n    grid-gap: 3rem;\n    gap: 3rem;\n  }\n  .xl\\:gap-13 {\n    grid-gap: 3.25rem;\n    gap: 3.25rem;\n  }\n  .xl\\:gap-14 {\n    grid-gap: 3.5rem;\n    gap: 3.5rem;\n  }\n  .xl\\:gap-15 {\n    grid-gap: 3.75rem;\n    gap: 3.75rem;\n  }\n  .xl\\:gap-16 {\n    grid-gap: 4rem;\n    gap: 4rem;\n  }\n  .xl\\:gap-20 {\n    grid-gap: 5rem;\n    gap: 5rem;\n  }\n  .xl\\:gap-24 {\n    grid-gap: 6rem;\n    gap: 6rem;\n  }\n  .xl\\:gap-28 {\n    grid-gap: 7rem;\n    gap: 7rem;\n  }\n  .xl\\:gap-32 {\n    grid-gap: 8rem;\n    gap: 8rem;\n  }\n  .xl\\:gap-36 {\n    grid-gap: 9rem;\n    gap: 9rem;\n  }\n  .xl\\:gap-40 {\n    grid-gap: 10rem;\n    gap: 10rem;\n  }\n  .xl\\:gap-44 {\n    grid-gap: 11rem;\n    gap: 11rem;\n  }\n  .xl\\:gap-48 {\n    grid-gap: 12rem;\n    gap: 12rem;\n  }\n  .xl\\:gap-52 {\n    grid-gap: 13rem;\n    gap: 13rem;\n  }\n  .xl\\:gap-56 {\n    grid-gap: 14rem;\n    gap: 14rem;\n  }\n  .xl\\:gap-60 {\n    grid-gap: 15rem;\n    gap: 15rem;\n  }\n  .xl\\:gap-64 {\n    grid-gap: 16rem;\n    gap: 16rem;\n  }\n  .xl\\:gap-72 {\n    grid-gap: 18rem;\n    gap: 18rem;\n  }\n  .xl\\:gap-80 {\n    grid-gap: 20rem;\n    gap: 20rem;\n  }\n  .xl\\:gap-96 {\n    grid-gap: 24rem;\n    gap: 24rem;\n  }\n  .xl\\:gap-px {\n    grid-gap: 1px;\n    gap: 1px;\n  }\n  .xl\\:gap-0\\.5 {\n    grid-gap: 0.125rem;\n    gap: 0.125rem;\n  }\n  .xl\\:gap-1\\.5 {\n    grid-gap: 0.375rem;\n    gap: 0.375rem;\n  }\n  .xl\\:gap-2\\.5 {\n    grid-gap: 0.625rem;\n    gap: 0.625rem;\n  }\n  .xl\\:gap-3\\.5 {\n    grid-gap: 0.875rem;\n    gap: 0.875rem;\n  }\n  .xl\\:gap-1\\/2 {\n    grid-gap: 50%;\n    gap: 50%;\n  }\n  .xl\\:gap-1\\/3 {\n    grid-gap: 33.333333%;\n    gap: 33.333333%;\n  }\n  .xl\\:gap-2\\/3 {\n    grid-gap: 66.666667%;\n    gap: 66.666667%;\n  }\n  .xl\\:gap-1\\/4 {\n    grid-gap: 25%;\n    gap: 25%;\n  }\n  .xl\\:gap-2\\/4 {\n    grid-gap: 50%;\n    gap: 50%;\n  }\n  .xl\\:gap-3\\/4 {\n    grid-gap: 75%;\n    gap: 75%;\n  }\n  .xl\\:gap-1\\/5 {\n    grid-gap: 20%;\n    gap: 20%;\n  }\n  .xl\\:gap-2\\/5 {\n    grid-gap: 40%;\n    gap: 40%;\n  }\n  .xl\\:gap-3\\/5 {\n    grid-gap: 60%;\n    gap: 60%;\n  }\n  .xl\\:gap-4\\/5 {\n    grid-gap: 80%;\n    gap: 80%;\n  }\n  .xl\\:gap-1\\/6 {\n    grid-gap: 16.666667%;\n    gap: 16.666667%;\n  }\n  .xl\\:gap-2\\/6 {\n    grid-gap: 33.333333%;\n    gap: 33.333333%;\n  }\n  .xl\\:gap-3\\/6 {\n    grid-gap: 50%;\n    gap: 50%;\n  }\n  .xl\\:gap-4\\/6 {\n    grid-gap: 66.666667%;\n    gap: 66.666667%;\n  }\n  .xl\\:gap-5\\/6 {\n    grid-gap: 83.333333%;\n    gap: 83.333333%;\n  }\n  .xl\\:gap-1\\/12 {\n    grid-gap: 8.333333%;\n    gap: 8.333333%;\n  }\n  .xl\\:gap-2\\/12 {\n    grid-gap: 16.666667%;\n    gap: 16.666667%;\n  }\n  .xl\\:gap-3\\/12 {\n    grid-gap: 25%;\n    gap: 25%;\n  }\n  .xl\\:gap-4\\/12 {\n    grid-gap: 33.333333%;\n    gap: 33.333333%;\n  }\n  .xl\\:gap-5\\/12 {\n    grid-gap: 41.666667%;\n    gap: 41.666667%;\n  }\n  .xl\\:gap-6\\/12 {\n    grid-gap: 50%;\n    gap: 50%;\n  }\n  .xl\\:gap-7\\/12 {\n    grid-gap: 58.333333%;\n    gap: 58.333333%;\n  }\n  .xl\\:gap-8\\/12 {\n    grid-gap: 66.666667%;\n    gap: 66.666667%;\n  }\n  .xl\\:gap-9\\/12 {\n    grid-gap: 75%;\n    gap: 75%;\n  }\n  .xl\\:gap-10\\/12 {\n    grid-gap: 83.333333%;\n    gap: 83.333333%;\n  }\n  .xl\\:gap-11\\/12 {\n    grid-gap: 91.666667%;\n    gap: 91.666667%;\n  }\n  .xl\\:gap-full {\n    grid-gap: 100%;\n    gap: 100%;\n  }\n  .xl\\:col-gap-0 {\n    grid-column-gap: 0;\n    -moz-column-gap: 0;\n    column-gap: 0;\n  }\n  .xl\\:col-gap-1 {\n    grid-column-gap: 0.25rem;\n    -moz-column-gap: 0.25rem;\n    column-gap: 0.25rem;\n  }\n  .xl\\:col-gap-2 {\n    grid-column-gap: 0.5rem;\n    -moz-column-gap: 0.5rem;\n    column-gap: 0.5rem;\n  }\n  .xl\\:col-gap-3 {\n    grid-column-gap: 0.75rem;\n    -moz-column-gap: 0.75rem;\n    column-gap: 0.75rem;\n  }\n  .xl\\:col-gap-4 {\n    grid-column-gap: 1rem;\n    -moz-column-gap: 1rem;\n    column-gap: 1rem;\n  }\n  .xl\\:col-gap-5 {\n    grid-column-gap: 1.25rem;\n    -moz-column-gap: 1.25rem;\n    column-gap: 1.25rem;\n  }\n  .xl\\:col-gap-6 {\n    grid-column-gap: 1.5rem;\n    -moz-column-gap: 1.5rem;\n    column-gap: 1.5rem;\n  }\n  .xl\\:col-gap-7 {\n    grid-column-gap: 1.75rem;\n    -moz-column-gap: 1.75rem;\n    column-gap: 1.75rem;\n  }\n  .xl\\:col-gap-8 {\n    grid-column-gap: 2rem;\n    -moz-column-gap: 2rem;\n    column-gap: 2rem;\n  }\n  .xl\\:col-gap-9 {\n    grid-column-gap: 2.25rem;\n    -moz-column-gap: 2.25rem;\n    column-gap: 2.25rem;\n  }\n  .xl\\:col-gap-10 {\n    grid-column-gap: 2.5rem;\n    -moz-column-gap: 2.5rem;\n    column-gap: 2.5rem;\n  }\n  .xl\\:col-gap-11 {\n    grid-column-gap: 2.75rem;\n    -moz-column-gap: 2.75rem;\n    column-gap: 2.75rem;\n  }\n  .xl\\:col-gap-12 {\n    grid-column-gap: 3rem;\n    -moz-column-gap: 3rem;\n    column-gap: 3rem;\n  }\n  .xl\\:col-gap-13 {\n    grid-column-gap: 3.25rem;\n    -moz-column-gap: 3.25rem;\n    column-gap: 3.25rem;\n  }\n  .xl\\:col-gap-14 {\n    grid-column-gap: 3.5rem;\n    -moz-column-gap: 3.5rem;\n    column-gap: 3.5rem;\n  }\n  .xl\\:col-gap-15 {\n    grid-column-gap: 3.75rem;\n    -moz-column-gap: 3.75rem;\n    column-gap: 3.75rem;\n  }\n  .xl\\:col-gap-16 {\n    grid-column-gap: 4rem;\n    -moz-column-gap: 4rem;\n    column-gap: 4rem;\n  }\n  .xl\\:col-gap-20 {\n    grid-column-gap: 5rem;\n    -moz-column-gap: 5rem;\n    column-gap: 5rem;\n  }\n  .xl\\:col-gap-24 {\n    grid-column-gap: 6rem;\n    -moz-column-gap: 6rem;\n    column-gap: 6rem;\n  }\n  .xl\\:col-gap-28 {\n    grid-column-gap: 7rem;\n    -moz-column-gap: 7rem;\n    column-gap: 7rem;\n  }\n  .xl\\:col-gap-32 {\n    grid-column-gap: 8rem;\n    -moz-column-gap: 8rem;\n    column-gap: 8rem;\n  }\n  .xl\\:col-gap-36 {\n    grid-column-gap: 9rem;\n    -moz-column-gap: 9rem;\n    column-gap: 9rem;\n  }\n  .xl\\:col-gap-40 {\n    grid-column-gap: 10rem;\n    -moz-column-gap: 10rem;\n    column-gap: 10rem;\n  }\n  .xl\\:col-gap-44 {\n    grid-column-gap: 11rem;\n    -moz-column-gap: 11rem;\n    column-gap: 11rem;\n  }\n  .xl\\:col-gap-48 {\n    grid-column-gap: 12rem;\n    -moz-column-gap: 12rem;\n    column-gap: 12rem;\n  }\n  .xl\\:col-gap-52 {\n    grid-column-gap: 13rem;\n    -moz-column-gap: 13rem;\n    column-gap: 13rem;\n  }\n  .xl\\:col-gap-56 {\n    grid-column-gap: 14rem;\n    -moz-column-gap: 14rem;\n    column-gap: 14rem;\n  }\n  .xl\\:col-gap-60 {\n    grid-column-gap: 15rem;\n    -moz-column-gap: 15rem;\n    column-gap: 15rem;\n  }\n  .xl\\:col-gap-64 {\n    grid-column-gap: 16rem;\n    -moz-column-gap: 16rem;\n    column-gap: 16rem;\n  }\n  .xl\\:col-gap-72 {\n    grid-column-gap: 18rem;\n    -moz-column-gap: 18rem;\n    column-gap: 18rem;\n  }\n  .xl\\:col-gap-80 {\n    grid-column-gap: 20rem;\n    -moz-column-gap: 20rem;\n    column-gap: 20rem;\n  }\n  .xl\\:col-gap-96 {\n    grid-column-gap: 24rem;\n    -moz-column-gap: 24rem;\n    column-gap: 24rem;\n  }\n  .xl\\:col-gap-px {\n    grid-column-gap: 1px;\n    -moz-column-gap: 1px;\n    column-gap: 1px;\n  }\n  .xl\\:col-gap-0\\.5 {\n    grid-column-gap: 0.125rem;\n    -moz-column-gap: 0.125rem;\n    column-gap: 0.125rem;\n  }\n  .xl\\:col-gap-1\\.5 {\n    grid-column-gap: 0.375rem;\n    -moz-column-gap: 0.375rem;\n    column-gap: 0.375rem;\n  }\n  .xl\\:col-gap-2\\.5 {\n    grid-column-gap: 0.625rem;\n    -moz-column-gap: 0.625rem;\n    column-gap: 0.625rem;\n  }\n  .xl\\:col-gap-3\\.5 {\n    grid-column-gap: 0.875rem;\n    -moz-column-gap: 0.875rem;\n    column-gap: 0.875rem;\n  }\n  .xl\\:col-gap-1\\/2 {\n    grid-column-gap: 50%;\n    -moz-column-gap: 50%;\n    column-gap: 50%;\n  }\n  .xl\\:col-gap-1\\/3 {\n    grid-column-gap: 33.333333%;\n    -moz-column-gap: 33.333333%;\n    column-gap: 33.333333%;\n  }\n  .xl\\:col-gap-2\\/3 {\n    grid-column-gap: 66.666667%;\n    -moz-column-gap: 66.666667%;\n    column-gap: 66.666667%;\n  }\n  .xl\\:col-gap-1\\/4 {\n    grid-column-gap: 25%;\n    -moz-column-gap: 25%;\n    column-gap: 25%;\n  }\n  .xl\\:col-gap-2\\/4 {\n    grid-column-gap: 50%;\n    -moz-column-gap: 50%;\n    column-gap: 50%;\n  }\n  .xl\\:col-gap-3\\/4 {\n    grid-column-gap: 75%;\n    -moz-column-gap: 75%;\n    column-gap: 75%;\n  }\n  .xl\\:col-gap-1\\/5 {\n    grid-column-gap: 20%;\n    -moz-column-gap: 20%;\n    column-gap: 20%;\n  }\n  .xl\\:col-gap-2\\/5 {\n    grid-column-gap: 40%;\n    -moz-column-gap: 40%;\n    column-gap: 40%;\n  }\n  .xl\\:col-gap-3\\/5 {\n    grid-column-gap: 60%;\n    -moz-column-gap: 60%;\n    column-gap: 60%;\n  }\n  .xl\\:col-gap-4\\/5 {\n    grid-column-gap: 80%;\n    -moz-column-gap: 80%;\n    column-gap: 80%;\n  }\n  .xl\\:col-gap-1\\/6 {\n    grid-column-gap: 16.666667%;\n    -moz-column-gap: 16.666667%;\n    column-gap: 16.666667%;\n  }\n  .xl\\:col-gap-2\\/6 {\n    grid-column-gap: 33.333333%;\n    -moz-column-gap: 33.333333%;\n    column-gap: 33.333333%;\n  }\n  .xl\\:col-gap-3\\/6 {\n    grid-column-gap: 50%;\n    -moz-column-gap: 50%;\n    column-gap: 50%;\n  }\n  .xl\\:col-gap-4\\/6 {\n    grid-column-gap: 66.666667%;\n    -moz-column-gap: 66.666667%;\n    column-gap: 66.666667%;\n  }\n  .xl\\:col-gap-5\\/6 {\n    grid-column-gap: 83.333333%;\n    -moz-column-gap: 83.333333%;\n    column-gap: 83.333333%;\n  }\n  .xl\\:col-gap-1\\/12 {\n    grid-column-gap: 8.333333%;\n    -moz-column-gap: 8.333333%;\n    column-gap: 8.333333%;\n  }\n  .xl\\:col-gap-2\\/12 {\n    grid-column-gap: 16.666667%;\n    -moz-column-gap: 16.666667%;\n    column-gap: 16.666667%;\n  }\n  .xl\\:col-gap-3\\/12 {\n    grid-column-gap: 25%;\n    -moz-column-gap: 25%;\n    column-gap: 25%;\n  }\n  .xl\\:col-gap-4\\/12 {\n    grid-column-gap: 33.333333%;\n    -moz-column-gap: 33.333333%;\n    column-gap: 33.333333%;\n  }\n  .xl\\:col-gap-5\\/12 {\n    grid-column-gap: 41.666667%;\n    -moz-column-gap: 41.666667%;\n    column-gap: 41.666667%;\n  }\n  .xl\\:col-gap-6\\/12 {\n    grid-column-gap: 50%;\n    -moz-column-gap: 50%;\n    column-gap: 50%;\n  }\n  .xl\\:col-gap-7\\/12 {\n    grid-column-gap: 58.333333%;\n    -moz-column-gap: 58.333333%;\n    column-gap: 58.333333%;\n  }\n  .xl\\:col-gap-8\\/12 {\n    grid-column-gap: 66.666667%;\n    -moz-column-gap: 66.666667%;\n    column-gap: 66.666667%;\n  }\n  .xl\\:col-gap-9\\/12 {\n    grid-column-gap: 75%;\n    -moz-column-gap: 75%;\n    column-gap: 75%;\n  }\n  .xl\\:col-gap-10\\/12 {\n    grid-column-gap: 83.333333%;\n    -moz-column-gap: 83.333333%;\n    column-gap: 83.333333%;\n  }\n  .xl\\:col-gap-11\\/12 {\n    grid-column-gap: 91.666667%;\n    -moz-column-gap: 91.666667%;\n    column-gap: 91.666667%;\n  }\n  .xl\\:col-gap-full {\n    grid-column-gap: 100%;\n    -moz-column-gap: 100%;\n    column-gap: 100%;\n  }\n  .xl\\:gap-x-0 {\n    grid-column-gap: 0;\n    -moz-column-gap: 0;\n    column-gap: 0;\n  }\n  .xl\\:gap-x-1 {\n    grid-column-gap: 0.25rem;\n    -moz-column-gap: 0.25rem;\n    column-gap: 0.25rem;\n  }\n  .xl\\:gap-x-2 {\n    grid-column-gap: 0.5rem;\n    -moz-column-gap: 0.5rem;\n    column-gap: 0.5rem;\n  }\n  .xl\\:gap-x-3 {\n    grid-column-gap: 0.75rem;\n    -moz-column-gap: 0.75rem;\n    column-gap: 0.75rem;\n  }\n  .xl\\:gap-x-4 {\n    grid-column-gap: 1rem;\n    -moz-column-gap: 1rem;\n    column-gap: 1rem;\n  }\n  .xl\\:gap-x-5 {\n    grid-column-gap: 1.25rem;\n    -moz-column-gap: 1.25rem;\n    column-gap: 1.25rem;\n  }\n  .xl\\:gap-x-6 {\n    grid-column-gap: 1.5rem;\n    -moz-column-gap: 1.5rem;\n    column-gap: 1.5rem;\n  }\n  .xl\\:gap-x-7 {\n    grid-column-gap: 1.75rem;\n    -moz-column-gap: 1.75rem;\n    column-gap: 1.75rem;\n  }\n  .xl\\:gap-x-8 {\n    grid-column-gap: 2rem;\n    -moz-column-gap: 2rem;\n    column-gap: 2rem;\n  }\n  .xl\\:gap-x-9 {\n    grid-column-gap: 2.25rem;\n    -moz-column-gap: 2.25rem;\n    column-gap: 2.25rem;\n  }\n  .xl\\:gap-x-10 {\n    grid-column-gap: 2.5rem;\n    -moz-column-gap: 2.5rem;\n    column-gap: 2.5rem;\n  }\n  .xl\\:gap-x-11 {\n    grid-column-gap: 2.75rem;\n    -moz-column-gap: 2.75rem;\n    column-gap: 2.75rem;\n  }\n  .xl\\:gap-x-12 {\n    grid-column-gap: 3rem;\n    -moz-column-gap: 3rem;\n    column-gap: 3rem;\n  }\n  .xl\\:gap-x-13 {\n    grid-column-gap: 3.25rem;\n    -moz-column-gap: 3.25rem;\n    column-gap: 3.25rem;\n  }\n  .xl\\:gap-x-14 {\n    grid-column-gap: 3.5rem;\n    -moz-column-gap: 3.5rem;\n    column-gap: 3.5rem;\n  }\n  .xl\\:gap-x-15 {\n    grid-column-gap: 3.75rem;\n    -moz-column-gap: 3.75rem;\n    column-gap: 3.75rem;\n  }\n  .xl\\:gap-x-16 {\n    grid-column-gap: 4rem;\n    -moz-column-gap: 4rem;\n    column-gap: 4rem;\n  }\n  .xl\\:gap-x-20 {\n    grid-column-gap: 5rem;\n    -moz-column-gap: 5rem;\n    column-gap: 5rem;\n  }\n  .xl\\:gap-x-24 {\n    grid-column-gap: 6rem;\n    -moz-column-gap: 6rem;\n    column-gap: 6rem;\n  }\n  .xl\\:gap-x-28 {\n    grid-column-gap: 7rem;\n    -moz-column-gap: 7rem;\n    column-gap: 7rem;\n  }\n  .xl\\:gap-x-32 {\n    grid-column-gap: 8rem;\n    -moz-column-gap: 8rem;\n    column-gap: 8rem;\n  }\n  .xl\\:gap-x-36 {\n    grid-column-gap: 9rem;\n    -moz-column-gap: 9rem;\n    column-gap: 9rem;\n  }\n  .xl\\:gap-x-40 {\n    grid-column-gap: 10rem;\n    -moz-column-gap: 10rem;\n    column-gap: 10rem;\n  }\n  .xl\\:gap-x-44 {\n    grid-column-gap: 11rem;\n    -moz-column-gap: 11rem;\n    column-gap: 11rem;\n  }\n  .xl\\:gap-x-48 {\n    grid-column-gap: 12rem;\n    -moz-column-gap: 12rem;\n    column-gap: 12rem;\n  }\n  .xl\\:gap-x-52 {\n    grid-column-gap: 13rem;\n    -moz-column-gap: 13rem;\n    column-gap: 13rem;\n  }\n  .xl\\:gap-x-56 {\n    grid-column-gap: 14rem;\n    -moz-column-gap: 14rem;\n    column-gap: 14rem;\n  }\n  .xl\\:gap-x-60 {\n    grid-column-gap: 15rem;\n    -moz-column-gap: 15rem;\n    column-gap: 15rem;\n  }\n  .xl\\:gap-x-64 {\n    grid-column-gap: 16rem;\n    -moz-column-gap: 16rem;\n    column-gap: 16rem;\n  }\n  .xl\\:gap-x-72 {\n    grid-column-gap: 18rem;\n    -moz-column-gap: 18rem;\n    column-gap: 18rem;\n  }\n  .xl\\:gap-x-80 {\n    grid-column-gap: 20rem;\n    -moz-column-gap: 20rem;\n    column-gap: 20rem;\n  }\n  .xl\\:gap-x-96 {\n    grid-column-gap: 24rem;\n    -moz-column-gap: 24rem;\n    column-gap: 24rem;\n  }\n  .xl\\:gap-x-px {\n    grid-column-gap: 1px;\n    -moz-column-gap: 1px;\n    column-gap: 1px;\n  }\n  .xl\\:gap-x-0\\.5 {\n    grid-column-gap: 0.125rem;\n    -moz-column-gap: 0.125rem;\n    column-gap: 0.125rem;\n  }\n  .xl\\:gap-x-1\\.5 {\n    grid-column-gap: 0.375rem;\n    -moz-column-gap: 0.375rem;\n    column-gap: 0.375rem;\n  }\n  .xl\\:gap-x-2\\.5 {\n    grid-column-gap: 0.625rem;\n    -moz-column-gap: 0.625rem;\n    column-gap: 0.625rem;\n  }\n  .xl\\:gap-x-3\\.5 {\n    grid-column-gap: 0.875rem;\n    -moz-column-gap: 0.875rem;\n    column-gap: 0.875rem;\n  }\n  .xl\\:gap-x-1\\/2 {\n    grid-column-gap: 50%;\n    -moz-column-gap: 50%;\n    column-gap: 50%;\n  }\n  .xl\\:gap-x-1\\/3 {\n    grid-column-gap: 33.333333%;\n    -moz-column-gap: 33.333333%;\n    column-gap: 33.333333%;\n  }\n  .xl\\:gap-x-2\\/3 {\n    grid-column-gap: 66.666667%;\n    -moz-column-gap: 66.666667%;\n    column-gap: 66.666667%;\n  }\n  .xl\\:gap-x-1\\/4 {\n    grid-column-gap: 25%;\n    -moz-column-gap: 25%;\n    column-gap: 25%;\n  }\n  .xl\\:gap-x-2\\/4 {\n    grid-column-gap: 50%;\n    -moz-column-gap: 50%;\n    column-gap: 50%;\n  }\n  .xl\\:gap-x-3\\/4 {\n    grid-column-gap: 75%;\n    -moz-column-gap: 75%;\n    column-gap: 75%;\n  }\n  .xl\\:gap-x-1\\/5 {\n    grid-column-gap: 20%;\n    -moz-column-gap: 20%;\n    column-gap: 20%;\n  }\n  .xl\\:gap-x-2\\/5 {\n    grid-column-gap: 40%;\n    -moz-column-gap: 40%;\n    column-gap: 40%;\n  }\n  .xl\\:gap-x-3\\/5 {\n    grid-column-gap: 60%;\n    -moz-column-gap: 60%;\n    column-gap: 60%;\n  }\n  .xl\\:gap-x-4\\/5 {\n    grid-column-gap: 80%;\n    -moz-column-gap: 80%;\n    column-gap: 80%;\n  }\n  .xl\\:gap-x-1\\/6 {\n    grid-column-gap: 16.666667%;\n    -moz-column-gap: 16.666667%;\n    column-gap: 16.666667%;\n  }\n  .xl\\:gap-x-2\\/6 {\n    grid-column-gap: 33.333333%;\n    -moz-column-gap: 33.333333%;\n    column-gap: 33.333333%;\n  }\n  .xl\\:gap-x-3\\/6 {\n    grid-column-gap: 50%;\n    -moz-column-gap: 50%;\n    column-gap: 50%;\n  }\n  .xl\\:gap-x-4\\/6 {\n    grid-column-gap: 66.666667%;\n    -moz-column-gap: 66.666667%;\n    column-gap: 66.666667%;\n  }\n  .xl\\:gap-x-5\\/6 {\n    grid-column-gap: 83.333333%;\n    -moz-column-gap: 83.333333%;\n    column-gap: 83.333333%;\n  }\n  .xl\\:gap-x-1\\/12 {\n    grid-column-gap: 8.333333%;\n    -moz-column-gap: 8.333333%;\n    column-gap: 8.333333%;\n  }\n  .xl\\:gap-x-2\\/12 {\n    grid-column-gap: 16.666667%;\n    -moz-column-gap: 16.666667%;\n    column-gap: 16.666667%;\n  }\n  .xl\\:gap-x-3\\/12 {\n    grid-column-gap: 25%;\n    -moz-column-gap: 25%;\n    column-gap: 25%;\n  }\n  .xl\\:gap-x-4\\/12 {\n    grid-column-gap: 33.333333%;\n    -moz-column-gap: 33.333333%;\n    column-gap: 33.333333%;\n  }\n  .xl\\:gap-x-5\\/12 {\n    grid-column-gap: 41.666667%;\n    -moz-column-gap: 41.666667%;\n    column-gap: 41.666667%;\n  }\n  .xl\\:gap-x-6\\/12 {\n    grid-column-gap: 50%;\n    -moz-column-gap: 50%;\n    column-gap: 50%;\n  }\n  .xl\\:gap-x-7\\/12 {\n    grid-column-gap: 58.333333%;\n    -moz-column-gap: 58.333333%;\n    column-gap: 58.333333%;\n  }\n  .xl\\:gap-x-8\\/12 {\n    grid-column-gap: 66.666667%;\n    -moz-column-gap: 66.666667%;\n    column-gap: 66.666667%;\n  }\n  .xl\\:gap-x-9\\/12 {\n    grid-column-gap: 75%;\n    -moz-column-gap: 75%;\n    column-gap: 75%;\n  }\n  .xl\\:gap-x-10\\/12 {\n    grid-column-gap: 83.333333%;\n    -moz-column-gap: 83.333333%;\n    column-gap: 83.333333%;\n  }\n  .xl\\:gap-x-11\\/12 {\n    grid-column-gap: 91.666667%;\n    -moz-column-gap: 91.666667%;\n    column-gap: 91.666667%;\n  }\n  .xl\\:gap-x-full {\n    grid-column-gap: 100%;\n    -moz-column-gap: 100%;\n    column-gap: 100%;\n  }\n  .xl\\:row-gap-0 {\n    grid-row-gap: 0;\n    row-gap: 0;\n  }\n  .xl\\:row-gap-1 {\n    grid-row-gap: 0.25rem;\n    row-gap: 0.25rem;\n  }\n  .xl\\:row-gap-2 {\n    grid-row-gap: 0.5rem;\n    row-gap: 0.5rem;\n  }\n  .xl\\:row-gap-3 {\n    grid-row-gap: 0.75rem;\n    row-gap: 0.75rem;\n  }\n  .xl\\:row-gap-4 {\n    grid-row-gap: 1rem;\n    row-gap: 1rem;\n  }\n  .xl\\:row-gap-5 {\n    grid-row-gap: 1.25rem;\n    row-gap: 1.25rem;\n  }\n  .xl\\:row-gap-6 {\n    grid-row-gap: 1.5rem;\n    row-gap: 1.5rem;\n  }\n  .xl\\:row-gap-7 {\n    grid-row-gap: 1.75rem;\n    row-gap: 1.75rem;\n  }\n  .xl\\:row-gap-8 {\n    grid-row-gap: 2rem;\n    row-gap: 2rem;\n  }\n  .xl\\:row-gap-9 {\n    grid-row-gap: 2.25rem;\n    row-gap: 2.25rem;\n  }\n  .xl\\:row-gap-10 {\n    grid-row-gap: 2.5rem;\n    row-gap: 2.5rem;\n  }\n  .xl\\:row-gap-11 {\n    grid-row-gap: 2.75rem;\n    row-gap: 2.75rem;\n  }\n  .xl\\:row-gap-12 {\n    grid-row-gap: 3rem;\n    row-gap: 3rem;\n  }\n  .xl\\:row-gap-13 {\n    grid-row-gap: 3.25rem;\n    row-gap: 3.25rem;\n  }\n  .xl\\:row-gap-14 {\n    grid-row-gap: 3.5rem;\n    row-gap: 3.5rem;\n  }\n  .xl\\:row-gap-15 {\n    grid-row-gap: 3.75rem;\n    row-gap: 3.75rem;\n  }\n  .xl\\:row-gap-16 {\n    grid-row-gap: 4rem;\n    row-gap: 4rem;\n  }\n  .xl\\:row-gap-20 {\n    grid-row-gap: 5rem;\n    row-gap: 5rem;\n  }\n  .xl\\:row-gap-24 {\n    grid-row-gap: 6rem;\n    row-gap: 6rem;\n  }\n  .xl\\:row-gap-28 {\n    grid-row-gap: 7rem;\n    row-gap: 7rem;\n  }\n  .xl\\:row-gap-32 {\n    grid-row-gap: 8rem;\n    row-gap: 8rem;\n  }\n  .xl\\:row-gap-36 {\n    grid-row-gap: 9rem;\n    row-gap: 9rem;\n  }\n  .xl\\:row-gap-40 {\n    grid-row-gap: 10rem;\n    row-gap: 10rem;\n  }\n  .xl\\:row-gap-44 {\n    grid-row-gap: 11rem;\n    row-gap: 11rem;\n  }\n  .xl\\:row-gap-48 {\n    grid-row-gap: 12rem;\n    row-gap: 12rem;\n  }\n  .xl\\:row-gap-52 {\n    grid-row-gap: 13rem;\n    row-gap: 13rem;\n  }\n  .xl\\:row-gap-56 {\n    grid-row-gap: 14rem;\n    row-gap: 14rem;\n  }\n  .xl\\:row-gap-60 {\n    grid-row-gap: 15rem;\n    row-gap: 15rem;\n  }\n  .xl\\:row-gap-64 {\n    grid-row-gap: 16rem;\n    row-gap: 16rem;\n  }\n  .xl\\:row-gap-72 {\n    grid-row-gap: 18rem;\n    row-gap: 18rem;\n  }\n  .xl\\:row-gap-80 {\n    grid-row-gap: 20rem;\n    row-gap: 20rem;\n  }\n  .xl\\:row-gap-96 {\n    grid-row-gap: 24rem;\n    row-gap: 24rem;\n  }\n  .xl\\:row-gap-px {\n    grid-row-gap: 1px;\n    row-gap: 1px;\n  }\n  .xl\\:row-gap-0\\.5 {\n    grid-row-gap: 0.125rem;\n    row-gap: 0.125rem;\n  }\n  .xl\\:row-gap-1\\.5 {\n    grid-row-gap: 0.375rem;\n    row-gap: 0.375rem;\n  }\n  .xl\\:row-gap-2\\.5 {\n    grid-row-gap: 0.625rem;\n    row-gap: 0.625rem;\n  }\n  .xl\\:row-gap-3\\.5 {\n    grid-row-gap: 0.875rem;\n    row-gap: 0.875rem;\n  }\n  .xl\\:row-gap-1\\/2 {\n    grid-row-gap: 50%;\n    row-gap: 50%;\n  }\n  .xl\\:row-gap-1\\/3 {\n    grid-row-gap: 33.333333%;\n    row-gap: 33.333333%;\n  }\n  .xl\\:row-gap-2\\/3 {\n    grid-row-gap: 66.666667%;\n    row-gap: 66.666667%;\n  }\n  .xl\\:row-gap-1\\/4 {\n    grid-row-gap: 25%;\n    row-gap: 25%;\n  }\n  .xl\\:row-gap-2\\/4 {\n    grid-row-gap: 50%;\n    row-gap: 50%;\n  }\n  .xl\\:row-gap-3\\/4 {\n    grid-row-gap: 75%;\n    row-gap: 75%;\n  }\n  .xl\\:row-gap-1\\/5 {\n    grid-row-gap: 20%;\n    row-gap: 20%;\n  }\n  .xl\\:row-gap-2\\/5 {\n    grid-row-gap: 40%;\n    row-gap: 40%;\n  }\n  .xl\\:row-gap-3\\/5 {\n    grid-row-gap: 60%;\n    row-gap: 60%;\n  }\n  .xl\\:row-gap-4\\/5 {\n    grid-row-gap: 80%;\n    row-gap: 80%;\n  }\n  .xl\\:row-gap-1\\/6 {\n    grid-row-gap: 16.666667%;\n    row-gap: 16.666667%;\n  }\n  .xl\\:row-gap-2\\/6 {\n    grid-row-gap: 33.333333%;\n    row-gap: 33.333333%;\n  }\n  .xl\\:row-gap-3\\/6 {\n    grid-row-gap: 50%;\n    row-gap: 50%;\n  }\n  .xl\\:row-gap-4\\/6 {\n    grid-row-gap: 66.666667%;\n    row-gap: 66.666667%;\n  }\n  .xl\\:row-gap-5\\/6 {\n    grid-row-gap: 83.333333%;\n    row-gap: 83.333333%;\n  }\n  .xl\\:row-gap-1\\/12 {\n    grid-row-gap: 8.333333%;\n    row-gap: 8.333333%;\n  }\n  .xl\\:row-gap-2\\/12 {\n    grid-row-gap: 16.666667%;\n    row-gap: 16.666667%;\n  }\n  .xl\\:row-gap-3\\/12 {\n    grid-row-gap: 25%;\n    row-gap: 25%;\n  }\n  .xl\\:row-gap-4\\/12 {\n    grid-row-gap: 33.333333%;\n    row-gap: 33.333333%;\n  }\n  .xl\\:row-gap-5\\/12 {\n    grid-row-gap: 41.666667%;\n    row-gap: 41.666667%;\n  }\n  .xl\\:row-gap-6\\/12 {\n    grid-row-gap: 50%;\n    row-gap: 50%;\n  }\n  .xl\\:row-gap-7\\/12 {\n    grid-row-gap: 58.333333%;\n    row-gap: 58.333333%;\n  }\n  .xl\\:row-gap-8\\/12 {\n    grid-row-gap: 66.666667%;\n    row-gap: 66.666667%;\n  }\n  .xl\\:row-gap-9\\/12 {\n    grid-row-gap: 75%;\n    row-gap: 75%;\n  }\n  .xl\\:row-gap-10\\/12 {\n    grid-row-gap: 83.333333%;\n    row-gap: 83.333333%;\n  }\n  .xl\\:row-gap-11\\/12 {\n    grid-row-gap: 91.666667%;\n    row-gap: 91.666667%;\n  }\n  .xl\\:row-gap-full {\n    grid-row-gap: 100%;\n    row-gap: 100%;\n  }\n  .xl\\:gap-y-0 {\n    grid-row-gap: 0;\n    row-gap: 0;\n  }\n  .xl\\:gap-y-1 {\n    grid-row-gap: 0.25rem;\n    row-gap: 0.25rem;\n  }\n  .xl\\:gap-y-2 {\n    grid-row-gap: 0.5rem;\n    row-gap: 0.5rem;\n  }\n  .xl\\:gap-y-3 {\n    grid-row-gap: 0.75rem;\n    row-gap: 0.75rem;\n  }\n  .xl\\:gap-y-4 {\n    grid-row-gap: 1rem;\n    row-gap: 1rem;\n  }\n  .xl\\:gap-y-5 {\n    grid-row-gap: 1.25rem;\n    row-gap: 1.25rem;\n  }\n  .xl\\:gap-y-6 {\n    grid-row-gap: 1.5rem;\n    row-gap: 1.5rem;\n  }\n  .xl\\:gap-y-7 {\n    grid-row-gap: 1.75rem;\n    row-gap: 1.75rem;\n  }\n  .xl\\:gap-y-8 {\n    grid-row-gap: 2rem;\n    row-gap: 2rem;\n  }\n  .xl\\:gap-y-9 {\n    grid-row-gap: 2.25rem;\n    row-gap: 2.25rem;\n  }\n  .xl\\:gap-y-10 {\n    grid-row-gap: 2.5rem;\n    row-gap: 2.5rem;\n  }\n  .xl\\:gap-y-11 {\n    grid-row-gap: 2.75rem;\n    row-gap: 2.75rem;\n  }\n  .xl\\:gap-y-12 {\n    grid-row-gap: 3rem;\n    row-gap: 3rem;\n  }\n  .xl\\:gap-y-13 {\n    grid-row-gap: 3.25rem;\n    row-gap: 3.25rem;\n  }\n  .xl\\:gap-y-14 {\n    grid-row-gap: 3.5rem;\n    row-gap: 3.5rem;\n  }\n  .xl\\:gap-y-15 {\n    grid-row-gap: 3.75rem;\n    row-gap: 3.75rem;\n  }\n  .xl\\:gap-y-16 {\n    grid-row-gap: 4rem;\n    row-gap: 4rem;\n  }\n  .xl\\:gap-y-20 {\n    grid-row-gap: 5rem;\n    row-gap: 5rem;\n  }\n  .xl\\:gap-y-24 {\n    grid-row-gap: 6rem;\n    row-gap: 6rem;\n  }\n  .xl\\:gap-y-28 {\n    grid-row-gap: 7rem;\n    row-gap: 7rem;\n  }\n  .xl\\:gap-y-32 {\n    grid-row-gap: 8rem;\n    row-gap: 8rem;\n  }\n  .xl\\:gap-y-36 {\n    grid-row-gap: 9rem;\n    row-gap: 9rem;\n  }\n  .xl\\:gap-y-40 {\n    grid-row-gap: 10rem;\n    row-gap: 10rem;\n  }\n  .xl\\:gap-y-44 {\n    grid-row-gap: 11rem;\n    row-gap: 11rem;\n  }\n  .xl\\:gap-y-48 {\n    grid-row-gap: 12rem;\n    row-gap: 12rem;\n  }\n  .xl\\:gap-y-52 {\n    grid-row-gap: 13rem;\n    row-gap: 13rem;\n  }\n  .xl\\:gap-y-56 {\n    grid-row-gap: 14rem;\n    row-gap: 14rem;\n  }\n  .xl\\:gap-y-60 {\n    grid-row-gap: 15rem;\n    row-gap: 15rem;\n  }\n  .xl\\:gap-y-64 {\n    grid-row-gap: 16rem;\n    row-gap: 16rem;\n  }\n  .xl\\:gap-y-72 {\n    grid-row-gap: 18rem;\n    row-gap: 18rem;\n  }\n  .xl\\:gap-y-80 {\n    grid-row-gap: 20rem;\n    row-gap: 20rem;\n  }\n  .xl\\:gap-y-96 {\n    grid-row-gap: 24rem;\n    row-gap: 24rem;\n  }\n  .xl\\:gap-y-px {\n    grid-row-gap: 1px;\n    row-gap: 1px;\n  }\n  .xl\\:gap-y-0\\.5 {\n    grid-row-gap: 0.125rem;\n    row-gap: 0.125rem;\n  }\n  .xl\\:gap-y-1\\.5 {\n    grid-row-gap: 0.375rem;\n    row-gap: 0.375rem;\n  }\n  .xl\\:gap-y-2\\.5 {\n    grid-row-gap: 0.625rem;\n    row-gap: 0.625rem;\n  }\n  .xl\\:gap-y-3\\.5 {\n    grid-row-gap: 0.875rem;\n    row-gap: 0.875rem;\n  }\n  .xl\\:gap-y-1\\/2 {\n    grid-row-gap: 50%;\n    row-gap: 50%;\n  }\n  .xl\\:gap-y-1\\/3 {\n    grid-row-gap: 33.333333%;\n    row-gap: 33.333333%;\n  }\n  .xl\\:gap-y-2\\/3 {\n    grid-row-gap: 66.666667%;\n    row-gap: 66.666667%;\n  }\n  .xl\\:gap-y-1\\/4 {\n    grid-row-gap: 25%;\n    row-gap: 25%;\n  }\n  .xl\\:gap-y-2\\/4 {\n    grid-row-gap: 50%;\n    row-gap: 50%;\n  }\n  .xl\\:gap-y-3\\/4 {\n    grid-row-gap: 75%;\n    row-gap: 75%;\n  }\n  .xl\\:gap-y-1\\/5 {\n    grid-row-gap: 20%;\n    row-gap: 20%;\n  }\n  .xl\\:gap-y-2\\/5 {\n    grid-row-gap: 40%;\n    row-gap: 40%;\n  }\n  .xl\\:gap-y-3\\/5 {\n    grid-row-gap: 60%;\n    row-gap: 60%;\n  }\n  .xl\\:gap-y-4\\/5 {\n    grid-row-gap: 80%;\n    row-gap: 80%;\n  }\n  .xl\\:gap-y-1\\/6 {\n    grid-row-gap: 16.666667%;\n    row-gap: 16.666667%;\n  }\n  .xl\\:gap-y-2\\/6 {\n    grid-row-gap: 33.333333%;\n    row-gap: 33.333333%;\n  }\n  .xl\\:gap-y-3\\/6 {\n    grid-row-gap: 50%;\n    row-gap: 50%;\n  }\n  .xl\\:gap-y-4\\/6 {\n    grid-row-gap: 66.666667%;\n    row-gap: 66.666667%;\n  }\n  .xl\\:gap-y-5\\/6 {\n    grid-row-gap: 83.333333%;\n    row-gap: 83.333333%;\n  }\n  .xl\\:gap-y-1\\/12 {\n    grid-row-gap: 8.333333%;\n    row-gap: 8.333333%;\n  }\n  .xl\\:gap-y-2\\/12 {\n    grid-row-gap: 16.666667%;\n    row-gap: 16.666667%;\n  }\n  .xl\\:gap-y-3\\/12 {\n    grid-row-gap: 25%;\n    row-gap: 25%;\n  }\n  .xl\\:gap-y-4\\/12 {\n    grid-row-gap: 33.333333%;\n    row-gap: 33.333333%;\n  }\n  .xl\\:gap-y-5\\/12 {\n    grid-row-gap: 41.666667%;\n    row-gap: 41.666667%;\n  }\n  .xl\\:gap-y-6\\/12 {\n    grid-row-gap: 50%;\n    row-gap: 50%;\n  }\n  .xl\\:gap-y-7\\/12 {\n    grid-row-gap: 58.333333%;\n    row-gap: 58.333333%;\n  }\n  .xl\\:gap-y-8\\/12 {\n    grid-row-gap: 66.666667%;\n    row-gap: 66.666667%;\n  }\n  .xl\\:gap-y-9\\/12 {\n    grid-row-gap: 75%;\n    row-gap: 75%;\n  }\n  .xl\\:gap-y-10\\/12 {\n    grid-row-gap: 83.333333%;\n    row-gap: 83.333333%;\n  }\n  .xl\\:gap-y-11\\/12 {\n    grid-row-gap: 91.666667%;\n    row-gap: 91.666667%;\n  }\n  .xl\\:gap-y-full {\n    grid-row-gap: 100%;\n    row-gap: 100%;\n  }\n  .xl\\:grid-flow-row {\n    grid-auto-flow: row;\n  }\n  .xl\\:grid-flow-col {\n    grid-auto-flow: column;\n  }\n  .xl\\:grid-flow-row-dense {\n    grid-auto-flow: row dense;\n  }\n  .xl\\:grid-flow-col-dense {\n    grid-auto-flow: column dense;\n  }\n  .xl\\:grid-cols-1 {\n    grid-template-columns: repeat(1, minmax(0, 1fr));\n  }\n  .xl\\:grid-cols-2 {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n  .xl\\:grid-cols-3 {\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n  }\n  .xl\\:grid-cols-4 {\n    grid-template-columns: repeat(4, minmax(0, 1fr));\n  }\n  .xl\\:grid-cols-5 {\n    grid-template-columns: repeat(5, minmax(0, 1fr));\n  }\n  .xl\\:grid-cols-6 {\n    grid-template-columns: repeat(6, minmax(0, 1fr));\n  }\n  .xl\\:grid-cols-7 {\n    grid-template-columns: repeat(7, minmax(0, 1fr));\n  }\n  .xl\\:grid-cols-8 {\n    grid-template-columns: repeat(8, minmax(0, 1fr));\n  }\n  .xl\\:grid-cols-9 {\n    grid-template-columns: repeat(9, minmax(0, 1fr));\n  }\n  .xl\\:grid-cols-10 {\n    grid-template-columns: repeat(10, minmax(0, 1fr));\n  }\n  .xl\\:grid-cols-11 {\n    grid-template-columns: repeat(11, minmax(0, 1fr));\n  }\n  .xl\\:grid-cols-12 {\n    grid-template-columns: repeat(12, minmax(0, 1fr));\n  }\n  .xl\\:grid-cols-none {\n    grid-template-columns: none;\n  }\n  .xl\\:auto-cols-auto {\n    grid-auto-columns: auto;\n  }\n  .xl\\:auto-cols-min {\n    grid-auto-columns: min-content;\n  }\n  .xl\\:auto-cols-max {\n    grid-auto-columns: max-content;\n  }\n  .xl\\:auto-cols-fr {\n    grid-auto-columns: minmax(0, 1fr);\n  }\n  .xl\\:col-auto {\n    grid-column: auto;\n  }\n  .xl\\:col-span-1 {\n    grid-column: span 1 / span 1;\n  }\n  .xl\\:col-span-2 {\n    grid-column: span 2 / span 2;\n  }\n  .xl\\:col-span-3 {\n    grid-column: span 3 / span 3;\n  }\n  .xl\\:col-span-4 {\n    grid-column: span 4 / span 4;\n  }\n  .xl\\:col-span-5 {\n    grid-column: span 5 / span 5;\n  }\n  .xl\\:col-span-6 {\n    grid-column: span 6 / span 6;\n  }\n  .xl\\:col-span-7 {\n    grid-column: span 7 / span 7;\n  }\n  .xl\\:col-span-8 {\n    grid-column: span 8 / span 8;\n  }\n  .xl\\:col-span-9 {\n    grid-column: span 9 / span 9;\n  }\n  .xl\\:col-span-10 {\n    grid-column: span 10 / span 10;\n  }\n  .xl\\:col-span-11 {\n    grid-column: span 11 / span 11;\n  }\n  .xl\\:col-span-12 {\n    grid-column: span 12 / span 12;\n  }\n  .xl\\:col-span-full {\n    grid-column: 1 / -1;\n  }\n  .xl\\:col-start-1 {\n    grid-column-start: 1;\n  }\n  .xl\\:col-start-2 {\n    grid-column-start: 2;\n  }\n  .xl\\:col-start-3 {\n    grid-column-start: 3;\n  }\n  .xl\\:col-start-4 {\n    grid-column-start: 4;\n  }\n  .xl\\:col-start-5 {\n    grid-column-start: 5;\n  }\n  .xl\\:col-start-6 {\n    grid-column-start: 6;\n  }\n  .xl\\:col-start-7 {\n    grid-column-start: 7;\n  }\n  .xl\\:col-start-8 {\n    grid-column-start: 8;\n  }\n  .xl\\:col-start-9 {\n    grid-column-start: 9;\n  }\n  .xl\\:col-start-10 {\n    grid-column-start: 10;\n  }\n  .xl\\:col-start-11 {\n    grid-column-start: 11;\n  }\n  .xl\\:col-start-12 {\n    grid-column-start: 12;\n  }\n  .xl\\:col-start-13 {\n    grid-column-start: 13;\n  }\n  .xl\\:col-start-auto {\n    grid-column-start: auto;\n  }\n  .xl\\:col-end-1 {\n    grid-column-end: 1;\n  }\n  .xl\\:col-end-2 {\n    grid-column-end: 2;\n  }\n  .xl\\:col-end-3 {\n    grid-column-end: 3;\n  }\n  .xl\\:col-end-4 {\n    grid-column-end: 4;\n  }\n  .xl\\:col-end-5 {\n    grid-column-end: 5;\n  }\n  .xl\\:col-end-6 {\n    grid-column-end: 6;\n  }\n  .xl\\:col-end-7 {\n    grid-column-end: 7;\n  }\n  .xl\\:col-end-8 {\n    grid-column-end: 8;\n  }\n  .xl\\:col-end-9 {\n    grid-column-end: 9;\n  }\n  .xl\\:col-end-10 {\n    grid-column-end: 10;\n  }\n  .xl\\:col-end-11 {\n    grid-column-end: 11;\n  }\n  .xl\\:col-end-12 {\n    grid-column-end: 12;\n  }\n  .xl\\:col-end-13 {\n    grid-column-end: 13;\n  }\n  .xl\\:col-end-auto {\n    grid-column-end: auto;\n  }\n  .xl\\:grid-rows-1 {\n    grid-template-rows: repeat(1, minmax(0, 1fr));\n  }\n  .xl\\:grid-rows-2 {\n    grid-template-rows: repeat(2, minmax(0, 1fr));\n  }\n  .xl\\:grid-rows-3 {\n    grid-template-rows: repeat(3, minmax(0, 1fr));\n  }\n  .xl\\:grid-rows-4 {\n    grid-template-rows: repeat(4, minmax(0, 1fr));\n  }\n  .xl\\:grid-rows-5 {\n    grid-template-rows: repeat(5, minmax(0, 1fr));\n  }\n  .xl\\:grid-rows-6 {\n    grid-template-rows: repeat(6, minmax(0, 1fr));\n  }\n  .xl\\:grid-rows-none {\n    grid-template-rows: none;\n  }\n  .xl\\:auto-rows-auto {\n    grid-auto-rows: auto;\n  }\n  .xl\\:auto-rows-min {\n    grid-auto-rows: min-content;\n  }\n  .xl\\:auto-rows-max {\n    grid-auto-rows: max-content;\n  }\n  .xl\\:auto-rows-fr {\n    grid-auto-rows: minmax(0, 1fr);\n  }\n  .xl\\:row-auto {\n    grid-row: auto;\n  }\n  .xl\\:row-span-1 {\n    grid-row: span 1 / span 1;\n  }\n  .xl\\:row-span-2 {\n    grid-row: span 2 / span 2;\n  }\n  .xl\\:row-span-3 {\n    grid-row: span 3 / span 3;\n  }\n  .xl\\:row-span-4 {\n    grid-row: span 4 / span 4;\n  }\n  .xl\\:row-span-5 {\n    grid-row: span 5 / span 5;\n  }\n  .xl\\:row-span-6 {\n    grid-row: span 6 / span 6;\n  }\n  .xl\\:row-span-full {\n    grid-row: 1 / -1;\n  }\n  .xl\\:row-start-1 {\n    grid-row-start: 1;\n  }\n  .xl\\:row-start-2 {\n    grid-row-start: 2;\n  }\n  .xl\\:row-start-3 {\n    grid-row-start: 3;\n  }\n  .xl\\:row-start-4 {\n    grid-row-start: 4;\n  }\n  .xl\\:row-start-5 {\n    grid-row-start: 5;\n  }\n  .xl\\:row-start-6 {\n    grid-row-start: 6;\n  }\n  .xl\\:row-start-7 {\n    grid-row-start: 7;\n  }\n  .xl\\:row-start-auto {\n    grid-row-start: auto;\n  }\n  .xl\\:row-end-1 {\n    grid-row-end: 1;\n  }\n  .xl\\:row-end-2 {\n    grid-row-end: 2;\n  }\n  .xl\\:row-end-3 {\n    grid-row-end: 3;\n  }\n  .xl\\:row-end-4 {\n    grid-row-end: 4;\n  }\n  .xl\\:row-end-5 {\n    grid-row-end: 5;\n  }\n  .xl\\:row-end-6 {\n    grid-row-end: 6;\n  }\n  .xl\\:row-end-7 {\n    grid-row-end: 7;\n  }\n  .xl\\:row-end-auto {\n    grid-row-end: auto;\n  }\n  .xl\\:transform {\n    --transform-translate-x: 0;\n    --transform-translate-y: 0;\n    --transform-rotate: 0;\n    --transform-skew-x: 0;\n    --transform-skew-y: 0;\n    --transform-scale-x: 1;\n    --transform-scale-y: 1;\n    transform: translateX(var(--transform-translate-x)) translateY(var(--transform-translate-y)) rotate(var(--transform-rotate)) skewX(var(--transform-skew-x)) skewY(var(--transform-skew-y)) scaleX(var(--transform-scale-x)) scaleY(var(--transform-scale-y));\n  }\n  .xl\\:transform-none {\n    transform: none;\n  }\n  .xl\\:origin-center {\n    transform-origin: center;\n  }\n  .xl\\:origin-top {\n    transform-origin: top;\n  }\n  .xl\\:origin-top-right {\n    transform-origin: top right;\n  }\n  .xl\\:origin-right {\n    transform-origin: right;\n  }\n  .xl\\:origin-bottom-right {\n    transform-origin: bottom right;\n  }\n  .xl\\:origin-bottom {\n    transform-origin: bottom;\n  }\n  .xl\\:origin-bottom-left {\n    transform-origin: bottom left;\n  }\n  .xl\\:origin-left {\n    transform-origin: left;\n  }\n  .xl\\:origin-top-left {\n    transform-origin: top left;\n  }\n  .xl\\:scale-0 {\n    --transform-scale-x: 0;\n    --transform-scale-y: 0;\n  }\n  .xl\\:scale-50 {\n    --transform-scale-x: .5;\n    --transform-scale-y: .5;\n  }\n  .xl\\:scale-75 {\n    --transform-scale-x: .75;\n    --transform-scale-y: .75;\n  }\n  .xl\\:scale-90 {\n    --transform-scale-x: .9;\n    --transform-scale-y: .9;\n  }\n  .xl\\:scale-95 {\n    --transform-scale-x: .95;\n    --transform-scale-y: .95;\n  }\n  .xl\\:scale-100 {\n    --transform-scale-x: 1;\n    --transform-scale-y: 1;\n  }\n  .xl\\:scale-105 {\n    --transform-scale-x: 1.05;\n    --transform-scale-y: 1.05;\n  }\n  .xl\\:scale-110 {\n    --transform-scale-x: 1.1;\n    --transform-scale-y: 1.1;\n  }\n  .xl\\:scale-125 {\n    --transform-scale-x: 1.25;\n    --transform-scale-y: 1.25;\n  }\n  .xl\\:scale-150 {\n    --transform-scale-x: 1.5;\n    --transform-scale-y: 1.5;\n  }\n  .xl\\:scale-x-0 {\n    --transform-scale-x: 0;\n  }\n  .xl\\:scale-x-50 {\n    --transform-scale-x: .5;\n  }\n  .xl\\:scale-x-75 {\n    --transform-scale-x: .75;\n  }\n  .xl\\:scale-x-90 {\n    --transform-scale-x: .9;\n  }\n  .xl\\:scale-x-95 {\n    --transform-scale-x: .95;\n  }\n  .xl\\:scale-x-100 {\n    --transform-scale-x: 1;\n  }\n  .xl\\:scale-x-105 {\n    --transform-scale-x: 1.05;\n  }\n  .xl\\:scale-x-110 {\n    --transform-scale-x: 1.1;\n  }\n  .xl\\:scale-x-125 {\n    --transform-scale-x: 1.25;\n  }\n  .xl\\:scale-x-150 {\n    --transform-scale-x: 1.5;\n  }\n  .xl\\:scale-y-0 {\n    --transform-scale-y: 0;\n  }\n  .xl\\:scale-y-50 {\n    --transform-scale-y: .5;\n  }\n  .xl\\:scale-y-75 {\n    --transform-scale-y: .75;\n  }\n  .xl\\:scale-y-90 {\n    --transform-scale-y: .9;\n  }\n  .xl\\:scale-y-95 {\n    --transform-scale-y: .95;\n  }\n  .xl\\:scale-y-100 {\n    --transform-scale-y: 1;\n  }\n  .xl\\:scale-y-105 {\n    --transform-scale-y: 1.05;\n  }\n  .xl\\:scale-y-110 {\n    --transform-scale-y: 1.1;\n  }\n  .xl\\:scale-y-125 {\n    --transform-scale-y: 1.25;\n  }\n  .xl\\:scale-y-150 {\n    --transform-scale-y: 1.5;\n  }\n  .xl\\:hover\\:scale-0:hover {\n    --transform-scale-x: 0;\n    --transform-scale-y: 0;\n  }\n  .xl\\:hover\\:scale-50:hover {\n    --transform-scale-x: .5;\n    --transform-scale-y: .5;\n  }\n  .xl\\:hover\\:scale-75:hover {\n    --transform-scale-x: .75;\n    --transform-scale-y: .75;\n  }\n  .xl\\:hover\\:scale-90:hover {\n    --transform-scale-x: .9;\n    --transform-scale-y: .9;\n  }\n  .xl\\:hover\\:scale-95:hover {\n    --transform-scale-x: .95;\n    --transform-scale-y: .95;\n  }\n  .xl\\:hover\\:scale-100:hover {\n    --transform-scale-x: 1;\n    --transform-scale-y: 1;\n  }\n  .xl\\:hover\\:scale-105:hover {\n    --transform-scale-x: 1.05;\n    --transform-scale-y: 1.05;\n  }\n  .xl\\:hover\\:scale-110:hover {\n    --transform-scale-x: 1.1;\n    --transform-scale-y: 1.1;\n  }\n  .xl\\:hover\\:scale-125:hover {\n    --transform-scale-x: 1.25;\n    --transform-scale-y: 1.25;\n  }\n  .xl\\:hover\\:scale-150:hover {\n    --transform-scale-x: 1.5;\n    --transform-scale-y: 1.5;\n  }\n  .xl\\:hover\\:scale-x-0:hover {\n    --transform-scale-x: 0;\n  }\n  .xl\\:hover\\:scale-x-50:hover {\n    --transform-scale-x: .5;\n  }\n  .xl\\:hover\\:scale-x-75:hover {\n    --transform-scale-x: .75;\n  }\n  .xl\\:hover\\:scale-x-90:hover {\n    --transform-scale-x: .9;\n  }\n  .xl\\:hover\\:scale-x-95:hover {\n    --transform-scale-x: .95;\n  }\n  .xl\\:hover\\:scale-x-100:hover {\n    --transform-scale-x: 1;\n  }\n  .xl\\:hover\\:scale-x-105:hover {\n    --transform-scale-x: 1.05;\n  }\n  .xl\\:hover\\:scale-x-110:hover {\n    --transform-scale-x: 1.1;\n  }\n  .xl\\:hover\\:scale-x-125:hover {\n    --transform-scale-x: 1.25;\n  }\n  .xl\\:hover\\:scale-x-150:hover {\n    --transform-scale-x: 1.5;\n  }\n  .xl\\:hover\\:scale-y-0:hover {\n    --transform-scale-y: 0;\n  }\n  .xl\\:hover\\:scale-y-50:hover {\n    --transform-scale-y: .5;\n  }\n  .xl\\:hover\\:scale-y-75:hover {\n    --transform-scale-y: .75;\n  }\n  .xl\\:hover\\:scale-y-90:hover {\n    --transform-scale-y: .9;\n  }\n  .xl\\:hover\\:scale-y-95:hover {\n    --transform-scale-y: .95;\n  }\n  .xl\\:hover\\:scale-y-100:hover {\n    --transform-scale-y: 1;\n  }\n  .xl\\:hover\\:scale-y-105:hover {\n    --transform-scale-y: 1.05;\n  }\n  .xl\\:hover\\:scale-y-110:hover {\n    --transform-scale-y: 1.1;\n  }\n  .xl\\:hover\\:scale-y-125:hover {\n    --transform-scale-y: 1.25;\n  }\n  .xl\\:hover\\:scale-y-150:hover {\n    --transform-scale-y: 1.5;\n  }\n  .xl\\:focus\\:scale-0:focus {\n    --transform-scale-x: 0;\n    --transform-scale-y: 0;\n  }\n  .xl\\:focus\\:scale-50:focus {\n    --transform-scale-x: .5;\n    --transform-scale-y: .5;\n  }\n  .xl\\:focus\\:scale-75:focus {\n    --transform-scale-x: .75;\n    --transform-scale-y: .75;\n  }\n  .xl\\:focus\\:scale-90:focus {\n    --transform-scale-x: .9;\n    --transform-scale-y: .9;\n  }\n  .xl\\:focus\\:scale-95:focus {\n    --transform-scale-x: .95;\n    --transform-scale-y: .95;\n  }\n  .xl\\:focus\\:scale-100:focus {\n    --transform-scale-x: 1;\n    --transform-scale-y: 1;\n  }\n  .xl\\:focus\\:scale-105:focus {\n    --transform-scale-x: 1.05;\n    --transform-scale-y: 1.05;\n  }\n  .xl\\:focus\\:scale-110:focus {\n    --transform-scale-x: 1.1;\n    --transform-scale-y: 1.1;\n  }\n  .xl\\:focus\\:scale-125:focus {\n    --transform-scale-x: 1.25;\n    --transform-scale-y: 1.25;\n  }\n  .xl\\:focus\\:scale-150:focus {\n    --transform-scale-x: 1.5;\n    --transform-scale-y: 1.5;\n  }\n  .xl\\:focus\\:scale-x-0:focus {\n    --transform-scale-x: 0;\n  }\n  .xl\\:focus\\:scale-x-50:focus {\n    --transform-scale-x: .5;\n  }\n  .xl\\:focus\\:scale-x-75:focus {\n    --transform-scale-x: .75;\n  }\n  .xl\\:focus\\:scale-x-90:focus {\n    --transform-scale-x: .9;\n  }\n  .xl\\:focus\\:scale-x-95:focus {\n    --transform-scale-x: .95;\n  }\n  .xl\\:focus\\:scale-x-100:focus {\n    --transform-scale-x: 1;\n  }\n  .xl\\:focus\\:scale-x-105:focus {\n    --transform-scale-x: 1.05;\n  }\n  .xl\\:focus\\:scale-x-110:focus {\n    --transform-scale-x: 1.1;\n  }\n  .xl\\:focus\\:scale-x-125:focus {\n    --transform-scale-x: 1.25;\n  }\n  .xl\\:focus\\:scale-x-150:focus {\n    --transform-scale-x: 1.5;\n  }\n  .xl\\:focus\\:scale-y-0:focus {\n    --transform-scale-y: 0;\n  }\n  .xl\\:focus\\:scale-y-50:focus {\n    --transform-scale-y: .5;\n  }\n  .xl\\:focus\\:scale-y-75:focus {\n    --transform-scale-y: .75;\n  }\n  .xl\\:focus\\:scale-y-90:focus {\n    --transform-scale-y: .9;\n  }\n  .xl\\:focus\\:scale-y-95:focus {\n    --transform-scale-y: .95;\n  }\n  .xl\\:focus\\:scale-y-100:focus {\n    --transform-scale-y: 1;\n  }\n  .xl\\:focus\\:scale-y-105:focus {\n    --transform-scale-y: 1.05;\n  }\n  .xl\\:focus\\:scale-y-110:focus {\n    --transform-scale-y: 1.1;\n  }\n  .xl\\:focus\\:scale-y-125:focus {\n    --transform-scale-y: 1.25;\n  }\n  .xl\\:focus\\:scale-y-150:focus {\n    --transform-scale-y: 1.5;\n  }\n  .xl\\:rotate-0 {\n    --transform-rotate: 0;\n  }\n  .xl\\:rotate-1 {\n    --transform-rotate: 1deg;\n  }\n  .xl\\:rotate-2 {\n    --transform-rotate: 2deg;\n  }\n  .xl\\:rotate-3 {\n    --transform-rotate: 3deg;\n  }\n  .xl\\:rotate-6 {\n    --transform-rotate: 6deg;\n  }\n  .xl\\:rotate-12 {\n    --transform-rotate: 12deg;\n  }\n  .xl\\:rotate-45 {\n    --transform-rotate: 45deg;\n  }\n  .xl\\:rotate-90 {\n    --transform-rotate: 90deg;\n  }\n  .xl\\:rotate-180 {\n    --transform-rotate: 180deg;\n  }\n  .xl\\:-rotate-180 {\n    --transform-rotate: -180deg;\n  }\n  .xl\\:-rotate-90 {\n    --transform-rotate: -90deg;\n  }\n  .xl\\:-rotate-45 {\n    --transform-rotate: -45deg;\n  }\n  .xl\\:-rotate-12 {\n    --transform-rotate: -12deg;\n  }\n  .xl\\:-rotate-6 {\n    --transform-rotate: -6deg;\n  }\n  .xl\\:-rotate-3 {\n    --transform-rotate: -3deg;\n  }\n  .xl\\:-rotate-2 {\n    --transform-rotate: -2deg;\n  }\n  .xl\\:-rotate-1 {\n    --transform-rotate: -1deg;\n  }\n  .xl\\:hover\\:rotate-0:hover {\n    --transform-rotate: 0;\n  }\n  .xl\\:hover\\:rotate-1:hover {\n    --transform-rotate: 1deg;\n  }\n  .xl\\:hover\\:rotate-2:hover {\n    --transform-rotate: 2deg;\n  }\n  .xl\\:hover\\:rotate-3:hover {\n    --transform-rotate: 3deg;\n  }\n  .xl\\:hover\\:rotate-6:hover {\n    --transform-rotate: 6deg;\n  }\n  .xl\\:hover\\:rotate-12:hover {\n    --transform-rotate: 12deg;\n  }\n  .xl\\:hover\\:rotate-45:hover {\n    --transform-rotate: 45deg;\n  }\n  .xl\\:hover\\:rotate-90:hover {\n    --transform-rotate: 90deg;\n  }\n  .xl\\:hover\\:rotate-180:hover {\n    --transform-rotate: 180deg;\n  }\n  .xl\\:hover\\:-rotate-180:hover {\n    --transform-rotate: -180deg;\n  }\n  .xl\\:hover\\:-rotate-90:hover {\n    --transform-rotate: -90deg;\n  }\n  .xl\\:hover\\:-rotate-45:hover {\n    --transform-rotate: -45deg;\n  }\n  .xl\\:hover\\:-rotate-12:hover {\n    --transform-rotate: -12deg;\n  }\n  .xl\\:hover\\:-rotate-6:hover {\n    --transform-rotate: -6deg;\n  }\n  .xl\\:hover\\:-rotate-3:hover {\n    --transform-rotate: -3deg;\n  }\n  .xl\\:hover\\:-rotate-2:hover {\n    --transform-rotate: -2deg;\n  }\n  .xl\\:hover\\:-rotate-1:hover {\n    --transform-rotate: -1deg;\n  }\n  .xl\\:focus\\:rotate-0:focus {\n    --transform-rotate: 0;\n  }\n  .xl\\:focus\\:rotate-1:focus {\n    --transform-rotate: 1deg;\n  }\n  .xl\\:focus\\:rotate-2:focus {\n    --transform-rotate: 2deg;\n  }\n  .xl\\:focus\\:rotate-3:focus {\n    --transform-rotate: 3deg;\n  }\n  .xl\\:focus\\:rotate-6:focus {\n    --transform-rotate: 6deg;\n  }\n  .xl\\:focus\\:rotate-12:focus {\n    --transform-rotate: 12deg;\n  }\n  .xl\\:focus\\:rotate-45:focus {\n    --transform-rotate: 45deg;\n  }\n  .xl\\:focus\\:rotate-90:focus {\n    --transform-rotate: 90deg;\n  }\n  .xl\\:focus\\:rotate-180:focus {\n    --transform-rotate: 180deg;\n  }\n  .xl\\:focus\\:-rotate-180:focus {\n    --transform-rotate: -180deg;\n  }\n  .xl\\:focus\\:-rotate-90:focus {\n    --transform-rotate: -90deg;\n  }\n  .xl\\:focus\\:-rotate-45:focus {\n    --transform-rotate: -45deg;\n  }\n  .xl\\:focus\\:-rotate-12:focus {\n    --transform-rotate: -12deg;\n  }\n  .xl\\:focus\\:-rotate-6:focus {\n    --transform-rotate: -6deg;\n  }\n  .xl\\:focus\\:-rotate-3:focus {\n    --transform-rotate: -3deg;\n  }\n  .xl\\:focus\\:-rotate-2:focus {\n    --transform-rotate: -2deg;\n  }\n  .xl\\:focus\\:-rotate-1:focus {\n    --transform-rotate: -1deg;\n  }\n  .xl\\:translate-x-0 {\n    --transform-translate-x: 0;\n  }\n  .xl\\:translate-x-1 {\n    --transform-translate-x: 0.25rem;\n  }\n  .xl\\:translate-x-2 {\n    --transform-translate-x: 0.5rem;\n  }\n  .xl\\:translate-x-3 {\n    --transform-translate-x: 0.75rem;\n  }\n  .xl\\:translate-x-4 {\n    --transform-translate-x: 1rem;\n  }\n  .xl\\:translate-x-5 {\n    --transform-translate-x: 1.25rem;\n  }\n  .xl\\:translate-x-6 {\n    --transform-translate-x: 1.5rem;\n  }\n  .xl\\:translate-x-7 {\n    --transform-translate-x: 1.75rem;\n  }\n  .xl\\:translate-x-8 {\n    --transform-translate-x: 2rem;\n  }\n  .xl\\:translate-x-9 {\n    --transform-translate-x: 2.25rem;\n  }\n  .xl\\:translate-x-10 {\n    --transform-translate-x: 2.5rem;\n  }\n  .xl\\:translate-x-11 {\n    --transform-translate-x: 2.75rem;\n  }\n  .xl\\:translate-x-12 {\n    --transform-translate-x: 3rem;\n  }\n  .xl\\:translate-x-13 {\n    --transform-translate-x: 3.25rem;\n  }\n  .xl\\:translate-x-14 {\n    --transform-translate-x: 3.5rem;\n  }\n  .xl\\:translate-x-15 {\n    --transform-translate-x: 3.75rem;\n  }\n  .xl\\:translate-x-16 {\n    --transform-translate-x: 4rem;\n  }\n  .xl\\:translate-x-20 {\n    --transform-translate-x: 5rem;\n  }\n  .xl\\:translate-x-24 {\n    --transform-translate-x: 6rem;\n  }\n  .xl\\:translate-x-28 {\n    --transform-translate-x: 7rem;\n  }\n  .xl\\:translate-x-32 {\n    --transform-translate-x: 8rem;\n  }\n  .xl\\:translate-x-36 {\n    --transform-translate-x: 9rem;\n  }\n  .xl\\:translate-x-40 {\n    --transform-translate-x: 10rem;\n  }\n  .xl\\:translate-x-44 {\n    --transform-translate-x: 11rem;\n  }\n  .xl\\:translate-x-48 {\n    --transform-translate-x: 12rem;\n  }\n  .xl\\:translate-x-52 {\n    --transform-translate-x: 13rem;\n  }\n  .xl\\:translate-x-56 {\n    --transform-translate-x: 14rem;\n  }\n  .xl\\:translate-x-60 {\n    --transform-translate-x: 15rem;\n  }\n  .xl\\:translate-x-64 {\n    --transform-translate-x: 16rem;\n  }\n  .xl\\:translate-x-72 {\n    --transform-translate-x: 18rem;\n  }\n  .xl\\:translate-x-80 {\n    --transform-translate-x: 20rem;\n  }\n  .xl\\:translate-x-96 {\n    --transform-translate-x: 24rem;\n  }\n  .xl\\:translate-x-px {\n    --transform-translate-x: 1px;\n  }\n  .xl\\:translate-x-0\\.5 {\n    --transform-translate-x: 0.125rem;\n  }\n  .xl\\:translate-x-1\\.5 {\n    --transform-translate-x: 0.375rem;\n  }\n  .xl\\:translate-x-2\\.5 {\n    --transform-translate-x: 0.625rem;\n  }\n  .xl\\:translate-x-3\\.5 {\n    --transform-translate-x: 0.875rem;\n  }\n  .xl\\:translate-x-1\\/2 {\n    --transform-translate-x: 50%;\n  }\n  .xl\\:translate-x-1\\/3 {\n    --transform-translate-x: 33.333333%;\n  }\n  .xl\\:translate-x-2\\/3 {\n    --transform-translate-x: 66.666667%;\n  }\n  .xl\\:translate-x-1\\/4 {\n    --transform-translate-x: 25%;\n  }\n  .xl\\:translate-x-2\\/4 {\n    --transform-translate-x: 50%;\n  }\n  .xl\\:translate-x-3\\/4 {\n    --transform-translate-x: 75%;\n  }\n  .xl\\:translate-x-1\\/5 {\n    --transform-translate-x: 20%;\n  }\n  .xl\\:translate-x-2\\/5 {\n    --transform-translate-x: 40%;\n  }\n  .xl\\:translate-x-3\\/5 {\n    --transform-translate-x: 60%;\n  }\n  .xl\\:translate-x-4\\/5 {\n    --transform-translate-x: 80%;\n  }\n  .xl\\:translate-x-1\\/6 {\n    --transform-translate-x: 16.666667%;\n  }\n  .xl\\:translate-x-2\\/6 {\n    --transform-translate-x: 33.333333%;\n  }\n  .xl\\:translate-x-3\\/6 {\n    --transform-translate-x: 50%;\n  }\n  .xl\\:translate-x-4\\/6 {\n    --transform-translate-x: 66.666667%;\n  }\n  .xl\\:translate-x-5\\/6 {\n    --transform-translate-x: 83.333333%;\n  }\n  .xl\\:translate-x-1\\/12 {\n    --transform-translate-x: 8.333333%;\n  }\n  .xl\\:translate-x-2\\/12 {\n    --transform-translate-x: 16.666667%;\n  }\n  .xl\\:translate-x-3\\/12 {\n    --transform-translate-x: 25%;\n  }\n  .xl\\:translate-x-4\\/12 {\n    --transform-translate-x: 33.333333%;\n  }\n  .xl\\:translate-x-5\\/12 {\n    --transform-translate-x: 41.666667%;\n  }\n  .xl\\:translate-x-6\\/12 {\n    --transform-translate-x: 50%;\n  }\n  .xl\\:translate-x-7\\/12 {\n    --transform-translate-x: 58.333333%;\n  }\n  .xl\\:translate-x-8\\/12 {\n    --transform-translate-x: 66.666667%;\n  }\n  .xl\\:translate-x-9\\/12 {\n    --transform-translate-x: 75%;\n  }\n  .xl\\:translate-x-10\\/12 {\n    --transform-translate-x: 83.333333%;\n  }\n  .xl\\:translate-x-11\\/12 {\n    --transform-translate-x: 91.666667%;\n  }\n  .xl\\:translate-x-full {\n    --transform-translate-x: 100%;\n  }\n  .xl\\:-translate-x-1 {\n    --transform-translate-x: -0.25rem;\n  }\n  .xl\\:-translate-x-2 {\n    --transform-translate-x: -0.5rem;\n  }\n  .xl\\:-translate-x-3 {\n    --transform-translate-x: -0.75rem;\n  }\n  .xl\\:-translate-x-4 {\n    --transform-translate-x: -1rem;\n  }\n  .xl\\:-translate-x-5 {\n    --transform-translate-x: -1.25rem;\n  }\n  .xl\\:-translate-x-6 {\n    --transform-translate-x: -1.5rem;\n  }\n  .xl\\:-translate-x-7 {\n    --transform-translate-x: -1.75rem;\n  }\n  .xl\\:-translate-x-8 {\n    --transform-translate-x: -2rem;\n  }\n  .xl\\:-translate-x-9 {\n    --transform-translate-x: -2.25rem;\n  }\n  .xl\\:-translate-x-10 {\n    --transform-translate-x: -2.5rem;\n  }\n  .xl\\:-translate-x-11 {\n    --transform-translate-x: -2.75rem;\n  }\n  .xl\\:-translate-x-12 {\n    --transform-translate-x: -3rem;\n  }\n  .xl\\:-translate-x-13 {\n    --transform-translate-x: -3.25rem;\n  }\n  .xl\\:-translate-x-14 {\n    --transform-translate-x: -3.5rem;\n  }\n  .xl\\:-translate-x-15 {\n    --transform-translate-x: -3.75rem;\n  }\n  .xl\\:-translate-x-16 {\n    --transform-translate-x: -4rem;\n  }\n  .xl\\:-translate-x-20 {\n    --transform-translate-x: -5rem;\n  }\n  .xl\\:-translate-x-24 {\n    --transform-translate-x: -6rem;\n  }\n  .xl\\:-translate-x-28 {\n    --transform-translate-x: -7rem;\n  }\n  .xl\\:-translate-x-32 {\n    --transform-translate-x: -8rem;\n  }\n  .xl\\:-translate-x-36 {\n    --transform-translate-x: -9rem;\n  }\n  .xl\\:-translate-x-40 {\n    --transform-translate-x: -10rem;\n  }\n  .xl\\:-translate-x-44 {\n    --transform-translate-x: -11rem;\n  }\n  .xl\\:-translate-x-48 {\n    --transform-translate-x: -12rem;\n  }\n  .xl\\:-translate-x-52 {\n    --transform-translate-x: -13rem;\n  }\n  .xl\\:-translate-x-56 {\n    --transform-translate-x: -14rem;\n  }\n  .xl\\:-translate-x-60 {\n    --transform-translate-x: -15rem;\n  }\n  .xl\\:-translate-x-64 {\n    --transform-translate-x: -16rem;\n  }\n  .xl\\:-translate-x-72 {\n    --transform-translate-x: -18rem;\n  }\n  .xl\\:-translate-x-80 {\n    --transform-translate-x: -20rem;\n  }\n  .xl\\:-translate-x-96 {\n    --transform-translate-x: -24rem;\n  }\n  .xl\\:-translate-x-px {\n    --transform-translate-x: -1px;\n  }\n  .xl\\:-translate-x-0\\.5 {\n    --transform-translate-x: -0.125rem;\n  }\n  .xl\\:-translate-x-1\\.5 {\n    --transform-translate-x: -0.375rem;\n  }\n  .xl\\:-translate-x-2\\.5 {\n    --transform-translate-x: -0.625rem;\n  }\n  .xl\\:-translate-x-3\\.5 {\n    --transform-translate-x: -0.875rem;\n  }\n  .xl\\:-translate-x-1\\/2 {\n    --transform-translate-x: -50%;\n  }\n  .xl\\:-translate-x-1\\/3 {\n    --transform-translate-x: -33.33333%;\n  }\n  .xl\\:-translate-x-2\\/3 {\n    --transform-translate-x: -66.66667%;\n  }\n  .xl\\:-translate-x-1\\/4 {\n    --transform-translate-x: -25%;\n  }\n  .xl\\:-translate-x-2\\/4 {\n    --transform-translate-x: -50%;\n  }\n  .xl\\:-translate-x-3\\/4 {\n    --transform-translate-x: -75%;\n  }\n  .xl\\:-translate-x-1\\/5 {\n    --transform-translate-x: -20%;\n  }\n  .xl\\:-translate-x-2\\/5 {\n    --transform-translate-x: -40%;\n  }\n  .xl\\:-translate-x-3\\/5 {\n    --transform-translate-x: -60%;\n  }\n  .xl\\:-translate-x-4\\/5 {\n    --transform-translate-x: -80%;\n  }\n  .xl\\:-translate-x-1\\/6 {\n    --transform-translate-x: -16.66667%;\n  }\n  .xl\\:-translate-x-2\\/6 {\n    --transform-translate-x: -33.33333%;\n  }\n  .xl\\:-translate-x-3\\/6 {\n    --transform-translate-x: -50%;\n  }\n  .xl\\:-translate-x-4\\/6 {\n    --transform-translate-x: -66.66667%;\n  }\n  .xl\\:-translate-x-5\\/6 {\n    --transform-translate-x: -83.33333%;\n  }\n  .xl\\:-translate-x-1\\/12 {\n    --transform-translate-x: -8.33333%;\n  }\n  .xl\\:-translate-x-2\\/12 {\n    --transform-translate-x: -16.66667%;\n  }\n  .xl\\:-translate-x-3\\/12 {\n    --transform-translate-x: -25%;\n  }\n  .xl\\:-translate-x-4\\/12 {\n    --transform-translate-x: -33.33333%;\n  }\n  .xl\\:-translate-x-5\\/12 {\n    --transform-translate-x: -41.66667%;\n  }\n  .xl\\:-translate-x-6\\/12 {\n    --transform-translate-x: -50%;\n  }\n  .xl\\:-translate-x-7\\/12 {\n    --transform-translate-x: -58.33333%;\n  }\n  .xl\\:-translate-x-8\\/12 {\n    --transform-translate-x: -66.66667%;\n  }\n  .xl\\:-translate-x-9\\/12 {\n    --transform-translate-x: -75%;\n  }\n  .xl\\:-translate-x-10\\/12 {\n    --transform-translate-x: -83.33333%;\n  }\n  .xl\\:-translate-x-11\\/12 {\n    --transform-translate-x: -91.66667%;\n  }\n  .xl\\:-translate-x-full {\n    --transform-translate-x: -100%;\n  }\n  .xl\\:translate-y-0 {\n    --transform-translate-y: 0;\n  }\n  .xl\\:translate-y-1 {\n    --transform-translate-y: 0.25rem;\n  }\n  .xl\\:translate-y-2 {\n    --transform-translate-y: 0.5rem;\n  }\n  .xl\\:translate-y-3 {\n    --transform-translate-y: 0.75rem;\n  }\n  .xl\\:translate-y-4 {\n    --transform-translate-y: 1rem;\n  }\n  .xl\\:translate-y-5 {\n    --transform-translate-y: 1.25rem;\n  }\n  .xl\\:translate-y-6 {\n    --transform-translate-y: 1.5rem;\n  }\n  .xl\\:translate-y-7 {\n    --transform-translate-y: 1.75rem;\n  }\n  .xl\\:translate-y-8 {\n    --transform-translate-y: 2rem;\n  }\n  .xl\\:translate-y-9 {\n    --transform-translate-y: 2.25rem;\n  }\n  .xl\\:translate-y-10 {\n    --transform-translate-y: 2.5rem;\n  }\n  .xl\\:translate-y-11 {\n    --transform-translate-y: 2.75rem;\n  }\n  .xl\\:translate-y-12 {\n    --transform-translate-y: 3rem;\n  }\n  .xl\\:translate-y-13 {\n    --transform-translate-y: 3.25rem;\n  }\n  .xl\\:translate-y-14 {\n    --transform-translate-y: 3.5rem;\n  }\n  .xl\\:translate-y-15 {\n    --transform-translate-y: 3.75rem;\n  }\n  .xl\\:translate-y-16 {\n    --transform-translate-y: 4rem;\n  }\n  .xl\\:translate-y-20 {\n    --transform-translate-y: 5rem;\n  }\n  .xl\\:translate-y-24 {\n    --transform-translate-y: 6rem;\n  }\n  .xl\\:translate-y-28 {\n    --transform-translate-y: 7rem;\n  }\n  .xl\\:translate-y-32 {\n    --transform-translate-y: 8rem;\n  }\n  .xl\\:translate-y-36 {\n    --transform-translate-y: 9rem;\n  }\n  .xl\\:translate-y-40 {\n    --transform-translate-y: 10rem;\n  }\n  .xl\\:translate-y-44 {\n    --transform-translate-y: 11rem;\n  }\n  .xl\\:translate-y-48 {\n    --transform-translate-y: 12rem;\n  }\n  .xl\\:translate-y-52 {\n    --transform-translate-y: 13rem;\n  }\n  .xl\\:translate-y-56 {\n    --transform-translate-y: 14rem;\n  }\n  .xl\\:translate-y-60 {\n    --transform-translate-y: 15rem;\n  }\n  .xl\\:translate-y-64 {\n    --transform-translate-y: 16rem;\n  }\n  .xl\\:translate-y-72 {\n    --transform-translate-y: 18rem;\n  }\n  .xl\\:translate-y-80 {\n    --transform-translate-y: 20rem;\n  }\n  .xl\\:translate-y-96 {\n    --transform-translate-y: 24rem;\n  }\n  .xl\\:translate-y-px {\n    --transform-translate-y: 1px;\n  }\n  .xl\\:translate-y-0\\.5 {\n    --transform-translate-y: 0.125rem;\n  }\n  .xl\\:translate-y-1\\.5 {\n    --transform-translate-y: 0.375rem;\n  }\n  .xl\\:translate-y-2\\.5 {\n    --transform-translate-y: 0.625rem;\n  }\n  .xl\\:translate-y-3\\.5 {\n    --transform-translate-y: 0.875rem;\n  }\n  .xl\\:translate-y-1\\/2 {\n    --transform-translate-y: 50%;\n  }\n  .xl\\:translate-y-1\\/3 {\n    --transform-translate-y: 33.333333%;\n  }\n  .xl\\:translate-y-2\\/3 {\n    --transform-translate-y: 66.666667%;\n  }\n  .xl\\:translate-y-1\\/4 {\n    --transform-translate-y: 25%;\n  }\n  .xl\\:translate-y-2\\/4 {\n    --transform-translate-y: 50%;\n  }\n  .xl\\:translate-y-3\\/4 {\n    --transform-translate-y: 75%;\n  }\n  .xl\\:translate-y-1\\/5 {\n    --transform-translate-y: 20%;\n  }\n  .xl\\:translate-y-2\\/5 {\n    --transform-translate-y: 40%;\n  }\n  .xl\\:translate-y-3\\/5 {\n    --transform-translate-y: 60%;\n  }\n  .xl\\:translate-y-4\\/5 {\n    --transform-translate-y: 80%;\n  }\n  .xl\\:translate-y-1\\/6 {\n    --transform-translate-y: 16.666667%;\n  }\n  .xl\\:translate-y-2\\/6 {\n    --transform-translate-y: 33.333333%;\n  }\n  .xl\\:translate-y-3\\/6 {\n    --transform-translate-y: 50%;\n  }\n  .xl\\:translate-y-4\\/6 {\n    --transform-translate-y: 66.666667%;\n  }\n  .xl\\:translate-y-5\\/6 {\n    --transform-translate-y: 83.333333%;\n  }\n  .xl\\:translate-y-1\\/12 {\n    --transform-translate-y: 8.333333%;\n  }\n  .xl\\:translate-y-2\\/12 {\n    --transform-translate-y: 16.666667%;\n  }\n  .xl\\:translate-y-3\\/12 {\n    --transform-translate-y: 25%;\n  }\n  .xl\\:translate-y-4\\/12 {\n    --transform-translate-y: 33.333333%;\n  }\n  .xl\\:translate-y-5\\/12 {\n    --transform-translate-y: 41.666667%;\n  }\n  .xl\\:translate-y-6\\/12 {\n    --transform-translate-y: 50%;\n  }\n  .xl\\:translate-y-7\\/12 {\n    --transform-translate-y: 58.333333%;\n  }\n  .xl\\:translate-y-8\\/12 {\n    --transform-translate-y: 66.666667%;\n  }\n  .xl\\:translate-y-9\\/12 {\n    --transform-translate-y: 75%;\n  }\n  .xl\\:translate-y-10\\/12 {\n    --transform-translate-y: 83.333333%;\n  }\n  .xl\\:translate-y-11\\/12 {\n    --transform-translate-y: 91.666667%;\n  }\n  .xl\\:translate-y-full {\n    --transform-translate-y: 100%;\n  }\n  .xl\\:-translate-y-1 {\n    --transform-translate-y: -0.25rem;\n  }\n  .xl\\:-translate-y-2 {\n    --transform-translate-y: -0.5rem;\n  }\n  .xl\\:-translate-y-3 {\n    --transform-translate-y: -0.75rem;\n  }\n  .xl\\:-translate-y-4 {\n    --transform-translate-y: -1rem;\n  }\n  .xl\\:-translate-y-5 {\n    --transform-translate-y: -1.25rem;\n  }\n  .xl\\:-translate-y-6 {\n    --transform-translate-y: -1.5rem;\n  }\n  .xl\\:-translate-y-7 {\n    --transform-translate-y: -1.75rem;\n  }\n  .xl\\:-translate-y-8 {\n    --transform-translate-y: -2rem;\n  }\n  .xl\\:-translate-y-9 {\n    --transform-translate-y: -2.25rem;\n  }\n  .xl\\:-translate-y-10 {\n    --transform-translate-y: -2.5rem;\n  }\n  .xl\\:-translate-y-11 {\n    --transform-translate-y: -2.75rem;\n  }\n  .xl\\:-translate-y-12 {\n    --transform-translate-y: -3rem;\n  }\n  .xl\\:-translate-y-13 {\n    --transform-translate-y: -3.25rem;\n  }\n  .xl\\:-translate-y-14 {\n    --transform-translate-y: -3.5rem;\n  }\n  .xl\\:-translate-y-15 {\n    --transform-translate-y: -3.75rem;\n  }\n  .xl\\:-translate-y-16 {\n    --transform-translate-y: -4rem;\n  }\n  .xl\\:-translate-y-20 {\n    --transform-translate-y: -5rem;\n  }\n  .xl\\:-translate-y-24 {\n    --transform-translate-y: -6rem;\n  }\n  .xl\\:-translate-y-28 {\n    --transform-translate-y: -7rem;\n  }\n  .xl\\:-translate-y-32 {\n    --transform-translate-y: -8rem;\n  }\n  .xl\\:-translate-y-36 {\n    --transform-translate-y: -9rem;\n  }\n  .xl\\:-translate-y-40 {\n    --transform-translate-y: -10rem;\n  }\n  .xl\\:-translate-y-44 {\n    --transform-translate-y: -11rem;\n  }\n  .xl\\:-translate-y-48 {\n    --transform-translate-y: -12rem;\n  }\n  .xl\\:-translate-y-52 {\n    --transform-translate-y: -13rem;\n  }\n  .xl\\:-translate-y-56 {\n    --transform-translate-y: -14rem;\n  }\n  .xl\\:-translate-y-60 {\n    --transform-translate-y: -15rem;\n  }\n  .xl\\:-translate-y-64 {\n    --transform-translate-y: -16rem;\n  }\n  .xl\\:-translate-y-72 {\n    --transform-translate-y: -18rem;\n  }\n  .xl\\:-translate-y-80 {\n    --transform-translate-y: -20rem;\n  }\n  .xl\\:-translate-y-96 {\n    --transform-translate-y: -24rem;\n  }\n  .xl\\:-translate-y-px {\n    --transform-translate-y: -1px;\n  }\n  .xl\\:-translate-y-0\\.5 {\n    --transform-translate-y: -0.125rem;\n  }\n  .xl\\:-translate-y-1\\.5 {\n    --transform-translate-y: -0.375rem;\n  }\n  .xl\\:-translate-y-2\\.5 {\n    --transform-translate-y: -0.625rem;\n  }\n  .xl\\:-translate-y-3\\.5 {\n    --transform-translate-y: -0.875rem;\n  }\n  .xl\\:-translate-y-1\\/2 {\n    --transform-translate-y: -50%;\n  }\n  .xl\\:-translate-y-1\\/3 {\n    --transform-translate-y: -33.33333%;\n  }\n  .xl\\:-translate-y-2\\/3 {\n    --transform-translate-y: -66.66667%;\n  }\n  .xl\\:-translate-y-1\\/4 {\n    --transform-translate-y: -25%;\n  }\n  .xl\\:-translate-y-2\\/4 {\n    --transform-translate-y: -50%;\n  }\n  .xl\\:-translate-y-3\\/4 {\n    --transform-translate-y: -75%;\n  }\n  .xl\\:-translate-y-1\\/5 {\n    --transform-translate-y: -20%;\n  }\n  .xl\\:-translate-y-2\\/5 {\n    --transform-translate-y: -40%;\n  }\n  .xl\\:-translate-y-3\\/5 {\n    --transform-translate-y: -60%;\n  }\n  .xl\\:-translate-y-4\\/5 {\n    --transform-translate-y: -80%;\n  }\n  .xl\\:-translate-y-1\\/6 {\n    --transform-translate-y: -16.66667%;\n  }\n  .xl\\:-translate-y-2\\/6 {\n    --transform-translate-y: -33.33333%;\n  }\n  .xl\\:-translate-y-3\\/6 {\n    --transform-translate-y: -50%;\n  }\n  .xl\\:-translate-y-4\\/6 {\n    --transform-translate-y: -66.66667%;\n  }\n  .xl\\:-translate-y-5\\/6 {\n    --transform-translate-y: -83.33333%;\n  }\n  .xl\\:-translate-y-1\\/12 {\n    --transform-translate-y: -8.33333%;\n  }\n  .xl\\:-translate-y-2\\/12 {\n    --transform-translate-y: -16.66667%;\n  }\n  .xl\\:-translate-y-3\\/12 {\n    --transform-translate-y: -25%;\n  }\n  .xl\\:-translate-y-4\\/12 {\n    --transform-translate-y: -33.33333%;\n  }\n  .xl\\:-translate-y-5\\/12 {\n    --transform-translate-y: -41.66667%;\n  }\n  .xl\\:-translate-y-6\\/12 {\n    --transform-translate-y: -50%;\n  }\n  .xl\\:-translate-y-7\\/12 {\n    --transform-translate-y: -58.33333%;\n  }\n  .xl\\:-translate-y-8\\/12 {\n    --transform-translate-y: -66.66667%;\n  }\n  .xl\\:-translate-y-9\\/12 {\n    --transform-translate-y: -75%;\n  }\n  .xl\\:-translate-y-10\\/12 {\n    --transform-translate-y: -83.33333%;\n  }\n  .xl\\:-translate-y-11\\/12 {\n    --transform-translate-y: -91.66667%;\n  }\n  .xl\\:-translate-y-full {\n    --transform-translate-y: -100%;\n  }\n  .xl\\:hover\\:translate-x-0:hover {\n    --transform-translate-x: 0;\n  }\n  .xl\\:hover\\:translate-x-1:hover {\n    --transform-translate-x: 0.25rem;\n  }\n  .xl\\:hover\\:translate-x-2:hover {\n    --transform-translate-x: 0.5rem;\n  }\n  .xl\\:hover\\:translate-x-3:hover {\n    --transform-translate-x: 0.75rem;\n  }\n  .xl\\:hover\\:translate-x-4:hover {\n    --transform-translate-x: 1rem;\n  }\n  .xl\\:hover\\:translate-x-5:hover {\n    --transform-translate-x: 1.25rem;\n  }\n  .xl\\:hover\\:translate-x-6:hover {\n    --transform-translate-x: 1.5rem;\n  }\n  .xl\\:hover\\:translate-x-7:hover {\n    --transform-translate-x: 1.75rem;\n  }\n  .xl\\:hover\\:translate-x-8:hover {\n    --transform-translate-x: 2rem;\n  }\n  .xl\\:hover\\:translate-x-9:hover {\n    --transform-translate-x: 2.25rem;\n  }\n  .xl\\:hover\\:translate-x-10:hover {\n    --transform-translate-x: 2.5rem;\n  }\n  .xl\\:hover\\:translate-x-11:hover {\n    --transform-translate-x: 2.75rem;\n  }\n  .xl\\:hover\\:translate-x-12:hover {\n    --transform-translate-x: 3rem;\n  }\n  .xl\\:hover\\:translate-x-13:hover {\n    --transform-translate-x: 3.25rem;\n  }\n  .xl\\:hover\\:translate-x-14:hover {\n    --transform-translate-x: 3.5rem;\n  }\n  .xl\\:hover\\:translate-x-15:hover {\n    --transform-translate-x: 3.75rem;\n  }\n  .xl\\:hover\\:translate-x-16:hover {\n    --transform-translate-x: 4rem;\n  }\n  .xl\\:hover\\:translate-x-20:hover {\n    --transform-translate-x: 5rem;\n  }\n  .xl\\:hover\\:translate-x-24:hover {\n    --transform-translate-x: 6rem;\n  }\n  .xl\\:hover\\:translate-x-28:hover {\n    --transform-translate-x: 7rem;\n  }\n  .xl\\:hover\\:translate-x-32:hover {\n    --transform-translate-x: 8rem;\n  }\n  .xl\\:hover\\:translate-x-36:hover {\n    --transform-translate-x: 9rem;\n  }\n  .xl\\:hover\\:translate-x-40:hover {\n    --transform-translate-x: 10rem;\n  }\n  .xl\\:hover\\:translate-x-44:hover {\n    --transform-translate-x: 11rem;\n  }\n  .xl\\:hover\\:translate-x-48:hover {\n    --transform-translate-x: 12rem;\n  }\n  .xl\\:hover\\:translate-x-52:hover {\n    --transform-translate-x: 13rem;\n  }\n  .xl\\:hover\\:translate-x-56:hover {\n    --transform-translate-x: 14rem;\n  }\n  .xl\\:hover\\:translate-x-60:hover {\n    --transform-translate-x: 15rem;\n  }\n  .xl\\:hover\\:translate-x-64:hover {\n    --transform-translate-x: 16rem;\n  }\n  .xl\\:hover\\:translate-x-72:hover {\n    --transform-translate-x: 18rem;\n  }\n  .xl\\:hover\\:translate-x-80:hover {\n    --transform-translate-x: 20rem;\n  }\n  .xl\\:hover\\:translate-x-96:hover {\n    --transform-translate-x: 24rem;\n  }\n  .xl\\:hover\\:translate-x-px:hover {\n    --transform-translate-x: 1px;\n  }\n  .xl\\:hover\\:translate-x-0\\.5:hover {\n    --transform-translate-x: 0.125rem;\n  }\n  .xl\\:hover\\:translate-x-1\\.5:hover {\n    --transform-translate-x: 0.375rem;\n  }\n  .xl\\:hover\\:translate-x-2\\.5:hover {\n    --transform-translate-x: 0.625rem;\n  }\n  .xl\\:hover\\:translate-x-3\\.5:hover {\n    --transform-translate-x: 0.875rem;\n  }\n  .xl\\:hover\\:translate-x-1\\/2:hover {\n    --transform-translate-x: 50%;\n  }\n  .xl\\:hover\\:translate-x-1\\/3:hover {\n    --transform-translate-x: 33.333333%;\n  }\n  .xl\\:hover\\:translate-x-2\\/3:hover {\n    --transform-translate-x: 66.666667%;\n  }\n  .xl\\:hover\\:translate-x-1\\/4:hover {\n    --transform-translate-x: 25%;\n  }\n  .xl\\:hover\\:translate-x-2\\/4:hover {\n    --transform-translate-x: 50%;\n  }\n  .xl\\:hover\\:translate-x-3\\/4:hover {\n    --transform-translate-x: 75%;\n  }\n  .xl\\:hover\\:translate-x-1\\/5:hover {\n    --transform-translate-x: 20%;\n  }\n  .xl\\:hover\\:translate-x-2\\/5:hover {\n    --transform-translate-x: 40%;\n  }\n  .xl\\:hover\\:translate-x-3\\/5:hover {\n    --transform-translate-x: 60%;\n  }\n  .xl\\:hover\\:translate-x-4\\/5:hover {\n    --transform-translate-x: 80%;\n  }\n  .xl\\:hover\\:translate-x-1\\/6:hover {\n    --transform-translate-x: 16.666667%;\n  }\n  .xl\\:hover\\:translate-x-2\\/6:hover {\n    --transform-translate-x: 33.333333%;\n  }\n  .xl\\:hover\\:translate-x-3\\/6:hover {\n    --transform-translate-x: 50%;\n  }\n  .xl\\:hover\\:translate-x-4\\/6:hover {\n    --transform-translate-x: 66.666667%;\n  }\n  .xl\\:hover\\:translate-x-5\\/6:hover {\n    --transform-translate-x: 83.333333%;\n  }\n  .xl\\:hover\\:translate-x-1\\/12:hover {\n    --transform-translate-x: 8.333333%;\n  }\n  .xl\\:hover\\:translate-x-2\\/12:hover {\n    --transform-translate-x: 16.666667%;\n  }\n  .xl\\:hover\\:translate-x-3\\/12:hover {\n    --transform-translate-x: 25%;\n  }\n  .xl\\:hover\\:translate-x-4\\/12:hover {\n    --transform-translate-x: 33.333333%;\n  }\n  .xl\\:hover\\:translate-x-5\\/12:hover {\n    --transform-translate-x: 41.666667%;\n  }\n  .xl\\:hover\\:translate-x-6\\/12:hover {\n    --transform-translate-x: 50%;\n  }\n  .xl\\:hover\\:translate-x-7\\/12:hover {\n    --transform-translate-x: 58.333333%;\n  }\n  .xl\\:hover\\:translate-x-8\\/12:hover {\n    --transform-translate-x: 66.666667%;\n  }\n  .xl\\:hover\\:translate-x-9\\/12:hover {\n    --transform-translate-x: 75%;\n  }\n  .xl\\:hover\\:translate-x-10\\/12:hover {\n    --transform-translate-x: 83.333333%;\n  }\n  .xl\\:hover\\:translate-x-11\\/12:hover {\n    --transform-translate-x: 91.666667%;\n  }\n  .xl\\:hover\\:translate-x-full:hover {\n    --transform-translate-x: 100%;\n  }\n  .xl\\:hover\\:-translate-x-1:hover {\n    --transform-translate-x: -0.25rem;\n  }\n  .xl\\:hover\\:-translate-x-2:hover {\n    --transform-translate-x: -0.5rem;\n  }\n  .xl\\:hover\\:-translate-x-3:hover {\n    --transform-translate-x: -0.75rem;\n  }\n  .xl\\:hover\\:-translate-x-4:hover {\n    --transform-translate-x: -1rem;\n  }\n  .xl\\:hover\\:-translate-x-5:hover {\n    --transform-translate-x: -1.25rem;\n  }\n  .xl\\:hover\\:-translate-x-6:hover {\n    --transform-translate-x: -1.5rem;\n  }\n  .xl\\:hover\\:-translate-x-7:hover {\n    --transform-translate-x: -1.75rem;\n  }\n  .xl\\:hover\\:-translate-x-8:hover {\n    --transform-translate-x: -2rem;\n  }\n  .xl\\:hover\\:-translate-x-9:hover {\n    --transform-translate-x: -2.25rem;\n  }\n  .xl\\:hover\\:-translate-x-10:hover {\n    --transform-translate-x: -2.5rem;\n  }\n  .xl\\:hover\\:-translate-x-11:hover {\n    --transform-translate-x: -2.75rem;\n  }\n  .xl\\:hover\\:-translate-x-12:hover {\n    --transform-translate-x: -3rem;\n  }\n  .xl\\:hover\\:-translate-x-13:hover {\n    --transform-translate-x: -3.25rem;\n  }\n  .xl\\:hover\\:-translate-x-14:hover {\n    --transform-translate-x: -3.5rem;\n  }\n  .xl\\:hover\\:-translate-x-15:hover {\n    --transform-translate-x: -3.75rem;\n  }\n  .xl\\:hover\\:-translate-x-16:hover {\n    --transform-translate-x: -4rem;\n  }\n  .xl\\:hover\\:-translate-x-20:hover {\n    --transform-translate-x: -5rem;\n  }\n  .xl\\:hover\\:-translate-x-24:hover {\n    --transform-translate-x: -6rem;\n  }\n  .xl\\:hover\\:-translate-x-28:hover {\n    --transform-translate-x: -7rem;\n  }\n  .xl\\:hover\\:-translate-x-32:hover {\n    --transform-translate-x: -8rem;\n  }\n  .xl\\:hover\\:-translate-x-36:hover {\n    --transform-translate-x: -9rem;\n  }\n  .xl\\:hover\\:-translate-x-40:hover {\n    --transform-translate-x: -10rem;\n  }\n  .xl\\:hover\\:-translate-x-44:hover {\n    --transform-translate-x: -11rem;\n  }\n  .xl\\:hover\\:-translate-x-48:hover {\n    --transform-translate-x: -12rem;\n  }\n  .xl\\:hover\\:-translate-x-52:hover {\n    --transform-translate-x: -13rem;\n  }\n  .xl\\:hover\\:-translate-x-56:hover {\n    --transform-translate-x: -14rem;\n  }\n  .xl\\:hover\\:-translate-x-60:hover {\n    --transform-translate-x: -15rem;\n  }\n  .xl\\:hover\\:-translate-x-64:hover {\n    --transform-translate-x: -16rem;\n  }\n  .xl\\:hover\\:-translate-x-72:hover {\n    --transform-translate-x: -18rem;\n  }\n  .xl\\:hover\\:-translate-x-80:hover {\n    --transform-translate-x: -20rem;\n  }\n  .xl\\:hover\\:-translate-x-96:hover {\n    --transform-translate-x: -24rem;\n  }\n  .xl\\:hover\\:-translate-x-px:hover {\n    --transform-translate-x: -1px;\n  }\n  .xl\\:hover\\:-translate-x-0\\.5:hover {\n    --transform-translate-x: -0.125rem;\n  }\n  .xl\\:hover\\:-translate-x-1\\.5:hover {\n    --transform-translate-x: -0.375rem;\n  }\n  .xl\\:hover\\:-translate-x-2\\.5:hover {\n    --transform-translate-x: -0.625rem;\n  }\n  .xl\\:hover\\:-translate-x-3\\.5:hover {\n    --transform-translate-x: -0.875rem;\n  }\n  .xl\\:hover\\:-translate-x-1\\/2:hover {\n    --transform-translate-x: -50%;\n  }\n  .xl\\:hover\\:-translate-x-1\\/3:hover {\n    --transform-translate-x: -33.33333%;\n  }\n  .xl\\:hover\\:-translate-x-2\\/3:hover {\n    --transform-translate-x: -66.66667%;\n  }\n  .xl\\:hover\\:-translate-x-1\\/4:hover {\n    --transform-translate-x: -25%;\n  }\n  .xl\\:hover\\:-translate-x-2\\/4:hover {\n    --transform-translate-x: -50%;\n  }\n  .xl\\:hover\\:-translate-x-3\\/4:hover {\n    --transform-translate-x: -75%;\n  }\n  .xl\\:hover\\:-translate-x-1\\/5:hover {\n    --transform-translate-x: -20%;\n  }\n  .xl\\:hover\\:-translate-x-2\\/5:hover {\n    --transform-translate-x: -40%;\n  }\n  .xl\\:hover\\:-translate-x-3\\/5:hover {\n    --transform-translate-x: -60%;\n  }\n  .xl\\:hover\\:-translate-x-4\\/5:hover {\n    --transform-translate-x: -80%;\n  }\n  .xl\\:hover\\:-translate-x-1\\/6:hover {\n    --transform-translate-x: -16.66667%;\n  }\n  .xl\\:hover\\:-translate-x-2\\/6:hover {\n    --transform-translate-x: -33.33333%;\n  }\n  .xl\\:hover\\:-translate-x-3\\/6:hover {\n    --transform-translate-x: -50%;\n  }\n  .xl\\:hover\\:-translate-x-4\\/6:hover {\n    --transform-translate-x: -66.66667%;\n  }\n  .xl\\:hover\\:-translate-x-5\\/6:hover {\n    --transform-translate-x: -83.33333%;\n  }\n  .xl\\:hover\\:-translate-x-1\\/12:hover {\n    --transform-translate-x: -8.33333%;\n  }\n  .xl\\:hover\\:-translate-x-2\\/12:hover {\n    --transform-translate-x: -16.66667%;\n  }\n  .xl\\:hover\\:-translate-x-3\\/12:hover {\n    --transform-translate-x: -25%;\n  }\n  .xl\\:hover\\:-translate-x-4\\/12:hover {\n    --transform-translate-x: -33.33333%;\n  }\n  .xl\\:hover\\:-translate-x-5\\/12:hover {\n    --transform-translate-x: -41.66667%;\n  }\n  .xl\\:hover\\:-translate-x-6\\/12:hover {\n    --transform-translate-x: -50%;\n  }\n  .xl\\:hover\\:-translate-x-7\\/12:hover {\n    --transform-translate-x: -58.33333%;\n  }\n  .xl\\:hover\\:-translate-x-8\\/12:hover {\n    --transform-translate-x: -66.66667%;\n  }\n  .xl\\:hover\\:-translate-x-9\\/12:hover {\n    --transform-translate-x: -75%;\n  }\n  .xl\\:hover\\:-translate-x-10\\/12:hover {\n    --transform-translate-x: -83.33333%;\n  }\n  .xl\\:hover\\:-translate-x-11\\/12:hover {\n    --transform-translate-x: -91.66667%;\n  }\n  .xl\\:hover\\:-translate-x-full:hover {\n    --transform-translate-x: -100%;\n  }\n  .xl\\:hover\\:translate-y-0:hover {\n    --transform-translate-y: 0;\n  }\n  .xl\\:hover\\:translate-y-1:hover {\n    --transform-translate-y: 0.25rem;\n  }\n  .xl\\:hover\\:translate-y-2:hover {\n    --transform-translate-y: 0.5rem;\n  }\n  .xl\\:hover\\:translate-y-3:hover {\n    --transform-translate-y: 0.75rem;\n  }\n  .xl\\:hover\\:translate-y-4:hover {\n    --transform-translate-y: 1rem;\n  }\n  .xl\\:hover\\:translate-y-5:hover {\n    --transform-translate-y: 1.25rem;\n  }\n  .xl\\:hover\\:translate-y-6:hover {\n    --transform-translate-y: 1.5rem;\n  }\n  .xl\\:hover\\:translate-y-7:hover {\n    --transform-translate-y: 1.75rem;\n  }\n  .xl\\:hover\\:translate-y-8:hover {\n    --transform-translate-y: 2rem;\n  }\n  .xl\\:hover\\:translate-y-9:hover {\n    --transform-translate-y: 2.25rem;\n  }\n  .xl\\:hover\\:translate-y-10:hover {\n    --transform-translate-y: 2.5rem;\n  }\n  .xl\\:hover\\:translate-y-11:hover {\n    --transform-translate-y: 2.75rem;\n  }\n  .xl\\:hover\\:translate-y-12:hover {\n    --transform-translate-y: 3rem;\n  }\n  .xl\\:hover\\:translate-y-13:hover {\n    --transform-translate-y: 3.25rem;\n  }\n  .xl\\:hover\\:translate-y-14:hover {\n    --transform-translate-y: 3.5rem;\n  }\n  .xl\\:hover\\:translate-y-15:hover {\n    --transform-translate-y: 3.75rem;\n  }\n  .xl\\:hover\\:translate-y-16:hover {\n    --transform-translate-y: 4rem;\n  }\n  .xl\\:hover\\:translate-y-20:hover {\n    --transform-translate-y: 5rem;\n  }\n  .xl\\:hover\\:translate-y-24:hover {\n    --transform-translate-y: 6rem;\n  }\n  .xl\\:hover\\:translate-y-28:hover {\n    --transform-translate-y: 7rem;\n  }\n  .xl\\:hover\\:translate-y-32:hover {\n    --transform-translate-y: 8rem;\n  }\n  .xl\\:hover\\:translate-y-36:hover {\n    --transform-translate-y: 9rem;\n  }\n  .xl\\:hover\\:translate-y-40:hover {\n    --transform-translate-y: 10rem;\n  }\n  .xl\\:hover\\:translate-y-44:hover {\n    --transform-translate-y: 11rem;\n  }\n  .xl\\:hover\\:translate-y-48:hover {\n    --transform-translate-y: 12rem;\n  }\n  .xl\\:hover\\:translate-y-52:hover {\n    --transform-translate-y: 13rem;\n  }\n  .xl\\:hover\\:translate-y-56:hover {\n    --transform-translate-y: 14rem;\n  }\n  .xl\\:hover\\:translate-y-60:hover {\n    --transform-translate-y: 15rem;\n  }\n  .xl\\:hover\\:translate-y-64:hover {\n    --transform-translate-y: 16rem;\n  }\n  .xl\\:hover\\:translate-y-72:hover {\n    --transform-translate-y: 18rem;\n  }\n  .xl\\:hover\\:translate-y-80:hover {\n    --transform-translate-y: 20rem;\n  }\n  .xl\\:hover\\:translate-y-96:hover {\n    --transform-translate-y: 24rem;\n  }\n  .xl\\:hover\\:translate-y-px:hover {\n    --transform-translate-y: 1px;\n  }\n  .xl\\:hover\\:translate-y-0\\.5:hover {\n    --transform-translate-y: 0.125rem;\n  }\n  .xl\\:hover\\:translate-y-1\\.5:hover {\n    --transform-translate-y: 0.375rem;\n  }\n  .xl\\:hover\\:translate-y-2\\.5:hover {\n    --transform-translate-y: 0.625rem;\n  }\n  .xl\\:hover\\:translate-y-3\\.5:hover {\n    --transform-translate-y: 0.875rem;\n  }\n  .xl\\:hover\\:translate-y-1\\/2:hover {\n    --transform-translate-y: 50%;\n  }\n  .xl\\:hover\\:translate-y-1\\/3:hover {\n    --transform-translate-y: 33.333333%;\n  }\n  .xl\\:hover\\:translate-y-2\\/3:hover {\n    --transform-translate-y: 66.666667%;\n  }\n  .xl\\:hover\\:translate-y-1\\/4:hover {\n    --transform-translate-y: 25%;\n  }\n  .xl\\:hover\\:translate-y-2\\/4:hover {\n    --transform-translate-y: 50%;\n  }\n  .xl\\:hover\\:translate-y-3\\/4:hover {\n    --transform-translate-y: 75%;\n  }\n  .xl\\:hover\\:translate-y-1\\/5:hover {\n    --transform-translate-y: 20%;\n  }\n  .xl\\:hover\\:translate-y-2\\/5:hover {\n    --transform-translate-y: 40%;\n  }\n  .xl\\:hover\\:translate-y-3\\/5:hover {\n    --transform-translate-y: 60%;\n  }\n  .xl\\:hover\\:translate-y-4\\/5:hover {\n    --transform-translate-y: 80%;\n  }\n  .xl\\:hover\\:translate-y-1\\/6:hover {\n    --transform-translate-y: 16.666667%;\n  }\n  .xl\\:hover\\:translate-y-2\\/6:hover {\n    --transform-translate-y: 33.333333%;\n  }\n  .xl\\:hover\\:translate-y-3\\/6:hover {\n    --transform-translate-y: 50%;\n  }\n  .xl\\:hover\\:translate-y-4\\/6:hover {\n    --transform-translate-y: 66.666667%;\n  }\n  .xl\\:hover\\:translate-y-5\\/6:hover {\n    --transform-translate-y: 83.333333%;\n  }\n  .xl\\:hover\\:translate-y-1\\/12:hover {\n    --transform-translate-y: 8.333333%;\n  }\n  .xl\\:hover\\:translate-y-2\\/12:hover {\n    --transform-translate-y: 16.666667%;\n  }\n  .xl\\:hover\\:translate-y-3\\/12:hover {\n    --transform-translate-y: 25%;\n  }\n  .xl\\:hover\\:translate-y-4\\/12:hover {\n    --transform-translate-y: 33.333333%;\n  }\n  .xl\\:hover\\:translate-y-5\\/12:hover {\n    --transform-translate-y: 41.666667%;\n  }\n  .xl\\:hover\\:translate-y-6\\/12:hover {\n    --transform-translate-y: 50%;\n  }\n  .xl\\:hover\\:translate-y-7\\/12:hover {\n    --transform-translate-y: 58.333333%;\n  }\n  .xl\\:hover\\:translate-y-8\\/12:hover {\n    --transform-translate-y: 66.666667%;\n  }\n  .xl\\:hover\\:translate-y-9\\/12:hover {\n    --transform-translate-y: 75%;\n  }\n  .xl\\:hover\\:translate-y-10\\/12:hover {\n    --transform-translate-y: 83.333333%;\n  }\n  .xl\\:hover\\:translate-y-11\\/12:hover {\n    --transform-translate-y: 91.666667%;\n  }\n  .xl\\:hover\\:translate-y-full:hover {\n    --transform-translate-y: 100%;\n  }\n  .xl\\:hover\\:-translate-y-1:hover {\n    --transform-translate-y: -0.25rem;\n  }\n  .xl\\:hover\\:-translate-y-2:hover {\n    --transform-translate-y: -0.5rem;\n  }\n  .xl\\:hover\\:-translate-y-3:hover {\n    --transform-translate-y: -0.75rem;\n  }\n  .xl\\:hover\\:-translate-y-4:hover {\n    --transform-translate-y: -1rem;\n  }\n  .xl\\:hover\\:-translate-y-5:hover {\n    --transform-translate-y: -1.25rem;\n  }\n  .xl\\:hover\\:-translate-y-6:hover {\n    --transform-translate-y: -1.5rem;\n  }\n  .xl\\:hover\\:-translate-y-7:hover {\n    --transform-translate-y: -1.75rem;\n  }\n  .xl\\:hover\\:-translate-y-8:hover {\n    --transform-translate-y: -2rem;\n  }\n  .xl\\:hover\\:-translate-y-9:hover {\n    --transform-translate-y: -2.25rem;\n  }\n  .xl\\:hover\\:-translate-y-10:hover {\n    --transform-translate-y: -2.5rem;\n  }\n  .xl\\:hover\\:-translate-y-11:hover {\n    --transform-translate-y: -2.75rem;\n  }\n  .xl\\:hover\\:-translate-y-12:hover {\n    --transform-translate-y: -3rem;\n  }\n  .xl\\:hover\\:-translate-y-13:hover {\n    --transform-translate-y: -3.25rem;\n  }\n  .xl\\:hover\\:-translate-y-14:hover {\n    --transform-translate-y: -3.5rem;\n  }\n  .xl\\:hover\\:-translate-y-15:hover {\n    --transform-translate-y: -3.75rem;\n  }\n  .xl\\:hover\\:-translate-y-16:hover {\n    --transform-translate-y: -4rem;\n  }\n  .xl\\:hover\\:-translate-y-20:hover {\n    --transform-translate-y: -5rem;\n  }\n  .xl\\:hover\\:-translate-y-24:hover {\n    --transform-translate-y: -6rem;\n  }\n  .xl\\:hover\\:-translate-y-28:hover {\n    --transform-translate-y: -7rem;\n  }\n  .xl\\:hover\\:-translate-y-32:hover {\n    --transform-translate-y: -8rem;\n  }\n  .xl\\:hover\\:-translate-y-36:hover {\n    --transform-translate-y: -9rem;\n  }\n  .xl\\:hover\\:-translate-y-40:hover {\n    --transform-translate-y: -10rem;\n  }\n  .xl\\:hover\\:-translate-y-44:hover {\n    --transform-translate-y: -11rem;\n  }\n  .xl\\:hover\\:-translate-y-48:hover {\n    --transform-translate-y: -12rem;\n  }\n  .xl\\:hover\\:-translate-y-52:hover {\n    --transform-translate-y: -13rem;\n  }\n  .xl\\:hover\\:-translate-y-56:hover {\n    --transform-translate-y: -14rem;\n  }\n  .xl\\:hover\\:-translate-y-60:hover {\n    --transform-translate-y: -15rem;\n  }\n  .xl\\:hover\\:-translate-y-64:hover {\n    --transform-translate-y: -16rem;\n  }\n  .xl\\:hover\\:-translate-y-72:hover {\n    --transform-translate-y: -18rem;\n  }\n  .xl\\:hover\\:-translate-y-80:hover {\n    --transform-translate-y: -20rem;\n  }\n  .xl\\:hover\\:-translate-y-96:hover {\n    --transform-translate-y: -24rem;\n  }\n  .xl\\:hover\\:-translate-y-px:hover {\n    --transform-translate-y: -1px;\n  }\n  .xl\\:hover\\:-translate-y-0\\.5:hover {\n    --transform-translate-y: -0.125rem;\n  }\n  .xl\\:hover\\:-translate-y-1\\.5:hover {\n    --transform-translate-y: -0.375rem;\n  }\n  .xl\\:hover\\:-translate-y-2\\.5:hover {\n    --transform-translate-y: -0.625rem;\n  }\n  .xl\\:hover\\:-translate-y-3\\.5:hover {\n    --transform-translate-y: -0.875rem;\n  }\n  .xl\\:hover\\:-translate-y-1\\/2:hover {\n    --transform-translate-y: -50%;\n  }\n  .xl\\:hover\\:-translate-y-1\\/3:hover {\n    --transform-translate-y: -33.33333%;\n  }\n  .xl\\:hover\\:-translate-y-2\\/3:hover {\n    --transform-translate-y: -66.66667%;\n  }\n  .xl\\:hover\\:-translate-y-1\\/4:hover {\n    --transform-translate-y: -25%;\n  }\n  .xl\\:hover\\:-translate-y-2\\/4:hover {\n    --transform-translate-y: -50%;\n  }\n  .xl\\:hover\\:-translate-y-3\\/4:hover {\n    --transform-translate-y: -75%;\n  }\n  .xl\\:hover\\:-translate-y-1\\/5:hover {\n    --transform-translate-y: -20%;\n  }\n  .xl\\:hover\\:-translate-y-2\\/5:hover {\n    --transform-translate-y: -40%;\n  }\n  .xl\\:hover\\:-translate-y-3\\/5:hover {\n    --transform-translate-y: -60%;\n  }\n  .xl\\:hover\\:-translate-y-4\\/5:hover {\n    --transform-translate-y: -80%;\n  }\n  .xl\\:hover\\:-translate-y-1\\/6:hover {\n    --transform-translate-y: -16.66667%;\n  }\n  .xl\\:hover\\:-translate-y-2\\/6:hover {\n    --transform-translate-y: -33.33333%;\n  }\n  .xl\\:hover\\:-translate-y-3\\/6:hover {\n    --transform-translate-y: -50%;\n  }\n  .xl\\:hover\\:-translate-y-4\\/6:hover {\n    --transform-translate-y: -66.66667%;\n  }\n  .xl\\:hover\\:-translate-y-5\\/6:hover {\n    --transform-translate-y: -83.33333%;\n  }\n  .xl\\:hover\\:-translate-y-1\\/12:hover {\n    --transform-translate-y: -8.33333%;\n  }\n  .xl\\:hover\\:-translate-y-2\\/12:hover {\n    --transform-translate-y: -16.66667%;\n  }\n  .xl\\:hover\\:-translate-y-3\\/12:hover {\n    --transform-translate-y: -25%;\n  }\n  .xl\\:hover\\:-translate-y-4\\/12:hover {\n    --transform-translate-y: -33.33333%;\n  }\n  .xl\\:hover\\:-translate-y-5\\/12:hover {\n    --transform-translate-y: -41.66667%;\n  }\n  .xl\\:hover\\:-translate-y-6\\/12:hover {\n    --transform-translate-y: -50%;\n  }\n  .xl\\:hover\\:-translate-y-7\\/12:hover {\n    --transform-translate-y: -58.33333%;\n  }\n  .xl\\:hover\\:-translate-y-8\\/12:hover {\n    --transform-translate-y: -66.66667%;\n  }\n  .xl\\:hover\\:-translate-y-9\\/12:hover {\n    --transform-translate-y: -75%;\n  }\n  .xl\\:hover\\:-translate-y-10\\/12:hover {\n    --transform-translate-y: -83.33333%;\n  }\n  .xl\\:hover\\:-translate-y-11\\/12:hover {\n    --transform-translate-y: -91.66667%;\n  }\n  .xl\\:hover\\:-translate-y-full:hover {\n    --transform-translate-y: -100%;\n  }\n  .xl\\:focus\\:translate-x-0:focus {\n    --transform-translate-x: 0;\n  }\n  .xl\\:focus\\:translate-x-1:focus {\n    --transform-translate-x: 0.25rem;\n  }\n  .xl\\:focus\\:translate-x-2:focus {\n    --transform-translate-x: 0.5rem;\n  }\n  .xl\\:focus\\:translate-x-3:focus {\n    --transform-translate-x: 0.75rem;\n  }\n  .xl\\:focus\\:translate-x-4:focus {\n    --transform-translate-x: 1rem;\n  }\n  .xl\\:focus\\:translate-x-5:focus {\n    --transform-translate-x: 1.25rem;\n  }\n  .xl\\:focus\\:translate-x-6:focus {\n    --transform-translate-x: 1.5rem;\n  }\n  .xl\\:focus\\:translate-x-7:focus {\n    --transform-translate-x: 1.75rem;\n  }\n  .xl\\:focus\\:translate-x-8:focus {\n    --transform-translate-x: 2rem;\n  }\n  .xl\\:focus\\:translate-x-9:focus {\n    --transform-translate-x: 2.25rem;\n  }\n  .xl\\:focus\\:translate-x-10:focus {\n    --transform-translate-x: 2.5rem;\n  }\n  .xl\\:focus\\:translate-x-11:focus {\n    --transform-translate-x: 2.75rem;\n  }\n  .xl\\:focus\\:translate-x-12:focus {\n    --transform-translate-x: 3rem;\n  }\n  .xl\\:focus\\:translate-x-13:focus {\n    --transform-translate-x: 3.25rem;\n  }\n  .xl\\:focus\\:translate-x-14:focus {\n    --transform-translate-x: 3.5rem;\n  }\n  .xl\\:focus\\:translate-x-15:focus {\n    --transform-translate-x: 3.75rem;\n  }\n  .xl\\:focus\\:translate-x-16:focus {\n    --transform-translate-x: 4rem;\n  }\n  .xl\\:focus\\:translate-x-20:focus {\n    --transform-translate-x: 5rem;\n  }\n  .xl\\:focus\\:translate-x-24:focus {\n    --transform-translate-x: 6rem;\n  }\n  .xl\\:focus\\:translate-x-28:focus {\n    --transform-translate-x: 7rem;\n  }\n  .xl\\:focus\\:translate-x-32:focus {\n    --transform-translate-x: 8rem;\n  }\n  .xl\\:focus\\:translate-x-36:focus {\n    --transform-translate-x: 9rem;\n  }\n  .xl\\:focus\\:translate-x-40:focus {\n    --transform-translate-x: 10rem;\n  }\n  .xl\\:focus\\:translate-x-44:focus {\n    --transform-translate-x: 11rem;\n  }\n  .xl\\:focus\\:translate-x-48:focus {\n    --transform-translate-x: 12rem;\n  }\n  .xl\\:focus\\:translate-x-52:focus {\n    --transform-translate-x: 13rem;\n  }\n  .xl\\:focus\\:translate-x-56:focus {\n    --transform-translate-x: 14rem;\n  }\n  .xl\\:focus\\:translate-x-60:focus {\n    --transform-translate-x: 15rem;\n  }\n  .xl\\:focus\\:translate-x-64:focus {\n    --transform-translate-x: 16rem;\n  }\n  .xl\\:focus\\:translate-x-72:focus {\n    --transform-translate-x: 18rem;\n  }\n  .xl\\:focus\\:translate-x-80:focus {\n    --transform-translate-x: 20rem;\n  }\n  .xl\\:focus\\:translate-x-96:focus {\n    --transform-translate-x: 24rem;\n  }\n  .xl\\:focus\\:translate-x-px:focus {\n    --transform-translate-x: 1px;\n  }\n  .xl\\:focus\\:translate-x-0\\.5:focus {\n    --transform-translate-x: 0.125rem;\n  }\n  .xl\\:focus\\:translate-x-1\\.5:focus {\n    --transform-translate-x: 0.375rem;\n  }\n  .xl\\:focus\\:translate-x-2\\.5:focus {\n    --transform-translate-x: 0.625rem;\n  }\n  .xl\\:focus\\:translate-x-3\\.5:focus {\n    --transform-translate-x: 0.875rem;\n  }\n  .xl\\:focus\\:translate-x-1\\/2:focus {\n    --transform-translate-x: 50%;\n  }\n  .xl\\:focus\\:translate-x-1\\/3:focus {\n    --transform-translate-x: 33.333333%;\n  }\n  .xl\\:focus\\:translate-x-2\\/3:focus {\n    --transform-translate-x: 66.666667%;\n  }\n  .xl\\:focus\\:translate-x-1\\/4:focus {\n    --transform-translate-x: 25%;\n  }\n  .xl\\:focus\\:translate-x-2\\/4:focus {\n    --transform-translate-x: 50%;\n  }\n  .xl\\:focus\\:translate-x-3\\/4:focus {\n    --transform-translate-x: 75%;\n  }\n  .xl\\:focus\\:translate-x-1\\/5:focus {\n    --transform-translate-x: 20%;\n  }\n  .xl\\:focus\\:translate-x-2\\/5:focus {\n    --transform-translate-x: 40%;\n  }\n  .xl\\:focus\\:translate-x-3\\/5:focus {\n    --transform-translate-x: 60%;\n  }\n  .xl\\:focus\\:translate-x-4\\/5:focus {\n    --transform-translate-x: 80%;\n  }\n  .xl\\:focus\\:translate-x-1\\/6:focus {\n    --transform-translate-x: 16.666667%;\n  }\n  .xl\\:focus\\:translate-x-2\\/6:focus {\n    --transform-translate-x: 33.333333%;\n  }\n  .xl\\:focus\\:translate-x-3\\/6:focus {\n    --transform-translate-x: 50%;\n  }\n  .xl\\:focus\\:translate-x-4\\/6:focus {\n    --transform-translate-x: 66.666667%;\n  }\n  .xl\\:focus\\:translate-x-5\\/6:focus {\n    --transform-translate-x: 83.333333%;\n  }\n  .xl\\:focus\\:translate-x-1\\/12:focus {\n    --transform-translate-x: 8.333333%;\n  }\n  .xl\\:focus\\:translate-x-2\\/12:focus {\n    --transform-translate-x: 16.666667%;\n  }\n  .xl\\:focus\\:translate-x-3\\/12:focus {\n    --transform-translate-x: 25%;\n  }\n  .xl\\:focus\\:translate-x-4\\/12:focus {\n    --transform-translate-x: 33.333333%;\n  }\n  .xl\\:focus\\:translate-x-5\\/12:focus {\n    --transform-translate-x: 41.666667%;\n  }\n  .xl\\:focus\\:translate-x-6\\/12:focus {\n    --transform-translate-x: 50%;\n  }\n  .xl\\:focus\\:translate-x-7\\/12:focus {\n    --transform-translate-x: 58.333333%;\n  }\n  .xl\\:focus\\:translate-x-8\\/12:focus {\n    --transform-translate-x: 66.666667%;\n  }\n  .xl\\:focus\\:translate-x-9\\/12:focus {\n    --transform-translate-x: 75%;\n  }\n  .xl\\:focus\\:translate-x-10\\/12:focus {\n    --transform-translate-x: 83.333333%;\n  }\n  .xl\\:focus\\:translate-x-11\\/12:focus {\n    --transform-translate-x: 91.666667%;\n  }\n  .xl\\:focus\\:translate-x-full:focus {\n    --transform-translate-x: 100%;\n  }\n  .xl\\:focus\\:-translate-x-1:focus {\n    --transform-translate-x: -0.25rem;\n  }\n  .xl\\:focus\\:-translate-x-2:focus {\n    --transform-translate-x: -0.5rem;\n  }\n  .xl\\:focus\\:-translate-x-3:focus {\n    --transform-translate-x: -0.75rem;\n  }\n  .xl\\:focus\\:-translate-x-4:focus {\n    --transform-translate-x: -1rem;\n  }\n  .xl\\:focus\\:-translate-x-5:focus {\n    --transform-translate-x: -1.25rem;\n  }\n  .xl\\:focus\\:-translate-x-6:focus {\n    --transform-translate-x: -1.5rem;\n  }\n  .xl\\:focus\\:-translate-x-7:focus {\n    --transform-translate-x: -1.75rem;\n  }\n  .xl\\:focus\\:-translate-x-8:focus {\n    --transform-translate-x: -2rem;\n  }\n  .xl\\:focus\\:-translate-x-9:focus {\n    --transform-translate-x: -2.25rem;\n  }\n  .xl\\:focus\\:-translate-x-10:focus {\n    --transform-translate-x: -2.5rem;\n  }\n  .xl\\:focus\\:-translate-x-11:focus {\n    --transform-translate-x: -2.75rem;\n  }\n  .xl\\:focus\\:-translate-x-12:focus {\n    --transform-translate-x: -3rem;\n  }\n  .xl\\:focus\\:-translate-x-13:focus {\n    --transform-translate-x: -3.25rem;\n  }\n  .xl\\:focus\\:-translate-x-14:focus {\n    --transform-translate-x: -3.5rem;\n  }\n  .xl\\:focus\\:-translate-x-15:focus {\n    --transform-translate-x: -3.75rem;\n  }\n  .xl\\:focus\\:-translate-x-16:focus {\n    --transform-translate-x: -4rem;\n  }\n  .xl\\:focus\\:-translate-x-20:focus {\n    --transform-translate-x: -5rem;\n  }\n  .xl\\:focus\\:-translate-x-24:focus {\n    --transform-translate-x: -6rem;\n  }\n  .xl\\:focus\\:-translate-x-28:focus {\n    --transform-translate-x: -7rem;\n  }\n  .xl\\:focus\\:-translate-x-32:focus {\n    --transform-translate-x: -8rem;\n  }\n  .xl\\:focus\\:-translate-x-36:focus {\n    --transform-translate-x: -9rem;\n  }\n  .xl\\:focus\\:-translate-x-40:focus {\n    --transform-translate-x: -10rem;\n  }\n  .xl\\:focus\\:-translate-x-44:focus {\n    --transform-translate-x: -11rem;\n  }\n  .xl\\:focus\\:-translate-x-48:focus {\n    --transform-translate-x: -12rem;\n  }\n  .xl\\:focus\\:-translate-x-52:focus {\n    --transform-translate-x: -13rem;\n  }\n  .xl\\:focus\\:-translate-x-56:focus {\n    --transform-translate-x: -14rem;\n  }\n  .xl\\:focus\\:-translate-x-60:focus {\n    --transform-translate-x: -15rem;\n  }\n  .xl\\:focus\\:-translate-x-64:focus {\n    --transform-translate-x: -16rem;\n  }\n  .xl\\:focus\\:-translate-x-72:focus {\n    --transform-translate-x: -18rem;\n  }\n  .xl\\:focus\\:-translate-x-80:focus {\n    --transform-translate-x: -20rem;\n  }\n  .xl\\:focus\\:-translate-x-96:focus {\n    --transform-translate-x: -24rem;\n  }\n  .xl\\:focus\\:-translate-x-px:focus {\n    --transform-translate-x: -1px;\n  }\n  .xl\\:focus\\:-translate-x-0\\.5:focus {\n    --transform-translate-x: -0.125rem;\n  }\n  .xl\\:focus\\:-translate-x-1\\.5:focus {\n    --transform-translate-x: -0.375rem;\n  }\n  .xl\\:focus\\:-translate-x-2\\.5:focus {\n    --transform-translate-x: -0.625rem;\n  }\n  .xl\\:focus\\:-translate-x-3\\.5:focus {\n    --transform-translate-x: -0.875rem;\n  }\n  .xl\\:focus\\:-translate-x-1\\/2:focus {\n    --transform-translate-x: -50%;\n  }\n  .xl\\:focus\\:-translate-x-1\\/3:focus {\n    --transform-translate-x: -33.33333%;\n  }\n  .xl\\:focus\\:-translate-x-2\\/3:focus {\n    --transform-translate-x: -66.66667%;\n  }\n  .xl\\:focus\\:-translate-x-1\\/4:focus {\n    --transform-translate-x: -25%;\n  }\n  .xl\\:focus\\:-translate-x-2\\/4:focus {\n    --transform-translate-x: -50%;\n  }\n  .xl\\:focus\\:-translate-x-3\\/4:focus {\n    --transform-translate-x: -75%;\n  }\n  .xl\\:focus\\:-translate-x-1\\/5:focus {\n    --transform-translate-x: -20%;\n  }\n  .xl\\:focus\\:-translate-x-2\\/5:focus {\n    --transform-translate-x: -40%;\n  }\n  .xl\\:focus\\:-translate-x-3\\/5:focus {\n    --transform-translate-x: -60%;\n  }\n  .xl\\:focus\\:-translate-x-4\\/5:focus {\n    --transform-translate-x: -80%;\n  }\n  .xl\\:focus\\:-translate-x-1\\/6:focus {\n    --transform-translate-x: -16.66667%;\n  }\n  .xl\\:focus\\:-translate-x-2\\/6:focus {\n    --transform-translate-x: -33.33333%;\n  }\n  .xl\\:focus\\:-translate-x-3\\/6:focus {\n    --transform-translate-x: -50%;\n  }\n  .xl\\:focus\\:-translate-x-4\\/6:focus {\n    --transform-translate-x: -66.66667%;\n  }\n  .xl\\:focus\\:-translate-x-5\\/6:focus {\n    --transform-translate-x: -83.33333%;\n  }\n  .xl\\:focus\\:-translate-x-1\\/12:focus {\n    --transform-translate-x: -8.33333%;\n  }\n  .xl\\:focus\\:-translate-x-2\\/12:focus {\n    --transform-translate-x: -16.66667%;\n  }\n  .xl\\:focus\\:-translate-x-3\\/12:focus {\n    --transform-translate-x: -25%;\n  }\n  .xl\\:focus\\:-translate-x-4\\/12:focus {\n    --transform-translate-x: -33.33333%;\n  }\n  .xl\\:focus\\:-translate-x-5\\/12:focus {\n    --transform-translate-x: -41.66667%;\n  }\n  .xl\\:focus\\:-translate-x-6\\/12:focus {\n    --transform-translate-x: -50%;\n  }\n  .xl\\:focus\\:-translate-x-7\\/12:focus {\n    --transform-translate-x: -58.33333%;\n  }\n  .xl\\:focus\\:-translate-x-8\\/12:focus {\n    --transform-translate-x: -66.66667%;\n  }\n  .xl\\:focus\\:-translate-x-9\\/12:focus {\n    --transform-translate-x: -75%;\n  }\n  .xl\\:focus\\:-translate-x-10\\/12:focus {\n    --transform-translate-x: -83.33333%;\n  }\n  .xl\\:focus\\:-translate-x-11\\/12:focus {\n    --transform-translate-x: -91.66667%;\n  }\n  .xl\\:focus\\:-translate-x-full:focus {\n    --transform-translate-x: -100%;\n  }\n  .xl\\:focus\\:translate-y-0:focus {\n    --transform-translate-y: 0;\n  }\n  .xl\\:focus\\:translate-y-1:focus {\n    --transform-translate-y: 0.25rem;\n  }\n  .xl\\:focus\\:translate-y-2:focus {\n    --transform-translate-y: 0.5rem;\n  }\n  .xl\\:focus\\:translate-y-3:focus {\n    --transform-translate-y: 0.75rem;\n  }\n  .xl\\:focus\\:translate-y-4:focus {\n    --transform-translate-y: 1rem;\n  }\n  .xl\\:focus\\:translate-y-5:focus {\n    --transform-translate-y: 1.25rem;\n  }\n  .xl\\:focus\\:translate-y-6:focus {\n    --transform-translate-y: 1.5rem;\n  }\n  .xl\\:focus\\:translate-y-7:focus {\n    --transform-translate-y: 1.75rem;\n  }\n  .xl\\:focus\\:translate-y-8:focus {\n    --transform-translate-y: 2rem;\n  }\n  .xl\\:focus\\:translate-y-9:focus {\n    --transform-translate-y: 2.25rem;\n  }\n  .xl\\:focus\\:translate-y-10:focus {\n    --transform-translate-y: 2.5rem;\n  }\n  .xl\\:focus\\:translate-y-11:focus {\n    --transform-translate-y: 2.75rem;\n  }\n  .xl\\:focus\\:translate-y-12:focus {\n    --transform-translate-y: 3rem;\n  }\n  .xl\\:focus\\:translate-y-13:focus {\n    --transform-translate-y: 3.25rem;\n  }\n  .xl\\:focus\\:translate-y-14:focus {\n    --transform-translate-y: 3.5rem;\n  }\n  .xl\\:focus\\:translate-y-15:focus {\n    --transform-translate-y: 3.75rem;\n  }\n  .xl\\:focus\\:translate-y-16:focus {\n    --transform-translate-y: 4rem;\n  }\n  .xl\\:focus\\:translate-y-20:focus {\n    --transform-translate-y: 5rem;\n  }\n  .xl\\:focus\\:translate-y-24:focus {\n    --transform-translate-y: 6rem;\n  }\n  .xl\\:focus\\:translate-y-28:focus {\n    --transform-translate-y: 7rem;\n  }\n  .xl\\:focus\\:translate-y-32:focus {\n    --transform-translate-y: 8rem;\n  }\n  .xl\\:focus\\:translate-y-36:focus {\n    --transform-translate-y: 9rem;\n  }\n  .xl\\:focus\\:translate-y-40:focus {\n    --transform-translate-y: 10rem;\n  }\n  .xl\\:focus\\:translate-y-44:focus {\n    --transform-translate-y: 11rem;\n  }\n  .xl\\:focus\\:translate-y-48:focus {\n    --transform-translate-y: 12rem;\n  }\n  .xl\\:focus\\:translate-y-52:focus {\n    --transform-translate-y: 13rem;\n  }\n  .xl\\:focus\\:translate-y-56:focus {\n    --transform-translate-y: 14rem;\n  }\n  .xl\\:focus\\:translate-y-60:focus {\n    --transform-translate-y: 15rem;\n  }\n  .xl\\:focus\\:translate-y-64:focus {\n    --transform-translate-y: 16rem;\n  }\n  .xl\\:focus\\:translate-y-72:focus {\n    --transform-translate-y: 18rem;\n  }\n  .xl\\:focus\\:translate-y-80:focus {\n    --transform-translate-y: 20rem;\n  }\n  .xl\\:focus\\:translate-y-96:focus {\n    --transform-translate-y: 24rem;\n  }\n  .xl\\:focus\\:translate-y-px:focus {\n    --transform-translate-y: 1px;\n  }\n  .xl\\:focus\\:translate-y-0\\.5:focus {\n    --transform-translate-y: 0.125rem;\n  }\n  .xl\\:focus\\:translate-y-1\\.5:focus {\n    --transform-translate-y: 0.375rem;\n  }\n  .xl\\:focus\\:translate-y-2\\.5:focus {\n    --transform-translate-y: 0.625rem;\n  }\n  .xl\\:focus\\:translate-y-3\\.5:focus {\n    --transform-translate-y: 0.875rem;\n  }\n  .xl\\:focus\\:translate-y-1\\/2:focus {\n    --transform-translate-y: 50%;\n  }\n  .xl\\:focus\\:translate-y-1\\/3:focus {\n    --transform-translate-y: 33.333333%;\n  }\n  .xl\\:focus\\:translate-y-2\\/3:focus {\n    --transform-translate-y: 66.666667%;\n  }\n  .xl\\:focus\\:translate-y-1\\/4:focus {\n    --transform-translate-y: 25%;\n  }\n  .xl\\:focus\\:translate-y-2\\/4:focus {\n    --transform-translate-y: 50%;\n  }\n  .xl\\:focus\\:translate-y-3\\/4:focus {\n    --transform-translate-y: 75%;\n  }\n  .xl\\:focus\\:translate-y-1\\/5:focus {\n    --transform-translate-y: 20%;\n  }\n  .xl\\:focus\\:translate-y-2\\/5:focus {\n    --transform-translate-y: 40%;\n  }\n  .xl\\:focus\\:translate-y-3\\/5:focus {\n    --transform-translate-y: 60%;\n  }\n  .xl\\:focus\\:translate-y-4\\/5:focus {\n    --transform-translate-y: 80%;\n  }\n  .xl\\:focus\\:translate-y-1\\/6:focus {\n    --transform-translate-y: 16.666667%;\n  }\n  .xl\\:focus\\:translate-y-2\\/6:focus {\n    --transform-translate-y: 33.333333%;\n  }\n  .xl\\:focus\\:translate-y-3\\/6:focus {\n    --transform-translate-y: 50%;\n  }\n  .xl\\:focus\\:translate-y-4\\/6:focus {\n    --transform-translate-y: 66.666667%;\n  }\n  .xl\\:focus\\:translate-y-5\\/6:focus {\n    --transform-translate-y: 83.333333%;\n  }\n  .xl\\:focus\\:translate-y-1\\/12:focus {\n    --transform-translate-y: 8.333333%;\n  }\n  .xl\\:focus\\:translate-y-2\\/12:focus {\n    --transform-translate-y: 16.666667%;\n  }\n  .xl\\:focus\\:translate-y-3\\/12:focus {\n    --transform-translate-y: 25%;\n  }\n  .xl\\:focus\\:translate-y-4\\/12:focus {\n    --transform-translate-y: 33.333333%;\n  }\n  .xl\\:focus\\:translate-y-5\\/12:focus {\n    --transform-translate-y: 41.666667%;\n  }\n  .xl\\:focus\\:translate-y-6\\/12:focus {\n    --transform-translate-y: 50%;\n  }\n  .xl\\:focus\\:translate-y-7\\/12:focus {\n    --transform-translate-y: 58.333333%;\n  }\n  .xl\\:focus\\:translate-y-8\\/12:focus {\n    --transform-translate-y: 66.666667%;\n  }\n  .xl\\:focus\\:translate-y-9\\/12:focus {\n    --transform-translate-y: 75%;\n  }\n  .xl\\:focus\\:translate-y-10\\/12:focus {\n    --transform-translate-y: 83.333333%;\n  }\n  .xl\\:focus\\:translate-y-11\\/12:focus {\n    --transform-translate-y: 91.666667%;\n  }\n  .xl\\:focus\\:translate-y-full:focus {\n    --transform-translate-y: 100%;\n  }\n  .xl\\:focus\\:-translate-y-1:focus {\n    --transform-translate-y: -0.25rem;\n  }\n  .xl\\:focus\\:-translate-y-2:focus {\n    --transform-translate-y: -0.5rem;\n  }\n  .xl\\:focus\\:-translate-y-3:focus {\n    --transform-translate-y: -0.75rem;\n  }\n  .xl\\:focus\\:-translate-y-4:focus {\n    --transform-translate-y: -1rem;\n  }\n  .xl\\:focus\\:-translate-y-5:focus {\n    --transform-translate-y: -1.25rem;\n  }\n  .xl\\:focus\\:-translate-y-6:focus {\n    --transform-translate-y: -1.5rem;\n  }\n  .xl\\:focus\\:-translate-y-7:focus {\n    --transform-translate-y: -1.75rem;\n  }\n  .xl\\:focus\\:-translate-y-8:focus {\n    --transform-translate-y: -2rem;\n  }\n  .xl\\:focus\\:-translate-y-9:focus {\n    --transform-translate-y: -2.25rem;\n  }\n  .xl\\:focus\\:-translate-y-10:focus {\n    --transform-translate-y: -2.5rem;\n  }\n  .xl\\:focus\\:-translate-y-11:focus {\n    --transform-translate-y: -2.75rem;\n  }\n  .xl\\:focus\\:-translate-y-12:focus {\n    --transform-translate-y: -3rem;\n  }\n  .xl\\:focus\\:-translate-y-13:focus {\n    --transform-translate-y: -3.25rem;\n  }\n  .xl\\:focus\\:-translate-y-14:focus {\n    --transform-translate-y: -3.5rem;\n  }\n  .xl\\:focus\\:-translate-y-15:focus {\n    --transform-translate-y: -3.75rem;\n  }\n  .xl\\:focus\\:-translate-y-16:focus {\n    --transform-translate-y: -4rem;\n  }\n  .xl\\:focus\\:-translate-y-20:focus {\n    --transform-translate-y: -5rem;\n  }\n  .xl\\:focus\\:-translate-y-24:focus {\n    --transform-translate-y: -6rem;\n  }\n  .xl\\:focus\\:-translate-y-28:focus {\n    --transform-translate-y: -7rem;\n  }\n  .xl\\:focus\\:-translate-y-32:focus {\n    --transform-translate-y: -8rem;\n  }\n  .xl\\:focus\\:-translate-y-36:focus {\n    --transform-translate-y: -9rem;\n  }\n  .xl\\:focus\\:-translate-y-40:focus {\n    --transform-translate-y: -10rem;\n  }\n  .xl\\:focus\\:-translate-y-44:focus {\n    --transform-translate-y: -11rem;\n  }\n  .xl\\:focus\\:-translate-y-48:focus {\n    --transform-translate-y: -12rem;\n  }\n  .xl\\:focus\\:-translate-y-52:focus {\n    --transform-translate-y: -13rem;\n  }\n  .xl\\:focus\\:-translate-y-56:focus {\n    --transform-translate-y: -14rem;\n  }\n  .xl\\:focus\\:-translate-y-60:focus {\n    --transform-translate-y: -15rem;\n  }\n  .xl\\:focus\\:-translate-y-64:focus {\n    --transform-translate-y: -16rem;\n  }\n  .xl\\:focus\\:-translate-y-72:focus {\n    --transform-translate-y: -18rem;\n  }\n  .xl\\:focus\\:-translate-y-80:focus {\n    --transform-translate-y: -20rem;\n  }\n  .xl\\:focus\\:-translate-y-96:focus {\n    --transform-translate-y: -24rem;\n  }\n  .xl\\:focus\\:-translate-y-px:focus {\n    --transform-translate-y: -1px;\n  }\n  .xl\\:focus\\:-translate-y-0\\.5:focus {\n    --transform-translate-y: -0.125rem;\n  }\n  .xl\\:focus\\:-translate-y-1\\.5:focus {\n    --transform-translate-y: -0.375rem;\n  }\n  .xl\\:focus\\:-translate-y-2\\.5:focus {\n    --transform-translate-y: -0.625rem;\n  }\n  .xl\\:focus\\:-translate-y-3\\.5:focus {\n    --transform-translate-y: -0.875rem;\n  }\n  .xl\\:focus\\:-translate-y-1\\/2:focus {\n    --transform-translate-y: -50%;\n  }\n  .xl\\:focus\\:-translate-y-1\\/3:focus {\n    --transform-translate-y: -33.33333%;\n  }\n  .xl\\:focus\\:-translate-y-2\\/3:focus {\n    --transform-translate-y: -66.66667%;\n  }\n  .xl\\:focus\\:-translate-y-1\\/4:focus {\n    --transform-translate-y: -25%;\n  }\n  .xl\\:focus\\:-translate-y-2\\/4:focus {\n    --transform-translate-y: -50%;\n  }\n  .xl\\:focus\\:-translate-y-3\\/4:focus {\n    --transform-translate-y: -75%;\n  }\n  .xl\\:focus\\:-translate-y-1\\/5:focus {\n    --transform-translate-y: -20%;\n  }\n  .xl\\:focus\\:-translate-y-2\\/5:focus {\n    --transform-translate-y: -40%;\n  }\n  .xl\\:focus\\:-translate-y-3\\/5:focus {\n    --transform-translate-y: -60%;\n  }\n  .xl\\:focus\\:-translate-y-4\\/5:focus {\n    --transform-translate-y: -80%;\n  }\n  .xl\\:focus\\:-translate-y-1\\/6:focus {\n    --transform-translate-y: -16.66667%;\n  }\n  .xl\\:focus\\:-translate-y-2\\/6:focus {\n    --transform-translate-y: -33.33333%;\n  }\n  .xl\\:focus\\:-translate-y-3\\/6:focus {\n    --transform-translate-y: -50%;\n  }\n  .xl\\:focus\\:-translate-y-4\\/6:focus {\n    --transform-translate-y: -66.66667%;\n  }\n  .xl\\:focus\\:-translate-y-5\\/6:focus {\n    --transform-translate-y: -83.33333%;\n  }\n  .xl\\:focus\\:-translate-y-1\\/12:focus {\n    --transform-translate-y: -8.33333%;\n  }\n  .xl\\:focus\\:-translate-y-2\\/12:focus {\n    --transform-translate-y: -16.66667%;\n  }\n  .xl\\:focus\\:-translate-y-3\\/12:focus {\n    --transform-translate-y: -25%;\n  }\n  .xl\\:focus\\:-translate-y-4\\/12:focus {\n    --transform-translate-y: -33.33333%;\n  }\n  .xl\\:focus\\:-translate-y-5\\/12:focus {\n    --transform-translate-y: -41.66667%;\n  }\n  .xl\\:focus\\:-translate-y-6\\/12:focus {\n    --transform-translate-y: -50%;\n  }\n  .xl\\:focus\\:-translate-y-7\\/12:focus {\n    --transform-translate-y: -58.33333%;\n  }\n  .xl\\:focus\\:-translate-y-8\\/12:focus {\n    --transform-translate-y: -66.66667%;\n  }\n  .xl\\:focus\\:-translate-y-9\\/12:focus {\n    --transform-translate-y: -75%;\n  }\n  .xl\\:focus\\:-translate-y-10\\/12:focus {\n    --transform-translate-y: -83.33333%;\n  }\n  .xl\\:focus\\:-translate-y-11\\/12:focus {\n    --transform-translate-y: -91.66667%;\n  }\n  .xl\\:focus\\:-translate-y-full:focus {\n    --transform-translate-y: -100%;\n  }\n  .xl\\:skew-x-0 {\n    --transform-skew-x: 0;\n  }\n  .xl\\:skew-x-1 {\n    --transform-skew-x: 1deg;\n  }\n  .xl\\:skew-x-2 {\n    --transform-skew-x: 2deg;\n  }\n  .xl\\:skew-x-3 {\n    --transform-skew-x: 3deg;\n  }\n  .xl\\:skew-x-6 {\n    --transform-skew-x: 6deg;\n  }\n  .xl\\:skew-x-12 {\n    --transform-skew-x: 12deg;\n  }\n  .xl\\:-skew-x-12 {\n    --transform-skew-x: -12deg;\n  }\n  .xl\\:-skew-x-6 {\n    --transform-skew-x: -6deg;\n  }\n  .xl\\:-skew-x-3 {\n    --transform-skew-x: -3deg;\n  }\n  .xl\\:-skew-x-2 {\n    --transform-skew-x: -2deg;\n  }\n  .xl\\:-skew-x-1 {\n    --transform-skew-x: -1deg;\n  }\n  .xl\\:skew-y-0 {\n    --transform-skew-y: 0;\n  }\n  .xl\\:skew-y-1 {\n    --transform-skew-y: 1deg;\n  }\n  .xl\\:skew-y-2 {\n    --transform-skew-y: 2deg;\n  }\n  .xl\\:skew-y-3 {\n    --transform-skew-y: 3deg;\n  }\n  .xl\\:skew-y-6 {\n    --transform-skew-y: 6deg;\n  }\n  .xl\\:skew-y-12 {\n    --transform-skew-y: 12deg;\n  }\n  .xl\\:-skew-y-12 {\n    --transform-skew-y: -12deg;\n  }\n  .xl\\:-skew-y-6 {\n    --transform-skew-y: -6deg;\n  }\n  .xl\\:-skew-y-3 {\n    --transform-skew-y: -3deg;\n  }\n  .xl\\:-skew-y-2 {\n    --transform-skew-y: -2deg;\n  }\n  .xl\\:-skew-y-1 {\n    --transform-skew-y: -1deg;\n  }\n  .xl\\:hover\\:skew-x-0:hover {\n    --transform-skew-x: 0;\n  }\n  .xl\\:hover\\:skew-x-1:hover {\n    --transform-skew-x: 1deg;\n  }\n  .xl\\:hover\\:skew-x-2:hover {\n    --transform-skew-x: 2deg;\n  }\n  .xl\\:hover\\:skew-x-3:hover {\n    --transform-skew-x: 3deg;\n  }\n  .xl\\:hover\\:skew-x-6:hover {\n    --transform-skew-x: 6deg;\n  }\n  .xl\\:hover\\:skew-x-12:hover {\n    --transform-skew-x: 12deg;\n  }\n  .xl\\:hover\\:-skew-x-12:hover {\n    --transform-skew-x: -12deg;\n  }\n  .xl\\:hover\\:-skew-x-6:hover {\n    --transform-skew-x: -6deg;\n  }\n  .xl\\:hover\\:-skew-x-3:hover {\n    --transform-skew-x: -3deg;\n  }\n  .xl\\:hover\\:-skew-x-2:hover {\n    --transform-skew-x: -2deg;\n  }\n  .xl\\:hover\\:-skew-x-1:hover {\n    --transform-skew-x: -1deg;\n  }\n  .xl\\:hover\\:skew-y-0:hover {\n    --transform-skew-y: 0;\n  }\n  .xl\\:hover\\:skew-y-1:hover {\n    --transform-skew-y: 1deg;\n  }\n  .xl\\:hover\\:skew-y-2:hover {\n    --transform-skew-y: 2deg;\n  }\n  .xl\\:hover\\:skew-y-3:hover {\n    --transform-skew-y: 3deg;\n  }\n  .xl\\:hover\\:skew-y-6:hover {\n    --transform-skew-y: 6deg;\n  }\n  .xl\\:hover\\:skew-y-12:hover {\n    --transform-skew-y: 12deg;\n  }\n  .xl\\:hover\\:-skew-y-12:hover {\n    --transform-skew-y: -12deg;\n  }\n  .xl\\:hover\\:-skew-y-6:hover {\n    --transform-skew-y: -6deg;\n  }\n  .xl\\:hover\\:-skew-y-3:hover {\n    --transform-skew-y: -3deg;\n  }\n  .xl\\:hover\\:-skew-y-2:hover {\n    --transform-skew-y: -2deg;\n  }\n  .xl\\:hover\\:-skew-y-1:hover {\n    --transform-skew-y: -1deg;\n  }\n  .xl\\:focus\\:skew-x-0:focus {\n    --transform-skew-x: 0;\n  }\n  .xl\\:focus\\:skew-x-1:focus {\n    --transform-skew-x: 1deg;\n  }\n  .xl\\:focus\\:skew-x-2:focus {\n    --transform-skew-x: 2deg;\n  }\n  .xl\\:focus\\:skew-x-3:focus {\n    --transform-skew-x: 3deg;\n  }\n  .xl\\:focus\\:skew-x-6:focus {\n    --transform-skew-x: 6deg;\n  }\n  .xl\\:focus\\:skew-x-12:focus {\n    --transform-skew-x: 12deg;\n  }\n  .xl\\:focus\\:-skew-x-12:focus {\n    --transform-skew-x: -12deg;\n  }\n  .xl\\:focus\\:-skew-x-6:focus {\n    --transform-skew-x: -6deg;\n  }\n  .xl\\:focus\\:-skew-x-3:focus {\n    --transform-skew-x: -3deg;\n  }\n  .xl\\:focus\\:-skew-x-2:focus {\n    --transform-skew-x: -2deg;\n  }\n  .xl\\:focus\\:-skew-x-1:focus {\n    --transform-skew-x: -1deg;\n  }\n  .xl\\:focus\\:skew-y-0:focus {\n    --transform-skew-y: 0;\n  }\n  .xl\\:focus\\:skew-y-1:focus {\n    --transform-skew-y: 1deg;\n  }\n  .xl\\:focus\\:skew-y-2:focus {\n    --transform-skew-y: 2deg;\n  }\n  .xl\\:focus\\:skew-y-3:focus {\n    --transform-skew-y: 3deg;\n  }\n  .xl\\:focus\\:skew-y-6:focus {\n    --transform-skew-y: 6deg;\n  }\n  .xl\\:focus\\:skew-y-12:focus {\n    --transform-skew-y: 12deg;\n  }\n  .xl\\:focus\\:-skew-y-12:focus {\n    --transform-skew-y: -12deg;\n  }\n  .xl\\:focus\\:-skew-y-6:focus {\n    --transform-skew-y: -6deg;\n  }\n  .xl\\:focus\\:-skew-y-3:focus {\n    --transform-skew-y: -3deg;\n  }\n  .xl\\:focus\\:-skew-y-2:focus {\n    --transform-skew-y: -2deg;\n  }\n  .xl\\:focus\\:-skew-y-1:focus {\n    --transform-skew-y: -1deg;\n  }\n  .xl\\:transition-none {\n    transition-property: none;\n  }\n  .xl\\:transition-all {\n    transition-property: all;\n  }\n  .xl\\:transition {\n    transition-property: background-color, border-color, color, fill, stroke, opacity, box-shadow, transform;\n  }\n  .xl\\:transition-colors {\n    transition-property: background-color, border-color, color, fill, stroke;\n  }\n  .xl\\:transition-opacity {\n    transition-property: opacity;\n  }\n  .xl\\:transition-shadow {\n    transition-property: box-shadow;\n  }\n  .xl\\:transition-transform {\n    transition-property: transform;\n  }\n  .xl\\:ease-linear {\n    transition-timing-function: linear;\n  }\n  .xl\\:ease-in {\n    transition-timing-function: cubic-bezier(0.4, 0, 1, 1);\n  }\n  .xl\\:ease-out {\n    transition-timing-function: cubic-bezier(0, 0, 0.2, 1);\n  }\n  .xl\\:ease-in-out {\n    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n  }\n  .xl\\:duration-75 {\n    transition-duration: 75ms;\n  }\n  .xl\\:duration-100 {\n    transition-duration: 100ms;\n  }\n  .xl\\:duration-150 {\n    transition-duration: 150ms;\n  }\n  .xl\\:duration-200 {\n    transition-duration: 200ms;\n  }\n  .xl\\:duration-300 {\n    transition-duration: 300ms;\n  }\n  .xl\\:duration-500 {\n    transition-duration: 500ms;\n  }\n  .xl\\:duration-700 {\n    transition-duration: 700ms;\n  }\n  .xl\\:duration-1000 {\n    transition-duration: 1000ms;\n  }\n  .xl\\:delay-75 {\n    transition-delay: 75ms;\n  }\n  .xl\\:delay-100 {\n    transition-delay: 100ms;\n  }\n  .xl\\:delay-150 {\n    transition-delay: 150ms;\n  }\n  .xl\\:delay-200 {\n    transition-delay: 200ms;\n  }\n  .xl\\:delay-300 {\n    transition-delay: 300ms;\n  }\n  .xl\\:delay-500 {\n    transition-delay: 500ms;\n  }\n  .xl\\:delay-700 {\n    transition-delay: 700ms;\n  }\n  .xl\\:delay-1000 {\n    transition-delay: 1000ms;\n  }\n  .xl\\:animate-none {\n    animation: none;\n  }\n  .xl\\:animate-spin {\n    animation: spin 1s linear infinite;\n  }\n  .xl\\:animate-ping {\n    animation: ping 1s cubic-bezier(0, 0, 0.2, 1) infinite;\n  }\n  .xl\\:animate-pulse {\n    animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;\n  }\n  .xl\\:animate-bounce {\n    animation: bounce 1s infinite;\n  }\n}\n@property --tw-translate-x {\n  syntax: \"*\";\n  inherits: false;\n  initial-value: 0;\n}\n@property --tw-translate-y {\n  syntax: \"*\";\n  inherits: false;\n  initial-value: 0;\n}\n@property --tw-translate-z {\n  syntax: \"*\";\n  inherits: false;\n  initial-value: 0;\n}\n@property --tw-scale-x {\n  syntax: \"*\";\n  inherits: false;\n  initial-value: 1;\n}\n@property --tw-scale-y {\n  syntax: \"*\";\n  inherits: false;\n  initial-value: 1;\n}\n@property --tw-scale-z {\n  syntax: \"*\";\n  inherits: false;\n  initial-value: 1;\n}\n@property --tw-rotate-x {\n  syntax: \"*\";\n  inherits: false;\n  initial-value: rotateX(0);\n}\n@property --tw-rotate-y {\n  syntax: \"*\";\n  inherits: false;\n  initial-value: rotateY(0);\n}\n@property --tw-rotate-z {\n  syntax: \"*\";\n  inherits: false;\n  initial-value: rotateZ(0);\n}\n@property --tw-skew-x {\n  syntax: \"*\";\n  inherits: false;\n  initial-value: skewX(0);\n}\n@property --tw-skew-y {\n  syntax: \"*\";\n  inherits: false;\n  initial-value: skewY(0);\n}\n@property --tw-space-y-reverse {\n  syntax: \"*\";\n  inherits: false;\n  initial-value: 0;\n}\n@property --tw-space-x-reverse {\n  syntax: \"*\";\n  inherits: false;\n  initial-value: 0;\n}\n@property --tw-divide-y-reverse {\n  syntax: \"*\";\n  inherits: false;\n  initial-value: 0;\n}\n@property --tw-border-style {\n  syntax: \"*\";\n  inherits: false;\n  initial-value: solid;\n}\n@property --tw-leading {\n  syntax: \"*\";\n  inherits: false;\n}\n@property --tw-font-weight {\n  syntax: \"*\";\n  inherits: false;\n}\n@property --tw-tracking {\n  syntax: \"*\";\n  inherits: false;\n}\n@property --tw-shadow {\n  syntax: \"*\";\n  inherits: false;\n  initial-value: 0 0 #0000;\n}\n@property --tw-shadow-color {\n  syntax: \"*\";\n  inherits: false;\n}\n@property --tw-inset-shadow {\n  syntax: \"*\";\n  inherits: false;\n  initial-value: 0 0 #0000;\n}\n@property --tw-inset-shadow-color {\n  syntax: \"*\";\n  inherits: false;\n}\n@property --tw-ring-color {\n  syntax: \"*\";\n  inherits: false;\n}\n@property --tw-ring-shadow {\n  syntax: \"*\";\n  inherits: false;\n  initial-value: 0 0 #0000;\n}\n@property --tw-inset-ring-color {\n  syntax: \"*\";\n  inherits: false;\n}\n@property --tw-inset-ring-shadow {\n  syntax: \"*\";\n  inherits: false;\n  initial-value: 0 0 #0000;\n}\n@property --tw-ring-inset {\n  syntax: \"*\";\n  inherits: false;\n}\n@property --tw-ring-offset-width {\n  syntax: \"<length>\";\n  inherits: false;\n  initial-value: 0px;\n}\n@property --tw-ring-offset-color {\n  syntax: \"*\";\n  inherits: false;\n  initial-value: #fff;\n}\n@property --tw-ring-offset-shadow {\n  syntax: \"*\";\n  inherits: false;\n  initial-value: 0 0 #0000;\n}\n@property --tw-outline-style {\n  syntax: \"*\";\n  inherits: false;\n  initial-value: solid;\n}\n@property --tw-blur {\n  syntax: \"*\";\n  inherits: false;\n}\n@property --tw-brightness {\n  syntax: \"*\";\n  inherits: false;\n}\n@property --tw-contrast {\n  syntax: \"*\";\n  inherits: false;\n}\n@property --tw-grayscale {\n  syntax: \"*\";\n  inherits: false;\n}\n@property --tw-hue-rotate {\n  syntax: \"*\";\n  inherits: false;\n}\n@property --tw-invert {\n  syntax: \"*\";\n  inherits: false;\n}\n@property --tw-opacity {\n  syntax: \"*\";\n  inherits: false;\n}\n@property --tw-saturate {\n  syntax: \"*\";\n  inherits: false;\n}\n@property --tw-sepia {\n  syntax: \"*\";\n  inherits: false;\n}\n@property --tw-drop-shadow {\n  syntax: \"*\";\n  inherits: false;\n}\n@property --tw-duration {\n  syntax: \"*\";\n  inherits: false;\n}\n@property --tw-ease {\n  syntax: \"*\";\n  inherits: false;\n}\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n@keyframes ping {\n  75%, 100% {\n    transform: scale(2);\n    opacity: 0;\n  }\n}\n@keyframes pulse {\n  50% {\n    opacity: 0.5;\n  }\n}\n@keyframes bounce {\n  0%, 100% {\n    transform: translateY(-25%);\n    animation-timing-function: cubic-bezier(0.8, 0, 1, 1);\n  }\n  50% {\n    transform: none;\n    animation-timing-function: cubic-bezier(0, 0, 0.2, 1);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
